import * as React from 'react';
import React__default, { useLayoutEffect, useEffect, useMemo, useContext, useDebugValue, useReducer as useReducer$1, useRef, Fragment, useState, useCallback, createContext as createContext$1, isValidElement, createRef, cloneElement, PureComponent, Component } from 'react';
import * as ReactDOM from 'react-dom';
import { unstable_batchedUpdates, findDOMNode } from 'react-dom';

function _mergeNamespaces(n, m) {
	for (var i = 0; i < m.length; i++) {
		const e = m[i];
		if (typeof e !== 'string' && !Array.isArray(e)) { for (const k in e) {
			if (k !== 'default' && !(k in n)) {
				const d = Object.getOwnPropertyDescriptor(e, k);
				if (d) {
					Object.defineProperty(n, k, d.get ? d : {
						enumerable: true,
						get: () => e[k]
					});
				}
			}
		} }
	}
	return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: 'Module' }));
}

var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

var jsxRuntime$1 = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React__default,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:true,ref:true,__self:true,__source:true};
	function q(c,a,g){var b,d={},e=null,h=null;undefined!==g&&(e=""+g);undefined!==a.key&&(e=""+a.key);undefined!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a) undefined===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = React__default;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = undefined; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self) ;
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	var didWarnAboutKeySpread = {};
	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum();

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    {
	      if (hasOwnProperty.call(props, 'key')) {
	        var componentName = getComponentNameFromType(type);
	        var keys = Object.keys(props).filter(function (k) {
	          return k !== 'key';
	        });
	        var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';

	        if (!didWarnAboutKeySpread[componentName + beforeExample]) {
	          var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';

	          error('A props object containing a "key" prop is being spread into JSX:\n' + '  let props = %s;\n' + '  <%s {...props} />\n' + 'React keys must be passed directly to JSX without using spread:\n' + '  let props = %s;\n' + '  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);

	          didWarnAboutKeySpread[componentName + beforeExample] = true;
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime$1.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime$1.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime$1.exports;
const jsxRuntime = /*@__PURE__*/getDefaultExportFromCjs(jsxRuntimeExports);

const ReactRuntime = /*#__PURE__*/_mergeNamespaces({
	__proto__: null,
	default: jsxRuntime
}, [jsxRuntimeExports]);

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$2;

function requireReactIs_production_min$2 () {
	if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
	hasRequiredReactIs_production_min$2 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$2.AsyncMode=l;reactIs_production_min$2.ConcurrentMode=m;reactIs_production_min$2.ContextConsumer=k;reactIs_production_min$2.ContextProvider=h;reactIs_production_min$2.Element=c;reactIs_production_min$2.ForwardRef=n;reactIs_production_min$2.Fragment=e;reactIs_production_min$2.Lazy=t;reactIs_production_min$2.Memo=r;reactIs_production_min$2.Portal=d;
	reactIs_production_min$2.Profiler=g;reactIs_production_min$2.StrictMode=f;reactIs_production_min$2.Suspense=p;reactIs_production_min$2.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$2.isConcurrentMode=A;reactIs_production_min$2.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$2.isContextProvider=function(a){return z(a)===h};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$2.isForwardRef=function(a){return z(a)===n};reactIs_production_min$2.isFragment=function(a){return z(a)===e};reactIs_production_min$2.isLazy=function(a){return z(a)===t};
	reactIs_production_min$2.isMemo=function(a){return z(a)===r};reactIs_production_min$2.isPortal=function(a){return z(a)===d};reactIs_production_min$2.isProfiler=function(a){return z(a)===g};reactIs_production_min$2.isStrictMode=function(a){return z(a)===f};reactIs_production_min$2.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$2.typeOf=z;
	return reactIs_production_min$2;
}

var reactIs_development$2 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$2;

function requireReactIs_development$2 () {
	if (hasRequiredReactIs_development$2) return reactIs_development$2;
	hasRequiredReactIs_development$2 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$2.AsyncMode = AsyncMode;
	reactIs_development$2.ConcurrentMode = ConcurrentMode;
	reactIs_development$2.ContextConsumer = ContextConsumer;
	reactIs_development$2.ContextProvider = ContextProvider;
	reactIs_development$2.Element = Element;
	reactIs_development$2.ForwardRef = ForwardRef;
	reactIs_development$2.Fragment = Fragment;
	reactIs_development$2.Lazy = Lazy;
	reactIs_development$2.Memo = Memo;
	reactIs_development$2.Portal = Portal;
	reactIs_development$2.Profiler = Profiler;
	reactIs_development$2.StrictMode = StrictMode;
	reactIs_development$2.Suspense = Suspense;
	reactIs_development$2.isAsyncMode = isAsyncMode;
	reactIs_development$2.isConcurrentMode = isConcurrentMode;
	reactIs_development$2.isContextConsumer = isContextConsumer;
	reactIs_development$2.isContextProvider = isContextProvider;
	reactIs_development$2.isElement = isElement;
	reactIs_development$2.isForwardRef = isForwardRef;
	reactIs_development$2.isFragment = isFragment;
	reactIs_development$2.isLazy = isLazy;
	reactIs_development$2.isMemo = isMemo;
	reactIs_development$2.isPortal = isPortal;
	reactIs_development$2.isProfiler = isProfiler;
	reactIs_development$2.isStrictMode = isStrictMode;
	reactIs_development$2.isSuspense = isSuspense;
	reactIs_development$2.isValidElementType = isValidElementType;
	reactIs_development$2.typeOf = typeOf;
	  })();
	}
	return reactIs_development$2;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = requireReactIs_production_min$2();
} else {
  reactIs$2.exports = requireReactIs_development$2();
}

var reactIsExports$1 = reactIs$2.exports;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has$1;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has$1;
	hasRequiredHas = 1;
	has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
	return has$1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;
	var ReactIs = reactIsExports$1;
	var assign = requireObjectAssign();
	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();
	var printWarning = function() {
	};
	if (process.env.NODE_ENV !== "production") {
	  printWarning = function(text) {
	    var message = "Warning: " + text;
	    if (typeof console !== "undefined") {
	      console.error(message);
	    }
	    try {
	      throw new Error(message);
	    } catch (x) {
	    }
	  };
	}
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = "@@iterator";
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === "function") {
	      return iteratorFn;
	    }
	  }
	  var ANONYMOUS = "<<anonymous>>";
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker("array"),
	    bigint: createPrimitiveTypeChecker("bigint"),
	    bool: createPrimitiveTypeChecker("boolean"),
	    func: createPrimitiveTypeChecker("function"),
	    number: createPrimitiveTypeChecker("number"),
	    object: createPrimitiveTypeChecker("object"),
	    string: createPrimitiveTypeChecker("string"),
	    symbol: createPrimitiveTypeChecker("symbol"),
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker
	  };
	  function is(x, y) {
	    if (x === y) {
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      return x !== x && y !== y;
	    }
	  }
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === "object" ? data : {};
	    this.stack = "";
	  }
	  PropTypeError.prototype = Error.prototype;
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== "production") {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          var err = new Error(
	            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
	          );
	          err.name = "Invariant Violation";
	          throw err;
	        } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
	          var cacheKey = componentName + ":" + propName;
	          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
	          manualPropTypeWarningCount < 3) {
	            printWarning(
	              "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
	          }
	          return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	  }
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        var preciseType = getPreciseType(propValue);
	        return new PropTypeError(
	          "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
	          { expectedType }
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== "function") {
	        return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== "production") {
	        if (arguments.length > 1) {
	          printWarning(
	            "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
	          );
	        } else {
	          printWarning("Invalid argument supplied to oneOf, expected an array.");
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === "symbol") {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== "function") {
	        return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== "object") {
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : undefined;
	      return emptyFunctionThatReturnsNull;
	    }
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== "function") {
	        printWarning(
	          "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
	        var checker2 = arrayOfTypeCheckers[i2];
	        var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, "expectedType")) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
	      return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
	    );
	  }
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== "object") {
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== "function") {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== "object") {
	        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
	      }
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== "function") {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case "number":
	      case "string":
	      case "undefined":
	        return true;
	      case "boolean":
	        return !propValue;
	      case "object":
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	        return true;
	      default:
	        return false;
	    }
	  }
	  function isSymbol(propType, propValue) {
	    if (propType === "symbol") {
	      return true;
	    }
	    if (!propValue) {
	      return false;
	    }
	    if (propValue["@@toStringTag"] === "Symbol") {
	      return true;
	    }
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	      return true;
	    }
	    return false;
	  }
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return "array";
	    }
	    if (propValue instanceof RegExp) {
	      return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	      return "symbol";
	    }
	    return propType;
	  }
	  function getPreciseType(propValue) {
	    if (typeof propValue === "undefined" || propValue === null) {
	      return "" + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	      if (propValue instanceof Date) {
	        return "date";
	      } else if (propValue instanceof RegExp) {
	        return "regexp";
	      }
	    }
	    return propType;
	  }
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case "array":
	      case "object":
	        return "an " + type;
	      case "boolean":
	      case "date":
	      case "regexp":
	        return "a " + type;
	      default:
	        return type;
	    }
	  }
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIsExports$1;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
const PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

var ReactReduxContext = /*#__PURE__*/React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$2 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function Provider$1(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = useMemo(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$2(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider$1.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var reactIs$1 = reactIsExports$1;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

var reactIs_production_min$1 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;reactIs_production_min$1.ContextConsumer=h;reactIs_production_min$1.ContextProvider=z;reactIs_production_min$1.Element=A;reactIs_production_min$1.ForwardRef=B;reactIs_production_min$1.Fragment=C;reactIs_production_min$1.Lazy=D;reactIs_production_min$1.Memo=E;reactIs_production_min$1.Portal=F;reactIs_production_min$1.Profiler=G;reactIs_production_min$1.StrictMode=H;
	reactIs_production_min$1.Suspense=I;reactIs_production_min$1.isAsyncMode=function(){return  false};reactIs_production_min$1.isConcurrentMode=function(){return  false};reactIs_production_min$1.isContextConsumer=function(a){return y(a)===h};reactIs_production_min$1.isContextProvider=function(a){return y(a)===g};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min$1.isForwardRef=function(a){return y(a)===k};reactIs_production_min$1.isFragment=function(a){return y(a)===d};reactIs_production_min$1.isLazy=function(a){return y(a)===p};reactIs_production_min$1.isMemo=function(a){return y(a)===n};
	reactIs_production_min$1.isPortal=function(a){return y(a)===c};reactIs_production_min$1.isProfiler=function(a){return y(a)===f};reactIs_production_min$1.isStrictMode=function(a){return y(a)===e};reactIs_production_min$1.isSuspense=function(a){return y(a)===l};reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?true:false};
	reactIs_production_min$1.typeOf=y;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = 0xeac7;
	var REACT_PORTAL_TYPE = 0xeaca;
	var REACT_FRAGMENT_TYPE = 0xeacb;
	var REACT_STRICT_MODE_TYPE = 0xeacc;
	var REACT_PROFILER_TYPE = 0xead2;
	var REACT_PROVIDER_TYPE = 0xeacd;
	var REACT_CONTEXT_TYPE = 0xeace;
	var REACT_FORWARD_REF_TYPE = 0xead0;
	var REACT_SUSPENSE_TYPE = 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	var REACT_MEMO_TYPE = 0xead3;
	var REACT_LAZY_TYPE = 0xead4;
	var REACT_BLOCK_TYPE = 0xead9;
	var REACT_SERVER_BLOCK_TYPE = 0xeada;
	var REACT_FUNDAMENTAL_TYPE = 0xead5;
	var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

	if (typeof Symbol === 'function' && Symbol.for) {
	  var symbolFor = Symbol.for;
	  REACT_ELEMENT_TYPE = symbolFor('react.element');
	  REACT_PORTAL_TYPE = symbolFor('react.portal');
	  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	  REACT_PROFILER_TYPE = symbolFor('react.profiler');
	  REACT_PROVIDER_TYPE = symbolFor('react.provider');
	  REACT_CONTEXT_TYPE = symbolFor('react.context');
	  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	  REACT_MEMO_TYPE = symbolFor('react.memo');
	  REACT_LAZY_TYPE = symbolFor('react.lazy');
	  REACT_BLOCK_TYPE = symbolFor('react.block');
	  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	  symbolFor('react.scope');
	  symbolFor('react.opaque.id');
	  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	  symbolFor('react.offscreen');
	  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	}

	// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	var enableScopeAPI = false; // Experimental Create Event Handle API.

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

if (process.env.NODE_ENV === 'production') {
  requireReactIs_production_min$1();
} else {
  requireReactIs_development$1();
}

/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = useContext(ReactReduxContext);

  if (process.env.NODE_ENV !== 'production' && !contextValue) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === undefined) {
    context = ReactReduxContext;
  }

  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return useContext(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext$1(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === undefined) {
    context = ReactReduxContext;
  }

  var useStore$1 = context === ReactReduxContext ? useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore$1();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();

var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = useReducer$1(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = useMemo(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = useRef();
  var latestSelector = useRef();
  var latestStoreState = useRef();
  var latestSelectedState = useRef();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect$2(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect$2(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === undefined) {
    context = ReactReduxContext;
  }

  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === undefined) {
      equalityFn = refEquality;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }

      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }

      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }

    var _useReduxContext = useReduxContext$1(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    useDebugValue(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();

// with standard React renderers (ReactDOM, React Native)

setBatch(unstable_batchedUpdates);

var extendStatics$1 = function(d, b) {
  extendStatics$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics$1(d, b);
};
function __extends$1(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics$1(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$2 = function() {
  __assign$2 = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var packagesCache = {};
var _win = undefined;
try {
  _win = window;
} catch (e) {
}
function setVersion(packageName, packageVersion) {
  if (typeof _win !== "undefined") {
    var packages = _win.__packages__ = _win.__packages__ || {};
    if (!packages[packageName] || !packagesCache[packageName]) {
      packagesCache[packageName] = packageVersion;
      var versions = packages[packageName] = packages[packageName] || [];
      versions.push(packageVersion);
    }
  }
}

setVersion('@fluentui/set-version', '6.0.0');

var GLOBAL_STYLESHEET_KEY = "__global__";
var SHADOW_DOM_STYLESHEET_SETTING = "__shadow_dom_stylesheet__";
var DEFAULT_SHADOW_CONFIG = {
  stylesheetKey: GLOBAL_STYLESHEET_KEY,
  inShadow: false,
  window: undefined,
  __isShadowConfig__: true
};
var makeShadowConfig = function(stylesheetKey, inShadow, window) {
  return {
    stylesheetKey,
    inShadow,
    window,
    __isShadowConfig__: true
  };
};
var isShadowConfig = function(value) {
  if (!(value && isRecord(value))) {
    return false;
  }
  return value.__isShadowConfig__ === true;
};
function isRecord(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

/**
 * Separates the classes and style objects. Any classes that are pre-registered
 * args are auto expanded into objects.
 */
function extractStyleParts(sheet) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var classes = [];
    var objects = [];
    var stylesheet = sheet;
    function _processArgs(argsList) {
        for (var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++) {
            var arg = argsList_1[_i];
            if (arg && !isShadowConfig(arg)) {
                if (typeof arg === 'string') {
                    if (arg.indexOf(' ') >= 0) {
                        _processArgs(arg.split(' '));
                    }
                    else {
                        var translatedArgs = stylesheet.argsFromClassName(arg);
                        if (translatedArgs) {
                            _processArgs(translatedArgs);
                        }
                        else {
                            // Avoid adding the same class twice.
                            if (classes.indexOf(arg) === -1) {
                                classes.push(arg);
                            }
                        }
                    }
                }
                else if (Array.isArray(arg)) {
                    _processArgs(arg);
                }
                else if (typeof arg === 'object') {
                    objects.push(arg);
                }
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects,
    };
}

function setRTL$1(isRTL) {
  if (_rtl !== isRTL) {
    _rtl = isRTL;
  }
}
function getRTL$1() {
  if (_rtl === undefined) {
    _rtl = // eslint-disable-next-line no-restricted-globals
    typeof document !== "undefined" && // eslint-disable-next-line no-restricted-globals
    !!document.documentElement && // eslint-disable-next-line no-restricted-globals
    document.documentElement.getAttribute("dir") === "rtl";
  }
  return _rtl;
}
var _rtl;
_rtl = getRTL$1();
function getStyleOptions() {
  return {
    rtl: getRTL$1(),
    shadowConfig: DEFAULT_SHADOW_CONFIG
  };
}

var InjectionMode = {
  /**
   * Avoids style injection, use getRules() to read the styles.
   */
  none: 0,
  /**
   * Inserts rules using the insertRule api.
   */
  insertNode: 1,
  /**
   * Appends rules using appendChild.
   */
  appendChild: 2
};
var STYLESHEET_SETTING = "__stylesheet__";
var REUSE_STYLE_NODE = typeof navigator !== "undefined" && /rv:11.0/.test(navigator.userAgent);
var _global$2 = {};
try {
  _global$2 = window || {};
} catch (_a) {
}
var _stylesheet;
var Stylesheet = (
  /** @class */
  function() {
    function Stylesheet2(config, serializedStylesheet) {
      var _a, _b, _c, _d, _e, _f;
      this._rules = [];
      this._preservedRules = [];
      this._counter = 0;
      this._keyToClassName = {};
      this._onInsertRuleCallbacks = [];
      this._onResetCallbacks = [];
      this._classNameToArgs = {};
      this._config = __assign$2({ injectionMode: typeof document === "undefined" ? InjectionMode.none : InjectionMode.insertNode, defaultPrefix: "css", namespace: undefined, cspSettings: undefined }, config);
      this._classNameToArgs = (_a = serializedStylesheet === null || serializedStylesheet === undefined ? undefined : serializedStylesheet.classNameToArgs) !== null && _a !== undefined ? _a : this._classNameToArgs;
      this._counter = (_b = serializedStylesheet === null || serializedStylesheet === undefined ? undefined : serializedStylesheet.counter) !== null && _b !== undefined ? _b : this._counter;
      this._keyToClassName = (_d = (_c = this._config.classNameCache) !== null && _c !== undefined ? _c : serializedStylesheet === null || serializedStylesheet === undefined ? undefined : serializedStylesheet.keyToClassName) !== null && _d !== undefined ? _d : this._keyToClassName;
      this._preservedRules = (_e = serializedStylesheet === null || serializedStylesheet === undefined ? undefined : serializedStylesheet.preservedRules) !== null && _e !== undefined ? _e : this._preservedRules;
      this._rules = (_f = serializedStylesheet === null || serializedStylesheet === undefined ? undefined : serializedStylesheet.rules) !== null && _f !== undefined ? _f : this._rules;
    }
    Stylesheet2.getInstance = function(shadowConfig) {
      _stylesheet = _global$2[STYLESHEET_SETTING];
      if (_global$2[SHADOW_DOM_STYLESHEET_SETTING]) {
        return _global$2[SHADOW_DOM_STYLESHEET_SETTING].getInstance(shadowConfig);
      }
      if (!_stylesheet || _stylesheet._lastStyleElement && _stylesheet._lastStyleElement.ownerDocument !== document) {
        var fabricConfig = (_global$2 === null || _global$2 === undefined ? undefined : _global$2.FabricConfig) || {};
        var stylesheet = new Stylesheet2(fabricConfig.mergeStyles, fabricConfig.serializedStylesheet);
        _stylesheet = stylesheet;
        _global$2[STYLESHEET_SETTING] = stylesheet;
      }
      return _stylesheet;
    };
    Stylesheet2.prototype.serialize = function() {
      return JSON.stringify({
        classNameToArgs: this._classNameToArgs,
        counter: this._counter,
        keyToClassName: this._keyToClassName,
        preservedRules: this._preservedRules,
        rules: this._rules
      });
    };
    Stylesheet2.prototype.setConfig = function(config) {
      this._config = __assign$2(__assign$2({}, this._config), config);
    };
    Stylesheet2.prototype.onReset = function(callback) {
      var _this = this;
      this._onResetCallbacks.push(callback);
      return function() {
        _this._onResetCallbacks = _this._onResetCallbacks.filter(function(cb) {
          return cb !== callback;
        });
      };
    };
    Stylesheet2.prototype.onInsertRule = function(callback) {
      var _this = this;
      this._onInsertRuleCallbacks.push(callback);
      return function() {
        _this._onInsertRuleCallbacks = _this._onInsertRuleCallbacks.filter(function(cb) {
          return cb !== callback;
        });
      };
    };
    Stylesheet2.prototype.getClassName = function(displayName) {
      var namespace = this._config.namespace;
      var prefix = displayName || this._config.defaultPrefix;
      return "".concat(namespace ? namespace + "-" : "").concat(prefix, "-").concat(this._counter++);
    };
    Stylesheet2.prototype.cacheClassName = function(className, key, args, rules) {
      this._keyToClassName[this._getCacheKey(key)] = className;
      this._classNameToArgs[className] = {
        args,
        rules
      };
    };
    Stylesheet2.prototype.classNameFromKey = function(key) {
      return this._keyToClassName[this._getCacheKey(key)];
    };
    Stylesheet2.prototype.getClassNameCache = function() {
      return this._keyToClassName;
    };
    Stylesheet2.prototype.argsFromClassName = function(className) {
      var entry = this._classNameToArgs[className];
      return entry && entry.args;
    };
    Stylesheet2.prototype.insertedRulesFromClassName = function(className) {
      var entry = this._classNameToArgs[className];
      return entry && entry.rules;
    };
    Stylesheet2.prototype.insertRule = function(rule, preserve, stylesheetKey) {
      if (stylesheetKey === undefined) {
        stylesheetKey = GLOBAL_STYLESHEET_KEY;
      }
      var injectionMode = this._config.injectionMode;
      var element = injectionMode !== InjectionMode.none ? this._getStyleElement() : undefined;
      if (preserve) {
        this._preservedRules.push(rule);
      }
      if (element) {
        switch (injectionMode) {
          case InjectionMode.insertNode:
            this._insertRuleIntoSheet(element.sheet, rule);
            break;
          case InjectionMode.appendChild:
            element.appendChild(document.createTextNode(rule));
            break;
        }
      } else {
        this._rules.push(rule);
      }
      if (this._config.onInsertRule) {
        this._config.onInsertRule(rule);
      }
      this._onInsertRuleCallbacks.forEach(function(callback) {
        return callback({ key: stylesheetKey, sheet: element ? element.sheet : undefined, rule });
      });
    };
    Stylesheet2.prototype.getRules = function(includePreservedRules) {
      return (includePreservedRules ? this._preservedRules.join("") : "") + this._rules.join("");
    };
    Stylesheet2.prototype.reset = function() {
      this._rules = [];
      this._counter = 0;
      this._classNameToArgs = {};
      this._keyToClassName = {};
      this._onResetCallbacks.forEach(function(callback) {
        return callback();
      });
    };
    Stylesheet2.prototype.resetKeys = function() {
      this._keyToClassName = {};
    };
    Stylesheet2.prototype._createStyleElement = function() {
      var _a;
      var doc = ((_a = this._config.window) === null || _a === undefined ? undefined : _a.document) || document;
      var head = doc.head;
      var styleElement = doc.createElement("style");
      var nodeToInsertBefore = null;
      styleElement.setAttribute("data-merge-styles", "true");
      var cspSettings = this._config.cspSettings;
      if (cspSettings) {
        if (cspSettings.nonce) {
          styleElement.setAttribute("nonce", cspSettings.nonce);
        }
      }
      if (this._lastStyleElement) {
        nodeToInsertBefore = this._lastStyleElement.nextElementSibling;
      } else {
        var placeholderStyleTag = this._findPlaceholderStyleTag();
        if (placeholderStyleTag) {
          nodeToInsertBefore = placeholderStyleTag.nextElementSibling;
        } else {
          nodeToInsertBefore = head.childNodes[0];
        }
      }
      head.insertBefore(styleElement, head.contains(nodeToInsertBefore) ? nodeToInsertBefore : null);
      this._lastStyleElement = styleElement;
      return styleElement;
    };
    Stylesheet2.prototype._insertRuleIntoSheet = function(sheet, rule) {
      if (!sheet) {
        return false;
      }
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
        return true;
      } catch (e) {
      }
      return false;
    };
    Stylesheet2.prototype._getCacheKey = function(key) {
      return key;
    };
    Stylesheet2.prototype._getStyleElement = function() {
      var _this = this;
      if (!this._styleElement) {
        this._styleElement = this._createStyleElement();
        if (!REUSE_STYLE_NODE) {
          var win = this._config.window || window;
          win.requestAnimationFrame(function() {
            _this._styleElement = undefined;
          });
        }
      }
      return this._styleElement;
    };
    Stylesheet2.prototype._findPlaceholderStyleTag = function() {
      var head = document.head;
      if (head) {
        return head.querySelector("style[data-merge-styles]");
      }
      return null;
    };
    return Stylesheet2;
  }()
);

var rules = {};
function kebabRules(rulePairs, index) {
    var rule = rulePairs[index];
    if (rule.charAt(0) !== '-') {
        rulePairs[index] = rules[rule] = rules[rule] || rule.replace(/([A-Z])/g, '-$1').toLowerCase();
    }
}

var _vendorSettings;
function getVendorSettings() {
  var _a;
  if (!_vendorSettings) {
    var doc = typeof document !== "undefined" ? document : undefined;
    var nav = typeof navigator !== "undefined" ? navigator : undefined;
    var userAgent = (_a = nav === null || nav === undefined ? undefined : nav.userAgent) === null || _a === undefined ? undefined : _a.toLowerCase();
    if (!doc) {
      _vendorSettings = {
        isWebkit: true,
        isMoz: true,
        isOpera: true,
        isMs: true
      };
    } else {
      _vendorSettings = {
        isWebkit: !!(doc && "WebkitAppearance" in doc.documentElement.style),
        isMoz: !!(userAgent && userAgent.indexOf("firefox") > -1),
        isOpera: !!(userAgent && userAgent.indexOf("opera") > -1),
        isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
      };
    }
  }
  return _vendorSettings;
}

var autoPrefixNames = {
    'user-select': 1,
};
function prefixRules(rulePairs, index) {
    var vendorSettings = getVendorSettings();
    var name = rulePairs[index];
    if (autoPrefixNames[name]) {
        var value = rulePairs[index + 1];
        if (autoPrefixNames[name]) {
            if (vendorSettings.isWebkit) {
                rulePairs.push('-webkit-' + name, value);
            }
            if (vendorSettings.isMoz) {
                rulePairs.push('-moz-' + name, value);
            }
            if (vendorSettings.isMs) {
                rulePairs.push('-ms-' + name, value);
            }
            if (vendorSettings.isOpera) {
                rulePairs.push('-o-' + name, value);
            }
        }
    }
}

var NON_PIXEL_NUMBER_PROPS = [
    'column-count',
    'font-weight',
    'flex',
    'flex-grow',
    'flex-shrink',
    'fill-opacity',
    'opacity',
    'order',
    'z-index',
    'zoom',
];
function provideUnits(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === 'number') {
        var isNonPixelProp = NON_PIXEL_NUMBER_PROPS.indexOf(name) > -1;
        var isVariableOrPrefixed = name.indexOf('--') > -1;
        var unit = isNonPixelProp || isVariableOrPrefixed ? '' : 'px';
        rulePairs[index + 1] = "".concat(value).concat(unit);
    }
}

var _a$i;
var LEFT = 'left';
var RIGHT = 'right';
var NO_FLIP = '@noflip';
var NAME_REPLACEMENTS = (_a$i = {},
    _a$i[LEFT] = RIGHT,
    _a$i[RIGHT] = LEFT,
    _a$i);
var VALUE_REPLACEMENTS = {
    'w-resize': 'e-resize',
    'sw-resize': 'se-resize',
    'nw-resize': 'ne-resize',
};
/**
 * RTLifies the rulePair in the array at the current index. This mutates the array for performance
 * reasons.
 */
function rtlifyRules(options, rulePairs, index) {
    if (options.rtl) {
        var name_1 = rulePairs[index];
        if (!name_1) {
            return;
        }
        var value = rulePairs[index + 1];
        if (typeof value === 'string' && value.indexOf(NO_FLIP) >= 0) {
            rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
        }
        else if (name_1.indexOf(LEFT) >= 0) {
            rulePairs[index] = name_1.replace(LEFT, RIGHT);
        }
        else if (name_1.indexOf(RIGHT) >= 0) {
            rulePairs[index] = name_1.replace(RIGHT, LEFT);
        }
        else if (String(value).indexOf(LEFT) >= 0) {
            rulePairs[index + 1] = value.replace(LEFT, RIGHT);
        }
        else if (String(value).indexOf(RIGHT) >= 0) {
            rulePairs[index + 1] = value.replace(RIGHT, LEFT);
        }
        else if (NAME_REPLACEMENTS[name_1]) {
            rulePairs[index] = NAME_REPLACEMENTS[name_1];
        }
        else if (VALUE_REPLACEMENTS[value]) {
            rulePairs[index + 1] = VALUE_REPLACEMENTS[value];
        }
        else {
            switch (name_1) {
                case 'margin':
                case 'padding':
                    rulePairs[index + 1] = flipQuad(value);
                    break;
                case 'box-shadow':
                    rulePairs[index + 1] = negateNum(value, 0);
                    break;
            }
        }
    }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */
function negateNum(value, partIndex) {
    var parts = value.split(' ');
    var numberVal = parseInt(parts[partIndex], 10);
    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
    return parts.join(' ');
}
/**
 * Given a string quad, flips the left and right values.
 */
function flipQuad(value) {
    if (typeof value === 'string') {
        var parts = value.split(' ');
        if (parts.length === 4) {
            return "".concat(parts[0], " ").concat(parts[3], " ").concat(parts[2], " ").concat(parts[1]);
        }
    }
    return value;
}

/**
 * Split a string into tokens separated by whitespace, except all text within parentheses
 * is treated as a single token (whitespace is ignored within parentheses).
 *
 * Unlike String.split(' '), multiple consecutive space characters are collapsed and
 * removed from the returned array (including leading and trailing spaces).
 *
 * For example:
 * `tokenizeWithParentheses("3px calc(var(--x) / 2) 9px    0 ")`
 *   => `["3px", "calc(var(--x) / 2)", "9px", "0"]`
 *
 * @returns The array of tokens. Returns an empty array if the string was empty or contained only whitespace.
 */
function tokenizeWithParentheses(value) {
    var parts = [];
    var partStart = 0;
    var parens = 0;
    for (var i = 0; i < value.length; i++) {
        switch (value[i]) {
            case '(':
                parens++;
                break;
            case ')':
                if (parens) {
                    parens--;
                }
                break;
            case '\t':
            case ' ':
                if (!parens) {
                    // Add the new part if it's not an empty string
                    if (i > partStart) {
                        parts.push(value.substring(partStart, i));
                    }
                    partStart = i + 1;
                }
                break;
        }
    }
    // Add the last part
    if (partStart < value.length) {
        parts.push(value.substring(partStart));
    }
    return parts;
}

var DISPLAY_NAME = "displayName";
function getDisplayName(rules) {
  var rootStyle = rules && rules["&"];
  return rootStyle ? rootStyle.displayName : undefined;
}
var globalSelectorRegExp = /\:global\((.+?)\)/g;
function expandCommaSeparatedGlobals(selectorWithGlobals) {
  if (!globalSelectorRegExp.test(selectorWithGlobals)) {
    return selectorWithGlobals;
  }
  var replacementInfo = [];
  var findGlobal = /\:global\((.+?)\)/g;
  var match = null;
  while (match = findGlobal.exec(selectorWithGlobals)) {
    if (match[1].indexOf(",") > -1) {
      replacementInfo.push([
        match.index,
        match.index + match[0].length,
        // Wrap each of the found selectors in :global()
        match[1].split(",").map(function(v) {
          return ":global(".concat(v.trim(), ")");
        }).join(", ")
      ]);
    }
  }
  return replacementInfo.reverse().reduce(function(selector, _a) {
    var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
    var prefix = selector.slice(0, matchIndex);
    var suffix = selector.slice(matchEndIndex);
    return prefix + replacement + suffix;
  }, selectorWithGlobals);
}
function isSelector(potentialSelector) {
  return potentialSelector.indexOf(":global(") >= 0 || potentialSelector.indexOf(":") === 0;
}
function expandSelector(newSelector, currentSelector) {
  if (newSelector.indexOf(":global(") >= 0) {
    return newSelector.replace(globalSelectorRegExp, "$1");
  } else if (newSelector.indexOf(":host(") === 0) {
    return newSelector;
  } else if (newSelector.indexOf(":") === 0) {
    return currentSelector + newSelector;
  } else if (newSelector.indexOf("&") < 0) {
    return currentSelector + " " + newSelector;
  }
  return newSelector;
}
function extractSelector(currentSelector, rules, selector, value, stylesheet) {
  if (rules === undefined) {
    rules = { __order: [] };
  }
  if (selector.indexOf("@") === 0) {
    selector = selector + "{" + currentSelector;
    extractRules([value], rules, selector, stylesheet);
  } else if (selector.indexOf(",") > -1) {
    expandCommaSeparatedGlobals(selector).split(",").map(function(s) {
      return s.trim();
    }).forEach(function(separatedSelector) {
      return extractRules([value], rules, expandSelector(separatedSelector, currentSelector), stylesheet);
    });
  } else {
    extractRules([value], rules, expandSelector(selector, currentSelector), stylesheet);
  }
}
function extractRules(args, rules, currentSelector, stylesheet) {
  if (rules === undefined) {
    rules = { __order: [] };
  }
  if (currentSelector === undefined) {
    currentSelector = "&";
  }
  var currentRules = rules[currentSelector];
  if (!currentRules) {
    currentRules = {};
    rules[currentSelector] = currentRules;
    rules.__order.push(currentSelector);
  }
  for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
    var arg = args_1[_i];
    if (typeof arg === "string") {
      var expandedRules = stylesheet.argsFromClassName(arg);
      if (expandedRules) {
        extractRules(expandedRules, rules, currentSelector, stylesheet);
      }
    } else if (Array.isArray(arg)) {
      extractRules(arg, rules, currentSelector, stylesheet);
    } else {
      for (var prop in arg) {
        if (arg.hasOwnProperty(prop)) {
          var propValue = arg[prop];
          if (prop === "selectors") {
            var selectors = arg.selectors;
            for (var newSelector in selectors) {
              if (selectors.hasOwnProperty(newSelector)) {
                extractSelector(currentSelector, rules, newSelector, selectors[newSelector], stylesheet);
              }
            }
          } else if (typeof propValue === "object" || isSelector(prop)) {
            if (propValue !== null && propValue !== undefined) {
              extractSelector(currentSelector, rules, prop, propValue, stylesheet);
            }
          } else {
            if (propValue !== undefined) {
              if (prop === "margin" || prop === "padding") {
                expandQuads(currentRules, prop, propValue);
              } else {
                currentRules[prop] = propValue;
              }
            }
          }
        }
      }
    }
  }
  return rules;
}
function expandQuads(currentRules, name, value) {
  var parts = typeof value === "string" ? tokenizeWithParentheses(value) : [value];
  if (parts.length === 0) {
    parts.push(value);
  }
  if (parts[parts.length - 1] === "!important") {
    parts = parts.slice(0, -1).map(function(p) {
      return p + " !important";
    });
  }
  currentRules[name + "Top"] = parts[0];
  currentRules[name + "Right"] = parts[1] || parts[0];
  currentRules[name + "Bottom"] = parts[2] || parts[0];
  currentRules[name + "Left"] = parts[3] || parts[1] || parts[0];
}
function getKeyForRules(options, rules) {
  var serialized = [options.rtl ? "rtl" : "ltr"];
  var hasProps = false;
  for (var _i = 0, _a = rules.__order; _i < _a.length; _i++) {
    var selector = _a[_i];
    serialized.push(selector);
    var rulesForSelector = rules[selector];
    for (var propName in rulesForSelector) {
      if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
        hasProps = true;
        serialized.push(propName, rulesForSelector[propName]);
      }
    }
  }
  return hasProps ? serialized.join("") : undefined;
}
function repeatString(target, count) {
  if (count <= 0) {
    return "";
  }
  if (count === 1) {
    return target;
  }
  return target + repeatString(target, count - 1);
}
function serializeRuleEntries(options, ruleEntries) {
  if (!ruleEntries) {
    return "";
  }
  var allEntries = [];
  for (var entry in ruleEntries) {
    if (ruleEntries.hasOwnProperty(entry) && entry !== DISPLAY_NAME && ruleEntries[entry] !== undefined) {
      allEntries.push(entry, ruleEntries[entry]);
    }
  }
  for (var i = 0; i < allEntries.length; i += 2) {
    kebabRules(allEntries, i);
    provideUnits(allEntries, i);
    rtlifyRules(options, allEntries, i);
    prefixRules(allEntries, i);
  }
  for (var i = 1; i < allEntries.length; i += 4) {
    allEntries.splice(i, 1, ":", allEntries[i], ";");
  }
  return allEntries.join("");
}
function styleToRegistration(options) {
  var _a;
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  var stylesheet = (_a = options.stylesheet) !== null && _a !== undefined ? _a : Stylesheet.getInstance(options.shadowConfig);
  var rules = extractRules(args, undefined, undefined, stylesheet);
  var key = getKeyForRules(options, rules);
  if (key) {
    var registration = {
      className: stylesheet.classNameFromKey(key),
      key,
      args
    };
    if (!registration.className) {
      registration.className = stylesheet.getClassName(getDisplayName(rules));
      var rulesToInsert = [];
      for (var _b = 0, _c = rules.__order; _b < _c.length; _b++) {
        var selector = _c[_b];
        rulesToInsert.push(selector, serializeRuleEntries(options, rules[selector]));
      }
      registration.rulesToInsert = rulesToInsert;
    }
    return registration;
  }
  return undefined;
}
function applyRegistration(registration, specificityMultiplier, shadowConfig, sheet) {
  if (specificityMultiplier === undefined) {
    specificityMultiplier = 1;
  }
  var stylesheet = sheet !== null && sheet !== undefined ? sheet : Stylesheet.getInstance(shadowConfig);
  var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
  if (rulesToInsert) {
    for (var i = 0; i < rulesToInsert.length; i += 2) {
      var rules = rulesToInsert[i + 1];
      if (rules) {
        var selector = rulesToInsert[i];
        selector = selector.replace(/&/g, repeatString(".".concat(registration.className), specificityMultiplier));
        var processedRule = "".concat(selector, "{").concat(rules, "}").concat(selector.indexOf("@") === 0 ? "}" : "");
        stylesheet.insertRule(processedRule);
      }
    }
    stylesheet.cacheClassName(className, key, args, rulesToInsert);
  }
}
function styleToClassName(options) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  var registration = styleToRegistration.apply(undefined, __spreadArray([options], args, false));
  if (registration) {
    applyRegistration(registration, options.specificityMultiplier, options.shadowConfig, options.stylesheet);
    return registration.className;
  }
  return "";
}

/**
 * Concatenation helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */
function mergeStyles() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mergeCss(args, getStyleOptions());
}
/**
 * Concatenation helper, which can merge class names together. Skips over falsey values.
 * Accepts a set of options that will be used when calculating styles.
 *
 * @public
 */
function mergeCss(args, options) {
    var styleArgs = args instanceof Array ? args : [args];
    var opts = options || {};
    var hasShadowConfig = isShadowConfig(styleArgs[0]);
    if (hasShadowConfig) {
        opts.shadowConfig = styleArgs[0];
    }
    opts.stylesheet = Stylesheet.getInstance(opts.shadowConfig);
    var _a = extractStyleParts(opts.stylesheet, styleArgs), classes = _a.classes, objects = _a.objects;
    if (objects.length) {
        classes.push(styleToClassName(opts, objects));
    }
    return classes.join(' ');
}

/**
 * Combine a set of styles together (but does not register css classes).
 * @param styleSets - One or more stylesets to be merged (each param can also be falsy).
 */
function concatStyleSets() {
    var styleSets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styleSets[_i] = arguments[_i];
    }
    if (styleSets.length === 1 &&
        styleSets[0] &&
        !styleSets[0].subComponentStyles &&
        !isShadowConfig(styleSets[0])) {
        return styleSets[0];
    }
    var mergedSet = {};
    // We process sub component styles in two phases. First we collect them, then we combine them into 1 style function.
    var workingSubcomponentStyles = {};
    for (var _a = 0, styleSets_1 = styleSets; _a < styleSets_1.length; _a++) {
        var currentSet = styleSets_1[_a];
        if (currentSet && !isShadowConfig(currentSet)) {
            for (var prop in currentSet) {
                if (currentSet.hasOwnProperty(prop)) {
                    if (prop === 'subComponentStyles' && currentSet.subComponentStyles !== undefined) {
                        // subcomponent styles - style functions or objects
                        var currentComponentStyles = currentSet.subComponentStyles;
                        for (var subCompProp in currentComponentStyles) {
                            if (currentComponentStyles.hasOwnProperty(subCompProp)) {
                                if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
                                    workingSubcomponentStyles[subCompProp].push(currentComponentStyles[subCompProp]);
                                }
                                else {
                                    workingSubcomponentStyles[subCompProp] = [currentComponentStyles[subCompProp]];
                                }
                            }
                        }
                        continue;
                    }
                    // the as any casts below is a workaround for ts 2.8.
                    // todo: remove cast to any in ts 2.9.
                    var mergedValue = mergedSet[prop];
                    var currentValue = currentSet[prop];
                    if (mergedValue === undefined) {
                        mergedSet[prop] = currentValue;
                    }
                    else {
                        mergedSet[prop] = __spreadArray(__spreadArray([], (Array.isArray(mergedValue) ? mergedValue : [mergedValue]), true), (Array.isArray(currentValue) ? currentValue : [currentValue]), true);
                    }
                }
            }
        }
    }
    if (Object.keys(workingSubcomponentStyles).length > 0) {
        mergedSet.subComponentStyles = {};
        var mergedSubStyles = mergedSet.subComponentStyles;
        var _loop_1 = function (subCompProp) {
            if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
                var workingSet_1 = workingSubcomponentStyles[subCompProp];
                mergedSubStyles[subCompProp] = function (styleProps) {
                    return concatStyleSets.apply(undefined, workingSet_1.map(function (styleFunctionOrObject) {
                        return typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject;
                    }));
                };
            }
        };
        // now we process the subcomponent styles if there are any
        for (var subCompProp in workingSubcomponentStyles) {
            _loop_1(subCompProp);
        }
    }
    return mergedSet;
}

/**
 * Takes in one or more style set objects, each consisting of a set of areas,
 * each which will produce a class name. Using this is analogous to calling
 * `mergeStyles` for each property in the object, but ensures we maintain the
 * set ordering when multiple style sets are merged.
 *
 * @param styleSets - One or more style sets to be merged.
 */
function mergeStyleSets() {
    var styleSets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styleSets[_i] = arguments[_i];
    }
    return mergeCssSets(styleSets, getStyleOptions());
}
/**
 * Takes in one or more style set objects, each1consisting of a set of areas,
 * each which will produce a class name. Using this is analogous to calling
 * `mergeCss` for each property in the object, but ensures the
 * set ordering when multiple style sets are merged.
 *
 * @param styleSets - One or more style sets to be merged.
 * @param options - (optional) Options to use when creating rules.
 */
function mergeCssSets(styleSets, options) {
    var classNameSet = { subComponentStyles: {} };
    var shadowConfig = undefined;
    var styleSet;
    if (isShadowConfig(styleSets[0])) {
        shadowConfig = styleSets[0];
        styleSet = styleSets[1];
    }
    else {
        styleSet = styleSets[0];
    }
    shadowConfig !== null && shadowConfig !== undefined ? shadowConfig : (shadowConfig = options === null || options === undefined ? undefined : options.shadowConfig);
    var opts = __assign$2(__assign$2({}, options), { shadowConfig: shadowConfig });
    if (!styleSet && styleSets.length <= 1) {
        return { subComponentStyles: {} };
    }
    var sheet = Stylesheet.getInstance(shadowConfig);
    opts.stylesheet = sheet;
    var concatenatedStyleSet = concatStyleSets.apply(undefined, styleSets);
    var registrations = [];
    for (var styleSetArea in concatenatedStyleSet) {
        if (concatenatedStyleSet.hasOwnProperty(styleSetArea)) {
            if (styleSetArea === 'subComponentStyles') {
                classNameSet.subComponentStyles = concatenatedStyleSet.subComponentStyles || {};
                continue;
            }
            else if (styleSetArea === '__shadowConfig__') {
                continue;
            }
            var styles = concatenatedStyleSet[styleSetArea];
            var _a = extractStyleParts(sheet, styles), classes = _a.classes, objects = _a.objects;
            if (objects === null || objects === undefined ? undefined : objects.length) {
                var registration = styleToRegistration(opts || {}, { displayName: styleSetArea }, objects);
                if (registration) {
                    registrations.push(registration);
                    classNameSet[styleSetArea] = classes.concat([registration.className]).join(' ');
                }
            }
            else {
                classNameSet[styleSetArea] = classes.join(' ');
            }
        }
    }
    for (var _i = 0, registrations_1 = registrations; _i < registrations_1.length; _i++) {
        var registration = registrations_1[_i];
        if (registration) {
            applyRegistration(registration, options === null || options === undefined ? undefined : options.specificityMultiplier, shadowConfig);
        }
    }
    return classNameSet;
}

/**
 * Concatenates style sets into one, but resolves functional sets using the given props.
 * @param styleProps - Props used to resolve functional sets.
 * @param allStyles - Style sets, which can be functions or objects.
 */
function concatStyleSetsWithProps(styleProps) {
    var allStyles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        allStyles[_i - 1] = arguments[_i];
    }
    var result = [];
    for (var _a = 0, allStyles_1 = allStyles; _a < allStyles_1.length; _a++) {
        var styles = allStyles_1[_a];
        if (styles) {
            result.push(typeof styles === 'function' ? styles(styleProps) : styles);
        }
    }
    if (result.length === 1) {
        return result[0];
    }
    else if (result.length) {
        // cliffkoh: I cannot figure out how to avoid the cast to any here.
        // It is something to do with the use of Omit in IStyleSet.
        // It might not be necessary once  Omit becomes part of lib.d.ts (when we remove our own Omit and rely on
        // the official version).
        return concatStyleSets.apply(undefined, result);
    }
    return {};
}

/**
 * Registers a font face.
 * @public
 */
function fontFace(font) {
    var stylesheet = Stylesheet.getInstance();
    var rule = serializeRuleEntries(getStyleOptions(), font);
    var className = stylesheet.classNameFromKey(rule);
    if (className) {
        return;
    }
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@font-face{".concat(rule, "}"), true);
    stylesheet.cacheClassName(name, rule, [], ['font-face', rule]);
}

/**
 * Registers keyframe definitions.
 *
 * @public
 */
function keyframes(timeline) {
    var stylesheet = Stylesheet.getInstance();
    var rulesArray = [];
    for (var prop in timeline) {
        if (timeline.hasOwnProperty(prop)) {
            rulesArray.push(prop, '{', serializeRuleEntries(getStyleOptions(), timeline[prop]), '}');
        }
    }
    var rules = rulesArray.join('');
    var className = stylesheet.classNameFromKey(rules);
    if (className) {
        return className;
    }
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@keyframes ".concat(name, "{").concat(rules, "}"), true);
    stylesheet.cacheClassName(name, rules, [], ['keyframes', rules]);
    return name;
}

/**
 * Builds a class names object from a given map.
 *
 * @param styles - Map of unprocessed styles.
 * @returns Map of property name to class name.
 */
function buildClassMap(styles) {
    var classes = {};
    var _loop_1 = function (styleName) {
        if (styles.hasOwnProperty(styleName)) {
            var className_1;
            Object.defineProperty(classes, styleName, {
                get: function () {
                    if (className_1 === undefined) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        className_1 = mergeStyles(styles[styleName]).toString();
                    }
                    return className_1;
                },
                enumerable: true,
                configurable: true,
            });
        }
    };
    for (var styleName in styles) {
        _loop_1(styleName);
    }
    return classes;
}

function canUseDOM$2() {
  return (
    // eslint-disable-next-line no-restricted-globals
    typeof window !== "undefined" && !!// eslint-disable-next-line no-restricted-globals, @typescript-eslint/no-deprecated
    (window.document && window.document.createElement)
  );
}

var _window = undefined;
try {
  _window = window;
} catch (e) {
}
function getWindow$2(rootElement) {
  if (!canUseDOM$2() || typeof _window === "undefined") {
    return undefined;
  } else {
    var el = rootElement;
    return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : _window;
  }
}

/**
 * Bugs often appear in async code when stuff gets disposed, but async operations don't get canceled.
 * This Async helper class solves these issues by tying async code to the lifetime of a disposable object.
 *
 * Usage: Anything class extending from BaseModel can access this helper via this.async. Otherwise create a
 * new instance of the class and remember to call dispose() during your code's dispose handler.
 *
 * @public
 */
var Async = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Async(parent, onError) {
        this._timeoutIds = null;
        this._immediateIds = null;
        this._intervalIds = null;
        this._animationFrameIds = null;
        this._isDisposed = false;
        this._parent = parent || null;
        this._onErrorHandler = onError;
        this._noop = function () {
            /* do nothing */
        };
    }
    /**
     * Dispose function, clears all async operations.
     */
    Async.prototype.dispose = function () {
        var id;
        this._isDisposed = true;
        this._parent = null;
        // Clear timeouts.
        if (this._timeoutIds) {
            for (id in this._timeoutIds) {
                if (this._timeoutIds.hasOwnProperty(id)) {
                    this.clearTimeout(parseInt(id, 10));
                }
            }
            this._timeoutIds = null;
        }
        // Clear immediates.
        if (this._immediateIds) {
            for (id in this._immediateIds) {
                if (this._immediateIds.hasOwnProperty(id)) {
                    this.clearImmediate(parseInt(id, 10));
                }
            }
            this._immediateIds = null;
        }
        // Clear intervals.
        if (this._intervalIds) {
            for (id in this._intervalIds) {
                if (this._intervalIds.hasOwnProperty(id)) {
                    this.clearInterval(parseInt(id, 10));
                }
            }
            this._intervalIds = null;
        }
        // Clear animation frames.
        if (this._animationFrameIds) {
            for (id in this._animationFrameIds) {
                if (this._animationFrameIds.hasOwnProperty(id)) {
                    this.cancelAnimationFrame(parseInt(id, 10));
                }
            }
            this._animationFrameIds = null;
        }
    };
    /**
     * SetTimeout override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */
    Async.prototype.setTimeout = function (callback, duration) {
        var _this = this;
        var timeoutId = 0;
        if (!this._isDisposed) {
            if (!this._timeoutIds) {
                this._timeoutIds = {};
            }
            timeoutId = setTimeout(function () {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._timeoutIds) {
                        delete _this._timeoutIds[timeoutId];
                    }
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            }, duration);
            this._timeoutIds[timeoutId] = true;
        }
        return timeoutId;
    };
    /**
     * Clears the timeout.
     * @param id - Id to cancel.
     */
    Async.prototype.clearTimeout = function (id) {
        if (this._timeoutIds && this._timeoutIds[id]) {
            clearTimeout(id);
            delete this._timeoutIds[id];
        }
    };
    /**
     * SetImmediate override, which will auto cancel the immediate during dispose.
     * @param callback - Callback to execute.
     * @param targetElement - Optional target element to use for identifying the correct window.
     * @returns The setTimeout id.
     */
    Async.prototype.setImmediate = function (callback, targetElement) {
        var _this = this;
        var immediateId = 0;
        var win = getWindow$2(targetElement);
        if (!this._isDisposed) {
            if (!this._immediateIds) {
                this._immediateIds = {};
            }
            var setImmediateCallback = function () {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._immediateIds) {
                        delete _this._immediateIds[immediateId];
                    }
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            };
            immediateId = win.setTimeout(setImmediateCallback, 0);
            this._immediateIds[immediateId] = true;
        }
        return immediateId;
    };
    /**
     * Clears the immediate.
     * @param id - Id to cancel.
     * @param targetElement - Optional target element to use for identifying the correct window.
     */
    Async.prototype.clearImmediate = function (id, targetElement) {
        var win = getWindow$2(targetElement);
        if (this._immediateIds && this._immediateIds[id]) {
            win.clearTimeout(id);
            delete this._immediateIds[id];
        }
    };
    /**
     * SetInterval override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */
    Async.prototype.setInterval = function (callback, duration) {
        var _this = this;
        var intervalId = 0;
        if (!this._isDisposed) {
            if (!this._intervalIds) {
                this._intervalIds = {};
            }
            intervalId = setInterval(function () {
                // Time to execute the interval callback, enqueue it as a foreground task to be executed.
                try {
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            }, duration);
            this._intervalIds[intervalId] = true;
        }
        return intervalId;
    };
    /**
     * Clears the interval.
     * @param id - Id to cancel.
     */
    Async.prototype.clearInterval = function (id) {
        if (this._intervalIds && this._intervalIds[id]) {
            clearInterval(id);
            delete this._intervalIds[id];
        }
    };
    /**
     * Creates a function that, when executed, will only call the func function at most once per
     * every wait milliseconds. Provide an options object to indicate that func should be invoked
     * on the leading and/or trailing edge of the wait timeout. Subsequent calls to the throttled
     * function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the throttled function is invoked more than once during the wait timeout.
     *
     * @param func - The function to throttle.
     * @param wait - The number of milliseconds to throttle executions to. Defaults to 0.
     * @param options - The options object.
     * @returns The new throttled function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype.throttle = function (func, wait, options) {
        var _this = this;
        if (this._isDisposed) {
            return this._noop;
        }
        var waitMS = wait || 0;
        var leading = true;
        var trailing = true;
        var lastExecuteTime = 0;
        var lastResult;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === 'boolean') {
            leading = options.leading;
        }
        if (options && typeof options.trailing === 'boolean') {
            trailing = options.trailing;
        }
        var callback = function (userCall) {
            var now = Date.now();
            var delta = now - lastExecuteTime;
            var waitLength = leading ? waitMS - delta : waitMS;
            if (delta >= waitMS && (!userCall || leading)) {
                lastExecuteTime = now;
                if (timeoutId) {
                    _this.clearTimeout(timeoutId);
                    timeoutId = null;
                }
                lastResult = func.apply(_this._parent, lastArgs);
            }
            else if (timeoutId === null && trailing) {
                timeoutId = _this.setTimeout(callback, waitLength);
            }
            return lastResult;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultFunction = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastArgs = args;
            return callback(true);
        });
        return resultFunction;
    };
    /**
     * Creates a function that will delay the execution of func until after wait milliseconds have
     * elapsed since the last time it was invoked. Provide an options object to indicate that func
     * should be invoked on the leading and/or trailing edge of the wait timeout. Subsequent calls
     * to the debounced function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the debounced function is invoked more than once during the wait
     * timeout.
     *
     * @param func - The function to debounce.
     * @param wait - The number of milliseconds to delay.
     * @param options - The options object.
     * @returns The new debounced function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype.debounce = function (func, wait, options) {
        var _this = this;
        if (this._isDisposed) {
            var noOpFunction = (function () {
                /** Do nothing */
            });
            noOpFunction.cancel = function () {
                return;
            };
            noOpFunction.flush = (function () { return null; });
            noOpFunction.pending = function () { return false; };
            return noOpFunction;
        }
        var waitMS = wait || 0;
        var leading = false;
        var trailing = true;
        var maxWait = null;
        var lastCallTime = 0;
        var lastExecuteTime = Date.now();
        var lastResult;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === 'boolean') {
            leading = options.leading;
        }
        if (options && typeof options.trailing === 'boolean') {
            trailing = options.trailing;
        }
        if (options && typeof options.maxWait === 'number' && !isNaN(options.maxWait)) {
            maxWait = options.maxWait;
        }
        var markExecuted = function (time) {
            if (timeoutId) {
                _this.clearTimeout(timeoutId);
                timeoutId = null;
            }
            lastExecuteTime = time;
        };
        var invokeFunction = function (time) {
            markExecuted(time);
            lastResult = func.apply(_this._parent, lastArgs);
        };
        var callback = function (userCall) {
            var now = Date.now();
            var executeImmediately = false;
            if (userCall) {
                if (leading && now - lastCallTime >= waitMS) {
                    executeImmediately = true;
                }
                lastCallTime = now;
            }
            var delta = now - lastCallTime;
            var waitLength = waitMS - delta;
            var maxWaitDelta = now - lastExecuteTime;
            var maxWaitExpired = false;
            if (maxWait !== null) {
                // maxWait only matters when there is a pending callback
                if (maxWaitDelta >= maxWait && timeoutId) {
                    maxWaitExpired = true;
                }
                else {
                    waitLength = Math.min(waitLength, maxWait - maxWaitDelta);
                }
            }
            if (delta >= waitMS || maxWaitExpired || executeImmediately) {
                invokeFunction(now);
            }
            else if ((timeoutId === null || !userCall) && trailing) {
                timeoutId = _this.setTimeout(callback, waitLength);
            }
            return lastResult;
        };
        var pending = function () {
            return !!timeoutId;
        };
        var cancel = function () {
            if (pending()) {
                // Mark the debounced function as having executed
                markExecuted(Date.now());
            }
        };
        var flush = function () {
            if (pending()) {
                invokeFunction(Date.now());
            }
            return lastResult;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultFunction = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastArgs = args;
            return callback(true);
        });
        resultFunction.cancel = cancel;
        resultFunction.flush = flush;
        resultFunction.pending = pending;
        return resultFunction;
    };
    Async.prototype.requestAnimationFrame = function (callback, targetElement) {
        var _this = this;
        var animationFrameId = 0;
        var win = getWindow$2(targetElement);
        if (!this._isDisposed) {
            if (!this._animationFrameIds) {
                this._animationFrameIds = {};
            }
            var animationFrameCallback = function () {
                try {
                    // Now delete the record and call the callback.
                    if (_this._animationFrameIds) {
                        delete _this._animationFrameIds[animationFrameId];
                    }
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            };
            animationFrameId = win.requestAnimationFrame
                ? win.requestAnimationFrame(animationFrameCallback)
                : win.setTimeout(animationFrameCallback, 0);
            this._animationFrameIds[animationFrameId] = true;
        }
        return animationFrameId;
    };
    Async.prototype.cancelAnimationFrame = function (id, targetElement) {
        var win = getWindow$2(targetElement);
        if (this._animationFrameIds && this._animationFrameIds[id]) {
            win.cancelAnimationFrame ? win.cancelAnimationFrame(id) : win.clearTimeout(id);
            delete this._animationFrameIds[id];
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype._logError = function (e) {
        if (this._onErrorHandler) {
            this._onErrorHandler(e);
        }
    };
    return Async;
}());

/**
 * Determines whether or not an element has the virtual hierarchy extension.
 *
 * @public
 */
function isVirtualElement$1(element) {
    return element && !!element._virtual;
}

/**
 * Gets the virtual parent given the child element, if it exists.
 *
 * @public
 */
function getVirtualParent$1(child) {
    var parent;
    if (child && isVirtualElement$1(child)) {
        parent = child._virtual.parent;
    }
    return parent;
}

/**
 * Gets the element which is the parent of a given element.
 * If `allowVirtuaParents` is `true`, this method prefers the virtual parent over
 * real DOM parent when present.
 *
 * @public
 */
function getParent$1(child, allowVirtualParents) {
    var _a, _b;
    if (allowVirtualParents === undefined) { allowVirtualParents = true; }
    if (!child) {
        return null;
    }
    var parent = allowVirtualParents && getVirtualParent$1(child);
    if (parent) {
        return parent;
    }
    // Support looking for parents in shadow DOM
    if (typeof child.assignedElements !== 'function' && ((_a = child.assignedSlot) === null || _a === undefined ? undefined : _a.parentNode)) {
        // Element is slotted
        return child.assignedSlot;
    }
    else if (((_b = child.parentNode) === null || _b === undefined ? undefined : _b.nodeType) === 11) {
        // nodeType 11 is DOCUMENT_FRAGMENT
        // Element is in shadow root
        return child.parentNode.host;
    }
    else {
        return child.parentNode;
    }
}

/**
 * Determines whether or not a parent element contains a given child element.
 * If `allowVirtualParents` is true, this method may return `true` if the child
 * has the parent in its virtual element hierarchy.
 *
 * @public
 */
function elementContains$1(parent, child, allowVirtualParents) {
    if (allowVirtualParents === undefined) { allowVirtualParents = true; }
    var isContained = false;
    if (parent && child) {
        if (allowVirtualParents) {
            if (parent === child) {
                isContained = true;
            }
            else {
                isContained = false;
                while (child) {
                    var nextParent = getParent$1(child);
                    if (nextParent === parent) {
                        isContained = true;
                        break;
                    }
                    child = nextParent;
                }
            }
        }
        else if (parent.contains) {
            isContained = parent.contains(child);
        }
    }
    return isContained;
}

function findElementRecursive(element, matchFunction, doc) {
  doc !== null && doc !== undefined ? doc : doc = document;
  if (!element || element === doc.body || element instanceof Document) {
    return null;
  }
  return matchFunction(element) ? element : findElementRecursive(getParent$1(element), matchFunction);
}

/**
 * Determines if an element, or any of its ancestors, contain the given attribute
 * @param element - element to start searching at
 * @param attribute - the attribute to search for
 * @returns the value of the first instance found
 */
function elementContainsAttribute(element, attribute, doc) {
    var elementMatch = findElementRecursive(element, function (testElement) { return testElement.hasAttribute(attribute); }, doc);
    return elementMatch && elementMatch.getAttribute(attribute);
}

var getActiveElement = function (doc) {
    var ae = doc.activeElement;
    while (ae === null || ae === undefined ? undefined : ae.shadowRoot) {
        ae = ae.shadowRoot.activeElement;
    }
    return ae;
};

var getEventTarget = function (event) {
    var target = event.target;
    if (target && target.shadowRoot) {
        target = event.composedPath()[0];
    }
    return target;
};

var DATA_PORTAL_ATTRIBUTE = 'data-portal-element';
/**
 * Identify element as a portal by setting an attribute.
 * @param element - Element to mark as a portal.
 */
function setPortalAttribute(element) {
    element.setAttribute(DATA_PORTAL_ATTRIBUTE, 'true');
}

/**
 * Determine whether a target is within a portal from perspective of root or optional parent.
 * This function only works against portal components that use the setPortalAttribute function.
 * If both parent and child are within the same portal this function will return false.
 * @param target - Element to query portal containment status of.
 * @param parent - Optional parent perspective. Search for containing portal stops at parent
 * (or root if parent is undefined or invalid.)
 */
function portalContainsElement(target, parent, doc) {
    var _a;
    var elementMatch = findElementRecursive(target, function (testElement) { var _a; return parent === testElement || !!((_a = testElement.hasAttribute) === null || _a === undefined ? undefined : _a.call(testElement, DATA_PORTAL_ATTRIBUTE)); }, doc);
    return elementMatch !== null && !!((_a = elementMatch.hasAttribute) === null || _a === undefined ? undefined : _a.call(elementMatch, DATA_PORTAL_ATTRIBUTE));
}

/**
 * Sets the virtual parent of an element.
 * Pass `undefined` as the `parent` to clear the virtual parent.
 *
 * @public
 */
function setVirtualParent$1(child, parent) {
    var virtualChild = child;
    var virtualParent = parent;
    if (!virtualChild._virtual) {
        virtualChild._virtual = {
            children: [],
        };
    }
    var oldParent = virtualChild._virtual.parent;
    if (oldParent && oldParent !== parent) {
        // Remove the child from its old parent.
        var index = oldParent._virtual.children.indexOf(virtualChild);
        if (index > -1) {
            oldParent._virtual.children.splice(index, 1);
        }
    }
    virtualChild._virtual.parent = virtualParent || undefined;
    if (virtualParent) {
        if (!virtualParent._virtual) {
            virtualParent._virtual = {
                children: [],
            };
        }
        virtualParent._virtual.children.push(virtualChild);
    }
}

function getDocument$1(rootElement) {
  if (!canUseDOM$2() || typeof document === "undefined") {
    return undefined;
  } else {
    var el = rootElement;
    return el && el.ownerDocument ? el.ownerDocument : document;
  }
}

var IS_FOCUSABLE_ATTRIBUTE$1 = 'data-is-focusable';
var IS_VISIBLE_ATTRIBUTE = 'data-is-visible';
var FOCUSZONE_ID_ATTRIBUTE$1 = 'data-focuszone-id';
var FOCUSZONE_SUB_ATTRIBUTE = 'data-is-sub-focuszone';
/**
 * Gets the first focusable element.
 *
 * @public
 */
function getFirstFocusable(rootElement, currentElement, includeElementsInFocusZones, includeShadowRoots) {
    return getNextElement(rootElement, currentElement, true /*checkNode*/, false /*suppressParentTraversal*/, false /*suppressChildTraversal*/, includeElementsInFocusZones, undefined, undefined, undefined, includeShadowRoots);
}
/**
 * Gets the last focusable element.
 *
 * @public
 */
function getLastFocusable(rootElement, currentElement, includeElementsInFocusZones, includeShadowRoots) {
    return getPreviousElement(rootElement, currentElement, true /*checkNode*/, false /*suppressParentTraversal*/, true /*traverseChildren*/, includeElementsInFocusZones, undefined, undefined, includeShadowRoots);
}
/**
 * Gets the first tabbable element. (The difference between focusable and tabbable is that tabbable elements are
 * focusable elements that also have tabIndex != -1.)
 * @param rootElement - The parent element to search beneath.
 * @param currentElement - The descendant of rootElement to start the search at.  This element is the first one checked,
 * and iteration continues forward.  Typical use passes rootElement.firstChild.
 * @param includeElementsInFocusZones - true if traversal should go into FocusZone descendants.
 * @param checkNode - Include currentElement in search when true. Defaults to true.
 * @public
 */
function getFirstTabbable(rootElement, currentElement, includeElementsInFocusZones, checkNode, includeShadowRoots) {
    return getNextElement(rootElement, currentElement, checkNode, false /*suppressParentTraversal*/, false /*suppressChildTraversal*/, includeElementsInFocusZones, false /*allowFocusRoot*/, true /*tabbable*/, undefined, includeShadowRoots);
}
/**
 * Gets the last tabbable element. (The difference between focusable and tabbable is that tabbable elements are
 * focusable elements that also have tabIndex != -1.)
 * @param rootElement - The parent element to search beneath.
 * @param currentElement - The descendant of rootElement to start the search at.  This element is the first one checked,
 * and iteration continues in reverse.  Typical use passes rootElement.lastChild.
 * @param includeElementsInFocusZones - true if traversal should go into FocusZone descendants.
 * @param checkNode - Include currentElement in search when true. Defaults to true.
 * @public
 */
function getLastTabbable(rootElement, currentElement, includeElementsInFocusZones, checkNode, includeShadowRoots) {
    return getPreviousElement(rootElement, currentElement, checkNode, false /*suppressParentTraversal*/, true /*traverseChildren*/, includeElementsInFocusZones, false /*allowFocusRoot*/, true /*tabbable*/, includeShadowRoots);
}
/**
 * Attempts to focus the first focusable element that is a child or child's child of the rootElement.
 *
 * @public
 * @param rootElement - Element to start the search for a focusable child.
 * @param bypassHiddenElements - If true, focus will be not be set on hidden elements.
 * @returns True if focus was set, false if it was not.
 */
function focusFirstChild(rootElement, bypassHiddenElements, includeShadowRoots) {
    var element = getNextElement(rootElement, rootElement, true, false, false, true, undefined, undefined, bypassHiddenElements, includeShadowRoots);
    if (element) {
        focusAsync(element);
        return true;
    }
    return false;
}
/**
 * Traverse to find the previous element.
 * If tabbable is true, the element must have tabIndex != -1.
 *
 * @public
 */
function getPreviousElement(rootElement, currentElement, checkNode, suppressParentTraversal, traverseChildren, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots) {
    var _a;
    if (!currentElement || (!allowFocusRoot && currentElement === rootElement)) {
        return null;
    }
    var isCurrentElementVisible = isElementVisible(currentElement);
    // Check its children.
    if (traverseChildren &&
        isCurrentElementVisible &&
        (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
        var lastElementChild = (currentElement.lastElementChild ||
            (includeShadowRoots && ((_a = currentElement.shadowRoot) === null || _a === undefined ? undefined : _a.lastElementChild)));
        var childMatch = getPreviousElement(rootElement, lastElementChild, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
        if (childMatch) {
            if ((tabbable && isElementTabbable(childMatch, true, includeShadowRoots)) || !tabbable) {
                return childMatch;
            }
            var childMatchSiblingMatch = getPreviousElement(rootElement, childMatch.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
            if (childMatchSiblingMatch) {
                return childMatchSiblingMatch;
            }
            var childMatchParent = childMatch.parentElement;
            // At this point if we have not found any potential matches
            // start looking at the rest of the subtree under the currentParent.
            // NOTE: We do not want to recurse here because doing so could
            // cause elements to get skipped.
            while (childMatchParent && childMatchParent !== currentElement) {
                var childMatchParentMatch = getPreviousElement(rootElement, childMatchParent.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
                if (childMatchParentMatch) {
                    return childMatchParentMatch;
                }
                childMatchParent = childMatchParent.parentElement;
            }
        }
    }
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable, includeShadowRoots)) {
        return currentElement;
    }
    // Check its previous sibling.
    var siblingMatch = getPreviousElement(rootElement, currentElement.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
    if (siblingMatch) {
        return siblingMatch;
    }
    // Check its parent.
    if (!suppressParentTraversal) {
        return getPreviousElement(rootElement, currentElement.parentElement, true, false, false, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
    }
    return null;
}
/**
 * Traverse to find the next focusable element.
 * If tabbable is true, the element must have tabIndex != -1.
 *
 * @public
 * @param checkNode - Include currentElement in search when true.
 */
function getNextElement(rootElement, currentElement, checkNode, suppressParentTraversal, suppressChildTraversal, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots) {
    var _a;
    if (!currentElement || (currentElement === rootElement && suppressChildTraversal && !allowFocusRoot)) {
        return null;
    }
    var checkElementVisibility = bypassHiddenElements ? isElementVisibleAndNotHidden : isElementVisible;
    var isCurrentElementVisible = checkElementVisibility(currentElement);
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable, includeShadowRoots)) {
        return currentElement;
    }
    // Check its children.
    if (!suppressChildTraversal &&
        isCurrentElementVisible &&
        (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
        var firstElementchild = (currentElement.firstElementChild ||
            (includeShadowRoots && ((_a = currentElement.shadowRoot) === null || _a === undefined ? undefined : _a.firstElementChild)));
        var childMatch = getNextElement(rootElement, firstElementchild, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots);
        if (childMatch) {
            return childMatch;
        }
    }
    if (currentElement === rootElement) {
        return null;
    }
    // Check its sibling.
    var siblingMatch = getNextElement(rootElement, currentElement.nextElementSibling, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots);
    if (siblingMatch) {
        return siblingMatch;
    }
    if (!suppressParentTraversal) {
        return getNextElement(rootElement, currentElement.parentElement, false, false, true, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots);
    }
    return null;
}
/**
 * Determines if an element is visible.
 *
 * @public
 */
function isElementVisible(element) {
    // If the element is not valid, return false.
    if (!element || !element.getAttribute) {
        return false;
    }
    var visibilityAttribute = element.getAttribute(IS_VISIBLE_ATTRIBUTE);
    // If the element is explicitly marked with the visibility attribute, return that value as boolean.
    if (visibilityAttribute !== null && visibilityAttribute !== undefined) {
        return visibilityAttribute === 'true';
    }
    // Fallback to other methods of determining actual visibility.
    return (element.offsetHeight !== 0 ||
        element.offsetParent !== null ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        element.isVisible === true); // used as a workaround for testing.
}
/**
 * Determines if an element is visible and not hidden
 * @param element - Element to check
 * @returns Returns true if the given element is visible and not hidden
 *
 * @public
 */
function isElementVisibleAndNotHidden(element, win) {
    var theWin = win !== null && win !== undefined ? win : getWindow$2();
    return (!!element &&
        isElementVisible(element) &&
        !element.hidden &&
        theWin.getComputedStyle(element).visibility !== 'hidden');
}
/**
 * Determines if an element can receive focus programmatically or via a mouse click.
 * If checkTabIndex is true, additionally checks to ensure the element can be focused with the tab key,
 * meaning tabIndex != -1.
 *
 * @public
 */
function isElementTabbable(element, checkTabIndex, checkShadowRoot) {
    if (checkShadowRoot === undefined) { checkShadowRoot = true; }
    // If this element is null or is disabled, it is not considered tabbable.
    if (!element || element.disabled) {
        return false;
    }
    var tabIndex = 0;
    var tabIndexAttributeValue = null;
    if (element && element.getAttribute) {
        tabIndexAttributeValue = element.getAttribute('tabIndex');
        if (tabIndexAttributeValue) {
            tabIndex = parseInt(tabIndexAttributeValue, 10);
        }
    }
    var isFocusableAttribute = element.getAttribute ? element.getAttribute(IS_FOCUSABLE_ATTRIBUTE$1) : null;
    var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
    var delegatesFocus = checkShadowRoot && element.shadowRoot ? !!element.shadowRoot.delegatesFocus : false;
    var result = !!element &&
        isFocusableAttribute !== 'false' &&
        (element.tagName === 'A' ||
            element.tagName === 'BUTTON' ||
            element.tagName === 'INPUT' ||
            element.tagName === 'TEXTAREA' ||
            element.tagName === 'SELECT' ||
            isFocusableAttribute === 'true' ||
            isTabIndexSet ||
            delegatesFocus);
    return checkTabIndex ? tabIndex !== -1 && result : result;
}
/**
 * Determines if a given element is a focus zone.
 *
 * @public
 */
function isElementFocusZone(element) {
    return !!(element && element.getAttribute && !!element.getAttribute(FOCUSZONE_ID_ATTRIBUTE$1));
}
/**
 * Determines if a given element is a focus sub zone.
 *
 * @public
 */
function isElementFocusSubZone(element) {
    return !!(element && element.getAttribute && element.getAttribute(FOCUSZONE_SUB_ATTRIBUTE) === 'true');
}
/**
 * Determines if an element, or any of its children, contain focus.
 *
 * @public
 */
function doesElementContainFocus(element) {
    var doc = getDocument$1(element);
    var currentActiveElement = doc && doc.activeElement;
    if (currentActiveElement && elementContains$1(element, currentActiveElement)) {
        return true;
    }
    return false;
}
/**
 * Determines if an, or any of its ancestors, sepcificies that it doesn't want focus to wrap
 * @param element - element to start searching from
 * @param noWrapDataAttribute - the no wrap data attribute to match (either)
 * @returns true if focus should wrap, false otherwise
 */
function shouldWrapFocus(element, noWrapDataAttribute, doc) {
    var theDoc = getDocument$1();
    return elementContainsAttribute(element, noWrapDataAttribute, theDoc) === 'true' ? false : true;
}
var animationId = undefined;
/**
 * Sets focus to an element asynchronously. The focus will be set at the next browser repaint,
 * meaning it won't cause any extra recalculations. If more than one focusAsync is called during one frame,
 * only the latest called focusAsync element will actually be focused
 * @param element - The element to focus
 */
function focusAsync(element) {
    if (element) {
        var win = getWindow$2(element);
        if (win) {
            // cancel any previous focus queues
            if (animationId !== undefined) {
                win.cancelAnimationFrame(animationId);
            }
            // element.focus() is a no-op if the element is no longer in the DOM, meaning this is always safe
            animationId = win.requestAnimationFrame(function () {
                element && element.focus();
                // We are done focusing for this frame, so reset the queued focus element
                animationId = undefined;
            });
        }
    }
}
/**
 * Finds the closest focusable element via an index path from a parent. See
 * `getElementIndexPath` for getting an index path from an element to a child.
 */
function getFocusableByIndexPath(parent, path) {
    var element = parent;
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var index = path_1[_i];
        var nextChild = element.children[Math.min(index, element.children.length - 1)];
        if (!nextChild) {
            break;
        }
        element = nextChild;
    }
    element =
        isElementTabbable(element) && isElementVisible(element)
            ? element
            : getNextElement(parent, element, true) || getPreviousElement(parent, element);
    return element;
}
/**
 * Finds the element index path from a parent element to a child element.
 *
 * If you had this node structure: "A has children [B, C] and C has child D",
 * the index path from A to D would be [1, 0], or `parent.chidren[1].children[0]`.
 */
function getElementIndexPath(fromElement, toElement) {
    var path = [];
    while (toElement && fromElement && toElement !== fromElement) {
        var parent_1 = getParent$1(toElement, true);
        if (parent_1 === null) {
            return [];
        }
        path.unshift(Array.prototype.indexOf.call(parent_1.children, toElement));
        toElement = parent_1;
    }
    return path;
}

function on(element, eventName, callback, options) {
    element.addEventListener(eventName, callback, options);
    return function () { return element.removeEventListener(eventName, callback, options); };
}

/**
 * Compares a to b and b to a.
 *
 * @public
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function shallowCompare(a, b) {
    if (!a || !b) {
        // only return true if both a and b are falsy
        return !a && !b;
    }
    for (var propName in a) {
        if (a.hasOwnProperty(propName)) {
            if (!b.hasOwnProperty(propName) || b[propName] !== a[propName]) {
                return false;
            }
        }
    }
    for (var propName in b) {
        if (b.hasOwnProperty(propName)) {
            if (!a.hasOwnProperty(propName)) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Makes a resulting merge of a bunch of objects. Pass in the target object followed by 1 or more
 * objects as arguments and they will be merged sequentially into the target. Note that this will
 * shallow merge; it will not create new cloned values for target members.
 *
 * @public
 * @param target - Target object to merge following object arguments into.
 * @param args - One or more objects that will be mixed into the target in the order they are provided.
 * @returns Resulting merged target.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function assign$2(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return filteredAssign.apply(this, [null, target].concat(args));
}
/**
 * Makes a resulting merge of a bunch of objects, but allows a filter function to be passed in to filter
 * the resulting merges. This allows for scenarios where you want to merge "everything except that one thing"
 * or "properties that start with data-". Note that this will shallow merge; it will not create new cloned
 * values for target members.
 *
 * @public
 * @param isAllowed - Callback to determine if the given propName is allowed in the result.
 * @param target - Target object to merge following object arguments into.
 * @param args - One or more objects that will be mixed into the target in the order they are provided.
 * @returns Resulting merged target.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function filteredAssign(isAllowed, target) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    target = target || {};
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var sourceObject = args_1[_a];
        if (sourceObject) {
            for (var propName in sourceObject) {
                if (sourceObject.hasOwnProperty(propName) && (!isAllowed || isAllowed(propName))) {
                    target[propName] = sourceObject[propName];
                }
            }
        }
    }
    return target;
}

/** An instance of EventGroup allows anything with a handle to it to trigger events on it.
 *  If the target is an HTMLElement, the event will be attached to the element and can be
 *  triggered as usual (like clicking for onClick).
 *  The event can be triggered by calling EventGroup.raise() here. If the target is an
 *  HTMLElement, the event gets raised and is handled by the browser. Otherwise, it gets
 *  handled here in EventGroup, and the handler is called in the context of the parent
 *  (which is passed in in the constructor).
 *
 * @public
 * {@docCategory EventGroup}
 */
var EventGroup = /** @class */ (function () {
    /** parent: the context in which events attached to non-HTMLElements are called */
    function EventGroup(parent) {
        this._id = EventGroup._uniqueId++;
        this._parent = parent;
        this._eventRecords = [];
    }
    /** For IE8, bubbleEvent is ignored here and must be dealt with by the handler.
     *  Events raised here by default have bubbling set to false and cancelable set to true.
     *  This applies also to built-in events being raised manually here on HTMLElements,
     *  which may lead to unexpected behavior if it differs from the defaults.
     *
     */
    EventGroup.raise = function (target, eventName, eventArgs, bubbleEvent, doc) {
        var retVal;
        var theDoc = doc !== null && doc !== undefined ? doc : getDocument$1();
        if (EventGroup._isElement(target)) {
            if (typeof theDoc !== 'undefined' && theDoc.createEvent) {
                var ev = theDoc.createEvent('HTMLEvents');
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                ev.initEvent(eventName, bubbleEvent || false, true);
                assign$2(ev, eventArgs);
                retVal = target.dispatchEvent(ev);
            }
            else if (typeof theDoc !== 'undefined' && theDoc.createEventObject) {
                // IE8
                var evObj = theDoc.createEventObject(eventArgs);
                // cannot set cancelBubble on evObj, fireEvent will overwrite it
                target.fireEvent('on' + eventName, evObj);
            }
        }
        else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
            while (target && retVal !== false) {
                var events = target.__events__;
                var eventRecords = events ? events[eventName] : null;
                if (eventRecords) {
                    for (var id in eventRecords) {
                        if (eventRecords.hasOwnProperty(id)) {
                            var eventRecordList = eventRecords[id];
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
                            for (var listIndex = 0; retVal !== false && listIndex < eventRecordList.length; listIndex++) {
                                var record = eventRecordList[listIndex];
                                if (record.objectCallback) {
                                    retVal = record.objectCallback.call(record.parent, eventArgs);
                                }
                            }
                        }
                    }
                }
                // If the target has a parent, bubble the event up.
                target = bubbleEvent ? target.parent : null;
            }
        }
        return retVal;
    };
    EventGroup.isObserved = function (target, eventName) {
        var events = target && target.__events__;
        return !!events && !!events[eventName];
    };
    /** Check to see if the target has declared support of the given event. */
    EventGroup.isDeclared = function (target, eventName) {
        var declaredEvents = target && target.__declaredEvents;
        return !!declaredEvents && !!declaredEvents[eventName];
    };
    EventGroup.stopPropagation = function (event) {
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        else {
            // IE8
            event.cancelBubble = true;
        }
    };
    EventGroup._isElement = function (target) {
        return (!!target && (!!target.addEventListener || (typeof HTMLElement !== 'undefined' && target instanceof HTMLElement)));
    };
    EventGroup.prototype.dispose = function () {
        if (!this._isDisposed) {
            this._isDisposed = true;
            this.off();
            this._parent = null;
        }
    };
    /** On the target, attach a set of events, where the events object is a name to function mapping. */
    EventGroup.prototype.onAll = function (target, events, useCapture) {
        for (var eventName in events) {
            if (events.hasOwnProperty(eventName)) {
                this.on(target, eventName, events[eventName], useCapture);
            }
        }
    };
    /**
     * On the target, attach an event whose handler will be called in the context of the parent
     * of this instance of EventGroup.
     */
    EventGroup.prototype.on = function (target, eventName, callback, options) {
        var _this = this;
        if (eventName.indexOf(',') > -1) {
            var events = eventName.split(/[ ,]+/);
            for (var i = 0; i < events.length; i++) {
                this.on(target, events[i], callback, options);
            }
        }
        else {
            var parent_1 = this._parent;
            var eventRecord = {
                target: target,
                eventName: eventName,
                parent: parent_1,
                callback: callback,
                options: options,
            };
            // Initialize and wire up the record on the target, so that it can call the callback if the event fires.
            var events = (target.__events__ = target.__events__ || {});
            events[eventName] =
                events[eventName] ||
                    {
                        count: 0,
                    };
            events[eventName][this._id] = events[eventName][this._id] || [];
            events[eventName][this._id].push(eventRecord);
            events[eventName].count++;
            if (EventGroup._isElement(target)) {
                var processElementEvent = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (_this._isDisposed) {
                        return;
                    }
                    var result;
                    try {
                        result = callback.apply(parent_1, args);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
                        if (result === false && args[0]) {
                            var e = args[0];
                            if (e.preventDefault) {
                                e.preventDefault();
                            }
                            if (e.stopPropagation) {
                                e.stopPropagation();
                            }
                            e.cancelBubble = true;
                        }
                    }
                    catch (e) {
                        // ignore
                    }
                    return result;
                };
                eventRecord.elementCallback = processElementEvent;
                if (target.addEventListener) {
                    target.addEventListener(eventName, processElementEvent, options);
                }
                else if (target.attachEvent) {
                    // IE8
                    target.attachEvent('on' + eventName, processElementEvent);
                }
            }
            else {
                var processObjectEvent = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (_this._isDisposed) {
                        return;
                    }
                    return callback.apply(parent_1, args);
                };
                eventRecord.objectCallback = processObjectEvent;
            }
            // Remember the record locally, so that it can be removed.
            this._eventRecords.push(eventRecord);
        }
    };
    EventGroup.prototype.off = function (target, eventName, callback, options) {
        for (var i = 0; i < this._eventRecords.length; i++) {
            var eventRecord = this._eventRecords[i];
            if ((!target || target === eventRecord.target) &&
                (!eventName || eventName === eventRecord.eventName) &&
                (!callback || callback === eventRecord.callback) &&
                (typeof options !== 'boolean' || options === eventRecord.options)) {
                var events = eventRecord.target.__events__;
                var targetArrayLookup = events[eventRecord.eventName];
                var targetArray = targetArrayLookup ? targetArrayLookup[this._id] : null;
                // We may have already target's entries, so check for null.
                if (targetArray) {
                    if (targetArray.length === 1 || !callback) {
                        targetArrayLookup.count -= targetArray.length;
                        delete events[eventRecord.eventName][this._id];
                    }
                    else {
                        targetArrayLookup.count--;
                        targetArray.splice(targetArray.indexOf(eventRecord), 1);
                    }
                    if (!targetArrayLookup.count) {
                        delete events[eventRecord.eventName];
                    }
                }
                if (eventRecord.elementCallback) {
                    if (eventRecord.target.removeEventListener) {
                        eventRecord.target.removeEventListener(eventRecord.eventName, eventRecord.elementCallback, eventRecord.options);
                    }
                    else if (eventRecord.target.detachEvent) {
                        // IE8
                        eventRecord.target.detachEvent('on' + eventRecord.eventName, eventRecord.elementCallback);
                    }
                }
                this._eventRecords.splice(i--, 1);
            }
        }
    };
    /** Trigger the given event in the context of this instance of EventGroup. */
    EventGroup.prototype.raise = function (eventName, eventArgs, bubbleEvent) {
        return EventGroup.raise(this._parent, eventName, eventArgs, bubbleEvent);
    };
    /** Declare an event as being supported by this instance of EventGroup. */
    EventGroup.prototype.declare = function (event) {
        var declaredEvents = (this._parent.__declaredEvents = this._parent.__declaredEvents || {});
        if (typeof event === 'string') {
            declaredEvents[event] = true;
        }
        else {
            for (var i = 0; i < event.length; i++) {
                declaredEvents[event[i]] = true;
            }
        }
    };
    EventGroup._uniqueId = 0;
    return EventGroup;
}());

var _scrollbarWidth;
var _bodyScrollDisabledCount = 0;
var DisabledScrollClassName = mergeStyles({
    overflow: 'hidden !important',
});
/**
 * Placing this attribute on scrollable divs optimizes detection to know
 * if the div is scrollable or not (given we can avoid expensive operations
 * like getComputedStyle.)
 *
 * @public
 */
var DATA_IS_SCROLLABLE_ATTRIBUTE = 'data-is-scrollable';
/**
 * Allows the user to scroll within a element,
 * while preventing the user from scrolling the body
 */
var allowScrollOnElement = function (element, events) {
    var window = getWindow$2(element);
    if (!element || !window) {
        return;
    }
    var _previousClientY = 0;
    var _element = null;
    var computedStyles = window.getComputedStyle(element);
    // remember the clientY for future calls of _preventOverscrolling
    var _saveClientY = function (event) {
        if (event.targetTouches.length === 1) {
            _previousClientY = event.targetTouches[0].clientY;
        }
    };
    // prevent the body from scrolling when the user attempts
    // to scroll past the top or bottom of the element
    var _preventOverscrolling = function (event) {
        // only respond to a single-finger touch
        if (event.targetTouches.length !== 1) {
            return;
        }
        // prevent the body touchmove handler from firing
        // so that scrolling is allowed within the element
        event.stopPropagation();
        if (!_element) {
            return;
        }
        var clientY = event.targetTouches[0].clientY - _previousClientY;
        var scrollableParent = findScrollableParent(event.target);
        if (scrollableParent && _element !== scrollableParent) {
            _element = scrollableParent;
            computedStyles = window.getComputedStyle(_element);
        }
        var scrollTop = _element.scrollTop;
        var isColumnReverse = (computedStyles === null || computedStyles === undefined ? undefined : computedStyles.flexDirection) === 'column-reverse';
        // if the element is scrolled to the top,
        // prevent the user from scrolling up
        if (scrollTop === 0 && (isColumnReverse ? clientY < 0 : clientY > 0)) {
            event.preventDefault();
        }
        // if the element is scrolled to the bottom,
        // prevent the user from scrolling down
        if (_element.scrollHeight - Math.abs(Math.ceil(scrollTop)) <= _element.clientHeight &&
            (isColumnReverse ? clientY > 0 : clientY < 0)) {
            event.preventDefault();
        }
    };
    events.on(element, 'touchstart', _saveClientY, { passive: false });
    events.on(element, 'touchmove', _preventOverscrolling, { passive: false });
    _element = element;
};
/**
 * Same as allowScrollOnElement but does not prevent overscrolling.
 */
var allowOverscrollOnElement = function (element, events) {
    if (!element) {
        return;
    }
    var _allowElementScroll = function (event) {
        event.stopPropagation();
    };
    events.on(element, 'touchmove', _allowElementScroll, { passive: false });
};
var _disableIosBodyScroll = function (event) {
    event.preventDefault();
};
/**
 * Disables the body scrolling.
 *
 * @public
 */
function disableBodyScroll() {
    var doc = getDocument$1();
    if (doc && doc.body && !_bodyScrollDisabledCount) {
        doc.body.classList.add(DisabledScrollClassName);
        doc.body.addEventListener('touchmove', _disableIosBodyScroll, { passive: false, capture: false });
    }
    _bodyScrollDisabledCount++;
}
/**
 * Enables the body scrolling.
 *
 * @public
 */
function enableBodyScroll() {
    if (_bodyScrollDisabledCount > 0) {
        var doc = getDocument$1();
        if (doc && doc.body && _bodyScrollDisabledCount === 1) {
            doc.body.classList.remove(DisabledScrollClassName);
            doc.body.removeEventListener('touchmove', _disableIosBodyScroll);
        }
        _bodyScrollDisabledCount--;
    }
}
/**
 * Calculates the width of a scrollbar for the browser/os.
 *
 * @public
 */
function getScrollbarWidth(doc) {
    if (_scrollbarWidth === undefined) {
        var theDoc = getDocument$1();
        var scrollDiv = theDoc.createElement('div');
        scrollDiv.style.setProperty('width', '100px');
        scrollDiv.style.setProperty('height', '100px');
        scrollDiv.style.setProperty('overflow', 'scroll');
        scrollDiv.style.setProperty('position', 'absolute');
        scrollDiv.style.setProperty('top', '-9999px');
        theDoc.body.appendChild(scrollDiv);
        // Get the scrollbar width
        _scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        // Delete the DIV
        theDoc.body.removeChild(scrollDiv);
    }
    return _scrollbarWidth;
}
/**
 * Traverses up the DOM for the element with the data-is-scrollable=true attribute, or returns
 * document.body.
 *
 * @public
 */
function findScrollableParent(startingElement) {
    var el = startingElement;
    var doc = getDocument$1(startingElement);
    // First do a quick scan for the scrollable attribute.
    while (el && el !== doc.body) {
        if (el.getAttribute(DATA_IS_SCROLLABLE_ATTRIBUTE) === 'true') {
            return el;
        }
        el = el.parentElement;
    }
    // If we haven't found it, the use the slower method: compute styles to evaluate if overflow is set.
    el = startingElement;
    while (el && el !== doc.body) {
        if (el.getAttribute(DATA_IS_SCROLLABLE_ATTRIBUTE) !== 'false') {
            var computedStyles = getComputedStyle(el);
            var overflowY = computedStyles ? computedStyles.getPropertyValue('overflow-y') : '';
            if (overflowY && (overflowY === 'scroll' || overflowY === 'auto')) {
                return el;
            }
        }
        el = el.parentElement;
    }
    // Fall back to window scroll.
    if (!el || el === doc.body) {
        el = getWindow$2(startingElement);
    }
    return el;
}

/* eslint-disable no-console */
/**
 * Sends a warning to console, if the api is present.
 *
 * @public
 * @param message - Warning message.
 */
function warn$1(message) {
    if (console && console.warn) {
        console.warn(message);
    }
}

/**
 * Warns when props are required if a condition is met.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param requiredProps - The name of the props that are required when the condition is met.
 * @param conditionalPropName - The name of the prop that the condition is based on.
 * @param condition - Whether the condition is met.
 */
function warnConditionallyRequiredProps(componentName, props, requiredProps, conditionalPropName, condition) {
    if (condition === true && process.env.NODE_ENV !== 'production') {
        for (var _i = 0, requiredProps_1 = requiredProps; _i < requiredProps_1.length; _i++) {
            var requiredPropName = requiredProps_1[_i];
            if (!(requiredPropName in props)) {
                warn$1("".concat(componentName, " property '").concat(requiredPropName, "' is required when '").concat(conditionalPropName, "' is used.'"));
            }
        }
    }
}

/**
 * Warns when two props which are mutually exclusive are both being used.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param exclusiveMap - A map where the key is a parameter, and the value is the other parameter.
 */
function warnMutuallyExclusive(componentName, props, exclusiveMap) {
    if (process.env.NODE_ENV !== 'production') {
        for (var propName in exclusiveMap) {
            if (props && props[propName] !== undefined) {
                var propInExclusiveMapValue = exclusiveMap[propName];
                if (propInExclusiveMapValue && props[propInExclusiveMapValue] !== undefined) {
                    warn$1("".concat(componentName, " property '").concat(propName, "' is mutually exclusive with '").concat(exclusiveMap[propName], "'. ") +
                        "Use one or the other.");
                }
            }
        }
    }
}

/**
 * Warns when a deprecated props are being used.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
 * either null or a replacement prop name.
 */
function warnDeprecations(componentName, props, deprecationMap) {
    if (process.env.NODE_ENV !== 'production') {
        for (var propName in deprecationMap) {
            if (props && propName in props) {
                var deprecationMessage = "".concat(componentName, " property '").concat(propName, "' was used but has been deprecated.");
                var replacementPropName = deprecationMap[propName];
                if (replacementPropName) {
                    deprecationMessage += " Use '".concat(replacementPropName, "' instead.");
                }
                warn$1(deprecationMessage);
            }
        }
    }
}

/**
 * BaseComponent class, which provides basic helpers for all components.
 *
 * @public
 * {@docCategory BaseComponent}
 *
 * @deprecated Do not use. We are moving away from class component.
 */
/** @class */ ((function (_super) {
    __extends$1(BaseComponent, _super);
    /**
     * BaseComponent constructor
     * @param props - The props for the component.
     * @param context - The context for the component.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function BaseComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        _makeAllSafe(_this, BaseComponent.prototype, [
            'componentDidMount',
            'shouldComponentUpdate',
            'getSnapshotBeforeUpdate',
            'render',
            'componentDidUpdate',
            'componentWillUnmount',
        ]);
        return _this;
    }
    /**
     * When the component receives props, make sure the componentRef is updated.
     */
    BaseComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        this._updateComponentRef(prevProps, this.props);
    };
    /**
     * When the component has mounted, update the componentRef.
     */
    BaseComponent.prototype.componentDidMount = function () {
        this._setComponentRef(this.props.componentRef, this);
    };
    /**
     * If we have disposables, dispose them automatically on unmount.
     */
    BaseComponent.prototype.componentWillUnmount = function () {
        this._setComponentRef(this.props.componentRef, null);
        if (this.__disposables) {
            for (var i = 0, len = this._disposables.length; i < len; i++) {
                var disposable = this.__disposables[i];
                if (disposable.dispose) {
                    disposable.dispose();
                }
            }
            this.__disposables = null;
        }
    };
    Object.defineProperty(BaseComponent.prototype, "className", {
        /**
         * Gets the object's class name.
         */
        get: function () {
            if (!this.__className) {
                var funcNameRegex = /function (.{1,})\(/;
                var results = funcNameRegex.exec(this.constructor.toString());
                this.__className = results && results.length > 1 ? results[1] : '';
            }
            return this.__className;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_disposables", {
        /**
         * Allows subclasses to push things to this._disposables to be auto disposed.
         */
        get: function () {
            if (!this.__disposables) {
                this.__disposables = [];
            }
            return this.__disposables;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_async", {
        /**
         * Gets the async instance associated with the component, created on demand. The async instance gives
         * subclasses a way to execute setTimeout/setInterval async calls safely, where the callbacks
         * will be cleared/ignored automatically after unmounting. The helpers within the async object also
         * preserve the this pointer so that you don't need to "bind" the callbacks.
         */
        get: function () {
            if (!this.__async) {
                this.__async = new Async(this);
                this._disposables.push(this.__async);
            }
            return this.__async;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_events", {
        /**
         * Gets the event group instance assocaited with the component, created on demand. The event instance
         * provides on/off methods for listening to DOM (or regular javascript object) events. The event callbacks
         * will be automatically disconnected after unmounting. The helpers within the events object also
         * preserve the this reference so that you don't need to "bind" the callbacks.
         */
        get: function () {
            if (!this.__events) {
                this.__events = new EventGroup(this);
                this._disposables.push(this.__events);
            }
            return this.__events;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Helper to return a memoized ref resolver function.
     * @param refName - Name of the member to assign the ref to.
     * @returns A function instance keyed from the given refname.
     * @deprecated Use `createRef` from React.createRef.
     */
    BaseComponent.prototype._resolveRef = function (refName) {
        var _this = this;
        if (!this.__resolves) {
            this.__resolves = {};
        }
        if (!this.__resolves[refName]) {
            this.__resolves[refName] = function (ref) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (_this[refName] = ref);
            };
        }
        return this.__resolves[refName];
    };
    /**
     * Updates the componentRef (by calling it with "this" when necessary.)
     */
    BaseComponent.prototype._updateComponentRef = function (currentProps, newProps) {
        if (newProps === undefined) { newProps = {}; }
        // currentProps *should* always be defined, but verify that just in case a subclass is manually
        // calling a lifecycle method with no parameters (which has happened) or other odd usage.
        if (currentProps && newProps && currentProps.componentRef !== newProps.componentRef) {
            this._setComponentRef(currentProps.componentRef, null);
            this._setComponentRef(newProps.componentRef, this);
        }
    };
    /**
     * Warns when a deprecated props are being used.
     *
     * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
     * either null or a replacement prop name.
     */
    BaseComponent.prototype._warnDeprecations = function (deprecationMap) {
        warnDeprecations(this.className, this.props, deprecationMap);
    };
    /**
     * Warns when props which are mutually exclusive with each other are both used.
     *
     * @param mutuallyExclusiveMap - The map of mutually exclusive props.
     */
    BaseComponent.prototype._warnMutuallyExclusive = function (mutuallyExclusiveMap) {
        warnMutuallyExclusive(this.className, this.props, mutuallyExclusiveMap);
    };
    /**
     * Warns when props are required if a condition is met.
     *
     * @param requiredProps - The name of the props that are required when the condition is met.
     * @param conditionalPropName - The name of the prop that the condition is based on.
     * @param condition - Whether the condition is met.
     */
    BaseComponent.prototype._warnConditionallyRequiredProps = function (requiredProps, conditionalPropName, condition) {
        warnConditionallyRequiredProps(this.className, this.props, requiredProps, conditionalPropName, condition);
    };
    BaseComponent.prototype._setComponentRef = function (ref, value) {
        if (!this._skipComponentRefResolution && ref) {
            if (typeof ref === 'function') {
                ref(value);
            }
            if (typeof ref === 'object') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ref.current = value;
            }
        }
    };
    return BaseComponent;
})(React.Component));
/**
 * Helper to override a given method with a wrapper method that can try/catch the original, but also
 * ensures that the BaseComponent's methods are called before the subclass's. This ensures that
 * componentWillUnmount in the base is called and that things in the _disposables array are disposed.
 */
// eslint-disable-next-line @typescript-eslint/no-deprecated
function _makeAllSafe(obj, prototype, methodNames) {
    for (var i = 0, len = methodNames.length; i < len; i++) {
        _makeSafe(obj, prototype, methodNames[i]);
    }
}
// eslint-disable-next-line @typescript-eslint/no-deprecated
function _makeSafe(obj, prototype, methodName) {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    var classMethod = obj[methodName];
    var prototypeMethod = prototype[methodName];
    if (classMethod || prototypeMethod) {
        obj[methodName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            /* eslint-enable @typescript-eslint/no-explicit-any */
            var retVal;
            if (prototypeMethod) {
                retVal = prototypeMethod.apply(this, args);
            }
            if (classMethod !== prototypeMethod) {
                retVal = classMethod.apply(this, args);
            }
            return retVal;
        };
    }
}
/**
 * Simple constant function for returning null, used to render empty templates in JSX.
 *
 * @public
 */
function nullRender() {
    return null;
}

var DelayedRender = (
  /** @class */
  function(_super) {
    __extends$1(DelayedRender2, _super);
    function DelayedRender2(props) {
      var _this = _super.call(this, props) || this;
      _this.state = {
        isRendered: getWindow$2() === undefined
      };
      return _this;
    }
    DelayedRender2.prototype.componentDidMount = function() {
      var _this = this;
      var delay = this.props.delay;
      this._timeoutId = window.setTimeout(function() {
        _this.setState({
          isRendered: true
        });
      }, delay);
    };
    DelayedRender2.prototype.componentWillUnmount = function() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
      }
    };
    DelayedRender2.prototype.render = function() {
      return this.state.isRendered ? React.Children.only(this.props.children) : null;
    };
    DelayedRender2.defaultProps = {
      delay: 0
    };
    return DelayedRender2;
  }(React.Component)
);

var GLOBAL_SETTINGS_PROP_NAME = "__globalSettings__";
var CALLBACK_STATE_PROP_NAME = "__callbacks__";
var _counter = 0;
var GlobalSettings = (
  /** @class */
  function() {
    function GlobalSettings2() {
    }
    GlobalSettings2.getValue = function(key, defaultValue) {
      var globalSettings = _getGlobalSettings();
      if (globalSettings[key] === undefined) {
        globalSettings[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue;
      }
      return globalSettings[key];
    };
    GlobalSettings2.setValue = function(key, value) {
      var globalSettings = _getGlobalSettings();
      var callbacks = globalSettings[CALLBACK_STATE_PROP_NAME];
      var oldValue = globalSettings[key];
      if (value !== oldValue) {
        globalSettings[key] = value;
        var changeDescription = {
          oldValue,
          value,
          key
        };
        for (var id in callbacks) {
          if (callbacks.hasOwnProperty(id)) {
            callbacks[id](changeDescription);
          }
        }
      }
      return value;
    };
    GlobalSettings2.addChangeListener = function(cb) {
      var id = cb.__id__;
      var callbacks = _getCallbacks();
      if (!id) {
        id = cb.__id__ = String(_counter++);
      }
      callbacks[id] = cb;
    };
    GlobalSettings2.removeChangeListener = function(cb) {
      var callbacks = _getCallbacks();
      delete callbacks[cb.__id__];
    };
    return GlobalSettings2;
  }()
);
function _getGlobalSettings() {
  var _a;
  var win = getWindow$2();
  var globalObj = win || {};
  if (!globalObj[GLOBAL_SETTINGS_PROP_NAME]) {
    globalObj[GLOBAL_SETTINGS_PROP_NAME] = (_a = {}, _a[CALLBACK_STATE_PROP_NAME] = {}, _a);
  }
  return globalObj[GLOBAL_SETTINGS_PROP_NAME];
}
function _getCallbacks() {
  var globalSettings = _getGlobalSettings();
  return globalSettings[CALLBACK_STATE_PROP_NAME];
}

/**
 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
 *
 * @public
 * {@docCategory KeyCodes}
 */
var KeyCodes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    pauseBreak: 19,
    capslock: 20,
    escape: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    del: 46,
    zero: 48,
    one: 49,
    two: 50,
    three: 51,
    four: 52,
    five: 53,
    six: 54,
    seven: 55,
    eight: 56,
    nine: 57,
    colon: 58,
    a: 65,
    b: 66,
    c: 67,
    d: 68,
    e: 69,
    f: 70,
    g: 71,
    h: 72,
    i: 73,
    j: 74,
    k: 75,
    l: 76,
    m: 77,
    n: 78,
    o: 79,
    p: 80,
    q: 81,
    r: 82,
    s: 83,
    t: 84,
    u: 85,
    v: 86,
    w: 87,
    x: 88,
    y: 89,
    z: 90,
    leftWindow: 91,
    rightWindow: 92,
    select: 93,
    /* eslint-disable @typescript-eslint/naming-convention */
    zero_numpad: 96,
    one_numpad: 97,
    two_numpad: 98,
    three_numpad: 99,
    four_numpad: 100,
    five_numpad: 101,
    six_numpad: 102,
    seven_numpad: 103,
    eight_numpad: 104,
    nine_numpad: 105,
    /* eslint-enable @typescript-eslint/naming-convention */
    multiply: 106,
    add: 107,
    subtract: 109,
    decimalPoint: 110,
    divide: 111,
    f1: 112,
    f2: 113,
    f3: 114,
    f4: 115,
    f5: 116,
    f6: 117,
    f7: 118,
    f8: 119,
    f9: 120,
    f10: 121,
    f11: 122,
    f12: 123,
    numlock: 144,
    scrollLock: 145,
    semicolon: 186,
    equalSign: 187,
    comma: 188,
    dash: 189,
    period: 190,
    forwardSlash: 191,
    graveAccent: 192,
    openBracket: 219,
    backSlash: 220,
    closeBracket: 221,
    singleQuote: 222,
};

/**
 * Rectangle helper class.
 *
 * @public
 * {@docCategory Rectangle}
 */
var Rectangle = /** @class */ (function () {
    function Rectangle(left, right, top, bottom) {
        if (left === undefined) { left = 0; }
        if (right === undefined) { right = 0; }
        if (top === undefined) { top = 0; }
        if (bottom === undefined) { bottom = 0; }
        this.top = top;
        this.bottom = bottom;
        this.left = left;
        this.right = right;
    }
    Object.defineProperty(Rectangle.prototype, "width", {
        /**
         * Calculated automatically by subtracting the right from left
         */
        get: function () {
            return this.right - this.left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "height", {
        /**
         * Calculated automatically by subtracting the bottom from top.
         */
        get: function () {
            return this.bottom - this.top;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Tests if another rect is approximately equal to this rect (within 4 decimal places.)
     */
    Rectangle.prototype.equals = function (rect) {
        // Fixing to 4 decimal places because it allows enough precision and will handle cases when something
        // should be rounded, like .999999 should round to 1.
        return (parseFloat(this.top.toFixed(4)) === parseFloat(rect.top.toFixed(4)) &&
            parseFloat(this.bottom.toFixed(4)) === parseFloat(rect.bottom.toFixed(4)) &&
            parseFloat(this.left.toFixed(4)) === parseFloat(rect.left.toFixed(4)) &&
            parseFloat(this.right.toFixed(4)) === parseFloat(rect.right.toFixed(4)));
    };
    return Rectangle;
}());

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Returns a single function which will call each of the given functions in the context of the
 * parent.
 */
function appendFunction(parent) {
    var functions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        functions[_i - 1] = arguments[_i];
    }
    if (functions.length < 2) {
        return functions[0];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        functions.forEach(function (f) { return f && f.apply(parent, args); });
    };
}

/**
 * ARIA helper to concatenate attributes, returning undefined if all attributes
 * are undefined. (Empty strings are not a valid ARIA attribute value.)
 *
 * @param ariaAttributes - ARIA attributes to merge
 */
function mergeAriaAttributeValues() {
    var ariaAttributes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        ariaAttributes[_i] = arguments[_i];
    }
    var mergedAttribute = ariaAttributes
        .filter(function (arg) { return arg; })
        .join(' ')
        .trim();
    return mergedAttribute === '' ? undefined : mergedAttribute;
}

/**
 * Helper to find the index of an item within an array, using a callback to
 * determine the match.
 *
 * @public
 * @param array - Array to search.
 * @param cb - Callback which returns true on matches.
 * @param fromIndex - Optional index to start from (defaults to 0)
 */
function findIndex(array, cb, fromIndex) {
    if (fromIndex === undefined) { fromIndex = 0; }
    var index = -1;
    for (var i = fromIndex; array && i < array.length; i++) {
        if (cb(array[i], i)) {
            index = i;
            break;
        }
    }
    return index;
}
/**
 * Helper to find the first item within an array that satisfies the callback.
 * @param array - Array to search
 * @param cb - Callback which returns true on matches
 */
function find$3(array, cb) {
    var index = findIndex(array, cb);
    if (index < 0) {
        return undefined;
    }
    return array[index];
}
/**
 * Given an array, this function returns a new array where an element has been inserted at the given index.
 * @param array - The array to operate on
 * @param index - The index where an element should be inserted
 * @param itemToAdd - The element to insert
 */
function addElementAtIndex(array, index, itemToAdd) {
    var copy = array.slice();
    copy.splice(index, 0, itemToAdd);
    return copy;
}
/**
 * Returns a boolean indicating if the two given arrays are equal in length and values.
 *
 * @param array1 - First array to compare
 * @param array2 - Second array to compare
 * @returns True if the arrays are the same length and have the same values in the same positions, false otherwise.
 */
function arraysEqual(array1, array2) {
    if (array1.length !== array2.length) {
        return false;
    }
    for (var i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }
    return true;
}

/**
 * Fetches an item from session storage without throwing an exception
 * @param key The key of the item to fetch from session storage
 */
function getItem$1(key) {
    var result = null;
    try {
        var win = getWindow$2();
        result = win ? win.sessionStorage.getItem(key) : null;
    }
    catch (e) {
        /* Eat the exception */
    }
    return result;
}
/**
 * Inserts an item into session storage without throwing an exception
 * @param key The key of the item to add to session storage
 * @param data The data to put into session storage
 */
function setItem(key, data) {
    var _a;
    try {
        (_a = getWindow$2()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem(key, data);
    }
    catch (e) {
        /* Eat the exception */
    }
}

var RTL_LOCAL_STORAGE_KEY = 'isRTL';
// Default to undefined so that we initialize on first read.
var _isRTL;
/**
 * Gets the rtl state of the page (returns true if in rtl.)
 */
function getRTL(theme) {
    if (theme === undefined) { theme = {}; }
    if (theme.rtl !== undefined) {
        return theme.rtl;
    }
    if (_isRTL === undefined) {
        // Fabric supports persisting the RTL setting between page refreshes via session storage
        var savedRTL = getItem$1(RTL_LOCAL_STORAGE_KEY);
        if (savedRTL !== null) {
            _isRTL = savedRTL === '1';
            setRTL(_isRTL);
        }
        var doc = getDocument$1();
        if (_isRTL === undefined && doc) {
            _isRTL = ((doc.body && doc.body.getAttribute('dir')) || doc.documentElement.getAttribute('dir')) === 'rtl';
            setRTL$1(_isRTL);
        }
    }
    return !!_isRTL;
}
/**
 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
 */
function setRTL(isRTL, persistSetting) {
    if (persistSetting === undefined) { persistSetting = false; }
    var doc = getDocument$1();
    if (doc) {
        doc.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    }
    if (persistSetting) {
        setItem(RTL_LOCAL_STORAGE_KEY, isRTL ? '1' : '0');
    }
    _isRTL = isRTL;
    setRTL$1(_isRTL);
}

var MAX_CACHE_COUNT = 50;
var DEFAULT_SPECIFICITY_MULTIPLIER = 5;
var _memoizedClassNames = 0;
var stylesheet$1 = Stylesheet.getInstance();
if (stylesheet$1 && stylesheet$1.onReset) {
    stylesheet$1.onReset(function () { return _memoizedClassNames++; });
}
// Note that because of the caching nature within the classNames memoization,
// I've disabled this rule to simply be able to work with any types.
/* eslint-disable @typescript-eslint/no-explicit-any */
// This represents a prop we attach to each Map to indicate the cached return value
// associated with the graph node.
var retVal = '__retval__';
/**
 * Creates a getClassNames function which calls getStyles given the props, and injects them
 * into mergeStyleSets.
 *
 * Note that the props you pass in on every render should be in the same order and
 * immutable (numbers, strings, and booleans). This will allow the results to be memoized. Violating
 * these will cause extra recalcs to occur.
 */
function classNamesFunction(options) {
    // We build a trie where each node is a Map. The map entry key represents an argument
    // value, and the entry value is another node (Map). Each node has a `__retval__`
    // property which is used to hold the cached response.
    if (options === undefined) { options = {}; }
    // To derive the response, we can simply ensure the arguments are added or already
    // exist in the trie. At the last node, if there is a `__retval__` we return that. Otherwise
    // we call the `getStyles` api to evaluate, cache on the property, and return that.
    // let map: IRecursiveMemoNode = new Map();
    var windowMap = new Map();
    var styleCalcCount = 0;
    var getClassNamesCount = 0;
    var currentMemoizedClassNames = _memoizedClassNames;
    var getClassNames = function (styleFunctionOrObject, styleProps) {
        var _a;
        if (styleProps === undefined) { styleProps = {}; }
        // If useStaticStyles is true, styleFunctionOrObject returns slot to classname mappings.
        // If there is also no style overrides, we can skip merge styles completely and
        // simply return the result from the style funcion.
        if (options.useStaticStyles &&
            typeof styleFunctionOrObject === 'function' &&
            styleFunctionOrObject.__noStyleOverride__) {
            return styleFunctionOrObject(styleProps);
        }
        getClassNamesCount++;
        var shadowConfig = styleFunctionOrObject
            ? styleFunctionOrObject.__shadowConfig__
            : undefined;
        var key = shadowConfig && shadowConfig.window ? shadowConfig.window : '__default__';
        if (!windowMap.has(key)) {
            windowMap.set(key, new Map());
        }
        var current = windowMap.get(key);
        // let current: Map<any, any> = map;
        var theme = styleProps.theme;
        var rtl = theme && theme.rtl !== undefined ? theme.rtl : getRTL();
        var disableCaching = options.disableCaching;
        // On reset of our stylesheet, reset memoized cache.
        if (currentMemoizedClassNames !== _memoizedClassNames) {
            currentMemoizedClassNames = _memoizedClassNames;
            // map = new Map();
            windowMap.set(key, new Map());
            current = windowMap.get(key);
            styleCalcCount = 0;
        }
        if (!options.disableCaching) {
            current = _traverseMap(windowMap.get(key), styleFunctionOrObject);
            current = _traverseMap(current, styleProps);
        }
        if (disableCaching || !current[retVal]) {
            if (styleFunctionOrObject === undefined) {
                current[retVal] = {};
            }
            else {
                current[retVal] = mergeCssSets([
                    (typeof styleFunctionOrObject === 'function'
                        ? styleFunctionOrObject(styleProps)
                        : styleFunctionOrObject),
                ], {
                    shadowConfig: styleFunctionOrObject.__shadowConfig__,
                    rtl: !!rtl,
                    specificityMultiplier: options.useStaticStyles ? DEFAULT_SPECIFICITY_MULTIPLIER : undefined,
                });
            }
            if (!disableCaching) {
                styleCalcCount++;
            }
        }
        if (styleCalcCount > (options.cacheSize || MAX_CACHE_COUNT)) {
            var win = getWindow$2();
            if ((_a = win === null || win === undefined ? undefined : win.FabricConfig) === null || _a === undefined ? undefined : _a.enableClassNameCacheFullWarning) {
                // eslint-disable-next-line no-console
                console.warn("Styles are being recalculated too frequently. Cache miss rate is ".concat(styleCalcCount, "/").concat(getClassNamesCount, "."));
                // eslint-disable-next-line no-console
                console.trace();
            }
            windowMap.get(key).clear();
            styleCalcCount = 0;
            // Mutate the options passed in, that's all we can do.
            options.disableCaching = true;
        }
        // Note: the retVal is an attached property on the Map; not a key in the Map. We use this attached property to
        // cache the return value for this branch of the graph.
        return current[retVal];
    };
    return getClassNames;
}
function _traverseEdge(current, value) {
    value = _normalizeValue(value);
    if (!current.has(value)) {
        current.set(value, new Map());
    }
    return current.get(value);
}
function _traverseMap(current, inputs) {
    if (typeof inputs === 'function') {
        var cachedInputsFromStyled = inputs.__cachedInputs__;
        if (cachedInputsFromStyled) {
            // The styled helper will generate the styles function and will attach the cached
            // inputs (consisting of the default styles, customzied styles, and user provided styles.)
            // These should be used as cache keys for deriving the memoized value.
            for (var _i = 0, _a = inputs.__cachedInputs__; _i < _a.length; _i++) {
                var input = _a[_i];
                current = _traverseEdge(current, input);
            }
        }
        else {
            current = _traverseEdge(current, inputs);
        }
    }
    else if (typeof inputs === 'object') {
        for (var propName in inputs) {
            if (inputs.hasOwnProperty(propName)) {
                current = _traverseEdge(current, inputs[propName]);
            }
        }
    }
    return current;
}
function _normalizeValue(value) {
    switch (value) {
        case undefined:
            return '__undefined__';
        case null:
            return '__null__';
        default:
            return value;
    }
}

var _initializedStylesheetResets$1 = false;
var _resetCounter = 0;
var _emptyObject = { empty: true };
var _dictionary = {};
var _weakMap = typeof WeakMap === 'undefined' ? null : WeakMap;
/**
 * Reset memoizations.
 */
function resetMemoizations() {
    _resetCounter++;
}
/**
 * Memoizes a function; when you pass in the same parameters multiple times, it returns a cached result.
 * Be careful when passing in objects, you need to pass in the same INSTANCE for caching to work. Otherwise
 * it will grow the cache unnecessarily. Also avoid using default values that evaluate functions; passing in
 * undefined for a value and relying on a default function will execute it the first time, but will not
 * re-evaluate subsequent times which may have been unexpected.
 *
 * By default, the cache will reset after 100 permutations, to avoid abuse cases where the function is
 * unintendedly called with unique objects. Without a reset, the cache could grow infinitely, so we safeguard
 * by resetting. To override this behavior, pass a value of 0 to the maxCacheSize parameter.
 *
 * @public
 * @param cb - The function to memoize.
 * @param maxCacheSize - Max results to cache. If the cache exceeds this value, it will reset on the next call.
 * @param ignoreNullOrUndefinedResult - Flag to decide whether to cache callback result if it is undefined/null.
 * If the flag is set to true, the callback result is recomputed every time till the callback result is
 * not undefined/null for the first time, and then the non-undefined/null version gets cached.
 * @returns A memoized version of the function.
 */
function memoizeFunction(cb, maxCacheSize, ignoreNullOrUndefinedResult) {
    if (maxCacheSize === undefined) { maxCacheSize = 100; }
    if (ignoreNullOrUndefinedResult === undefined) { ignoreNullOrUndefinedResult = false; }
    // Avoid breaking scenarios which don't have weak map.
    if (!_weakMap) {
        return cb;
    }
    if (!_initializedStylesheetResets$1) {
        var stylesheet = Stylesheet.getInstance();
        if (stylesheet && stylesheet.onReset) {
            Stylesheet.getInstance().onReset(resetMemoizations);
        }
        _initializedStylesheetResets$1 = true;
    }
    var rootNode;
    var cacheSize = 0;
    var localResetCounter = _resetCounter;
    return function memoizedFunction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var currentNode = rootNode;
        if (rootNode === undefined ||
            localResetCounter !== _resetCounter ||
            (maxCacheSize > 0 && cacheSize > maxCacheSize)) {
            rootNode = _createNode();
            cacheSize = 0;
            localResetCounter = _resetCounter;
        }
        currentNode = rootNode;
        // Traverse the tree until we find the match.
        for (var i = 0; i < args.length; i++) {
            var arg = _normalizeArg(args[i]);
            if (!currentNode.map.has(arg)) {
                currentNode.map.set(arg, _createNode());
            }
            currentNode = currentNode.map.get(arg);
        }
        if (!currentNode.hasOwnProperty('value')) {
            currentNode.value = cb.apply(undefined, args);
            cacheSize++;
        }
        if (ignoreNullOrUndefinedResult && (currentNode.value === null || currentNode.value === undefined)) {
            currentNode.value = cb.apply(undefined, args);
        }
        return currentNode.value;
    };
}
/**
 * Creates a memoizer for a single-value function, backed by a WeakMap.
 * With a WeakMap, the memoized values are only kept as long as the source objects,
 * ensuring that there is no memory leak.
 *
 * This function assumes that the input values passed to the wrapped function will be
 * `function` or `object` types. To memoize functions which accept other inputs, use
 * `memoizeFunction`, which memoizes against arbitrary inputs using a lookup cache.
 *
 * @public
 */
function createMemoizer(getValue) {
    if (!_weakMap) {
        // Without a `WeakMap` implementation, memoization is not possible.
        return getValue;
    }
    var cache = new _weakMap();
    function memoizedGetValue(input) {
        if (!input || (typeof input !== 'function' && typeof input !== 'object')) {
            // A WeakMap can only be used to test against reference values, i.e. 'function' and 'object'.
            // All other inputs cannot be memoized against in this manner.
            return getValue(input);
        }
        if (cache.has(input)) {
            return cache.get(input);
        }
        var value = getValue(input);
        cache.set(input, value);
        return value;
    }
    return memoizedGetValue;
}
function _normalizeArg(val) {
    if (!val) {
        return _emptyObject;
    }
    else if (typeof val === 'object' || typeof val === 'function') {
        return val;
    }
    else if (!_dictionary[val]) {
        _dictionary[val] = { val: val };
    }
    return _dictionary[val];
}
function _createNode() {
    return {
        map: _weakMap ? new _weakMap() : null,
    };
}

function createComposedComponent(outer) {
    var Outer = outer;
    var outerMemoizer = createMemoizer(function (inner) {
        if (outer === inner) {
            throw new Error('Attempted to compose a component with itself.');
        }
        var Inner = inner;
        var innerMemoizer = createMemoizer(function (defaultRender) {
            var InnerWithDefaultRender = function (innerProps) {
                return React.createElement(Inner, __assign$2({}, innerProps, { defaultRender: defaultRender }));
            };
            return InnerWithDefaultRender;
        });
        var OuterWithDefaultRender = function (outerProps) {
            var defaultRender = outerProps.defaultRender;
            return React.createElement(Outer, __assign$2({}, outerProps, { defaultRender: defaultRender ? innerMemoizer(defaultRender) : Inner }));
        };
        return OuterWithDefaultRender;
    });
    return outerMemoizer;
}
var componentAsMemoizer = createMemoizer(createComposedComponent);
/**
 * Composes two components which conform to the `IComponentAs` specification; that is, two
 * components which accept a `defaultRender` prop, which is a 'default' implementation of
 * a component which accepts the same overall props.
 *
 * @public
 */
function composeComponentAs(outer, inner) {
    return componentAsMemoizer(outer)(inner);
}

/**
 * Determines whether a component is controlled.
 * @param props - Component props
 * @param valueProp - Prop containing the controlled value
 * @returns true if controlled, false if uncontrolled
 */
function isControlled(props, valueProp) {
    // React's built-in <input> considers a prop to be provided if its value is non-null/undefined.
    // Mirror that behavior here (rather than checking for just undefined).
    return props[valueProp] !== undefined && props[valueProp] !== null;
}

/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */
function css() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        if (arg) {
            if (typeof arg === 'string') {
                classes.push(arg);
            }
            else if (arg.hasOwnProperty('toString') && typeof arg.toString === 'function') {
                classes.push(arg.toString());
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                for (var key in arg) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
    }
    return classes.join(' ');
}

var CustomizationsGlobalKey = "customizations";
var NO_CUSTOMIZATIONS = { settings: {}, scopedSettings: {}, inCustomizerContext: false };
var _allSettings = GlobalSettings.getValue(CustomizationsGlobalKey, {
  settings: {},
  scopedSettings: {},
  inCustomizerContext: false
});
var _events = [];
var Customizations = (
  /** @class */
  function() {
    function Customizations2() {
    }
    Customizations2.reset = function() {
      _allSettings.settings = {};
      _allSettings.scopedSettings = {};
    };
    Customizations2.applySettings = function(settings) {
      _allSettings.settings = __assign$2(__assign$2({}, _allSettings.settings), settings);
      Customizations2._raiseChange();
    };
    Customizations2.applyScopedSettings = function(scopeName, settings) {
      _allSettings.scopedSettings[scopeName] = __assign$2(__assign$2({}, _allSettings.scopedSettings[scopeName]), settings);
      Customizations2._raiseChange();
    };
    Customizations2.getSettings = function(properties, scopeName, localSettings) {
      if (localSettings === undefined) {
        localSettings = NO_CUSTOMIZATIONS;
      }
      var settings = {};
      var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
      var globalScopedSettings = scopeName && _allSettings.scopedSettings[scopeName] || {};
      for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
        var property = properties_1[_i];
        settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || _allSettings.settings[property];
      }
      return settings;
    };
    Customizations2.applyBatchedUpdates = function(code, suppressUpdate) {
      Customizations2._suppressUpdates = true;
      try {
        code();
      } catch (_a) {
      }
      Customizations2._suppressUpdates = false;
      if (!suppressUpdate) {
        Customizations2._raiseChange();
      }
    };
    Customizations2.observe = function(onChange) {
      _events.push(onChange);
    };
    Customizations2.unobserve = function(onChange) {
      _events = _events.filter(function(cb) {
        return cb !== onChange;
      });
    };
    Customizations2._raiseChange = function() {
      if (!Customizations2._suppressUpdates) {
        _events.forEach(function(cb) {
          return cb();
        });
      }
    };
    return Customizations2;
  }()
);

var CustomizerContext = React.createContext({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {},
    },
});

/**
 * Merge new and old settings, giving priority to new settings.
 * New settings is optional in which case oldSettings is returned as-is.
 * @param oldSettings - Old settings to fall back to.
 * @param newSettings - New settings that will be merged over oldSettings.
 * @returns Merged settings.
 */
function mergeSettings(oldSettings, newSettings) {
    if (oldSettings === undefined) { oldSettings = {}; }
    var mergeSettingsWith = _isSettingsFunction(newSettings) ? newSettings : _settingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function mergeScopedSettings(oldSettings, newSettings) {
    if (oldSettings === undefined) { oldSettings = {}; }
    var mergeSettingsWith = _isSettingsFunction(newSettings) ? newSettings : _scopedSettingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function _isSettingsFunction(settings) {
    return typeof settings === 'function';
}
function _settingsMergeWith(newSettings) {
    return function (settings) { return (newSettings ? __assign$2(__assign$2({}, settings), newSettings) : settings); };
}
function _scopedSettingsMergeWith(scopedSettingsFromProps) {
    if (scopedSettingsFromProps === undefined) { scopedSettingsFromProps = {}; }
    return function (oldScopedSettings) {
        var newScopedSettings = __assign$2({}, oldScopedSettings);
        for (var scopeName in scopedSettingsFromProps) {
            if (scopedSettingsFromProps.hasOwnProperty(scopeName)) {
                newScopedSettings[scopeName] = __assign$2(__assign$2({}, oldScopedSettings[scopeName]), scopedSettingsFromProps[scopeName]);
            }
        }
        return newScopedSettings;
    };
}

/**
 * Merge props and customizations giving priority to props over context.
 * NOTE: This function will always perform multiple merge operations. Use with caution.
 * @param props - New settings to merge in.
 * @param parentContext - Context containing current settings.
 * @returns Merged customizations.
 */
function mergeCustomizations(props, parentContext) {
    var _a = (parentContext || {}).customizations, customizations = _a === undefined ? { settings: {}, scopedSettings: {} } : _a;
    return {
        customizations: {
            settings: mergeSettings(customizations.settings, props.settings),
            scopedSettings: mergeScopedSettings(customizations.scopedSettings, props.scopedSettings),
            inCustomizerContext: true,
        },
    };
}

/**
 * The Customizer component allows for default props to be mixed into components which
 * are decorated with the customizable() decorator, or use the styled HOC. This enables
 * injection scenarios like:
 *
 * 1. render svg icons instead of the icon font within all buttons
 * 2. inject a custom theme object into a component
 *
 * Props are provided via the settings prop which should be one of the following:
 * - A json map which contains 1 or more name/value pairs representing injectable props.
 * - A function that receives the current settings and returns the new ones that apply to the scope
 *
 * @public
 *
 * @deprecated This component is deprecated for purpose of applying theme to components
 * as of `@fluentui/react` version 8. Use `ThemeProvider` for applying theme instead.
 */
var Customizer = /** @class */ (function (_super) {
    __extends$1(Customizer, _super);
    function Customizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onCustomizationChange = function () { return _this.forceUpdate(); };
        return _this;
    }
    Customizer.prototype.componentDidMount = function () {
        Customizations.observe(this._onCustomizationChange);
    };
    Customizer.prototype.componentWillUnmount = function () {
        Customizations.unobserve(this._onCustomizationChange);
    };
    Customizer.prototype.render = function () {
        var _this = this;
        var contextTransform = this.props.contextTransform;
        return (React.createElement(CustomizerContext.Consumer, null, function (parentContext) {
            var newContext = mergeCustomizations(_this.props, parentContext);
            if (contextTransform) {
                newContext = contextTransform(newContext);
            }
            return React.createElement(CustomizerContext.Provider, { value: newContext }, _this.props.children);
        }));
    };
    return Customizer;
}(React.Component));

/**
 * Allows you to hoist static functions in components.
 * Created for the purpose of fixing broken static functions in classes
 * that utilize decorators.
 *
 * @public
 * @param source - The object where the methods are hoisted from.
 * @param dest - The object to hoist the methods onto.
 * @returns The dest object with methods added
 */
function hoistStatics(source, dest) {
    for (var name_1 in source) {
        if (source.hasOwnProperty(name_1)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            dest[name_1] = source[name_1];
        }
    }
    return dest;
}

var noop$6 = function () { return false; };
var noopShadow = function () { return DEFAULT_SHADOW_CONFIG; };
var noopRootStylesheets = function () { return new Map(); };
var noopUndefined = function () { return undefined; };
var getNewContext = function () {
    return {
        stylesheets: new Map(),
        useAdoptedStylesheetEx: noop$6,
        useAdoptedStylesheet: noop$6,
        useShadowConfig: noopShadow,
        useMergeStylesShadowRootContext: noopUndefined,
        useHasMergeStylesShadowRootContext: noop$6,
        useMergeStylesRootStylesheets: noopRootStylesheets,
        useWindow: noopUndefined,
        useStyled: noopUndefined,
    };
};
var MergeStylesDefaultContext = React.createContext(getNewContext());

var useMergeStylesHooks = function () {
    var ctx = React.useContext(MergeStylesDefaultContext);
    return {
        useAdoptedStylesheet: ctx.useAdoptedStylesheet,
        useAdoptedStylesheetEx: ctx.useAdoptedStylesheetEx,
        useShadowConfig: ctx.useShadowConfig,
        useMergeStylesShadowRootContext: ctx.useMergeStylesShadowRootContext,
        useHasMergeStylesShadowRootContext: ctx.useHasMergeStylesShadowRootContext,
        useMergeStylesRootStylesheets: ctx.useMergeStylesRootStylesheets,
        useWindow: ctx.useWindow,
        useStyled: ctx.useStyled,
    };
};

var MergeStylesShadowRootContext = React.createContext(undefined);

/**
 * Test if a context is available.
 * @returns true if there is a context.
 */
var useHasMergeStylesShadowRootContext = function () {
    return !!useMergeStylesShadowRootContext();
};
/**
 * Get a reference to the shadow root context.
 * @returns The context for the shadow root.
 */
var useMergeStylesShadowRootContext = function () {
    return React.useContext(MergeStylesShadowRootContext);
};

var MergeStylesShadowRootConsumer = function (_a) {
    var stylesheetKey = _a.stylesheetKey, children = _a.children;
    var _b = useMergeStylesHooks(), useAdoptedStylesheetEx = _b.useAdoptedStylesheetEx, useMergeStylesRootStylesheets = _b.useMergeStylesRootStylesheets, useWindow = _b.useWindow;
    var shadowCtx = useMergeStylesShadowRootContext();
    var rootMergeStyles = useMergeStylesRootStylesheets();
    var win = useWindow();
    useAdoptedStylesheetEx(GLOBAL_STYLESHEET_KEY, shadowCtx, rootMergeStyles, win);
    useAdoptedStylesheetEx(stylesheetKey, shadowCtx, rootMergeStyles, win);
    return children(!!shadowCtx);
};

var WindowContext = React.createContext({
  // eslint-disable-next-line no-restricted-globals
  window: typeof window === "object" ? window : undefined
});
var useWindow = function() {
  return React.useContext(WindowContext).window;
};
var useDocument = function() {
  var _a;
  return (_a = React.useContext(WindowContext).window) === null || _a === undefined ? undefined : _a.document;
};

var memoizedMakeShadowConfig = memoizeFunction(makeShadowConfig);
var mergeComponentStyles = memoizeFunction(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function (defaultStyles, componentStyles, shadowConfig) {
    var _a;
    var styles = (_a = componentStyles !== null && componentStyles !== undefined ? componentStyles : defaultStyles) !== null && _a !== undefined ? _a : {};
    styles.__shadowConfig__ = shadowConfig;
    return styles;
});
function customizable(scope, fields, concatStyles) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function customizableFactory(ComposedComponent) {
        var _a;
        var resultClass = (_a = /** @class */ (function (_super) {
                __extends$1(ComponentWithInjectedProps, _super);
                function ComponentWithInjectedProps(props) {
                    var _this = _super.call(this, props) || this;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    _this._styleCache = {};
                    _this._onSettingChanged = _this._onSettingChanged.bind(_this);
                    return _this;
                }
                ComponentWithInjectedProps.prototype.componentDidMount = function () {
                    Customizations.observe(this._onSettingChanged);
                };
                ComponentWithInjectedProps.prototype.componentWillUnmount = function () {
                    Customizations.unobserve(this._onSettingChanged);
                };
                ComponentWithInjectedProps.prototype.render = function () {
                    var _this = this;
                    return (React.createElement(MergeStylesShadowRootConsumer, { stylesheetKey: scope }, function (inShadow) {
                        return (React.createElement(CustomizerContext.Consumer, null, function (context) {
                            var _b;
                            var defaultProps = Customizations.getSettings(fields, scope, context.customizations);
                            var win = (_b = _this.context.window) !== null && _b !== undefined ? _b : getWindow$2();
                            var shadowConfig = memoizedMakeShadowConfig(scope, inShadow, win);
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            var componentProps = _this.props;
                            // If defaultProps.styles is a function, evaluate it before calling concatStyleSets
                            if (defaultProps.styles && typeof defaultProps.styles === 'function') {
                                defaultProps.styles = defaultProps.styles(__assign$2(__assign$2({}, defaultProps), componentProps));
                            }
                            // If concatStyles is true and custom styles have been defined compute those styles
                            if (defaultProps.styles) {
                                if (_this._styleCache.default !== defaultProps.styles ||
                                    _this._styleCache.component !== componentProps.styles) {
                                    var mergedStyles = concatStyleSets(defaultProps.styles, componentProps.styles);
                                    mergedStyles.__shadowConfig__ = shadowConfig;
                                    _this._styleCache.default = defaultProps.styles;
                                    _this._styleCache.component = componentProps.styles;
                                    _this._styleCache.merged = mergedStyles;
                                }
                                return (React.createElement(ComposedComponent, __assign$2({}, defaultProps, componentProps, { styles: _this._styleCache.merged })));
                            }
                            var styles = mergeComponentStyles(defaultProps.styles, componentProps.styles, shadowConfig);
                            return React.createElement(ComposedComponent, __assign$2({}, defaultProps, componentProps, { styles: styles }));
                        }));
                    }));
                };
                ComponentWithInjectedProps.prototype._onSettingChanged = function () {
                    this.forceUpdate();
                };
                return ComponentWithInjectedProps;
            }(React.Component)),
            _a.displayName = 'Customized' + scope,
            _a.contextType = WindowContext,
            _a);
        return hoistStatics(ComposedComponent, resultClass);
    };
}

/**
 * Hook to get Customizations settings from Customizations singleton or CustomizerContext.
 * It will trigger component state update on settings change observed.
 */
function useCustomizationSettings(properties, scopeName) {
    var forceUpdate = useForceUpdate();
    var customizations = React.useContext(CustomizerContext).customizations;
    var inCustomizerContext = customizations.inCustomizerContext;
    React.useEffect(function () {
        if (!inCustomizerContext) {
            Customizations.observe(forceUpdate);
        }
        return function () {
            if (!inCustomizerContext) {
                Customizations.unobserve(forceUpdate);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude forceUpdate
    }, [inCustomizerContext]);
    return Customizations.getSettings(properties, scopeName, customizations);
}
function useForceUpdate() {
    var _a = React.useState(0), setValue = _a[1];
    return function () { return setValue(function (value) { return ++value; }); };
}

/**
 * Extends a component's lifetime methods by appending new functions to the existing lifetime functions.
 */
function extendComponent(parent, methods) {
    for (var name_1 in methods) {
        if (methods.hasOwnProperty(name_1)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            parent[name_1] = appendFunction(parent, parent[name_1], methods[name_1]);
        }
    }
}

var CURRENT_ID_PROPERTY = "__currentId__";
var DEFAULT_ID_STRING = "id__";
var _global$1 = getWindow$2() || {};
if (_global$1[CURRENT_ID_PROPERTY] === undefined) {
  _global$1[CURRENT_ID_PROPERTY] = 0;
}
var _initializedStylesheetResets = false;
function getId(prefix) {
  if (!_initializedStylesheetResets) {
    var stylesheet = Stylesheet.getInstance();
    if (stylesheet && stylesheet.onReset) {
      stylesheet.onReset(resetIds);
    }
    _initializedStylesheetResets = true;
  }
  var index = _global$1[CURRENT_ID_PROPERTY]++;
  return (prefix === undefined ? DEFAULT_ID_STRING : prefix) + index;
}
function resetIds(counter) {
  if (counter === undefined) {
    counter = 0;
  }
  _global$1[CURRENT_ID_PROPERTY] = counter;
}

var toObjectMap$1 = function() {
  var items = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    items[_i] = arguments[_i];
  }
  var result = {};
  for (var _a = 0, items_1 = items; _a < items_1.length; _a++) {
    var item = items_1[_a];
    var keys = Array.isArray(item) ? item : Object.keys(item);
    for (var _b = 0, keys_1 = keys; _b < keys_1.length; _b++) {
      var key = keys_1[_b];
      result[key] = 1;
    }
  }
  return result;
};
var baseElementEvents$1 = toObjectMap$1([
  "onCopy",
  "onCut",
  "onPaste",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onFocus",
  "onFocusCapture",
  "onBlur",
  "onBlurCapture",
  "onChange",
  "onInput",
  "onSubmit",
  "onLoad",
  "onError",
  "onKeyDown",
  "onKeyDownCapture",
  "onKeyPress",
  "onKeyUp",
  "onAbort",
  "onCanPlay",
  "onCanPlayThrough",
  "onDurationChange",
  "onEmptied",
  "onEncrypted",
  "onEnded",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onPause",
  "onPlay",
  "onPlaying",
  "onProgress",
  "onRateChange",
  "onSeeked",
  "onSeeking",
  "onStalled",
  "onSuspend",
  "onTimeUpdate",
  "onVolumeChange",
  "onWaiting",
  "onClick",
  "onClickCapture",
  "onContextMenu",
  "onDoubleClick",
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop",
  "onMouseDown",
  "onMouseDownCapture",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onMouseUpCapture",
  "onSelect",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onScroll",
  "onWheel",
  "onPointerCancel",
  "onPointerDown",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerMove",
  "onPointerOut",
  "onPointerOver",
  "onPointerUp",
  "onGotPointerCapture",
  "onLostPointerCapture"
]);
var baseElementProperties$1 = toObjectMap$1([
  "accessKey",
  // global
  "children",
  // global
  "className",
  // global
  "contentEditable",
  // global
  "dir",
  // global
  "draggable",
  // global
  "hidden",
  // global
  "htmlFor",
  // global
  "id",
  // global
  "lang",
  // global
  "ref",
  // global
  "role",
  // global
  "style",
  // global
  "tabIndex",
  // global
  "title",
  // global
  "translate",
  // global
  "spellCheck",
  // global
  "name"
  // global
]);
var htmlElementProperties$1 = toObjectMap$1(baseElementProperties$1, baseElementEvents$1);
toObjectMap$1(htmlElementProperties$1, [
  "form"
  // button, fieldset, input, label, meter, object, output, select, textarea
]);
var audioProperties$1 = toObjectMap$1(htmlElementProperties$1, [
  "height",
  // canvas, embed, iframe, img, input, object, video
  "loop",
  // audio, video
  "muted",
  // audio, video
  "preload",
  // audio, video
  "src",
  // audio, embed, iframe, img, input, script, source, track, video
  "width"
  // canvas, embed, iframe, img, input, object, video
]);
toObjectMap$1(audioProperties$1, [
  "poster"
  // video
]);
toObjectMap$1(htmlElementProperties$1, [
  "start"
  // ol
]);
toObjectMap$1(htmlElementProperties$1, [
  "value"
  // button, input, li, option, meter, progress, param
]);
var anchorProperties$1 = toObjectMap$1(htmlElementProperties$1, [
  "download",
  // a, area
  "href",
  // a, area, base, link
  "hrefLang",
  // a, area, link
  "media",
  // a, area, link, source, style
  "rel",
  // a, area, link
  "target",
  // a, area, base, form
  "type"
  // a, button, input, link, menu, object, script, source, style
]);
var buttonProperties$1 = toObjectMap$1(htmlElementProperties$1, [
  "autoFocus",
  // button, input, select, textarea
  "disabled",
  // button, fieldset, input, optgroup, option, select, textarea
  "form",
  // button, fieldset, input, label, meter, object, output, select, textarea
  "formAction",
  // input, button
  "formEncType",
  // input, button
  "formMethod",
  // input, button
  "formNoValidate",
  // input, button
  "formTarget",
  // input, button
  "type",
  // a, button, input, link, menu, object, script, source, style
  "value"
  // button, input, li, option, meter, progress, param,
]);
var inputProperties$1 = toObjectMap$1(buttonProperties$1, [
  "accept",
  // input
  "alt",
  // area, img, input
  "autoCapitalize",
  // input, textarea
  "autoComplete",
  // form, input
  "checked",
  // input
  "dirname",
  // input, textarea
  "form",
  // button, fieldset, input, label, meter, object, output, select, textarea
  "height",
  // canvas, embed, iframe, img, input, object, video
  "inputMode",
  // input
  "list",
  // input
  "max",
  // input, meter
  "maxLength",
  // input, textarea
  "min",
  // input, meter
  "minLength",
  // input, textarea
  "multiple",
  // input, select
  "pattern",
  // input
  "placeholder",
  // input, textarea
  "readOnly",
  // input, textarea
  "required",
  // input, select, textarea
  "src",
  // audio, embed, iframe, img, input, script, source, track, video
  "step",
  // input
  "size",
  // input
  "type",
  // a, button, input, link, menu, object, script, source, style
  "value",
  // button, input, li, option, meter, progress, param
  "width"
  // canvas, embed, iframe, img, input, object, video
]);
toObjectMap$1(buttonProperties$1, [
  "autoCapitalize",
  // input, textarea
  "cols",
  // textarea
  "dirname",
  // input, textarea
  "form",
  // button, fieldset, input, label, meter, object, output, select, textarea
  "maxLength",
  // input, textarea
  "minLength",
  // input, textarea
  "placeholder",
  // input, textarea
  "readOnly",
  // input, textarea
  "required",
  // input, select, textarea
  "rows",
  // textarea
  "wrap"
  // textarea
]);
toObjectMap$1(buttonProperties$1, [
  "form",
  // button, fieldset, input, label, meter, object, output, select, textarea
  "multiple",
  // input, select
  "required"
  // input, select, textarea
]);
toObjectMap$1(htmlElementProperties$1, [
  "selected",
  // option
  "value"
  // button, input, li, option, meter, progress, param
]);
toObjectMap$1(htmlElementProperties$1, [
  "cellPadding",
  // table
  "cellSpacing"
  // table
]);
toObjectMap$1(htmlElementProperties$1, [
  "rowSpan",
  // td, th
  "scope"
  // th
]);
toObjectMap$1(htmlElementProperties$1, [
  "colSpan",
  // td
  "headers",
  // td
  "rowSpan",
  // td, th
  "scope"
  // th
]);
toObjectMap$1(htmlElementProperties$1, [
  "span"
  // col, colgroup
]);
toObjectMap$1(htmlElementProperties$1, [
  "span"
  // col, colgroup
]);
toObjectMap$1(htmlElementProperties$1, [
  "acceptCharset",
  // form
  "action",
  // form
  "encType",
  // form
  "encType",
  // form
  "method",
  // form
  "noValidate",
  // form
  "target"
  // form
]);
toObjectMap$1(htmlElementProperties$1, [
  "allow",
  // iframe
  "allowFullScreen",
  // iframe
  "allowPaymentRequest",
  // iframe
  "allowTransparency",
  // iframe
  "csp",
  // iframe
  "height",
  // canvas, embed, iframe, img, input, object, video
  "importance",
  // iframe
  "referrerPolicy",
  // iframe
  "sandbox",
  // iframe
  "src",
  // audio, embed, iframe, img, input, script, source, track, video
  "srcDoc",
  // iframe
  "width"
  // canvas, embed, iframe, img, input, object, video,
]);
var imgProperties$1 = toObjectMap$1(htmlElementProperties$1, [
  "alt",
  // area, img, input
  "crossOrigin",
  // img
  "height",
  // canvas, embed, iframe, img, input, object, video
  "src",
  // audio, embed, iframe, img, input, script, source, track, video
  "srcSet",
  // img, source
  "useMap",
  // img, object,
  "width"
  // canvas, embed, iframe, img, input, object, video
]);
var divProperties = htmlElementProperties$1;
function getNativeProps$1(props, allowedPropNames, excludedPropNames) {
  var isArray = Array.isArray(allowedPropNames);
  var result = {};
  var keys = Object.keys(props);
  for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
    var key = keys_2[_i];
    var isNativeProp = !isArray && allowedPropNames[key] || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf("data-") === 0 || key.indexOf("aria-") === 0;
    if (isNativeProp && (!excludedPropNames || (excludedPropNames === null || excludedPropNames === undefined ? undefined : excludedPropNames.indexOf(key)) === -1)) {
      result[key] = props[key];
    }
  }
  return result;
}

var REACT_LIFECYCLE_EXCLUSIONS = [
    'setState',
    'render',
    'componentWillMount',
    'UNSAFE_componentWillMount',
    'componentDidMount',
    'componentWillReceiveProps',
    'UNSAFE_componentWillReceiveProps',
    'shouldComponentUpdate',
    'componentWillUpdate',
    'getSnapshotBeforeUpdate',
    'UNSAFE_componentWillUpdate',
    'componentDidUpdate',
    'componentWillUnmount',
];
/**
 * Allows you to hoist methods, except those in an exclusion set from a source object into a destination object.
 *
 * @public
 * @param destination - The instance of the object to hoist the methods onto.
 * @param source - The instance of the object where the methods are hoisted from.
 * @param exclusions - (Optional) What methods to exclude from being hoisted.
 * @returns An array of names of methods that were hoisted.
 */
function hoistMethods(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
destination, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, exclusions) {
    if (exclusions === undefined) { exclusions = REACT_LIFECYCLE_EXCLUSIONS; }
    var hoisted = [];
    var _loop_1 = function (methodName) {
        if (typeof source[methodName] === 'function' &&
            destination[methodName] === undefined &&
            (!exclusions || exclusions.indexOf(methodName) === -1)) {
            hoisted.push(methodName);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            destination[methodName] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                source[methodName].apply(source, args);
            };
        }
    };
    for (var methodName in source) {
        _loop_1(methodName);
    }
    return hoisted;
}
/**
 * Provides a method for convenience to unhoist hoisted methods.
 *
 * @public
 * @param source - The source object upon which methods were hoisted.
 * @param methodNames - An array of method names to unhoist.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function unhoistMethods(source, methodNames) {
    methodNames.forEach(function (methodName) { return delete source[methodName]; });
}

/**
 * Helper to manage componentRef resolution. Internally appends logic to
 * lifetime methods to resolve componentRef to the passed in object.
 *
 * Usage: call initializeComponentRef(this) in the constructor,
 */
function initializeComponentRef(obj) {
    extendComponent(obj, {
        componentDidMount: _onMount,
        componentDidUpdate: _onUpdate,
        componentWillUnmount: _onUnmount,
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _onMount() {
    _setComponentRef(this.props.componentRef, this);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _onUpdate(prevProps) {
    if (prevProps.componentRef !== this.props.componentRef) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _setComponentRef(prevProps.componentRef, null);
        _setComponentRef(this.props.componentRef, this);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _onUnmount() {
    _setComponentRef(this.props.componentRef, null);
}
function _setComponentRef(componentRef, value) {
    if (componentRef) {
        if (typeof componentRef === 'object') {
            componentRef.current = value;
        }
        else if (typeof componentRef === 'function') {
            componentRef(value);
        }
    }
}

var _a$h;
var DirectionalKeyCodes = (_a$h = {}, _a$h[KeyCodes.up] = 1, _a$h[KeyCodes.down] = 1, _a$h[KeyCodes.left] = 1, _a$h[KeyCodes.right] = 1, _a$h[KeyCodes.home] = 1, _a$h[KeyCodes.end] = 1, _a$h[KeyCodes.tab] = 1, _a$h[KeyCodes.pageUp] = 1, _a$h[KeyCodes.pageDown] = 1, _a$h);
function isDirectionalKeyCode(which) {
  return !!DirectionalKeyCodes[which];
}

var IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
var IsFocusHiddenClassName = 'ms-Fabric--isFocusHidden';
function updateClassList(el, enabled) {
    if (el) {
        el.classList.add(enabled ? IsFocusVisibleClassName : IsFocusHiddenClassName);
        el.classList.remove(enabled ? IsFocusHiddenClassName : IsFocusVisibleClassName);
    }
}
/**
 * Sets the visibility of focus styling.
 *
 * By default, focus styles (the box surrounding a focused Button, for example) only show up when navigational
 * keypresses occur (through Tab, arrows, PgUp/PgDn, Home and End), and are hidden when mouse interactions occur.
 * This API provides an imperative way to turn them on/off.
 *
 * A use case might be when you have a keypress like ctrl-f6 navigate to a particular region on the page,
 * and want focus to show up.
 *
 * @param enabled - Whether to turn focus visibility on or off.
 * @param target - Optional target from which to get window in case no `providerElem` has been specified.
 * @param registeredProviders - Array of provider refs that are associated with a FocusRectsProvider. If no array
 *                              is passed in, the classnames are attached to the document body that contains `target`.
 */
function setFocusVisibility(enabled, target, registeredProviders) {
    var _a;
    if (registeredProviders) {
        registeredProviders.forEach(function (ref) { return updateClassList(ref.current, enabled); });
    }
    else {
        updateClassList((_a = getWindow$2(target)) === null || _a === undefined ? undefined : _a.document.body, enabled);
    }
}

var mountCounters = /* @__PURE__ */ new WeakMap();
var callbackMap = /* @__PURE__ */ new WeakMap();
function setMountCounters(key, delta) {
  var newValue;
  var currValue = mountCounters.get(key);
  if (currValue) {
    newValue = currValue + delta;
  } else {
    newValue = 1;
  }
  mountCounters.set(key, newValue);
  return newValue;
}
function setCallbackMap(context) {
  var callbacks = callbackMap.get(context);
  if (callbacks) {
    return callbacks;
  }
  var onMouseDown = function(ev) {
    return _onMouseDown(ev, context.registeredProviders);
  };
  var onPointerDown = function(ev) {
    return _onPointerDown(ev, context.registeredProviders);
  };
  var onKeyDown = function(ev) {
    return _onKeyDown(ev, context.registeredProviders);
  };
  var onKeyUp = function(ev) {
    return _onKeyUp(ev, context.registeredProviders);
  };
  callbacks = { onMouseDown, onPointerDown, onKeyDown, onKeyUp };
  callbackMap.set(context, callbacks);
  return callbacks;
}
var FocusRectsContext = React.createContext(undefined);
function useFocusRects(rootRef) {
  var context = React.useContext(FocusRectsContext);
  React.useEffect(function() {
    var _a, _b, _c, _d;
    var win = getWindow$2(rootRef === null || rootRef === undefined ? undefined : rootRef.current);
    if (!win || ((_a = win.FabricConfig) === null || _a === undefined ? undefined : _a.disableFocusRects) === true) {
      return undefined;
    }
    var el = win;
    var onMouseDown;
    var onPointerDown;
    var onKeyDown;
    var onKeyUp;
    if (((_b = context === null || context === undefined ? undefined : context.providerRef) === null || _b === undefined ? undefined : _b.current) && ((_d = (_c = context === null || context === undefined ? undefined : context.providerRef) === null || _c === undefined ? undefined : _c.current) === null || _d === undefined ? undefined : _d.addEventListener)) {
      el = context.providerRef.current;
      var callbacks = (
        /*@__NOINLINE__*/
        setCallbackMap(context)
      );
      onMouseDown = callbacks.onMouseDown;
      onPointerDown = callbacks.onPointerDown;
      onKeyDown = callbacks.onKeyDown;
      onKeyUp = callbacks.onKeyUp;
    } else {
      onMouseDown = _onMouseDown;
      onPointerDown = _onPointerDown;
      onKeyDown = _onKeyDown;
      onKeyUp = _onKeyUp;
    }
    var count = setMountCounters(el, 1);
    if (count <= 1) {
      el.addEventListener("mousedown", onMouseDown, true);
      el.addEventListener("pointerdown", onPointerDown, true);
      el.addEventListener("keydown", onKeyDown, true);
      el.addEventListener("keyup", onKeyUp, true);
    }
    return function() {
      var _a2;
      if (!win || ((_a2 = win.FabricConfig) === null || _a2 === undefined ? undefined : _a2.disableFocusRects) === true) {
        return;
      }
      count = setMountCounters(el, -1);
      if (count === 0) {
        el.removeEventListener("mousedown", onMouseDown, true);
        el.removeEventListener("pointerdown", onPointerDown, true);
        el.removeEventListener("keydown", onKeyDown, true);
        el.removeEventListener("keyup", onKeyUp, true);
      }
    };
  }, [context, rootRef]);
}
var FocusRects = function(props) {
  useFocusRects(props.rootRef);
  return null;
};
function _onMouseDown(ev, registeredProviders) {
  setFocusVisibility(false, ev.target, registeredProviders);
}
function _onPointerDown(ev, registeredProviders) {
  if (ev.pointerType !== "mouse") {
    setFocusVisibility(false, ev.target, registeredProviders);
  }
}
function _onKeyDown(ev, registeredProviders) {
  if (isDirectionalKeyCode(ev.which)) {
    setFocusVisibility(true, ev.target, registeredProviders);
  }
}
function _onKeyUp(ev, registeredProviders) {
  if (isDirectionalKeyCode(ev.which)) {
    setFocusVisibility(true, ev.target, registeredProviders);
  }
}

var FocusRectsProvider = function (props) {
    var providerRef = props.providerRef, layerRoot = props.layerRoot;
    var registeredProviders = React.useState([])[0];
    var parentContext = React.useContext(FocusRectsContext);
    // Inherit the parent context if it exists, unless this is a layer root.
    // This allows the topmost provider element in the DOM tree to handle the focus events.
    // Since layers are in a separate HTML tree from their parent, they shouldn't use the parent's providerRef.
    var inheritParentContext = parentContext !== undefined && !layerRoot;
    var context = React.useMemo(function () {
        return inheritParentContext
            ? undefined
            : {
                providerRef: providerRef,
                registeredProviders: registeredProviders,
                registerProvider: function (ref) {
                    // Register this child provider with the current context, and any parent contexts
                    registeredProviders.push(ref);
                    parentContext === null || parentContext === undefined ? undefined : parentContext.registerProvider(ref);
                },
                unregisterProvider: function (ref) {
                    parentContext === null || parentContext === undefined ? undefined : parentContext.unregisterProvider(ref);
                    var i = registeredProviders.indexOf(ref);
                    if (i >= 0) {
                        registeredProviders.splice(i, 1);
                    }
                },
            };
    }, [providerRef, registeredProviders, parentContext, inheritParentContext]);
    React.useEffect(function () {
        if (context) {
            context.registerProvider(context.providerRef);
            return function () { return context.unregisterProvider(context.providerRef); };
        }
    }, [context]);
    // Create a new context provider if this is not inheriting from the parent.
    if (context) {
        return React.createElement(FocusRectsContext.Provider, { value: context }, props.children);
    }
    else {
        return React.createElement(React.Fragment, null, props.children);
    }
};

/**
 * Regular expressions matching characters to ignore when calculating the initials.
 */
/**
 * Regular expression matching characters within various types of enclosures, including the enclosures themselves
 *  so for example, (xyz) [xyz] {xyz} <xyz> all would be ignored
 */
var UNWANTED_ENCLOSURES_REGEX$1 = /[\(\[\{\<][^\)\]\}\>]*[\)\]\}\>]/g;
/**
 * Regular expression matching special ASCII characters except space, plus some unicode special characters.
 * Applies after unwanted enclosures have been removed
 */
var UNWANTED_CHARS_REGEX$1 = /[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uD800-\uFFFF]/g;
/**
 * Regular expression matching phone numbers. Applied after chars matching UNWANTED_CHARS_REGEX have been removed
 * and number has been trimmed for whitespaces
 */
var PHONENUMBER_REGEX$1 = /^\d+[\d\s]*(:?ext|x|)\s*\d+$/i;
/** Regular expression matching one or more spaces. */
var MULTIPLE_WHITESPACES_REGEX$1 = /\s+/g;
/**
 * Regular expression matching languages for which we currently don't support initials.
 * Arabic:   Arabic, Arabic Supplement, Arabic Extended-A.
 * Korean:   Hangul Jamo, Hangul Compatibility Jamo, Hangul Jamo Extended-A, Hangul Syllables, Hangul Jamo Extended-B.
 * Japanese: Hiragana, Katakana.
 * CJK:      CJK Unified Ideographs Extension A, CJK Unified Ideographs, CJK Compatibility Ideographs,
 *             CJK Unified Ideographs Extension B
 */
var UNSUPPORTED_TEXT_REGEX$1 = 
// eslint-disable-next-line @fluentui/max-len
/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD869][\uDC00-\uDED6]/;
function getInitialsLatin$1(displayName, isRtl) {
    var initials = '';
    var splits = displayName.split(' ');
    if (splits.length === 2) {
        initials += splits[0].charAt(0).toUpperCase();
        initials += splits[1].charAt(0).toUpperCase();
    }
    else if (splits.length === 3) {
        initials += splits[0].charAt(0).toUpperCase();
        initials += splits[2].charAt(0).toUpperCase();
    }
    else if (splits.length !== 0) {
        initials += splits[0].charAt(0).toUpperCase();
    }
    if (isRtl && initials.length > 1) {
        return initials.charAt(1) + initials.charAt(0);
    }
    return initials;
}
function cleanupDisplayName$1(displayName) {
    displayName = displayName.replace(UNWANTED_ENCLOSURES_REGEX$1, '');
    displayName = displayName.replace(UNWANTED_CHARS_REGEX$1, '');
    displayName = displayName.replace(MULTIPLE_WHITESPACES_REGEX$1, ' ');
    displayName = displayName.trim();
    return displayName;
}
/**
 * Get (up to 2 characters) initials based on display name of the persona.
 *
 * @public
 */
function getInitials$1(displayName, isRtl, allowPhoneInitials) {
    if (!displayName) {
        return '';
    }
    displayName = cleanupDisplayName$1(displayName);
    // For names containing CJK characters, and phone numbers, we don't display initials
    if (UNSUPPORTED_TEXT_REGEX$1.test(displayName) || (!allowPhoneInitials && PHONENUMBER_REGEX$1.test(displayName))) {
        return '';
    }
    return getInitialsLatin$1(displayName, isRtl);
}

/**
 * Fetches an item from local storage without throwing an exception
 * @param key The key of the item to fetch from local storage
 */
function getItem(key) {
    var result = null;
    try {
        var win = getWindow$2();
        result = win ? win.localStorage.getItem(key) : null;
    }
    catch (e) {
        /* Eat the exception */
    }
    return result;
}

// Default to undefined so that we initialize on first read.
var _language;
var STORAGE_KEY = 'language';
/**
 * Gets the language set for the page.
 * @param persistenceType - Where to persist the value. Default is `sessionStorage` if available.
 */
function getLanguage(persistenceType) {
    if (persistenceType === undefined) { persistenceType = 'sessionStorage'; }
    if (_language === undefined) {
        var doc = getDocument$1();
        var savedLanguage = persistenceType === 'localStorage'
            ? getItem(STORAGE_KEY)
            : persistenceType === 'sessionStorage'
                ? getItem$1(STORAGE_KEY)
                : undefined;
        if (savedLanguage) {
            _language = savedLanguage;
        }
        if (_language === undefined && doc) {
            _language = doc.documentElement.getAttribute('lang');
        }
        if (_language === undefined) {
            _language = 'en';
        }
    }
    return _language;
}

/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */
function merge$4(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        _merge(target || {}, arg);
    }
    return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _merge(target, source, circularReferences) {
    if (circularReferences === undefined) { circularReferences = []; }
    circularReferences.push(source);
    for (var name_1 in source) {
        if (source.hasOwnProperty(name_1)) {
            if (name_1 !== '__proto__' && name_1 !== 'constructor' && name_1 !== 'prototype') {
                var value = source[name_1];
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    var isCircularReference = circularReferences.indexOf(value) > -1;
                    target[name_1] = (isCircularReference ? value : _merge(target[name_1] || {}, value, circularReferences));
                }
                else {
                    target[name_1] = value;
                }
            }
        }
    }
    circularReferences.pop();
    return target;
}

var isIOS = function() {
  if (!window || !window.navigator || !window.navigator.userAgent) {
    return false;
  }
  return /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
};

/**
 * The helper functions here will make the target element as modal to screen readers, by placing aria-hidden on elements
 * that are siblings to the target element and the target element's ancestors (because aria-hidden gets inherited).
 * That way, all other elements on the page are hidden to the screen reader.
 */
/** Tag names to ignore when modalizing */
var tagsToIgnore = ['TEMPLATE', 'STYLE', 'SCRIPT'];
/**
 * Call this on a target element to make it modal to screen readers.
 * Returns a function that undoes the changes it made.
 */
function modalize(target) {
    var targetDocument = getDocument$1(target);
    if (!targetDocument) {
        // can't do this in SSR
        return function () { return undefined; };
    }
    var affectedNodes = [];
    // start at target, then recurse and do the same for parent, until we reach <body>
    while (target !== targetDocument.body && target.parentElement) {
        // grab all siblings of current element
        for (var _i = 0, _a = target.parentElement.children; _i < _a.length; _i++) {
            var sibling = _a[_i];
            // but ignore elements that are already aria-hidden
            var ariaHidden = sibling.getAttribute('aria-hidden');
            if (sibling !== target && (ariaHidden === null || ariaHidden === undefined ? undefined : ariaHidden.toLowerCase()) !== 'true' && tagsToIgnore.indexOf(sibling.tagName) === -1) {
                affectedNodes.push([sibling, ariaHidden]);
            }
        }
        target = target.parentElement;
    }
    // take all those elements and set aria-hidden=true on them
    affectedNodes.forEach(function (_a) {
        var node = _a[0];
        node.setAttribute('aria-hidden', 'true');
    });
    return function () {
        unmodalize(affectedNodes);
        affectedNodes = []; // dispose
    };
}
/**
 * Undoes the changes that modalize() did.
 */
function unmodalize(affectedNodes) {
    affectedNodes.forEach(function (_a) {
        var node = _a[0], originalValue = _a[1];
        // Restore the original value (false or unset)
        if (originalValue) {
            node.setAttribute('aria-hidden', originalValue);
        }
        else {
            node.removeAttribute('aria-hidden');
        }
    });
}

var isMacResult;
/**
 * Returns true if the user is on a Mac. Caches the result value.
 * @param reset - Reset the cached result value (mainly for testing).
 */
function isMac(reset) {
    var _a;
    if (typeof isMacResult === 'undefined' || reset) {
        var win = getWindow$2();
        // In certain SSR frameworks, `window` will be defined even on the server but `navigator` will be undefined
        var userAgent = (_a = win === null || win === undefined ? undefined : win.navigator) === null || _a === undefined ? undefined : _a.userAgent;
        isMacResult = !!userAgent && userAgent.indexOf('Macintosh') !== -1;
    }
    return !!isMacResult;
}

/**
 * Detects whether an element's content has horizontal overflow
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */
function hasHorizontalOverflow(element) {
    return element.clientWidth < element.scrollWidth;
}
/**
 * Detects whether an element's content has vertical overflow
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */
function hasVerticalOverflow(element) {
    return element.clientHeight < element.scrollHeight;
}
/**
 * Detects whether an element's content has overflow in any direction
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */
function hasOverflow(element) {
    return hasHorizontalOverflow(element) || hasVerticalOverflow(element);
}

function createComposedRenderFunction(outer) {
    var outerMemoizer = createMemoizer(function (inner) {
        var innerMemoizer = createMemoizer(function (defaultRender) {
            return function (innerProps) {
                return inner(innerProps, defaultRender);
            };
        });
        return function (outerProps, defaultRender) {
            return outer(outerProps, defaultRender ? innerMemoizer(defaultRender) : inner);
        };
    });
    return outerMemoizer;
}
var memoizer = createMemoizer(createComposedRenderFunction);
/**
 * Composes two 'render functions' to produce a final render function that renders
 * the outer function, passing the inner function as 'default render'. The inner function
 * is then passed the original 'default render' prop.
 * @public
 */
function composeRenderFunction(outer, inner) {
    return memoizer(outer)(inner);
}

var DefaultFields = ['theme', 'styles'];
function styled(Component, baseStyles, getProps, customizable, pure) {
    customizable = customizable || { scope: '', fields: undefined };
    var scope = customizable.scope, _a = customizable.fields, fields = _a === undefined ? DefaultFields : _a;
    var Wrapped = React.forwardRef(function (props, forwardedRef) {
        var styles = React.useRef();
        var settings = useCustomizationSettings(fields, scope);
        var customizedStyles = settings.styles; settings.dir; var rest = __rest$1(settings, ["styles", "dir"]);
        var additionalProps = getProps ? getProps(props) : undefined;
        var useStyled = useMergeStylesHooks().useStyled;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var cache = (styles.current && styles.current.__cachedInputs__) || [];
        var propStyles = props.styles;
        if (!styles.current || customizedStyles !== cache[1] || propStyles !== cache[2]) {
            // Using styled components as the Component arg will result in nested styling arrays.
            // The function can be cached and in order to prevent the props from being retained within it's closure
            // we pass in just the styles and not the entire props
            var concatenatedStyles = function (styleProps) {
                return concatStyleSetsWithProps(styleProps, baseStyles, customizedStyles, propStyles);
            };
            // The __cachedInputs__ array is attached to the function and consumed by the
            // classNamesFunction as a list of keys to include for memoizing classnames.
            concatenatedStyles.__cachedInputs__ = [
                baseStyles,
                customizedStyles,
                propStyles,
            ];
            concatenatedStyles.__noStyleOverride__ =
                !customizedStyles && !propStyles;
            styles.current = concatenatedStyles;
        }
        styles.current.__shadowConfig__ = useStyled(scope);
        return React.createElement(Component, __assign$2({ ref: forwardedRef }, rest, additionalProps, props, { styles: styles.current }));
    });
    // Function.prototype.name is an ES6 feature, so the cast to any is required until we're
    // able to drop IE 11 support and compile with ES6 libs
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Wrapped.displayName = "Styled".concat(Component.displayName || Component.name);
    // This preserves backwards compatibility.
    var pureComponent = pure ? React.memo(Wrapped) : Wrapped;
    // Check if the wrapper has a displayName after it has been memoized. Then assign it to the pure component.
    if (Wrapped.displayName) {
        pureComponent.displayName = Wrapped.displayName;
    }
    return pureComponent;
}

var warningsMap;
if (process.env.NODE_ENV !== 'production') {
    warningsMap = {
        valueOnChange: {},
        valueDefaultValue: {},
        controlledToUncontrolled: {},
        uncontrolledToControlled: {},
    };
}
/**
 * Check for and warn on the following error conditions with a form component:
 * - A value prop is provided (indicated it's being used as controlled) without a change handler,
 *    and the component is not read-only
 * - Both the value and defaultValue props are provided
 * - The component is attempting to switch between controlled and uncontrolled
 *
 * The messages mimic the warnings React gives for these error conditions on input elements.
 * The warning will only be displayed once per component ID.
 */
function warnControlledUsage(params) {
    if (process.env.NODE_ENV !== 'production') {
        var componentId = params.componentId, componentName = params.componentName, defaultValueProp = params.defaultValueProp, props = params.props, oldProps = params.oldProps, onChangeProp = params.onChangeProp, readOnlyProp = params.readOnlyProp, valueProp = params.valueProp;
        // This warning logic closely follows what React does for native <input> elements.
        var oldIsControlled = oldProps ? isControlled(oldProps, valueProp) : undefined;
        var newIsControlled = isControlled(props, valueProp);
        if (newIsControlled) {
            // onChange (or readOnly) must be provided if value is provided
            var hasOnChange = !!props[onChangeProp];
            var isReadOnly = !!(readOnlyProp && props[readOnlyProp]);
            if (!(hasOnChange || isReadOnly) && !warningsMap.valueOnChange[componentId]) {
                warningsMap.valueOnChange[componentId] = true;
                warn$1("Warning: You provided a '".concat(String(valueProp), "' prop to a ").concat(String(componentName), " without an '").concat(String(onChangeProp), "' handler. ") +
                    "This will render a read-only field. If the field should be mutable use '".concat(String(defaultValueProp), "'. ") +
                    "Otherwise, set '".concat(String(onChangeProp), "'").concat(readOnlyProp ? " or '".concat(String(readOnlyProp), "'") : '', "."));
            }
            // value and defaultValue are mutually exclusive
            var defaultValue = props[defaultValueProp];
            if (defaultValue !== undefined && defaultValue !== null && !warningsMap.valueDefaultValue[componentId]) {
                warningsMap.valueDefaultValue[componentId] = true;
                warn$1("Warning: You provided both '".concat(String(valueProp), "' and '").concat(String(defaultValueProp), "' to a ").concat(componentName, ". ") +
                    "Form fields must be either controlled or uncontrolled (specify either the '".concat(String(valueProp), "' prop, ") +
                    "or the '".concat(String(defaultValueProp), "' prop, but not both). Decide between using a controlled or uncontrolled ") +
                    "".concat(componentName, " and remove one of these props. More info: https://fb.me/react-controlled-components"));
            }
        }
        // Warn if switching between uncontrolled and controlled. (One difference between this implementation
        // and React's <input> is that if oldIsControlled is indeterminate and newIsControlled true, we don't warn.)
        if (oldProps && newIsControlled !== oldIsControlled) {
            var oldType = oldIsControlled ? 'a controlled' : 'an uncontrolled';
            var newType = oldIsControlled ? 'uncontrolled' : 'controlled';
            var warnMap = oldIsControlled ? warningsMap.controlledToUncontrolled : warningsMap.uncontrolledToControlled;
            if (!warnMap[componentId]) {
                warnMap[componentId] = true;
                warn$1("Warning: A component is changing ".concat(oldType, " ").concat(componentName, " to be ").concat(newType, ". ") +
                    "".concat(componentName, "s should not switch from controlled to uncontrolled (or vice versa). ") +
                    "Decide between using controlled or uncontrolled for the lifetime of the component. " +
                    "More info: https://fb.me/react-controlled-components");
            }
        }
    }
}

/**
 * Function to apply default values to a component props object. This function is intended for function components,
 * to maintain parity with the `defaultProps` feature of class components. It accounts for properties that are
 * specified, but undefined.
 * @param defaultProps- An object with default values for various properties
 * @param propsWithoutDefaults- The props object passed into the component
 */
function getPropsWithDefaults(defaultProps, propsWithoutDefaults) {
    var props = __assign$2({}, propsWithoutDefaults);
    for (var _i = 0, _a = Object.keys(defaultProps); _i < _a.length; _i++) {
        var key = _a[_i];
        if (props[key] === undefined) {
            props[key] = defaultProps[key];
        }
    }
    return props;
}

/**
 * Set up a ref resolver function given internal state managed for the ref.
 * @param local Set
 */
var createResolver$1 = function (local) {
    return function (newValue) {
        for (var _i = 0, _a = local.refs; _i < _a.length; _i++) {
            var ref = _a[_i];
            if (typeof ref === 'function') {
                ref(newValue);
            }
            else if (ref) {
                // work around the immutability of the React.Ref type
                ref.current = newValue;
            }
        }
    };
};
/**
 * Helper to merge refs from within class components.
 */
var createMergedRef = function (value) {
    var local = {
        refs: [],
    };
    return function () {
        var newRefs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newRefs[_i] = arguments[_i];
        }
        if (!local.resolver || !arraysEqual(local.refs, newRefs)) {
            local.resolver = createResolver$1(local);
        }
        local.refs = newRefs;
        return local.resolver;
    };
};

/**
 * React currently throws a warning when using `useLayoutEffect` on the server. To get around it,
 * this hook calls `useEffect` on the server (no-op) and `useLayoutEffect` in the browser.
 *
 * Prefer `useEffect` unless you have a specific need to do something after mount and before paint,
 * such as to avoid a render flash for certain operations.
 *
 * Server-side rendering is detected based on `canUseDOM` from `@fluentui/utilities`.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 */
// eslint-disable-next-line no-restricted-properties
var useIsomorphicLayoutEffect$1 = canUseDOM$2() ? React.useLayoutEffect : React.useEffect;

var ICON_SETTING_NAME = 'icons';
var _iconSettings = GlobalSettings.getValue(ICON_SETTING_NAME, {
    __options: {
        disableWarnings: false,
        warnOnMissingIcons: true,
    },
    __remapped: {},
});
// Reset icon registration on stylesheet resets.
var stylesheet = Stylesheet.getInstance();
if (stylesheet && stylesheet.onReset) {
    stylesheet.onReset(function () {
        for (var name_1 in _iconSettings) {
            if (_iconSettings.hasOwnProperty(name_1) && !!_iconSettings[name_1].subset) {
                _iconSettings[name_1].subset.className = undefined;
            }
        }
    });
}
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */
var normalizeIconName = function (name) { return name.toLowerCase(); };
/**
 * Registers a given subset of icons.
 *
 * @param iconSubset - the icon subset definition.
 */
function registerIcons(iconSubset, options) {
    var subset = __assign$2(__assign$2({}, iconSubset), { isRegistered: false, className: undefined });
    var icons = iconSubset.icons;
    // Grab options, optionally mix user provided ones on top.
    options = options ? __assign$2(__assign$2({}, _iconSettings.__options), options) : _iconSettings.__options;
    for (var iconName in icons) {
        if (icons.hasOwnProperty(iconName)) {
            var code = icons[iconName];
            var normalizedIconName = normalizeIconName(iconName);
            if (_iconSettings[normalizedIconName]) {
                _warnDuplicateIcon(iconName);
            }
            else {
                _iconSettings[normalizedIconName] = {
                    code: code,
                    subset: subset,
                };
            }
        }
    }
}
/**
 * Remaps one icon name to another.
 */
function registerIconAlias(iconName, mappedToName) {
    _iconSettings.__remapped[normalizeIconName(iconName)] = normalizeIconName(mappedToName);
}
/**
 * Gets an icon definition. If an icon is requested but the subset has yet to be registered,
 * it will get registered immediately.
 *
 * @public
 * @param name - Name of icon.
 */
function getIcon(name) {
    var icon = undefined;
    var options = _iconSettings.__options;
    name = name ? normalizeIconName(name) : '';
    name = _iconSettings.__remapped[name] || name;
    if (name) {
        icon = _iconSettings[name];
        if (icon) {
            var subset = icon.subset;
            if (subset && subset.fontFace) {
                if (!subset.isRegistered) {
                    fontFace(subset.fontFace);
                    subset.isRegistered = true;
                }
                if (!subset.className) {
                    subset.className = mergeStyles(subset.style, {
                        fontFamily: subset.fontFace.fontFamily,
                        fontWeight: subset.fontFace.fontWeight || 'normal',
                        fontStyle: subset.fontFace.fontStyle || 'normal',
                    });
                }
            }
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (!options.disableWarnings && options.warnOnMissingIcons) {
                warn$1("The icon \"".concat(name, "\" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information."));
            }
        }
    }
    return icon;
}
var _missingIcons = [];
var _missingIconsTimer = undefined;
function _warnDuplicateIcon(iconName) {
    var options = _iconSettings.__options;
    var warningDelay = 2000;
    var maxIconsInMessage = 10;
    if (!options.disableWarnings) {
        _missingIcons.push(iconName);
        if (_missingIconsTimer === undefined) {
            _missingIconsTimer = setTimeout(function () {
                warn$1("Some icons were re-registered. Applications should only call registerIcons for any given " +
                    "icon once. Redefining what an icon is may have unintended consequences. Duplicates " +
                    "include: \n" +
                    _missingIcons.slice(0, maxIconsInMessage).join(', ') +
                    (_missingIcons.length > maxIconsInMessage ? " (+ ".concat(_missingIcons.length - maxIconsInMessage, " more)") : ''));
                _missingIconsTimer = undefined;
                _missingIcons = [];
            }, warningDelay);
        }
    }
}

/** Generates all the semantic slot colors based on the theme so far
 * We'll use these as fallbacks for semantic slots that the passed in theme did not define.
 * The caller must still mix in the customized semantic slots at the end.
 */
function makeSemanticColors(p, e, s, isInverted, depComments) {
    if (depComments === undefined) { depComments = false; }
    var semanticColors = __assign$2({ primaryButtonBorder: 'transparent', errorText: !isInverted ? '#a4262c' : '#F1707B', messageText: !isInverted ? '#323130' : '#F3F2F1', messageLink: !isInverted ? '#005A9E' : '#6CB8F6', messageLinkHovered: !isInverted ? '#004578' : '#82C7FF', infoIcon: !isInverted ? '#605e5c' : '#C8C6C4', errorIcon: !isInverted ? '#A80000' : '#F1707B', blockingIcon: !isInverted ? '#FDE7E9' : '#442726', warningIcon: !isInverted ? '#797775' : '#C8C6C4', severeWarningIcon: !isInverted ? '#D83B01' : '#FCE100', successIcon: !isInverted ? '#107C10' : '#92C353', infoBackground: !isInverted ? '#f3f2f1' : '#323130', errorBackground: !isInverted ? '#FDE7E9' : '#442726', blockingBackground: !isInverted ? '#FDE7E9' : '#442726', warningBackground: !isInverted ? '#FFF4CE' : '#433519', severeWarningBackground: !isInverted ? '#FED9CC' : '#4F2A0F', successBackground: !isInverted ? '#DFF6DD' : '#393D1B', 
        // deprecated
        warningHighlight: !isInverted ? '#ffb900' : '#fff100', successText: !isInverted ? '#107C10' : '#92c353' }, s);
    var fullSemanticColors = getSemanticColors(p, e, semanticColors, isInverted);
    return _fixDeprecatedSlots(fullSemanticColors, depComments);
}
/**
 * Map partial platte and effects to partial semantic colors.
 */
function getSemanticColors(p, e, s, isInverted, depComments) {
    var result = {};
    // map palette
    var _a = p || {}, white = _a.white, black = _a.black, themePrimary = _a.themePrimary, themeDark = _a.themeDark, themeDarker = _a.themeDarker, themeDarkAlt = _a.themeDarkAlt, themeLighter = _a.themeLighter, neutralLight = _a.neutralLight, neutralLighter = _a.neutralLighter, neutralDark = _a.neutralDark, neutralQuaternary = _a.neutralQuaternary, neutralQuaternaryAlt = _a.neutralQuaternaryAlt, neutralPrimary = _a.neutralPrimary, neutralSecondary = _a.neutralSecondary, neutralSecondaryAlt = _a.neutralSecondaryAlt, neutralTertiary = _a.neutralTertiary, neutralTertiaryAlt = _a.neutralTertiaryAlt, neutralLighterAlt = _a.neutralLighterAlt, accent = _a.accent;
    if (white) {
        result.bodyBackground = white;
        result.bodyFrameBackground = white;
        result.accentButtonText = white;
        result.buttonBackground = white;
        result.primaryButtonText = white;
        result.primaryButtonTextHovered = white;
        result.primaryButtonTextPressed = white;
        result.inputBackground = white;
        result.inputForegroundChecked = white;
        result.listBackground = white;
        result.menuBackground = white;
        result.cardStandoutBackground = white;
    }
    if (black) {
        result.bodyTextChecked = black;
        result.buttonTextCheckedHovered = black;
    }
    if (themePrimary) {
        result.link = themePrimary;
        result.primaryButtonBackground = themePrimary;
        result.inputBackgroundChecked = themePrimary;
        result.inputIcon = themePrimary;
        result.inputFocusBorderAlt = themePrimary;
        result.menuIcon = themePrimary;
        result.menuHeader = themePrimary;
        result.accentButtonBackground = themePrimary;
    }
    if (themeDark) {
        result.primaryButtonBackgroundPressed = themeDark;
        result.inputBackgroundCheckedHovered = themeDark;
        result.inputIconHovered = themeDark;
    }
    if (themeDarker) {
        result.linkHovered = themeDarker;
    }
    if (themeDarkAlt) {
        result.primaryButtonBackgroundHovered = themeDarkAlt;
    }
    if (themeLighter) {
        result.inputPlaceholderBackgroundChecked = themeLighter;
    }
    if (neutralLight) {
        result.bodyBackgroundChecked = neutralLight;
        result.bodyFrameDivider = neutralLight;
        result.bodyDivider = neutralLight;
        result.variantBorder = neutralLight;
        result.buttonBackgroundCheckedHovered = neutralLight;
        result.buttonBackgroundPressed = neutralLight;
        result.listItemBackgroundChecked = neutralLight;
        result.listHeaderBackgroundPressed = neutralLight;
        result.menuItemBackgroundPressed = neutralLight;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        result.menuItemBackgroundChecked = neutralLight;
    }
    if (neutralLighter) {
        result.bodyBackgroundHovered = neutralLighter;
        result.buttonBackgroundHovered = neutralLighter;
        result.buttonBackgroundDisabled = neutralLighter;
        result.buttonBorderDisabled = neutralLighter;
        result.primaryButtonBackgroundDisabled = neutralLighter;
        result.disabledBackground = neutralLighter;
        result.listItemBackgroundHovered = neutralLighter;
        result.listHeaderBackgroundHovered = neutralLighter;
        result.menuItemBackgroundHovered = neutralLighter;
    }
    if (neutralQuaternary) {
        result.primaryButtonTextDisabled = neutralQuaternary;
        result.disabledSubtext = neutralQuaternary;
    }
    if (neutralQuaternaryAlt) {
        result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
    }
    if (neutralTertiary) {
        result.disabledBodyText = neutralTertiary;
        result.variantBorderHovered = (s === null || s === undefined ? undefined : s.variantBorderHovered) || neutralTertiary;
        result.buttonTextDisabled = neutralTertiary;
        result.inputIconDisabled = neutralTertiary;
        result.disabledText = neutralTertiary;
    }
    if (neutralPrimary) {
        result.bodyText = neutralPrimary;
        result.actionLink = neutralPrimary;
        result.buttonText = neutralPrimary;
        result.inputBorderHovered = neutralPrimary;
        result.inputText = neutralPrimary;
        result.listText = neutralPrimary;
        result.menuItemText = neutralPrimary;
    }
    if (neutralLighterAlt) {
        result.bodyStandoutBackground = neutralLighterAlt;
        result.defaultStateBackground = neutralLighterAlt;
    }
    if (neutralDark) {
        result.actionLinkHovered = neutralDark;
        result.buttonTextHovered = neutralDark;
        result.buttonTextChecked = neutralDark;
        result.buttonTextPressed = neutralDark;
        result.inputTextHovered = neutralDark;
        result.menuItemTextHovered = neutralDark;
    }
    if (neutralSecondary) {
        result.bodySubtext = neutralSecondary;
        result.focusBorder = neutralSecondary;
        result.inputBorder = neutralSecondary;
        result.smallInputBorder = neutralSecondary;
        result.inputPlaceholderText = neutralSecondary;
    }
    if (neutralSecondaryAlt) {
        result.buttonBorder = neutralSecondaryAlt;
    }
    if (neutralTertiaryAlt) {
        result.disabledBodySubtext = neutralTertiaryAlt;
        result.disabledBorder = neutralTertiaryAlt;
        result.buttonBackgroundChecked = neutralTertiaryAlt;
        result.menuDivider = neutralTertiaryAlt;
    }
    if (accent) {
        result.accentButtonBackground = accent;
    }
    // map effects
    if (e === null || e === undefined ? undefined : e.elevation4) {
        result.cardShadow = e.elevation4;
    }
    if (!isInverted && (e === null || e === undefined ? undefined : e.elevation8)) {
        result.cardShadowHovered = e.elevation8;
    }
    else if (result.variantBorderHovered) {
        result.cardShadowHovered = '0 0 1px ' + result.variantBorderHovered;
    }
    result = __assign$2(__assign$2({}, result), s);
    return result;
}
function _fixDeprecatedSlots(s, depComments) {
    // Add @deprecated tag as comment if enabled
    var dep = '';
    if (depComments === true) {
        dep = ' /* @deprecated */';
    }
    /*  eslint-disable @typescript-eslint/no-deprecated */
    s.listTextColor = s.listText + dep;
    s.menuItemBackgroundChecked += dep;
    s.warningHighlight += dep;
    s.warningText = s.messageText + dep;
    s.successText += dep;
    /* eslint-enable @typescript-eslint/no-deprecated */
    return s;
}

/**
 * Merge a partial/full theme into a full theme and returns a merged full theme.
 */
function mergeThemes(theme, partialTheme) {
    var _a, _b, _c;
    if (partialTheme === undefined) { partialTheme = {}; }
    var mergedTheme = merge$4({}, theme, partialTheme, {
        semanticColors: getSemanticColors(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted),
    });
    if (((_a = partialTheme.palette) === null || _a === undefined ? undefined : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === undefined ? undefined : _b.accent)) {
        mergedTheme.palette.accent = partialTheme.palette.themePrimary;
    }
    if (partialTheme.defaultFontStyle) {
        for (var _i = 0, _d = Object.keys(mergedTheme.fonts); _i < _d.length; _i++) {
            var fontStyle = _d[_i];
            mergedTheme.fonts[fontStyle] = merge$4(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_c = partialTheme === null || partialTheme === undefined ? undefined : partialTheme.fonts) === null || _c === undefined ? undefined : _c[fontStyle]);
        }
    }
    return mergedTheme;
}

// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var DefaultPalette = {
    themeDarker: '#004578',
    themeDark: '#005a9e',
    themeDarkAlt: '#106ebe',
    themePrimary: '#0078d4',
    themeSecondary: '#2b88d8',
    themeTertiary: '#71afe5',
    themeLight: '#c7e0f4',
    themeLighter: '#deecf9',
    themeLighterAlt: '#eff6fc',
    black: '#000000',
    blackTranslucent40: 'rgba(0,0,0,.4)',
    neutralDark: '#201f1e',
    neutralPrimary: '#323130',
    neutralPrimaryAlt: '#3b3a39',
    neutralSecondary: '#605e5c',
    neutralSecondaryAlt: '#8a8886',
    neutralTertiary: '#a19f9d',
    neutralTertiaryAlt: '#c8c6c4',
    neutralQuaternary: '#d2d0ce',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralLight: '#edebe9',
    neutralLighter: '#f3f2f1',
    neutralLighterAlt: '#faf9f8',
    accent: '#0078d4',
    white: '#ffffff',
    whiteTranslucent40: 'rgba(255,255,255,.4)',
    yellowDark: '#d29200',
    yellow: '#ffb900',
    yellowLight: '#fff100',
    orange: '#d83b01',
    orangeLight: '#ea4300',
    orangeLighter: '#ff8c00',
    redDark: '#a4262c',
    red: '#e81123',
    magentaDark: '#5c005c',
    magenta: '#b4009e',
    magentaLight: '#e3008c',
    purpleDark: '#32145a',
    purple: '#5c2d91',
    purpleLight: '#b4a0ff',
    blueDark: '#002050',
    blueMid: '#00188f',
    blue: '#0078d4',
    blueLight: '#00bcf2',
    tealDark: '#004b50',
    teal: '#008272',
    tealLight: '#00b294',
    greenDark: '#004b1c',
    green: '#107c10',
    greenLight: '#bad80a',
};

var Depths;
(function (Depths) {
    Depths.depth0 = '0 0 0 0 transparent';
    Depths.depth4 = '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)';
    Depths.depth8 = '0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)';
    Depths.depth16 = '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)';
    Depths.depth64 = '0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)';
})(Depths || (Depths = {}));

var DefaultEffects = {
    elevation4: Depths.depth4,
    elevation8: Depths.depth8,
    elevation16: Depths.depth16,
    elevation64: Depths.depth64,
    roundedCorner2: '2px',
    roundedCorner4: '4px',
    roundedCorner6: '6px',
};

var DefaultSpacing = {
    s2: '4px',
    s1: '8px',
    m: '16px',
    l1: '20px',
    l2: '32px',
};

/* Register the keyframes */
var EASING_FUNCTION_1 = 'cubic-bezier(.1,.9,.2,1)';
var EASING_FUNCTION_2 = 'cubic-bezier(.1,.25,.75,.9)';
var DURATION_1 = '0.167s';
var DURATION_2 = '0.267s';
var DURATION_3 = '0.367s';
var DURATION_4 = '0.467s';
var FADE_IN = keyframes({
    from: { opacity: 0 },
    to: { opacity: 1 },
});
var FADE_OUT = keyframes({
    from: { opacity: 1 },
    to: { opacity: 0, visibility: 'hidden' },
});
var SLIDE_RIGHT_IN10 = _createSlideInX(-10);
var SLIDE_RIGHT_IN20 = _createSlideInX(-20);
var SLIDE_RIGHT_IN40 = _createSlideInX(-40);
var SLIDE_RIGHT_IN400 = _createSlideInX(-400);
var SLIDE_LEFT_IN10 = _createSlideInX(10);
var SLIDE_LEFT_IN20 = _createSlideInX(20);
var SLIDE_LEFT_IN40 = _createSlideInX(40);
var SLIDE_LEFT_IN400 = _createSlideInX(400);
var SLIDE_UP_IN10 = _createSlideInY(10);
var SLIDE_UP_IN20 = _createSlideInY(20);
var SLIDE_DOWN_IN10 = _createSlideInY(-10);
var SLIDE_DOWN_IN20 = _createSlideInY(-20);
var SLIDE_RIGHT_OUT10 = _createSlideOutX(10);
var SLIDE_RIGHT_OUT20 = _createSlideOutX(20);
var SLIDE_RIGHT_OUT40 = _createSlideOutX(40);
var SLIDE_RIGHT_OUT400 = _createSlideOutX(400);
var SLIDE_LEFT_OUT10 = _createSlideOutX(-10);
var SLIDE_LEFT_OUT20 = _createSlideOutX(-20);
var SLIDE_LEFT_OUT40 = _createSlideOutX(-40);
var SLIDE_LEFT_OUT400 = _createSlideOutX(-400);
var SLIDE_UP_OUT10 = _createSlideOutY(-10);
var SLIDE_UP_OUT20 = _createSlideOutY(-20);
var SLIDE_DOWN_OUT10 = _createSlideOutY(10);
var SLIDE_DOWN_OUT20 = _createSlideOutY(20);
var SCALE_UP100 = keyframes({
    from: { transform: 'scale3d(.98,.98,1)' },
    to: { transform: 'scale3d(1,1,1)' },
});
var SCALE_DOWN98 = keyframes({
    from: { transform: 'scale3d(1,1,1)' },
    to: { transform: 'scale3d(.98,.98,1)' },
});
var SCALE_DOWN100 = keyframes({
    from: { transform: 'scale3d(1.03,1.03,1)' },
    to: { transform: 'scale3d(1,1,1)' },
});
var SCALE_UP103 = keyframes({
    from: { transform: 'scale3d(1,1,1)' },
    to: { transform: 'scale3d(1.03,1.03,1)' },
});
var ROTATE90 = keyframes({
    from: { transform: 'rotateZ(0deg)' },
    to: { transform: 'rotateZ(90deg)' },
});
var ROTATE_N90 = keyframes({
    from: { transform: 'rotateZ(0deg)' },
    to: { transform: 'rotateZ(-90deg)' },
});
/**
 * Exporting raw duraction values and easing functions to be used in custom animations
 */
var AnimationVariables = {
    easeFunction1: EASING_FUNCTION_1,
    easeFunction2: EASING_FUNCTION_2,
    durationValue1: DURATION_1,
    durationValue2: DURATION_2,
    durationValue3: DURATION_3,
    durationValue4: DURATION_4,
};
/**
 * All Fabric standard animations, exposed as json objects referencing predefined
 * keyframes. These objects can be mixed in with other class definitions.
 */
var AnimationStyles = {
    slideRightIn10: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_RIGHT_IN10), DURATION_3, EASING_FUNCTION_1),
    slideRightIn20: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_RIGHT_IN20), DURATION_3, EASING_FUNCTION_1),
    slideRightIn40: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_RIGHT_IN40), DURATION_3, EASING_FUNCTION_1),
    slideRightIn400: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_RIGHT_IN400), DURATION_3, EASING_FUNCTION_1),
    slideLeftIn10: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_LEFT_IN10), DURATION_3, EASING_FUNCTION_1),
    slideLeftIn20: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_LEFT_IN20), DURATION_3, EASING_FUNCTION_1),
    slideLeftIn40: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_LEFT_IN40), DURATION_3, EASING_FUNCTION_1),
    slideLeftIn400: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_LEFT_IN400), DURATION_3, EASING_FUNCTION_1),
    slideUpIn10: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_UP_IN10), DURATION_3, EASING_FUNCTION_1),
    slideUpIn20: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_UP_IN20), DURATION_3, EASING_FUNCTION_1),
    slideDownIn10: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_DOWN_IN10), DURATION_3, EASING_FUNCTION_1),
    slideDownIn20: _createAnimation("".concat(FADE_IN, ",").concat(SLIDE_DOWN_IN20), DURATION_3, EASING_FUNCTION_1),
    slideRightOut10: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_RIGHT_OUT10), DURATION_3, EASING_FUNCTION_1),
    slideRightOut20: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_RIGHT_OUT20), DURATION_3, EASING_FUNCTION_1),
    slideRightOut40: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_RIGHT_OUT40), DURATION_3, EASING_FUNCTION_1),
    slideRightOut400: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_RIGHT_OUT400), DURATION_3, EASING_FUNCTION_1),
    slideLeftOut10: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_LEFT_OUT10), DURATION_3, EASING_FUNCTION_1),
    slideLeftOut20: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_LEFT_OUT20), DURATION_3, EASING_FUNCTION_1),
    slideLeftOut40: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_LEFT_OUT40), DURATION_3, EASING_FUNCTION_1),
    slideLeftOut400: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_LEFT_OUT400), DURATION_3, EASING_FUNCTION_1),
    slideUpOut10: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_UP_OUT10), DURATION_3, EASING_FUNCTION_1),
    slideUpOut20: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_UP_OUT20), DURATION_3, EASING_FUNCTION_1),
    slideDownOut10: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_DOWN_OUT10), DURATION_3, EASING_FUNCTION_1),
    slideDownOut20: _createAnimation("".concat(FADE_OUT, ",").concat(SLIDE_DOWN_OUT20), DURATION_3, EASING_FUNCTION_1),
    scaleUpIn100: _createAnimation("".concat(FADE_IN, ",").concat(SCALE_UP100), DURATION_3, EASING_FUNCTION_1),
    scaleDownIn100: _createAnimation("".concat(FADE_IN, ",").concat(SCALE_DOWN100), DURATION_3, EASING_FUNCTION_1),
    scaleUpOut103: _createAnimation("".concat(FADE_OUT, ",").concat(SCALE_UP103), DURATION_1, EASING_FUNCTION_2),
    scaleDownOut98: _createAnimation("".concat(FADE_OUT, ",").concat(SCALE_DOWN98), DURATION_1, EASING_FUNCTION_2),
    fadeIn100: _createAnimation(FADE_IN, DURATION_1, EASING_FUNCTION_2),
    fadeIn200: _createAnimation(FADE_IN, DURATION_2, EASING_FUNCTION_2),
    fadeIn400: _createAnimation(FADE_IN, DURATION_3, EASING_FUNCTION_2),
    fadeIn500: _createAnimation(FADE_IN, DURATION_4, EASING_FUNCTION_2),
    fadeOut100: _createAnimation(FADE_OUT, DURATION_1, EASING_FUNCTION_2),
    fadeOut200: _createAnimation(FADE_OUT, DURATION_2, EASING_FUNCTION_2),
    fadeOut400: _createAnimation(FADE_OUT, DURATION_3, EASING_FUNCTION_2),
    fadeOut500: _createAnimation(FADE_OUT, DURATION_4, EASING_FUNCTION_2),
    rotate90deg: _createAnimation(ROTATE90, '0.1s', EASING_FUNCTION_2),
    rotateN90deg: _createAnimation(ROTATE_N90, '0.1s', EASING_FUNCTION_2),
    // expandCollapse 100/200/400, delay 100/200
};
function _createAnimation(animationName, animationDuration, animationTimingFunction) {
    return {
        animationName: animationName,
        animationDuration: animationDuration,
        animationTimingFunction: animationTimingFunction,
        animationFillMode: 'both',
    };
}
function _createSlideInX(fromX) {
    return keyframes({
        from: { transform: "translate3d(".concat(fromX, "px,0,0)"), pointerEvents: 'none' },
        to: { transform: "translate3d(0,0,0)", pointerEvents: 'auto' },
    });
}
function _createSlideInY(fromY) {
    return keyframes({
        from: { transform: "translate3d(0,".concat(fromY, "px,0)"), pointerEvents: 'none' },
        to: { transform: "translate3d(0,0,0)", pointerEvents: 'auto' },
    });
}
function _createSlideOutX(toX) {
    return keyframes({
        from: { transform: "translate3d(0,0,0)" },
        to: { transform: "translate3d(".concat(toX, "px,0,0)") },
    });
}
function _createSlideOutY(toY) {
    return keyframes({
        from: { transform: "translate3d(0,0,0)" },
        to: { transform: "translate3d(0,".concat(toY, "px,0)") },
    });
}

// Font face names to be registered.
var LocalizedFontNames;
(function (LocalizedFontNames) {
    LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
    LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
    LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
    LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
    LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
    LocalizedFontNames.Thai = 'Leelawadee UI Web';
    LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
    LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
    LocalizedFontNames.Selawik = 'Selawik Web';
    LocalizedFontNames.Armenian = 'Segoe UI Web (Armenian)';
    LocalizedFontNames.Georgian = 'Segoe UI Web (Georgian)';
})(LocalizedFontNames || (LocalizedFontNames = {}));
// Font families with fallbacks, for the general regions.
var LocalizedFontFamilies;
(function (LocalizedFontFamilies) {
    LocalizedFontFamilies.Arabic = "'".concat(LocalizedFontNames.Arabic, "'");
    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
    LocalizedFontFamilies.Cyrillic = "'".concat(LocalizedFontNames.Cyrillic, "'");
    LocalizedFontFamilies.EastEuropean = "'".concat(LocalizedFontNames.EastEuropean, "'");
    LocalizedFontFamilies.Greek = "'".concat(LocalizedFontNames.Greek, "'");
    LocalizedFontFamilies.Hebrew = "'".concat(LocalizedFontNames.Hebrew, "'");
    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
    LocalizedFontFamilies.Selawik = "'".concat(LocalizedFontNames.Selawik, "'");
    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
    LocalizedFontFamilies.Vietnamese = "'".concat(LocalizedFontNames.Vietnamese, "'");
    LocalizedFontFamilies.WestEuropean = "'".concat(LocalizedFontNames.WestEuropean, "'");
    LocalizedFontFamilies.Armenian = "'".concat(LocalizedFontNames.Armenian, "'");
    LocalizedFontFamilies.Georgian = "'".concat(LocalizedFontNames.Georgian, "'");
})(LocalizedFontFamilies || (LocalizedFontFamilies = {}));
// Standard font sizes.
var FontSizes;
(function (FontSizes) {
    FontSizes.size10 = '10px';
    FontSizes.size12 = '12px';
    FontSizes.size14 = '14px';
    FontSizes.size16 = '16px';
    FontSizes.size18 = '18px';
    FontSizes.size20 = '20px';
    FontSizes.size24 = '24px';
    FontSizes.size28 = '28px';
    FontSizes.size32 = '32px';
    FontSizes.size42 = '42px';
    FontSizes.size68 = '68px';
    FontSizes.mini = '10px';
    FontSizes.xSmall = '10px';
    FontSizes.small = '12px';
    FontSizes.smallPlus = '12px';
    FontSizes.medium = '14px';
    FontSizes.mediumPlus = '16px';
    FontSizes.icon = '16px';
    FontSizes.large = '18px';
    FontSizes.xLarge = '20px';
    FontSizes.xLargePlus = '24px';
    FontSizes.xxLarge = '28px';
    FontSizes.xxLargePlus = '32px';
    FontSizes.superLarge = '42px';
    FontSizes.mega = '68px';
})(FontSizes || (FontSizes = {}));
// Standard font weights.
var FontWeights;
(function (FontWeights) {
    FontWeights.light = 100;
    FontWeights.semilight = 300;
    FontWeights.regular = 400;
    FontWeights.semibold = 600;
    FontWeights.bold = 700;
})(FontWeights || (FontWeights = {}));
// Standard Icon Sizes.
var IconFontSizes;
(function (IconFontSizes) {
    IconFontSizes.xSmall = '10px';
    IconFontSizes.small = '12px';
    IconFontSizes.medium = '16px';
    IconFontSizes.large = '20px';
})(IconFontSizes || (IconFontSizes = {}));

// Fallback fonts, if specified system or web fonts are unavailable.
var FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
// By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.
var defaultFontFamily = "'Segoe UI', '".concat(LocalizedFontNames.WestEuropean, "'");
// Mapping of language prefix to to font family.
var LanguageToFontMap = {
    ar: LocalizedFontFamilies.Arabic,
    bg: LocalizedFontFamilies.Cyrillic,
    cs: LocalizedFontFamilies.EastEuropean,
    el: LocalizedFontFamilies.Greek,
    et: LocalizedFontFamilies.EastEuropean,
    he: LocalizedFontFamilies.Hebrew,
    hi: LocalizedFontFamilies.Hindi,
    hr: LocalizedFontFamilies.EastEuropean,
    hu: LocalizedFontFamilies.EastEuropean,
    ja: LocalizedFontFamilies.Japanese,
    kk: LocalizedFontFamilies.EastEuropean,
    ko: LocalizedFontFamilies.Korean,
    lt: LocalizedFontFamilies.EastEuropean,
    lv: LocalizedFontFamilies.EastEuropean,
    pl: LocalizedFontFamilies.EastEuropean,
    ru: LocalizedFontFamilies.Cyrillic,
    sk: LocalizedFontFamilies.EastEuropean,
    'sr-latn': LocalizedFontFamilies.EastEuropean,
    th: LocalizedFontFamilies.Thai,
    tr: LocalizedFontFamilies.EastEuropean,
    uk: LocalizedFontFamilies.Cyrillic,
    vi: LocalizedFontFamilies.Vietnamese,
    'zh-hans': LocalizedFontFamilies.ChineseSimplified,
    'zh-hant': LocalizedFontFamilies.ChineseTraditional,
    hy: LocalizedFontFamilies.Armenian,
    ka: LocalizedFontFamilies.Georgian,
};
function _fontFamilyWithFallbacks(fontFamily) {
    return "".concat(fontFamily, ", ").concat(FontFamilyFallbacks);
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */
function _getLocalizedFontFamily(language) {
    for (var lang in LanguageToFontMap) {
        if (LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return LanguageToFontMap[lang];
        }
    }
    return defaultFontFamily;
}
function _createFont(size, weight, fontFamily) {
    return {
        fontFamily: fontFamily,
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        fontSize: size,
        fontWeight: weight,
    };
}
function createFontStyles(localeCode) {
    var localizedFont = _getLocalizedFontFamily(localeCode);
    var fontFamilyWithFallback = _fontFamilyWithFallbacks(localizedFont);
    var fontStyles = {
        tiny: _createFont(FontSizes.mini, FontWeights.regular, fontFamilyWithFallback),
        xSmall: _createFont(FontSizes.xSmall, FontWeights.regular, fontFamilyWithFallback),
        small: _createFont(FontSizes.small, FontWeights.regular, fontFamilyWithFallback),
        smallPlus: _createFont(FontSizes.smallPlus, FontWeights.regular, fontFamilyWithFallback),
        medium: _createFont(FontSizes.medium, FontWeights.regular, fontFamilyWithFallback),
        mediumPlus: _createFont(FontSizes.mediumPlus, FontWeights.regular, fontFamilyWithFallback),
        large: _createFont(FontSizes.large, FontWeights.regular, fontFamilyWithFallback),
        xLarge: _createFont(FontSizes.xLarge, FontWeights.semibold, fontFamilyWithFallback),
        xLargePlus: _createFont(FontSizes.xLargePlus, FontWeights.semibold, fontFamilyWithFallback),
        xxLarge: _createFont(FontSizes.xxLarge, FontWeights.semibold, fontFamilyWithFallback),
        xxLargePlus: _createFont(FontSizes.xxLargePlus, FontWeights.semibold, fontFamilyWithFallback),
        superLarge: _createFont(FontSizes.superLarge, FontWeights.semibold, fontFamilyWithFallback),
        mega: _createFont(FontSizes.mega, FontWeights.semibold, fontFamilyWithFallback),
    };
    return fontStyles;
}

// Default urls.
var DefaultBaseUrl = 'https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets';
// Standard font styling.
var DefaultFontStyles = createFontStyles(getLanguage());
function _registerFontFace(fontFamily, url, fontWeight, localFontName) {
    fontFamily = "'".concat(fontFamily, "'");
    var localFontSrc = localFontName !== undefined ? "local('".concat(localFontName, "'),") : '';
    fontFace({
        fontFamily: fontFamily,
        src: localFontSrc + "url('".concat(url, ".woff2') format('woff2'),") + "url('".concat(url, ".woff') format('woff')"),
        fontWeight: fontWeight,
        fontStyle: 'normal',
        fontDisplay: 'swap',
    });
}
function _registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
    if (cdnFontName === undefined) { cdnFontName = 'segoeui'; }
    var urlBase = "".concat(baseUrl, "/").concat(cdnFolder, "/").concat(cdnFontName);
    _registerFontFace(fontFamily, urlBase + '-light', FontWeights.light, localFontName && localFontName + ' Light');
    _registerFontFace(fontFamily, urlBase + '-semilight', FontWeights.semilight, localFontName && localFontName + ' SemiLight');
    _registerFontFace(fontFamily, urlBase + '-regular', FontWeights.regular, localFontName);
    _registerFontFace(fontFamily, urlBase + '-semibold', FontWeights.semibold, localFontName && localFontName + ' SemiBold');
    _registerFontFace(fontFamily, urlBase + '-bold', FontWeights.bold, localFontName && localFontName + ' Bold');
}
function registerDefaultFontFaces(baseUrl) {
    if (baseUrl) {
        var fontUrl = "".concat(baseUrl, "/fonts");
        // Produce @font-face definitions for all supported web fonts.
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Thai, 'leelawadeeui-thai', 'leelawadeeui');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Arabic, 'segoeui-arabic');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Cyrillic, 'segoeui-cyrillic');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.EastEuropean, 'segoeui-easteuropean');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Greek, 'segoeui-greek');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Hebrew, 'segoeui-hebrew');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Vietnamese, 'segoeui-vietnamese');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');
        _registerFontFaceSet(fontUrl, LocalizedFontFamilies.Selawik, 'selawik', 'selawik');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Armenian, 'segoeui-armenian');
        _registerFontFaceSet(fontUrl, LocalizedFontNames.Georgian, 'segoeui-georgian');
        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
        // the font-face generated above to use the 'semilight' weight instead.
        _registerFontFace('Leelawadee UI Web', "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-semilight"), FontWeights.light);
        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
        // the font-face generated above to use the 'bold' weight instead.
        _registerFontFace('Leelawadee UI Web', "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-bold"), FontWeights.semibold);
    }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */
function _getFontBaseUrl() {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var fabricConfig = (_a = getWindow$2()) === null || _a === undefined ? undefined : _a.FabricConfig;
    return (_b = fabricConfig === null || fabricConfig === undefined ? undefined : fabricConfig.fontBaseUrl) !== null && _b !== undefined ? _b : DefaultBaseUrl;
}
/**
 * Register the font faces.
 */
registerDefaultFontFaces(_getFontBaseUrl());

/**
 * Creates a custom theme definition.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
function createTheme(theme, depComments) {
    if (theme === undefined) { theme = {}; }
    if (depComments === undefined) { depComments = false; }
    var isInverted = !!theme.isInverted;
    var baseTheme = {
        palette: DefaultPalette,
        effects: DefaultEffects,
        fonts: DefaultFontStyles,
        spacing: DefaultSpacing,
        isInverted: isInverted,
        disableGlobalClassNames: false,
        semanticColors: makeSemanticColors(DefaultPalette, DefaultEffects, undefined, isInverted, depComments),
        rtl: undefined,
    };
    return mergeThemes(baseTheme, theme);
}

var HighContrastSelector = '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)';
var ScreenWidthMinSmall = 320;
var ScreenWidthMinMedium = 480;
var ScreenWidthMinLarge = 640;
var ScreenWidthMinXLarge = 1024;
var ScreenWidthMinXXLarge = 1366;
var ScreenWidthMaxSmall = ScreenWidthMinMedium - 1;
var ScreenWidthMaxMedium = ScreenWidthMinLarge - 1;
var ScreenWidthMinUhfMobile = 768;
function getScreenSelector(min, max) {
    var minSelector = " and (min-width: ".concat(min, "px)") ;
    var maxSelector = " and (max-width: ".concat(max, "px)") ;
    return "@media only screen".concat(minSelector).concat(maxSelector);
}
/**
 * The style which turns off high contrast adjustment in browsers.
 */
function getHighContrastNoAdjustStyle() {
    return {
        forcedColorAdjust: 'none',
        MsHighContrastAdjust: 'none',
    };
}

var ZIndexes;
(function (ZIndexes) {
    ZIndexes.Nav = 1;
    /**
     * @deprecated Do not use
     */
    ZIndexes.ScrollablePane = 1;
    ZIndexes.FocusStyle = 1;
    ZIndexes.Coachmark = 1000;
    ZIndexes.Layer = 1000000;
    ZIndexes.KeytipLayer = 1000001;
})(ZIndexes || (ZIndexes = {}));

function getFocusStyle(theme, insetOrOptions, position, highContrastStyle, borderColor, outlineColor, isFocusedOnly, borderRadius) {
  if (typeof insetOrOptions === "number" || !insetOrOptions) {
    return _getFocusStyleInternal(theme, {
      inset: insetOrOptions,
      position,
      highContrastStyle,
      borderColor,
      outlineColor,
      isFocusedOnly,
      borderRadius
    });
  } else {
    return _getFocusStyleInternal(theme, insetOrOptions);
  }
}
function _getFocusStyleInternal(theme, options) {
  var _a, _b;
  if (options === undefined) {
    options = {};
  }
  var borderRadius = options.borderRadius, _c = options.inset, inset = _c === undefined ? 0 : _c, _d = options.width, width = _d === undefined ? 1 : _d, _e = options.position, position = _e === undefined ? "relative" : _e, highContrastStyle = options.highContrastStyle, _f = options.borderColor, borderColor = _f === undefined ? theme.palette.white : _f, _g = options.outlineColor, outlineColor = _g === undefined ? theme.palette.neutralSecondary : _g, _h = options.isFocusedOnly, isFocusedOnly = _h === undefined ? true : _h, pointerEvents = options.pointerEvents;
  return {
    // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
    outline: "transparent",
    // Requirement because pseudo-element is absolutely positioned.
    position,
    selectors: (_a = {
      // Clear the focus border in Firefox.
      // Reference: http://stackoverflow.com/a/199319/1436671
      "::-moz-focus-inner": {
        border: "0"
      }
    }, // When the element that uses this mixin is in a :focus state, add a pseudo-element to
    // create a border.
    _a[".".concat(IsFocusVisibleClassName, " &").concat(isFocusedOnly ? ":focus" : "", ":after, :host(.").concat(IsFocusVisibleClassName, ") &").concat(isFocusedOnly ? ":focus" : "", ":after")] = {
      content: '""',
      position: "absolute",
      pointerEvents,
      left: inset + 1,
      top: inset + 1,
      bottom: inset + 1,
      right: inset + 1,
      border: "".concat(width, "px solid ").concat(borderColor),
      outline: "".concat(width, "px solid ").concat(outlineColor),
      zIndex: ZIndexes.FocusStyle,
      borderRadius,
      selectors: (_b = {}, _b[HighContrastSelector] = highContrastStyle, _b)
    }, _a)
  };
}
function focusClear() {
  return {
    selectors: {
      "&::-moz-focus-inner": {
        // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
        border: 0
      },
      "&": {
        // Clear browser specific focus styles and use transparent as placeholder for focus style
        outline: "transparent"
      }
    }
  };
}

var hiddenContentStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
};

var DEFAULT_DURATION = '14s';
var DEFAULT_DELAY = '2s';
var DEFAULT_ITERATION_COUNT = '1';
function _continuousPulseStepOne(beaconColorOne, innerDimension) {
    return {
        borderColor: beaconColorOne,
        borderWidth: '0px',
        width: innerDimension,
        height: innerDimension,
    };
}
function _continuousPulseStepTwo(borderWidth) {
    return {
        opacity: 1,
        borderWidth: borderWidth,
    };
}
function _continuousPulseStepThree() {
    return {
        opacity: 1,
    };
}
function _continuousPulseStepFour(beaconColorTwo, outerDimension) {
    return {
        borderWidth: '0',
        width: outerDimension,
        height: outerDimension,
        opacity: 0,
        borderColor: beaconColorTwo,
    };
}
function _continuousPulseStepFive(beaconColorOne, innerDimension) {
    return __assign$2(__assign$2({}, _continuousPulseStepOne(beaconColorOne, innerDimension)), {
        opacity: 0,
    });
}
function _continuousPulseAnimationDouble(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
    return keyframes({
        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '1.42%': _continuousPulseStepTwo(borderWidth),
        '3.57%': _continuousPulseStepThree(),
        '7.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '8%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '29.99%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '30%': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '31.42%': _continuousPulseStepTwo(borderWidth),
        '33.57%': _continuousPulseStepThree(),
        '37.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '38%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '79.42%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '79.43': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '81.85': _continuousPulseStepTwo(borderWidth),
        '83.42': _continuousPulseStepThree(),
        '87%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '100%': {},
    });
}
function _continuousPulseAnimationSingle(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
    return keyframes({
        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '14.2%': _continuousPulseStepTwo(borderWidth),
        '35.7%': _continuousPulseStepThree(),
        '71.4%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '100%': {},
    });
}
function _createDefaultAnimation(animationName, delayLength) {
    return {
        animationName: animationName,
        animationIterationCount: DEFAULT_ITERATION_COUNT,
        animationDuration: DEFAULT_DURATION,
        animationDelay: delayLength || DEFAULT_DELAY,
    };
}
var PulsingBeaconAnimationStyles = {
    continuousPulseAnimationDouble: _continuousPulseAnimationDouble,
    continuousPulseAnimationSingle: _continuousPulseAnimationSingle,
    createDefaultAnimation: _createDefaultAnimation,
};

var _getGlobalClassNames = memoizeFunction(function(classNames, disableGlobalClassNames) {
  var styleSheet = Stylesheet.getInstance();
  if (disableGlobalClassNames) {
    return Object.keys(classNames).reduce(function(acc, className) {
      acc[className] = styleSheet.getClassName(classNames[className]);
      return acc;
    }, {});
  }
  return classNames;
});
function getGlobalClassNames(classNames, theme, disableGlobalClassNames) {
  return _getGlobalClassNames(classNames, theme.disableGlobalClassNames);
}

var __assign$1 = function() {
  __assign$1 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
        t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
var _root$1 = typeof window === "undefined" ? window : window;
var _styleNonce = _root$1 && _root$1.CSPSettings && _root$1.CSPSettings.nonce;
var _themeState = initializeThemeState();
function initializeThemeState() {
  var state = _root$1.__themeState__ || {
    theme: undefined,
    lastStyleElement: undefined,
    registeredStyles: []
  };
  if (!state.runState) {
    state = __assign$1(__assign$1({}, state), { perf: {
      count: 0,
      duration: 0
    }, runState: {
      flushTimer: 0,
      mode: 0,
      buffer: []
    } });
  }
  if (!state.registeredThemableStyles) {
    state = __assign$1(__assign$1({}, state), { registeredThemableStyles: [] });
  }
  _root$1.__themeState__ = state;
  return state;
}
function applyThemableStyles(stylesArray, styleRecord) {
  if (_themeState.loadStyles) {
    _themeState.loadStyles(resolveThemableArray(stylesArray).styleString, stylesArray);
  } else {
    registerStyles(stylesArray);
  }
}
function loadTheme$1(theme) {
  _themeState.theme = theme;
  reloadStyles();
}
function clearStyles(option) {
  {
    clearStylesInternal(_themeState.registeredThemableStyles);
    _themeState.registeredThemableStyles = [];
  }
}
function clearStylesInternal(records) {
  records.forEach(function(styleRecord) {
    var styleElement = styleRecord && styleRecord.styleElement;
    if (styleElement && styleElement.parentElement) {
      styleElement.parentElement.removeChild(styleElement);
    }
  });
}
function reloadStyles() {
  if (_themeState.theme) {
    var themableStyles = [];
    for (var _i = 0, _a = _themeState.registeredThemableStyles; _i < _a.length; _i++) {
      var styleRecord = _a[_i];
      themableStyles.push(styleRecord.themableStyle);
    }
    if (themableStyles.length > 0) {
      clearStyles();
      applyThemableStyles([].concat.apply([], themableStyles));
    }
  }
}
function resolveThemableArray(splitStyleArray) {
  var theme = _themeState.theme;
  var themable = false;
  var resolvedArray = (splitStyleArray || []).map(function(currentValue) {
    var themeSlot = currentValue.theme;
    if (themeSlot) {
      themable = true;
      var themedValue = theme ? theme[themeSlot] : undefined;
      var defaultValue = currentValue.defaultValue || "inherit";
      if (theme && !themedValue && console && !(themeSlot in theme) && typeof DEBUG !== "undefined" && DEBUG) {
        console.warn('Theming value not provided for "'.concat(themeSlot, '". Falling back to "').concat(defaultValue, '".'));
      }
      return themedValue || defaultValue;
    } else {
      return currentValue.rawString;
    }
  });
  return {
    styleString: resolvedArray.join(""),
    themable
  };
}
function registerStyles(styleArray) {
  if (typeof document === "undefined") {
    return;
  }
  var head = document.getElementsByTagName("head")[0];
  var styleElement = document.createElement("style");
  var _a = resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
  styleElement.setAttribute("data-load-themed-styles", "true");
  if (_styleNonce) {
    styleElement.setAttribute("nonce", _styleNonce);
  }
  styleElement.appendChild(document.createTextNode(styleString));
  _themeState.perf.count++;
  head.appendChild(styleElement);
  var ev = document.createEvent("HTMLEvents");
  ev.initEvent(
    "styleinsert",
    true,
    false
    /* cancelable */
  );
  ev.args = {
    newStyle: styleElement
  };
  document.dispatchEvent(ev);
  var record = {
    styleElement,
    themableStyle: styleArray
  };
  if (themable) {
    _themeState.registeredThemableStyles.push(record);
  } else {
    _themeState.registeredStyles.push(record);
  }
}

var _theme = createTheme({});
var _onThemeChangeCallbacks = [];
var ThemeSettingName = 'theme';
function initializeThemeInCustomizations() {
    var _a;
    var _b, _c;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var win = getWindow$2();
    if ((_b = win === null || win === undefined ? undefined : win.FabricConfig) === null || _b === undefined ? undefined : _b.legacyTheme) {
        // does everything the `else` clause does and more, such as invoke legacy theming
        loadTheme(win.FabricConfig.legacyTheme);
    }
    else if (!Customizations.getSettings([ThemeSettingName]).theme) {
        if ((_c = win === null || win === undefined ? undefined : win.FabricConfig) === null || _c === undefined ? undefined : _c.theme) {
            _theme = createTheme(win.FabricConfig.theme);
        }
        // Set the default theme.
        Customizations.applySettings((_a = {}, _a[ThemeSettingName] = _theme, _a));
    }
}
initializeThemeInCustomizations();
/**
 * Gets the theme object
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
function getTheme(depComments) {
    if (depComments === undefined) { depComments = false; }
    if (depComments === true) {
        _theme = createTheme({}, depComments);
    }
    return _theme;
}
/**
 * Applies the theme, while filling in missing slots.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
function loadTheme(theme, depComments) {
    var _a;
    if (depComments === undefined) { depComments = false; }
    _theme = createTheme(theme, depComments);
    // Invoke the legacy method of theming the page as well.
    loadTheme$1(__assign$2(__assign$2(__assign$2(__assign$2({}, _theme.palette), _theme.semanticColors), _theme.effects), _loadFonts(_theme)));
    Customizations.applySettings((_a = {}, _a[ThemeSettingName] = _theme, _a));
    _onThemeChangeCallbacks.forEach(function (callback) {
        try {
            callback(_theme);
        }
        catch (e) {
            // don't let a bad callback break everything else
        }
    });
    return _theme;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */
function _loadFonts(theme) {
    var lines = {};
    for (var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++) {
        var fontName = _a[_i];
        var font = theme.fonts[fontName];
        for (var _b = 0, _c = Object.keys(font); _b < _c.length; _b++) {
            var propName = _c[_b];
            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
            var value = font[propName];
            if (propName === 'fontSize' && typeof value === 'number') {
                // if it's a number, convert it to px by default like our theming system does
                value = value + 'px';
            }
            lines[name_1] = value;
        }
    }
    return lines;
}

// This file mimics styles and mixins from _General.Mixins.scss
var normalize$4 = {
    boxShadow: 'none',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
};
var noWrap = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

/**
 * {@docCategory AnimationClassNames}
 */
var AnimationClassNames = buildClassMap(AnimationStyles);

var FLUENT_CDN_BASE_URL$1 = 'https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001';

// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
setVersion('@fluentui/style-utilities', '8.11.7');

initializeThemeInCustomizations();

var DirectionalHint = {
    /**
     * Appear above the target element, with the left edges of the callout and target aligning.
     */
    topLeftEdge: 0,
    /**
     * Appear above the target element, with the centers of the callout and target aligning.
     */
    topCenter: 1,
    /**
     * Appear above the target element, with the right edges of the callout and target aligning.
     */
    topRightEdge: 2,
    /**
     * Appear above the target element, aligning with the target element such that the callout tends toward
     * the center of the screen.
     */
    topAutoEdge: 3,
    /**
     * Appear below the target element, with the left edges of the callout and target aligning.
     */
    bottomLeftEdge: 4,
    /**
     * Appear below the target element, with the centers of the callout and target aligning.
     */
    bottomCenter: 5,
    /**
     * Appear below the target element, with the right edges of the callout and target aligning.
     */
    bottomRightEdge: 6,
    /**
     * Appear below the target element, aligning with the target element such that the callout tends toward
     * the center of the screen.
     */
    bottomAutoEdge: 7,
    /**
     * Appear to the left of the target element, with the top edges of the callout and target aligning.
     */
    leftTopEdge: 8,
    /**
     * Appear to the left of the target element, with the centers of the callout and target aligning.
     */
    leftCenter: 9,
    /**
     * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
     */
    leftBottomEdge: 10,
    /**
     * Appear to the right of the target element, with the top edges of the callout and target aligning.
     */
    rightTopEdge: 11,
    /**
     * Appear to the right of the target element, with the centers of the callout and target aligning.
     */
    rightCenter: 12,
    /**
     * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
     */
    rightBottomEdge: 13,
};

var RectangleEdge;
(function (RectangleEdge) {
    RectangleEdge[RectangleEdge["top"] = 1] = "top";
    RectangleEdge[RectangleEdge["bottom"] = -1] = "bottom";
    RectangleEdge[RectangleEdge["left"] = 2] = "left";
    RectangleEdge[RectangleEdge["right"] = -2] = "right";
})(RectangleEdge || (RectangleEdge = {}));
var Position;
(function (Position) {
    Position[Position["top"] = 0] = "top";
    Position[Position["bottom"] = 1] = "bottom";
    Position[Position["start"] = 2] = "start";
    Position[Position["end"] = 3] = "end";
})(Position || (Position = {}));

var _a$g;
function _createPositionData(targetEdge, alignmentEdge, isAuto) {
    return {
        targetEdge: targetEdge,
        alignmentEdge: alignmentEdge,
        isAuto: isAuto,
    };
}
// Currently the beakPercent is set to 50 for all positions meaning that it should tend to the center of the target
var DirectionalDictionary = (_a$g = {},
    _a$g[DirectionalHint.topLeftEdge] = _createPositionData(RectangleEdge.top, RectangleEdge.left),
    _a$g[DirectionalHint.topCenter] = _createPositionData(RectangleEdge.top),
    _a$g[DirectionalHint.topRightEdge] = _createPositionData(RectangleEdge.top, RectangleEdge.right),
    _a$g[DirectionalHint.topAutoEdge] = _createPositionData(RectangleEdge.top, undefined, true),
    _a$g[DirectionalHint.bottomLeftEdge] = _createPositionData(RectangleEdge.bottom, RectangleEdge.left),
    _a$g[DirectionalHint.bottomCenter] = _createPositionData(RectangleEdge.bottom),
    _a$g[DirectionalHint.bottomRightEdge] = _createPositionData(RectangleEdge.bottom, RectangleEdge.right),
    _a$g[DirectionalHint.bottomAutoEdge] = _createPositionData(RectangleEdge.bottom, undefined, true),
    _a$g[DirectionalHint.leftTopEdge] = _createPositionData(RectangleEdge.left, RectangleEdge.top),
    _a$g[DirectionalHint.leftCenter] = _createPositionData(RectangleEdge.left),
    _a$g[DirectionalHint.leftBottomEdge] = _createPositionData(RectangleEdge.left, RectangleEdge.bottom),
    _a$g[DirectionalHint.rightTopEdge] = _createPositionData(RectangleEdge.right, RectangleEdge.top),
    _a$g[DirectionalHint.rightCenter] = _createPositionData(RectangleEdge.right),
    _a$g[DirectionalHint.rightBottomEdge] = _createPositionData(RectangleEdge.right, RectangleEdge.bottom),
    _a$g);
function _isRectangleWithinBounds(rect, boundingRect) {
    if (rect.top < boundingRect.top) {
        return false;
    }
    if (rect.bottom > boundingRect.bottom) {
        return false;
    }
    if (rect.left < boundingRect.left) {
        return false;
    }
    if (rect.right > boundingRect.right) {
        return false;
    }
    return true;
}
/**
 * Gets all of the edges of a rectangle that are outside of the given bounds.
 * If there are no out of bounds edges it returns an empty array.
 */
function _getOutOfBoundsEdges(rect, boundingRect) {
    var outOfBounds = [];
    if (rect.top < boundingRect.top) {
        outOfBounds.push(RectangleEdge.top);
    }
    if (rect.bottom > boundingRect.bottom) {
        outOfBounds.push(RectangleEdge.bottom);
    }
    if (rect.left < boundingRect.left) {
        outOfBounds.push(RectangleEdge.left);
    }
    if (rect.right > boundingRect.right) {
        outOfBounds.push(RectangleEdge.right);
    }
    return outOfBounds;
}
function _getEdgeValue(rect, edge) {
    return rect[RectangleEdge[edge]];
}
function _setEdgeValue(rect, edge, value) {
    rect[RectangleEdge[edge]] = value;
    return rect;
}
/**
 * Returns the middle value of an edge. Only returns 1 value rather than xy coordinates as
 * the itself already contains the other coordinate.
 * For instance, a bottom edge's current value is it's y coordinate, so the number returned is the x.
 */
function _getCenterValue(rect, edge) {
    var edges = _getFlankingEdges(edge);
    return (_getEdgeValue(rect, edges.positiveEdge) + _getEdgeValue(rect, edges.negativeEdge)) / 2;
}
/**
 * Flips the value depending on the edge.
 * If the edge is a "positive" edge, Top or Left, then the value should stay as it is.
 * If the edge is a "negative" edge, Bottom or Right, then the value should be flipped.
 * This is to account for the fact that the coordinates are effectively reserved in certain cases for the
 * "negative" edges.
 *
 * For example, when testing to see if a bottom edge 1 is within the bounds of another bottom edge 2:
 * If edge 1 is greater than edge 2 then it is out of bounds. This is reversed for top edge 1 and top edge 2.
 * If top edge 1 is less than edge 2 then it is out of bounds.
 */
function _getRelativeEdgeValue(edge, value) {
    if (edge > 0) {
        return value;
    }
    else {
        return value * -1;
    }
}
function _getRelativeRectEdgeValue(edge, rect) {
    return _getRelativeEdgeValue(edge, _getEdgeValue(rect, edge));
}
function _getRelativeEdgeDifference(rect, hostRect, edge) {
    var edgeDifference = _getEdgeValue(rect, edge) - _getEdgeValue(hostRect, edge);
    return _getRelativeEdgeValue(edge, edgeDifference);
}
/**
 * Moves the edge of a rectangle to the value given. It only moves the edge in a linear direction based on that edge.
 * For example, if it's a bottom edge it will only change y coordinates.
 * if maintainSize is set to false, it will only adjust the specified edge value
 */
function _moveEdge(rect, edge, newValue, maintainSize) {
    if (maintainSize === undefined) { maintainSize = true; }
    var difference = _getEdgeValue(rect, edge) - newValue;
    var returnRect = _setEdgeValue(rect, edge, newValue);
    if (maintainSize) {
        returnRect = _setEdgeValue(rect, edge * -1, _getEdgeValue(rect, edge * -1) - difference);
    }
    return returnRect;
}
/**
 * Aligns the edge on the passed in rect to the target. If there is a gap then it will have that space between the two.
 */
function _alignEdges(rect, target, edge, gap) {
    if (gap === undefined) { gap = 0; }
    return _moveEdge(rect, edge, _getEdgeValue(target, edge) + _getRelativeEdgeValue(edge, gap));
}
/**
 * Aligns the targetEdge on the passed in target to the rects corresponding opposite edge.
 * For instance if targetEdge is bottom, then the rects top will be moved to match it.
 */
function _alignOppositeEdges(rect, target, targetEdge, gap) {
    if (gap === undefined) { gap = 0; }
    var oppositeEdge = targetEdge * -1;
    var adjustedGap = _getRelativeEdgeValue(oppositeEdge, gap);
    return _moveEdge(rect, targetEdge * -1, _getEdgeValue(target, targetEdge) + adjustedGap);
}
/**
 * Tests to see if the given edge is within the bounds of the given rectangle.
 */
function _isEdgeInBounds(rect, bounds, edge) {
    var adjustedRectValue = _getRelativeRectEdgeValue(edge, rect);
    return adjustedRectValue > _getRelativeRectEdgeValue(edge, bounds);
}
/**
 * Returns a measure of how much a rectangle is out of bounds for a given alignment;
 * this can be used to compare which rectangle is more or less out of bounds.
 * A value of 0 means the rectangle is entirely in bounds
 */
function _getOutOfBoundsDegree(rect, bounds) {
    var breakingEdges = _getOutOfBoundsEdges(rect, bounds);
    var total = 0;
    for (var _i = 0, breakingEdges_1 = breakingEdges; _i < breakingEdges_1.length; _i++) {
        var edge = breakingEdges_1[_i];
        total += Math.pow(_getRelativeEdgeDifference(rect, bounds, edge), 2);
    }
    return total;
}
/**
 * Returns true if scroll-resizing will move the target edge within the bounding rectangle,
 * and there is room between the target edge and the bounding edge for scrolled content.
 * Returns false otherwise.
 */
function _canScrollResizeToFitEdge(target, bounding, targetEdge, minimumScrollResizeHeight) {
    if (minimumScrollResizeHeight === undefined) { minimumScrollResizeHeight = 200; }
    // Only scroll vertically to fit - cannot scroll to fit right or left edges
    if (targetEdge !== RectangleEdge.bottom && targetEdge !== RectangleEdge.top) {
        return false;
    }
    return _getRelativeEdgeDifference(target, bounding, targetEdge) >= minimumScrollResizeHeight;
}
/**
 * Attempts to move the rectangle through various sides of the target to find a place to fit.
 * If no fit is found, the least bad option should be returned.
 */
function _flipToFit(rect, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap) {
    if (shouldScroll === undefined) { shouldScroll = false; }
    if (gap === undefined) { gap = 0; }
    var directions = [
        RectangleEdge.left,
        RectangleEdge.right,
        RectangleEdge.bottom,
        RectangleEdge.top,
    ];
    // In RTL page, RectangleEdge.right has a higher priority than RectangleEdge.left, so the order should be updated.
    if (getRTL()) {
        directions[0] *= -1;
        directions[1] *= -1;
    }
    var currentEstimate = rect;
    var currentEdge = positionData.targetEdge;
    var currentAlignment = positionData.alignmentEdge;
    // keep track of least bad option, in case no sides fit
    var oobDegree;
    var bestEdge = currentEdge;
    var bestAlignment = currentAlignment;
    // Keep switching sides until one is found with enough space.
    // If all sides don't fit then return the unmodified element.
    for (var i = 0; i < 4; i++) {
        if (_isEdgeInBounds(currentEstimate, bounding, currentEdge)) {
            // Edge is in bounds, return current estimate
            return {
                elementRectangle: currentEstimate,
                targetEdge: currentEdge,
                alignmentEdge: currentAlignment,
            };
        }
        else if (shouldScroll && _canScrollResizeToFitEdge(target, bounding, currentEdge, minimumScrollResizeHeight)) {
            // Scrolling will allow edge to fit, move the estimate currentEdge inside the bounds and return
            switch (currentEdge) {
                case RectangleEdge.bottom:
                    currentEstimate.bottom = bounding.bottom;
                    break;
                case RectangleEdge.top:
                    currentEstimate.top = bounding.top;
                    break;
            }
            return {
                elementRectangle: currentEstimate,
                targetEdge: currentEdge,
                alignmentEdge: currentAlignment,
                forcedInBounds: true,
            };
        }
        else {
            // update least-bad edges
            var currentOOBDegree = _getOutOfBoundsDegree(currentEstimate, bounding);
            if (!oobDegree || currentOOBDegree < oobDegree) {
                oobDegree = currentOOBDegree;
                bestEdge = currentEdge;
                bestAlignment = currentAlignment;
            }
            directions.splice(directions.indexOf(currentEdge), 1);
            if (directions.length > 0) {
                if (directions.indexOf(currentEdge * -1) > -1) {
                    currentEdge = currentEdge * -1;
                }
                else {
                    currentAlignment = currentEdge;
                    currentEdge = directions.slice(-1)[0];
                }
                currentEstimate = _estimatePosition(rect, target, { targetEdge: currentEdge, alignmentEdge: currentAlignment }, gap);
            }
        }
    }
    // nothing fits, use least-bad option
    currentEstimate = _estimatePosition(rect, target, { targetEdge: bestEdge, alignmentEdge: bestAlignment }, gap);
    return {
        elementRectangle: currentEstimate,
        targetEdge: bestEdge,
        alignmentEdge: bestAlignment,
    };
}
/**
 * Flips only the alignment edge of an element rectangle. This is used instead of nudging the alignment edges
 * into position, when `alignTargetEdge` is specified.
 */
function _flipAlignmentEdge(elementEstimate, target, gap, coverTarget) {
    var alignmentEdge = elementEstimate.alignmentEdge, targetEdge = elementEstimate.targetEdge, elementRectangle = elementEstimate.elementRectangle;
    var oppositeEdge = alignmentEdge * -1;
    var newEstimate = _estimatePosition(elementRectangle, target, { targetEdge: targetEdge, alignmentEdge: oppositeEdge }, gap, coverTarget);
    return {
        elementRectangle: newEstimate,
        targetEdge: targetEdge,
        alignmentEdge: oppositeEdge,
    };
}
/**
 * Adjusts a element rectangle to fit within the bounds given. If directionalHintFixed or covertarget is passed in
 * then the element will not flip sides on the target. They will, however, be nudged to fit within the bounds given.
 */
function _adjustFitWithinBounds(element, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap, directionalHintFixed, coverTarget) {
    if (shouldScroll === undefined) { shouldScroll = false; }
    if (gap === undefined) { gap = 0; }
    var alignmentEdge = positionData.alignmentEdge, alignTargetEdge = positionData.alignTargetEdge;
    var elementEstimate = {
        elementRectangle: element,
        targetEdge: positionData.targetEdge,
        alignmentEdge: alignmentEdge,
    };
    if (!directionalHintFixed && !coverTarget) {
        elementEstimate = _flipToFit(element, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap);
    }
    var outOfBounds = _getOutOfBoundsEdges(elementEstimate.elementRectangle, bounding);
    // if directionalHintFixed is specified, we need to force the target edge to not change
    // we need *-1 because targetEdge refers to the target's edge; the callout edge is the opposite
    var fixedEdge = directionalHintFixed ? -elementEstimate.targetEdge : undefined;
    if (outOfBounds.length > 0) {
        if (alignTargetEdge) {
            // The edge opposite to the alignment edge might be out of bounds.
            // Flip alignment to see if we can get it within bounds.
            if (elementEstimate.alignmentEdge && outOfBounds.indexOf(elementEstimate.alignmentEdge * -1) > -1) {
                var flippedElementEstimate = _flipAlignmentEdge(elementEstimate, target, gap, coverTarget);
                if (_isRectangleWithinBounds(flippedElementEstimate.elementRectangle, bounding)) {
                    return flippedElementEstimate;
                }
                else {
                    // If the flipped elements edges are still out of bounds, try nudging it.
                    elementEstimate = _alignOutOfBoundsEdges(_getOutOfBoundsEdges(flippedElementEstimate.elementRectangle, bounding), elementEstimate, bounding, fixedEdge);
                }
            }
            else {
                elementEstimate = _alignOutOfBoundsEdges(outOfBounds, elementEstimate, bounding, fixedEdge);
            }
        }
        else {
            elementEstimate = _alignOutOfBoundsEdges(outOfBounds, elementEstimate, bounding, fixedEdge);
        }
    }
    return elementEstimate;
}
/**
 * Iterates through a list of out of bounds edges and tries to nudge and align them.
 * @param outOfBoundsEdges - Array of edges that are out of bounds
 * @param elementEstimate - The current element positioning estimate
 * @param bounding - The current bounds
 * @param preserveEdge - Specify an edge that should not be modified
 */
function _alignOutOfBoundsEdges(outOfBoundsEdges, elementEstimate, bounding, preserveEdge) {
    for (var _i = 0, outOfBoundsEdges_1 = outOfBoundsEdges; _i < outOfBoundsEdges_1.length; _i++) {
        var direction = outOfBoundsEdges_1[_i];
        var edgeAttempt = undefined;
        // if preserveEdge is specified, do not call _alignEdges, skip directly to _moveEdge
        // this is because _alignEdges will move the opposite edge
        if (preserveEdge && preserveEdge === direction * -1) {
            edgeAttempt = _moveEdge(elementEstimate.elementRectangle, direction, _getEdgeValue(bounding, direction), false);
            elementEstimate.forcedInBounds = true;
        }
        else {
            edgeAttempt = _alignEdges(elementEstimate.elementRectangle, bounding, direction);
            var inBounds = _isEdgeInBounds(edgeAttempt, bounding, direction * -1);
            // only update estimate if the attempt didn't break out of the opposite bounding edge
            if (!inBounds) {
                edgeAttempt = _moveEdge(edgeAttempt, direction * -1, _getEdgeValue(bounding, direction * -1), false);
                elementEstimate.forcedInBounds = true;
            }
        }
        elementEstimate.elementRectangle = edgeAttempt;
    }
    return elementEstimate;
}
/**
 * Moves the middle point on an edge to the point given.
 * Only moves in one direction. For instance if a bottom edge is passed in, then
 * the bottom edge will be moved in the x axis to match the point.
 */
function _centerEdgeToPoint(rect, edge, point) {
    var positiveEdge = _getFlankingEdges(edge).positiveEdge;
    var elementMiddle = _getCenterValue(rect, edge);
    var distanceToMiddle = elementMiddle - _getEdgeValue(rect, positiveEdge);
    return _moveEdge(rect, positiveEdge, point - distanceToMiddle);
}
/**
 * Moves the element rectangle to be appropriately positioned relative to a given target.
 * Does not flip or adjust the element.
 */
function _estimatePosition(elementToPosition, target, positionData, gap, coverTarget) {
    if (gap === undefined) { gap = 0; }
    var estimatedElementPosition = new Rectangle(elementToPosition.left, elementToPosition.right, elementToPosition.top, elementToPosition.bottom);
    var alignmentEdge = positionData.alignmentEdge, targetEdge = positionData.targetEdge;
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    estimatedElementPosition = coverTarget
        ? _alignEdges(estimatedElementPosition, target, targetEdge, gap)
        : _alignOppositeEdges(estimatedElementPosition, target, targetEdge, gap);
    // if no alignment edge is provided it's supposed to be centered.
    if (!alignmentEdge) {
        var targetMiddlePoint = _getCenterValue(target, targetEdge);
        estimatedElementPosition = _centerEdgeToPoint(estimatedElementPosition, elementEdge, targetMiddlePoint);
    }
    else {
        estimatedElementPosition = _alignEdges(estimatedElementPosition, target, alignmentEdge);
    }
    return estimatedElementPosition;
}
/**
 * Returns the non-opposite edges of the target edge.
 * For instance if bottom is passed in then left and right will be returned.
 */
function _getFlankingEdges(edge) {
    if (edge === RectangleEdge.top || edge === RectangleEdge.bottom) {
        return {
            positiveEdge: RectangleEdge.left,
            negativeEdge: RectangleEdge.right,
        };
    }
    else {
        return {
            positiveEdge: RectangleEdge.top,
            negativeEdge: RectangleEdge.bottom,
        };
    }
}
/**
 * Retrieve the final value for the return edge of `elementRectangle`. If the `elementRectangle` is closer to one side
 * of the bounds versus the other, the return edge is flipped to grow inward.
 */
function _finalizeReturnEdge(elementRectangle, returnEdge, bounds) {
    if (bounds &&
        Math.abs(_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge)) >
            Math.abs(_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge * -1))) {
        return returnEdge * -1;
    }
    return returnEdge;
}
/**
 * Whether or not the considered edge of the elementRectangle is lying on the edge of the bounds
 * @param elementRectangle The rectangle whose edge we are considering
 * @param bounds The rectangle marking the bounds
 * @param edge The target edge we're considering
 * @returns If the target edge of the elementRectangle is in the same location as that edge of the bounds
 */
function _isEdgeOnBounds(elementRectangle, edge, bounds) {
    return bounds !== undefined && _getEdgeValue(elementRectangle, edge) === _getEdgeValue(bounds, edge);
}
/**
 * Finalizes the element position based on the hostElement. Only returns the
 * rectangle values to position such that they are anchored to the target.
 * This helps prevent resizing from looking very strange.
 * For instance, if the target edge is top and aligned with the left side then
 * the bottom and left values are returned so as the Callout shrinks it shrinks towards that corner.
 */
function _finalizeElementPosition(elementRectangle, hostElement, targetEdge, bounds, alignmentEdge, coverTarget, doNotFinalizeReturnEdge, forceWithinBounds) {
    var returnValue = {};
    var hostRect = _getRectangleFromElement(hostElement);
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    var returnEdge = alignmentEdge ? alignmentEdge : _getFlankingEdges(targetEdge).positiveEdge;
    // If we are finalizing the return edge, choose the edge such that we grow away from the bounds
    // If we are not finalizing the return edge but the opposite edge is flush against the bounds,
    // choose that as the anchor edge so the element rect can grow away from the bounds' edge
    // In this case there will not be a visual difference because there is no more room for the elementRectangle to grow
    // in the usual direction
    if (!doNotFinalizeReturnEdge || _isEdgeOnBounds(elementRectangle, getOppositeEdge(returnEdge), bounds)) {
        returnEdge = _finalizeReturnEdge(elementRectangle, returnEdge, bounds);
    }
    returnValue[RectangleEdge[elementEdge]] = _getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge);
    returnValue[RectangleEdge[returnEdge]] = _getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge);
    // if the positioned element will still overflow, return all four edges with in-bounds values
    if (forceWithinBounds) {
        returnValue[RectangleEdge[elementEdge * -1]] = _getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge * -1);
        returnValue[RectangleEdge[returnEdge * -1]] = _getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge * -1);
    }
    return returnValue;
}
// Since the beak is rotated 45 degrees the actual height/width is the length of the diagonal.
// We still want to position the beak based on it's midpoint which does not change. It will
// be at (beakwidth / 2, beakwidth / 2)
function _calculateActualBeakWidthInPixels(beakWidth) {
    return Math.sqrt(beakWidth * beakWidth * 2);
}
/**
 * Returns the appropriate IPositionData based on the props altered for RTL.
 * If directionalHintForRTL is passed in that is used if the page is RTL.
 * If directionalHint is specified, no directionalHintForRTL is available, and the page is RTL, the hint will be
 * flipped (e.g. bottomLeftEdge would become bottomRightEdge).
 *
 * If there is no directionalHint passed in, bottomAutoEdge is chosen automatically.
 */
function _getPositionData(directionalHint, directionalHintForRTL, previousPositions) {
    if (directionalHint === undefined) { directionalHint = DirectionalHint.bottomAutoEdge; }
    if (previousPositions) {
        return {
            alignmentEdge: previousPositions.alignmentEdge,
            isAuto: previousPositions.isAuto,
            targetEdge: previousPositions.targetEdge,
        };
    }
    var positionInformation = __assign$2({}, DirectionalDictionary[directionalHint]);
    if (getRTL()) {
        // If alignment edge exists and that alignment edge is -2 or 2, right or left, then flip it.
        if (positionInformation.alignmentEdge && positionInformation.alignmentEdge % 2 === 0) {
            positionInformation.alignmentEdge = positionInformation.alignmentEdge * -1;
        }
        return directionalHintForRTL !== undefined ? DirectionalDictionary[directionalHintForRTL] : positionInformation;
    }
    return positionInformation;
}
/**
 * Gets the alignment data for the given information. This only really matters if the positioning is Auto.
 * If it is auto then the alignmentEdge should be chosen based on the target edge's position relative to
 * the center of the page.
 */
function _getAlignmentData(positionData, target, boundingRect, coverTarget, alignTargetEdge) {
    if (positionData.isAuto) {
        positionData.alignmentEdge = getClosestEdge(positionData.targetEdge, target, boundingRect);
    }
    positionData.alignTargetEdge = alignTargetEdge;
    return positionData;
}
function getClosestEdge(targetEdge, target, boundingRect) {
    var targetCenter = _getCenterValue(target, targetEdge);
    var boundingCenter = _getCenterValue(boundingRect, targetEdge);
    var _a = _getFlankingEdges(targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    if (targetCenter <= boundingCenter) {
        return positiveEdge;
    }
    else {
        return negativeEdge;
    }
}
function _positionElementWithinBounds(elementToPosition, target, bounding, positionData, gap, shouldScroll, minimumScrollResizeHeight, directionalHintFixed, coverTarget) {
    if (shouldScroll === undefined) { shouldScroll = false; }
    var estimatedElementPosition = _estimatePosition(elementToPosition, target, positionData, gap, coverTarget);
    if (_isRectangleWithinBounds(estimatedElementPosition, bounding)) {
        return {
            elementRectangle: estimatedElementPosition,
            targetEdge: positionData.targetEdge,
            alignmentEdge: positionData.alignmentEdge,
        };
    }
    else {
        return _adjustFitWithinBounds(estimatedElementPosition, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap, directionalHintFixed, coverTarget);
    }
}
function _finalizeBeakPosition(elementPosition, positionedBeak, bounds) {
    var targetEdge = elementPosition.targetEdge * -1;
    // The "host" element that we will use to help position the beak.
    var actualElement = new Rectangle(0, elementPosition.elementRectangle.width, 0, elementPosition.elementRectangle.height);
    var returnValue = {};
    var returnEdge = _finalizeReturnEdge(elementPosition.elementRectangle, elementPosition.alignmentEdge ? elementPosition.alignmentEdge : _getFlankingEdges(targetEdge).positiveEdge, bounds);
    // only show the beak if the callout is not fully covering the target
    var beakEdgeDifference = _getRelativeEdgeDifference(elementPosition.elementRectangle, elementPosition.targetRectangle, targetEdge);
    var showBeak = beakEdgeDifference > Math.abs(_getEdgeValue(positionedBeak, targetEdge));
    returnValue[RectangleEdge[targetEdge]] = _getEdgeValue(positionedBeak, targetEdge);
    returnValue[RectangleEdge[returnEdge]] = _getRelativeEdgeDifference(positionedBeak, actualElement, returnEdge);
    return {
        elementPosition: __assign$2({}, returnValue),
        closestEdge: getClosestEdge(elementPosition.targetEdge, positionedBeak, actualElement),
        targetEdge: targetEdge,
        hideBeak: !showBeak,
    };
}
function _positionBeak(beakWidth, elementPosition) {
    var target = elementPosition.targetRectangle;
    /**
     * Note about beak positioning: The actual beak width only matters for getting the gap between the callout and
     * target, it does not impact the beak placement within the callout. For example example, if the beakWidth is 8,
     * then the actual beakWidth is sqrroot(8^2 + 8^2) = 11.31x11.31. So the callout will need to be an extra 3 pixels
     * away from its target. While the beak is being positioned in the callout it still acts as though it were 8x8.
     */
    var _a = _getFlankingEdges(elementPosition.targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    var beakTargetPoint = _getCenterValue(target, elementPosition.targetEdge);
    var elementBounds = new Rectangle(beakWidth / 2, elementPosition.elementRectangle.width - beakWidth / 2, beakWidth / 2, elementPosition.elementRectangle.height - beakWidth / 2);
    var beakPosition = new Rectangle(0, beakWidth, 0, beakWidth);
    beakPosition = _moveEdge(beakPosition, elementPosition.targetEdge * -1, -beakWidth / 2);
    beakPosition = _centerEdgeToPoint(beakPosition, elementPosition.targetEdge * -1, beakTargetPoint - _getRelativeRectEdgeValue(positiveEdge, elementPosition.elementRectangle));
    if (!_isEdgeInBounds(beakPosition, elementBounds, positiveEdge)) {
        beakPosition = _alignEdges(beakPosition, elementBounds, positiveEdge);
    }
    else if (!_isEdgeInBounds(beakPosition, elementBounds, negativeEdge)) {
        beakPosition = _alignEdges(beakPosition, elementBounds, negativeEdge);
    }
    return beakPosition;
}
function _getRectangleFromElement(element) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var clientRect = element.getBoundingClientRect();
    return new Rectangle(clientRect.left, clientRect.right, clientRect.top, clientRect.bottom);
}
function _getRectangleFromIRect(rect) {
    return new Rectangle(rect.left, rect.right, rect.top, rect.bottom);
}
function _getTargetRect(bounds, target) {
    var targetRectangle;
    if (target) {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!target.preventDefault) {
            var ev = target;
            targetRectangle = new Rectangle(ev.clientX, ev.clientX, ev.clientY, ev.clientY);
            // eslint-disable-next-line no-extra-boolean-cast
        }
        else if (!!target.getBoundingClientRect) {
            targetRectangle = _getRectangleFromElement(target);
            // HTMLImgElements can have x and y values. The check for it being a point must go last.
        }
        else {
            var rectOrPoint = target;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var left = rectOrPoint.left || rectOrPoint.x;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var top_1 = rectOrPoint.top || rectOrPoint.y;
            var right = rectOrPoint.right || left;
            var bottom = rectOrPoint.bottom || top_1;
            targetRectangle = new Rectangle(left, right, top_1, bottom);
        }
        if (!_isRectangleWithinBounds(targetRectangle, bounds)) {
            var outOfBounds = _getOutOfBoundsEdges(targetRectangle, bounds);
            for (var _i = 0, outOfBounds_1 = outOfBounds; _i < outOfBounds_1.length; _i++) {
                var direction = outOfBounds_1[_i];
                targetRectangle[RectangleEdge[direction]] = bounds[RectangleEdge[direction]];
            }
        }
    }
    else {
        targetRectangle = new Rectangle(0, 0, 0, 0);
    }
    return targetRectangle;
}
/**
 * If max height is less than zero it returns the bounds height instead.
 */
function _getMaxHeightFromTargetRectangle(targetRectangle, targetEdge, gapSpace, bounds, coverTarget) {
    var maxHeight = 0;
    var directionalHint = DirectionalDictionary[targetEdge];
    // If cover target is set, then the max height should be calculated using the opposite of the target edge since
    // that's the direction that the callout will expand in.
    // For instance, if the directionalhint is bottomLeftEdge then the callout will position so it's bottom edge
    // is aligned with the bottom of the target and expand up towards the top of the screen and the calculated max height
    // is (bottom of target) - (top of screen) - gapSpace.
    var target = coverTarget ? directionalHint.targetEdge * -1 : directionalHint.targetEdge;
    if (target === RectangleEdge.top) {
        maxHeight = _getEdgeValue(targetRectangle, directionalHint.targetEdge) - bounds.top - gapSpace;
    }
    else if (target === RectangleEdge.bottom) {
        maxHeight = bounds.bottom - _getEdgeValue(targetRectangle, directionalHint.targetEdge) - gapSpace;
    }
    else {
        maxHeight = bounds.bottom - targetRectangle.top - gapSpace;
    }
    return maxHeight > 0 ? maxHeight : bounds.height;
}
function _positionElementRelative(props, elementToPosition, boundingRect, previousPositions, shouldScroll, minimumScrollResizeHeight) {
    if (shouldScroll === undefined) { shouldScroll = false; }
    var gap = props.gapSpace ? props.gapSpace : 0;
    var targetRect = _getTargetRect(boundingRect, props.target);
    var positionData = _getAlignmentData(_getPositionData(props.directionalHint, props.directionalHintForRTL, previousPositions), targetRect, boundingRect, props.coverTarget, props.alignTargetEdge);
    var positionedElement = _positionElementWithinBounds(_getRectangleFromElement(elementToPosition), targetRect, boundingRect, positionData, gap, shouldScroll, minimumScrollResizeHeight, props.directionalHintFixed, props.coverTarget);
    return __assign$2(__assign$2({}, positionedElement), { targetRectangle: targetRect });
}
function _finalizePositionData(positionedElement, hostElement, bounds, coverTarget, doNotFinalizeReturnEdge) {
    var finalizedElement = _finalizeElementPosition(positionedElement.elementRectangle, hostElement, positionedElement.targetEdge, bounds, positionedElement.alignmentEdge, coverTarget, doNotFinalizeReturnEdge, positionedElement.forcedInBounds);
    return {
        elementPosition: finalizedElement,
        targetEdge: positionedElement.targetEdge,
        alignmentEdge: positionedElement.alignmentEdge,
    };
}
function _positionElement(props, hostElement, elementToPosition, previousPositions, win) {
    var theWin = win !== null && win !== undefined ? win : getWindow$2();
    var boundingRect = props.bounds
        ? _getRectangleFromIRect(props.bounds)
        : new Rectangle(0, theWin.innerWidth - getScrollbarWidth(), 0, theWin.innerHeight);
    var positionedElement = _positionElementRelative(props, elementToPosition, boundingRect, previousPositions);
    return _finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget);
}
function _calculateGapSpace(isBeakVisible, beakWidth, gapSpace) {
    if (beakWidth === undefined) { beakWidth = 0; }
    if (gapSpace === undefined) { gapSpace = 0; }
    return _calculateActualBeakWidthInPixels(isBeakVisible ? beakWidth : 0) / 2 + gapSpace;
}
function _positionCallout(props, hostElement, callout, previousPositions, shouldScroll, minimumScrollResizeHeight, doNotFinalizeReturnEdge, win) {
    if (shouldScroll === undefined) { shouldScroll = false; }
    var theWin = win !== null && win !== undefined ? win : getWindow$2();
    var beakWidth = props.isBeakVisible ? props.beakWidth || 0 : 0;
    var gap = _calculateGapSpace(props.isBeakVisible, props.beakWidth, props.gapSpace);
    var positionProps = props;
    positionProps.gapSpace = gap;
    var boundingRect = props.bounds
        ? _getRectangleFromIRect(props.bounds)
        : new Rectangle(0, theWin.innerWidth - getScrollbarWidth(), 0, theWin.innerHeight);
    var positionedElement = _positionElementRelative(positionProps, callout, boundingRect, previousPositions, shouldScroll, minimumScrollResizeHeight);
    var beakPositioned = _positionBeak(beakWidth, positionedElement);
    var finalizedBeakPosition = _finalizeBeakPosition(positionedElement, beakPositioned, boundingRect);
    return __assign$2(__assign$2({}, _finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget, doNotFinalizeReturnEdge)), { beakPosition: finalizedBeakPosition });
}
function _positionCard(props, hostElement, callout, previousPositions, win) {
    var theWin = win !== null && win !== undefined ? win : getWindow$2();
    return _positionCallout(props, hostElement, callout, previousPositions, false, undefined, true, theWin);
}
function _getRectangleFromTarget(target) {
    var _a, _b, _c, _d;
    var mouseTarget = target;
    var elementTarget = target;
    var rectOrPointTarget = target;
    var targetRect;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var left = (_a = rectOrPointTarget.left) !== null && _a !== undefined ? _a : rectOrPointTarget.x;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var top = (_b = rectOrPointTarget.top) !== null && _b !== undefined ? _b : rectOrPointTarget.y;
    var right = (_c = rectOrPointTarget.right) !== null && _c !== undefined ? _c : left;
    var bottom = (_d = rectOrPointTarget.bottom) !== null && _d !== undefined ? _d : top;
    // eslint-disable-next-line no-extra-boolean-cast -- may not actually be a MouseEvent
    if (!!mouseTarget.stopPropagation) {
        targetRect = new Rectangle(mouseTarget.clientX, mouseTarget.clientX, mouseTarget.clientY, mouseTarget.clientY);
    }
    else if (left !== undefined && top !== undefined) {
        targetRect = new Rectangle(left, right, top, bottom);
    }
    else {
        targetRect = _getRectangleFromElement(elementTarget);
    }
    return targetRect;
}
/**
 * Used to position an element relative to the given positioning props.
 * If positioning has been completed before, previousPositions can be passed to ensure that the positioning element
 * repositions based on its previous targets rather than starting with directionalhint.
 */
function positionElement(props, hostElement, elementToPosition, previousPositions, win) {
    return _positionElement(props, hostElement, elementToPosition, previousPositions, win);
}
function positionCallout(props, hostElement, elementToPosition, previousPositions, shouldScroll, minimumScrollResizeHeight, win) {
    return _positionCallout(props, hostElement, elementToPosition, previousPositions, shouldScroll, minimumScrollResizeHeight, undefined, win);
}
function positionCard(props, hostElement, elementToPosition, previousPositions, win) {
    return _positionCard(props, hostElement, elementToPosition, previousPositions, win);
}
/**
 * Gets the maximum height that a rectangle can have in order to fit below or above a target.
 * If the directional hint specifies a left or right edge (i.e. leftCenter) it will limit the height to the topBorder
 * of the target given.
 * If no bounds are provided then the window is treated as the bounds.
 */
function getMaxHeight(target, targetEdge, gapSpace, bounds, coverTarget, win) {
    if (gapSpace === undefined) { gapSpace = 0; }
    var theWin = win !== null && win !== undefined ? win : getWindow$2();
    var targetRect = _getRectangleFromTarget(target);
    var boundingRectangle = bounds
        ? _getRectangleFromIRect(bounds)
        : new Rectangle(0, theWin.innerWidth - getScrollbarWidth(), 0, theWin.innerHeight);
    return _getMaxHeightFromTargetRectangle(targetRect, targetEdge, gapSpace, boundingRectangle, coverTarget);
}
/**
 * Returns the opposite edge of the given RectangleEdge.
 */
function getOppositeEdge(edge) {
    return edge * -1;
}
function _getBoundsFromTargetWindow(target, targetWindow) {
    var segments = undefined;
    if (targetWindow.getWindowSegments) {
        segments = targetWindow.getWindowSegments();
    }
    // Identify if we're dealing with single screen scenarios.
    if (segments === undefined || segments.length <= 1) {
        return {
            top: 0,
            left: 0,
            right: targetWindow.innerWidth,
            bottom: targetWindow.innerHeight,
            width: targetWindow.innerWidth,
            height: targetWindow.innerHeight,
        };
    }
    // Logic for determining dual screen scenarios.
    var x = 0;
    var y = 0;
    // If the target is an Element get coordinates for its center.
    if (target !== null && !!target.getBoundingClientRect) {
        var clientRect = target.getBoundingClientRect();
        x = (clientRect.left + clientRect.right) / 2;
        y = (clientRect.top + clientRect.bottom) / 2;
    }
    // If the target is not null get x-axis and y-axis coordinates directly.
    else if (target !== null) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        x = target.left || target.x;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        y = target.top || target.y;
    }
    var bounds = { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
    // Define which window segment are the coordinates in and calculate bounds based on that.
    for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
        var segment = segments_1[_i];
        if (x && segment.left <= x && segment.right >= x && y && segment.top <= y && segment.bottom >= y) {
            bounds = {
                top: segment.top,
                left: segment.left,
                right: segment.right,
                bottom: segment.bottom,
                width: segment.width,
                height: segment.height,
            };
        }
    }
    return bounds;
}
function getBoundsFromTargetWindow(target, targetWindow) {
    return _getBoundsFromTargetWindow(target, targetWindow);
}
function calculateGapSpace(isBeakVisible, beakWidth, gapSpace) {
    return _calculateGapSpace(isBeakVisible, beakWidth, gapSpace);
}
function getRectangleFromTarget(target) {
    return _getRectangleFromTarget(target);
}

/**
 * Hook to provide an Async instance that is automatically cleaned up on dismount.
 */
function useAsync() {
    var asyncRef = React.useRef();
    if (!asyncRef.current) {
        asyncRef.current = new Async();
    }
    React.useEffect(function () {
        return function () {
            var _a;
            (_a = asyncRef.current) === null || _a === undefined ? undefined : _a.dispose();
            asyncRef.current = undefined;
        };
    }, []);
    return asyncRef.current;
}

/**
 * Hook to initialize and return a constant value. Unlike `React.useMemo`, this is guaranteed to
 * always return the same value (and if the initializer is a function, only call it once).
 * This is similar to setting a private member in a class constructor.
 *
 * If the value should ever change based on dependencies, use `React.useMemo` instead.
 *
 * @param initialValue - Initial value, or function to get the initial value. Similar to `useState`,
 * only the value/function passed in the first time this is called is respected.
 * @returns The value. The identity of this value will always be the same.
 */
function useConst(initialValue) {
    // Use useRef to store the value because it's the least expensive built-in hook that works here
    // (we could also use `const [value] = React.useState(initialValue)` but that's more expensive
    // internally due to reducer handling which we don't need)
    var ref = React.useRef();
    if (ref.current === undefined) {
        // Box the value in an object so we can tell if it's initialized even if the initializer
        // returns/is undefined
        ref.current = {
            value: typeof initialValue === 'function' ? initialValue() : initialValue,
        };
    }
    return ref.current.value;
}

/**
 * Hook to store a value and generate callbacks for setting the value to true or false.
 * The identity of the callbacks will always stay the same.
 *
 * @param initialState - Initial value
 * @returns Array with the current value and an object containing the updater callbacks.
 */
function useBoolean(initialState) {
    var _a = React.useState(initialState), value = _a[0], setValue = _a[1];
    var setTrue = useConst(function () { return function () {
        setValue(true);
    }; });
    var setFalse = useConst(function () { return function () {
        setValue(false);
    }; });
    var toggle = useConst(function () { return function () {
        setValue(function (currentValue) { return !currentValue; });
    }; });
    return [value, { setTrue: setTrue, setFalse: setFalse, toggle: toggle }];
}

function useControllableValue(controlledValue, defaultUncontrolledValue, onChange) {
    var _a = React.useState(defaultUncontrolledValue), value = _a[0], setValue = _a[1];
    var isControlled = useConst(controlledValue !== undefined);
    var currentValue = isControlled ? controlledValue : value;
    // Duplicate the current value and onChange in refs so they're accessible from
    // setValueOrCallOnChange without creating a new callback every time
    var valueRef = React.useRef(currentValue);
    var onChangeRef = React.useRef(onChange);
    React.useEffect(function () {
        valueRef.current = currentValue;
        onChangeRef.current = onChange;
    });
    // To match the behavior of the setter returned by React.useState, this callback's identity
    // should never change. This means it MUST NOT directly reference variables that can change.
    var setValueOrCallOnChange = useConst(function () { return function (update, ev) {
        // Assuming here that TValue is not a function, because a controllable value will typically
        // be something a user can enter as input
        var newValue = typeof update === 'function' ? update(valueRef.current) : update;
        if (onChangeRef.current) {
            onChangeRef.current(ev, newValue);
        }
        if (!isControlled) {
            setValue(newValue);
        }
    }; });
    return [currentValue, setValueOrCallOnChange];
}

/**
 * Modified `useCallback` that returns the same function reference every time, but internally calls
 * the most-recently passed callback implementation. Can be useful in situations such as:
 * - Event handler dependencies change too frequently, such as user props which might change on
 *   every render, or volatile values such as useState/useDispatch
 * - Callback must be referenced in a captured context (such as a window event handler or unmount
 *   handler that's registered once) but needs access to the latest props
 *
 * In general, prefer `useCallback` unless you've encountered one of the problems above.
 *
 * https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 *
 * @param fn - The callback function that will be used
 * @returns A function which is referentially stable but internally calls the most recently passed callback
 */
function useEventCallback$1(fn) {
    var callbackRef = React.useRef(function () {
        throw new Error('Cannot call an event handler while rendering');
    });
    useIsomorphicLayoutEffect$1(function () {
        callbackRef.current = fn;
    }, [fn]);
    // useConst rather than useCallback to ensure the reference is always stable
    // (useCallback's deps list is an optimization, not a guarantee)
    return useConst(function () { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callback = callbackRef.current;
        return callback.apply(undefined, args);
    }; });
}

function useId$1(prefix, providedId) {
  var ref = React.useRef(providedId);
  if (!ref.current) {
    ref.current = getId(prefix);
  }
  return ref.current;
}

/**
 * React hook to merge multiple React refs (either MutableRefObjects or ref callbacks) into a single ref callback that
 * updates all provided refs
 * @param refs - Refs to collectively update with one ref value.
 * @returns A function with an attached "current" prop, so that it can be treated like a RefObject.
 */
function useMergedRefs$1() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    var mergedCallback = React.useCallback(function (value) {
        // Update the "current" prop hanging on the function.
        mergedCallback.current = value;
        for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
            var ref = refs_1[_i];
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref) {
                // work around the immutability of the React.Ref type
                ref.current = value;
            }
        }
    }, __spreadArray([], refs, true));
    return mergedCallback;
}

/**
 * Hook to attach an event handler on mount and handle cleanup.
 * @param element - Element (or ref to an element) to attach the event handler to
 * @param eventName - The event to attach a handler for
 * @param callback - The handler for the event
 * @param useCapture - Whether or not to attach the handler for the capture phase
 */
function useOnEvent(element, eventName, callback, useCapture) {
    // Use a ref for the callback to prevent repeatedly attaching/unattaching callbacks that are unstable across renders
    var callbackRef = React.useRef(callback);
    callbackRef.current = callback;
    React.useEffect(function () {
        var actualElement = element && 'current' in element ? element.current : element;
        if (!actualElement || !actualElement.addEventListener) {
            return;
        }
        var dispose = on(actualElement, eventName, function (ev) { return callbackRef.current(ev); }, useCapture);
        return dispose;
    }, [element, eventName, useCapture]);
}

/**
 * Hook keeping track of a given value from a previous execution of the component the Hook is used in.
 *
 * See [React Hooks FAQ](https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state)
 */
function usePrevious$1(value) {
    var ref = React.useRef();
    React.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}

/**
 * Creates a ref, and calls a callback whenever the ref changes to a non-null value. The callback can optionally return
 * a cleanup function that'll be called before the value changes, and when the ref is unmounted.
 *
 * This can be used to work around a limitation that useEffect cannot depend on `ref.current` (see
 * https://github.com/facebook/react/issues/14387#issuecomment-503616820).
 *
 * Usage example:
 * ```ts
 * const myRef = useRefEffect<HTMLElement>(element => {
 *  ...
 *  return () => { ... cleanup ... };
 * });
 * ```
 * ```jsx
 * <div ref={myRef} />
 * ```
 *
 * @param callback - Called whenever the ref's value changes to non-null. Can optionally return a cleanup function.
 * @param initial - (Optional) The initial value for the ref.
 *
 * @returns A function that should be called to set the ref's value. The object also has a `.current` member that can be
 * used to access the ref's value (like a normal RefObject). It can be hooked up to an element's `ref` property.
 */
function useRefEffect(callback, initial) {
    if (initial === undefined) { initial = null; }
    var createRefCallback = function () {
        var refCallback = function (value) {
            if (data.ref.current !== value) {
                if (data.cleanup) {
                    data.cleanup();
                    data.cleanup = undefined;
                }
                data.ref.current = value;
                if (value !== null) {
                    data.cleanup = data.callback(value);
                }
            }
        };
        refCallback.current = initial;
        return refCallback;
    };
    var data = React.useRef({
        ref: createRefCallback(),
        callback: callback,
    }).current;
    data.callback = callback;
    return data.ref;
}

/**
 *  Returns a wrapper function for `setTimeout` which automatically handles disposal.
 */
var useSetTimeout = function () {
    var timeoutIds = useConst({});
    // Cleanup function.
    React.useEffect(function () { return function () {
        for (var _i = 0, _a = Object.keys(timeoutIds); _i < _a.length; _i++) {
            var id = _a[_i];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            clearTimeout(id);
        }
    }; }, 
    // useConst ensures this will never change, but react-hooks/exhaustive-deps doesn't know that
    [timeoutIds]);
    // Return wrapper which will auto cleanup.
    return useConst({
        setTimeout: function (func, duration) {
            var id = setTimeout(func, duration);
            timeoutIds[id] = 1;
            return id;
        },
        clearTimeout: function (id) {
            delete timeoutIds[id];
            clearTimeout(id);
        },
    });
};

/**
 * Hook to calculate and cache the target element specified by the given target attribute,
 * as well as the target element's (or host element's) parent window
 * @param target- Target selector passed to the component as a property, describing the element that
 * the callout should target
 * @param hostElement- The callout's host element, used for determining the parent window.
 */
function useTarget(target, hostElement) {
    var _a, _b, _c;
    var previousTargetProp = React.useRef();
    var targetRef = React.useRef(null);
    /**
     * Stores an instance of Window, used to check
     * for server side rendering and if focus was lost.
     */
    var targetWindow = useWindow();
    // If the target element changed, find the new one. If we are tracking
    // target with class name, always find element because we do not know if
    // fabric has rendered a new element and disposed the old element.
    if (!target || target !== previousTargetProp.current || typeof target === 'string') {
        var currentElement = hostElement === null || hostElement === undefined ? undefined : hostElement.current;
        if (target) {
            if (typeof target === 'string') {
                // If element is part of shadow dom, then querySelector on shadow root, else query on document
                if ((_a = currentElement === null || currentElement === undefined ? undefined : currentElement.getRootNode()) === null || _a === undefined ? undefined : _a.host) {
                    targetRef.current = (_c = (_b = currentElement === null || currentElement === undefined ? undefined : currentElement.getRootNode()) === null || _b === undefined ? undefined : _b.querySelector(target)) !== null && _c !== undefined ? _c : null;
                }
                else {
                    var currentDoc = getDocument$1(currentElement);
                    targetRef.current = currentDoc ? currentDoc.querySelector(target) : null;
                }
            }
            else if ('stopPropagation' in target) {
                targetRef.current = target;
            }
            else if ('getBoundingClientRect' in target) {
                targetRef.current = target;
            }
            else if ('current' in target) {
                targetRef.current = target.current;
            }
            else {
                targetRef.current = target;
            }
        }
        previousTargetProp.current = target;
    }
    return [targetRef, targetWindow];
}

/**
 * Hook which synchronously executes a callback when the component is about to unmount.
 *
 * @param callback - Function to call during unmount.
 */
var useUnmount = function (callback) {
    var unmountRef = React.useRef(callback);
    unmountRef.current = callback;
    React.useEffect(function () { return function () {
        var _a;
        (_a = unmountRef.current) === null || _a === undefined ? undefined : _a.call(unmountRef);
    }; }, []);
};

var warningId = 0;
/**
 * Only in development mode, display console warnings when certain conditions are met.
 * Note that all warnings except `controlledUsage` will only be shown on first render
 * (new `controlledUsage` warnings may be shown later due to prop changes).
 */
function useWarnings(options) {
    if (process.env.NODE_ENV !== 'production') {
        var name_1 = options.name, props = options.props, _a = options.other, other = _a === undefined ? [] : _a, conditionallyRequired = options.conditionallyRequired, deprecations = options.deprecations, mutuallyExclusive = options.mutuallyExclusive, controlledUsage = options.controlledUsage;
        /* eslint-disable react-hooks/rules-of-hooks -- build-time conditional */
        var hasWarnedRef = React.useRef(false);
        var componentId = useConst(function () { return "useWarnings_".concat(warningId++); });
        var oldProps = usePrevious$1(props);
        /* eslint-enable react-hooks/rules-of-hooks */
        // Warn synchronously (not in useEffect) on first render to make debugging easier.
        if (!hasWarnedRef.current) {
            hasWarnedRef.current = true;
            for (var _i = 0, other_1 = other; _i < other_1.length; _i++) {
                var warning = other_1[_i];
                warn$1(warning);
            }
            if (conditionallyRequired) {
                for (var _b = 0, conditionallyRequired_1 = conditionallyRequired; _b < conditionallyRequired_1.length; _b++) {
                    var req = conditionallyRequired_1[_b];
                    warnConditionallyRequiredProps(name_1, props, req.requiredProps, req.conditionalPropName, req.condition);
                }
            }
            deprecations && warnDeprecations(name_1, props, deprecations);
            mutuallyExclusive && warnMutuallyExclusive(name_1, props, mutuallyExclusive);
        }
        // Controlled usage warnings may be displayed on either first or subsequent renders due to
        // prop changes. Note that it's safe to run this synchronously (not in useEffect) even in
        // concurrent mode because `warnControlledUsage` internally tracks which warnings have been
        // displayed for each component instance (so nothing will be displayed twice).
        controlledUsage && warnControlledUsage(__assign$2(__assign$2({}, controlledUsage), { componentId: componentId, props: props, componentName: name_1, oldProps: oldProps }));
    }
}

function useScrollbarAsync(props, root) {
    var async = useAsync();
    var _a = React.useState(false), needsVerticalScrollBarState = _a[0], setNeedsVerticalScrollBar = _a[1];
    React.useEffect(function () {
        async.requestAnimationFrame(function () {
            var _a;
            // If overflowY is overridden, don't waste time calculating whether the scrollbar is necessary.
            if (props.style && props.style.overflowY) {
                return;
            }
            var needsVerticalScrollBar = false;
            if (root && root.current && ((_a = root.current) === null || _a === undefined ? undefined : _a.firstElementChild)) {
                // ClientHeight returns the client height of an element rounded to an
                // integer. On some browsers at different zoom levels this rounding
                // can generate different results for the root container and child even
                // though they are the same height. This causes us to show a scroll bar
                // when not needed. Ideally we would use BoundingClientRect().height
                // instead however seems that the API is 90% slower than using ClientHeight.
                // Therefore instead we will calculate the difference between heights and
                // allow for a 1px difference to still be considered ok and not show the
                // scroll bar.
                var rootHeight = root.current.clientHeight;
                var firstChildHeight = root.current.firstElementChild.clientHeight;
                if (rootHeight > 0 && firstChildHeight > rootHeight) {
                    needsVerticalScrollBar = firstChildHeight - rootHeight > 1;
                }
            }
            if (needsVerticalScrollBarState !== needsVerticalScrollBar) {
                setNeedsVerticalScrollBar(needsVerticalScrollBar);
            }
        });
        return function () { return async.dispose(); };
    });
    return needsVerticalScrollBarState;
}
function defaultFocusRestorer(options) {
    var originalElement = options.originalElement, containsFocus = options.containsFocus;
    if (originalElement && containsFocus && originalElement !== getWindow$2()) {
        // Make sure that the focus method actually exists
        // In some cases the object might exist but not be a real element.
        // This is primarily for IE 11 and should be removed once IE 11 is no longer in use.
        // This is wrapped in a setTimeout because of a React 16 bug that is resolved in 17.
        // Once we move to 17, the setTimeout should be removed (ref: https://github.com/facebook/react/issues/17894#issuecomment-656094405)
        setTimeout(function () {
            var _a;
            (_a = originalElement.focus) === null || _a === undefined ? undefined : _a.call(originalElement);
        }, 0);
    }
}
function useRestoreFocus(props, root) {
    var _a = props.onRestoreFocus, onRestoreFocus = _a === undefined ? defaultFocusRestorer : _a;
    var originalFocusedElement = React.useRef();
    var containsFocus = React.useRef(false);
    React.useEffect(function () {
        originalFocusedElement.current = getDocument$1().activeElement;
        if (doesElementContainFocus(root.current)) {
            containsFocus.current = true;
        }
        return function () {
            var _a;
            onRestoreFocus === null || onRestoreFocus === undefined ? undefined : onRestoreFocus({
                originalElement: originalFocusedElement.current,
                containsFocus: containsFocus.current,
                documentContainsFocus: ((_a = getDocument$1()) === null || _a === undefined ? undefined : _a.hasFocus()) || false,
            });
            // De-reference DOM Node to avoid retainment via transpiled closure of _onKeyDown
            originalFocusedElement.current = undefined;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on first render
    }, []);
    useOnEvent(root, 'focus', React.useCallback(function () {
        containsFocus.current = true;
    }, []), true);
    useOnEvent(root, 'blur', React.useCallback(function (ev) {
        /** The popup should update this._containsFocus when:
         * relatedTarget exists AND
         * the relatedTarget is not contained within the popup.
         * If the relatedTarget is within the popup, that means the popup still has focus
         * and focused moved from one element to another within the popup.
         * If relatedTarget is undefined or null that usually means that a
         * keyboard event occurred and focus didn't change
         */
        if (root.current && ev.relatedTarget && !root.current.contains(ev.relatedTarget)) {
            containsFocus.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on first render
    }, []), true);
}
function useHideSiblingNodes(props, root) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var shouldHideSiblings = String(props['aria-modal']).toLowerCase() === 'true' && props.enableAriaHiddenSiblings;
    React.useEffect(function () {
        if (!(shouldHideSiblings && root.current)) {
            return;
        }
        var unmodalize = modalize(root.current);
        return unmodalize;
    }, [root, shouldHideSiblings]);
}
/**
 * This adds accessibility to Dialog and Panel controls
 */
var Popup = React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var props = getPropsWithDefaults({ shouldRestoreFocus: true, enableAriaHiddenSiblings: true }, propsWithoutDefaults);
    var root = React.useRef();
    var mergedRootRef = useMergedRefs$1(root, forwardedRef);
    useHideSiblingNodes(props, root);
    useRestoreFocus(props, root);
    var role = props.role, className = props.className, ariaLabel = props.ariaLabel, ariaLabelledBy = props.ariaLabelledBy, ariaDescribedBy = props.ariaDescribedBy, style = props.style, children = props.children, onDismiss = props.onDismiss;
    var needsVerticalScrollBar = useScrollbarAsync(props, root);
    var onKeyDown = React.useCallback(function (ev) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        switch (ev.which) {
            case KeyCodes.escape:
                if (onDismiss) {
                    onDismiss(ev);
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                break;
        }
    }, [onDismiss]);
    var win = useWindow();
    useOnEvent(win, 'keydown', onKeyDown);
    return (React.createElement("div", __assign$2({ ref: mergedRootRef }, getNativeProps$1(props, divProperties), { className: className, role: role, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, onKeyDown: onKeyDown, style: __assign$2({ overflowY: needsVerticalScrollBar ? 'scroll' : undefined, outline: 'none' }, style) }), children));
});
Popup.displayName = 'Popup';

var useDocumentEx = function() {
  var _a;
  return (_a = useDocument()) !== null && _a !== undefined ? _a : typeof document !== "undefined" ? document : undefined;
};
var useWindowEx = function() {
  var _a;
  return (_a = useWindow()) !== null && _a !== undefined ? _a : typeof window !== "undefined" ? window : undefined;
};
var getDocumentEx = function(ctx) {
  var _a, _b;
  return (_b = (_a = ctx === null || ctx === undefined ? undefined : ctx.window) === null || _a === undefined ? undefined : _a.document) !== null && _b !== undefined ? _b : typeof document !== "undefined" ? document : undefined;
};
var getWindowEx = function(ctx) {
  var _a;
  return (_a = ctx === null || ctx === undefined ? undefined : ctx.window) !== null && _a !== undefined ? _a : typeof window !== "undefined" ? window : undefined;
};

var _a$f;
var COMPONENT_NAME$b = 'CalloutContentBase';
var ANIMATIONS = (_a$f = {},
    _a$f[RectangleEdge.top] = AnimationClassNames.slideUpIn10,
    _a$f[RectangleEdge.bottom] = AnimationClassNames.slideDownIn10,
    _a$f[RectangleEdge.left] = AnimationClassNames.slideLeftIn10,
    _a$f[RectangleEdge.right] = AnimationClassNames.slideRightIn10,
    _a$f);
var BEAK_ORIGIN_POSITION = { top: 0, left: 0 };
// Microsoft Edge will overwrite inline styles if there is an animation pertaining to that style.
// To help ensure that edge will respect the offscreen style opacity
// filter needs to be added as an additional way to set opacity.
// Also set pointer-events: none so that the callout will not occlude the element it is
// going to be positioned against
var OFF_SCREEN_STYLE$1 = {
    opacity: 0,
    filter: 'opacity(0)',
    pointerEvents: 'none',
};
// role and role description go hand-in-hand. Both would be included by spreading getNativeProps for a basic element
// This constant array can be used to filter these out of native props spread on callout root and apply them together on
// calloutMain (the Popup component within the callout)
var ARIA_ROLE_ATTRIBUTES = ['role', 'aria-roledescription'];
var DEFAULT_PROPS$8 = {
    preventDismissOnLostFocus: false,
    preventDismissOnScroll: false,
    preventDismissOnResize: false,
    isBeakVisible: true,
    beakWidth: 16,
    gapSpace: 0,
    minPagePadding: 8,
    directionalHint: DirectionalHint.bottomAutoEdge,
};
var getClassNames$x = classNamesFunction({
    disableCaching: true, // disabling caching because stylesProp.position mutates often
});
/**
 * (Hook) to return a function to lazily fetch the bounds of the target element for the callout.
 */
function useBounds$1(_a, targetRef, targetWindow) {
    var bounds = _a.bounds, _b = _a.minPagePadding, minPagePadding = _b === undefined ? DEFAULT_PROPS$8.minPagePadding : _b, target = _a.target;
    var _c = React.useState(false), targetWindowResized = _c[0], setTargetWindowResized = _c[1];
    var cachedBounds = React.useRef();
    var getBounds = React.useCallback(function () {
        if (!cachedBounds.current || targetWindowResized) {
            var currentBounds = typeof bounds === 'function' ? (targetWindow ? bounds(target, targetWindow) : undefined) : bounds;
            if (!currentBounds && targetWindow) {
                currentBounds = getBoundsFromTargetWindow(targetRef.current, targetWindow);
                currentBounds = {
                    top: currentBounds.top + minPagePadding,
                    left: currentBounds.left + minPagePadding,
                    right: currentBounds.right - minPagePadding,
                    bottom: currentBounds.bottom - minPagePadding,
                    width: currentBounds.width - minPagePadding * 2,
                    height: currentBounds.height - minPagePadding * 2,
                };
            }
            cachedBounds.current = currentBounds;
            targetWindowResized && setTargetWindowResized(false);
        }
        return cachedBounds.current;
    }, [bounds, minPagePadding, target, targetRef, targetWindow, targetWindowResized]);
    var async = useAsync();
    useOnEvent(targetWindow, 'resize', async.debounce(function () {
        setTargetWindowResized(true);
    }, 500, { leading: true }));
    return getBounds;
}
/**
 * (Hook) to return the maximum available height for the Callout to render into.
 */
function useMaxHeight$1(_a, getBounds, targetRef, positions) {
    var _b;
    var calloutMaxHeight = _a.calloutMaxHeight, finalHeight = _a.finalHeight, directionalHint = _a.directionalHint, directionalHintFixed = _a.directionalHintFixed, hidden = _a.hidden, gapSpace = _a.gapSpace, beakWidth = _a.beakWidth, isBeakVisible = _a.isBeakVisible, coverTarget = _a.coverTarget;
    var _c = React.useState(), maxHeight = _c[0], setMaxHeight = _c[1];
    var _d = (_b = positions === null || positions === undefined ? undefined : positions.elementPosition) !== null && _b !== undefined ? _b : {}, top = _d.top, bottom = _d.bottom;
    var targetRect = (targetRef === null || targetRef === undefined ? undefined : targetRef.current) ? getRectangleFromTarget(targetRef.current) : undefined;
    React.useEffect(function () {
        var _a;
        var bounds = (_a = getBounds()) !== null && _a !== undefined ? _a : {};
        var topBounds = bounds.top;
        var bottomBounds = bounds.bottom;
        var calculatedHeight;
        // If aligned to top edge of target and not covering target, update bottom bounds to the
        // top of the target (accounting for gap space and beak)
        if ((positions === null || positions === undefined ? undefined : positions.targetEdge) === RectangleEdge.top && (targetRect === null || targetRect === undefined ? undefined : targetRect.top) && !coverTarget) {
            bottomBounds = targetRect.top - calculateGapSpace(isBeakVisible, beakWidth, gapSpace);
        }
        if (typeof top === 'number' && bottomBounds) {
            calculatedHeight = bottomBounds - top;
        }
        else if (typeof bottom === 'number' && typeof topBounds === 'number' && bottomBounds) {
            calculatedHeight = bottomBounds - topBounds - bottom;
        }
        if ((!calloutMaxHeight && !hidden) ||
            (calloutMaxHeight && calculatedHeight && calloutMaxHeight > calculatedHeight)) {
            setMaxHeight(calculatedHeight);
        }
        else if (calloutMaxHeight) {
            setMaxHeight(calloutMaxHeight);
        }
        else {
            setMaxHeight(undefined);
        }
    }, [
        bottom,
        calloutMaxHeight,
        finalHeight,
        directionalHint,
        directionalHintFixed,
        getBounds,
        hidden,
        positions,
        top,
        gapSpace,
        beakWidth,
        isBeakVisible,
        targetRect,
        coverTarget,
    ]);
    return maxHeight;
}
/**
 * (Hook) to find the current position of Callout. If Callout is resized then a new position is calculated.
 */
function usePositions(props, hostElement, calloutElement, targetRef, getBounds, popupRef) {
    var _a = React.useState(), positions = _a[0], setPositions = _a[1];
    var positionAttempts = React.useRef(0);
    var previousTarget = React.useRef();
    var async = useAsync();
    var hidden = props.hidden, target = props.target, finalHeight = props.finalHeight, calloutMaxHeight = props.calloutMaxHeight, onPositioned = props.onPositioned, directionalHint = props.directionalHint, hideOverflow = props.hideOverflow, preferScrollResizePositioning = props.preferScrollResizePositioning;
    var win = useWindowEx();
    var localRef = React.useRef();
    var popupStyles;
    if (localRef.current !== popupRef.current) {
        localRef.current = popupRef.current;
        popupStyles = popupRef.current ? win === null || win === undefined ? undefined : win.getComputedStyle(popupRef.current) : undefined;
    }
    var popupOverflowY = popupStyles === null || popupStyles === undefined ? undefined : popupStyles.overflowY;
    React.useEffect(function () {
        if (!hidden) {
            var timerId_1 = async.requestAnimationFrame(function () {
                var _a, _b;
                if (hostElement.current && calloutElement) {
                    var currentProps = __assign$2(__assign$2({}, props), { target: targetRef.current, bounds: getBounds() });
                    // duplicate calloutElement & remove useMaxHeight's maxHeight for position calc
                    var dupeCalloutElement = calloutElement.cloneNode(true);
                    dupeCalloutElement.style.maxHeight = calloutMaxHeight ? "".concat(calloutMaxHeight) : '';
                    dupeCalloutElement.style.visibility = 'hidden';
                    (_a = calloutElement.parentElement) === null || _a === undefined ? undefined : _a.appendChild(dupeCalloutElement);
                    var previousPositions = previousTarget.current === target ? positions : undefined;
                    // only account for scroll resizing if styles allow callout to scroll
                    // (popup styles determine if callout will scroll)
                    var isOverflowYHidden = hideOverflow || popupOverflowY === 'clip' || popupOverflowY === 'hidden';
                    var shouldScroll = preferScrollResizePositioning && !isOverflowYHidden;
                    // If there is a finalHeight given then we assume that the user knows and will handle
                    // additional positioning adjustments so we should call positionCard
                    var newPositions = finalHeight
                        ? positionCard(currentProps, hostElement.current, dupeCalloutElement, previousPositions, win)
                        : positionCallout(currentProps, hostElement.current, dupeCalloutElement, previousPositions, shouldScroll, undefined, win);
                    // clean up duplicate calloutElement
                    (_b = calloutElement.parentElement) === null || _b === undefined ? undefined : _b.removeChild(dupeCalloutElement);
                    // Set the new position only when the positions do not exist or one of the new callout positions
                    // is different. The position should not change if the position is within 2 decimal places.
                    if ((!positions && newPositions) ||
                        (positions && newPositions && !arePositionsEqual$1(positions, newPositions) && positionAttempts.current < 5)) {
                        // We should not reposition the callout more than a few times, if it is then the content is likely resizing
                        // and we should stop trying to reposition to prevent a stack overflow.
                        positionAttempts.current++;
                        setPositions(newPositions);
                    }
                    else if (positionAttempts.current > 0) {
                        // Only call the onPositioned callback if the callout has been re-positioned at least once.
                        positionAttempts.current = 0;
                        onPositioned === null || onPositioned === undefined ? undefined : onPositioned(positions);
                    }
                }
            }, calloutElement);
            previousTarget.current = target;
            return function () {
                async.cancelAnimationFrame(timerId_1);
                previousTarget.current = undefined;
            };
        }
        else {
            // When the callout is hidden, clear position state so that it is not accidentally used next render.
            setPositions(undefined);
            positionAttempts.current = 0;
        }
    }, [
        hidden,
        directionalHint,
        async,
        calloutElement,
        calloutMaxHeight,
        hostElement,
        targetRef,
        finalHeight,
        getBounds,
        onPositioned,
        positions,
        props,
        target,
        hideOverflow,
        preferScrollResizePositioning,
        popupOverflowY,
        win,
    ]);
    return positions;
}
/**
 * (Hook) to set up behavior to automatically focus the callout when it appears, if indicated by props.
 */
function useAutoFocus$1(_a, positions, calloutElement) {
    var hidden = _a.hidden, setInitialFocus = _a.setInitialFocus;
    var async = useAsync();
    var hasPositions = !!positions;
    React.useEffect(function () {
        if (!hidden && setInitialFocus && hasPositions && calloutElement) {
            var timerId_2 = async.requestAnimationFrame(function () { return focusFirstChild(calloutElement); }, calloutElement);
            return function () { return async.cancelAnimationFrame(timerId_2); };
        }
    }, [hidden, hasPositions, async, calloutElement, setInitialFocus]);
}
/**
 * (Hook) to set up various handlers to dismiss the popup when it loses focus or the window scrolls or similar cases.
 */
function useDismissHandlers(_a, positions, hostElement, targetRef, targetWindow) {
    var hidden = _a.hidden, onDismiss = _a.onDismiss, preventDismissOnScroll = _a.preventDismissOnScroll, preventDismissOnResize = _a.preventDismissOnResize, preventDismissOnLostFocus = _a.preventDismissOnLostFocus, dismissOnTargetClick = _a.dismissOnTargetClick, shouldDismissOnWindowFocus = _a.shouldDismissOnWindowFocus, preventDismissOnEvent = _a.preventDismissOnEvent;
    var isMouseDownOnPopup = React.useRef(false);
    var async = useAsync();
    var mouseDownHandlers = useConst([
        function () {
            isMouseDownOnPopup.current = true;
        },
        function () {
            isMouseDownOnPopup.current = false;
        },
    ]);
    var positionsExists = !!positions;
    React.useEffect(function () {
        var dismissOnScroll = function (ev) {
            if (positionsExists && !preventDismissOnScroll) {
                dismissOnClickOrScroll(ev);
            }
        };
        var dismissOnResize = function (ev) {
            if (!preventDismissOnResize && !(preventDismissOnEvent && preventDismissOnEvent(ev))) {
                onDismiss === null || onDismiss === undefined ? undefined : onDismiss(ev);
            }
        };
        var dismissOnLostFocus = function (ev) {
            if (!preventDismissOnLostFocus) {
                dismissOnClickOrScroll(ev);
            }
        };
        var dismissOnClickOrScroll = function (ev) {
            var eventPaths = ev.composedPath ? ev.composedPath() : [];
            var target = eventPaths.length > 0 ? eventPaths[0] : ev.target;
            var isEventTargetOutsideCallout = hostElement.current && !elementContains$1(hostElement.current, target);
            // If mouse is pressed down on callout but moved outside then released, don't dismiss the callout.
            if (isEventTargetOutsideCallout && isMouseDownOnPopup.current) {
                isMouseDownOnPopup.current = false;
                return;
            }
            if ((!targetRef.current && isEventTargetOutsideCallout) ||
                (ev.target !== targetWindow &&
                    isEventTargetOutsideCallout &&
                    (!targetRef.current ||
                        'stopPropagation' in targetRef.current ||
                        dismissOnTargetClick ||
                        (target !== targetRef.current && !elementContains$1(targetRef.current, target))))) {
                if (preventDismissOnEvent && preventDismissOnEvent(ev)) {
                    return;
                }
                onDismiss === null || onDismiss === undefined ? undefined : onDismiss(ev);
            }
        };
        var dismissOnTargetWindowBlur = function (ev) {
            // Do nothing
            if (!shouldDismissOnWindowFocus) {
                return;
            }
            if (((preventDismissOnEvent && !preventDismissOnEvent(ev)) ||
                (!preventDismissOnEvent && !preventDismissOnLostFocus)) &&
                !(targetWindow === null || targetWindow === undefined ? undefined : targetWindow.document.hasFocus()) &&
                ev.relatedTarget === null) {
                onDismiss === null || onDismiss === undefined ? undefined : onDismiss(ev);
            }
        };
        // This is added so the callout will dismiss when the window is scrolled
        // but not when something inside the callout is scrolled. The delay seems
        // to be required to avoid React firing an async focus event in IE from
        // the target changing focus quickly prior to rendering the callout.
        var disposablesPromise = new Promise(function (resolve) {
            async.setTimeout(function () {
                if (!hidden && targetWindow) {
                    var disposables_1 = [
                        on(targetWindow, 'scroll', dismissOnScroll, true),
                        on(targetWindow, 'resize', dismissOnResize, true),
                        on(targetWindow.document.documentElement, 'focus', dismissOnLostFocus, true),
                        on(targetWindow.document.documentElement, 'click', dismissOnLostFocus, true),
                        on(targetWindow, 'blur', dismissOnTargetWindowBlur, true),
                    ];
                    resolve(function () {
                        disposables_1.forEach(function (dispose) { return dispose(); });
                    });
                }
            }, 0);
        });
        return function () {
            disposablesPromise.then(function (dispose) { return dispose(); });
        };
    }, [
        hidden,
        async,
        hostElement,
        targetRef,
        targetWindow,
        onDismiss,
        shouldDismissOnWindowFocus,
        dismissOnTargetClick,
        preventDismissOnLostFocus,
        preventDismissOnResize,
        preventDismissOnScroll,
        positionsExists,
        preventDismissOnEvent,
    ]);
    return mouseDownHandlers;
}
var CalloutContentBase = React.memo(React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var props = getPropsWithDefaults(DEFAULT_PROPS$8, propsWithoutDefaults);
    var styles = props.styles, style = props.style, ariaLabel = props.ariaLabel, ariaDescribedBy = props.ariaDescribedBy, ariaLabelledBy = props.ariaLabelledBy, className = props.className, isBeakVisible = props.isBeakVisible, children = props.children, beakWidth = props.beakWidth, calloutWidth = props.calloutWidth, calloutMaxWidth = props.calloutMaxWidth, calloutMinWidth = props.calloutMinWidth, doNotLayer = props.doNotLayer, finalHeight = props.finalHeight, _a = props.hideOverflow, hideOverflow = _a === undefined ? !!finalHeight : _a, backgroundColor = props.backgroundColor, calloutMaxHeight = props.calloutMaxHeight, onScroll = props.onScroll, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    _b = props.shouldRestoreFocus, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    shouldRestoreFocus = _b === undefined ? true : _b, target = props.target, hidden = props.hidden, onLayerMounted = props.onLayerMounted, popupProps = props.popupProps;
    var hostElement = React.useRef(null);
    var popupRef = React.useRef(null);
    var mergedPopupRefs = useMergedRefs$1(popupRef, popupProps === null || popupProps === undefined ? undefined : popupProps.ref);
    var _c = React.useState(null), calloutElement = _c[0], setCalloutElement = _c[1];
    var calloutCallback = React.useCallback(function (calloutEl) {
        setCalloutElement(calloutEl);
    }, []);
    var rootRef = useMergedRefs$1(hostElement, forwardedRef);
    var _d = useTarget(props.target, {
        current: calloutElement,
    }), targetRef = _d[0], targetWindow = _d[1];
    var getBounds = useBounds$1(props, targetRef, targetWindow);
    var positions = usePositions(props, hostElement, calloutElement, targetRef, getBounds, mergedPopupRefs);
    var maxHeight = useMaxHeight$1(props, getBounds, targetRef, positions);
    var _e = useDismissHandlers(props, positions, hostElement, targetRef, targetWindow), mouseDownOnPopup = _e[0], mouseUpOnPopup = _e[1];
    // do not set both top and bottom css props from positions
    // instead, use maxHeight
    var isForcedInBounds = (positions === null || positions === undefined ? undefined : positions.elementPosition.top) && (positions === null || positions === undefined ? undefined : positions.elementPosition.bottom);
    var cssPositions = __assign$2(__assign$2({}, positions === null || positions === undefined ? undefined : positions.elementPosition), { maxHeight: maxHeight });
    if (isForcedInBounds) {
        cssPositions.bottom = undefined;
    }
    useAutoFocus$1(props, positions, calloutElement);
    React.useEffect(function () {
        if (!hidden) {
            onLayerMounted === null || onLayerMounted === undefined ? undefined : onLayerMounted();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run if hidden changes
    }, [hidden]);
    // If there is no target window then we are likely in server side rendering and we should not render anything.
    if (!targetWindow) {
        return null;
    }
    var overflowYHidden = hideOverflow;
    var beakVisible = isBeakVisible && !!target;
    var classNames = getClassNames$x(styles, {
        theme: props.theme,
        className: className,
        overflowYHidden: overflowYHidden,
        calloutWidth: calloutWidth,
        positions: positions,
        beakWidth: beakWidth,
        backgroundColor: backgroundColor,
        calloutMaxWidth: calloutMaxWidth,
        calloutMinWidth: calloutMinWidth,
        doNotLayer: doNotLayer,
    });
    var overflowStyle = __assign$2(__assign$2({ maxHeight: calloutMaxHeight ? calloutMaxHeight : '100%' }, style), (overflowYHidden && { overflowY: 'hidden' }));
    var visibilityStyle = props.hidden ? { visibility: 'hidden' } : undefined;
    // React.CSSProperties does not understand IRawStyle, so the inline animations will need to be cast as any for now.
    return (React.createElement("div", { ref: rootRef, className: classNames.container, style: visibilityStyle },
        React.createElement("div", __assign$2({}, getNativeProps$1(props, divProperties, ARIA_ROLE_ATTRIBUTES), { className: css(classNames.root, positions && positions.targetEdge && ANIMATIONS[positions.targetEdge]), style: positions ? __assign$2({}, cssPositions) : OFF_SCREEN_STYLE$1, 
            // Safari and Firefox on Mac OS requires this to back-stop click events so focus remains in the Callout.
            // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
            tabIndex: -1, ref: calloutCallback }),
            beakVisible && React.createElement("div", { className: classNames.beak, style: getBeakPosition(positions) }),
            beakVisible && React.createElement("div", { className: classNames.beakCurtain }),
            React.createElement(Popup
            // don't use getNativeElementProps for role and roledescription because it will also
            // pass through data-* props (resulting in them being used in two places)
            , __assign$2({ 
                // don't use getNativeElementProps for role and roledescription because it will also
                // pass through data-* props (resulting in them being used in two places)
                role: props.role, "aria-roledescription": props['aria-roledescription'], ariaDescribedBy: ariaDescribedBy, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, className: classNames.calloutMain, onDismiss: props.onDismiss, onMouseDown: mouseDownOnPopup, onMouseUp: mouseUpOnPopup, onRestoreFocus: props.onRestoreFocus, onScroll: onScroll, shouldRestoreFocus: shouldRestoreFocus, style: overflowStyle }, popupProps, { ref: mergedPopupRefs }), children))));
}), function (previousProps, nextProps) {
    if (!nextProps.shouldUpdateWhenHidden && previousProps.hidden && nextProps.hidden) {
        // Do not update when hidden.
        return true;
    }
    return shallowCompare(previousProps, nextProps);
});
/**
 * (Utility) to find and return the current `Callout` Beak position.
 *
 * @param positions
 */
function getBeakPosition(positions) {
    var _a, _b;
    var beakPositionStyle = __assign$2(__assign$2({}, (_a = positions === null || positions === undefined ? undefined : positions.beakPosition) === null || _a === undefined ? undefined : _a.elementPosition), { display: ((_b = positions === null || positions === undefined ? undefined : positions.beakPosition) === null || _b === undefined ? undefined : _b.hideBeak) ? 'none' : undefined });
    if (!beakPositionStyle.top && !beakPositionStyle.bottom && !beakPositionStyle.left && !beakPositionStyle.right) {
        beakPositionStyle.left = BEAK_ORIGIN_POSITION.left;
        beakPositionStyle.top = BEAK_ORIGIN_POSITION.top;
    }
    return beakPositionStyle;
}
/**
 * (Utility) used to compare two different elementPositions to determine whether they are equal.
 *
 * @param prevElementPositions
 * @param newElementPosition
 */
function arePositionsEqual$1(prevElementPositions, newElementPosition) {
    return (comparePositions$1(prevElementPositions.elementPosition, newElementPosition.elementPosition) &&
        comparePositions$1(prevElementPositions.beakPosition.elementPosition, newElementPosition.beakPosition.elementPosition));
}
/**
 * (Utility) used in **arePositionsEqual** to compare two different elementPositions.
 *
 * @param prevElementPositions
 * @param newElementPositions
 */
function comparePositions$1(prevElementPositions, newElementPositions) {
    for (var key in newElementPositions) {
        if (newElementPositions.hasOwnProperty(key)) {
            var oldPositionEdge = prevElementPositions[key];
            var newPositionEdge = newElementPositions[key];
            if (oldPositionEdge !== undefined && newPositionEdge !== undefined) {
                if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    return true;
}
CalloutContentBase.displayName = COMPONENT_NAME$b;

function getBeakStyle(beakWidth) {
    return {
        height: beakWidth,
        width: beakWidth,
    };
}
var GlobalClassNames$l = {
    container: 'ms-Callout-container',
    root: 'ms-Callout',
    beak: 'ms-Callout-beak',
    beakCurtain: 'ms-Callout-beakCurtain',
    calloutMain: 'ms-Callout-main',
};
var getStyles$z = function (props) {
    var _a;
    var theme = props.theme, className = props.className, overflowYHidden = props.overflowYHidden, calloutWidth = props.calloutWidth, beakWidth = props.beakWidth, backgroundColor = props.backgroundColor, calloutMaxWidth = props.calloutMaxWidth, calloutMinWidth = props.calloutMinWidth, doNotLayer = props.doNotLayer;
    var classNames = getGlobalClassNames(GlobalClassNames$l, theme);
    var semanticColors = theme.semanticColors, effects = theme.effects;
    return {
        container: [
            classNames.container,
            {
                position: 'relative',
            },
        ],
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'absolute',
                display: 'flex',
                zIndex: doNotLayer ? ZIndexes.Layer : undefined,
                boxSizing: 'border-box',
                borderRadius: effects.roundedCorner2,
                boxShadow: effects.elevation16,
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: 'WindowText',
                    },
                    _a),
            },
            focusClear(),
            className,
            !!calloutWidth && { width: calloutWidth },
            !!calloutMaxWidth && { maxWidth: calloutMaxWidth },
            !!calloutMinWidth && { minWidth: calloutMinWidth },
        ],
        beak: [
            classNames.beak,
            {
                position: 'absolute',
                backgroundColor: semanticColors.menuBackground,
                boxShadow: 'inherit',
                border: 'inherit',
                boxSizing: 'border-box',
                transform: 'rotate(45deg)',
            },
            getBeakStyle(beakWidth),
            backgroundColor && {
                backgroundColor: backgroundColor,
            },
        ],
        beakCurtain: [
            classNames.beakCurtain,
            {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: semanticColors.menuBackground,
                borderRadius: effects.roundedCorner2,
            },
        ],
        calloutMain: [
            classNames.calloutMain,
            {
                backgroundColor: semanticColors.menuBackground,
                overflowX: 'hidden',
                overflowY: 'auto',
                position: 'relative',
                width: '100%',
                borderRadius: effects.roundedCorner2,
            },
            overflowYHidden && {
                overflowY: 'hidden',
            },
            backgroundColor && {
                backgroundColor: backgroundColor,
            },
        ],
    };
};

var CalloutContent = styled(CalloutContentBase, getStyles$z, undefined, {
    scope: 'CalloutContent',
});

var PortalCompatContext = React.createContext(undefined);
var portalCompatContextDefaultValue = function() {
    return function() {
        return undefined;
    };
};
PortalCompatContext.Provider;
function usePortalCompat() {
    var _React_useContext;
    return (_React_useContext = React.useContext(PortalCompatContext)) !== null && _React_useContext !== undefined ? _React_useContext : portalCompatContextDefaultValue;
}

var getClassNames$w = classNamesFunction();
var getFabricTheme = memoizeFunction(function (theme, isRTL) { return createTheme(__assign$2(__assign$2({}, theme), { rtl: isRTL })); });
var getDir = function (_a) {
    var theme = _a.theme, dir = _a.dir;
    var contextDir = getRTL(theme) ? 'rtl' : 'ltr';
    var pageDir = getRTL() ? 'rtl' : 'ltr';
    var componentDir = dir ? dir : contextDir;
    return {
        // If Fabric dir !== contextDir
        // Or If contextDir !== pageDir
        // Then we need to set dir of the Fabric root
        rootDir: componentDir !== contextDir || componentDir !== pageDir ? componentDir : dir,
        // If dir !== contextDir || pageDir
        // then set contextual theme around content
        needsTheme: componentDir !== contextDir,
    };
};
var FabricBase = React.forwardRef(function (props, ref) {
    var className = props.className, theme = props.theme, applyTheme = props.applyTheme, applyThemeToBody = props.applyThemeToBody, styles = props.styles;
    var classNames = getClassNames$w(styles, {
        theme: theme,
        applyTheme: applyTheme,
        className: className,
    });
    var rootElement = React.useRef(null);
    useApplyThemeToBody(applyThemeToBody, classNames, rootElement);
    return React.createElement(React.Fragment, null, useRenderedContent(props, classNames, rootElement, ref));
});
FabricBase.displayName = 'FabricBase';
function useRenderedContent(props, _a, rootElement, ref) {
    var root = _a.root;
    var _b = props.as, Root = _b === undefined ? 'div' : _b, dir = props.dir, theme = props.theme;
    var divProps = getNativeProps$1(props, divProperties, ['dir']);
    var _c = getDir(props), rootDir = _c.rootDir, needsTheme = _c.needsTheme;
    var renderedContent = (React.createElement(FocusRectsProvider, { providerRef: rootElement },
        React.createElement(Root, __assign$2({ dir: rootDir }, divProps, { className: root, ref: useMergedRefs$1(rootElement, ref) }))));
    // Create the contextual theme if component direction does not match parent direction.
    if (needsTheme) {
        // Disabling ThemeProvider here because theme doesn't need to be re-provided by ThemeProvider if dir has changed.
        renderedContent = (
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        React.createElement(Customizer, { settings: { theme: getFabricTheme(theme, dir === 'rtl') } }, renderedContent));
    }
    return renderedContent;
}
function useApplyThemeToBody(applyThemeToBody, _a, rootElement) {
    var bodyThemed = _a.bodyThemed;
    React.useEffect(function () {
        if (applyThemeToBody) {
            var currentDoc_1 = getDocument$1(rootElement.current);
            if (currentDoc_1) {
                currentDoc_1.body.classList.add(bodyThemed);
                return function () {
                    currentDoc_1.body.classList.remove(bodyThemed);
                };
            }
        }
    }, [bodyThemed, applyThemeToBody, rootElement]);
    return rootElement;
}

var inheritFont = { fontFamily: 'inherit' };
var GlobalClassNames$k = {
    root: 'ms-Fabric',
    bodyThemed: 'ms-Fabric-bodyThemed',
};
var getStyles$y = function (props) {
    var applyTheme = props.applyTheme, className = props.className, preventBlanketFontInheritance = props.preventBlanketFontInheritance, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$k, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                color: theme.palette.neutralPrimary,
            },
            !preventBlanketFontInheritance && {
                '& button': inheritFont,
                '& input': inheritFont,
                '& textarea': inheritFont,
            },
            // apply theme to only if applyTheme is true
            applyTheme && {
                color: theme.semanticColors.bodyText,
                backgroundColor: theme.semanticColors.bodyBackground,
            },
            className,
        ],
        bodyThemed: [
            {
                backgroundColor: theme.semanticColors.bodyBackground,
            },
        ],
    };
};

/**
 * @deprecated This component is deprecated as of `@fluentui/react` version 8. Use `ThemeProvider` instead.
 */
var Fabric = styled(FabricBase, getStyles$y, undefined, {
    scope: 'Fabric',
});

var _layersByHostId = {};
var _layerHostsById = {};
var defaultHostId = 'fluent-default-layer-host';
var _defaultHostSelector = "#".concat(defaultHostId);
/**
 * Register a layer for a given host id
 * @param hostId - Id of the layer host
 * @param layer - Layer instance
 */
function registerLayer(hostId, callback) {
    if (!_layersByHostId[hostId]) {
        _layersByHostId[hostId] = [];
    }
    _layersByHostId[hostId].push(callback);
    var layerHosts = _layerHostsById[hostId];
    if (layerHosts) {
        for (var _i = 0, layerHosts_1 = layerHosts; _i < layerHosts_1.length; _i++) {
            var layerHost = layerHosts_1[_i];
            layerHost.notifyLayersChanged();
        }
    }
}
/**
 * Unregister a layer for a given host id
 * @param hostId - Id of the layer host
 * @param layer - Layer instance
 */
function unregisterLayer(hostId, callback) {
    var layers = _layersByHostId[hostId];
    if (layers) {
        var idx = layers.indexOf(callback);
        if (idx >= 0) {
            layers.splice(idx, 1);
            if (layers.length === 0) {
                delete _layersByHostId[hostId];
            }
        }
    }
    var layerHosts = _layerHostsById[hostId];
    if (layerHosts) {
        for (var _i = 0, layerHosts_2 = layerHosts; _i < layerHosts_2.length; _i++) {
            var layerHost = layerHosts_2[_i];
            layerHost.notifyLayersChanged();
        }
    }
}
/**
 * Gets the Layer Host instance associated with a hostId, if applicable.
 * @param hostId - Id of the layer host
 * @returns A component ref for the associated layer host.
 */
function getLayerHost(hostId) {
    var layerHosts = _layerHostsById[hostId];
    return (layerHosts && layerHosts[0]) || undefined;
}
/**
 * When no default layer host is provided, this function is executed to create the default host.
 */
function createDefaultLayerHost(doc, shadowRoot) {
    if (shadowRoot === undefined) { shadowRoot = null; }
    var host = doc.createElement('div');
    host.setAttribute('id', defaultHostId);
    host.style.cssText = 'position:fixed;z-index:1000000';
    if (shadowRoot) {
        shadowRoot.appendChild(host);
    }
    else {
        doc === null || doc === undefined ? undefined : doc.body.appendChild(host);
    }
    // doc?.body.appendChild(host);
    return host;
}
/**
 * Get the default target selector when determining a host
 */
function getDefaultTarget() {
    return _defaultHostSelector;
}

var getClassNames$v = classNamesFunction();
var getFocusVisibility = function (providerRef) {
    if (providerRef === null || providerRef === undefined ? undefined : providerRef.current) {
        return providerRef.current.classList.contains(IsFocusVisibleClassName);
    }
    return false;
};
var LayerBase = React.forwardRef(function (props, ref) {
    var registerPortalEl = usePortalCompat();
    var rootRef = React.useRef(null);
    var mergedRef = useMergedRefs$1(rootRef, ref);
    var layerRef = React.useRef();
    var fabricElementRef = React.useRef(null);
    var focusContext = React.useContext(FocusRectsContext);
    // Tracks if the layer mount events need to be raised.
    // Required to allow the DOM to render after the layer element is added.
    var _a = React.useState(false), needRaiseLayerMount = _a[0], setNeedRaiseLayerMount = _a[1];
    // Sets the focus visible className when the FocusRectsProvider for the layer is rendered
    // This allows the current focus visibility style to be carried over to the layer content
    var focusRectsRef = React.useCallback(function (el) {
        var isFocusVisible = getFocusVisibility(focusContext === null || focusContext === undefined ? undefined : focusContext.providerRef);
        if (el && isFocusVisible) {
            el.classList.add(IsFocusVisibleClassName);
        }
    }, [focusContext]);
    var children = props.children, className = props.className, eventBubblingEnabled = props.eventBubblingEnabled, fabricProps = props.fabricProps, hostId = props.hostId, insertFirst = props.insertFirst, _b = props.onLayerDidMount, onLayerDidMount = _b === undefined ? function () { return undefined; } : _b, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    _c = props.onLayerMounted, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    onLayerMounted = _c === undefined ? function () { return undefined; } : _c, onLayerWillUnmount = props.onLayerWillUnmount, styles = props.styles, theme = props.theme;
    var fabricRef = useMergedRefs$1(fabricElementRef, fabricProps === null || fabricProps === undefined ? undefined : fabricProps.ref, focusRectsRef);
    var classNames = getClassNames$v(styles, {
        theme: theme,
        className: className,
        isNotHost: !hostId,
    });
    // Returns the user provided hostId props element, the default target selector,
    // or undefined if document doesn't exist.
    var getHost = function (doc, shadowRoot) {
        var _a, _b;
        if (shadowRoot === undefined) { shadowRoot = null; }
        var root = shadowRoot !== null && shadowRoot !== undefined ? shadowRoot : doc;
        if (hostId) {
            var layerHost = getLayerHost(hostId);
            if (layerHost) {
                return (_a = layerHost.rootRef.current) !== null && _a !== undefined ? _a : null;
            }
            return (_b = root.getElementById(hostId)) !== null && _b !== undefined ? _b : null;
        }
        else {
            var defaultHostSelector = getDefaultTarget();
            // Find the host.
            var host = defaultHostSelector ? root.querySelector(defaultHostSelector) : null;
            // If no host is available, create a container for injecting layers in.
            // Having a container scopes layout computation.
            if (!host) {
                host = createDefaultLayerHost(doc, shadowRoot);
            }
            return host;
        }
    };
    // Removes the current layer element's parentNode and runs onLayerWillUnmount prop if provided.
    var removeLayerElement = function () {
        onLayerWillUnmount === null || onLayerWillUnmount === undefined ? undefined : onLayerWillUnmount();
        var elem = layerRef.current;
        // Clear ref before removing from the DOM
        layerRef.current = undefined;
        if (elem && elem.parentNode) {
            elem.parentNode.removeChild(elem);
        }
    };
    // If a doc or host exists, it will remove and update layer parentNodes.
    var createLayerElement = function () {
        var _a, _b, _c, _d;
        var doc = getDocument$1(rootRef.current);
        var shadowRoot = ((_b = (_a = rootRef.current) === null || _a === undefined ? undefined : _a.getRootNode()) === null || _b === undefined ? undefined : _b.host)
            ? (_c = rootRef === null || rootRef === undefined ? undefined : rootRef.current) === null || _c === undefined ? undefined : _c.getRootNode()
            : undefined;
        if (!doc || (!doc && !shadowRoot)) {
            return;
        }
        var host = getHost(doc, shadowRoot);
        if (!host) {
            return;
        }
        // Tabster in V9 sets aria-hidden on the elements outside of the modal dialog. And it doesn't set aria-hidden
        // on the virtual children of the dialog. But the host element itself is not a virtual child of a dialog, it
        // might contain virtual children. noDirectAriaHidden flag makes Tabster to poke inside the element and set
        // aria-hidden on the children (if they are not virtual children of the active V9 dialog) not on the host element.
        // To avoid importing Tabster as a dependency here, we just set a flag on the host element which is checked by
        // Tabster.
        if (!host.__tabsterElementFlags) {
            host.__tabsterElementFlags = {};
        }
        host.__tabsterElementFlags.noDirectAriaHidden = true;
        // Remove and re-create any previous existing layer elements.
        removeLayerElement();
        var el = ((_d = host.ownerDocument) !== null && _d !== undefined ? _d : doc).createElement('div');
        el.className = classNames.root;
        setPortalAttribute(el);
        setVirtualParent$1(el, rootRef.current);
        insertFirst ? host.insertBefore(el, host.firstChild) : host.appendChild(el);
        layerRef.current = el;
        setNeedRaiseLayerMount(true);
    };
    useIsomorphicLayoutEffect$1(function () {
        createLayerElement();
        // Check if the user provided a hostId prop and register the layer with the ID.
        if (hostId) {
            registerLayer(hostId, createLayerElement);
        }
        var unregisterPortalEl = layerRef.current ? registerPortalEl(layerRef.current) : undefined;
        return function () {
            if (unregisterPortalEl) {
                unregisterPortalEl();
            }
            removeLayerElement();
            if (hostId) {
                unregisterLayer(hostId, createLayerElement);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should run if the hostId updates.
    }, [hostId]);
    React.useEffect(function () {
        if (layerRef.current && needRaiseLayerMount) {
            onLayerMounted === null || onLayerMounted === undefined ? undefined : onLayerMounted();
            onLayerDidMount === null || onLayerDidMount === undefined ? undefined : onLayerDidMount();
            setNeedRaiseLayerMount(false);
        }
    }, [needRaiseLayerMount, onLayerMounted, onLayerDidMount]);
    useDebugWarnings$4(props);
    return (React.createElement("span", { className: "ms-layer", ref: mergedRef }, layerRef.current &&
        ReactDOM.createPortal(React.createElement(FocusRectsProvider, { layerRoot: true, providerRef: fabricRef },
            React.createElement(Fabric, __assign$2({}, (!eventBubblingEnabled && getFilteredEvents()), fabricProps, { className: css(classNames.content, fabricProps === null || fabricProps === undefined ? undefined : fabricProps.className), ref: fabricRef }), children)), layerRef.current)));
});
LayerBase.displayName = 'LayerBase';
var filteredEventProps;
var onFilterEvent = function (ev) {
    // We should just be able to check ev.bubble here and only stop events that are bubbling up. However, even though
    // mouseenter and mouseleave do NOT bubble up, they are showing up as bubbling. Therefore we stop events based on
    // event name rather than ev.bubble.
    if (ev.eventPhase === Event.BUBBLING_PHASE &&
        ev.type !== 'mouseenter' &&
        ev.type !== 'mouseleave' &&
        ev.type !== 'touchstart' &&
        ev.type !== 'touchend') {
        ev.stopPropagation();
    }
};
function getFilteredEvents() {
    if (!filteredEventProps) {
        filteredEventProps = {};
        [
            'onClick',
            'onContextMenu',
            'onDoubleClick',
            'onDrag',
            'onDragEnd',
            'onDragEnter',
            'onDragExit',
            'onDragLeave',
            'onDragOver',
            'onDragStart',
            'onDrop',
            'onMouseDown',
            'onMouseEnter',
            'onMouseLeave',
            'onMouseMove',
            'onMouseOver',
            'onMouseOut',
            'onMouseUp',
            'onTouchMove',
            'onTouchStart',
            'onTouchCancel',
            'onTouchEnd',
            'onKeyDown',
            'onKeyPress',
            'onKeyUp',
            'onFocus',
            'onBlur',
            'onChange',
            'onInput',
            'onInvalid',
            'onSubmit',
        ].forEach(function (name) { return (filteredEventProps[name] = onFilterEvent); });
    }
    return filteredEventProps;
}
function useDebugWarnings$4(props) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- build-time conditional
        useWarnings({
            name: 'Layer',
            props: props,
            deprecations: { onLayerMounted: 'onLayerDidMount' },
        });
    }
}

var GlobalClassNames$j = {
    root: 'ms-Layer',
    rootNoHost: 'ms-Layer--fixed',
    content: 'ms-Layer-content',
};
var getStyles$x = function (props) {
    var className = props.className, isNotHost = props.isNotHost, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$j, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isNotHost && [
                classNames.rootNoHost,
                {
                    position: 'fixed',
                    zIndex: ZIndexes.Layer,
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    visibility: 'hidden',
                },
            ],
            className,
        ],
        content: [
            classNames.content,
            {
                visibility: 'visible',
            },
        ],
    };
};

var Layer = styled(LayerBase, getStyles$x, undefined, {
    scope: 'Layer',
    fields: ['hostId', 'theme', 'styles'],
});

var Callout = React.forwardRef(function (_a, forwardedRef) {
    var layerProps = _a.layerProps, doNotLayer = _a.doNotLayer, rest = __rest$1(_a, ["layerProps", "doNotLayer"]);
    var content = React.createElement(CalloutContent, __assign$2({}, rest, { doNotLayer: doNotLayer, ref: forwardedRef }));
    return doNotLayer ? content : React.createElement(Layer, __assign$2({}, layerProps), content);
});
Callout.displayName = 'Callout';

var COMPONENT_NAME$a = "FocusTrapZone";
var DEFAULT_PROPS$7 = {
  disabled: false,
  disableFirstFocus: false,
  forceFocusInsideTrap: true,
  isClickableOutsideFocusTrap: false,
  // Hardcoding completely uncontrolled flag for proper interop with FluentUI V9.
  "data-tabster": '{"uncontrolled": {"completely": true}}'
};
var useComponentRef$7 = function(componentRef, previouslyFocusedElement, focusFTZ) {
  React.useImperativeHandle(componentRef, function() {
    return {
      get previouslyFocusedElement() {
        return previouslyFocusedElement;
      },
      focus: focusFTZ
    };
  }, [focusFTZ, previouslyFocusedElement]);
};
var FocusTrapZone = React.forwardRef(function(propsWithoutDefaults, ref) {
  var _a;
  var root = React.useRef(null);
  var firstBumper = React.useRef(null);
  var lastBumper = React.useRef(null);
  var mergedRootRef = useMergedRefs$1(root, ref);
  var doc = useDocument();
  var win = useWindowEx();
  var inShadow = useHasMergeStylesShadowRootContext();
  var isFirstRender = (_a = usePrevious$1(false)) !== null && _a !== undefined ? _a : true;
  var props = getPropsWithDefaults(DEFAULT_PROPS$7, propsWithoutDefaults);
  var internalState = useConst({
    hasFocus: false,
    focusStackId: useId$1("ftz-", props.id)
  });
  var children = props.children, componentRef = props.componentRef, disabled = props.disabled, disableFirstFocus = props.disableFirstFocus, forceFocusInsideTrap = props.forceFocusInsideTrap, focusPreviouslyFocusedInnerElement = props.focusPreviouslyFocusedInnerElement, firstFocusableSelector = props.firstFocusableSelector, firstFocusableTarget = props.firstFocusableTarget, _b = props.disableRestoreFocus, disableRestoreFocus = _b === undefined ? props.ignoreExternalFocusing : _b, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, enableAriaHiddenSiblings = props.enableAriaHiddenSiblings;
  var bumperProps = {
    "aria-hidden": true,
    style: {
      pointerEvents: "none",
      position: "fixed"
      // 'fixed' prevents browsers from scrolling to bumpers when viewport does not contain them
    },
    tabIndex: disabled ? -1 : 0,
    // make bumpers tabbable only when enabled
    "data-is-visible": true,
    "data-is-focus-trap-zone-bumper": true
  };
  var focusElementAsync = React.useCallback(function(element) {
    if (element !== firstBumper.current && element !== lastBumper.current) {
      focusAsync(element);
    }
  }, []);
  var focusFTZ = useEventCallback$1(function() {
    if (!root.current) {
      return;
    }
    var previouslyFocusedElementInTrapZone = internalState.previouslyFocusedElementInTrapZone;
    if (focusPreviouslyFocusedInnerElement && previouslyFocusedElementInTrapZone && elementContains$1(root.current, previouslyFocusedElementInTrapZone)) {
      focusElementAsync(previouslyFocusedElementInTrapZone);
      return;
    }
    var firstFocusableChild = null;
    if (typeof firstFocusableTarget === "string") {
      firstFocusableChild = root.current.querySelector(firstFocusableTarget);
    } else if (firstFocusableTarget) {
      firstFocusableChild = firstFocusableTarget(root.current);
    } else if (firstFocusableSelector) {
      var focusSelector = typeof firstFocusableSelector === "string" ? firstFocusableSelector : firstFocusableSelector();
      firstFocusableChild = root.current.querySelector("." + focusSelector);
    }
    if (!firstFocusableChild) {
      firstFocusableChild = getNextElement(root.current, root.current.firstChild, false, false, false, true, undefined, undefined, undefined, inShadow);
    }
    if (firstFocusableChild) {
      focusElementAsync(firstFocusableChild);
    }
  });
  var focusBumper = function(isFirstBumper) {
    if (disabled || !root.current) {
      return;
    }
    var nextFocusable = isFirstBumper === internalState.hasFocus ? getLastTabbable(root.current, lastBumper.current, true, false, inShadow) : getFirstTabbable(root.current, firstBumper.current, true, false, inShadow);
    if (nextFocusable) {
      if (nextFocusable === firstBumper.current || nextFocusable === lastBumper.current) {
        focusFTZ();
      } else {
        nextFocusable.focus();
      }
    }
  };
  var onRootBlurCapture = function(ev) {
    var _a2;
    (_a2 = props.onBlurCapture) === null || _a2 === undefined ? undefined : _a2.call(props, ev);
    var relatedTarget = ev.relatedTarget;
    if (ev.relatedTarget === null) {
      relatedTarget = getActiveElement(doc);
    }
    if (!elementContains$1(root.current, relatedTarget)) {
      internalState.hasFocus = false;
    }
  };
  var onRootFocusCapture = function(ev) {
    var _a2;
    (_a2 = props.onFocusCapture) === null || _a2 === undefined ? undefined : _a2.call(props, ev);
    if (ev.target === firstBumper.current) {
      focusBumper(true);
    } else if (ev.target === lastBumper.current) {
      focusBumper(false);
    }
    internalState.hasFocus = true;
    if (ev.target !== ev.currentTarget && !(ev.target === firstBumper.current || ev.target === lastBumper.current)) {
      internalState.previouslyFocusedElementInTrapZone = getEventTarget(ev.nativeEvent);
    }
  };
  var returnFocusToInitiator = useEventCallback$1(function(elementToFocusOnDismiss) {
    FocusTrapZone.focusStack = FocusTrapZone.focusStack.filter(function(value) {
      return internalState.focusStackId !== value;
    });
    if (!doc) {
      return;
    }
    var activeElement = doc.activeElement;
    if (!disableRestoreFocus && typeof (elementToFocusOnDismiss === null || elementToFocusOnDismiss === undefined ? undefined : elementToFocusOnDismiss.focus) === "function" && // only restore focus if the current focused element is within the FTZ, or if nothing is focused
    (elementContains$1(root.current, activeElement) || activeElement === doc.body || activeElement.shadowRoot)) {
      focusElementAsync(elementToFocusOnDismiss);
    }
  });
  var forceFocusOrClickInTrap = useEventCallback$1(function(ev) {
    if (disabled) {
      return;
    }
    if (internalState.focusStackId === FocusTrapZone.focusStack.slice(-1)[0]) {
      var targetElement = getEventTarget(ev);
      if (targetElement && !elementContains$1(root.current, targetElement)) {
        if (doc && getActiveElement(doc) === doc.body) {
          setTimeout(function() {
            if (doc && getActiveElement(doc) === doc.body) {
              focusFTZ();
              internalState.hasFocus = true;
            }
          }, 0);
        } else {
          focusFTZ();
          internalState.hasFocus = true;
        }
        ev.preventDefault();
        ev.stopPropagation();
      }
    }
  });
  React.useEffect(function() {
    var disposables = [];
    if (forceFocusInsideTrap) {
      disposables.push(on(win, "focus", forceFocusOrClickInTrap, true));
    }
    if (!isClickableOutsideFocusTrap) {
      disposables.push(on(win, "click", forceFocusOrClickInTrap, true));
    }
    return function() {
      disposables.forEach(function(dispose) {
        return dispose();
      });
    };
  }, [forceFocusInsideTrap, isClickableOutsideFocusTrap, win]);
  React.useEffect(function() {
    if (disabled || !isFirstRender && !forceFocusInsideTrap || !root.current) {
      return;
    }
    FocusTrapZone.focusStack.push(internalState.focusStackId);
    var elementToFocusOnDismiss = props.elementToFocusOnDismiss || getActiveElement(doc);
    if (!disableFirstFocus && !elementContains$1(root.current, elementToFocusOnDismiss)) {
      focusFTZ();
    }
    return function() {
      return returnFocusToInitiator(elementToFocusOnDismiss);
    };
  }, [forceFocusInsideTrap, disabled]);
  React.useEffect(function() {
    if (!disabled && enableAriaHiddenSiblings) {
      var unmodalize = modalize(root.current);
      return unmodalize;
    }
  }, [disabled, enableAriaHiddenSiblings, root]);
  useUnmount(function() {
    delete internalState.previouslyFocusedElementInTrapZone;
  });
  useComponentRef$7(componentRef, internalState.previouslyFocusedElementInTrapZone, focusFTZ);
  return React.createElement(
    "div",
    __assign$2({ "aria-labelledby": props.ariaLabelledBy }, getNativeProps$1(props, divProperties), { ref: mergedRootRef, onFocusCapture: onRootFocusCapture, onBlurCapture: onRootBlurCapture }),
    React.createElement("div", __assign$2({}, bumperProps, { ref: firstBumper })),
    children,
    React.createElement("div", __assign$2({}, bumperProps, { ref: lastBumper }))
  );
});
FocusTrapZone.displayName = COMPONENT_NAME$a;
FocusTrapZone.focusStack = [];

var getClassNames$u = classNamesFunction();
var TooltipBase = /** @class */ (function (_super) {
    __extends$1(TooltipBase, _super);
    function TooltipBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderContent = function (props) {
            if (typeof props.content === 'string') {
                return React.createElement("p", { className: _this._classNames.subText }, props.content);
            }
            else {
                return React.createElement("div", { className: _this._classNames.subText }, props.content);
            }
        };
        return _this;
    }
    TooltipBase.prototype.render = function () {
        var _a = this.props, className = _a.className, calloutProps = _a.calloutProps, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, styles = _a.styles, id = _a.id, maxWidth = _a.maxWidth, _b = _a.onRenderContent, onRenderContent = _b === undefined ? this._onRenderContent : _b, targetElement = _a.targetElement, theme = _a.theme;
        this._classNames = getClassNames$u(styles, {
            theme: theme,
            className: className || (calloutProps && calloutProps.className),
            beakWidth: calloutProps && calloutProps.isBeakVisible ? calloutProps.beakWidth : 0,
            gapSpace: calloutProps && calloutProps.gapSpace,
            maxWidth: maxWidth,
        });
        return (React.createElement(Callout, __assign$2({ target: targetElement, directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL }, calloutProps, getNativeProps$1(this.props, divProperties, ['id']), { className: this._classNames.root }),
            React.createElement("div", { className: this._classNames.content, id: id, onFocus: this.props.onFocus, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave }, onRenderContent(this.props, this._onRenderContent))));
    };
    // Specify default props values
    TooltipBase.defaultProps = {
        directionalHint: DirectionalHint.topCenter,
        maxWidth: '364px',
        calloutProps: {
            isBeakVisible: true,
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false,
        },
    };
    return TooltipBase;
}(React.Component));

var getStyles$w = function(props) {
  var className = props.className, _a = props.beakWidth, beakWidth = _a === undefined ? 16 : _a, _b = props.gapSpace, gapSpace = _b === undefined ? 0 : _b, maxWidth = props.maxWidth, theme = props.theme;
  var semanticColors = theme.semanticColors, fonts = theme.fonts, effects = theme.effects;
  var tooltipGapSpace = -(Math.sqrt(beakWidth * beakWidth / 2) + gapSpace) + 1 / // There isn't really a great way to pass in a `window` reference here so disabling the line rule
  // eslint-disable-next-line no-restricted-globals
  window.devicePixelRatio;
  return {
    root: [
      "ms-Tooltip",
      theme.fonts.medium,
      AnimationClassNames.fadeIn200,
      {
        background: semanticColors.menuBackground,
        boxShadow: effects.elevation8,
        padding: "8px",
        maxWidth,
        selectors: {
          ":after": {
            content: "''",
            position: "absolute",
            bottom: tooltipGapSpace,
            left: tooltipGapSpace,
            right: tooltipGapSpace,
            top: tooltipGapSpace,
            zIndex: 0
          }
        }
      },
      className
    ],
    content: [
      "ms-Tooltip-content",
      fonts.small,
      {
        position: "relative",
        zIndex: 1,
        color: semanticColors.menuItemText,
        wordWrap: "break-word",
        overflowWrap: "break-word",
        overflow: "hidden"
      }
    ],
    subText: [
      "ms-Tooltip-subtext",
      {
        // Using inherit here to avoid unintentional global overrides of the <p> tag.
        fontSize: "inherit",
        fontWeight: "inherit",
        color: "inherit",
        margin: 0
      }
    ]
  };
};

var Tooltip$1 = styled(TooltipBase, getStyles$w, undefined, {
    scope: 'Tooltip',
});

/**
 * {@docCategory Tooltip}
 */
var TooltipDelay;
(function (TooltipDelay) {
    TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
    /** 300 ms delay before showing the tooltip */
    TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
    /** 500 ms delay before showing the tooltip */
    TooltipDelay[TooltipDelay["long"] = 2] = "long";
})(TooltipDelay || (TooltipDelay = {}));

/**
 * {@docCategory Tooltip}
 */
var TooltipOverflowMode;
(function (TooltipOverflowMode) {
    /** Only show tooltip if parent DOM element is overflowing */
    TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
    /**
     * Only show tooltip if tooltip host's content is overflowing.
     * Note that this does not check the children for overflow, only the TooltipHost root.
     */
    TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
})(TooltipOverflowMode || (TooltipOverflowMode = {}));

var getClassNames$t = classNamesFunction();
var TooltipHostBase = /** @class */ (function (_super) {
    __extends$1(TooltipHostBase, _super);
    // Constructor
    function TooltipHostBase(props) {
        var _this = _super.call(this, props) || this;
        // The wrapping div that gets the hover events
        _this._tooltipHost = React.createRef();
        _this._defaultTooltipId = getId('tooltip');
        _this.show = function () {
            _this._toggleTooltip(true);
        };
        _this.dismiss = function () {
            _this._hideTooltip();
        };
        _this._getTargetElement = function () {
            if (!_this._tooltipHost.current) {
                return undefined;
            }
            var overflowMode = _this.props.overflowMode;
            // Select target element based on overflow mode. For parent mode, you want to position the tooltip relative
            // to the parent element, otherwise it might look off.
            if (overflowMode !== undefined) {
                switch (overflowMode) {
                    case TooltipOverflowMode.Parent:
                        return _this._tooltipHost.current.parentElement;
                    case TooltipOverflowMode.Self:
                        return _this._tooltipHost.current;
                }
            }
            return _this._tooltipHost.current;
        };
        _this._onTooltipFocus = function (ev) {
            if (_this._ignoreNextFocusEvent) {
                _this._ignoreNextFocusEvent = false;
                return;
            }
            _this._onTooltipMouseEnter(ev);
        };
        _this._onTooltipContentFocus = function (ev) {
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) {
                TooltipHostBase._currentVisibleTooltip.dismiss();
            }
            TooltipHostBase._currentVisibleTooltip = _this;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
        };
        _this._onTooltipBlur = function (ev) {
            var _a;
            // The focused element gets a blur event when the document loses focus
            // (e.g. switching tabs in the browser), but we don't want to show the
            // tooltip again when the document gets focus back. Handle this case by
            // checking if the blurred element is still the document's activeElement,
            // and ignoring when it next gets focus back.
            // See https://github.com/microsoft/fluentui/issues/13541
            _this._ignoreNextFocusEvent = ((_a = getDocumentEx(_this.context)) === null || _a === undefined ? undefined : _a.activeElement) === ev.target;
            _this._dismissTimerId = _this._async.setTimeout(function () {
                _this._hideTooltip();
            }, 0);
        };
        // Show Tooltip
        _this._onTooltipMouseEnter = function (ev) {
            var _a = _this.props, overflowMode = _a.overflowMode, delay = _a.delay;
            var doc = getDocumentEx(_this.context);
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) {
                TooltipHostBase._currentVisibleTooltip.dismiss();
            }
            TooltipHostBase._currentVisibleTooltip = _this;
            if (overflowMode !== undefined) {
                var overflowElement = _this._getTargetElement();
                if (overflowElement && !hasOverflow(overflowElement)) {
                    return;
                }
            }
            if (ev.target && portalContainsElement(ev.target, _this._getTargetElement(), doc)) {
                // Do not show tooltip when target is inside a portal relative to TooltipHost.
                return;
            }
            _this._clearDismissTimer();
            _this._clearOpenTimer();
            if (delay !== TooltipDelay.zero) {
                var delayTime = _this._getDelayTime(delay); // non-null assertion because we set it in `defaultProps`
                _this._openTimerId = _this._async.setTimeout(function () {
                    _this._toggleTooltip(true);
                }, delayTime);
            }
            else {
                _this._toggleTooltip(true);
            }
        };
        // Hide Tooltip
        _this._onTooltipMouseLeave = function (ev) {
            var closeDelay = _this.props.closeDelay;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
            if (closeDelay) {
                _this._dismissTimerId = _this._async.setTimeout(function () {
                    _this._toggleTooltip(false);
                }, closeDelay);
            }
            else {
                _this._toggleTooltip(false);
            }
            if (TooltipHostBase._currentVisibleTooltip === _this) {
                TooltipHostBase._currentVisibleTooltip = undefined;
            }
        };
        _this._onTooltipKeyDown = function (ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if ((ev.which === KeyCodes.escape || ev.ctrlKey) && _this.state.isTooltipVisible) {
                _this._hideTooltip();
                ev.stopPropagation();
            }
        };
        _this._clearDismissTimer = function () {
            _this._async.clearTimeout(_this._dismissTimerId);
        };
        _this._clearOpenTimer = function () {
            _this._async.clearTimeout(_this._openTimerId);
        };
        // Hide Tooltip
        _this._hideTooltip = function () {
            _this._clearOpenTimer();
            _this._clearDismissTimer();
            _this._toggleTooltip(false);
        };
        _this._toggleTooltip = function (isTooltipVisible) {
            if (_this.state.isTooltipVisible !== isTooltipVisible) {
                _this.setState({ isTooltipVisible: isTooltipVisible }, function () { return _this.props.onTooltipToggle && _this.props.onTooltipToggle(isTooltipVisible); });
            }
        };
        _this._getDelayTime = function (delay) {
            switch (delay) {
                case TooltipDelay.medium:
                    return 300;
                case TooltipDelay.long:
                    return 500;
                default:
                    return 0;
            }
        };
        initializeComponentRef(_this);
        _this.state = {
            isAriaPlaceholderRendered: false,
            isTooltipVisible: false,
        };
        return _this;
    }
    // Render
    TooltipHostBase.prototype.render = function () {
        var _a = this.props, calloutProps = _a.calloutProps, children = _a.children, content = _a.content, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, className = _a.hostClassName, id = _a.id, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        _b = _a.setAriaDescribedBy, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        setAriaDescribedBy = _b === undefined ? true : _b, tooltipProps = _a.tooltipProps, styles = _a.styles, theme = _a.theme;
        this._classNames = getClassNames$t(styles, {
            theme: theme,
            className: className,
        });
        var isTooltipVisible = this.state.isTooltipVisible;
        var tooltipId = id || this._defaultTooltipId;
        var tooltipRenderProps = __assign$2(__assign$2({ id: "".concat(tooltipId, "--tooltip"), content: content, targetElement: this._getTargetElement(), directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL, calloutProps: assign$2({}, calloutProps, {
                onDismiss: this._hideTooltip,
                onFocus: this._onTooltipContentFocus,
                onMouseEnter: this._onTooltipMouseEnter,
                onMouseLeave: this._onTooltipMouseLeave,
            }), onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave }, getNativeProps$1(this.props, divProperties, ['id'])), tooltipProps);
        // Get the content of the tooltip for use in the hidden div used for screen readers
        var tooltipContent = (tooltipProps === null || tooltipProps === undefined ? undefined : tooltipProps.onRenderContent)
            ? tooltipProps.onRenderContent(tooltipRenderProps, function (props) { return ((props === null || props === undefined ? undefined : props.content) ? React.createElement(React.Fragment, null, props.content) : null); })
            : content;
        var showTooltip = isTooltipVisible && !!tooltipContent;
        var ariaDescribedBy = setAriaDescribedBy && isTooltipVisible && !!tooltipContent ? tooltipId : undefined;
        return (React.createElement("div", { className: this._classNames.root, ref: this._tooltipHost, onFocusCapture: this._onTooltipFocus, onBlurCapture: this._onTooltipBlur, onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave, onKeyDown: this._onTooltipKeyDown, role: "none", "aria-describedby": ariaDescribedBy },
            children,
            showTooltip && React.createElement(Tooltip$1, __assign$2({}, tooltipRenderProps)),
            React.createElement("div", { hidden: true, id: tooltipId, style: hiddenContentStyle }, tooltipContent)));
    };
    TooltipHostBase.prototype.componentDidMount = function () {
        this._async = new Async(this);
    };
    TooltipHostBase.prototype.componentWillUnmount = function () {
        if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip === this) {
            TooltipHostBase._currentVisibleTooltip = undefined;
        }
        this._async.dispose();
    };
    TooltipHostBase.defaultProps = {
        delay: TooltipDelay.medium,
    };
    TooltipHostBase.contextType = WindowContext;
    return TooltipHostBase;
}(React.Component));

var GlobalClassNames$i = {
    root: 'ms-TooltipHost',
    ariaPlaceholder: 'ms-TooltipHost-aria-placeholder',
};
var getStyles$v = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$i, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'inline',
            },
            className,
        ],
    };
};

var TooltipHost = styled(TooltipHostBase, getStyles$v, undefined, {
    scope: 'TooltipHost',
});

/**
 * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
 * {@docCategory Icon}
 */
var IconType;
(function (IconType) {
    /**
     * Render using the fabric icon font.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */
    IconType[IconType["default"] = 0] = "default";
    /**
     * Render using an image, where imageProps would be used.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */
    IconType[IconType["image"] = 1] = "image";
    /**
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */
    IconType[IconType["Default"] = 100000] = "Default";
    /**
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */
    IconType[IconType["Image"] = 100001] = "Image";
})(IconType || (IconType = {}));

/**
 * The possible methods that can be used to fit the image.
 * {@docCategory Image}
 */
var ImageFit;
(function (ImageFit) {
    /**
     * The image is not scaled. The image is centered and cropped within the content box.
     */
    ImageFit[ImageFit["center"] = 0] = "center";
    /**
     * The image is scaled to maintain its aspect ratio while being fully contained within the frame. The image will
     * be centered horizontally and vertically within the frame. The space in the top and bottom or in the sides of
     * the frame will be empty depending on the difference in aspect ratio between the image and the frame.
     */
    ImageFit[ImageFit["contain"] = 1] = "contain";
    /**
     * The image is scaled to maintain its aspect ratio while filling the frame. Portions of the image will be cropped
     * from the top and bottom, or the sides, depending on the difference in aspect ratio between the image and the frame.
     */
    ImageFit[ImageFit["cover"] = 2] = "cover";
    /**
     * Neither the image nor the frame are scaled. If their sizes do not match, the image will either be cropped or the
     * frame will have empty space.
     */
    ImageFit[ImageFit["none"] = 3] = "none";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height or width is less than the Image frame's height or width,
     * but if both natural height and width are larger than the frame it will behave as ImageFit.cover.
     */
    ImageFit[ImageFit["centerCover"] = 4] = "centerCover";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height and width is less than the Image frame's height and width,
     * but if either natural height or width are larger than the frame it will behave as ImageFit.contain.
     */
    ImageFit[ImageFit["centerContain"] = 5] = "centerContain";
})(ImageFit || (ImageFit = {}));
/**
 * The cover style to be used on the image
 * {@docCategory Image}
 */
var ImageCoverStyle;
(function (ImageCoverStyle) {
    /**
     * The image will be shown at 100% height of container and the width will be scaled accordingly
     */
    ImageCoverStyle[ImageCoverStyle["landscape"] = 0] = "landscape";
    /**
     * The image will be shown at 100% width of container and the height will be scaled accordingly
     */
    ImageCoverStyle[ImageCoverStyle["portrait"] = 1] = "portrait";
})(ImageCoverStyle || (ImageCoverStyle = {}));
/**
 * {@docCategory Image}
 */
var ImageLoadState;
(function (ImageLoadState) {
    /**
     * The image has not yet been loaded, and there is no error yet.
     */
    ImageLoadState[ImageLoadState["notLoaded"] = 0] = "notLoaded";
    /**
     * The image has been loaded successfully.
     */
    ImageLoadState[ImageLoadState["loaded"] = 1] = "loaded";
    /**
     * An error has been encountered while loading the image.
     */
    ImageLoadState[ImageLoadState["error"] = 2] = "error";
    /**
     * @deprecated Not used. Use `onLoadingStateChange` and re-render the Image with a different src.
     */
    ImageLoadState[ImageLoadState["errorLoaded"] = 3] = "errorLoaded";
})(ImageLoadState || (ImageLoadState = {}));

var getClassNames$s = classNamesFunction();
var SVG_REGEX = /\.svg$/i;
var KEY_PREFIX = 'fabricImage';
function useLoadState(props, imageElement) {
    var onLoadingStateChange = props.onLoadingStateChange, onLoad = props.onLoad, onError = props.onError, src = props.src;
    var _a = React.useState(ImageLoadState.notLoaded), loadState = _a[0], setLoadState = _a[1];
    useIsomorphicLayoutEffect$1(function () {
        // If the src property changes, reset the load state
        // (does nothing if the load state is already notLoaded)
        setLoadState(ImageLoadState.notLoaded);
    }, [src]);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intended to run every render
    React.useEffect(function () {
        if (loadState === ImageLoadState.notLoaded) {
            // testing if naturalWidth and naturalHeight are greater than zero is better than checking
            // .complete, because .complete will also be set to true if the image breaks. However,
            // for some browsers, SVG images do not have a naturalWidth or naturalHeight, so fall back
            // to checking .complete for these images.
            var isLoaded = imageElement.current
                ? (src && imageElement.current.naturalWidth > 0 && imageElement.current.naturalHeight > 0) ||
                    (imageElement.current.complete && SVG_REGEX.test(src))
                : false;
            if (isLoaded) {
                setLoadState(ImageLoadState.loaded);
            }
        }
    });
    React.useEffect(function () {
        onLoadingStateChange === null || onLoadingStateChange === undefined ? undefined : onLoadingStateChange(loadState);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when loadState changes
    }, [loadState]);
    var onImageLoaded = React.useCallback(function (ev) {
        onLoad === null || onLoad === undefined ? undefined : onLoad(ev);
        if (src) {
            setLoadState(ImageLoadState.loaded);
        }
    }, [src, onLoad]);
    var onImageError = React.useCallback(function (ev) {
        onError === null || onError === undefined ? undefined : onError(ev);
        setLoadState(ImageLoadState.error);
    }, [onError]);
    return [loadState, onImageLoaded, onImageError];
}
var ImageBase = React.forwardRef(function (props, forwardedRef) {
    var frameElement = React.useRef();
    var imageElement = React.useRef();
    var _a = useLoadState(props, imageElement), loadState = _a[0], onImageLoaded = _a[1], onImageError = _a[2];
    var imageProps = getNativeProps$1(props, imgProperties$1, [
        'width',
        'height',
    ]);
    var src = props.src, alt = props.alt, width = props.width, height = props.height, _b = props.shouldFadeIn, shouldFadeIn = _b === undefined ? true : _b, shouldStartVisible = props.shouldStartVisible, className = props.className, imageFit = props.imageFit, role = props.role, maximizeFrame = props.maximizeFrame, styles = props.styles, theme = props.theme, loading = props.loading;
    var coverStyle = useCoverStyle(props, loadState, imageElement, frameElement);
    var classNames = getClassNames$s(styles, {
        theme: theme,
        className: className,
        width: width,
        height: height,
        maximizeFrame: maximizeFrame,
        shouldFadeIn: shouldFadeIn,
        shouldStartVisible: shouldStartVisible,
        isLoaded: loadState === ImageLoadState.loaded || (loadState === ImageLoadState.notLoaded && props.shouldStartVisible),
        isLandscape: coverStyle === ImageCoverStyle.landscape,
        isCenter: imageFit === ImageFit.center,
        isCenterContain: imageFit === ImageFit.centerContain,
        isCenterCover: imageFit === ImageFit.centerCover,
        isContain: imageFit === ImageFit.contain,
        isCover: imageFit === ImageFit.cover,
        isNone: imageFit === ImageFit.none,
        isError: loadState === ImageLoadState.error,
        isNotImageFit: imageFit === undefined,
    });
    // If image dimensions aren't specified, the natural size of the image is used.
    return (React.createElement("div", { className: classNames.root, style: { width: width, height: height }, ref: frameElement },
        React.createElement("img", __assign$2({}, imageProps, { onLoad: onImageLoaded, onError: onImageError, key: KEY_PREFIX + props.src || '', className: classNames.image, ref: useMergedRefs$1(imageElement, forwardedRef), src: src, alt: alt, role: role, loading: loading }))));
});
ImageBase.displayName = 'ImageBase';
function useCoverStyle(props, loadState, imageElement, frameElement) {
    var previousLoadState = React.useRef(loadState);
    var coverStyle = React.useRef();
    if (coverStyle === undefined ||
        (previousLoadState.current === ImageLoadState.notLoaded && loadState === ImageLoadState.loaded)) {
        coverStyle.current = computeCoverStyle(props, loadState, imageElement, frameElement);
    }
    previousLoadState.current = loadState;
    return coverStyle.current;
}
function computeCoverStyle(props, loadState, imageElement, frameElement) {
    var imageFit = props.imageFit, width = props.width, height = props.height;
    // Do not compute cover style if it was already specified in props
    if (props.coverStyle !== undefined) {
        return props.coverStyle;
    }
    else if (loadState === ImageLoadState.loaded &&
        (imageFit === ImageFit.cover ||
            imageFit === ImageFit.contain ||
            imageFit === ImageFit.centerContain ||
            imageFit === ImageFit.centerCover) &&
        imageElement.current &&
        frameElement.current) {
        // Determine the desired ratio using the width and height props.
        // If those props aren't available, measure measure the frame.
        var desiredRatio = undefined;
        if (typeof width === 'number' &&
            typeof height === 'number' &&
            imageFit !== ImageFit.centerContain &&
            imageFit !== ImageFit.centerCover) {
            desiredRatio = width / height;
        }
        else {
            desiredRatio = frameElement.current.clientWidth / frameElement.current.clientHeight;
        }
        // Examine the source image to determine its original ratio.
        var naturalRatio = imageElement.current.naturalWidth / imageElement.current.naturalHeight;
        // Should we crop from the top or the sides?
        if (naturalRatio > desiredRatio) {
            return ImageCoverStyle.landscape;
        }
    }
    return ImageCoverStyle.portrait;
}

var GlobalClassNames$h = {
    root: 'ms-Image',
    rootMaximizeFrame: 'ms-Image--maximizeFrame',
    image: 'ms-Image-image',
    imageCenter: 'ms-Image-image--center',
    imageContain: 'ms-Image-image--contain',
    imageCover: 'ms-Image-image--cover',
    imageCenterContain: 'ms-Image-image--centerContain',
    imageCenterCover: 'ms-Image-image--centerCover',
    imageNone: 'ms-Image-image--none',
    imageLandscape: 'ms-Image-image--landscape',
    imagePortrait: 'ms-Image-image--portrait',
};
var getStyles$u = function (props) {
    var className = props.className, width = props.width, height = props.height, maximizeFrame = props.maximizeFrame, isLoaded = props.isLoaded, shouldFadeIn = props.shouldFadeIn, shouldStartVisible = props.shouldStartVisible, isLandscape = props.isLandscape, isCenter = props.isCenter, isContain = props.isContain, isCover = props.isCover, isCenterContain = props.isCenterContain, isCenterCover = props.isCenterCover, isNone = props.isNone, isError = props.isError, isNotImageFit = props.isNotImageFit, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$h, theme);
    var ImageFitStyles = {
        position: 'absolute',
        left: '50% /* @noflip */',
        top: '50%',
        transform: 'translate(-50%,-50%)', // @todo test RTL renders transform: translate(50%,-50%);
    };
    // Cut the mustard using msMaxTouchPoints to detect IE11 which does not support CSS object-fit
    var window = getWindow$2();
    var supportsObjectFit = window !== undefined &&
        // eslint-disable-next-line @fluentui/max-len
        // cast needed as vendor prefixed `msMaxTouchPoints` api is no longer part of TS lib declaration - introduced with TS 4.4
        window.navigator.msMaxTouchPoints === undefined;
    var fallbackObjectFitStyles = (isContain && isLandscape) || (isCover && !isLandscape)
        ? { width: '100%', height: 'auto' }
        : { width: 'auto', height: '100%' };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                overflow: 'hidden',
            },
            maximizeFrame && [
                classNames.rootMaximizeFrame,
                {
                    height: '100%',
                    width: '100%',
                },
            ],
            isLoaded && shouldFadeIn && !shouldStartVisible && AnimationClassNames.fadeIn400,
            (isCenter || isContain || isCover || isCenterContain || isCenterCover) && {
                position: 'relative',
            },
            className,
        ],
        image: [
            classNames.image,
            {
                display: 'block',
                opacity: 0,
            },
            isLoaded && [
                'is-loaded',
                {
                    opacity: 1,
                },
            ],
            isCenter && [classNames.imageCenter, ImageFitStyles],
            isContain && [
                classNames.imageContain,
                supportsObjectFit && {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                !supportsObjectFit && ImageFitStyles,
            ],
            isCover && [
                classNames.imageCover,
                supportsObjectFit && {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                !supportsObjectFit && ImageFitStyles,
            ],
            isCenterContain && [
                classNames.imageCenterContain,
                isLandscape && {
                    maxWidth: '100%',
                },
                !isLandscape && {
                    maxHeight: '100%',
                },
                ImageFitStyles,
            ],
            isCenterCover && [
                classNames.imageCenterCover,
                isLandscape && {
                    maxHeight: '100%',
                },
                !isLandscape && {
                    maxWidth: '100%',
                },
                ImageFitStyles,
            ],
            isNone && [
                classNames.imageNone,
                {
                    width: 'auto',
                    height: 'auto',
                },
            ],
            isNotImageFit && [
                !!width &&
                    !height && {
                    height: 'auto',
                    width: '100%',
                },
                !width &&
                    !!height && {
                    height: '100%',
                    width: 'auto',
                },
                !!width &&
                    !!height && {
                    height: '100%',
                    width: '100%',
                },
            ],
            isLandscape && classNames.imageLandscape,
            !isLandscape && classNames.imagePortrait,
            !isLoaded && 'is-notLoaded',
            shouldFadeIn && 'is-fadeIn',
            isError && 'is-error',
        ],
    };
};

var Image$2 = styled(ImageBase, getStyles$u, undefined, {
    scope: 'Image',
}, true);
Image$2.displayName = 'Image';

/** Class names used in themeable and non-themeable Icon components */
var classNames = mergeStyleSets({
    root: {
        display: 'inline-block',
        textDecoration: 'inherit',
    },
    placeholder: [
        'ms-Icon-placeHolder',
        {
            width: '1em',
        },
    ],
    image: [
        'ms-Icon-imageContainer',
        {
            overflow: 'hidden',
        },
    ],
});
/** Class name used only in non-themeable Icon components */
var MS_ICON = 'ms-Icon';
var getStyles$t = function (props) {
    var className = props.className, iconClassName = props.iconClassName, isPlaceholder = props.isPlaceholder, isImage = props.isImage, styles = props.styles;
    return {
        root: [
            isPlaceholder && classNames.placeholder,
            classNames.root,
            isImage && classNames.image,
            iconClassName,
            className,
            styles && styles.root,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            styles && styles.imageContainer,
        ],
    };
};

var getIconContent = memoizeFunction(function (iconName) {
    var _a = getIcon(iconName) || {
        subset: {},
        code: undefined,
    }, code = _a.code, subset = _a.subset;
    if (!code) {
        return null;
    }
    return {
        children: code,
        iconClassName: subset.className,
        fontFamily: subset.fontFace && subset.fontFace.fontFamily,
        mergeImageProps: subset.mergeImageProps,
    };
}, undefined, true /*ignoreNullOrUndefinedResult */);
/**
 * Fast icon component which only supports font glyphs (not images) and can't be targeted by customizations.
 * To style the icon, use `className` or reference `ms-Icon` in CSS.
 * {@docCategory Icon}
 */
var FontIcon = function (props) {
    var iconName = props.iconName, className = props.className, _a = props.style, style = _a === undefined ? {} : _a;
    var iconContent = getIconContent(iconName) || {};
    var iconClassName = iconContent.iconClassName, children = iconContent.children, fontFamily = iconContent.fontFamily, mergeImageProps = iconContent.mergeImageProps;
    var nativeProps = getNativeProps$1(props, htmlElementProperties$1);
    var accessibleName = props['aria-label'] || props.title;
    var containerProps = props['aria-label'] || props['aria-labelledby'] || props.title
        ? {
            role: mergeImageProps ? undefined : 'img',
        }
        : {
            'aria-hidden': true,
        };
    var finalChildren = children;
    if (mergeImageProps) {
        if (typeof children === 'object' && typeof children.props === 'object' && accessibleName) {
            finalChildren = React.cloneElement(children, { alt: accessibleName });
        }
    }
    return (React.createElement("i", __assign$2({ "data-icon-name": iconName }, containerProps, nativeProps, (mergeImageProps
        ? {
            title: undefined,
            'aria-label': undefined,
        }
        : {}), { className: css(MS_ICON, classNames.root, iconClassName, !iconName && classNames.placeholder, className), 
        // Apply the font family this way to ensure it doesn't get overridden by Fabric Core ms-Icon styles
        // https://github.com/microsoft/fluentui/issues/10449
        style: __assign$2({ fontFamily: fontFamily }, style) }), finalChildren));
};
/**
 * Memoized helper for rendering a FontIcon.
 * @param iconName - The name of the icon to use from the icon font.
 * @param className - Class name for styling the icon.
 * @param ariaLabel - Label for the icon for the benefit of screen readers.
 * {@docCategory Icon}
 */
memoizeFunction(function (iconName, className, ariaLabel) {
    return FontIcon({ iconName: iconName, className: className, 'aria-label': ariaLabel });
});

var getClassNames$r = classNamesFunction({
    // Icon is used a lot by other components.
    // It's likely to see expected cases which pass different className to the Icon.
    // Therefore setting a larger cache size.
    cacheSize: 100,
});
var IconBase = /** @class */ (function (_super) {
    __extends$1(IconBase, _super);
    function IconBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onImageLoadingStateChange = function (state) {
            if (_this.props.imageProps && _this.props.imageProps.onLoadingStateChange) {
                _this.props.imageProps.onLoadingStateChange(state);
            }
            if (state === ImageLoadState.error) {
                _this.setState({ imageLoadError: true });
            }
        };
        _this.state = {
            imageLoadError: false,
        };
        return _this;
    }
    IconBase.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, styles = _a.styles, iconName = _a.iconName, imageErrorAs = _a.imageErrorAs, theme = _a.theme;
        var isPlaceholder = typeof iconName === 'string' && iconName.length === 0;
        var isImage = 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        !!this.props.imageProps || this.props.iconType === IconType.image || this.props.iconType === IconType.Image;
        var iconContent = getIconContent(iconName) || {};
        var iconClassName = iconContent.iconClassName, iconContentChildren = iconContent.children, mergeImageProps = iconContent.mergeImageProps;
        var classNames = getClassNames$r(styles, {
            theme: theme,
            className: className,
            iconClassName: iconClassName,
            isImage: isImage,
            isPlaceholder: isPlaceholder,
        });
        var RootType = isImage ? 'span' : 'i';
        var nativeProps = getNativeProps$1(this.props, htmlElementProperties$1, [
            'aria-label',
        ]);
        var imageLoadError = this.state.imageLoadError;
        var imageProps = __assign$2(__assign$2({}, this.props.imageProps), { onLoadingStateChange: this._onImageLoadingStateChange });
        var ImageType = (imageLoadError && imageErrorAs) || Image$2;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var ariaLabel = this.props['aria-label'] || this.props.ariaLabel;
        var accessibleName = imageProps.alt || ariaLabel || this.props.title;
        var hasName = !!(accessibleName ||
            this.props['aria-labelledby'] ||
            imageProps['aria-label'] ||
            imageProps['aria-labelledby']);
        var containerProps = hasName
            ? {
                role: isImage || mergeImageProps ? undefined : 'img',
                'aria-label': isImage || mergeImageProps ? undefined : accessibleName,
            }
            : {
                'aria-hidden': true,
            };
        var finalIconContentChildren = iconContentChildren;
        if (mergeImageProps && iconContentChildren && typeof iconContentChildren === 'object' && accessibleName) {
            finalIconContentChildren = React.cloneElement(iconContentChildren, {
                alt: accessibleName,
            });
        }
        return (React.createElement(RootType, __assign$2({ "data-icon-name": iconName }, containerProps, nativeProps, (mergeImageProps
            ? {
                title: undefined,
                'aria-label': undefined,
            }
            : {}), { className: classNames.root }), isImage ? React.createElement(ImageType, __assign$2({}, imageProps)) : children || finalIconContentChildren));
    };
    return IconBase;
}(React.Component));

/**
 * Legacy Icon component which can be targeted by customization. It's recommended to use `FontIcon`
 * or `ImageIcon` instead, especially in scenarios where rendering performance is important.
 * {@docCategory Icon}
 */
var Icon = styled(IconBase, getStyles$t, undefined, {
    scope: 'Icon',
}, true);
Icon.displayName = 'Icon';

/**
 * Fast icon component which only supports images (not font glyphs) and can't be targeted by customizations.
 * To style the icon, use `className` or reference `ms-Icon` in CSS.
 * {@docCategory Icon}
 */
var ImageIcon = function (props) {
    var className = props.className, imageProps = props.imageProps;
    var nativeProps = getNativeProps$1(props, htmlElementProperties$1, [
        'aria-label',
        'aria-labelledby',
        'title',
        'aria-describedby',
    ]);
    var altText = imageProps.alt || props['aria-label'];
    var hasName = altText ||
        props['aria-labelledby'] ||
        props.title ||
        imageProps['aria-label'] ||
        imageProps['aria-labelledby'] ||
        imageProps.title;
    // move naming or describing attributes from the container (where they are invalid) to the image
    var imageNameProps = {
        'aria-labelledby': props['aria-labelledby'],
        'aria-describedby': props['aria-describedby'],
        title: props.title,
    };
    var containerProps = hasName
        ? {}
        : {
            'aria-hidden': true,
        };
    return (React.createElement("div", __assign$2({}, containerProps, nativeProps, { className: css(MS_ICON, classNames.root, classNames.image, className) }),
        React.createElement(Image$2, __assign$2({}, imageNameProps, imageProps, { alt: hasName ? altText : '' }))));
};

/**
 * {@docCategory Persona}
 */
var PersonaSize;
(function (PersonaSize) {
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size8` instead.
     */
    PersonaSize[PersonaSize["tiny"] = 0] = "tiny";
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size24` instead.
     */
    PersonaSize[PersonaSize["extraExtraSmall"] = 1] = "extraExtraSmall";
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size32` instead.
     */
    PersonaSize[PersonaSize["extraSmall"] = 2] = "extraSmall";
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size40` instead.
     */
    PersonaSize[PersonaSize["small"] = 3] = "small";
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size48` instead.
     */
    PersonaSize[PersonaSize["regular"] = 4] = "regular";
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size72` instead.
     */
    PersonaSize[PersonaSize["large"] = 5] = "large";
    /**
     * Deprecated in favor of standardized numeric sizing.
     * @deprecated Use `size100` instead.
     */
    PersonaSize[PersonaSize["extraLarge"] = 6] = "extraLarge";
    /**
     * No `PersonaCoin` is rendered.
     */
    PersonaSize[PersonaSize["size8"] = 17] = "size8";
    /**
     * No `PersonaCoin` is rendered. Deprecated to align with design specifications.
     * @deprecated Use `size8` instead.
     */
    PersonaSize[PersonaSize["size10"] = 9] = "size10";
    /**
     * Renders a 16px `PersonaCoin`.
     * @deprecated Deprecated due to not being in the design specification.
     */
    PersonaSize[PersonaSize["size16"] = 8] = "size16";
    /**
     * Renders a 24px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size24"] = 10] = "size24";
    /**
     * Renders a 28px `PersonaCoin`.
     * @deprecated Deprecated due to not being in the design specification.
     */
    PersonaSize[PersonaSize["size28"] = 7] = "size28";
    /**
     * Renders a 32px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size32"] = 11] = "size32";
    /**
     * Renders a 40px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size40"] = 12] = "size40";
    /**
     * Renders a 48px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size48"] = 13] = "size48";
    /**
     * Renders a 56px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size56"] = 16] = "size56";
    /**
     * Renders a 72px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size72"] = 14] = "size72";
    /**
     * Renders a 100px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size100"] = 15] = "size100";
    /**
     * Renders a 120px `PersonaCoin`.
     */
    PersonaSize[PersonaSize["size120"] = 18] = "size120";
})(PersonaSize || (PersonaSize = {}));
/**
 * {@docCategory Persona}
 */
var PersonaPresence$1;
(function (PersonaPresence) {
    PersonaPresence[PersonaPresence["none"] = 0] = "none";
    PersonaPresence[PersonaPresence["offline"] = 1] = "offline";
    PersonaPresence[PersonaPresence["online"] = 2] = "online";
    PersonaPresence[PersonaPresence["away"] = 3] = "away";
    PersonaPresence[PersonaPresence["dnd"] = 4] = "dnd";
    PersonaPresence[PersonaPresence["blocked"] = 5] = "blocked";
    PersonaPresence[PersonaPresence["busy"] = 6] = "busy";
})(PersonaPresence$1 || (PersonaPresence$1 = {}));
/**
 * {@docCategory Persona}
 */
var PersonaInitialsColor;
(function (PersonaInitialsColor) {
    PersonaInitialsColor[PersonaInitialsColor["lightBlue"] = 0] = "lightBlue";
    PersonaInitialsColor[PersonaInitialsColor["blue"] = 1] = "blue";
    PersonaInitialsColor[PersonaInitialsColor["darkBlue"] = 2] = "darkBlue";
    PersonaInitialsColor[PersonaInitialsColor["teal"] = 3] = "teal";
    PersonaInitialsColor[PersonaInitialsColor["lightGreen"] = 4] = "lightGreen";
    PersonaInitialsColor[PersonaInitialsColor["green"] = 5] = "green";
    PersonaInitialsColor[PersonaInitialsColor["darkGreen"] = 6] = "darkGreen";
    PersonaInitialsColor[PersonaInitialsColor["lightPink"] = 7] = "lightPink";
    PersonaInitialsColor[PersonaInitialsColor["pink"] = 8] = "pink";
    PersonaInitialsColor[PersonaInitialsColor["magenta"] = 9] = "magenta";
    PersonaInitialsColor[PersonaInitialsColor["purple"] = 10] = "purple";
    /**
     * @deprecated `black` is a color that can result in offensive persona coins with some initials combinations,
     * so it can only be set with overrides. Will be removed in a future major release.
     */
    PersonaInitialsColor[PersonaInitialsColor["black"] = 11] = "black";
    PersonaInitialsColor[PersonaInitialsColor["orange"] = 12] = "orange";
    /**
     * @deprecated `red` is a color that often has a special meaning, so it is considered a reserved color and
     * can only be set with overrides. Will be removed in a future major release.
     */
    PersonaInitialsColor[PersonaInitialsColor["red"] = 13] = "red";
    PersonaInitialsColor[PersonaInitialsColor["darkRed"] = 14] = "darkRed";
    /**
     * Transparent is not intended to be used with typical initials due to accessibility issues.
     * Its primary use is for overflow buttons, so it is considered a reserved color and can only be set with overrides.
     */
    PersonaInitialsColor[PersonaInitialsColor["transparent"] = 15] = "transparent";
    PersonaInitialsColor[PersonaInitialsColor["violet"] = 16] = "violet";
    PersonaInitialsColor[PersonaInitialsColor["lightRed"] = 17] = "lightRed";
    PersonaInitialsColor[PersonaInitialsColor["gold"] = 18] = "gold";
    PersonaInitialsColor[PersonaInitialsColor["burgundy"] = 19] = "burgundy";
    PersonaInitialsColor[PersonaInitialsColor["warmGray"] = 20] = "warmGray";
    PersonaInitialsColor[PersonaInitialsColor["coolGray"] = 21] = "coolGray";
    /**
     * `gray` is a color that can result in offensive persona coins with some initials combinations,
     * so it can only be set with overrides.
     */
    PersonaInitialsColor[PersonaInitialsColor["gray"] = 22] = "gray";
    PersonaInitialsColor[PersonaInitialsColor["cyan"] = 23] = "cyan";
    PersonaInitialsColor[PersonaInitialsColor["rust"] = 24] = "rust";
})(PersonaInitialsColor || (PersonaInitialsColor = {}));

var _a$e;
// Persona Sizes
var personaSize;
(function (personaSize) {
    personaSize.size8 = '20px';
    // TODO: remove in a future major release as it's deprecated.
    personaSize.size10 = '20px';
    // TODO: remove in a future major release as it's deprecated.
    personaSize.size16 = '16px';
    personaSize.size24 = '24px';
    // TODO: remove in a future major release as it's deprecated.
    personaSize.size28 = '28px';
    personaSize.size32 = '32px';
    personaSize.size40 = '40px';
    personaSize.size48 = '48px';
    personaSize.size56 = '56px';
    personaSize.size72 = '72px';
    personaSize.size100 = '100px';
    personaSize.size120 = '120px';
})(personaSize || (personaSize = {}));
// Persona Presence Sizes
var personaPresenceSize;
(function (personaPresenceSize) {
    personaPresenceSize.size6 = '6px';
    personaPresenceSize.size8 = '8px';
    personaPresenceSize.size12 = '12px';
    personaPresenceSize.size16 = '16px';
    personaPresenceSize.size20 = '20px';
    personaPresenceSize.size28 = '28px';
    personaPresenceSize.size32 = '32px';
    /**
     * @deprecated This is now unused
     */
    personaPresenceSize.border = '2px';
})(personaPresenceSize || (personaPresenceSize = {}));
// TODO: remove the deprecated parts in a future major release.
var sizeBoolean = function (size) { return ({
    isSize8: size === PersonaSize.size8,
    /* eslint-disable @typescript-eslint/no-deprecated */
    isSize10: size === PersonaSize.size10 || size === PersonaSize.tiny,
    isSize16: size === PersonaSize.size16,
    isSize24: size === PersonaSize.size24 || size === PersonaSize.extraExtraSmall,
    isSize28: size === PersonaSize.size28 || size === PersonaSize.extraSmall,
    isSize32: size === PersonaSize.size32,
    isSize40: size === PersonaSize.size40 || size === PersonaSize.small,
    isSize48: size === PersonaSize.size48 || size === PersonaSize.regular,
    isSize56: size === PersonaSize.size56,
    isSize72: size === PersonaSize.size72 || size === PersonaSize.large,
    isSize100: size === PersonaSize.size100 || size === PersonaSize.extraLarge,
    isSize120: size === PersonaSize.size120,
}); };
var sizeToPixels = (_a$e = {},
    // Old deprecated sizes
    _a$e[PersonaSize.tiny] = 10,
    _a$e[PersonaSize.extraExtraSmall] = 24,
    _a$e[PersonaSize.extraSmall] = 28,
    _a$e[PersonaSize.small] = 40,
    _a$e[PersonaSize.regular] = 48,
    _a$e[PersonaSize.large] = 72,
    _a$e[PersonaSize.extraLarge] = 100,
    // New sizes
    _a$e[PersonaSize.size8] = 8,
    _a$e[PersonaSize.size10] = 10, // TODO: deprecated (not in the design specs)
    _a$e[PersonaSize.size16] = 16, // TODO: deprecated (not in the design specs)
    _a$e[PersonaSize.size24] = 24,
    _a$e[PersonaSize.size28] = 28, // TODO: deprecated (not in the design specs)
    /* eslint-enable @typescript-eslint/no-deprecated */
    _a$e[PersonaSize.size32] = 32,
    _a$e[PersonaSize.size40] = 40,
    _a$e[PersonaSize.size48] = 48,
    _a$e[PersonaSize.size56] = 56,
    _a$e[PersonaSize.size72] = 72,
    _a$e[PersonaSize.size100] = 100,
    _a$e[PersonaSize.size120] = 120,
    _a$e);
var presenceBoolean = function (presence) { return ({
    isAvailable: presence === PersonaPresence$1.online,
    isAway: presence === PersonaPresence$1.away,
    isBlocked: presence === PersonaPresence$1.blocked,
    isBusy: presence === PersonaPresence$1.busy,
    isDoNotDisturb: presence === PersonaPresence$1.dnd,
    isOffline: presence === PersonaPresence$1.offline,
}); };

var coinSizeFontScaleFactor = 6;
var coinSizePresenceScaleFactor = 3;
var presenceMaxSize = 40;
var presenceFontMaxSize = 20;
var getClassNames$q = classNamesFunction({
    // There can be many PersonaPresence rendered with different sizes.
    // Therefore setting a larger cache size.
    cacheSize: 100,
});
/**
 * PersonaPresence with no default styles.
 * [Use the `getStyles` API to add your own styles.](https://github.com/microsoft/fluentui/wiki/Styling)
 */
var PersonaPresenceBase = React.forwardRef(function (props, forwardedRef) {
    var coinSize = props.coinSize, isOutOfOffice = props.isOutOfOffice, styles = props.styles, // Use getStyles from props.
    presence = props.presence, theme = props.theme, presenceTitle = props.presenceTitle, presenceColors = props.presenceColors;
    var rootRef = React.useRef(null);
    var mergedRootRef = useMergedRefs$1(forwardedRef, rootRef);
    var size = sizeBoolean(props.size);
    // Render Presence Icon if Persona is above size 32.
    var renderIcon = !(size.isSize8 || size.isSize10 || size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32) &&
        (coinSize ? coinSize > 32 : true);
    var presenceHeightWidth = coinSize
        ? coinSize / coinSizePresenceScaleFactor < presenceMaxSize
            ? coinSize / coinSizePresenceScaleFactor + 'px'
            : presenceMaxSize + 'px'
        : '';
    var presenceFontSize = coinSize
        ? coinSize / coinSizeFontScaleFactor < presenceFontMaxSize
            ? coinSize / coinSizeFontScaleFactor + 'px'
            : presenceFontMaxSize + 'px'
        : '';
    var coinSizeWithPresenceIconStyle = coinSize
        ? { fontSize: presenceFontSize, lineHeight: presenceHeightWidth }
        : undefined;
    var coinSizeWithPresenceStyle = coinSize ? { width: presenceHeightWidth, height: presenceHeightWidth } : undefined;
    // Use getStyles from props, or fall back to getStyles from styles file.
    var classNames = getClassNames$q(styles, {
        theme: theme,
        presence: presence,
        size: props.size,
        isOutOfOffice: isOutOfOffice,
        presenceColors: presenceColors,
    });
    if (presence === PersonaPresence$1.none) {
        return null;
    }
    return (React.createElement("div", { role: "presentation", className: classNames.presence, style: coinSizeWithPresenceStyle, title: presenceTitle, ref: mergedRootRef }, renderIcon && (React.createElement(Icon, { className: classNames.presenceIcon, iconName: determineIcon(props.presence, props.isOutOfOffice), style: coinSizeWithPresenceIconStyle }))));
});
PersonaPresenceBase.displayName = 'PersonaPresenceBase';
function determineIcon(presence, isOutOfOffice) {
    if (!presence) {
        return undefined;
    }
    var oofIcon = 'SkypeArrow';
    switch (PersonaPresence$1[presence]) {
        case 'online':
            return 'SkypeCheck';
        case 'away':
            return isOutOfOffice ? oofIcon : 'SkypeClock';
        case 'dnd':
            return 'SkypeMinus';
        case 'offline':
            return isOutOfOffice ? oofIcon : '';
    }
    return '';
}

var GlobalClassNames$g = {
    presence: 'ms-Persona-presence',
    presenceIcon: 'ms-Persona-presenceIcon',
};
var getStyles$s = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var theme = props.theme, presenceColors = props.presenceColors;
    var semanticColors = theme.semanticColors, fonts = theme.fonts;
    var classNames = getGlobalClassNames(GlobalClassNames$g, theme);
    var size = sizeBoolean(props.size);
    var presence = presenceBoolean(props.presence);
    // Presence colors
    var presenceColorAvailable = (presenceColors && presenceColors.available) || '#6BB700';
    var presenceColorAway = (presenceColors && presenceColors.away) || '#FFAA44';
    var presenceColorBusy = (presenceColors && presenceColors.busy) || '#C43148';
    var presenceColorDnd = (presenceColors && presenceColors.dnd) || '#C50F1F';
    var presenceColorOffline = (presenceColors && presenceColors.offline) || '#8A8886';
    var presenceColorOof = (presenceColors && presenceColors.oof) || '#B4009E';
    var presenceColorBackground = (presenceColors && presenceColors.background) || semanticColors.bodyBackground;
    var isOpenCirclePresence = presence.isOffline ||
        (props.isOutOfOffice && (presence.isAvailable || presence.isBusy || presence.isAway || presence.isDoNotDisturb));
    var borderSizeForSmallPersonas = '1px';
    var borderSizeForLargePersonas = '2px';
    var borderSize = size.isSize72 || size.isSize100 ? borderSizeForLargePersonas : borderSizeForSmallPersonas;
    return {
        presence: [
            classNames.presence,
            __assign$2(__assign$2({ position: 'absolute', height: personaPresenceSize.size12, width: personaPresenceSize.size12, borderRadius: '50%', top: 'auto', right: '-2px', bottom: '-2px', border: "2px solid ".concat(presenceColorBackground), textAlign: 'center', boxSizing: 'content-box', backgroundClip: 'border-box' }, getHighContrastNoAdjustStyle()), { selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        borderColor: 'Window',
                        backgroundColor: 'WindowText',
                    },
                    _a) }),
            (size.isSize8 || size.isSize10) && {
                right: 'auto',
                top: '7px',
                left: 0,
                border: 0,
                selectors: (_b = {},
                    _b[HighContrastSelector] = {
                        top: '9px',
                        border: '1px solid WindowText',
                    },
                    _b),
            },
            (size.isSize8 || size.isSize10 || size.isSize24 || size.isSize28 || size.isSize32) &&
                makeSizeStyle(personaPresenceSize.size8),
            (size.isSize40 || size.isSize48) && makeSizeStyle(personaPresenceSize.size12),
            size.isSize16 && {
                height: personaPresenceSize.size6,
                width: personaPresenceSize.size6,
                borderWidth: '1.5px',
            },
            size.isSize56 && makeSizeStyle(personaPresenceSize.size16),
            size.isSize72 && makeSizeStyle(personaPresenceSize.size20),
            size.isSize100 && makeSizeStyle(personaPresenceSize.size28),
            size.isSize120 && makeSizeStyle(personaPresenceSize.size32),
            presence.isAvailable && {
                backgroundColor: presenceColorAvailable,
                selectors: (_c = {},
                    _c[HighContrastSelector] = backgroundColor('Highlight'),
                    _c),
            },
            presence.isAway && backgroundColor(presenceColorAway),
            presence.isBlocked && [
                {
                    selectors: (_d = {
                            // Only show :after at larger sizes
                            ':after': size.isSize40 || size.isSize48 || size.isSize72 || size.isSize100
                                ? {
                                    content: '""',
                                    width: '100%',
                                    height: borderSize,
                                    backgroundColor: presenceColorBusy,
                                    transform: 'translateY(-50%) rotate(-45deg)',
                                    position: 'absolute',
                                    top: '50%',
                                    left: 0,
                                }
                                : undefined
                        },
                        _d[HighContrastSelector] = {
                            selectors: {
                                ':after': {
                                    width: "calc(100% - 4px)",
                                    left: '2px',
                                    backgroundColor: 'Window',
                                },
                            },
                        },
                        _d),
                },
            ],
            presence.isBusy && backgroundColor(presenceColorBusy),
            presence.isDoNotDisturb && backgroundColor(presenceColorDnd),
            presence.isOffline && backgroundColor(presenceColorOffline),
            (isOpenCirclePresence || presence.isBlocked) && [
                {
                    backgroundColor: presenceColorBackground,
                    selectors: (_e = {
                            ':before': {
                                content: '""',
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                border: "".concat(borderSize, " solid ").concat(presenceColorBusy),
                                borderRadius: '50%',
                                boxSizing: 'border-box',
                            }
                        },
                        _e[HighContrastSelector] = {
                            backgroundColor: 'WindowText',
                            selectors: {
                                ':before': {
                                    width: "calc(100% - 2px)",
                                    height: "calc(100% - 2px)",
                                    top: '1px',
                                    left: '1px',
                                    borderColor: 'Window',
                                },
                            },
                        },
                        _e),
                },
            ],
            isOpenCirclePresence && presence.isAvailable && makeBeforeBorderStyle(borderSize, presenceColorAvailable),
            isOpenCirclePresence && presence.isBusy && makeBeforeBorderStyle(borderSize, presenceColorBusy),
            isOpenCirclePresence && presence.isAway && makeBeforeBorderStyle(borderSize, presenceColorOof),
            isOpenCirclePresence && presence.isDoNotDisturb && makeBeforeBorderStyle(borderSize, presenceColorDnd),
            isOpenCirclePresence && presence.isOffline && makeBeforeBorderStyle(borderSize, presenceColorOffline),
            isOpenCirclePresence &&
                presence.isOffline &&
                props.isOutOfOffice &&
                makeBeforeBorderStyle(borderSize, presenceColorOof),
        ],
        presenceIcon: [
            classNames.presenceIcon,
            {
                color: presenceColorBackground,
                fontSize: '6px', // exception case where we don't have an available theme.fonts variable to match it.
                lineHeight: personaPresenceSize.size12,
                verticalAlign: 'top',
                selectors: (_f = {},
                    _f[HighContrastSelector] = {
                        color: 'Window',
                    },
                    _f),
            },
            size.isSize56 && {
                fontSize: '8px', // exception case where we don't have an available theme.fonts variable to match it.
                lineHeight: personaPresenceSize.size16,
            },
            size.isSize72 && {
                fontSize: fonts.small.fontSize,
                lineHeight: personaPresenceSize.size20,
            },
            size.isSize100 && {
                fontSize: fonts.medium.fontSize,
                lineHeight: personaPresenceSize.size28,
            },
            size.isSize120 && {
                fontSize: fonts.medium.fontSize,
                lineHeight: personaPresenceSize.size32,
            },
            presence.isAway && {
                position: 'relative',
                left: isOpenCirclePresence ? undefined : '1px',
            },
            isOpenCirclePresence && presence.isAvailable && makeOpenCircleIconStyle(presenceColorAvailable),
            isOpenCirclePresence && presence.isBusy && makeOpenCircleIconStyle(presenceColorBusy),
            isOpenCirclePresence && presence.isAway && makeOpenCircleIconStyle(presenceColorOof),
            isOpenCirclePresence && presence.isDoNotDisturb && makeOpenCircleIconStyle(presenceColorDnd),
            isOpenCirclePresence && presence.isOffline && makeOpenCircleIconStyle(presenceColorOffline),
            isOpenCirclePresence && presence.isOffline && props.isOutOfOffice && makeOpenCircleIconStyle(presenceColorOof),
        ],
    };
};
function makeOpenCircleIconStyle(color) {
    return {
        color: color,
        borderColor: color,
    };
}
function makeBeforeBorderStyle(borderSize, color) {
    return {
        selectors: {
            ':before': {
                border: "".concat(borderSize, " solid ").concat(color),
            },
        },
    };
}
function makeSizeStyle(size) {
    return {
        height: size,
        width: size,
    };
}
function backgroundColor(color) {
    return { backgroundColor: color };
}

/**
 * PersonaPresence is used to render an individual's presence.
 */
var PersonaPresence = styled(PersonaPresenceBase, getStyles$s, undefined, { scope: 'PersonaPresence' });

/**
 * Following colors are considered reserved and can only be set with overrides, so they are excluded from this set:
 * - `gray` and `black` can result in offensive persona coins with some initials combinations
 * - `red` often has a special meaning
 * - `transparent` is not intended to be used with typical initials due to accessibility issues;
 *   its primary use is for Facepile overflow buttons.
 */
var COLOR_SWATCHES_LOOKUP = [
    PersonaInitialsColor.lightBlue,
    PersonaInitialsColor.blue,
    PersonaInitialsColor.darkBlue,
    PersonaInitialsColor.teal,
    PersonaInitialsColor.green,
    PersonaInitialsColor.darkGreen,
    PersonaInitialsColor.lightPink,
    PersonaInitialsColor.pink,
    PersonaInitialsColor.magenta,
    PersonaInitialsColor.purple,
    PersonaInitialsColor.orange,
    PersonaInitialsColor.lightRed,
    PersonaInitialsColor.darkRed,
    PersonaInitialsColor.violet,
    PersonaInitialsColor.gold,
    PersonaInitialsColor.burgundy,
    PersonaInitialsColor.warmGray,
    PersonaInitialsColor.cyan,
    PersonaInitialsColor.rust,
    PersonaInitialsColor.coolGray,
];
var COLOR_SWATCHES_NUM_ENTRIES = COLOR_SWATCHES_LOOKUP.length;
function getInitialsColorFromName(displayName) {
    var color = PersonaInitialsColor.blue;
    if (!displayName) {
        return color;
    }
    var hashCode = 0;
    for (var iLen = displayName.length - 1; iLen >= 0; iLen--) {
        var ch = displayName.charCodeAt(iLen);
        var shift = iLen % 8;
        // eslint-disable-next-line no-bitwise
        hashCode ^= (ch << shift) + (ch >> (8 - shift));
    }
    color = COLOR_SWATCHES_LOOKUP[hashCode % COLOR_SWATCHES_NUM_ENTRIES];
    return color;
}
function personaInitialsColorToHexCode(personaInitialsColor) {
    switch (personaInitialsColor) {
        case PersonaInitialsColor.lightBlue:
            return '#4F6BED';
        case PersonaInitialsColor.blue:
            return '#0078D4';
        case PersonaInitialsColor.darkBlue:
            return '#004E8C';
        case PersonaInitialsColor.teal:
            return '#038387';
        case PersonaInitialsColor.lightGreen:
        case PersonaInitialsColor.green:
            return '#498205';
        case PersonaInitialsColor.darkGreen:
            return '#0B6A0B';
        case PersonaInitialsColor.lightPink:
            return '#C239B3';
        case PersonaInitialsColor.pink:
            return '#E3008C';
        case PersonaInitialsColor.magenta:
            return '#881798';
        case PersonaInitialsColor.purple:
            return '#5C2E91';
        case PersonaInitialsColor.orange:
            return '#CA5010';
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        case PersonaInitialsColor.red:
            return '#EE1111';
        case PersonaInitialsColor.lightRed:
            return '#D13438';
        case PersonaInitialsColor.darkRed:
            return '#A4262C';
        case PersonaInitialsColor.transparent:
            return 'transparent';
        case PersonaInitialsColor.violet:
            return '#8764B8';
        case PersonaInitialsColor.gold:
            return '#986F0B';
        case PersonaInitialsColor.burgundy:
            return '#750B1C';
        case PersonaInitialsColor.warmGray:
            return '#7A7574';
        case PersonaInitialsColor.cyan:
            return '#005B70';
        case PersonaInitialsColor.rust:
            return '#8E562E';
        case PersonaInitialsColor.coolGray:
            return '#69797E';
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        case PersonaInitialsColor.black:
            return '#1D1D1D';
        case PersonaInitialsColor.gray:
            return '#393939';
    }
}
/**
 * Gets the hex color string (prefixed with #) for the given persona props.
 * This is the logic used internally by the Persona control.
 * @param props - Current persona props
 * @returns Hex color string prefixed with #
 */
function getPersonaInitialsColor(props) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var primaryText = props.primaryText, text = props.text;
    var initialsColor = props.initialsColor;
    var initialsColorCode;
    if (typeof initialsColor === 'string') {
        initialsColorCode = initialsColor;
    }
    else {
        initialsColor = initialsColor !== undefined ? initialsColor : getInitialsColorFromName(text || primaryText);
        initialsColorCode = personaInitialsColorToHexCode(initialsColor);
    }
    return initialsColorCode;
}

var getClassNames$p = classNamesFunction({
    // There can be many PersonaCoin rendered with different sizes.
    // Therefore setting a larger cache size.
    cacheSize: 100,
});
var getInitialsStyles = memoizeFunction(function (className, initialsColor, initialsTextColor, text, primaryText, showUnknownPersonaCoin) {
    return mergeStyles(className, !showUnknownPersonaCoin && {
        backgroundColor: getPersonaInitialsColor({ text: text, initialsColor: initialsColor, primaryText: primaryText }),
        color: initialsTextColor,
    });
});
var DEFAULT_PROPS$6 = {
    size: PersonaSize.size48,
    presence: PersonaPresence$1.none,
    imageAlt: '',
};
function useDebugWarnings$3(props) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- build-time conditional
        useWarnings({
            name: 'PersonaCoin',
            props: props,
            deprecations: { primaryText: 'text' },
        });
    }
}
function useImageLoadState(_a) {
    var onPhotoLoadingStateChange = _a.onPhotoLoadingStateChange, imageUrl = _a.imageUrl;
    var _b = React.useState(ImageLoadState.notLoaded), imageLoadState = _b[0], setImageLoadstate = _b[1];
    React.useEffect(function () {
        setImageLoadstate(ImageLoadState.notLoaded);
    }, [imageUrl]);
    var onLoadingStateChange = function (loadState) {
        setImageLoadstate(loadState);
        onPhotoLoadingStateChange === null || onPhotoLoadingStateChange === undefined ? undefined : onPhotoLoadingStateChange(loadState);
    };
    return [imageLoadState, onLoadingStateChange];
}
/**
 * PersonaCoin with no default styles.
 * [Use the `getStyles` API to add your own styles.](https://github.com/microsoft/fluentui/wiki/Styling)
 */
var PersonaCoinBase = React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var props = getPropsWithDefaults(DEFAULT_PROPS$6, propsWithoutDefaults);
    useDebugWarnings$3(props);
    var _a = useImageLoadState(props), imageLoadState = _a[0], onLoadingStateChange = _a[1];
    var renderCoin = getCoinRenderer(onLoadingStateChange);
    var className = props.className, coinProps = props.coinProps, showUnknownPersonaCoin = props.showUnknownPersonaCoin, coinSize = props.coinSize, styles = props.styles, imageUrl = props.imageUrl, initialsColor = props.initialsColor, initialsTextColor = props.initialsTextColor, isOutOfOffice = props.isOutOfOffice, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    _b = props.onRenderCoin, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    onRenderCoin = _b === undefined ? renderCoin : _b, _c = props.onRenderPersonaCoin, onRenderPersonaCoin = _c === undefined ? onRenderCoin : _c, _d = props.onRenderInitials, onRenderInitials = _d === undefined ? renderPersonaCoinInitials : _d, presence = props.presence, presenceTitle = props.presenceTitle, presenceColors = props.presenceColors, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    primaryText = props.primaryText, showInitialsUntilImageLoads = props.showInitialsUntilImageLoads, text = props.text, theme = props.theme, size = props.size;
    var divProps = getNativeProps$1(props, divProperties);
    var divCoinProps = getNativeProps$1(coinProps || {}, divProperties);
    var coinSizeStyle = coinSize ? { width: coinSize, height: coinSize } : undefined;
    var hideImage = showUnknownPersonaCoin;
    var personaPresenceProps = {
        coinSize: coinSize,
        isOutOfOffice: isOutOfOffice,
        presence: presence,
        presenceTitle: presenceTitle,
        presenceColors: presenceColors,
        size: size,
        theme: theme,
    };
    // Use getStyles from props, or fall back to getStyles from styles file.
    var classNames = getClassNames$p(styles, {
        theme: theme,
        className: coinProps && coinProps.className ? coinProps.className : className,
        size: size,
        coinSize: coinSize,
        showUnknownPersonaCoin: showUnknownPersonaCoin,
    });
    var shouldRenderInitials = Boolean(imageLoadState !== ImageLoadState.loaded &&
        ((showInitialsUntilImageLoads && imageUrl) || !imageUrl || imageLoadState === ImageLoadState.error || hideImage));
    return (React.createElement("div", __assign$2({ role: "presentation" }, divProps, { className: classNames.coin, ref: forwardedRef }),
        // Render PersonaCoin if size is not size8. size10 and tiny need to removed after a deprecation cleanup.
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        size !== PersonaSize.size8 && size !== PersonaSize.size10 && size !== PersonaSize.tiny ? (React.createElement("div", __assign$2({ role: "presentation" }, divCoinProps, { className: classNames.imageArea, style: coinSizeStyle }),
            shouldRenderInitials && (React.createElement("div", { className: getInitialsStyles(classNames.initials, initialsColor, initialsTextColor, text, primaryText, showUnknownPersonaCoin), style: coinSizeStyle, "aria-hidden": "true" }, onRenderInitials(props, renderPersonaCoinInitials))),
            !hideImage && onRenderPersonaCoin(props, renderCoin),
            React.createElement(PersonaPresence, __assign$2({}, personaPresenceProps)))) : // Otherwise, render just PersonaPresence.
            props.presence ? (React.createElement(PersonaPresence, __assign$2({}, personaPresenceProps))) : (
            // Just render Contact Icon if there isn't a Presence prop.
            React.createElement(Icon, { iconName: "Contact", className: classNames.size10WithoutPresenceIcon })),
        props.children));
});
PersonaCoinBase.displayName = 'PersonaCoinBase';
var getCoinRenderer = function (onLoadingStateChange) {
    return function (_a) {
        var coinSize = _a.coinSize, styles = _a.styles, imageUrl = _a.imageUrl, imageAlt = _a.imageAlt, imageShouldFadeIn = _a.imageShouldFadeIn, imageShouldStartVisible = _a.imageShouldStartVisible, theme = _a.theme, showUnknownPersonaCoin = _a.showUnknownPersonaCoin, _b = _a.size, size = _b === undefined ? DEFAULT_PROPS$6.size : _b;
        // Render the Image component only if an image URL is provided
        if (!imageUrl) {
            return null;
        }
        var classNames = getClassNames$p(styles, {
            theme: theme,
            size: size,
            showUnknownPersonaCoin: showUnknownPersonaCoin,
        });
        var dimension = coinSize || sizeToPixels[size];
        return (React.createElement(Image$2, { className: classNames.image, imageFit: ImageFit.cover, src: imageUrl, width: dimension, height: dimension, alt: imageAlt, shouldFadeIn: imageShouldFadeIn, shouldStartVisible: imageShouldStartVisible, onLoadingStateChange: onLoadingStateChange }));
    };
};
var renderPersonaCoinInitials = function (_a) {
    var imageInitials = _a.imageInitials, allowPhoneInitials = _a.allowPhoneInitials, showUnknownPersonaCoin = _a.showUnknownPersonaCoin, text = _a.text, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    primaryText = _a.primaryText, theme = _a.theme;
    if (showUnknownPersonaCoin) {
        return React.createElement(Icon, { iconName: "Help" });
    }
    var isRTL = getRTL(theme);
    imageInitials = imageInitials || getInitials$1(text || primaryText || '', isRTL, allowPhoneInitials);
    return imageInitials !== '' ? React.createElement("span", null, imageInitials) : React.createElement(Icon, { iconName: "Contact" });
};

var GlobalClassNames$f = {
    coin: 'ms-Persona-coin',
    imageArea: 'ms-Persona-imageArea',
    image: 'ms-Persona-image',
    initials: 'ms-Persona-initials',
    size8: 'ms-Persona--size8',
    size10: 'ms-Persona--size10',
    size16: 'ms-Persona--size16',
    size24: 'ms-Persona--size24',
    size28: 'ms-Persona--size28',
    size32: 'ms-Persona--size32',
    size40: 'ms-Persona--size40',
    size48: 'ms-Persona--size48',
    size56: 'ms-Persona--size56',
    size72: 'ms-Persona--size72',
    size100: 'ms-Persona--size100',
    size120: 'ms-Persona--size120',
};
var getStyles$r = function (props) {
    var _a;
    var className = props.className, theme = props.theme, coinSize = props.coinSize;
    var palette = theme.palette, fonts = theme.fonts;
    var size = sizeBoolean(props.size);
    var classNames = getGlobalClassNames(GlobalClassNames$f, theme);
    // Static colors used when displaying 'unknown persona' coin
    var unknownPersonaBackgroundColor = 'rgb(234, 234, 234)';
    var unknownPersonaFontColor = 'rgb(168, 0, 0)';
    var dimension = coinSize || (props.size && sizeToPixels[props.size]) || 48;
    return {
        coin: [
            classNames.coin,
            fonts.medium,
            size.isSize8 && classNames.size8,
            size.isSize10 && classNames.size10,
            size.isSize16 && classNames.size16,
            size.isSize24 && classNames.size24,
            size.isSize28 && classNames.size28,
            size.isSize32 && classNames.size32,
            size.isSize40 && classNames.size40,
            size.isSize48 && classNames.size48,
            size.isSize56 && classNames.size56,
            size.isSize72 && classNames.size72,
            size.isSize100 && classNames.size100,
            size.isSize120 && classNames.size120,
            className,
        ],
        size10WithoutPresenceIcon: {
            fontSize: fonts.xSmall.fontSize,
            position: 'absolute',
            top: '5px',
            right: 'auto',
            left: 0,
        },
        imageArea: [
            classNames.imageArea,
            {
                position: 'relative',
                textAlign: 'center',
                flex: '0 0 auto',
                height: dimension,
                width: dimension,
            },
            dimension <= 10 && {
                overflow: 'visible',
                background: 'transparent',
                height: 0,
                width: 0,
            },
        ],
        image: [
            classNames.image,
            {
                marginRight: '10px',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
                borderRadius: '50%',
                perspective: '1px',
            },
            dimension <= 10 && {
                overflow: 'visible',
                background: 'transparent',
                height: 0,
                width: 0,
            },
            dimension > 10 && {
                height: dimension,
                width: dimension,
            },
        ],
        initials: [
            classNames.initials,
            {
                borderRadius: '50%',
                color: props.showUnknownPersonaCoin ? unknownPersonaFontColor : palette.white,
                fontSize: fonts.large.fontSize,
                fontWeight: FontWeights.semibold,
                // copying the logic for the dimensions; defaulted to 46 for size48
                lineHeight: dimension === 48 ? 46 : dimension,
                height: dimension,
                selectors: (_a = {},
                    _a[HighContrastSelector] = __assign$2(__assign$2({ border: '1px solid WindowText' }, getHighContrastNoAdjustStyle()), { color: 'WindowText', boxSizing: 'border-box', backgroundColor: 'Window !important' }),
                    _a.i = {
                        fontWeight: FontWeights.semibold,
                    },
                    _a),
            },
            props.showUnknownPersonaCoin && {
                backgroundColor: unknownPersonaBackgroundColor,
            },
            dimension < 32 && {
                fontSize: fonts.xSmall.fontSize,
            },
            dimension >= 32 &&
                dimension < 40 && {
                fontSize: fonts.medium.fontSize,
            },
            dimension >= 40 &&
                dimension < 56 && {
                fontSize: fonts.mediumPlus.fontSize,
            },
            dimension >= 56 &&
                dimension < 72 && {
                fontSize: fonts.xLarge.fontSize,
            },
            dimension >= 72 &&
                dimension < 100 && {
                fontSize: fonts.xxLarge.fontSize,
            },
            dimension >= 100 && {
                fontSize: fonts.superLarge.fontSize,
            },
        ],
    };
};

/**
 * PersonaCoin is used to render an individual's avatar and presence.
 */
var PersonaCoin = styled(PersonaCoinBase, getStyles$r, undefined, {
    scope: 'PersonaCoin',
});

var getClassNames$o = classNamesFunction();
var DEFAULT_PROPS$5 = {
    size: PersonaSize.size48,
    presence: PersonaPresence$1.none,
    imageAlt: '',
    showOverflowTooltip: true,
};
function useDebugWarnings$2(props) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- build-time conditional
        useWarnings({
            name: 'Persona',
            props: props,
            deprecations: { primaryText: 'text' },
        });
    }
}
/**
 * Persona with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/microsoft/fluentui/wiki/Styling)
 */
var PersonaBase = React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var props = getPropsWithDefaults(DEFAULT_PROPS$5, propsWithoutDefaults);
    useDebugWarnings$2(props);
    var rootRef = React.useRef(null);
    var mergedRootRef = useMergedRefs$1(forwardedRef, rootRef);
    /**
     * Deprecation helper for getting text.
     */
    var getText = function () {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        return props.text || props.primaryText || '';
    };
    /**
     * Renders various types of Text (primaryText, secondaryText, etc)
     * based on the classNames passed
     * @param elementClassNames - element className
     * @param renderFunction - render function
     * @param defaultRenderFunction - default render function
     */
    var renderElement = function (elementClassNames, renderFunction, defaultRenderFunction) {
        var content = renderFunction && renderFunction(props, defaultRenderFunction);
        return content ? (React.createElement("div", { dir: "auto", className: elementClassNames }, content)) : undefined;
    };
    /**
     * using closure to wrap the default render behavior
     * to make it independent of the type of text passed
     * @param text - text to render
     */
    var onRenderText = function (text, tooltip) {
        if (tooltip === undefined) { tooltip = true; }
        // return default render behavior for valid text or undefined
        return text
            ? tooltip
                ? function () {
                    // default onRender behavior
                    return (React.createElement(TooltipHost, { content: text, overflowMode: TooltipOverflowMode.Parent, directionalHint: DirectionalHint.topLeftEdge }, text));
                }
                : function () { return React.createElement(React.Fragment, null, text); }
            : undefined;
    };
    var onInternalRenderPersonaCoin = function (providedCoinProps) {
        return React.createElement(PersonaCoin, __assign$2({}, providedCoinProps));
    };
    // wrapping default render behavior based on various props properties
    var onInternalRenderPrimaryText = onRenderText(getText(), props.showOverflowTooltip);
    var onInternalRenderSecondaryText = onRenderText(props.secondaryText, props.showOverflowTooltip);
    var onInternalRenderTertiaryText = onRenderText(props.tertiaryText, props.showOverflowTooltip);
    var onInternalRenderOptionalText = onRenderText(props.optionalText, props.showOverflowTooltip);
    var hidePersonaDetails = props.hidePersonaDetails, _a = props.onRenderOptionalText, onRenderOptionalText = _a === undefined ? onInternalRenderOptionalText : _a, _b = props.onRenderPrimaryText, onRenderPrimaryText = _b === undefined ? onInternalRenderPrimaryText : _b, _c = props.onRenderSecondaryText, onRenderSecondaryText = _c === undefined ? onInternalRenderSecondaryText : _c, _d = props.onRenderTertiaryText, onRenderTertiaryText = _d === undefined ? onInternalRenderTertiaryText : _d, _e = props.onRenderPersonaCoin, onRenderPersonaCoin = _e === undefined ? onInternalRenderPersonaCoin : _e;
    var size = props.size;
    // These properties are to be explicitly passed into PersonaCoin because they are the only props directly used
    var allowPhoneInitials = props.allowPhoneInitials, className = props.className, coinProps = props.coinProps, showUnknownPersonaCoin = props.showUnknownPersonaCoin, coinSize = props.coinSize, styles = props.styles, imageAlt = props.imageAlt, imageInitials = props.imageInitials, imageShouldFadeIn = props.imageShouldFadeIn, imageShouldStartVisible = props.imageShouldStartVisible, imageUrl = props.imageUrl, initialsColor = props.initialsColor, initialsTextColor = props.initialsTextColor, isOutOfOffice = props.isOutOfOffice, onPhotoLoadingStateChange = props.onPhotoLoadingStateChange, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    onRenderCoin = props.onRenderCoin, onRenderInitials = props.onRenderInitials, presence = props.presence, presenceTitle = props.presenceTitle, presenceColors = props.presenceColors, showInitialsUntilImageLoads = props.showInitialsUntilImageLoads, showSecondaryText = props.showSecondaryText, theme = props.theme;
    var personaCoinProps = __assign$2({ allowPhoneInitials: allowPhoneInitials, showUnknownPersonaCoin: showUnknownPersonaCoin, coinSize: coinSize, imageAlt: imageAlt, imageInitials: imageInitials, imageShouldFadeIn: imageShouldFadeIn, imageShouldStartVisible: imageShouldStartVisible, imageUrl: imageUrl, initialsColor: initialsColor, initialsTextColor: initialsTextColor, onPhotoLoadingStateChange: onPhotoLoadingStateChange, onRenderCoin: onRenderCoin, onRenderInitials: onRenderInitials, presence: presence, presenceTitle: presenceTitle, showInitialsUntilImageLoads: showInitialsUntilImageLoads, size: size, text: getText(), isOutOfOffice: isOutOfOffice, presenceColors: presenceColors }, coinProps);
    var classNames = getClassNames$o(styles, {
        theme: theme,
        className: className,
        showSecondaryText: showSecondaryText,
        presence: presence,
        size: size,
    });
    var divProps = getNativeProps$1(props, divProperties);
    var personaDetails = (React.createElement("div", { className: classNames.details },
        renderElement(classNames.primaryText, onRenderPrimaryText, onInternalRenderPrimaryText),
        renderElement(classNames.secondaryText, onRenderSecondaryText, onInternalRenderSecondaryText),
        renderElement(classNames.tertiaryText, onRenderTertiaryText, onInternalRenderTertiaryText),
        renderElement(classNames.optionalText, onRenderOptionalText, onInternalRenderOptionalText),
        props.children));
    return (React.createElement("div", __assign$2({}, divProps, { ref: mergedRootRef, className: classNames.root, style: coinSize ? { height: coinSize, minWidth: coinSize } : undefined }),
        onRenderPersonaCoin(personaCoinProps, onRenderPersonaCoin),
        /* eslint-disable @typescript-eslint/no-deprecated */
        (!hidePersonaDetails ||
            size === PersonaSize.size8 ||
            size === PersonaSize.size10 ||
            size === PersonaSize.tiny) &&
            personaDetails
    /* eslint-enable @typescript-eslint/no-deprecated */
    ));
});
PersonaBase.displayName = 'PersonaBase';

var GlobalClassNames$e = {
    root: 'ms-Persona',
    size8: 'ms-Persona--size8',
    size10: 'ms-Persona--size10',
    size16: 'ms-Persona--size16',
    size24: 'ms-Persona--size24',
    size28: 'ms-Persona--size28',
    size32: 'ms-Persona--size32',
    size40: 'ms-Persona--size40',
    size48: 'ms-Persona--size48',
    size56: 'ms-Persona--size56',
    size72: 'ms-Persona--size72',
    size100: 'ms-Persona--size100',
    size120: 'ms-Persona--size120',
    available: 'ms-Persona--online',
    away: 'ms-Persona--away',
    blocked: 'ms-Persona--blocked',
    busy: 'ms-Persona--busy',
    doNotDisturb: 'ms-Persona--donotdisturb',
    offline: 'ms-Persona--offline',
    details: 'ms-Persona-details',
    primaryText: 'ms-Persona-primaryText',
    secondaryText: 'ms-Persona-secondaryText',
    tertiaryText: 'ms-Persona-tertiaryText',
    optionalText: 'ms-Persona-optionalText',
    textContent: 'ms-Persona-textContent',
};
var getStyles$q = function (props) {
    var className = props.className, showSecondaryText = props.showSecondaryText, theme = props.theme;
    var semanticColors = theme.semanticColors, fonts = theme.fonts;
    var classNames = getGlobalClassNames(GlobalClassNames$e, theme);
    var size = sizeBoolean(props.size);
    var presence = presenceBoolean(props.presence);
    var showSecondaryTextDefaultHeight = '16px';
    var sharedTextStyles = {
        color: semanticColors.bodySubtext,
        fontWeight: FontWeights.regular,
        fontSize: fonts.small.fontSize,
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            normalize$4,
            {
                color: semanticColors.bodyText,
                position: 'relative',
                height: personaSize.size48,
                minWidth: personaSize.size48,
                display: 'flex',
                alignItems: 'center',
                selectors: {
                    '.contextualHost': {
                        display: 'none',
                    },
                },
            },
            size.isSize8 && [
                classNames.size8,
                {
                    height: personaSize.size8,
                    minWidth: personaSize.size8,
                },
            ],
            // TODO: Deprecated size and needs to be removed in a future major release.
            size.isSize10 && [
                classNames.size10,
                {
                    height: personaSize.size10,
                    minWidth: personaSize.size10,
                },
            ],
            // TODO: Deprecated size and needs to be removed in a future major release.
            size.isSize16 && [
                classNames.size16,
                {
                    height: personaSize.size16,
                    minWidth: personaSize.size16,
                },
            ],
            size.isSize24 && [
                classNames.size24,
                {
                    height: personaSize.size24,
                    minWidth: personaSize.size24,
                },
            ],
            size.isSize24 &&
                showSecondaryText && {
                height: '36px',
            },
            // TODO: Deprecated size and needs to be removed in a future major release.
            size.isSize28 && [
                classNames.size28,
                {
                    height: personaSize.size28,
                    minWidth: personaSize.size28,
                },
            ],
            size.isSize28 &&
                showSecondaryText && {
                height: '32px',
            },
            size.isSize32 && [
                classNames.size32,
                {
                    height: personaSize.size32,
                    minWidth: personaSize.size32,
                },
            ],
            size.isSize40 && [
                classNames.size40,
                {
                    height: personaSize.size40,
                    minWidth: personaSize.size40,
                },
            ],
            size.isSize48 && classNames.size48,
            size.isSize56 && [
                classNames.size56,
                {
                    height: personaSize.size56,
                    minWidth: personaSize.size56,
                },
            ],
            size.isSize72 && [
                classNames.size72,
                {
                    height: personaSize.size72,
                    minWidth: personaSize.size72,
                },
            ],
            size.isSize100 && [
                classNames.size100,
                {
                    height: personaSize.size100,
                    minWidth: personaSize.size100,
                },
            ],
            size.isSize120 && [
                classNames.size120,
                {
                    height: personaSize.size120,
                    minWidth: personaSize.size120,
                },
            ],
            /**
             * Modifiers: presence
             */
            presence.isAvailable && classNames.available,
            presence.isAway && classNames.away,
            presence.isBlocked && classNames.blocked,
            presence.isBusy && classNames.busy,
            presence.isDoNotDisturb && classNames.doNotDisturb,
            presence.isOffline && classNames.offline,
            className,
        ],
        details: [
            classNames.details,
            {
                padding: '0 24px 0 16px',
                minWidth: 0,
                width: '100%',
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
            },
            (size.isSize8 || size.isSize10) && {
                paddingLeft: 17, // increased padding because we don't render a coin at this size
            },
            (size.isSize24 || size.isSize28 || size.isSize32) && {
                padding: '0 8px',
            },
            (size.isSize40 || size.isSize48) && {
                padding: '0 12px',
            },
        ],
        primaryText: [
            classNames.primaryText,
            noWrap,
            {
                color: semanticColors.bodyText,
                fontWeight: FontWeights.regular,
                fontSize: fonts.medium.fontSize,
                selectors: {
                    ':hover': {
                        color: semanticColors.inputTextHovered,
                    },
                },
            },
            showSecondaryText && {
                height: showSecondaryTextDefaultHeight,
                lineHeight: showSecondaryTextDefaultHeight,
                overflowX: 'hidden',
            },
            (size.isSize8 || size.isSize10) && {
                fontSize: fonts.small.fontSize,
                lineHeight: personaSize.size8,
            },
            size.isSize16 && {
                lineHeight: personaSize.size28,
            },
            (size.isSize24 || size.isSize28 || size.isSize32 || size.isSize40 || size.isSize48) &&
                showSecondaryText && {
                height: 18,
            },
            (size.isSize56 || size.isSize72 || size.isSize100 || size.isSize120) && {
                fontSize: fonts.xLarge.fontSize,
            },
            (size.isSize56 || size.isSize72 || size.isSize100 || size.isSize120) &&
                showSecondaryText && {
                height: 22,
            },
        ],
        secondaryText: [
            classNames.secondaryText,
            noWrap,
            sharedTextStyles,
            (size.isSize8 || size.isSize10 || size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32) && {
                display: 'none',
            },
            showSecondaryText && {
                display: 'block',
                height: showSecondaryTextDefaultHeight,
                lineHeight: showSecondaryTextDefaultHeight,
                overflowX: 'hidden',
            },
            size.isSize24 &&
                showSecondaryText && {
                height: 18,
            },
            (size.isSize56 || size.isSize72 || size.isSize100 || size.isSize120) && {
                fontSize: fonts.medium.fontSize,
            },
            (size.isSize56 || size.isSize72 || size.isSize100 || size.isSize120) &&
                showSecondaryText && {
                height: 18,
            },
        ],
        tertiaryText: [
            classNames.tertiaryText,
            noWrap,
            sharedTextStyles,
            {
                display: 'none',
                fontSize: fonts.medium.fontSize,
            },
            (size.isSize72 || size.isSize100 || size.isSize120) && {
                display: 'block',
            },
        ],
        optionalText: [
            classNames.optionalText,
            noWrap,
            sharedTextStyles,
            {
                display: 'none',
                fontSize: fonts.medium.fontSize,
            },
            (size.isSize100 || size.isSize120) && {
                display: 'block',
            },
        ],
        textContent: [classNames.textContent, noWrap],
    };
};

/**
 * Personas are used for rendering an individual's avatar, presence and details.
 * They are used within the PeoplePicker components.
 */
var Persona = styled(PersonaBase, getStyles$q, undefined, {
    scope: 'Persona',
});

var getClassNames$n = classNamesFunction();
/**
 * {@docCategory Announced}
 */
var AnnouncedBase = /** @class */ (function (_super) {
    __extends$1(AnnouncedBase, _super);
    function AnnouncedBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnouncedBase.prototype.render = function () {
        var _a = this.props, message = _a.message, styles = _a.styles, _b = _a.as, Root = _b === undefined ? 'div' : _b, className = _a.className;
        var classNames = getClassNames$n(styles, { className: className });
        return (React.createElement(Root, __assign$2({ role: "status", className: classNames.root }, getNativeProps$1(this.props, divProperties, ['className'])),
            React.createElement(DelayedRender, null,
                React.createElement("div", { className: classNames.screenReaderText }, message))));
    };
    AnnouncedBase.defaultProps = {
        'aria-live': 'polite',
    };
    return AnnouncedBase;
}(React.Component));

var getStyles$p = function (props) {
    return {
        root: props.className,
        screenReaderText: hiddenContentStyle,
    };
};

var Announced = styled(AnnouncedBase, getStyles$p, undefined, { scope: 'Announced' });

/**
 * {@docCategory FocusZone}
 */
var FocusZoneTabbableElements = {
    /** Tabbing is not allowed */
    none: 0,
    /** All tabbing action is allowed */
    all: 1,
    /** Tabbing is allowed only on input elements */
    inputOnly: 2,
};
/**
 * {@docCategory FocusZone}
 */
var FocusZoneDirection;
(function (FocusZoneDirection) {
    /** Only react to up/down arrows. */
    FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
    /** Only react to left/right arrows. */
    FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
    /** React to all arrows. */
    FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
    /**
     * React to all arrows. Navigate next item in DOM on right/down arrow keys and previous - left/up arrow keys.
     * Right and Left arrow keys are swapped in RTL mode.
     */
    FocusZoneDirection[FocusZoneDirection["domOrder"] = 3] = "domOrder";
})(FocusZoneDirection || (FocusZoneDirection = {}));

var IS_FOCUSABLE_ATTRIBUTE = "data-is-focusable";
var IS_ENTER_DISABLED_ATTRIBUTE = "data-disable-click-on-enter";
var FOCUSZONE_ID_ATTRIBUTE = "data-focuszone-id";
var TABINDEX = "tabindex";
var NO_VERTICAL_WRAP = "data-no-vertical-wrap";
var NO_HORIZONTAL_WRAP = "data-no-horizontal-wrap";
var LARGE_DISTANCE_FROM_CENTER = 999999999;
var LARGE_NEGATIVE_DISTANCE_FROM_CENTER = -999999999;
var focusZoneStyles;
var focusZoneClass = "ms-FocusZone";
function raiseClickFromKeyboardEvent(target, ev) {
  var event;
  if (typeof MouseEvent === "function") {
    event = new MouseEvent("click", {
      ctrlKey: ev === null || ev === undefined ? undefined : ev.ctrlKey,
      metaKey: ev === null || ev === undefined ? undefined : ev.metaKey,
      shiftKey: ev === null || ev === undefined ? undefined : ev.shiftKey,
      altKey: ev === null || ev === undefined ? undefined : ev.altKey,
      bubbles: ev === null || ev === undefined ? undefined : ev.bubbles,
      cancelable: ev === null || ev === undefined ? undefined : ev.cancelable
    });
  } else {
    event = document.createEvent("MouseEvents");
    event.initMouseEvent(
      "click",
      ev ? ev.bubbles : false,
      ev ? ev.cancelable : false,
      // eslint-disable-next-line no-restricted-globals
      window,
      // not using getWindow() since this can only be run client side
      0,
      // detail
      0,
      // screen x
      0,
      // screen y
      0,
      // client x
      0,
      // client y
      ev ? ev.ctrlKey : false,
      ev ? ev.altKey : false,
      ev ? ev.shiftKey : false,
      ev ? ev.metaKey : false,
      0,
      // button
      null
    );
  }
  target.dispatchEvent(event);
}
function getRootClass() {
  if (!focusZoneStyles) {
    focusZoneStyles = mergeStyles({
      selectors: {
        ":focus": {
          outline: "none"
        }
      }
    }, focusZoneClass);
  }
  return focusZoneStyles;
}
var _allInstances = {};
var _outerZones = /* @__PURE__ */ new Set();
var ALLOWED_INPUT_TYPES = ["text", "number", "password", "email", "tel", "url", "search", "textarea"];
var ALLOW_VIRTUAL_ELEMENTS = false;
var FocusZone = (
  /** @class */
  function(_super) {
    __extends$1(FocusZone2, _super);
    function FocusZone2(props) {
      var _a, _b, _c, _d;
      var _this = _super.call(this, props) || this;
      _this._root = React.createRef();
      _this._mergedRef = createMergedRef();
      _this._onFocus = function(ev) {
        if (_this._portalContainsElement(ev.target)) {
          return;
        }
        var _a2 = _this.props, onActiveElementChanged = _a2.onActiveElementChanged, doNotAllowFocusEventToPropagate = _a2.doNotAllowFocusEventToPropagate, stopFocusPropagation = _a2.stopFocusPropagation, onFocusNotification = _a2.onFocusNotification, onFocus = _a2.onFocus, shouldFocusInnerElementWhenReceivedFocus = _a2.shouldFocusInnerElementWhenReceivedFocus, defaultTabbableElement = _a2.defaultTabbableElement;
        var isImmediateDescendant = _this._isImmediateDescendantOfZone(ev.target);
        var newActiveElement;
        if (isImmediateDescendant) {
          newActiveElement = ev.target;
        } else {
          var parentElement = ev.target;
          while (parentElement && parentElement !== _this._root.current) {
            if (isElementTabbable(parentElement, undefined, _this._inShadowRoot) && _this._isImmediateDescendantOfZone(parentElement)) {
              newActiveElement = parentElement;
              break;
            }
            parentElement = getParent$1(parentElement, ALLOW_VIRTUAL_ELEMENTS);
          }
        }
        if (shouldFocusInnerElementWhenReceivedFocus && ev.target === _this._root.current) {
          var maybeElementToFocus = defaultTabbableElement && typeof defaultTabbableElement === "function" && _this._root.current && defaultTabbableElement(_this._root.current);
          if (maybeElementToFocus && isElementTabbable(maybeElementToFocus, undefined, _this._inShadowRoot)) {
            newActiveElement = maybeElementToFocus;
            maybeElementToFocus.focus();
          } else {
            _this.focus(true);
            if (_this._activeElement) {
              newActiveElement = null;
            }
          }
        }
        var initialElementFocused = !_this._activeElement;
        if (newActiveElement && newActiveElement !== _this._activeElement) {
          if (isImmediateDescendant || initialElementFocused) {
            _this._setFocusAlignment(newActiveElement, true, true);
          }
          _this._activeElement = newActiveElement;
          if (initialElementFocused) {
            _this._updateTabIndexes();
          }
        }
        if (onActiveElementChanged) {
          onActiveElementChanged(_this._activeElement, ev);
        }
        if (stopFocusPropagation || doNotAllowFocusEventToPropagate) {
          ev.stopPropagation();
        }
        if (onFocus) {
          onFocus(ev);
        } else if (onFocusNotification) {
          onFocusNotification();
        }
      };
      _this._onBlur = function() {
        _this._setParkedFocus(false);
      };
      _this._onMouseDown = function(ev) {
        if (_this._portalContainsElement(ev.target)) {
          return;
        }
        var disabled = _this.props.disabled;
        if (disabled) {
          return;
        }
        var target = ev.target;
        var path = [];
        while (target && target !== _this._root.current) {
          path.push(target);
          target = getParent$1(target, ALLOW_VIRTUAL_ELEMENTS);
        }
        while (path.length) {
          target = path.pop();
          if (target && isElementTabbable(target, undefined, _this._inShadowRoot)) {
            _this._setActiveElement(target, true);
          }
          if (isElementFocusZone(target)) {
            break;
          }
        }
      };
      _this._onKeyDown = function(ev, theme) {
        if (_this._portalContainsElement(ev.target)) {
          return;
        }
        var _a2 = _this.props, direction = _a2.direction, disabled = _a2.disabled, isInnerZoneKeystroke = _a2.isInnerZoneKeystroke, pagingSupportDisabled = _a2.pagingSupportDisabled, shouldEnterInnerZone = _a2.shouldEnterInnerZone;
        if (disabled) {
          return;
        }
        if (_this.props.onKeyDown) {
          _this.props.onKeyDown(ev);
        }
        if (ev.isDefaultPrevented()) {
          return;
        }
        if (_this._getDocument().activeElement === _this._root.current && _this._isInnerZone) {
          return;
        }
        if ((shouldEnterInnerZone && shouldEnterInnerZone(ev) || isInnerZoneKeystroke && isInnerZoneKeystroke(ev)) && _this._isImmediateDescendantOfZone(ev.target)) {
          var innerZone = _this._getFirstInnerZone();
          if (innerZone) {
            if (!innerZone.focus(true)) {
              return;
            }
          } else if (isElementFocusSubZone(ev.target)) {
            if (!_this.focusElement(getNextElement(ev.target, ev.target.firstChild, true))) {
              return;
            }
          } else {
            return;
          }
        } else if (ev.altKey) {
          return;
        } else {
          switch (ev.which) {
            case KeyCodes.space:
              if (_this._shouldRaiseClicksOnSpace && _this._tryInvokeClickForFocusable(ev.target, ev)) {
                break;
              }
              return;
            case KeyCodes.left:
              if (direction !== FocusZoneDirection.vertical) {
                _this._preventDefaultWhenHandled(ev);
                if (_this._moveFocusLeft(theme)) {
                  break;
                }
              }
              return;
            case KeyCodes.right:
              if (direction !== FocusZoneDirection.vertical) {
                _this._preventDefaultWhenHandled(ev);
                if (_this._moveFocusRight(theme)) {
                  break;
                }
              }
              return;
            case KeyCodes.up:
              if (direction !== FocusZoneDirection.horizontal) {
                _this._preventDefaultWhenHandled(ev);
                if (_this._moveFocusUp()) {
                  break;
                }
              }
              return;
            case KeyCodes.down:
              if (direction !== FocusZoneDirection.horizontal) {
                _this._preventDefaultWhenHandled(ev);
                if (_this._moveFocusDown()) {
                  break;
                }
              }
              return;
            case KeyCodes.pageDown:
              if (!pagingSupportDisabled && _this._moveFocusPaging(true)) {
                break;
              }
              return;
            case KeyCodes.pageUp:
              if (!pagingSupportDisabled && _this._moveFocusPaging(false)) {
                break;
              }
              return;
            case KeyCodes.tab:
              if (
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                _this.props.allowTabKey || _this.props.handleTabKey === FocusZoneTabbableElements.all || _this.props.handleTabKey === FocusZoneTabbableElements.inputOnly && _this._isElementInput(ev.target)
              ) {
                var focusChanged = false;
                _this._processingTabKey = true;
                if (direction === FocusZoneDirection.vertical || !_this._shouldWrapFocus(_this._activeElement, NO_HORIZONTAL_WRAP)) {
                  focusChanged = ev.shiftKey ? _this._moveFocusUp() : _this._moveFocusDown();
                } else {
                  var tabWithDirection = getRTL(theme) ? !ev.shiftKey : ev.shiftKey;
                  focusChanged = tabWithDirection ? _this._moveFocusLeft(theme) : _this._moveFocusRight(theme);
                }
                _this._processingTabKey = false;
                if (focusChanged) {
                  break;
                } else if (_this.props.shouldResetActiveElementWhenTabFromZone) {
                  _this._activeElement = null;
                }
              }
              return;
            case KeyCodes.home:
              if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, false)) {
                return false;
              }
              var firstChild = _this._root.current && _this._root.current.firstChild;
              if (_this._root.current && firstChild && _this.focusElement(getNextElement(_this._root.current, firstChild, true))) {
                break;
              }
              return;
            case KeyCodes.end:
              if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, true)) {
                return false;
              }
              var lastChild = _this._root.current && _this._root.current.lastChild;
              if (_this._root.current && _this.focusElement(getPreviousElement(_this._root.current, lastChild, true, true, true))) {
                break;
              }
              return;
            case KeyCodes.enter:
              if (_this._shouldRaiseClicksOnEnter && _this._tryInvokeClickForFocusable(ev.target, ev)) {
                break;
              }
              return;
            default:
              return;
          }
        }
        ev.preventDefault();
        ev.stopPropagation();
      };
      _this._getHorizontalDistanceFromCenter = function(isForward, activeRect, targetRect) {
        var leftAlignment = _this._focusAlignment.left || _this._focusAlignment.x || 0;
        var targetRectTop = Math.floor(targetRect.top);
        var activeRectBottom = Math.floor(activeRect.bottom);
        var targetRectBottom = Math.floor(targetRect.bottom);
        var activeRectTop = Math.floor(activeRect.top);
        var isValidCandidateOnpagingDown = isForward && targetRectTop > activeRectBottom;
        var isValidCandidateOnpagingUp = !isForward && targetRectBottom < activeRectTop;
        if (isValidCandidateOnpagingDown || isValidCandidateOnpagingUp) {
          if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
            return 0;
          }
          return Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
        }
        if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
          return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
        }
        return LARGE_DISTANCE_FROM_CENTER;
      };
      initializeComponentRef(_this);
      if (process.env.NODE_ENV !== "production") {
        warnDeprecations("FocusZone", props, {
          rootProps: undefined,
          allowTabKey: "handleTabKey",
          elementType: "as",
          ariaDescribedBy: "aria-describedby",
          ariaLabelledBy: "aria-labelledby"
        });
      }
      _this._id = getId("FocusZone");
      _this._focusAlignment = {
        left: 0,
        top: 0
      };
      _this._processingTabKey = false;
      var shouldRaiseClicksFallback = (_b = (_a = props.shouldRaiseClicks) !== null && _a !== undefined ? _a : FocusZone2.defaultProps.shouldRaiseClicks) !== null && _b !== undefined ? _b : true;
      _this._shouldRaiseClicksOnEnter = (_c = props.shouldRaiseClicksOnEnter) !== null && _c !== undefined ? _c : shouldRaiseClicksFallback;
      _this._shouldRaiseClicksOnSpace = (_d = props.shouldRaiseClicksOnSpace) !== null && _d !== undefined ? _d : shouldRaiseClicksFallback;
      return _this;
    }
    FocusZone2.getOuterZones = function() {
      return _outerZones.size;
    };
    FocusZone2._onKeyDownCapture = function(ev) {
      if (ev.which === KeyCodes.tab) {
        _outerZones.forEach(function(zone) {
          return zone._updateTabIndexes();
        });
      }
    };
    FocusZone2.prototype.componentDidMount = function() {
      var _a;
      var root = this._root.current;
      this._inShadowRoot = !!((_a = this.context) === null || _a === undefined ? undefined : _a.shadowRoot);
      _allInstances[this._id] = this;
      if (root) {
        var parentElement = getParent$1(root, ALLOW_VIRTUAL_ELEMENTS);
        while (parentElement && parentElement !== this._getDocument().body && parentElement.nodeType === 1) {
          if (isElementFocusZone(parentElement)) {
            this._isInnerZone = true;
            break;
          }
          parentElement = getParent$1(parentElement, ALLOW_VIRTUAL_ELEMENTS);
        }
        if (!this._isInnerZone) {
          _outerZones.add(this);
          this._root.current && this._root.current.addEventListener("keydown", FocusZone2._onKeyDownCapture, true);
        }
        this._root.current && this._root.current.addEventListener("blur", this._onBlur, true);
        this._updateTabIndexes();
        if (this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === "string") {
          this._activeElement = this._getDocument().querySelector(this.props.defaultTabbableElement);
        } else if (this.props.defaultActiveElement) {
          this._activeElement = this._getDocument().querySelector(this.props.defaultActiveElement);
        }
        if (this.props.shouldFocusOnMount) {
          this.focus();
        }
      }
    };
    FocusZone2.prototype.componentDidUpdate = function() {
      var _a;
      var root = this._root.current;
      var doc = this._getDocument();
      this._inShadowRoot = !!((_a = this.context) === null || _a === undefined ? undefined : _a.shadowRoot);
      if (this._activeElement && !elementContains$1(this._root.current, this._activeElement, ALLOW_VIRTUAL_ELEMENTS) || this._defaultFocusElement && !elementContains$1(this._root.current, this._defaultFocusElement, ALLOW_VIRTUAL_ELEMENTS)) {
        this._activeElement = null;
        this._defaultFocusElement = null;
        this._updateTabIndexes();
      }
      if (!this.props.preventFocusRestoration && doc && this._lastIndexPath && (doc.activeElement === doc.body || doc.activeElement === null || doc.activeElement === root)) {
        var elementToFocus = getFocusableByIndexPath(root, this._lastIndexPath);
        if (elementToFocus) {
          this._setActiveElement(elementToFocus, true);
          elementToFocus.focus();
          this._setParkedFocus(false);
        } else {
          this._setParkedFocus(true);
        }
      }
    };
    FocusZone2.prototype.componentWillUnmount = function() {
      delete _allInstances[this._id];
      if (!this._isInnerZone) {
        _outerZones.delete(this);
        this._root.current && this._root.current.removeEventListener("keydown", FocusZone2._onKeyDownCapture, true);
      }
      if (this._root.current) {
        this._root.current.removeEventListener("blur", this._onBlur, true);
      }
      this._activeElement = null;
      this._defaultFocusElement = null;
    };
    FocusZone2.prototype.render = function() {
      var _this = this;
      var _a = this.props, tag = _a.as, elementType = _a.elementType, rootProps = _a.rootProps, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className;
      var divProps = getNativeProps$1(this.props, htmlElementProperties$1);
      var Tag = tag || elementType || "div";
      this._evaluateFocusBeforeRender();
      var theme = getTheme();
      return React.createElement(Tag, __assign$2({ "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, divProps, rootProps, {
        // Once the getClassName correctly memoizes inputs this should
        // be replaced so that className is passed to getRootClass and is included there so
        // the class names will always be in the same order.
        className: css(getRootClass(), className),
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        ref: this._mergedRef(this.props.elementRef, this._root),
        "data-focuszone-id": this._id,
        // eslint-disable-next-line react/jsx-no-bind
        onKeyDown: function(ev) {
          return _this._onKeyDown(ev, theme);
        },
        onFocus: this._onFocus,
        onMouseDownCapture: this._onMouseDown
      }), this.props.children);
    };
    FocusZone2.prototype.focus = function(forceIntoFirstElement, bypassHiddenElements) {
      if (forceIntoFirstElement === undefined) {
        forceIntoFirstElement = false;
      }
      if (bypassHiddenElements === undefined) {
        bypassHiddenElements = false;
      }
      if (this._root.current) {
        if (!forceIntoFirstElement && this._root.current.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === "true" && this._isInnerZone) {
          var ownerZoneElement = this._getOwnerZone(this._root.current);
          if (ownerZoneElement !== this._root.current) {
            var ownerZone = _allInstances[ownerZoneElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
            return !!ownerZone && ownerZone.focusElement(this._root.current);
          }
          return false;
        } else if (!forceIntoFirstElement && this._activeElement && elementContains$1(this._root.current, this._activeElement) && isElementTabbable(this._activeElement, undefined, this._inShadowRoot) && (!bypassHiddenElements || isElementVisibleAndNotHidden(this._activeElement))) {
          this._activeElement.focus();
          return true;
        } else {
          var firstChild = this._root.current.firstChild;
          return this.focusElement(getNextElement(this._root.current, firstChild, true, undefined, undefined, undefined, undefined, undefined, bypassHiddenElements));
        }
      }
      return false;
    };
    FocusZone2.prototype.focusLast = function() {
      if (this._root.current) {
        var lastChild = this._root.current && this._root.current.lastChild;
        return this.focusElement(getPreviousElement(this._root.current, lastChild, true, true, true));
      }
      return false;
    };
    FocusZone2.prototype.focusElement = function(element, forceAlignment) {
      var _a = this.props, onBeforeFocus = _a.onBeforeFocus, shouldReceiveFocus = _a.shouldReceiveFocus;
      if (shouldReceiveFocus && !shouldReceiveFocus(element) || onBeforeFocus && !onBeforeFocus(element)) {
        return false;
      }
      if (element) {
        this._setActiveElement(element, forceAlignment);
        if (this._activeElement) {
          this._activeElement.focus();
        }
        return true;
      }
      return false;
    };
    FocusZone2.prototype.setFocusAlignment = function(point) {
      this._focusAlignment = point;
    };
    Object.defineProperty(FocusZone2.prototype, "defaultFocusElement", {
      get: function() {
        return this._defaultFocusElement;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(FocusZone2.prototype, "activeElement", {
      get: function() {
        return this._activeElement;
      },
      enumerable: false,
      configurable: true
    });
    FocusZone2.prototype._evaluateFocusBeforeRender = function() {
      var root = this._root.current;
      var doc = this._getDocument();
      if (doc) {
        var focusedElement = doc.activeElement;
        if (focusedElement !== root) {
          var shouldRestoreFocus = elementContains$1(root, focusedElement, false);
          this._lastIndexPath = shouldRestoreFocus ? getElementIndexPath(root, focusedElement) : undefined;
        }
      }
    };
    FocusZone2.prototype._setParkedFocus = function(isParked) {
      var root = this._root.current;
      if (root && this._isParked !== isParked) {
        this._isParked = isParked;
        if (isParked) {
          if (!this.props.allowFocusRoot) {
            this._parkedTabIndex = root.getAttribute("tabindex");
            root.setAttribute("tabindex", "-1");
          }
          root.focus();
        } else if (!this.props.allowFocusRoot) {
          if (this._parkedTabIndex) {
            root.setAttribute("tabindex", this._parkedTabIndex);
            this._parkedTabIndex = undefined;
          } else {
            root.removeAttribute("tabindex");
          }
        }
      }
    };
    FocusZone2.prototype._setActiveElement = function(element, forceAlignment) {
      var previousActiveElement = this._activeElement;
      this._activeElement = element;
      if (previousActiveElement) {
        if (isElementFocusZone(previousActiveElement)) {
          this._updateTabIndexes(previousActiveElement);
        }
        previousActiveElement.tabIndex = -1;
      }
      if (this._activeElement) {
        if (!this._focusAlignment || forceAlignment) {
          this._setFocusAlignment(element, true, true);
        }
        this._activeElement.tabIndex = 0;
      }
    };
    FocusZone2.prototype._preventDefaultWhenHandled = function(ev) {
      this.props.preventDefaultWhenHandled && ev.preventDefault();
    };
    FocusZone2.prototype._tryInvokeClickForFocusable = function(targetElement, ev) {
      var target = targetElement;
      if (target === this._root.current) {
        return false;
      }
      do {
        if (target.tagName === "BUTTON" || target.tagName === "A" || target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SUMMARY") {
          return false;
        }
        if (this._isImmediateDescendantOfZone(target) && target.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === "true" && target.getAttribute(IS_ENTER_DISABLED_ATTRIBUTE) !== "true") {
          raiseClickFromKeyboardEvent(target, ev);
          return true;
        }
        target = getParent$1(target, ALLOW_VIRTUAL_ELEMENTS);
      } while (target !== this._root.current);
      return false;
    };
    FocusZone2.prototype._getFirstInnerZone = function(rootElement) {
      rootElement = rootElement || this._activeElement || this._root.current;
      if (!rootElement) {
        return null;
      }
      if (isElementFocusZone(rootElement)) {
        return _allInstances[rootElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
      }
      var child = rootElement.firstElementChild;
      while (child) {
        if (isElementFocusZone(child)) {
          return _allInstances[child.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
        }
        var match = this._getFirstInnerZone(child);
        if (match) {
          return match;
        }
        child = child.nextElementSibling;
      }
      return null;
    };
    FocusZone2.prototype._moveFocus = function(isForward, getDistanceFromCenter, ev, useDefaultWrap) {
      if (useDefaultWrap === undefined) {
        useDefaultWrap = true;
      }
      var element = this._activeElement;
      var candidateDistance = -1;
      var candidateElement = undefined;
      var changedFocus = false;
      var isBidirectional = this.props.direction === FocusZoneDirection.bidirectional;
      if (!element || !this._root.current) {
        return false;
      }
      if (this._isElementInput(element)) {
        if (!this._shouldInputLoseFocus(element, isForward)) {
          return false;
        }
      }
      var activeRect = isBidirectional ? element.getBoundingClientRect() : null;
      do {
        element = isForward ? getNextElement(this._root.current, element) : getPreviousElement(this._root.current, element);
        if (isBidirectional) {
          if (element) {
            var targetRect = element.getBoundingClientRect();
            var elementDistance = getDistanceFromCenter(activeRect, targetRect);
            if (elementDistance === -1 && candidateDistance === -1) {
              candidateElement = element;
              break;
            }
            if (elementDistance > -1 && (candidateDistance === -1 || elementDistance < candidateDistance)) {
              candidateDistance = elementDistance;
              candidateElement = element;
            }
            if (candidateDistance >= 0 && elementDistance < 0) {
              break;
            }
          }
        } else {
          candidateElement = element;
          break;
        }
      } while (element);
      if (candidateElement && candidateElement !== this._activeElement) {
        changedFocus = true;
        this.focusElement(candidateElement);
      } else if (this.props.isCircularNavigation && useDefaultWrap) {
        if (isForward) {
          return this.focusElement(getNextElement(this._root.current, this._root.current.firstElementChild, true));
        } else {
          return this.focusElement(getPreviousElement(this._root.current, this._root.current.lastElementChild, true, true, true));
        }
      }
      return changedFocus;
    };
    FocusZone2.prototype._moveFocusDown = function() {
      var _this = this;
      var targetTop = -1;
      var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;
      if (
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        this._moveFocus(true, function(activeRect, targetRect) {
          var distance = -1;
          var targetRectTop = Math.floor(targetRect.top);
          var activeRectBottom = Math.floor(activeRect.bottom);
          if (targetRectTop < activeRectBottom) {
            if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
              return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            }
            return LARGE_DISTANCE_FROM_CENTER;
          }
          if (targetTop === -1 && targetRectTop >= activeRectBottom || targetRectTop === targetTop) {
            targetTop = targetRectTop;
            if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
              distance = 0;
            } else {
              distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
          }
          return distance;
        })
      ) {
        this._setFocusAlignment(this._activeElement, false, true);
        return true;
      }
      return false;
    };
    FocusZone2.prototype._moveFocusUp = function() {
      var _this = this;
      var targetTop = -1;
      var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;
      if (
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        this._moveFocus(false, function(activeRect, targetRect) {
          var distance = -1;
          var targetRectBottom = Math.floor(targetRect.bottom);
          var targetRectTop = Math.floor(targetRect.top);
          var activeRectTop = Math.floor(activeRect.top);
          if (targetRectBottom > activeRectTop) {
            if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
              return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            }
            return LARGE_DISTANCE_FROM_CENTER;
          }
          if (targetTop === -1 && targetRectBottom <= activeRectTop || targetRectTop === targetTop) {
            targetTop = targetRectTop;
            if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
              distance = 0;
            } else {
              distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
          }
          return distance;
        })
      ) {
        this._setFocusAlignment(this._activeElement, false, true);
        return true;
      }
      return false;
    };
    FocusZone2.prototype._moveFocusLeft = function(theme) {
      var _this = this;
      var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);
      if (this._moveFocus(
        getRTL(theme),
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        function(activeRect, targetRect) {
          var distance = -1;
          var topBottomComparison;
          if (getRTL(theme)) {
            topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
          } else {
            topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
          }
          if (topBottomComparison && targetRect.right <= activeRect.right && _this.props.direction !== FocusZoneDirection.vertical) {
            distance = activeRect.right - targetRect.right;
          } else if (!shouldWrap) {
            distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
          }
          return distance;
        },
        undefined,
        shouldWrap
      )) {
        this._setFocusAlignment(this._activeElement, true, false);
        return true;
      }
      return false;
    };
    FocusZone2.prototype._moveFocusRight = function(theme) {
      var _this = this;
      var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);
      if (this._moveFocus(
        !getRTL(theme),
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        function(activeRect, targetRect) {
          var distance = -1;
          var topBottomComparison;
          if (getRTL(theme)) {
            topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
          } else {
            topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
          }
          if (topBottomComparison && targetRect.left >= activeRect.left && _this.props.direction !== FocusZoneDirection.vertical) {
            distance = targetRect.left - activeRect.left;
          } else if (!shouldWrap) {
            distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
          }
          return distance;
        },
        undefined,
        shouldWrap
      )) {
        this._setFocusAlignment(this._activeElement, true, false);
        return true;
      }
      return false;
    };
    FocusZone2.prototype._moveFocusPaging = function(isForward, useDefaultWrap) {
      if (useDefaultWrap === undefined) {
        useDefaultWrap = true;
      }
      var element = this._activeElement;
      if (!element || !this._root.current) {
        return false;
      }
      if (this._isElementInput(element)) {
        if (!this._shouldInputLoseFocus(element, isForward)) {
          return false;
        }
      }
      var scrollableParent = findScrollableParent(element);
      if (!scrollableParent) {
        return false;
      }
      var candidateDistance = -1;
      var candidateElement = undefined;
      var targetTop = -1;
      var targetBottom = -1;
      var pagesize = scrollableParent.clientHeight;
      var activeRect = element.getBoundingClientRect();
      do {
        element = isForward ? getNextElement(this._root.current, element) : getPreviousElement(this._root.current, element);
        if (element) {
          var targetRect = element.getBoundingClientRect();
          var targetRectTop = Math.floor(targetRect.top);
          var activeRectBottom = Math.floor(activeRect.bottom);
          var targetRectBottom = Math.floor(targetRect.bottom);
          var activeRectTop = Math.floor(activeRect.top);
          var elementDistance = this._getHorizontalDistanceFromCenter(isForward, activeRect, targetRect);
          var isElementPassedPageSizeOnPagingDown = isForward && targetRectTop > activeRectBottom + pagesize;
          var isElementPassedPageSizeOnPagingUp = !isForward && targetRectBottom < activeRectTop - pagesize;
          if (isElementPassedPageSizeOnPagingDown || isElementPassedPageSizeOnPagingUp) {
            break;
          }
          if (elementDistance > -1) {
            if (isForward && targetRectTop > targetTop) {
              targetTop = targetRectTop;
              candidateDistance = elementDistance;
              candidateElement = element;
            } else if (!isForward && targetRectBottom < targetBottom) {
              targetBottom = targetRectBottom;
              candidateDistance = elementDistance;
              candidateElement = element;
            } else if (candidateDistance === -1 || elementDistance <= candidateDistance) {
              candidateDistance = elementDistance;
              candidateElement = element;
            }
          }
        }
      } while (element);
      var changedFocus = false;
      if (candidateElement && candidateElement !== this._activeElement) {
        changedFocus = true;
        this.focusElement(candidateElement);
        this._setFocusAlignment(candidateElement, false, true);
      } else if (this.props.isCircularNavigation && useDefaultWrap) {
        if (isForward) {
          return this.focusElement(getNextElement(this._root.current, this._root.current.firstElementChild, true));
        }
        return this.focusElement(getPreviousElement(this._root.current, this._root.current.lastElementChild, true, true, true));
      }
      return changedFocus;
    };
    FocusZone2.prototype._setFocusAlignment = function(element, isHorizontal, isVertical) {
      if (this.props.direction === FocusZoneDirection.bidirectional && (!this._focusAlignment || isHorizontal || isVertical)) {
        var rect = element.getBoundingClientRect();
        var left = rect.left + rect.width / 2;
        var top_1 = rect.top + rect.height / 2;
        if (!this._focusAlignment) {
          this._focusAlignment = { left, top: top_1 };
        }
        if (isHorizontal) {
          this._focusAlignment.left = left;
        }
        if (isVertical) {
          this._focusAlignment.top = top_1;
        }
      }
    };
    FocusZone2.prototype._isImmediateDescendantOfZone = function(element) {
      return this._getOwnerZone(element) === this._root.current;
    };
    FocusZone2.prototype._getOwnerZone = function(element) {
      var parentElement = getParent$1(element, ALLOW_VIRTUAL_ELEMENTS);
      while (parentElement && parentElement !== this._root.current && parentElement !== this._getDocument().body) {
        if (isElementFocusZone(parentElement)) {
          return parentElement;
        }
        parentElement = getParent$1(parentElement, ALLOW_VIRTUAL_ELEMENTS);
      }
      return parentElement;
    };
    FocusZone2.prototype._updateTabIndexes = function(element) {
      if (!this._activeElement && this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === "function") {
        this._activeElement = this.props.defaultTabbableElement(this._root.current);
      }
      if (!element && this._root.current) {
        this._defaultFocusElement = null;
        element = this._root.current;
        if (this._activeElement && !elementContains$1(element, this._activeElement)) {
          this._activeElement = null;
        }
      }
      if (this._activeElement && !isElementTabbable(this._activeElement, undefined, this._inShadowRoot)) {
        this._activeElement = null;
      }
      var childNodes = element && element.children;
      for (var childIndex = 0; childNodes && childIndex < childNodes.length; childIndex++) {
        var child = childNodes[childIndex];
        if (!isElementFocusZone(child)) {
          if (child.getAttribute && child.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === "false") {
            child.setAttribute(TABINDEX, "-1");
          }
          if (isElementTabbable(child, undefined, this._inShadowRoot)) {
            if (this.props.disabled) {
              child.setAttribute(TABINDEX, "-1");
            } else if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
              this._defaultFocusElement = child;
              if (child.getAttribute(TABINDEX) !== "0") {
                child.setAttribute(TABINDEX, "0");
              }
            } else if (child.getAttribute(TABINDEX) !== "-1") {
              child.setAttribute(TABINDEX, "-1");
            }
          } else if (child.tagName === "svg" && child.getAttribute("focusable") !== "false") {
            child.setAttribute("focusable", "false");
          }
        } else if (child.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === "true") {
          if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
            this._defaultFocusElement = child;
            if (child.getAttribute(TABINDEX) !== "0") {
              child.setAttribute(TABINDEX, "0");
            }
          } else if (child.getAttribute(TABINDEX) !== "-1") {
            child.setAttribute(TABINDEX, "-1");
          }
        }
        this._updateTabIndexes(child);
      }
    };
    FocusZone2.prototype._isContentEditableElement = function(element) {
      return element && element.getAttribute("contenteditable") === "true";
    };
    FocusZone2.prototype._isElementInput = function(element) {
      if (element && element.tagName && (element.tagName.toLowerCase() === "input" || element.tagName.toLowerCase() === "textarea")) {
        return true;
      }
      return false;
    };
    FocusZone2.prototype._shouldInputLoseFocus = function(element, isForward) {
      if (!this._processingTabKey && element && element.type && ALLOWED_INPUT_TYPES.indexOf(element.type.toLowerCase()) > -1) {
        var selectionStart = element.selectionStart;
        var selectionEnd = element.selectionEnd;
        var isRangeSelected = selectionStart !== selectionEnd;
        var inputValue = element.value;
        var isReadonly = element.readOnly;
        if (isRangeSelected || selectionStart > 0 && !isForward && !isReadonly || selectionStart !== inputValue.length && isForward && !isReadonly || !!this.props.handleTabKey && !(this.props.shouldInputLoseFocusOnArrowKey && this.props.shouldInputLoseFocusOnArrowKey(element))) {
          return false;
        }
      }
      return true;
    };
    FocusZone2.prototype._shouldWrapFocus = function(element, noWrapDataAttribute) {
      return this.props.checkForNoWrap ? shouldWrapFocus(element, noWrapDataAttribute) : true;
    };
    FocusZone2.prototype._portalContainsElement = function(element) {
      return element && !!this._root.current && portalContainsElement(element, this._root.current);
    };
    FocusZone2.prototype._getDocument = function() {
      return getDocument$1(this._root.current);
    };
    FocusZone2.contextType = MergeStylesShadowRootContext;
    FocusZone2.defaultProps = {
      isCircularNavigation: false,
      direction: FocusZoneDirection.bidirectional,
      shouldRaiseClicks: true,
      // Hardcoding uncontrolled flag for proper interop with FluentUI V9.
      "data-tabster": '{"uncontrolled": {}}'
    };
    return FocusZone2;
  }(React.Component)
);

var getClassNames$m = classNamesFunction();
/**
 * The useLink hook processes the Link component props and returns
 * state, slots and slotProps for consumption by the component.
 */
var useLink = function (props, forwardedRef) {
    var as = props.as, className = props.className, disabled = props.disabled, href = props.href, onClick = props.onClick, styles = props.styles, theme = props.theme, underline = props.underline;
    var rootRef = React.useRef(null);
    var mergedRootRefs = useMergedRefs$1(rootRef, forwardedRef);
    useComponentRef$6(props, rootRef);
    useFocusRects(rootRef);
    var classNames = getClassNames$m(styles, {
        className: className,
        isButton: !href,
        isDisabled: disabled,
        isUnderlined: underline,
        theme: theme,
    });
    var _onClick = function (ev) {
        if (disabled) {
            ev.preventDefault();
        }
        else if (onClick) {
            onClick(ev);
        }
    };
    var rootType = as ? as : href ? 'a' : 'button';
    var state = {};
    var slots = { root: rootType };
    var slotProps = {
        root: __assign$2(__assign$2({}, adjustPropsForRootType(rootType, props)), { 'aria-disabled': disabled, className: classNames.root, onClick: _onClick, ref: mergedRootRefs }),
    };
    return { state: state, slots: slots, slotProps: slotProps };
};
var useComponentRef$6 = function (props, link) {
    React.useImperativeHandle(props.componentRef, function () { return ({
        focus: function () {
            if (link.current) {
                link.current.focus();
            }
        },
    }); }, [link]);
};
var adjustPropsForRootType = function (RootType, props) {
    // Deconstruct the props so we remove props like `as`, `theme` and `styles`
    // as those will always be removed. We also take some props that are optional
    // based on the RootType.
    props.as; var disabled = props.disabled, target = props.target, href = props.href; props.theme; props.getStyles; props.styles; props.componentRef; props.underline; var restProps = __rest$1(props, ["as", "disabled", "target", "href", "theme", "getStyles", "styles", "componentRef", "underline"]);
    // RootType will be a string if we're dealing with an html component
    if (typeof RootType === 'string') {
        // Remove the disabled prop for anchor elements
        if (RootType === 'a') {
            return __assign$2({ target: target, href: disabled ? undefined : href }, restProps);
        }
        // Add the type='button' prop for button elements
        if (RootType === 'button') {
            return __assign$2({ type: 'button', disabled: disabled }, restProps);
        }
        // Remove the target and href props for all other non anchor elements
        return __assign$2(__assign$2({}, restProps), { disabled: disabled });
    }
    // Retain all props except 'as' for ReactComponents
    return __assign$2({ target: target, href: href, disabled: disabled }, restProps);
};

var LinkBase = React.forwardRef(function (props, ref) {
    var _a = useLink(props, ref), slots = _a.slots, slotProps = _a.slotProps;
    return React.createElement(slots.root, __assign$2({}, slotProps.root));
});
LinkBase.displayName = 'LinkBase';

var GlobalClassNames$d = {
    root: 'ms-Link',
};
var getStyles$o = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var className = props.className, isButton = props.isButton, isDisabled = props.isDisabled, isUnderlined = props.isUnderlined, theme = props.theme;
    var semanticColors = theme.semanticColors;
    // Tokens
    var linkColor = semanticColors.link;
    var linkInteractedColor = semanticColors.linkHovered;
    var linkDisabledColor = semanticColors.disabledText;
    var focusBorderColor = semanticColors.focusBorder;
    var classNames = getGlobalClassNames(GlobalClassNames$d, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                color: linkColor,
                outline: 'none',
                fontSize: 'inherit',
                fontWeight: 'inherit',
                textDecoration: isUnderlined ? 'underline' : 'none',
                selectors: (_a = {},
                    _a[".".concat(IsFocusVisibleClassName, " &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus")] = {
                        // Can't use getFocusStyle because it doesn't support wrapping links
                        // https://github.com/microsoft/fluentui/issues/4883#issuecomment-406743543
                        // Using box-shadow and outline allows the focus rect to wrap links that span multiple lines
                        // and helps the focus rect avoid getting clipped.
                        boxShadow: "0 0 0 1px ".concat(focusBorderColor, " inset"),
                        outline: "1px auto ".concat(focusBorderColor),
                        selectors: (_b = {},
                            _b[HighContrastSelector] = {
                                outline: '1px solid WindowText',
                            },
                            _b),
                    },
                    _a[HighContrastSelector] = {
                        // For IE high contrast mode
                        borderBottom: 'none',
                    },
                    _a),
            },
            isButton && {
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'inline',
                margin: 0,
                overflow: 'inherit',
                padding: 0,
                textAlign: 'left',
                textOverflow: 'inherit',
                userSelect: 'text',
                borderBottom: '1px solid transparent', // For Firefox high contrast mode
                selectors: (_c = {},
                    _c[HighContrastSelector] = {
                        color: 'LinkText',
                        forcedColorAdjust: 'none',
                    },
                    _c),
            },
            !isButton && {
                selectors: (_d = {},
                    _d[HighContrastSelector] = {
                        // This is mainly for MessageBar, which sets MsHighContrastAdjust: none by default
                        MsHighContrastAdjust: 'auto',
                        forcedColorAdjust: 'auto',
                    },
                    _d),
            },
            isDisabled && [
                'is-disabled',
                {
                    color: linkDisabledColor,
                    cursor: 'default',
                },
                {
                    selectors: (_e = {
                            '&:link, &:visited': {
                                pointerEvents: 'none',
                            }
                        },
                        _e[HighContrastSelector] = {
                            // We need to specify the color in High Contrast because of the case of Links rendering as buttons.
                            color: 'GrayText',
                        },
                        _e),
                },
            ],
            !isDisabled && {
                selectors: {
                    '&:active, &:hover, &:active:hover': {
                        color: linkInteractedColor,
                        textDecoration: 'underline',
                        selectors: (_f = {},
                            _f[HighContrastSelector] = {
                                color: 'LinkText',
                            },
                            _f),
                    },
                    '&:focus': {
                        color: linkColor,
                        selectors: (_g = {},
                            _g[HighContrastSelector] = {
                                color: 'LinkText',
                            },
                            _g),
                    },
                },
            },
            classNames.root,
            className,
        ],
    };
};

var Link = styled(LinkBase, getStyles$o, undefined, {
    scope: 'Link',
});

/**
 * {@docCategory ContextualMenu}
 */
var ContextualMenuItemType;
(function (ContextualMenuItemType) {
    ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
    ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
    ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
    ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
})(ContextualMenuItemType || (ContextualMenuItemType = {}));

/**
 * Determines the effective checked state of a menu item.
 *
 * @param item {IContextualMenuItem} to get the check state of.
 * @returns {true} if the item is checked.
 * @returns {false} if the item is unchecked.
 * @returns {null} if the item is not checkable.
 */
function getIsChecked(item) {
    if (item.canCheck) {
        return !!(item.isChecked || item.checked);
    }
    if (typeof item.isChecked === 'boolean') {
        return item.isChecked;
    }
    if (typeof item.checked === 'boolean') {
        return item.checked;
    }
    // Item is not checkable.
    return null;
}
function hasSubmenu(item) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return !!(item.subMenuProps || item.items);
}
function isItemDisabled(item) {
    return !!(item.isDisabled || item.disabled);
}
function getMenuItemAriaRole(item) {
    var isChecked = getIsChecked(item);
    var canCheck = isChecked !== null;
    return canCheck ? 'menuitemcheckbox' : 'menuitem';
}

var defaultIconRenderer = function (props) {
    var item = props.item, classNames = props.classNames;
    var iconProps = item.iconProps;
    return React.createElement(Icon, __assign$2({}, iconProps, { className: classNames.icon }));
};
var renderItemIcon = function (props) {
    var item = props.item, hasIcons = props.hasIcons;
    if (!hasIcons) {
        return null;
    }
    if (item.onRenderIcon) {
        return item.onRenderIcon(props, defaultIconRenderer);
    }
    return defaultIconRenderer(props);
};
var renderCheckMarkIcon = function (_a) {
    var onCheckmarkClick = _a.onCheckmarkClick, item = _a.item, classNames = _a.classNames;
    var isItemChecked = getIsChecked(item);
    if (onCheckmarkClick) {
        // Ensures that the item is passed as the first argument to the checkmark click callback.
        var onClick = function (e) { return onCheckmarkClick(item, e); };
        return (React.createElement(Icon, { iconName: item.canCheck !== false && isItemChecked ? 'CheckMark' : '', className: classNames.checkmarkIcon, 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: onClick }));
    }
    return null;
};
var renderItemName = function (_a) {
    var item = _a.item, classNames = _a.classNames;
    /* eslint-disable @typescript-eslint/no-deprecated */
    if (item.text || item.name) {
        return React.createElement("span", { className: classNames.label }, item.text || item.name);
    }
    /* eslint-enable @typescript-eslint/no-deprecated */
    return null;
};
var renderSecondaryText = function (_a) {
    var item = _a.item, classNames = _a.classNames;
    if (item.secondaryText) {
        return React.createElement("span", { className: classNames.secondaryText }, item.secondaryText);
    }
    return null;
};
var renderSubMenuIcon = function (_a) {
    var item = _a.item, classNames = _a.classNames, theme = _a.theme;
    if (hasSubmenu(item)) {
        return (React.createElement(Icon, __assign$2({ iconName: getRTL(theme) ? 'ChevronLeft' : 'ChevronRight' }, item.submenuIconProps, { className: classNames.subMenuIcon })));
    }
    return null;
};
var ContextualMenuItemBase = /** @class */ (function (_super) {
    __extends$1(ContextualMenuItemBase, _super);
    function ContextualMenuItemBase(props) {
        var _this = _super.call(this, props) || this;
        _this.openSubMenu = function () {
            var _a = _this.props, item = _a.item, openSubMenu = _a.openSubMenu, getSubmenuTarget = _a.getSubmenuTarget;
            if (getSubmenuTarget) {
                var submenuTarget = getSubmenuTarget();
                if (hasSubmenu(item) && openSubMenu && submenuTarget) {
                    openSubMenu(item, submenuTarget);
                }
            }
        };
        _this.dismissSubMenu = function () {
            var _a = _this.props, item = _a.item, dismissSubMenu = _a.dismissSubMenu;
            if (hasSubmenu(item) && dismissSubMenu) {
                dismissSubMenu();
            }
        };
        _this.dismissMenu = function (dismissAll) {
            var dismissMenu = _this.props.dismissMenu;
            if (dismissMenu) {
                dismissMenu(undefined /* ev */, dismissAll);
            }
        };
        initializeComponentRef(_this);
        return _this;
    }
    ContextualMenuItemBase.prototype.render = function () {
        var _a = this.props, item = _a.item, classNames = _a.classNames;
        var renderContent = item.onRenderContent || this._renderLayout;
        return (React.createElement("div", { className: item.split ? classNames.linkContentMenu : classNames.linkContent }, renderContent(this.props, {
            renderCheckMarkIcon: renderCheckMarkIcon,
            renderItemIcon: renderItemIcon,
            renderItemName: renderItemName,
            renderSecondaryText: renderSecondaryText,
            renderSubMenuIcon: renderSubMenuIcon,
        })));
    };
    ContextualMenuItemBase.prototype._renderLayout = function (props, defaultRenders) {
        return (React.createElement(React.Fragment, null,
            defaultRenders.renderCheckMarkIcon(props),
            defaultRenders.renderItemIcon(props),
            defaultRenders.renderItemName(props),
            defaultRenders.renderSecondaryText(props),
            defaultRenders.renderSubMenuIcon(props)));
    };
    return ContextualMenuItemBase;
}(React.Component));

/**
 * @deprecated use getStyles exported from VerticalDivider.styles.ts
 */
var getDividerClassNames = memoizeFunction(
// eslint-disable-next-line @typescript-eslint/no-deprecated
function (theme) {
    return mergeStyleSets({
        wrapper: {
            display: 'inline-flex',
            height: '100%',
            alignItems: 'center',
        },
        divider: {
            width: 1,
            height: '100%',
            backgroundColor: theme.palette.neutralTertiaryAlt,
        },
    });
});

var CONTEXTUAL_MENU_ITEM_HEIGHT = 36;
var MediumScreenSelector$1 = getScreenSelector(0, ScreenWidthMaxMedium);
var getMenuItemStyles = memoizeFunction(function (theme) {
    var _a, _b, _c, _d, _e;
    var semanticColors = theme.semanticColors, fonts = theme.fonts, palette = theme.palette;
    var ContextualMenuItemBackgroundHoverColor = semanticColors.menuItemBackgroundHovered;
    var ContextualMenuItemTextHoverColor = semanticColors.menuItemTextHovered;
    var ContextualMenuItemBackgroundSelectedColor = semanticColors.menuItemBackgroundPressed;
    var ContextualMenuItemDividerColor = semanticColors.bodyDivider;
    var menuItemStyles = {
        item: [
            fonts.medium,
            {
                color: semanticColors.bodyText,
                position: 'relative',
                boxSizing: 'border-box',
            },
        ],
        divider: {
            display: 'block',
            height: '1px',
            backgroundColor: ContextualMenuItemDividerColor,
            position: 'relative',
        },
        root: [
            getFocusStyle(theme),
            fonts.medium,
            {
                color: semanticColors.bodyText,
                backgroundColor: 'transparent',
                border: 'none',
                width: '100%',
                height: CONTEXTUAL_MENU_ITEM_HEIGHT,
                lineHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
                display: 'block',
                cursor: 'pointer',
                padding: '0px 8px 0 4px', // inner elements have a margin of 4px (4 + 4 = 8px as on right side)
                textAlign: 'left',
            },
        ],
        rootDisabled: {
            color: semanticColors.disabledBodyText,
            cursor: 'default',
            pointerEvents: 'none',
            selectors: (_a = {},
                _a[HighContrastSelector] = {
                    // ensure disabled text looks different than enabled
                    color: 'GrayText',
                    opacity: 1,
                },
                _a),
        },
        rootHovered: {
            backgroundColor: ContextualMenuItemBackgroundHoverColor,
            color: ContextualMenuItemTextHoverColor,
            selectors: {
                '.ms-ContextualMenu-icon': {
                    color: palette.themeDarkAlt,
                },
                '.ms-ContextualMenu-submenuIcon': {
                    color: palette.neutralPrimary,
                },
            },
        },
        rootFocused: {
            backgroundColor: palette.white,
        },
        rootChecked: {
            selectors: {
                '.ms-ContextualMenu-checkmarkIcon': {
                    color: palette.neutralPrimary,
                },
            },
        },
        rootPressed: {
            backgroundColor: ContextualMenuItemBackgroundSelectedColor,
            selectors: {
                '.ms-ContextualMenu-icon': {
                    color: palette.themeDark,
                },
                '.ms-ContextualMenu-submenuIcon': {
                    color: palette.neutralPrimary,
                },
            },
        },
        rootExpanded: {
            backgroundColor: ContextualMenuItemBackgroundSelectedColor,
            color: semanticColors.bodyTextChecked,
            selectors: (_b = {
                    '.ms-ContextualMenu-submenuIcon': (_c = {},
                        _c[HighContrastSelector] = {
                            // icons inside of anchor tags are not properly inheriting color in high contrast
                            color: 'inherit',
                        },
                        _c)
                },
                _b[HighContrastSelector] = __assign$2({}, getHighContrastNoAdjustStyle()),
                _b),
        },
        linkContent: {
            whiteSpace: 'nowrap',
            height: 'inherit',
            display: 'flex',
            alignItems: 'center',
            maxWidth: '100%',
        },
        anchorLink: {
            padding: '0px 8px 0 4px', // inner elements have a margin of 4px (4 + 4 = 8px as on right side)
            textRendering: 'auto',
            color: 'inherit',
            letterSpacing: 'normal',
            wordSpacing: 'normal',
            textTransform: 'none',
            textIndent: '0px',
            textShadow: 'none',
            textDecoration: 'none',
            boxSizing: 'border-box',
        },
        label: {
            margin: '0 4px',
            verticalAlign: 'middle',
            display: 'inline-block',
            flexGrow: '1',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        secondaryText: {
            color: theme.palette.neutralSecondary,
            paddingLeft: '20px',
            textAlign: 'right',
        },
        icon: {
            display: 'inline-block',
            minHeight: '1px',
            maxHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
            fontSize: IconFontSizes.medium,
            width: IconFontSizes.medium,
            margin: '0 4px',
            verticalAlign: 'middle',
            flexShrink: '0',
            selectors: (_d = {},
                _d[MediumScreenSelector$1] = {
                    fontSize: IconFontSizes.large,
                    width: IconFontSizes.large,
                },
                _d),
        },
        iconColor: {
            color: semanticColors.menuIcon,
        },
        iconDisabled: {
            color: semanticColors.disabledBodyText,
        },
        checkmarkIcon: {
            color: semanticColors.bodySubtext,
        },
        subMenuIcon: {
            height: CONTEXTUAL_MENU_ITEM_HEIGHT,
            lineHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
            color: palette.neutralSecondary,
            textAlign: 'center',
            display: 'inline-block',
            verticalAlign: 'middle',
            flexShrink: '0',
            fontSize: IconFontSizes.small, // 12px
            selectors: (_e = {
                    ':hover': {
                        color: palette.neutralPrimary,
                    },
                    ':active': {
                        color: palette.neutralPrimary,
                    }
                },
                _e[MediumScreenSelector$1] = {
                    fontSize: IconFontSizes.medium, // 16px
                },
                _e),
        },
        splitButtonFlexContainer: [
            getFocusStyle(theme),
            {
                display: 'flex',
                height: CONTEXTUAL_MENU_ITEM_HEIGHT,
                flexWrap: 'nowrap',
                justifyContent: 'center',
                alignItems: 'flex-start',
            },
        ],
    };
    return concatStyleSets(menuItemStyles);
});

var CONTEXTUAL_SPLIT_MENU_MINWIDTH = '28px';
var MediumScreenSelector = getScreenSelector(0, ScreenWidthMaxMedium);
var getSplitButtonVerticalDividerClassNames = memoizeFunction(
/* eslint-disable @typescript-eslint/no-deprecated */
function (theme) {
    var _a;
    return mergeStyleSets(getDividerClassNames(theme), {
        /* eslint-enable @typescript-eslint/no-deprecated */
        wrapper: {
            position: 'absolute',
            right: 28, // width of the splitMenu based on the padding plus icon fontSize
            selectors: (_a = {},
                _a[MediumScreenSelector] = {
                    right: 32, // fontSize of the icon increased from 12px to 16px
                },
                _a),
        },
        divider: {
            height: 16,
            width: 1,
        },
    });
});
var GlobalClassNames$c = {
    item: 'ms-ContextualMenu-item',
    divider: 'ms-ContextualMenu-divider',
    root: 'ms-ContextualMenu-link',
    isChecked: 'is-checked',
    isExpanded: 'is-expanded',
    isDisabled: 'is-disabled',
    linkContent: 'ms-ContextualMenu-linkContent',
    linkContentMenu: 'ms-ContextualMenu-linkContent',
    icon: 'ms-ContextualMenu-icon',
    iconColor: 'ms-ContextualMenu-iconColor',
    checkmarkIcon: 'ms-ContextualMenu-checkmarkIcon',
    subMenuIcon: 'ms-ContextualMenu-submenuIcon',
    label: 'ms-ContextualMenu-itemText',
    secondaryText: 'ms-ContextualMenu-secondaryText',
    splitMenu: 'ms-ContextualMenu-splitMenu',
    screenReaderText: 'ms-ContextualMenu-screenReaderText',
};
/**
 * @deprecated Will be removed in \>= 7.0.
 * This is a package-internal method that has been depended on.
 * It is being kept in this form for backwards compatibility.
 * @internal
 */
// TODO: Audit perf. impact of and potentially remove memoizeFunction.
// https://github.com/microsoft/fluentui/issues/5534
var getItemClassNames = memoizeFunction(function (theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className) {
    var _a, _b, _c, _d;
    var styles = getMenuItemStyles(theme);
    var classNames = getGlobalClassNames(GlobalClassNames$c, theme);
    return mergeStyleSets({
        item: [classNames.item, styles.item, itemClassName],
        divider: [classNames.divider, styles.divider, dividerClassName],
        root: [
            classNames.root,
            styles.root,
            checked && [classNames.isChecked, styles.rootChecked],
            isAnchorLink && styles.anchorLink,
            expanded && [classNames.isExpanded, styles.rootExpanded],
            disabled && [classNames.isDisabled, styles.rootDisabled],
            !disabled &&
                !expanded && [
                {
                    selectors: (_a = {
                            ':hover': styles.rootHovered,
                            ':active': styles.rootPressed
                        },
                        // eslint-disable-next-line @fluentui/max-len
                        _a[".".concat(IsFocusVisibleClassName, " &:focus, .").concat(IsFocusVisibleClassName, " &:focus:hover, :host(.").concat(IsFocusVisibleClassName, ") &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus:hover")] = styles.rootFocused,
                        _a[".".concat(IsFocusVisibleClassName, " &:hover, :host(.").concat(IsFocusVisibleClassName, ") &:hover")] = {
                            background: 'inherit;',
                        },
                        _a),
                },
            ],
            className,
        ],
        splitPrimary: [
            styles.root,
            {
                width: "calc(100% - ".concat(CONTEXTUAL_SPLIT_MENU_MINWIDTH, ")"),
            },
            checked && ['is-checked', styles.rootChecked],
            (disabled || primaryDisabled) && ['is-disabled', styles.rootDisabled],
            !(disabled || primaryDisabled) &&
                !checked && [
                {
                    selectors: (_b = {
                            ':hover': styles.rootHovered
                        },
                        // when hovering over the splitPrimary also affect the splitMenu
                        _b[":hover ~ .".concat(classNames.splitMenu)] = styles.rootHovered,
                        _b[':active'] = styles.rootPressed,
                        // eslint-disable-next-line @fluentui/max-len
                        _b[".".concat(IsFocusVisibleClassName, " &:focus, .").concat(IsFocusVisibleClassName, " &:focus:hover, :host(.").concat(IsFocusVisibleClassName, ") &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus:hover")] = styles.rootFocused,
                        _b[".".concat(IsFocusVisibleClassName, " &:hover, :host(.").concat(IsFocusVisibleClassName, ") &:hover")] = {
                            background: 'inherit;',
                        },
                        _b),
                },
            ],
        ],
        splitMenu: [
            classNames.splitMenu,
            styles.root,
            {
                flexBasis: '0',
                padding: '0 8px',
                minWidth: CONTEXTUAL_SPLIT_MENU_MINWIDTH,
            },
            expanded && ['is-expanded', styles.rootExpanded],
            disabled && ['is-disabled', styles.rootDisabled],
            !disabled &&
                !expanded && [
                {
                    selectors: (_c = {
                            ':hover': styles.rootHovered,
                            ':active': styles.rootPressed
                        },
                        // eslint-disable-next-line @fluentui/max-len
                        _c[".".concat(IsFocusVisibleClassName, " &:focus, .").concat(IsFocusVisibleClassName, " &:focus:hover, :host(.").concat(IsFocusVisibleClassName, ") &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus:hover")] = styles.rootFocused,
                        _c[".".concat(IsFocusVisibleClassName, " &:hover, :host(.").concat(IsFocusVisibleClassName, ") &:hover")] = {
                            background: 'inherit;',
                        },
                        _c),
                },
            ],
        ],
        anchorLink: styles.anchorLink,
        linkContent: [classNames.linkContent, styles.linkContent],
        linkContentMenu: [
            classNames.linkContentMenu,
            styles.linkContent,
            {
                justifyContent: 'center',
            },
        ],
        icon: [
            classNames.icon,
            knownIcon && styles.iconColor,
            styles.icon,
            iconClassName,
            disabled && [classNames.isDisabled, styles.iconDisabled],
        ],
        iconColor: styles.iconColor,
        checkmarkIcon: [classNames.checkmarkIcon, knownIcon && styles.checkmarkIcon, styles.icon, iconClassName],
        subMenuIcon: [
            classNames.subMenuIcon,
            styles.subMenuIcon,
            subMenuClassName,
            expanded && { color: theme.palette.neutralPrimary },
            disabled && [styles.iconDisabled],
        ],
        label: [classNames.label, styles.label],
        secondaryText: [classNames.secondaryText, styles.secondaryText],
        splitContainer: [
            styles.splitButtonFlexContainer,
            !disabled &&
                !checked && [
                {
                    selectors: (_d = {},
                        // eslint-disable-next-line @fluentui/max-len
                        _d[".".concat(IsFocusVisibleClassName, " &:focus, .").concat(IsFocusVisibleClassName, " &:focus:hover, :host(.").concat(IsFocusVisibleClassName, ") &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus:hover")] = styles.rootFocused,
                        _d),
                },
            ],
        ],
        screenReaderText: [
            classNames.screenReaderText,
            styles.screenReaderText,
            hiddenContentStyle,
            { visibility: 'hidden' },
        ],
    });
});
/**
 * Wrapper function for generating ContextualMenuItem classNames which adheres to
 * the getStyles API, but invokes memoized className generator function with
 * primitive values.
 *
 * @param props - the ContextualMenuItem style props used to generate its styles.
 */
var getItemStyles = function (props) {
    var theme = props.theme, disabled = props.disabled, expanded = props.expanded, checked = props.checked, isAnchorLink = props.isAnchorLink, knownIcon = props.knownIcon, itemClassName = props.itemClassName, dividerClassName = props.dividerClassName, iconClassName = props.iconClassName, subMenuClassName = props.subMenuClassName, primaryDisabled = props.primaryDisabled, className = props.className;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return getItemClassNames(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className);
};

/**
 * ContextualMenuItem description
 */
var ContextualMenuItem = styled(ContextualMenuItemBase, getItemStyles, undefined, { scope: 'ContextualMenuItem' });

var ContextualMenuItemWrapper = /** @class */ (function (_super) {
    __extends$1(ContextualMenuItemWrapper, _super);
    function ContextualMenuItemWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._onItemMouseEnter = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) {
                onItemMouseEnter(item, ev, ev.currentTarget);
            }
        };
        _this._onItemClick = function (ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) {
                onItemClickBase(item, ev, ev.currentTarget);
            }
        };
        _this._onItemMouseLeave = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseLeave = _a.onItemMouseLeave;
            if (onItemMouseLeave) {
                onItemMouseLeave(item, ev);
            }
        };
        _this._onItemKeyDown = function (ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            if (onItemKeyDown) {
                onItemKeyDown(item, ev);
            }
        };
        _this._onItemMouseMove = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) {
                onItemMouseMove(item, ev, ev.currentTarget);
            }
        };
        _this._getSubmenuTarget = function () {
            return undefined;
        };
        initializeComponentRef(_this);
        return _this;
    }
    ContextualMenuItemWrapper.prototype.shouldComponentUpdate = function (newProps) {
        return !shallowCompare(newProps, this.props);
    };
    return ContextualMenuItemWrapper;
}(React.Component));

var KTP_PREFIX = 'ktp';
var KTP_SEPARATOR = '-';
var DATAKTP_TARGET = 'data-ktp-target';
var DATAKTP_EXECUTE_TARGET = 'data-ktp-execute-target';
var KTP_LAYER_ID = 'ktp-layer-id';
// Events
var KeytipEvents;
(function (KeytipEvents) {
    KeytipEvents.KEYTIP_ADDED = 'keytipAdded';
    KeytipEvents.KEYTIP_REMOVED = 'keytipRemoved';
    KeytipEvents.KEYTIP_UPDATED = 'keytipUpdated';
    KeytipEvents.PERSISTED_KEYTIP_ADDED = 'persistedKeytipAdded';
    KeytipEvents.PERSISTED_KEYTIP_REMOVED = 'persistedKeytipRemoved';
    KeytipEvents.PERSISTED_KEYTIP_EXECUTE = 'persistedKeytipExecute';
    KeytipEvents.ENTER_KEYTIP_MODE = 'enterKeytipMode';
    KeytipEvents.EXIT_KEYTIP_MODE = 'exitKeytipMode';
})(KeytipEvents || (KeytipEvents = {}));

/**
 * This class is responsible for handling registering, updating, and unregistering of keytips
 */
var KeytipManager = /** @class */ (function () {
    function KeytipManager() {
        this.keytips = {};
        this.persistedKeytips = {};
        this.sequenceMapping = {};
        // This is (and should be) updated and kept in sync
        // with the inKeytipMode in KeytipLayer.
        this.inKeytipMode = false;
        // Boolean that gets checked before entering keytip mode by the KeytipLayer
        // Used for an override in special cases (e.g. Disable entering keytip mode when a modal is shown)
        this.shouldEnterKeytipMode = true;
        // Boolean to indicate whether to delay firing an event to update subscribers of
        // keytip data changed.
        this.delayUpdatingKeytipChange = false;
    }
    /**
     * Static function to get singleton KeytipManager instance
     *
     * @returns Singleton KeytipManager instance
     */
    KeytipManager.getInstance = function () {
        return this._instance;
    };
    /**
     * Initialization code to set set parameters to define
     * how the KeytipManager handles keytip data.
     *
     * @param delayUpdatingKeytipChange - T/F if we should delay notifiying keytip subscribers
     * of keytip changes
     */
    KeytipManager.prototype.init = function (delayUpdatingKeytipChange) {
        this.delayUpdatingKeytipChange = delayUpdatingKeytipChange;
    };
    /**
     * Registers a keytip
     *
     * @param keytipProps - Keytip to register
     * @param persisted - T/F if this keytip should be persisted, default is false
     * @returns Unique ID for this keytip
     */
    KeytipManager.prototype.register = function (keytipProps, persisted) {
        if (persisted === undefined) { persisted = false; }
        var props = keytipProps;
        if (!persisted) {
            // Add the overflowSetSequence if necessary
            props = this.addParentOverflow(keytipProps);
            this.sequenceMapping[props.keySequences.toString()] = props;
        }
        // Create a unique keytip
        var uniqueKeytip = this._getUniqueKtp(props);
        // Add to dictionary
        persisted
            ? (this.persistedKeytips[uniqueKeytip.uniqueID] = uniqueKeytip)
            : (this.keytips[uniqueKeytip.uniqueID] = uniqueKeytip);
        // We only want to add something new if we are currently showing keytip mode
        if (this.inKeytipMode || !this.delayUpdatingKeytipChange) {
            var event_1 = persisted ? KeytipEvents.PERSISTED_KEYTIP_ADDED : KeytipEvents.KEYTIP_ADDED;
            EventGroup.raise(this, event_1, {
                keytip: props,
                uniqueID: uniqueKeytip.uniqueID,
            });
        }
        return uniqueKeytip.uniqueID;
    };
    /**
     * Update a keytip
     *
     * @param keytipProps - Keytip to update
     * @param uniqueID - Unique ID of this keytip
     */
    KeytipManager.prototype.update = function (keytipProps, uniqueID) {
        var newKeytipProps = this.addParentOverflow(keytipProps);
        var uniqueKeytip = this._getUniqueKtp(newKeytipProps, uniqueID);
        var oldKeyTip = this.keytips[uniqueID];
        if (oldKeyTip) {
            // Update everything except 'visible'
            uniqueKeytip.keytip.visible = oldKeyTip.keytip.visible;
            // Update keytip in this.keytips
            this.keytips[uniqueID] = uniqueKeytip;
            // Update the sequence to be up to date
            delete this.sequenceMapping[oldKeyTip.keytip.keySequences.toString()];
            this.sequenceMapping[uniqueKeytip.keytip.keySequences.toString()] = uniqueKeytip.keytip;
            // Raise event only if we are currently in keytip mode
            if (this.inKeytipMode || !this.delayUpdatingKeytipChange) {
                EventGroup.raise(this, KeytipEvents.KEYTIP_UPDATED, {
                    keytip: uniqueKeytip.keytip,
                    uniqueID: uniqueKeytip.uniqueID,
                });
            }
        }
    };
    /**
     * Unregisters a keytip
     *
     * @param keytipToRemove - IKeytipProps of the keytip to remove
     * @param uniqueID - Unique ID of this keytip
     * @param persisted - T/F if this keytip should be persisted, default is false
     */
    KeytipManager.prototype.unregister = function (keytipToRemove, uniqueID, persisted) {
        if (persisted === undefined) { persisted = false; }
        persisted ? delete this.persistedKeytips[uniqueID] : delete this.keytips[uniqueID];
        !persisted && delete this.sequenceMapping[keytipToRemove.keySequences.toString()];
        var event = persisted ? KeytipEvents.PERSISTED_KEYTIP_REMOVED : KeytipEvents.KEYTIP_REMOVED;
        // Update keytips only if we're in keytip mode
        if (this.inKeytipMode || !this.delayUpdatingKeytipChange) {
            EventGroup.raise(this, event, {
                keytip: keytipToRemove,
                uniqueID: uniqueID,
            });
        }
    };
    /**
     * Manual call to enter keytip mode
     */
    KeytipManager.prototype.enterKeytipMode = function () {
        EventGroup.raise(this, KeytipEvents.ENTER_KEYTIP_MODE);
    };
    /**
     * Manual call to exit keytip mode
     */
    KeytipManager.prototype.exitKeytipMode = function () {
        EventGroup.raise(this, KeytipEvents.EXIT_KEYTIP_MODE);
    };
    /**
     * Gets all IKeytipProps from this.keytips
     *
     * @returns All keytips stored in the manager
     */
    KeytipManager.prototype.getKeytips = function () {
        var _this = this;
        return Object.keys(this.keytips).map(function (key) { return _this.keytips[key].keytip; });
    };
    /**
     * Adds the overflowSetSequence to the keytipProps if its parent keytip also has it
     *
     * @param keytipProps - Keytip props to add overflowSetSequence to if necessary
     * @returns - Modified keytip props, if needed to be modified
     */
    KeytipManager.prototype.addParentOverflow = function (keytipProps) {
        var fullSequence = __spreadArray([], keytipProps.keySequences, true);
        fullSequence.pop();
        if (fullSequence.length !== 0) {
            var parentKeytip = this.sequenceMapping[fullSequence.toString()];
            if (parentKeytip && parentKeytip.overflowSetSequence) {
                return __assign$2(__assign$2({}, keytipProps), { overflowSetSequence: parentKeytip.overflowSetSequence });
            }
        }
        return keytipProps;
    };
    /**
     * Public function to bind for overflow items that have a submenu
     */
    KeytipManager.prototype.menuExecute = function (overflowButtonSequences, keytipSequences) {
        EventGroup.raise(this, KeytipEvents.PERSISTED_KEYTIP_EXECUTE, {
            overflowButtonSequences: overflowButtonSequences,
            keytipSequences: keytipSequences,
        });
    };
    /**
     * Creates an IUniqueKeytip object
     *
     * @param keytipProps - IKeytipProps
     * @param uniqueID - Unique ID, will default to the next unique ID if not passed
     * @returns IUniqueKeytip object
     */
    KeytipManager.prototype._getUniqueKtp = function (keytipProps, uniqueID) {
        if (uniqueID === undefined) { uniqueID = getId(); }
        return { keytip: __assign$2({}, keytipProps), uniqueID: uniqueID };
    };
    KeytipManager._instance = new KeytipManager();
    return KeytipManager;
}());

/**
 * Converts a whole set of KeySequences into one keytip ID, which will be the ID for the last keytip sequence specified
 * keySequences should not include the initial keytip 'start' sequence.
 *
 * @param keySequences - Full path of IKeySequences for one keytip.
 * @returns String to use for the keytip ID.
 */
function sequencesToID(keySequences) {
    return keySequences.reduce(function (prevValue, keySequence) {
        return prevValue + KTP_SEPARATOR + keySequence.split('').join(KTP_SEPARATOR);
    }, KTP_PREFIX);
}
/**
 * Merges an overflow sequence with a key sequence.
 *
 * @param keySequences - Full sequence for one keytip.
 * @param overflowKeySequences - Full overflow keytip sequence.
 * @returns Sequence that will be used by the keytip when in the overflow.
 */
function mergeOverflows(keySequences, overflowKeySequences) {
    var overflowSequenceLen = overflowKeySequences.length;
    var overflowSequence = __spreadArray([], overflowKeySequences, true).pop();
    var newKeySequences = __spreadArray([], keySequences, true);
    return addElementAtIndex(newKeySequences, overflowSequenceLen - 1, overflowSequence);
}
/**
 * Gets the aria-describedby value to put on the component with this keytip.
 *
 * @param keySequences - KeySequences of the keytip.
 * @returns The aria-describedby value to set on the component with this keytip.
 */
function getAriaDescribedBy(keySequences) {
    var describedby = ' ' + KTP_LAYER_ID;
    if (!keySequences.length) {
        // Return just the layer ID
        return describedby;
    }
    return describedby + ' ' + sequencesToID(keySequences);
}

/**
 * Hook that creates attributes for components which are enabled with Keytip.
 */
function useKeytipData(options) {
    var uniqueId = React.useRef();
    var keytipProps = options.keytipProps
        ? __assign$2({ disabled: options.disabled }, options.keytipProps) : undefined;
    var keytipManager = useConst(KeytipManager.getInstance());
    var prevOptions = usePrevious$1(options);
    // useLayoutEffect used to strictly emulate didUpdate/didMount behavior
    useIsomorphicLayoutEffect$1(function () {
        if (uniqueId.current &&
            keytipProps &&
            ((prevOptions === null || prevOptions === undefined ? undefined : prevOptions.keytipProps) !== options.keytipProps || (prevOptions === null || prevOptions === undefined ? undefined : prevOptions.disabled) !== options.disabled)) {
            keytipManager.update(keytipProps, uniqueId.current);
        }
    });
    useIsomorphicLayoutEffect$1(function () {
        // Register Keytip in KeytipManager
        if (keytipProps) {
            uniqueId.current = keytipManager.register(keytipProps);
        }
        return function () {
            // Unregister Keytip in KeytipManager
            keytipProps && keytipManager.unregister(keytipProps, uniqueId.current);
        };
        // this is meant to run only at mount, and updates are handled separately
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var nativeKeytipProps = {
        ariaDescribedBy: options.ariaDescribedBy,
        keytipId: undefined,
    };
    if (keytipProps) {
        nativeKeytipProps = getKeytipData(keytipManager, keytipProps, options.ariaDescribedBy);
    }
    return nativeKeytipProps;
}
/**
 * Gets the aria- and data- attributes to attach to the component
 * @param keytipProps - options for Keytip
 * @param describedByPrepend - ariaDescribedBy value to prepend
 */
function getKeytipData(keytipManager, keytipProps, describedByPrepend) {
    // Add the parent overflow sequence if necessary
    var newKeytipProps = keytipManager.addParentOverflow(keytipProps);
    // Construct aria-describedby and data-ktp-id attributes
    var ariaDescribedBy = mergeAriaAttributeValues(describedByPrepend, getAriaDescribedBy(newKeytipProps.keySequences));
    var keySequences = __spreadArray([], newKeytipProps.keySequences, true);
    if (newKeytipProps.overflowSetSequence) {
        keySequences = mergeOverflows(keySequences, newKeytipProps.overflowSetSequence);
    }
    var keytipId = sequencesToID(keySequences);
    return {
        ariaDescribedBy: ariaDescribedBy,
        keytipId: keytipId,
    };
}

/**
 * A small element to help the target component correctly read out its aria-describedby for its Keytip
 * {@docCategory Keytips}
 */
var KeytipData = function (props) {
    var _a;
    var children = props.children, keytipDataProps = __rest$1(props, ["children"]);
    var _b = useKeytipData(keytipDataProps), keytipId = _b.keytipId, ariaDescribedBy = _b.ariaDescribedBy;
    return children((_a = {},
        _a[DATAKTP_TARGET] = keytipId,
        _a[DATAKTP_EXECUTE_TARGET] = keytipId,
        _a['aria-describedby'] = ariaDescribedBy,
        _a));
};

var ContextualMenuAnchor = /** @class */ (function (_super) {
    __extends$1(ContextualMenuAnchor, _super);
    function ContextualMenuAnchor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._anchor = React.createRef();
        _this._getMemoizedMenuButtonKeytipProps = memoizeFunction(function (keytipProps) {
            return __assign$2(__assign$2({}, keytipProps), { hasMenu: true });
        });
        _this._getSubmenuTarget = function () {
            return _this._anchor.current ? _this._anchor.current : undefined;
        };
        _this._onItemClick = function (ev) {
            var _a = _this.props, item = _a.item, onItemClick = _a.onItemClick;
            if (onItemClick) {
                onItemClick(item, ev);
            }
        };
        _this._renderAriaDescription = function (ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? (React.createElement("span", { id: _this._ariaDescriptionId, className: className }, ariaDescription)) : null;
        };
        return _this;
    }
    ContextualMenuAnchor.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, expandedMenuItemKey = _a.expandedMenuItemKey, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var ChildrenRenderer = ContextualMenuItem;
        if (this.props.item.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(this.props.item.contextualMenuItemAs, ChildrenRenderer);
        }
        if (this.props.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(this.props.contextualMenuItemAs, ChildrenRenderer);
        }
        var anchorRel = item.rel;
        if (item.target && item.target.toLowerCase() === '_blank') {
            anchorRel = anchorRel ? anchorRel : 'nofollow noopener noreferrer'; // Safe default to prevent tabjacking
        }
        var itemHasSubmenu = hasSubmenu(item);
        var nativeProps = getNativeProps$1(item, anchorProperties$1);
        var disabled = isItemDisabled(item);
        var itemProps = item.itemProps, ariaDescription = item.ariaDescription;
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) {
            keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        }
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        if (ariaDescription) {
            this._ariaDescriptionId = getId();
        }
        var ariaDescribedByIds = mergeAriaAttributeValues(item.ariaDescribedBy, ariaDescription ? this._ariaDescriptionId : undefined, nativeProps['aria-describedby']);
        var additionalItemProperties = {
            'aria-describedby': ariaDescribedByIds,
        };
        return (React.createElement("div", null,
            React.createElement(KeytipData, { keytipProps: item.keytipProps, ariaDescribedBy: ariaDescribedByIds, disabled: disabled }, function (keytipAttributes) { return (React.createElement("a", __assign$2({}, additionalItemProperties, nativeProps, keytipAttributes, { ref: _this._anchor, href: item.href, target: item.target, rel: anchorRel, className: classNames.root, role: "menuitem", "aria-haspopup": itemHasSubmenu || undefined, "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined, "aria-posinset": focusableElementIndex + 1, "aria-setsize": totalItemCount, "aria-disabled": isItemDisabled(item), 
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                style: item.style, onClick: _this._onItemClick, onMouseEnter: _this._onItemMouseEnter, onMouseLeave: _this._onItemMouseLeave, onMouseMove: _this._onItemMouseMove, onKeyDown: itemHasSubmenu ? _this._onItemKeyDown : undefined }),
                React.createElement(ChildrenRenderer, __assign$2({ componentRef: item.componentRef, item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: _this._getSubmenuTarget }, itemProps)),
                _this._renderAriaDescription(ariaDescription, classNames.screenReaderText))); })));
    };
    return ContextualMenuAnchor;
}(ContextualMenuItemWrapper));

var ContextualMenuButton = /** @class */ (function (_super) {
    __extends$1(ContextualMenuButton, _super);
    function ContextualMenuButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._btn = React.createRef();
        _this._getMemoizedMenuButtonKeytipProps = memoizeFunction(function (keytipProps) {
            return __assign$2(__assign$2({}, keytipProps), { hasMenu: true });
        });
        _this._renderAriaDescription = function (ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? (React.createElement("span", { id: _this._ariaDescriptionId, className: className }, ariaDescription)) : null;
        };
        _this._getSubmenuTarget = function () {
            return _this._btn.current ? _this._btn.current : undefined;
        };
        return _this;
    }
    ContextualMenuButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, contextualMenuItemAs = _a.contextualMenuItemAs, expandedMenuItemKey = _a.expandedMenuItemKey, onItemMouseDown = _a.onItemMouseDown, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var ChildrenRenderer = ContextualMenuItem;
        if (item.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(item.contextualMenuItemAs, ChildrenRenderer);
        }
        if (contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(contextualMenuItemAs, ChildrenRenderer);
        }
        var isChecked = getIsChecked(item);
        var canCheck = isChecked !== null;
        var defaultRole = getMenuItemAriaRole(item);
        var itemHasSubmenu = hasSubmenu(item);
        var itemProps = item.itemProps, ariaLabel = item.ariaLabel, ariaDescription = item.ariaDescription;
        var buttonNativeProperties = getNativeProps$1(item, buttonProperties$1);
        // Do not add the disabled attribute to the button so that it is focusable
        delete buttonNativeProperties.disabled;
        var itemRole = item.role || defaultRole;
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        if (ariaDescription) {
            this._ariaDescriptionId = getId();
        }
        var ariaDescribedByIds = mergeAriaAttributeValues(item.ariaDescribedBy, ariaDescription ? this._ariaDescriptionId : undefined, buttonNativeProperties['aria-describedby']);
        var itemButtonProperties = {
            className: classNames.root,
            onClick: this._onItemClick,
            onKeyDown: itemHasSubmenu ? this._onItemKeyDown : undefined,
            onMouseEnter: this._onItemMouseEnter,
            onMouseLeave: this._onItemMouseLeave,
            onMouseDown: function (ev) {
                return onItemMouseDown ? onItemMouseDown(item, ev) : undefined;
            },
            onMouseMove: this._onItemMouseMove,
            href: item.href,
            title: item.title,
            'aria-label': ariaLabel,
            'aria-describedby': ariaDescribedByIds,
            'aria-haspopup': itemHasSubmenu || undefined,
            'aria-expanded': itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
            'aria-posinset': focusableElementIndex + 1,
            'aria-setsize': totalItemCount,
            'aria-disabled': isItemDisabled(item),
            'aria-checked': (itemRole === 'menuitemcheckbox' || itemRole === 'menuitemradio') && canCheck ? !!isChecked : undefined,
            'aria-selected': itemRole === 'menuitem' && canCheck ? !!isChecked : undefined,
            role: itemRole,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            style: item.style,
        };
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) {
            keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        }
        return (React.createElement(KeytipData, { keytipProps: keytipProps, ariaDescribedBy: ariaDescribedByIds, disabled: isItemDisabled(item) }, function (keytipAttributes) { return (React.createElement("button", __assign$2({ ref: _this._btn }, buttonNativeProperties, itemButtonProperties, keytipAttributes),
            React.createElement(ChildrenRenderer, __assign$2({ componentRef: item.componentRef, item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: _this._getSubmenuTarget }, itemProps)),
            _this._renderAriaDescription(ariaDescription, classNames.screenReaderText))); }));
    };
    return ContextualMenuButton;
}(ContextualMenuItemWrapper));

var getStyles$n = function (props) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var theme = props.theme, getClassNames = props.getClassNames, className = props.className;
    if (!theme) {
        throw new Error('Theme is undefined or null.');
    }
    if (getClassNames) {
        var names = getClassNames(theme);
        return {
            wrapper: [names.wrapper],
            divider: [names.divider],
        };
    }
    return {
        wrapper: [
            {
                display: 'inline-flex',
                height: '100%',
                alignItems: 'center',
            },
            className,
        ],
        divider: [
            {
                width: 1,
                height: '100%',
                backgroundColor: theme.palette.neutralTertiaryAlt,
            },
        ],
    };
};

var getClassNames$l = classNamesFunction();
var VerticalDividerBase = React.forwardRef(function (props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var styles = props.styles, theme = props.theme, deprecatedGetClassNames = props.getClassNames, className = props.className;
    var classNames = getClassNames$l(styles, { theme: theme, getClassNames: deprecatedGetClassNames, className: className });
    return (React.createElement("span", { className: classNames.wrapper, ref: ref },
        React.createElement("span", { className: classNames.divider })));
});
VerticalDividerBase.displayName = 'VerticalDividerBase';

var VerticalDivider = styled(VerticalDividerBase, getStyles$n, undefined, {
    scope: 'VerticalDivider',
});

var TouchIdleDelay$1 = 500; /* ms */
var ContextualMenuSplitButton = /** @class */ (function (_super) {
    __extends$1(ContextualMenuSplitButton, _super);
    function ContextualMenuSplitButton(props) {
        var _this = _super.call(this, props) || this;
        _this._getMemoizedMenuButtonKeytipProps = memoizeFunction(function (keytipProps) {
            return __assign$2(__assign$2({}, keytipProps), { hasMenu: true });
        });
        _this._onItemKeyDown = function (ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === KeyCodes.enter) {
                _this._executeItemClick(ev);
                ev.preventDefault();
                ev.stopPropagation();
            }
            else if (onItemKeyDown) {
                onItemKeyDown(item, ev);
            }
        };
        _this._getSubmenuTarget = function () {
            return _this._splitButton;
        };
        _this._renderAriaDescription = function (ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? (React.createElement("span", { id: _this._ariaDescriptionId, className: className }, ariaDescription)) : null;
        };
        _this._onItemMouseEnterPrimary = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) {
                onItemMouseEnter(__assign$2(__assign$2({}, item), { subMenuProps: undefined, items: undefined }), ev, _this._splitButton);
            }
        };
        _this._onItemMouseEnterIcon = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) {
                onItemMouseEnter(item, ev, _this._splitButton);
            }
        };
        _this._onItemMouseMovePrimary = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) {
                onItemMouseMove(__assign$2(__assign$2({}, item), { subMenuProps: undefined, items: undefined }), ev, _this._splitButton);
            }
        };
        _this._onItemMouseMoveIcon = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) {
                onItemMouseMove(item, ev, _this._splitButton);
            }
        };
        _this._onIconItemClick = function (ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) {
                onItemClickBase(item, ev, (_this._splitButton ? _this._splitButton : ev.currentTarget));
            }
        };
        _this._executeItemClick = function (ev) {
            var _a = _this.props, item = _a.item, executeItemClick = _a.executeItemClick, onItemClick = _a.onItemClick;
            if (item.disabled || item.isDisabled) {
                return;
            }
            if (_this._processingTouch && !item.canCheck && onItemClick) {
                return onItemClick(item, ev);
            }
            if (executeItemClick) {
                executeItemClick(item, ev);
            }
        };
        _this._onTouchStart = function (ev) {
            if (_this._splitButton && !('onpointerdown' in _this._splitButton)) {
                _this._handleTouchAndPointerEvent(ev);
            }
        };
        _this._onPointerDown = function (ev) {
            if (ev.pointerType === 'touch') {
                _this._handleTouchAndPointerEvent(ev);
                ev.preventDefault();
                ev.stopImmediatePropagation();
            }
        };
        _this._async = new Async(_this);
        _this._events = new EventGroup(_this);
        _this._dismissLabelId = getId();
        return _this;
    }
    ContextualMenuSplitButton.prototype.componentDidMount = function () {
        if (this._splitButton && 'onpointerdown' in this._splitButton) {
            this._events.on(this._splitButton, 'pointerdown', this._onPointerDown, true);
        }
    };
    ContextualMenuSplitButton.prototype.componentWillUnmount = function () {
        this._async.dispose();
        this._events.dispose();
    };
    ContextualMenuSplitButton.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, item = _b.item, classNames = _b.classNames, index = _b.index, focusableElementIndex = _b.focusableElementIndex, totalItemCount = _b.totalItemCount, hasCheckmarks = _b.hasCheckmarks, hasIcons = _b.hasIcons, onItemMouseLeave = _b.onItemMouseLeave, expandedMenuItemKey = _b.expandedMenuItemKey;
        var itemHasSubmenu = hasSubmenu(item);
        var keytipProps = item.keytipProps;
        if (keytipProps) {
            keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        }
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        var ariaDescription = item.ariaDescription;
        if (ariaDescription) {
            this._ariaDescriptionId = getId();
        }
        var ariaChecked = (_a = getIsChecked(item)) !== null && _a !== undefined ? _a : undefined;
        return (React.createElement(KeytipData, { keytipProps: keytipProps, disabled: isItemDisabled(item) }, function (keytipAttributes) { return (React.createElement("div", { "data-ktp-target": keytipAttributes['data-ktp-target'], ref: function (splitButton) { return (_this._splitButton = splitButton); }, role: getMenuItemAriaRole(item), "aria-label": item.ariaLabel, className: classNames.splitContainer, "aria-disabled": isItemDisabled(item), "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined, "aria-haspopup": true, "aria-describedby": mergeAriaAttributeValues(item.ariaDescribedBy, ariaDescription ? _this._ariaDescriptionId : undefined, keytipAttributes['aria-describedby']), "aria-checked": ariaChecked, "aria-posinset": focusableElementIndex + 1, "aria-setsize": totalItemCount, onMouseEnter: _this._onItemMouseEnterPrimary, onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(_this, __assign$2(__assign$2({}, item), { subMenuProps: null, items: null })) : undefined, onMouseMove: _this._onItemMouseMovePrimary, onKeyDown: _this._onItemKeyDown, onClick: _this._executeItemClick, onTouchStart: _this._onTouchStart, tabIndex: 0, "data-is-focusable": true, "aria-roledescription": item['aria-roledescription'] },
            _this._renderSplitPrimaryButton(item, classNames, index, hasCheckmarks, hasIcons),
            _this._renderSplitDivider(item),
            _this._renderSplitIconButton(item, classNames, index, keytipAttributes),
            _this._renderAriaDescription(ariaDescription, classNames.screenReaderText))); }));
    };
    ContextualMenuSplitButton.prototype._renderSplitPrimaryButton = function (item, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    classNames, index, hasCheckmarks, hasIcons) {
        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === undefined ? ContextualMenuItem : _b, onItemClick = _a.onItemClick;
        var itemProps = {
            key: item.key,
            disabled: isItemDisabled(item) || item.primaryDisabled,
            /* eslint-disable @typescript-eslint/no-deprecated */
            name: item.name,
            text: item.text || item.name,
            secondaryText: item.secondaryText,
            /* eslint-enable @typescript-eslint/no-deprecated */
            className: classNames.splitPrimary,
            canCheck: item.canCheck,
            isChecked: item.isChecked,
            checked: item.checked,
            iconProps: item.iconProps,
            id: this._dismissLabelId,
            onClick: item.onClick,
            onRenderIcon: item.onRenderIcon,
            data: item.data,
            'data-is-focusable': false,
        };
        var itemComponentProps = item.itemProps;
        return (React.createElement("button", __assign$2({}, getNativeProps$1(itemProps, buttonProperties$1)),
            React.createElement(ChildrenRenderer, __assign$2({ "data-is-focusable": false, item: itemProps, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons }, itemComponentProps))));
    };
    ContextualMenuSplitButton.prototype._renderSplitDivider = function (item) {
        var getDividerClassNames = item.getSplitButtonVerticalDividerClassNames || getSplitButtonVerticalDividerClassNames;
        return React.createElement(VerticalDivider, { getClassNames: getDividerClassNames });
    };
    ContextualMenuSplitButton.prototype._renderSplitIconButton = function (item, classNames, // eslint-disable-line @typescript-eslint/no-deprecated
    index, keytipAttributes) {
        var _a = this.props, onItemMouseLeave = _a.onItemMouseLeave, onItemMouseDown = _a.onItemMouseDown, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var ChildrenRenderer = ContextualMenuItem;
        if (this.props.item.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(this.props.item.contextualMenuItemAs, ChildrenRenderer);
        }
        if (this.props.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(this.props.contextualMenuItemAs, ChildrenRenderer);
        }
        var itemProps = {
            onClick: this._onIconItemClick,
            disabled: isItemDisabled(item),
            className: classNames.splitMenu,
            subMenuProps: item.subMenuProps,
            submenuIconProps: item.submenuIconProps,
            split: true,
            key: item.key,
            'aria-labelledby': this._dismissLabelId,
        };
        var buttonProps = __assign$2(__assign$2({}, getNativeProps$1(itemProps, buttonProperties$1)), {
            onMouseEnter: this._onItemMouseEnterIcon,
            onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(this, item) : undefined,
            onMouseDown: function (ev) {
                return onItemMouseDown ? onItemMouseDown(item, ev) : undefined;
            },
            onMouseMove: this._onItemMouseMoveIcon,
            'data-is-focusable': false,
            'data-ktp-execute-target': keytipAttributes['data-ktp-execute-target'],
            'aria-haspopup': true,
        });
        var itemComponentProps = item.itemProps;
        return (React.createElement("button", __assign$2({}, buttonProps),
            React.createElement(ChildrenRenderer, __assign$2({ componentRef: item.componentRef, item: itemProps, classNames: classNames, index: index, hasIcons: false, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: this._getSubmenuTarget }, itemComponentProps))));
    };
    ContextualMenuSplitButton.prototype._handleTouchAndPointerEvent = function (ev) {
        var _this = this;
        var onTap = this.props.onTap;
        if (onTap) {
            onTap(ev);
        }
        // If we already have an existing timeout from a previous touch/pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function () {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
        }, TouchIdleDelay$1);
    };
    return ContextualMenuSplitButton;
}(ContextualMenuItemWrapper));

var BaseDecorator = /** @class */ (function (_super) {
    __extends$1(BaseDecorator, _super);
    function BaseDecorator(props) {
        var _this = _super.call(this, props) || this;
        _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
        return _this;
    }
    /**
     * Updates the ref to the component composed by the decorator, which will also take care of hoisting
     * (and unhoisting as appropriate) methods from said component.
     *
     * Pass this method as the argument to the 'ref' property of the composed component.
     */
    BaseDecorator.prototype._updateComposedComponentRef = function (composedComponentInstance) {
        this._composedComponentInstance = composedComponentInstance;
        if (composedComponentInstance) {
            this._hoisted = hoistMethods(this, composedComponentInstance);
        }
        else if (this._hoisted) {
            unhoistMethods(this, this._hoisted);
        }
    };
    return BaseDecorator;
}(React.Component));

var ResponsiveMode;
(function (ResponsiveMode) {
    /** Width \<= 479px */
    ResponsiveMode[ResponsiveMode["small"] = 0] = "small";
    /** Width \> 479px and \<= 639px */
    ResponsiveMode[ResponsiveMode["medium"] = 1] = "medium";
    /** Width \> 639px and \<= 1023px */
    ResponsiveMode[ResponsiveMode["large"] = 2] = "large";
    /** Width \> 1023px and \<= 1365px */
    ResponsiveMode[ResponsiveMode["xLarge"] = 3] = "xLarge";
    /** Width \> 1365px and \<= 1919px */
    ResponsiveMode[ResponsiveMode["xxLarge"] = 4] = "xxLarge";
    /** Width \> 1919px */
    ResponsiveMode[ResponsiveMode["xxxLarge"] = 5] = "xxxLarge";
    ResponsiveMode[ResponsiveMode["unknown"] = 999] = "unknown";
})(ResponsiveMode || (ResponsiveMode = {}));
var RESPONSIVE_MAX_CONSTRAINT = [479, 639, 1023, 1365, 1919, 99999999];
/**
 * Tracking the last mode we successfully rendered, which allows us to
 * paint initial renders with the correct size.
 */
var _lastMode;
function getInitialResponsiveMode() {
    var _a;
    return (_a = _lastMode) !== null && _a !== undefined ? _a : ResponsiveMode.large;
}
/**
 * @deprecated Decorator usage is deprecated. Either call `getResponsiveMode` manually, or
 * use the `useResponsiveMode` hook within a function component.
 */
function withResponsiveMode(ComposedComponent) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var resultClass = (_a = /** @class */ (function (_super) {
            __extends$1(WithResponsiveMode, _super);
            function WithResponsiveMode(props) {
                var _this = _super.call(this, props) || this;
                _this._onResize = function () {
                    var responsiveMode = getResponsiveMode(_this.context.window);
                    if (responsiveMode !== _this.state.responsiveMode) {
                        _this.setState({
                            responsiveMode: responsiveMode,
                        });
                    }
                };
                _this._events = new EventGroup(_this);
                _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
                _this.state = {
                    responsiveMode: getInitialResponsiveMode(),
                };
                return _this;
            }
            WithResponsiveMode.prototype.componentDidMount = function () {
                this._events.on(this.context.window, 'resize', this._onResize);
                this._onResize();
            };
            WithResponsiveMode.prototype.componentWillUnmount = function () {
                this._events.dispose();
            };
            WithResponsiveMode.prototype.render = function () {
                var responsiveMode = this.state.responsiveMode;
                return responsiveMode === ResponsiveMode.unknown ? null : (React.createElement(ComposedComponent, __assign$2({ ref: this._updateComposedComponentRef, responsiveMode: responsiveMode }, this.props)));
            };
            return WithResponsiveMode;
        }(BaseDecorator)),
        _a.contextType = WindowContext,
        _a);
    return hoistStatics(ComposedComponent, resultClass);
}
function getWidthOfCurrentWindow(currentWindow) {
    try {
        return currentWindow.document.documentElement.clientWidth;
    }
    catch (e) {
        return currentWindow.innerWidth;
    }
}
/**
 * Hook to get the current responsive mode (window size category).
 * @param currentWindow - Use this window when determining the responsive mode.
 */
function getResponsiveMode(currentWindow) {
    var responsiveMode = ResponsiveMode.small;
    if (currentWindow) {
        try {
            while (getWidthOfCurrentWindow(currentWindow) > RESPONSIVE_MAX_CONSTRAINT[responsiveMode]) {
                responsiveMode++;
            }
        }
        catch (e) {
            // Return a best effort result in cases where we're in the browser but it throws on getting innerWidth.
            responsiveMode = getInitialResponsiveMode();
        }
        // Tracking last mode just gives us a better default in future renders,
        // which avoids starting with the wrong value if we've measured once.
        _lastMode = responsiveMode;
    }
    else {
        {
            throw new Error('Content was rendered in a server environment without providing a default responsive mode. ' +
                'Call setResponsiveMode to define what the responsive mode is.');
        }
    }
    return responsiveMode;
}

/**
 * Hook to get the current responsive mode (window size category).
 * @param elementRef - Use this element's parent window when determining the responsive mode.
 * @param overrideResponsiveMode - Override the responsive mode. If this param is present, it's always returned.
 */
var useResponsiveMode = function (elementRef, overrideResponsiveMode) {
    var _a = React.useState(getInitialResponsiveMode()), lastResponsiveMode = _a[0], setLastResponsiveMode = _a[1];
    var onResize = React.useCallback(function () {
        var newResponsiveMode = getResponsiveMode(getWindow$2(elementRef.current));
        // Setting the same value should not cause a re-render.
        if (lastResponsiveMode !== newResponsiveMode) {
            setLastResponsiveMode(newResponsiveMode);
        }
    }, [elementRef, lastResponsiveMode]);
    var win = useWindow();
    useOnEvent(win, 'resize', onResize);
    // Call resize function initially on mount, or if the override changes from defined to undefined
    // (the effect will run on all override changes, but onResize will only be called if it changed to undefined)
    React.useEffect(function () {
        if (overrideResponsiveMode === undefined) {
            onResize();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- only meant to run on mount or when override changes
    }, [overrideResponsiveMode]);
    return overrideResponsiveMode !== null && overrideResponsiveMode !== undefined ? overrideResponsiveMode : lastResponsiveMode;
};

var MenuContext = React.createContext({});

var getClassNames$k = classNamesFunction();
var getContextualMenuItemClassNames = classNamesFunction();
// The default ContextualMenu properties have no items and beak, the default submenu direction is right and top.
var DEFAULT_PROPS$4 = {
    items: [],
    shouldFocusOnMount: true,
    gapSpace: 0,
    directionalHint: DirectionalHint.bottomAutoEdge,
    beakWidth: 16,
};
/* return number of menu items, excluding headers and dividers */
function getItemCount(items) {
    var totalItemCount = 0;
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (item.itemType !== ContextualMenuItemType.Divider && item.itemType !== ContextualMenuItemType.Header) {
            var itemCount = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
            totalItemCount += itemCount;
        }
    }
    return totalItemCount;
}
function getSubmenuItems(item, options) {
    var target = options === null || options === undefined ? undefined : options.target;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var items = item.subMenuProps ? item.subMenuProps.items : item.items;
    if (items) {
        var overrideItems = [];
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var subItem = items_2[_i];
            if (subItem.preferMenuTargetAsEventTarget) {
                // For sub-items which need an overridden target, intercept `onClick`
                var onClick = subItem.onClick, contextItem = __rest$1(subItem, ["onClick"]);
                overrideItems.push(__assign$2(__assign$2({}, contextItem), { onClick: getOnClickWithOverrideTarget(onClick, target) }));
            }
            else {
                overrideItems.push(subItem);
            }
        }
        return overrideItems;
    }
}
/**
 * Returns true if a list of menu items can contain a checkbox
 */
function canAnyMenuItemsCheck(items) {
    return items.some(function (item) {
        if (item.canCheck) {
            return true;
        }
        // If the item is a section, check if any of the items in the section can check.
        if (item.sectionProps && item.sectionProps.items.some(function (submenuItem) { return submenuItem.canCheck === true; })) {
            return true;
        }
        return false;
    });
}
var NavigationIdleDelay = 250; /* ms */
var COMPONENT_NAME$9 = 'ContextualMenu';
var _getMenuItemStylesFunction = memoizeFunction(function () {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return function (styleProps) {
        return concatStyleSetsWithProps.apply(undefined, __spreadArray([styleProps, getItemStyles], styles, false));
    };
});
//#region Custom hooks
function useVisibility(props, targetWindow) {
    var _a = props.hidden, hidden = _a === undefined ? false : _a, onMenuDismissed = props.onMenuDismissed, onMenuOpened = props.onMenuOpened;
    var previousHidden = usePrevious$1(hidden);
    var onMenuOpenedRef = React.useRef(onMenuOpened);
    var onMenuClosedRef = React.useRef(onMenuDismissed);
    var propsRef = React.useRef(props);
    onMenuOpenedRef.current = onMenuOpened;
    onMenuClosedRef.current = onMenuDismissed;
    propsRef.current = props;
    React.useEffect(function () {
        var _a, _b;
        // Don't issue dismissed callbacks on initial mount
        if (hidden && previousHidden === false) {
            (_a = onMenuClosedRef.current) === null || _a === undefined ? undefined : _a.call(onMenuClosedRef, propsRef.current);
        }
        else if (!hidden && previousHidden !== false) {
            (_b = onMenuOpenedRef.current) === null || _b === undefined ? undefined : _b.call(onMenuOpenedRef, propsRef.current);
        }
    }, [hidden, previousHidden]);
    // Issue onDismissedCallback on unmount
    React.useEffect(function () { return function () { var _a; return (_a = onMenuClosedRef.current) === null || _a === undefined ? undefined : _a.call(onMenuClosedRef, propsRef.current); }; }, []);
}
function useSubMenuState(_a, dismiss) {
    var hidden = _a.hidden, items = _a.items, theme = _a.theme, className = _a.className, id = _a.id, menuTarget = _a.target;
    var _b = React.useState(), expandedMenuItemKey = _b[0], setExpandedMenuItemKey = _b[1];
    var _c = React.useState(), submenuTarget = _c[0], setSubmenuTarget = _c[1];
    /** True if the menu was expanded by mouse click OR hover (as opposed to by keyboard) */
    var _d = React.useState(), shouldFocusOnContainer = _d[0], setShouldFocusOnContainer = _d[1];
    var subMenuId = useId$1(COMPONENT_NAME$9, id);
    var closeSubMenu = React.useCallback(function () {
        setShouldFocusOnContainer(undefined);
        setExpandedMenuItemKey(undefined);
        setSubmenuTarget(undefined);
    }, []);
    var openSubMenu = React.useCallback(function (_a, target, focusContainer) {
        var submenuItemKey = _a.key;
        if (expandedMenuItemKey === submenuItemKey) {
            return;
        }
        target.focus();
        setShouldFocusOnContainer(focusContainer);
        setExpandedMenuItemKey(submenuItemKey);
        setSubmenuTarget(target);
    }, [expandedMenuItemKey]);
    React.useEffect(function () {
        if (hidden) {
            closeSubMenu();
        }
    }, [hidden, closeSubMenu]);
    var onSubMenuDismiss = useOnSubmenuDismiss(dismiss, closeSubMenu);
    var getSubmenuProps = function () {
        var item = findItemByKeyFromItems(expandedMenuItemKey, items);
        var submenuProps = null;
        if (item) {
            submenuProps = {
                items: getSubmenuItems(item, { target: menuTarget }),
                target: submenuTarget,
                onDismiss: onSubMenuDismiss,
                isSubMenu: true,
                id: subMenuId,
                shouldFocusOnMount: true,
                shouldFocusOnContainer: shouldFocusOnContainer,
                directionalHint: getRTL(theme) ? DirectionalHint.leftTopEdge : DirectionalHint.rightTopEdge,
                className: className,
                gapSpace: 0,
                isBeakVisible: false,
            };
            if (item.subMenuProps) {
                assign$2(submenuProps, item.subMenuProps);
            }
            if (item.preferMenuTargetAsEventTarget) {
                var onItemClick = item.onItemClick;
                submenuProps.onItemClick = getOnClickWithOverrideTarget(onItemClick, menuTarget);
            }
        }
        return submenuProps;
    };
    return [expandedMenuItemKey, openSubMenu, getSubmenuProps, onSubMenuDismiss];
}
function useShouldUpdateFocusOnMouseMove(_a) {
    var delayUpdateFocusOnHover = _a.delayUpdateFocusOnHover, hidden = _a.hidden;
    var shouldUpdateFocusOnMouseEvent = React.useRef(!delayUpdateFocusOnHover);
    var gotMouseMove = React.useRef(false);
    React.useEffect(function () {
        shouldUpdateFocusOnMouseEvent.current = !delayUpdateFocusOnHover;
        gotMouseMove.current = hidden ? false : !delayUpdateFocusOnHover && gotMouseMove.current;
    }, [delayUpdateFocusOnHover, hidden]);
    var onMenuFocusCapture = React.useCallback(function () {
        if (delayUpdateFocusOnHover) {
            shouldUpdateFocusOnMouseEvent.current = false;
        }
    }, [delayUpdateFocusOnHover]);
    return [shouldUpdateFocusOnMouseEvent, gotMouseMove, onMenuFocusCapture];
}
function usePreviousActiveElement(_a, targetWindow, hostElement) {
    var hidden = _a.hidden, onRestoreFocus = _a.onRestoreFocus;
    var previousActiveElement = React.useRef();
    var tryFocusPreviousActiveElement = React.useCallback(function (options) {
        var _a, _b;
        if (onRestoreFocus) {
            onRestoreFocus(options);
        }
        else if (options === null || options === undefined ? undefined : options.documentContainsFocus) {
            // Make sure that the focus method actually exists
            // In some cases the object might exist but not be a real element.
            // This is primarily for IE 11 and should be removed once IE 11 is no longer in use.
            (_b = (_a = previousActiveElement.current) === null || _a === undefined ? undefined : _a.focus) === null || _b === undefined ? undefined : _b.call(_a);
        }
    }, [onRestoreFocus]);
    useIsomorphicLayoutEffect$1(function () {
        var _a, _b;
        if (!hidden) {
            var newElement = targetWindow === null || targetWindow === undefined ? undefined : targetWindow.document.activeElement;
            if (!((_a = hostElement.current) === null || _a === undefined ? undefined : _a.contains(newElement)) && newElement.tagName !== 'BODY') {
                previousActiveElement.current = newElement;
            }
        }
        else if (previousActiveElement.current) {
            tryFocusPreviousActiveElement({
                originalElement: previousActiveElement.current,
                containsFocus: true,
                documentContainsFocus: ((_b = getDocument$1()) === null || _b === undefined ? undefined : _b.hasFocus()) || false,
            });
            previousActiveElement.current = undefined;
        }
    }, [hidden, targetWindow === null || targetWindow === undefined ? undefined : targetWindow.document.activeElement, tryFocusPreviousActiveElement, hostElement]);
    return [tryFocusPreviousActiveElement];
}
function useKeyHandlers(_a, dismiss, hostElement, openSubMenu) {
    var theme = _a.theme, isSubMenu = _a.isSubMenu, _b = _a.focusZoneProps, _c = _b === undefined ? {} : _b, checkForNoWrap = _c.checkForNoWrap, _d = _c.direction, focusZoneDirection = _d === undefined ? FocusZoneDirection.vertical : _d;
    /** True if the most recent keydown event was for alt (option) or meta (command). */
    var lastKeyDownWasAltOrMeta = React.useRef();
    /**
     * Calls `shouldHandleKey` to determine whether the keyboard event should be handled;
     * if so, stops event propagation and dismisses menu(s).
     * @param ev - The keyboard event.
     * @param shouldHandleKey - Returns whether we should handle this keyboard event.
     * @param dismissAllMenus - If true, dismiss all menus. Otherwise, dismiss only the current menu.
     * Only does anything if `shouldHandleKey` returns true.
     * @returns Whether the event was handled.
     */
    var keyHandler = function (ev, shouldHandleKey, dismissAllMenus) {
        var handled = false;
        if (shouldHandleKey(ev)) {
            dismiss(ev, dismissAllMenus);
            ev.preventDefault();
            ev.stopPropagation();
            handled = true;
        }
        return handled;
    };
    /**
     * Checks if the submenu should be closed
     */
    var shouldCloseSubMenu = function (ev) {
        var submenuCloseKey = getRTL(theme) ? KeyCodes.right : KeyCodes.left;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (ev.which !== submenuCloseKey || !isSubMenu) {
            return false;
        }
        return !!(focusZoneDirection === FocusZoneDirection.vertical ||
            (checkForNoWrap && !shouldWrapFocus(ev.target, 'data-no-horizontal-wrap')));
    };
    var shouldHandleKeyDown = function (ev) {
        return (
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        ev.which === KeyCodes.escape ||
            shouldCloseSubMenu(ev) ||
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            (ev.which === KeyCodes.up && (ev.altKey || ev.metaKey)));
    };
    var onKeyDown = function (ev) {
        // Take note if we are processing an alt (option) or meta (command) keydown.
        // See comment in shouldHandleKeyUp for reasoning.
        lastKeyDownWasAltOrMeta.current = isAltOrMeta(ev);
        // On Mac, pressing escape dismisses all levels of native context menus
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var dismissAllMenus = ev.which === KeyCodes.escape && (isMac() || isIOS());
        return keyHandler(ev, shouldHandleKeyDown, dismissAllMenus);
    };
    /**
     * We close the menu on key up only if ALL of the following are true:
     * - Most recent key down was alt or meta (command)
     * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
     *   expand/collapse the menu)
     * - We're not on a Mac (or iOS)
     *
     * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
     * closing any open context menus. There is not a similar behavior on Macs.
     */
    var shouldHandleKeyUp = function (ev) {
        var keyPressIsAltOrMetaAlone = lastKeyDownWasAltOrMeta.current && isAltOrMeta(ev);
        lastKeyDownWasAltOrMeta.current = false;
        return !!keyPressIsAltOrMetaAlone && !(isIOS() || isMac());
    };
    var onKeyUp = function (ev) {
        return keyHandler(ev, shouldHandleKeyUp, true /* dismissAllMenus */);
    };
    var onMenuKeyDown = function (ev) {
        // Mark as handled if onKeyDown returns true (for handling collapse cases)
        // or if we are attempting to expand a submenu
        var handled = onKeyDown(ev);
        if (handled || !hostElement.current) {
            return;
        }
        // If we have a modifier key being pressed, we do not want to move focus.
        // Otherwise, handle up and down keys.
        var hasModifier = !!(ev.altKey || ev.metaKey);
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var isUp = ev.which === KeyCodes.up;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var isDown = ev.which === KeyCodes.down;
        if (!hasModifier && (isUp || isDown)) {
            var elementToFocus = isUp
                ? getLastFocusable(hostElement.current, hostElement.current.lastChild, true)
                : getFirstFocusable(hostElement.current, hostElement.current.firstChild, true);
            if (elementToFocus) {
                elementToFocus.focus();
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    };
    var onItemKeyDown = function (item, ev) {
        var openKey = getRTL(theme) ? KeyCodes.left : KeyCodes.right;
        if (!item.disabled &&
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            (ev.which === openKey || ev.which === KeyCodes.enter || (ev.which === KeyCodes.down && (ev.altKey || ev.metaKey)))) {
            openSubMenu(item, ev.currentTarget);
            ev.preventDefault();
        }
    };
    return [onKeyDown, onKeyUp, onMenuKeyDown, onItemKeyDown];
}
function useScrollHandler(asyncTracker) {
    var isScrollIdle = React.useRef(true);
    var scrollIdleTimeoutId = React.useRef();
    /**
     * Scroll handler for the callout to make sure the mouse events
     * for updating focus are not interacting during scroll
     */
    var onScroll = function () {
        if (!isScrollIdle.current && scrollIdleTimeoutId.current !== undefined) {
            asyncTracker.clearTimeout(scrollIdleTimeoutId.current);
            scrollIdleTimeoutId.current = undefined;
        }
        else {
            isScrollIdle.current = false;
        }
        scrollIdleTimeoutId.current = asyncTracker.setTimeout(function () {
            isScrollIdle.current = true;
        }, NavigationIdleDelay);
    };
    return [onScroll, isScrollIdle];
}
function useOnSubmenuDismiss(dismiss, closeSubMenu) {
    var isMountedRef = React.useRef(false);
    React.useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    /**
     * This function is called ASYNCHRONOUSLY, and so there is a chance it is called
     * after the component is unmounted. The isMountedRef is added to prevent
     * from calling setState() after unmount. Do NOT copy this pattern in synchronous
     * code.
     */
    var onSubMenuDismiss = function (ev, dismissAll) {
        if (dismissAll) {
            dismiss(ev, dismissAll);
        }
        else if (isMountedRef.current) {
            closeSubMenu();
        }
    };
    return onSubMenuDismiss;
}
function useSubmenuEnterTimer(_a, asyncTracker) {
    var _b = _a.subMenuHoverDelay, subMenuHoverDelay = _b === undefined ? NavigationIdleDelay : _b;
    var enterTimerRef = React.useRef(undefined);
    var cancelSubMenuTimer = function () {
        if (enterTimerRef.current !== undefined) {
            asyncTracker.clearTimeout(enterTimerRef.current);
            enterTimerRef.current = undefined;
        }
    };
    var startSubmenuTimer = function (onTimerExpired) {
        enterTimerRef.current = asyncTracker.setTimeout(function () {
            onTimerExpired();
            cancelSubMenuTimer();
        }, subMenuHoverDelay);
    };
    return [cancelSubMenuTimer, startSubmenuTimer, enterTimerRef];
}
function useMouseHandlers(props, isScrollIdle, subMenuEntryTimer, targetWindow, shouldUpdateFocusOnMouseEvent, gotMouseMove, expandedMenuItemKey, hostElement, startSubmenuTimer, cancelSubMenuTimer, openSubMenu, onSubMenuDismiss, dismiss) {
    var menuTarget = props.target;
    var onItemMouseEnterBase = function (item, ev, target) {
        if (shouldUpdateFocusOnMouseEvent.current) {
            gotMouseMove.current = true;
        }
        if (shouldIgnoreMouseEvent()) {
            return;
        }
        updateFocusOnMouseEvent(item, ev, target);
    };
    var onItemMouseMoveBase = function (item, ev, target) {
        var targetElement = ev.currentTarget;
        // Always do this check to make sure we record a mouseMove if needed (even if we are timed out)
        if (shouldUpdateFocusOnMouseEvent.current) {
            gotMouseMove.current = true;
        }
        else {
            return;
        }
        if (!isScrollIdle.current ||
            subMenuEntryTimer.current !== undefined ||
            targetElement === (targetWindow === null || targetWindow === undefined ? undefined : targetWindow.document.activeElement)) {
            return;
        }
        updateFocusOnMouseEvent(item, ev, target);
    };
    var shouldIgnoreMouseEvent = function () {
        return !isScrollIdle.current || !gotMouseMove.current;
    };
    var onMouseItemLeave = function (item, ev) {
        var _a;
        if (shouldIgnoreMouseEvent()) {
            return;
        }
        cancelSubMenuTimer();
        if (expandedMenuItemKey !== undefined) {
            return;
        }
        /**
         * IE11 focus() method forces parents to scroll to top of element.
         * Edge and IE expose a setActive() function for focusable divs that
         * sets the page focus but does not scroll the parent element.
         */
        if (hostElement.current.setActive) {
            try {
                hostElement.current.setActive();
            }
            catch (e) {
                /* no-op */
            }
        }
        else {
            (_a = hostElement.current) === null || _a === undefined ? undefined : _a.focus();
        }
    };
    /**
     * Handles updating focus when mouseEnter or mouseMove fire.
     * As part of updating focus, This function will also update
     * the expand/collapse state accordingly.
     */
    var updateFocusOnMouseEvent = function (item, ev, target) {
        var targetElement = target ? target : ev.currentTarget;
        if (item.key === expandedMenuItemKey) {
            return;
        }
        cancelSubMenuTimer();
        // If the menu is not expanded we can update focus without any delay
        if (expandedMenuItemKey === undefined) {
            targetElement.focus();
        }
        // Delay updating expanding/dismissing the submenu
        // and only set focus if we have not already done so
        if (hasSubmenu(item)) {
            ev.stopPropagation();
            startSubmenuTimer(function () {
                targetElement.focus();
                openSubMenu(item, targetElement, true);
            });
        }
        else {
            startSubmenuTimer(function () {
                onSubMenuDismiss(ev);
                targetElement.focus();
            });
        }
    };
    var onItemClick = function (item, ev) {
        onItemClickBase(item, ev, ev.currentTarget);
    };
    var onItemClickBase = function (item, ev, target) {
        var items = getSubmenuItems(item, { target: menuTarget });
        // Cancel an async menu item hover timeout action from being taken and instead
        // just trigger the click event instead.
        cancelSubMenuTimer();
        if (!hasSubmenu(item) && (!items || !items.length)) {
            // This is an item without a menu. Click it.
            executeItemClick(item, ev);
        }
        else {
            if (item.key !== expandedMenuItemKey) {
                // This has a collapsed sub menu. Expand it.
                // focus on the container by default when the menu is opened with a click event
                // this differentiates from a keyboard interaction triggering the click event
                var shouldFocusOnContainer = typeof props.shouldFocusOnContainer === 'boolean'
                    ? props.shouldFocusOnContainer
                    : ev.nativeEvent.pointerType === 'mouse';
                openSubMenu(item, target, shouldFocusOnContainer);
            }
        }
        ev.stopPropagation();
        ev.preventDefault();
    };
    var onAnchorClick = function (item, ev) {
        executeItemClick(item, ev);
        ev.stopPropagation();
    };
    var executeItemClick = function (item, ev) {
        if (item.disabled || item.isDisabled) {
            return;
        }
        if (item.preferMenuTargetAsEventTarget) {
            overrideTarget(ev, menuTarget);
        }
        var shouldDismiss = false;
        if (item.onClick) {
            shouldDismiss = !!item.onClick(ev, item);
        }
        else if (props.onItemClick) {
            shouldDismiss = !!props.onItemClick(ev, item);
        }
        if (shouldDismiss || !ev.defaultPrevented) {
            dismiss(ev, true);
        }
    };
    return [
        onItemMouseEnterBase,
        onItemMouseMoveBase,
        onMouseItemLeave,
        onItemClick,
        onAnchorClick,
        executeItemClick,
        onItemClickBase,
    ];
}
//#endregion
var ContextualMenuBase = React.memo(React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var _a;
    var _b = getPropsWithDefaults(DEFAULT_PROPS$4, propsWithoutDefaults); _b.ref; var props = __rest$1(_b, ["ref"]);
    var hostElement = React.useRef(null);
    var asyncTracker = useAsync();
    var menuId = useId$1(COMPONENT_NAME$9, props.id);
    useWarnings({
        name: COMPONENT_NAME$9,
        props: props,
        deprecations: {
            getMenuClassNames: 'styles',
        },
    });
    var dismiss = function (ev, dismissAll) { var _a; return (_a = props.onDismiss) === null || _a === undefined ? undefined : _a.call(props, ev, dismissAll); };
    var _c = useTarget(props.target, hostElement), targetRef = _c[0], targetWindow = _c[1];
    var tryFocusPreviousActiveElement = usePreviousActiveElement(props, targetWindow, hostElement)[0];
    var _d = useSubMenuState(props, dismiss), expandedMenuItemKey = _d[0], openSubMenu = _d[1], getSubmenuProps = _d[2], onSubMenuDismiss = _d[3];
    var _e = useShouldUpdateFocusOnMouseMove(props), shouldUpdateFocusOnMouseEvent = _e[0], gotMouseMove = _e[1], onMenuFocusCapture = _e[2];
    var _f = useScrollHandler(asyncTracker), onScroll = _f[0], isScrollIdle = _f[1];
    var _g = useSubmenuEnterTimer(props, asyncTracker), cancelSubMenuTimer = _g[0], startSubmenuTimer = _g[1], subMenuEntryTimer = _g[2];
    var responsiveMode = useResponsiveMode(hostElement, props.responsiveMode);
    useVisibility(props);
    var _h = useKeyHandlers(props, dismiss, hostElement, openSubMenu), onKeyDown = _h[0], onKeyUp = _h[1], onMenuKeyDown = _h[2], onItemKeyDown = _h[3];
    var _j = useMouseHandlers(props, isScrollIdle, subMenuEntryTimer, targetWindow, shouldUpdateFocusOnMouseEvent, gotMouseMove, expandedMenuItemKey, hostElement, startSubmenuTimer, cancelSubMenuTimer, openSubMenu, onSubMenuDismiss, dismiss), onItemMouseEnterBase = _j[0], onItemMouseMoveBase = _j[1], onMouseItemLeave = _j[2], onItemClick = _j[3], onAnchorClick = _j[4], executeItemClick = _j[5], onItemClickBase = _j[6];
    //#region Render helpers
    var onDefaultRenderMenuList = function (menuListProps, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames, defaultRender) {
        var indexCorrection = 0;
        var items = menuListProps.items, totalItemCount = menuListProps.totalItemCount, hasCheckmarks = menuListProps.hasCheckmarks, hasIcons = menuListProps.hasIcons;
        return (React.createElement("ul", { className: menuClassNames.list, onKeyDown: onKeyDown, onKeyUp: onKeyUp, role: 'presentation' }, items.map(function (item, index) {
            var menuItem = renderMenuItem(item, index, indexCorrection, totalItemCount, hasCheckmarks, hasIcons, menuClassNames);
            if (item.itemType !== ContextualMenuItemType.Divider && item.itemType !== ContextualMenuItemType.Header) {
                var indexIncrease = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
                indexCorrection += indexIncrease;
            }
            return menuItem;
        })));
    };
    var renderFocusZone = function (children, adjustedFocusZoneProps) {
        var _a = props.focusZoneAs, ChildrenRenderer = _a === undefined ? FocusZone : _a;
        return React.createElement(ChildrenRenderer, __assign$2({}, adjustedFocusZoneProps), children);
    };
    /**
     * !!!IMPORTANT!!! Avoid mutating `item: IContextualMenuItem` argument. It will
     * cause the menu items to always re-render because the component update is based on shallow comparison.
     */
    var renderMenuItem = function (item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames) {
        var _a;
        var renderedItems = [];
        var iconProps = item.iconProps || { iconName: 'None' };
        var getItemClassNames = item.getItemClassNames, // eslint-disable-line @typescript-eslint/no-deprecated
        itemProps = item.itemProps;
        var styles = itemProps ? itemProps.styles : undefined;
        // We only send a dividerClassName when the item to be rendered is a divider.
        // For all other cases, the default divider style is used.
        var dividerClassName = item.itemType === ContextualMenuItemType.Divider ? item.className : undefined;
        var subMenuIconClassName = item.submenuIconProps ? item.submenuIconProps.className : '';
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var itemClassNames;
        // IContextualMenuItem#getItemClassNames for backwards compatibility
        // otherwise uses mergeStyles for class names.
        if (getItemClassNames) {
            itemClassNames = getItemClassNames(props.theme, isItemDisabled(item), expandedMenuItemKey === item.key, !!getIsChecked(item), !!item.href, iconProps.iconName !== 'None', item.className, dividerClassName, iconProps.className, subMenuIconClassName, item.primaryDisabled);
        }
        else {
            var itemStyleProps = {
                theme: props.theme,
                disabled: isItemDisabled(item),
                expanded: expandedMenuItemKey === item.key,
                checked: !!getIsChecked(item),
                isAnchorLink: !!item.href,
                knownIcon: iconProps.iconName !== 'None',
                itemClassName: item.className,
                dividerClassName: dividerClassName,
                iconClassName: iconProps.className,
                subMenuClassName: subMenuIconClassName,
                primaryDisabled: item.primaryDisabled,
            };
            // We need to generate default styles then override if styles are provided
            // since the ContextualMenu currently handles item classNames.
            itemClassNames = getContextualMenuItemClassNames(_getMenuItemStylesFunction((_a = menuClassNames.subComponentStyles) === null || _a === undefined ? undefined : _a.menuItem, styles), itemStyleProps);
        }
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (item.text === '-' || item.name === '-') {
            item.itemType = ContextualMenuItemType.Divider;
        }
        switch (item.itemType) {
            case ContextualMenuItemType.Divider:
                renderedItems.push(renderSeparator(index, itemClassNames));
                break;
            case ContextualMenuItemType.Header:
                renderedItems.push(renderSeparator(index, itemClassNames));
                var headerItem = renderHeaderMenuItem(item, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons);
                renderedItems.push(renderListItem(headerItem, item.key || index, itemClassNames, item.title));
                break;
            case ContextualMenuItemType.Section:
                renderedItems.push(renderSectionItem(item, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons));
                break;
            default:
                var defaultRenderNormalItem = function () {
                    return renderNormalItem(item, itemClassNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
                };
                var menuItem = props.onRenderContextualMenuItem
                    ? props.onRenderContextualMenuItem(item, defaultRenderNormalItem)
                    : defaultRenderNormalItem();
                renderedItems.push(renderListItem(menuItem, item.key || index, itemClassNames, item.title));
                break;
        }
        // Since multiple nodes *could* be rendered, wrap them all in a fragment with this item's key.
        // This ensures the reconciler handles multi-item output per-node correctly and does not re-mount content.
        return React.createElement(React.Fragment, { key: item.key }, renderedItems);
    };
    var defaultMenuItemRenderer = function (item, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames) {
        var index = item.index, focusableElementIndex = item.focusableElementIndex, totalItemCount = item.totalItemCount, hasCheckmarks = item.hasCheckmarks, hasIcons = item.hasIcons;
        return renderMenuItem(item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons, menuClassNames);
    };
    var renderSectionItem = function (sectionItem, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    itemClassNames, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames, index, hasCheckmarks, hasIcons) {
        var sectionProps = sectionItem.sectionProps;
        if (!sectionProps) {
            return;
        }
        var headerItem;
        var groupProps;
        if (sectionProps.title) {
            var headerContextualMenuItem = undefined;
            var ariaLabelledby = '';
            if (typeof sectionProps.title === 'string') {
                // Since title is a user-facing string, it needs to be stripped
                // of whitespace in order to build a valid element ID
                var id_1 = menuId + sectionProps.title.replace(/\s/g, '');
                headerContextualMenuItem = {
                    key: "section-".concat(sectionProps.title, "-title"),
                    itemType: ContextualMenuItemType.Header,
                    text: sectionProps.title,
                    id: id_1,
                };
                ariaLabelledby = id_1;
            }
            else {
                var id_2 = sectionProps.title.id || menuId + sectionProps.title.key.replace(/\s/g, '');
                headerContextualMenuItem = __assign$2(__assign$2({}, sectionProps.title), { id: id_2 });
                ariaLabelledby = id_2;
            }
            if (headerContextualMenuItem) {
                groupProps = {
                    role: 'group',
                    'aria-labelledby': ariaLabelledby,
                };
                headerItem = renderHeaderMenuItem(headerContextualMenuItem, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons);
            }
        }
        if (sectionProps.items && sectionProps.items.length > 0) {
            var correctedIndex_1 = 0;
            return (React.createElement("li", { role: "presentation", key: sectionProps.key || sectionItem.key || "section-".concat(index) },
                React.createElement("div", __assign$2({}, groupProps),
                    React.createElement("ul", { className: menuClassNames.list, role: "presentation" },
                        sectionProps.topDivider && renderSeparator(index, itemClassNames, true, true),
                        headerItem && renderListItem(headerItem, sectionItem.key || index, itemClassNames, sectionItem.title),
                        sectionProps.items.map(function (contextualMenuItem, itemsIndex) {
                            var menuItem = renderMenuItem(contextualMenuItem, itemsIndex, correctedIndex_1, getItemCount(sectionProps.items), hasCheckmarks, hasIcons, menuClassNames);
                            if (contextualMenuItem.itemType !== ContextualMenuItemType.Divider &&
                                contextualMenuItem.itemType !== ContextualMenuItemType.Header) {
                                var indexIncrease = contextualMenuItem.customOnRenderListLength
                                    ? contextualMenuItem.customOnRenderListLength
                                    : 1;
                                correctedIndex_1 += indexIncrease;
                            }
                            return menuItem;
                        }),
                        sectionProps.bottomDivider && renderSeparator(index, itemClassNames, false, true)))));
        }
    };
    var renderListItem = function (content, key, classNames, // eslint-disable-line @typescript-eslint/no-deprecated
    title) {
        return (React.createElement("li", { role: "presentation", title: title, key: key, className: classNames.item }, content));
    };
    var renderSeparator = function (index, classNames, // eslint-disable-line @typescript-eslint/no-deprecated
    top, fromSection) {
        if (fromSection || index > 0) {
            return (React.createElement("li", { role: "separator", key: 'separator-' + index + (top === undefined ? '' : top ? '-top' : '-bottom'), className: classNames.divider, "aria-hidden": "true" }));
        }
        return null;
    };
    var renderNormalItem = function (item, classNames, // eslint-disable-line @typescript-eslint/no-deprecated
    index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        if (item.onRender) {
            return item.onRender(__assign$2({ 'aria-posinset': focusableElementIndex + 1, 'aria-setsize': totalItemCount }, item), dismiss);
        }
        var contextualMenuItemAs = props.contextualMenuItemAs;
        var commonProps = {
            item: item,
            classNames: classNames,
            index: index,
            focusableElementIndex: focusableElementIndex,
            totalItemCount: totalItemCount,
            hasCheckmarks: hasCheckmarks,
            hasIcons: hasIcons,
            contextualMenuItemAs: contextualMenuItemAs,
            onItemMouseEnter: onItemMouseEnterBase,
            onItemMouseLeave: onMouseItemLeave,
            onItemMouseMove: onItemMouseMoveBase,
            onItemMouseDown: onItemMouseDown,
            executeItemClick: executeItemClick,
            onItemKeyDown: onItemKeyDown,
            expandedMenuItemKey: expandedMenuItemKey,
            openSubMenu: openSubMenu,
            dismissSubMenu: onSubMenuDismiss,
            dismissMenu: dismiss,
        };
        if (item.href) {
            var ContextualMenuAnchorAs = ContextualMenuAnchor;
            if (item.contextualMenuItemWrapperAs) {
                ContextualMenuAnchorAs = composeComponentAs(item.contextualMenuItemWrapperAs, ContextualMenuAnchorAs);
            }
            return React.createElement(ContextualMenuAnchorAs, __assign$2({}, commonProps, { onItemClick: onAnchorClick }));
        }
        if (item.split && hasSubmenu(item)) {
            var ContextualMenuSplitButtonAs = ContextualMenuSplitButton;
            if (item.contextualMenuItemWrapperAs) {
                ContextualMenuSplitButtonAs = composeComponentAs(item.contextualMenuItemWrapperAs, ContextualMenuSplitButtonAs);
            }
            return (React.createElement(ContextualMenuSplitButtonAs, __assign$2({}, commonProps, { onItemClick: onItemClick, onItemClickBase: onItemClickBase, onTap: cancelSubMenuTimer })));
        }
        var ContextualMenuButtonAs = ContextualMenuButton;
        if (item.contextualMenuItemWrapperAs) {
            ContextualMenuButtonAs = composeComponentAs(item.contextualMenuItemWrapperAs, ContextualMenuButtonAs);
        }
        return React.createElement(ContextualMenuButtonAs, __assign$2({}, commonProps, { onItemClick: onItemClick, onItemClickBase: onItemClickBase }));
    };
    var renderHeaderMenuItem = function (item, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    itemClassNames, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames, index, hasCheckmarks, hasIcons) {
        var ChildrenRenderer = ContextualMenuItem;
        if (item.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(item.contextualMenuItemAs, ChildrenRenderer);
        }
        if (props.contextualMenuItemAs) {
            ChildrenRenderer = composeComponentAs(props.contextualMenuItemAs, ChildrenRenderer);
        }
        var itemProps = item.itemProps, id = item.id;
        var divHtmlProperties = itemProps && getNativeProps$1(itemProps, divProperties);
        return (
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        React.createElement("div", __assign$2({ id: id, className: menuClassNames.header }, divHtmlProperties, { style: item.style }),
            React.createElement(ChildrenRenderer, __assign$2({ item: item, classNames: itemClassNames, index: index, onCheckmarkClick: hasCheckmarks ? onItemClick : undefined, hasIcons: hasIcons }, itemProps))));
    };
    //#endregion
    //#region Main render
    var isBeakVisible = props.isBeakVisible;
    var items = props.items, labelElementId = props.labelElementId, id = props.id, className = props.className, beakWidth = props.beakWidth, directionalHint = props.directionalHint, directionalHintForRTL = props.directionalHintForRTL, alignTargetEdge = props.alignTargetEdge, gapSpace = props.gapSpace, coverTarget = props.coverTarget, ariaLabel = props.ariaLabel, doNotLayer = props.doNotLayer, target = props.target, bounds = props.bounds, useTargetWidth = props.useTargetWidth, useTargetAsMinWidth = props.useTargetAsMinWidth, directionalHintFixed = props.directionalHintFixed, shouldFocusOnMount = props.shouldFocusOnMount, shouldFocusOnContainer = props.shouldFocusOnContainer, title = props.title, styles = props.styles, theme = props.theme, calloutProps = props.calloutProps, _k = props.onRenderSubMenu, onRenderSubMenu = _k === undefined ? onDefaultRenderSubMenu : _k, _l = props.onRenderMenuList, onRenderMenuList = _l === undefined ? function (menuListProps, defaultRender) { return onDefaultRenderMenuList(menuListProps, classNames); } : _l, focusZoneProps = props.focusZoneProps, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    getMenuClassNames = props.getMenuClassNames;
    var classNames = getMenuClassNames
        ? getMenuClassNames(theme, className)
        : getClassNames$k(styles, {
            theme: theme,
            className: className,
        });
    var hasIcons = itemsHaveIcons(items);
    function itemsHaveIcons(contextualMenuItems) {
        for (var _i = 0, contextualMenuItems_1 = contextualMenuItems; _i < contextualMenuItems_1.length; _i++) {
            var item = contextualMenuItems_1[_i];
            if (item.iconProps) {
                return true;
            }
            if (item.itemType === ContextualMenuItemType.Section &&
                item.sectionProps &&
                itemsHaveIcons(item.sectionProps.items)) {
                return true;
            }
        }
        return false;
    }
    var adjustedFocusZoneProps = __assign$2(__assign$2({ direction: FocusZoneDirection.vertical, handleTabKey: FocusZoneTabbableElements.all, isCircularNavigation: true, 'data-tabster': '{"uncontrolled": {}, "focusable": { "excludeFromMover": true }}' }, focusZoneProps), { className: css(classNames.root, (_a = props.focusZoneProps) === null || _a === undefined ? undefined : _a.className) });
    var hasCheckmarks = canAnyMenuItemsCheck(items);
    var submenuProps = expandedMenuItemKey && props.hidden !== true ? getSubmenuProps() : null;
    isBeakVisible = isBeakVisible === undefined ? responsiveMode <= ResponsiveMode.medium : isBeakVisible;
    /**
     * When useTargetWidth is true, get the width of the target element and apply it for the context menu container
     */
    var contextMenuStyle;
    var targetAsHtmlElement = targetRef.current;
    if ((useTargetWidth || useTargetAsMinWidth) && targetAsHtmlElement && targetAsHtmlElement.offsetWidth) {
        var targetBoundingRect = targetAsHtmlElement.getBoundingClientRect();
        var targetWidth = targetBoundingRect.width - 2; /* Accounts for 1px border */
        if (useTargetWidth) {
            contextMenuStyle = {
                width: targetWidth,
            };
        }
        else if (useTargetAsMinWidth) {
            contextMenuStyle = {
                minWidth: targetWidth,
            };
        }
    }
    // The menu should only return if items were provided, if no items were provided then it should not appear.
    if (items && items.length > 0) {
        var totalItemCount_1 = getItemCount(items);
        var calloutStyles_1 = classNames.subComponentStyles
            ? classNames.subComponentStyles.callout
            : undefined;
        return (React.createElement(MenuContext.Consumer, null, function (menuContext) { return (React.createElement(Callout, __assign$2({ styles: calloutStyles_1, onRestoreFocus: tryFocusPreviousActiveElement }, calloutProps, { target: target || menuContext.target, isBeakVisible: isBeakVisible, beakWidth: beakWidth, directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL, gapSpace: gapSpace, coverTarget: coverTarget, doNotLayer: doNotLayer, className: css('ms-ContextualMenu-Callout', calloutProps && calloutProps.className), setInitialFocus: shouldFocusOnMount, onDismiss: props.onDismiss || menuContext.onDismiss, onScroll: onScroll, bounds: bounds, directionalHintFixed: directionalHintFixed, alignTargetEdge: alignTargetEdge, hidden: props.hidden || menuContext.hidden, ref: forwardedRef }),
            React.createElement("div", { style: contextMenuStyle, ref: hostElement, id: id, className: classNames.container, tabIndex: shouldFocusOnContainer ? 0 : -1, onKeyDown: onMenuKeyDown, onKeyUp: onKeyUp, onFocusCapture: onMenuFocusCapture, "aria-label": ariaLabel, "aria-labelledby": labelElementId, role: 'menu' },
                title && React.createElement("div", { className: classNames.title },
                    " ",
                    title,
                    " "),
                items && items.length
                    ? renderFocusZone(onRenderMenuList({
                        ariaLabel: ariaLabel,
                        items: items,
                        totalItemCount: totalItemCount_1,
                        hasCheckmarks: hasCheckmarks,
                        hasIcons: hasIcons,
                        defaultMenuItemRenderer: function (item) {
                            return defaultMenuItemRenderer(item, classNames);
                        },
                        labelElementId: labelElementId,
                    }, function (menuListProps, defaultRender) { return onDefaultRenderMenuList(menuListProps, classNames); }), adjustedFocusZoneProps)
                    : null,
                submenuProps && onRenderSubMenu(submenuProps, onDefaultRenderSubMenu)),
            React.createElement(FocusRects, null))); }));
    }
    else {
        return null;
    }
    //#endregion
}), function (prevProps, newProps) {
    if (!newProps.shouldUpdateWhenHidden && prevProps.hidden && newProps.hidden) {
        // Do not update when hidden.
        return true;
    }
    return shallowCompare(prevProps, newProps);
});
ContextualMenuBase.displayName = 'ContextualMenuBase';
/**
 * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
 */
function isAltOrMeta(ev) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return ev.which === KeyCodes.alt || ev.key === 'Meta';
}
function onItemMouseDown(item, ev) {
    var _a;
    (_a = item.onMouseDown) === null || _a === undefined ? undefined : _a.call(item, item, ev);
}
function onDefaultRenderSubMenu(subMenuProps, defaultRender) {
    throw Error('ContextualMenuBase: onRenderSubMenu callback is null or undefined. ' +
        'Please ensure to set `onRenderSubMenu` property either manually or with `styled` helper.');
}
/**
 * Returns the item that matches a given key if any.
 * @param key - The key of the item to match
 * @param items - The items to look for the key
 */
function findItemByKeyFromItems(key, items) {
    for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
        var item = items_3[_i];
        if (item.itemType === ContextualMenuItemType.Section && item.sectionProps) {
            var match = findItemByKeyFromItems(key, item.sectionProps.items);
            if (match) {
                return match;
            }
        }
        else if (item.key && item.key === key) {
            return item;
        }
    }
}
function getOnClickWithOverrideTarget(onClick, target) {
    return onClick
        ? function (ev, item) {
            overrideTarget(ev, target);
            return onClick(ev, item);
        }
        : onClick;
}
function overrideTarget(ev, target) {
    if (ev && target) {
        ev.persist();
        if (target instanceof Event) {
            ev.target = target.target;
        }
        else if (target instanceof Element) {
            ev.target = target;
        }
    }
}

var GlobalClassNames$b = {
    root: 'ms-ContextualMenu',
    container: 'ms-ContextualMenu-container',
    list: 'ms-ContextualMenu-list',
    header: 'ms-ContextualMenu-header',
    title: 'ms-ContextualMenu-title',
    isopen: 'is-open',
};
var getStyles$m = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$b, theme);
    var fonts = theme.fonts, semanticColors = theme.semanticColors, effects = theme.effects;
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            classNames.isopen,
            {
                backgroundColor: semanticColors.menuBackground,
                minWidth: '180px',
            },
            className,
        ],
        container: [
            classNames.container,
            {
                selectors: {
                    ':focus': { outline: 0 },
                },
            },
        ],
        list: [
            classNames.list,
            classNames.isopen,
            {
                listStyleType: 'none',
                margin: '0',
                padding: '0',
            },
        ],
        header: [
            classNames.header,
            fonts.small,
            {
                fontWeight: FontWeights.semibold,
                color: semanticColors.menuHeader,
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                height: CONTEXTUAL_MENU_ITEM_HEIGHT,
                lineHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
                cursor: 'default',
                padding: '0px 6px',
                userSelect: 'none',
                textAlign: 'left',
            },
        ],
        title: [
            classNames.title,
            {
                fontSize: fonts.mediumPlus.fontSize,
                paddingRight: '14px',
                paddingLeft: '14px',
                paddingBottom: '5px',
                paddingTop: '5px',
                backgroundColor: semanticColors.menuItemBackgroundPressed,
            },
        ],
        subComponentStyles: {
            callout: {
                root: {
                    boxShadow: effects.elevation8,
                },
            },
            menuItem: {},
        },
    };
};

function onRenderSubMenu(subMenuProps) {
    return React.createElement(LocalContextualMenu, __assign$2({}, subMenuProps));
}
// This is to prevent cyclic import with ContextualMenu.base.tsx.
var LocalContextualMenu = styled(ContextualMenuBase, getStyles$m, function (props) { return ({
    onRenderSubMenu: props.onRenderSubMenu
        ? composeRenderFunction(props.onRenderSubMenu, onRenderSubMenu)
        : onRenderSubMenu,
}); }, { scope: 'ContextualMenu' });
/**
 * ContextualMenu description
 */
var ContextualMenu = LocalContextualMenu;
ContextualMenu.displayName = 'ContextualMenu';

var ButtonGlobalClassNames = {
    msButton: 'ms-Button',
    msButtonHasMenu: 'ms-Button--hasMenu',
    msButtonIcon: 'ms-Button-icon',
    msButtonMenuIcon: 'ms-Button-menuIcon',
    msButtonLabel: 'ms-Button-label',
    msButtonDescription: 'ms-Button-description',
    msButtonScreenReaderText: 'ms-Button-screenReaderText',
    msButtonFlexContainer: 'ms-Button-flexContainer',
    msButtonTextContainer: 'ms-Button-textContainer',
};
var getBaseButtonClassNames = memoizeFunction(function (theme, styles, className, variantClassName, iconClassName, menuIconClassName, disabled, hasMenu, checked, expanded, isSplit) {
    var _a, _b;
    var classNames = getGlobalClassNames(ButtonGlobalClassNames, theme || {});
    var isExpanded = expanded && !isSplit;
    return mergeStyleSets(styles.__shadowConfig__, {
        root: [
            classNames.msButton,
            styles.root,
            variantClassName,
            checked && ['is-checked', styles.rootChecked],
            isExpanded && [
                'is-expanded',
                styles.rootExpanded,
                (_a = {},
                    _a[":hover .".concat(classNames.msButtonIcon)] = styles.iconExpandedHovered,
                    // menuIcon falls back to rootExpandedHovered to support original behavior
                    _a[":hover .".concat(classNames.msButtonMenuIcon)] = styles.menuIconExpandedHovered || styles.rootExpandedHovered,
                    _a[':hover'] = styles.rootExpandedHovered,
                    _a),
            ],
            hasMenu && [ButtonGlobalClassNames.msButtonHasMenu, styles.rootHasMenu],
            disabled && ['is-disabled', styles.rootDisabled],
            !disabled &&
                !isExpanded &&
                !checked && (_b = {
                    ':hover': styles.rootHovered
                },
                _b[":hover .".concat(classNames.msButtonLabel)] = styles.labelHovered,
                _b[":hover .".concat(classNames.msButtonIcon)] = styles.iconHovered,
                _b[":hover .".concat(classNames.msButtonDescription)] = styles.descriptionHovered,
                _b[":hover .".concat(classNames.msButtonMenuIcon)] = styles.menuIconHovered,
                _b[':focus'] = styles.rootFocused,
                _b[':active'] = styles.rootPressed,
                _b[":active .".concat(classNames.msButtonIcon)] = styles.iconPressed,
                _b[":active .".concat(classNames.msButtonDescription)] = styles.descriptionPressed,
                _b[":active .".concat(classNames.msButtonMenuIcon)] = styles.menuIconPressed,
                _b),
            disabled && checked && [styles.rootCheckedDisabled],
            !disabled &&
                checked && {
                ':hover': styles.rootCheckedHovered,
                ':active': styles.rootCheckedPressed,
            },
            className,
        ],
        flexContainer: [classNames.msButtonFlexContainer, styles.flexContainer],
        textContainer: [classNames.msButtonTextContainer, styles.textContainer],
        icon: [
            classNames.msButtonIcon,
            iconClassName,
            styles.icon,
            isExpanded && styles.iconExpanded,
            checked && styles.iconChecked,
            disabled && styles.iconDisabled,
        ],
        label: [classNames.msButtonLabel, styles.label, checked && styles.labelChecked, disabled && styles.labelDisabled],
        menuIcon: [
            classNames.msButtonMenuIcon,
            menuIconClassName,
            styles.menuIcon,
            checked && styles.menuIconChecked,
            disabled && !isSplit && styles.menuIconDisabled,
            !disabled &&
                !isExpanded &&
                !checked && {
                ':hover': styles.menuIconHovered,
                ':active': styles.menuIconPressed,
            },
            isExpanded && ['is-expanded', styles.menuIconExpanded],
        ],
        description: [
            classNames.msButtonDescription,
            styles.description,
            checked && styles.descriptionChecked,
            disabled && styles.descriptionDisabled,
        ],
        screenReaderText: [classNames.msButtonScreenReaderText, styles.screenReaderText],
    });
});

var SplitButtonGlobalClassNames = {
    msSplitButtonDivider: 'ms-SplitButton-divider',
};
var getSplitButtonClassNames = memoizeFunction(function (styles, disabled, expanded, checked, primaryDisabled) {
    return {
        root: mergeStyles(styles.splitButtonMenuButton, expanded && [styles.splitButtonMenuButtonExpanded], disabled && [styles.splitButtonMenuButtonDisabled], checked && !disabled && [styles.splitButtonMenuButtonChecked], primaryDisabled &&
            !disabled && [
            {
                ':focus': styles.splitButtonMenuFocused,
            },
        ]),
        splitButtonContainer: mergeStyles(styles.splitButtonContainer, !disabled &&
            checked && [
            styles.splitButtonContainerChecked,
            {
                ':hover': styles.splitButtonContainerCheckedHovered,
            },
        ], !disabled &&
            !checked && [
            {
                ':hover': styles.splitButtonContainerHovered,
                ':focus': styles.splitButtonContainerFocused,
            },
        ], disabled && styles.splitButtonContainerDisabled),
        icon: mergeStyles(styles.splitButtonMenuIcon, disabled && styles.splitButtonMenuIconDisabled, !disabled && primaryDisabled && styles.splitButtonMenuIcon),
        flexContainer: mergeStyles(styles.splitButtonFlexContainer),
        divider: mergeStyles(SplitButtonGlobalClassNames.msSplitButtonDivider, styles.splitButtonDivider, (primaryDisabled || disabled) && styles.splitButtonDividerDisabled),
    };
});

var TouchIdleDelay = 500; /* ms */
var COMPONENT_NAME$8 = 'BaseButton';
/**
 * {@docCategory Button}
 */
var BaseButton = /** @class */ (function (_super) {
    __extends$1(BaseButton, _super);
    function BaseButton(props) {
        var _this = _super.call(this, props) || this;
        _this._buttonElement = React.createRef();
        _this._splitButtonContainer = React.createRef();
        _this._mergedRef = createMergedRef();
        _this._renderedVisibleMenu = false;
        _this._getMemoizedMenuButtonKeytipProps = memoizeFunction(function (keytipProps) {
            return __assign$2(__assign$2({}, keytipProps), { hasMenu: true });
        });
        _this._onRenderIcon = function (buttonProps, defaultRender) {
            var iconProps = _this.props.iconProps;
            if (iconProps && (iconProps.iconName !== undefined || iconProps.imageProps)) {
                var className = iconProps.className, imageProps = iconProps.imageProps, rest = __rest$1(iconProps, ["className", "imageProps"]);
                // If the styles prop is specified as part of iconProps, fall back to regular Icon as FontIcon and ImageIcon
                // do not have this prop.
                if (iconProps.styles) {
                    return React.createElement(Icon, __assign$2({ className: css(_this._classNames.icon, className), imageProps: imageProps }, rest));
                }
                if (iconProps.iconName) {
                    return React.createElement(FontIcon, __assign$2({ className: css(_this._classNames.icon, className) }, rest));
                }
                if (imageProps) {
                    return React.createElement(ImageIcon, __assign$2({ className: css(_this._classNames.icon, className), imageProps: imageProps }, rest));
                }
            }
            return null;
        };
        _this._onRenderTextContents = function () {
            var _a = _this.props, text = _a.text, children = _a.children, 
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            _b = _a.secondaryText, 
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            secondaryText = _b === undefined ? _this.props.description : _b, _c = _a.onRenderText, onRenderText = _c === undefined ? _this._onRenderText : _c, _d = _a.onRenderDescription, onRenderDescription = _d === undefined ? _this._onRenderDescription : _d;
            if (text || typeof children === 'string' || secondaryText) {
                return (React.createElement("span", { className: _this._classNames.textContainer },
                    onRenderText(_this.props, _this._onRenderText),
                    onRenderDescription(_this.props, _this._onRenderDescription)));
            }
            return [onRenderText(_this.props, _this._onRenderText), onRenderDescription(_this.props, _this._onRenderDescription)];
        };
        _this._onRenderText = function () {
            var text = _this.props.text;
            var children = _this.props.children;
            // For backwards compat, we should continue to take in the text content from children.
            if (text === undefined && typeof children === 'string') {
                text = children;
            }
            if (_this._hasText()) {
                return (React.createElement("span", { key: _this._labelId, className: _this._classNames.label, id: _this._labelId }, text));
            }
            return null;
        };
        _this._onRenderChildren = function () {
            var children = _this.props.children;
            // If children is just a string, either it or the text will be rendered via onRenderLabel
            // If children is another component, it will be rendered after text
            if (typeof children === 'string') {
                return null;
            }
            return children;
        };
        _this._onRenderDescription = function (props) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = props.secondaryText, secondaryText = _a === undefined ? _this.props.description : _a;
            // ms-Button-description is only shown when the button type is compound.
            // In other cases it will not be displayed.
            return secondaryText ? (React.createElement("span", { key: _this._descriptionId, className: _this._classNames.description, id: _this._descriptionId }, secondaryText)) : null;
        };
        _this._onRenderAriaDescription = function () {
            var ariaDescription = _this.props.ariaDescription;
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
            // otherwise it will be assigned to descriptionSpan.
            return ariaDescription ? (React.createElement("span", { className: _this._classNames.screenReaderText, id: _this._ariaDescriptionId }, ariaDescription)) : null;
        };
        _this._onRenderMenuIcon = function (props) {
            var menuIconProps = _this.props.menuIconProps;
            return React.createElement(FontIcon, __assign$2({ iconName: "ChevronDown" }, menuIconProps, { className: _this._classNames.menuIcon }));
        };
        _this._onRenderMenu = function (menuProps) {
            var MenuType = _this.props.menuAs ? composeComponentAs(_this.props.menuAs, ContextualMenu) : ContextualMenu;
            return React.createElement(MenuType, __assign$2({}, menuProps));
        };
        _this._onDismissMenu = function (ev) {
            var menuProps = _this.props.menuProps;
            if (menuProps && menuProps.onDismiss) {
                menuProps.onDismiss(ev);
            }
            if (!ev || !ev.defaultPrevented) {
                _this._dismissMenu();
            }
        };
        _this._dismissMenu = function () {
            _this._menuShouldFocusOnMount = undefined;
            _this._menuShouldFocusOnContainer = undefined;
            _this.setState({ menuHidden: true });
        };
        _this._openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
            if (shouldFocusOnMount === undefined) { shouldFocusOnMount = true; }
            if (_this.props.menuProps) {
                _this._menuShouldFocusOnContainer = shouldFocusOnContainer;
                _this._menuShouldFocusOnMount = shouldFocusOnMount;
                _this._renderedVisibleMenu = true;
                _this.setState({ menuHidden: false });
            }
        };
        _this._onToggleMenu = function (shouldFocusOnContainer) {
            var shouldFocusOnMount = true;
            if (_this.props.menuProps && _this.props.menuProps.shouldFocusOnMount === false) {
                shouldFocusOnMount = false;
            }
            _this.state.menuHidden ? _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount) : _this._dismissMenu();
        };
        _this._onSplitContainerFocusCapture = function (ev) {
            var container = _this._splitButtonContainer.current;
            // If the target is coming from the portal we do not need to set focus on the container.
            if (!container || (ev.target && portalContainsElement(ev.target, container))) {
                return;
            }
            // We should never be able to focus the individual buttons in a split button. Focus
            // should always remain on the container.
            container.focus();
        };
        _this._onSplitButtonPrimaryClick = function (ev) {
            if (!_this.state.menuHidden) {
                _this._dismissMenu();
            }
            // toggle split buttons need two separate targets, even for touch
            var singleTouchTarget = _this._processingTouch && !_this.props.toggle;
            if (!singleTouchTarget && _this.props.onClick) {
                _this.props.onClick(ev);
            }
            else if (singleTouchTarget) {
                _this._onMenuClick(ev);
            }
        };
        _this._onKeyDown = function (ev) {
            // explicity cancelling event so click won't fire after this
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (_this.props.disabled && (ev.which === KeyCodes.enter || ev.which === KeyCodes.space)) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            else if (!_this.props.disabled) {
                if (_this.props.menuProps) {
                    _this._onMenuKeyDown(ev);
                }
                else if (_this.props.onKeyDown !== undefined) {
                    _this.props.onKeyDown(ev); // not cancelling event because it's not disabled
                }
            }
        };
        _this._onKeyUp = function (ev) {
            if (!_this.props.disabled && _this.props.onKeyUp !== undefined) {
                _this.props.onKeyUp(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onKeyPress = function (ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (!_this.props.disabled && _this.props.onKeyPress !== undefined) {
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                _this.props.onKeyPress(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onMouseUp = function (ev) {
            if (!_this.props.disabled && _this.props.onMouseUp !== undefined) {
                _this.props.onMouseUp(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onMouseDown = function (ev) {
            if (!_this.props.disabled && _this.props.onMouseDown !== undefined) {
                _this.props.onMouseDown(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onClick = function (ev) {
            if (!_this.props.disabled) {
                if (_this.props.menuProps) {
                    _this._onMenuClick(ev);
                }
                else if (_this.props.onClick !== undefined) {
                    _this.props.onClick(ev); // not cancelling event because it's not disabled
                }
            }
        };
        _this._onSplitButtonContainerKeyDown = function (ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === KeyCodes.enter || ev.which === KeyCodes.space) {
                if (_this._buttonElement.current) {
                    _this._buttonElement.current.click();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
            else {
                _this._onMenuKeyDown(ev);
            }
        };
        _this._onMenuKeyDown = function (ev) {
            var _a;
            if (_this.props.disabled) {
                return;
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(ev);
            }
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var isUp = ev.which === KeyCodes.up;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var isDown = ev.which === KeyCodes.down;
            if (!ev.defaultPrevented && _this._isValidMenuOpenKey(ev)) {
                var onMenuClick = _this.props.onMenuClick;
                if (onMenuClick) {
                    onMenuClick(ev, _this.props);
                }
                _this._onToggleMenu(false);
                ev.preventDefault();
                ev.stopPropagation();
            }
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === KeyCodes.enter || ev.which === KeyCodes.space) {
                // We manually set the focus visibility to true if opening via Enter or Space to account for the scenario where
                // a user clicks on the button, closes the menu and then opens it via keyboard. In this scenario our default logic
                // for setting focus visibility is not triggered since there is no keyboard navigation present beforehand.
                setFocusVisibility(true, ev.target, (_a = _this.context) === null || _a === undefined ? undefined : _a.registeredProviders);
            }
            if (!(ev.altKey || ev.metaKey) && (isUp || isDown)) {
                // Suppose a menu, with shouldFocusOnMount: false, is open, and user wants to keyboard to the menu items
                // We need to re-render the menu with shouldFocusOnMount as true.
                if (!_this.state.menuHidden && _this.props.menuProps) {
                    var currentShouldFocusOnMount = _this._menuShouldFocusOnMount !== undefined
                        ? _this._menuShouldFocusOnMount
                        : _this.props.menuProps.shouldFocusOnMount;
                    if (!currentShouldFocusOnMount) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        _this._menuShouldFocusOnMount = true;
                        _this.forceUpdate();
                    }
                }
            }
        };
        _this._onTouchStart = function () {
            if (_this._isSplitButton &&
                _this._splitButtonContainer.current &&
                !('onpointerdown' in _this._splitButtonContainer.current)) {
                _this._handleTouchAndPointerEvent();
            }
        };
        _this._onMenuClick = function (ev) {
            var _a = _this.props, onMenuClick = _a.onMenuClick, menuProps = _a.menuProps;
            if (onMenuClick) {
                onMenuClick(ev, _this.props);
            }
            // focus on the container by default when the menu is opened with a click event
            // this differentiates from a keyboard interaction triggering the click event
            var shouldFocusOnContainer = typeof (menuProps === null || menuProps === undefined ? undefined : menuProps.shouldFocusOnContainer) === 'boolean'
                ? menuProps.shouldFocusOnContainer
                : ev.nativeEvent.pointerType === 'mouse';
            if (!ev.defaultPrevented) {
                _this._onToggleMenu(shouldFocusOnContainer);
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        initializeComponentRef(_this);
        _this._async = new Async(_this);
        _this._events = new EventGroup(_this);
        warnConditionallyRequiredProps(COMPONENT_NAME$8, props, ['menuProps', 'onClick'], 'split', _this.props.split);
        warnDeprecations(COMPONENT_NAME$8, props, {
            rootProps: undefined,
            description: 'secondaryText',
            toggled: 'checked',
        });
        _this._labelId = getId();
        _this._descriptionId = getId();
        _this._ariaDescriptionId = getId();
        _this.state = {
            menuHidden: true,
        };
        return _this;
    }
    Object.defineProperty(BaseButton.prototype, "_isSplitButton", {
        get: function () {
            return !!this.props.menuProps && !!this.props.onClick && this.props.split === true;
        },
        enumerable: false,
        configurable: true
    });
    BaseButton.prototype.render = function () {
        var _a;
        var _b = this.props, ariaDescription = _b.ariaDescription, ariaLabel = _b.ariaLabel, ariaHidden = _b.ariaHidden, className = _b.className, disabled = _b.disabled, allowDisabledFocus = _b.allowDisabledFocus, primaryDisabled = _b.primaryDisabled, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        _c = _b.secondaryText, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        secondaryText = _c === undefined ? this.props.description : _c, href = _b.href, iconProps = _b.iconProps, menuIconProps = _b.menuIconProps, styles = _b.styles, checked = _b.checked, variantClassName = _b.variantClassName, theme = _b.theme, toggle = _b.toggle, getClassNames = _b.getClassNames, role = _b.role;
        var menuHidden = this.state.menuHidden;
        // Button is disabled if the whole button (in case of splitButton is disabled) or if the primary action is disabled
        var isPrimaryButtonDisabled = disabled || primaryDisabled;
        this._classNames = getClassNames
            ? getClassNames(theme, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, !menuHidden, !!this.props.menuProps, this.props.split, !!allowDisabledFocus)
            : getBaseButtonClassNames(theme, styles, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, !!this.props.menuProps, checked, !menuHidden, this.props.split);
        var _d = this, _ariaDescriptionId = _d._ariaDescriptionId, _labelId = _d._labelId, _descriptionId = _d._descriptionId;
        // Anchor tag cannot be disabled hence in disabled state rendering
        // anchor button as normal button
        var renderAsAnchor = !isPrimaryButtonDisabled && !!href;
        var tag = renderAsAnchor ? 'a' : 'button';
        var nativeProps = getNativeProps$1(
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        assign$2(renderAsAnchor ? {} : { type: 'button' }, this.props.rootProps, this.props), renderAsAnchor ? anchorProperties$1 : buttonProperties$1, [
            'disabled', // let disabled buttons be focused and styled as disabled.
        ]);
        // Check for ariaLabel passed in via Button props, and fall back to aria-label passed in via native props
        var resolvedAriaLabel = ariaLabel || nativeProps['aria-label'];
        // Check for ariaDescription, secondaryText or aria-describedby in the native props to determine source of
        // aria-describedby. Otherwise default to undefined so property does not appear in output.
        var ariaDescribedBy = undefined;
        if (ariaDescription) {
            ariaDescribedBy = _ariaDescriptionId;
        }
        else if (secondaryText && this.props.onRenderDescription !== nullRender) {
            // for buttons like CompoundButton with a valid onRenderDescription, we need to set an ariaDescribedBy
            // for buttons that do not render anything (via nullRender), we should not set an ariaDescribedBy
            ariaDescribedBy = _descriptionId;
        }
        else if (nativeProps['aria-describedby']) {
            ariaDescribedBy = nativeProps['aria-describedby'];
        }
        // If an explicit aria-labelledby is given, use that and we're done.
        // If any kind of description is given (which will end up as an aria-describedby attribute)
        // and no ariaLabel is specified, set the labelledby element.
        // Otherwise, the button is labeled implicitly by the descendent text on the button (if it exists).
        var ariaLabelledBy = undefined;
        if (nativeProps['aria-labelledby']) {
            ariaLabelledBy = nativeProps['aria-labelledby'];
        }
        else if (ariaDescribedBy && !resolvedAriaLabel) {
            ariaLabelledBy = this._hasText() ? _labelId : undefined;
        }
        var dataIsFocusable = this.props['data-is-focusable'] === false || (disabled && !allowDisabledFocus) || this._isSplitButton
            ? false
            : true;
        var isCheckboxTypeRole = role === 'menuitemcheckbox' || role === 'checkbox';
        // if isCheckboxTypeRole, always return a checked value.
        // Otherwise only return checked value if toggle is set to true.
        // This is because role="checkbox" always needs to have an aria-checked value
        // but our checked prop only sets aria-pressed if we mark the button as a toggle="true"
        var checkedOrPressedValue = isCheckboxTypeRole ? !!checked : toggle === true ? !!checked : undefined;
        var buttonProps = assign$2(nativeProps, (_a = {
                className: this._classNames.root,
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                ref: this._mergedRef(this.props.elementRef, this._buttonElement),
                disabled: isPrimaryButtonDisabled && !allowDisabledFocus,
                onKeyDown: this._onKeyDown,
                onKeyPress: this._onKeyPress,
                onKeyUp: this._onKeyUp,
                onMouseDown: this._onMouseDown,
                onMouseUp: this._onMouseUp,
                onClick: this._onClick,
                'aria-label': resolvedAriaLabel,
                'aria-labelledby': ariaLabelledBy,
                'aria-describedby': ariaDescribedBy,
                'aria-disabled': isPrimaryButtonDisabled,
                'data-is-focusable': dataIsFocusable
            },
            // aria-pressed attribute should only be present for toggle buttons
            // aria-checked attribute should only be present for toggle buttons with checkbox type role
            _a[isCheckboxTypeRole ? 'aria-checked' : 'aria-pressed'] = checkedOrPressedValue,
            _a));
        if (ariaHidden) {
            buttonProps['aria-hidden'] = true;
        }
        if (this._isSplitButton) {
            return this._onRenderSplitButtonContent(tag, buttonProps);
        }
        else if (this.props.menuProps) {
            var _e = this.props.menuProps.id, id = _e === undefined ? "".concat(this._labelId, "-menu") : _e;
            assign$2(buttonProps, {
                'aria-expanded': !menuHidden,
                'aria-controls': !menuHidden ? id : null,
                'aria-haspopup': true,
            });
        }
        return this._onRenderContent(tag, buttonProps);
    };
    BaseButton.prototype.componentDidMount = function () {
        // For split buttons, touching anywhere in the button should drop the dropdown, which should contain the
        // primary action. This gives more hit target space for touch environments. We're setting the onpointerdown here,
        // because React does not support Pointer events yet.
        if (this._isSplitButton && this._splitButtonContainer.current) {
            if ('onpointerdown' in this._splitButtonContainer.current) {
                this._events.on(this._splitButtonContainer.current, 'pointerdown', this._onPointerDown, true);
            }
            if ('onpointerup' in this._splitButtonContainer.current && this.props.onPointerUp) {
                this._events.on(this._splitButtonContainer.current, 'pointerup', this.props.onPointerUp, true);
            }
        }
    };
    BaseButton.prototype.componentDidUpdate = function (prevProps, prevState) {
        // If Button's menu was closed, run onAfterMenuDismiss.
        if (this.props.onAfterMenuDismiss && !prevState.menuHidden && this.state.menuHidden) {
            this.props.onAfterMenuDismiss();
        }
    };
    BaseButton.prototype.componentWillUnmount = function () {
        this._async.dispose();
        this._events.dispose();
    };
    BaseButton.prototype.focus = function () {
        var _a, _b;
        if (this._isSplitButton && this._splitButtonContainer.current) {
            setFocusVisibility(true, undefined, (_a = this.context) === null || _a === undefined ? undefined : _a.registeredProviders);
            this._splitButtonContainer.current.focus();
        }
        else if (this._buttonElement.current) {
            setFocusVisibility(true, undefined, (_b = this.context) === null || _b === undefined ? undefined : _b.registeredProviders);
            this._buttonElement.current.focus();
        }
    };
    BaseButton.prototype.dismissMenu = function () {
        this._dismissMenu();
    };
    BaseButton.prototype.openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
        this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
    };
    BaseButton.prototype._onRenderContent = function (tag, buttonProps) {
        var _this = this;
        var props = this.props;
        var Tag = tag;
        var menuIconProps = props.menuIconProps, menuProps = props.menuProps, _a = props.onRenderIcon, onRenderIcon = _a === undefined ? this._onRenderIcon : _a, _b = props.onRenderAriaDescription, onRenderAriaDescription = _b === undefined ? this._onRenderAriaDescription : _b, _c = props.onRenderChildren, onRenderChildren = _c === undefined ? this._onRenderChildren : _c, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        _d = props.onRenderMenu, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        onRenderMenu = _d === undefined ? this._onRenderMenu : _d, _e = props.onRenderMenuIcon, onRenderMenuIcon = _e === undefined ? this._onRenderMenuIcon : _e, disabled = props.disabled;
        var keytipProps = props.keytipProps;
        if (keytipProps && menuProps) {
            keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        }
        var Button = function (keytipAttributes) { return (React.createElement(Tag, __assign$2({}, buttonProps, keytipAttributes),
            React.createElement("span", { className: _this._classNames.flexContainer, "data-automationid": "splitbuttonprimary" },
                onRenderIcon(props, _this._onRenderIcon),
                _this._onRenderTextContents(),
                onRenderAriaDescription(props, _this._onRenderAriaDescription),
                onRenderChildren(props, _this._onRenderChildren),
                !_this._isSplitButton &&
                    (menuProps || menuIconProps || _this.props.onRenderMenuIcon) &&
                    onRenderMenuIcon(_this.props, _this._onRenderMenuIcon),
                menuProps &&
                    !menuProps.doNotLayer &&
                    _this._shouldRenderMenu() &&
                    onRenderMenu(_this._getMenuProps(menuProps), _this._onRenderMenu)))); };
        var Content = keytipProps ? (
        // If we're making a split button, we won't put the keytip here
        React.createElement(KeytipData, { keytipProps: !this._isSplitButton ? keytipProps : undefined, ariaDescribedBy: buttonProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return Button(keytipAttributes); })) : (Button());
        if (menuProps && menuProps.doNotLayer) {
            return (React.createElement(React.Fragment, null,
                Content,
                this._shouldRenderMenu() && onRenderMenu(this._getMenuProps(menuProps), this._onRenderMenu)));
        }
        return (React.createElement(React.Fragment, null,
            Content,
            React.createElement(FocusRects, null)));
    };
    /**
     * Method to help determine if the menu's component tree should
     * be rendered. It takes into account whether the menu is expanded,
     * whether it is a persisted menu and whether it has been shown to the user.
     */
    BaseButton.prototype._shouldRenderMenu = function () {
        var menuHidden = this.state.menuHidden;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var _a = this.props, persistMenu = _a.persistMenu, renderPersistedMenuHiddenOnMount = _a.renderPersistedMenuHiddenOnMount;
        if (!menuHidden) {
            // Always should render a menu when it is expanded
            return true;
        }
        else if (persistMenu && (this._renderedVisibleMenu || renderPersistedMenuHiddenOnMount)) {
            // _renderedVisibleMenu ensures that the first rendering of
            // the menu happens on-screen, as edge's scrollbar calculations are off if done while hidden.
            return true;
        }
        return false;
    };
    BaseButton.prototype._hasText = function () {
        // _onRenderTextContents and _onRenderText do not perform the same checks. Below is parity with what _onRenderText
        // used to have before the refactor that introduced this function. _onRenderTextContents does not require props.
        // text to be undefined in order for props.children to be used as a fallback.
        // Purely a code maintainability/reuse issue, but logged as Issue #4979.
        return this.props.text !== null && (this.props.text !== undefined || typeof this.props.children === 'string');
    };
    BaseButton.prototype._getMenuProps = function (menuProps) {
        var persistMenu = this.props.persistMenu;
        var menuHidden = this.state.menuHidden;
        // the accessible menu label (accessible name) has a relationship to the button.
        // If the menu props do not specify an explicit value for aria-label or aria-labelledBy,
        // AND the button has text, we'll set the menu aria-labelledBy to the text element id.
        if (!menuProps.ariaLabel && !menuProps.labelElementId && this._hasText()) {
            menuProps = __assign$2(__assign$2({}, menuProps), { labelElementId: this._labelId });
        }
        return __assign$2(__assign$2({ id: this._labelId + '-menu', directionalHint: DirectionalHint.bottomLeftEdge }, menuProps), { shouldFocusOnContainer: this._menuShouldFocusOnContainer, shouldFocusOnMount: this._menuShouldFocusOnMount, hidden: persistMenu ? menuHidden : undefined, className: css('ms-BaseButton-menuhost', menuProps.className), target: this._isSplitButton ? this._splitButtonContainer.current : this._buttonElement.current, onDismiss: this._onDismissMenu });
    };
    BaseButton.prototype._onRenderSplitButtonContent = function (tag, buttonProps) {
        var _this = this;
        var _a = this.props, _b = _a.styles, styles = _b === undefined ? {} : _b, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, getSplitButtonClassNames$1 = _a.getSplitButtonClassNames, primaryDisabled = _a.primaryDisabled, menuProps = _a.menuProps, toggle = _a.toggle, role = _a.role, primaryActionButtonProps = _a.primaryActionButtonProps;
        var keytipProps = this.props.keytipProps;
        var menuHidden = this.state.menuHidden;
        var classNames = getSplitButtonClassNames$1
            ? getSplitButtonClassNames$1(!!disabled, !menuHidden, !!checked, !!allowDisabledFocus)
            : styles && getSplitButtonClassNames(styles, !!disabled, !menuHidden, !!checked, !!primaryDisabled);
        assign$2(buttonProps, {
            onClick: undefined,
            onPointerDown: undefined,
            onPointerUp: undefined,
            tabIndex: -1,
            'data-is-focusable': false,
        });
        if (keytipProps && menuProps) {
            keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        }
        var containerProps = getNativeProps$1(buttonProps, [], ['disabled']);
        // Add additional props to apply on primary action button
        if (primaryActionButtonProps) {
            assign$2(buttonProps, primaryActionButtonProps);
        }
        var SplitButton = function (keytipAttributes) { return (React.createElement("div", __assign$2({}, containerProps, { "data-ktp-target": keytipAttributes ? keytipAttributes['data-ktp-target'] : undefined, role: role ? role : 'button', "aria-disabled": disabled, "aria-haspopup": true, "aria-expanded": !menuHidden, "aria-pressed": toggle ? !!checked : undefined, "aria-describedby": mergeAriaAttributeValues(buttonProps['aria-describedby'], keytipAttributes ? keytipAttributes['aria-describedby'] : undefined), className: classNames && classNames.splitButtonContainer, onKeyDown: _this._onSplitButtonContainerKeyDown, onTouchStart: _this._onTouchStart, ref: _this._splitButtonContainer, "data-is-focusable": true, onClick: !disabled && !primaryDisabled ? _this._onSplitButtonPrimaryClick : undefined, tabIndex: (!disabled && !primaryDisabled) || allowDisabledFocus ? 0 : undefined, "aria-roledescription": buttonProps['aria-roledescription'], onFocusCapture: _this._onSplitContainerFocusCapture }),
            React.createElement("span", { style: { display: 'flex', width: '100%' } },
                _this._onRenderContent(tag, buttonProps),
                _this._onRenderSplitButtonMenuButton(classNames, keytipAttributes),
                _this._onRenderSplitButtonDivider(classNames)))); };
        return keytipProps ? (React.createElement(KeytipData, { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return SplitButton(keytipAttributes); })) : (SplitButton());
    };
    BaseButton.prototype._onRenderSplitButtonDivider = function (classNames) {
        if (classNames && classNames.divider) {
            var onClick = function (ev) {
                ev.stopPropagation();
            };
            return React.createElement("span", { className: classNames.divider, "aria-hidden": true, onClick: onClick });
        }
        return null;
    };
    BaseButton.prototype._onRenderSplitButtonMenuButton = function (classNames, keytipAttributes) {
        var _a = this.props, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, disabled = _a.disabled, splitButtonMenuProps = _a.splitButtonMenuProps, splitButtonAriaLabel = _a.splitButtonAriaLabel, primaryDisabled = _a.primaryDisabled;
        var menuHidden = this.state.menuHidden;
        var menuIconProps = this.props.menuIconProps;
        if (menuIconProps === undefined) {
            menuIconProps = {
                iconName: 'ChevronDown',
            };
        }
        var splitButtonProps = __assign$2(__assign$2({}, splitButtonMenuProps), { styles: classNames, checked: checked, disabled: disabled, allowDisabledFocus: allowDisabledFocus, onClick: this._onMenuClick, menuProps: undefined, iconProps: __assign$2(__assign$2({}, menuIconProps), { className: this._classNames.menuIcon }), ariaLabel: splitButtonAriaLabel, 'aria-haspopup': true, 'aria-expanded': !menuHidden, 'data-is-focusable': false });
        // Add data-ktp-execute-target to the split button if the keytip is defined
        return (React.createElement(BaseButton, __assign$2({}, splitButtonProps, { "data-ktp-execute-target": keytipAttributes ? keytipAttributes['data-ktp-execute-target'] : keytipAttributes, onMouseDown: this._onMouseDown, tabIndex: primaryDisabled && !allowDisabledFocus ? 0 : -1 })));
    };
    BaseButton.prototype._onPointerDown = function (ev) {
        var onPointerDown = this.props.onPointerDown;
        if (onPointerDown) {
            onPointerDown(ev);
        }
        if (ev.pointerType === 'touch') {
            this._handleTouchAndPointerEvent();
            ev.preventDefault();
            ev.stopImmediatePropagation();
        }
    };
    BaseButton.prototype._handleTouchAndPointerEvent = function () {
        var _this = this;
        // If we already have an existing timeout from a previous touch and pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId !== undefined) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function () {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
            // Touch and pointer events don't focus the button naturally,
            // so adding an imperative focus call to guarantee this behavior.
            // Only focus the button if a splitbutton menu is not open
            if (_this.state.menuHidden) {
                _this.focus();
            }
        }, TouchIdleDelay);
    };
    /**
     * Returns if the user hits a valid keyboard key to open the menu
     * @param ev - the keyboard event
     * @returns True if user clicks on custom trigger key if enabled or alt + down arrow if not. False otherwise.
     */
    BaseButton.prototype._isValidMenuOpenKey = function (ev) {
        if (this.props.menuTriggerKeyCode) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            return ev.which === this.props.menuTriggerKeyCode;
        }
        else if (this.props.menuProps) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            return ev.which === KeyCodes.down && (ev.altKey || ev.metaKey);
        }
        // Note: When enter is pressed, we will let the event continue to propagate
        // to trigger the onClick event on the button
        return false;
    };
    BaseButton.defaultProps = {
        baseClassName: 'ms-Button',
        styles: {},
        split: false,
    };
    // needed to access registeredProviders when manually setting focus visibility
    BaseButton.contextType = FocusRectsContext;
    return BaseButton;
}(React.Component));

var noOutline = {
    outline: 0,
};
var iconStyle = function (fontSize) {
    return {
        fontSize: fontSize,
        margin: '0 4px',
        height: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        flexShrink: 0,
    };
};
/**
 * Gets the base button styles. Note: because it is a base class to be used with the `mergeRules`
 * helper, it should have values for all class names in the interface. This let `mergeRules` optimize
 * mixing class names together.
 */
var getStyles$l = memoizeFunction(function (theme) {
    var _a, _b;
    var semanticColors = theme.semanticColors, effects = theme.effects, fonts = theme.fonts;
    var border = semanticColors.buttonBorder;
    var disabledBackground = semanticColors.disabledBackground;
    var disabledText = semanticColors.disabledText;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        outlineColor: 'ButtonText',
    };
    return {
        root: [
            getFocusStyle(theme, { inset: 1, highContrastStyle: buttonHighContrastFocus, borderColor: 'transparent' }),
            theme.fonts.medium,
            {
                border: '1px solid ' + border,
                borderRadius: effects.roundedCorner2,
                boxSizing: 'border-box',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
                textDecoration: 'none',
                textAlign: 'center',
                userSelect: 'none',
                // IE11 workaround for preventing shift of child elements of a button when active.
                ':active > span': {
                    position: 'relative',
                    left: 0,
                    top: 0,
                },
            },
        ],
        rootDisabled: [
            getFocusStyle(theme, { inset: 1, highContrastStyle: buttonHighContrastFocus, borderColor: 'transparent' }),
            {
                backgroundColor: disabledBackground,
                borderColor: disabledBackground,
                color: disabledText,
                cursor: 'default',
                ':hover': noOutline,
                ':focus': noOutline,
            },
        ],
        iconDisabled: (_a = {
                color: disabledText
            },
            _a[HighContrastSelector] = {
                color: 'GrayText',
            },
            _a),
        menuIconDisabled: (_b = {
                color: disabledText
            },
            _b[HighContrastSelector] = {
                color: 'GrayText',
            },
            _b),
        flexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
        },
        description: {
            display: 'block',
        },
        textContainer: {
            flexGrow: 1,
            display: 'block',
        },
        icon: iconStyle(fonts.mediumPlus.fontSize),
        menuIcon: iconStyle(fonts.small.fontSize),
        label: {
            margin: '0 4px',
            lineHeight: '100%',
            display: 'block',
        },
        screenReaderText: hiddenContentStyle,
    };
});

var getStyles$k = memoizeFunction(function (theme, customStyles) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var effects = theme.effects, palette = theme.palette, semanticColors = theme.semanticColors;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        border: 'none',
    };
    var splitButtonDividerBaseStyles = {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8,
    };
    var splitButtonStyles = {
        splitButtonContainer: [
            getFocusStyle(theme, { highContrastStyle: buttonHighContrastFocus, inset: 2, pointerEvents: 'none' }),
            {
                display: 'inline-flex',
                '.ms-Button--default': {
                    borderTopRightRadius: '0',
                    borderBottomRightRadius: '0',
                    borderRight: 'none',
                    flexGrow: '1',
                },
                '.ms-Button--primary': (_a = {
                        borderTopRightRadius: '0',
                        borderBottomRightRadius: '0',
                        border: 'none',
                        flexGrow: '1',
                        ':hover': {
                            border: 'none',
                        },
                        ':active': {
                            border: 'none',
                        }
                    },
                    _a[HighContrastSelector] = __assign$2(__assign$2({ color: 'WindowText', backgroundColor: 'Window', border: '1px solid WindowText', borderRightWidth: '0' }, getHighContrastNoAdjustStyle()), { ':hover': {
                            backgroundColor: 'Highlight',
                            border: '1px solid Highlight',
                            borderRightWidth: '0',
                            color: 'HighlightText',
                        }, ':active': {
                            border: '1px solid Highlight',
                        } }),
                    _a),
                '.ms-Button--default + .ms-Button': (_b = {},
                    _b[HighContrastSelector] = {
                        border: '1px solid WindowText',
                        borderLeftWidth: '0',
                        ':hover': {
                            backgroundColor: 'HighlightText',
                            borderColor: 'Highlight',
                            color: 'Highlight',
                            '.ms-Button-menuIcon': __assign$2({ backgroundColor: 'HighlightText', color: 'Highlight' }, getHighContrastNoAdjustStyle()),
                        },
                    },
                    _b),
                '.ms-Button--default + .ms-Button[aria-expanded="true"]': (_c = {},
                    _c[HighContrastSelector] = {
                        backgroundColor: 'HighlightText',
                        borderColor: 'Highlight',
                        color: 'Highlight',
                        '.ms-Button-menuIcon': __assign$2({ backgroundColor: 'HighlightText', color: 'Highlight' }, getHighContrastNoAdjustStyle()),
                    },
                    _c),
                '.ms-Button--primary + .ms-Button': (_d = {
                        border: 'none'
                    },
                    _d[HighContrastSelector] = {
                        border: '1px solid WindowText',
                        borderLeftWidth: '0',
                        ':hover': {
                            borderLeftWidth: '0',
                            backgroundColor: 'Highlight',
                            borderColor: 'Highlight',
                            color: 'HighlightText',
                            '.ms-Button-menuIcon': __assign$2(__assign$2({}, getHighContrastNoAdjustStyle()), { color: 'HighlightText' }),
                        },
                    },
                    _d),
                '.ms-Button--primary + .ms-Button[aria-expanded="true"]': (_e = {},
                    _e[HighContrastSelector] = __assign$2(__assign$2({ backgroundColor: 'Highlight', borderColor: 'Highlight', color: 'HighlightText' }, getHighContrastNoAdjustStyle()), { '.ms-Button-menuIcon': {
                            color: 'HighlightText',
                        } }),
                    _e),
                '.ms-Button.is-disabled': (_f = {},
                    _f[HighContrastSelector] = {
                        color: 'GrayText',
                        borderColor: 'GrayText',
                        backgroundColor: 'Window',
                    },
                    _f),
            },
        ],
        splitButtonContainerHovered: {
            '.ms-Button--default.is-disabled': (_g = {
                    backgroundColor: semanticColors.buttonBackgroundDisabled,
                    color: semanticColors.buttonTextDisabled
                },
                _g[HighContrastSelector] = {
                    color: 'GrayText',
                    borderColor: 'GrayText',
                    backgroundColor: 'Window',
                },
                _g),
            '.ms-Button--primary.is-disabled': (_h = {
                    backgroundColor: semanticColors.primaryButtonBackgroundDisabled,
                    color: semanticColors.primaryButtonTextDisabled
                },
                _h[HighContrastSelector] = {
                    color: 'GrayText',
                    borderColor: 'GrayText',
                    backgroundColor: 'Window',
                },
                _h),
        },
        splitButtonContainerChecked: {
            '.ms-Button--primary': (_j = {},
                _j[HighContrastSelector] = __assign$2({ color: 'Window', backgroundColor: 'WindowText' }, getHighContrastNoAdjustStyle()),
                _j),
        },
        splitButtonContainerCheckedHovered: {
            '.ms-Button--primary': (_k = {},
                _k[HighContrastSelector] = __assign$2({ color: 'Window', backgroundColor: 'WindowText' }, getHighContrastNoAdjustStyle()),
                _k),
        },
        splitButtonContainerFocused: {
            outline: 'none!important',
        },
        splitButtonMenuButton: (_l = {
                padding: 6,
                height: 'auto',
                boxSizing: 'border-box',
                borderRadius: 0,
                borderTopRightRadius: effects.roundedCorner2,
                borderBottomRightRadius: effects.roundedCorner2,
                border: "1px solid ".concat(palette.neutralSecondaryAlt),
                borderLeft: 'none',
                outline: 'transparent',
                userSelect: 'none',
                display: 'inline-block',
                textDecoration: 'none',
                textAlign: 'center',
                cursor: 'pointer',
                verticalAlign: 'top',
                width: 32,
                marginLeft: -1,
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0
            },
            _l[HighContrastSelector] = {
                '.ms-Button-menuIcon': {
                    color: 'WindowText',
                },
            },
            _l),
        splitButtonDivider: __assign$2(__assign$2({}, splitButtonDividerBaseStyles), (_m = {}, _m[HighContrastSelector] = {
            backgroundColor: 'WindowText',
        }, _m)),
        splitButtonDividerDisabled: __assign$2(__assign$2({}, splitButtonDividerBaseStyles), (_o = {}, _o[HighContrastSelector] = {
            backgroundColor: 'GrayText',
        }, _o)),
        splitButtonMenuButtonDisabled: (_p = {
                pointerEvents: 'none',
                border: 'none',
                ':hover': {
                    cursor: 'default',
                },
                '.ms-Button--primary': (_q = {},
                    _q[HighContrastSelector] = {
                        color: 'GrayText',
                        borderColor: 'GrayText',
                        backgroundColor: 'Window',
                    },
                    _q),
                '.ms-Button-menuIcon': (_r = {},
                    _r[HighContrastSelector] = {
                        color: 'GrayText',
                    },
                    _r)
            },
            _p[HighContrastSelector] = {
                color: 'GrayText',
                border: '1px solid GrayText',
                backgroundColor: 'Window',
            },
            _p),
        splitButtonFlexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
        },
        splitButtonContainerDisabled: (_s = {
                outline: 'none',
                border: 'none'
            },
            _s[HighContrastSelector] = __assign$2({ color: 'GrayText', borderColor: 'GrayText', backgroundColor: 'Window' }, getHighContrastNoAdjustStyle()),
            _s),
        splitButtonMenuFocused: __assign$2({}, getFocusStyle(theme, { highContrastStyle: buttonHighContrastFocus, inset: 2 })),
    };
    return concatStyleSets(splitButtonStyles, customStyles);
});

var splitButtonDividerBaseStyles = function () {
    return {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8,
    };
};
function standardStyles(theme) {
    var _a, _b, _c, _d, _e;
    var s = theme.semanticColors, p = theme.palette;
    var buttonBackground = s.buttonBackground;
    var buttonBackgroundPressed = s.buttonBackgroundPressed;
    var buttonBackgroundHovered = s.buttonBackgroundHovered;
    var buttonBackgroundDisabled = s.buttonBackgroundDisabled;
    var buttonText = s.buttonText;
    var buttonTextHovered = s.buttonTextHovered;
    var buttonTextDisabled = s.buttonTextDisabled;
    var buttonTextChecked = s.buttonTextChecked;
    var buttonTextCheckedHovered = s.buttonTextCheckedHovered;
    return {
        root: {
            backgroundColor: buttonBackground,
            color: buttonText,
        },
        rootHovered: (_a = {
                backgroundColor: buttonBackgroundHovered,
                color: buttonTextHovered
            },
            _a[HighContrastSelector] = {
                borderColor: 'Highlight',
                color: 'Highlight',
            },
            _a),
        rootPressed: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked,
        },
        rootExpanded: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked,
        },
        rootChecked: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked,
        },
        rootCheckedHovered: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextCheckedHovered,
        },
        rootDisabled: (_b = {
                color: buttonTextDisabled,
                backgroundColor: buttonBackgroundDisabled
            },
            _b[HighContrastSelector] = {
                color: 'GrayText',
                borderColor: 'GrayText',
                backgroundColor: 'Window',
            },
            _b),
        // Split button styles
        splitButtonContainer: (_c = {},
            _c[HighContrastSelector] = {
                border: 'none',
            },
            _c),
        splitButtonMenuButton: {
            color: p.white,
            backgroundColor: 'transparent',
            ':hover': (_d = {
                    backgroundColor: p.neutralLight
                },
                _d[HighContrastSelector] = {
                    color: 'Highlight',
                },
                _d),
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: s.buttonBackgroundDisabled,
            ':hover': {
                backgroundColor: s.buttonBackgroundDisabled,
            },
        },
        splitButtonDivider: __assign$2(__assign$2({}, splitButtonDividerBaseStyles()), (_e = { backgroundColor: p.neutralTertiaryAlt }, _e[HighContrastSelector] = {
            backgroundColor: 'WindowText',
        }, _e)),
        splitButtonDividerDisabled: {
            backgroundColor: theme.palette.neutralTertiaryAlt,
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: p.neutralQuaternaryAlt,
            ':hover': {
                backgroundColor: p.neutralQuaternaryAlt,
            },
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: p.neutralQuaternaryAlt,
            ':hover': {
                backgroundColor: p.neutralQuaternaryAlt,
            },
        },
        splitButtonMenuIcon: {
            color: s.buttonText,
        },
        splitButtonMenuIconDisabled: {
            color: s.buttonTextDisabled,
        },
    };
}
function primaryStyles(theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var p = theme.palette, s = theme.semanticColors;
    return {
        root: (_a = {
                backgroundColor: s.primaryButtonBackground,
                border: "1px solid ".concat(s.primaryButtonBackground),
                color: s.primaryButtonText
            },
            _a[HighContrastSelector] = __assign$2({ color: 'Window', backgroundColor: 'WindowText', borderColor: 'WindowText' }, getHighContrastNoAdjustStyle()),
            _a[".".concat(IsFocusVisibleClassName, " &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus")] = {
                ':after': {
                    border: "none",
                    outlineColor: p.white,
                },
            },
            _a),
        rootHovered: (_b = {
                backgroundColor: s.primaryButtonBackgroundHovered,
                border: "1px solid ".concat(s.primaryButtonBackgroundHovered),
                color: s.primaryButtonTextHovered
            },
            _b[HighContrastSelector] = {
                color: 'Window',
                backgroundColor: 'Highlight',
                borderColor: 'Highlight',
            },
            _b),
        rootPressed: (_c = {
                backgroundColor: s.primaryButtonBackgroundPressed,
                border: "1px solid ".concat(s.primaryButtonBackgroundPressed),
                color: s.primaryButtonTextPressed
            },
            _c[HighContrastSelector] = __assign$2({ color: 'Window', backgroundColor: 'WindowText', borderColor: 'WindowText' }, getHighContrastNoAdjustStyle()),
            _c),
        rootExpanded: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed,
        },
        rootChecked: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed,
        },
        rootCheckedHovered: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed,
        },
        rootDisabled: (_d = {
                color: s.primaryButtonTextDisabled,
                backgroundColor: s.primaryButtonBackgroundDisabled
            },
            _d[HighContrastSelector] = {
                color: 'GrayText',
                borderColor: 'GrayText',
                backgroundColor: 'Window',
            },
            _d),
        // Split button styles
        splitButtonContainer: (_e = {},
            _e[HighContrastSelector] = {
                border: 'none',
            },
            _e),
        splitButtonDivider: __assign$2(__assign$2({}, splitButtonDividerBaseStyles()), (_f = { backgroundColor: p.white }, _f[HighContrastSelector] = {
            backgroundColor: 'Window',
        }, _f)),
        splitButtonMenuButton: (_g = {
                backgroundColor: s.primaryButtonBackground,
                color: s.primaryButtonText
            },
            _g[HighContrastSelector] = {
                backgroundColor: 'Canvas',
            },
            _g[':hover'] = (_h = {
                    backgroundColor: s.primaryButtonBackgroundHovered
                },
                _h[HighContrastSelector] = {
                    color: 'Highlight',
                },
                _h),
            _g),
        splitButtonMenuButtonDisabled: {
            backgroundColor: s.primaryButtonBackgroundDisabled,
            ':hover': {
                backgroundColor: s.primaryButtonBackgroundDisabled,
            },
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            ':hover': {
                backgroundColor: s.primaryButtonBackgroundPressed,
            },
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            ':hover': {
                backgroundColor: s.primaryButtonBackgroundPressed,
            },
        },
        splitButtonMenuIcon: {
            color: s.primaryButtonText,
        },
        splitButtonMenuIconDisabled: (_j = {
                color: p.neutralTertiary
            },
            _j[HighContrastSelector] = {
                color: 'GrayText',
            },
            _j),
    };
}

var DEFAULT_BUTTON_MIN_HEIGHT = '32px';
var DEFAULT_BUTTON_MIN_WIDTH = '80px';
var getStyles$j = memoizeFunction(function (theme, customStyles, primary) {
    var baseButtonStyles = getStyles$l(theme);
    var splitButtonStyles = getStyles$k(theme);
    var defaultButtonStyles = {
        root: {
            minWidth: DEFAULT_BUTTON_MIN_WIDTH,
            minHeight: DEFAULT_BUTTON_MIN_HEIGHT,
        },
        label: {
            fontWeight: FontWeights.semibold,
        },
    };
    return concatStyleSets(baseButtonStyles, defaultButtonStyles, primary ? primaryStyles(theme) : standardStyles(theme), splitButtonStyles, customStyles);
});

/**
 * {@docCategory Button}
 */
var DefaultButton = /** @class */ (function (_super) {
    __extends$1(DefaultButton, _super);
    function DefaultButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultButton.prototype.render = function () {
        var _a = this.props, _b = _a.primary, primary = _b === undefined ? false : _b, styles = _a.styles, theme = _a.theme;
        return (React.createElement(BaseButton, __assign$2({}, this.props, { variantClassName: primary ? 'ms-Button--primary' : 'ms-Button--default', styles: getStyles$j(theme, styles, primary), onRenderDescription: nullRender })));
    };
    DefaultButton = __decorate([
        customizable('DefaultButton', ['theme', 'styles'])
    ], DefaultButton);
    return DefaultButton;
}(React.Component));

var DEFAULT_BUTTON_HEIGHT = '40px';
var DEFAULT_PADDING = '0 4px';
var getStyles$i = memoizeFunction(function (theme, customStyles) {
    var _a, _b, _c;
    var baseButtonStyles = getStyles$l(theme);
    var actionButtonStyles = {
        root: (_a = {
                padding: DEFAULT_PADDING,
                height: DEFAULT_BUTTON_HEIGHT,
                color: theme.palette.neutralPrimary,
                backgroundColor: 'transparent',
                border: '1px solid transparent'
            },
            _a[HighContrastSelector] = {
                borderColor: 'Window',
            },
            _a),
        rootHovered: (_b = {
                color: theme.palette.themePrimary
            },
            _b[HighContrastSelector] = {
                color: 'Highlight',
            },
            _b),
        iconHovered: {
            color: theme.palette.themePrimary,
        },
        rootPressed: {
            color: theme.palette.black,
        },
        rootExpanded: {
            color: theme.palette.themePrimary,
        },
        iconPressed: {
            color: theme.palette.themeDarker,
        },
        rootDisabled: (_c = {
                color: theme.palette.neutralTertiary,
                backgroundColor: 'transparent',
                borderColor: 'transparent'
            },
            _c[HighContrastSelector] = {
                color: 'GrayText',
            },
            _c),
        rootChecked: {
            color: theme.palette.black,
        },
        iconChecked: {
            color: theme.palette.themeDarker,
        },
        flexContainer: {
            justifyContent: 'flex-start',
        },
        icon: {
            color: theme.palette.themeDarkAlt,
        },
        iconDisabled: {
            color: 'inherit',
        },
        menuIcon: {
            color: theme.palette.neutralSecondary,
        },
        textContainer: {
            flexGrow: 0,
        },
    };
    return concatStyleSets(baseButtonStyles, actionButtonStyles, customStyles);
});

/**
 * {@docCategory Button}
 */
var ActionButton = /** @class */ (function (_super) {
    __extends$1(ActionButton, _super);
    function ActionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return (React.createElement(BaseButton, __assign$2({}, this.props, { variantClassName: "ms-Button--action ms-Button--command", styles: getStyles$i(theme, styles), onRenderDescription: nullRender })));
    };
    ActionButton = __decorate([
        customizable('ActionButton', ['theme', 'styles'])
    ], ActionButton);
    return ActionButton;
}(React.Component));

var getStyles$h = memoizeFunction(function (theme, customStyles) {
    var _a;
    var baseButtonStyles = getStyles$l(theme);
    var splitButtonStyles = getStyles$k(theme);
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var iconButtonStyles = {
        root: {
            padding: '0 4px',
            width: '32px',
            height: '32px',
            backgroundColor: 'transparent',
            border: 'none',
            color: semanticColors.link,
        },
        rootHovered: (_a = {
                color: palette.themeDarkAlt,
                backgroundColor: palette.neutralLighter
            },
            _a[HighContrastSelector] = {
                borderColor: 'Highlight',
                color: 'Highlight',
            },
            _a),
        rootHasMenu: {
            width: 'auto',
        },
        rootPressed: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight,
        },
        rootExpanded: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight,
        },
        rootChecked: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight,
        },
        rootCheckedHovered: {
            color: palette.themeDark,
            backgroundColor: palette.neutralQuaternaryAlt,
        },
        rootDisabled: {
            color: palette.neutralTertiaryAlt,
        },
    };
    return concatStyleSets(baseButtonStyles, iconButtonStyles, splitButtonStyles, customStyles);
});

/**
 * {@docCategory Button}
 */
var IconButton = /** @class */ (function (_super) {
    __extends$1(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return (React.createElement(BaseButton, __assign$2({}, this.props, { variantClassName: "ms-Button--icon", styles: getStyles$h(theme, styles), onRenderText: nullRender, onRenderDescription: nullRender })));
    };
    IconButton = __decorate([
        customizable('IconButton', ['theme', 'styles'])
    ], IconButton);
    return IconButton;
}(React.Component));

/**
 * {@docCategory Button}
 */
var PrimaryButton = /** @class */ (function (_super) {
    __extends$1(PrimaryButton, _super);
    function PrimaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrimaryButton.prototype.render = function () {
        return React.createElement(DefaultButton, __assign$2({}, this.props, { primary: true, onRenderDescription: nullRender }));
    };
    PrimaryButton = __decorate([
        customizable('PrimaryButton', ['theme', 'styles'])
    ], PrimaryButton);
    return PrimaryButton;
}(React.Component));

/**
 * {@docCategory Button}
 */
var CommandButton = ActionButton;

var getClassNames$j = classNamesFunction({
    // Label is used a lot by other components.
    // It's likely to see expected cases which pass different className to the Label.
    // Therefore setting a larger cache size.
    cacheSize: 100,
});
var LabelBase = /** @class */ (function (_super) {
    __extends$1(LabelBase, _super);
    function LabelBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelBase.prototype.render = function () {
        var _a = this.props, _b = _a.as, RootType = _b === undefined ? 'label' : _b, children = _a.children, className = _a.className, disabled = _a.disabled, styles = _a.styles, required = _a.required, theme = _a.theme;
        var classNames = getClassNames$j(styles, {
            className: className,
            disabled: disabled,
            required: required,
            theme: theme,
        });
        return (React.createElement(RootType, __assign$2({}, getNativeProps$1(this.props, divProperties), { className: classNames.root }), children));
    };
    return LabelBase;
}(React.Component));

var getStyles$g = function (props) {
    var _a;
    var theme = props.theme, className = props.className, disabled = props.disabled, required = props.required;
    var semanticColors = theme.semanticColors;
    // Tokens
    var labelFontWeight = FontWeights.semibold;
    var labelColor = semanticColors.bodyText;
    var labelDisabledColor = semanticColors.disabledBodyText;
    var labelRequiredStarColor = semanticColors.errorText;
    return {
        root: [
            'ms-Label',
            theme.fonts.medium,
            {
                fontWeight: labelFontWeight,
                color: labelColor,
                boxSizing: 'border-box',
                boxShadow: 'none',
                margin: 0,
                display: 'block',
                padding: '5px 0',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
            },
            disabled && {
                color: labelDisabledColor,
                selectors: (_a = {},
                    _a[HighContrastSelector] = __assign$2({ color: 'GrayText' }, getHighContrastNoAdjustStyle()),
                    _a),
            },
            required && {
                selectors: {
                    '::after': {
                        content: "' *'",
                        color: labelRequiredStarColor,
                        paddingRight: 12,
                    },
                },
            },
            className,
        ],
    };
};

var Label = styled(LabelBase, getStyles$g, undefined, {
    scope: 'Label',
});

var getClassNames$i = classNamesFunction();
var LARGE_IMAGE_SIZE = 71;
var DEFAULT_PROPS$3 = {
    // This ensures default imageSize value doesn't mutate. Mutation can cause style re-calcuation.
    imageSize: { width: 32, height: 32 },
};
var ChoiceGroupOptionBase = function (propsWithoutDefaults) {
    // Mix the `key` prop back in since custom render functions may be expecting it
    // (React uses `key` internally rather than passing it through to the component)
    var props = getPropsWithDefaults(__assign$2(__assign$2({}, DEFAULT_PROPS$3), { key: propsWithoutDefaults.itemKey }), propsWithoutDefaults);
    var ariaLabel = props.ariaLabel, focused = props.focused, required = props.required, theme = props.theme, iconProps = props.iconProps, imageSrc = props.imageSrc, imageSize = props.imageSize, disabled = props.disabled, checked = props.checked, id = props.id, styles = props.styles, name = props.name, rest = __rest$1(props, ["ariaLabel", "focused", "required", "theme", "iconProps", "imageSrc", "imageSize", "disabled", "checked", "id", "styles", "name"]);
    var classNames = getClassNames$i(styles, {
        theme: theme,
        hasIcon: !!iconProps,
        hasImage: !!imageSrc,
        checked: checked,
        disabled: disabled,
        imageIsLarge: !!imageSrc && (imageSize.width > LARGE_IMAGE_SIZE || imageSize.height > LARGE_IMAGE_SIZE),
        imageSize: imageSize,
        focused: focused,
    });
    var _a = getNativeProps$1(rest, inputProperties$1), className = _a.className, nativeProps = __rest$1(_a, ["className"]);
    var defaultOnRenderLabel = function () {
        return (React.createElement("span", { id: props.labelId, className: "ms-ChoiceFieldLabel" }, props.text));
    };
    var defaultOnRenderField = function () {
        var _a = props.imageAlt, imageAlt = _a === undefined ? '' : _a, selectedImageSrc = props.selectedImageSrc;
        var onRenderLabel = props.onRenderLabel
            ? composeRenderFunction(props.onRenderLabel, defaultOnRenderLabel)
            : defaultOnRenderLabel;
        var label = onRenderLabel(__assign$2(__assign$2({}, props), { key: props.itemKey }));
        return (React.createElement("label", { htmlFor: id, className: classNames.field },
            imageSrc && (React.createElement("div", { className: classNames.innerField },
                React.createElement("div", { className: classNames.imageWrapper },
                    React.createElement(Image$2, __assign$2({ src: imageSrc, alt: imageAlt }, imageSize))),
                React.createElement("div", { className: classNames.selectedImageWrapper },
                    React.createElement(Image$2, __assign$2({ src: selectedImageSrc, alt: imageAlt }, imageSize))))),
            iconProps && (React.createElement("div", { className: classNames.innerField },
                React.createElement("div", { className: classNames.iconWrapper },
                    React.createElement(Icon, __assign$2({}, iconProps))))),
            imageSrc || iconProps ? React.createElement("div", { className: classNames.labelWrapper }, label) : label));
    };
    var _b = props.onRenderField, onRenderField = _b === undefined ? defaultOnRenderField : _b;
    var onChange = function (evt) {
        var _a;
        (_a = props.onChange) === null || _a === undefined ? undefined : _a.call(props, evt, __assign$2(__assign$2({}, props), { key: props.itemKey }));
    };
    var onBlur = function (evt) {
        var _a;
        (_a = props.onBlur) === null || _a === undefined ? undefined : _a.call(props, evt);
    };
    var onFocus = function (evt) {
        var _a;
        (_a = props.onFocus) === null || _a === undefined ? undefined : _a.call(props, evt, __assign$2(__assign$2({}, props), { key: props.itemKey }));
    };
    return (React.createElement("div", { className: classNames.root },
        React.createElement("div", { className: classNames.choiceFieldWrapper },
            React.createElement("input", __assign$2({ "aria-label": ariaLabel, id: id, className: css(classNames.input, className), type: "radio", name: name, disabled: disabled, checked: checked, required: required }, nativeProps, { onChange: onChange, onFocus: onFocus, onBlur: onBlur })),
            onRenderField(__assign$2(__assign$2({}, props), { key: props.itemKey }), defaultOnRenderField))));
};
ChoiceGroupOptionBase.displayName = 'ChoiceGroupOption';

var GlobalClassNames$a = {
    root: 'ms-ChoiceField',
    choiceFieldWrapper: 'ms-ChoiceField-wrapper',
    input: 'ms-ChoiceField-input',
    field: 'ms-ChoiceField-field',
    innerField: 'ms-ChoiceField-innerField',
    imageWrapper: 'ms-ChoiceField-imageWrapper',
    iconWrapper: 'ms-ChoiceField-iconWrapper',
    labelWrapper: 'ms-ChoiceField-labelWrapper',
    checked: 'is-checked',
};
var labelWrapperLineHeight = 15;
var labelWrapperHeight = labelWrapperLineHeight * 2 + 2; // adding 2px height to ensure text doesn't get cutoff
var iconSize = 32;
var choiceFieldSize = 20;
var choiceFieldTransitionDuration = '200ms';
var choiceFieldTransitionTiming = 'cubic-bezier(.4, 0, .23, 1)';
var radioButtonSpacing = 3;
var radioButtonInnerSize = 5;
function getChoiceGroupFocusStyle(focusBorderColor, hasIconOrImage) {
    var _a, _b;
    return [
        'is-inFocus',
        {
            selectors: (_a = {},
                _a[".".concat(IsFocusVisibleClassName, " &, :host(.").concat(IsFocusVisibleClassName, ") &")] = {
                    position: 'relative',
                    outline: 'transparent',
                    selectors: {
                        '::-moz-focus-inner': {
                            border: 0,
                        },
                        ':after': {
                            content: '""',
                            top: -2,
                            right: -2,
                            bottom: -2,
                            left: -2,
                            pointerEvents: 'none',
                            border: "1px solid ".concat(focusBorderColor),
                            position: 'absolute',
                            selectors: (_b = {},
                                _b[HighContrastSelector] = {
                                    borderColor: 'WindowText',
                                    borderWidth: hasIconOrImage ? 1 : 2,
                                },
                                _b),
                        },
                    },
                },
                _a),
        },
    ];
}
function getImageWrapperStyle(isSelectedImageWrapper, className, checked) {
    return [
        className,
        {
            paddingBottom: 2,
            transitionProperty: 'opacity',
            transitionDuration: choiceFieldTransitionDuration,
            transitionTimingFunction: 'ease',
            selectors: {
                '.ms-Image': {
                    display: 'inline-block',
                    borderStyle: 'none',
                },
            },
        },
        (checked ? !isSelectedImageWrapper : isSelectedImageWrapper) && [
            'is-hidden',
            {
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                opacity: 0,
            },
        ],
    ];
}
var getStyles$f = function (props) {
    var _a, _b, _c, _d, _e;
    var theme = props.theme, hasIcon = props.hasIcon, hasImage = props.hasImage, checked = props.checked, disabled = props.disabled, imageIsLarge = props.imageIsLarge, focused = props.focused, imageSize = props.imageSize;
    var palette = theme.palette, semanticColors = theme.semanticColors, fonts = theme.fonts;
    var classNames = getGlobalClassNames(GlobalClassNames$a, theme);
    // Tokens
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.smallInputBorder
    var circleBorderColor = palette.neutralPrimary;
    var circleHoveredBorderColor = semanticColors.inputBorderHovered;
    var circleCheckedBorderColor = semanticColors.inputBackgroundChecked;
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.inputBackgroundCheckedHovered
    var circleCheckedHoveredBorderColor = palette.themeDark;
    var circleDisabledBorderColor = semanticColors.disabledBodySubtext;
    var circleBackgroundColor = semanticColors.bodyBackground;
    var dotUncheckedHoveredColor = palette.neutralSecondary;
    var dotCheckedColor = semanticColors.inputBackgroundChecked;
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.inputBackgroundCheckedHovered
    var dotCheckedHoveredColor = palette.themeDark;
    var dotDisabledColor = semanticColors.disabledBodySubtext;
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.bodyTextChecked
    var labelHoverFocusColor = palette.neutralDark;
    var focusBorderColor = semanticColors.focusBorder;
    var iconOrImageChoiceBorderUncheckedHoveredColor = semanticColors.inputBorderHovered;
    // TODO: after updating the semanticColors slots mapping this needs to be semanticColors.inputBackgroundCheckedHovered
    var iconOrImageChoiceBorderCheckedColor = semanticColors.inputBackgroundChecked;
    var iconOrImageChoiceBorderCheckedHoveredColor = palette.themeDark;
    var iconOrImageChoiceBackgroundColor = palette.neutralLighter;
    var fieldHoverOrFocusProperties = {
        selectors: {
            '.ms-ChoiceFieldLabel': {
                color: labelHoverFocusColor,
            },
            ':before': {
                borderColor: checked ? circleCheckedHoveredBorderColor : circleHoveredBorderColor,
            },
            ':after': [
                !hasIcon &&
                    !hasImage &&
                    !checked && {
                    content: '""',
                    transitionProperty: 'background-color',
                    left: 5,
                    top: 5,
                    width: 10,
                    height: 10,
                    backgroundColor: dotUncheckedHoveredColor,
                },
                checked && {
                    borderColor: dotCheckedHoveredColor,
                    background: dotCheckedHoveredColor,
                },
            ],
        },
    };
    var enabledFieldWithImageHoverOrFocusProperties = {
        borderColor: checked ? iconOrImageChoiceBorderCheckedHoveredColor : iconOrImageChoiceBorderUncheckedHoveredColor,
        selectors: {
            ':before': {
                opacity: 1,
                borderColor: checked ? circleCheckedHoveredBorderColor : circleHoveredBorderColor,
            },
        },
    };
    var circleAreaProperties = [
        {
            content: '""',
            display: 'inline-block',
            backgroundColor: circleBackgroundColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: circleBorderColor,
            width: choiceFieldSize,
            height: choiceFieldSize,
            fontWeight: 'normal',
            position: 'absolute',
            top: 0,
            left: 0,
            boxSizing: 'border-box',
            transitionProperty: 'border-color',
            transitionDuration: choiceFieldTransitionDuration,
            transitionTimingFunction: choiceFieldTransitionTiming,
            borderRadius: '50%',
        },
        disabled && {
            borderColor: circleDisabledBorderColor,
            selectors: (_a = {},
                _a[HighContrastSelector] = __assign$2({ borderColor: 'GrayText', background: 'Window' }, getHighContrastNoAdjustStyle()),
                _a),
        },
        checked && {
            borderColor: disabled ? circleDisabledBorderColor : circleCheckedBorderColor,
            selectors: (_b = {},
                _b[HighContrastSelector] = {
                    borderColor: 'Highlight',
                    background: 'Window',
                    forcedColorAdjust: 'none',
                },
                _b),
        },
        (hasIcon || hasImage) && {
            top: radioButtonSpacing,
            right: radioButtonSpacing,
            left: 'auto', // To reset the value of 'left' to its default value, so that 'right' works
            opacity: checked ? 1 : 0,
        },
    ];
    var dotAreaProperties = [
        {
            content: '""',
            width: 0,
            height: 0,
            borderRadius: '50%',
            position: 'absolute',
            left: choiceFieldSize / 2,
            right: 0,
            transitionProperty: 'border-width',
            transitionDuration: choiceFieldTransitionDuration,
            transitionTimingFunction: choiceFieldTransitionTiming,
            boxSizing: 'border-box',
        },
        checked && {
            borderWidth: 5,
            borderStyle: 'solid',
            borderColor: disabled ? dotDisabledColor : dotCheckedColor,
            background: dotCheckedColor,
            left: 5,
            top: 5,
            width: 10,
            height: 10,
            selectors: (_c = {},
                _c[HighContrastSelector] = {
                    borderColor: 'Highlight',
                    forcedColorAdjust: 'none',
                },
                _c),
        },
        checked &&
            (hasIcon || hasImage) && {
            top: radioButtonSpacing + radioButtonInnerSize,
            right: radioButtonSpacing + radioButtonInnerSize,
            left: 'auto', // To reset the value of 'left' to its default value, so that 'right' works
        },
    ];
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                color: semanticColors.bodyText,
                minHeight: 26,
                border: 'none',
                position: 'relative',
                marginTop: 8,
                selectors: {
                    '.ms-ChoiceFieldLabel': {
                        display: 'inline-block',
                    },
                },
            },
            !hasIcon &&
                !hasImage && {
                selectors: {
                    '.ms-ChoiceFieldLabel': {
                        paddingLeft: '26px',
                    },
                },
            },
            hasImage && 'ms-ChoiceField--image',
            hasIcon && 'ms-ChoiceField--icon',
            (hasIcon || hasImage) && {
                display: 'inline-flex',
                fontSize: 0,
                margin: '0 4px 4px 0',
                paddingLeft: 0,
                backgroundColor: iconOrImageChoiceBackgroundColor,
                height: '100%',
            },
        ],
        choiceFieldWrapper: [
            classNames.choiceFieldWrapper,
            focused && getChoiceGroupFocusStyle(focusBorderColor, hasIcon || hasImage),
        ],
        // The hidden input
        input: [
            classNames.input,
            {
                position: 'absolute',
                opacity: 0,
                top: 0,
                right: 0,
                width: '100%',
                height: '100%',
                margin: 0,
            },
            disabled && 'is-disabled',
        ],
        field: [
            classNames.field,
            checked && classNames.checked,
            {
                display: 'inline-block',
                cursor: 'pointer',
                marginTop: 0,
                position: 'relative',
                verticalAlign: 'top',
                userSelect: 'none',
                minHeight: 20,
                selectors: {
                    ':hover': !disabled && fieldHoverOrFocusProperties,
                    ':focus': !disabled && fieldHoverOrFocusProperties,
                    // The circle
                    ':before': circleAreaProperties,
                    // The dot
                    ':after': dotAreaProperties,
                },
            },
            hasIcon && 'ms-ChoiceField--icon',
            hasImage && 'ms-ChoiceField-field--image',
            (hasIcon || hasImage) && {
                boxSizing: 'content-box',
                cursor: 'pointer',
                paddingTop: 22,
                margin: 0,
                textAlign: 'center',
                transitionProperty: 'all',
                transitionDuration: choiceFieldTransitionDuration,
                transitionTimingFunction: 'ease',
                border: '1px solid transparent',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
            },
            checked && {
                borderColor: iconOrImageChoiceBorderCheckedColor,
            },
            (hasIcon || hasImage) &&
                !disabled && {
                selectors: {
                    ':hover': enabledFieldWithImageHoverOrFocusProperties,
                    ':focus': enabledFieldWithImageHoverOrFocusProperties,
                },
            },
            disabled && {
                cursor: 'default',
                selectors: {
                    '.ms-ChoiceFieldLabel': {
                        color: semanticColors.disabledBodyText,
                        selectors: (_d = {},
                            _d[HighContrastSelector] = __assign$2({ color: 'GrayText' }, getHighContrastNoAdjustStyle()),
                            _d),
                    },
                },
            },
            checked &&
                disabled && {
                borderColor: iconOrImageChoiceBackgroundColor,
            },
        ],
        innerField: [
            classNames.innerField,
            hasImage && {
                // using non-null assertion because we have a default in `ChoiceGroupOptionBase` class.
                height: imageSize.height,
                width: imageSize.width,
            },
            (hasIcon || hasImage) && {
                position: 'relative',
                display: 'inline-block',
                paddingLeft: 30,
                paddingRight: 30,
            },
            (hasIcon || hasImage) &&
                imageIsLarge && {
                paddingLeft: 24,
                paddingRight: 24,
            },
            (hasIcon || hasImage) &&
                disabled && {
                opacity: 0.25,
                selectors: (_e = {},
                    _e[HighContrastSelector] = {
                        color: 'GrayText',
                        opacity: 1,
                    },
                    _e),
            },
        ],
        imageWrapper: getImageWrapperStyle(false, classNames.imageWrapper, checked),
        selectedImageWrapper: getImageWrapperStyle(true, classNames.imageWrapper, checked),
        iconWrapper: [
            classNames.iconWrapper,
            {
                fontSize: iconSize,
                lineHeight: iconSize,
                height: iconSize,
            },
        ],
        labelWrapper: [
            classNames.labelWrapper,
            fonts.medium,
            (hasIcon || hasImage) && {
                display: 'block',
                position: 'relative',
                margin: '4px 8px 2px 8px',
                height: labelWrapperHeight,
                lineHeight: labelWrapperLineHeight,
                // using non-null assertion because we have a default in `ChoiceGroupOptionBase` class.
                maxWidth: imageSize.width * 2,
                overflow: 'hidden',
                whiteSpace: 'pre-wrap',
            },
        ],
    };
};

var ChoiceGroupOption = styled(ChoiceGroupOptionBase, getStyles$f, undefined, { scope: 'ChoiceGroupOption' });

var getClassNames$h = classNamesFunction();
var getOptionId = function (option, id) {
    return "".concat(id, "-").concat(option.key);
};
var findOption = function (options, key) {
    return key === undefined ? undefined : find$3(options, function (value) { return value.key === key; });
};
var focusSelectedOption = function (options, keyChecked, id, focusProviders, doc) {
    var optionToFocus = findOption(options, keyChecked) || options.filter(function (option) { return !option.disabled; })[0];
    var elementToFocus = optionToFocus && (doc === null || doc === undefined ? undefined : doc.getElementById(getOptionId(optionToFocus, id)));
    if (elementToFocus) {
        elementToFocus.focus();
        setFocusVisibility(true, elementToFocus, focusProviders);
    }
};
var focusFromFocusTrapZone = function (evt) {
    return evt.relatedTarget instanceof HTMLElement && evt.relatedTarget.dataset.isFocusTrapZoneBumper === 'true';
};
var useComponentRef$5 = function (options, keyChecked, id, componentRef, focusProviders) {
    var doc = useDocumentEx();
    React.useImperativeHandle(componentRef, function () { return ({
        get checkedOption() {
            return findOption(options, keyChecked);
        },
        focus: function () {
            focusSelectedOption(options, keyChecked, id, focusProviders, doc);
        },
    }); }, [options, keyChecked, id, focusProviders, doc]);
};
var COMPONENT_NAME$7 = 'ChoiceGroup';
var ChoiceGroupBase = React.forwardRef(function (props, forwardedRef) {
    var className = props.className, theme = props.theme, styles = props.styles, _a = props.options, options = _a === undefined ? [] : _a, label = props.label, required = props.required, disabled = props.disabled, name = props.name, defaultSelectedKey = props.defaultSelectedKey, componentRef = props.componentRef, onChange = props.onChange;
    var id = useId$1('ChoiceGroup');
    var labelId = useId$1('ChoiceGroupLabel');
    var divProps = getNativeProps$1(props, divProperties, [
        'onChange',
        'className',
        'required',
    ]);
    var classNames = getClassNames$h(styles, {
        theme: theme,
        className: className,
        optionsContainIconOrImage: options.some(function (option) { return !!(option.iconProps || option.imageSrc); }),
    });
    var ariaLabelledBy = props.ariaLabelledBy || (label ? labelId : props['aria-labelledby']);
    var _b = useControllableValue(props.selectedKey, defaultSelectedKey), keyChecked = _b[0], setKeyChecked = _b[1];
    var _c = React.useState(), keyFocused = _c[0], setKeyFocused = _c[1];
    var rootRef = React.useRef(null);
    var mergedRootRefs = useMergedRefs$1(rootRef, forwardedRef);
    var focusContext = React.useContext(FocusRectsContext);
    useDebugWarnings$1(props);
    useComponentRef$5(options, keyChecked, id, componentRef, focusContext === null || focusContext === undefined ? undefined : focusContext.registeredProviders);
    useFocusRects(rootRef);
    var onFocus = React.useCallback(function (ev, option) {
        var _a;
        if (option) {
            setKeyFocused(option.itemKey);
            (_a = option.onFocus) === null || _a === undefined ? undefined : _a.call(option, ev);
        }
    }, []);
    var onBlur = React.useCallback(function (ev, option) {
        var _a;
        setKeyFocused(undefined);
        (_a = option === null || option === undefined ? undefined : option.onBlur) === null || _a === undefined ? undefined : _a.call(option, ev);
    }, []);
    var onOptionChange = React.useCallback(function (evt, option) {
        var _a;
        if (!option) {
            return;
        }
        setKeyChecked(option.itemKey);
        (_a = option.onChange) === null || _a === undefined ? undefined : _a.call(option, evt);
        onChange === null || onChange === undefined ? undefined : onChange(evt, findOption(options, option.itemKey));
    }, [onChange, options, setKeyChecked]);
    var onRadioFocus = React.useCallback(function (evt) {
        // Handles scenarios like this bug: https://github.com/microsoft/fluentui/issues/20173
        if (focusFromFocusTrapZone(evt)) {
            focusSelectedOption(options, keyChecked, id, focusContext === null || focusContext === undefined ? undefined : focusContext.registeredProviders);
        }
    }, [options, keyChecked, id, focusContext]);
    return (React.createElement("div", __assign$2({ className: classNames.root }, divProps, { ref: mergedRootRefs }),
        React.createElement("div", __assign$2({ role: "radiogroup" }, (ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }), { onFocus: onRadioFocus }),
            label && (React.createElement(Label, { className: classNames.label, required: required, id: labelId, disabled: disabled }, label)),
            React.createElement("div", { className: classNames.flexContainer }, options.map(function (option) {
                return (React.createElement(ChoiceGroupOption, __assign$2({ itemKey: option.key }, option, { key: option.key, onBlur: onBlur, onFocus: onFocus, onChange: onOptionChange, focused: option.key === keyFocused, checked: option.key === keyChecked, disabled: option.disabled || disabled, id: getOptionId(option, id), labelId: option.labelId || "".concat(labelId, "-").concat(option.key), name: name || id, required: required })));
            })))));
});
ChoiceGroupBase.displayName = COMPONENT_NAME$7;
function useDebugWarnings$1(props) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- build-time conditional
        useWarnings({
            name: COMPONENT_NAME$7,
            props: props,
            mutuallyExclusive: {
                selectedKey: 'defaultSelectedKey',
            },
        });
    }
}

var GlobalClassNames$9 = {
    root: 'ms-ChoiceFieldGroup',
    flexContainer: 'ms-ChoiceFieldGroup-flexContainer',
};
var getStyles$e = function (props) {
    var className = props.className, optionsContainIconOrImage = props.optionsContainIconOrImage, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$9, theme);
    return {
        root: [
            className,
            classNames.root,
            theme.fonts.medium,
            {
                display: 'block',
            },
        ],
        flexContainer: [
            classNames.flexContainer,
            optionsContainIconOrImage && {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
            },
        ],
    };
};

var ChoiceGroup = styled(ChoiceGroupBase, getStyles$e, undefined, { scope: 'ChoiceGroup' });

var COACHMARK_WIDTH = 32;
var COACHMARK_HEIGHT = 32;
var translateOne = memoizeFunction(function () {
    return keyframes({
        '0%': {
            transform: 'translate(0, 0)', // orig 25
            animationTimingFunction: 'linear',
        },
        '78.57%': {
            transform: 'translate(0, 0)', // orig 25
            animationTimingFunction: 'cubic-bezier(0.62, 0, 0.56, 1)',
        },
        '82.14%': {
            transform: 'translate(0, -5px)', // orig 20
            animationTimingFunction: 'cubic-bezier(0.58, 0, 0, 1)',
        },
        '84.88%': {
            transform: 'translate(0, 9px)', // 34
            animationTimingFunction: 'cubic-bezier(1, 0, 0.56, 1)',
        },
        '88.1%': {
            transform: 'translate(0, -2px)', // orig 23
            animationTimingFunction: 'cubic-bezier(0.58, 0, 0.67, 1)',
        },
        '90.12%': {
            transform: 'translate(0, 0)',
            animationTimingFunction: 'linear',
        },
        '100%': {
            transform: 'translate(0, 0)',
        },
    });
});
var scaleOne = memoizeFunction(function () {
    return keyframes({
        '0%': {
            transform: ' scale(0)',
            animationTimingFunction: 'linear',
        },
        '14.29%': {
            transform: 'scale(0)',
            animationTimingFunction: 'cubic-bezier(0.84, 0, 0.52, 0.99)',
        },
        '16.67%': {
            transform: 'scale(1.15)',
            animationTimingFunction: 'cubic-bezier(0.48, -0.01, 0.52, 1.01)',
        },
        '19.05%': {
            transform: 'scale(0.95)',
            animationTimingFunction: 'cubic-bezier(0.48, 0.02, 0.52, 0.98)',
        },
        '21.43%': {
            transform: 'scale(1)',
            animationTimingFunction: 'linear',
        },
        '42.86%': {
            transform: 'scale(1)',
            animationTimingFunction: 'cubic-bezier(0.48, -0.02, 0.52, 1.02)',
        },
        '45.71%': {
            transform: 'scale(0.8)',
            animationTimingFunction: 'cubic-bezier(0.48, 0.01, 0.52, 0.99)',
        },
        '50%': {
            transform: 'scale(1)',
            animationTimingFunction: 'linear',
        },
        '90.12%': {
            transform: 'scale(1)',
            animationTimingFunction: 'cubic-bezier(0.48, -0.02, 0.52, 1.02)',
        },
        '92.98%': {
            transform: 'scale(0.8)',
            animationTimingFunction: 'cubic-bezier(0.48, 0.01, 0.52, 0.99)',
        },
        '97.26%': {
            transform: 'scale(1)',
            animationTimingFunction: 'linear',
        },
        '100%': {
            transform: 'scale(1)',
        },
    });
});
var rotateOne = memoizeFunction(function () {
    return keyframes({
        '0%': {
            transform: 'rotate(0deg)',
            animationTimingFunction: 'linear',
        },
        '83.33%': {
            transform: ' rotate(0deg)',
            animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',
        },
        '83.93%': {
            transform: 'rotate(15deg)',
            animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',
        },
        '84.52%': {
            transform: 'rotate(-15deg)',
            animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',
        },
        '85.12%': {
            transform: 'rotate(15deg)',
            animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',
        },
        '85.71%': {
            transform: 'rotate(-15deg)',
            animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)',
        },
        '86.31%': {
            transform: 'rotate(0deg)',
            animationTimingFunction: 'linear',
        },
        '100%': {
            transform: 'rotate(0deg)',
        },
    });
});
function getStyles$d(props) {
    var _a;
    var theme = props.theme, className = props.className, color = props.color, beaconColorOne = props.beaconColorOne, beaconColorTwo = props.beaconColorTwo, delayBeforeCoachmarkAnimation = props.delayBeforeCoachmarkAnimation, isCollapsed = props.isCollapsed, isMeasuring = props.isMeasuring, entityHostHeight = props.entityHostHeight, entityHostWidth = props.entityHostWidth, transformOrigin = props.transformOrigin;
    if (!theme) {
        throw new Error('theme is undefined or null in base Dropdown getStyles function.');
    }
    var animationInnerDimension = '35px';
    var animationOuterDimension = '150px';
    var animationBorderWidth = '10px';
    var ContinuousPulse = PulsingBeaconAnimationStyles.continuousPulseAnimationDouble(beaconColorOne ? beaconColorOne : theme.palette.themePrimary, beaconColorTwo ? beaconColorTwo : theme.palette.themeTertiary, animationInnerDimension, animationOuterDimension, animationBorderWidth);
    var ContinuousPulseAnimation = PulsingBeaconAnimationStyles.createDefaultAnimation(ContinuousPulse, delayBeforeCoachmarkAnimation);
    return {
        root: [
            theme.fonts.medium,
            {
                position: 'relative',
            },
            className,
        ],
        pulsingBeacon: [
            {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: getRTL(theme) ? 'translate(50%, -50%)' : 'translate(-50%, -50%)',
                width: '0px',
                height: '0px',
                borderRadius: '225px',
                borderStyle: 'solid',
                opacity: '0',
            },
            isCollapsed && ContinuousPulseAnimation,
        ],
        // Translate Animation Layer
        translateAnimationContainer: [
            {
                width: '100%',
                height: '100%',
            },
            isCollapsed && {
                animationDuration: '14s',
                animationTimingFunction: 'linear',
                animationDirection: 'normal',
                animationIterationCount: '1',
                animationDelay: '0s',
                animationFillMode: 'forwards',
                animationName: translateOne(),
                transition: 'opacity 0.5s ease-in-out',
            },
            !isCollapsed && {
                opacity: '1',
            },
        ],
        // Scale Animation Layer
        scaleAnimationLayer: [
            {
                width: '100%',
                height: '100%',
            },
            isCollapsed && {
                animationDuration: '14s',
                animationTimingFunction: 'linear',
                animationDirection: 'normal',
                animationIterationCount: '1',
                animationDelay: '0s',
                animationFillMode: 'forwards',
                animationName: scaleOne(),
            },
        ],
        // Rotate Animation Layer
        rotateAnimationLayer: [
            {
                width: '100%',
                height: '100%',
            },
            isCollapsed && {
                animationDuration: '14s',
                animationTimingFunction: 'linear',
                animationDirection: 'normal',
                animationIterationCount: '1',
                animationDelay: '0s',
                animationFillMode: 'forwards',
                animationName: rotateOne(),
            },
            !isCollapsed && {
                opacity: '1',
            },
        ],
        // Layer Host, defaults to collapsed
        entityHost: [
            {
                position: 'relative',
                outline: 'none',
                overflow: 'hidden',
                backgroundColor: color,
                borderRadius: COACHMARK_WIDTH,
                transition: 'border-radius 250ms, width 500ms, height 500ms cubic-bezier(0.5, 0, 0, 1)',
                visibility: 'hidden',
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        backgroundColor: 'Window',
                        border: '2px solid WindowText',
                    },
                    _a[".".concat(IsFocusVisibleClassName, " &:focus")] = {
                        outline: "1px solid ".concat(theme.palette.themeTertiary),
                    },
                    _a),
            },
            !isMeasuring &&
                isCollapsed && {
                width: COACHMARK_WIDTH,
                height: COACHMARK_HEIGHT,
            },
            !isMeasuring && {
                visibility: 'visible',
            },
            !isCollapsed && {
                borderRadius: '1px',
                opacity: '1',
                width: entityHostWidth,
                height: entityHostHeight,
            },
            isCollapsed && {
                cursor: 'pointer',
            },
        ],
        entityInnerHost: [
            {
                transition: 'transform 500ms cubic-bezier(0.5, 0, 0, 1)',
                transformOrigin: transformOrigin,
                transform: 'scale(0)',
            },
            !isCollapsed && {
                width: entityHostWidth,
                height: entityHostHeight,
                transform: 'scale(1)',
            },
            !isMeasuring && {
                visibility: 'visible',
            },
        ],
        childrenContainer: [
            {
                display: !isMeasuring && isCollapsed ? 'none' : 'block',
            },
        ],
        ariaContainer: {
            position: 'fixed',
            opacity: 0,
            height: 0,
            width: 0,
            pointerEvents: 'none',
        },
    };
}

var getClassNames$g = memoizeFunction(function () {
    var _a;
    return mergeStyleSets({
        root: [
            {
                position: 'absolute',
                boxSizing: 'border-box',
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        border: '1px solid WindowText',
                    },
                    _a),
            },
            focusClear(),
        ],
        container: {
            position: 'relative',
        },
        main: {
            backgroundColor: '#ffffff',
            overflowX: 'hidden',
            overflowY: 'hidden',
            position: 'relative',
        },
        overFlowYHidden: {
            overflowY: 'hidden',
        },
    });
});

var _a$d;
var OFF_SCREEN_STYLE = { opacity: 0 };
// In order for some of the max height logic to work properly we need to set the border.
// The value is arbitrary.
var BORDER_WIDTH = 1;
var SLIDE_ANIMATIONS = (_a$d = {},
    _a$d[RectangleEdge.top] = 'slideUpIn20',
    _a$d[RectangleEdge.bottom] = 'slideDownIn20',
    _a$d[RectangleEdge.left] = 'slideLeftIn20',
    _a$d[RectangleEdge.right] = 'slideRightIn20',
    _a$d);
var DEFAULT_PROPS$2 = {
    preventDismissOnScroll: false,
    offsetFromTarget: 0,
    minPagePadding: 8,
    directionalHint: DirectionalHint.bottomAutoEdge,
};
function useBounds(props, targetWindow) {
    /** The bounds used when determining if and where the PositioningContainer should be placed. */
    var getBounds = function () {
        var currentBounds = props.bounds;
        if (!currentBounds) {
            currentBounds = {
                top: 0 + props.minPagePadding,
                left: 0 + props.minPagePadding,
                right: targetWindow.innerWidth - props.minPagePadding,
                bottom: targetWindow.innerHeight - props.minPagePadding,
                width: targetWindow.innerWidth - props.minPagePadding * 2,
                height: targetWindow.innerHeight - props.minPagePadding * 2,
            };
        }
        return currentBounds;
    };
    return getBounds;
}
function usePositionState(props, positionedHost, contentHost, targetRef, getCachedBounds) {
    var async = useAsync();
    var doc = useDocumentEx();
    var win = useWindowEx();
    /**
     * Current set of calculated positions for the outermost parent container.
     */
    var _a = React.useState(), positions = _a[0], setPositions = _a[1];
    var positionAttempts = React.useRef(0);
    var updateAsyncPosition = function () {
        async.requestAnimationFrame(function () { return updatePosition(); });
    };
    var updatePosition = function () {
        var offsetFromTarget = props.offsetFromTarget, onPositioned = props.onPositioned;
        var hostElement = positionedHost.current;
        var positioningContainerElement = contentHost.current;
        if (hostElement && positioningContainerElement) {
            var currentProps = __assign$2({}, props);
            currentProps.bounds = getCachedBounds();
            currentProps.target = targetRef.current;
            var target = currentProps.target;
            if (target) {
                // Check if the target is an Element or a MouseEvent and the document contains it
                // or don't check anything else if the target is a Point or Rectangle
                if ((!target.getBoundingClientRect && !target.preventDefault) ||
                    (doc === null || doc === undefined ? undefined : doc.body.contains(target))) {
                    currentProps.gapSpace = offsetFromTarget;
                    var newPositions = positionElement(currentProps, hostElement, positioningContainerElement, undefined, win);
                    // Set the new position only when the positions are not exists or one of the new positioningContainer
                    // positions are different. The position should not change if the position is within 2 decimal places.
                    if ((!positions && newPositions) ||
                        (positions && newPositions && !arePositionsEqual(positions, newPositions) && positionAttempts.current < 5)) {
                        // We should not reposition the positioningContainer more than a few times, if it is then the content is
                        // likely resizing and we should stop trying to reposition to prevent a stack overflow.
                        positionAttempts.current++;
                        setPositions(newPositions);
                        onPositioned === null || onPositioned === undefined ? undefined : onPositioned(newPositions);
                    }
                    else {
                        positionAttempts.current = 0;
                        onPositioned === null || onPositioned === undefined ? undefined : onPositioned(newPositions);
                    }
                }
                else if (positions !== undefined) {
                    setPositions(undefined);
                }
            }
            else if (positions !== undefined) {
                setPositions(undefined);
            }
        }
    };
    React.useEffect(updateAsyncPosition);
    return [positions, updateAsyncPosition];
}
function useSetInitialFocus(_a, contentHost, positions) {
    var setInitialFocus = _a.setInitialFocus;
    var didSetInitialFocus = React.useRef(false);
    React.useEffect(function () {
        if (!didSetInitialFocus.current && contentHost.current && setInitialFocus && positions) {
            didSetInitialFocus.current = true;
            focusFirstChild(contentHost.current);
        }
    });
}
function useMaxHeight(_a, targetRef, getCachedBounds) {
    var directionalHintFixed = _a.directionalHintFixed, offsetFromTarget = _a.offsetFromTarget, directionalHint = _a.directionalHint, target = _a.target;
    /**
     * The maximum height the PositioningContainer can grow to
     * without going beyond the window or target bounds
     */
    var maxHeight = React.useRef();
    var win = useWindowEx();
    // If the target element changed, reset the max height. If we are tracking
    // target with class name, always reset because we do not know if
    // fabric has rendered a new element and disposed the old element.
    if (typeof target === 'string') {
        maxHeight.current = undefined;
    }
    React.useEffect(function () {
        maxHeight.current = undefined;
    }, [target, offsetFromTarget]);
    /**
     * Return the maximum height the container can grow to
     * without going out of the specified bounds
     */
    var getCachedMaxHeight = function () {
        if (!maxHeight.current) {
            if (directionalHintFixed && targetRef.current) {
                var gapSpace = offsetFromTarget ? offsetFromTarget : 0;
                maxHeight.current = getMaxHeight(targetRef.current, directionalHint, gapSpace, getCachedBounds(), undefined, win);
            }
            else {
                maxHeight.current = getCachedBounds().height - BORDER_WIDTH * 2;
            }
        }
        return maxHeight.current;
    };
    return getCachedMaxHeight;
}
function useAutoDismissEvents(_a, positionedHost, targetWindow, targetRef, positions, updateAsyncPosition) {
    var onDismiss = _a.onDismiss, preventDismissOnScroll = _a.preventDismissOnScroll;
    var async = useAsync();
    var onResize = React.useCallback(function (ev) {
        if (onDismiss) {
            onDismiss(ev);
        }
        else {
            updateAsyncPosition();
        }
    }, [onDismiss, updateAsyncPosition]);
    var dismissOnLostFocus = React.useCallback(function (ev) {
        var target = ev.target;
        var clickedOutsideCallout = positionedHost.current && !elementContains$1(positionedHost.current, target);
        if ((!targetRef.current && clickedOutsideCallout) ||
            (ev.target !== targetWindow &&
                clickedOutsideCallout &&
                (targetRef.current.stopPropagation ||
                    !targetRef.current ||
                    (target !== targetRef.current && !elementContains$1(targetRef.current, target))))) {
            onResize(ev);
        }
    }, [onResize, positionedHost, targetRef, targetWindow]);
    var dismissOnScroll = React.useCallback(function (ev) {
        if (positions && !preventDismissOnScroll) {
            dismissOnLostFocus(ev);
        }
    }, [dismissOnLostFocus, positions, preventDismissOnScroll]);
    React.useEffect(function () {
        var events = new EventGroup({});
        // This is added so the positioningContainer will dismiss when the window is scrolled
        // but not when something inside the positioningContainer is scrolled. The delay seems
        // to be required to avoid React firing an async focus event in IE from
        // the target changing focus quickly prior to rendering the positioningContainer.
        async.setTimeout(function () {
            var _a, _b;
            events.on(targetWindow, 'scroll', async.throttle(dismissOnScroll, 10), true);
            events.on(targetWindow, 'resize', async.throttle(onResize, 10), true);
            events.on((_a = targetWindow === null || targetWindow === undefined ? undefined : targetWindow.document) === null || _a === undefined ? undefined : _a.body, 'focus', dismissOnLostFocus, true);
            events.on((_b = targetWindow === null || targetWindow === undefined ? undefined : targetWindow.document) === null || _b === undefined ? undefined : _b.body, 'click', dismissOnLostFocus, true);
        }, 0);
        return function () { return events.dispose(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on mount
    }, [dismissOnScroll]);
}
function useHeightOffset(_a, contentHost) {
    var finalHeight = _a.finalHeight;
    /**
     * Tracks the current height offset and updates during
     * the height animation when props.finalHeight is specified.
     * State stored as object to ensure re-render even if the value does not change.
     *  See https://github.com/microsoft/fluentui/issues/23545
     */
    var _b = React.useState({ value: 0 }), heightOffset = _b[0], setHeightOffset = _b[1];
    var async = useAsync();
    var setHeightOffsetTimer = React.useRef(0);
    /** Animates the height if finalHeight was given. */
    var setHeightOffsetEveryFrame = function () {
        if (contentHost && finalHeight) {
            setHeightOffsetTimer.current = async.requestAnimationFrame(function () {
                if (!contentHost.current) {
                    return;
                }
                var positioningContainerMainElem = contentHost.current.lastChild;
                var cardScrollHeight = positioningContainerMainElem.scrollHeight;
                var cardCurrHeight = positioningContainerMainElem.offsetHeight;
                var scrollDiff = cardScrollHeight - cardCurrHeight;
                setHeightOffset({ value: heightOffset.value + scrollDiff });
                if (positioningContainerMainElem.offsetHeight < finalHeight) {
                    setHeightOffsetEveryFrame();
                }
                else {
                    async.cancelAnimationFrame(setHeightOffsetTimer.current);
                }
            });
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only re-run if finalHeight changes
    React.useEffect(setHeightOffsetEveryFrame, [finalHeight]);
    return heightOffset.value;
}
var PositioningContainer = React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var props = getPropsWithDefaults(DEFAULT_PROPS$2, propsWithoutDefaults);
    // @TODO rename to reflect the name of this class
    var contentHost = React.useRef(null);
    /**
     * The primary positioned div.
     */
    var positionedHost = React.useRef(null);
    var rootRef = useMergedRefs$1(forwardedRef, positionedHost);
    var _a = useTarget(props.target, positionedHost), targetRef = _a[0], targetWindow = _a[1];
    var getCachedBounds = useBounds(props, targetWindow);
    var _b = usePositionState(props, positionedHost, contentHost, targetRef, getCachedBounds), positions = _b[0], updateAsyncPosition = _b[1];
    var getCachedMaxHeight = useMaxHeight(props, targetRef, getCachedBounds);
    var heightOffset = useHeightOffset(props, contentHost);
    useSetInitialFocus(props, contentHost, positions);
    useAutoDismissEvents(props, positionedHost, targetWindow, targetRef, positions, updateAsyncPosition);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on initial render
    React.useEffect(function () { var _a; return (_a = props.onLayerMounted) === null || _a === undefined ? undefined : _a.call(props); }, []);
    // If there is no target window then we are likely in server side rendering and we should not render anything.
    if (!targetWindow) {
        return null;
    }
    var className = props.className, doNotLayer = props.doNotLayer, positioningContainerWidth = props.positioningContainerWidth, positioningContainerMaxHeight = props.positioningContainerMaxHeight, children = props.children;
    var styles = getClassNames$g();
    var directionalClassName = positions && positions.targetEdge ? AnimationClassNames[SLIDE_ANIMATIONS[positions.targetEdge]] : '';
    var getContentMaxHeight = getCachedMaxHeight() + heightOffset;
    var contentMaxHeight = positioningContainerMaxHeight && positioningContainerMaxHeight > getContentMaxHeight
        ? getContentMaxHeight
        : positioningContainerMaxHeight;
    var content = (React.createElement("div", { ref: rootRef, className: css('ms-PositioningContainer', styles.container) },
        React.createElement("div", { className: mergeStyles('ms-PositioningContainer-layerHost', styles.root, className, directionalClassName, !!positioningContainerWidth && { width: positioningContainerWidth }, doNotLayer && { zIndex: ZIndexes.Layer }), style: positions ? positions.elementPosition : OFF_SCREEN_STYLE, 
            // Safari and Firefox on Mac OS requires this to back-stop click events so focus remains in the Callout.
            // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
            tabIndex: -1, ref: contentHost },
            children,
            // @TODO apply to the content container
            contentMaxHeight)));
    return doNotLayer ? content : React.createElement(Layer, __assign$2({}, props.layerProps), content);
});
PositioningContainer.displayName = 'PositioningContainer';
function arePositionsEqual(positions, newPosition) {
    return comparePositions(positions.elementPosition, newPosition.elementPosition);
}
function comparePositions(oldPositions, newPositions) {
    for (var key in newPositions) {
        if (newPositions.hasOwnProperty(key)) {
            var oldPositionEdge = oldPositions[key];
            var newPositionEdge = newPositions[key];
            if (oldPositionEdge && newPositionEdge) {
                if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) {
                    return false;
                }
            }
        }
    }
    return true;
}

function getStyles$c(props) {
    var _a;
    return {
        root: [
            {
                position: 'absolute',
                boxShadow: 'inherit',
                border: 'none',
                boxSizing: 'border-box',
                transform: props.transform,
                width: props.width,
                height: props.height,
                left: props.left,
                top: props.top,
                right: props.right,
                bottom: props.bottom,
            },
        ],
        beak: {
            fill: props.color,
            display: 'block',
            selectors: (_a = {},
                _a[HighContrastSelector] = {
                    fill: 'windowtext',
                },
                _a),
        },
    };
}

var BEAK_HEIGHT = 10;
var BEAK_WIDTH = 18;
var Beak = React.forwardRef(function (props, forwardedRef) {
    var left = props.left, top = props.top, bottom = props.bottom, right = props.right, color = props.color, _a = props.direction, direction = _a === undefined ? RectangleEdge.top : _a;
    var svgHeight;
    var svgWidth;
    if (direction === RectangleEdge.top || direction === RectangleEdge.bottom) {
        svgHeight = BEAK_HEIGHT;
        svgWidth = BEAK_WIDTH;
    }
    else {
        svgHeight = BEAK_WIDTH;
        svgWidth = BEAK_HEIGHT;
    }
    var pointOne;
    var pointTwo;
    var pointThree;
    var transform;
    switch (direction) {
        case RectangleEdge.top:
        default:
            pointOne = "".concat(BEAK_WIDTH / 2, ", 0");
            pointTwo = "".concat(BEAK_WIDTH, ", ").concat(BEAK_HEIGHT);
            pointThree = "0, ".concat(BEAK_HEIGHT);
            transform = 'translateY(-100%)';
            break;
        case RectangleEdge.right:
            pointOne = "0, 0";
            pointTwo = "".concat(BEAK_HEIGHT, ", ").concat(BEAK_HEIGHT);
            pointThree = "0, ".concat(BEAK_WIDTH);
            transform = 'translateX(100%)';
            break;
        case RectangleEdge.bottom:
            pointOne = "0, 0";
            pointTwo = "".concat(BEAK_WIDTH, ", 0");
            pointThree = "".concat(BEAK_WIDTH / 2, ", ").concat(BEAK_HEIGHT);
            transform = 'translateY(100%)';
            break;
        case RectangleEdge.left:
            pointOne = "".concat(BEAK_HEIGHT, ", 0");
            pointTwo = "0, ".concat(BEAK_HEIGHT);
            pointThree = "".concat(BEAK_HEIGHT, ", ").concat(BEAK_WIDTH);
            transform = 'translateX(-100%)';
            break;
    }
    var getClassNames = classNamesFunction();
    var classNames = getClassNames(getStyles$c, {
        left: left,
        top: top,
        bottom: bottom,
        right: right,
        height: "".concat(svgHeight, "px"),
        width: "".concat(svgWidth, "px"),
        transform: transform,
        color: color,
    });
    return (React.createElement("div", { className: classNames.root, role: "presentation", ref: forwardedRef },
        React.createElement("svg", { height: svgHeight, width: svgWidth, className: classNames.beak },
            React.createElement("polygon", { points: pointOne + ' ' + pointTwo + ' ' + pointThree }))));
});
Beak.displayName = 'Beak';

var getClassNames$f = classNamesFunction();
var DEFAULT_PROPS$1 = {
    isCollapsed: true,
    mouseProximityOffset: 10,
    delayBeforeMouseOpen: 3600, // The approximate time the coachmark shows up
    delayBeforeCoachmarkAnimation: 0,
    isPositionForced: true,
    positioningContainerProps: {
        directionalHint: DirectionalHint.bottomAutoEdge,
    },
};
function useCollapsedState(props, entityInnerHostElementRef) {
    var propsIsCollapsed = props.isCollapsed, onAnimationOpenStart = props.onAnimationOpenStart, onAnimationOpenEnd = props.onAnimationOpenEnd;
    /** Is the Coachmark currently collapsed into a tear drop shape */
    var _a = React.useState(!!propsIsCollapsed), isCollapsed = _a[0], setIsCollapsed = _a[1];
    var setTimeout = useSetTimeout().setTimeout;
    // Rather than pushing out logic elsewhere to prevent openCoachmark from being called repeatedly,
    // we'll track it here and only invoke the logic once. We do this with a ref, rather than just the state,
    // because the openCoachmark callback can be captured in scope for an effect
    var hasCoachmarkBeenOpened = React.useRef(!isCollapsed);
    var openCoachmark = React.useCallback(function () {
        var _a, _b;
        if (!hasCoachmarkBeenOpened.current) {
            setIsCollapsed(false);
            onAnimationOpenStart === null || onAnimationOpenStart === undefined ? undefined : onAnimationOpenStart();
            (_b = (_a = entityInnerHostElementRef.current) === null || _a === undefined ? undefined : _a.addEventListener) === null || _b === undefined ? undefined : _b.call(_a, 'transitionend', function () {
                // Need setTimeout to trigger narrator
                setTimeout(function () {
                    if (entityInnerHostElementRef.current) {
                        focusFirstChild(entityInnerHostElementRef.current);
                    }
                }, 1000);
                onAnimationOpenEnd === null || onAnimationOpenEnd === undefined ? undefined : onAnimationOpenEnd();
            });
            hasCoachmarkBeenOpened.current = true;
        }
    }, [entityInnerHostElementRef, onAnimationOpenEnd, onAnimationOpenStart, setTimeout]);
    React.useEffect(function () {
        if (!propsIsCollapsed) {
            openCoachmark();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run if isCollapsed changes
    }, [propsIsCollapsed]);
    return [isCollapsed, openCoachmark];
}
function usePositionedData() {
    var async = useAsync();
    /**
     * Alignment edge of callout in relation to target
     */
    var _a = React.useState(), targetAlignment = _a[0], setTargetAlignment = _a[1];
    /**
     * Position of Coachmark/TeachingBubble in relation to target
     */
    var _b = React.useState(), targetPosition = _b[0], setTargetPosition = _b[1];
    var onPositioned = function (_a) {
        var alignmentEdge = _a.alignmentEdge, targetEdge = _a.targetEdge;
        return async.requestAnimationFrame(function () {
            setTargetAlignment(alignmentEdge);
            setTargetPosition(targetEdge);
        });
    };
    return [targetAlignment, targetPosition, onPositioned];
}
function useBeakPosition(props, targetAlignment, targetPosition) {
    var isRTL = getRTL(props.theme);
    return React.useMemo(function () {
        var beakDirection = targetPosition === undefined ? RectangleEdge.bottom : getOppositeEdge(targetPosition);
        var beakPosition = { direction: beakDirection };
        var transformOriginX;
        var transformOriginY;
        var distanceAdjustment = '3px'; // Adjustment distance for Beak to shift towards Coachmark bubble.
        switch (beakDirection) {
            // If Beak is pointing Up or Down
            case RectangleEdge.top:
            case RectangleEdge.bottom:
                // If there is no target alignment, then beak is X-axis centered in callout
                if (!targetAlignment) {
                    beakPosition.left = "calc(50% - ".concat(BEAK_WIDTH / 2, "px)");
                    transformOriginX = 'center';
                }
                else {
                    // Beak is aligned to the left of target
                    if (targetAlignment === RectangleEdge.left) {
                        beakPosition.left = "".concat(COACHMARK_WIDTH / 2 - BEAK_WIDTH / 2, "px");
                        transformOriginX = 'left';
                    }
                    else {
                        // Beak is aligned to the right of target
                        beakPosition.right = "".concat(COACHMARK_WIDTH / 2 - BEAK_WIDTH / 2, "px");
                        transformOriginX = 'right';
                    }
                }
                if (beakDirection === RectangleEdge.top) {
                    beakPosition.top = distanceAdjustment;
                    transformOriginY = 'top';
                }
                else {
                    beakPosition.bottom = distanceAdjustment;
                    transformOriginY = 'bottom';
                }
                break;
            // If Beak is pointing Left or Right
            case RectangleEdge.left:
            case RectangleEdge.right:
                // If there is no target alignment, then beak is Y-axis centered in callout
                if (!targetAlignment) {
                    beakPosition.top = "calc(50% - ".concat(BEAK_WIDTH / 2, "px)");
                    transformOriginY = "center";
                }
                else {
                    // Beak is aligned to the top of target
                    if (targetAlignment === RectangleEdge.top) {
                        beakPosition.top = "".concat(COACHMARK_WIDTH / 2 - BEAK_WIDTH / 2, "px");
                        transformOriginY = "top";
                    }
                    else {
                        // Beak is aligned to the bottom of target
                        beakPosition.bottom = "".concat(COACHMARK_WIDTH / 2 - BEAK_WIDTH / 2, "px");
                        transformOriginY = "bottom";
                    }
                }
                if (beakDirection === RectangleEdge.left) {
                    if (isRTL) {
                        beakPosition.right = distanceAdjustment;
                    }
                    else {
                        beakPosition.left = distanceAdjustment;
                    }
                    transformOriginX = 'left';
                }
                else {
                    if (isRTL) {
                        beakPosition.left = distanceAdjustment;
                    }
                    else {
                        beakPosition.right = distanceAdjustment;
                    }
                    transformOriginX = 'right';
                }
                break;
        }
        return [beakPosition, "".concat(transformOriginX, " ").concat(transformOriginY)];
    }, [targetAlignment, targetPosition, isRTL]);
}
function useListeners(props, translateAnimationContainer, openCoachmark) {
    var _a;
    var document = (_a = getDocument$1()) === null || _a === undefined ? undefined : _a.documentElement;
    useOnEvent(document, 'keydown', function (e) {
        var _a, _b;
        // Open coachmark if user presses ALT + C (arbitrary keypress for now)
        if (
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        (e.altKey && e.which === KeyCodes.c) ||
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            (e.which === KeyCodes.enter && ((_b = (_a = translateAnimationContainer.current) === null || _a === undefined ? undefined : _a.contains) === null || _b === undefined ? undefined : _b.call(_a, e.target)))) {
            openCoachmark();
        }
    }, true);
    var dismissOnLostFocus = function (ev) {
        var _a;
        if (props.preventDismissOnLostFocus) {
            var clickTarget = ev.target;
            var clickedOutsideCallout = translateAnimationContainer.current && !elementContains$1(translateAnimationContainer.current, clickTarget);
            var target = props.target;
            if (clickedOutsideCallout && clickTarget !== target && !elementContains$1(target, clickTarget)) {
                (_a = props.onDismiss) === null || _a === undefined ? undefined : _a.call(props, ev);
            }
        }
    };
    useOnEvent(document, 'click', dismissOnLostFocus, true);
    useOnEvent(document, 'focus', dismissOnLostFocus, true);
}
function useProximityHandlers(props, translateAnimationContainer, openCoachmark, setBounds) {
    var _a = useSetTimeout(), setTimeout = _a.setTimeout, clearTimeout = _a.clearTimeout;
    /** The target element the mouse would be in proximity to */
    var targetElementRect = React.useRef();
    var win = useWindowEx();
    var doc = useDocumentEx();
    React.useEffect(function () {
        var setTargetElementRect = function () {
            if (translateAnimationContainer.current) {
                targetElementRect.current = translateAnimationContainer.current.getBoundingClientRect();
            }
        };
        var events = new EventGroup({});
        // We don't want the user to immediately trigger the Coachmark when it's opened
        setTimeout(function () {
            var _a = props.mouseProximityOffset, mouseProximityOffset = _a === undefined ? 0 : _a;
            /** Cached ids returned when setTimeout runs during the window resize event trigger. */
            var timeoutIds = [];
            // Take the initial measure out of the initial render to prevent an unnecessary render.
            setTimeout(function () {
                setTargetElementRect();
                // When the window resizes we want to async get the bounding client rectangle.
                // Every time the event is triggered we want to setTimeout and then clear any previous
                // instances of setTimeout.
                events.on(win, 'resize', function () {
                    timeoutIds.forEach(function (value) {
                        clearTimeout(value);
                    });
                    timeoutIds.splice(0, timeoutIds.length); // clear array
                    timeoutIds.push(setTimeout(function () {
                        setTargetElementRect();
                        setBounds(getBounds(props.isPositionForced, props.positioningContainerProps, win));
                    }, 100));
                });
            }, 10);
            // Every time the document's mouse move is triggered, we want to check if inside of an element
            // and set the state with the result.
            events.on(doc, 'mousemove', function (e) {
                var _a;
                var mouseY = e.clientY;
                var mouseX = e.clientX;
                setTargetElementRect();
                if (isInsideElement(targetElementRect.current, mouseX, mouseY, mouseProximityOffset)) {
                    openCoachmark();
                }
                (_a = props.onMouseMove) === null || _a === undefined ? undefined : _a.call(props, e);
            });
        }, props.delayBeforeMouseOpen);
        return function () { return events.dispose(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on mount
    }, []);
}
function useComponentRef$4(props) {
    var onDismiss = props.onDismiss;
    React.useImperativeHandle(props.componentRef, function (ev) { return ({
        dismiss: function () {
            onDismiss === null || onDismiss === undefined ? undefined : onDismiss(ev);
        },
    }); }, [onDismiss]);
}
function useAriaAlert(_a) {
    var ariaAlertText = _a.ariaAlertText;
    var async = useAsync();
    /** ARIA alert text to read aloud with Narrator once the Coachmark is mounted */
    var _b = React.useState(), alertText = _b[0], setAlertText = _b[1];
    React.useEffect(function () {
        // Need to add RAF to have narrator read change in alert container
        async.requestAnimationFrame(function () {
            setAlertText(ariaAlertText);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on mount
    }, []);
    return alertText;
}
function useAutoFocus(_a) {
    var preventFocusOnMount = _a.preventFocusOnMount;
    var setTimeout = useSetTimeout().setTimeout;
    /**
     * The cached HTMLElement reference to the Entity Inner Host
     * element.
     */
    var entityHost = React.useRef(null);
    React.useEffect(function () {
        if (!preventFocusOnMount) {
            setTimeout(function () { var _a; return (_a = entityHost.current) === null || _a === undefined ? undefined : _a.focus(); }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on mount
    }, []);
    return entityHost;
}
function useEntityHostMeasurements(props, entityInnerHostElementRef) {
    /** Is the teaching bubble currently retrieving the original dimensions of the hosted entity. */
    var _a = React.useState(!!props.isCollapsed), isMeasuring = _a[0], setIsMeasuring = _a[1];
    /** Cached width and height of _entityInnerHostElement */
    var _b = React.useState(props.isCollapsed ? { width: 0, height: 0 } : {}), entityInnerHostRect = _b[0], setEntityInnerHostRect = _b[1];
    var async = useAsync();
    React.useEffect(function () {
        async.requestAnimationFrame(function () {
            if (entityInnerHostElementRef.current) {
                setEntityInnerHostRect({
                    width: entityInnerHostElementRef.current.offsetWidth,
                    height: entityInnerHostElementRef.current.offsetHeight,
                });
                setIsMeasuring(false);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on mount
    }, []);
    return [isMeasuring, entityInnerHostRect];
}
function useDeprecationWarning(props) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- build-time conditional
        useWarnings({
            name: COMPONENT_NAME$6,
            props: props,
            deprecations: {
                teachingBubbleRef: undefined,
                collapsed: 'isCollapsed',
                beakWidth: undefined,
                beakHeight: undefined,
                width: undefined,
                height: undefined,
            },
        });
    }
}
var COMPONENT_NAME$6 = 'CoachmarkBase';
var CoachmarkBase = React.forwardRef(function (propsWithoutDefaults, forwardedRef) {
    var props = getPropsWithDefaults(DEFAULT_PROPS$1, propsWithoutDefaults);
    var win = useWindowEx();
    var entityInnerHostElementRef = React.useRef(null);
    var translateAnimationContainer = React.useRef(null);
    var _a = usePositionedData(), targetAlignment = _a[0], targetPosition = _a[1], onPositioned = _a[2];
    var _b = useCollapsedState(props, entityInnerHostElementRef), isCollapsed = _b[0], openCoachmark = _b[1];
    var _c = useBeakPosition(props, targetAlignment, targetPosition), beakPositioningProps = _c[0], transformOrigin = _c[1];
    var _d = useEntityHostMeasurements(props, entityInnerHostElementRef), isMeasuring = _d[0], entityInnerHostRect = _d[1];
    var _e = React.useState(getBounds(props.isPositionForced, props.positioningContainerProps, win)), bounds = _e[0], setBounds = _e[1];
    var alertText = useAriaAlert(props);
    var entityHost = useAutoFocus(props);
    useListeners(props, translateAnimationContainer, openCoachmark);
    useComponentRef$4(props);
    useProximityHandlers(props, translateAnimationContainer, openCoachmark, setBounds);
    useDeprecationWarning(props);
    React.useEffect(function () {
        setBounds(getBounds(props.isPositionForced, props.positioningContainerProps, win));
    }, [props.isPositionForced, props.positioningContainerProps, win]);
    var beaconColorOne = props.beaconColorOne, beaconColorTwo = props.beaconColorTwo, children = props.children, target = props.target, color = props.color, positioningContainerProps = props.positioningContainerProps, ariaDescribedBy = props.ariaDescribedBy, ariaDescribedByText = props.ariaDescribedByText, ariaLabelledBy = props.ariaLabelledBy, ariaLabelledByText = props.ariaLabelledByText, ariaAlertText = props.ariaAlertText, delayBeforeCoachmarkAnimation = props.delayBeforeCoachmarkAnimation, styles = props.styles, theme = props.theme, className = props.className, persistentBeak = props.persistentBeak;
    // Defaulting the main background before passing it to the styles because it is used for `Beak` too.
    var defaultColor = color;
    if (!defaultColor && theme) {
        defaultColor = theme.semanticColors.primaryButtonBackground;
    }
    var classNames = getClassNames$f(styles, {
        theme: theme,
        beaconColorOne: beaconColorOne,
        beaconColorTwo: beaconColorTwo,
        className: className,
        isCollapsed: isCollapsed,
        isMeasuring: isMeasuring,
        color: defaultColor,
        transformOrigin: transformOrigin,
        entityHostHeight: entityInnerHostRect.height === undefined ? undefined : "".concat(entityInnerHostRect.height, "px"),
        entityHostWidth: entityInnerHostRect.width === undefined ? undefined : "".concat(entityInnerHostRect.width, "px"),
        width: "".concat(COACHMARK_WIDTH, "px"),
        height: "".concat(COACHMARK_HEIGHT, "px"),
        delayBeforeCoachmarkAnimation: "".concat(delayBeforeCoachmarkAnimation, "ms"),
    });
    var finalHeight = isCollapsed ? COACHMARK_HEIGHT : entityInnerHostRect.height;
    var onClickCallout = React.useCallback(function () {
        openCoachmark();
    }, [openCoachmark]);
    return (React.createElement(PositioningContainer, __assign$2({ target: target, offsetFromTarget: BEAK_HEIGHT, finalHeight: finalHeight, ref: forwardedRef, onPositioned: onPositioned, bounds: bounds }, positioningContainerProps),
        React.createElement("div", { className: classNames.root },
            ariaAlertText && (React.createElement("div", { className: classNames.ariaContainer, role: "alert", "aria-hidden": !isCollapsed }, alertText)),
            React.createElement("div", { className: classNames.pulsingBeacon }),
            React.createElement("div", { className: classNames.translateAnimationContainer, ref: translateAnimationContainer },
                React.createElement("div", { className: classNames.scaleAnimationLayer },
                    React.createElement("div", { className: classNames.rotateAnimationLayer },
                        (isCollapsed || persistentBeak) && React.createElement(Beak, __assign$2({}, beakPositioningProps, { color: defaultColor })),
                        React.createElement("div", { className: classNames.entityHost, ref: entityHost, tabIndex: -1, "data-is-focusable": true, role: "dialog", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, onClick: onClickCallout },
                            isCollapsed && [
                                ariaLabelledBy && (React.createElement("p", { id: ariaLabelledBy, key: 0, className: classNames.ariaContainer }, ariaLabelledByText)),
                                ariaDescribedBy && (React.createElement("p", { id: ariaDescribedBy, key: 1, className: classNames.ariaContainer }, ariaDescribedByText)),
                            ],
                            React.createElement(FocusTrapZone, { isClickableOutsideFocusTrap: true, forceFocusInsideTrap: false },
                                React.createElement("div", { className: classNames.entityInnerHost, ref: entityInnerHostElementRef },
                                    React.createElement("div", { className: classNames.childrenContainer, "aria-hidden": isCollapsed }, children))))))))));
});
CoachmarkBase.displayName = COMPONENT_NAME$6;
function getBounds(isPositionForced, positioningContainerProps, win) {
    var _a, _b;
    if (isPositionForced) {
        // If directionalHint direction is the top or bottom auto edge, then we want to set the left/right bounds
        // to the window x-axis to have auto positioning work correctly.
        if (positioningContainerProps &&
            (positioningContainerProps.directionalHint === DirectionalHint.topAutoEdge ||
                positioningContainerProps.directionalHint === DirectionalHint.bottomAutoEdge)) {
            return {
                left: 0,
                top: -Infinity,
                bottom: Infinity,
                right: (_a = win === null || win === undefined ? undefined : win.innerWidth) !== null && _a !== undefined ? _a : 0,
                width: (_b = win === null || win === undefined ? undefined : win.innerWidth) !== null && _b !== undefined ? _b : 0,
                height: Infinity,
            };
        }
        else {
            return {
                left: -Infinity,
                top: -Infinity,
                bottom: Infinity,
                right: Infinity,
                width: Infinity,
                height: Infinity,
            };
        }
    }
    else {
        return undefined;
    }
}
function isInsideElement(
// eslint-disable-next-line @typescript-eslint/no-deprecated
targetElementRect, mouseX, mouseY, mouseProximityOffset) {
    if (mouseProximityOffset === undefined) { mouseProximityOffset = 0; }
    return (mouseX > targetElementRect.left - mouseProximityOffset &&
        mouseX < targetElementRect.left + targetElementRect.width + mouseProximityOffset &&
        mouseY > targetElementRect.top - mouseProximityOffset &&
        mouseY < targetElementRect.top + targetElementRect.height + mouseProximityOffset);
}

var Coachmark = styled(CoachmarkBase, getStyles$d, undefined, {
    scope: 'Coachmark',
});

/**
 * {@docCategory List}
 */
var ScrollToMode = {
    /**
     * Does not make any consideration to where in the viewport the item should align to.
     */
    auto: 0,
    /**
     * Attempts to scroll the list so the top of the desired item is aligned with the top of the viewport.
     */
    top: 1,
    /**
     * Attempts to scroll the list so the bottom of the desired item is aligned with the bottom of the viewport.
     */
    bottom: 2,
    /**
     * Attempts to scroll the list so the desired item is in the exact center of the viewport.
     */
    center: 3,
};

var getScrollHeight = function (el) {
    if (el === undefined) {
        return 0;
    }
    var scrollHeight = 0;
    if ('scrollHeight' in el) {
        scrollHeight = el.scrollHeight;
    }
    else if ('document' in el) {
        scrollHeight = el.document.documentElement.scrollHeight;
    }
    // No need to round as scrollHeight is already rounded for us.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight
    return scrollHeight;
};
var getScrollYPosition = function (el) {
    if (el === undefined) {
        return 0;
    }
    var scrollPos = 0;
    if ('scrollTop' in el) {
        scrollPos = el.scrollTop;
    }
    else if ('scrollY' in el) {
        scrollPos = el.scrollY;
    }
    // Round this value to an integer as it may be fractional.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTop
    // See: https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
    return Math.ceil(scrollPos);
};
var setScrollYPosition = function (el, pos) {
    if ('scrollTop' in el) {
        el.scrollTop = pos;
    }
    else if ('scrollY' in el) {
        el.scrollTo(el.scrollX, pos);
    }
};

// import { ListDebugRenderer } from './utils/ListDebugRenderer';
var RESIZE_DELAY = 16;
var MIN_SCROLL_UPDATE_DELAY = 100;
var MAX_SCROLL_UPDATE_DELAY = 500;
var IDLE_DEBOUNCE_DELAY = 200;
// The amount of time to wait before declaring that the list isn't scrolling
var DONE_SCROLLING_WAIT = 500;
var DEFAULT_ITEMS_PER_PAGE = 10;
var DEFAULT_PAGE_HEIGHT = 30;
var DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
var DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
var PAGE_KEY_PREFIX = 'page-';
var SPACER_KEY_PREFIX = 'spacer-';
// Fraction of a page to have been scrolled before re-running expensive calculations
var SCROLL_RATIO = 1 / 3;
var EMPTY_RECT = {
    top: -1,
    bottom: -1,
    left: -1,
    right: -1,
    width: 0,
    height: 0,
};
// Naming expensive measures so that they're named in profiles.
var _measurePageRect = function (element) { return element.getBoundingClientRect(); };
var _measureSurfaceRect = _measurePageRect;
var _measureScrollRect = _measurePageRect;
/**
 * The List renders virtualized pages of items. Each page's item count is determined by the getItemCountForPage callback
 * if provided by the caller, or 10 as default. Each page's height is determined by the getPageHeight callback if
 * provided by the caller, or by cached measurements if available, or by a running average, or a default fallback.
 *
 * The algorithm for rendering pages works like this:
 *
 * 1. Predict visible pages based on "current measure data" (page heights, surface position, visible window)
 * 2. If changes are necessary, apply changes (add/remove pages)
 * 3. For pages that are added, measure the page heights if we need to using getBoundingClientRect
 * 4. If measurements don't match predictions, update measure data and goto step 1 asynchronously
 *
 * Measuring too frequently can pull performance down significantly. To compensate, we cache measured values so that
 * we can avoid re-measuring during operations that should not alter heights, like scrolling.
 *
 * To optimize glass rendering performance, onShouldVirtualize can be set. When onShouldVirtualize return false,
 * List will run in fast mode (not virtualized) to render all items without any measurements to improve page load time.
 * And we start doing measurements and rendering in virtualized mode when items grows larger than this threshold.
 *
 * However, certain operations can make measure data stale. For example, resizing the list, or passing in new props,
 * or forcing an update change cause pages to shrink/grow. When these operations occur, we increment a measureVersion
 * number, which we associate with cached measurements and use to determine if a remeasure should occur.
 */
var List = /** @class */ (function (_super) {
    __extends$1(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this._root = React.createRef();
        _this._surface = React.createRef();
        _this._pageRefs = {};
        _this._getDerivedStateFromProps = function (nextProps, previousState) {
            if (nextProps.items !== _this.props.items ||
                nextProps.renderCount !== _this.props.renderCount ||
                nextProps.startIndex !== _this.props.startIndex ||
                nextProps.version !== _this.props.version ||
                (!previousState.hasMounted && _this.props.renderEarly && canUseDOM$2())) {
                // We have received new items so we want to make sure that initially we only render a single window to
                // fill the currently visible rect, and then later render additional windows.
                _this._resetRequiredWindows();
                _this._requiredRect = null;
                _this._measureVersion++;
                _this._invalidatePageCache();
                return _this._updatePages(nextProps, previousState);
            }
            return previousState;
        };
        _this._onRenderRoot = function (props) {
            var rootRef = props.rootRef, surfaceElement = props.surfaceElement, divProps = props.divProps;
            return (React.createElement("div", __assign$2({ ref: rootRef }, divProps), surfaceElement));
        };
        _this._onRenderSurface = function (props) {
            var surfaceRef = props.surfaceRef, pageElements = props.pageElements, divProps = props.divProps;
            return (React.createElement("div", __assign$2({ ref: surfaceRef }, divProps), pageElements));
        };
        _this._onRenderPage = function (pageProps, defaultRender) {
            var _a;
            var _b = _this.props, onRenderCell = _b.onRenderCell, onRenderCellConditional = _b.onRenderCellConditional, role = _b.role;
            var _c = pageProps.page, _d = _c.items, items = _d === undefined ? [] : _d, startIndex = _c.startIndex, divProps = __rest$1(pageProps, ["page"]);
            // only assign list item role if no role is assigned
            var cellRole = role === undefined ? 'listitem' : 'presentation';
            var cells = [];
            for (var i = 0; i < items.length; i++) {
                var index = startIndex + i;
                var item = items[i];
                var itemKey = _this.props.getKey ? _this.props.getKey(item, index) : item && item.key;
                if (itemKey === null || itemKey === undefined) {
                    itemKey = index;
                }
                var renderCell = onRenderCellConditional !== null && onRenderCellConditional !== undefined ? onRenderCellConditional : onRenderCell;
                var cell = (_a = renderCell === null || renderCell === undefined ? undefined : renderCell(item, index, !_this.props.ignoreScrollingState ? _this.state.isScrolling : undefined)) !== null && _a !== undefined ? _a : null;
                if (!onRenderCellConditional || cell) {
                    cells.push(React.createElement("div", { role: cellRole, className: 'ms-List-cell', key: itemKey, "data-list-index": index, "data-automationid": "ListCell" }, cell));
                }
            }
            return React.createElement("div", __assign$2({}, divProps), cells);
        };
        initializeComponentRef(_this);
        _this.state = {
            pages: [],
            isScrolling: false,
            getDerivedStateFromProps: _this._getDerivedStateFromProps,
            hasMounted: false,
        };
        _this._estimatedPageHeight = 0;
        _this._totalEstimates = 0;
        _this._requiredWindowsAhead = 0;
        _this._requiredWindowsBehind = 0;
        // Track the measure version for everything.
        _this._measureVersion = 0;
        _this._cachedPageHeights = {};
        _this._estimatedPageHeight = 0;
        _this._focusedIndex = -1;
        _this._pageCache = {};
        return _this;
    }
    // private _debugRenderer: ListDebugRenderer;
    // private _debugRafId: number | undefined = undefined;
    List.getDerivedStateFromProps = function (nextProps, previousState) {
        return previousState.getDerivedStateFromProps(nextProps, previousState);
    };
    Object.defineProperty(List.prototype, "pageRefs", {
        get: function () {
            return this._pageRefs;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Scroll to the given index. By default will bring the page the specified item is on into the view. If a callback
     * to measure the height of an individual item is specified, will only scroll to bring the specific item into view.
     *
     * Note: with items of variable height and no passed in `getPageHeight` method, the list might jump after scrolling
     * when windows before/ahead are being rendered, and the estimated height is replaced using actual elements.
     *
     * @param index - Index of item to scroll to
     * @param measureItem - Optional callback to measure the height of an individual item
     * @param scrollToMode - Optional defines where in the window the item should be positioned to when scrolling
     */
    List.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
        if (scrollToMode === undefined) { scrollToMode = ScrollToMode.auto; }
        var startIndex = this.props.startIndex;
        var renderCount = this._getRenderCount();
        var endIndex = startIndex + renderCount;
        var allowedRect = this._allowedRect;
        var scrollTop = 0;
        var itemsPerPage = 1;
        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
            var pageSpecification = this._getPageSpecification(this.props, itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            itemsPerPage = pageSpecification.itemCount;
            var requestedIndexIsInPage = itemIndex <= index && itemIndex + itemsPerPage > index;
            if (requestedIndexIsInPage) {
                // We have found the page. If the user provided a way to measure an individual item, we will try to scroll in
                // just the given item, otherwise we'll only bring the page into view
                if (measureItem && this._scrollElement) {
                    var scrollRect = _measureScrollRect(this._scrollElement);
                    var scrollPosition = getScrollYPosition(this._scrollElement);
                    var scrollWindow = {
                        top: scrollPosition,
                        bottom: scrollPosition + scrollRect.height,
                    };
                    // Adjust for actual item position within page
                    var itemPositionWithinPage = index - itemIndex;
                    for (var itemIndexInPage = 0; itemIndexInPage < itemPositionWithinPage; ++itemIndexInPage) {
                        scrollTop += measureItem(itemIndex + itemIndexInPage);
                    }
                    var scrollBottom = scrollTop + measureItem(index);
                    // If scrollToMode is set to something other than auto, we always want to
                    // scroll the item into a specific position on the page.
                    switch (scrollToMode) {
                        case ScrollToMode.top:
                            setScrollYPosition(this._scrollElement, scrollTop);
                            return;
                        case ScrollToMode.bottom:
                            setScrollYPosition(this._scrollElement, scrollBottom - scrollRect.height);
                            return;
                        case ScrollToMode.center:
                            setScrollYPosition(this._scrollElement, (scrollTop + scrollBottom - scrollRect.height) / 2);
                            return;
                    }
                    var itemIsFullyVisible = scrollTop >= scrollWindow.top && scrollBottom <= scrollWindow.bottom;
                    if (itemIsFullyVisible) {
                        // Item is already visible, do nothing.
                        return;
                    }
                    var itemIsPartiallyAbove = scrollTop < scrollWindow.top;
                    var itemIsPartiallyBelow = scrollBottom > scrollWindow.bottom;
                    if (itemIsPartiallyAbove) ;
                    else if (itemIsPartiallyBelow) {
                        //  Adjust scrollTop position to just bring in the element
                        // .------.  - scrollTop
                        // |      |
                        // | .------.
                        // '-|----' | - scrollWindow.bottom
                        //   | Item |
                        //   '------' - scrollBottom
                        scrollTop = scrollBottom - scrollRect.height;
                    }
                }
                if (this._scrollElement) {
                    setScrollYPosition(this._scrollElement, scrollTop);
                }
                return;
            }
            scrollTop += pageHeight;
        }
    };
    List.prototype.getStartItemIndexInView = function (measureItem) {
        var pages = this.state.pages || [];
        for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
            var page = pages_1[_i];
            var isPageVisible = !page.isSpacer && (this._scrollTop || 0) >= page.top && (this._scrollTop || 0) <= page.top + page.height;
            if (isPageVisible) {
                if (!measureItem) {
                    var rowHeight = Math.floor(page.height / page.itemCount);
                    return page.startIndex + Math.floor((this._scrollTop - page.top) / rowHeight);
                }
                else {
                    var totalRowHeight = 0;
                    for (var itemIndex = page.startIndex; itemIndex < page.startIndex + page.itemCount; itemIndex++) {
                        var rowHeight = measureItem(itemIndex);
                        if (page.top + totalRowHeight <= this._scrollTop &&
                            this._scrollTop < page.top + totalRowHeight + rowHeight) {
                            return itemIndex;
                        }
                        else {
                            totalRowHeight += rowHeight;
                        }
                    }
                }
            }
        }
        return 0;
    };
    List.prototype.componentDidMount = function () {
        this._async = new Async(this);
        this._events = new EventGroup(this);
        // Ensure that scrolls are lazy updated.
        this._onAsyncScrollDebounced = this._async.debounce(this._onAsyncScroll, MIN_SCROLL_UPDATE_DELAY, {
            leading: false,
            maxWait: MAX_SCROLL_UPDATE_DELAY,
        });
        this._onAsyncIdleDebounced = this._async.debounce(this._onAsyncIdle, IDLE_DEBOUNCE_DELAY, {
            leading: false,
        });
        this._onAsyncResizeDebounced = this._async.debounce(this._onAsyncResize, RESIZE_DELAY, {
            leading: false,
        });
        this._onScrollingDoneDebounced = this._async.debounce(this._onScrollingDone, DONE_SCROLLING_WAIT, {
            leading: false,
        });
        this._scrollElement = findScrollableParent(this._root.current);
        this._scrollTop = 0;
        this.setState(__assign$2(__assign$2({}, this._updatePages(this.props, this.state)), { hasMounted: true }));
        this._measureVersion++;
        var win = getWindowEx(this.context);
        this._events.on(win, 'resize', this._onAsyncResizeDebounced);
        if (this._root.current) {
            this._events.on(this._root.current, 'focus', this._onFocus, true);
        }
        if (this._scrollElement) {
            this._events.on(this._scrollElement, 'scroll', this._onScroll);
            this._events.on(this._scrollElement, 'scroll', this._onAsyncScrollDebounced);
        }
        // this._debugRenderer = new ListDebugRenderer();
        // const debugRender = () => {
        //   this._debugRenderer.render({
        //     visibleRect: this._visibleRect,
        //     allowedRect: this._allowedRect,
        //     requiredRect: this._requiredRect,
        //     materializedRect: this._materializedRect,
        //     surfaceRect: this._surfaceRect,
        //     totalListHeight: this.getTotalListHeight(),
        //     pages: this.state.pages,
        //     scrollTop: Math.abs(this._scrollTop - getScrollYPosition(this._scrollElement)),
        //     estimatedLine: this._estimatedPageHeight * SCROLL_RATIO,
        //     scrollY: getScrollYPosition(this._scrollElement),
        //   });
        //   this._debugRafId = requestAnimationFrame(debugRender);
        // };
        // debugRender();
    };
    List.prototype.componentDidUpdate = function (previousProps, previousState) {
        // Multiple updates may have been queued, so the callback will reflect all of them.
        // Re-fetch the current props and states to avoid using a stale props or state captured in the closure.
        var finalProps = this.props;
        var finalState = this.state;
        if (this.state.pagesVersion !== previousState.pagesVersion) {
            // If we weren't provided with the page height, measure the pages
            if (!finalProps.getPageHeight) {
                // If measured version is invalid since we've updated the DOM
                var heightsChanged = this._updatePageMeasurements(finalState.pages);
                // On first render, we should re-measure so that we don't get a visual glitch.
                if (heightsChanged) {
                    this._materializedRect = null;
                    if (!this._hasCompletedFirstRender) {
                        this._hasCompletedFirstRender = true;
                        this.setState(this._updatePages(finalProps, finalState));
                    }
                    else {
                        this._onAsyncScrollDebounced();
                    }
                }
                else {
                    // Enqueue an idle bump.
                    this._onAsyncIdleDebounced();
                }
            }
            else {
                // Enqueue an idle bump
                this._onAsyncIdleDebounced();
            }
            // Notify the caller that rendering the new pages has completed
            if (finalProps.onPagesUpdated) {
                finalProps.onPagesUpdated(finalState.pages);
            }
        }
    };
    List.prototype.componentWillUnmount = function () {
        var _a, _b;
        (_a = this._async) === null || _a === undefined ? undefined : _a.dispose();
        (_b = this._events) === null || _b === undefined ? undefined : _b.dispose();
        delete this._scrollElement;
        // this._debugRenderer.dispose();
        // if (this._debugRafId) {
        //   cancelAnimationFrame(this._debugRafId);
        //   this._debugRafId = undefined;
        // }
    };
    List.prototype.shouldComponentUpdate = function (newProps, newState) {
        var oldPages = this.state.pages;
        var newPages = newState.pages;
        var shouldComponentUpdate = false;
        // Update if the page stops scrolling
        if (!newState.isScrolling && this.state.isScrolling) {
            return true;
        }
        if (newProps.version !== this.props.version) {
            return true;
        }
        if (newProps.className !== this.props.className) {
            return true;
        }
        if (newProps.items === this.props.items && oldPages.length === newPages.length) {
            for (var i = 0; i < oldPages.length; i++) {
                var oldPage = oldPages[i];
                var newPage = newPages[i];
                if (oldPage.key !== newPage.key || oldPage.itemCount !== newPage.itemCount) {
                    shouldComponentUpdate = true;
                    break;
                }
            }
        }
        else {
            shouldComponentUpdate = true;
        }
        return shouldComponentUpdate;
    };
    List.prototype.forceUpdate = function () {
        this._invalidatePageCache();
        // Ensure that when the list is force updated we update the pages first before render.
        this._updateRenderRects(this.props, this.state, true);
        this.setState(this._updatePages(this.props, this.state));
        this._measureVersion++;
        _super.prototype.forceUpdate.call(this);
    };
    /**
     * Get the current height the list and it's pages.
     */
    List.prototype.getTotalListHeight = function () {
        return this._surfaceRect.height;
    };
    List.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.role, role = _b === undefined ? 'list' : _b, onRenderSurface = _a.onRenderSurface, onRenderRoot = _a.onRenderRoot;
        var _c = this.state.pages, pages = _c === undefined ? [] : _c;
        var pageElements = [];
        var divProps = getNativeProps$1(this.props, divProperties);
        for (var _i = 0, pages_2 = pages; _i < pages_2.length; _i++) {
            var page = pages_2[_i];
            pageElements.push(this._renderPage(page));
        }
        var finalOnRenderSurface = onRenderSurface
            ? composeRenderFunction(onRenderSurface, this._onRenderSurface)
            : this._onRenderSurface;
        var finalOnRenderRoot = onRenderRoot
            ? composeRenderFunction(onRenderRoot, this._onRenderRoot)
            : this._onRenderRoot;
        return finalOnRenderRoot({
            rootRef: this._root,
            pages: pages,
            surfaceElement: finalOnRenderSurface({
                surfaceRef: this._surface,
                pages: pages,
                pageElements: pageElements,
                divProps: {
                    role: 'presentation',
                    className: 'ms-List-surface',
                },
            }),
            divProps: __assign$2(__assign$2({}, divProps), { className: css('ms-List', className), role: pageElements.length > 0 ? role : undefined, 'aria-label': pageElements.length > 0 ? divProps['aria-label'] : undefined }),
        });
    };
    List.prototype._shouldVirtualize = function (props) {
        if (props === undefined) { props = this.props; }
        var onShouldVirtualize = props.onShouldVirtualize;
        return !onShouldVirtualize || onShouldVirtualize(props);
    };
    /**
     * when props.items change or forceUpdate called, throw away cached pages
     */
    List.prototype._invalidatePageCache = function () {
        this._pageCache = {};
    };
    List.prototype._renderPage = function (page) {
        var _this = this;
        var usePageCache = this.props.usePageCache;
        var cachedPage;
        // if usePageCache is set and cached page element can be found, just return cached page
        if (usePageCache) {
            cachedPage = this._pageCache[page.key];
            if (cachedPage && cachedPage.pageElement) {
                return cachedPage.pageElement;
            }
        }
        var pageStyle = this._getPageStyle(page);
        var _a = this.props.onRenderPage, onRenderPage = _a === undefined ? this._onRenderPage : _a;
        var pageElement = onRenderPage({
            page: page,
            className: 'ms-List-page',
            key: page.key,
            ref: function (newRef) {
                _this._pageRefs[page.key] = newRef;
            },
            style: pageStyle,
            role: 'presentation',
        }, this._onRenderPage);
        // cache the first page for now since it is re-rendered a lot times unnecessarily.
        // todo: a more aggresive caching mechanism is to cache pages constaining the items not changed.
        // now we re-render pages too frequently, for example, props.items increased from 30 to 60, although the
        // first 30 items did not change, we still re-rendered all of them in this props.items change.
        if (usePageCache && page.startIndex === 0) {
            this._pageCache[page.key] = {
                page: page,
                pageElement: pageElement,
            };
        }
        return pageElement;
    };
    /** Generate the style object for the page. */
    List.prototype._getPageStyle = function (page) {
        var getPageStyle = this.props.getPageStyle;
        return __assign$2(__assign$2({}, (getPageStyle ? getPageStyle(page) : {})), (!page.items
            ? {
                height: page.height,
            }
            : {}));
    };
    /** Track the last item index focused so that we ensure we keep it rendered. */
    List.prototype._onFocus = function (ev) {
        var target = ev.target;
        while (target !== this._surface.current) {
            var indexString = target.getAttribute('data-list-index');
            if (indexString) {
                this._focusedIndex = Number(indexString);
                break;
            }
            target = getParent$1(target);
        }
    };
    /**
     * Called synchronously to reset the required render range to 0 on scrolling. After async scroll has executed,
     * we will call onAsyncIdle which will reset it back to it's correct value.
     */
    List.prototype._onScroll = function () {
        if (!this.state.isScrolling && !this.props.ignoreScrollingState) {
            this.setState({ isScrolling: true });
        }
        this._resetRequiredWindows();
        this._onScrollingDoneDebounced();
    };
    List.prototype._resetRequiredWindows = function () {
        this._requiredWindowsAhead = 0;
        this._requiredWindowsBehind = 0;
    };
    /**
     * Debounced method to asynchronously update the visible region on a scroll event.
     */
    List.prototype._onAsyncScroll = function () {
        this._updateRenderRects(this.props, this.state);
        // Only update pages when the visible rect falls outside of the materialized rect.
        if (!this._materializedRect || !_isContainedWithin(this._requiredRect, this._materializedRect)) {
            this.setState(this._updatePages(this.props, this.state));
        }
    };
    /**
     * This is an async debounced method that will try and increment the windows we render. If we can increment
     * either, we increase the amount we render and re-evaluate.
     */
    List.prototype._onAsyncIdle = function () {
        var _a = this.props, renderedWindowsAhead = _a.renderedWindowsAhead, renderedWindowsBehind = _a.renderedWindowsBehind;
        var _b = this, requiredWindowsAhead = _b._requiredWindowsAhead, requiredWindowsBehind = _b._requiredWindowsBehind;
        var windowsAhead = Math.min(renderedWindowsAhead, requiredWindowsAhead + 1);
        var windowsBehind = Math.min(renderedWindowsBehind, requiredWindowsBehind + 1);
        if (windowsAhead !== requiredWindowsAhead || windowsBehind !== requiredWindowsBehind) {
            // console.log('idling', windowsBehind, windowsAhead);
            this._requiredWindowsAhead = windowsAhead;
            this._requiredWindowsBehind = windowsBehind;
            this._updateRenderRects(this.props, this.state);
            this.setState(this._updatePages(this.props, this.state));
        }
        if (renderedWindowsAhead > windowsAhead || renderedWindowsBehind > windowsBehind) {
            // Async increment on next tick.
            this._onAsyncIdleDebounced();
        }
    };
    /**
     * Function to call when the list is done scrolling.
     * This function is debounced.
     */
    List.prototype._onScrollingDone = function () {
        if (!this.props.ignoreScrollingState) {
            this.setState({ isScrolling: false });
            this._onAsyncIdle();
        }
    };
    List.prototype._onAsyncResize = function () {
        this.forceUpdate();
    };
    List.prototype._updatePages = function (nextProps, previousState) {
        // console.log('updating pages');
        if (!this._requiredRect) {
            this._updateRenderRects(nextProps, previousState);
        }
        var newListState = this._buildPages(nextProps, previousState);
        var oldListPages = previousState.pages;
        this._notifyPageChanges(oldListPages, newListState.pages, this.props);
        return __assign$2(__assign$2(__assign$2({}, previousState), newListState), { pagesVersion: {} });
    };
    /**
     * Notify consumers that the rendered pages have changed
     * @param oldPages - The old pages
     * @param newPages - The new pages
     * @param props - The props to use
     */
    List.prototype._notifyPageChanges = function (oldPages, newPages, props) {
        var onPageAdded = props.onPageAdded, onPageRemoved = props.onPageRemoved;
        if (onPageAdded || onPageRemoved) {
            var renderedIndexes = {};
            for (var _i = 0, oldPages_1 = oldPages; _i < oldPages_1.length; _i++) {
                var page = oldPages_1[_i];
                if (page.items) {
                    renderedIndexes[page.startIndex] = page;
                }
            }
            for (var _a = 0, newPages_1 = newPages; _a < newPages_1.length; _a++) {
                var page = newPages_1[_a];
                if (page.items) {
                    if (!renderedIndexes[page.startIndex]) {
                        this._onPageAdded(page);
                    }
                    else {
                        delete renderedIndexes[page.startIndex];
                    }
                }
            }
            for (var index in renderedIndexes) {
                if (renderedIndexes.hasOwnProperty(index)) {
                    this._onPageRemoved(renderedIndexes[index]);
                }
            }
        }
    };
    List.prototype._updatePageMeasurements = function (pages) {
        var heightChanged = false;
        // when not in virtualize mode, we render all the items without page measurement
        if (!this._shouldVirtualize()) {
            return heightChanged;
        }
        for (var i = 0; i < pages.length; i++) {
            var page = pages[i];
            if (page.items) {
                heightChanged = this._measurePage(page) || heightChanged;
            }
        }
        return heightChanged;
    };
    /**
     * Given a page, measure its dimensions, update cache.
     * @returns True if the height has changed.
     */
    List.prototype._measurePage = function (page) {
        var hasChangedHeight = false;
        var pageElement = this._pageRefs[page.key];
        var cachedHeight = this._cachedPageHeights[page.startIndex];
        // console.log('   * measure attempt', page.startIndex, cachedHeight);
        if (pageElement &&
            this._shouldVirtualize() &&
            (!cachedHeight || cachedHeight.measureVersion !== this._measureVersion)) {
            var newClientRect = {
                width: pageElement.clientWidth,
                height: pageElement.clientHeight,
            };
            if (newClientRect.height || newClientRect.width) {
                hasChangedHeight = page.height !== newClientRect.height;
                // console.warn(' *** expensive page measure', page.startIndex, page.height, newClientRect.height);
                page.height = newClientRect.height;
                this._cachedPageHeights[page.startIndex] = {
                    height: newClientRect.height,
                    measureVersion: this._measureVersion,
                };
                this._estimatedPageHeight = Math.round((this._estimatedPageHeight * this._totalEstimates + newClientRect.height) / (this._totalEstimates + 1));
                this._totalEstimates++;
            }
        }
        return hasChangedHeight;
    };
    /** Called when a page has been added to the DOM. */
    List.prototype._onPageAdded = function (page) {
        var onPageAdded = this.props.onPageAdded;
        // console.log('page added', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageAdded) {
            onPageAdded(page);
        }
    };
    /** Called when a page has been removed from the DOM. */
    List.prototype._onPageRemoved = function (page) {
        var onPageRemoved = this.props.onPageRemoved;
        // console.log('  --- page removed', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageRemoved) {
            onPageRemoved(page);
        }
    };
    /** Build up the pages that should be rendered. */
    List.prototype._buildPages = function (props, state) {
        var renderCount = props.renderCount;
        var items = props.items, startIndex = props.startIndex, getPageHeight = props.getPageHeight;
        renderCount = this._getRenderCount(props);
        var materializedRect = __assign$2({}, EMPTY_RECT);
        var pages = [];
        var itemsPerPage = 1;
        var pageTop = 0;
        var currentSpacer = null;
        var focusedIndex = this._focusedIndex;
        var endIndex = startIndex + renderCount;
        var shouldVirtualize = this._shouldVirtualize(props);
        // First render is very important to track; when we render cells, we have no idea of estimated page height.
        // So we should default to rendering only the first page so that we can get information.
        // However if the user provides a measure function, let's just assume they know the right heights.
        var isFirstRender = this._estimatedPageHeight === 0 && !getPageHeight;
        var allowedRect = this._allowedRect;
        var _loop_1 = function (itemIndex) {
            var pageSpecification = this_1._getPageSpecification(props, itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            var pageData = pageSpecification.data;
            var key = pageSpecification.key;
            itemsPerPage = pageSpecification.itemCount;
            var pageBottom = pageTop + pageHeight - 1;
            var isPageRendered = findIndex(state.pages, function (page) { return !!page.items && page.startIndex === itemIndex; }) > -1;
            var isPageInAllowedRange = !allowedRect || (pageBottom >= allowedRect.top && pageTop <= allowedRect.bottom);
            var isPageInRequiredRange = !this_1._requiredRect || (pageBottom >= this_1._requiredRect.top && pageTop <= this_1._requiredRect.bottom);
            var isPageVisible = (!isFirstRender && (isPageInRequiredRange || (isPageInAllowedRange && isPageRendered))) || !shouldVirtualize;
            var isPageFocused = focusedIndex >= itemIndex && focusedIndex < itemIndex + itemsPerPage;
            var isFirstPage = itemIndex === startIndex;
            // Only render whats visible, focused, or first page,
            // or when running in fast rendering mode (not in virtualized mode), we render all current items in pages
            if (isPageVisible || isPageFocused || isFirstPage) {
                if (currentSpacer) {
                    pages.push(currentSpacer);
                    currentSpacer = null;
                }
                var itemsInPage = Math.min(itemsPerPage, endIndex - itemIndex);
                var newPage = this_1._createPage(key, items.slice(itemIndex, itemIndex + itemsInPage), itemIndex, undefined, undefined, pageData);
                newPage.top = pageTop;
                newPage.height = pageHeight;
                if (this_1._visibleRect && this_1._visibleRect.bottom) {
                    newPage.isVisible = pageBottom >= this_1._visibleRect.top && pageTop <= this_1._visibleRect.bottom;
                }
                pages.push(newPage);
                if (isPageInRequiredRange && this_1._allowedRect) {
                    _mergeRect(materializedRect, {
                        top: pageTop,
                        bottom: pageBottom,
                        height: pageHeight,
                        left: allowedRect.left,
                        right: allowedRect.right,
                        width: allowedRect.width,
                    });
                }
            }
            else {
                if (!currentSpacer) {
                    currentSpacer = this_1._createPage(SPACER_KEY_PREFIX + itemIndex, undefined, itemIndex, 0, undefined, pageData, true /*isSpacer*/);
                }
                currentSpacer.height = (currentSpacer.height || 0) + (pageBottom - pageTop) + 1;
                currentSpacer.itemCount += itemsPerPage;
            }
            pageTop += pageBottom - pageTop + 1;
            // in virtualized mode, we render need to render first page then break and measure,
            // otherwise, we render all items without measurement to make rendering fast
            if (isFirstRender && shouldVirtualize) {
                return "break";
            }
        };
        var this_1 = this;
        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
            var state_1 = _loop_1(itemIndex);
            if (state_1 === "break")
                break;
        }
        if (currentSpacer) {
            currentSpacer.key = SPACER_KEY_PREFIX + 'end';
            pages.push(currentSpacer);
        }
        this._materializedRect = materializedRect;
        // console.log('materialized: ', materializedRect);
        return __assign$2(__assign$2({}, state), { pages: pages, measureVersion: this._measureVersion });
    };
    List.prototype._getPageSpecification = function (props, itemIndex, visibleRect) {
        var getPageSpecification = props.getPageSpecification;
        if (getPageSpecification) {
            var pageData = getPageSpecification(itemIndex, visibleRect, props.items);
            var _a = pageData.itemCount, itemCount = _a === undefined ? this._getItemCountForPage(itemIndex, visibleRect) : _a;
            var _b = pageData.height, height = _b === undefined ? this._getPageHeight(itemIndex, visibleRect, itemCount) : _b;
            return {
                itemCount: itemCount,
                height: height,
                data: pageData.data,
                key: pageData.key,
            };
        }
        else {
            var itemCount = this._getItemCountForPage(itemIndex, visibleRect);
            return {
                itemCount: itemCount,
                height: this._getPageHeight(itemIndex, visibleRect, itemCount),
            };
        }
    };
    /**
     * Get the pixel height of a give page. Will use the props getPageHeight first, and if not provided, fallback to
     * cached height, or estimated page height, or default page height.
     */
    List.prototype._getPageHeight = function (itemIndex, visibleRect, itemsPerPage) {
        if (this.props.getPageHeight) {
            return this.props.getPageHeight(itemIndex, visibleRect, itemsPerPage, this.props.items);
        }
        else {
            var cachedHeight = this._cachedPageHeights[itemIndex];
            return cachedHeight ? cachedHeight.height : this._estimatedPageHeight || DEFAULT_PAGE_HEIGHT;
        }
    };
    List.prototype._getItemCountForPage = function (itemIndex, visibileRect) {
        var itemsPerPage = this.props.getItemCountForPage
            ? this.props.getItemCountForPage(itemIndex, visibileRect)
            : DEFAULT_ITEMS_PER_PAGE;
        return itemsPerPage ? itemsPerPage : DEFAULT_ITEMS_PER_PAGE;
    };
    List.prototype._createPage = function (pageKey, items, startIndex, count, style, data, isSpacer) {
        if (startIndex === undefined) { startIndex = -1; }
        if (count === undefined) { count = items ? items.length : 0; }
        if (style === undefined) { style = {}; }
        pageKey = pageKey || PAGE_KEY_PREFIX + startIndex;
        var cachedPage = this._pageCache[pageKey];
        if (cachedPage && cachedPage.page) {
            return cachedPage.page;
        }
        return {
            key: pageKey,
            startIndex: startIndex,
            itemCount: count,
            items: items,
            style: style,
            top: 0,
            height: 0,
            data: data,
            isSpacer: isSpacer || false,
        };
    };
    List.prototype._getRenderCount = function (props) {
        var _a = props || this.props, items = _a.items, startIndex = _a.startIndex, renderCount = _a.renderCount;
        return renderCount === undefined ? (items ? items.length - startIndex : 0) : renderCount;
    };
    /** Calculate the visible rect within the list where top: 0 and left: 0 is the top/left of the list. */
    List.prototype._updateRenderRects = function (props, state, forceUpdate) {
        var renderedWindowsAhead = props.renderedWindowsAhead, renderedWindowsBehind = props.renderedWindowsBehind;
        var pages = state.pages;
        // when not in virtualize mode, we render all items without measurement to optimize page rendering perf
        if (!this._shouldVirtualize(props)) {
            return;
        }
        var surfaceRect = this._surfaceRect || __assign$2({}, EMPTY_RECT);
        var scrollHeight = getScrollHeight(this._scrollElement);
        var scrollTop = getScrollYPosition(this._scrollElement);
        // WARNING: EXPENSIVE CALL! We need to know the surface top relative to the window.
        // This needs to be called to recalculate when new pages should be loaded.
        // We check to see how far we've scrolled and if it's further than a third of a page we run it again.
        if (this._surface.current &&
            (forceUpdate ||
                !pages ||
                !this._surfaceRect ||
                !scrollHeight ||
                scrollHeight !== this._scrollHeight ||
                Math.abs(this._scrollTop - scrollTop) > this._estimatedPageHeight * SCROLL_RATIO)) {
            surfaceRect = this._surfaceRect = _measureSurfaceRect(this._surface.current);
            this._scrollTop = scrollTop;
        }
        // If the scroll height has changed, something in the container likely resized and
        // we should redo the page heights incase their content resized.
        if (forceUpdate || !scrollHeight || scrollHeight !== this._scrollHeight) {
            this._measureVersion++;
        }
        this._scrollHeight = scrollHeight || 0;
        // If the surface is above the container top or below the container bottom, or if this is not the first
        // render return empty rect.
        // The first time the list gets rendered we need to calculate the rectangle. The width of the list is
        // used to calculate the width of the list items.
        var visibleTop = Math.max(0, -surfaceRect.top);
        var win = getWindow$2(this._root.current);
        var visibleRect = {
            top: visibleTop,
            left: surfaceRect.left,
            bottom: visibleTop + win.innerHeight,
            right: surfaceRect.right,
            width: surfaceRect.width,
            height: win.innerHeight,
        };
        // The required/allowed rects are adjusted versions of the visible rect.
        this._requiredRect = _expandRect(visibleRect, this._requiredWindowsBehind, this._requiredWindowsAhead);
        this._allowedRect = _expandRect(visibleRect, renderedWindowsBehind, renderedWindowsAhead);
        // store the visible rect for later use.
        this._visibleRect = visibleRect;
    };
    List.defaultProps = {
        startIndex: 0,
        onRenderCell: function (item, index, containsFocus) { return React.createElement(React.Fragment, null, (item && item.name) || ''); },
        onRenderCellConditional: undefined,
        renderedWindowsAhead: DEFAULT_RENDERED_WINDOWS_AHEAD,
        renderedWindowsBehind: DEFAULT_RENDERED_WINDOWS_BEHIND,
    };
    List.contextType = WindowContext;
    return List;
}(React.Component));
function _expandRect(rect, pagesBefore, pagesAfter) {
    var top = rect.top - pagesBefore * rect.height;
    var height = rect.height + (pagesBefore + pagesAfter) * rect.height;
    return {
        top: top,
        bottom: top + height,
        height: height,
        left: rect.left,
        right: rect.right,
        width: rect.width,
    };
}
function _isContainedWithin(innerRect, outerRect) {
    return (innerRect.top >= outerRect.top &&
        innerRect.left >= outerRect.left &&
        innerRect.bottom <= outerRect.bottom &&
        innerRect.right <= outerRect.right);
}
function _mergeRect(targetRect, newRect) {
    targetRect.top = newRect.top < targetRect.top || targetRect.top === -1 ? newRect.top : targetRect.top;
    targetRect.left = newRect.left < targetRect.left || targetRect.left === -1 ? newRect.left : targetRect.left;
    targetRect.bottom =
        newRect.bottom > targetRect.bottom || targetRect.bottom === -1 ? newRect.bottom : targetRect.bottom;
    targetRect.right = newRect.right > targetRect.right || targetRect.right === -1 ? newRect.right : targetRect.right;
    targetRect.width = targetRect.right - targetRect.left + 1;
    targetRect.height = targetRect.bottom - targetRect.top + 1;
    return targetRect;
}

/**
 * Possible variations of the spinner circle size.
 * {@docCategory Spinner}
 */
var SpinnerSize;
(function (SpinnerSize) {
    /**
     * 12px Spinner diameter
     */
    SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
    /**
     * 16px Spinner diameter
     */
    SpinnerSize[SpinnerSize["small"] = 1] = "small";
    /**
     * 20px Spinner diameter
     */
    SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
    /**
     * 28px Spinner diameter
     */
    SpinnerSize[SpinnerSize["large"] = 3] = "large";
})(SpinnerSize || (SpinnerSize = {}));
/**
 * @deprecated Use `SpinnerSize` instead. Will be removed at \>= 2.0.0.
 * {@docCategory Spinner}
 */
var SpinnerType;
(function (SpinnerType) {
    /**
     * @deprecated Use `SpinnerSize.medium` instead. Will be removed at \>= 2.0.0.
     */
    SpinnerType[SpinnerType["normal"] = 0] = "normal";
    /**
     * @deprecated Use `SpinnerSize.large` instead. Will be removed at \>= 2.0.0.
     */
    SpinnerType[SpinnerType["large"] = 1] = "large";
})(SpinnerType || (SpinnerType = {}));

var getClassNames$e = classNamesFunction();
var SpinnerBase = /** @class */ (function (_super) {
    __extends$1(SpinnerBase, _super);
    function SpinnerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerBase.prototype.render = function () {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var _a = this.props, type = _a.type, size = _a.size, ariaLabel = _a.ariaLabel, ariaLive = _a.ariaLive, styles = _a.styles, label = _a.label, theme = _a.theme, className = _a.className, labelPosition = _a.labelPosition;
        var statusMessage = ariaLabel;
        var nativeProps = getNativeProps$1(this.props, divProperties, ['size']);
        // SpinnerType is deprecated. If someone is still using this property, rather than putting the SpinnerType into the
        // ISpinnerStyleProps, we'll map SpinnerType to its equivalent SpinnerSize and pass that in. Once SpinnerType
        // finally goes away we should delete this.
        var styleSize = size;
        if (styleSize === undefined && type !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            styleSize = type === SpinnerType.large ? SpinnerSize.large : SpinnerSize.medium;
        }
        var classNames = getClassNames$e(styles, {
            theme: theme,
            size: styleSize,
            className: className,
            labelPosition: labelPosition,
        });
        return (React.createElement("div", __assign$2({}, nativeProps, { className: classNames.root }),
            React.createElement("div", { className: classNames.circle }),
            label && React.createElement("div", { className: classNames.label }, label),
            statusMessage && (React.createElement("div", { role: "status", "aria-live": ariaLive },
                React.createElement(DelayedRender, null,
                    React.createElement("div", { className: classNames.screenReaderText }, statusMessage))))));
    };
    SpinnerBase.defaultProps = {
        size: SpinnerSize.medium,
        ariaLive: 'polite',
        labelPosition: 'bottom',
    };
    return SpinnerBase;
}(React.Component));

var GlobalClassNames$8 = {
    root: 'ms-Spinner',
    circle: 'ms-Spinner-circle',
    label: 'ms-Spinner-label',
};
var spinAnimation = memoizeFunction(function () {
    return keyframes({
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(360deg)',
        },
    });
});
var getStyles$b = function (props) {
    var _a;
    var theme = props.theme, size = props.size, className = props.className, labelPosition = props.labelPosition;
    var palette = theme.palette;
    var classNames = getGlobalClassNames(GlobalClassNames$8, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            },
            labelPosition === 'top' && {
                flexDirection: 'column-reverse',
            },
            labelPosition === 'right' && {
                flexDirection: 'row',
            },
            labelPosition === 'left' && {
                flexDirection: 'row-reverse',
            },
            className,
        ],
        circle: [
            classNames.circle,
            {
                boxSizing: 'border-box',
                borderRadius: '50%',
                borderWidth: '1.5px',
                borderStyle: 'solid',
                borderTopColor: palette.themePrimary,
                borderRightColor: palette.themeLight,
                borderBottomColor: palette.themeLight,
                borderLeftColor: palette.themeLight,
                animationName: spinAnimation(),
                animationDuration: '1.3s',
                animationIterationCount: 'infinite',
                animationTimingFunction: 'cubic-bezier(.53,.21,.29,.67)',
                selectors: (_a = {},
                    _a[HighContrastSelector] = __assign$2({ borderTopColor: 'Highlight' }, getHighContrastNoAdjustStyle()),
                    _a),
            },
            size === SpinnerSize.xSmall && [
                'ms-Spinner--xSmall',
                {
                    width: 12,
                    height: 12,
                },
            ],
            size === SpinnerSize.small && [
                'ms-Spinner--small',
                {
                    width: 16,
                    height: 16,
                },
            ],
            size === SpinnerSize.medium && [
                'ms-Spinner--medium',
                {
                    width: 20,
                    height: 20,
                },
            ],
            size === SpinnerSize.large && [
                'ms-Spinner--large',
                {
                    width: 28,
                    height: 28,
                },
            ],
        ],
        label: [
            classNames.label,
            theme.fonts.small,
            {
                color: palette.themePrimary,
                margin: '8px 0 0',
                textAlign: 'center',
            },
            labelPosition === 'top' && {
                margin: '0 0 8px',
            },
            labelPosition === 'right' && {
                margin: '0 0 0 8px',
            },
            labelPosition === 'left' && {
                margin: '0 8px 0 0',
            },
        ],
        screenReaderText: hiddenContentStyle,
    };
};

var Spinner = styled(SpinnerBase, getStyles$b, undefined, { scope: 'Spinner' });

/**
 * {@docCategory Dialog}
 */
var DialogType;
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(DialogType || (DialogType = {}));

var animationDuration = AnimationVariables.durationValue2;
var globalClassNames$2 = {
  root: "ms-Modal",
  main: "ms-Dialog-main",
  scrollableContent: "ms-Modal-scrollableContent",
  isOpen: "is-open",
  layer: "ms-Modal-Layer"
};
var getStyles$a = function(props) {
  var _a;
  var className = props.className, containerClassName = props.containerClassName, scrollableContentClassName = props.scrollableContentClassName, isOpen = props.isOpen, isVisible = props.isVisible, hasBeenOpened = props.hasBeenOpened, modalRectangleTop = props.modalRectangleTop, theme = props.theme, topOffsetFixed = props.topOffsetFixed, isModeless = props.isModeless, layerClassName = props.layerClassName, isDefaultDragHandle = props.isDefaultDragHandle, windowInnerHeight = props.windowInnerHeight;
  var palette = theme.palette, effects = theme.effects, fonts = theme.fonts;
  var classNames = getGlobalClassNames(globalClassNames$2, theme);
  return {
    root: [
      classNames.root,
      fonts.medium,
      {
        backgroundColor: "transparent",
        position: "fixed",
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0,
        pointerEvents: "none",
        transition: "opacity ".concat(animationDuration)
      },
      topOffsetFixed && typeof modalRectangleTop === "number" && hasBeenOpened && {
        alignItems: "flex-start"
      },
      isOpen && classNames.isOpen,
      isVisible && {
        opacity: 1
      },
      isVisible && !isModeless && {
        pointerEvents: "auto"
      },
      className
    ],
    main: [
      classNames.main,
      {
        boxShadow: effects.elevation64,
        borderRadius: effects.roundedCorner2,
        backgroundColor: palette.white,
        boxSizing: "border-box",
        position: "relative",
        textAlign: "left",
        outline: "3px solid transparent",
        maxHeight: "calc(100% - 32px)",
        maxWidth: "calc(100% - 32px)",
        minHeight: "176px",
        minWidth: "288px",
        overflowY: "auto",
        zIndex: isModeless ? ZIndexes.Layer : undefined
      },
      isModeless && {
        pointerEvents: "auto"
      },
      topOffsetFixed && typeof modalRectangleTop === "number" && hasBeenOpened && {
        top: modalRectangleTop
      },
      isDefaultDragHandle && {
        cursor: "move"
      },
      containerClassName
    ],
    scrollableContent: [
      classNames.scrollableContent,
      {
        overflowY: "auto",
        flexGrow: 1,
        maxHeight: "100vh",
        selectors: (_a = {}, _a["@supports (-webkit-overflow-scrolling: touch)"] = {
          maxHeight: windowInnerHeight
        }, _a)
      },
      scrollableContentClassName
    ],
    layer: isModeless && [layerClassName, classNames.layer, { pointerEvents: "none" }],
    keyboardMoveIconContainer: {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      width: "100%",
      padding: "3px 0px"
    },
    keyboardMoveIcon: {
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      fontSize: fonts.xLargePlus.fontSize,
      width: "24px"
    }
  };
};

var getClassNames$d = classNamesFunction();
var OverlayBase = /** @class */ (function (_super) {
    __extends$1(OverlayBase, _super);
    function OverlayBase(props) {
        var _this = _super.call(this, props) || this;
        initializeComponentRef(_this);
        var _a = _this.props.allowTouchBodyScroll, allowTouchBodyScroll = _a === undefined ? false : _a;
        _this._allowTouchBodyScroll = allowTouchBodyScroll;
        return _this;
    }
    OverlayBase.prototype.componentDidMount = function () {
        !this._allowTouchBodyScroll && disableBodyScroll();
    };
    OverlayBase.prototype.componentWillUnmount = function () {
        !this._allowTouchBodyScroll && enableBodyScroll();
    };
    OverlayBase.prototype.render = function () {
        var _a = this.props, isDark = _a.isDarkThemed, className = _a.className, theme = _a.theme, styles = _a.styles;
        var divProps = getNativeProps$1(this.props, divProperties);
        var classNames = getClassNames$d(styles, {
            theme: theme,
            className: className,
            isDark: isDark,
        });
        return React.createElement("div", __assign$2({}, divProps, { className: classNames.root }));
    };
    return OverlayBase;
}(React.Component));

var GlobalClassNames$7 = {
    root: 'ms-Overlay',
    rootDark: 'ms-Overlay--dark',
};
var getStyles$9 = function (props) {
    var _a;
    var className = props.className, theme = props.theme, isNone = props.isNone, isDark = props.isDark;
    var palette = theme.palette;
    var classNames = getGlobalClassNames(GlobalClassNames$7, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                backgroundColor: palette.whiteTranslucent40,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                position: 'absolute',
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        border: '1px solid WindowText',
                        opacity: 0,
                    },
                    _a),
            },
            isNone && {
                visibility: 'hidden',
            },
            isDark && [
                classNames.rootDark,
                {
                    backgroundColor: palette.blackTranslucent40,
                },
            ],
            className,
        ],
    };
};

var Overlay = styled(OverlayBase, getStyles$9, undefined, {
    scope: 'Overlay',
});

var getClassNames$c = memoizeFunction(function (className, isDragging) {
    return {
        root: mergeStyles(className, isDragging && {
            touchAction: 'none',
            selectors: {
                '& *': {
                    userSelect: 'none',
                },
            },
        }),
    };
});

var eventMapping = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend',
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup',
    },
};
var DraggableZone = /** @class */ (function (_super) {
    __extends$1(DraggableZone, _super);
    function DraggableZone(props) {
        var _this = _super.call(this, props) || this;
        _this._currentEventType = eventMapping.mouse;
        _this._events = [];
        _this._onMouseDown = function (event) {
            var onMouseDown = React.Children.only(_this.props.children).props.onMouseDown;
            if (onMouseDown) {
                onMouseDown(event);
            }
            _this._currentEventType = eventMapping.mouse;
            return _this._onDragStart(event);
        };
        _this._onMouseUp = function (event) {
            var onMouseUp = React.Children.only(_this.props.children).props.onMouseUp;
            if (onMouseUp) {
                onMouseUp(event);
            }
            _this._currentEventType = eventMapping.mouse;
            return _this._onDragStop(event);
        };
        _this._onTouchStart = function (event) {
            var onTouchStart = React.Children.only(_this.props.children).props.onTouchStart;
            if (onTouchStart) {
                onTouchStart(event);
            }
            _this._currentEventType = eventMapping.touch;
            return _this._onDragStart(event);
        };
        _this._onTouchEnd = function (event) {
            var onTouchEnd = React.Children.only(_this.props.children).props.onTouchEnd;
            if (onTouchEnd) {
                onTouchEnd(event);
            }
            _this._currentEventType = eventMapping.touch;
            _this._onDragStop(event);
        };
        _this._onDragStart = function (event) {
            // Only handle left click for dragging
            if (typeof event.button === 'number' && event.button !== 0) {
                return false;
            }
            // If the target doesn't match the handleSelector OR
            // if the target does match the preventDragSelector, bail out
            if ((_this.props.handleSelector && !_this._matchesSelector(event.target, _this.props.handleSelector)) ||
                (_this.props.preventDragSelector &&
                    _this._matchesSelector(event.target, _this.props.preventDragSelector))) {
                return;
            }
            // Remember the touch identifier if this is a touch event so we can
            // distinguish between individual touches in multitouch scenarios
            // by remembering which touch point we were given
            _this._touchId = _this._getTouchId(event);
            var position = _this._getControlPosition(event);
            if (position === undefined) {
                return;
            }
            var dragData = _this._createDragDataFromPosition(position);
            _this.props.onStart && _this.props.onStart(event, dragData);
            _this.setState({
                isDragging: true,
                lastPosition: position,
            });
            // hook up the appropriate mouse/touch events to the body to ensure
            // smooth dragging
            var doc = getDocumentEx(_this.context);
            _this._events = [
                on(doc.body, _this._currentEventType.move, _this._onDrag, true /* use capture phase */),
                on(doc.body, _this._currentEventType.stop, _this._onDragStop, true /* use capture phase */),
            ];
        };
        _this._onDrag = function (event) {
            // Prevent scrolling on mobile devices
            if (event.type === 'touchmove') {
                event.preventDefault();
            }
            var position = _this._getControlPosition(event);
            if (!position) {
                return;
            }
            // create the updated drag data from the position data
            var updatedData = _this._createUpdatedDragData(_this._createDragDataFromPosition(position));
            var updatedPosition = updatedData.position;
            _this.props.onDragChange && _this.props.onDragChange(event, updatedData);
            _this.setState({
                position: updatedPosition,
                lastPosition: position,
            });
        };
        _this._onDragStop = function (event) {
            if (!_this.state.isDragging) {
                return;
            }
            var position = _this._getControlPosition(event);
            if (!position) {
                return;
            }
            var baseDragData = _this._createDragDataFromPosition(position);
            // Set dragging to false and reset the lastPosition
            _this.setState({
                isDragging: false,
                lastPosition: undefined,
            });
            _this.props.onStop && _this.props.onStop(event, baseDragData);
            if (_this.props.position) {
                _this.setState({
                    position: _this.props.position,
                });
            }
            // Remove event handlers
            _this._events.forEach(function (dispose) { return dispose(); });
        };
        _this.state = {
            isDragging: false,
            position: _this.props.position || { x: 0, y: 0 },
            lastPosition: undefined,
        };
        return _this;
    }
    DraggableZone.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.position && (!prevProps.position || this.props.position !== prevProps.position)) {
            this.setState({ position: this.props.position });
        }
    };
    DraggableZone.prototype.componentWillUnmount = function () {
        this._events.forEach(function (dispose) { return dispose(); });
    };
    DraggableZone.prototype.render = function () {
        var child = React.Children.only(this.props.children);
        var props = child.props;
        var position = this.props.position;
        var _a = this.state, statePosition = _a.position, isDragging = _a.isDragging;
        var x = statePosition.x;
        var y = statePosition.y;
        if (position && !isDragging) {
            x = position.x;
            y = position.y;
        }
        return React.cloneElement(child, {
            style: __assign$2(__assign$2({}, props.style), { transform: "translate(".concat(x, "px, ").concat(y, "px)") }),
            className: getClassNames$c(props.className, this.state.isDragging).root,
            onMouseDown: this._onMouseDown,
            onMouseUp: this._onMouseUp,
            onTouchStart: this._onTouchStart,
            onTouchEnd: this._onTouchEnd,
        });
    };
    /**
     * Get the control position based off the event that fired
     * @param event - The event to get offsets from
     */
    DraggableZone.prototype._getControlPosition = function (event) {
        var touchObj = this._getActiveTouch(event);
        // did we get the right touch?
        if (this._touchId !== undefined && !touchObj) {
            return undefined;
        }
        var eventToGetOffset = touchObj || event;
        return {
            x: eventToGetOffset.clientX,
            y: eventToGetOffset.clientY,
        };
    };
    /**
     * Get the active touch point that we have saved from the event's TouchList
     * @param event - The event used to get the TouchList for the active touch point
     */
    DraggableZone.prototype._getActiveTouch = function (event) {
        return ((event.targetTouches && this._findTouchInTouchList(event.targetTouches)) ||
            (event.changedTouches && this._findTouchInTouchList(event.changedTouches)));
    };
    /**
     * Get the initial touch identifier associated with the given event
     * @param event - The event that contains the TouchList
     */
    DraggableZone.prototype._getTouchId = function (event) {
        var touch = (event.targetTouches && event.targetTouches[0]) || (event.changedTouches && event.changedTouches[0]);
        if (touch) {
            return touch.identifier;
        }
    };
    /**
     * Returns if an element (or any of the element's parents) match the given selector
     */
    DraggableZone.prototype._matchesSelector = function (element, selector) {
        var _a;
        if (!element || element === ((_a = getDocumentEx(this.context)) === null || _a === undefined ? undefined : _a.body)) {
            return false;
        }
        var matchesSelectorFn = 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        element.matches || element.webkitMatchesSelector || element.msMatchesSelector; /* for IE */
        if (!matchesSelectorFn) {
            return false;
        }
        return matchesSelectorFn.call(element, selector) || this._matchesSelector(element.parentElement, selector);
    };
    /**
     * Attempts to find the Touch that matches the identifier  we stored in dragStart
     * @param touchList The TouchList to look for the stored identifier from dragStart
     */
    DraggableZone.prototype._findTouchInTouchList = function (touchList) {
        if (this._touchId === undefined) {
            return;
        }
        for (var i = 0; i < touchList.length; i++) {
            if (touchList[i].identifier === this._touchId) {
                return touchList[i];
            }
        }
        return undefined;
    };
    /**
     * Create DragData based off of the last known position and the new position passed in
     * @param position The new position as part of the drag
     */
    DraggableZone.prototype._createDragDataFromPosition = function (position) {
        var lastPosition = this.state.lastPosition;
        // If we have no lastPosition, use the given position
        // for last position
        if (lastPosition === undefined) {
            return {
                delta: { x: 0, y: 0 },
                lastPosition: position,
                position: position,
            };
        }
        return {
            delta: {
                x: position.x - lastPosition.x,
                y: position.y - lastPosition.y,
            },
            lastPosition: lastPosition,
            position: position,
        };
    };
    /**
     * Creates an updated DragData based off the current position and given baseDragData
     * @param baseDragData The base DragData (from _createDragDataFromPosition) used to calculate the updated positions
     */
    DraggableZone.prototype._createUpdatedDragData = function (baseDragData) {
        var position = this.state.position;
        return {
            position: {
                x: position.x + baseDragData.delta.x,
                y: position.y + baseDragData.delta.y,
            },
            delta: baseDragData.delta,
            lastPosition: position,
        };
    };
    DraggableZone.contextType = WindowContext;
    return DraggableZone;
}(React.Component));

var ZERO = { x: 0, y: 0 };
var DEFAULT_PROPS = {
  isOpen: false,
  isDarkOverlay: true,
  className: "",
  containerClassName: "",
  enableAriaHiddenSiblings: true
};
var getClassNames$b = classNamesFunction();
var getMoveDelta = function(ev) {
  var delta = 10;
  if (ev.shiftKey) {
    if (!ev.ctrlKey) {
      delta = 50;
    }
  } else if (ev.ctrlKey) {
    delta = 1;
  }
  return delta;
};
var useComponentRef$3 = function(props, focusTrapZone) {
  React.useImperativeHandle(props.componentRef, function() {
    return {
      focus: function() {
        if (focusTrapZone.current) {
          focusTrapZone.current.focus();
        }
      }
    };
  }, [focusTrapZone]);
};
var ModalBase = React.forwardRef(function(propsWithoutDefaults, ref) {
  var _a, _b, _c, _d, _e;
  var props = getPropsWithDefaults(DEFAULT_PROPS, propsWithoutDefaults);
  var allowTouchBodyScroll = props.allowTouchBodyScroll, className = props.className, children = props.children, containerClassName = props.containerClassName, scrollableContentClassName = props.scrollableContentClassName, elementToFocusOnDismiss = props.elementToFocusOnDismiss, firstFocusableSelector = props.firstFocusableSelector, focusTrapZoneProps = props.focusTrapZoneProps, forceFocusInsideTrap = props.forceFocusInsideTrap, _f = props.disableRestoreFocus, disableRestoreFocus = _f === undefined ? props.ignoreExternalFocusing : _f, isBlocking = props.isBlocking, isAlert = props.isAlert, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, isDarkOverlay = props.isDarkOverlay, onDismiss = props.onDismiss, layerProps = props.layerProps, overlay = props.overlay, isOpen = props.isOpen, titleAriaId = props.titleAriaId, styles = props.styles, subtitleAriaId = props.subtitleAriaId, theme = props.theme, topOffsetFixed = props.topOffsetFixed, responsiveMode = props.responsiveMode, onLayerDidMount = props.onLayerDidMount, isModeless = props.isModeless, dragOptions = props.dragOptions, onDismissed = props.onDismissed, enableAriaHiddenSiblings = props.enableAriaHiddenSiblings, popupProps = props.popupProps;
  var rootRef = React.useRef(null);
  var focusTrapZone = React.useRef(null);
  var focusTrapZoneRef = useMergedRefs$1(focusTrapZone, focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.componentRef);
  var focusTrapZoneElm = React.useRef(null);
  var mergedRef = useMergedRefs$1(rootRef, ref);
  var modalResponsiveMode = useResponsiveMode(mergedRef);
  var focusTrapZoneId = useId$1("ModalFocusTrapZone", focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.id);
  var win = useWindow();
  var _g = useSetTimeout(), setTimeout = _g.setTimeout, clearTimeout = _g.clearTimeout;
  var _h = React.useState(isOpen), isModalOpen = _h[0], setIsModalOpen = _h[1];
  var _j = React.useState(isOpen), isVisible = _j[0], setIsVisible = _j[1];
  var _k = React.useState(ZERO), coordinates = _k[0], setCoordinates = _k[1];
  var _l = React.useState(), modalRectangleTop = _l[0], setModalRectangleTop = _l[1];
  var _m = useBoolean(false), isModalMenuOpen = _m[0], _o = _m[1], toggleModalMenuOpen = _o.toggle, setModalMenuClose = _o.setFalse;
  var internalState = useConst(function() {
    return {
      onModalCloseTimer: 0,
      allowTouchBodyScroll,
      scrollableContent: null,
      lastSetCoordinates: ZERO,
      events: new EventGroup({})
    };
  });
  var keepInBounds = (dragOptions || {}).keepInBounds;
  var isAlertRole = isAlert !== null && isAlert !== undefined ? isAlert : isBlocking && !isModeless;
  var layerClassName = layerProps === undefined ? "" : layerProps.className;
  var classNames = getClassNames$b(styles, {
    theme,
    className,
    containerClassName,
    scrollableContentClassName,
    isOpen,
    isVisible,
    hasBeenOpened: internalState.hasBeenOpened,
    modalRectangleTop,
    topOffsetFixed,
    isModeless,
    layerClassName,
    windowInnerHeight: win === null || win === undefined ? undefined : win.innerHeight,
    isDefaultDragHandle: dragOptions && !dragOptions.dragHandleSelector
  });
  var mergedLayerProps = __assign$2(__assign$2({ eventBubblingEnabled: false }, layerProps), { onLayerDidMount: layerProps && layerProps.onLayerDidMount ? layerProps.onLayerDidMount : onLayerDidMount, insertFirst: (layerProps === null || layerProps === undefined ? undefined : layerProps.insertFirst) || isModeless, className: classNames.layer });
  var allowScrollOnModal = React.useCallback(function(elt) {
    if (elt) {
      if (internalState.allowTouchBodyScroll) {
        allowOverscrollOnElement(elt, internalState.events);
      } else {
        allowScrollOnElement(elt, internalState.events);
      }
    } else {
      internalState.events.off(internalState.scrollableContent);
    }
    internalState.scrollableContent = elt;
  }, [internalState]);
  var registerInitialModalPosition = function() {
    var dialogMain = focusTrapZoneElm.current;
    var modalRectangle = dialogMain === null || dialogMain === undefined ? undefined : dialogMain.getBoundingClientRect();
    if (modalRectangle) {
      if (topOffsetFixed) {
        setModalRectangleTop(modalRectangle.top);
      }
      if (keepInBounds) {
        internalState.minPosition = { x: -modalRectangle.left, y: -modalRectangle.top };
        internalState.maxPosition = { x: modalRectangle.left, y: modalRectangle.top };
      }
    }
  };
  var getClampedAxis = React.useCallback(function(axis, position) {
    var minPosition = internalState.minPosition, maxPosition = internalState.maxPosition;
    if (keepInBounds && minPosition && maxPosition) {
      position = Math.max(minPosition[axis], position);
      position = Math.min(maxPosition[axis], position);
    }
    return position;
  }, [keepInBounds, internalState]);
  var handleModalClose = function() {
    var _a2;
    internalState.lastSetCoordinates = ZERO;
    setModalMenuClose();
    internalState.isInKeyboardMoveMode = false;
    setIsModalOpen(false);
    setCoordinates(ZERO);
    (_a2 = internalState.disposeOnKeyUp) === null || _a2 === undefined ? undefined : _a2.call(internalState);
    onDismissed === null || onDismissed === undefined ? undefined : onDismissed();
  };
  var handleDragStart = React.useCallback(function() {
    setModalMenuClose();
    internalState.isInKeyboardMoveMode = false;
  }, [internalState, setModalMenuClose]);
  var handleDrag = React.useCallback(function(ev, dragData) {
    setCoordinates(function(prevValue) {
      return {
        x: getClampedAxis("x", prevValue.x + dragData.delta.x),
        y: getClampedAxis("y", prevValue.y + dragData.delta.y)
      };
    });
  }, [getClampedAxis]);
  var handleDragStop = React.useCallback(function() {
    if (focusTrapZone.current) {
      focusTrapZone.current.focus();
    }
  }, []);
  var handleEnterKeyboardMoveMode = function() {
    var handleKeyDown = function(ev) {
      if (ev.altKey && ev.ctrlKey && ev.keyCode === KeyCodes.space) {
        ev.preventDefault();
        ev.stopPropagation();
        return;
      }
      var newLocal = ev.altKey || ev.keyCode === KeyCodes.escape;
      if (isModalMenuOpen && newLocal) {
        setModalMenuClose();
      }
      if (internalState.isInKeyboardMoveMode && (ev.keyCode === KeyCodes.escape || ev.keyCode === KeyCodes.enter)) {
        internalState.isInKeyboardMoveMode = false;
        ev.preventDefault();
        ev.stopPropagation();
      }
      if (internalState.isInKeyboardMoveMode) {
        var handledEvent = true;
        var delta_1 = getMoveDelta(ev);
        switch (ev.keyCode) {
          case KeyCodes.escape:
            setCoordinates(internalState.lastSetCoordinates);
          case KeyCodes.enter: {
            internalState.lastSetCoordinates = ZERO;
            break;
          }
          case KeyCodes.up: {
            setCoordinates(function(prevValue) {
              return { x: prevValue.x, y: getClampedAxis("y", prevValue.y - delta_1) };
            });
            break;
          }
          case KeyCodes.down: {
            setCoordinates(function(prevValue) {
              return { x: prevValue.x, y: getClampedAxis("y", prevValue.y + delta_1) };
            });
            break;
          }
          case KeyCodes.left: {
            setCoordinates(function(prevValue) {
              return { x: getClampedAxis("x", prevValue.x - delta_1), y: prevValue.y };
            });
            break;
          }
          case KeyCodes.right: {
            setCoordinates(function(prevValue) {
              return { x: getClampedAxis("x", prevValue.x + delta_1), y: prevValue.y };
            });
            break;
          }
          default: {
            handledEvent = false;
          }
        }
        if (handledEvent) {
          ev.preventDefault();
          ev.stopPropagation();
        }
      }
    };
    internalState.lastSetCoordinates = coordinates;
    setModalMenuClose();
    internalState.isInKeyboardMoveMode = true;
    internalState.events.on(
      win,
      "keydown",
      handleKeyDown,
      true
      /* useCapture */
    );
    internalState.disposeOnKeyDown = function() {
      internalState.events.off(
        win,
        "keydown",
        handleKeyDown,
        true
        /* useCapture */
      );
      internalState.disposeOnKeyDown = undefined;
    };
  };
  var handleExitKeyboardMoveMode = function(ev) {
    var _a2, _b2;
    (_a2 = focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.onBlur) === null || _a2 === undefined ? undefined : _a2.call(focusTrapZoneProps, ev);
    internalState.lastSetCoordinates = ZERO;
    internalState.isInKeyboardMoveMode = false;
    (_b2 = internalState.disposeOnKeyDown) === null || _b2 === undefined ? undefined : _b2.call(internalState);
  };
  var registerForKeyUp = function() {
    var handleKeyUp = function(ev) {
      if (ev.altKey && ev.ctrlKey && ev.keyCode === KeyCodes.space) {
        if (elementContains$1(internalState.scrollableContent, ev.target)) {
          toggleModalMenuOpen();
          ev.preventDefault();
          ev.stopPropagation();
        }
      }
    };
    if (!internalState.disposeOnKeyUp) {
      internalState.events.on(
        win,
        "keyup",
        handleKeyUp,
        true
        /* useCapture */
      );
      internalState.disposeOnKeyUp = function() {
        internalState.events.off(
          win,
          "keyup",
          handleKeyUp,
          true
          /* useCapture */
        );
        internalState.disposeOnKeyUp = undefined;
      };
    }
  };
  React.useEffect(function() {
    clearTimeout(internalState.onModalCloseTimer);
    if (isOpen) {
      requestAnimationFrame(function() {
        return setTimeout(registerInitialModalPosition, 0);
      });
      setIsModalOpen(true);
      if (dragOptions) {
        registerForKeyUp();
      }
      internalState.hasBeenOpened = true;
      setIsVisible(true);
    }
    if (!isOpen && isModalOpen) {
      internalState.onModalCloseTimer = setTimeout(handleModalClose, parseFloat(animationDuration) * 1e3);
      setIsVisible(false);
    }
  }, [isModalOpen, isOpen]);
  useUnmount(function() {
    internalState.events.dispose();
    if (internalState.onModalCloseTimer) {
      clearTimeout(internalState.onModalCloseTimer);
      internalState.onModalCloseTimer = 0;
    }
  });
  useComponentRef$3(props, focusTrapZone);
  useDebugWarnings(props);
  var modalContent = React.createElement(
    FocusTrapZone,
    __assign$2({}, focusTrapZoneProps, {
      id: focusTrapZoneId,
      ref: focusTrapZoneElm,
      componentRef: focusTrapZoneRef,
      className: css(classNames.main, focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.className),
      elementToFocusOnDismiss: (_a = focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.elementToFocusOnDismiss) !== null && _a !== undefined ? _a : elementToFocusOnDismiss,
      isClickableOutsideFocusTrap: (_b = focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.isClickableOutsideFocusTrap) !== null && _b !== undefined ? _b : isModeless || isClickableOutsideFocusTrap || !isBlocking,
      disableRestoreFocus: (_c = focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.disableRestoreFocus) !== null && _c !== undefined ? _c : disableRestoreFocus,
      forceFocusInsideTrap: ((_d = focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.forceFocusInsideTrap) !== null && _d !== undefined ? _d : forceFocusInsideTrap) && !isModeless,
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      firstFocusableSelector: (focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.firstFocusableSelector) || firstFocusableSelector,
      focusPreviouslyFocusedInnerElement: (_e = focusTrapZoneProps === null || focusTrapZoneProps === undefined ? undefined : focusTrapZoneProps.focusPreviouslyFocusedInnerElement) !== null && _e !== undefined ? _e : true,
      onBlur: internalState.isInKeyboardMoveMode ? handleExitKeyboardMoveMode : undefined
    }),
    dragOptions && internalState.isInKeyboardMoveMode && React.createElement("div", { className: classNames.keyboardMoveIconContainer }, dragOptions.keyboardMoveIconProps ? React.createElement(Icon, __assign$2({}, dragOptions.keyboardMoveIconProps)) : React.createElement(Icon, { iconName: "move", className: classNames.keyboardMoveIcon })),
    React.createElement(
      "div",
      { ref: allowScrollOnModal, className: classNames.scrollableContent, "data-is-scrollable": true },
      dragOptions && isModalMenuOpen && React.createElement(dragOptions.menu, { items: [
        { key: "move", text: dragOptions.moveMenuItemText, onClick: handleEnterKeyboardMoveMode },
        { key: "close", text: dragOptions.closeMenuItemText, onClick: handleModalClose }
      ], onDismiss: setModalMenuClose, alignTargetEdge: true, coverTarget: true, directionalHint: DirectionalHint.topLeftEdge, directionalHintFixed: true, shouldFocusOnMount: true, target: internalState.scrollableContent }),
      children
    )
  );
  return isModalOpen && modalResponsiveMode >= (responsiveMode || ResponsiveMode.small) && React.createElement(
    Layer,
    __assign$2({ ref: mergedRef }, mergedLayerProps),
    React.createElement(
      Popup,
      __assign$2({
        role: isAlertRole ? "alertdialog" : "dialog",
        ariaLabelledBy: titleAriaId,
        ariaDescribedBy: subtitleAriaId,
        onDismiss,
        shouldRestoreFocus: !disableRestoreFocus,
        // Modeless modals shouldn't hide siblings.
        // Popup will automatically handle this based on the aria-modal setting.
        enableAriaHiddenSiblings,
        "aria-modal": !isModeless
      }, popupProps),
      React.createElement(
        "div",
        { className: classNames.root, role: !isModeless ? "document" : undefined },
        !isModeless && React.createElement(Overlay, __assign$2({ "aria-hidden": true, isDarkThemed: isDarkOverlay, onClick: isBlocking ? undefined : onDismiss, allowTouchBodyScroll }, overlay)),
        dragOptions ? React.createElement(DraggableZone, { handleSelector: dragOptions.dragHandleSelector || "#".concat(focusTrapZoneId), preventDragSelector: "button", onStart: handleDragStart, onDragChange: handleDrag, onStop: handleDragStop, position: coordinates }, modalContent) : modalContent
      )
    )
  ) || null;
});
ModalBase.displayName = "Modal";
function useDebugWarnings(props) {
  if (process.env.NODE_ENV !== "production") {
    useWarnings({
      name: "Modal",
      props,
      deprecations: { onLayerDidMount: "layerProps.onLayerDidMount" }
    });
  }
}

var Modal = styled(ModalBase, getStyles$a, undefined, {
    scope: 'Modal',
    fields: ['theme', 'styles', 'enableAriaHiddenSiblings'],
});
Modal.displayName = 'Modal';

var getClassNames$a = classNamesFunction();
var DialogFooterBase = /** @class */ (function (_super) {
    __extends$1(DialogFooterBase, _super);
    function DialogFooterBase(props) {
        var _this = _super.call(this, props) || this;
        initializeComponentRef(_this);
        return _this;
    }
    DialogFooterBase.prototype.render = function () {
        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
        this._classNames = getClassNames$a(styles, {
            theme: theme,
            className: className,
        });
        return (React.createElement("div", { className: this._classNames.actions },
            React.createElement("div", { className: this._classNames.actionsRight }, this._renderChildrenAsActions())));
    };
    DialogFooterBase.prototype._renderChildrenAsActions = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            return child ? React.createElement("span", { className: _this._classNames.action }, child) : null;
        });
    };
    return DialogFooterBase;
}(React.Component));

var GlobalClassNames$6 = {
    actions: 'ms-Dialog-actions',
    action: 'ms-Dialog-action',
    actionsRight: 'ms-Dialog-actionsRight',
};
var getStyles$8 = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$6, theme);
    return {
        actions: [
            classNames.actions,
            {
                position: 'relative',
                width: '100%',
                minHeight: '24px',
                lineHeight: '24px',
                margin: '16px 0 0',
                fontSize: '0',
                selectors: {
                    '.ms-Button': {
                        lineHeight: 'normal',
                        verticalAlign: 'middle',
                    },
                },
            },
            className,
        ],
        action: [
            classNames.action,
            {
                margin: '0 4px',
            },
        ],
        actionsRight: [
            classNames.actionsRight,
            {
                alignItems: 'center',
                display: 'flex',
                fontSize: '0',
                justifyContent: 'flex-end',
                marginRight: '-4px',
            },
        ],
    };
};

var DialogFooter = styled(DialogFooterBase, getStyles$8, undefined, { scope: 'DialogFooter' });
DialogFooter.displayName = 'DialogFooter';

var getClassNames$9 = classNamesFunction();
var DialogFooterType = (React.createElement(DialogFooter, null)).type;
var COMPONENT_NAME$5 = 'DialogContent';
// eslint-disable-next-line @typescript-eslint/no-deprecated
var DialogContentBase = /** @class */ (function (_super) {
    __extends$1(DialogContentBase, _super);
    function DialogContentBase(props) {
        var _this = _super.call(this, props) || this;
        initializeComponentRef(_this);
        warnDeprecations(COMPONENT_NAME$5, props, {
            titleId: 'titleProps.id',
        });
        return _this;
    }
    DialogContentBase.prototype.render = function () {
        var _a = this.props, showCloseButton = _a.showCloseButton, className = _a.className, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, _b = _a.titleProps, titleProps = _b === undefined ? {} : _b, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        titleId = _a.titleId, title = _a.title, type = _a.type, styles = _a.styles, theme = _a.theme, draggableHeaderClassName = _a.draggableHeaderClassName;
        var classNames = getClassNames$9(styles, {
            theme: theme,
            className: className,
            isLargeHeader: type === DialogType.largeHeader,
            isClose: type === DialogType.close,
            draggableHeaderClassName: draggableHeaderClassName,
        });
        var groupings = this._groupChildren();
        var subTextContent;
        if (subText) {
            subTextContent = (React.createElement("p", { className: classNames.subText, id: subTextId }, subText));
        }
        return (React.createElement("div", { className: classNames.content },
            React.createElement("div", { className: classNames.header },
                React.createElement("div", __assign$2({ id: titleId, role: "heading", "aria-level": 1 }, titleProps, { className: css(classNames.title, titleProps.className) }), title),
                React.createElement("div", { className: classNames.topButton },
                    this.props.topButtonsProps.map(function (props, index) { return (React.createElement(IconButton, __assign$2({ key: props.uniqueId || index }, props))); }),
                    (type === DialogType.close || (showCloseButton && type !== DialogType.largeHeader)) && (React.createElement(IconButton, { className: classNames.button, iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss })))),
            React.createElement("div", { className: classNames.inner },
                React.createElement("div", { className: classNames.innerContent },
                    subTextContent,
                    groupings.contents),
                groupings.footers)));
    };
    // @TODO - typing the footers as an array of DialogFooter is difficult because
    // casing "child as DialogFooter" causes a problem because
    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
    DialogContentBase.prototype._groupChildren = function () {
        var groupings = {
            footers: [],
            contents: [],
        };
        React.Children.map(this.props.children, function (child) {
            if (typeof child === 'object' && child !== null && child.type === DialogFooterType) {
                groupings.footers.push(child);
            }
            else {
                groupings.contents.push(child);
            }
        });
        return groupings;
    };
    DialogContentBase.defaultProps = {
        showCloseButton: false,
        className: '',
        topButtonsProps: [],
        closeButtonAriaLabel: 'Close',
    };
    DialogContentBase = __decorate([
        withResponsiveMode
    ], DialogContentBase);
    return DialogContentBase;
}(React.Component));

var GlobalClassNames$5 = {
    contentLgHeader: 'ms-Dialog-lgHeader',
    close: 'ms-Dialog--close',
    subText: 'ms-Dialog-subText',
    header: 'ms-Dialog-header',
    headerLg: 'ms-Dialog--lgHeader',
    button: 'ms-Dialog-button ms-Dialog-button--close',
    inner: 'ms-Dialog-inner',
    content: 'ms-Dialog-content',
    title: 'ms-Dialog-title',
};
var getStyles$7 = function (props) {
    var _a, _b, _c;
    var className = props.className, theme = props.theme, isLargeHeader = props.isLargeHeader, isClose = props.isClose, hidden = props.hidden, isMultiline = props.isMultiline, draggableHeaderClassName = props.draggableHeaderClassName;
    var palette = theme.palette, fonts = theme.fonts, effects = theme.effects, semanticColors = theme.semanticColors;
    var classNames = getGlobalClassNames(GlobalClassNames$5, theme);
    return {
        content: [
            isLargeHeader && [
                classNames.contentLgHeader,
                {
                    borderTop: "4px solid ".concat(palette.themePrimary),
                },
            ],
            isClose && classNames.close,
            {
                flexGrow: 1,
                overflowY: 'hidden', // required for allowScrollOnElement
            },
            className,
        ],
        subText: [
            classNames.subText,
            fonts.medium,
            {
                margin: '0 0 24px 0',
                color: semanticColors.bodySubtext,
                lineHeight: '1.5',
                wordWrap: 'break-word',
                fontWeight: FontWeights.regular,
            },
        ],
        header: [
            classNames.header,
            {
                position: 'relative',
                width: '100%',
                boxSizing: 'border-box',
            },
            isClose && classNames.close,
            draggableHeaderClassName && [
                draggableHeaderClassName,
                {
                    cursor: 'move',
                },
            ],
        ],
        button: [
            classNames.button,
            hidden && {
                selectors: {
                    '.ms-Icon.ms-Icon--Cancel': {
                        color: semanticColors.buttonText,
                        fontSize: IconFontSizes.medium,
                    },
                },
            },
        ],
        inner: [
            classNames.inner,
            {
                padding: '0 24px 24px',
                selectors: (_a = {},
                    _a["@media (min-width: ".concat(ScreenWidthMinSmall, "px) and (max-width: ").concat(ScreenWidthMaxSmall, "px)")] = {
                        padding: '0 16px 16px',
                    },
                    _a),
            },
        ],
        innerContent: [
            classNames.content,
            {
                position: 'relative',
                width: '100%',
            },
        ],
        title: [
            classNames.title,
            fonts.xLarge,
            {
                color: semanticColors.bodyText,
                margin: '0',
                minHeight: fonts.xLarge.fontSize,
                padding: '16px 46px 20px 24px',
                lineHeight: 'normal',
                selectors: (_b = {},
                    _b["@media (min-width: ".concat(ScreenWidthMinSmall, "px) and (max-width: ").concat(ScreenWidthMaxSmall, "px)")] = {
                        padding: '16px 46px 16px 16px',
                    },
                    _b),
            },
            isLargeHeader && {
                color: semanticColors.menuHeader,
            },
            isMultiline && { fontSize: fonts.xxLarge.fontSize },
        ],
        topButton: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                position: 'absolute',
                top: '0',
                right: '0',
                padding: '15px 15px 0 0',
                selectors: (_c = {
                        '> *': {
                            flex: '0 0 auto',
                        },
                        '.ms-Dialog-button': {
                            color: semanticColors.buttonText,
                        },
                        '.ms-Dialog-button:hover': {
                            color: semanticColors.buttonTextHovered,
                            borderRadius: effects.roundedCorner2,
                        }
                    },
                    _c["@media (min-width: ".concat(ScreenWidthMinSmall, "px) and (max-width: ").concat(ScreenWidthMaxSmall, "px)")] = {
                        padding: '15px 8px 0 0',
                    },
                    _c),
            },
        ],
    };
};

var DialogContent = styled(DialogContentBase, getStyles$7, undefined, { scope: 'DialogContent' });
DialogContent.displayName = 'DialogContent';

var getClassNames$8 = classNamesFunction();
var DefaultModalProps = {
    isDarkOverlay: false,
    isBlocking: false,
    className: '',
    containerClassName: '',
    topOffsetFixed: false,
    enableAriaHiddenSiblings: true,
};
var DefaultDialogContentProps = {
    type: DialogType.normal,
    className: '',
    topButtonsProps: [],
};
// eslint-disable-next-line @typescript-eslint/no-deprecated
var DialogBase = /** @class */ (function (_super) {
    __extends$1(DialogBase, _super);
    function DialogBase(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function () {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = (modalProps && modalProps.subtitleAriaId) || ariaDescribedById;
            if (!id) {
                id = ((dialogContentProps && dialogContentProps.subText) || subText) && _this._defaultSubTextId;
            }
            return id;
        };
        _this._getTitleTextId = function () {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = (modalProps && modalProps.titleAriaId) || ariaLabelledById;
            if (!id) {
                id = ((dialogContentProps && dialogContentProps.title) || title) && _this._defaultTitleTextId;
            }
            return id;
        };
        _this._id = getId('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        if (process.env.NODE_ENV !== 'production') {
            warnDeprecations('Dialog', props, {
                isOpen: 'hidden',
                type: 'dialogContentProps.type',
                subText: 'dialogContentProps.subText',
                contentClassName: 'dialogContentProps.className',
                topButtonsProps: 'dialogContentProps.topButtonsProps',
                className: 'modalProps.className',
                isDarkOverlay: 'modalProps.isDarkOverlay',
                isBlocking: 'modalProps.isBlocking',
                containerClassName: 'modalProps.containerClassName',
                onDismissed: 'modalProps.onDismissed',
                onLayerDidMount: 'modalProps.layerProps.onLayerDidMount',
                ariaDescribedById: 'modalProps.subtitleAriaId',
                ariaLabelledById: 'modalProps.titleAriaId',
            });
        }
        return _this;
    }
    DialogBase.prototype.render = function () {
        var _a, _b, _c;
        var props = this.props;
        var 
        /* eslint-disable @typescript-eslint/no-deprecated */
        className = props.className, containerClassName = props.containerClassName, contentClassName = props.contentClassName, elementToFocusOnDismiss = props.elementToFocusOnDismiss, firstFocusableSelector = props.firstFocusableSelector, forceFocusInsideTrap = props.forceFocusInsideTrap, styles = props.styles, hidden = props.hidden, _d = props.disableRestoreFocus, disableRestoreFocus = _d === undefined ? props.ignoreExternalFocusing : _d, isBlocking = props.isBlocking, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, isDarkOverlay = props.isDarkOverlay, _e = props.isOpen, isOpen = _e === undefined ? !hidden : _e, onDismiss = props.onDismiss, onDismissed = props.onDismissed, onLayerDidMount = props.onLayerDidMount, responsiveMode = props.responsiveMode, subText = props.subText, theme = props.theme, title = props.title, topButtonsProps = props.topButtonsProps, type = props.type, 
        /* eslint-enable @typescript-eslint/no-deprecated */
        minWidth = props.minWidth, maxWidth = props.maxWidth, modalProps = props.modalProps;
        var mergedLayerProps = __assign$2({ onLayerDidMount: onLayerDidMount }, modalProps === null || modalProps === undefined ? undefined : modalProps.layerProps);
        var dialogDraggableClassName;
        var dragOptions;
        // If dragOptions are provided, but no drag handle is specified, we supply a drag handle,
        // and inform dialog contents to add class to draggable class to the header
        if ((modalProps === null || modalProps === undefined ? undefined : modalProps.dragOptions) && !((_a = modalProps.dragOptions) === null || _a === undefined ? undefined : _a.dragHandleSelector)) {
            // spread options to avoid mutating props
            dragOptions = __assign$2({}, modalProps.dragOptions);
            dialogDraggableClassName = 'ms-Dialog-draggable-header';
            dragOptions.dragHandleSelector = ".".concat(dialogDraggableClassName);
        }
        var mergedModalProps = __assign$2(__assign$2(__assign$2(__assign$2({}, DefaultModalProps), { elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, disableRestoreFocus: disableRestoreFocus, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, responsiveMode: responsiveMode, className: className, containerClassName: containerClassName, isBlocking: isBlocking, isDarkOverlay: isDarkOverlay, onDismissed: onDismissed }), modalProps), { dragOptions: dragOptions, layerProps: mergedLayerProps, isOpen: isOpen });
        var dialogContentProps = __assign$2(__assign$2(__assign$2({ className: contentClassName, subText: subText, title: title, topButtonsProps: topButtonsProps, type: type }, DefaultDialogContentProps), props.dialogContentProps), { draggableHeaderClassName: dialogDraggableClassName, titleProps: __assign$2({ 
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                id: ((_b = props.dialogContentProps) === null || _b === undefined ? undefined : _b.titleId) || this._defaultTitleTextId }, (_c = props.dialogContentProps) === null || _c === undefined ? undefined : _c.titleProps) });
        var classNames = getClassNames$8(styles, {
            theme: theme,
            className: mergedModalProps.className,
            containerClassName: mergedModalProps.containerClassName,
            hidden: hidden,
            dialogDefaultMinWidth: minWidth,
            dialogDefaultMaxWidth: maxWidth,
        });
        return (React.createElement(Modal, __assign$2({}, mergedModalProps, { className: classNames.root, containerClassName: classNames.main, onDismiss: onDismiss || mergedModalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
            React.createElement(DialogContent, __assign$2({ subTextId: this._defaultSubTextId, showCloseButton: mergedModalProps.isBlocking, onDismiss: onDismiss }, dialogContentProps), props.children)));
    };
    DialogBase.defaultProps = {
        hidden: true,
    };
    DialogBase = __decorate([
        withResponsiveMode
    ], DialogBase);
    return DialogBase;
}(React.Component));

var GlobalClassNames$4 = {
    root: 'ms-Dialog',
};
var getStyles$6 = function (props) {
    var _a;
    var className = props.className, containerClassName = props.containerClassName, // eslint-disable-line @typescript-eslint/no-deprecated
    _b = props.dialogDefaultMinWidth, // eslint-disable-line @typescript-eslint/no-deprecated
    dialogDefaultMinWidth = _b === undefined ? '288px' : _b, _c = props.dialogDefaultMaxWidth, dialogDefaultMaxWidth = _c === undefined ? '340px' : _c, hidden = props.hidden, theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames$4, theme);
    return {
        root: [classNames.root, theme.fonts.medium, className],
        main: [
            {
                width: dialogDefaultMinWidth,
                outline: '3px solid transparent',
                selectors: (_a = {},
                    _a["@media (min-width: ".concat(ScreenWidthMinMedium, "px)")] = {
                        width: 'auto',
                        maxWidth: dialogDefaultMaxWidth,
                        minWidth: dialogDefaultMinWidth,
                    },
                    _a),
            },
            !hidden && { display: 'flex' },
            containerClassName,
        ],
    };
};

var Dialog = styled(DialogBase, getStyles$6, undefined, { scope: 'Dialog' });
Dialog.displayName = 'Dialog';

/**
 * {@docCategory Panel}
 */
var PanelType;
(function (PanelType) {
    /**
     * Renders the Panel with a `fluid` (full screen) width.
     * Recommended for use on small screen breakpoints.
     * - Small (320-479): full screen width, 16px left/right padding
     * - Medium (480-639): full screen width, 16px left/right padding
     * - Large (640-1023): full screen width, 32px left/right padding
     * - XLarge (1024-1365): full screen width, 32px left/right padding
     * - XXLarge (1366-up): full screen width, 40px left/right padding
     */
    PanelType[PanelType["smallFluid"] = 0] = "smallFluid";
    /**
     * Renders the Panel in fixed-width `small` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): 340px width, 16px left/right padding
     * - Large (640-1023): 340px width, 32px left/right padding
     * - XLarge (1024-1365): 340px width, 32px left/right padding
     * - XXLarge (1366-up): 340px width, 40px left/right padding
     */
    PanelType[PanelType["smallFixedFar"] = 1] = "smallFixedFar";
    /**
     * Renders the Panel in fixed-width `small` size, anchored to the near side (left in LTR mode).
     * - Small (320-479): 272px width, 16px left/right padding
     * - Medium (480-639): 272px width, 16px left/right padding
     * - Large (640-1023): 272px width, 32px left/right padding
     * - XLarge (1024-1365): 272px width, 32px left/right padding
     * - XXLarge (1366-up): 272px width, 40px left/right padding
     */
    PanelType[PanelType["smallFixedNear"] = 2] = "smallFixedNear";
    /**
     * Renders the Panel in `medium` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): 592px width, 32px left/right padding
     * - XLarge (1024-1365): 644px width, 32px left/right padding
     * - XXLarge (1366-up): 644px width, 40px left/right padding
     */
    PanelType[PanelType["medium"] = 3] = "medium";
    /**
     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639):  adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
     * - XXLarge (1366-up): 428px fixed left margin, fluid width, 40px left/right padding
     */
    PanelType[PanelType["large"] = 4] = "large";
    /**
     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode), with a fixed width at
     * XX-Large breakpoint.
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
     * - XXLarge (1366-up): 940px width, 40px left/right padding
     */
    PanelType[PanelType["largeFixed"] = 5] = "largeFixed";
    /**
     * Renders the Panel in `extra large` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): adapts to `PanelType.large` at this breakpoint
     * - XXLarge (1366-1919): 176px fixed left margin, fluid width, 40px left/right padding
     * - XXXLarge (1920-up): 176px fixed left margin, fluid width, 40px left/right padding
     */
    PanelType[PanelType["extraLarge"] = 6] = "extraLarge";
    /**
     * Renders the Panel in `custom` size using `customWidth`, anchored to the far side (right in LTR mode).
     * - Has a fixed width provided by the `customWidth` prop
     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
     * taking up 100% of the viewport width
     */
    PanelType[PanelType["custom"] = 7] = "custom";
    /**
     * Renders the Panel in `custom` size using `customWidth`, anchored to the near side (left in LTR mode).
     * - Has a fixed width provided by the `customWidth` prop
     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
     * taking up 100% of the viewport width
     */
    PanelType[PanelType["customNear"] = 8] = "customNear";
})(PanelType || (PanelType = {}));

var getClassNames$7 = classNamesFunction();
var COMPONENT_NAME$4 = 'Panel';
var PanelVisibilityState;
(function (PanelVisibilityState) {
    PanelVisibilityState[PanelVisibilityState["closed"] = 0] = "closed";
    PanelVisibilityState[PanelVisibilityState["animatingOpen"] = 1] = "animatingOpen";
    PanelVisibilityState[PanelVisibilityState["open"] = 2] = "open";
    PanelVisibilityState[PanelVisibilityState["animatingClosed"] = 3] = "animatingClosed";
})(PanelVisibilityState || (PanelVisibilityState = {}));
var PanelBase = /** @class */ (function (_super) {
    __extends$1(PanelBase, _super);
    function PanelBase(props) {
        var _this = _super.call(this, props) || this;
        _this._panel = React.createRef();
        _this._animationCallback = null;
        _this._hasCustomNavigation = !!(_this.props.onRenderNavigation || _this.props.onRenderNavigationContent);
        _this.dismiss = function (ev) {
            if (_this.props.onDismiss && _this.isActive) {
                _this.props.onDismiss(ev);
            }
            if (!ev || (ev && !ev.defaultPrevented)) {
                _this.close();
            }
        };
        // Allow the user to scroll within the panel but not on the body
        _this._allowScrollOnPanel = function (elt) {
            var _a;
            _this._resizeObserver = _this._createResizeObserver(function (entries) {
                if (entries.length > 0 && entries[0].target === elt) {
                    _this._updateFooterPosition();
                }
            });
            if (elt) {
                (_a = _this._resizeObserver) === null || _a === undefined ? undefined : _a.observe(elt);
                if (_this._allowTouchBodyScroll) {
                    allowOverscrollOnElement(elt, _this._events);
                }
                else {
                    allowScrollOnElement(elt, _this._events);
                }
            }
            else {
                _this._events.off(_this._scrollableContent);
            }
            _this._scrollableContent = elt;
        };
        _this._onRenderNavigation = function (props) {
            if (!_this.props.onRenderNavigationContent && !_this.props.onRenderNavigation && !_this.props.hasCloseButton) {
                return null;
            }
            var _a = _this.props.onRenderNavigationContent, onRenderNavigationContent = _a === undefined ? _this._onRenderNavigationContent : _a;
            return (React.createElement("div", { className: _this._classNames.navigation }, onRenderNavigationContent(props, _this._onRenderNavigationContent)));
        };
        _this._onRenderNavigationContent = function (props) {
            var _a;
            var closeButtonAriaLabel = props.closeButtonAriaLabel, hasCloseButton = props.hasCloseButton, _b = props.onRenderHeader, onRenderHeader = _b === undefined ? _this._onRenderHeader : _b;
            if (hasCloseButton) {
                var iconButtonStyles = (_a = _this._classNames.subComponentStyles) === null || _a === undefined ? undefined : _a.closeButton();
                return (React.createElement(React.Fragment, null,
                    !_this._hasCustomNavigation && onRenderHeader(_this.props, _this._onRenderHeader, _this._headerTextId),
                    React.createElement(IconButton, { styles: iconButtonStyles, className: _this._classNames.closeButton, onClick: _this._onPanelClick, ariaLabel: closeButtonAriaLabel, title: closeButtonAriaLabel, "data-is-visible": true, iconProps: { iconName: 'Cancel' } })));
            }
            return null;
        };
        _this._onRenderHeader = function (props, defaultRender, headerTextId) {
            var headerText = props.headerText, _a = props.headerTextProps, headerTextProps = _a === undefined ? {} : _a;
            if (headerText) {
                return (React.createElement("div", { className: _this._classNames.header },
                    React.createElement("div", __assign$2({ id: headerTextId, role: "heading", "aria-level": 1 }, headerTextProps, { className: css(_this._classNames.headerText, headerTextProps.className) }), headerText)));
            }
            return null;
        };
        _this._onRenderBody = function (props) {
            return React.createElement("div", { className: _this._classNames.content }, props.children);
        };
        _this._onRenderFooter = function (props) {
            var _a = _this.props.onRenderFooterContent, onRenderFooterContent = _a === undefined ? null : _a;
            if (onRenderFooterContent) {
                return (React.createElement("div", { className: _this._classNames.footer },
                    React.createElement("div", { className: _this._classNames.footerInner }, onRenderFooterContent())));
            }
            return null;
        };
        _this._animateTo = function (newVisibilityState) {
            if (newVisibilityState === PanelVisibilityState.open && _this.props.onOpen) {
                _this.props.onOpen();
            }
            _this._animationCallback = _this._async.setTimeout(function () {
                _this.setState({ visibility: newVisibilityState });
                _this._onTransitionComplete(newVisibilityState);
            }, 200);
        };
        _this._clearExistingAnimationTimer = function () {
            if (_this._animationCallback !== null) {
                _this._async.clearTimeout(_this._animationCallback);
            }
        };
        _this._onPanelClick = function (ev) {
            _this.dismiss(ev);
        };
        _this._onTransitionComplete = function (newVisibilityState) {
            _this._updateFooterPosition();
            if (newVisibilityState === PanelVisibilityState.open && _this.props.onOpened) {
                _this.props.onOpened();
            }
            if (newVisibilityState === PanelVisibilityState.closed && _this.props.onDismissed) {
                _this.props.onDismissed();
            }
        };
        var _a = _this.props.allowTouchBodyScroll, allowTouchBodyScroll = _a === undefined ? false : _a;
        _this._allowTouchBodyScroll = allowTouchBodyScroll;
        initializeComponentRef(_this);
        warnDeprecations(COMPONENT_NAME$4, props, {
            ignoreExternalFocusing: 'focusTrapZoneProps',
            forceFocusInsideTrap: 'focusTrapZoneProps',
            firstFocusableSelector: 'focusTrapZoneProps',
        });
        _this.state = {
            isFooterSticky: false,
            // intentionally ignore props so animation takes place during componentDidMount
            visibility: PanelVisibilityState.closed,
            id: getId('Panel'),
        };
        return _this;
    }
    PanelBase.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.isOpen === undefined) {
            return null; // no state update
        }
        if (nextProps.isOpen &&
            (prevState.visibility === PanelVisibilityState.closed ||
                prevState.visibility === PanelVisibilityState.animatingClosed)) {
            return { visibility: PanelVisibilityState.animatingOpen };
        }
        if (!nextProps.isOpen &&
            (prevState.visibility === PanelVisibilityState.open ||
                prevState.visibility === PanelVisibilityState.animatingOpen)) {
            return { visibility: PanelVisibilityState.animatingClosed };
        }
        return null;
    };
    PanelBase.prototype.componentDidMount = function () {
        this._async = new Async(this);
        this._events = new EventGroup(this);
        var win = getWindowEx(this.context);
        var doc = getDocumentEx(this.context);
        this._events.on(win, 'resize', this._updateFooterPosition);
        if (this._shouldListenForOuterClick(this.props)) {
            this._events.on(doc === null || doc === undefined ? undefined : doc.body, 'mousedown', this._dismissOnOuterClick, true);
        }
        if (this.props.isOpen) {
            this.setState({ visibility: PanelVisibilityState.animatingOpen });
        }
    };
    PanelBase.prototype.componentDidUpdate = function (previousProps, previousState) {
        var shouldListenOnOuterClick = this._shouldListenForOuterClick(this.props);
        var previousShouldListenOnOuterClick = this._shouldListenForOuterClick(previousProps);
        if (this.state.visibility !== previousState.visibility) {
            this._clearExistingAnimationTimer();
            if (this.state.visibility === PanelVisibilityState.animatingOpen) {
                this._animateTo(PanelVisibilityState.open);
            }
            else if (this.state.visibility === PanelVisibilityState.animatingClosed) {
                this._animateTo(PanelVisibilityState.closed);
            }
        }
        var doc = getDocumentEx(this.context);
        if (shouldListenOnOuterClick && !previousShouldListenOnOuterClick) {
            this._events.on(doc === null || doc === undefined ? undefined : doc.body, 'mousedown', this._dismissOnOuterClick, true);
        }
        else if (!shouldListenOnOuterClick && previousShouldListenOnOuterClick) {
            this._events.off(doc === null || doc === undefined ? undefined : doc.body, 'mousedown', this._dismissOnOuterClick, true);
        }
    };
    PanelBase.prototype.componentWillUnmount = function () {
        var _a;
        this._async.dispose();
        this._events.dispose();
        (_a = this._resizeObserver) === null || _a === undefined ? undefined : _a.disconnect();
    };
    PanelBase.prototype.render = function () {
        var _a = this.props, _b = _a.className, className = _b === undefined ? '' : _b, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, 
        /* eslint-disable @typescript-eslint/no-deprecated */
        firstFocusableSelector = _a.firstFocusableSelector, focusTrapZoneProps = _a.focusTrapZoneProps, forceFocusInsideTrap = _a.forceFocusInsideTrap, hasCloseButton = _a.hasCloseButton, headerText = _a.headerText, _c = _a.headerClassName, headerClassName = _c === undefined ? '' : _c, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isFooterAtBottom = _a.isFooterAtBottom, isLightDismiss = _a.isLightDismiss, isHiddenOnDismiss = _a.isHiddenOnDismiss, layerProps = _a.layerProps, overlayProps = _a.overlayProps, popupProps = _a.popupProps, type = _a.type, styles = _a.styles, theme = _a.theme, customWidth = _a.customWidth, _d = _a.onLightDismissClick, onLightDismissClick = _d === undefined ? this._onPanelClick : _d, _e = _a.onRenderNavigation, onRenderNavigation = _e === undefined ? this._onRenderNavigation : _e, _f = _a.onRenderHeader, onRenderHeader = _f === undefined ? this._onRenderHeader : _f, _g = _a.onRenderBody, onRenderBody = _g === undefined ? this._onRenderBody : _g, _h = _a.onRenderFooter, onRenderFooter = _h === undefined ? this._onRenderFooter : _h;
        var _j = this.state, isFooterSticky = _j.isFooterSticky, visibility = _j.visibility, id = _j.id;
        var isLeft = type === PanelType.smallFixedNear || type === PanelType.customNear ? true : false;
        var isRTL = getRTL(theme);
        var isOnRightSide = isRTL ? isLeft : !isLeft;
        var customWidthStyles = type === PanelType.custom || type === PanelType.customNear ? { width: customWidth } : {};
        var nativeProps = getNativeProps$1(this.props, divProperties);
        var isOpen = this.isActive;
        var isAnimating = visibility === PanelVisibilityState.animatingClosed || visibility === PanelVisibilityState.animatingOpen;
        this._headerTextId = headerText && id + '-headerText';
        if (!isOpen && !isAnimating && !isHiddenOnDismiss) {
            return null;
        }
        this._classNames = getClassNames$7(styles, {
            theme: theme,
            className: className,
            focusTrapZoneClassName: focusTrapZoneProps ? focusTrapZoneProps.className : undefined,
            hasCloseButton: hasCloseButton,
            headerClassName: headerClassName,
            isAnimating: isAnimating,
            isFooterSticky: isFooterSticky,
            isFooterAtBottom: isFooterAtBottom,
            isOnRightSide: isOnRightSide,
            isOpen: isOpen,
            isHiddenOnDismiss: isHiddenOnDismiss,
            type: type,
            hasCustomNavigation: this._hasCustomNavigation,
        });
        var _k = this, _classNames = _k._classNames, _allowTouchBodyScroll = _k._allowTouchBodyScroll;
        var overlay;
        if (isBlocking && isOpen) {
            overlay = (React.createElement(Overlay, __assign$2({ className: _classNames.overlay, isDarkThemed: false, onClick: isLightDismiss ? onLightDismissClick : undefined, allowTouchBodyScroll: _allowTouchBodyScroll }, overlayProps)));
        }
        return (React.createElement(Layer, __assign$2({}, layerProps),
            React.createElement(Popup, __assign$2({ role: "dialog", "aria-modal": isBlocking ? 'true' : undefined, ariaLabelledBy: this._headerTextId ? this._headerTextId : undefined, onDismiss: this.dismiss, className: _classNames.hiddenPanel, enableAriaHiddenSiblings: isOpen ? true : false }, popupProps),
                React.createElement("div", __assign$2({ "aria-hidden": !isOpen && isAnimating }, nativeProps, { ref: this._panel, className: _classNames.root }),
                    overlay,
                    React.createElement(FocusTrapZone, __assign$2({ ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: !isBlocking || (isHiddenOnDismiss && !isOpen) ? false : forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector, isClickableOutsideFocusTrap: true }, focusTrapZoneProps, { className: _classNames.main, style: customWidthStyles, elementToFocusOnDismiss: elementToFocusOnDismiss }),
                        React.createElement("div", { className: _classNames.contentInner },
                            React.createElement("div", { ref: this._allowScrollOnPanel, className: _classNames.scrollableContent, "data-is-scrollable": true },
                                React.createElement("div", { className: _classNames.commands, "data-is-visible": true }, onRenderNavigation(this.props, this._onRenderNavigation)),
                                (this._hasCustomNavigation || !hasCloseButton) &&
                                    onRenderHeader(this.props, this._onRenderHeader, this._headerTextId),
                                onRenderBody(this.props, this._onRenderBody),
                                onRenderFooter(this.props, this._onRenderFooter))))))));
    };
    PanelBase.prototype.open = function () {
        if (this.props.isOpen !== undefined) {
            return;
        }
        if (this.isActive) {
            return;
        }
        this.setState({ visibility: PanelVisibilityState.animatingOpen });
    };
    PanelBase.prototype.close = function () {
        if (this.props.isOpen !== undefined) {
            return;
        }
        if (!this.isActive) {
            return;
        }
        this.setState({ visibility: PanelVisibilityState.animatingClosed });
    };
    Object.defineProperty(PanelBase.prototype, "isActive", {
        /** isActive is true when panel is open or opening. */
        get: function () {
            return (this.state.visibility === PanelVisibilityState.open ||
                this.state.visibility === PanelVisibilityState.animatingOpen);
        },
        enumerable: false,
        configurable: true
    });
    PanelBase.prototype._createResizeObserver = function (callback) {
        var _a;
        var doc = getDocumentEx(this.context);
        var resizeObserver = null;
        if ((_a = doc === null || doc === undefined ? undefined : doc.defaultView) === null || _a === undefined ? undefined : _a.ResizeObserver) {
            resizeObserver = new doc.defaultView.ResizeObserver(callback);
        }
        return resizeObserver;
    };
    PanelBase.prototype._shouldListenForOuterClick = function (props) {
        return !!props.isBlocking && !!props.isOpen;
    };
    PanelBase.prototype._updateFooterPosition = function () {
        var scrollableContent = this._scrollableContent;
        if (scrollableContent) {
            var height = scrollableContent.clientHeight;
            var innerHeight_1 = scrollableContent.scrollHeight;
            this.setState({
                isFooterSticky: height < innerHeight_1 ? true : false,
            });
        }
    };
    PanelBase.prototype._dismissOnOuterClick = function (ev) {
        var panel = this._panel.current;
        if (this.isActive && panel && !ev.defaultPrevented) {
            if (!elementContains$1(panel, ev.target)) {
                if (this.props.onOuterClick) {
                    this.props.onOuterClick(ev);
                }
                else {
                    this.dismiss(ev);
                }
            }
        }
    };
    PanelBase.defaultProps = {
        isHiddenOnDismiss: false,
        isOpen: undefined,
        isBlocking: true,
        hasCloseButton: true,
        type: PanelType.smallFixedFar,
    };
    PanelBase.contextType = WindowContext;
    return PanelBase;
}(React.Component));

var _a$c, _b$3, _c$1, _d, _e;
var GlobalClassNames$3 = {
    root: 'ms-Panel',
    main: 'ms-Panel-main',
    commands: 'ms-Panel-commands',
    contentInner: 'ms-Panel-contentInner',
    scrollableContent: 'ms-Panel-scrollableContent',
    navigation: 'ms-Panel-navigation',
    closeButton: 'ms-Panel-closeButton ms-PanelAction-close',
    header: 'ms-Panel-header',
    headerText: 'ms-Panel-headerText',
    content: 'ms-Panel-content',
    footer: 'ms-Panel-footer',
    footerInner: 'ms-Panel-footerInner',
    isOpen: 'is-open',
    hasCloseButton: 'ms-Panel--hasCloseButton',
    smallFluid: 'ms-Panel--smFluid',
    smallFixedNear: 'ms-Panel--smLeft',
    smallFixedFar: 'ms-Panel--sm',
    medium: 'ms-Panel--md',
    large: 'ms-Panel--lg',
    largeFixed: 'ms-Panel--fixed',
    extraLarge: 'ms-Panel--xl',
    custom: 'ms-Panel--custom',
    customNear: 'ms-Panel--customLeft',
};
var panelWidth = {
    full: '100%',
    auto: 'auto',
    xs: 272,
    sm: 340,
    md1: 592,
    md2: 644,
    lg: 940,
};
var panelMargin = {
    auto: 'auto',
    none: 0,
    md: 48,
    lg: 428,
    xl: 176,
};
// Following consts are used below in `getPanelBreakpoints()` function to provide
// necessary fallbacks for different types of Panel in different breakpoints.
var smallPanelSelectors = (_a$c = {},
    _a$c["@media (min-width: ".concat(ScreenWidthMinMedium, "px)")] = {
        width: panelWidth.sm,
    },
    _a$c);
var mediumPanelSelectors = (_b$3 = {},
    _b$3["@media (min-width: ".concat(ScreenWidthMinLarge, "px)")] = {
        width: panelWidth.md1,
    },
    _b$3["@media (min-width: ".concat(ScreenWidthMinXLarge, "px)")] = {
        width: panelWidth.md2,
    },
    _b$3);
var largePanelSelectors = (_c$1 = {},
    _c$1["@media (min-width: ".concat(ScreenWidthMinUhfMobile, "px)")] = {
        left: panelMargin.md,
        width: panelWidth.auto,
    },
    _c$1["@media (min-width: ".concat(ScreenWidthMinXXLarge, "px)")] = {
        left: panelMargin.lg,
    },
    _c$1);
var largeFixedPanelSelectors = (_d = {},
    _d["@media (min-width: ".concat(ScreenWidthMinXXLarge, "px)")] = {
        left: panelMargin.auto,
        width: panelWidth.lg,
    },
    _d);
var extraLargePanelSelectors = (_e = {},
    _e["@media (min-width: ".concat(ScreenWidthMinXXLarge, "px)")] = {
        left: panelMargin.xl,
    },
    _e);
// Make sure Panels have fallbacks to different breakpoints by reusing same selectors.
// This is done in the effort to follow design redlines.
var getPanelBreakpoints = function (type) {
    var selectors;
    // Panel types `smallFluid`, `smallFixedNear`, `custom` and `customNear`
    // are not checked in here because they render the same in all the breakpoints
    // and have the checks done separately in the `getStyles` function below.
    switch (type) {
        case PanelType.smallFixedFar:
            selectors = __assign$2({}, smallPanelSelectors);
            break;
        case PanelType.medium:
            selectors = __assign$2(__assign$2({}, smallPanelSelectors), mediumPanelSelectors);
            break;
        case PanelType.large:
            selectors = __assign$2(__assign$2(__assign$2({}, smallPanelSelectors), mediumPanelSelectors), largePanelSelectors);
            break;
        case PanelType.largeFixed:
            selectors = __assign$2(__assign$2(__assign$2(__assign$2({}, smallPanelSelectors), mediumPanelSelectors), largePanelSelectors), largeFixedPanelSelectors);
            break;
        case PanelType.extraLarge:
            selectors = __assign$2(__assign$2(__assign$2(__assign$2({}, smallPanelSelectors), mediumPanelSelectors), largePanelSelectors), extraLargePanelSelectors);
            break;
    }
    return selectors;
};
var commandBarHeight = '44px';
var sharedPaddingStyles = {
    paddingLeft: '24px',
    paddingRight: '24px',
};
var getStyles$5 = function (props) {
    var _a, _b, _c, _d;
    var className = props.className, focusTrapZoneClassName = props.focusTrapZoneClassName, hasCloseButton = props.hasCloseButton, headerClassName = props.headerClassName, isAnimating = props.isAnimating, isFooterSticky = props.isFooterSticky, isFooterAtBottom = props.isFooterAtBottom, isOnRightSide = props.isOnRightSide, isOpen = props.isOpen, isHiddenOnDismiss = props.isHiddenOnDismiss, hasCustomNavigation = props.hasCustomNavigation, theme = props.theme, _e = props.type, type = _e === undefined ? PanelType.smallFixedFar : _e;
    var effects = theme.effects, fonts = theme.fonts, semanticColors = theme.semanticColors;
    var classNames = getGlobalClassNames(GlobalClassNames$3, theme);
    var isCustomPanel = type === PanelType.custom || type === PanelType.customNear;
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isOpen && classNames.isOpen,
            hasCloseButton && classNames.hasCloseButton,
            {
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            isCustomPanel && isOnRightSide && classNames.custom,
            isCustomPanel && !isOnRightSide && classNames.customNear,
            className,
        ],
        overlay: [
            {
                pointerEvents: 'auto',
                cursor: 'pointer',
            },
            isOpen && isAnimating && AnimationClassNames.fadeIn100,
            !isOpen && isAnimating && AnimationClassNames.fadeOut100,
        ],
        hiddenPanel: [
            !isOpen &&
                !isAnimating &&
                isHiddenOnDismiss && {
                visibility: 'hidden',
            },
        ],
        main: [
            classNames.main,
            {
                backgroundColor: semanticColors.bodyBackground,
                boxShadow: effects.elevation64,
                pointerEvents: 'auto',
                position: 'absolute',
                display: 'flex',
                flexDirection: 'column',
                overflowX: 'hidden',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                bottom: 0,
                top: 0,
                // left, right, width are overridden depending on the type of the Panel and the screen breakpoint.
                left: panelMargin.auto,
                right: panelMargin.none,
                width: panelWidth.full,
                selectors: __assign$2((_a = {}, _a[HighContrastSelector] = {
                    borderLeft: "3px solid ".concat(semanticColors.variantBorder),
                    borderRight: "3px solid ".concat(semanticColors.variantBorder),
                }, _a), getPanelBreakpoints(type)),
            },
            type === PanelType.smallFluid && {
                left: panelMargin.none,
            },
            type === PanelType.smallFixedNear && {
                left: panelMargin.none,
                right: panelMargin.auto,
                width: panelWidth.xs,
            },
            type === PanelType.customNear && {
                right: 'auto',
                left: 0,
            },
            isCustomPanel && {
                maxWidth: '100vw',
            },
            isOpen && isAnimating && !isOnRightSide && AnimationClassNames.slideRightIn40,
            isOpen && isAnimating && isOnRightSide && AnimationClassNames.slideLeftIn40,
            !isOpen && isAnimating && !isOnRightSide && AnimationClassNames.slideLeftOut40,
            !isOpen && isAnimating && isOnRightSide && AnimationClassNames.slideRightOut40,
            focusTrapZoneClassName,
        ],
        commands: [
            classNames.commands,
            {
                // Ensures that the sticky header always has a background to prevent overlaps on scroll.
                backgroundColor: semanticColors.bodyBackground,
                paddingTop: 18,
                selectors: (_b = {},
                    _b["@media (min-height: ".concat(ScreenWidthMinMedium, "px)")] = {
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                    },
                    _b),
            },
            hasCustomNavigation && {
                paddingTop: 'inherit',
            },
        ],
        navigation: [
            classNames.navigation,
            {
                display: 'flex',
                justifyContent: 'flex-end',
            },
            hasCustomNavigation && {
                height: commandBarHeight,
            },
        ],
        contentInner: [
            classNames.contentInner,
            {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflowY: 'hidden',
            },
        ],
        header: [
            classNames.header,
            sharedPaddingStyles,
            {
                alignSelf: 'flex-start',
            },
            hasCloseButton &&
                !hasCustomNavigation && {
                flexGrow: 1,
            },
            hasCustomNavigation && {
                // Ensure that title doesn't shrink if screen is too small
                flexShrink: 0,
            },
        ],
        headerText: [
            classNames.headerText,
            fonts.xLarge,
            {
                color: semanticColors.bodyText,
                lineHeight: '27px',
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                hyphens: 'auto',
            },
            headerClassName,
        ],
        scrollableContent: [
            classNames.scrollableContent,
            {
                overflowY: 'auto',
            },
            isFooterAtBottom && {
                flexGrow: 1,
                display: 'inherit',
                flexDirection: 'inherit',
            },
        ],
        content: [
            classNames.content,
            sharedPaddingStyles,
            {
                paddingBottom: 20,
            },
            isFooterAtBottom && {
                selectors: (_c = {},
                    _c["@media (min-height: ".concat(ScreenWidthMinMedium, "px)")] = {
                        flexGrow: 1,
                    },
                    _c),
            },
        ],
        footer: [
            classNames.footer,
            {
                // Ensure that footer doesn't shrink if screen is too small
                flexShrink: 0,
                borderTop: '1px solid transparent',
                transition: "opacity ".concat(AnimationVariables.durationValue3, " ").concat(AnimationVariables.easeFunction2),
                selectors: (_d = {},
                    _d["@media (min-height: ".concat(ScreenWidthMinMedium, "px)")] = {
                        position: 'sticky',
                        bottom: 0,
                    },
                    _d),
            },
            isFooterSticky && {
                backgroundColor: semanticColors.bodyBackground,
                borderTopColor: semanticColors.variantBorder,
            },
        ],
        footerInner: [
            classNames.footerInner,
            sharedPaddingStyles,
            {
                paddingBottom: 16,
                paddingTop: 16,
            },
        ],
        subComponentStyles: {
            closeButton: {
                root: [
                    classNames.closeButton,
                    {
                        marginRight: 14,
                        color: theme.palette.neutralSecondary,
                        fontSize: IconFontSizes.large,
                    },
                    hasCustomNavigation && {
                        marginRight: 0,
                        height: 'auto',
                        width: '44px',
                    },
                ],
                rootHovered: {
                    color: theme.palette.neutralPrimary,
                },
            },
        },
    };
};

/**
 * Panel description
 */
var Panel = styled(PanelBase, getStyles$5, undefined, {
    scope: 'Panel',
});

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$j(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none',
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons\"",
            src: "url('".concat(baseUrl, "fabric-icons-a13498cf.woff') format('woff')"),
        },
        icons: {
            GlobalNavButton: '\uE700',
            ChevronDown: '\uE70D',
            ChevronUp: '\uE70E',
            Edit: '\uE70F',
            Add: '\uE710',
            Cancel: '\uE711',
            More: '\uE712',
            Settings: '\uE713',
            Mail: '\uE715',
            Filter: '\uE71C',
            Search: '\uE721',
            Share: '\uE72D',
            BlockedSite: '\uE72F',
            FavoriteStar: '\uE734',
            FavoriteStarFill: '\uE735',
            CheckMark: '\uE73E',
            Delete: '\uE74D',
            ChevronLeft: '\uE76B',
            ChevronRight: '\uE76C',
            Calendar: '\uE787',
            Megaphone: '\uE789',
            Undo: '\uE7A7',
            Flag: '\uE7C1',
            Page: '\uE7C3',
            Pinned: '\uE840',
            View: '\uE890',
            Clear: '\uE894',
            Download: '\uE896',
            Upload: '\uE898',
            Folder: '\uE8B7',
            Sort: '\uE8CB',
            AlignRight: '\uE8E2',
            AlignLeft: '\uE8E4',
            Tag: '\uE8EC',
            AddFriend: '\uE8FA',
            Info: '\uE946',
            SortLines: '\uE9D0',
            List: '\uEA37',
            CircleRing: '\uEA3A',
            Heart: '\uEB51',
            HeartFill: '\uEB52',
            Tiles: '\uECA5',
            Embed: '\uECCE',
            Glimmer: '\uECF4',
            Ascending: '\uEDC0',
            Descending: '\uEDC1',
            SortUp: '\uEE68',
            SortDown: '\uEE69',
            SyncToPC: '\uEE6E',
            LargeGrid: '\uEECB',
            SkypeCheck: '\uEF80',
            SkypeClock: '\uEF81',
            SkypeMinus: '\uEF82',
            ClearFilter: '\uEF8F',
            Flow: '\uEF90',
            StatusCircleCheckmark: '\uF13E',
            MoreVertical: '\uF2BC',
        },
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$i(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-0\"",
            src: "url('".concat(baseUrl, "fabric-icons-0-467ee27f.woff') format('woff')")
        },
        icons: {
            'PageLink': '\uE302',
            'CommentSolid': '\uE30E',
            'ChangeEntitlements': '\uE310',
            'Installation': '\uE311',
            'WebAppBuilderModule': '\uE313',
            'WebAppBuilderFragment': '\uE314',
            'WebAppBuilderSlot': '\uE315',
            'BullseyeTargetEdit': '\uE319',
            'WebAppBuilderFragmentCreate': '\uE31B',
            'PageData': '\uE31C',
            'PageHeaderEdit': '\uE31D',
            'ProductList': '\uE31E',
            'UnpublishContent': '\uE31F',
            'DependencyAdd': '\uE344',
            'DependencyRemove': '\uE345',
            'EntitlementPolicy': '\uE346',
            'EntitlementRedemption': '\uE347',
            'SchoolDataSyncLogo': '\uE34C',
            'PinSolid12': '\uE352',
            'PinSolidOff12': '\uE353',
            'AddLink': '\uE35E',
            'SharepointAppIcon16': '\uE365',
            'DataflowsLink': '\uE366',
            'TimePicker': '\uE367',
            'UserWarning': '\uE368',
            'ComplianceAudit': '\uE369',
            'InternetSharing': '\uE704',
            'Brightness': '\uE706',
            'MapPin': '\uE707',
            'Airplane': '\uE709',
            'Tablet': '\uE70A',
            'QuickNote': '\uE70B',
            'Video': '\uE714',
            'People': '\uE716',
            'Phone': '\uE717',
            'Pin': '\uE718',
            'Shop': '\uE719',
            'Stop': '\uE71A',
            'Link': '\uE71B',
            'AllApps': '\uE71D',
            'Zoom': '\uE71E',
            'ZoomOut': '\uE71F',
            'Microphone': '\uE720',
            'Camera': '\uE722',
            'Attach': '\uE723',
            'Send': '\uE724',
            'FavoriteList': '\uE728',
            'PageSolid': '\uE729',
            'Forward': '\uE72A',
            'Back': '\uE72B',
            'Refresh': '\uE72C',
            'Lock': '\uE72E',
            'ReportHacked': '\uE730',
            'EMI': '\uE731',
            'MiniLink': '\uE732',
            'Blocked': '\uE733',
            'ReadingMode': '\uE736',
            'Favicon': '\uE737',
            'Remove': '\uE738',
            'Checkbox': '\uE739',
            'CheckboxComposite': '\uE73A',
            'CheckboxFill': '\uE73B',
            'CheckboxIndeterminate': '\uE73C',
            'CheckboxCompositeReversed': '\uE73D',
            'BackToWindow': '\uE73F',
            'FullScreen': '\uE740',
            'Print': '\uE749',
            'Up': '\uE74A',
            'Down': '\uE74B',
            'OEM': '\uE74C',
            'Save': '\uE74E',
            'ReturnKey': '\uE751',
            'Cloud': '\uE753',
            'Flashlight': '\uE754',
            'CommandPrompt': '\uE756',
            'Sad': '\uE757',
            'RealEstate': '\uE758',
            'SIPMove': '\uE759',
            'EraseTool': '\uE75C',
            'GripperTool': '\uE75E',
            'Dialpad': '\uE75F',
            'PageLeft': '\uE760',
            'PageRight': '\uE761',
            'MultiSelect': '\uE762',
            'KeyboardClassic': '\uE765',
            'Play': '\uE768',
            'Pause': '\uE769',
            'InkingTool': '\uE76D',
            'Emoji2': '\uE76E',
            'GripperBarHorizontal': '\uE76F',
            'System': '\uE770',
            'Personalize': '\uE771',
            'SearchAndApps': '\uE773',
            'Globe': '\uE774',
            'EaseOfAccess': '\uE776',
            'ContactInfo': '\uE779',
            'Unpin': '\uE77A',
            'Contact': '\uE77B',
            'Memo': '\uE77C',
            'IncomingCall': '\uE77E'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$h(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-1\"",
            src: "url('".concat(baseUrl, "fabric-icons-1-4d521695.woff') format('woff')")
        },
        icons: {
            'Paste': '\uE77F',
            'WindowsLogo': '\uE782',
            'Error': '\uE783',
            'GripperBarVertical': '\uE784',
            'Unlock': '\uE785',
            'Slideshow': '\uE786',
            'Trim': '\uE78A',
            'AutoEnhanceOn': '\uE78D',
            'AutoEnhanceOff': '\uE78E',
            'Color': '\uE790',
            'SaveAs': '\uE792',
            'Light': '\uE793',
            'Filters': '\uE795',
            'AspectRatio': '\uE799',
            'Contrast': '\uE7A1',
            'Redo': '\uE7A6',
            'Crop': '\uE7A8',
            'PhotoCollection': '\uE7AA',
            'Album': '\uE7AB',
            'Rotate': '\uE7AD',
            'PanoIndicator': '\uE7B0',
            'Translate': '\uE7B2',
            'RedEye': '\uE7B3',
            'ViewOriginal': '\uE7B4',
            'ThumbnailView': '\uE7B6',
            'Package': '\uE7B8',
            'Telemarketer': '\uE7B9',
            'Warning': '\uE7BA',
            'Financial': '\uE7BB',
            'Education': '\uE7BE',
            'ShoppingCart': '\uE7BF',
            'Train': '\uE7C0',
            'Move': '\uE7C2',
            'TouchPointer': '\uE7C9',
            'Merge': '\uE7D5',
            'TurnRight': '\uE7DB',
            'Ferry': '\uE7E3',
            'Highlight': '\uE7E6',
            'PowerButton': '\uE7E8',
            'Tab': '\uE7E9',
            'Admin': '\uE7EF',
            'TVMonitor': '\uE7F4',
            'Speakers': '\uE7F5',
            'Game': '\uE7FC',
            'HorizontalTabKey': '\uE7FD',
            'UnstackSelected': '\uE7FE',
            'StackIndicator': '\uE7FF',
            'Nav2DMapView': '\uE800',
            'StreetsideSplitMinimize': '\uE802',
            'Car': '\uE804',
            'Bus': '\uE806',
            'EatDrink': '\uE807',
            'SeeDo': '\uE808',
            'LocationCircle': '\uE80E',
            'Home': '\uE80F',
            'SwitcherStartEnd': '\uE810',
            'ParkingLocation': '\uE811',
            'IncidentTriangle': '\uE814',
            'Touch': '\uE815',
            'MapDirections': '\uE816',
            'CaretHollow': '\uE817',
            'CaretSolid': '\uE818',
            'History': '\uE81C',
            'Location': '\uE81D',
            'MapLayers': '\uE81E',
            'SearchNearby': '\uE820',
            'Work': '\uE821',
            'Recent': '\uE823',
            'Hotel': '\uE824',
            'Bank': '\uE825',
            'LocationDot': '\uE827',
            'Dictionary': '\uE82D',
            'ChromeBack': '\uE830',
            'FolderOpen': '\uE838',
            'PinnedFill': '\uE842',
            'RevToggleKey': '\uE845',
            'USB': '\uE88E',
            'Previous': '\uE892',
            'Next': '\uE893',
            'Sync': '\uE895',
            'Help': '\uE897',
            'Emoji': '\uE899',
            'MailForward': '\uE89C',
            'ClosePane': '\uE89F',
            'OpenPane': '\uE8A0',
            'PreviewLink': '\uE8A1',
            'ZoomIn': '\uE8A3',
            'Bookmarks': '\uE8A4',
            'Document': '\uE8A5',
            'ProtectedDocument': '\uE8A6',
            'OpenInNewWindow': '\uE8A7',
            'MailFill': '\uE8A8',
            'ViewAll': '\uE8A9',
            'Switch': '\uE8AB',
            'Rename': '\uE8AC',
            'Go': '\uE8AD',
            'Remote': '\uE8AF',
            'SelectAll': '\uE8B3',
            'Orientation': '\uE8B4',
            'Import': '\uE8B5'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$g(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-2\"",
            src: "url('".concat(baseUrl, "fabric-icons-2-63c99abf.woff') format('woff')")
        },
        icons: {
            'Picture': '\uE8B9',
            'ChromeClose': '\uE8BB',
            'ShowResults': '\uE8BC',
            'Message': '\uE8BD',
            'CalendarDay': '\uE8BF',
            'CalendarWeek': '\uE8C0',
            'MailReplyAll': '\uE8C2',
            'Read': '\uE8C3',
            'Cut': '\uE8C6',
            'PaymentCard': '\uE8C7',
            'Copy': '\uE8C8',
            'Important': '\uE8C9',
            'MailReply': '\uE8CA',
            'GotoToday': '\uE8D1',
            'Font': '\uE8D2',
            'FontColor': '\uE8D3',
            'FolderFill': '\uE8D5',
            'Permissions': '\uE8D7',
            'DisableUpdates': '\uE8D8',
            'Unfavorite': '\uE8D9',
            'Italic': '\uE8DB',
            'Underline': '\uE8DC',
            'Bold': '\uE8DD',
            'MoveToFolder': '\uE8DE',
            'Dislike': '\uE8E0',
            'Like': '\uE8E1',
            'AlignCenter': '\uE8E3',
            'OpenFile': '\uE8E5',
            'ClearSelection': '\uE8E6',
            'FontDecrease': '\uE8E7',
            'FontIncrease': '\uE8E8',
            'FontSize': '\uE8E9',
            'CellPhone': '\uE8EA',
            'RepeatOne': '\uE8ED',
            'RepeatAll': '\uE8EE',
            'Calculator': '\uE8EF',
            'Library': '\uE8F1',
            'PostUpdate': '\uE8F3',
            'NewFolder': '\uE8F4',
            'CalendarReply': '\uE8F5',
            'UnsyncFolder': '\uE8F6',
            'SyncFolder': '\uE8F7',
            'BlockContact': '\uE8F8',
            'Accept': '\uE8FB',
            'BulletedList': '\uE8FD',
            'Preview': '\uE8FF',
            'News': '\uE900',
            'Chat': '\uE901',
            'Group': '\uE902',
            'World': '\uE909',
            'Comment': '\uE90A',
            'DockLeft': '\uE90C',
            'DockRight': '\uE90D',
            'Repair': '\uE90F',
            'Accounts': '\uE910',
            'Street': '\uE913',
            'RadioBullet': '\uE915',
            'Stopwatch': '\uE916',
            'Clock': '\uE917',
            'WorldClock': '\uE918',
            'AlarmClock': '\uE919',
            'Photo': '\uE91B',
            'ActionCenter': '\uE91C',
            'Hospital': '\uE91D',
            'Timer': '\uE91E',
            'FullCircleMask': '\uE91F',
            'LocationFill': '\uE920',
            'ChromeMinimize': '\uE921',
            'ChromeRestore': '\uE923',
            'Annotation': '\uE924',
            'Fingerprint': '\uE928',
            'Handwriting': '\uE929',
            'ChromeFullScreen': '\uE92D',
            'Completed': '\uE930',
            'Label': '\uE932',
            'FlickDown': '\uE935',
            'FlickUp': '\uE936',
            'FlickLeft': '\uE937',
            'FlickRight': '\uE938',
            'MiniExpand': '\uE93A',
            'MiniContract': '\uE93B',
            'Streaming': '\uE93E',
            'MusicInCollection': '\uE940',
            'OneDriveLogo': '\uE941',
            'CompassNW': '\uE942',
            'Code': '\uE943',
            'LightningBolt': '\uE945',
            'CalculatorMultiply': '\uE947',
            'CalculatorAddition': '\uE948',
            'CalculatorSubtract': '\uE949',
            'CalculatorPercentage': '\uE94C',
            'CalculatorEqualTo': '\uE94E',
            'PrintfaxPrinterFile': '\uE956',
            'StorageOptical': '\uE958',
            'Communications': '\uE95A',
            'Headset': '\uE95B',
            'Health': '\uE95E',
            'Webcam2': '\uE960',
            'FrontCamera': '\uE96B',
            'ChevronUpSmall': '\uE96D'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$f(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-3\"",
            src: "url('".concat(baseUrl, "fabric-icons-3-089e217a.woff') format('woff')")
        },
        icons: {
            'ChevronDownSmall': '\uE96E',
            'ChevronLeftSmall': '\uE96F',
            'ChevronRightSmall': '\uE970',
            'ChevronUpMed': '\uE971',
            'ChevronDownMed': '\uE972',
            'ChevronLeftMed': '\uE973',
            'ChevronRightMed': '\uE974',
            'Devices2': '\uE975',
            'PC1': '\uE977',
            'PresenceChickletVideo': '\uE979',
            'Reply': '\uE97A',
            'HalfAlpha': '\uE97E',
            'ConstructionCone': '\uE98F',
            'DoubleChevronLeftMed': '\uE991',
            'Volume0': '\uE992',
            'Volume1': '\uE993',
            'Volume2': '\uE994',
            'Volume3': '\uE995',
            'Chart': '\uE999',
            'Robot': '\uE99A',
            'Manufacturing': '\uE99C',
            'LockSolid': '\uE9A2',
            'FitPage': '\uE9A6',
            'FitWidth': '\uE9A7',
            'BidiLtr': '\uE9AA',
            'BidiRtl': '\uE9AB',
            'RightDoubleQuote': '\uE9B1',
            'Sunny': '\uE9BD',
            'CloudWeather': '\uE9BE',
            'Cloudy': '\uE9BF',
            'PartlyCloudyDay': '\uE9C0',
            'PartlyCloudyNight': '\uE9C1',
            'ClearNight': '\uE9C2',
            'RainShowersDay': '\uE9C3',
            'Rain': '\uE9C4',
            'Thunderstorms': '\uE9C6',
            'RainSnow': '\uE9C7',
            'Snow': '\uE9C8',
            'BlowingSnow': '\uE9C9',
            'Frigid': '\uE9CA',
            'Fog': '\uE9CB',
            'Squalls': '\uE9CC',
            'Duststorm': '\uE9CD',
            'Unknown': '\uE9CE',
            'Precipitation': '\uE9CF',
            'Ribbon': '\uE9D1',
            'AreaChart': '\uE9D2',
            'Assign': '\uE9D3',
            'FlowChart': '\uE9D4',
            'CheckList': '\uE9D5',
            'Diagnostic': '\uE9D9',
            'Generate': '\uE9DA',
            'LineChart': '\uE9E6',
            'Equalizer': '\uE9E9',
            'BarChartHorizontal': '\uE9EB',
            'BarChartVertical': '\uE9EC',
            'Freezing': '\uE9EF',
            'FunnelChart': '\uE9F1',
            'Processing': '\uE9F5',
            'Quantity': '\uE9F8',
            'ReportDocument': '\uE9F9',
            'StackColumnChart': '\uE9FC',
            'SnowShowerDay': '\uE9FD',
            'HailDay': '\uEA00',
            'WorkFlow': '\uEA01',
            'HourGlass': '\uEA03',
            'StoreLogoMed20': '\uEA04',
            'TimeSheet': '\uEA05',
            'TriangleSolid': '\uEA08',
            'UpgradeAnalysis': '\uEA0B',
            'VideoSolid': '\uEA0C',
            'RainShowersNight': '\uEA0F',
            'SnowShowerNight': '\uEA11',
            'Teamwork': '\uEA12',
            'HailNight': '\uEA13',
            'PeopleAdd': '\uEA15',
            'Glasses': '\uEA16',
            'DateTime2': '\uEA17',
            'Shield': '\uEA18',
            'Header1': '\uEA19',
            'PageAdd': '\uEA1A',
            'NumberedList': '\uEA1C',
            'PowerBILogo': '\uEA1E',
            'Info2': '\uEA1F',
            'MusicInCollectionFill': '\uEA36',
            'Asterisk': '\uEA38',
            'ErrorBadge': '\uEA39',
            'CircleFill': '\uEA3B',
            'Record2': '\uEA3F',
            'AllAppsMirrored': '\uEA40',
            'BookmarksMirrored': '\uEA41',
            'BulletedListMirrored': '\uEA42',
            'CaretHollowMirrored': '\uEA45',
            'CaretSolidMirrored': '\uEA46',
            'ChromeBackMirrored': '\uEA47',
            'ClearSelectionMirrored': '\uEA48',
            'ClosePaneMirrored': '\uEA49',
            'DockLeftMirrored': '\uEA4C',
            'DoubleChevronLeftMedMirrored': '\uEA4D',
            'GoMirrored': '\uEA4F'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$e(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-4\"",
            src: "url('".concat(baseUrl, "fabric-icons-4-a656cc0a.woff') format('woff')")
        },
        icons: {
            'HelpMirrored': '\uEA51',
            'ImportMirrored': '\uEA52',
            'ImportAllMirrored': '\uEA53',
            'ListMirrored': '\uEA55',
            'MailForwardMirrored': '\uEA56',
            'MailReplyMirrored': '\uEA57',
            'MailReplyAllMirrored': '\uEA58',
            'MiniContractMirrored': '\uEA59',
            'MiniExpandMirrored': '\uEA5A',
            'OpenPaneMirrored': '\uEA5B',
            'ParkingLocationMirrored': '\uEA5E',
            'SendMirrored': '\uEA63',
            'ShowResultsMirrored': '\uEA65',
            'ThumbnailViewMirrored': '\uEA67',
            'Media': '\uEA69',
            'Devices3': '\uEA6C',
            'Focus': '\uEA6F',
            'VideoLightOff': '\uEA74',
            'Lightbulb': '\uEA80',
            'StatusTriangle': '\uEA82',
            'VolumeDisabled': '\uEA85',
            'Puzzle': '\uEA86',
            'EmojiNeutral': '\uEA87',
            'EmojiDisappointed': '\uEA88',
            'HomeSolid': '\uEA8A',
            'Ringer': '\uEA8F',
            'PDF': '\uEA90',
            'HeartBroken': '\uEA92',
            'StoreLogo16': '\uEA96',
            'MultiSelectMirrored': '\uEA98',
            'Broom': '\uEA99',
            'AddToShoppingList': '\uEA9A',
            'Cocktails': '\uEA9D',
            'Wines': '\uEABF',
            'Articles': '\uEAC1',
            'Cycling': '\uEAC7',
            'DietPlanNotebook': '\uEAC8',
            'Pill': '\uEACB',
            'ExerciseTracker': '\uEACC',
            'HandsFree': '\uEAD0',
            'Medical': '\uEAD4',
            'Running': '\uEADA',
            'Weights': '\uEADB',
            'Trackers': '\uEADF',
            'AddNotes': '\uEAE3',
            'AllCurrency': '\uEAE4',
            'BarChart4': '\uEAE7',
            'CirclePlus': '\uEAEE',
            'Coffee': '\uEAEF',
            'Cotton': '\uEAF3',
            'Market': '\uEAFC',
            'Money': '\uEAFD',
            'PieDouble': '\uEB04',
            'PieSingle': '\uEB05',
            'RemoveFilter': '\uEB08',
            'Savings': '\uEB0B',
            'Sell': '\uEB0C',
            'StockDown': '\uEB0F',
            'StockUp': '\uEB11',
            'Lamp': '\uEB19',
            'Source': '\uEB1B',
            'MSNVideos': '\uEB1C',
            'Cricket': '\uEB1E',
            'Golf': '\uEB1F',
            'Baseball': '\uEB20',
            'Soccer': '\uEB21',
            'MoreSports': '\uEB22',
            'AutoRacing': '\uEB24',
            'CollegeHoops': '\uEB25',
            'CollegeFootball': '\uEB26',
            'ProFootball': '\uEB27',
            'ProHockey': '\uEB28',
            'Rugby': '\uEB2D',
            'SubstitutionsIn': '\uEB31',
            'Tennis': '\uEB33',
            'Arrivals': '\uEB34',
            'Design': '\uEB3C',
            'Website': '\uEB41',
            'Drop': '\uEB42',
            'HistoricalWeather': '\uEB43',
            'SkiResorts': '\uEB45',
            'Snowflake': '\uEB46',
            'BusSolid': '\uEB47',
            'FerrySolid': '\uEB48',
            'AirplaneSolid': '\uEB4C',
            'TrainSolid': '\uEB4D',
            'Ticket': '\uEB54',
            'WifiWarning4': '\uEB63',
            'Devices4': '\uEB66',
            'AzureLogo': '\uEB6A',
            'BingLogo': '\uEB6B',
            'MSNLogo': '\uEB6C',
            'OutlookLogoInverse': '\uEB6D',
            'OfficeLogo': '\uEB6E',
            'SkypeLogo': '\uEB6F',
            'Door': '\uEB75',
            'EditMirrored': '\uEB7E',
            'GiftCard': '\uEB8E',
            'DoubleBookmark': '\uEB8F',
            'StatusErrorFull': '\uEB90'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$d(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-5\"",
            src: "url('".concat(baseUrl, "fabric-icons-5-f95ba260.woff') format('woff')")
        },
        icons: {
            'Certificate': '\uEB95',
            'FastForward': '\uEB9D',
            'Rewind': '\uEB9E',
            'Photo2': '\uEB9F',
            'OpenSource': '\uEBC2',
            'Movers': '\uEBCD',
            'CloudDownload': '\uEBD3',
            'Family': '\uEBDA',
            'WindDirection': '\uEBE6',
            'Bug': '\uEBE8',
            'SiteScan': '\uEBEC',
            'BrowserScreenShot': '\uEBED',
            'F12DevTools': '\uEBEE',
            'CSS': '\uEBEF',
            'JS': '\uEBF0',
            'DeliveryTruck': '\uEBF4',
            'ReminderPerson': '\uEBF7',
            'ReminderGroup': '\uEBF8',
            'ReminderTime': '\uEBF9',
            'TabletMode': '\uEBFC',
            'Umbrella': '\uEC04',
            'NetworkTower': '\uEC05',
            'CityNext': '\uEC06',
            'CityNext2': '\uEC07',
            'Section': '\uEC0C',
            'OneNoteLogoInverse': '\uEC0D',
            'ToggleFilled': '\uEC11',
            'ToggleBorder': '\uEC12',
            'SliderThumb': '\uEC13',
            'ToggleThumb': '\uEC14',
            'Documentation': '\uEC17',
            'Badge': '\uEC1B',
            'Giftbox': '\uEC1F',
            'VisualStudioLogo': '\uEC22',
            'HomeGroup': '\uEC26',
            'ExcelLogoInverse': '\uEC28',
            'WordLogoInverse': '\uEC29',
            'PowerPointLogoInverse': '\uEC2A',
            'Cafe': '\uEC32',
            'SpeedHigh': '\uEC4A',
            'Commitments': '\uEC4D',
            'ThisPC': '\uEC4E',
            'MusicNote': '\uEC4F',
            'MicOff': '\uEC54',
            'PlaybackRate1x': '\uEC57',
            'EdgeLogo': '\uEC60',
            'CompletedSolid': '\uEC61',
            'AlbumRemove': '\uEC62',
            'MessageFill': '\uEC70',
            'TabletSelected': '\uEC74',
            'MobileSelected': '\uEC75',
            'LaptopSelected': '\uEC76',
            'TVMonitorSelected': '\uEC77',
            'DeveloperTools': '\uEC7A',
            'Shapes': '\uEC7C',
            'InsertTextBox': '\uEC7D',
            'LowerBrightness': '\uEC8A',
            'WebComponents': '\uEC8B',
            'OfflineStorage': '\uEC8C',
            'DOM': '\uEC8D',
            'CloudUpload': '\uEC8E',
            'ScrollUpDown': '\uEC8F',
            'DateTime': '\uEC92',
            'Event': '\uECA3',
            'Cake': '\uECA4',
            'Org': '\uECA6',
            'PartyLeader': '\uECA7',
            'DRM': '\uECA8',
            'CloudAdd': '\uECA9',
            'AppIconDefault': '\uECAA',
            'Photo2Add': '\uECAB',
            'Photo2Remove': '\uECAC',
            'Calories': '\uECAD',
            'POI': '\uECAF',
            'AddTo': '\uECC8',
            'RadioBtnOff': '\uECCA',
            'RadioBtnOn': '\uECCB',
            'ExploreContent': '\uECCD',
            'Product': '\uECDC',
            'ProgressLoopInner': '\uECDE',
            'ProgressLoopOuter': '\uECDF',
            'Blocked2': '\uECE4',
            'FangBody': '\uECEB',
            'Toolbox': '\uECED',
            'PageHeader': '\uECEE',
            'ChatInviteFriend': '\uECFE',
            'Brush': '\uECFF',
            'Shirt': '\uED00',
            'Crown': '\uED01',
            'Diamond': '\uED02',
            'ScaleUp': '\uED09',
            'QRCode': '\uED14',
            'Feedback': '\uED15',
            'SharepointLogoInverse': '\uED18',
            'YammerLogo': '\uED19',
            'Hide': '\uED1A',
            'Uneditable': '\uED1D',
            'ReturnToSession': '\uED24',
            'OpenFolderHorizontal': '\uED25',
            'CalendarMirrored': '\uED28'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$c(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-6\"",
            src: "url('".concat(baseUrl, "fabric-icons-6-ef6fd590.woff') format('woff')")
        },
        icons: {
            'SwayLogoInverse': '\uED29',
            'OutOfOffice': '\uED34',
            'Trophy': '\uED3F',
            'ReopenPages': '\uED50',
            'EmojiTabSymbols': '\uED58',
            'AADLogo': '\uED68',
            'AccessLogo': '\uED69',
            'AdminALogoInverse32': '\uED6A',
            'AdminCLogoInverse32': '\uED6B',
            'AdminDLogoInverse32': '\uED6C',
            'AdminELogoInverse32': '\uED6D',
            'AdminLLogoInverse32': '\uED6E',
            'AdminMLogoInverse32': '\uED6F',
            'AdminOLogoInverse32': '\uED70',
            'AdminPLogoInverse32': '\uED71',
            'AdminSLogoInverse32': '\uED72',
            'AdminYLogoInverse32': '\uED73',
            'DelveLogoInverse': '\uED76',
            'ExchangeLogoInverse': '\uED78',
            'LyncLogo': '\uED79',
            'OfficeVideoLogoInverse': '\uED7A',
            'SocialListeningLogo': '\uED7C',
            'VisioLogoInverse': '\uED7D',
            'Balloons': '\uED7E',
            'Cat': '\uED7F',
            'MailAlert': '\uED80',
            'MailCheck': '\uED81',
            'MailLowImportance': '\uED82',
            'MailPause': '\uED83',
            'MailRepeat': '\uED84',
            'SecurityGroup': '\uED85',
            'Table': '\uED86',
            'VoicemailForward': '\uED87',
            'VoicemailReply': '\uED88',
            'Waffle': '\uED89',
            'RemoveEvent': '\uED8A',
            'EventInfo': '\uED8B',
            'ForwardEvent': '\uED8C',
            'WipePhone': '\uED8D',
            'AddOnlineMeeting': '\uED8E',
            'JoinOnlineMeeting': '\uED8F',
            'RemoveLink': '\uED90',
            'PeopleBlock': '\uED91',
            'PeopleRepeat': '\uED92',
            'PeopleAlert': '\uED93',
            'PeoplePause': '\uED94',
            'TransferCall': '\uED95',
            'AddPhone': '\uED96',
            'UnknownCall': '\uED97',
            'NoteReply': '\uED98',
            'NoteForward': '\uED99',
            'NotePinned': '\uED9A',
            'RemoveOccurrence': '\uED9B',
            'Timeline': '\uED9C',
            'EditNote': '\uED9D',
            'CircleHalfFull': '\uED9E',
            'Room': '\uED9F',
            'Unsubscribe': '\uEDA0',
            'Subscribe': '\uEDA1',
            'HardDrive': '\uEDA2',
            'RecurringTask': '\uEDB2',
            'TaskManager': '\uEDB7',
            'TaskManagerMirrored': '\uEDB8',
            'Combine': '\uEDBB',
            'Split': '\uEDBC',
            'DoubleChevronUp': '\uEDBD',
            'DoubleChevronLeft': '\uEDBE',
            'DoubleChevronRight': '\uEDBF',
            'TextBox': '\uEDC2',
            'TextField': '\uEDC3',
            'NumberField': '\uEDC4',
            'Dropdown': '\uEDC5',
            'PenWorkspace': '\uEDC6',
            'BookingsLogo': '\uEDC7',
            'ClassNotebookLogoInverse': '\uEDC8',
            'DelveAnalyticsLogo': '\uEDCA',
            'DocsLogoInverse': '\uEDCB',
            'Dynamics365Logo': '\uEDCC',
            'DynamicSMBLogo': '\uEDCD',
            'OfficeAssistantLogo': '\uEDCE',
            'OfficeStoreLogo': '\uEDCF',
            'OneNoteEduLogoInverse': '\uEDD0',
            'PlannerLogo': '\uEDD1',
            'PowerApps': '\uEDD2',
            'Suitcase': '\uEDD3',
            'ProjectLogoInverse': '\uEDD4',
            'CaretLeft8': '\uEDD5',
            'CaretRight8': '\uEDD6',
            'CaretUp8': '\uEDD7',
            'CaretDown8': '\uEDD8',
            'CaretLeftSolid8': '\uEDD9',
            'CaretRightSolid8': '\uEDDA',
            'CaretUpSolid8': '\uEDDB',
            'CaretDownSolid8': '\uEDDC',
            'ClearFormatting': '\uEDDD',
            'Superscript': '\uEDDE',
            'Subscript': '\uEDDF',
            'Strikethrough': '\uEDE0',
            'Export': '\uEDE1',
            'ExportMirrored': '\uEDE2'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$b(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-7\"",
            src: "url('".concat(baseUrl, "fabric-icons-7-2b97bb99.woff') format('woff')")
        },
        icons: {
            'SingleBookmark': '\uEDFF',
            'SingleBookmarkSolid': '\uEE00',
            'DoubleChevronDown': '\uEE04',
            'FollowUser': '\uEE05',
            'ReplyAll': '\uEE0A',
            'WorkforceManagement': '\uEE0F',
            'RecruitmentManagement': '\uEE12',
            'Questionnaire': '\uEE19',
            'ManagerSelfService': '\uEE23',
            'ProductionFloorManagement': '\uEE29',
            'ProductRelease': '\uEE2E',
            'ProductVariant': '\uEE30',
            'ReplyMirrored': '\uEE35',
            'ReplyAllMirrored': '\uEE36',
            'Medal': '\uEE38',
            'AddGroup': '\uEE3D',
            'QuestionnaireMirrored': '\uEE4B',
            'CloudImportExport': '\uEE55',
            'TemporaryUser': '\uEE58',
            'CaretSolid16': '\uEE62',
            'GroupedDescending': '\uEE66',
            'GroupedAscending': '\uEE67',
            'AwayStatus': '\uEE6A',
            'MyMoviesTV': '\uEE6C',
            'GenericScan': '\uEE6F',
            'AustralianRules': '\uEE70',
            'WifiEthernet': '\uEE77',
            'TrackersMirrored': '\uEE92',
            'DateTimeMirrored': '\uEE93',
            'StopSolid': '\uEE95',
            'DoubleChevronUp12': '\uEE96',
            'DoubleChevronDown12': '\uEE97',
            'DoubleChevronLeft12': '\uEE98',
            'DoubleChevronRight12': '\uEE99',
            'CalendarAgenda': '\uEE9A',
            'ConnectVirtualMachine': '\uEE9D',
            'AddEvent': '\uEEB5',
            'AssetLibrary': '\uEEB6',
            'DataConnectionLibrary': '\uEEB7',
            'DocLibrary': '\uEEB8',
            'FormLibrary': '\uEEB9',
            'FormLibraryMirrored': '\uEEBA',
            'ReportLibrary': '\uEEBB',
            'ReportLibraryMirrored': '\uEEBC',
            'ContactCard': '\uEEBD',
            'CustomList': '\uEEBE',
            'CustomListMirrored': '\uEEBF',
            'IssueTracking': '\uEEC0',
            'IssueTrackingMirrored': '\uEEC1',
            'PictureLibrary': '\uEEC2',
            'OfficeAddinsLogo': '\uEEC7',
            'OfflineOneDriveParachute': '\uEEC8',
            'OfflineOneDriveParachuteDisabled': '\uEEC9',
            'TriangleSolidUp12': '\uEECC',
            'TriangleSolidDown12': '\uEECD',
            'TriangleSolidLeft12': '\uEECE',
            'TriangleSolidRight12': '\uEECF',
            'TriangleUp12': '\uEED0',
            'TriangleDown12': '\uEED1',
            'TriangleLeft12': '\uEED2',
            'TriangleRight12': '\uEED3',
            'ArrowUpRight8': '\uEED4',
            'ArrowDownRight8': '\uEED5',
            'DocumentSet': '\uEED6',
            'GoToDashboard': '\uEEED',
            'DelveAnalytics': '\uEEEE',
            'ArrowUpRightMirrored8': '\uEEEF',
            'ArrowDownRightMirrored8': '\uEEF0',
            'CompanyDirectory': '\uEF0D',
            'OpenEnrollment': '\uEF1C',
            'CompanyDirectoryMirrored': '\uEF2B',
            'OneDriveAdd': '\uEF32',
            'ProfileSearch': '\uEF35',
            'Header2': '\uEF36',
            'Header3': '\uEF37',
            'Header4': '\uEF38',
            'RingerSolid': '\uEF3A',
            'Eyedropper': '\uEF3C',
            'MarketDown': '\uEF42',
            'CalendarWorkWeek': '\uEF51',
            'SidePanel': '\uEF52',
            'GlobeFavorite': '\uEF53',
            'CaretTopLeftSolid8': '\uEF54',
            'CaretTopRightSolid8': '\uEF55',
            'ViewAll2': '\uEF56',
            'DocumentReply': '\uEF57',
            'PlayerSettings': '\uEF58',
            'ReceiptForward': '\uEF59',
            'ReceiptReply': '\uEF5A',
            'ReceiptCheck': '\uEF5B',
            'Fax': '\uEF5C',
            'RecurringEvent': '\uEF5D',
            'ReplyAlt': '\uEF5E',
            'ReplyAllAlt': '\uEF5F',
            'EditStyle': '\uEF60',
            'EditMail': '\uEF61',
            'Lifesaver': '\uEF62',
            'LifesaverLock': '\uEF63',
            'InboxCheck': '\uEF64',
            'FolderSearch': '\uEF65'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$a(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-8\"",
            src: "url('".concat(baseUrl, "fabric-icons-8-6fdf1528.woff') format('woff')")
        },
        icons: {
            'CollapseMenu': '\uEF66',
            'ExpandMenu': '\uEF67',
            'Boards': '\uEF68',
            'SunAdd': '\uEF69',
            'SunQuestionMark': '\uEF6A',
            'LandscapeOrientation': '\uEF6B',
            'DocumentSearch': '\uEF6C',
            'PublicCalendar': '\uEF6D',
            'PublicContactCard': '\uEF6E',
            'PublicEmail': '\uEF6F',
            'PublicFolder': '\uEF70',
            'WordDocument': '\uEF71',
            'PowerPointDocument': '\uEF72',
            'ExcelDocument': '\uEF73',
            'GroupedList': '\uEF74',
            'ClassroomLogo': '\uEF75',
            'Sections': '\uEF76',
            'EditPhoto': '\uEF77',
            'Starburst': '\uEF78',
            'ShareiOS': '\uEF79',
            'AirTickets': '\uEF7A',
            'PencilReply': '\uEF7B',
            'Tiles2': '\uEF7C',
            'SkypeCircleCheck': '\uEF7D',
            'SkypeCircleClock': '\uEF7E',
            'SkypeCircleMinus': '\uEF7F',
            'SkypeMessage': '\uEF83',
            'ClosedCaption': '\uEF84',
            'ATPLogo': '\uEF85',
            'OfficeFormsLogoInverse': '\uEF86',
            'RecycleBin': '\uEF87',
            'EmptyRecycleBin': '\uEF88',
            'Hide2': '\uEF89',
            'Breadcrumb': '\uEF8C',
            'BirthdayCake': '\uEF8D',
            'TimeEntry': '\uEF95',
            'CRMProcesses': '\uEFB1',
            'PageEdit': '\uEFB6',
            'PageArrowRight': '\uEFB8',
            'PageRemove': '\uEFBA',
            'Database': '\uEFC7',
            'DataManagementSettings': '\uEFC8',
            'CRMServices': '\uEFD2',
            'EditContact': '\uEFD3',
            'ConnectContacts': '\uEFD4',
            'AppIconDefaultAdd': '\uEFDA',
            'AppIconDefaultList': '\uEFDE',
            'ActivateOrders': '\uEFE0',
            'DeactivateOrders': '\uEFE1',
            'ProductCatalog': '\uEFE8',
            'ScatterChart': '\uEFEB',
            'AccountActivity': '\uEFF4',
            'DocumentManagement': '\uEFFC',
            'CRMReport': '\uEFFE',
            'KnowledgeArticle': '\uF000',
            'Relationship': '\uF003',
            'HomeVerify': '\uF00E',
            'ZipFolder': '\uF012',
            'SurveyQuestions': '\uF01B',
            'TextDocument': '\uF029',
            'TextDocumentShared': '\uF02B',
            'PageCheckedOut': '\uF02C',
            'PageShared': '\uF02D',
            'SaveAndClose': '\uF038',
            'Script': '\uF03A',
            'Archive': '\uF03F',
            'ActivityFeed': '\uF056',
            'Compare': '\uF057',
            'EventDate': '\uF059',
            'ArrowUpRight': '\uF069',
            'CaretRight': '\uF06B',
            'SetAction': '\uF071',
            'ChatBot': '\uF08B',
            'CaretSolidLeft': '\uF08D',
            'CaretSolidDown': '\uF08E',
            'CaretSolidRight': '\uF08F',
            'CaretSolidUp': '\uF090',
            'PowerAppsLogo': '\uF091',
            'PowerApps2Logo': '\uF092',
            'SearchIssue': '\uF09A',
            'SearchIssueMirrored': '\uF09B',
            'FabricAssetLibrary': '\uF09C',
            'FabricDataConnectionLibrary': '\uF09D',
            'FabricDocLibrary': '\uF09E',
            'FabricFormLibrary': '\uF09F',
            'FabricFormLibraryMirrored': '\uF0A0',
            'FabricReportLibrary': '\uF0A1',
            'FabricReportLibraryMirrored': '\uF0A2',
            'FabricPublicFolder': '\uF0A3',
            'FabricFolderSearch': '\uF0A4',
            'FabricMovetoFolder': '\uF0A5',
            'FabricUnsyncFolder': '\uF0A6',
            'FabricSyncFolder': '\uF0A7',
            'FabricOpenFolderHorizontal': '\uF0A8',
            'FabricFolder': '\uF0A9',
            'FabricFolderFill': '\uF0AA',
            'FabricNewFolder': '\uF0AB',
            'FabricPictureLibrary': '\uF0AC',
            'PhotoVideoMedia': '\uF0B1',
            'AddFavorite': '\uF0C8'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$9(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-9\"",
            src: "url('".concat(baseUrl, "fabric-icons-9-c6162b42.woff') format('woff')")
        },
        icons: {
            'AddFavoriteFill': '\uF0C9',
            'BufferTimeBefore': '\uF0CF',
            'BufferTimeAfter': '\uF0D0',
            'BufferTimeBoth': '\uF0D1',
            'PublishContent': '\uF0D4',
            'ClipboardList': '\uF0E3',
            'ClipboardListMirrored': '\uF0E4',
            'CannedChat': '\uF0F2',
            'SkypeForBusinessLogo': '\uF0FC',
            'TabCenter': '\uF100',
            'PageCheckedin': '\uF104',
            'PageList': '\uF106',
            'ReadOutLoud': '\uF112',
            'CaretBottomLeftSolid8': '\uF121',
            'CaretBottomRightSolid8': '\uF122',
            'FolderHorizontal': '\uF12B',
            'MicrosoftStaffhubLogo': '\uF130',
            'GiftboxOpen': '\uF133',
            'StatusCircleOuter': '\uF136',
            'StatusCircleInner': '\uF137',
            'StatusCircleRing': '\uF138',
            'StatusTriangleOuter': '\uF139',
            'StatusTriangleInner': '\uF13A',
            'StatusTriangleExclamation': '\uF13B',
            'StatusCircleExclamation': '\uF13C',
            'StatusCircleErrorX': '\uF13D',
            'StatusCircleInfo': '\uF13F',
            'StatusCircleBlock': '\uF140',
            'StatusCircleBlock2': '\uF141',
            'StatusCircleQuestionMark': '\uF142',
            'StatusCircleSync': '\uF143',
            'Toll': '\uF160',
            'ExploreContentSingle': '\uF164',
            'CollapseContent': '\uF165',
            'CollapseContentSingle': '\uF166',
            'InfoSolid': '\uF167',
            'GroupList': '\uF168',
            'ProgressRingDots': '\uF16A',
            'CaloriesAdd': '\uF172',
            'BranchFork': '\uF173',
            'MuteChat': '\uF17A',
            'AddHome': '\uF17B',
            'AddWork': '\uF17C',
            'MobileReport': '\uF18A',
            'ScaleVolume': '\uF18C',
            'HardDriveGroup': '\uF18F',
            'FastMode': '\uF19A',
            'ToggleLeft': '\uF19E',
            'ToggleRight': '\uF19F',
            'TriangleShape': '\uF1A7',
            'RectangleShape': '\uF1A9',
            'CubeShape': '\uF1AA',
            'Trophy2': '\uF1AE',
            'BucketColor': '\uF1B6',
            'BucketColorFill': '\uF1B7',
            'Taskboard': '\uF1C2',
            'SingleColumn': '\uF1D3',
            'DoubleColumn': '\uF1D4',
            'TripleColumn': '\uF1D5',
            'ColumnLeftTwoThirds': '\uF1D6',
            'ColumnRightTwoThirds': '\uF1D7',
            'AccessLogoFill': '\uF1DB',
            'AnalyticsLogo': '\uF1DE',
            'AnalyticsQuery': '\uF1DF',
            'NewAnalyticsQuery': '\uF1E0',
            'AnalyticsReport': '\uF1E1',
            'WordLogo': '\uF1E3',
            'WordLogoFill': '\uF1E4',
            'ExcelLogo': '\uF1E5',
            'ExcelLogoFill': '\uF1E6',
            'OneNoteLogo': '\uF1E7',
            'OneNoteLogoFill': '\uF1E8',
            'OutlookLogo': '\uF1E9',
            'OutlookLogoFill': '\uF1EA',
            'PowerPointLogo': '\uF1EB',
            'PowerPointLogoFill': '\uF1EC',
            'PublisherLogo': '\uF1ED',
            'PublisherLogoFill': '\uF1EE',
            'ScheduleEventAction': '\uF1EF',
            'FlameSolid': '\uF1F3',
            'ServerProcesses': '\uF1FE',
            'Server': '\uF201',
            'SaveAll': '\uF203',
            'LinkedInLogo': '\uF20A',
            'Decimals': '\uF218',
            'SidePanelMirrored': '\uF221',
            'ProtectRestrict': '\uF22A',
            'Blog': '\uF22B',
            'UnknownMirrored': '\uF22E',
            'PublicContactCardMirrored': '\uF230',
            'GridViewSmall': '\uF232',
            'GridViewMedium': '\uF233',
            'GridViewLarge': '\uF234',
            'Step': '\uF241',
            'StepInsert': '\uF242',
            'StepShared': '\uF243',
            'StepSharedAdd': '\uF244',
            'StepSharedInsert': '\uF245',
            'ViewDashboard': '\uF246',
            'ViewList': '\uF247'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$8(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-10\"",
            src: "url('".concat(baseUrl, "fabric-icons-10-c4ded8e4.woff') format('woff')")
        },
        icons: {
            'ViewListGroup': '\uF248',
            'ViewListTree': '\uF249',
            'TriggerAuto': '\uF24A',
            'TriggerUser': '\uF24B',
            'PivotChart': '\uF24C',
            'StackedBarChart': '\uF24D',
            'StackedLineChart': '\uF24E',
            'BuildQueue': '\uF24F',
            'BuildQueueNew': '\uF250',
            'UserFollowed': '\uF25C',
            'ContactLink': '\uF25F',
            'Stack': '\uF26F',
            'Bullseye': '\uF272',
            'VennDiagram': '\uF273',
            'FiveTileGrid': '\uF274',
            'FocalPoint': '\uF277',
            'Insert': '\uF278',
            'RingerRemove': '\uF279',
            'TeamsLogoInverse': '\uF27A',
            'TeamsLogo': '\uF27B',
            'TeamsLogoFill': '\uF27C',
            'SkypeForBusinessLogoFill': '\uF27D',
            'SharepointLogo': '\uF27E',
            'SharepointLogoFill': '\uF27F',
            'DelveLogo': '\uF280',
            'DelveLogoFill': '\uF281',
            'OfficeVideoLogo': '\uF282',
            'OfficeVideoLogoFill': '\uF283',
            'ExchangeLogo': '\uF284',
            'ExchangeLogoFill': '\uF285',
            'Signin': '\uF286',
            'DocumentApproval': '\uF28B',
            'CloneToDesktop': '\uF28C',
            'InstallToDrive': '\uF28D',
            'Blur': '\uF28E',
            'Build': '\uF28F',
            'ProcessMetaTask': '\uF290',
            'BranchFork2': '\uF291',
            'BranchLocked': '\uF292',
            'BranchCommit': '\uF293',
            'BranchCompare': '\uF294',
            'BranchMerge': '\uF295',
            'BranchPullRequest': '\uF296',
            'BranchSearch': '\uF297',
            'BranchShelveset': '\uF298',
            'RawSource': '\uF299',
            'MergeDuplicate': '\uF29A',
            'RowsGroup': '\uF29B',
            'RowsChild': '\uF29C',
            'Deploy': '\uF29D',
            'Redeploy': '\uF29E',
            'ServerEnviroment': '\uF29F',
            'VisioDiagram': '\uF2A0',
            'HighlightMappedShapes': '\uF2A1',
            'TextCallout': '\uF2A2',
            'IconSetsFlag': '\uF2A4',
            'VisioLogo': '\uF2A7',
            'VisioLogoFill': '\uF2A8',
            'VisioDocument': '\uF2A9',
            'TimelineProgress': '\uF2AA',
            'TimelineDelivery': '\uF2AB',
            'Backlog': '\uF2AC',
            'TeamFavorite': '\uF2AD',
            'TaskGroup': '\uF2AE',
            'TaskGroupMirrored': '\uF2AF',
            'ScopeTemplate': '\uF2B0',
            'AssessmentGroupTemplate': '\uF2B1',
            'NewTeamProject': '\uF2B2',
            'CommentAdd': '\uF2B3',
            'CommentNext': '\uF2B4',
            'CommentPrevious': '\uF2B5',
            'ShopServer': '\uF2B6',
            'LocaleLanguage': '\uF2B7',
            'QueryList': '\uF2B8',
            'UserSync': '\uF2B9',
            'UserPause': '\uF2BA',
            'StreamingOff': '\uF2BB',
            'ArrowTallUpLeft': '\uF2BD',
            'ArrowTallUpRight': '\uF2BE',
            'ArrowTallDownLeft': '\uF2BF',
            'ArrowTallDownRight': '\uF2C0',
            'FieldEmpty': '\uF2C1',
            'FieldFilled': '\uF2C2',
            'FieldChanged': '\uF2C3',
            'FieldNotChanged': '\uF2C4',
            'RingerOff': '\uF2C5',
            'PlayResume': '\uF2C6',
            'BulletedList2': '\uF2C7',
            'BulletedList2Mirrored': '\uF2C8',
            'ImageCrosshair': '\uF2C9',
            'GitGraph': '\uF2CA',
            'Repo': '\uF2CB',
            'RepoSolid': '\uF2CC',
            'FolderQuery': '\uF2CD',
            'FolderList': '\uF2CE',
            'FolderListMirrored': '\uF2CF',
            'LocationOutline': '\uF2D0',
            'POISolid': '\uF2D1',
            'CalculatorNotEqualTo': '\uF2D2',
            'BoxSubtractSolid': '\uF2D3'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$7(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-11\"",
            src: "url('".concat(baseUrl, "fabric-icons-11-2a8393d6.woff') format('woff')")
        },
        icons: {
            'BoxAdditionSolid': '\uF2D4',
            'BoxMultiplySolid': '\uF2D5',
            'BoxPlaySolid': '\uF2D6',
            'BoxCheckmarkSolid': '\uF2D7',
            'CirclePauseSolid': '\uF2D8',
            'CirclePause': '\uF2D9',
            'MSNVideosSolid': '\uF2DA',
            'CircleStopSolid': '\uF2DB',
            'CircleStop': '\uF2DC',
            'NavigateBack': '\uF2DD',
            'NavigateBackMirrored': '\uF2DE',
            'NavigateForward': '\uF2DF',
            'NavigateForwardMirrored': '\uF2E0',
            'UnknownSolid': '\uF2E1',
            'UnknownMirroredSolid': '\uF2E2',
            'CircleAddition': '\uF2E3',
            'CircleAdditionSolid': '\uF2E4',
            'FilePDB': '\uF2E5',
            'FileTemplate': '\uF2E6',
            'FileSQL': '\uF2E7',
            'FileJAVA': '\uF2E8',
            'FileASPX': '\uF2E9',
            'FileCSS': '\uF2EA',
            'FileSass': '\uF2EB',
            'FileLess': '\uF2EC',
            'FileHTML': '\uF2ED',
            'JavaScriptLanguage': '\uF2EE',
            'CSharpLanguage': '\uF2EF',
            'CSharp': '\uF2F0',
            'VisualBasicLanguage': '\uF2F1',
            'VB': '\uF2F2',
            'CPlusPlusLanguage': '\uF2F3',
            'CPlusPlus': '\uF2F4',
            'FSharpLanguage': '\uF2F5',
            'FSharp': '\uF2F6',
            'TypeScriptLanguage': '\uF2F7',
            'PythonLanguage': '\uF2F8',
            'PY': '\uF2F9',
            'CoffeeScript': '\uF2FA',
            'MarkDownLanguage': '\uF2FB',
            'FullWidth': '\uF2FE',
            'FullWidthEdit': '\uF2FF',
            'Plug': '\uF300',
            'PlugSolid': '\uF301',
            'PlugConnected': '\uF302',
            'PlugDisconnected': '\uF303',
            'UnlockSolid': '\uF304',
            'Variable': '\uF305',
            'Parameter': '\uF306',
            'CommentUrgent': '\uF307',
            'Storyboard': '\uF308',
            'DiffInline': '\uF309',
            'DiffSideBySide': '\uF30A',
            'ImageDiff': '\uF30B',
            'ImagePixel': '\uF30C',
            'FileBug': '\uF30D',
            'FileCode': '\uF30E',
            'FileComment': '\uF30F',
            'BusinessHoursSign': '\uF310',
            'FileImage': '\uF311',
            'FileSymlink': '\uF312',
            'AutoFillTemplate': '\uF313',
            'WorkItem': '\uF314',
            'WorkItemBug': '\uF315',
            'LogRemove': '\uF316',
            'ColumnOptions': '\uF317',
            'Packages': '\uF318',
            'BuildIssue': '\uF319',
            'AssessmentGroup': '\uF31A',
            'VariableGroup': '\uF31B',
            'FullHistory': '\uF31C',
            'Wheelchair': '\uF31F',
            'SingleColumnEdit': '\uF321',
            'DoubleColumnEdit': '\uF322',
            'TripleColumnEdit': '\uF323',
            'ColumnLeftTwoThirdsEdit': '\uF324',
            'ColumnRightTwoThirdsEdit': '\uF325',
            'StreamLogo': '\uF329',
            'PassiveAuthentication': '\uF32A',
            'AlertSolid': '\uF331',
            'MegaphoneSolid': '\uF332',
            'TaskSolid': '\uF333',
            'ConfigurationSolid': '\uF334',
            'BugSolid': '\uF335',
            'CrownSolid': '\uF336',
            'Trophy2Solid': '\uF337',
            'QuickNoteSolid': '\uF338',
            'ConstructionConeSolid': '\uF339',
            'PageListSolid': '\uF33A',
            'PageListMirroredSolid': '\uF33B',
            'StarburstSolid': '\uF33C',
            'ReadingModeSolid': '\uF33D',
            'SadSolid': '\uF33E',
            'HealthSolid': '\uF33F',
            'ShieldSolid': '\uF340',
            'GiftBoxSolid': '\uF341',
            'ShoppingCartSolid': '\uF342',
            'MailSolid': '\uF343',
            'ChatSolid': '\uF344',
            'RibbonSolid': '\uF345'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$6(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-12\"",
            src: "url('".concat(baseUrl, "fabric-icons-12-7e945a1e.woff') format('woff')")
        },
        icons: {
            'FinancialSolid': '\uF346',
            'FinancialMirroredSolid': '\uF347',
            'HeadsetSolid': '\uF348',
            'PermissionsSolid': '\uF349',
            'ParkingSolid': '\uF34A',
            'ParkingMirroredSolid': '\uF34B',
            'DiamondSolid': '\uF34C',
            'AsteriskSolid': '\uF34D',
            'OfflineStorageSolid': '\uF34E',
            'BankSolid': '\uF34F',
            'DecisionSolid': '\uF350',
            'Parachute': '\uF351',
            'ParachuteSolid': '\uF352',
            'FiltersSolid': '\uF353',
            'ColorSolid': '\uF354',
            'ReviewSolid': '\uF355',
            'ReviewRequestSolid': '\uF356',
            'ReviewRequestMirroredSolid': '\uF357',
            'ReviewResponseSolid': '\uF358',
            'FeedbackRequestSolid': '\uF359',
            'FeedbackRequestMirroredSolid': '\uF35A',
            'FeedbackResponseSolid': '\uF35B',
            'WorkItemBar': '\uF35C',
            'WorkItemBarSolid': '\uF35D',
            'Separator': '\uF35E',
            'NavigateExternalInline': '\uF35F',
            'PlanView': '\uF360',
            'TimelineMatrixView': '\uF361',
            'EngineeringGroup': '\uF362',
            'ProjectCollection': '\uF363',
            'CaretBottomRightCenter8': '\uF364',
            'CaretBottomLeftCenter8': '\uF365',
            'CaretTopRightCenter8': '\uF366',
            'CaretTopLeftCenter8': '\uF367',
            'DonutChart': '\uF368',
            'ChevronUnfold10': '\uF369',
            'ChevronFold10': '\uF36A',
            'DoubleChevronDown8': '\uF36B',
            'DoubleChevronUp8': '\uF36C',
            'DoubleChevronLeft8': '\uF36D',
            'DoubleChevronRight8': '\uF36E',
            'ChevronDownEnd6': '\uF36F',
            'ChevronUpEnd6': '\uF370',
            'ChevronLeftEnd6': '\uF371',
            'ChevronRightEnd6': '\uF372',
            'ContextMenu': '\uF37C',
            'AzureAPIManagement': '\uF37F',
            'AzureServiceEndpoint': '\uF380',
            'VSTSLogo': '\uF381',
            'VSTSAltLogo1': '\uF382',
            'VSTSAltLogo2': '\uF383',
            'FileTypeSolution': '\uF387',
            'WordLogoInverse16': '\uF390',
            'WordLogo16': '\uF391',
            'WordLogoFill16': '\uF392',
            'PowerPointLogoInverse16': '\uF393',
            'PowerPointLogo16': '\uF394',
            'PowerPointLogoFill16': '\uF395',
            'ExcelLogoInverse16': '\uF396',
            'ExcelLogo16': '\uF397',
            'ExcelLogoFill16': '\uF398',
            'OneNoteLogoInverse16': '\uF399',
            'OneNoteLogo16': '\uF39A',
            'OneNoteLogoFill16': '\uF39B',
            'OutlookLogoInverse16': '\uF39C',
            'OutlookLogo16': '\uF39D',
            'OutlookLogoFill16': '\uF39E',
            'PublisherLogoInverse16': '\uF39F',
            'PublisherLogo16': '\uF3A0',
            'PublisherLogoFill16': '\uF3A1',
            'VisioLogoInverse16': '\uF3A2',
            'VisioLogo16': '\uF3A3',
            'VisioLogoFill16': '\uF3A4',
            'TestBeaker': '\uF3A5',
            'TestBeakerSolid': '\uF3A6',
            'TestExploreSolid': '\uF3A7',
            'TestAutoSolid': '\uF3A8',
            'TestUserSolid': '\uF3A9',
            'TestImpactSolid': '\uF3AA',
            'TestPlan': '\uF3AB',
            'TestStep': '\uF3AC',
            'TestParameter': '\uF3AD',
            'TestSuite': '\uF3AE',
            'TestCase': '\uF3AF',
            'Sprint': '\uF3B0',
            'SignOut': '\uF3B1',
            'TriggerApproval': '\uF3B2',
            'Rocket': '\uF3B3',
            'AzureKeyVault': '\uF3B4',
            'Onboarding': '\uF3BA',
            'Transition': '\uF3BC',
            'LikeSolid': '\uF3BF',
            'DislikeSolid': '\uF3C0',
            'CRMCustomerInsightsApp': '\uF3C8',
            'EditCreate': '\uF3C9',
            'PlayReverseResume': '\uF3E4',
            'PlayReverse': '\uF3E5',
            'SearchData': '\uF3F1',
            'UnSetColor': '\uF3F9',
            'DeclineCall': '\uF405'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$5(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-13\"",
            src: "url('".concat(baseUrl, "fabric-icons-13-c3989a02.woff') format('woff')")
        },
        icons: {
            'RectangularClipping': '\uF407',
            'TeamsLogo16': '\uF40A',
            'TeamsLogoFill16': '\uF40B',
            'Spacer': '\uF40D',
            'SkypeLogo16': '\uF40E',
            'SkypeForBusinessLogo16': '\uF40F',
            'SkypeForBusinessLogoFill16': '\uF410',
            'FilterSolid': '\uF412',
            'MailUndelivered': '\uF415',
            'MailTentative': '\uF416',
            'MailTentativeMirrored': '\uF417',
            'MailReminder': '\uF418',
            'ReceiptUndelivered': '\uF419',
            'ReceiptTentative': '\uF41A',
            'ReceiptTentativeMirrored': '\uF41B',
            'Inbox': '\uF41C',
            'IRMReply': '\uF41D',
            'IRMReplyMirrored': '\uF41E',
            'IRMForward': '\uF41F',
            'IRMForwardMirrored': '\uF420',
            'VoicemailIRM': '\uF421',
            'EventAccepted': '\uF422',
            'EventTentative': '\uF423',
            'EventTentativeMirrored': '\uF424',
            'EventDeclined': '\uF425',
            'IDBadge': '\uF427',
            'BackgroundColor': '\uF42B',
            'OfficeFormsLogoInverse16': '\uF433',
            'OfficeFormsLogo': '\uF434',
            'OfficeFormsLogoFill': '\uF435',
            'OfficeFormsLogo16': '\uF436',
            'OfficeFormsLogoFill16': '\uF437',
            'OfficeFormsLogoInverse24': '\uF43A',
            'OfficeFormsLogo24': '\uF43B',
            'OfficeFormsLogoFill24': '\uF43C',
            'PageLock': '\uF43F',
            'NotExecuted': '\uF440',
            'NotImpactedSolid': '\uF441',
            'FieldReadOnly': '\uF442',
            'FieldRequired': '\uF443',
            'BacklogBoard': '\uF444',
            'ExternalBuild': '\uF445',
            'ExternalTFVC': '\uF446',
            'ExternalXAML': '\uF447',
            'IssueSolid': '\uF448',
            'DefectSolid': '\uF449',
            'LadybugSolid': '\uF44A',
            'NugetLogo': '\uF44C',
            'TFVCLogo': '\uF44D',
            'ProjectLogo32': '\uF47E',
            'ProjectLogoFill32': '\uF47F',
            'ProjectLogo16': '\uF480',
            'ProjectLogoFill16': '\uF481',
            'SwayLogo32': '\uF482',
            'SwayLogoFill32': '\uF483',
            'SwayLogo16': '\uF484',
            'SwayLogoFill16': '\uF485',
            'ClassNotebookLogo32': '\uF486',
            'ClassNotebookLogoFill32': '\uF487',
            'ClassNotebookLogo16': '\uF488',
            'ClassNotebookLogoFill16': '\uF489',
            'ClassNotebookLogoInverse32': '\uF48A',
            'ClassNotebookLogoInverse16': '\uF48B',
            'StaffNotebookLogo32': '\uF48C',
            'StaffNotebookLogoFill32': '\uF48D',
            'StaffNotebookLogo16': '\uF48E',
            'StaffNotebookLogoFill16': '\uF48F',
            'StaffNotebookLogoInverted32': '\uF490',
            'StaffNotebookLogoInverted16': '\uF491',
            'KaizalaLogo': '\uF492',
            'TaskLogo': '\uF493',
            'ProtectionCenterLogo32': '\uF494',
            'GallatinLogo': '\uF496',
            'Globe2': '\uF49A',
            'Guitar': '\uF49B',
            'Breakfast': '\uF49C',
            'Brunch': '\uF49D',
            'BeerMug': '\uF49E',
            'Vacation': '\uF49F',
            'Teeth': '\uF4A0',
            'Taxi': '\uF4A1',
            'Chopsticks': '\uF4A2',
            'SyncOccurence': '\uF4A3',
            'UnsyncOccurence': '\uF4A4',
            'GIF': '\uF4A9',
            'PrimaryCalendar': '\uF4AE',
            'SearchCalendar': '\uF4AF',
            'VideoOff': '\uF4B0',
            'MicrosoftFlowLogo': '\uF4B1',
            'BusinessCenterLogo': '\uF4B2',
            'ToDoLogoBottom': '\uF4B3',
            'ToDoLogoTop': '\uF4B4',
            'EditSolid12': '\uF4B5',
            'EditSolidMirrored12': '\uF4B6',
            'UneditableSolid12': '\uF4B7',
            'UneditableSolidMirrored12': '\uF4B8',
            'UneditableMirrored': '\uF4B9',
            'AdminALogo32': '\uF4BA',
            'AdminALogoFill32': '\uF4BB',
            'ToDoLogoInverse': '\uF4BC'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$4(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-14\"",
            src: "url('".concat(baseUrl, "fabric-icons-14-5cf58db8.woff') format('woff')")
        },
        icons: {
            'Snooze': '\uF4BD',
            'WaffleOffice365': '\uF4E0',
            'ImageSearch': '\uF4E8',
            'NewsSearch': '\uF4E9',
            'VideoSearch': '\uF4EA',
            'R': '\uF4EB',
            'FontColorA': '\uF4EC',
            'FontColorSwatch': '\uF4ED',
            'LightWeight': '\uF4EE',
            'NormalWeight': '\uF4EF',
            'SemiboldWeight': '\uF4F0',
            'GroupObject': '\uF4F1',
            'UngroupObject': '\uF4F2',
            'AlignHorizontalLeft': '\uF4F3',
            'AlignHorizontalCenter': '\uF4F4',
            'AlignHorizontalRight': '\uF4F5',
            'AlignVerticalTop': '\uF4F6',
            'AlignVerticalCenter': '\uF4F7',
            'AlignVerticalBottom': '\uF4F8',
            'HorizontalDistributeCenter': '\uF4F9',
            'VerticalDistributeCenter': '\uF4FA',
            'Ellipse': '\uF4FB',
            'Line': '\uF4FC',
            'Octagon': '\uF4FD',
            'Hexagon': '\uF4FE',
            'Pentagon': '\uF4FF',
            'RightTriangle': '\uF500',
            'HalfCircle': '\uF501',
            'QuarterCircle': '\uF502',
            'ThreeQuarterCircle': '\uF503',
            '6PointStar': '\uF504',
            '12PointStar': '\uF505',
            'ArrangeBringToFront': '\uF506',
            'ArrangeSendToBack': '\uF507',
            'ArrangeSendBackward': '\uF508',
            'ArrangeBringForward': '\uF509',
            'BorderDash': '\uF50A',
            'BorderDot': '\uF50B',
            'LineStyle': '\uF50C',
            'LineThickness': '\uF50D',
            'WindowEdit': '\uF50E',
            'HintText': '\uF50F',
            'MediaAdd': '\uF510',
            'AnchorLock': '\uF511',
            'AutoHeight': '\uF512',
            'ChartSeries': '\uF513',
            'ChartXAngle': '\uF514',
            'ChartYAngle': '\uF515',
            'Combobox': '\uF516',
            'LineSpacing': '\uF517',
            'Padding': '\uF518',
            'PaddingTop': '\uF519',
            'PaddingBottom': '\uF51A',
            'PaddingLeft': '\uF51B',
            'PaddingRight': '\uF51C',
            'NavigationFlipper': '\uF51D',
            'AlignJustify': '\uF51E',
            'TextOverflow': '\uF51F',
            'VisualsFolder': '\uF520',
            'VisualsStore': '\uF521',
            'PictureCenter': '\uF522',
            'PictureFill': '\uF523',
            'PicturePosition': '\uF524',
            'PictureStretch': '\uF525',
            'PictureTile': '\uF526',
            'Slider': '\uF527',
            'SliderHandleSize': '\uF528',
            'DefaultRatio': '\uF529',
            'NumberSequence': '\uF52A',
            'GUID': '\uF52B',
            'ReportAdd': '\uF52C',
            'DashboardAdd': '\uF52D',
            'MapPinSolid': '\uF52E',
            'WebPublish': '\uF52F',
            'PieSingleSolid': '\uF530',
            'BlockedSolid': '\uF531',
            'DrillDown': '\uF532',
            'DrillDownSolid': '\uF533',
            'DrillExpand': '\uF534',
            'DrillShow': '\uF535',
            'SpecialEvent': '\uF536',
            'OneDriveFolder16': '\uF53B',
            'FunctionalManagerDashboard': '\uF542',
            'BIDashboard': '\uF543',
            'CodeEdit': '\uF544',
            'RenewalCurrent': '\uF545',
            'RenewalFuture': '\uF546',
            'SplitObject': '\uF547',
            'BulkUpload': '\uF548',
            'DownloadDocument': '\uF549',
            'GreetingCard': '\uF54B',
            'Flower': '\uF54E',
            'WaitlistConfirm': '\uF550',
            'WaitlistConfirmMirrored': '\uF551',
            'LaptopSecure': '\uF552',
            'DragObject': '\uF553',
            'EntryView': '\uF554',
            'EntryDecline': '\uF555',
            'ContactCardSettings': '\uF556',
            'ContactCardSettingsMirrored': '\uF557'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$3(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-15\"",
            src: "url('".concat(baseUrl, "fabric-icons-15-3807251b.woff') format('woff')")
        },
        icons: {
            'CalendarSettings': '\uF558',
            'CalendarSettingsMirrored': '\uF559',
            'HardDriveLock': '\uF55A',
            'HardDriveUnlock': '\uF55B',
            'AccountManagement': '\uF55C',
            'ReportWarning': '\uF569',
            'TransitionPop': '\uF5B2',
            'TransitionPush': '\uF5B3',
            'TransitionEffect': '\uF5B4',
            'LookupEntities': '\uF5B5',
            'ExploreData': '\uF5B6',
            'AddBookmark': '\uF5B7',
            'SearchBookmark': '\uF5B8',
            'DrillThrough': '\uF5B9',
            'MasterDatabase': '\uF5BA',
            'CertifiedDatabase': '\uF5BB',
            'MaximumValue': '\uF5BC',
            'MinimumValue': '\uF5BD',
            'VisualStudioIDELogo32': '\uF5D0',
            'PasteAsText': '\uF5D5',
            'PasteAsCode': '\uF5D6',
            'BrowserTab': '\uF5D7',
            'BrowserTabScreenshot': '\uF5D8',
            'DesktopScreenshot': '\uF5D9',
            'FileYML': '\uF5DA',
            'ClipboardSolid': '\uF5DC',
            'FabricUserFolder': '\uF5E5',
            'FabricNetworkFolder': '\uF5E6',
            'BullseyeTarget': '\uF5F0',
            'AnalyticsView': '\uF5F1',
            'Video360Generic': '\uF609',
            'Untag': '\uF60B',
            'Leave': '\uF627',
            'Trending12': '\uF62D',
            'Blocked12': '\uF62E',
            'Warning12': '\uF62F',
            'CheckedOutByOther12': '\uF630',
            'CheckedOutByYou12': '\uF631',
            'CircleShapeSolid': '\uF63C',
            'SquareShapeSolid': '\uF63D',
            'TriangleShapeSolid': '\uF63E',
            'DropShapeSolid': '\uF63F',
            'RectangleShapeSolid': '\uF640',
            'ZoomToFit': '\uF649',
            'InsertColumnsLeft': '\uF64A',
            'InsertColumnsRight': '\uF64B',
            'InsertRowsAbove': '\uF64C',
            'InsertRowsBelow': '\uF64D',
            'DeleteColumns': '\uF64E',
            'DeleteRows': '\uF64F',
            'DeleteRowsMirrored': '\uF650',
            'DeleteTable': '\uF651',
            'AccountBrowser': '\uF652',
            'VersionControlPush': '\uF664',
            'StackedColumnChart2': '\uF666',
            'TripleColumnWide': '\uF66E',
            'QuadColumn': '\uF66F',
            'WhiteBoardApp16': '\uF673',
            'WhiteBoardApp32': '\uF674',
            'PinnedSolid': '\uF676',
            'InsertSignatureLine': '\uF677',
            'ArrangeByFrom': '\uF678',
            'Phishing': '\uF679',
            'CreateMailRule': '\uF67A',
            'PublishCourse': '\uF699',
            'DictionaryRemove': '\uF69A',
            'UserRemove': '\uF69B',
            'UserEvent': '\uF69C',
            'Encryption': '\uF69D',
            'PasswordField': '\uF6AA',
            'OpenInNewTab': '\uF6AB',
            'Hide3': '\uF6AC',
            'VerifiedBrandSolid': '\uF6AD',
            'MarkAsProtected': '\uF6AE',
            'AuthenticatorApp': '\uF6B1',
            'WebTemplate': '\uF6B2',
            'DefenderTVM': '\uF6B3',
            'MedalSolid': '\uF6B9',
            'D365TalentLearn': '\uF6BB',
            'D365TalentInsight': '\uF6BC',
            'D365TalentHRCore': '\uF6BD',
            'BacklogList': '\uF6BF',
            'ButtonControl': '\uF6C0',
            'TableGroup': '\uF6D9',
            'MountainClimbing': '\uF6DB',
            'TagUnknown': '\uF6DF',
            'TagUnknownMirror': '\uF6E0',
            'TagUnknown12': '\uF6E1',
            'TagUnknown12Mirror': '\uF6E2',
            'Link12': '\uF6E3',
            'Presentation': '\uF6E4',
            'Presentation12': '\uF6E5',
            'Lock12': '\uF6E6',
            'BuildDefinition': '\uF6E9',
            'ReleaseDefinition': '\uF6EA',
            'SaveTemplate': '\uF6EC',
            'UserGauge': '\uF6ED',
            'BlockedSiteSolid12': '\uF70A',
            'TagSolid': '\uF70E',
            'OfficeChat': '\uF70F'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$2(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-16\"",
            src: "url('".concat(baseUrl, "fabric-icons-16-9cf93f3b.woff') format('woff')")
        },
        icons: {
            'OfficeChatSolid': '\uF710',
            'MailSchedule': '\uF72E',
            'WarningSolid': '\uF736',
            'Blocked2Solid': '\uF737',
            'SkypeCircleArrow': '\uF747',
            'SkypeArrow': '\uF748',
            'SyncStatus': '\uF751',
            'SyncStatusSolid': '\uF752',
            'ProjectDocument': '\uF759',
            'ToDoLogoOutline': '\uF75B',
            'VisioOnlineLogoFill32': '\uF75F',
            'VisioOnlineLogo32': '\uF760',
            'VisioOnlineLogoCloud32': '\uF761',
            'VisioDiagramSync': '\uF762',
            'Event12': '\uF763',
            'EventDateMissed12': '\uF764',
            'UserOptional': '\uF767',
            'ResponsesMenu': '\uF768',
            'DoubleDownArrow': '\uF769',
            'DistributeDown': '\uF76A',
            'BookmarkReport': '\uF76B',
            'FilterSettings': '\uF76C',
            'GripperDotsVertical': '\uF772',
            'MailAttached': '\uF774',
            'AddIn': '\uF775',
            'LinkedDatabase': '\uF779',
            'TableLink': '\uF77A',
            'PromotedDatabase': '\uF77D',
            'BarChartVerticalFilter': '\uF77E',
            'BarChartVerticalFilterSolid': '\uF77F',
            'MicOff2': '\uF781',
            'MicrosoftTranslatorLogo': '\uF782',
            'ShowTimeAs': '\uF787',
            'FileRequest': '\uF789',
            'WorkItemAlert': '\uF78F',
            'PowerBILogo16': '\uF790',
            'PowerBILogoBackplate16': '\uF791',
            'BulletedListText': '\uF792',
            'BulletedListBullet': '\uF793',
            'BulletedListTextMirrored': '\uF794',
            'BulletedListBulletMirrored': '\uF795',
            'NumberedListText': '\uF796',
            'NumberedListNumber': '\uF797',
            'NumberedListTextMirrored': '\uF798',
            'NumberedListNumberMirrored': '\uF799',
            'RemoveLinkChain': '\uF79A',
            'RemoveLinkX': '\uF79B',
            'FabricTextHighlight': '\uF79C',
            'ClearFormattingA': '\uF79D',
            'ClearFormattingEraser': '\uF79E',
            'Photo2Fill': '\uF79F',
            'IncreaseIndentText': '\uF7A0',
            'IncreaseIndentArrow': '\uF7A1',
            'DecreaseIndentText': '\uF7A2',
            'DecreaseIndentArrow': '\uF7A3',
            'IncreaseIndentTextMirrored': '\uF7A4',
            'IncreaseIndentArrowMirrored': '\uF7A5',
            'DecreaseIndentTextMirrored': '\uF7A6',
            'DecreaseIndentArrowMirrored': '\uF7A7',
            'CheckListText': '\uF7A8',
            'CheckListCheck': '\uF7A9',
            'CheckListTextMirrored': '\uF7AA',
            'CheckListCheckMirrored': '\uF7AB',
            'NumberSymbol': '\uF7AC',
            'Coupon': '\uF7BC',
            'VerifiedBrand': '\uF7BD',
            'ReleaseGate': '\uF7BE',
            'ReleaseGateCheck': '\uF7BF',
            'ReleaseGateError': '\uF7C0',
            'M365InvoicingLogo': '\uF7C1',
            'RemoveFromShoppingList': '\uF7D5',
            'ShieldAlert': '\uF7D7',
            'FabricTextHighlightComposite': '\uF7DA',
            'Dataflows': '\uF7DD',
            'GenericScanFilled': '\uF7DE',
            'DiagnosticDataBarTooltip': '\uF7DF',
            'SaveToMobile': '\uF7E0',
            'Orientation2': '\uF7E1',
            'ScreenCast': '\uF7E2',
            'ShowGrid': '\uF7E3',
            'SnapToGrid': '\uF7E4',
            'ContactList': '\uF7E5',
            'NewMail': '\uF7EA',
            'EyeShadow': '\uF7EB',
            'FabricFolderConfirm': '\uF7FF',
            'InformationBarriers': '\uF803',
            'CommentActive': '\uF804',
            'ColumnVerticalSectionEdit': '\uF806',
            'WavingHand': '\uF807',
            'ShakeDevice': '\uF80A',
            'SmartGlassRemote': '\uF80B',
            'Rotate90Clockwise': '\uF80D',
            'Rotate90CounterClockwise': '\uF80E',
            'CampaignTemplate': '\uF811',
            'ChartTemplate': '\uF812',
            'PageListFilter': '\uF813',
            'SecondaryNav': '\uF814',
            'ColumnVerticalSection': '\uF81E',
            'SkypeCircleSlash': '\uF825',
            'SkypeSlash': '\uF826'
        }
    };
    registerIcons(subset, options);
}

// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fluentui-assets-license
function initializeIcons$1(baseUrl, options) {
    if (baseUrl === undefined) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-17\"",
            src: "url('".concat(baseUrl, "fabric-icons-17-0c4ed701.woff') format('woff')")
        },
        icons: {
            'CustomizeToolbar': '\uF828',
            'DuplicateRow': '\uF82A',
            'RemoveFromTrash': '\uF82B',
            'MailOptions': '\uF82C',
            'Childof': '\uF82D',
            'Footer': '\uF82E',
            'Header': '\uF82F',
            'BarChartVerticalFill': '\uF830',
            'StackedColumnChart2Fill': '\uF831',
            'PlainText': '\uF834',
            'AccessibiltyChecker': '\uF835',
            'DatabaseSync': '\uF842',
            'ReservationOrders': '\uF845',
            'TabOneColumn': '\uF849',
            'TabTwoColumn': '\uF84A',
            'TabThreeColumn': '\uF84B',
            'BulletedTreeList': '\uF84C',
            'MicrosoftTranslatorLogoGreen': '\uF852',
            'MicrosoftTranslatorLogoBlue': '\uF853',
            'InternalInvestigation': '\uF854',
            'AddReaction': '\uF85D',
            'ContactHeart': '\uF862',
            'VisuallyImpaired': '\uF866',
            'EventToDoLogo': '\uF869',
            'Variable2': '\uF86D',
            'ModelingView': '\uF871',
            'DisconnectVirtualMachine': '\uF873',
            'ReportLock': '\uF875',
            'Uneditable2': '\uF876',
            'Uneditable2Mirrored': '\uF877',
            'BarChartVerticalEdit': '\uF89D',
            'GlobalNavButtonActive': '\uF89F',
            'PollResults': '\uF8A0',
            'Rerun': '\uF8A1',
            'QandA': '\uF8A2',
            'QandAMirror': '\uF8A3',
            'BookAnswers': '\uF8A4',
            'AlertSettings': '\uF8B6',
            'TrimStart': '\uF8BB',
            'TrimEnd': '\uF8BC',
            'TableComputed': '\uF8F5',
            'DecreaseIndentLegacy': '\uE290',
            'IncreaseIndentLegacy': '\uE291',
            'SizeLegacy': '\uE2B2'
        }
    };
    registerIcons(subset, options);
}

var registerIconAliases = function () {
    registerIconAlias('trash', 'delete');
    registerIconAlias('onedrive', 'onedrivelogo');
    registerIconAlias('alertsolid12', 'eventdatemissed12');
    registerIconAlias('sixpointstar', '6pointstar');
    registerIconAlias('twelvepointstar', '12pointstar');
    registerIconAlias('toggleon', 'toggleleft');
    registerIconAlias('toggleoff', 'toggleright');
};

// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
setVersion('@fluentui/font-icons-mdl2', '8.5.58');

var DEFAULT_BASE_URL$1 = "".concat(FLUENT_CDN_BASE_URL$1, "/assets/icons/");
var win = getWindow$2();
function initializeIcons(baseUrl, options) {
    var _a, _b;
    if (baseUrl === undefined) { baseUrl = ((_a = win === null || win === undefined ? undefined : win.FabricConfig) === null || _a === undefined ? undefined : _a.iconBaseUrl) || ((_b = win === null || win === undefined ? undefined : win.FabricConfig) === null || _b === undefined ? undefined : _b.fontBaseUrl) || DEFAULT_BASE_URL$1; }
    [initializeIcons$j, initializeIcons$i, initializeIcons$h, initializeIcons$g, initializeIcons$f, initializeIcons$e, initializeIcons$d, initializeIcons$c, initializeIcons$b, initializeIcons$a, initializeIcons$9, initializeIcons$8, initializeIcons$7, initializeIcons$6, initializeIcons$5, initializeIcons$4, initializeIcons$3, initializeIcons$2, initializeIcons$1].forEach(function (initialize) { return initialize(baseUrl, options); });
    registerIconAliases();
}

/**
 * Wrapper for ResizeObserver, with fallback for browsers that don't support ResizeObserver.
 *
 * Calls the onResize callback once layout is complete, and again whenever any of the target(s) change size.
 * Or if ResizeObserver isn't supported, calls the callback whenever the window changes size.
 *
 * @param target - Either a single element, or array of elements to watch for size changes.
 * @param onResize - Callback to be notified when layout is complete, and when the target(s) change size.
 *    If this browser supports ResizeObserver, the callback will be passed the ResizeObserverEntry[] array.
 *    Otherwise, the entries array will be undefined, and you'll need to find another way to get the element's size,
 *    (e.g. clientWidth/clientHeight or getBoundingClientRect).
 *
 * @returns A function to clean up the observer/listener.
 */
var observeResize = function (target, onResize) {
    if (typeof ResizeObserver !== 'undefined') {
        var observer_1 = new ResizeObserver(onResize);
        if (Array.isArray(target)) {
            target.forEach(function (t) { return observer_1.observe(t); });
        }
        else {
            observer_1.observe(target);
        }
        return function () { return observer_1.disconnect(); };
    }
    else {
        // Fallback for browsers that don't support ResizeObserver
        var onResizeWrapper_1 = function () { return onResize(undefined); };
        var win_1 = getWindow$2(Array.isArray(target) ? target[0] : target);
        if (!win_1) {
            // Can't listen for resize if we can't get the window object
            return function () {
                // Nothing to clean up
            };
        }
        // Listen for the first animation frame, which will happen after layout is complete
        var animationFrameId_1 = win_1.requestAnimationFrame(onResizeWrapper_1);
        win_1.addEventListener('resize', onResizeWrapper_1, false);
        return function () {
            win_1.cancelAnimationFrame(animationFrameId_1);
            win_1.removeEventListener('resize', onResizeWrapper_1, false);
        };
    }
};

/**
 * Track whether any items don't fit within their container, and move them to the overflow menu.
 * Items are moved into the overflow menu from back to front, excluding pinned items.
 *
 * The overflow menu button must be the last sibling of all of the items that can be put into the overflow, and it
 * must be hooked up to the `setMenuButtonRef` setter function that's returned by `useOverflow`:
 * ```ts
 * const overflow = useOverflow(...);
 * ```
 * ```jsx
 * <Container>
 *  <Item /> // Index 0
 *  <Item /> // Index 1
 *  ...
 *  <Button ref={overflow.setMenuButtonRef} /> // Can be any React.Component or HTMLElement
 * </Container>
 * ```
 */
var useOverflow = function (_a) {
    var onOverflowItemsChanged = _a.onOverflowItemsChanged, rtl = _a.rtl, pinnedIndex = _a.pinnedIndex;
    var updateOverflowRef = React.useRef();
    var containerWidthRef = React.useRef();
    // Attach a resize observer to the container
    var containerRef = useRefEffect(function (container) {
        var cleanupObserver = observeResize(container, function (entries) {
            containerWidthRef.current = entries ? entries[0].contentRect.width : container.clientWidth;
            if (updateOverflowRef.current) {
                updateOverflowRef.current();
            }
        });
        return function () {
            cleanupObserver();
            containerWidthRef.current = undefined;
        };
    });
    var menuButtonRef = useRefEffect(function (menuButton) {
        containerRef(menuButton.parentElement);
        return function () { return containerRef(null); };
    });
    useIsomorphicLayoutEffect$1(function () {
        var container = containerRef.current;
        var menuButton = menuButtonRef.current;
        if (!container || !menuButton) {
            return;
        }
        // items contains the container's children, excluding the overflow menu button itself
        var items = [];
        for (var i = 0; i < container.children.length; i++) {
            var item = container.children[i];
            if (item instanceof HTMLElement && item !== menuButton) {
                items.push(item);
            }
        }
        // Keep track of the minimum width of the container to fit each child index.
        // This cache is an integral part of the algorithm and not just a performance optimization: it allows us to
        // recalculate the overflowIndex on subsequent resizes even if some items are already inside the overflow.
        var minContainerWidth = [];
        var extraWidth = 0; // The accumulated width of items that don't move into the overflow
        updateOverflowRef.current = function () {
            var containerWidth = containerWidthRef.current;
            if (containerWidth === undefined) {
                return;
            }
            // Iterate the items in reverse order until we find one that fits within the bounds of the container
            for (var i = items.length - 1; i >= 0; i--) {
                // Calculate the min container width for this item if we haven't done so yet
                if (minContainerWidth[i] === undefined) {
                    var itemOffsetEnd = rtl ? containerWidth - items[i].offsetLeft : items[i].offsetLeft + items[i].offsetWidth;
                    // If the item after this one is pinned, reserve space for it
                    if (i + 1 < items.length && i + 1 === pinnedIndex) {
                        // Use distance between the end of the previous item and this one (rather than the
                        // pinned item's offsetWidth), to account for any margin between the items.
                        extraWidth = minContainerWidth[i + 1] - itemOffsetEnd;
                    }
                    // Reserve space for the menu button after the first item was added to the overflow
                    if (i === items.length - 2) {
                        extraWidth += menuButton.offsetWidth;
                    }
                    minContainerWidth[i] = itemOffsetEnd + extraWidth;
                }
                if (containerWidth > minContainerWidth[i]) {
                    setOverflowIndex(i + 1);
                    return;
                }
            }
            // If we got here, nothing fits outside the overflow
            setOverflowIndex(0);
        };
        var prevOverflowIndex = items.length;
        var setOverflowIndex = function (overflowIndex) {
            if (prevOverflowIndex !== overflowIndex) {
                prevOverflowIndex = overflowIndex;
                onOverflowItemsChanged(overflowIndex, items.map(function (ele, index) { return ({
                    ele: ele,
                    isOverflowing: index >= overflowIndex && index !== pinnedIndex,
                }); }));
            }
        };
        var cancelAnimationFrame = undefined;
        // If the container width is already known from a previous render, update the overflow with its width.
        // Do this in an animation frame to avoid forcing layout to happen early.
        if (containerWidthRef.current !== undefined) {
            var win_1 = getWindow$2(container);
            if (win_1) {
                var animationFrameId_1 = win_1.requestAnimationFrame(updateOverflowRef.current);
                cancelAnimationFrame = function () { return win_1.cancelAnimationFrame(animationFrameId_1); };
            }
        }
        return function () {
            if (cancelAnimationFrame) {
                cancelAnimationFrame();
            }
            // On cleanup, need to remove all items from the overflow
            // so they don't have stale properties on the next render
            setOverflowIndex(items.length);
            updateOverflowRef.current = undefined;
        };
    });
    return { menuButtonRef: menuButtonRef };
};

var COMPONENT_NAME$3 = 'PivotItem';
var PivotItem = /** @class */ (function (_super) {
    __extends$1(PivotItem, _super);
    function PivotItem(props) {
        var _this = _super.call(this, props) || this;
        initializeComponentRef(_this);
        warnDeprecations(COMPONENT_NAME$3, props, {
            linkText: 'headerText',
        });
        return _this;
    }
    PivotItem.prototype.render = function () {
        return React.createElement("div", __assign$2({}, getNativeProps$1(this.props, divProperties)), this.props.children);
    };
    return PivotItem;
}(React.Component));

var getClassNames$6 = classNamesFunction();
var COMPONENT_NAME$2 = 'Pivot';
var getTabId = function (props, pivotId, itemKey, index) {
    if (props.getTabId) {
        return props.getTabId(itemKey, index);
    }
    return pivotId + "-Tab".concat(index);
};
// Gets the set of PivotLinks as array of IPivotItemProps
// The set of Links is determined by child components of type PivotItem
var getLinkItems = function (props, pivotId) {
    var result = {
        links: [],
        keyToIndexMapping: {},
        keyToTabIdMapping: {},
    };
    React.Children.forEach(React.Children.toArray(props.children), function (child, index) {
        if (isPivotItem(child)) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = child.props, linkText = _a.linkText, pivotItemProps = __rest$1(_a, ["linkText"]);
            var itemKey = child.props.itemKey || index.toString();
            result.links.push(__assign$2(__assign$2({ headerText: linkText }, pivotItemProps), { itemKey: itemKey }));
            result.keyToIndexMapping[itemKey] = index;
            result.keyToTabIdMapping[itemKey] = getTabId(props, pivotId, itemKey, index);
        }
        else if (child) {
            warn$1('The children of a Pivot component must be of type PivotItem to be rendered.');
        }
    });
    return result;
};
var isPivotItem = function (item) {
    var _a;
    return React.isValidElement(item) && ((_a = item.type) === null || _a === undefined ? undefined : _a.name) === PivotItem.name;
};
var PivotBase = React.forwardRef(function (props, ref) {
    var focusZoneRef = React.useRef(null);
    var overflowMenuButtonComponentRef = React.useRef(null);
    var pivotId = useId$1('Pivot');
    var _a = useControllableValue(props.selectedKey, props.defaultSelectedKey), selectedKey = _a[0], setSelectedKey = _a[1];
    var componentRef = props.componentRef, theme = props.theme, linkSize = props.linkSize, linkFormat = props.linkFormat, overflowBehavior = props.overflowBehavior, overflowAriaLabel = props.overflowAriaLabel, focusZoneProps = props.focusZoneProps, overflowButtonAs = props.overflowButtonAs;
    var classNames;
    var nameProps = {
        'aria-label': props['aria-label'],
        'aria-labelledby': props['aria-labelledby'],
    };
    var divProps = getNativeProps$1(props, divProperties, [
        'aria-label',
        'aria-labelledby',
    ]);
    var linkCollection = getLinkItems(props, pivotId);
    React.useImperativeHandle(componentRef, function () { return ({
        focus: function () {
            var _a;
            (_a = focusZoneRef.current) === null || _a === undefined ? undefined : _a.focus();
        },
    }); });
    var renderLinkContent = function (link) {
        if (!link) {
            return null;
        }
        var itemCount = link.itemCount, itemIcon = link.itemIcon, headerText = link.headerText;
        return (React.createElement("span", { className: classNames.linkContent },
            itemIcon !== undefined && (React.createElement("span", { className: classNames.icon },
                React.createElement(Icon, { iconName: itemIcon }))),
            headerText !== undefined && React.createElement("span", { className: classNames.text },
                " ",
                link.headerText),
            itemCount !== undefined && React.createElement("span", { className: classNames.count },
                " (",
                itemCount,
                ")")));
    };
    var renderPivotLink = function (renderLinkCollection, link, renderPivotLinkSelectedKey, className) {
        var itemKey = link.itemKey, headerButtonProps = link.headerButtonProps, onRenderItemLink = link.onRenderItemLink;
        var tabId = renderLinkCollection.keyToTabIdMapping[itemKey];
        var linkContent;
        var isSelected = renderPivotLinkSelectedKey === itemKey;
        if (onRenderItemLink) {
            linkContent = onRenderItemLink(link, renderLinkContent);
        }
        else {
            linkContent = renderLinkContent(link);
        }
        var contentString = link.headerText || '';
        contentString += link.itemCount ? ' (' + link.itemCount + ')' : '';
        // Adding space supplementary for icon
        contentString += link.itemIcon ? ' xx' : '';
        var itemSemantics = link.role && link.role !== 'tab'
            ? {
                role: link.role,
            }
            : {
                role: 'tab',
                'aria-selected': isSelected,
            };
        return (React.createElement(CommandButton, __assign$2({}, headerButtonProps, itemSemantics, { id: tabId, key: itemKey, className: css(className, isSelected && classNames.linkIsSelected), 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: function (ev) { return onLinkClick(itemKey, ev); }, 
            // eslint-disable-next-line react/jsx-no-bind
            onKeyDown: function (ev) { return onKeyDown(itemKey, ev); }, "aria-label": link.ariaLabel, name: link.headerText, keytipProps: link.keytipProps, "data-content": contentString }), linkContent));
    };
    var onLinkClick = function (itemKey, ev) {
        ev.preventDefault();
        updateSelectedItem(itemKey, ev);
    };
    var onKeyDown = function (itemKey, ev) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (ev.which === KeyCodes.enter) {
            ev.preventDefault();
            updateSelectedItem(itemKey);
        }
    };
    var updateSelectedItem = function (itemKey, ev) {
        var _a;
        setSelectedKey(itemKey);
        linkCollection = getLinkItems(props, pivotId);
        if (props.onLinkClick && linkCollection.keyToIndexMapping[itemKey] >= 0) {
            var selectedIndex = linkCollection.keyToIndexMapping[itemKey];
            var item = React.Children.toArray(props.children)[selectedIndex];
            if (isPivotItem(item)) {
                props.onLinkClick(item, ev);
            }
        }
        (_a = overflowMenuButtonComponentRef.current) === null || _a === undefined ? undefined : _a.dismissMenu();
    };
    var renderPivotItem = function (itemKey, isActive) {
        if (props.headersOnly || !itemKey) {
            return null;
        }
        var index = linkCollection.keyToIndexMapping[itemKey];
        var selectedTabId = linkCollection.keyToTabIdMapping[itemKey];
        return (React.createElement("div", { role: "tabpanel", hidden: !isActive, key: itemKey, "aria-hidden": !isActive, "aria-labelledby": selectedTabId, className: classNames.itemContainer }, React.Children.toArray(props.children)[index]));
    };
    var isKeyValid = function (itemKey) {
        return itemKey === null || (itemKey !== undefined && linkCollection.keyToIndexMapping[itemKey] !== undefined);
    };
    var getSelectedKey = function () {
        if (isKeyValid(selectedKey)) {
            return selectedKey;
        }
        if (linkCollection.links.length) {
            return linkCollection.links[0].itemKey;
        }
        return undefined;
    };
    classNames = getClassNames$6(props.styles, {
        theme: theme,
        linkSize: linkSize,
        linkFormat: linkFormat,
    });
    var renderedSelectedKey = getSelectedKey();
    var renderedSelectedIndex = renderedSelectedKey ? linkCollection.keyToIndexMapping[renderedSelectedKey] : 0;
    var items = linkCollection.links.map(function (l) {
        return renderPivotLink(linkCollection, l, renderedSelectedKey, classNames.link);
    });
    // The overflow menu starts empty and items[] is updated as the overflow items change
    var overflowMenuProps = React.useMemo(function () { return ({
        items: [],
        alignTargetEdge: true,
        directionalHint: DirectionalHint.bottomRightEdge,
    }); }, []);
    var overflowMenuButtonRef = useOverflow({
        onOverflowItemsChanged: function (overflowIndex, elements) {
            // Set data-is-overflowing on each item
            elements.forEach(function (_a) {
                var ele = _a.ele, isOverflowing = _a.isOverflowing;
                return (ele.dataset.isOverflowing = "".concat(isOverflowing));
            });
            // Update the menu items
            overflowMenuProps.items = linkCollection.links
                .slice(overflowIndex)
                .filter(function (link) { return link.itemKey !== renderedSelectedKey; })
                .map(function (link, index) {
                link.role = 'menuitem';
                return {
                    key: link.itemKey || "".concat(overflowIndex + index),
                    onRender: function () { return renderPivotLink(linkCollection, link, renderedSelectedKey, classNames.linkInMenu); },
                };
            });
        },
        rtl: getRTL(theme),
        pinnedIndex: renderedSelectedIndex,
    }).menuButtonRef;
    var OverflowButton = overflowButtonAs ? overflowButtonAs : CommandButton;
    return (React.createElement("div", __assign$2({ ref: ref }, divProps),
        React.createElement(FocusZone, __assign$2({ componentRef: focusZoneRef, role: "tablist" }, nameProps, { direction: FocusZoneDirection.horizontal }, focusZoneProps, { className: css(classNames.root, focusZoneProps === null || focusZoneProps === undefined ? undefined : focusZoneProps.className) }),
            items,
            overflowBehavior === 'menu' && (React.createElement(OverflowButton, { className: css(classNames.link, classNames.overflowMenuButton), elementRef: overflowMenuButtonRef, componentRef: overflowMenuButtonComponentRef, menuProps: overflowMenuProps, menuIconProps: { iconName: 'More', style: { color: 'inherit' } }, ariaLabel: overflowAriaLabel, role: "tab" }))),
        renderedSelectedKey &&
            linkCollection.links.map(function (link) {
                return (link.alwaysRender === true || renderedSelectedKey === link.itemKey) &&
                    renderPivotItem(link.itemKey, renderedSelectedKey === link.itemKey);
            })));
});
PivotBase.displayName = COMPONENT_NAME$2;

var globalClassNames$1 = {
  count: "ms-Pivot-count",
  icon: "ms-Pivot-icon",
  linkIsSelected: "is-selected",
  link: "ms-Pivot-link",
  linkContent: "ms-Pivot-linkContent",
  root: "ms-Pivot",
  rootIsLarge: "ms-Pivot--large",
  rootIsTabs: "ms-Pivot--tabs",
  text: "ms-Pivot-text",
  linkInMenu: "ms-Pivot-linkInMenu",
  overflowMenuButton: "ms-Pivot-overflowMenuButton"
};
var getLinkStyles = function(props, classNames, isLinkInOverflowMenu) {
  var _a, _b, _c;
  if (isLinkInOverflowMenu === undefined) {
    isLinkInOverflowMenu = false;
  }
  var linkSize = props.linkSize, linkFormat = props.linkFormat;
  var _d = props.theme, semanticColors = _d.semanticColors, fonts = _d.fonts;
  var rootIsLarge = linkSize === "large";
  var rootIsTabs = linkFormat === "tabs";
  return [
    fonts.medium,
    {
      color: semanticColors.actionLink,
      padding: "0 8px",
      position: "relative",
      backgroundColor: "transparent",
      border: 0,
      borderRadius: 0,
      selectors: {
        ":hover": {
          backgroundColor: semanticColors.buttonBackgroundHovered,
          color: semanticColors.buttonTextHovered,
          cursor: "pointer"
        },
        ":active": {
          backgroundColor: semanticColors.buttonBackgroundPressed,
          color: semanticColors.buttonTextHovered
        },
        ":focus": {
          outline: "none"
        }
      }
    },
    !isLinkInOverflowMenu && [
      {
        display: "inline-block",
        lineHeight: 44,
        height: 44,
        marginRight: 8,
        textAlign: "center",
        selectors: (_a = {}, _a[".".concat(IsFocusVisibleClassName, " &:focus, :host(.").concat(IsFocusVisibleClassName, ") &:focus")] = {
          outline: "1px solid ".concat(semanticColors.focusBorder)
        }, _a[".".concat(IsFocusVisibleClassName, " &:focus:after, :host(.").concat(IsFocusVisibleClassName, ") &:focus:after")] = {
          content: "attr(data-content)",
          position: "relative",
          border: 0
        }, _a[":before"] = {
          backgroundColor: "transparent",
          bottom: 0,
          content: '""',
          height: 2,
          left: 8,
          position: "absolute",
          right: 8,
          transition: "left ".concat(AnimationVariables.durationValue2, " ").concat(AnimationVariables.easeFunction2, ",\n                        right ").concat(AnimationVariables.durationValue2, " ").concat(AnimationVariables.easeFunction2)
        }, _a[":after"] = {
          color: "transparent",
          content: "attr(data-content)",
          display: "block",
          fontWeight: FontWeights.bold,
          height: 1,
          overflow: "hidden",
          visibility: "hidden"
        }, _a)
      },
      rootIsLarge && {
        fontSize: fonts.large.fontSize
      },
      rootIsTabs && [
        {
          marginRight: 0,
          height: 44,
          lineHeight: 44,
          backgroundColor: semanticColors.buttonBackground,
          padding: "0 10px",
          verticalAlign: "top",
          selectors: (_b = {
            ":focus": {
              outlineOffset: "-2px"
            }
          }, _b[".".concat(IsFocusVisibleClassName, " &:focus::before, :host(.").concat(IsFocusVisibleClassName, ") &:focus::before")] = {
            height: "auto",
            background: "transparent",
            transition: "none"
          }, _b["&:hover, &:focus"] = {
            color: semanticColors.buttonTextCheckedHovered
          }, _b["&:active, &:hover"] = {
            color: semanticColors.primaryButtonText,
            backgroundColor: semanticColors.primaryButtonBackground
          }, _b["&.".concat(classNames.linkIsSelected)] = {
            backgroundColor: semanticColors.primaryButtonBackground,
            color: semanticColors.primaryButtonText,
            fontWeight: FontWeights.regular,
            selectors: (_c = {
              ":before": {
                backgroundColor: "transparent",
                transition: "none",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                content: '""',
                height: 0
              },
              ":hover": {
                backgroundColor: semanticColors.primaryButtonBackgroundHovered,
                color: semanticColors.primaryButtonText
              },
              ":active": {
                backgroundColor: semanticColors.primaryButtonBackgroundPressed,
                color: semanticColors.primaryButtonText
              }
            }, _c[HighContrastSelector] = __assign$2({ fontWeight: FontWeights.semibold, color: "HighlightText", background: "Highlight" }, getHighContrastNoAdjustStyle()), _c)
          }, // eslint-disable-next-line @fluentui/max-len
          _b[".".concat(IsFocusVisibleClassName, " &.").concat(classNames.linkIsSelected, ":focus, :host(.").concat(IsFocusVisibleClassName, ") &.").concat(classNames.linkIsSelected, ":focus")] = {
            outlineColor: semanticColors.primaryButtonText
          }, _b)
        }
      ]
    ]
  ];
};
var getStyles$4 = function(props) {
  var _a, _b, _c, _d;
  var className = props.className, linkSize = props.linkSize, linkFormat = props.linkFormat, theme = props.theme;
  var semanticColors = theme.semanticColors, fonts = theme.fonts;
  var classNames = getGlobalClassNames(globalClassNames$1, theme);
  var rootIsLarge = linkSize === "large";
  var rootIsTabs = linkFormat === "tabs";
  return {
    root: [
      classNames.root,
      fonts.medium,
      normalize$4,
      {
        position: "relative",
        color: semanticColors.link,
        whiteSpace: "nowrap"
      },
      rootIsLarge && classNames.rootIsLarge,
      rootIsTabs && classNames.rootIsTabs,
      className
    ],
    itemContainer: {
      selectors: {
        "&[hidden]": {
          display: "none"
        }
      }
    },
    link: __spreadArray(__spreadArray([
      classNames.link
    ], getLinkStyles(props, classNames), true), [
      (_a = {}, _a["&[data-is-overflowing='true']"] = {
        display: "none"
      }, _a)
    ], false),
    overflowMenuButton: [
      classNames.overflowMenuButton,
      (_b = {
        visibility: "hidden",
        position: "absolute",
        right: 0
      }, _b[".".concat(classNames.link, "[data-is-overflowing='true'] ~ &")] = {
        visibility: "visible",
        position: "relative"
      }, _b)
    ],
    linkInMenu: __spreadArray(__spreadArray([
      classNames.linkInMenu
    ], getLinkStyles(props, classNames, true), true), [
      {
        justifyContent: "start",
        height: 36,
        lineHeight: 36,
        width: "100%"
      }
    ], false),
    linkIsSelected: [
      classNames.link,
      classNames.linkIsSelected,
      {
        fontWeight: FontWeights.semibold,
        selectors: (_c = {
          ":before": {
            backgroundColor: semanticColors.inputBackgroundChecked,
            selectors: (_d = {}, _d[HighContrastSelector] = {
              backgroundColor: "Highlight"
            }, _d)
          },
          ":hover::before": {
            left: 0,
            right: 0
          }
        }, _c[HighContrastSelector] = {
          color: "Highlight"
        }, _c)
      }
    ],
    linkContent: [
      classNames.linkContent,
      {
        flex: "0 1 100%",
        selectors: {
          "& > * ": {
            marginLeft: 4
          },
          "& > *:first-child": {
            marginLeft: 0
          }
        }
      }
    ],
    text: [
      classNames.text,
      {
        display: "inline-block",
        verticalAlign: "top"
      }
    ],
    count: [
      classNames.count,
      {
        display: "inline-block",
        verticalAlign: "top"
      }
    ],
    icon: classNames.icon
  };
};

/**
 * The Pivot control and related tabs pattern are used for navigating frequently accessed,
 * distinct content categories. Pivots allow for navigation between two or more content
 * views and relies on text headers to articulate the different sections of content.
 */
var Pivot = styled(PivotBase, getStyles$4, undefined, {
    scope: 'Pivot',
});

var getClassNames$5 = classNamesFunction();
// if the percentComplete is near 0, don't animate it.
// This prevents animations on reset to 0 scenarios
var ZERO_THRESHOLD$1 = 0.01;
/**
 * ProgressIndicator with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/microsoft/fluentui/wiki/Styling)
 */
var ProgressIndicatorBase = /** @class */ (function (_super) {
    __extends$1(ProgressIndicatorBase, _super);
    function ProgressIndicatorBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderProgress = function (props) {
            var _a = _this.props, ariaLabel = _a.ariaLabel, ariaValueText = _a.ariaValueText, barHeight = _a.barHeight, className = _a.className, description = _a.description, 
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            _b = _a.label, 
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            label = _b === undefined ? _this.props.title : _b, styles = _a.styles, theme = _a.theme;
            var percentComplete = typeof _this.props.percentComplete === 'number'
                ? Math.min(100, Math.max(0, _this.props.percentComplete * 100))
                : undefined;
            var classNames = getClassNames$5(styles, {
                theme: theme,
                className: className,
                barHeight: barHeight,
                indeterminate: percentComplete === undefined ? true : false,
            });
            var progressBarStyles = {
                width: percentComplete !== undefined ? percentComplete + '%' : undefined,
                transition: percentComplete !== undefined && percentComplete < ZERO_THRESHOLD$1 ? 'none' : undefined,
            };
            var ariaValueMin = percentComplete !== undefined ? 0 : undefined;
            var ariaValueMax = percentComplete !== undefined ? 100 : undefined;
            var ariaValueNow = percentComplete !== undefined ? Math.floor(percentComplete) : undefined;
            return (React.createElement("div", { className: classNames.itemProgress },
                React.createElement("div", { className: classNames.progressTrack }),
                React.createElement("div", { className: classNames.progressBar, style: progressBarStyles, role: "progressbar", "aria-describedby": description ? _this._descriptionId : undefined, "aria-label": ariaLabel, "aria-labelledby": label ? _this._labelId : undefined, "aria-valuemin": ariaValueMin, "aria-valuemax": ariaValueMax, "aria-valuenow": ariaValueNow, "aria-valuetext": ariaValueText })));
        };
        var id = getId('progress-indicator');
        _this._labelId = id + '-label';
        _this._descriptionId = id + '-description';
        return _this;
    }
    ProgressIndicatorBase.prototype.render = function () {
        var _a = this.props, barHeight = _a.barHeight, className = _a.className, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        _b = _a.label, 
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        label = _b === undefined ? this.props.title : _b, // Fall back to deprecated value.
        description = _a.description, styles = _a.styles, theme = _a.theme, progressHidden = _a.progressHidden, _c = _a.onRenderProgress, onRenderProgress = _c === undefined ? this._onRenderProgress : _c;
        var percentComplete = typeof this.props.percentComplete === 'number'
            ? Math.min(100, Math.max(0, this.props.percentComplete * 100))
            : undefined;
        var classNames = getClassNames$5(styles, {
            theme: theme,
            className: className,
            barHeight: barHeight,
            indeterminate: percentComplete === undefined ? true : false,
        });
        return (React.createElement("div", { className: classNames.root },
            label ? (React.createElement("div", { id: this._labelId, className: classNames.itemName }, label)) : null,
            !progressHidden
                ? onRenderProgress(__assign$2(__assign$2({}, this.props), { percentComplete: percentComplete }), this._onRenderProgress)
                : null,
            description ? (React.createElement("div", { id: this._descriptionId, className: classNames.itemDescription }, description)) : null));
    };
    ProgressIndicatorBase.defaultProps = {
        label: '',
        description: '',
        width: 180,
    };
    return ProgressIndicatorBase;
}(React.Component));

var GlobalClassNames$2 = {
    root: 'ms-ProgressIndicator',
    itemName: 'ms-ProgressIndicator-itemName',
    itemDescription: 'ms-ProgressIndicator-itemDescription',
    itemProgress: 'ms-ProgressIndicator-itemProgress',
    progressTrack: 'ms-ProgressIndicator-progressTrack',
    progressBar: 'ms-ProgressIndicator-progressBar',
};
var IndeterminateProgress = memoizeFunction(function () {
    return keyframes({
        '0%': {
            left: '-30%',
        },
        '100%': {
            left: '100%',
        },
    });
});
var IndeterminateProgressRTL = memoizeFunction(function () {
    return keyframes({
        '100%': {
            right: '-30%',
        },
        '0%': {
            right: '100%',
        },
    });
});
var getStyles$3 = function (props) {
    var _a, _b, _c;
    var isRTL = getRTL(props.theme);
    var className = props.className, indeterminate = props.indeterminate, theme = props.theme, _d = props.barHeight, barHeight = _d === undefined ? 2 : _d;
    var palette = theme.palette, semanticColors = theme.semanticColors, fonts = theme.fonts;
    var classNames = getGlobalClassNames(GlobalClassNames$2, theme);
    var marginBetweenText = 8;
    var textHeight = 18;
    var progressTrackColor = palette.neutralLight;
    return {
        root: [classNames.root, fonts.medium, className],
        itemName: [
            classNames.itemName,
            noWrap,
            {
                color: semanticColors.bodyText,
                paddingTop: marginBetweenText / 2,
                lineHeight: textHeight + 2,
            },
        ],
        itemDescription: [
            classNames.itemDescription,
            {
                color: semanticColors.bodySubtext,
                fontSize: fonts.small.fontSize,
                lineHeight: textHeight,
            },
        ],
        itemProgress: [
            classNames.itemProgress,
            {
                position: 'relative',
                overflow: 'hidden',
                height: barHeight,
                padding: "".concat(marginBetweenText, "px 0"),
            },
        ],
        progressTrack: [
            classNames.progressTrack,
            {
                position: 'absolute',
                width: '100%',
                height: barHeight,
                backgroundColor: progressTrackColor,
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        borderBottom: '1px solid WindowText',
                    },
                    _a),
            },
        ],
        progressBar: [
            {
                backgroundColor: palette.themePrimary,
                height: barHeight,
                position: 'absolute',
                transition: 'width .3s ease',
                width: 0,
                selectors: (_b = {},
                    _b[HighContrastSelector] = __assign$2({ backgroundColor: 'highlight' }, getHighContrastNoAdjustStyle()),
                    _b),
            },
            indeterminate
                ? {
                    position: 'absolute',
                    minWidth: '33%',
                    background: "linear-gradient(to right, ".concat(progressTrackColor, " 0%, ") +
                        "".concat(palette.themePrimary, " 50%, ").concat(progressTrackColor, " 100%)"),
                    animation: "".concat(isRTL ? IndeterminateProgressRTL() : IndeterminateProgress(), " 3s infinite"),
                    selectors: (_c = {},
                        _c[HighContrastSelector] = {
                            background: "highlight",
                        },
                        _c),
                }
                : {
                    transition: 'width .15s linear',
                },
            classNames.progressBar,
        ],
    };
};

/**
 * ProgressIndicator description
 */
var ProgressIndicator$1 = styled(ProgressIndicatorBase, getStyles$3, undefined, { scope: 'ProgressIndicator' });

var assign$1 = __assign$2;

/**
 * This function is required for any module that uses slots.
 *
 * This function is a slot resolver that automatically evaluates slot functions to generate React elements.
 * A byproduct of this resolver is that it removes slots from the React hierarchy by bypassing React.createElement.
 *
 * To use this function on a per-file basis, use the jsx directive targeting withSlots.
 * This directive must be the FIRST LINE in the file to work correctly.
 * Usage of this pragma also requires withSlots import statement.
 *
 * See React.createElement
 */
// Can't use typeof on React.createElement since it's overloaded. Approximate createElement's signature for now
// and widen as needed.
function withSlots(type, props) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var slotType = type;
    if (slotType.isSlot) {
        // Since we are bypassing createElement, use React.Children.toArray to make sure children are
        // properly assigned keys.
        // TODO: should this be mutating? does React mutate children subprop with createElement?
        // TODO: will toArray clobber existing keys?
        // TODO: React generates warnings because it doesn't detect hidden member _store that is set in createElement.
        //        Even children passed to createElement without keys don't generate this warning.
        //        Is there a better way to prevent slots from appearing in hierarchy? toArray doesn't address root issue.
        children = React.Children.toArray(children);
        // TODO: There is something weird going on here with children embedded in props vs. rest args.
        // Comment out these lines to see. Make sure this function is doing the right things.
        if (children.length === 0) {
            return slotType(props);
        }
        return slotType(__assign$2(__assign$2({}, props), { children: children }));
    }
    else {
        // TODO: Are there some cases where children should NOT be spread? Also, spreading reraises perf question.
        //        Children had to be spread to avoid breaking KeytipData in Toggle.view:
        //        react-dom.development.js:18931 Uncaught TypeError: children is not a function
        //        Without spread, function child is a child array of one element
        // TODO: is there a reason this can't be:
        // return React.createElement.apply(this, arguments);
        return React.createElement.apply(React, __spreadArray([type, props], children, false));
    }
}
/**
 * This function creates factories that render ouput depending on the user ISlotProp props passed in.
 * @param DefaultComponent - Base component to render when not overridden by user props.
 * @param options - Factory options, including defaultProp value for shorthand prop mapping.
 * @returns ISlotFactory function used for rendering slots.
 */
function createFactory(DefaultComponent, options) {
    if (options === undefined) { options = {}; }
    var _a = options.defaultProp, defaultProp = _a === undefined ? 'children' : _a;
    var result = function (componentProps, userProps, userSlotOptions, defaultStyles, theme) {
        // If they passed in raw JSX, just return that.
        if (React.isValidElement(userProps)) {
            return userProps;
        }
        var flattenedUserProps = _translateShorthand(defaultProp, userProps);
        var finalProps = _constructFinalProps(defaultStyles, theme, componentProps, flattenedUserProps);
        if (userSlotOptions) {
            if (userSlotOptions.component) {
                // TODO: Remove cast if possible. This cast is needed because TS errors on the intrinsic portion of ReactType.
                // return <userSlotOptions.component {...finalProps} />;
                var UserComponent = userSlotOptions.component;
                return React.createElement(UserComponent, __assign$2({}, finalProps));
            }
            if (userSlotOptions.render) {
                return userSlotOptions.render(finalProps, DefaultComponent);
            }
        }
        return React.createElement(DefaultComponent, __assign$2({}, finalProps));
    };
    return result;
}
/**
 * Default factory for components without explicit factories.
 */
var defaultFactory = memoizeFunction(function (type) { return createFactory(type); });
/**
 * This function generates slots that can be used in JSX given a definition of slots and their corresponding types.
 * @param userProps - Props as pass to component.
 * @param slots - Slot definition object defining the default slot component for each slot.
 * @returns A set of created slots that components can render in JSX.
 */
function getSlots(userProps, slots) {
    var result = {};
    // userProps already has default props mixed in by createComponent. Recast here to gain typing for this function.
    var mixedProps = userProps;
    var _loop_1 = function (name_1) {
        if (slots.hasOwnProperty(name_1)) {
            // This closure method requires the use of withSlots to prevent unnecessary rerenders. This is because React
            // detects each closure as a different component (since it is a new instance) from the previous one and then
            // forces a rerender of the entire slot subtree. For now, the only way to avoid this is to use withSlots, which
            // bypasses the call to React.createElement.
            var slot = function (componentProps) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (args.length > 0) {
                    // If React.createElement is being incorrectly used with slots, there will be additional arguments.
                    // We can detect these additional arguments and error on their presence.
                    throw new Error('Any module using getSlots must use withSlots. Please see withSlots javadoc for more info.');
                }
                // TODO: having TS infer types here seems to cause infinite loop.
                //   use explicit types or casting to preserve typing if possible.
                // TODO: this should be a lookup on TProps property instead of being TProps directly, which is probably
                //   causing the infinite loop
                return _renderSlot(slots[name_1], 
                // TODO: this cast to any is hiding a relationship issue between the first two args
                componentProps, mixedProps[name_1], mixedProps.slots && mixedProps.slots[name_1], 
                // _defaultStyles should always be present, but a check for existence is added to make view tests
                // easier to use.
                mixedProps._defaultStyles && mixedProps._defaultStyles[name_1], mixedProps.theme);
            };
            slot.isSlot = true;
            result[name_1] = slot;
        }
    };
    for (var name_1 in slots) {
        _loop_1(name_1);
    }
    return result;
}
/**
 * Helper function that translates shorthand as needed.
 * @param defaultProp
 * @param slotProps
 */
function _translateShorthand(defaultProp, slotProps) {
    var _a;
    var transformedProps;
    if (typeof slotProps === 'string' || typeof slotProps === 'number' || typeof slotProps === 'boolean') {
        transformedProps = (_a = {},
            _a[defaultProp] = slotProps,
            _a);
    }
    else {
        transformedProps = slotProps;
    }
    return transformedProps;
}
/**
 * Helper function that constructs final styles and props given a series of props ordered by increasing priority.
 */
function _constructFinalProps(defaultStyles, theme) {
    var allProps = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        allProps[_i - 2] = arguments[_i];
    }
    var finalProps = {};
    var classNames = [];
    for (var _a = 0, allProps_1 = allProps; _a < allProps_1.length; _a++) {
        var props = allProps_1[_a];
        classNames.push(props && props.className);
        assign$1(finalProps, props);
    }
    finalProps.className = mergeCss([defaultStyles, classNames], { rtl: getRTL(theme) });
    return finalProps;
}
/**
 * Render a slot given component and user props. Uses component factory if available, otherwise falls back
 * to default factory.
 * @param ComponentType Factory component type.
 * @param componentProps The properties passed into slot from within the component.
 * @param userProps The user properties passed in from outside of the component.
 */
function _renderSlot(ComponentType, componentProps, userProps, slotOptions, defaultStyles, theme) {
    if (ComponentType.create !== undefined) {
        return ComponentType.create(componentProps, userProps, slotOptions, defaultStyles);
    }
    else {
        // TODO: need to resolve typing / generic issues passing through memoizeFunction. for now, cast to 'unknown'
        return defaultFactory(ComponentType)(componentProps, userProps, slotOptions, defaultStyles, theme);
    }
}

function createComponent(view, options) {
  if (options === undefined) {
    options = {};
  }
  var _a = options.factoryOptions, factoryOptions = _a === undefined ? {} : _a;
  var defaultProp = factoryOptions.defaultProp;
  var ResultComponent = function(componentProps) {
    var settings = _getCustomizations(options.displayName, React.useContext(CustomizerContext), options.fields);
    var stateReducer = options.state;
    if (stateReducer) {
      componentProps = __assign$2(__assign$2({}, componentProps), stateReducer(componentProps));
    }
    var theme = componentProps.theme || settings.theme;
    var tokens = _resolveTokens(componentProps, theme, options.tokens, settings.tokens, componentProps.tokens);
    var styles = _resolveStyles(componentProps, theme, tokens, options.styles, settings.styles, componentProps.styles);
    var viewProps = __assign$2(__assign$2({}, componentProps), { styles, tokens, _defaultStyles: styles, theme });
    return view(viewProps);
  };
  ResultComponent.displayName = options.displayName || view.name;
  if (defaultProp) {
    ResultComponent.create = createFactory(ResultComponent, { defaultProp });
  }
  assign$1(ResultComponent, options.statics);
  return ResultComponent;
}
function _resolveStyles(props, theme, tokens) {
  var allStyles = [];
  for (var _i = 3; _i < arguments.length; _i++) {
    allStyles[_i - 3] = arguments[_i];
  }
  return concatStyleSets.apply(undefined, allStyles.map(function(styles) {
    return typeof styles === "function" ? styles(props, theme, tokens) : styles;
  }));
}
function _resolveTokens(props, theme) {
  var allTokens = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    allTokens[_i - 2] = arguments[_i];
  }
  var tokens = {};
  for (var _a = 0, allTokens_1 = allTokens; _a < allTokens_1.length; _a++) {
    var currentTokens = allTokens_1[_a];
    if (currentTokens) {
      currentTokens = typeof currentTokens === "function" ? currentTokens(props, theme) : currentTokens;
      if (Array.isArray(currentTokens)) {
        currentTokens = _resolveTokens.apply(undefined, __spreadArray([props, theme], currentTokens, false));
      }
      assign$1(tokens, currentTokens);
    }
  }
  return tokens;
}
function _getCustomizations(displayName, context, fields) {
  var DefaultFields = ["theme", "styles", "tokens"];
  return Customizations.getSettings(fields || DefaultFields, displayName, context.customizations);
}

var GlobalClassNames$1 = {
    root: 'ms-StackItem',
};
var alignMap = {
    start: 'flex-start',
    end: 'flex-end',
};
var StackItemStyles = function (props, theme, tokens) {
    var grow = props.grow, shrink = props.shrink, disableShrink = props.disableShrink, align = props.align, verticalFill = props.verticalFill, order = props.order, className = props.className, _a = props.basis, basis = _a === undefined ? 'auto' : _a;
    var classNames = getGlobalClassNames(GlobalClassNames$1, theme);
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            {
                flexBasis: basis,
                margin: tokens.margin,
                padding: tokens.padding,
                height: verticalFill ? '100%' : 'auto',
                width: 'auto',
            },
            grow && {
                flexGrow: grow === true ? 1 : grow,
            },
            (disableShrink || (!grow && !shrink)) && {
                flexShrink: 0,
            },
            shrink &&
                !disableShrink && {
                flexShrink: 1,
            },
            align && {
                alignSelf: alignMap[align] || align,
            },
            order && {
                order: order,
            },
            className,
        ],
        // TODO: this cast may be hiding some potential issues with styling and name
        //        lookups and should be removed
    };
};

var StackItemView = function (props) {
    var children = props.children;
    var nativeProps = getNativeProps$1(props, htmlElementProperties$1);
    // eslint-disable-next-line eqeqeq
    if (children == null) {
        return null;
    }
    var Slots = getSlots(props, {
        root: 'div',
    });
    return withSlots(Slots.root, __assign$2({}, nativeProps), children);
};
var StackItem = createComponent(StackItemView, {
    displayName: 'StackItem',
    styles: StackItemStyles,
});

// Helper function that converts a themed spacing key (if given) to the corresponding themed spacing value.
var _getThemedSpacing = function (space, theme) {
    if (theme.spacing.hasOwnProperty(space)) {
        return theme.spacing[space];
    }
    return space;
};
// Helper function that takes a gap as a string and converts it into a { value, unit } representation.
var _getValueUnitGap = function (gap) {
    var numericalPart = parseFloat(gap);
    var numericalValue = isNaN(numericalPart) ? 0 : numericalPart;
    var numericalString = isNaN(numericalPart) ? '' : numericalPart.toString();
    var unitPart = gap.substring(numericalString.toString().length);
    return {
        value: numericalValue,
        unit: unitPart || 'px',
    };
};
/**
 * Takes in a gap size in either a CSS-style format (e.g. 10 or "10px")
 *  or a key of a themed spacing value (e.g. "s1").
 * Returns the separate numerical value of the padding (e.g. 10)
 *  and the CSS unit (e.g. "px").
 */
var parseGap = function (gap, theme) {
    if (gap === undefined || gap === '') {
        return {
            rowGap: {
                value: 0,
                unit: 'px',
            },
            columnGap: {
                value: 0,
                unit: 'px',
            },
        };
    }
    if (typeof gap === 'number') {
        return {
            rowGap: {
                value: gap,
                unit: 'px',
            },
            columnGap: {
                value: gap,
                unit: 'px',
            },
        };
    }
    var splitGap = gap.split(' ');
    // If the array has more than two values, then return 0px.
    if (splitGap.length > 2) {
        return {
            rowGap: {
                value: 0,
                unit: 'px',
            },
            columnGap: {
                value: 0,
                unit: 'px',
            },
        };
    }
    // If the array has two values, then parse each one.
    if (splitGap.length === 2) {
        return {
            rowGap: _getValueUnitGap(_getThemedSpacing(splitGap[0], theme)),
            columnGap: _getValueUnitGap(_getThemedSpacing(splitGap[1], theme)),
        };
    }
    // Else, parse the numerical value and pass it as both the vertical and horizontal gap.
    var calculatedGap = _getValueUnitGap(_getThemedSpacing(gap, theme));
    return {
        rowGap: calculatedGap,
        columnGap: calculatedGap,
    };
};
/**
 * Takes in a padding in a CSS-style format (e.g. 10, "10px", "10px 10px", etc.)
 *  where the separate padding values can also be the key of a themed spacing value
 *  (e.g. "s1 m", "10px l1 20px l2", etc.).
 * Returns a CSS-style padding.
 */
var parsePadding = function (padding, theme) {
    if (padding === undefined || typeof padding === 'number' || padding === '') {
        return padding;
    }
    var paddingValues = padding.split(' ');
    if (paddingValues.length < 2) {
        return _getThemedSpacing(padding, theme);
    }
    return paddingValues.reduce(function (padding1, padding2) {
        return _getThemedSpacing(padding1, theme) + ' ' + _getThemedSpacing(padding2, theme);
    });
};

var nameMap = {
    start: 'flex-start',
    end: 'flex-end',
};
var GlobalClassNames = {
    root: 'ms-Stack',
    inner: 'ms-Stack-inner',
    child: 'ms-Stack-child',
};
var styles$3 = function (props, theme, tokens) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var className = props.className, disableShrink = props.disableShrink, enableScopedSelectors = props.enableScopedSelectors, grow = props.grow, horizontal = props.horizontal, horizontalAlign = props.horizontalAlign, reversed = props.reversed, verticalAlign = props.verticalAlign, verticalFill = props.verticalFill, wrap = props.wrap;
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    /*  eslint-disable @typescript-eslint/no-deprecated */
    var childrenGap = tokens && tokens.childrenGap ? tokens.childrenGap : props.gap;
    var maxHeight = tokens && tokens.maxHeight ? tokens.maxHeight : props.maxHeight;
    var maxWidth = tokens && tokens.maxWidth ? tokens.maxWidth : props.maxWidth;
    var padding = tokens && tokens.padding ? tokens.padding : props.padding;
    /* eslint-enable @typescript-eslint/no-deprecated */
    var _p = parseGap(childrenGap, theme), rowGap = _p.rowGap, columnGap = _p.columnGap;
    var horizontalMargin = "".concat(-0.5 * columnGap.value).concat(columnGap.unit);
    var verticalMargin = "".concat(-0.5 * rowGap.value).concat(rowGap.unit);
    // styles to be applied to all direct children regardless of wrap or direction
    var childStyles = {
        textOverflow: 'ellipsis',
    };
    var childSelector = '> ' + (enableScopedSelectors ? '.' + GlobalClassNames.child : '*');
    var disableShrinkStyles = (_a = {},
        // flexShrink styles are applied by the StackItem
        _a["".concat(childSelector, ":not(.").concat(GlobalClassNames$1.root, ")")] = {
            flexShrink: 0,
        },
        _a);
    if (wrap) {
        return {
            root: [
                classNames.root,
                {
                    flexWrap: 'wrap',
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    width: 'auto',
                    overflow: 'visible',
                    height: '100%',
                },
                horizontalAlign && (_b = {},
                    _b[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
                    _b),
                verticalAlign && (_c = {},
                    _c[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
                    _c),
                className,
                {
                    // not allowed to be overridden by className
                    // since this is necessary in order to prevent collapsing margins
                    display: 'flex',
                },
                horizontal && {
                    height: verticalFill ? '100%' : 'auto',
                },
            ],
            inner: [
                classNames.inner,
                (_d = {
                        display: 'flex',
                        flexWrap: 'wrap',
                        marginLeft: horizontalMargin,
                        marginRight: horizontalMargin,
                        marginTop: verticalMargin,
                        marginBottom: verticalMargin,
                        overflow: 'visible',
                        boxSizing: 'border-box',
                        padding: parsePadding(padding, theme),
                        // avoid unnecessary calc() calls if horizontal gap is 0
                        width: columnGap.value === 0 ? '100%' : "calc(100% + ".concat(columnGap.value).concat(columnGap.unit, ")"),
                        maxWidth: '100vw'
                    },
                    _d[childSelector] = __assign$2({ margin: "".concat(0.5 * rowGap.value).concat(rowGap.unit, " ").concat(0.5 * columnGap.value).concat(columnGap.unit) }, childStyles),
                    _d),
                disableShrink && disableShrinkStyles,
                horizontalAlign && (_e = {},
                    _e[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
                    _e),
                verticalAlign && (_f = {},
                    _f[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
                    _f),
                horizontal && (_g = {
                        flexDirection: reversed ? 'row-reverse' : 'row',
                        // avoid unnecessary calc() calls if vertical gap is 0
                        height: rowGap.value === 0 ? '100%' : "calc(100% + ".concat(rowGap.value).concat(rowGap.unit, ")")
                    },
                    _g[childSelector] = {
                        maxWidth: columnGap.value === 0 ? '100%' : "calc(100% - ".concat(columnGap.value).concat(columnGap.unit, ")"),
                    },
                    _g),
                !horizontal && (_h = {
                        flexDirection: reversed ? 'column-reverse' : 'column',
                        height: "calc(100% + ".concat(rowGap.value).concat(rowGap.unit, ")")
                    },
                    _h[childSelector] = {
                        maxHeight: rowGap.value === 0 ? '100%' : "calc(100% - ".concat(rowGap.value).concat(rowGap.unit, ")"),
                    },
                    _h),
            ],
        };
    }
    return {
        root: [
            classNames.root,
            (_j = {
                    display: 'flex',
                    flexDirection: horizontal ? (reversed ? 'row-reverse' : 'row') : reversed ? 'column-reverse' : 'column',
                    flexWrap: 'nowrap',
                    width: 'auto',
                    height: verticalFill ? '100%' : 'auto',
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    padding: parsePadding(padding, theme),
                    boxSizing: 'border-box'
                },
                _j[childSelector] = childStyles,
                _j),
            disableShrink && disableShrinkStyles,
            grow && {
                flexGrow: grow === true ? 1 : grow,
            },
            horizontalAlign && (_k = {},
                _k[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
                _k),
            verticalAlign && (_l = {},
                _l[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
                _l),
            horizontal &&
                columnGap.value > 0 && (_m = {},
                // apply gap margin to every direct child except the first direct child if the direction is not reversed,
                // and the last direct one if it is
                _m[reversed ? "".concat(childSelector, ":not(:last-child)") : "".concat(childSelector, ":not(:first-child)")] = {
                    marginLeft: "".concat(columnGap.value).concat(columnGap.unit),
                },
                _m),
            !horizontal &&
                rowGap.value > 0 && (_o = {},
                // apply gap margin to every direct child except the first direct child if the direction is not reversed,
                // and the last direct one if it is
                _o[reversed ? "".concat(childSelector, ":not(:last-child)") : "".concat(childSelector, ":not(:first-child)")] = {
                    marginTop: "".concat(rowGap.value).concat(rowGap.unit),
                },
                _o),
            className,
        ],
        // TODO: this cast may be hiding some potential issues with styling and name
        //        lookups and should be removed
    };
};

var StackView = function (props) {
    var _a = props.as, RootType = _a === undefined ? 'div' : _a, _b = props.disableShrink, disableShrink = _b === undefined ? false : _b, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    _c = props.doNotRenderFalsyValues, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    doNotRenderFalsyValues = _c === undefined ? false : _c, _d = props.enableScopedSelectors, enableScopedSelectors = _d === undefined ? false : _d, wrap = props.wrap, rest = __rest$1(props, ["as", "disableShrink", "doNotRenderFalsyValues", "enableScopedSelectors", "wrap"]);
    warnDeprecations('Stack', props, {
        gap: 'tokens.childrenGap',
        maxHeight: 'tokens.maxHeight',
        maxWidth: 'tokens.maxWidth',
        padding: 'tokens.padding',
    });
    var stackInnerId = useId$1('stack-inner');
    var stackChildren = _processStackChildren(props.children, {
        disableShrink: disableShrink,
        enableScopedSelectors: enableScopedSelectors,
        doNotRenderFalsyValues: doNotRenderFalsyValues,
    });
    var nativeProps = getNativeProps$1(rest, htmlElementProperties$1);
    var Slots = getSlots(props, {
        root: RootType,
        inner: 'div',
    });
    if (wrap) {
        return (withSlots(Slots.root, __assign$2({}, nativeProps),
            withSlots(Slots.inner, { key: stackInnerId }, stackChildren)));
    }
    return withSlots(Slots.root, __assign$2({}, nativeProps), stackChildren);
};
function _processStackChildren(children, _a) {
    var disableShrink = _a.disableShrink, enableScopedSelectors = _a.enableScopedSelectors, doNotRenderFalsyValues = _a.doNotRenderFalsyValues;
    var childrenArray = React.Children.toArray(children);
    childrenArray = React.Children.map(childrenArray, function (child) {
        if (!child) {
            return doNotRenderFalsyValues ? null : child;
        }
        // We need to allow children that aren't falsy values, but not valid elements since they could be
        // a string like <Stack>{'sample string'}</Stack>
        if (!React.isValidElement(child)) {
            return child;
        }
        if (child.type === React.Fragment) {
            return child.props.children
                ? _processStackChildren(child.props.children, { disableShrink: disableShrink, enableScopedSelectors: enableScopedSelectors, doNotRenderFalsyValues: doNotRenderFalsyValues })
                : null;
        }
        var childAsReactElement = child;
        var defaultItemProps = {};
        if (_isStackItem(child)) {
            defaultItemProps = { shrink: !disableShrink };
        }
        var childClassName = childAsReactElement.props.className;
        return React.cloneElement(childAsReactElement, __assign$2(__assign$2(__assign$2(__assign$2({}, defaultItemProps), childAsReactElement.props), (childClassName && { className: childClassName })), (enableScopedSelectors && { className: css(GlobalClassNames.child, childClassName) })));
    });
    return childrenArray;
}
function _isStackItem(item) {
    // In theory, we should be able to just check item.type === StackItem.
    // However, under certain unclear circumstances (see https://github.com/microsoft/fluentui/issues/10785),
    // the object identity is different despite the function implementation being the same.
    return (!!item &&
        typeof item === 'object' &&
        !!item.type &&
        // StackItem is generated by createComponent, so we need to check its displayName instead of name
        item.type.displayName === StackItem.displayName);
}
var StackStatics = {
    Item: StackItem,
};
var Stack = createComponent(StackView, {
    displayName: 'Stack',
    styles: styles$3,
    statics: StackStatics,
});

var getClassNames$4 = classNamesFunction();
var useComponentRef$2 = function (componentRef, rootElementRef) {
    React.useImperativeHandle(componentRef, function () { return ({
        focus: function () { var _a; return (_a = rootElementRef.current) === null || _a === undefined ? undefined : _a.focus(); },
    }); }, [rootElementRef]);
};
var TeachingBubbleContentBase = React.forwardRef(function (props, forwardedRef) {
    var _a, _b;
    var rootElementRef = React.useRef(null);
    var documentRef = useDocument();
    var mergedRootRef = useMergedRefs$1(rootElementRef, forwardedRef);
    var ariaDescribedById = useId$1('teaching-bubble-content-');
    var ariaLabelledById = useId$1('teaching-bubble-title-');
    var ariaDescribedBy = (_a = props.ariaDescribedBy) !== null && _a !== undefined ? _a : ariaDescribedById;
    var ariaLabelledBy = (_b = props.ariaLabelledBy) !== null && _b !== undefined ? _b : ariaLabelledById;
    var illustrationImage = props.illustrationImage, primaryButtonProps = props.primaryButtonProps, secondaryButtonProps = props.secondaryButtonProps, headline = props.headline, hasCondensedHeadline = props.hasCondensedHeadline, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    _c = props.hasCloseButton, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    hasCloseButton = _c === undefined ? props.hasCloseIcon : _c, onDismiss = props.onDismiss, closeButtonAriaLabel = props.closeButtonAriaLabel, hasSmallHeadline = props.hasSmallHeadline, isWide = props.isWide, styles = props.styles, theme = props.theme, customFooterContent = props.footerContent, focusTrapZoneProps = props.focusTrapZoneProps;
    var classNames = getClassNames$4(styles, {
        theme: theme,
        hasCondensedHeadline: hasCondensedHeadline,
        hasSmallHeadline: hasSmallHeadline,
        hasCloseButton: hasCloseButton,
        hasHeadline: !!headline,
        isWide: isWide,
        primaryButtonClassName: primaryButtonProps ? primaryButtonProps.className : undefined,
        secondaryButtonClassName: secondaryButtonProps ? secondaryButtonProps.className : undefined,
    });
    var onKeyDown = React.useCallback(function (ev) {
        if (onDismiss) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === KeyCodes.escape) {
                onDismiss(ev);
            }
        }
    }, [onDismiss]);
    useOnEvent(documentRef, 'keydown', onKeyDown);
    var imageContent;
    var headerContent;
    var bodyContent;
    var footerContent;
    var closeButton;
    if (illustrationImage && illustrationImage.src) {
        imageContent = (React.createElement("div", { className: classNames.imageContent },
            React.createElement(Image$2, __assign$2({}, illustrationImage))));
    }
    if (headline) {
        var HeaderWrapperAs = typeof headline === 'string' ? 'p' : 'div';
        headerContent = (React.createElement("div", { className: classNames.header },
            React.createElement(HeaderWrapperAs, { role: "heading", "aria-level": 3, className: classNames.headline, id: ariaLabelledBy }, headline)));
    }
    if (props.children) {
        var BodyContentWrapperAs = typeof props.children === 'string' ? 'p' : 'div';
        bodyContent = (React.createElement("div", { className: classNames.body },
            React.createElement(BodyContentWrapperAs, { className: classNames.subText, id: ariaDescribedBy }, props.children)));
    }
    if (primaryButtonProps || secondaryButtonProps || customFooterContent) {
        footerContent = (React.createElement(Stack, { className: classNames.footer, horizontal: true, horizontalAlign: customFooterContent ? 'space-between' : 'end' },
            React.createElement(Stack.Item, { align: "center" }, React.createElement("span", null, customFooterContent)),
            React.createElement(Stack.Item, null,
                primaryButtonProps && React.createElement(PrimaryButton, __assign$2({}, primaryButtonProps, { className: classNames.primaryButton })),
                secondaryButtonProps && React.createElement(DefaultButton, __assign$2({}, secondaryButtonProps, { className: classNames.secondaryButton })))));
    }
    if (hasCloseButton) {
        closeButton = (React.createElement(IconButton, { className: classNames.closeButton, iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }));
    }
    useComponentRef$2(props.componentRef, rootElementRef);
    return (React.createElement("div", { className: classNames.content, ref: mergedRootRef, role: 'dialog', tabIndex: -1, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "data-is-focusable": true },
        imageContent,
        React.createElement(FocusTrapZone, __assign$2({ isClickableOutsideFocusTrap: true }, focusTrapZoneProps),
            React.createElement("div", { className: classNames.bodyContent },
                headerContent,
                bodyContent,
                footerContent,
                closeButton))));
});

var globalClassNames = {
  root: "ms-TeachingBubble",
  body: "ms-TeachingBubble-body",
  bodyContent: "ms-TeachingBubble-bodycontent",
  closeButton: "ms-TeachingBubble-closebutton",
  content: "ms-TeachingBubble-content",
  footer: "ms-TeachingBubble-footer",
  header: "ms-TeachingBubble-header",
  headerIsCondensed: "ms-TeachingBubble-header--condensed",
  headerIsSmall: "ms-TeachingBubble-header--small",
  headerIsLarge: "ms-TeachingBubble-header--large",
  headline: "ms-TeachingBubble-headline",
  image: "ms-TeachingBubble-image",
  primaryButton: "ms-TeachingBubble-primaryButton",
  secondaryButton: "ms-TeachingBubble-secondaryButton",
  subText: "ms-TeachingBubble-subText",
  // TODO: Button global class name usage should be converted to a styles function once
  //        Button supports JS styling, which means these button names can be removed.
  button: "ms-Button",
  buttonLabel: "ms-Button-label"
};
var opacityFadeIn = memoizeFunction(function() {
  return keyframes({
    "0%": {
      opacity: 0,
      animationTimingFunction: AnimationVariables.easeFunction1,
      transform: "scale3d(.90,.90,.90)"
    },
    "100%": {
      opacity: 1,
      transform: "scale3d(1,1,1)"
    }
  });
});
var rootStyle = function(isWide, calloutProps) {
  var _a = calloutProps || {}, calloutWidth = _a.calloutWidth, calloutMaxWidth = _a.calloutMaxWidth;
  return [
    {
      display: "block",
      maxWidth: 364,
      border: 0,
      outline: "transparent",
      width: calloutWidth || "calc(100% + 1px)",
      animationName: "".concat(opacityFadeIn()),
      animationDuration: "300ms",
      animationTimingFunction: "linear",
      animationFillMode: "both"
    },
    isWide && {
      maxWidth: calloutMaxWidth || 456
    }
  ];
};
var headerStyle = function(classNames, hasCondensedHeadline, hasSmallHeadline) {
  if (hasCondensedHeadline) {
    return [
      classNames.headerIsCondensed,
      {
        marginBottom: 14
      }
    ];
  }
  return [
    hasSmallHeadline && classNames.headerIsSmall,
    !hasSmallHeadline && classNames.headerIsLarge,
    {
      selectors: {
        ":not(:last-child)": {
          marginBottom: 14
        }
      }
    }
  ];
};
var getStyles$2 = function(props) {
  var _a, _b, _c;
  var hasCondensedHeadline = props.hasCondensedHeadline, hasSmallHeadline = props.hasSmallHeadline, hasCloseButton = props.hasCloseButton, hasHeadline = props.hasHeadline, isWide = props.isWide, primaryButtonClassName = props.primaryButtonClassName, secondaryButtonClassName = props.secondaryButtonClassName, theme = props.theme, _d = props.calloutProps, calloutProps = _d === undefined ? { className: undefined, theme } : _d;
  var hasLargeHeadline = !hasCondensedHeadline && !hasSmallHeadline;
  var palette = theme.palette, semanticColors = theme.semanticColors, fonts = theme.fonts;
  var classNames = getGlobalClassNames(globalClassNames, theme);
  var hideDefaultFocusRing = getFocusStyle(theme, {
    outlineColor: "transparent",
    borderColor: "transparent"
  });
  return {
    root: [classNames.root, fonts.medium, calloutProps.className],
    body: [
      classNames.body,
      hasCloseButton && !hasHeadline && { marginRight: 24 },
      {
        selectors: {
          ":not(:last-child)": {
            marginBottom: 20
          }
        }
      }
    ],
    bodyContent: [
      classNames.bodyContent,
      {
        padding: "20px 24px 20px 24px"
      }
    ],
    closeButton: [
      classNames.closeButton,
      {
        position: "absolute",
        right: 0,
        top: 0,
        margin: "15px 15px 0 0",
        borderRadius: 0,
        color: palette.white,
        fontSize: fonts.small.fontSize,
        selectors: {
          ":hover": {
            background: palette.themeDarkAlt,
            color: palette.white
          },
          ":active": {
            background: palette.themeDark,
            color: palette.white
          },
          ":focus": {
            border: "1px solid ".concat(semanticColors.variantBorder)
          }
        }
      }
    ],
    content: __spreadArray(__spreadArray([
      classNames.content
    ], rootStyle(isWide), true), [
      isWide && {
        display: "flex"
      }
    ], false),
    footer: [
      classNames.footer,
      {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        color: palette.white,
        selectors: (_a = {}, // TODO: global class name usage should be converted to a styles function once Button supports JS styling
        _a[".".concat(classNames.button, ":not(:first-child)")] = {
          marginLeft: 10
        }, _a)
      }
    ],
    header: __spreadArray(__spreadArray([
      classNames.header
    ], headerStyle(classNames, hasCondensedHeadline, hasSmallHeadline), true), [
      hasCloseButton && { marginRight: 24 },
      (hasCondensedHeadline || hasSmallHeadline) && [
        fonts.medium,
        {
          fontWeight: FontWeights.semibold
        }
      ]
    ], false),
    headline: [
      classNames.headline,
      {
        margin: 0,
        color: palette.white,
        fontWeight: FontWeights.semibold,
        overflowWrap: "break-word"
      },
      hasLargeHeadline && [
        {
          fontSize: fonts.xLarge.fontSize
        }
      ]
    ],
    imageContent: [
      classNames.header,
      classNames.image,
      isWide && {
        display: "flex",
        alignItems: "center",
        maxWidth: 154
      }
    ],
    primaryButton: [
      classNames.primaryButton,
      primaryButtonClassName,
      hideDefaultFocusRing,
      {
        backgroundColor: palette.white,
        borderColor: palette.white,
        color: palette.themePrimary,
        whiteSpace: "nowrap",
        selectors: (_b = {}, // TODO: global class name usage should be converted to a styles function once Button supports JS styling
        _b[".".concat(classNames.buttonLabel)] = fonts.medium, _b[":hover"] = {
          backgroundColor: palette.themeLighter,
          borderColor: palette.themeLighter,
          color: palette.themeDark
        }, _b[":focus"] = {
          backgroundColor: palette.themeLighter,
          border: "1px solid ".concat(palette.black),
          color: palette.themeDark,
          outline: "1px solid ".concat(palette.white),
          outlineOffset: "-2px"
        }, _b[":active"] = {
          backgroundColor: palette.white,
          borderColor: palette.white,
          color: palette.themePrimary
        }, _b)
      }
    ],
    secondaryButton: [
      classNames.secondaryButton,
      secondaryButtonClassName,
      hideDefaultFocusRing,
      {
        backgroundColor: palette.themePrimary,
        borderColor: palette.white,
        whiteSpace: "nowrap",
        selectors: (_c = {}, // TODO: global class name usage should be converted to a styles function once Button supports JS styling
        _c[".".concat(classNames.buttonLabel)] = [
          fonts.medium,
          {
            color: palette.white
          }
        ], _c[":hover"] = {
          backgroundColor: palette.themeDarkAlt,
          borderColor: palette.white
        }, _c[":focus"] = {
          backgroundColor: palette.themeDark,
          border: "1px solid ".concat(palette.black),
          outline: "1px solid ".concat(palette.white),
          outlineOffset: "-2px"
        }, _c[":active"] = {
          backgroundColor: palette.themePrimary,
          borderColor: palette.white
        }, _c)
      }
    ],
    subText: [
      classNames.subText,
      {
        margin: 0,
        fontSize: fonts.medium.fontSize,
        color: palette.white,
        fontWeight: FontWeights.regular
      }
    ],
    subComponentStyles: {
      callout: {
        root: __spreadArray(__spreadArray([], rootStyle(isWide, calloutProps), true), [fonts.medium], false),
        beak: [
          {
            background: palette.themePrimary
          }
        ],
        calloutMain: [
          {
            background: palette.themePrimary
          }
        ]
      }
    }
  };
};

var TeachingBubbleContent = styled(TeachingBubbleContentBase, getStyles$2, undefined, { scope: 'TeachingBubbleContent' });

var COMPONENT_NAME$1 = 'TeachingBubble';
var defaultCalloutProps = {
    beakWidth: 16,
    gapSpace: 0,
    setInitialFocus: true,
    doNotLayer: false,
    directionalHint: DirectionalHint.rightCenter,
};
var getClassNames$3 = classNamesFunction();
var useComponentRef$1 = function (componentRef, rootElementRef) {
    React.useImperativeHandle(componentRef, function () { return ({
        focus: function () { var _a; return (_a = rootElementRef.current) === null || _a === undefined ? undefined : _a.focus(); },
    }); }, [rootElementRef]);
};
var TeachingBubbleBase = React.forwardRef(function (props, forwardedRef) {
    var rootElementRef = React.useRef(null);
    var mergedRootRef = useMergedRefs$1(rootElementRef, forwardedRef);
    var setCalloutProps = props.calloutProps, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    targetElement = props.targetElement, onDismiss = props.onDismiss, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    _a = props.hasCloseButton, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    hasCloseButton = _a === undefined ? props.hasCloseIcon : _a, isWide = props.isWide, styles = props.styles, theme = props.theme, target = props.target;
    var calloutProps = React.useMemo(function () { return (__assign$2(__assign$2(__assign$2({}, defaultCalloutProps), setCalloutProps), { theme: theme })); }, [setCalloutProps, theme]);
    var stylesProps = {
        theme: theme,
        isWide: isWide,
        calloutProps: calloutProps,
        hasCloseButton: hasCloseButton,
    };
    var classNames = getClassNames$3(styles, stylesProps);
    var calloutStyles = classNames.subComponentStyles
        ? classNames.subComponentStyles.callout
        : undefined;
    useComponentRef$1(props.componentRef, rootElementRef);
    return (React.createElement(Callout, __assign$2({ target: target || targetElement, onDismiss: onDismiss }, calloutProps, { className: classNames.root, styles: calloutStyles, hideOverflow: true }),
        React.createElement("div", { ref: mergedRootRef },
            React.createElement(TeachingBubbleContent, __assign$2({}, props)))));
});
TeachingBubbleBase.displayName = COMPONENT_NAME$1;

var TeachingBubble = styled(TeachingBubbleBase, getStyles$2, undefined, { scope: 'TeachingBubble' });

var TextView = function (props) {
    // eslint-disable-next-line eqeqeq
    if (props.children == null) {
        return null;
    }
    props.block; props.className; var _a = props.as, RootType = _a === undefined ? 'span' : _a; props.variant; props.nowrap; var rest = __rest$1(props, ["block", "className", "as", "variant", "nowrap"]);
    var Slots = getSlots(props, {
        root: RootType,
    });
    return withSlots(Slots.root, __assign$2({}, getNativeProps$1(rest, htmlElementProperties$1)));
};

var TextStyles = function (props, theme) {
    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
    var fonts = theme.fonts, semanticColors = theme.semanticColors;
    var variantObject = fonts[variant || 'medium'];
    return {
        root: [
            variantObject,
            {
                color: variantObject.color || semanticColors.bodyText,
                display: block ? (as === 'td' ? 'table-cell' : 'block') : 'inline',
                mozOsxFontSmoothing: variantObject.MozOsxFontSmoothing,
                webkitFontSmoothing: variantObject.WebkitFontSmoothing,
            },
            nowrap && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            className,
        ],
    };
};

var Text$1 = createComponent(TextView, {
    displayName: 'Text',
    styles: TextStyles,
});

var getClassNames$2 = classNamesFunction();
var COMPONENT_NAME = 'Toggle';
var ToggleBase = React.forwardRef(function (props, forwardedRef) {
    var _a = props.as, RootType = _a === undefined ? 'div' : _a, ariaLabel = props.ariaLabel, controlledChecked = props.checked, className = props.className, _b = props.defaultChecked, defaultChecked = _b === undefined ? false : _b, disabled = props.disabled, inlineLabel = props.inlineLabel, label = props.label, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    offAriaLabel = props.offAriaLabel, offText = props.offText, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    onAriaLabel = props.onAriaLabel, onChange = props.onChange, 
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    onChanged = props.onChanged, onToggleClick = props.onClick, onText = props.onText, role = props.role, styles = props.styles, theme = props.theme;
    var _c = useControllableValue(controlledChecked, defaultChecked, React.useCallback(function (ev, isChecked) {
        onChange === null || onChange === undefined ? undefined : onChange(ev, isChecked);
        onChanged === null || onChanged === undefined ? undefined : onChanged(isChecked);
    }, [onChange, onChanged])), checked = _c[0], setChecked = _c[1];
    var classNames = getClassNames$2(styles, {
        theme: theme,
        className: className,
        disabled: disabled,
        checked: checked,
        inlineLabel: inlineLabel,
        onOffMissing: !onText && !offText,
    });
    var badAriaLabel = checked ? onAriaLabel : offAriaLabel;
    var id = useId$1(COMPONENT_NAME, props.id);
    var labelId = "".concat(id, "-label");
    var stateTextId = "".concat(id, "-stateText");
    var stateText = checked ? onText : offText;
    var toggleNativeProps = getNativeProps$1(props, inputProperties$1, [
        'defaultChecked',
    ]);
    // The following properties take priority for what Narrator should read:
    // 1. ariaLabel
    // 2. onAriaLabel (if checked) or offAriaLabel (if not checked)
    // 3. label, if existent
    var labelledById = undefined;
    if (!ariaLabel && !badAriaLabel) {
        if (label) {
            labelledById = labelId;
        }
        if (stateText && !labelledById) {
            labelledById = stateTextId;
        }
    }
    var toggleButton = React.useRef(null);
    useFocusRects(toggleButton);
    useComponentRef(props, checked, toggleButton);
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- build-time conditional
        useWarnings({
            name: COMPONENT_NAME,
            props: props,
            deprecations: {
                offAriaLabel: undefined,
                onAriaLabel: 'ariaLabel',
                onChanged: 'onChange',
            },
            mutuallyExclusive: { checked: 'defaultChecked' },
        });
    }
    var onClick = function (ev) {
        if (!disabled) {
            setChecked(!checked, ev);
            if (onToggleClick) {
                onToggleClick(ev);
            }
        }
    };
    var slotProps = {
        root: {
            className: classNames.root,
            hidden: toggleNativeProps.hidden,
        },
        label: {
            children: label,
            className: classNames.label,
            htmlFor: id,
            id: labelId,
        },
        container: {
            className: classNames.container,
        },
        pill: __assign$2(__assign$2({}, toggleNativeProps), { 'aria-disabled': disabled, 'aria-checked': checked, 'aria-label': ariaLabel ? ariaLabel : badAriaLabel, 'aria-labelledby': labelledById, className: classNames.pill, 'data-is-focusable': true, 'data-ktp-target': true, disabled: disabled, id: id, onClick: onClick, ref: toggleButton, role: role ? role : 'switch', type: 'button' }),
        thumb: {
            className: classNames.thumb,
        },
        stateText: {
            children: stateText,
            className: classNames.text,
            htmlFor: id,
            id: stateTextId,
        },
    };
    return (React.createElement(RootType, __assign$2({ ref: forwardedRef }, slotProps.root),
        label && React.createElement(Label, __assign$2({}, slotProps.label)),
        React.createElement("div", __assign$2({}, slotProps.container),
            React.createElement("button", __assign$2({}, slotProps.pill),
                React.createElement("span", __assign$2({}, slotProps.thumb))),
            ((checked && onText) || offText) && React.createElement(Label, __assign$2({}, slotProps.stateText)))));
});
ToggleBase.displayName = COMPONENT_NAME + 'Base';
var useComponentRef = function (props, isChecked, toggleButtonRef) {
    React.useImperativeHandle(props.componentRef, function () { return ({
        get checked() {
            return !!isChecked;
        },
        focus: function () {
            if (toggleButtonRef.current) {
                toggleButtonRef.current.focus();
            }
        },
    }); }, [isChecked, toggleButtonRef]);
};

var DEFAULT_PILL_WIDTH = 40;
var DEFAULT_PILL_HEIGHT = 20;
var DEFAULT_THUMB_SIZE = 12;
var getStyles$1 = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var theme = props.theme, className = props.className, disabled = props.disabled, checked = props.checked, inlineLabel = props.inlineLabel, onOffMissing = props.onOffMissing;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    // Tokens
    var pillUncheckedBackground = semanticColors.bodyBackground;
    var pillCheckedBackground = semanticColors.inputBackgroundChecked;
    var pillCheckedHoveredBackground = semanticColors.inputBackgroundCheckedHovered;
    var thumbUncheckedHoveredBackground = palette.neutralDark;
    var pillCheckedDisabledBackground = semanticColors.disabledBodySubtext;
    var thumbBackground = semanticColors.smallInputBorder;
    var thumbCheckedBackground = semanticColors.inputForegroundChecked;
    var thumbDisabledBackground = semanticColors.disabledBodySubtext;
    var thumbCheckedDisabledBackground = semanticColors.disabledBackground;
    var pillBorderColor = semanticColors.smallInputBorder;
    var pillBorderHoveredColor = semanticColors.inputBorderHovered;
    var pillBorderDisabledColor = semanticColors.disabledBodySubtext;
    var textDisabledColor = semanticColors.disabledText;
    return {
        root: [
            'ms-Toggle',
            checked && 'is-checked',
            !disabled && 'is-enabled',
            disabled && 'is-disabled',
            theme.fonts.medium,
            {
                marginBottom: '8px',
            },
            inlineLabel && {
                display: 'flex',
                alignItems: 'center',
            },
            className,
        ],
        label: [
            'ms-Toggle-label',
            { display: 'inline-block' },
            disabled && {
                color: textDisabledColor,
                selectors: (_a = {},
                    _a[HighContrastSelector] = {
                        color: 'GrayText',
                    },
                    _a),
            },
            inlineLabel &&
                !onOffMissing && {
                marginRight: 16,
            },
            onOffMissing &&
                inlineLabel && {
                order: 1,
                marginLeft: 16,
            },
            inlineLabel && { wordBreak: 'break-word' },
        ],
        container: [
            'ms-Toggle-innerContainer',
            {
                display: 'flex',
                position: 'relative',
            },
        ],
        pill: [
            'ms-Toggle-background',
            getFocusStyle(theme, { inset: -3 }),
            {
                fontSize: '20px',
                boxSizing: 'border-box',
                width: DEFAULT_PILL_WIDTH,
                height: DEFAULT_PILL_HEIGHT,
                borderRadius: DEFAULT_PILL_HEIGHT / 2,
                transition: 'all 0.1s ease',
                border: "1px solid ".concat(pillBorderColor),
                background: pillUncheckedBackground,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '0 3px',
                overflow: 'visible',
            },
            !disabled && [
                !checked && {
                    selectors: {
                        ':hover': [
                            {
                                borderColor: pillBorderHoveredColor,
                            },
                        ],
                        ':hover .ms-Toggle-thumb': [
                            {
                                backgroundColor: thumbUncheckedHoveredBackground,
                                selectors: (_b = {},
                                    _b[HighContrastSelector] = {
                                        borderColor: 'Highlight',
                                    },
                                    _b),
                            },
                        ],
                    },
                },
                checked && [
                    {
                        background: pillCheckedBackground,
                        borderColor: 'transparent',
                        justifyContent: 'flex-end',
                    },
                    {
                        selectors: (_c = {
                                ':hover': [
                                    {
                                        backgroundColor: pillCheckedHoveredBackground,
                                        borderColor: 'transparent',
                                        selectors: (_d = {},
                                            _d[HighContrastSelector] = {
                                                backgroundColor: 'Highlight',
                                            },
                                            _d),
                                    },
                                ]
                            },
                            _c[HighContrastSelector] = __assign$2({ backgroundColor: 'Highlight' }, getHighContrastNoAdjustStyle()),
                            _c),
                    },
                ],
            ],
            disabled && [
                {
                    cursor: 'default',
                },
                !checked && [
                    {
                        borderColor: pillBorderDisabledColor,
                    },
                ],
                checked && [
                    {
                        backgroundColor: pillCheckedDisabledBackground,
                        borderColor: 'transparent',
                        justifyContent: 'flex-end',
                    },
                ],
            ],
            !disabled && {
                selectors: {
                    '&:hover': {
                        selectors: (_e = {},
                            _e[HighContrastSelector] = {
                                borderColor: 'Highlight',
                            },
                            _e),
                    },
                },
            },
        ],
        thumb: [
            'ms-Toggle-thumb',
            {
                display: 'block',
                width: DEFAULT_THUMB_SIZE,
                height: DEFAULT_THUMB_SIZE,
                borderRadius: '50%',
                transition: 'all 0.1s ease',
                backgroundColor: thumbBackground,
                /* Border is added to handle high contrast mode for Firefox */
                borderColor: 'transparent',
                borderWidth: DEFAULT_THUMB_SIZE / 2,
                borderStyle: 'solid',
                boxSizing: 'border-box',
            },
            !disabled &&
                checked && [
                {
                    backgroundColor: thumbCheckedBackground,
                    selectors: (_f = {},
                        _f[HighContrastSelector] = {
                            backgroundColor: 'Window',
                            borderColor: 'Window',
                        },
                        _f),
                },
            ],
            disabled && [
                !checked && [
                    {
                        backgroundColor: thumbDisabledBackground,
                    },
                ],
                checked && [
                    {
                        backgroundColor: thumbCheckedDisabledBackground,
                    },
                ],
            ],
        ],
        text: [
            'ms-Toggle-stateText',
            {
                selectors: {
                    // Workaround: make rules more specific than Label rules.
                    '&&': {
                        padding: '0',
                        margin: '0 8px',
                        userSelect: 'none',
                        fontWeight: FontWeights.regular,
                    },
                },
            },
            disabled && {
                selectors: {
                    '&&': {
                        color: textDisabledColor,
                        selectors: (_g = {},
                            _g[HighContrastSelector] = {
                                color: 'GrayText',
                            },
                            _g),
                    },
                },
            },
        ],
    };
};

var Toggle = styled(ToggleBase, getStyles$1, undefined, {
    scope: 'Toggle',
});

var ThemeContext$1 = React.createContext(undefined);

/**
 * Get theme from CustomizerContext or Customizations singleton.
 */
function useCompatTheme() {
    return useCustomizationSettings(['theme']).theme;
}
/**
 * React hook for programmatically accessing the theme.
 */
var useTheme$1 = function () {
    var theme = React.useContext(ThemeContext$1);
    var legacyTheme = useCompatTheme();
    return theme || legacyTheme || createTheme({});
};

const IconDirectionContext = React.createContext(undefined);
const IconDirectionContextDefaultValue = {};
const IconDirectionContextProvider = IconDirectionContext.Provider;
const useIconContext = () => React.useContext(IconDirectionContext) ? React.useContext(IconDirectionContext) : IconDirectionContextDefaultValue;

const positionMap = ['Top', 'Right', 'Bottom', 'Left'];
function generateStyles$2(property, suffix, ...values) {
  const [firstValue, secondValue = firstValue, thirdValue = firstValue, fourthValue = secondValue] = values;
  const valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  const styles = {};
  for (let i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      const newKey = property + positionMap[i] + suffix;
      styles[newKey] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * A function that implements CSS spec conformant expansion for "borderWidth"
 *
 * @example
 *   borderWidth('10px')
 *   borderWidth('10px', '5px')
 *   borderWidth('2px', '4px', '8px')
 *   borderWidth('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-width
 */
function borderWidth(...values) {
  return generateStyles$2('border', 'Width', ...values);
}

/**
 * A function that implements CSS spec conformant expansion for "borderStyle"
 *
 * @example
 *  borderStyle('solid')
 *  borderStyle('solid', 'dashed')
 *  borderStyle('solid', 'dashed', 'dotted')
 *  borderStyle('solid', 'dashed', 'dotted', 'double')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-style
 */
function borderStyle(...values) {
  return generateStyles$2('border', 'Style', ...values);
}

/**
 * A function that implements CSS spec conformant expansion for "borderColor"
 *
 * @example
 *  borderColor('red')
 *  borderColor('red', 'blue')
 *  borderColor('red', 'blue', 'green')
 *  borderColor('red', 'blue', 'green', 'yellow')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-color
 */
function borderColor(...values) {
  return generateStyles$2('border', 'Color', ...values);
}

const LINE_STYLES = ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'];
function isBorderStyle(value) {
  return LINE_STYLES.includes(value);
}

/**
 * A function that implements expansion for "border" to all sides of an element, it's simplified - check usage examples.
 *
 * @example
 *  border('2px')
 *  border('solid')
 *  border('2px', 'solid')
 *  border('solid', '2px')
 *  border('2px', 'solid', 'red')
 *  border('solid', '2px', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border
 *
 * @deprecated Just use `{ border: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */
function border(...values) {
  if (isBorderStyle(values[0])) {
    return Object.assign({}, borderStyle(values[0]), values[1] && borderWidth(values[1]), values[2] && borderColor(values[2]));
  }
  return Object.assign({}, borderWidth(values[0]), values[1] && borderStyle(values[1]), values[2] && borderColor(values[2]));
}

/**
 * A function that implements expansion for "border-left", it's simplified - check usage examples.
 *
 * @example
 *  borderLeft('2px')
 *  borderLeft('solid')
 *  borderLeft('2px', 'solid')
 *  borderLeft('solid', '2px')
 *  borderLeft('2px', 'solid', 'red')
 *  borderLeft('solid', '2px', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-left
 *
 * @deprecated Just use `{ borderLeft: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */
function borderLeft(...values) {
  if (isBorderStyle(values[0])) {
    return Object.assign({
      borderLeftStyle: values[0]
    }, values[1] && {
      borderLeftWidth: values[1]
    }, values[2] && {
      borderLeftColor: values[2]
    });
  }
  return Object.assign({
    borderLeftWidth: values[0]
  }, values[1] && {
    borderLeftStyle: values[1]
  }, values[2] && {
    borderLeftColor: values[2]
  });
}

/**
 * A function that implements expansion for "border-Bottom", it's simplified - check usage examples.
 *
 * @example
 *  borderBottom('2px')
 *  borderBottom('solid')
 *  borderBottom('2px', 'solid')
 *  borderBottom('solid', '2px')
 *  borderBottom('2px', 'solid', 'red')
 *  borderBottom('solid', '2px', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom
 *
 * @deprecated Just use `{ borderBottom: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */
function borderBottom(...values) {
  if (isBorderStyle(values[0])) {
    return Object.assign({
      borderBottomStyle: values[0]
    }, values[1] && {
      borderBottomWidth: values[1]
    }, values[2] && {
      borderBottomColor: values[2]
    });
  }
  return Object.assign({
    borderBottomWidth: values[0]
  }, values[1] && {
    borderBottomStyle: values[1]
  }, values[2] && {
    borderBottomColor: values[2]
  });
}

/**
 * A function that implements expansion for "border-right", it's simplified - check usage examples.
 *
 * @example
 *  borderRight('2px')
 *  borderRight('solid')
 *  borderRight('2px', 'solid')
 *  borderRight('solid', '2px')
 *  borderRight('2px', 'solid', 'red')
 *  borderRight('solid', '2px', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-right
 *
 * @deprecated Just use `{ borderRight: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */
function borderRight(...values) {
  if (isBorderStyle(values[0])) {
    return Object.assign({
      borderRightStyle: values[0]
    }, values[1] && {
      borderRightWidth: values[1]
    }, values[2] && {
      borderRightColor: values[2]
    });
  }
  return Object.assign({
    borderRightWidth: values[0]
  }, values[1] && {
    borderRightStyle: values[1]
  }, values[2] && {
    borderRightColor: values[2]
  });
}

/**
 * A function that implements expansion for "border-Top", it's simplified - check usage examples.
 *
 * @example
 *  borderTop('2px')
 *  borderTop('solid')
 *  borderTop('2px', 'solid')
 *  borderTop('solid', '2px')
 *  borderTop('2px', 'solid', 'red')
 *  borderTop('solid', '2px', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-top
 *
 * @deprecated Just use `{ borderTop: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */
function borderTop(...values) {
  if (isBorderStyle(values[0])) {
    return Object.assign({
      borderTopStyle: values[0]
    }, values[1] && {
      borderTopWidth: values[1]
    }, values[2] && {
      borderTopColor: values[2]
    });
  }
  return Object.assign({
    borderTopWidth: values[0]
  }, values[1] && {
    borderTopStyle: values[1]
  }, values[2] && {
    borderTopColor: values[2]
  });
}

/**
 * A function that implements CSS spec conformant expansion for "borderRadius". "/" is not supported, please use CSS
 * longhands directly.
 *
 * @example
 *   borderRadius('10px')
 *   borderRadius('10px', '5%')
 *   borderRadius('2px', '4px', '8px')
 *   borderRadius('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/border-radius
 *
 * @deprecated Just use `{ borderRadius: '10px 5% 8px 4px' }` instead as Griffel supports CSS shorthands now
 */
function borderRadius$1(value1, value2 = value1, value3 = value1, value4 = value2) {
  return {
    borderBottomRightRadius: value3,
    borderBottomLeftRadius: value4,
    borderTopRightRadius: value2,
    borderTopLeftRadius: value1
  };
}

const isUnit = value => typeof value === 'string' && /(\d+(\w+|%))/.test(value);
const isUnitless = value => typeof value === 'number' && !Number.isNaN(value);
const isInitial = value => value === 'initial';
const isAuto = value => value === 'auto';
const isNone = value => value === 'none';
const widthReservedKeys = ['content', 'fit-content', 'max-content', 'min-content'];
const isWidth = value => widthReservedKeys.some(key => value === key) || isUnit(value);
/**
 * A function that implements CSS spec conformant expansion for "flex".
 *
 * @example
 *   flex('auto')
 *   flex(1, '2.5rem')
 *   flex(0, 0, 'auto')
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/flex
 *
 * @deprecated Just use `{ flex: '1 1 0' }` instead as Griffel supports CSS shorthands now
 */
function flex(...values) {
  const isOneValueSyntax = values.length === 1;
  const isTwoValueSyntax = values.length === 2;
  const isThreeValueSyntax = values.length === 3;
  if (isOneValueSyntax) {
    const [firstValue] = values;
    if (isInitial(firstValue)) {
      return {
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: 'auto'
      };
    }
    if (isAuto(firstValue)) {
      return {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto'
      };
    }
    if (isNone(firstValue)) {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto'
      };
    }
    if (isUnitless(firstValue)) {
      return {
        flexGrow: firstValue,
        flexShrink: 1,
        flexBasis: 0
      };
    }
    if (isWidth(firstValue)) {
      return {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: firstValue
      };
    }
  }
  if (isTwoValueSyntax) {
    const [firstValue, secondValue] = values;
    if (isUnitless(secondValue)) {
      return {
        flexGrow: firstValue,
        flexShrink: secondValue,
        flexBasis: 0
      };
    }
    if (isWidth(secondValue)) {
      return {
        flexGrow: firstValue,
        flexShrink: 1,
        flexBasis: secondValue
      };
    }
  }
  if (isThreeValueSyntax) {
    const [firstValue, secondValue, thirdValue] = values;
    if (isUnitless(firstValue) && isUnitless(secondValue) && (isAuto(thirdValue) || isWidth(thirdValue))) {
      return {
        flexGrow: firstValue,
        flexShrink: secondValue,
        flexBasis: thirdValue
      };
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`The value passed to shorthands.flex did not match any flex property specs. The CSS styles were not generated. Please, check the flex documentation.`);
  }
  return {};
}

/**
 * A function that implements CSS spec conformant expansion for "gap"
 *
 * @example
 *   gap('10px')
 *   gap('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/gap
 *
 * @deprecated Just use `{ gap: '10px 5px' }` instead as Griffel supports CSS shorthands now
 */
function gap(columnGap, rowGap = columnGap) {
  return {
    columnGap,
    rowGap
  };
}

const cssVarRegEx = /var\(.*\)/gi;
function isValidGridAreaInput(value) {
  return value === undefined || typeof value === 'number' || typeof value === 'string' && !cssVarRegEx.test(value);
}
// A custom-ident can be an alpha-numeric string including dash (-), underscore, escaped (\) characters, and escaped unicode
const customIdentRegEx = /^[a-zA-Z0-9\-_\\#;]+$/;
const nonCustomIdentRegEx = /^-moz-initial$|^auto$|^initial$|^inherit$|^revert$|^unset$|^span \d+$|^\d.*/;
// See https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident
function isCustomIdent(value) {
  return value !== undefined && typeof value === 'string' && customIdentRegEx.test(value) && !nonCustomIdentRegEx.test(value);
}
/**
 * A function that implements CSS spec conformant expansion for "grid-area"
 *
 * @example
 *   gridArea('auto')
 *   gridArea('first', 'second')
 *   gridArea(2, 4, 4)
 *   gridArea(2, 4, 1, 3)
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/grid-area
 *
 * @deprecated Just use `{ gridArea: '2 / 4 / 1 / 3' }` instead as Griffel supports CSS shorthands now
 */
function gridArea(...values) {
  // if any value is not valid, then do not apply the CSS.
  if (values.some(value => !isValidGridAreaInput(value))) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(`The value passed to shorthands.gridArea() did not match any gridArea property specs. The CSS styles were not generated. Please, check the gridArea documentation.`, ['The value passed to shorthands.gridArea() did not match any gridArea property specs. ', 'The CSS styles were not generated.\n', 'Please, check the `grid-area` documentation:\n', '- https://developer.mozilla.org/docs/Web/CSS/grid-area', '- https://griffel.js.org/react/api/shorthands#shorthandsgridarea'].join(''));
    }
    return {};
  }
  const gridRowStart = values[0] !== undefined ? values[0] : 'auto';
  // When grid-column-start is omitted, if grid-row-start is a <custom-ident>,
  // all four longhands are set to that value.
  // Otherwise, it is set to auto.
  const gridColumnStart = values[1] !== undefined ? values[1] : isCustomIdent(gridRowStart) ? gridRowStart : 'auto';
  // When grid-row-end is omitted,
  // if grid-row-start is a <custom-ident>, grid-row-end is set to that <custom-ident>;
  // otherwise, it is set to auto.
  const gridRowEnd = values[2] !== undefined ? values[2] : isCustomIdent(gridRowStart) ? gridRowStart : 'auto';
  // When grid-column-end is omitted,
  // if grid-column-start is a <custom-ident>, grid-column-end is set to that <custom-ident>;
  // otherwise, it is set to auto.
  const gridColumnEnd = values[3] !== undefined ? values[3] : isCustomIdent(gridColumnStart) ? gridColumnStart : 'auto';
  return {
    gridRowStart,
    gridColumnStart,
    gridRowEnd,
    gridColumnEnd
  };
}

/**
 * A function that implements CSS spec conformant expansion for "margin"
 *
 * @example
 *   margin('10px')
 *   margin('10px', '5px')
 *   margin('2px', '4px', '8px')
 *   margin('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/margin
 *
 * @deprecated Just use `{ margin: '10px 5px 8px 4px' }` instead as Griffel supports CSS shorthands now
 */
function margin(...values) {
  return generateStyles$2('margin', '', ...values);
}

/**
 * A function that implements CSS spec conformant expansion for "margin-block"
 *
 * @example
 *   marginBlock('10px')
 *   marginBlock('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/margin-block
 *
 * @deprecated Just use `{ marginBlock: '10px' }` instead as Griffel supports CSS shorthands now
 */
function marginBlock(start, end = start) {
  return {
    marginBlockStart: start,
    marginBlockEnd: end
  };
}

/**
 * A function that implements CSS spec conformant expansion for "margin-inline"
 *
 * @example
 *   marginInline('10px')
 *   marginInline('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/margin-inline
 *
 * @deprecated Just use `{ marginInline: '10px' }` instead as Griffel supports CSS shorthands now
 */
function marginInline(start, end = start) {
  return {
    marginInlineStart: start,
    marginInlineEnd: end
  };
}

/**
 * A function that implements CSS spec conformant expansion for "padding"
 *
 * @example
 *   padding('10px')
 *   padding('10px', '5px')
 *   padding('2px', '4px', '8px')
 *   padding('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/padding
 *
 * @deprecated Just use `{ padding: '10px 5px 8px 4px' }` instead as Griffel supports CSS shorthands now
 */
function padding(...values) {
  return generateStyles$2('padding', '', ...values);
}

/**
 * A function that implements CSS spec conformant expansion for "padding-block"
 *
 * @example
 *   paddingBlock('10px')
 *   paddingBlock('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/padding-block
 *
 * @deprecated Just use `{ paddingBlock: '10px' }` instead as Griffel supports CSS shorthands now
 */
function paddingBlock(start, end = start) {
  return {
    paddingBlockStart: start,
    paddingBlockEnd: end
  };
}

/**
 * A function that implements CSS spec conformant expansion for "padding-inline"
 *
 * @example
 *   paddingInline('10px')
 *   paddingInline('10px', '5px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/padding-inline
 *
 * @deprecated Just use `{ paddingInline: '10px' }` instead as Griffel supports CSS shorthands now
 */
function paddingInline(start, end = start) {
  return {
    paddingInlineStart: start,
    paddingInlineEnd: end
  };
}

/**
 * A function that implements CSS spec conformant expansion for "overflow"
 *
 * @example
 *   overflow('hidden')
 *   overflow('hidden', 'scroll')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
 *
 * @deprecated Just use `{ overflow: 'hidden scroll' }` instead as Griffel supports CSS shorthands now
 */
function overflow(overflowX, overflowY = overflowX) {
  return {
    overflowX,
    overflowY
  };
}

/**
 * A function that implements CSS spec conformant expansion for "inset"
 *
 * @example
 *   inset('10px')
 *   inset('10px', '5px')
 *   inset('2px', '4px', '8px')
 *   inset('1px', 0, '3px', '4px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/inset
 *
 * @deprecated Just use `{ inset: '10px 5px 8px 4px' }` instead as Griffel supports CSS shorthands now
 */
function inset(...values) {
  const [firstValue, secondValue = firstValue, thirdValue = firstValue, fourthValue = secondValue] = values;
  return {
    top: firstValue,
    right: secondValue,
    bottom: thirdValue,
    left: fourthValue
  };
}

/**
 * A function that implements expansion for "outline", it's simplified - check usage examples.
 *
 * @example
 *  outline('2px')
 *  outline('2px', 'solid')
 *  outline('2px', 'solid', 'red')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/outline
 *
 * @deprecated Just use `{ outline: '2px solid red' }` instead as Griffel supports CSS shorthands now
 */
function outline(outlineWidth, outlineStyle, outlineColor) {
  return Object.assign({
    outlineWidth
  }, outlineStyle && {
    outlineStyle
  }, outlineColor && {
    outlineColor
  });
}

/**
 * A function that implements expansion for "transition", it's simplified - check usage examples.
 *
 * @example
 *  transition('inherit')
 *  transition('margin-right', '4s')
 *  transition('margin-right', '4s', '1s')
 *  transition('margin-right', '4s', '1s', 'ease-in')
 *  transition([
 *    ['margin-right', '4s', '1s', 'ease-in'],
 *    ['margin-right', '4s', '1s', 'ease-in'],
 * ])
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/transition
 *
 * @deprecated Just use `{ transition: 'margin-right 4s 1s ease-in' }` instead as Griffel supports CSS shorthands now
 */
function transition(...values) {
  if (isTransitionGlobalInputs(values)) {
    return {
      transitionDelay: values[0],
      transitionDuration: values[0],
      transitionProperty: values[0],
      transitionTimingFunction: values[0]
    };
  }
  const transitionInputs = normalizeTransitionInputs(values);
  return transitionInputs.reduce((acc, [property, duration = '0s', delay = '0s', timingFunction = 'ease'], index) => {
    if (index === 0) {
      acc.transitionProperty = property;
      acc.transitionDuration = duration;
      acc.transitionDelay = delay;
      acc.transitionTimingFunction = timingFunction;
    } else {
      acc.transitionProperty += `, ${property}`;
      acc.transitionDuration += `, ${duration}`;
      acc.transitionDelay += `, ${delay}`;
      acc.transitionTimingFunction += `, ${timingFunction}`;
    }
    return acc;
  }, {});
}
const transitionGlobalInputs = ['-moz-initial', 'inherit', 'initial', 'revert', 'unset'];
function isTransitionGlobalInputs(values) {
  return values.length === 1 && transitionGlobalInputs.includes(values[0]);
}
function normalizeTransitionInputs(transitionInputs) {
  if (transitionInputs.length === 1 && Array.isArray(transitionInputs[0])) {
    return transitionInputs[0];
  }
  return [transitionInputs];
}

/**
 * A function that implements expansion for "textDecoration" to all sides of an element, it's simplified - check usage examples.
 *
 * @example
 *  textDecoration('none')
 *  textDecoration('dotted')
 *  textDecoration('underline', 'dotted')
 *  textDecoration('underline', 'dotted', 'red')
 *  textDecoration('underline', 'dotted', 'red', '2px')
 *
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration
 *
 * @deprecated Just use `{ textDecoration: 'underline dotted red 2px' }` instead as Griffel supports CSS shorthands now
 */
function textDecoration(value, ...values) {
  if (values.length === 0) {
    return isTextDecorationStyleInput(value) ? {
      textDecorationStyle: value
    } : {
      textDecorationLine: value
    };
  }
  const [textDecorationStyle, textDecorationColor, textDecorationThickness] = values;
  return Object.assign({
    textDecorationLine: value
  }, textDecorationStyle && {
    textDecorationStyle
  }, textDecorationColor && {
    textDecorationColor
  }, textDecorationThickness && {
    textDecorationThickness
  });
}
const textDecorationStyleInputs = ['dashed', 'dotted', 'double', 'solid', 'wavy'];
function isTextDecorationStyleInput(value) {
  return textDecorationStyleInputs.includes(value);
}

const __GLOBAL__ = typeof window === "undefined" ? window : window;
const __NAMESPACE_PREFIX__ = "@griffel/";
function getGlobalVar(name, defaultValue) {
  if (!__GLOBAL__[Symbol.for(__NAMESPACE_PREFIX__ + name)]) {
    __GLOBAL__[Symbol.for(__NAMESPACE_PREFIX__ + name)] = defaultValue;
  }
  return __GLOBAL__[Symbol.for(__NAMESPACE_PREFIX__ + name)];
}
const DEBUG_RESET_CLASSES = /* @__PURE__ */ getGlobalVar("DEBUG_RESET_CLASSES", {});
const DEFINITION_LOOKUP_TABLE = /* @__PURE__ */ getGlobalVar("DEFINITION_LOOKUP_TABLE", {});
const DATA_BUCKET_ATTR = "data-make-styles-bucket";
const DATA_PRIORITY_ATTR = "data-priority";
const HASH_PREFIX = "f";
const RESET_HASH_PREFIX = "r";
const SEQUENCE_HASH_LENGTH = 7;
const SEQUENCE_PREFIX = "___";
const DEBUG_SEQUENCE_SEPARATOR = "_";
const SEQUENCE_SIZE = process.env.NODE_ENV === "production" ? SEQUENCE_PREFIX.length + SEQUENCE_HASH_LENGTH : SEQUENCE_PREFIX.length + SEQUENCE_HASH_LENGTH + DEBUG_SEQUENCE_SEPARATOR.length + SEQUENCE_HASH_LENGTH;
const LOOKUP_DEFINITIONS_INDEX = 0;
const LOOKUP_DIR_INDEX = 1;
const UNSUPPORTED_CSS_PROPERTIES = {
  all: 1,
  borderColor: 1,
  borderStyle: 1,
  borderWidth: 1,
  borderBlock: 1,
  borderBlockEnd: 1,
  borderBlockStart: 1,
  borderInline: 1,
  borderInlineEnd: 1,
  borderInlineStart: 1
};
const RESET = "DO_NOT_USE_DIRECTLY: @griffel/reset-value";

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

function padEndHash(value) {
  const hashLength = value.length;
  if (hashLength === SEQUENCE_HASH_LENGTH) {
    return value;
  }
  for (let i = hashLength; i < SEQUENCE_HASH_LENGTH; i++) {
    value += '0';
  }
  return value;
}
function hashSequence(classes, dir, sequenceIds = []) {
  if (process.env.NODE_ENV === 'production') {
    return SEQUENCE_PREFIX + padEndHash(murmur2(classes + dir));
  }
  return SEQUENCE_PREFIX + padEndHash(murmur2(classes + dir)) + DEBUG_SEQUENCE_SEPARATOR + padEndHash(murmur2(sequenceIds.join('')));
}

/**
 * Reduces a classname map for slot to a classname string. Uses classnames according to text directions.
 *
 * @private
 */
function reduceToClassName(classMap, dir) {
  // - `classString` is a string of classnames separated by a space, used to output classes
  // - `hashString` is a string of classnames separated by a space, used to generate a hash
  //
  // `hashString` is needed to handle `null` values in a class map as they don't produce any classes.
  let classString = '';
  let hashString = '';
  // eslint-disable-next-line guard-for-in
  for (const propertyHash in classMap) {
    const classNameMapping = classMap[propertyHash];
    if (classNameMapping === 0) {
      hashString += propertyHash + ' ';
      continue;
    }
    const hasRTLClassName = Array.isArray(classNameMapping);
    const className = dir === 'rtl' ? (hasRTLClassName ? classNameMapping[1] : classNameMapping) + ' ' : (hasRTLClassName ? classNameMapping[0] : classNameMapping) + ' ';
    classString += className;
    hashString += className;
  }
  return [classString.slice(0, -1), hashString.slice(0, -1)];
}
/**
 * Reduces classname maps for slots to classname strings. Registers them in a definition cache to be used by
 * `mergeClasses()`.
 *
 * @internal
 */
function reduceToClassNameForSlots(classesMapBySlot, dir) {
  const classNamesForSlots = {};
  // eslint-disable-next-line guard-for-in
  for (const slotName in classesMapBySlot) {
    const [slotClasses, slotClassesHash] = reduceToClassName(classesMapBySlot[slotName], dir);
    // Handles a case when there are no classes in a set i.e. "makeStyles({ root: {} })"
    if (slotClassesHash === '') {
      classNamesForSlots[slotName] = '';
      continue;
    }
    const sequenceHash = hashSequence(slotClassesHash, dir);
    const resultSlotClasses = sequenceHash + (slotClasses === '' ? '' : ' ' + slotClasses);
    DEFINITION_LOOKUP_TABLE[sequenceHash] = [classesMapBySlot[slotName], dir];
    classNamesForSlots[slotName] = resultSlotClasses;
  }
  return classNamesForSlots;
}

// Contains a mapping of previously resolved sequences of atomic classnames
const mergeClassesCachedResults = {};
function mergeClasses() {
  // arguments are parsed manually to avoid double loops as TS & Babel transforms rest via an additional loop
  // @see https://babeljs.io/docs/en/babel-plugin-transform-parameters
  /* eslint-disable prefer-rest-params */
  let dir = null;
  let resultClassName = '';
  // Is used as a cache key to avoid object merging
  let sequenceMatch = '';
  const sequencesIds = new Array(arguments.length);
  let containsResetClassName = '';
  for (let i = 0; i < arguments.length; i++) {
    const className = arguments[i];
    if (typeof className === 'string' && className !== '') {
      // All classes generated by `makeStyles()` are prefixed by a sequence hash, this allows to identify class sets
      // without parsing each className in a string
      const sequenceIndex = className.indexOf(SEQUENCE_PREFIX);
      if (sequenceIndex === -1) {
        if (process.env.NODE_ENV !== 'production') {
          className.split(' ').forEach(entry => {
            if (entry.startsWith(RESET_HASH_PREFIX) && DEBUG_RESET_CLASSES[entry]) {
              if (containsResetClassName) {
                // eslint-disable-next-line no-console
                console.error('mergeClasses(): a passed string contains multiple classes produced by makeResetStyles (' + `${className} & ${resultClassName}, this will lead to non-deterministic behavior. Learn more:` + 'https://griffel.js.org/react/api/make-reset-styles#limitations' + '\n' + `Source string: ${className}`);
              } else {
                containsResetClassName = entry;
              }
            }
          });
        }
        resultClassName += className + ' ';
      } else {
        const sequenceId = className.substr(sequenceIndex, SEQUENCE_SIZE);
        // Handles a case with mixed classnames, i.e. "ui-button ATOMIC_CLASSES"
        if (sequenceIndex > 0) {
          resultClassName += className.slice(0, sequenceIndex);
        }
        sequenceMatch += sequenceId;
        sequencesIds[i] = sequenceId;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (className.indexOf(SEQUENCE_PREFIX, sequenceIndex + 1) !== -1) {
          // eslint-disable-next-line no-console
          console.error('mergeClasses(): a passed string contains multiple identifiers of atomic classes (classes that start ' + `with "${SEQUENCE_PREFIX}"), it's possible that passed classes were concatenated in a wrong way. ` + `Source string: ${className}`);
        }
      }
    }
  }
  // .slice() there allows to avoid trailing space for non-atomic classes
  // "ui-button ui-flex " => "ui-button ui-flex"
  if (sequenceMatch === '') {
    return resultClassName.slice(0, -1);
  }
  // It's safe to reuse results to avoid continuous merging as results are stable
  // "__seq1 ... __seq2 ..." => "__seq12 ..."
  const mergeClassesResult = mergeClassesCachedResults[sequenceMatch];
  if (mergeClassesResult !== undefined) {
    return resultClassName + mergeClassesResult;
  }
  const sequenceMappings = [];
  for (let i = 0; i < arguments.length; i++) {
    const sequenceId = sequencesIds[i];
    if (sequenceId) {
      const sequenceMapping = DEFINITION_LOOKUP_TABLE[sequenceId];
      if (sequenceMapping) {
        sequenceMappings.push(sequenceMapping[LOOKUP_DEFINITIONS_INDEX]);
        if (process.env.NODE_ENV !== 'production') {
          if (dir !== null && dir !== sequenceMapping[LOOKUP_DIR_INDEX]) {
            // eslint-disable-next-line no-console
            console.error(`mergeClasses(): a passed string contains an identifier (${sequenceId}) that has different direction ` + `(dir="${sequenceMapping[1] ? 'rtl' : 'ltr'}") setting than other classes. This is not supported. ` + `Source string: ${arguments[i]}`);
          }
        }
        dir = sequenceMapping[LOOKUP_DIR_INDEX];
      } else {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.error(`mergeClasses(): a passed string contains an identifier (${sequenceId}) that does not match any entry ` + `in cache. Source string: ${arguments[i]}`);
        }
      }
    }
  }
  // eslint-disable-next-line prefer-spread
  const resultClassesMap = Object.assign.apply(Object,
  // .assign() mutates the first object, we can't mutate mappings as it will produce invalid results later
  [{}].concat(sequenceMappings));
  const [atomicClasses, classesMapHash] = reduceToClassName(resultClassesMap, dir);
  // Each merge of classes generates a new sequence of atomic classes that needs to be registered
  const newSequenceHash = hashSequence(classesMapHash, dir, sequencesIds);
  const newClassName = newSequenceHash + ' ' + atomicClasses;
  mergeClassesCachedResults[sequenceMatch] = newClassName;
  DEFINITION_LOOKUP_TABLE[newSequenceHash] = [resultClassesMap, dir];
  return resultClassName + newClassName;
}

const sequenceDetails = {};
const cssRules = /*#__PURE__*/new Set();
const debugData = {
  getChildrenSequences: debugSequenceHash => {
    const key = Object.keys(mergeClassesCachedResults).find(key => mergeClassesCachedResults[key].startsWith(debugSequenceHash));
    if (key) {
      // key of the mergeClasses cache contains merge order
      return key.split(SEQUENCE_PREFIX).filter(sequence => sequence.length).map(sequence => SEQUENCE_PREFIX + sequence);
    }
    return [];
  },
  addCSSRule: rule => {
    cssRules.add(rule);
  },
  addSequenceDetails: (classNamesForSlots, sourceURL) => {
    Object.entries(classNamesForSlots).forEach(([slotName, sequenceHash]) => {
      sequenceDetails[sequenceHash.substring(0, SEQUENCE_SIZE)] = {
        slotName,
        sourceURL
      };
    });
  },
  getCSSRules: () => {
    return Array.from(cssRules);
  },
  getSequenceDetails: sequenceHash => {
    return sequenceDetails[sequenceHash];
  }
};

function getDirectionalClassName(classes, direction) {
  return Array.isArray(classes) ? direction === 'rtl' ? classes[1] : classes[0] : classes || '';
}
function getDebugClassNames(lookupItem, parentLookupItem, parentDebugClassNames, overridingSiblings) {
  const classesMapping = lookupItem[0];
  const direction = lookupItem[1];
  return Object.entries(classesMapping).map(([propertyHash, classes]) => {
    const className = getDirectionalClassName(classes, direction);
    let overriddenBy;
    if (parentDebugClassNames && parentLookupItem) {
      const matching = parentDebugClassNames.find(({
        className: parentClassName
      }) => parentClassName === className);
      if (!matching && parentLookupItem[0][propertyHash]) {
        // parent node does not have current className (style), but has current selector:
        // style is overriden in current merging by another rule in sibling node
        overriddenBy = getDirectionalClassName(parentLookupItem[0][propertyHash], parentLookupItem[1]);
      } else if (matching && parentLookupItem[0][propertyHash]) {
        // parent node has current className (style), and has current selector:
        // case 1. style is not overriden during current merging; it may be overriden in higher level of merging
        // case 2. style is overriden in current merging by exactly the same rule in sibling nodes
        const siblingHasSameRule = overridingSiblings ? overridingSiblings.filter(({
          debugClassNames
        }) => debugClassNames.filter(({
          className: siblingClassName
        }) => siblingClassName === className).length > 0).length > 0 : false;
        overriddenBy = siblingHasSameRule ? matching.className // case 2
        : matching.overriddenBy; // case 1
      } else if (!matching && !parentLookupItem[0][propertyHash]) {
        // parent node does not have current className (style), and does not have current selector:
        // this case is not possible
        overriddenBy = undefined;
      } else if (matching && !parentLookupItem[0][propertyHash]) {
        // parent node has current className (style), but does not have current selector:
        // this case is not possible
        overriddenBy = undefined;
      }
    }
    return {
      className,
      overriddenBy
    };
  });
}

function getDebugTree(debugSequenceHash, parentNode) {
  const lookupItem = DEFINITION_LOOKUP_TABLE[debugSequenceHash];
  if (lookupItem === undefined) {
    return undefined;
  }
  const parentLookupItem = parentNode ? DEFINITION_LOOKUP_TABLE[parentNode.sequenceHash] : undefined;
  const debugClassNames = getDebugClassNames(lookupItem, parentLookupItem, parentNode === null || parentNode === undefined ? undefined : parentNode.debugClassNames, parentNode === null || parentNode === undefined ? undefined : parentNode.children);
  const node = {
    sequenceHash: debugSequenceHash,
    direction: lookupItem[1],
    children: [],
    debugClassNames
  };
  const childrenSequences = debugData.getChildrenSequences(node.sequenceHash);
  childrenSequences.reverse() // first process the overriding children that are merged last
  .forEach(sequence => {
    const child = getDebugTree(sequence, node);
    if (child) {
      node.children.push(child);
    }
  });
  // if it's leaf (makeStyle node), get css rules
  if (!node.children.length) {
    node.rules = {};
    node.debugClassNames.forEach(({
      className
    }) => {
      const mapData = debugData.getSequenceDetails(debugSequenceHash);
      if (mapData) {
        node.slot = mapData.slotName;
        node.sourceURL = mapData.sourceURL;
      }
      const cssRule = debugData.getCSSRules().find(cssRule => {
        return cssRule.includes(className);
      });
      node.rules[className] = cssRule;
    });
  }
  return node;
}

function injectDevTools(document) {
  const window = document.defaultView;
  if (!window || window.__GRIFFEL_DEVTOOLS__) {
    return;
  }
  const devtools = {
    getInfo: element => {
      const rootDebugSequenceHash = Array.from(element.classList).find(className => className.startsWith(SEQUENCE_PREFIX));
      if (rootDebugSequenceHash === undefined) {
        return undefined;
      }
      return getDebugTree(rootDebugSequenceHash);
    }
  };
  Object.defineProperty(window, '__GRIFFEL_DEVTOOLS__', {
    configurable: false,
    enumerable: false,
    get() {
      return devtools;
    }
  });
}

const isDevToolsEnabled = /*#__PURE__*/(() => {
  var _a;
  // Accessing "window.sessionStorage" causes an exception when third party cookies are blocked
  // https://stackoverflow.com/questions/30481516/iframe-in-chrome-error-failed-to-read-localstorage-from-window-access-deni
  try {
    return Boolean(typeof window !== 'undefined' && ((_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem('__GRIFFEL_DEVTOOLS__')));
  } catch (e) {
    return false;
  }
})();

/**
 * @internal
 *
 * @param entry - CSS bucket entry that can be either a string or an array
 * @returns An array where the first element is the CSS rule
 */
function normalizeCSSBucketEntry(entry) {
  if (!Array.isArray(entry)) {
    return [entry];
  }
  if (process.env.NODE_ENV !== 'production' && entry.length > 2) {
    throw new Error('CSS Bucket contains an entry with greater than 2 items, please report this to https://github.com/microsoft/griffel/issues');
  }
  return entry;
}

function createIsomorphicStyleSheet(styleElement, bucketName, priority, elementAttributes) {
  // no CSSStyleSheet in SSR, just append rules here for server render
  const __cssRulesForSSR = [];
  elementAttributes[DATA_BUCKET_ATTR] = bucketName;
  elementAttributes[DATA_PRIORITY_ATTR] = String(priority);
  if (styleElement) {
    for (const attrName in elementAttributes) {
      styleElement.setAttribute(attrName, elementAttributes[attrName]);
    }
  }
  function insertRule(rule) {
    if (styleElement === null || styleElement === undefined ? undefined : styleElement.sheet) {
      return styleElement.sheet.insertRule(rule, styleElement.sheet.cssRules.length);
    }
    return __cssRulesForSSR.push(rule);
  }
  return {
    elementAttributes,
    insertRule,
    element: styleElement,
    bucketName,
    cssRules() {
      if (styleElement === null || styleElement === undefined ? undefined : styleElement.sheet) {
        return Array.from(styleElement.sheet.cssRules).map(cssRule => cssRule.cssText);
      }
      return __cssRulesForSSR;
    }
  };
}

/**
 * Ordered style buckets using their short pseudo name.
 *
 * @internal
 */
const styleBucketOrdering = [
// reset styles
'r',
// catch-all
'd',
// link
'l',
// visited
'v',
// focus-within
'w',
// focus
'f',
// focus-visible
'i',
// hover
'h',
// active
'a',
// at rules for reset styles
's',
// keyframes
'k',
// at-rules
't',
// @media rules
'm',
// @container rules
'c'];
// avoid repeatedly calling `indexOf` to determine order during new insertions
const styleBucketOrderingMap = /*#__PURE__*/styleBucketOrdering.reduce((acc, cur, j) => {
  acc[cur] = j;
  return acc;
}, {});
function getStyleSheetKey(bucketName, media, priority) {
  return (bucketName === 'm' ? bucketName + media : bucketName) + priority;
}
/**
 * Lazily adds a `<style>` bucket to the `<head>`. This will ensure that the style buckets are ordered.
 */
function getStyleSheetForBucket(bucketName, targetDocument, insertionPoint, renderer, metadata = {}) {
  var _a, _b;
  const isMediaBucket = bucketName === 'm';
  const media = (_a = metadata['m']) !== null && _a !== undefined ? _a : '0';
  const priority = (_b = metadata['p']) !== null && _b !== undefined ? _b : 0;
  const stylesheetKey = getStyleSheetKey(bucketName, media, priority);
  if (!renderer.stylesheets[stylesheetKey]) {
    const tag = targetDocument && targetDocument.createElement('style');
    const stylesheet = createIsomorphicStyleSheet(tag, bucketName, priority, Object.assign({}, renderer.styleElementAttributes, isMediaBucket && {
      media
    }));
    renderer.stylesheets[stylesheetKey] = stylesheet;
    if (targetDocument && tag) {
      targetDocument.head.insertBefore(tag, findInsertionPoint(targetDocument, insertionPoint, bucketName, renderer, metadata));
    }
  }
  return renderer.stylesheets[stylesheetKey];
}
function isSameInsertionKey(element, bucketName, metadata) {
  var _a, _b;
  const targetKey = bucketName + ((_a = metadata['m']) !== null && _a !== undefined ? _a : '');
  const elementKey = element.getAttribute(DATA_BUCKET_ATTR) + ((_b = element.media) !== null && _b !== undefined ? _b : '');
  return targetKey === elementKey;
}
/**
 * Finds an element before which the new bucket style element should be inserted following the bucket sort order.
 *
 * @param targetDocument - A document
 * @param insertionPoint - An element that will be used as an initial insertion point
 * @param targetBucket - The bucket that should be inserted to DOM
 * @param renderer - Griffel renderer
 * @param metadata - metadata for CSS rule
 * @returns - Smallest style element with greater sort order than the current bucket
 */
function findInsertionPoint(targetDocument, insertionPoint, targetBucket, renderer, metadata = {}) {
  var _a, _b;
  const targetOrder = styleBucketOrderingMap[targetBucket];
  const media = (_a = metadata['m']) !== null && _a !== undefined ? _a : '';
  const priority = (_b = metadata['p']) !== null && _b !== undefined ? _b : 0;
  // Similar to javascript sort comparators where
  // a positive value is increasing sort order
  // a negative value is decreasing sort order
  let comparer = el => targetOrder - styleBucketOrderingMap[el.getAttribute(DATA_BUCKET_ATTR)];
  let styleElements = targetDocument.head.querySelectorAll(`[${DATA_BUCKET_ATTR}]`);
  if (targetBucket === 'm') {
    const mediaElements = targetDocument.head.querySelectorAll(`[${DATA_BUCKET_ATTR}="${targetBucket}"]`);
    // only reduce the scope of the search and change comparer
    // if there are other media buckets already on the page
    if (mediaElements.length) {
      styleElements = mediaElements;
      comparer = el => renderer.compareMediaQueries(media, el.media);
    }
  }
  const comparerWithPriority = el => {
    if (isSameInsertionKey(el, targetBucket, metadata)) {
      return priority - Number(el.getAttribute('data-priority'));
    }
    return comparer(el);
  };
  const length = styleElements.length;
  let index = length - 1;
  while (index >= 0) {
    const styleElement = styleElements.item(index);
    if (comparerWithPriority(styleElement) > 0) {
      return styleElement.nextSibling;
    }
    index--;
  }
  if (length > 0) {
    return styleElements.item(0);
  }
  return insertionPoint ? insertionPoint.nextSibling : null;
}

/**
 * Suffixes to be ignored in case of error
 */
const ignoreSuffixes = /*#__PURE__*/['-moz-placeholder', '-moz-focus-inner', '-moz-focusring', '-ms-input-placeholder', '-moz-read-write', '-moz-read-only'].join('|');
const ignoreSuffixesRegex = /*#__PURE__*/new RegExp(`:(${ignoreSuffixes})`);
/**
 * @internal
 *
 * Calls `sheet.insertRule` and catches errors related to browser prefixes.
 */
function safeInsertRule(sheet, ruleCSS) {
  try {
    sheet.insertRule(ruleCSS);
  } catch (e) {
    // We've disabled these warnings due to false-positive errors with browser prefixes
    if (process.env.NODE_ENV !== 'production' && !ignoreSuffixesRegex.test(ruleCSS)) {
      // eslint-disable-next-line no-console
      console.error(`There was a problem inserting the following rule: "${ruleCSS}"`, e);
    }
  }
}

let lastIndex = 0;
/** @internal */
const defaultCompareMediaQueries = (a, b) => a < b ? -1 : a > b ? 1 : 0;
/**
 * Creates a new instances of a renderer.
 *
 * @public
 */
function createDOMRenderer(targetDocument = typeof document === 'undefined' ? undefined : document, options = {}) {
  const {
    classNameHashSalt,
    unstable_filterCSSRule,
    insertionPoint,
    styleElementAttributes,
    compareMediaQueries = defaultCompareMediaQueries
  } = options;
  const renderer = {
    classNameHashSalt,
    insertionCache: {},
    stylesheets: {},
    styleElementAttributes: Object.freeze(styleElementAttributes),
    compareMediaQueries,
    id: `d${lastIndex++}`,
    insertCSSRules(cssRules) {
      // eslint-disable-next-line guard-for-in
      for (const styleBucketName in cssRules) {
        const cssRulesForBucket = cssRules[styleBucketName];
        // This is a hot path in rendering styles: ".length" is cached in "l" var to avoid accesses the property
        for (let i = 0, l = cssRulesForBucket.length; i < l; i++) {
          const [ruleCSS, metadata] = normalizeCSSBucketEntry(cssRulesForBucket[i]);
          const sheet = getStyleSheetForBucket(styleBucketName, targetDocument, insertionPoint || null, renderer, metadata);
          if (renderer.insertionCache[ruleCSS]) {
            continue;
          }
          renderer.insertionCache[ruleCSS] = styleBucketName;
          if (process.env.NODE_ENV !== 'production' && isDevToolsEnabled) {
            debugData.addCSSRule(ruleCSS);
          }
          if (unstable_filterCSSRule) {
            if (unstable_filterCSSRule(ruleCSS)) {
              safeInsertRule(sheet, ruleCSS);
            }
          } else {
            safeInsertRule(sheet, ruleCSS);
          }
        }
      }
    }
  };
  if (targetDocument && process.env.NODE_ENV !== 'production' && isDevToolsEnabled) {
    injectDevTools(targetDocument);
  }
  return renderer;
}

// TODO: duplicated from https://github.com/lahmatiy/react-render-tracker/blob/main/src/publisher/react-integration/utils/stackTrace.ts
// once it is published as a standalone npm package, remove this file
// Adopted version of StackTrace-Parser
// https://github.com/errwischt/stacktrace-parser/blob/master/src/stack-trace-parser.js
const UNKNOWN_FUNCTION = '<unknown>';
function parseStackTraceLine(line) {
  return parseChrome(line) || parseGecko(line) || parseJSC(line);
}
const chromeRe = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)?\)?\s*$/i;
const chromeRe2 = /^\s*at ()((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)\s*$/i;
const chromeEvalRe = /\((\S*)\)/;
function parseChrome(line) {
  const parts = chromeRe.exec(line) || chromeRe2.exec(line);
  if (!parts) {
    return null;
  }
  let loc = parts[2];
  const isNative = loc && loc.indexOf('native') === 0; // start of line
  const isEval = loc && loc.indexOf('eval') === 0; // start of line
  const submatch = chromeEvalRe.exec(loc);
  if (isEval && submatch != null) {
    // throw out eval line/column and use top-most line/column number
    loc = submatch[1]; // url
  }
  return {
    loc: !isNative ? parts[2] : null,
    name: parts[1] || UNKNOWN_FUNCTION
  };
}
const geckoRe = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)\s*$/i;
const geckoEvalRe = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGecko(line) {
  const parts = geckoRe.exec(line);
  if (!parts) {
    return null;
  }
  let loc = parts[3];
  const isEval = loc && loc.indexOf(' > eval') > -1;
  const submatch = geckoEvalRe.exec(loc);
  if (isEval && submatch != null) {
    // throw out eval line/column and use top-most line number
    loc = submatch[1];
  }
  return {
    loc: parts[3],
    name: parts[1] || UNKNOWN_FUNCTION
  };
}
const javaScriptCoreRe = /^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?)\s*$/i;
function parseJSC(line) {
  const parts = javaScriptCoreRe.exec(line);
  if (!parts) {
    return null;
  }
  return {
    loc: parts[3],
    name: parts[1] || UNKNOWN_FUNCTION
  };
}

function getSourceURLfromError() {
  const stacks = String(new Error().stack).split('\n');
  const userMakeStyleCallLine = findUserMakeStyleCallInStacks(stacks);
  if (userMakeStyleCallLine === undefined) {
    return undefined;
  }
  const result = parseStackTraceLine(userMakeStyleCallLine);
  return result === null || result === undefined ? undefined : result.loc;
}
function findUserMakeStyleCallInStacks(stacks) {
  for (let i = stacks.length - 1; i >= 0; --i) {
    if (stacks[i].includes('at getSourceURLfromError')) {
      // The error stacks look like:
      //   getSourceURLfromError
      //   makeStyles/__styles in griffel core
      //   makeStyles/__styles in griffel react
      //   user makeStyles call
      return stacks[i + 3];
    }
  }
  return undefined;
}

/**
 * Default implementation of insertion factory. Inserts styles only once per renderer and performs
 * insertion immediately after styles computation.
 *
 * @internal
 */
const insertionFactory$1 = () => {
  const insertionCache = {};
  return function insertStyles(renderer, cssRules) {
    if (insertionCache[renderer.id] === undefined) {
      renderer.insertCSSRules(cssRules);
      insertionCache[renderer.id] = true;
    }
  };
};

/**
 * Takes an array of [keyValue1, keyValue2] pairs and creates an object of {keyValue1: keyValue2, keyValue2: keyValue1}
 * @param {Array} array the array of pairs
 * @return {Object} the {key, value} pair object
 */
function arrayToObject$1(array) {
  return array.reduce(function (obj, _ref) {
    var prop1 = _ref[0],
      prop2 = _ref[1];
    obj[prop1] = prop2;
    obj[prop2] = prop1;
    return obj;
  }, {});
}
function isBoolean$3(val) {
  return typeof val === 'boolean';
}
function isFunction$4(val) {
  return typeof val === 'function';
}
function isNumber$4(val) {
  return typeof val === 'number';
}
function isNullOrUndefined$1(val) {
  return val === null || typeof val === 'undefined';
}
function isObject$8(val) {
  return val && typeof val === 'object';
}
function isString$3(val) {
  return typeof val === 'string';
}
function includes(inclusive, inclusee) {
  return inclusive.indexOf(inclusee) !== -1;
}

/**
 * Flip the sign of a CSS value, possibly with a unit.
 *
 * We can't just negate the value with unary minus due to the units.
 *
 * @private
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example -77%)
 */
function flipSign(value) {
  if (parseFloat(value) === 0) {
    // Don't mangle zeroes
    return value;
  }
  if (value[0] === '-') {
    return value.slice(1);
  }
  return "-" + value;
}
function flipTransformSign(match, prefix, offset, suffix) {
  return prefix + flipSign(offset) + suffix;
}

/**
 * Takes a percentage for background position and inverts it.
 * This was copied and modified from CSSJanus:
 * https://github.com/cssjanus/cssjanus/blob/4245f834365f6cfb0239191a151432fb85abab23/src/cssjanus.js#L152-L175
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example 23%)
 */
function calculateNewBackgroundPosition(value) {
  var idx = value.indexOf('.');
  if (idx === -1) {
    value = 100 - parseFloat(value) + "%";
  } else {
    // Two off, one for the "%" at the end, one for the dot itself
    var len = value.length - idx - 2;
    value = 100 - parseFloat(value);
    value = value.toFixed(len) + "%";
  }
  return value;
}

/**
 * This takes a list of CSS values and converts it to an array
 * @param {String} value - something like `1px`, `1px 2em`, or `3pt rgb(150, 230, 550) 40px calc(100% - 5px)`
 * @return {Array} the split values (for example: `['3pt', 'rgb(150, 230, 550)', '40px', 'calc(100% - 5px)']`)
 */
function getValuesAsList(value) {
  return value.replace(/ +/g, ' ') // remove all extraneous spaces
  .split(' ').map(function (i) {
    return i.trim();
  }) // get rid of extra space before/after each item
  .filter(Boolean) // get rid of empty strings
  // join items which are within parenthese
  // luckily `calc (100% - 5px)` is invalid syntax and it must be `calc(100% - 5px)`, otherwise this would be even more complex
  .reduce(function (_ref2, item) {
    var list = _ref2.list,
      state = _ref2.state;
    var openParansCount = (item.match(/\(/g) || []).length;
    var closedParansCount = (item.match(/\)/g) || []).length;
    if (state.parensDepth > 0) {
      list[list.length - 1] = list[list.length - 1] + " " + item;
    } else {
      list.push(item);
    }
    state.parensDepth += openParansCount - closedParansCount;
    return {
      list: list,
      state: state
    };
  }, {
    list: [],
    state: {
      parensDepth: 0
    }
  }).list;
}

/**
 * This is intended for properties that are `top right bottom left` and will switch them to `top left bottom right`
 * @param {String} value - `1px 2px 3px 4px` for example, but also handles cases where there are too few/too many and
 * simply returns the value in those cases (which is the correct behavior)
 * @return {String} the result - `1px 4px 3px 2px` for example.
 */
function handleQuartetValues(value) {
  var splitValues = getValuesAsList(value);
  if (splitValues.length <= 3 || splitValues.length > 4) {
    return value;
  }
  var top = splitValues[0],
    right = splitValues[1],
    bottom = splitValues[2],
    left = splitValues[3];
  return [top, left, bottom, right].join(' ');
}

/**
 *
 * @param {String|Number|Object} value css property value to test
 * @returns If the css property value can(should?) have an RTL equivalent
 */
function canConvertValue(value) {
  return !isBoolean$3(value) && !isNullOrUndefined$1(value);
}

/**
 * Splits a shadow style into its separate shadows using the comma delimiter, but creating an exception
 * for comma separated values in parentheses often used for rgba colours.
 * @param {String} value
 * @returns {Array} array of all box shadow values in the string
 */
function splitShadow(value) {
  var shadows = [];
  var start = 0;
  var end = 0;
  var rgba = false;
  while (end < value.length) {
    if (!rgba && value[end] === ',') {
      shadows.push(value.substring(start, end).trim());
      end++;
      start = end;
    } else if (value[end] === "(") {
      rgba = true;
      end++;
    } else if (value[end] === ')') {
      rgba = false;
      end++;
    } else {
      end++;
    }
  }

  // push the last shadow value if there is one
  // istanbul ignore next
  if (start != end) {
    shadows.push(value.substring(start, end + 1));
  }
  return shadows;
}

// some values require a little fudging, that fudging goes here.
var propertyValueConverters = {
  padding: function padding(_ref) {
    var value = _ref.value;
    if (isNumber$4(value)) {
      return value;
    }
    return handleQuartetValues(value);
  },
  textShadow: function textShadow(_ref2) {
    var value = _ref2.value;
    var flippedShadows = splitShadow(value).map(function (shadow) {
      // intentionally leaving off the `g` flag here because we only want to change the first number (which is the offset-x)
      return shadow.replace(/(^|\s)(-*)([.|\d]+)/, function (match, whiteSpace, negative, number) {
        if (number === '0') {
          return match;
        }
        var doubleNegative = negative === '' ? '-' : '';
        return "" + whiteSpace + doubleNegative + number;
      });
    });
    return flippedShadows.join(',');
  },
  borderColor: function borderColor(_ref3) {
    var value = _ref3.value;
    return handleQuartetValues(value);
  },
  borderRadius: function borderRadius(_ref4) {
    var value = _ref4.value;
    if (isNumber$4(value)) {
      return value;
    }
    if (includes(value, '/')) {
      var _value$split = value.split('/'),
        radius1 = _value$split[0],
        radius2 = _value$split[1];
      var convertedRadius1 = propertyValueConverters.borderRadius({
        value: radius1.trim()
      });
      var convertedRadius2 = propertyValueConverters.borderRadius({
        value: radius2.trim()
      });
      return convertedRadius1 + " / " + convertedRadius2;
    }
    var splitValues = getValuesAsList(value);
    switch (splitValues.length) {
      case 2:
        {
          return splitValues.reverse().join(' ');
        }
      case 4:
        {
          var topLeft = splitValues[0],
            topRight = splitValues[1],
            bottomRight = splitValues[2],
            bottomLeft = splitValues[3];
          return [topRight, topLeft, bottomLeft, bottomRight].join(' ');
        }
      default:
        {
          return value;
        }
    }
  },
  background: function background(_ref5) {
    var value = _ref5.value,
      valuesToConvert = _ref5.valuesToConvert,
      isRtl = _ref5.isRtl,
      bgImgDirectionRegex = _ref5.bgImgDirectionRegex,
      bgPosDirectionRegex = _ref5.bgPosDirectionRegex;
    if (isNumber$4(value)) {
      return value;
    }

    // Yeah, this is in need of a refactor 🙃...
    // but this property is a tough cookie 🍪
    // get the backgroundPosition out of the string by removing everything that couldn't be the backgroundPosition value
    var backgroundPositionValue = value.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g, '').trim();
    // replace that backgroundPosition value with the converted version
    value = value.replace(backgroundPositionValue, propertyValueConverters.backgroundPosition({
      value: backgroundPositionValue,
      valuesToConvert: valuesToConvert,
      isRtl: isRtl,
      bgPosDirectionRegex: bgPosDirectionRegex
    }));
    // do the backgroundImage value replacing on the whole value (because why not?)
    return propertyValueConverters.backgroundImage({
      value: value,
      valuesToConvert: valuesToConvert,
      bgImgDirectionRegex: bgImgDirectionRegex
    });
  },
  backgroundImage: function backgroundImage(_ref6) {
    var value = _ref6.value,
      valuesToConvert = _ref6.valuesToConvert,
      bgImgDirectionRegex = _ref6.bgImgDirectionRegex;
    if (!includes(value, 'url(') && !includes(value, 'linear-gradient(')) {
      return value;
    }
    return value.replace(bgImgDirectionRegex, function (match, g1, group2) {
      return match.replace(group2, valuesToConvert[group2]);
    });
  },
  backgroundPosition: function backgroundPosition(_ref7) {
    var value = _ref7.value,
      valuesToConvert = _ref7.valuesToConvert,
      isRtl = _ref7.isRtl,
      bgPosDirectionRegex = _ref7.bgPosDirectionRegex;
    return value
    // intentionally only grabbing the first instance of this because that represents `left`
    .replace(isRtl ? /^((-|\d|\.)+%)/ : null, function (match, group) {
      return calculateNewBackgroundPosition(group);
    }).replace(bgPosDirectionRegex, function (match) {
      return valuesToConvert[match];
    });
  },
  backgroundPositionX: function backgroundPositionX(_ref8) {
    var value = _ref8.value,
      valuesToConvert = _ref8.valuesToConvert,
      isRtl = _ref8.isRtl,
      bgPosDirectionRegex = _ref8.bgPosDirectionRegex;
    if (isNumber$4(value)) {
      return value;
    }
    return propertyValueConverters.backgroundPosition({
      value: value,
      valuesToConvert: valuesToConvert,
      isRtl: isRtl,
      bgPosDirectionRegex: bgPosDirectionRegex
    });
  },
  transition: function transition(_ref9) {
    var value = _ref9.value,
      propertiesToConvert = _ref9.propertiesToConvert;
    return value.split(/,\s*/g).map(function (transition) {
      var values = transition.split(' ');

      // Property is always defined first
      values[0] = propertiesToConvert[values[0]] || values[0];
      return values.join(' ');
    }).join(', ');
  },
  transitionProperty: function transitionProperty(_ref10) {
    var value = _ref10.value,
      propertiesToConvert = _ref10.propertiesToConvert;
    return value.split(/,\s*/g).map(function (prop) {
      return propertiesToConvert[prop] || prop;
    }).join(', ');
  },
  transform: function transform(_ref11) {
    var value = _ref11.value;
    // This was copied and modified from CSSJanus:
    // https://github.com/cssjanus/cssjanus/blob/4a40f001b1ba35567112d8b8e1d9d95eda4234c3/src/cssjanus.js#L152-L153
    var nonAsciiPattern = "[^\\u0020-\\u007e]";
    var escapePattern = "(?:" + '(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)' + "|\\\\[^\\r\\n\\f0-9a-f])";
    var signedQuantPattern = "((?:-?" + ('(?:[0-9]*\\.[0-9]+|[0-9]+)' + "(?:\\s*" + '(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)' + "|" + ("-?" + ("(?:[_a-z]|" + nonAsciiPattern + "|" + escapePattern + ")") + ("(?:[_a-z0-9-]|" + nonAsciiPattern + "|" + escapePattern + ")") + "*") + ")?") + ")|(?:inherit|auto))";
    var translateXRegExp = new RegExp("(translateX\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", 'gi');
    var translateRegExp = new RegExp("(translate\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,1}\\s*\\))", 'gi');
    var translate3dRegExp = new RegExp("(translate3d\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,2}\\s*\\))", 'gi');
    var rotateRegExp = new RegExp("(rotate[ZY]?\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", 'gi');
    return value.replace(translateXRegExp, flipTransformSign).replace(translateRegExp, flipTransformSign).replace(translate3dRegExp, flipTransformSign).replace(rotateRegExp, flipTransformSign);
  }
};
propertyValueConverters.objectPosition = propertyValueConverters.backgroundPosition;
propertyValueConverters.margin = propertyValueConverters.padding;
propertyValueConverters.borderWidth = propertyValueConverters.padding;
propertyValueConverters.boxShadow = propertyValueConverters.textShadow;
propertyValueConverters.webkitBoxShadow = propertyValueConverters.boxShadow;
propertyValueConverters.mozBoxShadow = propertyValueConverters.boxShadow;
propertyValueConverters.WebkitBoxShadow = propertyValueConverters.boxShadow;
propertyValueConverters.MozBoxShadow = propertyValueConverters.boxShadow;
propertyValueConverters.borderStyle = propertyValueConverters.borderColor;
propertyValueConverters.webkitTransform = propertyValueConverters.transform;
propertyValueConverters.mozTransform = propertyValueConverters.transform;
propertyValueConverters.WebkitTransform = propertyValueConverters.transform;
propertyValueConverters.MozTransform = propertyValueConverters.transform;
propertyValueConverters.transformOrigin = propertyValueConverters.backgroundPosition;
propertyValueConverters.webkitTransformOrigin = propertyValueConverters.transformOrigin;
propertyValueConverters.mozTransformOrigin = propertyValueConverters.transformOrigin;
propertyValueConverters.WebkitTransformOrigin = propertyValueConverters.transformOrigin;
propertyValueConverters.MozTransformOrigin = propertyValueConverters.transformOrigin;
propertyValueConverters.webkitTransition = propertyValueConverters.transition;
propertyValueConverters.mozTransition = propertyValueConverters.transition;
propertyValueConverters.WebkitTransition = propertyValueConverters.transition;
propertyValueConverters.MozTransition = propertyValueConverters.transition;
propertyValueConverters.webkitTransitionProperty = propertyValueConverters.transitionProperty;
propertyValueConverters.mozTransitionProperty = propertyValueConverters.transitionProperty;
propertyValueConverters.WebkitTransitionProperty = propertyValueConverters.transitionProperty;
propertyValueConverters.MozTransitionProperty = propertyValueConverters.transitionProperty;

// kebab-case versions

propertyValueConverters['text-shadow'] = propertyValueConverters.textShadow;
propertyValueConverters['border-color'] = propertyValueConverters.borderColor;
propertyValueConverters['border-radius'] = propertyValueConverters.borderRadius;
propertyValueConverters['background-image'] = propertyValueConverters.backgroundImage;
propertyValueConverters['background-position'] = propertyValueConverters.backgroundPosition;
propertyValueConverters['background-position-x'] = propertyValueConverters.backgroundPositionX;
propertyValueConverters['object-position'] = propertyValueConverters.objectPosition;
propertyValueConverters['border-width'] = propertyValueConverters.padding;
propertyValueConverters['box-shadow'] = propertyValueConverters.textShadow;
propertyValueConverters['-webkit-box-shadow'] = propertyValueConverters.textShadow;
propertyValueConverters['-moz-box-shadow'] = propertyValueConverters.textShadow;
propertyValueConverters['border-style'] = propertyValueConverters.borderColor;
propertyValueConverters['-webkit-transform'] = propertyValueConverters.transform;
propertyValueConverters['-moz-transform'] = propertyValueConverters.transform;
propertyValueConverters['transform-origin'] = propertyValueConverters.transformOrigin;
propertyValueConverters['-webkit-transform-origin'] = propertyValueConverters.transformOrigin;
propertyValueConverters['-moz-transform-origin'] = propertyValueConverters.transformOrigin;
propertyValueConverters['-webkit-transition'] = propertyValueConverters.transition;
propertyValueConverters['-moz-transition'] = propertyValueConverters.transition;
propertyValueConverters['transition-property'] = propertyValueConverters.transitionProperty;
propertyValueConverters['-webkit-transition-property'] = propertyValueConverters.transitionProperty;
propertyValueConverters['-moz-transition-property'] = propertyValueConverters.transitionProperty;

// this will be an object of properties that map to their corresponding rtl property (their doppelganger)
var propertiesToConvert = arrayToObject$1([['paddingLeft', 'paddingRight'], ['marginLeft', 'marginRight'], ['left', 'right'], ['borderLeft', 'borderRight'], ['borderLeftColor', 'borderRightColor'], ['borderLeftStyle', 'borderRightStyle'], ['borderLeftWidth', 'borderRightWidth'], ['borderTopLeftRadius', 'borderTopRightRadius'], ['borderBottomLeftRadius', 'borderBottomRightRadius'],
// kebab-case versions
['padding-left', 'padding-right'], ['margin-left', 'margin-right'], ['border-left', 'border-right'], ['border-left-color', 'border-right-color'], ['border-left-style', 'border-right-style'], ['border-left-width', 'border-right-width'], ['border-top-left-radius', 'border-top-right-radius'], ['border-bottom-left-radius', 'border-bottom-right-radius']]);
var propsToIgnore = ['content'];

// this is the same as the propertiesToConvert except for values
var valuesToConvert = arrayToObject$1([['ltr', 'rtl'], ['left', 'right'], ['w-resize', 'e-resize'], ['sw-resize', 'se-resize'], ['nw-resize', 'ne-resize']]);

// Sorry for the regex 😞, but basically thisis used to replace _every_ instance of
// `ltr`, `rtl`, `right`, and `left` in `backgroundimage` with the corresponding opposite.
// A situation we're accepting here:
// url('/left/right/rtl/ltr.png') will be changed to url('/right/left/ltr/rtl.png')
// Definite trade-offs here, but I think it's a good call.
var bgImgDirectionRegex = new RegExp('(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)', 'g');
var bgPosDirectionRegex = new RegExp('(left)|(right)');

/**
 * converts properties and values in the CSS in JS object to their corresponding RTL values
 * @param {Object} object the CSS in JS object
 * @return {Object} the RTL converted object
 */
function convert$1(object) {
  return Object.keys(object).reduce(function (newObj, originalKey) {
    var originalValue = object[originalKey];
    if (isString$3(originalValue)) {
      // you're welcome to later code 😺
      originalValue = originalValue.trim();
    }

    // Some properties should never be transformed
    if (includes(propsToIgnore, originalKey)) {
      newObj[originalKey] = originalValue;
      return newObj;
    }
    var _convertProperty = convertProperty(originalKey, originalValue),
      key = _convertProperty.key,
      value = _convertProperty.value;
    newObj[key] = value;
    return newObj;
  }, Array.isArray(object) ? [] : {});
}

/**
 * Converts a property and its value to the corresponding RTL key and value
 * @param {String} originalKey the original property key
 * @param {Number|String|Object} originalValue the original css property value
 * @return {Object} the new {key, value} pair
 */
function convertProperty(originalKey, originalValue) {
  var isNoFlip = /\/\*\s?@noflip\s?\*\//.test(originalValue);
  var key = isNoFlip ? originalKey : getPropertyDoppelganger(originalKey);
  var value = isNoFlip ? originalValue : getValueDoppelganger(key, originalValue);
  return {
    key: key,
    value: value
  };
}

/**
 * This gets the RTL version of the given property if it has a corresponding RTL property
 * @param {String} property the name of the property
 * @return {String} the name of the RTL property
 */
function getPropertyDoppelganger(property) {
  return propertiesToConvert[property] || property;
}

/**
 * This converts the given value to the RTL version of that value based on the key
 * @param {String} key this is the key (note: this should be the RTL version of the originalKey)
 * @param {String|Number|Object} originalValue the original css property value. If it's an object, then we'll convert that as well
 * @return {String|Number|Object} the converted value
 */
function getValueDoppelganger(key, originalValue) {
  if (!canConvertValue(originalValue)) {
    return originalValue;
  }
  if (isObject$8(originalValue)) {
    return convert$1(originalValue); // recursion 🌀
  }

  var isNum = isNumber$4(originalValue);
  var isFunc = isFunction$4(originalValue);
  var importantlessValue = isNum || isFunc ? originalValue : originalValue.replace(/ !important.*?$/, '');
  var isImportant = !isNum && importantlessValue.length !== originalValue.length;
  var valueConverter = propertyValueConverters[key];
  var newValue;
  if (valueConverter) {
    newValue = valueConverter({
      value: importantlessValue,
      valuesToConvert: valuesToConvert,
      propertiesToConvert: propertiesToConvert,
      isRtl: true,
      bgImgDirectionRegex: bgImgDirectionRegex,
      bgPosDirectionRegex: bgPosDirectionRegex
    });
  } else {
    newValue = valuesToConvert[importantlessValue] || importantlessValue;
  }
  if (isImportant) {
    return newValue + " !important";
  }
  return newValue;
}

const uppercasePattern = /[A-Z]/g;
const msPattern = /^ms-/;
const cache = {};
function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}
function hyphenateProperty(name) {
  if (Object.prototype.hasOwnProperty.call(cache, name)) {
    return cache[name];
  }
  if (name.substr(0, 2) === '--') {
    return name;
  }
  const hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
}

function normalizeNestedProperty(nestedProperty) {
  if (nestedProperty.charAt(0) === '&') {
    return nestedProperty.slice(1);
  }
  return nestedProperty;
}

var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var MEDIA = '@media';
var IMPORT = '@import';
var SUPPORTS = '@supports';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs$2 = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from$1 = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$2 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$1 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @param {number} position
 * @return {number}
 */
function indexof (value, search, position) {
	return value.indexOf(search, position)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position$3 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {object[]} siblings
 * @param {number} length
 */
function node$1 (value, root, parent, type, props, children, length, siblings) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: '', siblings: siblings}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node$1('', null, null, '', null, null, 0, root.siblings), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position$3 > 0 ? charat(characters, --position$3) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next$1 () {
	character = position$3 < length ? charat(characters, position$3++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek$1 () {
	return charat(characters, position$3)
}

/**
 * @return {number}
 */
function caret () {
	return position$3
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token$1 (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position$3 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$2(slice(position$3 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace$1 (type) {
	while (character = peek$1())
		if (character < 33)
			next$1();
		else
			break

	return token$1(type) > 2 || token$1(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next$1())
		switch (token$1(character)) {
			case 0: append(identifier(position$3 - 1), children);
				break
			case 2: append(delimit(character), children);
				break
			default: append(from$1(character), children);
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next$1())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek$1() == 32 && next$1() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next$1())
		switch (character) {
			// ] ) " '
			case type:
				return position$3
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next$1();
				break
		}

	return position$3
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next$1())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek$1() === 47)
			break

	return '/*' + slice(index, position$3 - 1) + '*' + from$1(type === 47 ? type : next$1())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token$1(peek$1()))
		next$1();

	return slice(index, position$3)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$3('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$3 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next$1()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace$1(delimit(character), '&', '&\f'), '&\f', abs$2(index ? points[index - 1] : 0)) != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace$1(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek$1()) {
					case 42: case 47:
						append(comment$2(commenter(next$1(), caret()), root, parent, declarations), declarations);
						if ((token$1(previous || 1) == 5 || token$1(peek$1() || 1) == 5) && strlen(characters) && substr(characters, -1, undefined) !== ' ') characters += ' ';
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace$1(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length || (variable === 0 && previous === 47)))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1, declarations) : declaration(replace$1(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$3(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse$3(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$3(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from$1(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek$1() === 45)
							characters += delimit(next$1());

						atrule = peek$1(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs$2(j = points[i])), z = value; x < size; ++x)
			if (z = trim$2(j > 0 ? rule[x] + ' ' + y : replace$1(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node$1(value, root, parent, offset === 0 ? RULESET : type, props, children, length, siblings)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @param {object[]} siblings
 * @return {object}
 */
function comment$2 (value, root, parent, siblings) {
	return node$1(value, root, parent, COMMENT, from$1(char()), substr(value, 2, -2), 0, siblings)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @param {object[]} siblings
 * @return {object}
 */
function declaration (value, root, parent, length, siblings) {
	return node$1(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length, siblings)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize$3 (children, callback) {
	var output = '';

	for (var i = 0; i < children.length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify$2 (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize$3(element.children, callback) + '}'
		case RULESET: if (!strlen(element.value = element.props.join(','))) return ''
	}

	return strlen(children = serialize$3(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

function middleware$1(collection) {
  var length = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}

const globalPlugin = (element) => {
  switch (element.type) {
    case RULESET:
      if (typeof element.props === "string") {
        if (process.env.NODE_ENV !== "production") {
          throw new Error(`"element.props" has type "string" (${JSON.stringify(element.props, null, 2)}), it's not expected. Please report a bug if it happens.`);
        }
        return;
      }
      element.props = element.props.map((value) => {
        if (value.indexOf(":global(") === -1) {
          return value;
        }
        return tokenize(value).reduce((acc, value2, index, children) => {
          if (value2 === "") {
            return acc;
          }
          if (value2 === ":" && children[index + 1] === "global") {
            const selector = (
              // An inner part of ":global()"
              children[index + 2].slice(1, -1) + // A separator between selectors i.e. "body .class"
              " "
            );
            acc.unshift(selector);
            children[index + 1] = "";
            children[index + 2] = "";
            return acc;
          }
          acc.push(value2);
          return acc;
        }, []).join("");
      });
  }
};

/* eslint-disable no-fallthrough */
function prefix(value, length, children) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // backface-visibility, column, box-decoration-break
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
      return WEBKIT + value + value;
    // backdrop-filter, background-clip: text
    case 4215:
      // Additional check on "backdrop-(f)ilter" to prevent conflict with "background-clip"
      // https://github.com/thysultan/stylis/issues/292
      if (charat(value, 9) === 102) {
        return WEBKIT + value + value;
      }
      // background-clip: text
      if (charat(value, length + 1) === 116) {
        return WEBKIT + value + value;
      }
      break;
    // tab-size
    case 4789:
      return MOZ + value + value;
    // appearance, user-select, hyphens
    case 5349:
    case 4246:
    case 6968:
      return WEBKIT + value + MOZ + value + value;
    // cursor
    // @ts-expect-error fall through is intentional here
    case 6187:
      if (!match(value, /grab/)) {
        return replace$1(replace$1(replace$1(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
      }
    // background, background-image
    case 5495:
    case 3959:
      // eslint-disable-next-line no-useless-concat
      return replace$1(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (f)ill-available
        // @ts-expect-error fall through is intentional here
        case 102:
          if (charat(value, length + 3) === 108) {
            return replace$1(value, /(.+:)(.+)-([^]+)/,
            // eslint-disable-next-line no-useless-concat, eqeqeq
            '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
          }
        // (s)tretch
        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace$1(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
  }
  return value;
}
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixerPlugin(element, index, children, callback) {
  if (element.length > -1) if (!element.return) switch (element.type) {
    case DECLARATION:
      element.return = prefix(element.value, element.length);
      return;
    case RULESET:
      if (element.length)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return combine(element.props, function (value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ':read-only':
            case ':read-write':
              return serialize$3(
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              [copy(element, {
                props: [replace$1(value, /:(read-\w+)/, ':' + MOZ + '$1')]
              })], callback);
            // :placeholder
            case '::placeholder':
              return serialize$3([
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              copy(element, {
                props: [replace$1(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
              }),
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              copy(element, {
                props: [replace$1(value, /:(plac\w+)/, ':' + MOZ + '$1')]
              })], callback);
          }
          return '';
        });
  }
  return undefined;
}

function isAtRuleElement(element) {
  switch (element.type) {
    case '@container':
    case MEDIA:
    case SUPPORTS:
    case LAYER:
      return true;
  }
  return false;
}

const sortClassesInAtRulesPlugin = element => {
  if (isAtRuleElement(element) && Array.isArray(element.children)) {
    element.children.sort((a, b) => a.props[0] > b.props[0] ? 1 : -1);
  }
};

function compileCSSRules(cssRules, sortClassesInAtRules) {
  const rules = [];
  serialize$3(compile(cssRules), middleware$1([
    globalPlugin,
    sortClassesInAtRulesPlugin ,
    prefixerPlugin,
    stringify$2,
    // 💡 we are using `.insertRule()` API for DOM operations, which does not support
    // insertion of multiple CSS rules in a single call. `rulesheet` plugin extracts
    // individual rules to be used with this API
    rulesheet((rule) => rules.push(rule))
  ]));
  return rules;
}

const PSEUDO_SELECTOR_REGEX = /,( *[^ &])/g;
/**
 * Normalizes pseudo selectors to always contain &, requires to work properly with comma-separated selectors.
 *
 * @example
 *   ":hover" => "&:hover"
 *   " :hover" => "& :hover"
 *   ":hover,:focus" => "&:hover,&:focus"
 *   " :hover, :focus" => "& :hover,& :focus"
 */
function normalizePseudoSelector(pseudoSelector) {
  return '&' + normalizeNestedProperty(
  // Regex there replaces a comma, spaces and an ampersand if it's present with comma and an ampersand.
  // This allows to normalize input, see examples in JSDoc.
  pseudoSelector.replace(PSEUDO_SELECTOR_REGEX, ',&$1'));
}
function createCSSRule(classNameSelector, cssDeclaration, pseudos) {
  let cssRule = cssDeclaration;
  if (pseudos.length > 0) {
    cssRule = pseudos.reduceRight((acc, selector) => {
      return `${normalizePseudoSelector(selector)} { ${acc} }`;
    }, cssDeclaration);
  }
  return `${classNameSelector}{${cssRule}}`;
}
function compileAtomicCSSRule(options, atRules) {
  const {
    className,
    selectors,
    property,
    rtlClassName,
    rtlProperty,
    rtlValue,
    value
  } = options;
  const {
    container,
    layer,
    media,
    supports
  } = atRules;
  const classNameSelector = `.${className}`;
  const cssDeclaration = Array.isArray(value) ? `${value.map(v => `${hyphenateProperty(property)}: ${v}`).join(';')};` : `${hyphenateProperty(property)}: ${value};`;
  let cssRule = createCSSRule(classNameSelector, cssDeclaration, selectors);
  if (rtlProperty && rtlClassName) {
    const rtlClassNameSelector = `.${rtlClassName}`;
    const rtlCSSDeclaration = Array.isArray(rtlValue) ? `${rtlValue.map(v => `${hyphenateProperty(rtlProperty)}: ${v}`).join(';')};` : `${hyphenateProperty(rtlProperty)}: ${rtlValue};`;
    cssRule += createCSSRule(rtlClassNameSelector, rtlCSSDeclaration, selectors);
  }
  if (media) {
    cssRule = `@media ${media} { ${cssRule} }`;
  }
  if (layer) {
    cssRule = `@layer ${layer} { ${cssRule} }`;
  }
  if (supports) {
    cssRule = `@supports ${supports} { ${cssRule} }`;
  }
  if (container) {
    cssRule = `@container ${container} { ${cssRule} }`;
  }
  return compileCSSRules(cssRule);
}

function cssifyObject(style) {
  let css = '';
  // eslint-disable-next-line guard-for-in
  for (const property in style) {
    const value = style[property];
    if (typeof value === 'string' || typeof value === 'number') {
      css += hyphenateProperty(property) + ':' + value + ';';
      continue;
    }
    if (Array.isArray(value)) {
      for (const arrValue of value) {
        css += hyphenateProperty(property) + ':' + arrValue + ';';
      }
    }
  }
  return css;
}

function compileKeyframeRule(keyframeObject) {
  let css = '';
  // eslint-disable-next-line guard-for-in
  for (const percentage in keyframeObject) {
    css += `${percentage}{${cssifyObject(keyframeObject[percentage])}}`;
  }
  return css;
}
/**
 * Creates CSS rules for insertion from passed CSS.
 */
function compileKeyframesCSS(keyframeName, keyframeCSS) {
  const cssRule = `@keyframes ${keyframeName} {${keyframeCSS}}`;
  const rules = [];
  serialize$3(compile(cssRule), middleware$1([stringify$2, prefixerPlugin,
  // 💡 we are using `.insertRule()` API for DOM operations, which does not support
  // insertion of multiple CSS rules in a single call. `rulesheet` plugin extracts
  // individual rules to be used with this API
  rulesheet(rule => rules.push(rule))]));
  return rules;
}

const shorthands$1 = {
  animation: [-1, ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimeline', 'animationTimingFunction']],
  animationRange: [-1, ['animationRangeEnd', 'animationRangeStart']],
  background: [-2, ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize']],
  backgroundPosition: [-1, ['backgroundPositionX', 'backgroundPositionY']],
  border: [-2, ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth']],
  borderBottom: [-1, ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth']],
  borderImage: [-1, ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth']],
  borderLeft: [-1, ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth']],
  borderRadius: [-1, ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius']],
  borderRight: [-1, ['borderRightColor', 'borderRightStyle', 'borderRightWidth']],
  borderTop: [-1, ['borderTopColor', 'borderTopStyle', 'borderTopWidth']],
  caret: [-1, ['caretColor', 'caretShape']],
  columnRule: [-1, ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth']],
  columns: [-1, ['columnCount', 'columnWidth']],
  containIntrinsicSize: [-1, ['containIntrinsicHeight', 'containIntrinsicWidth']],
  container: [-1, ['containerName', 'containerType']],
  flex: [-1, ['flexBasis', 'flexGrow', 'flexShrink']],
  flexFlow: [-1, ['flexDirection', 'flexWrap']],
  font: [-1, ['fontFamily', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'lineHeight']],
  gap: [-1, ['columnGap', 'rowGap']],
  grid: [-1, ['columnGap', 'gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridColumnGap', 'gridRowGap', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows', 'rowGap']],
  gridArea: [-1, ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart']],
  gridColumn: [-1, ['gridColumnEnd', 'gridColumnStart']],
  gridRow: [-1, ['gridRowEnd', 'gridRowStart']],
  gridTemplate: [-1, ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows']],
  inset: [-1, ['bottom', 'left', 'right', 'top']],
  insetBlock: [-1, ['insetBlockEnd', 'insetBlockStart']],
  insetInline: [-1, ['insetInlineEnd', 'insetInlineStart']],
  listStyle: [-1, ['listStyleImage', 'listStylePosition', 'listStyleType']],
  margin: [-1, ['marginBottom', 'marginLeft', 'marginRight', 'marginTop']],
  marginBlock: [-1, ['marginBlockEnd', 'marginBlockStart']],
  marginInline: [-1, ['marginInlineEnd', 'marginInlineStart']],
  mask: [-1, ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPosition', 'maskRepeat', 'maskSize']],
  maskBorder: [-1, ['maskBorderMode', 'maskBorderOutset', 'maskBorderRepeat', 'maskBorderSlice', 'maskBorderSource', 'maskBorderWidth']],
  offset: [-1, ['offsetAnchor', 'offsetDistance', 'offsetPath', 'offsetPosition', 'offsetRotate']],
  outline: [-1, ['outlineColor', 'outlineStyle', 'outlineWidth']],
  overflow: [-1, ['overflowX', 'overflowY']],
  overscrollBehavior: [-1, ['overscrollBehaviorX', 'overscrollBehaviorY']],
  padding: [-1, ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop']],
  paddingBlock: [-1, ['paddingBlockEnd', 'paddingBlockStart']],
  paddingInline: [-1, ['paddingInlineEnd', 'paddingInlineStart']],
  placeContent: [-1, ['alignContent', 'justifyContent']],
  placeItems: [-1, ['alignItems', 'justifyItems']],
  placeSelf: [-1, ['alignSelf', 'justifySelf']],
  scrollMargin: [-1, ['scrollMarginBottom', 'scrollMarginLeft', 'scrollMarginRight', 'scrollMarginTop']],
  scrollMarginBlock: [-1, ['scrollMarginBlockEnd', 'scrollMarginBlockStart']],
  scrollMarginInline: [-1, ['scrollMarginInlineEnd', 'scrollMarginInlineStart']],
  scrollPadding: [-1, ['scrollPaddingBottom', 'scrollPaddingLeft', 'scrollPaddingRight', 'scrollPaddingTop']],
  scrollPaddingBlock: [-1, ['scrollPaddingBlockEnd', 'scrollPaddingBlockStart']],
  scrollPaddingInline: [-1, ['scrollPaddingInlineEnd', 'scrollPaddingInlineStart']],
  scrollTimeline: [-1, ['scrollTimelineAxis', 'scrollTimelineName']],
  textDecoration: [-1, ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle', 'textDecorationThickness']],
  textEmphasis: [-1, ['textEmphasisColor', 'textEmphasisStyle']],
  transition: [-1, ['transitionBehavior', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']],
  viewTimeline: [-1, ['viewTimelineAxis', 'viewTimelineName']]
};

function generateCombinedQuery(currentMediaQuery, nestedMediaQuery) {
  if (currentMediaQuery.length === 0) {
    return nestedMediaQuery;
  }
  return `${currentMediaQuery} and ${nestedMediaQuery}`;
}

function isMediaQuerySelector(property) {
  return property.substr(0, 6) === '@media';
}

function isLayerSelector(property) {
  return property.substr(0, 6) === '@layer';
}

const regex = /^(:|\[|>|&)/;
function isNestedSelector(property) {
  return regex.test(property);
}

function isSupportQuerySelector(property) {
  return property.substr(0, 9) === '@supports';
}

function isContainerQuerySelector(property) {
  return property.substring(0, 10) === '@container';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObject$7(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
}

/**
 * Maps the long pseudo name to the short pseudo name. Pseudos that match here will be ordered, everything else will
 * make their way to default style bucket. We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */
const pseudosMap = {
  // :focus-within
  'us-w': 'w',
  // :focus-visible
  'us-v': 'i',
  // :link
  nk: 'l',
  // :visited
  si: 'v',
  // :focus
  cu: 'f',
  // :hover
  ve: 'h',
  // :active
  ti: 'a'
};
/**
 * Gets the bucket depending on the pseudo.
 *
 * Input:
 *
 * ```
 * ":hover"
 * ":focus:hover"
 * ```
 *
 * Output:
 *
 * ```
 * "h"
 * "f"
 * ```
 *
 * @internal
 */
function getStyleBucketName(selectors, atRules) {
  if (atRules.media) {
    return 'm';
  }
  // We are grouping all the at-rules like @supports etc. under `t` bucket.
  if (atRules.layer || atRules.supports) {
    return 't';
  }
  if (atRules.container) {
    return 'c';
  }
  if (selectors.length > 0) {
    const normalizedPseudo = selectors[0].trim();
    if (normalizedPseudo.charCodeAt(0) === 58 /* ":" */) {
      // We send through a subset of the string instead of the full pseudo name.
      // For example:
      // - `"focus-visible"` name would instead of `"us-v"`.
      // - `"focus"` name would instead of `"us"`.
      // Return a mapped pseudo else default bucket.
      return pseudosMap[normalizedPseudo.slice(4, 8)] /* allows to avoid collisions between "focus-visible" & "focus" */ || pseudosMap[normalizedPseudo.slice(3, 5)] || 'd';
    }
  }
  // Return default bucket
  return 'd';
}

function addAtRulePrefix(atRule, prefix) {
  return atRule ? prefix + atRule : atRule;
}
function atRulesToString(atRules) {
  return addAtRulePrefix(atRules.container, 'c') + addAtRulePrefix(atRules.media, 'm') + addAtRulePrefix(atRules.layer, 'l') + addAtRulePrefix(atRules.supports, 's');
}
function hashPropertyKey(selector, property, atRules) {
  // uniq key based on property & selector, used for merging later
  const computedKey = selector + atRulesToString(atRules) + property;
  // "key" can be really long as it includes selectors, we use hashes to reduce sizes of keys
  // ".foo :hover" => "abcd"
  const hashedKey = murmur2(computedKey);
  // As these hashes are used as object keys in build output we should avoid having numbers as a first character to
  // avoid having quotes:
  // {
  //   "1abc": {}, // we don't want this
  //   Aabc: {}, // no quotes
  // }
  const firstCharCode = hashedKey.charCodeAt(0);
  const startsWithNumber = firstCharCode >= 48 && firstCharCode <= 57;
  if (startsWithNumber) {
    return String.fromCharCode(firstCharCode + 17) + hashedKey.slice(1);
  }
  return hashedKey;
}

function hashClassName({
  property,
  selector,
  salt,
  value
}, atRules) {
  return HASH_PREFIX + murmur2(salt + selector + atRulesToString(atRules) + property +
  // Trimming of value is required to generate consistent hashes
  value.trim());
}

function isResetValue(value) {
  return value === RESET;
}

/**
 * Trims selectors to generate consistent hashes.
 */
function trimSelector(selector) {
  return selector.replace(/>\s+/g, '>');
}

function logError$1(...args) {
  if (process.env.NODE_ENV !== 'production' && typeof document !== 'undefined') {
    console.error(...args);
  }
}

function warnAboutUnresolvedRule(property, value) {
  const message = /*#__PURE__*/(() => {
    const ruleText = JSON.stringify(value, null, 2);
    const message = ['@griffel/react: A rule was not resolved to CSS properly. ' + 'Please check your `makeStyles` or `makeResetStyles` calls for following:', ' '.repeat(2) + 'makeStyles({', ' '.repeat(4) + `[slot]: {`, ' '.repeat(6) + `"${property}": ${ruleText.split('\n').map((l, n) => ' '.repeat(n === 0 ? 0 : 6) + l).join('\n')}`, ' '.repeat(4) + '}', ' '.repeat(2) + `})`, ''];
    if (property.indexOf('&') === -1) {
      message.push(`It looks that you're are using a nested selector, but it is missing an ampersand placeholder where the generated class name should be injected.`);
      message.push(`Try to update a property to include it i.e "${property}" => "&${property}".`);
    } else {
      message.push('');
      message.push("If it's not obvious what triggers a problem, please report an issue at https://github.com/microsoft/griffel/issues");
    }
    return message.join('\n');
  })();
  logError$1(message);
}

function warnAboutUnsupportedProperties(property, value) {
  const message = /*#__PURE__*/(() => [`@griffel/react: You are using unsupported shorthand CSS property "${property}". ` + `Please check your "makeStyles" calls, there *should not* be following:`, ' '.repeat(2) + `makeStyles({`, ' '.repeat(4) + `[slot]: { ${property}: "${value}" }`, ' '.repeat(2) + `})`, '', 'Learn why CSS shorthands are not supported: https://aka.ms/griffel-css-shorthands'].join('\n'))();
  logError$1(message);
}

function getShorthandDefinition(property) {
  return shorthands$1[property];
}
function computePropertyPriority(shorthand) {
  var _a;
  return (_a = shorthand === null || shorthand === undefined ? undefined : shorthand[0]) !== null && _a !== undefined ? _a : 0;
}
function pushToClassesMap(classesMap, propertyKey, ltrClassname, rtlClassname) {
  classesMap[propertyKey] = rtlClassname ? [ltrClassname, rtlClassname] : ltrClassname;
}
function createBucketEntry(cssRule, metadata) {
  if (metadata.length > 0) {
    return [cssRule, Object.fromEntries(metadata)];
  }
  return cssRule;
}
function pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, media, priority) {
  var _a;
  const metadata = [];
  if (priority !== 0) {
    metadata.push(['p', priority]);
  }
  if (styleBucketName === 'm' && media) {
    metadata.push(['m', media]);
  }
  (_a = cssRulesByBucket[styleBucketName]) !== null && _a !== undefined ? _a : cssRulesByBucket[styleBucketName] = [];
  if (ltrCSS) {
    cssRulesByBucket[styleBucketName].push(createBucketEntry(ltrCSS, metadata));
  }
  if (rtlCSS) {
    cssRulesByBucket[styleBucketName].push(createBucketEntry(rtlCSS, metadata));
  }
}
/**
 * Transforms input styles to classes maps & CSS rules.
 *
 * @internal
 */
function resolveStyleRules(styles, classNameHashSalt = '', selectors = [], atRules = {
  container: '',
  layer: '',
  media: '',
  supports: ''
}, cssClassesMap = {}, cssRulesByBucket = {}, rtlValue) {
  // eslint-disable-next-line guard-for-in
  for (const property in styles) {
    // eslint-disable-next-line no-prototype-builtins
    if (UNSUPPORTED_CSS_PROPERTIES.hasOwnProperty(property)) {
      warnAboutUnsupportedProperties(property, styles[property]);
      continue;
    }
    const value = styles[property];
    // eslint-disable-next-line eqeqeq
    if (value == null) {
      continue;
    }
    if (isResetValue(value)) {
      const selector = trimSelector(selectors.join(''));
      // uniq key based on a hash of property & selector, used for merging later
      const key = hashPropertyKey(selector, property, atRules);
      pushToClassesMap(cssClassesMap, key, 0, undefined);
      continue;
    }
    if (typeof value === 'string' || typeof value === 'number') {
      const selector = trimSelector(selectors.join(''));
      const shorthand = getShorthandDefinition(property);
      if (shorthand) {
        const shorthandProperties = shorthand[1];
        const shorthandResetStyles = Object.fromEntries(shorthandProperties.map(property => [property, RESET]));
        resolveStyleRules(shorthandResetStyles, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket);
      }
      // uniq key based on a hash of property & selector, used for merging later
      const key = hashPropertyKey(selector, property, atRules);
      const className = hashClassName({
        value: value.toString(),
        salt: classNameHashSalt,
        selector,
        property
      }, atRules);
      const rtlDefinition = rtlValue && {
        key: property,
        value: rtlValue
      } || convertProperty(property, value);
      const flippedInRtl = rtlDefinition.key !== property || rtlDefinition.value !== value;
      const rtlClassName = flippedInRtl ? hashClassName({
        value: rtlDefinition.value.toString(),
        property: rtlDefinition.key,
        salt: classNameHashSalt,
        selector
      }, atRules) : undefined;
      const rtlCompileOptions = flippedInRtl ? {
        rtlClassName,
        rtlProperty: rtlDefinition.key,
        rtlValue: rtlDefinition.value
      } : undefined;
      const styleBucketName = getStyleBucketName(selectors, atRules);
      const [ltrCSS, rtlCSS] = compileAtomicCSSRule(Object.assign({
        className,
        selectors,
        property,
        value
      }, rtlCompileOptions), atRules);
      pushToClassesMap(cssClassesMap, key, className, rtlClassName);
      pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, atRules.media, computePropertyPriority(shorthand));
    } else if (property === 'animationName') {
      const animationNameValue = Array.isArray(value) ? value : [value];
      const animationNames = [];
      const rtlAnimationNames = [];
      for (const keyframeObject of animationNameValue) {
        const keyframeCSS = compileKeyframeRule(keyframeObject);
        const rtlKeyframeCSS = compileKeyframeRule(convert$1(keyframeObject));
        const animationName = HASH_PREFIX + murmur2(keyframeCSS);
        let rtlAnimationName;
        const keyframeRules = compileKeyframesCSS(animationName, keyframeCSS);
        let rtlKeyframeRules = [];
        if (keyframeCSS === rtlKeyframeCSS) {
          // If CSS for LTR & RTL are same we will re-use animationName from LTR to avoid duplication of rules in output
          rtlAnimationName = animationName;
        } else {
          rtlAnimationName = HASH_PREFIX + murmur2(rtlKeyframeCSS);
          rtlKeyframeRules = compileKeyframesCSS(rtlAnimationName, rtlKeyframeCSS);
        }
        for (let i = 0; i < keyframeRules.length; i++) {
          pushToCSSRules(cssRulesByBucket,
          // keyframes styles should be inserted into own bucket
          'k', keyframeRules[i], rtlKeyframeRules[i], atRules.media,
          // keyframes always have default priority
          0);
        }
        animationNames.push(animationName);
        rtlAnimationNames.push(rtlAnimationName);
      }
      resolveStyleRules({
        animationName: animationNames.join(', ')
      }, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket, rtlAnimationNames.join(', '));
    } else if (Array.isArray(value)) {
      // not animationName property but array in the value => fallback values
      if (value.length === 0) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`makeStyles(): An empty array was passed as input to "${property}", the property will be omitted in the styles.`);
        }
        continue;
      }
      const selector = trimSelector(selectors.join(''));
      const shorthand = getShorthandDefinition(property);
      if (shorthand) {
        const shorthandProperties = shorthand[1];
        const shorthandResetStyles = Object.fromEntries(shorthandProperties.map(property => [property, RESET]));
        resolveStyleRules(shorthandResetStyles, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket);
      }
      const key = hashPropertyKey(selector, property, atRules);
      const className = hashClassName({
        value: value.map(v => (v !== null && v !== undefined ? v : '').toString()).join(';'),
        salt: classNameHashSalt,
        selector,
        property
      }, atRules);
      const rtlDefinitions = value.map(v => convertProperty(property, v));
      const rtlPropertyConsistent = !rtlDefinitions.some(v => v.key !== rtlDefinitions[0].key);
      if (!rtlPropertyConsistent) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('makeStyles(): mixing CSS fallback values which result in multiple CSS properties in RTL is not supported.');
        }
        continue;
      }
      const flippedInRtl = rtlDefinitions[0].key !== property || rtlDefinitions.some((v, i) => v.value !== value[i]);
      const rtlClassName = flippedInRtl ? hashClassName({
        value: rtlDefinitions.map(v => {
          var _a;
          return ((_a = v === null || v === undefined ? undefined : v.value) !== null && _a !== undefined ? _a : '').toString();
        }).join(';'),
        salt: classNameHashSalt,
        property: rtlDefinitions[0].key,
        selector
      }, atRules) : undefined;
      const rtlCompileOptions = flippedInRtl ? {
        rtlClassName,
        rtlProperty: rtlDefinitions[0].key,
        rtlValue: rtlDefinitions.map(d => d.value)
      } : undefined;
      const styleBucketName = getStyleBucketName(selectors, atRules);
      const [ltrCSS, rtlCSS] = compileAtomicCSSRule(Object.assign({
        className,
        selectors,
        property,
        value: value
      }, rtlCompileOptions), atRules);
      pushToClassesMap(cssClassesMap, key, className, rtlClassName);
      pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, atRules.media, computePropertyPriority(shorthand));
    } else if (isObject$7(value)) {
      if (isNestedSelector(property)) {
        resolveStyleRules(value, classNameHashSalt, selectors.concat(normalizeNestedProperty(property)), atRules, cssClassesMap, cssRulesByBucket);
      } else if (isMediaQuerySelector(property)) {
        const combinedMediaQuery = generateCombinedQuery(atRules.media, property.slice(6).trim());
        resolveStyleRules(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
          media: combinedMediaQuery
        }), cssClassesMap, cssRulesByBucket);
      } else if (isLayerSelector(property)) {
        const combinedLayerQuery = (atRules.layer ? `${atRules.layer}.` : '') + property.slice(6).trim();
        resolveStyleRules(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
          layer: combinedLayerQuery
        }), cssClassesMap, cssRulesByBucket);
      } else if (isSupportQuerySelector(property)) {
        const combinedSupportQuery = generateCombinedQuery(atRules.supports, property.slice(9).trim());
        resolveStyleRules(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
          supports: combinedSupportQuery
        }), cssClassesMap, cssRulesByBucket);
      } else if (isContainerQuerySelector(property)) {
        // TODO implement nested container queries if needed
        // The only way to target multiple containers is to nest container queries
        // https://developer.mozilla.org/en-US/docs/Web/CSS/@container#nested_container_queries
        const containerQuery = property.slice(10).trim();
        resolveStyleRules(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
          container: containerQuery
        }), cssClassesMap, cssRulesByBucket);
      } else {
        warnAboutUnresolvedRule(property, value);
      }
    }
  }
  return [cssClassesMap, cssRulesByBucket];
}

/**
 * Calls resolveStyleRules() for each slot, is also used by build time transform.
 *
 * @param stylesBySlots - An object with makeStyles rules where a key is a slot name
 * @param classNameHashSalt - A salt for classes hash
 *
 * @return - A tuple with an object classnames mapping where a key is a slot name and an array with CSS rules
 */
function resolveStyleRulesForSlots(stylesBySlots, classNameHashSalt = '') {
  const classesMapBySlot = {};
  const cssRules = {};
  // eslint-disable-next-line guard-for-in
  for (const slotName in stylesBySlots) {
    const slotStyles = stylesBySlots[slotName];
    const [cssClassMap, cssRulesByBucket] = resolveStyleRules(slotStyles, classNameHashSalt);
    classesMapBySlot[slotName] = cssClassMap;
    Object.keys(cssRulesByBucket).forEach(styleBucketName => {
      cssRules[styleBucketName] = (cssRules[styleBucketName] || []).concat(cssRulesByBucket[styleBucketName]);
    });
  }
  return [classesMapBySlot, cssRules];
}

function makeStyles$1(stylesBySlots, factory = insertionFactory$1) {
  const insertStyles = factory();
  let classesMapBySlot = null;
  let cssRules = null;
  let ltrClassNamesForSlots = null;
  let rtlClassNamesForSlots = null;
  let sourceURL;
  if (process.env.NODE_ENV !== 'production' && isDevToolsEnabled) {
    sourceURL = getSourceURLfromError();
  }
  let classNameHashSalt;
  function computeClasses(options) {
    const {
      dir,
      renderer
    } = options;
    if (classesMapBySlot === null) {
      [classesMapBySlot, cssRules] = resolveStyleRulesForSlots(stylesBySlots, renderer.classNameHashSalt);
      if (process.env.NODE_ENV !== 'production') {
        if (renderer.classNameHashSalt) {
          if (classNameHashSalt !== renderer.classNameHashSalt) {
            console.error(['@griffel/core:', '\n\n', 'A provided renderer has different "classNameHashSalt".', 'This is not supported and WILL cause issues with classnames generation.', 'Ensure that all renderers created with "createDOMRenderer()" have the same "classNameHashSalt".'].join(' '));
          }
          classNameHashSalt = renderer.classNameHashSalt;
        }
      }
    }
    const isLTR = dir === 'ltr';
    if (isLTR) {
      if (ltrClassNamesForSlots === null) {
        ltrClassNamesForSlots = reduceToClassNameForSlots(classesMapBySlot, dir);
      }
    } else {
      if (rtlClassNamesForSlots === null) {
        rtlClassNamesForSlots = reduceToClassNameForSlots(classesMapBySlot, dir);
      }
    }
    insertStyles(renderer, cssRules);
    const classNamesForSlots = isLTR ? ltrClassNamesForSlots : rtlClassNamesForSlots;
    if (process.env.NODE_ENV !== 'production' && isDevToolsEnabled) {
      debugData.addSequenceDetails(classNamesForSlots, sourceURL);
    }
    return classNamesForSlots;
  }
  return computeClasses;
}

/**
 * A version of makeStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */
function __styles$1(classesMapBySlot, cssRules, factory = insertionFactory$1) {
  const insertStyles = factory();
  let ltrClassNamesForSlots = null;
  let rtlClassNamesForSlots = null;
  let sourceURL;
  if (process.env.NODE_ENV !== 'production' && isDevToolsEnabled) {
    sourceURL = getSourceURLfromError();
  }
  function computeClasses(options) {
    const {
      dir,
      renderer
    } = options;
    const isLTR = dir === 'ltr';
    if (isLTR) {
      if (ltrClassNamesForSlots === null) {
        ltrClassNamesForSlots = reduceToClassNameForSlots(classesMapBySlot, dir);
      }
    } else {
      if (rtlClassNamesForSlots === null) {
        rtlClassNamesForSlots = reduceToClassNameForSlots(classesMapBySlot, dir);
      }
    }
    insertStyles(renderer, cssRules);
    const classNamesForSlots = isLTR ? ltrClassNamesForSlots : rtlClassNamesForSlots;
    if (process.env.NODE_ENV !== 'production' && isDevToolsEnabled) {
      debugData.addSequenceDetails(classNamesForSlots, sourceURL);
    }
    return classNamesForSlots;
  }
  return computeClasses;
}

/**
 * @internal
 */
function __resetStyles$1(ltrClassName, rtlClassName, cssRules, factory = insertionFactory$1) {
  const insertStyles = factory();
  function computeClassName(options) {
    const {
      dir,
      renderer
    } = options;
    const className = dir === 'ltr' ? ltrClassName : rtlClassName || ltrClassName;
    insertStyles(renderer, Array.isArray(cssRules) ? {
      r: cssRules
    } : cssRules);
    if (process.env.NODE_ENV !== 'production') {
      DEBUG_RESET_CLASSES[className] = 1;
    }
    return className;
  }
  return computeClassName;
}

// This should be just "export * as shorthands from "
// https://github.com/microsoft/fluentui/issues/20694
const shorthands = {
  border,
  borderLeft,
  borderBottom,
  borderRight,
  borderTop,
  borderColor,
  borderStyle,
  borderRadius: borderRadius$1,
  borderWidth,
  flex,
  gap,
  gridArea,
  margin,
  marginBlock,
  marginInline,
  padding,
  paddingBlock,
  paddingInline,
  overflow,
  inset,
  outline,
  transition,
  textDecoration
};

/**
 * Verifies if an application can use DOM.
 */
function canUseDOM$1() {
  return typeof window !== 'undefined' && !!(window.document && window.document.createElement);
}

const useInsertionEffect$2 =
// @ts-expect-error Hack to make sure that `useInsertionEffect` will not cause bundling issues in older React versions
// eslint-disable-next-line no-useless-concat
React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : undefined;

const insertionFactory = () => {
  const insertionCache = {};
  return function insert(renderer, cssRules) {
    // Even if `useInsertionEffect` is available, we can use it on a client only as it will not be executed in SSR
    if (useInsertionEffect$2 && canUseDOM$1()) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useInsertionEffect$2(() => {
        renderer.insertCSSRules(cssRules);
      }, [renderer, cssRules]);
      return;
    }
    if (insertionCache[renderer.id] === undefined) {
      renderer.insertCSSRules(cssRules);
      insertionCache[renderer.id] = true;
    }
  };
};

/**
 * @private
 */
const RendererContext = /*#__PURE__*/React.createContext( /*#__PURE__*/createDOMRenderer());
/**
 * Returns an instance of current makeStyles() renderer.
 *
 * @private Exported as "useRenderer_unstable" use it on own risk. Can be changed or removed without a notice.
 */
function useRenderer() {
  return React.useContext(RendererContext);
}

/**
 * @private
 */
const TextDirectionContext = /*#__PURE__*/React.createContext('ltr');
/**
 * @public
 */
const TextDirectionProvider = ({
  children,
  dir
}) => {
  return /*#__PURE__*/React.createElement(TextDirectionContext.Provider, {
    value: dir
  }, children);
};
/**
 * Returns current directionality of the element's text.
 *
 * @private
 */
function useTextDirection() {
  return React.useContext(TextDirectionContext);
}

function isInsideComponent() {
  // React 18 always logs errors if a dispatcher is not present:
  // https://github.com/facebook/react/blob/42f15b324f50d0fd98322c21646ac3013e30344a/packages/react/src/ReactHooks.js#L26-L36
  try {
    // @ts-expect-error "SECRET_INTERNALS" are not typed
    const dispatcher = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher.current;
    // Before any React component was rendered "dispatcher" will be "null"
    if (dispatcher === null || dispatcher === undefined) {
      return false;
    }
    // A check with hooks call (i.e. call "React.useContext()" outside a component) will always produce errors, but
    // a call on the dispatcher wont
    dispatcher.useContext({});
    return true;
  } catch (e) {
    return false;
  }
}

function makeStyles(stylesBySlots) {
  const getStyles = makeStyles$1(stylesBySlots, insertionFactory);
  if (process.env.NODE_ENV !== 'production') {
    if (isInsideComponent()) {
      throw new Error(["makeStyles(): this function cannot be called in component's scope.", 'All makeStyles() calls should be top level i.e. in a root scope of a file.'].join(' '));
    }
  }
  return function useClasses() {
    const dir = useTextDirection();
    const renderer = useRenderer();
    return getStyles({
      dir,
      renderer
    });
  };
}

/**
 * A version of makeStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function __styles(classesMapBySlot, cssRules) {
  const getStyles = __styles$1(classesMapBySlot, cssRules, insertionFactory);
  return function useClasses() {
    const dir = useTextDirection();
    const renderer = useRenderer();
    return getStyles({
      dir,
      renderer
    });
  };
}

/**
 * A version of makeResetStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function __resetStyles(ltrClassName, rtlClassName, cssRules) {
  const getStyles = __resetStyles$1(ltrClassName, rtlClassName, cssRules, insertionFactory);
  return function useClasses() {
    const dir = useTextDirection();
    const renderer = useRenderer();
    return getStyles({
      dir,
      renderer
    });
  };
}

const useRootStyles$4 = __styles({
  "root": {
    "mc9l5x": "f1w7gpdv",
    "Bg96gwp": "fez10in",
    "ycbfsm": "fg4l7m0"
  },
  "rtl": {
    "Bz10aip": "f13rod7r"
  }
}, {
  "d": [".f1w7gpdv{display:inline;}", ".fez10in{line-height:0;}", ".f13rod7r{-webkit-transform:scaleX(-1);-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1);}"],
  "t": ["@media (forced-colors: active){.fg4l7m0{forced-color-adjust:auto;}}"]
});
const useIconState = (props, options) => {
  const {
    title,
    primaryFill = "currentColor",
    ...rest
  } = props;
  const state = {
    ...rest,
    title: undefined,
    fill: primaryFill
  };
  const styles = useRootStyles$4();
  const iconContext = useIconContext();
  state.className = mergeClasses(styles.root, (options === null || options === undefined ? undefined : options.flipInRtl) && (iconContext === null || iconContext === undefined ? undefined : iconContext.textDirection) === 'rtl' && styles.rtl, state.className);
  if (title) {
    state['aria-label'] = title;
  }
  if (!state['aria-label'] && !state['aria-labelledby']) {
    state['aria-hidden'] = true;
  } else {
    state['role'] = 'img';
  }
  return state;
};

const createFluentIcon = (displayName, width, paths, options) => {
  const viewBoxWidth = width === "1em" ? "20" : width;
  const Icon = React.forwardRef((props, ref) => {
    const state = {
      ...useIconState(props, {
        flipInRtl: options === null || options === undefined ? undefined : options.flipInRtl
      }),
      ref,
      width,
      height: width,
      viewBox: `0 0 ${viewBoxWidth} ${viewBoxWidth}`,
      xmlns: "http://www.w3.org/2000/svg"
    };
    return React.createElement("svg", state, ...paths.map(d => React.createElement("path", {
      d,
      fill: state.fill
    })));
  });
  Icon.displayName = displayName;
  return Icon;
};

const AddRegular = /*#__PURE__*/createFluentIcon('AddRegular', "1em", ["M10 2.5a.5.5 0 0 0-1 0V9H2.5a.5.5 0 0 0 0 1H9v6.5a.5.5 0 0 0 1 0V10h6.5a.5.5 0 0 0 0-1H10V2.5Z"]);
const ArrowClockwiseFilled = /*#__PURE__*/createFluentIcon('ArrowClockwiseFilled', "1em", ["M4 10a6 6 0 0 1 9.97-4.5h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3a.75.75 0 0 0-1.5 0v1.16a7.5 7.5 0 1 0 2.5 5.31.75.75 0 0 0-1.5.06V10a6 6 0 0 1-12 0Z"]);
const ArrowClockwiseRegular = /*#__PURE__*/createFluentIcon('ArrowClockwiseRegular', "1em", ["M4 10a6 6 0 0 1 10.47-4H12.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.6a7 7 0 1 0 1.98 4.36.5.5 0 1 0-1 .08L16 10a6 6 0 0 1-12 0Z"]);
const ArrowDownRegular = /*#__PURE__*/createFluentIcon('ArrowDownRegular', "1em", ["M16.87 10.84a.5.5 0 1 0-.74-.68l-5.63 6.17V2.5a.5.5 0 0 0-1 0v13.83l-5.63-6.17a.5.5 0 0 0-.74.68l6.31 6.91a.75.75 0 0 0 1.11 0l6.32-6.91Z"]);
const ArrowLeftRegular = /*#__PURE__*/createFluentIcon('ArrowLeftRegular', "1em", ["M9.16 16.87a.5.5 0 1 0 .67-.74L3.67 10.5H17.5a.5.5 0 0 0 0-1H3.67l6.16-5.63a.5.5 0 0 0-.67-.74L2.24 9.44a.75.75 0 0 0 0 1.11l6.92 6.32Z"]);
const ArrowMaximizeRegular = /*#__PURE__*/createFluentIcon('ArrowMaximizeRegular', "1em", ["M10.5 3h6.04l.09.02.06.02.08.04.05.04.06.06.03.04.04.07.03.08.02.08V9.5a.5.5 0 0 1-1 .09V4.7L4.7 16h4.8a.5.5 0 0 1 .5.41v.09a.5.5 0 0 1-.41.5H3.41l-.1-.04-.08-.04-.05-.04-.06-.06-.03-.04-.04-.07-.03-.08v-.02A.5.5 0 0 1 3 16.5v.07-6.07a.5.5 0 0 1 1-.09v4.89L15.3 4h-4.8a.5.5 0 0 1-.5-.41V3.5c0-.28.22-.5.5-.5Z"]);
const ArrowMinimizeRegular = /*#__PURE__*/createFluentIcon('ArrowMinimizeRegular', "1em", ["M3.5 11h5a.5.5 0 0 1 .5.41v5.09a.5.5 0 0 1-1 .09V12.7l-5.15 5.15a.5.5 0 0 1-.76-.63l.06-.07L7.29 12H3.5a.5.5 0 0 1-.5-.41v-.09a.5.5 0 0 1 .41-.5H8.5h-5Zm14.35-8.85c.18.17.2.44.06.63l-.06.07L12.71 8h3.79a.5.5 0 0 1 .5.41v.09a.5.5 0 0 1-.41.5h-5.18l-.1-.04-.08-.04-.05-.04-.03-.03-.04-.04-.04-.06-.03-.06-.02-.06V8.6a.5.5 0 0 1-.02-.1v.07V3.5a.5.5 0 0 1 1-.09V7.3l5.15-5.15c.2-.2.5-.2.7 0Z"]);
const ArrowRedoRegular = /*#__PURE__*/createFluentIcon('ArrowRedoRegular', "1em", ["M15 2.5a.5.5 0 0 1 1 0v4.9a.6.6 0 0 1-.6.6h-4.9a.5.5 0 0 1 0-1h3.6l-3.48-3.02a4 4 0 1 0-5.24 6.04l8.17 7.1a.5.5 0 1 1-.66.76l-8.17-7.1a5 5 0 1 1 6.56-7.55L15 6.46V2.5Z"], {
  flipInRtl: true
});
const ArrowTurnLeftUpRegular = /*#__PURE__*/createFluentIcon('ArrowTurnLeftUpRegular', "1em", ["M3.15 8.85a.5.5 0 0 1 0-.7l4-4c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L8 5.71V12c0 1.1.9 2 2 2h6.5a.5.5 0 0 1 0 1H10a3 3 0 0 1-3-3V5.7L3.85 8.86a.5.5 0 0 1-.7 0Z"]);
const ArrowUndoRegular = /*#__PURE__*/createFluentIcon('ArrowUndoRegular', "1em", ["M5 2.5a.5.5 0 0 0-1 0v4.9c0 .33.27.6.6.6h4.9a.5.5 0 0 0 0-1H5.9l3.48-3.02a4 4 0 0 1 5.25 6.04l-8.17 7.1a.5.5 0 0 0 .65.76l8.17-7.1a5 5 0 0 0-6.56-7.55L5 6.46V2.5Z"], {
  flipInRtl: true
});
const ArrowUpRegular = /*#__PURE__*/createFluentIcon('ArrowUpRegular', "1em", ["M3.13 9.16a.5.5 0 1 0 .74.68L9.5 3.67V17.5a.5.5 0 1 0 1 0V3.67l5.63 6.17a.5.5 0 0 0 .74-.68l-6.32-6.92a.75.75 0 0 0-1.1 0L3.13 9.16Z"]);
const ChatAddRegular = /*#__PURE__*/createFluentIcon('ChatAddRegular', "1em", ["M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3h-3ZM18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10ZM3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02a.5.5 0 0 0-.18 0l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A6.97 6.97 0 0 1 3 10Z"]);

const CheckboxUncheckedRegular = /*#__PURE__*/createFluentIcon('CheckboxUncheckedRegular', "1em", ["M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z"]);
const CheckmarkRegular = /*#__PURE__*/createFluentIcon('CheckmarkRegular', "1em", ["M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27l-3.65-4.1Z"]);
const CheckmarkCircleRegular = /*#__PURE__*/createFluentIcon('CheckmarkCircleRegular', "1em", ["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm3.36 4.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0Z"]);
const ChevronDownRegular = /*#__PURE__*/createFluentIcon('ChevronDownRegular', "1em", ["M15.85 7.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 0 1-.78 0L4.15 8.35a.5.5 0 1 1 .7-.7L10 12.8l5.15-5.16c.2-.2.5-.2.7 0Z"]);
const ChevronLeftRegular = /*#__PURE__*/createFluentIcon('ChevronLeftRegular', "1em", ["M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7Z"]);
const ChevronRightRegular = /*#__PURE__*/createFluentIcon('ChevronRightRegular', "1em", ["M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 0 1-.7-.7L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7Z"]);
const ChevronUpRegular = /*#__PURE__*/createFluentIcon('ChevronUpRegular', "1em", ["M4.15 12.35a.5.5 0 0 1 0-.7L9.6 6.16a.55.55 0 0 1 .78 0l5.46 5.49a.5.5 0 0 1-.7.7L10 7.2l-5.15 5.16a.5.5 0 0 1-.7 0Z"]);
const ClockRegular = /*#__PURE__*/createFluentIcon('ClockRegular', "1em", ["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-.5 2a.5.5 0 0 1 .5.41V10h2.5a.5.5 0 0 1 .09 1H9.5a.5.5 0 0 1-.5-.41V5.5c0-.28.22-.5.5-.5Z"]);
const CodeRegular = /*#__PURE__*/createFluentIcon('CodeRegular', "1em", ["M12.97 3.68a.5.5 0 0 0-.94-.36l-5 13a.5.5 0 1 0 .94.36l5-13ZM5.83 6.12c.2.18.23.5.05.7L3.16 10l2.72 3.17a.5.5 0 0 1-.76.66l-3-3.5a.5.5 0 0 1 0-.66l3-3.5a.5.5 0 0 1 .7-.05Zm8.34 8.26a.5.5 0 0 1-.05-.7l2.72-3.18-2.72-3.17a.5.5 0 1 1 .76-.66l3 3.5a.5.5 0 0 1 0 .66l-3 3.5a.5.5 0 0 1-.7.05Z"]);
const CopyRegular = /*#__PURE__*/createFluentIcon('CopyRegular', "1em", ["M8 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8ZM7 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4ZM4 6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17h6.23A2 2 0 0 1 12 18H7.5A3.5 3.5 0 0 1 4 14.5V6Z"]);
const DismissRegular = /*#__PURE__*/createFluentIcon('DismissRegular', "1em", ["m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"]);
const DismissCircleRegular = /*#__PURE__*/createFluentIcon('DismissCircleRegular', "1em", ["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM7.8 7.11l.08.06L10 9.3l2.12-2.12a.5.5 0 0 1 .64-.06l.07.06c.17.18.2.44.06.64l-.06.07L10.7 10l2.12 2.12c.17.17.2.44.06.64l-.06.07a.5.5 0 0 1-.64.06l-.07-.06L10 10.7l-2.12 2.12a.5.5 0 0 1-.64.06l-.07-.06a.5.5 0 0 1-.06-.64l.06-.07L9.3 10 7.17 7.88a.5.5 0 0 1-.06-.64l.06-.07a.5.5 0 0 1 .64-.06Z"]);
const EditRegular = /*#__PURE__*/createFluentIcon('EditRegular', "1em", ["M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68l9.36-9.36a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 1 1 2.8 2.8l-.68.66-2.8-2.79.68-.67Zm-1.38 1.38 2.8 2.8-7.99 7.97c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l8-8Z"]);

const EyeRegular = /*#__PURE__*/createFluentIcon('EyeRegular', "1em", ["M3.26 11.6A6.97 6.97 0 0 1 10 6c3.2 0 6.06 2.33 6.74 5.6a.5.5 0 0 0 .98-.2A7.97 7.97 0 0 0 10 5a7.97 7.97 0 0 0-7.72 6.4.5.5 0 0 0 .98.2ZM10 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-2.5 3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"]);
const EyeOffRegular = /*#__PURE__*/createFluentIcon('EyeOffRegular', "1em", ["M2.85 2.15a.5.5 0 1 0-.7.7l3.5 3.5a8.1 8.1 0 0 0-3.37 5.05.5.5 0 1 0 .98.2 7.09 7.09 0 0 1 3.1-4.53l1.6 1.59a3.5 3.5 0 1 0 4.88 4.89l4.3 4.3a.5.5 0 0 0 .71-.7l-15-15Zm9.27 10.68a2.5 2.5 0 1 1-3.45-3.45l3.45 3.45Zm-2-4.83 3.38 3.38A3.5 3.5 0 0 0 10.12 8ZM10 6c-.57 0-1.13.07-1.67.21l-.8-.8A7.65 7.65 0 0 1 10 5c3.7 0 6.94 2.67 7.72 6.4a.5.5 0 0 1-.98.2A6.97 6.97 0 0 0 10 6Z"]);
const FilterRegular = /*#__PURE__*/createFluentIcon('FilterRegular', "1em", ["M7.5 13h5a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09-5Zm-2-4h9a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09-9Zm-2-4h13a.5.5 0 0 1 .09 1H3.5a.5.5 0 0 1-.09-1H16.5h-13Z"]);
const HeadsetRegular = /*#__PURE__*/createFluentIcon('HeadsetRegular', "1em", ["M4 8a6 6 0 1 1 12 0v3a2 2 0 0 1-2 2h-1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2A5 5 0 0 0 5 8h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5v1c0 1.1.9 2 2 2h1a2 2 0 1 1 .27 1H7a3 3 0 0 1-3-3V8Zm11 1h-2v3h1a1 1 0 0 0 1-1V9ZM5 12h2V9H5v3Zm4 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"]);
const HighlightRegular = /*#__PURE__*/createFluentIcon('HighlightRegular', "1em", ["M3.5 2c.28 0 .5.22.5.5v4c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 1 0v4c0 .65-.42 1.2-1 1.41V9a2 2 0 0 1-2 2v2.07a2 2 0 0 1-1.1 1.8l-6.18 3.08A.5.5 0 0 1 6 17.5V11a2 2 0 0 1-2-2V7.91c-.58-.2-1-.76-1-1.41v-4c0-.28.22-.5.5-.5ZM5 8v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8H5Zm2 3v5.7l5.45-2.73a1 1 0 0 0 .55-.9V11H7Z"]);
const HomeRegular = /*#__PURE__*/createFluentIcon('HomeRegular', "1em", ["M9 2.39a1.5 1.5 0 0 1 2 0l5.5 4.94c.32.28.5.69.5 1.12v7.05c0 .83-.67 1.5-1.5 1.5H13a1.5 1.5 0 0 1-1.5-1.5V12a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v3.5c0 .83-.67 1.5-1.5 1.5H4.5A1.5 1.5 0 0 1 3 15.5V8.45c0-.43.18-.84.5-1.12L9 2.39Zm1.33.74a.5.5 0 0 0-.66 0l-5.5 4.94a.5.5 0 0 0-.17.38v7.05c0 .28.22.5.5.5H7a.5.5 0 0 0 .5-.5V12c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v3.5c0 .28.22.5.5.5h2.5a.5.5 0 0 0 .5-.5V8.45a.5.5 0 0 0-.17-.38l-5.5-4.94Z"]);
const InfoRegular = /*#__PURE__*/createFluentIcon('InfoRegular', "1em", ["M10.5 8.91a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91Zm.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"]);
const InsertRegular = /*#__PURE__*/createFluentIcon('InsertRegular', "1em", ["M6 3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6ZM4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 13a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6Zm-2-1c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2Zm-2-6c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15A.5.5 0 0 1 2 10Z"]);
const LinkSquareRegular = /*#__PURE__*/createFluentIcon('LinkSquareRegular', "1em", ["M4.5 3C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H6v1H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5H9v-1h1.5c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-6Zm5 4H11v1H9.5C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H14V7h1.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5v-6A2.5 2.5 0 0 1 9.5 7Z"]);
const ListRegular = /*#__PURE__*/createFluentIcon('ListRegular', "1em", ["M2 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 10c0-.28.22-.5.5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5ZM2.5 9a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"]);
const LockClosedFilled = /*#__PURE__*/createFluentIcon('LockClosedFilled', "1em", ["M10 2a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-1V5a3 3 0 0 0-3-3ZM8 5a2 2 0 1 1 4 0v1H8V5Zm2 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"]);
const LockOpenRegular = /*#__PURE__*/createFluentIcon('LockOpenRegular', "1em", ["M10 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-11a2 2 0 0 0-2 2v2h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h6V4a3 3 0 1 1 6 0v.5a.5.5 0 0 1-1 0V4a2 2 0 0 0-2-2Zm-1 5H6a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z"]);
const MoreHorizontalRegular = /*#__PURE__*/createFluentIcon('MoreHorizontalRegular', "1em", ["M6.25 10a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"]);
const NavigationRegular = /*#__PURE__*/createFluentIcon('NavigationRegular', "1em", ["M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm.5 4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"]);

const PaymentRegular = /*#__PURE__*/createFluentIcon('PaymentRegular', "1em", ["M13.5 13a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5ZM4.75 5C3.78 5 3 5.78 3 6.75V8h14V6.75C17 5.78 16.22 5 15.25 5H4.75ZM17 9H3v4.25c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75V9Z"]);
const PeopleCommunityRegular = /*#__PURE__*/createFluentIcon('PeopleCommunityRegular', "1em", ["M8.75 3.75a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0Zm-4.5 0a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM2.5 7.5h4.18c-.16.31-.28.65-.35 1H2.5A.5.5 0 0 0 2 9v.5c0 1.26 1.1 2.61 3.1 2.93-.33.22-.6.51-.79.85C2.21 12.71 1 11.08 1 9.5V9c0-.83.67-1.5 1.5-1.5Zm5.38 0a2.74 2.74 0 1 1 4.24 3.49A2.74 2.74 0 0 1 7.88 7.5Zm.54 1a1.74 1.74 0 0 0 .87 2.35 1.74 1.74 0 0 0 2.46-1.6 1.74 1.74 0 0 0-2.01-1.73c-.59.09-1.08.46-1.32.98Zm7.27 4.78c-.2-.34-.46-.63-.79-.85 2-.32 3.1-1.67 3.1-2.93V9a.5.5 0 0 0-.5-.5h-3.82c-.08-.35-.2-.69-.36-1h4.18c.83 0 1.5.67 1.5 1.5v.5c0 1.59-1.2 3.21-3.31 3.78Zm-1.2.1a1.5 1.5 0 0 0-.99-.38h-7A1.5 1.5 0 0 0 5 14.5v.5c0 1.97 1.86 4 5 4 3.14 0 5-2.03 5-4v-.5c0-.45-.2-.85-.51-1.13ZM6 14.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v.5c0 1.44-1.43 3-4 3-2.57 0-4-1.56-4-3v-.5ZM14 1a2.75 2.75 0 1 1 0 5.5A2.75 2.75 0 0 1 14 1Zm0 1a1.75 1.75 0 1 0 0 3.5A1.75 1.75 0 0 0 14 2Z"]);
const PersonRegular = /*#__PURE__*/createFluentIcon('PersonRegular', "1em", ["M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 10 18c1.85 0 3.58-.39 4.87-1.2A4.35 4.35 0 0 0 17 13a2 2 0 0 0-2-2H5Zm-1 2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1c0 1.3-.62 2.28-1.67 2.95A8.16 8.16 0 0 1 10 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 4 13Z"]);
const PhoneLaptopRegular = /*#__PURE__*/createFluentIcon('PhoneLaptopRegular', "1em", ["M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V6H3V4.5ZM10 15h7.5a.5.5 0 0 0 0-1H10v1Zm-5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1H5ZM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5v-8ZM3.5 8a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-4Z"]);
const SaveRegular = /*#__PURE__*/createFluentIcon('SaveRegular', "1em", ["M3 5c0-1.1.9-2 2-2h8.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1v-4.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V16a1 1 0 0 0 1-1V6.62a1 1 0 0 0-.3-.7L14.1 4.28a1 1 0 0 0-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 6.5V4H5Zm2 0v2.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4H7Zm7 12v-4.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V16h8Z"]);
const SendFilled = /*#__PURE__*/createFluentIcon('SendFilled', "1em", ["M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z"], {
  flipInRtl: true
});
const SendRegular = /*#__PURE__*/createFluentIcon('SendRegular', "1em", ["M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1 0 .9l-15 7.5a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52Zm2.7 8.39-1.61 6.06L16.38 10 3.27 3.44 4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88Z"], {
  flipInRtl: true
});
const SettingsRegular = /*#__PURE__*/createFluentIcon('SettingsRegular', "1em", ["M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54Zm1.06 0 1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1c.3.79.72 1.51 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67a7.56 7.56 0 0 0 2.5 0l.3-1.67a2 2 0 0 1 2.64-1.53l1.6.58a7.5 7.5 0 0 0 1.24-2.16l-1.3-1.1a2 2 0 0 1 0-3.04l1.3-1.1a7.5 7.5 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a7.55 7.55 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a7.5 7.5 0 0 0-1.24 2.16ZM7.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm1 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"]);

const SquareDismissRegular = /*#__PURE__*/createFluentIcon('SquareDismissRegular', "1em", ["M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.2c.35.1.68.24 1 .4V6a3 3 0 0 0-3-3H6Zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0Z"]);
const TextAlignCenterRegular = /*#__PURE__*/createFluentIcon('TextAlignCenterRegular', "1em", ["M4 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm-2 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5ZM6.5 14a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z"]);
const TextAlignLeftRegular = /*#__PURE__*/createFluentIcon('TextAlignLeftRegular', "1em", ["M2 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm.5 4.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"]);
const TextAlignRightRegular = /*#__PURE__*/createFluentIcon('TextAlignRightRegular', "1em", ["M6 4.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm-4 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5ZM9.5 14a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1h-8Z"]);
const TextBoldRegular = /*#__PURE__*/createFluentIcon('TextBoldRegular', "1em", ["M5.5 4.25C5.5 3.56 6.06 3 6.75 3h3.5a4 4 0 0 1 3.17 6.44c.9.7 1.58 1.8 1.58 3.31A4.23 4.23 0 0 1 10.75 17h-4c-.69 0-1.25-.56-1.25-1.25V4.25ZM8 11v3.5h2.75c.81 0 1.75-.62 1.75-1.75S11.56 11 10.75 11H8Zm0-2.5h2.25a1.5 1.5 0 1 0 0-3H8v3Z"]);
const TextClearFormattingRegular = /*#__PURE__*/createFluentIcon('TextClearFormattingRegular', "1em", ["M6 2c.2 0 .4.13.47.32l3.5 8.95a.5.5 0 0 1-.94.37L8.01 9H4l-1.04 2.68a.5.5 0 1 1-.94-.36l3.5-9A.5.5 0 0 1 6 2Zm0 1.88L4.4 8H7.6l-1.6-4.12ZM11.5 2c.28 0 .5.22.5.5v3.52a2.48 2.48 0 0 1 2.26-1.3c.89 0 1.6.34 2.15 1 .55.66.82 1.54.82 2.64l-.01.42-.05-.05a2.49 2.49 0 0 0-1.15-.65 2.86 2.86 0 0 0-.53-1.62c-.36-.47-.86-.7-1.48-.7-.6 0-1.09.24-1.47.72-.3.37-.47.83-.54 1.37v1.03c.05.43.18.8.37 1.12L11 11.37V2.5c0-.28.22-.5.5-.5ZM9.44 16.47a1.5 1.5 0 0 1 0-2.13l4.9-4.9a1.5 1.5 0 0 1 2.13 0l2.1 2.1a1.5 1.5 0 0 1-.01 2.12L14.22 18h2.53a.5.5 0 1 1 0 1h-4.1a1.5 1.5 0 0 1-1.12-.44l-2.1-2.1Zm5.61-6.32-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 0 0 0-.7l-2.1-2.1a.5.5 0 0 0-.7 0Zm-1.5 7.1-2.8-2.8-.6.6a.5.5 0 0 0 0 .7l2.1 2.1c.19.2.5.2.7 0l.6-.6Z"]);
const TextColorRegular = /*#__PURE__*/createFluentIcon('TextColorRegular', "1em", ["M10.46 2.31a.5.5 0 0 0-.92 0l-3 7.5a.5.5 0 1 0 .92.38L8.54 7.5h2.92l1.08 2.69a.5.5 0 1 0 .92-.38l-3-7.5ZM10 3.85l1.06 2.65H8.94L10 3.85ZM4.5 12c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11ZM4 13.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-3Z"]);
const TextFontRegular = /*#__PURE__*/createFluentIcon('TextFontRegular', "1em", ["M6 2c.2 0 .4.13.47.32L8.9 8.57v.02l.18.44-.53 1.4-.46-1.17H3.91l-.94 2.42a.5.5 0 1 1-.94-.36L3.1 8.59v-.02l2.43-6.25A.5.5 0 0 1 6 2ZM4.3 8.26h3.4L6 3.88 4.3 8.26Zm8.17-2.94a.5.5 0 0 0-.94 0L7.15 17H6.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.28l1.13-3h5.37l1.15 3h-.37a.5.5 0 1 0 0 1h2a.5.5 0 1 0 0-1h-.56L12.47 5.32ZM14.34 13H9.72l2.29-6.09L14.34 13Z"]);
const TextFontSizeRegular = /*#__PURE__*/createFluentIcon('TextFontSizeRegular', "1em", ["M13 3.5c.2 0 .4.13.47.32l3 8v.02l1.5 3.98a.5.5 0 1 1-.94.36l-1.38-3.68h-5.3l-1.38 3.68a.5.5 0 0 1-.93 0L6.96 13.5H4.04l-1.08 2.69a.5.5 0 1 1-.92-.38l1.2-2.98v-.03l1.8-4.49a.5.5 0 0 1 .92 0l1.8 4.5v.02l.73 1.79 1.04-2.78v-.03l3-7.99A.5.5 0 0 1 13 3.5Zm-2.28 8h4.56L13 5.42l-2.28 6.08Zm-4.16 1L5.5 9.85 4.44 12.5h2.12Z"]);
const TextIndentDecreaseLtrRegular = /*#__PURE__*/createFluentIcon('TextIndentDecreaseLtrRegular', "1em", ["M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5ZM3.56 7.73a.5.5 0 0 1 .7.7L3.22 9.5l1.06 1.06a.5.5 0 1 1-.7.7l-1.42-1.4a.5.5 0 0 1 0-.71l1.41-1.42ZM6.5 9a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1h-11ZM6 14.5c0-.28.22-.5.5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5Z"]);
const TextIndentIncreaseLtrRegular = /*#__PURE__*/createFluentIcon('TextIndentIncreaseLtrRegular', "1em", ["M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm.5 4.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM2.85 7.73a.5.5 0 1 0-.7.7L3.2 9.5l-1.06 1.06a.5.5 0 1 0 .7.7l1.42-1.4a.5.5 0 0 0 0-.71L2.85 7.73Z"]);
const TextItalicRegular = /*#__PURE__*/createFluentIcon('TextItalicRegular', "1em", ["M16 3a.5.5 0 0 1 0 1h-3.16L8.23 16h3.27a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h3.16l4.61-12H8.5a.5.5 0 0 1 0-1H16Z"]);
const TextNumberListLtrRegular = /*#__PURE__*/createFluentIcon('TextNumberListLtrRegular', "1em", ["M5 1.5a.5.5 0 0 0-.39-.49.5.5 0 0 0-.56.27l-.07.12a2.96 2.96 0 0 1-1.2 1.15.5.5 0 1 0 .44.9c.3-.15.56-.34.78-.53V5.5a.5.5 0 0 0 1 0v-4ZM2.65 7.65a.5.5 0 0 0 .7.7l.05-.04.2-.12C3.76 8.09 4 8 4.3 8c.23 0 .41.06.53.15.1.07.16.17.16.35a.5.5 0 0 1-.21.44c-.15.12-.35.22-.62.35l-.14.08c-.32.15-.7.36-1 .7-.33.35-.53.81-.53 1.43 0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1H3.59c.04-.1.1-.2.17-.27a2.38 2.38 0 0 1 .83-.53c.27-.13.59-.29.84-.5.33-.27.57-.65.57-1.2 0-.5-.22-.9-.57-1.15A1.92 1.92 0 0 0 4.33 7h-.01a2.5 2.5 0 0 0-1.66.63v.01h-.01Zm.01-.02-.01.02s.1-.1.01-.02ZM4.25 15a.5.5 0 1 0 0 1c.34 0 .53.1.63.18.1.09.13.2.13.3-.01.2-.19.52-.76.52-.41 0-.63-.1-.72-.17a.42.42 0 0 1-.1-.07.5.5 0 0 0-.88.46v.01l.02.02a.8.8 0 0 0 .1.15c.07.08.17.17.3.27.28.18.7.33 1.28.33 1.03 0 1.73-.67 1.76-1.48.01-.37-.12-.74-.4-1.02.28-.28.41-.65.4-1.02-.03-.8-.73-1.48-1.76-1.48-.59 0-1 .15-1.28.33a1.4 1.4 0 0 0-.4.42l-.01.01v.01a.5.5 0 0 0 .87.48.42.42 0 0 1 .1-.08c.1-.07.3-.17.72-.17.57 0 .75.33.76.52 0 .1-.04.21-.13.3-.1.08-.29.18-.63.18Zm-.82-.75.01-.02v.02ZM8.5 4a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1h-8Zm0 5a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1h-8ZM8 14.5c0-.28.22-.5.5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5Z"]);
const TextQuoteFilled = /*#__PURE__*/createFluentIcon('TextQuoteFilled', "1em", ["M9 6.5a2.5 2.5 0 1 0-1.17 2.12 8.8 8.8 0 0 1-.96 2.76 12.06 12.06 0 0 1-2.22 2.77.5.5 0 0 0 .7.7h.02c.74-.75 1.66-1.67 2.38-2.98A10.83 10.83 0 0 0 9 6.5Zm5.83 2.12A2.5 2.5 0 1 1 16 6.5c0 2.33-.52 4.04-1.25 5.37-.72 1.3-1.64 2.23-2.38 2.97l-.02.01a.5.5 0 0 1-.7-.7c.75-.76 1.57-1.59 2.22-2.77a8.8 8.8 0 0 0 .96-2.76Z"]);
const TextStrikethroughRegular = /*#__PURE__*/createFluentIcon('TextStrikethroughRegular', "1em", ["M6.53 4.03A6.15 6.15 0 0 1 10 3a6.16 6.16 0 0 1 4.9 2.2.5.5 0 0 1-.8.6A5.17 5.17 0 0 0 10 4c-1.15 0-2.18.35-2.9.85C6.36 5.35 6 5.98 6 6.5c0 .9.43 1.48 1.17 1.93.36.22.78.4 1.25.57H6.23A3.02 3.02 0 0 1 5 6.5c0-.98.64-1.86 1.53-2.47ZM16.5 10a.5.5 0 0 1 0 1h-2.73A3.02 3.02 0 0 1 15 13.5c0 1.23-.72 2.12-1.68 2.68-.94.56-2.16.82-3.32.82a7.27 7.27 0 0 1-2.9-.48 4.55 4.55 0 0 1-2.02-1.74.5.5 0 0 1 .84-.56c.45.68.96 1.11 1.58 1.38.64.28 1.44.4 2.5.4 1.03 0 2.06-.24 2.82-.68.74-.44 1.18-1.05 1.18-1.82 0-.9-.43-1.48-1.17-1.93-.36-.22-.78-.4-1.25-.57H3.5a.5.5 0 0 1 0-1h13Z"]);
const TextSubscriptRegular = /*#__PURE__*/createFluentIcon('TextSubscriptRegular', "1em", ["M13.54 4.12c.2.18.23.5.05.7L9.16 10l4.08 4.77c-.18.29-.34.63-.42 1.04L8.5 10.77l-4.34 5.06a.5.5 0 1 1-.75-.66L7.84 10 3.41 4.83a.5.5 0 1 1 .75-.66L8.5 9.23l4.33-5.06a.5.5 0 0 1 .7-.05ZM15.58 12c-.46 0-.83.42-.83.86a.5.5 0 0 1-1 0 1.87 1.87 0 0 1 3.42-1.04c.36.55.37 1.27-.04 1.98-.21.36-.5.63-.79.86l-.42.3-.06.05-.34.24c-.32.24-.55.47-.67.75h2.1a.5.5 0 1 1 0 1H14.3a.54.54 0 0 1-.05 0 .5.5 0 0 1-.5-.5c0-1.04.6-1.62 1.17-2.05l.36-.26.06-.04.38-.28c.24-.19.42-.37.55-.58.25-.43.19-.73.07-.92a.89.89 0 0 0-.76-.37Z"]);
const TextSuperscriptRegular = /*#__PURE__*/createFluentIcon('TextSuperscriptRegular', "1em", ["M15.58 3c-.46 0-.83.42-.83.86a.5.5 0 0 1-1 0 1.87 1.87 0 0 1 3.42-1.04c.36.55.37 1.27-.04 1.98-.21.36-.5.63-.79.86l-.42.3-.06.05-.34.24c-.32.24-.55.47-.67.75h2.1a.5.5 0 1 1 0 1H14.24a.5.5 0 0 1-.5-.5c0-1.04.6-1.62 1.17-2.05l.36-.26.06-.04.38-.28c.24-.19.42-.37.55-.58.25-.43.19-.73.07-.92a.89.89 0 0 0-.76-.37ZM12.8 4.22c.09.35.3.66.58.86L9.16 10l4.43 5.17a.5.5 0 1 1-.76.66L8.5 10.77l-4.34 5.06a.5.5 0 0 1-.75-.66L7.84 10 3.41 4.83a.5.5 0 1 1 .75-.66L8.5 9.23l4.3-5Z"]);
const TextUnderlineRegular = /*#__PURE__*/createFluentIcon('TextUnderlineRegular', "1em", ["M6 3.5a.5.5 0 0 0-1 0v6.45A5.02 5.02 0 0 0 10 15c2.77 0 5-2.26 5-5.05V3.5a.5.5 0 0 0-1 0v6.45C14 12.2 12.2 14 10 14s-4-1.8-4-4.05V3.5Zm-1 13c0-.28.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z"]);
const WarningFilled = /*#__PURE__*/createFluentIcon('WarningFilled', "1em", ["M8.68 2.79a1.5 1.5 0 0 1 2.64 0l6.5 12A1.5 1.5 0 0 1 16.5 17h-13a1.5 1.5 0 0 1-1.32-2.21l6.5-12ZM10.5 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Zm.25 6.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"]);

const WarningRegular = /*#__PURE__*/createFluentIcon('WarningRegular', "1em", ["M9.56 3.26a.5.5 0 0 1 .88 0l6.5 12a.5.5 0 0 1-.44.74h-13a.5.5 0 0 1-.44-.74l6.5-12Zm1.76-.47a1.5 1.5 0 0 0-2.64 0l-6.5 12A1.5 1.5 0 0 0 3.5 17h13a1.5 1.5 0 0 0 1.32-2.21l-6.5-12ZM10.5 7.5a.5.5 0 0 0-1 0v4a.5.5 0 1 0 1 0v-4Zm.25 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"]);

const ArrowCounterclockwise16Filled = /*#__PURE__*/createFluentIcon('ArrowCounterclockwise16Filled', "16", ["M12.5 8a4.5 4.5 0 0 0-7.85-3h1.6a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 1 1 1.5 0v.78a6 6 0 1 1-1.94 5.32.75.75 0 1 1 1.49-.2A4.5 4.5 0 0 0 12.5 8Z"]);
const ArrowCounterclockwise16Regular = /*#__PURE__*/createFluentIcon('ArrowCounterclockwise16Regular', "16", ["M13 8a5 5 0 0 0-9-3h2a.5.5 0 1 1 0 1H2.99a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.53A5.99 5.99 0 0 1 14 8a6 6 0 0 1-11.97.54.5.5 0 0 1 1-.08A5 5 0 0 0 13 8Z"]);

const Book20Regular = /*#__PURE__*/createFluentIcon('Book20Regular', "20", ["M6 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5Zm1 0v1h6V5H7ZM4 4v12c0 1.1.9 2 2 2h9.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1h10a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Zm10-1a1 1 0 0 1 1 1v11H5V4a1 1 0 0 1 1-1h8Z"]);
const BookOpen20Regular = /*#__PURE__*/createFluentIcon('BookOpen20Regular', "20", ["M10 16c-.46.6-1.18 1-2 1H3.5A1.5 1.5 0 0 1 2 15.5v-11C2 3.67 2.67 3 3.5 3H8c.82 0 1.54.4 2 1 .46-.6 1.18-1 2-1h4.5c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5H12a2.5 2.5 0 0 1-2-1ZM3 4.5v11c0 .28.22.5.5.5H8c.83 0 1.5-.67 1.5-1.5v-9C9.5 4.67 8.83 4 8 4H3.5a.5.5 0 0 0-.5.5Zm7.5 10c0 .83.67 1.5 1.5 1.5h4.5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5H12c-.83 0-1.5.67-1.5 1.5v9Z"]);

const ChatHelp20Regular = /*#__PURE__*/createFluentIcon('ChatHelp20Regular', "20", ["M9.25 7.3c-.16.2-.25.44-.25.7a.5.5 0 0 1-1 0 1.95 1.95 0 0 1 2-2 1.95 1.95 0 0 1 2 2c0 .49-.12.87-.3 1.19-.17.28-.38.5-.55.68l-.04.04c-.19.2-.33.35-.43.55-.1.2-.18.45-.18.83a.5.5 0 1 1-1 0 2.71 2.71 0 0 1 .89-2.07l.02-.02c.19-.2.32-.34.42-.51.1-.17.17-.37.17-.69 0-.26-.09-.5-.25-.7A.95.95 0 0 0 10 7c-.36 0-.6.13-.75.3Zm.75 6.91a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4ZM2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A7.97 7.97 0 0 1 2 10Zm8-7a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05A7 7 0 1 0 10 3Z"]);
const CheckmarkStarburst20Regular = /*#__PURE__*/createFluentIcon('CheckmarkStarburst20Regular', "20", ["m8.46 1.9.99.39c.35.14.75.14 1.1 0l.99-.4c1.21-.47 2.58.1 3.1 1.3l.42.97c.16.35.43.62.78.77l.98.43c1.2.52 1.76 1.89 1.28 3.1l-.39.99a1.5 1.5 0 0 0 0 1.1l.4.99a2.42 2.42 0 0 1-1.3 3.1l-.97.42a1.5 1.5 0 0 0-.78.78l-.42.98a2.42 2.42 0 0 1-3.1 1.28l-1-.39a1.5 1.5 0 0 0-1.09 0l-.99.4a2.42 2.42 0 0 1-3.1-1.3l-.43-.97a1.5 1.5 0 0 0-.77-.78l-.98-.42a2.42 2.42 0 0 1-1.28-3.1l.39-1a1.5 1.5 0 0 0 0-1.09l-.4-.99a2.42 2.42 0 0 1 1.3-3.1l.97-.43c.35-.15.62-.42.77-.77l.43-.98a2.42 2.42 0 0 1 3.1-1.28Zm3.44.93-.99.39a2.5 2.5 0 0 1-1.83 0l-.99-.4a1.42 1.42 0 0 0-1.81.76l-.43.98a2.5 2.5 0 0 1-1.3 1.3l-.97.42c-.7.3-1.03 1.1-.75 1.81l.39 1a2.5 2.5 0 0 1 0 1.82l-.4 1c-.27.7.06 1.5.76 1.81l.98.43a2.5 2.5 0 0 1 1.3 1.3l.42.97c.3.7 1.1 1.03 1.81.75l1-.39a2.5 2.5 0 0 1 1.82 0l1 .4c.7.27 1.5-.06 1.81-.76l.43-.98a2.5 2.5 0 0 1 1.3-1.3l.97-.42c.7-.3 1.03-1.1.75-1.82l-.39-.99a2.5 2.5 0 0 1 0-1.83l.4-.99a1.42 1.42 0 0 0-.76-1.81l-.98-.43a2.5 2.5 0 0 1-1.3-1.3l-.42-.97c-.3-.7-1.1-1.03-1.82-.75Zm-2.92 8.94 3.65-4.1a.5.5 0 0 1 .8.59l-.06.07-4 4.5a.5.5 0 0 1-.65.08l-.07-.06-2-2a.5.5 0 0 1 .63-.76l.07.06 1.63 1.62 3.65-4.1-3.65 4.1Z"]);
const ChevronDown16Regular = /*#__PURE__*/createFluentIcon('ChevronDown16Regular', "16", ["M3.15 5.65c.2-.2.5-.2.7 0L8 9.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 0-.7Z"]);
const ChevronUp16Regular = /*#__PURE__*/createFluentIcon('ChevronUp16Regular', "16", ["M3.15 10.35c.2.2.5.2.7 0L8 6.21l4.15 4.14a.5.5 0 0 0 .7-.7l-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 0 .7Z"]);
const Clipboard20Regular = /*#__PURE__*/createFluentIcon('Clipboard20Regular', "20", ["M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1Z"]);

const Copy20Filled = /*#__PURE__*/createFluentIcon('Copy20Filled', "20", ["M6 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4ZM4 6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17h6.23A2 2 0 0 1 12 18H7.5A3.5 3.5 0 0 1 4 14.5V6Z"]);
const Copy20Regular = /*#__PURE__*/createFluentIcon('Copy20Regular', "20", ["M8 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8ZM7 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4ZM4 6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17h6.23A2 2 0 0 1 12 18H7.5A3.5 3.5 0 0 1 4 14.5V6Z"]);

const DocumentHeader20Regular = /*#__PURE__*/createFluentIcon('DocumentHeader20Regular', "20", ["M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6ZM5 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm2 0a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Z"]);

const MailRead20Regular = /*#__PURE__*/createFluentIcon('MailRead20Regular', "20", ["M9.74 2.07a.5.5 0 0 1 .52 0l6.77 4.06A2 2 0 0 1 18 7.85v6.65a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5V7.85a2 2 0 0 1 .97-1.72l6.77-4.06ZM10 3.08 3.49 7 3.47 7 10 10.92 16.53 7h-.02L10 3.07Zm7 4.8-6.74 4.05a.5.5 0 0 1-.52 0L3 7.88v6.62c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V7.88Z"]);
const Mic20Regular = /*#__PURE__*/createFluentIcon('Mic20Regular', "20", ["M10 13a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v5a3 3 0 0 0 3 3Zm0-1a2 2 0 0 1-2-2V5a2 2 0 1 1 4 0v5a2 2 0 0 1-2 2ZM5 9.5c.28 0 .5.22.5.5a4.5 4.5 0 1 0 9 0 .5.5 0 0 1 1 0 5.5 5.5 0 0 1-5 5.48v2.02a.5.5 0 0 1-1 0v-2.02a5.5 5.5 0 0 1-5-5.48c0-.28.22-.5.5-.5Z"]);

const PresenceAvailable10Filled = /*#__PURE__*/createFluentIcon('PresenceAvailable10Filled', "10", ["M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10Zm2.1-5.9L4.85 6.35a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 1.9-1.9a.5.5 0 0 1 .7.71Z"]);
const PresenceAvailable10Regular = /*#__PURE__*/createFluentIcon('PresenceAvailable10Regular', "10", ["M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0ZM1 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm6.1-1.6c.2.2.2.5 0 .7L4.85 6.35a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 1.9-1.9c.2-.19.5-.19.7 0Z"]);
const PresenceAvailable12Filled = /*#__PURE__*/createFluentIcon('PresenceAvailable12Filled', "12", ["M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Zm2.53-6.72L5.78 8.03c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l.47.47 2.22-2.22a.75.75 0 0 1 1.06 1.06Z"]);
const PresenceAvailable12Regular = /*#__PURE__*/createFluentIcon('PresenceAvailable12Regular', "12", ["M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0ZM1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm7.03-1.78c.3.3.3.77 0 1.06L5.78 8.03c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l.47.47 2.22-2.22c.3-.3.77-.3 1.06 0Z"]);
const PresenceAvailable16Filled = /*#__PURE__*/createFluentIcon('PresenceAvailable16Filled', "16", ["M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm3.7-9.3-4 4a1 1 0 0 1-1.41 0l-2-2a1 1 0 1 1 1.42-1.4L7 8.58l3.3-3.3a1 1 0 0 1 1.4 1.42Z"]);
const PresenceAvailable16Regular = /*#__PURE__*/createFluentIcon('PresenceAvailable16Regular', "16", ["M11.7 6.7a1 1 0 0 0-1.4-1.4L7 8.58l-1.3-1.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l4-4ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"]);
const PresenceAvailable20Filled = /*#__PURE__*/createFluentIcon('PresenceAvailable20Filled', "20", ["M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm4.2-11.8-4.5 4.5a1 1 0 0 1-1.4 0l-2-2a1 1 0 1 1 1.4-1.4L9 10.58l3.8-3.8a1 1 0 1 1 1.4 1.42Z"]);
const PresenceAvailable20Regular = /*#__PURE__*/createFluentIcon('PresenceAvailable20Regular', "20", ["M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm12.2-3.2a1 1 0 0 1 0 1.4l-4.5 4.5a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.4L9 10.58l3.8-3.8a1 1 0 0 1 1.4 0Z"]);
const PresenceAway10Filled = /*#__PURE__*/createFluentIcon('PresenceAway10Filled', "10", ["M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10Zm0-7v1.8l1.35 1.35a.5.5 0 1 1-.7.7l-1.5-1.5A.5.5 0 0 1 4 5V3a.5.5 0 0 1 1 0Z"]);
const PresenceAway12Filled = /*#__PURE__*/createFluentIcon('PresenceAway12Filled', "12", ["M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Zm.5-8.75v2.4l1.49 1.28A.75.75 0 1 1 7 8.07l-1.75-1.5A.75.75 0 0 1 5 6V3.25a.75.75 0 0 1 1.5 0Z"]);
const PresenceAway16Filled = /*#__PURE__*/createFluentIcon('PresenceAway16Filled', "16", ["M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm.5-11.5v3.02l2.12 1.7a1 1 0 1 1-1.24 1.56l-2.5-2A1 1 0 0 1 6.5 8V4.5a1 1 0 0 1 2 0Z"]);
const PresenceAway20Filled = /*#__PURE__*/createFluentIcon('PresenceAway20Filled', "20", ["M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-14V9.6l2.7 2.7a1 1 0 0 1-1.4 1.42l-3-3A1 1 0 0 1 8 10V6a1 1 0 1 1 2 0Z"]);
const PresenceBlocked10Regular = /*#__PURE__*/createFluentIcon('PresenceBlocked10Regular', "10", ["M10 5A5 5 0 1 0 0 5a5 5 0 0 0 10 0ZM9 5a4 4 0 0 1-6.45 3.16l5.61-5.61C8.69 3.22 9 4.08 9 5ZM7.45 1.84 1.84 7.45a4 4 0 0 1 5.61-5.61Z"]);
const PresenceBlocked12Regular = /*#__PURE__*/createFluentIcon('PresenceBlocked12Regular', "12", ["M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0Zm-1.5 0c0-.97-.3-1.87-.83-2.6L3.39 9.66A4.5 4.5 0 0 0 10.5 6ZM8.6 2.33a4.5 4.5 0 0 0-6.28 6.28l6.29-6.28Z"]);
const PresenceBlocked16Regular = /*#__PURE__*/createFluentIcon('PresenceBlocked16Regular', "16", ["M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-2 0c0-1.3-.41-2.5-1.1-3.48L4.51 12.9A6 6 0 0 0 14 8Zm-2.52-4.9a6 6 0 0 0-8.37 8.37l8.37-8.36Z"]);
const PresenceBlocked20Regular = /*#__PURE__*/createFluentIcon('PresenceBlocked20Regular', "20", ["M20 10a10 10 0 1 0-20 0 10 10 0 0 0 20 0Zm-2 0a8 8 0 0 1-12.9 6.32L16.31 5.09A7.97 7.97 0 0 1 18 10Zm-3.1-6.32L3.69 14.91A8 8 0 0 1 14.91 3.68Z"]);
const PresenceBusy10Filled = /*#__PURE__*/createFluentIcon('PresenceBusy10Filled', "10", ["M10 5A5 5 0 1 1 0 5a5 5 0 0 1 10 0Z"]);
const PresenceBusy12Filled = /*#__PURE__*/createFluentIcon('PresenceBusy12Filled', "12", ["M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0Z"]);
const PresenceBusy16Filled = /*#__PURE__*/createFluentIcon('PresenceBusy16Filled', "16", ["M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z"]);
const PresenceBusy20Filled = /*#__PURE__*/createFluentIcon('PresenceBusy20Filled', "20", ["M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z"]);
const PresenceDnd10Filled = /*#__PURE__*/createFluentIcon('PresenceDnd10Filled', "10", ["M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10ZM3.5 4.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Z"]);
const PresenceDnd10Regular = /*#__PURE__*/createFluentIcon('PresenceDnd10Regular', "10", ["M5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0ZM1 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm2 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 3 5Z"]);
const PresenceDnd12Filled = /*#__PURE__*/createFluentIcon('PresenceDnd12Filled', "12", ["M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12ZM3.75 5.25h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Z"]);
const PresenceDnd12Regular = /*#__PURE__*/createFluentIcon('PresenceDnd12Regular', "12", ["M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0ZM1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3 6c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 3 6Z"]);
const PresenceDnd16Filled = /*#__PURE__*/createFluentIcon('PresenceDnd16Filled', "16", ["M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM5.25 7h5.5a1 1 0 1 1 0 2h-5.5a1 1 0 1 1 0-2Z"]);
const PresenceDnd16Regular = /*#__PURE__*/createFluentIcon('PresenceDnd16Regular', "16", ["M5.25 7a1 1 0 0 0 0 2h5.5a1 1 0 1 0 0-2h-5.5ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"]);
const PresenceDnd20Filled = /*#__PURE__*/createFluentIcon('PresenceDnd20Filled', "20", ["M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM7 9h6a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2Z"]);
const PresenceDnd20Regular = /*#__PURE__*/createFluentIcon('PresenceDnd20Regular', "20", ["M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm4 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z"]);
const PresenceOffline10Regular = /*#__PURE__*/createFluentIcon('PresenceOffline10Regular', "10", ["M6.85 3.15c.2.2.2.5 0 .7L5.71 5l1.14 1.15a.5.5 0 1 1-.7.7L5 5.71 3.85 6.85a.5.5 0 1 1-.7-.7L4.29 5 3.15 3.85a.5.5 0 1 1 .7-.7L5 4.29l1.15-1.14c.2-.2.5-.2.7 0ZM0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5Zm5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"]);
const PresenceOffline12Regular = /*#__PURE__*/createFluentIcon('PresenceOffline12Regular', "12", ["M8.03 3.97c.3.3.3.77 0 1.06L7.06 6l.97.97a.75.75 0 0 1-1.06 1.06L6 7.06l-.97.97a.75.75 0 0 1-1.06-1.06L4.94 6l-.97-.97a.75.75 0 0 1 1.06-1.06l.97.97.97-.97c.3-.3.77-.3 1.06 0ZM0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6Zm6-4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"]);
const PresenceOffline16Regular = /*#__PURE__*/createFluentIcon('PresenceOffline16Regular', "16", ["M10.7 5.3a1 1 0 0 1 0 1.4L9.42 8l1.3 1.3a1 1 0 0 1-1.42 1.4L8 9.42l-1.3 1.3a1 1 0 0 1-1.4-1.42L6.58 8l-1.3-1.3a1 1 0 0 1 1.42-1.4L8 6.58l1.3-1.3a1 1 0 0 1 1.4 0ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"]);
const PresenceOffline20Regular = /*#__PURE__*/createFluentIcon('PresenceOffline20Regular', "20", ["M13.7 6.3a1 1 0 0 1 0 1.4L11.42 10l2.3 2.3a1 1 0 0 1-1.42 1.4L10 11.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L8.58 10l-2.3-2.3a1 1 0 0 1 1.42-1.4L10 8.58l2.3-2.3a1 1 0 0 1 1.4 0ZM0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"]);
const PresenceOof10Regular = /*#__PURE__*/createFluentIcon('PresenceOof10Regular', "10", ["M5.35 3.85a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7L4.7 5.5h1.8a.5.5 0 1 0 0-1H4.7l.65-.65ZM5 0a5 5 0 1 0 0 10A5 5 0 0 0 5 0ZM1 5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"]);
const PresenceOof12Regular = /*#__PURE__*/createFluentIcon('PresenceOof12Regular', "12", ["M6.28 4.53a.75.75 0 0 0-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 0 0 1.06-1.06l-.72-.72h2.69a.75.75 0 1 0 0-1.5h-2.7l.73-.72ZM6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0ZM1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z"]);
const PresenceOof16Regular = /*#__PURE__*/createFluentIcon('PresenceOof16Regular', "16", ["M8.2 6.2a1 1 0 1 0-1.4-1.4L4.3 7.3a1 1 0 0 0 0 1.4l2.5 2.5a1 1 0 0 0 1.4-1.4L7.42 9H11a1 1 0 1 0 0-2H7.41l.8-.8ZM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z"]);
const PresenceOof20Regular = /*#__PURE__*/createFluentIcon('PresenceOof20Regular', "20", ["M10.7 7.7A1 1 0 1 0 9.28 6.3l-3 3a1 1 0 0 0 0 1.41l3 3a1 1 0 1 0 1.42-1.41l-1.3-1.3H13a1 1 0 1 0 0-2H9.4l1.3-1.29ZM10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"]);
const PresenceUnknown10Regular = /*#__PURE__*/createFluentIcon('PresenceUnknown10Regular', "10", ["M5 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5Z"]);
const PresenceUnknown12Regular = /*#__PURE__*/createFluentIcon('PresenceUnknown12Regular', "12", ["M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6Z"]);
const PresenceUnknown16Regular = /*#__PURE__*/createFluentIcon('PresenceUnknown16Regular', "16", ["M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z"]);
const PresenceUnknown20Regular = /*#__PURE__*/createFluentIcon('PresenceUnknown20Regular', "20", ["M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0Z"]);

const ThumbDislike16Filled = /*#__PURE__*/createFluentIcon('ThumbDislike16Filled', "16", ["M13.1 4.62a3.5 3.5 0 0 0-4.38-2.73L3.77 3.27a2 2 0 0 0-1.43 1.56l-.23 1.2c-.16.87.46 1.64 1.16 1.93.25.1.55.25.85.46a8.22 8.22 0 0 1 3.02 3.92l.28.7c.14.38.28.73.41 1 .11.23.25.46.42.63.19.19.44.33.75.33.36 0 .67-.12.91-.34.24-.2.4-.48.5-.76.22-.55.29-1.25.3-1.9a14.73 14.73 0 0 0-.13-2h.51a2.5 2.5 0 0 0 2.46-2.96l-.46-2.42Z"]);
const ThumbDislike16Regular = /*#__PURE__*/createFluentIcon('ThumbDislike16Regular', "16", ["m10.58 10 .05.45a11 11 0 0 1-.02 2.68c-.07.44-.2.88-.44 1.23-.25.38-.64.64-1.17.64-.52 0-.83-.37-1.02-.7-.2-.31-.36-.75-.54-1.2l-.01-.03c-.55-1.4-1.3-3.31-3.3-4.65-.31-.2-.6-.36-.86-.46-.7-.3-1.32-1.06-1.16-1.94l.23-1.2a2 2 0 0 1 1.43-1.55l4.95-1.38a3.5 3.5 0 0 1 4.37 2.73l.46 2.42A2.5 2.5 0 0 1 11.09 10h-.51Zm1.53-5.2a2.5 2.5 0 0 0-3.13-1.94L4.03 4.23a1 1 0 0 0-.71.78l-.22 1.2c-.06.28.16.66.55.82.31.13.66.31 1.03.55 2.28 1.53 3.13 3.7 3.67 5.11l.01.02c.2.5.33.85.47 1.08A.73.73 0 0 0 9 14c.14 0 .25-.05.35-.2.12-.18.22-.46.28-.83a10.06 10.06 0 0 0-.08-3.12l-.03-.2-.01-.05V9.6A.5.5 0 0 1 10 9h1.09a1.5 1.5 0 0 0 1.47-1.78l-.45-2.42Z"]);
const ThumbDislike20Filled = /*#__PURE__*/createFluentIcon('ThumbDislike20Filled', "20", ["M12.48 18.3c-.8.83-2.09.38-2.43-.6-.28-.8-.64-1.77-1-2.48C8 13.1 7.38 11.9 5.67 10.37c-.23-.2-.52-.36-.84-.49-1.13-.44-2.2-1.61-1.91-3l.35-1.77a2.5 2.5 0 0 1 1.8-1.92l5.6-1.53a4.5 4.5 0 0 1 5.6 3.54l.69 3.76A3 3 0 0 1 14 12.5h-.89l.01.05c.08.41.18.97.24 1.58.07.62.1 1.29.05 1.92a3.68 3.68 0 0 1-.5 1.73c-.11.16-.27.35-.44.52Z"]);
const ThumbDislike20Regular = /*#__PURE__*/createFluentIcon('ThumbDislike20Regular', "20", ["M10.05 17.7c.34.98 1.63 1.43 2.43.6.17-.17.33-.36.44-.52.32-.48.45-1.12.5-1.73.05-.63.02-1.3-.05-1.92-.06-.6-.16-1.17-.24-1.58v-.05H14a3 3 0 0 0 2.95-3.54l-.69-3.76a4.5 4.5 0 0 0-5.6-3.54L5.06 3.2c-.92.25-1.62 1-1.8 1.92l-.35 1.77c-.28 1.39.78 2.56 1.9 3 .33.13.62.3.85.5 1.7 1.5 2.32 2.72 3.38 4.84.36.71.72 1.68 1 2.49Zm1.97-5.58v.04a14.2 14.2 0 0 1 .36 2.08c.06.58.09 1.18.04 1.73-.04.55-.15.98-.33 1.25-.06.1-.18.22-.33.39-.2.2-.63.16-.76-.23-.29-.82-.67-1.83-1.05-2.6-1.07-2.14-1.76-3.5-3.62-5.15-.34-.3-.74-.52-1.13-.68-.88-.34-1.45-1.14-1.3-1.87l.35-1.77c.11-.56.53-1 1.08-1.15l5.6-1.53a3.5 3.5 0 0 1 4.36 2.75l.68 3.76a2 2 0 0 1-1.96 2.36h-1.5a.5.5 0 0 0-.5.62Z"]);
const ThumbLike16Filled = /*#__PURE__*/createFluentIcon('ThumbLike16Filled', "16", ["M9.58 1.05c-.75-.2-1.34.35-1.55.87-.24.6-.45 1.02-.7 1.53-.16.3-.33.65-.53 1.09-.48 1-.95 1.65-1.3 2.04a4.06 4.06 0 0 1-.5.49h-.02L3.11 8.19a2 2 0 0 0-.86 2.43l.52 1.38a2 2 0 0 0 1.28 1.2l5.35 1.69a2.5 2.5 0 0 0 3.15-1.68l1.36-4.65A2 2 0 0 0 12 6h-1.38l.2-.74c.13-.56.24-1.2.23-1.74-.01-.5-.06-1.02-.27-1.46-.22-.48-.6-.83-1.19-1Zm-4.6 6.03Z"]);
const ThumbLike16Regular = /*#__PURE__*/createFluentIcon('ThumbLike16Regular', "16", ["M8.03 1.92c.21-.52.8-1.08 1.55-.87.6.17.97.52 1.2 1 .2.44.25.96.26 1.46a7.5 7.5 0 0 1-.24 1.74c-.06.26-.12.51-.19.74h1.38a2 2 0 0 1 1.92 2.56l-1.36 4.65a2.5 2.5 0 0 1-3.15 1.68L4.05 13.2A2 2 0 0 1 2.77 12l-.52-1.4a2 2 0 0 1 .86-2.42l1.87-1.1.02-.01.1-.09c.1-.07.23-.2.4-.4.35-.39.82-1.03 1.3-2.04.2-.44.37-.78.53-1.1.25-.5.46-.92.7-1.52Zm-2.51 6-.02.01-1.88 1.11a1 1 0 0 0-.43 1.22l.52 1.38a1 1 0 0 0 .64.6l5.35 1.68c.8.26 1.65-.2 1.89-1l1.36-4.65A1 1 0 0 0 12 6.99H9.93a.5.5 0 0 1-.48-.67c.1-.28.26-.77.38-1.3.13-.54.22-1.08.2-1.5 0-.46-.05-.8-.16-1.05a.78.78 0 0 0-.56-.45c-.04-.02-.1-.01-.16.03a.54.54 0 0 0-.19.25c-.25.63-.5 1.11-.76 1.65-.16.3-.32.63-.5 1.01a9.52 9.52 0 0 1-1.45 2.28 5.06 5.06 0 0 1-.7.66l-.02.01-.01.01Zm-.54-.84Z"]);
const ThumbLike20Filled = /*#__PURE__*/createFluentIcon('ThumbLike20Filled', "20", ["M12.48 1.7c-.8-.83-2.09-.38-2.43.6-.28.8-.64 1.77-1 2.48C8 6.9 7.38 8.1 5.67 9.63c-.23.2-.52.36-.84.49-1.13.44-2.2 1.61-1.91 3l.35 1.77a2.5 2.5 0 0 0 1.8 1.92l5.6 1.52a4.5 4.5 0 0 0 5.6-3.53l.69-3.76A3 3 0 0 0 14 7.5h-.89l.01-.05c.08-.41.18-.97.24-1.59.07-.6.1-1.28.05-1.9a3.68 3.68 0 0 0-.5-1.74 4.16 4.16 0 0 0-.44-.52Z"]);
const ThumbLike20Regular = /*#__PURE__*/createFluentIcon('ThumbLike20Regular', "20", ["M10.05 2.3c.34-.98 1.63-1.43 2.43-.6.17.17.33.36.44.52.32.48.45 1.12.5 1.73.05.63.02 1.3-.05 1.91-.06.62-.16 1.18-.24 1.59v.05H14a3 3 0 0 1 2.95 3.54l-.69 3.76a4.5 4.5 0 0 1-5.6 3.53l-5.6-1.52a2.5 2.5 0 0 1-1.8-1.92l-.35-1.77c-.28-1.39.78-2.56 1.9-3 .33-.13.62-.3.85-.5 1.7-1.5 2.32-2.72 3.38-4.84.36-.71.72-1.68 1-2.49Zm1.97 5.58v-.04a13.7 13.7 0 0 0 .13-.58c.08-.4.17-.93.23-1.5.06-.58.09-1.18.04-1.73a2.73 2.73 0 0 0-.33-1.25 3.26 3.26 0 0 0-.33-.39c-.2-.2-.63-.16-.76.23-.29.82-.67 1.83-1.05 2.6-1.07 2.14-1.76 3.5-3.62 5.15-.34.3-.74.52-1.13.68-.88.34-1.45 1.14-1.3 1.87l.35 1.77c.11.56.53 1 1.08 1.15l5.6 1.53c1.98.54 4-.73 4.36-2.75l.68-3.76a2 2 0 0 0-1.96-2.36h-1.5a.5.5 0 0 1-.5-.62Z"]);

const iconFilledClassName = "fui-Icon-filled";
const iconRegularClassName = "fui-Icon-regular";

const useBundledIconStyles = __styles({
  "root": {
    "mc9l5x": "fjseox"
  },
  "visible": {
    "mc9l5x": "f1w7gpdv"
  }
}, {
  "d": [".fjseox{display:none;}", ".f1w7gpdv{display:inline;}"]
});
const bundleIcon = (FilledIcon, RegularIcon) => {
  const Component = props => {
    const {
      className,
      filled,
      ...rest
    } = props;
    const styles = useBundledIconStyles();
    return React.createElement(React.Fragment, null, React.createElement(FilledIcon, Object.assign({}, rest, {
      className: mergeClasses(styles.root, filled && styles.visible, iconFilledClassName, className)
    })), React.createElement(RegularIcon, Object.assign({}, rest, {
      className: mergeClasses(styles.root, !filled && styles.visible, iconRegularClassName, className)
    })));
  };
  Component.displayName = "CompoundIcon";
  return Component;
};

/**
 * Creates a CSS rule from a theme object.
 *
 * Useful for scenarios when you want to apply theming statically to a top level elements like `body`.
 */ function createCSSRuleFromTheme(selector, theme) {
    if (theme) {
        const cssVarsAsString = Object.keys(theme).reduce((cssVarRule, cssVar)=>{
            return `${cssVarRule}--${cssVar}: ${theme[cssVar]}; `;
        }, '');
        return `${selector} { ${cssVarsAsString} }`;
    }
    return `${selector} {}`;
}

/**
 * @internal
 * Internal reference for the render function
 */ const SLOT_RENDER_FUNCTION_SYMBOL = Symbol.for('fui.slotRenderFunction');
/**
 * @internal
 * Internal reference for the render function
 */ const SLOT_ELEMENT_TYPE_SYMBOL = Symbol.for('fui.slotElementType');

/**
 * Creates a slot from a slot shorthand or properties (`props.SLOT_NAME` or `props` itself)
 * @param value - the value of the slot, it can be a slot shorthand, a slot component or a slot properties
 * @param options - values you can pass to alter the signature of a slot, those values are:
 *
 * * `elementType` - the base element type of a slot, defaults to `'div'`
 * * `defaultProps` - similar to a React component declaration, you can provide a slot default properties to be merged with the shorthand/properties provided.
 */ function always(value, options) {
    const { defaultProps, elementType } = options;
    const props = resolveShorthand$1(value);
    /**
   * Casting is required here as SlotComponentType is a function, not an object.
   * Although SlotComponentType has a function signature, it is still just an object.
   * This is required to make a slot callable (JSX compatible), this is the exact same approach
   * that is used on `@types/react` components
   */ const propsWithMetadata = {
        ...defaultProps,
        ...props,
        [SLOT_ELEMENT_TYPE_SYMBOL]: elementType
    };
    if (props && typeof props.children === 'function') {
        propsWithMetadata[SLOT_RENDER_FUNCTION_SYMBOL] = props.children;
        propsWithMetadata.children = defaultProps === null || defaultProps === undefined ? undefined : defaultProps.children;
    }
    return propsWithMetadata;
}
/**
 * Creates a slot from a slot shorthand or properties (`props.SLOT_NAME` or `props` itself)
 * @param value - the value of the slot, it can be a slot shorthand, a slot component or a slot properties
 * @param options - values you can pass to alter the signature of a slot, those values are:
 *
 * * `elementType` - the base element type of a slot, defaults to `'div'`
 * * `defaultProps` - similar to a React component declaration, you can provide a slot default properties to be merged with the shorthand/properties provided
 * * `renderByDefault` - a boolean that indicates if a slot will be rendered even if it's base value is `undefined`.
 * By default if `props.SLOT_NAME` is `undefined` then `state.SLOT_NAME` becomes `undefined`
 * and nothing will be rendered, but if `renderByDefault = true` then `state.SLOT_NAME` becomes an object
 * with the values provided by `options.defaultProps` (or `{}`). This is useful for cases such as providing a default content
 * in case no shorthand is provided, like the case of the `expandIcon` slot for the `AccordionHeader`
 */ function optional(value, options) {
    if (value === null || value === undefined && !options.renderByDefault) {
        return undefined;
    }
    return always(value, options);
}
/**
 * Helper function that converts a slot shorthand or properties to a slot properties object
 * The main difference between this function and `slot` is that this function does not return the metadata required for a slot to be considered a properly renderable slot, it only converts the value to a slot properties object
 * @param value - the value of the slot, it can be a slot shorthand or a slot properties object
 */ function resolveShorthand$1(value) {
    if (typeof value === 'string' || typeof value === 'number' || Array.isArray(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    React.isValidElement(value)) {
        return {
            children: value
        };
    }
    if (value && typeof value !== 'object' && process.env.NODE_ENV !== 'production') {
        // TODO: would be nice to have a link to slot documentation in this error message
        // eslint-disable-next-line no-console
        console.error(`@fluentui/react-utilities [slot.${resolveShorthand$1.name}]:
A slot got an invalid value "${value}" (${typeof value}).
A valid value for a slot is a slot shorthand or slot properties object.
Slot shorthands can be strings, numbers, arrays or JSX elements`);
    }
    return value;
}

/**
 * Guard method that validates if a shorthand is a slot
 * can be used to extends properties provided by a slot
 *
 * @example
 * ```
 * const backdropSlot = resolveShorthand(backdrop, {
 *  defaultProps: {
 *    onClick: useEventCallback(event => {
 *     if (isResolvedShorthand(backdrop)) {
 *        backdrop.onClick?.(event)
 *      }
 *      // do something after passing click down the line
 *    }),
 *  },
 * })
 * ```
 * @example
 * ```
 * const handleBackDropClick = (event) => {
 *  // do your thing
 * }
 * const backdropSlot = resolveShorthand(backdrop, {
 *  defaultProps: {
 *    onClick: useEventCallback(
 *      mergeCallbacks(isResolvedShorthand(backdrop) ? backdrop.onClick : undefined, handleBackdropClick)
 *    )
 * })
 * ```
 */ function isResolvedShorthand(shorthand) {
    return shorthand !== null && typeof shorthand === 'object' && !Array.isArray(shorthand) && !React.isValidElement(shorthand);
}

/**
 * Guard method to ensure a given element is a slot.
 * This is mainly used internally to ensure a slot is being used as a component.
 */ function isSlot(element) {
    return Boolean(element === null || element === undefined ? undefined : element.hasOwnProperty(SLOT_ELEMENT_TYPE_SYMBOL));
}

/**
 * @internal
 * Assertion method to ensure state slots properties are properly declared.
 * A properly declared slot must be declared by using the `slot` method.
 *
 * @example
 * ```tsx
 * export const renderInput_unstable = (state: InputState) => {
    assertSlots<InputSlots>(state);
    return (
      <state.root>
        {state.contentBefore && <state.contentBefore />}
        <state.input />
        {state.contentAfter && <state.contentAfter />}
      </state.root>
    );
  };
 * ```
 */ function assertSlots(state) {
    /**
   * This verification is not necessary in production
   * as we're verifying static properties that will not change between environments
   */ if (process.env.NODE_ENV !== 'production') {
        const typedState = state;
        for (const slotName of Object.keys(typedState.components)){
            const slotElement = typedState[slotName];
            if (slotElement === undefined) {
                continue;
            }
            // this means a slot is being declared without using, slot.always or slot.optional or even resolveShorthand on the state hook,
            // but the render method is using the new `assertSlots` method. That scenario can be solved by simply updating the slot element with the proper element type
            // FIXME: this slot will still fail to support child render function scenario
            if (!isSlot(slotElement)) {
                typedState[slotName] = always(slotElement, {
                    elementType: typedState.components[slotName]
                });
                // eslint-disable-next-line no-console
                console.warn(`@fluentui/react-utilities [${assertSlots.name}]:
"state.${slotName}" is not a slot!
Be sure to create slots properly by using "slot.always" or "slot.optional".`);
            } else {
                // This means a slot is being declared by using resolveShorthand on the state hook,
                // but the render method is using the new `assertSlots` method. That scenario can be solved by simply updating the slot element with the proper element type
                const { [SLOT_ELEMENT_TYPE_SYMBOL]: elementType } = slotElement;
                if (elementType !== typedState.components[slotName]) {
                    slotElement[SLOT_ELEMENT_TYPE_SYMBOL] = typedState.components[slotName];
                    // eslint-disable-next-line no-console
                    console.warn(`@fluentui/react-utilities [${assertSlots.name}]:
"state.${slotName}" element type differs from "state.components.${slotName}",
${elementType} !== ${typedState.components[slotName]}.
Be sure to create slots properly by using "slot.always" or "slot.optional" with the correct elementType.`);
                }
            }
        }
    }
}

const toObjectMap = (...items)=>{
    const result = {};
    for (const item of items){
        const keys = Array.isArray(item) ? item : Object.keys(item);
        for (const key of keys){
            result[key] = 1;
        }
    }
    return result;
};
/**
 * An array of events that are allowed on every html element type.
 *
 * @public
 */ const baseElementEvents = toObjectMap([
    'onAuxClick',
    'onAnimationEnd',
    'onAnimationStart',
    'onCopy',
    'onCut',
    'onPaste',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onInput',
    'onSubmit',
    'onLoad',
    'onError',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyUp',
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onScroll',
    'onWheel',
    'onPointerCancel',
    'onPointerDown',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerMove',
    'onPointerOut',
    'onPointerOver',
    'onPointerUp',
    'onGotPointerCapture',
    'onLostPointerCapture'
]);
/**
 * An array of element attributes which are allowed on every html element type.
 *
 * @public
 */ const baseElementProperties = toObjectMap([
    'accessKey',
    'children',
    'className',
    'contentEditable',
    'dir',
    'draggable',
    'hidden',
    'htmlFor',
    'id',
    'lang',
    'ref',
    'role',
    'style',
    'tabIndex',
    'title',
    'translate',
    'spellCheck',
    'name'
]);
/**
 * An array of microdata attributes that are allowed on every html element type.
 *
 * @public
 */ const microdataProperties = toObjectMap([
    'itemID',
    'itemProp',
    'itemRef',
    'itemScope',
    'itemType'
]);
/**
 * An array of HTML element properties and events.
 *
 * @public
 */ const htmlElementProperties = toObjectMap(baseElementProperties, baseElementEvents, microdataProperties);
/**
 * An array of LABEL tag properties and events.
 *
 * @public
 */ const labelProperties = toObjectMap(htmlElementProperties, [
    'form'
]);
/**
 * An array of AUDIO tag properties and events.

 * @public
 */ const audioProperties = toObjectMap(htmlElementProperties, [
    'height',
    'loop',
    'muted',
    'preload',
    'src',
    'width'
]);
/**
 * An array of VIDEO tag properties and events.
 *
 * @public
 */ const videoProperties = toObjectMap(audioProperties, [
    'poster'
]);
/**
 * An array of OL tag properties and events.
 *
 * @public
 */ const olProperties = toObjectMap(htmlElementProperties, [
    'start'
]);
/**
 * An array of LI tag properties and events.
 *
 * @public
 */ const liProperties = toObjectMap(htmlElementProperties, [
    'value'
]);
/**
 * An array of A tag properties and events.
 *
 * @public
 */ const anchorProperties = toObjectMap(htmlElementProperties, [
    'download',
    'href',
    'hrefLang',
    'media',
    'rel',
    'target',
    'type'
]);
/**
 * An array of TIME tag properties and events.
 *
 * @public
 */ const timeProperties = toObjectMap(htmlElementProperties, [
    'dateTime'
]);
/**
 * An array of BUTTON tag properties and events.
 *
 * @public
 */ const buttonProperties = toObjectMap(htmlElementProperties, [
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'type',
    'value'
]);
/**
 * An array of INPUT tag properties and events.
 *
 * @public
 */ const inputProperties = toObjectMap(buttonProperties, [
    'accept',
    'alt',
    'autoCapitalize',
    'autoComplete',
    'checked',
    'dirname',
    'form',
    'height',
    'inputMode',
    'list',
    'max',
    'maxLength',
    'min',
    'multiple',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'src',
    'step',
    'size',
    'type',
    'value',
    'width'
]);
/**
 * An array of TEXTAREA tag properties and events.
 *
 * @public
 */ const textAreaProperties = toObjectMap(buttonProperties, [
    'autoCapitalize',
    'cols',
    'dirname',
    'form',
    'maxLength',
    'placeholder',
    'readOnly',
    'required',
    'rows',
    'wrap'
]);
/**
 * An array of SELECT tag properties and events.
 *
 * @public
 */ const selectProperties = toObjectMap(buttonProperties, [
    'form',
    'multiple',
    'required'
]);
const optionProperties = toObjectMap(htmlElementProperties, [
    'selected',
    'value'
]);
/**
 * An array of TABLE tag properties and events.
 *
 * @public
 */ const tableProperties = toObjectMap(htmlElementProperties, [
    'cellPadding',
    'cellSpacing'
]);
/**
 * An array of TR tag properties and events.
 *
 * @public
 */ const trProperties = htmlElementProperties;
/**
 * An array of TH tag properties and events.
 *
 * @public
 */ const thProperties = toObjectMap(htmlElementProperties, [
    'colSpan',
    'rowSpan',
    'scope'
]);
/**
 * An array of TD tag properties and events.
 *
 * @public
 */ const tdProperties = toObjectMap(htmlElementProperties, [
    'colSpan',
    'headers',
    'rowSpan',
    'scope'
]);
const colGroupProperties = toObjectMap(htmlElementProperties, [
    'span'
]);
const colProperties = toObjectMap(htmlElementProperties, [
    'span'
]);
/**
 * An array of FIELDSET tag properties and events.
 *
 * @public
 */ const fieldsetProperties = toObjectMap(htmlElementProperties, [
    'disabled',
    'form'
]);
/**
 * An array of FORM tag properties and events.
 *
 * @public
 */ const formProperties = toObjectMap(htmlElementProperties, [
    'acceptCharset',
    'action',
    'encType',
    'encType',
    'method',
    'noValidate',
    'target'
]);
/**
 * An array of IFRAME tag properties and events.
 *
 * @public
 */ const iframeProperties = toObjectMap(htmlElementProperties, [
    'allow',
    'allowFullScreen',
    'allowPaymentRequest',
    'allowTransparency',
    'csp',
    'height',
    'importance',
    'referrerPolicy',
    'sandbox',
    'src',
    'srcDoc',
    'width'
]);
/**
 * An array of IMAGE tag properties and events.
 *
 * @public
 */ const imgProperties = toObjectMap(htmlElementProperties, [
    'alt',
    'crossOrigin',
    'height',
    'src',
    'srcSet',
    'useMap',
    'width'
]);
/**
 * An array of DIALOG tag properties and events.
 *
 * @public
 */ const dialogProperties = toObjectMap(htmlElementProperties, [
    'open',
    'onCancel',
    'onClose'
]);
/**
 * Gets native supported props for an html element provided the allowance set. Use one of the property
 * sets defined (divProperties, buttonPropertes, etc) to filter out supported properties from a given
 * props set. Note that all data- and aria- prefixed attributes will be allowed.
 * NOTE: getNativeProps should always be applied first when adding props to a react component. The
 * non-native props should be applied second. This will prevent getNativeProps from overriding your custom props.
 * For example, if props passed to getNativeProps has an onClick function and getNativeProps is added to
 * the component after an onClick function is added, then the getNativeProps onClick will override it.
 *
 * @public
 * @param props - The unfiltered input props
 * @param allowedPropNames - The array or record of allowed prop names.
 * @param excludedPropNames
 * @returns The filtered props
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getNativeProps(// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, allowedPropNames, excludedPropNames) {
    // It'd be great to properly type this while allowing 'aria-` and 'data-' attributes like TypeScript does for
    // JSX attributes, but that ability is hardcoded into the TS compiler with no analog in TypeScript typings.
    // Then we'd be able to enforce props extends native props (including aria- and data- attributes), and then
    // return native props.
    // We should be able to do this once this PR is merged: https://github.com/microsoft/TypeScript/pull/26797
    const isArray = Array.isArray(allowedPropNames);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    const keys = Object.keys(props);
    for (const key of keys){
        const isNativeProp = !isArray && allowedPropNames[key] || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf('data-') === 0 || key.indexOf('aria-') === 0;
        if (isNativeProp && (!excludedPropNames || (excludedPropNames === null || excludedPropNames === undefined ? undefined : excludedPropNames.indexOf(key)) === -1)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result[key] = props[key];
        }
    }
    return result;
}

const nativeElementMap = {
    label: labelProperties,
    audio: audioProperties,
    video: videoProperties,
    ol: olProperties,
    li: liProperties,
    a: anchorProperties,
    button: buttonProperties,
    input: inputProperties,
    textarea: textAreaProperties,
    select: selectProperties,
    option: optionProperties,
    table: tableProperties,
    tr: trProperties,
    th: thProperties,
    td: tdProperties,
    colGroup: colGroupProperties,
    col: colProperties,
    fieldset: fieldsetProperties,
    form: formProperties,
    iframe: iframeProperties,
    img: imgProperties,
    time: timeProperties,
    dialog: dialogProperties
};
/**
 * Given an element tagname and user props, filters the props to only allowed props for the given
 * element type.
 * @param tagName - Tag name (e.g. "div")
 * @param props - Props object
 * @param excludedPropNames - List of props to disallow
 *
 * @deprecated use getIntrinsicElementProps instead, it is a type-safe version of this method
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getNativeElementProps(tagName, props, excludedPropNames) {
    const allowedPropNames = tagName && nativeElementMap[tagName] || htmlElementProperties;
    allowedPropNames.as = 1;
    return getNativeProps(props, allowedPropNames, excludedPropNames);
}
/**
 * Splits the native props into ones that go to the `root` slot, and ones that go to the primary slot.
 *
 * This function is only for use with components that have a primary slot other than `root`.
 * Most components should use {@link getNativeElementProps} for their root slot if it is the primary slot.
 *
 * @returns An object containing the native props for the `root` and primary slots.
 */ const getPartitionedNativeProps = ({ primarySlotTagName, props, excludedPropNames })=>{
    return {
        root: {
            style: props.style,
            className: props.className
        },
        // eslint-disable-next-line deprecation/deprecation
        primary: getNativeElementProps(primarySlotTagName, props, [
            ...excludedPropNames || [],
            'style',
            'className'
        ])
    };
};

/**
 * Given an element tagname and user props, filters the props to only allowed props for the given
 * element type.
 *
 * Equivalent to {@link getNativeElementProps}, but more type-safe.
 */ const getIntrinsicElementProps = (/** The slot's default element type (e.g. 'div') */ tagName, /** The component's props object */ props, /** List of native props to exclude from the returned value */ excludedPropNames)=>{
    var _props_as;
    // eslint-disable-next-line deprecation/deprecation
    return getNativeElementProps((_props_as = props.as) !== null && _props_as !== undefined ? _props_as : tagName, props, excludedPropNames);
};

/**
 *
 * Resolves shorthands into slot props, to ensure normalization of the signature
 * being passed down to getSlots method
 * @param value - the base shorthand props
 * @param options - options to resolve shorthand props
 *
 * @deprecated use slot.always or slot.optional combined with assertSlots instead
 */ // eslint-disable-next-line deprecation/deprecation
const resolveShorthand = (value, options)=>optional(value, {
        ...options,
        renderByDefault: options === null || options === undefined ? undefined : options.required,
        // elementType as undefined is the way to identify between a slot and a resolveShorthand call
        // in the case elementType is undefined assertSlots will fail, ensuring it'll only work with slot method.
        elementType: undefined
    });

/**
 * @internal
 * Helper to manage a browser timer.
 * Ensures that the timer isn't set multiple times at once,
 * and is cleaned up when the component is unloaded.
 *
 * @param setTimer - The timer setter function
 * @param cancelTimer - The timer cancel function
 * @returns A pair of [setTimer, cancelTimer] that are stable between renders.
 *
 * @example
 * const [setTimer, cancelTimer] = useBrowserTimer(setTimeout, cancelTimeout);
 *
 * setTimer(() => console.log('Hello world!'), 1000);
 * cancelTimer();
 */ function useBrowserTimer(setTimer, cancelTimer) {
    const id = React.useRef(undefined);
    const set = React.useCallback((fn, delay)=>{
        if (id.current !== undefined) {
            cancelTimer(id.current);
        }
        id.current = setTimer(fn, delay);
        return id.current;
    }, [
        cancelTimer,
        setTimer
    ]);
    const cancel = React.useCallback(()=>{
        if (id.current !== undefined) {
            cancelTimer(id.current);
            id.current = undefined;
        }
    }, [
        cancelTimer
    ]);
    // Clean up the timeout when the component is unloaded
    React.useEffect(()=>cancel, [
        cancel
    ]);
    return [
        set,
        cancel
    ];
}

/**
 * @internal
 */ const ThemeContext = React.createContext(undefined);
/**
 * @internal
 */ const ThemeProvider = ThemeContext.Provider;

/**
 * @internal
 * Used to provide a CSS class that applies theme css variables
 *
 * Useful for elements in the React tree (can read context) but not in the DOM Tree. E.g. Portals
 */ const ThemeClassNameContext = React.createContext(undefined);
const themeClassNameContextDefaultVaue = '';
const ThemeClassNameProvider = ThemeClassNameContext.Provider;
/**
 * @returns CSS class that applies css variables
 */ function useThemeClassName() {
    var _React_useContext;
    return (_React_useContext = React.useContext(ThemeClassNameContext)) !== null && _React_useContext !== undefined ? _React_useContext : themeClassNameContextDefaultVaue;
}

/**
 * @internal
 * Context shared by all of the tooltips in the app
 */ const TooltipVisibilityContext = React.createContext(undefined);
const tooltipVisibilityContextDefaultValue = {};
/**
 * @internal
 */ const TooltipVisibilityProvider = TooltipVisibilityContext.Provider;
function useTooltipVisibility() {
    var _React_useContext;
    return (_React_useContext = React.useContext(TooltipVisibilityContext)) !== null && _React_useContext !== undefined ? _React_useContext : tooltipVisibilityContextDefaultValue;
}

const ProviderContext = React.createContext(undefined);
const providerContextDefaultValue = {
  // eslint-disable-next-line @nx/workspace-no-restricted-globals -- expected ignore ( SSR friendly acquisition of globals )
  targetDocument: typeof document === "object" ? document : undefined,
  dir: "ltr"
};
const Provider = ProviderContext.Provider;
function useFluent() {
  var _React_useContext;
  return (_React_useContext = React.useContext(ProviderContext)) !== null && _React_useContext !== undefined ? _React_useContext : providerContextDefaultValue;
}

/**
 * @internal
 */ const OverridesContext = React.createContext(undefined);
/**
 * @internal
 */ const OverridesProvider = OverridesContext.Provider;
function useOverrides() {
    var _React_useContext;
    return (_React_useContext = React.useContext(OverridesContext)) !== null && _React_useContext !== undefined ? _React_useContext : {};
}

/**
 * @internal
 */ const CustomStyleHooksContext$1 = React.createContext(undefined);
const noop$5 = ()=>{};
/**
 * @internal
 */ const CustomStyleHooksProvider$1 = CustomStyleHooksContext$1.Provider;
/**
 * Gets a custom style hook
 * @param hook - One of the hook properties in CustomStyleHooksContextValue
 * @returns The corresponding hook when defined, otherwise a no-op function.
 */ const useCustomStyleHook$1 = (hook)=>{
    var _React_useContext;
    var _React_useContext_hook;
    return (_React_useContext_hook = (_React_useContext = React.useContext(CustomStyleHooksContext$1)) === null || _React_useContext === undefined ? undefined : _React_useContext[hook]) !== null && _React_useContext_hook !== undefined ? _React_useContext_hook : noop$5;
};

/**
 * Provides a mount node for portals to render into.
 *
 * @internal
 */ const PortalMountNodeContext = React.createContext(undefined);
/**
 * @internal
 */ PortalMountNodeContext.Provider;
function usePortalMountNode$1() {
    return React.useContext(PortalMountNodeContext);
}

/**
 * @internal
 */ const AnnounceContext = React.createContext(undefined);
const AnnounceProvider = AnnounceContext.Provider;
/**
 * Returns a function that can be used to announce messages to screen readers.
 */ function useAnnounce$1() {
    var _React_useContext;
    return (_React_useContext = React.useContext(AnnounceContext)) !== null && _React_useContext !== undefined ? _React_useContext : {
        announce: ()=>undefined
    };
}

function isFactoryDispatch(newState) {
    return typeof newState === 'function';
}
/**
 * @internal
 *
 * A [`useState`](https://reactjs.org/docs/hooks-reference.html#usestate)-like hook
 * to manage a value that could be either `controlled` or `uncontrolled`,
 * such as a checked state or text input string.
 *
 * @see https://react.dev/learn/sharing-state-between-components#controlled-and-uncontrolled-components for more details on `controlled`/`uncontrolled`
 *
 * @returns an array of the current value and an updater (dispatcher) function.
 * The updater function is referentially stable (won't change during the component's lifecycle).
 * It can take either a new value, or a function which is passed the previous value and returns the new value.
 *
 * ❗️❗️ Calls to the dispatcher will only modify the state if the state is `uncontrolled`.
 * Meaning that if a state is `controlled`, calls to the dispatcher do not modify the state.
 *
 */ const useControllableState = (options)=>{
    'use no memo';
    if (process.env.NODE_ENV !== 'production') {
        if (options.state !== undefined && options.defaultState !== undefined) {
            // eslint-disable-next-line no-console
            console.error(`@fluentui/react-utilities [useControllableState]:
A component must be either controlled or uncontrolled (specify either the state or the defaultState, but not both).
Decide between using a controlled or uncontrolled component and remove one of this props.
More info: https://reactjs.org/link/controlled-components
${new Error().stack}`);
        }
    }
    const [internalState, setInternalState] = React.useState(()=>{
        if (options.defaultState === undefined) {
            return options.initialState;
        }
        return isInitializer(options.defaultState) ? options.defaultState() : options.defaultState;
    });
    // Heads up!
    // This part is specific for controlled mode and mocks behavior of React dispatcher function.
    const stateValueRef = React.useRef(options.state);
    React.useEffect(()=>{
        stateValueRef.current = options.state;
    }, [
        options.state
    ]);
    const setControlledState = React.useCallback((newState)=>{
        if (isFactoryDispatch(newState)) {
            newState(stateValueRef.current);
        }
    }, []);
    return useIsControlled(options.state) ? [
        options.state,
        setControlledState
    ] : [
        internalState,
        setInternalState
    ];
};
function isInitializer(value) {
    return typeof value === 'function';
}
/**
 * Helper hook to handle previous comparison of controlled/uncontrolled
 * Prints an error when isControlled value switches between subsequent renders
 * @returns - whether the value is controlled
 */ const useIsControlled = (controlledValue)=>{
    'use no memo';
    const [isControlled] = React.useState(()=>controlledValue !== undefined);
    if (process.env.NODE_ENV !== 'production') {
        // We don't want these warnings in production even though it is against native behaviour
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(()=>{
            if (isControlled !== (controlledValue !== undefined)) {
                const error = new Error();
                const controlWarning = isControlled ? 'a controlled value to be uncontrolled' : 'an uncontrolled value to be controlled';
                const undefinedWarning = isControlled ? 'defined to an undefined' : 'undefined to a defined';
                // eslint-disable-next-line no-console
                console.error(`@fluentui/react-utilities [useControllableState]:
A component is changing ${controlWarning}. This is likely caused by the value changing from ${undefinedWarning} value, which should not happen.
Decide between using a controlled or uncontrolled input element for the lifetime of the component.
More info: https://reactjs.org/link/controlled-components
${error.stack}`);
            }
        }, [
            isControlled,
            controlledValue
        ]);
    }
    return isControlled;
};

function canUseDOM() {
  return (
    /* eslint-disable @nx/workspace-no-restricted-globals -- expected ignore ( SSR friendly acquisition of globals )*/
    typeof window !== "undefined" && !!(window.document && // eslint-disable-next-line deprecation/deprecation
    window.document.createElement)
  );
}

/**
 * Default context value to use in case there is no SSRProvider. This is fine for client-only apps.
 *
 * @internal
 */ const defaultSSRContextValue = {
    current: 0
};
const SSRContext = /*#__PURE__*/ React.createContext(undefined);
/**
 * @internal
 */ function useSSRContext() {
    var _React_useContext;
    return (_React_useContext = React.useContext(SSRContext)) !== null && _React_useContext !== undefined ? _React_useContext : defaultSSRContextValue;
}
/**
 * Returns whether the component is currently being server side rendered or hydrated on the client. Can be used to delay
 * browser-specific rendering until after hydration. May cause re-renders on a client when is used within SSRProvider.
 */ function useIsSSR() {
    const isInSSRContext = useSSRContext() !== defaultSSRContextValue;
    const [isSSR, setIsSSR] = React.useState(isInSSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider, provide a warning to hint to the
    // developer to add one.
    if (process.env.NODE_ENV !== 'production') {
        if (!isInSSRContext && !canUseDOM()) {
            // eslint-disable-next-line no-console
            console.error(`@fluentui/react-components [${useIsSSR.name}]:
When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.


Check documentation at https://aka.ms/fluentui-ssr.`);
        }
    }
    // If on the client, and the component was initially server rendered, then schedule a layout effect to update the
    // component after hydration.
    if (canUseDOM() && isInSSRContext) {
        // This if statement technically breaks the rules of hooks, but is safe because the condition never changes after
        // mounting.
        // eslint-disable-next-line
        React.useLayoutEffect(()=>{
            setIsSSR(false);
        }, []);
    }
    return isSSR;
}

/**
 * React currently throws a warning when using useLayoutEffect on the server. To get around it, we can conditionally
 * useEffect on the server (no-op) and useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also need affected components to render on
 * the server.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 */ // eslint-disable-next-line no-restricted-properties
const useIsomorphicLayoutEffect = canUseDOM() ? React.useLayoutEffect : React.useEffect;

/**
 * @internal
 * https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 *
 * Modified `useCallback` that can be used when dependencies change too frequently. Can occur when
 * e.g. user props are dependencies which could change on every render
 * e.g. volatile values (i.e. useState/useDispatch) are dependencies which could change frequently
 *
 * This should not be used often, but can be a useful re-render optimization since the callback is a ref and
 * will not be invalidated between re-renders
 *
 * @param fn - The callback function that will be used
 */ const useEventCallback = (fn)=>{
    const callbackRef = React.useRef(()=>{
        throw new Error('Cannot call an event handler while rendering');
    });
    useIsomorphicLayoutEffect(()=>{
        callbackRef.current = fn;
    }, [
        fn
    ]);
    return React.useCallback((...args)=>{
        const callback = callbackRef.current;
        return callback(...args);
    }, [
        callbackRef
    ]);
};

/**
 * @internal
 * Checks if components was mounted the first time.
 * Since concurrent mode will be released in the future this needs to be verified
 * Currently (React 17) will always render the initial mount once
 * https://codesandbox.io/s/heuristic-brook-s4w0q?file=/src/App.jsx
 * https://codesandbox.io/s/holy-grass-8nieu?file=/src/App.jsx
 *
 * @example
 * const isFirstMount = useFirstMount();
 */ function useFirstMount() {
    const isFirst = React.useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

const IdPrefixContext = React.createContext(undefined);
/**
 * Allows to define a prefix that will be used for all IDs generated by useId() hook. It's useful to avoid collisions
 * between different bundles.
 */ IdPrefixContext.Provider;
function useIdPrefix() {
    return React.useContext(IdPrefixContext) || '';
}
/**
 * Hook to generate a unique ID.
 *
 * @param prefix - Optional prefix for the ID. Defaults to 'fui-'.
 * @param providedId - Optional id provided by a parent component. Defaults to the provided value if present,
 *  without conditioning the hook call
 * @returns The ID
 */ function useId(prefix = 'fui-', providedId) {
    'use no memo';
    const contextValue = useSSRContext();
    const idPrefix = useIdPrefix();
    // Checking if useId is available on React, if it is, we use it to generate the id. String concatenation is used to
    // prevent bundlers from complaining with older versions of React.
    const _useId = React['use' + 'Id'];
    if (_useId) {
        const generatedId = _useId();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const escapedId = React.useMemo(()=>generatedId.replace(/:/g, ''), [
            generatedId
        ]);
        return providedId || `${idPrefix}${prefix}${escapedId}`;
    }
    // Hooks appear to be running conditionally, but they will always run in the same order since it's based on
    // the version of React being used. This is safe to ignore.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useMemo(()=>{
        if (providedId) {
            return providedId;
        }
        return `${idPrefix}${prefix}${++contextValue.current}`;
    }, [
        idPrefix,
        prefix,
        providedId,
        contextValue
    ]);
}

/**
 * React hook to merge multiple React refs (either MutableRefObjects or ref callbacks) into a single ref callback that
 * updates all provided refs
 * @param refs - Refs to collectively update with one ref value.
 * @returns A function with an attached "current" prop, so that it can be treated like a RefObject.
 */ function useMergedRefs(...refs) {
    'use no memo';
    const mergedCallback = React.useCallback((value)=>{
        // Update the "current" prop hanging on the function.
        mergedCallback.current = value;
        for (const ref of refs){
            if (typeof ref === 'function') {
                ref(value);
            } else if (ref) {
                // work around the immutability of the React.Ref type
                ref.current = value;
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- already exhaustive
    [
        ...refs
    ]);
    return mergedCallback;
}

const DEFAULT_CONTAINS = (parent, child)=>!!(parent === null || parent === undefined ? undefined : parent.contains(child));
/**
 * @internal
 * Utility to perform checks where a click/touch event was made outside a component
 */ const useOnClickOutside = (options)=>{
    const { targetDocument } = useFluent();
    const win = targetDocument === null || targetDocument === undefined ? undefined : targetDocument.defaultView;
    const { refs, callback, element, disabled, disabledFocusOnIframe, contains = DEFAULT_CONTAINS } = options;
    const timeoutId = React.useRef(undefined);
    useIFrameFocus({
        element,
        disabled: disabledFocusOnIframe || disabled,
        callback,
        refs,
        contains
    });
    const isMouseDownInsideRef = React.useRef(false);
    const listener = useEventCallback((ev)=>{
        if (isMouseDownInsideRef.current) {
            isMouseDownInsideRef.current = false;
            return;
        }
        const target = ev.composedPath()[0];
        const isOutside = refs.every((ref)=>!contains(ref.current || null, target));
        if (isOutside && !disabled) {
            callback(ev);
        }
    });
    const handleMouseDown = useEventCallback((ev)=>{
        // Selecting text from inside to outside will rigger click event.
        // In this case click event target is outside but mouse down event target is inside.
        // And this click event should be considered as inside click.
        isMouseDownInsideRef.current = refs.some((ref)=>contains(ref.current || null, ev.target));
    });
    React.useEffect(()=>{
        if (disabled) {
            return;
        }
        // Store the current event to avoid triggering handlers immediately
        // Note this depends on a deprecated but extremely well supported quirk of the web platform
        // https://github.com/facebook/react/issues/20074
        let currentEvent = getWindowEvent(win);
        const conditionalHandler = (event)=>{
            // Skip if this event is the same as the one running when we added the handlers
            if (event === currentEvent) {
                currentEvent = undefined;
                return;
            }
            listener(event);
        };
        // use capture phase because React can update DOM before the event bubbles to the document
        element === null || element === undefined ? undefined : element.addEventListener('click', conditionalHandler, true);
        element === null || element === undefined ? undefined : element.addEventListener('touchstart', conditionalHandler, true);
        element === null || element === undefined ? undefined : element.addEventListener('contextmenu', conditionalHandler, true);
        element === null || element === undefined ? undefined : element.addEventListener('mousedown', handleMouseDown, true);
        // Garbage collect this event after it's no longer useful to avoid memory leaks
        timeoutId.current = win === null || win === undefined ? undefined : win.setTimeout(()=>{
            currentEvent = undefined;
        }, 1);
        return ()=>{
            element === null || element === undefined ? undefined : element.removeEventListener('click', conditionalHandler, true);
            element === null || element === undefined ? undefined : element.removeEventListener('touchstart', conditionalHandler, true);
            element === null || element === undefined ? undefined : element.removeEventListener('contextmenu', conditionalHandler, true);
            element === null || element === undefined ? undefined : element.removeEventListener('mousedown', handleMouseDown, true);
            win === null || win === undefined ? undefined : win.clearTimeout(timeoutId.current);
            currentEvent = undefined;
        };
    }, [
        listener,
        element,
        disabled,
        handleMouseDown,
        win
    ]);
};
const getWindowEvent = (target)=>{
    if (target) {
        var _target_ownerDocument_defaultView, _target_ownerDocument;
        if (typeof target.window === 'object' && target.window === target) {
            // eslint-disable-next-line deprecation/deprecation
            return target.event;
        }
        var _target_ownerDocument_defaultView_event;
        // eslint-disable-next-line deprecation/deprecation
        return (_target_ownerDocument_defaultView_event = (_target_ownerDocument = target.ownerDocument) === null || _target_ownerDocument === undefined ? undefined : (_target_ownerDocument_defaultView = _target_ownerDocument.defaultView) === null || _target_ownerDocument_defaultView === undefined ? undefined : _target_ownerDocument_defaultView.event) !== null && _target_ownerDocument_defaultView_event !== undefined ? _target_ownerDocument_defaultView_event : undefined;
    }
    return undefined;
};
const FUI_FRAME_EVENT = 'fuiframefocus';
/**
 * Since click events do not propagate past iframes, we use focus to detect if a
 * click has happened inside an iframe, since the only ways of focusing inside an
 * iframe are:
 *   - clicking inside
 *   - tabbing inside
 *
 * Polls the value of `document.activeElement`. If it is an iframe, then dispatch
 * a custom DOM event. When the custom event is received call the provided callback
 */ const useIFrameFocus = (options)=>{
    const { disabled, element: targetDocument, callback, contains = DEFAULT_CONTAINS, pollDuration = 1000, refs } = options;
    const timeoutRef = React.useRef();
    const listener = useEventCallback((e)=>{
        const isOutside = refs.every((ref)=>!contains(ref.current || null, e.target));
        if (isOutside && !disabled) {
            callback(e);
        }
    });
    // Adds listener to the custom iframe focus event
    React.useEffect(()=>{
        if (disabled) {
            return;
        }
        targetDocument === null || targetDocument === undefined ? undefined : targetDocument.addEventListener(FUI_FRAME_EVENT, listener, true);
        return ()=>{
            targetDocument === null || targetDocument === undefined ? undefined : targetDocument.removeEventListener(FUI_FRAME_EVENT, listener, true);
        };
    }, [
        targetDocument,
        disabled,
        listener
    ]);
    // Starts polling for the active element
    React.useEffect(()=>{
        var _targetDocument_defaultView;
        if (disabled) {
            return;
        }
        timeoutRef.current = targetDocument === null || targetDocument === undefined ? undefined : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === undefined ? undefined : _targetDocument_defaultView.setInterval(()=>{
            const activeElement = targetDocument === null || targetDocument === undefined ? undefined : targetDocument.activeElement;
            if ((activeElement === null || activeElement === undefined ? undefined : activeElement.tagName) === 'IFRAME' || (activeElement === null || activeElement === undefined ? undefined : activeElement.tagName) === 'WEBVIEW') {
                const event = new CustomEvent(FUI_FRAME_EVENT, {
                    bubbles: true
                });
                activeElement.dispatchEvent(event);
            }
        }, pollDuration);
        return ()=>{
            var _targetDocument_defaultView;
            targetDocument === null || targetDocument === undefined ? undefined : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === undefined ? undefined : _targetDocument_defaultView.clearTimeout(timeoutRef.current);
        };
    }, [
        targetDocument,
        disabled,
        pollDuration
    ]);
};

/**
 * @internal
 * Utility to perform checks where a click/touch event was made outside a component
 */ const useOnScrollOutside = (options)=>{
    const { refs, callback, element, disabled, contains: containsProp } = options;
    const listener = useEventCallback((ev)=>{
        const contains = containsProp || ((parent, child)=>!!(parent === null || parent === undefined ? undefined : parent.contains(child)));
        const target = ev.composedPath()[0];
        const isOutside = refs.every((ref)=>!contains(ref.current || null, target));
        if (isOutside && !disabled) {
            callback(ev);
        }
    });
    React.useEffect(()=>{
        if (disabled) {
            return;
        }
        element === null || element === undefined ? undefined : element.addEventListener('wheel', listener);
        element === null || element === undefined ? undefined : element.addEventListener('touchmove', listener);
        return ()=>{
            element === null || element === undefined ? undefined : element.removeEventListener('wheel', listener);
            element === null || element === undefined ? undefined : element.removeEventListener('touchmove', listener);
        };
    }, [
        listener,
        element,
        disabled
    ]);
};

/**
 * @internal
 */ const usePrevious = (value)=>{
    const ref = React.useRef(null);
    React.useEffect(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

const setTimeoutNoop = (_callback)=>-1;
const clearTimeoutNoop = (_handle)=>undefined;
/**
 * @internal
 * Helper to manage a browser timeout.
 * Ensures that the timeout isn't set multiple times at once and is cleaned up
 * when the component is unloaded.
 *
 * @returns A pair of [setTimeout, clearTimeout] that are stable between renders.
 */ function useTimeout() {
    const { targetDocument } = useFluent();
    const win = targetDocument === null || targetDocument === undefined ? undefined : targetDocument.defaultView;
    const setTimerFn = win ? win.setTimeout : setTimeoutNoop;
    const clearTimerFn = win ? win.clearTimeout : clearTimeoutNoop;
    return useBrowserTimer(setTimerFn, clearTimerFn);
}

/**
 * @internal
 * Combine two event callbacks into a single callback function that calls each one in order.
 *
 * Usage example:
 * ```ts
 * state.slot.onChange = mergeCallbacks(state.slot.onChange, ev => {
 *   // Handle onChange
 * });
 * ```
 *
 * The primary use is to avoid the need to capture an existing callback (`state.slot.onChange` in the example) to a
 * local variable before replacing with a new listener that calls the existing one. This helps avoid bugs like:
 * * Infinite recursion by calling the re-assigned state.slot.onChange if it's not captured to a local variable.
 * * Missing a call to the original onChange due to an early return or other conditional.
 *
 * If you need a callback that is stable between renders, wrap the result in {@link useEventCallback}.
 *
 * @param callback1 - The first callback to be called, or undefined
 * @param callback2 - The second callback to be called, or undefined
 *
 * @returns A function that that calls the provided functions in order
 */ function mergeCallbacks(callback1, callback2) {
    return (...args)=>{
        callback1 === null || callback1 === undefined ? undefined : callback1(...args);
        callback2 === null || callback2 === undefined ? undefined : callback2(...args);
    };
}

/**
 * Verifies if a given node is an HTMLElement,
 * this method works seamlessly with frames and elements from different documents
 *
 * This is preferred over simply using `instanceof`.
 * Since `instanceof` might be problematic while operating with [multiple realms](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/instanceof#instanceof_and_multiple_realms)
 *
 * @example
 * ```ts
 * isHTMLElement(event.target) && event.target.focus()
 * isHTMLElement(event.target, {constructorName: 'HTMLInputElement'}) && event.target.value // some value
 * ```
 *
 */ function isHTMLElement$3(element, options) {
    var _typedElement_ownerDocument;
    const typedElement = element;
    var _options_constructorName;
    return Boolean((typedElement === null || typedElement === undefined ? undefined : (_typedElement_ownerDocument = typedElement.ownerDocument) === null || _typedElement_ownerDocument === undefined ? undefined : _typedElement_ownerDocument.defaultView) && typedElement instanceof typedElement.ownerDocument.defaultView[(_options_constructorName = undefined ) !== null && _options_constructorName !== undefined ? _options_constructorName : 'HTMLElement']);
}

/**
 * @internal
 */ /**
 * @internal
 * @param compare - comparison function for items
 * @returns Priority queue implemented with a min heap
 */ function createPriorityQueue(compare) {
    const arr = [];
    let size = 0;
    const swap = (a, b)=>{
        const tmp = arr[a];
        arr[a] = arr[b];
        arr[b] = tmp;
    };
    const heapify = (i)=>{
        let smallest = i;
        const l = left(i);
        const r = right(i);
        if (l < size && compare(arr[l], arr[smallest]) < 0) {
            smallest = l;
        }
        if (r < size && compare(arr[r], arr[smallest]) < 0) {
            smallest = r;
        }
        if (smallest !== i) {
            swap(smallest, i);
            heapify(smallest);
        }
    };
    const dequeue = ()=>{
        if (size === 0) {
            throw new Error('Priority queue empty');
        }
        const res = arr[0];
        arr[0] = arr[--size];
        heapify(0);
        return res;
    };
    const peek = ()=>{
        if (size === 0) {
            return null;
        }
        return arr[0];
    };
    const enqueue = (item)=>{
        arr[size++] = item;
        let i = size - 1;
        let p = parent(i);
        while(i > 0 && compare(arr[p], arr[i]) > 0){
            swap(p, i);
            i = p;
            p = parent(i);
        }
    };
    const contains = (item)=>{
        const index = arr.indexOf(item);
        return index >= 0 && index < size;
    };
    const remove = (item)=>{
        const i = arr.indexOf(item);
        if (i === -1 || i >= size) {
            return;
        }
        arr[i] = arr[--size];
        heapify(i);
    };
    const clear = ()=>{
        size = 0;
    };
    const all = ()=>{
        return arr.slice(0, size);
    };
    return {
        all,
        clear,
        contains,
        dequeue,
        enqueue,
        peek,
        remove,
        size: ()=>size
    };
}
const left = (i)=>{
    return 2 * i + 1;
};
const right = (i)=>{
    return 2 * i + 2;
};
const parent = (i)=>{
    return Math.floor((i - 1) / 2);
};

/**
 * @internal
 * Checks if a given element is a FluentUI trigger (e.g. `MenuTrigger` or `Tooltip`).
 * See the {@link FluentTriggerComponent} type for more info.
 */ function isFluentTrigger(element) {
    return Boolean(element.type.isFluentTriggerComponent);
}

/**
 * @internal
 * resolve the trigger props to the children, either by calling the render function, or cloning with the new props.
 */ function applyTriggerPropsToChildren(children, triggerChildProps) {
    if (typeof children === 'function') {
        return children(triggerChildProps);
    } else if (children) {
        return cloneTriggerTree(children, triggerChildProps);
    }
    // Components in React should return either JSX elements or "null", otherwise React will throw:
    //   Nothing was returned from render.
    //   This usually means a return statement is missing. Or, to render nothing, return null.
    return children || null;
}
/**
 * Clones a React element tree, and applies the given props to the first grandchild that is not
 * a FluentTriggerComponent or React Fragment (the same element returned by {@link getTriggerChild}).
 */ function cloneTriggerTree(child, triggerProps) {
    if (!React.isValidElement(child) || child.type === React.Fragment) {
        throw new Error('A trigger element must be a single element for this component. ' + "Please ensure that you're not using React Fragments.");
    }
    if (isFluentTrigger(child)) {
        const grandchild = cloneTriggerTree(child.props.children, triggerProps);
        return React.cloneElement(child, undefined, grandchild);
    } else {
        return React.cloneElement(child, triggerProps);
    }
}

/**
 * @internal
 * Gets the trigger element of a FluentTriggerComponent (such as Tooltip or MenuTrigger).
 *
 * In the case where the immediate child is itself a FluentTriggerComponent and/or React Fragment,
 * it returns the first descendant that is _not_ a FluentTriggerComponent or Fragment.
 * This allows multiple triggers to be stacked, and still apply their props to the actual trigger element.
 *
 * For example, the following returns `<div id="child" />`:
 * ```jsx
 * getTriggerChild(
 *   <Tooltip>
 *     <MenuTrigger>
 *       <div id="child" />
 *     </MenuTrigger>
 *   </Tooltip>
 * );
 * ```
 *
 * In the case where the immediate child is not a valid element,
 * null is returned
 */ function getTriggerChild(children) {
    if (!React.isValidElement(children)) {
        return null;
    }
    return isFluentTrigger(children) ? getTriggerChild(// FIXME: This casting should be unnecessary as isFluentTrigger is a guard type method,
    // but for some reason it's failing on build
    children.props.children) : children;
}

/**
 * Determines whether or not an element has the virtual hierarchy extension.
 * @internal
 */ function isVirtualElement(element) {
    return element && !!element._virtual;
}

/**
 * Gets the virtual parent given the child element, if it exists.
 * @internal
 */ function getVirtualParent(child) {
    return isVirtualElement(child) ? child._virtual.parent || null : null;
}
/**
 * Gets the element which is the parent of a given element.
 * This method prefers the virtual parent over real DOM parent when present.
 * @internal
 */ function getParent(child, options = {}) {
    if (!child) {
        return null;
    }
    if (!options.skipVirtual) {
        const virtualParent = getVirtualParent(child);
        if (virtualParent) {
            return virtualParent;
        }
    }
    const parent = child.parentNode;
    if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        return parent.host;
    }
    return parent;
}

/**
 * Similar functionality to `element.contains` DOM API for use without of order DOM elements that
 * checks the virtual parent hierarchy. If a virtual parents exists, it is chosen over the actual parent
 *
 * @internal
 * @returns true if the child can find the parent in its virtual hierarchy
 */ function elementContains(parent, child) {
    if (!parent || !child) {
        return false;
    }
    if (parent === child) {
        return true;
    } else {
        // Tracks references of nodes that have been visited to prevent infinite loops
        const set = new WeakSet();
        while(child){
            const nextParent = getParent(child, {
                skipVirtual: set.has(child)
            });
            set.add(child);
            if (nextParent === parent) {
                return true;
            }
            child = nextParent;
        }
    }
    return false;
}

/**
 * Sets the virtual parent of an element.
 *
 * @internal
 * @param child - Theme element to set the virtual parent
 * @param parent - The virtual parent, use `undefined` to remove a virtual parent relationship
 */ function setVirtualParent(child, parent) {
    if (!child) {
        return;
    }
    const virtualChild = child;
    if (!virtualChild._virtual) {
        virtualChild._virtual = {};
    }
    virtualChild._virtual.parent = parent;
}

// TODO:
// this is for backwards compatibility with getSlotsNext
// it should be removed once getSlotsNext is obsolete
function createCompatSlotComponent(type, props) {
    return {
        ...props,
        [SLOT_ELEMENT_TYPE_SYMBOL]: type
    };
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=z;reactIs_production_min.Element=A;reactIs_production_min.ForwardRef=B;reactIs_production_min.Fragment=C;reactIs_production_min.Lazy=D;reactIs_production_min.Memo=E;reactIs_production_min.Portal=F;reactIs_production_min.Profiler=G;reactIs_production_min.StrictMode=H;
	reactIs_production_min.Suspense=I;reactIs_production_min.isAsyncMode=function(){return  false};reactIs_production_min.isConcurrentMode=function(){return  false};reactIs_production_min.isContextConsumer=function(a){return y(a)===h};reactIs_production_min.isContextProvider=function(a){return y(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return y(a)===k};reactIs_production_min.isFragment=function(a){return y(a)===d};reactIs_production_min.isLazy=function(a){return y(a)===p};reactIs_production_min.isMemo=function(a){return y(a)===n};
	reactIs_production_min.isPortal=function(a){return y(a)===c};reactIs_production_min.isProfiler=function(a){return y(a)===f};reactIs_production_min.isStrictMode=function(a){return y(a)===e};reactIs_production_min.isSuspense=function(a){return y(a)===l};reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?true:false};
	reactIs_production_min.typeOf=y;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = 0xeac7;
	var REACT_PORTAL_TYPE = 0xeaca;
	var REACT_FRAGMENT_TYPE = 0xeacb;
	var REACT_STRICT_MODE_TYPE = 0xeacc;
	var REACT_PROFILER_TYPE = 0xead2;
	var REACT_PROVIDER_TYPE = 0xeacd;
	var REACT_CONTEXT_TYPE = 0xeace;
	var REACT_FORWARD_REF_TYPE = 0xead0;
	var REACT_SUSPENSE_TYPE = 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	var REACT_MEMO_TYPE = 0xead3;
	var REACT_LAZY_TYPE = 0xead4;
	var REACT_BLOCK_TYPE = 0xead9;
	var REACT_SERVER_BLOCK_TYPE = 0xeada;
	var REACT_FUNDAMENTAL_TYPE = 0xead5;
	var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

	if (typeof Symbol === 'function' && Symbol.for) {
	  var symbolFor = Symbol.for;
	  REACT_ELEMENT_TYPE = symbolFor('react.element');
	  REACT_PORTAL_TYPE = symbolFor('react.portal');
	  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	  REACT_PROFILER_TYPE = symbolFor('react.profiler');
	  REACT_PROVIDER_TYPE = symbolFor('react.provider');
	  REACT_CONTEXT_TYPE = symbolFor('react.context');
	  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	  REACT_MEMO_TYPE = symbolFor('react.memo');
	  REACT_LAZY_TYPE = symbolFor('react.lazy');
	  REACT_BLOCK_TYPE = symbolFor('react.block');
	  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	  symbolFor('react.scope');
	  symbolFor('react.opaque.id');
	  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	  symbolFor('react.offscreen');
	  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	}

	// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	var enableScopeAPI = false; // Experimental Create Event Handle API.

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;

function warnIfElementTypeIsInvalid(type) {
    if (process.env.NODE_ENV === 'development' && typeof type === 'object' && !reactIsExports.isValidElementType(type)) {
        // eslint-disable-next-line no-console
        console.error(`@fluentui/react-jsx-runtime:
Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: ${type}.

If this happened in a slot of Fluent UI component, you might be facing package resolution issues.
Please make sure you don't have multiple versions of "@fluentui/react-utilities" installed in your dependencies or sub-dependencies.
You can check this by searching up for matching entries in a lockfile produced by your package manager (yarn.lock, pnpm-lock.yaml or package-lock.json).`);
    }
}

function createJSX(runtime, slotRuntime) {
    return function jsx(type, overrideProps, key, source, self) {
        // TODO:
        // this is for backwards compatibility with getSlotsNext
        // it should be removed once getSlotsNext is obsolete
        if (isSlot(overrideProps)) {
            return slotRuntime(createCompatSlotComponent(type, overrideProps), null, key, source, self);
        }
        if (isSlot(type)) {
            return slotRuntime(type, overrideProps, key, source, self);
        }
        warnIfElementTypeIsInvalid(type);
        return runtime(type, overrideProps, key, source, self);
    };
}

/**
 * @internal
 */ function getMetadataFromSlotComponent(type) {
    const { as, [SLOT_ELEMENT_TYPE_SYMBOL]: baseElementType, [SLOT_RENDER_FUNCTION_SYMBOL]: renderFunction, ...propsWithoutMetadata } = type;
    const props = propsWithoutMetadata;
    const elementType = typeof baseElementType === 'string' ? as !== null && as !== undefined ? as : baseElementType : baseElementType;
    if (typeof elementType !== 'string' && as) {
        props.as = as;
    }
    return {
        elementType,
        props,
        renderFunction
    };
}

const Runtime = ReactRuntime;

const jsxSlot = (type, overrideProps, key)=>{
    const { elementType, renderFunction, props: slotProps } = getMetadataFromSlotComponent(type);
    const props = {
        ...slotProps,
        ...overrideProps
    };
    if (renderFunction) {
        return Runtime.jsx(React.Fragment, {
            children: renderFunction(elementType, props)
        }, key);
    }
    return Runtime.jsx(elementType, props, key);
};

const jsxsSlot = (type, overrideProps, key)=>{
    const { elementType, renderFunction, props: slotProps } = getMetadataFromSlotComponent(type);
    const props = {
        ...slotProps,
        ...overrideProps
    };
    if (renderFunction) {
        /**
     * In static runtime then children is an array and this array won't be keyed.
     * We should wrap children by a static fragment
     * as there's no way to know if renderFunction will render statically or dynamically
     */ return Runtime.jsx(React.Fragment, {
            children: renderFunction(elementType, {
                ...props,
                children: Runtime.jsxs(React.Fragment, {
                    children: props.children
                }, undefined)
            })
        }, key);
    }
    return Runtime.jsxs(elementType, props, key);
};

const jsx = createJSX(Runtime.jsx, jsxSlot);
const jsxs = createJSX(Runtime.jsxs, jsxsSlot);

/**
 * Render the final JSX of FluentProvider
 */ const renderFluentProvider_unstable = (state, contextValues)=>{
    assertSlots(state);
    // Typescript (vscode) incorrectly references the FluentProviderProps.customStyleHooks_unstable
    // instead of FluentProviderContextValues.customStyleHooks_unstable and thinks it is
    // Partial<CustomStyleHooksContextValue>, so it needs to be cast to Required<CustomStyleHooksContextValue>
    return /*#__PURE__*/ jsx(Provider, {
        value: contextValues.provider,
        children: /*#__PURE__*/ jsx(ThemeProvider, {
            value: contextValues.theme,
            children: /*#__PURE__*/ jsx(ThemeClassNameProvider, {
                value: contextValues.themeClassName,
                children: /*#__PURE__*/ jsx(CustomStyleHooksProvider$1, {
                    value: contextValues.customStyleHooks_unstable,
                    children: /*#__PURE__*/ jsx(TooltipVisibilityProvider, {
                        value: contextValues.tooltip,
                        children: /*#__PURE__*/ jsx(TextDirectionProvider, {
                            dir: contextValues.textDirection,
                            children: /*#__PURE__*/ jsx(IconDirectionContextProvider, {
                                value: contextValues.iconDirection,
                                children: /*#__PURE__*/ jsx(OverridesProvider, {
                                    value: contextValues.overrides_unstable,
                                    children: /*#__PURE__*/ jsxs(state.root, {
                                        children: [
                                            canUseDOM() ? null : /*#__PURE__*/ jsx("style", {
                                                // Using dangerous HTML because react can escape characters
                                                // which can lead to invalid CSS.
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML: {
                                                    __html: state.serverStyleProps.cssRule
                                                },
                                                ...state.serverStyleProps.attributes
                                            }),
                                            state.root.children
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

// src/WeakRefInstance.ts
var _canUseWeakRef = typeof WeakRef !== "undefined";
var WeakRefInstance = class {
  constructor(instance) {
    if (_canUseWeakRef && typeof instance === "object") {
      this._weakRef = new WeakRef(instance);
    } else {
      this._instance = instance;
    }
  }
  /**
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef/deref}
   */
  deref() {
    var _a, _b;
    let instance;
    if (this._weakRef) {
      instance = (_a = this._weakRef) == null ? undefined : _a.deref();
      if (!instance) {
        delete this._weakRef;
      }
    } else {
      instance = this._instance;
      if ((_b = instance == null ? undefined : instance.isDisposed) == null ? undefined : _b.call(instance)) {
        delete this._instance;
      }
    }
    return instance;
  }
};

// src/FocusEvent.ts
var KEYBORG_FOCUSIN = "keyborg:focusin";
var KEYBORG_FOCUSOUT = "keyborg:focusout";
function canOverrideNativeFocus(win) {
  const HTMLElement = win.HTMLElement;
  const origFocus = HTMLElement.prototype.focus;
  let isCustomFocusCalled = false;
  HTMLElement.prototype.focus = function focus() {
    isCustomFocusCalled = true;
  };
  const btn = win.document.createElement("button");
  btn.focus();
  HTMLElement.prototype.focus = origFocus;
  return isCustomFocusCalled;
}
var _canOverrideNativeFocus = false;
function nativeFocus(element) {
  const focus = element.focus;
  if (focus.__keyborgNativeFocus) {
    focus.__keyborgNativeFocus.call(element);
  } else {
    element.focus();
  }
}
function setupFocusEvent(win) {
  const kwin = win;
  if (!_canOverrideNativeFocus) {
    _canOverrideNativeFocus = canOverrideNativeFocus(kwin);
  }
  const origFocus = kwin.HTMLElement.prototype.focus;
  if (origFocus.__keyborgNativeFocus) {
    return;
  }
  kwin.HTMLElement.prototype.focus = focus;
  const shadowTargets = /* @__PURE__ */ new Set();
  const focusOutHandler = (e) => {
    const target = e.target;
    if (!target) {
      return;
    }
    const event = new CustomEvent(KEYBORG_FOCUSOUT, {
      cancelable: true,
      bubbles: true,
      // Allows the event to bubble past an open shadow root
      composed: true,
      detail: {
        originalEvent: e
      }
    });
    target.dispatchEvent(event);
  };
  const focusInHandler = (e) => {
    const target = e.target;
    if (!target) {
      return;
    }
    let node = e.composedPath()[0];
    const currentShadows = /* @__PURE__ */ new Set();
    while (node) {
      if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        currentShadows.add(node);
        node = node.host;
      } else {
        node = node.parentNode;
      }
    }
    for (const shadowRootWeakRef of shadowTargets) {
      const shadowRoot = shadowRootWeakRef.deref();
      if (!shadowRoot || !currentShadows.has(shadowRoot)) {
        shadowTargets.delete(shadowRootWeakRef);
        if (shadowRoot) {
          shadowRoot.removeEventListener("focusin", focusInHandler, true);
          shadowRoot.removeEventListener("focusout", focusOutHandler, true);
        }
      }
    }
    onFocusIn(target, e.relatedTarget || undefined);
  };
  const onFocusIn = (target, relatedTarget, originalEvent) => {
    var _a;
    const shadowRoot = target.shadowRoot;
    if (shadowRoot) {
      for (const shadowRootWeakRef of shadowTargets) {
        if (shadowRootWeakRef.deref() === shadowRoot) {
          return;
        }
      }
      shadowRoot.addEventListener("focusin", focusInHandler, true);
      shadowRoot.addEventListener("focusout", focusOutHandler, true);
      shadowTargets.add(new WeakRefInstance(shadowRoot));
      return;
    }
    const details = {
      relatedTarget,
      originalEvent
    };
    const event = new CustomEvent(KEYBORG_FOCUSIN, {
      cancelable: true,
      bubbles: true,
      // Allows the event to bubble past an open shadow root
      composed: true,
      detail: details
    });
    event.details = details;
    if (_canOverrideNativeFocus || data.lastFocusedProgrammatically) {
      details.isFocusedProgrammatically = target === ((_a = data.lastFocusedProgrammatically) == null ? undefined : _a.deref());
      data.lastFocusedProgrammatically = undefined;
    }
    target.dispatchEvent(event);
  };
  const data = kwin.__keyborgData = {
    focusInHandler,
    focusOutHandler,
    shadowTargets
  };
  kwin.document.addEventListener(
    "focusin",
    kwin.__keyborgData.focusInHandler,
    true
  );
  kwin.document.addEventListener(
    "focusout",
    kwin.__keyborgData.focusOutHandler,
    true
  );
  function focus() {
    const keyborgNativeFocusEvent = kwin.__keyborgData;
    if (keyborgNativeFocusEvent) {
      keyborgNativeFocusEvent.lastFocusedProgrammatically = new WeakRefInstance(
        this
      );
    }
    return origFocus.apply(this, arguments);
  }
  let activeElement = kwin.document.activeElement;
  while (activeElement && activeElement.shadowRoot) {
    onFocusIn(activeElement);
    activeElement = activeElement.shadowRoot.activeElement;
  }
  focus.__keyborgNativeFocus = origFocus;
}
function disposeFocusEvent(win) {
  const kwin = win;
  const proto = kwin.HTMLElement.prototype;
  const origFocus = proto.focus.__keyborgNativeFocus;
  const keyborgNativeFocusEvent = kwin.__keyborgData;
  if (keyborgNativeFocusEvent) {
    kwin.document.removeEventListener(
      "focusin",
      keyborgNativeFocusEvent.focusInHandler,
      true
    );
    kwin.document.removeEventListener(
      "focusout",
      keyborgNativeFocusEvent.focusOutHandler,
      true
    );
    for (const shadowRootWeakRef of keyborgNativeFocusEvent.shadowTargets) {
      const shadowRoot = shadowRootWeakRef.deref();
      if (shadowRoot) {
        shadowRoot.removeEventListener(
          "focusin",
          keyborgNativeFocusEvent.focusInHandler,
          true
        );
        shadowRoot.removeEventListener(
          "focusout",
          keyborgNativeFocusEvent.focusOutHandler,
          true
        );
      }
    }
    keyborgNativeFocusEvent.shadowTargets.clear();
    delete kwin.__keyborgData;
  }
  if (origFocus) {
    proto.focus = origFocus;
  }
}

// src/Keyborg.ts
var _dismissTimeout = 500;
var _lastId = 0;
var KeyborgCore = class {
  constructor(win, props) {
    this._isNavigatingWithKeyboard_DO_NOT_USE = false;
    this._onFocusIn = (e) => {
      if (this._isMouseOrTouchUsedTimer) {
        return;
      }
      if (this.isNavigatingWithKeyboard) {
        return;
      }
      const details = e.detail;
      if (!details.relatedTarget) {
        return;
      }
      if (details.isFocusedProgrammatically || details.isFocusedProgrammatically === undefined) {
        return;
      }
      this.isNavigatingWithKeyboard = true;
    };
    this._onMouseDown = (e) => {
      if (e.buttons === 0 || e.clientX === 0 && e.clientY === 0 && e.screenX === 0 && e.screenY === 0) {
        return;
      }
      this._onMouseOrTouch();
    };
    this._onMouseOrTouch = () => {
      const win = this._win;
      if (win) {
        if (this._isMouseOrTouchUsedTimer) {
          win.clearTimeout(this._isMouseOrTouchUsedTimer);
        }
        this._isMouseOrTouchUsedTimer = win.setTimeout(() => {
          delete this._isMouseOrTouchUsedTimer;
        }, 1e3);
      }
      this.isNavigatingWithKeyboard = false;
    };
    this._onKeyDown = (e) => {
      const isNavigatingWithKeyboard = this.isNavigatingWithKeyboard;
      if (isNavigatingWithKeyboard) {
        if (this._shouldDismissKeyboardNavigation(e)) {
          this._scheduleDismiss();
        }
      } else {
        if (this._shouldTriggerKeyboardNavigation(e)) {
          this.isNavigatingWithKeyboard = true;
        }
      }
    };
    this.id = "c" + ++_lastId;
    this._win = win;
    const doc = win.document;
    if (props) {
      const triggerKeys = props.triggerKeys;
      const dismissKeys = props.dismissKeys;
      if (triggerKeys == null ? undefined : triggerKeys.length) {
        this._triggerKeys = new Set(triggerKeys);
      }
      if (dismissKeys == null ? undefined : dismissKeys.length) {
        this._dismissKeys = new Set(dismissKeys);
      }
    }
    doc.addEventListener(KEYBORG_FOCUSIN, this._onFocusIn, true);
    doc.addEventListener("mousedown", this._onMouseDown, true);
    win.addEventListener("keydown", this._onKeyDown, true);
    doc.addEventListener("touchstart", this._onMouseOrTouch, true);
    doc.addEventListener("touchend", this._onMouseOrTouch, true);
    doc.addEventListener("touchcancel", this._onMouseOrTouch, true);
    setupFocusEvent(win);
  }
  get isNavigatingWithKeyboard() {
    return this._isNavigatingWithKeyboard_DO_NOT_USE;
  }
  set isNavigatingWithKeyboard(val) {
    if (this._isNavigatingWithKeyboard_DO_NOT_USE !== val) {
      this._isNavigatingWithKeyboard_DO_NOT_USE = val;
      this.update();
    }
  }
  dispose() {
    const win = this._win;
    if (win) {
      if (this._isMouseOrTouchUsedTimer) {
        win.clearTimeout(this._isMouseOrTouchUsedTimer);
        this._isMouseOrTouchUsedTimer = undefined;
      }
      if (this._dismissTimer) {
        win.clearTimeout(this._dismissTimer);
        this._dismissTimer = undefined;
      }
      disposeFocusEvent(win);
      const doc = win.document;
      doc.removeEventListener(KEYBORG_FOCUSIN, this._onFocusIn, true);
      doc.removeEventListener("mousedown", this._onMouseDown, true);
      win.removeEventListener("keydown", this._onKeyDown, true);
      doc.removeEventListener("touchstart", this._onMouseOrTouch, true);
      doc.removeEventListener("touchend", this._onMouseOrTouch, true);
      doc.removeEventListener("touchcancel", this._onMouseOrTouch, true);
      delete this._win;
    }
  }
  isDisposed() {
    return !!this._win;
  }
  /**
   * Updates all keyborg instances with the keyboard navigation state
   */
  update() {
    var _a, _b;
    const keyborgs = (_b = (_a = this._win) == null ? undefined : _a.__keyborg) == null ? undefined : _b.refs;
    if (keyborgs) {
      for (const id of Object.keys(keyborgs)) {
        Keyborg.update(keyborgs[id], this.isNavigatingWithKeyboard);
      }
    }
  }
  /**
   * @returns whether the keyboard event should trigger keyboard navigation mode
   */
  _shouldTriggerKeyboardNavigation(e) {
    var _a;
    if (e.key === "Tab") {
      return true;
    }
    const activeElement = (_a = this._win) == null ? undefined : _a.document.activeElement;
    const isTriggerKey = !this._triggerKeys || this._triggerKeys.has(e.keyCode);
    const isEditable = activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.isContentEditable);
    return isTriggerKey && !isEditable;
  }
  /**
   * @returns whether the keyboard event should dismiss keyboard navigation mode
   */
  _shouldDismissKeyboardNavigation(e) {
    var _a;
    return (_a = this._dismissKeys) == null ? undefined : _a.has(e.keyCode);
  }
  _scheduleDismiss() {
    const win = this._win;
    if (win) {
      if (this._dismissTimer) {
        win.clearTimeout(this._dismissTimer);
        this._dismissTimer = undefined;
      }
      const was = win.document.activeElement;
      this._dismissTimer = win.setTimeout(() => {
        this._dismissTimer = undefined;
        const cur = win.document.activeElement;
        if (was && cur && was === cur) {
          this.isNavigatingWithKeyboard = false;
        }
      }, _dismissTimeout);
    }
  }
};
var Keyborg = class _Keyborg {
  constructor(win, props) {
    this._cb = [];
    this._id = "k" + ++_lastId;
    this._win = win;
    const current = win.__keyborg;
    if (current) {
      this._core = current.core;
      current.refs[this._id] = this;
    } else {
      this._core = new KeyborgCore(win, props);
      win.__keyborg = {
        core: this._core,
        refs: { [this._id]: this }
      };
    }
  }
  static create(win, props) {
    return new _Keyborg(win, props);
  }
  static dispose(instance) {
    instance.dispose();
  }
  /**
   * Updates all subscribed callbacks with the keyboard navigation state
   */
  static update(instance, isNavigatingWithKeyboard) {
    instance._cb.forEach((callback) => callback(isNavigatingWithKeyboard));
  }
  dispose() {
    var _a;
    const current = (_a = this._win) == null ? undefined : _a.__keyborg;
    if (current == null ? undefined : current.refs[this._id]) {
      delete current.refs[this._id];
      if (Object.keys(current.refs).length === 0) {
        current.core.dispose();
        delete this._win.__keyborg;
      }
    } else if (process.env.NODE_ENV !== "production") {
      console.error(
        `Keyborg instance ${this._id} is being disposed incorrectly.`
      );
    }
    this._cb = [];
    delete this._core;
    delete this._win;
  }
  /**
   * @returns Whether the user is navigating with keyboard
   */
  isNavigatingWithKeyboard() {
    var _a;
    return !!((_a = this._core) == null ? undefined : _a.isNavigatingWithKeyboard);
  }
  /**
   * @param callback - Called when the keyboard navigation state changes
   */
  subscribe(callback) {
    this._cb.push(callback);
  }
  /**
   * @param callback - Registered with subscribe
   */
  unsubscribe(callback) {
    const index = this._cb.indexOf(callback);
    if (index >= 0) {
      this._cb.splice(index, 1);
    }
  }
  /**
   * Manually set the keyboard navigtion state
   */
  setVal(isNavigatingWithKeyboard) {
    if (this._core) {
      this._core.isNavigatingWithKeyboard = isNavigatingWithKeyboard;
    }
  }
};
function createKeyborg(win, props) {
  return Keyborg.create(win, props);
}
function disposeKeyborg(instance) {
  Keyborg.dispose(instance);
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const TABSTER_ATTRIBUTE_NAME = "data-tabster";
const TABSTER_DUMMY_INPUT_ATTRIBUTE_NAME = "data-tabster-dummy";
const FOCUSABLE_SELECTOR = /*#__PURE__*/["a[href]", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "*[tabindex]", "*[contenteditable]", "details > summary", "audio[controls]", "video[controls]"].join(", ");
const AsyncFocusSources = {
  EscapeGroupper: 1,
  Restorer: 2,
  Deloser: 3
};
const Visibilities = {
  Invisible: 0,
  PartiallyVisible: 1,
  Visible: 2
};
const RestorerTypes = {
  Source: 0,
  Target: 1
};
const MoverDirections = {
  Both: 0,
  Vertical: 1,
  Horizontal: 2,
  Grid: 3,
  GridLinear: 4 // Two-dimentional movement depending on the visual placement. Allows linear movement.

};
const MoverKeys = {
  ArrowUp: 1,
  ArrowDown: 2,
  ArrowLeft: 3,
  ArrowRight: 4,
  PageUp: 5,
  PageDown: 6,
  Home: 7,
  End: 8
};
const GroupperTabbabilities = {
  Unlimited: 0,
  Limited: 1,
  LimitedTrapFocus: 2 // The focus is limited as above, plus trapped when inside.

};
const GroupperMoveFocusActions = {
  Enter: 1,
  Escape: 2
};
const SysDummyInputsPositions = {
  Auto: 0,
  Inside: 1,
  Outside: 2 // Tabster will always place dummy inputs outside of the container.

};

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function getTabsterOnElement(tabster, element) {
  var _a;

  return (_a = tabster.storageEntry(element)) === null || _a === undefined ? undefined : _a.tabster;
}
function updateTabsterByAttribute(tabster, element, dispose) {
  var _a, _b;

  const newAttrValue = dispose || tabster._noop ? undefined : element.getAttribute(TABSTER_ATTRIBUTE_NAME);
  let entry = tabster.storageEntry(element);
  let newAttr;

  if (newAttrValue) {
    if (newAttrValue !== ((_a = entry === null || entry === undefined ? undefined : entry.attr) === null || _a === undefined ? undefined : _a.string)) {
      try {
        const newValue = JSON.parse(newAttrValue);

        if (typeof newValue !== "object") {
          throw new Error(`Value is not a JSON object, got '${newAttrValue}'.`);
        }

        newAttr = {
          string: newAttrValue,
          object: newValue
        };
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error(`data-tabster attribute error: ${e}`, element);
        }
      }
    } else {
      return;
    }
  } else if (!entry) {
    return;
  }

  if (!entry) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entry = tabster.storageEntry(element, true);
  }

  if (!entry.tabster) {
    entry.tabster = {};
  }

  const tabsterOnElement = entry.tabster || {};
  const oldTabsterProps = ((_b = entry.attr) === null || _b === undefined ? undefined : _b.object) || {};
  const newTabsterProps = (newAttr === null || newAttr === undefined ? undefined : newAttr.object) || {};

  for (const key of Object.keys(oldTabsterProps)) {
    if (!newTabsterProps[key]) {
      if (key === "root") {
        const root = tabsterOnElement[key];

        if (root) {
          tabster.root.onRoot(root, true);
        }
      }

      switch (key) {
        case "deloser":
        case "root":
        case "groupper":
        case "modalizer":
        case "restorer":
        case "mover":
          // eslint-disable-next-line no-case-declarations
          const part = tabsterOnElement[key];

          if (part) {
            part.dispose();
            delete tabsterOnElement[key];
          }

          break;

        case "observed":
          delete tabsterOnElement[key];

          if (tabster.observedElement) {
            tabster.observedElement.onObservedElementUpdate(element);
          }

          break;

        case "focusable":
        case "outline":
        case "uncontrolled":
        case "sys":
          delete tabsterOnElement[key];
          break;
      }
    }
  }

  for (const key of Object.keys(newTabsterProps)) {
    const sys = newTabsterProps.sys;

    switch (key) {
      case "deloser":
        if (tabsterOnElement.deloser) {
          tabsterOnElement.deloser.setProps(newTabsterProps.deloser);
        } else {
          if (tabster.deloser) {
            tabsterOnElement.deloser = tabster.deloser.createDeloser(element, newTabsterProps.deloser);
          } else if (process.env.NODE_ENV === 'development') {
            console.error("Deloser API used before initialization, please call `getDeloser()`");
          }
        }

        break;

      case "root":
        if (tabsterOnElement.root) {
          tabsterOnElement.root.setProps(newTabsterProps.root);
        } else {
          tabsterOnElement.root = tabster.root.createRoot(element, newTabsterProps.root, sys);
        }

        tabster.root.onRoot(tabsterOnElement.root);
        break;

      case "modalizer":
        if (tabsterOnElement.modalizer) {
          tabsterOnElement.modalizer.setProps(newTabsterProps.modalizer);
        } else {
          if (tabster.modalizer) {
            tabsterOnElement.modalizer = tabster.modalizer.createModalizer(element, newTabsterProps.modalizer, sys);
          } else if (process.env.NODE_ENV === 'development') {
            console.error("Modalizer API used before initialization, please call `getModalizer()`");
          }
        }

        break;

      case "restorer":
        if (tabsterOnElement.restorer) {
          tabsterOnElement.restorer.setProps(newTabsterProps.restorer);
        } else {
          if (tabster.restorer) {
            if (newTabsterProps.restorer) {
              tabsterOnElement.restorer = tabster.restorer.createRestorer(element, newTabsterProps.restorer);
            }
          } else if (process.env.NODE_ENV === 'development') {
            console.error("Restorer API used before initialization, please call `getRestorer()`");
          }
        }

        break;

      case "focusable":
        tabsterOnElement.focusable = newTabsterProps.focusable;
        break;

      case "groupper":
        if (tabsterOnElement.groupper) {
          tabsterOnElement.groupper.setProps(newTabsterProps.groupper);
        } else {
          if (tabster.groupper) {
            tabsterOnElement.groupper = tabster.groupper.createGroupper(element, newTabsterProps.groupper, sys);
          } else if (process.env.NODE_ENV === 'development') {
            console.error("Groupper API used before initialization, please call `getGroupper()`");
          }
        }

        break;

      case "mover":
        if (tabsterOnElement.mover) {
          tabsterOnElement.mover.setProps(newTabsterProps.mover);
        } else {
          if (tabster.mover) {
            tabsterOnElement.mover = tabster.mover.createMover(element, newTabsterProps.mover, sys);
          } else if (process.env.NODE_ENV === 'development') {
            console.error("Mover API used before initialization, please call `getMover()`");
          }
        }

        break;

      case "observed":
        if (tabster.observedElement) {
          tabsterOnElement.observed = newTabsterProps.observed;
          tabster.observedElement.onObservedElementUpdate(element);
        } else if (process.env.NODE_ENV === 'development') {
          console.error("ObservedElement API used before initialization, please call `getObservedElement()`");
        }

        break;

      case "uncontrolled":
        tabsterOnElement.uncontrolled = newTabsterProps.uncontrolled;
        break;

      case "outline":
        if (tabster.outline) {
          tabsterOnElement.outline = newTabsterProps.outline;
        } else if (process.env.NODE_ENV === 'development') {
          console.error("Outline API used before initialization, please call `getOutline()`");
        }

        break;

      case "sys":
        tabsterOnElement.sys = newTabsterProps.sys;
        break;

      default:
        console.error(`Unknown key '${key}' in data-tabster attribute value.`);
    }
  }

  if (newAttr) {
    entry.attr = newAttr;
  } else {
    if (Object.keys(tabsterOnElement).length === 0) {
      delete entry.tabster;
      delete entry.attr;
    }

    tabster.storageEntry(element, false);
  }
}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Events sent by Tabster.
 */
const TabsterFocusInEventName = "tabster:focusin";
const TabsterFocusOutEventName = "tabster:focusout"; // Event is dispatched when Tabster wants to move focus as the result of
// handling keyboard event. This allows to preventDefault() if you want to have
// some custom logic.

const TabsterMoveFocusEventName = "tabster:movefocus";
/**
 * Events sent by Modalizer.
 */

const ModalizerActiveEventName = "tabster:modalizer:active";
const ModalizerInactiveEventName = "tabster:modalizer:inactive";
/**
 * Events sent by Mover.
 */

const MoverStateEventName = "tabster:mover:state";
/**
 * Events to be sent to Mover by the application.
 */
// Event that can be dispatched by the application to programmatically move
// focus inside Mover.

const MoverMoveFocusEventName = "tabster:mover:movefocus"; // Event that can be dispatched by the application to forget or modify
// memorized element in Mover with memorizeCurrent property.

const MoverMemorizedElementEventName = "tabster:mover:memorized-element";
/**
 * Events sent by Groupper.
 */

/**
 * Events to be sent to Groupper by the application.
 */
// Event that can be dispatched by the application to programmatically enter
// or escape Groupper.

const GroupperMoveFocusEventName = "tabster:groupper:movefocus";
/**
 * Events sent by Restorer.
 */

const RestorerRestoreFocusEventName = "tabster:restorer:restore-focus";
/**
 * Events sent by Root.
 */

const RootFocusEventName = "tabster:root:focus";
const RootBlurEventName = "tabster:root:blur"; // Node.js environments do not have CustomEvent and it is needed for the events to be
// evaluated. It doesn't matter if it works or not in Node.js environment.
// So, we just need to make sure that it doesn't throw undefined reference.

const CustomEvent_ = typeof CustomEvent !== "undefined" ? CustomEvent : function () {
  /* no-op */
};
class TabsterCustomEvent extends CustomEvent_ {
  constructor(type, detail) {
    super(type, {
      bubbles: true,
      cancelable: true,
      composed: true,
      detail
    });
    this.details = detail;
  }

}
class TabsterFocusInEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(TabsterFocusInEventName, detail);
  }

}
class TabsterFocusOutEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(TabsterFocusOutEventName, detail);
  }

}
class TabsterMoveFocusEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(TabsterMoveFocusEventName, detail);
  }

}
class MoverStateEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(MoverStateEventName, detail);
  }

}
class ModalizerActiveEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(ModalizerActiveEventName, detail);
  }

}
class ModalizerInactiveEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(ModalizerInactiveEventName, detail);
  }

}
class RestorerRestoreFocusEvent extends TabsterCustomEvent {
  constructor() {
    super(RestorerRestoreFocusEventName);
  }

}
class RootFocusEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(RootFocusEventName, detail);
  }

}
class RootBlurEvent extends TabsterCustomEvent {
  constructor(detail) {
    super(RootBlurEventName, detail);
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const _createMutationObserver = callback => new MutationObserver(callback);

const _createTreeWalker = (doc, root, whatToShow, filter) => doc.createTreeWalker(root, whatToShow, filter);

const _getParentNode = node => node ? node.parentNode : null;

const _getParentElement = element => element ? element.parentElement : null;

const _nodeContains = (parent, child) => !!(child && (parent === null || parent === undefined ? undefined : parent.contains(child)));

const _getActiveElement = doc => doc.activeElement;

const _querySelector = (element, selector) => element.querySelector(selector);

const _querySelectorAll = (element, selector) => Array.prototype.slice.call(element.querySelectorAll(selector), 0);

const _getElementById = (doc, id) => doc.getElementById(id);

const _getFirstChild = node => (node === null || node === undefined ? undefined : node.firstChild) || null;

const _getLastChild = node => (node === null || node === undefined ? undefined : node.lastChild) || null;

const _getNextSibling = node => (node === null || node === undefined ? undefined : node.nextSibling) || null;

const _getPreviousSibling = node => (node === null || node === undefined ? undefined : node.previousSibling) || null;

const _getFirstElementChild = element => (element === null || element === undefined ? undefined : element.firstElementChild) || null;

const _getLastElementChild = element => (element === null || element === undefined ? undefined : element.lastElementChild) || null;

const _getNextElementSibling = element => (element === null || element === undefined ? undefined : element.nextElementSibling) || null;

const _getPreviousElementSibling = element => (element === null || element === undefined ? undefined : element.previousElementSibling) || null;

const _appendChild = (parent, child) => parent.appendChild(child);

const _insertBefore = (parent, child, referenceChild) => parent.insertBefore(child, referenceChild);

const _getSelection = ref => {
  var _a;

  return ((_a = ref.ownerDocument) === null || _a === undefined ? undefined : _a.getSelection()) || null;
};

const _getElementsByName = (referenceElement, name) => referenceElement.ownerDocument.getElementsByName(name);

const dom = {
  createMutationObserver: _createMutationObserver,
  createTreeWalker: _createTreeWalker,
  getParentNode: _getParentNode,
  getParentElement: _getParentElement,
  nodeContains: _nodeContains,
  getActiveElement: _getActiveElement,
  querySelector: _querySelector,
  querySelectorAll: _querySelectorAll,
  getElementById: _getElementById,
  getFirstChild: _getFirstChild,
  getLastChild: _getLastChild,
  getNextSibling: _getNextSibling,
  getPreviousSibling: _getPreviousSibling,
  getFirstElementChild: _getFirstElementChild,
  getLastElementChild: _getLastElementChild,
  getNextElementSibling: _getNextElementSibling,
  getPreviousElementSibling: _getPreviousElementSibling,
  appendChild: _appendChild,
  insertBefore: _insertBefore,
  getSelection: _getSelection,
  getElementsByName: _getElementsByName
};
function setDOMAPI(domapi) {
  for (const key of Object.keys(domapi)) {
    dom[key] = domapi[key];
  }
}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

let _isBrokenIE11;

const _DOMRect = typeof DOMRect !== "undefined" ? DOMRect : class {
  constructor(x, y, width, height) {
    this.left = x || 0;
    this.top = y || 0;
    this.right = (x || 0) + (width || 0);
    this.bottom = (y || 0) + (height || 0);
  }

};

let _uidCounter = 0;

try {
  // IE11 only accepts `filter` argument as a function (not object with the `acceptNode`
  // property as the docs define). Also `entityReferenceExpansion` argument is not
  // optional. And it throws exception when the above arguments aren't there.
  document.createTreeWalker(document, NodeFilter.SHOW_ELEMENT);
  _isBrokenIE11 = false;
} catch (e) {
  _isBrokenIE11 = true;
}

const _updateDummyInputsTimeout = 100;
function getInstanceContext(getWindow) {
  const win = getWindow();
  let ctx = win.__tabsterInstanceContext;

  if (!ctx) {
    ctx = {
      elementByUId: {},
      basics: {
        Promise: win.Promise || undefined,
        WeakRef: win.WeakRef || undefined
      },
      containerBoundingRectCache: {},
      lastContainerBoundingRectCacheId: 0,
      fakeWeakRefs: [],
      fakeWeakRefsStarted: false
    };
    win.__tabsterInstanceContext = ctx;
  }

  return ctx;
}
function disposeInstanceContext(win) {
  const ctx = win.__tabsterInstanceContext;

  if (ctx) {
    ctx.elementByUId = {};
    delete ctx.WeakRef;
    ctx.containerBoundingRectCache = {};

    if (ctx.containerBoundingRectCacheTimer) {
      win.clearTimeout(ctx.containerBoundingRectCacheTimer);
    }

    if (ctx.fakeWeakRefsTimer) {
      win.clearTimeout(ctx.fakeWeakRefsTimer);
    }

    ctx.fakeWeakRefs = [];
    delete win.__tabsterInstanceContext;
  }
}
function createWeakMap(win) {
  const ctx = win.__tabsterInstanceContext;
  return new ((ctx === null || ctx === undefined ? undefined : ctx.basics.WeakMap) || WeakMap)();
}
function hasSubFocusable(element) {
  return !!element.querySelector(FOCUSABLE_SELECTOR);
}

class FakeWeakRef {
  constructor(target) {
    this._target = target;
  }

  deref() {
    return this._target;
  }

  static cleanup(fwr, forceRemove) {
    if (!fwr._target) {
      return true;
    }

    if (forceRemove || !documentContains(fwr._target.ownerDocument, fwr._target)) {
      delete fwr._target;
      return true;
    }

    return false;
  }

}

class WeakHTMLElement {
  constructor(getWindow, element, data) {
    const context = getInstanceContext(getWindow);
    let ref;

    if (context.WeakRef) {
      ref = new context.WeakRef(element);
    } else {
      ref = new FakeWeakRef(element);
      context.fakeWeakRefs.push(ref);
    }

    this._ref = ref;
    this._data = data;
  }

  get() {
    const ref = this._ref;
    let element;

    if (ref) {
      element = ref.deref();

      if (!element) {
        delete this._ref;
      }
    }

    return element;
  }

  getData() {
    return this._data;
  }

}
function cleanupFakeWeakRefs(getWindow, forceRemove) {
  const context = getInstanceContext(getWindow);
  context.fakeWeakRefs = context.fakeWeakRefs.filter(e => !FakeWeakRef.cleanup(e, forceRemove));
}
function startFakeWeakRefsCleanup(getWindow) {
  const context = getInstanceContext(getWindow);

  if (!context.fakeWeakRefsStarted) {
    context.fakeWeakRefsStarted = true;
    context.WeakRef = getWeakRef(context);
  }

  if (!context.fakeWeakRefsTimer) {
    context.fakeWeakRefsTimer = getWindow().setTimeout(() => {
      context.fakeWeakRefsTimer = undefined;
      cleanupFakeWeakRefs(getWindow);
      startFakeWeakRefsCleanup(getWindow);
    }, 2 * 60 * 1000); // 2 minutes.
  }
}
function stopFakeWeakRefsCleanupAndClearStorage(getWindow) {
  const context = getInstanceContext(getWindow);
  context.fakeWeakRefsStarted = false;

  if (context.fakeWeakRefsTimer) {
    getWindow().clearTimeout(context.fakeWeakRefsTimer);
    context.fakeWeakRefsTimer = undefined;
    context.fakeWeakRefs = [];
  }
}
function createElementTreeWalker(doc, root, acceptNode) {
  // IE11 will throw an exception when the TreeWalker root is not an Element.
  if (root.nodeType !== Node.ELEMENT_NODE) {
    return undefined;
  } // TypeScript isn't aware of IE11 behaving badly.


  const filter = _isBrokenIE11 ? acceptNode : {
    acceptNode
  };
  return dom.createTreeWalker(doc, root, NodeFilter.SHOW_ELEMENT, filter, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: We still don't want to completely break IE11, so, entityReferenceExpansion argument is not optional.
  false
  /* Last argument is not optional for IE11! */
  );
}
function getBoundingRect(getWindow, element) {
  let cacheId = element.__tabsterCacheId;
  const context = getInstanceContext(getWindow);
  const cached = cacheId ? context.containerBoundingRectCache[cacheId] : undefined;

  if (cached) {
    return cached.rect;
  }

  const scrollingElement = element.ownerDocument && element.ownerDocument.documentElement;

  if (!scrollingElement) {
    return new _DOMRect();
  } // A bounding rect of the top-level element contains the whole page regardless of the
  // scrollbar. So, we improvise a little and limiting the final result...


  let left = 0;
  let top = 0;
  let right = scrollingElement.clientWidth;
  let bottom = scrollingElement.clientHeight;

  if (element !== scrollingElement) {
    const r = element.getBoundingClientRect();
    left = Math.max(left, r.left);
    top = Math.max(top, r.top);
    right = Math.min(right, r.right);
    bottom = Math.min(bottom, r.bottom);
  }

  const rect = new _DOMRect(left < right ? left : -1, top < bottom ? top : -1, left < right ? right - left : 0, top < bottom ? bottom - top : 0);

  if (!cacheId) {
    cacheId = "r-" + ++context.lastContainerBoundingRectCacheId;
    element.__tabsterCacheId = cacheId;
  }

  context.containerBoundingRectCache[cacheId] = {
    rect,
    element
  };

  if (!context.containerBoundingRectCacheTimer) {
    context.containerBoundingRectCacheTimer = window.setTimeout(() => {
      context.containerBoundingRectCacheTimer = undefined;

      for (const cId of Object.keys(context.containerBoundingRectCache)) {
        delete context.containerBoundingRectCache[cId].element.__tabsterCacheId;
      }

      context.containerBoundingRectCache = {};
    }, 50);
  }

  return rect;
}
function isElementVerticallyVisibleInContainer(getWindow, element, tolerance) {
  const container = getScrollableContainer(element);

  if (!container) {
    return false;
  }

  const containerRect = getBoundingRect(getWindow, container);
  const elementRect = element.getBoundingClientRect();
  const intersectionTolerance = elementRect.height * (1 - tolerance);
  const topIntersection = Math.max(0, containerRect.top - elementRect.top);
  const bottomIntersection = Math.max(0, elementRect.bottom - containerRect.bottom);
  const totalIntersection = topIntersection + bottomIntersection;
  return totalIntersection === 0 || totalIntersection <= intersectionTolerance;
}
function scrollIntoView(getWindow, element, alignToTop) {
  // Built-in DOM's scrollIntoView() is cool, but when we have nested containers,
  // it scrolls all of them, not just the deepest one. So, trying to work it around.
  const container = getScrollableContainer(element);

  if (container) {
    const containerRect = getBoundingRect(getWindow, container);
    const elementRect = element.getBoundingClientRect();

    if (alignToTop) {
      container.scrollTop += elementRect.top - containerRect.top;
    } else {
      container.scrollTop += elementRect.bottom - containerRect.bottom;
    }
  }
}
function getScrollableContainer(element) {
  const doc = element.ownerDocument;

  if (doc) {
    for (let el = dom.getParentElement(element); el; el = dom.getParentElement(el)) {
      if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
        return el;
      }
    }

    return doc.documentElement;
  }

  return null;
}
function makeFocusIgnored(element) {
  element.__shouldIgnoreFocus = true;
}
function shouldIgnoreFocus(element) {
  return !!element.__shouldIgnoreFocus;
}
function getUId(wnd) {
  const rnd = new Uint32Array(4);

  if (wnd.crypto && wnd.crypto.getRandomValues) {
    wnd.crypto.getRandomValues(rnd);
  } else if (wnd.msCrypto && wnd.msCrypto.getRandomValues) {
    wnd.msCrypto.getRandomValues(rnd);
  } else {
    for (let i = 0; i < rnd.length; i++) {
      rnd[i] = 0xffffffff * Math.random();
    }
  }

  const srnd = [];

  for (let i = 0; i < rnd.length; i++) {
    srnd.push(rnd[i].toString(36));
  }

  srnd.push("|");
  srnd.push((++_uidCounter).toString(36));
  srnd.push("|");
  srnd.push(Date.now().toString(36));
  return srnd.join("");
}
function getElementUId(getWindow, element) {
  const context = getInstanceContext(getWindow);
  let uid = element.__tabsterElementUID;

  if (!uid) {
    uid = element.__tabsterElementUID = getUId(getWindow());
  }

  if (!context.elementByUId[uid] && documentContains(element.ownerDocument, element)) {
    context.elementByUId[uid] = new WeakHTMLElement(getWindow, element);
  }

  return uid;
}
function clearElementCache(getWindow, parent) {
  const context = getInstanceContext(getWindow);

  for (const key of Object.keys(context.elementByUId)) {
    const wel = context.elementByUId[key];
    const el = wel && wel.get();

    if (el && parent) {
      if (!dom.nodeContains(parent, el)) {
        continue;
      }
    }

    delete context.elementByUId[key];
  }
} // IE11 doesn't have document.contains()...

function documentContains(doc, element) {
  return dom.nodeContains(doc === null || doc === undefined ? undefined : doc.body, element);
}
function matchesSelector(element, selector) {
  const matches = element.matches || element.matchesSelector || element.msMatchesSelector || element.webkitMatchesSelector;
  return matches && matches.call(element, selector);
}
function getPromise(getWindow) {
  const context = getInstanceContext(getWindow);

  if (context.basics.Promise) {
    return context.basics.Promise;
  }

  throw new Error("No Promise defined.");
}
function getWeakRef(context) {
  return context.basics.WeakRef;
}
let _lastTabsterPartId = 0;
class TabsterPart {
  constructor(tabster, element, props) {
    const getWindow = tabster.getWindow;
    this._tabster = tabster;
    this._element = new WeakHTMLElement(getWindow, element);
    this._props = { ...props
    };
    this.id = "i" + ++_lastTabsterPartId;
  }

  getElement() {
    return this._element.get();
  }

  getProps() {
    return this._props;
  }

  setProps(props) {
    this._props = { ...props
    };
  }

}
/**
 * Dummy HTML elements that are used as focus sentinels for the DOM enclosed within them
 */

class DummyInput {
  constructor(getWindow, isOutside, props, element, fixedTarget) {
    var _a;

    this._focusIn = e => {
      if (this._fixedTarget) {
        const target = this._fixedTarget.get();

        if (target) {
          nativeFocus(target);
        }

        return;
      }

      const input = this.input;

      if (this.onFocusIn && input) {
        const relatedTarget = e.relatedTarget;
        this.onFocusIn(this, this._isBackward(true, input, relatedTarget), relatedTarget);
      }
    };

    this._focusOut = e => {
      if (this._fixedTarget) {
        return;
      }

      this.useDefaultAction = false;
      const input = this.input;

      if (this.onFocusOut && input) {
        const relatedTarget = e.relatedTarget;
        this.onFocusOut(this, this._isBackward(false, input, relatedTarget), relatedTarget);
      }
    };

    const win = getWindow();
    const input = win.document.createElement("i");
    input.tabIndex = 0;
    input.setAttribute("role", "none");
    input.setAttribute(TABSTER_DUMMY_INPUT_ATTRIBUTE_NAME, "");
    input.setAttribute("aria-hidden", "true");
    const style = input.style;
    style.position = "fixed";
    style.width = style.height = "1px";
    style.opacity = "0.001";
    style.zIndex = "-1";
    style.setProperty("content-visibility", "hidden");
    makeFocusIgnored(input);
    this.input = input;
    this.isFirst = props.isFirst;
    this.isOutside = isOutside;
    this._isPhantom = (_a = props.isPhantom) !== null && _a !== undefined ? _a : false;
    this._fixedTarget = fixedTarget;
    input.addEventListener("focusin", this._focusIn);
    input.addEventListener("focusout", this._focusOut);
    input.__tabsterDummyContainer = element;

    if (this._isPhantom) {
      this._disposeTimer = win.setTimeout(() => {
        delete this._disposeTimer;
        this.dispose();
      }, 0);

      this._clearDisposeTimeout = () => {
        if (this._disposeTimer) {
          win.clearTimeout(this._disposeTimer);
          delete this._disposeTimer;
        }

        delete this._clearDisposeTimeout;
      };
    }
  }

  dispose() {
    var _a;

    if (this._clearDisposeTimeout) {
      this._clearDisposeTimeout();
    }

    const input = this.input;

    if (!input) {
      return;
    }

    delete this._fixedTarget;
    delete this.onFocusIn;
    delete this.onFocusOut;
    delete this.input;
    input.removeEventListener("focusin", this._focusIn);
    input.removeEventListener("focusout", this._focusOut);
    delete input.__tabsterDummyContainer;
    (_a = dom.getParentNode(input)) === null || _a === undefined ? undefined : _a.removeChild(input);
  }

  setTopLeft(top, left) {
    var _a;

    const style = (_a = this.input) === null || _a === undefined ? undefined : _a.style;

    if (style) {
      style.top = `${top}px`;
      style.left = `${left}px`;
    }
  }

  _isBackward(isIn, current, previous) {
    return isIn && !previous ? !this.isFirst : !!(previous && current.compareDocumentPosition(previous) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

}
const DummyInputManagerPriorities = {
  Root: 1,
  Modalizer: 2,
  Mover: 3,
  Groupper: 4
};
class DummyInputManager {
  constructor(tabster, element, priority, sys, outsideByDefault, callForDefaultAction) {
    this._element = element;
    this._instance = new DummyInputManagerCore(tabster, element, this, priority, sys, outsideByDefault, callForDefaultAction);
  }

  _setHandlers(onFocusIn, onFocusOut) {
    this._onFocusIn = onFocusIn;
    this._onFocusOut = onFocusOut;
  }

  moveOut(backwards) {
    var _a;

    (_a = this._instance) === null || _a === undefined ? undefined : _a.moveOut(backwards);
  }

  moveOutWithDefaultAction(backwards, relatedEvent) {
    var _a;

    (_a = this._instance) === null || _a === undefined ? undefined : _a.moveOutWithDefaultAction(backwards, relatedEvent);
  }

  getHandler(isIn) {
    return isIn ? this._onFocusIn : this._onFocusOut;
  }

  setTabbable(tabbable) {
    var _a;

    (_a = this._instance) === null || _a === undefined ? undefined : _a.setTabbable(this, tabbable);
  }

  dispose() {
    if (this._instance) {
      this._instance.dispose(this);

      delete this._instance;
    }

    delete this._onFocusIn;
    delete this._onFocusOut;
  }

  static moveWithPhantomDummy(tabster, element, // The target element to move to or out of.
  moveOutOfElement, // Whether to move out of the element or into it.
  isBackward, // Are we tabbing of shift-tabbing?
  relatedEvent // The event that triggered the move.
  ) {
    // Phantom dummy is a hack to use browser's default action to move
    // focus from a specific point in the application to the next/previous
    // element. Default action is needed because next focusable element
    // is not always available to focus directly (for example, next focusable
    // is inside isolated iframe) or for uncontrolled areas we want to make
    // sure that something that controls it takes care of the focusing.
    // It works in a way that during the Tab key handling, we create a dummy
    // input element, place it to the specific place in the DOM and focus it,
    // then the default action of the Tab press will move focus from our dummy
    // input. And we remove it from the DOM right after that.
    const dummy = new DummyInput(tabster.getWindow, true, {
      isPhantom: true,
      isFirst: true
    });
    const input = dummy.input;

    if (input) {
      let parent;
      let insertBefore; // Let's say we have a following DOM structure:
      // <div>
      //   <button>Button1</button>
      //   <div id="uncontrolled" data-tabster={uncontrolled: {}}>
      //     <button>Button2</button>
      //     <button>Button3</button>
      //   </div>
      //   <button>Button4</button>
      // </div>
      //
      // We pass the "uncontrolled" div as the element to move to or out of.
      //
      // When we pass moveOutOfElement=true and isBackward=false,
      // the phantom dummy input will be inserted before Button4.
      //
      // When we pass moveOutOfElement=true and isBackward=true, there are
      // two cases. If the uncontrolled element is focusable (has tabindex=0),
      // the phantom dummy input will be inserted after Button1. If the
      // uncontrolled element is not focusable, the phantom dummy input will be
      // inserted before Button2.
      //
      // When we pass moveOutOfElement=false and isBackward=false, the
      // phantom dummy input will be inserted after Button1.
      //
      // When we pass moveOutOfElement=false and isBackward=true, the phantom
      // dummy input will be inserted before Button4.
      //
      // And we have a corner case for <body> and we make sure that the inserted
      // dummy is inserted properly when there are existing permanent dummies.

      if (element.tagName === "BODY") {
        // We cannot insert elements outside of BODY.
        parent = element;
        insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? dom.getFirstElementChild(element) : null;
      } else {
        if (moveOutOfElement && (!isBackward || isBackward && !tabster.focusable.isFocusable(element, false, true, true))) {
          parent = element;
          insertBefore = isBackward ? element.firstElementChild : null;
        } else {
          parent = dom.getParentElement(element);
          insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? element : dom.getNextElementSibling(element);
        }

        let potentialDummy;
        let dummyFor;

        do {
          // This is a safety pillow for the cases when someone, combines
          // groupper with uncontrolled on the same node. Which is technically
          // not correct, but moving into the container element via its dummy
          // input would produce a correct behaviour in uncontrolled mode.
          potentialDummy = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? dom.getPreviousElementSibling(insertBefore) : insertBefore;
          dummyFor = getDummyInputContainer(potentialDummy);

          if (dummyFor === element) {
            insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? potentialDummy : dom.getNextElementSibling(potentialDummy);
          } else {
            dummyFor = null;
          }
        } while (dummyFor);
      }

      if (parent === null || parent === undefined ? undefined : parent.dispatchEvent(new TabsterMoveFocusEvent({
        by: "root",
        owner: parent,
        next: null,
        relatedEvent
      }))) {
        dom.insertBefore(parent, input, insertBefore);
        nativeFocus(input);
      }
    }
  }

  static addPhantomDummyWithTarget(tabster, sourceElement, isBackward, targetElement) {
    const dummy = new DummyInput(tabster.getWindow, true, {
      isPhantom: true,
      isFirst: true
    }, undefined, new WeakHTMLElement(tabster.getWindow, targetElement));
    const input = dummy.input;

    if (input) {
      let dummyParent;
      let insertBefore;

      if (hasSubFocusable(sourceElement) && !isBackward) {
        dummyParent = sourceElement;
        insertBefore = dom.getFirstElementChild(sourceElement);
      } else {
        dummyParent = dom.getParentElement(sourceElement);
        insertBefore = isBackward ? sourceElement : dom.getNextElementSibling(sourceElement);
      }

      if (dummyParent) {
        dom.insertBefore(dummyParent, input, insertBefore);
      }
    }
  }

}

function setDummyInputDebugValue(dummy, wrappers) {
  var _a;

  const what = {
    1: "Root",
    2: "Modalizer",
    3: "Mover",
    4: "Groupper"
  };
  (_a = dummy.input) === null || _a === undefined ? undefined : _a.setAttribute(TABSTER_DUMMY_INPUT_ATTRIBUTE_NAME, [`isFirst=${dummy.isFirst}`, `isOutside=${dummy.isOutside}`, ...wrappers.map(w => `(${what[w.priority]}, tabbable=${w.tabbable})`)].join(", "));
}

class DummyInputObserver {
  constructor(win) {
    this._updateQueue = new Set();
    this._lastUpdateQueueTime = 0;
    this._changedParents = new WeakSet();
    this._dummyElements = [];
    this._dummyCallbacks = new WeakMap();

    this._domChanged = parent => {
      var _a;

      if (this._changedParents.has(parent)) {
        return;
      }

      this._changedParents.add(parent);

      if (this._updateDummyInputsTimer) {
        return;
      }

      this._updateDummyInputsTimer = (_a = this._win) === null || _a === undefined ? undefined : _a.call(this).setTimeout(() => {
        delete this._updateDummyInputsTimer;

        for (const ref of this._dummyElements) {
          const dummyElement = ref.get();

          if (dummyElement) {
            const callback = this._dummyCallbacks.get(dummyElement);

            if (callback) {
              const dummyParent = dom.getParentNode(dummyElement);

              if (!dummyParent || this._changedParents.has(dummyParent)) {
                callback();
              }
            }
          }
        }

        this._changedParents = new WeakSet();
      }, _updateDummyInputsTimeout);
    };

    this._win = win;
  }

  add(dummy, callback) {
    if (!this._dummyCallbacks.has(dummy) && this._win) {
      this._dummyElements.push(new WeakHTMLElement(this._win, dummy));

      this._dummyCallbacks.set(dummy, callback);

      this.domChanged = this._domChanged;
    }
  }

  remove(dummy) {
    this._dummyElements = this._dummyElements.filter(ref => {
      const element = ref.get();
      return element && element !== dummy;
    });

    this._dummyCallbacks.delete(dummy);

    if (this._dummyElements.length === 0) {
      delete this.domChanged;
    }
  }

  dispose() {
    var _a;

    const win = (_a = this._win) === null || _a === undefined ? undefined : _a.call(this);

    if (this._updateTimer) {
      win === null || win === undefined ? undefined : win.clearTimeout(this._updateTimer);
      delete this._updateTimer;
    }

    if (this._updateDummyInputsTimer) {
      win === null || win === undefined ? undefined : win.clearTimeout(this._updateDummyInputsTimer);
      delete this._updateDummyInputsTimer;
    }

    this._changedParents = new WeakSet();
    this._dummyCallbacks = new WeakMap();
    this._dummyElements = [];

    this._updateQueue.clear();

    delete this.domChanged;
    delete this._win;
  }

  updatePositions(compute) {
    if (!this._win) {
      // As this is a public method, we make sure that it has no effect when
      // called after dispose().
      return;
    }

    this._updateQueue.add(compute);

    this._lastUpdateQueueTime = Date.now();

    this._scheduledUpdatePositions();
  }

  _scheduledUpdatePositions() {
    var _a;

    if (this._updateTimer) {
      return;
    }

    this._updateTimer = (_a = this._win) === null || _a === undefined ? undefined : _a.call(this).setTimeout(() => {
      delete this._updateTimer; // updatePositions() might be called quite a lot during the scrolling.
      // So, instead of clearing the timeout and scheduling a new one, we
      // check if enough time has passed since the last updatePositions() call
      // and only schedule a new one if not.
      // At maximum, we will update dummy inputs positions
      // _updateDummyInputsTimeout * 2 after the last updatePositions() call.

      if (this._lastUpdateQueueTime + _updateDummyInputsTimeout <= Date.now()) {
        // A cache for current bulk of updates to reduce getComputedStyle() calls.
        const scrollTopLeftCache = new Map();
        const setTopLeftCallbacks = [];

        for (const compute of this._updateQueue) {
          setTopLeftCallbacks.push(compute(scrollTopLeftCache));
        }

        this._updateQueue.clear(); // We're splitting the computation of offsets and setting them to avoid extra
        // reflows.


        for (const setTopLeft of setTopLeftCallbacks) {
          setTopLeft();
        } // Explicitly clear to not hold references till the next garbage collection.


        scrollTopLeftCache.clear();
      } else {
        this._scheduledUpdatePositions();
      }
    }, _updateDummyInputsTimeout);
  }

}
/**
 * Parent class that encapsulates the behaviour of dummy inputs (focus sentinels)
 */

class DummyInputManagerCore {
  constructor(tabster, element, manager, priority, sys, outsideByDefault, callForDefaultAction) {
    this._wrappers = [];
    this._isOutside = false;
    this._transformElements = new Set();

    this._onFocusIn = (dummyInput, isBackward, relatedTarget) => {
      this._onFocus(true, dummyInput, isBackward, relatedTarget);
    };

    this._onFocusOut = (dummyInput, isBackward, relatedTarget) => {
      this._onFocus(false, dummyInput, isBackward, relatedTarget);
    };

    this.moveOut = backwards => {
      var _a;

      const first = this._firstDummy;
      const last = this._lastDummy;

      if (first && last) {
        // For the sake of performance optimization, the dummy input
        // position in the DOM updates asynchronously from the DOM change.
        // Calling _ensurePosition() to make sure the position is correct.
        this._ensurePosition();

        const firstInput = first.input;
        const lastInput = last.input;
        const element = (_a = this._element) === null || _a === undefined ? undefined : _a.get();

        if (firstInput && lastInput && element) {
          let toFocus;

          if (backwards) {
            firstInput.tabIndex = 0;
            toFocus = firstInput;
          } else {
            lastInput.tabIndex = 0;
            toFocus = lastInput;
          }

          if (toFocus) {
            nativeFocus(toFocus);
          }
        }
      }
    };
    /**
     * Prepares to move focus out of the given element by focusing
     * one of the dummy inputs and setting the `useDefaultAction` flag
     * @param backwards focus moving to an element behind the given element
     */


    this.moveOutWithDefaultAction = (backwards, relatedEvent) => {
      var _a;

      const first = this._firstDummy;
      const last = this._lastDummy;

      if (first && last) {
        // For the sake of performance optimization, the dummy input
        // position in the DOM updates asynchronously from the DOM change.
        // Calling _ensurePosition() to make sure the position is correct.
        this._ensurePosition();

        const firstInput = first.input;
        const lastInput = last.input;
        const element = (_a = this._element) === null || _a === undefined ? undefined : _a.get();

        if (firstInput && lastInput && element) {
          let toFocus;

          if (backwards) {
            if (!first.isOutside && this._tabster.focusable.isFocusable(element, true, true, true)) {
              toFocus = element;
            } else {
              first.useDefaultAction = true;
              firstInput.tabIndex = 0;
              toFocus = firstInput;
            }
          } else {
            last.useDefaultAction = true;
            lastInput.tabIndex = 0;
            toFocus = lastInput;
          }

          if (toFocus && element.dispatchEvent(new TabsterMoveFocusEvent({
            by: "root",
            owner: element,
            next: null,
            relatedEvent
          }))) {
            nativeFocus(toFocus);
          }
        }
      }
    };

    this.setTabbable = (manager, tabbable) => {
      var _a, _b;

      for (const w of this._wrappers) {
        if (w.manager === manager) {
          w.tabbable = tabbable;
          break;
        }
      }

      const wrapper = this._getCurrent();

      if (wrapper) {
        const tabIndex = wrapper.tabbable ? 0 : -1;
        let input = (_a = this._firstDummy) === null || _a === undefined ? undefined : _a.input;

        if (input) {
          input.tabIndex = tabIndex;
        }

        input = (_b = this._lastDummy) === null || _b === undefined ? undefined : _b.input;

        if (input) {
          input.tabIndex = tabIndex;
        }
      }

      if (process.env.NODE_ENV === 'development') {
        this._firstDummy && setDummyInputDebugValue(this._firstDummy, this._wrappers);
        this._lastDummy && setDummyInputDebugValue(this._lastDummy, this._wrappers);
      }
    };
    /**
     * Adds dummy inputs as the first and last child of the given element
     * Called each time the children under the element is mutated
     */


    this._addDummyInputs = () => {
      if (this._addTimer) {
        return;
      }

      this._addTimer = this._getWindow().setTimeout(() => {
        delete this._addTimer;

        this._ensurePosition();

        if (process.env.NODE_ENV === 'development') {
          this._firstDummy && setDummyInputDebugValue(this._firstDummy, this._wrappers);
          this._lastDummy && setDummyInputDebugValue(this._lastDummy, this._wrappers);
        }

        this._addTransformOffsets();
      }, 0);
    };

    this._addTransformOffsets = () => {
      this._tabster._dummyObserver.updatePositions(this._computeTransformOffsets);
    };

    this._computeTransformOffsets = scrollTopLeftCache => {
      var _a, _b;

      const from = ((_a = this._firstDummy) === null || _a === undefined ? undefined : _a.input) || ((_b = this._lastDummy) === null || _b === undefined ? undefined : _b.input);
      const transformElements = this._transformElements;
      const newTransformElements = new Set();
      let scrollTop = 0;
      let scrollLeft = 0;

      const win = this._getWindow();

      for (let element = from; element && element.nodeType === Node.ELEMENT_NODE; element = dom.getParentElement(element)) {
        let scrollTopLeft = scrollTopLeftCache.get(element); // getComputedStyle() and element.scrollLeft/Top() cause style recalculation,
        // so we cache the result across all elements in the current bulk.

        if (scrollTopLeft === undefined) {
          const transform = win.getComputedStyle(element).transform;

          if (transform && transform !== "none") {
            scrollTopLeft = {
              scrollTop: element.scrollTop,
              scrollLeft: element.scrollLeft
            };
          }

          scrollTopLeftCache.set(element, scrollTopLeft || null);
        }

        if (scrollTopLeft) {
          newTransformElements.add(element);

          if (!transformElements.has(element)) {
            element.addEventListener("scroll", this._addTransformOffsets);
          }

          scrollTop += scrollTopLeft.scrollTop;
          scrollLeft += scrollTopLeft.scrollLeft;
        }
      }

      for (const el of transformElements) {
        if (!newTransformElements.has(el)) {
          el.removeEventListener("scroll", this._addTransformOffsets);
        }
      }

      this._transformElements = newTransformElements;
      return () => {
        var _a, _b;

        (_a = this._firstDummy) === null || _a === undefined ? undefined : _a.setTopLeft(scrollTop, scrollLeft);
        (_b = this._lastDummy) === null || _b === undefined ? undefined : _b.setTopLeft(scrollTop, scrollLeft);
      };
    };

    const el = element.get();

    if (!el) {
      throw new Error("No element");
    }

    this._tabster = tabster;
    this._getWindow = tabster.getWindow;
    this._callForDefaultAction = callForDefaultAction;
    const instance = el.__tabsterDummy;

    (instance || this)._wrappers.push({
      manager,
      priority,
      tabbable: true
    });

    if (instance) {
      if (process.env.NODE_ENV === 'development') {
        this._firstDummy && setDummyInputDebugValue(this._firstDummy, instance._wrappers);
        this._lastDummy && setDummyInputDebugValue(this._lastDummy, instance._wrappers);
      }

      return instance;
    }

    el.__tabsterDummy = this; // Some elements allow only specific types of direct descendants and we need to
    // put our dummy inputs inside or outside of the element accordingly.

    const forcedDummyPosition = sys === null || sys === undefined ? undefined : sys.dummyInputsPosition;
    const tagName = el.tagName;
    this._isOutside = !forcedDummyPosition ? (outsideByDefault || tagName === "UL" || tagName === "OL" || tagName === "TABLE") && !(tagName === "LI" || tagName === "TD" || tagName === "TH") : forcedDummyPosition === SysDummyInputsPositions.Outside;
    this._firstDummy = new DummyInput(this._getWindow, this._isOutside, {
      isFirst: true
    }, element);
    this._lastDummy = new DummyInput(this._getWindow, this._isOutside, {
      isFirst: false
    }, element); // We will be checking dummy input parents to see if their child list have changed.
    // So, it is enough to have just one of the inputs observed, because
    // both dummy inputs always have the same parent.

    const dummyElement = this._firstDummy.input;
    dummyElement && tabster._dummyObserver.add(dummyElement, this._addDummyInputs);
    this._firstDummy.onFocusIn = this._onFocusIn;
    this._firstDummy.onFocusOut = this._onFocusOut;
    this._lastDummy.onFocusIn = this._onFocusIn;
    this._lastDummy.onFocusOut = this._onFocusOut;
    this._element = element;

    this._addDummyInputs();
  }

  dispose(manager, force) {
    var _a, _b, _c, _d;

    const wrappers = this._wrappers = this._wrappers.filter(w => w.manager !== manager && !force);

    if (process.env.NODE_ENV === 'development') {
      this._firstDummy && setDummyInputDebugValue(this._firstDummy, wrappers);
      this._lastDummy && setDummyInputDebugValue(this._lastDummy, wrappers);
    }

    if (wrappers.length === 0) {
      delete ((_a = this._element) === null || _a === undefined ? undefined : _a.get()).__tabsterDummy;

      for (const el of this._transformElements) {
        el.removeEventListener("scroll", this._addTransformOffsets);
      }

      this._transformElements.clear();

      const win = this._getWindow();

      if (this._addTimer) {
        win.clearTimeout(this._addTimer);
        delete this._addTimer;
      }

      const dummyElement = (_b = this._firstDummy) === null || _b === undefined ? undefined : _b.input;
      dummyElement && this._tabster._dummyObserver.remove(dummyElement);
      (_c = this._firstDummy) === null || _c === undefined ? undefined : _c.dispose();
      (_d = this._lastDummy) === null || _d === undefined ? undefined : _d.dispose();
    }
  }

  _onFocus(isIn, dummyInput, isBackward, relatedTarget) {
    var _a;

    const wrapper = this._getCurrent();

    if (wrapper && (!dummyInput.useDefaultAction || this._callForDefaultAction)) {
      (_a = wrapper.manager.getHandler(isIn)) === null || _a === undefined ? undefined : _a(dummyInput, isBackward, relatedTarget);
    }
  }

  _getCurrent() {
    this._wrappers.sort((a, b) => {
      if (a.tabbable !== b.tabbable) {
        return a.tabbable ? -1 : 1;
      }

      return a.priority - b.priority;
    });

    return this._wrappers[0];
  }

  _ensurePosition() {
    var _a, _b, _c;

    const element = (_a = this._element) === null || _a === undefined ? undefined : _a.get();
    const firstDummyInput = (_b = this._firstDummy) === null || _b === undefined ? undefined : _b.input;
    const lastDummyInput = (_c = this._lastDummy) === null || _c === undefined ? undefined : _c.input;

    if (!element || !firstDummyInput || !lastDummyInput) {
      return;
    }

    if (this._isOutside) {
      const elementParent = dom.getParentNode(element);

      if (elementParent) {
        const nextSibling = dom.getNextSibling(element);

        if (nextSibling !== lastDummyInput) {
          dom.insertBefore(elementParent, lastDummyInput, nextSibling);
        }

        if (dom.getPreviousElementSibling(element) !== firstDummyInput) {
          dom.insertBefore(elementParent, firstDummyInput, element);
        }
      }
    } else {
      if (dom.getLastElementChild(element) !== lastDummyInput) {
        dom.appendChild(element, lastDummyInput);
      }

      const firstElementChild = dom.getFirstElementChild(element);

      if (firstElementChild && firstElementChild !== firstDummyInput && firstElementChild.parentNode) {
        dom.insertBefore(firstElementChild.parentNode, firstDummyInput, firstElementChild);
      }
    }
  }

}

function getLastChild$2(container) {
  let lastChild = null;

  for (let i = dom.getLastElementChild(container); i; i = dom.getLastElementChild(i)) {
    lastChild = i;
  }

  return lastChild || undefined;
}
function getAdjacentElement(from, prev) {
  let cur = from;
  let adjacent = null;

  while (cur && !adjacent) {
    adjacent = prev ? dom.getPreviousElementSibling(cur) : dom.getNextElementSibling(cur);
    cur = dom.getParentElement(cur);
  }

  return adjacent || undefined;
}
function augmentAttribute(tabster, element, name, value // Restore original value when undefined.
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const entry = tabster.storageEntry(element, true);
  let ret = false;

  if (!entry.aug) {
    if (value === undefined) {
      return ret;
    }

    entry.aug = {};
  }

  if (value === undefined) {
    if (name in entry.aug) {
      const origVal = entry.aug[name];
      delete entry.aug[name];

      if (origVal === null) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, origVal);
      }

      ret = true;
    }
  } else {
    let origValue;

    if (!(name in entry.aug)) {
      origValue = element.getAttribute(name);
    }

    if (origValue !== undefined && origValue !== value) {
      entry.aug[name] = origValue;

      if (value === null) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value);
      }

      ret = true;
    }
  }

  if (value === undefined && Object.keys(entry.aug).length === 0) {
    delete entry.aug;
    tabster.storageEntry(element, false);
  }

  return ret;
}
function isDisplayNone(element) {
  var _a, _b;

  const elementDocument = element.ownerDocument;
  const computedStyle = (_a = elementDocument.defaultView) === null || _a === undefined ? undefined : _a.getComputedStyle(element); // offsetParent is null for elements with display:none, display:fixed and for <body>.

  if (element.offsetParent === null && elementDocument.body !== element && (computedStyle === null || computedStyle === undefined ? undefined : computedStyle.position) !== "fixed") {
    return true;
  } // For our purposes of looking for focusable elements, visibility:hidden has the same
  // effect as display:none.


  if ((computedStyle === null || computedStyle === undefined ? undefined : computedStyle.visibility) === "hidden") {
    return true;
  } // if an element has display: fixed, we need to check if it is also hidden with CSS,
  // or within a parent hidden with CSS


  if ((computedStyle === null || computedStyle === undefined ? undefined : computedStyle.position) === "fixed") {
    if (computedStyle.display === "none") {
      return true;
    }

    if (((_b = element.parentElement) === null || _b === undefined ? undefined : _b.offsetParent) === null && elementDocument.body !== element.parentElement) {
      return true;
    }
  }

  return false;
}
function isRadio(element) {
  return element.tagName === "INPUT" && !!element.name && element.type === "radio";
}
function getRadioButtonGroup(element) {
  if (!isRadio(element)) {
    return;
  }

  const name = element.name;
  let radioButtons = Array.from(dom.getElementsByName(element, name));
  let checked;
  radioButtons = radioButtons.filter(el => {
    if (isRadio(el)) {
      if (el.checked) {
        checked = el;
      }

      return true;
    }

    return false;
  });
  return {
    name,
    buttons: new Set(radioButtons),
    checked
  };
}
/**
 * If the passed element is Tabster dummy input, returns the container element this dummy input belongs to.
 * @param element Element to check for being dummy input.
 * @returns Dummy input container element (if the passed element is a dummy input) or null.
 */

function getDummyInputContainer(element) {
  var _a;

  return ((_a = element === null || element === undefined ? undefined : element.__tabsterDummyContainer) === null || _a === undefined ? undefined : _a.get()) || null;
}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function getTabsterAttribute(props, plain) {
  const attr = JSON.stringify(props);

  {
    return attr;
  }
}
/**
 * Updates Tabster props object with new props.
 * @param element an element to set data-tabster attribute on.
 * @param props current Tabster props to update.
 * @param newProps new Tabster props to add.
 *  When the value of a property in newProps is undefined, the property
 *  will be removed from the attribute.
 */

function mergeTabsterProps(props, newProps) {
  for (const key of Object.keys(newProps)) {
    const value = newProps[key];

    if (value) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      props[key] = value;
    } else {
      delete props[key];
    }
  }
}
/**
 * Sets or updates Tabster attribute of the element.
 * @param element an element to set data-tabster attribute on.
 * @param newProps new Tabster props to set.
 * @param update if true, newProps will be merged with the existing props.
 *  When true and the value of a property in newProps is undefined, the property
 *  will be removed from the attribute.
 */

function setTabsterAttribute(element, newProps, update) {
  let props;

  {
    const attr = element.getAttribute(TABSTER_ATTRIBUTE_NAME);

    if (attr) {
      try {
        props = JSON.parse(attr);
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error(`data-tabster attribute error: ${e}`, element);
        }
      }
    }
  }

  if (!props) {
    props = {};
  }

  mergeTabsterProps(props, newProps);

  if (Object.keys(props).length > 0) {
    element.setAttribute(TABSTER_ATTRIBUTE_NAME, getTabsterAttribute(props));
  } else {
    element.removeAttribute(TABSTER_ATTRIBUTE_NAME);
  }
}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

function _setInformativeStyle$3(weakElement, remove, id) {
  if (process.env.NODE_ENV === 'development') {
    const element = weakElement.get();

    if (element) {
      if (remove) {
        element.style.removeProperty("--tabster-root");
      } else {
        element.style.setProperty("--tabster-root", id + ",");
      }
    }
  }
}

class RootDummyManager extends DummyInputManager {
  constructor(tabster, element, setFocused, sys) {
    super(tabster, element, DummyInputManagerPriorities.Root, sys, undefined, true);

    this._onDummyInputFocus = dummyInput => {
      var _a;

      if (dummyInput.useDefaultAction) {
        // When we've reached the last focusable element, we want to let the browser
        // to move the focus outside of the page. In order to do that we're synchronously
        // calling focus() of the dummy input from the Tab key handler and allowing
        // the default action to move the focus out.
        this._setFocused(false);
      } else {
        // The only way a dummy input gets focused is during the keyboard navigation.
        this._tabster.keyboardNavigation.setNavigatingWithKeyboard(true);

        const element = this._element.get();

        if (element) {
          this._setFocused(true);

          const toFocus = this._tabster.focusedElement.getFirstOrLastTabbable(dummyInput.isFirst, {
            container: element,
            ignoreAccessibility: true
          });

          if (toFocus) {
            nativeFocus(toFocus);
            return;
          }
        }

        (_a = dummyInput.input) === null || _a === undefined ? undefined : _a.blur();
      }
    };

    this._setHandlers(this._onDummyInputFocus);

    this._tabster = tabster;
    this._setFocused = setFocused;
  }

}

class Root extends TabsterPart {
  constructor(tabster, element, onDispose, props, sys) {
    super(tabster, element, props);
    this._isFocused = false;

    this._setFocused = hasFocused => {
      var _a;

      if (this._setFocusedTimer) {
        this._tabster.getWindow().clearTimeout(this._setFocusedTimer);

        delete this._setFocusedTimer;
      }

      if (this._isFocused === hasFocused) {
        return;
      }

      const element = this._element.get();

      if (element) {
        if (hasFocused) {
          this._isFocused = true;
          (_a = this._dummyManager) === null || _a === undefined ? undefined : _a.setTabbable(false);
          element.dispatchEvent(new RootFocusEvent({
            element
          }));
        } else {
          this._setFocusedTimer = this._tabster.getWindow().setTimeout(() => {
            var _a;

            delete this._setFocusedTimer;
            this._isFocused = false;
            (_a = this._dummyManager) === null || _a === undefined ? undefined : _a.setTabbable(true);
            element.dispatchEvent(new RootBlurEvent({
              element
            }));
          }, 0);
        }
      }
    };

    this._onFocusIn = event => {
      const getParent = this._tabster.getParent;

      const rootElement = this._element.get();

      let curElement = event.composedPath()[0];

      do {
        if (curElement === rootElement) {
          this._setFocused(true);

          return;
        }

        curElement = curElement && getParent(curElement);
      } while (curElement);
    };

    this._onFocusOut = () => {
      this._setFocused(false);
    };

    this._onDispose = onDispose;
    const win = tabster.getWindow;
    this.uid = getElementUId(win, element);
    this._sys = sys;

    if (tabster.controlTab || tabster.rootDummyInputs) {
      this.addDummyInputs();
    }

    const w = win();
    const doc = w.document;
    doc.addEventListener(KEYBORG_FOCUSIN, this._onFocusIn);
    doc.addEventListener(KEYBORG_FOCUSOUT, this._onFocusOut);

    this._add();
  }

  addDummyInputs() {
    if (!this._dummyManager) {
      this._dummyManager = new RootDummyManager(this._tabster, this._element, this._setFocused, this._sys);
    }
  }

  dispose() {
    var _a;

    this._onDispose(this);

    const win = this._tabster.getWindow();

    const doc = win.document;
    doc.removeEventListener(KEYBORG_FOCUSIN, this._onFocusIn);
    doc.removeEventListener(KEYBORG_FOCUSOUT, this._onFocusOut);

    if (this._setFocusedTimer) {
      win.clearTimeout(this._setFocusedTimer);
      delete this._setFocusedTimer;
    }

    (_a = this._dummyManager) === null || _a === undefined ? undefined : _a.dispose();

    this._remove();
  }

  moveOutWithDefaultAction(isBackward, relatedEvent) {
    const dummyManager = this._dummyManager;

    if (dummyManager) {
      dummyManager.moveOutWithDefaultAction(isBackward, relatedEvent);
    } else {
      const el = this.getElement();

      if (el) {
        RootDummyManager.moveWithPhantomDummy(this._tabster, el, true, isBackward, relatedEvent);
      }
    }
  }

  _add() {
    if (process.env.NODE_ENV === 'development') {
      _setInformativeStyle$3(this._element, false, this.uid);
    }
  }

  _remove() {
    if (process.env.NODE_ENV === 'development') {
      _setInformativeStyle$3(this._element, true);
    }
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

class RootAPI {
  constructor(tabster, autoRoot) {
    this._autoRootWaiting = false;
    this._roots = {};
    this._forceDummy = false;
    this.rootById = {};

    this._autoRootCreate = () => {
      var _a;

      const doc = this._win().document;

      const body = doc.body;

      if (body) {
        this._autoRootUnwait(doc);

        const props = this._autoRoot;

        if (props) {
          setTabsterAttribute(body, {
            root: props
          });
          updateTabsterByAttribute(this._tabster, body);
          return (_a = getTabsterOnElement(this._tabster, body)) === null || _a === undefined ? undefined : _a.root;
        }
      } else if (!this._autoRootWaiting) {
        this._autoRootWaiting = true;
        doc.addEventListener("readystatechange", this._autoRootCreate);
      }

      return undefined;
    };

    this._onRootDispose = root => {
      delete this._roots[root.id];
    };

    this._tabster = tabster;
    this._win = tabster.getWindow;
    this._autoRoot = autoRoot;
    tabster.queueInit(() => {
      if (this._autoRoot) {
        this._autoRootCreate();
      }
    });
  }

  _autoRootUnwait(doc) {
    doc.removeEventListener("readystatechange", this._autoRootCreate);
    this._autoRootWaiting = false;
  }

  dispose() {
    const win = this._win();

    this._autoRootUnwait(win.document);

    delete this._autoRoot;
    Object.keys(this._roots).forEach(rootId => {
      if (this._roots[rootId]) {
        this._roots[rootId].dispose();

        delete this._roots[rootId];
      }
    });
    this.rootById = {};
  }

  createRoot(element, props, sys) {
    if (process.env.NODE_ENV === 'development') ;

    const newRoot = new Root(this._tabster, element, this._onRootDispose, props, sys);
    this._roots[newRoot.id] = newRoot;

    if (this._forceDummy) {
      newRoot.addDummyInputs();
    }

    return newRoot;
  }

  addDummyInputs() {
    this._forceDummy = true;
    const roots = this._roots;

    for (const id of Object.keys(roots)) {
      roots[id].addDummyInputs();
    }
  }

  static getRootByUId(getWindow, id) {
    const tabster = getWindow().__tabsterInstance;

    return tabster && tabster.root.rootById[id];
  }
  /**
   * Fetches the tabster context for an element walking up its ancestors
   *
   * @param tabster Tabster instance
   * @param element The element the tabster context should represent
   * @param options Additional options
   * @returns undefined if the element is not a child of a tabster root, otherwise all applicable tabster behaviours and configurations
   */


  static getTabsterContext(tabster, element, options) {
    if (options === undefined) {
      options = {};
    }

    var _a, _b, _c, _d;

    if (!element.ownerDocument) {
      return undefined;
    }

    const {
      checkRtl,
      referenceElement
    } = options;
    const getParent = tabster.getParent; // Normally, the initialization starts on the next tick after the tabster
    // instance creation. However, if the application starts using it before
    // the next tick, we need to make sure the initialization is done.

    tabster.drainInitQueue();
    let root;
    let modalizer;
    let groupper;
    let mover;
    let excludedFromMover = false;
    let groupperBeforeMover;
    let modalizerInGroupper;
    let dirRightToLeft;
    let uncontrolled;
    let curElement = referenceElement || element;
    const ignoreKeydown = {};

    while (curElement && (!root || checkRtl)) {
      const tabsterOnElement = getTabsterOnElement(tabster, curElement);

      if (checkRtl && dirRightToLeft === undefined) {
        const dir = curElement.dir;

        if (dir) {
          dirRightToLeft = dir.toLowerCase() === "rtl";
        }
      }

      if (!tabsterOnElement) {
        curElement = getParent(curElement);
        continue;
      }

      const tagName = curElement.tagName;

      if (tabsterOnElement.uncontrolled || tagName === "IFRAME" || tagName === "WEBVIEW") {
        uncontrolled = curElement;
      }

      if (!mover && ((_a = tabsterOnElement.focusable) === null || _a === undefined ? undefined : _a.excludeFromMover) && !groupper) {
        excludedFromMover = true;
      }

      const curModalizer = tabsterOnElement.modalizer;
      const curGroupper = tabsterOnElement.groupper;
      const curMover = tabsterOnElement.mover;

      if (!modalizer && curModalizer) {
        modalizer = curModalizer;
      }

      if (!groupper && curGroupper && (!modalizer || curModalizer)) {
        if (modalizer) {
          // Modalizer dominates the groupper when they are on the same node and the groupper is active.
          if (!curGroupper.isActive() && curGroupper.getProps().tabbability && modalizer.userId !== ((_b = tabster.modalizer) === null || _b === undefined ? undefined : _b.activeId)) {
            modalizer = undefined;
            groupper = curGroupper;
          }

          modalizerInGroupper = curGroupper;
        } else {
          groupper = curGroupper;
        }
      }

      if (!mover && curMover && (!modalizer || curModalizer) && (!curGroupper || curElement !== element) && curElement.contains(element) // Mover makes sense only for really inside elements, not for virutal out of the DOM order children.
      ) {
        mover = curMover;
        groupperBeforeMover = !!groupper && groupper !== curGroupper;
      }

      if (tabsterOnElement.root) {
        root = tabsterOnElement.root;
      }

      if ((_c = tabsterOnElement.focusable) === null || _c === undefined ? undefined : _c.ignoreKeydown) {
        Object.assign(ignoreKeydown, tabsterOnElement.focusable.ignoreKeydown);
      }

      curElement = getParent(curElement);
    } // No root element could be found, try to get an auto root


    if (!root) {
      const rootAPI = tabster.root;
      const autoRoot = rootAPI._autoRoot;

      if (autoRoot) {
        if ((_d = element.ownerDocument) === null || _d === undefined ? undefined : _d.body) {
          root = rootAPI._autoRootCreate();
        }
      }
    }

    if (groupper && !mover) {
      groupperBeforeMover = true;
    }

    if (process.env.NODE_ENV === 'development' && !root) {
      if (modalizer || groupper || mover) {
        console.error("Tabster Root is required for Mover, Groupper and Modalizer to work.");
      }
    }

    const shouldIgnoreKeydown = event => !!ignoreKeydown[event.key];

    return root ? {
      root,
      modalizer,
      groupper,
      mover,
      groupperBeforeMover,
      modalizerInGroupper,
      rtl: checkRtl ? !!dirRightToLeft : undefined,
      uncontrolled,
      excludedFromMover,
      ignoreKeydown: shouldIgnoreKeydown
    } : undefined;
  }

  static getRoot(tabster, element) {
    var _a;

    const getParent = tabster.getParent;

    for (let el = element; el; el = getParent(el)) {
      const root = (_a = getTabsterOnElement(tabster, el)) === null || _a === undefined ? undefined : _a.root;

      if (root) {
        return root;
      }
    }

    return undefined;
  }

  onRoot(root, removed) {
    if (removed) {
      delete this.rootById[root.uid];
    } else {
      this.rootById[root.uid] = root;
    }
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
class Subscribable {
  constructor() {
    this._callbacks = [];
  }

  dispose() {
    this._callbacks = [];
    delete this._val;
  }

  subscribe(callback) {
    const callbacks = this._callbacks;
    const index = callbacks.indexOf(callback);

    if (index < 0) {
      callbacks.push(callback);
    }
  }

  subscribeFirst(callback) {
    const callbacks = this._callbacks;
    const index = callbacks.indexOf(callback);

    if (index >= 0) {
      callbacks.splice(index, 1);
    }

    callbacks.unshift(callback);
  }

  unsubscribe(callback) {
    const index = this._callbacks.indexOf(callback);

    if (index >= 0) {
      this._callbacks.splice(index, 1);
    }
  }

  setVal(val, detail) {
    if (this._val === val) {
      return;
    }

    this._val = val;

    this._callCallbacks(val, detail);
  }

  getVal() {
    return this._val;
  }

  trigger(val, detail) {
    this._callCallbacks(val, detail);
  }

  _callCallbacks(val, detail) {
    this._callbacks.forEach(callback => callback(val, detail));
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
class FocusableAPI {
  constructor(tabster) {
    this._tabster = tabster;
  }

  dispose() {
    /**/
  }

  getProps(element) {
    const tabsterOnElement = getTabsterOnElement(this._tabster, element);
    return tabsterOnElement && tabsterOnElement.focusable || {};
  }

  isFocusable(el, includeProgrammaticallyFocusable, noVisibleCheck, noAccessibleCheck) {
    if (matchesSelector(el, FOCUSABLE_SELECTOR) && (includeProgrammaticallyFocusable || el.tabIndex !== -1)) {
      return (noVisibleCheck || this.isVisible(el)) && (noAccessibleCheck || this.isAccessible(el));
    }

    return false;
  }

  isVisible(el) {
    if (!el.ownerDocument || el.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    if (isDisplayNone(el)) {
      return false;
    }

    const rect = el.ownerDocument.body.getBoundingClientRect();

    if (rect.width === 0 && rect.height === 0) {
      // This might happen, for example, if our <body> is in hidden <iframe>.
      return false;
    }

    return true;
  }

  isAccessible(el) {
    var _a;

    for (let e = el; e; e = dom.getParentElement(e)) {
      const tabsterOnElement = getTabsterOnElement(this._tabster, e);

      if (this._isHidden(e)) {
        return false;
      }

      const ignoreDisabled = (_a = tabsterOnElement === null || tabsterOnElement === undefined ? undefined : tabsterOnElement.focusable) === null || _a === undefined ? undefined : _a.ignoreAriaDisabled;

      if (!ignoreDisabled && this._isDisabled(e)) {
        return false;
      }
    }

    return true;
  }

  _isDisabled(el) {
    return el.hasAttribute("disabled");
  }

  _isHidden(el) {
    var _a;

    const attrVal = el.getAttribute("aria-hidden");

    if (attrVal && attrVal.toLowerCase() === "true") {
      if (!((_a = this._tabster.modalizer) === null || _a === undefined ? undefined : _a.isAugmented(el))) {
        return true;
      }
    }

    return false;
  }

  findFirst(options, out) {
    return this.findElement({ ...options
    }, out);
  }

  findLast(options, out) {
    return this.findElement({
      isBackward: true,
      ...options
    }, out);
  }

  findNext(options, out) {
    return this.findElement({ ...options
    }, out);
  }

  findPrev(options, out) {
    return this.findElement({ ...options,
      isBackward: true
    }, out);
  }

  findDefault(options, out) {
    return this.findElement({ ...options,
      acceptCondition: el => this.isFocusable(el, options.includeProgrammaticallyFocusable) && !!this.getProps(el).isDefault
    }, out) || null;
  }

  findAll(options) {
    return this._findElements(true, options) || [];
  }

  findElement(options, out) {
    const found = this._findElements(false, options, out);

    return found ? found[0] : found;
  }

  _findElements(isFindAll, options, out) {
    var _a, _b, _c;

    const {
      container,
      currentElement = null,
      includeProgrammaticallyFocusable,
      useActiveModalizer,
      ignoreAccessibility,
      modalizerId,
      isBackward,
      onElement
    } = options;

    if (!out) {
      out = {};
    }

    const elements = [];
    let {
      acceptCondition
    } = options;
    const hasCustomCondition = !!acceptCondition;

    if (!container) {
      return null;
    }

    if (!acceptCondition) {
      acceptCondition = el => this.isFocusable(el, includeProgrammaticallyFocusable, false, ignoreAccessibility);
    }

    const acceptElementState = {
      container,
      modalizerUserId: modalizerId === undefined && useActiveModalizer ? (_a = this._tabster.modalizer) === null || _a === undefined ? undefined : _a.activeId : modalizerId || ((_c = (_b = RootAPI.getTabsterContext(this._tabster, container)) === null || _b === undefined ? undefined : _b.modalizer) === null || _c === undefined ? undefined : _c.userId),
      from: currentElement || container,
      isBackward,
      isFindAll,
      acceptCondition,
      hasCustomCondition,
      includeProgrammaticallyFocusable,
      ignoreAccessibility,
      cachedGrouppers: {},
      cachedRadioGroups: {}
    };
    const walker = createElementTreeWalker(container.ownerDocument, container, node => this._acceptElement(node, acceptElementState));

    if (!walker) {
      return null;
    }

    const prepareForNextElement = shouldContinueIfNotFound => {
      var _a, _b;

      const foundElement = (_a = acceptElementState.foundElement) !== null && _a !== undefined ? _a : acceptElementState.foundBackward;

      if (foundElement) {
        elements.push(foundElement);
      }

      if (isFindAll) {
        if (foundElement) {
          acceptElementState.found = false;
          delete acceptElementState.foundElement;
          delete acceptElementState.foundBackward;
          delete acceptElementState.fromCtx;
          acceptElementState.from = foundElement;

          if (onElement && !onElement(foundElement)) {
            return false;
          }
        }

        return !!(foundElement || shouldContinueIfNotFound);
      } else {
        if (foundElement && out) {
          out.uncontrolled = (_b = RootAPI.getTabsterContext(this._tabster, foundElement)) === null || _b === undefined ? undefined : _b.uncontrolled;
        }

        return !!(shouldContinueIfNotFound && !foundElement);
      }
    };

    if (!currentElement) {
      out.outOfDOMOrder = true;
    }

    if (currentElement && dom.nodeContains(container, currentElement)) {
      walker.currentNode = currentElement;
    } else if (isBackward) {
      const lastChild = getLastChild$2(container);

      if (!lastChild) {
        return null;
      }

      if (this._acceptElement(lastChild, acceptElementState) === NodeFilter.FILTER_ACCEPT && !prepareForNextElement(true)) {
        if (acceptElementState.skippedFocusable) {
          out.outOfDOMOrder = true;
        }

        return elements;
      }

      walker.currentNode = lastChild;
    }

    do {
      if (isBackward) {
        walker.previousNode();
      } else {
        walker.nextNode();
      }
    } while (prepareForNextElement());

    if (acceptElementState.skippedFocusable) {
      out.outOfDOMOrder = true;
    }

    return elements.length ? elements : null;
  }

  _acceptElement(element, state) {
    var _a, _b, _c;

    if (state.found) {
      return NodeFilter.FILTER_ACCEPT;
    }

    const foundBackward = state.foundBackward;

    if (foundBackward && (element === foundBackward || !dom.nodeContains(foundBackward, element))) {
      state.found = true;
      state.foundElement = foundBackward;
      return NodeFilter.FILTER_ACCEPT;
    }

    const container = state.container;

    if (element === container) {
      return NodeFilter.FILTER_SKIP;
    }

    if (!dom.nodeContains(container, element)) {
      return NodeFilter.FILTER_REJECT;
    }

    if (getDummyInputContainer(element)) {
      return NodeFilter.FILTER_REJECT;
    }

    if (dom.nodeContains(state.rejectElementsFrom, element)) {
      return NodeFilter.FILTER_REJECT;
    }

    const ctx = state.currentCtx = RootAPI.getTabsterContext(this._tabster, element); // Tabster is opt in, if it is not managed, don't try and get do anything special

    if (!ctx) {
      return NodeFilter.FILTER_SKIP;
    }

    if (shouldIgnoreFocus(element)) {
      if (this.isFocusable(element, undefined, true, true)) {
        state.skippedFocusable = true;
      }

      return NodeFilter.FILTER_SKIP;
    } // We assume iframes are focusable because native tab behaviour would tab inside.
    // But we do it only during the standard search when there is no custom accept
    // element condition.


    if (!state.hasCustomCondition && (element.tagName === "IFRAME" || element.tagName === "WEBVIEW")) {
      if (((_a = ctx.modalizer) === null || _a === undefined ? undefined : _a.userId) === ((_b = this._tabster.modalizer) === null || _b === undefined ? undefined : _b.activeId)) {
        state.found = true;
        state.rejectElementsFrom = state.foundElement = element;
        return NodeFilter.FILTER_ACCEPT;
      } else {
        return NodeFilter.FILTER_REJECT;
      }
    }

    if (!state.ignoreAccessibility && !this.isAccessible(element)) {
      if (this.isFocusable(element, false, true, true)) {
        state.skippedFocusable = true;
      }

      return NodeFilter.FILTER_REJECT;
    }

    let result;
    let fromCtx = state.fromCtx;

    if (!fromCtx) {
      fromCtx = state.fromCtx = RootAPI.getTabsterContext(this._tabster, state.from);
    }

    const fromMover = fromCtx === null || fromCtx === undefined ? undefined : fromCtx.mover;
    let groupper = ctx.groupper;
    let mover = ctx.mover;
    result = (_c = this._tabster.modalizer) === null || _c === undefined ? undefined : _c.acceptElement(element, state);

    if (result !== undefined) {
      state.skippedFocusable = true;
    }

    if (result === undefined && (groupper || mover || fromMover)) {
      const groupperElement = groupper === null || groupper === undefined ? undefined : groupper.getElement();
      const fromMoverElement = fromMover === null || fromMover === undefined ? undefined : fromMover.getElement();
      let moverElement = mover === null || mover === undefined ? undefined : mover.getElement();

      if (moverElement && dom.nodeContains(fromMoverElement, moverElement) && dom.nodeContains(container, fromMoverElement) && (!groupperElement || !mover || dom.nodeContains(fromMoverElement, groupperElement))) {
        mover = fromMover;
        moverElement = fromMoverElement;
      }

      if (groupperElement && (groupperElement === container || !dom.nodeContains(container, groupperElement))) {
        groupper = undefined;
      }

      if (moverElement && !dom.nodeContains(container, moverElement)) {
        mover = undefined;
      }

      if (groupper && mover) {
        if (moverElement && groupperElement && !dom.nodeContains(groupperElement, moverElement)) {
          mover = undefined;
        } else {
          groupper = undefined;
        }
      }

      if (groupper) {
        result = groupper.acceptElement(element, state);
      }

      if (mover) {
        result = mover.acceptElement(element, state);
      }
    }

    if (result === undefined) {
      result = state.acceptCondition(element) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;

      if (result === NodeFilter.FILTER_SKIP && this.isFocusable(element, false, true, true)) {
        state.skippedFocusable = true;
      }
    }

    if (result === NodeFilter.FILTER_ACCEPT && !state.found) {
      if (!state.isFindAll && isRadio(element) && !element.checked) {
        // We need to mimic the browser's behaviour to skip unchecked radio buttons.
        const radioGroupName = element.name;
        let radioGroup = state.cachedRadioGroups[radioGroupName];

        if (!radioGroup) {
          radioGroup = getRadioButtonGroup(element);

          if (radioGroup) {
            state.cachedRadioGroups[radioGroupName] = radioGroup;
          }
        }

        if ((radioGroup === null || radioGroup === undefined ? undefined : radioGroup.checked) && radioGroup.checked !== element) {
          // Currently found element is a radio button in a group that has another radio button checked.
          return NodeFilter.FILTER_SKIP;
        }
      }

      if (state.isBackward) {
        // When TreeWalker goes backwards, it visits the container first,
        // then it goes inside. So, if the container is accepted, we remember it,
        // but allowing the TreeWalker to check inside.
        state.foundBackward = element;
        result = NodeFilter.FILTER_SKIP;
      } else {
        state.found = true;
        state.foundElement = element;
      }
    }

    return result;
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const Keys = {
  Tab: "Tab",
  Enter: "Enter",
  Escape: "Escape",
  Space: " ",
  PageUp: "PageUp",
  PageDown: "PageDown",
  End: "End",
  Home: "Home",
  ArrowLeft: "ArrowLeft",
  ArrowUp: "ArrowUp",
  ArrowRight: "ArrowRight",
  ArrowDown: "ArrowDown"
};

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

function getUncontrolledCompletelyContainer(tabster, element) {
  var _a;

  const getParent = tabster.getParent;
  let el = element;

  do {
    const uncontrolledOnElement = (_a = getTabsterOnElement(tabster, el)) === null || _a === undefined ? undefined : _a.uncontrolled;

    if (uncontrolledOnElement && tabster.uncontrolled.isUncontrolledCompletely(el, !!uncontrolledOnElement.completely)) {
      return el;
    }

    el = getParent(el);
  } while (el);

  return undefined;
}

const AsyncFocusIntentPriorityBySource = {
  [AsyncFocusSources.Restorer]: 0,
  [AsyncFocusSources.Deloser]: 1,
  [AsyncFocusSources.EscapeGroupper]: 2
};
class FocusedElementState extends Subscribable {
  constructor(tabster, getWindow) {
    super();

    this._init = () => {
      const win = this._win();

      const doc = win.document; // Add these event listeners as capture - we want Tabster to run before user event handlers

      doc.addEventListener(KEYBORG_FOCUSIN, this._onFocusIn, true);
      doc.addEventListener(KEYBORG_FOCUSOUT, this._onFocusOut, true);
      win.addEventListener("keydown", this._onKeyDown, true);
      const activeElement = dom.getActiveElement(doc);

      if (activeElement && activeElement !== doc.body) {
        this._setFocusedElement(activeElement);
      }

      this.subscribe(this._onChanged);
    };

    this._onFocusIn = e => {
      const target = e.composedPath()[0];

      if (target) {
        this._setFocusedElement(target, e.detail.relatedTarget, e.detail.isFocusedProgrammatically);
      }
    };

    this._onFocusOut = e => {
      var _a;

      this._setFocusedElement(undefined, (_a = e.detail) === null || _a === undefined ? undefined : _a.originalEvent.relatedTarget);
    }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


    this._validateFocusedElement = element => {// TODO: Make sure this is not needed anymore and write tests.
    };

    this._onKeyDown = event => {
      if (event.key !== Keys.Tab || event.ctrlKey) {
        return;
      }

      const currentElement = this.getVal();

      if (!currentElement || !currentElement.ownerDocument || currentElement.contentEditable === "true") {
        return;
      }

      const tabster = this._tabster;
      const controlTab = tabster.controlTab;
      const ctx = RootAPI.getTabsterContext(tabster, currentElement);

      if (!ctx || ctx.ignoreKeydown(event)) {
        return;
      }

      const isBackward = event.shiftKey;
      const next = FocusedElementState.findNextTabbable(tabster, ctx, undefined, currentElement, undefined, isBackward, true);
      const rootElement = ctx.root.getElement();

      if (!rootElement) {
        return;
      }

      const nextElement = next === null || next === undefined ? undefined : next.element;
      const uncontrolledCompletelyContainer = getUncontrolledCompletelyContainer(tabster, currentElement);

      if (nextElement) {
        const nextUncontrolled = next.uncontrolled;

        if (ctx.uncontrolled || dom.nodeContains(nextUncontrolled, currentElement)) {
          if (!next.outOfDOMOrder && nextUncontrolled === ctx.uncontrolled || uncontrolledCompletelyContainer && !dom.nodeContains(uncontrolledCompletelyContainer, nextElement)) {
            // Nothing to do, everything will be done by the browser or something
            // that controls the uncontrolled area.
            return;
          } // We are in uncontrolled area. We allow whatever controls it to move
          // focus, but we add a phantom dummy to make sure the focus is moved
          // to the correct place if the uncontrolled area allows default action.
          // We only need that in the controlled mode, because in uncontrolled
          // mode we have dummy inputs around everything that redirects focus.


          DummyInputManager.addPhantomDummyWithTarget(tabster, currentElement, isBackward, nextElement);
          return;
        }

        if (nextUncontrolled || nextElement.tagName === "IFRAME") {
          // For iframes and uncontrolled areas we always want to use default action to
          // move focus into.
          if (rootElement.dispatchEvent(new TabsterMoveFocusEvent({
            by: "root",
            owner: rootElement,
            next: nextElement,
            relatedEvent: event
          }))) {
            DummyInputManager.moveWithPhantomDummy(this._tabster, nextUncontrolled !== null && nextUncontrolled !== undefined ? nextUncontrolled : nextElement, false, isBackward, event);
          }

          return;
        }

        if (controlTab || (next === null || next === undefined ? undefined : next.outOfDOMOrder)) {
          if (rootElement.dispatchEvent(new TabsterMoveFocusEvent({
            by: "root",
            owner: rootElement,
            next: nextElement,
            relatedEvent: event
          }))) {
            event.preventDefault();
            event.stopImmediatePropagation();
            nativeFocus(nextElement);
          }
        }
      } else {
        if (!uncontrolledCompletelyContainer && rootElement.dispatchEvent(new TabsterMoveFocusEvent({
          by: "root",
          owner: rootElement,
          next: null,
          relatedEvent: event
        }))) {
          ctx.root.moveOutWithDefaultAction(isBackward, event);
        }
      }
    };

    this._onChanged = (element, detail) => {
      var _a, _b;

      if (element) {
        element.dispatchEvent(new TabsterFocusInEvent(detail));
      } else {
        const last = (_a = this._lastVal) === null || _a === undefined ? undefined : _a.get();

        if (last) {
          const d = { ...detail
          };
          const lastCtx = RootAPI.getTabsterContext(this._tabster, last);
          const modalizerId = (_b = lastCtx === null || lastCtx === undefined ? undefined : lastCtx.modalizer) === null || _b === undefined ? undefined : _b.userId;

          if (modalizerId) {
            d.modalizerId = modalizerId;
          }

          last.dispatchEvent(new TabsterFocusOutEvent(d));
        }
      }
    };

    this._tabster = tabster;
    this._win = getWindow;
    tabster.queueInit(this._init);
  }

  dispose() {
    super.dispose();

    const win = this._win();

    const doc = win.document;
    doc.removeEventListener(KEYBORG_FOCUSIN, this._onFocusIn, true);
    doc.removeEventListener(KEYBORG_FOCUSOUT, this._onFocusOut, true);
    win.removeEventListener("keydown", this._onKeyDown, true);
    this.unsubscribe(this._onChanged);
    const asyncFocus = this._asyncFocus;

    if (asyncFocus) {
      win.clearTimeout(asyncFocus.timeout);
      delete this._asyncFocus;
    }

    delete FocusedElementState._lastResetElement;
    delete this._nextVal;
    delete this._lastVal;
  }

  static forgetMemorized(instance, parent) {
    var _a, _b;

    let wel = FocusedElementState._lastResetElement;
    let el = wel && wel.get();

    if (el && dom.nodeContains(parent, el)) {
      delete FocusedElementState._lastResetElement;
    }

    el = (_b = (_a = instance._nextVal) === null || _a === undefined ? undefined : _a.element) === null || _b === undefined ? undefined : _b.get();

    if (el && dom.nodeContains(parent, el)) {
      delete instance._nextVal;
    }

    wel = instance._lastVal;
    el = wel && wel.get();

    if (el && dom.nodeContains(parent, el)) {
      delete instance._lastVal;
    }
  }

  getFocusedElement() {
    return this.getVal();
  }

  getLastFocusedElement() {
    var _a;

    let el = (_a = this._lastVal) === null || _a === undefined ? undefined : _a.get();

    if (!el || el && !documentContains(el.ownerDocument, el)) {
      this._lastVal = el = undefined;
    }

    return el;
  }

  focus(element, noFocusedProgrammaticallyFlag, noAccessibleCheck, preventScroll) {
    if (!this._tabster.focusable.isFocusable(element, noFocusedProgrammaticallyFlag, false, noAccessibleCheck)) {
      return false;
    }

    element.focus({
      preventScroll
    });
    return true;
  }

  focusDefault(container) {
    const el = this._tabster.focusable.findDefault({
      container
    });

    if (el) {
      this._tabster.focusedElement.focus(el);

      return true;
    }

    return false;
  }

  getFirstOrLastTabbable(isFirst, props) {
    var _a;

    const {
      container,
      ignoreAccessibility
    } = props;
    let toFocus;

    if (container) {
      const ctx = RootAPI.getTabsterContext(this._tabster, container);

      if (ctx) {
        toFocus = (_a = FocusedElementState.findNextTabbable(this._tabster, ctx, container, undefined, undefined, !isFirst, ignoreAccessibility)) === null || _a === undefined ? undefined : _a.element;
      }
    }

    if (toFocus && !dom.nodeContains(container, toFocus)) {
      toFocus = undefined;
    }

    return toFocus || undefined;
  }

  _focusFirstOrLast(isFirst, props) {
    const toFocus = this.getFirstOrLastTabbable(isFirst, props);

    if (toFocus) {
      this.focus(toFocus, false, true);
      return true;
    }

    return false;
  }

  focusFirst(props) {
    return this._focusFirstOrLast(true, props);
  }

  focusLast(props) {
    return this._focusFirstOrLast(false, props);
  }

  resetFocus(container) {
    if (!this._tabster.focusable.isVisible(container)) {
      return false;
    }

    if (!this._tabster.focusable.isFocusable(container, true, true, true)) {
      const prevTabIndex = container.getAttribute("tabindex");
      const prevAriaHidden = container.getAttribute("aria-hidden");
      container.tabIndex = -1;
      container.setAttribute("aria-hidden", "true");
      FocusedElementState._lastResetElement = new WeakHTMLElement(this._win, container);
      this.focus(container, true, true);

      this._setOrRemoveAttribute(container, "tabindex", prevTabIndex);

      this._setOrRemoveAttribute(container, "aria-hidden", prevAriaHidden);
    } else {
      this.focus(container);
    }

    return true;
  }

  requestAsyncFocus(source, callback, delay) {
    const win = this._tabster.getWindow();

    const currentAsyncFocus = this._asyncFocus;

    if (currentAsyncFocus) {
      if (AsyncFocusIntentPriorityBySource[source] > AsyncFocusIntentPriorityBySource[currentAsyncFocus.source]) {
        // Previously registered intent has higher priority.
        return;
      } // New intent has higher priority.


      win.clearTimeout(currentAsyncFocus.timeout);
    }

    this._asyncFocus = {
      source,
      callback,
      timeout: win.setTimeout(() => {
        this._asyncFocus = undefined;
        callback();
      }, delay)
    };
  }

  cancelAsyncFocus(source) {
    const asyncFocus = this._asyncFocus;

    if ((asyncFocus === null || asyncFocus === undefined ? undefined : asyncFocus.source) === source) {
      this._tabster.getWindow().clearTimeout(asyncFocus.timeout);

      this._asyncFocus = undefined;
    }
  }

  _setOrRemoveAttribute(element, name, value) {
    if (value === null) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, value);
    }
  }

  _setFocusedElement(element, relatedTarget, isFocusedProgrammatically) {
    var _a, _b;

    if (this._tabster._noop) {
      return;
    }

    const detail = {
      relatedTarget
    };

    if (element) {
      const lastResetElement = (_a = FocusedElementState._lastResetElement) === null || _a === undefined ? undefined : _a.get();
      FocusedElementState._lastResetElement = undefined;

      if (lastResetElement === element || shouldIgnoreFocus(element)) {
        return;
      }

      detail.isFocusedProgrammatically = isFocusedProgrammatically;
      const ctx = RootAPI.getTabsterContext(this._tabster, element);
      const modalizerId = (_b = ctx === null || ctx === undefined ? undefined : ctx.modalizer) === null || _b === undefined ? undefined : _b.userId;

      if (modalizerId) {
        detail.modalizerId = modalizerId;
      }
    }

    const nextVal = this._nextVal = {
      element: element ? new WeakHTMLElement(this._win, element) : undefined,
      detail
    };

    if (element && element !== this._val) {
      this._validateFocusedElement(element);
    } // _validateFocusedElement() might cause the refocus which will trigger
    // another call to this function. Making sure that the value is correct.


    if (this._nextVal === nextVal) {
      this.setVal(element, detail);
    }

    this._nextVal = undefined;
  }

  setVal(val, detail) {
    super.setVal(val, detail);

    if (val) {
      this._lastVal = new WeakHTMLElement(this._win, val);
    }
  }

  static findNextTabbable(tabster, ctx, container, currentElement, referenceElement, isBackward, ignoreAccessibility) {
    const actualContainer = container || ctx.root.getElement();

    if (!actualContainer) {
      return null;
    }

    let next = null;
    const isTabbingTimer = FocusedElementState._isTabbingTimer;
    const win = tabster.getWindow();

    if (isTabbingTimer) {
      win.clearTimeout(isTabbingTimer);
    }

    FocusedElementState.isTabbing = true;
    FocusedElementState._isTabbingTimer = win.setTimeout(() => {
      delete FocusedElementState._isTabbingTimer;
      FocusedElementState.isTabbing = false;
    }, 0);
    const modalizer = ctx.modalizer;
    const groupper = ctx.groupper;
    const mover = ctx.mover;

    const callFindNext = what => {
      next = what.findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility);

      if (currentElement && !(next === null || next === undefined ? undefined : next.element)) {
        const parentElement = what !== modalizer && dom.getParentElement(what.getElement());

        if (parentElement) {
          const parentCtx = RootAPI.getTabsterContext(tabster, currentElement, {
            referenceElement: parentElement
          });

          if (parentCtx) {
            const currentScopeElement = what.getElement();
            const newCurrent = isBackward ? currentScopeElement : currentScopeElement && getLastChild$2(currentScopeElement) || currentScopeElement;

            if (newCurrent) {
              next = FocusedElementState.findNextTabbable(tabster, parentCtx, container, newCurrent, parentElement, isBackward, ignoreAccessibility);

              if (next) {
                next.outOfDOMOrder = true;
              }
            }
          }
        }
      }
    };

    if (groupper && mover) {
      callFindNext(ctx.groupperBeforeMover ? groupper : mover);
    } else if (groupper) {
      callFindNext(groupper);
    } else if (mover) {
      callFindNext(mover);
    } else if (modalizer) {
      callFindNext(modalizer);
    } else {
      const findProps = {
        container: actualContainer,
        currentElement,
        referenceElement,
        ignoreAccessibility,
        useActiveModalizer: true
      };
      const findPropsOut = {};
      const nextElement = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
      next = {
        element: nextElement,
        outOfDOMOrder: findPropsOut.outOfDOMOrder,
        uncontrolled: findPropsOut.uncontrolled
      };
    }

    return next;
  }

}
FocusedElementState.isTabbing = false;

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

class GroupperDummyManager extends DummyInputManager {
  constructor(element, groupper, tabster, sys) {
    super(tabster, element, DummyInputManagerPriorities.Groupper, sys, true);

    this._setHandlers((dummyInput, isBackward, relatedTarget) => {
      var _a, _b;

      const container = element.get();
      const input = dummyInput.input;

      if (container && input) {
        const ctx = RootAPI.getTabsterContext(tabster, input);

        if (ctx) {
          let next;
          next = (_a = groupper.findNextTabbable(relatedTarget || undefined, undefined, isBackward, true)) === null || _a === undefined ? undefined : _a.element;

          if (!next) {
            next = (_b = FocusedElementState.findNextTabbable(tabster, ctx, undefined, dummyInput.isOutside ? input : getAdjacentElement(container, !isBackward), undefined, isBackward, true)) === null || _b === undefined ? undefined : _b.element;
          }

          if (next) {
            nativeFocus(next);
          }
        }
      }
    });
  }

}

class Groupper extends TabsterPart {
  constructor(tabster, element, onDispose, props, sys) {
    super(tabster, element, props);
    this._shouldTabInside = false;
    this.makeTabbable(false);
    this._onDispose = onDispose;

    if (!tabster.controlTab) {
      this.dummyManager = new GroupperDummyManager(this._element, this, tabster, sys);
    }
  }

  dispose() {
    var _a;

    this._onDispose(this);

    const element = this._element.get();

    (_a = this.dummyManager) === null || _a === undefined ? undefined : _a.dispose();
    delete this.dummyManager;

    if (element) {
      if (process.env.NODE_ENV === 'development') {
        _setInformativeStyle$1(this._element, true);
      }
    }

    delete this._first;
  }

  findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
    const groupperElement = this.getElement();

    if (!groupperElement) {
      return null;
    }

    const currentIsDummy = getDummyInputContainer(currentElement) === groupperElement;

    if (!this._shouldTabInside && currentElement && dom.nodeContains(groupperElement, currentElement) && !currentIsDummy) {
      return {
        element: undefined,
        outOfDOMOrder: true
      };
    }

    const groupperFirstFocusable = this.getFirst(true);

    if (!currentElement || !dom.nodeContains(groupperElement, currentElement) || currentIsDummy) {
      return {
        element: groupperFirstFocusable,
        outOfDOMOrder: true
      };
    }

    const tabster = this._tabster;
    let next = null;
    let outOfDOMOrder = false;
    let uncontrolled;

    if (this._shouldTabInside && groupperFirstFocusable) {
      const findProps = {
        container: groupperElement,
        currentElement,
        referenceElement,
        ignoreAccessibility,
        useActiveModalizer: true
      };
      const findPropsOut = {};
      next = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
      outOfDOMOrder = !!findPropsOut.outOfDOMOrder;

      if (!next && this._props.tabbability === GroupperTabbabilities.LimitedTrapFocus) {
        next = tabster.focusable[isBackward ? "findLast" : "findFirst"]({
          container: groupperElement,
          ignoreAccessibility,
          useActiveModalizer: true
        }, findPropsOut);
        outOfDOMOrder = true;
      }

      uncontrolled = findPropsOut.uncontrolled;
    }

    return {
      element: next,
      uncontrolled,
      outOfDOMOrder
    };
  }

  makeTabbable(isTabbable) {
    this._shouldTabInside = isTabbable || !this._props.tabbability;

    if (process.env.NODE_ENV === 'development') {
      _setInformativeStyle$1(this._element, !this._shouldTabInside);
    }
  }

  isActive(noIfFirstIsFocused) {
    var _a;

    const element = this.getElement() || null;
    let isParentActive = true;

    for (let e = dom.getParentElement(element); e; e = dom.getParentElement(e)) {
      const g = (_a = getTabsterOnElement(this._tabster, e)) === null || _a === undefined ? undefined : _a.groupper;

      if (g) {
        if (!g._shouldTabInside) {
          isParentActive = false;
        }
      }
    }

    let ret = isParentActive ? this._props.tabbability ? this._shouldTabInside : false : undefined;

    if (ret && noIfFirstIsFocused) {
      const focused = this._tabster.focusedElement.getFocusedElement();

      if (focused) {
        ret = focused !== this.getFirst(true);
      }
    }

    return ret;
  }

  getFirst(orContainer) {
    var _a;

    const groupperElement = this.getElement();
    let first;

    if (groupperElement) {
      if (orContainer && this._tabster.focusable.isFocusable(groupperElement)) {
        return groupperElement;
      }

      first = (_a = this._first) === null || _a === undefined ? undefined : _a.get();

      if (!first) {
        first = this._tabster.focusable.findFirst({
          container: groupperElement,
          useActiveModalizer: true
        }) || undefined;

        if (first) {
          this.setFirst(first);
        }
      }
    }

    return first;
  }

  setFirst(element) {
    if (element) {
      this._first = new WeakHTMLElement(this._tabster.getWindow, element);
    } else {
      delete this._first;
    }
  }

  acceptElement(element, state) {
    const cachedGrouppers = state.cachedGrouppers;
    const parentElement = dom.getParentElement(this.getElement());
    const parentCtx = parentElement && RootAPI.getTabsterContext(this._tabster, parentElement);
    const parentCtxGroupper = parentCtx === null || parentCtx === undefined ? undefined : parentCtx.groupper;
    const parentGroupper = (parentCtx === null || parentCtx === undefined ? undefined : parentCtx.groupperBeforeMover) ? parentCtxGroupper : undefined;
    let parentGroupperElement;

    const getIsActive = groupper => {
      let cached = cachedGrouppers[groupper.id];
      let isActive;

      if (cached) {
        isActive = cached.isActive;
      } else {
        isActive = this.isActive(true);
        cached = cachedGrouppers[groupper.id] = {
          isActive
        };
      }

      return isActive;
    };

    if (parentGroupper) {
      parentGroupperElement = parentGroupper.getElement();

      if (!getIsActive(parentGroupper) && parentGroupperElement && state.container !== parentGroupperElement && dom.nodeContains(state.container, parentGroupperElement)) {
        // Do not fall into a child groupper of inactive parent groupper if it's in the scope of the search.
        state.skippedFocusable = true;
        return NodeFilter.FILTER_REJECT;
      }
    }

    const isActive = getIsActive(this);
    const groupperElement = this.getElement();

    if (groupperElement) {
      if (isActive !== true) {
        if (groupperElement === element && parentCtxGroupper) {
          if (!parentGroupperElement) {
            parentGroupperElement = parentCtxGroupper.getElement();
          }

          if (parentGroupperElement && !getIsActive(parentCtxGroupper) && dom.nodeContains(state.container, parentGroupperElement) && parentGroupperElement !== state.container) {
            state.skippedFocusable = true;
            return NodeFilter.FILTER_REJECT;
          }
        }

        if (groupperElement !== element && dom.nodeContains(groupperElement, element)) {
          state.skippedFocusable = true;
          return NodeFilter.FILTER_REJECT;
        }

        const cached = cachedGrouppers[this.id];
        let first;

        if ("first" in cached) {
          first = cached.first;
        } else {
          first = cached.first = this.getFirst(true);
        }

        if (first && state.acceptCondition(first)) {
          state.rejectElementsFrom = groupperElement;
          state.skippedFocusable = true;

          if (first !== state.from) {
            state.found = true;
            state.foundElement = first;
            return NodeFilter.FILTER_ACCEPT;
          } else {
            return NodeFilter.FILTER_REJECT;
          }
        }
      }
    }

    return undefined;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

class GroupperAPI {
  constructor(tabster, getWindow) {
    this._current = {};
    this._grouppers = {};

    this._init = () => {
      const win = this._win(); // Making sure groupper's onFocus is called before modalizer's onFocus.


      this._tabster.focusedElement.subscribeFirst(this._onFocus);

      const doc = win.document;
      const activeElement = dom.getActiveElement(doc);

      if (activeElement) {
        this._onFocus(activeElement);
      }

      doc.addEventListener("mousedown", this._onMouseDown, true);
      win.addEventListener("keydown", this._onKeyDown, true);
      win.addEventListener(GroupperMoveFocusEventName, this._onMoveFocus);
    };

    this._onGroupperDispose = groupper => {
      delete this._grouppers[groupper.id];
    };

    this._onFocus = element => {
      if (element) {
        this._updateCurrent(element, true, true);
      }
    };

    this._onMouseDown = e => {
      if (e.target) {
        this._updateCurrent(e.target, true);
      }
    };

    this._onKeyDown = event => {
      if (event.key !== Keys.Enter && event.key !== Keys.Escape) {
        return;
      } // Give a chance to other listeners to handle the event.


      if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
        return;
      }

      const element = this._tabster.focusedElement.getFocusedElement();

      if (element) {
        this.handleKeyPress(element, event);
      }
    };

    this._onMoveFocus = e => {
      var _a;

      const element = e.composedPath()[0];
      const action = (_a = e.detail) === null || _a === undefined ? undefined : _a.action;

      if (element && action !== undefined && !e.defaultPrevented) {
        if (action === GroupperMoveFocusActions.Enter) {
          this._enterGroupper(element);
        } else {
          this._escapeGroupper(element);
        }

        e.stopImmediatePropagation();
      }
    };

    this._tabster = tabster;
    this._win = getWindow;
    tabster.queueInit(this._init);
  }

  dispose() {
    const win = this._win();

    this._tabster.focusedElement.cancelAsyncFocus(AsyncFocusSources.EscapeGroupper);

    this._current = {};

    if (this._updateTimer) {
      win.clearTimeout(this._updateTimer);
      delete this._updateTimer;
    }

    this._tabster.focusedElement.unsubscribe(this._onFocus);

    win.document.removeEventListener("mousedown", this._onMouseDown, true);
    win.removeEventListener("keydown", this._onKeyDown, true);
    win.removeEventListener(GroupperMoveFocusEventName, this._onMoveFocus);
    Object.keys(this._grouppers).forEach(groupperId => {
      if (this._grouppers[groupperId]) {
        this._grouppers[groupperId].dispose();

        delete this._grouppers[groupperId];
      }
    });
  }

  createGroupper(element, props, sys) {
    if (process.env.NODE_ENV === 'development') ;

    const newGroupper = new Groupper(this._tabster, element, this._onGroupperDispose, props, sys);
    this._grouppers[newGroupper.id] = newGroupper;

    const focusedElement = this._tabster.focusedElement.getFocusedElement(); // Newly created groupper contains currently focused element, update the state on the next tick (to
    // make sure all grouppers are processed).


    if (focusedElement && dom.nodeContains(element, focusedElement) && !this._updateTimer) {
      this._updateTimer = this._win().setTimeout(() => {
        delete this._updateTimer; // Making sure the focused element hasn't changed.

        if (focusedElement === this._tabster.focusedElement.getFocusedElement()) {
          this._updateCurrent(focusedElement, true, true);
        }
      }, 0);
    }

    return newGroupper;
  }

  forgetCurrentGrouppers() {
    this._current = {};
  }

  _updateCurrent(element, includeTarget, checkTarget) {
    var _a;

    if (this._updateTimer) {
      this._win().clearTimeout(this._updateTimer);

      delete this._updateTimer;
    }

    const newIds = {};
    let isTarget = true;

    for (let el = element; el; el = dom.getParentElement(el)) {
      const groupper = (_a = getTabsterOnElement(this._tabster, el)) === null || _a === undefined ? undefined : _a.groupper;

      if (groupper) {
        newIds[groupper.id] = true;

        if (isTarget && checkTarget && el !== element) {
          isTarget = false;
        }

        if (includeTarget || !isTarget) {
          this._current[groupper.id] = groupper;
          const isTabbable = groupper.isActive() || element !== el && (!groupper.getProps().delegated || groupper.getFirst(false) !== element);
          groupper.makeTabbable(isTabbable);
        }

        isTarget = false;
      }
    }

    for (const id of Object.keys(this._current)) {
      const groupper = this._current[id];

      if (!(groupper.id in newIds)) {
        groupper.makeTabbable(false);
        groupper.setFirst(undefined);
        delete this._current[id];
      }
    }
  }

  _enterGroupper(element, relatedEvent) {
    const tabster = this._tabster;
    const ctx = RootAPI.getTabsterContext(tabster, element);
    const groupper = (ctx === null || ctx === undefined ? undefined : ctx.groupper) || (ctx === null || ctx === undefined ? undefined : ctx.modalizerInGroupper);
    const groupperElement = groupper === null || groupper === undefined ? undefined : groupper.getElement();

    if (groupper && groupperElement && (element === groupperElement || groupper.getProps().delegated && element === groupper.getFirst(false))) {
      const next = tabster.focusable.findNext({
        container: groupperElement,
        currentElement: element,
        useActiveModalizer: true
      });

      if (next && (!relatedEvent || relatedEvent && groupperElement.dispatchEvent(new TabsterMoveFocusEvent({
        by: "groupper",
        owner: groupperElement,
        next,
        relatedEvent
      })))) {
        if (relatedEvent) {
          // When the application hasn't prevented default,
          // we consider the event completely handled, hence we
          // prevent the initial event's default action and stop
          // propagation.
          relatedEvent.preventDefault();
          relatedEvent.stopImmediatePropagation();
        }

        next.focus();
        return next;
      }
    }

    return null;
  }

  _escapeGroupper(element, relatedEvent, fromModalizer) {
    var _a;

    const tabster = this._tabster;
    const ctx = RootAPI.getTabsterContext(tabster, element);
    const modalizerInGroupper = ctx === null || ctx === undefined ? undefined : ctx.modalizerInGroupper;
    let groupper = (ctx === null || ctx === undefined ? undefined : ctx.groupper) || modalizerInGroupper;
    const groupperElement = groupper === null || groupper === undefined ? undefined : groupper.getElement();

    if (groupper && groupperElement && dom.nodeContains(groupperElement, element)) {
      let next;

      if (element !== groupperElement || fromModalizer) {
        next = groupper.getFirst(true);
      } else {
        const parentElement = dom.getParentElement(groupperElement);
        const parentCtx = parentElement ? RootAPI.getTabsterContext(tabster, parentElement) : undefined;
        groupper = parentCtx === null || parentCtx === undefined ? undefined : parentCtx.groupper;
        next = groupper === null || groupper === undefined ? undefined : groupper.getFirst(true);
      }

      if (next && (!relatedEvent || relatedEvent && groupperElement.dispatchEvent(new TabsterMoveFocusEvent({
        by: "groupper",
        owner: groupperElement,
        next,
        relatedEvent
      })))) {
        if (groupper) {
          groupper.makeTabbable(false);

          if (modalizerInGroupper) {
            (_a = tabster.modalizer) === null || _a === undefined ? undefined : _a.setActive(undefined);
          }
        } // This part happens asynchronously inside setTimeout,
        // so no need to prevent default or stop propagation.


        next.focus();
        return next;
      }
    }

    return null;
  }

  moveFocus(element, action) {
    return action === GroupperMoveFocusActions.Enter ? this._enterGroupper(element) : this._escapeGroupper(element);
  }

  handleKeyPress(element, event, fromModalizer) {
    const tabster = this._tabster;
    const ctx = RootAPI.getTabsterContext(tabster, element);

    if (ctx && ((ctx === null || ctx === undefined ? undefined : ctx.groupper) || (ctx === null || ctx === undefined ? undefined : ctx.modalizerInGroupper))) {
      tabster.focusedElement.cancelAsyncFocus(AsyncFocusSources.EscapeGroupper);

      if (ctx.ignoreKeydown(event)) {
        return;
      }

      if (event.key === Keys.Enter) {
        this._enterGroupper(element, event);
      } else if (event.key === Keys.Escape) {
        // We will handle Esc asynchronously, if something in the application will
        // move focus during the keypress handling, we will not interfere.
        const focusedElement = tabster.focusedElement.getFocusedElement();
        tabster.focusedElement.requestAsyncFocus(AsyncFocusSources.EscapeGroupper, () => {
          if (focusedElement !== tabster.focusedElement.getFocusedElement() && ( // A part of Modalizer that has called this handler to escape the active groupper
          // might have been removed from DOM, if the focus is on body, we still want to handle Esc.
          fromModalizer && !focusedElement || !fromModalizer)) {
            // Something else in the application has moved focus, we will not handle Esc.
            return;
          }

          this._escapeGroupper(element, event, fromModalizer);
        }, 0);
      }
    }
  }

}

function _setInformativeStyle$1(weakElement, remove) {
  if (process.env.NODE_ENV === 'development') {
    const element = weakElement.get();

    if (element) {
      if (remove) {
        element.style.removeProperty("--tabster-groupper");
      } else {
        element.style.setProperty("--tabster-groupper", "unlimited");
      }
    }
  }
}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
class KeyboardNavigationState extends Subscribable {
  constructor(getWindow) {
    super();

    this._onChange = isNavigatingWithKeyboard => {
      this.setVal(isNavigatingWithKeyboard, undefined);
    };

    this._keyborg = createKeyborg(getWindow());

    this._keyborg.subscribe(this._onChange);
  }

  dispose() {
    super.dispose();

    if (this._keyborg) {
      this._keyborg.unsubscribe(this._onChange);

      disposeKeyborg(this._keyborg);
      delete this._keyborg;
    }
  }

  setNavigatingWithKeyboard(isNavigatingWithKeyboard) {
    var _a;

    (_a = this._keyborg) === null || _a === undefined ? undefined : _a.setVal(isNavigatingWithKeyboard);
  }

  isNavigatingWithKeyboard() {
    var _a;

    return !!((_a = this._keyborg) === null || _a === undefined ? undefined : _a.isNavigatingWithKeyboard());
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
let _wasFocusedCounter = 0;
const _ariaHidden = "aria-hidden";

function _setInformativeStyle(weakElement, remove, internalId, userId, isActive, wasFocused) {
  if (process.env.NODE_ENV === 'development') {
    const element = weakElement.get();

    if (element) {
      if (remove) {
        element.style.removeProperty("--tabster-modalizer");
      } else {
        element.style.setProperty("--tabster-modalizer", internalId + "," + userId + "," + (isActive ? "active" : "inactive") + "," + "," + (wasFocused ? `focused(${wasFocused})` : "not-focused"));
      }
    }
  }
}
/**
 * Manages the dummy inputs for the Modalizer.
 */


class ModalizerDummyManager extends DummyInputManager {
  constructor(element, tabster, sys) {
    super(tabster, element, DummyInputManagerPriorities.Modalizer, sys);

    this._setHandlers((dummyInput, isBackward) => {
      var _a, _b;

      const el = element.get();
      const container = el && ((_a = RootAPI.getRoot(tabster, el)) === null || _a === undefined ? undefined : _a.getElement());
      const input = dummyInput.input;
      let toFocus;

      if (container && input) {
        const dummyContainer = getDummyInputContainer(input);
        const ctx = RootAPI.getTabsterContext(tabster, dummyContainer || input);

        if (ctx) {
          toFocus = (_b = FocusedElementState.findNextTabbable(tabster, ctx, container, input, undefined, isBackward, true)) === null || _b === undefined ? undefined : _b.element;
        }

        if (toFocus) {
          nativeFocus(toFocus);
        }
      }
    });
  }

}

class Modalizer extends TabsterPart {
  constructor(tabster, element, onDispose, props, sys, activeElements) {
    super(tabster, element, props);
    this._wasFocused = 0;
    this.userId = props.id;
    this._onDispose = onDispose;
    this._activeElements = activeElements;

    if (!tabster.controlTab) {
      this.dummyManager = new ModalizerDummyManager(this._element, tabster, sys);
    }

    if (process.env.NODE_ENV === 'development') {
      _setInformativeStyle(this._element, false, this.id, this.userId, this._isActive, this._wasFocused);
    }
  }

  makeActive(isActive) {
    if (this._isActive !== isActive) {
      this._isActive = isActive;
      const element = this.getElement();

      if (element) {
        const activeElements = this._activeElements;
        const index = activeElements.map(e => e.get()).indexOf(element);

        if (isActive) {
          if (index < 0) {
            activeElements.push(new WeakHTMLElement(this._tabster.getWindow, element));
          }
        } else {
          if (index >= 0) {
            activeElements.splice(index, 1);
          }
        }
      }

      if (process.env.NODE_ENV === 'development') {
        _setInformativeStyle(this._element, false, this.id, this.userId, this._isActive, this._wasFocused);
      }

      this._dispatchEvent(isActive);
    }
  }

  focused(noIncrement) {
    if (!noIncrement) {
      this._wasFocused = ++_wasFocusedCounter;
    }

    return this._wasFocused;
  }

  setProps(props) {
    if (props.id) {
      this.userId = props.id;
    }

    this._props = { ...props
    };
  }

  dispose() {
    var _a;

    this.makeActive(false);

    this._onDispose(this);

    (_a = this.dummyManager) === null || _a === undefined ? undefined : _a.dispose();
    delete this.dummyManager;
    this._activeElements = [];

    this._remove();
  }

  isActive() {
    return !!this._isActive;
  }

  contains(element) {
    return dom.nodeContains(this.getElement(), element);
  }

  findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
    var _a, _b;

    const modalizerElement = this.getElement();

    if (!modalizerElement) {
      return null;
    }

    const tabster = this._tabster;
    let next = null;
    let outOfDOMOrder = false;
    let uncontrolled;
    const container = currentElement && ((_a = RootAPI.getRoot(tabster, currentElement)) === null || _a === undefined ? undefined : _a.getElement());

    if (container) {
      const findProps = {
        container,
        currentElement,
        referenceElement,
        ignoreAccessibility,
        useActiveModalizer: true
      };
      const findPropsOut = {};
      next = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);

      if (!next && this._props.isTrapped && ((_b = tabster.modalizer) === null || _b === undefined ? undefined : _b.activeId)) {
        next = tabster.focusable[isBackward ? "findLast" : "findFirst"]({
          container,
          ignoreAccessibility,
          useActiveModalizer: true
        }, findPropsOut);

        if (next === null) {
          next = currentElement;
        }

        outOfDOMOrder = true;
      } else {
        outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
      }

      uncontrolled = findPropsOut.uncontrolled;
    }

    return {
      element: next,
      uncontrolled,
      outOfDOMOrder
    };
  }

  _dispatchEvent(isActive, allElements) {
    const element = this.getElement();
    let defaultPrevented = false;

    if (element) {
      const elements = allElements ? this._activeElements.map(e => e.get()) : [element];

      for (const el of elements) {
        if (el) {
          const eventDetail = {
            id: this.userId,
            element
          };
          const event = isActive ? new ModalizerActiveEvent(eventDetail) : new ModalizerInactiveEvent(eventDetail);
          el.dispatchEvent(event);

          if (event.defaultPrevented) {
            defaultPrevented = true;
          }
        }
      }
    }

    return defaultPrevented;
  }

  _remove() {
    if (process.env.NODE_ENV === 'development') {
      _setInformativeStyle(this._element, true);
    }
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

class ModalizerAPI {
  constructor(tabster, // @deprecated use accessibleCheck.
  alwaysAccessibleSelector, accessibleCheck) {
    this._onModalizerDispose = modalizer => {
      const id = modalizer.id;
      const userId = modalizer.userId;
      const part = this._parts[userId];
      delete this._modalizers[id];

      if (part) {
        delete part[id];

        if (Object.keys(part).length === 0) {
          delete this._parts[userId];

          if (this.activeId === userId) {
            this.setActive(undefined);
          }
        }
      }
    };

    this._onKeyDown = event => {
      var _a;

      if (event.key !== Keys.Escape) {
        return;
      }

      const tabster = this._tabster;
      const element = tabster.focusedElement.getFocusedElement();

      if (element) {
        const ctx = RootAPI.getTabsterContext(tabster, element);
        const modalizer = ctx === null || ctx === undefined ? undefined : ctx.modalizer;

        if (ctx && !ctx.groupper && (modalizer === null || modalizer === undefined ? undefined : modalizer.isActive()) && !ctx.ignoreKeydown(event)) {
          const activeId = modalizer.userId;

          if (activeId) {
            const part = this._parts[activeId];

            if (part) {
              const focusedSince = Object.keys(part).map(id => {
                var _a;

                const m = part[id];
                const el = m.getElement();
                let groupper;

                if (el) {
                  groupper = (_a = getTabsterOnElement(this._tabster, el)) === null || _a === undefined ? undefined : _a.groupper;
                }

                return m && el && groupper ? {
                  el,
                  focusedSince: m.focused(true)
                } : {
                  focusedSince: 0
                };
              }).filter(f => f.focusedSince > 0).sort((a, b) => a.focusedSince > b.focusedSince ? -1 : a.focusedSince < b.focusedSince ? 1 : 0);

              if (focusedSince.length) {
                const groupperElement = focusedSince[0].el;

                if (groupperElement) {
                  (_a = tabster.groupper) === null || _a === undefined ? undefined : _a.handleKeyPress(groupperElement, event, true);
                }
              }
            }
          }
        }
      }
    };
    /**
     * Subscribes to the focus state and handles modalizer related focus events
     * @param focusedElement - Element that is focused
     * @param detail - Additional data about the focus event
     */


    this._onFocus = (focusedElement, detail) => {
      var _a, _b;

      const ctx = focusedElement && RootAPI.getTabsterContext(this._tabster, focusedElement); // Modalizer behaviour is opt in, only apply to elements that have a tabster context

      if (!ctx || !focusedElement) {
        return;
      }

      const augmentedMap = this._augMap;

      for (let e = focusedElement; e; e = dom.getParentElement(e)) {
        // If the newly focused element is inside some of the hidden containers,
        // remove aria-hidden from those synchronously for the screen readers
        // to be able to read the element. The rest of aria-hiddens, will be removed
        // acynchronously for the sake of performance.
        if (augmentedMap.has(e)) {
          augmentedMap.delete(e);
          augmentAttribute(this._tabster, e, _ariaHidden);
        }
      }

      const modalizer = ctx.modalizer; // An inactive groupper with the modalizer on the same node will not give the modalizer
      // in the context, yet we still want to track that the modalizer's container was focused.

      (_b = modalizer || ((_a = getTabsterOnElement(this._tabster, focusedElement)) === null || _a === undefined ? undefined : _a.modalizer)) === null || _b === undefined ? undefined : _b.focused();

      if ((modalizer === null || modalizer === undefined ? undefined : modalizer.userId) === this.activeId) {
        this.currentIsOthersAccessible = modalizer === null || modalizer === undefined ? undefined : modalizer.getProps().isOthersAccessible;
        return;
      } // Developers calling `element.focus()` should change/deactivate active modalizer


      if (detail.isFocusedProgrammatically || this.currentIsOthersAccessible || (modalizer === null || modalizer === undefined ? undefined : modalizer.getProps().isAlwaysAccessible)) {
        this.setActive(modalizer);
      } else {
        // Focused outside of the active modalizer, try pull focus back to current modalizer
        const win = this._win();

        win.clearTimeout(this._restoreModalizerFocusTimer); // TODO some rendering frameworks (i.e. React) might async rerender the DOM so we need to wait for a duration
        // Figure out a better way of doing this rather than a 100ms timeout

        this._restoreModalizerFocusTimer = win.setTimeout(() => this._restoreModalizerFocus(focusedElement), 100);
      }
    };

    this._tabster = tabster;
    this._win = tabster.getWindow;
    this._modalizers = {};
    this._parts = {};
    this._augMap = new WeakMap();
    this._aug = [];
    this._alwaysAccessibleSelector = alwaysAccessibleSelector;
    this._accessibleCheck = accessibleCheck;
    this.activeElements = [];

    if (!tabster.controlTab) {
      tabster.root.addDummyInputs();
    }

    const win = this._win();

    win.addEventListener("keydown", this._onKeyDown, true);
    tabster.queueInit(() => {
      this._tabster.focusedElement.subscribe(this._onFocus);
    });
  }

  dispose() {
    const win = this._win();

    win.removeEventListener("keydown", this._onKeyDown, true); // Dispose all modalizers managed by the API

    Object.keys(this._modalizers).forEach(modalizerId => {
      if (this._modalizers[modalizerId]) {
        this._modalizers[modalizerId].dispose();

        delete this._modalizers[modalizerId];
      }
    });
    win.clearTimeout(this._restoreModalizerFocusTimer);
    win.clearTimeout(this._hiddenUpdateTimer);
    this._parts = {};
    delete this.activeId;
    this.activeElements = [];
    this._augMap = new WeakMap();
    this._aug = [];

    this._tabster.focusedElement.unsubscribe(this._onFocus);
  }

  createModalizer(element, props, sys) {
    var _a;

    if (process.env.NODE_ENV === 'development') ;

    const modalizer = new Modalizer(this._tabster, element, this._onModalizerDispose, props, sys, this.activeElements);
    const id = modalizer.id;
    const userId = props.id;
    this._modalizers[id] = modalizer;
    let part = this._parts[userId];

    if (!part) {
      part = this._parts[userId] = {};
    }

    part[id] = modalizer; // Adding a modalizer which is already focused, activate it

    if (dom.nodeContains(element, (_a = this._tabster.focusedElement.getFocusedElement()) !== null && _a !== undefined ? _a : null)) {
      if (userId !== this.activeId) {
        this.setActive(modalizer);
      } else {
        modalizer.makeActive(true);
      }
    }

    return modalizer;
  }

  isAugmented(element) {
    return this._augMap.has(element);
  }

  hiddenUpdate() {
    if (this._hiddenUpdateTimer) {
      return;
    }

    this._hiddenUpdateTimer = this._win().setTimeout(() => {
      delete this._hiddenUpdateTimer;

      this._hiddenUpdate();
    }, 250);
  }

  setActive(modalizer) {
    const userId = modalizer === null || modalizer === undefined ? undefined : modalizer.userId;
    const activeId = this.activeId;

    if (activeId === userId) {
      return;
    }

    this.activeId = userId;

    if (activeId) {
      const part = this._parts[activeId];

      if (part) {
        for (const id of Object.keys(part)) {
          part[id].makeActive(false);
        }
      }
    }

    if (userId) {
      const part = this._parts[userId];

      if (part) {
        for (const id of Object.keys(part)) {
          part[id].makeActive(true);
        }
      }
    }

    this.currentIsOthersAccessible = modalizer === null || modalizer === undefined ? undefined : modalizer.getProps().isOthersAccessible;
    this.hiddenUpdate();
  }

  focus(elementFromModalizer, noFocusFirst, noFocusDefault) {
    const ctx = RootAPI.getTabsterContext(this._tabster, elementFromModalizer);
    const modalizer = ctx === null || ctx === undefined ? undefined : ctx.modalizer;

    if (modalizer) {
      this.setActive(modalizer);
      const props = modalizer.getProps();
      const modalizerRoot = modalizer.getElement();

      if (modalizerRoot) {
        if (noFocusFirst === undefined) {
          noFocusFirst = props.isNoFocusFirst;
        }

        if (!noFocusFirst && this._tabster.keyboardNavigation.isNavigatingWithKeyboard() && this._tabster.focusedElement.focusFirst({
          container: modalizerRoot
        })) {
          return true;
        }

        if (noFocusDefault === undefined) {
          noFocusDefault = props.isNoFocusDefault;
        }

        if (!noFocusDefault && this._tabster.focusedElement.focusDefault(modalizerRoot)) {
          return true;
        }

        this._tabster.focusedElement.resetFocus(modalizerRoot);
      }
    } else if (process.env.NODE_ENV === 'development') {
      console.error("Element is not in Modalizer.", elementFromModalizer);
    }

    return false;
  }

  acceptElement(element, state) {
    var _a;

    const modalizerUserId = state.modalizerUserId;
    const currentModalizer = (_a = state.currentCtx) === null || _a === undefined ? undefined : _a.modalizer;

    if (modalizerUserId) {
      for (const e of this.activeElements) {
        const el = e.get();

        if (el && (dom.nodeContains(element, el) || el === element)) {
          // We have a part of currently active modalizer somewhere deeper in the DOM,
          // skipping all other checks.
          return NodeFilter.FILTER_SKIP;
        }
      }
    }

    const ret = modalizerUserId === (currentModalizer === null || currentModalizer === undefined ? undefined : currentModalizer.userId) || !modalizerUserId && (currentModalizer === null || currentModalizer === undefined ? undefined : currentModalizer.getProps().isAlwaysAccessible) ? undefined : NodeFilter.FILTER_SKIP;

    if (ret !== undefined) {
      state.skippedFocusable = true;
    }

    return ret;
  }

  _hiddenUpdate() {
    var _a;

    const tabster = this._tabster;
    const body = tabster.getWindow().document.body;
    const activeId = this.activeId;
    const parts = this._parts;
    const visibleElements = [];
    const hiddenElements = [];
    const alwaysAccessibleSelector = this._alwaysAccessibleSelector;
    const alwaysAccessibleElements = alwaysAccessibleSelector ? Array.from(dom.querySelectorAll(body, alwaysAccessibleSelector)) : [];
    const activeModalizerElements = [];

    for (const userId of Object.keys(parts)) {
      const modalizerParts = parts[userId];

      for (const id of Object.keys(modalizerParts)) {
        const modalizer = modalizerParts[id];
        const el = modalizer.getElement();
        const props = modalizer.getProps();
        const isAlwaysAccessible = props.isAlwaysAccessible;

        if (el) {
          if (userId === activeId) {
            activeModalizerElements.push(el);

            if (!this.currentIsOthersAccessible) {
              visibleElements.push(el);
            }
          } else if (isAlwaysAccessible) {
            alwaysAccessibleElements.push(el);
          } else {
            hiddenElements.push(el);
          }
        }
      }
    }

    const augmentedMap = this._augMap;
    const allVisibleElements = visibleElements.length > 0 ? [...visibleElements, ...alwaysAccessibleElements] : undefined;
    const newAugmented = [];
    const newAugmentedMap = new WeakMap();

    const toggle = (element, hide) => {
      var _a;

      const tagName = element.tagName;

      if (tagName === "SCRIPT" || tagName === "STYLE") {
        return;
      }

      let isAugmented = false;

      if (augmentedMap.has(element)) {
        if (hide) {
          isAugmented = true;
        } else {
          augmentedMap.delete(element);
          augmentAttribute(tabster, element, _ariaHidden);
        }
      } else if (hide && !((_a = this._accessibleCheck) === null || _a === undefined ? undefined : _a.call(this, element, activeModalizerElements)) && augmentAttribute(tabster, element, _ariaHidden, "true")) {
        augmentedMap.set(element, true);
        isAugmented = true;
      }

      if (isAugmented) {
        newAugmented.push(new WeakHTMLElement(tabster.getWindow, element));
        newAugmentedMap.set(element, true);
      }
    };

    const walk = element => {
      var _a;

      for (let el = dom.getFirstElementChild(element); el; el = dom.getNextElementSibling(el)) {
        let skip = false;
        let containsModalizer = false;
        let containedByModalizer = false;

        if (allVisibleElements) {
          const elParent = tabster.getParent(el);

          for (const c of allVisibleElements) {
            if (el === c) {
              skip = true;
              break;
            }

            if (dom.nodeContains(el, c)) {
              containsModalizer = true;
              break;
            } else if (dom.nodeContains(c, elParent)) {
              // tabster.getParent() could be provided by the application to
              // handle, for example, virtual parents. Making sure, we are
              // not setting aria-hidden on elements which are virtually
              // inside modalizer.
              containedByModalizer = true;
            }
          }

          if (containsModalizer || ((_a = el.__tabsterElementFlags) === null || _a === undefined ? undefined : _a.noDirectAriaHidden)) {
            walk(el);
          } else if (!skip && !containedByModalizer) {
            toggle(el, true);
          }
        } else {
          toggle(el, false);
        }
      }
    };

    if (!allVisibleElements) {
      alwaysAccessibleElements.forEach(e => toggle(e, false));
    }

    hiddenElements.forEach(e => toggle(e, true));

    if (body) {
      walk(body);
    }

    (_a = this._aug) === null || _a === undefined ? undefined : _a.map(e => e.get()).forEach(e => {
      if (e && !newAugmentedMap.get(e)) {
        toggle(e, false);
      }
    });
    this._aug = newAugmented;
    this._augMap = newAugmentedMap;
  }
  /**
   * Called when an element is focused outside of an active modalizer.
   * Attempts to pull focus back into the active modalizer
   * @param outsideElement - An element being focused outside of the modalizer
   */


  _restoreModalizerFocus(outsideElement) {
    const ownerDocument = outsideElement === null || outsideElement === undefined ? undefined : outsideElement.ownerDocument;

    if (!outsideElement || !ownerDocument) {
      return;
    }

    const ctx = RootAPI.getTabsterContext(this._tabster, outsideElement);
    const modalizer = ctx === null || ctx === undefined ? undefined : ctx.modalizer;
    const activeId = this.activeId;

    if (!modalizer && !activeId || modalizer && activeId === modalizer.userId) {
      return;
    }

    const container = ctx === null || ctx === undefined ? undefined : ctx.root.getElement();

    if (container) {
      let toFocus = this._tabster.focusable.findFirst({
        container,
        useActiveModalizer: true
      });

      if (toFocus) {
        if (outsideElement.compareDocumentPosition(toFocus) & document.DOCUMENT_POSITION_PRECEDING) {
          toFocus = this._tabster.focusable.findLast({
            container,
            useActiveModalizer: true
          });

          if (!toFocus) {
            // This only might mean that findFirst/findLast are buggy and inconsistent.
            throw new Error("Something went wrong.");
          }
        }

        this._tabster.focusedElement.focus(toFocus);

        return;
      }
    } // Current Modalizer doesn't seem to have focusable elements.
    // Blurring the currently focused element which is outside of the current Modalizer.


    outsideElement.blur();
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

const _inputSelector = /*#__PURE__*/["input", "textarea", "*[contenteditable]"].join(", ");

class MoverDummyManager extends DummyInputManager {
  constructor(element, tabster, getMemorized, sys) {
    super(tabster, element, DummyInputManagerPriorities.Mover, sys);

    this._onFocusDummyInput = dummyInput => {
      var _a, _b;

      const container = this._element.get();

      const input = dummyInput.input;

      if (container && input) {
        const ctx = RootAPI.getTabsterContext(this._tabster, container);
        let toFocus;

        if (ctx) {
          toFocus = (_a = FocusedElementState.findNextTabbable(this._tabster, ctx, undefined, input, undefined, !dummyInput.isFirst, true)) === null || _a === undefined ? undefined : _a.element;
        }

        const memorized = (_b = this._getMemorized()) === null || _b === undefined ? undefined : _b.get();

        if (memorized && this._tabster.focusable.isFocusable(memorized)) {
          toFocus = memorized;
        }

        if (toFocus) {
          nativeFocus(toFocus);
        }
      }
    };

    this._tabster = tabster;
    this._getMemorized = getMemorized;

    this._setHandlers(this._onFocusDummyInput);
  }

} // TypeScript enums produce depressing JavaScript code, so, we're just using
// a few old style constants here.


const _moverUpdateAdd = 1;
const _moverUpdateAttr = 2;
const _moverUpdateRemove = 3;
class Mover extends TabsterPart {
  constructor(tabster, element, onDispose, props, sys) {
    var _a;

    super(tabster, element, props);
    this._visible = {};

    this._onIntersection = entries => {
      for (const entry of entries) {
        const el = entry.target;
        const id = getElementUId(this._win, el);
        let newVisibility;
        let fullyVisible = this._fullyVisible;

        if (entry.intersectionRatio >= 0.25) {
          newVisibility = entry.intersectionRatio >= 0.75 ? Visibilities.Visible : Visibilities.PartiallyVisible;

          if (newVisibility === Visibilities.Visible) {
            fullyVisible = id;
          }
        } else {
          newVisibility = Visibilities.Invisible;
        }

        if (this._visible[id] !== newVisibility) {
          if (newVisibility === undefined) {
            delete this._visible[id];

            if (fullyVisible === id) {
              delete this._fullyVisible;
            }
          } else {
            this._visible[id] = newVisibility;
            this._fullyVisible = fullyVisible;
          }

          const state = this.getState(el);

          if (state) {
            el.dispatchEvent(new MoverStateEvent(state));
          }
        }
      }
    };

    this._win = tabster.getWindow;
    this.visibilityTolerance = (_a = props.visibilityTolerance) !== null && _a !== undefined ? _a : 0.8;

    if (this._props.trackState || this._props.visibilityAware) {
      this._intersectionObserver = new IntersectionObserver(this._onIntersection, {
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      this._observeState();
    }

    this._onDispose = onDispose;

    const getMemorized = () => props.memorizeCurrent ? this._current : undefined;

    if (!tabster.controlTab) {
      this.dummyManager = new MoverDummyManager(this._element, tabster, getMemorized, sys);
    }
  }

  dispose() {
    var _a;

    this._onDispose(this);

    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();

      delete this._intersectionObserver;
    }

    delete this._current;
    delete this._fullyVisible;
    delete this._allElements;
    delete this._updateQueue;

    if (this._unobserve) {
      this._unobserve();

      delete this._unobserve;
    }

    const win = this._win();

    if (this._setCurrentTimer) {
      win.clearTimeout(this._setCurrentTimer);
      delete this._setCurrentTimer;
    }

    if (this._updateTimer) {
      win.clearTimeout(this._updateTimer);
      delete this._updateTimer;
    }

    (_a = this.dummyManager) === null || _a === undefined ? undefined : _a.dispose();
    delete this.dummyManager;
  }

  setCurrent(element) {
    if (element) {
      this._current = new WeakHTMLElement(this._win, element);
    } else {
      this._current = undefined;
    }

    if ((this._props.trackState || this._props.visibilityAware) && !this._setCurrentTimer) {
      this._setCurrentTimer = this._win().setTimeout(() => {
        var _a;

        delete this._setCurrentTimer;
        const changed = [];

        if (this._current !== this._prevCurrent) {
          changed.push(this._current);
          changed.push(this._prevCurrent);
          this._prevCurrent = this._current;
        }

        for (const weak of changed) {
          const el = weak === null || weak === undefined ? undefined : weak.get();

          if (el && ((_a = this._allElements) === null || _a === undefined ? undefined : _a.get(el)) === this) {
            const props = this._props;

            if (el && (props.visibilityAware !== undefined || props.trackState)) {
              const state = this.getState(el);

              if (state) {
                el.dispatchEvent(new MoverStateEvent(state));
              }
            }
          }
        }
      });
    }
  }

  getCurrent() {
    var _a;

    return ((_a = this._current) === null || _a === undefined ? undefined : _a.get()) || null;
  }

  findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
    const container = this.getElement();
    const currentIsDummy = container && getDummyInputContainer(currentElement) === container;

    if (!container) {
      return null;
    }

    let next = null;
    let outOfDOMOrder = false;
    let uncontrolled;

    if (this._props.tabbable || currentIsDummy || currentElement && !dom.nodeContains(container, currentElement)) {
      const findProps = {
        currentElement,
        referenceElement,
        container,
        ignoreAccessibility,
        useActiveModalizer: true
      };
      const findPropsOut = {};
      next = this._tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
      outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
      uncontrolled = findPropsOut.uncontrolled;
    }

    return {
      element: next,
      uncontrolled,
      outOfDOMOrder
    };
  }

  acceptElement(element, state) {
    var _a, _b;

    if (!FocusedElementState.isTabbing) {
      return ((_a = state.currentCtx) === null || _a === undefined ? undefined : _a.excludedFromMover) ? NodeFilter.FILTER_REJECT : undefined;
    }

    const {
      memorizeCurrent,
      visibilityAware,
      hasDefault = true
    } = this._props;
    const moverElement = this.getElement();

    if (moverElement && (memorizeCurrent || visibilityAware || hasDefault) && (!dom.nodeContains(moverElement, state.from) || getDummyInputContainer(state.from) === moverElement)) {
      let found;

      if (memorizeCurrent) {
        const current = (_b = this._current) === null || _b === undefined ? undefined : _b.get();

        if (current && state.acceptCondition(current)) {
          found = current;
        }
      }

      if (!found && hasDefault) {
        found = this._tabster.focusable.findDefault({
          container: moverElement,
          useActiveModalizer: true
        });
      }

      if (!found && visibilityAware) {
        found = this._tabster.focusable.findElement({
          container: moverElement,
          useActiveModalizer: true,
          isBackward: state.isBackward,
          acceptCondition: el => {
            var _a;

            const id = getElementUId(this._win, el);
            const visibility = this._visible[id];
            return moverElement !== el && !!((_a = this._allElements) === null || _a === undefined ? undefined : _a.get(el)) && state.acceptCondition(el) && (visibility === Visibilities.Visible || visibility === Visibilities.PartiallyVisible && (visibilityAware === Visibilities.PartiallyVisible || !this._fullyVisible));
          }
        });
      }

      if (found) {
        state.found = true;
        state.foundElement = found;
        state.rejectElementsFrom = moverElement;
        state.skippedFocusable = true;
        return NodeFilter.FILTER_ACCEPT;
      }
    }

    return undefined;
  }

  _observeState() {
    const element = this.getElement();

    if (this._unobserve || !element || typeof MutationObserver === "undefined") {
      return;
    }

    const win = this._win();

    const allElements = this._allElements = new WeakMap();
    const tabsterFocusable = this._tabster.focusable;
    let updateQueue = this._updateQueue = [];
    const observer = dom.createMutationObserver(mutations => {
      for (const mutation of mutations) {
        const target = mutation.target;
        const removed = mutation.removedNodes;
        const added = mutation.addedNodes;

        if (mutation.type === "attributes") {
          if (mutation.attributeName === "tabindex") {
            updateQueue.push({
              element: target,
              type: _moverUpdateAttr
            });
          }
        } else {
          for (let i = 0; i < removed.length; i++) {
            updateQueue.push({
              element: removed[i],
              type: _moverUpdateRemove
            });
          }

          for (let i = 0; i < added.length; i++) {
            updateQueue.push({
              element: added[i],
              type: _moverUpdateAdd
            });
          }
        }
      }

      requestUpdate();
    });

    const setElement = (element, remove) => {
      var _a, _b;

      const current = allElements.get(element);

      if (current && remove) {
        (_a = this._intersectionObserver) === null || _a === undefined ? undefined : _a.unobserve(element);
        allElements.delete(element);
      }

      if (!current && !remove) {
        allElements.set(element, this);
        (_b = this._intersectionObserver) === null || _b === undefined ? undefined : _b.observe(element);
      }
    };

    const updateElement = element => {
      const isFocusable = tabsterFocusable.isFocusable(element);
      const current = allElements.get(element);

      if (current) {
        if (!isFocusable) {
          setElement(element, true);
        }
      } else {
        if (isFocusable) {
          setElement(element);
        }
      }
    };

    const addNewElements = element => {
      const {
        mover
      } = getMoverGroupper(element);

      if (mover && mover !== this) {
        if (mover.getElement() === element && tabsterFocusable.isFocusable(element)) {
          setElement(element);
        } else {
          return;
        }
      }

      const walker = createElementTreeWalker(win.document, element, node => {
        const {
          mover,
          groupper
        } = getMoverGroupper(node);

        if (mover && mover !== this) {
          return NodeFilter.FILTER_REJECT;
        }

        const groupperFirstFocusable = groupper === null || groupper === undefined ? undefined : groupper.getFirst(true);

        if (groupper && groupper.getElement() !== node && groupperFirstFocusable && groupperFirstFocusable !== node) {
          return NodeFilter.FILTER_REJECT;
        }

        if (tabsterFocusable.isFocusable(node)) {
          setElement(node);
        }

        return NodeFilter.FILTER_SKIP;
      });

      if (walker) {
        walker.currentNode = element;

        while (walker.nextNode()) {
          /* Iterating for the sake of calling processNode() callback. */
        }
      }
    };

    const removeWalk = element => {
      const current = allElements.get(element);

      if (current) {
        setElement(element, true);
      }

      for (let el = dom.getFirstElementChild(element); el; el = dom.getNextElementSibling(el)) {
        removeWalk(el);
      }
    };

    const requestUpdate = () => {
      if (!this._updateTimer && updateQueue.length) {
        this._updateTimer = win.setTimeout(() => {
          delete this._updateTimer;

          for (const {
            element,
            type
          } of updateQueue) {
            switch (type) {
              case _moverUpdateAttr:
                updateElement(element);
                break;

              case _moverUpdateAdd:
                addNewElements(element);
                break;

              case _moverUpdateRemove:
                removeWalk(element);
                break;
            }
          }

          updateQueue = this._updateQueue = [];
        }, 0);
      }
    };

    const getMoverGroupper = element => {
      const ret = {};

      for (let el = element; el; el = dom.getParentElement(el)) {
        const toe = getTabsterOnElement(this._tabster, el);

        if (toe) {
          if (toe.groupper && !ret.groupper) {
            ret.groupper = toe.groupper;
          }

          if (toe.mover) {
            ret.mover = toe.mover;
            break;
          }
        }
      }

      return ret;
    };

    updateQueue.push({
      element,
      type: _moverUpdateAdd
    });
    requestUpdate();
    observer.observe(element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["tabindex"]
    });

    this._unobserve = () => {
      observer.disconnect();
    };
  }

  getState(element) {
    const id = getElementUId(this._win, element);

    if (id in this._visible) {
      const visibility = this._visible[id] || Visibilities.Invisible;
      const isCurrent = this._current ? this._current.get() === element : undefined;
      return {
        isCurrent,
        visibility
      };
    }

    return undefined;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars
/**
 * Calculates distance between two rectangles.
 *
 * @param ax1 first rectangle left
 * @param ay1 first rectangle top
 * @param ax2 first rectangle right
 * @param ay2 first rectangle bottom
 * @param bx1 second rectangle left
 * @param by1 second rectangle top
 * @param bx2 second rectangle right
 * @param by2 second rectangle bottom
 * @returns number, shortest distance between the rectangles.
 */


function getDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
  const xDistance = ax2 < bx1 ? bx1 - ax2 : bx2 < ax1 ? ax1 - bx2 : 0;
  const yDistance = ay2 < by1 ? by1 - ay2 : by2 < ay1 ? ay1 - by2 : 0;
  return xDistance === 0 ? yDistance : yDistance === 0 ? xDistance : Math.sqrt(xDistance * xDistance + yDistance * yDistance);
}

class MoverAPI {
  constructor(tabster, getWindow) {
    this._init = () => {
      const win = this._win();

      win.addEventListener("keydown", this._onKeyDown, true);
      win.addEventListener(MoverMoveFocusEventName, this._onMoveFocus);
      win.addEventListener(MoverMemorizedElementEventName, this._onMemorizedElement);

      this._tabster.focusedElement.subscribe(this._onFocus);
    };

    this._onMoverDispose = mover => {
      delete this._movers[mover.id];
    };

    this._onFocus = element => {
      var _a; // When something in the app gets focused, we are making sure that
      // the relevant context Mover is aware of it.
      // Looking for the relevant context Mover from the currently
      // focused element parent, not from the element itself, because the
      // Mover element itself cannot be its own current (but might be
      // current for its parent Mover).


      let currentFocusableElement = element;
      let deepestFocusableElement = element;

      for (let el = dom.getParentElement(element); el; el = dom.getParentElement(el)) {
        // We go through all Movers up from the focused element and
        // set their current element to the deepest focusable of that
        // Mover.
        const mover = (_a = getTabsterOnElement(this._tabster, el)) === null || _a === undefined ? undefined : _a.mover;

        if (mover) {
          mover.setCurrent(deepestFocusableElement);
          currentFocusableElement = undefined;
        }

        if (!currentFocusableElement && this._tabster.focusable.isFocusable(el)) {
          currentFocusableElement = deepestFocusableElement = el;
        }
      }
    };

    this._onKeyDown = async event => {
      var _a;

      if (this._ignoredInputTimer) {
        this._win().clearTimeout(this._ignoredInputTimer);

        delete this._ignoredInputTimer;
      }

      (_a = this._ignoredInputResolve) === null || _a === undefined ? undefined : _a.call(this, false); // Give a chance to other listeners to handle the event (for example,
      // to scroll instead of moving focus).

      if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
        return;
      }

      const key = event.key;
      let moverKey;

      if (key === Keys.ArrowDown) {
        moverKey = MoverKeys.ArrowDown;
      } else if (key === Keys.ArrowRight) {
        moverKey = MoverKeys.ArrowRight;
      } else if (key === Keys.ArrowUp) {
        moverKey = MoverKeys.ArrowUp;
      } else if (key === Keys.ArrowLeft) {
        moverKey = MoverKeys.ArrowLeft;
      } else if (key === Keys.PageDown) {
        moverKey = MoverKeys.PageDown;
      } else if (key === Keys.PageUp) {
        moverKey = MoverKeys.PageUp;
      } else if (key === Keys.Home) {
        moverKey = MoverKeys.Home;
      } else if (key === Keys.End) {
        moverKey = MoverKeys.End;
      }

      if (!moverKey) {
        return;
      }

      const focused = this._tabster.focusedElement.getFocusedElement();

      if (!focused || (await this._isIgnoredInput(focused, key))) {
        return;
      }

      this._moveFocus(focused, moverKey, event);
    };

    this._onMoveFocus = e => {
      var _a;

      const element = e.composedPath()[0];
      const key = (_a = e.detail) === null || _a === undefined ? undefined : _a.key;

      if (element && key !== undefined && !e.defaultPrevented) {
        this._moveFocus(element, key);

        e.stopImmediatePropagation();
      }
    };

    this._onMemorizedElement = e => {
      var _a;

      const target = e.composedPath()[0];
      let memorizedElement = (_a = e.detail) === null || _a === undefined ? undefined : _a.memorizedElement;

      if (target) {
        const ctx = RootAPI.getTabsterContext(this._tabster, target);
        const mover = ctx === null || ctx === undefined ? undefined : ctx.mover;

        if (mover) {
          if (memorizedElement && !dom.nodeContains(mover.getElement(), memorizedElement)) {
            memorizedElement = undefined;
          }

          mover.setCurrent(memorizedElement);
          e.stopImmediatePropagation();
        }
      }
    };

    this._tabster = tabster;
    this._win = getWindow;
    this._movers = {};
    tabster.queueInit(this._init);
  }

  dispose() {
    var _a;

    const win = this._win();

    this._tabster.focusedElement.unsubscribe(this._onFocus);

    (_a = this._ignoredInputResolve) === null || _a === undefined ? undefined : _a.call(this, false);

    if (this._ignoredInputTimer) {
      win.clearTimeout(this._ignoredInputTimer);
      delete this._ignoredInputTimer;
    }

    win.removeEventListener("keydown", this._onKeyDown, true);
    win.removeEventListener(MoverMoveFocusEventName, this._onMoveFocus);
    win.removeEventListener(MoverMemorizedElementEventName, this._onMemorizedElement);
    Object.keys(this._movers).forEach(moverId => {
      if (this._movers[moverId]) {
        this._movers[moverId].dispose();

        delete this._movers[moverId];
      }
    });
  }

  createMover(element, props, sys) {
    if (process.env.NODE_ENV === 'development') ;

    const newMover = new Mover(this._tabster, element, this._onMoverDispose, props, sys);
    this._movers[newMover.id] = newMover;
    return newMover;
  }

  moveFocus(fromElement, key) {
    return this._moveFocus(fromElement, key);
  }

  _moveFocus(fromElement, key, relatedEvent) {
    var _a, _b;

    const tabster = this._tabster;
    const ctx = RootAPI.getTabsterContext(tabster, fromElement, {
      checkRtl: true
    });

    if (!ctx || !ctx.mover || ctx.excludedFromMover || relatedEvent && ctx.ignoreKeydown(relatedEvent)) {
      return null;
    }

    const mover = ctx.mover;
    const container = mover.getElement();

    if (ctx.groupperBeforeMover) {
      const groupper = ctx.groupper;

      if (groupper && !groupper.isActive(true)) {
        // For the cases when we have Mover/Active Groupper/Inactive Groupper, we need to check
        // the grouppers between the current element and the current mover.
        for (let el = dom.getParentElement(groupper.getElement()); el && el !== container; el = dom.getParentElement(el)) {
          if ((_b = (_a = getTabsterOnElement(tabster, el)) === null || _a === undefined ? undefined : _a.groupper) === null || _b === undefined ? undefined : _b.isActive(true)) {
            return null;
          }
        }
      } else {
        return null;
      }
    }

    if (!container) {
      return null;
    }

    const focusable = tabster.focusable;
    const moverProps = mover.getProps();
    const direction = moverProps.direction || MoverDirections.Both;
    const isBoth = direction === MoverDirections.Both;
    const isVertical = isBoth || direction === MoverDirections.Vertical;
    const isHorizontal = isBoth || direction === MoverDirections.Horizontal;
    const isGridLinear = direction === MoverDirections.GridLinear;
    const isGrid = isGridLinear || direction === MoverDirections.Grid;
    const isCyclic = moverProps.cyclic;
    let next;
    let scrollIntoViewArg;
    let focusedElementRect;
    let focusedElementX1 = 0;
    let focusedElementX2 = 0;

    if (isGrid) {
      focusedElementRect = fromElement.getBoundingClientRect();
      focusedElementX1 = Math.ceil(focusedElementRect.left);
      focusedElementX2 = Math.floor(focusedElementRect.right);
    }

    if (ctx.rtl) {
      if (key === MoverKeys.ArrowRight) {
        key = MoverKeys.ArrowLeft;
      } else if (key === MoverKeys.ArrowLeft) {
        key = MoverKeys.ArrowRight;
      }
    }

    if (key === MoverKeys.ArrowDown && isVertical || key === MoverKeys.ArrowRight && (isHorizontal || isGrid)) {
      next = focusable.findNext({
        currentElement: fromElement,
        container,
        useActiveModalizer: true
      });

      if (next && isGrid) {
        const nextElementX1 = Math.ceil(next.getBoundingClientRect().left);

        if (!isGridLinear && focusedElementX2 > nextElementX1) {
          next = undefined;
        }
      } else if (!next && isCyclic) {
        next = focusable.findFirst({
          container,
          useActiveModalizer: true
        });
      }
    } else if (key === MoverKeys.ArrowUp && isVertical || key === MoverKeys.ArrowLeft && (isHorizontal || isGrid)) {
      next = focusable.findPrev({
        currentElement: fromElement,
        container,
        useActiveModalizer: true
      });

      if (next && isGrid) {
        const nextElementX2 = Math.floor(next.getBoundingClientRect().right);

        if (!isGridLinear && nextElementX2 > focusedElementX1) {
          next = undefined;
        }
      } else if (!next && isCyclic) {
        next = focusable.findLast({
          container,
          useActiveModalizer: true
        });
      }
    } else if (key === MoverKeys.Home) {
      if (isGrid) {
        focusable.findElement({
          container,
          currentElement: fromElement,
          useActiveModalizer: true,
          isBackward: true,
          acceptCondition: el => {
            var _a;

            if (!focusable.isFocusable(el)) {
              return false;
            }

            const nextElementX1 = Math.ceil((_a = el.getBoundingClientRect().left) !== null && _a !== undefined ? _a : 0);

            if (el !== fromElement && focusedElementX1 <= nextElementX1) {
              return true;
            }

            next = el;
            return false;
          }
        });
      } else {
        next = focusable.findFirst({
          container,
          useActiveModalizer: true
        });
      }
    } else if (key === MoverKeys.End) {
      if (isGrid) {
        focusable.findElement({
          container,
          currentElement: fromElement,
          useActiveModalizer: true,
          acceptCondition: el => {
            var _a;

            if (!focusable.isFocusable(el)) {
              return false;
            }

            const nextElementX1 = Math.ceil((_a = el.getBoundingClientRect().left) !== null && _a !== undefined ? _a : 0);

            if (el !== fromElement && focusedElementX1 >= nextElementX1) {
              return true;
            }

            next = el;
            return false;
          }
        });
      } else {
        next = focusable.findLast({
          container,
          useActiveModalizer: true
        });
      }
    } else if (key === MoverKeys.PageUp) {
      focusable.findElement({
        currentElement: fromElement,
        container,
        useActiveModalizer: true,
        isBackward: true,
        acceptCondition: el => {
          if (!focusable.isFocusable(el)) {
            return false;
          }

          if (isElementVerticallyVisibleInContainer(this._win, el, mover.visibilityTolerance)) {
            next = el;
            return false;
          }

          return true;
        }
      }); // will be on the first column move forward and preserve previous column

      if (isGrid && next) {
        const firstColumnX1 = Math.ceil(next.getBoundingClientRect().left);
        focusable.findElement({
          currentElement: next,
          container,
          useActiveModalizer: true,
          acceptCondition: el => {
            if (!focusable.isFocusable(el)) {
              return false;
            }

            const nextElementX1 = Math.ceil(el.getBoundingClientRect().left);

            if (focusedElementX1 < nextElementX1 || firstColumnX1 >= nextElementX1) {
              return true;
            }

            next = el;
            return false;
          }
        });
      }

      scrollIntoViewArg = false;
    } else if (key === MoverKeys.PageDown) {
      focusable.findElement({
        currentElement: fromElement,
        container,
        useActiveModalizer: true,
        acceptCondition: el => {
          if (!focusable.isFocusable(el)) {
            return false;
          }

          if (isElementVerticallyVisibleInContainer(this._win, el, mover.visibilityTolerance)) {
            next = el;
            return false;
          }

          return true;
        }
      }); // will be on the last column move backwards and preserve previous column

      if (isGrid && next) {
        const lastColumnX1 = Math.ceil(next.getBoundingClientRect().left);
        focusable.findElement({
          currentElement: next,
          container,
          useActiveModalizer: true,
          isBackward: true,
          acceptCondition: el => {
            if (!focusable.isFocusable(el)) {
              return false;
            }

            const nextElementX1 = Math.ceil(el.getBoundingClientRect().left);

            if (focusedElementX1 > nextElementX1 || lastColumnX1 <= nextElementX1) {
              return true;
            }

            next = el;
            return false;
          }
        });
      }

      scrollIntoViewArg = true;
    } else if (isGrid) {
      const isBackward = key === MoverKeys.ArrowUp;
      const ax1 = focusedElementX1; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      const ay1 = Math.ceil(focusedElementRect.top);
      const ax2 = focusedElementX2; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      const ay2 = Math.floor(focusedElementRect.bottom);
      let targetElement;
      let lastDistance;
      let lastIntersection = 0;
      focusable.findAll({
        container,
        currentElement: fromElement,
        isBackward,
        onElement: el => {
          // Find element which has maximal intersection with the focused element horizontally,
          // or the closest one.
          const rect = el.getBoundingClientRect();
          const bx1 = Math.ceil(rect.left);
          const by1 = Math.ceil(rect.top);
          const bx2 = Math.floor(rect.right);
          const by2 = Math.floor(rect.bottom);

          if (isBackward && ay1 < by2 || !isBackward && ay2 > by1) {
            // Only consider elements which are below/above curretly focused.
            return true;
          }

          const xIntersectionWidth = Math.ceil(Math.min(ax2, bx2)) - Math.floor(Math.max(ax1, bx1));
          const minWidth = Math.ceil(Math.min(ax2 - ax1, bx2 - bx1));

          if (xIntersectionWidth > 0 && minWidth >= xIntersectionWidth) {
            // Element intersects with the focused element on X axis.
            const intersection = xIntersectionWidth / minWidth;

            if (intersection > lastIntersection) {
              targetElement = el;
              lastIntersection = intersection;
            }
          } else if (lastIntersection === 0) {
            // If we didn't have intersection, try just the closest one.
            const distance = getDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2);

            if (lastDistance === undefined || distance < lastDistance) {
              lastDistance = distance;
              targetElement = el;
            }
          } else if (lastIntersection > 0) {
            // Element doesn't intersect, but we had intersection already, stop search.
            return false;
          }

          return true;
        }
      });
      next = targetElement;
    }

    if (next && (!relatedEvent || relatedEvent && container.dispatchEvent(new TabsterMoveFocusEvent({
      by: "mover",
      owner: container,
      next,
      relatedEvent
    })))) {
      if (scrollIntoViewArg !== undefined) {
        scrollIntoView(this._win, next, scrollIntoViewArg);
      }

      if (relatedEvent) {
        relatedEvent.preventDefault();
        relatedEvent.stopImmediatePropagation();
      }

      nativeFocus(next);
      return next;
    }

    return null;
  }

  async _isIgnoredInput(element, key) {
    if (element.getAttribute("aria-expanded") === "true" && element.hasAttribute("aria-activedescendant")) {
      // It is likely a combobox with expanded options and arrow keys are
      // controlled by it.
      return true;
    }

    if (matchesSelector(element, _inputSelector)) {
      let selectionStart = 0;
      let selectionEnd = 0;
      let textLength = 0;
      let asyncRet;

      if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
        const type = element.type;
        const value = element.value;
        textLength = (value || "").length;

        if (type === "email" || type === "number") {
          // For these types Chromium doesn't provide selectionStart and selectionEnd.
          // Hence the ugly workaround to find if the caret position is changed with
          // the keypress.
          // TODO: Have a look at range, week, time, time, date, datetime-local.
          if (textLength) {
            const selection = dom.getSelection(element);

            if (selection) {
              const initialLength = selection.toString().length;
              const isBackward = key === Keys.ArrowLeft || key === Keys.ArrowUp;
              selection.modify("extend", isBackward ? "backward" : "forward", "character");

              if (initialLength !== selection.toString().length) {
                // The caret is moved, so, we're not on the edge of the value.
                // Restore original selection.
                selection.modify("extend", isBackward ? "forward" : "backward", "character");
                return true;
              } else {
                textLength = 0;
              }
            }
          }
        } else {
          const selStart = element.selectionStart;

          if (selStart === null) {
            // Do not ignore not text editable inputs like checkboxes and radios (but ignore hidden).
            return type === "hidden";
          }

          selectionStart = selStart || 0;
          selectionEnd = element.selectionEnd || 0;
        }
      } else if (element.contentEditable === "true") {
        asyncRet = new (getPromise(this._win))(resolve => {
          this._ignoredInputResolve = value => {
            delete this._ignoredInputResolve;
            resolve(value);
          };

          const win = this._win();

          if (this._ignoredInputTimer) {
            win.clearTimeout(this._ignoredInputTimer);
          }

          const {
            anchorNode: prevAnchorNode,
            focusNode: prevFocusNode,
            anchorOffset: prevAnchorOffset,
            focusOffset: prevFocusOffset
          } = dom.getSelection(element) || {}; // Get selection gives incorrect value if we call it syncronously onKeyDown.

          this._ignoredInputTimer = win.setTimeout(() => {
            var _a, _b, _c;

            delete this._ignoredInputTimer;
            const {
              anchorNode,
              focusNode,
              anchorOffset,
              focusOffset
            } = dom.getSelection(element) || {};

            if (anchorNode !== prevAnchorNode || focusNode !== prevFocusNode || anchorOffset !== prevAnchorOffset || focusOffset !== prevFocusOffset) {
              (_a = this._ignoredInputResolve) === null || _a === undefined ? undefined : _a.call(this, false);
              return;
            }

            selectionStart = anchorOffset || 0;
            selectionEnd = focusOffset || 0;
            textLength = ((_b = element.textContent) === null || _b === undefined ? undefined : _b.length) || 0;

            if (anchorNode && focusNode) {
              if (dom.nodeContains(element, anchorNode) && dom.nodeContains(element, focusNode)) {
                if (anchorNode !== element) {
                  let anchorFound = false;

                  const addOffsets = node => {
                    if (node === anchorNode) {
                      anchorFound = true;
                    } else if (node === focusNode) {
                      return true;
                    }

                    const nodeText = node.textContent;

                    if (nodeText && !dom.getFirstChild(node)) {
                      const len = nodeText.length;

                      if (anchorFound) {
                        if (focusNode !== anchorNode) {
                          selectionEnd += len;
                        }
                      } else {
                        selectionStart += len;
                        selectionEnd += len;
                      }
                    }

                    let stop = false;

                    for (let e = dom.getFirstChild(node); e && !stop; e = e.nextSibling) {
                      stop = addOffsets(e);
                    }

                    return stop;
                  };

                  addOffsets(element);
                }
              }
            }

            (_c = this._ignoredInputResolve) === null || _c === undefined ? undefined : _c.call(this, true);
          }, 0);
        });
      }

      if (asyncRet && !(await asyncRet)) {
        return true;
      }

      if (selectionStart !== selectionEnd) {
        return true;
      }

      if (selectionStart > 0 && (key === Keys.ArrowLeft || key === Keys.ArrowUp || key === Keys.Home)) {
        return true;
      }

      if (selectionStart < textLength && (key === Keys.ArrowRight || key === Keys.ArrowDown || key === Keys.End)) {
        return true;
      }
    }

    return false;
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function observeMutations(doc, tabster, updateTabsterByAttribute, syncState) {
  if (typeof MutationObserver === "undefined") {
    return () => {
      /* Noop */
    };
  }

  const getWindow = tabster.getWindow;
  let elementByUId;

  const onMutation = mutations => {
    var _a, _b, _c, _d, _e;

    const removedNodes = new Set();

    for (const mutation of mutations) {
      const target = mutation.target;
      const removed = mutation.removedNodes;
      const added = mutation.addedNodes;

      if (mutation.type === "attributes") {
        if (mutation.attributeName === TABSTER_ATTRIBUTE_NAME) {
          // removedNodes helps to make sure we are not recreating things
          // for the removed elements.
          // For some reason, if we do removeChild() and setAttribute() on the
          // removed child in the same tick, both the child removal and the attribute
          // change will be present in the mutation records. And the attribute change
          // will follow the child removal.
          // So, we remember the removed nodes and ignore attribute changes for them.
          if (!removedNodes.has(target)) {
            updateTabsterByAttribute(tabster, target);
          }
        }
      } else {
        for (let i = 0; i < removed.length; i++) {
          const removedNode = removed[i];
          removedNodes.add(removedNode);
          updateTabsterElements(removedNode, true);
          (_b = (_a = tabster._dummyObserver).domChanged) === null || _b === undefined ? undefined : _b.call(_a, target);
        }

        for (let i = 0; i < added.length; i++) {
          updateTabsterElements(added[i]);
          (_d = (_c = tabster._dummyObserver).domChanged) === null || _d === undefined ? undefined : _d.call(_c, target);
        }
      }
    }

    removedNodes.clear();
    (_e = tabster.modalizer) === null || _e === undefined ? undefined : _e.hiddenUpdate();
  };

  function updateTabsterElements(node, removed) {
    if (!elementByUId) {
      elementByUId = getInstanceContext(getWindow).elementByUId;
    }

    processNode(node, removed);
    const walker = createElementTreeWalker(doc, node, element => {
      return processNode(element, removed);
    });

    if (walker) {
      while (walker.nextNode()) {
        /* Iterating for the sake of calling processNode() callback. */
      }
    }
  }

  function processNode(element, removed) {
    var _a;

    if (!element.getAttribute) {
      // It might actually be a text node.
      return NodeFilter.FILTER_SKIP;
    }

    const uid = element.__tabsterElementUID;

    if (uid && elementByUId) {
      if (removed) {
        delete elementByUId[uid];
      } else {
        (_a = elementByUId[uid]) !== null && _a !== undefined ? _a : elementByUId[uid] = new WeakHTMLElement(getWindow, element);
      }
    }

    if (getTabsterOnElement(tabster, element) || element.hasAttribute(TABSTER_ATTRIBUTE_NAME)) {
      updateTabsterByAttribute(tabster, element, removed);
    }

    return NodeFilter.FILTER_SKIP;
  }

  const observer = dom.createMutationObserver(onMutation);

  if (syncState) {
    updateTabsterElements(getWindow().document.body);
  }

  observer.observe(doc, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [TABSTER_ATTRIBUTE_NAME]
  });
  return () => {
    observer.disconnect();
  };
}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Allows default or user focus behaviour on the DOM subtree
 * i.e. Tabster will not control focus events within an uncontrolled area
 */
class UncontrolledAPI {
  constructor(isUncontrolledCompletely) {
    this._isUncontrolledCompletely = isUncontrolledCompletely;
  }

  isUncontrolledCompletely(element, completely) {
    var _a;

    const isUncontrolledCompletely = (_a = this._isUncontrolledCompletely) === null || _a === undefined ? undefined : _a.call(this, element, completely); // If isUncontrolledCompletely callback is not defined or returns undefined, then the default
    // behaviour is to return the uncontrolled.completely value from the element.

    return isUncontrolledCompletely === undefined ? completely : isUncontrolledCompletely;
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

class Restorer extends TabsterPart {
  constructor(tabster, element, props) {
    var _a;

    super(tabster, element, props);
    this._hasFocus = false;

    this._onFocusOut = e => {
      var _a;

      const element = (_a = this._element) === null || _a === undefined ? undefined : _a.get();

      if (element && e.relatedTarget === null) {
        element.dispatchEvent(new RestorerRestoreFocusEvent());
      }

      if (element && !dom.nodeContains(element, e.relatedTarget)) {
        this._hasFocus = false;
      }
    };

    this._onFocusIn = () => {
      this._hasFocus = true;
    };

    if (this._props.type === RestorerTypes.Source) {
      const element = (_a = this._element) === null || _a === undefined ? undefined : _a.get();
      element === null || element === undefined ? undefined : element.addEventListener("focusout", this._onFocusOut);
      element === null || element === undefined ? undefined : element.addEventListener("focusin", this._onFocusIn); // set hasFocus when the instance is created, in case focus has already moved within it

      this._hasFocus = dom.nodeContains(element, element && dom.getActiveElement(element.ownerDocument));
    }
  }

  dispose() {
    var _a;

    if (this._props.type === RestorerTypes.Source) {
      const element = (_a = this._element) === null || _a === undefined ? undefined : _a.get();
      element === null || element === undefined ? undefined : element.removeEventListener("focusout", this._onFocusOut);
      element === null || element === undefined ? undefined : element.removeEventListener("focusin", this._onFocusIn);

      if (this._hasFocus) {
        const doc = this._tabster.getWindow().document;

        doc.body.dispatchEvent(new RestorerRestoreFocusEvent());
      }
    }
  }

}

class History {
  constructor(getWindow) {
    this._stack = [];
    this._getWindow = getWindow;
  }
  /**
   * Push a weak element to the top of the history stack.
   * If the stack is full, the bottom weak element is removed.
   * If the element is already at the top of the stack, it is not duplicated.
   */


  push(element) {
    var _a; // Don't duplicate the top of history


    if (((_a = this._stack[this._stack.length - 1]) === null || _a === undefined ? undefined : _a.get()) === element) {
      return;
    }

    if (this._stack.length > History.DEPTH) {
      this._stack.shift();
    }

    this._stack.push(new WeakHTMLElement(this._getWindow, element));
  }
  /**
   * Pop the first element from the history that satisfies the callback.
   * The history is searched from the top to the bottom (from the most recent to the least recent).
   *
   * If a weak reference to the element is broken,
   * or the element is no longer in the DOM,
   * the element is removed from the top of the stack while popping.
   *
   * If no matching element is found, undefined is returned.
   * If the stack is empty, undefined is returned.
   */


  pop(filter) {
    if (filter === undefined) {
      filter = () => true;
    }

    var _a;

    const doc = this._getWindow().document;

    for (let index = this._stack.length - 1; index >= 0; index--) {
      const maybeElement = (_a = this._stack.pop()) === null || _a === undefined ? undefined : _a.get();

      if (maybeElement && dom.nodeContains(doc.body, dom.getParentElement(maybeElement)) && filter(maybeElement)) {
        return maybeElement;
      }
    }

    return undefined;
  }

}

History.DEPTH = 10;
class RestorerAPI {
  constructor(tabster) {
    this._onRestoreFocus = e => {
      var _a, _b;

      this._focusedElementState.cancelAsyncFocus(AsyncFocusSources.Restorer); // ShadowDOM will have shadowRoot as e.target.


      const source = e.composedPath()[0];

      if (source) {
        // source id must be recovered before source is removed from DOM
        // otherwise it'll be unreachable
        // (as tabster on element will not be available through getTabsterOnElement)
        const sourceId = (_b = (_a = getTabsterOnElement(this._tabster, source)) === null || _a === undefined ? undefined : _a.restorer) === null || _b === undefined ? undefined : _b.getProps().id;

        this._focusedElementState.requestAsyncFocus(AsyncFocusSources.Restorer, () => this._restoreFocus(source, sourceId), 0);
      }
    };

    this._onFocusIn = element => {
      var _a;

      if (!element) {
        return;
      }

      const tabsterAttribute = getTabsterOnElement(this._tabster, element);

      if (((_a = tabsterAttribute === null || tabsterAttribute === undefined ? undefined : tabsterAttribute.restorer) === null || _a === undefined ? undefined : _a.getProps().type) !== RestorerTypes.Target) {
        return;
      }

      this._history.push(element);
    };

    this._restoreFocus = (source, sourceId) => {
      var _a; // don't restore focus if focus isn't lost to body


      const doc = this._getWindow().document;

      if (dom.getActiveElement(doc) !== doc.body) {
        return;
      }

      if ( // clicking on any empty space focuses body - this is can be a false positive
      !this._keyboardNavState.isNavigatingWithKeyboard() && // Source no longer exists on DOM - always restore focus
      dom.nodeContains(doc.body, source)) {
        return;
      }

      const getId = element => {
        var _a, _b;

        return (_b = (_a = getTabsterOnElement(this._tabster, element)) === null || _a === undefined ? undefined : _a.restorer) === null || _b === undefined ? undefined : _b.getProps().id;
      };

      (_a = this._history.pop(target => sourceId === getId(target))) === null || _a === undefined ? undefined : _a.focus();
    };

    this._tabster = tabster;
    this._getWindow = tabster.getWindow;

    this._getWindow().addEventListener(RestorerRestoreFocusEventName, this._onRestoreFocus);

    this._history = new History(this._getWindow);
    this._keyboardNavState = tabster.keyboardNavigation;
    this._focusedElementState = tabster.focusedElement;

    this._focusedElementState.subscribe(this._onFocusIn);
  }

  dispose() {
    const win = this._getWindow();

    this._focusedElementState.unsubscribe(this._onFocusIn);

    this._focusedElementState.cancelAsyncFocus(AsyncFocusSources.Restorer);

    win.removeEventListener(RestorerRestoreFocusEventName, this._onRestoreFocus);
  }

  createRestorer(element, props) {
    const restorer = new Restorer(this._tabster, element, props); // Focus might already be on a restorer target when it gets created so the focusin will not do anything

    if (props.type === RestorerTypes.Target && dom.getActiveElement(element.ownerDocument) === element) {
      this._history.push(element);
    }

    return restorer;
  }

}

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

class Tabster {
  constructor(tabster) {
    this.keyboardNavigation = tabster.keyboardNavigation;
    this.focusedElement = tabster.focusedElement;
    this.focusable = tabster.focusable;
    this.root = tabster.root;
    this.uncontrolled = tabster.uncontrolled;
    this.core = tabster;
  }

}
/**
 * Extends Window to include an internal Tabster instance.
 */


class TabsterCore {
  constructor(win, props) {
    var _a, _b;

    this._forgetMemorizedElements = [];
    this._wrappers = new Set();
    this._initQueue = [];
    this._version = "8.2.0";
    this._noop = false;

    this.getWindow = () => {
      if (!this._win) {
        throw new Error("Using disposed Tabster.");
      }

      return this._win;
    };

    this._storage = createWeakMap(win);
    this._win = win;
    const getWindow = this.getWindow;

    if (props === null || props === undefined ? undefined : props.DOMAPI) {
      setDOMAPI({ ...props.DOMAPI
      });
    }

    this.keyboardNavigation = new KeyboardNavigationState(getWindow);
    this.focusedElement = new FocusedElementState(this, getWindow);
    this.focusable = new FocusableAPI(this);
    this.root = new RootAPI(this, props === null || props === undefined ? undefined : props.autoRoot);
    this.uncontrolled = new UncontrolledAPI( // TODO: Remove checkUncontrolledTrappingFocus in the next major version.
    (props === null || props === undefined ? undefined : props.checkUncontrolledCompletely) || (props === null || props === undefined ? undefined : props.checkUncontrolledTrappingFocus));
    this.controlTab = (_a = props === null || props === undefined ? undefined : props.controlTab) !== null && _a !== undefined ? _a : true;
    this.rootDummyInputs = !!(props === null || props === undefined ? undefined : props.rootDummyInputs);
    this._dummyObserver = new DummyInputObserver(getWindow);
    this.getParent = (_b = props === null || props === undefined ? undefined : props.getParent) !== null && _b !== undefined ? _b : dom.getParentNode;
    this.internal = {
      stopObserver: () => {
        if (this._unobserve) {
          this._unobserve();

          delete this._unobserve;
        }
      },
      resumeObserver: syncState => {
        if (!this._unobserve) {
          const doc = getWindow().document;
          this._unobserve = observeMutations(doc, this, updateTabsterByAttribute, syncState);
        }
      }
    };
    startFakeWeakRefsCleanup(getWindow); // Gives a tick to the host app to initialize other tabster
    // APIs before tabster starts observing attributes.

    this.queueInit(() => {
      this.internal.resumeObserver(true);
    });
  }
  /**
   * Merges external props with the current props. Not all
   * props can/should be mergeable, so let's add more as we move on.
   * @param props Tabster props
   */


  _mergeProps(props) {
    var _a;

    if (!props) {
      return;
    }

    this.getParent = (_a = props.getParent) !== null && _a !== undefined ? _a : this.getParent;
  }

  createTabster(noRefCount, props) {
    const wrapper = new Tabster(this);

    if (!noRefCount) {
      this._wrappers.add(wrapper);
    }

    this._mergeProps(props);

    return wrapper;
  }

  disposeTabster(wrapper, allInstances) {
    if (allInstances) {
      this._wrappers.clear();
    } else {
      this._wrappers.delete(wrapper);
    }

    if (this._wrappers.size === 0) {
      this.dispose();
    }
  }

  dispose() {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    this.internal.stopObserver();
    const win = this._win;
    win === null || win === undefined ? undefined : win.clearTimeout(this._initTimer);
    delete this._initTimer;
    this._initQueue = [];
    this._forgetMemorizedElements = [];

    if (win && this._forgetMemorizedTimer) {
      win.clearTimeout(this._forgetMemorizedTimer);
      delete this._forgetMemorizedTimer;
    }

    (_a = this.outline) === null || _a === undefined ? undefined : _a.dispose();
    (_b = this.crossOrigin) === null || _b === undefined ? undefined : _b.dispose();
    (_c = this.deloser) === null || _c === undefined ? undefined : _c.dispose();
    (_d = this.groupper) === null || _d === undefined ? undefined : _d.dispose();
    (_e = this.mover) === null || _e === undefined ? undefined : _e.dispose();
    (_f = this.modalizer) === null || _f === undefined ? undefined : _f.dispose();
    (_g = this.observedElement) === null || _g === undefined ? undefined : _g.dispose();
    (_h = this.restorer) === null || _h === undefined ? undefined : _h.dispose();
    this.keyboardNavigation.dispose();
    this.focusable.dispose();
    this.focusedElement.dispose();
    this.root.dispose();

    this._dummyObserver.dispose();

    stopFakeWeakRefsCleanupAndClearStorage(this.getWindow);
    clearElementCache(this.getWindow);
    this._storage = new WeakMap();

    this._wrappers.clear();

    if (win) {
      disposeInstanceContext(win);
      delete win.__tabsterInstance;
      delete this._win;
    }
  }

  storageEntry(element, addremove) {
    const storage = this._storage;
    let entry = storage.get(element);

    if (entry) {
      if (addremove === false && Object.keys(entry).length === 0) {
        storage.delete(element);
      }
    } else if (addremove === true) {
      entry = {};
      storage.set(element, entry);
    }

    return entry;
  }

  forceCleanup() {
    if (!this._win) {
      return;
    }

    this._forgetMemorizedElements.push(this._win.document.body);

    if (this._forgetMemorizedTimer) {
      return;
    }

    this._forgetMemorizedTimer = this._win.setTimeout(() => {
      delete this._forgetMemorizedTimer;

      for (let el = this._forgetMemorizedElements.shift(); el; el = this._forgetMemorizedElements.shift()) {
        clearElementCache(this.getWindow, el);
        FocusedElementState.forgetMemorized(this.focusedElement, el);
      }
    }, 0);
    cleanupFakeWeakRefs(this.getWindow, true);
  }

  queueInit(callback) {
    var _a;

    if (!this._win) {
      return;
    }

    this._initQueue.push(callback);

    if (!this._initTimer) {
      this._initTimer = (_a = this._win) === null || _a === undefined ? undefined : _a.setTimeout(() => {
        delete this._initTimer;
        this.drainInitQueue();
      }, 0);
    }
  }

  drainInitQueue() {
    if (!this._win) {
      return;
    }

    const queue = this._initQueue; // Resetting the queue before calling the callbacks to avoid recursion.

    this._initQueue = [];
    queue.forEach(callback => callback());
  }

}
/**
 * Creates an instance of Tabster, returns the current window instance if it already exists.
 */

function createTabster(win, props) {
  let tabster = getCurrentTabster(win);

  if (tabster) {
    return tabster.createTabster(false, props);
  }

  tabster = new TabsterCore(win, props);
  win.__tabsterInstance = tabster;
  return tabster.createTabster();
}
/**
 * Creates a new groupper instance or returns an existing one
 * @param tabster Tabster instance
 */

function getGroupper(tabster) {
  const tabsterCore = tabster.core;

  if (!tabsterCore.groupper) {
    tabsterCore.groupper = new GroupperAPI(tabsterCore, tabsterCore.getWindow);
  }

  return tabsterCore.groupper;
}
/**
 * Creates a new mover instance or returns an existing one
 * @param tabster Tabster instance
 */

function getMover(tabster) {
  const tabsterCore = tabster.core;

  if (!tabsterCore.mover) {
    tabsterCore.mover = new MoverAPI(tabsterCore, tabsterCore.getWindow);
  }

  return tabsterCore.mover;
}
/**
 * Creates a new modalizer instance or returns an existing one
 * @param tabster Tabster instance
 * @param alwaysAccessibleSelector When Modalizer is active, we put
 * aria-hidden to everything else to hide it from screen readers. This CSS
 * selector allows to exclude some elements from this behaviour. For example,
 * this could be used to exclude aria-live region with the application-wide
 * status announcements.
 * @param accessibleCheck An optional callback that will be called when
 * active Modalizer wants to hide an element that doesn't belong to it from
 * the screen readers by setting aria-hidden. Similar to alwaysAccessibleSelector
 * but allows to address the elements programmatically rather than with a selector.
 * If the callback returns true, the element will not receive aria-hidden.
 */

function getModalizer(tabster, // @deprecated use accessibleCheck.
alwaysAccessibleSelector, accessibleCheck) {
  const tabsterCore = tabster.core;

  if (!tabsterCore.modalizer) {
    tabsterCore.modalizer = new ModalizerAPI(tabsterCore, alwaysAccessibleSelector, accessibleCheck);
  }

  return tabsterCore.modalizer;
}
function getRestorer(tabster) {
  const tabsterCore = tabster.core;

  if (!tabsterCore.restorer) {
    tabsterCore.restorer = new RestorerAPI(tabsterCore);
  }

  return tabsterCore.restorer;
}
function disposeTabster(tabster, allInstances) {
  tabster.core.disposeTabster(tabster, allInstances);
}
/**
 * Returns an instance of Tabster if it already exists on the window .
 * @param win window instance that could contain an Tabster instance.
 */

function getCurrentTabster(win) {
  return win.__tabsterInstance;
}

/**
 * Tries to get a tabster instance on the current window or creates a new one
 * Since Tabster is single instance only, feel free to call this hook to ensure Tabster exists if necessary
 *
 * @internal
 * @returns Tabster core instance
 */ const useTabster = ()=>{
    const { targetDocument } = useFluent();
    const defaultView = (targetDocument === null || targetDocument === undefined ? undefined : targetDocument.defaultView) || undefined;
    const shadowDOMAPI = defaultView === null || defaultView === undefined ? undefined : defaultView.__tabsterShadowDOMAPI;
    const tabster = React.useMemo(()=>{
        if (!defaultView) {
            return null;
        }
        return createTabster(defaultView, {
            autoRoot: {},
            controlTab: false,
            getParent,
            checkUncontrolledTrappingFocus: (element)=>{
                var _element_firstElementChild;
                return !!((_element_firstElementChild = element.firstElementChild) === null || _element_firstElementChild === undefined ? undefined : _element_firstElementChild.hasAttribute('data-is-focus-trap-zone-bumper'));
            },
            DOMAPI: shadowDOMAPI
        });
    }, [
        defaultView,
        shadowDOMAPI
    ]);
    useIsomorphicLayoutEffect(()=>{
        return ()=>{
            if (tabster) {
                disposeTabster(tabster);
            }
        };
    }, [
        tabster
    ]);
    return tabster;
};

/**
 * @internal
 * Hook that returns tabster attributes while ensuring tabster exists
 */ const useTabsterAttributes = (props)=>{
    // A tabster instance is not necessary to generate tabster attributes
    // but calling the hook will ensure that a tabster instance exists internally and avoids consumers doing the same
    useTabster();
    const strAttr = getTabsterAttribute(props);
    return React.useMemo(()=>({
            [TABSTER_ATTRIBUTE_NAME]: strAttr
        }), [
        strAttr
    ]);
};

/**
 * A hook that returns the necessary tabster attributes to support arrow key navigation
 * @param options - Options to configure keyboard navigation
 */ const useArrowNavigationGroup = (options = {})=>{
    const { circular, axis, memorizeCurrent = true, tabbable, ignoreDefaultKeydown, // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_hasDefault } = options;
    const tabster = useTabster();
    if (tabster) {
        getMover(tabster);
    }
    return useTabsterAttributes({
        mover: {
            cyclic: !!circular,
            direction: axisToMoverDirection(axis !== null && axis !== undefined ? axis : 'vertical'),
            memorizeCurrent,
            tabbable,
            hasDefault: unstable_hasDefault
        },
        ...ignoreDefaultKeydown && {
            focusable: {
                ignoreKeydown: ignoreDefaultKeydown
            }
        }
    });
};
function axisToMoverDirection(axis) {
    switch(axis){
        case 'horizontal':
            return MoverDirections.Horizontal;
        case 'grid':
            return MoverDirections.Grid;
        case 'grid-linear':
            return MoverDirections.GridLinear;
        case 'both':
            return MoverDirections.Both;
        case 'vertical':
        default:
            return MoverDirections.Vertical;
    }
}

/**
 * A hook that returns the necessary tabster attributes to support groupping.
 * @param options - Options to configure keyboard navigation
 */ const useFocusableGroup = (options)=>{
    const tabster = useTabster();
    if (tabster) {
        getGroupper(tabster);
    }
    return useTabsterAttributes({
        groupper: {
            tabbability: getTabbability(options === null || options === undefined ? undefined : options.tabBehavior)
        },
        focusable: {
            ignoreKeydown: options === null || options === undefined ? undefined : options.ignoreDefaultKeydown
        }
    });
};
const getTabbability = (tabBehavior)=>{
    switch(tabBehavior){
        case 'unlimited':
            return GroupperTabbabilities.Unlimited;
        case 'limited':
            return GroupperTabbabilities.Limited;
        case 'limited-trap-focus':
            return GroupperTabbabilities.LimitedTrapFocus;
        default:
            return undefined;
    }
};

/**
 * Returns a set of helper functions that will traverse focusable elements in the context of a root DOM element
 */ const useFocusFinders = ()=>{
    const tabster = useTabster();
    const { targetDocument } = useFluent();
    // Narrow props for now and let need dictate additional props in the future
    const findAllFocusable = React.useCallback((container, acceptCondition)=>(tabster === null || tabster === undefined ? undefined : tabster.focusable.findAll({
            container,
            acceptCondition
        })) || [], [
        tabster
    ]);
    const findFirstFocusable = React.useCallback((container)=>tabster === null || tabster === undefined ? undefined : tabster.focusable.findFirst({
            container
        }), [
        tabster
    ]);
    const findLastFocusable = React.useCallback((container)=>tabster === null || tabster === undefined ? undefined : tabster.focusable.findLast({
            container
        }), [
        tabster
    ]);
    const findNextFocusable = React.useCallback((currentElement, options = {})=>{
        if (!tabster || !targetDocument) {
            return null;
        }
        const { container = targetDocument.body } = options;
        return tabster.focusable.findNext({
            currentElement,
            container
        });
    }, [
        tabster,
        targetDocument
    ]);
    const findPrevFocusable = React.useCallback((currentElement, options = {})=>{
        if (!tabster || !targetDocument) {
            return null;
        }
        const { container = targetDocument.body } = options;
        return tabster.focusable.findPrev({
            currentElement,
            container
        });
    }, [
        tabster,
        targetDocument
    ]);
    return {
        findAllFocusable,
        findFirstFocusable,
        findLastFocusable,
        findNextFocusable,
        findPrevFocusable
    };
};

const FOCUS_VISIBLE_ATTR = "data-fui-focus-visible";
const FOCUS_WITHIN_ATTR = "data-fui-focus-within";

/**
 * @internal
 * @param scope - Applies the ponyfill to all DOM children
 * @param targetWindow - window
 */ function applyFocusVisiblePolyfill(scope, targetWindow) {
    if (alreadyInScope(scope)) {
        // Focus visible polyfill already applied at this scope
        return ()=>undefined;
    }
    const state = {
        current: undefined
    };
    const keyborg = createKeyborg(targetWindow);
    function registerElementIfNavigating(el) {
        if (keyborg.isNavigatingWithKeyboard() && isHTMLElement$3(el)) {
            state.current = el;
            el.setAttribute(FOCUS_VISIBLE_ATTR, '');
        }
    }
    function disposeCurrentElement() {
        if (state.current) {
            state.current.removeAttribute(FOCUS_VISIBLE_ATTR);
            state.current = undefined;
        }
    }
    // When navigation mode changes remove the focus-visible selector
    keyborg.subscribe((isNavigatingWithKeyboard)=>{
        if (!isNavigatingWithKeyboard) {
            disposeCurrentElement();
        }
    });
    // Keyborg's focusin event is delegated so it's only registered once on the window
    // and contains metadata about the focus event
    const keyborgListener = (e)=>{
        disposeCurrentElement();
        const target = e.composedPath()[0];
        registerElementIfNavigating(target);
    };
    // Make sure that when focus leaves the scope, the focus visible class is removed
    const blurListener = (e)=>{
        if (!e.relatedTarget || isHTMLElement$3(e.relatedTarget) && !scope.contains(e.relatedTarget)) {
            disposeCurrentElement();
        }
    };
    scope.addEventListener(KEYBORG_FOCUSIN, keyborgListener);
    scope.addEventListener('focusout', blurListener);
    scope.focusVisible = true;
    if (scope.contains(targetWindow.document.activeElement)) {
        registerElementIfNavigating(targetWindow.document.activeElement);
    }
    // Return disposer
    return ()=>{
        disposeCurrentElement();
        scope.removeEventListener(KEYBORG_FOCUSIN, keyborgListener);
        scope.removeEventListener('focusout', blurListener);
        delete scope.focusVisible;
        disposeKeyborg(keyborg);
    };
}
function alreadyInScope(el) {
    if (!el) {
        return false;
    }
    if (el.focusVisible) {
        return true;
    }
    return alreadyInScope(el === null || el === undefined ? undefined : el.parentElement);
}

function useFocusVisible(options = {}) {
    const contextValue = useFluent();
    const scopeRef = React.useRef(null);
    var _options_targetDocument;
    const targetDocument = (_options_targetDocument = options.targetDocument) !== null && _options_targetDocument !== undefined ? _options_targetDocument : contextValue.targetDocument;
    React.useEffect(()=>{
        if ((targetDocument === null || targetDocument === undefined ? undefined : targetDocument.defaultView) && scopeRef.current) {
            return applyFocusVisiblePolyfill(scopeRef.current, targetDocument.defaultView);
        }
    }, [
        scopeRef,
        targetDocument
    ]);
    return scopeRef;
}

function applyFocusWithinPolyfill(element, win) {
  const keyborg = createKeyborg(win);
  keyborg.subscribe((isNavigatingWithKeyboard) => {
    if (!isNavigatingWithKeyboard) {
      removeFocusWithinClass(element);
    }
  });
  const keyborgListener = (e) => {
    if (keyborg.isNavigatingWithKeyboard() && isHTMLElement$2(e.target)) {
      applyFocusWithinClass(element);
    }
  };
  const blurListener = (e) => {
    if (!e.relatedTarget || isHTMLElement$2(e.relatedTarget) && !element.contains(e.relatedTarget)) {
      removeFocusWithinClass(element);
    }
  };
  element.addEventListener(KEYBORG_FOCUSIN, keyborgListener);
  element.addEventListener("focusout", blurListener);
  return () => {
    element.removeEventListener(KEYBORG_FOCUSIN, keyborgListener);
    element.removeEventListener("focusout", blurListener);
    disposeKeyborg(keyborg);
  };
}
function applyFocusWithinClass(el) {
  el.setAttribute(FOCUS_WITHIN_ATTR, "");
}
function removeFocusWithinClass(el) {
  el.removeAttribute(FOCUS_WITHIN_ATTR);
}
function isHTMLElement$2(target) {
  if (!target) {
    return false;
  }
  return Boolean(target && typeof target === "object" && "classList" in target && "contains" in target);
}

/**
 * A ponyfill that allows `:focus-within` to support visibility based on keyboard/mouse navigation
 * like `:focus-visible` https://github.com/WICG/focus-visible/issues/151
 * @returns ref to the element that uses `:focus-within` styles
 */ function useFocusWithin() {
    const { targetDocument } = useFluent();
    const elementRef = React.useRef(null);
    React.useEffect(()=>{
        if ((targetDocument === null || targetDocument === undefined ? undefined : targetDocument.defaultView) && elementRef.current) {
            return applyFocusWithinPolyfill(elementRef.current, targetDocument.defaultView);
        }
    }, [
        elementRef,
        targetDocument
    ]);
    return elementRef;
}

/**
 * @internal
 * Instantiates [keyborg](https://github.com/microsoft/keyborg)
 * @returns - keyborg instance
 */ function useKeyborgRef() {
    const { targetDocument } = useFluent();
    const keyborgRef = React.useRef(null);
    React.useEffect(()=>{
        if (targetDocument) {
            const keyborg = createKeyborg(targetDocument.defaultView);
            keyborgRef.current = keyborg;
            return ()=>{
                disposeKeyborg(keyborg);
                keyborgRef.current = null;
            };
        }
    }, [
        targetDocument
    ]);
    return keyborgRef;
}

/**
 * Applies modal dialog behaviour through DOM attributes
 * Modal element will focus trap and hide other content on the page
 * The trigger element will be focused if focus is lost after the modal element is removed
 *
 * @returns DOM attributes to apply to the modal element and its trigger
 */ const useModalAttributes = (options = {})=>{
    const { trapFocus, alwaysFocusable, legacyTrapFocus } = options;
    const tabster = useTabster();
    // Initializes the modalizer and restorer APIs
    if (tabster) {
        getModalizer(tabster);
        getRestorer(tabster);
    }
    const id = useId('modal-', options.id);
    const modalAttributes = useTabsterAttributes({
        restorer: {
            type: RestorerTypes.Source
        },
        ...trapFocus && {
            modalizer: {
                id,
                isOthersAccessible: !trapFocus,
                isAlwaysAccessible: alwaysFocusable,
                isTrapped: legacyTrapFocus && trapFocus
            }
        }
    });
    const triggerAttributes = useTabsterAttributes({
        restorer: {
            type: RestorerTypes.Target
        }
    });
    return {
        modalAttributes,
        triggerAttributes
    };
};

/**
 * Instantiates [keyborg](https://github.com/microsoft/keyborg) and checks if the user is navigating with the keyboard.
 * @returns {() => boolean}
 */ function useIsNavigatingWithKeyboard() {
    const keyborgRef = useKeyborgRef();
    return React.useCallback(()=>{
        var _keyborgRef_current;
        var _keyborgRef_current_isNavigatingWithKeyboard;
        return (_keyborgRef_current_isNavigatingWithKeyboard = (_keyborgRef_current = keyborgRef.current) === null || _keyborgRef_current === undefined ? undefined : _keyborgRef_current.isNavigatingWithKeyboard()) !== null && _keyborgRef_current_isNavigatingWithKeyboard !== undefined ? _keyborgRef_current_isNavigatingWithKeyboard : false;
    }, [
        keyborgRef
    ]);
}

/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ const grey = {
    '2': '#050505',
    '4': '#0a0a0a',
    '6': '#0f0f0f',
    '8': '#141414',
    '10': '#1a1a1a',
    '12': '#1f1f1f',
    '14': '#242424',
    '16': '#292929',
    '18': '#2e2e2e',
    '20': '#333333',
    '22': '#383838',
    '24': '#3d3d3d',
    '26': '#424242',
    '28': '#474747',
    '30': '#4d4d4d',
    '32': '#525252',
    '34': '#575757',
    '36': '#5c5c5c',
    '38': '#616161',
    '40': '#666666',
    '42': '#6b6b6b',
    '44': '#707070',
    '46': '#757575',
    '48': '#7a7a7a',
    '50': '#808080',
    '52': '#858585',
    '54': '#8a8a8a',
    '56': '#8f8f8f',
    '58': '#949494',
    '60': '#999999',
    '62': '#9e9e9e',
    '64': '#a3a3a3',
    '66': '#a8a8a8',
    '68': '#adadad',
    '70': '#b3b3b3',
    '72': '#b8b8b8',
    '74': '#bdbdbd',
    '76': '#c2c2c2',
    '78': '#c7c7c7',
    '80': '#cccccc',
    '82': '#d1d1d1',
    '84': '#d6d6d6',
    '86': '#dbdbdb',
    '88': '#e0e0e0',
    '90': '#e6e6e6',
    '92': '#ebebeb',
    '94': '#f0f0f0',
    '96': '#f5f5f5',
    '98': '#fafafa'
};
const whiteAlpha = {
    '5': 'rgba(255, 255, 255, 0.05)',
    '10': 'rgba(255, 255, 255, 0.1)',
    '20': 'rgba(255, 255, 255, 0.2)',
    '30': 'rgba(255, 255, 255, 0.3)',
    '40': 'rgba(255, 255, 255, 0.4)',
    '50': 'rgba(255, 255, 255, 0.5)',
    '60': 'rgba(255, 255, 255, 0.6)',
    '70': 'rgba(255, 255, 255, 0.7)',
    '80': 'rgba(255, 255, 255, 0.8)',
    '90': 'rgba(255, 255, 255, 0.9)'
};
const blackAlpha = {
    '5': 'rgba(0, 0, 0, 0.05)',
    '10': 'rgba(0, 0, 0, 0.1)',
    '20': 'rgba(0, 0, 0, 0.2)',
    '30': 'rgba(0, 0, 0, 0.3)',
    '40': 'rgba(0, 0, 0, 0.4)',
    '50': 'rgba(0, 0, 0, 0.5)',
    '60': 'rgba(0, 0, 0, 0.6)',
    '70': 'rgba(0, 0, 0, 0.7)',
    '80': 'rgba(0, 0, 0, 0.8)',
    '90': 'rgba(0, 0, 0, 0.9)'
};
const grey10Alpha = {
    '5': 'rgba(26, 26, 26, 0.05)',
    '10': 'rgba(26, 26, 26, 0.1)',
    '20': 'rgba(26, 26, 26, 0.2)',
    '30': 'rgba(26, 26, 26, 0.3)',
    '40': 'rgba(26, 26, 26, 0.4)',
    '50': 'rgba(26, 26, 26, 0.5)',
    '60': 'rgba(26, 26, 26, 0.6)',
    '70': 'rgba(26, 26, 26, 0.7)',
    '80': 'rgba(26, 26, 26, 0.8)',
    '90': 'rgba(26, 26, 26, 0.9)'
};
const grey12Alpha = {
    '5': 'rgba(31, 31, 31, 0.05)',
    '10': 'rgba(31, 31, 31, 0.1)',
    '20': 'rgba(31, 31, 31, 0.2)',
    '30': 'rgba(31, 31, 31, 0.3)',
    '40': 'rgba(31, 31, 31, 0.4)',
    '50': 'rgba(31, 31, 31, 0.5)',
    '60': 'rgba(31, 31, 31, 0.6)',
    '70': 'rgba(31, 31, 31, 0.7)',
    '80': 'rgba(31, 31, 31, 0.8)',
    '90': 'rgba(31, 31, 31, 0.9)'
};
const grey14Alpha = {
    '5': 'rgba(36, 36, 36, 0.05)',
    '10': 'rgba(36, 36, 36, 0.1)',
    '20': 'rgba(36, 36, 36, 0.2)',
    '30': 'rgba(36, 36, 36, 0.3)',
    '40': 'rgba(36, 36, 36, 0.4)',
    '50': 'rgba(36, 36, 36, 0.5)',
    '60': 'rgba(36, 36, 36, 0.6)',
    '70': 'rgba(36, 36, 36, 0.7)',
    '80': 'rgba(36, 36, 36, 0.8)',
    '90': 'rgba(36, 36, 36, 0.9)'
};
const white = '#ffffff';
const black = '#000000';
const darkRed = {
    shade50: '#130204',
    shade40: '#230308',
    shade30: '#420610',
    shade20: '#590815',
    shade10: '#690a19',
    primary: '#750b1c',
    tint10: '#861b2c',
    tint20: '#962f3f',
    tint30: '#ac4f5e',
    tint40: '#d69ca5',
    tint50: '#e9c7cd',
    tint60: '#f9f0f2'
};
const cranberry = {
    shade50: '#200205',
    shade40: '#3b0509',
    shade30: '#6e0811',
    shade20: '#960b18',
    shade10: '#b10e1c',
    primary: '#c50f1f',
    tint10: '#cc2635',
    tint20: '#d33f4c',
    tint30: '#dc626d',
    tint40: '#eeacb2',
    tint50: '#f6d1d5',
    tint60: '#fdf3f4'
};
const red = {
    shade50: '#210809',
    shade40: '#3f1011',
    shade30: '#751d1f',
    shade20: '#9f282b',
    shade10: '#bc2f32',
    primary: '#d13438',
    tint10: '#d7494c',
    tint20: '#dc5e62',
    tint30: '#e37d80',
    tint40: '#f1bbbc',
    tint50: '#f8dadb',
    tint60: '#fdf6f6'
};
const darkOrange = {
    shade50: '#230900',
    shade40: '#411200',
    shade30: '#7a2101',
    shade20: '#a62d01',
    shade10: '#c43501',
    primary: '#da3b01',
    tint10: '#de501c',
    tint20: '#e36537',
    tint30: '#e9835e',
    tint40: '#f4bfab',
    tint50: '#f9dcd1',
    tint60: '#fdf6f3'
};
const pumpkin = {
    shade50: '#200d03',
    shade40: '#3d1805',
    shade30: '#712d09',
    shade20: '#9a3d0c',
    shade10: '#b6480e',
    primary: '#ca5010',
    tint10: '#d06228',
    tint20: '#d77440',
    tint30: '#df8e64',
    tint40: '#efc4ad',
    tint50: '#f7dfd2',
    tint60: '#fdf7f4'
};
const orange = {
    shade50: '#271002',
    shade40: '#4a1e04',
    shade30: '#8a3707',
    shade20: '#bc4b09',
    shade10: '#de590b',
    primary: '#f7630c',
    tint10: '#f87528',
    tint20: '#f98845',
    tint30: '#faa06b',
    tint40: '#fdcfb4',
    tint50: '#fee5d7',
    tint60: '#fff9f5'
};
const peach = {
    shade50: '#291600',
    shade40: '#4d2a00',
    shade30: '#8f4e00',
    shade20: '#c26a00',
    shade10: '#e67e00',
    primary: '#ff8c00',
    tint10: '#ff9a1f',
    tint20: '#ffa83d',
    tint30: '#ffba66',
    tint40: '#ffddb3',
    tint50: '#ffedd6',
    tint60: '#fffaf5'
};
const marigold = {
    shade50: '#251a00',
    shade40: '#463100',
    shade30: '#835b00',
    shade20: '#b27c00',
    shade10: '#d39300',
    primary: '#eaa300',
    tint10: '#edad1c',
    tint20: '#efb839',
    tint30: '#f2c661',
    tint40: '#f9e2ae',
    tint50: '#fcefd3',
    tint60: '#fefbf4'
};
const yellow = {
    shade50: '#282400',
    shade40: '#4c4400',
    shade30: '#817400',
    shade20: '#c0ad00',
    shade10: '#e4cc00',
    primary: '#fde300',
    tint10: '#fde61e',
    tint20: '#fdea3d',
    tint30: '#feee66',
    tint40: '#fef7b2',
    tint50: '#fffad6',
    tint60: '#fffef5'
};
const gold = {
    shade50: '#1f1900',
    shade40: '#3a2f00',
    shade30: '#6c5700',
    shade20: '#937700',
    shade10: '#ae8c00',
    primary: '#c19c00',
    tint10: '#c8a718',
    tint20: '#d0b232',
    tint30: '#dac157',
    tint40: '#ecdfa5',
    tint50: '#f5eece',
    tint60: '#fdfbf2'
};
const brass = {
    shade50: '#181202',
    shade40: '#2e2103',
    shade30: '#553e06',
    shade20: '#745408',
    shade10: '#89640a',
    primary: '#986f0b',
    tint10: '#a47d1e',
    tint20: '#b18c34',
    tint30: '#c1a256',
    tint40: '#e0cea2',
    tint50: '#efe4cb',
    tint60: '#fbf8f2'
};
const brown = {
    shade50: '#170e07',
    shade40: '#2b1a0e',
    shade30: '#50301a',
    shade20: '#6c4123',
    shade10: '#804d29',
    primary: '#8e562e',
    tint10: '#9c663f',
    tint20: '#a97652',
    tint30: '#bb8f6f',
    tint40: '#ddc3b0',
    tint50: '#edded3',
    tint60: '#faf7f4'
};
const forest = {
    shade50: '#0c1501',
    shade40: '#162702',
    shade30: '#294903',
    shade20: '#376304',
    shade10: '#427505',
    primary: '#498205',
    tint10: '#599116',
    tint20: '#6ba02b',
    tint30: '#85b44c',
    tint40: '#bdd99b',
    tint50: '#dbebc7',
    tint60: '#f6faf0'
};
const seafoam = {
    shade50: '#002111',
    shade40: '#003d20',
    shade30: '#00723b',
    shade20: '#009b51',
    shade10: '#00b85f',
    primary: '#00cc6a',
    tint10: '#19d279',
    tint20: '#34d889',
    tint30: '#5ae0a0',
    tint40: '#a8f0cd',
    tint50: '#cff7e4',
    tint60: '#f3fdf8'
};
const lightGreen = {
    shade50: '#031a02',
    shade40: '#063004',
    shade30: '#0b5a08',
    shade20: '#0e7a0b',
    shade10: '#11910d',
    primary: '#13a10e',
    tint10: '#27ac22',
    tint20: '#3db838',
    tint30: '#5ec75a',
    tint40: '#a7e3a5',
    tint50: '#cef0cd',
    tint60: '#f2fbf2'
};
const green = {
    shade50: '#031403',
    shade40: '#052505',
    shade30: '#094509',
    shade20: '#0c5e0c',
    shade10: '#0e700e',
    primary: '#107c10',
    tint10: '#218c21',
    tint20: '#359b35',
    tint30: '#54b054',
    tint40: '#9fd89f',
    tint50: '#c9eac9',
    tint60: '#f1faf1'
};
const darkGreen = {
    shade50: '#021102',
    shade40: '#032003',
    shade30: '#063b06',
    shade20: '#085108',
    shade10: '#0a5f0a',
    primary: '#0b6a0b',
    tint10: '#1a7c1a',
    tint20: '#2d8e2d',
    tint30: '#4da64d',
    tint40: '#9ad29a',
    tint50: '#c6e7c6',
    tint60: '#f0f9f0'
};
const lightTeal = {
    shade50: '#001d1f',
    shade40: '#00373a',
    shade30: '#00666d',
    shade20: '#008b94',
    shade10: '#00a5af',
    primary: '#00b7c3',
    tint10: '#18bfca',
    tint20: '#32c8d1',
    tint30: '#58d3db',
    tint40: '#a6e9ed',
    tint50: '#cef3f5',
    tint60: '#f2fcfd'
};
const teal = {
    shade50: '#001516',
    shade40: '#012728',
    shade30: '#02494c',
    shade20: '#026467',
    shade10: '#037679',
    primary: '#038387',
    tint10: '#159195',
    tint20: '#2aa0a4',
    tint30: '#4cb4b7',
    tint40: '#9bd9db',
    tint50: '#c7ebec',
    tint60: '#f0fafa'
};
const steel = {
    shade50: '#000f12',
    shade40: '#001b22',
    shade30: '#00333f',
    shade20: '#004555',
    shade10: '#005265',
    primary: '#005b70',
    tint10: '#0f6c81',
    tint20: '#237d92',
    tint30: '#4496a9',
    tint40: '#94c8d4',
    tint50: '#c3e1e8',
    tint60: '#eff7f9'
};
const blue = {
    shade50: '#001322',
    shade40: '#002440',
    shade30: '#004377',
    shade20: '#005ba1',
    shade10: '#006cbf',
    primary: '#0078d4',
    tint10: '#1a86d9',
    tint20: '#3595de',
    tint30: '#5caae5',
    tint40: '#a9d3f2',
    tint50: '#d0e7f8',
    tint60: '#f3f9fd'
};
const royalBlue = {
    shade50: '#000c16',
    shade40: '#00172a',
    shade30: '#002c4e',
    shade20: '#003b6a',
    shade10: '#00467e',
    primary: '#004e8c',
    tint10: '#125e9a',
    tint20: '#286fa8',
    tint30: '#4a89ba',
    tint40: '#9abfdc',
    tint50: '#c7dced',
    tint60: '#f0f6fa'
};
const cornflower = {
    shade50: '#0d1126',
    shade40: '#182047',
    shade30: '#2c3c85',
    shade20: '#3c51b4',
    shade10: '#4760d5',
    primary: '#4f6bed',
    tint10: '#637cef',
    tint20: '#778df1',
    tint30: '#93a4f4',
    tint40: '#c8d1fa',
    tint50: '#e1e6fc',
    tint60: '#f7f9fe'
};
const navy = {
    shade50: '#00061d',
    shade40: '#000c36',
    shade30: '#001665',
    shade20: '#001e89',
    shade10: '#0023a2',
    primary: '#0027b4',
    tint10: '#173bbd',
    tint20: '#3050c6',
    tint30: '#546fd2',
    tint40: '#a3b2e8',
    tint50: '#ccd5f3',
    tint60: '#f2f4fc'
};
const lavender = {
    shade50: '#120f25',
    shade40: '#221d46',
    shade30: '#3f3682',
    shade20: '#5649b0',
    shade10: '#6656d1',
    primary: '#7160e8',
    tint10: '#8172eb',
    tint20: '#9184ee',
    tint30: '#a79cf1',
    tint40: '#d2ccf8',
    tint50: '#e7e4fb',
    tint60: '#f9f8fe'
};
const purple = {
    shade50: '#0f0717',
    shade40: '#1c0e2b',
    shade30: '#341a51',
    shade20: '#46236e',
    shade10: '#532982',
    primary: '#5c2e91',
    tint10: '#6b3f9e',
    tint20: '#7c52ab',
    tint30: '#9470bd',
    tint40: '#c6b1de',
    tint50: '#e0d3ed',
    tint60: '#f7f4fb'
};
const grape = {
    shade50: '#160418',
    shade40: '#29072e',
    shade30: '#4c0d55',
    shade20: '#671174',
    shade10: '#7a1589',
    primary: '#881798',
    tint10: '#952aa4',
    tint20: '#a33fb1',
    tint30: '#b55fc1',
    tint40: '#d9a7e0',
    tint50: '#eaceef',
    tint60: '#faf2fb'
};
const berry = {
    shade50: '#1f091d',
    shade40: '#3a1136',
    shade30: '#6d2064',
    shade20: '#932b88',
    shade10: '#af33a1',
    primary: '#c239b3',
    tint10: '#c94cbc',
    tint20: '#d161c4',
    tint30: '#da7ed0',
    tint40: '#edbbe7',
    tint50: '#f5daf2',
    tint60: '#fdf5fc'
};
const lilac = {
    shade50: '#1c0b1f',
    shade40: '#35153a',
    shade30: '#63276d',
    shade20: '#863593',
    shade10: '#9f3faf',
    primary: '#b146c2',
    tint10: '#ba58c9',
    tint20: '#c36bd1',
    tint30: '#cf87da',
    tint40: '#e6bfed',
    tint50: '#f2dcf5',
    tint60: '#fcf6fd'
};
const pink = {
    shade50: '#24091b',
    shade40: '#441232',
    shade30: '#80215d',
    shade20: '#ad2d7e',
    shade10: '#cd3595',
    primary: '#e43ba6',
    tint10: '#e750b0',
    tint20: '#ea66ba',
    tint30: '#ef85c8',
    tint40: '#f7c0e3',
    tint50: '#fbddf0',
    tint60: '#fef6fb'
};
const magenta = {
    shade50: '#1f0013',
    shade40: '#390024',
    shade30: '#6b0043',
    shade20: '#91005a',
    shade10: '#ac006b',
    primary: '#bf0077',
    tint10: '#c71885',
    tint20: '#ce3293',
    tint30: '#d957a8',
    tint40: '#eca5d1',
    tint50: '#f5cee6',
    tint60: '#fcf2f9'
};
const plum = {
    shade50: '#13000c',
    shade40: '#240017',
    shade30: '#43002b',
    shade20: '#5a003b',
    shade10: '#6b0045',
    primary: '#77004d',
    tint10: '#87105d',
    tint20: '#98246f',
    tint30: '#ad4589',
    tint40: '#d696c0',
    tint50: '#e9c4dc',
    tint60: '#faf0f6'
};
const beige = {
    shade50: '#141313',
    shade40: '#252323',
    shade30: '#444241',
    shade20: '#5d5958',
    shade10: '#6e6968',
    primary: '#7a7574',
    tint10: '#8a8584',
    tint20: '#9a9594',
    tint30: '#afabaa',
    tint40: '#d7d4d4',
    tint50: '#eae8e8',
    tint60: '#faf9f9'
};
const mink = {
    shade50: '#0f0e0e',
    shade40: '#1c1b1a',
    shade30: '#343231',
    shade20: '#474443',
    shade10: '#54514f',
    primary: '#5d5a58',
    tint10: '#706d6b',
    tint20: '#84817e',
    tint30: '#9e9b99',
    tint40: '#cecccb',
    tint50: '#e5e4e3',
    tint60: '#f8f8f8'
};
const platinum = {
    shade50: '#111314',
    shade40: '#1f2426',
    shade30: '#3b4447',
    shade20: '#505c60',
    shade10: '#5f6d71',
    primary: '#69797e',
    tint10: '#79898d',
    tint20: '#89989d',
    tint30: '#a0adb2',
    tint40: '#cdd6d8',
    tint50: '#e4e9ea',
    tint60: '#f8f9fa'
};
const anchor = {
    shade50: '#090a0b',
    shade40: '#111315',
    shade30: '#202427',
    shade20: '#2b3135',
    shade10: '#333a3f',
    primary: '#394146',
    tint10: '#4d565c',
    tint20: '#626c72',
    tint30: '#808a90',
    tint40: '#bcc3c7',
    tint50: '#dbdfe1',
    tint60: '#f6f7f8'
};

const statusSharedColors = {
    red,
    green,
    darkOrange,
    yellow,
    berry,
    lightGreen,
    marigold
};
const personaSharedColors = {
    darkRed,
    cranberry,
    pumpkin,
    peach,
    gold,
    brass,
    brown,
    forest,
    seafoam,
    darkGreen,
    lightTeal,
    teal,
    steel,
    blue,
    royalBlue,
    cornflower,
    navy,
    lavender,
    purple,
    grape,
    lilac,
    pink,
    magenta,
    plum,
    beige,
    mink,
    platinum,
    anchor
};
const mappedStatusColors = {
    cranberry,
    green,
    orange
};

const statusSharedColorNames = [
  "red",
  "green",
  "darkOrange",
  "yellow",
  "berry",
  "lightGreen",
  "marigold"
];
const personaSharedColorNames = [
  "darkRed",
  "cranberry",
  "pumpkin",
  "peach",
  "gold",
  "brass",
  "brown",
  "forest",
  "seafoam",
  "darkGreen",
  "lightTeal",
  "teal",
  "steel",
  "blue",
  "royalBlue",
  "cornflower",
  "navy",
  "lavender",
  "purple",
  "grape",
  "lilac",
  "pink",
  "magenta",
  "plum",
  "beige",
  "mink",
  "platinum",
  "anchor"
];

const statusColorMapping = {
    success: 'green',
    warning: 'orange',
    danger: 'cranberry'
};

const statusColorPaletteTokens$1 = statusSharedColorNames.reduce((acc, sharedColor) => {
  const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
  const sharedColorTokens = {
    [`colorPalette${color}Background1`]: statusSharedColors[sharedColor].tint60,
    [`colorPalette${color}Background2`]: statusSharedColors[sharedColor].tint40,
    [`colorPalette${color}Background3`]: statusSharedColors[sharedColor].primary,
    [`colorPalette${color}Foreground1`]: statusSharedColors[sharedColor].shade10,
    [`colorPalette${color}Foreground2`]: statusSharedColors[sharedColor].shade30,
    [`colorPalette${color}Foreground3`]: statusSharedColors[sharedColor].primary,
    [`colorPalette${color}BorderActive`]: statusSharedColors[sharedColor].primary,
    [`colorPalette${color}Border1`]: statusSharedColors[sharedColor].tint40,
    [`colorPalette${color}Border2`]: statusSharedColors[sharedColor].primary
  };
  return Object.assign(acc, sharedColorTokens);
}, {});
statusColorPaletteTokens$1.colorPaletteYellowForeground1 = statusSharedColors.yellow.shade30;
statusColorPaletteTokens$1.colorPaletteRedForegroundInverted = statusSharedColors.red.tint20;
statusColorPaletteTokens$1.colorPaletteGreenForegroundInverted = statusSharedColors.green.tint20;
statusColorPaletteTokens$1.colorPaletteYellowForegroundInverted = statusSharedColors.yellow.tint40;
const personaColorPaletteTokens$1 = personaSharedColorNames.reduce((acc, sharedColor) => {
  const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
  const sharedColorTokens = {
    [`colorPalette${color}Background2`]: personaSharedColors[sharedColor].tint40,
    [`colorPalette${color}Foreground2`]: personaSharedColors[sharedColor].shade30,
    [`colorPalette${color}BorderActive`]: personaSharedColors[sharedColor].primary
  };
  return Object.assign(acc, sharedColorTokens);
}, {});
const colorPaletteTokens$1 = {
  ...statusColorPaletteTokens$1,
  ...personaColorPaletteTokens$1
};
const colorStatusTokens$1 = Object.entries(statusColorMapping).reduce((acc, [statusColor, sharedColor]) => {
  const color = statusColor.slice(0, 1).toUpperCase() + statusColor.slice(1);
  const statusColorTokens = {
    [`colorStatus${color}Background1`]: mappedStatusColors[sharedColor].tint60,
    [`colorStatus${color}Background2`]: mappedStatusColors[sharedColor].tint40,
    [`colorStatus${color}Background3`]: mappedStatusColors[sharedColor].primary,
    [`colorStatus${color}Foreground1`]: mappedStatusColors[sharedColor].shade10,
    [`colorStatus${color}Foreground2`]: mappedStatusColors[sharedColor].shade30,
    [`colorStatus${color}Foreground3`]: mappedStatusColors[sharedColor].primary,
    [`colorStatus${color}ForegroundInverted`]: mappedStatusColors[sharedColor].tint30,
    [`colorStatus${color}BorderActive`]: mappedStatusColors[sharedColor].primary,
    [`colorStatus${color}Border1`]: mappedStatusColors[sharedColor].tint40,
    [`colorStatus${color}Border2`]: mappedStatusColors[sharedColor].primary
  };
  return Object.assign(acc, statusColorTokens);
}, {});
colorStatusTokens$1.colorStatusDangerBackground3Hover = mappedStatusColors[statusColorMapping.danger].shade10;
colorStatusTokens$1.colorStatusDangerBackground3Pressed = mappedStatusColors[statusColorMapping.danger].shade20;
colorStatusTokens$1.colorStatusWarningForeground1 = mappedStatusColors[statusColorMapping.warning].shade20;
colorStatusTokens$1.colorStatusWarningForeground3 = mappedStatusColors[statusColorMapping.warning].shade20;
colorStatusTokens$1.colorStatusWarningBorder2 = mappedStatusColors[statusColorMapping.warning].shade20;

const generateColorTokens$1 = (brand) => ({
  colorNeutralForeground1: grey[14],
  colorNeutralForeground1Hover: grey[14],
  colorNeutralForeground1Pressed: grey[14],
  colorNeutralForeground1Selected: grey[14],
  colorNeutralForeground2: grey[26],
  colorNeutralForeground2Hover: grey[14],
  colorNeutralForeground2Pressed: grey[14],
  colorNeutralForeground2Selected: grey[14],
  colorNeutralForeground2BrandHover: brand[80],
  colorNeutralForeground2BrandPressed: brand[70],
  colorNeutralForeground2BrandSelected: brand[80],
  colorNeutralForeground3: grey[38],
  colorNeutralForeground3Hover: grey[26],
  colorNeutralForeground3Pressed: grey[26],
  colorNeutralForeground3Selected: grey[26],
  colorNeutralForeground3BrandHover: brand[80],
  colorNeutralForeground3BrandPressed: brand[70],
  colorNeutralForeground3BrandSelected: brand[80],
  colorNeutralForeground4: grey[44],
  colorNeutralForegroundDisabled: grey[74],
  colorNeutralForegroundInvertedDisabled: whiteAlpha[40],
  colorBrandForegroundLink: brand[70],
  colorBrandForegroundLinkHover: brand[60],
  colorBrandForegroundLinkPressed: brand[40],
  colorBrandForegroundLinkSelected: brand[70],
  colorNeutralForeground2Link: grey[26],
  colorNeutralForeground2LinkHover: grey[14],
  colorNeutralForeground2LinkPressed: grey[14],
  colorNeutralForeground2LinkSelected: grey[14],
  colorCompoundBrandForeground1: brand[80],
  colorCompoundBrandForeground1Hover: brand[70],
  colorCompoundBrandForeground1Pressed: brand[60],
  colorBrandForeground1: brand[80],
  colorBrandForeground2: brand[70],
  colorBrandForeground2Hover: brand[60],
  colorBrandForeground2Pressed: brand[30],
  colorNeutralForeground1Static: grey[14],
  colorNeutralForegroundStaticInverted: white,
  colorNeutralForegroundInverted: white,
  colorNeutralForegroundInvertedHover: white,
  colorNeutralForegroundInvertedPressed: white,
  colorNeutralForegroundInvertedSelected: white,
  colorNeutralForegroundInverted2: white,
  colorNeutralForegroundOnBrand: white,
  colorNeutralForegroundInvertedLink: white,
  colorNeutralForegroundInvertedLinkHover: white,
  colorNeutralForegroundInvertedLinkPressed: white,
  colorNeutralForegroundInvertedLinkSelected: white,
  colorBrandForegroundInverted: brand[100],
  colorBrandForegroundInvertedHover: brand[110],
  colorBrandForegroundInvertedPressed: brand[100],
  colorBrandForegroundOnLight: brand[80],
  colorBrandForegroundOnLightHover: brand[70],
  colorBrandForegroundOnLightPressed: brand[50],
  colorBrandForegroundOnLightSelected: brand[60],
  colorNeutralBackground1: white,
  colorNeutralBackground1Hover: grey[96],
  colorNeutralBackground1Pressed: grey[88],
  colorNeutralBackground1Selected: grey[92],
  colorNeutralBackground2: grey[98],
  colorNeutralBackground2Hover: grey[94],
  colorNeutralBackground2Pressed: grey[86],
  colorNeutralBackground2Selected: grey[90],
  colorNeutralBackground3: grey[96],
  colorNeutralBackground3Hover: grey[92],
  colorNeutralBackground3Pressed: grey[84],
  colorNeutralBackground3Selected: grey[88],
  colorNeutralBackground4: grey[94],
  colorNeutralBackground4Hover: grey[98],
  colorNeutralBackground4Pressed: grey[96],
  colorNeutralBackground4Selected: white,
  colorNeutralBackground5: grey[92],
  colorNeutralBackground5Hover: grey[96],
  colorNeutralBackground5Pressed: grey[94],
  colorNeutralBackground5Selected: grey[98],
  colorNeutralBackground6: grey[90],
  colorNeutralBackgroundInverted: grey[16],
  colorNeutralBackgroundStatic: grey[20],
  colorNeutralBackgroundAlpha: whiteAlpha[50],
  colorNeutralBackgroundAlpha2: whiteAlpha[80],
  colorSubtleBackground: "transparent",
  colorSubtleBackgroundHover: grey[96],
  colorSubtleBackgroundPressed: grey[88],
  colorSubtleBackgroundSelected: grey[92],
  colorSubtleBackgroundLightAlphaHover: whiteAlpha[70],
  colorSubtleBackgroundLightAlphaPressed: whiteAlpha[50],
  colorSubtleBackgroundLightAlphaSelected: "transparent",
  colorSubtleBackgroundInverted: "transparent",
  colorSubtleBackgroundInvertedHover: blackAlpha[10],
  colorSubtleBackgroundInvertedPressed: blackAlpha[30],
  colorSubtleBackgroundInvertedSelected: blackAlpha[20],
  colorTransparentBackground: "transparent",
  colorTransparentBackgroundHover: "transparent",
  colorTransparentBackgroundPressed: "transparent",
  colorTransparentBackgroundSelected: "transparent",
  colorNeutralBackgroundDisabled: grey[94],
  colorNeutralBackgroundInvertedDisabled: whiteAlpha[10],
  colorNeutralStencil1: grey[90],
  colorNeutralStencil2: grey[98],
  colorNeutralStencil1Alpha: blackAlpha[10],
  colorNeutralStencil2Alpha: blackAlpha[5],
  colorBackgroundOverlay: blackAlpha[40],
  colorScrollbarOverlay: blackAlpha[50],
  colorBrandBackground: brand[80],
  colorBrandBackgroundHover: brand[70],
  colorBrandBackgroundPressed: brand[40],
  colorBrandBackgroundSelected: brand[60],
  colorCompoundBrandBackground: brand[80],
  colorCompoundBrandBackgroundHover: brand[70],
  colorCompoundBrandBackgroundPressed: brand[60],
  colorBrandBackgroundStatic: brand[80],
  colorBrandBackground2: brand[160],
  colorBrandBackground2Hover: brand[150],
  colorBrandBackground2Pressed: brand[130],
  colorBrandBackground3Static: brand[60],
  colorBrandBackground4Static: brand[40],
  colorBrandBackgroundInverted: white,
  colorBrandBackgroundInvertedHover: brand[160],
  colorBrandBackgroundInvertedPressed: brand[140],
  colorBrandBackgroundInvertedSelected: brand[150],
  colorNeutralCardBackground: grey[98],
  colorNeutralCardBackgroundHover: white,
  colorNeutralCardBackgroundPressed: grey[96],
  colorNeutralCardBackgroundSelected: grey[92],
  colorNeutralCardBackgroundDisabled: grey[94],
  colorNeutralStrokeAccessible: grey[38],
  colorNeutralStrokeAccessibleHover: grey[34],
  colorNeutralStrokeAccessiblePressed: grey[30],
  colorNeutralStrokeAccessibleSelected: brand[80],
  colorNeutralStroke1: grey[82],
  colorNeutralStroke1Hover: grey[78],
  colorNeutralStroke1Pressed: grey[70],
  colorNeutralStroke1Selected: grey[74],
  colorNeutralStroke2: grey[88],
  colorNeutralStroke3: grey[94],
  colorNeutralStrokeSubtle: grey[88],
  colorNeutralStrokeOnBrand: white,
  colorNeutralStrokeOnBrand2: white,
  colorNeutralStrokeOnBrand2Hover: white,
  colorNeutralStrokeOnBrand2Pressed: white,
  colorNeutralStrokeOnBrand2Selected: white,
  colorBrandStroke1: brand[80],
  colorBrandStroke2: brand[140],
  colorBrandStroke2Hover: brand[120],
  colorBrandStroke2Pressed: brand[80],
  colorBrandStroke2Contrast: brand[140],
  colorCompoundBrandStroke: brand[80],
  colorCompoundBrandStrokeHover: brand[70],
  colorCompoundBrandStrokePressed: brand[60],
  colorNeutralStrokeDisabled: grey[88],
  colorNeutralStrokeInvertedDisabled: whiteAlpha[40],
  colorTransparentStroke: "transparent",
  colorTransparentStrokeInteractive: "transparent",
  colorTransparentStrokeDisabled: "transparent",
  colorNeutralStrokeAlpha: blackAlpha[5],
  colorNeutralStrokeAlpha2: whiteAlpha[20],
  colorStrokeFocus1: white,
  colorStrokeFocus2: black,
  colorNeutralShadowAmbient: "rgba(0,0,0,0.12)",
  colorNeutralShadowKey: "rgba(0,0,0,0.14)",
  colorNeutralShadowAmbientLighter: "rgba(0,0,0,0.06)",
  colorNeutralShadowKeyLighter: "rgba(0,0,0,0.07)",
  colorNeutralShadowAmbientDarker: "rgba(0,0,0,0.20)",
  colorNeutralShadowKeyDarker: "rgba(0,0,0,0.24)",
  colorBrandShadowAmbient: "rgba(0,0,0,0.30)",
  colorBrandShadowKey: "rgba(0,0,0,0.25)"
});

const borderRadius = {
    borderRadiusNone: '0',
    borderRadiusSmall: '2px',
    borderRadiusMedium: '4px',
    borderRadiusLarge: '6px',
    borderRadiusXLarge: '8px',
    borderRadiusCircular: '10000px'
};

const curves = {
    curveAccelerateMax: 'cubic-bezier(0.9,0.1,1,0.2)',
    curveAccelerateMid: 'cubic-bezier(1,0,1,1)',
    curveAccelerateMin: 'cubic-bezier(0.8,0,0.78,1)',
    curveDecelerateMax: 'cubic-bezier(0.1,0.9,0.2,1)',
    curveDecelerateMid: 'cubic-bezier(0,0,0,1)',
    curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
    curveEasyEaseMax: 'cubic-bezier(0.8,0,0.2,1)',
    curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
    curveLinear: 'cubic-bezier(0,0,1,1)'
};

const durations = {
    durationUltraFast: '50ms',
    durationFaster: '100ms',
    durationFast: '150ms',
    durationNormal: '200ms',
    durationGentle: '250ms',
    durationSlow: '300ms',
    durationSlower: '400ms',
    durationUltraSlow: '500ms'
};

const fontSizes = {
    fontSizeBase100: '10px',
    fontSizeBase200: '12px',
    fontSizeBase300: '14px',
    fontSizeBase400: '16px',
    fontSizeBase500: '20px',
    fontSizeBase600: '24px',
    fontSizeHero700: '28px',
    fontSizeHero800: '32px',
    fontSizeHero900: '40px',
    fontSizeHero1000: '68px'
};
const lineHeights = {
    lineHeightBase100: '14px',
    lineHeightBase200: '16px',
    lineHeightBase300: '20px',
    lineHeightBase400: '22px',
    lineHeightBase500: '28px',
    lineHeightBase600: '32px',
    lineHeightHero700: '36px',
    lineHeightHero800: '40px',
    lineHeightHero900: '52px',
    lineHeightHero1000: '92px'
};
const fontWeights = {
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemibold: 600,
    fontWeightBold: 700
};
const fontFamilies = {
    fontFamilyBase: "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
    fontFamilyMonospace: "Consolas, 'Courier New', Courier, monospace",
    fontFamilyNumeric: "Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"
};

// Intentionally not exported! Use horizontalSpacings and verticalSpacings instead.
const spacings = {
    none: '0',
    xxs: '2px',
    xs: '4px',
    sNudge: '6px',
    s: '8px',
    mNudge: '10px',
    m: '12px',
    l: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px'
};
const horizontalSpacings = {
    spacingHorizontalNone: spacings.none,
    spacingHorizontalXXS: spacings.xxs,
    spacingHorizontalXS: spacings.xs,
    spacingHorizontalSNudge: spacings.sNudge,
    spacingHorizontalS: spacings.s,
    spacingHorizontalMNudge: spacings.mNudge,
    spacingHorizontalM: spacings.m,
    spacingHorizontalL: spacings.l,
    spacingHorizontalXL: spacings.xl,
    spacingHorizontalXXL: spacings.xxl,
    spacingHorizontalXXXL: spacings.xxxl
};
const verticalSpacings = {
    spacingVerticalNone: spacings.none,
    spacingVerticalXXS: spacings.xxs,
    spacingVerticalXS: spacings.xs,
    spacingVerticalSNudge: spacings.sNudge,
    spacingVerticalS: spacings.s,
    spacingVerticalMNudge: spacings.mNudge,
    spacingVerticalM: spacings.m,
    spacingVerticalL: spacings.l,
    spacingVerticalXL: spacings.xl,
    spacingVerticalXXL: spacings.xxl,
    spacingVerticalXXXL: spacings.xxxl
};

const strokeWidths = {
    strokeWidthThin: '1px',
    strokeWidthThick: '2px',
    strokeWidthThicker: '3px',
    strokeWidthThickest: '4px'
};

const tokens$2 = {
    // Color tokens
    colorNeutralForeground1: 'var(--colorNeutralForeground1)',
    colorNeutralForeground1Hover: 'var(--colorNeutralForeground1Hover)',
    colorNeutralForeground1Pressed: 'var(--colorNeutralForeground1Pressed)',
    colorNeutralForeground1Selected: 'var(--colorNeutralForeground1Selected)',
    colorNeutralForeground2: 'var(--colorNeutralForeground2)',
    colorNeutralForeground2Hover: 'var(--colorNeutralForeground2Hover)',
    colorNeutralForeground2Pressed: 'var(--colorNeutralForeground2Pressed)',
    colorNeutralForeground2Selected: 'var(--colorNeutralForeground2Selected)',
    colorNeutralForeground2BrandHover: 'var(--colorNeutralForeground2BrandHover)',
    colorNeutralForeground2BrandPressed: 'var(--colorNeutralForeground2BrandPressed)',
    colorNeutralForeground2BrandSelected: 'var(--colorNeutralForeground2BrandSelected)',
    colorNeutralForeground3: 'var(--colorNeutralForeground3)',
    colorNeutralForeground3Hover: 'var(--colorNeutralForeground3Hover)',
    colorNeutralForeground3Pressed: 'var(--colorNeutralForeground3Pressed)',
    colorNeutralForeground3Selected: 'var(--colorNeutralForeground3Selected)',
    colorNeutralForeground3BrandHover: 'var(--colorNeutralForeground3BrandHover)',
    colorNeutralForeground3BrandPressed: 'var(--colorNeutralForeground3BrandPressed)',
    colorNeutralForeground3BrandSelected: 'var(--colorNeutralForeground3BrandSelected)',
    colorNeutralForeground4: 'var(--colorNeutralForeground4)',
    colorNeutralForegroundDisabled: 'var(--colorNeutralForegroundDisabled)',
    colorBrandForegroundLink: 'var(--colorBrandForegroundLink)',
    colorBrandForegroundLinkHover: 'var(--colorBrandForegroundLinkHover)',
    colorBrandForegroundLinkPressed: 'var(--colorBrandForegroundLinkPressed)',
    colorBrandForegroundLinkSelected: 'var(--colorBrandForegroundLinkSelected)',
    colorNeutralForeground2Link: 'var(--colorNeutralForeground2Link)',
    colorNeutralForeground2LinkHover: 'var(--colorNeutralForeground2LinkHover)',
    colorNeutralForeground2LinkPressed: 'var(--colorNeutralForeground2LinkPressed)',
    colorNeutralForeground2LinkSelected: 'var(--colorNeutralForeground2LinkSelected)',
    colorCompoundBrandForeground1: 'var(--colorCompoundBrandForeground1)',
    colorCompoundBrandForeground1Hover: 'var(--colorCompoundBrandForeground1Hover)',
    colorCompoundBrandForeground1Pressed: 'var(--colorCompoundBrandForeground1Pressed)',
    colorNeutralForegroundOnBrand: 'var(--colorNeutralForegroundOnBrand)',
    colorNeutralForegroundInverted: 'var(--colorNeutralForegroundInverted)',
    colorNeutralForegroundInvertedHover: 'var(--colorNeutralForegroundInvertedHover)',
    colorNeutralForegroundInvertedPressed: 'var(--colorNeutralForegroundInvertedPressed)',
    colorNeutralForegroundInvertedSelected: 'var(--colorNeutralForegroundInvertedSelected)',
    colorNeutralForegroundInverted2: 'var(--colorNeutralForegroundInverted2)',
    colorNeutralForegroundStaticInverted: 'var(--colorNeutralForegroundStaticInverted)',
    colorNeutralForegroundInvertedLink: 'var(--colorNeutralForegroundInvertedLink)',
    colorNeutralForegroundInvertedLinkHover: 'var(--colorNeutralForegroundInvertedLinkHover)',
    colorNeutralForegroundInvertedLinkPressed: 'var(--colorNeutralForegroundInvertedLinkPressed)',
    colorNeutralForegroundInvertedLinkSelected: 'var(--colorNeutralForegroundInvertedLinkSelected)',
    colorNeutralForegroundInvertedDisabled: 'var(--colorNeutralForegroundInvertedDisabled)',
    colorBrandForeground1: 'var(--colorBrandForeground1)',
    colorBrandForeground2: 'var(--colorBrandForeground2)',
    colorBrandForeground2Hover: 'var(--colorBrandForeground2Hover)',
    colorBrandForeground2Pressed: 'var(--colorBrandForeground2Pressed)',
    colorNeutralForeground1Static: 'var(--colorNeutralForeground1Static)',
    colorBrandForegroundInverted: 'var(--colorBrandForegroundInverted)',
    colorBrandForegroundInvertedHover: 'var(--colorBrandForegroundInvertedHover)',
    colorBrandForegroundInvertedPressed: 'var(--colorBrandForegroundInvertedPressed)',
    colorBrandForegroundOnLight: 'var(--colorBrandForegroundOnLight)',
    colorBrandForegroundOnLightHover: 'var(--colorBrandForegroundOnLightHover)',
    colorBrandForegroundOnLightPressed: 'var(--colorBrandForegroundOnLightPressed)',
    colorBrandForegroundOnLightSelected: 'var(--colorBrandForegroundOnLightSelected)',
    colorNeutralBackground1: 'var(--colorNeutralBackground1)',
    colorNeutralBackground1Hover: 'var(--colorNeutralBackground1Hover)',
    colorNeutralBackground1Pressed: 'var(--colorNeutralBackground1Pressed)',
    colorNeutralBackground1Selected: 'var(--colorNeutralBackground1Selected)',
    colorNeutralBackground2: 'var(--colorNeutralBackground2)',
    colorNeutralBackground2Hover: 'var(--colorNeutralBackground2Hover)',
    colorNeutralBackground2Pressed: 'var(--colorNeutralBackground2Pressed)',
    colorNeutralBackground2Selected: 'var(--colorNeutralBackground2Selected)',
    colorNeutralBackground3: 'var(--colorNeutralBackground3)',
    colorNeutralBackground3Hover: 'var(--colorNeutralBackground3Hover)',
    colorNeutralBackground3Pressed: 'var(--colorNeutralBackground3Pressed)',
    colorNeutralBackground3Selected: 'var(--colorNeutralBackground3Selected)',
    colorNeutralBackground4: 'var(--colorNeutralBackground4)',
    colorNeutralBackground4Hover: 'var(--colorNeutralBackground4Hover)',
    colorNeutralBackground4Pressed: 'var(--colorNeutralBackground4Pressed)',
    colorNeutralBackground4Selected: 'var(--colorNeutralBackground4Selected)',
    colorNeutralBackground5: 'var(--colorNeutralBackground5)',
    colorNeutralBackground5Hover: 'var(--colorNeutralBackground5Hover)',
    colorNeutralBackground5Pressed: 'var(--colorNeutralBackground5Pressed)',
    colorNeutralBackground5Selected: 'var(--colorNeutralBackground5Selected)',
    colorNeutralBackground6: 'var(--colorNeutralBackground6)',
    colorNeutralBackgroundInverted: 'var(--colorNeutralBackgroundInverted)',
    colorNeutralBackgroundStatic: 'var(--colorNeutralBackgroundStatic)',
    colorNeutralBackgroundAlpha: 'var(--colorNeutralBackgroundAlpha)',
    colorNeutralBackgroundAlpha2: 'var(--colorNeutralBackgroundAlpha2)',
    colorSubtleBackground: 'var(--colorSubtleBackground)',
    colorSubtleBackgroundHover: 'var(--colorSubtleBackgroundHover)',
    colorSubtleBackgroundPressed: 'var(--colorSubtleBackgroundPressed)',
    colorSubtleBackgroundSelected: 'var(--colorSubtleBackgroundSelected)',
    colorSubtleBackgroundLightAlphaHover: 'var(--colorSubtleBackgroundLightAlphaHover)',
    colorSubtleBackgroundLightAlphaPressed: 'var(--colorSubtleBackgroundLightAlphaPressed)',
    colorSubtleBackgroundLightAlphaSelected: 'var(--colorSubtleBackgroundLightAlphaSelected)',
    colorSubtleBackgroundInverted: 'var(--colorSubtleBackgroundInverted)',
    colorSubtleBackgroundInvertedHover: 'var(--colorSubtleBackgroundInvertedHover)',
    colorSubtleBackgroundInvertedPressed: 'var(--colorSubtleBackgroundInvertedPressed)',
    colorSubtleBackgroundInvertedSelected: 'var(--colorSubtleBackgroundInvertedSelected)',
    colorTransparentBackground: 'var(--colorTransparentBackground)',
    colorTransparentBackgroundHover: 'var(--colorTransparentBackgroundHover)',
    colorTransparentBackgroundPressed: 'var(--colorTransparentBackgroundPressed)',
    colorTransparentBackgroundSelected: 'var(--colorTransparentBackgroundSelected)',
    colorNeutralBackgroundDisabled: 'var(--colorNeutralBackgroundDisabled)',
    colorNeutralBackgroundInvertedDisabled: 'var(--colorNeutralBackgroundInvertedDisabled)',
    colorNeutralStencil1: 'var(--colorNeutralStencil1)',
    colorNeutralStencil2: 'var(--colorNeutralStencil2)',
    colorNeutralStencil1Alpha: 'var(--colorNeutralStencil1Alpha)',
    colorNeutralStencil2Alpha: 'var(--colorNeutralStencil2Alpha)',
    colorBackgroundOverlay: 'var(--colorBackgroundOverlay)',
    colorScrollbarOverlay: 'var(--colorScrollbarOverlay)',
    colorBrandBackground: 'var(--colorBrandBackground)',
    colorBrandBackgroundHover: 'var(--colorBrandBackgroundHover)',
    colorBrandBackgroundPressed: 'var(--colorBrandBackgroundPressed)',
    colorBrandBackgroundSelected: 'var(--colorBrandBackgroundSelected)',
    colorCompoundBrandBackground: 'var(--colorCompoundBrandBackground)',
    colorCompoundBrandBackgroundHover: 'var(--colorCompoundBrandBackgroundHover)',
    colorCompoundBrandBackgroundPressed: 'var(--colorCompoundBrandBackgroundPressed)',
    colorBrandBackgroundStatic: 'var(--colorBrandBackgroundStatic)',
    colorBrandBackground2: 'var(--colorBrandBackground2)',
    colorBrandBackground2Hover: 'var(--colorBrandBackground2Hover)',
    colorBrandBackground2Pressed: 'var(--colorBrandBackground2Pressed)',
    colorBrandBackground3Static: 'var(--colorBrandBackground3Static)',
    colorBrandBackground4Static: 'var(--colorBrandBackground4Static)',
    colorBrandBackgroundInverted: 'var(--colorBrandBackgroundInverted)',
    colorBrandBackgroundInvertedHover: 'var(--colorBrandBackgroundInvertedHover)',
    colorBrandBackgroundInvertedPressed: 'var(--colorBrandBackgroundInvertedPressed)',
    colorBrandBackgroundInvertedSelected: 'var(--colorBrandBackgroundInvertedSelected)',
    colorNeutralCardBackground: 'var(--colorNeutralCardBackground)',
    colorNeutralCardBackgroundHover: 'var(--colorNeutralCardBackgroundHover)',
    colorNeutralCardBackgroundPressed: 'var(--colorNeutralCardBackgroundPressed)',
    colorNeutralCardBackgroundSelected: 'var(--colorNeutralCardBackgroundSelected)',
    colorNeutralCardBackgroundDisabled: 'var(--colorNeutralCardBackgroundDisabled)',
    colorNeutralStrokeAccessible: 'var(--colorNeutralStrokeAccessible)',
    colorNeutralStrokeAccessibleHover: 'var(--colorNeutralStrokeAccessibleHover)',
    colorNeutralStrokeAccessiblePressed: 'var(--colorNeutralStrokeAccessiblePressed)',
    colorNeutralStrokeAccessibleSelected: 'var(--colorNeutralStrokeAccessibleSelected)',
    colorNeutralStroke1: 'var(--colorNeutralStroke1)',
    colorNeutralStroke1Hover: 'var(--colorNeutralStroke1Hover)',
    colorNeutralStroke1Pressed: 'var(--colorNeutralStroke1Pressed)',
    colorNeutralStroke1Selected: 'var(--colorNeutralStroke1Selected)',
    colorNeutralStroke2: 'var(--colorNeutralStroke2)',
    colorNeutralStroke3: 'var(--colorNeutralStroke3)',
    colorNeutralStrokeSubtle: 'var(--colorNeutralStrokeSubtle)',
    colorNeutralStrokeOnBrand: 'var(--colorNeutralStrokeOnBrand)',
    colorNeutralStrokeOnBrand2: 'var(--colorNeutralStrokeOnBrand2)',
    colorNeutralStrokeOnBrand2Hover: 'var(--colorNeutralStrokeOnBrand2Hover)',
    colorNeutralStrokeOnBrand2Pressed: 'var(--colorNeutralStrokeOnBrand2Pressed)',
    colorNeutralStrokeOnBrand2Selected: 'var(--colorNeutralStrokeOnBrand2Selected)',
    colorBrandStroke1: 'var(--colorBrandStroke1)',
    colorBrandStroke2: 'var(--colorBrandStroke2)',
    colorBrandStroke2Hover: 'var(--colorBrandStroke2Hover)',
    colorBrandStroke2Pressed: 'var(--colorBrandStroke2Pressed)',
    colorBrandStroke2Contrast: 'var(--colorBrandStroke2Contrast)',
    colorCompoundBrandStroke: 'var(--colorCompoundBrandStroke)',
    colorCompoundBrandStrokeHover: 'var(--colorCompoundBrandStrokeHover)',
    colorCompoundBrandStrokePressed: 'var(--colorCompoundBrandStrokePressed)',
    colorNeutralStrokeDisabled: 'var(--colorNeutralStrokeDisabled)',
    colorNeutralStrokeInvertedDisabled: 'var(--colorNeutralStrokeInvertedDisabled)',
    colorTransparentStroke: 'var(--colorTransparentStroke)',
    colorTransparentStrokeInteractive: 'var(--colorTransparentStrokeInteractive)',
    colorTransparentStrokeDisabled: 'var(--colorTransparentStrokeDisabled)',
    colorNeutralStrokeAlpha: 'var(--colorNeutralStrokeAlpha)',
    colorNeutralStrokeAlpha2: 'var(--colorNeutralStrokeAlpha2)',
    colorStrokeFocus1: 'var(--colorStrokeFocus1)',
    colorStrokeFocus2: 'var(--colorStrokeFocus2)',
    colorNeutralShadowAmbient: 'var(--colorNeutralShadowAmbient)',
    colorNeutralShadowKey: 'var(--colorNeutralShadowKey)',
    colorNeutralShadowAmbientLighter: 'var(--colorNeutralShadowAmbientLighter)',
    colorNeutralShadowKeyLighter: 'var(--colorNeutralShadowKeyLighter)',
    colorNeutralShadowAmbientDarker: 'var(--colorNeutralShadowAmbientDarker)',
    colorNeutralShadowKeyDarker: 'var(--colorNeutralShadowKeyDarker)',
    colorBrandShadowAmbient: 'var(--colorBrandShadowAmbient)',
    colorBrandShadowKey: 'var(--colorBrandShadowKey)',
    // Color palette tokens
    // Color palette red tokens
    colorPaletteRedBackground1: 'var(--colorPaletteRedBackground1)',
    colorPaletteRedBackground2: 'var(--colorPaletteRedBackground2)',
    colorPaletteRedBackground3: 'var(--colorPaletteRedBackground3)',
    colorPaletteRedBorderActive: 'var(--colorPaletteRedBorderActive)',
    colorPaletteRedBorder1: 'var(--colorPaletteRedBorder1)',
    colorPaletteRedBorder2: 'var(--colorPaletteRedBorder2)',
    colorPaletteRedForeground1: 'var(--colorPaletteRedForeground1)',
    colorPaletteRedForeground2: 'var(--colorPaletteRedForeground2)',
    colorPaletteRedForeground3: 'var(--colorPaletteRedForeground3)',
    colorPaletteRedForegroundInverted: 'var(--colorPaletteRedForegroundInverted)',
    // Color palette green tokens
    colorPaletteGreenBackground1: 'var(--colorPaletteGreenBackground1)',
    colorPaletteGreenBackground2: 'var(--colorPaletteGreenBackground2)',
    colorPaletteGreenBackground3: 'var(--colorPaletteGreenBackground3)',
    colorPaletteGreenBorderActive: 'var(--colorPaletteGreenBorderActive)',
    colorPaletteGreenBorder1: 'var(--colorPaletteGreenBorder1)',
    colorPaletteGreenBorder2: 'var(--colorPaletteGreenBorder2)',
    colorPaletteGreenForeground1: 'var(--colorPaletteGreenForeground1)',
    colorPaletteGreenForeground2: 'var(--colorPaletteGreenForeground2)',
    colorPaletteGreenForeground3: 'var(--colorPaletteGreenForeground3)',
    colorPaletteGreenForegroundInverted: 'var(--colorPaletteGreenForegroundInverted)',
    // Color palette dark orange tokens
    colorPaletteDarkOrangeBackground1: 'var(--colorPaletteDarkOrangeBackground1)',
    colorPaletteDarkOrangeBackground2: 'var(--colorPaletteDarkOrangeBackground2)',
    colorPaletteDarkOrangeBackground3: 'var(--colorPaletteDarkOrangeBackground3)',
    colorPaletteDarkOrangeBorderActive: 'var(--colorPaletteDarkOrangeBorderActive)',
    colorPaletteDarkOrangeBorder1: 'var(--colorPaletteDarkOrangeBorder1)',
    colorPaletteDarkOrangeBorder2: 'var(--colorPaletteDarkOrangeBorder2)',
    colorPaletteDarkOrangeForeground1: 'var(--colorPaletteDarkOrangeForeground1)',
    colorPaletteDarkOrangeForeground2: 'var(--colorPaletteDarkOrangeForeground2)',
    colorPaletteDarkOrangeForeground3: 'var(--colorPaletteDarkOrangeForeground3)',
    // Color palette yellow tokens
    colorPaletteYellowBackground1: 'var(--colorPaletteYellowBackground1)',
    colorPaletteYellowBackground2: 'var(--colorPaletteYellowBackground2)',
    colorPaletteYellowBackground3: 'var(--colorPaletteYellowBackground3)',
    colorPaletteYellowBorderActive: 'var(--colorPaletteYellowBorderActive)',
    colorPaletteYellowBorder1: 'var(--colorPaletteYellowBorder1)',
    colorPaletteYellowBorder2: 'var(--colorPaletteYellowBorder2)',
    colorPaletteYellowForeground1: 'var(--colorPaletteYellowForeground1)',
    colorPaletteYellowForeground2: 'var(--colorPaletteYellowForeground2)',
    colorPaletteYellowForeground3: 'var(--colorPaletteYellowForeground3)',
    colorPaletteYellowForegroundInverted: 'var(--colorPaletteYellowForegroundInverted)',
    // Color palette berry tokens
    colorPaletteBerryBackground1: 'var(--colorPaletteBerryBackground1)',
    colorPaletteBerryBackground2: 'var(--colorPaletteBerryBackground2)',
    colorPaletteBerryBackground3: 'var(--colorPaletteBerryBackground3)',
    colorPaletteBerryBorderActive: 'var(--colorPaletteBerryBorderActive)',
    colorPaletteBerryBorder1: 'var(--colorPaletteBerryBorder1)',
    colorPaletteBerryBorder2: 'var(--colorPaletteBerryBorder2)',
    colorPaletteBerryForeground1: 'var(--colorPaletteBerryForeground1)',
    colorPaletteBerryForeground2: 'var(--colorPaletteBerryForeground2)',
    colorPaletteBerryForeground3: 'var(--colorPaletteBerryForeground3)',
    // Color palette marigold tokens
    colorPaletteMarigoldBackground1: 'var(--colorPaletteMarigoldBackground1)',
    colorPaletteMarigoldBackground2: 'var(--colorPaletteMarigoldBackground2)',
    colorPaletteMarigoldBackground3: 'var(--colorPaletteMarigoldBackground3)',
    colorPaletteMarigoldBorderActive: 'var(--colorPaletteMarigoldBorderActive)',
    colorPaletteMarigoldBorder1: 'var(--colorPaletteMarigoldBorder1)',
    colorPaletteMarigoldBorder2: 'var(--colorPaletteMarigoldBorder2)',
    colorPaletteMarigoldForeground1: 'var(--colorPaletteMarigoldForeground1)',
    colorPaletteMarigoldForeground2: 'var(--colorPaletteMarigoldForeground2)',
    colorPaletteMarigoldForeground3: 'var(--colorPaletteMarigoldForeground3)',
    // Color palette light green tokens
    colorPaletteLightGreenBackground1: 'var(--colorPaletteLightGreenBackground1)',
    colorPaletteLightGreenBackground2: 'var(--colorPaletteLightGreenBackground2)',
    colorPaletteLightGreenBackground3: 'var(--colorPaletteLightGreenBackground3)',
    colorPaletteLightGreenBorderActive: 'var(--colorPaletteLightGreenBorderActive)',
    colorPaletteLightGreenBorder1: 'var(--colorPaletteLightGreenBorder1)',
    colorPaletteLightGreenBorder2: 'var(--colorPaletteLightGreenBorder2)',
    colorPaletteLightGreenForeground1: 'var(--colorPaletteLightGreenForeground1)',
    colorPaletteLightGreenForeground2: 'var(--colorPaletteLightGreenForeground2)',
    colorPaletteLightGreenForeground3: 'var(--colorPaletteLightGreenForeground3)',
    // Color palette anchor tokens
    colorPaletteAnchorBackground2: 'var(--colorPaletteAnchorBackground2)',
    colorPaletteAnchorBorderActive: 'var(--colorPaletteAnchorBorderActive)',
    colorPaletteAnchorForeground2: 'var(--colorPaletteAnchorForeground2)',
    // Color palette beige tokens
    colorPaletteBeigeBackground2: 'var(--colorPaletteBeigeBackground2)',
    colorPaletteBeigeBorderActive: 'var(--colorPaletteBeigeBorderActive)',
    colorPaletteBeigeForeground2: 'var(--colorPaletteBeigeForeground2)',
    // Color palette blue tokens
    colorPaletteBlueBackground2: 'var(--colorPaletteBlueBackground2)',
    colorPaletteBlueBorderActive: 'var(--colorPaletteBlueBorderActive)',
    colorPaletteBlueForeground2: 'var(--colorPaletteBlueForeground2)',
    // Color palette brass tokens
    colorPaletteBrassBackground2: 'var(--colorPaletteBrassBackground2)',
    colorPaletteBrassBorderActive: 'var(--colorPaletteBrassBorderActive)',
    colorPaletteBrassForeground2: 'var(--colorPaletteBrassForeground2)',
    // Color palette brown tokens
    colorPaletteBrownBackground2: 'var(--colorPaletteBrownBackground2)',
    colorPaletteBrownBorderActive: 'var(--colorPaletteBrownBorderActive)',
    colorPaletteBrownForeground2: 'var(--colorPaletteBrownForeground2)',
    // Color palette cornflower tokens
    colorPaletteCornflowerBackground2: 'var(--colorPaletteCornflowerBackground2)',
    colorPaletteCornflowerBorderActive: 'var(--colorPaletteCornflowerBorderActive)',
    colorPaletteCornflowerForeground2: 'var(--colorPaletteCornflowerForeground2)',
    // Color palette cranberry tokens
    colorPaletteCranberryBackground2: 'var(--colorPaletteCranberryBackground2)',
    colorPaletteCranberryBorderActive: 'var(--colorPaletteCranberryBorderActive)',
    colorPaletteCranberryForeground2: 'var(--colorPaletteCranberryForeground2)',
    // Color palette dark green tokens
    colorPaletteDarkGreenBackground2: 'var(--colorPaletteDarkGreenBackground2)',
    colorPaletteDarkGreenBorderActive: 'var(--colorPaletteDarkGreenBorderActive)',
    colorPaletteDarkGreenForeground2: 'var(--colorPaletteDarkGreenForeground2)',
    // Color palette dark red tokens
    colorPaletteDarkRedBackground2: 'var(--colorPaletteDarkRedBackground2)',
    colorPaletteDarkRedBorderActive: 'var(--colorPaletteDarkRedBorderActive)',
    colorPaletteDarkRedForeground2: 'var(--colorPaletteDarkRedForeground2)',
    // Color palette forest tokens
    colorPaletteForestBackground2: 'var(--colorPaletteForestBackground2)',
    colorPaletteForestBorderActive: 'var(--colorPaletteForestBorderActive)',
    colorPaletteForestForeground2: 'var(--colorPaletteForestForeground2)',
    // Color palette gold tokens
    colorPaletteGoldBackground2: 'var(--colorPaletteGoldBackground2)',
    colorPaletteGoldBorderActive: 'var(--colorPaletteGoldBorderActive)',
    colorPaletteGoldForeground2: 'var(--colorPaletteGoldForeground2)',
    // Color palette grape tokens
    colorPaletteGrapeBackground2: 'var(--colorPaletteGrapeBackground2)',
    colorPaletteGrapeBorderActive: 'var(--colorPaletteGrapeBorderActive)',
    colorPaletteGrapeForeground2: 'var(--colorPaletteGrapeForeground2)',
    // Color palette lavender tokens
    colorPaletteLavenderBackground2: 'var(--colorPaletteLavenderBackground2)',
    colorPaletteLavenderBorderActive: 'var(--colorPaletteLavenderBorderActive)',
    colorPaletteLavenderForeground2: 'var(--colorPaletteLavenderForeground2)',
    // Color palette light teal tokens
    colorPaletteLightTealBackground2: 'var(--colorPaletteLightTealBackground2)',
    colorPaletteLightTealBorderActive: 'var(--colorPaletteLightTealBorderActive)',
    colorPaletteLightTealForeground2: 'var(--colorPaletteLightTealForeground2)',
    // Color palette lilac tokens
    colorPaletteLilacBackground2: 'var(--colorPaletteLilacBackground2)',
    colorPaletteLilacBorderActive: 'var(--colorPaletteLilacBorderActive)',
    colorPaletteLilacForeground2: 'var(--colorPaletteLilacForeground2)',
    // Color palette magenta tokens
    colorPaletteMagentaBackground2: 'var(--colorPaletteMagentaBackground2)',
    colorPaletteMagentaBorderActive: 'var(--colorPaletteMagentaBorderActive)',
    colorPaletteMagentaForeground2: 'var(--colorPaletteMagentaForeground2)',
    // Color palette mink tokens
    colorPaletteMinkBackground2: 'var(--colorPaletteMinkBackground2)',
    colorPaletteMinkBorderActive: 'var(--colorPaletteMinkBorderActive)',
    colorPaletteMinkForeground2: 'var(--colorPaletteMinkForeground2)',
    // Color palette navy tokens
    colorPaletteNavyBackground2: 'var(--colorPaletteNavyBackground2)',
    colorPaletteNavyBorderActive: 'var(--colorPaletteNavyBorderActive)',
    colorPaletteNavyForeground2: 'var(--colorPaletteNavyForeground2)',
    // Color palette peach tokens
    colorPalettePeachBackground2: 'var(--colorPalettePeachBackground2)',
    colorPalettePeachBorderActive: 'var(--colorPalettePeachBorderActive)',
    colorPalettePeachForeground2: 'var(--colorPalettePeachForeground2)',
    // Color palette pink tokens
    colorPalettePinkBackground2: 'var(--colorPalettePinkBackground2)',
    colorPalettePinkBorderActive: 'var(--colorPalettePinkBorderActive)',
    colorPalettePinkForeground2: 'var(--colorPalettePinkForeground2)',
    // Color palette platinum tokens
    colorPalettePlatinumBackground2: 'var(--colorPalettePlatinumBackground2)',
    colorPalettePlatinumBorderActive: 'var(--colorPalettePlatinumBorderActive)',
    colorPalettePlatinumForeground2: 'var(--colorPalettePlatinumForeground2)',
    // Color palette plum tokens
    colorPalettePlumBackground2: 'var(--colorPalettePlumBackground2)',
    colorPalettePlumBorderActive: 'var(--colorPalettePlumBorderActive)',
    colorPalettePlumForeground2: 'var(--colorPalettePlumForeground2)',
    // Color palette pumpkin tokens
    colorPalettePumpkinBackground2: 'var(--colorPalettePumpkinBackground2)',
    colorPalettePumpkinBorderActive: 'var(--colorPalettePumpkinBorderActive)',
    colorPalettePumpkinForeground2: 'var(--colorPalettePumpkinForeground2)',
    // Color palette purple tokens
    colorPalettePurpleBackground2: 'var(--colorPalettePurpleBackground2)',
    colorPalettePurpleBorderActive: 'var(--colorPalettePurpleBorderActive)',
    colorPalettePurpleForeground2: 'var(--colorPalettePurpleForeground2)',
    // Color palette royal blue tokens
    colorPaletteRoyalBlueBackground2: 'var(--colorPaletteRoyalBlueBackground2)',
    colorPaletteRoyalBlueBorderActive: 'var(--colorPaletteRoyalBlueBorderActive)',
    colorPaletteRoyalBlueForeground2: 'var(--colorPaletteRoyalBlueForeground2)',
    // Color palette seafoam tokens
    colorPaletteSeafoamBackground2: 'var(--colorPaletteSeafoamBackground2)',
    colorPaletteSeafoamBorderActive: 'var(--colorPaletteSeafoamBorderActive)',
    colorPaletteSeafoamForeground2: 'var(--colorPaletteSeafoamForeground2)',
    // Color palette steel tokens
    colorPaletteSteelBackground2: 'var(--colorPaletteSteelBackground2)',
    colorPaletteSteelBorderActive: 'var(--colorPaletteSteelBorderActive)',
    colorPaletteSteelForeground2: 'var(--colorPaletteSteelForeground2)',
    // Color palette teal tokens
    colorPaletteTealBackground2: 'var(--colorPaletteTealBackground2)',
    colorPaletteTealBorderActive: 'var(--colorPaletteTealBorderActive)',
    colorPaletteTealForeground2: 'var(--colorPaletteTealForeground2)',
    // Color status success tokens
    colorStatusSuccessBackground1: 'var(--colorStatusSuccessBackground1)',
    colorStatusSuccessBackground2: 'var(--colorStatusSuccessBackground2)',
    colorStatusSuccessBackground3: 'var(--colorStatusSuccessBackground3)',
    colorStatusSuccessForeground1: 'var(--colorStatusSuccessForeground1)',
    colorStatusSuccessForeground2: 'var(--colorStatusSuccessForeground2)',
    colorStatusSuccessForeground3: 'var(--colorStatusSuccessForeground3)',
    colorStatusSuccessForegroundInverted: 'var(--colorStatusSuccessForegroundInverted)',
    colorStatusSuccessBorderActive: 'var(--colorStatusSuccessBorderActive)',
    colorStatusSuccessBorder1: 'var(--colorStatusSuccessBorder1)',
    colorStatusSuccessBorder2: 'var(--colorStatusSuccessBorder2)',
    // Color status warning tokens
    colorStatusWarningBackground1: 'var(--colorStatusWarningBackground1)',
    colorStatusWarningBackground2: 'var(--colorStatusWarningBackground2)',
    colorStatusWarningBackground3: 'var(--colorStatusWarningBackground3)',
    colorStatusWarningForeground1: 'var(--colorStatusWarningForeground1)',
    colorStatusWarningForeground2: 'var(--colorStatusWarningForeground2)',
    colorStatusWarningForeground3: 'var(--colorStatusWarningForeground3)',
    colorStatusWarningForegroundInverted: 'var(--colorStatusWarningForegroundInverted)',
    colorStatusWarningBorderActive: 'var(--colorStatusWarningBorderActive)',
    colorStatusWarningBorder1: 'var(--colorStatusWarningBorder1)',
    colorStatusWarningBorder2: 'var(--colorStatusWarningBorder2)',
    // Color status danger tokens
    colorStatusDangerBackground1: 'var(--colorStatusDangerBackground1)',
    colorStatusDangerBackground2: 'var(--colorStatusDangerBackground2)',
    colorStatusDangerBackground3: 'var(--colorStatusDangerBackground3)',
    colorStatusDangerBackground3Hover: 'var(--colorStatusDangerBackground3Hover)',
    colorStatusDangerBackground3Pressed: 'var(--colorStatusDangerBackground3Pressed)',
    colorStatusDangerForeground1: 'var(--colorStatusDangerForeground1)',
    colorStatusDangerForeground2: 'var(--colorStatusDangerForeground2)',
    colorStatusDangerForeground3: 'var(--colorStatusDangerForeground3)',
    colorStatusDangerForegroundInverted: 'var(--colorStatusDangerForegroundInverted)',
    colorStatusDangerBorderActive: 'var(--colorStatusDangerBorderActive)',
    colorStatusDangerBorder1: 'var(--colorStatusDangerBorder1)',
    colorStatusDangerBorder2: 'var(--colorStatusDangerBorder2)',
    // Border radius tokens
    borderRadiusNone: 'var(--borderRadiusNone)',
    borderRadiusSmall: 'var(--borderRadiusSmall)',
    borderRadiusMedium: 'var(--borderRadiusMedium)',
    borderRadiusLarge: 'var(--borderRadiusLarge)',
    borderRadiusXLarge: 'var(--borderRadiusXLarge)',
    borderRadiusCircular: 'var(--borderRadiusCircular)',
    // Font family tokens
    fontFamilyBase: 'var(--fontFamilyBase)',
    fontFamilyMonospace: 'var(--fontFamilyMonospace)',
    fontFamilyNumeric: 'var(--fontFamilyNumeric)',
    // Font size tokens
    fontSizeBase100: 'var(--fontSizeBase100)',
    fontSizeBase200: 'var(--fontSizeBase200)',
    fontSizeBase300: 'var(--fontSizeBase300)',
    fontSizeBase400: 'var(--fontSizeBase400)',
    fontSizeBase500: 'var(--fontSizeBase500)',
    fontSizeBase600: 'var(--fontSizeBase600)',
    fontSizeHero700: 'var(--fontSizeHero700)',
    fontSizeHero800: 'var(--fontSizeHero800)',
    fontSizeHero900: 'var(--fontSizeHero900)',
    fontSizeHero1000: 'var(--fontSizeHero1000)',
    // Font weight tokens
    fontWeightRegular: 'var(--fontWeightRegular)',
    fontWeightMedium: 'var(--fontWeightMedium)',
    fontWeightSemibold: 'var(--fontWeightSemibold)',
    fontWeightBold: 'var(--fontWeightBold)',
    // Line height tokens
    lineHeightBase100: 'var(--lineHeightBase100)',
    lineHeightBase200: 'var(--lineHeightBase200)',
    lineHeightBase300: 'var(--lineHeightBase300)',
    lineHeightBase400: 'var(--lineHeightBase400)',
    lineHeightBase500: 'var(--lineHeightBase500)',
    lineHeightBase600: 'var(--lineHeightBase600)',
    lineHeightHero700: 'var(--lineHeightHero700)',
    lineHeightHero800: 'var(--lineHeightHero800)',
    lineHeightHero900: 'var(--lineHeightHero900)',
    lineHeightHero1000: 'var(--lineHeightHero1000)',
    // Shadow tokens
    shadow2: 'var(--shadow2)',
    shadow4: 'var(--shadow4)',
    shadow8: 'var(--shadow8)',
    shadow16: 'var(--shadow16)',
    shadow28: 'var(--shadow28)',
    shadow64: 'var(--shadow64)',
    // Shadow brand tokens
    shadow2Brand: 'var(--shadow2Brand)',
    shadow4Brand: 'var(--shadow4Brand)',
    shadow8Brand: 'var(--shadow8Brand)',
    shadow16Brand: 'var(--shadow16Brand)',
    shadow28Brand: 'var(--shadow28Brand)',
    shadow64Brand: 'var(--shadow64Brand)',
    // Stroke width tokens
    strokeWidthThin: 'var(--strokeWidthThin)',
    strokeWidthThick: 'var(--strokeWidthThick)',
    strokeWidthThicker: 'var(--strokeWidthThicker)',
    strokeWidthThickest: 'var(--strokeWidthThickest)',
    // Spacings
    spacingHorizontalNone: 'var(--spacingHorizontalNone)',
    spacingHorizontalXXS: 'var(--spacingHorizontalXXS)',
    spacingHorizontalXS: 'var(--spacingHorizontalXS)',
    spacingHorizontalSNudge: 'var(--spacingHorizontalSNudge)',
    spacingHorizontalS: 'var(--spacingHorizontalS)',
    spacingHorizontalMNudge: 'var(--spacingHorizontalMNudge)',
    spacingHorizontalM: 'var(--spacingHorizontalM)',
    spacingHorizontalL: 'var(--spacingHorizontalL)',
    spacingHorizontalXL: 'var(--spacingHorizontalXL)',
    spacingHorizontalXXL: 'var(--spacingHorizontalXXL)',
    spacingHorizontalXXXL: 'var(--spacingHorizontalXXXL)',
    spacingVerticalNone: 'var(--spacingVerticalNone)',
    spacingVerticalXXS: 'var(--spacingVerticalXXS)',
    spacingVerticalXS: 'var(--spacingVerticalXS)',
    spacingVerticalSNudge: 'var(--spacingVerticalSNudge)',
    spacingVerticalS: 'var(--spacingVerticalS)',
    spacingVerticalMNudge: 'var(--spacingVerticalMNudge)',
    spacingVerticalM: 'var(--spacingVerticalM)',
    spacingVerticalL: 'var(--spacingVerticalL)',
    spacingVerticalXL: 'var(--spacingVerticalXL)',
    spacingVerticalXXL: 'var(--spacingVerticalXXL)',
    spacingVerticalXXXL: 'var(--spacingVerticalXXXL)',
    // Durations
    durationUltraFast: 'var(--durationUltraFast)',
    durationFaster: 'var(--durationFaster)',
    durationFast: 'var(--durationFast)',
    durationNormal: 'var(--durationNormal)',
    durationGentle: 'var(--durationGentle)',
    durationSlow: 'var(--durationSlow)',
    durationSlower: 'var(--durationSlower)',
    durationUltraSlow: 'var(--durationUltraSlow)',
    // Curves
    curveAccelerateMax: 'var(--curveAccelerateMax)',
    curveAccelerateMid: 'var(--curveAccelerateMid)',
    curveAccelerateMin: 'var(--curveAccelerateMin)',
    curveDecelerateMax: 'var(--curveDecelerateMax)',
    curveDecelerateMid: 'var(--curveDecelerateMid)',
    curveDecelerateMin: 'var(--curveDecelerateMin)',
    curveEasyEaseMax: 'var(--curveEasyEaseMax)',
    curveEasyEase: 'var(--curveEasyEase)',
    curveLinear: 'var(--curveLinear)',
    /**
   * ZIndexes
   * Special case where the tokens contain default values
   * ZIndexes are not mandatory, so they are not included in the theme, but can be used as tokens with default values
   */ /**
   * Elevation 0
   * Can be used for background elements, like surfaces
   */ zIndexBackground: 'var(--zIndexBackground, 0)',
    /**
   * Elevation 2
   * Can be used content that is on top of the background, like cards
   */ zIndexContent: 'var(--zIndexContent, 1)',
    /**
   * Elevation 4
   * Can be used for overlays, like the backdrop of a modal
   */ zIndexOverlay: 'var(--zIndexOverlay, 1000)',
    /**
   * Elevation 8
   * Can be used for popups, like modals and drawers
   */ zIndexPopup: 'var(--zIndexPopup, 2000)',
    /**
   * Elevation 16
   * Can be used for messages, like snackbars and toasts
   */ zIndexMessages: 'var(--zIndexMessages, 3000)',
    /**
   * Elevation 28
   * Can be used for floating elements, like dropdowns
   */ zIndexFloating: 'var(--zIndexFloating, 4000)',
    /**
   * Elevation 64
   * Can be used for high priority floating elements, like tooltips
   */ zIndexPriority: 'var(--zIndexPriority, 5000)',
    /**
   * Special elevation
   * Can be used for elements that need to be above everything else, like debug overlays
   */ zIndexDebug: 'var(--zIndexDebug, 6000)'
};

function createShadowTokens(ambientColor, keyColor, tokenSuffix = '') {
    return {
        [`shadow2${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 1px 2px ${keyColor}`,
        [`shadow4${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 2px 4px ${keyColor}`,
        [`shadow8${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 4px 8px ${keyColor}`,
        [`shadow16${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 8px 16px ${keyColor}`,
        [`shadow28${tokenSuffix}`]: `0 0 8px ${ambientColor}, 0 14px 28px ${keyColor}`,
        [`shadow64${tokenSuffix}`]: `0 0 8px ${ambientColor}, 0 32px 64px ${keyColor}`
    };
}

const createLightTheme = (brand) => {
  const colorTokens = generateColorTokens$1(brand);
  return {
    ...borderRadius,
    ...fontSizes,
    ...lineHeights,
    ...fontFamilies,
    ...fontWeights,
    ...strokeWidths,
    ...horizontalSpacings,
    ...verticalSpacings,
    ...durations,
    ...curves,
    ...colorTokens,
    ...colorPaletteTokens$1,
    ...colorStatusTokens$1,
    ...createShadowTokens(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
    ...createShadowTokens(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, "Brand")
  };
};

const brandWeb = {
    10: `#061724`,
    20: `#082338`,
    30: `#0a2e4a`,
    40: `#0c3b5e`,
    50: `#0e4775`,
    60: `#0f548c`,
    70: `#115ea3`,
    80: `#0f6cbd`,
    90: `#2886de`,
    100: `#479ef5`,
    110: `#62abf5`,
    120: `#77b7f7`,
    130: `#96c6fa`,
    140: `#b4d6fa`,
    150: `#cfe4fa`,
    160: `#ebf3fc`
};

const statusColorPaletteTokens = statusSharedColorNames.reduce((acc, sharedColor) => {
  const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
  const sharedColorTokens = {
    [`colorPalette${color}Background1`]: statusSharedColors[sharedColor].shade40,
    [`colorPalette${color}Background2`]: statusSharedColors[sharedColor].shade30,
    [`colorPalette${color}Background3`]: statusSharedColors[sharedColor].primary,
    [`colorPalette${color}Foreground1`]: statusSharedColors[sharedColor].tint30,
    [`colorPalette${color}Foreground2`]: statusSharedColors[sharedColor].tint40,
    [`colorPalette${color}Foreground3`]: statusSharedColors[sharedColor].tint20,
    [`colorPalette${color}BorderActive`]: statusSharedColors[sharedColor].tint30,
    [`colorPalette${color}Border1`]: statusSharedColors[sharedColor].primary,
    [`colorPalette${color}Border2`]: statusSharedColors[sharedColor].tint20
  };
  return Object.assign(acc, sharedColorTokens);
}, {});
statusColorPaletteTokens.colorPaletteRedForeground3 = statusSharedColors.red.tint30;
statusColorPaletteTokens.colorPaletteRedBorder2 = statusSharedColors.red.tint30;
statusColorPaletteTokens.colorPaletteGreenForeground3 = statusSharedColors.green.tint40;
statusColorPaletteTokens.colorPaletteGreenBorder2 = statusSharedColors.green.tint40;
statusColorPaletteTokens.colorPaletteDarkOrangeForeground3 = statusSharedColors.darkOrange.tint30;
statusColorPaletteTokens.colorPaletteDarkOrangeBorder2 = statusSharedColors.darkOrange.tint30;
statusColorPaletteTokens.colorPaletteRedForegroundInverted = statusSharedColors.red.primary;
statusColorPaletteTokens.colorPaletteGreenForegroundInverted = statusSharedColors.green.primary;
statusColorPaletteTokens.colorPaletteYellowForegroundInverted = statusSharedColors.yellow.shade30;
const personaColorPaletteTokens = personaSharedColorNames.reduce((acc, sharedColor) => {
  const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
  const sharedColorTokens = {
    [`colorPalette${color}Background2`]: personaSharedColors[sharedColor].shade30,
    [`colorPalette${color}Foreground2`]: personaSharedColors[sharedColor].tint40,
    [`colorPalette${color}BorderActive`]: personaSharedColors[sharedColor].tint30
  };
  return Object.assign(acc, sharedColorTokens);
}, {});
personaColorPaletteTokens.colorPaletteDarkRedBackground2 = personaSharedColors.darkRed.shade20;
personaColorPaletteTokens.colorPalettePlumBackground2 = personaSharedColors.plum.shade20;
const colorPaletteTokens = {
  ...statusColorPaletteTokens,
  ...personaColorPaletteTokens
};
const colorStatusTokens = Object.entries(statusColorMapping).reduce((acc, [statusColor, sharedColor]) => {
  const color = statusColor.slice(0, 1).toUpperCase() + statusColor.slice(1);
  const statusColorTokens = {
    [`colorStatus${color}Background1`]: mappedStatusColors[sharedColor].shade40,
    [`colorStatus${color}Background2`]: mappedStatusColors[sharedColor].shade30,
    [`colorStatus${color}Background3`]: mappedStatusColors[sharedColor].primary,
    [`colorStatus${color}Foreground1`]: mappedStatusColors[sharedColor].tint30,
    [`colorStatus${color}Foreground2`]: mappedStatusColors[sharedColor].tint40,
    [`colorStatus${color}Foreground3`]: mappedStatusColors[sharedColor].tint20,
    [`colorStatus${color}BorderActive`]: mappedStatusColors[sharedColor].tint30,
    [`colorStatus${color}ForegroundInverted`]: mappedStatusColors[sharedColor].shade10,
    [`colorStatus${color}Border1`]: mappedStatusColors[sharedColor].primary,
    [`colorStatus${color}Border2`]: mappedStatusColors[sharedColor].tint20
  };
  return Object.assign(acc, statusColorTokens);
}, {});
colorStatusTokens.colorStatusDangerBackground3Hover = mappedStatusColors[statusColorMapping.danger].shade10;
colorStatusTokens.colorStatusDangerBackground3Pressed = mappedStatusColors[statusColorMapping.danger].shade20;
colorStatusTokens.colorStatusDangerForeground3 = mappedStatusColors[statusColorMapping.danger].tint40;
colorStatusTokens.colorStatusDangerBorder2 = mappedStatusColors[statusColorMapping.danger].tint30;
colorStatusTokens.colorStatusSuccessForeground3 = mappedStatusColors[statusColorMapping.success].tint40;
colorStatusTokens.colorStatusSuccessBorder2 = mappedStatusColors[statusColorMapping.success].tint40;
colorStatusTokens.colorStatusWarningForegroundInverted = mappedStatusColors[statusColorMapping.warning].shade20;

const webLightTheme = createLightTheme(brandWeb);

const generateColorTokens = (brand) => ({
  colorNeutralForeground1: white,
  colorNeutralForeground1Hover: white,
  colorNeutralForeground1Pressed: white,
  colorNeutralForeground1Selected: white,
  colorNeutralForeground2: grey[84],
  colorNeutralForeground2Hover: white,
  colorNeutralForeground2Pressed: white,
  colorNeutralForeground2Selected: white,
  colorNeutralForeground2BrandHover: brand[100],
  colorNeutralForeground2BrandPressed: brand[90],
  colorNeutralForeground2BrandSelected: brand[100],
  colorNeutralForeground3: grey[68],
  colorNeutralForeground3Hover: grey[84],
  colorNeutralForeground3Pressed: grey[84],
  colorNeutralForeground3Selected: grey[84],
  colorNeutralForeground3BrandHover: brand[100],
  colorNeutralForeground3BrandPressed: brand[90],
  colorNeutralForeground3BrandSelected: brand[100],
  colorNeutralForeground4: grey[60],
  colorNeutralForegroundDisabled: grey[36],
  colorNeutralForegroundInvertedDisabled: whiteAlpha[40],
  colorBrandForegroundLink: brand[100],
  colorBrandForegroundLinkHover: brand[110],
  colorBrandForegroundLinkPressed: brand[90],
  colorBrandForegroundLinkSelected: brand[100],
  colorNeutralForeground2Link: grey[84],
  colorNeutralForeground2LinkHover: white,
  colorNeutralForeground2LinkPressed: white,
  colorNeutralForeground2LinkSelected: white,
  colorCompoundBrandForeground1: brand[100],
  colorCompoundBrandForeground1Hover: brand[110],
  colorCompoundBrandForeground1Pressed: brand[90],
  colorBrandForeground1: brand[100],
  colorBrandForeground2: brand[110],
  colorBrandForeground2Hover: brand[130],
  colorBrandForeground2Pressed: brand[160],
  colorNeutralForeground1Static: grey[14],
  colorNeutralForegroundStaticInverted: white,
  colorNeutralForegroundInverted: grey[14],
  colorNeutralForegroundInvertedHover: grey[14],
  colorNeutralForegroundInvertedPressed: grey[14],
  colorNeutralForegroundInvertedSelected: grey[14],
  colorNeutralForegroundInverted2: grey[14],
  colorNeutralForegroundOnBrand: white,
  colorNeutralForegroundInvertedLink: white,
  colorNeutralForegroundInvertedLinkHover: white,
  colorNeutralForegroundInvertedLinkPressed: white,
  colorNeutralForegroundInvertedLinkSelected: white,
  colorBrandForegroundInverted: brand[80],
  colorBrandForegroundInvertedHover: brand[70],
  colorBrandForegroundInvertedPressed: brand[60],
  colorBrandForegroundOnLight: brand[80],
  colorBrandForegroundOnLightHover: brand[70],
  colorBrandForegroundOnLightPressed: brand[50],
  colorBrandForegroundOnLightSelected: brand[60],
  colorNeutralBackground1: grey[16],
  colorNeutralBackground1Hover: grey[24],
  colorNeutralBackground1Pressed: grey[12],
  colorNeutralBackground1Selected: grey[22],
  colorNeutralBackground2: grey[12],
  colorNeutralBackground2Hover: grey[20],
  colorNeutralBackground2Pressed: grey[8],
  colorNeutralBackground2Selected: grey[18],
  colorNeutralBackground3: grey[8],
  colorNeutralBackground3Hover: grey[16],
  colorNeutralBackground3Pressed: grey[4],
  colorNeutralBackground3Selected: grey[14],
  colorNeutralBackground4: grey[4],
  colorNeutralBackground4Hover: grey[12],
  colorNeutralBackground4Pressed: black,
  colorNeutralBackground4Selected: grey[10],
  colorNeutralBackground5: black,
  colorNeutralBackground5Hover: grey[8],
  colorNeutralBackground5Pressed: grey[2],
  colorNeutralBackground5Selected: grey[6],
  colorNeutralBackground6: grey[20],
  colorNeutralBackgroundInverted: white,
  colorNeutralBackgroundStatic: grey[24],
  colorNeutralBackgroundAlpha: grey10Alpha[50],
  colorNeutralBackgroundAlpha2: grey12Alpha[70],
  colorSubtleBackground: "transparent",
  colorSubtleBackgroundHover: grey[22],
  colorSubtleBackgroundPressed: grey[18],
  colorSubtleBackgroundSelected: grey[20],
  colorSubtleBackgroundLightAlphaHover: grey14Alpha[80],
  colorSubtleBackgroundLightAlphaPressed: grey14Alpha[50],
  colorSubtleBackgroundLightAlphaSelected: "transparent",
  colorSubtleBackgroundInverted: "transparent",
  colorSubtleBackgroundInvertedHover: blackAlpha[10],
  colorSubtleBackgroundInvertedPressed: blackAlpha[30],
  colorSubtleBackgroundInvertedSelected: blackAlpha[20],
  colorTransparentBackground: "transparent",
  colorTransparentBackgroundHover: "transparent",
  colorTransparentBackgroundPressed: "transparent",
  colorTransparentBackgroundSelected: "transparent",
  colorNeutralBackgroundDisabled: grey[8],
  colorNeutralBackgroundInvertedDisabled: whiteAlpha[10],
  colorNeutralStencil1: grey[34],
  colorNeutralStencil2: grey[20],
  colorNeutralStencil1Alpha: whiteAlpha[10],
  colorNeutralStencil2Alpha: whiteAlpha[5],
  colorBackgroundOverlay: blackAlpha[50],
  colorScrollbarOverlay: whiteAlpha[60],
  colorBrandBackground: brand[70],
  colorBrandBackgroundHover: brand[80],
  colorBrandBackgroundPressed: brand[40],
  colorBrandBackgroundSelected: brand[60],
  colorCompoundBrandBackground: brand[100],
  colorCompoundBrandBackgroundHover: brand[110],
  colorCompoundBrandBackgroundPressed: brand[90],
  colorBrandBackgroundStatic: brand[80],
  colorBrandBackground2: brand[20],
  colorBrandBackground2Hover: brand[40],
  colorBrandBackground2Pressed: brand[10],
  colorBrandBackground3Static: brand[60],
  colorBrandBackground4Static: brand[40],
  colorBrandBackgroundInverted: white,
  colorBrandBackgroundInvertedHover: brand[160],
  colorBrandBackgroundInvertedPressed: brand[140],
  colorBrandBackgroundInvertedSelected: brand[150],
  colorNeutralCardBackground: grey[20],
  colorNeutralCardBackgroundHover: grey[24],
  colorNeutralCardBackgroundPressed: grey[18],
  colorNeutralCardBackgroundSelected: grey[22],
  colorNeutralCardBackgroundDisabled: grey[8],
  colorNeutralStrokeAccessible: grey[68],
  colorNeutralStrokeAccessibleHover: grey[74],
  colorNeutralStrokeAccessiblePressed: grey[70],
  colorNeutralStrokeAccessibleSelected: brand[100],
  colorNeutralStroke1: grey[40],
  colorNeutralStroke1Hover: grey[46],
  colorNeutralStroke1Pressed: grey[42],
  colorNeutralStroke1Selected: grey[44],
  colorNeutralStroke2: grey[32],
  colorNeutralStroke3: grey[24],
  colorNeutralStrokeSubtle: grey[4],
  colorNeutralStrokeOnBrand: grey[16],
  colorNeutralStrokeOnBrand2: white,
  colorNeutralStrokeOnBrand2Hover: white,
  colorNeutralStrokeOnBrand2Pressed: white,
  colorNeutralStrokeOnBrand2Selected: white,
  colorBrandStroke1: brand[100],
  colorBrandStroke2: brand[50],
  colorBrandStroke2Hover: brand[50],
  colorBrandStroke2Pressed: brand[30],
  colorBrandStroke2Contrast: brand[50],
  colorCompoundBrandStroke: brand[100],
  colorCompoundBrandStrokeHover: brand[110],
  colorCompoundBrandStrokePressed: brand[90],
  colorNeutralStrokeDisabled: grey[26],
  colorNeutralStrokeInvertedDisabled: whiteAlpha[40],
  colorTransparentStroke: "transparent",
  colorTransparentStrokeInteractive: "transparent",
  colorTransparentStrokeDisabled: "transparent",
  colorNeutralStrokeAlpha: whiteAlpha[10],
  colorNeutralStrokeAlpha2: whiteAlpha[20],
  colorStrokeFocus1: black,
  colorStrokeFocus2: white,
  colorNeutralShadowAmbient: "rgba(0,0,0,0.24)",
  colorNeutralShadowKey: "rgba(0,0,0,0.28)",
  colorNeutralShadowAmbientLighter: "rgba(0,0,0,0.12)",
  colorNeutralShadowKeyLighter: "rgba(0,0,0,0.14)",
  colorNeutralShadowAmbientDarker: "rgba(0,0,0,0.40)",
  colorNeutralShadowKeyDarker: "rgba(0,0,0,0.48)",
  colorBrandShadowAmbient: "rgba(0,0,0,0.30)",
  colorBrandShadowKey: "rgba(0,0,0,0.25)"
});

const createDarkTheme = (brand) => {
  const colorTokens = generateColorTokens(brand);
  return {
    ...borderRadius,
    ...fontSizes,
    ...lineHeights,
    ...fontFamilies,
    ...fontWeights,
    ...strokeWidths,
    ...horizontalSpacings,
    ...verticalSpacings,
    ...durations,
    ...curves,
    ...colorTokens,
    ...colorPaletteTokens,
    ...colorStatusTokens,
    ...createShadowTokens(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
    ...createShadowTokens(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, "Brand")
  };
};

const webDarkTheme = createDarkTheme(brandWeb);

const fluentProviderClassNames = {
  root: 'fui-FluentProvider'
};
const useStyles$G = /*#__PURE__*/__styles$1({
  root: {
    sj55zd: "f19n0e5",
    De3pzq: "fxugw4r",
    fsow6f: ["f1o700av", "fes3tcz"],
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".f19n0e5{color:var(--colorNeutralForeground1);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f1o700av{text-align:left;}", ".fes3tcz{text-align:right;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});
/** Applies style classnames to slots */
const useFluentProviderStyles_unstable = state => {
  'use no memo';

  const renderer = useRenderer();
  const styles = useStyles$G({
    dir: state.dir,
    renderer
  });
  state.root.className = mergeClasses(fluentProviderClassNames.root, state.themeClassName, styles.root, state.root.className);
  return state;
};

// String concatenation is used to prevent bundlers to complain with older versions of React
const useInsertionEffect$1 = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : useIsomorphicLayoutEffect;
const createStyleTag = (target, elementAttributes)=>{
    if (!target) {
        return undefined;
    }
    const tag = target.createElement('style');
    Object.keys(elementAttributes).forEach((attrName)=>{
        tag.setAttribute(attrName, elementAttributes[attrName]);
    });
    target.head.appendChild(tag);
    return tag;
};
const insertSheet = (tag, rule)=>{
    const sheet = tag.sheet;
    if (sheet) {
        if (sheet.cssRules.length > 0) {
            sheet.deleteRule(0);
        }
        sheet.insertRule(rule, 0);
    } else if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('FluentProvider: No sheet available on styleTag, styles will not be inserted into DOM.');
    }
};
/**
 * Writes a theme as css variables in a style tag on the provided targetDocument as a rule applied to a CSS class
 * @internal
 * @returns CSS class to apply the rule
 */ const useFluentProviderThemeStyleTag = (options)=>{
    'use no memo';
    const { targetDocument, theme, rendererAttributes } = options;
    const styleTag = React.useRef();
    const styleTagId = useId(fluentProviderClassNames.root);
    const styleElementAttributes = rendererAttributes;
    const rule = React.useMemo(()=>createCSSRuleFromTheme(`.${styleTagId}`, theme), [
        theme,
        styleTagId
    ]);
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useMemo(()=>{
            // Heads up!
            // .useMemo() is used because it is called during render and DOM for _current_ component is not mounted yet. Also,
            // this allows to do checks with strict mode enabled as .useEffect() will be called with incremented IDs because
            // of double render.
            if (targetDocument) {
                const providerSelector = `.${fluentProviderClassNames.root}.${styleTagId}`;
                const providerElements = targetDocument.querySelectorAll(providerSelector);
                // In SSR, we will have DOM upfront. To avoid false positives the check on nested style tag is performed
                const isSSR = targetDocument.querySelector(`${providerSelector} > style[id="${styleTagId}"]`) !== null;
                const elementsCount = isSSR ? 1 : 0;
                if (providerElements.length > elementsCount) {
                    // eslint-disable-next-line no-console
                    console.error([
                        '@fluentui/react-provider: There are conflicting ids in your DOM.',
                        'Please make sure that you configured your application properly.',
                        '\n',
                        '\n',
                        'Configuration guide: https://aka.ms/fluentui-conflicting-ids'
                    ].join(' '));
                }
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
    useHandleSSRStyleElements(targetDocument, styleTagId);
    useInsertionEffect$1(()=>{
        // The style element could already have been created during SSR - no need to recreate it
        const ssrStyleElement = targetDocument === null || targetDocument === undefined ? undefined : targetDocument.getElementById(styleTagId);
        if (ssrStyleElement) {
            styleTag.current = ssrStyleElement;
        } else {
            styleTag.current = createStyleTag(targetDocument, {
                ...styleElementAttributes,
                id: styleTagId
            });
            if (styleTag.current) {
                insertSheet(styleTag.current, rule);
            }
        }
        return ()=>{
            var _styleTag_current;
            (_styleTag_current = styleTag.current) === null || _styleTag_current === undefined ? undefined : _styleTag_current.remove();
        };
    }, [
        styleTagId,
        targetDocument,
        rule,
        styleElementAttributes
    ]);
    return {
        styleTagId,
        rule
    };
};
function useHandleSSRStyleElements(targetDocument, styleTagId) {
    // Using a state factory so that this logic only runs once per render
    // Each FluentProvider can create its own style element during SSR as a slot
    // Moves all theme style elements to document head during render to avoid hydration errors.
    // Should be strict mode safe since the logic is idempotent.
    React.useState(()=>{
        if (!targetDocument) {
            return;
        }
        const themeStyleElement = targetDocument.getElementById(styleTagId);
        if (themeStyleElement) {
            targetDocument.head.append(themeStyleElement);
        }
    });
}

// Meomizing empty objects to avoid unnecessary rerenders.
const DEFAULT_STYLE_HOOKS = {};
const DEFAULT_RENDERER_ATTRIBUTES = {};
/**
 * Create the state required to render FluentProvider.
 *
 * The returned state can be modified with hooks such as useFluentProviderStyles_unstable,
 * before being passed to renderFluentProvider_unstable.
 *
 * @param props - props from this instance of FluentProvider
 * @param ref - reference to root HTMLElement of FluentProvider
 */ const useFluentProvider_unstable = (props, ref)=>{
    'use no memo';
    const parentContext = useFluent();
    const parentTheme = useTheme();
    const parentOverrides = useOverrides();
    const parentCustomStyleHooks = React.useContext(CustomStyleHooksContext$1) || DEFAULT_STYLE_HOOKS;
    /**
   * TODO: add merge functions to "dir" merge,
   * nesting providers with the same "dir" should not add additional attributes to DOM
   * see https://github.com/microsoft/fluentui/blob/0dc74a19f3aa5a058224c20505016fbdb84db172/packages/fluentui/react-northstar/src/utils/mergeProviderContexts.ts#L89-L93
   */ const { applyStylesToPortals = true, // eslint-disable-next-line @typescript-eslint/naming-convention
    customStyleHooks_unstable, dir = parentContext.dir, targetDocument = parentContext.targetDocument, theme, overrides_unstable: overrides = {} } = props;
    const mergedTheme = shallowMerge$1(parentTheme, theme);
    const mergedOverrides = shallowMerge$1(parentOverrides, overrides);
    const mergedCustomStyleHooks = shallowMerge$1(parentCustomStyleHooks, customStyleHooks_unstable);
    const renderer = useRenderer();
    var _renderer_styleElementAttributes;
    const { styleTagId, rule } = useFluentProviderThemeStyleTag({
        theme: mergedTheme,
        targetDocument,
        rendererAttributes: (_renderer_styleElementAttributes = renderer.styleElementAttributes) !== null && _renderer_styleElementAttributes !== undefined ? _renderer_styleElementAttributes : DEFAULT_RENDERER_ATTRIBUTES
    });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(()=>{
            if (mergedTheme === undefined) {
                // eslint-disable-next-line no-console
                console.warn([
                    '@fluentui/react-provider: FluentProvider does not have your "theme" defined.',
                    "Make sure that your top-level FluentProvider has set a `theme` prop or you're setting the theme in your child FluentProvider."
                ].join(' '));
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
    return {
        applyStylesToPortals,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        customStyleHooks_unstable: mergedCustomStyleHooks,
        dir,
        targetDocument,
        theme: mergedTheme,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        overrides_unstable: mergedOverrides,
        themeClassName: styleTagId,
        components: {
            root: 'div'
        },
        root: always(getIntrinsicElementProps('div', {
            ...props,
            dir,
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: useMergedRefs(ref, useFocusVisible({
                targetDocument
            }))
        }), {
            elementType: 'div'
        }),
        serverStyleProps: {
            cssRule: rule,
            attributes: {
                ...renderer.styleElementAttributes,
                id: styleTagId
            }
        }
    };
};
function shallowMerge$1(a, b) {
    // Merge impacts perf: we should like to avoid it if it's possible
    if (a && b) {
        return {
            ...a,
            ...b
        };
    }
    if (a) {
        return a;
    }
    return b;
}
function useTheme() {
    return React.useContext(ThemeContext);
}

function useFluentProviderContextValues_unstable(state) {
    const { applyStylesToPortals, // eslint-disable-next-line @typescript-eslint/naming-convention
    customStyleHooks_unstable, dir, root, targetDocument, theme, themeClassName, // eslint-disable-next-line @typescript-eslint/naming-convention
    overrides_unstable } = state;
    const provider = React.useMemo(()=>({
            dir,
            targetDocument
        }), [
        dir,
        targetDocument
    ]);
    // "Tooltip" component mutates an object in this context, instance should be stable
    const [tooltip] = React.useState(()=>({}));
    const iconDirection = React.useMemo(()=>({
            textDirection: dir
        }), [
        dir
    ]);
    return {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        customStyleHooks_unstable,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        overrides_unstable,
        provider,
        textDirection: dir,
        iconDirection,
        tooltip,
        theme,
        themeClassName: applyStylesToPortals ? root.className : themeClassName
    };
}

const FluentProvider = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useFluentProvider_unstable(props, ref);
    useFluentProviderStyles_unstable(state);
    const contextValues = useFluentProviderContextValues_unstable(state);
    return renderFluentProvider_unstable(state, contextValues);
});
FluentProvider.displayName = 'FluentProvider';

var scheduler = {exports: {}};

var scheduler_production_min = {};

/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredScheduler_production_min;

function requireScheduler_production_min () {
	if (hasRequiredScheduler_production_min) return scheduler_production_min;
	hasRequiredScheduler_production_min = 1;
	(function (exports) {
function f(a,b){var c=a.length;a.push(b);a:for(;0<c;){var d=c-1>>>1,e=a[d];if(0<g(e,b))a[d]=b,a[c]=e,c=d;else break a}}function h(a){return 0===a.length?null:a[0]}function k(a){if(0===a.length)return null;var b=a[0],c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length,w=e>>>1;d<w;){var m=2*(d+1)-1,C=a[m],n=m+1,x=a[n];if(0>g(C,c))n<e&&0>g(x,C)?(a[d]=x,a[n]=c,d=n):(a[d]=C,a[m]=c,d=m);else if(n<e&&0>g(x,c))a[d]=x,a[n]=c,d=n;else break a}}return b}
		function g(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()};}else {var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q};}var r=[],t=[],u=1,v=null,y=3,z=false,A=false,B=false,D="function"===typeof setTimeout?setTimeout:null,E="function"===typeof clearTimeout?clearTimeout:null,F="undefined"!==typeof setImmediate?setImmediate:null;
		"undefined"!==typeof navigator&&undefined!==navigator.scheduling&&undefined!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function G(a){for(var b=h(t);null!==b;){if(null===b.callback)k(t);else if(b.startTime<=a)k(t),b.sortIndex=b.expirationTime,f(r,b);else break;b=h(t);}}function H(a){B=false;G(a);if(!A)if(null!==h(r))A=true,I(J);else {var b=h(t);null!==b&&K(H,b.startTime-a);}}
		function J(a,b){A=false;B&&(B=false,E(L),L=-1);z=true;var c=y;try{G(b);for(v=h(r);null!==v&&(!(v.expirationTime>b)||a&&!M());){var d=v.callback;if("function"===typeof d){v.callback=null;y=v.priorityLevel;var e=d(v.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?v.callback=e:v===h(r)&&k(r);G(b);}else k(r);v=h(r);}if(null!==v)var w=!0;else {var m=h(t);null!==m&&K(H,m.startTime-b);w=!1;}return w}finally{v=null,y=c,z=false;}}var N=false,O=null,L=-1,P=5,Q=-1;
		function M(){return exports.unstable_now()-Q<P?false:true}function R(){if(null!==O){var a=exports.unstable_now();Q=a;var b=true;try{b=O(!0,a);}finally{b?S():(N=false,O=null);}}else N=false;}var S;if("function"===typeof F)S=function(){F(R);};else if("undefined"!==typeof MessageChannel){var T=new MessageChannel,U=T.port2;T.port1.onmessage=R;S=function(){U.postMessage(null);};}else S=function(){D(R,0);};function I(a){O=a;N||(N=true,S());}function K(a,b){L=D(function(){a(exports.unstable_now());},b);}
		exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null;};exports.unstable_continueExecution=function(){A||z||(A=true,I(J));};
		exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):P=0<a?Math.floor(1E3/a):5;};exports.unstable_getCurrentPriorityLevel=function(){return y};exports.unstable_getFirstCallbackNode=function(){return h(r)};exports.unstable_next=function(a){switch(y){case 1:case 2:case 3:var b=3;break;default:b=y;}var c=y;y=b;try{return a()}finally{y=c;}};exports.unstable_pauseExecution=function(){};
		exports.unstable_requestPaint=function(){};exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3;}var c=y;y=a;try{return b()}finally{y=c;}};
		exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3;}e=c+e;a={id:u++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,f(t,a),null===h(r)&&a===h(t)&&(B?(E(L),L=-1):B=true,K(H,c-d))):(a.sortIndex=e,f(r,a),A||z||(A=true,I(J)));return a};
		exports.unstable_shouldYield=M;exports.unstable_wrapCallback=function(a){var b=y;return function(){var c=y;y=b;try{return a.apply(this,arguments)}finally{y=c;}}}; 
	} (scheduler_production_min));
	return scheduler_production_min;
}

var scheduler_development = {};

var hasRequiredScheduler_development;

function requireScheduler_development () {
	if (hasRequiredScheduler_development) return scheduler_development;
	hasRequiredScheduler_development = 1;
	(function (exports) {
		/**
		 * @license React
		 * scheduler.development.js
		 *
		 * Copyright (c) Facebook, Inc. and its affiliates.
		 *
		 * This source code is licensed under the MIT license found in the
		 * LICENSE file in the root directory of this source tree.
		 */
		if (process.env.NODE_ENV !== "production") {
		  (function() {
		    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
		      __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
		    }
		    var enableProfiling = false;
		    var frameYieldMs = 5;
		    function push(heap, node) {
		      var index = heap.length;
		      heap.push(node);
		      siftUp(heap, node, index);
		    }
		    function peek(heap) {
		      return heap.length === 0 ? null : heap[0];
		    }
		    function pop(heap) {
		      if (heap.length === 0) {
		        return null;
		      }
		      var first = heap[0];
		      var last = heap.pop();
		      if (last !== first) {
		        heap[0] = last;
		        siftDown(heap, last, 0);
		      }
		      return first;
		    }
		    function siftUp(heap, node, i) {
		      var index = i;
		      while (index > 0) {
		        var parentIndex = index - 1 >>> 1;
		        var parent = heap[parentIndex];
		        if (compare(parent, node) > 0) {
		          heap[parentIndex] = node;
		          heap[index] = parent;
		          index = parentIndex;
		        } else {
		          return;
		        }
		      }
		    }
		    function siftDown(heap, node, i) {
		      var index = i;
		      var length = heap.length;
		      var halfLength = length >>> 1;
		      while (index < halfLength) {
		        var leftIndex = (index + 1) * 2 - 1;
		        var left = heap[leftIndex];
		        var rightIndex = leftIndex + 1;
		        var right = heap[rightIndex];
		        if (compare(left, node) < 0) {
		          if (rightIndex < length && compare(right, left) < 0) {
		            heap[index] = right;
		            heap[rightIndex] = node;
		            index = rightIndex;
		          } else {
		            heap[index] = left;
		            heap[leftIndex] = node;
		            index = leftIndex;
		          }
		        } else if (rightIndex < length && compare(right, node) < 0) {
		          heap[index] = right;
		          heap[rightIndex] = node;
		          index = rightIndex;
		        } else {
		          return;
		        }
		      }
		    }
		    function compare(a, b) {
		      var diff = a.sortIndex - b.sortIndex;
		      return diff !== 0 ? diff : a.id - b.id;
		    }
		    var ImmediatePriority = 1;
		    var UserBlockingPriority = 2;
		    var NormalPriority = 3;
		    var LowPriority = 4;
		    var IdlePriority = 5;
		    function markTaskErrored(task, ms) {
		    }
		    var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
		    if (hasPerformanceNow) {
		      var localPerformance = performance;
		      exports.unstable_now = function() {
		        return localPerformance.now();
		      };
		    } else {
		      var localDate = Date;
		      var initialTime = localDate.now();
		      exports.unstable_now = function() {
		        return localDate.now() - initialTime;
		      };
		    }
		    var maxSigned31BitInt = 1073741823;
		    var IMMEDIATE_PRIORITY_TIMEOUT = -1;
		    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
		    var NORMAL_PRIORITY_TIMEOUT = 5e3;
		    var LOW_PRIORITY_TIMEOUT = 1e4;
		    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
		    var taskQueue = [];
		    var timerQueue = [];
		    var taskIdCounter = 1;
		    var currentTask = null;
		    var currentPriorityLevel = NormalPriority;
		    var isPerformingWork = false;
		    var isHostCallbackScheduled = false;
		    var isHostTimeoutScheduled = false;
		    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
		    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
		    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null;
		    typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
		    function advanceTimers(currentTime) {
		      var timer = peek(timerQueue);
		      while (timer !== null) {
		        if (timer.callback === null) {
		          pop(timerQueue);
		        } else if (timer.startTime <= currentTime) {
		          pop(timerQueue);
		          timer.sortIndex = timer.expirationTime;
		          push(taskQueue, timer);
		        } else {
		          return;
		        }
		        timer = peek(timerQueue);
		      }
		    }
		    function handleTimeout(currentTime) {
		      isHostTimeoutScheduled = false;
		      advanceTimers(currentTime);
		      if (!isHostCallbackScheduled) {
		        if (peek(taskQueue) !== null) {
		          isHostCallbackScheduled = true;
		          requestHostCallback(flushWork);
		        } else {
		          var firstTimer = peek(timerQueue);
		          if (firstTimer !== null) {
		            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
		          }
		        }
		      }
		    }
		    function flushWork(hasTimeRemaining, initialTime2) {
		      isHostCallbackScheduled = false;
		      if (isHostTimeoutScheduled) {
		        isHostTimeoutScheduled = false;
		        cancelHostTimeout();
		      }
		      isPerformingWork = true;
		      var previousPriorityLevel = currentPriorityLevel;
		      try {
		        var currentTime; if (enableProfiling) ; else {
		          return workLoop(hasTimeRemaining, initialTime2);
		        }
		      } finally {
		        currentTask = null;
		        currentPriorityLevel = previousPriorityLevel;
		        isPerformingWork = false;
		      }
		    }
		    function workLoop(hasTimeRemaining, initialTime2) {
		      var currentTime = initialTime2;
		      advanceTimers(currentTime);
		      currentTask = peek(taskQueue);
		      while (currentTask !== null && true) {
		        if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
		          break;
		        }
		        var callback = currentTask.callback;
		        if (typeof callback === "function") {
		          currentTask.callback = null;
		          currentPriorityLevel = currentTask.priorityLevel;
		          var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
		          var continuationCallback = callback(didUserCallbackTimeout);
		          currentTime = exports.unstable_now();
		          if (typeof continuationCallback === "function") {
		            currentTask.callback = continuationCallback;
		          } else {
		            if (currentTask === peek(taskQueue)) {
		              pop(taskQueue);
		            }
		          }
		          advanceTimers(currentTime);
		        } else {
		          pop(taskQueue);
		        }
		        currentTask = peek(taskQueue);
		      }
		      if (currentTask !== null) {
		        return true;
		      } else {
		        var firstTimer = peek(timerQueue);
		        if (firstTimer !== null) {
		          requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
		        }
		        return false;
		      }
		    }
		    function unstable_runWithPriority(priorityLevel, eventHandler) {
		      switch (priorityLevel) {
		        case ImmediatePriority:
		        case UserBlockingPriority:
		        case NormalPriority:
		        case LowPriority:
		        case IdlePriority:
		          break;
		        default:
		          priorityLevel = NormalPriority;
		      }
		      var previousPriorityLevel = currentPriorityLevel;
		      currentPriorityLevel = priorityLevel;
		      try {
		        return eventHandler();
		      } finally {
		        currentPriorityLevel = previousPriorityLevel;
		      }
		    }
		    function unstable_next(eventHandler) {
		      var priorityLevel;
		      switch (currentPriorityLevel) {
		        case ImmediatePriority:
		        case UserBlockingPriority:
		        case NormalPriority:
		          priorityLevel = NormalPriority;
		          break;
		        default:
		          priorityLevel = currentPriorityLevel;
		          break;
		      }
		      var previousPriorityLevel = currentPriorityLevel;
		      currentPriorityLevel = priorityLevel;
		      try {
		        return eventHandler();
		      } finally {
		        currentPriorityLevel = previousPriorityLevel;
		      }
		    }
		    function unstable_wrapCallback(callback) {
		      var parentPriorityLevel = currentPriorityLevel;
		      return function() {
		        var previousPriorityLevel = currentPriorityLevel;
		        currentPriorityLevel = parentPriorityLevel;
		        try {
		          return callback.apply(this, arguments);
		        } finally {
		          currentPriorityLevel = previousPriorityLevel;
		        }
		      };
		    }
		    function unstable_scheduleCallback(priorityLevel, callback, options) {
		      var currentTime = exports.unstable_now();
		      var startTime2;
		      if (typeof options === "object" && options !== null) {
		        var delay = options.delay;
		        if (typeof delay === "number" && delay > 0) {
		          startTime2 = currentTime + delay;
		        } else {
		          startTime2 = currentTime;
		        }
		      } else {
		        startTime2 = currentTime;
		      }
		      var timeout;
		      switch (priorityLevel) {
		        case ImmediatePriority:
		          timeout = IMMEDIATE_PRIORITY_TIMEOUT;
		          break;
		        case UserBlockingPriority:
		          timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
		          break;
		        case IdlePriority:
		          timeout = IDLE_PRIORITY_TIMEOUT;
		          break;
		        case LowPriority:
		          timeout = LOW_PRIORITY_TIMEOUT;
		          break;
		        case NormalPriority:
		        default:
		          timeout = NORMAL_PRIORITY_TIMEOUT;
		          break;
		      }
		      var expirationTime = startTime2 + timeout;
		      var newTask = {
		        id: taskIdCounter++,
		        callback,
		        priorityLevel,
		        startTime: startTime2,
		        expirationTime,
		        sortIndex: -1
		      };
		      if (startTime2 > currentTime) {
		        newTask.sortIndex = startTime2;
		        push(timerQueue, newTask);
		        if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
		          if (isHostTimeoutScheduled) {
		            cancelHostTimeout();
		          } else {
		            isHostTimeoutScheduled = true;
		          }
		          requestHostTimeout(handleTimeout, startTime2 - currentTime);
		        }
		      } else {
		        newTask.sortIndex = expirationTime;
		        push(taskQueue, newTask);
		        if (!isHostCallbackScheduled && !isPerformingWork) {
		          isHostCallbackScheduled = true;
		          requestHostCallback(flushWork);
		        }
		      }
		      return newTask;
		    }
		    function unstable_pauseExecution() {
		    }
		    function unstable_continueExecution() {
		      if (!isHostCallbackScheduled && !isPerformingWork) {
		        isHostCallbackScheduled = true;
		        requestHostCallback(flushWork);
		      }
		    }
		    function unstable_getFirstCallbackNode() {
		      return peek(taskQueue);
		    }
		    function unstable_cancelCallback(task) {
		      task.callback = null;
		    }
		    function unstable_getCurrentPriorityLevel() {
		      return currentPriorityLevel;
		    }
		    var isMessageLoopRunning = false;
		    var scheduledHostCallback = null;
		    var taskTimeoutID = -1;
		    var frameInterval = frameYieldMs;
		    var startTime = -1;
		    function shouldYieldToHost() {
		      var timeElapsed = exports.unstable_now() - startTime;
		      if (timeElapsed < frameInterval) {
		        return false;
		      }
		      return true;
		    }
		    function requestPaint() {
		    }
		    function forceFrameRate(fps) {
		      if (fps < 0 || fps > 125) {
		        console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
		        return;
		      }
		      if (fps > 0) {
		        frameInterval = Math.floor(1e3 / fps);
		      } else {
		        frameInterval = frameYieldMs;
		      }
		    }
		    var performWorkUntilDeadline = function() {
		      if (scheduledHostCallback !== null) {
		        var currentTime = exports.unstable_now();
		        startTime = currentTime;
		        var hasTimeRemaining = true;
		        var hasMoreWork = true;
		        try {
		          hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
		        } finally {
		          if (hasMoreWork) {
		            schedulePerformWorkUntilDeadline();
		          } else {
		            isMessageLoopRunning = false;
		            scheduledHostCallback = null;
		          }
		        }
		      } else {
		        isMessageLoopRunning = false;
		      }
		    };
		    var schedulePerformWorkUntilDeadline;
		    if (typeof localSetImmediate === "function") {
		      schedulePerformWorkUntilDeadline = function() {
		        localSetImmediate(performWorkUntilDeadline);
		      };
		    } else if (typeof MessageChannel !== "undefined") {
		      var channel = new MessageChannel();
		      var port = channel.port2;
		      channel.port1.onmessage = performWorkUntilDeadline;
		      schedulePerformWorkUntilDeadline = function() {
		        port.postMessage(null);
		      };
		    } else {
		      schedulePerformWorkUntilDeadline = function() {
		        localSetTimeout(performWorkUntilDeadline, 0);
		      };
		    }
		    function requestHostCallback(callback) {
		      scheduledHostCallback = callback;
		      if (!isMessageLoopRunning) {
		        isMessageLoopRunning = true;
		        schedulePerformWorkUntilDeadline();
		      }
		    }
		    function requestHostTimeout(callback, ms) {
		      taskTimeoutID = localSetTimeout(function() {
		        callback(exports.unstable_now());
		      }, ms);
		    }
		    function cancelHostTimeout() {
		      localClearTimeout(taskTimeoutID);
		      taskTimeoutID = -1;
		    }
		    var unstable_requestPaint = requestPaint;
		    var unstable_Profiling = null;
		    exports.unstable_IdlePriority = IdlePriority;
		    exports.unstable_ImmediatePriority = ImmediatePriority;
		    exports.unstable_LowPriority = LowPriority;
		    exports.unstable_NormalPriority = NormalPriority;
		    exports.unstable_Profiling = unstable_Profiling;
		    exports.unstable_UserBlockingPriority = UserBlockingPriority;
		    exports.unstable_cancelCallback = unstable_cancelCallback;
		    exports.unstable_continueExecution = unstable_continueExecution;
		    exports.unstable_forceFrameRate = forceFrameRate;
		    exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
		    exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
		    exports.unstable_next = unstable_next;
		    exports.unstable_pauseExecution = unstable_pauseExecution;
		    exports.unstable_requestPaint = unstable_requestPaint;
		    exports.unstable_runWithPriority = unstable_runWithPriority;
		    exports.unstable_scheduleCallback = unstable_scheduleCallback;
		    exports.unstable_shouldYield = shouldYieldToHost;
		    exports.unstable_wrapCallback = unstable_wrapCallback;
		    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
		      __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
		    }
		  })();
		} 
	} (scheduler_development));
	return scheduler_development;
}

if (process.env.NODE_ENV === 'production') {
  scheduler.exports = requireScheduler_production_min();
} else {
  scheduler.exports = requireScheduler_development();
}

var schedulerExports = scheduler.exports;

const createProvider = (Original)=>{
    const Provider = (props)=>{
        // Holds an actual "props.value"
        const valueRef = React.useRef(props.value);
        // Used to sync context updates and avoid stale values, can be considered as render/effect counter of Provider.
        const versionRef = React.useRef(0);
        // A stable object, is used to avoid context updates via mutation of its values.
        const contextValue = React.useRef();
        if (!contextValue.current) {
            contextValue.current = {
                value: valueRef,
                version: versionRef,
                listeners: []
            };
        }
        useIsomorphicLayoutEffect(()=>{
            valueRef.current = props.value;
            versionRef.current += 1;
            schedulerExports.unstable_runWithPriority(schedulerExports.unstable_NormalPriority, ()=>{
                contextValue.current.listeners.forEach((listener)=>{
                    listener([
                        versionRef.current,
                        props.value
                    ]);
                });
            });
        }, [
            props.value
        ]);
        return React.createElement(Original, {
            value: contextValue.current
        }, props.children);
    };
    /* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
        Provider.displayName = 'ContextSelector.Provider';
    }
    return Provider;
};
/**
 * @internal
 */ const createContext = (defaultValue)=>{
    // eslint-disable-next-line @fluentui/no-context-default-value
    const context = React.createContext({
        value: {
            current: defaultValue
        },
        version: {
            current: -1
        },
        listeners: []
    });
    context.Provider = createProvider(context.Provider);
    // We don't support Consumer API
    delete context.Consumer;
    return context;
};

/**
 * @internal
 * This hook returns context selected value by selector.
 * It will only accept context created by `createContext`.
 * It will trigger re-render if only the selected value is referentially changed.
 */ const useContextSelector = (context, selector)=>{
    const contextValue = React.useContext(context);
    const { value: { current: value }, version: { current: version }, listeners } = contextValue;
    const selected = selector(value);
    const [state, setState] = React.useState([
        value,
        selected
    ]);
    const dispatch = (payload)=>{
        setState((prevState)=>{
            if (!payload) {
                // early bail out when is dispatched during render
                return [
                    value,
                    selected
                ];
            }
            if (payload[0] <= version) {
                if (Object.is(prevState[1], selected)) {
                    return prevState; // bail out
                }
                return [
                    value,
                    selected
                ];
            }
            try {
                if (Object.is(prevState[0], payload[1])) {
                    return prevState; // do not update
                }
                const nextSelected = selector(payload[1]);
                if (Object.is(prevState[1], nextSelected)) {
                    return prevState; // do not update
                }
                return [
                    payload[1],
                    nextSelected
                ];
            } catch (e) {
            // ignored (stale props or some other reason)
            }
            // explicitly spread to enforce typing
            return [
                prevState[0],
                prevState[1]
            ]; // schedule update
        });
    };
    if (!Object.is(state[1], selected)) {
        // schedule re-render
        // this is safe because it's self contained
        dispatch(undefined);
    }
    const stableDispatch = useEventCallback(dispatch);
    useIsomorphicLayoutEffect(()=>{
        listeners.push(stableDispatch);
        return ()=>{
            const index = listeners.indexOf(stableDispatch);
            listeners.splice(index, 1);
        };
    }, [
        stableDispatch,
        listeners
    ]);
    return state[1];
};

const Enter = 'Enter';
const Space = ' ';
const Escape = 'Escape';

/**
 * @internal
 *
 * Button keyboard handling, role, disabled and tabIndex implementation that ensures ARIA spec
 * for multiple scenarios of non native button elements. Ensuring 1st rule of ARIA for cases
 * where no attribute addition is required.
 *
 * @param type - the proper scenario to be interpreted by the hook.
 *  1. `button` - Minimal interference from the hook, as semantic button already supports most of the states
 *  2. `a` or `div` - Proper keyboard/mouse handling plus other support to ensure ARIA behavior
 * @param props - the props to be passed down the line to the desired element.
 * This hook will encapsulate proper properties, such as `onClick`, `onKeyDown`, `onKeyUp`, etc,.
 *
 * @example
 * ```tsx
 * const buttonProps = useARIAButtonProps('a', {
 *   href: './some-route'
 *   onClick: () => console.log('this should run both on click and Space and Enter')
 * })
 *
 * // ...
 *
 * return (
 *  <a {...buttonProps}>This anchor will behave as a proper button</a>
 * )
 * ```
 */ function useARIAButtonProps(type, props) {
    const { disabled, disabledFocusable = false, ['aria-disabled']: ariaDisabled, onClick, onKeyDown, onKeyUp, ...rest } = props !== null && props !== undefined ? props : {};
    const normalizedARIADisabled = typeof ariaDisabled === 'string' ? ariaDisabled === 'true' : ariaDisabled;
    const isDisabled = disabled || disabledFocusable || normalizedARIADisabled;
    const handleClick = useEventCallback((ev)=>{
        if (isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
        } else {
            onClick === null || onClick === undefined ? undefined : onClick(ev);
        }
    });
    const handleKeyDown = useEventCallback((ev)=>{
        onKeyDown === null || onKeyDown === undefined ? undefined : onKeyDown(ev);
        if (ev.isDefaultPrevented()) {
            return;
        }
        const key = ev.key;
        if (isDisabled && (key === Enter || key === Space)) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (key === Space) {
            ev.preventDefault();
            return;
        } else if (key === Enter) {
            ev.preventDefault();
            ev.currentTarget.click();
        }
    });
    const handleKeyUp = useEventCallback((ev)=>{
        onKeyUp === null || onKeyUp === undefined ? undefined : onKeyUp(ev);
        if (ev.isDefaultPrevented()) {
            return;
        }
        const key = ev.key;
        if (isDisabled && (key === Enter || key === Space)) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (key === Space) {
            ev.preventDefault();
            ev.currentTarget.click();
        }
    });
    // If a <button> tag is to be rendered we just need to set disabled and aria-disabled correctly
    if (type === 'button' || type === undefined) {
        return {
            ...rest,
            disabled: disabled && !disabledFocusable,
            'aria-disabled': disabledFocusable ? true : normalizedARIADisabled,
            // onclick should still use internal handler to ensure prevention if disabled
            // if disabledFocusable then there's no requirement for handlers as those events should not be propagated
            onClick: disabledFocusable ? undefined : handleClick,
            onKeyUp: disabledFocusable ? undefined : onKeyUp,
            onKeyDown: disabledFocusable ? undefined : onKeyDown
        };
    } else {
        // the role needs to be explicitly set if the href is undefined
        const isLink = !!rest.href;
        let roleOverride = isLink ? undefined : 'button';
        if (!roleOverride && isDisabled) {
            // need to set role=link explicitly for disabled links
            roleOverride = 'link';
        }
        const resultProps = {
            role: roleOverride,
            tabIndex: disabledFocusable || !isLink && !disabled ? 0 : undefined,
            ...rest,
            // If it's not a <button> than listeners are required even with disabledFocusable
            // Since you cannot assure the default behavior of the element
            // E.g: <a> will redirect on click
            onClick: handleClick,
            onKeyUp: handleKeyUp,
            onKeyDown: handleKeyDown,
            'aria-disabled': isDisabled
        };
        if (type === 'a' && isDisabled) {
            resultProps.href = undefined;
        }
        return resultProps;
    }
}

const renderAvatar_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsxs(state.root, {
        children: [
            state.initials && /*#__PURE__*/ jsx(state.initials, {}),
            state.icon && /*#__PURE__*/ jsx(state.icon, {}),
            state.image && /*#__PURE__*/ jsx(state.image, {}),
            state.badge && /*#__PURE__*/ jsx(state.badge, {}),
            state.activeAriaLabelElement
        ]
    });
};

/**
 * Regular expressions matching characters to ignore when calculating the initials.
 */ /**
 * Regular expression matching characters within various types of enclosures, including the enclosures themselves
 *  so for example, (xyz) [xyz] {xyz} all would be ignored
 */ const UNWANTED_ENCLOSURES_REGEX = /[\(\[\{][^\)\]\}]*[\)\]\}]/g;
/**
 * Regular expression matching special ASCII characters except space, plus some unicode special characters.
 * Applies after unwanted enclosures have been removed
 */ const UNWANTED_CHARS_REGEX = /[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uD800-\uFFFF]/g;
/**
 * Regular expression matching phone numbers. Applied after chars matching UNWANTED_CHARS_REGEX have been removed
 * and number has been trimmed for whitespaces
 */ const PHONENUMBER_REGEX = /^\d+[\d\s]*(:?ext|x|)\s*\d+$/i;
/** Regular expression matching one or more spaces. */ const MULTIPLE_WHITESPACES_REGEX = /\s+/g;
/**
 * Regular expression matching languages for which we currently don't support initials.
 * Arabic:   Arabic, Arabic Supplement, Arabic Extended-A.
 * Korean:   Hangul Jamo, Hangul Compatibility Jamo, Hangul Jamo Extended-A, Hangul Syllables, Hangul Jamo Extended-B.
 * Japanese: Hiragana, Katakana.
 * CJK:      CJK Unified Ideographs Extension A, CJK Unified Ideographs, CJK Compatibility Ideographs,
 *             CJK Unified Ideographs Extension B
 */ const UNSUPPORTED_TEXT_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD869][\uDC00-\uDED6]/;
function getInitialsLatin(displayName, isRtl, firstInitialOnly) {
    let initials = '';
    const splits = displayName.split(' ');
    if (splits.length !== 0) {
        initials += splits[0].charAt(0).toUpperCase();
    }
    if (!firstInitialOnly) {
        if (splits.length === 2) {
            initials += splits[1].charAt(0).toUpperCase();
        } else if (splits.length === 3) {
            initials += splits[2].charAt(0).toUpperCase();
        }
    }
    if (isRtl && initials.length > 1) {
        return initials.charAt(1) + initials.charAt(0);
    }
    return initials;
}
function cleanupDisplayName(displayName) {
    displayName = displayName.replace(UNWANTED_ENCLOSURES_REGEX, '');
    displayName = displayName.replace(UNWANTED_CHARS_REGEX, '');
    displayName = displayName.replace(MULTIPLE_WHITESPACES_REGEX, ' ');
    displayName = displayName.trim();
    return displayName;
}
/**
 * Get (up to 2 characters) initials based on display name of the persona.
 *
 * @param displayName - The full name of the person or entity
 * @param isRtl - Whether the display is in RTL
 * @param options - Extra options to control the behavior of getInitials
 *
 * @returns The 1 or 2 character initials based on the name. Or an empty string if no initials
 * could be derived from the name.
 *
 * @internal
 */ function getInitials(displayName, isRtl, options) {
    if (!displayName) {
        return '';
    }
    displayName = cleanupDisplayName(displayName);
    // For names containing CJK characters, and phone numbers, we don't display initials
    if (UNSUPPORTED_TEXT_REGEX.test(displayName) || !(options === null || options === undefined ? undefined : options.allowPhoneInitials) && PHONENUMBER_REGEX.test(displayName)) {
        return '';
    }
    return getInitialsLatin(displayName, isRtl, options === null || options === undefined ? undefined : options.firstInitialOnly);
}

/**
 * Returns the props and state required to render the component
 */ const useBadge_unstable = (props, ref)=>{
    const { shape = 'circular', size = 'medium', iconPosition = 'before', appearance = 'filled', color = 'brand' } = props;
    const state = {
        shape,
        size,
        iconPosition,
        appearance,
        color,
        components: {
            root: 'div',
            icon: 'span'
        },
        root: always(getIntrinsicElementProps('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        icon: optional(props.icon, {
            elementType: 'span'
        })
    };
    return state;
};

const badgeClassNames = {
  root: 'fui-Badge',
  icon: 'fui-Badge__icon'
};
const useRootClassName$5 = /*#__PURE__*/__resetStyles("r1l7mb74", "rntuq2r", [".r1l7mb74{display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;position:relative;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase200);height:20px;width:20px;min-width:max-content;padding:0 calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));border-radius:var(--borderRadiusCircular);border-color:var(--colorTransparentStroke);}", ".r1l7mb74::after{content:\"\";position:absolute;top:0;left:0;bottom:0;right:0;border-style:solid;border-color:inherit;border-width:var(--strokeWidthThin);border-radius:inherit;}", ".rntuq2r{display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;position:relative;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase200);height:20px;width:20px;min-width:max-content;padding:0 calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));border-radius:var(--borderRadiusCircular);border-color:var(--colorTransparentStroke);}", ".rntuq2r::after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-style:solid;border-color:inherit;border-width:var(--strokeWidthThin);border-radius:inherit;}"]);
const useRootStyles$3 = /*#__PURE__*/__styles({
  fontSmallToTiny: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fcpl73t"
  },
  tiny: {
    a9b677: "f16dn6v3",
    Bqenvij: "f3mu39s",
    Be2twd7: "f130uwy9",
    Bg96gwp: "fod1mrr",
    Bf4jedk: "f18p0k4z",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f19jm9xf"
  },
  "extra-small": {
    a9b677: "fpd43o0",
    Bqenvij: "f30q22z",
    Be2twd7: "f1tccstq",
    Bg96gwp: "f1y3arg5",
    Bf4jedk: "f18p0k4z",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f19jm9xf"
  },
  small: {
    a9b677: "fjw5fx7",
    Bqenvij: "fd461yt",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fupdldz"
  },
  medium: {},
  large: {
    a9b677: "fq4mcun",
    Bqenvij: "frvgh55",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1996nqw"
  },
  "extra-large": {
    a9b677: "f1szoe96",
    Bqenvij: "f1d2rq10",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fty64o7"
  },
  square: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1fabniw"
  },
  rounded: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5"
  },
  roundedSmallToTiny: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "fq9zq91"
  },
  circular: {},
  borderGhost: {
    ap17g6: "f10ludwy"
  },
  filled: {},
  "filled-brand": {
    De3pzq: "ffp7eso",
    sj55zd: "f1phragk"
  },
  "filled-danger": {
    De3pzq: "fdl5y0r",
    sj55zd: "f1phragk"
  },
  "filled-important": {
    De3pzq: "f1c73kur",
    sj55zd: "fr0bkrk"
  },
  "filled-informative": {
    De3pzq: "f3vzo32",
    sj55zd: "f11d4kpn"
  },
  "filled-severe": {
    De3pzq: "f1s438gw",
    sj55zd: "f1phragk"
  },
  "filled-subtle": {
    De3pzq: "fxugw4r",
    sj55zd: "f19n0e5"
  },
  "filled-success": {
    De3pzq: "flxk52p",
    sj55zd: "f1phragk"
  },
  "filled-warning": {
    De3pzq: "ffq97bm",
    sj55zd: "ff5vbop"
  },
  ghost: {},
  "ghost-brand": {
    sj55zd: "f16muhyy"
  },
  "ghost-danger": {
    sj55zd: "f1whyuy6"
  },
  "ghost-important": {
    sj55zd: "f19n0e5"
  },
  "ghost-informative": {
    sj55zd: "f11d4kpn"
  },
  "ghost-severe": {
    sj55zd: "f1l8vj45"
  },
  "ghost-subtle": {
    sj55zd: "fonrgv7"
  },
  "ghost-success": {
    sj55zd: "f1m7fhi8"
  },
  "ghost-warning": {
    sj55zd: "fpti2h4"
  },
  outline: {
    g2u3we: "f23ftbb",
    h3c5rm: ["f1gkuv52", "f1p1bl80"],
    B9xav0g: "fioka3i",
    zhjwy3: ["f1p1bl80", "f1gkuv52"]
  },
  "outline-brand": {
    sj55zd: "f16muhyy"
  },
  "outline-danger": {
    sj55zd: "f1whyuy6",
    g2u3we: "fyqpifd",
    h3c5rm: ["f3ukxca", "f1k7dugc"],
    B9xav0g: "f1njxb2b",
    zhjwy3: ["f1k7dugc", "f3ukxca"]
  },
  "outline-important": {
    sj55zd: "f11d4kpn",
    g2u3we: "fq0vr37",
    h3c5rm: ["f1byw159", "f11cr0be"],
    B9xav0g: "f1c1zstj",
    zhjwy3: ["f11cr0be", "f1byw159"]
  },
  "outline-informative": {
    sj55zd: "f11d4kpn",
    g2u3we: "f68mrw8",
    h3c5rm: ["f7pw515", "fw35ms5"],
    B9xav0g: "frpde29",
    zhjwy3: ["fw35ms5", "f7pw515"]
  },
  "outline-severe": {
    sj55zd: "f1l8vj45"
  },
  "outline-subtle": {
    sj55zd: "fonrgv7"
  },
  "outline-success": {
    sj55zd: "f1m7fhi8",
    g2u3we: "f1mmhl11",
    h3c5rm: ["f1tjpp2f", "f1ocn5n7"],
    B9xav0g: "f1gjv25d",
    zhjwy3: ["f1ocn5n7", "f1tjpp2f"]
  },
  "outline-warning": {
    sj55zd: "fpti2h4"
  },
  tint: {},
  "tint-brand": {
    De3pzq: "f16xkysk",
    sj55zd: "faj9fo0",
    g2u3we: "f161y7kd",
    h3c5rm: ["f1c8dzaj", "f1sl6hi9"],
    B9xav0g: "f1619yhw",
    zhjwy3: ["f1sl6hi9", "f1c8dzaj"]
  },
  "tint-danger": {
    De3pzq: "ff0poqj",
    sj55zd: "f1hcrxcs",
    g2u3we: "f1oqjm8o",
    h3c5rm: ["fkgrb8g", "frb5wm0"],
    B9xav0g: "f1iai1ph",
    zhjwy3: ["frb5wm0", "fkgrb8g"]
  },
  "tint-important": {
    De3pzq: "f945g0u",
    sj55zd: "fr0bkrk",
    g2u3we: "fghlq4f",
    h3c5rm: ["f1gn591s", "fjscplz"],
    B9xav0g: "fb073pr",
    zhjwy3: ["fjscplz", "f1gn591s"]
  },
  "tint-informative": {
    De3pzq: "f1ctqxl6",
    sj55zd: "f11d4kpn",
    g2u3we: "f68mrw8",
    h3c5rm: ["f7pw515", "fw35ms5"],
    B9xav0g: "frpde29",
    zhjwy3: ["fw35ms5", "f7pw515"]
  },
  "tint-severe": {
    De3pzq: "f1xzsg4",
    sj55zd: "f1k5f75o",
    g2u3we: "fxy9dsj",
    h3c5rm: ["f54u6j2", "fcm23ze"],
    B9xav0g: "f4vf0uq",
    zhjwy3: ["fcm23ze", "f54u6j2"]
  },
  "tint-subtle": {
    De3pzq: "fxugw4r",
    sj55zd: "f11d4kpn",
    g2u3we: "f68mrw8",
    h3c5rm: ["f7pw515", "fw35ms5"],
    B9xav0g: "frpde29",
    zhjwy3: ["fw35ms5", "f7pw515"]
  },
  "tint-success": {
    De3pzq: "f2vsrz6",
    sj55zd: "ffmvakt",
    g2u3we: "fdmic9h",
    h3c5rm: ["f196y6m", "fetptd8"],
    B9xav0g: "f1pev5xq",
    zhjwy3: ["fetptd8", "f196y6m"]
  },
  "tint-warning": {
    De3pzq: "f10s6hli",
    sj55zd: "f42v8de",
    g2u3we: "fn9i3n",
    h3c5rm: ["f1aw8cx4", "f51if14"],
    B9xav0g: "fvq8iai",
    zhjwy3: ["f51if14", "f1aw8cx4"]
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", ".f16dn6v3{width:6px;}", ".f3mu39s{height:6px;}", ".f130uwy9{font-size:4px;}", ".fod1mrr{line-height:4px;}", ".f18p0k4z{min-width:unset;}", [".f19jm9xf{padding:unset;}", {
    p: -1
  }], ".fpd43o0{width:10px;}", ".f30q22z{height:10px;}", ".f1tccstq{font-size:6px;}", ".f1y3arg5{line-height:6px;}", [".f19jm9xf{padding:unset;}", {
    p: -1
  }], ".fjw5fx7{width:16px;}", ".fd461yt{height:16px;}", [".fupdldz{padding:0 calc(var(--spacingHorizontalXXS) + var(--spacingHorizontalXXS));}", {
    p: -1
  }], ".fq4mcun{width:24px;}", ".frvgh55{height:24px;}", [".f1996nqw{padding:0 calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));}", {
    p: -1
  }], ".f1szoe96{width:32px;}", ".f1d2rq10{height:32px;}", [".fty64o7{padding:0 calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS));}", {
    p: -1
  }], [".f1fabniw{border-radius:var(--borderRadiusNone);}", {
    p: -1
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".fq9zq91{border-radius:var(--borderRadiusSmall);}", {
    p: -1
  }], ".f10ludwy::after{display:none;}", ".ffp7eso{background-color:var(--colorBrandBackground);}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", ".fdl5y0r{background-color:var(--colorPaletteRedBackground3);}", ".f1c73kur{background-color:var(--colorNeutralForeground1);}", ".fr0bkrk{color:var(--colorNeutralBackground1);}", ".f3vzo32{background-color:var(--colorNeutralBackground5);}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f1s438gw{background-color:var(--colorPaletteDarkOrangeBackground3);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".flxk52p{background-color:var(--colorPaletteGreenBackground3);}", ".ffq97bm{background-color:var(--colorPaletteYellowBackground3);}", ".ff5vbop{color:var(--colorNeutralForeground1Static);}", ".f16muhyy{color:var(--colorBrandForeground1);}", ".f1whyuy6{color:var(--colorPaletteRedForeground3);}", ".f1l8vj45{color:var(--colorPaletteDarkOrangeForeground3);}", ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}", ".f1m7fhi8{color:var(--colorPaletteGreenForeground3);}", ".fpti2h4{color:var(--colorPaletteYellowForeground2);}", ".f23ftbb{border-top-color:currentColor;}", ".f1gkuv52{border-right-color:currentColor;}", ".f1p1bl80{border-left-color:currentColor;}", ".fioka3i{border-bottom-color:currentColor;}", ".fyqpifd{border-top-color:var(--colorPaletteRedBorder2);}", ".f3ukxca{border-right-color:var(--colorPaletteRedBorder2);}", ".f1k7dugc{border-left-color:var(--colorPaletteRedBorder2);}", ".f1njxb2b{border-bottom-color:var(--colorPaletteRedBorder2);}", ".fq0vr37{border-top-color:var(--colorNeutralStrokeAccessible);}", ".f1byw159{border-right-color:var(--colorNeutralStrokeAccessible);}", ".f11cr0be{border-left-color:var(--colorNeutralStrokeAccessible);}", ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}", ".f68mrw8{border-top-color:var(--colorNeutralStroke2);}", ".f7pw515{border-right-color:var(--colorNeutralStroke2);}", ".fw35ms5{border-left-color:var(--colorNeutralStroke2);}", ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}", ".f1mmhl11{border-top-color:var(--colorPaletteGreenBorder2);}", ".f1tjpp2f{border-right-color:var(--colorPaletteGreenBorder2);}", ".f1ocn5n7{border-left-color:var(--colorPaletteGreenBorder2);}", ".f1gjv25d{border-bottom-color:var(--colorPaletteGreenBorder2);}", ".f16xkysk{background-color:var(--colorBrandBackground2);}", ".faj9fo0{color:var(--colorBrandForeground2);}", ".f161y7kd{border-top-color:var(--colorBrandStroke2);}", ".f1c8dzaj{border-right-color:var(--colorBrandStroke2);}", ".f1sl6hi9{border-left-color:var(--colorBrandStroke2);}", ".f1619yhw{border-bottom-color:var(--colorBrandStroke2);}", ".ff0poqj{background-color:var(--colorPaletteRedBackground1);}", ".f1hcrxcs{color:var(--colorPaletteRedForeground1);}", ".f1oqjm8o{border-top-color:var(--colorPaletteRedBorder1);}", ".fkgrb8g{border-right-color:var(--colorPaletteRedBorder1);}", ".frb5wm0{border-left-color:var(--colorPaletteRedBorder1);}", ".f1iai1ph{border-bottom-color:var(--colorPaletteRedBorder1);}", ".f945g0u{background-color:var(--colorNeutralForeground3);}", ".fghlq4f{border-top-color:var(--colorTransparentStroke);}", ".f1gn591s{border-right-color:var(--colorTransparentStroke);}", ".fjscplz{border-left-color:var(--colorTransparentStroke);}", ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}", ".f1ctqxl6{background-color:var(--colorNeutralBackground4);}", ".f1xzsg4{background-color:var(--colorPaletteDarkOrangeBackground1);}", ".f1k5f75o{color:var(--colorPaletteDarkOrangeForeground1);}", ".fxy9dsj{border-top-color:var(--colorPaletteDarkOrangeBorder1);}", ".f54u6j2{border-right-color:var(--colorPaletteDarkOrangeBorder1);}", ".fcm23ze{border-left-color:var(--colorPaletteDarkOrangeBorder1);}", ".f4vf0uq{border-bottom-color:var(--colorPaletteDarkOrangeBorder1);}", ".f2vsrz6{background-color:var(--colorPaletteGreenBackground1);}", ".ffmvakt{color:var(--colorPaletteGreenForeground1);}", ".fdmic9h{border-top-color:var(--colorPaletteGreenBorder1);}", ".f196y6m{border-right-color:var(--colorPaletteGreenBorder1);}", ".fetptd8{border-left-color:var(--colorPaletteGreenBorder1);}", ".f1pev5xq{border-bottom-color:var(--colorPaletteGreenBorder1);}", ".f10s6hli{background-color:var(--colorPaletteYellowBackground1);}", ".f42v8de{color:var(--colorPaletteYellowForeground1);}", ".fn9i3n{border-top-color:var(--colorPaletteYellowBorder1);}", ".f1aw8cx4{border-right-color:var(--colorPaletteYellowBorder1);}", ".f51if14{border-left-color:var(--colorPaletteYellowBorder1);}", ".fvq8iai{border-bottom-color:var(--colorPaletteYellowBorder1);}"]
});
const useIconRootClassName = /*#__PURE__*/__resetStyles("rttl5z0", null, [".rttl5z0{display:flex;line-height:1;margin:0 calc(-1 * var(--spacingHorizontalXXS));font-size:12px;}"]);
const useIconStyles$1 = /*#__PURE__*/__styles({
  beforeText: {
    t21cq0: ["f1t8l4o1", "f11juvx6"]
  },
  afterText: {
    Frg6f3: ["f11juvx6", "f1t8l4o1"]
  },
  beforeTextXL: {
    t21cq0: ["f1rs9grm", "f1kwmkpi"]
  },
  afterTextXL: {
    Frg6f3: ["f1kwmkpi", "f1rs9grm"]
  },
  tiny: {
    Be2twd7: "f1tccstq"
  },
  "extra-small": {
    Be2twd7: "fnmn6fi"
  },
  small: {
    Be2twd7: "f1ugzwwg"
  },
  medium: {},
  large: {
    Be2twd7: "f4ybsrx"
  },
  "extra-large": {
    Be2twd7: "fe5j1ua"
  }
}, {
  d: [".f1t8l4o1{margin-right:calc(var(--spacingHorizontalXXS) + var(--spacingHorizontalXXS));}", ".f11juvx6{margin-left:calc(var(--spacingHorizontalXXS) + var(--spacingHorizontalXXS));}", ".f1rs9grm{margin-right:calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));}", ".f1kwmkpi{margin-left:calc(var(--spacingHorizontalXS) + var(--spacingHorizontalXXS));}", ".f1tccstq{font-size:6px;}", ".fnmn6fi{font-size:10px;}", ".f1ugzwwg{font-size:12px;}", ".f4ybsrx{font-size:16px;}", ".fe5j1ua{font-size:20px;}"]
});
/**
 * Applies style classnames to slots
 */
const useBadgeStyles_unstable = state => {
  'use no memo';

  const rootClassName = useRootClassName$5();
  const rootStyles = useRootStyles$3();
  const smallToTiny = state.size === 'small' || state.size === 'extra-small' || state.size === 'tiny';
  state.root.className = mergeClasses(badgeClassNames.root, rootClassName, smallToTiny && rootStyles.fontSmallToTiny, rootStyles[state.size], rootStyles[state.shape], state.shape === 'rounded' && smallToTiny && rootStyles.roundedSmallToTiny, state.appearance === 'ghost' && rootStyles.borderGhost, rootStyles[state.appearance], rootStyles[`${state.appearance}-${state.color}`], state.root.className);
  const iconRootClassName = useIconRootClassName();
  const iconStyles = useIconStyles$1();
  if (state.icon) {
    let iconPositionClass;
    if (state.root.children) {
      if (state.size === 'extra-large') {
        iconPositionClass = state.iconPosition === 'after' ? iconStyles.afterTextXL : iconStyles.beforeTextXL;
      } else {
        iconPositionClass = state.iconPosition === 'after' ? iconStyles.afterText : iconStyles.beforeText;
      }
    }
    state.icon.className = mergeClasses(badgeClassNames.icon, iconRootClassName, iconPositionClass, iconStyles[state.size], state.icon.className);
  }
  return state;
};

const renderBadge_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsxs(state.root, {
        children: [
            state.iconPosition === 'before' && state.icon && /*#__PURE__*/ jsx(state.icon, {}),
            state.root.children,
            state.iconPosition === 'after' && state.icon && /*#__PURE__*/ jsx(state.icon, {})
        ]
    });
};

/**
 * Define a styled Badge, using the `useBadge_unstable` hook.
 */ const Badge = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useBadge_unstable(props, ref);
    useBadgeStyles_unstable(state);
    useCustomStyleHook$1('useBadgeStyles_unstable')(state);
    return renderBadge_unstable(state);
});
Badge.displayName = 'Badge';

const presenceAwayFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceAway10Filled,
    'extra-small': PresenceAway10Filled,
    small: PresenceAway12Filled,
    medium: PresenceAway16Filled,
    large: PresenceAway20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceAway20Filled
};
const presenceAvailableRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceAvailable10Regular,
    'extra-small': PresenceAvailable10Regular,
    small: PresenceAvailable12Regular,
    medium: PresenceAvailable16Regular,
    large: PresenceAvailable20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceAvailable20Regular
};
const presenceAvailableFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceAvailable10Filled,
    'extra-small': PresenceAvailable10Filled,
    small: PresenceAvailable12Filled,
    medium: PresenceAvailable16Filled,
    large: PresenceAvailable20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceAvailable20Filled
};
const presenceBlockedRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceBlocked10Regular,
    'extra-small': PresenceBlocked10Regular,
    small: PresenceBlocked12Regular,
    medium: PresenceBlocked16Regular,
    large: PresenceBlocked20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceBlocked20Regular
};
const presenceBusyFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceBusy10Filled,
    'extra-small': PresenceBusy10Filled,
    small: PresenceBusy12Filled,
    medium: PresenceBusy16Filled,
    large: PresenceBusy20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceBusy20Filled
};
const presenceDndFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceDnd10Filled,
    'extra-small': PresenceDnd10Filled,
    small: PresenceDnd12Filled,
    medium: PresenceDnd16Filled,
    large: PresenceDnd20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceDnd20Filled
};
const presenceDndRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceDnd10Regular,
    'extra-small': PresenceDnd10Regular,
    small: PresenceDnd12Regular,
    medium: PresenceDnd16Regular,
    large: PresenceDnd20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceDnd20Regular
};
const presenceOofRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceOof10Regular,
    'extra-small': PresenceOof10Regular,
    small: PresenceOof12Regular,
    medium: PresenceOof16Regular,
    large: PresenceOof20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceOof20Regular
};
const presenceOfflineRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceOffline10Regular,
    'extra-small': PresenceOffline10Regular,
    small: PresenceOffline12Regular,
    medium: PresenceOffline16Regular,
    large: PresenceOffline20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceOffline20Regular
};
const presenceUnknownRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: PresenceUnknown10Regular,
    'extra-small': PresenceUnknown10Regular,
    small: PresenceUnknown12Regular,
    medium: PresenceUnknown16Regular,
    large: PresenceUnknown20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': PresenceUnknown20Regular
};

const iconMap$1 = (status, outOfOffice, size)=>{
    switch(status){
        case 'available':
            return outOfOffice ? presenceAvailableRegular[size] : presenceAvailableFilled[size];
        case 'away':
            return outOfOffice ? presenceOofRegular[size] : presenceAwayFilled[size];
        case 'blocked':
            return presenceBlockedRegular[size];
        case 'busy':
            return outOfOffice ? presenceUnknownRegular[size] : presenceBusyFilled[size];
        case 'do-not-disturb':
            return outOfOffice ? presenceDndRegular[size] : presenceDndFilled[size];
        case 'offline':
            return outOfOffice ? presenceOofRegular[size] : presenceOfflineRegular[size];
        case 'out-of-office':
            return presenceOofRegular[size];
        case 'unknown':
            return presenceUnknownRegular[size];
    }
};
const DEFAULT_STRINGS$1 = {
    busy: 'busy',
    'out-of-office': 'out of office',
    away: 'away',
    available: 'available',
    offline: 'offline',
    'do-not-disturb': 'do not disturb',
    unknown: 'unknown',
    blocked: 'blocked'
};
/**
 * Returns the props and state required to render the component
 */ const usePresenceBadge_unstable = (props, ref)=>{
    const { size = 'medium', status = 'available', outOfOffice = false } = props;
    const statusText = DEFAULT_STRINGS$1[status];
    const oofText = props.outOfOffice && props.status !== 'out-of-office' ? ` ${DEFAULT_STRINGS$1['out-of-office']}` : '';
    const IconElement = iconMap$1(status, outOfOffice, size);
    const state = {
        ...useBadge_unstable({
            'aria-label': statusText + oofText,
            role: 'img',
            ...props,
            size,
            icon: optional(props.icon, {
                defaultProps: {
                    children: IconElement ? /*#__PURE__*/ React.createElement(IconElement, null) : null
                },
                renderByDefault: true,
                elementType: 'span'
            })
        }, ref),
        status,
        outOfOffice
    };
    return state;
};

const presenceBadgeClassNames = {
  root: 'fui-PresenceBadge',
  icon: 'fui-PresenceBadge__icon'
};
const getIsBusy = status => {
  if (status === 'busy' || status === 'do-not-disturb' || status === 'blocked') {
    return true;
  }
  return false;
};
const useRootClassName$4 = /*#__PURE__*/__resetStyles("r832ydo", null, [".r832ydo{display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;border-radius:var(--borderRadiusCircular);background-color:var(--colorNeutralBackground1);padding:1px;background-clip:content-box;}"]);
const useIconClassName = /*#__PURE__*/__resetStyles("r11ag4qr", null, [".r11ag4qr{display:flex;margin:-1px;}"]);
const useStyles$F = /*#__PURE__*/__styles({
  statusBusy: {
    sj55zd: "fvi85wt"
  },
  statusAway: {
    sj55zd: "f14k8a89"
  },
  statusAvailable: {
    sj55zd: "fqa5hgp"
  },
  statusOffline: {
    sj55zd: "f11d4kpn"
  },
  statusOutOfOffice: {
    sj55zd: "fdce8r3"
  },
  statusUnknown: {
    sj55zd: "f11d4kpn"
  },
  outOfOffice: {
    sj55zd: "fr0bkrk"
  },
  outOfOfficeAvailable: {
    sj55zd: "fqa5hgp"
  },
  outOfOfficeBusy: {
    sj55zd: "fvi85wt"
  },
  outOfOfficeUnknown: {
    sj55zd: "f11d4kpn"
  },
  tiny: {
    Bubjx69: "f9ikmtg",
    a9b677: "f16dn6v3",
    B2eet1l: "f1w2irj7",
    B5pe6w7: "fab5kbq",
    p4uzdd: "f1ms1d91"
  },
  large: {
    Bubjx69: "f9ikmtg",
    a9b677: "f64fuq3",
    B5pe6w7: "f1vfi1yj",
    p4uzdd: "f15s34gz"
  },
  extraLarge: {
    Bubjx69: "f9ikmtg",
    a9b677: "f1w9dchk",
    B5pe6w7: "f14efy9b",
    p4uzdd: "fhipgdu"
  }
}, {
  d: [".fvi85wt{color:var(--colorPaletteRedBackground3);}", ".f14k8a89{color:var(--colorPaletteMarigoldBackground3);}", ".fqa5hgp{color:var(--colorPaletteLightGreenForeground3);}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".fdce8r3{color:var(--colorPaletteBerryForeground3);}", ".fr0bkrk{color:var(--colorNeutralBackground1);}", ".f9ikmtg{aspect-ratio:1;}", ".f16dn6v3{width:6px;}", ".f1w2irj7{background-clip:unset;}", ".fab5kbq svg{width:6px!important;}", ".f1ms1d91 svg{height:6px!important;}", ".f64fuq3{width:20px;}", ".f1vfi1yj svg{width:20px!important;}", ".f15s34gz svg{height:20px!important;}", ".f1w9dchk{width:28px;}", ".f14efy9b svg{width:28px!important;}", ".fhipgdu svg{height:28px!important;}"]
});
/**
 * Applies style classnames to slots
 */
const usePresenceBadgeStyles_unstable = state => {
  'use no memo';

  const rootClassName = useRootClassName$4();
  const iconClassName = useIconClassName();
  const styles = useStyles$F();
  const isBusy = getIsBusy(state.status);
  state.root.className = mergeClasses(presenceBadgeClassNames.root, rootClassName, isBusy && styles.statusBusy, state.status === 'away' && styles.statusAway, state.status === 'available' && styles.statusAvailable, state.status === 'offline' && styles.statusOffline, state.status === 'out-of-office' && styles.statusOutOfOffice, state.status === 'unknown' && styles.statusUnknown, state.outOfOffice && styles.outOfOffice, state.outOfOffice && state.status === 'available' && styles.outOfOfficeAvailable, state.outOfOffice && isBusy && styles.outOfOfficeBusy, state.outOfOffice && (state.status === 'out-of-office' || state.status === 'away' || state.status === 'offline') && styles.statusOutOfOffice, state.outOfOffice && state.status === 'unknown' && styles.outOfOfficeUnknown, state.size === 'tiny' && styles.tiny, state.size === 'large' && styles.large, state.size === 'extra-large' && styles.extraLarge, state.root.className);
  if (state.icon) {
    state.icon.className = mergeClasses(presenceBadgeClassNames.icon, iconClassName, state.icon.className);
  }
  return state;
};

/**
 * Define a styled Badge, using the `useBadge_unstable` hook.
 */ const PresenceBadge = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = usePresenceBadge_unstable(props, ref);
    usePresenceBadgeStyles_unstable(state);
    useCustomStyleHook$1('usePresenceBadgeStyles_unstable')(state);
    return renderBadge_unstable(state);
});
PresenceBadge.displayName = 'PresenceBadge';

const avatarContext = React.createContext(undefined);
const avatarContextDefaultValue = {};
/**
 * @internal
 */ avatarContext.Provider;
/**
 * @internal
 */ const useAvatarContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(avatarContext)) !== null && _React_useContext !== undefined ? _React_useContext : avatarContextDefaultValue;
};

const DEFAULT_STRINGS = {
    active: 'active',
    inactive: 'inactive'
};
const useAvatar_unstable = (props, ref)=>{
    const { dir } = useFluent();
    const { shape: contextShape, size: contextSize } = useAvatarContext();
    const { name, size = contextSize !== null && contextSize !== undefined ? contextSize : 32, shape = contextShape !== null && contextShape !== undefined ? contextShape : 'circular', active = 'unset', activeAppearance = 'ring', idForColor } = props;
    let { color = 'neutral' } = props;
    // Resolve 'colorful' to a specific color name
    if (color === 'colorful') {
        var _ref;
        color = avatarColors[getHashCode((_ref = idForColor !== null && idForColor !== undefined ? idForColor : name) !== null && _ref !== undefined ? _ref : '') % avatarColors.length];
    }
    const baseId = useId('avatar-');
    const root = always(getIntrinsicElementProps('span', {
        role: 'img',
        id: baseId,
        // aria-label and/or aria-labelledby are resolved below
        ...props,
        ref
    }, /* excludedPropNames: */ [
        'name'
    ]), {
        elementType: 'span'
    });
    const [imageHidden, setImageHidden] = React.useState(undefined);
    let image = optional(props.image, {
        defaultProps: {
            alt: '',
            role: 'presentation',
            'aria-hidden': true,
            hidden: imageHidden
        },
        elementType: 'img'
    }); // Image shouldn't be rendered if its src is not set
    if (!(image === null || image === undefined ? undefined : image.src)) {
        image = undefined;
    } // Hide the image if it fails to load and restore it on a successful load
    if (image) {
        image.onError = mergeCallbacks(image.onError, ()=>setImageHidden(true));
        image.onLoad = mergeCallbacks(image.onLoad, ()=>setImageHidden(undefined));
    } // Resolve the initials slot, defaulted to getInitials.
    let initials = optional(props.initials, {
        renderByDefault: true,
        defaultProps: {
            children: getInitials(name, dir === 'rtl', {
                firstInitialOnly: size <= 16
            }),
            id: baseId + '__initials'
        },
        elementType: 'span'
    }); // Don't render the initials slot if it's empty
    if (!(initials === null || initials === undefined ? undefined : initials.children)) {
        initials = undefined;
    } // Render the icon slot *only if* there aren't any initials or image to display
    let icon = undefined;
    if (!initials && (!image || imageHidden)) {
        icon = optional(props.icon, {
            renderByDefault: true,
            defaultProps: {
                children: /*#__PURE__*/ React.createElement(PersonRegular, null),
                'aria-hidden': true
            },
            elementType: 'span'
        });
    }
    const badge = optional(props.badge, {
        defaultProps: {
            size: getBadgeSize(size),
            id: baseId + '__badge'
        },
        elementType: PresenceBadge
    });
    let activeAriaLabelElement; // Resolve aria-label and/or aria-labelledby if not provided by the user
    if (!root['aria-label'] && !root['aria-labelledby']) {
        if (name) {
            root['aria-label'] = name; // Include the badge in labelledby if it exists
            if (badge) {
                root['aria-labelledby'] = root.id + ' ' + badge.id;
            }
        } else if (initials) {
            // root's aria-label should be the name, but fall back to being labelledby the initials if name is missing
            root['aria-labelledby'] = initials.id + (badge ? ' ' + badge.id : '');
        } // Add the active state to the aria label
        if (active === 'active' || active === 'inactive') {
            const activeText = DEFAULT_STRINGS[active];
            if (root['aria-labelledby']) {
                // If using aria-labelledby, render a hidden span and append it to the labelledby
                const activeId = baseId + '__active';
                root['aria-labelledby'] += ' ' + activeId;
                activeAriaLabelElement = /*#__PURE__*/ React.createElement("span", {
                    hidden: true,
                    id: activeId
                }, activeText);
            } else if (root['aria-label']) {
                // Otherwise, just append it to the aria-label
                root['aria-label'] += ' ' + activeText;
            }
        }
    }
    return {
        size,
        shape,
        active,
        activeAppearance,
        activeAriaLabelElement,
        color,
        components: {
            root: 'span',
            initials: 'span',
            icon: 'span',
            image: 'img',
            badge: PresenceBadge
        },
        root,
        initials,
        icon,
        image,
        badge
    };
};
const getBadgeSize = (size)=>{
    if (size >= 96) {
        return 'extra-large';
    } else if (size >= 64) {
        return 'large';
    } else if (size >= 56) {
        return 'medium';
    } else if (size >= 40) {
        return 'small';
    } else if (size >= 28) {
        return 'extra-small';
    } else {
        return 'tiny';
    }
};
const avatarColors = [
    'dark-red',
    'cranberry',
    'red',
    'pumpkin',
    'peach',
    'marigold',
    'gold',
    'brass',
    'brown',
    'forest',
    'seafoam',
    'dark-green',
    'light-teal',
    'teal',
    'steel',
    'blue',
    'royal-blue',
    'cornflower',
    'navy',
    'lavender',
    'purple',
    'grape',
    'lilac',
    'pink',
    'magenta',
    'plum',
    'beige',
    'mink',
    'platinum',
    'anchor'
];
const getHashCode = (str)=>{
    let hashCode = 0;
    for(let len = str.length - 1; len >= 0; len--){
        const ch = str.charCodeAt(len);
        const shift = len % 8;
        hashCode ^= (ch << shift) + (ch >> 8 - shift); // eslint-disable-line no-bitwise
    }
    return hashCode;
};

const avatarClassNames = {
  root: 'fui-Avatar',
  image: 'fui-Avatar__image',
  initials: 'fui-Avatar__initials',
  icon: 'fui-Avatar__icon',
  badge: 'fui-Avatar__badge'
};
const useRootClassName$3 = /*#__PURE__*/__resetStyles("r81b29z", "r1aatmv", {
  r: [".r81b29z{display:inline-block;flex-shrink:0;position:relative;vertical-align:middle;border-radius:var(--borderRadiusCircular);font-family:var(--fontFamilyBase);font-weight:var(--fontWeightSemibold);font-size:var(--fontSizeBase300);width:32px;height:32px;}", ".r81b29z::before,.r81b29z::after{position:absolute;top:0;left:0;bottom:0;right:0;z-index:-1;margin:calc(-2 * var(--fui-Avatar-ringWidth, 0px));border-radius:inherit;transition-property:margin,opacity;transition-timing-function:var(--curveEasyEaseMax),var(--curveLinear);transition-duration:var(--durationUltraSlow),var(--durationSlower);}", ".r81b29z::before{border-style:solid;border-width:var(--fui-Avatar-ringWidth);}", ".r1aatmv{display:inline-block;flex-shrink:0;position:relative;vertical-align:middle;border-radius:var(--borderRadiusCircular);font-family:var(--fontFamilyBase);font-weight:var(--fontWeightSemibold);font-size:var(--fontSizeBase300);width:32px;height:32px;}", ".r1aatmv::before,.r1aatmv::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;margin:calc(-2 * var(--fui-Avatar-ringWidth, 0px));border-radius:inherit;transition-property:margin,opacity;transition-timing-function:var(--curveEasyEaseMax),var(--curveLinear);transition-duration:var(--durationUltraSlow),var(--durationSlower);}", ".r1aatmv::before{border-style:solid;border-width:var(--fui-Avatar-ringWidth);}"],
  s: ["@media screen and (prefers-reduced-motion: reduce){.r81b29z::before,.r81b29z::after{transition-duration:0.01ms;}}", "@media screen and (prefers-reduced-motion: reduce){.r1aatmv::before,.r1aatmv::after{transition-duration:0.01ms;}}"]
});
const useImageClassName = /*#__PURE__*/__resetStyles("r136dc0n", "rjly0nl", [".r136dc0n{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;object-fit:cover;vertical-align:top;}", ".rjly0nl{position:absolute;top:0;right:0;width:100%;height:100%;border-radius:inherit;object-fit:cover;vertical-align:top;}"]);
const useIconInitialsClassName = /*#__PURE__*/__resetStyles("rip04v", "r31uzil", [".rip04v{position:absolute;box-sizing:border-box;top:0;left:0;width:100%;height:100%;line-height:1;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);display:flex;align-items:center;justify-content:center;vertical-align:center;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:inherit;}", ".r31uzil{position:absolute;box-sizing:border-box;top:0;right:0;width:100%;height:100%;line-height:1;border:var(--strokeWidthThin) solid var(--colorTransparentStroke);display:flex;align-items:center;justify-content:center;vertical-align:center;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:inherit;}"]);
const useStyles$E = /*#__PURE__*/__styles({
  textCaption2Strong: {
    Be2twd7: "f13mqy1h"
  },
  textCaption1Strong: {
    Be2twd7: "fy9rknc"
  },
  textSubtitle2: {
    Be2twd7: "fod5ikn"
  },
  textSubtitle1: {
    Be2twd7: "f1pp30po"
  },
  textTitle3: {
    Be2twd7: "f1x0m3f5"
  },
  squareSmall: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "fq9zq91"
  },
  squareMedium: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5"
  },
  squareLarge: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1o0qvyv"
  },
  squareXLarge: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1kijzfu"
  },
  activeOrInactive: {
    Bz10aip: "ftfx35i",
    Bmy1vo4: "fv0atk9",
    B3o57yi: "f1iry5bo",
    Bkqvd7p: "f15n41j8",
    Hwfdqs: "f1onx1g3"
  },
  ring: {
    Ftih45: "f1wl9k8s"
  },
  ringBadgeCutout: {
    f4a502: "fp2gujx"
  },
  ringThick: {
    of393c: "fq1w1vq"
  },
  ringThicker: {
    of393c: "fzg6ace"
  },
  ringThickest: {
    of393c: "f1nu8p71"
  },
  shadow: {
    Bsft5z2: "f13zj6fq"
  },
  shadow4: {
    Be6vj1x: "fcjn15l"
  },
  shadow8: {
    Be6vj1x: "f1tm8t9f"
  },
  shadow16: {
    Be6vj1x: "f1a1aohj"
  },
  shadow28: {
    Be6vj1x: "fond6v5"
  },
  inactive: {
    abs64n: "fp25eh",
    Bz10aip: "f1clczzi",
    Bkqvd7p: "f1l3s34x",
    Bfgortx: 0,
    Bnvr3x9: 0,
    b2tv09: 0,
    Bucmhp4: 0,
    iayac2: "flkahu5",
    b6ubon: "fw457kn",
    Bqinb2h: "f1wmllxl"
  },
  badge: {
    qhf8xq: "f1euv43f",
    B5kzvoi: "f1yab3r1",
    j35jbq: ["f1e31b4d", "f1vgc2s3"]
  },
  badgeCutout: {
    btxmck: "f1eugkqs"
  },
  badgeAlign: {
    Dnlfbu: ["f1tlnv9o", "f1y9kyih"]
  },
  tiny: {
    Bdjeniz: "f1uwoubl",
    niu6jh: "fid048z"
  },
  "extra-small": {
    Bdjeniz: "f13ar0e0",
    niu6jh: "fid048z"
  },
  small: {
    Bdjeniz: "fwwuruf",
    niu6jh: "fid048z"
  },
  medium: {
    Bdjeniz: "f1af27q5",
    niu6jh: "fid048z"
  },
  large: {
    Bdjeniz: "f18yy57a",
    niu6jh: "f924bxt"
  },
  "extra-large": {
    Bdjeniz: "f2jg042",
    niu6jh: "f924bxt"
  },
  icon12: {
    Be2twd7: "f1ugzwwg"
  },
  icon16: {
    Be2twd7: "f4ybsrx"
  },
  icon20: {
    Be2twd7: "fe5j1ua"
  },
  icon24: {
    Be2twd7: "f1rt2boy"
  },
  icon28: {
    Be2twd7: "f24l1pt"
  },
  icon32: {
    Be2twd7: "ffl51b"
  },
  icon48: {
    Be2twd7: "f18m8u13"
  }
}, {
  d: [".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".f1pp30po{font-size:var(--fontSizeBase500);}", ".f1x0m3f5{font-size:var(--fontSizeBase600);}", [".fq9zq91{border-radius:var(--borderRadiusSmall);}", {
    p: -1
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".f1o0qvyv{border-radius:var(--borderRadiusLarge);}", {
    p: -1
  }], [".f1kijzfu{border-radius:var(--borderRadiusXLarge);}", {
    p: -1
  }], ".ftfx35i{transform:perspective(1px);}", ".fv0atk9{transition-property:transform,opacity;}", ".f1iry5bo{transition-duration:var(--durationUltraSlow),var(--durationFaster);}", ".f15n41j8{transition-timing-function:var(--curveEasyEaseMax),var(--curveLinear);}", ".f1wl9k8s::before{content:\"\";}", ".fp2gujx::before{-webkit-mask-image:radial-gradient(circle at bottom calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)) var(--fui-Avatar-badgeAlign) calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));mask-image:radial-gradient(circle at bottom calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)) var(--fui-Avatar-badgeAlign) calc(var(--fui-Avatar-badgeRadius) + 2 * var(--fui-Avatar-ringWidth)), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));}", ".fq1w1vq{--fui-Avatar-ringWidth:var(--strokeWidthThick);}", ".fzg6ace{--fui-Avatar-ringWidth:var(--strokeWidthThicker);}", ".f1nu8p71{--fui-Avatar-ringWidth:var(--strokeWidthThickest);}", ".f13zj6fq::after{content:\"\";}", ".fcjn15l::after{box-shadow:var(--shadow4);}", ".f1tm8t9f::after{box-shadow:var(--shadow8);}", ".f1a1aohj::after{box-shadow:var(--shadow16);}", ".fond6v5::after{box-shadow:var(--shadow28);}", ".fp25eh{opacity:0.8;}", ".f1clczzi{transform:scale(0.875);}", ".f1l3s34x{transition-timing-function:var(--curveDecelerateMin),var(--curveLinear);}", [".flkahu5::before,.flkahu5::after{margin:0;}", {
    p: -1
  }], ".fw457kn::before,.fw457kn::after{opacity:0;}", ".f1wmllxl::before,.f1wmllxl::after{transition-timing-function:var(--curveDecelerateMin),var(--curveLinear);}", ".f1euv43f{position:absolute;}", ".f1yab3r1{bottom:0;}", ".f1e31b4d{right:0;}", ".f1vgc2s3{left:0;}", ".f1eugkqs{-webkit-mask-image:radial-gradient(circle at bottom var(--fui-Avatar-badgeRadius) var(--fui-Avatar-badgeAlign) var(--fui-Avatar-badgeRadius), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));mask-image:radial-gradient(circle at bottom var(--fui-Avatar-badgeRadius) var(--fui-Avatar-badgeAlign) var(--fui-Avatar-badgeRadius), transparent calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) - 0.25px), white calc(var(--fui-Avatar-badgeRadius) + var(--fui-Avatar-badgeGap) + 0.25px));}", ".f1tlnv9o{--fui-Avatar-badgeAlign:right;}", ".f1y9kyih{--fui-Avatar-badgeAlign:left;}", ".f1uwoubl{--fui-Avatar-badgeRadius:3px;}", ".fid048z{--fui-Avatar-badgeGap:var(--strokeWidthThin);}", ".f13ar0e0{--fui-Avatar-badgeRadius:5px;}", ".fwwuruf{--fui-Avatar-badgeRadius:6px;}", ".f1af27q5{--fui-Avatar-badgeRadius:8px;}", ".f18yy57a{--fui-Avatar-badgeRadius:10px;}", ".f924bxt{--fui-Avatar-badgeGap:var(--strokeWidthThick);}", ".f2jg042{--fui-Avatar-badgeRadius:14px;}", ".f1ugzwwg{font-size:12px;}", ".f4ybsrx{font-size:16px;}", ".fe5j1ua{font-size:20px;}", ".f1rt2boy{font-size:24px;}", ".f24l1pt{font-size:28px;}", ".ffl51b{font-size:32px;}", ".f18m8u13{font-size:48px;}"],
  m: [["@media screen and (prefers-reduced-motion: reduce){.f1onx1g3{transition-duration:0.01ms;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }]]
});
const useSizeStyles = /*#__PURE__*/__styles({
  "16": {
    a9b677: "fjw5fx7",
    Bqenvij: "fd461yt"
  },
  "20": {
    a9b677: "f64fuq3",
    Bqenvij: "fjamq6b"
  },
  "24": {
    a9b677: "fq4mcun",
    Bqenvij: "frvgh55"
  },
  "28": {
    a9b677: "f1w9dchk",
    Bqenvij: "fxldao9"
  },
  "32": {
    a9b677: "f1szoe96",
    Bqenvij: "f1d2rq10"
  },
  "36": {
    a9b677: "fpdz1er",
    Bqenvij: "f8ljn23"
  },
  "40": {
    a9b677: "feqmc2u",
    Bqenvij: "fbhnoac"
  },
  "48": {
    a9b677: "f124akge",
    Bqenvij: "ff2sm71"
  },
  "56": {
    a9b677: "f1u66zr1",
    Bqenvij: "fzki0ko"
  },
  "64": {
    a9b677: "fa9ln6p",
    Bqenvij: "f16k9i2m"
  },
  "72": {
    a9b677: "fhcae8x",
    Bqenvij: "f1shusfg"
  },
  "96": {
    a9b677: "f1kyr2gn",
    Bqenvij: "fypu0ge"
  },
  "120": {
    a9b677: "fwfqyga",
    Bqenvij: "fjr5b71"
  },
  "128": {
    a9b677: "f1iksgmy",
    Bqenvij: "fele2au"
  }
}, {
  d: [".fjw5fx7{width:16px;}", ".fd461yt{height:16px;}", ".f64fuq3{width:20px;}", ".fjamq6b{height:20px;}", ".fq4mcun{width:24px;}", ".frvgh55{height:24px;}", ".f1w9dchk{width:28px;}", ".fxldao9{height:28px;}", ".f1szoe96{width:32px;}", ".f1d2rq10{height:32px;}", ".fpdz1er{width:36px;}", ".f8ljn23{height:36px;}", ".feqmc2u{width:40px;}", ".fbhnoac{height:40px;}", ".f124akge{width:48px;}", ".ff2sm71{height:48px;}", ".f1u66zr1{width:56px;}", ".fzki0ko{height:56px;}", ".fa9ln6p{width:64px;}", ".f16k9i2m{height:64px;}", ".fhcae8x{width:72px;}", ".f1shusfg{height:72px;}", ".f1kyr2gn{width:96px;}", ".fypu0ge{height:96px;}", ".fwfqyga{width:120px;}", ".fjr5b71{height:120px;}", ".f1iksgmy{width:128px;}", ".fele2au{height:128px;}"]
});
const useColorStyles = /*#__PURE__*/__styles({
  neutral: {
    sj55zd: "f11d4kpn",
    De3pzq: "f18f03hv"
  },
  brand: {
    sj55zd: "fonrgv7",
    De3pzq: "f1blnnmj"
  },
  "dark-red": {
    sj55zd: "fqjd1y1",
    De3pzq: "f1vq2oo4"
  },
  cranberry: {
    sj55zd: "fg9gses",
    De3pzq: "f1lwxszt"
  },
  red: {
    sj55zd: "f23f7i0",
    De3pzq: "f1q9qhfq"
  },
  pumpkin: {
    sj55zd: "fjnan08",
    De3pzq: "fz91bi3"
  },
  peach: {
    sj55zd: "fknu15p",
    De3pzq: "f1b9nr51"
  },
  marigold: {
    sj55zd: "f9603vw",
    De3pzq: "f3z4w6d"
  },
  gold: {
    sj55zd: "fmq0uwp",
    De3pzq: "fg50kya"
  },
  brass: {
    sj55zd: "f28g5vo",
    De3pzq: "f4w2gd0"
  },
  brown: {
    sj55zd: "ftl572b",
    De3pzq: "f14wu1f4"
  },
  forest: {
    sj55zd: "f1gymlvd",
    De3pzq: "f19ut4y6"
  },
  seafoam: {
    sj55zd: "fnnb6wn",
    De3pzq: "f1n057jc"
  },
  "dark-green": {
    sj55zd: "ff58qw8",
    De3pzq: "f11t05wk"
  },
  "light-teal": {
    sj55zd: "f1up9qbj",
    De3pzq: "f42feg1"
  },
  teal: {
    sj55zd: "f135dsb4",
    De3pzq: "f6hvv1p"
  },
  steel: {
    sj55zd: "f151dlcp",
    De3pzq: "f1lnp8zf"
  },
  blue: {
    sj55zd: "f1rjv50u",
    De3pzq: "f1ggcpy6"
  },
  "royal-blue": {
    sj55zd: "f1emykk5",
    De3pzq: "f12rj61f"
  },
  cornflower: {
    sj55zd: "fqsigj7",
    De3pzq: "f8k7hur"
  },
  navy: {
    sj55zd: "f1nj97xi",
    De3pzq: "f19gw0ux"
  },
  lavender: {
    sj55zd: "fwctg0i",
    De3pzq: "ff379vm"
  },
  purple: {
    sj55zd: "fjrsgpu",
    De3pzq: "f1mzf1e1"
  },
  grape: {
    sj55zd: "f1fiiydq",
    De3pzq: "f1o4k8oy"
  },
  lilac: {
    sj55zd: "f1res9jt",
    De3pzq: "f1x6mz1o"
  },
  pink: {
    sj55zd: "fv3fbbi",
    De3pzq: "fydlv6t"
  },
  magenta: {
    sj55zd: "f1f1fwnz",
    De3pzq: "f4xb6j5"
  },
  plum: {
    sj55zd: "f8ptl6j",
    De3pzq: "fqo8e26"
  },
  beige: {
    sj55zd: "f1ntv3ld",
    De3pzq: "f101elhj"
  },
  mink: {
    sj55zd: "f1fscmp",
    De3pzq: "f13g8o5c"
  },
  platinum: {
    sj55zd: "f1dr00v2",
    De3pzq: "fkh7blw"
  },
  anchor: {
    sj55zd: "f1f3ti53",
    De3pzq: "fu4yj0j"
  }
}, {
  d: [".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f18f03hv{background-color:var(--colorNeutralBackground6);}", ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}", ".f1blnnmj{background-color:var(--colorBrandBackgroundStatic);}", ".fqjd1y1{color:var(--colorPaletteDarkRedForeground2);}", ".f1vq2oo4{background-color:var(--colorPaletteDarkRedBackground2);}", ".fg9gses{color:var(--colorPaletteCranberryForeground2);}", ".f1lwxszt{background-color:var(--colorPaletteCranberryBackground2);}", ".f23f7i0{color:var(--colorPaletteRedForeground2);}", ".f1q9qhfq{background-color:var(--colorPaletteRedBackground2);}", ".fjnan08{color:var(--colorPalettePumpkinForeground2);}", ".fz91bi3{background-color:var(--colorPalettePumpkinBackground2);}", ".fknu15p{color:var(--colorPalettePeachForeground2);}", ".f1b9nr51{background-color:var(--colorPalettePeachBackground2);}", ".f9603vw{color:var(--colorPaletteMarigoldForeground2);}", ".f3z4w6d{background-color:var(--colorPaletteMarigoldBackground2);}", ".fmq0uwp{color:var(--colorPaletteGoldForeground2);}", ".fg50kya{background-color:var(--colorPaletteGoldBackground2);}", ".f28g5vo{color:var(--colorPaletteBrassForeground2);}", ".f4w2gd0{background-color:var(--colorPaletteBrassBackground2);}", ".ftl572b{color:var(--colorPaletteBrownForeground2);}", ".f14wu1f4{background-color:var(--colorPaletteBrownBackground2);}", ".f1gymlvd{color:var(--colorPaletteForestForeground2);}", ".f19ut4y6{background-color:var(--colorPaletteForestBackground2);}", ".fnnb6wn{color:var(--colorPaletteSeafoamForeground2);}", ".f1n057jc{background-color:var(--colorPaletteSeafoamBackground2);}", ".ff58qw8{color:var(--colorPaletteDarkGreenForeground2);}", ".f11t05wk{background-color:var(--colorPaletteDarkGreenBackground2);}", ".f1up9qbj{color:var(--colorPaletteLightTealForeground2);}", ".f42feg1{background-color:var(--colorPaletteLightTealBackground2);}", ".f135dsb4{color:var(--colorPaletteTealForeground2);}", ".f6hvv1p{background-color:var(--colorPaletteTealBackground2);}", ".f151dlcp{color:var(--colorPaletteSteelForeground2);}", ".f1lnp8zf{background-color:var(--colorPaletteSteelBackground2);}", ".f1rjv50u{color:var(--colorPaletteBlueForeground2);}", ".f1ggcpy6{background-color:var(--colorPaletteBlueBackground2);}", ".f1emykk5{color:var(--colorPaletteRoyalBlueForeground2);}", ".f12rj61f{background-color:var(--colorPaletteRoyalBlueBackground2);}", ".fqsigj7{color:var(--colorPaletteCornflowerForeground2);}", ".f8k7hur{background-color:var(--colorPaletteCornflowerBackground2);}", ".f1nj97xi{color:var(--colorPaletteNavyForeground2);}", ".f19gw0ux{background-color:var(--colorPaletteNavyBackground2);}", ".fwctg0i{color:var(--colorPaletteLavenderForeground2);}", ".ff379vm{background-color:var(--colorPaletteLavenderBackground2);}", ".fjrsgpu{color:var(--colorPalettePurpleForeground2);}", ".f1mzf1e1{background-color:var(--colorPalettePurpleBackground2);}", ".f1fiiydq{color:var(--colorPaletteGrapeForeground2);}", ".f1o4k8oy{background-color:var(--colorPaletteGrapeBackground2);}", ".f1res9jt{color:var(--colorPaletteLilacForeground2);}", ".f1x6mz1o{background-color:var(--colorPaletteLilacBackground2);}", ".fv3fbbi{color:var(--colorPalettePinkForeground2);}", ".fydlv6t{background-color:var(--colorPalettePinkBackground2);}", ".f1f1fwnz{color:var(--colorPaletteMagentaForeground2);}", ".f4xb6j5{background-color:var(--colorPaletteMagentaBackground2);}", ".f8ptl6j{color:var(--colorPalettePlumForeground2);}", ".fqo8e26{background-color:var(--colorPalettePlumBackground2);}", ".f1ntv3ld{color:var(--colorPaletteBeigeForeground2);}", ".f101elhj{background-color:var(--colorPaletteBeigeBackground2);}", ".f1fscmp{color:var(--colorPaletteMinkForeground2);}", ".f13g8o5c{background-color:var(--colorPaletteMinkBackground2);}", ".f1dr00v2{color:var(--colorPalettePlatinumForeground2);}", ".fkh7blw{background-color:var(--colorPalettePlatinumBackground2);}", ".f1f3ti53{color:var(--colorPaletteAnchorForeground2);}", ".fu4yj0j{background-color:var(--colorPaletteAnchorBackground2);}"]
});
const useRingColorStyles = /*#__PURE__*/__styles({
  neutral: {
    Bic5iru: "f1uuiafn"
  },
  brand: {
    Bic5iru: "f1uuiafn"
  },
  "dark-red": {
    Bic5iru: "f1t2x9on"
  },
  cranberry: {
    Bic5iru: "f1pvshc9"
  },
  red: {
    Bic5iru: "f1ectbk9"
  },
  pumpkin: {
    Bic5iru: "fvzpl0b"
  },
  peach: {
    Bic5iru: "fwj2kd7"
  },
  marigold: {
    Bic5iru: "fr120vy"
  },
  gold: {
    Bic5iru: "f8xmmar"
  },
  brass: {
    Bic5iru: "f1hbety2"
  },
  brown: {
    Bic5iru: "f1vg3s4g"
  },
  forest: {
    Bic5iru: "f1m3olm5"
  },
  seafoam: {
    Bic5iru: "f17xiqtr"
  },
  "dark-green": {
    Bic5iru: "fx32vyh"
  },
  "light-teal": {
    Bic5iru: "f1mkihwv"
  },
  teal: {
    Bic5iru: "fecnooh"
  },
  steel: {
    Bic5iru: "f15hfgzm"
  },
  blue: {
    Bic5iru: "fqproka"
  },
  "royal-blue": {
    Bic5iru: "f17v2w59"
  },
  cornflower: {
    Bic5iru: "fp0q1mo"
  },
  navy: {
    Bic5iru: "f1nlym55"
  },
  lavender: {
    Bic5iru: "f62vk8h"
  },
  purple: {
    Bic5iru: "f15zl69q"
  },
  grape: {
    Bic5iru: "f53w4j7"
  },
  lilac: {
    Bic5iru: "fu2771t"
  },
  pink: {
    Bic5iru: "fzflscs"
  },
  magenta: {
    Bic5iru: "fb6rmqc"
  },
  plum: {
    Bic5iru: "f1a4gm5b"
  },
  beige: {
    Bic5iru: "f1qpf9z1"
  },
  mink: {
    Bic5iru: "f1l7or83"
  },
  platinum: {
    Bic5iru: "fzrj0iu"
  },
  anchor: {
    Bic5iru: "f8oz6wf"
  }
}, {
  d: [".f1uuiafn::before{color:var(--colorBrandStroke1);}", ".f1t2x9on::before{color:var(--colorPaletteDarkRedBorderActive);}", ".f1pvshc9::before{color:var(--colorPaletteCranberryBorderActive);}", ".f1ectbk9::before{color:var(--colorPaletteRedBorderActive);}", ".fvzpl0b::before{color:var(--colorPalettePumpkinBorderActive);}", ".fwj2kd7::before{color:var(--colorPalettePeachBorderActive);}", ".fr120vy::before{color:var(--colorPaletteMarigoldBorderActive);}", ".f8xmmar::before{color:var(--colorPaletteGoldBorderActive);}", ".f1hbety2::before{color:var(--colorPaletteBrassBorderActive);}", ".f1vg3s4g::before{color:var(--colorPaletteBrownBorderActive);}", ".f1m3olm5::before{color:var(--colorPaletteForestBorderActive);}", ".f17xiqtr::before{color:var(--colorPaletteSeafoamBorderActive);}", ".fx32vyh::before{color:var(--colorPaletteDarkGreenBorderActive);}", ".f1mkihwv::before{color:var(--colorPaletteLightTealBorderActive);}", ".fecnooh::before{color:var(--colorPaletteTealBorderActive);}", ".f15hfgzm::before{color:var(--colorPaletteSteelBorderActive);}", ".fqproka::before{color:var(--colorPaletteBlueBorderActive);}", ".f17v2w59::before{color:var(--colorPaletteRoyalBlueBorderActive);}", ".fp0q1mo::before{color:var(--colorPaletteCornflowerBorderActive);}", ".f1nlym55::before{color:var(--colorPaletteNavyBorderActive);}", ".f62vk8h::before{color:var(--colorPaletteLavenderBorderActive);}", ".f15zl69q::before{color:var(--colorPalettePurpleBorderActive);}", ".f53w4j7::before{color:var(--colorPaletteGrapeBorderActive);}", ".fu2771t::before{color:var(--colorPaletteLilacBorderActive);}", ".fzflscs::before{color:var(--colorPalettePinkBorderActive);}", ".fb6rmqc::before{color:var(--colorPaletteMagentaBorderActive);}", ".f1a4gm5b::before{color:var(--colorPalettePlumBorderActive);}", ".f1qpf9z1::before{color:var(--colorPaletteBeigeBorderActive);}", ".f1l7or83::before{color:var(--colorPaletteMinkBorderActive);}", ".fzrj0iu::before{color:var(--colorPalettePlatinumBorderActive);}", ".f8oz6wf::before{color:var(--colorPaletteAnchorBorderActive);}"]
});
const useAvatarStyles_unstable = state => {
  'use no memo';

  const {
    size,
    shape,
    active,
    activeAppearance,
    color
  } = state;
  const rootClassName = useRootClassName$3();
  const imageClassName = useImageClassName();
  const iconInitialsClassName = useIconInitialsClassName();
  const styles = useStyles$E();
  const sizeStyles = useSizeStyles();
  const colorStyles = useColorStyles();
  const ringColorStyles = useRingColorStyles();
  const rootClasses = [rootClassName, size !== 32 && sizeStyles[size]];
  if (state.badge) {
    rootClasses.push(styles.badgeAlign, styles[state.badge.size || 'medium']);
  }
  if (size <= 24) {
    rootClasses.push(styles.textCaption2Strong);
  } else if (size <= 28) {
    rootClasses.push(styles.textCaption1Strong);
  } else if (size <= 40) ; else if (size <= 56) {
    rootClasses.push(styles.textSubtitle2);
  } else if (size <= 96) {
    rootClasses.push(styles.textSubtitle1);
  } else {
    rootClasses.push(styles.textTitle3);
  }
  if (shape === 'square') {
    if (size <= 24) {
      rootClasses.push(styles.squareSmall);
    } else if (size <= 48) {
      rootClasses.push(styles.squareMedium);
    } else if (size <= 72) {
      rootClasses.push(styles.squareLarge);
    } else {
      rootClasses.push(styles.squareXLarge);
    }
  }
  if (active === 'active' || active === 'inactive') {
    rootClasses.push(styles.activeOrInactive);
    if (activeAppearance === 'ring' || activeAppearance === 'ring-shadow') {
      rootClasses.push(styles.ring, ringColorStyles[color]);
      if (state.badge) {
        rootClasses.push(styles.ringBadgeCutout);
      }
      if (size <= 48) {
        rootClasses.push(styles.ringThick);
      } else if (size <= 64) {
        rootClasses.push(styles.ringThicker);
      } else {
        rootClasses.push(styles.ringThickest);
      }
    }
    if (activeAppearance === 'shadow' || activeAppearance === 'ring-shadow') {
      rootClasses.push(styles.shadow);
      if (size <= 28) {
        rootClasses.push(styles.shadow4);
      } else if (size <= 48) {
        rootClasses.push(styles.shadow8);
      } else if (size <= 64) {
        rootClasses.push(styles.shadow16);
      } else {
        rootClasses.push(styles.shadow28);
      }
    }
    // Note: The inactive style overrides some of the activeAppearance styles and must be applied after them
    if (active === 'inactive') {
      rootClasses.push(styles.inactive);
    }
  }
  state.root.className = mergeClasses(avatarClassNames.root, ...rootClasses, state.root.className);
  if (state.badge) {
    state.badge.className = mergeClasses(avatarClassNames.badge, styles.badge, state.badge.className);
  }
  if (state.image) {
    state.image.className = mergeClasses(avatarClassNames.image, imageClassName, colorStyles[color], state.badge && styles.badgeCutout, state.image.className);
  }
  if (state.initials) {
    state.initials.className = mergeClasses(avatarClassNames.initials, iconInitialsClassName, colorStyles[color], state.badge && styles.badgeCutout, state.initials.className);
  }
  if (state.icon) {
    let iconSizeClass;
    if (size <= 16) {
      iconSizeClass = styles.icon12;
    } else if (size <= 24) {
      iconSizeClass = styles.icon16;
    } else if (size <= 40) {
      iconSizeClass = styles.icon20;
    } else if (size <= 48) {
      iconSizeClass = styles.icon24;
    } else if (size <= 56) {
      iconSizeClass = styles.icon28;
    } else if (size <= 72) {
      iconSizeClass = styles.icon32;
    } else {
      iconSizeClass = styles.icon48;
    }
    state.icon.className = mergeClasses(avatarClassNames.icon, iconInitialsClassName, iconSizeClass, colorStyles[color], state.badge && styles.badgeCutout, state.icon.className);
  }
  return state;
};

const Avatar = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useAvatar_unstable(props, ref);
    useAvatarStyles_unstable(state);
    useCustomStyleHook$1('useAvatarStyles_unstable')(state);
    return renderAvatar_unstable(state);
});
Avatar.displayName = 'Avatar';

/**
 * Creates a virtual element based on the position of a click event
 * Can be used as a target for popper in scenarios such as context menus
 */ function createVirtualElementFromClick(nativeEvent) {
    const left = nativeEvent.clientX;
    const top = nativeEvent.clientY;
    const right = left + 1;
    const bottom = top + 1;
    function getBoundingClientRect() {
        return {
            left,
            top,
            right,
            bottom,
            x: left,
            y: top,
            height: 1,
            width: 1
        };
    }
    return {
        getBoundingClientRect
    };
}

const DATA_POSITIONING_INTERSECTING = 'data-popper-is-intersecting';
const DATA_POSITIONING_ESCAPED = 'data-popper-escaped';
const DATA_POSITIONING_HIDDEN = 'data-popper-reference-hidden';
const DATA_POSITIONING_PLACEMENT = 'data-popper-placement';
const POSITIONING_END_EVENT = 'fui-positioningend';

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const min$1 = Math.min;
const max$1 = Math.max;
const round$1 = Math.round;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === undefined) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? undefined : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow$1(state, options) {
  var _await$platform$isEle;
  if (options === undefined) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? undefined : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? undefined : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? undefined : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? undefined : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? undefined : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? undefined : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? undefined : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1$1 ? center - min$1$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$2 = function (options) {
  if (options === undefined) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? undefined : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? undefined : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? undefined : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? undefined : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? undefined : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide$1 = function (options) {
  if (options === undefined) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow$1(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow$1(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? undefined : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$3 = function (options) {
  if (options === undefined) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? undefined : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$2 = function (options) {
  if (options === undefined) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift$1 = function (options) {
  if (options === undefined) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? undefined : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? undefined : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size$1 = function (options) {
  if (options === undefined) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? undefined : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min$1(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min$1(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$1(overflow.left, 0);
        const xMax = max$1(overflow.right, 0);
        const yMin = max$1(overflow.top, 0);
        const yMax = max$1(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

function hasWindow$1() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode$1(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow$1(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? undefined : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode$1(node) ? node.ownerDocument : node.document) || window.document) == null ? undefined : _ref.documentElement;
}
function isNode$1(value) {
  if (!hasWindow$1()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow$1(value).Node;
}
function isElement(value) {
  if (!hasWindow$1()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function isHTMLElement$1(value) {
  if (!hasWindow$1()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow$1() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$1(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return ['transform', 'translate', 'scale', 'rotate', 'perspective'].some(value => css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode$1(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode$1(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode$1(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode$1(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === undefined) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? undefined : _node$ownerDocument2.body);
  const win = getWindow$1(scrollableAncestor);
  if (isBody) {
    getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, []));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round$1(width) !== offsetWidth || round$1(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round$1(rect.width) : rect.width) / width;
  let y = ($ ? round$1(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow$1(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === undefined) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$1(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === undefined) {
    includeScale = false;
  }
  if (isFixedStrategy === undefined) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$1(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow$1(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === undefined) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max$1(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max$1(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max$1(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode$1(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, []).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode$1(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode$1(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow$1(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement$1(element)) {
    let svgOffsetParent = getParentNode$1(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode$1(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}

const platform$2 = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
const detectOverflow = detectOverflow$1;

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$2 = offset$3;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = shift$2;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = flip$2;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = size$1;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = hide$1;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = arrow$1;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = limitShift$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform: platform$2,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

/**
 * Parses Floating UI placement and returns the different components
 * @param placement - the floating ui placement (i.e. bottom-start)
 *
 * @returns side and alignment components of the placement
 */ function parseFloatingUIPlacement(placement) {
    const tokens = placement.split('-');
    return {
        side: tokens[0],
        alignment: tokens[1]
    };
}

/**
 * Returns the parent node or the host of the node argument.
 * @param node - DOM node.
 * @returns - parent DOM node.
 */ const getParentNode = (node)=>{
    if (node.nodeName === 'HTML') {
        return node;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return node.parentNode || node.host;
};
/**
 * Returns CSS styles of the given node.
 * @param node - DOM node.
 * @returns - CSS styles.
 */ const getStyleComputedProperty = (node)=>{
    var _node_ownerDocument;
    if (node.nodeType !== 1) {
        return {};
    }
    const window = (_node_ownerDocument = node.ownerDocument) === null || _node_ownerDocument === undefined ? undefined : _node_ownerDocument.defaultView;
    return window.getComputedStyle(node, null);
};
/**
 * Returns the first scrollable parent of the given element.
 * @param node - DOM node.
 * @returns - the first scrollable parent.
 */ const getScrollParent = (node)=>{
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    const parentNode = node && getParentNode(node);
    // eslint-disable-next-line
    if (!parentNode) return document.body;
    switch(parentNode.nodeName){
        case 'HTML':
        case 'BODY':
            return parentNode.ownerDocument.body;
        case '#document':
            return parentNode.body;
    }
    // If any of the overflow props is defined for the node then we return it as the parent
    const { overflow, overflowX, overflowY } = getStyleComputedProperty(parentNode);
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
        return parentNode;
    }
    return getScrollParent(parentNode);
};
const hasScrollParent = (node)=>{
    var _scrollParentElement_ownerDocument;
    const scrollParentElement = getScrollParent(node);
    return scrollParentElement ? scrollParentElement !== ((_scrollParentElement_ownerDocument = scrollParentElement.ownerDocument) === null || _scrollParentElement_ownerDocument === undefined ? undefined : _scrollParentElement_ownerDocument.body) : false;
};

/**
 * Allows to mimic a behavior from V1 of Popper and accept `window` and `scrollParent` as strings.
 */ function getBoundary(element, boundary) {
    if (boundary === 'window') {
        return element === null || element === undefined ? undefined : element.ownerDocument.documentElement;
    }
    if (boundary === 'clippingParents') {
        return 'clippingAncestors';
    }
    if (boundary === 'scrollParent') {
        let boundariesNode = getScrollParent(element);
        if (boundariesNode.nodeName === 'BODY') {
            boundariesNode = element === null || element === undefined ? undefined : element.ownerDocument.documentElement;
        }
        return boundariesNode;
    }
    return boundary;
}

var WorkTag;
(function(WorkTag) {
    WorkTag[WorkTag["FunctionComponent"] = 0] = "FunctionComponent";
    WorkTag[WorkTag["ClassComponent"] = 1] = "ClassComponent";
    WorkTag[WorkTag["IndeterminateComponent"] = 2] = "IndeterminateComponent";
    WorkTag[WorkTag["HostRoot"] = 3] = "HostRoot";
    WorkTag[WorkTag["HostPortal"] = 4] = "HostPortal";
    WorkTag[WorkTag["HostComponent"] = 5] = "HostComponent";
    WorkTag[WorkTag["HostText"] = 6] = "HostText";
    WorkTag[WorkTag["Fragment"] = 7] = "Fragment";
    WorkTag[WorkTag["Mode"] = 8] = "Mode";
    WorkTag[WorkTag["ContextConsumer"] = 9] = "ContextConsumer";
    WorkTag[WorkTag["ContextProvider"] = 10] = "ContextProvider";
    WorkTag[WorkTag["ForwardRef"] = 11] = "ForwardRef";
    WorkTag[WorkTag["Profiler"] = 12] = "Profiler";
    WorkTag[WorkTag["SuspenseComponent"] = 13] = "SuspenseComponent";
    WorkTag[WorkTag["MemoComponent"] = 14] = "MemoComponent";
    WorkTag[WorkTag["SimpleMemoComponent"] = 15] = "SimpleMemoComponent";
    WorkTag[WorkTag["LazyComponent"] = 16] = "LazyComponent";
    WorkTag[WorkTag["IncompleteClassComponent"] = 17] = "IncompleteClassComponent";
    WorkTag[WorkTag["DehydratedFragment"] = 18] = "DehydratedFragment";
    WorkTag[WorkTag["SuspenseListComponent"] = 19] = "SuspenseListComponent";
    WorkTag[WorkTag["FundamentalComponent"] = 20] = "FundamentalComponent";
    WorkTag[WorkTag["ScopeComponent"] = 21] = "ScopeComponent";
})(WorkTag || (WorkTag = {}));
function getReactFiberFromNode(elm) {
    if (!elm) {
        return null;
    }
    for(const k in elm){
        // React 16 uses "__reactInternalInstance$" prefix
        // React 17 uses "__reactFiber$" prefix
        // https://github.com/facebook/react/pull/18377
        if (k.indexOf('__reactInternalInstance$') === 0 || k.indexOf('__reactFiber$') === 0) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return elm[k];
        }
    }
    throw new Error('getReactFiber(): Failed to find a React Fiber on a node');
}

/**
 * Generally when adding an arrow to popper, it's necessary to offset the position of the popper by the
 * height of the arrow. A simple utility to merge a provided offset with an arrow height to return the final offset
 *
 * @internal
 * @param userOffset - The offset provided by the user
 * @param arrowHeight - The height of the arrow in px
 * @returns User offset augmented with arrow height
 */ function mergeArrowOffset(userOffset, arrowHeight) {
    if (typeof userOffset === 'number') {
        return addArrowOffset(userOffset, arrowHeight);
    }
    if (typeof userOffset === 'object' && userOffset !== null) {
        return addArrowOffset(userOffset, arrowHeight);
    }
    if (typeof userOffset === 'function') {
        return (offsetParams)=>{
            const offset = userOffset(offsetParams);
            return addArrowOffset(offset, arrowHeight);
        };
    }
    return {
        mainAxis: arrowHeight
    };
}
const addArrowOffset = (offset, arrowHeight)=>{
    if (typeof offset === 'number') {
        return {
            mainAxis: offset + arrowHeight
        };
    }
    var _offset_mainAxis;
    return {
        ...offset,
        mainAxis: ((_offset_mainAxis = offset.mainAxis) !== null && _offset_mainAxis !== undefined ? _offset_mainAxis : 0) + arrowHeight
    };
};

function toFloatingUIPadding(padding, isRtl) {
    if (typeof padding === 'number') {
        return padding;
    }
    const { start, end, ...verticalPadding } = padding;
    const paddingObject = verticalPadding;
    const left = isRtl ? 'end' : 'start';
    const right = isRtl ? 'start' : 'end';
    // assign properties explicitly since undefined values are actually handled by floating UI
    // TODO create floating UI issue
    if (padding[left]) {
        paddingObject.left = padding[left];
    }
    if (padding[right]) {
        paddingObject.right = padding[right];
    }
    return paddingObject;
}

const getPositionMap$1 = (rtl)=>({
        above: 'top',
        below: 'bottom',
        before: rtl ? 'right' : 'left',
        after: rtl ? 'left' : 'right'
    });
// Floating UI automatically flips alignment
// https://github.com/floating-ui/floating-ui/issues/1563
const getAlignmentMap$1 = ()=>({
        start: 'start',
        end: 'end',
        top: 'start',
        bottom: 'end',
        center: undefined
    });
const shouldAlignToCenter = (p, a)=>{
    const positionedVertically = p === 'above' || p === 'below';
    const alignedVertically = a === 'top' || a === 'bottom';
    return positionedVertically && alignedVertically || !positionedVertically && !alignedVertically;
};
/**
 * Maps internal positioning values to Floating UI placement
 * @see positioningHelper.test.ts for expected placement values
 */ const toFloatingUIPlacement = (align, position, rtl)=>{
    const alignment = shouldAlignToCenter(position, align) ? 'center' : align;
    const computedPosition = position && getPositionMap$1(rtl)[position];
    const computedAlignment = alignment && getAlignmentMap$1()[alignment];
    if (computedPosition && computedAlignment) {
        return `${computedPosition}-${computedAlignment}`;
    }
    return computedPosition;
};

const getPositionMap = ()=>({
        top: 'above',
        bottom: 'below',
        right: 'after',
        left: 'before'
    });
// Floating UI automatically flips alignment
// https://github.com/floating-ui/floating-ui/issues/1563
const getAlignmentMap = (position)=>{
    if (position === 'above' || position === 'below') {
        return {
            start: 'start',
            end: 'end'
        };
    }
    return {
        start: 'top',
        end: 'bottom'
    };
};
/**
 * Maps Floating UI placement to positioning values
 * @see positioningHelper.test.ts for expected placement values
 */ const fromFloatingUIPlacement = (placement)=>{
    const { side, alignment: floatingUIAlignment } = parseFloatingUIPlacement(placement);
    const position = getPositionMap()[side];
    const alignment = floatingUIAlignment && getAlignmentMap(position)[floatingUIAlignment];
    return {
        position,
        alignment
    };
};

// Look up table for shorthand to avoid parsing strings
const shorthandLookup = {
    above: {
        position: 'above',
        align: 'center'
    },
    'above-start': {
        position: 'above',
        align: 'start'
    },
    'above-end': {
        position: 'above',
        align: 'end'
    },
    below: {
        position: 'below',
        align: 'center'
    },
    'below-start': {
        position: 'below',
        align: 'start'
    },
    'below-end': {
        position: 'below',
        align: 'end'
    },
    before: {
        position: 'before',
        align: 'center'
    },
    'before-top': {
        position: 'before',
        align: 'top'
    },
    'before-bottom': {
        position: 'before',
        align: 'bottom'
    },
    after: {
        position: 'after',
        align: 'center'
    },
    'after-top': {
        position: 'after',
        align: 'top'
    },
    'after-bottom': {
        position: 'after',
        align: 'bottom'
    }
};
function resolvePositioningShorthand(shorthand) {
    if (shorthand === undefined || shorthand === null) {
        return {};
    }
    if (typeof shorthand === 'string') {
        return shorthandLookup[shorthand];
    }
    return shorthand;
}

/**
 * Creates a MutableRef with ref change callback. Is useful as React.useRef() doesn't notify you when its content
 * changes and mutating the .current property doesn't cause a re-render. An opt-out will be use a callback ref via
 * React.useState(), but it will cause re-renders always.
 *
 * https://reactjs.org/docs/hooks-reference.html#useref
 * https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 *
 * @param initialValue - initial ref value
 * @param callback - a callback to run when value changes
 * @param skipInitialResolve - a flag to skip an initial ref report
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 */ function useCallbackRef(initialValue, callback, skipInitialResolve) {
    const isFirst = React.useRef(true);
    const [ref] = React.useState(()=>({
            // value
            value: initialValue,
            // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    useIsomorphicLayoutEffect(()=>{
        isFirst.current = false;
    }, []);
    // update callback
    ref.callback = callback;
    return ref.facade;
}

/**
 * Promise microtask debouncer used by Popper.js v2
 * This is no longer exported in Floating UI (Popper.js v3)
 * https://github.com/floating-ui/floating-ui/blob/v2.x/src/utils/debounce.js
 * @param fn function that will be debounced
 */ function debounce$2(fn) {
    let pending;
    return ()=>{
        if (!pending) {
            pending = new Promise((resolve)=>{
                Promise.resolve().then(()=>{
                    pending = undefined;
                    resolve(fn());
                });
            });
        }
        return pending;
    };
}

//
// Dev utils to detect if nodes have "autoFocus" props.
//
/**
 * Detects if a passed HTML node has "autoFocus" prop on a React's fiber. Is needed as React handles autofocus behavior
 * in React DOM and will not pass "autoFocus" to an actual HTML.
 *
 * @param node
 */ function hasAutofocusProp(node) {
    // https://github.com/facebook/react/blob/848bb2426e44606e0a55dfe44c7b3ece33772485/packages/react-dom/src/client/ReactDOMHostConfig.js#L157-L166
    const isAutoFocusableElement = node.nodeName === 'BUTTON' || node.nodeName === 'INPUT' || node.nodeName === 'SELECT' || node.nodeName === 'TEXTAREA';
    if (isAutoFocusableElement) {
        var _getReactFiberFromNode;
        return !!((_getReactFiberFromNode = getReactFiberFromNode(node)) === null || _getReactFiberFromNode === undefined ? undefined : _getReactFiberFromNode.pendingProps.autoFocus);
    }
    return false;
}
function hasAutofocusFilter(node) {
    return hasAutofocusProp(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
}

/**
 * Writes all DOM element updates after position is computed
 */ function writeArrowUpdates(options) {
    const { arrow, middlewareData } = options;
    if (!middlewareData.arrow || !arrow) {
        return;
    }
    const { x: arrowX, y: arrowY } = middlewareData.arrow;
    Object.assign(arrow.style, {
        left: arrowX !== null && arrowX !== undefined ? `${arrowX}px` : '',
        top: arrowY !== null && arrowY !== undefined ? `${arrowY}px` : ''
    });
}

/**
 * Writes all container element position updates after the position is computed
 */ function writeContainerUpdates(options) {
    var _middlewareData_hide, _middlewareData_hide1, _container_ownerDocument_defaultView;
    const { container, placement, middlewareData, strategy, lowPPI, coordinates, useTransform = true } = options;
    if (!container) {
        return;
    }
    container.setAttribute(DATA_POSITIONING_PLACEMENT, placement);
    container.removeAttribute(DATA_POSITIONING_INTERSECTING);
    if (middlewareData.intersectionObserver.intersecting) {
        container.setAttribute(DATA_POSITIONING_INTERSECTING, '');
    }
    container.removeAttribute(DATA_POSITIONING_ESCAPED);
    if ((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === undefined ? undefined : _middlewareData_hide.escaped) {
        container.setAttribute(DATA_POSITIONING_ESCAPED, '');
    }
    container.removeAttribute(DATA_POSITIONING_HIDDEN);
    if ((_middlewareData_hide1 = middlewareData.hide) === null || _middlewareData_hide1 === undefined ? undefined : _middlewareData_hide1.referenceHidden) {
        container.setAttribute(DATA_POSITIONING_HIDDEN, '');
    }
    // Round so that the coordinates land on device pixels.
    // This prevents blurriness in cases where the browser doesn't apply pixel snapping, such as when other effects like
    // `backdrop-filter: blur()` are applied to the container, and the browser is zoomed in.
    // See https://github.com/microsoft/fluentui/issues/26764 for more info.
    const devicePixelRatio = ((_container_ownerDocument_defaultView = container.ownerDocument.defaultView) === null || _container_ownerDocument_defaultView === undefined ? undefined : _container_ownerDocument_defaultView.devicePixelRatio) || 1;
    const x = Math.round(coordinates.x * devicePixelRatio) / devicePixelRatio;
    const y = Math.round(coordinates.y * devicePixelRatio) / devicePixelRatio;
    Object.assign(container.style, {
        position: strategy
    });
    if (useTransform) {
        Object.assign(container.style, {
            transform: lowPPI ? `translate(${x}px, ${y}px)` : `translate3d(${x}px, ${y}px, 0)`
        });
        return;
    }
    Object.assign(container.style, {
        left: `${x}px`,
        top: `${y}px`
    });
}

/**
 * AutoSizes contains many options from historic implementation.
 * Now options 'always'/'height-always'/'width-always' are obsolete.
 * This function maps them to true/'height'/'width'
 */ const normalizeAutoSize = (autoSize)=>{
    switch(autoSize){
        case 'always':
        case true:
            return {
                applyMaxWidth: true,
                applyMaxHeight: true
            };
        case 'width-always':
        case 'width':
            return {
                applyMaxWidth: true,
                applyMaxHeight: false
            };
        case 'height-always':
        case 'height':
            return {
                applyMaxWidth: false,
                applyMaxHeight: true
            };
        default:
            return false;
    }
};

function coverTarget() {
    return {
        name: 'coverTarget',
        fn: (middlewareArguments)=>{
            const { placement, rects, x, y } = middlewareArguments;
            const basePlacement = parseFloatingUIPlacement(placement).side;
            const newCoords = {
                x,
                y
            };
            switch(basePlacement){
                case 'bottom':
                    newCoords.y -= rects.reference.height;
                    break;
                case 'top':
                    newCoords.y += rects.reference.height;
                    break;
                case 'left':
                    newCoords.x += rects.reference.width;
                    break;
                case 'right':
                    newCoords.x -= rects.reference.width;
                    break;
            }
            return newCoords;
        }
    };
}

function flip(options) {
    const { hasScrollableElement, flipBoundary, container, fallbackPositions = [], isRtl } = options;
    const fallbackPlacements = fallbackPositions.reduce((acc, shorthand)=>{
        const { position, align } = resolvePositioningShorthand(shorthand);
        const placement = toFloatingUIPlacement(align, position, isRtl);
        if (placement) {
            acc.push(placement);
        }
        return acc;
    }, []);
    return flip$1({
        ...hasScrollableElement && {
            boundary: 'clippingAncestors'
        },
        ...flipBoundary && {
            altBoundary: true,
            boundary: getBoundary(container, flipBoundary)
        },
        fallbackStrategy: 'bestFit',
        ...fallbackPlacements.length && {
            fallbackPlacements
        }
    });
}

function intersecting() {
    return {
        name: 'intersectionObserver',
        fn: async (middlewareArguments)=>{
            const floatingRect = middlewareArguments.rects.floating;
            const altOverflow = await detectOverflow(middlewareArguments, {
                altBoundary: true
            });
            const isIntersectingTop = altOverflow.top < floatingRect.height && altOverflow.top > 0;
            const isIntersectingBottom = altOverflow.bottom < floatingRect.height && altOverflow.bottom > 0;
            const isIntersecting = isIntersectingTop || isIntersectingBottom;
            return {
                data: {
                    intersecting: isIntersecting
                }
            };
        }
    };
}

/**
 * floating-ui `size` middleware uses floating element's height/width to calculate available height/width.
 * This middleware only runs once per lifecycle, resetting styles applied by maxSize from previous lifecycle.
 * Then floating element's original size is restored and `size` middleware can calculate available height/width correctly.
 */ const resetMaxSize = (autoSize)=>({
        name: 'resetMaxSize',
        fn ({ middlewareData, elements }) {
            var _middlewareData_resetMaxSize;
            if ((_middlewareData_resetMaxSize = middlewareData.resetMaxSize) === null || _middlewareData_resetMaxSize === undefined ? undefined : _middlewareData_resetMaxSize.maxSizeAlreadyReset) {
                return {};
            }
            const { applyMaxWidth, applyMaxHeight } = autoSize;
            if (applyMaxWidth) {
                elements.floating.style.removeProperty('box-sizing');
                elements.floating.style.removeProperty('max-width');
                elements.floating.style.removeProperty('width');
            }
            if (applyMaxHeight) {
                elements.floating.style.removeProperty('box-sizing');
                elements.floating.style.removeProperty('max-height');
                elements.floating.style.removeProperty('height');
            }
            return {
                data: {
                    maxSizeAlreadyReset: true
                },
                reset: {
                    rects: true
                }
            };
        }
    });
function maxSize(autoSize, options) {
    const { container, overflowBoundary, overflowBoundaryPadding, isRtl } = options;
    return size({
        ...overflowBoundaryPadding && {
            padding: toFloatingUIPadding(overflowBoundaryPadding, isRtl)
        },
        ...overflowBoundary && {
            altBoundary: true,
            boundary: getBoundary(container, overflowBoundary)
        },
        apply ({ availableHeight, availableWidth, elements, rects }) {
            const applyMaxSizeStyles = (apply, dimension, availableSize)=>{
                if (!apply) {
                    return;
                }
                elements.floating.style.setProperty('box-sizing', 'border-box');
                elements.floating.style.setProperty(`max-${dimension}`, `${availableSize}px`);
                if (rects.floating[dimension] > availableSize) {
                    elements.floating.style.setProperty(dimension, `${availableSize}px`);
                    const axis = dimension === 'width' ? 'x' : 'y';
                    if (!elements.floating.style.getPropertyValue(`overflow-${axis}`)) {
                        elements.floating.style.setProperty(`overflow-${axis}`, 'auto');
                    }
                }
            };
            const { applyMaxWidth, applyMaxHeight } = autoSize;
            applyMaxSizeStyles(applyMaxWidth, 'width', availableWidth);
            applyMaxSizeStyles(applyMaxHeight, 'height', availableHeight);
        }
    });
}

/**
 * Shim to transform offset values from this library to Floating UI
 * @param rawOffset Offset from this library
 * @returns An offset value compatible with Floating UI
 */ function getFloatingUIOffset(rawOffset) {
    if (!rawOffset) {
        return rawOffset;
    }
    if (typeof rawOffset === 'number' || typeof rawOffset === 'object') {
        return rawOffset;
    }
    return ({ rects: { floating, reference }, placement })=>{
        const { position, alignment } = fromFloatingUIPlacement(placement);
        return rawOffset({
            positionedRect: floating,
            targetRect: reference,
            position,
            alignment
        });
    };
}

/**
 * Wraps floating UI offset middleware to to transform offset value
 */ function offset$1(offsetValue) {
    const floatingUIOffset = getFloatingUIOffset(offsetValue);
    return offset$2(floatingUIOffset);
}

/**
 * Wraps the floating UI shift middleware for easier usage of our options
 */ function shift(options) {
    const { hasScrollableElement, shiftToCoverTarget, disableTether, overflowBoundary, container, overflowBoundaryPadding, isRtl } = options;
    return shift$1({
        ...hasScrollableElement && {
            boundary: 'clippingAncestors'
        },
        ...shiftToCoverTarget && {
            crossAxis: true,
            limiter: limitShift({
                crossAxis: true,
                mainAxis: false
            })
        },
        ...disableTether && {
            crossAxis: disableTether === 'all',
            limiter: limitShift({
                crossAxis: disableTether !== 'all',
                mainAxis: false
            })
        },
        ...overflowBoundaryPadding && {
            padding: toFloatingUIPadding(overflowBoundaryPadding, isRtl)
        },
        ...overflowBoundary && {
            altBoundary: true,
            boundary: getBoundary(container, overflowBoundary)
        }
    });
}

const matchTargetSizeCssVar = '--fui-match-target-size';
function matchTargetSize() {
    return {
        name: 'matchTargetSize',
        fn: async (middlewareArguments)=>{
            const { rects: { reference: referenceRect, floating: floatingRect }, elements: { floating: floatingElement }, middlewareData: { matchTargetSize: { matchTargetSizeAttempt = false } = {} } } = middlewareArguments;
            if (referenceRect.width === floatingRect.width || matchTargetSizeAttempt) {
                return {};
            }
            const { width } = referenceRect;
            floatingElement.style.setProperty(matchTargetSizeCssVar, `${width}px`);
            if (!floatingElement.style.width) {
                floatingElement.style.width = `var(${matchTargetSizeCssVar})`;
            }
            return {
                data: {
                    matchTargetSizeAttempt: true
                },
                reset: {
                    rects: true
                }
            };
        }
    };
}

function listScrollParents(node) {
    const scrollParents = [];
    let cur = node;
    while(cur){
        const scrollParent = getScrollParent(cur);
        if (node.ownerDocument.body === scrollParent) {
            scrollParents.push(scrollParent);
            break;
        }
        if (scrollParent.nodeName === 'BODY' && scrollParent !== node.ownerDocument.body) {
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.error('@fluentui/react-positioning: You are comparing two different documents! This is an unexpected error, please report this as a bug to the Fluent UI team ');
            }
            break;
        }
        scrollParents.push(scrollParent);
        cur = scrollParent;
    }
    return scrollParents;
}

function createResizeObserver(targetWindow, callback) {
    // https://github.com/jsdom/jsdom/issues/3368
    // Add the polyfill here so it is not needed for all unit tests that leverage positioning
    if (process.env.NODE_ENV === 'test') {
        targetWindow.ResizeObserver = class ResizeObserver {
            observe() {
            // do nothing
            }
            unobserve() {
            // do nothing
            }
            disconnect() {
            // do nothing
            }
        };
    }
    return new targetWindow.ResizeObserver(callback);
}

function createPositionManager(options) {
  let isDestroyed = false;
  const { container, target, arrow, strategy, middleware, placement, useTransform = true, disableUpdateOnResize = false } = options;
  const targetWindow = container.ownerDocument.defaultView;
  if (!target || !container || !targetWindow) {
    return {
      updatePosition: () => undefined,
      dispose: () => undefined
    };
  }
  const resizeObserver = disableUpdateOnResize ? null : createResizeObserver(targetWindow, (entries) => {
    const shouldUpdateOnResize = entries.every((entry) => {
      return entry.contentRect.width > 0 && entry.contentRect.height > 0;
    });
    if (shouldUpdateOnResize) {
      updatePosition();
    }
  });
  let isFirstUpdate = true;
  const scrollParents = /* @__PURE__ */ new Set();
  Object.assign(container.style, {
    position: "fixed",
    left: 0,
    top: 0,
    margin: 0
  });
  const forceUpdate = () => {
    if (isDestroyed) {
      return;
    }
    if (isFirstUpdate) {
      listScrollParents(container).forEach((scrollParent) => scrollParents.add(scrollParent));
      if (isHTMLElement$3(target)) {
        listScrollParents(target).forEach((scrollParent) => scrollParents.add(scrollParent));
      }
      scrollParents.forEach((scrollParent) => {
        scrollParent.addEventListener("scroll", updatePosition, {
          passive: true
        });
      });
      resizeObserver === null || resizeObserver === undefined ? undefined : resizeObserver.observe(container);
      if (isHTMLElement$3(target)) {
        resizeObserver === null || resizeObserver === undefined ? undefined : resizeObserver.observe(target);
      }
      isFirstUpdate = false;
    }
    Object.assign(container.style, {
      position: strategy
    });
    computePosition(target, container, {
      placement,
      middleware,
      strategy
    }).then(({ x, y, middlewareData, placement: computedPlacement }) => {
      if (isDestroyed) {
        return;
      }
      writeArrowUpdates({
        arrow,
        middlewareData
      });
      writeContainerUpdates({
        container,
        middlewareData,
        placement: computedPlacement,
        coordinates: {
          x,
          y
        },
        lowPPI: ((targetWindow === null || targetWindow === undefined ? undefined : targetWindow.devicePixelRatio) || 1) <= 1,
        strategy,
        useTransform
      });
      container.dispatchEvent(new CustomEvent(POSITIONING_END_EVENT));
    }).catch((err) => {
      if (process.env.NODE_ENV === "development") {
        console.error("[usePositioning]: Failed to calculate position", err);
      }
    });
  };
  const updatePosition = debounce$2(() => forceUpdate());
  const dispose = () => {
    isDestroyed = true;
    if (targetWindow) {
      targetWindow.removeEventListener("scroll", updatePosition);
      targetWindow.removeEventListener("resize", updatePosition);
    }
    scrollParents.forEach((scrollParent) => {
      scrollParent.removeEventListener("scroll", updatePosition);
    });
    scrollParents.clear();
    resizeObserver === null || resizeObserver === undefined ? undefined : resizeObserver.disconnect();
  };
  if (targetWindow) {
    targetWindow.addEventListener("scroll", updatePosition, {
      passive: true
    });
    targetWindow.addEventListener("resize", updatePosition);
  }
  updatePosition();
  return {
    updatePosition,
    dispose
  };
}

/**
 * @internal
 */
const CONTROLLER = '__FUIDT_CONTROLLER__';

/**
 * @internal
 */
const ELEMENT_METADATA = '__FUIDT_ELEMENT_METADATA__';

/**
 * @internal
 */
const HTML_ELEMENT_REFERENCE = '__FUIDT_HTML_ELEMENT_REFERENCE__';

/**
 * @internal
 */
const SERIALIZED_DATA_CHANGE = '__FUIDT_SERIALIZED_DATA_CHANGE__';

/**
 * Verifies if a given node is an HTMLElement,
 * this method works seamlessly with frames and elements from different documents
 *
 * This is preferred over simply using `instanceof`.
 * Since `instanceof` might be problematic while operating with [multiple realms](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/instanceof#instanceof_and_multiple_realms)
 *
 * @example
 * ```ts
 * isHTMLElement(event.target) && event.target.focus()
 * isHTMLElement(event.target, {constructorName: 'HTMLInputElement'}) && event.target.value // some value
 * ```
 *
 */
function isHTMLElement(element, options) {
  var _typedElement$ownerDo, _options$constructorN;
  const typedElement = element;
  return Boolean((typedElement == null || (_typedElement$ownerDo = typedElement.ownerDocument) == null ? undefined : _typedElement$ownerDo.defaultView) && typedElement instanceof typedElement.ownerDocument.defaultView[(_options$constructorN = undefined ) != null ? _options$constructorN : 'HTMLElement']);
}

/**
 * @internal
 */

const isHTMLElementWithMetadata = element => Boolean(isHTMLElement(element) && ELEMENT_METADATA in element && element.parentElement !== null);

const createController = defaultView => {
  let selectedElement = null;
  const observer = new MutationObserver(mutations => {
    if (!selectedElement) {
      return;
    }
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && Array.from(mutation.removedNodes).includes(selectedElement)) {
        controller.withdraw();
      }
    }
  });
  const controller = {
    get selectedElement() {
      return selectedElement;
    },
    select: nextSelectedElement => {
      if (isHTMLElementWithMetadata(nextSelectedElement)) {
        selectedElement = nextSelectedElement;
        observer.observe(nextSelectedElement.parentElement, {
          childList: true,
          subtree: false
        });
      }
      if (selectedElement && nextSelectedElement) {
        const metadata = selectedElement[ELEMENT_METADATA];
        if (metadata.references.has(nextSelectedElement)) {
          return selectedElement;
        }
      }
      controller.withdraw();
      return selectedElement;
    },
    withdraw: () => {
      selectedElement = null;
      observer.disconnect();
      defaultView.postMessage(SERIALIZED_DATA_CHANGE);
    }
  };
  return controller;
};
const injectController = _ref => {
  let {
    defaultView
  } = _ref;
  if (!defaultView) {
    return;
  }
  if (!defaultView[CONTROLLER]) {
    defaultView[CONTROLLER] = createController(defaultView);
  }
};
const getController = targetDocument => {
  var _targetDocument$defau, _targetDocument$defau2;
  injectController(targetDocument);
  return (_targetDocument$defau = (_targetDocument$defau2 = targetDocument.defaultView) == null ? undefined : _targetDocument$defau2[CONTROLLER]) != null ? _targetDocument$defau : null;
};

const serialize$2 = (data, references) => {
  const serializedData = JSON.parse(JSON.stringify(data, (_, value) => {
    if (isHTMLElement(value)) return references.add(value);
    if (typeof value === 'object' && value && Object.getPrototypeOf(value) !== Object.prototype && Object.getPrototypeOf(value) !== Array.prototype) {
      if ('toString' in value) {
        return value.toString();
      }
      return undefined;
    }
    return value;
  }));
  return serializedData;
};

let counter = 0;
const generateReferenceId = () => HTML_ELEMENT_REFERENCE + ":" + counter++;
const createReferences = () => {
  const map = new Map();
  const weakMap = new WeakMap();
  const references = {
    add: element => {
      if (weakMap.has(element)) {
        // biome-ignore lint/style/noNonNullAssertion: weakMap.has(element) ensures this is not undefined
        return weakMap.get(element);
      }
      const id = generateReferenceId();
      map.set(id, element);
      weakMap.set(element, id);
      return id;
    },
    get: id => {
      const element = map.get(id);
      if (element && weakMap.has(element)) {
        return element;
      }
    },
    has: element => {
      return weakMap.has(element);
    }
  };
  return references;
};

/**
 * devtools middleware
 * @public
 */
const devtools = function (targetDocument, middlewareDataCallback) {
  if (targetDocument === undefined) {
    targetDocument = document;
  }
  if (middlewareDataCallback === undefined) {
    middlewareDataCallback = floatingUIMiddlewareDataCallback;
  }
  return {
    name: '@floating-ui/devtools',
    fn: state => {
      const {
        [ELEMENT_METADATA]: metadata
      } = isHTMLElementWithMetadata(state.elements.floating) ? state.elements.floating : Object.assign(state.elements.floating, {
        [ELEMENT_METADATA]: {
          references: createReferences(),
          serializedData: []
        }
      });
      const serializedData = serialize$2(middlewareDataCallback(state), metadata.references);
      metadata.serializedData.unshift(serializedData);
      const controller = getController(targetDocument);
      if (metadata.serializedData.length > 1 && state.elements.floating === (controller == null ? undefined : controller.selectedElement)) {
        var _targetDocument$defau;
        (_targetDocument$defau = targetDocument.defaultView) == null || _targetDocument$defau.postMessage(SERIALIZED_DATA_CHANGE);
      }
      return {};
    }
  };
};
const floatingUIMiddlewareDataCallback = state => ({
  ...state,
  type: 'FloatingUIMiddleware'
});

const devtoolsCallback = (options)=>(middlewareState)=>{
        const { elements: { floating, reference } } = middlewareState;
        const scrollParentsSet = new Set();
        if (isHTMLElement$3(reference)) {
            listScrollParents(reference).forEach((scrollParent)=>scrollParentsSet.add(scrollParent));
        }
        listScrollParents(floating).forEach((scrollParent)=>scrollParentsSet.add(scrollParent));
        const flipBoundaries = Array.isArray(options.flipBoundary) ? options.flipBoundary : isHTMLElement$3(options.flipBoundary) ? [
            options.flipBoundary
        ] : [];
        const overflowBoundaries = Array.isArray(options.overflowBoundary) ? options.overflowBoundary : isHTMLElement$3(options.overflowBoundary) ? [
            options.overflowBoundary
        ] : [];
        return {
            type: 'FluentUIMiddleware',
            middlewareState,
            options,
            initialPlacement: fromFloatingUIPlacement(middlewareState.initialPlacement),
            placement: fromFloatingUIPlacement(middlewareState.placement),
            flipBoundaries,
            overflowBoundaries,
            scrollParents: Array.from(scrollParentsSet)
        };
    };

/**
 * @internal
 */ function usePositioning(options) {
    'use no memo';
    const managerRef = React.useRef(null);
    const targetRef = React.useRef(null);
    const overrideTargetRef = React.useRef(null);
    const containerRef = React.useRef(null);
    const arrowRef = React.useRef(null);
    const { enabled = true } = options;
    const resolvePositioningOptions = usePositioningOptions(options);
    const updatePositionManager = React.useCallback(()=>{
        if (managerRef.current) {
            managerRef.current.dispose();
        }
        managerRef.current = null;
        var _overrideTargetRef_current;
        const target = (_overrideTargetRef_current = overrideTargetRef.current) !== null && _overrideTargetRef_current !== undefined ? _overrideTargetRef_current : targetRef.current;
        if (enabled && canUseDOM() && target && containerRef.current) {
            managerRef.current = createPositionManager({
                container: containerRef.current,
                target,
                arrow: arrowRef.current,
                ...resolvePositioningOptions(containerRef.current, arrowRef.current)
            });
        }
    }, [
        enabled,
        resolvePositioningOptions
    ]);
    const setOverrideTarget = useEventCallback((target)=>{
        overrideTargetRef.current = target;
        updatePositionManager();
    });
    React.useImperativeHandle(options.positioningRef, ()=>({
            updatePosition: ()=>{
                var _managerRef_current;
                return (_managerRef_current = managerRef.current) === null || _managerRef_current === undefined ? undefined : _managerRef_current.updatePosition();
            },
            setTarget: (target)=>{
                if (options.target && process.env.NODE_ENV !== 'production') {
                    const err = new Error();
                    // eslint-disable-next-line no-console
                    console.warn('Imperative setTarget should not be used at the same time as target option');
                    // eslint-disable-next-line no-console
                    console.warn(err.stack);
                }
                setOverrideTarget(target);
            }
        }), [
        options.target,
        setOverrideTarget
    ]);
    useIsomorphicLayoutEffect(()=>{
        var _options_target;
        setOverrideTarget((_options_target = options.target) !== null && _options_target !== undefined ? _options_target : null);
    }, [
        options.target,
        setOverrideTarget
    ]);
    useIsomorphicLayoutEffect(()=>{
        updatePositionManager();
    }, [
        updatePositionManager
    ]);
    if (process.env.NODE_ENV !== 'production') {
        // This checked should run only in development mode
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useEffect(()=>{
            if (containerRef.current) {
                var _contentNode_ownerDocument;
                const contentNode = containerRef.current;
                const treeWalker = (_contentNode_ownerDocument = contentNode.ownerDocument) === null || _contentNode_ownerDocument === undefined ? undefined : _contentNode_ownerDocument.createTreeWalker(contentNode, NodeFilter.SHOW_ELEMENT, {
                    acceptNode: hasAutofocusFilter
                });
                while(treeWalker.nextNode()){
                    const node = treeWalker.currentNode;
                    // eslint-disable-next-line no-console
                    console.warn('<Popper>:', node);
                    // eslint-disable-next-line no-console
                    console.warn([
                        '<Popper>: ^ this node contains "autoFocus" prop on a React element. This can break the initial',
                        'positioning of an element and cause a window jump effect. This issue occurs because React polyfills',
                        '"autoFocus" behavior to solve inconsistencies between different browsers:',
                        'https://github.com/facebook/react/issues/11851#issuecomment-351787078',
                        '\n',
                        'However, ".focus()" in this case occurs before any other React effects will be executed',
                        '(React.useEffect(), componentDidMount(), etc.) and we can not prevent this behavior. If you really',
                        'want to use "autoFocus" please add "position: fixed" to styles of the element that is wrapped by',
                        '"Popper".',
                        `In general, it's not recommended to use "autoFocus" as it may break accessibility aspects:`,
                        'https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-autofocus.md',
                        '\n',
                        'We suggest to use the "trapFocus" prop on Fluent components or a catch "ref" and then use',
                        '"ref.current.focus" in React.useEffect():',
                        'https://reactjs.org/docs/refs-and-the-dom.html#adding-a-ref-to-a-dom-element'
                    ].join(' '));
                }
            }
        // We run this check once, no need to add deps here
        // TODO: Should be rework to handle options.enabled and contentRef updates
        }, []);
    }
    const setTarget = useCallbackRef(null, (target)=>{
        if (targetRef.current !== target) {
            targetRef.current = target;
            updatePositionManager();
        }
    });
    const onPositioningEnd = useEventCallback(()=>{
        var _options_onPositioningEnd;
        return (_options_onPositioningEnd = options.onPositioningEnd) === null || _options_onPositioningEnd === undefined ? undefined : _options_onPositioningEnd.call(options);
    });
    const setContainer = useCallbackRef(null, (container)=>{
        if (containerRef.current !== container) {
            var _containerRef_current;
            (_containerRef_current = containerRef.current) === null || _containerRef_current === undefined ? undefined : _containerRef_current.removeEventListener(POSITIONING_END_EVENT, onPositioningEnd);
            container === null || container === undefined ? undefined : container.addEventListener(POSITIONING_END_EVENT, onPositioningEnd);
            containerRef.current = container;
            updatePositionManager();
        }
    });
    const setArrow = useCallbackRef(null, (arrow)=>{
        if (arrowRef.current !== arrow) {
            arrowRef.current = arrow;
            updatePositionManager();
        }
    });
    // Let users use callback refs so they feel like 'normal' DOM refs
    return {
        targetRef: setTarget,
        containerRef: setContainer,
        arrowRef: setArrow
    };
}
function usePositioningOptions(options) {
    'use no memo';
    const { align, arrowPadding, autoSize: rawAutoSize, coverTarget: coverTarget$1, flipBoundary, offset, overflowBoundary, pinned, position, unstable_disableTether: disableTether, // eslint-disable-next-line deprecation/deprecation
    positionFixed, strategy, overflowBoundaryPadding, fallbackPositions, useTransform, matchTargetSize: matchTargetSize$1, disableUpdateOnResize = false, shiftToCoverTarget } = options;
    const { dir, targetDocument } = useFluent();
    const isRtl = dir === 'rtl';
    const positionStrategy = (strategy !== null && strategy !== undefined ? strategy : positionFixed) ? 'fixed' : 'absolute';
    const autoSize = normalizeAutoSize(rawAutoSize);
    return React.useCallback((container, arrow$1)=>{
        const hasScrollableElement = hasScrollParent(container);
        const middleware = [
            autoSize && resetMaxSize(autoSize),
            matchTargetSize$1 && matchTargetSize(),
            offset && offset$1(offset),
            coverTarget$1 && coverTarget(),
            !pinned && flip({
                container,
                flipBoundary,
                hasScrollableElement,
                isRtl,
                fallbackPositions
            }),
            shift({
                container,
                hasScrollableElement,
                overflowBoundary,
                disableTether,
                overflowBoundaryPadding,
                isRtl,
                shiftToCoverTarget
            }),
            autoSize && maxSize(autoSize, {
                container,
                overflowBoundary,
                overflowBoundaryPadding,
                isRtl
            }),
            intersecting(),
            arrow$1 && arrow({
                element: arrow$1,
                padding: arrowPadding
            }),
            hide({
                strategy: 'referenceHidden'
            }),
            hide({
                strategy: 'escaped'
            }),
            process.env.NODE_ENV !== 'production' && targetDocument && devtools(targetDocument, devtoolsCallback(options))
        ].filter(Boolean);
        const placement = toFloatingUIPlacement(align, position, isRtl);
        return {
            placement,
            middleware,
            strategy: positionStrategy,
            useTransform,
            disableUpdateOnResize
        };
    }, // Options is missing here, but it's not required
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        align,
        arrowPadding,
        autoSize,
        coverTarget$1,
        disableTether,
        flipBoundary,
        isRtl,
        offset,
        overflowBoundary,
        pinned,
        position,
        positionStrategy,
        overflowBoundaryPadding,
        fallbackPositions,
        useTransform,
        matchTargetSize$1,
        targetDocument,
        disableUpdateOnResize
    ]);
}

/**
 * @internal
 * A state hook that manages a popper virtual element from mouseevents.
 * Useful for scenarios where a component needs to be positioned by mouse click (e.g. contextmenu)
 * React synthetic events are not persisted by this hook
 *
 * @param initialState - initializes a user provided state similare to useState
 * @returns state and dispatcher for a Popper virtual element that uses native/synthetic mouse events
 */ const usePositioningMouseTarget = (initialState)=>{
    const [virtualElement, setVirtualElement] = React.useState(initialState);
    const setVirtualMouseTarget = (event)=>{
        if (event === undefined || event === null) {
            setVirtualElement(undefined);
            return;
        }
        let mouseevent;
        if (!(event instanceof MouseEvent)) {
            mouseevent = event.nativeEvent;
        } else {
            mouseevent = event;
        }
        if (!(mouseevent instanceof MouseEvent) && process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error('usePositioningMouseTarget should only be used with MouseEvent');
        }
        const contextTarget = createVirtualElementFromClick(mouseevent);
        setVirtualElement(contextTarget);
    };
    return [
        virtualElement,
        setVirtualMouseTarget
    ];
};

const PopoverContext = createContext(undefined);
const popoverContextDefaultValue = {
    open: false,
    setOpen: ()=>null,
    toggleOpen: ()=>null,
    triggerRef: {
        current: null
    },
    contentRef: {
        current: null
    },
    arrowRef: {
        current: null
    },
    openOnContext: false,
    openOnHover: false,
    size: 'medium',
    trapFocus: false,
    inline: false
};
PopoverContext.Provider;
const usePopoverContext_unstable = (selector)=>useContextSelector(PopoverContext, (ctx = popoverContextDefaultValue)=>selector(ctx));

/**
 * Create the state required to render PopoverSurface.
 *
 * The returned state can be modified with hooks such as usePopoverSurfaceStyles_unstable,
 * before being passed to renderPopoverSurface_unstable.
 *
 * @param props - props from this instance of PopoverSurface
 * @param ref - reference to root HTMLDivElement of PopoverSurface
 */ const usePopoverSurface_unstable = (props, ref)=>{
    const contentRef = usePopoverContext_unstable((context)=>context.contentRef);
    const openOnHover = usePopoverContext_unstable((context)=>context.openOnHover);
    const setOpen = usePopoverContext_unstable((context)=>context.setOpen);
    const mountNode = usePopoverContext_unstable((context)=>context.mountNode);
    const arrowRef = usePopoverContext_unstable((context)=>context.arrowRef);
    const size = usePopoverContext_unstable((context)=>context.size);
    const withArrow = usePopoverContext_unstable((context)=>context.withArrow);
    const appearance = usePopoverContext_unstable((context)=>context.appearance);
    const trapFocus = usePopoverContext_unstable((context)=>context.trapFocus);
    const inertTrapFocus = usePopoverContext_unstable((context)=>context.inertTrapFocus);
    const inline = usePopoverContext_unstable((context)=>context.inline);
    const { modalAttributes } = useModalAttributes({
        trapFocus,
        legacyTrapFocus: !inertTrapFocus,
        alwaysFocusable: !trapFocus
    });
    const state = {
        inline,
        appearance,
        withArrow,
        size,
        arrowRef,
        mountNode,
        components: {
            root: 'div'
        },
        root: always(getIntrinsicElementProps('div', {
            // FIXME:
            // `contentRef` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: useMergedRefs(ref, contentRef),
            role: trapFocus ? 'dialog' : 'group',
            'aria-modal': trapFocus ? true : undefined,
            ...modalAttributes,
            ...props
        }), {
            elementType: 'div'
        })
    };
    const { onMouseEnter: onMouseEnterOriginal, onMouseLeave: onMouseLeaveOriginal, onKeyDown: onKeyDownOriginal } = state.root;
    state.root.onMouseEnter = (e)=>{
        if (openOnHover) {
            setOpen(e, true);
        }
        onMouseEnterOriginal === null || onMouseEnterOriginal === undefined ? undefined : onMouseEnterOriginal(e);
    };
    state.root.onMouseLeave = (e)=>{
        if (openOnHover) {
            setOpen(e, false);
        }
        onMouseLeaveOriginal === null || onMouseLeaveOriginal === undefined ? undefined : onMouseLeaveOriginal(e);
    };
    state.root.onKeyDown = (e)=>{
        var _contentRef_current;
        // only close if the event happened inside the current popover
        // If using a stack of inline popovers, the user should call `stopPropagation` to avoid dismissing the entire stack
        if (e.key === 'Escape' && ((_contentRef_current = contentRef.current) === null || _contentRef_current === undefined ? undefined : _contentRef_current.contains(e.target))) {
            e.preventDefault();
            setOpen(e, false);
        }
        onKeyDownOriginal === null || onKeyDownOriginal === undefined ? undefined : onKeyDownOriginal(e);
    };
    return state;
};

/**
 * The function that normalizes the `mountNode` prop into an object with element and className props.
 *
 * @param mountNode - an HTML element or an object with props
 */ function toMountNodeProps(mountNode) {
    if (isHTMLElement$3(mountNode)) {
        return {
            element: mountNode
        };
    }
    if (typeof mountNode === 'object') {
        if (mountNode === null) {
            return {
                element: null
            };
        }
        return mountNode;
    }
    return {};
}

// src/useIsStrictMode.ts
var getCurrentOwner = () => {
  try {
    return React["".concat(
      "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE"
    )].A.getOwner();
  } catch {
  }
  try {
    return React["".concat("__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")].ReactCurrentOwner.current;
  } catch {
    if (process.env.NODE_ENV !== "production") {
      console.error(
        "use-disposable: failed to get current fiber, please report this bug to maintainers"
      );
    }
  }
};
var REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var useIsStrictMode = () => {
  if (process.env.NODE_ENV === "production") {
    return false;
  }
  const isStrictMode = React.useRef(undefined);
  const reactMajorVersion = React.useMemo(() => {
    return Number(React.version.split(".")[0]);
  }, [React.version]);
  if (isNaN(reactMajorVersion) || reactMajorVersion < 18) {
    return false;
  }
  if (isStrictMode.current === undefined) {
    let currentOwner = getCurrentOwner();
    while (currentOwner && currentOwner.return) {
      currentOwner = currentOwner.return;
      if (currentOwner.type === REACT_STRICT_MODE_TYPE || currentOwner.elementType === REACT_STRICT_MODE_TYPE) {
        isStrictMode.current = true;
      }
    }
  }
  return !!isStrictMode.current;
};
var effectSet = /* @__PURE__ */ new WeakSet();
function useStrictEffect(effect, deps) {
  const currentOwner = getCurrentOwner();
  React.useEffect(() => {
    if (!effectSet.has(currentOwner)) {
      effectSet.add(currentOwner);
      effect();
      return;
    }
    const dispose = effect();
    return dispose;
  }, deps);
}
var memoSet = /* @__PURE__ */ new WeakSet();
function useStrictMemo(factory, deps) {
  return React.useMemo(() => {
    const currentOwner = getCurrentOwner();
    if (!memoSet.has(currentOwner)) {
      memoSet.add(currentOwner);
      return null;
    }
    return factory();
  }, deps);
}

// src/useDisposable.ts
function useDisposable(factory, deps) {
  var _a;
  const isStrictMode = useIsStrictMode() && process.env.NODE_ENV !== "production";
  const useMemo4 = isStrictMode ? useStrictMemo : React.useMemo;
  const useEffect3 = isStrictMode ? useStrictEffect : React.useEffect;
  const [disposable, dispose] = (_a = useMemo4(() => factory(), deps)) != null ? _a : [
    null,
    () => null
  ];
  useEffect3(() => {
    return dispose;
  }, deps);
  return disposable;
}

const usePortalMountNodeStylesStyles = /*#__PURE__*/__styles({
  root: {
    qhf8xq: "f1euv43f",
    Bhzewxz: "f15twtuk",
    oyh7mz: ["f1vgc2s3", "f1e31b4d"],
    j35jbq: ["f1e31b4d", "f1vgc2s3"],
    Bj3rh1h: "f494woh"
  }
}, {
  d: [".f1euv43f{position:absolute;}", ".f15twtuk{top:0;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", ".f494woh{z-index:1000000;}"]
});

const useInsertionEffect = React['useInsertion' + 'Effect'];
/**
 * Creates a new element on a "document.body" to mount portals.
 */ const usePortalMountNode = (options)=>{
    'use no memo';
    const { targetDocument, dir } = useFluent();
    const mountNode = usePortalMountNode$1();
    const focusVisibleRef = useFocusVisible();
    const classes = usePortalMountNodeStylesStyles();
    const themeClassName = useThemeClassName();
    const className = mergeClasses(themeClassName, classes.root, options.className);
    const targetNode = mountNode !== null && mountNode !== undefined ? mountNode : targetDocument === null || targetDocument === undefined ? undefined : targetDocument.body;
    const element = useDisposable(()=>{
        if (targetNode === undefined || options.disabled) {
            return [
                null,
                ()=>null
            ];
        }
        const newElement = targetNode.ownerDocument.createElement('div');
        targetNode.appendChild(newElement);
        return [
            newElement,
            ()=>newElement.remove()
        ];
    }, [
        targetNode
    ]);
    if (useInsertionEffect) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useInsertionEffect(()=>{
            if (!element) {
                return;
            }
            const classesToApply = className.split(' ').filter(Boolean);
            element.classList.add(...classesToApply);
            element.setAttribute('dir', dir);
            element.setAttribute('data-portal-node', 'true');
            focusVisibleRef.current = element;
            return ()=>{
                element.classList.remove(...classesToApply);
                element.removeAttribute('dir');
            };
        }, [
            className,
            dir,
            element,
            focusVisibleRef
        ]);
    } else {
        // This useMemo call is intentional for React 17
        // We don't want to re-create the portal element when its attributes change.
        // This also should not be done in an effect because, changing the value of css variables
        // after initial mount can trigger interesting CSS side effects like transitions.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useMemo(()=>{
            if (!element) {
                return;
            }
            // Force replace all classes
            element.className = className;
            element.setAttribute('dir', dir);
            element.setAttribute('data-portal-node', 'true');
            focusVisibleRef.current = element;
        }, [
            className,
            dir,
            element,
            focusVisibleRef
        ]);
    }
    return element;
};

/**
 * Create the state required to render Portal.
 *
 * The returned state can be modified with hooks such as usePortalStyles, before being passed to renderPortal_unstable.
 *
 * @param props - props from this instance of Portal
 */ const usePortal_unstable = (props)=>{
    const { element, className } = toMountNodeProps(props.mountNode);
    const virtualParentRootRef = React.useRef(null);
    const fallbackElement = usePortalMountNode({
        disabled: !!element,
        className
    });
    const mountNode = element !== null && element !== undefined ? element : fallbackElement;
    const state = {
        children: props.children,
        mountNode,
        virtualParentRootRef
    };
    React.useEffect(()=>{
        if (!mountNode) {
            return;
        }
        const virtualParent = virtualParentRootRef.current;
        // By default, we create a mount node for portal on `document.body` (see usePortalMountNode()) and have following structure:
        //
        // <body>
        //   <!-- ⚛️ application root -->
        //   <div id="root">
        //     <!-- ⬇️ portal node rendered in a tree to anchor (virtual parent node) -->
        //     <span aria-hidden="true"></span>
        //   </div>
        //   <div id="portal-mount-node">
        //     <!-- 🧩portal content -->
        //   </div>
        // </body>
        //
        // To make sure that `.elementContains()` works correctly, we link a virtual parent to a portal node (a virtual parent node becomes a parent of mount node):
        //   virtual.contains(mountNode) === false
        //   (while we need ⬇️⬇️⬇️)
        //   elementsContains(virtualParent, mountNode) === true
        //   elementsContains(mountNode, virtualParent) === false
        //
        // For more details, check docs for virtual parent utils.
        //
        // However, if a user provides a custom mount node (via `props`) the structure could be different:
        //
        // <body>
        //   <!-- application root -->
        //   <div id="root">
        //     <div id="portal-mount-node">
        //       <!-- 🧩portal content -->
        //
        //       <span aria-hidden="true"></span>
        //     </div>
        //   </div>
        // </body>
        //
        // A mount node in this case contains portal's content and a virtual parent node. In this case nodes linking is redundant and the check below avoids it.
        //
        // Otherwise, there is a circular reference - both elements are parents of each other:
        //   elementsContains(mountNode, virtualParent) === true
        //   elementsContains(virtualParent, mountNode) === true
        const isVirtualParentInsideChild = mountNode.contains(virtualParent);
        if (virtualParent && !isVirtualParentInsideChild) {
            setVirtualParent(mountNode, virtualParent);
            return ()=>{
                setVirtualParent(mountNode, undefined);
            };
        }
    }, [
        virtualParentRootRef,
        mountNode
    ]);
    return state;
};

/**
 * Render the final JSX of Portal
 */ const renderPortal_unstable = (state)=>{
    return /*#__PURE__*/ React.createElement("span", {
        hidden: true,
        ref: state.virtualParentRootRef
    }, state.mountNode && /*#__PURE__*/ ReactDOM.createPortal(state.children, state.mountNode));
};

/**
 * A portal provides a way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ const Portal = (props)=>{
    const state = usePortal_unstable(props);
    return renderPortal_unstable(state);
};
Portal.displayName = 'Portal';

/**
 * Render the final JSX of PopoverSurface
 */ const renderPopoverSurface_unstable = (state)=>{
    assertSlots(state);
    const surface = /*#__PURE__*/ jsxs(state.root, {
        children: [
            state.withArrow && /*#__PURE__*/ jsx("div", {
                ref: state.arrowRef,
                className: state.arrowClassName
            }),
            state.root.children
        ]
    });
    if (state.inline) {
        return surface;
    }
    return /*#__PURE__*/ jsx(Portal, {
        mountNode: state.mountNode,
        children: surface
    });
};

const popoverSurfaceClassNames = {
  root: 'fui-PopoverSurface'
};
const arrowHeights = {
  small: 6,
  medium: 8,
  large: 8
};
/**
 * Styles for the root slot
 */
const useStyles$D = /*#__PURE__*/__styles({
  root: {
    sj55zd: "f19n0e5",
    De3pzq: "fxugw4r",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "f9ggezi",
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi",
    B93otf3: "f1hdglry",
    vin17d: "fo1kyvf",
    Ezkn3b: "fetxo7e",
    nyiy2g: "f8x1vz1",
    swvrvq: "f8g0anz",
    Bkovbt3: "fezwn9i",
    hgjdhn: "fz5efge",
    fsy9dk: "f1ydixl4",
    B3ogreh: "f8dgqj5",
    jv49x5: "fnyfnr8",
    Bk7o48c: "fgw77r4",
    Bv12yb3: "ftje0s4",
    vcguit: "fxes1gr",
    z0t1cu: "fi19xcv",
    Bks05zx: "f1mzajhk",
    yckwsp: "fgez7cy",
    Bvtglag: "fjp4h9y",
    Bhu2qc9: "fymb6k8"
  },
  inline: {
    Bj3rh1h: "f19g0ac"
  },
  inverted: {
    De3pzq: "fg3r6xk",
    sj55zd: "fonrgv7"
  },
  brand: {
    De3pzq: "ffp7eso",
    sj55zd: "f1phragk"
  },
  smallPadding: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1sy4kr4"
  },
  mediumPadding: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f4zyqsv"
  },
  largePadding: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fop8ug2"
  },
  smallArrow: {
    rhnwrx: "f1s3jn22",
    Bdy53xb: "fv40uqz"
  },
  mediumLargeArrow: {
    rhnwrx: "f1f72gjr",
    Bdy53xb: "f69yoe5"
  },
  arrow: {
    B7ck84d: "f1ewtqcl",
    qhf8xq: "f1euv43f",
    Bj3rh1h: "f1bsuimh",
    De3pzq: "f1u2r49w",
    B2eet1l: "fqhgnl",
    Beyfa6y: "f17bz04i",
    Bz10aip: "f36o3x3",
    Bqenvij: "fzofk8q",
    a9b677: "f1wbx1ie",
    Ftih45: "f1wl9k8s",
    Br0sdwz: "f1aocrix",
    cmx5o7: "f1ljr5q2",
    susq4k: 0,
    Biibvgv: 0,
    Bicfajf: 0,
    qehafq: 0,
    Brs5u8j: "f155f1qt",
    Ccq8qp: "f9mhzq7",
    Baz25je: "fr6rhvx",
    Bcgcnre: 0,
    Bqjgrrk: 0,
    qa3bma: 0,
    y0oebl: 0,
    Biqmznv: 0,
    Bm6vgfq: 0,
    Bbv0w2i: 0,
    uvfttm: 0,
    eqrjj: 0,
    Bk5zm6e: 0,
    m598lv: 0,
    B4f6apu: 0,
    ydt019: 0,
    Bq4z7u6: 0,
    Bdkvgpv: 0,
    B0qfbqy: 0,
    kj8mxx: "f1kc0wz4",
    r59vdv: "fgq90dz",
    Bkw5xw4: "fq0y47f",
    hl6cv3: "f1pwrbz6",
    aea9ga: "f1hxxcvm",
    yayu3t: "fw8rgyo",
    Bhsv975: "f1wnzycx",
    rhl9o9: "f1730wal",
    B7gxrvb: "f1fy4ixr",
    B6q6orb: "fobkauc",
    B0lu1f8: "f16bqv1l"
  }
}, {
  d: [".f19n0e5{color:var(--colorNeutralForeground1);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".f9ggezi{border:1px solid var(--colorTransparentStroke);}", {
    p: -2
  }], ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}", ".f1hdglry{animation-composition:replace,accumulate;}", ".fo1kyvf{animation-duration:var(--durationSlower);}", ".fetxo7e{animation-timing-function:var(--curveDecelerateMid);}", ".f8x1vz1{--fui-positioning-slide-distance-x:0px;}", ".f8g0anz{--fui-positioning-slide-distance-y:10px;}", ".fezwn9i[data-popper-placement^=right]{--fui-positioning-slide-distance-x:-10px;}", ".fz5efge[data-popper-placement^=right]{--fui-positioning-slide-distance-y:0px;}", ".f1ydixl4[data-popper-placement^=bottom]{--fui-positioning-slide-distance-x:0px;}", ".f8dgqj5[data-popper-placement^=bottom]{--fui-positioning-slide-distance-y:-10px;}", ".fnyfnr8[data-popper-placement^=left]{--fui-positioning-slide-distance-x:10px;}", ".fgw77r4[data-popper-placement^=left]{--fui-positioning-slide-distance-y:0px;}", ".ftje0s4{animation-name:f5j8bii,f79suad;}", ".fymb6k8{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 8px 16px var(--colorNeutralShadowKey));}", ".f19g0ac{z-index:1;}", ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}", ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}", ".ffp7eso{background-color:var(--colorBrandBackground);}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", [".f1sy4kr4{padding:12px;}", {
    p: -1
  }], [".f4zyqsv{padding:16px;}", {
    p: -1
  }], [".fop8ug2{padding:20px;}", {
    p: -1
  }], ".f1s3jn22{--fui-positioning-arrow-height:8.484px;}", ".fv40uqz{--fui-positioning-arrow-offset:-4.242px;}", ".f1f72gjr{--fui-positioning-arrow-height:11.312px;}", ".f69yoe5{--fui-positioning-arrow-offset:-5.656px;}", ".f1ewtqcl{box-sizing:border-box;}", ".f1euv43f{position:absolute;}", ".f1bsuimh{z-index:-1;}", ".f1u2r49w{background-color:inherit;}", ".fqhgnl{background-clip:content-box;}", ".f17bz04i{border-bottom-left-radius:var(--borderRadiusSmall);}", ".f36o3x3{transform:rotate(var(--fui-positioning-arrow-angle));}", ".fzofk8q{height:var(--fui-positioning-arrow-height);}", ".f1wbx1ie{width:var(--fui-positioning-arrow-height);}", ".f1wl9k8s::before{content:\"\";}", ".f1aocrix::before{display:block;}", ".f1ljr5q2::before{background-color:inherit;}", [".f155f1qt::before{margin:-1px;}", {
    p: -1
  }], ".f9mhzq7::before{width:100%;}", ".fr6rhvx::before{height:100%;}", [".f1kc0wz4::before{border:1px solid var(--colorTransparentStroke);}", {
    p: -2
  }], ".fgq90dz::before{border-bottom-left-radius:var(--borderRadiusSmall);}", ".fq0y47f::before{clip-path:polygon(0% 0%, 100% 100%, 0% 100%);}", "[data-popper-placement^=\"top\"] .f1pwrbz6{bottom:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"top\"] .f1hxxcvm{--fui-positioning-arrow-angle:-45deg;}", "[data-popper-placement^=\"right\"] .fw8rgyo{left:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"right\"] .f1wnzycx{--fui-positioning-arrow-angle:45deg;}", "[data-popper-placement^=\"bottom\"] .f1730wal{top:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"bottom\"] .f1fy4ixr{--fui-positioning-arrow-angle:135deg;}", "[data-popper-placement^=\"left\"] .fobkauc{right:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"left\"] .f16bqv1l{--fui-positioning-arrow-angle:225deg;}"],
  k: ["@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}", "@keyframes f79suad{from{transform:translate(var(--fui-positioning-slide-distance-x), var(--fui-positioning-slide-distance-y));}}"],
  m: [["@media (prefers-reduced-motion){.fxes1gr[data-popper-placement]{animation-composition:replace;}}", {
    m: "(prefers-reduced-motion)"
  }], ["@media (prefers-reduced-motion){.fi19xcv[data-popper-placement]{animation-duration:1ms;}}", {
    m: "(prefers-reduced-motion)"
  }], ["@media (prefers-reduced-motion){.f1mzajhk[data-popper-placement]{animation-name:f5j8bii;}}", {
    m: "(prefers-reduced-motion)"
  }]],
  t: ["@supports not (animation-composition: accumulate){.fgez7cy[data-popper-placement]{animation-composition:replace;}}", "@supports not (animation-composition: accumulate){.fjp4h9y[data-popper-placement]{animation-name:f5j8bii;}}"]
});
/**
 * Apply styling to the PopoverSurface slots based on the state
 */
const usePopoverSurfaceStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$D();
  state.root.className = mergeClasses(popoverSurfaceClassNames.root, styles.root, state.inline && styles.inline, state.size === 'small' && styles.smallPadding, state.size === 'medium' && styles.mediumPadding, state.size === 'large' && styles.largePadding, state.appearance === 'inverted' && styles.inverted, state.appearance === 'brand' && styles.brand, state.root.className);
  state.arrowClassName = mergeClasses(styles.arrow, state.size === 'small' ? styles.smallArrow : styles.mediumLargeArrow);
  return state;
};

/**
 * @internal
 * The default value of the tooltip's border radius (borderRadiusMedium).
 *
 * Unfortunately, Popper requires it to be specified as a variable instead of using CSS.
 * While we could use getComputedStyle, that adds a performance penalty for something that
 * will likely never change.
 */ const popoverSurfaceBorderRadius = 4;

/**
 * Create the state required to render Popover.
 *
 * The returned state can be modified with hooks such as usePopoverStyles,
 * before being passed to renderPopover_unstable.
 *
 * @param props - props from this instance of Popover
 */ const usePopover_unstable = (props)=>{
    const [contextTarget, setContextTarget] = usePositioningMouseTarget();
    const initialState = {
        size: 'medium',
        contextTarget,
        setContextTarget,
        ...props
    };
    const children = React.Children.toArray(props.children);
    if (process.env.NODE_ENV !== 'production') {
        if (children.length === 0) {
            // eslint-disable-next-line no-console
            console.warn('Popover must contain at least one child');
        }
        if (children.length > 2) {
            // eslint-disable-next-line no-console
            console.warn('Popover must contain at most two children');
        }
    }
    let popoverTrigger = undefined;
    let popoverSurface = undefined;
    if (children.length === 2) {
        popoverTrigger = children[0];
        popoverSurface = children[1];
    } else if (children.length === 1) {
        popoverSurface = children[0];
    }
    const [open, setOpenState] = useOpenState(initialState);
    const [setOpenTimeout, clearOpenTimeout] = useTimeout();
    const setOpen = useEventCallback((e, shouldOpen)=>{
        clearOpenTimeout();
        if (!(e instanceof Event) && e.persist) {
            // < React 17 still uses pooled synthetic events
            e.persist();
        }
        if (e.type === 'mouseleave') {
            var _props_mouseLeaveDelay;
            // FIXME leaking Node timeout type
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setOpenTimeout(()=>{
                setOpenState(e, shouldOpen);
            }, (_props_mouseLeaveDelay = props.mouseLeaveDelay) !== null && _props_mouseLeaveDelay !== undefined ? _props_mouseLeaveDelay : 500);
        } else {
            setOpenState(e, shouldOpen);
        }
    });
    const toggleOpen = React.useCallback((e)=>{
        setOpen(e, !open);
    }, [
        setOpen,
        open
    ]);
    const positioningRefs = usePopoverRefs(initialState);
    const { targetDocument } = useFluent();
    var _props_closeOnIframeFocus;
    useOnClickOutside({
        contains: elementContains,
        element: targetDocument,
        callback: (ev)=>setOpen(ev, false),
        refs: [
            positioningRefs.triggerRef,
            positioningRefs.contentRef
        ],
        disabled: !open,
        disabledFocusOnIframe: !((_props_closeOnIframeFocus = props.closeOnIframeFocus) !== null && _props_closeOnIframeFocus !== undefined ? _props_closeOnIframeFocus : true)
    });
    // only close on scroll for context, or when closeOnScroll is specified
    const closeOnScroll = initialState.openOnContext || initialState.closeOnScroll;
    useOnScrollOutside({
        contains: elementContains,
        element: targetDocument,
        callback: (ev)=>setOpen(ev, false),
        refs: [
            positioningRefs.triggerRef,
            positioningRefs.contentRef
        ],
        disabled: !open || !closeOnScroll
    });
    const { findFirstFocusable } = useFocusFinders();
    React.useEffect(()=>{
        if (props.unstable_disableAutoFocus) {
            return;
        }
        if (open && positioningRefs.contentRef.current) {
            var _positioningRefs_contentRef_current_getAttribute;
            const containerTabIndex = (_positioningRefs_contentRef_current_getAttribute = positioningRefs.contentRef.current.getAttribute('tabIndex')) !== null && _positioningRefs_contentRef_current_getAttribute !== undefined ? _positioningRefs_contentRef_current_getAttribute : undefined;
            const firstFocusable = isNaN(containerTabIndex) ? findFirstFocusable(positioningRefs.contentRef.current) : positioningRefs.contentRef.current;
            firstFocusable === null || firstFocusable === undefined ? undefined : firstFocusable.focus();
        }
    }, [
        findFirstFocusable,
        open,
        positioningRefs.contentRef,
        props.unstable_disableAutoFocus
    ]);
    var _props_inertTrapFocus, _props_inline;
    return {
        ...initialState,
        ...positioningRefs,
        // eslint-disable-next-line deprecation/deprecation
        inertTrapFocus: (_props_inertTrapFocus = props.inertTrapFocus) !== null && _props_inertTrapFocus !== undefined ? _props_inertTrapFocus : props.legacyTrapFocus === undefined ? false : !props.legacyTrapFocus,
        popoverTrigger,
        popoverSurface,
        open,
        setOpen,
        toggleOpen,
        setContextTarget,
        contextTarget,
        inline: (_props_inline = props.inline) !== null && _props_inline !== undefined ? _props_inline : false
    };
};
/**
 * Creates and manages the Popover open state
 */ function useOpenState(state) {
    'use no memo';
    const onOpenChange = useEventCallback((e, data)=>{
        var _state_onOpenChange;
        return (_state_onOpenChange = state.onOpenChange) === null || _state_onOpenChange === undefined ? undefined : _state_onOpenChange.call(state, e, data);
    });
    const [open, setOpenState] = useControllableState({
        state: state.open,
        defaultState: state.defaultOpen,
        initialState: false
    });
    state.open = open !== undefined ? open : state.open;
    const setContextTarget = state.setContextTarget;
    const setOpen = React.useCallback((e, shouldOpen)=>{
        if (shouldOpen && e.type === 'contextmenu') {
            setContextTarget(e);
        }
        if (!shouldOpen) {
            setContextTarget(undefined);
        }
        setOpenState(shouldOpen);
        onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
            open: shouldOpen
        });
    }, [
        setOpenState,
        onOpenChange,
        setContextTarget
    ]);
    return [
        open,
        setOpen
    ];
}
/**
 * Creates and sets the necessary trigger, target and content refs used by Popover
 */ function usePopoverRefs(state) {
    'use no memo';
    const positioningOptions = {
        position: 'above',
        align: 'center',
        arrowPadding: 2 * popoverSurfaceBorderRadius,
        target: state.openOnContext ? state.contextTarget : undefined,
        ...resolvePositioningShorthand(state.positioning)
    };
    // no reason to render arrow when covering the target
    if (positioningOptions.coverTarget) {
        state.withArrow = false;
    }
    if (state.withArrow) {
        positioningOptions.offset = mergeArrowOffset(positioningOptions.offset, arrowHeights[state.size]);
    }
    const { targetRef: triggerRef, containerRef: contentRef, arrowRef } = usePositioning(positioningOptions);
    return {
        triggerRef,
        contentRef,
        arrowRef
    };
}

/**
 * Render the final JSX of Popover
 */ const renderPopover_unstable = (state)=>{
    const { appearance, arrowRef, contentRef, inline, mountNode, open, openOnContext, openOnHover, setOpen, size, toggleOpen, trapFocus, triggerRef, withArrow, inertTrapFocus } = state;
    return /*#__PURE__*/ React.createElement(PopoverContext.Provider, {
        value: {
            appearance,
            arrowRef,
            contentRef,
            inline,
            mountNode,
            open,
            openOnContext,
            openOnHover,
            setOpen,
            toggleOpen,
            triggerRef,
            size,
            trapFocus,
            inertTrapFocus,
            withArrow
        }
    }, state.popoverTrigger, state.open && state.popoverSurface);
};

/**
 * Create the state required to render PopoverTrigger.
 *
 * The returned state can be modified with hooks such as usePopoverTriggerStyles,
 * before being passed to renderPopoverTrigger_unstable.
 *
 * @param props - props from this instance of PopoverTrigger
 */ const usePopoverTrigger_unstable = (props)=>{
    const { children, disableButtonEnhancement = false } = props;
    const child = getTriggerChild(children);
    const open = usePopoverContext_unstable((context)=>context.open);
    const setOpen = usePopoverContext_unstable((context)=>context.setOpen);
    const toggleOpen = usePopoverContext_unstable((context)=>context.toggleOpen);
    const triggerRef = usePopoverContext_unstable((context)=>context.triggerRef);
    const openOnHover = usePopoverContext_unstable((context)=>context.openOnHover);
    const openOnContext = usePopoverContext_unstable((context)=>context.openOnContext);
    const { triggerAttributes } = useModalAttributes();
    const onContextMenu = (e)=>{
        if (openOnContext) {
            e.preventDefault();
            setOpen(e, true);
        }
    };
    const onClick = (e)=>{
        if (!openOnContext) {
            toggleOpen(e);
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === Escape && open && !e.isDefaultPrevented()) {
            setOpen(e, false);
            // stop propagation to avoid conflicting with other elements that listen for `Escape`
            // e,g: Dialog, Popover, Menu and Tooltip
            e.preventDefault();
        }
    };
    const onMouseEnter = (e)=>{
        if (openOnHover) {
            setOpen(e, true);
        }
    };
    const onMouseLeave = (e)=>{
        if (openOnHover) {
            setOpen(e, false);
        }
    };
    const contextMenuProps = {
        ...triggerAttributes,
        'aria-expanded': `${open}`,
        ...child === null || child === undefined ? undefined : child.props,
        onMouseEnter: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : child.props.onMouseEnter, onMouseEnter)),
        onMouseLeave: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : child.props.onMouseLeave, onMouseLeave)),
        onContextMenu: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : child.props.onContextMenu, onContextMenu)),
        ref: useMergedRefs(triggerRef, child === null || child === undefined ? undefined : child.ref)
    };
    const triggerChildProps = {
        ...contextMenuProps,
        onClick: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : child.props.onClick, onClick)),
        onKeyDown: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : child.props.onKeyDown, onKeyDown))
    };
    const ariaButtonTriggerChildProps = useARIAButtonProps((child === null || child === undefined ? undefined : child.type) === 'button' || (child === null || child === undefined ? undefined : child.type) === 'a' ? child.type : 'div', triggerChildProps);
    return {
        children: applyTriggerPropsToChildren(props.children, useARIAButtonProps((child === null || child === undefined ? undefined : child.type) === 'button' || (child === null || child === undefined ? undefined : child.type) === 'a' ? child.type : 'div', openOnContext ? contextMenuProps : disableButtonEnhancement ? triggerChildProps : ariaButtonTriggerChildProps))
    };
};

/**
 * Render the final JSX of PopoverTrigger
 */ const renderPopoverTrigger_unstable = (state)=>{
    return state.children;
};

/**
 * The height of the tooltip's arrow in pixels.
 */ const arrowHeight = 6;
/**
 * The default value of the tooltip's border radius (borderRadiusMedium).
 *
 * Unfortunately, Popper requires it to be specified as a variable instead of using CSS.
 * While we could use getComputedStyle, that adds a performance penalty for something that
 * will likely never change.
 */ const tooltipBorderRadius = 4;

/**
 * Create the state required to render Tooltip.
 *
 * The returned state can be modified with hooks such as useTooltipStyles_unstable,
 * before being passed to renderTooltip_unstable.
 *
 * @param props - props from this instance of Tooltip
 */ const useTooltip_unstable = (props)=>{
    'use no memo';
    var _child_props, _child_props1, _child_props2, _child_props3, _child_props4, _child_props5;
    const context = useTooltipVisibility();
    const isServerSideRender = useIsSSR();
    const { targetDocument } = useFluent();
    const [setDelayTimeout, clearDelayTimeout] = useTimeout();
    const { appearance = 'normal', children, content, withArrow = false, positioning = 'above', onVisibleChange, relationship, showDelay = 250, hideDelay = 250, mountNode } = props;
    const [visible, setVisibleInternal] = useControllableState({
        state: props.visible,
        initialState: false
    });
    const setVisible = React.useCallback((ev, data)=>{
        clearDelayTimeout();
        setVisibleInternal((oldVisible)=>{
            if (data.visible !== oldVisible) {
                onVisibleChange === null || onVisibleChange === undefined ? undefined : onVisibleChange(ev, data);
            }
            return data.visible;
        });
    }, [
        clearDelayTimeout,
        setVisibleInternal,
        onVisibleChange
    ]);
    const state = {
        withArrow,
        positioning,
        showDelay,
        hideDelay,
        relationship,
        visible,
        shouldRenderTooltip: visible,
        appearance,
        mountNode,
        // Slots
        components: {
            content: 'div'
        },
        content: always(content, {
            defaultProps: {
                role: 'tooltip'
            },
            elementType: 'div'
        })
    };
    state.content.id = useId('tooltip-', state.content.id);
    const positioningOptions = {
        enabled: state.visible,
        arrowPadding: 2 * tooltipBorderRadius,
        position: 'above',
        align: 'center',
        offset: 4,
        ...resolvePositioningShorthand(state.positioning)
    };
    if (state.withArrow) {
        positioningOptions.offset = mergeArrowOffset(positioningOptions.offset, arrowHeight);
    }
    const { targetRef, containerRef, arrowRef } = usePositioning(positioningOptions);
    state.content.ref = useMergedRefs(state.content.ref, containerRef);
    state.arrowRef = arrowRef;
    // When this tooltip is visible, hide any other tooltips, and register it
    // as the visibleTooltip with the TooltipContext.
    // Also add a listener on document to hide the tooltip if Escape is pressed
    useIsomorphicLayoutEffect(()=>{
        if (visible) {
            var _context_visibleTooltip;
            const thisTooltip = {
                hide: (ev)=>setVisible(undefined, {
                        visible: false,
                        documentKeyboardEvent: ev
                    })
            };
            (_context_visibleTooltip = context.visibleTooltip) === null || _context_visibleTooltip === undefined ? undefined : _context_visibleTooltip.hide();
            context.visibleTooltip = thisTooltip;
            const onDocumentKeyDown = (ev)=>{
                if (ev.key === Escape && !ev.defaultPrevented) {
                    thisTooltip.hide(ev);
                    // stop propagation to avoid conflicting with other elements that listen for `Escape`
                    // e,g: Dialog, Popover, Menu and Tooltip
                    ev.preventDefault();
                }
            };
            targetDocument === null || targetDocument === undefined ? undefined : targetDocument.addEventListener('keydown', onDocumentKeyDown, {
                // As this event is added at targeted document,
                // we need to capture the event to be sure keydown handling from tooltip happens first
                capture: true
            });
            return ()=>{
                if (context.visibleTooltip === thisTooltip) {
                    context.visibleTooltip = undefined;
                }
                targetDocument === null || targetDocument === undefined ? undefined : targetDocument.removeEventListener('keydown', onDocumentKeyDown, {
                    capture: true
                });
            };
        }
    }, [
        context,
        targetDocument,
        visible,
        setVisible
    ]);
    // Used to skip showing the tooltip  in certain situations when the trigger is focused.
    // See comments where this is set for more info.
    const ignoreNextFocusEventRef = React.useRef(false);
    // Listener for onPointerEnter and onFocus on the trigger element
    const onEnterTrigger = React.useCallback((ev)=>{
        if (ev.type === 'focus' && ignoreNextFocusEventRef.current) {
            ignoreNextFocusEventRef.current = false;
            return;
        }
        // Show immediately if another tooltip is already visible
        const delay = context.visibleTooltip ? 0 : state.showDelay;
        setDelayTimeout(()=>{
            setVisible(ev, {
                visible: true
            });
        }, delay);
        ev.persist(); // Persist the event since the setVisible call will happen asynchronously
    }, [
        setDelayTimeout,
        setVisible,
        state.showDelay,
        context
    ]);
    const isNavigatingWithKeyboard = useIsNavigatingWithKeyboard()();
    // Callback ref that attaches a keyborg:focusin event listener.
    const [keyborgListenerCallbackRef] = React.useState(()=>{
        const onKeyborgFocusIn = (ev)=>{
            var _ev_detail;
            // Skip showing the tooltip if focus moved programmatically.
            // For example, we don't want to show the tooltip when a dialog is closed
            // and Tabster programmatically restores focus to the trigger button.
            // See https://github.com/microsoft/fluentui/issues/27576
            if (((_ev_detail = ev.detail) === null || _ev_detail === undefined ? undefined : _ev_detail.isFocusedProgrammatically) && !isNavigatingWithKeyboard) {
                ignoreNextFocusEventRef.current = true;
            }
        };
        // Save the current element to remove the listener when the ref changes
        let current = null;
        // Callback ref that attaches the listener to the element
        return (element)=>{
            current === null || current === undefined ? undefined : current.removeEventListener(KEYBORG_FOCUSIN, onKeyborgFocusIn);
            element === null || element === undefined ? undefined : element.addEventListener(KEYBORG_FOCUSIN, onKeyborgFocusIn);
            current = element;
        };
    });
    // Listener for onPointerLeave and onBlur on the trigger element
    const onLeaveTrigger = React.useCallback((ev)=>{
        let delay = state.hideDelay;
        if (ev.type === 'blur') {
            // Hide immediately when losing focus
            delay = 0;
            // The focused element gets a blur event when the document loses focus
            // (e.g. switching tabs in the browser), but we don't want to show the
            // tooltip again when the document gets focus back. Handle this case by
            // checking if the blurred element is still the document's activeElement.
            // See https://github.com/microsoft/fluentui/issues/13541
            ignoreNextFocusEventRef.current = (targetDocument === null || targetDocument === undefined ? undefined : targetDocument.activeElement) === ev.target;
        }
        setDelayTimeout(()=>{
            setVisible(ev, {
                visible: false
            });
        }, delay);
        ev.persist(); // Persist the event since the setVisible call will happen asynchronously
    }, [
        setDelayTimeout,
        setVisible,
        state.hideDelay,
        targetDocument
    ]);
    // Cancel the hide timer when the mouse or focus enters the tooltip, and restart it when the mouse or focus leaves.
    // This keeps the tooltip visible when the mouse is moved over it, or it has focus within.
    state.content.onPointerEnter = mergeCallbacks(state.content.onPointerEnter, clearDelayTimeout);
    state.content.onPointerLeave = mergeCallbacks(state.content.onPointerLeave, onLeaveTrigger);
    state.content.onFocus = mergeCallbacks(state.content.onFocus, clearDelayTimeout);
    state.content.onBlur = mergeCallbacks(state.content.onBlur, onLeaveTrigger);
    const child = getTriggerChild(children);
    const triggerAriaProps = {};
    const isMenuTrigger = (child === null || child === undefined ? undefined : (_child_props = child.props) === null || _child_props === undefined ? undefined : _child_props['aria-haspopup']) === 'menu' && (child === null || child === undefined ? undefined : (_child_props1 = child.props) === null || _child_props1 === undefined ? undefined : _child_props1['aria-expanded']);
    if (relationship === 'label') {
        // aria-label only works if the content is a string. Otherwise, need to use aria-labelledby.
        if (typeof state.content.children === 'string') {
            triggerAriaProps['aria-label'] = state.content.children;
        } else {
            triggerAriaProps['aria-labelledby'] = state.content.id;
            // Always render the tooltip even if hidden, so that aria-labelledby refers to a valid element
            state.shouldRenderTooltip = true;
        }
    } else if (relationship === 'description') {
        triggerAriaProps['aria-describedby'] = state.content.id;
        // Always render the tooltip even if hidden, so that aria-describedby refers to a valid element
        state.shouldRenderTooltip = true;
    }
    // Case 1: Don't render the Tooltip in SSR to avoid hydration errors
    // Case 2: Don't render the Tooltip, if it triggers Menu and it's already opened
    if (isServerSideRender || isMenuTrigger) {
        state.shouldRenderTooltip = false;
    }
    // Apply the trigger props to the child, either by calling the render function, or cloning with the new props
    state.children = applyTriggerPropsToChildren(children, {
        ...triggerAriaProps,
        ...child === null || child === undefined ? undefined : child.props,
        ref: useMergedRefs(child === null || child === undefined ? undefined : child.ref, keyborgListenerCallbackRef, // If the target prop is not provided, attach targetRef to the trigger element's ref prop
        positioningOptions.target === undefined ? targetRef : undefined),
        onPointerEnter: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : (_child_props2 = child.props) === null || _child_props2 === undefined ? undefined : _child_props2.onPointerEnter, onEnterTrigger)),
        onPointerLeave: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : (_child_props3 = child.props) === null || _child_props3 === undefined ? undefined : _child_props3.onPointerLeave, onLeaveTrigger)),
        onFocus: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : (_child_props4 = child.props) === null || _child_props4 === undefined ? undefined : _child_props4.onFocus, onEnterTrigger)),
        onBlur: useEventCallback(mergeCallbacks(child === null || child === undefined ? undefined : (_child_props5 = child.props) === null || _child_props5 === undefined ? undefined : _child_props5.onBlur, onLeaveTrigger))
    });
    return state;
};

/**
 * Render the final JSX of Tooltip
 */ const renderTooltip_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            state.children,
            state.shouldRenderTooltip && /*#__PURE__*/ jsx(Portal, {
                mountNode: state.mountNode,
                children: /*#__PURE__*/ jsxs(state.content, {
                    children: [
                        state.withArrow && /*#__PURE__*/ jsx("div", {
                            ref: state.arrowRef,
                            className: state.arrowClassName
                        }),
                        state.content.children
                    ]
                })
            })
        ]
    });
};

const tooltipClassNames = {
  content: 'fui-Tooltip__content'
};
/**
 * Styles for the tooltip
 */
const useStyles$C = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "fjseox",
    B7ck84d: "f1ewtqcl",
    B2u0y6b: "f132xexn",
    Bceei9c: "f158kwzp",
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bg96gwp: "fwrc4pm",
    Btd35i7: "fokg9q4",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    Bgfg5da: 0,
    B9xav0g: 0,
    oivjwe: 0,
    Bn0qgzm: 0,
    B4g9neb: 0,
    zhjwy3: 0,
    wvpqe5: 0,
    ibv6hh: 0,
    u1mtju: 0,
    h3c5rm: 0,
    vrafjx: 0,
    Bekrc4i: 0,
    i8vvqc: 0,
    g2u3we: 0,
    icvyot: 0,
    B4j52fo: 0,
    irswps: "f9ggezi",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1bzqsji",
    De3pzq: "fxugw4r",
    sj55zd: "f19n0e5",
    Bhu2qc9: "fxeb0a7"
  },
  visible: {
    mc9l5x: "ftgm304"
  },
  inverted: {
    De3pzq: "fg3r6xk",
    sj55zd: "fonrgv7"
  },
  arrow: {
    B7ck84d: "f1ewtqcl",
    qhf8xq: "f1euv43f",
    Bj3rh1h: "f1bsuimh",
    rhnwrx: "f1s3jn22",
    Bdy53xb: "fv40uqz",
    De3pzq: "f1u2r49w",
    B2eet1l: "fqhgnl",
    Beyfa6y: "f17bz04i",
    Bz10aip: "f36o3x3",
    Bqenvij: "fzofk8q",
    a9b677: "f1wbx1ie",
    Ftih45: "f1wl9k8s",
    Br0sdwz: "f1aocrix",
    cmx5o7: "f1ljr5q2",
    susq4k: 0,
    Biibvgv: 0,
    Bicfajf: 0,
    qehafq: 0,
    Brs5u8j: "f155f1qt",
    Ccq8qp: "f9mhzq7",
    Baz25je: "fr6rhvx",
    Bcgcnre: 0,
    Bqjgrrk: 0,
    qa3bma: 0,
    y0oebl: 0,
    Biqmznv: 0,
    Bm6vgfq: 0,
    Bbv0w2i: 0,
    uvfttm: 0,
    eqrjj: 0,
    Bk5zm6e: 0,
    m598lv: 0,
    B4f6apu: 0,
    ydt019: 0,
    Bq4z7u6: 0,
    Bdkvgpv: 0,
    B0qfbqy: 0,
    kj8mxx: "f1kc0wz4",
    r59vdv: "fgq90dz",
    Bkw5xw4: "fq0y47f",
    hl6cv3: "f1pwrbz6",
    aea9ga: "f1hxxcvm",
    yayu3t: "fw8rgyo",
    Bhsv975: "f1wnzycx",
    rhl9o9: "f1730wal",
    B7gxrvb: "f1fy4ixr",
    B6q6orb: "fobkauc",
    B0lu1f8: "f16bqv1l"
  }
}, {
  d: [".fjseox{display:none;}", ".f1ewtqcl{box-sizing:border-box;}", ".f132xexn{max-width:240px;}", ".f158kwzp{cursor:default;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".fokg9q4{overflow-wrap:break-word;}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".f9ggezi{border:1px solid var(--colorTransparentStroke);}", {
    p: -2
  }], [".f1bzqsji{padding:4px 11px 6px 11px;}", {
    p: -1
  }], ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".fxeb0a7{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 4px 8px var(--colorNeutralShadowKey));}", ".ftgm304{display:block;}", ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}", ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}", ".f1euv43f{position:absolute;}", ".f1bsuimh{z-index:-1;}", ".f1s3jn22{--fui-positioning-arrow-height:8.484px;}", ".fv40uqz{--fui-positioning-arrow-offset:-4.242px;}", ".f1u2r49w{background-color:inherit;}", ".fqhgnl{background-clip:content-box;}", ".f17bz04i{border-bottom-left-radius:var(--borderRadiusSmall);}", ".f36o3x3{transform:rotate(var(--fui-positioning-arrow-angle));}", ".fzofk8q{height:var(--fui-positioning-arrow-height);}", ".f1wbx1ie{width:var(--fui-positioning-arrow-height);}", ".f1wl9k8s::before{content:\"\";}", ".f1aocrix::before{display:block;}", ".f1ljr5q2::before{background-color:inherit;}", [".f155f1qt::before{margin:-1px;}", {
    p: -1
  }], ".f9mhzq7::before{width:100%;}", ".fr6rhvx::before{height:100%;}", [".f1kc0wz4::before{border:1px solid var(--colorTransparentStroke);}", {
    p: -2
  }], ".fgq90dz::before{border-bottom-left-radius:var(--borderRadiusSmall);}", ".fq0y47f::before{clip-path:polygon(0% 0%, 100% 100%, 0% 100%);}", "[data-popper-placement^=\"top\"] .f1pwrbz6{bottom:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"top\"] .f1hxxcvm{--fui-positioning-arrow-angle:-45deg;}", "[data-popper-placement^=\"right\"] .fw8rgyo{left:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"right\"] .f1wnzycx{--fui-positioning-arrow-angle:45deg;}", "[data-popper-placement^=\"bottom\"] .f1730wal{top:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"bottom\"] .f1fy4ixr{--fui-positioning-arrow-angle:135deg;}", "[data-popper-placement^=\"left\"] .fobkauc{right:var(--fui-positioning-arrow-offset);}", "[data-popper-placement^=\"left\"] .f16bqv1l{--fui-positioning-arrow-angle:225deg;}"]
});
/**
 * Apply styling to the Tooltip slots based on the state
 */
const useTooltipStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$C();
  state.content.className = mergeClasses(tooltipClassNames.content, styles.root, state.appearance === 'inverted' && styles.inverted, state.visible && styles.visible, state.content.className);
  state.arrowClassName = styles.arrow;
  return state;
};

/**
 * A tooltip provides light weight contextual information on top of its target element.
 */ const Tooltip = (props)=>{
    const state = useTooltip_unstable(props);
    useTooltipStyles_unstable(state);
    useCustomStyleHook$1('useTooltipStyles_unstable')(state);
    return renderTooltip_unstable(state);
};
Tooltip.displayName = 'Tooltip';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
Tooltip.isFluentTriggerComponent = true;

/**
 * Renders a Button component by passing the state defined props to the appropriate slots.
 */ const renderButton_unstable = (state)=>{
    assertSlots(state);
    const { iconOnly, iconPosition } = state;
    return /*#__PURE__*/ jsxs(state.root, {
        children: [
            iconPosition !== 'after' && state.icon && /*#__PURE__*/ jsx(state.icon, {}),
            !iconOnly && state.root.children,
            iconPosition === 'after' && state.icon && /*#__PURE__*/ jsx(state.icon, {})
        ]
    });
};

const buttonContext = React.createContext(undefined);
const buttonContextDefaultValue = {};
/**
 * @internal
 * Internal context provider used to update default values between internal components
 */ buttonContext.Provider;
/**
 * @internal
 * Internal context hook used to update default values between internal components
 */ const useButtonContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(buttonContext)) !== null && _React_useContext !== undefined ? _React_useContext : buttonContextDefaultValue;
};

/**
 * Given user props, defines default props for the Button, calls useButtonState, and returns processed state.
 * @param props - User provided props to the Button component.
 * @param ref - User provided ref to be passed to the Button component.
 */ const useButton_unstable = (props, ref)=>{
    const { size: contextSize } = useButtonContext();
    const { appearance = 'secondary', as = 'button', disabled = false, disabledFocusable = false, icon, iconPosition = 'before', shape = 'rounded', size = contextSize !== null && contextSize !== undefined ? contextSize : 'medium' } = props;
    const iconShorthand = optional(icon, {
        elementType: 'span'
    });
    return {
        // Props passed at the top-level
        appearance,
        disabled,
        disabledFocusable,
        iconPosition,
        shape,
        size,
        iconOnly: Boolean((iconShorthand === null || iconShorthand === undefined ? undefined : iconShorthand.children) && !props.children),
        components: {
            root: 'button',
            icon: 'span'
        },
        root: always(getIntrinsicElementProps(as, useARIAButtonProps(props.as, props)), {
            elementType: 'button',
            defaultProps: {
                ref: ref,
                type: as === 'button' ? 'button' : undefined
            }
        }),
        icon: iconShorthand
    };
};

const buttonClassNames = {
  root: 'fui-Button',
  icon: 'fui-Button__icon'
};
const useRootBaseClassName$1 = /*#__PURE__*/__resetStyles("r1alrhcs", null, {
  r: [".r1alrhcs{align-items:center;box-sizing:border-box;display:inline-flex;justify-content:center;text-decoration-line:none;vertical-align:middle;margin:0;overflow:hidden;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);font-family:var(--fontFamilyBase);outline-style:none;padding:5px var(--spacingHorizontalM);min-width:96px;border-radius:var(--borderRadiusMedium);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);transition-duration:var(--durationFaster);transition-property:background,border,color;transition-timing-function:var(--curveEasyEase);}", ".r1alrhcs:hover{background-color:var(--colorNeutralBackground1Hover);border-color:var(--colorNeutralStroke1Hover);color:var(--colorNeutralForeground1Hover);cursor:pointer;}", ".r1alrhcs:hover:active{background-color:var(--colorNeutralBackground1Pressed);border-color:var(--colorNeutralStroke1Pressed);color:var(--colorNeutralForeground1Pressed);outline-style:none;}", ".r1alrhcs[data-fui-focus-visible]{border-color:var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);border-width:1px;outline:var(--strokeWidthThick) solid var(--colorTransparentStroke);box-shadow:0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;z-index:1;}"],
  s: ["@media screen and (prefers-reduced-motion: reduce){.r1alrhcs{transition-duration:0.01ms;}}", "@media (forced-colors: active){.r1alrhcs:focus{border-color:ButtonText;}.r1alrhcs:hover{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}.r1alrhcs:hover:active{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}}", "@supports (-moz-appearance:button){.r1alrhcs[data-fui-focus-visible]{box-shadow:0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"]
});
const useIconBaseClassName$1 = /*#__PURE__*/__resetStyles("rywnvv2", null, [".rywnvv2{align-items:center;display:inline-flex;justify-content:center;font-size:20px;height:20px;width:20px;--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}"]);
const useRootStyles$2 = /*#__PURE__*/__styles({
  outline: {
    De3pzq: "f1c21dwh",
    Jwef8y: "fjxutwb",
    iro3zm: "fwiml72"
  },
  primary: {
    De3pzq: "ffp7eso",
    g2u3we: "f1p3nwhy",
    h3c5rm: ["f11589ue", "f1pdflbu"],
    B9xav0g: "f1q5o8ev",
    zhjwy3: ["f1pdflbu", "f11589ue"],
    sj55zd: "f1phragk",
    Jwef8y: "f15wkkf3",
    Bgoe8wy: "f1s2uweq",
    Bwzppfd: ["fr80ssc", "fecsdlb"],
    oetu4i: "f1ukrpxl",
    gg5e9n: ["fecsdlb", "fr80ssc"],
    Bi91k9c: "f1rq72xc",
    iro3zm: "fnp9lpt",
    b661bw: "f1h0usnq",
    Bk6r4ia: ["fs4ktlq", "fx2bmrt"],
    B9zn80p: "f16h9ulv",
    Bpld233: ["fx2bmrt", "fs4ktlq"],
    B2d53fq: "f1d6v5y2",
    Bsw6fvg: "f1rirnrt",
    Bjwas2f: "f1uu00uk",
    Bn1d65q: ["fkvaka8", "f9a0qzu"],
    Bxeuatn: "f1ux7til",
    n51gp8: ["f9a0qzu", "fkvaka8"],
    Bbusuzp: "f1lkg8j3",
    ycbfsm: "fkc42ay",
    Bqrx1nm: "fq7113v",
    pgvf35: "ff1wgvm",
    Bh7lczh: ["fiob0tu", "f1x4h75k"],
    dpv3f4: "f1j6scgf",
    Bpnjhaq: ["f1x4h75k", "fiob0tu"],
    ze5xyy: "f4xjyn1",
    g2kj27: "fbgcvur",
    Bf756sw: "f1ks1yx8",
    Bow2dr7: ["f1o6qegi", "fmxjhhp"],
    Bvhedfk: "fcnxywj",
    Gye4lf: ["fmxjhhp", "f1o6qegi"],
    pc6evw: "f9ddjv3"
  },
  secondary: {},
  subtle: {
    De3pzq: "fhovq9v",
    g2u3we: "f1p3nwhy",
    h3c5rm: ["f11589ue", "f1pdflbu"],
    B9xav0g: "f1q5o8ev",
    zhjwy3: ["f1pdflbu", "f11589ue"],
    sj55zd: "fkfq4zb",
    Jwef8y: "f1t94bn6",
    Bgoe8wy: "f1s2uweq",
    Bwzppfd: ["fr80ssc", "fecsdlb"],
    oetu4i: "f1ukrpxl",
    gg5e9n: ["fecsdlb", "fr80ssc"],
    Bi91k9c: "fnwyq0v",
    Bk3fhr4: "ft1hn21",
    Bmfj8id: "fuxngvv",
    Bbdnnc7: "fy5bs14",
    iro3zm: "fsv2rcd",
    b661bw: "f1h0usnq",
    Bk6r4ia: ["fs4ktlq", "fx2bmrt"],
    B9zn80p: "f16h9ulv",
    Bpld233: ["fx2bmrt", "fs4ktlq"],
    B2d53fq: "f1omzyqd",
    em6i61: "f1dfjoow",
    vm6p8p: "f1j98vj9",
    x3br3k: "fj8yq94",
    ze5xyy: "f4xjyn1",
    Bx3q9su: "f1et0tmh",
    pc6evw: "f9ddjv3",
    xd2cci: "f1wi8ngl"
  },
  transparent: {
    De3pzq: "f1c21dwh",
    g2u3we: "f1p3nwhy",
    h3c5rm: ["f11589ue", "f1pdflbu"],
    B9xav0g: "f1q5o8ev",
    zhjwy3: ["f1pdflbu", "f11589ue"],
    sj55zd: "fkfq4zb",
    Jwef8y: "fjxutwb",
    Bgoe8wy: "f1s2uweq",
    Bwzppfd: ["fr80ssc", "fecsdlb"],
    oetu4i: "f1ukrpxl",
    gg5e9n: ["fecsdlb", "fr80ssc"],
    Bi91k9c: "f139oj5f",
    Bk3fhr4: "ft1hn21",
    Bmfj8id: "fuxngvv",
    iro3zm: "fwiml72",
    b661bw: "f1h0usnq",
    Bk6r4ia: ["fs4ktlq", "fx2bmrt"],
    B9zn80p: "f16h9ulv",
    Bpld233: ["fx2bmrt", "fs4ktlq"],
    B2d53fq: "f1fg1p5m",
    em6i61: "f1dfjoow",
    vm6p8p: "f1j98vj9",
    Bqrx1nm: "f1tme0vf",
    ze5xyy: "f4xjyn1",
    g2kj27: "f18onu3q",
    pc6evw: "f9ddjv3"
  },
  circular: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f44lkw9"
  },
  rounded: {},
  square: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1fabniw"
  },
  small: {
    Bf4jedk: "fh7ncta",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fneth5b",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fwrc4pm"
  },
  smallWithIcon: {
    Byoj8tv: "f1brlhvm",
    z8tnut: "f1sl3k7w"
  },
  medium: {},
  large: {
    Bf4jedk: "f14es27b",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f4db1ww",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    Be2twd7: "fod5ikn",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "faaz57k"
  },
  largeWithIcon: {
    Byoj8tv: "fy7v416",
    z8tnut: "f1a1bwwz"
  }
}, {
  d: [".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".ffp7eso{background-color:var(--colorBrandBackground);}", ".f1p3nwhy{border-top-color:transparent;}", ".f11589ue{border-right-color:transparent;}", ".f1pdflbu{border-left-color:transparent;}", ".f1q5o8ev{border-bottom-color:transparent;}", ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}", ".fhovq9v{background-color:var(--colorSubtleBackground);}", ".fkfq4zb{color:var(--colorNeutralForeground2);}", [".f44lkw9{border-radius:var(--borderRadiusCircular);}", {
    p: -1
  }], [".f1fabniw{border-radius:var(--borderRadiusNone);}", {
    p: -1
  }], ".fh7ncta{min-width:64px;}", [".fneth5b{padding:3px var(--spacingHorizontalS);}", {
    p: -1
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f1brlhvm{padding-bottom:1px;}", ".f1sl3k7w{padding-top:1px;}", ".f14es27b{min-width:96px;}", [".f4db1ww{padding:8px var(--spacingHorizontalL);}", {
    p: -1
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".fod5ikn{font-size:var(--fontSizeBase400);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".faaz57k{line-height:var(--lineHeightBase400);}", ".fy7v416{padding-bottom:7px;}", ".f1a1bwwz{padding-top:7px;}"],
  h: [".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}", ".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}", ".f15wkkf3:hover{background-color:var(--colorBrandBackgroundHover);}", ".f1s2uweq:hover{border-top-color:transparent;}", ".fr80ssc:hover{border-right-color:transparent;}", ".fecsdlb:hover{border-left-color:transparent;}", ".f1ukrpxl:hover{border-bottom-color:transparent;}", ".f1rq72xc:hover{color:var(--colorNeutralForegroundOnBrand);}", ".fnp9lpt:hover:active{background-color:var(--colorBrandBackgroundPressed);}", ".f1h0usnq:hover:active{border-top-color:transparent;}", ".fs4ktlq:hover:active{border-right-color:transparent;}", ".fx2bmrt:hover:active{border-left-color:transparent;}", ".f16h9ulv:hover:active{border-bottom-color:transparent;}", ".f1d6v5y2:hover:active{color:var(--colorNeutralForegroundOnBrand);}", ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}", ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}", ".ft1hn21:hover .fui-Icon-filled{display:inline;}", ".fuxngvv:hover .fui-Icon-regular{display:none;}", ".fy5bs14:hover .fui-Button__icon{color:var(--colorNeutralForeground2BrandHover);}", ".fsv2rcd:hover:active{background-color:var(--colorSubtleBackgroundPressed);}", ".f1omzyqd:hover:active{color:var(--colorNeutralForeground2Pressed);}", ".f1dfjoow:hover:active .fui-Icon-filled{display:inline;}", ".f1j98vj9:hover:active .fui-Icon-regular{display:none;}", ".fj8yq94:hover:active .fui-Button__icon{color:var(--colorNeutralForeground2BrandPressed);}", ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}", ".f1fg1p5m:hover:active{color:var(--colorNeutralForeground2BrandPressed);}"],
  m: [["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1uu00uk{border-top-color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f9a0qzu{border-left-color:HighlightText;}.fkvaka8{border-right-color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ux7til{border-bottom-color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fq7113v:hover{background-color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.ff1wgvm:hover{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1x4h75k:hover{border-left-color:Highlight;}.fiob0tu:hover{border-right-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1j6scgf:hover{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f4xjyn1:hover{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fbgcvur:hover:active{background-color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ks1yx8:hover:active{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1o6qegi:hover:active{border-right-color:Highlight;}.fmxjhhp:hover:active{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fcnxywj:hover:active{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f9ddjv3:hover:active{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1et0tmh:hover .fui-Button__icon{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1wi8ngl:hover:active .fui-Button__icon{color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1tme0vf:hover{background-color:var(--colorTransparentBackground);}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f18onu3q:hover:active{background-color:var(--colorTransparentBackground);}}", {
    m: "(forced-colors: active)"
  }]]
});
const useRootDisabledStyles = /*#__PURE__*/__styles({
  base: {
    De3pzq: "f1bg9a2p",
    g2u3we: "f1jj8ep1",
    h3c5rm: ["f15xbau", "fy0fskl"],
    B9xav0g: "f4ikngz",
    zhjwy3: ["fy0fskl", "f15xbau"],
    sj55zd: "f1s2aq7o",
    Bceei9c: "fdrzuqr",
    Bfinmwp: "f15x8b5r",
    Jwef8y: "f1falr9n",
    Bgoe8wy: "f12mpcsy",
    Bwzppfd: ["f1gwvigk", "f18rmfxp"],
    oetu4i: "f1jnshp0",
    gg5e9n: ["f18rmfxp", "f1gwvigk"],
    Bi91k9c: "fvgxktp",
    eoavqd: "fphbwmw",
    Bk3fhr4: "f19vpps7",
    Bmfj8id: "fv5swzo",
    Bbdnnc7: "f1al02dq",
    iro3zm: "f1t6o4dc",
    b661bw: "f10ztigi",
    Bk6r4ia: ["f1ft5sdu", "f1gzf82w"],
    B9zn80p: "f12zbtn2",
    Bpld233: ["f1gzf82w", "f1ft5sdu"],
    B2d53fq: "fcvwxyo",
    c3iz72: "f8w4c43",
    em6i61: "f1ol4fw6",
    vm6p8p: "f1q1lw4e",
    x3br3k: "f1dwjv2g"
  },
  highContrast: {
    Bsw6fvg: "f4lkoma",
    Bjwas2f: "fg455y9",
    Bn1d65q: ["f1rvyvqg", "f14g86mu"],
    Bxeuatn: "f1cwzwz",
    n51gp8: ["f14g86mu", "f1rvyvqg"],
    Bbusuzp: "f1dcs8yz",
    G867l3: "fjwq6ea",
    gdbnj: ["f1lr3nhc", "f1mbxvi6"],
    mxns5l: "fn5gmvv",
    o3nasb: ["f1mbxvi6", "f1lr3nhc"],
    Bqrx1nm: "f1vmkb5g",
    pgvf35: "f53ppgq",
    Bh7lczh: ["f1663y11", "f80fkiy"],
    dpv3f4: "f18v5270",
    Bpnjhaq: ["f80fkiy", "f1663y11"],
    ze5xyy: "f1kc2mi9",
    g2kj27: "f1y0svfh",
    Bf756sw: "fihuait",
    Bow2dr7: ["fnxhupq", "fyd6l6x"],
    Bvhedfk: "fx507ft",
    Gye4lf: ["fyd6l6x", "fnxhupq"],
    pc6evw: "fb3rf2x"
  },
  outline: {
    De3pzq: "f1c21dwh",
    Jwef8y: "f9ql6rf",
    iro3zm: "f3h1zc4"
  },
  primary: {
    g2u3we: "f1p3nwhy",
    h3c5rm: ["f11589ue", "f1pdflbu"],
    B9xav0g: "f1q5o8ev",
    zhjwy3: ["f1pdflbu", "f11589ue"],
    Bgoe8wy: "f1s2uweq",
    Bwzppfd: ["fr80ssc", "fecsdlb"],
    oetu4i: "f1ukrpxl",
    gg5e9n: ["fecsdlb", "fr80ssc"],
    b661bw: "f1h0usnq",
    Bk6r4ia: ["fs4ktlq", "fx2bmrt"],
    B9zn80p: "f16h9ulv",
    Bpld233: ["fx2bmrt", "fs4ktlq"]
  },
  secondary: {},
  subtle: {
    De3pzq: "f1c21dwh",
    g2u3we: "f1p3nwhy",
    h3c5rm: ["f11589ue", "f1pdflbu"],
    B9xav0g: "f1q5o8ev",
    zhjwy3: ["f1pdflbu", "f11589ue"],
    Jwef8y: "f9ql6rf",
    Bgoe8wy: "f1s2uweq",
    Bwzppfd: ["fr80ssc", "fecsdlb"],
    oetu4i: "f1ukrpxl",
    gg5e9n: ["fecsdlb", "fr80ssc"],
    iro3zm: "f3h1zc4",
    b661bw: "f1h0usnq",
    Bk6r4ia: ["fs4ktlq", "fx2bmrt"],
    B9zn80p: "f16h9ulv",
    Bpld233: ["fx2bmrt", "fs4ktlq"]
  },
  transparent: {
    De3pzq: "f1c21dwh",
    g2u3we: "f1p3nwhy",
    h3c5rm: ["f11589ue", "f1pdflbu"],
    B9xav0g: "f1q5o8ev",
    zhjwy3: ["f1pdflbu", "f11589ue"],
    Jwef8y: "f9ql6rf",
    Bgoe8wy: "f1s2uweq",
    Bwzppfd: ["fr80ssc", "fecsdlb"],
    oetu4i: "f1ukrpxl",
    gg5e9n: ["fecsdlb", "fr80ssc"],
    iro3zm: "f3h1zc4",
    b661bw: "f1h0usnq",
    Bk6r4ia: ["fs4ktlq", "fx2bmrt"],
    B9zn80p: "f16h9ulv",
    Bpld233: ["fx2bmrt", "fs4ktlq"]
  }
}, {
  d: [".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}", ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}", ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}", ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}", ".fdrzuqr{cursor:not-allowed;}", ".f15x8b5r .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1p3nwhy{border-top-color:transparent;}", ".f11589ue{border-right-color:transparent;}", ".f1pdflbu{border-left-color:transparent;}", ".f1q5o8ev{border-bottom-color:transparent;}"],
  h: [".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}", ".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}", ".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}", ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}", ".fphbwmw:hover{cursor:not-allowed;}", ".f19vpps7:hover .fui-Icon-filled{display:none;}", ".fv5swzo:hover .fui-Icon-regular{display:inline;}", ".f1al02dq:hover .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}", ".f1t6o4dc:hover:active{background-color:var(--colorNeutralBackgroundDisabled);}", ".f10ztigi:hover:active{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f1ft5sdu:hover:active{border-right-color:var(--colorNeutralStrokeDisabled);}", ".f1gzf82w:hover:active{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f12zbtn2:hover:active{border-bottom-color:var(--colorNeutralStrokeDisabled);}", ".fcvwxyo:hover:active{color:var(--colorNeutralForegroundDisabled);}", ".f8w4c43:hover:active{cursor:not-allowed;}", ".f1ol4fw6:hover:active .fui-Icon-filled{display:none;}", ".f1q1lw4e:hover:active .fui-Icon-regular{display:inline;}", ".f1dwjv2g:hover:active .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}", ".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}", ".f3h1zc4:hover:active{background-color:var(--colorTransparentBackground);}", ".f1s2uweq:hover{border-top-color:transparent;}", ".fr80ssc:hover{border-right-color:transparent;}", ".fecsdlb:hover{border-left-color:transparent;}", ".f1ukrpxl:hover{border-bottom-color:transparent;}", ".f1h0usnq:hover:active{border-top-color:transparent;}", ".fs4ktlq:hover:active{border-right-color:transparent;}", ".fx2bmrt:hover:active{border-left-color:transparent;}", ".f16h9ulv:hover:active{border-bottom-color:transparent;}"],
  m: [["@media (forced-colors: active){.f4lkoma{background-color:ButtonFace;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fjwq6ea:focus{border-top-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1lr3nhc:focus{border-right-color:GrayText;}.f1mbxvi6:focus{border-left-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fn5gmvv:focus{border-bottom-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1vmkb5g:hover{background-color:ButtonFace;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f53ppgq:hover{border-top-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1663y11:hover{border-right-color:GrayText;}.f80fkiy:hover{border-left-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f18v5270:hover{border-bottom-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1kc2mi9:hover{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1y0svfh:hover:active{background-color:ButtonFace;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fihuait:hover:active{border-top-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fnxhupq:hover:active{border-right-color:GrayText;}.fyd6l6x:hover:active{border-left-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fx507ft:hover:active{border-bottom-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fb3rf2x:hover:active{color:GrayText;}}", {
    m: "(forced-colors: active)"
  }]]
});
const useRootFocusStyles = /*#__PURE__*/__styles({
  circular: {
    Bw81rd7: 0,
    kdpuga: 0,
    dm238s: 0,
    B6xbmo0: 0,
    B3whbx2: "f1062rbf"
  },
  rounded: {},
  square: {
    Bw81rd7: 0,
    kdpuga: 0,
    dm238s: 0,
    B6xbmo0: 0,
    B3whbx2: "fj0ryk1"
  },
  primary: {
    B8q5s1w: "f17t0x8g",
    Bci5o5g: ["f194v5ow", "fk7jm04"],
    n8qw10: "f1qgg65p",
    Bdrgwmp: ["fk7jm04", "f194v5ow"],
    j6ew2k: ["fhgccpy", "fjo7pq6"],
    he4mth: "f32wu9k",
    Byr4aka: "fu5nqqq",
    lks7q5: ["f13prjl2", "f1nl83rv"],
    Bnan3qt: "f1czftr5",
    k1dn9: ["f1nl83rv", "f13prjl2"],
    Boium3a: ["f12k37oa", "fdnykm2"],
    tm8e47: "fr96u23"
  },
  small: {
    Bw81rd7: 0,
    kdpuga: 0,
    dm238s: 0,
    B6xbmo0: 0,
    B3whbx2: "fazmxh"
  },
  medium: {},
  large: {
    Bw81rd7: 0,
    kdpuga: 0,
    dm238s: 0,
    B6xbmo0: 0,
    B3whbx2: "f1b6alqh"
  }
}, {
  d: [[".f1062rbf[data-fui-focus-visible]{border-radius:var(--borderRadiusCircular);}", {
    p: -1
  }], [".fj0ryk1[data-fui-focus-visible]{border-radius:var(--borderRadiusNone);}", {
    p: -1
  }], ".f17t0x8g[data-fui-focus-visible]{border-top-color:var(--colorStrokeFocus2);}", ".f194v5ow[data-fui-focus-visible]{border-right-color:var(--colorStrokeFocus2);}", ".fk7jm04[data-fui-focus-visible]{border-left-color:var(--colorStrokeFocus2);}", ".f1qgg65p[data-fui-focus-visible]{border-bottom-color:var(--colorStrokeFocus2);}", ".fhgccpy[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}", ".fjo7pq6[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}", ".f32wu9k[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;}", ".fu5nqqq[data-fui-focus-visible]:hover{border-top-color:var(--colorStrokeFocus2);}", ".f13prjl2[data-fui-focus-visible]:hover{border-right-color:var(--colorStrokeFocus2);}", ".f1nl83rv[data-fui-focus-visible]:hover{border-left-color:var(--colorStrokeFocus2);}", ".f1czftr5[data-fui-focus-visible]:hover{border-bottom-color:var(--colorStrokeFocus2);}", [".fazmxh[data-fui-focus-visible]{border-radius:var(--borderRadiusSmall);}", {
    p: -1
  }], [".f1b6alqh[data-fui-focus-visible]{border-radius:var(--borderRadiusLarge);}", {
    p: -1
  }]],
  t: ["@supports (-moz-appearance:button){.f12k37oa[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}.fdnykm2[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}}", "@supports (-moz-appearance:button){.fr96u23[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"]
});
const useRootIconOnlyStyles = /*#__PURE__*/__styles({
  small: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fu97m5z",
    Bf4jedk: "f17fgpbq",
    B2u0y6b: "f1jt17bm"
  },
  medium: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f18ktai2",
    Bf4jedk: "fwbmr0d",
    B2u0y6b: "f44c6la"
  },
  large: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1hbd1aw",
    Bf4jedk: "f12clzc2",
    B2u0y6b: "fjy1crr"
  }
}, {
  d: [[".fu97m5z{padding:1px;}", {
    p: -1
  }], ".f17fgpbq{min-width:24px;}", ".f1jt17bm{max-width:24px;}", [".f18ktai2{padding:5px;}", {
    p: -1
  }], ".fwbmr0d{min-width:32px;}", ".f44c6la{max-width:32px;}", [".f1hbd1aw{padding:7px;}", {
    p: -1
  }], ".f12clzc2{min-width:40px;}", ".fjy1crr{max-width:40px;}"]
});
const useIconStyles = /*#__PURE__*/__styles({
  small: {
    Be2twd7: "fe5j1ua",
    Bqenvij: "fjamq6b",
    a9b677: "f64fuq3",
    Bqrlyyl: "fbaiahx"
  },
  medium: {},
  large: {
    Be2twd7: "f1rt2boy",
    Bqenvij: "frvgh55",
    a9b677: "fq4mcun",
    Bqrlyyl: "f1exjqw5"
  },
  before: {
    t21cq0: ["f1nizpg2", "f1a695kz"]
  },
  after: {
    Frg6f3: ["f1a695kz", "f1nizpg2"]
  }
}, {
  d: [".fe5j1ua{font-size:20px;}", ".fjamq6b{height:20px;}", ".f64fuq3{width:20px;}", ".fbaiahx{--fui-Button__icon--spacing:var(--spacingHorizontalXS);}", ".f1rt2boy{font-size:24px;}", ".frvgh55{height:24px;}", ".fq4mcun{width:24px;}", ".f1exjqw5{--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}", ".f1nizpg2{margin-right:var(--fui-Button__icon--spacing);}", ".f1a695kz{margin-left:var(--fui-Button__icon--spacing);}"]
});
const useButtonStyles_unstable = state => {
  'use no memo';

  const rootBaseClassName = useRootBaseClassName$1();
  const iconBaseClassName = useIconBaseClassName$1();
  const rootStyles = useRootStyles$2();
  const rootDisabledStyles = useRootDisabledStyles();
  const rootFocusStyles = useRootFocusStyles();
  const rootIconOnlyStyles = useRootIconOnlyStyles();
  const iconStyles = useIconStyles();
  const {
    appearance,
    disabled,
    disabledFocusable,
    icon,
    iconOnly,
    iconPosition,
    shape,
    size
  } = state;
  state.root.className = mergeClasses(buttonClassNames.root, rootBaseClassName, appearance && rootStyles[appearance], rootStyles[size], icon && size === 'small' && rootStyles.smallWithIcon, icon && size === 'large' && rootStyles.largeWithIcon, rootStyles[shape],
  // Disabled styles
  (disabled || disabledFocusable) && rootDisabledStyles.base, (disabled || disabledFocusable) && rootDisabledStyles.highContrast, appearance && (disabled || disabledFocusable) && rootDisabledStyles[appearance],
  // Focus styles
  appearance === 'primary' && rootFocusStyles.primary, rootFocusStyles[size], rootFocusStyles[shape],
  // Icon-only styles
  iconOnly && rootIconOnlyStyles[size],
  // User provided class name
  state.root.className);
  if (state.icon) {
    state.icon.className = mergeClasses(buttonClassNames.icon, iconBaseClassName, !!state.root.children && iconStyles[iconPosition], iconStyles[size], state.icon.className);
  }
  return state;
};

/**
 * Buttons give people a way to trigger an action.
 */ const Button = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useButton_unstable(props, ref);
    useButtonStyles_unstable(state);
    useCustomStyleHook$1('useButtonStyles_unstable')(state);
    return renderButton_unstable(state);
// Casting is required due to lack of distributive union to support unions on @types/react
});
Button.displayName = 'Button';

const FieldContext = React.createContext(undefined);
FieldContext.Provider;
const useFieldContext_unstable = ()=>React.useContext(FieldContext);

/**
 * Renders a Divider component by passing the slot props (defined in `state`) to the appropriate slots.
 */ const renderDivider_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsx(state.root, {
        children: state.root.children !== undefined && /*#__PURE__*/ jsx(state.wrapper, {
            children: state.root.children
        })
    });
};

/**
 * Returns the props and state required to render the component
 * @param props - User-provided props to the Divider component.
 * @param ref - User-provided ref to be passed to the Divider component.
 */ const useDivider_unstable = (props, ref)=>{
    const { alignContent = 'center', appearance = 'default', inset = false, vertical = false, wrapper } = props;
    const dividerId = useId('divider-');
    return {
        // Props passed at the top-level
        alignContent,
        appearance,
        inset,
        vertical,
        // Slots definition
        components: {
            root: 'div',
            wrapper: 'div'
        },
        root: always(getIntrinsicElementProps('div', {
            role: 'separator',
            'aria-orientation': vertical ? 'vertical' : 'horizontal',
            'aria-labelledby': props.children ? dividerId : undefined,
            ...props,
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref
        }), {
            elementType: 'div'
        }),
        wrapper: always(wrapper, {
            defaultProps: {
                id: dividerId,
                children: props.children
            },
            elementType: 'div'
        })
    };
};

const dividerClassNames = {
  root: 'fui-Divider',
  wrapper: 'fui-Divider__wrapper'
};
const useBaseStyles = /*#__PURE__*/__styles({
  base: {
    Bt984gj: "f122n59",
    B7ck84d: "f1ewtqcl",
    mc9l5x: "f22iagw",
    Beiy3e4: "f1063pyq",
    Bh6795r: "fqerorx",
    qhf8xq: "f10pi13n",
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fwrc4pm",
    fsow6f: "f17mccla",
    Bcvre1j: "fyl8oag",
    Br0sdwz: "f16vkdww",
    Bn78ew0: "fhsnbul",
    li1rpt: "f1gw3sf2",
    ap17g6: "f1ly5f7u",
    B771hl4: "f1s3tz6t"
  },
  childless: {
    susq4k: "f1kyqvp9",
    Bicfajf: ["fzynn9s", "f1z0ukd1"],
    jwcpgy: ["fekrn8e", "ftdg338"],
    B4rk6o: "fesgyo"
  },
  start: {
    Bsft5z2: "f13zj6fq"
  },
  center: {
    Ftih45: "f1wl9k8s",
    Bsft5z2: "f13zj6fq"
  },
  end: {
    Ftih45: "f1wl9k8s"
  },
  brand: {
    sj55zd: "f16muhyy",
    Bq4z7u6: "fcbuu2a",
    Bk5zm6e: ["f1wdw2dr", "f1ttio3w"],
    Bqjgrrk: "f1582fpk",
    Bm6vgfq: ["f1ttio3w", "f1wdw2dr"],
    B0n5ga8: "f1ahrvm8",
    s924m2: ["f1cd3wbc", "f17hbk9y"],
    B1q35kw: "fvrapl0",
    Gp14am: ["f17hbk9y", "f1cd3wbc"]
  },
  "default": {
    sj55zd: "fkfq4zb",
    Bq4z7u6: "f1vccso1",
    Bk5zm6e: ["f1geml7w", "fjml6kk"],
    Bqjgrrk: "f1r7kh1m",
    Bm6vgfq: ["fjml6kk", "f1geml7w"],
    B0n5ga8: "f16j7guv",
    s924m2: ["fx01ahm", "fj1a37q"],
    B1q35kw: "fl8d8yv",
    Gp14am: ["fj1a37q", "fx01ahm"]
  },
  subtle: {
    sj55zd: "f11d4kpn",
    Bq4z7u6: "f5g06un",
    Bk5zm6e: ["f13sxdku", "f1n015lb"],
    Bqjgrrk: "f1x6bl8t",
    Bm6vgfq: ["f1n015lb", "f13sxdku"],
    B0n5ga8: "fvod1wy",
    s924m2: ["fwslg65", "flk0e17"],
    B1q35kw: "f103fvts",
    Gp14am: ["flk0e17", "fwslg65"]
  },
  strong: {
    sj55zd: "f19n0e5",
    Bq4z7u6: "f10tv6oz",
    Bk5zm6e: ["f16xp3sf", "f1seuxxq"],
    Bqjgrrk: "fwrmqbx",
    Bm6vgfq: ["f1seuxxq", "f16xp3sf"],
    B0n5ga8: "ft83z1f",
    s924m2: ["f1g4150c", "f192dr6e"],
    B1q35kw: "f1qnawh6",
    Gp14am: ["f192dr6e", "f1g4150c"]
  }
}, {
  d: [".f122n59{align-items:center;}", ".f1ewtqcl{box-sizing:border-box;}", ".f22iagw{display:flex;}", ".f1063pyq{flex-direction:row;}", ".fqerorx{flex-grow:1;}", ".f10pi13n{position:relative;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f17mccla{text-align:center;}", ".fyl8oag::before{box-sizing:border-box;}", ".f16vkdww::before{display:flex;}", ".fhsnbul::before{flex-grow:1;}", ".f1gw3sf2::after{box-sizing:border-box;}", ".f1ly5f7u::after{display:flex;}", ".f1s3tz6t::after{flex-grow:1;}", ".f1kyqvp9::before{margin-bottom:0;}", ".fzynn9s::before{margin-right:0;}", ".f1z0ukd1::before{margin-left:0;}", ".fekrn8e::after{margin-left:0;}", ".ftdg338::after{margin-right:0;}", ".fesgyo::after{margin-top:0;}", ".f13zj6fq::after{content:\"\";}", ".f1wl9k8s::before{content:\"\";}", ".f16muhyy{color:var(--colorBrandForeground1);}", ".fcbuu2a::before{border-top-color:var(--colorBrandStroke1);}", ".f1wdw2dr::before{border-right-color:var(--colorBrandStroke1);}", ".f1ttio3w::before{border-left-color:var(--colorBrandStroke1);}", ".f1582fpk::before{border-bottom-color:var(--colorBrandStroke1);}", ".f1ahrvm8::after{border-top-color:var(--colorBrandStroke1);}", ".f1cd3wbc::after{border-right-color:var(--colorBrandStroke1);}", ".f17hbk9y::after{border-left-color:var(--colorBrandStroke1);}", ".fvrapl0::after{border-bottom-color:var(--colorBrandStroke1);}", ".fkfq4zb{color:var(--colorNeutralForeground2);}", ".f1vccso1::before{border-top-color:var(--colorNeutralStroke2);}", ".f1geml7w::before{border-right-color:var(--colorNeutralStroke2);}", ".fjml6kk::before{border-left-color:var(--colorNeutralStroke2);}", ".f1r7kh1m::before{border-bottom-color:var(--colorNeutralStroke2);}", ".f16j7guv::after{border-top-color:var(--colorNeutralStroke2);}", ".fx01ahm::after{border-right-color:var(--colorNeutralStroke2);}", ".fj1a37q::after{border-left-color:var(--colorNeutralStroke2);}", ".fl8d8yv::after{border-bottom-color:var(--colorNeutralStroke2);}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f5g06un::before{border-top-color:var(--colorNeutralStroke3);}", ".f13sxdku::before{border-right-color:var(--colorNeutralStroke3);}", ".f1n015lb::before{border-left-color:var(--colorNeutralStroke3);}", ".f1x6bl8t::before{border-bottom-color:var(--colorNeutralStroke3);}", ".fvod1wy::after{border-top-color:var(--colorNeutralStroke3);}", ".fwslg65::after{border-right-color:var(--colorNeutralStroke3);}", ".flk0e17::after{border-left-color:var(--colorNeutralStroke3);}", ".f103fvts::after{border-bottom-color:var(--colorNeutralStroke3);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".f10tv6oz::before{border-top-color:var(--colorNeutralStroke1);}", ".f16xp3sf::before{border-right-color:var(--colorNeutralStroke1);}", ".f1seuxxq::before{border-left-color:var(--colorNeutralStroke1);}", ".fwrmqbx::before{border-bottom-color:var(--colorNeutralStroke1);}", ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}", ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}", ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}", ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}"]
});
const useHorizontalStyles = /*#__PURE__*/__styles({
  base: {
    a9b677: "fly5x3f",
    Bdkvgpv: "f163fonl",
    B0qfbqy: "f51yk4v",
    pbipgd: "f13rof3u",
    Bm2nyyq: "f8rth92",
    xrcqlc: "f6czdpx",
    i5u598: "f1iyka9k"
  },
  inset: {
    uwmqm3: ["fjlbh76", "f11qrl6u"],
    z189sj: ["f11qrl6u", "fjlbh76"]
  },
  start: {
    Ftih45: "f1wl9k8s",
    Bicfajf: ["f1ojjlep", "fk1kexq"],
    Bxwl2t9: "f1he2m4d",
    jwcpgy: ["f12w1bnb", "f1558wlj"]
  },
  center: {
    Bicfajf: ["f1ojjlep", "fk1kexq"],
    jwcpgy: ["f12w1bnb", "f1558wlj"]
  },
  end: {
    Bicfajf: ["f1ojjlep", "fk1kexq"],
    Bsft5z2: "f13zj6fq",
    jwcpgy: ["f12w1bnb", "f1558wlj"],
    Iy66sp: "f1ayce8x"
  }
}, {
  d: [".fly5x3f{width:100%;}", ".f163fonl::before{border-top-style:solid;}", ".f51yk4v::before{border-top-width:var(--strokeWidthThin);}", ".f13rof3u::before{min-width:8px;}", ".f8rth92::after{border-top-style:solid;}", ".f6czdpx::after{border-top-width:var(--strokeWidthThin);}", ".f1iyka9k::after{min-width:8px;}", ".fjlbh76{padding-left:12px;}", ".f11qrl6u{padding-right:12px;}", ".f1wl9k8s::before{content:\"\";}", ".f1ojjlep::before{margin-right:12px;}", ".fk1kexq::before{margin-left:12px;}", ".f1he2m4d::before{max-width:8px;}", ".f12w1bnb::after{margin-left:12px;}", ".f1558wlj::after{margin-right:12px;}", ".f13zj6fq::after{content:\"\";}", ".f1ayce8x::after{max-width:8px;}"]
});
const useVerticalStyles = /*#__PURE__*/__styles({
  base: {
    Beiy3e4: "f1vx9l62",
    sshi5w: "f16gbxbe",
    m598lv: ["f1yq6w5o", "f1jpmc5p"],
    B4f6apu: ["f9sc749", "f1x8pvcy"],
    zkzzav: "fhkwbjy",
    Barhvk9: ["flthirb", "ftkbnf5"],
    Ihftqj: ["f13hvwk3", "f1en4csx"],
    Bde111x: "f19onpk6"
  },
  inset: {
    B6of3ja: "f1xdg43u",
    jrapky: "f1jlhsmd"
  },
  withChildren: {
    sshi5w: "f1tjaq3g"
  },
  start: {
    Ftih45: "f1wl9k8s",
    susq4k: "fg2pwug",
    Bbdr6tz: "fkjtzyi",
    B4rk6o: "f8vk40g"
  },
  center: {
    susq4k: "fg2pwug",
    B4rk6o: "f8vk40g"
  },
  end: {
    susq4k: "fg2pwug",
    Bsft5z2: "f13zj6fq",
    B4rk6o: "f8vk40g",
    gn64ia: "fqg5mu5"
  }
}, {
  d: [".f1vx9l62{flex-direction:column;}", ".f16gbxbe{min-height:20px;}", ".f1yq6w5o::before{border-right-style:solid;}", ".f1jpmc5p::before{border-left-style:solid;}", ".f9sc749::before{border-right-width:var(--strokeWidthThin);}", ".f1x8pvcy::before{border-left-width:var(--strokeWidthThin);}", ".fhkwbjy::before{min-height:8px;}", ".flthirb::after{border-right-style:solid;}", ".ftkbnf5::after{border-left-style:solid;}", ".f13hvwk3::after{border-right-width:var(--strokeWidthThin);}", ".f1en4csx::after{border-left-width:var(--strokeWidthThin);}", ".f19onpk6::after{min-height:8px;}", ".f1xdg43u{margin-top:12px;}", ".f1jlhsmd{margin-bottom:12px;}", ".f1tjaq3g{min-height:84px;}", ".f1wl9k8s::before{content:\"\";}", ".fg2pwug::before{margin-bottom:12px;}", ".fkjtzyi::before{max-height:8px;}", ".f8vk40g::after{margin-top:12px;}", ".f13zj6fq::after{content:\"\";}", ".fqg5mu5::after{max-height:8px;}"]
});
const useDividerStyles_unstable = state => {
  'use no memo';

  const baseStyles = useBaseStyles();
  const horizontalStyles = useHorizontalStyles();
  const verticalStyles = useVerticalStyles();
  const {
    alignContent,
    appearance,
    inset,
    vertical
  } = state;
  state.root.className = mergeClasses(dividerClassNames.root,
  // Base styles
  baseStyles.base, baseStyles[alignContent], appearance && baseStyles[appearance],
  // Horizontal styles
  !vertical && horizontalStyles.base, !vertical && inset && horizontalStyles.inset, !vertical && horizontalStyles[alignContent],
  // Vertical styles
  vertical && verticalStyles.base, vertical && inset && verticalStyles.inset, vertical && verticalStyles[alignContent], vertical && state.root.children !== undefined && verticalStyles.withChildren,
  // Childless styles
  state.root.children === undefined && baseStyles.childless,
  // User provided class name
  state.root.className);
  if (state.wrapper) {
    state.wrapper.className = mergeClasses(dividerClassNames.wrapper, state.wrapper.className);
  }
  return state;
};

/**
 * A divider visually segments content into groups.
 */ const Divider = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useDivider_unstable(props, ref);
    useDividerStyles_unstable(state);
    useCustomStyleHook$1('useDividerStyles_unstable')(state);
    return renderDivider_unstable(state);
});
Divider.displayName = 'Divider';

/**
 * Define the render function.
 * Given the state of an image, renders it.
 */ const renderImage_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsx(state.root, {});
};

/**
 * Given user props, returns state and render function for an Image.
 */ const useImage_unstable = (props, ref)=>{
    const { bordered = false, fit = 'default', block = false, shape = 'square', shadow = false } = props;
    const state = {
        bordered,
        fit,
        block,
        shape,
        shadow,
        components: {
            root: 'img'
        },
        root: always(getIntrinsicElementProps('img', {
            ref,
            ...props
        }), {
            elementType: 'img'
        })
    };
    return state;
};

const imageClassNames = {
  root: 'fui-Image'
};
const useStyles$B = /*#__PURE__*/__styles({
  base: {
    g2u3we: "fj3muxo",
    h3c5rm: ["f1akhkt", "f1lxtadh"],
    B9xav0g: "f1aperda",
    zhjwy3: ["f1lxtadh", "f1akhkt"],
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1fabniw",
    B7ck84d: "f1ewtqcl",
    mc9l5x: "f14t3ns0"
  },
  bordered: {
    icvyot: "fzkkow9",
    vrafjx: ["fcdblym", "fjik90z"],
    oivjwe: "fg706s2",
    wvpqe5: ["fjik90z", "fcdblym"],
    B4j52fo: "f192inf7",
    Bekrc4i: ["f5tn483", "f1ojsxk5"],
    Bn0qgzm: "f1vxd6vx",
    ibv6hh: ["f1ojsxk5", "f5tn483"]
  },
  circular: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f44lkw9"
  },
  rounded: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5"
  },
  square: {},
  shadow: {
    E5pizo: "f1whvlc6"
  },
  center: {
    st4lth: "f1plgu50",
    Ermj5k: "f14xojzb",
    Bqenvij: "f1l02sjl",
    a9b677: "fly5x3f"
  },
  contain: {
    st4lth: "f1kle4es",
    Ermj5k: "f14xojzb",
    Bqenvij: "f1l02sjl",
    a9b677: "fly5x3f"
  },
  "default": {},
  cover: {
    st4lth: "f1ps3kmd",
    Ermj5k: "f14xojzb",
    Bqenvij: "f1l02sjl",
    a9b677: "fly5x3f"
  },
  none: {
    st4lth: "f1plgu50",
    Ermj5k: ["f13uwng7", "fjmyj0p"],
    Bqenvij: "f1l02sjl",
    a9b677: "fly5x3f"
  },
  block: {
    a9b677: "fly5x3f"
  }
}, {
  d: [".fj3muxo{border-top-color:var(--colorNeutralStroke1);}", ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}", ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}", ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}", [".f1fabniw{border-radius:var(--borderRadiusNone);}", {
    p: -1
  }], ".f1ewtqcl{box-sizing:border-box;}", ".f14t3ns0{display:inline-block;}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f192inf7{border-top-width:var(--strokeWidthThin);}", ".f5tn483{border-right-width:var(--strokeWidthThin);}", ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}", ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}", [".f44lkw9{border-radius:var(--borderRadiusCircular);}", {
    p: -1
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f1whvlc6{box-shadow:var(--shadow4);}", ".f1plgu50{object-fit:none;}", ".f14xojzb{object-position:center;}", ".f1l02sjl{height:100%;}", ".fly5x3f{width:100%;}", ".f1kle4es{object-fit:contain;}", ".f1ps3kmd{object-fit:cover;}", ".f13uwng7{object-position:left top;}", ".fjmyj0p{object-position:right top;}"]
});
const useImageStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$B();
  state.root.className = mergeClasses(imageClassNames.root, styles.base, state.block && styles.block, state.bordered && styles.bordered, state.shadow && styles.shadow, styles[state.fit], styles[state.shape], state.root.className);
  return state;
};

/**
 * The Image component ensures the consistent styling of images.
 */ const Image$1 = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useImage_unstable(props, ref);
    useImageStyles_unstable(state);
    useCustomStyleHook$1('useImageStyles_unstable')(state);
    return renderImage_unstable(state);
});
Image$1.displayName = 'Image';

/**
 * Create the state required to render Text.
 *
 * The returned state can be modified with hooks such as useTextStyles_unstable,
 * before being passed to renderText_unstable.
 *
 * @param props - props from this instance of Text
 * @param ref - reference to root HTMLElement of Text
 */ const useText_unstable = (props, ref)=>{
    const { wrap, truncate, block, italic, underline, strikethrough, size, font, weight, align } = props;
    const state = {
        align: align !== null && align !== undefined ? align : 'start',
        block: block !== null && block !== undefined ? block : false,
        font: font !== null && font !== undefined ? font : 'base',
        italic: italic !== null && italic !== undefined ? italic : false,
        size: size !== null && size !== undefined ? size : 300,
        strikethrough: strikethrough !== null && strikethrough !== undefined ? strikethrough : false,
        truncate: truncate !== null && truncate !== undefined ? truncate : false,
        underline: underline !== null && underline !== undefined ? underline : false,
        weight: weight !== null && weight !== undefined ? weight : 'regular',
        wrap: wrap !== null && wrap !== undefined ? wrap : true,
        components: {
            root: 'span'
        },
        root: always(getIntrinsicElementProps('span', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLHeadingElement & HTMLPreElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'span'
        })
    };
    return state;
};

/**
 * Render the final JSX of Text
 */ const renderText_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsx(state.root, {});
};

const textClassNames = {
  root: 'fui-Text'
};
/**
 * Styles for the root slot
 */
const useStyles$A = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bg96gwp: "f1i3iumi",
    Bhrd7zp: "figsok6",
    fsow6f: "fpgzoln",
    mc9l5x: "f1w7gpdv",
    Huce71: "f6juhto",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1gl81tg",
    ygn44y: "f2jf649"
  },
  nowrap: {
    Huce71: "fz5stix",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp"
  },
  truncate: {
    ygn44y: "f1cmbuwj"
  },
  block: {
    mc9l5x: "ftgm304"
  },
  italic: {
    B80ckks: "f1j4dglz"
  },
  underline: {
    w71qe1: "f13mvf36"
  },
  strikethrough: {
    w71qe1: "fv5q2k7"
  },
  strikethroughUnderline: {
    w71qe1: "f1drk4o6"
  },
  base100: {
    Be2twd7: "f13mqy1h",
    Bg96gwp: "fcpl73t"
  },
  base200: {
    Be2twd7: "fy9rknc",
    Bg96gwp: "fwrc4pm"
  },
  base400: {
    Be2twd7: "fod5ikn",
    Bg96gwp: "faaz57k"
  },
  base500: {
    Be2twd7: "f1pp30po",
    Bg96gwp: "f106mvju"
  },
  base600: {
    Be2twd7: "f1x0m3f5",
    Bg96gwp: "fb86gi6"
  },
  hero700: {
    Be2twd7: "fojgt09",
    Bg96gwp: "fcen8rp"
  },
  hero800: {
    Be2twd7: "fccw675",
    Bg96gwp: "f1ebx5kk"
  },
  hero900: {
    Be2twd7: "f15afnhw",
    Bg96gwp: "fr3w3wp"
  },
  hero1000: {
    Be2twd7: "fpyltcb",
    Bg96gwp: "f1ivgwrt"
  },
  monospace: {
    Bahqtrf: "f1fedwem"
  },
  numeric: {
    Bahqtrf: "f1uq0ln5"
  },
  weightMedium: {
    Bhrd7zp: "fdj6btp"
  },
  weightSemibold: {
    Bhrd7zp: "fl43uef"
  },
  weightBold: {
    Bhrd7zp: "flh3ekv"
  },
  alignCenter: {
    fsow6f: "f17mccla"
  },
  alignEnd: {
    fsow6f: "f12ymhq5"
  },
  alignJustify: {
    fsow6f: "f1j59e10"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fpgzoln{text-align:start;}", ".f1w7gpdv{display:inline;}", ".f6juhto{white-space:normal;}", [".f1gl81tg{overflow:visible;}", {
    p: -1
  }], ".f2jf649{text-overflow:clip;}", ".fz5stix{white-space:nowrap;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], ".f1cmbuwj{text-overflow:ellipsis;}", ".ftgm304{display:block;}", ".f1j4dglz{font-style:italic;}", ".f13mvf36{text-decoration-line:underline;}", ".fv5q2k7{text-decoration-line:line-through;}", ".f1drk4o6{text-decoration-line:line-through underline;}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".faaz57k{line-height:var(--lineHeightBase400);}", ".f1pp30po{font-size:var(--fontSizeBase500);}", ".f106mvju{line-height:var(--lineHeightBase500);}", ".f1x0m3f5{font-size:var(--fontSizeBase600);}", ".fb86gi6{line-height:var(--lineHeightBase600);}", ".fojgt09{font-size:var(--fontSizeHero700);}", ".fcen8rp{line-height:var(--lineHeightHero700);}", ".fccw675{font-size:var(--fontSizeHero800);}", ".f1ebx5kk{line-height:var(--lineHeightHero800);}", ".f15afnhw{font-size:var(--fontSizeHero900);}", ".fr3w3wp{line-height:var(--lineHeightHero900);}", ".fpyltcb{font-size:var(--fontSizeHero1000);}", ".f1ivgwrt{line-height:var(--lineHeightHero1000);}", ".f1fedwem{font-family:var(--fontFamilyMonospace);}", ".f1uq0ln5{font-family:var(--fontFamilyNumeric);}", ".fdj6btp{font-weight:var(--fontWeightMedium);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".flh3ekv{font-weight:var(--fontWeightBold);}", ".f17mccla{text-align:center;}", ".f12ymhq5{text-align:end;}", ".f1j59e10{text-align:justify;}"]
});
/**
 * Apply styling to the Text slots based on the state
 */
const useTextStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$A();
  state.root.className = mergeClasses(textClassNames.root, styles.root, state.wrap === false && styles.nowrap, state.truncate && styles.truncate, state.block && styles.block, state.italic && styles.italic, state.underline && styles.underline, state.strikethrough && styles.strikethrough, state.underline && state.strikethrough && styles.strikethroughUnderline, state.size === 100 && styles.base100, state.size === 200 && styles.base200, state.size === 400 && styles.base400, state.size === 500 && styles.base500, state.size === 600 && styles.base600, state.size === 700 && styles.hero700, state.size === 800 && styles.hero800, state.size === 900 && styles.hero900, state.size === 1000 && styles.hero1000, state.font === 'monospace' && styles.monospace, state.font === 'numeric' && styles.numeric, state.weight === 'medium' && styles.weightMedium, state.weight === 'semibold' && styles.weightSemibold, state.weight === 'bold' && styles.weightBold, state.align === 'center' && styles.alignCenter, state.align === 'end' && styles.alignEnd, state.align === 'justify' && styles.alignJustify, state.root.className);
  return state;
};

/**
 * Typography and styling abstraction component used to ensure consistency of text.
 */ const Text = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useText_unstable(props, ref);
    useTextStyles_unstable(state);
    useCustomStyleHook$1('useTextStyles_unstable')(state);
    return renderText_unstable(state);
// Work around some small mismatches in inferred types which don't matter in practice
});
Text.displayName = 'Text';

function createPreset(options) {
    const { useStyles, className, displayName } = options;
    const Wrapper = React.forwardRef((props, ref)=>{
        'use no memo';
        const styles = useStyles();
        const state = useText_unstable(props, ref);
        useTextStyles_unstable(state);
        state.root.className = mergeClasses(className, state.root.className, styles.root, props.className);
        return renderText_unstable(state);
    });
    Wrapper.displayName = displayName;
    return Wrapper;
}

const body1ClassNames = {
  root: 'fui-Body1'
};
/**
 * Styles for the root slot
 */
const useBody1Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});

/**
 * Text preset component for the Body1 typography variant
 */ const Body1 = createPreset({
    useStyles: useBody1Styles,
    className: body1ClassNames.root,
    displayName: 'Body1'
});

const clampMax = (max)=>{
    const internalMax = max <= 0 ? 1 : max;
    if (process.env.NODE_ENV !== 'production') {
        if (max <= 0) {
            // eslint-disable-next-line no-console
            console.error(`The prop 'max' must be greater than 0. Received max: ${max}`);
        }
    }
    return internalMax;
};

const clampValue = (value, max)=>{
    if (value === undefined) {
        return value;
    }
    const internalValue = value < 0 ? 0 : value > max ? max : value;
    if (process.env.NODE_ENV !== 'production') {
        if (value < 0) {
            // eslint-disable-next-line no-console
            console.error(`The prop 'value' must be greater than or equal to zero. Received value: ${value}`);
        }
        if (value > max) {
            // eslint-disable-next-line no-console
            console.error(`The prop 'value' must be less than or equal to 'max'. Received value: ${value}, max: ${max}`);
        }
    }
    return internalValue;
};

/**
 * Create the state required to render ProgressBar.
 *
 * The returned state can be modified with hooks such as useProgressBarStyles_unstable,
 * before being passed to renderProgressBar_unstable.
 *
 * @param props - props from this instance of ProgressBar
 * @param ref - reference to root HTMLElement of ProgressBar
 */ const useProgressBar_unstable = (props, ref)=>{
    const field = useFieldContext_unstable();
    const fieldState = field === null || field === undefined ? undefined : field.validationState;
    const { color = fieldState === 'error' || fieldState === 'warning' || fieldState === 'success' ? fieldState : 'brand', shape = 'rounded', thickness = 'medium' } = props;
    var _props_max;
    const max = clampMax((_props_max = props.max) !== null && _props_max !== undefined ? _props_max : 1);
    const value = clampValue(props.value, max);
    const root = always(getIntrinsicElementProps('div', {
        // FIXME:
        // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
        // but since it would be a breaking change to fix it, we are casting ref to it's proper type
        ref: ref,
        role: 'progressbar',
        'aria-valuemin': value !== undefined ? 0 : undefined,
        'aria-valuemax': value !== undefined ? max : undefined,
        'aria-valuenow': value,
        'aria-labelledby': field === null || field === undefined ? undefined : field.labelId,
        ...props
    }), {
        elementType: 'div'
    });
    if (field && (field.validationMessageId || field.hintId)) {
        // Prepend the field's validation message and/or hint to the user's aria-describedby
        root['aria-describedby'] = [
            field === null || field === undefined ? undefined : field.validationMessageId,
            field === null || field === undefined ? undefined : field.hintId,
            root['aria-describedby']
        ].filter(Boolean).join(' ');
    }
    const bar = always(props.bar, {
        elementType: 'div'
    });
    const state = {
        color,
        max,
        shape,
        thickness,
        value,
        components: {
            root: 'div',
            bar: 'div'
        },
        root,
        bar
    };
    return state;
};

/**
 * Render the final JSX of ProgressBar
 */ const renderProgressBar_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsx(state.root, {
        children: state.bar && /*#__PURE__*/ jsx(state.bar, {})
    });
};

const progressBarClassNames = {
  root: 'fui-ProgressBar',
  bar: 'fui-ProgressBar__bar'
};
// If the percentComplete is near 0, don't animate it.
// This prevents animations on reset to 0 scenarios.
const ZERO_THRESHOLD = 0.01;
/**
 * Styles for the root slot
 */
const useRootStyles$1 = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "ftgm304",
    De3pzq: "f18f03hv",
    a9b677: "fly5x3f",
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    Bpep1pd: "fu42dvn"
  },
  rounded: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5"
  },
  square: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1fabniw"
  },
  medium: {
    Bqenvij: "f4t8t6x"
  },
  large: {
    Bqenvij: "f6ywr7j"
  }
}, {
  d: [".ftgm304{display:block;}", ".f18f03hv{background-color:var(--colorNeutralBackground6);}", ".fly5x3f{width:100%;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".f1fabniw{border-radius:var(--borderRadiusNone);}", {
    p: -1
  }], ".f4t8t6x{height:2px;}", ".f6ywr7j{height:4px;}"],
  m: [["@media screen and (forced-colors: active){.fu42dvn{background-color:CanvasText;}}", {
    m: "screen and (forced-colors: active)"
  }]]
});
/**
 * Styles for the ProgressBar bar
 */
const useBarStyles = /*#__PURE__*/__styles({
  base: {
    Bpep1pd: "f1neahkh",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f12b9xdw",
    Bqenvij: "f1l02sjl"
  },
  nonZeroDeterminate: {
    Bmy1vo4: "fjt6zfz",
    B3o57yi: "f1wofebd",
    Bkqvd7p: "fv71qf3"
  },
  indeterminate: {
    B2u0y6b: "fa0wk36",
    qhf8xq: "f10pi13n",
    Bcmaq0h: ["fpo0yib", "f1u5hf6c"],
    Bv12yb3: ["fwd2bol", "f14gig94"],
    vin17d: "f1a27w2r",
    Ezkn3b: "f452v7t",
    w3vfg9: "f1cpbl36",
    Gqtpxc: "f4akx1t",
    B3vm3ge: "f18p5put"
  },
  brand: {
    De3pzq: "ftywsgz"
  },
  error: {
    De3pzq: "fdl5y0r"
  },
  warning: {
    De3pzq: "f1s438gw"
  },
  success: {
    De3pzq: "flxk52p"
  }
}, {
  m: [["@media screen and (forced-colors: active){.f1neahkh{background-color:Highlight;}}", {
    m: "screen and (forced-colors: active)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f4akx1t{animation-duration:0.01ms;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f18p5put{animation-iteration-count:1;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }]],
  d: [[".f12b9xdw{border-radius:inherit;}", {
    p: -1
  }], ".f1l02sjl{height:100%;}", ".fjt6zfz{transition-property:width;}", ".f1wofebd{transition-duration:0.3s;}", ".fv71qf3{transition-timing-function:ease;}", ".fa0wk36{max-width:33%;}", ".f10pi13n{position:relative;}", ".fpo0yib{background-image:linear-gradient(\n      to right,\n      var(--colorNeutralBackground6) 0%,\n      var(--colorTransparentBackground) 50%,\n      var(--colorNeutralBackground6) 100%\n    );}", ".f1u5hf6c{background-image:linear-gradient(\n      to left,\n      var(--colorNeutralBackground6) 0%,\n      var(--colorTransparentBackground) 50%,\n      var(--colorNeutralBackground6) 100%\n    );}", ".fwd2bol{animation-name:f1keuaan;}", ".f14gig94{animation-name:f10x8f8u;}", ".f1a27w2r{animation-duration:3s;}", ".f452v7t{animation-timing-function:linear;}", ".f1cpbl36{animation-iteration-count:infinite;}", ".ftywsgz{background-color:var(--colorCompoundBrandBackground);}", ".fdl5y0r{background-color:var(--colorPaletteRedBackground3);}", ".f1s438gw{background-color:var(--colorPaletteDarkOrangeBackground3);}", ".flxk52p{background-color:var(--colorPaletteGreenBackground3);}"],
  k: ["@keyframes f1keuaan{0%{left:-33%;}100%{left:100%;}}", "@keyframes f10x8f8u{0%{right:-33%;}100%{right:100%;}}"]
});
/**
 * Apply styling to the ProgressBar slots based on the state
 */
const useProgressBarStyles_unstable = state => {
  'use no memo';

  const {
    color,
    max,
    shape,
    thickness,
    value
  } = state;
  const rootStyles = useRootStyles$1();
  const barStyles = useBarStyles();
  state.root.className = mergeClasses(progressBarClassNames.root, rootStyles.root, rootStyles[shape], rootStyles[thickness], state.root.className);
  if (state.bar) {
    state.bar.className = mergeClasses(progressBarClassNames.bar, barStyles.base, barStyles.brand, value === undefined && barStyles.indeterminate, value !== undefined && value > ZERO_THRESHOLD && barStyles.nonZeroDeterminate, color && value !== undefined && barStyles[color], state.bar.className);
  }
  if (state.bar && value !== undefined) {
    state.bar.style = {
      width: Math.min(100, Math.max(0, value / max * 100)) + '%',
      ...state.bar.style
    };
  }
  return state;
};

/**
 * A ProgressBar bar shows the progression of a task.
 */ const ProgressBar = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useProgressBar_unstable(props, ref);
    useProgressBarStyles_unstable(state);
    useCustomStyleHook$1('useProgressBarStyles_unstable')(state);
    return renderProgressBar_unstable(state);
});
ProgressBar.displayName = 'ProgressBar';

/**
 * Create the state required to render Toolbar.
 *
 * The returned state can be modified with hooks such as useToolbarStyles_unstable,
 * before being passed to renderToolbar_unstable.
 *
 * @param props - props from this instance of Toolbar
 * @param ref - reference to root HTMLElement of Toolbar
 */ const useToolbar_unstable = (props, ref)=>{
    const { size = 'medium', vertical = false } = props;
    const arrowNavigationProps = useArrowNavigationGroup({
        circular: true,
        axis: 'both'
    });
    const initialState = {
        size,
        vertical,
        // TODO add appropriate props/defaults
        components: {
            // TODO add each slot's element type or component
            root: 'div'
        },
        // TODO add appropriate slots, for example:
        // mySlot: resolveShorthand(props.mySlot),
        root: always(getIntrinsicElementProps('div', {
            role: 'toolbar',
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...vertical && {
                'aria-orientation': 'vertical'
            },
            ...arrowNavigationProps,
            ...props
        }), {
            elementType: 'div'
        })
    };
    const [checkedValues, onCheckedValueChange] = useToolbarSelectableState({
        checkedValues: props.checkedValues,
        defaultCheckedValues: props.defaultCheckedValues,
        onCheckedValueChange: props.onCheckedValueChange
    });
    const handleToggleButton = useEventCallback((e, name, value, checked)=>{
        if (name && value) {
            const checkedItems = (checkedValues === null || checkedValues === undefined ? undefined : checkedValues[name]) || [];
            const newCheckedItems = [
                ...checkedItems
            ];
            if (checked) {
                newCheckedItems.splice(newCheckedItems.indexOf(value), 1);
            } else {
                newCheckedItems.push(value);
            }
            onCheckedValueChange === null || onCheckedValueChange === undefined ? undefined : onCheckedValueChange(e, {
                name,
                checkedItems: newCheckedItems
            });
        }
    });
    const handleRadio = useEventCallback((e, name, value, checked)=>{
        if (name && value) {
            onCheckedValueChange === null || onCheckedValueChange === undefined ? undefined : onCheckedValueChange(e, {
                name,
                checkedItems: [
                    value
                ]
            });
        }
    });
    return {
        ...initialState,
        handleToggleButton,
        handleRadio,
        checkedValues: checkedValues !== null && checkedValues !== undefined ? checkedValues : {}
    };
};
/**
 * Adds appropriate state values and handlers for selectable items
 * i.e checkboxes and radios
 */ const useToolbarSelectableState = (state)=>{
    const [checkedValues, setCheckedValues] = useControllableState({
        state: state.checkedValues,
        defaultState: state.defaultCheckedValues,
        initialState: {}
    });
    const { onCheckedValueChange: onCheckedValueChangeOriginal } = state;
    const onCheckedValueChange = useEventCallback((e, { name, checkedItems })=>{
        if (onCheckedValueChangeOriginal) {
            onCheckedValueChangeOriginal(e, {
                name,
                checkedItems
            });
        }
        setCheckedValues((s)=>{
            return s ? {
                ...s,
                [name]: checkedItems
            } : {
                [name]: checkedItems
            };
        });
    });
    return [
        checkedValues,
        onCheckedValueChange
    ];
};

const ToolbarContext = createContext(undefined);

/**
 * Render the final JSX of Toolbar
 */ const renderToolbar_unstable = (state, contextValues)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsx(ToolbarContext.Provider, {
        value: contextValues.toolbar,
        children: /*#__PURE__*/ jsx(state.root, {
            children: state.root.children
        })
    });
};

const toolbarClassNames = {
  root: 'fui-Toolbar'
};
/**
 * Styles for the root slot
 */
const useStyles$z = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Bt984gj: "f122n59",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1yqiaad"
  },
  vertical: {
    Beiy3e4: "f1vx9l62",
    a9b677: "f1acs6jw"
  },
  small: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fvz760z"
  },
  medium: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1yqiaad"
  },
  large: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1ms6bdn"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f122n59{align-items:center;}", [".f1yqiaad{padding:4px 8px;}", {
    p: -1
  }], ".f1vx9l62{flex-direction:column;}", ".f1acs6jw{width:fit-content;}", [".fvz760z{padding:0px 4px;}", {
    p: -1
  }], [".f1yqiaad{padding:4px 8px;}", {
    p: -1
  }], [".f1ms6bdn{padding:4px 20px;}", {
    p: -1
  }]]
});
/**
 * Apply styling to the Toolbar slots based on the state
 */
const useToolbarStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$z();
  const {
    vertical,
    size
  } = state;
  state.root.className = mergeClasses(toolbarClassNames.root, styles.root, vertical && styles.vertical, size === 'small' && !vertical && styles.small, size === 'medium' && !vertical && styles.medium, size === 'large' && !vertical && styles.large, state.root.className);
  return state;
};

function useToolbarContextValues_unstable(state) {
    const { size, handleToggleButton, vertical, checkedValues, handleRadio } = state;
    // This context is created with "@fluentui/react-context-selector", these is no sense to memoize it
    const toolbar = {
        size,
        vertical,
        handleToggleButton,
        handleRadio,
        checkedValues
    };
    return {
        toolbar
    };
}

/**
 * Toolbar component
 */ const Toolbar = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useToolbar_unstable(props, ref);
    const contextValues = useToolbarContextValues_unstable(state);
    useToolbarStyles_unstable(state);
    useCustomStyleHook$1('useToolbarStyles_unstable')(state);
    return renderToolbar_unstable(state, contextValues);
});
Toolbar.displayName = 'Toolbar';

/**
 * @internal
 *
 * Create the state related to selectable cards.
 *
 * This internal hook controls all the logic for selectable cards and is
 * intended to be used alongside with useCard_unstable.
 *
 * @param props - props from this instance of Card
 * @param a11yProps - accessibility props shared between elements of the card
 * @param cardRef - reference to the root element of Card
 */ const useCardSelectable = (props, { referenceLabel, referenceId }, cardRef)=>{
    const { checkbox = {}, onSelectionChange, floatingAction, onClick, onKeyDown } = props;
    const { findAllFocusable } = useFocusFinders();
    const checkboxRef = React.useRef(null);
    const [selected, setSelected] = useControllableState({
        state: props.selected,
        defaultState: props.defaultSelected,
        initialState: false
    });
    const selectable = [
        props.selected,
        props.defaultSelected,
        onSelectionChange
    ].some((prop)=>typeof prop !== 'undefined');
    const [selectFocused, setSelectFocused] = React.useState(false);
    const shouldRestrictTriggerAction = React.useCallback((event)=>{
        if (!cardRef.current) {
            return false;
        }
        const focusableElements = findAllFocusable(cardRef.current);
        const target = event.target;
        const isElementInFocusableGroup = focusableElements.some((element)=>element.contains(target));
        const isCheckboxSlot = (checkboxRef === null || checkboxRef === undefined ? undefined : checkboxRef.current) === target;
        return isElementInFocusableGroup && !isCheckboxSlot;
    }, [
        cardRef,
        findAllFocusable
    ]);
    const onChangeHandler = React.useCallback((event)=>{
        if (shouldRestrictTriggerAction(event)) {
            return;
        }
        const newCheckedValue = !selected;
        setSelected(newCheckedValue);
        if (onSelectionChange) {
            onSelectionChange(event, {
                selected: newCheckedValue
            });
        }
    }, [
        onSelectionChange,
        selected,
        setSelected,
        shouldRestrictTriggerAction
    ]);
    const onKeyDownHandler = React.useCallback((event)=>{
        if ([
            Enter
        ].includes(event.key)) {
            event.preventDefault();
            onChangeHandler(event);
        }
    }, [
        onChangeHandler
    ]);
    const checkboxSlot = React.useMemo(()=>{
        if (!selectable || floatingAction) {
            return;
        }
        const selectableCheckboxProps = {};
        if (referenceId) {
            selectableCheckboxProps['aria-labelledby'] = referenceId;
        } else if (referenceLabel) {
            selectableCheckboxProps['aria-label'] = referenceLabel;
        }
        return optional(checkbox, {
            defaultProps: {
                ref: checkboxRef,
                type: 'checkbox',
                checked: selected,
                onChange: (event)=>onChangeHandler(event),
                onFocus: ()=>setSelectFocused(true),
                onBlur: ()=>setSelectFocused(false),
                ...selectableCheckboxProps
            },
            elementType: 'input'
        });
    }, [
        checkbox,
        floatingAction,
        selected,
        selectable,
        onChangeHandler,
        referenceId,
        referenceLabel
    ]);
    const floatingActionSlot = React.useMemo(()=>{
        if (!floatingAction) {
            return;
        }
        return optional(floatingAction, {
            defaultProps: {
                ref: checkboxRef
            },
            elementType: 'div'
        });
    }, [
        floatingAction
    ]);
    const selectableCardProps = React.useMemo(()=>{
        if (!selectable) {
            return null;
        }
        return {
            onClick: mergeCallbacks(onClick, onChangeHandler),
            onKeyDown: mergeCallbacks(onKeyDown, onKeyDownHandler)
        };
    }, [
        selectable,
        onChangeHandler,
        onClick,
        onKeyDown,
        onKeyDownHandler
    ]);
    return {
        selected,
        selectable,
        selectFocused,
        selectableCardProps,
        checkboxSlot,
        floatingActionSlot
    };
};

const cardContext = React.createContext(undefined);
/**
 * @internal
 */ const cardContextDefaultValue = {
    selectableA11yProps: {
        referenceId: undefined,
        setReferenceId () {
        /* Noop */ },
        referenceLabel: undefined,
        setReferenceLabel () {
        /* Noop */ }
    }
};
/**
 * @internal
 */ const CardProvider = cardContext.Provider;

const focusMap = {
    off: undefined,
    'no-tab': 'limited-trap-focus',
    'tab-exit': 'limited',
    'tab-only': 'unlimited'
};
/**
 * Create the state for interactive cards.
 *
 * This internal hook defines if the card is interactive
 * and control focus properties based on that.
 *
 * @param props - props from this instance of Card
 */ const useCardInteractive = ({ focusMode: initialFocusMode, ...props })=>{
    const interactive = [
        'onClick',
        'onDoubleClick',
        'onMouseUp',
        'onMouseDown',
        'onPointerUp',
        'onPointerDown',
        'onTouchStart',
        'onTouchEnd',
        'onDragStart',
        'onDragEnd'
    ].some((prop)=>props[prop]);
    // default focusMode to tab-only when interactive, and off when not
    const focusMode = initialFocusMode !== null && initialFocusMode !== undefined ? initialFocusMode : interactive ? 'no-tab' : 'off';
    const groupperAttrs = useFocusableGroup({
        tabBehavior: focusMap[focusMode]
    });
    const interactiveFocusAttributes = {
        ...groupperAttrs,
        tabIndex: 0
    };
    return {
        interactive,
        focusAttributes: focusMode === 'off' ? null : interactiveFocusAttributes
    };
};
/**
 * Create the state required to render Card.
 *
 * The returned state can be modified with hooks such as useCardStyles_unstable,
 * before being passed to renderCard_unstable.
 *
 * @param props - props from this instance of Card
 * @param ref - reference to the root element of Card
 */ const useCard_unstable = (props, ref)=>{
    const { appearance = 'filled', orientation = 'vertical', size = 'medium' } = props;
    const [referenceId, setReferenceId] = React.useState(cardContextDefaultValue.selectableA11yProps.referenceId);
    const [referenceLabel, setReferenceLabel] = React.useState(cardContextDefaultValue.selectableA11yProps.referenceId);
    const cardBaseRef = useFocusWithin();
    const { selectable, selected, selectableCardProps, selectFocused, checkboxSlot, floatingActionSlot } = useCardSelectable(props, {
        referenceId,
        referenceLabel
    }, cardBaseRef);
    const cardRef = useMergedRefs(cardBaseRef, ref);
    const { interactive, focusAttributes } = useCardInteractive(props);
    return {
        appearance,
        orientation,
        size,
        interactive,
        selectable,
        selectFocused,
        selected,
        selectableA11yProps: {
            setReferenceId,
            referenceId,
            referenceLabel,
            setReferenceLabel
        },
        components: {
            root: 'div',
            floatingAction: 'div',
            checkbox: 'input'
        },
        root: always(getIntrinsicElementProps('div', {
            ref: cardRef,
            role: 'group',
            ...!selectable ? focusAttributes : null,
            ...props,
            ...selectableCardProps
        }), {
            elementType: 'div'
        }),
        floatingAction: floatingActionSlot,
        checkbox: checkboxSlot
    };
};

/**
 * Render the final JSX of Card.
 */ const renderCard_unstable = (state, cardContextValue)=>{
    assertSlots(state);
    return /*#__PURE__*/ jsx(state.root, {
        children: /*#__PURE__*/ jsxs(CardProvider, {
            value: cardContextValue,
            children: [
                state.checkbox ? /*#__PURE__*/ jsx(state.checkbox, {}) : null,
                state.floatingAction ? /*#__PURE__*/ jsx(state.floatingAction, {}) : null,
                state.root.children
            ]
        })
    });
};

/**
 * Static CSS class names used internally for the component slots.
 */
const cardClassNames = {
  root: 'fui-Card',
  floatingAction: 'fui-Card__floatingAction',
  checkbox: 'fui-Card__checkbox'
};
const useCardResetStyles = /*#__PURE__*/__resetStyles("rfxo2k2", "rgle7w9", [".rfxo2k2{overflow:hidden;border-radius:var(--fui-Card--border-radius);padding:var(--fui-Card--size);gap:var(--fui-Card--size);display:flex;position:relative;box-sizing:border-box;color:var(--colorNeutralForeground1);}", ".rfxo2k2::after{position:absolute;top:0;left:0;right:0;bottom:0;content:\"\";pointer-events:none;border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-radius:var(--fui-Card--border-radius);}", ".rfxo2k2>.fui-CardHeader,.rfxo2k2>.fui-CardFooter{flex-shrink:0;}", ".rgle7w9{overflow:hidden;border-radius:var(--fui-Card--border-radius);padding:var(--fui-Card--size);gap:var(--fui-Card--size);display:flex;position:relative;box-sizing:border-box;color:var(--colorNeutralForeground1);}", ".rgle7w9::after{position:absolute;top:0;right:0;left:0;bottom:0;content:\"\";pointer-events:none;border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-radius:var(--fui-Card--border-radius);}", ".rgle7w9>.fui-CardHeader,.rgle7w9>.fui-CardFooter{flex-shrink:0;}"]);
const useCardStyles = /*#__PURE__*/__styles({
  focused: {
    Brovlpu: "ftqa4ok",
    B486eqv: "f2hkw1w",
    B8q5s1w: "f8hki3x",
    Bci5o5g: ["f1d2448m", "ffh67wi"],
    n8qw10: "f1bjia2o",
    Bdrgwmp: ["ffh67wi", "f1d2448m"],
    Bb7d1vk: "f226i61",
    zhwhgb: ["f13kzufm", "fsx75g8"],
    dhy2o1: "flujwa2",
    Gfyso: ["fsx75g8", "f13kzufm"],
    Bm4h7ae: "f15bsgw9",
    B7ys5i9: "f14e48fq",
    Busjfv9: "f18yb2kv",
    Bhk32uz: "fd6o370",
    f6g5ot: 0,
    Boxcth7: 0,
    Bhdgwq3: 0,
    hgwjuy: 0,
    Bshpdp8: 0,
    Bsom6fd: 0,
    Blkhhs4: 0,
    Bonggc9: 0,
    Ddfuxk: 0,
    i03rao: 0,
    kclons: 0,
    clg4pj: 0,
    Bpqj9nj: 0,
    B6dhp37: 0,
    Bf4ptjt: 0,
    Bqtpl0w: 0,
    i4rwgc: "fpqizxz",
    Dah5zi: 0,
    B1tsrr9: 0,
    qqdqy8: 0,
    Bkh64rk: 0,
    e3fwne: "fnd8nzh",
    J0r882: "f15fr7a0",
    Bule8hv: ["fwsq40z", "fy0y4wt"],
    Bjwuhne: "f34ld9f",
    Ghsupd: ["fy0y4wt", "fwsq40z"]
  },
  selectableFocused: {
    Brovlpu: "ftqa4ok",
    B486eqv: "f2hkw1w",
    Bssx7fj: "f1b1k54r",
    uh7if5: ["f4ne723", "fqqcjud"],
    clntm0: "fh7aioi",
    Dlk2r6: ["fqqcjud", "f4ne723"],
    Bm3wd5j: "f1k55ka9",
    Bbrhkcr: ["fgclinu", "f16pcs8n"],
    f1oku: "fycbxed",
    aywvf2: ["f16pcs8n", "fgclinu"],
    B2j2mmj: "ffht0p2",
    wigs8: "f1p0ul1q",
    pbfy6t: "f1c901ms",
    B0v4ure: "f1alokd7",
    Byrf0fs: 0,
    Bsiemmq: 0,
    Bwckmig: 0,
    skfxo0: 0,
    Iidy0u: 0,
    B98u21t: 0,
    Bvwlmkc: 0,
    jo1ztg: 0,
    Ba1iezr: 0,
    Blmvk6g: 0,
    B24cy0v: 0,
    Bil7v7r: 0,
    Br3gin4: 0,
    nr063g: 0,
    ghq09: 0,
    Bbgo44z: 0,
    Bseh09z: "f1i978nd",
    az1dzo: 0,
    Ba3ybja: 0,
    B6352mv: 0,
    vppk2z: 0,
    Biaj6j7: "f1nh8hsq",
    B2pnrqr: "f1amxum7",
    B29w5g4: ["f1cec8w7", "f554mv0"],
    Bhhzhcn: "f1sj6kbr",
    Bec0n69: ["f554mv0", "f1cec8w7"]
  },
  orientationHorizontal: {
    Beiy3e4: "f1063pyq",
    Bt984gj: "f122n59",
    Binpb3b: "ftrw7vg",
    qrt8p2: "f18opajm",
    k6ws3r: ["f13002it", "fqo182t"],
    Btcwela: ["f18yna97", "f1kd6wh7"],
    Fer9m8: "f4i4759"
  },
  orientationVertical: {
    Beiy3e4: "f1vx9l62",
    B5nvv7i: ["f14k419y", "f1fgo9fz"],
    Baxg94k: ["f1fgo9fz", "f14k419y"],
    tn21ii: "fvqmfsm",
    B0ud6bj: "f3am6yf",
    Bgdo4j: "f1r5wgso"
  },
  sizeSmall: {
    B7balbw: "f1pi9uxy",
    B1h88n7: "f1h1zgly"
  },
  sizeMedium: {
    B7balbw: "frsmuga",
    B1h88n7: "fuldkky"
  },
  sizeLarge: {
    B7balbw: "f1qua4xo",
    B1h88n7: "fimkt6v"
  },
  interactive: {
    rhjd8f: "f1epqm3e"
  },
  filled: {
    De3pzq: "fxugw4r",
    E5pizo: "f1whvlc6",
    B0n5ga8: "f16gxe2i",
    s924m2: ["fpgykix", "fzybk4o"],
    B1q35kw: "f1osi826",
    Gp14am: ["fzybk4o", "fpgykix"]
  },
  filledInteractive: {
    Bceei9c: "f1k6fduh",
    De3pzq: "fxugw4r",
    E5pizo: "f1whvlc6",
    B0n5ga8: "f16gxe2i",
    s924m2: ["fpgykix", "fzybk4o"],
    B1q35kw: "f1osi826",
    Gp14am: ["fzybk4o", "fpgykix"],
    Bi91k9c: "feu1g3u",
    Jwef8y: "f1knas48",
    Bvxd0ez: "f1m145df",
    ecr2s2: "fb40n2d"
  },
  filledInteractiveSelected: {
    De3pzq: "f1nfm20t",
    B0n5ga8: "f16eln5f",
    s924m2: ["fa2okxs", "fg4zq3l"],
    B1q35kw: "ff6932p",
    Gp14am: ["fg4zq3l", "fa2okxs"],
    Bi91k9c: "fx9teim",
    Jwef8y: "f1kz6goq"
  },
  filledAlternative: {
    De3pzq: "f1dmdbja",
    E5pizo: "f1whvlc6",
    B0n5ga8: "f16gxe2i",
    s924m2: ["fpgykix", "fzybk4o"],
    B1q35kw: "f1osi826",
    Gp14am: ["fzybk4o", "fpgykix"]
  },
  filledAlternativeInteractive: {
    Bceei9c: "f1k6fduh",
    De3pzq: "f1dmdbja",
    E5pizo: "f1whvlc6",
    B0n5ga8: "f16gxe2i",
    s924m2: ["fpgykix", "fzybk4o"],
    B1q35kw: "f1osi826",
    Gp14am: ["fzybk4o", "fpgykix"],
    Bi91k9c: "fnwyq0v",
    Jwef8y: "f1uvynv3",
    Bvxd0ez: "f1m145df",
    ecr2s2: "f1yhgkbh"
  },
  filledAlternativeInteractiveSelected: {
    De3pzq: "fjxa0vh",
    B0n5ga8: "f16eln5f",
    s924m2: ["fa2okxs", "fg4zq3l"],
    B1q35kw: "ff6932p",
    Gp14am: ["fg4zq3l", "fa2okxs"],
    Bi91k9c: "f1luvkty",
    Jwef8y: "fehi0vp"
  },
  outline: {
    De3pzq: "f1c21dwh",
    E5pizo: "f1couhl3",
    B0n5ga8: "ft83z1f",
    s924m2: ["f1g4150c", "f192dr6e"],
    B1q35kw: "f1qnawh6",
    Gp14am: ["f192dr6e", "f1g4150c"]
  },
  outlineInteractive: {
    Bceei9c: "f1k6fduh",
    De3pzq: "f1c21dwh",
    E5pizo: "f1couhl3",
    B0n5ga8: "ft83z1f",
    s924m2: ["f1g4150c", "f192dr6e"],
    B1q35kw: "f1qnawh6",
    Gp14am: ["f192dr6e", "f1g4150c"],
    Bi91k9c: "feu1g3u",
    Jwef8y: "fjxutwb",
    Be0v6ae: "f1llr77y",
    B5kxglz: ["fzk0khw", "fjj8tog"],
    B3pwyw6: "fb1u8ub",
    Bymgtzf: ["fjj8tog", "fzk0khw"],
    ecr2s2: "fophhak",
    dmfk: "f1uohb70",
    B4ofi8: ["f1jm7v1n", "f1bus3rq"],
    jgq6uv: "f1fbu7rr",
    Baxewws: ["f1bus3rq", "f1jm7v1n"]
  },
  outlineInteractiveSelected: {
    De3pzq: "f1q9pm1r",
    B0n5ga8: "f16eln5f",
    s924m2: ["fa2okxs", "fg4zq3l"],
    B1q35kw: "ff6932p",
    Gp14am: ["fg4zq3l", "fa2okxs"],
    Bi91k9c: "fx9teim",
    Jwef8y: "fg59vm4"
  },
  subtle: {
    De3pzq: "fhovq9v",
    E5pizo: "f1couhl3",
    B0n5ga8: "f16gxe2i",
    s924m2: ["fpgykix", "fzybk4o"],
    B1q35kw: "f1osi826",
    Gp14am: ["fzybk4o", "fpgykix"]
  },
  subtleInteractive: {
    Bceei9c: "f1k6fduh",
    De3pzq: "fhovq9v",
    E5pizo: "f1couhl3",
    B0n5ga8: "f16gxe2i",
    s924m2: ["fpgykix", "fzybk4o"],
    B1q35kw: "f1osi826",
    Gp14am: ["fzybk4o", "fpgykix"],
    Bi91k9c: "feu1g3u",
    Jwef8y: "f1t94bn6",
    ecr2s2: "f1wfn5kd"
  },
  subtleInteractiveSelected: {
    De3pzq: "fq5gl1p",
    B0n5ga8: "f16eln5f",
    s924m2: ["fa2okxs", "fg4zq3l"],
    B1q35kw: "ff6932p",
    Gp14am: ["fg4zq3l", "fa2okxs"],
    Bi91k9c: "fx9teim",
    Jwef8y: "f1uqaxdt"
  },
  highContrastSelected: {
    ycbfsm: "fkc42ay",
    Bsw6fvg: "f1rirnrt",
    Bbusuzp: "f1lkg8j3",
    xgfqdd: "f1nkj0oa",
    Bmmdzwq: "fey3rwa",
    zkpvhj: ["f5jhx11", "fff9uym"],
    B20bydw: "fm7n0jy",
    Bwwwggl: ["fff9uym", "f5jhx11"]
  },
  highContrastInteractive: {
    h1vhog: "fpfvv3l",
    kslmdy: "f1oamsm6",
    Baaf6ca: "f1il21bs",
    x9zz3d: "fnn5dk0",
    Bmmdzwq: "fey3rwa",
    zkpvhj: ["f5jhx11", "fff9uym"],
    B20bydw: "fm7n0jy",
    Bwwwggl: ["fff9uym", "f5jhx11"]
  },
  select: {
    qhf8xq: "f1euv43f",
    Bhzewxz: "fqclxi7",
    j35jbq: ["fiv86kb", "f36uhnt"],
    Bj3rh1h: "f19g0ac"
  },
  hiddenCheckbox: {
    B68tc82: 0,
    Bmxbyg5: 0,
    Bpg54ce: "f1a3p1vp",
    a9b677: "frkrog8",
    Bqenvij: "f1mpe4l3",
    qhf8xq: "f1euv43f",
    Bh84pgu: "fmf1zke",
    Bgl5zvf: "f1wch0ki",
    Huce71: "fz5stix"
  }
}, {
  f: [".ftqa4ok:focus{outline-style:none;}"],
  i: [".f2hkw1w:focus-visible{outline-style:none;}"],
  d: [".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}", ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}", ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}", ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}", ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}", ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}", ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}", ".fd6o370[data-fui-focus-visible]::after{z-index:1;}", [".fpqizxz[data-fui-focus-visible]::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}", {
    p: -2
  }], [".fnd8nzh[data-fui-focus-visible]::after{border-radius:var(--fui-Card--border-radius);}", {
    p: -1
  }], ".f15fr7a0[data-fui-focus-visible]::after{top:calc(0px - var(--strokeWidthThick) - -2px);}", ".fwsq40z[data-fui-focus-visible]::after{right:calc(0px - var(--strokeWidthThick) - -2px);}", ".fy0y4wt[data-fui-focus-visible]::after{left:calc(0px - var(--strokeWidthThick) - -2px);}", ".f34ld9f[data-fui-focus-visible]::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}", ".f1b1k54r[data-fui-focus-within]:focus-within{border-top-color:transparent;}", ".f4ne723[data-fui-focus-within]:focus-within{border-right-color:transparent;}", ".fqqcjud[data-fui-focus-within]:focus-within{border-left-color:transparent;}", ".fh7aioi[data-fui-focus-within]:focus-within{border-bottom-color:transparent;}", ".ffht0p2[data-fui-focus-within]:focus-within::after{content:\"\";}", ".f1p0ul1q[data-fui-focus-within]:focus-within::after{position:absolute;}", ".f1c901ms[data-fui-focus-within]:focus-within::after{pointer-events:none;}", ".f1alokd7[data-fui-focus-within]:focus-within::after{z-index:1;}", [".f1i978nd[data-fui-focus-within]:focus-within::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}", {
    p: -2
  }], [".f1nh8hsq[data-fui-focus-within]:focus-within::after{border-radius:var(--fui-Card--border-radius);}", {
    p: -1
  }], ".f1amxum7[data-fui-focus-within]:focus-within::after{top:calc(0px - var(--strokeWidthThick) - -2px);}", ".f1cec8w7[data-fui-focus-within]:focus-within::after{right:calc(0px - var(--strokeWidthThick) - -2px);}", ".f554mv0[data-fui-focus-within]:focus-within::after{left:calc(0px - var(--strokeWidthThick) - -2px);}", ".f1sj6kbr[data-fui-focus-within]:focus-within::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}", ".f1063pyq{flex-direction:row;}", ".f122n59{align-items:center;}", ".ftrw7vg>.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}", ".f18opajm>.fui-CardPreview{margin-bottom:calc(var(--fui-Card--size) * -1);}", ".f13002it>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-left:calc(var(--fui-Card--size) * -1);}", ".fqo182t>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-right:calc(var(--fui-Card--size) * -1);}", ".f18yna97>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-right:calc(var(--fui-Card--size) * -1);}", ".f1kd6wh7>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-left:calc(var(--fui-Card--size) * -1);}", ".f4i4759>.fui-CardHeader:last-of-type,.f4i4759>.fui-CardFooter:last-of-type{flex-grow:1;}", ".f1vx9l62{flex-direction:column;}", ".f14k419y>.fui-CardPreview{margin-left:calc(var(--fui-Card--size) * -1);}", ".f1fgo9fz>.fui-CardPreview{margin-right:calc(var(--fui-Card--size) * -1);}", ".fvqmfsm>:not([aria-hidden=\"true\"]).fui-CardPreview:first-of-type{margin-top:calc(var(--fui-Card--size) * -1);}", ".f3am6yf>.fui-Card__floatingAction+.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}", ".f1r5wgso>:not([aria-hidden=\"true\"]).fui-CardPreview:last-of-type{margin-bottom:calc(var(--fui-Card--size) * -1);}", ".f1pi9uxy{--fui-Card--size:8px;}", ".f1h1zgly{--fui-Card--border-radius:var(--borderRadiusSmall);}", ".frsmuga{--fui-Card--size:12px;}", ".fuldkky{--fui-Card--border-radius:var(--borderRadiusMedium);}", ".f1qua4xo{--fui-Card--size:16px;}", ".fimkt6v{--fui-Card--border-radius:var(--borderRadiusLarge);}", ".f1epqm3e .fui-Text{color:currentColor;}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f1whvlc6{box-shadow:var(--shadow4);}", ".f16gxe2i::after{border-top-color:var(--colorTransparentStroke);}", ".fpgykix::after{border-right-color:var(--colorTransparentStroke);}", ".fzybk4o::after{border-left-color:var(--colorTransparentStroke);}", ".f1osi826::after{border-bottom-color:var(--colorTransparentStroke);}", ".f1k6fduh{cursor:pointer;}", ".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}", ".f16eln5f::after{border-top-color:var(--colorNeutralStroke1Selected);}", ".fa2okxs::after{border-right-color:var(--colorNeutralStroke1Selected);}", ".fg4zq3l::after{border-left-color:var(--colorNeutralStroke1Selected);}", ".ff6932p::after{border-bottom-color:var(--colorNeutralStroke1Selected);}", ".f1dmdbja{background-color:var(--colorNeutralBackground2);}", ".fjxa0vh{background-color:var(--colorNeutralBackground2Selected);}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1couhl3{box-shadow:none;}", ".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}", ".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}", ".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}", ".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}", ".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}", ".fhovq9v{background-color:var(--colorSubtleBackground);}", ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}", ".f1euv43f{position:absolute;}", ".fqclxi7{top:4px;}", ".fiv86kb{right:4px;}", ".f36uhnt{left:4px;}", ".f19g0ac{z-index:1;}", [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], ".frkrog8{width:1px;}", ".f1mpe4l3{height:1px;}", ".fmf1zke{clip:rect(0 0 0 0);}", ".f1wch0ki{clip-path:inset(50%);}", ".fz5stix{white-space:nowrap;}"],
  m: [["@media (forced-colors: active){.f226i61[data-fui-focus-visible]::after{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f13kzufm[data-fui-focus-visible]::after{border-right-color:Highlight;}.fsx75g8[data-fui-focus-visible]::after{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.flujwa2[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1k55ka9[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f16pcs8n[data-fui-focus-within]:focus-within::after{border-left-color:Highlight;}.fgclinu[data-fui-focus-within]:focus-within::after{border-right-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fycbxed[data-fui-focus-within]:focus-within::after{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1nkj0oa .fui-CardPreview,.f1nkj0oa .fui-CardFooter{forced-color-adjust:auto;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fey3rwa::after{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f5jhx11::after{border-right-color:Highlight;}.fff9uym::after{border-left-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fm7n0jy::after{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fpfvv3l:hover,.fpfvv3l :active{forced-color-adjust:none;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1oamsm6:hover,.f1oamsm6 :active{background-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1il21bs:hover,.f1il21bs :active{color:HighlightText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fnn5dk0:hover .fui-CardPreview,.fnn5dk0 :active .fui-CardPreview,.fnn5dk0:hover .fui-CardFooter,.fnn5dk0 :active .fui-CardFooter{forced-color-adjust:auto;}}", {
    m: "(forced-colors: active)"
  }]],
  h: [".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}", ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}", ".f1m145df:hover{box-shadow:var(--shadow8);}", ".fx9teim:hover{color:var(--colorNeutralForeground1Selected);}", ".f1kz6goq:hover{background-color:var(--colorNeutralBackground1Selected);}", ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}", ".f1uvynv3:hover{background-color:var(--colorNeutralBackground2Hover);}", ".f1luvkty:hover{color:var(--colorNeutralForeground2Selected);}", ".fehi0vp:hover{background-color:var(--colorNeutralBackground2Selected);}", ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}", ".f1llr77y:hover::after{border-top-color:var(--colorNeutralStroke1Hover);}", ".fzk0khw:hover::after{border-right-color:var(--colorNeutralStroke1Hover);}", ".fjj8tog:hover::after{border-left-color:var(--colorNeutralStroke1Hover);}", ".fb1u8ub:hover::after{border-bottom-color:var(--colorNeutralStroke1Hover);}", ".fg59vm4:hover{background-color:var(--colorTransparentBackgroundSelected);}", ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}", ".f1uqaxdt:hover{background-color:var(--colorSubtleBackgroundSelected);}"],
  a: [".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}", ".f1yhgkbh:active{background-color:var(--colorNeutralBackground2Pressed);}", ".fophhak:active{background-color:var(--colorTransparentBackgroundPressed);}", ".f1uohb70:active::after{border-top-color:var(--colorNeutralStroke1Pressed);}", ".f1jm7v1n:active::after{border-right-color:var(--colorNeutralStroke1Pressed);}", ".f1bus3rq:active::after{border-left-color:var(--colorNeutralStroke1Pressed);}", ".f1fbu7rr:active::after{border-bottom-color:var(--colorNeutralStroke1Pressed);}", ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"]
});
/**
 * Apply styling to the Card slots based on the state.
 */
const useCardStyles_unstable = state => {
  'use no memo';

  const resetStyles = useCardResetStyles();
  const styles = useCardStyles();
  const orientationMap = {
    horizontal: styles.orientationHorizontal,
    vertical: styles.orientationVertical
  };
  const sizeMap = {
    small: styles.sizeSmall,
    medium: styles.sizeMedium,
    large: styles.sizeLarge
  };
  const appearanceMap = {
    filled: styles.filled,
    'filled-alternative': styles.filledAlternative,
    outline: styles.outline,
    subtle: styles.subtle
  };
  const selectedMap = {
    filled: styles.filledInteractiveSelected,
    'filled-alternative': styles.filledAlternativeInteractiveSelected,
    outline: styles.outlineInteractiveSelected,
    subtle: styles.subtleInteractiveSelected
  };
  const interactiveMap = {
    filled: styles.filledInteractive,
    'filled-alternative': styles.filledAlternativeInteractive,
    outline: styles.outlineInteractive,
    subtle: styles.subtleInteractive
  };
  const isSelectableOrInteractive = state.interactive || state.selectable;
  const focusedClassName = React.useMemo(() => {
    if (state.selectable) {
      if (state.selectFocused) {
        return styles.selectableFocused;
      }
      return '';
    }
    return styles.focused;
  }, [state.selectFocused, state.selectable, styles.focused, styles.selectableFocused]);
  state.root.className = mergeClasses(cardClassNames.root, resetStyles, orientationMap[state.orientation], sizeMap[state.size], appearanceMap[state.appearance], isSelectableOrInteractive && styles.interactive, isSelectableOrInteractive && interactiveMap[state.appearance], state.selected && selectedMap[state.appearance], focusedClassName, isSelectableOrInteractive && styles.highContrastInteractive, state.selected && styles.highContrastSelected, state.root.className);
  if (state.floatingAction) {
    state.floatingAction.className = mergeClasses(cardClassNames.floatingAction, styles.select, state.floatingAction.className);
  }
  if (state.checkbox) {
    state.checkbox.className = mergeClasses(cardClassNames.checkbox, styles.hiddenCheckbox, state.checkbox.className);
  }
  return state;
};

function useCardContextValue({ selectableA11yProps }) {
    return {
        selectableA11yProps
    };
}

/**
 * A card provides scaffolding for hosting actions and content for a single topic.
 */ const Card = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useCard_unstable(props, ref);
    const cardContextValue = useCardContextValue(state);
    useCardStyles_unstable(state);
    return renderCard_unstable(state, cardContextValue);
});
Card.displayName = 'Card';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

const MCAPSBotContext$1 = React__default.createContext(null);
const AppContextProvider$1 = ({ mcapsBotContext, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotContext$1.Provider, { value: mcapsBotContext, children });
};

const generateId = () => {
    const timestamp = Date.now().toString();
    const random = Math.random().toString().substring(2);
    return `${timestamp}${random}`;
};

const getDateTime = () => {
    let current = new Date();
    let cDate = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate();
    let cTime = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
    let dateTime = cDate + ' ' + cTime;
    return dateTime.toString();
};

function isQuestionExitInSuggestions(data, suggestionText) {
        console.log('isQuestionExitInSuggestions', suggestionText);
    for (const section of data) {
        if (section.suggestions) {
            const exists = section.suggestions.some(suggestion => suggestion.suggestion === suggestionText);
            if (exists) {
                return true;
            }
        }
    }
    return false;
}

function getQuesAns(answer) {
    if(answer && answer?.source === "nl2sqldbcopilot") {
        if(answer?.data?.errorCode && answer?.data?.errorCode !== null && answer?.data?.errorCode !== undefined) {
            return {
                question: answer?.question,
                conversationId: answer?.conversationId,
                botConversationId: generateId(),
                answer: answer?.data?.errorMessage
            }
        } else if(answer?.data?.isChart && answer?.data?.isChart !== null && answer?.data?.isChart !== undefined && answer?.data?.isChart === true) {
             return {
                question: answer?.question,
                conversationId: answer?.conversationId,
                botConversationId: generateId(),
                answer: JSON.parse(answer?.data?.chartData).data
            }
        } else {
            return {
                question: answer?.question,
                conversationId: answer?.conversationId,
                botConversationId: generateId(),
                answer: answer?.data?.markDownResult
            }

        }
    } else {
        if(answer?.data?.errorCode && answer?.data?.errorCode !== null && answer?.data?.errorCode !== undefined) {
            return {
                question: answer?.question,
                conversationId: answer?.conversationId,
                botConversationId: generateId(),
                answer: answer?.data?.errorMessage
            }
        } else {
            let response = { reply: answer };
            if (response.reply && typeof response.reply == "string") {
            response.reply = JSON.parse(response.reply);
            }
        
            if (response.reply?.data && typeof response.reply?.data == "string") {
            response.reply = JSON.parse(response.reply?.data);
            }
            if (response.reply && typeof response.reply == "string") {
            response.reply = JSON.parse(response.reply);
            }
            if (response.reply && response.reply.ResponseType === "error") {
                response.reply = JSON.parse(response.reply.Data);
            }
            let botResponse = typeof response.reply?.reply === "string"
                ? response.reply?.reply?.replace(/:/g, "")
                : typeof response.reply?.aiResponseData === "string"
                ? response.reply?.aiResponseData?.replace(/:/g, "")
                : response.reply?.reply
                ? response.reply?.reply
                : typeof response.reply?.contentData === "string"
                ? response.reply?.contentData
                    .replace(/<Cell>/g, "")
                    .replace(/<\/Cell>/g, "")
                : response.reply
                ? response.reply
                : response.data
                ? response
                : "";
        
            return {
                question: answer?.question,
                conversationId: answer?.conversationId,
                botConversationId: generateId(),
                answer: botResponse,
            };
        }
    }
  
}

function getErrorResponse(error) {
    let response = { reply: error.config.data };
    if (response.reply && typeof response.reply == "string") {
        response.reply = JSON.parse(response.reply);
    }

    return {
        question: response.reply?.question,
        conversationId: response.reply?.conversationId,
        botConversationId: generateId(),
        answer: error.message,
    };
}

const getCommandResponse = (answer) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(answer, "text/html");
    let text = doc.body.textContent;
    return text;
};

const getEventTypeQuestionAnser = (key,value,formState,eventType) => {
    if (eventType["Event"].includes(key)) {
        return {
            type: "Event",
            userQuestion: formState,
            botResponse: undefined
        }
    } else if (eventType["Query"].includes(key)) {
        return {
            type: "Query",
            userQuestion: value.question,
            botResponse: value.answer
        }
    } else if (eventType["CopilotPanelActions"].includes(key)) {
        return {
            type: "Event",
            userQuestion: value.question,
            botResponse: value.answer
        }
    } else if (eventType["Command"].includes(key)) {
        return {
            type: "Command",
            userQuestion: value.question,
            botResponse: value.answer
        }
    }
};

const getEventTypeQuestionAnserV1 = (key,value,eventType) => {
    if (eventType["Event"].includes(key)) {
        return {
            type: "Event",
            userQuestion: value,
            botResponse: undefined
        }
    } 
    else if (eventType["Query"].includes(key)) {
        return {
            type: "Query",
            userQuestion: value.question,
            botResponse: value.answer
        }
    } else if (eventType["CopilotPanelActions"].includes(key)) {
        return {
            type: "Event",
            userQuestion: value.question,
            botResponse: value.answer
        }
    } else if (eventType["Command"].includes(key)) {
        return {
            type: "Command",
            userQuestion: value.question,
            botResponse: value.answer
        }
    }
};

const SET_USER = "SET_USER";
const set_user = (user) => ({
  type: SET_USER,
  user
});
const initialState$7 = {
  user: undefined
};
const useReducer = (state = initialState$7, action) => {
  switch (action.type) {
    case SET_USER:
      const { user } = action;
      return { ...state, user };
    default:
      return state;
  }
};

const SET_APP_NAME = "SET_APP_NAME";
const GET_APP_NAME = "GET_APP_NAME";
const get_appName = () => ({
  type: GET_APP_NAME
});
const set_appName = (appname) => ({
  type: SET_APP_NAME,
  appname
});
const initialState$6 = {
  appname: undefined
};
const appReducer = (state = initialState$6, action) => {
  switch (action.type) {
    case SET_APP_NAME:
      const { appname } = action;
      return { ...state, appname };
    default:
      return state;
  }
};

const SET_CONFIGURATION = "SET_CONFIGURATION";
const GET_CONFIGURATION = "GET_CONFIGURATION";
const get_configuration = () => ({
  type: GET_CONFIGURATION
});
const set_configuration = (config) => ({
  type: SET_CONFIGURATION,
  config
});
const initialState$5 = {
  config: {}
};
const configReducer = (state = initialState$5, action) => {
  switch (action.type) {
    case SET_CONFIGURATION:
      const { config } = action;
      return { ...state, config };
    case GET_CONFIGURATION:
    default:
      return state;
  }
};

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
// These constants are currently NOT exported directly, we may export them later associated with a frozen namespace (maybe)
// For now do NOT expect that we will export these values.
var UNDEF_VALUE = undefined;
var NULL_VALUE = null;
var EMPTY$1 = "";
var FUNCTION = "function";
var OBJECT$1 = "object";
var PROTOTYPE = "prototype";
var __PROTO__ = "__proto__";
var UNDEFINED = "undefined";
var CONSTRUCTOR = "constructor";
var SYMBOL = "Symbol";
var POLYFILL_TAG = "_polyfill";
var LENGTH = "length";
var NAME = "name";
var CALL$1 = "call";
var TO_STRING = "toString";
/**
 * @ignore
 */
var ObjClass$1 = Object;
/**
 * @ignore
 */
var ObjProto$1 = ObjClass$1[PROTOTYPE];
/**
 * @ignore
 */
var StrCls = String;
/**
 * @ignore
 */
var StrProto = StrCls[PROTOTYPE];
/**
 * @ignore
 */
var MathCls = Math;
/**
 * @ignore
 */
var ArrCls = Array;
/**
 * @ignore
 */
var ArrProto = ArrCls[PROTOTYPE];
/**
 * @ignore
 *
 */
var ArrSlice = ArrProto["slice"];

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Call the specified function with zero or more individual arguments, the call will be wrapped in a try / catch
 * block and the result returned wrapped in an {@link ISafeReturn} instance. If the function call throws an
 * exception the {@link ISafeReturn.e error} property will contain the exception otherwise the {@link ISafeReturn.v value}
 * property will contain the value returned from the function.
 * @since 0.10.5
 * @group Safe
 * @param func - The function to call
 * @param argArray - An array of the arguments to pass to the function
 * @returns The return value of the function or undefined if an exception is thrown
 * @example
 * ```ts
 * let result = safe((value: string) => {
 *    return JSON.parse(value);
 * }, ["{ invalid: json value"]);
 *
 * // result.e instanceof SyntaxError
 *
 * let result2 = safe((value: string) => {
 *   return JSON.parse(value);
 * }, ["{ valid: json value"]);
 *
 * // result2.v === { valid: "json value" }
 */
function safe(func, argArray) {
    try {
        return {
            v: func.apply(this, argArray)
        };
    }
    catch (e) {
        return { e: e };
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Function to safely execute a callback function, if the function throws the provided default
 * value will be returned.
 * @since 0.9.5
 * @group Safe
 * @param cb - Callback function be wrapped with an exception
 * @param defValue - The default value to return when an exception is thrown
 * @returns The result of the callback function or the default if an exception occurred calling the callback
 * function.
 * @example
 * ```ts
 * let theExpression = "{ invalid: json value";
 *
 * let result = safeGet(() => {
 *     return JSON.parse(theExpression);
 * }, {});
 *
 * // result === {};
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function safeGet(cb, defValue) {
    var result = safe(cb);
    return result.e ? defValue : result.v;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _primitiveTypes;
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the provided type.
 * @param theType - The type to match against the `typeof value`
 * @returns A function which takes a single argument and returns a boolean
 */
/*#__NO_SIDE_EFFECTS__*/
function _createIs(theType) {
    return function (value) {
        return typeof value === theType;
    };
}
/**
 * @ignore
 * @internal
 * Create and returns a function that will return `true` if the argument passed
 * to it matches the object type specified based on {@link objToString}.
 * @param - The object name to match for the `objToString(value)`
 * @returns A function which takes a single argument and returns a boolean
 */
/*#__NO_SIDE_EFFECTS__*/
function _createObjIs(theName) {
    var theType = "[object " + theName + "]";
    return function (value) {
        return !!(value && objToString(value) === theType);
    };
}
/**
 * The `objToString()` method returns a string representing the object. This explicitly
 * always calls the `Object.prototype.toString()` method.
 *
 * An object's toString() method is most commonly invoked when that object undergoes:
 * - explicit type conversion to a string (for example, String(myObject))
 * - implicit type coercion into a string (for example, myObject + "hello world")
 *
 * @group Object
 * @param value - The object to be converted into a string
 * @returns A string representation of the object
 * @example
 * ```ts
 * objToString(new Date()); // [object Date]
 * objToString(new String()); // [object String]
 *
 * // Math has its Symbol.toStringTag
 * objToString(Math); // [object Math]
 *
 * objToString(undefined); // [object Undefined]
 * objToString(null); // [object Null]
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function objToString(value) {
    return ObjProto$1.toString.call(value);
}
/**
 * Checks if the provided value is undefined or contains the string value "undefined",
 * if you want to consider the string value as undefined see {@link isStrictUndefined}
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns true if the value is undefined or "undefined", otherwise false
 * @example
 * ```ts
 * isUndefined(undefined);              // true
 * isUndefined("undefined");            // true
 *
 * isUndefined(null);                   // false
 * isUndefined("null");                 // false
 * isUndefined("1");                    // false
 * isUndefined("aa");                   // false
 * isUndefined(new Date());             // false
 * isUndefined(1);                      // false
 * isUndefined("");                     // false
 * isUndefined(_dummyFunction);         // false
 * isUndefined([]);                     // false
 * isUndefined(new Array(1));           // false
 * isUndefined(true);                   // false
 * isUndefined(false);                  // false
 * isUndefined("true");                 // false
 * isUndefined("false");                // false
 * isUndefined(new Boolean(true));      // false
 * isUndefined(new Boolean(false));     // false
 * isUndefined(new Boolean("true"));    // false
 * isUndefined(new Boolean("false"));   // false
 * isUndefined(Boolean(true));          // false
 * isUndefined(Boolean(false));         // false
 * isUndefined(Boolean("true"));        // false
 * isUndefined(Boolean("false"));       // false
 * isUndefined(new RegExp(""));         // false
 * isUndefined(new ArrayBuffer(0));     // false
 * isUndefined(new Error("Test Error"));// false
 * isUndefined(new TypeError("Test TypeError"));    // false
 * isUndefined(new TestError("Test TestError"));    // false
 * isUndefined(_dummyError());          // false
 * isUndefined(Promise.reject());       // false
 * isUndefined(Promise.resolve());      // false
 * isUndefined(new Promise(() => {}));  // false
 * isUndefined(_simplePromise());       // false
 * isUndefined(_simplePromiseLike());   // false
 * isUndefined(Object.create(null));    // false
 * isUndefined(polyObjCreate(null));    // false
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isUndefined$2(value) {
    return typeof value === UNDEFINED || value === UNDEFINED;
}
/**
 * Checks if the provided value is null, undefined or contains the string value of "undefined".
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns `true` if the value is `null` or `undefined`
 * @example
 * ```ts
 * isNullOrUndefined(null);         // true
 * isNullOrUndefined(undefined);    // true
 * isNullOrUndefined("undefined");  // true
 *
 * let value = null;
 * isNullOrUndefined(value);        // true
 * let value = undefined;
 * isNullOrUndefined(value);        // true
 *
 * isNullOrUndefined("");           // false
 * isNullOrUndefined(0);            // false
 * isNullOrUndefined(new Date());   // false
 * isNullOrUndefined(true);         // false
 * isNullOrUndefined(false);        // false
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isNullOrUndefined(value) {
    return value === NULL_VALUE || isUndefined$2(value);
}
/**
 * Checks if the provided value is null, undefined only, a string value of "undefined" is NOT considered
 * to be undefined.
 * @group Type Identity
 * @group Value Check
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * isStrictNullOrUndefined(null);         // true
 * isStrictNullOrUndefined(undefined);    // true
 * isStrictNullOrUndefined("undefined");  // false
 *
 * let value = null;
 * isStrictNullOrUndefined(value);        // true
 * let value = undefined;
 * isStrictNullOrUndefined(value);        // true
 *
 * isStrictNullOrUndefined("");           // false
 * isStrictNullOrUndefined(0);            // false
 * isStrictNullOrUndefined(new Date());   // false
 * isStrictNullOrUndefined(true);         // false
 * isStrictNullOrUndefined(false);        // false
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isStrictNullOrUndefined(value) {
    return value === NULL_VALUE || !isDefined(value);
}
/**
 * Checks if the passed value is defined, which means it has any value and is not undefined.
 * A string value of "undefined" is considered to be defined.
 * @group Value Check
 * @param arg - The value to check
 * @returns true if arg has a value (is not === undefined)
 * @example
 * ```ts
 * isDefined(null);         // false
 * isDefined(undefined);    // false
 * isDefined("undefined");  // true
 *
 * let value = null;
 * isDefined(value);        // false
 * let value = undefined;
 * isDefined(value);        // false
 *
 * isDefined("");           // true
 * isDefined(0);            // true
 * isDefined(new Date());   // true
 * isDefined(true);         // true
 * isDefined(false);        // true
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isDefined(arg) {
    return !!arg || arg !== UNDEF_VALUE;
}
/**
 * Identifies whether the provided value is a JavaScript [primitive](https://developer.mozilla.org/en-US/docs/Glossary/Primitive)
 * which is when is it not an object and has no methods or properties. There are 6 primitive data types:
 * - string
 * - number
 * - bigint
 * - boolean
 * - undefined
 * - symbol
 *
 * Most of the time, a primitive value is represented directly at the lowest level of the language implementation.
 *
 * All primitives are immutable; that is, they cannot be altered. It is important not to confuse a primitive itself
 * with a variable assigned a primitive value. The variable may be reassigned to a new value, but the existing value
 * can not be changed in the ways that objects, arrays, and functions can be altered. The language does not offer
 * utilities to mutate primitive values.
 * @since 0.9.6
 * @group Type Identity
 * @param theType - The type as a string value to be checked whther it's a primitive type, this should be the value
 * returned from `typeof value`.
 * @example
 * ```ts
 * isPrimitiveType(null);                   // false
 * isPrimitiveType(undefined);              // false
 * isPrimitiveType("null");                 // false
 * isPrimitiveType("undefined");            // false
 * isPrimitiveType("1");                    // false
 * isPrimitiveType("aa");                   // false
 * isPrimitiveType(1);                      // false
 * isPrimitiveType(Number(2));              // false
 * isPrimitiveType("");                     // false
 * isPrimitiveType(String(""));             // false
 * isPrimitiveType(true);                   // false
 * isPrimitiveType(false);                  // false
 * isPrimitiveType("true");                 // false
 * isPrimitiveType("false");                // false
 * isPrimitiveType(BigInt(42));             // false
 * isPrimitiveType(Symbol.for("Hello"));    // false
 *
 * isPrimitiveType("string");               // true
 * isPrimitiveType("number");               // true
 * isPrimitiveType("boolean");              // true
 * isPrimitiveType("undefined");            // true
 * isPrimitiveType("symbol");               // true
 * isPrimitiveType("bigint");               // true
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isPrimitiveType(theType) {
    !_primitiveTypes && (_primitiveTypes = ["string", "number", "boolean", UNDEFINED, "symbol", "bigint"]);
    return theType !== OBJECT$1 && _primitiveTypes.indexOf(theType) !== -1;
}
/**
 * Checks to see if the past value is a string value
 * @group Type Identity
 * @group String
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * isString("");            // true
 * isString("null");        // true
 * isString("undefined");   // true
 * isString(String(""));    // true
 *
 * isString(null);          // false
 * isString(undefined);     // false
 * isString(0);             // false
 * ```
 */
var isString$2 = ( /*#__PURE__*/_createIs("string"));
/**
 * Checks to see if the past value is a function value
 * @group Type Identity
 * @param value - The value to check
 * @returns
 * @example
 * ```ts
 * function myFunction() { }
 * isFunction(null);            // false
 * isFunction(undefined);       // false
 * isFunction("null");          // false
 * isFunction("undefined");     // false
 * isFunction("1");             // false
 * isFunction("aa");            // false
 * isFunction(new Date());      // false
 * isFunction(1);               // false
 * isFunction("");              // false
 * isFunction(myFunction);      // true
 * isFunction([]);              // false
 * isFunction(new Array(1));    // false
 * ```
 */
var isFunction$3 = ( /*#__PURE__*/_createIs(FUNCTION));
/**
 * Checks to see if the past value is an object value
 * @group Type Identity
 * @group Object
 * @typeParam T - The object type, defaults to any
 * @param value - The value to check
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function isObject$6(value) {
    if (!value && isNullOrUndefined(value)) {
        return false;
    }
    return !!value && typeof value === OBJECT$1;
}
/**
 * Checks if the type of value is an Array.
 *
 * @group Type Identity
 * @group Array
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Array, false otherwise.
 * @example
 * ```ts
 * import { isArray, isObject } from "@nevware21/ts-utils";
 *
 * function performAction(value: any) {
 *     if (isArray(value) || isObject(value)) {
 *         // Do something
 *     } else {
 *         // Do something else
 *     }
 * }
 * ```
 */
var isArray$3 = ArrCls.isArray;
/**
 * Check if an object is of type Date
 * @group Type Identity
 * @example
 * ```ts
 * import { isDate } from "@nevware21/ts-utils";
 *
 * let _theDate = null;
 *
 * function getSetDate(newDate?: any) {
 *     _theDate = isDate(newDate) ? newDate : new Date();
 *
 *     return _theDate;
 * }
 * ```
 */
var isDate$4 = ( /*#__PURE__*/_createObjIs("Date"));
/**
 * Checks if the type of value is a number.
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
var isNumber$3 = ( /*#__PURE__*/_createIs("number"));
/**
 * Checks if the type of value is a boolean.
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
var isBoolean$2 = ( /*#__PURE__*/_createIs("boolean"));
/**
 * Checks if the type of value is a Error object.
 * @group Type Identity
 * @group Error
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a Error, false otherwise.
 */
var isError$2 = ( /*#__PURE__*/_createObjIs("Error"));
/**
 * Checks if the type of value is a PromiseLike instance (contains a then function).
 * @group Type Identity
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a PromiseLike, false otherwise.
 */
/*#__NO_SIDE_EFFECTS__*/
function isPromiseLike(value) {
    return !!(value && value.then && isFunction$3(value.then));
}
/**
 * Checks if the type of value evaluates to true value, handling some special
 * case usages of Boolean(true/false) and new Boolean(true/false).
 * @group Value Check
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is not truthy, false otherwise.
 */
/*#__NO_SIDE_EFFECTS__*/
function isTruthy(value) {
    // Objects created with no prototype (Object.create(null)) cannot be converted to primitives
    // Which causes this code to throw, additionally just using !! also fails for Boolean objects
    // !!(new Boolean(false)) evaluates to true
    return !(!value || safeGet(function () { return !(value && (0 + value)); }, !value));
    //return !(!value || !(value && (0 + value)));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objGetOwnPropertyDescriptor() method returns an object describing the configuration of a specific property on
 * a given object (that is, one directly present on an object and not in the object's prototype chain). The object
 * returned is mutable but mutating it has no effect on the original property's configuration.
 * @since 0.4.3
 * @group Object
 * @param target - Object that contains the property.
 * @param prop - Name of the property.
 * @returns A property descriptor of the given property if it exists on the object, otherwise undefined.
 *
 * @example
 * ```ts
 * o = {};
 * objDefineProp(o, 'qux', {
 *   value: 8675309,
 *   writable: false,
 *   enumerable: false
 * });
 * d = objGetOwnPropertyDescriptor(o, 'qux');
 * // d is {
 * //   value: 8675309,
 * //   writable: false,
 * //   enumerable: false,
 * //   configurable: false
 * // }
 *
 * objGetOwnPropertyDescriptor('foo', 0);
 * // TypeError: "foo" is not an object  // ES5 code
 *
 * objGetOwnPropertyDescriptor('foo', 0);
 * // Object returned by ES2015 code: {
 * //   configurable: false,
 * //   enumerable: true,
 * //   value: "f",
 * //   writable: false
 * // }
 * ```
 * Note: In ES5, if the first argument to this method is not an object (a primitive), then it will cause a TypeError. In ES2015, a non-object first argument will be coerced to an object at first.
 */
var objGetOwnPropertyDescriptor = ObjClass$1.getOwnPropertyDescriptor;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objHasOwnProperty() method returns a boolean indicating whether the object
 * has the specified property as its own property (as opposed to inheriting it).
 *
 * The objHasOwnProperty() method returns true if the specified property is a direct
 * property of the object — even if the value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in
 * operator, this method does not check for the specified property in the object's
 * prototype chain.
 *
 * The method can be called on most JavaScript objects, because most objects descend
 * from Object, and hence inherit its methods. For example Array is an Object, so you
 * can use objHasOwnProperty() method to check whether an index exists:
 * @group Object
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * objHasOwnProperty(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * objHasOwnProperty(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * objHasOwnProperty(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * objHasOwnProperty(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function objHasOwnProperty(obj, prop) {
    return !!obj && ObjProto$1.hasOwnProperty[CALL$1](obj, prop);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The objHasOwn() method returns a boolean indicating whether the object
 * has the specified property as its own property (as opposed to inheriting it).
 * If the property is inherited, or does not exist, the method returns false.
 *
 * The objHasOwn() method returns true if the specified property is a direct property
 * of the object — even if the property value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in operator,
 * this method does not check for the specified property in the object's prototype chain.
 *
 * It is recommended over {@link objHasOwnProperty} () because it works for objects created using
 * objCreate(null) and with objects that have overridden the inherited hasOwnProperty() method.
 * While it is possible to workaround these problems by calling Object.prototype.hasOwnProperty()
 * on an external object, Object.hasOwn() is more intuitive.
 *
 * @since 0.4.3
 * @group Object
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * objHasOwn(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * objHasOwn(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * objHasOwn(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * objHasOwn(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
var objHasOwn = ObjClass$1["hasOwn"] || polyObjHasOwn;
/**
 * The polyObjHasOwn() method is a polyfill for {@link objHasOwn} when the native
 * [Object.hasOwnreturns](https://caniuse.com/?search=hasOwn) is not supported, it returns a
 * boolean indicating whether the object has the specified property as its own property (as
 * opposed to inheriting it). If the property is inherited, or does not exist, the method
 * returns false.
 *
 * The objHasOwn() method returns true if the specified property is a direct property
 * of the object — even if the property value is null or undefined. The method returns
 * false if the property is inherited, or has not been declared at all. Unlike the in operator,
 * this method does not check for the specified property in the object's prototype chain.
 *
 * It is recommended over objHasOwnProperty() because it works for objects created using
 * objCreate(null) and with objects that have overridden the inherited hasOwnProperty() method.
 * While it is possible to workaround these problems by calling Object.prototype.hasOwnProperty()
 * on an external object, Object.hasOwn() is more intuitive.
 *
 * @since 0.4.3
 * @group Object
 * @group Polyfill
 * @param obj - The object being evaluated
 * @param prop - The String or Symbol of the property to test
 * @returns `true` if the object has the specified property as own property; otherwise `false`
 * @example
 * ```ts
 * let example = {};
 * polyObjHasOwn(example, 'prop');   // false
 *
 * example.prop = 'exists';
 * polyObjHasOwn(example, 'prop');   // true - 'prop' has been defined
 *
 * example.prop = null;
 * polyObjHasOwn(example, 'prop');   // true - own property exists with value of null
 *
 * example.prop = undefined;
 * polyObjHasOwn(example, 'prop');   // true - own property exists with value of undefined
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function polyObjHasOwn(obj, prop) {
    return objHasOwnProperty(obj, prop) || !!objGetOwnPropertyDescriptor(obj, prop);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Calls the provided `callbackFn` function once for each key in an object. This is equivelent to `arrForEach(Object.keys(theObject), callbackFn)` or
 * if not using the array helper `Object.keys(theObject).forEach(callbackFn)` except that this helper avoid creating a temporary of the object
 * keys before iterating over them and like the `arrForEach` helper you CAN stop or break the iteration by returning -1 from the `callbackFn` function.
 * @group Object
 * @typeParam T - The object type
 * @param callbackfn  A function that accepts up to two arguments, the key name and the current value of the property represented by the key.
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, null or undefined
 * the object will be used as the this value.
 * @example
 * ```ts
 * function performAction<T>(target: T, source: any) {
 *    if (!isNullOrUndefined(source)) {
 *        objForEachKey(source, (key, value) => {
 *            // Set the target with a reference to the same value with the same name
 *            target[key] = value;
 *        });
 *    }
 *
 *    return target;
 * }
 * ```
 */
function objForEachKey(theObject, callbackfn, thisArg) {
    if (theObject && isObject$6(theObject)) {
        for (var prop in theObject) {
            if (objHasOwn(theObject, prop)) {
                if (callbackfn[CALL$1](theObject, prop, theObject[prop]) === -1) {
                    break;
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Internal Helper function to create a key and value mapped representation of the values
 * @param values - The source values
 * @param keyType - Identifies the value to populate against the key
 * @param valueType - Identifies the value to populate against the value
 * @param completeFn - The function to call to complete the map (used to freeze the instance)
 * @returns
 */
/*#__NO_SIDE_EFFECTS__*/
function _createKeyValueMap(values, keyType, valueType, completeFn) {
    var theMap = {};
    objForEachKey(values, function (key, value) {
        theMap[key] = keyType ? value : key;
        theMap[value] = key;
    });
    return completeFn(theMap);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Throw an error exception with the specified optional message
 * @group Error
 * @param message
 */
function throwError(message) {
    throw new Error(message);
}
/**
 * Throw a type error with the specified optional message
 * @group Error
 * @param message
 */
function throwTypeError(message) {
    throw new TypeError(message);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _objFreeze = ObjClass$1["freeze"];
function _doNothing(value) {
    return value;
}
/*#__NO_SIDE_EFFECTS__*/
function _getProto(value) {
    return value[__PROTO__] || NULL_VALUE;
}
/**
 * The `objAssign()` method copies all enumerable own properties from one or more source objects
 * to a target object. It returns the modified target object.
 *
 * Properties in the target object are overwritten by properties in the sources if they have the
 * same key. Later sources' properties overwrite earlier ones.
 *
 * The objAssign() method only copies enumerable and own properties from a source object to a
 * target object. It uses `Get` on the source and `Set` on the target, so it will invoke
 * [getters](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get) and
 * [setters](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set).
 * Therefore it assigns properties, versus copying or defining new properties. This may make it
 * unsuitable for merging new properties into a prototype if the merge sources contain getters.
 *
 * For copying property definitions (including their enumerability) into prototypes, use
 * {@link objGetOwnPropertyDescriptor} and {@link objDefineProp} instead.
 *
 * Both String and Symbol properties are copied.
 *
 * In case of an error, for example if a property is non-writable, a TypeError is raised, and
 * the target object is changed if any properties are added before the error is raised.
 * @group Object
 * @example
 * ```ts
 * const obj = { a: 1 };
 * const copy = objAssign({}, obj);
 * console.log(copy); // { a: 1 }
 *
 * const o1 = { a: 1 };
 * const o2 = { b: 2 };
 * const o3 = { c: 3 };
 *
 * const obj = objAssign(o1, o2, o3);
 * console.log(obj); // { a: 1, b: 2, c: 3 }
 * console.log(o1);  // { a: 1, b: 2, c: 3 }, target object itself is changed.
 * ```
 */
var objAssign = ObjClass$1["assign"];
/**
 * The `objKeys()` method returns an array of a given object's own enumerable property names, iterated in
 * the same order that a normal loop would.
 *
 * objKeys() returns an array whose elements are strings corresponding to the enumerable properties found
 * directly upon object. The ordering of the properties is the same as that given by looping over the
 * properties of the object manually.
 * @group Object
 * @param value - The object to obtain a copy of the keys from
 * @returns An array of the properties names for the value object.
 * @example
 * ```ts
 * // simple array
 * const arr = ['a', 'b', 'c'];
 * console.log(objKeys(arr)); // console: ['0', '1', '2']
 *
 * // array-like object
 * const obj = { 0: 'a', 1: 'b', 2: 'c' };
 * console.log(objKeys(obj)); // console: ['0', '1', '2']
 *
 * // array-like object with random key ordering
 * const anObj = { 100: 'a', 2: 'b', 7: 'c' };
 * console.log(objKeys(anObj)); // console: ['2', '7', '100']
 *
 * // getFoo is a property which isn't enumerable
 * const myObj = objCreate({}, {
 *   getFoo: {
 *     value() { return this.foo; }
 *   }
 * });
 * myObj.foo = 1;
 * console.log(objKeys(myObj)); // console: ['foo']
 * ```
 */
var objKeys = ObjClass$1.keys;
/**
 * Perform a deep freeze on the object and all of it's contained values / properties by recursively calling
 * `objFreeze()` on all enumerable properties of the object and on each property returned.
 * @group Object
 * @param value - the object to be completly frozen.
 * @returns The originally passed in object.
 */
function objDeepFreeze(value) {
    if (_objFreeze) {
        objForEachKey(value, function (key, value) {
            if (isArray$3(value) || isObject$6(value)) {
                _objFreeze(value);
            }
        });
    }
    return objFreeze(value);
}
/**
 * The `objFreeze()` method freezes an object. A frozen object can no longer be changed; freezing an object
 * prevents new properties from being added to it, existing properties from being removed, prevents changing the
 * enumerability, configurability, or writability of existing properties, and prevents the values of existing
 * properties from being changed. In addition, freezing an object also prevents its prototype from being changed.
 * `objFreeze()` returns the same object that was passed in.
 *
 * Nothing can be added to or removed from the properties set of a frozen object. Any attempt to do so will fail,
 * either silently or by throwing a TypeError exception (most commonly, but not exclusively, when in strict mode).
 *
 * For data properties of a frozen object, values cannot be changed, the writable and configurable attributes are
 * set to false. Accessor properties (getters and setters) work the same (and still give the illusion that you are
 * changing the value). Note that values that are objects can still be modified, unless they are also frozen. As
 * an object, an array can be frozen; after doing so, its elements cannot be altered and no elements can be added
 * to or removed from the array.
 *
 * `objFreeze()` returns the same object that was passed into the function. It does not create a frozen copy.
 * @group Object
 * @param value - The object to freeze.
 * @returns The object that was passed to the function.
 */
var objFreeze = _objFreeze || _doNothing;
/**
 * The objGetPrototypeOf() method returns the prototype (i.e. the value of the internal `Prototype` property)
 * of the specified value.
 * @since 0.4.4
 * @group Object
 * @param value - The object whose prototype is to be returned, which may be null.
 */
var objGetPrototypeOf = ObjClass$1["getPrototypeOf"] || _getProto;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create a TypeScript style enum class which is a mapping that maps from the key -> value and the value -> key.
 * This is effectively the same as defining a non-constant enum, but this only repeats the "Name" of the enum value once.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * }
 * const Animals = createEnum<typeof Animal>({
 *    Dog: Animal.Dog,
 *    Cat: Animal.Cat,
 *    Butterfly: Animal.Butterfly,
 *    Bear: Animal.Bear
 * });
 * // You end up with an object that maps everything to the name
 * Animals.Dog === 0;           // true
 * Animals[0] === "Dog";        // true
 * Animals["Dog"] === 0;        // true
 * Animals.Cat === 1;           // true
 * Animals[1] === "Cat";        // true
 * Animals["Cat"] === 1;        // true
 * ```

 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type being mapped
 * @returns A new frozen (immutable) object which looks and acts like a TypeScript Enum class.
 */
/*#__NO_SIDE_EFFECTS__*/
function createEnum(values) {
    return _createKeyValueMap(values, 1 /* eMapValues.Value */, 0 /* eMapValues.Key */, objDeepFreeze);
}
/**
 * Create a map object which contains both the property key and value which both map to the key,
 * E[key] => key and E[value] => key.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * }
 * const animalMap = createEnumKeyMap<typeof Animal>({
 *    Dog: Animal.Dog,
 *    Cat: Animal.Cat,
 *    Butterfly: Animal.Butterfly,
 *    Bear: Animal.Bear
 * });
 * // You end up with an object that maps everything to the name
 * animalMap.Dog === "Dog";         // true
 * animalMap[0] === "Dog";          // true
 * animalMap["Dog"] === "Dog";      // true
 * animalMap.Cat === "Cat";         // true
 * animalMap[1] === "Cat";          // true
 * animalMap["Cat"] === "Cat";      // true
 * // Helper function to always return the "Name" of the type of animal
 * function getAnimalType(type: string | number | Animal) {
 *     return animalMap[type];
 * }
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type being mapped
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the value.
 */
/*#__NO_SIDE_EFFECTS__*/
function createEnumKeyMap(values) {
    return _createKeyValueMap(values, 0 /* eMapValues.Key */, 0 /* eMapValues.Key */, objDeepFreeze);
}
/**
 * Create a map object which contains both the perperty key and value which both map to the requested
 * generic mapValue with a type of V, E[key] => mapValue and E[value] => mapValue.
 * @group Enum
 * @example
 * ```ts
 * const enum Animal {
 *    Dog = 0,
 *    Cat = 1,
 *    Butterfly = 2,
 *    Bear = 3
 * };
 * // Creates a simple mapping to a string value
 * const animalFamilyMap = createValueMap<typeof Animal, string>({
 *    Dog: [ Animal.Dog, "Canidae"],
 *    Cat: [ Animal.Cat, "Felidae"],
 *    Butterfly: [ Animal.Butterfly, "Papilionidae"],
 *    Bear: [ Animal.Bear, "Ursidae"]
 * });
 * // You end up with an object that maps everything to the name
 * animalMap.Dog === "Canidae";     // true with typeof animalMap.Dog is "string"
 * animalMap[0] === "Canidae";      // true with typeof animalMap[0] is "string"
 * animalMap["Dog"] === "Canidae";  // true with typeof animalMap["Dog"] is "string"
 * animalMap.Cat === "Felidae";     // true with typeof animalMap.Cat is "string"
 * animalMap[1] === "Felidae";      // true with typeof animalMap[1] is "string"
 * animalMap["Cat"] === "Felidae";  // true with typeof animalMap["Cat"] is "string"
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the const enum type (eg. typeof Animal);
 * @typeParam V - Identifies the type of the mapping `string`; `number`; etc is not restructed to primitive types.
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the defiend mapped value.
 */
/*#__NO_SIDE_EFFECTS__*/
function createSimpleMap(values) {
    var mapClass = {};
    objForEachKey(values, function (key, value) {
        mapClass[key] = value[1];
        mapClass[value[0]] = value[1];
    });
    return objDeepFreeze(mapClass);
}
/**
 * Create a strongly types map object which contains both the perperty key and value which both map
 * to the requested mapValue,
 * E[key] => mapValue and E[value] => mapValue.
 * - E = the const enum type (typeof Animal);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @group Enum
 * @example
 * ```ts
 * // Create a strongly types map
 * const animalFamilyMap = createTypeMap<typeof Animal, {
 *     // Defined the enum lookups
 *     [Animal.Dog]: "Canidae",
 *     [Animal.Cat]: "Felidae",
 *     [Animal.Butterfly]: "Papilionidae",
 *     [Animal.Bear]: "Ursidae",
 *     // Defined Named reference
 *     Dog: "Canidae",
 *     Cat: "Felidae",
 *     Butterfly: "Papilionidae",
 *     Bear: "Ursidae",
 * }>({
 *     Dog: [ Animal.Dog, "Canidae"],
 *     Cat: [ Animal.Cat, "Felidae"],
 *     Butterfly: [ Animal.Butterfly, "Papilionidae"],
 *     Bear: [ Animal.Bear, "Ursidae"]
 * });
 * // You end up with a strongly types result for each value
 * animalMap.Dog === "Canidae";     // true with typeof animalMap.Dog is (const) "Canidae"
 * animalMap[0] === "Canidae";      // true with typeof animalMap[0] is "Canidae"
 * animalMap["Dog"] === "Canidae";  // true with typeof animalMap["Dog"] is "Canidae"
 * animalMap.Cat === "Felidae";     // true with typeof animalMap.Cat is "Felidae"
 * animalMap[1] === "Felidae";      // true with typeof animalMap[1] is "Felidae"
 * animalMap["Cat"] === "Felidae";  // true with typeof animalMap["Cat"] is "Felidae"
 *
 * or using an interface to define the direct string mappings
 *
 * interface IAnimalFamilyMap {
 *     Dog: "Canidae",
 *     Cat: "Felidae",
 *     Butterfly: "Papilionidae",
 *     Bear: "Ursidae"
 * }
 *
 * // Create a strongly types map
 * const animalFamilyMap = createTypeMap<typeof Animal, IAnimalFamilyMap & {
 *     // Defined the enum lookups
 *     [Animal.Dog]: "Canidae",
 *     [Animal.Cat]: "Felidae",
 *     [Animal.Butterfly]: "Papilionidae",
 *     [Animal.Bear]: "Ursidae"
 * }>({
 *     Dog: [ Animal.Dog, "Canidae"],
 *     Cat: [ Animal.Cat, "Felidae"],
 *     Butterfly: [ Animal.Butterfly, "Papilionidae"],
 *     Bear: [ Animal.Bear, "Ursidae"]
 * });
 *
 * // You also end up with a strongly types result for each value
 * animalMap.Dog === "Canidae";     // true with typeof animalMap.Dog is (const) "Canidae"
 * animalMap[0] === "Canidae";      // true with typeof animalMap[0] is "Canidae"
 * animalMap["Dog"] === "Canidae";  // true with typeof animalMap["Dog"] is "Canidae"
 * animalMap.Cat === "Felidae";     // true with typeof animalMap.Cat is "Felidae"
 * animalMap[1] === "Felidae";      // true with typeof animalMap[1] is "Felidae"
 * animalMap["Cat"] === "Felidae";  // true with typeof animalMap["Cat"] is "Felidae"
 * ```
 * @param values - The values to populate on the new object
 * @typeParam E - Identifies the enum type
 * @typeParam T - Identifies the return type that is being created via the mapping.
 * @returns A new frozen (immutable) object which contains a property for each key and value that returns the defined mapped value.
 */
/*#__NO_SIDE_EFFECTS__*/
function createTypeMap(values) {
    return createSimpleMap(values);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore
 * @internal
 */
var _wellKnownSymbolMap = /*#__PURE__*/ createEnumKeyMap({
    asyncIterator: 0 /* WellKnownSymbols.asyncIterator */,
    hasInstance: 1 /* WellKnownSymbols.hasInstance */,
    isConcatSpreadable: 2 /* WellKnownSymbols.isConcatSpreadable */,
    iterator: 3 /* WellKnownSymbols.iterator */,
    match: 4 /* WellKnownSymbols.match */,
    matchAll: 5 /* WellKnownSymbols.matchAll */,
    replace: 6 /* WellKnownSymbols.replace */,
    search: 7 /* WellKnownSymbols.search */,
    species: 8 /* WellKnownSymbols.species */,
    split: 9 /* WellKnownSymbols.split */,
    toPrimitive: 10 /* WellKnownSymbols.toPrimitive */,
    toStringTag: 11 /* WellKnownSymbols.toStringTag */,
    unscopables: 12 /* WellKnownSymbols.unscopables */
});

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The asString() method returns a string representing the value by
 * explicitly using `String(`value`)`.
 *
 * @since 0.4.3
 * @group String
 * @group Conversion
 * @group Value
 * @param value - The value to get a string representation of
 * @example
 * ```ts
 * const arr = [ 1, 2, 3];
 * asString(arr);       // "1,2,3"
 * asString(null);      // "null"
 * asString(undefined); // "undefined"
 * asString(42);        // "42"
 * asString(Symbol.for("Hello"));   // "Symbol(Hello)"
 * ```
 */
var asString = StrCls;

var GLOBAL_CONFIG_KEY = "__tsUtils$gblCfg";
var _globalCfg;
// @__NO_SIDE_EFFECTS__
function _getGlobalValue() {
  var result;
  if (typeof globalThis !== UNDEFINED) {
    result = globalThis;
  }
  if (!result && typeof self !== UNDEFINED) {
    result = self;
  }
  if (!result && typeof window !== UNDEFINED) {
    result = window;
  }
  if (!result && typeof window !== UNDEFINED) {
    result = window;
  }
  return result;
}
// @__NO_SIDE_EFFECTS__
function _getGlobalConfig() {
  if (!_globalCfg) {
    var gbl = safe(_getGlobalValue).v || {};
    _globalCfg = gbl[GLOBAL_CONFIG_KEY] = gbl[GLOBAL_CONFIG_KEY] || {};
  }
  return _globalCfg;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var ERROR_TYPE = "[object Error]";
/**
 * Returns string representation of an object suitable for diagnostics logging.
 * @group Error
 * @group Diagnostic
 * @param object - The object to be converted to a diagnostic string value
 * @param format - Identifies whether the JSON value should be formated
 * - `true` - Format with 4 spaces
 * - 'number' - The number of spaces to format with
 * - `false` (or not Truthy) - Do not format
 * @returns A string representation of the object suitable for diagnostics logging
 * @example
 * ```ts
 * let obj = { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } };
 *
 * let objStr = dumpObj(obj);
 * // objStr === "[object Object]: { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } }"
 *
 * let objStrFmt = dumpObj(obj, true);
 * // objStrFmt === "[object Object]: {\n    a: 1,\n    b: "Hello",\n    c: {\n        d: 2,\n        e: "Darkness"\n    }\n}"
 *
 * let objStrFmt2 = dumpObj(obj, 2);
 * // objStrFmt2 === "[object Object]: {\n  a: 1,\n  b: "Hello",\n  c: {\n    d: 2,\n    e: "Darkness"\n  }\n}"
 *
 * let objStrFmt3 = dumpObj(obj, 0);
 * // objStrFmt3 === "[object Object]: { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } }"
 *
 * let objStrFmt4 = dumpObj(obj, false);
 * // objStrFmt4 === "[object Object]: { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } }"
 *
 * let objStrFmt5 = dumpObj(obj, null);
 * // objStrFmt5 === "[object Object]: { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } }"
 *
 * let objStrFmt6 = dumpObj(obj, undefined);
 * // objStrFmt6 === "[object Object]: { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } }"
 *
 * let objStrFmt7 = dumpObj(obj, "");
 * // objStrFmt7 === "[object Object]: { a: 1, b: "Hello", c: { d: 2, e: "Darkness" } }"
 *
 * let err = new Error("Hello Darkness");
 * let errStr = dumpObj(err);
 * // errStr === "[object Error]: { stack: 'Error: Hello Darkness\n    at <anonymous>:1:13', message: 'Hello Darkness', name: 'Error'"
 *
 * let errStrFmt = dumpObj(err, true);
 * // errStrFmt === "[object Error]: {\n    stack: "Error: Hello Darkness\n    at <anonymous>:1:13",\n    message: "Hello Darkness",\n    name: "Error"\n}"
 *
 * let errStrFmt2 = dumpObj(err, 2);
 * // errStrFmt2 === "[object Error]: {\n  stack: "Error: Hello Darkness\n    at <anonymous>:1:13",\n  message: "Hello Darkness",\n  name: "Error"\n}"
 *
 * let errStrFmt3 = dumpObj(err, 0);
 * // errStrFmt3 === "[object Error]: { stack: "Error: Hello Darkness\n    at <anonymous>:1:13", message: "Hello Darkness", name: "Error" }"
 *
 * ```
 * @see {@link dumpObj}
 */
/*#__NO_SIDE_EFFECTS__*/
function dumpObj(object, format) {
    var propertyValueDump = EMPTY$1;
    var objType = ObjProto$1[TO_STRING][CALL$1](object);
    if (objType === ERROR_TYPE) {
        object = { stack: asString(object.stack), message: asString(object.message), name: asString(object.name) };
    }
    try {
        propertyValueDump = JSON.stringify(object, NULL_VALUE, format ? ((typeof format === "number") ? format : 4) : UNDEF_VALUE);
        propertyValueDump = (propertyValueDump && propertyValueDump.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ")) || asString(object);
    }
    catch (e) {
        // Unable to convert object (probably circular)
        propertyValueDump = " - " + dumpObj(e, format);
    }
    return objType + ": " + propertyValueDump;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Internal helper to convert an expanded function back into an instance `this` function call
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @param clsProto - The Class or class prototype to fallback to if the instance doesn't have the function.
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
var _unwrapFunction = /*__PURE__*/ _unwrapFunctionWithPoly;
/**
 * @internal
 * @ignore
 * Internal helper to convert an expanded function back into an instance `this` function call
 * @param funcName - The function name to call on the first argument passed to the wrapped function
 * @param clsProto - The Class or class prototype to fallback to if the instance doesn't have the function.
 * @param polyFunc - The function to call if not available on the thisArg, act like the polyfill
 * @returns A function which will call the funcName against the first passed argument and pass on the remaining arguments
 */
/*#__NO_SIDE_EFFECTS__*/
function _unwrapFunctionWithPoly(funcName, clsProto, polyFunc) {
    var clsFn = clsProto && clsProto[funcName];
    return function (thisArg) {
        var theFunc = (thisArg && thisArg[funcName]) || clsFn;
        if (theFunc || polyFunc) {
            var theArgs = arguments;
            return (theFunc || polyFunc).apply(thisArg, theFunc ? ArrSlice[CALL$1](theArgs, 1) : theArgs);
        }
        throwTypeError("\"" + asString(funcName) + "\" not defined for " + dumpObj(thisArg));
    };
}
/**
 * @internal
 * @ignore
 * Internal helper to lookup and return the named property from the first argument (which becomes the this)
 *
 * @since 0.4.2
 * @typeParam T - The type of the object which contains the propName
 * @param propName - The property name
 * @returns The value of the property
 */
/*#__NO_SIDE_EFFECTS__*/
function _unwrapProp(propName) {
    return function (thisArg) {
        return thisArg[propName];
    };
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `mathMax()` function returns the largest of the zero or more numbers given as input
 * parameters, or NaN if any parameter isn't a number and can't be converted into one.
 *
 * If no arguments are given, the result is -Infinity.
 *
 * If at least one of arguments cannot be converted to a number, the result is NaN.
 *
 * @since 0.4.2
 * @group Math
 * @param values - Zero or more numbers among which the largest value will be selected and returned.
 * @returns The largest of the given numbers. If any one or more of the parameters cannot be
 * converted into a number, NaN is returned. The result is -Infinity if no parameters are provided.
 * @example
 * ```ts
 * mathMax(10, 20);   //  20
 * mathMax(-10, -20); // -10
 * mathMax(-10, 20);  //  20
 * ```
 */
var mathMax = MathCls.max;

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strSlice()` method extracts a section of a string and returns it as a new string, without
 * modifying the original string.
 * `strSlice()` extracts the text from one string and returns a new string. Changes to the text in one
 * string do not affect the other string.
 * `strSlice()` extracts up to but not including endIndex. str.slice(1, 4) extracts the second character
 * through the fourth character (characters indexed 1, 2, and 3).
 * As an example, strSlice(2, -1) extracts the third character through the second to last character
 * in the string.
 * @group String
 * @param value - The value to haveextract a number
 * @param beginIndex - The zero-based index at which to begin extraction.
 * If `beginIndex` is negative, `strSlice()` begins extraction from `value.length + beginIndex`.
 * (E.g. `strSlice("test", -2)` returns "st")
 * If `beginIndex` is omitted, undefined, or cannot be converted to a number (using Number(`beginIndex`)),
 * strSlice() begins extraction from the beginning of the string. (E.g. `strSlice("test")` returns "test")
 * If `beginIndex` is greater than or equal to `value.length`, an empty string is returned.
 * (E.g. `strSlice("test", 4)` returns "")
 * @param endIndex - The index of the first character to exclude from the returned substring.
 * If `endIndex` is omitted, undefined, or cannot be converted to a number (using Number(`endIndex`))
 * strSlice() extracts to the end of the string. (E.g. `strSlice("test", 2)` returns "st")
 * If `endIndex` is greater than `value.length`, strSlice() also extracts to the end of the string.
 * (E.g. strSlice("test", 2, 10)` returns "st")
 * If `endIndex` is negative, `strSlice()` treats it as `value.length + endIndex`. (E.g, if `endIndex`
 * is -2, it is treated as `value.length - 2` and `strSlice("test", 1, -2)` returns "e") .
 * If `endIndex` represents a position that is before the one represented by startIndex, `strSlice()`
 * returns "". (E.g `strSlice("test", 2, -10)`, strSlice("test", -1, -2)` or `strSlice("test", 3, 2)`).
 * @returns A new string containing the extracted section of the string.
 */
var strSlice = ( /*#__PURE__*/_unwrapFunction("slice", StrProto));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strSubstring()` method returns the part of the string between the start and end indexes, or to the end of the string.
 *
 * `strSubstring()` extracts characters from indexStart up to but not including indexEnd. In particular:
 * - If `indexEnd` is omitted, strSubstring() extracts characters to the end of the string.
 * - If `indexStart` is equal to indexEnd, strSubstring() returns an empty string.
 * - If `indexStart` is greater than indexEnd, then the effect of strSubstring() is as if the two arguments were swapped; see example below.
 *
 * Any argument value that is less than 0 or greater than `value.length` is treated as if it were 0 and `value.length`, respectively.
 *
 * Any argument value that is NaN is treated as if it were 0.
 * @group String
 * @param value - The string value to return the substring from.
 * @param indexStart - The index of the first character to include in the returned substring.
 * @param indexEnd - The index of the first character to exclude from the returned substring.
 * @return A new string containing the specified part of the given string
 * @example
 * ```ts
 * const anyString = 'Nevware21';
 * // Displays 'N'
 * console.log(strSubstring(anyString, 0, 1));
 * console.log(strSubstring(anyString, 1, 0));
 *
 * // Displays 'Nevwar'
 * console.log(strSubstring(anyString, 0, 6));
 *
 * // Displays 'are21'
 * console.log(strSubstring(anyString, 4));
 *
 * // Displays 'are'
 * console.log(strSubstring(anyString, 4, 7));
 *
 * // Displays '21'
 * console.log(strSubstring(anyString, 7, 4));
 *
 * // Displays 'Nevware'
 * console.log(strSubstring(anyString, 0, 7));
 *
 * // Displays 'Nevware21'
 * console.log(strSubstring(anyString, 0, 10));
 * ```
 */
var strSubstring = ( /*#__PURE__*/_unwrapFunction("substring", StrProto));
/**
 * The strSubstr() method returns a portion of the string, starting at the specified index and extending for a given
 * number of characters afterwards.
 *
 * @since 0.4.2
 * @group String
 * @param value - The string value to return the substring from.
 * @param start - The index of the first character to include in the returned substring.
 * @param length - The number of characters to extract.
 * @returns A new string containing the specified part of the given string.
 */
var strSubstr = ( /*#__PURE__*/_unwrapFunctionWithPoly("substr", StrProto, polyStrSubstr));
/**
 * The polyStrSubstr() method returns a portion of the string, starting at the specified index and extending for a given
 * number of characters afterwards.
 *
 * @since 0.4.2
 * @group String
 * @group Polyfill
 * @param value - The string value to return the substring from.
 * @param start - The index of the first character to include in the returned substring.
 * @param length - The number of characters to extract.
 * @returns A new string containing the specified part of the given string.
 */
/*#__NO_SIDE_EFFECTS__*/
function polyStrSubstr(value, start, length) {
    if (isNullOrUndefined(value)) {
        throwTypeError("'polyStrSubstr called with invalid " + dumpObj(value));
    }
    if (length < 0) {
        return EMPTY$1;
    }
    // If start is omitted or undefined, its treated as zero
    start = start || 0;
    if (start < 0) {
        start = mathMax(start + value[LENGTH], 0);
    }
    if (isUndefined$2(length)) {
        return strSlice(value, start);
    }
    return strSlice(value, start, start + length);
}
/**
 * Returns a substring of the string starting from the left.
 *
 * `strLeft()` extracts the number of characters from left of the string up to the count. In particular:
 * - If `count` is less than zero, strLeft() returns an empty string.
 * - If `count` is less than `value.length', strLeft() returns a new string with the `count` number of characters from the left of the string.
 * - If `count` is greater than `value.length`, then the value original value is returned.
 *
 * Any argument value that is NaN is treated as if it were 0.
 *
 * @since 0.4.2
 * @group String
 * @param value - The string value to return the substring from.
 * @param count - The number of characters to extract
 * @returns The substring based on the count number of characters from the right
 * @example
 * ```ts
 * strLeft("Nevware21", -1); // ""
 * strLeft("Nevware21", 0); // ""
 * strLeft("Nevware21", 1); // "N"
 * strLeft("Nevware21", 3); // "Nev"
 * strLeft("Nevware21", 21); // "Nevware21"
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function strLeft(value, count) {
    return strSubstring(value, 0, count);
}

var UNIQUE_REGISTRY_ID = "_urid";
var _polySymbols;
// @__NO_SIDE_EFFECTS__
function _globalSymbolRegistry() {
  if (!_polySymbols) {
    var gblCfg = _getGlobalConfig();
    _polySymbols = gblCfg.gblSym = gblCfg.gblSym || { k: {}, s: {} };
  }
  return _polySymbols;
}
var _wellKnownSymbolCache;
// @__NO_SIDE_EFFECTS__
function polyNewSymbol(description) {
  var theSymbol = {
    description: asString(description),
    toString: function() {
      return SYMBOL + "(" + description + ")";
    }
  };
  theSymbol[POLYFILL_TAG] = true;
  return theSymbol;
}
// @__NO_SIDE_EFFECTS__
function polySymbolFor(key) {
  var registry = /* @__PURE__ */ _globalSymbolRegistry();
  if (!objHasOwn(registry.k, key)) {
    var newSymbol_1 = /* @__PURE__ */ polyNewSymbol(key);
    var regId_1 = objKeys(registry.s).length;
    newSymbol_1[UNIQUE_REGISTRY_ID] = function() {
      return regId_1 + "_" + newSymbol_1[TO_STRING]();
    };
    registry.k[key] = newSymbol_1;
    registry.s[newSymbol_1[UNIQUE_REGISTRY_ID]()] = asString(key);
  }
  return registry.k[key];
}
// @__NO_SIDE_EFFECTS__
function polyGetKnownSymbol(name) {
  !_wellKnownSymbolCache && (_wellKnownSymbolCache = {});
  var result;
  var knownName = _wellKnownSymbolMap[name];
  if (knownName) {
    result = _wellKnownSymbolCache[knownName] = _wellKnownSymbolCache[knownName] || /* @__PURE__ */ polyNewSymbol(SYMBOL + "." + knownName);
  }
  return result;
}

var propMap = {
  e: "enumerable",
  c: "configurable",
  v: "value",
  w: "writable",
  g: "get",
  s: "set"
};
// @__NO_SIDE_EFFECTS__
function _createProp(value) {
  var prop = {};
  prop[propMap["c"]] = true;
  prop[propMap["e"]] = true;
  if (value.l) {
    prop.get = function() {
      return value.l.v;
    };
    var desc = objGetOwnPropertyDescriptor(value.l, "v");
    if (desc && desc.set) {
      prop.set = function(newValue) {
        value.l.v = newValue;
      };
    }
  }
  objForEachKey(value, function(key, value2) {
    prop[propMap[key]] = isUndefined$2(value2) ? prop[propMap[key]] : value2;
  });
  return prop;
}
var objDefineProp = ObjClass$1["defineProperty"];
function objDefineAccessors(target, prop, getProp, setProp, configurable, enumerable) {
  var desc = {
    e: enumerable,
    c: configurable
  };
  {
    desc.g = getProp;
  }
  return objDefineProp(target, prop, /* @__PURE__ */ _createProp(desc));
}
function objDefine(target, key, propDesc) {
  return objDefineProp(target, key, /* @__PURE__ */ _createProp(propDesc));
}

var _globalLazyTestHooks;
function _initTestHooks() {
  _globalLazyTestHooks = _getGlobalConfig();
}
// @__NO_SIDE_EFFECTS__
function getLazy(cb) {
  var lazyValue = {};
  !_globalLazyTestHooks && _initTestHooks();
  lazyValue.b = _globalLazyTestHooks.lzy;
  objDefineProp(lazyValue, "v", {
    configurable: true,
    get: function() {
      var result = cb();
      if (!_globalLazyTestHooks.lzy) {
        objDefineProp(lazyValue, "v", {
          value: result
        });
      }
      lazyValue.b = _globalLazyTestHooks.lzy;
      return result;
    }
  });
  return lazyValue;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create and return an readonly {@link ILazyValue} instance which will cache and return the value returned
 * by the callback function. The callback function will only be called once, multiple access of the value
 * does not cause re-execution of the callback as the result from the first call is cached internally.
 * If the callback throws the default value will be returned.
 * @since 0.9.5
 * @group Lazy
 * @group Safe
 * @param cb - The callback function to fetch the value to be lazily evaluated and cached
 * @param defValue - The default value to return when an exception is thrown
 * @returns A new readonly {@link ILazyValue} instance which wraps the callback and will be used to cache
 * the result of the callback
 * @example
 * ```ts
 * // This does not cause the evaluation to occur
 * let cachedValue = safeGetLazy(() => callSomeExpensiveFunctionWhichMightThrow(), "someDefaultValue");
 * let theValue;
 *
 * // Just checking if there is an object still does not cause the evaluation
 * if (cachedValue) {
 *     // This will cause the evaluation to occur and the result will be cached
 *     theValue = cachedValue.v;
 * }
 *
 * // Accessing the value again will not cause the re-evaluation to occur, it will just return the same
 * // result value again.
 * theValue === cachedValue.v;  // true
 *
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function safeGetLazy(cb, defValue) {
    return getLazy(function () {
        var result = safe(cb);
        return result.e ? defValue : result.v;
    });
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2024 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Create and return a readonly {@link ICachedValue} instance that is populated with the provided value.
 * This is useful when you want to cache a previously fetched value and return it without having to re-fetch
 * it again.
 * This is a lightweight version of {@link getLazy} which does not support any expiration or invalidation,
 * it also will not honor the {@link setBypassLazyCache} setting and will always return the provided value.
 * @since 0.10.5
 * @group Helpers
 * @group Cache
 * @typeparam T - The type of the value to be cached
 * @param value
 * @returns A new {@link ICachedValue} instance which wraps the provided value
 * @example
 * ```ts
 * let cachedValue = createCachedValue("some value");
 * // cachedValue.v === "some value"
 *
 * JSON.stringify(cachedValue) === '{"v":"some value"}';
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function createCachedValue(value) {
    return objDefineProp({
        toJSON: function () { return value; }
    }, "v", { value: value });
}

var WINDOW = "window";
var _cachedGlobal;
function _getGlobalInstFn(getFn, theArgs) {
  var cachedValue;
  return function() {
    !_globalLazyTestHooks && _initTestHooks();
    (!cachedValue || _globalLazyTestHooks.lzy) && (cachedValue = createCachedValue(safe(getFn, theArgs).v));
    return cachedValue.v;
  };
}
// @__NO_SIDE_EFFECTS__
function lazySafeGetInst(name) {
  return getLazy(function() {
    return safe(getInst, [name]).v || UNDEF_VALUE;
  });
}
// @__NO_SIDE_EFFECTS__
function getGlobal(useCached) {
  !_globalLazyTestHooks && _initTestHooks();
  (!_cachedGlobal || useCached === false || _globalLazyTestHooks.lzy) && (_cachedGlobal = createCachedValue(safe(_getGlobalValue).v || NULL_VALUE));
  return _cachedGlobal.v;
}
// @__NO_SIDE_EFFECTS__
function getInst(name, useCached) {
  var gbl = !_cachedGlobal || useCached === false ? /* @__PURE__ */ getGlobal(useCached) : _cachedGlobal.v;
  if (gbl && gbl[name]) {
    return gbl[name];
  }
  if (name === WINDOW) {
    return getWindow();
  }
  return NULL_VALUE;
}
// @__NO_SIDE_EFFECTS__
function hasDocument() {
  return !!getDocument();
}
var getDocument = /* @__PURE__ */ _getGlobalInstFn(getInst, ["document"]);
// @__NO_SIDE_EFFECTS__
function hasWindow() {
  return !!getWindow();
}
var getWindow = /* @__PURE__ */ _getGlobalInstFn(getInst, [WINDOW]);
// @__NO_SIDE_EFFECTS__
function hasNavigator() {
  return !!getNavigator();
}
var getNavigator = /* @__PURE__ */ _getGlobalInstFn(getInst, ["navigator"]);
// @__NO_SIDE_EFFECTS__
function hasHistory() {
  return !!getHistory();
}
var getHistory = /* @__PURE__ */ _getGlobalInstFn(getInst, ["history"]);
var isNode = /* @__PURE__ */ _getGlobalInstFn(function() {
  return !!safe(function() {
    return process && (process.versions || {}).node;
  }).v;
});
var isWebWorker = /* @__PURE__ */ _getGlobalInstFn(function() {
  return !!safe(function() {
    return self && self instanceof WorkerGlobalScope;
  }).v;
});

var _symbol;
var _symbolFor;
function _initSymbol() {
  if (!_symbol || !_symbol.b) {
    _symbol = lazySafeGetInst(SYMBOL);
    _symbolFor = safeGetLazy(function() {
      return _symbol.v ? _symbol.v["for"] : UNDEF_VALUE;
    }, UNDEF_VALUE);
  }
}
// @__NO_SIDE_EFFECTS__
function hasSymbol$1() {
  return !!/* @__PURE__ */ getSymbol();
}
// @__NO_SIDE_EFFECTS__
function getSymbol() {
  !_globalLazyTestHooks && _initTestHooks();
  (!_symbol || _globalLazyTestHooks.lzy) && _initSymbol();
  return _symbol.v;
}
// @__NO_SIDE_EFFECTS__
function getKnownSymbol(name, noPoly) {
  var knownName = _wellKnownSymbolMap[name];
  !_globalLazyTestHooks && _initTestHooks();
  (!_symbol || _globalLazyTestHooks.lzy) && _initSymbol();
  return _symbol.v ? _symbol.v[knownName || name] : !noPoly ? polyGetKnownSymbol(name) : UNDEF_VALUE;
}
// @__NO_SIDE_EFFECTS__
function newSymbol(description, noPoly) {
  !_globalLazyTestHooks && _initTestHooks();
  (!_symbol || _globalLazyTestHooks.lzy) && _initSymbol();
  return _symbol.v ? _symbol.v(description) : polyNewSymbol(description) ;
}
// @__NO_SIDE_EFFECTS__
function symbolFor(key) {
  !_globalLazyTestHooks && _initTestHooks();
  (!_symbolFor || !_symbol || _globalLazyTestHooks.lzy) && _initSymbol();
  return (_symbolFor.v || polySymbolFor)(key);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Checks if the type of value looks like an iterator instance (contains a next function).
 *
 * @since 0.4.0
 * @group Type Identity
 * @group Iterator
 * @typeParam T - Identifies the return type of the iterator defaults to any
 * @param value - The value to be checked
 * @returns {boolean} True if the value is an Iterator, otherwise false
 * @example
 * ```ts
 * isIterator(null);        // false
 * isIterator(undefined);   // false
 * isIterator("null");      // false (Strings are iterable but not iterators)
 * isIterator([]);          // false (Arrays are iterable but not iterators)
 * isIterator({
 *     next: function() { return true }
 * });                      // true, iterators must contain a "next" function
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isIterator(value) {
    return !!value && isFunction$3(value.next);
}
/**
 * Checks if the value looks like it is iterable, contains a [symbol.iterator].
 *
 * @since 0.4.0
 * @group Type Identity
 * @group Iterator
 * @typeParam T - Identifies the return type of the iterator
 * @param value - The value to be checked
 * @returns {boolean} True if the value is an Iterable, otherwise false
 * @example
 * ```ts
 * isIterable(null);        // false
 * isIterable(undefined);   // false
 * isIterable("null");      // true (Strings are iterable)
 * isIterable([]);          // true (Arrays are iterable)
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function isIterable(value) {
    return !isStrictNullOrUndefined(value) && isFunction$3(value[getKnownSymbol(3 /* WellKnownSymbols.iterator */)]);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _iterSymbol;
/**
 * Calls the provided `callbackFn` function once for each element in the iterator or iterator returned by
 * the iterable and processed in the same order as returned by the iterator. As with the {@link arrForEach}
 * you CAN stop / break the iteration by returning -1 from the`callbackFn` function.
 *
 * The order of processing is not reset if you add or remove elements to the iterator, the actual behavior
 * will depend on the iterator imeplementation.
 *
 * If the passed `iter` is both an Iterable<T> and Iterator<T> the Iterator<T> interface takes preceedence.
 * @remarks
 * If Symbols are NOT supported then the iterable MUST be using the same polyFill for the well know symbols,
 * if you are targetting a mixed environment you SHOULD either
 * - only use the polyfill Symbol's provided by this library
 * - ensure that you add any symbol polyfills BEFORE these utilities
 * iterForOf expects a `synchronous` function.
 * iterForOf does not wait for promises. Make sure you are aware of the implications while using
 * promises (or async functions) as forEach callback.
 *
 * @since 0.4.2
 * @group Iterator
 * @typeParam T - Identifies the element type of the iterator
 * @param callbackfn A `synchronous` function that accepts up to three arguments. iterForOf calls the
 * callbackfn function one time for each element returned by the iterator.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is
 * omitted, null or undefined the iterator will be used as the this value.
 * @throws Any exception thrown while processing the iterator
 * @example
 * ```ts
 * const items = {
 *     'item1': 'value1',
 *     'item2': 'value2',
 *     'item3': 'value3
 * };
 * const copyItems = [];
 *
 * iterForOf(items, (item) => {
 *   copyItems.push(item);
 *   // May return -1 to abort the iteration
 * });
 * ```
 */
function iterForOf(iter, callbackfn, thisArg) {
    if (iter) {
        if (!isIterator(iter)) {
            !_iterSymbol && (_iterSymbol = createCachedValue(getKnownSymbol(3 /* WellKnownSymbols.iterator */)));
            iter = iter[_iterSymbol.v] ? iter[_iterSymbol.v]() : null;
        }
        if (isIterator(iter)) {
            var err = undefined;
            var iterResult = undefined;
            try {
                var count = 0;
                while (!(iterResult = iter.next()).done) {
                    if (callbackfn[CALL$1](thisArg || iter, iterResult.value, count, iter) === -1) {
                        break;
                    }
                    count++;
                }
            }
            catch (failed) {
                err = { e: failed };
                if (iter.throw) {
                    iterResult = null;
                    iter.throw(err);
                }
            }
            finally {
                try {
                    if (iterResult && !iterResult.done) {
                        iter.return && iter.return(iterResult);
                    }
                }
                finally {
                    if (err) {
                        // eslint-disable-next-line no-unsafe-finally
                        throw err.e;
                    }
                }
            }
        }
    }
}

function fnApply(fn, thisArg, argArray) {
  return fn.apply(thisArg, argArray);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Appends the `elms` to the `target` where the elms may be an array, a single object
 * or an iterator object
 * @group Array
 * @group Iterator
 * @example
 * ```ts
 * let theArray = arrAppend([], 1);
 * arrAppend(theArray, [ 2, 3, 4 ]);
 * arrAppend(theArray, [ "a", "b", "c" ]);
 * // theArray is now [ 1, 2, 3, 4, "a", "b", "c" ]
 * ```
 * @param target - The target array
 * @param elms - The item, array of items an iterable or iterator object of items to add to the target
 * @returns The passed in target array
 * @example
 * ```ts
 * // Adding a single value
 * arrAppend([], undefined);            // []
 * arrAppend([], 0);                    // [ 0 ]
 * arrAppend([1], undefined);           // [ 1 ]
 * arrAppend([1], 2);                   // [ 1, 2 ]
 *
 * // Adding an array
 * arrAppend([], [] as number[]);       // []
 * arrAppend([], [0]);                  // [ 0 ]
 * arrAppend([1], []);                  // [ 1 ]
 * arrAppend([1], [2]);                 // [ 1, 2 ]
 *
 * // Adding with an iterator
 * arrAppend([], ([] as number[]).values());    // []
 * arrAppend([], [0].values());         // [ 0 ]
 * arrAppend([1], [].keys());           // [ 1 ]
 * arrAppend([1], [2].values());        // [ 1, 2 ]
 * arrAppend([1], [2].keys());          // [ 1, 0 ] - 0 is from the index from the first element
 * ```
 */
function arrAppend(target, elms) {
    if (!isUndefined$2(elms) && target) {
        if (isArray$3(elms)) {
            // This is not just "target.push(elms)" but becomes effectively "target.push(elms[0], elms[1], ...)"
            fnApply(target.push, target, elms);
        }
        else if (isIterator(elms) || isIterable(elms)) {
            iterForOf(elms, function (elm) {
                target.push(elm);
            });
        }
        else {
            target.push(elms);
        }
    }
    return target;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Calls the provided `callbackFn` function once for each element in an array in ascending index order. It is not invoked for index properties
 * that have been deleted or are uninitialized. And unlike the ES6 forEach() you CAN stop or break the iteration by returning -1 from the
 * `callbackFn` function.
 *
 * The range (number of elements) processed by arrForEach() is set before the first call to the `callbackFn`. Any elements added beyond the range
 * or elements which as assigned to indexes already processed will not be visited by the `callbackFn`.
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the element type of the array
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackfn A `synchronous` function that accepts up to three arguments. arrForEach calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, null or undefined
 * the array will be used as the this value.
 * @remarks
 * arrForEach expects a `synchronous` function.
 * arrForEach does not wait for promises. Make sure you are aware of the implications while using promises (or async functions) as forEach callback.
 * @example
 * ```ts
 * const items = ['item1', 'item2', 'item3'];
 * const copyItems = [];
 *
 * // before using for loop
 * for (let i = 0; i < items.length; i++) {
 *   copyItems.push(items[i]);
 * }
 *
 * // before using forEach()
 * items.forEach((item) => {
 *   copyItems.push(item);
 * });
 *
 * // after
 * arrForEach(items, (item) => {
 *   copyItems.push(item);
 *   // May return -1 to abort the iteration
 * });
 *
 * // Also supports input as an array like object
 * const items = { length: 3, 0: 'item1', 1: 'item2', 2: 'item3' };
 * ```
 */
function arrForEach(theArray, callbackfn, thisArg) {
    if (theArray) {
        var len = theArray[LENGTH] >>> 0;
        for (var idx = 0; idx < len; idx++) {
            if (idx in theArray) {
                if (callbackfn[CALL$1](theArray, theArray[idx], idx, theArray) === -1) {
                    break;
                }
            }
        }
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrIndexOf() method returns the first index at which a given element can be found in the array,
 * or -1 if it is not present.
 * `arrIndexOf()` compares searchElement to elements of the Array using strict equality (the same
 * method used by the === or triple-equals operator).
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of array elements
 * @param theArray - The array or array like object of elements to be searched.
 * @param searchElement - The element to locate in the array.
 * @param fromIndex - The index to start the search at. If the index is greater than or equal to
 * the array's length, -1 is returned, which means the array will not be searched. If the provided
 * index value is a negative number, it is taken as the offset from the end of the array.
 * Note: if the provided index is negative, the array is still searched from front to back. If the
 * provided index is 0, then the whole array will be searched. Default: 0 (entire array is searched).
 * @return The first index of the element in the array; -1 if not found.
 * @example
 * ```ts
 * const array = [2, 9, 9];
 * arrIndexOf(array, 2);     // 0
 * arrIndexOf(array, 7);     // -1
 * arrIndexOf(array, 9, 2);  // 2
 * arrIndexOf(array, 2, -1); // -1
 * arrIndexOf(array, 2, -3); // 0
 *
 * let indices: number[] = [];
 * const array = ['a', 'b', 'a', 'c', 'a', 'd'];
 * const element = 'a';
 * let idx = arrIndexOf(array, element);
 * while (idx !== -1) {
 *   indices.push(idx);
 *   idx = arrIndexOf(array, element, idx + 1);
 * }
 * console.log(indices);
 * // [0, 2, 4]
 *
 * function updateVegetablesCollection (veggies, veggie) {
 *     if (arrIndexOf(veggies, veggie) === -1) {
 *         veggies.push(veggie);
 *         console.log('New veggies collection is : ' + veggies);
 *     } else {
 *         console.log(veggie + ' already exists in the veggies collection.');
 *     }
 * }
 *
 * let veggies = ['potato', 'tomato', 'chillies', 'green-pepper'];
 *
 * updateVegetablesCollection(veggies, 'spinach');
 * // New veggies collection is : potato,tomato,chillies,green-pepper,spinach
 * updateVegetablesCollection(veggies, 'spinach');
 * // spinach already exists in the veggies collection.
 *
 * // Array Like
 * let arrayLike = {
 *   length: 3,
 *   0: "potato",
 *   1: "tomato",
 *   2: "chillies",
 *   3: "green-pepper"  // Not checked as index is > length
 * };
 *
 * arrIndexOf(arrayLike, "potato"); // 0
 * arrIndexOf(arrayLike, "tomato"); // 1
 * arrIndexOf(arrayLike, "chillies"); 2
 * arrIndexOf(arrayLike, "green-pepper"); // -1
 * ```
 */
var arrIndexOf = ( /*#__PURE__*/_unwrapFunction("indexOf", ArrProto));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrMap() method creates a new array populated with the results of calling a provided function on every
 * element in the calling array.
 *
 * `arrMap` calls a provided callbackFn function once for each element in an array, in order, and constructs
 * a new array from the results. callbackFn is invoked only for indexes of the array which have assigned
 * values (including undefined).
 *
 * It is not called for missing elements of the array; that is:
 * - indexes that have never been set;
 * - indexes which have been deleted.
 *
 * @since 0.3.3
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of the array elements
 * @typeParam R - Identifies the type of the elements returned by the callback function, defaults to T.
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackFn - The function that is called for evetn element of `theArray`.
 * @param thisArg - The value to use as the `this` when executing the `callbackFn`.
 * @example
 * ```ts
 * const numbers = [1, 4, 9];
 * const roots = arrMap(numbers, (num) => Math.sqrt(num));
 *
 * // roots is now     [1, 2, 3]
 * // numbers is still [1, 4, 9]
 *
 * const kvArray = [{ key: 1, value: 10 },
 *                  { key: 2, value: 20 },
 *                  { key: 3, value: 30 }];
 *
 * const reformattedArray = arrMap(kvArray, ({ key, value}) => ({ [key]: value }));
 *
 * // reformattedArray is now [{1: 10}, {2: 20}, {3: 30}],
 *
 * // kvArray is still:
 * // [{key: 1, value: 10},
 * //  {key: 2, value: 20},
 * //  {key: 3, value: 30}]
 *
 * // Also supports Array Like objects with same output
 * const kvArray = {
 *   length: 3,
 *   0: { key: 1, value: 10 },
 *   1: { key: 2, value: 20 },
 *   2: { key: 3, value: 30 }
 * };
 * ```
 */
var arrMap = ( /*#__PURE__*/_unwrapFunction("map", ArrProto));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrSlice() method returns a shallow copy of a portion of an array into a new array object
 * selected from start to end (end not included) where start and end represent the index of items
 * in that array. The original array will not be modified.
 *
 * The `arrSlice()` method is a copying method. It does not alter this but instead returns a shallow
 * copy that contains some of the same elements as the ones from the original array.
 *
 * The `arrSlice()` method preserves empty slots. If the sliced portion is sparse, the returned arra
 * is sparse as well.
 *
 * The `arrSlice()` method is generic. It only expects the this value to have a length property and
 * integer-keyed properties.
 *
 * For both start and end, a negative index can be used to indicate an offset from the end of the array.
 * For example, -2 refers to the second to last element of the array.
 * @since 0.9.3
 * @group Array
 * @group ArrayLike
 * @param start Zero-based index at which to start extraction, converted to an integer.
 * - Negative index counts back from the end of the array — if start < 0, start + array.length is used.
 * - If start < -array.length or start is omitted, 0 is used.
 * - If start >= array.length, nothing is extracted.
 * @param end Zero-based index at which to end extraction, converted to an integer. slice() extracts
 * up to but not including end.
 * - Negative index counts back from the end of the array — if end < 0, end + array.length is used.
 * - If end < -array.length, 0 is used.
 * - If end >= array.length or end is omitted, array.length is used, causing all elements until the
 * end to be extracted.
 * - If end is positioned before or at start after normalization, nothing is extracted.
 * @example
 * ```ts
 * const lyrics = ["Hello", "Darkness", "my", "old", "friend.", "I've", "come", "to", "talk" ];
 *
 * arrSlice(lyrics);        // [ "Hello", "Darkness", "my", "old", "friend.", "I've", "come", "to", "talk" ]
 * arrSlice(lyrics, 1, 3);  // [ "Darkness", "my" ]
 * arrSlicw(lyrics, 2);     // [ "my", "old", "friend.", "I've", "come", "to", "talk" ]
 * arrSlice(lyrics, 2, 4);  // [ "my", "old" ]
 * arrSlice(lyrics, 1, 5);  // [ "Darkness", "my", "old", "friend." ]
 * arrSlice(lyrics, -2);    // [ "to", "talk" ]
 * arrSlice(lyrics, 2, -1); // [ "my", "old", "friend.", "I've", "come", "to" ]
 * ```
 */
function arrSlice(theArray, start, end) {
    return ((theArray && theArray["slice"]) || ArrSlice).apply(theArray, ArrSlice[CALL$1](arguments, 1));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The arrReduce() method executes a user-supplied "reducer" callback function on each element of the array,
 * in order, passing in the return value from the calculation on the preceding element. The final result of
 * running the reducer across all elements of the array is a single value.
 *
 * The first time that the callback is run there is no "return value of the previous calculation". If supplied,
 * an initial value may be used in its place. Otherwise the array element at index 0 is used as the initial
 * value and iteration starts from the next element (index 1 instead of index 0).
 * @group Array
 * @group ArrayLike
 * @typeParam T - Identifies the type of array elements
 * @param theArray - The array or array like object of elements to be searched.
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 * @returns The value that results from running the "reducer" callback function to completion over the entire array.
 * @example
 * ```ts
 * const getMax = (a: number, b: number) => Math.max(a, b);
 *
 * // callback is invoked for each element in the array starting at index 0
 * arrReduce([1, 100], getMax, 50); // 100
 * arrReduce([    50], getMax, 10); // 50
 *
 * // callback is invoked once for element at index 1
 * arrReduce([1, 100], getMax);     // 100
 *
 * // callback is not invoked
 * arrReduce([    50], getMax);     // 50
 * arrReduce([      ], getMax, 1);  // 1
 *
 * arrReduce([      ], getMax);     // throws TypeError
 *
 * // Also supports Array like objects
 * arrReduce({ length: 2, 0: 1, 1: 100 }, getMax, 50); // 100
 * arrReduce({ length: 1, 0: 50 }, getMax, 10); // 50
 *
 * // callback is invoked once for element at index 1
 * arrReduce({ length: 2, 0: 1, 1: 100 }, getMax);     // 100
 *
 * // callback is not invoked
 * arrReduce({ length: 1, 0: 50 }, getMax);     // 50
 * arrReduce({ length: 0 }, getMax, 1);  // 1
  * ```
 */
var arrReduce = ( /*#__PURE__*/_unwrapFunction("reduce", ArrProto));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @group Object
 * @param obj Object to use as a prototype. May be null
 */
var objCreate = ObjClass$1["create"] || polyObjCreate;
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @group Polyfill
 * @group Object
 * @param obj Object to use as a prototype. May be null
 */
/*#__NO_SIDE_EFFECTS__*/
function polyObjCreate(obj) {
    if (!obj) {
        return {};
    }
    var type = typeof obj;
    if (type !== OBJECT$1 && type !== FUNCTION) {
        throwTypeError("Prototype must be an Object or function: " + dumpObj(obj));
    }
    function tempFunc() { }
    tempFunc[PROTOTYPE] = obj;
    return new tempFunc();
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _isProtoArray;
/**
 * The objSetPrototypeOf() method sets the prototype (i.e., the internal [Prototype] property) of a specified
 * object to another object or null.
 * @group Object
 * @param obj - The object which is to have it's prototype set.
 * @param proto - The object's new prototype (an object or null)
 * @returns The specified object.
 */
function objSetPrototypeOf(obj, proto) {
    var fn = ObjClass$1["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            !_isProtoArray && (_isProtoArray = getLazy(function () {
                var _a;
                return ((_a = {}, _a[__PROTO__] = [], _a) instanceof Array);
            }));
            _isProtoArray.v ? d[__PROTO__] = b : objForEachKey(b, function (key, value) { return d[key] = value; });
        };
    return fn(obj, proto);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 */
/*#__NO_SIDE_EFFECTS__*/
function _createCustomError(name, d, b) {
    safe(objDefine, [d, NAME, { v: name, c: true, e: false }]);
    d = objSetPrototypeOf(d, b);
    function __() {
        this.constructor = d;
        safe(objDefine, [this, NAME, { v: name, c: true, e: false }]);
    }
    d[PROTOTYPE] = b === NULL_VALUE ? objCreate(b) : (__[PROTOTYPE] = b[PROTOTYPE], new __());
    return d;
}
function _setName(baseClass, name) {
    name && (baseClass[NAME] = name);
    //name && (baseClass[PROTOTYPE][NAME] = name);
}
/**
 * Create a Custom Error class which may be used to throw custom errors.
 * @group Error
 * @param name - The name of the Custom Error
 * @param constructCb - [Optional] An optional callback function to call when a
 * new Customer Error instance is being created.
 * @param errorBase - [Optional] (since v0.9.6) The error class to extend for this class, defaults to Error.
 * @returns A new Error `class`
 * @example
 * ```ts
 * import { createCustomError, isError } from "@nevware21/ts-utils";
 *
 * // For an error that just contains a message
 * let myCustomErrorError = createCustomError("MessageError");
 *
 * try {
 *     throw new myCustomErrorError("Error Message!");
 * } catch(e) {
 *      // e.name === MessageError
 *      // isError(e) === true;
 *      // Object.prototype.toString.call(e) === "[object Error]";
 * }
 *
 * // Or a more complex error object
 * interface MyCriticalErrorConstructor extends CustomErrorConstructor {
 *     new(message: string, file: string, line: number, col: number): MyCriticalError;
 *     (message: string, file: string, line: number, col: number): MyCriticalError;
 * }
 *
 * interface MyCriticalError extends Error {
 *     readonly errorId: number;
 *     readonly args: any[];        // Holds all of the arguments passed during construction
 * }
 *
 * let _totalErrors = 0;
 * let myCustomError = createCustomError<MyCriticalErrorConstructor>("CriticalError", (self, args) => {
 *     _totalErrors++;
 *     self.errorId = _totalErrors;
 *     self.args = args;
 * });
 *
 * try {
 *     throw new myCustomError("Not Again!");
 * } catch(e) {
 *      // e.name === CriticalError
 *      // isError(e) === true;
 *      // Object.prototype.toString.call(e) === "[object Error]";
 * }
 *
 * // ----------------------------------------------------------
 * // Extending another custom error class
 * // ----------------------------------------------------------
 *
 * let AppError = createCustomError("ApplicationError");
 * let theAppError = new appError();
 *
 * isError(theAppError);                    // true
 * theAppError instanceof Error;            // true
 * theAppError instanceof AppError;         // true
 *
 * let StartupError = createCustomError("StartupError", null, AppError);
 * let theStartupError = new StartupError();
 *
 * isError(theStartupError);                // true
 * theStartupError instanceof Error;        // true
 * theStartupError instanceof AppError;     // true
 * theStartupError instanceof StartupError; // true
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function createCustomError(name, constructCb, errorBase) {
    var theBaseClass = Error;
    var orgName = theBaseClass[PROTOTYPE][NAME];
    var captureFn = Error.captureStackTrace;
    return _createCustomError(name, function () {
        var _this = this;
        var theArgs = arguments;
        try {
            safe(_setName, [theBaseClass, name]);
            var _self = fnApply(theBaseClass, _this, ArrSlice[CALL$1](theArgs)) || _this;
            if (_self !== _this) {
                // Looks like runtime error constructor reset the prototype chain, so restore it
                var orgProto = objGetPrototypeOf(_this);
                if (orgProto !== objGetPrototypeOf(_self)) {
                    objSetPrototypeOf(_self, orgProto);
                }
            }
            // Make sure we only capture our stack details
            captureFn && captureFn(_self, _this[CONSTRUCTOR]);
            // Run the provided construction function
            constructCb && constructCb(_self, theArgs);
            return _self;
        }
        finally {
            safe(_setName, [theBaseClass, orgName]);
        }
    }, theBaseClass);
}
/**
 * @internal
 * @ignore
 */
var _unsupportedError;
/**
 * Throw a custom `UnsupportedError` Error instance with the given message.
 * @group Error
 * @param message - The message to include in the exception
 * @example
 * ```ts
 * import { throwUnsupported } from "@nevware21/ts-utils";
 *
 * if (!window) {
 *     throwUnsupported("A window is needed for this operation");
 * }
 * ```
 */
function throwUnsupported(message) {
    if (!_unsupportedError) {
        // Lazily create the class
        _unsupportedError = createCustomError("UnsupportedError");
    }
    throw new _unsupportedError(message);
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Return the number of milliseconds that have elapsed since January 1, 1970 00:00:00 UTC.
 *
 * To offer protection against timing attacks and fingerprinting, the precision of utcNow()
 * might get rounded depending on browser settings. In Firefox, the privacy.reduceTimerPrecision
 * preference is enabled by default and defaults to 20µs in Firefox 59; in 60 it will be 2ms.
 *
 * @since 0.4.4
 * @group Timer
 *
 * @returns A Number representing the milliseconds elapsed since the UNIX epoch.
 * @example
 * ```ts
 * let now = utcNow();
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function utcNow() {
    return (Date.now || polyUtcNow)();
}
/**
 * Polyfill fallback to return the number of milliseconds that have elapsed since January 1, 1970 00:00:00 UTC.
 *
 * To offer protection against timing attacks and fingerprinting, the precision of utcNow()
 * might get rounded depending on browser settings. In Firefox, the privacy.reduceTimerPrecision
 * preference is enabled by default and defaults to 20µs in Firefox 59; in 60 it will be 2ms.
 *
 * @since 0.4.4
 * @group Timer
 * @group Polyfill
 *
 * @returns A Number representing the milliseconds elapsed since the UNIX epoch.
  * @example
 * ```ts
 * let now = polyUtcNow();
 * ```
*/
/*#__NO_SIDE_EFFECTS__*/
function polyUtcNow() {
    return new Date().getTime();
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/*#__NO_SIDE_EFFECTS__*/
function _createTrimFn(exp) {
    return function _doTrim(value) {
        if (isNullOrUndefined(value)) {
            throwTypeError("strTrim called [" + dumpObj(value) + "]");
        }
        if (value && value.replace) {
            value = value.replace(exp, EMPTY$1);
        }
        return value;
    };
}
/**
 * The trim() method removes whitespace from both ends of a string and returns a new string,
 * without modifying the original string. Whitespace in this context is all the whitespace
 * characters (space, tab, no-break space, etc.) and all the line terminator characters
 * (LF, CR, etc.).
 * @group Polyfill
 * @group String
 * @param value - The string value to be trimmed.
 * @returns A new string representing str stripped of whitespace from both its beginning and end.
 * If neither the beginning or end of str has any whitespace, a new string is still returned (essentially
 * a copy of str), with no exception being thrown.
 * To return a new string with whitespace trimmed from just one end, use `strTrimStart()` or `strTrimEnd()`.
 */
var polyStrTrim = ( /*#__PURE__*/_createTrimFn(/^\s+|(?=\s)\s+$/g));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The trim() method removes whitespace from both ends of a string and returns a new string,
 * without modifying the original string. Whitespace in this context is all the whitespace
 * characters (space, tab, no-break space, etc.) and all the line terminator characters
 * (LF, CR, etc.).
 * @group String
 * @param value - The string value to be trimmed.
 * @returns A new string representing str stripped of whitespace from both its beginning and end.
 * If neither the beginning or end of str has any whitespace, a new string is still returned (essentially
 * a copy of str), with no exception being thrown.
 * To return a new string with whitespace trimmed from just one end, use `strTrimStart()` or `strTrimEnd()`.
 */
var strTrim = ( /*#__PURE__*/_unwrapFunctionWithPoly("trim", StrProto, polyStrTrim));

var _fnToString;
var _objCtrFnString;
var _gblWindow;
// @__NO_SIDE_EFFECTS__
function isPlainObject$6(value) {
  if (!value || typeof value !== OBJECT$1) {
    return false;
  }
  if (!_gblWindow) {
    _gblWindow = hasWindow() ? getWindow() : true;
  }
  var result = false;
  if (value !== _gblWindow) {
    if (!_objCtrFnString) {
      _fnToString = Function[PROTOTYPE][TO_STRING];
      _objCtrFnString = _fnToString[CALL$1](ObjClass$1);
    }
    try {
      var proto = objGetPrototypeOf(value);
      result = !proto;
      if (!result) {
        if (objHasOwnProperty(proto, CONSTRUCTOR)) {
          proto = proto[CONSTRUCTOR];
        }
        result = proto && typeof proto === FUNCTION && _fnToString[CALL$1](proto) === _objCtrFnString;
      }
    } catch (ex) {
    }
  }
  return result;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 * Generic Object deep copy handler which creates a new plain object and copies enumerable properties from
 * the source to the new target plain object. The source object does not have to be a plain object.
 * @param details - The details object for the current property being copied
 * @returns true if the handler processed the field.
 */
/*#__NO_SIDE_EFFECTS__*/
function _defaultDeepCopyHandler(details) {
    // Make sure we at least copy plain objects
    details.value && plainObjDeepCopyHandler(details);
    // Always return true so that the iteration completes
    return true;
}
/**
 * @internal
 * @ignore
 * The ordered default deep copy handlers
 */
var defaultDeepCopyHandlers = [
    arrayDeepCopyHandler,
    plainObjDeepCopyHandler,
    functionDeepCopyHandler,
    dateDeepCopyHandler
];
/**
 * @internal
 * @ignore
 * Helper function used for detecting and handling recursive properties
 * @param visitMap - The current map of objects that have been visited
 * @param source - The value (object) to be copied
 * @param newPath - The new access path from the origin to the current property
 * @param cb - The callback function to call if the current object has not already been processed.
 * @returns The new deep copied property, may be incomplete as the object is recursive and is still in the process of being copied
 */
/*#__NO_SIDE_EFFECTS__*/
function _getSetVisited(visitMap, source, newPath, cb) {
    var theEntry;
    arrForEach(visitMap, function (entry) {
        if (entry.k === source) {
            theEntry = entry;
            return -1;
        }
    });
    if (!theEntry) {
        // Add the target to the visit map so that deep nested objects refer to the single instance
        // Even if we have not finished processing it yet.
        theEntry = { k: source, v: source };
        visitMap.push(theEntry);
        // Now call the copy callback so that it populates the target
        cb(theEntry);
    }
    return theEntry.v;
}
/**
 * @internal
 * @ignore
 * Internal helper which performs the recursive deep copy
 * @param visitMap - The current map of objects that have been visited
 * @param value - The value being copied
 * @param ctx - The current copy context
 * @param key - [Optional] the current `key` for the value from the source object
 * @returns The new deep copied instance of the value.
 */
function _deepCopy(visitMap, value, ctx, key) {
    var userHandler = ctx.handler;
    var newPath = ctx.path ? (key ? ctx.path.concat(key) : ctx.path) : [];
    var newCtx = {
        handler: ctx.handler,
        src: ctx.src,
        path: newPath
    };
    var theType = typeof value;
    var isPlain = false;
    var isPrim = false;
    if (value && theType === OBJECT$1) {
        isPlain = isPlainObject$6(value);
    }
    else {
        isPrim = value === NULL_VALUE || isPrimitiveType(theType);
    }
    var details = {
        type: theType,
        isPrim: isPrim,
        isPlain: isPlain,
        value: value,
        result: value,
        path: newPath,
        origin: ctx.src,
        copy: function (source, newKey) {
            return _deepCopy(visitMap, source, newKey ? newCtx : ctx, newKey);
        },
        copyTo: function (target, source) {
            return _copyProps(visitMap, target, source, newCtx);
        }
    };
    if (!details.isPrim) {
        return _getSetVisited(visitMap, value, newPath, function (newEntry) {
            // Use an accessor to set the new value onto the new entry
            objDefine(details, "result", {
                g: function () {
                    return newEntry.v;
                },
                s: function (newValue) {
                    newEntry.v = newValue;
                }
            });
            var idx = 0;
            var handler = userHandler;
            while (!(handler || (idx < defaultDeepCopyHandlers.length ? defaultDeepCopyHandlers[idx++] : _defaultDeepCopyHandler))[CALL$1](ctx, details)) {
                handler = NULL_VALUE;
            }
        });
    }
    // Allow the user handler to override the provided value
    if (userHandler && userHandler[CALL$1](ctx, details)) {
        return details.result;
    }
    return value;
}
/**
 * @internal
 * @ignore
 * Internal helper to copy all of the enumerable properties from the source object to the new target object
 * @param visitMap - The current map of objects that have been visited
 * @param target - The target object to copy the properties to.
 * @param source - The source object to copy the properties from.
 * @param ctx - The current deep copy context
 * @returns The populated target object
 */
function _copyProps(visitMap, target, source, ctx) {
    if (!isNullOrUndefined(source)) {
        // Copy all properties (not just own properties)
        for (var key in source) {
            // Perform a deep copy of the object
            target[key] = _deepCopy(visitMap, source[key], ctx, key);
        }
    }
    return target;
}
/**
 * Object helper to copy all of the enumerable properties from the source object to the target, the
 * properties are copied via {@link objDeepCopy}. Automatic handling of recursive properties was added in v0.4.4
 * @group Object
 * @param target - The target object to populated
 * @param source - The source object to copy the properties from
 * @param handler - An optional callback that lets you provide / overide the deep cloning (Since 0.4.4)
 * @returns The target object
 * @example
 * ```ts
 * let a: any = { a: 1 };
 * let b: any = { b: 2, d: new Date(), e: new TestClass("Hello Darkness") };
 * a.b = b;        // { a: 1, b: { b: 2} }
 * b.a = a;        // { a: 1, b: { b: 2, a: { a: 1, { b: 2, a: ... }}}}
 *
 * function copyHandler(details: IObjDeepCopyHandlerDetails) {
 *     // details.origin === a
 *     // details.path[] is the path to the current value
 *     if (details.value && isDate(details.value)) {
 *         // So for the date path === [ "b", "d" ] which represents
 *         // details.origin["b"]["d"] === The Date
 *
 *         // Create a clone the Date object and set as the "newValue"
 *         details.value = new Date(details.value.getTime());
 *
 *         // Return true to indicate that we have "handled" the conversion
 *         // See objDeepCopy example for just reusing the original value (just don't replace details.value)
 *         return true;
 *     }
 *
 *     return false;
 * }
 *
 * let c: any = objCopyProps({}, a, copyHandler);
 *
 * assert.notEqual(a, c, "check a and c are not the same");
 * assert.ok(c !== c.b.a, "The root object won't be the same for the target reference as are are copying properties to our target");
 * assert.ok(c.b === c.b.a.b, "Check that the 2 'b' references are the same object");
 * assert.ok(c.b.a === c.b.a.b.a, "Check that the 2 'a' references are the same object");
 * assert.ok(c.b.d === c.b.a.b.d, "Check that the 2 'd' references are the same object");
 * assert.ok(isDate(c.b.d), "The copied date is still real 'Date' instance");
 * assert.notEqual(c.b.d, a.b.d, "And the copied date is not the same as the original");
 * assert.equal(c.b.d.getTime(), a.b.d.getTime(), "But the dates are the same");
 *
 * assert.ok(isObject(c.b.d), "The copied date is now an object");
 * ```
 */
function objCopyProps(target, source, handler) {
    var ctx = {
        handler: handler,
        src: source,
        path: []
    };
    return _copyProps([], target, source, ctx);
}
/**
 * Performs a deep copy of the source object, this is designed to work with base (plain) objects, arrays and primitives
 * if the source object contains class objects they will either be not cloned or may be considered non-operational after
 * performing a deep copy. ie. This is performing a deep copy of the objects properties so that altering the copy will
 * not mutate the source object hierarchy.
 * Automatic handling of recursive properties was added in v0.4.4.
 * @group Object
 * @group Object - Deep Copy
 * @param source - The source object to be copied
 * @param handler - An optional callback that lets you provide / overide the deep cloning (Since 0.4.4)
 * @return A new object which contains a deep copy of the source properties
 * @example
 * ```ts
 * let a: any = { a: 1 };
 * let b: any = { b: 2, d: new Date(), e: new TestClass("Hello Darkness") };
 * a.b = b;        // { a: 1, b: { b: 2} }
 * b.a = a;        // { a: 1, b: { b: 2, a: { a: 1, { b: 2, a: ... }}}}
 *
 * function copyHandler(details: IObjDeepCopyHandlerDetails) {
 *     // details.origin === a
 *     // details.path[] is the path to the current value
 *     if (details.value && isDate(details.value)) {
 *         // So for the date path === [ "b", "d" ] which represents
 *         // details.origin["b"]["d"] === The Date
 *
 *         // Return true to indicate that we have "handled" the conversion
 *         // Which in this case will reuse the existing instance (as we didn't replace details.value)
 *         // See objCopyProps example for replacing the Date instance
 *         return true;
 *     }
 *
 *     return false;
 * }
 *
 * let c: any = objDeepCopy(a, copyHandler);
 *
 * assert.notEqual(a, c, "check a and c are not the same");
 * assert.ok(c === c.b.a, "The root object won't be the same for the target reference");
 * assert.ok(c.b === c.b.a.b, "Check that the 2 'b' references are the same object");
 * assert.ok(c.b.a === c.b.a.b.a, "Check that the 2 'a' references are the same object");
 * assert.ok(c.b.d === c.b.a.b.d, "Check that the 2 'd' references are the same object");
 * assert.ok(isDate(c.b.d), "The copied date is still real 'Date' instance");
 * assert.equal(c.b.d, a.b.d, "And the copied date is the original date");
 * assert.equal(c.b.d.getTime(), a.b.d.getTime(), "But the dates are the same");
 * assert.ok(isObject(c.b.d), "The copied date is now an object");
 * assert.ok(!isError(c.b.e), "The copied error is no longer a real 'Error' instance");
 * assert.ok(isObject(c.b.e), "The copied error is now an object");
 * assert.equal(42, c.b.e.value, "Expect that the local property was copied");
 * ```
 */
/*#__NO_SIDE_EFFECTS__*/
function objDeepCopy(source, handler) {
    var ctx = {
        handler: handler,
        src: source
    };
    return _deepCopy([], source, ctx);
}
/**
 * Deep copy handler to identify and copy arrays.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function arrayDeepCopyHandler(details) {
    var value = details.value;
    if (isArray$3(value)) {
        // Assign the "result" value before performing any additional deep Copying, so any recursive object get a reference to this instance
        var target = details.result = [];
        target.length = value.length;
        // Copying all properties as arrays can contain non-indexed based properties
        details.copyTo(target, value);
        return true;
    }
    return false;
}
/**
 * Deep copy handler to identify and copy Date instances.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function dateDeepCopyHandler(details) {
    var value = details.value;
    if (isDate$4(value)) {
        details.result = new Date(value.getTime());
        return true;
    }
    return false;
}
/**
 * Deep copy handler to identify and copy functions. This handler just returns the original
 * function so the original function will be assigned to any new deep copied instance.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function functionDeepCopyHandler(details) {
    if (details.type === FUNCTION) {
        return true;
    }
    return false;
}
/**
 * Deep copy handler to identify and copy plain objects.
 * @since 0.4.4
 * @group Object - Deep Copy
 * @param details - The details object for the current property being copied
 * @returns `true` if the current value is a function otherwise `false`
 */
function plainObjDeepCopyHandler(details) {
    var value = details.value;
    if (value && details.isPlain) {
        // Assign the "result" value before performing any additional deep Copying, so any recursive object get a reference to this instance
        var target = details.result = {};
        details.copyTo(target, value);
        return true;
    }
    return false;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @internal
 * @ignore
 */
function _doExtend(target, theArgs) {
    arrForEach(theArgs, function (theArg) {
        objCopyProps(target, theArg);
    });
    return target;
}
/**
 * Create a new object by merging the passed arguments, this is effectively the same as calling `objExtend({}, ...theArgs)` where
 * all of the arguments are added to a new object that is returned.
 * @group Object
 * @param target - The original object to be extended.
 * @param objN - The optional number of arguments to be copied
 * @returns - A new object or the original
 */
function deepExtend(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(objDeepCopy(target) || {}, ArrSlice[CALL$1](arguments));
}
/**
 * Extend the target object by merging the passed arguments into it
 * @group Object
 * @param target - The object to be extended or overwritten
 * @param objN - The optional number of arguments to be copied
 * @returns - A new object or the original
 */
function objExtend$1(target, obj1, obj2, obj3, obj4, obj5, obj6) {
    return _doExtend(target, ArrSlice[CALL$1](arguments));
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Helper to return the length value of an object, this will return the value
 * of the "length" property. Generally used to return the length of a string or array.
 *
 * @since 0.4.2
 * @group Array
 * @group String
 * @group String
 * @group Array
 * @group Object
 * @param value - The value to return the length property from, must contain a `length` property
 * @example
 * ```ts
 * getLength("");               // returns 0
 * getLength("Hello World");    // returns 11
 * getLength([]);               // returns 0;
 * getLength([0, 1, 2, 3]);     // returns 4;
 * getLength({ length: 42});    // returns 42
 * getLength({ length: () => 53; }); // returns the function that if called would return 53
 * ```
 */
var getLength = ( /*#__PURE__*/_unwrapProp(LENGTH));

var _perf;
// @__NO_SIDE_EFFECTS__
function getPerformance() {
  !_globalLazyTestHooks && _initTestHooks();
  (!_perf || !_perf.b && _globalLazyTestHooks.lzy) && (_perf = lazySafeGetInst("performance"));
  return _perf.v;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strSplit()` splits a string into substrings using the pattern and divides a String
 * into an ordered list of substrings by searching for the pattern, puts these substrings
 * into an array, and returns the array.
 * @since 0.9.1
 * @group String
 * @param value - The string value to be split into substrings.
 * @param separator - The pattern describing where each split should occur. Can be undefined, a
 * string, or an object with a [`Symbol.split`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol/split)
 * method (if supported) — the typical example being a regular expression. Omitting separator or
 * passing undefined causes strSplit() to return an array with the calling string as a single
 * element. All values that are not undefined or objects with a `@@split` method are coerced to strings.
 * @param limit - A non-negative integer specifying a limit on the number of substrings to be
 * included in the array. If provided, splits the string at each occurrence of the specified
 * separator, but stops when limit entries have been placed in the array. Any leftover text is
 * not included in the array at all.
 * - The array may contain fewer entries than limit if the end of the string is reached before
 * the limit is reached.
 * - If limit is 0, [] is returned.
 * @return An Array of strings, split at each point where the separator occurs in the given string.
 * @example
 * ```ts
 * strSplit("Oh brave new world that has such people in it.", " ");
 * // [ "Oh", "brave", "new", "world", "that", "has", "such", "people", "in", "it." ]
 *
 * strSplit("Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec", ",");
 * // [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
 * ```
 */
var strSplit = ( /*#__PURE__*/_unwrapFunction("split", StrProto));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Set the named value on the target object where the path may be presented by a string which
 * contains "." characters to separate the nested objects of the heirarchy / path to the value.
 * @since 0.9.1
 * @group Value
 * @param target - The target object
 * @param path - The path identifying the location of the final key value
 * @param value - The value to set
 * @example
 * ```ts
 * let theValue = { };
 * setValueByKey(theValue, "Hello.Darkness.my", "old");
 * // Resulting Object: { Hello: { Darkness: { my: "old" } } }
 * setValueByKey(theValue, "friend", "I've");
 * // Resulting Object: { Hello: { Darkness: { my: "old" } }, friend: "I've" }
 * setValueByKey(theValue, "come.to.see", "you");
 * // Resulting Object: { Hello: { Darkness: { my: "old" } }, friend: "I've", come: { to : { see: "you" } } }
 * ```
 */
function setValueByKey(target, path, value) {
    if (target && path) {
        var parts = strSplit(path, ".");
        var lastKey = parts.pop();
        arrForEach(parts, function (key) {
            if (isNullOrUndefined(target[key])) {
                // Add an empty object / map
                target[key] = {};
            }
            target = target[key];
        });
        target[lastKey] = value;
    }
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * This method lets you determine whether or not a string ends with another string. This method is case-sensitive.
 * @group String
 * @param value - The value to be checked
 * @param searchString - The characters to be searched for at the end of `value` string.
 * @param length - If provided, it is used as the length of `value`. Defaults to value.length.
 */
var strEndsWith = ( /*#__PURE__*/_unwrapFunctionWithPoly("endsWith", StrProto, polyStrEndsWith));
/**
 * This method lets you determine whether or not a string ends with another string. This method is case-sensitive.
 * @group Polyfill
 * @group String
 * @param value - The value to be checked
 * @param searchString - The characters to be searched for at the end of `value` string.
 * @param length - If provided, it is used as the length of `value`. Defaults to value.length.
 */
/*#__NO_SIDE_EFFECTS__*/
function polyStrEndsWith(value, searchString, length) {
    if (!isString$2(value)) {
        throwTypeError("'" + dumpObj(value) + "' is not a string");
    }
    var searchValue = isString$2(searchString) ? searchString : asString(searchString);
    var end = !isUndefined$2(length) && length < value[LENGTH] ? length : value[LENGTH];
    return strSubstring(value, end - searchValue[LENGTH], end) === searchValue;
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * The `strIndexOf()` method, given two arguments: the string and a substring to search for, searches
 * the entire calling string, and returns the index of the first occurrence of the specified substring.
 * Given a thrid argument: a number, the method returns the first occurrence of the specified substring
 * at an index greater than or equal to the specified number.
 * @group String
 * @param value - The value to be checked for the seeach string
 * @param searchString - The substring to search for in the value
 * @param position - The starting position to search from
 * @example
 * ```ts
 * strIndexOf('hello world', '') // returns 0
 * strIndexOf('hello world', '', 0) // returns 0
 * strIndexOf('hello world', '', 3) // returns 3
 * strIndexOf('hello world', '', 8) // returns 8
 *
 * // However, if the thrid argument is greater than the length of the string
 * strIndexOf('hello world', '', 11) // returns 11
 * strIndexOf('hello world', '', 13) // returns 11
 * strIndexOf('hello world', '', 22) // returns 11
 *
 * strIndexOf('Blue Whale', 'Blue')      // returns  0
 * strIndexOf('Blue Whale', 'Blute')     // returns -1
 * strIndexOf('Blue Whale', 'Whale', 0)  // returns  5
 * strIndexOf('Blue Whale', 'Whale', 5)  // returns  5
 * strIndexOf('Blue Whale', 'Whale', 7)  // returns -1
 * strIndexOf('Blue Whale', '')          // returns  0
 * strIndexOf('Blue Whale', '', 9)       // returns  9
 * strIndexOf('Blue Whale', '', 10)      // returns 10
 * strIndexOf('Blue Whale', '', 11)      // returns 10
 * ```
 */
var strIndexOf = ( /*#__PURE__*/_unwrapFunction("indexOf", StrProto));

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var REF = "ref";
var UNREF = "unref";
var HAS_REF = "hasRef";
var ENABLED = "enabled";
/**
 * @ignore
 * @internal
 * Internal function to create and manage an ITimerHandler implementation, the object returned from this function
 * it directly used / returned by the pulic functions used to create timers (idle, interval and timeout)
 * @param startTimer - Should the timer be started as part of creating the handler
 * @param refreshFn - The function used to create/start or refresh the timer
 * @param cancelFn - The function used to cancel the timer.
 * @returns The new ITimerHandler instance
 */
/*#__NO_SIDE_EFFECTS__*/
function _createTimerHandler(startTimer, refreshFn, cancelFn) {
    var ref = true;
    var timerId = startTimer ? refreshFn(NULL_VALUE) : NULL_VALUE;
    var theTimerHandler;
    function _unref() {
        ref = false;
        timerId && timerId[UNREF] && timerId[UNREF]();
        return theTimerHandler;
    }
    function _cancel() {
        timerId && cancelFn(timerId);
        timerId = NULL_VALUE;
    }
    function _refresh() {
        timerId = refreshFn(timerId);
        if (!ref) {
            _unref();
        }
        return theTimerHandler;
    }
    function _setEnabled(value) {
        !value && timerId && _cancel();
        value && !timerId && _refresh();
    }
    theTimerHandler = {
        cancel: _cancel,
        refresh: _refresh
    };
    theTimerHandler[HAS_REF] = function () {
        if (timerId && timerId[HAS_REF]) {
            return timerId[HAS_REF]();
        }
        return ref;
    };
    theTimerHandler[REF] = function () {
        ref = true;
        timerId && timerId[REF] && timerId[REF]();
        return theTimerHandler;
    };
    theTimerHandler[UNREF] = _unref;
    theTimerHandler = objDefineProp(theTimerHandler, ENABLED, {
        get: function () { return !!timerId; },
        set: _setEnabled
    });
    return {
        h: theTimerHandler,
        dn: function () {
            timerId = NULL_VALUE;
        }
    };
}

/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
function _createTimeoutWith(startTimer, overrideFn, theArgs) {
    var isArr = isArray$3(overrideFn);
    var len = isArr ? overrideFn.length : 0;
    var setFn = (len > 0 ? overrideFn[0] : (!isArr ? overrideFn : UNDEF_VALUE)) || setTimeout;
    var clearFn = (len > 1 ? overrideFn[1] : UNDEF_VALUE) || clearTimeout;
    var timerFn = theArgs[0];
    theArgs[0] = function () {
        handler.dn();
        fnApply(timerFn, UNDEF_VALUE, ArrSlice[CALL$1](arguments));
    };
    var handler = _createTimerHandler(startTimer, function (timerId) {
        if (timerId) {
            if (timerId.refresh) {
                timerId.refresh();
                return timerId;
            }
            fnApply(clearFn, UNDEF_VALUE, [timerId]);
        }
        return fnApply(setFn, UNDEF_VALUE, theArgs);
    }, function (timerId) {
        fnApply(clearFn, UNDEF_VALUE, [timerId]);
    });
    return handler.h;
}
/**
 * Creates and starts a timer which executes a function or specified piece of code once the timer expires, this is simular
 * to using `setTimeout` but provides a return object for cancelling and restarting (refresh) the timer.
 *
 * The timer may be cancelled (cleared) by calling the `cancel()` function on the returned {@link ITimerHandler}, or
 * you can "reschedule" and/or "restart" the timer by calling the `refresh()` function on the returned {@link ITimerHandler}
 * instance
 *
 * @since 0.4.4
 * @group Timer
 *
 * @param callback - The function to be executed after the timer expires.
 * @param timeout - The time, in milliseconds that the timer should wait before the specified
 * function or code is executed. If this parameter is omitted, a value of 0 is used, meaning
 * execute "immediately", or more accurately, the next event cycle.
 * @param args - Additional arguments which are passed through to the function specified by `callback`.
 * @returns A {@link ITimerHandler} instance which can be used to cancel the timeout.
 * @example
 * ```ts
 * let timeoutCalled = false;
 * let theTimeout = scheduleTimeout(() => {
 *     // This callback will be called after 100ms as this uses setTimeout()
 *     timeoutCalled = true;
 * }, 100);
 *
 * // Instead of calling clearTimeout() with the returned value from setTimeout() the returned
 * // handler instance can be used instead to cancel the timer
 * theTimeout.cancel();
 * theTimeout.enabled;    // false
 *
 * // You can start the timer via enabled
 * theTimeout.enabled = true;
 *
 * // You can also "restart" the timer, whether it has previously triggered not not via the `refresh()`
 * theTimeout.refresh();
 * ```
 */
function scheduleTimeout(callback, timeout) {
    return _createTimeoutWith(true, UNDEF_VALUE, ArrSlice[CALL$1](arguments));
}
/**
 * Creates a non-running (paused) timer which will execute a function or specified piece of code when enabled and the timer expires,
 * this is simular to using `scheduleTimeout` but the timer is not enabled (running) and you MUST call `refresh` to start the timer.
 *
 * The timer may be cancelled (cleared) by calling the `cancel()` function on the returned {@link ITimerHandler}, or
 * you can "reschedule" and/or "restart" the timer by calling the `refresh()` function on the returned {@link ITimerHandler}
 * instance
 *
 * @since 0.7.0
 * @group Timer
 *
 * @param callback - The function to be executed after the timer expires.
 * @param timeout - The time, in milliseconds that the timer should wait before the specified
 * function or code is executed. If this parameter is omitted, a value of 0 is used, meaning
 * execute "immediately", or more accurately, the next event cycle.
 * @param args - Additional arguments which are passed through to the function specified by `callback`.
 * @returns A {@link ITimerHandler} instance which can be used to cancel the timeout.
 * @example
 * ```ts
 * let timeoutCalled = false;
 * let theTimeout = createTimeout(() => {
 *     // This callback will be called after 100ms as this uses setTimeout()
 *     timeoutCalled = true;
 * }, 100);
 *
 * // As the timer is not started you will need to call "refresh" to start the timer
 * theTimeout.refresh();
 *
 * // or set enabled to true
 * theTimeout.enabled = true;
 * ```
 */
function createTimeout(callback, timeout) {
    return _createTimeoutWith(false, UNDEF_VALUE, ArrSlice[CALL$1](arguments));
}

var _a$b;
var Constructor = "constructor";
var Prototype = "prototype";
var strFunction = "function";
var DynInstFuncTable = "_dynInstFuncs";
var DynProxyTag = "_isDynProxy";
var DynClassName = "_dynClass";
var DynClassNamePrefix = "_dynCls$";
var DynInstChkTag = "_dynInstChk";
var DynAllowInstChkTag = DynInstChkTag;
var DynProtoDefaultOptions = "_dfOpts";
var UnknownValue = "_unknown_";
var str__Proto = "__proto__";
var DynProtoBaseProto = "_dyn" + str__Proto;
var DynProtoGlobalSettings = "__dynProto$Gbl";
var DynProtoCurrent = "_dynInstProto";
var strUseBaseInst = "useBaseInst";
var strSetInstFuncs = "setInstFuncs";
var Obj = Object;
var _objGetPrototypeOf = Obj["getPrototypeOf"];
var _objGetOwnProps = Obj["getOwnPropertyNames"];
var _gbl = getGlobal();
var _gblInst = _gbl[DynProtoGlobalSettings] || (_gbl[DynProtoGlobalSettings] = {
  o: (_a$b = {}, _a$b[strSetInstFuncs] = true, _a$b[strUseBaseInst] = true, _a$b),
  n: 1e3
  // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
function _isObjectOrArrayPrototype(target) {
  return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
function _isObjectArrayOrFunctionPrototype(target) {
  return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
function _getObjProto$1(target) {
  var newProto;
  if (target) {
    if (_objGetPrototypeOf) {
      return _objGetPrototypeOf(target);
    }
    var curProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
    newProto = target[DynProtoBaseProto] || curProto;
    if (!objHasOwnProperty(target, DynProtoBaseProto)) {
      delete target[DynProtoCurrent];
      newProto = target[DynProtoBaseProto] = target[DynProtoCurrent] || target[DynProtoBaseProto];
      target[DynProtoCurrent] = curProto;
    }
  }
  return newProto;
}
function _forEachProp(target, func) {
  var props = [];
  if (_objGetOwnProps) {
    props = _objGetOwnProps(target);
  } else {
    for (var name_1 in target) {
      if (typeof name_1 === "string" && objHasOwnProperty(target, name_1)) {
        props.push(name_1);
      }
    }
  }
  if (props && props.length > 0) {
    for (var lp = 0; lp < props.length; lp++) {
      func(props[lp]);
    }
  }
}
function _isDynamicCandidate(target, funcName, skipOwn) {
  return funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || objHasOwnProperty(target, funcName)) && funcName !== str__Proto && funcName !== Prototype;
}
function _throwTypeError(message) {
  throwTypeError("DynamicProto: " + message);
}
function _getInstanceFuncs(thisTarget) {
  var instFuncs = objCreate(null);
  _forEachProp(thisTarget, function(name) {
    if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
      instFuncs[name] = thisTarget[name];
    }
  });
  return instFuncs;
}
function _hasVisited(values, value) {
  for (var lp = values.length - 1; lp >= 0; lp--) {
    if (values[lp] === value) {
      return true;
    }
  }
  return false;
}
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
  function _instFuncProxy(target, funcHost, funcName) {
    var theFunc = funcHost[funcName];
    if (theFunc[DynProxyTag] && useBaseInst) {
      var instFuncTable = target[DynInstFuncTable] || {};
      if (instFuncTable[DynAllowInstChkTag] !== false) {
        theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
      }
    }
    return function() {
      return theFunc.apply(target, arguments);
    };
  }
  var baseFuncs = objCreate(null);
  _forEachProp(instFuncs, function(name) {
    baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
  });
  var baseProto = _getObjProto$1(classProto);
  var visited = [];
  while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
    _forEachProp(baseProto, function(name) {
      if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
        baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
      }
    });
    visited.push(baseProto);
    baseProto = _getObjProto$1(baseProto);
  }
  return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
  var instFunc = null;
  if (target && objHasOwnProperty(proto, DynClassName)) {
    var instFuncTable = target[DynInstFuncTable] || objCreate(null);
    instFunc = (instFuncTable[proto[DynClassName]] || objCreate(null))[funcName];
    if (!instFunc) {
      _throwTypeError("Missing [" + funcName + "] " + strFunction);
    }
    if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
      var canAddInst = !objHasOwnProperty(target, funcName);
      var objProto = _getObjProto$1(target);
      var visited = [];
      while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
        var protoFunc = objProto[funcName];
        if (protoFunc) {
          canAddInst = protoFunc === currentDynProtoProxy;
          break;
        }
        visited.push(objProto);
        objProto = _getObjProto$1(objProto);
      }
      try {
        if (canAddInst) {
          target[funcName] = instFunc;
        }
        instFunc[DynInstChkTag] = 1;
      } catch (e) {
        instFuncTable[DynAllowInstChkTag] = false;
      }
    }
  }
  return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
  var protoFunc = proto[funcName];
  if (protoFunc === currentDynProtoProxy) {
    protoFunc = _getObjProto$1(proto)[funcName];
  }
  if (typeof protoFunc !== strFunction) {
    _throwTypeError("[" + funcName + "] is not a " + strFunction);
  }
  return protoFunc;
}
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
  function _createDynamicPrototype(proto2, funcName) {
    var dynProtoProxy = function() {
      var instFunc = _getInstFunc(this, funcName, proto2, dynProtoProxy) || _getProtoFunc(funcName, proto2, dynProtoProxy);
      return instFunc.apply(this, arguments);
    };
    dynProtoProxy[DynProxyTag] = 1;
    return dynProtoProxy;
  }
  if (!_isObjectOrArrayPrototype(proto)) {
    var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || objCreate(null);
    if (!_isObjectOrArrayPrototype(instFuncTable)) {
      var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || objCreate(null);
      if (instFuncTable[DynAllowInstChkTag] !== false) {
        instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
      }
      if (!_isObjectOrArrayPrototype(instFuncs_1)) {
        _forEachProp(target, function(name) {
          if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
            instFuncs_1[name] = target[name];
            delete target[name];
            if (!objHasOwnProperty(proto, name) || proto[name] && !proto[name][DynProxyTag]) {
              proto[name] = _createDynamicPrototype(proto, name);
            }
          }
        });
      }
    }
  }
}
function _checkPrototype(classProto, thisTarget) {
  if (_objGetPrototypeOf) {
    var visited = [];
    var thisProto = _getObjProto$1(thisTarget);
    while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
      if (thisProto === classProto) {
        return true;
      }
      visited.push(thisProto);
      thisProto = _getObjProto$1(thisProto);
    }
    return false;
  }
  return true;
}
function _getObjName(target, unknownValue) {
  if (objHasOwnProperty(target, Prototype)) {
    return target.name || unknownValue || UnknownValue;
  }
  return ((target || {})[Constructor] || {}).name || unknownValue || UnknownValue;
}
function dynamicProto(theClass, target, delegateFunc, options) {
  if (!objHasOwnProperty(theClass, Prototype)) {
    _throwTypeError("theClass is an invalid class definition.");
  }
  var classProto = theClass[Prototype];
  if (!_checkPrototype(classProto, target)) {
    _throwTypeError("[" + _getObjName(theClass) + "] not in hierarchy of [" + _getObjName(target) + "]");
  }
  var className = null;
  if (objHasOwnProperty(classProto, DynClassName)) {
    className = classProto[DynClassName];
  } else {
    className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _gblInst.n;
    _gblInst.n++;
    classProto[DynClassName] = className;
  }
  var perfOptions = dynamicProto[DynProtoDefaultOptions];
  var useBaseInst = !!perfOptions[strUseBaseInst];
  if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
    useBaseInst = !!options[strUseBaseInst];
  }
  var instFuncs = _getInstanceFuncs(target);
  var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
  delegateFunc(target, baseFuncs);
  var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
  if (setInstanceFunc && options) {
    setInstanceFunc = !!options[strSetInstFuncs];
  }
  _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
dynamicProto[DynProtoDefaultOptions] = _gblInst.o;

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES5 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
(getGlobal() || {})["Symbol"];
(getGlobal() || {})["Reflect"];
var strHasOwnProperty = "hasOwnProperty";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (ObjProto[strHasOwnProperty].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = objAssign || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = ObjClass["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) {
            d.__proto__ = b;
        }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[strHasOwnProperty](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== strShimFunction && b !== null) {
        throwTypeError("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[strShimPrototype] = b === null ? objCreate(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Create an enum style object which has both the key => value and value => key mappings
 * @param values - The values to populate on the new object
 * @returns
 */
var createEnumStyle = createEnum;
/**
 * Create a 2 index map that maps an enum's key and value to the defined map value, X["key"] => mapValue and X[0] => mapValue.
 * Generic values
 * - E = the const enum type (typeof eRequestHeaders);
 * - V = Identifies the valid values for the keys, this should include both the enum numeric and string key of the type. The
 * resulting "Value" of each entry identifies the valid values withing the assignments.
 * @param values - The values to populate on the new object
 * @returns
 */
var createValueMap = createTypeMap;

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_LOWER_CASE$2 = "toLowerCase"; // Count: 11
var _DYN_BLK_VAL = "blkVal"; // Count: 5
var _DYN_LENGTH$5 = "length"; // Count: 49
var _DYN_RD_ONLY = "rdOnly"; // Count: 4
var _DYN_NOTIFY = "notify"; // Count: 4
var _DYN_WARN_TO_CONSOLE = "warnToConsole"; // Count: 4
var _DYN_THROW_INTERNAL = "throwInternal"; // Count: 5
var _DYN_SET_DF = "setDf"; // Count: 6
var _DYN_WATCH = "watch"; // Count: 9
var _DYN_LOGGER = "logger"; // Count: 21
var _DYN_APPLY = "apply"; // Count: 7
var _DYN_PUSH$2 = "push"; // Count: 31
var _DYN_SPLICE = "splice"; // Count: 8
var _DYN_HDLR = "hdlr"; // Count: 6
var _DYN_CANCEL = "cancel"; // Count: 5
var _DYN_INITIALIZE$1 = "initialize"; // Count: 5
var _DYN_IDENTIFIER = "identifier"; // Count: 8
var _DYN_IS_INITIALIZED = "isInitialized"; // Count: 10
var _DYN_GET_PLUGIN = "getPlugin"; // Count: 6
var _DYN_POLL_INTERNAL_LOGS = "pollInternalLogs"; // Count: 2
var _DYN_NAME$3 = "name"; // Count: 11
var _DYN_TIME = "time"; // Count: 6
var _DYN_PROCESS_NEXT = "processNext"; // Count: 15
var _DYN_GET_PROCESS_TEL_CONT0 = "getProcessTelContext"; // Count: 2
var _DYN_GET_NOTIFY_MGR = "getNotifyMgr"; // Count: 5
var _DYN_ADD_NOTIFICATION_LIS1 = "addNotificationListener"; // Count: 4
var _DYN_REMOVE_NOTIFICATION_2 = "removeNotificationListener"; // Count: 4
var _DYN_ENABLED = "enabled"; // Count: 6
var _DYN_STOP_POLLING_INTERNA3 = "stopPollingInternalLogs"; // Count: 2
var _DYN_UNLOAD = "unload"; // Count: 9
var _DYN_ON_COMPLETE = "onComplete"; // Count: 5
var _DYN_VERSION$1 = "version"; // Count: 6
var _DYN_LOGGING_LEVEL_CONSOL4 = "loggingLevelConsole"; // Count: 2
var _DYN_CREATE_NEW$1 = "createNew"; // Count: 7
var _DYN_TEARDOWN = "teardown"; // Count: 9
var _DYN_MESSAGE_ID = "messageId"; // Count: 4
var _DYN_MESSAGE$2 = "message"; // Count: 7
var _DYN_IS_ASYNC = "isAsync"; // Count: 6
var _DYN_DIAG_LOG$2 = "diagLog"; // Count: 10
var _DYN__DO_TEARDOWN = "_doTeardown"; // Count: 5
var _DYN_UPDATE$1 = "update"; // Count: 6
var _DYN_GET_NEXT = "getNext"; // Count: 12
var _DYN_SET_NEXT_PLUGIN = "setNextPlugin"; // Count: 5
var _DYN_PROTOCOL = "protocol"; // Count: 3
var _DYN_USER_AGENT = "userAgent"; // Count: 5
var _DYN_SPLIT$1 = "split"; // Count: 7
var _DYN_NODE_TYPE = "nodeType"; // Count: 3
var _DYN_REPLACE = "replace"; // Count: 9
var _DYN_LOG_INTERNAL_MESSAGE = "logInternalMessage"; // Count: 2
var _DYN_TYPE = "type"; // Count: 14
var _DYN_HANDLER = "handler"; // Count: 5
var _DYN_STATUS$1 = "status"; // Count: 5
var _DYN_ITEMS_RECEIVED$1 = "itemsReceived"; // Count: 3
var _DYN_GET_RESPONSE_HEADER = "getResponseHeader"; // Count: 2
var _DYN_GET_ALL_RESPONSE_HEA5 = "getAllResponseHeaders"; // Count: 2
var _DYN_IS_CHILD_EVT = "isChildEvt"; // Count: 3
var _DYN_DATA$1 = "data"; // Count: 7
var _DYN_GET_CTX = "getCtx"; // Count: 6
var _DYN_SET_CTX = "setCtx"; // Count: 10
var _DYN_COMPLETE = "complete"; // Count: 3
var _DYN_URL_STRING = "urlString"; // Count: 5
var _DYN_SEND_POST = "sendPOST"; // Count: 3
var _DYN_HEADERS$1 = "headers"; // Count: 5
var _DYN_TIMEOUT = "timeout"; // Count: 6
var _DYN_SET_REQUEST_HEADER$1 = "setRequestHeader"; // Count: 2
var _DYN_TRACE_ID$2 = "traceId"; // Count: 5
var _DYN_SPAN_ID$1 = "spanId"; // Count: 5
var _DYN_TRACE_FLAGS$1 = "traceFlags"; // Count: 6

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var aggregationErrorType;
/**
 * Throws an Aggregation Error which includes all of the errors that led to this error occurring
 * @param message - The message describing the aggregation error (the sourceError details are added to this)
 * @param sourceErrors - An array of the errors that caused this situation
 */
function throwAggregationError(message, sourceErrors) {
    if (!aggregationErrorType) {
        aggregationErrorType = createCustomError("AggregationError", function (self, args) {
            if (args[_DYN_LENGTH$5 /* @min:%2elength */] > 1) {
                // Save the provided errors
                self.errors = args[1];
            }
        });
    }
    var theMessage = message;
    arrForEach(sourceErrors, function (srcError, idx) {
        theMessage += "\n".concat(idx, " > ").concat(dumpObj(srcError));
    });
    throw new aggregationErrorType(theMessage, sourceErrors || []);
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Helper to coallesce the promise resolved / reject into a single callback to simplify error handling.
 * @group Await Helper
 * @param value - The value or promise like value to wait to be resolved or rejected.
 * @param cb - The callback function to call with the resulting value, if the value is not a
 * promise like value then the callback is called synchronously, if the value is a promise then
 * the callback will be called once the promise completes the resulting value will be passed as an
 * IAwaitResponse instance, it will be called whether any promise resolves or rejects.
 * @returns The value returned by the `cb` callback function, if the value is a promise then the return value
 * of the callback will be returned as a promise whether the callback returns a promise or not.
 * @example
 * ```ts
 * let promise = createPromise<number>((resolve, reject) => {
 *     resolve(42);
 * });
 *
 * // Handle via doAwaitResponse
 * doAwaitResponse(promise, (value) => {
 *     if (!value.rejected) {
 *          // Do something with the value
 *     } else {
 *         // Do something with the reason
 *     }
 * });
 *
 * // It can also handle the raw value, so you could process the result of either a
 * // synchrounous return of the value or a Promise
 * doAwaitResponse(42, (value) => {
 *     if (!value.rejected) {
 *         // Do something with the value
 *     } else {
 *        // This will never be true as the value is not a promise
 *     }
 * });
 * ```
 */
function doAwaitResponse(value, cb) {
    return doAwait(value, function (value) {
        return cb ? cb({
            value: value,
            rejected: false
        }) : value;
    }, function (reason) {
        return cb ? cb({
            rejected: true,
            reason: reason
        }) : reason;
    });
}
/**
 * Wait for the promise to resolve or reject, if resolved the callback function will be called with it's value and if
 * rejected the rejectFn will be called with the reason. If the passed promise argument is not a promise the callback
 * will be called synchronously with the value.
 * @group Await Helper
 * @param value - The value or promise like value to wait for
 * @param resolveFn - The callback to call on the promise successful resolving.
 * @param rejectFn - The callback to call when the promise rejects
 * @returns The passed value, if it is a promise and there is either a resolve or reject handler
 * then it will return a chained promise with the value from the resolve or reject handler (depending
 * whether it resolve or rejects)
 * @example
 * ```ts
 * let promise = createPromise<number>((resolve, reject) => {
 *     resolve(42);
 * });
 *
 * // Handle via a chained promise
 * let chainedPromise = promise.then((value) => {
 *     // Do something with the value
 * });
 *
 * // Handle via doAwait
 * doAwait(promise, (value) => {
 *     // Do something with the value
 * });
 *
 * // It can also handle the raw value, so you could process the result of either a
 * // synchrounous return of the value or a Promise
 * doAwait(42, (value) => {
 *     // Do something with the value
 * });
 * ```
 */
function doAwait(value, resolveFn, rejectFn, finallyFn) {
    var result = value;
    if (isPromiseLike(value)) {
        if (resolveFn || rejectFn) {
            result = value.then(resolveFn, rejectFn);
        }
    }
    else {
        if (resolveFn) {
            result = resolveFn(value);
        }
    }
    return result;
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore -- Don't include in the generated documentation
 * @internal
 */
var STRING_STATES = [
    "pending", "resolving", "resolved", "rejected"
];

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var DISPATCH_EVENT = "dispatchEvent";
var _hasInitEvent;
/**
 * @internal
 * @ignore
 * @param target
 * @param evtName
 * @param populateEvent
 * @param useNewEvent
 */
function emitEvent(target, evtName, populateEvent, useNewEvent) {
    var doc = getDocument();
    !_hasInitEvent && (_hasInitEvent = safeGetLazy(function () {
        var evt;
        if (doc && doc.createEvent) {
            evt = doc.createEvent("Event");
        }
        return (!!evt && evt.initEvent);
    }, null));
    var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : (useNewEvent ? new Event(evtName) : {});
    populateEvent(theEvt);
    if (_hasInitEvent.v) {
        theEvt.initEvent(evtName, false, true);
    }
    if (theEvt && target[DISPATCH_EVENT]) {
        target[DISPATCH_EVENT](theEvt);
    }
    else {
        var handler = target["on" + evtName];
        if (handler) {
            handler(theEvt);
        }
        else {
            var theConsole = getInst("console");
            theConsole && (theConsole["error"] || theConsole["log"])(evtName, dumpObj(theEvt));
        }
    }
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
var STR_PROMISE = "Promise";

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var NODE_UNHANDLED_REJECTION = "unhandledRejection";
var UNHANDLED_REJECTION = NODE_UNHANDLED_REJECTION.toLowerCase();
var _currentPromiseId = [];
var _uniquePromiseId = 0;
var _unhandledRejectionTimeout = 10;
var _hasPromiseRejectionEvent;
function dumpFnObj(value) {
    if (isFunction$3(value)) {
        return value.toString();
    }
    return dumpObj(value);
}
function _createPromise(newPromise, processor, executor) {
    var additionalArgs = arrSlice(arguments, 3);
    var _state = 0 /* ePromiseState.Pending */;
    var _hasResolved = false;
    var _settledValue;
    var _queue = [];
    var _id = _uniquePromiseId++;
    var _handled = false;
    var _unHandledRejectionHandler = null;
    var _thePromise;
    !_hasPromiseRejectionEvent && (_hasPromiseRejectionEvent = lazySafeGetInst(STR_PROMISE + "RejectionEvent"));
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    var _then = function (onResolved, onRejected) {
        try {
            _currentPromiseId.push(_id);
            _handled = true;
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "then(" + dumpFnObj(onResolved)+ ", " + dumpFnObj(onResolved) +  ")");
            //#endif
            var thenPromise = newPromise(function (resolve, reject) {
                // Queue the new promise returned to be resolved or rejected
                // when this promise settles.
                _queue.push(function () {
                    // https://tc39.es/ecma262/#sec-newpromisereactionjob
                    //let value: any;
                    try {
                        // First call the onFulfilled or onRejected handler, on the settled value
                        // of this promise. If the corresponding `handler` does not exist, simply
                        // pass through the settled value.
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling settled value " + dumpFnObj(_settledValue));
                        //#endif
                        var handler = _state === 2 /* ePromiseState.Resolved */ ? onResolved : onRejected;
                        var value = isUndefined$2(handler) ? _settledValue : (isFunction$3(handler) ? handler(_settledValue) : handler);
                        //#ifdef DEBUG
                        //#:(!DEBUG) _debugLog(_toString(), "Handling Result " + dumpFnObj(value));
                        //#endif
                        if (isPromiseLike(value)) {
                            // The called handlers returned a new promise, so the chained promise
                            // will follow the state of this promise.
                            value.then(resolve, reject);
                        }
                        else if (handler) {
                            // If we have a handler then chained promises are always "resolved" with the result returned
                            resolve(value);
                        }
                        else if (_state === 3 /* ePromiseState.Rejected */) {
                            // If this promise is rejected then the chained promise should be rejected
                            // with either the settled value of this promise or the return value of the handler.
                            reject(value);
                        }
                        else {
                            // If this promise is fulfilled, then the chained promise is also fulfilled
                            // with either the settled value of this promise or the return value of the handler.
                            resolve(value);
                        }
                    }
                    catch (e) {
                        reject(e);
                    }
                });
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Added to Queue " + _queue.length);
                //#endif
                // If this promise is already settled, then immediately process the callback we
                // just added to the queue.
                if (_hasResolved) {
                    _processQueue();
                }
            }, additionalArgs);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Created -> " + thenPromise.toString());
            //#endif
            return thenPromise;
        }
        finally {
            _currentPromiseId.pop();
        }
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    var _catch = function (onRejected) {
        // Reuse then onRejected to support rejection
        return _then(undefined, onRejected);
    };
    // https://tc39.es/ecma262/#sec-promise.prototype.finally
    var _finally = function (onFinally) {
        var thenFinally = onFinally;
        var catchFinally = onFinally;
        if (isFunction$3(onFinally)) {
            thenFinally = function (value) {
                onFinally && onFinally();
                return value;
            };
            catchFinally = function (reason) {
                onFinally && onFinally();
                throw reason;
            };
        }
        return _then(thenFinally, catchFinally);
    };
    var _strState = function () {
        return STRING_STATES[_state];
    };
    var _processQueue = function () {
        if (_queue.length > 0) {
            // The onFulfilled and onRejected handlers must be called asynchronously. Thus,
            // we make a copy of the queue and work on it once the current call stack unwinds.
            var pending = _queue.slice();
            _queue = [];
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing queue " + pending.length);
            //#endif
            _handled = true;
            processor(pending);
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Processing done");
            //#endif
            _unHandledRejectionHandler && _unHandledRejectionHandler.cancel();
            _unHandledRejectionHandler = null;
        }
    };
    var _createSettleIfFn = function (newState, allowState) {
        return function (theValue) {
            if (_state === allowState) {
                if (newState === 2 /* ePromiseState.Resolved */ && isPromiseLike(theValue)) {
                    _state = 1 /* ePromiseState.Resolving */;
                    //#ifdef DEBUG
                    //#:(!DEBUG) _debugLog(_toString(), "Resolving");
                    //#endif
                    theValue.then(_createSettleIfFn(2 /* ePromiseState.Resolved */, 1 /* ePromiseState.Resolving */), _createSettleIfFn(3 /* ePromiseState.Rejected */, 1 /* ePromiseState.Resolving */));
                    return;
                }
                _state = newState;
                _hasResolved = true;
                _settledValue = theValue;
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), _strState());
                //#endif
                _processQueue();
                if (!_handled && newState === 3 /* ePromiseState.Rejected */ && !_unHandledRejectionHandler) {
                    _unHandledRejectionHandler = scheduleTimeout(_notifyUnhandledRejection, _unhandledRejectionTimeout);
                }
            }
        };
    };
    var _notifyUnhandledRejection = function () {
        if (!_handled) {
            if (isNode()) {
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + NODE_UNHANDLED_REJECTION);
                //#endif
                process.emit(NODE_UNHANDLED_REJECTION, _settledValue, _thePromise);
            }
            else {
                var gbl = getWindow() || getGlobal();
                //#ifdef DEBUG
                //#:(!DEBUG) _debugLog(_toString(), "Emitting " + UNHANDLED_REJECTION);
                //#endif
                emitEvent(gbl, UNHANDLED_REJECTION, function (theEvt) {
                    objDefine(theEvt, "promise", { g: function () { return _thePromise; } });
                    theEvt.reason = _settledValue;
                    return theEvt;
                }, !!_hasPromiseRejectionEvent.v);
            }
        }
    };
    _thePromise = {
        then: _then,
        "catch": _catch,
        finally: _finally
    };
    objDefineProp(_thePromise, "state", {
        get: _strState
    });
    if (hasSymbol$1()) {
        _thePromise[getKnownSymbol(11 /* WellKnownSymbols.toStringTag */)] = "IPromise";
    }
    var _toString = function () {
        return "IPromise" + ("") + " " + _strState() + (_hasResolved ? (" - " + dumpFnObj(_settledValue)) : "");
    };
    _thePromise.toString = _toString;
    (function _initialize() {
        if (!isFunction$3(executor)) {
            throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpFnObj(executor));
        }
        var _rejectFn = _createSettleIfFn(3 /* ePromiseState.Rejected */, 0 /* ePromiseState.Pending */);
        try {
            //#ifdef DEBUG
            //#:(!DEBUG) _debugLog(_toString(), "Executing");
            //#endif
            executor.call(_thePromise, _createSettleIfFn(2 /* ePromiseState.Resolved */, 0 /* ePromiseState.Pending */), _rejectFn);
        }
        catch (e) {
            _rejectFn(e);
        }
    })();
    //#ifdef DEBUG
    //#:(!DEBUG) _debugLog(_toString(), "Returning");
    //#endif
    return _thePromise;
}
/**
 * @ignore
 * @internal
 * Returns a function which when called will return a new Promise object that resolves to an array of the
 * results from the input promises. The returned promise will resolve when all of the inputs' promises have
 * resolved, or if the input contains no promises. It rejects immediately upon any of the input promises
 * rejected or non-promises throwing an error, and will reject with this first rejection message / error.
 * @param newPromise - The delegate function used to create a new promise object the new promise instance.
 * @returns A function to create a promise that will be resolved when all arguments are resolved.
 */
function _createAllPromise(newPromise) {
    return function (input) {
        var additionalArgs = arrSlice(arguments, 1);
        return newPromise(function (resolve, reject) {
            try {
                var values_1 = [];
                var pending_1 = 1; // Prefix to 1 so we finish iterating over all of the input promises first
                arrForEach(input, function (item, idx) {
                    if (item) {
                        pending_1++;
                        doAwait(item, function (value) {
                            // Set the result values
                            values_1[idx] = value;
                            if (--pending_1 === 0) {
                                resolve(values_1);
                            }
                        }, reject);
                    }
                });
                // Now decrement the pending so that we finish correctly
                pending_1--;
                if (pending_1 === 0) {
                    // All promises were either resolved or where not a promise
                    resolve(values_1);
                }
            }
            catch (e) {
                reject(e);
            }
        }, additionalArgs);
    };
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _processPendingItems = function (pending) {
    arrForEach(pending, function (fn) {
        try {
            fn();
        }
        catch (e) {
            // Don't let 1 failing handler break all others
            // TODO: Add some form of error reporting (i.e. Call any registered JS error handler so the error is reported)
        }
    });
};
/**
 * @internal
 * @ignore
 * Return an item processor that processes all of the pending items asynchronously using the optional timeout.
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 * @return An item processor
 */
function timeoutItemProcessor(timeout) {
    var callbackTimeout = isNumber$3(timeout) ? timeout : 0;
    return function (pending) {
        scheduleTimeout(function () {
            _processPendingItems(pending);
        }, callbackTimeout);
    };
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * Creates an asynchronous Promise instance that when resolved or rejected will execute it's pending chained operations
 * __asynchronously__ using the optional provided timeout value to schedule when the chained items will be ececuted.
 * @group Async
 * @group Promise
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 */
function createAsyncPromise(executor, timeout) {
    return _createPromise(createAsyncPromise, timeoutItemProcessor(timeout), executor, timeout);
}

/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
var _isPromiseSupported;
/**
 * Creates a Promise instance that when resolved or rejected will execute it's pending chained operations using the
 * available native Promise implementation.
 * If runtime does not support native `Promise` class (or no polyfill is available) this function will fallback to using
 * `createAsyncPromise` which will resolve them __asynchronously__ using the optional provided timeout value to
 * schedule when the chained items will be executed.
 * @group Alias
 * @group Promise
 * @group Native
 * @param executor - The function to be executed during the creation of the promise. Any errors thrown in the executor will
 * cause the promise to be rejected. The return value of the executor is always ignored
 * @param timeout - Optional timeout to wait before processing the items, defaults to zero.
 */
function createNativePromise(executor, timeout) {
    !_isPromiseSupported && (_isPromiseSupported = lazySafeGetInst(STR_PROMISE));
    var PrmCls = _isPromiseSupported.v;
    if (!PrmCls) {
        return createAsyncPromise(executor);
    }
    if (!isFunction$3(executor)) {
        throwTypeError(STR_PROMISE + ": executor is not a function - " + dumpObj(executor));
    }
    var _state = 0 /* ePromiseState.Pending */;
    function _strState() {
        return STRING_STATES[_state];
    }
    var thePromise = new PrmCls(function (resolve, reject) {
        function _resolve(value) {
            _state = 2 /* ePromiseState.Resolved */;
            resolve(value);
        }
        function _reject(reason) {
            _state = 3 /* ePromiseState.Rejected */;
            reject(reason);
        }
        executor(_resolve, _reject);
    });
    objDefineProp(thePromise, "state", {
        get: _strState
    });
    return thePromise;
}

var _promiseCreator;
function createPromise(executor, timeout) {
  !_promiseCreator && (_promiseCreator = getLazy(function() {
    return createNativePromise;
  }));
  return _promiseCreator.v.call(this, executor, timeout);
}
var createAllPromise = _createAllPromise(createPromise);

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
var UNDEFINED_VALUE$2 = undefined;
var STR_EMPTY$1 = "";
var STR_CHANNELS = "channels";
var STR_CORE = "core";
var STR_CREATE_PERF_MGR = "createPerfMgr";
var STR_DISABLED = "disabled";
var STR_EXTENSION_CONFIG = "extensionConfig";
var STR_EXTENSIONS = "extensions";
var STR_PROCESS_TELEMETRY = "processTelemetry";
var STR_PRIORITY = "priority";
var STR_EVENTS_SENT = "eventsSent";
var STR_EVENTS_DISCARDED = "eventsDiscarded";
var STR_EVENTS_SEND_REQUEST = "eventsSendRequest";
var STR_PERF_EVENT = "perfEvent";
var STR_OFFLINE_STORE = "offlineEventsStored";
var STR_OFFLINE_SENT = "offlineBatchSent";
var STR_OFFLINE_DROP = "offlineBatchDrop";
var STR_GET_PERF_MGR = "getPerfMgr";
var STR_DOMAIN = "domain";
var STR_PATH = "path";
var STR_NOT_DYNAMIC_ERROR = "Not dynamic - ";

var listenerFuncs = [STR_EVENTS_SENT, STR_EVENTS_DISCARDED, STR_EVENTS_SEND_REQUEST, STR_PERF_EVENT];
var _aiNamespace = null;
var _debugListener;
function _listenerProxyFunc(name, config) {
  return function() {
    var args = arguments;
    var dbgExt = getDebugExt(config);
    if (dbgExt) {
      var listener = dbgExt.listener;
      if (listener && listener[name]) {
        listener[name][
          _DYN_APPLY
          /* @min:%2eapply */
        ](listener, args);
      }
    }
  };
}
function _getExtensionNamespace() {
  var target = getInst("Microsoft");
  if (target) {
    _aiNamespace = target["ApplicationInsights"];
  }
  return _aiNamespace;
}
function getDebugExt(config) {
  var ns = _aiNamespace;
  if (!ns && config.disableDbgExt !== true) {
    ns = _aiNamespace || _getExtensionNamespace();
  }
  return ns ? ns["ChromeDbgExt"] : null;
}
function getDebugListener(config) {
  if (!_debugListener) {
    _debugListener = {};
    for (var lp = 0; lp < listenerFuncs[
      _DYN_LENGTH$5
      /* @min:%2elength */
    ]; lp++) {
      _debugListener[listenerFuncs[lp]] = _listenerProxyFunc(listenerFuncs[lp], config);
    }
  }
  return _debugListener;
}

var strDocumentMode = "documentMode";
var strLocation = "location";
var strConsole = "console";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var strXMLHttpRequest = "XMLHttpRequest";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
var _useXDomainRequest = null;
var _beaconsSupported = null;
function _hasProperty(theClass, property) {
  var supported = false;
  if (theClass) {
    try {
      supported = property in theClass;
      if (!supported) {
        var proto = theClass[strShimPrototype];
        if (proto) {
          supported = property in proto;
        }
      }
    } catch (e) {
    }
    if (!supported) {
      try {
        var tmp = new theClass();
        supported = !isUndefined$2(tmp[property]);
      } catch (e) {
      }
    }
  }
  return supported;
}
function getLocation$1(checkForMock) {
  if (checkForMock && _enableMocks) {
    var mockLocation = getInst("__mockLocation");
    if (mockLocation) {
      return mockLocation;
    }
  }
  if (typeof location === strShimObject && location) {
    return location;
  }
  return getInst(strLocation);
}
function getConsole() {
  if (typeof console !== strShimUndefined) {
    return console;
  }
  return getInst(strConsole);
}
function hasJSON() {
  return Boolean(typeof JSON === strShimObject && JSON || getInst(strJSON) !== null);
}
function getJSON() {
  if (hasJSON()) {
    return JSON || getInst(strJSON);
  }
  return null;
}
function getCrypto() {
  return getInst(strCrypto);
}
function getMsCrypto() {
  return getInst(strMsCrypto);
}
function isReactNative() {
  var nav = getNavigator();
  if (nav && nav.product) {
    return nav.product === strReactNative;
  }
  return false;
}
function isIE() {
  var nav = getNavigator();
  if (nav && (nav[
    _DYN_USER_AGENT
    /* @min:%2euserAgent */
  ] !== _navUserAgentCheck || _isTrident === null)) {
    _navUserAgentCheck = nav[
      _DYN_USER_AGENT
      /* @min:%2euserAgent */
    ];
    var userAgent = (_navUserAgentCheck || STR_EMPTY$1)[
      _DYN_TO_LOWER_CASE$2
      /* @min:%2etoLowerCase */
    ]();
    _isTrident = strContains(userAgent, strMsie) || strContains(userAgent, strTrident);
  }
  return _isTrident;
}
function getIEVersion(userAgentStr) {
  if (userAgentStr === undefined) {
    userAgentStr = null;
  }
  if (!userAgentStr) {
    var navigator_1 = getNavigator() || {};
    userAgentStr = navigator_1 ? (navigator_1.userAgent || STR_EMPTY$1)[
      _DYN_TO_LOWER_CASE$2
      /* @min:%2etoLowerCase */
    ]() : STR_EMPTY$1;
  }
  var ua = (userAgentStr || STR_EMPTY$1)[
    _DYN_TO_LOWER_CASE$2
    /* @min:%2etoLowerCase */
  ]();
  if (strContains(ua, strMsie)) {
    var doc = getDocument() || {};
    return Math.max(parseInt(ua[
      _DYN_SPLIT$1
      /* @min:%2esplit */
    ](strMsie)[1]), doc[strDocumentMode] || 0);
  } else if (strContains(ua, strTrident)) {
    var tridentVer = parseInt(ua[
      _DYN_SPLIT$1
      /* @min:%2esplit */
    ](strTrident)[1]);
    if (tridentVer) {
      return tridentVer + 4;
    }
  }
  return null;
}
function isBeaconsSupported(useCached) {
  if (_beaconsSupported === null || useCached === false) {
    _beaconsSupported = hasNavigator() && Boolean(getNavigator().sendBeacon);
  }
  return _beaconsSupported;
}
function isFetchSupported$1(withKeepAlive) {
  var isSupported = false;
  try {
    isSupported = !!getInst("fetch");
    var request = getInst("Request");
    if (isSupported && withKeepAlive && request) {
      isSupported = _hasProperty(request, "keepalive");
    }
  } catch (e) {
  }
  return isSupported;
}
function useXDomainRequest() {
  if (_useXDomainRequest === null) {
    _useXDomainRequest = typeof XDomainRequest !== strShimUndefined;
    if (_useXDomainRequest && isXhrSupported()) {
      _useXDomainRequest = _useXDomainRequest && !_hasProperty(getInst(strXMLHttpRequest), "withCredentials");
    }
  }
  return _useXDomainRequest;
}
function isXhrSupported() {
  var isSupported = false;
  try {
    var xmlHttpRequest = getInst(strXMLHttpRequest);
    isSupported = !!xmlHttpRequest;
  } catch (e) {
  }
  return isSupported;
}
function dispatchEvent(target, evnt) {
  if (target && target.dispatchEvent && evnt) {
    target.dispatchEvent(evnt);
    return true;
  }
  return false;
}
function createCustomDomEvent(eventName, details) {
  var event = null;
  var detail = { detail: details || null };
  if (isFunction$3(CustomEvent)) {
    event = new CustomEvent(eventName, detail);
  } else {
    var doc = getDocument();
    if (doc && doc.createEvent) {
      event = doc.createEvent("CustomEvent");
      event.initCustomEvent(eventName, true, true, detail);
    }
  }
  return event;
}
function sendCustomEvent(evtName, cfg, customDetails) {
  var global = getGlobal();
  if (global && global.CustomEvent) {
    try {
      var details = { cfg: cfg || null, customDetails: customDetails || null };
      return dispatchEvent(global, createCustomDomEvent(evtName, details));
    } catch (e) {
    }
  }
  return false;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$a;
var STR_WARN_TO_CONSOLE = "warnToConsole";
/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
var defaultValues$3 = {
    loggingLevelConsole: 0,
    loggingLevelTelemetry: 1,
    maxMessageLimit: 25,
    enableDebug: false
};
var _logFuncs = (_a$a = {},
    _a$a[0 /* eLoggingSeverity.DISABLED */] = null,
    _a$a[1 /* eLoggingSeverity.CRITICAL */] = "errorToConsole",
    _a$a[2 /* eLoggingSeverity.WARNING */] = STR_WARN_TO_CONSOLE,
    _a$a[3 /* eLoggingSeverity.DEBUG */] = "debugToConsole",
    _a$a);
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text[_DYN_REPLACE /* @min:%2ereplace */](/\"/g, STR_EMPTY$1) + "\"";
    }
    return STR_EMPTY$1;
}
function _logToConsole(func, message) {
    var theConsole = getConsole();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) {
            logFunc = func;
        }
        if (isFunction$3(theConsole[logFunc])) {
            theConsole[logFunc](message);
        }
    }
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === undefined) { isUserAct = false; }
        var _self = this;
        _self[_DYN_MESSAGE_ID /* @min:%2emessageId */] = msgId;
        _self[_DYN_MESSAGE$2 /* @min:%2emessage */] =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = STR_EMPTY$1;
        if (hasJSON()) {
            strProps = getJSON().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : STR_EMPTY$1) +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : STR_EMPTY$1);
        _self[_DYN_MESSAGE$2 /* @min:%2emessage */] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());
function safeGetLogger(core, config) {
    return (core || {})[_DYN_LOGGER /* @min:%2elogger */] || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        var _unloadHandler;
        dynamicProto(DiagnosticLogger, this, function (_self) {
            _unloadHandler = _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function () { return _loggingLevelConsole; };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {LoggingSeverity} - The severity of the log message
             * @param message - {_InternalLogMessage} - The log message.
             */
            _self[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */] = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === undefined) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_enableDebug) {
                    throw dumpObj(message);
                }
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = _logFuncs[severity] || STR_WARN_TO_CONSOLE;
                    if (!isUndefined$2(message[_DYN_MESSAGE$2 /* @min:%2emessage */])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // Only log traces if the console Logging Level is >= the throwInternal severity level
                            if (_loggingLevelConsole >= severity) {
                                _self[logFunc](message[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                            }
                        }
                        _logInternalMessage(severity, message);
                    }
                    else {
                        _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */ ? "Critical" : "Warning"), message);
                    }
                }
            };
            _self.debugToConsole = function (message) {
                _logToConsole("debug", message);
                _debugExtMsg("warning", message);
            };
            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */] = function (message) {
                _logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            _self.errorToConsole = function (message) {
                _logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            _self[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */] = _logInternalMessage;
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                _unloadHandler && _unloadHandler.rm();
                _unloadHandler = null;
            };
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message[_DYN_MESSAGE_ID /* @min:%2emessageId */];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[_DYN_PUSH$2 /* @min:%2epush */](message);
                        _messageCount++;
                        _debugExtMsg((severity === 1 /* eLoggingSeverity.CRITICAL */ ? "error" : "warn"), message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */, throttleLimitMessage, false);
                        _self.queue[_DYN_PUSH$2 /* @min:%2epush */](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */) {
                            _self.errorToConsole(throttleLimitMessage);
                        }
                        else {
                            _self[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](throttleLimitMessage);
                        }
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                // make sure the config is dynamic
                return onConfigChange(createDynamicConfig(config, defaultValues$3, _self).cfg, function (details) {
                    var config = details.cfg;
                    _loggingLevelConsole = config[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */];
                    _loggingLevelTelemetry = config.loggingLevelTelemetry;
                    _maxInternalMessageLimit = config.maxMessageLimit;
                    _enableDebug = config.enableDebug;
                });
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = getDebugExt(config || {});
                if (dbgExt && dbgExt[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]) {
                    dbgExt[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](name, data);
                }
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.debugToConsole.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.errorToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
// Removed Stub for DiagnosticLogger.prototype.unload.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    DiagnosticLogger.__ieDyn=1;

    return DiagnosticLogger;
}());
function _getLogger(logger) {
    return (logger || new DiagnosticLogger());
}
/**
 * This is a helper method which will call throwInternal on the passed logger, will throw exceptions in
 * debug mode or attempt to log the error as a console warning. This helper is provided mostly to better
 * support minification as logger.throwInternal() will not compress the publish "throwInternal" used throughout
 * the code.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - {LoggingSeverity} - The severity of the log message
 * @param message - {_InternalLogMessage} - The log message.
 */
function _throwInternal(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === undefined) { isUserAct = false; }
    _getLogger(logger)[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](severity, msgId, msg, properties, isUserAct);
}
/**
 * This is a helper method which will call warnToConsole on the passed logger with the provided message.
 * @param logger - The Diagnostic Logger instance to use.
 * @param message - {_InternalLogMessage} - The log message.
 */
function _warnToConsole(logger, message) {
    _getLogger(logger)[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
}
/**
 * Logs a message to the internal queue.
 * @param logger - The Diagnostic Logger instance to use.
 * @param severity - {LoggingSeverity} - The severity of the log message
 * @param message - {_InternalLogMessage} - The message to log.
 */
function _logInternalMessage(logger, severity, message) {
    _getLogger(logger)[_DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */](severity, message);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minification
var strGetPrototypeOf = "getPrototypeOf";
var rCamelCase = /-([a-z])/g;
var rNormalizeInvalid = /([^\w\d_$])/g;
var rLeadingNumeric = /^(\d+[\w\d_$])/;
var _getObjProto = Object[strGetPrototypeOf];
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name - The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    if (value && isString$2(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rCamelCase, function (_all, letter) {
            return letter.toUpperCase();
        });
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rNormalizeInvalid, "_");
        value = value[_DYN_REPLACE /* @min:%2ereplace */](rLeadingNumeric, function (_all, match) {
            return "_" + match;
        });
    }
    return value;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return strIndexOf(value, search) !== -1;
    }
    return false;
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString$2(date) {
    return date && date.toISOString() || "";
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError$2(object)) {
        return object[_DYN_NAME$3 /* @min:%2ename */];
    }
    return STR_EMPTY$1;
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined$2(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined$2(defValue) ? defValue : {};
    }
    return theValue;
}
function _createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if (isFunction$3(source)) {
        srcFunc = source;
    }
    else {
        src = source;
    }
    return function () {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) {
            src = srcFunc();
        }
        if (src) {
            return src[funcName][_DYN_APPLY /* @min:%2eapply */](src, originalArguments);
        }
    };
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && isObject$6(target) && isObject$6(source)) {
        var _loop_1 = function (field) {
            if (isString$2(field)) {
                var value = source[field];
                if (isFunction$3(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = _createProxyFunction(source, field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (objHasOwn(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    objDefine(target, field, {
                        g: function () {
                            return source[field];
                        },
                        s: function (theValue) {
                            source[field] = theValue;
                        }
                    });
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Creates a proxy function on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param name - The function name that will be added on the target
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param theFunc - The function name on the source that will be proxied on the target
 * @param overwriteTarget - If `false` this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctionAs(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        {
            target[name] = _createProxyFunction(source, theFunc);
        }
    }
}
/**
 * Creates proxy functions on the target which internally will call the source version with all arguments passed to the target method.
 *
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param functionsToProxy - An array of function names that will be proxied on the target
 * @param overwriteTarget - If false this will not replace any pre-existing name otherwise (the default) it will overwrite any existing name
 */
function proxyFunctions(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && isObject$6(target) && isArray$3(functionsToProxy)) {
        arrForEach(functionsToProxy, function (theFuncName) {
            if (isString$2(theFuncName)) {
                proxyFunctionAs(target, theFuncName, source, theFuncName);
            }
        });
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults - Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && objAssign) {
        theObject = ObjClass(objAssign({}, theObject));
    }
    return theObject;
}
function objExtend(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[_DYN_LENGTH$5 /* @min:%2elength */];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && isBoolean$2(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!isObject$6(extended)) {
        extended = {};
    }
    // Loop through each remaining object and conduct a merge
    for (; idx < argLen; idx++) {
        var arg = theArgs[idx];
        var isArgArray = isArray$3(arg);
        var isArgObj = isObject$6(arg);
        for (var prop in arg) {
            var propOk = (isArgArray && (prop in arg)) || (isArgObj && objHasOwn(arg, prop));
            if (!propOk) {
                continue;
            }
            var newValue = arg[prop];
            var isNewArray = undefined;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = isArray$3(newValue)) || isPlainObject$6(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!isArray$3(clone)) {
                        // We can't "merge" an array with a non-array so overwrite the original
                        clone = [];
                    }
                }
                else if (!isPlainObject$6(clone)) {
                    // We can't "merge" an object with a non-object
                    clone = {};
                }
                // Never move the original objects always clone them
                newValue = objExtend(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) {
                extended[prop] = newValue;
            }
        }
    }
    return extended;
}
function isFeatureEnabled(feature, cfg) {
    var rlt = false;
    var ft = cfg && cfg.featureOptIn && cfg.featureOptIn[feature];
    if (feature && ft) {
        var mode = ft.mode;
        // NOTE: None will be considered as true
        rlt = (mode == 3 /* FeatureOptInMode.enable */) || (mode == 1 /* FeatureOptInMode.none */);
    }
    return rlt;
}
function getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function formatErrorMessageXdr(xdr, message) {
    if (xdr) {
        return "XDomainRequest,Response:" + getResponseText(xdr) || "";
    }
    return message;
}
function formatErrorMessageXhr(xhr, message) {
    if (xhr) {
        return "XMLHttpRequest,Status:" + xhr[_DYN_STATUS$1 /* @min:%2estatus */] + ",Response:" + getResponseText(xhr) || xhr.response || "";
    }
    return message;
}
function prependTransports(theTransports, newTransports) {
    if (newTransports) {
        if (isNumber$3(newTransports)) {
            theTransports = [newTransports].concat(theTransports);
        }
        else if (isArray$3(newTransports)) {
            theTransports = newTransports.concat(theTransports);
        }
    }
    return theTransports;
}
/**
 * Parses the response from the backend.
 * @param response - XMLHttpRequest or XDomainRequest response
 */
function parseResponse(response, diagLog) {
    try {
        if (response && response !== "") {
            var result = getJSON().parse(response);
            if (result && result[_DYN_ITEMS_RECEIVED$1 /* @min:%2eitemsReceived */] && result[_DYN_ITEMS_RECEIVED$1 /* @min:%2eitemsReceived */] >= result.itemsAccepted &&
                result.itemsReceived - result.itemsAccepted === result.errors[_DYN_LENGTH$5 /* @min:%2elength */]) {
                return result;
            }
        }
    }
    catch (e) {
        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 43 /* _eInternalMessageId.InvalidBackendResponse */, "Cannot parse the response. " + getExceptionName(e), {
            response: response
        });
    }
    return null;
}
var strDisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var strWithCredentials = "withCredentials";
var strTimeout = "timeout";
/**
 * Create and open an XMLHttpRequest object
 * @param method - The request method
 * @param urlString - The url
 * @param withCredentials - Option flag indicating that credentials should be sent
 * @param disabled - Optional flag indicating that the XHR object should be marked as disabled and not tracked (default is false)
 * @param isSync - Optional flag indicating if the instance should be a synchronous request (defaults to false)
 * @param timeout - Optional value identifying the timeout value that should be assigned to the XHR request
 * @returns A new opened XHR request
 */
function openXhr(method, urlString, withCredentials, disabled, isSync, timeout) {
    if (isSync === undefined) { isSync = false; }
    function _wrapSetXhrProp(xhr, prop, value) {
        try {
            xhr[prop] = value;
        }
        catch (e) {
            // - Wrapping as depending on the environment setting the property may fail (non-terminally)
        }
    }
    var xhr = new XMLHttpRequest();
    {
        // Tag the instance so it's not tracked (trackDependency)
        // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
        // cause the request to fail and we no telemetry would be sent
        _wrapSetXhrProp(xhr, strDisabledPropertyName, disabled);
    }
    if (withCredentials) {
        // Some libraries require that the withCredentials flag is set "before" open and
        // - Wrapping as IE 10 has started throwing when setting before open
        _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
    }
    xhr.open(method, urlString, !isSync);
    if (withCredentials) {
        // withCredentials should be set AFTER open (https://xhr.spec.whatwg.org/#the-withcredentials-attribute)
        // And older firefox instances from 11+ will throw for sync events (current versions don't) which happens during unload processing
        _wrapSetXhrProp(xhr, strWithCredentials, withCredentials);
    }
    // Only set the timeout for asynchronous requests as
    // "Timeout shouldn't be used for synchronous XMLHttpRequests requests used in a document environment or it will throw an InvalidAccessError exception.""
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/timeout
    if (!isSync && timeout) {
        _wrapSetXhrProp(xhr, strTimeout, timeout);
    }
    return xhr;
}
/**
* Converts the XHR getAllResponseHeaders to a map containing the header key and value.
* @internal
*/
// tslint:disable-next-line: align
function convertAllHeadersToMap(headersString) {
    var headers = {};
    if (isString$2(headersString)) {
        var headersArray = strTrim(headersString)[_DYN_SPLIT$1 /* @min:%2esplit */](/[\r\n]+/);
        arrForEach(headersArray, function (headerEntry) {
            if (headerEntry) {
                var idx = headerEntry.indexOf(": ");
                if (idx !== -1) {
                    // The new spec has the headers returning all as lowercase -- but not all browsers do this yet
                    var header = strTrim(headerEntry.substring(0, idx))[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]();
                    var value = strTrim(headerEntry.substring(idx + 1));
                    headers[header] = value;
                }
                else {
                    headers[strTrim(headerEntry)] = 1;
                }
            }
        });
    }
    return headers;
}
/**
* append the XHR headers.
* @internal
*/
function _appendHeader(theHeaders, xhr, name) {
    if (!theHeaders[name] && xhr && xhr[_DYN_GET_RESPONSE_HEADER /* @min:%2egetResponseHeader */]) {
        var value = xhr[_DYN_GET_RESPONSE_HEADER /* @min:%2egetResponseHeader */](name);
        if (value) {
            theHeaders[name] = strTrim(value);
        }
    }
    return theHeaders;
}
var STR_KILL_DURATION_HEADER = "kill-duration";
var STR_KILL_DURATION_SECONDS_HEADER = "kill-duration-seconds";
var STR_TIME_DELTA_HEADER = "time-delta-millis";
/**
* get the XHR getAllResponseHeaders.
* @internal
*/
function _getAllResponseHeaders(xhr, isOneDs) {
    var theHeaders = {};
    if (!xhr[_DYN_GET_ALL_RESPONSE_HEA5 /* @min:%2egetAllResponseHeaders */]) {
        // Firefox 2-63 doesn't have getAllResponseHeaders function but it does have getResponseHeader
        // Only call these if getAllResponseHeaders doesn't exist, otherwise we can get invalid response errors
        // as collector is not currently returning the correct header to allow JS to access these headers
        if (!!isOneDs) {
            theHeaders = _appendHeader(theHeaders, xhr, STR_TIME_DELTA_HEADER);
            theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_HEADER);
            theHeaders = _appendHeader(theHeaders, xhr, STR_KILL_DURATION_SECONDS_HEADER);
        }
    }
    else {
        theHeaders = convertAllHeadersToMap(xhr[_DYN_GET_ALL_RESPONSE_HEA5 /* @min:%2egetAllResponseHeaders */]());
    }
    return theHeaders;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
var SEED1 = 123456789;
var SEED2 = 987654321;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = SEED1;
var _mwcZ = SEED2;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (SEED1 + seedValue) & MaxUInt32;
    _mwcZ = (SEED2 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = utcNow() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value = 0;
    var c = getCrypto() || getMsCrypto();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    if (value === 0 && isIE()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    if (value === 0) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === undefined) { maxLength = 22; }
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = random32() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = STR_EMPTY$1;
    while (result[_DYN_LENGTH$5 /* @min:%2elength */] < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var version = "3.0.5";
var instanceName = "." + newId(6);
var _dataUid = 0;
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function _canAcceptData(target) {
    return target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 1 || target[_DYN_NODE_TYPE /* @min:%2enodeType */] === 9 || !(+target[_DYN_NODE_TYPE /* @min:%2enodeType */]);
}
function _getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if (_canAcceptData(target)) {
                objDefine(target, data.id, {
                    e: false,
                    v: theCache
                });
            }
        }
        catch (e) {
            // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function createUniqueNamespace(name, includeVersion) {
    if (includeVersion === undefined) { includeVersion = false; }
    return normalizeJsName(name + (_dataUid++) + (includeVersion ? "." + version : STR_EMPTY$1) + instanceName);
}
function createElmNodeData(name) {
    var data = {
        id: createUniqueNamespace("_aiData-" + (name || STR_EMPTY$1) + "." + version),
        accept: function (target) {
            return _canAcceptData(target);
        },
        get: function (target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = _getCache(data, target);
                    theCache[normalizeJsName(name)] = defValue;
                }
                return defValue;
            }
            return theCache[normalizeJsName(name)];
        },
        kill: function (target, name) {
            if (target && target[name]) {
                try {
                    delete target[name];
                }
                catch (e) {
                    // Just cleaning up, so if this fails -- ignore
                }
            }
        }
    };
    return data;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function _isConfigDefaults(value) {
    return (value && isObject$6(value) && (value.isVal || value.fb || objHasOwn(value, "v") || objHasOwn(value, "mrg") || objHasOwn(value, "ref") || value.set));
}
function _getDefault(dynamicHandler, theConfig, cfgDefaults) {
    var defValue;
    var isDefaultValid = cfgDefaults.dfVal || isDefined;
    // There is a fallback config key so try and grab that first
    if (theConfig && cfgDefaults.fb) {
        var fallbacks = cfgDefaults.fb;
        if (!isArray$3(fallbacks)) {
            fallbacks = [fallbacks];
        }
        for (var lp = 0; lp < fallbacks[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            var fallback = fallbacks[lp];
            var fbValue = theConfig[fallback];
            if (isDefaultValid(fbValue)) {
                defValue = fbValue;
            }
            else if (dynamicHandler) {
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                fbValue = dynamicHandler.cfg[fallback];
                if (isDefaultValid(fbValue)) {
                    defValue = fbValue;
                }
                // Needed to ensure that the fallback value (and potentially) new field is also dynamic even if null/undefined
                dynamicHandler.set(dynamicHandler.cfg, asString(fallback), fbValue);
            }
            if (isDefaultValid(defValue)) {
                // We have a valid default so break out of the look
                break;
            }
        }
    }
    // If the value is still not defined and we have a default value then use that
    if (!isDefaultValid(defValue) && isDefaultValid(cfgDefaults.v)) {
        defValue = cfgDefaults.v;
    }
    return defValue;
}
/**
 * Recursively resolve the default value
 * @param dynamicHandler
 * @param theConfig
 * @param cfgDefaults
 * @returns
 */
function _resolveDefaultValue(dynamicHandler, theConfig, cfgDefaults) {
    var theValue = cfgDefaults;
    if (cfgDefaults && _isConfigDefaults(cfgDefaults)) {
        theValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    if (theValue) {
        if (_isConfigDefaults(theValue)) {
            theValue = _resolveDefaultValue(dynamicHandler, theConfig, theValue);
        }
        var newValue_1;
        if (isArray$3(theValue)) {
            newValue_1 = [];
            newValue_1[_DYN_LENGTH$5 /* @min:%2elength */] = theValue[_DYN_LENGTH$5 /* @min:%2elength */];
        }
        else if (isPlainObject$6(theValue)) {
            newValue_1 = {};
        }
        if (newValue_1) {
            objForEachKey(theValue, function (key, value) {
                if (value && _isConfigDefaults(value)) {
                    value = _resolveDefaultValue(dynamicHandler, theConfig, value);
                }
                newValue_1[key] = value;
            });
            theValue = newValue_1;
        }
    }
    return theValue;
}
/**
 * Applies the default value on the config property and makes sure that it's dynamic
 * @param theConfig
 * @param name
 * @param defaultValue
 */
function _applyDefaultValue(dynamicHandler, theConfig, name, defaultValue) {
    // Resolve the initial config value from the provided value or use the defined default
    var isValid;
    var setFn;
    var defValue;
    var cfgDefaults = defaultValue;
    var mergeDf;
    var reference;
    var readOnly;
    var blkDynamicValue;
    if (_isConfigDefaults(cfgDefaults)) {
        // looks like a IConfigDefault
        isValid = cfgDefaults.isVal;
        setFn = cfgDefaults.set;
        readOnly = cfgDefaults[_DYN_RD_ONLY /* @min:%2erdOnly */];
        blkDynamicValue = cfgDefaults[_DYN_BLK_VAL /* @min:%2eblkVal */];
        mergeDf = cfgDefaults.mrg;
        reference = cfgDefaults.ref;
        if (!reference && isUndefined$2(reference)) {
            reference = !!mergeDf;
        }
        defValue = _getDefault(dynamicHandler, theConfig, cfgDefaults);
    }
    else {
        defValue = defaultValue;
    }
    if (blkDynamicValue) {
        // Mark the property so that any value assigned will be blocked from conversion, we need to do this
        // before assigning or fetching the value to ensure it's not converted
        dynamicHandler[_DYN_BLK_VAL /* @min:%2eblkVal */](theConfig, name);
    }
    // Set the value to the default value;
    var theValue;
    var usingDefault = true;
    var cfgValue = theConfig[name];
    // try and get and user provided values
    if (cfgValue || !isNullOrUndefined(cfgValue)) {
        // Use the defined theConfig[name] value
        theValue = cfgValue;
        usingDefault = false;
        // The values are different and we have a special default value check, which is used to
        // override config values like empty strings to continue using the default
        if (isValid && theValue !== defValue && !isValid(theValue)) {
            theValue = defValue;
            usingDefault = true;
        }
        if (setFn) {
            theValue = setFn(theValue, defValue, theConfig);
            usingDefault = theValue === defValue;
        }
    }
    if (!usingDefault) {
        if (isPlainObject$6(theValue) || isArray$3(defValue)) {
            // we are using the user supplied value and it's an object
            if (mergeDf && defValue && (isPlainObject$6(defValue) || isArray$3(defValue))) {
                // Resolve/apply the defaults
                objForEachKey(defValue, function (dfName, dfValue) {
                    // Sets the value and makes it dynamic (if it doesn't already exist)
                    _applyDefaultValue(dynamicHandler, theValue, dfName, dfValue);
                });
            }
        }
    }
    else if (defValue) {
        // Just resolve the default
        theValue = _resolveDefaultValue(dynamicHandler, theConfig, defValue);
    }
    else {
        theValue = defValue;
    }
    // if (theValue && usingDefault && (isPlainObject(theValue) || isArray(theValue))) {
    //     theValue = _cfgDeepCopy(theValue);
    // }
    // Needed to ensure that the (potentially) new field is dynamic even if null/undefined
    dynamicHandler.set(theConfig, name, theValue);
    if (reference) {
        dynamicHandler.ref(theConfig, name);
    }
    if (readOnly) {
        dynamicHandler[_DYN_RD_ONLY /* @min:%2erdOnly */](theConfig, name);
    }
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// Using Symbol.for so that if the same symbol was already created it would be returned
// To handle multiple instances using potentially different versions we are not using
// createUniqueNamespace()
var CFG_HANDLER_LINK = symbolFor("[[ai_dynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects / arrays with if they should not be converted
 */
var BLOCK_DYNAMIC = symbolFor("[[ai_blkDynCfg_1]]");
/**
 * @internal
 * @ignore
 * The symbol to tag objects to indicate that when included into the configuration that
 * they should be converted into a trackable dynamic object.
 */
var FORCE_DYNAMIC = symbolFor("[[ai_frcDynCfg_1]]");
function _cfgDeepCopy(source) {
    if (source) {
        var target_1;
        if (isArray$3(source)) {
            target_1 = [];
            target_1[_DYN_LENGTH$5 /* @min:%2elength */] = source[_DYN_LENGTH$5 /* @min:%2elength */];
        }
        else if (isPlainObject$6(source)) {
            target_1 = {};
        }
        if (target_1) {
            // Copying index values by property name as the extensionConfig can be an array or object
            objForEachKey(source, function (key, value) {
                // Perform a deep copy of the object
                target_1[key] = _cfgDeepCopy(value);
            });
            return target_1;
        }
    }
    return source;
}
/**
 * @internal
 * Get the dynamic config handler if the value is already dynamic
 * @param value
 * @returns
 */
function getDynamicConfigHandler(value) {
    {
        var handler = value[CFG_HANDLER_LINK] || value;
        if (handler.cfg && (handler.cfg === value || handler.cfg[CFG_HANDLER_LINK] === handler)) {
            return handler;
        }
    }
    return null;
}
/**
 * Mark the provided value so that if it's included into the configuration it will NOT have
 * its properties converted into a dynamic (reactive) object. If the object is not a plain object
 * or an array (ie. a class) this function has not affect as only Objects and Arrays are converted
 * into dynamic objects in the dynamic configuration.
 *
 * When you have tagged a value as both {@link forceDynamicConversion} and blocked force will take precedence.
 *
 * You should only need to use this function, if you are creating dynamic "classes" from objects
 * which confirm to the require interface. A common case for this is during unit testing where it's
 * easier to create mock extensions.
 *
 * If `value` is falsy (null / undefined / 0 / empty string etc) it will not be tagged and
 * if there is an exception adding the property to the value (because its frozen etc) the
 * exception will be swallowed
 *
 * @example
 * ```ts
 * // This is a valid "extension", but it is technically an object
 * // So when included in the config.extensions it WILL be cloned and then
 * // converted into a dynamic object, where all of its properties will become
 * // get/set object properties and will be tracked. While this WILL still
 * // function, when attempt to use a mocking framework on top of this the
 * // functions are now technically get accessors which return a function
 * // and this can cause some mocking frameworks to fail.
 * let mockChannel = {
 *      pause: () => { },
*      resume: () => { },
*      teardown: () => { },
*      flush: (async: any, callBack: any) => { },
*      processTelemetry: (env: any) => { },
*      setNextPlugin: (next: any) => { },
*      initialize: (config: any, core: any, extensions: any) => { },
*      identifier: "testChannel",
*      priority: 1003
* };
 * ```
 * @param value - The object that you want to block from being converted into a
 * trackable dynamic object
 * @returns The original value
 */
function blockDynamicConversion(value) {
    if (value && (isPlainObject$6(value) || isArray$3(value))) {
        try {
            value[BLOCK_DYNAMIC] = true;
        }
        catch (e) {
            // Don't throw for this case as it's an ask only
        }
    }
    return value;
}
/**
 * @internal
 * @ignore
 * Helper function to check whether an object can or should be converted into a dynamic
 * object.
 * @param value - The object to check whether it should be converted
 * @returns `true` if the value should be converted otherwise `false`.
 */
function _canMakeDynamic(getFunc, state, value) {
    var result = false;
    // Object must exist and be truthy
    if (value && !getFunc[state.blkVal]) {
        // Tagged as always convert
        result = value[FORCE_DYNAMIC];
        // Check that it's not explicitly tagged as blocked
        if (!result && !value[BLOCK_DYNAMIC]) {
            // Only convert plain objects or arrays by default
            result = isPlainObject$6(value) || isArray$3(value);
        }
    }
    return result;
}
/**
 * Throws an invalid access exception
 * @param message - The message to include in the exception
 */
function throwInvalidAccess(message) {
    throwTypeError("InvalidAccess:" + message);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var arrayMethodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
];
var _throwDynamicError = function (logger, name, desc, e) {
    logger && logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](3 /* eLoggingSeverity.DEBUG */, 108 /* _eInternalMessageId.DynamicConfigException */, "".concat(desc, " [").concat(name, "] failed - ") + dumpObj(e));
};
function _patchArray(state, target, name) {
    if (isArray$3(target)) {
        // Monkey Patch the methods that might change the array
        arrForEach(arrayMethodsToPatch, function (method) {
            var orgMethod = target[method];
            target[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result = orgMethod[_DYN_APPLY /* @min:%2eapply */](this, args);
                // items may be added, removed or moved so need to make some new dynamic properties
                _makeDynamicObject(state, target, name, "Patching");
                return result;
            };
        });
    }
}
function _getOwnPropGetter(target, name) {
    var propDesc = objGetOwnPropertyDescriptor(target, name);
    return propDesc && propDesc.get;
}
function _createDynamicProperty(state, theConfig, name, value) {
    // Does not appear to be dynamic so lets make it so
    var detail = {
        n: name,
        h: [],
        trk: function (handler) {
            if (handler && handler.fn) {
                if (arrIndexOf(detail.h, handler) === -1) {
                    // Add this handler to the collection that should be notified when the value changes
                    detail.h[_DYN_PUSH$2 /* @min:%2epush */](handler);
                }
                state.trk(handler, detail);
            }
        },
        clr: function (handler) {
            var idx = arrIndexOf(detail.h, handler);
            if (idx !== -1) {
                detail.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
            }
        }
    };
    // Flag to optimize lookup response time by avoiding additional function calls
    var checkDynamic = true;
    var isObjectOrArray = false;
    function _getProperty() {
        if (checkDynamic) {
            isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
            // Make sure that if it's an object that we make it dynamic
            if (value && !value[CFG_HANDLER_LINK] && isObjectOrArray) {
                // It doesn't look like it's already dynamic so lets make sure it's converted the object into a dynamic Config as well
                value = _makeDynamicObject(state, value, name, "Converting");
            }
            // If it needed to be converted it now has been
            checkDynamic = false;
        }
        // If there is an active handler then add it to the tracking set of handlers
        var activeHandler = state.act;
        if (activeHandler) {
            detail.trk(activeHandler);
        }
        return value;
    }
    // Tag this getter as our dynamic property and provide shortcut for notifying a change
    _getProperty[state.prop] = {
        chng: function () {
            state.add(detail);
        }
    };
    function _setProperty(newValue) {
        if (value !== newValue) {
            if (!!_getProperty[state.ro] && !state.upd) {
                // field is marked as readonly so return false
                throwInvalidAccess("[" + name + "] is read-only:" + dumpObj(theConfig));
            }
            if (checkDynamic) {
                isObjectOrArray = isObjectOrArray || _canMakeDynamic(_getProperty, state, value);
                checkDynamic = false;
            }
            // The value must be a plain object or an array to enforce the reference (in-place updates)
            var isReferenced = isObjectOrArray && _getProperty[state.rf];
            if (isObjectOrArray) {
                // We are about to replace a plain object or an array
                if (isReferenced) {
                    // Reassign the properties from the current value to the same properties from the newValue
                    // This will set properties not in the newValue to undefined
                    objForEachKey(value, function (key) {
                        value[key] = newValue ? newValue[key] : UNDEFINED_VALUE$2;
                    });
                    // Now assign / re-assign value with all of the keys from newValue
                    try {
                        objForEachKey(newValue, function (key, theValue) {
                            _setDynamicProperty(state, value, key, theValue);
                        });
                        // Now drop newValue so when we assign value later it keeps the existing reference
                        newValue = value;
                    }
                    catch (e) {
                        // Unable to convert to dynamic property so just leave as non-dynamic
                        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Assigning", e);
                        // Mark as not an object or array so we don't try and do this again
                        isObjectOrArray = false;
                    }
                }
                else if (value && value[CFG_HANDLER_LINK]) {
                    // As we are replacing the value, if it's already dynamic then we need to notify the listeners
                    // for every property it has already
                    objForEachKey(value, function (key) {
                        // Check if the value is dynamic
                        var getter = _getOwnPropGetter(value, key);
                        if (getter) {
                            // And if it is tell it's listeners that the value has changed
                            var valueState = getter[state.prop];
                            valueState && valueState.chng();
                        }
                    });
                }
            }
            if (newValue !== value) {
                var newIsObjectOrArray = newValue && _canMakeDynamic(_getProperty, state, newValue);
                if (!isReferenced && newIsObjectOrArray) {
                    // As the newValue is an object/array lets preemptively make it dynamic
                    newValue = _makeDynamicObject(state, newValue, name, "Converting");
                }
                // Now assign the internal "value" to the newValue
                value = newValue;
                isObjectOrArray = newIsObjectOrArray;
            }
            // Cause any listeners to be scheduled for notification
            state.add(detail);
        }
    }
    objDefine(theConfig, detail.n, { g: _getProperty, s: _setProperty });
}
function _setDynamicProperty(state, target, name, value) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        if (!isDynamic) {
            _createDynamicProperty(state, target, name, value);
        }
        else {
            // Looks like it's already dynamic just assign the new value
            target[name] = value;
        }
    }
    return target;
}
function _setDynamicPropertyState(state, target, name, flags) {
    if (target) {
        // To be a dynamic property it needs to have a get function
        var getter = _getOwnPropGetter(target, name);
        var isDynamic = getter && !!getter[state.prop];
        var inPlace = flags && flags[0 /* _eSetDynamicPropertyFlags.inPlace */];
        var rdOnly = flags && flags[1 /* _eSetDynamicPropertyFlags.readOnly */];
        var blkProp = flags && flags[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */];
        if (!isDynamic) {
            if (blkProp) {
                try {
                    // Attempt to mark the target as blocked from conversion
                    blockDynamicConversion(target);
                }
                catch (e) {
                    _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "Blocking", e);
                }
            }
            try {
                // Make sure it's dynamic so that we can tag the property as per the state
                _setDynamicProperty(state, target, name, target[name]);
                getter = _getOwnPropGetter(target, name);
            }
            catch (e) {
                // Unable to convert to dynamic property so just leave as non-dynamic
                _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, "State", e);
            }
        }
        // Assign the optional flags if true
        if (inPlace) {
            getter[state.rf] = inPlace;
        }
        if (rdOnly) {
            getter[state.ro] = rdOnly;
        }
        if (blkProp) {
            getter[state.blkVal] = true;
        }
    }
    return target;
}
function _makeDynamicObject(state, target, name, desc) {
    try {
        // Assign target with new value properties (converting into dynamic properties in the process)
        objForEachKey(target, function (key, value) {
            // Assign and/or make the property dynamic
            _setDynamicProperty(state, target, key, value);
        });
        if (!target[CFG_HANDLER_LINK]) {
            // Link the config back to the dynamic config details
            objDefineProp(target, CFG_HANDLER_LINK, {
                get: function () {
                    return state[_DYN_HDLR /* @min:%2ehdlr */];
                }
            });
            _patchArray(state, target, name);
        }
    }
    catch (e) {
        // Unable to convert to dynamic property so just leave as non-dynamic
        _throwDynamicError((state.hdlr || {})[_DYN_LOGGER /* @min:%2elogger */], name, desc, e);
    }
    return target;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var symPrefix = "[[ai_";
var symPostfix = "]]";
function _createState(cfgHandler) {
    var _a;
    var dynamicPropertySymbol = newSymbol(symPrefix + "get" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReadOnly = newSymbol(symPrefix + "ro" + cfgHandler.uid + symPostfix);
    var dynamicPropertyReferenced = newSymbol(symPrefix + "rf" + cfgHandler.uid + symPostfix);
    var dynamicPropertyBlockValue = newSymbol(symPrefix + "blkVal" + cfgHandler.uid + symPostfix);
    var dynamicPropertyDetail = newSymbol(symPrefix + "dtl" + cfgHandler.uid + symPostfix);
    var _waitingHandlers = null;
    var _watcherTimer = null;
    var theState;
    function _useHandler(activeHandler, callback) {
        var prevWatcher = theState.act;
        try {
            theState.act = activeHandler;
            if (activeHandler && activeHandler[dynamicPropertyDetail]) {
                // Clear out the previously tracked details for this handler, so that access are re-evaluated
                arrForEach(activeHandler[dynamicPropertyDetail], function (detail) {
                    detail.clr(activeHandler);
                });
                activeHandler[dynamicPropertyDetail] = [];
            }
            callback({
                cfg: cfgHandler.cfg,
                set: cfgHandler.set.bind(cfgHandler),
                setDf: cfgHandler[_DYN_SET_DF /* @min:%2esetDf */].bind(cfgHandler),
                ref: cfgHandler.ref.bind(cfgHandler),
                rdOnly: cfgHandler[_DYN_RD_ONLY /* @min:%2erdOnly */].bind(cfgHandler)
            });
        }
        catch (e) {
            var logger = cfgHandler[_DYN_LOGGER /* @min:%2elogger */];
            if (logger) {
                // Don't let one individual failure break everyone
                logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](1 /* eLoggingSeverity.CRITICAL */, 107 /* _eInternalMessageId.ConfigWatcherException */, dumpObj(e));
            }
            // Re-throw the exception so that any true "error" is reported back to the called
            throw e;
        }
        finally {
            theState.act = prevWatcher || null;
        }
    }
    function _notifyWatchers() {
        if (_waitingHandlers) {
            var notifyHandlers = _waitingHandlers;
            _waitingHandlers = null;
            // Stop any timer as we are running them now anyway
            _watcherTimer && _watcherTimer[_DYN_CANCEL /* @min:%2ecancel */]();
            _watcherTimer = null;
            var watcherFailures_1 = [];
            // Now run the handlers
            arrForEach(notifyHandlers, function (handler) {
                if (handler) {
                    if (handler[dynamicPropertyDetail]) {
                        arrForEach(handler[dynamicPropertyDetail], function (detail) {
                            // Clear out this handler from  previously tracked details, so that access are re-evaluated
                            detail.clr(handler);
                        });
                        handler[dynamicPropertyDetail] = null;
                    }
                    // The handler may have self removed as part of another handler so re-check
                    if (handler.fn) {
                        try {
                            _useHandler(handler, handler.fn);
                        }
                        catch (e) {
                            // Don't let a single failing watcher cause other watches to fail
                            watcherFailures_1[_DYN_PUSH$2 /* @min:%2epush */](e);
                        }
                    }
                }
            });
            // During notification we may have had additional updates -- so notify those updates as well
            if (_waitingHandlers) {
                try {
                    _notifyWatchers();
                }
                catch (e) {
                    watcherFailures_1[_DYN_PUSH$2 /* @min:%2epush */](e);
                }
            }
            if (watcherFailures_1[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                throwAggregationError("Watcher error(s): ", watcherFailures_1);
            }
        }
    }
    function _addWatcher(detail) {
        if (detail && detail.h[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
            if (!_waitingHandlers) {
                _waitingHandlers = [];
            }
            if (!_watcherTimer) {
                _watcherTimer = scheduleTimeout(function () {
                    _watcherTimer = null;
                    _notifyWatchers();
                }, 0);
            }
            // Add all of the handlers for this detail (if not already present) - using normal for-loop for performance
            for (var idx = 0; idx < detail.h[_DYN_LENGTH$5 /* @min:%2elength */]; idx++) {
                var handler = detail.h[idx];
                // Add this handler to the collection of handlers to re-execute
                if (handler && arrIndexOf(_waitingHandlers, handler) === -1) {
                    _waitingHandlers[_DYN_PUSH$2 /* @min:%2epush */](handler);
                }
            }
        }
    }
    function _trackHandler(handler, detail) {
        if (handler) {
            var details = handler[dynamicPropertyDetail] = handler[dynamicPropertyDetail] || [];
            if (arrIndexOf(details, detail) === -1) {
                // If this detail is not already listed as tracked then add it so that we re-evaluate it's usage
                details[_DYN_PUSH$2 /* @min:%2epush */](detail);
            }
        }
    }
    theState = (_a = {
            prop: dynamicPropertySymbol,
            ro: dynamicPropertyReadOnly,
            rf: dynamicPropertyReferenced
        },
        _a[_DYN_BLK_VAL /* @min:blkVal */] = dynamicPropertyBlockValue,
        _a[_DYN_HDLR /* @min:hdlr */] = cfgHandler,
        _a.add = _addWatcher,
        _a[_DYN_NOTIFY /* @min:notify */] = _notifyWatchers,
        _a.use = _useHandler,
        _a.trk = _trackHandler,
        _a);
    return theState;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Identifies a function which will be re-called whenever any of it's accessed configuration values
 * change.
 * @param configHandler - The callback that will be called for the initial request and then whenever any
 * accessed configuration changes are identified.
 */
function _createAndUseHandler(state, configHandler) {
    var handler = {
        fn: configHandler,
        rm: function () {
            // Clear all references to the handler so it can be garbage collected
            // This will also cause this handler to never get called and eventually removed
            handler.fn = null;
            state = null;
            configHandler = null;
        }
    };
    state.use(handler, configHandler);
    return handler;
}
/**
 * Creates the dynamic config handler and associates with the target config as the root object
 * @param target - The config that you want to be root of the dynamic config
 * @param inPlace - Should the passed config be converted in-place or a new proxy returned
 * @returns The existing dynamic handler or a new instance with the provided config values
 */
function _createDynamicHandler(logger, target, inPlace) {
    var _a;
    var dynamicHandler = getDynamicConfigHandler(target);
    if (dynamicHandler) {
        // The passed config is already dynamic so return it's tracker
        return dynamicHandler;
    }
    var uid = createUniqueNamespace("dyncfg", true);
    var newTarget = (inPlace !== false) ? target : _cfgDeepCopy(target);
    var theState;
    function _notifyWatchers() {
        theState[_DYN_NOTIFY /* @min:%2enotify */]();
    }
    function _setValue(target, name, value) {
        try {
            target = _setDynamicProperty(theState, target, name, value);
        }
        catch (e) {
            // Unable to convert to dynamic property so just leave as non-dynamic
            _throwDynamicError(logger, name, "Setting value", e);
        }
        return target[name];
    }
    function _watch(configHandler) {
        return _createAndUseHandler(theState, configHandler);
    }
    function _block(configHandler, allowUpdate) {
        theState.use(null, function (details) {
            var prevUpd = theState.upd;
            try {
                if (!isUndefined$2(allowUpdate)) {
                    theState.upd = allowUpdate;
                }
                configHandler(details);
            }
            finally {
                theState.upd = prevUpd;
            }
        });
    }
    function _ref(target, name) {
        var _a;
        // Make sure it's dynamic and mark as referenced with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[0 /* _eSetDynamicPropertyFlags.inPlace */] = true, _a))[name];
    }
    function _rdOnly(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[1 /* _eSetDynamicPropertyFlags.readOnly */] = true, _a))[name];
    }
    function _blkPropValue(target, name) {
        var _a;
        // Make sure it's dynamic and mark as readonly with it's current value
        return _setDynamicPropertyState(theState, target, name, (_a = {}, _a[2 /* _eSetDynamicPropertyFlags.blockDynamicProperty */] = true, _a))[name];
    }
    function _applyDefaults(theConfig, defaultValues) {
        if (defaultValues) {
            // Resolve/apply the defaults
            objForEachKey(defaultValues, function (name, value) {
                // Sets the value and makes it dynamic (if it doesn't already exist)
                _applyDefaultValue(cfgHandler, theConfig, name, value);
            });
        }
        return theConfig;
    }
    var cfgHandler = (_a = {
            uid: null,
            cfg: newTarget
        },
        _a[_DYN_LOGGER /* @min:logger */] = logger,
        _a[_DYN_NOTIFY /* @min:notify */] = _notifyWatchers,
        _a.set = _setValue,
        _a[_DYN_SET_DF /* @min:setDf */] = _applyDefaults,
        _a[_DYN_WATCH /* @min:watch */] = _watch,
        _a.ref = _ref,
        _a[_DYN_RD_ONLY /* @min:rdOnly */] = _rdOnly,
        _a[_DYN_BLK_VAL /* @min:blkVal */] = _blkPropValue,
        _a._block = _block,
        _a);
    objDefine(cfgHandler, "uid", {
        c: false,
        e: false,
        w: false,
        v: uid
    });
    theState = _createState(cfgHandler);
    // Setup tracking for all defined default keys
    _makeDynamicObject(theState, newTarget, "config", "Creating");
    return cfgHandler;
}
/**
 * Log an invalid access message to the console
 * @param message
 */
function _logInvalidAccess(logger, message) {
    if (logger) {
        logger[_DYN_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */](message);
        logger[_DYN_THROW_INTERNAL /* @min:%2ethrowInternal */](2 /* eLoggingSeverity.WARNING */, 108 /* _eInternalMessageId.DynamicConfigException */, message);
    }
    else {
        // We don't have a logger so just throw an exception
        throwInvalidAccess(message);
    }
}
/**
 * Create or return a dynamic version of the passed config, if it is not already dynamic
 * @param config - The config to be converted into a dynamic config
 * @param defaultConfig - The default values to apply on the config if the properties don't already exist
 * @param inPlace - Should the config be converted in-place into a dynamic config or a new instance returned, defaults to true
 * @returns The dynamic config handler for the config (whether new or existing)
 */
function createDynamicConfig(config, defaultConfig, logger, inPlace) {
    var dynamicHandler = _createDynamicHandler(logger, config || {}, inPlace);
    if (defaultConfig) {
        dynamicHandler[_DYN_SET_DF /* @min:%2esetDf */](dynamicHandler.cfg, defaultConfig);
    }
    return dynamicHandler;
}
/**
 * Watch and track changes for accesses to the current config, the provided config MUST already be
 * a dynamic config or a child accessed via the dynamic config
 * @param config
 * @param configHandler
 * @param logger - The logger instance to use if there is no existing handler
 * @returns A watcher handler instance that can be used to remove itself when being unloaded
 * @throws TypeError if the provided config is not a dynamic config instance
 */
function onConfigChange(config, configHandler, logger) {
    var handler = config[CFG_HANDLER_LINK] || config;
    if (handler.cfg && (handler.cfg === config || handler.cfg[CFG_HANDLER_LINK] === handler)) {
        return handler[_DYN_WATCH /* @min:%2ewatch */](configHandler);
    }
    _logInvalidAccess(logger, STR_NOT_DYNAMIC_ERROR + dumpObj(config));
    return createDynamicConfig(config, null, logger)[_DYN_WATCH /* @min:%2ewatch */](configHandler);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Run the unload function of the target object if it exists
 * @param target - The target object that contains the unload function
 * @param isAsync - The caller identifies whether it is expecting the operation to complete synchronously or asynchronously. Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @returns The result of the target function
 */
function runTargetUnload(target, isAsync) {
    if (target && target[_DYN_UNLOAD /* @min:%2eunload */]) {
        return target[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
    }
}
/**
 * Call the unload function on all targets handling any returned [IPromise](https://nevware21.github.io/ts-async/typedoc/interfaces/IPromise.html)
 * / Promise before calling the next targets unload
 * @param targets - An array of the targets to unload
 * @param isAsync - The caller identifies whether it is expecting the operations to complete synchronously or asynchronously.  Even
 * if the caller is not waiting the operation may still be performed asynchronously depending on the component and the reverse is
 * also true.
 * @param done - Optional callback function to call once all of the unload functions have been called.
 */
function doUnloadAll(targets, isAsync, done) {
    var result;
    if (!done) {
        result = createPromise(function (resolved) {
            done = resolved;
        });
    }
    if (targets && getLength(targets) > 0) {
        doAwaitResponse(runTargetUnload(targets[0], isAsync), function () {
            doUnloadAll(arrSlice(targets, 1), isAsync, done);
        });
    }
    else {
        done();
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var ChannelControllerPriority = 500;
var DisabledPropertyName$1 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
// export const SampleRate = "sampleRate";
// export const ProcessLegacy = "ProcessLegacy";
// export const HttpMethod = "http.method";
// export const DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
// export const DEFAULT_BREEZE_PATH = "/v2/track";
// export const strNotSpecified = "not_specified";
// export const strIkey = "iKey";

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * @internal
 * @ignore
 * @param str
 * @param defaultValue
 * @returns
 */
function _stringToBoolOrDefault(theValue, defaultValue, theConfig) {
    if (!theValue && isNullOrUndefined(theValue)) {
        return defaultValue;
    }
    if (isBoolean$2(theValue)) {
        return theValue;
    }
    return asString(theValue)[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() === "true";
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the field defined as an object
 * that should be merged
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfMerge(defaultValue) {
    return {
        mrg: true,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field set function
 * @param setter - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfSet(setter, defaultValue) {
    return {
        set: setter,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance with the provided field validator
 * @param validator - The IConfigCheckFn function to validate the user provided value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfValidate(validator, defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        isVal: validator,
        v: defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate and convert the user
 * provided value to a boolean from a string or boolean value
 * @param defaultValue - The default value to apply it not provided or it's not valid
 * @param fallBackName - The fallback configuration name if the current value is not available
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfBoolean(defaultValue, fallBackName) {
    return {
        fb: fallBackName,
        set: _stringToBoolOrDefault,
        v: !!defaultValue
    };
}
/**
 * Helper which returns an IConfigDefaultCheck instance that will validate that the user
 * provided value is a function.
 * @param defaultValue - The default string value to apply it not provided or it's not valid, defaults to an empty string
 * @returns a new IConfigDefaultCheck structure
 */
function cfgDfString(defaultValue) {
    return {
        isVal: isString$2,
        v: asString(STR_EMPTY$1)
    };
}

var _a$9, _b$2;
var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc;
var _cookieCache = {};
var _globalCookieConfig = {};
var rootDefaultConfig = (_a$9 = {
  cookieCfg: cfgDfMerge((_b$2 = {}, _b$2[STR_DOMAIN] = { fb: "cookieDomain", dfVal: isNotNullOrUndefined }, _b$2.path = { fb: "cookiePath", dfVal: isNotNullOrUndefined }, _b$2.enabled = UNDEFINED_VALUE$2, _b$2.ignoreCookies = UNDEFINED_VALUE$2, _b$2.blockedCookies = UNDEFINED_VALUE$2, _b$2)),
  cookieDomain: UNDEFINED_VALUE$2,
  cookiePath: UNDEFINED_VALUE$2
}, _a$9[strDisableCookiesUsage] = UNDEFINED_VALUE$2, _a$9);
function _getDoc() {
  !_doc && (_doc = getLazy(function() {
    return getDocument();
  }));
}
function _gblCookieMgr(config, logger) {
  var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
  if (!inst) {
    inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
    _globalCookieConfig[strConfigCookieMgr] = inst;
  }
  return inst;
}
function _isMgrEnabled(cookieMgr) {
  if (cookieMgr) {
    return cookieMgr.isEnabled();
  }
  return true;
}
function _isIgnoredCookie(cookieMgrCfg, name) {
  if (name && cookieMgrCfg && isArray$3(cookieMgrCfg.ignoreCookies)) {
    return arrIndexOf(cookieMgrCfg.ignoreCookies, name) !== -1;
  }
  return false;
}
function _isBlockedCookie(cookieMgrCfg, name) {
  if (name && cookieMgrCfg && isArray$3(cookieMgrCfg.blockedCookies)) {
    if (arrIndexOf(cookieMgrCfg.blockedCookies, name) !== -1) {
      return true;
    }
  }
  return _isIgnoredCookie(cookieMgrCfg, name);
}
function _isCfgEnabled(rootConfig, cookieMgrConfig) {
  var isCfgEnabled = cookieMgrConfig[
    _DYN_ENABLED
    /* @min:%2eenabled */
  ];
  if (isNullOrUndefined(isCfgEnabled)) {
    var cookieEnabled = undefined;
    if (!isUndefined$2(rootConfig[strIsCookieUseDisabled])) {
      cookieEnabled = !rootConfig[strIsCookieUseDisabled];
    }
    if (!isUndefined$2(rootConfig[strDisableCookiesUsage])) {
      cookieEnabled = !rootConfig[strDisableCookiesUsage];
    }
    isCfgEnabled = cookieEnabled;
  }
  return isCfgEnabled;
}
function safeGetCookieMgr(core, config) {
  var cookieMgr;
  if (core) {
    cookieMgr = core.getCookieMgr();
  }
  if (!cookieMgr) {
    cookieMgr = _gblCookieMgr(config, (core || {})[
      _DYN_LOGGER
      /* @min:%2elogger */
    ]);
  }
  return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
  var _a2;
  var cookieMgrConfig;
  var _path;
  var _domain;
  var unloadHandler;
  var _enabled;
  var _getCookieFn;
  var _setCookieFn;
  var _delCookieFn;
  rootConfig = createDynamicConfig(rootConfig || _globalCookieConfig, null, logger).cfg;
  unloadHandler = onConfigChange(rootConfig, function(details) {
    details[
      _DYN_SET_DF
      /* @min:%2esetDf */
    ](details.cfg, rootDefaultConfig);
    cookieMgrConfig = details.ref(details.cfg, "cookieCfg");
    _path = cookieMgrConfig[
      STR_PATH
      /* @min:%2epath */
    ] || "/";
    _domain = cookieMgrConfig[
      STR_DOMAIN
      /* @min:%2edomain */
    ];
    _enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false;
    _getCookieFn = cookieMgrConfig.getCookie || _getCookieValue;
    _setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
    _delCookieFn = cookieMgrConfig.delCookie || _setCookieValue;
  }, logger);
  var cookieMgr = (_a2 = {
    isEnabled: function() {
      var enabled = _isCfgEnabled(rootConfig, cookieMgrConfig) !== false && _enabled && areCookiesSupported(logger);
      var gblManager = _globalCookieConfig[strConfigCookieMgr];
      if (enabled && gblManager && cookieMgr !== gblManager) {
        enabled = _isMgrEnabled(gblManager);
      }
      return enabled;
    },
    setEnabled: function(value) {
      _enabled = value !== false;
      cookieMgrConfig[
        _DYN_ENABLED
        /* @min:%2eenabled */
      ] = value;
    },
    set: function(name, value, maxAgeSec, domain, path) {
      var result = false;
      if (_isMgrEnabled(cookieMgr) && !_isBlockedCookie(cookieMgrConfig, name)) {
        var values = {};
        var theValue = strTrim(value || STR_EMPTY$1);
        var idx = strIndexOf(theValue, ";");
        if (idx !== -1) {
          theValue = strTrim(strLeft(value, idx));
          values = _extractParts(strSubstring(value, idx + 1));
        }
        setValue(values, STR_DOMAIN, domain || _domain, isTruthy, isUndefined$2);
        if (!isNullOrUndefined(maxAgeSec)) {
          var _isIE = isIE();
          if (isUndefined$2(values[strExpires])) {
            var nowMs = utcNow();
            var expireMs = nowMs + maxAgeSec * 1e3;
            if (expireMs > 0) {
              var expiry = /* @__PURE__ */ new Date();
              expiry.setTime(expireMs);
              setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || STR_EMPTY$1, isTruthy);
            }
          }
          if (!_isIE) {
            setValue(values, "max-age", STR_EMPTY$1 + maxAgeSec, null, isUndefined$2);
          }
        }
        var location_1 = getLocation$1();
        if (location_1 && location_1[
          _DYN_PROTOCOL
          /* @min:%2eprotocol */
        ] === "https:") {
          setValue(values, "secure", null, null, isUndefined$2);
          if (_allowUaSameSite === null) {
            _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {})[
              _DYN_USER_AGENT
              /* @min:%2euserAgent */
            ]);
          }
          if (_allowUaSameSite) {
            setValue(values, "SameSite", "None", null, isUndefined$2);
          }
        }
        setValue(values, STR_PATH, path || _path, null, isUndefined$2);
        _setCookieFn(name, _formatCookieValue(theValue, values));
        result = true;
      }
      return result;
    },
    get: function(name) {
      var value = STR_EMPTY$1;
      if (_isMgrEnabled(cookieMgr) && !_isIgnoredCookie(cookieMgrConfig, name)) {
        value = _getCookieFn(name);
      }
      return value;
    },
    del: function(name, path) {
      var result = false;
      if (_isMgrEnabled(cookieMgr)) {
        result = cookieMgr.purge(name, path);
      }
      return result;
    },
    purge: function(name, path) {
      var _a3;
      var result = false;
      if (areCookiesSupported(logger)) {
        var values = (_a3 = {}, _a3[STR_PATH] = path ? path : "/", _a3[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a3);
        if (!isIE()) {
          values["max-age"] = "0";
        }
        _delCookieFn(name, _formatCookieValue(STR_EMPTY$1, values));
        result = true;
      }
      return result;
    }
  }, _a2[
    _DYN_UNLOAD
    /* @min:unload */
  ] = function(isAsync) {
    unloadHandler && unloadHandler.rm();
    unloadHandler = null;
  }, _a2);
  cookieMgr[strConfigCookieMgr] = cookieMgr;
  return cookieMgr;
}
function areCookiesSupported(logger) {
  if (_supportsCookies === null) {
    _supportsCookies = false;
    !_doc && _getDoc();
    try {
      var doc = _doc.v || {};
      _supportsCookies = doc[strCookie] !== void 0;
    } catch (e) {
      _throwInternal(logger, 2, 68, "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return _supportsCookies;
}
function _extractParts(theValue) {
  var values = {};
  if (theValue && theValue[
    _DYN_LENGTH$5
    /* @min:%2elength */
  ]) {
    var parts = strTrim(theValue)[
      _DYN_SPLIT$1
      /* @min:%2esplit */
    ](";");
    arrForEach(parts, function(thePart) {
      thePart = strTrim(thePart || STR_EMPTY$1);
      if (thePart) {
        var idx = strIndexOf(thePart, "=");
        if (idx === -1) {
          values[thePart] = null;
        } else {
          values[strTrim(strLeft(thePart, idx))] = strTrim(strSubstring(thePart, idx + 1));
        }
      }
    });
  }
  return values;
}
function _formatDate(theDate, func) {
  if (isFunction$3(theDate[func])) {
    return theDate[func]();
  }
  return null;
}
function _formatCookieValue(value, values) {
  var cookieValue = value || STR_EMPTY$1;
  objForEachKey(values, function(name, theValue) {
    cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : STR_EMPTY$1);
  });
  return cookieValue;
}
function _getCookieValue(name) {
  var cookieValue = STR_EMPTY$1;
  !_doc && _getDoc();
  if (_doc.v) {
    var theCookie = _doc.v[strCookie] || STR_EMPTY$1;
    if (_parsedCookieValue !== theCookie) {
      _cookieCache = _extractParts(theCookie);
      _parsedCookieValue = theCookie;
    }
    cookieValue = strTrim(_cookieCache[name] || STR_EMPTY$1);
  }
  return cookieValue;
}
function _setCookieValue(name, cookieValue) {
  !_doc && _getDoc();
  if (_doc.v) {
    _doc.v[strCookie] = name + "=" + cookieValue;
  }
}
function uaDisallowsSameSiteNone(userAgent) {
  if (!isString$2(userAgent)) {
    return false;
  }
  if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
    return true;
  }
  if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
    return true;
  }
  if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
    return true;
  }
  if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
    return true;
  }
  if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
    return true;
  }
  if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
    return true;
  }
  return false;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var defaultValues$2 = {
    perfEvtsSendAll: false
};
function _runListeners(listeners, name, isAsync, callback) {
    arrForEach(listeners, function (listener) {
        if (listener && listener[name]) {
            if (isAsync) {
                scheduleTimeout(function () { return callback(listener); }, 0);
            }
            else {
                try {
                    callback(listener);
                }
                catch (e) {
                    // Catch errors to ensure we don't block sending the requests
                }
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll;
        var unloadHandler;
        var _listeners = [];
        var cfgHandler = createDynamicConfig(config, defaultValues$2);
        unloadHandler = cfgHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
            perfEvtsSendAll = !!details.cfg.perfEvtsSendAll;
        });
        dynamicProto(NotificationManager, this, function (_self) {
            objDefine(_self, "listeners", {
                g: function () { return _listeners; }
            });
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _listeners[_DYN_PUSH$2 /* @min:%2epush */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - AWTNotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */] = function (listener) {
                var index = arrIndexOf(_listeners, listener);
                while (index > -1) {
                    _listeners[_DYN_SPLICE /* @min:%2esplice */](index, 1);
                    index = arrIndexOf(_listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param events - The array of events that have been sent.
             */
            _self[STR_EVENTS_SENT /* @min:%2eeventsSent */] = function (events) {
                _runListeners(_listeners, STR_EVENTS_SENT, true, function (listener) {
                    listener[STR_EVENTS_SENT /* @min:%2eeventsSent */](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param events - The array of events that have been discarded by the SDK.
             * @param reason - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */] = function (events, reason) {
                _runListeners(_listeners, STR_EVENTS_DISCARDED, true, function (listener) {
                    listener[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param sendReason - The reason why the event batch is being sent.
             * @param isAsync - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */] = function (sendReason, isAsync) {
                _runListeners(_listeners, STR_EVENTS_SEND_REQUEST, isAsync, function (listener) {
                    listener[STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendReason, isAsync);
                });
            };
            _self[STR_PERF_EVENT /* @min:%2eperfEvent */] = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent[_DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */]()) {
                        _runListeners(_listeners, STR_PERF_EVENT, false, function (listener) {
                            if (perfEvent[_DYN_IS_ASYNC /* @min:%2eisAsync */]) {
                                scheduleTimeout(function () { return listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent); }, 0);
                            }
                            else {
                                listener[STR_PERF_EVENT /* @min:%2eperfEvent */](perfEvent);
                            }
                        });
                    }
                }
            };
            _self[STR_OFFLINE_STORE /* @min:%2eofflineEventsStored */] = function (events) {
                if (events && events[_DYN_LENGTH$5 /* @min:%2elength */]) {
                    _runListeners(_listeners, STR_OFFLINE_STORE, true, function (listener) {
                        listener[STR_OFFLINE_STORE /* @min:%2eofflineEventsStored */](events);
                    });
                }
            };
            _self[STR_OFFLINE_SENT /* @min:%2eofflineBatchSent */] = function (batch) {
                if (batch && batch[_DYN_DATA$1 /* @min:%2edata */]) {
                    _runListeners(_listeners, STR_OFFLINE_SENT, true, function (listener) {
                        listener[STR_OFFLINE_SENT /* @min:%2eofflineBatchSent */](batch);
                    });
                }
            };
            _self[STR_OFFLINE_DROP /* @min:%2eofflineBatchDrop */] = function (cnt, reason) {
                if (cnt > 0) {
                    var rn_1 = reason || 0; // default is unknown
                    _runListeners(_listeners, STR_OFFLINE_DROP, true, function (listener) {
                        listener[STR_OFFLINE_DROP /* @min:%2eofflineBatchDrop */](cnt, rn_1);
                    });
                }
            };
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync) {
                var _finishUnload = function () {
                    unloadHandler && unloadHandler.rm();
                    unloadHandler = null;
                    _listeners = [];
                };
                var waiting;
                _runListeners(_listeners, "unload", false, function (listener) {
                    var asyncUnload = listener[_DYN_UNLOAD /* @min:%2eunload */](isAsync);
                    if (asyncUnload) {
                        if (!waiting) {
                            waiting = [];
                        }
                        waiting[_DYN_PUSH$2 /* @min:%2epush */](asyncUnload);
                    }
                });
                if (waiting) {
                    return createPromise(function (resolve) {
                        return doAwaitResponse(createAllPromise(waiting), function () {
                            _finishUnload();
                            resolve();
                        });
                    });
                }
                else {
                    _finishUnload();
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
// Removed Stub for NotificationManager.prototype.perfEvent.
// Removed Stub for NotificationManager.prototype.unload.
// Removed Stub for NotificationManager.prototype.offlineEventsStored.
// Removed Stub for NotificationManager.prototype.offlineBatchSent.
// Removed Stub for NotificationManager.prototype.offlineBatchDrop.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    NotificationManager.__ieDyn=1;

    return NotificationManager;
}());

var strExecutionContextKey = "ctx";
var strParentContextKey = "ParentContextKey";
var strChildrenContextKey = "ChildrenContextKey";
var _defaultPerfManager = null;
var PerfEvent = (
  /** @class */
  function() {
    function PerfEvent2(name, payloadDetails, isAsync) {
      var _self = this;
      _self.start = utcNow();
      _self[
        _DYN_NAME$3
        /* @min:%2ename */
      ] = name;
      _self[
        _DYN_IS_ASYNC
        /* @min:%2eisAsync */
      ] = isAsync;
      _self[
        _DYN_IS_CHILD_EVT
        /* @min:%2eisChildEvt */
      ] = function() {
        return false;
      };
      if (isFunction$3(payloadDetails)) {
        var theDetails_1;
        objDefine(_self, "payload", {
          g: function() {
            if (!theDetails_1 && isFunction$3(payloadDetails)) {
              theDetails_1 = payloadDetails();
              payloadDetails = null;
            }
            return theDetails_1;
          }
        });
      }
      _self[
        _DYN_GET_CTX
        /* @min:%2egetCtx */
      ] = function(key) {
        if (key) {
          if (key === PerfEvent2[strParentContextKey] || key === PerfEvent2[strChildrenContextKey]) {
            return _self[key];
          }
          return (_self[strExecutionContextKey] || {})[key];
        }
        return null;
      };
      _self[
        _DYN_SET_CTX
        /* @min:%2esetCtx */
      ] = function(key, value) {
        if (key) {
          if (key === PerfEvent2[strParentContextKey]) {
            if (!_self[key]) {
              _self[
                _DYN_IS_CHILD_EVT
                /* @min:%2eisChildEvt */
              ] = function() {
                return true;
              };
            }
            _self[key] = value;
          } else if (key === PerfEvent2[strChildrenContextKey]) {
            _self[key] = value;
          } else {
            var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
            ctx[key] = value;
          }
        }
      };
      _self[
        _DYN_COMPLETE
        /* @min:%2ecomplete */
      ] = function() {
        var childTime = 0;
        var childEvts = _self[
          _DYN_GET_CTX
          /* @min:%2egetCtx */
        ](PerfEvent2[strChildrenContextKey]);
        if (isArray$3(childEvts)) {
          for (var lp = 0; lp < childEvts[
            _DYN_LENGTH$5
            /* @min:%2elength */
          ]; lp++) {
            var childEvt = childEvts[lp];
            if (childEvt) {
              childTime += childEvt[
                _DYN_TIME
                /* @min:%2etime */
              ];
            }
          }
        }
        _self[
          _DYN_TIME
          /* @min:%2etime */
        ] = utcNow() - _self.start;
        _self.exTime = _self[
          _DYN_TIME
          /* @min:%2etime */
        ] - childTime;
        _self[
          _DYN_COMPLETE
          /* @min:%2ecomplete */
        ] = function() {
        };
      };
    }
    PerfEvent2.ParentContextKey = "parent";
    PerfEvent2.ChildrenContextKey = "childEvts";
    return PerfEvent2;
  }()
);
var PerfManager = (
  /** @class */
  function() {
    function PerfManager2(manager) {
      this.ctx = {};
      dynamicProto(PerfManager2, this, function(_self) {
        _self.create = function(src, payloadDetails, isAsync) {
          return new PerfEvent(src, payloadDetails, isAsync);
        };
        _self.fire = function(perfEvent) {
          if (perfEvent) {
            perfEvent[
              _DYN_COMPLETE
              /* @min:%2ecomplete */
            ]();
            if (manager && isFunction$3(manager[
              STR_PERF_EVENT
              /* @min:%2eperfEvent */
            ])) {
              manager[
                STR_PERF_EVENT
                /* @min:%2eperfEvent */
              ](perfEvent);
            }
          }
        };
        _self[
          _DYN_SET_CTX
          /* @min:%2esetCtx */
        ] = function(key, value) {
          if (key) {
            var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
            ctx[key] = value;
          }
        };
        _self[
          _DYN_GET_CTX
          /* @min:%2egetCtx */
        ] = function(key) {
          return (_self[strExecutionContextKey] || {})[key];
        };
      });
    }
    PerfManager2.__ieDyn = 1;
    return PerfManager2;
  }()
);
var doPerfActiveKey = "CoreUtils.doPerf";
function doPerf(mgrSource, getSource, func, details, isAsync) {
  if (mgrSource) {
    var perfMgr = mgrSource;
    if (perfMgr[STR_GET_PERF_MGR]) {
      perfMgr = perfMgr[STR_GET_PERF_MGR]();
    }
    if (perfMgr) {
      var perfEvt = undefined;
      var currentActive = perfMgr[
        _DYN_GET_CTX
        /* @min:%2egetCtx */
      ](doPerfActiveKey);
      try {
        perfEvt = perfMgr.create(getSource(), details, isAsync);
        if (perfEvt) {
          if (currentActive && perfEvt[
            _DYN_SET_CTX
            /* @min:%2esetCtx */
          ]) {
            perfEvt[
              _DYN_SET_CTX
              /* @min:%2esetCtx */
            ](PerfEvent[strParentContextKey], currentActive);
            if (currentActive[
              _DYN_GET_CTX
              /* @min:%2egetCtx */
            ] && currentActive[
              _DYN_SET_CTX
              /* @min:%2esetCtx */
            ]) {
              var children = currentActive[
                _DYN_GET_CTX
                /* @min:%2egetCtx */
              ](PerfEvent[strChildrenContextKey]);
              if (!children) {
                children = [];
                currentActive[
                  _DYN_SET_CTX
                  /* @min:%2esetCtx */
                ](PerfEvent[strChildrenContextKey], children);
              }
              children[
                _DYN_PUSH$2
                /* @min:%2epush */
              ](perfEvt);
            }
          }
          perfMgr[
            _DYN_SET_CTX
            /* @min:%2esetCtx */
          ](doPerfActiveKey, perfEvt);
          return func(perfEvt);
        }
      } catch (ex) {
        if (perfEvt && perfEvt[
          _DYN_SET_CTX
          /* @min:%2esetCtx */
        ]) {
          perfEvt[
            _DYN_SET_CTX
            /* @min:%2esetCtx */
          ]("exception", ex);
        }
      } finally {
        if (perfEvt) {
          perfMgr.fire(perfEvt);
        }
        perfMgr[
          _DYN_SET_CTX
          /* @min:%2esetCtx */
        ](doPerfActiveKey, currentActive);
      }
    }
  }
  return func();
}
function getGblPerfMgr() {
  return _defaultPerfManager;
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = STR_EMPTY$1, tmp;
    for (var a = 0; a < 4; a++) {
        tmp = random32();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
    return strSubstr(oct, 0, 8) + strSubstr(oct, 9, 4) + "4" + strSubstr(oct, 13, 3) + clockSequenceHi + strSubstr(oct, 16, 3) + strSubstr(oct, 19, 12);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var DEFAULT_VERSION = "00";
var INVALID_VERSION = "ff";
var INVALID_TRACE_ID = "00000000000000000000000000000000";
var INVALID_SPAN_ID = "0000000000000000";
function _isValid(value, len, invalidValue) {
    if (value && value[_DYN_LENGTH$5 /* @min:%2elength */] === len && value !== invalidValue) {
        return !!value.match(/^[\da-f]*$/i);
    }
    return false;
}
function _formatValue(value, len, defValue) {
    if (_isValid(value, len)) {
        return value;
    }
    return defValue;
}
function _formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) {
        value = 0x01;
    }
    var result = value.toString(16);
    while (result[_DYN_LENGTH$5 /* @min:%2elength */] < 2) {
        result = "0" + result;
    }
    return result;
}
/**
 * Create a new ITraceParent instance using the provided values.
 * @param traceId - The traceId to use, when invalid a new random W3C id will be generated.
 * @param spanId - The parent/span id to use, a new random value will be generated if it is invalid.
 * @param flags - The traceFlags to use, defaults to zero (0) if not supplied or invalid
 * @param version - The version to used, defaults to version "01" if not supplied or invalid.
 * @returns
 */
function createTraceParent(traceId, spanId, flags, version) {
    var _a;
    return _a = {},
        _a[_DYN_VERSION$1 /* @min:version */] = _isValid(version, 2, INVALID_VERSION) ? version : DEFAULT_VERSION,
        _a[_DYN_TRACE_ID$2 /* @min:traceId */] = isValidTraceId(traceId) ? traceId : generateW3CId(),
        _a[_DYN_SPAN_ID$1 /* @min:spanId */] = isValidSpanId(spanId) ? spanId : strLeft(generateW3CId(), 16),
        _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1,
        _a;
}
/**
 * Is the provided W3c Trace Id a valid string representation, it must be a 32-character string
 * of lowercase hexadecimal characters for example, 4bf92f3577b34da6a3ce929d0e0e4736.
 * If all characters as zero (00000000000000000000000000000000) it will be considered an invalid value.
 * @param value - The W3c trace Id to be validated
 * @returns true if valid otherwise false
 */
function isValidTraceId(value) {
    return _isValid(value, 32, INVALID_TRACE_ID);
}
/**
 * Is the provided W3c span id (aka. parent id) a valid string representation, it must be a 16-character
 * string of lowercase hexadecimal characters, for example, 00f067aa0ba902b7.
 * If all characters are zero (0000000000000000) this is considered an invalid value.
 * @param value - The W3c span id to be validated
 * @returns true if valid otherwise false
 */
function isValidSpanId(value) {
    return _isValid(value, 16, INVALID_SPAN_ID);
}
/**
 * Format the ITraceParent value as a string using the supported and know version formats.
 * So even if the passed traceParent is a later version the string value returned from this
 * function will convert it to only the known version formats.
 * This currently only supports version "00" and invalid "ff"
 * @param value - The parsed traceParent value
 * @returns
 */
function formatTraceParent(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = _formatFlags(value[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */]);
        if (!_isValid(flags, 2)) {
            flags = "01";
        }
        var version = value[_DYN_VERSION$1 /* @min:%2eversion */] || DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") {
            // Reduce version to "00"
            version = DEFAULT_VERSION;
        }
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat(_formatValue(value.traceId, 32, INVALID_TRACE_ID).toLowerCase(), "-").concat(_formatValue(value.spanId, 16, INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var pluginStateData = createElmNodeData("plugin");
function _getPluginState(plugin) {
    return pluginStateData.get(plugin, "state", {}, true);
}
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config - The current config for the instance
 * @param core - THe current core instance
 * @param extensions - The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[_DYN_GET_NEXT /* @min:%2egetNext */]();
    var pluginState;
    while (proxy) {
        var thePlugin = proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
        if (thePlugin) {
            if (lastPlugin && lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] && thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]) {
                // Set this plugin as the next for the previous one
                lastPlugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](thePlugin);
            }
            pluginState = _getPluginState(thePlugin);
            var isInitialized = !!pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */];
            if (thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]) {
                isInitialized = thePlugin[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]();
            }
            if (!isInitialized) {
                initPlugins[_DYN_PUSH$2 /* @min:%2epush */](thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
        }
    }
    // Now initialize the plugins
    arrForEach(initPlugins, function (thePlugin) {
        var core = processContext[STR_CORE /* @min:%2ecore */]();
        thePlugin[_DYN_INITIALIZE$1 /* @min:%2einitialize */](processContext.getCfg(), core, extensions, processContext[_DYN_GET_NEXT /* @min:%2egetNext */]());
        pluginState = _getPluginState(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extend from BaseTelemetryPlugin)
        if (!thePlugin[STR_CORE] && !pluginState[STR_CORE]) {
            pluginState[STR_CORE] = core;
        }
        pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = true;
        delete pluginState[_DYN_TEARDOWN /* @min:%2eteardown */];
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = extB[STR_PROCESS_TELEMETRY];
            if (extA[STR_PROCESS_TELEMETRY]) {
                result = bHasProcess ? extA[STR_PRIORITY] - extB[STR_PRIORITY] : 1;
            }
            else if (bHasProcess) {
                result = -1;
            }
        }
        else {
            result = extA ? 1 : -1;
        }
        return result;
    });
    // sort complete
}
/**
 * Creates a IDistributedTraceContext which optionally also "sets" the value on a parent
 * @param parentCtx - An optional parent distributed trace instance
 * @returns A new IDistributedTraceContext instance that uses an internal temporary object
 */
function createDistributedTraceContext(parentCtx) {
    var trace = {};
    return {
        getName: function () {
            return trace[_DYN_NAME$3 /* @min:%2ename */];
        },
        setName: function (newValue) {
            trace[_DYN_NAME$3 /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace[_DYN_TRACE_ID$2 /* @min:%2etraceId */];
        },
        setTraceId: function (newValue) {
            if (isValidTraceId(newValue)) {
                trace[_DYN_TRACE_ID$2 /* @min:%2etraceId */] = newValue;
            }
        },
        getSpanId: function () {
            return trace[_DYN_SPAN_ID$1 /* @min:%2espanId */];
        },
        setSpanId: function (newValue) {
            if (isValidSpanId(newValue)) {
                trace[_DYN_SPAN_ID$1 /* @min:%2espanId */] = newValue;
            }
        },
        getTraceFlags: function () {
            return trace[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */];
        },
        setTraceFlags: function (newTraceFlags) {
            trace[_DYN_TRACE_FLAGS$1 /* @min:%2etraceFlags */] = newTraceFlags;
        }
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var strTelemetryPluginChain = "TelemetryPluginChain";
var strHasRunFlags = "_hasRun";
var strGetTelCtx = "_getTelCtx";
var _chainId = 0;
function _getNextProxyStart(proxy, core, startAt) {
    while (proxy) {
        if (proxy[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]() === startAt) {
            return proxy;
        }
        proxy = proxy[_DYN_GET_NEXT /* @min:%2egetNext */]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return createTelemetryProxyChain([startAt], core.config || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param dynamicHandler
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */
function _createInternalContext(telemetryChain, dynamicHandler, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (!dynamicHandler) {
        dynamicHandler = createDynamicConfig({}, null, core[_DYN_LOGGER /* @min:%2elogger */]);
    }
    if (startAt !== null) {
        // There is no next element (null) vs not defined (undefined) so use the full chain
        _nextProxy = startAt ? _getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    }
    var context = {
        _next: _moveNext,
        ctx: {
            core: function () {
                return core;
            },
            diagLog: function () {
                return safeGetLogger(core, dynamicHandler.cfg);
            },
            getCfg: function () {
                return dynamicHandler.cfg;
            },
            getExtCfg: _resolveExtCfg,
            getConfig: _getConfig,
            hasNext: function () {
                return !!_nextProxy;
            },
            getNext: function () {
                return _nextProxy;
            },
            setNext: function (nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (onComplete) {
            _onComplete[_DYN_PUSH$2 /* @min:%2epush */]({
                func: onComplete,
                self: !isUndefined$2(that) ? that : context.ctx,
                args: args
            });
        }
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[_DYN_GET_NEXT /* @min:%2egetNext */]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                arrForEach(onComplete, function (completeDetails) {
                    try {
                        completeDetails.func.call(completeDetails.self, completeDetails.args);
                    }
                    catch (e) {
                        _throwInternal(core[_DYN_LOGGER /* @min:%2elogger */], 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected Exception during onComplete - " + dumpObj(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, createIfMissing) {
        var idCfg = null;
        var cfg = dynamicHandler.cfg;
        if (cfg && identifier) {
            var extCfg = cfg[STR_EXTENSION_CONFIG /* @min:%2eextensionConfig */];
            if (!extCfg && createIfMissing) {
                extCfg = {};
            }
            // Always set the value so that the property always exists
            cfg[STR_EXTENSION_CONFIG] = extCfg; // Note: it is valid for the "value" to be undefined
            // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
            extCfg = dynamicHandler.ref(cfg, STR_EXTENSION_CONFIG);
            if (extCfg) {
                idCfg = extCfg[identifier];
                if (!idCfg && createIfMissing) {
                    idCfg = {};
                }
                // Always set the value so that the property always exists
                extCfg[identifier] = idCfg; // Note: it is valid for the "value" to be undefined
                // Calling `ref()` has a side effect of causing the referenced property to become dynamic  (if not already)
                idCfg = dynamicHandler.ref(extCfg, identifier);
            }
        }
        return idCfg;
    }
    function _resolveExtCfg(identifier, defaultValues) {
        var newConfig = _getExtCfg(identifier, true);
        if (defaultValues) {
            // Enumerate over the defaultValues and if not already populated attempt to
            // find a value from the root config or use the default value
            objForEachKey(defaultValues, function (field, defaultValue) {
                // for each unspecified field, set the default value
                if (isNullOrUndefined(newConfig[field])) {
                    var cfgValue = dynamicHandler.cfg[field];
                    if (cfgValue || !isNullOrUndefined(cfgValue)) {
                        newConfig[field] = cfgValue;
                    }
                }
                _applyDefaultValue(dynamicHandler, newConfig, field, defaultValue);
            });
        }
        return dynamicHandler[_DYN_SET_DF /* @min:%2esetDf */](newConfig, defaultValues);
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === undefined) { defaultValue = false; }
        var theValue;
        var extConfig = _getExtCfg(identifier, false);
        var rootConfig = dynamicHandler.cfg;
        if (extConfig && (extConfig[field] || !isNullOrUndefined(extConfig[field]))) {
            theValue = extConfig[field];
        }
        else if (rootConfig[field] || !isNullOrUndefined(rootConfig[field])) {
            theValue = rootConfig[field];
        }
        return (theValue || !isNullOrUndefined(theValue)) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while (!!(nextPlugin = context._next())) {
            var plugin = nextPlugin[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]();
            if (plugin) {
                // callback with the current on
                cb(plugin);
            }
        }
    }
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryContext(telemetryChain, cfg, core, startAt) {
    var config = createDynamicConfig(cfg);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        if (nextPlugin) {
            // Run the next plugin which will call "processNext()"
            nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, context);
        }
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === undefined) { plugins = null; }
        if (isArray$3(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), config.cfg, core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for handling the unloading of the chain
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUnloadContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core.config);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin[_DYN_UNLOAD /* @min:%2eunload */](context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === undefined) { plugins = null; }
        if (isArray$3(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUnloadContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates a new Telemetry Item context with the current config, core and plugin execution chain for updating the configuration
 * @param plugins - The plugin instances that will be executed
 * @param config - The current config
 * @param core - The current core instance
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 */
function createProcessTelemetryUpdateContext(telemetryChain, core, startAt) {
    var config = createDynamicConfig(core.config);
    var internalContext = _createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function (plugin) {
            if (isFunction$3(plugin[_DYN_UPDATE$1 /* @min:%2eupdate */])) {
                plugin[_DYN_UPDATE$1 /* @min:%2eupdate */](context, updateState);
            }
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === undefined) { plugins = null; }
        if (isArray$3(plugins)) {
            plugins = createTelemetryProxyChain(plugins, config.cfg, core, startAt);
        }
        return createProcessTelemetryUpdateContext(plugins || context[_DYN_GET_NEXT /* @min:%2egetNext */](), core, startAt);
    }
    context[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = _processNext;
    context[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */] = _createNew;
    return context;
}
/**
 * Creates an execution chain from the array of plugins
 * @param plugins - The array of plugins that will be executed in this order
 * @param defItemCtx - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 */
function createTelemetryProxyChain(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if (isArray$3(plugins) && plugins[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        arrForEach(plugins, function (thePlugin) {
            if (!add && startAt === thePlugin) {
                add = true;
            }
            if (add && thePlugin && isFunction$3(thePlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Only add plugins that are processors
                var newProxy = createTelemetryPluginProxy(thePlugin, config, core);
                if (!firstProxy) {
                    firstProxy = newProxy;
                }
                if (lastProxy_1) {
                    // Set this new proxy as the next for the previous one
                    lastProxy_1._setNext(newProxy);
                }
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) {
        // Special case where the "startAt" was not in the original list of plugins
        return createTelemetryProxyChain([startAt], config, core);
    }
    return firstProxy;
}
/**
 * Create the processing telemetry proxy instance, the proxy is used to abstract the current plugin to allow monitoring and
 * execution plugins while passing around the dynamic execution state (IProcessTelemetryContext), the proxy instance no longer
 * contains any execution state and can be reused between requests (this was not the case for 2.7.2 and earlier with the
 * TelemetryPluginChain class).
 * @param plugin - The plugin instance to proxy
 * @param config - The default execution context to use when no telemetry context is passed to processTelemetry(), this
 * should be for legacy plugins only. Currently, only used for passing the current core instance and to provide better error
 * reporting (hasRun) when errors occur.
 * @returns
 */
function createTelemetryPluginProxy(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = isFunction$3(plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */]);
    var hasSetNext = isFunction$3(plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */]);
    var chainId;
    if (plugin) {
        chainId = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "-" + plugin[STR_PRIORITY /* @min:%2epriority */] + "-" + _chainId++;
    }
    else {
        chainId = "Unknown-0-" + _chainId++;
    }
    var proxyChain = {
        getPlugin: function () {
            return plugin;
        },
        getNext: function () {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function (nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && isFunction$3(plugin[strGetTelCtx])) {
            // This plugin extends from the BaseTelemetryPlugin so lets use it
            itemCtx = plugin[strGetTelCtx]();
        }
        if (!itemCtx) {
            // Create a temporary one
            itemCtx = createProcessTelemetryContext(proxyChain, config, core);
        }
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] : strTelemetryPluginChain;
        var hasRunContext = itemCtx[strHasRunFlags];
        if (!hasRunContext) {
            // Assign and populate
            hasRunContext = itemCtx[strHasRunFlags] = {};
        }
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) {
            doPerf(itemCtx[STR_CORE /* @min:%2ecore */](), function () { return identifier + ":" + name; }, function () {
                // Mark this component as having run
                hasRunContext[chainId] = true;
                try {
                    // Set a flag on the next plugin so we know if it was attempted to be executed
                    var nextId = nextProxy ? nextProxy._id : STR_EMPTY$1;
                    if (nextId) {
                        hasRunContext[nextId] = false;
                    }
                    hasRun = processPluginFn(itemCtx);
                }
                catch (error) {
                    var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                    if (hasNextRun) {
                        // The next plugin after us has already run so set this one as complete
                        hasRun = true;
                    }
                    if (!nextProxy || !hasNextRun) {
                        // Either we have no next plugin or the current one did not attempt to call the next plugin
                        // Which means the current one is the root of the failure so log/report this failure
                        _throwInternal(itemCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 73 /* _eInternalMessageId.PluginException */, "Plugin [" + identifier + "] failed during " + name + " - " + dumpObj(error) + ", run flags: " + dumpObj(hasRunContext));
                    }
                }
            }, details, isAsync);
        }
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) {
                return false;
            }
            var pluginState = _getPluginState(plugin);
            if (pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] || pluginState[STR_DISABLED]) {
                return false;
            }
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) {
                // Backward compatibility setting the next plugin on the instance
                plugin[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */](nextProxy);
            }
            plugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function () { return ({ item: env }); }, !(env.sync))) {
            // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
            // so we still want the next plugin to be executed.
            itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
        }
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[STR_CORE /* @min:%2ecore */] = null;
                    pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] = true;
                    pluginState[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = false;
                    if (plugin[_DYN_TEARDOWN /* @min:%2eteardown */] && plugin[_DYN_TEARDOWN /* @min:%2eteardown */](unloadCtx, unloadState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function () { }, unloadState[_DYN_IS_ASYNC /* @min:%2eisAsync */])) {
            // Only called if we hasRun was not true
            unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
        }
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = _getPluginState(plugin);
                var pluginCore = plugin[STR_CORE] || pluginState[STR_CORE /* @min:%2ecore */];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */]) {
                    if (plugin[_DYN_UPDATE$1 /* @min:%2eupdate */] && plugin[_DYN_UPDATE$1 /* @min:%2eupdate */](updateCtx, updateState) === true) {
                        // plugin told us that it was going to (or has) call unloadCtx.processNext()
                        hasRun = true;
                    }
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function () { }, false)) {
            // Only called if we hasRun was not true
            updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
        }
    }
    return objFreeze(proxyChain);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function createUnloadHandlerContainer() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) {
            handlers[_DYN_PUSH$2 /* @min:%2epush */](handler);
        }
    }
    function _runHandlers(unloadCtx, unloadState) {
        arrForEach(handlers, function (handler) {
            try {
                handler(unloadCtx, unloadState);
            }
            catch (e) {
                _throwInternal(unloadCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unexpected error calling unload handler - " + dumpObj(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Create a IUnloadHookContainer which can be used to remember unload hook functions to be executed during the component unloading
 * process.
 * @returns A new IUnloadHookContainer instance
 */
function createUnloadHookContainer() {
    var _hooks = [];
    function _doUnload(logger) {
        var oldHooks = _hooks;
        _hooks = [];
        // Remove all registered unload hooks
        arrForEach(oldHooks, function (fn) {
            // allow either rm or remove callback function
            try {
                (fn.rm || fn.remove).call(fn);
            }
            catch (e) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, "Unloading:" + dumpObj(e));
            }
        });
    }
    function _addHook(hooks) {
        if (hooks) {
            arrAppend(_hooks, hooks);
        }
    }
    return {
        run: _doUnload,
        add: _addHook
    };
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$8;
var strGetPlugin = "getPlugin";
var defaultValues$1 = (_a$8 = {},
    _a$8[STR_EXTENSION_CONFIG] = { isVal: isNotNullOrUndefined, v: {} },
    _a$8);
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hookContainer;
        _initDefaults();
        dynamicProto(BaseTelemetryPlugin, _self, function (_self) {
            _self[_DYN_INITIALIZE$1 /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[_DYN_TEARDOWN /* @min:%2eteardown */] = function (unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (unloadCtx && core !== unloadCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                    return;
                }
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || createProcessTelemetryUnloadContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                        reason: 0 /* TelemetryUnloadReason.ManualTeardown */
                    },
                    _a[_DYN_IS_ASYNC /* @min:isAsync */] = false,
                    _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        _hookContainer.run(theUnloadCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]());
                        if (result === true) {
                            theUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](theUnloadState);
                        }
                        _initDefaults();
                    }
                }
                if (!_self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] || _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */](theUnloadCtx, theUnloadState, _unloadCallback) !== true) {
                    _unloadCallback();
                }
                else {
                    // Tell the caller that we will be calling processNext()
                    result = true;
                }
                return result;
            };
            _self[_DYN_UPDATE$1 /* @min:%2eupdate */] = function (updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[STR_CORE /* @min:%2ecore */];
                if (!core || (updateCtx && core !== updateCtx[STR_CORE /* @min:%2ecore */]())) {
                    // Do Nothing
                    return;
                }
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || createProcessTelemetryUpdateContext(null, core, _nextPlugin && _nextPlugin[strGetPlugin] ? _nextPlugin[strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[_DYN_GET_NEXT /* @min:%2egetNext */]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) {
                    _updateCallback();
                }
                else {
                    result = true;
                }
                return result;
            };
            proxyFunctionAs(_self, "_addUnloadCb", function () { return _unloadHandlerContainer; }, "add");
            proxyFunctionAs(_self, "_addHook", function () { return _hookContainer; }, "add");
            objDefine(_self, "_unloadHooks", { g: function () { return _hookContainer; } });
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */] = function (itemCtx) {
            return _getTelCtx(itemCtx)[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]();
        };
        _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[_DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */] = function (next) {
            _nextPlugin = next;
        };
        _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */] = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](env);
            }
            else if (_nextPlugin && isFunction$3(_nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */])) {
                // Looks like backward compatibility or out of band processing. And as it looks
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */](env, null);
            }
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === undefined) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || createProcessTelemetryContext(null, {}, _self[STR_CORE /* @min:%2ecore */]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](null, _nextPlugin);
                }
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            // Make sure the extensionConfig exists and the config is dynamic
            createDynamicConfig(config, defaultValues$1, safeGetLogger(core));
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core[_DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */]()[_DYN_GET_NEXT /* @min:%2egetNext */]();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self[STR_CORE /* @min:%2ecore */] = core;
            _rootCtx = createProcessTelemetryContext(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[STR_CORE /* @min:%2ecore */] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hookContainer = createUnloadHookContainer();
            _unloadHandlerContainer = createUnloadHandlerContainer();
        }
    }
// Removed Stub for BaseTelemetryPlugin.prototype.initialize.
// Removed Stub for BaseTelemetryPlugin.prototype.teardown.
// Removed Stub for BaseTelemetryPlugin.prototype.update.
// Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
// Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseTelemetryPlugin.__ieDyn=1;

    return BaseTelemetryPlugin;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// 
// 
function _addInitializer(_initializers, id, telemetryInitializer) {
    var theInitializer = {
        id: id,
        fn: telemetryInitializer
    };
    arrAppend(_initializers, theInitializer);
    var handler = {
        remove: function () {
            arrForEach(_initializers, function (initializer, idx) {
                if (initializer.id === theInitializer.id) {
                    _initializers[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return -1;
                }
            });
        }
    };
    return handler;
}
function _runInitializers(_initializers, item, logger) {
    var doNotSendItem = false;
    var telemetryInitializersCount = _initializers[_DYN_LENGTH$5 /* @min:%2elength */];
    for (var i = 0; i < telemetryInitializersCount; ++i) {
        var telemetryInitializer = _initializers[i];
        if (telemetryInitializer) {
            try {
                if (telemetryInitializer.fn[_DYN_APPLY /* @min:%2eapply */](null, [item]) === false) {
                    doNotSendItem = true;
                    break;
                }
            }
            catch (e) {
                // log error but dont stop executing rest of the telemetry initializers
                // doNotSendItem = true;
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Telemetry initializer failed: " + getExceptionName(e), { exception: dumpObj(e) }, true);
            }
        }
    }
    return !doNotSendItem;
}
var TelemetryInitializerPlugin = /** @class */ (function (_super) {
    __extendsFn(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        dynamicProto(TelemetryInitializerPlugin, _this, function (_self, _base) {
            _self.addTelemetryInitializer = function (telemetryInitializer) {
                return _addInitializer(_initializers, _id++, telemetryInitializer);
            };
            _self[STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */] = function (item, itemCtx) {
                if (_runInitializers(_initializers, item, itemCtx ? itemCtx[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]() : _self[_DYN_DIAG_LOG$2 /* @min:%2ediagLog */]())) {
                    _self[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](item, itemCtx);
                }
            };
            _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] = function () {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
// Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
// Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryInitializerPlugin.__ieDyn=1;

    return TelemetryInitializerPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _a$7;
var strValidationError = "Plugins must provide initialize method";
var strNotificationManager = "_notificationManager";
var strSdkUnloadingError = "SDK is still unloading...";
var strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
/**
 * The default settings for the config.
 * WE MUST include all defaults here to ensure that the config is created with all of the properties
 * defined as dynamic.
 */
var defaultConfig = objDeepFreeze((_a$7 = {
        cookieCfg: {}
    },
    _a$7[STR_EXTENSIONS] = { rdOnly: true, ref: true, v: [] },
    _a$7[STR_CHANNELS] = { rdOnly: true, ref: true, v: [] },
    _a$7[STR_EXTENSION_CONFIG] = { ref: true, v: {} },
    _a$7[STR_CREATE_PERF_MGR] = UNDEFINED_VALUE$2,
    _a$7.loggingLevelConsole = 0 /* eLoggingSeverity.DISABLED */,
    _a$7.diagnosticLogInterval = UNDEFINED_VALUE$2,
    _a$7));
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */
function _createPerfManager(core, notificationMgr) {
    return new PerfManager(notificationMgr);
}
function _validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    var channels = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    arrForEach(allExtensions, function (ext) {
        // Check for ext.initialize
        if (isNullOrUndefined(ext) || isNullOrUndefined(ext[_DYN_INITIALIZE$1 /* @min:%2einitialize */])) {
            throwError(strValidationError);
        }
        var extPriority = ext[STR_PRIORITY /* @min:%2epriority */];
        var identifier = ext[_DYN_IDENTIFIER /* @min:%2eidentifier */];
        if (ext && extPriority) {
            if (!isNullOrUndefined(extPriorities[extPriority])) {
                _warnToConsole(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            }
            else {
                // set a value
                extPriorities[extPriority] = identifier;
            }
        }
        // Split extensions to core and channels
        if (!extPriority || extPriority < channelPriority) {
            // Add to core extension that will be managed by AppInsightsCore
            coreExtensions[_DYN_PUSH$2 /* @min:%2epush */](ext);
        }
        else {
            channels[_DYN_PUSH$2 /* @min:%2epush */](ext);
        }
    });
    return _a = {},
        _a[STR_CORE /* @min:core */] = coreExtensions,
        _a[STR_CHANNELS /* @min:channels */] = channels,
        _a;
}
function _isPluginPresent(thePlugin, plugins) {
    var exists = false;
    arrForEach(plugins, function (plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function _deepMergeConfig(details, target, newValues, merge) {
    // Lets assign the new values to the existing config
    if (newValues) {
        objForEachKey(newValues, function (key, value) {
            if (merge) {
                if (isPlainObject$6(value) && isPlainObject$6(target[key])) {
                    // The target is an object and it has a value
                    _deepMergeConfig(details, target[key], value, merge);
                }
            }
            if (merge && isPlainObject$6(value) && isPlainObject$6(target[key])) {
                // The target is an object and it has a value
                _deepMergeConfig(details, target[key], value, merge);
            }
            else {
                // Just Assign (replace) and/or make the property dynamic
                details.set(target, key, value);
            }
        });
    }
}
function _findWatcher(listeners, newWatcher) {
    var theListener = null;
    var idx = -1;
    arrForEach(listeners, function (listener, lp) {
        if (listener.w === newWatcher) {
            theListener = listener;
            idx = lp;
            return -1;
        }
    });
    return { i: idx, l: theListener };
}
function _addDelayedCfgListener(listeners, newWatcher) {
    var theListener = _findWatcher(listeners, newWatcher).l;
    if (!theListener) {
        theListener = {
            w: newWatcher,
            rm: function () {
                var fnd = _findWatcher(listeners, newWatcher);
                if (fnd.i !== -1) {
                    listeners[_DYN_SPLICE /* @min:%2esplice */](fnd.i, 1);
                }
            }
        };
        listeners[_DYN_PUSH$2 /* @min:%2epush */](theListener);
    }
    return theListener;
}
function _registerDelayedCfgListener(config, listeners, logger) {
    arrForEach(listeners, function (listener) {
        var unloadHdl = onConfigChange(config, listener.w, logger);
        delete listener.w; // Clear the listener reference so it will get garbage collected.
        // replace the remove function
        listener.rm = function () {
            unloadHdl.rm();
        };
    });
}
/**
 * @group Classes
 * @group Entrypoint
 */
var AppInsightsCore = /** @class */ (function () {
    function AppInsightsCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _configHandler;
        var _isInitialized;
        var _logger;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _channelConfig;
        var _channels;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _hookContainer;
        var _debugListener;
        var _traceCtx;
        var _instrumentationKey;
        var _cfgListeners;
        var _extensions;
        var _pluginVersionStringArr;
        var _pluginVersionString;
        /**
         * Internal log poller
         */
        var _internalLogPoller;
        var _internalLogPollerListening;
        var _forceStopInternalLogPoller;
        dynamicProto(AppInsightsCore, this, function (_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
            _self["_getDbgPlgTargets"] = function () {
                return [_extensions];
            };
            _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */] = function () { return _isInitialized; };
            // Creating the self.initialize = ()
            _self[_DYN_INITIALIZE$1 /* @min:%2einitialize */] = function (config, extensions, logger, notificationManager) {
                if (_isUnloading) {
                    throwError(strSdkUnloadingError);
                }
                // Make sure core is only initialized once
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    throwError("Core cannot be initialized more than once");
                }
                _configHandler = createDynamicConfig(config, defaultConfig, logger || _self[_DYN_LOGGER /* @min:%2elogger */], false);
                // Re-assigning the local config property so we don't have any references to the passed value and it can be garbage collected
                config = _configHandler.cfg;
                // This will be "re-run" if the referenced config properties are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    _instrumentationKey = details.cfg.instrumentationKey;
                    // Mark the extensionConfig and all first level keys as referenced
                    // This is so that calls to getExtCfg() will always return the same object
                    // Even when a user may "re-assign" the plugin properties (or it's unloaded/reloaded)
                    var extCfg = details.ref(details.cfg, STR_EXTENSION_CONFIG);
                    objForEachKey(extCfg, function (key) {
                        details.ref(extCfg, key);
                    });
                    if (isNullOrUndefined(_instrumentationKey)) {
                        throwError("Please provide instrumentation key");
                    }
                }));
                _notificationManager = notificationManager;
                _initDebugListener();
                _initPerfManager();
                _self[_DYN_LOGGER /* @min:%2elogger */] = logger;
                var cfgExtensions = config[STR_EXTENSIONS /* @min:%2eextensions */];
                // Extension validation
                _configExtensions = [];
                _configExtensions[_DYN_PUSH$2 /* @min:%2epush */].apply(_configExtensions, __spreadArrayFn(__spreadArrayFn([], extensions, false), cfgExtensions));
                _channelConfig = config[STR_CHANNELS /* @min:%2echannels */];
                _initPluginChain(null);
                if (!_channels || _channels[_DYN_LENGTH$5 /* @min:%2elength */] === 0) {
                    throwError("No " + STR_CHANNELS + " available");
                }
                if (_channelConfig && _channelConfig[_DYN_LENGTH$5 /* @min:%2elength */] > 1) {
                    var teeController = _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */]("TeeChannelController");
                    if (!teeController || !teeController.plugin) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "TeeChannel required");
                    }
                }
                _registerDelayedCfgListener(config, _cfgListeners, _logger);
                _cfgListeners = null;
                _isInitialized = true;
                _self.releaseQueue();
                _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */]();
            };
            _self.getChannels = function () {
                var controls = [];
                if (_channels) {
                    arrForEach(_channels, function (channel) {
                        controls[_DYN_PUSH$2 /* @min:%2epush */](channel);
                    });
                }
                return objFreeze(controls);
            };
            _self.track = function (telemetryItem) {
                doPerf(_self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */](), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        throwError("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    if (!telemetryItem[_DYN_NAME$3 /* @min:%2ename */] && isNullOrUndefined(telemetryItem[_DYN_NAME$3 /* @min:%2ename */])) {
                        _notifyInvalidEvent(telemetryItem);
                        throwError("telemetry name required");
                    }
                    // setup default iKey if not passed in
                    telemetryItem.iKey = telemetryItem.iKey || _instrumentationKey;
                    // add default timestamp if not passed in
                    telemetryItem[_DYN_TIME /* @min:%2etime */] = telemetryItem[_DYN_TIME /* @min:%2etime */] || toISOString$2(new Date());
                    // Common Schema 4.0
                    telemetryItem.ver = telemetryItem.ver || "4.0";
                    if (!_isUnloading && _self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                        // Process the telemetry plugin chain
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](telemetryItem);
                    }
                    else {
                        // Queue events until all extensions are initialized
                        _eventQueue[_DYN_PUSH$2 /* @min:%2epush */](telemetryItem);
                    }
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            _self[_DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */] = _createTelCtx;
            _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */] = function () {
                if (!_notificationManager) {
                    _notificationManager = new NotificationManager(_configHandler.cfg);
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param listener - An INotificationListener object.
             */
            _self[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */] = function (listener) {
                _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]()[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param listener - INotificationListener to remove.
             */
            _self[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */] = function (listener) {
                if (_notificationManager) {
                    _notificationManager[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */](listener);
                }
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = createCookieMgr(_configHandler.cfg, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                if (_cookieManager !== cookieMgr) {
                    runTargetUnload(_cookieManager, false);
                    _cookieManager = cookieMgr;
                }
            };
            _self[STR_GET_PERF_MGR /* @min:%2egetPerfMgr */] = function () {
                if (!_perfManager && !_cfgPerfManager) {
                    _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                        if (details.cfg.enablePerfMgr) {
                            var createPerfMgr = details.cfg[STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */];
                            if (isFunction$3(createPerfMgr)) {
                                _cfgPerfManager = createPerfMgr(_self, _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]());
                            }
                        }
                    }));
                }
                return _perfManager || _cfgPerfManager || getGblPerfMgr();
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue[_DYN_LENGTH$5 /* @min:%2elength */];
            };
            _self.releaseQueue = function () {
                if (_isInitialized && _eventQueue[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    arrForEach(eventQueue, function (event) {
                        _createTelCtx()[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](event);
                    });
                }
            };
            _self[_DYN_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */] = function (eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                return _startLogPoller(true);
            };
            function _startLogPoller(alwaysStart) {
                if ((!_internalLogPoller || !_internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */]) && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || (_logger && _logger.queue[_DYN_LENGTH$5 /* @min:%2elength */] > 0);
                    if (shouldStart) {
                        if (!_internalLogPollerListening) {
                            _internalLogPollerListening = true;
                            // listen for any configuration changes so that changes to the
                            // interval will cause the timer to be re-initialized
                            _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                                var interval = details.cfg.diagnosticLogInterval;
                                if (!interval || !(interval > 0)) {
                                    interval = 10000;
                                }
                                var isRunning = false;
                                if (_internalLogPoller) {
                                    // It was already created so remember it's running and cancel
                                    isRunning = _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */];
                                    _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                                }
                                // Create / reconfigure
                                _internalLogPoller = createTimeout(_flushInternalLogs, interval);
                                _internalLogPoller.unref();
                                // Restart if previously running
                                _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = isRunning;
                            }));
                        }
                        _internalLogPoller[_DYN_ENABLED /* @min:%2eenabled */] = true;
                    }
                }
                return _internalLogPoller;
            }
            _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */] = function () {
                _forceStopInternalLogPoller = true;
                _internalLogPoller && _internalLogPoller[_DYN_CANCEL /* @min:%2ecancel */]();
                _flushInternalLogs();
            };
            // Add addTelemetryInitializer
            proxyFunctions(_self, function () { return _telemetryInitializerPlugin; }, ["addTelemetryInitializer"]);
            _self[_DYN_UNLOAD /* @min:%2eunload */] = function (isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === undefined) { isAsync = true; }
                if (!_isInitialized) {
                    // The SDK is not initialized
                    throwError(strSdkNotInitialized);
                }
                // Check if the SDK still unloading so throw
                if (_isUnloading) {
                    // The SDK is already unloading
                    throwError(strSdkUnloadingError);
                }
                var unloadState = (_a = {
                        reason: 50 /* TelemetryUnloadReason.SdkUnload */
                    },
                    _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync,
                    _a.flushComplete = false,
                    _a);
                var result;
                if (isAsync && !unloadComplete) {
                    result = createPromise(function (resolve) {
                        // Set the callback to the promise resolve callback
                        unloadComplete = resolve;
                    });
                }
                var processUnloadCtx = createProcessTelemetryUnloadContext(_getPluginChain(), _self);
                processUnloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                    _hookContainer.run(_self[_DYN_LOGGER /* @min:%2elogger */]);
                    // Run any "unload" functions for the _cookieManager, _notificationManager and _logger
                    doUnloadAll([_cookieManager, _notificationManager, _logger], isAsync, function () {
                        _initDefaults();
                        unloadComplete && unloadComplete(unloadState);
                    });
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[_DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */, cbTimeout)) ;
                return result;
            };
            _self[_DYN_GET_PLUGIN /* @min:%2egetPlugin */] = _getPlugin;
            _self.addPlugin = function (plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError(strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */
                };
                function _addPlugin(removed) {
                    _configExtensions[_DYN_PUSH$2 /* @min:%2epush */](plugin);
                    updateState.added = [plugin];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [existingPlugin.plugin];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function (removed) {
                        if (!removed) {
                            // Previous plugin was successfully removed or was not installed
                            addCb && addCb(false);
                        }
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */;
                            _addPlugin();
                        }
                    });
                }
                else {
                    _addPlugin();
                }
            };
            _self.updateCfg = function (newConfig, mergeExisting) {
                if (mergeExisting === undefined) { mergeExisting = true; }
                var updateState;
                if (_self[_DYN_IS_INITIALIZED /* @min:%2eisInitialized */]()) {
                    updateState = {
                        reason: 1 /* TelemetryUpdateReason.ConfigurationChanged */,
                        cfg: _configHandler.cfg,
                        oldCfg: deepExtend({}, _configHandler.cfg),
                        newConfig: deepExtend({}, newConfig),
                        merge: mergeExisting
                    };
                    newConfig = updateState.newConfig;
                    var cfg = _configHandler.cfg;
                    // replace the immutable (if initialized) values
                    // We don't currently allow updating the extensions and channels via the update config
                    // So overwriting any user provided values to reuse the existing values
                    newConfig[STR_EXTENSIONS /* @min:%2eextensions */] = cfg[STR_EXTENSIONS /* @min:%2eextensions */];
                    newConfig[STR_CHANNELS /* @min:%2echannels */] = cfg[STR_CHANNELS /* @min:%2echannels */];
                }
                // Explicitly blocking any previous config watchers so that they don't get called because
                // of this bulk update (Probably not necessary)
                _configHandler._block(function (details) {
                    // Lets assign the new values to the existing config either overwriting or re-assigning
                    var theConfig = details.cfg;
                    _deepMergeConfig(details, theConfig, newConfig, mergeExisting);
                    if (!mergeExisting) {
                        // Remove (unassign) the values "missing" from the newConfig and also not in the default config
                        objForEachKey(theConfig, function (key) {
                            if (!objHasOwn(newConfig, key)) {
                                // Set the value to undefined
                                details.set(theConfig, key, UNDEFINED_VALUE$2);
                            }
                        });
                    }
                    // Apply defaults to the new config
                    details[_DYN_SET_DF /* @min:%2esetDf */](theConfig, defaultConfig);
                }, true);
                // Now execute all of the listeners (synchronously) so they update their values immediately
                _configHandler[_DYN_NOTIFY /* @min:%2enotify */]();
                if (updateState) {
                    _doUpdate(updateState);
                }
            };
            _self.evtNamespace = function () {
                return _evtNamespace;
            };
            _self.flush = _flushChannels;
            _self.getTraceCtx = function (createNew) {
                if (!_traceCtx) {
                    _traceCtx = createDistributedTraceContext();
                }
                return _traceCtx;
            };
            _self.setTraceCtx = function (traceCtx) {
                _traceCtx = traceCtx || null;
            };
            _self.addUnloadHook = _addUnloadHook;
            // Create the addUnloadCb
            proxyFunctionAs(_self, "addUnloadCb", function () { return _unloadHandlers; }, "add");
            _self.onCfgChange = function (handler) {
                var unloadHook;
                if (!_isInitialized) {
                    unloadHook = _addDelayedCfgListener(_cfgListeners, handler);
                }
                else {
                    unloadHook = onConfigChange(_configHandler.cfg, handler, _self[_DYN_LOGGER /* @min:%2elogger */]);
                }
                return {
                    rm: function () {
                        unloadHook.rm();
                    }
                };
            };
            _self.getWParam = function () {
                return (hasDocument() || !!_configHandler.cfg.enableWParam) ? 0 : -1;
            };
            function _setPluginVersions() {
                var thePlugins = {};
                _pluginVersionStringArr = [];
                var _addPluginVersions = function (plugins) {
                    if (plugins) {
                        arrForEach(plugins, function (plugin) {
                            if (plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] && plugin[_DYN_VERSION$1 /* @min:%2eversion */] && !thePlugins[plugin.identifier]) {
                                var ver = plugin[_DYN_IDENTIFIER /* @min:%2eidentifier */] + "=" + plugin[_DYN_VERSION$1 /* @min:%2eversion */];
                                _pluginVersionStringArr[_DYN_PUSH$2 /* @min:%2epush */](ver);
                                thePlugins[plugin.identifier] = plugin;
                            }
                        });
                    }
                };
                _addPluginVersions(_channels);
                if (_channelConfig) {
                    arrForEach(_channelConfig, function (channels) {
                        _addPluginVersions(channels);
                    });
                }
                _addPluginVersions(_configExtensions);
            }
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _configHandler = createDynamicConfig({}, defaultConfig, _self[_DYN_LOGGER /* @min:%2elogger */]);
                // Set the logging level to critical so that any critical initialization failures are displayed on the console
                _configHandler.cfg[_DYN_LOGGING_LEVEL_CONSOL4 /* @min:%2eloggingLevelConsole */] = 1 /* eLoggingSeverity.CRITICAL */;
                // Define _self.config
                objDefine(_self, "config", {
                    g: function () { return _configHandler.cfg; },
                    s: function (newValue) {
                        _self.updateCfg(newValue, false);
                    }
                });
                objDefine(_self, "pluginVersionStringArr", {
                    g: function () {
                        if (!_pluginVersionStringArr) {
                            _setPluginVersions();
                        }
                        return _pluginVersionStringArr;
                    }
                });
                objDefine(_self, "pluginVersionString", {
                    g: function () {
                        if (!_pluginVersionString) {
                            if (!_pluginVersionStringArr) {
                                _setPluginVersions();
                            }
                            _pluginVersionString = _pluginVersionStringArr.join(";");
                        }
                        return _pluginVersionString || STR_EMPTY$1;
                    }
                });
                objDefine(_self, "logger", {
                    g: function () {
                        if (!_logger) {
                            _logger = new DiagnosticLogger(_configHandler.cfg);
                            _configHandler[_DYN_LOGGER /* @min:%2elogger */] = _logger;
                        }
                        return _logger;
                    },
                    s: function (newLogger) {
                        _configHandler[_DYN_LOGGER /* @min:%2elogger */] = newLogger;
                        if (_logger !== newLogger) {
                            runTargetUnload(_logger, false);
                            _logger = newLogger;
                        }
                    }
                });
                _self[_DYN_LOGGER /* @min:%2elogger */] = new DiagnosticLogger(_configHandler.cfg);
                _extensions = [];
                var cfgExtensions = _self.config[STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$5 /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                _telemetryInitializerPlugin = new TelemetryInitializerPlugin();
                _eventQueue = [];
                runTargetUnload(_notificationManager, false);
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                runTargetUnload(_cookieManager, false);
                _cookieManager = null;
                _pluginChain = null;
                _configExtensions = [];
                _channelConfig = null;
                _channels = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = createUniqueNamespace("AIBaseCore", true);
                _unloadHandlers = createUnloadHandlerContainer();
                _traceCtx = null;
                _instrumentationKey = null;
                _hookContainer = createUnloadHookContainer();
                _cfgListeners = [];
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                _forceStopInternalLogPoller = false;
            }
            function _createTelCtx() {
                var theCtx = createProcessTelemetryContext(_getPluginChain(), _configHandler.cfg, _self);
                theCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = _validateExtensions(_self[_DYN_LOGGER /* @min:%2elogger */], ChannelControllerPriority, _configExtensions);
                _pluginChain = null;
                _pluginVersionString = null;
                _pluginVersionStringArr = null;
                // Get the primary channel queue and include as part of the normal extensions
                _channels = (_channelConfig || [])[0] || [];
                // Add any channels provided in the extensions and sort them
                _channels = sortPlugins(arrAppend(_channels, theExtensions[STR_CHANNELS /* @min:%2echannels */]));
                // Create an array of all extensions, including the _channels
                var allExtensions = arrAppend(sortPlugins(theExtensions[STR_CORE /* @min:%2ecore */]), _channels);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _extensions = objFreeze(allExtensions);
                // This has a side effect of adding the extensions passed during initialization
                // into the config.extensions, so you can see all of the extensions loaded.
                // This will also get updated by the addPlugin() and remove plugin code.
                var cfgExtensions = _self.config[STR_EXTENSIONS /* @min:%2eextensions */] || [];
                cfgExtensions.splice(0, cfgExtensions[_DYN_LENGTH$5 /* @min:%2elength */]);
                arrAppend(cfgExtensions, _extensions);
                var rootCtx = _createTelCtx();
                // Initializing the channels first
                if (_channels && _channels[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    initializePlugins(rootCtx[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](_channels), allExtensions);
                }
                // Now initialize the normal extensions (explicitly not including the _channels as this can cause duplicate initialization)
                initializePlugins(rootCtx, allExtensions);
                if (updateState) {
                    _doUpdate(updateState);
                }
            }
            function _getPlugin(pluginIdentifier) {
                var theExt = null;
                var thePlugin = null;
                var channelHosts = [];
                arrForEach(_extensions, function (ext) {
                    if (ext[_DYN_IDENTIFIER /* @min:%2eidentifier */] === pluginIdentifier && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                    if (ext.getChannel) {
                        channelHosts[_DYN_PUSH$2 /* @min:%2epush */](ext);
                    }
                });
                if (!thePlugin && channelHosts[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    arrForEach(channelHosts, function (host) {
                        thePlugin = host.getChannel(pluginIdentifier);
                        if (!thePlugin) {
                            return -1;
                        }
                    });
                }
                if (thePlugin) {
                    theExt = {
                        plugin: thePlugin,
                        setEnabled: function (enabled) {
                            _getPluginState(thePlugin)[STR_DISABLED] = !enabled;
                        },
                        isEnabled: function () {
                            var pluginState = _getPluginState(thePlugin);
                            return !pluginState[_DYN_TEARDOWN /* @min:%2eteardown */] && !pluginState[STR_DISABLED];
                        },
                        remove: function (isAsync, removeCb) {
                            var _a;
                            if (isAsync === undefined) { isAsync = true; }
                            var pluginsToRemove = [thePlugin];
                            var unloadState = (_a = {
                                    reason: 1 /* TelemetryUnloadReason.PluginUnload */
                                },
                                _a[_DYN_IS_ASYNC /* @min:isAsync */] = isAsync,
                                _a);
                            _removePlugins(pluginsToRemove, unloadState, function (removed) {
                                if (removed) {
                                    // Re-Initialize the plugin chain
                                    _initPluginChain({
                                        reason: 32 /* TelemetryUpdateReason.PluginRemoved */,
                                        removed: pluginsToRemove
                                    });
                                }
                                removeCb && removeCb(removed);
                            });
                        }
                    };
                }
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_extensions || []).slice();
                    // During add / remove this may get called again, so don't read if already present
                    if (arrIndexOf(extensions, _telemetryInitializerPlugin) === -1) {
                        extensions[_DYN_PUSH$2 /* @min:%2epush */](_telemetryInitializerPlugin);
                    }
                    _pluginChain = createTelemetryProxyChain(sortPlugins(extensions), _configHandler.cfg, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var unloadChain = createTelemetryProxyChain(thePlugins, _configHandler.cfg, _self);
                    var unloadCtx = createProcessTelemetryUnloadContext(unloadChain, _self);
                    unloadCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](function () {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        arrForEach(_configExtensions, function (plugin, idx) {
                            if (!_isPluginPresent(plugin, thePlugins)) {
                                newConfigExtensions[_DYN_PUSH$2 /* @min:%2epush */](plugin);
                            }
                            else {
                                removed = true;
                            }
                        });
                        _configExtensions = newConfigExtensions;
                        _pluginVersionString = null;
                        _pluginVersionStringArr = null;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            arrForEach(_channelConfig, function (queue, idx) {
                                var newQueue = [];
                                arrForEach(queue, function (channel) {
                                    if (!_isPluginPresent(channel, thePlugins)) {
                                        newQueue[_DYN_PUSH$2 /* @min:%2epush */](channel);
                                    }
                                    else {
                                        removed = true;
                                    }
                                });
                                newChannelConfig[_DYN_PUSH$2 /* @min:%2epush */](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startLogPoller();
                    });
                    unloadCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](unloadState);
                }
                else {
                    removeComplete(false);
                }
            }
            function _flushInternalLogs() {
                if (_logger && _logger.queue) {
                    var queue = _logger.queue.slice(0);
                    _logger.queue[_DYN_LENGTH$5 /* @min:%2elength */] = 0;
                    arrForEach(queue, function (logMessage) {
                        var _a;
                        var item = (_a = {},
                            _a[_DYN_NAME$3 /* @min:name */] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[_DYN_MESSAGE_ID /* @min:%2emessageId */],
                            _a.iKey = _instrumentationKey,
                            _a[_DYN_TIME /* @min:time */] = toISOString$2(new Date()),
                            _a.baseType = _InternalLogMessage.dataType,
                            _a.baseData = { message: logMessage[_DYN_MESSAGE$2 /* @min:%2emessage */] },
                            _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                // Setting waiting to one so that we don't call the callBack until we finish iterating
                var waiting = 1;
                var doneIterating = false;
                var cbTimer = null;
                cbTimeout = cbTimeout || 5000;
                function doCallback() {
                    waiting--;
                    if (doneIterating && waiting === 0) {
                        cbTimer && cbTimer[_DYN_CANCEL /* @min:%2ecancel */]();
                        cbTimer = null;
                        callBack && callBack(doneIterating);
                        callBack = null;
                    }
                }
                if (_channels && _channels[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    var flushCtx = _createTelCtx()[_DYN_CREATE_NEW$1 /* @min:%2ecreateNew */](_channels);
                    flushCtx.iterate(function (plugin) {
                        if (plugin.flush) {
                            waiting++;
                            var handled_1 = false;
                            // Not all channels will call this callback for every scenario
                            if (!plugin.flush(isAsync, function () {
                                handled_1 = true;
                                doCallback();
                            }, sendReason)) {
                                if (!handled_1) {
                                    // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                    // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                    // followup function (such as unloading)
                                    if (isAsync && cbTimer == null) {
                                        cbTimer = scheduleTimeout(function () {
                                            cbTimer = null;
                                            doCallback();
                                        }, cbTimeout);
                                    }
                                    else {
                                        doCallback();
                                    }
                                }
                            }
                        }
                    });
                }
                doneIterating = true;
                doCallback();
                return true;
            }
            function _initDebugListener() {
                // Lazily ensure that the notification manager is created
                !_notificationManager && _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var disableDbgExt = details.cfg.disableDbgExt;
                    if (disableDbgExt === true && _debugListener) {
                        // Remove any previously loaded debug listener
                        _notificationManager[_DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */](_debugListener);
                        _debugListener = null;
                    }
                    if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                        _debugListener = getDebugListener(details.cfg);
                        _notificationManager[_DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */](_debugListener);
                    }
                }));
            }
            function _initPerfManager() {
                // Will get recalled if any referenced config values are changed
                _addUnloadHook(_configHandler[_DYN_WATCH /* @min:%2ewatch */](function (details) {
                    var enablePerfMgr = details.cfg.enablePerfMgr;
                    if (!enablePerfMgr && _cfgPerfManager) {
                        // Remove any existing config based performance manager
                        _cfgPerfManager = null;
                    }
                    if (enablePerfMgr) {
                        // Set the performance manager creation function if not defined
                        getSetValue(details.cfg, STR_CREATE_PERF_MGR, _createPerfManager);
                    }
                }));
            }
            function _doUpdate(updateState) {
                var updateCtx = createProcessTelemetryUpdateContext(_getPluginChain(), _self);
                updateCtx[_DYN_ON_COMPLETE /* @min:%2eonComplete */](_startLogPoller);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) {
                    updateCtx[_DYN_PROCESS_NEXT /* @min:%2eprocessNext */](updateState);
                }
            }
            function _logOrThrowError(message) {
                var logger = _self[_DYN_LOGGER /* @min:%2elogger */];
                if (logger) {
                    // there should always be a logger
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 73 /* _eInternalMessageId.PluginException */, message);
                    _startLogPoller();
                }
                else {
                    throwError(message);
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[_DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */]();
                if (manager) {
                    manager[STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */]([telemetryItem], 2 /* eEventsDiscardedReason.InvalidEvent */);
                }
            }
            function _addUnloadHook(hooks) {
                _hookContainer.add(hooks);
            }
        });
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.getChannels.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.getProcessTelContext.
// Removed Stub for AppInsightsCore.prototype.getNotifyMgr.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.getCookieMgr.
// Removed Stub for AppInsightsCore.prototype.setCookieMgr.
// Removed Stub for AppInsightsCore.prototype.getPerfMgr.
// Removed Stub for AppInsightsCore.prototype.setPerfMgr.
// Removed Stub for AppInsightsCore.prototype.eventCnt.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
// Removed Stub for AppInsightsCore.prototype.stopPollingInternalLogs.
// Removed Stub for AppInsightsCore.prototype.addTelemetryInitializer.
// Removed Stub for AppInsightsCore.prototype.unload.
// Removed Stub for AppInsightsCore.prototype.getPlugin.
// Removed Stub for AppInsightsCore.prototype.addPlugin.
// Removed Stub for AppInsightsCore.prototype.updateCfg.
// Removed Stub for AppInsightsCore.prototype.evtNamespace.
// Removed Stub for AppInsightsCore.prototype.addUnloadCb.
// Removed Stub for AppInsightsCore.prototype.flush.
// Removed Stub for AppInsightsCore.prototype.getTraceCtx.
// Removed Stub for AppInsightsCore.prototype.setTraceCtx.
// Removed Stub for AppInsightsCore.prototype.addUnloadHook.
// Removed Stub for AppInsightsCore.prototype.onCfgChange.
// Removed Stub for AppInsightsCore.prototype.releaseQueue.
// Removed Stub for AppInsightsCore.prototype._updateHook.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    AppInsightsCore.__ieDyn=1;

    return AppInsightsCore;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var STR_EMPTY = "";
var STR_NO_RESPONSE_BODY = "NoResponseBody";
var _noResponseQs = "&" + STR_NO_RESPONSE_BODY + "=true";
var STR_POST_METHOD = "POST";
/**
 * This Internal component
 * Manager SendPost functions
 * SendPostManger
 * @internal for internal use only
 */
var SenderPostManager = /** @class */ (function () {
    function SenderPostManager() {
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _enableSendPromise;
        var _isInitialized;
        var _diagLog;
        var _isOneDs;
        var _onCompleteFuncs;
        var _disableCredentials;
        var _fallbackInst;
        var _disableXhr;
        var _disableBeacon;
        var _disableBeaconSync;
        var _disableFetchKeepAlive;
        var _addNoResponse;
        var _timeoutWrapper;
        dynamicProto(SenderPostManager, this, function (_self, _base) {
            var _sendCredentials = true; // for 1ds
            _initDefaults();
            _self[_DYN_INITIALIZE$1 /* @min:%2einitialize */] = function (config, diagLog) {
                _diagLog = diagLog;
                if (_isInitialized) {
                    _throwInternal(_diagLog, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _self.SetConfig(config);
                _isInitialized = true;
            };
            _self["_getDbgPlgTargets"] = function () {
                return [_isInitialized, _isOneDs, _disableCredentials, _enableSendPromise];
            };
            // This componet might get its config from sender, offline sender, 1ds post
            // so set this function to mock dynamic changes
            _self.SetConfig = function (config) {
                try {
                    _onCompleteFuncs = config.senderOnCompleteCallBack || {};
                    _disableCredentials = !!config.disableCredentials;
                    _isOneDs = !!config.isOneDs;
                    _enableSendPromise = !!config.enableSendPromise;
                    _disableXhr = !!config.disableXhr;
                    _disableBeacon = !!config.disableBeacon;
                    _disableBeaconSync = !!config.disableBeaconSync;
                    _timeoutWrapper = config.timeWrapper;
                    _addNoResponse = !!config.addNoResponse;
                    _disableFetchKeepAlive = !!config.disableFetchKeepAlive;
                    _fallbackInst = { sendPOST: _xhrSender };
                    if (!_isOneDs) {
                        _sendCredentials = false; // for appInsights, set it to false always
                    }
                    if (_disableCredentials) {
                        var location_1 = getLocation$1();
                        if (location_1 && location_1.protocol && location_1.protocol[_DYN_TO_LOWER_CASE$2 /* @min:%2etoLowerCase */]() === "file:") {
                            // Special case where a local html file fails with a CORS error on Chromium browsers
                            _sendCredentials = false;
                        }
                    }
                    return true;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return false;
            };
            _self.getSyncFetchPayload = function () {
                return _syncFetchPayload;
            };
            _self.getSenderInst = function (transports, sync) {
                if (transports && transports[_DYN_LENGTH$5 /* @min:%2elength */]) {
                    return _getSenderInterface(transports, sync);
                }
                return null;
            };
            _self.getFallbackInst = function () {
                return _fallbackInst;
            };
            _self[_DYN__DO_TEARDOWN /* @min:%2e_doTeardown */] = function (unloadCtx, unloadState) {
                _initDefaults();
            };
            /**
             * success handler
             */
            function _onSuccess(res, onComplete) {
                _doOnComplete(onComplete, 200, {}, res);
            }
            /**
             * error handler
             */
            function _onError(message, onComplete) {
                _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _doOnComplete(onComplete, 400, {});
            }
            function _onNoPayloadUrl(onComplete) {
                _onError("No endpoint url is provided for the batch", onComplete);
            }
            function _getSenderInterface(transports, syncSupport) {
                var _a;
                var transportType = 0 /* TransportType.NotSet */;
                var sendPostFunc = null;
                var lp = 0;
                while (sendPostFunc == null && lp < transports[_DYN_LENGTH$5 /* @min:%2elength */]) {
                    transportType = transports[lp];
                    if (!_disableXhr && transportType === 1 /* TransportType.Xhr */) {
                        if (useXDomainRequest()) {
                            // IE 8 and 9
                            sendPostFunc = _xdrSender;
                        }
                        else if (isXhrSupported()) {
                            sendPostFunc = _xhrSender;
                        }
                    }
                    else if (transportType === 2 /* TransportType.Fetch */ && isFetchSupported$1(syncSupport) && (!syncSupport || !_disableFetchKeepAlive)) {
                        sendPostFunc = _doFetchSender;
                    }
                    else if (transportType === 3 /* TransportType.Beacon */ && isBeaconsSupported() && (syncSupport ? !_disableBeaconSync : !_disableBeacon)) {
                        sendPostFunc = _beaconSender;
                    }
                    lp++;
                }
                if (sendPostFunc) {
                    return _a = {
                            _transport: transportType,
                            _isSync: syncSupport
                        },
                        _a[_DYN_SEND_POST /* @min:sendPOST */] = sendPostFunc,
                        _a;
                }
                return null;
            }
            function _doOnComplete(oncomplete, status, headers, response) {
                try {
                    oncomplete && oncomplete(status, headers, response);
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
            }
            function _doBeaconSend(payload, oncomplete) {
                var nav = getNavigator();
                var url = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!url) {
                    _onNoPayloadUrl(oncomplete);
                    // return true here, because we don't want to retry it with fallback sender
                    return true;
                }
                url = payload[_DYN_URL_STRING /* @min:%2eurlString */] + (_addNoResponse ? _noResponseQs : STR_EMPTY);
                var data = payload[_DYN_DATA$1 /* @min:%2edata */];
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = _isOneDs ? data : new Blob([data], { type: "text/plain;charset=UTF-8" });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _beaconSender(payload, oncomplete, sync) {
                var data = payload[_DYN_DATA$1 /* @min:%2edata */];
                try {
                    if (data) {
                        // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                        if (!_doBeaconSend(payload, oncomplete)) {
                            var onRetry = _onCompleteFuncs && _onCompleteFuncs.beaconOnRetry;
                            if (onRetry && isFunction$3(onRetry)) {
                                onRetry(payload, oncomplete, _doBeaconSend);
                            }
                            else {
                                _fallbackInst && _fallbackInst[_DYN_SEND_POST /* @min:%2esendPOST */](payload, oncomplete, true);
                                _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                            }
                        }
                        else {
                            // if can send
                            _onSuccess(STR_EMPTY, oncomplete);
                        }
                    }
                }
                catch (e) {
                    _isOneDs && _warnToConsole(_diagLog, "Failed to send telemetry using sendBeacon API. Ex:" + dumpObj(e));
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, STR_EMPTY);
                }
                return;
            }
            /**
             * Send XMLHttpRequest
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - Indicates if the request should be sent synchronously
             */
            function _xhrSender(payload, oncomplete, sync) {
                //let  internalPayload = payload as IInternalPayloadData;
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var headers = payload[_DYN_HEADERS$1 /* @min:%2eheaders */] || {};
                if (!sync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                if (_isOneDs && sync && payload.disableXhrSync) {
                    sync = false;
                }
                //const xhr = new XMLHttpRequest();
                var endPointUrl = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                var xhr = openXhr(STR_POST_METHOD, endPointUrl, _sendCredentials, true, sync, payload[_DYN_TIMEOUT /* @min:%2etimeout */]);
                xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */]("Content-type", "application/json");
                arrForEach(objKeys(headers), function (headerName) {
                    xhr[_DYN_SET_REQUEST_HEADER$1 /* @min:%2esetRequestHeader */](headerName, headers[headerName]);
                });
                xhr.onreadystatechange = function () {
                    if (!_isOneDs) {
                        _doOnReadyFunc(xhr);
                        if (xhr.readyState === 4) {
                            resolveFunc && resolveFunc(true);
                        }
                    }
                };
                xhr.onload = function () {
                    if (_isOneDs) {
                        _doOnReadyFunc(xhr);
                    }
                };
                function _doOnReadyFunc(xhr) {
                    var onReadyFunc = _onCompleteFuncs && _onCompleteFuncs.xhrOnComplete;
                    var onReadyFuncExist = onReadyFunc && isFunction$3(onReadyFunc);
                    if (onReadyFuncExist) {
                        onReadyFunc(xhr, oncomplete, payload);
                    }
                    else {
                        var response = getResponseText(xhr);
                        _doOnComplete(oncomplete, xhr[_DYN_STATUS$1 /* @min:%2estatus */], _getAllResponseHeaders(xhr, _isOneDs), response);
                    }
                }
                xhr.onerror = function (event) {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS$1 /* @min:%2estatus */] : 400, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY : formatErrorMessageXhr(xhr));
                    rejectFunc && rejectFunc(event);
                };
                xhr.ontimeout = function () {
                    _doOnComplete(oncomplete, _isOneDs ? xhr[_DYN_STATUS$1 /* @min:%2estatus */] : 500, _getAllResponseHeaders(xhr, _isOneDs), _isOneDs ? STR_EMPTY : formatErrorMessageXhr(xhr));
                    resolveFunc && resolveFunc(false);
                };
                xhr.send(payload[_DYN_DATA$1 /* @min:%2edata */]);
                return thePromise;
            }
            /**
             * Send fetch API request
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */
            function _doFetchSender(payload, oncomplete, sync) {
                var _a;
                var endPointUrl = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                var batch = payload[_DYN_DATA$1 /* @min:%2edata */];
                var plainTextBatch = _isOneDs ? batch : new Blob([batch], { type: "application/json" });
                var thePromise;
                var resolveFunc;
                var rejectFunc;
                var requestHeaders = new Headers();
                var batchLength = batch[_DYN_LENGTH$5 /* @min:%2elength */];
                var ignoreResponse = false;
                var responseHandled = false;
                var headers = payload[_DYN_HEADERS$1 /* @min:%2eheaders */] || {};
                //TODO: handle time out for 1ds
                var init = (_a = {
                        method: STR_POST_METHOD,
                        body: plainTextBatch
                    },
                    _a[DisabledPropertyName$1] = true // Mark so we don't attempt to track this request
                ,
                    _a);
                // Only add headers if there are headers to add, due to issue with some polyfills
                if (payload.headers && objKeys(payload.headers)[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
                    arrForEach(objKeys(headers), function (headerName) {
                        requestHeaders.append(headerName, headers[headerName]);
                    });
                    init[_DYN_HEADERS$1 /* @min:%2eheaders */] = requestHeaders;
                }
                if (_sendCredentials && _isOneDs) {
                    // for 1ds, Don't send credentials when URL is file://
                    init.credentials = "include";
                }
                if (sync) {
                    init.keepalive = true;
                    _syncFetchPayload += batchLength;
                    if (_isOneDs) {
                        if (payload["_sendReason"] === 2 /* SendRequestReason.Unload */) {
                            // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                            // just like beacon send assume that the events have been accepted and processed
                            ignoreResponse = true;
                            if (_addNoResponse) {
                                endPointUrl += _noResponseQs;
                            }
                        }
                    }
                    else {
                        // for appinsights, set to true for all sync request
                        ignoreResponse = true;
                    }
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[DisabledPropertyName$1] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                if (!sync && _enableSendPromise) {
                    thePromise = createPromise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                }
                if (!endPointUrl) {
                    _onNoPayloadUrl(oncomplete);
                    resolveFunc && resolveFunc(false);
                    return;
                }
                function _handleError(res) {
                    // In case there is an error in the request. Set the status to 0 for 1ds and 400 for appInsights
                    // so that the events can be retried later.
                    _doOnComplete(oncomplete, _isOneDs ? 0 : 400, {}, _isOneDs ? STR_EMPTY : res);
                }
                function _onFetchComplete(response, payload, value) {
                    var status = response[_DYN_STATUS$1 /* @min:%2estatus */];
                    var onCompleteFunc = _onCompleteFuncs.fetchOnComplete;
                    if (onCompleteFunc && isFunction$3(onCompleteFunc)) {
                        onCompleteFunc(response, oncomplete, value || STR_EMPTY, payload);
                    }
                    else {
                        _doOnComplete(oncomplete, status, {}, value || STR_EMPTY);
                    }
                }
                try {
                    doAwaitResponse(fetch(_isOneDs ? endPointUrl : request, _isOneDs ? init : null), function (result) {
                        if (sync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            if (!result.rejected) {
                                var response_1 = result.value;
                                try {
                                    /**
                                     * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                                     * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                                     * or if anything prevented the request from completing.
                                     */
                                    if (!_isOneDs && !response_1.ok) {
                                        // this is for appInsights only
                                        _handleError(response_1.statusText);
                                        resolveFunc && resolveFunc(false);
                                    }
                                    else {
                                        if (_isOneDs && !response_1.body) {
                                            _onFetchComplete(response_1, null, STR_EMPTY);
                                            resolveFunc && resolveFunc(true);
                                        }
                                        else {
                                            doAwaitResponse(response_1.text(), function (resp) {
                                                _onFetchComplete(response_1, payload, resp.value);
                                                resolveFunc && resolveFunc(true);
                                            });
                                        }
                                    }
                                }
                                catch (e) {
                                    _handleError(dumpObj(e));
                                    rejectFunc && rejectFunc(e);
                                }
                            }
                            else {
                                _handleError(result.reason && result.reason[_DYN_MESSAGE$2 /* @min:%2emessage */]);
                                rejectFunc && rejectFunc(result.reason);
                            }
                        }
                    });
                }
                catch (e) {
                    if (!responseHandled) {
                        _handleError(dumpObj(e));
                        rejectFunc && rejectFunc(e);
                    }
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _doOnComplete(oncomplete, 200, {});
                    resolveFunc && resolveFunc(true);
                }
                if (_isOneDs && !responseHandled && payload[_DYN_TIMEOUT /* @min:%2etimeout */] > 0) {
                    // Simulate timeout
                    _timeoutWrapper && _timeoutWrapper.set(function () {
                        if (!responseHandled) {
                            // Assume a 500 response (which will cause a retry)
                            responseHandled = true;
                            _doOnComplete(oncomplete, 500, {});
                            resolveFunc && resolveFunc(true);
                        }
                    }, payload[_DYN_TIMEOUT /* @min:%2etimeout */]);
                }
                return thePromise;
            }
            /**
             * Send XDomainRequest
             * @param payload - {string} - The data payload to be sent.
             * @param sync - {boolean} - Indicates if the request should be sent synchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _xdrSender(payload, oncomplete, sync) {
                // It doesn't support custom headers, so no action is taken with current requestHeaders
                var _window = getWindow();
                var xdr = new XDomainRequest();
                var data = payload[_DYN_DATA$1 /* @min:%2edata */];
                xdr.onload = function () {
                    var response = getResponseText(xdr);
                    var onloadFunc = _onCompleteFuncs && _onCompleteFuncs.xdrOnComplete;
                    if (onloadFunc && isFunction$3(onloadFunc)) {
                        onloadFunc(xdr, oncomplete, payload);
                    }
                    else {
                        _doOnComplete(oncomplete, 200, {}, response);
                    }
                };
                xdr.onerror = function () {
                    _doOnComplete(oncomplete, 400, {}, _isOneDs ? STR_EMPTY : formatErrorMessageXdr(xdr));
                };
                xdr.ontimeout = function () {
                    _doOnComplete(oncomplete, 500, {});
                };
                xdr.onprogress = function () { };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location[_DYN_PROTOCOL /* @min:%2eprotocol */] || "";
                var endpoint = payload[_DYN_URL_STRING /* @min:%2eurlString */];
                if (!endpoint) {
                    _onNoPayloadUrl(oncomplete);
                    return;
                }
                if (!_isOneDs && endpoint.lastIndexOf(hostingProtocol, 0) !== 0) {
                    var msg = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                    _throwInternal(_diagLog, 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + msg);
                    _onError(msg, oncomplete);
                    return;
                }
                var endpointUrl = _isOneDs ? endpoint : endpoint[_DYN_REPLACE /* @min:%2ereplace */](/^(https?:)/, "");
                xdr.open(STR_POST_METHOD, endpointUrl);
                if (payload[_DYN_TIMEOUT /* @min:%2etimeout */]) {
                    xdr[_DYN_TIMEOUT /* @min:%2etimeout */] = payload[_DYN_TIMEOUT /* @min:%2etimeout */];
                }
                xdr.send(data);
                if (_isOneDs && sync) {
                    _timeoutWrapper && _timeoutWrapper.set(function () {
                        xdr.send(data);
                    }, 0);
                }
                else {
                    xdr.send(data);
                }
            }
            function _initDefaults() {
                _syncFetchPayload = 0;
                _isInitialized = false;
                _enableSendPromise = false;
                _diagLog = null;
                _isOneDs = null;
                _onCompleteFuncs = null;
                _disableCredentials = null;
                _fallbackInst = null;
                _disableXhr = false;
                _disableBeacon = false;
                _disableBeaconSync = false;
                _disableFetchKeepAlive = false;
                _addNoResponse = false;
                _timeoutWrapper = null;
            }
        });
    }
// Removed Stub for SenderPostManager.prototype.initialize.
// Removed Stub for SenderPostManager.prototype.getSyncFetchPayload.
// Removed Stub for SenderPostManager.prototype.SetConfig.
// Removed Stub for SenderPostManager.prototype.getSenderInst.
// Removed Stub for SenderPostManager.prototype.getFallbackInst.
// Removed Stub for SenderPostManager.prototype._doTeardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    SenderPostManager.__ieDyn=1;

    return SenderPostManager;
}());

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var strEvents = "events";
var strVisibilityChangeEvt = "visibilitychange";
var strPageHide = "pagehide";
var strUnload = "unload";
var strBeforeUnload = "beforeunload";
var strPageHideNamespace = createUniqueNamespace("aiEvtPageHide");
createUniqueNamespace("aiEvtPageShow");
var rRemoveEmptyNs = /\.[\.]+/g;
var rRemoveTrailingEmptyNs = /[\.]+$/;
var _guid = 1;
var elmNodeData = createElmNodeData("events");
var eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function _normalizeNamespace(name) {
    if (name && name[_DYN_REPLACE /* @min:%2ereplace */]) {
        return name[_DYN_REPLACE /* @min:%2ereplace */](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, STR_EMPTY$1);
    }
    return name;
}
function _getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = STR_EMPTY$1;
        if (isArray$3(evtNamespace)) {
            theNamespace_1 = STR_EMPTY$1;
            arrForEach(evtNamespace, function (name) {
                name = _normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") {
                        name = "." + name;
                    }
                    theNamespace_1 += name;
                }
            });
        }
        else {
            theNamespace_1 = _normalizeNamespace(evtNamespace);
        }
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") {
                theNamespace_1 = "." + theNamespace_1;
            }
            // We may only have the namespace and not an eventName
            eventName = (eventName || STR_EMPTY$1) + theNamespace_1;
        }
    }
    var parsedEvent = (eventNamespace.exec(eventName || STR_EMPTY$1) || []);
    return _a = {},
        _a[_DYN_TYPE /* @min:type */] = parsedEvent[1],
        _a.ns = ((parsedEvent[2] || STR_EMPTY$1).replace(rRemoveEmptyNs, ".").replace(rRemoveTrailingEmptyNs, STR_EMPTY$1)[_DYN_SPLIT$1 /* @min:%2esplit */](".").sort()).join("."),
        _a;
}
// Exported for internal unit testing only
function _getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === undefined) { addDefault = true; }
    var aiEvts = elmNodeData.get(target, strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) {
        registeredEvents = aiEvts[evtName] = [];
    }
    return registeredEvents;
}
function _doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[_DYN_TYPE /* @min:%2etype */]) {
        if (obj[strRemoveEventListener]) {
            obj[strRemoveEventListener](evtName[_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
        }
        else if (obj[strDetachEvent]) {
            obj[strDetachEvent](strOnPrefix + evtName[_DYN_TYPE /* @min:%2etype */], handlerRef);
        }
    }
}
function _doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[_DYN_TYPE /* @min:%2etype */] && handlerRef) {
        if (obj[strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[strAddEventHelper](evtName[_DYN_TYPE /* @min:%2etype */], handlerRef, useCapture);
            result = true;
        }
        else if (obj[strAttachEvent]) {
            // IE before version 9
            obj[strAttachEvent](strOnPrefix + evtName[_DYN_TYPE /* @min:%2etype */], handlerRef);
            result = true;
        }
    }
    return result;
}
function _doUnregister(target, events, evtName, unRegFn) {
    var idx = events[_DYN_LENGTH$5 /* @min:%2elength */];
    while (idx--) {
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    _doDetach(target, theEvent.evtName, theEvent[_DYN_HANDLER /* @min:%2ehandler */], theEvent.capture);
                    // Remove the registered event
                    events[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                }
            }
        }
    }
}
function _unregisterEvents(target, evtName, unRegFn) {
    if (evtName[_DYN_TYPE /* @min:%2etype */]) {
        _doUnregister(target, _getRegisteredEvents(target, evtName[_DYN_TYPE /* @min:%2etype */]), evtName, unRegFn);
    }
    else {
        var eventCache = elmNodeData.get(target, strEvents, {});
        objForEachKey(eventCache, function (evtType, events) {
            _doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if (objKeys(eventCache)[_DYN_LENGTH$5 /* @min:%2elength */] === 0) {
            elmNodeData.kill(target, strEvents);
        }
    }
}
function mergeEvtNamespace(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if (isArray$3(namespaces)) {
            newNamespaces = [theNamespace].concat(namespaces);
        }
        else {
            newNamespaces = [theNamespace, namespaces];
        }
        // resort the namespaces so they are always in order
        newNamespaces = (_getEvtNamespace("xx", newNamespaces).ns)[_DYN_SPLIT$1 /* @min:%2esplit */](".");
    }
    else {
        newNamespaces = theNamespace;
    }
    return newNamespaces;
}
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj - Object to add the event too.
 * @param eventName - String that specifies any of the standard DHTML Events without "on" prefix, if may also include an optional (dot "." prefixed)
 * namespaces "click" "click.mynamespace" in addition to specific namespaces.
 * @param handlerRef - Pointer that specifies the function to call when event fires
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function eventOn(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === undefined) { useCapture = false; }
    var result = false;
    if (target) {
        try {
            var evtName = _getEvtNamespace(eventName, evtNamespace);
            result = _doAttach(target, evtName, handlerRef, useCapture);
            if (result && elmNodeData.accept(target)) {
                var registeredEvent = (_a = {
                        guid: _guid++,
                        evtName: evtName
                    },
                    _a[_DYN_HANDLER /* @min:handler */] = handlerRef,
                    _a.capture = useCapture,
                    _a);
                _getRegisteredEvents(target, evtName.type)[_DYN_PUSH$2 /* @min:%2epush */](registeredEvent);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object - to remove the event from
 * @param eventName - {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param handlerRef - {any} - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Additional namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace,
 * if the eventName also includes a namespace the namespace(s) are merged into a single namespace
 * @param useCapture - [Optional] Defaults to false
 */
function eventOff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === undefined) { useCapture = false; }
    if (target) {
        try {
            var evtName_1 = _getEvtNamespace(eventName, evtNamespace);
            var found_1 = false;
            _unregisterEvents(target, evtName_1, function (regEvent) {
                if ((evtName_1.ns && !handlerRef) || regEvent[_DYN_HANDLER /* @min:%2ehandler */] === handlerRef) {
                    found_1 = true;
                    return true;
                }
                return false;
            });
            if (!found_1) {
                // fallback to try and remove as requested
                _doDetach(target, evtName_1, handlerRef, useCapture);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName - {string} - The name of the event
 * @param callback - {any} - The callback function that needs to be executed for the given event
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback, evtNamespace) {
    var result = false;
    var w = getWindow();
    if (w) {
        result = eventOn(w, eventName, callback, evtNamespace);
        result = eventOn(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = getDocument();
    if (doc) {
        result = eventOn(doc, eventName, callback, evtNamespace) || result;
    }
    return result;
}
/**
 * Trys to remove event handler(s) for the specified event/namespace to the window, body and document
 * @param eventName - {string} - The name of the event, with optional namespaces or just the namespaces,
 * such as "click", "click.mynamespace" or ".mynamespace"
 * @param callback - {any} - - The callback function that needs to be removed from the given event, when using a
 * namespace (with or without a qualifying event) this may be null to remove all previously attached event handlers
 * otherwise this will only remove events with this specific handler.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventHandler(eventName, callback, evtNamespace) {
    var w = getWindow();
    if (w) {
        eventOff(w, eventName, callback, evtNamespace);
        eventOff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = getDocument();
    if (doc) {
        eventOff(doc, eventName, callback, evtNamespace);
    }
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function _addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
        arrForEach(events, function (name) {
            if (name) {
                if (!excludeEvents || arrIndexOf(excludeEvents, name) === -1) {
                    added = addEventHandler(name, listener, evtNamespace) || added;
                }
            }
        });
    }
    return added;
}
/**
 * Bind the listener to the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && isArray$3(events)) {
        added = _addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[_DYN_LENGTH$5 /* @min:%2elength */] > 0) {
            // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
            added = _addEventListeners(events, listener, null, evtNamespace);
        }
    }
    return added;
}
/**
 * Remove the listener from the array of events
 * @param events - An string array of event names to bind the listener to
 * @param listener - The event callback to call when the event is triggered
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 */
function removeEventListeners(events, listener, evtNamespace) {
    if (events && isArray$3(events)) {
        arrForEach(events, function (name) {
            if (name) {
                removeEventHandler(name, listener, evtNamespace);
            }
        });
    }
}
/**
 * Listen to the 'beforeunload', 'unload' and 'pagehide' events which indicates a page unload is occurring,
 * this does NOT listen to the 'visibilitychange' event as while it does indicate that the page is being hidden
 * it does not *necessarily* mean that the page is being completely unloaded, it can mean that the user is
 * just navigating to a different Tab and may come back (without unloading the page). As such you may also
 * need to listen to the 'addPageHideEventListener' and 'addPageShowEventListener' events.
 * @param listener - The event callback to call when a page unload event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked, unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageUnloadEventListener(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return addEventListeners([strBeforeUnload, strUnload, strPageHide], listener, excludeEvents, evtNamespace);
}
/**
 * Remove any matching 'beforeunload', 'unload' and 'pagehide' events that may have been added via addEventListener,
 * addEventListeners, addPageUnloadEventListener or addPageHideEventListener.
 * @param listener - The specific event callback to to be removed
 * @param evtNamespace - [Optional] Namespace(s) uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */
function removePageUnloadEventListener(listener, evtNamespace) {
    removeEventListeners([strBeforeUnload, strUnload, strPageHide], listener, evtNamespace);
}
/**
 * Listen to the pagehide and visibility changing to 'hidden' events, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when if you plan to call
 * removePageShowEventListener as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The event callback to call when a page hide event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] A Namespace to append to the event listeners so they can be uniquely identified and removed
 * based on this namespace. This call also adds an additional unique "pageshow" namespace to the events
 * so that only the matching "removePageHideEventListener" can remove these events.
 * Suggestion: pass as true if you are also calling addPageUnloadEventListener as that also hooks pagehide
 * @returns true - when at least one of the events was registered otherwise false
 */
function addPageHideEventListener(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = getDocument();
        if (listener && doc && doc.visibilityState === "hidden") {
            listener(evt);
        }
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = _addEventListeners([strPageHide], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || arrIndexOf(excludeEvents, strVisibilityChangeEvt) === -1) {
        pageUnloadAdded = _addEventListeners([strVisibilityChangeEvt], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    }
    if (!pageUnloadAdded && excludeEvents) {
        // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
        pageUnloadAdded = addPageHideEventListener(listener, null, evtNamespace);
    }
    return pageUnloadAdded;
}
/**
 * Removes the pageHide event listeners added by addPageHideEventListener, because the 'visibilitychange' uses
 * an internal proxy to detect the visibility state you SHOULD use a unique namespace when calling addPageHideEventListener
 * as the remove ignores the listener argument for the 'visibilitychange' event.
 * @param listener - The specific listener to remove for the 'pageshow' event only (ignored for 'visibilitychange')
 * @param evtNamespace - The unique namespace used when calling addPageShowEventListener
 */
function removePageHideEventListener(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = mergeEvtNamespace(strPageHideNamespace, evtNamespace);
    removeEventListeners([strPageHide], listener, newNamespaces);
    removeEventListeners([strVisibilityChangeEvt], null, newNamespaces);
}

/*
 * Application Insights JavaScript SDK - Core, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var aiInstrumentHooks = "_aiHooks";
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr[_DYN_LENGTH$5 /* @min:%2elength */]; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */ && type <= 2 /* CallbackType.HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* CallbackType.HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb[_DYN_APPLY /* @min:%2eapply */](callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {},
            _a[_DYN_NAME$3 /* @min:name */] = aiHook.n,
            _a.inst = funcThis,
            _a.ctx = null,
            _a.set = _replaceArg,
            _a);
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        funcArgs.evt = getInst("event");
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target[_DYN_PUSH$2 /* @min:%2epush */](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) {
            try {
                funcArgs.rslt = theFunc[_DYN_APPLY /* @min:%2eapply */](funcThis, orgArgs);
            }
            catch (err) {
                // Report the request callback
                funcArgs.err = err;
                _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */);
                // rethrow the original exception so anyone listening for it can catch the exception
                throw err;
            }
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */);
        return funcArgs.rslt;
    };
}
/** @ignore */
function _getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if (objHasOwnProperty(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, checkParentProto, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[strShimPrototype], funcName, callbacks, false);
    }
    return null;
}
function _createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = _createFunctionHook(aiHook);
        newFunc[aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function () {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            _arrLoop(aiHook.h, function (hook, idx) {
                if (hook.id === id) {
                    aiHook.h[_DYN_SPLICE /* @min:%2esplice */](idx, 1);
                    return 1;
                }
            });
        }
        // tslint:enable:object-literal-shorthand
    };
    aiHook.i++;
    aiHook.h[_DYN_PUSH$2 /* @min:%2epush */](theHook);
    return theHook;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === undefined) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === strShimFunction) {
                return _createInstrumentHook(owner, funcName, fn, callbacks);
            }
        }
    }
    return null;
}
/**
 * Add an instrumentation hook to the provided named "event" for the target class / object, this doesn't check whether the
 * named "event" is in fact a function and just assigns the instrumentation hook to the target[evtName]
 * @param target - The target object
 * @param evtName - The name of the event
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 * @param checkParentProto - If the function doesn't exist on the target or it's prototype should it attempt to hook the parent's prototype
 */
function InstrumentEvent(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = _getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) {
            return _createInstrumentHook(owner, evtName, owner[evtName], callbacks);
        }
    }
    return null;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var DEFAULT_BREEZE_PATH = "/v2/track";
var strNotSpecified = "not_specified";
var strIkey = "iKey";

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var RequestHeaders = createValueMap({
    requestContextHeader: [0 /* eRequestHeaders.requestContextHeader */, "Request-Context"],
    requestContextTargetKey: [1 /* eRequestHeaders.requestContextTargetKey */, "appId"],
    requestContextAppIdFormat: [2 /* eRequestHeaders.requestContextAppIdFormat */, "appId=cid-v1:"],
    requestIdHeader: [3 /* eRequestHeaders.requestIdHeader */, "Request-Id"],
    traceParentHeader: [4 /* eRequestHeaders.traceParentHeader */, "traceparent"],
    traceStateHeader: [5 /* eRequestHeaders.traceStateHeader */, "tracestate"],
    sdkContextHeader: [6 /* eRequestHeaders.sdkContextHeader */, "Sdk-Context"],
    sdkContextHeaderAppIdRequest: [7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */, "appId"],
    requestContextHeaderLowerCase: [8 /* eRequestHeaders.requestContextHeaderLowerCase */, "request-context"]
});

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SPLIT = "split"; // Count: 6
var _DYN_LENGTH$4 = "length"; // Count: 41
var _DYN_TO_LOWER_CASE$1 = "toLowerCase"; // Count: 6
var _DYN_INGESTIONENDPOINT = "ingestionendpoint"; // Count: 6
var _DYN_TO_STRING$2 = "toString"; // Count: 9
var _DYN_PUSH$1 = "push"; // Count: 5
var _DYN_REMOVE_ITEM = "removeItem"; // Count: 3
var _DYN_NAME$2 = "name"; // Count: 11
var _DYN_MESSAGE$1 = "message"; // Count: 10
var _DYN_COUNT$1 = "count"; // Count: 8
var _DYN_PRE_TRIGGER_DATE = "preTriggerDate"; // Count: 4
var _DYN_DISABLED = "disabled"; // Count: 3
var _DYN_INTERVAL = "interval"; // Count: 3
var _DYN_DAYS_OF_MONTH = "daysOfMonth"; // Count: 3
var _DYN_DATE = "date"; // Count: 5
var _DYN_GET_UTCDATE = "getUTCDate"; // Count: 3
var _DYN_STRINGIFY$1 = "stringify"; // Count: 4
var _DYN_PATHNAME = "pathname"; // Count: 4
var _DYN_CORRELATION_HEADER_E0 = "correlationHeaderExcludePatterns"; // Count: 2
var _DYN_EXCEPTIONS = "exceptions"; // Count: 6
var _DYN_PARSED_STACK = "parsedStack"; // Count: 13
var _DYN_PROPERTIES$1 = "properties"; // Count: 9
var _DYN_MEASUREMENTS$1 = "measurements"; // Count: 9
var _DYN_SIZE_IN_BYTES = "sizeInBytes"; // Count: 11
var _DYN_TYPE_NAME = "typeName"; // Count: 11
var _DYN_SEVERITY_LEVEL = "severityLevel"; // Count: 5
var _DYN_PROBLEM_GROUP = "problemGroup"; // Count: 3
var _DYN_IS_MANUAL = "isManual"; // Count: 3
var _DYN__CREATE_FROM_INTERFA1 = "CreateFromInterface"; // Count: 2
var _DYN_ASSEMBLY = "assembly"; // Count: 7
var _DYN_FILE_NAME = "fileName"; // Count: 8
var _DYN_HAS_FULL_STACK = "hasFullStack"; // Count: 6
var _DYN_LEVEL = "level"; // Count: 5
var _DYN_METHOD$1 = "method"; // Count: 7
var _DYN_LINE = "line"; // Count: 6
var _DYN_DURATION$1 = "duration"; // Count: 4
var _DYN_RECEIVED_RESPONSE = "receivedResponse"; // Count: 2

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key[_DYN_LENGTH$4 /* @min:%2elength */];
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[_DYN_LENGTH$4 /* @min:%2elength */] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = strSubstring(field, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = strTrim(asString(name));
        // truncate the string to 150 chars
        if (name[_DYN_LENGTH$4 /* @min:%2elength */] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */) {
            nameTrunc = strSubstring(name, 0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 57 /* _eInternalMessageId.NameTooLong */, "name is too long.  It has been truncated to " + 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === undefined) { maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */; // in case default parameters dont work
        value = strTrim(asString(value));
        if (value[_DYN_LENGTH$4 /* @min:%2elength */] > maxLength) {
            valueTrunc = strSubstring(value, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 61 /* _eInternalMessageId.StringValueTooLong */, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */, 66 /* _eInternalMessageId.UrlTooLong */);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[_DYN_LENGTH$4 /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */) {
            messageTrunc = strSubstring(message, 0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 56 /* _eInternalMessageId.MessageTruncated */, "message is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[_DYN_LENGTH$4 /* @min:%2elength */] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = strSubstring(value, 0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 52 /* _eInternalMessageId.ExceptionTruncated */, "exception is too long, it has been truncated to " + 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        objForEachKey(properties, function (prop, value) {
            if (isObject$6(value) && hasJSON()) {
                // Stringify any part C properties
                try {
                    value = getJSON()[_DYN_STRINGIFY$1 /* @min:%2estringify */](value);
                }
                catch (e) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        objForEachKey(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */, 69 /* _eInternalMessageId.IdTooLong */)[_DYN_TO_STRING$2 /* @min:%2etoString */]() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = strTrim(asString(input));
        if (input[_DYN_LENGTH$4 /* @min:%2elength */] > maxLength) {
            inputTrunc = strSubstring(input, 0, maxLength);
            _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return strSubstr(s, s[_DYN_LENGTH$4 /* @min:%2elength */] - 3);
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _document = getDocument() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance
        tempAnchor = anchorCache[anchorIdx] = _document.createElement("a");
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[_DYN_LENGTH$4 /* @min:%2elength */]) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DYN_LENGTH$4 /* @min:%2elength */] > 3 && isString$2(match[2]) && match[2][_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[_DYN_LENGTH$4 /* @min:%2elength */] > 2 && isString$2(match[2]) && match[2][_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
            result = match[2] || "";
            if (match[_DYN_LENGTH$4 /* @min:%2elength */] > 2) {
                var protocol = (match[1] || "")[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// listing only non-geo specific locations
var _internalEndpoints = [
    DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH,
    "https://breeze.aimon.applicationinsights.io" + DEFAULT_BREEZE_PATH,
    "https://dc-int.services.visualstudio.com" + DEFAULT_BREEZE_PATH
];
var _correlationIdPrefix = "cid-v1:";
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return arrIndexOf(_internalEndpoints, endpointUrl[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]()) !== -1;
}
/**
 * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
 * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
 * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
 * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
 * manually supply domains to include correlation headers on. Else, no headers will be included at all.
 */
function correlationIdCanIncludeCorrelationHeader(config, requestUrl, currentHost) {
    if (!requestUrl || (config && config.disableCorrelationHeaders)) {
        return false;
    }
    if (config && config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */]) {
        for (var i = 0; i < config.correlationHeaderExcludePatterns[_DYN_LENGTH$4 /* @min:%2elength */]; i++) {
            if (config[_DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */][i].test(requestUrl)) {
                return false;
            }
        }
    }
    var requestHost = urlParseUrl(requestUrl).host[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
    if (requestHost && (strIndexOf(requestHost, ":443") !== -1 || strIndexOf(requestHost, ":80") !== -1)) {
        // [Bug #1260] IE can include the port even for http and https URLs so if present
        // try and parse it to remove if it matches the default protocol port
        requestHost = (urlParseFullHost(requestUrl) || "")[_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
    }
    if ((!config || !config.enableCorsCorrelation) && (requestHost && requestHost !== currentHost)) {
        return false;
    }
    var includedDomains = config && config.correlationHeaderDomains;
    if (includedDomains) {
        var matchExists_1;
        arrForEach(includedDomains, function (domain) {
            var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            matchExists_1 = matchExists_1 || regex.test(requestHost);
        });
        if (!matchExists_1) {
            return false;
        }
    }
    var excludedDomains = config && config.correlationHeaderExcludedDomains;
    if (!excludedDomains || excludedDomains[_DYN_LENGTH$4 /* @min:%2elength */] === 0) {
        return true;
    }
    for (var i = 0; i < excludedDomains[_DYN_LENGTH$4 /* @min:%2elength */]; i++) {
        var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
        if (regex.test(requestHost)) {
            return false;
        }
    }
    // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
    // Previously we always returned false for a falsy requestHost
    return requestHost && requestHost[_DYN_LENGTH$4 /* @min:%2elength */] > 0;
}
/**
 * Combines target appId and target role name from response header.
 */
function correlationIdGetCorrelationContext(responseHeader) {
    if (responseHeader) {
        var correlationId = correlationIdGetCorrelationContextValue(responseHeader, RequestHeaders[1 /* eRequestHeaders.requestContextTargetKey */]);
        if (correlationId && correlationId !== _correlationIdPrefix) {
            return correlationId;
        }
    }
}
/**
 * Gets key from correlation response header
 */
function correlationIdGetCorrelationContextValue(responseHeader, key) {
    if (responseHeader) {
        var keyValues = responseHeader[_DYN_SPLIT /* @min:%2esplit */](",");
        for (var i = 0; i < keyValues[_DYN_LENGTH$4 /* @min:%2elength */]; ++i) {
            var keyValue = keyValues[i][_DYN_SPLIT /* @min:%2esplit */]("=");
            if (keyValue[_DYN_LENGTH$4 /* @min:%2elength */] === 2 && keyValue[0] === key) {
                return keyValue[1];
            }
        }
    }
}
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        var parsedUrl = urlParseUrl(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[_DYN_PATHNAME /* @min:%2epathname */] != null) {
                var pathName = (parsedUrl.pathname[_DYN_LENGTH$4 /* @min:%2elength */] === 0) ? "/" : parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl[_DYN_PATHNAME /* @min:%2epathname */];
                name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = dataSanitizeString(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = getPerformance();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return utcNow();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !isNullOrUndefined(start) && !isNullOrUndefined(end)) {
        result = end - start;
    }
    return result;
}
/**
 * Creates a IDistributedTraceContext from an optional telemetryTrace
 * @param telemetryTrace - The telemetryTrace instance that is being wrapped
 * @param parentCtx - An optional parent distributed trace instance, almost always undefined as this scenario is only used in the case of multiple property handlers.
 * @returns A new IDistributedTraceContext instance that is backed by the telemetryTrace or temporary object
 */
function createDistributedTraceContextFromTrace(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function () {
            return trace[_DYN_NAME$2 /* @min:%2ename */];
        },
        setName: function (newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[_DYN_NAME$2 /* @min:%2ename */] = newValue;
        },
        getTraceId: function () {
            return trace.traceID;
        },
        setTraceId: function (newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if (isValidTraceId(newValue)) {
                trace.traceID = newValue;
            }
        },
        getSpanId: function () {
            return trace.parentID;
        },
        setSpanId: function (newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if (isValidSpanId(newValue)) {
                trace.parentID = newValue;
            }
        },
        getTraceFlags: function () {
            return trace.traceFlags;
        },
        setTraceFlags: function (newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var StorageType = createEnumStyle({
    LocalStorage: 0 /* eStorageType.LocalStorage */,
    SessionStorage: 1 /* eStorageType.SessionStorage */
});

var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
var _storagePrefix = "";
function _getLocalStorageObject() {
  if (utlCanUseLocalStorage()) {
    return _getVerifiedStorageObject(StorageType.LocalStorage);
  }
  return null;
}
function _getVerifiedStorageObject(storageType) {
  try {
    if (isNullOrUndefined(getGlobal())) {
      return null;
    }
    var uid = (/* @__PURE__ */ new Date())[
      _DYN_TO_STRING$2
      /* @min:%2etoString */
    ]();
    var storage = getInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
    var name_1 = _storagePrefix + uid;
    storage.setItem(name_1, uid);
    var fail = storage.getItem(name_1) !== uid;
    storage[
      _DYN_REMOVE_ITEM
      /* @min:%2eremoveItem */
    ](name_1);
    if (!fail) {
      return storage;
    }
  } catch (exception) {
  }
  return null;
}
function _getSessionStorageObject() {
  if (utlCanUseSessionStorage()) {
    return _getVerifiedStorageObject(StorageType.SessionStorage);
  }
  return null;
}
function utlDisableStorage() {
  _canUseLocalStorage = false;
  _canUseSessionStorage = false;
}
function utlSetStoragePrefix(storagePrefix) {
  _storagePrefix = storagePrefix || "";
}
function utlEnableStorage() {
  _canUseLocalStorage = utlCanUseLocalStorage(true);
  _canUseSessionStorage = utlCanUseSessionStorage(true);
}
function utlCanUseLocalStorage(reset) {
  if (reset || _canUseLocalStorage === undefined) {
    _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
  }
  return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      return storage.getItem(name);
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2, 1, "Browser failed read of local storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return null;
}
function utlSetLocalStorage(logger, name, data) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      storage.setItem(name, data);
      return true;
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2, 3, "Browser failed write to local storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}
function utlRemoveStorage(logger, name) {
  var storage = _getLocalStorageObject();
  if (storage !== null) {
    try {
      storage[
        _DYN_REMOVE_ITEM
        /* @min:%2eremoveItem */
      ](name);
      return true;
    } catch (e) {
      _canUseLocalStorage = false;
      _throwInternal(logger, 2, 5, "Browser failed removal of local storage item. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}
function utlCanUseSessionStorage(reset) {
  if (reset || _canUseSessionStorage === undefined) {
    _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
  }
  return _canUseSessionStorage;
}
function utlGetSessionStorage(logger, name) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      return storage.getItem(name);
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2, 2, "Browser failed read of session storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return null;
}
function utlSetSessionStorage(logger, name, data) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      storage.setItem(name, data);
      return true;
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2, 4, "Browser failed write to session storage. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}
function utlRemoveSessionStorage(logger, name) {
  var storage = _getSessionStorageObject();
  if (storage !== null) {
    try {
      storage[
        _DYN_REMOVE_ITEM
        /* @min:%2eremoveItem */
      ](name);
      return true;
    } catch (e) {
      _canUseSessionStorage = false;
      _throwInternal(logger, 2, 6, "Browser failed removal of session storage item. " + getExceptionName(e), { exception: dumpObj(e) });
    }
  }
  return false;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var THROTTLE_STORAGE_PREFIX = "appInsightsThrottle";
var ThrottleMgr = /** @class */ (function () {
    function ThrottleMgr(core, namePrefix) {
        var _self = this;
        var _canUseLocalStorage;
        var _logger;
        var _config;
        var _localStorageObj;
        var _isTriggered; //_isTriggered is to make sure that we only trigger throttle once a day
        var _namePrefix;
        var _queue;
        var _isReady = false;
        var _isSpecificDaysGiven = false;
        _initConfig();
        // Special internal method to allow the unit tests and DebugPlugin to hook embedded objects
        _self["_getDbgPlgTargets"] = function () {
            return [_queue];
        };
        _self.getConfig = function () {
            return _config;
        };
        /**
         * Check if it is the correct day to send message.
         * If _isTriggered is true, even if canThrottle returns true, message will not be sent,
         * because we only allow triggering sendMessage() once a day.
         * @returns if the current date is the valid date to send message
         */
        _self.canThrottle = function (msgId) {
            var localObj = _getLocalStorageObjByKey(msgId);
            var cfg = _getCfgByKey(msgId);
            return _canThrottle(cfg, _canUseLocalStorage, localObj);
        };
        /**
         * Check if throttle is triggered on current day(UTC)
         * if canThrottle returns false, isTriggered will return false
         * @returns if throttle is triggered on current day(UTC)
         */
        _self.isTriggered = function (msgId) {
            return _isTrigger(msgId);
        };
        /**
         * Before isReady set to true, all message will be stored in queue.
         * Message will only be sent out after isReady set to true.
         * Initial and default value: false
         * @returns isReady state
         */
        _self.isReady = function () {
            return _isReady;
        };
        /**
         * Flush all message with given message key in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flush = function (msgId) {
            try {
                var queue = _getQueueByKey(msgId);
                if (queue && queue[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
                    var items = queue.slice(0);
                    _queue[msgId] = [];
                    arrForEach(items, function (item) {
                        _flushMessage(item.msgID, item[_DYN_MESSAGE$1 /* @min:%2emessage */], item.severity, false);
                    });
                    return true;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Flush all message in queue with isReady state set to true.
         * @returns if message queue is flushed
         */
        _self.flushAll = function () {
            try {
                if (_queue) {
                    var result_1 = true;
                    objForEachKey(_queue, function (key) {
                        var isFlushed = _self.flush(parseInt(key));
                        result_1 = result_1 && isFlushed;
                    });
                    return result_1;
                }
            }
            catch (err) {
                // eslint-disable-next-line no-empty
            }
            return false;
        };
        /**
         * Set isReady State
         * if isReady set to true, message queue will be flushed automatically.
         * @param isReady isReady State
         * @pa
         * @returns if message queue is flushed
         */
        _self.onReadyState = function (isReady, flushAll) {
            if (flushAll === undefined) { flushAll = true; }
            _isReady = isNullOrUndefined(isReady) ? true : isReady;
            if (_isReady && flushAll) {
                return _self.flushAll();
            }
            return null;
        };
        _self.sendMessage = function (msgID, message, severity) {
            return _flushMessage(msgID, message, severity, true);
        };
        function _flushMessage(msgID, message, severity, saveUnsentMsg) {
            if (_isReady) {
                var isSampledIn = _canSampledIn(msgID);
                if (!isSampledIn) {
                    return;
                }
                var cfg = _getCfgByKey(msgID);
                var localStorageObj = _getLocalStorageObjByKey(msgID);
                var canThrottle = _canThrottle(cfg, _canUseLocalStorage, localStorageObj);
                var throttled = false;
                var number = 0;
                var isTriggered = _isTrigger(msgID);
                try {
                    if (canThrottle && !isTriggered) {
                        number = Math.min(cfg.limit.maxSendNumber, localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] + 1);
                        localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] = 0;
                        throttled = true;
                        _isTriggered[msgID] = true;
                        localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */] = new Date();
                    }
                    else {
                        _isTriggered[msgID] = canThrottle;
                        localStorageObj[_DYN_COUNT$1 /* @min:%2ecount */] += 1;
                    }
                    var localStorageName = _getLocalStorageName(msgID);
                    _resetLocalStorage(_logger, localStorageName, localStorageObj);
                    for (var i = 0; i < number; i++) {
                        _sendMessage(msgID, _logger, message, severity);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return {
                    isThrottled: throttled,
                    throttleNum: number
                };
            }
            else {
                if (!!saveUnsentMsg) {
                    var queue = _getQueueByKey(msgID);
                    queue[_DYN_PUSH$1 /* @min:%2epush */]({
                        msgID: msgID,
                        message: message,
                        severity: severity
                    });
                }
            }
            return null;
        }
        function _initConfig() {
            _logger = safeGetLogger(core);
            _isTriggered = {};
            _localStorageObj = {};
            _queue = {};
            _config = {};
            _setCfgByKey(109 /* _eInternalMessageId.DefaultThrottleMsgKey */);
            _namePrefix = isNotNullOrUndefined(namePrefix) ? namePrefix : "";
            core.addUnloadHook(onConfigChange(core.config, function (details) {
                var coreConfig = details.cfg;
                _canUseLocalStorage = utlCanUseLocalStorage();
                var configMgr = coreConfig.throttleMgrCfg || {};
                objForEachKey(configMgr, function (key, cfg) {
                    _setCfgByKey(parseInt(key), cfg);
                });
            }));
        }
        function _getCfgByKey(msgID) {
            return _config[msgID] || _config[109 /* _eInternalMessageId.DefaultThrottleMsgKey */];
        }
        function _setCfgByKey(msgID, config) {
            var _a, _b;
            try {
                var cfg = config || {};
                var curCfg = {};
                curCfg[_DYN_DISABLED /* @min:%2edisabled */] = !!cfg[_DYN_DISABLED /* @min:%2edisabled */];
                var configInterval = cfg[_DYN_INTERVAL /* @min:%2einterval */] || {};
                _isSpecificDaysGiven = (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth) && (configInterval === null || configInterval === void 0 ? void 0 : configInterval.daysOfMonth[_DYN_LENGTH$4 /* @min:%2elength */]) > 0;
                curCfg[_DYN_INTERVAL /* @min:%2einterval */] = _getIntervalConfig(configInterval);
                var limit = {
                    samplingRate: ((_a = cfg.limit) === null || _a === void 0 ? void 0 : _a.samplingRate) || 100,
                    // dafault: every time sent only 1 event
                    maxSendNumber: ((_b = cfg.limit) === null || _b === void 0 ? void 0 : _b.maxSendNumber) || 1
                };
                curCfg.limit = limit;
                _config[msgID] = curCfg;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
        }
        function _getIntervalConfig(interval) {
            interval = interval || {};
            var monthInterval = interval === null || interval === undefined ? undefined : interval.monthInterval;
            var dayInterval = interval === null || interval === undefined ? undefined : interval.dayInterval;
            // default: send data every 3 month each year
            if (isNullOrUndefined(monthInterval) && isNullOrUndefined(dayInterval)) {
                interval.monthInterval = 3;
                if (!_isSpecificDaysGiven) {
                    // default: send data on 28th
                    interval[_DYN_DAYS_OF_MONTH /* @min:%2edaysOfMonth */] = [28];
                    _isSpecificDaysGiven = true;
                }
            }
            interval = {
                // dafault: sent every three months
                monthInterval: interval === null || interval === undefined ? undefined : interval.monthInterval,
                dayInterval: interval === null || interval === undefined ? undefined : interval.dayInterval,
                daysOfMonth: interval === null || interval === undefined ? undefined : interval.daysOfMonth
            };
            return interval;
        }
        function _canThrottle(config, canUseLocalStorage, localStorageObj) {
            if (config && !config[_DYN_DISABLED /* @min:%2edisabled */] && canUseLocalStorage && isNotNullOrUndefined(localStorageObj)) {
                var curDate = _getThrottleDate();
                var date = localStorageObj[_DYN_DATE /* @min:%2edate */];
                var interval = config[_DYN_INTERVAL /* @min:%2einterval */];
                var monthCheck = 1;
                if (interval === null || interval === undefined ? undefined : interval.monthInterval) {
                    var monthExpand = (curDate.getUTCFullYear() - date.getUTCFullYear()) * 12 + curDate.getUTCMonth() - date.getUTCMonth();
                    monthCheck = _checkInterval(interval.monthInterval, 0, monthExpand);
                }
                var dayCheck = 1;
                if (_isSpecificDaysGiven) {
                    dayCheck = arrIndexOf(interval[_DYN_DAYS_OF_MONTH /* @min:%2edaysOfMonth */], curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]());
                }
                else if (interval === null || interval === undefined ? undefined : interval.dayInterval) {
                    var daySpan = Math.floor((curDate.getTime() - date.getTime()) / 86400000);
                    dayCheck = _checkInterval(interval.dayInterval, 0, daySpan);
                }
                return monthCheck >= 0 && dayCheck >= 0;
            }
            return false;
        }
        function _getLocalStorageName(msgKey, prefix) {
            var fix = isNotNullOrUndefined(prefix) ? prefix : "";
            if (msgKey) {
                return THROTTLE_STORAGE_PREFIX + fix + "-" + msgKey;
            }
            return null;
        }
        // returns if throttle is triggered on current Date
        function _isTriggeredOnCurDate(preTriggerDate) {
            try {
                if (preTriggerDate) {
                    var curDate = new Date();
                    return preTriggerDate.getUTCFullYear() === curDate.getUTCFullYear() &&
                        preTriggerDate.getUTCMonth() === curDate.getUTCMonth() &&
                        preTriggerDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]() === curDate[_DYN_GET_UTCDATE /* @min:%2egetUTCDate */]();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        // transfer local storage string value to object that identifies start date, current count and preTriggerDate
        function _getLocalStorageObj(value, logger, storageName) {
            try {
                var storageObj = {
                    date: _getThrottleDate(),
                    count: 0
                };
                if (value) {
                    var obj = JSON.parse(value);
                    var curObj = {
                        date: _getThrottleDate(obj[_DYN_DATE /* @min:%2edate */]) || storageObj[_DYN_DATE /* @min:%2edate */],
                        count: obj[_DYN_COUNT$1 /* @min:%2ecount */] || storageObj[_DYN_COUNT$1 /* @min:%2ecount */],
                        preTriggerDate: obj.preTriggerDate ? _getThrottleDate(obj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]) : undefined
                    };
                    return curObj;
                }
                else {
                    _resetLocalStorage(logger, storageName, storageObj);
                    return storageObj;
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        // if datestr is not defined, current date will be returned
        function _getThrottleDate(dateStr) {
            // if new Date() can't be created through the provided dateStr, null will be returned.
            try {
                if (dateStr) {
                    var date = new Date(dateStr);
                    //make sure it is a valid Date Object
                    if (!isNaN(date.getDate())) {
                        return date;
                    }
                }
                else {
                    return new Date();
                }
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _resetLocalStorage(logger, storageName, obj) {
            try {
                return utlSetLocalStorage(logger, storageName, strTrim(JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */](obj)));
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _checkInterval(interval, start, current) {
            if (interval <= 0) {
                return 1;
            }
            // count from start year
            return (current >= start) && (current - start) % interval == 0 ? Math.floor((current - start) / interval) + 1 : -1;
        }
        function _sendMessage(msgID, logger, message, severity) {
            _throwInternal(logger, severity || 1 /* eLoggingSeverity.CRITICAL */, msgID, message);
        }
        // NOTE: config.limit.samplingRate is set to 4 decimal places,
        // so config.limit.samplingRate = 1 means 0.0001%
        function _canSampledIn(msgID) {
            try {
                var cfg = _getCfgByKey(msgID);
                return randomValue(1000000) <= cfg.limit.samplingRate;
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return false;
        }
        function _getLocalStorageObjByKey(key) {
            try {
                var curObj = _localStorageObj[key];
                if (!curObj) {
                    var localStorageName = _getLocalStorageName(key, _namePrefix);
                    curObj = _getLocalStorageObj(utlGetLocalStorage(_logger, localStorageName), _logger, localStorageName);
                    _localStorageObj[key] = curObj;
                }
                return _localStorageObj[key];
            }
            catch (e) {
                // eslint-disable-next-line no-empty
            }
            return null;
        }
        function _isTrigger(key) {
            var isTrigger = _isTriggered[key];
            if (isNullOrUndefined(isTrigger)) {
                isTrigger = false;
                var localStorageObj = _getLocalStorageObjByKey(key);
                if (localStorageObj) {
                    isTrigger = _isTriggeredOnCurDate(localStorageObj[_DYN_PRE_TRIGGER_DATE /* @min:%2epreTriggerDate */]);
                }
                _isTriggered[key] = isTrigger;
            }
            return _isTriggered[key];
        }
        function _getQueueByKey(key) {
            _queue = _queue || {};
            if (isNullOrUndefined(_queue[key])) {
                _queue[key] = [];
            }
            return _queue[key];
        }
    }
    return ThrottleMgr;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString[_DYN_SPLIT /* @min:%2esplit */](_FIELDS_SEPARATOR);
    var result = arrReduce(kvPairs, function (fields, kv) {
        var kvParts = kv[_DYN_SPLIT /* @min:%2esplit */](_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[_DYN_LENGTH$4 /* @min:%2elength */] === 2) { // only save fields with valid formats
            var key = kvParts[0][_DYN_TO_LOWER_CASE$1 /* @min:%2etoLowerCase */]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (objKeys(result)[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // apply the default endpoints
            var locationPrefix = result.location ? result.location + "." : "";
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply user override endpoint or the default endpoints
        result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] || DEFAULT_BREEZE_ENDPOINT;
        if (strEndsWith(result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */], "/")) {
            result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */] = result[_DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */].slice(0, -1);
        }
    }
    return result;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Envelope = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self.data = data;
        _self.time = toISOString$2(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */,
            iKey: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* FieldType.Hidden */ : 1 /* FieldType.Required */;
            },
            tags: 1 /* FieldType.Required */,
            data: 1 /* FieldType.Required */
        };
    }
    return Envelope;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Event$1 = /** @class */ (function () {
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !isString$2(result)) {
        if (JSON && JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */]) {
            result = JSON[_DYN_STRINGIFY$1 /* @min:%2estringify */](value);
            if (convertToString && (!result || result === "{}")) {
                if (isFunction$3(value[_DYN_TO_STRING$2 /* @min:%2etoString */])) {
                    result = value[_DYN_TO_STRING$2 /* @min:%2etoString */]();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !isString$2(evtMessage)) {
            evtMessage = theEvent[strMessage] || theEvent[strDescription] || evtMessage;
        }
        // Make sure the message is a string
        if (evtMessage && !isString$2(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && strIndexOf(evtMessage || "", errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    try {
        if (isObject$6(value)) {
            return "hasFullStack" in value && "typeName" in value;
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isExceptionInternal(value) {
    try {
        if (isObject$6(value)) {
            return ("ver" in value && "exceptions" in value && "properties" in value);
        }
    }
    catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && isString$2(details.src) && details.obj && isArray$3(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!isString$2(src)) {
        if (isString$2(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src[_DYN_SPLIT /* @min:%2esplit */]("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[_DYN_SPLIT /* @min:%2esplit */]("\n");
    for (var lp = 0; lp < lines[_DYN_LENGTH$4 /* @min:%2elength */]; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack[_DYN_PUSH$1 /* @min:%2epush */](entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj["exception"] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (getWindow() && getWindow()["opera"] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj[_DYN_MESSAGE$1 /* @min:%2emessage */]);
            }
            else if (errorObj["reason"] && errorObj.reason[strStack]) {
                // UnhandledPromiseRejection
                details = _convertStackObj(errorObj.reason[strStack]);
            }
            else if (isString$2(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (isString$2(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            arrForEach(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[_DYN_LENGTH$4 /* @min:%2elength */] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        arrForEach(frames, function (frame) {
            var theFrame = frame[_DYN_TO_STRING$2 /* @min:%2etoString */]();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                parsedStack[_DYN_PUSH$1 /* @min:%2epush */](parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[_DYN_LENGTH$4 /* @min:%2elength */] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                var rSize = parsedStack[right][_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[_DYN_NAME$2 /* @min:%2ename */] || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,200})\(/;
                var results = (funcNameRegex).exec((errorType).constructor[_DYN_TO_STRING$2 /* @min:%2etoString */]());
                typeName = (results && results[_DYN_LENGTH$4 /* @min:%2elength */] > 1) ? results[1] : "";
            }
            catch (e) {
                // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj - The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!isString$2(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (strIndexOf(result, errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
            // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function () {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            exceptions: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            if (id) {
                properties.id = id;
            }
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = [new _ExceptionDetails(logger, exception, properties)];
            _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
            _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
            if (severityLevel) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
            }
            if (id) {
                _self.id = id;
            }
        }
        else {
            _self[_DYN_EXCEPTIONS /* @min:%2eexceptions */] = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */] || [];
            _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = exception[_DYN_PROPERTIES$1 /* @min:%2eproperties */];
            _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = exception[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */];
            if (exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */]) {
                _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = exception[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */];
            }
            if (exception.id) {
                _self.id = exception.id;
                exception[_DYN_PROPERTIES$1 /* @min:%2eproperties */].id = exception.id;
            }
            if (exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */]) {
                _self[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */] = exception[_DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */];
            }
            // bool/int types, use isNullOrUndefined
            if (!isNullOrUndefined(exception[_DYN_IS_MANUAL /* @min:%2eisManual */])) {
                _self[_DYN_IS_MANUAL /* @min:%2eisManual */] = exception[_DYN_IS_MANUAL /* @min:%2eisManual */];
            }
        }
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = _getErrorType(error || evt || message);
        return _a = {},
            _a[_DYN_MESSAGE$1 /* @min:message */] = _formatMessage(message, errorType),
            _a.url = url,
            _a.lineNumber = lineNumber,
            _a.columnNumber = columnNumber,
            _a.error = _formatErrorCode(error || evt || message),
            _a.evt = _formatErrorCode(evt || message),
            _a[_DYN_TYPE_NAME /* @min:typeName */] = errorType,
            _a.stackDetails = _getStackFromErrorObj(stack || error || evt),
            _a.errorSrc = errorSrc,
            _a;
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */]
            && arrMap(exception[_DYN_EXCEPTIONS /* @min:%2eexceptions */], function (ex) { return _ExceptionDetails[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](logger, ex); });
        var exceptionData = new Exception(logger, __assignFn(__assignFn({}, exception), { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && arrMap(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return _a = {
                ver: "4.0"
            },
            _a[_DYN_EXCEPTIONS /* @min:exceptions */] = exceptionDetailsInterface,
            _a.severityLevel = severityLevel,
            _a.properties = properties,
            _a.measurements = measurements,
            _a.problemGroup = problemGroup,
            _a.id = id,
            _a.isManual = isManual,
            _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {},
                    _a[_DYN_HAS_FULL_STACK /* @min:hasFullStack */] = true,
                    _a.message = message,
                    _a.stack = details,
                    _a.typeName = typeName,
                    _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}());
var _ExceptionDetails = /** @class */ (function () {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */,
            outerId: 0 /* FieldType.Default */,
            typeName: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            hasFullStack: 0 /* FieldType.Default */,
            stack: 0 /* FieldType.Default */,
            parsedStack: 2 /* FieldType.Array */
        };
        var _self = this;
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!isError$2(error)) {
                error = error[strError] || evt || error;
            }
            _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = dataSanitizeString(logger, _getErrorType(error)) || strNotSpecified;
            _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = dataSanitizeMessage(logger, _formatMessage(exception || error, _self[_DYN_TYPE_NAME /* @min:%2etypeName */])) || strNotSpecified;
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = _parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if (isArray$3(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */])) {
                arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) {
                    frame[_DYN_ASSEMBLY /* @min:%2eassembly */] = dataSanitizeString(logger, frame[_DYN_ASSEMBLY /* @min:%2eassembly */]);
                    frame[_DYN_FILE_NAME /* @min:%2efileName */] = dataSanitizeString(logger, frame[_DYN_FILE_NAME /* @min:%2efileName */]);
                });
            }
            _self[strStack] = dataSanitizeException(logger, _formatStackTrace(stack));
            _self.hasFullStack = isArray$3(_self.parsedStack) && _self.parsedStack[_DYN_LENGTH$4 /* @min:%2elength */] > 0;
            if (properties) {
                properties[_DYN_TYPE_NAME /* @min:%2etypeName */] = properties[_DYN_TYPE_NAME /* @min:%2etypeName */] || _self[_DYN_TYPE_NAME /* @min:%2etypeName */];
            }
        }
        else {
            _self[_DYN_TYPE_NAME /* @min:%2etypeName */] = exception[_DYN_TYPE_NAME /* @min:%2etypeName */];
            _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = exception[_DYN_MESSAGE$1 /* @min:%2emessage */];
            _self[strStack] = exception[strStack];
            _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] = exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] || [];
            _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */] = exception[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */];
        }
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var _a;
        var _self = this;
        var parsedStack = _self[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array
            && arrMap(_self[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = (_a = {
                id: _self.id,
                outerId: _self.outerId,
                typeName: _self[_DYN_TYPE_NAME /* @min:%2etypeName */],
                message: _self[_DYN_MESSAGE$1 /* @min:%2emessage */],
                hasFullStack: _self[_DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */],
                stack: _self[strStack]
            },
            _a[_DYN_PARSED_STACK /* @min:parsedStack */] = parsedStack || undefined,
            _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */] instanceof Array
            && arrMap(exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */], function (frame) { return _StackFrame[_DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */](frame); }))
            || exception[_DYN_PARSED_STACK /* @min:%2eparsedStack */];
        var exceptionDetails = new _ExceptionDetails(logger, __assignFn(__assignFn({}, exception), { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}());
var _StackFrame = /** @class */ (function () {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */,
            method: 1 /* FieldType.Required */,
            assembly: 0 /* FieldType.Default */,
            fileName: 0 /* FieldType.Default */,
            line: 0 /* FieldType.Default */
        };
        var _self = this;
        _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[_DYN_LEVEL /* @min:%2elevel */] = level;
            _self[_DYN_METHOD$1 /* @min:%2emethod */] = NoMethod;
            _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = strTrim(frame);
            _self[_DYN_FILE_NAME /* @min:%2efileName */] = "";
            _self[_DYN_LINE /* @min:%2eline */] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[_DYN_LENGTH$4 /* @min:%2elength */] >= 5) {
                _self[_DYN_METHOD$1 /* @min:%2emethod */] = strTrim(matches[2]) || _self[_DYN_METHOD$1 /* @min:%2emethod */];
                _self[_DYN_FILE_NAME /* @min:%2efileName */] = strTrim(matches[4]);
                _self[_DYN_LINE /* @min:%2eline */] = parseInt(matches[5]) || 0;
            }
        }
        else {
            _self[_DYN_LEVEL /* @min:%2elevel */] = sourceFrame[_DYN_LEVEL /* @min:%2elevel */];
            _self[_DYN_METHOD$1 /* @min:%2emethod */] = sourceFrame[_DYN_METHOD$1 /* @min:%2emethod */];
            _self[_DYN_ASSEMBLY /* @min:%2eassembly */] = sourceFrame[_DYN_ASSEMBLY /* @min:%2eassembly */];
            _self[_DYN_FILE_NAME /* @min:%2efileName */] = sourceFrame[_DYN_FILE_NAME /* @min:%2efileName */];
            _self[_DYN_LINE /* @min:%2eline */] = sourceFrame[_DYN_LINE /* @min:%2eline */];
            _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] = 0;
        }
        _self.sizeInBytes += _self.method[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.fileName[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.assembly[_DYN_LENGTH$4 /* @min:%2elength */];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[_DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[_DYN_LENGTH$4 /* @min:%2elength */];
        _self.sizeInBytes += _self.line.toString()[_DYN_LENGTH$4 /* @min:%2elength */];
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        var _self = this;
        return {
            level: _self[_DYN_LEVEL /* @min:%2elevel */],
            method: _self[_DYN_METHOD$1 /* @min:%2emethod */],
            assembly: _self[_DYN_ASSEMBLY /* @min:%2eassembly */],
            fileName: _self[_DYN_FILE_NAME /* @min:%2efileName */],
            line: _self[_DYN_LINE /* @min:%2eline */]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            name: 1 /* FieldType.Required */,
            kind: 0 /* FieldType.Default */,
            value: 1 /* FieldType.Required */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = 0 /* DataPointType.Measurement */;
    }
    return DataPoint;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Metric = /** @class */ (function () {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            metrics: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new DataPoint();
        dataPoint[_DYN_COUNT$1 /* @min:%2ecount */] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [dataPoint];
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var strEmpty = "";
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = strEmpty + totalms % 1000;
    var sec = strEmpty + Math.floor(totalms / 1000) % 60;
    var min = strEmpty + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = strEmpty + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms[_DYN_LENGTH$4 /* @min:%2elength */] === 1 ? "00" + ms : ms[_DYN_LENGTH$4 /* @min:%2elength */] === 2 ? "0" + ms : ms;
    sec = sec[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + sec : sec;
    min = min[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + min : min;
    hour = hour[_DYN_LENGTH$4 /* @min:%2elength */] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && isString$2(message) && (message === "Script error." || message === "Script error");
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var PageView = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            id: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = dataSanitizeId(logger, id);
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        if (!isNaN(durationMs)) {
            _self[_DYN_DURATION$1 /* @min:%2eduration */] = msToTimeSpan(durationMs);
        }
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var RemoteDependencyData = /** @class */ (function () {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === undefined) { requestAPI = "Ajax"; }
        this.aiDataContract = {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            resultCode: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            success: 0 /* FieldType.Default */,
            data: 0 /* FieldType.Default */,
            target: 0 /* FieldType.Default */,
            type: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            kind: 0 /* FieldType.Default */,
            value: 0 /* FieldType.Default */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */,
            dependencyKind: 0 /* FieldType.Default */,
            dependencySource: 0 /* FieldType.Default */,
            commandName: 0 /* FieldType.Default */,
            dependencyTypeName: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[_DYN_DURATION$1 /* @min:%2eduration */] = msToTimeSpan(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = dataSanitizeString(logger, requestAPI);
        var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
        _self.data = dataSanitizeUrl(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = dataSanitizeString(logger, dependencyFields.target);
        if (correlationContext) {
            _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        }
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, dependencyFields[_DYN_NAME$2 /* @min:%2ename */]);
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Trace = /** @class */ (function () {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            message: 1 /* FieldType.Required */,
            severityLevel: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        message = message || strNotSpecified;
        _self[_DYN_MESSAGE$1 /* @min:%2emessage */] = dataSanitizeMessage(logger, message);
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (severityLevel) {
            _self[_DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */] = severityLevel;
        }
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var PageViewPerformance = /** @class */ (function () {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            url: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            perfTotal: 0 /* FieldType.Default */,
            networkConnect: 0 /* FieldType.Default */,
            sentRequest: 0 /* FieldType.Default */,
            receivedResponse: 0 /* FieldType.Default */,
            domProcessing: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self.url = dataSanitizeUrl(logger, url);
        _self[_DYN_NAME$2 /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES$1 /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS$1 /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[_DYN_DURATION$1 /* @min:%2eduration */] = cs4BaseData[_DYN_DURATION$1 /* @min:%2eduration */];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */] = cs4BaseData[_DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Data = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}());

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    __extendsFn(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(createClassFromInterface({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Create a telemetry item that the 1DS channel understands
 * @param item - domain specific properties; part B
 * @param baseType - telemetry item type. ie PageViewData
 * @param envelopeName - name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
 * @param customProperties - user defined custom properties; part C
 * @param systemProperties - system properties that are added to the context; part A
 * @returns ITelemetryItem that is sent to channel
 */
function createTelemetryItem(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = dataSanitizeString(logger, envelopeName) || strNotSpecified;
    if (isNullOrUndefined(item) ||
        isNullOrUndefined(baseType) ||
        isNullOrUndefined(envelopeName)) {
        throwError("Input doesn't contain all required fields");
    }
    var iKey = "";
    if (item[strIkey]) {
        iKey = item[strIkey];
        delete item[strIkey];
    }
    var telemetryItem = (_a = {},
        _a[_DYN_NAME$2 /* @min:name */] = envelopeName,
        _a.time = toISOString$2(new Date()),
        _a.iKey = iKey,
        _a.ext = systemProperties ? systemProperties : {},
        _a.tags = [],
        _a.data = {},
        _a.baseType = baseType,
        _a.baseData = item // Part B
    ,
        _a);
    // Part C
    if (!isNullOrUndefined(customProperties)) {
        objForEachKey(customProperties, function (prop, value) {
            telemetryItem.data[prop] = value;
        });
    }
    return telemetryItem;
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new ContextTagKeys();

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function createDomEvent(eventName) {
    var event = null;
    if (isFunction$3(Event)) { // Use Event constructor when available
        event = new Event(eventName);
    }
    else { // Event has no constructor in IE
        var doc = getDocument();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}

function _disableEvents(target, evtNamespace) {
  eventOff(target, null, null, evtNamespace);
}
function createOfflineListener(parentEvtNamespace) {
  var _document = getDocument();
  var _navigator = getNavigator();
  var _isListening = false;
  var listenerList = [];
  var rState = 1;
  if (_navigator && !isNullOrUndefined(_navigator.onLine) && !_navigator.onLine) {
    rState = 2;
  }
  var uState = 0;
  var _currentState = calCurrentState();
  var _evtNamespace = mergeEvtNamespace(createUniqueNamespace("OfflineListener"), parentEvtNamespace);
  try {
    if (_enableEvents(getWindow())) {
      _isListening = true;
    }
    if (_document) {
      var target = _document.body || _document;
      if (target.ononline) {
        if (_enableEvents(target)) {
          _isListening = true;
        }
      }
    }
  } catch (e) {
    _isListening = false;
  }
  function _enableEvents(target2) {
    var enabled = false;
    if (target2) {
      enabled = eventOn(target2, "online", _setOnline, _evtNamespace);
      if (enabled) {
        eventOn(target2, "offline", _setOffline, _evtNamespace);
      }
    }
    return enabled;
  }
  function _isOnline() {
    return _currentState;
  }
  function calCurrentState() {
    if (uState === 2 || rState === 2) {
      return false;
    }
    return true;
  }
  function listnerNoticeCheck() {
    var newState = calCurrentState();
    if (_currentState !== newState) {
      _currentState = newState;
      arrForEach(listenerList, function(callback) {
        var offlineState = {
          isOnline: _currentState,
          rState,
          uState
        };
        try {
          callback(offlineState);
        } catch (e) {
        }
      });
    }
  }
  function setOnlineState(newState) {
    uState = newState;
    listnerNoticeCheck();
  }
  function _setOnline() {
    rState = 1;
    listnerNoticeCheck();
  }
  function _setOffline() {
    rState = 2;
    listnerNoticeCheck();
  }
  function _unload() {
    var win = getWindow();
    if (win && _isListening) {
      _disableEvents(win, _evtNamespace);
      if (_document) {
        var target2 = _document.body || _document;
        if (!isUndefined$2(target2.ononline)) {
          _disableEvents(target2, _evtNamespace);
        }
      }
      _isListening = false;
    }
  }
  function addListener(callback) {
    listenerList[
      _DYN_PUSH$1
      /* @min:%2epush */
    ](callback);
    return {
      rm: function() {
        var index = listenerList.indexOf(callback);
        if (index > -1) {
          return listenerList.splice(index, 1);
        } else {
          return;
        }
      }
    };
  }
  return {
    isOnline: _isOnline,
    isListening: function() {
      return _isListening;
    },
    unload: _unload,
    addListener,
    setOnlineState
  };
}

/*
 * Application Insights JavaScript SDK - Common, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TO_STRING$1 = "toString"; // Count: 4
var _DYN_IS_STORAGE_USE_DISAB0 = "isStorageUseDisabled"; // Count: 3
var _DYN__ADD_HOOK$1 = "_addHook"; // Count: 6
var _DYN_CORE$1 = "core"; // Count: 7
var _DYN_DATA_TYPE$1 = "dataType"; // Count: 8
var _DYN_ENVELOPE_TYPE$1 = "envelopeType"; // Count: 7
var _DYN_DIAG_LOG$1 = "diagLog"; // Count: 13
var _DYN_TRACK = "track"; // Count: 7
var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
var _DYN_TRACK_PREVIOUS_PAGE_1 = "trackPreviousPageVisit"; // Count: 3
var _DYN_SEND_PAGE_VIEW_INTER2 = "sendPageViewInternal"; // Count: 7
var _DYN_START_TIME$1 = "startTime"; // Count: 6
var _DYN_PROPERTIES = "properties"; // Count: 3
var _DYN_DURATION = "duration"; // Count: 12
var _DYN_SEND_PAGE_VIEW_PERFO3 = "sendPageViewPerformanceInternal"; // Count: 3
var _DYN_POPULATE_PAGE_VIEW_P4 = "populatePageViewPerformanceEvent"; // Count: 3
var _DYN_HREF = "href"; // Count: 6
var _DYN_SEND_EXCEPTION_INTER5 = "sendExceptionInternal"; // Count: 2
var _DYN_EXCEPTION$1 = "exception"; // Count: 3
var _DYN_ERROR = "error"; // Count: 5
var _DYN__ONERROR = "_onerror"; // Count: 3
var _DYN_ERROR_SRC = "errorSrc"; // Count: 3
var _DYN_LINE_NUMBER = "lineNumber"; // Count: 5
var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
var _DYN_MESSAGE = "message"; // Count: 4
var _DYN__CREATE_AUTO_EXCEPTI6 = "CreateAutoException"; // Count: 3
var _DYN_ADD_TELEMETRY_INITIA7 = "addTelemetryInitializer"; // Count: 4
var _DYN_OVERRIDE_PAGE_VIEW_D8 = "overridePageViewDuration"; // Count: 2
var _DYN_AUTO_TRACK_PAGE_VISI9 = "autoTrackPageVisitTime"; // Count: 2
var _DYN_IS_BROWSER_LINK_TRAC10 = "isBrowserLinkTrackingEnabled"; // Count: 2
var _DYN_LENGTH$3 = "length"; // Count: 5
var _DYN_ENABLE_AUTO_ROUTE_TR11 = "enableAutoRouteTracking"; // Count: 2
var _DYN_ENABLE_UNHANDLED_PRO12 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
var _DYN_AUTO_UNHANDLED_PROMI13 = "autoUnhandledPromiseInstrumented"; // Count: 3
var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 5
var _DYN_IS_PERFORMANCE_TIMIN14 = "isPerformanceTimingSupported"; // Count: 2
var _DYN_GET_PERFORMANCE_TIMI15 = "getPerformanceTiming"; // Count: 2
var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
var _DYN_SHOULD_COLLECT_DURAT16 = "shouldCollectDuration"; // Count: 3
var _DYN_IS_PERFORMANCE_TIMIN17 = "isPerformanceTimingDataReady"; // Count: 2
var _DYN_RESPONSE_START = "responseStart"; // Count: 5
var _DYN_REQUEST_START = "requestStart"; // Count: 3
var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
var _DYN_CONNECT_END = "connectEnd"; // Count: 4
var _DYN_PAGE_VISIT_START_TIM18 = "pageVisitStartTime"; // Count: 2

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Class encapsulates sending page views and page view performance telemetry.
 */
var PageViewManager = /** @class */ (function () {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        dynamicProto(PageViewManager, this, function (_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var firstPageViewSent = false;
            var _logger;
            if (core) {
                _logger = core.logger;
            }
            function _flushChannels(isAsync) {
                if (core) {
                    core.flush(isAsync, function () {
                        // Event flushed, callback added to prevent promise creation
                    });
                }
            }
            function _startTimer() {
                if (!queueTimer) {
                    queueTimer = scheduleTimeout((function () {
                        queueTimer = null;
                        var allItems = itemQueue.slice(0);
                        var doFlush = false;
                        itemQueue = [];
                        arrForEach(allItems, function (item) {
                            if (!item()) {
                                // Not processed so rescheduled
                                itemQueue.push(item);
                            }
                            else {
                                doFlush = true;
                            }
                        });
                        if (itemQueue[_DYN_LENGTH$3 /* @min:%2elength */] > 0) {
                            _startTimer();
                        }
                        if (doFlush) {
                            // We process at least one item so flush the queue
                            _flushChannels(true);
                        }
                    }), 100);
                }
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                var name = pageView.name;
                if (isNullOrUndefined(name) || typeof name !== "string") {
                    var doc = getDocument();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if (isNullOrUndefined(uri) || typeof uri !== "string") {
                    var location_1 = getLocation$1();
                    uri = pageView.uri = location_1 && location_1[_DYN_HREF /* @min:%2ehref */] || "";
                }
                if (!firstPageViewSent) {
                    var perf = getPerformance();
                    // Access the performance timing object
                    var navigationEntries = (perf && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */] && perf[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation"));
                    // Edge Case the navigation Entries may return an empty array and the timeOrigin is not supported on IE
                    if (navigationEntries && navigationEntries[0] && !isUndefined$2(perf.timeOrigin)) {
                        // Get the value of loadEventStart
                        var loadEventStart = navigationEntries[0].loadEventStart;
                        pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(perf.timeOrigin + loadEventStart);
                    }
                    else {
                        // calculate the start time manually
                        var duration_1 = ((customProperties || pageView[_DYN_PROPERTIES /* @min:%2eproperties */] || {})[_DYN_DURATION /* @min:%2eduration */] || 0);
                        pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(new Date().getTime() - duration_1);
                    }
                    firstPageViewSent = true;
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN14 /* @min:%2eisPerformanceTimingSupported */]()) {
                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    if (!isWebWorker()) {
                        // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 25 /* _eInternalMessageId.NavigationTimingNotSupported */, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    }
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[_DYN_GET_PERFORMANCE_TIMI15 /* @min:%2egetPerformanceTiming */]()[_DYN_NAVIGATION_START /* @min:%2enavigationStart */];
                if (start > 0) {
                    customDuration = dateTimeUtilsDuration(start, +new Date);
                    if (!pageViewPerformanceManager[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */](customDuration)) {
                        customDuration = undefined;
                    }
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!isNullOrUndefined(customProperties) &&
                    !isNullOrUndefined(customProperties[_DYN_DURATION /* @min:%2eduration */])) {
                    duration = customProperties[_DYN_DURATION /* @min:%2eduration */];
                }
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) {
                            customProperties = {};
                        }
                        customProperties[_DYN_DURATION /* @min:%2eduration */] = customDuration;
                    }
                    // case 2
                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) {
                    customProperties = {};
                }
                // Queue the event for processing
                _addQueue(function () {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[_DYN_IS_PERFORMANCE_TIMIN17 /* @min:%2eisPerformanceTimingDataReady */]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[_DYN_DURATION /* @min:%2eduration */] = customDuration;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                            else {
                                if (!pageViewSent) {
                                    customProperties[_DYN_DURATION /* @min:%2eduration */] = pageViewPerformance.durationMs;
                                    appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        }
                        else if (start > 0 && dateTimeUtilsDuration(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[_DYN_DURATION /* @min:%2eduration */] = maxDurationLimit;
                                appInsights[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageView, customProperties);
                            }
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 38 /* _eInternalMessageId.TrackPVFailedCalc */, "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                    return processed;
                });
            };
            _self.teardown = function (unloadCtx, unloadState) {
                if (queueTimer) {
                    queueTimer.cancel();
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    itemQueue = [];
                    arrForEach(allItems, function (item) {
                        if (item()) ;
                    });
                }
            };
        });
    }
// Removed Stub for PageViewManager.prototype.trackPageView.
// Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewManager.__ieDyn=1;

    return PageViewManager;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MAX_DURATION_ALLOWED = 3600000; // 1h
var botAgentNames = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function _isPerformanceTimingSupported() {
    var perf = getPerformance();
    return perf && !!perf.timing;
}
function _isPerformanceNavigationTimingSupported() {
    var perf = getPerformance();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[_DYN_LENGTH$3 /* @min:%2elength */] > 0;
}
function _isPerformanceTimingDataReady() {
    var perf = getPerformance();
    var timing = perf ? perf.timing : 0;
    return timing
        && timing.domainLookupStart > 0
        && timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */] > 0
        && timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */] > 0
        && timing[_DYN_REQUEST_START /* @min:%2erequestStart */] > 0
        && timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */] > 0
        && timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */] > 0
        && timing[_DYN_CONNECT_END /* @min:%2econnectEnd */] > 0
        && timing.domLoading > 0;
}
function _getPerformanceTiming() {
    if (_isPerformanceTimingSupported()) {
        return getPerformance().timing;
    }
    return null;
}
function _getPerformanceNavigationTiming() {
    if (_isPerformanceNavigationTimingSupported()) {
        return getPerformance()[_DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */]("navigation")[0];
    }
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/
function _shouldCollectDuration() {
    var durations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        durations[_i] = arguments[_i];
    }
    var _navigator = getNavigator() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) {
        for (var i = 0; i < botAgentNames[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
            isGoogleBot = isGoogleBot || strIndexOf(userAgent.toLowerCase(), botAgentNames[i]) !== -1;
        }
    }
    if (isGoogleBot) {
        // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
        return false;
    }
    else {
        // for other page views, don't report if it's outside of a reasonable range
        for (var i = 0; i < durations[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
            if (durations[i] < 0 || durations[i] >= MAX_DURATION_ALLOWED) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */
var PageViewPerformanceManager = /** @class */ (function () {
    function PageViewPerformanceManager(core) {
        var _logger = safeGetLogger(core);
        dynamicProto(PageViewPerformanceManager, this, function (_self) {
            _self[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */] = function (pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */
                var navigationTiming = _getPerformanceNavigationTiming();
                var timing = _getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[_DYN_DURATION /* @min:%2eduration */];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */
                        network = navigationTiming[_DYN_START_TIME$1 /* @min:%2estartTime */] === 0 ? navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */] : dateTimeUtilsDuration(navigationTiming[_DYN_START_TIME$1 /* @min:%2estartTime */], navigationTiming[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                        request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                        response = dateTimeUtilsDuration(navigationTiming[_DYN_RESPONSE_START /* @min:%2eresponseStart */], navigationTiming[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                        dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    }
                    else {
                        total = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                        network = dateTimeUtilsDuration(timing[_DYN_NAVIGATION_START /* @min:%2enavigationStart */], timing[_DYN_CONNECT_END /* @min:%2econnectEnd */]);
                        request = dateTimeUtilsDuration(timing.requestStart, timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */]);
                        response = dateTimeUtilsDuration(timing[_DYN_RESPONSE_START /* @min:%2eresponseStart */], timing[_DYN_RESPONSE_END /* @min:%2eresponseEnd */]);
                        dom = dateTimeUtilsDuration(timing.responseEnd, timing[_DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */]);
                    }
                    if (total === 0) {
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 10 /* _eInternalMessageId.ErrorPVCalc */, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (!_self[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */](total, network, request, response, dom)) {
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 45 /* _eInternalMessageId.InvalidDurationValue */, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
                        // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                        // in this case, don't report client performance from this page
                        _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 8 /* _eInternalMessageId.ClientPerformanceMathError */, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
                    }
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[_DYN_DURATION /* @min:%2eduration */] = msToTimeSpan(total);
                        pageViewPerformance.networkConnect = msToTimeSpan(network);
                        pageViewPerformance.sentRequest = msToTimeSpan(request);
                        pageViewPerformance.receivedResponse = msToTimeSpan(response);
                        pageViewPerformance.domProcessing = msToTimeSpan(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[_DYN_GET_PERFORMANCE_TIMI15 /* @min:%2egetPerformanceTiming */] = _getPerformanceTiming;
            _self[_DYN_IS_PERFORMANCE_TIMIN14 /* @min:%2eisPerformanceTimingSupported */] = _isPerformanceTimingSupported;
            _self[_DYN_IS_PERFORMANCE_TIMIN17 /* @min:%2eisPerformanceTimingDataReady */] = _isPerformanceTimingDataReady;
            _self[_DYN_SHOULD_COLLECT_DURAT16 /* @min:%2eshouldCollectDuration */] = _shouldCollectDuration;
        });
    }
// Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
// Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
// Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
// Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageViewPerformanceManager.__ieDyn=1;

    return PageViewPerformanceManager;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Used to track page visit durations
 */
var PageVisitTimeManager = /** @class */ (function () {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler - Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */
    function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        dynamicProto(PageVisitTimeManager, this, function (_self) {
            _self[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */] = function (currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) {
                        pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Auto track page visit time failed, metric will not be collected: " + dumpObj(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName - Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */
            function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    if (utlCanUseSessionStorage()) {
                        if (utlGetSessionStorage(logger, prevPageVisitDataKeyName) != null) {
                            throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        }
                        var currPageVisitDataStr = getJSON().stringify(new PageVisitData(pageName, pageUrl));
                        utlSetSessionStorage(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Call to restart failed: " + dumpObj(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */
            function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if (utlCanUseSessionStorage()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = utcNow();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = utlGetSessionStorage(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && hasJSON()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[_DYN_PAGE_VISIT_START_TIM18 /* @min:%2epageVisitStartTime */];
                            // Remove data from storage since we already used it
                            utlRemoveSessionStorage(logger, prevPageVisitDataKeyName);
                        }
                    }
                }
                catch (e) {
                    _warnToConsole(logger, "Stop page visit timer failed: " + dumpObj(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            objDefine(_self, "_logger", { g: function () { return logger; } });
            objDefine(_self, "pageVisitTimeTrackingHandler", { g: function () { return pageVisitTimeTrackingHandler; } });
        });
    }
// Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PageVisitTimeManager.__ieDyn=1;

    return PageVisitTimeManager;
}());
var PageVisitData = /** @class */ (function () {
    function PageVisitData(pageName, pageUrl) {
        this[_DYN_PAGE_VISIT_START_TIM18 /* @min:%2epageVisitStartTime */] = utcNow();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Used to record timed events and page views.
 */
var Timing = /** @class */ (function () {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function (name) {
            if (typeof _events[name] !== "undefined") {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 62 /* _eInternalMessageId.StartCalledMoreThanOnce */, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        };
        _self.stop = function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 63 /* _eInternalMessageId.StopCalledWithoutStart */, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = dateTimeUtilsDuration(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}());

/*
 * Application Insights JavaScript SDK - Web Analytics, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/
var _a$6;
var strEvent = "event";
function _dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
    }
}
function _getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!isString$2(reason) && isFunction$3(reason[_DYN_TO_STRING$1 /* @min:%2etoString */])) {
            return reason[_DYN_TO_STRING$1 /* @min:%2etoString */]();
        }
        return dumpObj(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var MinMilliSeconds = 60000;
var defaultValues = objDeepFreeze((_a$6 = {
        sessionRenewalMs: cfgDfSet(_chkConfigMilliseconds, 30 * 60 * 1000),
        sessionExpirationMs: cfgDfSet(_chkConfigMilliseconds, 24 * 60 * 60 * 1000),
        disableExceptionTracking: cfgDfBoolean()
    },
    _a$6[_DYN_AUTO_TRACK_PAGE_VISI9 /* @min:autoTrackPageVisitTime */] = cfgDfBoolean(),
    _a$6[_DYN_OVERRIDE_PAGE_VIEW_D8 /* @min:overridePageViewDuration */] = cfgDfBoolean(),
    _a$6[_DYN_ENABLE_UNHANDLED_PRO12 /* @min:enableUnhandledPromiseRejectionTracking */] = cfgDfBoolean(),
    _a$6[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:autoUnhandledPromiseInstrumented */] = false,
    _a$6.samplingPercentage = cfgDfValidate(_chkSampling$1, 100),
    _a$6[_DYN_IS_STORAGE_USE_DISAB0 /* @min:isStorageUseDisabled */] = cfgDfBoolean(),
    _a$6[_DYN_IS_BROWSER_LINK_TRAC10 /* @min:isBrowserLinkTrackingEnabled */] = cfgDfBoolean(),
    _a$6[_DYN_ENABLE_AUTO_ROUTE_TR11 /* @min:enableAutoRouteTracking */] = cfgDfBoolean(),
    _a$6.namePrefix = cfgDfString(),
    _a$6.enableDebug = cfgDfBoolean(),
    _a$6.disableFlushOnBeforeUnload = cfgDfBoolean(),
    _a$6.disableFlushOnUnload = cfgDfBoolean(false, "disableFlushOnBeforeUnload"),
    _a$6));
function _chkConfigMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < MinMilliSeconds) {
        value = MinMilliSeconds;
    }
    return +value;
}
function _chkSampling$1(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
function _updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!isUndefined$2(extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */])) {
        if (extConfig[_DYN_IS_STORAGE_USE_DISAB0 /* @min:%2eisStorageUseDisabled */]) {
            utlDisableStorage();
        }
        else {
            utlEnableStorage();
        }
    }
}
var AnalyticsPlugin = /** @class */ (function (_super) {
    __extendsFn(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = AnalyticsPluginIdentifier; // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        var _extConfig;
        var _autoTrackPageVisitTime;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        dynamicProto(AnalyticsPlugin, _this, function (_self, _base) {
            var _addHook = _base[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */];
            _initDefaults();
            _self.getCookieMgr = function () {
                return safeGetCookieMgr(_self[_DYN_CORE$1 /* @min:%2ecore */]);
            };
            _self.processTelemetry = function (env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function (event, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(event, Event$1[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Event$1[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */
            _self.startTrackEvent = function (name) {
                try {
                    _eventTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 29 /* _eInternalMessageId.StartTrackEventFailed */, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackEvent = function (name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 30 /* _eInternalMessageId.StopTrackEventFailed */, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */
            _self.trackTrace = function (trace, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(trace, Trace[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Trace[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */, 39 /* _eInternalMessageId.TrackTraceFailed */, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param metric - input object argument. Only name and average are mandatory.
             * @param } customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */
            _self.trackMetric = function (metric, customProperties) {
                try {
                    var telemetryItem = createTelemetryItem(metric, Metric[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Metric[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties);
                    _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 36 /* _eInternalMessageId.TrackMetricFailed */, "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry - The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties - Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */
            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */] = function (pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */](inPv, __assignFn(__assignFn(__assignFn({}, inPv.properties), inPv.measurements), customProperties));
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](inPv.name, inPv.uri);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView - Page view item to be sent
             * @param properties - Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties - System level properties (Part A) that a user can add to the telemetry item
             */
            _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */] = function (pageView, properties, systemProperties) {
                var doc = getDocument();
                if (doc) {
                    pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                }
                if (isNullOrUndefined(pageView[_DYN_START_TIME$1 /* @min:%2estartTime */])) {
                    // calculate the start time manually
                    var duration = ((properties || pageView[_DYN_PROPERTIES /* @min:%2eproperties */] || {})[_DYN_DURATION /* @min:%2eduration */] || 0);
                    pageView[_DYN_START_TIME$1 /* @min:%2estartTime */] = new Date(new Date().getTime() - duration);
                }
                var telemetryItem = createTelemetryItem(pageView, PageView[_DYN_DATA_TYPE$1 /* @min:%2edataType */], PageView[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */
            _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */] = function (pageViewPerformance, properties, systemProperties) {
                var telemetryItem = createTelemetryItem(pageViewPerformance, PageViewPerformance[_DYN_DATA_TYPE$1 /* @min:%2edataType */], PageViewPerformance[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */
            _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[_DYN_POPULATE_PAGE_VIEW_P4 /* @min:%2epopulatePageViewPerformanceEvent */](inPvp);
                    _self[_DYN_SEND_PAGE_VIEW_PERFO3 /* @min:%2esendPageViewPerformanceInternal */](inPvp, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 37 /* _eInternalMessageId.TrackPVFailed */, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name - A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */
            _self.startTrackPage = function (name) {
                try {
                    if (typeof name !== "string") {
                        var doc = getDocument();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 31 /* _eInternalMessageId.StartTrackFailed */, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackPage = function (name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = getDocument();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = getLocation$1();
                        url = loc && loc[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_autoTrackPageVisitTime) {
                        _pageVisitTimeManager[_DYN_TRACK_PREVIOUS_PAGE_1 /* @min:%2etrackPreviousPageVisit */](name, url);
                    }
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 32 /* _eInternalMessageId.StopTrackFailed */, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */
            _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */] = function (exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = (exception && (exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] || exception[_DYN_ERROR /* @min:%2eerror */])) ||
                    // - Handle someone calling trackException based of v1 API where the exception was the Error
                    isError$2(exception) && exception ||
                    // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                    //   is preserved and does not list ApplicationInsights code as the source
                    { name: (exception && typeof exception), message: exception || strNotSpecified };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new Exception(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), theError, exception[_DYN_PROPERTIES /* @min:%2eproperties */] || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = createTelemetryItem(exceptionPartB, Exception[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), customProperties, systemProperties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param exception -   Object which contains exception to be sent
             * @param } customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */
            _self.trackException = function (exception, customProperties) {
                if (exception && !exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] && exception[_DYN_ERROR /* @min:%2eerror */]) {
                    exception[_DYN_EXCEPTION$1 /* @min:%2eexception */] = exception[_DYN_ERROR /* @min:%2eerror */];
                }
                try {
                    _self[_DYN_SEND_EXCEPTION_INTER5 /* @min:%2esendExceptionInternal */](exception, customProperties);
                }
                catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 35 /* _eInternalMessageId.TrackExceptionFailed */, "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param exception
             * @memberof ApplicationInsights
             */
            _self[_DYN__ONERROR /* @min:%2e_onerror */] = function (exception) {
                var error = exception && exception[_DYN_ERROR /* @min:%2eerror */];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = getWindow();
                        if (_window) {
                            evt = _window[strEvent];
                        }
                    }
                    var url = (exception && exception.url) || (getDocument() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] || "window.onerror@" + url + ":" + (exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0) + ":" + (exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0,
                        columnNumber: exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0,
                        message: exception[_DYN_MESSAGE /* @min:%2emessage */]
                    };
                    if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[_DYN_ERROR /* @min:%2eerror */])) {
                        _sendCORSException(Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[_DYN_LINE_NUMBER /* @min:%2elineNumber */] || 0, exception[_DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */] || 0, error, evt, null, errorSrc), properties);
                    }
                    else {
                        if (!exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */]) {
                            exception[_DYN_ERROR_SRC /* @min:%2eerrorSrc */] = errorSrc;
                        }
                        _self.trackException({ exception: exception, severityLevel: 3 /* eSeverityLevel.Error */ }, properties);
                    }
                }
                catch (e) {
                    var errorString = error ? (error.name + ", " + error[_DYN_MESSAGE /* @min:%2emessage */]) : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */, 11 /* _eInternalMessageId.ExceptionWhileLoggingError */, "_onError threw exception while logging error, error will not be collected: "
                        + getExceptionName(e), { exception: dumpObj(e), errorString: errorString });
                }
            };
            _self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */] = function (telemetryInitializer) {
                if (_self[_DYN_CORE$1 /* @min:%2ecore */]) {
                    // Just add to the core
                    return _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](telemetryInitializer);
                }
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) {
                    _preInitTelemetryInitializers = [];
                }
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    return;
                }
                if (isNullOrUndefined(core)) {
                    throwError("Error initializing");
                }
                _base.initialize(config, core, extensions, pluginChain);
                try {
                    _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        arrForEach(_preInitTelemetryInitializers, function (initializer) {
                            core[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    _populateDefaults(config);
                    _pageViewPerformanceManager = new PageViewPerformanceManager(_self[_DYN_CORE$1 /* @min:%2ecore */]);
                    _pageViewManager = new PageViewManager(_self, _extConfig.overridePageViewDuration, _self[_DYN_CORE$1 /* @min:%2ecore */], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new PageVisitTimeManager(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                    _eventTracking = new Timing(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), "trackEvent");
                    _eventTracking.action =
                        function (name, url, duration, properties, measurements) {
                            if (!properties) {
                                properties = {};
                            }
                            if (!measurements) {
                                measurements = {};
                            }
                            properties.duration = duration[_DYN_TO_STRING$1 /* @min:%2etoString */]();
                            _self.trackEvent({ name: name, properties: properties, measurements: measurements });
                        };
                    // initialize page view timing
                    _pageTracking = new Timing(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), "trackPageView");
                    _pageTracking.action = function (name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if (isNullOrUndefined(properties)) {
                            properties = {};
                        }
                        properties.duration = duration[_DYN_TO_STRING$1 /* @min:%2etoString */]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[_DYN_SEND_PAGE_VIEW_INTER2 /* @min:%2esendPageViewInternal */](pageViewItem, properties);
                    };
                    if (hasWindow()) {
                        _updateExceptionTracking();
                        _updateLocationChange();
                    }
                }
                catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                eventOff(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self[_DYN_CORE$1 /* @min:%2ecore */];
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    _extConfig = ctx.getExtCfg(identifier, defaultValues);
                    _autoTrackPageVisitTime = _extConfig[_DYN_AUTO_TRACK_PAGE_VISI9 /* @min:%2eautoTrackPageVisitTime */];
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _updateStorageUsage(_extConfig);
                    // _updateBrowserLinkTracking
                    _isBrowserLinkTrackingEnabled = _extConfig[_DYN_IS_BROWSER_LINK_TRAC10 /* @min:%2eisBrowserLinkTrackingEnabled */];
                    _addDefaultTelemetryInitializers();
                }));
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milliseconds
             */
            function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = { PageName: pageName, PageUrl: pageUrl };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = ["/browserLinkSignalR/", "/__browserLink/"];
                    var dropBrowserLinkRequests = function (envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === RemoteDependencyData[_DYN_DATA_TYPE$1 /* @min:%2edataType */]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) {
                                for (var i = 0; i < browserLinkPaths_1[_DYN_LENGTH$3 /* @min:%2elength */]; i++) {
                                    if (remoteData.target && strIndexOf(remoteData.target, browserLinkPaths_1[i]) >= 0) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    };
                    _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](_self[_DYN_ADD_TELEMETRY_INITIA7 /* @min:%2eaddTelemetryInitializer */](dropBrowserLinkRequests));
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = createTelemetryItem(exception, Exception[_DYN_DATA_TYPE$1 /* @min:%2edataType */], Exception[_DYN_ENVELOPE_TYPE$1 /* @min:%2eenvelopeType */], _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), properties);
                _self[_DYN_CORE$1 /* @min:%2ecore */][_DYN_TRACK /* @min:%2etrack */](telemetryItem);
            }
            function _updateExceptionTracking() {
                var _window = getWindow();
                var locn = getLocation$1(true);
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _disableExceptionTracking = _extConfig.disableExceptionTracking;
                    if (!_disableExceptionTracking && !_autoExceptionInstrumented && !_extConfig.autoExceptionInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onerror", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, message, url, lineNumber, columnNumber, error) {
                                if (!_disableExceptionTracking && callDetails.rslt !== true) {
                                    _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](message, url, lineNumber, columnNumber, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _autoExceptionInstrumented = true;
                    }
                }));
                _addUnhandledPromiseRejectionTracking(_window, locn);
            }
            function _updateLocationChange() {
                var win = getWindow();
                var locn = getLocation$1(true);
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableAutoRouteTracking = _extConfig[_DYN_ENABLE_AUTO_ROUTE_TR11 /* @min:%2eenableAutoRouteTracking */] === true;
                    /**
                     * Create a custom "locationchange" event which is triggered each time the history object is changed
                     */
                    if (win && _enableAutoRouteTracking && !_historyListenerAdded && hasHistory()) {
                        var _history = getHistory();
                        if (isFunction$3(_history.pushState) && isFunction$3(_history.replaceState) && typeof Event !== strShimUndefined) {
                            _addHistoryListener(win, _history, locn);
                        }
                    }
                }));
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[_DYN_CORE$1 /* @min:%2ecore */] && _self[_DYN_CORE$1 /* @min:%2ecore */].getTraceCtx) {
                    distributedTraceCtx = _self[_DYN_CORE$1 /* @min:%2ecore */].getTraceCtx(false);
                }
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[_DYN_CORE$1 /* @min:%2ecore */].getPlugin(PropertiesPluginIdentifier);
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) {
                            distributedTraceCtx = createDistributedTraceContextFromTrace(context.telemetryTrace);
                        }
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */
            function _addHistoryListener(win, history, locn) {
                if (_historyListenerAdded) {
                    return;
                }
                // Name Prefix is only referenced during the initial initialization and cannot be changed afterwards
                var namePrefix = _extConfig.namePrefix || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) {
                        _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                    }
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    else {
                        _currUri = locn && locn[_DYN_HREF /* @min:%2ehref */] || "";
                    }
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId(generateW3CId());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) {
                                traceLocationName = locn.pathname + (locn.hash || "");
                            }
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName(dataSanitizeString(_self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */](), traceLocationName));
                        }
                        scheduleTimeout((function (uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[_DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */]({ refUri: uri, properties: { duration: 0 } }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                _addHook(InstrumentEvent(history, "pushState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "pushState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                _addHook(InstrumentEvent(history, "replaceState", {
                    ns: _evtNamespace,
                    rsp: function () {
                        if (_enableAutoRouteTracking) {
                            _dispatchEvent(win, createDomEvent(namePrefix + "replaceState"));
                            _dispatchEvent(win, createDomEvent(namePrefix + "locationchange"));
                        }
                    }
                }, true));
                eventOn(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                eventOn(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                _historyListenerAdded = true;
            }
            function _addUnhandledPromiseRejectionTracking(_window, _location) {
                _self[_DYN__ADD_HOOK$1 /* @min:%2e_addHook */](onConfigChange(_extConfig, function () {
                    _enableUnhandledPromiseRejectionTracking = _extConfig[_DYN_ENABLE_UNHANDLED_PRO12 /* @min:%2eenableUnhandledPromiseRejectionTracking */] === true;
                    _autoExceptionInstrumented = _autoExceptionInstrumented || _extConfig[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:%2eautoUnhandledPromiseInstrumented */];
                    if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                        // We want to enable exception auto collection and it has not been done so yet
                        _addHook(InstrumentEvent(_window, "onunhandledrejection", {
                            ns: _evtNamespace,
                            rsp: function (callDetails, error) {
                                if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) { // handled could be typeof function
                                    _self[_DYN__ONERROR /* @min:%2e_onerror */](Exception[_DYN__CREATE_AUTO_EXCEPTI6 /* @min:%2eCreateAutoException */](_getReason(error), _location ? _location[_DYN_HREF /* @min:%2ehref */] : "", 0, 0, error, callDetails.evt));
                                }
                            }
                        }, false));
                        _extConfig[_DYN_AUTO_UNHANDLED_PROMI13 /* @min:%2eautoUnhandledPromiseInstrumented */] = _autoUnhandledPromiseInstrumented = true;
                    }
                }));
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity - {eLoggingSeverity} - The severity of the log message
             * @param msgId - {_eInternalLogMessage} - The log message.
             */
            function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[_DYN_DIAG_LOG$1 /* @min:%2ediagLog */]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                _autoTrackPageVisitTime = false;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = getLocation$1(true);
                _prevUri = location && location[_DYN_HREF /* @min:%2ehref */] || "";
                _currUri = null;
                _evtNamespace = null;
                _extConfig = null;
                // Define _self.config
                objDefine(_self, "config", {
                    g: function () { return _extConfig; }
                });
            }
            // For backward compatibility
            objDefine(_self, "_pageViewManager", { g: function () { return _pageViewManager; } });
            objDefine(_self, "_pageViewPerformanceManager", { g: function () { return _pageViewPerformanceManager; } });
            objDefine(_self, "_pageVisitTimeManager", { g: function () { return _pageVisitTimeManager; } });
            objDefine(_self, "_evtNamespace", { g: function () { return "." + _evtNamespace; } });
        });
        return _this;
    }
// Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
// Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
// Removed Stub for AnalyticsPlugin.prototype.trackEvent.
// Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
// Removed Stub for AnalyticsPlugin.prototype.trackTrace.
// Removed Stub for AnalyticsPlugin.prototype.trackMetric.
// Removed Stub for AnalyticsPlugin.prototype.trackPageView.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
// Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
// Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
// Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
// Removed Stub for AnalyticsPlugin.prototype.trackException.
// Removed Stub for AnalyticsPlugin.prototype._onerror.
// Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
// Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = '3.1.1'; // Not currently used anywhere
    return AnalyticsPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_FEATURE_OPT_IN = "featureOptIn"; // Count: 4
var _DYN_ON_CFG_CHANGE_RECEIV0 = "onCfgChangeReceive"; // Count: 2
var _DYN_NON_OVERRIDE_CONFIGS = "nonOverrideConfigs"; // Count: 2
var _DYN_SCHEDULE_FETCH_TIMEO1 = "scheduleFetchTimeout"; // Count: 2

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Delete a config key in the given cfg, if the config key exists in nonOverrideConfigs and its value is set to true
 * @param cfg cfg to modify
 * @param nonOverrideConfigs nonOverrideConfigs
 * @param curLevel cur config level, starting at 0
 * @param maxLevel max config level
 * @returns new copy of modified configs
 */
function replaceByNonOverrideCfg(cfg, nonOverrideConfigs, curLevel, maxLevel) {
    try {
        var exceedMaxLevel = curLevel > maxLevel;
        if (exceedMaxLevel) {
            cfg = null;
        }
        var curCfg_1 = curLevel == 0 ? objExtend$1({}, cfg) : cfg; // only copy cfg at the begining level
        if (curCfg_1 && nonOverrideConfigs && !exceedMaxLevel) {
            objForEachKey(curCfg_1, function (key) {
                var nonOverrideVal = nonOverrideConfigs[key];
                if (!!nonOverrideVal) {
                    if (isObject$6(curCfg_1[key]) && isObject$6(nonOverrideVal)) {
                        curCfg_1[key] = replaceByNonOverrideCfg(curCfg_1[key], nonOverrideVal, ++curLevel, maxLevel);
                    }
                    else {
                        delete curCfg_1[key];
                    }
                }
            });
        }
        return curCfg_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    // if errors happen, do nothing
    return cfg;
}
//                                                     CDN Mode, value = B (CDN value = B)
//                                |--------------------------------------------------------------------------|-----------|
//                                |                    | none        | disabled    | enabled     | forceOn   | forceOff  |
//                                | ------------------ | ----------- | ----------- | ----------- | --------- | --------- |
// | User Mode, value = A         | none               | none        | disabled    | enabled     | enabled   | disabled  |
// (user Value = A)               | disabled           | disabled    | disabled    | disabled    | enabled   | disabled  |
//                                | enabled            | enabled     | disabled    | enabled     | enabled   | disabled  |
//                                | none(blockCdn)     | none        | none        | none        | none      | none      |
//                                | disabled(blockCdn) | disabled    | disabled    | disabled    | disabled  | disabled  |
//                                | enabled(blockCdn)  | enabled     | enabled     | enabled     | enabled   | enabled   |
// This matrix identifies how feature based overrides are selected (if present)
//                                cdn Mode (cdn Value = B)
//                   |---------------------------------------------------------------------------|
//                   |                    | none     | disabled | enabled  | forceOn  | forceOff |
//                   | ------------------ | ---------| ---------| ---------| ---------|----------|
// | User Mode       | none               | A        | A        | A || B   | B || A   | B || A   |
// (user Value = A)  | disabled           | A        | A        | A        | B || A   | B || A   |
//                   | enabled            | A        | A        | A || B   | B || A   | B || A   |
//                   | none(blockCdn)     | A        | A        | A        | A        | A        |
//                   | disabled(blockCdn) | A        | A        | A        | A        | A        |
//                   | enabled(blockCdn)  | A        | A        | A        | A        | A        |
// Note:
// Where the "value" is an object (map) of encoded key/values which will be used to override the real configuration
// A = either the user supplied enable/disable value (via the `config.featureOptIn[name]`) or if not defined by the user the SDK defaults of the same.
// B = The enable/disable value obtained from the CDN for the named feature
// These are evaluated based on the above matrix to either
// - A (Always the user/sdk value)
// - B (Always the value from the CDN)
// - A || B (If A is null or undefined use the value from the CDN (B) otherwise A)
// - B || A (If B is null or undefined use the user/SDK value otherwise use the value from the CDN)
//
// The result of the value may also be null / undefined, which means there are no overrides to apply when the feature is enabled
var F = "featureOptIn.";
var M = ".mode";
var ON = ".onCfg";
var OFF = ".offCfg";
function resolveCdnFeatureCfg(field, cdnCfg, userOptInDetails) {
    var _a;
    // cdn conifg value
    if (!cdnCfg || !cdnCfg.enabled) {
        return null;
    }
    var cdnFt = (cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */] || {})[field] || { mode: 1 /* CdnFeatureMode.none */ };
    var cdnM = cdnFt.mode;
    var cdnOnV = cdnFt.onCfg;
    var cdnOffV = cdnFt.offCfg;
    var userFt = (userOptInDetails || {})[field] || { mode: 2 /* FeatureOptInMode.disable */ }; // default user mode is disable
    var userM = userFt.mode;
    var userOnV = userFt.onCfg;
    var userOffV = userFt.offCfg;
    var blockCdn = !!userFt.blockCdnCfg;
    var mFld = F + field + M;
    var onFld = F + field + ON;
    var offFld = F + field + OFF;
    var mode = userM;
    var onV = userOnV;
    var offV = userOffV;
    if (!blockCdn) {
        if (cdnM === 4 /* CdnFeatureMode.forceOn */ || cdnM === 5 /* CdnFeatureMode.forceOff */) {
            mode = (cdnM == 4 /* CdnFeatureMode.forceOn */ ? 3 /* FeatureOptInMode.enable */ : 2 /* FeatureOptInMode.disable */);
            onV = cdnOnV || userOnV;
            offV = cdnOffV || userOffV;
        }
        else if (cdnM === 2 /* CdnFeatureMode.disable */ || userM === 2 /* FeatureOptInMode.disable */) {
            mode = 2 /* FeatureOptInMode.disable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 3 /* CdnFeatureMode.enable */) {
            mode = 3 /* FeatureOptInMode.enable */;
            onV = userOnV || cdnOnV;
            offV = userOffV || cdnOffV;
        }
        else if (cdnM === 1 /* CdnFeatureMode.none */ && userM === 1 /* FeatureOptInMode.none */) {
            mode = 1 /* FeatureOptInMode.none */;
        }
    }
    return _a = {},
        _a[mFld] = mode,
        _a[onFld] = onV,
        _a[offFld] = offV,
        _a;
}
// helper function to get cdn config with opt-in features
function applyCdnfeatureCfg(cdnCfg, core) {
    try {
        if (!cdnCfg || !cdnCfg.enabled) {
            return null;
        }
        if (!cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]) {
            return cdnCfg.config;
        }
        var optInMap = cdnCfg[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */];
        var cdnConfig_1 = cdnCfg.config || {};
        objForEachKey(optInMap, function (key) {
            var featureVal = resolveCdnFeatureCfg(key, cdnCfg, core.config[_DYN_FEATURE_OPT_IN /* @min:%2efeatureOptIn */]);
            if (!isNullOrUndefined(featureVal)) {
                objForEachKey(featureVal, function (config, val) {
                    setValueByKey(cdnConfig_1, config, val);
                });
                _overrideCdnCfgByFeature(key, featureVal, cdnConfig_1);
            }
        });
        return cdnConfig_1;
    }
    catch (e) {
        // eslint-disable-next-line no-empty
    }
    return null;
}
function _overrideCdnCfgByFeature(field, ftVal, config) {
    var mode = ftVal[F + field + M];
    var val = ftVal[F + field + ON];
    var dVal = ftVal[F + field + OFF];
    var target = null;
    if (mode === 3 /* FeatureOptInMode.enable */) {
        target = val;
    }
    if (mode === 2 /* FeatureOptInMode.disable */) {
        target = dVal;
    }
    if (target) {
        objForEachKey(target, function (key, cfg) {
            setValueByKey(config, key, cfg);
        });
    }
}

var _a$5;
var EVENT_NAME = "ai_cfgsync";
var STR_GET_METHOD = "GET";
var FETCH_TIMEOUT = 18e5;
var udfVal = undefined;
var defaultNonOverrideCfg = { instrumentationKey: true, connectionString: true, endpointUrl: true };
var _defaultConfig$2 = objDeepFreeze((_a$5 = {
  syncMode: 1,
  blkCdnCfg: udfVal,
  customEvtName: udfVal,
  cfgUrl: udfVal,
  overrideSyncFn: udfVal,
  overrideFetchFn: udfVal
}, _a$5[
  _DYN_ON_CFG_CHANGE_RECEIV0
  /* @min:onCfgChangeReceive */
] = udfVal, _a$5[
  _DYN_SCHEDULE_FETCH_TIMEO1
  /* @min:scheduleFetchTimeout */
] = FETCH_TIMEOUT, _a$5[
  _DYN_NON_OVERRIDE_CONFIGS
  /* @min:nonOverrideConfigs */
] = defaultNonOverrideCfg, _a$5));
var CfgSyncPlugin = (
  /** @class */
  function(_super) {
    __extendsFn(CfgSyncPlugin2, _super);
    function CfgSyncPlugin2() {
      var _this = _super.call(this) || this;
      _this.priority = 198;
      _this.identifier = "AppInsightsCfgSyncPlugin";
      var _extensionConfig;
      var _mainConfig;
      var _evtName;
      var _evtNamespace;
      var _cfgUrl;
      var _timeoutHandle;
      var _receiveChanges;
      var _broadcastChanges;
      var _blkCdnCfg;
      var _fetchTimeout;
      var _retryCnt;
      var _onCfgChangeReceive;
      var _nonOverrideConfigs;
      var _fetchFn;
      var _overrideFetchFn;
      var _overrideSyncFn;
      var _paused = false;
      dynamicProto(CfgSyncPlugin2, _this, function(_self, _base) {
        _initDefaults();
        _self.initialize = function(config, core, extensions, pluginChain) {
          _base.initialize(config, core, extensions, pluginChain);
          _evtNamespace = mergeEvtNamespace(createUniqueNamespace(_self.identifier), core.evtNamespace && core.evtNamespace());
          _populateDefaults(config);
        };
        _self.getCfg = function() {
          return _mainConfig;
        };
        _self.pause = function() {
          _paused = true;
          _clearScheduledTimer();
        };
        _self.resume = function() {
          _paused = false;
          _setupTimer();
        };
        _self.setCfg = function(config) {
          return _setCfg(config);
        };
        _self.sync = function(customDetails) {
          return _sendCfgsyncEvents(customDetails);
        };
        _self.updateEventListenerName = function(eventName) {
          return _updateEventListenerName(eventName);
        };
        _self._doTeardown = function(unloadCtx, unloadState) {
          _eventOff();
          _clearScheduledTimer();
          _initDefaults();
        };
        _self["_getDbgPlgTargets"] = function() {
          return [_broadcastChanges, _receiveChanges, _evtName, _blkCdnCfg];
        };
        function _initDefaults() {
          _mainConfig = null;
          _evtName = null;
          _evtNamespace = null;
          _cfgUrl = null;
          _receiveChanges = null;
          _broadcastChanges = null;
          _nonOverrideConfigs = null;
          _timeoutHandle = null;
          _fetchTimeout = null;
          _retryCnt = null;
          _blkCdnCfg = null;
          _overrideFetchFn = null;
          _overrideSyncFn = null;
          _onCfgChangeReceive = null;
        }
        function _populateDefaults(config) {
          var identifier = _self.identifier;
          var core = _self.core;
          _self._addHook(onConfigChange(config, function() {
            var ctx = createProcessTelemetryContext(null, config, core);
            _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig$2);
            var preBlkCdn = _blkCdnCfg;
            _blkCdnCfg = !!_extensionConfig.blkCdnCfg;
            if (!isNullOrUndefined(preBlkCdn) && preBlkCdn !== _blkCdnCfg) {
              if (!_blkCdnCfg && _cfgUrl) {
                _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
              } else {
                _clearScheduledTimer();
              }
            }
            if (isNullOrUndefined(_receiveChanges)) {
              _receiveChanges = _extensionConfig.syncMode === 2;
            }
            if (isNullOrUndefined(_broadcastChanges)) {
              _broadcastChanges = _extensionConfig.syncMode === 1;
            }
            var newEvtName = _extensionConfig.customEvtName || EVENT_NAME;
            if (_evtName !== newEvtName) {
              if (_receiveChanges) {
                _updateEventListenerName(newEvtName);
              } else {
                _eventOff();
                _evtName = newEvtName;
              }
            }
            if (isNullOrUndefined(_cfgUrl)) {
              _cfgUrl = _extensionConfig.cfgUrl;
            }
            if (!_cfgUrl) {
              _mainConfig = config;
              if (_broadcastChanges) {
                _sendCfgsyncEvents();
              }
            }
          }));
          _overrideSyncFn = _extensionConfig.overrideSyncFn;
          _overrideFetchFn = _extensionConfig.overrideFetchFn;
          _onCfgChangeReceive = _extensionConfig[
            _DYN_ON_CFG_CHANGE_RECEIV0
            /* @min:%2eonCfgChangeReceive */
          ];
          _nonOverrideConfigs = _extensionConfig[
            _DYN_NON_OVERRIDE_CONFIGS
            /* @min:%2enonOverrideConfigs */
          ];
          _fetchTimeout = _extensionConfig[
            _DYN_SCHEDULE_FETCH_TIMEO1
            /* @min:%2escheduleFetchTimeout */
          ];
          _fetchFn = _getFetchFnInterface();
          _retryCnt = 0;
          if (_cfgUrl && !_blkCdnCfg) {
            _fetchFn && _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
          }
        }
        function _setCfg(config, isAutoSync) {
          if (config) {
            _mainConfig = config;
            if (!!isAutoSync && !_paused) {
              return _sendCfgsyncEvents();
            }
            if (_receiveChanges && !_paused) {
              _self.core.updateCfg(config);
              return true;
            }
          }
          return false;
        }
        function _eventOff() {
          try {
            var global_1 = getGlobal();
            if (global_1) {
              eventOff(global_1, null, null, _evtNamespace);
            }
          } catch (e) {
          }
        }
        function _sendCfgsyncEvents(customDetails) {
          try {
            if (!!_overrideSyncFn && isFunction$3(_overrideSyncFn)) {
              return _overrideSyncFn(_mainConfig, customDetails);
            }
            return sendCustomEvent(_evtName, _mainConfig, customDetails);
          } catch (e) {
          }
          return false;
        }
        function _updateEventListenerName(name) {
          try {
            _eventOff();
            if (name) {
              _evtName = name;
              _addEventListener();
            }
            return true;
          } catch (e) {
          }
          return false;
        }
        function _getFetchFnInterface() {
          var _fetchFn2 = _overrideFetchFn;
          if (isNullOrUndefined(_fetchFn2)) {
            if (isFetchSupported$1()) {
              _fetchFn2 = _fetchSender;
            } else if (isXhrSupported()) {
              _fetchFn2 = _xhrSender;
            }
          }
          return _fetchFn2;
        }
        function _fetchSender(url, oncomplete, isAutoSync) {
          var global = getGlobal();
          var fetchFn = global && global.fetch || null;
          if (url && fetchFn && isFunction$3(fetchFn)) {
            try {
              var init = {
                method: STR_GET_METHOD
              };
              var request = new Request(url, init);
              doAwaitResponse(fetch(request), function(result) {
                var response = result.value;
                if (!result.rejected) {
                  if (response.ok) {
                    doAwaitResponse(response.text(), function(res) {
                      _doOnComplete(oncomplete, response.status, res.value, isAutoSync);
                    });
                  } else {
                    _doOnComplete(oncomplete, response.status, null, isAutoSync);
                  }
                } else {
                  _doOnComplete(oncomplete, 400);
                }
              });
            } catch (e) {
            }
          }
        }
        function _xhrSender(url, oncomplete, isAutoSync) {
          try {
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open(STR_GET_METHOD, url);
            xhr_1.onreadystatechange = function() {
              if (xhr_1.readyState === XMLHttpRequest.DONE) {
                _doOnComplete(oncomplete, xhr_1.status, xhr_1.responseText, isAutoSync);
              }
            };
            xhr_1.onerror = function() {
              _doOnComplete(oncomplete, 400);
            };
            xhr_1.ontimeout = function() {
              _doOnComplete(oncomplete, 400);
            };
            xhr_1.send();
          } catch (e) {
          }
        }
        function _onFetchComplete(status, response, isAutoSync) {
          try {
            if (status >= 200 && status < 400 && response) {
              _retryCnt = 0;
              var JSON_1 = getJSON();
              if (JSON_1) {
                var cdnCfg = JSON_1.parse(response);
                var cfg = applyCdnfeatureCfg(cdnCfg, _self.core);
                cfg && _setCfg(cfg, isAutoSync);
              }
            } else {
              _retryCnt++;
            }
            if (_retryCnt < 3) {
              _setupTimer();
            }
          } catch (e) {
          }
        }
        function _doOnComplete(oncomplete, status, response, isAutoSync) {
          try {
            oncomplete(status, response, isAutoSync);
          } catch (e) {
          }
        }
        function _addEventListener() {
          if (_receiveChanges) {
            var global_2 = getGlobal();
            if (global_2) {
              try {
                eventOn(global_2, _evtName, function(event) {
                  var cfgEvent = event && event.detail;
                  if (_onCfgChangeReceive && cfgEvent) {
                    _onCfgChangeReceive(cfgEvent);
                  } else {
                    var cfg = cfgEvent && cfgEvent.cfg;
                    var newCfg = cfg && isPlainObject$6(cfg) && _replaceTartgetByKeys(cfg);
                    newCfg && _setCfg(newCfg);
                  }
                }, _evtNamespace, true);
              } catch (e) {
              }
            }
          }
        }
        function _replaceTartgetByKeys(cfg, level) {
          var _cfg = null;
          try {
            if (cfg) {
              _cfg = replaceByNonOverrideCfg(cfg, _nonOverrideConfigs, 0, 5);
            }
          } catch (e) {
          }
          return _cfg;
        }
        function _setupTimer() {
          if (!_timeoutHandle && _fetchTimeout) {
            _timeoutHandle = scheduleTimeout(function() {
              _timeoutHandle = null;
              _fetchFn(_cfgUrl, _onFetchComplete, _broadcastChanges);
            }, _fetchTimeout);
            _timeoutHandle.unref();
          }
        }
        function _clearScheduledTimer() {
          _timeoutHandle && _timeoutHandle.cancel();
          _timeoutHandle = null;
          _retryCnt = 0;
        }
        _self.processTelemetry = function(env, itemCtx) {
          _self.processNext(env, itemCtx);
        };
      });
      return _this;
    }
    CfgSyncPlugin2.__ieDyn = 1;
    return CfgSyncPlugin2;
  }(BaseTelemetryPlugin)
);

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION$1 = "duration";

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_TAGS = "tags"; // Count: 17
var _DYN_DEVICE_TYPE = "deviceType"; // Count: 3
var _DYN_DATA = "data"; // Count: 15
var _DYN_NAME$1 = "name"; // Count: 8
var _DYN_TRACE_ID$1 = "traceID"; // Count: 5
var _DYN_LENGTH$2 = "length"; // Count: 37
var _DYN_STRINGIFY = "stringify"; // Count: 5
var _DYN_MEASUREMENTS = "measurements"; // Count: 7
var _DYN_DATA_TYPE = "dataType"; // Count: 10
var _DYN_ENVELOPE_TYPE = "envelopeType"; // Count: 7
var _DYN_TO_STRING = "toString"; // Count: 7
var _DYN__GET = "_get"; // Count: 5
var _DYN_ENQUEUE = "enqueue"; // Count: 7
var _DYN_COUNT = "count"; // Count: 7
var _DYN_EVENTS_LIMIT_IN_MEM = "eventsLimitInMem"; // Count: 2
var _DYN_PUSH = "push"; // Count: 6
var _DYN_EMIT_LINE_DELIMITED_0 = "emitLineDelimitedJson"; // Count: 3
var _DYN_CLEAR = "clear"; // Count: 6
var _DYN_CREATE_NEW = "createNew"; // Count: 3
var _DYN_MARK_AS_SENT = "markAsSent"; // Count: 4
var _DYN_CLEAR_SENT = "clearSent"; // Count: 5
var _DYN_BUFFER_OVERRIDE = "bufferOverride"; // Count: 3
var _DYN__BUFFER__KEY = "BUFFER_KEY"; // Count: 5
var _DYN__SENT__BUFFER__KEY = "SENT_BUFFER_KEY"; // Count: 8
var _DYN__MAX__BUFFER__SIZE = "MAX_BUFFER_SIZE"; // Count: 5
var _DYN_TRIGGER_SEND = "triggerSend"; // Count: 5
var _DYN_DIAG_LOG = "diagLog"; // Count: 16
var _DYN_INITIALIZE = "initialize"; // Count: 3
var _DYN__SENDER = "_sender"; // Count: 5
var _DYN_CUSTOM_HEADERS = "customHeaders"; // Count: 3
var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 2
var _DYN_ONUNLOAD_DISABLE_BEA2 = "onunloadDisableBeacon"; // Count: 3
var _DYN_IS_BEACON_API_DISABL3 = "isBeaconApiDisabled"; // Count: 3
var _DYN_ALWAYS_USE_XHR_OVERR4 = "alwaysUseXhrOverride"; // Count: 2
var _DYN_DISABLE_XHR = "disableXhr"; // Count: 3
var _DYN_ENABLE_SESSION_STORA5 = "enableSessionStorageBuffer"; // Count: 2
var _DYN__BUFFER = "_buffer"; // Count: 9
var _DYN_ONUNLOAD_DISABLE_FET6 = "onunloadDisableFetch"; // Count: 2
var _DYN_DISABLE_SEND_BEACON_7 = "disableSendBeaconSplit"; // Count: 2
var _DYN_INSTRUMENTATION_KEY$1 = "instrumentationKey"; // Count: 2
var _DYN_ENABLE_SEND_PROMISE = "enableSendPromise"; // Count: 2
var _DYN_GET_SENDER_INST = "getSenderInst"; // Count: 4
var _DYN_UNLOAD_TRANSPORTS = "unloadTransports"; // Count: 2
var _DYN_CONVERT_UNDEFINED = "convertUndefined"; // Count: 2
var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 2
var _DYN_SERIALIZE = "serialize"; // Count: 4
var _DYN__ON_ERROR = "_onError"; // Count: 7
var _DYN__ON_PARTIAL_SUCCESS = "_onPartialSuccess"; // Count: 3
var _DYN__ON_SUCCESS = "_onSuccess"; // Count: 6
var _DYN_ITEMS_ACCEPTED = "itemsAccepted"; // Count: 3
var _DYN_ITEMS_RECEIVED = "itemsReceived"; // Count: 3
var _DYN_ORI_PAYLOAD = "oriPayload"; // Count: 3
var _DYN_BASE_TYPE = "baseType"; // Count: 4
var _DYN_SAMPLE_RATE = "sampleRate"; // Count: 4
var _DYN_EVENTS_SEND_REQUEST = "eventsSendRequest"; // Count: 2
var _DYN_GET_SAMPLING_SCORE = "getSamplingScore"; // Count: 2
var _DYN_GET_HASH_CODE_SCORE = "getHashCodeScore"; // Count: 4

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = "baseType";
var strBaseData = "baseData";
var strProperties = "properties";
var strTrue = "true";
function _setValueIf(target, field, value) {
    return setValue(target, field, value, isTruthy);
}
/*
 * Maps Part A data from CS 4.0
 */
function _extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[_DYN_TAGS /* @min:%2etags */] = env[_DYN_TAGS /* @min:%2etags */] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[_DYN_TAGS /* @min:%2etags */] = item[_DYN_TAGS /* @min:%2etags */] || [];
    var extUser = itmExt.user;
    if (extUser) {
        _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
        _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) {
        _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
    }
    var extDevice = itmExt.device;
    if (extDevice) {
        _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice.deviceClass);
        _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
        _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
        _setValueIf(envTags, CtxTagKeys[_DYN_DEVICE_TYPE /* @min:%2edeviceType */], extDevice[_DYN_DEVICE_TYPE /* @min:%2edeviceType */]);
    }
    var web = item.ext.web;
    if (web) {
        _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
        _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
        _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
        var envData = env[_DYN_DATA /* @min:%2edata */] = env[_DYN_DATA /* @min:%2edata */] || {};
        var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
        var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
        _setValueIf(envProps, "domain", web.domain);
        _setValueIf(envProps, "isManual", web.isManual ? strTrue : null);
        _setValueIf(envProps, "screenRes", web.screenRes);
        _setValueIf(envProps, "userConsent", web.userConsent ? strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) {
        _setValueIf(envTags, CtxTagKeys.deviceOS, extOs[_DYN_NAME$1 /* @min:%2ename */]);
    }
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
        _setValueIf(envTags, CtxTagKeys.operationName, dataSanitizeString(logger, extTrace[_DYN_NAME$1 /* @min:%2ename */]));
        _setValueIf(envTags, CtxTagKeys.operationId, extTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for (var i = itmTags[_DYN_LENGTH$2 /* @min:%2elength */] - 1; i >= 0; i--) {
        var tg = itmTags[i];
        objForEachKey(tg, function (key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    objForEachKey(itmTags, function (tg, value) {
        tgs[tg] = value;
    });
    var theTags = __assignFn(__assignFn({}, envTags), tgs);
    if (!theTags[CtxTagKeys.internalSdkVersion]) {
        // Append a version in case it is not already set
        theTags[CtxTagKeys.internalSdkVersion] = dataSanitizeString(logger, "javascript:".concat(EnvelopeCreator.Version), 64);
    }
    env[_DYN_TAGS /* @min:%2etags */] = optimizeObject(theTags);
}
function _extractPropsAndMeasurements(data, properties, measurements) {
    if (!isNullOrUndefined(data)) {
        objForEachKey(data, function (key, value) {
            if (isNumber$3(value)) {
                measurements[key] = value;
            }
            else if (isString$2(value)) {
                properties[key] = value;
            }
            else if (hasJSON()) {
                properties[key] = getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](value);
            }
        });
    }
}
function _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!isNullOrUndefined(properties)) {
        objForEachKey(properties, function (key, value) {
            properties[key] = value || customUndefinedValue;
        });
    }
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function _createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new Envelope(logger, data, envelopeType);
    _setValueIf(envelope, "sampleRate", telemetryItem[SampleRate]);
    if ((telemetryItem[strBaseData] || {}).startTime) {
        // Starting from Version 3.0.3, the time property will be assigned by the startTime value,
        // which records the loadEvent time for the pageView event.
        envelope.time = toISOString$2(telemetryItem[strBaseData].startTime);
    }
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[_DYN_NAME$1 /* @min:%2ename */] = envelope[_DYN_NAME$1 /* @min:%2ename */].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    _extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[_DYN_TAGS /* @min:%2etags */] = telemetryItem[_DYN_TAGS /* @min:%2etags */] || [];
    return optimizeObject(envelope);
}
function EnvelopeCreatorInit(logger, telemetryItem) {
    if (isNullOrUndefined(telemetryItem[strBaseData])) {
        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */, "telemetryItem.baseData cannot be null.");
    }
}
var EnvelopeCreator = {
    Version: '3.1.1'
};
function DependencyEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    if (isNullOrUndefined(bd)) {
        _warnToConsole(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[strProperties] && bd[strProperties][HttpMethod] ? bd[strProperties][HttpMethod] : "GET";
    var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd[_DYN_NAME$1 /* @min:%2ename */], bd[STR_DURATION$1 /* @min:%2eduration */], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new Data(RemoteDependencyData[_DYN_DATA_TYPE /* @min:%2edataType */], remoteDepData);
    return _createEnvelope(logger, RemoteDependencyData[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function EventEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[strBaseType] !== Event$1[_DYN_DATA_TYPE /* @min:%2edataType */]) {
        customProperties["baseTypeSource"] = telemetryItem[strBaseType]; // save the passed in base type as a property
    }
    if (telemetryItem[strBaseType] === Event$1[_DYN_DATA_TYPE /* @min:%2edataType */]) { // take collection
        customProperties = telemetryItem[strBaseData][strProperties] || {};
        customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    }
    else { // if its not a known type, convert to custom event
        if (telemetryItem[strBaseData]) {
            _extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
        }
    }
    // Extract root level properties from part C telemetryItem.data
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var eventName = telemetryItem[strBaseData][_DYN_NAME$1 /* @min:%2ename */];
    var eventData = new Event$1(logger, eventName, customProperties, customMeasurements);
    var data = new Data(Event$1[_DYN_DATA_TYPE /* @min:%2edataType */], eventData);
    return _createEnvelope(logger, Event$1[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function ExceptionEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    var customProperties = telemetryItem[strBaseData][strProperties] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], customProperties, customMeasurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    }
    var bd = telemetryItem[strBaseData];
    var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new Data(Exception[_DYN_DATA_TYPE /* @min:%2edataType */], exData);
    return _createEnvelope(logger, Exception[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function MetricEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[strBaseData];
    var props = baseData[strProperties] || {};
    var measurements = baseData[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseMetricData = new Metric(logger, baseData[_DYN_NAME$1 /* @min:%2ename */], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new Data(Metric[_DYN_DATA_TYPE /* @min:%2edataType */], baseMetricData);
    return _createEnvelope(logger, Metric[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[strBaseData];
    if (!isNullOrUndefined(baseData) &&
        !isNullOrUndefined(baseData[strProperties]) &&
        !isNullOrUndefined(baseData[strProperties][STR_DURATION$1])) { // from part B properties
        duration = baseData[strProperties][STR_DURATION$1];
        delete baseData[strProperties][STR_DURATION$1];
    }
    else if (!isNullOrUndefined(telemetryItem[_DYN_DATA /* @min:%2edata */]) &&
        !isNullOrUndefined(telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1])) { // from custom properties
        duration = telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1];
        delete telemetryItem[_DYN_DATA /* @min:%2edata */][STR_DURATION$1];
    }
    var bd = telemetryItem[strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[_DYN_TRACE_ID$1 /* @min:%2etraceID */]) {
        currentContextId = telemetryItem.ext.trace[_DYN_TRACE_ID$1 /* @min:%2etraceID */];
    }
    var id = bd.id || currentContextId;
    var name = bd[_DYN_NAME$1 /* @min:%2ename */];
    var url = bd.uri;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd.refUri)) {
        properties["refUri"] = bd.refUri;
    }
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd.pageType)) {
        properties["pageType"] = bd.pageType;
    }
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd.isLoggedIn)) {
        properties["isLoggedIn"] = bd.isLoggedIn[_DYN_TO_STRING /* @min:%2etoString */]();
    }
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!isNullOrUndefined(bd[strProperties])) {
        var pageTags = bd[strProperties];
        objForEachKey(pageTags, function (key, value) {
            properties[key] = value;
        });
    }
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
    var data = new Data(PageView[_DYN_DATA_TYPE /* @min:%2edataType */], pageViewData);
    return _createEnvelope(logger, PageView[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function PageViewPerformanceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[strBaseData];
    var name = bd[_DYN_NAME$1 /* @min:%2ename */];
    var url = bd.uri || bd.url;
    var properties = bd[strProperties] || {};
    var measurements = bd[_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], properties, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    }
    var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
    var data = new Data(PageViewPerformance[_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, PageViewPerformance[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}
function TraceEnvelopeCreator(logger, telemetryItem, customUndefinedValue) {
    EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[strBaseData].message;
    var severityLevel = telemetryItem[strBaseData].severityLevel;
    var props = telemetryItem[strBaseData][strProperties] || {};
    var measurements = telemetryItem[strBaseData][_DYN_MEASUREMENTS /* @min:%2emeasurements */] || {};
    _extractPropsAndMeasurements(telemetryItem[_DYN_DATA /* @min:%2edata */], props, measurements);
    if (!isNullOrUndefined(customUndefinedValue)) {
        _convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    }
    var baseData = new Trace(logger, message, severityLevel, props, measurements);
    var data = new Data(Trace[_DYN_DATA_TYPE /* @min:%2edataType */], baseData);
    return _createEnvelope(logger, Trace[_DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */], telemetryItem, data);
}

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var BaseSendBuffer = /** @class */ (function () {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this[_DYN__GET /* @min:%2e_get */] = function () {
            return _buffer;
        };
        this._set = function (buffer) {
            _buffer = buffer;
            return _buffer;
        };
        dynamicProto(BaseSendBuffer, this, function (_self) {
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DYN_COUNT /* @min:%2ecount */]() >= config[_DYN_EVENTS_LIMIT_IN_MEM /* @min:%2eeventsLimitInMem */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 105 /* _eInternalMessageId.InMemoryStorageBufferFull */, "Maximum in-memory buffer size reached: " + _self[_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[_DYN_PUSH /* @min:%2epush */](payload);
            };
            _self[_DYN_COUNT /* @min:%2ecount */] = function () {
                return _buffer[_DYN_LENGTH$2 /* @min:%2elength */];
            };
            _self.size = function () {
                var size = _buffer[_DYN_LENGTH$2 /* @min:%2elength */];
                for (var lp = 0; lp < _buffer[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                    size += _buffer[lp][_DYN_LENGTH$2 /* @min:%2elength */];
                }
                if (!config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */]) {
                    size += 2;
                }
                return size;
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function (payload) {
                if (payload && payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    var batch = config[_DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */] ?
                        payload.join("\n") :
                        "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = function (newLogger, newConfig, canUseSessionStorage) {
                var items = _buffer.slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                var newBuffer = !!canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                arrForEach(items, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                return newBuffer;
            };
        });
    }
// Removed Stub for BaseSendBuffer.prototype.enqueue.
// Removed Stub for BaseSendBuffer.prototype.count.
// Removed Stub for BaseSendBuffer.prototype.size.
// Removed Stub for BaseSendBuffer.prototype.clear.
// Removed Stub for BaseSendBuffer.prototype.getItems.
// Removed Stub for BaseSendBuffer.prototype.batchPayloads.
// Removed Stub for BaseSendBuffer.prototype.createNew.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    BaseSendBuffer.__ieDyn=1;

    return BaseSendBuffer;
}());
/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */ (function (_super) {
    __extendsFn(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        dynamicProto(ArraySendBuffer, _this, function (_self, _base) {
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                // not supported
            };
        });
        return _this;
    }
// Removed Stub for ArraySendBuffer.prototype.markAsSent.
// Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ArraySendBuffer.__ieDyn=1;

    return ArraySendBuffer;
}(BaseSendBuffer));
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */ (function (_super) {
    __extendsFn(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        //Note: should not use config.namePrefix directly, because it will always refers to the latest namePrefix
        var _namePrefix = config === null || config === undefined ? undefined : config.namePrefix;
        var _a = config[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */] || { getItem: utlGetSessionStorage, setItem: utlSetSessionStorage }, getItem = _a.getItem, setItem = _a.setItem;
        dynamicProto(SessionStorageSendBuffer, _this, function (_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[_DYN_LENGTH$2 /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                buffer[_DYN_LENGTH$2 /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
            }
            _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
            _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], buffer);
            _self[_DYN_ENQUEUE /* @min:%2eenqueue */] = function (payload) {
                if (_self[_DYN_COUNT /* @min:%2ecount */]() >= SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Maximum buffer size reached: " + _self[_DYN_COUNT /* @min:%2ecount */](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[_DYN__GET /* @min:%2e_get */]());
            };
            _self[_DYN_CLEAR /* @min:%2eclear */] = function () {
                _base[_DYN_CLEAR /* @min:%2eclear */]();
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _self[_DYN__GET /* @min:%2e_get */]());
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], []);
                _bufferFullMessageSent = false;
            };
            _self[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */] = function (payload) {
                _setBuffer(SessionStorageSendBuffer[_DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */], _self._set(_removePayloadsFromBuffer(payload, _self[_DYN__GET /* @min:%2e_get */]())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[_DYN_LENGTH$2 /* @min:%2elength */] > SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 67 /* _eInternalMessageId.SessionStorageBufferFull */, "Sent buffer reached its maximum size: " + sentElements[_DYN_LENGTH$2 /* @min:%2elength */], true);
                        sentElements[_DYN_LENGTH$2 /* @min:%2elength */] = SessionStorageSendBuffer[_DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */];
                    }
                    _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
                }
            };
            _self[_DYN_CLEAR_SENT /* @min:%2eclearSent */] = function (payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */], sentElements);
            };
            _self[_DYN_CREATE_NEW /* @min:%2ecreateNew */] = function (newLogger, newConfig, canUseSessionStorage) {
                canUseSessionStorage = !!canUseSessionStorage;
                var unsentItems = _self[_DYN__GET /* @min:%2e_get */]().slice(0);
                var sentItems = _getBuffer(SessionStorageSendBuffer[_DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */]).slice(0);
                newLogger = newLogger || logger;
                newConfig = newConfig || {};
                // to make sure that we do not send duplicated payloads when it is switched back to previous one
                _self[_DYN_CLEAR /* @min:%2eclear */]();
                var newBuffer = canUseSessionStorage ? new SessionStorageSendBuffer(newLogger, newConfig) : new ArraySendBuffer(newLogger, newConfig);
                arrForEach(unsentItems, function (payload) {
                    newBuffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                });
                if (canUseSessionStorage) {
                    // arr buffer will clear all payloads if markAsSent() is called
                    newBuffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](sentItems);
                }
                return newBuffer;
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                arrForEach(buffer, function (value) {
                    if (!isFunction$3(value) && arrIndexOf(payloads, value) === -1) {
                        remaining[_DYN_PUSH /* @min:%2epush */](value);
                    }
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = getJSON().parse(bufferJson);
                        if (isString$2(buffer_1)) {
                            // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                            buffer_1 = getJSON().parse(buffer_1);
                        }
                        if (buffer_1 && isArray$3(buffer_1)) {
                            return buffer_1;
                        }
                    }
                }
                catch (e) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e), { exception: dumpObj(e) });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = _namePrefix ? _namePrefix + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[_DYN_STRINGIFY /* @min:%2estringify */](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                }
                catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[_DYN_STRINGIFY /* @min:%2estringify */]([]));
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 41 /* _eInternalMessageId.FailedToSetStorageBuffer */, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: dumpObj(e) });
                }
            }
        });
        return _this;
    }
// Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
// Removed Stub for SessionStorageSendBuffer.prototype.clear.
// Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
// Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
// Removed Stub for SessionStorageSendBuffer.prototype.createNew.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}(BaseSendBuffer));

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var Serializer = /** @class */ (function () {
    function Serializer(logger) {
        dynamicProto(Serializer, this, function (_self) {
            /**
             * Serializes the current object to a JSON string.
             */
            _self[_DYN_SERIALIZE /* @min:%2eserialize */] = function (input) {
                var output = _serializeObject(input, "root");
                try {
                    return getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](output);
                }
                catch (e) {
                    // if serialization fails return an empty string
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction$3(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, "cannot serialize object because it is null or undefined", { name: name }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 50 /* _eInternalMessageId.CircularReferenceDetected */, "Circular reference detected while serializing object", { name: name }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") {
                        output = _serializeStringMap(source, "number", name);
                    }
                    else if (name === "properties") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (name === "tags") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (isArray$3(source)) {
                        output = _serializeArray(source, name);
                    }
                    else {
                        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
                        try {
                            // verify that the object can be stringified
                            getJSON()[_DYN_STRINGIFY /* @min:%2estringify */](source);
                            output = source;
                        }
                        catch (e) {
                            // if serialization fails return an empty string
                            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 48 /* _eInternalMessageId.CannotSerializeObject */, (e && isFunction$3(e[_DYN_TO_STRING /* @min:%2etoString */])) ? e[_DYN_TO_STRING /* @min:%2etoString */]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                objForEachKey(source.aiDataContract, function (field, contract) {
                    var isRequired = (isFunction$3(contract)) ? (contract() & 1 /* FieldType.Required */) : (contract & 1 /* FieldType.Required */);
                    var isHidden = (isFunction$3(contract)) ? (contract() & 4 /* FieldType.Hidden */) : (contract & 4 /* FieldType.Hidden */);
                    var isArray = contract & 2 /* FieldType.Array */;
                    var isPresent = source[field] !== undefined;
                    var isObj = isObject$6(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) {
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
                        // If not in debug mode, continue and hope the error is permissible
                    }
                    else if (!isHidden) { // Don't serialize hidden fields
                        var value = undefined;
                        if (isObj) {
                            if (isArray) {
                                // special case; recurse on each object in the source array
                                value = _serializeArray(source[field], field);
                            }
                            else {
                                // recurse on the source object in this field
                                value = _serializeObject(source[field], field);
                            }
                        }
                        else {
                            // assign the source field to the output even if undefined or required
                            value = source[field];
                        }
                        // only emit this field if the value is defined
                        if (value !== undefined) {
                            output[field] = value;
                        }
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!isArray$3(sources)) {
                        _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, 54 /* _eInternalMessageId.ItemNotInArray */, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
                    }
                    else {
                        output = [];
                        for (var i = 0; i < sources[_DYN_LENGTH$2 /* @min:%2elength */]; i++) {
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[_DYN_PUSH /* @min:%2epush */](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    objForEachKey(map, function (field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else if (!value[_DYN_TO_STRING /* @min:%2etoString */]) {
                                output[field] = "invalid field: toString() is not defined.";
                            }
                            else {
                                output[field] = value[_DYN_TO_STRING /* @min:%2etoString */]();
                            }
                        }
                        else if (expectedType === "number") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else {
                                var num = parseFloat(value);
                                output[field] = num;
                            }
                        }
                        else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            _throwInternal(logger, 1 /* eLoggingSeverity.CRITICAL */, output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
// Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    Serializer.__ieDyn=1;

    return Serializer;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
var HashCodeScoreGenerator = /** @class */ (function () {
    function HashCodeScoreGenerator() {
    }
    HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function (input) {
        if (input === "") {
            return 0;
        }
        while (input[_DYN_LENGTH$2 /* @min:%2elength */] < MIN_INPUT_LENGTH) {
            input = input.concat(input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input[_DYN_LENGTH$2 /* @min:%2elength */]; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var SamplingScoreGenerator = /** @class */ (function () {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new HashCodeScoreGenerator();
        var keys = new ContextTagKeys();
        _self[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */] = function (item) {
            var score = 0;
            if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.userId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.userId]);
            }
            else if (item.ext && item.ext.user && item.ext.user.id) {
                score = hashCodeGenerator[_DYN_GET_HASH_CODE_SCORE /* @min:%2egetHashCodeScore */](item.ext.user.id);
            }
            else if (item[_DYN_TAGS /* @min:%2etags */] && item[_DYN_TAGS /* @min:%2etags */][keys.operationId]) { // search in tags first, then ext
                score = hashCodeGenerator.getHashCodeScore(item[_DYN_TAGS /* @min:%2etags */][keys.operationId]);
            }
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]) {
                score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[_DYN_TRACE_ID$1 /* @min:%2etraceID */]);
            }
            else {
                // tslint:disable-next-line:insecure-random
                score = (Math.random() * 100);
            }
            return score;
        };
    }
    return SamplingScoreGenerator;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Sample = /** @class */ (function () {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || safeGetLogger(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
            sampleRate = 100;
        }
        this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] = sampleRate;
        this.samplingScoreGenerator = new SamplingScoreGenerator();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */
    Sample.prototype.isSampledIn = function (envelope) {
        var samplingPercentage = this[_DYN_SAMPLE_RATE /* @min:%2esampleRate */]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
            return true;
        }
        else if (envelope.baseType === Metric[_DYN_DATA_TYPE /* @min:%2edataType */]) {
            // exclude MetricData telemetry from sampling
            return true;
        }
        isSampledIn = this.samplingScoreGenerator[_DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}());

/*
 * Application Insights JavaScript SDK - Channel, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
var _a$4, _b$1;
var UNDEFINED_VALUE$1 = undefined;
var EMPTY_STR = "";
var FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function _getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function isOverrideFn(httpXHROverride) {
    return httpXHROverride && httpXHROverride.sendPOST;
}
var defaultAppInsightsChannelConfig = objDeepFreeze((_a$4 = {
        // Use the default value (handles empty string in the configuration)
        endpointUrl: cfgDfValidate(isTruthy, DEFAULT_BREEZE_ENDPOINT + DEFAULT_BREEZE_PATH)
    },
    _a$4[_DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */] = cfgDfBoolean(),
    _a$4[_DYN_MAX_BATCH_INTERVAL /* @min:maxBatchInterval */] = 15000,
    _a$4[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */] = 102400,
    _a$4.disableTelemetry = cfgDfBoolean(),
    _a$4[_DYN_ENABLE_SESSION_STORA5 /* @min:enableSessionStorageBuffer */] = cfgDfBoolean(true),
    _a$4.isRetryDisabled = cfgDfBoolean(),
    _a$4[_DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */] = cfgDfBoolean(true),
    _a$4[_DYN_DISABLE_SEND_BEACON_7 /* @min:disableSendBeaconSplit */] = cfgDfBoolean(true),
    _a$4[_DYN_DISABLE_XHR /* @min:disableXhr */] = cfgDfBoolean(),
    _a$4[_DYN_ONUNLOAD_DISABLE_FET6 /* @min:onunloadDisableFetch */] = cfgDfBoolean(),
    _a$4[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */] = cfgDfBoolean(),
    _a$4[_DYN_INSTRUMENTATION_KEY$1 /* @min:instrumentationKey */] = UNDEFINED_VALUE$1,
    _a$4.namePrefix = UNDEFINED_VALUE$1,
    _a$4.samplingPercentage = cfgDfValidate(_chkSampling, 100),
    _a$4[_DYN_CUSTOM_HEADERS /* @min:customHeaders */] = UNDEFINED_VALUE$1,
    _a$4[_DYN_CONVERT_UNDEFINED /* @min:convertUndefined */] = UNDEFINED_VALUE$1,
    _a$4[_DYN_EVENTS_LIMIT_IN_MEM /* @min:eventsLimitInMem */] = 10000,
    _a$4[_DYN_BUFFER_OVERRIDE /* @min:bufferOverride */] = false,
    _a$4.httpXHROverride = { isVal: isOverrideFn, v: UNDEFINED_VALUE$1 },
    _a$4[_DYN_ALWAYS_USE_XHR_OVERR4 /* @min:alwaysUseXhrOverride */] = cfgDfBoolean(),
    _a$4.transports = UNDEFINED_VALUE$1,
    _a$4.retryCodes = UNDEFINED_VALUE$1,
    _a$4));
function _chkSampling(value) {
    return !isNaN(value) && value > 0 && value <= 100;
}
var EnvelopeTypeCreator = (_b$1 = {},
    _b$1[Event$1.dataType] = EventEnvelopeCreator,
    _b$1[Trace.dataType] = TraceEnvelopeCreator,
    _b$1[PageView.dataType] = PageViewEnvelopeCreator,
    _b$1[PageViewPerformance.dataType] = PageViewPerformanceEnvelopeCreator,
    _b$1[Exception.dataType] = ExceptionEnvelopeCreator,
    _b$1[Metric.dataType] = MetricEnvelopeCreator,
    _b$1[RemoteDependencyData.dataType] = DependencyEnvelopeCreator,
    _b$1);
var Sender = /** @class */ (function (_super) {
    __extendsFn(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = BreezeChannelIdentifier;
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _endpointUrl;
        var _orgEndpointUrl;
        var _maxBatchSizeInBytes;
        var _beaconSupported;
        var _beaconOnUnloadSupported;
        var _beaconNormalSupported;
        var _customHeaders;
        var _disableTelemetry;
        var _instrumentationKey;
        var _convertUndefined;
        var _isRetryDisabled;
        var _maxBatchInterval;
        var _sessionStorageUsed;
        var _bufferOverrideUsed;
        var _namePrefix;
        var _enableSendPromise;
        var _alwaysUseCustomSend;
        var _disableXhr;
        var _fetchKeepAlive;
        var _xhrSend;
        var _fallbackSend;
        var _disableBeaconSplit;
        var _sendPostMgr;
        var _retryCodes;
        dynamicProto(Sender, _this, function (_self, _base) {
            _initDefaults();
            _self.pause = function () {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function () {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    _checkMaxSize();
                    _setupTimer();
                }
            };
            _self.flush = function (isAsync, callBack, sendReason) {
                if (isAsync === undefined) { isAsync = true; }
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */);
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 22 /* _eInternalMessageId.FlushFailed */, "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                }
            };
            _self.onunloadFlush = function () {
                if (!_paused) {
                    if (_beaconSupported || _alwaysUseCustomSend) {
                        try {
                            return _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, _doUnloadSend, 2 /* SendRequestReason.Unload */);
                        }
                        catch (e) {
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                    else {
                        _self.flush(false);
                    }
                }
            };
            _self.addHeader = function (name, value) {
                _headers[name] = value;
            };
            _self[_DYN_INITIALIZE /* @min:%2einitialize */] = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender is already initialized");
                }
                _base[_DYN_INITIALIZE /* @min:%2einitialize */](config, core, extensions, pluginChain);
                var identifier = _self.identifier;
                _serializer = new Serializer(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                _evtNamespace = mergeEvtNamespace(createUniqueNamespace("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = createOfflineListener(_evtNamespace);
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function (details) {
                    var config = details.cfg;
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    var ctx = createProcessTelemetryContext(null, config, core);
                    var senderConfig = ctx.getExtCfg(identifier, defaultAppInsightsChannelConfig);
                    objDefine(_self, "_senderConfig", {
                        g: function () {
                            return senderConfig;
                        }
                    });
                    // Only update the endpoint if the original config !== the current config
                    // This is so any redirect endpointUrl is not overwritten
                    if (_orgEndpointUrl !== senderConfig.endpointUrl) {
                        _endpointUrl = _orgEndpointUrl = senderConfig.endpointUrl;
                    }
                    if (_customHeaders && _customHeaders !== senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */]) {
                        // Removing any previously defined custom headers as they have changed
                        arrForEach(_customHeaders, function (customHeader) {
                            delete _headers[customHeader.header];
                        });
                    }
                    _maxBatchSizeInBytes = senderConfig[_DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */];
                    _beaconSupported = (senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false || senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false) && isBeaconsSupported();
                    _beaconOnUnloadSupported = senderConfig[_DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */] === false && isBeaconsSupported();
                    _beaconNormalSupported = senderConfig[_DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */] === false && isBeaconsSupported();
                    _alwaysUseCustomSend = senderConfig[_DYN_ALWAYS_USE_XHR_OVERR4 /* @min:%2ealwaysUseXhrOverride */];
                    _disableXhr = !!senderConfig[_DYN_DISABLE_XHR /* @min:%2edisableXhr */];
                    _retryCodes = senderConfig.retryCodes;
                    var bufferOverride = senderConfig[_DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */];
                    var canUseSessionStorage = !!senderConfig[_DYN_ENABLE_SESSION_STORA5 /* @min:%2eenableSessionStorageBuffer */] &&
                        (!!bufferOverride || utlCanUseSessionStorage());
                    var namePrefix = senderConfig.namePrefix;
                    //Note: emitLineDelimitedJson and eventsLimitInMem is directly accessed via config in senderBuffer
                    //Therefore, if canUseSessionStorage is not changed, we do not need to re initialize a new one
                    var shouldUpdate = (canUseSessionStorage !== _sessionStorageUsed)
                        || (canUseSessionStorage && (_namePrefix !== namePrefix)) // prefixName is only used in session storage
                        || (canUseSessionStorage && (_bufferOverrideUsed !== bufferOverride));
                    if (_self[_DYN__BUFFER /* @min:%2e_buffer */]) {
                        // case1 (Pre and Now enableSessionStorageBuffer settings are same)
                        // if namePrefix changes, transfer current buffer to new buffer
                        // else no action needed
                        //case2 (Pre and Now enableSessionStorageBuffer settings are changed)
                        // transfer current buffer to new buffer
                        if (shouldUpdate) {
                            try {
                                _self._buffer = _self._buffer[_DYN_CREATE_NEW /* @min:%2ecreateNew */](diagLog, senderConfig, canUseSessionStorage);
                            }
                            catch (e) {
                                _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                            }
                        }
                        _checkMaxSize();
                    }
                    else {
                        _self[_DYN__BUFFER /* @min:%2e_buffer */] = canUseSessionStorage
                            ? new SessionStorageSendBuffer(diagLog, senderConfig) : new ArraySendBuffer(diagLog, senderConfig);
                    }
                    _namePrefix = namePrefix;
                    _sessionStorageUsed = canUseSessionStorage;
                    _bufferOverrideUsed = bufferOverride;
                    _fetchKeepAlive = !senderConfig[_DYN_ONUNLOAD_DISABLE_FET6 /* @min:%2eonunloadDisableFetch */] && isFetchSupported$1(true);
                    _disableBeaconSplit = !!senderConfig[_DYN_DISABLE_SEND_BEACON_7 /* @min:%2edisableSendBeaconSplit */];
                    _self._sample = new Sample(senderConfig.samplingPercentage, diagLog);
                    _instrumentationKey = senderConfig[_DYN_INSTRUMENTATION_KEY$1 /* @min:%2einstrumentationKey */];
                    if (!_validateInstrumentationKey(_instrumentationKey, config)) {
                        _throwInternal(diagLog, 1 /* eLoggingSeverity.CRITICAL */, 100 /* _eInternalMessageId.InvalidInstrumentationKey */, "Invalid Instrumentation key " + _instrumentationKey);
                    }
                    _customHeaders = senderConfig[_DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */];
                    if (!isInternalApplicationInsightsEndpoint(_endpointUrl) && _customHeaders && _customHeaders[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                        arrForEach(_customHeaders, function (customHeader) {
                            _this.addHeader(customHeader.header, customHeader.value);
                        });
                    }
                    else {
                        _customHeaders = null;
                    }
                    _enableSendPromise = senderConfig[_DYN_ENABLE_SEND_PROMISE /* @min:%2eenableSendPromise */];
                    var sendPostConfig = _getSendPostMgrConfig();
                    // only init it once
                    if (!_sendPostMgr) {
                        _sendPostMgr = new SenderPostManager();
                        _sendPostMgr[_DYN_INITIALIZE /* @min:%2einitialize */](sendPostConfig, diagLog);
                    }
                    else {
                        _sendPostMgr.SetConfig(sendPostConfig);
                    }
                    var customInterface = senderConfig.httpXHROverride;
                    var httpInterface = null;
                    var syncInterface = null;
                    // User requested transport(s) values > Beacon > Fetch > XHR
                    // Beacon would be filtered out if user has set disableBeaconApi to true at _getSenderInterface
                    var theTransports = prependTransports([3 /* TransportType.Beacon */, 1 /* TransportType.Xhr */, 2 /* TransportType.Fetch */], senderConfig.transports);
                    httpInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */](theTransports, false);
                    var xhrInterface = _sendPostMgr && _sendPostMgr.getFallbackInst();
                    _xhrSend = function (payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync);
                    };
                    _fallbackSend = function (payload, isAsync) {
                        return _doSend(xhrInterface, payload, isAsync, false);
                    };
                    httpInterface = _alwaysUseCustomSend ? customInterface : (httpInterface || customInterface || xhrInterface);
                    _self[_DYN__SENDER /* @min:%2e_sender */] = function (payload, isAsync) {
                        return _doSend(httpInterface, payload, isAsync);
                    };
                    if (_fetchKeepAlive) {
                        // Try and use the fetch with keepalive
                        _syncUnloadSender = _fetchKeepAliveSender;
                    }
                    var syncTransports = prependTransports([3 /* TransportType.Beacon */, 1 /* TransportType.Xhr */], senderConfig[_DYN_UNLOAD_TRANSPORTS /* @min:%2eunloadTransports */]);
                    if (!_fetchKeepAlive) {
                        // remove fetch from theTransports
                        syncTransports = syncTransports.filter(function (transport) { return transport !== 2 /* TransportType.Fetch */; });
                    }
                    syncInterface = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */](syncTransports, true);
                    syncInterface = _alwaysUseCustomSend ? customInterface : (syncInterface || customInterface);
                    if ((_alwaysUseCustomSend || senderConfig[_DYN_UNLOAD_TRANSPORTS /* @min:%2eunloadTransports */] || !_syncUnloadSender) && syncInterface) {
                        _syncUnloadSender = function (payload, isAsync) {
                            return _doSend(syncInterface, payload, isAsync);
                        };
                    }
                    if (!_syncUnloadSender) {
                        _syncUnloadSender = _xhrSend;
                    }
                    _disableTelemetry = senderConfig.disableTelemetry;
                    _convertUndefined = senderConfig[_DYN_CONVERT_UNDEFINED /* @min:%2econvertUndefined */] || UNDEFINED_VALUE$1;
                    _isRetryDisabled = senderConfig.isRetryDisabled;
                    _maxBatchInterval = senderConfig[_DYN_MAX_BATCH_INTERVAL /* @min:%2emaxBatchInterval */];
                }));
            };
            _self.processTelemetry = function (telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    var isValidate = _validate(telemetryItem, diagLogger);
                    if (!isValidate) {
                        return;
                    }
                    var aiEnvelope = _getEnvelope(telemetryItem, diagLogger);
                    if (!aiEnvelope) {
                        return;
                    }
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer[_DYN_SERIALIZE /* @min:%2eserialize */](aiEnvelope);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                    _checkMaxSize(payload);
                    // enqueue the payload
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                }
                catch (e) {
                    _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            _self.isCompletelyIdle = function () {
                return !_paused && _syncFetchPayload === 0 && _self._buffer[_DYN_COUNT /* @min:%2ecount */]() === 0;
            };
            /**
             * xhr state changes
             */
            _self._xhrReadyStateChange = function (xhr, payload, countOfItemsInPayload) {
                return _xhrReadyStateChange(xhr, payload, countOfItemsInPayload);
            };
            /**
             * Immediately send buffered data
             * @param async - {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender - {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */
            _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */] = function (async, forcedSender, sendReason) {
                if (async === undefined) { async = true; }
                var result;
                if (!_paused) {
                    try {
                        var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                        // Send data only if disableTelemetry is false
                        if (!_disableTelemetry) {
                            if (buffer[_DYN_COUNT /* @min:%2ecount */]() > 0) {
                                var payload = buffer.getItems();
                                _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */, async);
                                // invoke send
                                if (forcedSender) {
                                    result = forcedSender.call(_self, payload, async);
                                }
                                else {
                                    result = _self[_DYN__SENDER /* @min:%2e_sender */](payload, async);
                                }
                            }
                            // update lastSend time to enable throttling
                            _lastSend = +new Date;
                        }
                        else {
                            buffer[_DYN_CLEAR /* @min:%2eclear */]();
                        }
                        _clearScheduledTimer();
                    }
                    catch (e) {
                        /* Ignore this error for IE under v10 */
                        var ieVer = getIEVersion();
                        if (!ieVer || ieVer > 9) {
                            _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 40 /* _eInternalMessageId.TransmissionFailed */, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
                        }
                    }
                }
                return result;
            };
            _self.getOfflineSupport = function () {
                var _a;
                return _a = {
                        getUrl: function () {
                            return _endpointUrl;
                        },
                        createPayload: _createPayload
                    },
                    _a[_DYN_SERIALIZE /* @min:serialize */] = _serialize,
                    _a.batch = _batch,
                    _a.shouldProcess = function (evt) {
                        return !!_validate(evt);
                    },
                    _a;
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _self.onunloadFlush();
                runTargetUnload(_offlineListener, false);
                _initDefaults();
            };
            /**
             * error handler
             */
            _self[_DYN__ON_ERROR /* @min:%2e_onError */] = function (payload, message, event) {
                _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 26 /* _eInternalMessageId.OnError */, "Failed to send telemetry.", { message: message });
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            };
            /**
             * partial success handler
             */
            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */] = function (payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) {
                        retry[_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                    else {
                        // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                        failed[_DYN_PUSH /* @min:%2epush */](extracted);
                    }
                }
                if (payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]);
                }
                if (failed[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _self[_DYN__ON_ERROR /* @min:%2e_onError */](failed, formatErrorMessageXhr(null, ["partial success", results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */], "of", results.itemsReceived].join(" ")));
                }
                if (retry[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    _resendPayload(retry);
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, "Partial success. " +
                        "Delivered: " + payload[_DYN_LENGTH$2 /* @min:%2elength */] + ", Failed: " + failed[_DYN_LENGTH$2 /* @min:%2elength */] +
                        ". Will retry to send " + retry[_DYN_LENGTH$2 /* @min:%2elength */] + " our of " + results[_DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */] + " items");
                }
            };
            /**
             * success handler
             */
            _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */] = function (payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
            };
            /**
             * xdr state changes
             */
            _self._xdrOnLoad = function (xdr, payload) {
                return _xdrOnLoad(xdr, payload);
            };
            function _xdrOnLoad(xdr, payload) {
                var responseText = _getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, 0);
                }
                else {
                    var results = parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[_DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */]
                        && !_isRetryDisabled) {
                        _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, results);
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, formatErrorMessageXdr(xdr));
                    }
                }
            }
            function _getSendPostMgrConfig() {
                var _a;
                try {
                    var onCompleteFuncs = {
                        xdrOnComplete: function (xdr, oncomplete, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) {
                                return;
                            }
                            return _xdrOnLoad(xdr, data);
                        },
                        fetchOnComplete: function (response, onComplete, resValue, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) {
                                return;
                            }
                            return _checkResponsStatus(response.status, data, response.url, data[_DYN_LENGTH$2 /* @min:%2elength */], response.statusText, resValue || "");
                        },
                        xhrOnComplete: function (request, oncomplete, payload) {
                            var data = _getPayloadArr(payload);
                            if (!data) {
                                return;
                            }
                            return _xhrReadyStateChange(request, data, data[_DYN_LENGTH$2 /* @min:%2elength */]);
                        },
                        beaconOnRetry: function (data, onComplete, canSend) {
                            return _onBeaconRetry(data, onComplete, canSend);
                        }
                    };
                    var config = (_a = {},
                        _a[_DYN_ENABLE_SEND_PROMISE /* @min:enableSendPromise */] = _enableSendPromise,
                        _a.isOneDs = false,
                        _a.disableCredentials = false,
                        _a[_DYN_DISABLE_XHR /* @min:disableXhr */] = _disableXhr,
                        _a.disableBeacon = !_beaconNormalSupported,
                        _a.disableBeaconSync = !_beaconOnUnloadSupported,
                        _a.senderOnCompleteCallBack = onCompleteFuncs,
                        _a);
                    return config;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            /**
             * xhr state changes
             */
            function _xhrReadyStateChange(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) {
                    _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                }
            }
            function _getPayloadArr(payload) {
                try {
                    if (payload) {
                        var internalPayload = payload;
                        var arr = internalPayload[_DYN_ORI_PAYLOAD /* @min:%2eoriPayload */];
                        if (arr && arr[_DYN_LENGTH$2 /* @min:%2elength */]) {
                            return arr;
                        }
                        return null;
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _validate(telemetryItem, diagLogger) {
                if (_disableTelemetry) {
                    // Do not send/save data
                    return false;
                }
                // validate input
                if (!telemetryItem) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */, "Cannot send empty telemetry");
                    return false;
                }
                // validate event
                if (telemetryItem.baseData && !telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 70 /* _eInternalMessageId.InvalidEvent */, "Cannot send telemetry without baseData and baseType");
                    return false;
                }
                if (!telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */]) {
                    // Default
                    telemetryItem[_DYN_BASE_TYPE /* @min:%2ebaseType */] = "EventData";
                }
                // ensure a sender was constructed
                if (!_self[_DYN__SENDER /* @min:%2e_sender */]) {
                    diagLogger && _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 28 /* _eInternalMessageId.SenderNotInitialized */, "Sender was not initialized");
                    return false;
                }
                // check if this item should be sampled in, else add sampleRate tag
                if (!_isSampledIn(telemetryItem)) {
                    // Item is sampled out, do not send it
                    diagLogger && _throwInternal(diagLogger, 2 /* eLoggingSeverity.WARNING */, 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */] });
                    return false;
                }
                else {
                    telemetryItem[SampleRate] = _self._sample[_DYN_SAMPLE_RATE /* @min:%2esampleRate */];
                }
                return true;
            }
            function _getEnvelope(telemetryItem, diagLogger) {
                // construct an envelope that Application Insights endpoint can understand
                // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                var defaultEnvelopeIkey = telemetryItem.iKey || _instrumentationKey;
                var aiEnvelope = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, _convertUndefined);
                if (!aiEnvelope) {
                    _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 47 /* _eInternalMessageId.CreateEnvelopeError */, "Unable to create an AppInsights envelope");
                    return;
                }
                var doNotSendItem = false;
                // this is for running in legacy mode, where customer may already have a custom initializer present
                if (telemetryItem[_DYN_TAGS /* @min:%2etags */] && telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy]) {
                    arrForEach(telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy], function (callBack) {
                        try {
                            if (callBack && callBack(aiEnvelope) === false) {
                                doNotSendItem = true;
                                _warnToConsole(diagLogger, "Telemetry processor check returns false");
                            }
                        }
                        catch (e) {
                            // log error but dont stop executing rest of the telemetry initializers
                            // doNotSendItem = true;
                            _throwInternal(diagLogger, 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
                        }
                    });
                    delete telemetryItem[_DYN_TAGS /* @min:%2etags */][ProcessLegacy];
                }
                if (doNotSendItem) {
                    return; // do not send, no need to execute next plugin
                }
                return aiEnvelope;
            }
            function _serialize(item) {
                var rlt = EMPTY_STR;
                var diagLogger = _self[_DYN_DIAG_LOG /* @min:%2ediagLog */]();
                try {
                    var valid = _validate(item, diagLogger);
                    var envelope = null;
                    if (valid) {
                        envelope = _getEnvelope(item, diagLogger);
                    }
                    if (envelope) {
                        rlt = _serializer[_DYN_SERIALIZE /* @min:%2eserialize */](envelope);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return rlt;
            }
            function _batch(arr) {
                var rlt = EMPTY_STR;
                if (arr && arr[_DYN_LENGTH$2 /* @min:%2elength */]) {
                    rlt = "[" + arr.join(",") + "]";
                }
                return rlt;
            }
            function _createPayload(data) {
                var _a;
                var headers = _getHeaders();
                return _a = {
                        urlString: _endpointUrl
                    },
                    _a[_DYN_DATA /* @min:data */] = data,
                    _a.headers = headers,
                    _a;
            }
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _getOnComplete(payload, status, headers, response) {
                // ***********************************************************************************************
                //TODO: handle other status codes
                if (status === 200 && payload) {
                    _self._onSuccess(payload, payload[_DYN_LENGTH$2 /* @min:%2elength */]);
                }
                else {
                    response && _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, response);
                }
            }
            function _doSend(sendInterface, payload, isAsync, markAsSent) {
                if (markAsSent === undefined) { markAsSent = true; }
                var onComplete = function (status, headers, response) {
                    return _getOnComplete(payload, status, headers, response);
                };
                var payloadData = _getPayload(payload);
                var sendPostFunc = sendInterface && sendInterface.sendPOST;
                if (sendPostFunc && payloadData) {
                    // ***********************************************************************************************
                    // mark payload as sent at the beginning of calling each send function
                    if (markAsSent) {
                        _self._buffer[_DYN_MARK_AS_SENT /* @min:%2emarkAsSent */](payload);
                    }
                    return sendPostFunc(payloadData, onComplete, !isAsync);
                }
                return null;
            }
            function _getPayload(payload) {
                var _a;
                if (isArray$3(payload) && payload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                    var batch = _self[_DYN__BUFFER /* @min:%2e_buffer */].batchPayloads(payload);
                    var headers = _getHeaders();
                    var payloadData = (_a = {},
                        _a[_DYN_DATA /* @min:data */] = batch,
                        _a.urlString = _endpointUrl,
                        _a.headers = headers,
                        _a.disableXhrSync = _disableXhr,
                        _a.disableFetchKeepAlive = !_fetchKeepAlive,
                        _a[_DYN_ORI_PAYLOAD /* @min:oriPayload */] = payload,
                        _a);
                    return payloadData;
                }
                return null;
            }
            function _getHeaders() {
                try {
                    var headers = _headers || {};
                    if (isInternalApplicationInsightsEndpoint(_endpointUrl)) {
                        headers[RequestHeaders[6 /* eRequestHeaders.sdkContextHeader */]] = RequestHeaders[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */];
                    }
                    return headers;
                }
                catch (e) {
                    // eslint-disable-next-line no-empty
                }
                return null;
            }
            function _checkMaxSize(incomingPayload) {
                var incomingSize = incomingPayload ? incomingPayload[_DYN_LENGTH$2 /* @min:%2elength */] : 0;
                if ((_self[_DYN__BUFFER /* @min:%2e_buffer */].size() + incomingSize) > _maxBatchSizeInBytes) {
                    if (!_offlineListener || _offlineListener.isOnline()) { // only trigger send when currently online
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 10 /* SendRequestReason.MaxBatchSize */);
                    }
                    return true;
                }
                return false;
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = parseResponse(res);
                    if (response && response.appId) {
                        _self._appId = response.appId;
                    }
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_isRetryDisabled && _isRetriable(status)) {
                        _resendPayload(payload);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " +
                            "Response code " + status + ". Will retry to send " + payload[_DYN_LENGTH$2 /* @min:%2elength */] + " items.");
                    }
                    else {
                        _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                    }
                }
                else if (_offlineListener && !_offlineListener.isOnline()) { // offline
                    // Note: Don't check for status == 0, since adblock gives this code
                    if (!_isRetryDisabled) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                }
                else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) {
                            response = parseResponse(res);
                        }
                        if (response && !_isRetryDisabled) {
                            _self[_DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */](payload, response);
                        }
                        else {
                            _self[_DYN__ON_ERROR /* @min:%2e_onError */](payload, errorMessage);
                        }
                    }
                    else {
                        _consecutiveErrors = 0;
                        _self[_DYN__ON_SUCCESS /* @min:%2e_onSuccess */](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) {
                    //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                    //  _stamp_specific_redirects = 0;
                    return false;
                }
                if (!isNullOrUndefined(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _endpointUrl) {
                        _endpointUrl = responseUrl;
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) {
                    // We are unloading so always call the sender with sync set to false
                    _syncUnloadSender(payload, false);
                }
                else {
                    // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                    var beaconInst = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */]([3 /* TransportType.Beacon */], true);
                    return _doSend(beaconInst, payload, isAsync);
                }
            }
            function _onBeaconRetry(payload, onComplete, canSend) {
                var internalPayload = payload;
                var data = internalPayload && internalPayload[_DYN_ORI_PAYLOAD /* @min:%2eoriPayload */];
                if (!_disableBeaconSplit) {
                    // Failed to send entire payload so try and split data and try to send as much events as possible
                    var droppedPayload = [];
                    for (var lp = 0; lp < data[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                        var thePayload = data[lp];
                        var arr = [thePayload];
                        var item = _getPayload(arr);
                        if (!canSend(item, onComplete)) {
                            // Can't send anymore, so split the batch and drop the rest
                            droppedPayload[_DYN_PUSH /* @min:%2epush */](thePayload);
                        }
                        else {
                            _self._onSuccess(arr, arr[_DYN_LENGTH$2 /* @min:%2elength */]);
                        }
                    }
                    if (droppedPayload[_DYN_LENGTH$2 /* @min:%2elength */] > 0) {
                        _fallbackSend && _fallbackSend(droppedPayload, true);
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                    }
                }
                else {
                    _fallbackSend && _fallbackSend(data, true);
                    _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with normal sender.");
                }
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                var transport = null;
                if (isArray$3(payload)) {
                    var payloadSize = payload[_DYN_LENGTH$2 /* @min:%2elength */];
                    for (var lp = 0; lp < payload[_DYN_LENGTH$2 /* @min:%2elength */]; lp++) {
                        payloadSize += payload[lp][_DYN_LENGTH$2 /* @min:%2elength */];
                    }
                    var syncFetchPayload = _sendPostMgr.getSyncFetchPayload();
                    if ((syncFetchPayload + payloadSize) <= FetchSyncRequestSizeLimitBytes) {
                        transport = 2 /* TransportType.Fetch */;
                    }
                    else if (isBeaconsSupported()) {
                        // Fallback to beacon sender as we at least get told which events can't be scheduled
                        transport = 3 /* TransportType.Beacon */;
                    }
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        transport = 1 /* TransportType.Xhr */;
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 2 /* eLoggingSeverity.WARNING */, 40 /* _eInternalMessageId.TransmissionFailed */, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                    var inst = _sendPostMgr && _sendPostMgr[_DYN_GET_SENDER_INST /* @min:%2egetSenderInst */]([transport], true);
                    return _doSend(inst, payload, isAsync);
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */
            function _resendPayload(payload, linearFactor) {
                if (linearFactor === undefined) { linearFactor = 1; }
                if (!payload || payload[_DYN_LENGTH$2 /* @min:%2elength */] === 0) {
                    return;
                }
                var buffer = _self[_DYN__BUFFER /* @min:%2e_buffer */];
                buffer[_DYN_CLEAR_SENT /* @min:%2eclearSent */](payload);
                _consecutiveErrors++;
                for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                    var item = payload_1[_i];
                    buffer[_DYN_ENQUEUE /* @min:%2eenqueue */](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */
            function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) {
                    delayInSeconds = SlotDelayInSeconds;
                }
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = utcNow() + (delayInSeconds * 1000);
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */
            function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - utcNow()) : 0;
                    var timerValue = Math.max(_maxBatchInterval, retryInterval);
                    _timeoutHandle = scheduleTimeout(function () {
                        _timeoutHandle = null;
                        _self[_DYN_TRIGGER_SEND /* @min:%2etriggerSend */](true, null, 1 /* SendRequestReason.NormalSchedule */);
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                _timeoutHandle && _timeoutHandle.cancel();
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */
            function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!isNullOrUndefined(_retryCodes)) {
                    return _retryCodes[_DYN_LENGTH$2 /* @min:%2elength */] && _retryCodes.indexOf(statusCode) > -1;
                }
                return statusCode === 401 // Unauthorized
                    // Removing as private links can return a 403 which causes excessive retries and session storage usage
                    // || statusCode === 403 // Forbidden
                    || statusCode === 408 // Timeout
                    || statusCode === 429 // Too many requests.
                    || statusCode === 500 // Internal server error.
                    || statusCode === 502 // Bad Gateway.
                    || statusCode === 503 // Service unavailable.
                    || statusCode === 504; // Gateway timeout.
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) {
                    return _self.core[func]();
                }
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */]) {
                    try {
                        manager[_DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */](sendRequest, isAsync);
                    }
                    catch (e) {
                        _throwInternal(_self[_DYN_DIAG_LOG /* @min:%2ediagLog */](), 1 /* eLoggingSeverity.CRITICAL */, 74 /* _eInternalMessageId.NotificationException */, "send request notification failed: " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */
            function _validateInstrumentationKey(instrumentationKey, config) {
                var disableValidation = config.disableInstrumentationKeyValidation;
                var disableIKeyValidationFlag = isNullOrUndefined(disableValidation) ? false : disableValidation;
                if (disableIKeyValidationFlag) {
                    return true;
                }
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(instrumentationKey);
            }
            function _initDefaults() {
                _self[_DYN__SENDER /* @min:%2e_sender */] = null;
                _self[_DYN__BUFFER /* @min:%2e_buffer */] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _syncUnloadSender = null;
                _evtNamespace = null;
                _endpointUrl = null;
                _orgEndpointUrl = null;
                _maxBatchSizeInBytes = 0;
                _beaconSupported = false;
                _customHeaders = null;
                _disableTelemetry = false;
                _instrumentationKey = null;
                _convertUndefined = UNDEFINED_VALUE$1;
                _isRetryDisabled = false;
                _sessionStorageUsed = null;
                _namePrefix = UNDEFINED_VALUE$1;
                _disableXhr = false;
                _fetchKeepAlive = false;
                _disableBeaconSplit = false;
                _xhrSend = null;
                _fallbackSend = null;
                _sendPostMgr = null;
                objDefine(_self, "_senderConfig", {
                    g: function () {
                        return objExtend({}, defaultAppInsightsChannelConfig);
                    }
                });
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function (orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !isNullOrUndefined(iKey)) {
            envelope = __assignFn(__assignFn({}, orig), { iKey: iKey });
        }
        else {
            envelope = orig;
        }
        var creator = EnvelopeTypeCreator[envelope.baseType] || EventEnvelopeCreator;
        return creator(logger, envelope, convertUndefined);
    };
// Removed Stub for Sender.prototype.pause.
// Removed Stub for Sender.prototype.resume.
// Removed Stub for Sender.prototype.flush.
// Removed Stub for Sender.prototype.onunloadFlush.
// Removed Stub for Sender.prototype.initialize.
// Removed Stub for Sender.prototype.processTelemetry.
// Removed Stub for Sender.prototype._xhrReadyStateChange.
// Removed Stub for Sender.prototype.triggerSend.
// Removed Stub for Sender.prototype._onError.
// Removed Stub for Sender.prototype._onPartialSuccess.
// Removed Stub for Sender.prototype._onSuccess.
// Removed Stub for Sender.prototype._xdrOnLoad.
// Removed Stub for Sender.prototype.addHeader.
// Removed Stub for Sender.prototype.isCompletelyIdle.
// Removed Stub for Sender.prototype.getOfflineSupport.
    return Sender;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var STR_DURATION = "duration";
var STR_PROPERTIES = "properties";

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_REQUEST_URL = "requestUrl"; // Count: 11
var _DYN_INST = "inst"; // Count: 5
var _DYN_LENGTH$1 = "length"; // Count: 10
var _DYN_TRACE_ID = "traceID"; // Count: 9
var _DYN_SPAN_ID = "spanID"; // Count: 8
var _DYN_TRACE_FLAGS = "traceFlags"; // Count: 13
var _DYN_CONTEXT$1 = "context"; // Count: 7
var _DYN_ABORTED = "aborted"; // Count: 7
var _DYN_TRACE_ID0 = "traceId"; // Count: 5
var _DYN_SPAN_ID1 = "spanId"; // Count: 5
var _DYN__ADD_HOOK = "_addHook"; // Count: 4
var _DYN_CORE = "core"; // Count: 8
var _DYN_INCLUDE_CORRELATION_2 = "includeCorrelationHeaders"; // Count: 4
var _DYN_GET_ABSOLUTE_URL = "getAbsoluteUrl"; // Count: 3
var _DYN_HEADERS = "headers"; // Count: 6
var _DYN_REQUEST_HEADERS = "requestHeaders"; // Count: 13
var _DYN_SET_REQUEST_HEADER = "setRequestHeader"; // Count: 3
var _DYN_TRACK_DEPENDENCY_DAT3 = "trackDependencyDataInternal"; // Count: 2
var _DYN_START_TIME = "startTime"; // Count: 6
var _DYN_TO_LOWER_CASE = "toLowerCase"; // Count: 6
var _DYN_ENABLE_REQUEST_HEADE4 = "enableRequestHeaderTracking"; // Count: 3
var _DYN_ENABLE_AJAX_ERROR_ST5 = "enableAjaxErrorStatusText"; // Count: 2
var _DYN_ENABLE_AJAX_PERF_TRA6 = "enableAjaxPerfTracking"; // Count: 2
var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView"; // Count: 2
var _DYN_EXCLUDE_REQUEST_FROM8 = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var _DYN_ADD_REQUEST_CONTEXT = "addRequestContext"; // Count: 2
var _DYN_DISABLE_AJAX_TRACKIN9 = "disableAjaxTracking"; // Count: 3
var _DYN_AJAX_PERF_LOOKUP_DEL10 = "ajaxPerfLookupDelay"; // Count: 2
var _DYN_DISABLE_FETCH_TRACKI11 = "disableFetchTracking"; // Count: 2
var _DYN_ENABLE_RESPONSE_HEAD12 = "enableResponseHeaderTracking"; // Count: 2
var _DYN_STATUS = "status"; // Count: 11
var _DYN_STATUS_TEXT = "statusText"; // Count: 9
var _DYN_HEADER_MAP = "headerMap"; // Count: 8
var _DYN_OPEN_DONE = "openDone"; // Count: 3
var _DYN_SEND_DONE = "sendDone"; // Count: 3
var _DYN_REQUEST_SENT_TIME = "requestSentTime"; // Count: 9
var _DYN_ABORT_DONE = "abortDone"; // Count: 3
var _DYN_GET_TRACE_ID = "getTraceId"; // Count: 3
var _DYN_GET_TRACE_FLAGS = "getTraceFlags"; // Count: 3
var _DYN_METHOD = "method"; // Count: 8
var _DYN_ERROR_STATUS_TEXT = "errorStatusText"; // Count: 3
var _DYN_STATE_CHANGE_ATTACHE13 = "stateChangeAttached"; // Count: 2
var _DYN_RESPONSE_TEXT = "responseText"; // Count: 6
var _DYN_RESPONSE_FINISHED_TI14 = "responseFinishedTime"; // Count: 7
var _DYN__CREATE_TRACK_ITEM = "CreateTrackItem"; // Count: 3
var _DYN_RESPONSE = "response"; // Count: 4
var _DYN_GET_ALL_RESPONSE_HEA15 = "getAllResponseHeaders"; // Count: 2
var _DYN_GET_PART_APROPS = "getPartAProps"; // Count: 3
var _DYN_PERF_MARK = "perfMark"; // Count: 4
var _DYN_NAME = "name"; // Count: 6
var _DYN_PERF_TIMING = "perfTiming"; // Count: 3
var _DYN_EXCEPTION = "exception"; // Count: 5
var _DYN_AJAX_DIAGNOSTICS_MES16 = "ajaxDiagnosticsMessage"; // Count: 3
var _DYN_CORRELATION_CONTEXT = "correlationContext"; // Count: 3
var _DYN_AJAX_TOTAL_DURATION = "ajaxTotalDuration"; // Count: 3
var _DYN_EVENT_TRACE_CTX = "eventTraceCtx"; // Count: 3

/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) {
        result = dateTimeUtilsDuration(from, to);
    }
    return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = _calcPerfDuration(resourceEntry, start, end);
    if (value) {
        result = _setPerfValue(props, name, msToTimeSpan(value));
    }
    return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = (props[strPerf] || {});
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */
    var resourceEntry = ajaxData[_DYN_PERF_TIMING /* @min:%2eperfTiming */];
    var props = dependency[STR_PROPERTIES /* @min:%2eproperties */] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[STR_DURATION /* @min:%2eduration */];
        if (!duration) {
            duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        }
        propsSet |= _setPerfValue(props, STR_DURATION, duration);
        propsSet |= _setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            arrForEach(serverTiming, function (value, idx) {
                var name = normalizeJsName(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                objForEachKey(value, function (key, val) {
                    if (key !== strName && isString$2(val) || isNumber$3(val)) {
                        if (newValue[key]) {
                            val = newValue[key] + ";" + val;
                        }
                        if (val || !isString$2(val)) {
                            // Only set the value if it has a value and it's not an empty string
                            newValue[key] = val;
                        }
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= _setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    }
    else {
        if (ajaxData[_DYN_PERF_MARK /* @min:%2eperfMark */]) {
            propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
        }
    }
    if (propsSet) {
        dependency[STR_PROPERTIES /* @min:%2eproperties */] = props;
    }
}
var XHRMonitoringState = /** @class */ (function () {
    function XHRMonitoringState() {
        var self = this;
        self[_DYN_OPEN_DONE /* @min:%2eopenDone */] = false;
        self.setRequestHeaderDone = false;
        self[_DYN_SEND_DONE /* @min:%2esendDone */] = false;
        self[_DYN_ABORT_DONE /* @min:%2eabortDone */] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[_DYN_STATE_CHANGE_ATTACHE13 /* @min:%2estateChangeAttached */] = false;
    }
    return XHRMonitoringState;
}());
var ajaxRecord = /** @class */ (function () {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[_DYN_PERF_MARK /* @min:%2eperfMark */] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] = null;
        self[_DYN_ABORTED /* @min:%2eaborted */] = 0;
        self.pageUrl = null;
        self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] = null;
        self.requestSize = 0;
        self[_DYN_METHOD /* @min:%2emethod */] = null;
        self[_DYN_STATUS /* @min:%2estatus */] = null;
        self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */] = null;
        self.responseStartedTime = null;
        self[_DYN_RESPONSE_FINISHED_TI14 /* @min:%2eresponseFinishedTime */] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new XHRMonitoringState();
        self.clientFailure = 0;
        self[_DYN_TRACE_ID /* @min:%2etraceID */] = traceId;
        self[_DYN_SPAN_ID /* @min:%2espanID */] = spanId;
        self[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx === null || traceCtx === undefined ? undefined : traceCtx.getTraceFlags();
        if (traceCtx) {
            self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = (_a = {},
                _a[_DYN_TRACE_ID0 /* @min:traceId */] = traceCtx[_DYN_GET_TRACE_ID /* @min:%2egetTraceId */](),
                _a[_DYN_SPAN_ID1 /* @min:spanId */] = traceCtx.getSpanId(),
                _a[_DYN_TRACE_FLAGS /* @min:traceFlags */] = traceCtx[_DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */](),
                _a);
        }
        else {
            self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */] = null;
        }
        dynamicProto(ajaxRecord, self, function (self) {
            self.getAbsoluteUrl = function () {
                return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? urlGetAbsoluteUrl(self[_DYN_REQUEST_URL /* @min:%2erequestUrl */]) : null;
            };
            self.getPathName = function () {
                return self[_DYN_REQUEST_URL /* @min:%2erequestUrl */] ? dataSanitizeUrl(_logger, urlGetCompleteUrl(self[_DYN_METHOD /* @min:%2emethod */], self[_DYN_REQUEST_URL /* @min:%2erequestUrl */])) : null;
            };
            self[_DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */] = function (ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */] < 0) {
                    return null;
                }
                var dependency = (_a = {
                        id: "|" + self[_DYN_TRACE_ID /* @min:%2etraceID */] + "." + self[_DYN_SPAN_ID /* @min:%2espanID */],
                        target: self[_DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */]()
                    },
                    _a[_DYN_NAME /* @min:name */] = self.getPathName(),
                    _a.type = ajaxType,
                    _a[_DYN_START_TIME /* @min:startTime */] = null,
                    _a.duration = self[_DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */],
                    _a.success = (+(self[_DYN_STATUS /* @min:%2estatus */])) >= 200 && (+(self[_DYN_STATUS /* @min:%2estatus */])) < 400,
                    _a.responseCode = (+(self[_DYN_STATUS /* @min:%2estatus */])),
                    _a[STR_PROPERTIES] = { HttpMethod: self[_DYN_METHOD /* @min:%2emethod */] },
                    _a);
                var props = dependency[STR_PROPERTIES];
                if (self[_DYN_ABORTED /* @min:%2eaborted */]) {
                    props[_DYN_ABORTED /* @min:%2eaborted */] = true;
                }
                if (self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]) {
                    // Set the correct dependency start time
                    dependency[_DYN_START_TIME /* @min:%2estartTime */] = new Date();
                    dependency[_DYN_START_TIME /* @min:%2estartTime */].setTime(self[_DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */]);
                }
                // Add Ajax perf details if available
                _populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if (objKeys(self.requestHeaders)[_DYN_LENGTH$1 /* @min:%2elength */] > 0) {
                        props[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */] = self[_DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */];
                    }
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[_DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */];
                        if (correlationContext) {
                            dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        }
                        if (response[_DYN_HEADER_MAP /* @min:%2eheaderMap */]) {
                            if (objKeys(response.headerMap)[_DYN_LENGTH$1 /* @min:%2elength */] > 0) {
                                props.responseHeaders = response[_DYN_HEADER_MAP /* @min:%2eheaderMap */];
                            }
                        }
                        if (self[_DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */]) {
                            if (self[_DYN_STATUS /* @min:%2estatus */] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") {
                                    props.responseText = response.responseText ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + response[strResponseText] : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                                }
                                if (responseType === "json") {
                                    props.responseText = response.response ? response[_DYN_STATUS_TEXT /* @min:%2estatusText */] + " - " + JSON.stringify(response[_DYN_RESPONSE /* @min:%2eresponse */]) : response[_DYN_STATUS_TEXT /* @min:%2estatusText */];
                                }
                            }
                            else if (self[_DYN_STATUS /* @min:%2estatus */] === 0) {
                                props.responseText = response[_DYN_STATUS_TEXT /* @min:%2estatusText */] || "";
                            }
                        }
                    }
                }
                return dependency;
            };
            self[_DYN_GET_PART_APROPS /* @min:%2egetPartAProps */] = function () {
                var _a;
                var partA = null;
                var traceCtx = self[_DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */];
                if (traceCtx && (traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */] || traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */])) {
                    partA = {};
                    var traceExt = partA[Extensions.TraceExt] = (_a = {},
                        _a[_DYN_TRACE_ID /* @min:traceID */] = traceCtx[_DYN_TRACE_ID0 /* @min:%2etraceId */],
                        _a.parentID = traceCtx[_DYN_SPAN_ID1 /* @min:%2espanId */],
                        _a);
                    if (!isNullOrUndefined(traceCtx[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */])) {
                        traceExt[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] = traceCtx[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */];
                    }
                }
                return partA;
            };
        });
    }
// Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
// Removed Stub for ajaxRecord.prototype.getPathName.
// Removed Stub for ajaxRecord.prototype.CreateTrackItem.
// Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    ajaxRecord.__ieDyn=1;

    return ajaxRecord;
}());

var _a$3;
var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var AJAX_DATA_CONTAINER = "_ajaxData";
var STR_FETCH = "fetch";
var ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var ERROR_PREFIX = ", monitoring data for this ajax call ";
var ERROR_POSTFIX = ERROR_PREFIX + "may be incorrect.";
var ERROR_NOT_SENT = ERROR_PREFIX + "won't be sent.";
var CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
var _markCount = 0;
function _supportsFetch() {
  var _global = getGlobal();
  if (!_global || isNullOrUndefined(_global.Request) || isNullOrUndefined(_global.Request[strShimPrototype]) || isNullOrUndefined(_global[STR_FETCH])) {
    return null;
  }
  return _global[STR_FETCH];
}
function _supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
  var _a2, _b;
  var result = false;
  if (isXhrSupported()) {
    var proto = XMLHttpRequest[strShimPrototype];
    result = !isNullOrUndefined(proto) && !isNullOrUndefined(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
    !isNullOrUndefined(proto.send) && !isNullOrUndefined(proto.abort);
  }
  var ieVer = getIEVersion();
  if (ieVer && ieVer < 9) {
    result = false;
  }
  if (result) {
    try {
      var xhr = new XMLHttpRequest();
      var xhrData = {
        xh: [],
        i: (_a2 = {}, _a2[ajaxDataId] = {}, _a2)
      };
      xhr[AJAX_DATA_CONTAINER] = xhrData;
      var theOpen = XMLHttpRequest[strShimPrototype].open;
      XMLHttpRequest[strShimPrototype].open = theOpen;
    } catch (e) {
      result = false;
      _throwInternalCritical(ajaxMonitorInstance, 15, "Failed to enable XMLHttpRequest monitoring, extension is not supported", (_b = {}, _b[
        _DYN_EXCEPTION
        /* @min:exception */
      ] = dumpObj(e), _b));
    }
  }
  return result;
}
var _getAjaxData = function(xhr, ajaxDataId) {
  if (xhr && ajaxDataId && xhr[AJAX_DATA_CONTAINER]) {
    return (xhr[AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
  }
  return null;
};
var _addSharedXhrHeaders = function(xhr, name, value) {
  if (xhr) {
    var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
    if (headers) {
      headers.push({
        n: name,
        v: value
      });
    }
  }
};
var _isHeaderSet = function(xhr, name) {
  var isPresent = false;
  if (xhr) {
    var headers = (xhr[AJAX_DATA_CONTAINER] || {}).xh;
    if (headers) {
      arrForEach(headers, function(header) {
        if (header.n === name) {
          isPresent = true;
          return -1;
        }
      });
    }
  }
  return isPresent;
};
function _getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
  var result = "";
  try {
    var ajaxData = _getAjaxData(xhr, ajaxDataId);
    if (ajaxData && ajaxData[
      _DYN_REQUEST_URL
      /* @min:%2erequestUrl */
    ]) {
      result += "(url: '" + ajaxData[
        _DYN_REQUEST_URL
        /* @min:%2erequestUrl */
      ] + "')";
    }
  } catch (e) {
  }
  return result;
}
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
  _throwInternal(ajaxMonitorInstance[strDiagLog](), 1, msgId, message, properties, isUserAct);
}
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
  _throwInternal(ajaxMonitorInstance[strDiagLog](), 2, msgId, message, properties, isUserAct);
}
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
  return function(callDetails) {
    var _a2;
    _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, (_a2 = {
      ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(callDetails[
        _DYN_INST
        /* @min:%2einst */
      ], ajaxMonitorInstance._ajaxDataId)
    }, _a2[
      _DYN_EXCEPTION
      /* @min:exception */
    ] = dumpObj(callDetails.err), _a2));
  };
}
function _indexOf(value, match) {
  if (value && match) {
    return strIndexOf(value, match);
  }
  return -1;
}
function _addHandler(container, id, theFunc) {
  var theHandler = {
    id,
    fn: theFunc
  };
  container.push(theHandler);
  return {
    remove: function() {
      arrForEach(container, function(initializer, idx) {
        if (initializer.id === theHandler.id) {
          container.splice(idx, 1);
          return -1;
        }
      });
    }
  };
}
function _processDependencyContainer(core, container, details, message) {
  var result = true;
  arrForEach(container, function(theFunc, idx) {
    try {
      if (theFunc.fn.call(null, details) === false) {
        result = false;
      }
    } catch (e) {
      _throwInternal(core && core.logger, 1, 64, "Dependency " + message + " [#" + idx + "] failed: " + getExceptionName(e), { exception: dumpObj(e) }, true);
    }
  });
  return result;
}
function _processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
  var _a2;
  var initializersCount = listeners[
    _DYN_LENGTH$1
    /* @min:%2elength */
  ];
  if (initializersCount > 0) {
    var details = (_a2 = {}, _a2[
      _DYN_CORE
      /* @min:core */
    ] = core, _a2.xhr = xhr, _a2.input = input, _a2.init = init, _a2.traceId = ajaxData[
      _DYN_TRACE_ID
      /* @min:%2etraceID */
    ], _a2.spanId = ajaxData[
      _DYN_SPAN_ID
      /* @min:%2espanID */
    ], _a2.traceFlags = ajaxData[
      _DYN_TRACE_FLAGS
      /* @min:%2etraceFlags */
    ], _a2.context = ajaxData[
      _DYN_CONTEXT$1
      /* @min:%2econtext */
    ] || {}, _a2.aborted = !!ajaxData[
      _DYN_ABORTED
      /* @min:%2eaborted */
    ], _a2);
    _processDependencyContainer(core, listeners, details, "listener");
    ajaxData[
      _DYN_TRACE_ID
      /* @min:%2etraceID */
    ] = details[
      _DYN_TRACE_ID0
      /* @min:%2etraceId */
    ];
    ajaxData[
      _DYN_SPAN_ID
      /* @min:%2espanID */
    ] = details[
      _DYN_SPAN_ID1
      /* @min:%2espanId */
    ];
    ajaxData[
      _DYN_TRACE_FLAGS
      /* @min:%2etraceFlags */
    ] = details[
      _DYN_TRACE_FLAGS
      /* @min:%2etraceFlags */
    ];
    ajaxData[
      _DYN_CONTEXT$1
      /* @min:%2econtext */
    ] = details[
      _DYN_CONTEXT$1
      /* @min:%2econtext */
    ];
  }
}
var BLOB_CORE = "*.blob.core.";
var DfltAjaxCorrelationHeaderExDomains = objFreeze([
  BLOB_CORE + "windows.net",
  BLOB_CORE + "chinacloudapi.cn",
  BLOB_CORE + "cloudapi.de",
  BLOB_CORE + "usgovcloudapi.net"
]);
var _internalExcludeEndpoints = [
  /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
var _defaultConfig$1 = objFreeze((_a$3 = {}, _a$3[
  _DYN_MAX_AJAX_CALLS_PER_V7
  /* @min:maxAjaxCallsPerView */
] = 500, _a$3[
  _DYN_DISABLE_AJAX_TRACKIN9
  /* @min:disableAjaxTracking */
] = false, _a$3[
  _DYN_DISABLE_FETCH_TRACKI11
  /* @min:disableFetchTracking */
] = false, _a$3[
  _DYN_EXCLUDE_REQUEST_FROM8
  /* @min:excludeRequestFromAutoTrackingPatterns */
] = undefined, _a$3.disableCorrelationHeaders = false, _a$3.distributedTracingMode = 1, _a$3.correlationHeaderExcludedDomains = DfltAjaxCorrelationHeaderExDomains, _a$3.correlationHeaderDomains = undefined, _a$3.correlationHeaderExcludePatterns = undefined, _a$3.appId = undefined, _a$3.enableCorsCorrelation = false, _a$3[
  _DYN_ENABLE_REQUEST_HEADE4
  /* @min:enableRequestHeaderTracking */
] = false, _a$3[
  _DYN_ENABLE_RESPONSE_HEAD12
  /* @min:enableResponseHeaderTracking */
] = false, _a$3[
  _DYN_ENABLE_AJAX_ERROR_ST5
  /* @min:enableAjaxErrorStatusText */
] = false, _a$3[
  _DYN_ENABLE_AJAX_PERF_TRA6
  /* @min:enableAjaxPerfTracking */
] = false, _a$3.maxAjaxPerfLookupAttempts = 3, _a$3[
  _DYN_AJAX_PERF_LOOKUP_DEL10
  /* @min:ajaxPerfLookupDelay */
] = 25, _a$3.ignoreHeaders = [
  "Authorization",
  "X-API-Key",
  "WWW-Authenticate"
], _a$3[
  _DYN_ADD_REQUEST_CONTEXT
  /* @min:addRequestContext */
] = undefined, _a$3.addIntEndpoints = true, _a$3));
var AjaxMonitor = (
  /** @class */
  function(_super) {
    __extendsFn(AjaxMonitor2, _super);
    function AjaxMonitor2() {
      var _this = _super.call(this) || this;
      _this.identifier = AjaxMonitor2.identifier;
      _this.priority = 120;
      var _fetchInitialized;
      var _xhrInitialized;
      var _currentWindowHost;
      var _extensionConfig;
      var _enableRequestHeaderTracking;
      var _enableAjaxErrorStatusText;
      var _trackAjaxAttempts;
      var _context;
      var _isUsingW3CHeaders;
      var _isUsingAIHeaders;
      var _markPrefix;
      var _enableAjaxPerfTracking;
      var _maxAjaxCallsPerView;
      var _enableResponseHeaderTracking;
      var _disabledUrls;
      var _disableAjaxTracking;
      var _disableFetchTracking;
      var _excludeRequestFromAutoTrackingPatterns;
      var _addRequestContext;
      var _evtNamespace;
      var _ajaxDataId;
      var _dependencyHandlerId;
      var _dependencyListeners;
      var _dependencyInitializers;
      var _ignoreHeaders;
      var _maxAjaxPerfLookupAttempts;
      var _ajaxPerfLookupDelay;
      var _distributedTracingMode;
      var _appId;
      var _polyfillInitialized;
      dynamicProto(AjaxMonitor2, _this, function(_self, _base) {
        var _addHook = _base[
          _DYN__ADD_HOOK
          /* @min:%2e_addHook */
        ];
        _initDefaults();
        _self.initialize = function(config, core, extensions, pluginChain) {
          if (!_self.isInitialized()) {
            _base.initialize(config, core, extensions, pluginChain);
            _evtNamespace = mergeEvtNamespace(createUniqueNamespace("ajax"), core && core.evtNamespace && core.evtNamespace());
            _populateDefaults(config);
            _instrumentXhr();
            _instrumentFetch();
            _populateContext();
          }
        };
        _self._doTeardown = function() {
          _initDefaults();
        };
        _self.trackDependencyData = function(dependency, properties) {
          _reportDependencyInternal(_dependencyInitializers, _self[
            _DYN_CORE
            /* @min:%2ecore */
          ], null, dependency, properties);
        };
        _self[
          _DYN_INCLUDE_CORRELATION_2
          /* @min:%2eincludeCorrelationHeaders */
        ] = function(ajaxData, input, init, xhr) {
          var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
          _processDependencyListeners(_dependencyListeners, _self[
            _DYN_CORE
            /* @min:%2ecore */
          ], ajaxData, xhr, input, init);
          if (input || input === "") {
            if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[
              _DYN_GET_ABSOLUTE_URL
              /* @min:%2egetAbsoluteUrl */
            ](), currentWindowHost)) {
              if (!init) {
                init = {};
              }
              var headers = new Headers(init[
                _DYN_HEADERS
                /* @min:%2eheaders */
              ] || (input instanceof Request ? input[
                _DYN_HEADERS
                /* @min:%2eheaders */
              ] || {} : {}));
              if (_isUsingAIHeaders) {
                var id = "|" + ajaxData[
                  _DYN_TRACE_ID
                  /* @min:%2etraceID */
                ] + "." + ajaxData[
                  _DYN_SPAN_ID
                  /* @min:%2espanID */
                ];
                headers.set(RequestHeaders[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ], id);
                if (_enableRequestHeaderTracking) {
                  ajaxData[
                    _DYN_REQUEST_HEADERS
                    /* @min:%2erequestHeaders */
                  ][RequestHeaders[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ]] = id;
                }
              }
              var appId = _appId || _context && _context.appId();
              if (appId) {
                headers.set(RequestHeaders[
                  0
                  /* eRequestHeaders.requestContextHeader */
                ], RequestHeaders[
                  2
                  /* eRequestHeaders.requestContextAppIdFormat */
                ] + appId);
                if (_enableRequestHeaderTracking) {
                  ajaxData[
                    _DYN_REQUEST_HEADERS
                    /* @min:%2erequestHeaders */
                  ][RequestHeaders[
                    0
                    /* eRequestHeaders.requestContextHeader */
                  ]] = RequestHeaders[
                    2
                    /* eRequestHeaders.requestContextAppIdFormat */
                  ] + appId;
                }
              }
              if (_isUsingW3CHeaders) {
                var traceFlags = ajaxData[
                  _DYN_TRACE_FLAGS
                  /* @min:%2etraceFlags */
                ];
                if (isNullOrUndefined(traceFlags)) {
                  traceFlags = 1;
                }
                var traceParent = formatTraceParent(createTraceParent(ajaxData[
                  _DYN_TRACE_ID
                  /* @min:%2etraceID */
                ], ajaxData[
                  _DYN_SPAN_ID
                  /* @min:%2espanID */
                ], traceFlags));
                headers.set(RequestHeaders[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ], traceParent);
                if (_enableRequestHeaderTracking) {
                  ajaxData[
                    _DYN_REQUEST_HEADERS
                    /* @min:%2erequestHeaders */
                  ][RequestHeaders[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ]] = traceParent;
                }
              }
              init[
                _DYN_HEADERS
                /* @min:%2eheaders */
              ] = headers;
            }
            return init;
          } else if (xhr) {
            if (correlationIdCanIncludeCorrelationHeader(_extensionConfig, ajaxData[
              _DYN_GET_ABSOLUTE_URL
              /* @min:%2egetAbsoluteUrl */
            ](), currentWindowHost)) {
              if (_isUsingAIHeaders) {
                if (!_isHeaderSet(xhr, RequestHeaders[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ])) {
                  var id = "|" + ajaxData[
                    _DYN_TRACE_ID
                    /* @min:%2etraceID */
                  ] + "." + ajaxData[
                    _DYN_SPAN_ID
                    /* @min:%2espanID */
                  ];
                  xhr[
                    _DYN_SET_REQUEST_HEADER
                    /* @min:%2esetRequestHeader */
                  ](RequestHeaders[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ], id);
                  if (_enableRequestHeaderTracking) {
                    ajaxData[
                      _DYN_REQUEST_HEADERS
                      /* @min:%2erequestHeaders */
                    ][RequestHeaders[
                      3
                      /* eRequestHeaders.requestIdHeader */
                    ]] = id;
                  }
                } else {
                  _throwInternalWarning(_self, 71, "Unable to set [" + RequestHeaders[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ] + "] as it has already been set by another instance");
                }
              }
              var appId = _appId || _context && _context.appId();
              if (appId) {
                if (!_isHeaderSet(xhr, RequestHeaders[
                  0
                  /* eRequestHeaders.requestContextHeader */
                ])) {
                  xhr[
                    _DYN_SET_REQUEST_HEADER
                    /* @min:%2esetRequestHeader */
                  ](RequestHeaders[
                    0
                    /* eRequestHeaders.requestContextHeader */
                  ], RequestHeaders[
                    2
                    /* eRequestHeaders.requestContextAppIdFormat */
                  ] + appId);
                  if (_enableRequestHeaderTracking) {
                    ajaxData[
                      _DYN_REQUEST_HEADERS
                      /* @min:%2erequestHeaders */
                    ][RequestHeaders[
                      0
                      /* eRequestHeaders.requestContextHeader */
                    ]] = RequestHeaders[
                      2
                      /* eRequestHeaders.requestContextAppIdFormat */
                    ] + appId;
                  }
                } else {
                  _throwInternalWarning(_self, 71, "Unable to set [" + RequestHeaders[
                    0
                    /* eRequestHeaders.requestContextHeader */
                  ] + "] as it has already been set by another instance");
                }
              }
              if (_isUsingW3CHeaders) {
                var traceFlags = ajaxData[
                  _DYN_TRACE_FLAGS
                  /* @min:%2etraceFlags */
                ];
                if (isNullOrUndefined(traceFlags)) {
                  traceFlags = 1;
                }
                if (!_isHeaderSet(xhr, RequestHeaders[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ])) {
                  var traceParent = formatTraceParent(createTraceParent(ajaxData[
                    _DYN_TRACE_ID
                    /* @min:%2etraceID */
                  ], ajaxData[
                    _DYN_SPAN_ID
                    /* @min:%2espanID */
                  ], traceFlags));
                  xhr[
                    _DYN_SET_REQUEST_HEADER
                    /* @min:%2esetRequestHeader */
                  ](RequestHeaders[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ], traceParent);
                  if (_enableRequestHeaderTracking) {
                    ajaxData[
                      _DYN_REQUEST_HEADERS
                      /* @min:%2erequestHeaders */
                    ][RequestHeaders[
                      4
                      /* eRequestHeaders.traceParentHeader */
                    ]] = traceParent;
                  }
                } else {
                  _throwInternalWarning(_self, 71, "Unable to set [" + RequestHeaders[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ] + "] as it has already been set by another instance");
                }
              }
            }
            return xhr;
          }
          return undefined;
        };
        _self[
          _DYN_TRACK_DEPENDENCY_DAT3
          /* @min:%2etrackDependencyDataInternal */
        ] = function(dependency, properties, systemProperties) {
          if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
            if ((_distributedTracingMode === 2 || _distributedTracingMode === 1) && typeof dependency.id === "string" && dependency.id[dependency.id[
              _DYN_LENGTH$1
              /* @min:%2elength */
            ] - 1] !== ".") {
              dependency.id += ".";
            }
            if (isNullOrUndefined(dependency[
              _DYN_START_TIME
              /* @min:%2estartTime */
            ])) {
              dependency[
                _DYN_START_TIME
                /* @min:%2estartTime */
              ] = /* @__PURE__ */ new Date();
            }
            var item = createTelemetryItem(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
            _self[
              _DYN_CORE
              /* @min:%2ecore */
            ].track(item);
          } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
            _throwInternalCritical(_self, 55, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
          }
          ++_trackAjaxAttempts;
        };
        _self.addDependencyListener = function(dependencyListener) {
          return _addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
        };
        _self.addDependencyInitializer = function(dependencyInitializer) {
          return _addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
        };
        function _initDefaults() {
          var location = getLocation$1();
          _fetchInitialized = false;
          _xhrInitialized = false;
          _polyfillInitialized = false;
          _currentWindowHost = location && location.host && location.host[
            _DYN_TO_LOWER_CASE
            /* @min:%2etoLowerCase */
          ]();
          _extensionConfig = null;
          _enableRequestHeaderTracking = false;
          _enableAjaxErrorStatusText = false;
          _trackAjaxAttempts = 0;
          _context = null;
          _isUsingW3CHeaders = false;
          _isUsingAIHeaders = false;
          _markPrefix = null;
          _enableAjaxPerfTracking = false;
          _maxAjaxCallsPerView = 0;
          _enableResponseHeaderTracking = false;
          _disabledUrls = {};
          _disableAjaxTracking = false;
          _disableFetchTracking = false;
          _excludeRequestFromAutoTrackingPatterns = null;
          _addRequestContext = null;
          _evtNamespace = null;
          _dependencyHandlerId = 0;
          _dependencyListeners = [];
          _dependencyInitializers = [];
          _ajaxDataId = createUniqueNamespace("ajaxData");
          _self._ajaxDataId = _ajaxDataId;
          _ignoreHeaders = null;
          _maxAjaxPerfLookupAttempts = 1;
          _ajaxPerfLookupDelay = 1;
          _distributedTracingMode = 1;
          _appId = null;
        }
        function _populateDefaults(config) {
          _self[
            _DYN__ADD_HOOK
            /* @min:%2e_addHook */
          ](onConfigChange(config, function(details) {
            var config2 = details.cfg;
            var ctx = createProcessTelemetryContext(null, config2, _self[
              _DYN_CORE
              /* @min:%2ecore */
            ]);
            _extensionConfig = ctx.getExtCfg(AjaxMonitor2.identifier, _defaultConfig$1);
            _distributedTracingMode = _extensionConfig.distributedTracingMode;
            _enableRequestHeaderTracking = _extensionConfig[
              _DYN_ENABLE_REQUEST_HEADE4
              /* @min:%2eenableRequestHeaderTracking */
            ];
            _enableAjaxErrorStatusText = _extensionConfig[
              _DYN_ENABLE_AJAX_ERROR_ST5
              /* @min:%2eenableAjaxErrorStatusText */
            ];
            _enableAjaxPerfTracking = _extensionConfig[
              _DYN_ENABLE_AJAX_PERF_TRA6
              /* @min:%2eenableAjaxPerfTracking */
            ];
            _maxAjaxCallsPerView = _extensionConfig[
              _DYN_MAX_AJAX_CALLS_PER_V7
              /* @min:%2emaxAjaxCallsPerView */
            ];
            _excludeRequestFromAutoTrackingPatterns = [].concat(_extensionConfig[
              _DYN_EXCLUDE_REQUEST_FROM8
              /* @min:%2eexcludeRequestFromAutoTrackingPatterns */
            ] || [], _extensionConfig.addIntEndpoints !== false ? _internalExcludeEndpoints : []);
            _addRequestContext = _extensionConfig[
              _DYN_ADD_REQUEST_CONTEXT
              /* @min:%2eaddRequestContext */
            ];
            _isUsingAIHeaders = _distributedTracingMode === 0 || _distributedTracingMode === 1;
            _isUsingW3CHeaders = _distributedTracingMode === 1 || _distributedTracingMode === 2;
            if (_enableAjaxPerfTracking) {
              var iKey = config2.instrumentationKey || "unkwn";
              if (iKey[
                _DYN_LENGTH$1
                /* @min:%2elength */
              ] > 5) {
                _markPrefix = AJAX_MONITOR_PREFIX + strSubstring(iKey, iKey[
                  _DYN_LENGTH$1
                  /* @min:%2elength */
                ] - 5) + ".";
              } else {
                _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
              }
            }
            _disableAjaxTracking = !!_extensionConfig[
              _DYN_DISABLE_AJAX_TRACKIN9
              /* @min:%2edisableAjaxTracking */
            ];
            _maxAjaxPerfLookupAttempts = _extensionConfig.maxAjaxPerfLookupAttempts;
            _ajaxPerfLookupDelay = _extensionConfig[
              _DYN_AJAX_PERF_LOOKUP_DEL10
              /* @min:%2eajaxPerfLookupDelay */
            ];
            _ignoreHeaders = _extensionConfig.ignoreHeaders;
            _appId = _extensionConfig.appId;
          }));
        }
        function _populateContext() {
          var propExt = _self[
            _DYN_CORE
            /* @min:%2ecore */
          ].getPlugin(PropertiesPluginIdentifier);
          if (propExt) {
            _context = propExt.plugin[
              _DYN_CONTEXT$1
              /* @min:%2econtext */
            ];
          }
        }
        function _canIncludeHeaders(header) {
          var rlt = true;
          if (header || _ignoreHeaders) {
            arrForEach(_ignoreHeaders, function(key) {
              if (key[
                _DYN_TO_LOWER_CASE
                /* @min:%2etoLowerCase */
              ]() === header[
                _DYN_TO_LOWER_CASE
                /* @min:%2etoLowerCase */
              ]()) {
                rlt = false;
                return -1;
              }
            });
          }
          return rlt;
        }
        function _instrumentFetch() {
          var fetch = _supportsFetch();
          if (!fetch) {
            return;
          }
          var global = getGlobal();
          var isPolyfill = fetch.polyfill;
          _self[
            _DYN__ADD_HOOK
            /* @min:%2e_addHook */
          ](onConfigChange(_extensionConfig, function() {
            _disableFetchTracking = !!_extensionConfig[
              _DYN_DISABLE_FETCH_TRACKI11
              /* @min:%2edisableFetchTracking */
            ];
            _enableResponseHeaderTracking = _extensionConfig[
              _DYN_ENABLE_RESPONSE_HEAD12
              /* @min:%2eenableResponseHeaderTracking */
            ];
            if (!_disableFetchTracking && !_fetchInitialized) {
              _addHook(InstrumentFunc(global, STR_FETCH, {
                ns: _evtNamespace,
                // Add request hook
                req: function(callDetails, input, init) {
                  var fetchData;
                  if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                  !(isPolyfill && _xhrInitialized)) {
                    var ctx = callDetails.ctx();
                    fetchData = _createFetchRecord(input, init);
                    var newInit = _self[
                      _DYN_INCLUDE_CORRELATION_2
                      /* @min:%2eincludeCorrelationHeaders */
                    ](fetchData, input, init);
                    if (newInit !== init) {
                      callDetails.set(1, newInit);
                    }
                    ctx.data = fetchData;
                  }
                },
                rsp: function(callDetails, input) {
                  if (!_disableFetchTracking) {
                    var fetchData_1 = callDetails.ctx().data;
                    if (fetchData_1) {
                      callDetails.rslt = callDetails.rslt.then(function(response) {
                        _reportFetchMetrics(callDetails, (response || {})[
                          _DYN_STATUS
                          /* @min:%2estatus */
                        ], input, response, fetchData_1, function() {
                          var _a2;
                          var ajaxResponse = (_a2 = {
                            statusText: (response || {})[
                              _DYN_STATUS_TEXT
                              /* @min:%2estatusText */
                            ]
                          }, _a2[
                            _DYN_HEADER_MAP
                            /* @min:headerMap */
                          ] = null, _a2[
                            _DYN_CORRELATION_CONTEXT
                            /* @min:correlationContext */
                          ] = _getFetchCorrelationContext(response), _a2);
                          if (_enableResponseHeaderTracking && response) {
                            var responseHeaderMap_1 = {};
                            response.headers.forEach(function(value, name) {
                              if (_canIncludeHeaders(name)) {
                                responseHeaderMap_1[name] = value;
                              }
                            });
                            ajaxResponse[
                              _DYN_HEADER_MAP
                              /* @min:%2eheaderMap */
                            ] = responseHeaderMap_1;
                          }
                          return ajaxResponse;
                        });
                        return response;
                      }).catch(function(reason) {
                        _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, { error: reason.message || dumpObj(reason) });
                        throw reason;
                      });
                    }
                  }
                },
                // Create an error callback to report any hook errors
                hkErr: _createErrorCallbackFunc(_self, 15, "Failed to monitor Window.fetch" + ERROR_POSTFIX)
              }, true, isWebWorker()));
              _fetchInitialized = true;
            } else if (isPolyfill && !_polyfillInitialized) {
              _addHook(InstrumentFunc(global, STR_FETCH, {
                ns: _evtNamespace,
                req: function(callDetails, input, init) {
                  _isDisabledRequest(null, input, init);
                }
              }));
              _polyfillInitialized = true;
            }
          }));
          if (isPolyfill) {
            global[STR_FETCH].polyfill = isPolyfill;
          }
        }
        function _hookProto(target, funcName, callbacks) {
          _addHook(InstrumentProto(target, funcName, callbacks));
        }
        function _instrumentXhr() {
          if (!_supportsAjaxMonitoring(_self, _ajaxDataId)) {
            return;
          }
          _self[
            _DYN__ADD_HOOK
            /* @min:%2e_addHook */
          ](onConfigChange(_extensionConfig, function() {
            _disableAjaxTracking = !!_extensionConfig[
              _DYN_DISABLE_AJAX_TRACKIN9
              /* @min:%2edisableAjaxTracking */
            ];
            _enableRequestHeaderTracking = _extensionConfig[
              _DYN_ENABLE_REQUEST_HEADE4
              /* @min:%2eenableRequestHeaderTracking */
            ];
            if (!_disableAjaxTracking && !_xhrInitialized) {
              _hookProto(XMLHttpRequest, "open", {
                ns: _evtNamespace,
                req: function(callDetails, method, url, async) {
                  if (!_disableAjaxTracking) {
                    var xhr = callDetails[
                      _DYN_INST
                      /* @min:%2einst */
                    ];
                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                    if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                      if (!ajaxData || !ajaxData.xhrMonitoringState[
                        _DYN_OPEN_DONE
                        /* @min:%2eopenDone */
                      ]) {
                        ajaxData = _openHandler(xhr, method, url, async);
                      }
                      _attachToOnReadyStateChange(xhr, ajaxData);
                    }
                  }
                },
                hkErr: _createErrorCallbackFunc(_self, 15, ERROR_HEADER + ".open" + ERROR_POSTFIX)
              });
              _hookProto(XMLHttpRequest, "send", {
                ns: _evtNamespace,
                req: function(callDetails, context) {
                  if (!_disableAjaxTracking) {
                    var xhr = callDetails[
                      _DYN_INST
                      /* @min:%2einst */
                    ];
                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[
                      _DYN_SEND_DONE
                      /* @min:%2esendDone */
                    ]) {
                      _createMarkId("xhr", ajaxData);
                      ajaxData[
                        _DYN_REQUEST_SENT_TIME
                        /* @min:%2erequestSentTime */
                      ] = dateTimeUtilsNow();
                      _self[
                        _DYN_INCLUDE_CORRELATION_2
                        /* @min:%2eincludeCorrelationHeaders */
                      ](ajaxData, undefined, undefined, xhr);
                      ajaxData.xhrMonitoringState[
                        _DYN_SEND_DONE
                        /* @min:%2esendDone */
                      ] = true;
                    }
                  }
                },
                hkErr: _createErrorCallbackFunc(_self, 17, ERROR_HEADER + ERROR_POSTFIX)
              });
              _hookProto(XMLHttpRequest, "abort", {
                ns: _evtNamespace,
                req: function(callDetails) {
                  if (!_disableAjaxTracking) {
                    var xhr = callDetails[
                      _DYN_INST
                      /* @min:%2einst */
                    ];
                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                    if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[
                      _DYN_ABORT_DONE
                      /* @min:%2eabortDone */
                    ]) {
                      ajaxData[
                        _DYN_ABORTED
                        /* @min:%2eaborted */
                      ] = 1;
                      ajaxData.xhrMonitoringState[
                        _DYN_ABORT_DONE
                        /* @min:%2eabortDone */
                      ] = true;
                    }
                  }
                },
                hkErr: _createErrorCallbackFunc(_self, 13, ERROR_HEADER + ".abort" + ERROR_POSTFIX)
              });
              _hookProto(XMLHttpRequest, "setRequestHeader", {
                ns: _evtNamespace,
                req: function(callDetails, header, value) {
                  if (!_disableAjaxTracking) {
                    var xhr = callDetails[
                      _DYN_INST
                      /* @min:%2einst */
                    ];
                    var ajaxData = _getAjaxData(xhr, _ajaxDataId);
                    if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                      _addSharedXhrHeaders(xhr, header, value);
                      if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                        if (ajaxData) {
                          ajaxData[
                            _DYN_REQUEST_HEADERS
                            /* @min:%2erequestHeaders */
                          ][header] = value;
                        }
                      }
                    }
                  }
                },
                hkErr: _createErrorCallbackFunc(_self, 71, ERROR_HEADER + ".setRequestHeader" + ERROR_POSTFIX)
              });
              _xhrInitialized = true;
            }
          }));
        }
        function _isDisabledRequest(xhr, request, init) {
          var isDisabled = false;
          var theUrl = ((!isString$2(request) ? (request || {}).url || "" : request) || "")[
            _DYN_TO_LOWER_CASE
            /* @min:%2etoLowerCase */
          ]();
          arrForEach(_excludeRequestFromAutoTrackingPatterns, function(regex) {
            var theRegex = regex;
            if (isString$2(regex)) {
              theRegex = new RegExp(regex);
            }
            if (!isDisabled) {
              isDisabled = theRegex.test(theUrl);
            }
          });
          if (isDisabled) {
            return isDisabled;
          }
          var idx = _indexOf(theUrl, "?");
          var idx2 = _indexOf(theUrl, "#");
          if (idx === -1 || idx2 !== -1 && idx2 < idx) {
            idx = idx2;
          }
          if (idx !== -1) {
            theUrl = theUrl.substring(0, idx);
          }
          if (!isNullOrUndefined(xhr)) {
            isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
          } else if (!isNullOrUndefined(request)) {
            isDisabled = (typeof request === "object" ? request[DisabledPropertyName] === true : false) || (init ? init[DisabledPropertyName] === true : false);
          }
          if (!isDisabled && theUrl && isInternalApplicationInsightsEndpoint(theUrl)) {
            isDisabled = true;
          }
          if (isDisabled) {
            if (!_disabledUrls[theUrl]) {
              _disabledUrls[theUrl] = 1;
            }
          } else {
            if (_disabledUrls[theUrl]) {
              isDisabled = true;
            }
          }
          return isDisabled;
        }
        function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
          var ajaxValidation = true;
          var initialized = _xhrInitialized;
          if (!isNullOrUndefined(xhr)) {
            ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined(ajaxData);
          }
          return initialized && ajaxValidation;
        }
        function _getDistributedTraceCtx() {
          var distributedTraceCtx = null;
          if (_self[
            _DYN_CORE
            /* @min:%2ecore */
          ] && _self[
            _DYN_CORE
            /* @min:%2ecore */
          ].getTraceCtx) {
            distributedTraceCtx = _self[
              _DYN_CORE
              /* @min:%2ecore */
            ].getTraceCtx(false);
          }
          if (!distributedTraceCtx && _context && _context.telemetryTrace) {
            distributedTraceCtx = createDistributedTraceContextFromTrace(_context.telemetryTrace);
          }
          return distributedTraceCtx;
        }
        function _openHandler(xhr, method, url, async) {
          var _a2;
          var distributedTraceCtx = _getDistributedTraceCtx();
          var traceID = distributedTraceCtx && distributedTraceCtx[
            _DYN_GET_TRACE_ID
            /* @min:%2egetTraceId */
          ]() || generateW3CId();
          var spanID = strSubstr(generateW3CId(), 0, 16);
          var xhrRequestData = xhr[AJAX_DATA_CONTAINER] = xhr[AJAX_DATA_CONTAINER] || { xh: [], i: {} };
          var ajaxDataCntr = xhrRequestData.i = xhrRequestData.i || {};
          var ajaxData = ajaxDataCntr[_ajaxDataId] = ajaxDataCntr[_ajaxDataId] || new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a2 = _self.core) === null || _a2 === undefined ? undefined : _a2.getTraceCtx());
          ajaxData[
            _DYN_TRACE_FLAGS
            /* @min:%2etraceFlags */
          ] = distributedTraceCtx && distributedTraceCtx[
            _DYN_GET_TRACE_FLAGS
            /* @min:%2egetTraceFlags */
          ]();
          ajaxData[
            _DYN_METHOD
            /* @min:%2emethod */
          ] = method;
          ajaxData[
            _DYN_REQUEST_URL
            /* @min:%2erequestUrl */
          ] = url;
          ajaxData.xhrMonitoringState[
            _DYN_OPEN_DONE
            /* @min:%2eopenDone */
          ] = true;
          ajaxData[
            _DYN_REQUEST_HEADERS
            /* @min:%2erequestHeaders */
          ] = {};
          ajaxData.async = async;
          ajaxData[
            _DYN_ERROR_STATUS_TEXT
            /* @min:%2eerrorStatusText */
          ] = _enableAjaxErrorStatusText;
          return ajaxData;
        }
        function _attachToOnReadyStateChange(xhr, ajaxData) {
          ajaxData.xhrMonitoringState[
            _DYN_STATE_CHANGE_ATTACHE13
            /* @min:%2estateChangeAttached */
          ] = eventOn(xhr, "readystatechange", function() {
            var _a2;
            try {
              if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) {
                _onAjaxComplete(xhr);
              }
            } catch (e) {
              var exceptionText = dumpObj(e);
              if (!exceptionText || _indexOf(exceptionText[
                _DYN_TO_LOWER_CASE
                /* @min:%2etoLowerCase */
              ](), "c00c023f") === -1) {
                _throwInternalCritical(_self, 16, ERROR_HEADER + " 'readystatechange' event handler" + ERROR_POSTFIX, (_a2 = {}, _a2[
                  _DYN_AJAX_DIAGNOSTICS_MES16
                  /* @min:ajaxDiagnosticsMessage */
                ] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a2[
                  _DYN_EXCEPTION
                  /* @min:exception */
                ] = exceptionText, _a2));
              }
            }
          }, _evtNamespace);
        }
        function _getResponseText(xhr) {
          try {
            var responseType = xhr.responseType;
            if (responseType === "" || responseType === "text") {
              return xhr[
                _DYN_RESPONSE_TEXT
                /* @min:%2eresponseText */
              ];
            }
          } catch (e) {
          }
          return null;
        }
        function _onAjaxComplete(xhr) {
          var ajaxData = _getAjaxData(xhr, _ajaxDataId);
          ajaxData[
            _DYN_RESPONSE_FINISHED_TI14
            /* @min:%2eresponseFinishedTime */
          ] = dateTimeUtilsNow();
          ajaxData[
            _DYN_STATUS
            /* @min:%2estatus */
          ] = xhr[
            _DYN_STATUS
            /* @min:%2estatus */
          ];
          function _reportXhrError(e, failedProps) {
            var errorProps = failedProps || {};
            errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
            if (e) {
              errorProps["exception"] = dumpObj(e);
            }
            _throwInternalWarning(_self, 14, FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + ERROR_NOT_SENT, errorProps);
          }
          _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
            try {
              var dependency = ajaxData[
                _DYN__CREATE_TRACK_ITEM
                /* @min:%2eCreateTrackItem */
              ]("Ajax", _enableRequestHeaderTracking, function() {
                var _a2;
                var ajaxResponse = (_a2 = {
                  statusText: xhr[
                    _DYN_STATUS_TEXT
                    /* @min:%2estatusText */
                  ]
                }, _a2[
                  _DYN_HEADER_MAP
                  /* @min:headerMap */
                ] = null, _a2[
                  _DYN_CORRELATION_CONTEXT
                  /* @min:correlationContext */
                ] = _getAjaxCorrelationContext(xhr), _a2.type = xhr.responseType, _a2[
                  _DYN_RESPONSE_TEXT
                  /* @min:responseText */
                ] = _getResponseText(xhr), _a2.response = xhr[
                  _DYN_RESPONSE
                  /* @min:%2eresponse */
                ], _a2);
                if (_enableResponseHeaderTracking) {
                  var headers = xhr[
                    _DYN_GET_ALL_RESPONSE_HEA15
                    /* @min:%2egetAllResponseHeaders */
                  ]();
                  if (headers) {
                    var arr = strTrim(headers).split(/[\r\n]+/);
                    var responseHeaderMap_2 = {};
                    arrForEach(arr, function(line) {
                      var parts = line.split(": ");
                      var header = parts.shift();
                      var value = parts.join(": ");
                      if (_canIncludeHeaders(header)) {
                        responseHeaderMap_2[header] = value;
                      }
                    });
                    ajaxResponse[
                      _DYN_HEADER_MAP
                      /* @min:%2eheaderMap */
                    ] = responseHeaderMap_2;
                  }
                }
                return ajaxResponse;
              });
              var properties = void 0;
              try {
                if (!!_addRequestContext) {
                  properties = _addRequestContext({ status: xhr[
                    _DYN_STATUS
                    /* @min:%2estatus */
                  ], xhr });
                }
              } catch (e) {
                _throwInternalWarning(_self, 104, CUSTOM_REQUEST_CONTEXT_ERROR);
              }
              if (dependency) {
                if (properties !== void 0) {
                  dependency[
                    STR_PROPERTIES
                    /* @min:%2eproperties */
                  ] = __assignFn(__assignFn({}, dependency.properties), properties);
                }
                var sysProperties = ajaxData[
                  _DYN_GET_PART_APROPS
                  /* @min:%2egetPartAProps */
                ]();
                _reportDependencyInternal(_dependencyInitializers, _self[
                  _DYN_CORE
                  /* @min:%2ecore */
                ], ajaxData, dependency, null, sysProperties);
              } else {
                _reportXhrError(null, {
                  requestSentTime: ajaxData[
                    _DYN_REQUEST_SENT_TIME
                    /* @min:%2erequestSentTime */
                  ],
                  responseFinishedTime: ajaxData[
                    _DYN_RESPONSE_FINISHED_TI14
                    /* @min:%2eresponseFinishedTime */
                  ]
                });
              }
            } finally {
              try {
                var xhrRequestData = xhr[AJAX_DATA_CONTAINER] || { i: {} };
                var ajaxDataCntr = xhrRequestData.i || {};
                if (ajaxDataCntr[_ajaxDataId]) {
                  ajaxDataCntr[_ajaxDataId] = null;
                }
              } catch (e) {
              }
            }
          }, function(e) {
            _reportXhrError(e, null);
          });
        }
        function _getAjaxCorrelationContext(xhr) {
          var _a2;
          try {
            var responseHeadersString = xhr[
              _DYN_GET_ALL_RESPONSE_HEA15
              /* @min:%2egetAllResponseHeaders */
            ]();
            if (responseHeadersString !== null) {
              var index = _indexOf(responseHeadersString[
                _DYN_TO_LOWER_CASE
                /* @min:%2etoLowerCase */
              ](), RequestHeaders[
                8
                /* eRequestHeaders.requestContextHeaderLowerCase */
              ]);
              if (index !== -1) {
                var responseHeader = xhr.getResponseHeader(RequestHeaders[
                  0
                  /* eRequestHeaders.requestContextHeader */
                ]);
                return correlationIdGetCorrelationContext(responseHeader);
              }
            }
          } catch (e) {
            _throwInternalWarning(_self, 18, CORRELATION_HEADER_ERROR, (_a2 = {}, _a2[
              _DYN_AJAX_DIAGNOSTICS_MES16
              /* @min:ajaxDiagnosticsMessage */
            ] = _getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId), _a2[
              _DYN_EXCEPTION
              /* @min:exception */
            ] = dumpObj(e), _a2));
          }
        }
        function _createMarkId(type, ajaxData) {
          if (ajaxData[
            _DYN_REQUEST_URL
            /* @min:%2erequestUrl */
          ] && _markPrefix && _enableAjaxPerfTracking) {
            var performance_1 = getPerformance();
            if (performance_1 && isFunction$3(performance_1.mark)) {
              _markCount++;
              var markId = _markPrefix + type + "#" + _markCount;
              performance_1.mark(markId);
              var entries = performance_1.getEntriesByName(markId);
              if (entries && entries[
                _DYN_LENGTH$1
                /* @min:%2elength */
              ] === 1) {
                ajaxData[
                  _DYN_PERF_MARK
                  /* @min:%2eperfMark */
                ] = entries[0];
              }
            }
          }
        }
        function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
          var perfMark = ajaxData[
            _DYN_PERF_MARK
            /* @min:%2eperfMark */
          ];
          var performance = getPerformance();
          var maxAttempts = _maxAjaxPerfLookupAttempts;
          var retryDelay = _ajaxPerfLookupDelay;
          var requestUrl = ajaxData[
            _DYN_REQUEST_URL
            /* @min:%2erequestUrl */
          ];
          var attempt = 0;
          (function locateResourceTiming() {
            try {
              if (performance && perfMark) {
                attempt++;
                var perfTiming = null;
                var entries = performance.getEntries();
                for (var lp = entries[
                  _DYN_LENGTH$1
                  /* @min:%2elength */
                ] - 1; lp >= 0; lp--) {
                  var entry = entries[lp];
                  if (entry) {
                    if (entry.entryType === "resource") {
                      if (entry.initiatorType === initiatorType && (_indexOf(entry[
                        _DYN_NAME
                        /* @min:%2ename */
                      ], requestUrl) !== -1 || _indexOf(requestUrl, entry[
                        _DYN_NAME
                        /* @min:%2ename */
                      ]) !== -1)) {
                        perfTiming = entry;
                      }
                    } else if (entry.entryType === "mark" && entry[
                      _DYN_NAME
                      /* @min:%2ename */
                    ] === perfMark[
                      _DYN_NAME
                      /* @min:%2ename */
                    ]) {
                      ajaxData[
                        _DYN_PERF_TIMING
                        /* @min:%2eperfTiming */
                      ] = perfTiming;
                      break;
                    }
                    if (entry[
                      _DYN_START_TIME
                      /* @min:%2estartTime */
                    ] < perfMark[
                      _DYN_START_TIME
                      /* @min:%2estartTime */
                    ] - 1e3) {
                      break;
                    }
                  }
                }
              }
              if (!perfMark || // - we don't have a perfMark or
              ajaxData[
                _DYN_PERF_TIMING
                /* @min:%2eperfTiming */
              ] || // - we have not found the perf entry or
              attempt >= maxAttempts || // - we have tried too many attempts or
              ajaxData.async === false) {
                if (perfMark && isFunction$3(performance.clearMarks)) {
                  performance.clearMarks(perfMark[
                    _DYN_NAME
                    /* @min:%2ename */
                  ]);
                }
                ajaxData.perfAttempts = attempt;
                trackCallback();
              } else {
                scheduleTimeout(locateResourceTiming, retryDelay);
              }
            } catch (e) {
              reportError(e);
            }
          })();
        }
        function _createFetchRecord(input, init) {
          var _a2;
          var distributedTraceCtx = _getDistributedTraceCtx();
          var traceID = distributedTraceCtx && distributedTraceCtx[
            _DYN_GET_TRACE_ID
            /* @min:%2egetTraceId */
          ]() || generateW3CId();
          var spanID = strSubstr(generateW3CId(), 0, 16);
          var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog](), (_a2 = _self.core) === null || _a2 === undefined ? undefined : _a2.getTraceCtx());
          ajaxData[
            _DYN_TRACE_FLAGS
            /* @min:%2etraceFlags */
          ] = distributedTraceCtx && distributedTraceCtx[
            _DYN_GET_TRACE_FLAGS
            /* @min:%2egetTraceFlags */
          ]();
          ajaxData[
            _DYN_REQUEST_SENT_TIME
            /* @min:%2erequestSentTime */
          ] = dateTimeUtilsNow();
          ajaxData[
            _DYN_ERROR_STATUS_TEXT
            /* @min:%2eerrorStatusText */
          ] = _enableAjaxErrorStatusText;
          var requestUrl;
          if (input instanceof Request) {
            requestUrl = (input || {}).url || "";
          } else {
            requestUrl = input;
          }
          if (requestUrl === "") {
            var location_1 = getLocation$1();
            if (location_1 && location_1.href) {
              requestUrl = strSplit(location_1.href, "#")[0];
            }
          }
          ajaxData[
            _DYN_REQUEST_URL
            /* @min:%2erequestUrl */
          ] = requestUrl;
          var method = "GET";
          if (init && init[
            _DYN_METHOD
            /* @min:%2emethod */
          ]) {
            method = init[
              _DYN_METHOD
              /* @min:%2emethod */
            ];
          } else if (input && input instanceof Request) {
            method = input[
              _DYN_METHOD
              /* @min:%2emethod */
            ];
          }
          ajaxData[
            _DYN_METHOD
            /* @min:%2emethod */
          ] = method;
          var requestHeaders = {};
          if (_enableRequestHeaderTracking) {
            var headers = new Headers((init ? init[
              _DYN_HEADERS
              /* @min:%2eheaders */
            ] : 0) || (input instanceof Request ? input[
              _DYN_HEADERS
              /* @min:%2eheaders */
            ] || {} : {}));
            headers.forEach(function(value, key) {
              if (_canIncludeHeaders(key)) {
                requestHeaders[key] = value;
              }
            });
          }
          ajaxData[
            _DYN_REQUEST_HEADERS
            /* @min:%2erequestHeaders */
          ] = requestHeaders;
          _createMarkId(STR_FETCH, ajaxData);
          return ajaxData;
        }
        function _getFailedFetchDiagnosticsMessage(input) {
          var result = "";
          try {
            if (!isNullOrUndefined(input)) {
              if (typeof input === "string") {
                result += "(url: '".concat(input, "')");
              } else {
                result += "(url: '".concat(input.url, "')");
              }
            }
          } catch (e) {
            _throwInternalCritical(_self, 15, "Failed to grab failed fetch diagnostics message", { exception: dumpObj(e) });
          }
          return result;
        }
        function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
          if (!ajaxData) {
            return;
          }
          function _reportFetchError(msgId, e, failedProps) {
            var errorProps = failedProps || {};
            errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
            if (e) {
              errorProps["exception"] = dumpObj(e);
            }
            _throwInternalWarning(_self, msgId, FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + ERROR_NOT_SENT, errorProps);
          }
          ajaxData[
            _DYN_RESPONSE_FINISHED_TI14
            /* @min:%2eresponseFinishedTime */
          ] = dateTimeUtilsNow();
          ajaxData[
            _DYN_STATUS
            /* @min:%2estatus */
          ] = status;
          _findPerfResourceEntry(STR_FETCH, ajaxData, function() {
            var dependency = ajaxData[
              _DYN__CREATE_TRACK_ITEM
              /* @min:%2eCreateTrackItem */
            ]("Fetch", _enableRequestHeaderTracking, getResponse);
            var properties2;
            try {
              if (!!_addRequestContext) {
                properties2 = _addRequestContext({ status, request: input, response });
              }
            } catch (e) {
              _throwInternalWarning(_self, 104, CUSTOM_REQUEST_CONTEXT_ERROR);
            }
            if (dependency) {
              if (properties2 !== void 0) {
                dependency[
                  STR_PROPERTIES
                  /* @min:%2eproperties */
                ] = __assignFn(__assignFn({}, dependency.properties), properties2);
              }
              var sysProperties = ajaxData[
                _DYN_GET_PART_APROPS
                /* @min:%2egetPartAProps */
              ]();
              _reportDependencyInternal(_dependencyInitializers, _self[
                _DYN_CORE
                /* @min:%2ecore */
              ], ajaxData, dependency, null, sysProperties);
            } else {
              _reportFetchError(14, null, {
                requestSentTime: ajaxData[
                  _DYN_REQUEST_SENT_TIME
                  /* @min:%2erequestSentTime */
                ],
                responseFinishedTime: ajaxData[
                  _DYN_RESPONSE_FINISHED_TI14
                  /* @min:%2eresponseFinishedTime */
                ]
              });
            }
          }, function(e) {
            _reportFetchError(18, e, null);
          });
        }
        function _getFetchCorrelationContext(response) {
          var _a2;
          if (response && response[
            _DYN_HEADERS
            /* @min:%2eheaders */
          ]) {
            try {
              var responseHeader = response[
                _DYN_HEADERS
                /* @min:%2eheaders */
              ].get(RequestHeaders[
                0
                /* eRequestHeaders.requestContextHeader */
              ]);
              return correlationIdGetCorrelationContext(responseHeader);
            } catch (e) {
              _throwInternalWarning(_self, 18, CORRELATION_HEADER_ERROR, (_a2 = {
                fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response)
              }, _a2[
                _DYN_EXCEPTION
                /* @min:exception */
              ] = dumpObj(e), _a2));
            }
          }
        }
        function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
          var _a2;
          var result = true;
          var initializersCount = initializers[
            _DYN_LENGTH$1
            /* @min:%2elength */
          ];
          if (initializersCount > 0) {
            var details = (_a2 = {
              item: dependency
            }, _a2[
              STR_PROPERTIES
              /* @min:properties */
            ] = properties, _a2.sysProperties = systemProperties, _a2.context = ajaxData ? ajaxData[
              _DYN_CONTEXT$1
              /* @min:%2econtext */
            ] : null, _a2.aborted = ajaxData ? !!ajaxData[
              _DYN_ABORTED
              /* @min:%2eaborted */
            ] : false, _a2);
            result = _processDependencyContainer(core, initializers, details, "initializer");
          }
          if (result) {
            _self[
              _DYN_TRACK_DEPENDENCY_DAT3
              /* @min:%2etrackDependencyDataInternal */
            ](dependency, properties, systemProperties);
          }
        }
      });
      return _this;
    }
    AjaxMonitor2.prototype.processTelemetry = function(item, itemCtx) {
      this.processNext(item, itemCtx);
    };
    AjaxMonitor2.prototype.addDependencyInitializer = function(dependencyInitializer) {
      return null;
    };
    AjaxMonitor2.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor2;
  }(BaseTelemetryPlugin)
);

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Version = '3.1.1';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = onConfigChange((config), function () {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
var _DYN_UPDATE = "update"; // Count: 4
var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
var _DYN_TELEMETRY_TRACE = "telemetryTrace"; // Count: 3
var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext"; // Count: 2
var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
var _DYN_APPLY_USER_CONTEXT = "applyUserContext"; // Count: 2
var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
var _DYN_ACCOUNT_ID = "accountId"; // Count: 7
var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
var _DYN_NAME_PREFIX = "namePrefix"; // Count: 3
var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 2
var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix"; // Count: 2
var _DYN_ID_LENGTH = "idLength"; // Count: 4
var _DYN_GET_NEW_ID = "getNewId"; // Count: 3
var _DYN_LENGTH = "length"; // Count: 4
var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 5
var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
var _DYN_JOIN = "join"; // Count: 5
var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
var _DYN_AUTH_USER_COOKIE_NAM7 = "authUserCookieName"; // Count: 3

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var SESSION_COOKIE_NAME = "ai_session";
var ACQUISITION_SPAN = 86400000; // 24 hours in ms
var RENEWAL_SPAN = 1800000; // 30 minutes in ms
var COOKIE_UPDATE_INTERVAL = 60000; // 1 minute in ms
var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());
var _SessionManager = /** @class */ (function () {
    function _SessionManager(config, core, unloadHookContainer) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _sessionExpirationMs;
        var _sessionRenewalMs;
        dynamicProto(_SessionManager, self, function (_self) {
            if (!config) {
                config = {};
            }
            var unloadHook = onConfigChange(config, function (details) {
                _sessionExpirationMs = config.sessionExpirationMs || ACQUISITION_SPAN;
                _sessionRenewalMs = config.sessionRenewalMs || RENEWAL_SPAN;
                // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
                var sessionCookiePostfix = config.sessionCookiePostfix || config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "";
                _storageNamePrefix = SESSION_COOKIE_NAME + sessionCookiePostfix;
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */] = new Session();
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function () {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = utcNow();
                var isExpired = false;
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                if (!session.id) {
                    isExpired = !_initializeAutomaticSession(session);
                }
                if (!isExpired && _sessionExpirationMs > 0) {
                    var timeSinceAcqMs = nowMs - session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                    var timeSinceRenewalMs = nowMs - session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > _sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > _sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) {
                    // update automaticSession so session state has correct id
                    _renew(nowMs);
                }
                else {
                    // do not update the cookie more often than cookieUpdateInterval
                    if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > COOKIE_UPDATE_INTERVAL) {
                        _setCookie(session, nowMs);
                    }
                }
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */
            _self.backup = function () {
                var session = _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                _setStorage(session.id, session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */], session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix);
                if (cookieValue && isFunction$3(cookieValue.split)) {
                    isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                }
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix);
                    if (storageValue) {
                        isValid = _initializeAutomaticSessionWithData(session, storageValue);
                    }
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[_DYN_LENGTH /* @min:%2elength */] >= 2) {
                    try {
                        var acqMs = +tokens[1] || 0;
                        var renewalMs = +tokens[2] || 0;
                        if (isNaN(acqMs) || acqMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session acquisition date is 0" + sessionReset);
                        }
                        else if (isNaN(renewalMs) || renewalMs <= 0) {
                            _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 27 /* _eInternalMessageId.SessionRenewalDateIsZero */, "AI session renewal date is 0" + sessionReset);
                        }
                        else if (tokens[0]) {
                            // Everything looks valid so set the values
                            session.id = tokens[0];
                            session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = acqMs;
                            session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = renewalMs;
                            isValid = true;
                        }
                    }
                    catch (e) {
                        _throwInternal(_logger, 1 /* eLoggingSeverity.CRITICAL */, 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: dumpObj(e) });
                    }
                }
                return isValid;
            }
            function _renew(nowMs) {
                var getNewId = config[_DYN_GET_NEW_ID /* @min:%2egetNewId */] || newId;
                _self.automaticSession.id = getNewId(config[_DYN_ID_LENGTH /* @min:%2eidLength */] || 22);
                _self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */][_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */] = nowMs;
                _setCookie(_self[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!utlCanUseLocalStorage()) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */, "Browser does not support local storage. Session durations will be inaccurate.");
                }
            }
            function _setCookie(session, nowMs) {
                var acq = session[_DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */];
                session[_DYN_RENEWAL_DATE /* @min:%2erenewalDate */] = nowMs;
                var renewalPeriodMs = _sessionRenewalMs;
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = (acq + _sessionExpirationMs) - nowMs;
                var cookie = [session.id, acq, nowMs];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) {
                    maxAgeSec = acqTimeLeftMs / 1000;
                }
                else {
                    maxAgeSec = renewalPeriodMs / 1000;
                }
                var cookieDomain = config.cookieDomain || null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix, cookie[_DYN_JOIN /* @min:%2ejoin */]("|"), _sessionExpirationMs > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                utlSetLocalStorage(_logger, _storageNamePrefix, [guid, acq, renewal][_DYN_JOIN /* @min:%2ejoin */]("|"));
            }
        });
    }
// Removed Stub for _SessionManager.prototype.update.
// Removed Stub for _SessionManager.prototype.backup.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    _SessionManager.__ieDyn=1;

    return _SessionManager;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var TelemetryTrace = /** @class */ (function () {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || generateW3CId();
        _self.parentID = parentId;
        var location = getLocation$1();
        if (!name && location && location.pathname) {
            name = location.pathname;
        }
        _self.name = dataSanitizeString(logger, name);
    }
    return TelemetryTrace;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

function _validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" ||
        !id ||
        id.match(/,|;|=| |\|/)) {
        return false;
    }
    return true;
}
var User = /** @class */ (function () {
    function User(config, core, unloadHookContainer) {
        /**
         * A flag indicating whether this represents a new user
         */
        this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */
        this.isUserCookieSet = false;
        var _logger = safeGetLogger(core);
        var _cookieManager = safeGetCookieMgr(core);
        var _storageNamePrefix;
        dynamicProto(User, this, function (_self) {
            // Define _self.config
            objDefine(_self, "config", {
                g: function () { return config; }
            });
            var unloadHook = onConfigChange(config, function () {
                var userCookiePostfix = config[_DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */] || "";
                _storageNamePrefix = User.userCookieName + userCookiePostfix;
                // get userId or create new one if none exists
                var cookie = _cookieManager.get(_storageNamePrefix);
                if (cookie) {
                    _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                    var params = cookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (params[_DYN_LENGTH /* @min:%2elength */] > 0) {
                        _self.id = params[0];
                        // we already have a cookie
                        _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = !!_self.id;
                    }
                }
                if (!_self.id) {
                    _self.id = _generateNewId();
                    var newCookie = _generateNewCookie(_self.id);
                    _setUserCookie(newCookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                    // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                    // We should respect their wishes and clear ourselves from local storage
                    var name_1 = (config[_DYN_NAME_PREFIX /* @min:%2enamePrefix */] || "") + "ai_session";
                    utlRemoveStorage(_logger, name_1);
                }
                // We still take the account id from the ctor param for backward compatibility.
                // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = config[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] || undefined;
                // Get the auth user id and account id from the cookie if exists
                // Cookie is in the pattern: <authenticatedId>|<accountId>
                var authCookie = _cookieManager.get(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
                if (authCookie) {
                    authCookie = decodeURI(authCookie);
                    var authCookieString = authCookie.split(User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                    if (authCookieString[0]) {
                        _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authCookieString[0];
                    }
                    if (authCookieString[_DYN_LENGTH /* @min:%2elength */] > 1 && authCookieString[1]) {
                        _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = authCookieString[1];
                    }
                }
            });
            unloadHookContainer && unloadHookContainer.add(unloadHook);
            function _generateNewId() {
                var theConfig = (config || {});
                var getNewId = theConfig[_DYN_GET_NEW_ID /* @min:%2egetNewId */] || newId;
                var id = getNewId(theConfig[_DYN_ID_LENGTH /* @min:%2eidLength */] ? config[_DYN_ID_LENGTH /* @min:%2eidLength */] : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = toISOString$2(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = true;
                var newCookie = [userId, acqStr];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */] = _cookieManager.set(_storageNamePrefix, cookie, oneYear);
            }
            _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === undefined) { storeInCookie = false; }
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                if (isInvalidInput) {
                    _throwInternal(_logger, 2 /* eLoggingSeverity.WARNING */, 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */, "Setting auth user context failed. " +
                        "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = authenticatedUserId;
                var authCookie = _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */];
                if (accountId) {
                    _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = accountId;
                    authCookie = [_self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], _self.accountId][_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]);
                }
                if (storeInCookie) {
                    // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                    // Encoding the cookie to handle unexpected unicode characters.
                    _cookieManager.set(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */], encodeURI(authCookie));
                }
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */
            _self.clearAuthenticatedUserContext = function () {
                _self[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */] = null;
                _self[_DYN_ACCOUNT_ID /* @min:%2eaccountId */] = null;
                _cookieManager.del(User[_DYN_AUTH_USER_COOKIE_NAM7 /* @min:%2eauthUserCookieName */]);
            };
            _self[_DYN_UPDATE /* @min:%2eupdate */] = function (userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[_DYN_JOIN /* @min:%2ejoin */](User[_DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */]));
                }
            };
        });
    }
// Removed Stub for User.prototype.setAuthenticatedUserContext.
// Removed Stub for User.prototype.clearAuthenticatedUserContext.
// Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/
var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
    if (target && target[name] && objKeys(target[name])[_DYN_LENGTH /* @min:%2elength */] === 0) {
        delete target[name];
    }
}
function _nullResult() {
    return null;
}
var TelemetryContext = /** @class */ (function () {
    function TelemetryContext(core, defaultConfig, previousTraceCtx, unloadHookContainer) {
        var _this = this;
        var logger = core.logger;
        dynamicProto(TelemetryContext, this, function (_self) {
            _self.appId = _nullResult;
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = _nullResult;
            _self.application = new Application();
            _self.internal = new Internal(defaultConfig, unloadHookContainer);
            if (hasWindow()) {
                _self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] = new _SessionManager(defaultConfig, core, unloadHookContainer);
                _self.device = new Device();
                _self.location = new Location();
                _self.user = new User(defaultConfig, core, unloadHookContainer);
                var traceId = undefined;
                var parentId = undefined;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */] = new TelemetryTrace(traceId, parentId, name_1, logger);
                _self.session = new Session();
            }
            _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */] = function () {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && isString$2(session.id)) {
                    sesId = session.id;
                }
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[_DYN_SESSION_MANAGER /* @min:%2esessionManager */] || {})[_DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */];
                    sesId = autoSession && isString$2(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */] = function (evt, itemCtx) {
                setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", _self[_DYN_GET_SESSION_ID /* @min:%2egetSessionId */](), isString$2);
            };
            _self[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */] = function (evt, itemCtx) {
                setValue(evt.ext, Extensions.OSExt, _self.os);
            };
            _self[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */] = function (evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString$2);
                    setValue(tags, CtxTagKeys.applicationBuild, application.build, isString$2);
                }
            };
            _self[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */] = function (evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
                    setValue(extDevice, "localId", device.id, isString$2);
                    setValue(extDevice, "ip", device.ip, isString$2);
                    setValue(extDevice, "model", device.model, isString$2);
                    setValue(extDevice, "deviceClass", device.deviceClass, isString$2);
                }
            };
            _self[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */] = function (evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = getSetValue(evt, strTags);
                    setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString$2); // not mapped in CS 4.0
                    setValue(tags, CtxTagKeys.internalSdkVersion, dataSanitizeString(logger, internal.sdkVersion, 64), isString$2);
                    if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
                        setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString$2);
                        setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString$2);
                    }
                }
            };
            _self[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */] = function (evt, itemCtx) {
                var location = _this.location;
                if (location) {
                    setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString$2);
                }
            };
            _self[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */] = function (evt, itemCtx) {
                var telemetryTrace = _self[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */];
                if (telemetryTrace) {
                    var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: undefined, parentID: undefined });
                    setValue(extTrace, "traceID", telemetryTrace.traceID, isString$2, isNullOrUndefined);
                    setValue(extTrace, "name", telemetryTrace.name, isString$2, isNullOrUndefined);
                    setValue(extTrace, "parentID", telemetryTrace.parentID, isString$2, isNullOrUndefined);
                }
            };
            _self.applyWebContext = function (evt, itemCtx) {
                var web = _this.web;
                if (web) {
                    setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
                }
            };
            _self[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */] = function (evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = getSetValue(evt, strTags, []);
                    // stays in tags
                    setValue(tags, CtxTagKeys.userAccountId, user[_DYN_ACCOUNT_ID /* @min:%2eaccountId */], isString$2);
                    // CS 4.0
                    var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
                    setValue(extUser, "id", user.id, isString$2);
                    setValue(extUser, "authId", user[_DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */], isString$2);
                }
            };
            _self.cleanUp = function (evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    _removeEmpty(ext, Extensions.DeviceExt);
                    _removeEmpty(ext, Extensions.UserExt);
                    _removeEmpty(ext, Extensions.WebExt);
                    _removeEmpty(ext, Extensions.OSExt);
                    _removeEmpty(ext, Extensions.AppExt);
                    _removeEmpty(ext, Extensions.TraceExt);
                }
            };
        });
    }
// Removed Stub for TelemetryContext.prototype.applySessionContext.
// Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
// Removed Stub for TelemetryContext.prototype.applyApplicationContext.
// Removed Stub for TelemetryContext.prototype.applyDeviceContext.
// Removed Stub for TelemetryContext.prototype.applyInternalContext.
// Removed Stub for TelemetryContext.prototype.applyLocationContext.
// Removed Stub for TelemetryContext.prototype.applyOperationContext.
// Removed Stub for TelemetryContext.prototype.applyWebContext.
// Removed Stub for TelemetryContext.prototype.applyUserContext.
// Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    TelemetryContext.__ieDyn=1;

    return TelemetryContext;
}());

/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/
var _a$2;
var undefString;
var nullValue = null;
var _defaultConfig = objDeepFreeze((_a$2 = {},
    _a$2[_DYN_ACCOUNT_ID /* @min:accountId */] = nullValue,
    _a$2.sessionRenewalMs = 30 * 60 * 1000,
    _a$2.samplingPercentage = 100,
    _a$2.sessionExpirationMs = 24 * 60 * 60 * 1000,
    _a$2.cookieDomain = nullValue,
    _a$2.sdkExtension = nullValue,
    _a$2.isBrowserLinkTrackingEnabled = false,
    _a$2.appId = nullValue,
    _a$2[_DYN_GET_SESSION_ID /* @min:getSessionId */] = nullValue,
    _a$2[_DYN_NAME_PREFIX /* @min:namePrefix */] = undefString,
    _a$2[_DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */] = undefString,
    _a$2[_DYN_USER_COOKIE_POSTFIX /* @min:userCookiePostfix */] = undefString,
    _a$2[_DYN_ID_LENGTH /* @min:idLength */] = 22,
    _a$2[_DYN_GET_NEW_ID /* @min:getNewId */] = nullValue,
    _a$2));
var PropertiesPlugin = /** @class */ (function (_super) {
    __extendsFn(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = PropertiesPluginIdentifier;
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        var _context;
        var _disableUserInitMessage;
        dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
            _initDefaults();
            objDefine(_self, "context", {
                g: function () {
                    return _context;
                }
            });
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event - The event that needs to be processed
             */
            _self.processTelemetry = function (event, itemCtx) {
                if (!isNullOrUndefined(event)) {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === PageView.envelopeType) {
                        itemCtx.diagLog().resetInternalMessageCount();
                    }
                    var theContext = (_context || {});
                    if (theContext.session) {
                        // If customer did not provide custom session id update the session manager
                        if (typeof _context.session.id !== "string" && theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */]) {
                            theContext[_DYN_SESSION_MANAGER /* @min:%2esessionManager */][_DYN_UPDATE /* @min:%2eupdate */]();
                        }
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[_DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */]) {
                        userCtx[_DYN_UPDATE /* @min:%2eupdate */](theContext.user.id);
                    }
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */]) {
                        userCtx[_DYN_IS_NEW_USER /* @min:%2eisNewUser */] = false;
                        if (!_disableUserInitMessage) {
                            var message = new _InternalLogMessage(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */, ((getNavigator() || {}).userAgent || ""));
                            _logInternalMessage(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, message);
                        }
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */]) {
                    var traceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
                    if (traceCtx === _distributedTraceCtx) {
                        core.setTraceCtx(_previousTraceCtx);
                    }
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
                _context = null;
                _disableUserInitMessage = true;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                // This function will be re-called whenever any referenced configuration is changed
                _self._addHook(onConfigChange(config, function () {
                    var ctx = createProcessTelemetryContext(null, config, core);
                    if (config.storagePrefix) {
                        utlSetStoragePrefix(config.storagePrefix);
                    }
                    _disableUserInitMessage = config.disableUserInitMessage === false ? false : true;
                    _extensionConfig = ctx.getExtCfg(identifier, _defaultConfig);
                    // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                    _self["_extConfig"] = _extensionConfig;
                }));
                // This is outside of the onConfigChange as we don't want to update (replace) these values whenever a referenced config item changes
                _previousTraceCtx = core[_DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */](false);
                _context = new TelemetryContext(core, _extensionConfig, _previousTraceCtx, _self._unloadHooks);
                _distributedTraceCtx = createDistributedTraceContextFromTrace(_self.context[_DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function () {
                    var breezeChannel = core.getPlugin(BreezeChannelIdentifier);
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                getSetValue(evt, "tags", []);
                getSetValue(evt, "ext", {});
                var ctx = _self.context;
                ctx[_DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */](evt, itemCtx);
                ctx[_DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */](evt, itemCtx);
                ctx[_DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */](evt, itemCtx);
                ctx[_DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */](evt, itemCtx);
                ctx[_DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */](evt, itemCtx);
                ctx[_DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[_DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */](evt, itemCtx); // legacy tags
                ctx[_DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PropertiesPlugin.__ieDyn=1;

    return PropertiesPlugin;
}(BaseTelemetryPlugin));

/*
 * Application Insights JavaScript SDK - Web, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting IE/ES5 this will export a mutable variables that someone could change ###
// ###################################################################################################################################################
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var _AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var _TRACK = "track";
var STR_SNIPPET = "snippet";
var STR_GET_COOKIE_MGR = "getCookieMgr";
var STR_START_TRACK_PAGE = "startTrackPage";
var STR_STOP_TRACK_PAGE = "stopTrackPage";
var STR_FLUSH = "flush";
var STR_START_TRACK_EVENT = "startTrackEvent";
var STR_STOP_TRACK_EVENT = "stopTrackEvent";
var STR_ADD_TELEMETRY_INITIALIZER = "addTelemetryInitializer";
var STR_POLL_INTERNAL_LOGS = "pollInternalLogs";
var STR_GET_PLUGIN = "getPlugin";
var STR_EVT_NAMESPACE = "evtNamespace";
var STR_TRACK_EVENT = _TRACK + "Event";
var STR_TRACK_TRACE = _TRACK + "Trace";
var STR_TRACK_METRIC = _TRACK + "Metric";
var STR_TRACK_PAGE_VIEW = _TRACK + "PageView";
var STR_TRACK_EXCEPTION = _TRACK + "Exception";
var STR_TRACK_DEPENDENCY_DATA = _TRACK + "DependencyData";
var STR_SET_AUTHENTICATED_USER_CONTEXT = "set" + _AUTHENTICATED_USER_CONTEXT;
var STR_CLEAR_AUTHENTICATED_USER_CONTEXT = "clear" + _AUTHENTICATED_USER_CONTEXT;

/*
 * Application Insights JavaScript SDK - Web, 3.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var _DYN_VERSION = "version"; // Count: 6
var _DYN_QUEUE = "queue"; // Count: 6
var _DYN_CONNECTION_STRING = "connectionString"; // Count: 4
var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 4
var _DYN_USER_OVERRIDE_ENDPOI0 = "userOverrideEndpointUrl"; // Count: 5
var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 3
var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
var _DYN_CONTEXT = "context"; // Count: 5
var _DYN_ADD_HOUSEKEEPING_BEF1 = "addHousekeepingBeforeUnload"; // Count: 2
var _DYN_SEND_MESSAGE = "sendMessage"; // Count: 3
var _DYN_UPDATE_SNIPPET_DEFIN2 = "updateSnippetDefinitions"; // Count: 2

var _a$1, _b, _c;
var _internalSdkSrc;
var _ignoreUpdateSnippetProperties = [
  STR_SNIPPET,
  "dependencies",
  "properties",
  "_snippetVersion",
  "appInsightsNew",
  "getSKUDefaults"
];
var IKEY_USAGE = "iKeyUsage";
var CDN_USAGE = "CdnUsage";
var SDK_LOADER_VER = "SdkLoaderVer";
var UNDEFINED_VALUE = undefined;
var default_limit = {
  samplingRate: 100,
  maxSendNumber: 1
};
var default_interval = {
  monthInterval: 3,
  daysOfMonth: [28]
};
var default_throttle_config = {
  disabled: true,
  limit: cfgDfMerge(default_limit),
  interval: cfgDfMerge(default_interval)
};
var defaultConfigValues = (_a$1 = {}, _a$1[
  _DYN_CONNECTION_STRING
  /* @min:connectionString */
] = UNDEFINED_VALUE, _a$1[
  _DYN_ENDPOINT_URL
  /* @min:endpointUrl */
] = UNDEFINED_VALUE, _a$1[
  _DYN_INSTRUMENTATION_KEY
  /* @min:instrumentationKey */
] = UNDEFINED_VALUE, _a$1[
  _DYN_USER_OVERRIDE_ENDPOI0
  /* @min:userOverrideEndpointUrl */
] = UNDEFINED_VALUE, _a$1.diagnosticLogInterval = cfgDfValidate(_chkDiagLevel, 1e4), _a$1.featureOptIn = (_b = {}, _b[IKEY_USAGE] = {
  mode: 2
  /* FeatureOptInMode.disable */
}, _b[CDN_USAGE] = {
  mode: 2
  /* FeatureOptInMode.disable */
}, _b[SDK_LOADER_VER] = {
  mode: 2
  /* FeatureOptInMode.disable */
}, _b), _a$1.throttleMgrCfg = cfgDfMerge((_c = {}, _c[
  109
  /* _eInternalMessageId.DefaultThrottleMsgKey */
] = cfgDfMerge(default_throttle_config), _c[
  106
  /* _eInternalMessageId.InstrumentationKeyDeprecation */
] = cfgDfMerge(default_throttle_config), _c[
  111
  /* _eInternalMessageId.SdkLdrUpdate */
] = cfgDfMerge(default_throttle_config), _c[
  110
  /* _eInternalMessageId.CdnDeprecation */
] = cfgDfMerge(default_throttle_config), _c)), _a$1);
function _chkDiagLevel(value) {
  return value && value > 0;
}
var AppInsightsSku = (
  /** @class */
  function() {
    function AppInsightsSku2(snippet) {
      var _this = this;
      var dependencies;
      var properties;
      var _sender;
      var _snippetVersion;
      var _evtNamespace;
      var _houseKeepingNamespace;
      var _core;
      var _config;
      var _analyticsPlugin;
      var _cfgSyncPlugin;
      var _throttleMgr;
      var _iKeySentMessage;
      var _cdnSentMessage;
      var _sdkVerSentMessage;
      dynamicProto(AppInsightsSku2, this, function(_self) {
        _initDefaults();
        objDefine(_self, "config", {
          g: function() {
            return _config;
          }
        });
        arrForEach(["pluginVersionStringArr", "pluginVersionString"], function(key) {
          objDefine(_self, key, {
            g: function() {
              if (_core) {
                return _core[key];
              }
              return null;
            }
          });
        });
        _snippetVersion = "" + (snippet.sv || snippet[
          _DYN_VERSION
          /* @min:%2eversion */
        ] || "");
        snippet[
          _DYN_QUEUE
          /* @min:%2equeue */
        ] = snippet[
          _DYN_QUEUE
          /* @min:%2equeue */
        ] || [];
        snippet[
          _DYN_VERSION
          /* @min:%2eversion */
        ] = snippet[
          _DYN_VERSION
          /* @min:%2eversion */
        ] || 2;
        var cfgHandler = createDynamicConfig(snippet.config || {}, defaultConfigValues);
        _config = cfgHandler.cfg;
        _analyticsPlugin = new AnalyticsPlugin();
        objDefine(_self, "appInsights", {
          g: function() {
            return _analyticsPlugin;
          }
        });
        properties = new PropertiesPlugin();
        dependencies = new AjaxMonitor();
        _sender = new Sender();
        _core = new AppInsightsCore();
        objDefine(_self, "core", {
          g: function() {
            return _core;
          }
        });
        _addUnloadHook(onConfigChange(cfgHandler, function() {
          if (_config[
            _DYN_CONNECTION_STRING
            /* @min:%2econnectionString */
          ]) {
            var cs = parseConnectionString(_config[
              _DYN_CONNECTION_STRING
              /* @min:%2econnectionString */
            ]);
            var ingest = cs.ingestionendpoint;
            _config[
              _DYN_ENDPOINT_URL
              /* @min:%2eendpointUrl */
            ] = _config[
              _DYN_USER_OVERRIDE_ENDPOI0
              /* @min:%2euserOverrideEndpointUrl */
            ] ? _config[
              _DYN_USER_OVERRIDE_ENDPOI0
              /* @min:%2euserOverrideEndpointUrl */
            ] : ingest + DEFAULT_BREEZE_PATH;
            _config[
              _DYN_INSTRUMENTATION_KEY
              /* @min:%2einstrumentationKey */
            ] = cs.instrumentationkey || _config[
              _DYN_INSTRUMENTATION_KEY
              /* @min:%2einstrumentationKey */
            ];
          }
          _config[
            _DYN_ENDPOINT_URL
            /* @min:%2eendpointUrl */
          ] = _config[
            _DYN_USER_OVERRIDE_ENDPOI0
            /* @min:%2euserOverrideEndpointUrl */
          ] ? _config[
            _DYN_USER_OVERRIDE_ENDPOI0
            /* @min:%2euserOverrideEndpointUrl */
          ] : _config[
            _DYN_ENDPOINT_URL
            /* @min:%2eendpointUrl */
          ];
        }));
        _self[
          STR_SNIPPET
          /* @min:%2esnippet */
        ] = snippet;
        _self[
          STR_FLUSH
          /* @min:%2eflush */
        ] = function(async, callBack) {
          if (async === undefined) {
            async = true;
          }
          var result;
          doPerf(_core, function() {
            return "AISKU.flush";
          }, function() {
            if (async && !callBack) {
              result = createPromise(function(resolve) {
                callBack = resolve;
              });
            }
            var waiting = 1;
            var flushDone = function() {
              waiting--;
              if (waiting === 0) {
                callBack();
              }
            };
            arrForEach(_core.getChannels(), function(channel) {
              if (channel) {
                waiting++;
                channel[
                  STR_FLUSH
                  /* @min:%2eflush */
                ](async, flushDone);
              }
            });
            flushDone();
          }, null, async);
          return result;
        };
        _self[
          _DYN_ONUNLOAD_FLUSH
          /* @min:%2eonunloadFlush */
        ] = function(async) {
          if (async === undefined) {
            async = true;
          }
          arrForEach(_core.getChannels(), function(channel) {
            if (channel[
              _DYN_ONUNLOAD_FLUSH
              /* @min:%2eonunloadFlush */
            ]) {
              channel[
                _DYN_ONUNLOAD_FLUSH
                /* @min:%2eonunloadFlush */
              ]();
            } else {
              channel[
                STR_FLUSH
                /* @min:%2eflush */
              ](async);
            }
          });
        };
        _self.loadAppInsights = function(legacyMode, logger, notificationManager) {
          if (legacyMode === undefined) {
            legacyMode = false;
          }
          if (legacyMode) {
            throwUnsupported("Legacy Mode is no longer supported");
          }
          function _updateSnippetProperties(snippet2) {
            if (snippet2) {
              var snippetVer = "";
              if (!isNullOrUndefined(_snippetVersion)) {
                snippetVer += _snippetVersion;
              }
              if (_self[
                _DYN_CONTEXT
                /* @min:%2econtext */
              ] && _self[
                _DYN_CONTEXT
                /* @min:%2econtext */
              ].internal) {
                _self[
                  _DYN_CONTEXT
                  /* @min:%2econtext */
                ].internal.snippetVer = snippetVer || "-";
              }
              objForEachKey(_self, function(field, value) {
                if (isString$2(field) && !isFunction$3(value) && field && field[0] !== "_" && // Don't copy "internal" values
                arrIndexOf(_ignoreUpdateSnippetProperties, field) === -1) {
                  if (snippet2[field] !== value) {
                    snippet2[field] = value;
                  }
                }
              });
            }
          }
          doPerf(_self.core, function() {
            return "AISKU.loadAppInsights";
          }, function() {
            _core.initialize(_config, [_sender, properties, dependencies, _analyticsPlugin, _cfgSyncPlugin], logger, notificationManager);
            objDefine(_self, "context", {
              g: function() {
                return properties[
                  _DYN_CONTEXT
                  /* @min:%2econtext */
                ];
              }
            });
            if (!_throttleMgr) {
              _throttleMgr = new ThrottleMgr(_core);
            }
            var sdkSrc = _findSdkSourceFile();
            if (sdkSrc && _self[
              _DYN_CONTEXT
              /* @min:%2econtext */
            ]) {
              _self[
                _DYN_CONTEXT
                /* @min:%2econtext */
              ].internal.sdkSrc = sdkSrc;
            }
            _updateSnippetProperties(_self[
              STR_SNIPPET
              /* @min:%2esnippet */
            ]);
            _self.emptyQueue();
            _self[
              STR_POLL_INTERNAL_LOGS
              /* @min:%2epollInternalLogs */
            ]();
            _self[
              _DYN_ADD_HOUSEKEEPING_BEF1
              /* @min:%2eaddHousekeepingBeforeUnload */
            ](_self);
            _addUnloadHook(onConfigChange(cfgHandler, function() {
              var defaultEnable = false;
              if (_config.throttleMgrCfg[
                109
                /* _eInternalMessageId.DefaultThrottleMsgKey */
              ]) {
                defaultEnable = !_config.throttleMgrCfg[
                  109
                  /* _eInternalMessageId.DefaultThrottleMsgKey */
                ].disabled;
              }
              if (!_throttleMgr.isReady() && _config.extensionConfig && _config.extensionConfig[_cfgSyncPlugin.identifier] && defaultEnable) {
                _throttleMgr.onReadyState(true);
              }
              var result;
              if (!_iKeySentMessage && !_config[
                _DYN_CONNECTION_STRING
                /* @min:%2econnectionString */
              ] && isFeatureEnabled(IKEY_USAGE, _config)) {
                result = _throttleMgr[
                  _DYN_SEND_MESSAGE
                  /* @min:%2esendMessage */
                ](106, "See Instrumentation key support at aka.ms/IkeyMigrate");
                _iKeySentMessage = true;
              }
              if (!_cdnSentMessage && _self[
                _DYN_CONTEXT
                /* @min:%2econtext */
              ].internal.sdkSrc && _self[
                _DYN_CONTEXT
                /* @min:%2econtext */
              ].internal.sdkSrc.indexOf("az416426") != -1 && isFeatureEnabled(CDN_USAGE, _config)) {
                result = _throttleMgr[
                  _DYN_SEND_MESSAGE
                  /* @min:%2esendMessage */
                ](110, "See Cdn support notice at aka.ms/JsActiveCdn");
                _cdnSentMessage = true;
              }
              if (!_sdkVerSentMessage && parseInt(_snippetVersion) < 6 && isFeatureEnabled(SDK_LOADER_VER, _config)) {
                result = _throttleMgr[
                  _DYN_SEND_MESSAGE
                  /* @min:%2esendMessage */
                ](111, "An updated Sdk Loader is available, see aka.ms/SnippetVer");
                _sdkVerSentMessage = true;
              }
            }));
          });
          return _self;
        };
        _self[
          _DYN_UPDATE_SNIPPET_DEFIN2
          /* @min:%2eupdateSnippetDefinitions */
        ] = function(snippet2) {
          proxyAssign(snippet2, _self, function(name) {
            return name && arrIndexOf(_ignoreUpdateSnippetProperties, name) === -1;
          });
        };
        _self.emptyQueue = function() {
          try {
            if (isArray$3(_self.snippet[
              _DYN_QUEUE
              /* @min:%2equeue */
            ])) {
              var length_1 = _self.snippet[
                _DYN_QUEUE
                /* @min:%2equeue */
              ].length;
              for (var i = 0; i < length_1; i++) {
                var call = _self.snippet[
                  _DYN_QUEUE
                  /* @min:%2equeue */
                ][i];
                call();
              }
              _self.snippet[
                _DYN_QUEUE
                /* @min:%2equeue */
              ] = void 0;
              delete _self.snippet[
                _DYN_QUEUE
                /* @min:%2equeue */
              ];
            }
          } catch (exception) {
            var properties_1 = {};
            if (exception && isFunction$3(exception.toString)) {
              properties_1.exception = exception.toString();
            }
          }
        };
        _self[
          _DYN_ADD_HOUSEKEEPING_BEF1
          /* @min:%2eaddHousekeepingBeforeUnload */
        ] = function(appInsightsInstance) {
          if (hasWindow() || hasDocument()) {
            var performHousekeeping_1 = function() {
              appInsightsInstance[
                _DYN_ONUNLOAD_FLUSH
                /* @min:%2eonunloadFlush */
              ](false);
              if (isFunction$3(_self.core[
                STR_GET_PLUGIN
                /* @min:%2egetPlugin */
              ])) {
                var loadedPlugin = _this.core[
                  STR_GET_PLUGIN
                  /* @min:%2egetPlugin */
                ](PropertiesPluginIdentifier);
                if (loadedPlugin) {
                  var propertiesPlugin = loadedPlugin.plugin;
                  if (propertiesPlugin && propertiesPlugin[
                    _DYN_CONTEXT
                    /* @min:%2econtext */
                  ] && propertiesPlugin[
                    _DYN_CONTEXT
                    /* @min:%2econtext */
                  ]._sessionManager) {
                    propertiesPlugin[
                      _DYN_CONTEXT
                      /* @min:%2econtext */
                    ]._sessionManager.backup();
                  }
                }
              }
            };
            var added_1 = false;
            if (!_houseKeepingNamespace) {
              _houseKeepingNamespace = mergeEvtNamespace(_evtNamespace, _core[
                STR_EVT_NAMESPACE
                /* @min:%2eevtNamespace */
              ] && _core[
                STR_EVT_NAMESPACE
                /* @min:%2eevtNamespace */
              ]());
            }
            _addUnloadHook(onConfigChange(_config, function(details) {
              var coreConfig = details.cfg;
              var analyticsPlugin = appInsightsInstance.appInsights;
              var ctx = createProcessTelemetryContext(null, coreConfig, analyticsPlugin.core);
              var extConfig = ctx.getExtCfg(analyticsPlugin.identifier || AnalyticsPluginIdentifier);
              _removePageEventHandlers();
              var excludePageUnloadEvents = coreConfig.disablePageUnloadEvents;
              if (!extConfig.disableFlushOnBeforeUnload) {
                if (addPageUnloadEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                  added_1 = true;
                }
                if (addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace)) {
                  added_1 = true;
                }
                if (!added_1 && !isReactNative()) {
                  _throwInternal(_core.logger, 1, 19, "Could not add handler for beforeunload and pagehide");
                }
              }
              if (!added_1 && !extConfig.disableFlushOnUnload) {
                addPageHideEventListener(performHousekeeping_1, excludePageUnloadEvents, _houseKeepingNamespace);
              }
            }));
          }
        };
        _self.getSender = function() {
          return _sender;
        };
        _self.unload = function(isAsync, unloadComplete, cbTimeout) {
          var unloadDone = false;
          var result;
          if (isAsync && !unloadComplete) {
            result = createPromise(function(resolve) {
              unloadComplete = resolve;
            });
          }
          function _unloadCallback(unloadState) {
            if (!unloadDone) {
              unloadDone = true;
              _initDefaults();
              unloadComplete && unloadComplete(unloadState);
            }
          }
          _self[
            _DYN_ONUNLOAD_FLUSH
            /* @min:%2eonunloadFlush */
          ](isAsync);
          _removePageEventHandlers();
          _core.unload && _core.unload(isAsync, _unloadCallback, cbTimeout);
          return result;
        };
        proxyFunctions(_self, _analyticsPlugin, [
          STR_GET_COOKIE_MGR,
          STR_TRACK_EVENT,
          STR_TRACK_PAGE_VIEW,
          "trackPageViewPerformance",
          STR_TRACK_EXCEPTION,
          "_onerror",
          STR_TRACK_TRACE,
          STR_TRACK_METRIC,
          STR_START_TRACK_PAGE,
          STR_STOP_TRACK_PAGE,
          STR_START_TRACK_EVENT,
          STR_STOP_TRACK_EVENT
        ]);
        proxyFunctions(_self, _getCurrentDependencies, [
          STR_TRACK_DEPENDENCY_DATA,
          "addDependencyListener",
          "addDependencyInitializer"
        ]);
        proxyFunctions(_self, _core, [
          STR_ADD_TELEMETRY_INITIALIZER,
          STR_POLL_INTERNAL_LOGS,
          "stopPollingInternalLogs",
          STR_GET_PLUGIN,
          "addPlugin",
          STR_EVT_NAMESPACE,
          "addUnloadCb",
          "getTraceCtx",
          "updateCfg",
          "onCfgChange"
        ]);
        proxyFunctions(_self, function() {
          var context = properties[
            _DYN_CONTEXT
            /* @min:%2econtext */
          ];
          return context ? context.user : null;
        }, [
          STR_SET_AUTHENTICATED_USER_CONTEXT,
          STR_CLEAR_AUTHENTICATED_USER_CONTEXT
        ]);
        function _getCurrentDependencies() {
          return dependencies;
        }
        function _initDefaults() {
          _evtNamespace = createUniqueNamespace("AISKU");
          _houseKeepingNamespace = null;
          dependencies = null;
          properties = null;
          _sender = null;
          _snippetVersion = null;
          _throttleMgr = null;
          _iKeySentMessage = false;
          _cdnSentMessage = false;
          _sdkVerSentMessage = false;
          _cfgSyncPlugin = new CfgSyncPlugin();
        }
        function _removePageEventHandlers() {
          if (_houseKeepingNamespace) {
            removePageUnloadEventListener(null, _houseKeepingNamespace);
            removePageHideEventListener(null, _houseKeepingNamespace);
          }
        }
        function _addUnloadHook(hooks) {
          _core.addUnloadHook(hooks);
        }
      });
    }
    AppInsightsSku2.prototype.addDependencyInitializer = function(dependencyInitializer) {
      return null;
    };
    return AppInsightsSku2;
  }()
);
function _findSdkSourceFile() {
  if (_internalSdkSrc) {
    return _internalSdkSrc;
  }
  var sdkSrc = null;
  var isModule = false;
  var cdns = [
    "://js.monitor.azure.com/",
    "://az416426.vo.msecnd.net/"
  ];
  try {
    var scrpt = (document || {}).currentScript;
    if (scrpt) {
      sdkSrc = scrpt.src;
    }
  } catch (e) {
  }
  if (sdkSrc) {
    try {
      var url_1 = sdkSrc.toLowerCase();
      if (url_1) {
        var src_1 = "";
        arrForEach(cdns, function(value, idx) {
          if (strIndexOf(url_1, value) !== -1) {
            src_1 = "cdn" + (idx + 1);
            if (strIndexOf(url_1, "/scripts/") === -1) {
              if (strIndexOf(url_1, "/next/") !== -1) {
                src_1 += "-next";
              } else if (strIndexOf(url_1, "/beta/") !== -1) {
                src_1 += "-beta";
              }
            }
            _internalSdkSrc = src_1 + (isModule ? ".mod" : "");
            return -1;
          }
        });
      }
    } catch (e) {
    }
    _internalSdkSrc = sdkSrc;
  }
  return _internalSdkSrc;
}

/*
 * Application Insights JavaScript SDK - React Plugin, 17.1.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* ReactPlugin.ts
* @copyright Microsoft 2019
*/
var defaultReactExtensionConfig = objDeepFreeze({
    history: { blkVal: true, v: undefined }
});
var ReactPlugin = /** @class */ (function (_super) {
    __extendsFn(ReactPlugin, _super);
    function ReactPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 185;
        _this.identifier = 'ReactPlugin';
        var _analyticsPlugin;
        var _extensionConfig;
        var _unlisten;
        var _pageViewTimer;
        var _pageViewTracked;
        dynamicProto(ReactPlugin, _this, function (_self, _base) {
            _initDefaults();
            _self.initialize = function (config, core, extensions, pluginChain) {
                _super.prototype.initialize.call(_this, config, core, extensions, pluginChain);
                _self._addHook(onConfigChange(config, function (details) {
                    var _a;
                    var ctx = _self._getTelCtx();
                    _extensionConfig = ctx.getExtCfg(_this.identifier, defaultReactExtensionConfig);
                    _analyticsPlugin = (_a = core.getPlugin(AnalyticsPluginIdentifier)) === null || _a === undefined ? undefined : _a.plugin;
                    if (isFunction$3(_unlisten)) {
                        _unlisten();
                        _unlisten = null;
                    }
                    if (_extensionConfig.history) {
                        _addHistoryListener(_extensionConfig.history);
                        if (!_pageViewTracked) {
                            var pageViewTelemetry = {
                                uri: _extensionConfig.history.location.pathname
                            };
                            _self.trackPageView(pageViewTelemetry);
                            _pageViewTracked = true;
                        }
                    }
                }));
            };
            _self.getCookieMgr = function () {
                return safeGetCookieMgr(_self.core);
            };
            _self.getAppInsights = _getAnalytics;
            _self.processTelemetry = function (event, itemCtx) {
                _self.processNext(event, itemCtx);
            };
            _self._doTeardown = function (unloadCtx, unloadState, asyncCallback) {
                if (isFunction$3(_unlisten)) {
                    _unlisten();
                }
                if (_pageViewTimer) {
                    clearTimeout(_pageViewTimer);
                }
                _initDefaults();
            };
            // Proxy the analytics functions
            proxyFunctions(_self, _getAnalytics, [
                "trackMetric",
                "trackPageView",
                "trackEvent",
                "trackException",
                "trackTrace",
            ]);
            function _initDefaults() {
                _analyticsPlugin = null;
                _extensionConfig = null;
                _unlisten = null;
                _pageViewTimer = null;
                _pageViewTracked = false;
            }
            function _getAnalytics() {
                if (!_analyticsPlugin) {
                    _throwInternal(_self.diagLog(), 1 /* eLoggingSeverity.CRITICAL */, 64 /* _eInternalMessageId.TelemetryInitializerFailed */, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
                }
                return _analyticsPlugin;
            }
            function _addHistoryListener(history) {
                var locationListener = function (arg) {
                    // v4 of the history API passes "location" as the first argument, while v5 passes an object that contains location and action 
                    var locn = null;
                    if ("location" in arg) {
                        // Looks like v5
                        locn = arg["location"];
                    }
                    else {
                        locn = arg;
                    }
                    // Timeout to ensure any changes to the DOM made by route changes get included in pageView telemetry
                    _pageViewTimer = setTimeout(function () {
                        _pageViewTimer = null;
                        var pageViewTelemetry = { uri: locn.pathname };
                        _self.trackPageView(pageViewTelemetry);
                    }, 500);
                };
                _unlisten = history.listen(locationListener);
            }
            objDefineAccessors(_self, "_extensionConfig", function () { return _extensionConfig; });
        });
        return _this;
    }
// Removed Stub for ReactPlugin.prototype.initialize.
// Removed Stub for ReactPlugin.prototype.getCookieMgr.
// Removed Stub for ReactPlugin.prototype.getAppInsights.
// Removed Stub for ReactPlugin.prototype.processTelemetry.
// Removed Stub for ReactPlugin.prototype.trackMetric.
// Removed Stub for ReactPlugin.prototype.trackPageView.
// Removed Stub for ReactPlugin.prototype.trackEvent.
// Removed Stub for ReactPlugin.prototype.trackException.
// Removed Stub for ReactPlugin.prototype.trackTrace.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ReactPlugin.__ieDyn=1;

    return ReactPlugin;
}(BaseTelemetryPlugin));

var Action;
(function(Action2) {
  Action2["Pop"] = "POP";
  Action2["Push"] = "PUSH";
  Action2["Replace"] = "REPLACE";
})(Action || (Action = {}));
var readOnly = process.env.NODE_ENV !== "production" ? function(obj) {
  return Object.freeze(obj);
} : function(obj) {
  return obj;
};
function warning$2(cond, message) {
  {
    if (typeof console !== "undefined") console.warn(message);
    try {
      throw new Error(message);
    } catch (e) {
    }
  }
}
var BeforeUnloadEventType = "beforeunload";
var PopStateEventType = "popstate";
function createBrowserHistory(options) {
  if (options === undefined) {
    options = {};
  }
  var _options = options, _options$window = _options.window, window = _options$window === undefined ? document.defaultView : _options$window;
  var globalHistory = window.history;
  function getIndexAndLocation() {
    var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
    var state = globalHistory.state || {};
    return [state.idx, readOnly({
      pathname,
      search,
      hash,
      state: state.usr || null,
      key: state.key || "default"
    })];
  }
  var blockedPopTx = null;
  function handlePop() {
    if (blockedPopTx) {
      blockers.call(blockedPopTx);
      blockedPopTx = null;
    } else {
      var nextAction = Action.Pop;
      var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
      if (blockers.length) {
        if (nextIndex != null) {
          var delta = index - nextIndex;
          if (delta) {
            blockedPopTx = {
              action: nextAction,
              location: nextLocation,
              retry: function retry() {
                go(delta * -1);
              }
            };
            go(delta);
          }
        } else {
          process.env.NODE_ENV !== "production" ? warning$2(
            false,
            // TODO: Write up a doc that explains our blocking strategy in
            // detail and link to it here so people can understand better what
            // is going on and how to avoid it.
            "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation."
          ) : undefined;
        }
      } else {
        applyTx(nextAction);
      }
    }
  }
  window.addEventListener(PopStateEventType, handlePop);
  var action = Action.Pop;
  var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
  var listeners = createEvents();
  var blockers = createEvents();
  if (index == null) {
    index = 0;
    globalHistory.replaceState(_extends({}, globalHistory.state, {
      idx: index
    }), "");
  }
  function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
  }
  function getNextLocation(to, state) {
    if (state === undefined) {
      state = null;
    }
    return readOnly(_extends({
      pathname: location.pathname,
      hash: "",
      search: ""
    }, typeof to === "string" ? parsePath(to) : to, {
      state,
      key: createKey()
    }));
  }
  function getHistoryStateAndUrl(nextLocation, index2) {
    return [{
      usr: nextLocation.state,
      key: nextLocation.key,
      idx: index2
    }, createHref(nextLocation)];
  }
  function allowTx(action2, location2, retry) {
    return !blockers.length || (blockers.call({
      action: action2,
      location: location2,
      retry
    }), false);
  }
  function applyTx(nextAction) {
    action = nextAction;
    var _getIndexAndLocation3 = getIndexAndLocation();
    index = _getIndexAndLocation3[0];
    location = _getIndexAndLocation3[1];
    listeners.call({
      action,
      location
    });
  }
  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);
    function retry() {
      push(to, state);
    }
    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1];
      try {
        globalHistory.pushState(historyState, "", url);
      } catch (error) {
        window.location.assign(url);
      }
      applyTx(nextAction);
    }
  }
  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);
    function retry() {
      replace(to, state);
    }
    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1];
      globalHistory.replaceState(historyState, "", url);
      applyTx(nextAction);
    }
  }
  function go(delta) {
    globalHistory.go(delta);
  }
  var history = {
    get action() {
      return action;
    },
    get location() {
      return location;
    },
    createHref,
    push,
    replace,
    go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      var unblock = blockers.push(blocker);
      if (blockers.length === 1) {
        window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
      }
      return function() {
        unblock();
        if (!blockers.length) {
          window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
        }
      };
    }
  };
  return history;
}
function promptBeforeUnload(event) {
  event.preventDefault();
  event.returnValue = "";
}
function createEvents() {
  var handlers = [];
  return {
    get length() {
      return handlers.length;
    },
    push: function push(fn) {
      handlers.push(fn);
      return function() {
        handlers = handlers.filter(function(handler) {
          return handler !== fn;
        });
      };
    },
    call: function call(arg) {
      handlers.forEach(function(fn) {
        return fn && fn(arg);
      });
    }
  };
}
function createKey() {
  return Math.random().toString(36).substr(2, 8);
}
function createPath(_ref) {
  var _ref$pathname = _ref.pathname, pathname = _ref$pathname === undefined ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === undefined ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === undefined ? "" : _ref$hash;
  if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
  if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
  return pathname;
}
function parsePath(path) {
  var parsedPath = {};
  if (path) {
    var hashIndex = path.indexOf("#");
    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }
    var searchIndex = path.indexOf("?");
    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }
    if (path) {
      parsedPath.pathname = path;
    }
  }
  return parsedPath;
}

// appInsights.js

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
let appInsights;

const initializeAppInsights = (instrumentationKey) => {

    if (!appInsights) {
        appInsights = new AppInsightsSku({
            config: {
                instrumentationKey: instrumentationKey,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: browserHistory }
                }
            }
        });
        appInsights.loadAppInsights();
    }

    return appInsights;
};

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

const { toString: toString$4 } = Object.prototype;
const { getPrototypeOf: getPrototypeOf$1 } = Object;
const kindOf$2 = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString$4.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf$2(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray: isArray$2 } = Array;
const isUndefined$1 = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && isFunction$2(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
const isString$1 = typeOfTest("string");
const isFunction$2 = typeOfTest("function");
const isNumber$2 = typeOfTest("number");
const isObject$5 = (thing) => thing !== null && typeof thing === "object";
const isBoolean$1 = (thing) => thing === true || thing === false;
const isPlainObject$5 = (val) => {
  if (kindOf$2(val) !== "object") {
    return false;
  }
  const prototype = getPrototypeOf$1(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate$3 = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$5(val) && isFunction$2(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction$2(thing.append) && ((kind = kindOf$2(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction$2(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim$1 = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$2(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : window;
})();
const isContextDefined = (context) => !isUndefined$1(context) && context !== _global;
function merge$3() {
  const { caseless } = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject$5(result[targetKey]) && isPlainObject$5(val)) {
      result[targetKey] = merge$3(result[targetKey], val);
    } else if (isPlainObject$5(val)) {
      result[targetKey] = merge$3({}, val);
    } else if (isArray$2(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}
const extend$3 = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction$2(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null) return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf$1(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray$1 = (thing) => {
  if (!thing) return null;
  if (isArray$2(thing)) return thing;
  let i = thing.length;
  if (!isNumber$2(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf$1(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty$3 = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction$2(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction$2(value)) return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray$2(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop$4 = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction$2(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject$5(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray$2(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined$1(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = undefined;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable$1 = (thing) => thing && (isObject$5(thing) || isFunction$2(thing)) && isFunction$2(thing.then) && isFunction$2(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({ source, data }) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === "function",
  isFunction$2(_global.postMessage)
);
const asap$1 = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
const utils$1 = {
  isArray: isArray$2,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$2,
  isBoolean: isBoolean$1,
  isObject: isObject$5,
  isPlainObject: isPlainObject$5,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined: isUndefined$1,
  isDate: isDate$3,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$2,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge: merge$3,
  extend: extend$3,
  trim: trim$1,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf: kindOf$2,
  kindOfTest,
  endsWith,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: hasOwnProperty$3,
  hasOwnProp: hasOwnProperty$3,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$4,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable: isThenable$1,
  setImmediate: _setImmediate,
  asap: asap$1
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
const httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

const URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

const FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

const Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const hasStandardBrowserEnv = ((product) => {
  return hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";

const utils = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	hasBrowserEnv,
	hasStandardBrowserEnv,
	hasStandardBrowserWebWorkerEnv,
	origin
}, Symbol.toStringTag, { value: 'Module' }));

const platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (0, JSON.stringify)(rawValue);
}

const defaults$1 = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults$1.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults$1.headers[method] = {};
});

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
const parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle$1(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle$1(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};

const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));

const isURLSameOrigin = platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

const cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

const xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  let controller = new AbortController();

  let aborted;

  const onabort = function (cancel) {
    if (!aborted) {
      aborted = true;
      unsubscribe();
      const err = cancel instanceof Error ? cancel : this.reason;
      controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
    }
  };

  let timer = timeout && setTimeout(() => {
    onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
  }, timeout);

  const unsubscribe = () => {
    if (signals) {
      timer && clearTimeout(timer);
      timer = null;
      signals.forEach(signal => {
        signal &&
        (signal.removeEventListener ? signal.removeEventListener('abort', onabort) : signal.unsubscribe(onabort));
      });
      signals = null;
    }
  };

  signals.forEach((signal) => signal && signal.addEventListener && signal.addEventListener('abort', onabort));

  const {signal} = controller;

  signal.unsubscribe = unsubscribe;

  return [signal, () => {
    timer && clearTimeout(timer);
    timer = null;
  }];
};

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize, encode) {
  for await (const chunk of iterable) {
    yield* streamChunk(ArrayBuffer.isView(chunk) ? chunk : (await encode(String(chunk))), chunkSize);
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish, encode) => {
  const iterator = readBytes(stream, chunkSize, encode);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
};

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils$1.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    return (await new Request(body).arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

const fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let [composedSignal, stopTimeout] = (signal || cancelToken || timeout) ?
    composeSignals([signal, cancelToken], timeout) : [];

  let finished, request;

  const onFinish = () => {
    !finished && setTimeout(() => {
      composedSignal && composedSignal.unsubscribe();
    });

    finished = true;
  };

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush, encodeText);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: withCredentials
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          isStreamResponse && onFinish();
        }, encodeText),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && onFinish();

    stopTimeout && stopTimeout();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    onFinish();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

const adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION = "1.7.4";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

const validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios(defaultConfig);
  const instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode;

axios.default = axios;

var reactDomServerLegacy_browser_production_min = {};

/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServerLegacy_browser_production_min;

function requireReactDomServerLegacy_browser_production_min () {
	if (hasRequiredReactDomServerLegacy_browser_production_min) return reactDomServerLegacy_browser_production_min;
	hasRequiredReactDomServerLegacy_browser_production_min = 1;
var aa=React__default;function l(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var p=Object.prototype.hasOwnProperty,fa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ha={},ia={};
	function ja(a){if(p.call(ia,a))return  true;if(p.call(ha,a))return  false;if(fa.test(a))return ia[a]=true;ha[a]=true;return  false}function r(a,b,c,d,f,e,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=e;this.removeEmptyString=g;}var t={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){t[a]=new r(a,0,false,a,null,false,false);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];t[b]=new r(b,1,false,a[1],null,false,false);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){t[a]=new r(a,2,false,a.toLowerCase(),null,false,false);});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){t[a]=new r(a,2,false,a,null,false,false);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){t[a]=new r(a,3,false,a.toLowerCase(),null,false,false);});
	["checked","multiple","muted","selected"].forEach(function(a){t[a]=new r(a,3,true,a,null,false,false);});["capture","download"].forEach(function(a){t[a]=new r(a,4,false,a,null,false,false);});["cols","rows","size","span"].forEach(function(a){t[a]=new r(a,6,false,a,null,false,false);});["rowSpan","start"].forEach(function(a){t[a]=new r(a,5,false,a.toLowerCase(),null,false,false);});var ka=/[\-:]([a-z])/g;function la(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ka,
	la);t[b]=new r(b,1,false,a,null,false,false);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ka,la);t[b]=new r(b,1,false,a,"http://www.w3.org/1999/xlink",false,false);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ka,la);t[b]=new r(b,1,false,a,"http://www.w3.org/XML/1998/namespace",false,false);});["tabIndex","crossOrigin"].forEach(function(a){t[a]=new r(a,1,false,a.toLowerCase(),null,false,false);});
	t.xlinkHref=new r("xlinkHref",1,false,"xlink:href","http://www.w3.org/1999/xlink",true,false);["src","href","action","formAction"].forEach(function(a){t[a]=new r(a,1,false,a.toLowerCase(),null,true,true);});
	var u={animationIterationCount:true,aspectRatio:true,borderImageOutset:true,borderImageSlice:true,borderImageWidth:true,boxFlex:true,boxFlexGroup:true,boxOrdinalGroup:true,columnCount:true,columns:true,flex:true,flexGrow:true,flexPositive:true,flexShrink:true,flexNegative:true,flexOrder:true,gridArea:true,gridRow:true,gridRowEnd:true,gridRowSpan:true,gridRowStart:true,gridColumn:true,gridColumnEnd:true,gridColumnSpan:true,gridColumnStart:true,fontWeight:true,lineClamp:true,lineHeight:true,opacity:true,order:true,orphans:true,tabSize:true,widows:true,zIndex:true,zoom:true,
	fillOpacity:true,floodOpacity:true,stopOpacity:true,strokeDasharray:true,strokeDashoffset:true,strokeMiterlimit:true,strokeOpacity:true,strokeWidth:true},ma=["Webkit","ms","Moz","O"];Object.keys(u).forEach(function(a){ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);u[b]=u[a];});});var na=/["'&<>]/;
	function v(a){if("boolean"===typeof a||"number"===typeof a)return ""+a;a=""+a;var b=na.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b;}a=f!==d?c+a.substring(f,d):c;}return a}var oa=/([A-Z])/g,pa=/^ms-/,qa=Array.isArray;function w(a,b){return {insertionMode:a,selectedValue:b}}
	function ra(a,b,c){switch(b){case "select":return w(1,null!=c.value?c.value:c.defaultValue);case "svg":return w(2,null);case "math":return w(3,null);case "foreignObject":return w(1,null);case "table":return w(4,null);case "thead":case "tbody":case "tfoot":return w(5,null);case "colgroup":return w(7,null);case "tr":return w(6,null)}return 4<=a.insertionMode||0===a.insertionMode?w(1,null):a}var sa=new Map;
	function ta(a,b,c){if("object"!==typeof c)throw Error(l(62));b=true;for(var d in c)if(p.call(c,d)){var f=c[d];if(null!=f&&"boolean"!==typeof f&&""!==f){if(0===d.indexOf("--")){var e=v(d);f=v((""+f).trim());}else {e=d;var g=sa.get(e);undefined!==g?e=g:(g=v(e.replace(oa,"-$1").toLowerCase().replace(pa,"-ms-")),sa.set(e,g),e=g);f="number"===typeof f?0===f||p.call(u,d)?""+f:f+"px":v((""+f).trim());}b?(b=false,a.push(' style="',e,":",f)):a.push(";",e,":",f);}}b||a.push('"');}
	function x(a,b,c,d){switch(c){case "style":ta(a,b,d);return;case "defaultValue":case "defaultChecked":case "innerHTML":case "suppressContentEditableWarning":case "suppressHydrationWarning":return}if(!(2<c.length)||"o"!==c[0]&&"O"!==c[0]||"n"!==c[1]&&"N"!==c[1])if(b=t.hasOwnProperty(c)?t[c]:null,null!==b){switch(typeof d){case "function":case "symbol":return;case "boolean":if(!b.acceptsBooleans)return}c=b.attributeName;switch(b.type){case 3:d&&a.push(" ",c,'=""');break;case 4:true===d?a.push(" ",c,'=""'):
	false!==d&&a.push(" ",c,'="',v(d),'"');break;case 5:isNaN(d)||a.push(" ",c,'="',v(d),'"');break;case 6:!isNaN(d)&&1<=d&&a.push(" ",c,'="',v(d),'"');break;default:b.sanitizeURL&&(d=""+d),a.push(" ",c,'="',v(d),'"');}}else if(ja(c)){switch(typeof d){case "function":case "symbol":return;case "boolean":if(b=c.toLowerCase().slice(0,5),"data-"!==b&&"aria-"!==b)return}a.push(" ",c,'="',v(d),'"');}}
	function y(a,b,c){if(null!=b){if(null!=c)throw Error(l(60));if("object"!==typeof b||!("__html"in b))throw Error(l(61));b=b.__html;null!==b&&undefined!==b&&a.push(""+b);}}function ua(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}
	function va(a,b,c,d){a.push(A(c));var f=c=null,e;for(e in b)if(p.call(b,e)){var g=b[e];if(null!=g)switch(e){case "children":c=g;break;case "dangerouslySetInnerHTML":f=g;break;default:x(a,d,e,g);}}a.push(">");y(a,f,c);return "string"===typeof c?(a.push(v(c)),null):c}var wa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,xa=new Map;function A(a){var b=xa.get(a);if(undefined===b){if(!wa.test(a))throw Error(l(65,a));b="<"+a;xa.set(a,b);}return b}
	function ya(a,b,c,d,f){switch(b){case "select":a.push(A("select"));var e=null,g=null;for(n in c)if(p.call(c,n)){var h=c[n];if(null!=h)switch(n){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "defaultValue":case "value":break;default:x(a,d,n,h);}}a.push(">");y(a,g,e);return e;case "option":g=f.selectedValue;a.push(A("option"));var k=h=null,m=null;var n=null;for(e in c)if(p.call(c,e)){var q=c[e];if(null!=q)switch(e){case "children":h=q;break;case "selected":m=q;break;case "dangerouslySetInnerHTML":n=
	q;break;case "value":k=q;default:x(a,d,e,q);}}if(null!=g)if(c=null!==k?""+k:ua(h),qa(g))for(d=0;d<g.length;d++){if(""+g[d]===c){a.push(' selected=""');break}}else ""+g===c&&a.push(' selected=""');else m&&a.push(' selected=""');a.push(">");y(a,n,h);return h;case "textarea":a.push(A("textarea"));n=g=e=null;for(h in c)if(p.call(c,h)&&(k=c[h],null!=k))switch(h){case "children":n=k;break;case "value":e=k;break;case "defaultValue":g=k;break;case "dangerouslySetInnerHTML":throw Error(l(91));default:x(a,d,
	h,k);}null===e&&null!==g&&(e=g);a.push(">");if(null!=n){if(null!=e)throw Error(l(92));if(qa(n)&&1<n.length)throw Error(l(93));e=""+n;}"string"===typeof e&&"\n"===e[0]&&a.push("\n");null!==e&&a.push(v(""+e));return null;case "input":a.push(A("input"));k=n=h=e=null;for(g in c)if(p.call(c,g)&&(m=c[g],null!=m))switch(g){case "children":case "dangerouslySetInnerHTML":throw Error(l(399,"input"));case "defaultChecked":k=m;break;case "defaultValue":h=m;break;case "checked":n=m;break;case "value":e=m;break;
	default:x(a,d,g,m);}null!==n?x(a,d,"checked",n):null!==k&&x(a,d,"checked",k);null!==e?x(a,d,"value",e):null!==h&&x(a,d,"value",h);a.push("/>");return null;case "menuitem":a.push(A("menuitem"));for(var C in c)if(p.call(c,C)&&(e=c[C],null!=e))switch(C){case "children":case "dangerouslySetInnerHTML":throw Error(l(400));default:x(a,d,C,e);}a.push(">");return null;case "title":a.push(A("title"));e=null;for(q in c)if(p.call(c,q)&&(g=c[q],null!=g))switch(q){case "children":e=g;break;case "dangerouslySetInnerHTML":throw Error(l(434));
	default:x(a,d,q,g);}a.push(">");return e;case "listing":case "pre":a.push(A(b));g=e=null;for(k in c)if(p.call(c,k)&&(h=c[k],null!=h))switch(k){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;default:x(a,d,k,h);}a.push(">");if(null!=g){if(null!=e)throw Error(l(60));if("object"!==typeof g||!("__html"in g))throw Error(l(61));c=g.__html;null!==c&&undefined!==c&&("string"===typeof c&&0<c.length&&"\n"===c[0]?a.push("\n",c):a.push(""+c));}"string"===typeof e&&"\n"===e[0]&&a.push("\n");return e;
	case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":a.push(A(b));for(var D in c)if(p.call(c,D)&&(e=c[D],null!=e))switch(D){case "children":case "dangerouslySetInnerHTML":throw Error(l(399,b));default:x(a,d,D,e);}a.push("/>");return null;case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return va(a,
	c,b,d);case "html":return 0===f.insertionMode&&a.push("<!DOCTYPE html>"),va(a,c,b,d);default:if(-1===b.indexOf("-")&&"string"!==typeof c.is)return va(a,c,b,d);a.push(A(b));g=e=null;for(m in c)if(p.call(c,m)&&(h=c[m],null!=h))switch(m){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "style":ta(a,d,h);break;case "suppressContentEditableWarning":case "suppressHydrationWarning":break;default:ja(m)&&"function"!==typeof h&&"symbol"!==typeof h&&a.push(" ",m,'="',v(h),'"');}a.push(">");
	y(a,g,e);return e}}function za(a,b,c){a.push('\x3c!--$?--\x3e<template id="');if(null===c)throw Error(l(395));a.push(c);return a.push('"></template>')}
	function Aa(a,b,c,d){switch(c.insertionMode){case 0:case 1:return a.push('<div hidden id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 2:return a.push('<svg aria-hidden="true" style="display:none" id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 3:return a.push('<math aria-hidden="true" style="display:none" id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 4:return a.push('<table hidden id="'),a.push(b.segmentPrefix),
	b=d.toString(16),a.push(b),a.push('">');case 5:return a.push('<table hidden><tbody id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 6:return a.push('<table hidden><tr id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 7:return a.push('<table hidden><colgroup id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');default:throw Error(l(397));}}
	function Ba(a,b){switch(b.insertionMode){case 0:case 1:return a.push("</div>");case 2:return a.push("</svg>");case 3:return a.push("</math>");case 4:return a.push("</table>");case 5:return a.push("</tbody></table>");case 6:return a.push("</tr></table>");case 7:return a.push("</colgroup></table>");default:throw Error(l(397));}}var Ca=/[<\u2028\u2029]/g;
	function Da(a){return JSON.stringify(a).replace(Ca,function(a){switch(a){case "<":return "\\u003c";case "\u2028":return "\\u2028";case "\u2029":return "\\u2029";default:throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");}})}
	function Ea(a,b){b=undefined===b?"":b;return {bootstrapChunks:[],startInlineScript:"<script>",placeholderPrefix:b+"P:",segmentPrefix:b+"S:",boundaryPrefix:b+"B:",idPrefix:b,nextSuspenseID:0,sentCompleteSegmentFunction:false,sentCompleteBoundaryFunction:false,sentClientRenderFunction:false,generateStaticMarkup:a}}function Fa(a,b,c,d){if(c.generateStaticMarkup)return a.push(v(b)),false;""===b?a=d:(d&&a.push("\x3c!-- --\x3e"),a.push(v(b)),a=true);return a}
	var B=Object.assign,Ga=Symbol.for("react.element"),Ha=Symbol.for("react.portal"),Ia=Symbol.for("react.fragment"),Ja=Symbol.for("react.strict_mode"),Ka=Symbol.for("react.profiler"),La=Symbol.for("react.provider"),Ma=Symbol.for("react.context"),Na=Symbol.for("react.forward_ref"),Oa=Symbol.for("react.suspense"),Pa=Symbol.for("react.suspense_list"),Qa=Symbol.for("react.memo"),Ra=Symbol.for("react.lazy"),Sa=Symbol.for("react.scope"),Ta=Symbol.for("react.debug_trace_mode"),Ua=Symbol.for("react.legacy_hidden"),
	Va=Symbol.for("react.default_value"),Wa=Symbol.iterator;
	function Xa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return "Fragment";case Ha:return "Portal";case Ka:return "Profiler";case Ja:return "StrictMode";case Oa:return "Suspense";case Pa:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return (a.displayName||"Context")+".Consumer";case La:return (a._context.displayName||"Context")+".Provider";case Na:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case Qa:return b=a.displayName||null,null!==b?b:Xa(a.type)||"Memo";case Ra:b=a._payload;a=a._init;try{return Xa(a(b))}catch(c){}}return null}var Ya={};function Za(a,b){a=a.contextTypes;if(!a)return Ya;var c={},d;for(d in a)c[d]=b[d];return c}var E=null;
	function F(a,b){if(a!==b){a.context._currentValue2=a.parentValue;a=a.parent;var c=b.parent;if(null===a){if(null!==c)throw Error(l(401));}else {if(null===c)throw Error(l(401));F(a,c);}b.context._currentValue2=b.value;}}function $a(a){a.context._currentValue2=a.parentValue;a=a.parent;null!==a&&$a(a);}function ab(a){var b=a.parent;null!==b&&ab(b);a.context._currentValue2=a.value;}
	function bb(a,b){a.context._currentValue2=a.parentValue;a=a.parent;if(null===a)throw Error(l(402));a.depth===b.depth?F(a,b):bb(a,b);}function cb(a,b){var c=b.parent;if(null===c)throw Error(l(402));a.depth===c.depth?F(a,c):cb(a,c);b.context._currentValue2=b.value;}function G(a){var b=E;b!==a&&(null===b?ab(a):null===a?$a(b):b.depth===a.depth?F(b,a):b.depth>a.depth?bb(b,a):cb(b,a),E=a);}
	var db={isMounted:function(){return  false},enqueueSetState:function(a,b){a=a._reactInternals;null!==a.queue&&a.queue.push(b);},enqueueReplaceState:function(a,b){a=a._reactInternals;a.replace=true;a.queue=[b];},enqueueForceUpdate:function(){}};
	function eb(a,b,c,d){var f=undefined!==a.state?a.state:null;a.updater=db;a.props=c;a.state=f;var e={queue:[],replace:false};a._reactInternals=e;var g=b.contextType;a.context="object"===typeof g&&null!==g?g._currentValue2:d;g=b.getDerivedStateFromProps;"function"===typeof g&&(g=g(c,f),f=null===g||undefined===g?f:B({},f,g),a.state=f);if("function"!==typeof b.getDerivedStateFromProps&&"function"!==typeof a.getSnapshotBeforeUpdate&&("function"===typeof a.UNSAFE_componentWillMount||"function"===typeof a.componentWillMount))if(b=
	a.state,"function"===typeof a.componentWillMount&&a.componentWillMount(),"function"===typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount(),b!==a.state&&db.enqueueReplaceState(a,a.state,null),null!==e.queue&&0<e.queue.length)if(b=e.queue,g=e.replace,e.queue=null,e.replace=false,g&&1===b.length)a.state=b[0];else {e=g?b[0]:a.state;f=true;for(g=g?1:0;g<b.length;g++){var h=b[g];h="function"===typeof h?h.call(a,e,c,d):h;null!=h&&(f?(f=false,e=B({},e,h)):B(e,h));}a.state=e;}else e.queue=null;}
	var fb={id:1,overflow:""};function gb(a,b,c){var d=a.id;a=a.overflow;var f=32-H(d)-1;d&=~(1<<f);c+=1;var e=32-H(b)+f;if(30<e){var g=f-f%5;e=(d&(1<<g)-1).toString(32);d>>=g;f-=g;return {id:1<<32-H(b)+f|c<<f|d,overflow:e+a}}return {id:1<<e|c<<f|d,overflow:a}}var H=Math.clz32?Math.clz32:hb,ib=Math.log,jb=Math.LN2;function hb(a){a>>>=0;return 0===a?32:31-(ib(a)/jb|0)|0}function kb(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var lb="function"===typeof Object.is?Object.is:kb,I=null,ob=null,J=null,K=null,L=false,M=false,N=0,O=null,P=0;function Q(){if(null===I)throw Error(l(321));return I}function pb(){if(0<P)throw Error(l(312));return {memoizedState:null,queue:null,next:null}}function qb(){null===K?null===J?(L=false,J=K=pb()):(L=true,K=J):null===K.next?(L=false,K=K.next=pb()):(L=true,K=K.next);return K}function rb(){ob=I=null;M=false;J=null;P=0;K=O=null;}function sb(a,b){return "function"===typeof b?b(a):b}
	function tb(a,b,c){I=Q();K=qb();if(L){var d=K.queue;b=d.dispatch;if(null!==O&&(c=O.get(d),undefined!==c)){O.delete(d);d=K.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);K.memoizedState=d;return [d,b]}return [K.memoizedState,b]}a=a===sb?"function"===typeof b?b():b:undefined!==c?c(b):b;K.memoizedState=a;a=K.queue={last:null,dispatch:null};a=a.dispatch=ub.bind(null,I,a);return [K.memoizedState,a]}
	function vb(a,b){I=Q();K=qb();b=undefined===b?null:b;if(null!==K){var c=K.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=false;else {for(var f=0;f<d.length&&f<b.length;f++)if(!lb(b[f],d[f])){d=false;break a}d=true;}if(d)return c[0]}}a=a();K.memoizedState=[a,b];return a}function ub(a,b,c){if(25<=P)throw Error(l(301));if(a===I)if(M=true,a={action:c,next:null},null===O&&(O=new Map),c=O.get(b),undefined===c)O.set(b,a);else {for(b=c;null!==b.next;)b=b.next;b.next=a;}}function wb(){throw Error(l(394));}
	function R(){}
	var xb={readContext:function(a){return a._currentValue2},useContext:function(a){Q();return a._currentValue2},useMemo:vb,useReducer:tb,useRef:function(a){I=Q();K=qb();var b=K.memoizedState;return null===b?(a={current:a},K.memoizedState=a):b},useState:function(a){return tb(sb,a)},useInsertionEffect:R,useLayoutEffect:function(){},useCallback:function(a,b){return vb(function(){return a},b)},useImperativeHandle:R,useEffect:R,useDebugValue:R,useDeferredValue:function(a){Q();return a},useTransition:function(){Q();return [false,
	wb]},useId:function(){var a=ob.treeContext;var b=a.overflow;a=a.id;a=(a&~(1<<32-H(a)-1)).toString(32)+b;var c=S;if(null===c)throw Error(l(404));b=N++;a=":"+c.idPrefix+"R"+a;0<b&&(a+="H"+b.toString(32));return a+":"},useMutableSource:function(a,b){Q();return b(a._source)},useSyncExternalStore:function(a,b,c){if(undefined===c)throw Error(l(407));return c()}},S=null,yb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;function zb(a){console.error(a);return null}
	function T(){}
	function Ab(a,b,c,d,f,e,g,h,k){var m=[],n=new Set;b={destination:null,responseState:b,progressiveChunkSize:undefined===d?12800:d,status:0,fatalError:null,nextSegmentId:0,allPendingTasks:0,pendingRootTasks:0,completedRootSegment:null,abortableTasks:n,pingedTasks:m,clientRenderedBoundaries:[],completedBoundaries:[],partialBoundaries:[],onError:undefined===f?zb:f,onAllReady:T,onShellReady:undefined===g?T:g,onShellError:T,onFatalError:T};c=U(b,0,null,c,false,false);c.parentFlushed=
	true;a=Bb(b,a,null,c,n,Ya,null,fb);m.push(a);return b}function Bb(a,b,c,d,f,e,g,h){a.allPendingTasks++;null===c?a.pendingRootTasks++:c.pendingTasks++;var k={node:b,ping:function(){var b=a.pingedTasks;b.push(k);1===b.length&&Cb(a);},blockedBoundary:c,blockedSegment:d,abortSet:f,legacyContext:e,context:g,treeContext:h};f.add(k);return k}function U(a,b,c,d,f,e){return {status:0,id:-1,index:b,parentFlushed:false,chunks:[],children:[],formatContext:d,boundary:c,lastPushedText:f,textEmbedded:e}}
	function V(a,b){a=a.onError(b);if(null!=a&&"string"!==typeof a)throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "'+typeof a+'" instead');return a}function W(a,b){var c=a.onShellError;c(b);c=a.onFatalError;c(b);null!==a.destination?(a.status=2,a.destination.destroy(b)):(a.status=1,a.fatalError=b);}
	function Db(a,b,c,d,f){I={};ob=b;N=0;for(a=c(d,f);M;)M=false,N=0,P+=1,K=null,a=c(d,f);rb();return a}function Eb(a,b,c,d){var f=c.render(),e=d.childContextTypes;if(null!==e&&undefined!==e){var g=b.legacyContext;if("function"!==typeof c.getChildContext)d=g;else {c=c.getChildContext();for(var h in c)if(!(h in e))throw Error(l(108,Xa(d)||"Unknown",h));d=B({},g,c);}b.legacyContext=d;X(a,b,f);b.legacyContext=g;}else X(a,b,f);}
	function Fb(a,b){if(a&&a.defaultProps){b=B({},b);a=a.defaultProps;for(var c in a) undefined===b[c]&&(b[c]=a[c]);return b}return b}
	function Gb(a,b,c,d,f){if("function"===typeof c)if(c.prototype&&c.prototype.isReactComponent){f=Za(c,b.legacyContext);var e=c.contextType;e=new c(d,"object"===typeof e&&null!==e?e._currentValue2:f);eb(e,c,d,f);Eb(a,b,e,c);}else {e=Za(c,b.legacyContext);f=Db(a,b,c,d,e);var g=0!==N;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&undefined===f.$$typeof)eb(f,c,d,e),Eb(a,b,f,c);else if(g){d=b.treeContext;b.treeContext=gb(d,1,0);try{X(a,b,f);}finally{b.treeContext=d;}}else X(a,b,f);}else if("string"===
	typeof c){f=b.blockedSegment;e=ya(f.chunks,c,d,a.responseState,f.formatContext);f.lastPushedText=false;g=f.formatContext;f.formatContext=ra(g,c,d);Hb(a,b,e);f.formatContext=g;switch(c){case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "input":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":break;default:f.chunks.push("</",c,">");}f.lastPushedText=false;}else {switch(c){case Ua:case Ta:case Ja:case Ka:case Ia:X(a,b,d.children);return;
	case Pa:X(a,b,d.children);return;case Sa:throw Error(l(343));case Oa:a:{c=b.blockedBoundary;f=b.blockedSegment;e=d.fallback;d=d.children;g=new Set;var h={id:null,rootSegmentID:-1,parentFlushed:false,pendingTasks:0,forceClientRender:false,completedSegments:[],byteSize:0,fallbackAbortableTasks:g,errorDigest:null},k=U(a,f.chunks.length,h,f.formatContext,false,false);f.children.push(k);f.lastPushedText=false;var m=U(a,0,null,f.formatContext,false,false);m.parentFlushed=true;b.blockedBoundary=h;b.blockedSegment=m;try{if(Hb(a,
	b,d),a.responseState.generateStaticMarkup||m.lastPushedText&&m.textEmbedded&&m.chunks.push("\x3c!-- --\x3e"),m.status=1,Y(h,m),0===h.pendingTasks)break a}catch(n){m.status=4,h.forceClientRender=true,h.errorDigest=V(a,n);}finally{b.blockedBoundary=c,b.blockedSegment=f;}b=Bb(a,e,c,k,g,b.legacyContext,b.context,b.treeContext);a.pingedTasks.push(b);}return}if("object"===typeof c&&null!==c)switch(c.$$typeof){case Na:d=Db(a,b,c.render,d,f);if(0!==N){c=b.treeContext;b.treeContext=gb(c,1,0);try{X(a,b,d);}finally{b.treeContext=
	c;}}else X(a,b,d);return;case Qa:c=c.type;d=Fb(c,d);Gb(a,b,c,d,f);return;case La:f=d.children;c=c._context;d=d.value;e=c._currentValue2;c._currentValue2=d;g=E;E=d={parent:g,depth:null===g?0:g.depth+1,context:c,parentValue:e,value:d};b.context=d;X(a,b,f);a=E;if(null===a)throw Error(l(403));d=a.parentValue;a.context._currentValue2=d===Va?a.context._defaultValue:d;a=E=a.parent;b.context=a;return;case Ma:d=d.children;d=d(c._currentValue2);X(a,b,d);return;case Ra:f=c._init;c=f(c._payload);d=Fb(c,d);Gb(a,
	b,c,d,undefined);return}throw Error(l(130,null==c?c:typeof c,""));}}
	function X(a,b,c){b.node=c;if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:Gb(a,b,c.type,c.props,c.ref);return;case Ha:throw Error(l(257));case Ra:var d=c._init;c=d(c._payload);X(a,b,c);return}if(qa(c)){Ib(a,b,c);return}null===c||"object"!==typeof c?d=null:(d=Wa&&c[Wa]||c["@@iterator"],d="function"===typeof d?d:null);if(d&&(d=d.call(c))){c=d.next();if(!c.done){var f=[];do f.push(c.value),c=d.next();while(!c.done);Ib(a,b,f);}return}a=Object.prototype.toString.call(c);throw Error(l(31,"[object Object]"===
	a?"object with keys {"+Object.keys(c).join(", ")+"}":a));}"string"===typeof c?(d=b.blockedSegment,d.lastPushedText=Fa(b.blockedSegment.chunks,c,a.responseState,d.lastPushedText)):"number"===typeof c&&(d=b.blockedSegment,d.lastPushedText=Fa(b.blockedSegment.chunks,""+c,a.responseState,d.lastPushedText));}function Ib(a,b,c){for(var d=c.length,f=0;f<d;f++){var e=b.treeContext;b.treeContext=gb(e,d,f);try{Hb(a,b,c[f]);}finally{b.treeContext=e;}}}
	function Hb(a,b,c){var d=b.blockedSegment.formatContext,f=b.legacyContext,e=b.context;try{return X(a,b,c)}catch(k){if(rb(),"object"===typeof k&&null!==k&&"function"===typeof k.then){c=k;var g=b.blockedSegment,h=U(a,g.chunks.length,null,g.formatContext,g.lastPushedText,true);g.children.push(h);g.lastPushedText=false;a=Bb(a,b.node,b.blockedBoundary,h,b.abortSet,b.legacyContext,b.context,b.treeContext).ping;c.then(a,a);b.blockedSegment.formatContext=d;b.legacyContext=f;b.context=e;G(e);}else throw b.blockedSegment.formatContext=
	d,b.legacyContext=f,b.context=e,G(e),k;}}function Jb(a){var b=a.blockedBoundary;a=a.blockedSegment;a.status=3;Kb(this,b,a);}
	function Lb(a,b,c){var d=a.blockedBoundary;a.blockedSegment.status=3;null===d?(b.allPendingTasks--,2!==b.status&&(b.status=2,null!==b.destination&&b.destination.push(null))):(d.pendingTasks--,d.forceClientRender||(d.forceClientRender=true,a=undefined===c?Error(l(432)):c,d.errorDigest=b.onError(a),d.parentFlushed&&b.clientRenderedBoundaries.push(d)),d.fallbackAbortableTasks.forEach(function(a){return Lb(a,b,c)}),d.fallbackAbortableTasks.clear(),b.allPendingTasks--,0===b.allPendingTasks&&(d=b.onAllReady,
	d()));}function Y(a,b){if(0===b.chunks.length&&1===b.children.length&&null===b.children[0].boundary){var c=b.children[0];c.id=b.id;c.parentFlushed=true;1===c.status&&Y(a,c);}else a.completedSegments.push(b);}
	function Kb(a,b,c){if(null===b){if(c.parentFlushed){if(null!==a.completedRootSegment)throw Error(l(389));a.completedRootSegment=c;}a.pendingRootTasks--;0===a.pendingRootTasks&&(a.onShellError=T,b=a.onShellReady,b());}else b.pendingTasks--,b.forceClientRender||(0===b.pendingTasks?(c.parentFlushed&&1===c.status&&Y(b,c),b.parentFlushed&&a.completedBoundaries.push(b),b.fallbackAbortableTasks.forEach(Jb,a),b.fallbackAbortableTasks.clear()):c.parentFlushed&&1===c.status&&(Y(b,c),1===b.completedSegments.length&&
	b.parentFlushed&&a.partialBoundaries.push(b)));a.allPendingTasks--;0===a.allPendingTasks&&(a=a.onAllReady,a());}
	function Cb(a){if(2!==a.status){var b=E,c=yb.current;yb.current=xb;var d=S;S=a.responseState;try{var f=a.pingedTasks,e;for(e=0;e<f.length;e++){var g=f[e];var h=a,k=g.blockedSegment;if(0===k.status){G(g.context);try{X(h,g,g.node),h.responseState.generateStaticMarkup||k.lastPushedText&&k.textEmbedded&&k.chunks.push("\x3c!-- --\x3e"),g.abortSet.delete(g),k.status=1,Kb(h,g.blockedBoundary,k);}catch(z){if(rb(),"object"===typeof z&&null!==z&&"function"===typeof z.then){var m=g.ping;z.then(m,m);}else {g.abortSet.delete(g);
	k.status=4;var n=g.blockedBoundary,q=z,C=V(h,q);null===n?W(h,q):(n.pendingTasks--,n.forceClientRender||(n.forceClientRender=!0,n.errorDigest=C,n.parentFlushed&&h.clientRenderedBoundaries.push(n)));h.allPendingTasks--;if(0===h.allPendingTasks){var D=h.onAllReady;D();}}}finally{}}}f.splice(0,e);null!==a.destination&&Mb(a,a.destination);}catch(z){V(a,z),W(a,z);}finally{S=d,yb.current=c,c===xb&&G(b);}}}
	function Z(a,b,c){c.parentFlushed=true;switch(c.status){case 0:var d=c.id=a.nextSegmentId++;c.lastPushedText=false;c.textEmbedded=false;a=a.responseState;b.push('<template id="');b.push(a.placeholderPrefix);a=d.toString(16);b.push(a);return b.push('"></template>');case 1:c.status=2;var f=true;d=c.chunks;var e=0;c=c.children;for(var g=0;g<c.length;g++){for(f=c[g];e<f.index;e++)b.push(d[e]);f=Nb(a,b,f);}for(;e<d.length-1;e++)b.push(d[e]);e<d.length&&(f=b.push(d[e]));return f;default:throw Error(l(390));}}
	function Nb(a,b,c){var d=c.boundary;if(null===d)return Z(a,b,c);d.parentFlushed=true;if(d.forceClientRender)return a.responseState.generateStaticMarkup||(d=d.errorDigest,b.push("\x3c!--$!--\x3e"),b.push("<template"),d&&(b.push(' data-dgst="'),d=v(d),b.push(d),b.push('"')),b.push("></template>")),Z(a,b,c),a=a.responseState.generateStaticMarkup?true:b.push("\x3c!--/$--\x3e"),a;if(0<d.pendingTasks){d.rootSegmentID=a.nextSegmentId++;0<d.completedSegments.length&&a.partialBoundaries.push(d);var f=a.responseState;
	var e=f.nextSuspenseID++;f=f.boundaryPrefix+e.toString(16);d=d.id=f;za(b,a.responseState,d);Z(a,b,c);return b.push("\x3c!--/$--\x3e")}if(d.byteSize>a.progressiveChunkSize)return d.rootSegmentID=a.nextSegmentId++,a.completedBoundaries.push(d),za(b,a.responseState,d.id),Z(a,b,c),b.push("\x3c!--/$--\x3e");a.responseState.generateStaticMarkup||b.push("\x3c!--$--\x3e");c=d.completedSegments;if(1!==c.length)throw Error(l(391));Nb(a,b,c[0]);a=a.responseState.generateStaticMarkup?true:b.push("\x3c!--/$--\x3e");
	return a}function Ob(a,b,c){Aa(b,a.responseState,c.formatContext,c.id);Nb(a,b,c);return Ba(b,c.formatContext)}
	function Pb(a,b,c){for(var d=c.completedSegments,f=0;f<d.length;f++)Qb(a,b,c,d[f]);d.length=0;a=a.responseState;d=c.id;c=c.rootSegmentID;b.push(a.startInlineScript);a.sentCompleteBoundaryFunction?b.push('$RC("'):(a.sentCompleteBoundaryFunction=true,b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));if(null===
	d)throw Error(l(395));c=c.toString(16);b.push(d);b.push('","');b.push(a.segmentPrefix);b.push(c);return b.push('")\x3c/script>')}
	function Qb(a,b,c,d){if(2===d.status)return  true;var f=d.id;if(-1===f){if(-1===(d.id=c.rootSegmentID))throw Error(l(392));return Ob(a,b,d)}Ob(a,b,d);a=a.responseState;b.push(a.startInlineScript);a.sentCompleteSegmentFunction?b.push('$RS("'):(a.sentCompleteSegmentFunction=true,b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));b.push(a.segmentPrefix);
	f=f.toString(16);b.push(f);b.push('","');b.push(a.placeholderPrefix);b.push(f);return b.push('")\x3c/script>')}
	function Mb(a,b){try{var c=a.completedRootSegment;if(null!==c&&0===a.pendingRootTasks){Nb(a,b,c);a.completedRootSegment=null;var d=a.responseState.bootstrapChunks;for(c=0;c<d.length-1;c++)b.push(d[c]);c<d.length&&b.push(d[c]);}var f=a.clientRenderedBoundaries,e;for(e=0;e<f.length;e++){var g=f[e];d=b;var h=a.responseState,k=g.id,m=g.errorDigest,n=g.errorMessage,q=g.errorComponentStack;d.push(h.startInlineScript);h.sentClientRenderFunction?d.push('$RX("'):(h.sentClientRenderFunction=!0,d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
	if(null===k)throw Error(l(395));d.push(k);d.push('"');if(m||n||q){d.push(",");var C=Da(m||"");d.push(C);}if(n||q){d.push(",");var D=Da(n||"");d.push(D);}if(q){d.push(",");var z=Da(q);d.push(z);}if(!d.push(")\x3c/script>")){a.destination=null;e++;f.splice(0,e);return}}f.splice(0,e);var ba=a.completedBoundaries;for(e=0;e<ba.length;e++)if(!Pb(a,b,ba[e])){a.destination=null;e++;ba.splice(0,e);return}ba.splice(0,e);var ca=a.partialBoundaries;for(e=0;e<ca.length;e++){var mb=ca[e];a:{f=a;g=b;var da=mb.completedSegments;
	for(h=0;h<da.length;h++)if(!Qb(f,g,mb,da[h])){h++;da.splice(0,h);var nb=!1;break a}da.splice(0,h);nb=!0;}if(!nb){a.destination=null;e++;ca.splice(0,e);return}}ca.splice(0,e);var ea=a.completedBoundaries;for(e=0;e<ea.length;e++)if(!Pb(a,b,ea[e])){a.destination=null;e++;ea.splice(0,e);return}ea.splice(0,e);}finally{0===a.allPendingTasks&&0===a.pingedTasks.length&&0===a.clientRenderedBoundaries.length&&0===a.completedBoundaries.length&&b.push(null);}}
	function Rb(a,b){try{var c=a.abortableTasks;c.forEach(function(c){return Lb(c,a,b)});c.clear();null!==a.destination&&Mb(a,a.destination);}catch(d){V(a,d),W(a,d);}}function Sb(){}
	function Tb(a,b,c,d){var f=false,e=null,g="",h={push:function(a){null!==a&&(g+=a);return  true},destroy:function(a){f=true;e=a;}},k=false;a=Ab(a,Ea(c,b?b.identifierPrefix:undefined),{insertionMode:1,selectedValue:null},Infinity,Sb,undefined,function(){k=true;});Cb(a);Rb(a,d);if(1===a.status)a.status=2,h.destroy(a.fatalError);else if(2!==a.status&&null===a.destination){a.destination=h;try{Mb(a,h);}catch(m){V(a,m),W(a,m);}}if(f)throw e;if(!k)throw Error(l(426));return g}
	reactDomServerLegacy_browser_production_min.renderToNodeStream=function(){throw Error(l(207));};reactDomServerLegacy_browser_production_min.renderToStaticMarkup=function(a,b){return Tb(a,b,true,'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server')};reactDomServerLegacy_browser_production_min.renderToStaticNodeStream=function(){throw Error(l(208));};reactDomServerLegacy_browser_production_min.renderToString=function(a,b){return Tb(a,b,false,'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server')};
	reactDomServerLegacy_browser_production_min.version="18.3.1";
	return reactDomServerLegacy_browser_production_min;
}

var reactDomServer_browser_production_min = {};

/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactDomServer_browser_production_min;

function requireReactDomServer_browser_production_min () {
	if (hasRequiredReactDomServer_browser_production_min) return reactDomServer_browser_production_min;
	hasRequiredReactDomServer_browser_production_min = 1;
var aa=React__default;function k(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var l=null,n=0;
	function p(a,b){if(0!==b.length)if(512<b.length)0<n&&(a.enqueue(new Uint8Array(l.buffer,0,n)),l=new Uint8Array(512),n=0),a.enqueue(b);else {var c=l.length-n;c<b.length&&(0===c?a.enqueue(l):(l.set(b.subarray(0,c),n),a.enqueue(l),b=b.subarray(c)),l=new Uint8Array(512),n=0);l.set(b,n);n+=b.length;}}function t(a,b){p(a,b);return  true}function ba(a){l&&0<n&&(a.enqueue(new Uint8Array(l.buffer,0,n)),l=null,n=0);}var ca=new TextEncoder;function u(a){return ca.encode(a)}function w(a){return ca.encode(a)}
	function da(a,b){"function"===typeof a.error?a.error(b):a.close();}var x=Object.prototype.hasOwnProperty,ea=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,fa={},ha={};
	function ia(a){if(x.call(ha,a))return  true;if(x.call(fa,a))return  false;if(ea.test(a))return ha[a]=true;fa[a]=true;return  false}function y(a,b,c,d,f,e,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=e;this.removeEmptyString=g;}var z={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){z[a]=new y(a,0,false,a,null,false,false);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];z[b]=new y(b,1,false,a[1],null,false,false);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){z[a]=new y(a,2,false,a.toLowerCase(),null,false,false);});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){z[a]=new y(a,2,false,a,null,false,false);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){z[a]=new y(a,3,false,a.toLowerCase(),null,false,false);});
	["checked","multiple","muted","selected"].forEach(function(a){z[a]=new y(a,3,true,a,null,false,false);});["capture","download"].forEach(function(a){z[a]=new y(a,4,false,a,null,false,false);});["cols","rows","size","span"].forEach(function(a){z[a]=new y(a,6,false,a,null,false,false);});["rowSpan","start"].forEach(function(a){z[a]=new y(a,5,false,a.toLowerCase(),null,false,false);});var ja=/[\-:]([a-z])/g;function ka(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ja,
	ka);z[b]=new y(b,1,false,a,null,false,false);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ja,ka);z[b]=new y(b,1,false,a,"http://www.w3.org/1999/xlink",false,false);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ja,ka);z[b]=new y(b,1,false,a,"http://www.w3.org/XML/1998/namespace",false,false);});["tabIndex","crossOrigin"].forEach(function(a){z[a]=new y(a,1,false,a.toLowerCase(),null,false,false);});
	z.xlinkHref=new y("xlinkHref",1,false,"xlink:href","http://www.w3.org/1999/xlink",true,false);["src","href","action","formAction"].forEach(function(a){z[a]=new y(a,1,false,a.toLowerCase(),null,true,true);});
	var B={animationIterationCount:true,aspectRatio:true,borderImageOutset:true,borderImageSlice:true,borderImageWidth:true,boxFlex:true,boxFlexGroup:true,boxOrdinalGroup:true,columnCount:true,columns:true,flex:true,flexGrow:true,flexPositive:true,flexShrink:true,flexNegative:true,flexOrder:true,gridArea:true,gridRow:true,gridRowEnd:true,gridRowSpan:true,gridRowStart:true,gridColumn:true,gridColumnEnd:true,gridColumnSpan:true,gridColumnStart:true,fontWeight:true,lineClamp:true,lineHeight:true,opacity:true,order:true,orphans:true,tabSize:true,widows:true,zIndex:true,zoom:true,
	fillOpacity:true,floodOpacity:true,stopOpacity:true,strokeDasharray:true,strokeDashoffset:true,strokeMiterlimit:true,strokeOpacity:true,strokeWidth:true},la=["Webkit","ms","Moz","O"];Object.keys(B).forEach(function(a){la.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);B[b]=B[a];});});var oa=/["'&<>]/;
	function C(a){if("boolean"===typeof a||"number"===typeof a)return ""+a;a=""+a;var b=oa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b;}a=f!==d?c+a.substring(f,d):c;}return a}
	var pa=/([A-Z])/g,qa=/^ms-/,ra=Array.isArray,sa=w("<script>"),ta=w("\x3c/script>"),ua=w('<script src="'),va=w('<script type="module" src="'),wa=w('" async="">\x3c/script>'),xa=/(<\/|<)(s)(cript)/gi;function ya(a,b,c,d){return ""+b+("s"===c?"\\u0073":"\\u0053")+d}
	function za(a,b,c,d,f){a=undefined===a?"":a;b=undefined===b?sa:w('<script nonce="'+C(b)+'">');var e=[];undefined!==c&&e.push(b,u((""+c).replace(xa,ya)),ta);if(undefined!==d)for(c=0;c<d.length;c++)e.push(ua,u(C(d[c])),wa);if(undefined!==f)for(d=0;d<f.length;d++)e.push(va,u(C(f[d])),wa);return {bootstrapChunks:e,startInlineScript:b,placeholderPrefix:w(a+"P:"),segmentPrefix:w(a+"S:"),boundaryPrefix:a+"B:",idPrefix:a,nextSuspenseID:0,sentCompleteSegmentFunction:false,sentCompleteBoundaryFunction:false,sentClientRenderFunction:false}}
	function D(a,b){return {insertionMode:a,selectedValue:b}}function Aa(a){return D("http://www.w3.org/2000/svg"===a?2:"http://www.w3.org/1998/Math/MathML"===a?3:0,null)}
	function Ba(a,b,c){switch(b){case "select":return D(1,null!=c.value?c.value:c.defaultValue);case "svg":return D(2,null);case "math":return D(3,null);case "foreignObject":return D(1,null);case "table":return D(4,null);case "thead":case "tbody":case "tfoot":return D(5,null);case "colgroup":return D(7,null);case "tr":return D(6,null)}return 4<=a.insertionMode||0===a.insertionMode?D(1,null):a}var Ca=w("\x3c!-- --\x3e");function Da(a,b,c,d){if(""===b)return d;d&&a.push(Ca);a.push(u(C(b)));return  true}
	var Ea=new Map,Fa=w(' style="'),Ga=w(":"),Ha=w(";");
	function Ia(a,b,c){if("object"!==typeof c)throw Error(k(62));b=true;for(var d in c)if(x.call(c,d)){var f=c[d];if(null!=f&&"boolean"!==typeof f&&""!==f){if(0===d.indexOf("--")){var e=u(C(d));f=u(C((""+f).trim()));}else {e=d;var g=Ea.get(e);undefined!==g?e=g:(g=w(C(e.replace(pa,"-$1").toLowerCase().replace(qa,"-ms-"))),Ea.set(e,g),e=g);f="number"===typeof f?0===f||x.call(B,d)?u(""+f):u(f+"px"):u(C((""+f).trim()));}b?(b=false,a.push(Fa,e,Ga,f)):a.push(Ha,e,Ga,f);}}b||a.push(E);}
	var H=w(" "),I=w('="'),E=w('"'),Ja=w('=""');
	function J(a,b,c,d){switch(c){case "style":Ia(a,b,d);return;case "defaultValue":case "defaultChecked":case "innerHTML":case "suppressContentEditableWarning":case "suppressHydrationWarning":return}if(!(2<c.length)||"o"!==c[0]&&"O"!==c[0]||"n"!==c[1]&&"N"!==c[1])if(b=z.hasOwnProperty(c)?z[c]:null,null!==b){switch(typeof d){case "function":case "symbol":return;case "boolean":if(!b.acceptsBooleans)return}c=u(b.attributeName);switch(b.type){case 3:d&&a.push(H,c,Ja);break;case 4:true===d?a.push(H,c,Ja):false!==
	d&&a.push(H,c,I,u(C(d)),E);break;case 5:isNaN(d)||a.push(H,c,I,u(C(d)),E);break;case 6:!isNaN(d)&&1<=d&&a.push(H,c,I,u(C(d)),E);break;default:b.sanitizeURL&&(d=""+d),a.push(H,c,I,u(C(d)),E);}}else if(ia(c)){switch(typeof d){case "function":case "symbol":return;case "boolean":if(b=c.toLowerCase().slice(0,5),"data-"!==b&&"aria-"!==b)return}a.push(H,u(c),I,u(C(d)),E);}}var K=w(">"),Ka=w("/>");
	function L(a,b,c){if(null!=b){if(null!=c)throw Error(k(60));if("object"!==typeof b||!("__html"in b))throw Error(k(61));b=b.__html;null!==b&&undefined!==b&&a.push(u(""+b));}}function La(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}var Ma=w(' selected=""');
	function Na(a,b,c,d){a.push(M(c));var f=c=null,e;for(e in b)if(x.call(b,e)){var g=b[e];if(null!=g)switch(e){case "children":c=g;break;case "dangerouslySetInnerHTML":f=g;break;default:J(a,d,e,g);}}a.push(K);L(a,f,c);return "string"===typeof c?(a.push(u(C(c))),null):c}var Oa=w("\n"),Pa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Qa=new Map;function M(a){var b=Qa.get(a);if(undefined===b){if(!Pa.test(a))throw Error(k(65,a));b=w("<"+a);Qa.set(a,b);}return b}var Ra=w("<!DOCTYPE html>");
	function Sa(a,b,c,d,f){switch(b){case "select":a.push(M("select"));var e=null,g=null;for(r in c)if(x.call(c,r)){var h=c[r];if(null!=h)switch(r){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "defaultValue":case "value":break;default:J(a,d,r,h);}}a.push(K);L(a,g,e);return e;case "option":g=f.selectedValue;a.push(M("option"));var m=h=null,q=null;var r=null;for(e in c)if(x.call(c,e)){var v=c[e];if(null!=v)switch(e){case "children":h=v;break;case "selected":q=v;break;case "dangerouslySetInnerHTML":r=
	v;break;case "value":m=v;default:J(a,d,e,v);}}if(null!=g)if(c=null!==m?""+m:La(h),ra(g))for(d=0;d<g.length;d++){if(""+g[d]===c){a.push(Ma);break}}else ""+g===c&&a.push(Ma);else q&&a.push(Ma);a.push(K);L(a,r,h);return h;case "textarea":a.push(M("textarea"));r=g=e=null;for(h in c)if(x.call(c,h)&&(m=c[h],null!=m))switch(h){case "children":r=m;break;case "value":e=m;break;case "defaultValue":g=m;break;case "dangerouslySetInnerHTML":throw Error(k(91));default:J(a,d,h,m);}null===e&&null!==g&&(e=g);a.push(K);
	if(null!=r){if(null!=e)throw Error(k(92));if(ra(r)&&1<r.length)throw Error(k(93));e=""+r;}"string"===typeof e&&"\n"===e[0]&&a.push(Oa);null!==e&&a.push(u(C(""+e)));return null;case "input":a.push(M("input"));m=r=h=e=null;for(g in c)if(x.call(c,g)&&(q=c[g],null!=q))switch(g){case "children":case "dangerouslySetInnerHTML":throw Error(k(399,"input"));case "defaultChecked":m=q;break;case "defaultValue":h=q;break;case "checked":r=q;break;case "value":e=q;break;default:J(a,d,g,q);}null!==r?J(a,d,"checked",
	r):null!==m&&J(a,d,"checked",m);null!==e?J(a,d,"value",e):null!==h&&J(a,d,"value",h);a.push(Ka);return null;case "menuitem":a.push(M("menuitem"));for(var A in c)if(x.call(c,A)&&(e=c[A],null!=e))switch(A){case "children":case "dangerouslySetInnerHTML":throw Error(k(400));default:J(a,d,A,e);}a.push(K);return null;case "title":a.push(M("title"));e=null;for(v in c)if(x.call(c,v)&&(g=c[v],null!=g))switch(v){case "children":e=g;break;case "dangerouslySetInnerHTML":throw Error(k(434));default:J(a,d,v,g);}a.push(K);
	return e;case "listing":case "pre":a.push(M(b));g=e=null;for(m in c)if(x.call(c,m)&&(h=c[m],null!=h))switch(m){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;default:J(a,d,m,h);}a.push(K);if(null!=g){if(null!=e)throw Error(k(60));if("object"!==typeof g||!("__html"in g))throw Error(k(61));c=g.__html;null!==c&&undefined!==c&&("string"===typeof c&&0<c.length&&"\n"===c[0]?a.push(Oa,u(c)):a.push(u(""+c)));}"string"===typeof e&&"\n"===e[0]&&a.push(Oa);return e;case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":a.push(M(b));
	for(var F in c)if(x.call(c,F)&&(e=c[F],null!=e))switch(F){case "children":case "dangerouslySetInnerHTML":throw Error(k(399,b));default:J(a,d,F,e);}a.push(Ka);return null;case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return Na(a,c,b,d);case "html":return 0===f.insertionMode&&a.push(Ra),Na(a,c,b,d);default:if(-1===b.indexOf("-")&&"string"!==typeof c.is)return Na(a,c,b,d);a.push(M(b));
	g=e=null;for(q in c)if(x.call(c,q)&&(h=c[q],null!=h))switch(q){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "style":Ia(a,d,h);break;case "suppressContentEditableWarning":case "suppressHydrationWarning":break;default:ia(q)&&"function"!==typeof h&&"symbol"!==typeof h&&a.push(H,u(q),I,u(C(h)),E);}a.push(K);L(a,g,e);return e}}
	var Ta=w("</"),Ua=w(">"),Va=w('<template id="'),Wa=w('"></template>'),Xa=w("\x3c!--$--\x3e"),Ya=w('\x3c!--$?--\x3e<template id="'),Za=w('"></template>'),$a=w("\x3c!--$!--\x3e"),ab=w("\x3c!--/$--\x3e"),bb=w("<template"),cb=w('"'),db=w(' data-dgst="');w(' data-msg="');w(' data-stck="');var eb=w("></template>");function fb(a,b,c){p(a,Ya);if(null===c)throw Error(k(395));p(a,c);return t(a,Za)}
	var gb=w('<div hidden id="'),hb=w('">'),ib=w("</div>"),jb=w('<svg aria-hidden="true" style="display:none" id="'),kb=w('">'),lb=w("</svg>"),mb=w('<math aria-hidden="true" style="display:none" id="'),nb=w('">'),ob=w("</math>"),pb=w('<table hidden id="'),qb=w('">'),rb=w("</table>"),sb=w('<table hidden><tbody id="'),tb=w('">'),ub=w("</tbody></table>"),vb=w('<table hidden><tr id="'),wb=w('">'),xb=w("</tr></table>"),yb=w('<table hidden><colgroup id="'),zb=w('">'),Ab=w("</colgroup></table>");
	function Bb(a,b,c,d){switch(c.insertionMode){case 0:case 1:return p(a,gb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,hb);case 2:return p(a,jb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,kb);case 3:return p(a,mb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,nb);case 4:return p(a,pb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,qb);case 5:return p(a,sb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,tb);case 6:return p(a,vb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,wb);case 7:return p(a,
	yb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,zb);default:throw Error(k(397));}}function Cb(a,b){switch(b.insertionMode){case 0:case 1:return t(a,ib);case 2:return t(a,lb);case 3:return t(a,ob);case 4:return t(a,rb);case 5:return t(a,ub);case 6:return t(a,xb);case 7:return t(a,Ab);default:throw Error(k(397));}}
	var Db=w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'),Eb=w('$RS("'),Gb=w('","'),Hb=w('")\x3c/script>'),Ib=w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'),
	Jb=w('$RC("'),Kb=w('","'),Lb=w('")\x3c/script>'),Mb=w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'),Nb=w('$RX("'),Ob=w('"'),Pb=w(")\x3c/script>"),Qb=w(","),Rb=/[<\u2028\u2029]/g;
	function Sb(a){return JSON.stringify(a).replace(Rb,function(a){switch(a){case "<":return "\\u003c";case "\u2028":return "\\u2028";case "\u2029":return "\\u2029";default:throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");}})}
	var N=Object.assign,Tb=Symbol.for("react.element"),Ub=Symbol.for("react.portal"),Vb=Symbol.for("react.fragment"),Wb=Symbol.for("react.strict_mode"),Xb=Symbol.for("react.profiler"),Yb=Symbol.for("react.provider"),Zb=Symbol.for("react.context"),$b=Symbol.for("react.forward_ref"),ac=Symbol.for("react.suspense"),bc=Symbol.for("react.suspense_list"),cc=Symbol.for("react.memo"),dc=Symbol.for("react.lazy"),ec=Symbol.for("react.scope"),fc=Symbol.for("react.debug_trace_mode"),gc=Symbol.for("react.legacy_hidden"),
	hc=Symbol.for("react.default_value"),ic=Symbol.iterator;
	function jc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Vb:return "Fragment";case Ub:return "Portal";case Xb:return "Profiler";case Wb:return "StrictMode";case ac:return "Suspense";case bc:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Zb:return (a.displayName||"Context")+".Consumer";case Yb:return (a._context.displayName||"Context")+".Provider";case $b:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case cc:return b=a.displayName||null,null!==b?b:jc(a.type)||"Memo";case dc:b=a._payload;a=a._init;try{return jc(a(b))}catch(c){}}return null}var kc={};function lc(a,b){a=a.contextTypes;if(!a)return kc;var c={},d;for(d in a)c[d]=b[d];return c}var O=null;
	function P(a,b){if(a!==b){a.context._currentValue=a.parentValue;a=a.parent;var c=b.parent;if(null===a){if(null!==c)throw Error(k(401));}else {if(null===c)throw Error(k(401));P(a,c);}b.context._currentValue=b.value;}}function mc(a){a.context._currentValue=a.parentValue;a=a.parent;null!==a&&mc(a);}function nc(a){var b=a.parent;null!==b&&nc(b);a.context._currentValue=a.value;}
	function oc(a,b){a.context._currentValue=a.parentValue;a=a.parent;if(null===a)throw Error(k(402));a.depth===b.depth?P(a,b):oc(a,b);}function pc(a,b){var c=b.parent;if(null===c)throw Error(k(402));a.depth===c.depth?P(a,c):pc(a,c);b.context._currentValue=b.value;}function Q(a){var b=O;b!==a&&(null===b?nc(a):null===a?mc(b):b.depth===a.depth?P(b,a):b.depth>a.depth?oc(b,a):pc(b,a),O=a);}
	var qc={isMounted:function(){return  false},enqueueSetState:function(a,b){a=a._reactInternals;null!==a.queue&&a.queue.push(b);},enqueueReplaceState:function(a,b){a=a._reactInternals;a.replace=true;a.queue=[b];},enqueueForceUpdate:function(){}};
	function rc(a,b,c,d){var f=undefined!==a.state?a.state:null;a.updater=qc;a.props=c;a.state=f;var e={queue:[],replace:false};a._reactInternals=e;var g=b.contextType;a.context="object"===typeof g&&null!==g?g._currentValue:d;g=b.getDerivedStateFromProps;"function"===typeof g&&(g=g(c,f),f=null===g||undefined===g?f:N({},f,g),a.state=f);if("function"!==typeof b.getDerivedStateFromProps&&"function"!==typeof a.getSnapshotBeforeUpdate&&("function"===typeof a.UNSAFE_componentWillMount||"function"===typeof a.componentWillMount))if(b=
	a.state,"function"===typeof a.componentWillMount&&a.componentWillMount(),"function"===typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount(),b!==a.state&&qc.enqueueReplaceState(a,a.state,null),null!==e.queue&&0<e.queue.length)if(b=e.queue,g=e.replace,e.queue=null,e.replace=false,g&&1===b.length)a.state=b[0];else {e=g?b[0]:a.state;f=true;for(g=g?1:0;g<b.length;g++){var h=b[g];h="function"===typeof h?h.call(a,e,c,d):h;null!=h&&(f?(f=false,e=N({},e,h)):N(e,h));}a.state=e;}else e.queue=null;}
	var sc={id:1,overflow:""};function tc(a,b,c){var d=a.id;a=a.overflow;var f=32-uc(d)-1;d&=~(1<<f);c+=1;var e=32-uc(b)+f;if(30<e){var g=f-f%5;e=(d&(1<<g)-1).toString(32);d>>=g;f-=g;return {id:1<<32-uc(b)+f|c<<f|d,overflow:e+a}}return {id:1<<e|c<<f|d,overflow:a}}var uc=Math.clz32?Math.clz32:vc,wc=Math.log,xc=Math.LN2;function vc(a){a>>>=0;return 0===a?32:31-(wc(a)/xc|0)|0}function yc(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var zc="function"===typeof Object.is?Object.is:yc,R=null,Ac=null,Bc=null,S=null,T=false,Cc=false,U=0,V=null,Dc=0;function W(){if(null===R)throw Error(k(321));return R}function Ec(){if(0<Dc)throw Error(k(312));return {memoizedState:null,queue:null,next:null}}function Fc(){null===S?null===Bc?(T=false,Bc=S=Ec()):(T=true,S=Bc):null===S.next?(T=false,S=S.next=Ec()):(T=true,S=S.next);return S}function Gc(){Ac=R=null;Cc=false;Bc=null;Dc=0;S=V=null;}function Hc(a,b){return "function"===typeof b?b(a):b}
	function Ic(a,b,c){R=W();S=Fc();if(T){var d=S.queue;b=d.dispatch;if(null!==V&&(c=V.get(d),undefined!==c)){V.delete(d);d=S.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);S.memoizedState=d;return [d,b]}return [S.memoizedState,b]}a=a===Hc?"function"===typeof b?b():b:undefined!==c?c(b):b;S.memoizedState=a;a=S.queue={last:null,dispatch:null};a=a.dispatch=Jc.bind(null,R,a);return [S.memoizedState,a]}
	function Kc(a,b){R=W();S=Fc();b=undefined===b?null:b;if(null!==S){var c=S.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=false;else {for(var f=0;f<d.length&&f<b.length;f++)if(!zc(b[f],d[f])){d=false;break a}d=true;}if(d)return c[0]}}a=a();S.memoizedState=[a,b];return a}function Jc(a,b,c){if(25<=Dc)throw Error(k(301));if(a===R)if(Cc=true,a={action:c,next:null},null===V&&(V=new Map),c=V.get(b),undefined===c)V.set(b,a);else {for(b=c;null!==b.next;)b=b.next;b.next=a;}}
	function Lc(){throw Error(k(394));}function Mc(){}
	var Oc={readContext:function(a){return a._currentValue},useContext:function(a){W();return a._currentValue},useMemo:Kc,useReducer:Ic,useRef:function(a){R=W();S=Fc();var b=S.memoizedState;return null===b?(a={current:a},S.memoizedState=a):b},useState:function(a){return Ic(Hc,a)},useInsertionEffect:Mc,useLayoutEffect:function(){},useCallback:function(a,b){return Kc(function(){return a},b)},useImperativeHandle:Mc,useEffect:Mc,useDebugValue:Mc,useDeferredValue:function(a){W();return a},useTransition:function(){W();
	return [false,Lc]},useId:function(){var a=Ac.treeContext;var b=a.overflow;a=a.id;a=(a&~(1<<32-uc(a)-1)).toString(32)+b;var c=Nc;if(null===c)throw Error(k(404));b=U++;a=":"+c.idPrefix+"R"+a;0<b&&(a+="H"+b.toString(32));return a+":"},useMutableSource:function(a,b){W();return b(a._source)},useSyncExternalStore:function(a,b,c){if(undefined===c)throw Error(k(407));return c()}},Nc=null,Pc=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;function Qc(a){console.error(a);return null}
	function X(){}
	function Rc(a,b,c,d,f,e,g,h,m){var q=[],r=new Set;b={destination:null,responseState:b,progressiveChunkSize:undefined===d?12800:d,status:0,fatalError:null,nextSegmentId:0,allPendingTasks:0,pendingRootTasks:0,completedRootSegment:null,abortableTasks:r,pingedTasks:q,clientRenderedBoundaries:[],completedBoundaries:[],partialBoundaries:[],onError:undefined===f?Qc:f,onAllReady:undefined===e?X:e,onShellReady:undefined===g?X:g,onShellError:undefined===h?X:h,onFatalError:undefined===m?X:m};c=Sc(b,0,null,c,false,false);c.parentFlushed=
	true;a=Tc(b,a,null,c,r,kc,null,sc);q.push(a);return b}function Tc(a,b,c,d,f,e,g,h){a.allPendingTasks++;null===c?a.pendingRootTasks++:c.pendingTasks++;var m={node:b,ping:function(){var b=a.pingedTasks;b.push(m);1===b.length&&Uc(a);},blockedBoundary:c,blockedSegment:d,abortSet:f,legacyContext:e,context:g,treeContext:h};f.add(m);return m}function Sc(a,b,c,d,f,e){return {status:0,id:-1,index:b,parentFlushed:false,chunks:[],children:[],formatContext:d,boundary:c,lastPushedText:f,textEmbedded:e}}
	function Y(a,b){a=a.onError(b);if(null!=a&&"string"!==typeof a)throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "'+typeof a+'" instead');return a}function Vc(a,b){var c=a.onShellError;c(b);c=a.onFatalError;c(b);null!==a.destination?(a.status=2,da(a.destination,b)):(a.status=1,a.fatalError=b);}
	function Wc(a,b,c,d,f){R={};Ac=b;U=0;for(a=c(d,f);Cc;)Cc=false,U=0,Dc+=1,S=null,a=c(d,f);Gc();return a}function Xc(a,b,c,d){var f=c.render(),e=d.childContextTypes;if(null!==e&&undefined!==e){var g=b.legacyContext;if("function"!==typeof c.getChildContext)d=g;else {c=c.getChildContext();for(var h in c)if(!(h in e))throw Error(k(108,jc(d)||"Unknown",h));d=N({},g,c);}b.legacyContext=d;Z(a,b,f);b.legacyContext=g;}else Z(a,b,f);}
	function Yc(a,b){if(a&&a.defaultProps){b=N({},b);a=a.defaultProps;for(var c in a) undefined===b[c]&&(b[c]=a[c]);return b}return b}
	function Zc(a,b,c,d,f){if("function"===typeof c)if(c.prototype&&c.prototype.isReactComponent){f=lc(c,b.legacyContext);var e=c.contextType;e=new c(d,"object"===typeof e&&null!==e?e._currentValue:f);rc(e,c,d,f);Xc(a,b,e,c);}else {e=lc(c,b.legacyContext);f=Wc(a,b,c,d,e);var g=0!==U;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&undefined===f.$$typeof)rc(f,c,d,e),Xc(a,b,f,c);else if(g){d=b.treeContext;b.treeContext=tc(d,1,0);try{Z(a,b,f);}finally{b.treeContext=d;}}else Z(a,b,f);}else if("string"===
	typeof c){f=b.blockedSegment;e=Sa(f.chunks,c,d,a.responseState,f.formatContext);f.lastPushedText=false;g=f.formatContext;f.formatContext=Ba(g,c,d);$c(a,b,e);f.formatContext=g;switch(c){case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "input":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":break;default:f.chunks.push(Ta,u(c),Ua);}f.lastPushedText=false;}else {switch(c){case gc:case fc:case Wb:case Xb:case Vb:Z(a,b,d.children);return;
	case bc:Z(a,b,d.children);return;case ec:throw Error(k(343));case ac:a:{c=b.blockedBoundary;f=b.blockedSegment;e=d.fallback;d=d.children;g=new Set;var h={id:null,rootSegmentID:-1,parentFlushed:false,pendingTasks:0,forceClientRender:false,completedSegments:[],byteSize:0,fallbackAbortableTasks:g,errorDigest:null},m=Sc(a,f.chunks.length,h,f.formatContext,false,false);f.children.push(m);f.lastPushedText=false;var q=Sc(a,0,null,f.formatContext,false,false);q.parentFlushed=true;b.blockedBoundary=h;b.blockedSegment=q;try{if($c(a,
	b,d),q.lastPushedText&&q.textEmbedded&&q.chunks.push(Ca),q.status=1,ad(h,q),0===h.pendingTasks)break a}catch(r){q.status=4,h.forceClientRender=true,h.errorDigest=Y(a,r);}finally{b.blockedBoundary=c,b.blockedSegment=f;}b=Tc(a,e,c,m,g,b.legacyContext,b.context,b.treeContext);a.pingedTasks.push(b);}return}if("object"===typeof c&&null!==c)switch(c.$$typeof){case $b:d=Wc(a,b,c.render,d,f);if(0!==U){c=b.treeContext;b.treeContext=tc(c,1,0);try{Z(a,b,d);}finally{b.treeContext=c;}}else Z(a,b,d);return;case cc:c=
	c.type;d=Yc(c,d);Zc(a,b,c,d,f);return;case Yb:f=d.children;c=c._context;d=d.value;e=c._currentValue;c._currentValue=d;g=O;O=d={parent:g,depth:null===g?0:g.depth+1,context:c,parentValue:e,value:d};b.context=d;Z(a,b,f);a=O;if(null===a)throw Error(k(403));d=a.parentValue;a.context._currentValue=d===hc?a.context._defaultValue:d;a=O=a.parent;b.context=a;return;case Zb:d=d.children;d=d(c._currentValue);Z(a,b,d);return;case dc:f=c._init;c=f(c._payload);d=Yc(c,d);Zc(a,b,c,d,undefined);return}throw Error(k(130,
	null==c?c:typeof c,""));}}
	function Z(a,b,c){b.node=c;if("object"===typeof c&&null!==c){switch(c.$$typeof){case Tb:Zc(a,b,c.type,c.props,c.ref);return;case Ub:throw Error(k(257));case dc:var d=c._init;c=d(c._payload);Z(a,b,c);return}if(ra(c)){bd(a,b,c);return}null===c||"object"!==typeof c?d=null:(d=ic&&c[ic]||c["@@iterator"],d="function"===typeof d?d:null);if(d&&(d=d.call(c))){c=d.next();if(!c.done){var f=[];do f.push(c.value),c=d.next();while(!c.done);bd(a,b,f);}return}a=Object.prototype.toString.call(c);throw Error(k(31,"[object Object]"===
	a?"object with keys {"+Object.keys(c).join(", ")+"}":a));}"string"===typeof c?(d=b.blockedSegment,d.lastPushedText=Da(b.blockedSegment.chunks,c,a.responseState,d.lastPushedText)):"number"===typeof c&&(d=b.blockedSegment,d.lastPushedText=Da(b.blockedSegment.chunks,""+c,a.responseState,d.lastPushedText));}function bd(a,b,c){for(var d=c.length,f=0;f<d;f++){var e=b.treeContext;b.treeContext=tc(e,d,f);try{$c(a,b,c[f]);}finally{b.treeContext=e;}}}
	function $c(a,b,c){var d=b.blockedSegment.formatContext,f=b.legacyContext,e=b.context;try{return Z(a,b,c)}catch(m){if(Gc(),"object"===typeof m&&null!==m&&"function"===typeof m.then){c=m;var g=b.blockedSegment,h=Sc(a,g.chunks.length,null,g.formatContext,g.lastPushedText,true);g.children.push(h);g.lastPushedText=false;a=Tc(a,b.node,b.blockedBoundary,h,b.abortSet,b.legacyContext,b.context,b.treeContext).ping;c.then(a,a);b.blockedSegment.formatContext=d;b.legacyContext=f;b.context=e;Q(e);}else throw b.blockedSegment.formatContext=
	d,b.legacyContext=f,b.context=e,Q(e),m;}}function cd(a){var b=a.blockedBoundary;a=a.blockedSegment;a.status=3;dd(this,b,a);}
	function ed(a,b,c){var d=a.blockedBoundary;a.blockedSegment.status=3;null===d?(b.allPendingTasks--,2!==b.status&&(b.status=2,null!==b.destination&&b.destination.close())):(d.pendingTasks--,d.forceClientRender||(d.forceClientRender=true,a=undefined===c?Error(k(432)):c,d.errorDigest=b.onError(a),d.parentFlushed&&b.clientRenderedBoundaries.push(d)),d.fallbackAbortableTasks.forEach(function(a){return ed(a,b,c)}),d.fallbackAbortableTasks.clear(),b.allPendingTasks--,0===b.allPendingTasks&&(d=b.onAllReady,d()));}
	function ad(a,b){if(0===b.chunks.length&&1===b.children.length&&null===b.children[0].boundary){var c=b.children[0];c.id=b.id;c.parentFlushed=true;1===c.status&&ad(a,c);}else a.completedSegments.push(b);}
	function dd(a,b,c){if(null===b){if(c.parentFlushed){if(null!==a.completedRootSegment)throw Error(k(389));a.completedRootSegment=c;}a.pendingRootTasks--;0===a.pendingRootTasks&&(a.onShellError=X,b=a.onShellReady,b());}else b.pendingTasks--,b.forceClientRender||(0===b.pendingTasks?(c.parentFlushed&&1===c.status&&ad(b,c),b.parentFlushed&&a.completedBoundaries.push(b),b.fallbackAbortableTasks.forEach(cd,a),b.fallbackAbortableTasks.clear()):c.parentFlushed&&1===c.status&&(ad(b,c),1===b.completedSegments.length&&
	b.parentFlushed&&a.partialBoundaries.push(b)));a.allPendingTasks--;0===a.allPendingTasks&&(a=a.onAllReady,a());}
	function Uc(a){if(2!==a.status){var b=O,c=Pc.current;Pc.current=Oc;var d=Nc;Nc=a.responseState;try{var f=a.pingedTasks,e;for(e=0;e<f.length;e++){var g=f[e];var h=a,m=g.blockedSegment;if(0===m.status){Q(g.context);try{Z(h,g,g.node),m.lastPushedText&&m.textEmbedded&&m.chunks.push(Ca),g.abortSet.delete(g),m.status=1,dd(h,g.blockedBoundary,m);}catch(G){if(Gc(),"object"===typeof G&&null!==G&&"function"===typeof G.then){var q=g.ping;G.then(q,q);}else {g.abortSet.delete(g);m.status=4;var r=g.blockedBoundary,
	v=G,A=Y(h,v);null===r?Vc(h,v):(r.pendingTasks--,r.forceClientRender||(r.forceClientRender=!0,r.errorDigest=A,r.parentFlushed&&h.clientRenderedBoundaries.push(r)));h.allPendingTasks--;if(0===h.allPendingTasks){var F=h.onAllReady;F();}}}finally{}}}f.splice(0,e);null!==a.destination&&fd(a,a.destination);}catch(G){Y(a,G),Vc(a,G);}finally{Nc=d,Pc.current=c,c===Oc&&Q(b);}}}
	function gd(a,b,c){c.parentFlushed=true;switch(c.status){case 0:var d=c.id=a.nextSegmentId++;c.lastPushedText=false;c.textEmbedded=false;a=a.responseState;p(b,Va);p(b,a.placeholderPrefix);a=u(d.toString(16));p(b,a);return t(b,Wa);case 1:c.status=2;var f=true;d=c.chunks;var e=0;c=c.children;for(var g=0;g<c.length;g++){for(f=c[g];e<f.index;e++)p(b,d[e]);f=hd(a,b,f);}for(;e<d.length-1;e++)p(b,d[e]);e<d.length&&(f=t(b,d[e]));return f;default:throw Error(k(390));}}
	function hd(a,b,c){var d=c.boundary;if(null===d)return gd(a,b,c);d.parentFlushed=true;if(d.forceClientRender)d=d.errorDigest,t(b,$a),p(b,bb),d&&(p(b,db),p(b,u(C(d))),p(b,cb)),t(b,eb),gd(a,b,c);else if(0<d.pendingTasks){d.rootSegmentID=a.nextSegmentId++;0<d.completedSegments.length&&a.partialBoundaries.push(d);var f=a.responseState;var e=f.nextSuspenseID++;f=w(f.boundaryPrefix+e.toString(16));d=d.id=f;fb(b,a.responseState,d);gd(a,b,c);}else if(d.byteSize>a.progressiveChunkSize)d.rootSegmentID=a.nextSegmentId++,
	a.completedBoundaries.push(d),fb(b,a.responseState,d.id),gd(a,b,c);else {t(b,Xa);c=d.completedSegments;if(1!==c.length)throw Error(k(391));hd(a,b,c[0]);}return t(b,ab)}function id(a,b,c){Bb(b,a.responseState,c.formatContext,c.id);hd(a,b,c);return Cb(b,c.formatContext)}
	function jd(a,b,c){for(var d=c.completedSegments,f=0;f<d.length;f++)kd(a,b,c,d[f]);d.length=0;a=a.responseState;d=c.id;c=c.rootSegmentID;p(b,a.startInlineScript);a.sentCompleteBoundaryFunction?p(b,Jb):(a.sentCompleteBoundaryFunction=true,p(b,Ib));if(null===d)throw Error(k(395));c=u(c.toString(16));p(b,d);p(b,Kb);p(b,a.segmentPrefix);p(b,c);return t(b,Lb)}
	function kd(a,b,c,d){if(2===d.status)return  true;var f=d.id;if(-1===f){if(-1===(d.id=c.rootSegmentID))throw Error(k(392));return id(a,b,d)}id(a,b,d);a=a.responseState;p(b,a.startInlineScript);a.sentCompleteSegmentFunction?p(b,Eb):(a.sentCompleteSegmentFunction=true,p(b,Db));p(b,a.segmentPrefix);f=u(f.toString(16));p(b,f);p(b,Gb);p(b,a.placeholderPrefix);p(b,f);return t(b,Hb)}
	function fd(a,b){l=new Uint8Array(512);n=0;try{var c=a.completedRootSegment;if(null!==c&&0===a.pendingRootTasks){hd(a,b,c);a.completedRootSegment=null;var d=a.responseState.bootstrapChunks;for(c=0;c<d.length-1;c++)p(b,d[c]);c<d.length&&t(b,d[c]);}var f=a.clientRenderedBoundaries,e;for(e=0;e<f.length;e++){var g=f[e];d=b;var h=a.responseState,m=g.id,q=g.errorDigest,r=g.errorMessage,v=g.errorComponentStack;p(d,h.startInlineScript);h.sentClientRenderFunction?p(d,Nb):(h.sentClientRenderFunction=!0,p(d,
	Mb));if(null===m)throw Error(k(395));p(d,m);p(d,Ob);if(q||r||v)p(d,Qb),p(d,u(Sb(q||"")));if(r||v)p(d,Qb),p(d,u(Sb(r||"")));v&&(p(d,Qb),p(d,u(Sb(v))));if(!t(d,Pb));}f.splice(0,e);var A=a.completedBoundaries;for(e=0;e<A.length;e++)if(!jd(a,b,A[e]));A.splice(0,e);ba(b);l=new Uint8Array(512);n=0;var F=a.partialBoundaries;for(e=0;e<F.length;e++){var G=F[e];a:{f=a;g=b;var ma=G.completedSegments;for(h=0;h<ma.length;h++)if(!kd(f,
	g,G,ma[h])){h++;ma.splice(0,h);var Fb=!1;break a}ma.splice(0,h);Fb=!0;}if(!Fb){a.destination=null;e++;F.splice(0,e);return}}F.splice(0,e);var na=a.completedBoundaries;for(e=0;e<na.length;e++)if(!jd(a,b,na[e]));na.splice(0,e);}finally{ba(b),0===a.allPendingTasks&&0===a.pingedTasks.length&&0===a.clientRenderedBoundaries.length&&0===a.completedBoundaries.length&&b.close();}}
	function ld(a,b){try{var c=a.abortableTasks;c.forEach(function(c){return ed(c,a,b)});c.clear();null!==a.destination&&fd(a,a.destination);}catch(d){Y(a,d),Vc(a,d);}}
	reactDomServer_browser_production_min.renderToReadableStream=function(a,b){return new Promise(function(c,d){var f,e,g=new Promise(function(a,b){e=a;f=b;}),h=Rc(a,za(b?b.identifierPrefix:undefined,b?b.nonce:undefined,b?b.bootstrapScriptContent:undefined,b?b.bootstrapScripts:undefined,b?b.bootstrapModules:undefined),Aa(b?b.namespaceURI:undefined),b?b.progressiveChunkSize:undefined,b?b.onError:undefined,e,function(){var a=new ReadableStream({type:"bytes",pull:function(a){if(1===h.status)h.status=2,da(a,h.fatalError);else if(2!==h.status&&null===h.destination){h.destination=
	a;try{fd(h,a);}catch(A){Y(h,A),Vc(h,A);}}},cancel:function(){ld(h);}},{highWaterMark:0});a.allReady=g;c(a);},function(a){g.catch(function(){});d(a);},f);if(b&&b.signal){var m=b.signal,q=function(){ld(h,m.reason);m.removeEventListener("abort",q);};m.addEventListener("abort",q);}Uc(h);})};reactDomServer_browser_production_min.version="18.3.1";
	return reactDomServer_browser_production_min;
}

var reactDomServerLegacy_browser_development = {};

var hasRequiredReactDomServerLegacy_browser_development;

function requireReactDomServerLegacy_browser_development () {
	if (hasRequiredReactDomServerLegacy_browser_development) return reactDomServerLegacy_browser_development;
	hasRequiredReactDomServerLegacy_browser_development = 1;
	/**
	 * @license React
	 * react-dom-server-legacy.browser.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	    var React = React__default;
	    var ReactVersion = "18.3.1";
	    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	    function warn(format) {
	      {
	        {
	          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	          }
	          printWarning("warn", format, args);
	        }
	      }
	    }
	    function error(format) {
	      {
	        {
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	          printWarning("error", format, args);
	        }
	      }
	    }
	    function printWarning(level, format, args) {
	      {
	        var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
	        var stack = ReactDebugCurrentFrame2.getStackAddendum();
	        if (stack !== "") {
	          format += "%s";
	          args = args.concat([stack]);
	        }
	        var argsWithFormat = args.map(function(item) {
	          return String(item);
	        });
	        argsWithFormat.unshift("Warning: " + format);
	        Function.prototype.apply.call(console[level], console, argsWithFormat);
	      }
	    }
	    function scheduleWork(callback) {
	      callback();
	    }
	    function beginWriting(destination) {
	    }
	    function writeChunk(destination, chunk) {
	      writeChunkAndReturn(destination, chunk);
	    }
	    function writeChunkAndReturn(destination, chunk) {
	      return destination.push(chunk);
	    }
	    function completeWriting(destination) {
	    }
	    function close(destination) {
	      destination.push(null);
	    }
	    function stringToChunk(content) {
	      return content;
	    }
	    function stringToPrecomputedChunk(content) {
	      return content;
	    }
	    function closeWithError(destination, error2) {
	      destination.destroy(error2);
	    }
	    function typeName(value) {
	      {
	        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
	        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
	        return type;
	      }
	    }
	    function willCoercionThrow(value) {
	      {
	        try {
	          testStringCoercion(value);
	          return false;
	        } catch (e) {
	          return true;
	        }
	      }
	    }
	    function testStringCoercion(value) {
	      return "" + value;
	    }
	    function checkAttributeStringCoercion(value, attributeName) {
	      {
	        if (willCoercionThrow(value)) {
	          error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
	          return testStringCoercion(value);
	        }
	      }
	    }
	    function checkCSSPropertyStringCoercion(value, propName) {
	      {
	        if (willCoercionThrow(value)) {
	          error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
	          return testStringCoercion(value);
	        }
	      }
	    }
	    function checkHtmlStringCoercion(value) {
	      {
	        if (willCoercionThrow(value)) {
	          error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
	          return testStringCoercion(value);
	        }
	      }
	    }
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var RESERVED = 0;
	    var STRING = 1;
	    var BOOLEANISH_STRING = 2;
	    var BOOLEAN = 3;
	    var OVERLOADED_BOOLEAN = 4;
	    var NUMERIC = 5;
	    var POSITIVE_NUMERIC = 6;
	    var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	    var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
	    var illegalAttributeNameCache = {};
	    var validatedAttributeNameCache = {};
	    function isAttributeNameSafe(attributeName) {
	      if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
	        return true;
	      }
	      if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
	        return false;
	      }
	      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	        validatedAttributeNameCache[attributeName] = true;
	        return true;
	      }
	      illegalAttributeNameCache[attributeName] = true;
	      {
	        error("Invalid attribute name: `%s`", attributeName);
	      }
	      return false;
	    }
	    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
	      if (propertyInfo !== null && propertyInfo.type === RESERVED) {
	        return false;
	      }
	      switch (typeof value) {
	        case "function":
	        case "symbol":
	          return true;
	        case "boolean": {
	          if (propertyInfo !== null) {
	            return !propertyInfo.acceptsBooleans;
	          } else {
	            var prefix2 = name.toLowerCase().slice(0, 5);
	            return prefix2 !== "data-" && prefix2 !== "aria-";
	          }
	        }
	        default:
	          return false;
	      }
	    }
	    function getPropertyInfo(name) {
	      return properties.hasOwnProperty(name) ? properties[name] : null;
	    }
	    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL2, removeEmptyString) {
	      this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	      this.attributeName = attributeName;
	      this.attributeNamespace = attributeNamespace;
	      this.mustUseProperty = mustUseProperty;
	      this.propertyName = name;
	      this.type = type;
	      this.sanitizeURL = sanitizeURL2;
	      this.removeEmptyString = removeEmptyString;
	    }
	    var properties = {};
	    var reservedProps = [
	      "children",
	      "dangerouslySetInnerHTML",
	      // TODO: This prevents the assignment of defaultValue to regular
	      // elements (not just inputs). Now that ReactDOMInput assigns to the
	      // defaultValue property -- do we need this?
	      "defaultValue",
	      "defaultChecked",
	      "innerHTML",
	      "suppressContentEditableWarning",
	      "suppressHydrationWarning",
	      "style"
	    ];
	    reservedProps.forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        RESERVED,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(_ref) {
	      var name = _ref[0], attributeName = _ref[1];
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEANISH_STRING,
	        false,
	        // mustUseProperty
	        name.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEANISH_STRING,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "allowFullScreen",
	      "async",
	      // Note: there is a special case that prevents it from being written to the DOM
	      // on the client side because the browsers are inconsistent. Instead we call focus().
	      "autoFocus",
	      "autoPlay",
	      "controls",
	      "default",
	      "defer",
	      "disabled",
	      "disablePictureInPicture",
	      "disableRemotePlayback",
	      "formNoValidate",
	      "hidden",
	      "loop",
	      "noModule",
	      "noValidate",
	      "open",
	      "playsInline",
	      "readOnly",
	      "required",
	      "reversed",
	      "scoped",
	      "seamless",
	      // Microdata
	      "itemScope"
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEAN,
	        false,
	        // mustUseProperty
	        name.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "checked",
	      // Note: `option.selected` is not updated if `select.multiple` is
	      // disabled with `removeAttribute`. We have special logic for handling this.
	      "multiple",
	      "muted",
	      "selected"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEAN,
	        true,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "capture",
	      "download"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        OVERLOADED_BOOLEAN,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "cols",
	      "rows",
	      "size",
	      "span"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        POSITIVE_NUMERIC,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["rowSpan", "start"].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        NUMERIC,
	        false,
	        // mustUseProperty
	        name.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    var CAMELIZE = /[\-\:]([a-z])/g;
	    var capitalize = function(token) {
	      return token[1].toUpperCase();
	    };
	    [
	      "accent-height",
	      "alignment-baseline",
	      "arabic-form",
	      "baseline-shift",
	      "cap-height",
	      "clip-path",
	      "clip-rule",
	      "color-interpolation",
	      "color-interpolation-filters",
	      "color-profile",
	      "color-rendering",
	      "dominant-baseline",
	      "enable-background",
	      "fill-opacity",
	      "fill-rule",
	      "flood-color",
	      "flood-opacity",
	      "font-family",
	      "font-size",
	      "font-size-adjust",
	      "font-stretch",
	      "font-style",
	      "font-variant",
	      "font-weight",
	      "glyph-name",
	      "glyph-orientation-horizontal",
	      "glyph-orientation-vertical",
	      "horiz-adv-x",
	      "horiz-origin-x",
	      "image-rendering",
	      "letter-spacing",
	      "lighting-color",
	      "marker-end",
	      "marker-mid",
	      "marker-start",
	      "overline-position",
	      "overline-thickness",
	      "paint-order",
	      "panose-1",
	      "pointer-events",
	      "rendering-intent",
	      "shape-rendering",
	      "stop-color",
	      "stop-opacity",
	      "strikethrough-position",
	      "strikethrough-thickness",
	      "stroke-dasharray",
	      "stroke-dashoffset",
	      "stroke-linecap",
	      "stroke-linejoin",
	      "stroke-miterlimit",
	      "stroke-opacity",
	      "stroke-width",
	      "text-anchor",
	      "text-decoration",
	      "text-rendering",
	      "underline-position",
	      "underline-thickness",
	      "unicode-bidi",
	      "unicode-range",
	      "units-per-em",
	      "v-alphabetic",
	      "v-hanging",
	      "v-ideographic",
	      "v-mathematical",
	      "vector-effect",
	      "vert-adv-y",
	      "vert-origin-x",
	      "vert-origin-y",
	      "word-spacing",
	      "writing-mode",
	      "xmlns:xlink",
	      "x-height"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "xlink:actuate",
	      "xlink:arcrole",
	      "xlink:role",
	      "xlink:show",
	      "xlink:title",
	      "xlink:type"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        "http://www.w3.org/1999/xlink",
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "xml:base",
	      "xml:lang",
	      "xml:space"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        "http://www.w3.org/XML/1998/namespace",
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["tabIndex", "crossOrigin"].forEach(function(attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(
	        attributeName,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    var xlinkHref = "xlinkHref";
	    properties[xlinkHref] = new PropertyInfoRecord(
	      "xlinkHref",
	      STRING,
	      false,
	      // mustUseProperty
	      "xlink:href",
	      "http://www.w3.org/1999/xlink",
	      true,
	      // sanitizeURL
	      false
	    );
	    ["src", "href", "action", "formAction"].forEach(function(attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(
	        attributeName,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        true,
	        // sanitizeURL
	        true
	      );
	    });
	    var isUnitlessNumber = {
	      animationIterationCount: true,
	      aspectRatio: true,
	      borderImageOutset: true,
	      borderImageSlice: true,
	      borderImageWidth: true,
	      boxFlex: true,
	      boxFlexGroup: true,
	      boxOrdinalGroup: true,
	      columnCount: true,
	      columns: true,
	      flex: true,
	      flexGrow: true,
	      flexPositive: true,
	      flexShrink: true,
	      flexNegative: true,
	      flexOrder: true,
	      gridArea: true,
	      gridRow: true,
	      gridRowEnd: true,
	      gridRowSpan: true,
	      gridRowStart: true,
	      gridColumn: true,
	      gridColumnEnd: true,
	      gridColumnSpan: true,
	      gridColumnStart: true,
	      fontWeight: true,
	      lineClamp: true,
	      lineHeight: true,
	      opacity: true,
	      order: true,
	      orphans: true,
	      tabSize: true,
	      widows: true,
	      zIndex: true,
	      zoom: true,
	      // SVG-related properties
	      fillOpacity: true,
	      floodOpacity: true,
	      stopOpacity: true,
	      strokeDasharray: true,
	      strokeDashoffset: true,
	      strokeMiterlimit: true,
	      strokeOpacity: true,
	      strokeWidth: true
	    };
	    function prefixKey(prefix2, key) {
	      return prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
	    }
	    var prefixes = ["Webkit", "ms", "Moz", "O"];
	    Object.keys(isUnitlessNumber).forEach(function(prop) {
	      prefixes.forEach(function(prefix2) {
	        isUnitlessNumber[prefixKey(prefix2, prop)] = isUnitlessNumber[prop];
	      });
	    });
	    var hasReadOnlyValue = {
	      button: true,
	      checkbox: true,
	      image: true,
	      hidden: true,
	      radio: true,
	      reset: true,
	      submit: true
	    };
	    function checkControlledValueProps(tagName, props) {
	      {
	        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
	          error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
	        }
	        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
	          error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
	        }
	      }
	    }
	    function isCustomComponent(tagName, props) {
	      if (tagName.indexOf("-") === -1) {
	        return typeof props.is === "string";
	      }
	      switch (tagName) {
	        case "annotation-xml":
	        case "color-profile":
	        case "font-face":
	        case "font-face-src":
	        case "font-face-uri":
	        case "font-face-format":
	        case "font-face-name":
	        case "missing-glyph":
	          return false;
	        default:
	          return true;
	      }
	    }
	    var ariaProperties = {
	      "aria-current": 0,
	      // state
	      "aria-description": 0,
	      "aria-details": 0,
	      "aria-disabled": 0,
	      // state
	      "aria-hidden": 0,
	      // state
	      "aria-invalid": 0,
	      // state
	      "aria-keyshortcuts": 0,
	      "aria-label": 0,
	      "aria-roledescription": 0,
	      // Widget Attributes
	      "aria-autocomplete": 0,
	      "aria-checked": 0,
	      "aria-expanded": 0,
	      "aria-haspopup": 0,
	      "aria-level": 0,
	      "aria-modal": 0,
	      "aria-multiline": 0,
	      "aria-multiselectable": 0,
	      "aria-orientation": 0,
	      "aria-placeholder": 0,
	      "aria-pressed": 0,
	      "aria-readonly": 0,
	      "aria-required": 0,
	      "aria-selected": 0,
	      "aria-sort": 0,
	      "aria-valuemax": 0,
	      "aria-valuemin": 0,
	      "aria-valuenow": 0,
	      "aria-valuetext": 0,
	      // Live Region Attributes
	      "aria-atomic": 0,
	      "aria-busy": 0,
	      "aria-live": 0,
	      "aria-relevant": 0,
	      // Drag-and-Drop Attributes
	      "aria-dropeffect": 0,
	      "aria-grabbed": 0,
	      // Relationship Attributes
	      "aria-activedescendant": 0,
	      "aria-colcount": 0,
	      "aria-colindex": 0,
	      "aria-colspan": 0,
	      "aria-controls": 0,
	      "aria-describedby": 0,
	      "aria-errormessage": 0,
	      "aria-flowto": 0,
	      "aria-labelledby": 0,
	      "aria-owns": 0,
	      "aria-posinset": 0,
	      "aria-rowcount": 0,
	      "aria-rowindex": 0,
	      "aria-rowspan": 0,
	      "aria-setsize": 0
	    };
	    var warnedProperties = {};
	    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
	    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
	    function validateProperty(tagName, name) {
	      {
	        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
	          return true;
	        }
	        if (rARIACamel.test(name)) {
	          var ariaName = "aria-" + name.slice(4).toLowerCase();
	          var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;
	          if (correctName == null) {
	            error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
	            warnedProperties[name] = true;
	            return true;
	          }
	          if (name !== correctName) {
	            error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	        if (rARIA.test(name)) {
	          var lowerCasedName = name.toLowerCase();
	          var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;
	          if (standardName == null) {
	            warnedProperties[name] = true;
	            return false;
	          }
	          if (name !== standardName) {
	            error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	      }
	      return true;
	    }
	    function warnInvalidARIAProps(type, props) {
	      {
	        var invalidProps = [];
	        for (var key in props) {
	          var isValid = validateProperty(type, key);
	          if (!isValid) {
	            invalidProps.push(key);
	          }
	        }
	        var unknownPropString = invalidProps.map(function(prop) {
	          return "`" + prop + "`";
	        }).join(", ");
	        if (invalidProps.length === 1) {
	          error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
	        } else if (invalidProps.length > 1) {
	          error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
	        }
	      }
	    }
	    function validateProperties(type, props) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnInvalidARIAProps(type, props);
	    }
	    var didWarnValueNull = false;
	    function validateProperties$1(type, props) {
	      {
	        if (type !== "input" && type !== "textarea" && type !== "select") {
	          return;
	        }
	        if (props != null && props.value === null && !didWarnValueNull) {
	          didWarnValueNull = true;
	          if (type === "select" && props.multiple) {
	            error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
	          } else {
	            error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
	          }
	        }
	      }
	    }
	    var possibleStandardNames = {
	      // HTML
	      accept: "accept",
	      acceptcharset: "acceptCharset",
	      "accept-charset": "acceptCharset",
	      accesskey: "accessKey",
	      action: "action",
	      allowfullscreen: "allowFullScreen",
	      alt: "alt",
	      as: "as",
	      async: "async",
	      autocapitalize: "autoCapitalize",
	      autocomplete: "autoComplete",
	      autocorrect: "autoCorrect",
	      autofocus: "autoFocus",
	      autoplay: "autoPlay",
	      autosave: "autoSave",
	      capture: "capture",
	      cellpadding: "cellPadding",
	      cellspacing: "cellSpacing",
	      challenge: "challenge",
	      charset: "charSet",
	      checked: "checked",
	      children: "children",
	      cite: "cite",
	      class: "className",
	      classid: "classID",
	      classname: "className",
	      cols: "cols",
	      colspan: "colSpan",
	      content: "content",
	      contenteditable: "contentEditable",
	      contextmenu: "contextMenu",
	      controls: "controls",
	      controlslist: "controlsList",
	      coords: "coords",
	      crossorigin: "crossOrigin",
	      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
	      data: "data",
	      datetime: "dateTime",
	      default: "default",
	      defaultchecked: "defaultChecked",
	      defaultvalue: "defaultValue",
	      defer: "defer",
	      dir: "dir",
	      disabled: "disabled",
	      disablepictureinpicture: "disablePictureInPicture",
	      disableremoteplayback: "disableRemotePlayback",
	      download: "download",
	      draggable: "draggable",
	      enctype: "encType",
	      enterkeyhint: "enterKeyHint",
	      for: "htmlFor",
	      form: "form",
	      formmethod: "formMethod",
	      formaction: "formAction",
	      formenctype: "formEncType",
	      formnovalidate: "formNoValidate",
	      formtarget: "formTarget",
	      frameborder: "frameBorder",
	      headers: "headers",
	      height: "height",
	      hidden: "hidden",
	      high: "high",
	      href: "href",
	      hreflang: "hrefLang",
	      htmlfor: "htmlFor",
	      httpequiv: "httpEquiv",
	      "http-equiv": "httpEquiv",
	      icon: "icon",
	      id: "id",
	      imagesizes: "imageSizes",
	      imagesrcset: "imageSrcSet",
	      innerhtml: "innerHTML",
	      inputmode: "inputMode",
	      integrity: "integrity",
	      is: "is",
	      itemid: "itemID",
	      itemprop: "itemProp",
	      itemref: "itemRef",
	      itemscope: "itemScope",
	      itemtype: "itemType",
	      keyparams: "keyParams",
	      keytype: "keyType",
	      kind: "kind",
	      label: "label",
	      lang: "lang",
	      list: "list",
	      loop: "loop",
	      low: "low",
	      manifest: "manifest",
	      marginwidth: "marginWidth",
	      marginheight: "marginHeight",
	      max: "max",
	      maxlength: "maxLength",
	      media: "media",
	      mediagroup: "mediaGroup",
	      method: "method",
	      min: "min",
	      minlength: "minLength",
	      multiple: "multiple",
	      muted: "muted",
	      name: "name",
	      nomodule: "noModule",
	      nonce: "nonce",
	      novalidate: "noValidate",
	      open: "open",
	      optimum: "optimum",
	      pattern: "pattern",
	      placeholder: "placeholder",
	      playsinline: "playsInline",
	      poster: "poster",
	      preload: "preload",
	      profile: "profile",
	      radiogroup: "radioGroup",
	      readonly: "readOnly",
	      referrerpolicy: "referrerPolicy",
	      rel: "rel",
	      required: "required",
	      reversed: "reversed",
	      role: "role",
	      rows: "rows",
	      rowspan: "rowSpan",
	      sandbox: "sandbox",
	      scope: "scope",
	      scoped: "scoped",
	      scrolling: "scrolling",
	      seamless: "seamless",
	      selected: "selected",
	      shape: "shape",
	      size: "size",
	      sizes: "sizes",
	      span: "span",
	      spellcheck: "spellCheck",
	      src: "src",
	      srcdoc: "srcDoc",
	      srclang: "srcLang",
	      srcset: "srcSet",
	      start: "start",
	      step: "step",
	      style: "style",
	      summary: "summary",
	      tabindex: "tabIndex",
	      target: "target",
	      title: "title",
	      type: "type",
	      usemap: "useMap",
	      value: "value",
	      width: "width",
	      wmode: "wmode",
	      wrap: "wrap",
	      // SVG
	      about: "about",
	      accentheight: "accentHeight",
	      "accent-height": "accentHeight",
	      accumulate: "accumulate",
	      additive: "additive",
	      alignmentbaseline: "alignmentBaseline",
	      "alignment-baseline": "alignmentBaseline",
	      allowreorder: "allowReorder",
	      alphabetic: "alphabetic",
	      amplitude: "amplitude",
	      arabicform: "arabicForm",
	      "arabic-form": "arabicForm",
	      ascent: "ascent",
	      attributename: "attributeName",
	      attributetype: "attributeType",
	      autoreverse: "autoReverse",
	      azimuth: "azimuth",
	      basefrequency: "baseFrequency",
	      baselineshift: "baselineShift",
	      "baseline-shift": "baselineShift",
	      baseprofile: "baseProfile",
	      bbox: "bbox",
	      begin: "begin",
	      bias: "bias",
	      by: "by",
	      calcmode: "calcMode",
	      capheight: "capHeight",
	      "cap-height": "capHeight",
	      clip: "clip",
	      clippath: "clipPath",
	      "clip-path": "clipPath",
	      clippathunits: "clipPathUnits",
	      cliprule: "clipRule",
	      "clip-rule": "clipRule",
	      color: "color",
	      colorinterpolation: "colorInterpolation",
	      "color-interpolation": "colorInterpolation",
	      colorinterpolationfilters: "colorInterpolationFilters",
	      "color-interpolation-filters": "colorInterpolationFilters",
	      colorprofile: "colorProfile",
	      "color-profile": "colorProfile",
	      colorrendering: "colorRendering",
	      "color-rendering": "colorRendering",
	      contentscripttype: "contentScriptType",
	      contentstyletype: "contentStyleType",
	      cursor: "cursor",
	      cx: "cx",
	      cy: "cy",
	      d: "d",
	      datatype: "datatype",
	      decelerate: "decelerate",
	      descent: "descent",
	      diffuseconstant: "diffuseConstant",
	      direction: "direction",
	      display: "display",
	      divisor: "divisor",
	      dominantbaseline: "dominantBaseline",
	      "dominant-baseline": "dominantBaseline",
	      dur: "dur",
	      dx: "dx",
	      dy: "dy",
	      edgemode: "edgeMode",
	      elevation: "elevation",
	      enablebackground: "enableBackground",
	      "enable-background": "enableBackground",
	      end: "end",
	      exponent: "exponent",
	      externalresourcesrequired: "externalResourcesRequired",
	      fill: "fill",
	      fillopacity: "fillOpacity",
	      "fill-opacity": "fillOpacity",
	      fillrule: "fillRule",
	      "fill-rule": "fillRule",
	      filter: "filter",
	      filterres: "filterRes",
	      filterunits: "filterUnits",
	      floodopacity: "floodOpacity",
	      "flood-opacity": "floodOpacity",
	      floodcolor: "floodColor",
	      "flood-color": "floodColor",
	      focusable: "focusable",
	      fontfamily: "fontFamily",
	      "font-family": "fontFamily",
	      fontsize: "fontSize",
	      "font-size": "fontSize",
	      fontsizeadjust: "fontSizeAdjust",
	      "font-size-adjust": "fontSizeAdjust",
	      fontstretch: "fontStretch",
	      "font-stretch": "fontStretch",
	      fontstyle: "fontStyle",
	      "font-style": "fontStyle",
	      fontvariant: "fontVariant",
	      "font-variant": "fontVariant",
	      fontweight: "fontWeight",
	      "font-weight": "fontWeight",
	      format: "format",
	      from: "from",
	      fx: "fx",
	      fy: "fy",
	      g1: "g1",
	      g2: "g2",
	      glyphname: "glyphName",
	      "glyph-name": "glyphName",
	      glyphorientationhorizontal: "glyphOrientationHorizontal",
	      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
	      glyphorientationvertical: "glyphOrientationVertical",
	      "glyph-orientation-vertical": "glyphOrientationVertical",
	      glyphref: "glyphRef",
	      gradienttransform: "gradientTransform",
	      gradientunits: "gradientUnits",
	      hanging: "hanging",
	      horizadvx: "horizAdvX",
	      "horiz-adv-x": "horizAdvX",
	      horizoriginx: "horizOriginX",
	      "horiz-origin-x": "horizOriginX",
	      ideographic: "ideographic",
	      imagerendering: "imageRendering",
	      "image-rendering": "imageRendering",
	      in2: "in2",
	      in: "in",
	      inlist: "inlist",
	      intercept: "intercept",
	      k1: "k1",
	      k2: "k2",
	      k3: "k3",
	      k4: "k4",
	      k: "k",
	      kernelmatrix: "kernelMatrix",
	      kernelunitlength: "kernelUnitLength",
	      kerning: "kerning",
	      keypoints: "keyPoints",
	      keysplines: "keySplines",
	      keytimes: "keyTimes",
	      lengthadjust: "lengthAdjust",
	      letterspacing: "letterSpacing",
	      "letter-spacing": "letterSpacing",
	      lightingcolor: "lightingColor",
	      "lighting-color": "lightingColor",
	      limitingconeangle: "limitingConeAngle",
	      local: "local",
	      markerend: "markerEnd",
	      "marker-end": "markerEnd",
	      markerheight: "markerHeight",
	      markermid: "markerMid",
	      "marker-mid": "markerMid",
	      markerstart: "markerStart",
	      "marker-start": "markerStart",
	      markerunits: "markerUnits",
	      markerwidth: "markerWidth",
	      mask: "mask",
	      maskcontentunits: "maskContentUnits",
	      maskunits: "maskUnits",
	      mathematical: "mathematical",
	      mode: "mode",
	      numoctaves: "numOctaves",
	      offset: "offset",
	      opacity: "opacity",
	      operator: "operator",
	      order: "order",
	      orient: "orient",
	      orientation: "orientation",
	      origin: "origin",
	      overflow: "overflow",
	      overlineposition: "overlinePosition",
	      "overline-position": "overlinePosition",
	      overlinethickness: "overlineThickness",
	      "overline-thickness": "overlineThickness",
	      paintorder: "paintOrder",
	      "paint-order": "paintOrder",
	      panose1: "panose1",
	      "panose-1": "panose1",
	      pathlength: "pathLength",
	      patterncontentunits: "patternContentUnits",
	      patterntransform: "patternTransform",
	      patternunits: "patternUnits",
	      pointerevents: "pointerEvents",
	      "pointer-events": "pointerEvents",
	      points: "points",
	      pointsatx: "pointsAtX",
	      pointsaty: "pointsAtY",
	      pointsatz: "pointsAtZ",
	      prefix: "prefix",
	      preservealpha: "preserveAlpha",
	      preserveaspectratio: "preserveAspectRatio",
	      primitiveunits: "primitiveUnits",
	      property: "property",
	      r: "r",
	      radius: "radius",
	      refx: "refX",
	      refy: "refY",
	      renderingintent: "renderingIntent",
	      "rendering-intent": "renderingIntent",
	      repeatcount: "repeatCount",
	      repeatdur: "repeatDur",
	      requiredextensions: "requiredExtensions",
	      requiredfeatures: "requiredFeatures",
	      resource: "resource",
	      restart: "restart",
	      result: "result",
	      results: "results",
	      rotate: "rotate",
	      rx: "rx",
	      ry: "ry",
	      scale: "scale",
	      security: "security",
	      seed: "seed",
	      shaperendering: "shapeRendering",
	      "shape-rendering": "shapeRendering",
	      slope: "slope",
	      spacing: "spacing",
	      specularconstant: "specularConstant",
	      specularexponent: "specularExponent",
	      speed: "speed",
	      spreadmethod: "spreadMethod",
	      startoffset: "startOffset",
	      stddeviation: "stdDeviation",
	      stemh: "stemh",
	      stemv: "stemv",
	      stitchtiles: "stitchTiles",
	      stopcolor: "stopColor",
	      "stop-color": "stopColor",
	      stopopacity: "stopOpacity",
	      "stop-opacity": "stopOpacity",
	      strikethroughposition: "strikethroughPosition",
	      "strikethrough-position": "strikethroughPosition",
	      strikethroughthickness: "strikethroughThickness",
	      "strikethrough-thickness": "strikethroughThickness",
	      string: "string",
	      stroke: "stroke",
	      strokedasharray: "strokeDasharray",
	      "stroke-dasharray": "strokeDasharray",
	      strokedashoffset: "strokeDashoffset",
	      "stroke-dashoffset": "strokeDashoffset",
	      strokelinecap: "strokeLinecap",
	      "stroke-linecap": "strokeLinecap",
	      strokelinejoin: "strokeLinejoin",
	      "stroke-linejoin": "strokeLinejoin",
	      strokemiterlimit: "strokeMiterlimit",
	      "stroke-miterlimit": "strokeMiterlimit",
	      strokewidth: "strokeWidth",
	      "stroke-width": "strokeWidth",
	      strokeopacity: "strokeOpacity",
	      "stroke-opacity": "strokeOpacity",
	      suppresscontenteditablewarning: "suppressContentEditableWarning",
	      suppresshydrationwarning: "suppressHydrationWarning",
	      surfacescale: "surfaceScale",
	      systemlanguage: "systemLanguage",
	      tablevalues: "tableValues",
	      targetx: "targetX",
	      targety: "targetY",
	      textanchor: "textAnchor",
	      "text-anchor": "textAnchor",
	      textdecoration: "textDecoration",
	      "text-decoration": "textDecoration",
	      textlength: "textLength",
	      textrendering: "textRendering",
	      "text-rendering": "textRendering",
	      to: "to",
	      transform: "transform",
	      typeof: "typeof",
	      u1: "u1",
	      u2: "u2",
	      underlineposition: "underlinePosition",
	      "underline-position": "underlinePosition",
	      underlinethickness: "underlineThickness",
	      "underline-thickness": "underlineThickness",
	      unicode: "unicode",
	      unicodebidi: "unicodeBidi",
	      "unicode-bidi": "unicodeBidi",
	      unicoderange: "unicodeRange",
	      "unicode-range": "unicodeRange",
	      unitsperem: "unitsPerEm",
	      "units-per-em": "unitsPerEm",
	      unselectable: "unselectable",
	      valphabetic: "vAlphabetic",
	      "v-alphabetic": "vAlphabetic",
	      values: "values",
	      vectoreffect: "vectorEffect",
	      "vector-effect": "vectorEffect",
	      version: "version",
	      vertadvy: "vertAdvY",
	      "vert-adv-y": "vertAdvY",
	      vertoriginx: "vertOriginX",
	      "vert-origin-x": "vertOriginX",
	      vertoriginy: "vertOriginY",
	      "vert-origin-y": "vertOriginY",
	      vhanging: "vHanging",
	      "v-hanging": "vHanging",
	      videographic: "vIdeographic",
	      "v-ideographic": "vIdeographic",
	      viewbox: "viewBox",
	      viewtarget: "viewTarget",
	      visibility: "visibility",
	      vmathematical: "vMathematical",
	      "v-mathematical": "vMathematical",
	      vocab: "vocab",
	      widths: "widths",
	      wordspacing: "wordSpacing",
	      "word-spacing": "wordSpacing",
	      writingmode: "writingMode",
	      "writing-mode": "writingMode",
	      x1: "x1",
	      x2: "x2",
	      x: "x",
	      xchannelselector: "xChannelSelector",
	      xheight: "xHeight",
	      "x-height": "xHeight",
	      xlinkactuate: "xlinkActuate",
	      "xlink:actuate": "xlinkActuate",
	      xlinkarcrole: "xlinkArcrole",
	      "xlink:arcrole": "xlinkArcrole",
	      xlinkhref: "xlinkHref",
	      "xlink:href": "xlinkHref",
	      xlinkrole: "xlinkRole",
	      "xlink:role": "xlinkRole",
	      xlinkshow: "xlinkShow",
	      "xlink:show": "xlinkShow",
	      xlinktitle: "xlinkTitle",
	      "xlink:title": "xlinkTitle",
	      xlinktype: "xlinkType",
	      "xlink:type": "xlinkType",
	      xmlbase: "xmlBase",
	      "xml:base": "xmlBase",
	      xmllang: "xmlLang",
	      "xml:lang": "xmlLang",
	      xmlns: "xmlns",
	      "xml:space": "xmlSpace",
	      xmlnsxlink: "xmlnsXlink",
	      "xmlns:xlink": "xmlnsXlink",
	      xmlspace: "xmlSpace",
	      y1: "y1",
	      y2: "y2",
	      y: "y",
	      ychannelselector: "yChannelSelector",
	      z: "z",
	      zoomandpan: "zoomAndPan"
	    };
	    var validateProperty$1 = function() {
	    };
	    {
	      var warnedProperties$1 = {};
	      var EVENT_NAME_REGEX = /^on./;
	      var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
	      var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
	      var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
	      validateProperty$1 = function(tagName, name, value, eventRegistry) {
	        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
	          return true;
	        }
	        var lowerCasedName = name.toLowerCase();
	        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
	          error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (eventRegistry != null) {
	          var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
	          if (registrationNameDependencies.hasOwnProperty(name)) {
	            return true;
	          }
	          var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
	          if (registrationName != null) {
	            error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	          if (EVENT_NAME_REGEX.test(name)) {
	            error("Unknown event handler property `%s`. It will be ignored.", name);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (EVENT_NAME_REGEX.test(name)) {
	          if (INVALID_EVENT_NAME_REGEX.test(name)) {
	            error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
	          return true;
	        }
	        if (lowerCasedName === "innerhtml") {
	          error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === "aria") {
	          error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
	          error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === "number" && isNaN(value)) {
	          error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        var propertyInfo = getPropertyInfo(name);
	        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;
	        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
	          var standardName = possibleStandardNames[lowerCasedName];
	          if (standardName !== name) {
	            error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (!isReserved && name !== lowerCasedName) {
	          error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          if (value) {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
	          } else {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (isReserved) {
	          return true;
	        }
	        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          warnedProperties$1[name] = true;
	          return false;
	        }
	        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
	          error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        return true;
	      };
	    }
	    var warnUnknownProperties = function(type, props, eventRegistry) {
	      {
	        var unknownProps = [];
	        for (var key in props) {
	          var isValid = validateProperty$1(type, key, props[key], eventRegistry);
	          if (!isValid) {
	            unknownProps.push(key);
	          }
	        }
	        var unknownPropString = unknownProps.map(function(prop) {
	          return "`" + prop + "`";
	        }).join(", ");
	        if (unknownProps.length === 1) {
	          error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
	        } else if (unknownProps.length > 1) {
	          error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
	        }
	      }
	    };
	    function validateProperties$2(type, props, eventRegistry) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnUnknownProperties(type, props, eventRegistry);
	    }
	    var warnValidStyle = function() {
	    };
	    {
	      var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	      var msPattern = /^-ms-/;
	      var hyphenPattern = /-(.)/g;
	      var badStyleValueWithSemicolonPattern = /;\s*$/;
	      var warnedStyleNames = {};
	      var warnedStyleValues = {};
	      var warnedForNaNValue = false;
	      var warnedForInfinityValue = false;
	      var camelize = function(string) {
	        return string.replace(hyphenPattern, function(_, character) {
	          return character.toUpperCase();
	        });
	      };
	      var warnHyphenatedStyleName = function(name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error(
	          "Unsupported style property %s. Did you mean %s?",
	          name,
	          // As Andi Smith suggests
	          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	          // is converted to lowercase `ms`.
	          camelize(name.replace(msPattern, "ms-"))
	        );
	      };
	      var warnBadVendoredStyleName = function(name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
	      };
	      var warnStyleValueWithSemicolon = function(name, value) {
	        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	          return;
	        }
	        warnedStyleValues[value] = true;
	        error(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, name, value.replace(badStyleValueWithSemicolonPattern, ""));
	      };
	      var warnStyleValueIsNaN = function(name, value) {
	        if (warnedForNaNValue) {
	          return;
	        }
	        warnedForNaNValue = true;
	        error("`NaN` is an invalid value for the `%s` css style property.", name);
	      };
	      var warnStyleValueIsInfinity = function(name, value) {
	        if (warnedForInfinityValue) {
	          return;
	        }
	        warnedForInfinityValue = true;
	        error("`Infinity` is an invalid value for the `%s` css style property.", name);
	      };
	      warnValidStyle = function(name, value) {
	        if (name.indexOf("-") > -1) {
	          warnHyphenatedStyleName(name);
	        } else if (badVendoredStyleNamePattern.test(name)) {
	          warnBadVendoredStyleName(name);
	        } else if (badStyleValueWithSemicolonPattern.test(value)) {
	          warnStyleValueWithSemicolon(name, value);
	        }
	        if (typeof value === "number") {
	          if (isNaN(value)) {
	            warnStyleValueIsNaN(name, value);
	          } else if (!isFinite(value)) {
	            warnStyleValueIsInfinity(name, value);
	          }
	        }
	      };
	    }
	    var warnValidStyle$1 = warnValidStyle;
	    var matchHtmlRegExp = /["'&<>]/;
	    function escapeHtml(string) {
	      {
	        checkHtmlStringCoercion(string);
	      }
	      var str = "" + string;
	      var match = matchHtmlRegExp.exec(str);
	      if (!match) {
	        return str;
	      }
	      var escape;
	      var html = "";
	      var index;
	      var lastIndex = 0;
	      for (index = match.index; index < str.length; index++) {
	        switch (str.charCodeAt(index)) {
	          case 34:
	            escape = "&quot;";
	            break;
	          case 38:
	            escape = "&amp;";
	            break;
	          case 39:
	            escape = "&#x27;";
	            break;
	          case 60:
	            escape = "&lt;";
	            break;
	          case 62:
	            escape = "&gt;";
	            break;
	          default:
	            continue;
	        }
	        if (lastIndex !== index) {
	          html += str.substring(lastIndex, index);
	        }
	        lastIndex = index + 1;
	        html += escape;
	      }
	      return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	    }
	    function escapeTextForBrowser(text) {
	      if (typeof text === "boolean" || typeof text === "number") {
	        return "" + text;
	      }
	      return escapeHtml(text);
	    }
	    var uppercasePattern = /([A-Z])/g;
	    var msPattern$1 = /^ms-/;
	    function hyphenateStyleName(name) {
	      return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-");
	    }
	    var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
	    var didWarn = false;
	    function sanitizeURL(url) {
	      {
	        if (!didWarn && isJavaScriptProtocol.test(url)) {
	          didWarn = true;
	          error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
	        }
	      }
	    }
	    var isArrayImpl = Array.isArray;
	    function isArray(a) {
	      return isArrayImpl(a);
	    }
	    var startInlineScript = stringToPrecomputedChunk("<script>");
	    function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
	      var idPrefix = identifierPrefix === undefined ? "" : identifierPrefix;
	      var inlineScriptWithNonce = startInlineScript ;
	      var bootstrapChunks = [];
	      return {
	        bootstrapChunks,
	        startInlineScript: inlineScriptWithNonce,
	        placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
	        segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
	        boundaryPrefix: idPrefix + "B:",
	        idPrefix,
	        nextSuspenseID: 0,
	        sentCompleteSegmentFunction: false,
	        sentCompleteBoundaryFunction: false,
	        sentClientRenderFunction: false
	      };
	    }
	    var ROOT_HTML_MODE = 0;
	    var HTML_MODE = 1;
	    var SVG_MODE = 2;
	    var MATHML_MODE = 3;
	    var HTML_TABLE_MODE = 4;
	    var HTML_TABLE_BODY_MODE = 5;
	    var HTML_TABLE_ROW_MODE = 6;
	    var HTML_COLGROUP_MODE = 7;
	    function createFormatContext(insertionMode, selectedValue) {
	      return {
	        insertionMode,
	        selectedValue
	      };
	    }
	    function getChildFormatContext(parentContext, type, props) {
	      switch (type) {
	        case "select":
	          return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);
	        case "svg":
	          return createFormatContext(SVG_MODE, null);
	        case "math":
	          return createFormatContext(MATHML_MODE, null);
	        case "foreignObject":
	          return createFormatContext(HTML_MODE, null);
	        case "table":
	          return createFormatContext(HTML_TABLE_MODE, null);
	        case "thead":
	        case "tbody":
	        case "tfoot":
	          return createFormatContext(HTML_TABLE_BODY_MODE, null);
	        case "colgroup":
	          return createFormatContext(HTML_COLGROUP_MODE, null);
	        case "tr":
	          return createFormatContext(HTML_TABLE_ROW_MODE, null);
	      }
	      if (parentContext.insertionMode >= HTML_TABLE_MODE) {
	        return createFormatContext(HTML_MODE, null);
	      }
	      if (parentContext.insertionMode === ROOT_HTML_MODE) {
	        return createFormatContext(HTML_MODE, null);
	      }
	      return parentContext;
	    }
	    var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;
	    function assignSuspenseBoundaryID(responseState) {
	      var generatedID = responseState.nextSuspenseID++;
	      return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
	    }
	    function makeId(responseState, treeId, localId) {
	      var idPrefix = responseState.idPrefix;
	      var id = ":" + idPrefix + "R" + treeId;
	      if (localId > 0) {
	        id += "H" + localId.toString(32);
	      }
	      return id + ":";
	    }
	    function encodeHTMLTextNode(text) {
	      return escapeTextForBrowser(text);
	    }
	    var textSeparator = stringToPrecomputedChunk("<!-- -->");
	    function pushTextInstance(target, text, responseState, textEmbedded) {
	      if (text === "") {
	        return textEmbedded;
	      }
	      if (textEmbedded) {
	        target.push(textSeparator);
	      }
	      target.push(stringToChunk(encodeHTMLTextNode(text)));
	      return true;
	    }
	    function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
	      if (lastPushedText && textEmbedded) {
	        target.push(textSeparator);
	      }
	    }
	    var styleNameCache = /* @__PURE__ */ new Map();
	    function processStyleName(styleName) {
	      var chunk = styleNameCache.get(styleName);
	      if (chunk !== undefined) {
	        return chunk;
	      }
	      var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
	      styleNameCache.set(styleName, result);
	      return result;
	    }
	    var styleAttributeStart = stringToPrecomputedChunk(' style="');
	    var styleAssign = stringToPrecomputedChunk(":");
	    var styleSeparator = stringToPrecomputedChunk(";");
	    function pushStyle(target, responseState, style) {
	      if (typeof style !== "object") {
	        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
	      }
	      var isFirst = true;
	      for (var styleName in style) {
	        if (!hasOwnProperty.call(style, styleName)) {
	          continue;
	        }
	        var styleValue = style[styleName];
	        if (styleValue == null || typeof styleValue === "boolean" || styleValue === "") {
	          continue;
	        }
	        var nameChunk = undefined;
	        var valueChunk = undefined;
	        var isCustomProperty = styleName.indexOf("--") === 0;
	        if (isCustomProperty) {
	          nameChunk = stringToChunk(escapeTextForBrowser(styleName));
	          {
	            checkCSSPropertyStringCoercion(styleValue, styleName);
	          }
	          valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
	        } else {
	          {
	            warnValidStyle$1(styleName, styleValue);
	          }
	          nameChunk = processStyleName(styleName);
	          if (typeof styleValue === "number") {
	            if (styleValue !== 0 && !hasOwnProperty.call(isUnitlessNumber, styleName)) {
	              valueChunk = stringToChunk(styleValue + "px");
	            } else {
	              valueChunk = stringToChunk("" + styleValue);
	            }
	          } else {
	            {
	              checkCSSPropertyStringCoercion(styleValue, styleName);
	            }
	            valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
	          }
	        }
	        if (isFirst) {
	          isFirst = false;
	          target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
	        } else {
	          target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
	        }
	      }
	      if (!isFirst) {
	        target.push(attributeEnd);
	      }
	    }
	    var attributeSeparator = stringToPrecomputedChunk(" ");
	    var attributeAssign = stringToPrecomputedChunk('="');
	    var attributeEnd = stringToPrecomputedChunk('"');
	    var attributeEmptyString = stringToPrecomputedChunk('=""');
	    function pushAttribute(target, responseState, name, value) {
	      switch (name) {
	        case "style": {
	          pushStyle(target, responseState, value);
	          return;
	        }
	        case "defaultValue":
	        case "defaultChecked":
	        case "innerHTML":
	        case "suppressContentEditableWarning":
	        case "suppressHydrationWarning":
	          return;
	      }
	      if (
	        // shouldIgnoreAttribute
	        // We have already filtered out null/undefined and reserved words.
	        name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")
	      ) {
	        return;
	      }
	      var propertyInfo = getPropertyInfo(name);
	      if (propertyInfo !== null) {
	        switch (typeof value) {
	          case "function":
	          case "symbol":
	            return;
	          case "boolean": {
	            if (!propertyInfo.acceptsBooleans) {
	              return;
	            }
	          }
	        }
	        var attributeName = propertyInfo.attributeName;
	        var attributeNameChunk = stringToChunk(attributeName);
	        switch (propertyInfo.type) {
	          case BOOLEAN:
	            if (value) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            }
	            return;
	          case OVERLOADED_BOOLEAN:
	            if (value === true) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            } else if (value === false) ;
	            else {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            return;
	          case NUMERIC:
	            if (!isNaN(value)) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          case POSITIVE_NUMERIC:
	            if (!isNaN(value) && value >= 1) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          default:
	            if (propertyInfo.sanitizeURL) {
	              {
	                checkAttributeStringCoercion(value, attributeName);
	              }
	              value = "" + value;
	              sanitizeURL(value);
	            }
	            target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	        }
	      } else if (isAttributeNameSafe(name)) {
	        switch (typeof value) {
	          case "function":
	          case "symbol":
	            return;
	          case "boolean": {
	            var prefix2 = name.toLowerCase().slice(0, 5);
	            if (prefix2 !== "data-" && prefix2 !== "aria-") {
	              return;
	            }
	          }
	        }
	        target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	      }
	    }
	    var endOfStartTag = stringToPrecomputedChunk(">");
	    var endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");
	    function pushInnerHTML(target, innerHTML, children) {
	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
	        }
	        if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
	          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          {
	            checkHtmlStringCoercion(html);
	          }
	          target.push(stringToChunk("" + html));
	        }
	      }
	    }
	    var didWarnDefaultInputValue = false;
	    var didWarnDefaultChecked = false;
	    var didWarnDefaultSelectValue = false;
	    var didWarnDefaultTextareaValue = false;
	    var didWarnInvalidOptionChildren = false;
	    var didWarnInvalidOptionInnerHTML = false;
	    var didWarnSelectedSetOnOption = false;
	    function checkSelectProp(props, propName) {
	      {
	        var value = props[propName];
	        if (value != null) {
	          var array = isArray(value);
	          if (props.multiple && !array) {
	            error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
	          } else if (!props.multiple && array) {
	            error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
	          }
	        }
	      }
	    }
	    function pushStartSelect(target, props, responseState) {
	      {
	        checkControlledValueProps("select", props);
	        checkSelectProp(props, "value");
	        checkSelectProp(props, "defaultValue");
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
	          error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
	          didWarnDefaultSelectValue = true;
	        }
	      }
	      target.push(startChunkForTag("select"));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            case "defaultValue":
	            case "value":
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function flattenOptionChildren(children) {
	      var content = "";
	      React.Children.forEach(children, function(child) {
	        if (child == null) {
	          return;
	        }
	        content += child;
	        {
	          if (!didWarnInvalidOptionChildren && typeof child !== "string" && typeof child !== "number") {
	            didWarnInvalidOptionChildren = true;
	            error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
	          }
	        }
	      });
	      return content;
	    }
	    var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');
	    function pushStartOption(target, props, responseState, formatContext) {
	      var selectedValue = formatContext.selectedValue;
	      target.push(startChunkForTag("option"));
	      var children = null;
	      var value = null;
	      var selected = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "selected":
	              selected = propValue;
	              {
	                if (!didWarnSelectedSetOnOption) {
	                  error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
	                  didWarnSelectedSetOnOption = true;
	                }
	              }
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            case "value":
	              value = propValue;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (selectedValue != null) {
	        var stringValue;
	        if (value !== null) {
	          {
	            checkAttributeStringCoercion(value, "value");
	          }
	          stringValue = "" + value;
	        } else {
	          {
	            if (innerHTML !== null) {
	              if (!didWarnInvalidOptionInnerHTML) {
	                didWarnInvalidOptionInnerHTML = true;
	                error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
	              }
	            }
	          }
	          stringValue = flattenOptionChildren(children);
	        }
	        if (isArray(selectedValue)) {
	          for (var i = 0; i < selectedValue.length; i++) {
	            {
	              checkAttributeStringCoercion(selectedValue[i], "value");
	            }
	            var v = "" + selectedValue[i];
	            if (v === stringValue) {
	              target.push(selectedMarkerAttribute);
	              break;
	            }
	          }
	        } else {
	          {
	            checkAttributeStringCoercion(selectedValue, "select.value");
	          }
	          if ("" + selectedValue === stringValue) {
	            target.push(selectedMarkerAttribute);
	          }
	        }
	      } else if (selected) {
	        target.push(selectedMarkerAttribute);
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function pushInput(target, props, responseState) {
	      {
	        checkControlledValueProps("input", props);
	        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
	          error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
	          didWarnDefaultChecked = true;
	        }
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
	          error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
	          didWarnDefaultInputValue = true;
	        }
	      }
	      target.push(startChunkForTag("input"));
	      var value = null;
	      var defaultValue = null;
	      var checked = null;
	      var defaultChecked = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	            case "dangerouslySetInnerHTML":
	              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
	            case "defaultChecked":
	              defaultChecked = propValue;
	              break;
	            case "defaultValue":
	              defaultValue = propValue;
	              break;
	            case "checked":
	              checked = propValue;
	              break;
	            case "value":
	              value = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (checked !== null) {
	        pushAttribute(target, responseState, "checked", checked);
	      } else if (defaultChecked !== null) {
	        pushAttribute(target, responseState, "checked", defaultChecked);
	      }
	      if (value !== null) {
	        pushAttribute(target, responseState, "value", value);
	      } else if (defaultValue !== null) {
	        pushAttribute(target, responseState, "value", defaultValue);
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartTextArea(target, props, responseState) {
	      {
	        checkControlledValueProps("textarea", props);
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
	          error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
	          didWarnDefaultTextareaValue = true;
	        }
	      }
	      target.push(startChunkForTag("textarea"));
	      var value = null;
	      var defaultValue = null;
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "value":
	              value = propValue;
	              break;
	            case "defaultValue":
	              defaultValue = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (value === null && defaultValue !== null) {
	        value = defaultValue;
	      }
	      target.push(endOfStartTag);
	      if (children != null) {
	        {
	          error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
	        }
	        if (value != null) {
	          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
	        }
	        if (isArray(children)) {
	          if (children.length > 1) {
	            throw new Error("<textarea> can only have at most one child.");
	          }
	          {
	            checkHtmlStringCoercion(children[0]);
	          }
	          value = "" + children[0];
	        }
	        {
	          checkHtmlStringCoercion(children);
	        }
	        value = "" + children;
	      }
	      if (typeof value === "string" && value[0] === "\n") {
	        target.push(leadingNewline);
	      }
	      if (value !== null) {
	        {
	          checkAttributeStringCoercion(value, "value");
	        }
	        target.push(stringToChunk(encodeHTMLTextNode("" + value)));
	      }
	      return null;
	    }
	    function pushSelfClosing(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	            case "dangerouslySetInnerHTML":
	              throw new Error(tag + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartMenuItem(target, props, responseState) {
	      target.push(startChunkForTag("menuitem"));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	            case "dangerouslySetInnerHTML":
	              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      return null;
	    }
	    function pushStartTitle(target, props, responseState) {
	      target.push(startChunkForTag("title"));
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      {
	        var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;
	        if (Array.isArray(children) && children.length > 1) {
	          error("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
	        } else if (child != null && child.$$typeof != null) {
	          error("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
	        } else if (child != null && typeof child !== "string" && typeof child !== "number") {
	          error("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
	        }
	      }
	      return children;
	    }
	    function pushStartGenericElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      if (typeof children === "string") {
	        target.push(stringToChunk(encodeHTMLTextNode(children)));
	        return null;
	      }
	      return children;
	    }
	    function pushStartCustomElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            case "style":
	              pushStyle(target, responseState, propValue);
	              break;
	            case "suppressContentEditableWarning":
	            case "suppressHydrationWarning":
	              break;
	            default:
	              if (isAttributeNameSafe(propKey) && typeof propValue !== "function" && typeof propValue !== "symbol") {
	                target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
	              }
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    var leadingNewline = stringToPrecomputedChunk("\n");
	    function pushStartPreformattedElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
	        }
	        if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
	          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          if (typeof html === "string" && html.length > 0 && html[0] === "\n") {
	            target.push(leadingNewline, stringToChunk(html));
	          } else {
	            {
	              checkHtmlStringCoercion(html);
	            }
	            target.push(stringToChunk("" + html));
	          }
	        }
	      }
	      if (typeof children === "string" && children[0] === "\n") {
	        target.push(leadingNewline);
	      }
	      return children;
	    }
	    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	    var validatedTagCache = /* @__PURE__ */ new Map();
	    function startChunkForTag(tag) {
	      var tagStartChunk = validatedTagCache.get(tag);
	      if (tagStartChunk === undefined) {
	        if (!VALID_TAG_REGEX.test(tag)) {
	          throw new Error("Invalid tag: " + tag);
	        }
	        tagStartChunk = stringToPrecomputedChunk("<" + tag);
	        validatedTagCache.set(tag, tagStartChunk);
	      }
	      return tagStartChunk;
	    }
	    var DOCTYPE = stringToPrecomputedChunk("<!DOCTYPE html>");
	    function pushStartInstance(target, type, props, responseState, formatContext) {
	      {
	        validateProperties(type, props);
	        validateProperties$1(type, props);
	        validateProperties$2(type, props, null);
	        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
	          error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
	        }
	        if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
	          if (type.indexOf("-") === -1 && typeof props.is !== "string" && type.toLowerCase() !== type) {
	            error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
	          }
	        }
	      }
	      switch (type) {
	        case "select":
	          return pushStartSelect(target, props, responseState);
	        case "option":
	          return pushStartOption(target, props, responseState, formatContext);
	        case "textarea":
	          return pushStartTextArea(target, props, responseState);
	        case "input":
	          return pushInput(target, props, responseState);
	        case "menuitem":
	          return pushStartMenuItem(target, props, responseState);
	        case "title":
	          return pushStartTitle(target, props, responseState);
	        case "listing":
	        case "pre": {
	          return pushStartPreformattedElement(target, props, type, responseState);
	        }
	        case "area":
	        case "base":
	        case "br":
	        case "col":
	        case "embed":
	        case "hr":
	        case "img":
	        case "keygen":
	        case "link":
	        case "meta":
	        case "param":
	        case "source":
	        case "track":
	        case "wbr": {
	          return pushSelfClosing(target, props, type, responseState);
	        }
	        case "annotation-xml":
	        case "color-profile":
	        case "font-face":
	        case "font-face-src":
	        case "font-face-uri":
	        case "font-face-format":
	        case "font-face-name":
	        case "missing-glyph": {
	          return pushStartGenericElement(target, props, type, responseState);
	        }
	        case "html": {
	          if (formatContext.insertionMode === ROOT_HTML_MODE) {
	            target.push(DOCTYPE);
	          }
	          return pushStartGenericElement(target, props, type, responseState);
	        }
	        default: {
	          if (type.indexOf("-") === -1 && typeof props.is !== "string") {
	            return pushStartGenericElement(target, props, type, responseState);
	          } else {
	            return pushStartCustomElement(target, props, type, responseState);
	          }
	        }
	      }
	    }
	    var endTag1 = stringToPrecomputedChunk("</");
	    var endTag2 = stringToPrecomputedChunk(">");
	    function pushEndInstance(target, type, props) {
	      switch (type) {
	        case "area":
	        case "base":
	        case "br":
	        case "col":
	        case "embed":
	        case "hr":
	        case "img":
	        case "input":
	        case "keygen":
	        case "link":
	        case "meta":
	        case "param":
	        case "source":
	        case "track":
	        case "wbr": {
	          break;
	        }
	        default: {
	          target.push(endTag1, stringToChunk(type), endTag2);
	        }
	      }
	    }
	    function writeCompletedRoot(destination, responseState) {
	      var bootstrapChunks = responseState.bootstrapChunks;
	      var i = 0;
	      for (; i < bootstrapChunks.length - 1; i++) {
	        writeChunk(destination, bootstrapChunks[i]);
	      }
	      if (i < bootstrapChunks.length) {
	        return writeChunkAndReturn(destination, bootstrapChunks[i]);
	      }
	      return true;
	    }
	    var placeholder1 = stringToPrecomputedChunk('<template id="');
	    var placeholder2 = stringToPrecomputedChunk('"></template>');
	    function writePlaceholder(destination, responseState, id) {
	      writeChunk(destination, placeholder1);
	      writeChunk(destination, responseState.placeholderPrefix);
	      var formattedID = stringToChunk(id.toString(16));
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, placeholder2);
	    }
	    var startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->");
	    var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
	    var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
	    var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->");
	    var endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->");
	    var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template");
	    var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
	    var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
	    var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
	    var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
	    var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");
	    function writeStartCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
	    }
	    function writeStartPendingSuspenseBoundary(destination, responseState, id) {
	      writeChunk(destination, startPendingSuspenseBoundary1);
	      if (id === null) {
	        throw new Error("An ID must have been assigned before we can complete the boundary.");
	      }
	      writeChunk(destination, id);
	      return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
	    }
	    function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
	      var result;
	      result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
	      writeChunk(destination, clientRenderedSuspenseBoundaryError1);
	      if (errorDigest) {
	        writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
	        writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
	        writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	      }
	      {
	        if (errorMesssage) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	        if (errorComponentStack) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	      }
	      result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
	      return result;
	    }
	    function writeEndCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndPendingSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
	    var startSegmentHTML2 = stringToPrecomputedChunk('">');
	    var endSegmentHTML = stringToPrecomputedChunk("</div>");
	    var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
	    var startSegmentSVG2 = stringToPrecomputedChunk('">');
	    var endSegmentSVG = stringToPrecomputedChunk("</svg>");
	    var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
	    var startSegmentMathML2 = stringToPrecomputedChunk('">');
	    var endSegmentMathML = stringToPrecomputedChunk("</math>");
	    var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
	    var startSegmentTable2 = stringToPrecomputedChunk('">');
	    var endSegmentTable = stringToPrecomputedChunk("</table>");
	    var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
	    var startSegmentTableBody2 = stringToPrecomputedChunk('">');
	    var endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>");
	    var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
	    var startSegmentTableRow2 = stringToPrecomputedChunk('">');
	    var endSegmentTableRow = stringToPrecomputedChunk("</tr></table>");
	    var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
	    var startSegmentColGroup2 = stringToPrecomputedChunk('">');
	    var endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");
	    function writeStartSegment(destination, responseState, formatContext, id) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE: {
	          writeChunk(destination, startSegmentHTML);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentHTML2);
	        }
	        case SVG_MODE: {
	          writeChunk(destination, startSegmentSVG);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentSVG2);
	        }
	        case MATHML_MODE: {
	          writeChunk(destination, startSegmentMathML);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentMathML2);
	        }
	        case HTML_TABLE_MODE: {
	          writeChunk(destination, startSegmentTable);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentTable2);
	        }
	        case HTML_TABLE_BODY_MODE: {
	          writeChunk(destination, startSegmentTableBody);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentTableBody2);
	        }
	        case HTML_TABLE_ROW_MODE: {
	          writeChunk(destination, startSegmentTableRow);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentTableRow2);
	        }
	        case HTML_COLGROUP_MODE: {
	          writeChunk(destination, startSegmentColGroup);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentColGroup2);
	        }
	        default: {
	          throw new Error("Unknown insertion mode. This is a bug in React.");
	        }
	      }
	    }
	    function writeEndSegment(destination, formatContext) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE: {
	          return writeChunkAndReturn(destination, endSegmentHTML);
	        }
	        case SVG_MODE: {
	          return writeChunkAndReturn(destination, endSegmentSVG);
	        }
	        case MATHML_MODE: {
	          return writeChunkAndReturn(destination, endSegmentMathML);
	        }
	        case HTML_TABLE_MODE: {
	          return writeChunkAndReturn(destination, endSegmentTable);
	        }
	        case HTML_TABLE_BODY_MODE: {
	          return writeChunkAndReturn(destination, endSegmentTableBody);
	        }
	        case HTML_TABLE_ROW_MODE: {
	          return writeChunkAndReturn(destination, endSegmentTableRow);
	        }
	        case HTML_COLGROUP_MODE: {
	          return writeChunkAndReturn(destination, endSegmentColGroup);
	        }
	        default: {
	          throw new Error("Unknown insertion mode. This is a bug in React.");
	        }
	      }
	    }
	    var completeSegmentFunction = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}";
	    var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
	    var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
	    var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
	    var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
	    var completeSegmentScript2 = stringToPrecomputedChunk('","');
	    var completeSegmentScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteSegmentFunction) {
	        responseState.sentCompleteSegmentFunction = true;
	        writeChunk(destination, completeSegmentScript1Full);
	      } else {
	        writeChunk(destination, completeSegmentScript1Partial);
	      }
	      writeChunk(destination, responseState.segmentPrefix);
	      var formattedID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, formattedID);
	      writeChunk(destination, completeSegmentScript2);
	      writeChunk(destination, responseState.placeholderPrefix);
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, completeSegmentScript3);
	    }
	    var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
	    var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
	    var completeBoundaryScript2 = stringToPrecomputedChunk('","');
	    var completeBoundaryScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteBoundaryFunction) {
	        responseState.sentCompleteBoundaryFunction = true;
	        writeChunk(destination, completeBoundaryScript1Full);
	      } else {
	        writeChunk(destination, completeBoundaryScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error("An ID must have been assigned before we can complete the boundary.");
	      }
	      var formattedContentID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, completeBoundaryScript2);
	      writeChunk(destination, responseState.segmentPrefix);
	      writeChunk(destination, formattedContentID);
	      return writeChunkAndReturn(destination, completeBoundaryScript3);
	    }
	    var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
	    var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
	    var clientRenderScript1A = stringToPrecomputedChunk('"');
	    var clientRenderScript2 = stringToPrecomputedChunk(")</script>");
	    var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(",");
	    function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentClientRenderFunction) {
	        responseState.sentClientRenderFunction = true;
	        writeChunk(destination, clientRenderScript1Full);
	      } else {
	        writeChunk(destination, clientRenderScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error("An ID must have been assigned before we can complete the boundary.");
	      }
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, clientRenderScript1A);
	      if (errorDigest || errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || "")));
	      }
	      if (errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || "")));
	      }
	      if (errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
	      }
	      return writeChunkAndReturn(destination, clientRenderScript2);
	    }
	    var regexForJSStringsInScripts = /[<\u2028\u2029]/g;
	    function escapeJSStringsForInstructionScripts(input) {
	      var escaped = JSON.stringify(input);
	      return escaped.replace(regexForJSStringsInScripts, function(match) {
	        switch (match) {
	          case "<":
	            return "\\u003c";
	          case "\u2028":
	            return "\\u2028";
	          case "\u2029":
	            return "\\u2029";
	          default: {
	            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
	          }
	        }
	      });
	    }
	    function createResponseState$1(generateStaticMarkup, identifierPrefix) {
	      var responseState = createResponseState(identifierPrefix);
	      return {
	        // Keep this in sync with ReactDOMServerFormatConfig
	        bootstrapChunks: responseState.bootstrapChunks,
	        startInlineScript: responseState.startInlineScript,
	        placeholderPrefix: responseState.placeholderPrefix,
	        segmentPrefix: responseState.segmentPrefix,
	        boundaryPrefix: responseState.boundaryPrefix,
	        idPrefix: responseState.idPrefix,
	        nextSuspenseID: responseState.nextSuspenseID,
	        sentCompleteSegmentFunction: responseState.sentCompleteSegmentFunction,
	        sentCompleteBoundaryFunction: responseState.sentCompleteBoundaryFunction,
	        sentClientRenderFunction: responseState.sentClientRenderFunction,
	        // This is an extra field for the legacy renderer
	        generateStaticMarkup
	      };
	    }
	    function createRootFormatContext() {
	      return {
	        insertionMode: HTML_MODE,
	        // We skip the root mode because we don't want to emit the DOCTYPE in legacy mode.
	        selectedValue: null
	      };
	    }
	    function pushTextInstance$1(target, text, responseState, textEmbedded) {
	      if (responseState.generateStaticMarkup) {
	        target.push(stringToChunk(escapeTextForBrowser(text)));
	        return false;
	      } else {
	        return pushTextInstance(target, text, responseState, textEmbedded);
	      }
	    }
	    function pushSegmentFinale$1(target, responseState, lastPushedText, textEmbedded) {
	      if (responseState.generateStaticMarkup) {
	        return;
	      } else {
	        return pushSegmentFinale(target, responseState, lastPushedText, textEmbedded);
	      }
	    }
	    function writeStartCompletedSuspenseBoundary$1(destination, responseState) {
	      if (responseState.generateStaticMarkup) {
	        return true;
	      }
	      return writeStartCompletedSuspenseBoundary(destination);
	    }
	    function writeStartClientRenderedSuspenseBoundary$1(destination, responseState, errorDigest, errorMessage, errorComponentStack) {
	      if (responseState.generateStaticMarkup) {
	        return true;
	      }
	      return writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMessage, errorComponentStack);
	    }
	    function writeEndCompletedSuspenseBoundary$1(destination, responseState) {
	      if (responseState.generateStaticMarkup) {
	        return true;
	      }
	      return writeEndCompletedSuspenseBoundary(destination);
	    }
	    function writeEndClientRenderedSuspenseBoundary$1(destination, responseState) {
	      if (responseState.generateStaticMarkup) {
	        return true;
	      }
	      return writeEndClientRenderedSuspenseBoundary(destination);
	    }
	    var assign = Object.assign;
	    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
	    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
	    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
	    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
	    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
	    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
	    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
	    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
	    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
	    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
	    var REACT_MEMO_TYPE = Symbol.for("react.memo");
	    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
	    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
	    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
	    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
	    var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for("react.default_value");
	    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	    var FAUX_ITERATOR_SYMBOL = "@@iterator";
	    function getIteratorFn(maybeIterable) {
	      if (maybeIterable === null || typeof maybeIterable !== "object") {
	        return null;
	      }
	      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
	      if (typeof maybeIterator === "function") {
	        return maybeIterator;
	      }
	      return null;
	    }
	    function getWrappedName(outerType, innerType, wrapperName) {
	      var displayName = outerType.displayName;
	      if (displayName) {
	        return displayName;
	      }
	      var functionName = innerType.displayName || innerType.name || "";
	      return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
	    }
	    function getContextName(type) {
	      return type.displayName || "Context";
	    }
	    function getComponentNameFromType(type) {
	      if (type == null) {
	        return null;
	      }
	      {
	        if (typeof type.tag === "number") {
	          error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
	        }
	      }
	      if (typeof type === "function") {
	        return type.displayName || type.name || null;
	      }
	      if (typeof type === "string") {
	        return type;
	      }
	      switch (type) {
	        case REACT_FRAGMENT_TYPE:
	          return "Fragment";
	        case REACT_PORTAL_TYPE:
	          return "Portal";
	        case REACT_PROFILER_TYPE:
	          return "Profiler";
	        case REACT_STRICT_MODE_TYPE:
	          return "StrictMode";
	        case REACT_SUSPENSE_TYPE:
	          return "Suspense";
	        case REACT_SUSPENSE_LIST_TYPE:
	          return "SuspenseList";
	      }
	      if (typeof type === "object") {
	        switch (type.$$typeof) {
	          case REACT_CONTEXT_TYPE:
	            var context = type;
	            return getContextName(context) + ".Consumer";
	          case REACT_PROVIDER_TYPE:
	            var provider = type;
	            return getContextName(provider._context) + ".Provider";
	          case REACT_FORWARD_REF_TYPE:
	            return getWrappedName(type, type.render, "ForwardRef");
	          case REACT_MEMO_TYPE:
	            var outerName = type.displayName || null;
	            if (outerName !== null) {
	              return outerName;
	            }
	            return getComponentNameFromType(type.type) || "Memo";
	          case REACT_LAZY_TYPE: {
	            var lazyComponent = type;
	            var payload = lazyComponent._payload;
	            var init = lazyComponent._init;
	            try {
	              return getComponentNameFromType(init(payload));
	            } catch (x) {
	              return null;
	            }
	          }
	        }
	      }
	      return null;
	    }
	    var disabledDepth = 0;
	    var prevLog;
	    var prevInfo;
	    var prevWarn;
	    var prevError;
	    var prevGroup;
	    var prevGroupCollapsed;
	    var prevGroupEnd;
	    function disabledLog() {
	    }
	    disabledLog.__reactDisabledLog = true;
	    function disableLogs() {
	      {
	        if (disabledDepth === 0) {
	          prevLog = console.log;
	          prevInfo = console.info;
	          prevWarn = console.warn;
	          prevError = console.error;
	          prevGroup = console.group;
	          prevGroupCollapsed = console.groupCollapsed;
	          prevGroupEnd = console.groupEnd;
	          var props = {
	            configurable: true,
	            enumerable: true,
	            value: disabledLog,
	            writable: true
	          };
	          Object.defineProperties(console, {
	            info: props,
	            log: props,
	            warn: props,
	            error: props,
	            group: props,
	            groupCollapsed: props,
	            groupEnd: props
	          });
	        }
	        disabledDepth++;
	      }
	    }
	    function reenableLogs() {
	      {
	        disabledDepth--;
	        if (disabledDepth === 0) {
	          var props = {
	            configurable: true,
	            enumerable: true,
	            writable: true
	          };
	          Object.defineProperties(console, {
	            log: assign({}, props, {
	              value: prevLog
	            }),
	            info: assign({}, props, {
	              value: prevInfo
	            }),
	            warn: assign({}, props, {
	              value: prevWarn
	            }),
	            error: assign({}, props, {
	              value: prevError
	            }),
	            group: assign({}, props, {
	              value: prevGroup
	            }),
	            groupCollapsed: assign({}, props, {
	              value: prevGroupCollapsed
	            }),
	            groupEnd: assign({}, props, {
	              value: prevGroupEnd
	            })
	          });
	        }
	        if (disabledDepth < 0) {
	          error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
	        }
	      }
	    }
	    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	    var prefix;
	    function describeBuiltInComponentFrame(name, source, ownerFn) {
	      {
	        if (prefix === undefined) {
	          try {
	            throw Error();
	          } catch (x) {
	            var match = x.stack.trim().match(/\n( *(at )?)/);
	            prefix = match && match[1] || "";
	          }
	        }
	        return "\n" + prefix + name;
	      }
	    }
	    var reentry = false;
	    var componentFrameCache;
	    {
	      var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
	      componentFrameCache = new PossiblyWeakMap();
	    }
	    function describeNativeComponentFrame(fn, construct) {
	      if (!fn || reentry) {
	        return "";
	      }
	      {
	        var frame = componentFrameCache.get(fn);
	        if (frame !== undefined) {
	          return frame;
	        }
	      }
	      var control;
	      reentry = true;
	      var previousPrepareStackTrace = Error.prepareStackTrace;
	      Error.prepareStackTrace = undefined;
	      var previousDispatcher;
	      {
	        previousDispatcher = ReactCurrentDispatcher.current;
	        ReactCurrentDispatcher.current = null;
	        disableLogs();
	      }
	      try {
	        if (construct) {
	          var Fake = function() {
	            throw Error();
	          };
	          Object.defineProperty(Fake.prototype, "props", {
	            set: function() {
	              throw Error();
	            }
	          });
	          if (typeof Reflect === "object" && Reflect.construct) {
	            try {
	              Reflect.construct(Fake, []);
	            } catch (x) {
	              control = x;
	            }
	            Reflect.construct(fn, [], Fake);
	          } else {
	            try {
	              Fake.call();
	            } catch (x) {
	              control = x;
	            }
	            fn.call(Fake.prototype);
	          }
	        } else {
	          try {
	            throw Error();
	          } catch (x) {
	            control = x;
	          }
	          fn();
	        }
	      } catch (sample) {
	        if (sample && control && typeof sample.stack === "string") {
	          var sampleLines = sample.stack.split("\n");
	          var controlLines = control.stack.split("\n");
	          var s = sampleLines.length - 1;
	          var c = controlLines.length - 1;
	          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	            c--;
	          }
	          for (; s >= 1 && c >= 0; s--, c--) {
	            if (sampleLines[s] !== controlLines[c]) {
	              if (s !== 1 || c !== 1) {
	                do {
	                  s--;
	                  c--;
	                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                    var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
	                    if (fn.displayName && _frame.includes("<anonymous>")) {
	                      _frame = _frame.replace("<anonymous>", fn.displayName);
	                    }
	                    {
	                      if (typeof fn === "function") {
	                        componentFrameCache.set(fn, _frame);
	                      }
	                    }
	                    return _frame;
	                  }
	                } while (s >= 1 && c >= 0);
	              }
	              break;
	            }
	          }
	        }
	      } finally {
	        reentry = false;
	        {
	          ReactCurrentDispatcher.current = previousDispatcher;
	          reenableLogs();
	        }
	        Error.prepareStackTrace = previousPrepareStackTrace;
	      }
	      var name = fn ? fn.displayName || fn.name : "";
	      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
	      {
	        if (typeof fn === "function") {
	          componentFrameCache.set(fn, syntheticFrame);
	        }
	      }
	      return syntheticFrame;
	    }
	    function describeClassComponentFrame(ctor, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(ctor, true);
	      }
	    }
	    function describeFunctionComponentFrame(fn, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(fn, false);
	      }
	    }
	    function shouldConstruct(Component) {
	      var prototype = Component.prototype;
	      return !!(prototype && prototype.isReactComponent);
	    }
	    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
	      if (type == null) {
	        return "";
	      }
	      if (typeof type === "function") {
	        {
	          return describeNativeComponentFrame(type, shouldConstruct(type));
	        }
	      }
	      if (typeof type === "string") {
	        return describeBuiltInComponentFrame(type);
	      }
	      switch (type) {
	        case REACT_SUSPENSE_TYPE:
	          return describeBuiltInComponentFrame("Suspense");
	        case REACT_SUSPENSE_LIST_TYPE:
	          return describeBuiltInComponentFrame("SuspenseList");
	      }
	      if (typeof type === "object") {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            return describeFunctionComponentFrame(type.render);
	          case REACT_MEMO_TYPE:
	            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
	          case REACT_LAZY_TYPE: {
	            var lazyComponent = type;
	            var payload = lazyComponent._payload;
	            var init = lazyComponent._init;
	            try {
	              return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	            } catch (x) {
	            }
	          }
	        }
	      }
	      return "";
	    }
	    var loggedTypeFailures = {};
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    function setCurrentlyValidatingElement(element) {
	      {
	        if (element) {
	          var owner = element._owner;
	          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	          ReactDebugCurrentFrame.setExtraStackFrame(stack);
	        } else {
	          ReactDebugCurrentFrame.setExtraStackFrame(null);
	        }
	      }
	    }
	    function checkPropTypes(typeSpecs, values, location, componentName, element) {
	      {
	        var has = Function.call.bind(hasOwnProperty);
	        for (var typeSpecName in typeSpecs) {
	          if (has(typeSpecs, typeSpecName)) {
	            var error$1 = undefined;
	            try {
	              if (typeof typeSpecs[typeSpecName] !== "function") {
	                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
	                err.name = "Invariant Violation";
	                throw err;
	              }
	              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
	            } catch (ex) {
	              error$1 = ex;
	            }
	            if (error$1 && !(error$1 instanceof Error)) {
	              setCurrentlyValidatingElement(element);
	              error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
	              setCurrentlyValidatingElement(null);
	            }
	            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	              loggedTypeFailures[error$1.message] = true;
	              setCurrentlyValidatingElement(element);
	              error("Failed %s type: %s", location, error$1.message);
	              setCurrentlyValidatingElement(null);
	            }
	          }
	        }
	      }
	    }
	    var warnedAboutMissingGetChildContext;
	    {
	      warnedAboutMissingGetChildContext = {};
	    }
	    var emptyContextObject = {};
	    {
	      Object.freeze(emptyContextObject);
	    }
	    function getMaskedContext(type, unmaskedContext) {
	      {
	        var contextTypes = type.contextTypes;
	        if (!contextTypes) {
	          return emptyContextObject;
	        }
	        var context = {};
	        for (var key in contextTypes) {
	          context[key] = unmaskedContext[key];
	        }
	        {
	          var name = getComponentNameFromType(type) || "Unknown";
	          checkPropTypes(contextTypes, context, "context", name);
	        }
	        return context;
	      }
	    }
	    function processChildContext(instance, type, parentContext, childContextTypes) {
	      {
	        if (typeof instance.getChildContext !== "function") {
	          {
	            var componentName = getComponentNameFromType(type) || "Unknown";
	            if (!warnedAboutMissingGetChildContext[componentName]) {
	              warnedAboutMissingGetChildContext[componentName] = true;
	              error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
	            }
	          }
	          return parentContext;
	        }
	        var childContext = instance.getChildContext();
	        for (var contextKey in childContext) {
	          if (!(contextKey in childContextTypes)) {
	            throw new Error((getComponentNameFromType(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
	          }
	        }
	        {
	          var name = getComponentNameFromType(type) || "Unknown";
	          checkPropTypes(childContextTypes, childContext, "child context", name);
	        }
	        return assign({}, parentContext, childContext);
	      }
	    }
	    var rendererSigil;
	    {
	      rendererSigil = {};
	    }
	    var rootContextSnapshot = null;
	    var currentActiveSnapshot = null;
	    function popNode(prev) {
	      {
	        prev.context._currentValue2 = prev.parentValue;
	      }
	    }
	    function pushNode(next) {
	      {
	        next.context._currentValue2 = next.value;
	      }
	    }
	    function popToNearestCommonAncestor(prev, next) {
	      if (prev === next) ;
	      else {
	        popNode(prev);
	        var parentPrev = prev.parent;
	        var parentNext = next.parent;
	        if (parentPrev === null) {
	          if (parentNext !== null) {
	            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
	          }
	        } else {
	          if (parentNext === null) {
	            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
	          }
	          popToNearestCommonAncestor(parentPrev, parentNext);
	        }
	        pushNode(next);
	      }
	    }
	    function popAllPrevious(prev) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev !== null) {
	        popAllPrevious(parentPrev);
	      }
	    }
	    function pushAllNext(next) {
	      var parentNext = next.parent;
	      if (parentNext !== null) {
	        pushAllNext(parentNext);
	      }
	      pushNode(next);
	    }
	    function popPreviousToCommonLevel(prev, next) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev === null) {
	        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
	      }
	      if (parentPrev.depth === next.depth) {
	        popToNearestCommonAncestor(parentPrev, next);
	      } else {
	        popPreviousToCommonLevel(parentPrev, next);
	      }
	    }
	    function popNextToCommonLevel(prev, next) {
	      var parentNext = next.parent;
	      if (parentNext === null) {
	        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
	      }
	      if (prev.depth === parentNext.depth) {
	        popToNearestCommonAncestor(prev, parentNext);
	      } else {
	        popNextToCommonLevel(prev, parentNext);
	      }
	      pushNode(next);
	    }
	    function switchContext(newSnapshot) {
	      var prev = currentActiveSnapshot;
	      var next = newSnapshot;
	      if (prev !== next) {
	        if (prev === null) {
	          pushAllNext(next);
	        } else if (next === null) {
	          popAllPrevious(prev);
	        } else if (prev.depth === next.depth) {
	          popToNearestCommonAncestor(prev, next);
	        } else if (prev.depth > next.depth) {
	          popPreviousToCommonLevel(prev, next);
	        } else {
	          popNextToCommonLevel(prev, next);
	        }
	        currentActiveSnapshot = next;
	      }
	    }
	    function pushProvider(context, nextValue) {
	      var prevValue;
	      {
	        prevValue = context._currentValue2;
	        context._currentValue2 = nextValue;
	        {
	          if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
	            error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
	          }
	          context._currentRenderer2 = rendererSigil;
	        }
	      }
	      var prevNode = currentActiveSnapshot;
	      var newNode = {
	        parent: prevNode,
	        depth: prevNode === null ? 0 : prevNode.depth + 1,
	        context,
	        parentValue: prevValue,
	        value: nextValue
	      };
	      currentActiveSnapshot = newNode;
	      return newNode;
	    }
	    function popProvider(context) {
	      var prevSnapshot = currentActiveSnapshot;
	      if (prevSnapshot === null) {
	        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
	      }
	      {
	        if (prevSnapshot.context !== context) {
	          error("The parent context is not the expected context. This is probably a bug in React.");
	        }
	      }
	      {
	        var _value = prevSnapshot.parentValue;
	        if (_value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) {
	          prevSnapshot.context._currentValue2 = prevSnapshot.context._defaultValue;
	        } else {
	          prevSnapshot.context._currentValue2 = _value;
	        }
	        {
	          if (context._currentRenderer2 !== undefined && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
	            error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
	          }
	          context._currentRenderer2 = rendererSigil;
	        }
	      }
	      return currentActiveSnapshot = prevSnapshot.parent;
	    }
	    function getActiveContext() {
	      return currentActiveSnapshot;
	    }
	    function readContext(context) {
	      var value = context._currentValue2;
	      return value;
	    }
	    function get(key) {
	      return key._reactInternals;
	    }
	    function set(key, value) {
	      key._reactInternals = value;
	    }
	    var didWarnAboutNoopUpdateForComponent = {};
	    var didWarnAboutDeprecatedWillMount = {};
	    var didWarnAboutUninitializedState;
	    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
	    var didWarnAboutLegacyLifecyclesAndDerivedState;
	    var didWarnAboutUndefinedDerivedState;
	    var warnOnUndefinedDerivedState;
	    var warnOnInvalidCallback;
	    var didWarnAboutDirectlyAssigningPropsToState;
	    var didWarnAboutContextTypeAndContextTypes;
	    var didWarnAboutInvalidateContextType;
	    {
	      didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
	      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
	      didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
	      didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
	      didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
	      didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */ new Set();
	      didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
	      var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
	      warnOnInvalidCallback = function(callback, callerName) {
	        if (callback === null || typeof callback === "function") {
	          return;
	        }
	        var key = callerName + "_" + callback;
	        if (!didWarnOnInvalidCallback.has(key)) {
	          didWarnOnInvalidCallback.add(key);
	          error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
	        }
	      };
	      warnOnUndefinedDerivedState = function(type, partialState) {
	        if (partialState === undefined) {
	          var componentName = getComponentNameFromType(type) || "Component";
	          if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
	            didWarnAboutUndefinedDerivedState.add(componentName);
	            error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
	          }
	        }
	      };
	    }
	    function warnNoop(publicInstance, callerName) {
	      {
	        var _constructor = publicInstance.constructor;
	        var componentName = _constructor && getComponentNameFromType(_constructor) || "ReactClass";
	        var warningKey = componentName + "." + callerName;
	        if (didWarnAboutNoopUpdateForComponent[warningKey]) {
	          return;
	        }
	        error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
	        didWarnAboutNoopUpdateForComponent[warningKey] = true;
	      }
	    }
	    var classComponentUpdater = {
	      isMounted: function(inst) {
	        return false;
	      },
	      enqueueSetState: function(inst, payload, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, "setState");
	        } else {
	          internals.queue.push(payload);
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, "setState");
	            }
	          }
	        }
	      },
	      enqueueReplaceState: function(inst, payload, callback) {
	        var internals = get(inst);
	        internals.replace = true;
	        internals.queue = [payload];
	        {
	          if (callback !== undefined && callback !== null) {
	            warnOnInvalidCallback(callback, "setState");
	          }
	        }
	      },
	      enqueueForceUpdate: function(inst, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, "forceUpdate");
	        } else {
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, "setState");
	            }
	          }
	        }
	      }
	    };
	    function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
	      var partialState = getDerivedStateFromProps(nextProps, prevState);
	      {
	        warnOnUndefinedDerivedState(ctor, partialState);
	      }
	      var newState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
	      return newState;
	    }
	    function constructClassInstance(ctor, props, maskedLegacyContext) {
	      var context = emptyContextObject;
	      var contextType = ctor.contextType;
	      {
	        if ("contextType" in ctor) {
	          var isValid = (
	            // Allow null for conditional declaration
	            contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined
	          );
	          if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
	            didWarnAboutInvalidateContextType.add(ctor);
	            var addendum = "";
	            if (contextType === undefined) {
	              addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
	            } else if (typeof contextType !== "object") {
	              addendum = " However, it is set to a " + typeof contextType + ".";
	            } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
	              addendum = " Did you accidentally pass the Context.Provider instead?";
	            } else if (contextType._context !== undefined) {
	              addendum = " Did you accidentally pass the Context.Consumer instead?";
	            } else {
	              addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
	            }
	            error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
	          }
	        }
	      }
	      if (typeof contextType === "object" && contextType !== null) {
	        context = readContext(contextType);
	      } else {
	        context = maskedLegacyContext;
	      }
	      var instance = new ctor(props, context);
	      {
	        if (typeof ctor.getDerivedStateFromProps === "function" && (instance.state === null || instance.state === undefined)) {
	          var componentName = getComponentNameFromType(ctor) || "Component";
	          if (!didWarnAboutUninitializedState.has(componentName)) {
	            didWarnAboutUninitializedState.add(componentName);
	            error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
	          }
	        }
	        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
	          var foundWillMountName = null;
	          var foundWillReceivePropsName = null;
	          var foundWillUpdateName = null;
	          if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            foundWillMountName = "componentWillMount";
	          } else if (typeof instance.UNSAFE_componentWillMount === "function") {
	            foundWillMountName = "UNSAFE_componentWillMount";
	          }
	          if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
	            foundWillReceivePropsName = "componentWillReceiveProps";
	          } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
	            foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
	          }
	          if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
	            foundWillUpdateName = "componentWillUpdate";
	          } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
	            foundWillUpdateName = "UNSAFE_componentWillUpdate";
	          }
	          if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
	            var _componentName = getComponentNameFromType(ctor) || "Component";
	            var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
	            if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
	              didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
	              error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
	            }
	          }
	        }
	      }
	      return instance;
	    }
	    function checkClassInstance(instance, ctor, newProps) {
	      {
	        var name = getComponentNameFromType(ctor) || "Component";
	        var renderPresent = instance.render;
	        if (!renderPresent) {
	          if (ctor.prototype && typeof ctor.prototype.render === "function") {
	            error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
	          } else {
	            error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
	          }
	        }
	        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
	          error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
	        }
	        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
	          error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
	        }
	        if (instance.propTypes) {
	          error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
	        }
	        if (instance.contextType) {
	          error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
	        }
	        {
	          if (instance.contextTypes) {
	            error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
	          }
	          if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
	            didWarnAboutContextTypeAndContextTypes.add(ctor);
	            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
	          }
	        }
	        if (typeof instance.componentShouldUpdate === "function") {
	          error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
	        }
	        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
	          error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
	        }
	        if (typeof instance.componentDidUnmount === "function") {
	          error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
	        }
	        if (typeof instance.componentDidReceiveProps === "function") {
	          error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
	        }
	        if (typeof instance.componentWillRecieveProps === "function") {
	          error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
	        }
	        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
	          error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
	        }
	        var hasMutatedProps = instance.props !== newProps;
	        if (instance.props !== undefined && hasMutatedProps) {
	          error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
	        }
	        if (instance.defaultProps) {
	          error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
	        }
	        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
	          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
	          error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
	        }
	        if (typeof instance.getDerivedStateFromProps === "function") {
	          error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
	        }
	        if (typeof instance.getDerivedStateFromError === "function") {
	          error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
	        }
	        if (typeof ctor.getSnapshotBeforeUpdate === "function") {
	          error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
	        }
	        var _state = instance.state;
	        if (_state && (typeof _state !== "object" || isArray(_state))) {
	          error("%s.state: must be set to an object or null", name);
	        }
	        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
	          error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
	        }
	      }
	    }
	    function callComponentWillMount(type, instance) {
	      var oldState = instance.state;
	      if (typeof instance.componentWillMount === "function") {
	        {
	          if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            var componentName = getComponentNameFromType(type) || "Unknown";
	            if (!didWarnAboutDeprecatedWillMount[componentName]) {
	              warn(
	                // keep this warning in sync with ReactStrictModeWarning.js
	                "componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s",
	                componentName
	              );
	              didWarnAboutDeprecatedWillMount[componentName] = true;
	            }
	          }
	        }
	        instance.componentWillMount();
	      }
	      if (typeof instance.UNSAFE_componentWillMount === "function") {
	        instance.UNSAFE_componentWillMount();
	      }
	      if (oldState !== instance.state) {
	        {
	          error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromType(type) || "Component");
	        }
	        classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
	      }
	    }
	    function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
	      if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
	        var oldQueue = internalInstance.queue;
	        var oldReplace = internalInstance.replace;
	        internalInstance.queue = null;
	        internalInstance.replace = false;
	        if (oldReplace && oldQueue.length === 1) {
	          inst.state = oldQueue[0];
	        } else {
	          var nextState = oldReplace ? oldQueue[0] : inst.state;
	          var dontMutate = true;
	          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
	            var partial = oldQueue[i];
	            var partialState = typeof partial === "function" ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;
	            if (partialState != null) {
	              if (dontMutate) {
	                dontMutate = false;
	                nextState = assign({}, nextState, partialState);
	              } else {
	                assign(nextState, partialState);
	              }
	            }
	          }
	          inst.state = nextState;
	        }
	      } else {
	        internalInstance.queue = null;
	      }
	    }
	    function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
	      {
	        checkClassInstance(instance, ctor, newProps);
	      }
	      var initialState = instance.state !== undefined ? instance.state : null;
	      instance.updater = classComponentUpdater;
	      instance.props = newProps;
	      instance.state = initialState;
	      var internalInstance = {
	        queue: [],
	        replace: false
	      };
	      set(instance, internalInstance);
	      var contextType = ctor.contextType;
	      if (typeof contextType === "object" && contextType !== null) {
	        instance.context = readContext(contextType);
	      } else {
	        instance.context = maskedLegacyContext;
	      }
	      {
	        if (instance.state === newProps) {
	          var componentName = getComponentNameFromType(ctor) || "Component";
	          if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
	            didWarnAboutDirectlyAssigningPropsToState.add(componentName);
	            error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
	          }
	        }
	      }
	      var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
	      if (typeof getDerivedStateFromProps === "function") {
	        instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
	      }
	      if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
	        callComponentWillMount(ctor, instance);
	        processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
	      }
	    }
	    var emptyTreeContext = {
	      id: 1,
	      overflow: ""
	    };
	    function getTreeId(context) {
	      var overflow = context.overflow;
	      var idWithLeadingBit = context.id;
	      var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
	      return id.toString(32) + overflow;
	    }
	    function pushTreeContext(baseContext, totalChildren, index) {
	      var baseIdWithLeadingBit = baseContext.id;
	      var baseOverflow = baseContext.overflow;
	      var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
	      var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
	      var slot = index + 1;
	      var length = getBitLength(totalChildren) + baseLength;
	      if (length > 30) {
	        var numberOfOverflowBits = baseLength - baseLength % 5;
	        var newOverflowBits = (1 << numberOfOverflowBits) - 1;
	        var newOverflow = (baseId & newOverflowBits).toString(32);
	        var restOfBaseId = baseId >> numberOfOverflowBits;
	        var restOfBaseLength = baseLength - numberOfOverflowBits;
	        var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
	        var restOfNewBits = slot << restOfBaseLength;
	        var id = restOfNewBits | restOfBaseId;
	        var overflow = newOverflow + baseOverflow;
	        return {
	          id: 1 << restOfLength | id,
	          overflow
	        };
	      } else {
	        var newBits = slot << baseLength;
	        var _id = newBits | baseId;
	        var _overflow = baseOverflow;
	        return {
	          id: 1 << length | _id,
	          overflow: _overflow
	        };
	      }
	    }
	    function getBitLength(number) {
	      return 32 - clz32(number);
	    }
	    function getLeadingBit(id) {
	      return 1 << getBitLength(id) - 1;
	    }
	    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
	    var log = Math.log;
	    var LN2 = Math.LN2;
	    function clz32Fallback(x) {
	      var asUint = x >>> 0;
	      if (asUint === 0) {
	        return 32;
	      }
	      return 31 - (log(asUint) / LN2 | 0) | 0;
	    }
	    function is(x, y) {
	      return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
	    }
	    var objectIs = typeof Object.is === "function" ? Object.is : is;
	    var currentlyRenderingComponent = null;
	    var currentlyRenderingTask = null;
	    var firstWorkInProgressHook = null;
	    var workInProgressHook = null;
	    var isReRender = false;
	    var didScheduleRenderPhaseUpdate = false;
	    var localIdCounter = 0;
	    var renderPhaseUpdates = null;
	    var numberOfReRenders = 0;
	    var RE_RENDER_LIMIT = 25;
	    var isInHookUserCodeInDev = false;
	    var currentHookNameInDev;
	    function resolveCurrentlyRenderingComponent() {
	      if (currentlyRenderingComponent === null) {
	        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
	      }
	      {
	        if (isInHookUserCodeInDev) {
	          error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
	        }
	      }
	      return currentlyRenderingComponent;
	    }
	    function areHookInputsEqual(nextDeps, prevDeps) {
	      if (prevDeps === null) {
	        {
	          error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
	        }
	        return false;
	      }
	      {
	        if (nextDeps.length !== prevDeps.length) {
	          error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(", ") + "]", "[" + prevDeps.join(", ") + "]");
	        }
	      }
	      for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
	        if (objectIs(nextDeps[i], prevDeps[i])) {
	          continue;
	        }
	        return false;
	      }
	      return true;
	    }
	    function createHook() {
	      if (numberOfReRenders > 0) {
	        throw new Error("Rendered more hooks than during the previous render");
	      }
	      return {
	        memoizedState: null,
	        queue: null,
	        next: null
	      };
	    }
	    function createWorkInProgressHook() {
	      if (workInProgressHook === null) {
	        if (firstWorkInProgressHook === null) {
	          isReRender = false;
	          firstWorkInProgressHook = workInProgressHook = createHook();
	        } else {
	          isReRender = true;
	          workInProgressHook = firstWorkInProgressHook;
	        }
	      } else {
	        if (workInProgressHook.next === null) {
	          isReRender = false;
	          workInProgressHook = workInProgressHook.next = createHook();
	        } else {
	          isReRender = true;
	          workInProgressHook = workInProgressHook.next;
	        }
	      }
	      return workInProgressHook;
	    }
	    function prepareToUseHooks(task, componentIdentity) {
	      currentlyRenderingComponent = componentIdentity;
	      currentlyRenderingTask = task;
	      {
	        isInHookUserCodeInDev = false;
	      }
	      localIdCounter = 0;
	    }
	    function finishHooks(Component, props, children, refOrContext) {
	      while (didScheduleRenderPhaseUpdate) {
	        didScheduleRenderPhaseUpdate = false;
	        localIdCounter = 0;
	        numberOfReRenders += 1;
	        workInProgressHook = null;
	        children = Component(props, refOrContext);
	      }
	      resetHooksState();
	      return children;
	    }
	    function checkDidRenderIdHook() {
	      var didRenderIdHook = localIdCounter !== 0;
	      return didRenderIdHook;
	    }
	    function resetHooksState() {
	      {
	        isInHookUserCodeInDev = false;
	      }
	      currentlyRenderingComponent = null;
	      currentlyRenderingTask = null;
	      didScheduleRenderPhaseUpdate = false;
	      firstWorkInProgressHook = null;
	      numberOfReRenders = 0;
	      renderPhaseUpdates = null;
	      workInProgressHook = null;
	    }
	    function readContext$1(context) {
	      {
	        if (isInHookUserCodeInDev) {
	          error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
	        }
	      }
	      return readContext(context);
	    }
	    function useContext(context) {
	      {
	        currentHookNameInDev = "useContext";
	      }
	      resolveCurrentlyRenderingComponent();
	      return readContext(context);
	    }
	    function basicStateReducer(state, action) {
	      return typeof action === "function" ? action(state) : action;
	    }
	    function useState(initialState) {
	      {
	        currentHookNameInDev = "useState";
	      }
	      return useReducer(
	        basicStateReducer,
	        // useReducer has a special case to support lazy useState initializers
	        initialState
	      );
	    }
	    function useReducer(reducer, initialArg, init) {
	      {
	        if (reducer !== basicStateReducer) {
	          currentHookNameInDev = "useReducer";
	        }
	      }
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      if (isReRender) {
	        var queue = workInProgressHook.queue;
	        var dispatch = queue.dispatch;
	        if (renderPhaseUpdates !== null) {
	          var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	          if (firstRenderPhaseUpdate !== undefined) {
	            renderPhaseUpdates.delete(queue);
	            var newState = workInProgressHook.memoizedState;
	            var update = firstRenderPhaseUpdate;
	            do {
	              var action = update.action;
	              {
	                isInHookUserCodeInDev = true;
	              }
	              newState = reducer(newState, action);
	              {
	                isInHookUserCodeInDev = false;
	              }
	              update = update.next;
	            } while (update !== null);
	            workInProgressHook.memoizedState = newState;
	            return [newState, dispatch];
	          }
	        }
	        return [workInProgressHook.memoizedState, dispatch];
	      } else {
	        {
	          isInHookUserCodeInDev = true;
	        }
	        var initialState;
	        if (reducer === basicStateReducer) {
	          initialState = typeof initialArg === "function" ? initialArg() : initialArg;
	        } else {
	          initialState = init !== undefined ? init(initialArg) : initialArg;
	        }
	        {
	          isInHookUserCodeInDev = false;
	        }
	        workInProgressHook.memoizedState = initialState;
	        var _queue = workInProgressHook.queue = {
	          last: null,
	          dispatch: null
	        };
	        var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
	        return [workInProgressHook.memoizedState, _dispatch];
	      }
	    }
	    function useMemo(nextCreate, deps) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var nextDeps = deps === undefined ? null : deps;
	      if (workInProgressHook !== null) {
	        var prevState = workInProgressHook.memoizedState;
	        if (prevState !== null) {
	          if (nextDeps !== null) {
	            var prevDeps = prevState[1];
	            if (areHookInputsEqual(nextDeps, prevDeps)) {
	              return prevState[0];
	            }
	          }
	        }
	      }
	      {
	        isInHookUserCodeInDev = true;
	      }
	      var nextValue = nextCreate();
	      {
	        isInHookUserCodeInDev = false;
	      }
	      workInProgressHook.memoizedState = [nextValue, nextDeps];
	      return nextValue;
	    }
	    function useRef(initialValue) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var previousRef = workInProgressHook.memoizedState;
	      if (previousRef === null) {
	        var ref = {
	          current: initialValue
	        };
	        {
	          Object.seal(ref);
	        }
	        workInProgressHook.memoizedState = ref;
	        return ref;
	      } else {
	        return previousRef;
	      }
	    }
	    function useLayoutEffect(create, inputs) {
	      {
	        currentHookNameInDev = "useLayoutEffect";
	        error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
	      }
	    }
	    function dispatchAction(componentIdentity, queue, action) {
	      if (numberOfReRenders >= RE_RENDER_LIMIT) {
	        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
	      }
	      if (componentIdentity === currentlyRenderingComponent) {
	        didScheduleRenderPhaseUpdate = true;
	        var update = {
	          action,
	          next: null
	        };
	        if (renderPhaseUpdates === null) {
	          renderPhaseUpdates = /* @__PURE__ */ new Map();
	        }
	        var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	        if (firstRenderPhaseUpdate === undefined) {
	          renderPhaseUpdates.set(queue, update);
	        } else {
	          var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
	          while (lastRenderPhaseUpdate.next !== null) {
	            lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
	          }
	          lastRenderPhaseUpdate.next = update;
	        }
	      }
	    }
	    function useCallback(callback, deps) {
	      return useMemo(function() {
	        return callback;
	      }, deps);
	    }
	    function useMutableSource(source, getSnapshot, subscribe) {
	      resolveCurrentlyRenderingComponent();
	      return getSnapshot(source._source);
	    }
	    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
	      if (getServerSnapshot === undefined) {
	        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
	      }
	      return getServerSnapshot();
	    }
	    function useDeferredValue(value) {
	      resolveCurrentlyRenderingComponent();
	      return value;
	    }
	    function unsupportedStartTransition() {
	      throw new Error("startTransition cannot be called during server rendering.");
	    }
	    function useTransition() {
	      resolveCurrentlyRenderingComponent();
	      return [false, unsupportedStartTransition];
	    }
	    function useId() {
	      var task = currentlyRenderingTask;
	      var treeId = getTreeId(task.treeContext);
	      var responseState = currentResponseState;
	      if (responseState === null) {
	        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
	      }
	      var localId = localIdCounter++;
	      return makeId(responseState, treeId, localId);
	    }
	    function noop() {
	    }
	    var Dispatcher = {
	      readContext: readContext$1,
	      useContext,
	      useMemo,
	      useReducer,
	      useRef,
	      useState,
	      useInsertionEffect: noop,
	      useLayoutEffect,
	      useCallback,
	      // useImperativeHandle is not run in the server environment
	      useImperativeHandle: noop,
	      // Effects are not run in the server environment.
	      useEffect: noop,
	      // Debugging effect
	      useDebugValue: noop,
	      useDeferredValue,
	      useTransition,
	      useId,
	      // Subscriptions are not setup in a server environment.
	      useMutableSource,
	      useSyncExternalStore
	    };
	    var currentResponseState = null;
	    function setCurrentResponseState(responseState) {
	      currentResponseState = responseState;
	    }
	    function getStackByComponentStackNode(componentStack) {
	      try {
	        var info = "";
	        var node = componentStack;
	        do {
	          switch (node.tag) {
	            case 0:
	              info += describeBuiltInComponentFrame(node.type, null, null);
	              break;
	            case 1:
	              info += describeFunctionComponentFrame(node.type, null, null);
	              break;
	            case 2:
	              info += describeClassComponentFrame(node.type, null, null);
	              break;
	          }
	          node = node.parent;
	        } while (node);
	        return info;
	      } catch (x) {
	        return "\nError generating stack: " + x.message + "\n" + x.stack;
	      }
	    }
	    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
	    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
	    var PENDING = 0;
	    var COMPLETED = 1;
	    var FLUSHED = 2;
	    var ABORTED = 3;
	    var ERRORED = 4;
	    var OPEN = 0;
	    var CLOSING = 1;
	    var CLOSED = 2;
	    var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;
	    function defaultErrorHandler(error2) {
	      console["error"](error2);
	      return null;
	    }
	    function noop$1() {
	    }
	    function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError2, onAllReady, onShellReady, onShellError, onFatalError) {
	      var pingedTasks = [];
	      var abortSet = /* @__PURE__ */ new Set();
	      var request = {
	        destination: null,
	        responseState,
	        progressiveChunkSize: progressiveChunkSize === undefined ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
	        status: OPEN,
	        fatalError: null,
	        nextSegmentId: 0,
	        allPendingTasks: 0,
	        pendingRootTasks: 0,
	        completedRootSegment: null,
	        abortableTasks: abortSet,
	        pingedTasks,
	        clientRenderedBoundaries: [],
	        completedBoundaries: [],
	        partialBoundaries: [],
	        onError: onError2 === undefined ? defaultErrorHandler : onError2,
	        onAllReady: noop$1 ,
	        onShellReady: onShellReady === undefined ? noop$1 : onShellReady,
	        onShellError: noop$1 ,
	        onFatalError: noop$1 
	      };
	      var rootSegment = createPendingSegment(
	        request,
	        0,
	        null,
	        rootFormatContext,
	        // Root segments are never embedded in Text on either edge
	        false,
	        false
	      );
	      rootSegment.parentFlushed = true;
	      var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
	      pingedTasks.push(rootTask);
	      return request;
	    }
	    function pingTask(request, task) {
	      var pingedTasks = request.pingedTasks;
	      pingedTasks.push(task);
	      if (pingedTasks.length === 1) {
	        scheduleWork(function() {
	          return performWork(request);
	        });
	      }
	    }
	    function createSuspenseBoundary(request, fallbackAbortableTasks) {
	      return {
	        id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
	        rootSegmentID: -1,
	        parentFlushed: false,
	        pendingTasks: 0,
	        forceClientRender: false,
	        completedSegments: [],
	        byteSize: 0,
	        fallbackAbortableTasks,
	        errorDigest: null
	      };
	    }
	    function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
	      request.allPendingTasks++;
	      if (blockedBoundary === null) {
	        request.pendingRootTasks++;
	      } else {
	        blockedBoundary.pendingTasks++;
	      }
	      var task = {
	        node,
	        ping: function() {
	          return pingTask(request, task);
	        },
	        blockedBoundary,
	        blockedSegment,
	        abortSet,
	        legacyContext,
	        context,
	        treeContext
	      };
	      {
	        task.componentStack = null;
	      }
	      abortSet.add(task);
	      return task;
	    }
	    function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
	      return {
	        status: PENDING,
	        id: -1,
	        // lazily assigned later
	        index,
	        parentFlushed: false,
	        chunks: [],
	        children: [],
	        formatContext,
	        boundary,
	        lastPushedText,
	        textEmbedded
	      };
	    }
	    var currentTaskInDEV = null;
	    function getCurrentStackInDEV() {
	      {
	        if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) {
	          return "";
	        }
	        return getStackByComponentStackNode(currentTaskInDEV.componentStack);
	      }
	    }
	    function pushBuiltInComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 0,
	          parent: task.componentStack,
	          type
	        };
	      }
	    }
	    function pushFunctionComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 1,
	          parent: task.componentStack,
	          type
	        };
	      }
	    }
	    function pushClassComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 2,
	          parent: task.componentStack,
	          type
	        };
	      }
	    }
	    function popComponentStackInDEV(task) {
	      {
	        if (task.componentStack === null) {
	          error("Unexpectedly popped too many stack frames. This is a bug in React.");
	        } else {
	          task.componentStack = task.componentStack.parent;
	        }
	      }
	    }
	    var lastBoundaryErrorComponentStackDev = null;
	    function captureBoundaryErrorDetailsDev(boundary, error2) {
	      {
	        var errorMessage;
	        if (typeof error2 === "string") {
	          errorMessage = error2;
	        } else if (error2 && typeof error2.message === "string") {
	          errorMessage = error2.message;
	        } else {
	          errorMessage = String(error2);
	        }
	        var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
	        lastBoundaryErrorComponentStackDev = null;
	        boundary.errorMessage = errorMessage;
	        boundary.errorComponentStack = errorComponentStack;
	      }
	    }
	    function logRecoverableError(request, error2) {
	      var errorDigest = request.onError(error2);
	      if (errorDigest != null && typeof errorDigest !== "string") {
	        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
	      }
	      return errorDigest;
	    }
	    function fatalError(request, error2) {
	      var onShellError = request.onShellError;
	      onShellError(error2);
	      var onFatalError = request.onFatalError;
	      onFatalError(error2);
	      if (request.destination !== null) {
	        request.status = CLOSED;
	        closeWithError(request.destination, error2);
	      } else {
	        request.status = CLOSING;
	        request.fatalError = error2;
	      }
	    }
	    function renderSuspenseBoundary(request, task, props) {
	      pushBuiltInComponentStackInDEV(task, "Suspense");
	      var parentBoundary = task.blockedBoundary;
	      var parentSegment = task.blockedSegment;
	      var fallback = props.fallback;
	      var content = props.children;
	      var fallbackAbortSet = /* @__PURE__ */ new Set();
	      var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
	      var insertionIndex = parentSegment.chunks.length;
	      var boundarySegment = createPendingSegment(
	        request,
	        insertionIndex,
	        newBoundary,
	        parentSegment.formatContext,
	        // boundaries never require text embedding at their edges because comment nodes bound them
	        false,
	        false
	      );
	      parentSegment.children.push(boundarySegment);
	      parentSegment.lastPushedText = false;
	      var contentRootSegment = createPendingSegment(
	        request,
	        0,
	        null,
	        parentSegment.formatContext,
	        // boundaries never require text embedding at their edges because comment nodes bound them
	        false,
	        false
	      );
	      contentRootSegment.parentFlushed = true;
	      task.blockedBoundary = newBoundary;
	      task.blockedSegment = contentRootSegment;
	      try {
	        renderNode(request, task, content);
	        pushSegmentFinale$1(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
	        contentRootSegment.status = COMPLETED;
	        queueCompletedSegment(newBoundary, contentRootSegment);
	        if (newBoundary.pendingTasks === 0) {
	          popComponentStackInDEV(task);
	          return;
	        }
	      } catch (error2) {
	        contentRootSegment.status = ERRORED;
	        newBoundary.forceClientRender = true;
	        newBoundary.errorDigest = logRecoverableError(request, error2);
	        {
	          captureBoundaryErrorDetailsDev(newBoundary, error2);
	        }
	      } finally {
	        task.blockedBoundary = parentBoundary;
	        task.blockedSegment = parentSegment;
	      }
	      var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        suspendedFallbackTask.componentStack = task.componentStack;
	      }
	      request.pingedTasks.push(suspendedFallbackTask);
	      popComponentStackInDEV(task);
	    }
	    function renderHostElement(request, task, type, props) {
	      pushBuiltInComponentStackInDEV(task, type);
	      var segment = task.blockedSegment;
	      var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
	      segment.lastPushedText = false;
	      var prevContext = segment.formatContext;
	      segment.formatContext = getChildFormatContext(prevContext, type, props);
	      renderNode(request, task, children);
	      segment.formatContext = prevContext;
	      pushEndInstance(segment.chunks, type);
	      segment.lastPushedText = false;
	      popComponentStackInDEV(task);
	    }
	    function shouldConstruct$1(Component) {
	      return Component.prototype && Component.prototype.isReactComponent;
	    }
	    function renderWithHooks(request, task, Component, props, secondArg) {
	      var componentIdentity = {};
	      prepareToUseHooks(task, componentIdentity);
	      var result = Component(props, secondArg);
	      return finishHooks(Component, props, result, secondArg);
	    }
	    function finishClassComponent(request, task, instance, Component, props) {
	      var nextChildren = instance.render();
	      {
	        if (instance.props !== props) {
	          if (!didWarnAboutReassigningProps) {
	            error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromType(Component) || "a component");
	          }
	          didWarnAboutReassigningProps = true;
	        }
	      }
	      {
	        var childContextTypes = Component.childContextTypes;
	        if (childContextTypes !== null && childContextTypes !== undefined) {
	          var previousContext = task.legacyContext;
	          var mergedContext = processChildContext(instance, Component, previousContext, childContextTypes);
	          task.legacyContext = mergedContext;
	          renderNodeDestructive(request, task, nextChildren);
	          task.legacyContext = previousContext;
	          return;
	        }
	      }
	      renderNodeDestructive(request, task, nextChildren);
	    }
	    function renderClassComponent(request, task, Component, props) {
	      pushClassComponentStackInDEV(task, Component);
	      var maskedContext = getMaskedContext(Component, task.legacyContext);
	      var instance = constructClassInstance(Component, props, maskedContext);
	      mountClassInstance(instance, Component, props, maskedContext);
	      finishClassComponent(request, task, instance, Component, props);
	      popComponentStackInDEV(task);
	    }
	    var didWarnAboutBadClass = {};
	    var didWarnAboutModulePatternComponent = {};
	    var didWarnAboutContextTypeOnFunctionComponent = {};
	    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
	    var didWarnAboutReassigningProps = false;
	    var didWarnAboutDefaultPropsOnFunctionComponent = {};
	    var didWarnAboutGenerators = false;
	    var didWarnAboutMaps = false;
	    var hasWarnedAboutUsingContextAsConsumer = false;
	    function renderIndeterminateComponent(request, task, Component, props) {
	      var legacyContext;
	      {
	        legacyContext = getMaskedContext(Component, task.legacyContext);
	      }
	      pushFunctionComponentStackInDEV(task, Component);
	      {
	        if (Component.prototype && typeof Component.prototype.render === "function") {
	          var componentName = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutBadClass[componentName]) {
	            error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
	            didWarnAboutBadClass[componentName] = true;
	          }
	        }
	      }
	      var value = renderWithHooks(request, task, Component, props, legacyContext);
	      var hasId = checkDidRenderIdHook();
	      {
	        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
	          var _componentName = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutModulePatternComponent[_componentName]) {
	            error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
	            didWarnAboutModulePatternComponent[_componentName] = true;
	          }
	        }
	      }
	      if (
	        // Run these checks in production only if the flag is off.
	        // Eventually we'll delete this branch altogether.
	        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined
	      ) {
	        {
	          var _componentName2 = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutModulePatternComponent[_componentName2]) {
	            error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
	            didWarnAboutModulePatternComponent[_componentName2] = true;
	          }
	        }
	        mountClassInstance(value, Component, props, legacyContext);
	        finishClassComponent(request, task, value, Component, props);
	      } else {
	        {
	          validateFunctionComponentInDev(Component);
	        }
	        if (hasId) {
	          var prevTreeContext = task.treeContext;
	          var totalChildren = 1;
	          var index = 0;
	          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	          try {
	            renderNodeDestructive(request, task, value);
	          } finally {
	            task.treeContext = prevTreeContext;
	          }
	        } else {
	          renderNodeDestructive(request, task, value);
	        }
	      }
	      popComponentStackInDEV(task);
	    }
	    function validateFunctionComponentInDev(Component) {
	      {
	        if (Component) {
	          if (Component.childContextTypes) {
	            error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
	          }
	        }
	        if (Component.defaultProps !== undefined) {
	          var componentName = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
	            error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
	            didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
	          }
	        }
	        if (typeof Component.getDerivedStateFromProps === "function") {
	          var _componentName3 = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
	            error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
	            didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
	          }
	        }
	        if (typeof Component.contextType === "object" && Component.contextType !== null) {
	          var _componentName4 = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
	            error("%s: Function components do not support contextType.", _componentName4);
	            didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
	          }
	        }
	      }
	    }
	    function resolveDefaultProps(Component, baseProps) {
	      if (Component && Component.defaultProps) {
	        var props = assign({}, baseProps);
	        var defaultProps = Component.defaultProps;
	        for (var propName in defaultProps) {
	          if (props[propName] === undefined) {
	            props[propName] = defaultProps[propName];
	          }
	        }
	        return props;
	      }
	      return baseProps;
	    }
	    function renderForwardRef(request, task, type, props, ref) {
	      pushFunctionComponentStackInDEV(task, type.render);
	      var children = renderWithHooks(request, task, type.render, props, ref);
	      var hasId = checkDidRenderIdHook();
	      if (hasId) {
	        var prevTreeContext = task.treeContext;
	        var totalChildren = 1;
	        var index = 0;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	        try {
	          renderNodeDestructive(request, task, children);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      } else {
	        renderNodeDestructive(request, task, children);
	      }
	      popComponentStackInDEV(task);
	    }
	    function renderMemo(request, task, type, props, ref) {
	      var innerType = type.type;
	      var resolvedProps = resolveDefaultProps(innerType, props);
	      renderElement(request, task, innerType, resolvedProps, ref);
	    }
	    function renderContextConsumer(request, task, context, props) {
	      {
	        if (context._context === undefined) {
	          if (context !== context.Consumer) {
	            if (!hasWarnedAboutUsingContextAsConsumer) {
	              hasWarnedAboutUsingContextAsConsumer = true;
	              error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
	            }
	          }
	        } else {
	          context = context._context;
	        }
	      }
	      var render = props.children;
	      {
	        if (typeof render !== "function") {
	          error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
	        }
	      }
	      var newValue = readContext(context);
	      var newChildren = render(newValue);
	      renderNodeDestructive(request, task, newChildren);
	    }
	    function renderContextProvider(request, task, type, props) {
	      var context = type._context;
	      var value = props.value;
	      var children = props.children;
	      var prevSnapshot;
	      {
	        prevSnapshot = task.context;
	      }
	      task.context = pushProvider(context, value);
	      renderNodeDestructive(request, task, children);
	      task.context = popProvider(context);
	      {
	        if (prevSnapshot !== task.context) {
	          error("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
	        }
	      }
	    }
	    function renderLazyComponent(request, task, lazyComponent, props, ref) {
	      pushBuiltInComponentStackInDEV(task, "Lazy");
	      var payload = lazyComponent._payload;
	      var init = lazyComponent._init;
	      var Component = init(payload);
	      var resolvedProps = resolveDefaultProps(Component, props);
	      renderElement(request, task, Component, resolvedProps, ref);
	      popComponentStackInDEV(task);
	    }
	    function renderElement(request, task, type, props, ref) {
	      if (typeof type === "function") {
	        if (shouldConstruct$1(type)) {
	          renderClassComponent(request, task, type, props);
	          return;
	        } else {
	          renderIndeterminateComponent(request, task, type, props);
	          return;
	        }
	      }
	      if (typeof type === "string") {
	        renderHostElement(request, task, type, props);
	        return;
	      }
	      switch (type) {
	        case REACT_LEGACY_HIDDEN_TYPE:
	        case REACT_DEBUG_TRACING_MODE_TYPE:
	        case REACT_STRICT_MODE_TYPE:
	        case REACT_PROFILER_TYPE:
	        case REACT_FRAGMENT_TYPE: {
	          renderNodeDestructive(request, task, props.children);
	          return;
	        }
	        case REACT_SUSPENSE_LIST_TYPE: {
	          pushBuiltInComponentStackInDEV(task, "SuspenseList");
	          renderNodeDestructive(request, task, props.children);
	          popComponentStackInDEV(task);
	          return;
	        }
	        case REACT_SCOPE_TYPE: {
	          throw new Error("ReactDOMServer does not yet support scope components.");
	        }
	        case REACT_SUSPENSE_TYPE: {
	          {
	            renderSuspenseBoundary(request, task, props);
	          }
	          return;
	        }
	      }
	      if (typeof type === "object" && type !== null) {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE: {
	            renderForwardRef(request, task, type, props, ref);
	            return;
	          }
	          case REACT_MEMO_TYPE: {
	            renderMemo(request, task, type, props, ref);
	            return;
	          }
	          case REACT_PROVIDER_TYPE: {
	            renderContextProvider(request, task, type, props);
	            return;
	          }
	          case REACT_CONTEXT_TYPE: {
	            renderContextConsumer(request, task, type, props);
	            return;
	          }
	          case REACT_LAZY_TYPE: {
	            renderLazyComponent(request, task, type, props);
	            return;
	          }
	        }
	      }
	      var info = "";
	      {
	        if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
	          info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
	        }
	      }
	      throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
	    }
	    function validateIterable(iterable, iteratorFn) {
	      {
	        if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
	        iterable[Symbol.toStringTag] === "Generator") {
	          if (!didWarnAboutGenerators) {
	            error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
	          }
	          didWarnAboutGenerators = true;
	        }
	        if (iterable.entries === iteratorFn) {
	          if (!didWarnAboutMaps) {
	            error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
	          }
	          didWarnAboutMaps = true;
	        }
	      }
	    }
	    function renderNodeDestructive(request, task, node) {
	      {
	        try {
	          return renderNodeDestructiveImpl(request, task, node);
	        } catch (x) {
	          if (typeof x === "object" && x !== null && typeof x.then === "function") ;
	          else {
	            lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
	          }
	          throw x;
	        }
	      }
	    }
	    function renderNodeDestructiveImpl(request, task, node) {
	      task.node = node;
	      if (typeof node === "object" && node !== null) {
	        switch (node.$$typeof) {
	          case REACT_ELEMENT_TYPE: {
	            var element = node;
	            var type = element.type;
	            var props = element.props;
	            var ref = element.ref;
	            renderElement(request, task, type, props, ref);
	            return;
	          }
	          case REACT_PORTAL_TYPE:
	            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
	          case REACT_LAZY_TYPE: {
	            var lazyNode = node;
	            var payload = lazyNode._payload;
	            var init = lazyNode._init;
	            var resolvedNode;
	            {
	              try {
	                resolvedNode = init(payload);
	              } catch (x) {
	                if (typeof x === "object" && x !== null && typeof x.then === "function") {
	                  pushBuiltInComponentStackInDEV(task, "Lazy");
	                }
	                throw x;
	              }
	            }
	            renderNodeDestructive(request, task, resolvedNode);
	            return;
	          }
	        }
	        if (isArray(node)) {
	          renderChildrenArray(request, task, node);
	          return;
	        }
	        var iteratorFn = getIteratorFn(node);
	        if (iteratorFn) {
	          {
	            validateIterable(node, iteratorFn);
	          }
	          var iterator = iteratorFn.call(node);
	          if (iterator) {
	            var step = iterator.next();
	            if (!step.done) {
	              var children = [];
	              do {
	                children.push(step.value);
	                step = iterator.next();
	              } while (!step.done);
	              renderChildrenArray(request, task, children);
	              return;
	            }
	            return;
	          }
	        }
	        var childString = Object.prototype.toString.call(node);
	        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(node).join(", ") + "}" : childString) + "). If you meant to render a collection of children, use an array instead.");
	      }
	      if (typeof node === "string") {
	        var segment = task.blockedSegment;
	        segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
	        return;
	      }
	      if (typeof node === "number") {
	        var _segment = task.blockedSegment;
	        _segment.lastPushedText = pushTextInstance$1(task.blockedSegment.chunks, "" + node, request.responseState, _segment.lastPushedText);
	        return;
	      }
	      {
	        if (typeof node === "function") {
	          error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
	        }
	      }
	    }
	    function renderChildrenArray(request, task, children) {
	      var totalChildren = children.length;
	      for (var i = 0; i < totalChildren; i++) {
	        var prevTreeContext = task.treeContext;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i);
	        try {
	          renderNode(request, task, children[i]);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      }
	    }
	    function spawnNewSuspendedTask(request, task, x) {
	      var segment = task.blockedSegment;
	      var insertionIndex = segment.chunks.length;
	      var newSegment = createPendingSegment(
	        request,
	        insertionIndex,
	        null,
	        segment.formatContext,
	        // Adopt the parent segment's leading text embed
	        segment.lastPushedText,
	        // Assume we are text embedded at the trailing edge
	        true
	      );
	      segment.children.push(newSegment);
	      segment.lastPushedText = false;
	      var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        if (task.componentStack !== null) {
	          newTask.componentStack = task.componentStack.parent;
	        }
	      }
	      var ping = newTask.ping;
	      x.then(ping, ping);
	    }
	    function renderNode(request, task, node) {
	      var previousFormatContext = task.blockedSegment.formatContext;
	      var previousLegacyContext = task.legacyContext;
	      var previousContext = task.context;
	      var previousComponentStack = null;
	      {
	        previousComponentStack = task.componentStack;
	      }
	      try {
	        return renderNodeDestructive(request, task, node);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === "object" && x !== null && typeof x.then === "function") {
	          spawnNewSuspendedTask(request, task, x);
	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext;
	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          }
	          return;
	        } else {
	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext;
	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          }
	          throw x;
	        }
	      }
	    }
	    function erroredTask(request, boundary, segment, error2) {
	      var errorDigest = logRecoverableError(request, error2);
	      if (boundary === null) {
	        fatalError(request, error2);
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          boundary.errorDigest = errorDigest;
	          {
	            captureBoundaryErrorDetailsDev(boundary, error2);
	          }
	          if (boundary.parentFlushed) {
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function abortTaskSoft(task) {
	      var request = this;
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      finishedTask(request, boundary, segment);
	    }
	    function abortTask(task, request, reason) {
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      if (boundary === null) {
	        request.allPendingTasks--;
	        if (request.status !== CLOSED) {
	          request.status = CLOSED;
	          if (request.destination !== null) {
	            close(request.destination);
	          }
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          var _error = reason === undefined ? new Error("The render was aborted by the server without a reason.") : reason;
	          boundary.errorDigest = request.onError(_error);
	          {
	            var errorPrefix = "The server did not finish this Suspense boundary: ";
	            if (_error && typeof _error.message === "string") {
	              _error = errorPrefix + _error.message;
	            } else {
	              _error = errorPrefix + String(_error);
	            }
	            var previousTaskInDev = currentTaskInDEV;
	            currentTaskInDEV = task;
	            try {
	              captureBoundaryErrorDetailsDev(boundary, _error);
	            } finally {
	              currentTaskInDEV = previousTaskInDev;
	            }
	          }
	          if (boundary.parentFlushed) {
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        }
	        boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
	          return abortTask(fallbackTask, request, reason);
	        });
	        boundary.fallbackAbortableTasks.clear();
	        request.allPendingTasks--;
	        if (request.allPendingTasks === 0) {
	          var onAllReady = request.onAllReady;
	          onAllReady();
	        }
	      }
	    }
	    function queueCompletedSegment(boundary, segment) {
	      if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
	        var childSegment = segment.children[0];
	        childSegment.id = segment.id;
	        childSegment.parentFlushed = true;
	        if (childSegment.status === COMPLETED) {
	          queueCompletedSegment(boundary, childSegment);
	        }
	      } else {
	        var completedSegments = boundary.completedSegments;
	        completedSegments.push(segment);
	      }
	    }
	    function finishedTask(request, boundary, segment) {
	      if (boundary === null) {
	        if (segment.parentFlushed) {
	          if (request.completedRootSegment !== null) {
	            throw new Error("There can only be one root segment. This is a bug in React.");
	          }
	          request.completedRootSegment = segment;
	        }
	        request.pendingRootTasks--;
	        if (request.pendingRootTasks === 0) {
	          request.onShellError = noop$1;
	          var onShellReady = request.onShellReady;
	          onShellReady();
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (boundary.forceClientRender) ;
	        else if (boundary.pendingTasks === 0) {
	          if (segment.parentFlushed) {
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	            }
	          }
	          if (boundary.parentFlushed) {
	            request.completedBoundaries.push(boundary);
	          }
	          boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
	          boundary.fallbackAbortableTasks.clear();
	        } else {
	          if (segment.parentFlushed) {
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	              var completedSegments = boundary.completedSegments;
	              if (completedSegments.length === 1) {
	                if (boundary.parentFlushed) {
	                  request.partialBoundaries.push(boundary);
	                }
	              }
	            }
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function retryTask(request, task) {
	      var segment = task.blockedSegment;
	      if (segment.status !== PENDING) {
	        return;
	      }
	      switchContext(task.context);
	      var prevTaskInDEV = null;
	      {
	        prevTaskInDEV = currentTaskInDEV;
	        currentTaskInDEV = task;
	      }
	      try {
	        renderNodeDestructive(request, task, task.node);
	        pushSegmentFinale$1(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
	        task.abortSet.delete(task);
	        segment.status = COMPLETED;
	        finishedTask(request, task.blockedBoundary, segment);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === "object" && x !== null && typeof x.then === "function") {
	          var ping = task.ping;
	          x.then(ping, ping);
	        } else {
	          task.abortSet.delete(task);
	          segment.status = ERRORED;
	          erroredTask(request, task.blockedBoundary, segment, x);
	        }
	      } finally {
	        {
	          currentTaskInDEV = prevTaskInDEV;
	        }
	      }
	    }
	    function performWork(request) {
	      if (request.status === CLOSED) {
	        return;
	      }
	      var prevContext = getActiveContext();
	      var prevDispatcher = ReactCurrentDispatcher$1.current;
	      ReactCurrentDispatcher$1.current = Dispatcher;
	      var prevGetCurrentStackImpl;
	      {
	        prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
	        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
	      }
	      var prevResponseState = currentResponseState;
	      setCurrentResponseState(request.responseState);
	      try {
	        var pingedTasks = request.pingedTasks;
	        var i;
	        for (i = 0; i < pingedTasks.length; i++) {
	          var task = pingedTasks[i];
	          retryTask(request, task);
	        }
	        pingedTasks.splice(0, i);
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error2) {
	        logRecoverableError(request, error2);
	        fatalError(request, error2);
	      } finally {
	        setCurrentResponseState(prevResponseState);
	        ReactCurrentDispatcher$1.current = prevDispatcher;
	        {
	          ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
	        }
	        if (prevDispatcher === Dispatcher) {
	          switchContext(prevContext);
	        }
	      }
	    }
	    function flushSubtree(request, destination, segment) {
	      segment.parentFlushed = true;
	      switch (segment.status) {
	        case PENDING: {
	          var segmentID = segment.id = request.nextSegmentId++;
	          segment.lastPushedText = false;
	          segment.textEmbedded = false;
	          return writePlaceholder(destination, request.responseState, segmentID);
	        }
	        case COMPLETED: {
	          segment.status = FLUSHED;
	          var r = true;
	          var chunks = segment.chunks;
	          var chunkIdx = 0;
	          var children = segment.children;
	          for (var childIdx = 0; childIdx < children.length; childIdx++) {
	            var nextChild = children[childIdx];
	            for (; chunkIdx < nextChild.index; chunkIdx++) {
	              writeChunk(destination, chunks[chunkIdx]);
	            }
	            r = flushSegment(request, destination, nextChild);
	          }
	          for (; chunkIdx < chunks.length - 1; chunkIdx++) {
	            writeChunk(destination, chunks[chunkIdx]);
	          }
	          if (chunkIdx < chunks.length) {
	            r = writeChunkAndReturn(destination, chunks[chunkIdx]);
	          }
	          return r;
	        }
	        default: {
	          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
	        }
	      }
	    }
	    function flushSegment(request, destination, segment) {
	      var boundary = segment.boundary;
	      if (boundary === null) {
	        return flushSubtree(request, destination, segment);
	      }
	      boundary.parentFlushed = true;
	      if (boundary.forceClientRender) {
	        writeStartClientRenderedSuspenseBoundary$1(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
	        flushSubtree(request, destination, segment);
	        return writeEndClientRenderedSuspenseBoundary$1(destination, request.responseState);
	      } else if (boundary.pendingTasks > 0) {
	        boundary.rootSegmentID = request.nextSegmentId++;
	        if (boundary.completedSegments.length > 0) {
	          request.partialBoundaries.push(boundary);
	        }
	        var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
	        writeStartPendingSuspenseBoundary(destination, request.responseState, id);
	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else if (boundary.byteSize > request.progressiveChunkSize) {
	        boundary.rootSegmentID = request.nextSegmentId++;
	        request.completedBoundaries.push(boundary);
	        writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id);
	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else {
	        writeStartCompletedSuspenseBoundary$1(destination, request.responseState);
	        var completedSegments = boundary.completedSegments;
	        if (completedSegments.length !== 1) {
	          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
	        }
	        var contentSegment = completedSegments[0];
	        flushSegment(request, destination, contentSegment);
	        return writeEndCompletedSuspenseBoundary$1(destination, request.responseState);
	      }
	    }
	    function flushClientRenderedBoundary(request, destination, boundary) {
	      return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
	    }
	    function flushSegmentContainer(request, destination, segment) {
	      writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
	      flushSegment(request, destination, segment);
	      return writeEndSegment(destination, segment.formatContext);
	    }
	    function flushCompletedBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        flushPartiallyCompletedSegment(request, destination, boundary, segment);
	      }
	      completedSegments.length = 0;
	      return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
	    }
	    function flushPartialBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
	          i++;
	          completedSegments.splice(0, i);
	          return false;
	        }
	      }
	      completedSegments.splice(0, i);
	      return true;
	    }
	    function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
	      if (segment.status === FLUSHED) {
	        return true;
	      }
	      var segmentID = segment.id;
	      if (segmentID === -1) {
	        var rootSegmentID = segment.id = boundary.rootSegmentID;
	        if (rootSegmentID === -1) {
	          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
	        }
	        return flushSegmentContainer(request, destination, segment);
	      } else {
	        flushSegmentContainer(request, destination, segment);
	        return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
	      }
	    }
	    function flushCompletedQueues(request, destination) {
	      try {
	        var completedRootSegment = request.completedRootSegment;
	        if (completedRootSegment !== null && request.pendingRootTasks === 0) {
	          flushSegment(request, destination, completedRootSegment);
	          request.completedRootSegment = null;
	          writeCompletedRoot(destination, request.responseState);
	        }
	        var clientRenderedBoundaries = request.clientRenderedBoundaries;
	        var i;
	        for (i = 0; i < clientRenderedBoundaries.length; i++) {
	          var boundary = clientRenderedBoundaries[i];
	          if (!flushClientRenderedBoundary(request, destination, boundary)) {
	            request.destination = null;
	            i++;
	            clientRenderedBoundaries.splice(0, i);
	            return;
	          }
	        }
	        clientRenderedBoundaries.splice(0, i);
	        var completedBoundaries = request.completedBoundaries;
	        for (i = 0; i < completedBoundaries.length; i++) {
	          var _boundary = completedBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary)) {
	            request.destination = null;
	            i++;
	            completedBoundaries.splice(0, i);
	            return;
	          }
	        }
	        completedBoundaries.splice(0, i);
	        completeWriting(destination);
	        beginWriting(destination);
	        var partialBoundaries = request.partialBoundaries;
	        for (i = 0; i < partialBoundaries.length; i++) {
	          var _boundary2 = partialBoundaries[i];
	          if (!flushPartialBoundary(request, destination, _boundary2)) {
	            request.destination = null;
	            i++;
	            partialBoundaries.splice(0, i);
	            return;
	          }
	        }
	        partialBoundaries.splice(0, i);
	        var largeBoundaries = request.completedBoundaries;
	        for (i = 0; i < largeBoundaries.length; i++) {
	          var _boundary3 = largeBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary3)) {
	            request.destination = null;
	            i++;
	            largeBoundaries.splice(0, i);
	            return;
	          }
	        }
	        largeBoundaries.splice(0, i);
	      } finally {
	        if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0) {
	          {
	            if (request.abortableTasks.size !== 0) {
	              error("There was still abortable task at the root when we closed. This is a bug in React.");
	            }
	          }
	          close(destination);
	        }
	      }
	    }
	    function startWork(request) {
	      scheduleWork(function() {
	        return performWork(request);
	      });
	    }
	    function startFlowing(request, destination) {
	      if (request.status === CLOSING) {
	        request.status = CLOSED;
	        closeWithError(destination, request.fatalError);
	        return;
	      }
	      if (request.status === CLOSED) {
	        return;
	      }
	      if (request.destination !== null) {
	        return;
	      }
	      request.destination = destination;
	      try {
	        flushCompletedQueues(request, destination);
	      } catch (error2) {
	        logRecoverableError(request, error2);
	        fatalError(request, error2);
	      }
	    }
	    function abort(request, reason) {
	      try {
	        var abortableTasks = request.abortableTasks;
	        abortableTasks.forEach(function(task) {
	          return abortTask(task, request, reason);
	        });
	        abortableTasks.clear();
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error2) {
	        logRecoverableError(request, error2);
	        fatalError(request, error2);
	      }
	    }
	    function onError() {
	    }
	    function renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
	      var didFatal = false;
	      var fatalError2 = null;
	      var result = "";
	      var destination = {
	        push: function(chunk) {
	          if (chunk !== null) {
	            result += chunk;
	          }
	          return true;
	        },
	        destroy: function(error2) {
	          didFatal = true;
	          fatalError2 = error2;
	        }
	      };
	      var readyToStream = false;
	      function onShellReady() {
	        readyToStream = true;
	      }
	      var request = createRequest(children, createResponseState$1(generateStaticMarkup, options ? options.identifierPrefix : undefined), createRootFormatContext(), Infinity, onError, undefined, onShellReady);
	      startWork(request);
	      abort(request, abortReason);
	      startFlowing(request, destination);
	      if (didFatal) {
	        throw fatalError2;
	      }
	      if (!readyToStream) {
	        throw new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
	      }
	      return result;
	    }
	    function renderToString(children, options) {
	      return renderToStringImpl(children, options, false, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
	    }
	    function renderToStaticMarkup(children, options) {
	      return renderToStringImpl(children, options, true, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
	    }
	    function renderToNodeStream() {
	      throw new Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
	    }
	    function renderToStaticNodeStream() {
	      throw new Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
	    }
	    reactDomServerLegacy_browser_development.renderToNodeStream = renderToNodeStream;
	    reactDomServerLegacy_browser_development.renderToStaticMarkup = renderToStaticMarkup;
	    reactDomServerLegacy_browser_development.renderToStaticNodeStream = renderToStaticNodeStream;
	    reactDomServerLegacy_browser_development.renderToString = renderToString;
	    reactDomServerLegacy_browser_development.version = ReactVersion;
	  })();
	}
	return reactDomServerLegacy_browser_development;
}

var reactDomServer_browser_development = {};

var hasRequiredReactDomServer_browser_development;

function requireReactDomServer_browser_development () {
	if (hasRequiredReactDomServer_browser_development) return reactDomServer_browser_development;
	hasRequiredReactDomServer_browser_development = 1;
	/**
	 * @license React
	 * react-dom-server.browser.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	    var React = React__default;
	    var ReactVersion = "18.3.1";
	    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	    function warn(format) {
	      {
	        {
	          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	          }
	          printWarning("warn", format, args);
	        }
	      }
	    }
	    function error(format) {
	      {
	        {
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	          printWarning("error", format, args);
	        }
	      }
	    }
	    function printWarning(level, format, args) {
	      {
	        var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
	        var stack = ReactDebugCurrentFrame2.getStackAddendum();
	        if (stack !== "") {
	          format += "%s";
	          args = args.concat([stack]);
	        }
	        var argsWithFormat = args.map(function(item) {
	          return String(item);
	        });
	        argsWithFormat.unshift("Warning: " + format);
	        Function.prototype.apply.call(console[level], console, argsWithFormat);
	      }
	    }
	    function scheduleWork(callback) {
	      callback();
	    }
	    var VIEW_SIZE = 512;
	    var currentView = null;
	    var writtenBytes = 0;
	    function beginWriting(destination) {
	      currentView = new Uint8Array(VIEW_SIZE);
	      writtenBytes = 0;
	    }
	    function writeChunk(destination, chunk) {
	      if (chunk.length === 0) {
	        return;
	      }
	      if (chunk.length > VIEW_SIZE) {
	        if (writtenBytes > 0) {
	          destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
	          currentView = new Uint8Array(VIEW_SIZE);
	          writtenBytes = 0;
	        }
	        destination.enqueue(chunk);
	        return;
	      }
	      var bytesToWrite = chunk;
	      var allowableBytes = currentView.length - writtenBytes;
	      if (allowableBytes < bytesToWrite.length) {
	        if (allowableBytes === 0) {
	          destination.enqueue(currentView);
	        } else {
	          currentView.set(bytesToWrite.subarray(0, allowableBytes), writtenBytes);
	          destination.enqueue(currentView);
	          bytesToWrite = bytesToWrite.subarray(allowableBytes);
	        }
	        currentView = new Uint8Array(VIEW_SIZE);
	        writtenBytes = 0;
	      }
	      currentView.set(bytesToWrite, writtenBytes);
	      writtenBytes += bytesToWrite.length;
	    }
	    function writeChunkAndReturn(destination, chunk) {
	      writeChunk(destination, chunk);
	      return true;
	    }
	    function completeWriting(destination) {
	      if (currentView && writtenBytes > 0) {
	        destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes));
	        currentView = null;
	        writtenBytes = 0;
	      }
	    }
	    function close(destination) {
	      destination.close();
	    }
	    var textEncoder = new TextEncoder();
	    function stringToChunk(content) {
	      return textEncoder.encode(content);
	    }
	    function stringToPrecomputedChunk(content) {
	      return textEncoder.encode(content);
	    }
	    function closeWithError(destination, error2) {
	      if (typeof destination.error === "function") {
	        destination.error(error2);
	      } else {
	        destination.close();
	      }
	    }
	    function typeName(value) {
	      {
	        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
	        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
	        return type;
	      }
	    }
	    function willCoercionThrow(value) {
	      {
	        try {
	          testStringCoercion(value);
	          return false;
	        } catch (e) {
	          return true;
	        }
	      }
	    }
	    function testStringCoercion(value) {
	      return "" + value;
	    }
	    function checkAttributeStringCoercion(value, attributeName) {
	      {
	        if (willCoercionThrow(value)) {
	          error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
	          return testStringCoercion(value);
	        }
	      }
	    }
	    function checkCSSPropertyStringCoercion(value, propName) {
	      {
	        if (willCoercionThrow(value)) {
	          error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
	          return testStringCoercion(value);
	        }
	      }
	    }
	    function checkHtmlStringCoercion(value) {
	      {
	        if (willCoercionThrow(value)) {
	          error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
	          return testStringCoercion(value);
	        }
	      }
	    }
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var RESERVED = 0;
	    var STRING = 1;
	    var BOOLEANISH_STRING = 2;
	    var BOOLEAN = 3;
	    var OVERLOADED_BOOLEAN = 4;
	    var NUMERIC = 5;
	    var POSITIVE_NUMERIC = 6;
	    var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	    var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
	    var illegalAttributeNameCache = {};
	    var validatedAttributeNameCache = {};
	    function isAttributeNameSafe(attributeName) {
	      if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
	        return true;
	      }
	      if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
	        return false;
	      }
	      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	        validatedAttributeNameCache[attributeName] = true;
	        return true;
	      }
	      illegalAttributeNameCache[attributeName] = true;
	      {
	        error("Invalid attribute name: `%s`", attributeName);
	      }
	      return false;
	    }
	    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
	      if (propertyInfo !== null && propertyInfo.type === RESERVED) {
	        return false;
	      }
	      switch (typeof value) {
	        case "function":
	        case "symbol":
	          return true;
	        case "boolean": {
	          if (propertyInfo !== null) {
	            return !propertyInfo.acceptsBooleans;
	          } else {
	            var prefix2 = name.toLowerCase().slice(0, 5);
	            return prefix2 !== "data-" && prefix2 !== "aria-";
	          }
	        }
	        default:
	          return false;
	      }
	    }
	    function getPropertyInfo(name) {
	      return properties.hasOwnProperty(name) ? properties[name] : null;
	    }
	    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL2, removeEmptyString) {
	      this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	      this.attributeName = attributeName;
	      this.attributeNamespace = attributeNamespace;
	      this.mustUseProperty = mustUseProperty;
	      this.propertyName = name;
	      this.type = type;
	      this.sanitizeURL = sanitizeURL2;
	      this.removeEmptyString = removeEmptyString;
	    }
	    var properties = {};
	    var reservedProps = [
	      "children",
	      "dangerouslySetInnerHTML",
	      // TODO: This prevents the assignment of defaultValue to regular
	      // elements (not just inputs). Now that ReactDOMInput assigns to the
	      // defaultValue property -- do we need this?
	      "defaultValue",
	      "defaultChecked",
	      "innerHTML",
	      "suppressContentEditableWarning",
	      "suppressHydrationWarning",
	      "style"
	    ];
	    reservedProps.forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        RESERVED,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(_ref) {
	      var name = _ref[0], attributeName = _ref[1];
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEANISH_STRING,
	        false,
	        // mustUseProperty
	        name.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEANISH_STRING,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "allowFullScreen",
	      "async",
	      // Note: there is a special case that prevents it from being written to the DOM
	      // on the client side because the browsers are inconsistent. Instead we call focus().
	      "autoFocus",
	      "autoPlay",
	      "controls",
	      "default",
	      "defer",
	      "disabled",
	      "disablePictureInPicture",
	      "disableRemotePlayback",
	      "formNoValidate",
	      "hidden",
	      "loop",
	      "noModule",
	      "noValidate",
	      "open",
	      "playsInline",
	      "readOnly",
	      "required",
	      "reversed",
	      "scoped",
	      "seamless",
	      // Microdata
	      "itemScope"
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEAN,
	        false,
	        // mustUseProperty
	        name.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "checked",
	      // Note: `option.selected` is not updated if `select.multiple` is
	      // disabled with `removeAttribute`. We have special logic for handling this.
	      "multiple",
	      "muted",
	      "selected"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        BOOLEAN,
	        true,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "capture",
	      "download"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        OVERLOADED_BOOLEAN,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "cols",
	      "rows",
	      "size",
	      "span"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        POSITIVE_NUMERIC,
	        false,
	        // mustUseProperty
	        name,
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["rowSpan", "start"].forEach(function(name) {
	      properties[name] = new PropertyInfoRecord(
	        name,
	        NUMERIC,
	        false,
	        // mustUseProperty
	        name.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    var CAMELIZE = /[\-\:]([a-z])/g;
	    var capitalize = function(token) {
	      return token[1].toUpperCase();
	    };
	    [
	      "accent-height",
	      "alignment-baseline",
	      "arabic-form",
	      "baseline-shift",
	      "cap-height",
	      "clip-path",
	      "clip-rule",
	      "color-interpolation",
	      "color-interpolation-filters",
	      "color-profile",
	      "color-rendering",
	      "dominant-baseline",
	      "enable-background",
	      "fill-opacity",
	      "fill-rule",
	      "flood-color",
	      "flood-opacity",
	      "font-family",
	      "font-size",
	      "font-size-adjust",
	      "font-stretch",
	      "font-style",
	      "font-variant",
	      "font-weight",
	      "glyph-name",
	      "glyph-orientation-horizontal",
	      "glyph-orientation-vertical",
	      "horiz-adv-x",
	      "horiz-origin-x",
	      "image-rendering",
	      "letter-spacing",
	      "lighting-color",
	      "marker-end",
	      "marker-mid",
	      "marker-start",
	      "overline-position",
	      "overline-thickness",
	      "paint-order",
	      "panose-1",
	      "pointer-events",
	      "rendering-intent",
	      "shape-rendering",
	      "stop-color",
	      "stop-opacity",
	      "strikethrough-position",
	      "strikethrough-thickness",
	      "stroke-dasharray",
	      "stroke-dashoffset",
	      "stroke-linecap",
	      "stroke-linejoin",
	      "stroke-miterlimit",
	      "stroke-opacity",
	      "stroke-width",
	      "text-anchor",
	      "text-decoration",
	      "text-rendering",
	      "underline-position",
	      "underline-thickness",
	      "unicode-bidi",
	      "unicode-range",
	      "units-per-em",
	      "v-alphabetic",
	      "v-hanging",
	      "v-ideographic",
	      "v-mathematical",
	      "vector-effect",
	      "vert-adv-y",
	      "vert-origin-x",
	      "vert-origin-y",
	      "word-spacing",
	      "writing-mode",
	      "xmlns:xlink",
	      "x-height"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "xlink:actuate",
	      "xlink:arcrole",
	      "xlink:role",
	      "xlink:show",
	      "xlink:title",
	      "xlink:type"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        "http://www.w3.org/1999/xlink",
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    [
	      "xml:base",
	      "xml:lang",
	      "xml:space"
	      // NOTE: if you add a camelCased prop to this list,
	      // you'll need to set attributeName to name.toLowerCase()
	      // instead in the assignment below.
	    ].forEach(function(attributeName) {
	      var name = attributeName.replace(CAMELIZE, capitalize);
	      properties[name] = new PropertyInfoRecord(
	        name,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName,
	        "http://www.w3.org/XML/1998/namespace",
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    ["tabIndex", "crossOrigin"].forEach(function(attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(
	        attributeName,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        false,
	        // sanitizeURL
	        false
	      );
	    });
	    var xlinkHref = "xlinkHref";
	    properties[xlinkHref] = new PropertyInfoRecord(
	      "xlinkHref",
	      STRING,
	      false,
	      // mustUseProperty
	      "xlink:href",
	      "http://www.w3.org/1999/xlink",
	      true,
	      // sanitizeURL
	      false
	    );
	    ["src", "href", "action", "formAction"].forEach(function(attributeName) {
	      properties[attributeName] = new PropertyInfoRecord(
	        attributeName,
	        STRING,
	        false,
	        // mustUseProperty
	        attributeName.toLowerCase(),
	        // attributeName
	        null,
	        // attributeNamespace
	        true,
	        // sanitizeURL
	        true
	      );
	    });
	    var isUnitlessNumber = {
	      animationIterationCount: true,
	      aspectRatio: true,
	      borderImageOutset: true,
	      borderImageSlice: true,
	      borderImageWidth: true,
	      boxFlex: true,
	      boxFlexGroup: true,
	      boxOrdinalGroup: true,
	      columnCount: true,
	      columns: true,
	      flex: true,
	      flexGrow: true,
	      flexPositive: true,
	      flexShrink: true,
	      flexNegative: true,
	      flexOrder: true,
	      gridArea: true,
	      gridRow: true,
	      gridRowEnd: true,
	      gridRowSpan: true,
	      gridRowStart: true,
	      gridColumn: true,
	      gridColumnEnd: true,
	      gridColumnSpan: true,
	      gridColumnStart: true,
	      fontWeight: true,
	      lineClamp: true,
	      lineHeight: true,
	      opacity: true,
	      order: true,
	      orphans: true,
	      tabSize: true,
	      widows: true,
	      zIndex: true,
	      zoom: true,
	      // SVG-related properties
	      fillOpacity: true,
	      floodOpacity: true,
	      stopOpacity: true,
	      strokeDasharray: true,
	      strokeDashoffset: true,
	      strokeMiterlimit: true,
	      strokeOpacity: true,
	      strokeWidth: true
	    };
	    function prefixKey(prefix2, key) {
	      return prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
	    }
	    var prefixes = ["Webkit", "ms", "Moz", "O"];
	    Object.keys(isUnitlessNumber).forEach(function(prop) {
	      prefixes.forEach(function(prefix2) {
	        isUnitlessNumber[prefixKey(prefix2, prop)] = isUnitlessNumber[prop];
	      });
	    });
	    var hasReadOnlyValue = {
	      button: true,
	      checkbox: true,
	      image: true,
	      hidden: true,
	      radio: true,
	      reset: true,
	      submit: true
	    };
	    function checkControlledValueProps(tagName, props) {
	      {
	        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
	          error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
	        }
	        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
	          error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
	        }
	      }
	    }
	    function isCustomComponent(tagName, props) {
	      if (tagName.indexOf("-") === -1) {
	        return typeof props.is === "string";
	      }
	      switch (tagName) {
	        case "annotation-xml":
	        case "color-profile":
	        case "font-face":
	        case "font-face-src":
	        case "font-face-uri":
	        case "font-face-format":
	        case "font-face-name":
	        case "missing-glyph":
	          return false;
	        default:
	          return true;
	      }
	    }
	    var ariaProperties = {
	      "aria-current": 0,
	      // state
	      "aria-description": 0,
	      "aria-details": 0,
	      "aria-disabled": 0,
	      // state
	      "aria-hidden": 0,
	      // state
	      "aria-invalid": 0,
	      // state
	      "aria-keyshortcuts": 0,
	      "aria-label": 0,
	      "aria-roledescription": 0,
	      // Widget Attributes
	      "aria-autocomplete": 0,
	      "aria-checked": 0,
	      "aria-expanded": 0,
	      "aria-haspopup": 0,
	      "aria-level": 0,
	      "aria-modal": 0,
	      "aria-multiline": 0,
	      "aria-multiselectable": 0,
	      "aria-orientation": 0,
	      "aria-placeholder": 0,
	      "aria-pressed": 0,
	      "aria-readonly": 0,
	      "aria-required": 0,
	      "aria-selected": 0,
	      "aria-sort": 0,
	      "aria-valuemax": 0,
	      "aria-valuemin": 0,
	      "aria-valuenow": 0,
	      "aria-valuetext": 0,
	      // Live Region Attributes
	      "aria-atomic": 0,
	      "aria-busy": 0,
	      "aria-live": 0,
	      "aria-relevant": 0,
	      // Drag-and-Drop Attributes
	      "aria-dropeffect": 0,
	      "aria-grabbed": 0,
	      // Relationship Attributes
	      "aria-activedescendant": 0,
	      "aria-colcount": 0,
	      "aria-colindex": 0,
	      "aria-colspan": 0,
	      "aria-controls": 0,
	      "aria-describedby": 0,
	      "aria-errormessage": 0,
	      "aria-flowto": 0,
	      "aria-labelledby": 0,
	      "aria-owns": 0,
	      "aria-posinset": 0,
	      "aria-rowcount": 0,
	      "aria-rowindex": 0,
	      "aria-rowspan": 0,
	      "aria-setsize": 0
	    };
	    var warnedProperties = {};
	    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
	    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
	    function validateProperty(tagName, name) {
	      {
	        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) {
	          return true;
	        }
	        if (rARIACamel.test(name)) {
	          var ariaName = "aria-" + name.slice(4).toLowerCase();
	          var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null;
	          if (correctName == null) {
	            error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
	            warnedProperties[name] = true;
	            return true;
	          }
	          if (name !== correctName) {
	            error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	        if (rARIA.test(name)) {
	          var lowerCasedName = name.toLowerCase();
	          var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null;
	          if (standardName == null) {
	            warnedProperties[name] = true;
	            return false;
	          }
	          if (name !== standardName) {
	            error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
	            warnedProperties[name] = true;
	            return true;
	          }
	        }
	      }
	      return true;
	    }
	    function warnInvalidARIAProps(type, props) {
	      {
	        var invalidProps = [];
	        for (var key in props) {
	          var isValid = validateProperty(type, key);
	          if (!isValid) {
	            invalidProps.push(key);
	          }
	        }
	        var unknownPropString = invalidProps.map(function(prop) {
	          return "`" + prop + "`";
	        }).join(", ");
	        if (invalidProps.length === 1) {
	          error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
	        } else if (invalidProps.length > 1) {
	          error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
	        }
	      }
	    }
	    function validateProperties(type, props) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnInvalidARIAProps(type, props);
	    }
	    var didWarnValueNull = false;
	    function validateProperties$1(type, props) {
	      {
	        if (type !== "input" && type !== "textarea" && type !== "select") {
	          return;
	        }
	        if (props != null && props.value === null && !didWarnValueNull) {
	          didWarnValueNull = true;
	          if (type === "select" && props.multiple) {
	            error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
	          } else {
	            error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
	          }
	        }
	      }
	    }
	    var possibleStandardNames = {
	      // HTML
	      accept: "accept",
	      acceptcharset: "acceptCharset",
	      "accept-charset": "acceptCharset",
	      accesskey: "accessKey",
	      action: "action",
	      allowfullscreen: "allowFullScreen",
	      alt: "alt",
	      as: "as",
	      async: "async",
	      autocapitalize: "autoCapitalize",
	      autocomplete: "autoComplete",
	      autocorrect: "autoCorrect",
	      autofocus: "autoFocus",
	      autoplay: "autoPlay",
	      autosave: "autoSave",
	      capture: "capture",
	      cellpadding: "cellPadding",
	      cellspacing: "cellSpacing",
	      challenge: "challenge",
	      charset: "charSet",
	      checked: "checked",
	      children: "children",
	      cite: "cite",
	      class: "className",
	      classid: "classID",
	      classname: "className",
	      cols: "cols",
	      colspan: "colSpan",
	      content: "content",
	      contenteditable: "contentEditable",
	      contextmenu: "contextMenu",
	      controls: "controls",
	      controlslist: "controlsList",
	      coords: "coords",
	      crossorigin: "crossOrigin",
	      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
	      data: "data",
	      datetime: "dateTime",
	      default: "default",
	      defaultchecked: "defaultChecked",
	      defaultvalue: "defaultValue",
	      defer: "defer",
	      dir: "dir",
	      disabled: "disabled",
	      disablepictureinpicture: "disablePictureInPicture",
	      disableremoteplayback: "disableRemotePlayback",
	      download: "download",
	      draggable: "draggable",
	      enctype: "encType",
	      enterkeyhint: "enterKeyHint",
	      for: "htmlFor",
	      form: "form",
	      formmethod: "formMethod",
	      formaction: "formAction",
	      formenctype: "formEncType",
	      formnovalidate: "formNoValidate",
	      formtarget: "formTarget",
	      frameborder: "frameBorder",
	      headers: "headers",
	      height: "height",
	      hidden: "hidden",
	      high: "high",
	      href: "href",
	      hreflang: "hrefLang",
	      htmlfor: "htmlFor",
	      httpequiv: "httpEquiv",
	      "http-equiv": "httpEquiv",
	      icon: "icon",
	      id: "id",
	      imagesizes: "imageSizes",
	      imagesrcset: "imageSrcSet",
	      innerhtml: "innerHTML",
	      inputmode: "inputMode",
	      integrity: "integrity",
	      is: "is",
	      itemid: "itemID",
	      itemprop: "itemProp",
	      itemref: "itemRef",
	      itemscope: "itemScope",
	      itemtype: "itemType",
	      keyparams: "keyParams",
	      keytype: "keyType",
	      kind: "kind",
	      label: "label",
	      lang: "lang",
	      list: "list",
	      loop: "loop",
	      low: "low",
	      manifest: "manifest",
	      marginwidth: "marginWidth",
	      marginheight: "marginHeight",
	      max: "max",
	      maxlength: "maxLength",
	      media: "media",
	      mediagroup: "mediaGroup",
	      method: "method",
	      min: "min",
	      minlength: "minLength",
	      multiple: "multiple",
	      muted: "muted",
	      name: "name",
	      nomodule: "noModule",
	      nonce: "nonce",
	      novalidate: "noValidate",
	      open: "open",
	      optimum: "optimum",
	      pattern: "pattern",
	      placeholder: "placeholder",
	      playsinline: "playsInline",
	      poster: "poster",
	      preload: "preload",
	      profile: "profile",
	      radiogroup: "radioGroup",
	      readonly: "readOnly",
	      referrerpolicy: "referrerPolicy",
	      rel: "rel",
	      required: "required",
	      reversed: "reversed",
	      role: "role",
	      rows: "rows",
	      rowspan: "rowSpan",
	      sandbox: "sandbox",
	      scope: "scope",
	      scoped: "scoped",
	      scrolling: "scrolling",
	      seamless: "seamless",
	      selected: "selected",
	      shape: "shape",
	      size: "size",
	      sizes: "sizes",
	      span: "span",
	      spellcheck: "spellCheck",
	      src: "src",
	      srcdoc: "srcDoc",
	      srclang: "srcLang",
	      srcset: "srcSet",
	      start: "start",
	      step: "step",
	      style: "style",
	      summary: "summary",
	      tabindex: "tabIndex",
	      target: "target",
	      title: "title",
	      type: "type",
	      usemap: "useMap",
	      value: "value",
	      width: "width",
	      wmode: "wmode",
	      wrap: "wrap",
	      // SVG
	      about: "about",
	      accentheight: "accentHeight",
	      "accent-height": "accentHeight",
	      accumulate: "accumulate",
	      additive: "additive",
	      alignmentbaseline: "alignmentBaseline",
	      "alignment-baseline": "alignmentBaseline",
	      allowreorder: "allowReorder",
	      alphabetic: "alphabetic",
	      amplitude: "amplitude",
	      arabicform: "arabicForm",
	      "arabic-form": "arabicForm",
	      ascent: "ascent",
	      attributename: "attributeName",
	      attributetype: "attributeType",
	      autoreverse: "autoReverse",
	      azimuth: "azimuth",
	      basefrequency: "baseFrequency",
	      baselineshift: "baselineShift",
	      "baseline-shift": "baselineShift",
	      baseprofile: "baseProfile",
	      bbox: "bbox",
	      begin: "begin",
	      bias: "bias",
	      by: "by",
	      calcmode: "calcMode",
	      capheight: "capHeight",
	      "cap-height": "capHeight",
	      clip: "clip",
	      clippath: "clipPath",
	      "clip-path": "clipPath",
	      clippathunits: "clipPathUnits",
	      cliprule: "clipRule",
	      "clip-rule": "clipRule",
	      color: "color",
	      colorinterpolation: "colorInterpolation",
	      "color-interpolation": "colorInterpolation",
	      colorinterpolationfilters: "colorInterpolationFilters",
	      "color-interpolation-filters": "colorInterpolationFilters",
	      colorprofile: "colorProfile",
	      "color-profile": "colorProfile",
	      colorrendering: "colorRendering",
	      "color-rendering": "colorRendering",
	      contentscripttype: "contentScriptType",
	      contentstyletype: "contentStyleType",
	      cursor: "cursor",
	      cx: "cx",
	      cy: "cy",
	      d: "d",
	      datatype: "datatype",
	      decelerate: "decelerate",
	      descent: "descent",
	      diffuseconstant: "diffuseConstant",
	      direction: "direction",
	      display: "display",
	      divisor: "divisor",
	      dominantbaseline: "dominantBaseline",
	      "dominant-baseline": "dominantBaseline",
	      dur: "dur",
	      dx: "dx",
	      dy: "dy",
	      edgemode: "edgeMode",
	      elevation: "elevation",
	      enablebackground: "enableBackground",
	      "enable-background": "enableBackground",
	      end: "end",
	      exponent: "exponent",
	      externalresourcesrequired: "externalResourcesRequired",
	      fill: "fill",
	      fillopacity: "fillOpacity",
	      "fill-opacity": "fillOpacity",
	      fillrule: "fillRule",
	      "fill-rule": "fillRule",
	      filter: "filter",
	      filterres: "filterRes",
	      filterunits: "filterUnits",
	      floodopacity: "floodOpacity",
	      "flood-opacity": "floodOpacity",
	      floodcolor: "floodColor",
	      "flood-color": "floodColor",
	      focusable: "focusable",
	      fontfamily: "fontFamily",
	      "font-family": "fontFamily",
	      fontsize: "fontSize",
	      "font-size": "fontSize",
	      fontsizeadjust: "fontSizeAdjust",
	      "font-size-adjust": "fontSizeAdjust",
	      fontstretch: "fontStretch",
	      "font-stretch": "fontStretch",
	      fontstyle: "fontStyle",
	      "font-style": "fontStyle",
	      fontvariant: "fontVariant",
	      "font-variant": "fontVariant",
	      fontweight: "fontWeight",
	      "font-weight": "fontWeight",
	      format: "format",
	      from: "from",
	      fx: "fx",
	      fy: "fy",
	      g1: "g1",
	      g2: "g2",
	      glyphname: "glyphName",
	      "glyph-name": "glyphName",
	      glyphorientationhorizontal: "glyphOrientationHorizontal",
	      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
	      glyphorientationvertical: "glyphOrientationVertical",
	      "glyph-orientation-vertical": "glyphOrientationVertical",
	      glyphref: "glyphRef",
	      gradienttransform: "gradientTransform",
	      gradientunits: "gradientUnits",
	      hanging: "hanging",
	      horizadvx: "horizAdvX",
	      "horiz-adv-x": "horizAdvX",
	      horizoriginx: "horizOriginX",
	      "horiz-origin-x": "horizOriginX",
	      ideographic: "ideographic",
	      imagerendering: "imageRendering",
	      "image-rendering": "imageRendering",
	      in2: "in2",
	      in: "in",
	      inlist: "inlist",
	      intercept: "intercept",
	      k1: "k1",
	      k2: "k2",
	      k3: "k3",
	      k4: "k4",
	      k: "k",
	      kernelmatrix: "kernelMatrix",
	      kernelunitlength: "kernelUnitLength",
	      kerning: "kerning",
	      keypoints: "keyPoints",
	      keysplines: "keySplines",
	      keytimes: "keyTimes",
	      lengthadjust: "lengthAdjust",
	      letterspacing: "letterSpacing",
	      "letter-spacing": "letterSpacing",
	      lightingcolor: "lightingColor",
	      "lighting-color": "lightingColor",
	      limitingconeangle: "limitingConeAngle",
	      local: "local",
	      markerend: "markerEnd",
	      "marker-end": "markerEnd",
	      markerheight: "markerHeight",
	      markermid: "markerMid",
	      "marker-mid": "markerMid",
	      markerstart: "markerStart",
	      "marker-start": "markerStart",
	      markerunits: "markerUnits",
	      markerwidth: "markerWidth",
	      mask: "mask",
	      maskcontentunits: "maskContentUnits",
	      maskunits: "maskUnits",
	      mathematical: "mathematical",
	      mode: "mode",
	      numoctaves: "numOctaves",
	      offset: "offset",
	      opacity: "opacity",
	      operator: "operator",
	      order: "order",
	      orient: "orient",
	      orientation: "orientation",
	      origin: "origin",
	      overflow: "overflow",
	      overlineposition: "overlinePosition",
	      "overline-position": "overlinePosition",
	      overlinethickness: "overlineThickness",
	      "overline-thickness": "overlineThickness",
	      paintorder: "paintOrder",
	      "paint-order": "paintOrder",
	      panose1: "panose1",
	      "panose-1": "panose1",
	      pathlength: "pathLength",
	      patterncontentunits: "patternContentUnits",
	      patterntransform: "patternTransform",
	      patternunits: "patternUnits",
	      pointerevents: "pointerEvents",
	      "pointer-events": "pointerEvents",
	      points: "points",
	      pointsatx: "pointsAtX",
	      pointsaty: "pointsAtY",
	      pointsatz: "pointsAtZ",
	      prefix: "prefix",
	      preservealpha: "preserveAlpha",
	      preserveaspectratio: "preserveAspectRatio",
	      primitiveunits: "primitiveUnits",
	      property: "property",
	      r: "r",
	      radius: "radius",
	      refx: "refX",
	      refy: "refY",
	      renderingintent: "renderingIntent",
	      "rendering-intent": "renderingIntent",
	      repeatcount: "repeatCount",
	      repeatdur: "repeatDur",
	      requiredextensions: "requiredExtensions",
	      requiredfeatures: "requiredFeatures",
	      resource: "resource",
	      restart: "restart",
	      result: "result",
	      results: "results",
	      rotate: "rotate",
	      rx: "rx",
	      ry: "ry",
	      scale: "scale",
	      security: "security",
	      seed: "seed",
	      shaperendering: "shapeRendering",
	      "shape-rendering": "shapeRendering",
	      slope: "slope",
	      spacing: "spacing",
	      specularconstant: "specularConstant",
	      specularexponent: "specularExponent",
	      speed: "speed",
	      spreadmethod: "spreadMethod",
	      startoffset: "startOffset",
	      stddeviation: "stdDeviation",
	      stemh: "stemh",
	      stemv: "stemv",
	      stitchtiles: "stitchTiles",
	      stopcolor: "stopColor",
	      "stop-color": "stopColor",
	      stopopacity: "stopOpacity",
	      "stop-opacity": "stopOpacity",
	      strikethroughposition: "strikethroughPosition",
	      "strikethrough-position": "strikethroughPosition",
	      strikethroughthickness: "strikethroughThickness",
	      "strikethrough-thickness": "strikethroughThickness",
	      string: "string",
	      stroke: "stroke",
	      strokedasharray: "strokeDasharray",
	      "stroke-dasharray": "strokeDasharray",
	      strokedashoffset: "strokeDashoffset",
	      "stroke-dashoffset": "strokeDashoffset",
	      strokelinecap: "strokeLinecap",
	      "stroke-linecap": "strokeLinecap",
	      strokelinejoin: "strokeLinejoin",
	      "stroke-linejoin": "strokeLinejoin",
	      strokemiterlimit: "strokeMiterlimit",
	      "stroke-miterlimit": "strokeMiterlimit",
	      strokewidth: "strokeWidth",
	      "stroke-width": "strokeWidth",
	      strokeopacity: "strokeOpacity",
	      "stroke-opacity": "strokeOpacity",
	      suppresscontenteditablewarning: "suppressContentEditableWarning",
	      suppresshydrationwarning: "suppressHydrationWarning",
	      surfacescale: "surfaceScale",
	      systemlanguage: "systemLanguage",
	      tablevalues: "tableValues",
	      targetx: "targetX",
	      targety: "targetY",
	      textanchor: "textAnchor",
	      "text-anchor": "textAnchor",
	      textdecoration: "textDecoration",
	      "text-decoration": "textDecoration",
	      textlength: "textLength",
	      textrendering: "textRendering",
	      "text-rendering": "textRendering",
	      to: "to",
	      transform: "transform",
	      typeof: "typeof",
	      u1: "u1",
	      u2: "u2",
	      underlineposition: "underlinePosition",
	      "underline-position": "underlinePosition",
	      underlinethickness: "underlineThickness",
	      "underline-thickness": "underlineThickness",
	      unicode: "unicode",
	      unicodebidi: "unicodeBidi",
	      "unicode-bidi": "unicodeBidi",
	      unicoderange: "unicodeRange",
	      "unicode-range": "unicodeRange",
	      unitsperem: "unitsPerEm",
	      "units-per-em": "unitsPerEm",
	      unselectable: "unselectable",
	      valphabetic: "vAlphabetic",
	      "v-alphabetic": "vAlphabetic",
	      values: "values",
	      vectoreffect: "vectorEffect",
	      "vector-effect": "vectorEffect",
	      version: "version",
	      vertadvy: "vertAdvY",
	      "vert-adv-y": "vertAdvY",
	      vertoriginx: "vertOriginX",
	      "vert-origin-x": "vertOriginX",
	      vertoriginy: "vertOriginY",
	      "vert-origin-y": "vertOriginY",
	      vhanging: "vHanging",
	      "v-hanging": "vHanging",
	      videographic: "vIdeographic",
	      "v-ideographic": "vIdeographic",
	      viewbox: "viewBox",
	      viewtarget: "viewTarget",
	      visibility: "visibility",
	      vmathematical: "vMathematical",
	      "v-mathematical": "vMathematical",
	      vocab: "vocab",
	      widths: "widths",
	      wordspacing: "wordSpacing",
	      "word-spacing": "wordSpacing",
	      writingmode: "writingMode",
	      "writing-mode": "writingMode",
	      x1: "x1",
	      x2: "x2",
	      x: "x",
	      xchannelselector: "xChannelSelector",
	      xheight: "xHeight",
	      "x-height": "xHeight",
	      xlinkactuate: "xlinkActuate",
	      "xlink:actuate": "xlinkActuate",
	      xlinkarcrole: "xlinkArcrole",
	      "xlink:arcrole": "xlinkArcrole",
	      xlinkhref: "xlinkHref",
	      "xlink:href": "xlinkHref",
	      xlinkrole: "xlinkRole",
	      "xlink:role": "xlinkRole",
	      xlinkshow: "xlinkShow",
	      "xlink:show": "xlinkShow",
	      xlinktitle: "xlinkTitle",
	      "xlink:title": "xlinkTitle",
	      xlinktype: "xlinkType",
	      "xlink:type": "xlinkType",
	      xmlbase: "xmlBase",
	      "xml:base": "xmlBase",
	      xmllang: "xmlLang",
	      "xml:lang": "xmlLang",
	      xmlns: "xmlns",
	      "xml:space": "xmlSpace",
	      xmlnsxlink: "xmlnsXlink",
	      "xmlns:xlink": "xmlnsXlink",
	      xmlspace: "xmlSpace",
	      y1: "y1",
	      y2: "y2",
	      y: "y",
	      ychannelselector: "yChannelSelector",
	      z: "z",
	      zoomandpan: "zoomAndPan"
	    };
	    var validateProperty$1 = function() {
	    };
	    {
	      var warnedProperties$1 = {};
	      var EVENT_NAME_REGEX = /^on./;
	      var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
	      var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
	      var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
	      validateProperty$1 = function(tagName, name, value, eventRegistry) {
	        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
	          return true;
	        }
	        var lowerCasedName = name.toLowerCase();
	        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
	          error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (eventRegistry != null) {
	          var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
	          if (registrationNameDependencies.hasOwnProperty(name)) {
	            return true;
	          }
	          var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
	          if (registrationName != null) {
	            error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	          if (EVENT_NAME_REGEX.test(name)) {
	            error("Unknown event handler property `%s`. It will be ignored.", name);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (EVENT_NAME_REGEX.test(name)) {
	          if (INVALID_EVENT_NAME_REGEX.test(name)) {
	            error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
	          return true;
	        }
	        if (lowerCasedName === "innerhtml") {
	          error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === "aria") {
	          error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
	          error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === "number" && isNaN(value)) {
	          error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        var propertyInfo = getPropertyInfo(name);
	        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED;
	        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
	          var standardName = possibleStandardNames[lowerCasedName];
	          if (standardName !== name) {
	            error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
	            warnedProperties$1[name] = true;
	            return true;
	          }
	        } else if (!isReserved && name !== lowerCasedName) {
	          error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          if (value) {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
	          } else {
	            error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
	          }
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        if (isReserved) {
	          return true;
	        }
	        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo)) {
	          warnedProperties$1[name] = true;
	          return false;
	        }
	        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
	          error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
	          warnedProperties$1[name] = true;
	          return true;
	        }
	        return true;
	      };
	    }
	    var warnUnknownProperties = function(type, props, eventRegistry) {
	      {
	        var unknownProps = [];
	        for (var key in props) {
	          var isValid = validateProperty$1(type, key, props[key], eventRegistry);
	          if (!isValid) {
	            unknownProps.push(key);
	          }
	        }
	        var unknownPropString = unknownProps.map(function(prop) {
	          return "`" + prop + "`";
	        }).join(", ");
	        if (unknownProps.length === 1) {
	          error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
	        } else if (unknownProps.length > 1) {
	          error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
	        }
	      }
	    };
	    function validateProperties$2(type, props, eventRegistry) {
	      if (isCustomComponent(type, props)) {
	        return;
	      }
	      warnUnknownProperties(type, props, eventRegistry);
	    }
	    var warnValidStyle = function() {
	    };
	    {
	      var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	      var msPattern = /^-ms-/;
	      var hyphenPattern = /-(.)/g;
	      var badStyleValueWithSemicolonPattern = /;\s*$/;
	      var warnedStyleNames = {};
	      var warnedStyleValues = {};
	      var warnedForNaNValue = false;
	      var warnedForInfinityValue = false;
	      var camelize = function(string) {
	        return string.replace(hyphenPattern, function(_, character) {
	          return character.toUpperCase();
	        });
	      };
	      var warnHyphenatedStyleName = function(name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error(
	          "Unsupported style property %s. Did you mean %s?",
	          name,
	          // As Andi Smith suggests
	          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	          // is converted to lowercase `ms`.
	          camelize(name.replace(msPattern, "ms-"))
	        );
	      };
	      var warnBadVendoredStyleName = function(name) {
	        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	          return;
	        }
	        warnedStyleNames[name] = true;
	        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
	      };
	      var warnStyleValueWithSemicolon = function(name, value) {
	        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	          return;
	        }
	        warnedStyleValues[value] = true;
	        error(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, name, value.replace(badStyleValueWithSemicolonPattern, ""));
	      };
	      var warnStyleValueIsNaN = function(name, value) {
	        if (warnedForNaNValue) {
	          return;
	        }
	        warnedForNaNValue = true;
	        error("`NaN` is an invalid value for the `%s` css style property.", name);
	      };
	      var warnStyleValueIsInfinity = function(name, value) {
	        if (warnedForInfinityValue) {
	          return;
	        }
	        warnedForInfinityValue = true;
	        error("`Infinity` is an invalid value for the `%s` css style property.", name);
	      };
	      warnValidStyle = function(name, value) {
	        if (name.indexOf("-") > -1) {
	          warnHyphenatedStyleName(name);
	        } else if (badVendoredStyleNamePattern.test(name)) {
	          warnBadVendoredStyleName(name);
	        } else if (badStyleValueWithSemicolonPattern.test(value)) {
	          warnStyleValueWithSemicolon(name, value);
	        }
	        if (typeof value === "number") {
	          if (isNaN(value)) {
	            warnStyleValueIsNaN(name, value);
	          } else if (!isFinite(value)) {
	            warnStyleValueIsInfinity(name, value);
	          }
	        }
	      };
	    }
	    var warnValidStyle$1 = warnValidStyle;
	    var matchHtmlRegExp = /["'&<>]/;
	    function escapeHtml(string) {
	      {
	        checkHtmlStringCoercion(string);
	      }
	      var str = "" + string;
	      var match = matchHtmlRegExp.exec(str);
	      if (!match) {
	        return str;
	      }
	      var escape;
	      var html = "";
	      var index;
	      var lastIndex = 0;
	      for (index = match.index; index < str.length; index++) {
	        switch (str.charCodeAt(index)) {
	          case 34:
	            escape = "&quot;";
	            break;
	          case 38:
	            escape = "&amp;";
	            break;
	          case 39:
	            escape = "&#x27;";
	            break;
	          case 60:
	            escape = "&lt;";
	            break;
	          case 62:
	            escape = "&gt;";
	            break;
	          default:
	            continue;
	        }
	        if (lastIndex !== index) {
	          html += str.substring(lastIndex, index);
	        }
	        lastIndex = index + 1;
	        html += escape;
	      }
	      return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	    }
	    function escapeTextForBrowser(text) {
	      if (typeof text === "boolean" || typeof text === "number") {
	        return "" + text;
	      }
	      return escapeHtml(text);
	    }
	    var uppercasePattern = /([A-Z])/g;
	    var msPattern$1 = /^ms-/;
	    function hyphenateStyleName(name) {
	      return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-");
	    }
	    var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
	    var didWarn = false;
	    function sanitizeURL(url) {
	      {
	        if (!didWarn && isJavaScriptProtocol.test(url)) {
	          didWarn = true;
	          error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
	        }
	      }
	    }
	    var isArrayImpl = Array.isArray;
	    function isArray(a) {
	      return isArrayImpl(a);
	    }
	    var startInlineScript = stringToPrecomputedChunk("<script>");
	    var endInlineScript = stringToPrecomputedChunk("</script>");
	    var startScriptSrc = stringToPrecomputedChunk('<script src="');
	    var startModuleSrc = stringToPrecomputedChunk('<script type="module" src="');
	    var endAsyncScript = stringToPrecomputedChunk('" async=""></script>');
	    function escapeBootstrapScriptContent(scriptText) {
	      {
	        checkHtmlStringCoercion(scriptText);
	      }
	      return ("" + scriptText).replace(scriptRegex, scriptReplacer);
	    }
	    var scriptRegex = /(<\/|<)(s)(cript)/gi;
	    var scriptReplacer = function(match, prefix2, s, suffix) {
	      return "" + prefix2 + (s === "s" ? "\\u0073" : "\\u0053") + suffix;
	    };
	    function createResponseState(identifierPrefix, nonce, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
	      var idPrefix = identifierPrefix === undefined ? "" : identifierPrefix;
	      var inlineScriptWithNonce = nonce === undefined ? startInlineScript : stringToPrecomputedChunk('<script nonce="' + escapeTextForBrowser(nonce) + '">');
	      var bootstrapChunks = [];
	      if (bootstrapScriptContent !== undefined) {
	        bootstrapChunks.push(inlineScriptWithNonce, stringToChunk(escapeBootstrapScriptContent(bootstrapScriptContent)), endInlineScript);
	      }
	      if (bootstrapScripts !== undefined) {
	        for (var i = 0; i < bootstrapScripts.length; i++) {
	          bootstrapChunks.push(startScriptSrc, stringToChunk(escapeTextForBrowser(bootstrapScripts[i])), endAsyncScript);
	        }
	      }
	      if (bootstrapModules !== undefined) {
	        for (var _i = 0; _i < bootstrapModules.length; _i++) {
	          bootstrapChunks.push(startModuleSrc, stringToChunk(escapeTextForBrowser(bootstrapModules[_i])), endAsyncScript);
	        }
	      }
	      return {
	        bootstrapChunks,
	        startInlineScript: inlineScriptWithNonce,
	        placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
	        segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
	        boundaryPrefix: idPrefix + "B:",
	        idPrefix,
	        nextSuspenseID: 0,
	        sentCompleteSegmentFunction: false,
	        sentCompleteBoundaryFunction: false,
	        sentClientRenderFunction: false
	      };
	    }
	    var ROOT_HTML_MODE = 0;
	    var HTML_MODE = 1;
	    var SVG_MODE = 2;
	    var MATHML_MODE = 3;
	    var HTML_TABLE_MODE = 4;
	    var HTML_TABLE_BODY_MODE = 5;
	    var HTML_TABLE_ROW_MODE = 6;
	    var HTML_COLGROUP_MODE = 7;
	    function createFormatContext(insertionMode, selectedValue) {
	      return {
	        insertionMode,
	        selectedValue
	      };
	    }
	    function createRootFormatContext(namespaceURI) {
	      var insertionMode = namespaceURI === "http://www.w3.org/2000/svg" ? SVG_MODE : namespaceURI === "http://www.w3.org/1998/Math/MathML" ? MATHML_MODE : ROOT_HTML_MODE;
	      return createFormatContext(insertionMode, null);
	    }
	    function getChildFormatContext(parentContext, type, props) {
	      switch (type) {
	        case "select":
	          return createFormatContext(HTML_MODE, props.value != null ? props.value : props.defaultValue);
	        case "svg":
	          return createFormatContext(SVG_MODE, null);
	        case "math":
	          return createFormatContext(MATHML_MODE, null);
	        case "foreignObject":
	          return createFormatContext(HTML_MODE, null);
	        case "table":
	          return createFormatContext(HTML_TABLE_MODE, null);
	        case "thead":
	        case "tbody":
	        case "tfoot":
	          return createFormatContext(HTML_TABLE_BODY_MODE, null);
	        case "colgroup":
	          return createFormatContext(HTML_COLGROUP_MODE, null);
	        case "tr":
	          return createFormatContext(HTML_TABLE_ROW_MODE, null);
	      }
	      if (parentContext.insertionMode >= HTML_TABLE_MODE) {
	        return createFormatContext(HTML_MODE, null);
	      }
	      if (parentContext.insertionMode === ROOT_HTML_MODE) {
	        return createFormatContext(HTML_MODE, null);
	      }
	      return parentContext;
	    }
	    var UNINITIALIZED_SUSPENSE_BOUNDARY_ID = null;
	    function assignSuspenseBoundaryID(responseState) {
	      var generatedID = responseState.nextSuspenseID++;
	      return stringToPrecomputedChunk(responseState.boundaryPrefix + generatedID.toString(16));
	    }
	    function makeId(responseState, treeId, localId) {
	      var idPrefix = responseState.idPrefix;
	      var id = ":" + idPrefix + "R" + treeId;
	      if (localId > 0) {
	        id += "H" + localId.toString(32);
	      }
	      return id + ":";
	    }
	    function encodeHTMLTextNode(text) {
	      return escapeTextForBrowser(text);
	    }
	    var textSeparator = stringToPrecomputedChunk("<!-- -->");
	    function pushTextInstance(target, text, responseState, textEmbedded) {
	      if (text === "") {
	        return textEmbedded;
	      }
	      if (textEmbedded) {
	        target.push(textSeparator);
	      }
	      target.push(stringToChunk(encodeHTMLTextNode(text)));
	      return true;
	    }
	    function pushSegmentFinale(target, responseState, lastPushedText, textEmbedded) {
	      if (lastPushedText && textEmbedded) {
	        target.push(textSeparator);
	      }
	    }
	    var styleNameCache = /* @__PURE__ */ new Map();
	    function processStyleName(styleName) {
	      var chunk = styleNameCache.get(styleName);
	      if (chunk !== undefined) {
	        return chunk;
	      }
	      var result = stringToPrecomputedChunk(escapeTextForBrowser(hyphenateStyleName(styleName)));
	      styleNameCache.set(styleName, result);
	      return result;
	    }
	    var styleAttributeStart = stringToPrecomputedChunk(' style="');
	    var styleAssign = stringToPrecomputedChunk(":");
	    var styleSeparator = stringToPrecomputedChunk(";");
	    function pushStyle(target, responseState, style) {
	      if (typeof style !== "object") {
	        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
	      }
	      var isFirst = true;
	      for (var styleName in style) {
	        if (!hasOwnProperty.call(style, styleName)) {
	          continue;
	        }
	        var styleValue = style[styleName];
	        if (styleValue == null || typeof styleValue === "boolean" || styleValue === "") {
	          continue;
	        }
	        var nameChunk = undefined;
	        var valueChunk = undefined;
	        var isCustomProperty = styleName.indexOf("--") === 0;
	        if (isCustomProperty) {
	          nameChunk = stringToChunk(escapeTextForBrowser(styleName));
	          {
	            checkCSSPropertyStringCoercion(styleValue, styleName);
	          }
	          valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
	        } else {
	          {
	            warnValidStyle$1(styleName, styleValue);
	          }
	          nameChunk = processStyleName(styleName);
	          if (typeof styleValue === "number") {
	            if (styleValue !== 0 && !hasOwnProperty.call(isUnitlessNumber, styleName)) {
	              valueChunk = stringToChunk(styleValue + "px");
	            } else {
	              valueChunk = stringToChunk("" + styleValue);
	            }
	          } else {
	            {
	              checkCSSPropertyStringCoercion(styleValue, styleName);
	            }
	            valueChunk = stringToChunk(escapeTextForBrowser(("" + styleValue).trim()));
	          }
	        }
	        if (isFirst) {
	          isFirst = false;
	          target.push(styleAttributeStart, nameChunk, styleAssign, valueChunk);
	        } else {
	          target.push(styleSeparator, nameChunk, styleAssign, valueChunk);
	        }
	      }
	      if (!isFirst) {
	        target.push(attributeEnd);
	      }
	    }
	    var attributeSeparator = stringToPrecomputedChunk(" ");
	    var attributeAssign = stringToPrecomputedChunk('="');
	    var attributeEnd = stringToPrecomputedChunk('"');
	    var attributeEmptyString = stringToPrecomputedChunk('=""');
	    function pushAttribute(target, responseState, name, value) {
	      switch (name) {
	        case "style": {
	          pushStyle(target, responseState, value);
	          return;
	        }
	        case "defaultValue":
	        case "defaultChecked":
	        case "innerHTML":
	        case "suppressContentEditableWarning":
	        case "suppressHydrationWarning":
	          return;
	      }
	      if (
	        // shouldIgnoreAttribute
	        // We have already filtered out null/undefined and reserved words.
	        name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")
	      ) {
	        return;
	      }
	      var propertyInfo = getPropertyInfo(name);
	      if (propertyInfo !== null) {
	        switch (typeof value) {
	          case "function":
	          case "symbol":
	            return;
	          case "boolean": {
	            if (!propertyInfo.acceptsBooleans) {
	              return;
	            }
	          }
	        }
	        var attributeName = propertyInfo.attributeName;
	        var attributeNameChunk = stringToChunk(attributeName);
	        switch (propertyInfo.type) {
	          case BOOLEAN:
	            if (value) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            }
	            return;
	          case OVERLOADED_BOOLEAN:
	            if (value === true) {
	              target.push(attributeSeparator, attributeNameChunk, attributeEmptyString);
	            } else if (value === false) ;
	            else {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            return;
	          case NUMERIC:
	            if (!isNaN(value)) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          case POSITIVE_NUMERIC:
	            if (!isNaN(value) && value >= 1) {
	              target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	            }
	            break;
	          default:
	            if (propertyInfo.sanitizeURL) {
	              {
	                checkAttributeStringCoercion(value, attributeName);
	              }
	              value = "" + value;
	              sanitizeURL(value);
	            }
	            target.push(attributeSeparator, attributeNameChunk, attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	        }
	      } else if (isAttributeNameSafe(name)) {
	        switch (typeof value) {
	          case "function":
	          case "symbol":
	            return;
	          case "boolean": {
	            var prefix2 = name.toLowerCase().slice(0, 5);
	            if (prefix2 !== "data-" && prefix2 !== "aria-") {
	              return;
	            }
	          }
	        }
	        target.push(attributeSeparator, stringToChunk(name), attributeAssign, stringToChunk(escapeTextForBrowser(value)), attributeEnd);
	      }
	    }
	    var endOfStartTag = stringToPrecomputedChunk(">");
	    var endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");
	    function pushInnerHTML(target, innerHTML, children) {
	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
	        }
	        if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
	          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          {
	            checkHtmlStringCoercion(html);
	          }
	          target.push(stringToChunk("" + html));
	        }
	      }
	    }
	    var didWarnDefaultInputValue = false;
	    var didWarnDefaultChecked = false;
	    var didWarnDefaultSelectValue = false;
	    var didWarnDefaultTextareaValue = false;
	    var didWarnInvalidOptionChildren = false;
	    var didWarnInvalidOptionInnerHTML = false;
	    var didWarnSelectedSetOnOption = false;
	    function checkSelectProp(props, propName) {
	      {
	        var value = props[propName];
	        if (value != null) {
	          var array = isArray(value);
	          if (props.multiple && !array) {
	            error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
	          } else if (!props.multiple && array) {
	            error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
	          }
	        }
	      }
	    }
	    function pushStartSelect(target, props, responseState) {
	      {
	        checkControlledValueProps("select", props);
	        checkSelectProp(props, "value");
	        checkSelectProp(props, "defaultValue");
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
	          error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
	          didWarnDefaultSelectValue = true;
	        }
	      }
	      target.push(startChunkForTag("select"));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            case "defaultValue":
	            case "value":
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function flattenOptionChildren(children) {
	      var content = "";
	      React.Children.forEach(children, function(child) {
	        if (child == null) {
	          return;
	        }
	        content += child;
	        {
	          if (!didWarnInvalidOptionChildren && typeof child !== "string" && typeof child !== "number") {
	            didWarnInvalidOptionChildren = true;
	            error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
	          }
	        }
	      });
	      return content;
	    }
	    var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""');
	    function pushStartOption(target, props, responseState, formatContext) {
	      var selectedValue = formatContext.selectedValue;
	      target.push(startChunkForTag("option"));
	      var children = null;
	      var value = null;
	      var selected = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "selected":
	              selected = propValue;
	              {
	                if (!didWarnSelectedSetOnOption) {
	                  error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
	                  didWarnSelectedSetOnOption = true;
	                }
	              }
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            case "value":
	              value = propValue;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (selectedValue != null) {
	        var stringValue;
	        if (value !== null) {
	          {
	            checkAttributeStringCoercion(value, "value");
	          }
	          stringValue = "" + value;
	        } else {
	          {
	            if (innerHTML !== null) {
	              if (!didWarnInvalidOptionInnerHTML) {
	                didWarnInvalidOptionInnerHTML = true;
	                error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
	              }
	            }
	          }
	          stringValue = flattenOptionChildren(children);
	        }
	        if (isArray(selectedValue)) {
	          for (var i = 0; i < selectedValue.length; i++) {
	            {
	              checkAttributeStringCoercion(selectedValue[i], "value");
	            }
	            var v = "" + selectedValue[i];
	            if (v === stringValue) {
	              target.push(selectedMarkerAttribute);
	              break;
	            }
	          }
	        } else {
	          {
	            checkAttributeStringCoercion(selectedValue, "select.value");
	          }
	          if ("" + selectedValue === stringValue) {
	            target.push(selectedMarkerAttribute);
	          }
	        }
	      } else if (selected) {
	        target.push(selectedMarkerAttribute);
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    function pushInput(target, props, responseState) {
	      {
	        checkControlledValueProps("input", props);
	        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
	          error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
	          didWarnDefaultChecked = true;
	        }
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
	          error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", props.type);
	          didWarnDefaultInputValue = true;
	        }
	      }
	      target.push(startChunkForTag("input"));
	      var value = null;
	      var defaultValue = null;
	      var checked = null;
	      var defaultChecked = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	            case "dangerouslySetInnerHTML":
	              throw new Error("input is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
	            case "defaultChecked":
	              defaultChecked = propValue;
	              break;
	            case "defaultValue":
	              defaultValue = propValue;
	              break;
	            case "checked":
	              checked = propValue;
	              break;
	            case "value":
	              value = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (checked !== null) {
	        pushAttribute(target, responseState, "checked", checked);
	      } else if (defaultChecked !== null) {
	        pushAttribute(target, responseState, "checked", defaultChecked);
	      }
	      if (value !== null) {
	        pushAttribute(target, responseState, "value", value);
	      } else if (defaultValue !== null) {
	        pushAttribute(target, responseState, "value", defaultValue);
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartTextArea(target, props, responseState) {
	      {
	        checkControlledValueProps("textarea", props);
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
	          error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
	          didWarnDefaultTextareaValue = true;
	        }
	      }
	      target.push(startChunkForTag("textarea"));
	      var value = null;
	      var defaultValue = null;
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "value":
	              value = propValue;
	              break;
	            case "defaultValue":
	              defaultValue = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      if (value === null && defaultValue !== null) {
	        value = defaultValue;
	      }
	      target.push(endOfStartTag);
	      if (children != null) {
	        {
	          error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
	        }
	        if (value != null) {
	          throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
	        }
	        if (isArray(children)) {
	          if (children.length > 1) {
	            throw new Error("<textarea> can only have at most one child.");
	          }
	          {
	            checkHtmlStringCoercion(children[0]);
	          }
	          value = "" + children[0];
	        }
	        {
	          checkHtmlStringCoercion(children);
	        }
	        value = "" + children;
	      }
	      if (typeof value === "string" && value[0] === "\n") {
	        target.push(leadingNewline);
	      }
	      if (value !== null) {
	        {
	          checkAttributeStringCoercion(value, "value");
	        }
	        target.push(stringToChunk(encodeHTMLTextNode("" + value)));
	      }
	      return null;
	    }
	    function pushSelfClosing(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	            case "dangerouslySetInnerHTML":
	              throw new Error(tag + " is a self-closing tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTagSelfClosing);
	      return null;
	    }
	    function pushStartMenuItem(target, props, responseState) {
	      target.push(startChunkForTag("menuitem"));
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	            case "dangerouslySetInnerHTML":
	              throw new Error("menuitems cannot have `children` nor `dangerouslySetInnerHTML`.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      return null;
	    }
	    function pushStartTitle(target, props, responseState) {
	      target.push(startChunkForTag("title"));
	      var children = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              throw new Error("`dangerouslySetInnerHTML` does not make sense on <title>.");
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      {
	        var child = Array.isArray(children) && children.length < 2 ? children[0] || null : children;
	        if (Array.isArray(children) && children.length > 1) {
	          error("A title element received an array with more than 1 element as children. In browsers title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
	        } else if (child != null && child.$$typeof != null) {
	          error("A title element received a React element for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
	        } else if (child != null && typeof child !== "string" && typeof child !== "number") {
	          error("A title element received a value that was not a string or number for children. In the browser title Elements can only have Text Nodes as children. If the children being rendered output more than a single text node in aggregate the browser will display markup and comments as text in the title and hydration will likely fail and fall back to client rendering");
	        }
	      }
	      return children;
	    }
	    function pushStartGenericElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      if (typeof children === "string") {
	        target.push(stringToChunk(encodeHTMLTextNode(children)));
	        return null;
	      }
	      return children;
	    }
	    function pushStartCustomElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            case "style":
	              pushStyle(target, responseState, propValue);
	              break;
	            case "suppressContentEditableWarning":
	            case "suppressHydrationWarning":
	              break;
	            default:
	              if (isAttributeNameSafe(propKey) && typeof propValue !== "function" && typeof propValue !== "symbol") {
	                target.push(attributeSeparator, stringToChunk(propKey), attributeAssign, stringToChunk(escapeTextForBrowser(propValue)), attributeEnd);
	              }
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      pushInnerHTML(target, innerHTML, children);
	      return children;
	    }
	    var leadingNewline = stringToPrecomputedChunk("\n");
	    function pushStartPreformattedElement(target, props, tag, responseState) {
	      target.push(startChunkForTag(tag));
	      var children = null;
	      var innerHTML = null;
	      for (var propKey in props) {
	        if (hasOwnProperty.call(props, propKey)) {
	          var propValue = props[propKey];
	          if (propValue == null) {
	            continue;
	          }
	          switch (propKey) {
	            case "children":
	              children = propValue;
	              break;
	            case "dangerouslySetInnerHTML":
	              innerHTML = propValue;
	              break;
	            default:
	              pushAttribute(target, responseState, propKey, propValue);
	              break;
	          }
	        }
	      }
	      target.push(endOfStartTag);
	      if (innerHTML != null) {
	        if (children != null) {
	          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
	        }
	        if (typeof innerHTML !== "object" || !("__html" in innerHTML)) {
	          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
	        }
	        var html = innerHTML.__html;
	        if (html !== null && html !== undefined) {
	          if (typeof html === "string" && html.length > 0 && html[0] === "\n") {
	            target.push(leadingNewline, stringToChunk(html));
	          } else {
	            {
	              checkHtmlStringCoercion(html);
	            }
	            target.push(stringToChunk("" + html));
	          }
	        }
	      }
	      if (typeof children === "string" && children[0] === "\n") {
	        target.push(leadingNewline);
	      }
	      return children;
	    }
	    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	    var validatedTagCache = /* @__PURE__ */ new Map();
	    function startChunkForTag(tag) {
	      var tagStartChunk = validatedTagCache.get(tag);
	      if (tagStartChunk === undefined) {
	        if (!VALID_TAG_REGEX.test(tag)) {
	          throw new Error("Invalid tag: " + tag);
	        }
	        tagStartChunk = stringToPrecomputedChunk("<" + tag);
	        validatedTagCache.set(tag, tagStartChunk);
	      }
	      return tagStartChunk;
	    }
	    var DOCTYPE = stringToPrecomputedChunk("<!DOCTYPE html>");
	    function pushStartInstance(target, type, props, responseState, formatContext) {
	      {
	        validateProperties(type, props);
	        validateProperties$1(type, props);
	        validateProperties$2(type, props, null);
	        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
	          error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
	        }
	        if (formatContext.insertionMode !== SVG_MODE && formatContext.insertionMode !== MATHML_MODE) {
	          if (type.indexOf("-") === -1 && typeof props.is !== "string" && type.toLowerCase() !== type) {
	            error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
	          }
	        }
	      }
	      switch (type) {
	        case "select":
	          return pushStartSelect(target, props, responseState);
	        case "option":
	          return pushStartOption(target, props, responseState, formatContext);
	        case "textarea":
	          return pushStartTextArea(target, props, responseState);
	        case "input":
	          return pushInput(target, props, responseState);
	        case "menuitem":
	          return pushStartMenuItem(target, props, responseState);
	        case "title":
	          return pushStartTitle(target, props, responseState);
	        case "listing":
	        case "pre": {
	          return pushStartPreformattedElement(target, props, type, responseState);
	        }
	        case "area":
	        case "base":
	        case "br":
	        case "col":
	        case "embed":
	        case "hr":
	        case "img":
	        case "keygen":
	        case "link":
	        case "meta":
	        case "param":
	        case "source":
	        case "track":
	        case "wbr": {
	          return pushSelfClosing(target, props, type, responseState);
	        }
	        case "annotation-xml":
	        case "color-profile":
	        case "font-face":
	        case "font-face-src":
	        case "font-face-uri":
	        case "font-face-format":
	        case "font-face-name":
	        case "missing-glyph": {
	          return pushStartGenericElement(target, props, type, responseState);
	        }
	        case "html": {
	          if (formatContext.insertionMode === ROOT_HTML_MODE) {
	            target.push(DOCTYPE);
	          }
	          return pushStartGenericElement(target, props, type, responseState);
	        }
	        default: {
	          if (type.indexOf("-") === -1 && typeof props.is !== "string") {
	            return pushStartGenericElement(target, props, type, responseState);
	          } else {
	            return pushStartCustomElement(target, props, type, responseState);
	          }
	        }
	      }
	    }
	    var endTag1 = stringToPrecomputedChunk("</");
	    var endTag2 = stringToPrecomputedChunk(">");
	    function pushEndInstance(target, type, props) {
	      switch (type) {
	        case "area":
	        case "base":
	        case "br":
	        case "col":
	        case "embed":
	        case "hr":
	        case "img":
	        case "input":
	        case "keygen":
	        case "link":
	        case "meta":
	        case "param":
	        case "source":
	        case "track":
	        case "wbr": {
	          break;
	        }
	        default: {
	          target.push(endTag1, stringToChunk(type), endTag2);
	        }
	      }
	    }
	    function writeCompletedRoot(destination, responseState) {
	      var bootstrapChunks = responseState.bootstrapChunks;
	      var i = 0;
	      for (; i < bootstrapChunks.length - 1; i++) {
	        writeChunk(destination, bootstrapChunks[i]);
	      }
	      if (i < bootstrapChunks.length) {
	        return writeChunkAndReturn(destination, bootstrapChunks[i]);
	      }
	      return true;
	    }
	    var placeholder1 = stringToPrecomputedChunk('<template id="');
	    var placeholder2 = stringToPrecomputedChunk('"></template>');
	    function writePlaceholder(destination, responseState, id) {
	      writeChunk(destination, placeholder1);
	      writeChunk(destination, responseState.placeholderPrefix);
	      var formattedID = stringToChunk(id.toString(16));
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, placeholder2);
	    }
	    var startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->");
	    var startPendingSuspenseBoundary1 = stringToPrecomputedChunk('<!--$?--><template id="');
	    var startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>');
	    var startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->");
	    var endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->");
	    var clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template");
	    var clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"');
	    var clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
	    var clientRenderedSuspenseBoundaryError1B = stringToPrecomputedChunk(' data-msg="');
	    var clientRenderedSuspenseBoundaryError1C = stringToPrecomputedChunk(' data-stck="');
	    var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");
	    function writeStartCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
	    }
	    function writeStartPendingSuspenseBoundary(destination, responseState, id) {
	      writeChunk(destination, startPendingSuspenseBoundary1);
	      if (id === null) {
	        throw new Error("An ID must have been assigned before we can complete the boundary.");
	      }
	      writeChunk(destination, id);
	      return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
	    }
	    function writeStartClientRenderedSuspenseBoundary(destination, responseState, errorDigest, errorMesssage, errorComponentStack) {
	      var result;
	      result = writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
	      writeChunk(destination, clientRenderedSuspenseBoundaryError1);
	      if (errorDigest) {
	        writeChunk(destination, clientRenderedSuspenseBoundaryError1A);
	        writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest)));
	        writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	      }
	      {
	        if (errorMesssage) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1B);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorMesssage)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	        if (errorComponentStack) {
	          writeChunk(destination, clientRenderedSuspenseBoundaryError1C);
	          writeChunk(destination, stringToChunk(escapeTextForBrowser(errorComponentStack)));
	          writeChunk(destination, clientRenderedSuspenseBoundaryErrorAttrInterstitial);
	        }
	      }
	      result = writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
	      return result;
	    }
	    function writeEndCompletedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndPendingSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    function writeEndClientRenderedSuspenseBoundary(destination, responseState) {
	      return writeChunkAndReturn(destination, endSuspenseBoundary);
	    }
	    var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="');
	    var startSegmentHTML2 = stringToPrecomputedChunk('">');
	    var endSegmentHTML = stringToPrecomputedChunk("</div>");
	    var startSegmentSVG = stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="');
	    var startSegmentSVG2 = stringToPrecomputedChunk('">');
	    var endSegmentSVG = stringToPrecomputedChunk("</svg>");
	    var startSegmentMathML = stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="');
	    var startSegmentMathML2 = stringToPrecomputedChunk('">');
	    var endSegmentMathML = stringToPrecomputedChunk("</math>");
	    var startSegmentTable = stringToPrecomputedChunk('<table hidden id="');
	    var startSegmentTable2 = stringToPrecomputedChunk('">');
	    var endSegmentTable = stringToPrecomputedChunk("</table>");
	    var startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="');
	    var startSegmentTableBody2 = stringToPrecomputedChunk('">');
	    var endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>");
	    var startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="');
	    var startSegmentTableRow2 = stringToPrecomputedChunk('">');
	    var endSegmentTableRow = stringToPrecomputedChunk("</tr></table>");
	    var startSegmentColGroup = stringToPrecomputedChunk('<table hidden><colgroup id="');
	    var startSegmentColGroup2 = stringToPrecomputedChunk('">');
	    var endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");
	    function writeStartSegment(destination, responseState, formatContext, id) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE: {
	          writeChunk(destination, startSegmentHTML);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentHTML2);
	        }
	        case SVG_MODE: {
	          writeChunk(destination, startSegmentSVG);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentSVG2);
	        }
	        case MATHML_MODE: {
	          writeChunk(destination, startSegmentMathML);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentMathML2);
	        }
	        case HTML_TABLE_MODE: {
	          writeChunk(destination, startSegmentTable);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentTable2);
	        }
	        case HTML_TABLE_BODY_MODE: {
	          writeChunk(destination, startSegmentTableBody);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentTableBody2);
	        }
	        case HTML_TABLE_ROW_MODE: {
	          writeChunk(destination, startSegmentTableRow);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentTableRow2);
	        }
	        case HTML_COLGROUP_MODE: {
	          writeChunk(destination, startSegmentColGroup);
	          writeChunk(destination, responseState.segmentPrefix);
	          writeChunk(destination, stringToChunk(id.toString(16)));
	          return writeChunkAndReturn(destination, startSegmentColGroup2);
	        }
	        default: {
	          throw new Error("Unknown insertion mode. This is a bug in React.");
	        }
	      }
	    }
	    function writeEndSegment(destination, formatContext) {
	      switch (formatContext.insertionMode) {
	        case ROOT_HTML_MODE:
	        case HTML_MODE: {
	          return writeChunkAndReturn(destination, endSegmentHTML);
	        }
	        case SVG_MODE: {
	          return writeChunkAndReturn(destination, endSegmentSVG);
	        }
	        case MATHML_MODE: {
	          return writeChunkAndReturn(destination, endSegmentMathML);
	        }
	        case HTML_TABLE_MODE: {
	          return writeChunkAndReturn(destination, endSegmentTable);
	        }
	        case HTML_TABLE_BODY_MODE: {
	          return writeChunkAndReturn(destination, endSegmentTableBody);
	        }
	        case HTML_TABLE_ROW_MODE: {
	          return writeChunkAndReturn(destination, endSegmentTableRow);
	        }
	        case HTML_COLGROUP_MODE: {
	          return writeChunkAndReturn(destination, endSegmentColGroup);
	        }
	        default: {
	          throw new Error("Unknown insertion mode. This is a bug in React.");
	        }
	      }
	    }
	    var completeSegmentFunction = "function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)}";
	    var completeBoundaryFunction = 'function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}}';
	    var clientRenderFunction = 'function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())}';
	    var completeSegmentScript1Full = stringToPrecomputedChunk(completeSegmentFunction + ';$RS("');
	    var completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("');
	    var completeSegmentScript2 = stringToPrecomputedChunk('","');
	    var completeSegmentScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedSegmentInstruction(destination, responseState, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteSegmentFunction) {
	        responseState.sentCompleteSegmentFunction = true;
	        writeChunk(destination, completeSegmentScript1Full);
	      } else {
	        writeChunk(destination, completeSegmentScript1Partial);
	      }
	      writeChunk(destination, responseState.segmentPrefix);
	      var formattedID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, formattedID);
	      writeChunk(destination, completeSegmentScript2);
	      writeChunk(destination, responseState.placeholderPrefix);
	      writeChunk(destination, formattedID);
	      return writeChunkAndReturn(destination, completeSegmentScript3);
	    }
	    var completeBoundaryScript1Full = stringToPrecomputedChunk(completeBoundaryFunction + ';$RC("');
	    var completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("');
	    var completeBoundaryScript2 = stringToPrecomputedChunk('","');
	    var completeBoundaryScript3 = stringToPrecomputedChunk('")</script>');
	    function writeCompletedBoundaryInstruction(destination, responseState, boundaryID, contentSegmentID) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentCompleteBoundaryFunction) {
	        responseState.sentCompleteBoundaryFunction = true;
	        writeChunk(destination, completeBoundaryScript1Full);
	      } else {
	        writeChunk(destination, completeBoundaryScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error("An ID must have been assigned before we can complete the boundary.");
	      }
	      var formattedContentID = stringToChunk(contentSegmentID.toString(16));
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, completeBoundaryScript2);
	      writeChunk(destination, responseState.segmentPrefix);
	      writeChunk(destination, formattedContentID);
	      return writeChunkAndReturn(destination, completeBoundaryScript3);
	    }
	    var clientRenderScript1Full = stringToPrecomputedChunk(clientRenderFunction + ';$RX("');
	    var clientRenderScript1Partial = stringToPrecomputedChunk('$RX("');
	    var clientRenderScript1A = stringToPrecomputedChunk('"');
	    var clientRenderScript2 = stringToPrecomputedChunk(")</script>");
	    var clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(",");
	    function writeClientRenderBoundaryInstruction(destination, responseState, boundaryID, errorDigest, errorMessage, errorComponentStack) {
	      writeChunk(destination, responseState.startInlineScript);
	      if (!responseState.sentClientRenderFunction) {
	        responseState.sentClientRenderFunction = true;
	        writeChunk(destination, clientRenderScript1Full);
	      } else {
	        writeChunk(destination, clientRenderScript1Partial);
	      }
	      if (boundaryID === null) {
	        throw new Error("An ID must have been assigned before we can complete the boundary.");
	      }
	      writeChunk(destination, boundaryID);
	      writeChunk(destination, clientRenderScript1A);
	      if (errorDigest || errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorDigest || "")));
	      }
	      if (errorMessage || errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorMessage || "")));
	      }
	      if (errorComponentStack) {
	        writeChunk(destination, clientRenderErrorScriptArgInterstitial);
	        writeChunk(destination, stringToChunk(escapeJSStringsForInstructionScripts(errorComponentStack)));
	      }
	      return writeChunkAndReturn(destination, clientRenderScript2);
	    }
	    var regexForJSStringsInScripts = /[<\u2028\u2029]/g;
	    function escapeJSStringsForInstructionScripts(input) {
	      var escaped = JSON.stringify(input);
	      return escaped.replace(regexForJSStringsInScripts, function(match) {
	        switch (match) {
	          case "<":
	            return "\\u003c";
	          case "\u2028":
	            return "\\u2028";
	          case "\u2029":
	            return "\\u2029";
	          default: {
	            throw new Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
	          }
	        }
	      });
	    }
	    var assign = Object.assign;
	    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
	    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
	    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
	    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
	    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
	    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
	    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
	    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
	    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
	    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
	    var REACT_MEMO_TYPE = Symbol.for("react.memo");
	    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
	    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
	    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
	    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
	    var REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED = Symbol.for("react.default_value");
	    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	    var FAUX_ITERATOR_SYMBOL = "@@iterator";
	    function getIteratorFn(maybeIterable) {
	      if (maybeIterable === null || typeof maybeIterable !== "object") {
	        return null;
	      }
	      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
	      if (typeof maybeIterator === "function") {
	        return maybeIterator;
	      }
	      return null;
	    }
	    function getWrappedName(outerType, innerType, wrapperName) {
	      var displayName = outerType.displayName;
	      if (displayName) {
	        return displayName;
	      }
	      var functionName = innerType.displayName || innerType.name || "";
	      return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
	    }
	    function getContextName(type) {
	      return type.displayName || "Context";
	    }
	    function getComponentNameFromType(type) {
	      if (type == null) {
	        return null;
	      }
	      {
	        if (typeof type.tag === "number") {
	          error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
	        }
	      }
	      if (typeof type === "function") {
	        return type.displayName || type.name || null;
	      }
	      if (typeof type === "string") {
	        return type;
	      }
	      switch (type) {
	        case REACT_FRAGMENT_TYPE:
	          return "Fragment";
	        case REACT_PORTAL_TYPE:
	          return "Portal";
	        case REACT_PROFILER_TYPE:
	          return "Profiler";
	        case REACT_STRICT_MODE_TYPE:
	          return "StrictMode";
	        case REACT_SUSPENSE_TYPE:
	          return "Suspense";
	        case REACT_SUSPENSE_LIST_TYPE:
	          return "SuspenseList";
	      }
	      if (typeof type === "object") {
	        switch (type.$$typeof) {
	          case REACT_CONTEXT_TYPE:
	            var context = type;
	            return getContextName(context) + ".Consumer";
	          case REACT_PROVIDER_TYPE:
	            var provider = type;
	            return getContextName(provider._context) + ".Provider";
	          case REACT_FORWARD_REF_TYPE:
	            return getWrappedName(type, type.render, "ForwardRef");
	          case REACT_MEMO_TYPE:
	            var outerName = type.displayName || null;
	            if (outerName !== null) {
	              return outerName;
	            }
	            return getComponentNameFromType(type.type) || "Memo";
	          case REACT_LAZY_TYPE: {
	            var lazyComponent = type;
	            var payload = lazyComponent._payload;
	            var init = lazyComponent._init;
	            try {
	              return getComponentNameFromType(init(payload));
	            } catch (x) {
	              return null;
	            }
	          }
	        }
	      }
	      return null;
	    }
	    var disabledDepth = 0;
	    var prevLog;
	    var prevInfo;
	    var prevWarn;
	    var prevError;
	    var prevGroup;
	    var prevGroupCollapsed;
	    var prevGroupEnd;
	    function disabledLog() {
	    }
	    disabledLog.__reactDisabledLog = true;
	    function disableLogs() {
	      {
	        if (disabledDepth === 0) {
	          prevLog = console.log;
	          prevInfo = console.info;
	          prevWarn = console.warn;
	          prevError = console.error;
	          prevGroup = console.group;
	          prevGroupCollapsed = console.groupCollapsed;
	          prevGroupEnd = console.groupEnd;
	          var props = {
	            configurable: true,
	            enumerable: true,
	            value: disabledLog,
	            writable: true
	          };
	          Object.defineProperties(console, {
	            info: props,
	            log: props,
	            warn: props,
	            error: props,
	            group: props,
	            groupCollapsed: props,
	            groupEnd: props
	          });
	        }
	        disabledDepth++;
	      }
	    }
	    function reenableLogs() {
	      {
	        disabledDepth--;
	        if (disabledDepth === 0) {
	          var props = {
	            configurable: true,
	            enumerable: true,
	            writable: true
	          };
	          Object.defineProperties(console, {
	            log: assign({}, props, {
	              value: prevLog
	            }),
	            info: assign({}, props, {
	              value: prevInfo
	            }),
	            warn: assign({}, props, {
	              value: prevWarn
	            }),
	            error: assign({}, props, {
	              value: prevError
	            }),
	            group: assign({}, props, {
	              value: prevGroup
	            }),
	            groupCollapsed: assign({}, props, {
	              value: prevGroupCollapsed
	            }),
	            groupEnd: assign({}, props, {
	              value: prevGroupEnd
	            })
	          });
	        }
	        if (disabledDepth < 0) {
	          error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
	        }
	      }
	    }
	    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	    var prefix;
	    function describeBuiltInComponentFrame(name, source, ownerFn) {
	      {
	        if (prefix === undefined) {
	          try {
	            throw Error();
	          } catch (x) {
	            var match = x.stack.trim().match(/\n( *(at )?)/);
	            prefix = match && match[1] || "";
	          }
	        }
	        return "\n" + prefix + name;
	      }
	    }
	    var reentry = false;
	    var componentFrameCache;
	    {
	      var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
	      componentFrameCache = new PossiblyWeakMap();
	    }
	    function describeNativeComponentFrame(fn, construct) {
	      if (!fn || reentry) {
	        return "";
	      }
	      {
	        var frame = componentFrameCache.get(fn);
	        if (frame !== undefined) {
	          return frame;
	        }
	      }
	      var control;
	      reentry = true;
	      var previousPrepareStackTrace = Error.prepareStackTrace;
	      Error.prepareStackTrace = undefined;
	      var previousDispatcher;
	      {
	        previousDispatcher = ReactCurrentDispatcher.current;
	        ReactCurrentDispatcher.current = null;
	        disableLogs();
	      }
	      try {
	        if (construct) {
	          var Fake = function() {
	            throw Error();
	          };
	          Object.defineProperty(Fake.prototype, "props", {
	            set: function() {
	              throw Error();
	            }
	          });
	          if (typeof Reflect === "object" && Reflect.construct) {
	            try {
	              Reflect.construct(Fake, []);
	            } catch (x) {
	              control = x;
	            }
	            Reflect.construct(fn, [], Fake);
	          } else {
	            try {
	              Fake.call();
	            } catch (x) {
	              control = x;
	            }
	            fn.call(Fake.prototype);
	          }
	        } else {
	          try {
	            throw Error();
	          } catch (x) {
	            control = x;
	          }
	          fn();
	        }
	      } catch (sample) {
	        if (sample && control && typeof sample.stack === "string") {
	          var sampleLines = sample.stack.split("\n");
	          var controlLines = control.stack.split("\n");
	          var s = sampleLines.length - 1;
	          var c = controlLines.length - 1;
	          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	            c--;
	          }
	          for (; s >= 1 && c >= 0; s--, c--) {
	            if (sampleLines[s] !== controlLines[c]) {
	              if (s !== 1 || c !== 1) {
	                do {
	                  s--;
	                  c--;
	                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                    var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
	                    if (fn.displayName && _frame.includes("<anonymous>")) {
	                      _frame = _frame.replace("<anonymous>", fn.displayName);
	                    }
	                    {
	                      if (typeof fn === "function") {
	                        componentFrameCache.set(fn, _frame);
	                      }
	                    }
	                    return _frame;
	                  }
	                } while (s >= 1 && c >= 0);
	              }
	              break;
	            }
	          }
	        }
	      } finally {
	        reentry = false;
	        {
	          ReactCurrentDispatcher.current = previousDispatcher;
	          reenableLogs();
	        }
	        Error.prepareStackTrace = previousPrepareStackTrace;
	      }
	      var name = fn ? fn.displayName || fn.name : "";
	      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
	      {
	        if (typeof fn === "function") {
	          componentFrameCache.set(fn, syntheticFrame);
	        }
	      }
	      return syntheticFrame;
	    }
	    function describeClassComponentFrame(ctor, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(ctor, true);
	      }
	    }
	    function describeFunctionComponentFrame(fn, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(fn, false);
	      }
	    }
	    function shouldConstruct(Component) {
	      var prototype = Component.prototype;
	      return !!(prototype && prototype.isReactComponent);
	    }
	    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
	      if (type == null) {
	        return "";
	      }
	      if (typeof type === "function") {
	        {
	          return describeNativeComponentFrame(type, shouldConstruct(type));
	        }
	      }
	      if (typeof type === "string") {
	        return describeBuiltInComponentFrame(type);
	      }
	      switch (type) {
	        case REACT_SUSPENSE_TYPE:
	          return describeBuiltInComponentFrame("Suspense");
	        case REACT_SUSPENSE_LIST_TYPE:
	          return describeBuiltInComponentFrame("SuspenseList");
	      }
	      if (typeof type === "object") {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            return describeFunctionComponentFrame(type.render);
	          case REACT_MEMO_TYPE:
	            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
	          case REACT_LAZY_TYPE: {
	            var lazyComponent = type;
	            var payload = lazyComponent._payload;
	            var init = lazyComponent._init;
	            try {
	              return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	            } catch (x) {
	            }
	          }
	        }
	      }
	      return "";
	    }
	    var loggedTypeFailures = {};
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    function setCurrentlyValidatingElement(element) {
	      {
	        if (element) {
	          var owner = element._owner;
	          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	          ReactDebugCurrentFrame.setExtraStackFrame(stack);
	        } else {
	          ReactDebugCurrentFrame.setExtraStackFrame(null);
	        }
	      }
	    }
	    function checkPropTypes(typeSpecs, values, location, componentName, element) {
	      {
	        var has = Function.call.bind(hasOwnProperty);
	        for (var typeSpecName in typeSpecs) {
	          if (has(typeSpecs, typeSpecName)) {
	            var error$1 = undefined;
	            try {
	              if (typeof typeSpecs[typeSpecName] !== "function") {
	                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
	                err.name = "Invariant Violation";
	                throw err;
	              }
	              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
	            } catch (ex) {
	              error$1 = ex;
	            }
	            if (error$1 && !(error$1 instanceof Error)) {
	              setCurrentlyValidatingElement(element);
	              error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
	              setCurrentlyValidatingElement(null);
	            }
	            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	              loggedTypeFailures[error$1.message] = true;
	              setCurrentlyValidatingElement(element);
	              error("Failed %s type: %s", location, error$1.message);
	              setCurrentlyValidatingElement(null);
	            }
	          }
	        }
	      }
	    }
	    var warnedAboutMissingGetChildContext;
	    {
	      warnedAboutMissingGetChildContext = {};
	    }
	    var emptyContextObject = {};
	    {
	      Object.freeze(emptyContextObject);
	    }
	    function getMaskedContext(type, unmaskedContext) {
	      {
	        var contextTypes = type.contextTypes;
	        if (!contextTypes) {
	          return emptyContextObject;
	        }
	        var context = {};
	        for (var key in contextTypes) {
	          context[key] = unmaskedContext[key];
	        }
	        {
	          var name = getComponentNameFromType(type) || "Unknown";
	          checkPropTypes(contextTypes, context, "context", name);
	        }
	        return context;
	      }
	    }
	    function processChildContext(instance, type, parentContext, childContextTypes) {
	      {
	        if (typeof instance.getChildContext !== "function") {
	          {
	            var componentName = getComponentNameFromType(type) || "Unknown";
	            if (!warnedAboutMissingGetChildContext[componentName]) {
	              warnedAboutMissingGetChildContext[componentName] = true;
	              error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
	            }
	          }
	          return parentContext;
	        }
	        var childContext = instance.getChildContext();
	        for (var contextKey in childContext) {
	          if (!(contextKey in childContextTypes)) {
	            throw new Error((getComponentNameFromType(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
	          }
	        }
	        {
	          var name = getComponentNameFromType(type) || "Unknown";
	          checkPropTypes(childContextTypes, childContext, "child context", name);
	        }
	        return assign({}, parentContext, childContext);
	      }
	    }
	    var rendererSigil;
	    {
	      rendererSigil = {};
	    }
	    var rootContextSnapshot = null;
	    var currentActiveSnapshot = null;
	    function popNode(prev) {
	      {
	        prev.context._currentValue = prev.parentValue;
	      }
	    }
	    function pushNode(next) {
	      {
	        next.context._currentValue = next.value;
	      }
	    }
	    function popToNearestCommonAncestor(prev, next) {
	      if (prev === next) ;
	      else {
	        popNode(prev);
	        var parentPrev = prev.parent;
	        var parentNext = next.parent;
	        if (parentPrev === null) {
	          if (parentNext !== null) {
	            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
	          }
	        } else {
	          if (parentNext === null) {
	            throw new Error("The stacks must reach the root at the same time. This is a bug in React.");
	          }
	          popToNearestCommonAncestor(parentPrev, parentNext);
	        }
	        pushNode(next);
	      }
	    }
	    function popAllPrevious(prev) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev !== null) {
	        popAllPrevious(parentPrev);
	      }
	    }
	    function pushAllNext(next) {
	      var parentNext = next.parent;
	      if (parentNext !== null) {
	        pushAllNext(parentNext);
	      }
	      pushNode(next);
	    }
	    function popPreviousToCommonLevel(prev, next) {
	      popNode(prev);
	      var parentPrev = prev.parent;
	      if (parentPrev === null) {
	        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
	      }
	      if (parentPrev.depth === next.depth) {
	        popToNearestCommonAncestor(parentPrev, next);
	      } else {
	        popPreviousToCommonLevel(parentPrev, next);
	      }
	    }
	    function popNextToCommonLevel(prev, next) {
	      var parentNext = next.parent;
	      if (parentNext === null) {
	        throw new Error("The depth must equal at least at zero before reaching the root. This is a bug in React.");
	      }
	      if (prev.depth === parentNext.depth) {
	        popToNearestCommonAncestor(prev, parentNext);
	      } else {
	        popNextToCommonLevel(prev, parentNext);
	      }
	      pushNode(next);
	    }
	    function switchContext(newSnapshot) {
	      var prev = currentActiveSnapshot;
	      var next = newSnapshot;
	      if (prev !== next) {
	        if (prev === null) {
	          pushAllNext(next);
	        } else if (next === null) {
	          popAllPrevious(prev);
	        } else if (prev.depth === next.depth) {
	          popToNearestCommonAncestor(prev, next);
	        } else if (prev.depth > next.depth) {
	          popPreviousToCommonLevel(prev, next);
	        } else {
	          popNextToCommonLevel(prev, next);
	        }
	        currentActiveSnapshot = next;
	      }
	    }
	    function pushProvider(context, nextValue) {
	      var prevValue;
	      {
	        prevValue = context._currentValue;
	        context._currentValue = nextValue;
	        {
	          if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
	            error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
	          }
	          context._currentRenderer = rendererSigil;
	        }
	      }
	      var prevNode = currentActiveSnapshot;
	      var newNode = {
	        parent: prevNode,
	        depth: prevNode === null ? 0 : prevNode.depth + 1,
	        context,
	        parentValue: prevValue,
	        value: nextValue
	      };
	      currentActiveSnapshot = newNode;
	      return newNode;
	    }
	    function popProvider(context) {
	      var prevSnapshot = currentActiveSnapshot;
	      if (prevSnapshot === null) {
	        throw new Error("Tried to pop a Context at the root of the app. This is a bug in React.");
	      }
	      {
	        if (prevSnapshot.context !== context) {
	          error("The parent context is not the expected context. This is probably a bug in React.");
	        }
	      }
	      {
	        var value = prevSnapshot.parentValue;
	        if (value === REACT_SERVER_CONTEXT_DEFAULT_VALUE_NOT_LOADED) {
	          prevSnapshot.context._currentValue = prevSnapshot.context._defaultValue;
	        } else {
	          prevSnapshot.context._currentValue = value;
	        }
	        {
	          if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
	            error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
	          }
	          context._currentRenderer = rendererSigil;
	        }
	      }
	      return currentActiveSnapshot = prevSnapshot.parent;
	    }
	    function getActiveContext() {
	      return currentActiveSnapshot;
	    }
	    function readContext(context) {
	      var value = context._currentValue;
	      return value;
	    }
	    function get(key) {
	      return key._reactInternals;
	    }
	    function set(key, value) {
	      key._reactInternals = value;
	    }
	    var didWarnAboutNoopUpdateForComponent = {};
	    var didWarnAboutDeprecatedWillMount = {};
	    var didWarnAboutUninitializedState;
	    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
	    var didWarnAboutLegacyLifecyclesAndDerivedState;
	    var didWarnAboutUndefinedDerivedState;
	    var warnOnUndefinedDerivedState;
	    var warnOnInvalidCallback;
	    var didWarnAboutDirectlyAssigningPropsToState;
	    var didWarnAboutContextTypeAndContextTypes;
	    var didWarnAboutInvalidateContextType;
	    {
	      didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
	      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
	      didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
	      didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
	      didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
	      didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */ new Set();
	      didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
	      var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
	      warnOnInvalidCallback = function(callback, callerName) {
	        if (callback === null || typeof callback === "function") {
	          return;
	        }
	        var key = callerName + "_" + callback;
	        if (!didWarnOnInvalidCallback.has(key)) {
	          didWarnOnInvalidCallback.add(key);
	          error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
	        }
	      };
	      warnOnUndefinedDerivedState = function(type, partialState) {
	        if (partialState === undefined) {
	          var componentName = getComponentNameFromType(type) || "Component";
	          if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
	            didWarnAboutUndefinedDerivedState.add(componentName);
	            error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
	          }
	        }
	      };
	    }
	    function warnNoop(publicInstance, callerName) {
	      {
	        var _constructor = publicInstance.constructor;
	        var componentName = _constructor && getComponentNameFromType(_constructor) || "ReactClass";
	        var warningKey = componentName + "." + callerName;
	        if (didWarnAboutNoopUpdateForComponent[warningKey]) {
	          return;
	        }
	        error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
	        didWarnAboutNoopUpdateForComponent[warningKey] = true;
	      }
	    }
	    var classComponentUpdater = {
	      isMounted: function(inst) {
	        return false;
	      },
	      enqueueSetState: function(inst, payload, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, "setState");
	        } else {
	          internals.queue.push(payload);
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, "setState");
	            }
	          }
	        }
	      },
	      enqueueReplaceState: function(inst, payload, callback) {
	        var internals = get(inst);
	        internals.replace = true;
	        internals.queue = [payload];
	        {
	          if (callback !== undefined && callback !== null) {
	            warnOnInvalidCallback(callback, "setState");
	          }
	        }
	      },
	      enqueueForceUpdate: function(inst, callback) {
	        var internals = get(inst);
	        if (internals.queue === null) {
	          warnNoop(inst, "forceUpdate");
	        } else {
	          {
	            if (callback !== undefined && callback !== null) {
	              warnOnInvalidCallback(callback, "setState");
	            }
	          }
	        }
	      }
	    };
	    function applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, prevState, nextProps) {
	      var partialState = getDerivedStateFromProps(nextProps, prevState);
	      {
	        warnOnUndefinedDerivedState(ctor, partialState);
	      }
	      var newState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
	      return newState;
	    }
	    function constructClassInstance(ctor, props, maskedLegacyContext) {
	      var context = emptyContextObject;
	      var contextType = ctor.contextType;
	      {
	        if ("contextType" in ctor) {
	          var isValid = (
	            // Allow null for conditional declaration
	            contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined
	          );
	          if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
	            didWarnAboutInvalidateContextType.add(ctor);
	            var addendum = "";
	            if (contextType === undefined) {
	              addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
	            } else if (typeof contextType !== "object") {
	              addendum = " However, it is set to a " + typeof contextType + ".";
	            } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
	              addendum = " Did you accidentally pass the Context.Provider instead?";
	            } else if (contextType._context !== undefined) {
	              addendum = " Did you accidentally pass the Context.Consumer instead?";
	            } else {
	              addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
	            }
	            error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
	          }
	        }
	      }
	      if (typeof contextType === "object" && contextType !== null) {
	        context = readContext(contextType);
	      } else {
	        context = maskedLegacyContext;
	      }
	      var instance = new ctor(props, context);
	      {
	        if (typeof ctor.getDerivedStateFromProps === "function" && (instance.state === null || instance.state === undefined)) {
	          var componentName = getComponentNameFromType(ctor) || "Component";
	          if (!didWarnAboutUninitializedState.has(componentName)) {
	            didWarnAboutUninitializedState.add(componentName);
	            error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
	          }
	        }
	        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
	          var foundWillMountName = null;
	          var foundWillReceivePropsName = null;
	          var foundWillUpdateName = null;
	          if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            foundWillMountName = "componentWillMount";
	          } else if (typeof instance.UNSAFE_componentWillMount === "function") {
	            foundWillMountName = "UNSAFE_componentWillMount";
	          }
	          if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
	            foundWillReceivePropsName = "componentWillReceiveProps";
	          } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
	            foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
	          }
	          if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
	            foundWillUpdateName = "componentWillUpdate";
	          } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
	            foundWillUpdateName = "UNSAFE_componentWillUpdate";
	          }
	          if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
	            var _componentName = getComponentNameFromType(ctor) || "Component";
	            var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
	            if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
	              didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
	              error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
	            }
	          }
	        }
	      }
	      return instance;
	    }
	    function checkClassInstance(instance, ctor, newProps) {
	      {
	        var name = getComponentNameFromType(ctor) || "Component";
	        var renderPresent = instance.render;
	        if (!renderPresent) {
	          if (ctor.prototype && typeof ctor.prototype.render === "function") {
	            error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
	          } else {
	            error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
	          }
	        }
	        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
	          error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
	        }
	        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
	          error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
	        }
	        if (instance.propTypes) {
	          error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
	        }
	        if (instance.contextType) {
	          error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
	        }
	        {
	          if (instance.contextTypes) {
	            error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
	          }
	          if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
	            didWarnAboutContextTypeAndContextTypes.add(ctor);
	            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
	          }
	        }
	        if (typeof instance.componentShouldUpdate === "function") {
	          error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
	        }
	        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
	          error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
	        }
	        if (typeof instance.componentDidUnmount === "function") {
	          error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
	        }
	        if (typeof instance.componentDidReceiveProps === "function") {
	          error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
	        }
	        if (typeof instance.componentWillRecieveProps === "function") {
	          error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
	        }
	        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
	          error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
	        }
	        var hasMutatedProps = instance.props !== newProps;
	        if (instance.props !== undefined && hasMutatedProps) {
	          error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
	        }
	        if (instance.defaultProps) {
	          error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
	        }
	        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
	          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
	          error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
	        }
	        if (typeof instance.getDerivedStateFromProps === "function") {
	          error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
	        }
	        if (typeof instance.getDerivedStateFromError === "function") {
	          error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
	        }
	        if (typeof ctor.getSnapshotBeforeUpdate === "function") {
	          error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
	        }
	        var _state = instance.state;
	        if (_state && (typeof _state !== "object" || isArray(_state))) {
	          error("%s.state: must be set to an object or null", name);
	        }
	        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
	          error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
	        }
	      }
	    }
	    function callComponentWillMount(type, instance) {
	      var oldState = instance.state;
	      if (typeof instance.componentWillMount === "function") {
	        {
	          if (instance.componentWillMount.__suppressDeprecationWarning !== true) {
	            var componentName = getComponentNameFromType(type) || "Unknown";
	            if (!didWarnAboutDeprecatedWillMount[componentName]) {
	              warn(
	                // keep this warning in sync with ReactStrictModeWarning.js
	                "componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s",
	                componentName
	              );
	              didWarnAboutDeprecatedWillMount[componentName] = true;
	            }
	          }
	        }
	        instance.componentWillMount();
	      }
	      if (typeof instance.UNSAFE_componentWillMount === "function") {
	        instance.UNSAFE_componentWillMount();
	      }
	      if (oldState !== instance.state) {
	        {
	          error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromType(type) || "Component");
	        }
	        classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
	      }
	    }
	    function processUpdateQueue(internalInstance, inst, props, maskedLegacyContext) {
	      if (internalInstance.queue !== null && internalInstance.queue.length > 0) {
	        var oldQueue = internalInstance.queue;
	        var oldReplace = internalInstance.replace;
	        internalInstance.queue = null;
	        internalInstance.replace = false;
	        if (oldReplace && oldQueue.length === 1) {
	          inst.state = oldQueue[0];
	        } else {
	          var nextState = oldReplace ? oldQueue[0] : inst.state;
	          var dontMutate = true;
	          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
	            var partial = oldQueue[i];
	            var partialState = typeof partial === "function" ? partial.call(inst, nextState, props, maskedLegacyContext) : partial;
	            if (partialState != null) {
	              if (dontMutate) {
	                dontMutate = false;
	                nextState = assign({}, nextState, partialState);
	              } else {
	                assign(nextState, partialState);
	              }
	            }
	          }
	          inst.state = nextState;
	        }
	      } else {
	        internalInstance.queue = null;
	      }
	    }
	    function mountClassInstance(instance, ctor, newProps, maskedLegacyContext) {
	      {
	        checkClassInstance(instance, ctor, newProps);
	      }
	      var initialState = instance.state !== undefined ? instance.state : null;
	      instance.updater = classComponentUpdater;
	      instance.props = newProps;
	      instance.state = initialState;
	      var internalInstance = {
	        queue: [],
	        replace: false
	      };
	      set(instance, internalInstance);
	      var contextType = ctor.contextType;
	      if (typeof contextType === "object" && contextType !== null) {
	        instance.context = readContext(contextType);
	      } else {
	        instance.context = maskedLegacyContext;
	      }
	      {
	        if (instance.state === newProps) {
	          var componentName = getComponentNameFromType(ctor) || "Component";
	          if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
	            didWarnAboutDirectlyAssigningPropsToState.add(componentName);
	            error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
	          }
	        }
	      }
	      var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
	      if (typeof getDerivedStateFromProps === "function") {
	        instance.state = applyDerivedStateFromProps(instance, ctor, getDerivedStateFromProps, initialState, newProps);
	      }
	      if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
	        callComponentWillMount(ctor, instance);
	        processUpdateQueue(internalInstance, instance, newProps, maskedLegacyContext);
	      }
	    }
	    var emptyTreeContext = {
	      id: 1,
	      overflow: ""
	    };
	    function getTreeId(context) {
	      var overflow = context.overflow;
	      var idWithLeadingBit = context.id;
	      var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
	      return id.toString(32) + overflow;
	    }
	    function pushTreeContext(baseContext, totalChildren, index) {
	      var baseIdWithLeadingBit = baseContext.id;
	      var baseOverflow = baseContext.overflow;
	      var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
	      var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
	      var slot = index + 1;
	      var length = getBitLength(totalChildren) + baseLength;
	      if (length > 30) {
	        var numberOfOverflowBits = baseLength - baseLength % 5;
	        var newOverflowBits = (1 << numberOfOverflowBits) - 1;
	        var newOverflow = (baseId & newOverflowBits).toString(32);
	        var restOfBaseId = baseId >> numberOfOverflowBits;
	        var restOfBaseLength = baseLength - numberOfOverflowBits;
	        var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
	        var restOfNewBits = slot << restOfBaseLength;
	        var id = restOfNewBits | restOfBaseId;
	        var overflow = newOverflow + baseOverflow;
	        return {
	          id: 1 << restOfLength | id,
	          overflow
	        };
	      } else {
	        var newBits = slot << baseLength;
	        var _id = newBits | baseId;
	        var _overflow = baseOverflow;
	        return {
	          id: 1 << length | _id,
	          overflow: _overflow
	        };
	      }
	    }
	    function getBitLength(number) {
	      return 32 - clz32(number);
	    }
	    function getLeadingBit(id) {
	      return 1 << getBitLength(id) - 1;
	    }
	    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
	    var log = Math.log;
	    var LN2 = Math.LN2;
	    function clz32Fallback(x) {
	      var asUint = x >>> 0;
	      if (asUint === 0) {
	        return 32;
	      }
	      return 31 - (log(asUint) / LN2 | 0) | 0;
	    }
	    function is(x, y) {
	      return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
	    }
	    var objectIs = typeof Object.is === "function" ? Object.is : is;
	    var currentlyRenderingComponent = null;
	    var currentlyRenderingTask = null;
	    var firstWorkInProgressHook = null;
	    var workInProgressHook = null;
	    var isReRender = false;
	    var didScheduleRenderPhaseUpdate = false;
	    var localIdCounter = 0;
	    var renderPhaseUpdates = null;
	    var numberOfReRenders = 0;
	    var RE_RENDER_LIMIT = 25;
	    var isInHookUserCodeInDev = false;
	    var currentHookNameInDev;
	    function resolveCurrentlyRenderingComponent() {
	      if (currentlyRenderingComponent === null) {
	        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
	      }
	      {
	        if (isInHookUserCodeInDev) {
	          error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
	        }
	      }
	      return currentlyRenderingComponent;
	    }
	    function areHookInputsEqual(nextDeps, prevDeps) {
	      if (prevDeps === null) {
	        {
	          error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
	        }
	        return false;
	      }
	      {
	        if (nextDeps.length !== prevDeps.length) {
	          error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(", ") + "]", "[" + prevDeps.join(", ") + "]");
	        }
	      }
	      for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
	        if (objectIs(nextDeps[i], prevDeps[i])) {
	          continue;
	        }
	        return false;
	      }
	      return true;
	    }
	    function createHook() {
	      if (numberOfReRenders > 0) {
	        throw new Error("Rendered more hooks than during the previous render");
	      }
	      return {
	        memoizedState: null,
	        queue: null,
	        next: null
	      };
	    }
	    function createWorkInProgressHook() {
	      if (workInProgressHook === null) {
	        if (firstWorkInProgressHook === null) {
	          isReRender = false;
	          firstWorkInProgressHook = workInProgressHook = createHook();
	        } else {
	          isReRender = true;
	          workInProgressHook = firstWorkInProgressHook;
	        }
	      } else {
	        if (workInProgressHook.next === null) {
	          isReRender = false;
	          workInProgressHook = workInProgressHook.next = createHook();
	        } else {
	          isReRender = true;
	          workInProgressHook = workInProgressHook.next;
	        }
	      }
	      return workInProgressHook;
	    }
	    function prepareToUseHooks(task, componentIdentity) {
	      currentlyRenderingComponent = componentIdentity;
	      currentlyRenderingTask = task;
	      {
	        isInHookUserCodeInDev = false;
	      }
	      localIdCounter = 0;
	    }
	    function finishHooks(Component, props, children, refOrContext) {
	      while (didScheduleRenderPhaseUpdate) {
	        didScheduleRenderPhaseUpdate = false;
	        localIdCounter = 0;
	        numberOfReRenders += 1;
	        workInProgressHook = null;
	        children = Component(props, refOrContext);
	      }
	      resetHooksState();
	      return children;
	    }
	    function checkDidRenderIdHook() {
	      var didRenderIdHook = localIdCounter !== 0;
	      return didRenderIdHook;
	    }
	    function resetHooksState() {
	      {
	        isInHookUserCodeInDev = false;
	      }
	      currentlyRenderingComponent = null;
	      currentlyRenderingTask = null;
	      didScheduleRenderPhaseUpdate = false;
	      firstWorkInProgressHook = null;
	      numberOfReRenders = 0;
	      renderPhaseUpdates = null;
	      workInProgressHook = null;
	    }
	    function readContext$1(context) {
	      {
	        if (isInHookUserCodeInDev) {
	          error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
	        }
	      }
	      return readContext(context);
	    }
	    function useContext(context) {
	      {
	        currentHookNameInDev = "useContext";
	      }
	      resolveCurrentlyRenderingComponent();
	      return readContext(context);
	    }
	    function basicStateReducer(state, action) {
	      return typeof action === "function" ? action(state) : action;
	    }
	    function useState(initialState) {
	      {
	        currentHookNameInDev = "useState";
	      }
	      return useReducer(
	        basicStateReducer,
	        // useReducer has a special case to support lazy useState initializers
	        initialState
	      );
	    }
	    function useReducer(reducer, initialArg, init) {
	      {
	        if (reducer !== basicStateReducer) {
	          currentHookNameInDev = "useReducer";
	        }
	      }
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      if (isReRender) {
	        var queue = workInProgressHook.queue;
	        var dispatch = queue.dispatch;
	        if (renderPhaseUpdates !== null) {
	          var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	          if (firstRenderPhaseUpdate !== undefined) {
	            renderPhaseUpdates.delete(queue);
	            var newState = workInProgressHook.memoizedState;
	            var update = firstRenderPhaseUpdate;
	            do {
	              var action = update.action;
	              {
	                isInHookUserCodeInDev = true;
	              }
	              newState = reducer(newState, action);
	              {
	                isInHookUserCodeInDev = false;
	              }
	              update = update.next;
	            } while (update !== null);
	            workInProgressHook.memoizedState = newState;
	            return [newState, dispatch];
	          }
	        }
	        return [workInProgressHook.memoizedState, dispatch];
	      } else {
	        {
	          isInHookUserCodeInDev = true;
	        }
	        var initialState;
	        if (reducer === basicStateReducer) {
	          initialState = typeof initialArg === "function" ? initialArg() : initialArg;
	        } else {
	          initialState = init !== undefined ? init(initialArg) : initialArg;
	        }
	        {
	          isInHookUserCodeInDev = false;
	        }
	        workInProgressHook.memoizedState = initialState;
	        var _queue = workInProgressHook.queue = {
	          last: null,
	          dispatch: null
	        };
	        var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
	        return [workInProgressHook.memoizedState, _dispatch];
	      }
	    }
	    function useMemo(nextCreate, deps) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var nextDeps = deps === undefined ? null : deps;
	      if (workInProgressHook !== null) {
	        var prevState = workInProgressHook.memoizedState;
	        if (prevState !== null) {
	          if (nextDeps !== null) {
	            var prevDeps = prevState[1];
	            if (areHookInputsEqual(nextDeps, prevDeps)) {
	              return prevState[0];
	            }
	          }
	        }
	      }
	      {
	        isInHookUserCodeInDev = true;
	      }
	      var nextValue = nextCreate();
	      {
	        isInHookUserCodeInDev = false;
	      }
	      workInProgressHook.memoizedState = [nextValue, nextDeps];
	      return nextValue;
	    }
	    function useRef(initialValue) {
	      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	      workInProgressHook = createWorkInProgressHook();
	      var previousRef = workInProgressHook.memoizedState;
	      if (previousRef === null) {
	        var ref = {
	          current: initialValue
	        };
	        {
	          Object.seal(ref);
	        }
	        workInProgressHook.memoizedState = ref;
	        return ref;
	      } else {
	        return previousRef;
	      }
	    }
	    function useLayoutEffect(create, inputs) {
	      {
	        currentHookNameInDev = "useLayoutEffect";
	        error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
	      }
	    }
	    function dispatchAction(componentIdentity, queue, action) {
	      if (numberOfReRenders >= RE_RENDER_LIMIT) {
	        throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
	      }
	      if (componentIdentity === currentlyRenderingComponent) {
	        didScheduleRenderPhaseUpdate = true;
	        var update = {
	          action,
	          next: null
	        };
	        if (renderPhaseUpdates === null) {
	          renderPhaseUpdates = /* @__PURE__ */ new Map();
	        }
	        var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	        if (firstRenderPhaseUpdate === undefined) {
	          renderPhaseUpdates.set(queue, update);
	        } else {
	          var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
	          while (lastRenderPhaseUpdate.next !== null) {
	            lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
	          }
	          lastRenderPhaseUpdate.next = update;
	        }
	      }
	    }
	    function useCallback(callback, deps) {
	      return useMemo(function() {
	        return callback;
	      }, deps);
	    }
	    function useMutableSource(source, getSnapshot, subscribe) {
	      resolveCurrentlyRenderingComponent();
	      return getSnapshot(source._source);
	    }
	    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
	      if (getServerSnapshot === undefined) {
	        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
	      }
	      return getServerSnapshot();
	    }
	    function useDeferredValue(value) {
	      resolveCurrentlyRenderingComponent();
	      return value;
	    }
	    function unsupportedStartTransition() {
	      throw new Error("startTransition cannot be called during server rendering.");
	    }
	    function useTransition() {
	      resolveCurrentlyRenderingComponent();
	      return [false, unsupportedStartTransition];
	    }
	    function useId() {
	      var task = currentlyRenderingTask;
	      var treeId = getTreeId(task.treeContext);
	      var responseState = currentResponseState;
	      if (responseState === null) {
	        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component.");
	      }
	      var localId = localIdCounter++;
	      return makeId(responseState, treeId, localId);
	    }
	    function noop() {
	    }
	    var Dispatcher = {
	      readContext: readContext$1,
	      useContext,
	      useMemo,
	      useReducer,
	      useRef,
	      useState,
	      useInsertionEffect: noop,
	      useLayoutEffect,
	      useCallback,
	      // useImperativeHandle is not run in the server environment
	      useImperativeHandle: noop,
	      // Effects are not run in the server environment.
	      useEffect: noop,
	      // Debugging effect
	      useDebugValue: noop,
	      useDeferredValue,
	      useTransition,
	      useId,
	      // Subscriptions are not setup in a server environment.
	      useMutableSource,
	      useSyncExternalStore
	    };
	    var currentResponseState = null;
	    function setCurrentResponseState(responseState) {
	      currentResponseState = responseState;
	    }
	    function getStackByComponentStackNode(componentStack) {
	      try {
	        var info = "";
	        var node = componentStack;
	        do {
	          switch (node.tag) {
	            case 0:
	              info += describeBuiltInComponentFrame(node.type, null, null);
	              break;
	            case 1:
	              info += describeFunctionComponentFrame(node.type, null, null);
	              break;
	            case 2:
	              info += describeClassComponentFrame(node.type, null, null);
	              break;
	          }
	          node = node.parent;
	        } while (node);
	        return info;
	      } catch (x) {
	        return "\nError generating stack: " + x.message + "\n" + x.stack;
	      }
	    }
	    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
	    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
	    var PENDING = 0;
	    var COMPLETED = 1;
	    var FLUSHED = 2;
	    var ABORTED = 3;
	    var ERRORED = 4;
	    var OPEN = 0;
	    var CLOSING = 1;
	    var CLOSED = 2;
	    var DEFAULT_PROGRESSIVE_CHUNK_SIZE = 12800;
	    function defaultErrorHandler(error2) {
	      console["error"](error2);
	      return null;
	    }
	    function noop$1() {
	    }
	    function createRequest(children, responseState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError) {
	      var pingedTasks = [];
	      var abortSet = /* @__PURE__ */ new Set();
	      var request = {
	        destination: null,
	        responseState,
	        progressiveChunkSize: progressiveChunkSize === undefined ? DEFAULT_PROGRESSIVE_CHUNK_SIZE : progressiveChunkSize,
	        status: OPEN,
	        fatalError: null,
	        nextSegmentId: 0,
	        allPendingTasks: 0,
	        pendingRootTasks: 0,
	        completedRootSegment: null,
	        abortableTasks: abortSet,
	        pingedTasks,
	        clientRenderedBoundaries: [],
	        completedBoundaries: [],
	        partialBoundaries: [],
	        onError: onError === undefined ? defaultErrorHandler : onError,
	        onAllReady: onAllReady === undefined ? noop$1 : onAllReady,
	        onShellReady: onShellReady === undefined ? noop$1 : onShellReady,
	        onShellError: onShellError === undefined ? noop$1 : onShellError,
	        onFatalError: onFatalError === undefined ? noop$1 : onFatalError
	      };
	      var rootSegment = createPendingSegment(
	        request,
	        0,
	        null,
	        rootFormatContext,
	        // Root segments are never embedded in Text on either edge
	        false,
	        false
	      );
	      rootSegment.parentFlushed = true;
	      var rootTask = createTask(request, children, null, rootSegment, abortSet, emptyContextObject, rootContextSnapshot, emptyTreeContext);
	      pingedTasks.push(rootTask);
	      return request;
	    }
	    function pingTask(request, task) {
	      var pingedTasks = request.pingedTasks;
	      pingedTasks.push(task);
	      if (pingedTasks.length === 1) {
	        scheduleWork(function() {
	          return performWork(request);
	        });
	      }
	    }
	    function createSuspenseBoundary(request, fallbackAbortableTasks) {
	      return {
	        id: UNINITIALIZED_SUSPENSE_BOUNDARY_ID,
	        rootSegmentID: -1,
	        parentFlushed: false,
	        pendingTasks: 0,
	        forceClientRender: false,
	        completedSegments: [],
	        byteSize: 0,
	        fallbackAbortableTasks,
	        errorDigest: null
	      };
	    }
	    function createTask(request, node, blockedBoundary, blockedSegment, abortSet, legacyContext, context, treeContext) {
	      request.allPendingTasks++;
	      if (blockedBoundary === null) {
	        request.pendingRootTasks++;
	      } else {
	        blockedBoundary.pendingTasks++;
	      }
	      var task = {
	        node,
	        ping: function() {
	          return pingTask(request, task);
	        },
	        blockedBoundary,
	        blockedSegment,
	        abortSet,
	        legacyContext,
	        context,
	        treeContext
	      };
	      {
	        task.componentStack = null;
	      }
	      abortSet.add(task);
	      return task;
	    }
	    function createPendingSegment(request, index, boundary, formatContext, lastPushedText, textEmbedded) {
	      return {
	        status: PENDING,
	        id: -1,
	        // lazily assigned later
	        index,
	        parentFlushed: false,
	        chunks: [],
	        children: [],
	        formatContext,
	        boundary,
	        lastPushedText,
	        textEmbedded
	      };
	    }
	    var currentTaskInDEV = null;
	    function getCurrentStackInDEV() {
	      {
	        if (currentTaskInDEV === null || currentTaskInDEV.componentStack === null) {
	          return "";
	        }
	        return getStackByComponentStackNode(currentTaskInDEV.componentStack);
	      }
	    }
	    function pushBuiltInComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 0,
	          parent: task.componentStack,
	          type
	        };
	      }
	    }
	    function pushFunctionComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 1,
	          parent: task.componentStack,
	          type
	        };
	      }
	    }
	    function pushClassComponentStackInDEV(task, type) {
	      {
	        task.componentStack = {
	          tag: 2,
	          parent: task.componentStack,
	          type
	        };
	      }
	    }
	    function popComponentStackInDEV(task) {
	      {
	        if (task.componentStack === null) {
	          error("Unexpectedly popped too many stack frames. This is a bug in React.");
	        } else {
	          task.componentStack = task.componentStack.parent;
	        }
	      }
	    }
	    var lastBoundaryErrorComponentStackDev = null;
	    function captureBoundaryErrorDetailsDev(boundary, error2) {
	      {
	        var errorMessage;
	        if (typeof error2 === "string") {
	          errorMessage = error2;
	        } else if (error2 && typeof error2.message === "string") {
	          errorMessage = error2.message;
	        } else {
	          errorMessage = String(error2);
	        }
	        var errorComponentStack = lastBoundaryErrorComponentStackDev || getCurrentStackInDEV();
	        lastBoundaryErrorComponentStackDev = null;
	        boundary.errorMessage = errorMessage;
	        boundary.errorComponentStack = errorComponentStack;
	      }
	    }
	    function logRecoverableError(request, error2) {
	      var errorDigest = request.onError(error2);
	      if (errorDigest != null && typeof errorDigest !== "string") {
	        throw new Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
	      }
	      return errorDigest;
	    }
	    function fatalError(request, error2) {
	      var onShellError = request.onShellError;
	      onShellError(error2);
	      var onFatalError = request.onFatalError;
	      onFatalError(error2);
	      if (request.destination !== null) {
	        request.status = CLOSED;
	        closeWithError(request.destination, error2);
	      } else {
	        request.status = CLOSING;
	        request.fatalError = error2;
	      }
	    }
	    function renderSuspenseBoundary(request, task, props) {
	      pushBuiltInComponentStackInDEV(task, "Suspense");
	      var parentBoundary = task.blockedBoundary;
	      var parentSegment = task.blockedSegment;
	      var fallback = props.fallback;
	      var content = props.children;
	      var fallbackAbortSet = /* @__PURE__ */ new Set();
	      var newBoundary = createSuspenseBoundary(request, fallbackAbortSet);
	      var insertionIndex = parentSegment.chunks.length;
	      var boundarySegment = createPendingSegment(
	        request,
	        insertionIndex,
	        newBoundary,
	        parentSegment.formatContext,
	        // boundaries never require text embedding at their edges because comment nodes bound them
	        false,
	        false
	      );
	      parentSegment.children.push(boundarySegment);
	      parentSegment.lastPushedText = false;
	      var contentRootSegment = createPendingSegment(
	        request,
	        0,
	        null,
	        parentSegment.formatContext,
	        // boundaries never require text embedding at their edges because comment nodes bound them
	        false,
	        false
	      );
	      contentRootSegment.parentFlushed = true;
	      task.blockedBoundary = newBoundary;
	      task.blockedSegment = contentRootSegment;
	      try {
	        renderNode(request, task, content);
	        pushSegmentFinale(contentRootSegment.chunks, request.responseState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded);
	        contentRootSegment.status = COMPLETED;
	        queueCompletedSegment(newBoundary, contentRootSegment);
	        if (newBoundary.pendingTasks === 0) {
	          popComponentStackInDEV(task);
	          return;
	        }
	      } catch (error2) {
	        contentRootSegment.status = ERRORED;
	        newBoundary.forceClientRender = true;
	        newBoundary.errorDigest = logRecoverableError(request, error2);
	        {
	          captureBoundaryErrorDetailsDev(newBoundary, error2);
	        }
	      } finally {
	        task.blockedBoundary = parentBoundary;
	        task.blockedSegment = parentSegment;
	      }
	      var suspendedFallbackTask = createTask(request, fallback, parentBoundary, boundarySegment, fallbackAbortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        suspendedFallbackTask.componentStack = task.componentStack;
	      }
	      request.pingedTasks.push(suspendedFallbackTask);
	      popComponentStackInDEV(task);
	    }
	    function renderHostElement(request, task, type, props) {
	      pushBuiltInComponentStackInDEV(task, type);
	      var segment = task.blockedSegment;
	      var children = pushStartInstance(segment.chunks, type, props, request.responseState, segment.formatContext);
	      segment.lastPushedText = false;
	      var prevContext = segment.formatContext;
	      segment.formatContext = getChildFormatContext(prevContext, type, props);
	      renderNode(request, task, children);
	      segment.formatContext = prevContext;
	      pushEndInstance(segment.chunks, type);
	      segment.lastPushedText = false;
	      popComponentStackInDEV(task);
	    }
	    function shouldConstruct$1(Component) {
	      return Component.prototype && Component.prototype.isReactComponent;
	    }
	    function renderWithHooks(request, task, Component, props, secondArg) {
	      var componentIdentity = {};
	      prepareToUseHooks(task, componentIdentity);
	      var result = Component(props, secondArg);
	      return finishHooks(Component, props, result, secondArg);
	    }
	    function finishClassComponent(request, task, instance, Component, props) {
	      var nextChildren = instance.render();
	      {
	        if (instance.props !== props) {
	          if (!didWarnAboutReassigningProps) {
	            error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromType(Component) || "a component");
	          }
	          didWarnAboutReassigningProps = true;
	        }
	      }
	      {
	        var childContextTypes = Component.childContextTypes;
	        if (childContextTypes !== null && childContextTypes !== undefined) {
	          var previousContext = task.legacyContext;
	          var mergedContext = processChildContext(instance, Component, previousContext, childContextTypes);
	          task.legacyContext = mergedContext;
	          renderNodeDestructive(request, task, nextChildren);
	          task.legacyContext = previousContext;
	          return;
	        }
	      }
	      renderNodeDestructive(request, task, nextChildren);
	    }
	    function renderClassComponent(request, task, Component, props) {
	      pushClassComponentStackInDEV(task, Component);
	      var maskedContext = getMaskedContext(Component, task.legacyContext);
	      var instance = constructClassInstance(Component, props, maskedContext);
	      mountClassInstance(instance, Component, props, maskedContext);
	      finishClassComponent(request, task, instance, Component, props);
	      popComponentStackInDEV(task);
	    }
	    var didWarnAboutBadClass = {};
	    var didWarnAboutModulePatternComponent = {};
	    var didWarnAboutContextTypeOnFunctionComponent = {};
	    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
	    var didWarnAboutReassigningProps = false;
	    var didWarnAboutDefaultPropsOnFunctionComponent = {};
	    var didWarnAboutGenerators = false;
	    var didWarnAboutMaps = false;
	    var hasWarnedAboutUsingContextAsConsumer = false;
	    function renderIndeterminateComponent(request, task, Component, props) {
	      var legacyContext;
	      {
	        legacyContext = getMaskedContext(Component, task.legacyContext);
	      }
	      pushFunctionComponentStackInDEV(task, Component);
	      {
	        if (Component.prototype && typeof Component.prototype.render === "function") {
	          var componentName = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutBadClass[componentName]) {
	            error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
	            didWarnAboutBadClass[componentName] = true;
	          }
	        }
	      }
	      var value = renderWithHooks(request, task, Component, props, legacyContext);
	      var hasId = checkDidRenderIdHook();
	      {
	        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
	          var _componentName = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutModulePatternComponent[_componentName]) {
	            error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
	            didWarnAboutModulePatternComponent[_componentName] = true;
	          }
	        }
	      }
	      if (
	        // Run these checks in production only if the flag is off.
	        // Eventually we'll delete this branch altogether.
	        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined
	      ) {
	        {
	          var _componentName2 = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutModulePatternComponent[_componentName2]) {
	            error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
	            didWarnAboutModulePatternComponent[_componentName2] = true;
	          }
	        }
	        mountClassInstance(value, Component, props, legacyContext);
	        finishClassComponent(request, task, value, Component, props);
	      } else {
	        {
	          validateFunctionComponentInDev(Component);
	        }
	        if (hasId) {
	          var prevTreeContext = task.treeContext;
	          var totalChildren = 1;
	          var index = 0;
	          task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	          try {
	            renderNodeDestructive(request, task, value);
	          } finally {
	            task.treeContext = prevTreeContext;
	          }
	        } else {
	          renderNodeDestructive(request, task, value);
	        }
	      }
	      popComponentStackInDEV(task);
	    }
	    function validateFunctionComponentInDev(Component) {
	      {
	        if (Component) {
	          if (Component.childContextTypes) {
	            error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
	          }
	        }
	        if (Component.defaultProps !== undefined) {
	          var componentName = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
	            error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
	            didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
	          }
	        }
	        if (typeof Component.getDerivedStateFromProps === "function") {
	          var _componentName3 = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
	            error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
	            didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
	          }
	        }
	        if (typeof Component.contextType === "object" && Component.contextType !== null) {
	          var _componentName4 = getComponentNameFromType(Component) || "Unknown";
	          if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
	            error("%s: Function components do not support contextType.", _componentName4);
	            didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
	          }
	        }
	      }
	    }
	    function resolveDefaultProps(Component, baseProps) {
	      if (Component && Component.defaultProps) {
	        var props = assign({}, baseProps);
	        var defaultProps = Component.defaultProps;
	        for (var propName in defaultProps) {
	          if (props[propName] === undefined) {
	            props[propName] = defaultProps[propName];
	          }
	        }
	        return props;
	      }
	      return baseProps;
	    }
	    function renderForwardRef(request, task, type, props, ref) {
	      pushFunctionComponentStackInDEV(task, type.render);
	      var children = renderWithHooks(request, task, type.render, props, ref);
	      var hasId = checkDidRenderIdHook();
	      if (hasId) {
	        var prevTreeContext = task.treeContext;
	        var totalChildren = 1;
	        var index = 0;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, index);
	        try {
	          renderNodeDestructive(request, task, children);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      } else {
	        renderNodeDestructive(request, task, children);
	      }
	      popComponentStackInDEV(task);
	    }
	    function renderMemo(request, task, type, props, ref) {
	      var innerType = type.type;
	      var resolvedProps = resolveDefaultProps(innerType, props);
	      renderElement(request, task, innerType, resolvedProps, ref);
	    }
	    function renderContextConsumer(request, task, context, props) {
	      {
	        if (context._context === undefined) {
	          if (context !== context.Consumer) {
	            if (!hasWarnedAboutUsingContextAsConsumer) {
	              hasWarnedAboutUsingContextAsConsumer = true;
	              error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
	            }
	          }
	        } else {
	          context = context._context;
	        }
	      }
	      var render = props.children;
	      {
	        if (typeof render !== "function") {
	          error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
	        }
	      }
	      var newValue = readContext(context);
	      var newChildren = render(newValue);
	      renderNodeDestructive(request, task, newChildren);
	    }
	    function renderContextProvider(request, task, type, props) {
	      var context = type._context;
	      var value = props.value;
	      var children = props.children;
	      var prevSnapshot;
	      {
	        prevSnapshot = task.context;
	      }
	      task.context = pushProvider(context, value);
	      renderNodeDestructive(request, task, children);
	      task.context = popProvider(context);
	      {
	        if (prevSnapshot !== task.context) {
	          error("Popping the context provider did not return back to the original snapshot. This is a bug in React.");
	        }
	      }
	    }
	    function renderLazyComponent(request, task, lazyComponent, props, ref) {
	      pushBuiltInComponentStackInDEV(task, "Lazy");
	      var payload = lazyComponent._payload;
	      var init = lazyComponent._init;
	      var Component = init(payload);
	      var resolvedProps = resolveDefaultProps(Component, props);
	      renderElement(request, task, Component, resolvedProps, ref);
	      popComponentStackInDEV(task);
	    }
	    function renderElement(request, task, type, props, ref) {
	      if (typeof type === "function") {
	        if (shouldConstruct$1(type)) {
	          renderClassComponent(request, task, type, props);
	          return;
	        } else {
	          renderIndeterminateComponent(request, task, type, props);
	          return;
	        }
	      }
	      if (typeof type === "string") {
	        renderHostElement(request, task, type, props);
	        return;
	      }
	      switch (type) {
	        case REACT_LEGACY_HIDDEN_TYPE:
	        case REACT_DEBUG_TRACING_MODE_TYPE:
	        case REACT_STRICT_MODE_TYPE:
	        case REACT_PROFILER_TYPE:
	        case REACT_FRAGMENT_TYPE: {
	          renderNodeDestructive(request, task, props.children);
	          return;
	        }
	        case REACT_SUSPENSE_LIST_TYPE: {
	          pushBuiltInComponentStackInDEV(task, "SuspenseList");
	          renderNodeDestructive(request, task, props.children);
	          popComponentStackInDEV(task);
	          return;
	        }
	        case REACT_SCOPE_TYPE: {
	          throw new Error("ReactDOMServer does not yet support scope components.");
	        }
	        case REACT_SUSPENSE_TYPE: {
	          {
	            renderSuspenseBoundary(request, task, props);
	          }
	          return;
	        }
	      }
	      if (typeof type === "object" && type !== null) {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE: {
	            renderForwardRef(request, task, type, props, ref);
	            return;
	          }
	          case REACT_MEMO_TYPE: {
	            renderMemo(request, task, type, props, ref);
	            return;
	          }
	          case REACT_PROVIDER_TYPE: {
	            renderContextProvider(request, task, type, props);
	            return;
	          }
	          case REACT_CONTEXT_TYPE: {
	            renderContextConsumer(request, task, type, props);
	            return;
	          }
	          case REACT_LAZY_TYPE: {
	            renderLazyComponent(request, task, type, props);
	            return;
	          }
	        }
	      }
	      var info = "";
	      {
	        if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
	          info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
	        }
	      }
	      throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
	    }
	    function validateIterable(iterable, iteratorFn) {
	      {
	        if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
	        iterable[Symbol.toStringTag] === "Generator") {
	          if (!didWarnAboutGenerators) {
	            error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
	          }
	          didWarnAboutGenerators = true;
	        }
	        if (iterable.entries === iteratorFn) {
	          if (!didWarnAboutMaps) {
	            error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
	          }
	          didWarnAboutMaps = true;
	        }
	      }
	    }
	    function renderNodeDestructive(request, task, node) {
	      {
	        try {
	          return renderNodeDestructiveImpl(request, task, node);
	        } catch (x) {
	          if (typeof x === "object" && x !== null && typeof x.then === "function") ;
	          else {
	            lastBoundaryErrorComponentStackDev = lastBoundaryErrorComponentStackDev !== null ? lastBoundaryErrorComponentStackDev : getCurrentStackInDEV();
	          }
	          throw x;
	        }
	      }
	    }
	    function renderNodeDestructiveImpl(request, task, node) {
	      task.node = node;
	      if (typeof node === "object" && node !== null) {
	        switch (node.$$typeof) {
	          case REACT_ELEMENT_TYPE: {
	            var element = node;
	            var type = element.type;
	            var props = element.props;
	            var ref = element.ref;
	            renderElement(request, task, type, props, ref);
	            return;
	          }
	          case REACT_PORTAL_TYPE:
	            throw new Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
	          case REACT_LAZY_TYPE: {
	            var lazyNode = node;
	            var payload = lazyNode._payload;
	            var init = lazyNode._init;
	            var resolvedNode;
	            {
	              try {
	                resolvedNode = init(payload);
	              } catch (x) {
	                if (typeof x === "object" && x !== null && typeof x.then === "function") {
	                  pushBuiltInComponentStackInDEV(task, "Lazy");
	                }
	                throw x;
	              }
	            }
	            renderNodeDestructive(request, task, resolvedNode);
	            return;
	          }
	        }
	        if (isArray(node)) {
	          renderChildrenArray(request, task, node);
	          return;
	        }
	        var iteratorFn = getIteratorFn(node);
	        if (iteratorFn) {
	          {
	            validateIterable(node, iteratorFn);
	          }
	          var iterator = iteratorFn.call(node);
	          if (iterator) {
	            var step = iterator.next();
	            if (!step.done) {
	              var children = [];
	              do {
	                children.push(step.value);
	                step = iterator.next();
	              } while (!step.done);
	              renderChildrenArray(request, task, children);
	              return;
	            }
	            return;
	          }
	        }
	        var childString = Object.prototype.toString.call(node);
	        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(node).join(", ") + "}" : childString) + "). If you meant to render a collection of children, use an array instead.");
	      }
	      if (typeof node === "string") {
	        var segment = task.blockedSegment;
	        segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, node, request.responseState, segment.lastPushedText);
	        return;
	      }
	      if (typeof node === "number") {
	        var _segment = task.blockedSegment;
	        _segment.lastPushedText = pushTextInstance(task.blockedSegment.chunks, "" + node, request.responseState, _segment.lastPushedText);
	        return;
	      }
	      {
	        if (typeof node === "function") {
	          error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
	        }
	      }
	    }
	    function renderChildrenArray(request, task, children) {
	      var totalChildren = children.length;
	      for (var i = 0; i < totalChildren; i++) {
	        var prevTreeContext = task.treeContext;
	        task.treeContext = pushTreeContext(prevTreeContext, totalChildren, i);
	        try {
	          renderNode(request, task, children[i]);
	        } finally {
	          task.treeContext = prevTreeContext;
	        }
	      }
	    }
	    function spawnNewSuspendedTask(request, task, x) {
	      var segment = task.blockedSegment;
	      var insertionIndex = segment.chunks.length;
	      var newSegment = createPendingSegment(
	        request,
	        insertionIndex,
	        null,
	        segment.formatContext,
	        // Adopt the parent segment's leading text embed
	        segment.lastPushedText,
	        // Assume we are text embedded at the trailing edge
	        true
	      );
	      segment.children.push(newSegment);
	      segment.lastPushedText = false;
	      var newTask = createTask(request, task.node, task.blockedBoundary, newSegment, task.abortSet, task.legacyContext, task.context, task.treeContext);
	      {
	        if (task.componentStack !== null) {
	          newTask.componentStack = task.componentStack.parent;
	        }
	      }
	      var ping = newTask.ping;
	      x.then(ping, ping);
	    }
	    function renderNode(request, task, node) {
	      var previousFormatContext = task.blockedSegment.formatContext;
	      var previousLegacyContext = task.legacyContext;
	      var previousContext = task.context;
	      var previousComponentStack = null;
	      {
	        previousComponentStack = task.componentStack;
	      }
	      try {
	        return renderNodeDestructive(request, task, node);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === "object" && x !== null && typeof x.then === "function") {
	          spawnNewSuspendedTask(request, task, x);
	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext;
	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          }
	          return;
	        } else {
	          task.blockedSegment.formatContext = previousFormatContext;
	          task.legacyContext = previousLegacyContext;
	          task.context = previousContext;
	          switchContext(previousContext);
	          {
	            task.componentStack = previousComponentStack;
	          }
	          throw x;
	        }
	      }
	    }
	    function erroredTask(request, boundary, segment, error2) {
	      var errorDigest = logRecoverableError(request, error2);
	      if (boundary === null) {
	        fatalError(request, error2);
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          boundary.errorDigest = errorDigest;
	          {
	            captureBoundaryErrorDetailsDev(boundary, error2);
	          }
	          if (boundary.parentFlushed) {
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function abortTaskSoft(task) {
	      var request = this;
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      finishedTask(request, boundary, segment);
	    }
	    function abortTask(task, request, reason) {
	      var boundary = task.blockedBoundary;
	      var segment = task.blockedSegment;
	      segment.status = ABORTED;
	      if (boundary === null) {
	        request.allPendingTasks--;
	        if (request.status !== CLOSED) {
	          request.status = CLOSED;
	          if (request.destination !== null) {
	            close(request.destination);
	          }
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (!boundary.forceClientRender) {
	          boundary.forceClientRender = true;
	          var _error = reason === undefined ? new Error("The render was aborted by the server without a reason.") : reason;
	          boundary.errorDigest = request.onError(_error);
	          {
	            var errorPrefix = "The server did not finish this Suspense boundary: ";
	            if (_error && typeof _error.message === "string") {
	              _error = errorPrefix + _error.message;
	            } else {
	              _error = errorPrefix + String(_error);
	            }
	            var previousTaskInDev = currentTaskInDEV;
	            currentTaskInDEV = task;
	            try {
	              captureBoundaryErrorDetailsDev(boundary, _error);
	            } finally {
	              currentTaskInDEV = previousTaskInDev;
	            }
	          }
	          if (boundary.parentFlushed) {
	            request.clientRenderedBoundaries.push(boundary);
	          }
	        }
	        boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
	          return abortTask(fallbackTask, request, reason);
	        });
	        boundary.fallbackAbortableTasks.clear();
	        request.allPendingTasks--;
	        if (request.allPendingTasks === 0) {
	          var onAllReady = request.onAllReady;
	          onAllReady();
	        }
	      }
	    }
	    function queueCompletedSegment(boundary, segment) {
	      if (segment.chunks.length === 0 && segment.children.length === 1 && segment.children[0].boundary === null) {
	        var childSegment = segment.children[0];
	        childSegment.id = segment.id;
	        childSegment.parentFlushed = true;
	        if (childSegment.status === COMPLETED) {
	          queueCompletedSegment(boundary, childSegment);
	        }
	      } else {
	        var completedSegments = boundary.completedSegments;
	        completedSegments.push(segment);
	      }
	    }
	    function finishedTask(request, boundary, segment) {
	      if (boundary === null) {
	        if (segment.parentFlushed) {
	          if (request.completedRootSegment !== null) {
	            throw new Error("There can only be one root segment. This is a bug in React.");
	          }
	          request.completedRootSegment = segment;
	        }
	        request.pendingRootTasks--;
	        if (request.pendingRootTasks === 0) {
	          request.onShellError = noop$1;
	          var onShellReady = request.onShellReady;
	          onShellReady();
	        }
	      } else {
	        boundary.pendingTasks--;
	        if (boundary.forceClientRender) ;
	        else if (boundary.pendingTasks === 0) {
	          if (segment.parentFlushed) {
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	            }
	          }
	          if (boundary.parentFlushed) {
	            request.completedBoundaries.push(boundary);
	          }
	          boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request);
	          boundary.fallbackAbortableTasks.clear();
	        } else {
	          if (segment.parentFlushed) {
	            if (segment.status === COMPLETED) {
	              queueCompletedSegment(boundary, segment);
	              var completedSegments = boundary.completedSegments;
	              if (completedSegments.length === 1) {
	                if (boundary.parentFlushed) {
	                  request.partialBoundaries.push(boundary);
	                }
	              }
	            }
	          }
	        }
	      }
	      request.allPendingTasks--;
	      if (request.allPendingTasks === 0) {
	        var onAllReady = request.onAllReady;
	        onAllReady();
	      }
	    }
	    function retryTask(request, task) {
	      var segment = task.blockedSegment;
	      if (segment.status !== PENDING) {
	        return;
	      }
	      switchContext(task.context);
	      var prevTaskInDEV = null;
	      {
	        prevTaskInDEV = currentTaskInDEV;
	        currentTaskInDEV = task;
	      }
	      try {
	        renderNodeDestructive(request, task, task.node);
	        pushSegmentFinale(segment.chunks, request.responseState, segment.lastPushedText, segment.textEmbedded);
	        task.abortSet.delete(task);
	        segment.status = COMPLETED;
	        finishedTask(request, task.blockedBoundary, segment);
	      } catch (x) {
	        resetHooksState();
	        if (typeof x === "object" && x !== null && typeof x.then === "function") {
	          var ping = task.ping;
	          x.then(ping, ping);
	        } else {
	          task.abortSet.delete(task);
	          segment.status = ERRORED;
	          erroredTask(request, task.blockedBoundary, segment, x);
	        }
	      } finally {
	        {
	          currentTaskInDEV = prevTaskInDEV;
	        }
	      }
	    }
	    function performWork(request) {
	      if (request.status === CLOSED) {
	        return;
	      }
	      var prevContext = getActiveContext();
	      var prevDispatcher = ReactCurrentDispatcher$1.current;
	      ReactCurrentDispatcher$1.current = Dispatcher;
	      var prevGetCurrentStackImpl;
	      {
	        prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
	        ReactDebugCurrentFrame$1.getCurrentStack = getCurrentStackInDEV;
	      }
	      var prevResponseState = currentResponseState;
	      setCurrentResponseState(request.responseState);
	      try {
	        var pingedTasks = request.pingedTasks;
	        var i;
	        for (i = 0; i < pingedTasks.length; i++) {
	          var task = pingedTasks[i];
	          retryTask(request, task);
	        }
	        pingedTasks.splice(0, i);
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error2) {
	        logRecoverableError(request, error2);
	        fatalError(request, error2);
	      } finally {
	        setCurrentResponseState(prevResponseState);
	        ReactCurrentDispatcher$1.current = prevDispatcher;
	        {
	          ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
	        }
	        if (prevDispatcher === Dispatcher) {
	          switchContext(prevContext);
	        }
	      }
	    }
	    function flushSubtree(request, destination, segment) {
	      segment.parentFlushed = true;
	      switch (segment.status) {
	        case PENDING: {
	          var segmentID = segment.id = request.nextSegmentId++;
	          segment.lastPushedText = false;
	          segment.textEmbedded = false;
	          return writePlaceholder(destination, request.responseState, segmentID);
	        }
	        case COMPLETED: {
	          segment.status = FLUSHED;
	          var r = true;
	          var chunks = segment.chunks;
	          var chunkIdx = 0;
	          var children = segment.children;
	          for (var childIdx = 0; childIdx < children.length; childIdx++) {
	            var nextChild = children[childIdx];
	            for (; chunkIdx < nextChild.index; chunkIdx++) {
	              writeChunk(destination, chunks[chunkIdx]);
	            }
	            r = flushSegment(request, destination, nextChild);
	          }
	          for (; chunkIdx < chunks.length - 1; chunkIdx++) {
	            writeChunk(destination, chunks[chunkIdx]);
	          }
	          if (chunkIdx < chunks.length) {
	            r = writeChunkAndReturn(destination, chunks[chunkIdx]);
	          }
	          return r;
	        }
	        default: {
	          throw new Error("Aborted, errored or already flushed boundaries should not be flushed again. This is a bug in React.");
	        }
	      }
	    }
	    function flushSegment(request, destination, segment) {
	      var boundary = segment.boundary;
	      if (boundary === null) {
	        return flushSubtree(request, destination, segment);
	      }
	      boundary.parentFlushed = true;
	      if (boundary.forceClientRender) {
	        writeStartClientRenderedSuspenseBoundary(destination, request.responseState, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
	        flushSubtree(request, destination, segment);
	        return writeEndClientRenderedSuspenseBoundary(destination, request.responseState);
	      } else if (boundary.pendingTasks > 0) {
	        boundary.rootSegmentID = request.nextSegmentId++;
	        if (boundary.completedSegments.length > 0) {
	          request.partialBoundaries.push(boundary);
	        }
	        var id = boundary.id = assignSuspenseBoundaryID(request.responseState);
	        writeStartPendingSuspenseBoundary(destination, request.responseState, id);
	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else if (boundary.byteSize > request.progressiveChunkSize) {
	        boundary.rootSegmentID = request.nextSegmentId++;
	        request.completedBoundaries.push(boundary);
	        writeStartPendingSuspenseBoundary(destination, request.responseState, boundary.id);
	        flushSubtree(request, destination, segment);
	        return writeEndPendingSuspenseBoundary(destination, request.responseState);
	      } else {
	        writeStartCompletedSuspenseBoundary(destination, request.responseState);
	        var completedSegments = boundary.completedSegments;
	        if (completedSegments.length !== 1) {
	          throw new Error("A previously unvisited boundary must have exactly one root segment. This is a bug in React.");
	        }
	        var contentSegment = completedSegments[0];
	        flushSegment(request, destination, contentSegment);
	        return writeEndCompletedSuspenseBoundary(destination, request.responseState);
	      }
	    }
	    function flushClientRenderedBoundary(request, destination, boundary) {
	      return writeClientRenderBoundaryInstruction(destination, request.responseState, boundary.id, boundary.errorDigest, boundary.errorMessage, boundary.errorComponentStack);
	    }
	    function flushSegmentContainer(request, destination, segment) {
	      writeStartSegment(destination, request.responseState, segment.formatContext, segment.id);
	      flushSegment(request, destination, segment);
	      return writeEndSegment(destination, segment.formatContext);
	    }
	    function flushCompletedBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        flushPartiallyCompletedSegment(request, destination, boundary, segment);
	      }
	      completedSegments.length = 0;
	      return writeCompletedBoundaryInstruction(destination, request.responseState, boundary.id, boundary.rootSegmentID);
	    }
	    function flushPartialBoundary(request, destination, boundary) {
	      var completedSegments = boundary.completedSegments;
	      var i = 0;
	      for (; i < completedSegments.length; i++) {
	        var segment = completedSegments[i];
	        if (!flushPartiallyCompletedSegment(request, destination, boundary, segment)) {
	          i++;
	          completedSegments.splice(0, i);
	          return false;
	        }
	      }
	      completedSegments.splice(0, i);
	      return true;
	    }
	    function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
	      if (segment.status === FLUSHED) {
	        return true;
	      }
	      var segmentID = segment.id;
	      if (segmentID === -1) {
	        var rootSegmentID = segment.id = boundary.rootSegmentID;
	        if (rootSegmentID === -1) {
	          throw new Error("A root segment ID must have been assigned by now. This is a bug in React.");
	        }
	        return flushSegmentContainer(request, destination, segment);
	      } else {
	        flushSegmentContainer(request, destination, segment);
	        return writeCompletedSegmentInstruction(destination, request.responseState, segmentID);
	      }
	    }
	    function flushCompletedQueues(request, destination) {
	      beginWriting();
	      try {
	        var completedRootSegment = request.completedRootSegment;
	        if (completedRootSegment !== null && request.pendingRootTasks === 0) {
	          flushSegment(request, destination, completedRootSegment);
	          request.completedRootSegment = null;
	          writeCompletedRoot(destination, request.responseState);
	        }
	        var clientRenderedBoundaries = request.clientRenderedBoundaries;
	        var i;
	        for (i = 0; i < clientRenderedBoundaries.length; i++) {
	          var boundary = clientRenderedBoundaries[i];
	          if (!flushClientRenderedBoundary(request, destination, boundary)) ;
	        }
	        clientRenderedBoundaries.splice(0, i);
	        var completedBoundaries = request.completedBoundaries;
	        for (i = 0; i < completedBoundaries.length; i++) {
	          var _boundary = completedBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary)) ;
	        }
	        completedBoundaries.splice(0, i);
	        completeWriting(destination);
	        beginWriting(destination);
	        var partialBoundaries = request.partialBoundaries;
	        for (i = 0; i < partialBoundaries.length; i++) {
	          var _boundary2 = partialBoundaries[i];
	          if (!flushPartialBoundary(request, destination, _boundary2)) {
	            request.destination = null;
	            i++;
	            partialBoundaries.splice(0, i);
	            return;
	          }
	        }
	        partialBoundaries.splice(0, i);
	        var largeBoundaries = request.completedBoundaries;
	        for (i = 0; i < largeBoundaries.length; i++) {
	          var _boundary3 = largeBoundaries[i];
	          if (!flushCompletedBoundary(request, destination, _boundary3)) ;
	        }
	        largeBoundaries.splice(0, i);
	      } finally {
	        completeWriting(destination);
	        if (request.allPendingTasks === 0 && request.pingedTasks.length === 0 && request.clientRenderedBoundaries.length === 0 && request.completedBoundaries.length === 0) {
	          {
	            if (request.abortableTasks.size !== 0) {
	              error("There was still abortable task at the root when we closed. This is a bug in React.");
	            }
	          }
	          close(destination);
	        }
	      }
	    }
	    function startWork(request) {
	      scheduleWork(function() {
	        return performWork(request);
	      });
	    }
	    function startFlowing(request, destination) {
	      if (request.status === CLOSING) {
	        request.status = CLOSED;
	        closeWithError(destination, request.fatalError);
	        return;
	      }
	      if (request.status === CLOSED) {
	        return;
	      }
	      if (request.destination !== null) {
	        return;
	      }
	      request.destination = destination;
	      try {
	        flushCompletedQueues(request, destination);
	      } catch (error2) {
	        logRecoverableError(request, error2);
	        fatalError(request, error2);
	      }
	    }
	    function abort(request, reason) {
	      try {
	        var abortableTasks = request.abortableTasks;
	        abortableTasks.forEach(function(task) {
	          return abortTask(task, request, reason);
	        });
	        abortableTasks.clear();
	        if (request.destination !== null) {
	          flushCompletedQueues(request, request.destination);
	        }
	      } catch (error2) {
	        logRecoverableError(request, error2);
	        fatalError(request, error2);
	      }
	    }
	    function renderToReadableStream(children, options) {
	      return new Promise(function(resolve, reject) {
	        var onFatalError;
	        var onAllReady;
	        var allReady = new Promise(function(res, rej) {
	          onAllReady = res;
	          onFatalError = rej;
	        });
	        function onShellReady() {
	          var stream = new ReadableStream(
	            {
	              type: "bytes",
	              pull: function(controller) {
	                startFlowing(request, controller);
	              },
	              cancel: function(reason) {
	                abort(request);
	              }
	            },
	            // $FlowFixMe size() methods are not allowed on byte streams.
	            {
	              highWaterMark: 0
	            }
	          );
	          stream.allReady = allReady;
	          resolve(stream);
	        }
	        function onShellError(error2) {
	          allReady.catch(function() {
	          });
	          reject(error2);
	        }
	        var request = createRequest(children, createResponseState(options ? options.identifierPrefix : undefined, options ? options.nonce : undefined, options ? options.bootstrapScriptContent : undefined, options ? options.bootstrapScripts : undefined, options ? options.bootstrapModules : undefined), createRootFormatContext(options ? options.namespaceURI : undefined), options ? options.progressiveChunkSize : undefined, options ? options.onError : undefined, onAllReady, onShellReady, onShellError, onFatalError);
	        if (options && options.signal) {
	          var signal = options.signal;
	          var listener = function() {
	            abort(request, signal.reason);
	            signal.removeEventListener("abort", listener);
	          };
	          signal.addEventListener("abort", listener);
	        }
	        startWork(request);
	      });
	    }
	    reactDomServer_browser_development.renderToReadableStream = renderToReadableStream;
	    reactDomServer_browser_development.version = ReactVersion;
	  })();
	}
	return reactDomServer_browser_development;
}

var l, s$1;
if (process.env.NODE_ENV === 'production') {
  l = requireReactDomServerLegacy_browser_production_min();
  s$1 = requireReactDomServer_browser_production_min();
} else {
  l = requireReactDomServerLegacy_browser_development();
  s$1 = requireReactDomServer_browser_development();
}

l.version;
var renderToString = l.renderToString;
l.renderToStaticMarkup;
l.renderToNodeStream;
l.renderToStaticNodeStream;
s$1.renderToReadableStream;

//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray$1(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject$4(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k;
    for (k in obj) {
      if (hasOwnProp(obj, k)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined(input) {
  return input === undefined;
}
function isNumber$1(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate$2(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map$3(arr, fn) {
  var res = [], i, arrLen = arr.length;
  for (i = 0; i < arrLen; ++i) {
    res.push(fn(arr[i], i));
  }
  return res;
}
function extend$2(a, b) {
  for (var i in b) {
    if (hasOwnProp(b, i)) {
      a[i] = b[i];
    }
  }
  if (hasOwnProp(b, "toString")) {
    a.toString = b.toString;
  }
  if (hasOwnProp(b, "valueOf")) {
    a.valueOf = b.valueOf;
  }
  return a;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m) {
  if (m._pf == null) {
    m._pf = defaultParsingFlags();
  }
  return m._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t = Object(this), len = t.length >>> 0, i;
    for (i = 0; i < len; i++) {
      if (i in t && fun.call(this, t[i], i, t)) {
        return true;
      }
    }
    return false;
  };
}
function isValid(m) {
  if (m._isValid == null) {
    var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
      return i != null;
    }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) {
      m._isValid = isNowValid;
    } else {
      return isNowValid;
    }
  }
  return m._isValid;
}
function createInvalid(flags) {
  var m = createUTC(NaN);
  if (flags != null) {
    extend$2(getParsingFlags(m), flags);
  } else {
    getParsingFlags(m).userInvalidated = true;
  }
  return m;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from2) {
  var i, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined(from2._isAMomentObject)) {
    to2._isAMomentObject = from2._isAMomentObject;
  }
  if (!isUndefined(from2._i)) {
    to2._i = from2._i;
  }
  if (!isUndefined(from2._f)) {
    to2._f = from2._f;
  }
  if (!isUndefined(from2._l)) {
    to2._l = from2._l;
  }
  if (!isUndefined(from2._strict)) {
    to2._strict = from2._strict;
  }
  if (!isUndefined(from2._tzm)) {
    to2._tzm = from2._tzm;
  }
  if (!isUndefined(from2._isUTC)) {
    to2._isUTC = from2._isUTC;
  }
  if (!isUndefined(from2._offset)) {
    to2._offset = from2._offset;
  }
  if (!isUndefined(from2._pf)) {
    to2._pf = getParsingFlags(from2);
  }
  if (!isUndefined(from2._locale)) {
    to2._locale = from2._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i = 0; i < momentPropertiesLen; i++) {
      prop = momentProperties[i];
      val = from2[prop];
      if (!isUndefined(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config) {
  copyConfig(this, config);
  this._d = new Date(config._d != null ? config._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = /* @__PURE__ */ new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn) {
  var firstTime = true;
  return extend$2(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i, key, argLen = arguments.length;
      for (i = 0; i < argLen; i++) {
        arg = "";
        if (typeof arguments[i] === "object") {
          arg += "\n[" + i + "] ";
          for (key in arguments[0]) {
            if (hasOwnProp(arguments[0], key)) {
              arg += key + ": " + arguments[0][key] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i];
        }
        args.push(arg);
      }
      warn(
        msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
      );
      firstTime = false;
    }
    return fn.apply(this, arguments);
  }, fn);
}
var deprecations$1 = {};
function deprecateSimple(name, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name, msg);
  }
  if (!deprecations$1[name]) {
    warn(msg);
    deprecations$1[name] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction$1(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set$1(config) {
  var prop, i;
  for (i in config) {
    if (hasOwnProp(config, i)) {
      prop = config[i];
      if (isFunction$1(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
  }
  this._config = config;
  this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend$2({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject$4(parentConfig[prop]) && isObject$4(childConfig[prop])) {
        res[prop] = {};
        extend$2(res[prop], parentConfig[prop]);
        extend$2(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject$4(parentConfig[prop])) {
      res[prop] = extend$2({}, res[prop]);
    }
  }
  return res;
}
function Locale(config) {
  if (config != null) {
    this.set(config);
  }
}
var keys$1;
if (Object.keys) {
  keys$1 = Object.keys;
} else {
  keys$1 = function(obj) {
    var i, res = [];
    for (i in obj) {
      if (hasOwnProp(obj, i)) {
        res.push(i);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key, mom, now2) {
  var output = this._calendar[key] || this._calendar["sameElse"];
  return isFunction$1(output) ? output.call(mom, now2) : output;
}
function zeroFill(number, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(
        func.apply(this, arguments),
        token2
      );
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array = format2.match(formattingTokens), i, length;
  for (i = 0, length = array.length; i < length; i++) {
    if (formatTokenFunctions[array[i]]) {
      array[i] = formatTokenFunctions[array[i]];
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }
  return function(mom) {
    var output = "", i2;
    for (i2 = 0; i2 < length; i2++) {
      output += isFunction$1(array[i2]) ? array[i2].call(mom, format2) : array[i2];
    }
    return output;
  };
}
function formatMoment(m, format2) {
  if (!m.isValid()) {
    return m.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m);
}
function expandFormat(format2, locale2) {
  var i = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(
      localFormattingTokens,
      replaceLongDateFormatTokens
    );
    localFormattingTokens.lastIndex = 0;
    i -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
  var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number) {
  return this._ordinal.replace("%d", number);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number, withoutSuffix, string, isFuture) {
  var output = this._relativeTime[string];
  return isFunction$1(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction$1(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases = {};
function addUnitAlias(unit, shorthand) {
  var lowerCase = unit.toLowerCase();
  aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
}
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {};
function addUnitPriority(unit, priority) {
  priorities[unit] = priority;
}
function getPrioritizedUnits(unitsObj) {
  var units = [], u;
  for (u in unitsObj) {
    if (hasOwnProp(unitsObj, u)) {
      units.push({ unit: u, priority: priorities[u] });
    }
  }
  units.sort(function(a, b) {
    return a.priority - b.priority;
  });
  return units;
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function absFloor(number) {
  if (number < 0) {
    return Math.ceil(number) || 0;
  } else {
    return Math.floor(number);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get$1(this, unit);
    }
  };
}
function get$1(mom, unit) {
  return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
}
function set$1$1(mom, unit, value) {
  if (mom.isValid() && !isNaN(value)) {
    if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
      value = toInt(value);
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
        value,
        mom.month(),
        daysInMonth(value, mom.month())
      );
    } else {
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
    }
  }
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction$1(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
    for (i = 0; i < prioritizedLen; i++) {
      this[prioritized[i].unit](units[prioritized[i].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction$1(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
regexes = {};
function addRegexToken(token2, regex, strictRegex) {
  regexes[token2] = isFunction$1(regex) ? regex : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex;
  };
}
function getParseRegexForToken(token2, config) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config._strict, config._locale);
}
function unescapeFormat(s) {
  return regexEscape(
    s.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }
    )
  );
}
function regexEscape(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var tokens$1 = {};
function addParseToken(token2, callback) {
  var i, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber$1(callback)) {
    func = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i = 0; i < tokenLen; i++) {
    tokens$1[token2[i]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config, token3) {
    config._w = config._w || {};
    callback(input, config._w, config, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config) {
  if (input != null && hasOwnProp(tokens$1, token2)) {
    tokens$1[token2](input, config._a, config, token2);
  }
}
var YEAR = 0, MONTH = 1, DATE$1 = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
function mod(n, x) {
  return (n % x + x) % x;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o) {
    var i;
    for (i = 0; i < this.length; ++i) {
      if (this[i] === o) {
        return i;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addUnitAlias("month", "M");
addUnitPriority("month", 8);
addRegexToken("M", match1to2);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
  var month = config._locale.monthsParse(input, token2, config._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m, format2) {
  if (!m) {
    return isArray$1(this._months) ? this._months : this._months["standalone"];
  }
  return isArray$1(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
}
function localeMonthsShort(m, format2) {
  if (!m) {
    return isArray$1(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray$1(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i = 0; i < 12; ++i) {
      mom = createUTC([2e3, i]);
      this._shortMonthsParse[i] = this.monthsShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i, mom, regex;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    if (strict && !this._longMonthsParse[i]) {
      this._longMonthsParse[i] = new RegExp(
        "^" + this.months(mom, "").replace(".", "") + "$",
        "i"
      );
      this._shortMonthsParse[i] = new RegExp(
        "^" + this.monthsShort(mom, "").replace(".", "") + "$",
        "i"
      );
    }
    if (!strict && !this._monthsParse[i]) {
      regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
      return i;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
      return i;
    } else if (!strict && this._monthsParse[i].test(monthName)) {
      return i;
    }
  }
}
function setMonth(mom, value) {
  var dayOfMonth;
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber$1(value)) {
        return mom;
      }
    }
  }
  dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
  mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get$1(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    shortPieces.push(this.monthsShort(mom, ""));
    longPieces.push(this.months(mom, ""));
    mixedPieces.push(this.months(mom, ""));
    mixedPieces.push(this.monthsShort(mom, ""));
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  for (i = 0; i < 12; i++) {
    shortPieces[i] = regexEscape(shortPieces[i]);
    longPieces[i] = regexEscape(longPieces[i]);
  }
  for (i = 0; i < 24; i++) {
    mixedPieces[i] = regexEscape(mixedPieces[i]);
  }
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._monthsShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
}
addFormatToken("Y", 0, 0, function() {
  var y = this.year();
  return y <= 9999 ? zeroFill(y, 4) : "+" + y;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addUnitAlias("year", "y");
addUnitPriority("year", 1);
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function createDate(y, m, d, h, M, s, ms) {
  var date;
  if (y < 100 && y >= 0) {
    date = new Date(y + 400, m, d, h, M, s, ms);
    if (isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
  } else {
    date = new Date(y, m, d, h, M, s, ms);
  }
  return date;
}
function createUTCDate(y) {
  var date, args;
  if (y < 100 && y >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y + 400;
    date = new Date(Date.UTC.apply(null, args));
    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
  } else {
    date = new Date(Date.UTC.apply(null, arguments));
  }
  return date;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addUnitAlias("week", "w");
addUnitAlias("isoWeek", "W");
addUnitPriority("week", 5);
addUnitPriority("isoWeek", 5);
addRegexToken("w", match1to2);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(input, week, config, token2) {
    week[token2.substr(0, 1)] = toInt(input);
  }
);
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addUnitAlias("day", "d");
addUnitAlias("weekday", "e");
addUnitAlias("isoWeekday", "E");
addUnitPriority("day", 11);
addUnitPriority("weekday", 11);
addUnitPriority("isoWeekday", 11);
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
  var weekday = config._locale.weekdaysParse(input, token2, config._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n) {
  return ws.slice(n, 7).concat(ws.slice(0, n));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m, format2) {
  var weekdays = isArray$1(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
}
function localeWeekdaysShort(m) {
  return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m) {
  return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i = 0; i < 7; ++i) {
      mom = createUTC([2e3, 1]).day(i);
      this._minWeekdaysParse[i] = this.weekdaysMin(
        mom,
        ""
      ).toLocaleLowerCase();
      this._shortWeekdaysParse[i] = this.weekdaysShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i, mom, regex;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    if (strict && !this._fullWeekdaysParse[i]) {
      this._fullWeekdaysParse[i] = new RegExp(
        "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._shortWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._minWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
    }
    if (!this._weekdaysParse[i]) {
      regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
      return i;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._weekdaysShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
  this._weekdaysMinStrictRegex = new RegExp(
    "^(" + minPieces.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      lowercase
    );
  });
}
meridiem("a", true);
meridiem("A", false);
addUnitAlias("hour", "h");
addUnitPriority("hour", 13);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2);
addRegexToken("h", match1to2);
addRegexToken("k", match1to2);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config) {
  config._isPm = config._locale.isPM(input);
  config._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config) {
  array[HOUR] = toInt(input);
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i, minl = Math.min(arr1.length, arr2.length);
  for (i = 0; i < minl; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return i;
    }
  }
  return minl;
}
function normalizeLocale(key) {
  return key ? key.toLowerCase().replace("_", "-") : key;
}
function chooseLocale(names) {
  var i = 0, j, next, locale2, split;
  while (i < names.length) {
    split = normalizeLocale(names[i]).split("-");
    j = split.length;
    next = normalizeLocale(names[i + 1]);
    next = next ? next.split("-") : null;
    while (j > 0) {
      locale2 = loadLocale(split.slice(0, j).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
        break;
      }
      j--;
    }
    i++;
  }
  return globalLocale;
}
function isLocaleNameSane(name) {
  return name.match("^[^/\\\\]*$") != null;
}
function loadLocale(name) {
  var oldLocale = null, aliasedRequire;
  if (locales[name] === undefined && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name);
      getSetGlobalLocale(oldLocale);
    } catch (e) {
      locales[name] = null;
    }
  }
  return locales[name];
}
function getSetGlobalLocale(key, values) {
  var data;
  if (key) {
    if (isUndefined(values)) {
      data = getLocale(key);
    } else {
      data = defineLocale(key, values);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn(
          "Locale " + key + " not found. Did you forget to load it?"
        );
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name, config) {
  if (config !== null) {
    var locale2, parentConfig = baseConfig;
    config.abbr = name;
    if (locales[name] != null) {
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      );
      parentConfig = locales[name]._config;
    } else if (config.parentLocale != null) {
      if (locales[config.parentLocale] != null) {
        parentConfig = locales[config.parentLocale]._config;
      } else {
        locale2 = loadLocale(config.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config.parentLocale]) {
            localeFamilies[config.parentLocale] = [];
          }
          localeFamilies[config.parentLocale].push({
            name,
            config
          });
          return null;
        }
      }
    }
    locales[name] = new Locale(mergeConfigs(parentConfig, config));
    if (localeFamilies[name]) {
      localeFamilies[name].forEach(function(x) {
        defineLocale(x.name, x.config);
      });
    }
    getSetGlobalLocale(name);
    return locales[name];
  } else {
    delete locales[name];
    return null;
  }
}
function updateLocale(name, config) {
  if (config != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name] != null && locales[name].parentLocale != null) {
      locales[name].set(mergeConfigs(locales[name]._config, config));
    } else {
      tmpLocale = loadLocale(name);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config = mergeConfigs(parentConfig, config);
      if (tmpLocale == null) {
        config.abbr = name;
      }
      locale2 = new Locale(config);
      locale2.parentLocale = locales[name];
      locales[name] = locale2;
    }
    getSetGlobalLocale(name);
  } else {
    if (locales[name] != null) {
      if (locales[name].parentLocale != null) {
        locales[name] = locales[name].parentLocale;
        if (name === getSetGlobalLocale()) {
          getSetGlobalLocale(name);
        }
      } else if (locales[name] != null) {
        delete locales[name];
      }
    }
  }
  return locales[name];
}
function getLocale(key) {
  var locale2;
  if (key && key._locale && key._locale._abbr) {
    key = key._locale._abbr;
  }
  if (!key) {
    return globalLocale;
  }
  if (!isArray$1(key)) {
    locale2 = loadLocale(key);
    if (locale2) {
      return locale2;
    }
    key = [key];
  }
  return chooseLocale(key);
}
function listLocales() {
  return keys$1(locales);
}
function checkOverflow(m) {
  var overflow, a = m._a;
  if (a && getParsingFlags(m).overflow === -2) {
    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE$1] < 1 || a[DATE$1] > daysInMonth(a[YEAR], a[MONTH]) ? DATE$1 : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE$1)) {
      overflow = DATE$1;
    }
    if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m).overflow = overflow;
  }
  return m;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config) {
  var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match) {
    getParsingFlags(config).iso = true;
    for (i = 0, l = isoDatesLen; i < l; i++) {
      if (isoDates[i][1].exec(match[1])) {
        dateFormat = isoDates[i][0];
        allowTime = isoDates[i][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config._isValid = false;
      return;
    }
    if (match[3]) {
      for (i = 0, l = isoTimesLen; i < l; i++) {
        if (isoTimes[i][1].exec(match[3])) {
          timeFormat = (match[2] || " ") + isoTimes[i][0];
          break;
        }
      }
      if (timeFormat == null) {
        config._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config._isValid = false;
      return;
    }
    if (match[4]) {
      if (tzRegex.exec(match[4])) {
        tzFormat = "Z";
      } else {
        config._isValid = false;
        return;
      }
    }
    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config);
  } else {
    config._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result.push(parseInt(secondStr, 10));
  }
  return result;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s) {
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
      parsedInput[0],
      parsedInput[1],
      parsedInput[2]
    ).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config).weekdayMismatch = true;
      config._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
    return h * 60 + m;
  }
}
function configFromRFC2822(config) {
  var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
  if (match) {
    parsedArray = extractFromRFC2822Strings(
      match[4],
      match[3],
      match[2],
      match[5],
      match[6],
      match[7]
    );
    if (!checkWeekday(match[1], parsedArray, config)) {
      return;
    }
    config._a = parsedArray;
    config._tzm = calculateOffset(match[8], match[9], match[10]);
    config._d = createUTCDate.apply(null, config._a);
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    getParsingFlags(config).rfc2822 = true;
  } else {
    config._isValid = false;
  }
}
function configFromString(config) {
  var matched = aspNetJsonRegex.exec(config._i);
  if (matched !== null) {
    config._d = /* @__PURE__ */ new Date(+matched[1]);
    return;
  }
  configFromISO(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  configFromRFC2822(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  if (config._strict) {
    config._isValid = false;
  } else {
    hooks.createFromInputFallback(config);
  }
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(config) {
    config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
  }
);
function defaults(a, b, c) {
  if (a != null) {
    return a;
  }
  if (b != null) {
    return b;
  }
  return c;
}
function currentDateArray(config) {
  var nowValue = new Date(hooks.now());
  if (config._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config) {
  var i, date, input = [], currentDate, expectedWeekday, yearToUse;
  if (config._d) {
    return;
  }
  currentDate = currentDateArray(config);
  if (config._w && config._a[DATE$1] == null && config._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config);
  }
  if (config._dayOfYear != null) {
    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
      getParsingFlags(config)._overflowDayOfYear = true;
    }
    date = createUTCDate(yearToUse, 0, config._dayOfYear);
    config._a[MONTH] = date.getUTCMonth();
    config._a[DATE$1] = date.getUTCDate();
  }
  for (i = 0; i < 3 && config._a[i] == null; ++i) {
    config._a[i] = input[i] = currentDate[i];
  }
  for (; i < 7; i++) {
    config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
  }
  if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
    config._nextDay = true;
    config._a[HOUR] = 0;
  }
  config._d = (config._useUTC ? createUTCDate : createDate).apply(
    null,
    input
  );
  expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
  if (config._tzm != null) {
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
  }
  if (config._nextDay) {
    config._a[HOUR] = 24;
  }
  if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
    getParsingFlags(config).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config) {
  var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w = config._w;
  if (w.GG != null || w.W != null || w.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults(
      w.GG,
      config._a[YEAR],
      weekOfYear(createLocal(), 1, 4).year
    );
    week = defaults(w.W, 1);
    weekday = defaults(w.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config._locale._week.dow;
    doy = config._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
    week = defaults(w.w, curWeek.week);
    if (w.d != null) {
      weekday = w.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w.e != null) {
      weekday = w.e + dow;
      if (w.e < 0 || w.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config._a[YEAR] = temp.year;
    config._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config) {
  if (config._f === hooks.ISO_8601) {
    configFromISO(config);
    return;
  }
  if (config._f === hooks.RFC_2822) {
    configFromRFC2822(config);
    return;
  }
  config._a = [];
  getParsingFlags(config).empty = true;
  var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i = 0; i < tokenLen; i++) {
    token2 = tokens2[i];
    parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
    if (parsedInput) {
      skipped = string.substr(0, string.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config).unusedInput.push(skipped);
      }
      string = string.slice(
        string.indexOf(parsedInput) + parsedInput.length
      );
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config).empty = false;
      } else {
        getParsingFlags(config).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config);
    } else if (config._strict && !parsedInput) {
      getParsingFlags(config).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
  if (string.length > 0) {
    getParsingFlags(config).unusedInput.push(string);
  }
  if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
    getParsingFlags(config).bigHour = undefined;
  }
  getParsingFlags(config).parsedDateParts = config._a.slice(0);
  getParsingFlags(config).meridiem = config._meridiem;
  config._a[HOUR] = meridiemFixWrap(
    config._locale,
    config._a[HOUR],
    config._meridiem
  );
  era = getParsingFlags(config).era;
  if (era !== null) {
    config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
  }
  configFromArray(config);
  checkOverflow(config);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config) {
  var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
  if (configfLen === 0) {
    getParsingFlags(config).invalidFormat = true;
    config._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < configfLen; i++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config);
    if (config._useUTC != null) {
      tempConfig._useUTC = config._useUTC;
    }
    tempConfig._f = config._f[i];
    configFromStringAndFormat(tempConfig);
    if (isValid(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend$2(config, bestMoment || tempConfig);
}
function configFromObject(config) {
  if (config._d) {
    return;
  }
  var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
  config._a = map$3(
    [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
    function(obj) {
      return obj && parseInt(obj, 10);
    }
  );
  configFromArray(config);
}
function createFromConfig(config) {
  var res = new Moment(checkOverflow(prepareConfig(config)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = undefined;
  }
  return res;
}
function prepareConfig(config) {
  var input = config._i, format2 = config._f;
  config._locale = config._locale || getLocale(config._l);
  if (input === null || format2 === undefined && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config._i = input = config._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate$2(input)) {
    config._d = input;
  } else if (isArray$1(format2)) {
    configFromStringAndArray(config);
  } else if (format2) {
    configFromStringAndFormat(config);
  } else {
    configFromInput(config);
  }
  if (!isValid(config)) {
    config._d = null;
  }
  return config;
}
function configFromInput(config) {
  var input = config._i;
  if (isUndefined(input)) {
    config._d = new Date(hooks.now());
  } else if (isDate$2(input)) {
    config._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config);
  } else if (isArray$1(input)) {
    config._a = map$3(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config);
  } else if (isObject$4(input)) {
    configFromObject(config);
  } else if (isNumber$1(input)) {
    config._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = undefined;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = undefined;
  }
  if (isObject$4(input) && isObjectEmpty(input) || isArray$1(input) && input.length === 0) {
    input = undefined;
  }
  c._isAMomentObject = true;
  c._useUTC = c._isUTC = isUTC;
  c._l = locale2;
  c._i = input;
  c._f = format2;
  c._strict = strict;
  return createFromConfig(c);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }
);
function pickBy(fn, moments) {
  var res, i;
  if (moments.length === 1 && isArray$1(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i = 1; i < moments.length; ++i) {
    if (!moments[i].isValid() || moments[i][fn](res)) {
      res = moments[i];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now$2 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m) {
  var key, unitHasDecimal = false, i, orderLen = ordering.length;
  for (key in m) {
    if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
      return false;
    }
  }
  for (i = 0; i < orderLen; ++i) {
    if (m[ordering[i]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
  minutes2 * 6e4 + // 1000 * 60
  hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number) {
  if (number < 0) {
    return Math.round(-1 * number) * -1;
  } else {
    return Math.round(number);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
  for (i = 0; i < len; i++) {
    if (toInt(array1[i]) !== toInt(array2[i])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset2 = this.utcOffset(), sign2 = "+";
    if (offset2 < 0) {
      offset2 = -offset2;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config) {
  config._useUTC = true;
  config._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string) {
  var matches = (string || "").match(matcher), chunk, parts, minutes2;
  if (matches === null) {
    return null;
  }
  chunk = matches[matches.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate$2(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m) {
  return -Math.round(m._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset2 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset2 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(
          this,
          createDuration(input - offset2, "m"),
          1,
          false
        );
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset2 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c = {}, other;
  copyConfig(c, this);
  c = prepareConfig(c);
  if (c._a) {
    other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
    this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
  var duration = input, match = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber$1(input) || !isNaN(+input)) {
    duration = {};
    if (key) {
      duration[key] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match = aspNetRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match[DATE$1]) * sign2,
      h: toInt(match[HOUR]) * sign2,
      m: toInt(match[MINUTE]) * sign2,
      s: toInt(match[SECOND]) * sign2,
      ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
      // the millisecond decimal point is included in the match
    };
  } else if (match = isoRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match[2], sign2),
      M: parseIso(match[3], sign2),
      w: parseIso(match[4], sign2),
      d: parseIso(match[5], sign2),
      h: parseIso(match[6], sign2),
      m: parseIso(match[7], sign2),
      s: parseIso(match[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(
      createLocal(duration.from),
      createLocal(duration.to)
    );
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base, other) {
  var res = {};
  res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
  if (base.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base, other) {
  var res;
  if (!(base.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base);
  if (base.isBefore(other)) {
    res = positiveMomentsDifference(base, other);
  } else {
    res = positiveMomentsDifference(other, base);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(
        name,
        "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
      );
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get$1(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1$1(mom, "Date", get$1(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate$2(input) || isString(input) || isNumber$1(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
}
function isMomentInputObject(input) {
  var objectTest = isObject$4(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, property, propertyLen = properties.length;
  for (i = 0; i < propertyLen; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray$1(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber$1(item) && isString(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject$4(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, property;
  for (i = 0; i < properties.length; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = undefined;
      formats = undefined;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = undefined;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = undefined;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction$1(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(
    output || this.localeData().calendar(format2, this, createLocal(now2))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from2, to2, units, inclusivity) {
  var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a, b) {
  if (a.date() < b.date()) {
    return -monthDiff(b, a);
  }
  var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b - anchor < 0) {
    anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString$3() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
  if (m.year() < 0 || m.year() > 9999) {
    return formatMoment(
      m,
      utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  if (isFunction$1(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
    }
  }
  return formatMoment(
    m,
    utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix, year, datetime, suffix;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix + year + datetime + suffix);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key) {
  var newLocaleData;
  if (key === undefined) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return new Date(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return new Date(y, m, d).valueOf();
  }
}
function utcStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y, m, d);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === undefined || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === undefined || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m = this;
  return [
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
    m.millisecond()
  ];
}
function toObject() {
  var m = this;
  return {
    years: m.year(),
    months: m.month(),
    date: m.date(),
    hours: m.hours(),
    minutes: m.minutes(),
    seconds: m.seconds(),
    milliseconds: m.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend$2({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(input, array, config, token2) {
    var era = config._locale.erasParse(input, token2, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config, token2) {
  var match;
  if (config._locale._eraYearOrdinalRegex) {
    match = input.match(config._locale._eraYearOrdinalRegex);
  }
  if (config._locale.eraYearOrdinalParse) {
    array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m, format2) {
  var i, l, date, eras = this._eras || getLocale("en")._eras;
  for (i = 0, l = eras.length; i < l; ++i) {
    switch (typeof eras[i].since) {
      case "string":
        date = hooks(eras[i].since).startOf("day");
        eras[i].since = date.valueOf();
        break;
    }
    switch (typeof eras[i].until) {
      case "undefined":
        eras[i].until = Infinity;
        break;
      case "string":
        date = hooks(eras[i].until).startOf("day").valueOf();
        eras[i].until = date.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i, l, eras = this.eras(), name, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i = 0, l = eras.length; i < l; ++i) {
    name = eras[i].name.toUpperCase();
    abbr = eras[i].abbr.toUpperCase();
    narrow = eras[i].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i];
          }
          break;
        case "NNNN":
          if (name === eraName) {
            return eras[i];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i];
          }
          break;
      }
    } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === undefined) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].name;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].narrow;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].abbr;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i, l, dir, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    dir = eras[i].since <= eras[i].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
      return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    namePieces.push(regexEscape(eras[i].name));
    abbrPieces.push(regexEscape(eras[i].abbr));
    narrowPieces.push(regexEscape(eras[i].narrow));
    mixedPieces.push(regexEscape(eras[i].name));
    mixedPieces.push(regexEscape(eras[i].abbr));
    mixedPieces.push(regexEscape(eras[i].narrow));
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp(
    "^(" + narrowPieces.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addUnitAlias("weekYear", "gg");
addUnitAlias("isoWeekYear", "GG");
addUnitPriority("weekYear", 1);
addUnitPriority("isoWeekYear", 1);
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(input, week, config, token2) {
    week[token2.substr(0, 2)] = toInt(input);
  }
);
addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date.getUTCFullYear());
  this.month(date.getUTCMonth());
  this.date(date.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addUnitAlias("quarter", "Q");
addUnitPriority("quarter", 7);
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addUnitAlias("date", "D");
addUnitPriority("date", 9);
addRegexToken("D", match1to2);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE$1);
addParseToken("Do", function(input, array) {
  array[DATE$1] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addUnitAlias("dayOfYear", "DDD");
addUnitPriority("dayOfYear", 4);
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config) {
  config._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addUnitAlias("minute", "m");
addUnitPriority("minute", 14);
addRegexToken("m", match1to2);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addUnitAlias("second", "s");
addUnitPriority("second", 15);
addRegexToken("s", match1to2);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addUnitAlias("millisecond", "ms");
addUnitPriority("millisecond", 16);
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto$1 = Moment.prototype;
proto$1.add = add;
proto$1.calendar = calendar$1;
proto$1.clone = clone;
proto$1.diff = diff;
proto$1.endOf = endOf;
proto$1.format = format;
proto$1.from = from;
proto$1.fromNow = fromNow;
proto$1.to = to;
proto$1.toNow = toNow;
proto$1.get = stringGet;
proto$1.invalidAt = invalidAt;
proto$1.isAfter = isAfter;
proto$1.isBefore = isBefore;
proto$1.isBetween = isBetween;
proto$1.isSame = isSame;
proto$1.isSameOrAfter = isSameOrAfter;
proto$1.isSameOrBefore = isSameOrBefore;
proto$1.isValid = isValid$2;
proto$1.lang = lang;
proto$1.locale = locale;
proto$1.localeData = localeData;
proto$1.max = prototypeMax;
proto$1.min = prototypeMin;
proto$1.parsingFlags = parsingFlags;
proto$1.set = stringSet;
proto$1.startOf = startOf;
proto$1.subtract = subtract;
proto$1.toArray = toArray;
proto$1.toObject = toObject;
proto$1.toDate = toDate;
proto$1.toISOString = toISOString;
proto$1.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto$1[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto$1.toJSON = toJSON;
proto$1.toString = toString$3;
proto$1.unix = unix;
proto$1.valueOf = valueOf;
proto$1.creationData = creationData;
proto$1.eraName = getEraName;
proto$1.eraNarrow = getEraNarrow;
proto$1.eraAbbr = getEraAbbr;
proto$1.eraYear = getEraYear;
proto$1.year = getSetYear;
proto$1.isLeapYear = getIsLeapYear;
proto$1.weekYear = getSetWeekYear;
proto$1.isoWeekYear = getSetISOWeekYear;
proto$1.quarter = proto$1.quarters = getSetQuarter;
proto$1.month = getSetMonth;
proto$1.daysInMonth = getDaysInMonth;
proto$1.week = proto$1.weeks = getSetWeek;
proto$1.isoWeek = proto$1.isoWeeks = getSetISOWeek;
proto$1.weeksInYear = getWeeksInYear;
proto$1.weeksInWeekYear = getWeeksInWeekYear;
proto$1.isoWeeksInYear = getISOWeeksInYear;
proto$1.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto$1.date = getSetDayOfMonth;
proto$1.day = proto$1.days = getSetDayOfWeek;
proto$1.weekday = getSetLocaleDayOfWeek;
proto$1.isoWeekday = getSetISODayOfWeek;
proto$1.dayOfYear = getSetDayOfYear;
proto$1.hour = proto$1.hours = getSetHour;
proto$1.minute = proto$1.minutes = getSetMinute;
proto$1.second = proto$1.seconds = getSetSecond;
proto$1.millisecond = proto$1.milliseconds = getSetMillisecond;
proto$1.utcOffset = getSetOffset;
proto$1.utc = setOffsetToUTC;
proto$1.local = setOffsetToLocal;
proto$1.parseZone = setOffsetToParsedOffset;
proto$1.hasAlignedHourOffset = hasAlignedHourOffset;
proto$1.isDST = isDaylightSavingTime;
proto$1.isLocal = isLocal;
proto$1.isUtcOffset = isUtcOffset;
proto$1.isUtc = isUtc;
proto$1.isUTC = isUtc;
proto$1.zoneAbbr = getZoneAbbr;
proto$1.zoneName = getZoneName;
proto$1.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto$1.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto$1.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto$1.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto$1.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string) {
  return string;
}
var proto$1$1 = Locale.prototype;
proto$1$1.calendar = calendar;
proto$1$1.longDateFormat = longDateFormat;
proto$1$1.invalidDate = invalidDate;
proto$1$1.ordinal = ordinal;
proto$1$1.preparse = preParsePostFormat;
proto$1$1.postformat = preParsePostFormat;
proto$1$1.relativeTime = relativeTime;
proto$1$1.pastFuture = pastFuture;
proto$1$1.set = set$1;
proto$1$1.eras = localeEras;
proto$1$1.erasParse = localeErasParse;
proto$1$1.erasConvertYear = localeErasConvertYear;
proto$1$1.erasAbbrRegex = erasAbbrRegex;
proto$1$1.erasNameRegex = erasNameRegex;
proto$1$1.erasNarrowRegex = erasNarrowRegex;
proto$1$1.months = localeMonths;
proto$1$1.monthsShort = localeMonthsShort;
proto$1$1.monthsParse = localeMonthsParse;
proto$1$1.monthsRegex = monthsRegex;
proto$1$1.monthsShortRegex = monthsShortRegex;
proto$1$1.week = localeWeek;
proto$1$1.firstDayOfYear = localeFirstDayOfYear;
proto$1$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1$1.weekdays = localeWeekdays;
proto$1$1.weekdaysMin = localeWeekdaysMin;
proto$1$1.weekdaysShort = localeWeekdaysShort;
proto$1$1.weekdaysParse = localeWeekdaysParse;
proto$1$1.weekdaysRegex = weekdaysRegex;
proto$1$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1$1.isPM = localeIsPM;
proto$1$1.meridiem = localeMeridiem;
function get$1$1(format2, index, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index, field) {
  if (isNumber$1(format2)) {
    index = format2;
    format2 = undefined;
  }
  format2 = format2 || "";
  if (index != null) {
    return get$1$1(format2, index, field, "month");
  }
  var i, out = [];
  for (i = 0; i < 12; i++) {
    out[i] = get$1$1(format2, i, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber$1(format2)) {
      index = format2;
      format2 = undefined;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index = format2;
    localeSorted = false;
    if (isNumber$1(format2)) {
      index = format2;
      format2 = undefined;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
  if (index != null) {
    return get$1$1(format2, (index + shift) % 7, field, "day");
  }
  for (i = 0; i < 7; i++) {
    out[i] = get$1$1(format2, (i + shift) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index) {
  return listMonthsImpl(format2, index, "months");
}
function listMonthsShort(format2, index) {
  return listMonthsImpl(format2, index, "monthsShort");
}
function listWeekdays(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number) {
    var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
    return number + output;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction) {
  var other = createDuration(input, value);
  duration._milliseconds += direction * other._milliseconds;
  duration._days += direction * other._days;
  duration._months += direction * other._months;
  return duration._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number) {
  if (number < 0) {
    return Math.floor(number);
  } else {
    return Math.ceil(number);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function valueOf$1() {
  if (!this.isValid()) {
    return NaN;
  }
  return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name) {
  return function() {
    return this.isValid() ? this._data[name] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a[2] = withoutSuffix;
  a[3] = +posNegDuration > 0;
  a[4] = locale2;
  return substituteTimeAgo.apply(null, a);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === undefined) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === undefined) {
    return false;
  }
  if (limit === undefined) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x) {
  return (x > 0) - (x < 0) || +x;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config) {
  config._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config) {
  config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.29.4";
setHookCallback(createLocal);
hooks.fn = proto$1;
hooks.min = min;
hooks.max = max;
hooks.now = now$2;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate$2;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto$1;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};

const styles$2 = `
  .heading {
    width:30%;
  }
  .region {
    border-top:none !important;
  }
  `;
const RenderDataAsTable = ({
  messageText,
  enableSend,
  setFeedbackButtonsVisible,
  isFullScreen,
  promptResult,
  setCopyText
}) => {
  useEffect(() => {
    setFeedbackButtonsVisible(true);
    enableSend();
    promptResult(true);
  }, []);
  const TableRenderer = ({ messageText: messageText2 }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { children: [
      messageText2.columns?.map((item) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          "th",
          {
            style: {
              paddingRight: 10,
              padding: 5,
              border: "1px solid #D3D3D3"
            },
            children: item
          }
        );
      }),
      messageText2.data?.map((item) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: item.map((data, idx) => {
          let columnType = messageText2.column_types[idx];
          return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { style: { padding: 5, border: "1px solid #D3D3D3" }, children: columnType == "datetime" && hooks(data, hooks.ISO_8601, true).isValid() ? hooks(data).format("DD-MMM-YYYY") : data });
        }) });
      })
    ] });
  };
  useEffect(() => {
    const jsx2 = /* @__PURE__ */ jsxRuntimeExports.jsx(TableRenderer, { messageText });
    const htmlString = renderToString(jsx2);
    setCopyText(htmlString);
  }, [messageText]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TableRenderer, { messageText });
};
const openLinkInNewTab = (link) => {
  window.open(link, "_blank");
};
const decodeEntities = (encodedString) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = encodedString;
  return textarea.value;
};
const StringWithLinks = (text) => {
  const convertUrlsToLinks = (inputText) => {
    const pattern = /\((https?:\/\/[^\)]+)\)/g;
    return inputText.replace(pattern, '<a href="$1" target="_blank">$1</a>');
  };
  const convertedText = convertUrlsToLinks(text);
  const regex = /\[([^]+?)\]<a href="([^"]*)" target="_blank">([^<]*)<\/a>/g;
  let modifiedString = convertedText;
  let matches;
  while ((matches = regex.exec(convertedText)) !== null) {
    if (matches && matches.length === 4) {
      const linkTextInBrackets = matches[1];
      const linkUrl = matches[2];
      const linkText = matches[3];
      modifiedString = modifiedString.replace(
        `[${linkTextInBrackets}]<a href="${linkUrl}" target="_blank">${linkText}</a>`,
        `<a href="${linkUrl}" target="_blank">${linkTextInBrackets}</a>`
      );
    }
  }
  let regex2 = /\[(.*?)\]\((.*?)\)/g;
  function replaceMatch(match, text2, link) {
    return `<a href="${link}" target="_blank">${text2}</a>`;
  }
  modifiedString = modifiedString.replace(regex2, replaceMatch);
  return modifiedString;
};
const RenderPlainTextMessage = ({
  messageText,
  setFeedbackButtonsVisible,
  enableSend,
  promptResult,
  isToggled,
  suggestionLinks,
  isTypewritingOn,
  setCopyText
}) => {
  const [wordsToDisplay, setWordsToDisplay] = useState([]);
  const [linkflag, setlinkflag] = useState(false);
  const [plainText, setplainText] = useState("");
  React.useEffect(() => {
    if (messageText) {
      let parsedMessage = messageText.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "");
      parsedMessage = parsedMessage?.trim().length == 0 ? "Sorry, we couldn't find an answer to your query. Please rephrase your question and try again." : parsedMessage;
      parsedMessage = decodeEntities(parsedMessage);
      parsedMessage = parsedMessage.replace(/\n/g, " </br> ");
      parsedMessage = StringWithLinks(parsedMessage);
      setplainText(parsedMessage);
      setCopyText(parsedMessage);
      if (!isTypewritingOn) {
        setFeedbackButtonsVisible(true);
        enableSend();
        promptResult(true);
        setlinkflag(true);
      } else {
        var htmlTagsRegex = /(<[^>]+>)([^<]+)?(<\/[^>]+>)|[^<>\s]+/g;
        var words = parsedMessage.match(htmlTagsRegex);
        words = words.filter(function(item) {
          return item.trim() !== "";
        });
        words = words.map((item) => item.replace(/(?<!<)\/br(?!>)/g, "<br />"));
        let currentIndex = 0;
        const intervalId = setInterval(() => {
          setWordsToDisplay((prevWords) => {
            if (currentIndex >= words.length) {
              setFeedbackButtonsVisible(true);
              clearInterval(intervalId);
              const divElement2 = document.getElementById("chatMessagesBody");
              if (divElement2) {
                divElement2.scrollTop = divElement2.scrollHeight;
              }
              enableSend();
              promptResult(true);
              setlinkflag(true);
              return prevWords;
            }
            const nextWord = words[currentIndex];
            currentIndex += 1;
            const divElement = document.getElementById("chatMessagesBody");
            if (divElement) {
              divElement.scrollTop = divElement.scrollHeight;
            }
            return [...prevWords, nextWord];
          });
        }, 100);
        return () => clearInterval(intervalId);
      }
    }
  }, [messageText]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { marginBottom: "10px" }, children: [
    isTypewritingOn ? wordsToDisplay.map((word, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      word === "</br>" ? /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: word } }),
      index < wordsToDisplay.length - 1 && " "
    ] }, index)) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: plainText } }),
    suggestionLinks.some((link) => link.link !== "") && linkflag && /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { style: { listStyleType: "none", padding: 0, margin: 0 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { fontWeight: "bold" }, children: "Learn More:" }),
      suggestionLinks.map(
        (link, index) => link.link && /* @__PURE__ */ jsxRuntimeExports.jsx("li", { style: { marginBottom: "2px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "#", onClick: () => openLinkInNewTab(link.link), children: `${suggestionLinks.filter((l) => l.link !== "").indexOf(link) + 1}. ${link.title}` }) }, index)
      )
    ] })
  ] });
};
const DbCopilotResponse = (props) => {
  let responseArray = props.response?.reply ? props.response.reply : props.response?.aiResponseData ? props.response?.aiResponseData : props.response;
  useState(false);
  useEffect(() => {
    const fluentAccordionItem = document.querySelectorAll(
      "fluent-accordion-item"
    );
    if (fluentAccordionItem.length > 0) {
      let style = document.createElement("style");
      style.innerHTML = styles$2;
      fluentAccordionItem[fluentAccordionItem.length - 1].shadowRoot.appendChild(style);
    }
  }, [responseArray]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        maxWidth: props.isFullScreen ? "760px" : "400px",
        overflowX: "auto"
      },
      children: [
        responseArray?.responseType == "error" && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: responseArray?.data?.errorMessage }),
        props.response.rephrasedQuestion && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          "I assume you are asking about the",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.response.rephrasedQuestion })
        ] }),
        responseArray?.responseType?.toLowerCase() != "error" && (responseArray && responseArray.data ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          RenderDataAsTable,
          {
            messageText: responseArray,
            setFeedbackButtonsVisible: props.setFeedbackButtonsVisible,
            enableSend: props.enableSend,
            isFullScreen: props.isFullScreen,
            promptResult: props.promptResult,
            setCopyText: props.setCopyText
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          RenderPlainTextMessage,
          {
            messageText: responseArray,
            setFeedbackButtonsVisible: props.setFeedbackButtonsVisible,
            enableSend: props.enableSend,
            promptResult: props.promptResult,
            isToggled: props.isToggled,
            suggestionLinks: props.suggestionLinks,
            isTypewritingOn: props.typewriterFlag,
            setCopyText: props.setCopyText
          }
        ))
      ]
    }
  );
};

var reactPlotly = {};

var factory = {};

(function (exports) {

	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = plotComponentFactory;

	var _react = _interopRequireWildcard(React__default);

	var _propTypes = _interopRequireDefault(propTypesExports);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { _defineProperties(Constructor.prototype, protoProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== undefined) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === undefined) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	// The naming convention is:
	//   - events are attached as `'plotly_' + eventName.toLowerCase()`
	//   - react props are `'on' + eventName`
	var eventNames = ['AfterExport', 'AfterPlot', 'Animated', 'AnimatingFrame', 'AnimationInterrupted', 'AutoSize', 'BeforeExport', 'BeforeHover', 'ButtonClicked', 'Click', 'ClickAnnotation', 'Deselect', 'DoubleClick', 'Framework', 'Hover', 'LegendClick', 'LegendDoubleClick', 'Relayout', 'Relayouting', 'Restyle', 'Redraw', 'Selected', 'Selecting', 'SliderChange', 'SliderEnd', 'SliderStart', 'SunburstClick', 'Transitioning', 'TransitionInterrupted', 'Unhover', 'WebGlContextLost'];
	var updateEvents = ['plotly_restyle', 'plotly_redraw', 'plotly_relayout', 'plotly_relayouting', 'plotly_doubleclick', 'plotly_animated', 'plotly_sunburstclick']; // Check if a window is available since SSR (server-side rendering)
	// breaks unnecessarily if you try to use it server-side.

	var isBrowser = typeof window !== 'undefined';

	function plotComponentFactory(Plotly) {
	  var PlotlyComponent = /*#__PURE__*/function (_Component) {
	    _inherits(PlotlyComponent, _Component);

	    var _super = _createSuper(PlotlyComponent);

	    function PlotlyComponent(props) {
	      var _this;

	      _classCallCheck(this, PlotlyComponent);

	      _this = _super.call(this, props);
	      _this.p = Promise.resolve();
	      _this.resizeHandler = null;
	      _this.handlers = {};
	      _this.syncWindowResize = _this.syncWindowResize.bind(_assertThisInitialized(_this));
	      _this.syncEventHandlers = _this.syncEventHandlers.bind(_assertThisInitialized(_this));
	      _this.attachUpdateEvents = _this.attachUpdateEvents.bind(_assertThisInitialized(_this));
	      _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
	      _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
	      _this.figureCallback = _this.figureCallback.bind(_assertThisInitialized(_this));
	      _this.updatePlotly = _this.updatePlotly.bind(_assertThisInitialized(_this));
	      return _this;
	    }

	    _createClass(PlotlyComponent, [{
	      key: "updatePlotly",
	      value: function updatePlotly(shouldInvokeResizeHandler, figureCallbackFunction, shouldAttachUpdateEvents) {
	        var _this2 = this;

	        this.p = this.p.then(function () {
	          if (_this2.unmounting) {
	            return;
	          }

	          if (!_this2.el) {
	            throw new Error('Missing element reference');
	          } // eslint-disable-next-line consistent-return


	          return Plotly.react(_this2.el, {
	            data: _this2.props.data,
	            layout: _this2.props.layout,
	            config: _this2.props.config,
	            frames: _this2.props.frames
	          });
	        }).then(function () {
	          if (_this2.unmounting) {
	            return;
	          }

	          _this2.syncWindowResize(shouldInvokeResizeHandler);

	          _this2.syncEventHandlers();

	          _this2.figureCallback(figureCallbackFunction);

	          if (shouldAttachUpdateEvents) {
	            _this2.attachUpdateEvents();
	          }
	        })["catch"](function (err) {
	          if (_this2.props.onError) {
	            _this2.props.onError(err);
	          }
	        });
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.unmounting = false;
	        this.updatePlotly(true, this.props.onInitialized, true);
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        this.unmounting = false; // frames *always* changes identity so fall back to check length only :(

	        var numPrevFrames = prevProps.frames && prevProps.frames.length ? prevProps.frames.length : 0;
	        var numNextFrames = this.props.frames && this.props.frames.length ? this.props.frames.length : 0;
	        var figureChanged = !(prevProps.layout === this.props.layout && prevProps.data === this.props.data && prevProps.config === this.props.config && numNextFrames === numPrevFrames);
	        var revisionDefined = prevProps.revision !== undefined;
	        var revisionChanged = prevProps.revision !== this.props.revision;

	        if (!figureChanged && (!revisionDefined || revisionDefined && !revisionChanged)) {
	          return;
	        }

	        this.updatePlotly(false, this.props.onUpdate, false);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.unmounting = true;
	        this.figureCallback(this.props.onPurge);

	        if (this.resizeHandler && isBrowser) {
	          window.removeEventListener('resize', this.resizeHandler);
	          this.resizeHandler = null;
	        }

	        this.removeUpdateEvents();
	        Plotly.purge(this.el);
	      }
	    }, {
	      key: "attachUpdateEvents",
	      value: function attachUpdateEvents() {
	        var _this3 = this;

	        if (!this.el || !this.el.removeListener) {
	          return;
	        }

	        updateEvents.forEach(function (updateEvent) {
	          _this3.el.on(updateEvent, _this3.handleUpdate);
	        });
	      }
	    }, {
	      key: "removeUpdateEvents",
	      value: function removeUpdateEvents() {
	        var _this4 = this;

	        if (!this.el || !this.el.removeListener) {
	          return;
	        }

	        updateEvents.forEach(function (updateEvent) {
	          _this4.el.removeListener(updateEvent, _this4.handleUpdate);
	        });
	      }
	    }, {
	      key: "handleUpdate",
	      value: function handleUpdate() {
	        this.figureCallback(this.props.onUpdate);
	      }
	    }, {
	      key: "figureCallback",
	      value: function figureCallback(callback) {
	        if (typeof callback === 'function') {
	          var _this$el = this.el,
	              data = _this$el.data,
	              layout = _this$el.layout;
	          var frames = this.el._transitionData ? this.el._transitionData._frames : null;
	          var figure = {
	            data: data,
	            layout: layout,
	            frames: frames
	          };
	          callback(figure, this.el);
	        }
	      }
	    }, {
	      key: "syncWindowResize",
	      value: function syncWindowResize(invoke) {
	        var _this5 = this;

	        if (!isBrowser) {
	          return;
	        }

	        if (this.props.useResizeHandler && !this.resizeHandler) {
	          this.resizeHandler = function () {
	            return Plotly.Plots.resize(_this5.el);
	          };

	          window.addEventListener('resize', this.resizeHandler);

	          if (invoke) {
	            this.resizeHandler();
	          }
	        } else if (!this.props.useResizeHandler && this.resizeHandler) {
	          window.removeEventListener('resize', this.resizeHandler);
	          this.resizeHandler = null;
	        }
	      }
	    }, {
	      key: "getRef",
	      value: function getRef(el) {
	        this.el = el;

	        if (this.props.debug && isBrowser) {
	          window.gd = this.el;
	        }
	      } // Attach and remove event handlers as they're added or removed from props:

	    }, {
	      key: "syncEventHandlers",
	      value: function syncEventHandlers() {
	        var _this6 = this;

	        eventNames.forEach(function (eventName) {
	          var prop = _this6.props['on' + eventName];
	          var handler = _this6.handlers[eventName];
	          var hasHandler = Boolean(handler);

	          if (prop && !hasHandler) {
	            _this6.addEventHandler(eventName, prop);
	          } else if (!prop && hasHandler) {
	            // Needs to be removed:
	            _this6.removeEventHandler(eventName);
	          } else if (prop && hasHandler && prop !== handler) {
	            // replace the handler
	            _this6.removeEventHandler(eventName);

	            _this6.addEventHandler(eventName, prop);
	          }
	        });
	      }
	    }, {
	      key: "addEventHandler",
	      value: function addEventHandler(eventName, prop) {
	        this.handlers[eventName] = prop;
	        this.el.on(this.getPlotlyEventName(eventName), this.handlers[eventName]);
	      }
	    }, {
	      key: "removeEventHandler",
	      value: function removeEventHandler(eventName) {
	        this.el.removeListener(this.getPlotlyEventName(eventName), this.handlers[eventName]);
	        delete this.handlers[eventName];
	      }
	    }, {
	      key: "getPlotlyEventName",
	      value: function getPlotlyEventName(eventName) {
	        return 'plotly_' + eventName.toLowerCase();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          id: this.props.divId,
	          style: this.props.style,
	          ref: this.getRef,
	          className: this.props.className
	        });
	      }
	    }]);

	    return PlotlyComponent;
	  }(_react.Component);

	  PlotlyComponent.propTypes = {
	    data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    config: _propTypes["default"].object,
	    layout: _propTypes["default"].object,
	    frames: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    revision: _propTypes["default"].number,
	    onInitialized: _propTypes["default"].func,
	    onPurge: _propTypes["default"].func,
	    onError: _propTypes["default"].func,
	    onUpdate: _propTypes["default"].func,
	    debug: _propTypes["default"].bool,
	    style: _propTypes["default"].object,
	    className: _propTypes["default"].string,
	    useResizeHandler: _propTypes["default"].bool,
	    divId: _propTypes["default"].string
	  };
	  eventNames.forEach(function (eventName) {
	    PlotlyComponent.propTypes['on' + eventName] = _propTypes["default"].func;
	  });
	  PlotlyComponent.defaultProps = {
	    debug: false,
	    useResizeHandler: false,
	    data: [],
	    style: {
	      position: 'relative',
	      display: 'inline-block'
	    }
	  };
	  return PlotlyComponent;
	}
	
} (factory));

var plotly = {exports: {}};

(function (module, exports) {
	(function webpackUniversalModuleDefinition(root, factory) {
	  module.exports = factory();
	})(self, function() {
	  return (
	    /******/
	    function() {
	      var __webpack_modules__ = {
	        /***/
	        98847: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var rules = {
	              "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
	              "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
	              "X input:focus,X button:focus": "outline:none;",
	              "X a": "text-decoration:none;",
	              "X a:hover": "text-decoration:none;",
	              "X .crisp": "shape-rendering:crispEdges;",
	              "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
	              "X svg": "overflow:hidden;",
	              "X svg a": "fill:#447adb;",
	              "X svg a:hover": "fill:#3c6dc5;",
	              "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
	              "X .main-svg .draglayer": "pointer-events:all;",
	              "X .cursor-default": "cursor:default;",
	              "X .cursor-pointer": "cursor:pointer;",
	              "X .cursor-crosshair": "cursor:crosshair;",
	              "X .cursor-move": "cursor:move;",
	              "X .cursor-col-resize": "cursor:col-resize;",
	              "X .cursor-row-resize": "cursor:row-resize;",
	              "X .cursor-ns-resize": "cursor:ns-resize;",
	              "X .cursor-ew-resize": "cursor:ew-resize;",
	              "X .cursor-sw-resize": "cursor:sw-resize;",
	              "X .cursor-s-resize": "cursor:s-resize;",
	              "X .cursor-se-resize": "cursor:se-resize;",
	              "X .cursor-w-resize": "cursor:w-resize;",
	              "X .cursor-e-resize": "cursor:e-resize;",
	              "X .cursor-nw-resize": "cursor:nw-resize;",
	              "X .cursor-n-resize": "cursor:n-resize;",
	              "X .cursor-ne-resize": "cursor:ne-resize;",
	              "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
	              "X .modebar": "position:absolute;top:2px;right:2px;",
	              "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
	              "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
	              "X:hover .modebar--hover .modebar-group": "opacity:1;",
	              "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
	              "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
	              "X .modebar-btn svg": "position:relative;top:2px;",
	              "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
	              "X .modebar.vertical svg": "top:-1px;",
	              "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
	              "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
	              "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
	              "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
	              "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
	              "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
	              "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
	              "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
	              Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
	              "Y p": "margin:0;",
	              "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
	              "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
	              "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
	            };
	            for (var selector in rules) {
	              var fullSelector = selector.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
	              Lib.addStyleRule(fullSelector, rules[selector]);
	            }
	          }
	        ),
	        /***/
	        98222: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(82887);
	          }
	        ),
	        /***/
	        27206: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(60822);
	          }
	        ),
	        /***/
	        59893: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(23381);
	          }
	        ),
	        /***/
	        5224: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(83832);
	          }
	        ),
	        /***/
	        59509: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(72201);
	          }
	        ),
	        /***/
	        75557: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(91815);
	          }
	        ),
	        /***/
	        40338: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(21462);
	          }
	        ),
	        /***/
	        35080: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(51319);
	          }
	        ),
	        /***/
	        61396: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(57516);
	          }
	        ),
	        /***/
	        40549: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(98128);
	          }
	        ),
	        /***/
	        49866: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(99442);
	          }
	        ),
	        /***/
	        36089: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(93740);
	          }
	        ),
	        /***/
	        19548: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(8729);
	          }
	        ),
	        /***/
	        35831: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(93814);
	          }
	        ),
	        /***/
	        61039: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(14382);
	          }
	        ),
	        /***/
	        97040: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(51759);
	          }
	        ),
	        /***/
	        77986: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(10421);
	          }
	        ),
	        /***/
	        24296: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(43102);
	          }
	        ),
	        /***/
	        58872: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(92165);
	          }
	        ),
	        /***/
	        29626: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(3325);
	          }
	        ),
	        /***/
	        65591: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(36071);
	          }
	        ),
	        /***/
	        69738: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(43905);
	          }
	        ),
	        /***/
	        92650: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(35902);
	          }
	        ),
	        /***/
	        35630: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(69816);
	          }
	        ),
	        /***/
	        73434: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(94507);
	          }
	        ),
	        /***/
	        27909: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Plotly = __webpack_require__2(19548);
	            Plotly.register([
	              // traces
	              __webpack_require__2(27206),
	              __webpack_require__2(5224),
	              __webpack_require__2(58872),
	              __webpack_require__2(65591),
	              __webpack_require__2(69738),
	              __webpack_require__2(92650),
	              __webpack_require__2(49866),
	              __webpack_require__2(25743),
	              __webpack_require__2(6197),
	              __webpack_require__2(97040),
	              __webpack_require__2(85461),
	              __webpack_require__2(73434),
	              __webpack_require__2(54201),
	              __webpack_require__2(81299),
	              __webpack_require__2(47645),
	              __webpack_require__2(35630),
	              __webpack_require__2(77986),
	              __webpack_require__2(83043),
	              __webpack_require__2(93005),
	              __webpack_require__2(96881),
	              __webpack_require__2(4534),
	              __webpack_require__2(50581),
	              __webpack_require__2(40549),
	              __webpack_require__2(77900),
	              __webpack_require__2(47582),
	              __webpack_require__2(35080),
	              __webpack_require__2(21641),
	              __webpack_require__2(17280),
	              __webpack_require__2(5861),
	              __webpack_require__2(29626),
	              __webpack_require__2(10021),
	              __webpack_require__2(65317),
	              __webpack_require__2(96268),
	              __webpack_require__2(61396),
	              __webpack_require__2(35831),
	              __webpack_require__2(16122),
	              __webpack_require__2(46163),
	              __webpack_require__2(40344),
	              __webpack_require__2(40338),
	              __webpack_require__2(48131),
	              __webpack_require__2(36089),
	              __webpack_require__2(55334),
	              __webpack_require__2(75557),
	              __webpack_require__2(19440),
	              __webpack_require__2(99488),
	              __webpack_require__2(59893),
	              __webpack_require__2(97393),
	              // transforms
	              __webpack_require__2(98222),
	              __webpack_require__2(61039),
	              __webpack_require__2(24296),
	              __webpack_require__2(66398),
	              // components
	              __webpack_require__2(59509)
	            ]);
	            module2.exports = Plotly;
	          }
	        ),
	        /***/
	        46163: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(15154);
	          }
	        ),
	        /***/
	        96881: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(64943);
	          }
	        ),
	        /***/
	        50581: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(21164);
	          }
	        ),
	        /***/
	        55334: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(54186);
	          }
	        ),
	        /***/
	        65317: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(94873);
	          }
	        ),
	        /***/
	        10021: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(67618);
	          }
	        ),
	        /***/
	        54201: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(58810);
	          }
	        ),
	        /***/
	        5861: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(20593);
	          }
	        ),
	        /***/
	        16122: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(29396);
	          }
	        ),
	        /***/
	        83043: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(13551);
	          }
	        ),
	        /***/
	        48131: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(46858);
	          }
	        ),
	        /***/
	        47582: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(17988);
	          }
	        ),
	        /***/
	        21641: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(68868);
	          }
	        ),
	        /***/
	        96268: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(20467);
	          }
	        ),
	        /***/
	        19440: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(91271);
	          }
	        ),
	        /***/
	        99488: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(21461);
	          }
	        ),
	        /***/
	        97393: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(85956);
	          }
	        ),
	        /***/
	        25743: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(52979);
	          }
	        ),
	        /***/
	        66398: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(32275);
	          }
	        ),
	        /***/
	        17280: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(6419);
	          }
	        ),
	        /***/
	        77900: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(61510);
	          }
	        ),
	        /***/
	        81299: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(87619);
	          }
	        ),
	        /***/
	        93005: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(93601);
	          }
	        ),
	        /***/
	        40344: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(96595);
	          }
	        ),
	        /***/
	        47645: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(70954);
	          }
	        ),
	        /***/
	        6197: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(47462);
	          }
	        ),
	        /***/
	        4534: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(17659);
	          }
	        ),
	        /***/
	        85461: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(19990);
	          }
	        ),
	        /***/
	        82884: (
	          /***/
	          function(module2) {
	            module2.exports = [
	              // no arrow
	              {
	                path: "",
	                backoff: 0
	              },
	              // wide with flat back
	              {
	                path: "M-2.4,-3V3L0.6,0Z",
	                backoff: 0.6
	              },
	              // narrower with flat back
	              {
	                path: "M-3.7,-2.5V2.5L1.3,0Z",
	                backoff: 1.3
	              },
	              // barbed
	              {
	                path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
	                backoff: 1.55
	              },
	              // wide line-drawn
	              {
	                path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
	                backoff: 1.6
	              },
	              // narrower line-drawn
	              {
	                path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
	                backoff: 2
	              },
	              // circle
	              {
	                path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
	                backoff: 0,
	                noRotate: true
	              },
	              // square
	              {
	                path: "M2,2V-2H-2V2Z",
	                backoff: 0,
	                noRotate: true
	              }
	            ];
	          }
	        ),
	        /***/
	        50215: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var ARROWPATHS = __webpack_require__2(82884);
	            var fontAttrs = __webpack_require__2(41940);
	            var cartesianConstants = __webpack_require__2(85555);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            __webpack_require__2(24695);
	            module2.exports = templatedArray("annotation", {
	              visible: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc+arraydraw"
	              },
	              text: {
	                valType: "string",
	                editType: "calc+arraydraw"
	              },
	              textangle: {
	                valType: "angle",
	                dflt: 0,
	                editType: "calc+arraydraw"
	              },
	              font: fontAttrs({
	                editType: "calc+arraydraw",
	                colorEditType: "arraydraw"
	              }),
	              width: {
	                valType: "number",
	                min: 1,
	                dflt: null,
	                editType: "calc+arraydraw"
	              },
	              height: {
	                valType: "number",
	                min: 1,
	                dflt: null,
	                editType: "calc+arraydraw"
	              },
	              opacity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 1,
	                editType: "arraydraw"
	              },
	              align: {
	                valType: "enumerated",
	                values: ["left", "center", "right"],
	                dflt: "center",
	                editType: "arraydraw"
	              },
	              valign: {
	                valType: "enumerated",
	                values: ["top", "middle", "bottom"],
	                dflt: "middle",
	                editType: "arraydraw"
	              },
	              bgcolor: {
	                valType: "color",
	                dflt: "rgba(0,0,0,0)",
	                editType: "arraydraw"
	              },
	              bordercolor: {
	                valType: "color",
	                dflt: "rgba(0,0,0,0)",
	                editType: "arraydraw"
	              },
	              borderpad: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "calc+arraydraw"
	              },
	              borderwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "calc+arraydraw"
	              },
	              // arrow
	              showarrow: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc+arraydraw"
	              },
	              arrowcolor: {
	                valType: "color",
	                editType: "arraydraw"
	              },
	              arrowhead: {
	                valType: "integer",
	                min: 0,
	                max: ARROWPATHS.length,
	                dflt: 1,
	                editType: "arraydraw"
	              },
	              startarrowhead: {
	                valType: "integer",
	                min: 0,
	                max: ARROWPATHS.length,
	                dflt: 1,
	                editType: "arraydraw"
	              },
	              arrowside: {
	                valType: "flaglist",
	                flags: ["end", "start"],
	                extras: ["none"],
	                dflt: "end",
	                editType: "arraydraw"
	              },
	              arrowsize: {
	                valType: "number",
	                min: 0.3,
	                dflt: 1,
	                editType: "calc+arraydraw"
	              },
	              startarrowsize: {
	                valType: "number",
	                min: 0.3,
	                dflt: 1,
	                editType: "calc+arraydraw"
	              },
	              arrowwidth: {
	                valType: "number",
	                min: 0.1,
	                editType: "calc+arraydraw"
	              },
	              standoff: {
	                valType: "number",
	                min: 0,
	                dflt: 0,
	                editType: "calc+arraydraw"
	              },
	              startstandoff: {
	                valType: "number",
	                min: 0,
	                dflt: 0,
	                editType: "calc+arraydraw"
	              },
	              ax: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              ay: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              axref: {
	                valType: "enumerated",
	                dflt: "pixel",
	                values: ["pixel", cartesianConstants.idRegex.x.toString()],
	                editType: "calc"
	              },
	              ayref: {
	                valType: "enumerated",
	                dflt: "pixel",
	                values: ["pixel", cartesianConstants.idRegex.y.toString()],
	                editType: "calc"
	              },
	              // positioning
	              xref: {
	                valType: "enumerated",
	                values: ["paper", cartesianConstants.idRegex.x.toString()],
	                editType: "calc"
	              },
	              x: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              xanchor: {
	                valType: "enumerated",
	                values: ["auto", "left", "center", "right"],
	                dflt: "auto",
	                editType: "calc+arraydraw"
	              },
	              xshift: {
	                valType: "number",
	                dflt: 0,
	                editType: "calc+arraydraw"
	              },
	              yref: {
	                valType: "enumerated",
	                values: ["paper", cartesianConstants.idRegex.y.toString()],
	                editType: "calc"
	              },
	              y: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["auto", "top", "middle", "bottom"],
	                dflt: "auto",
	                editType: "calc+arraydraw"
	              },
	              yshift: {
	                valType: "number",
	                dflt: 0,
	                editType: "calc+arraydraw"
	              },
	              clicktoshow: {
	                valType: "enumerated",
	                values: [false, "onoff", "onout"],
	                dflt: false,
	                editType: "arraydraw"
	              },
	              xclick: {
	                valType: "any",
	                editType: "arraydraw"
	              },
	              yclick: {
	                valType: "any",
	                editType: "arraydraw"
	              },
	              hovertext: {
	                valType: "string",
	                editType: "arraydraw"
	              },
	              hoverlabel: {
	                bgcolor: {
	                  valType: "color",
	                  editType: "arraydraw"
	                },
	                bordercolor: {
	                  valType: "color",
	                  editType: "arraydraw"
	                },
	                font: fontAttrs({
	                  editType: "arraydraw"
	                }),
	                editType: "arraydraw"
	              },
	              captureevents: {
	                valType: "boolean",
	                editType: "arraydraw"
	              },
	              editType: "calc",
	              _deprecated: {
	                ref: {
	                  valType: "string",
	                  editType: "calc"
	                }
	              }
	            });
	          }
	        ),
	        /***/
	        3749: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var draw = __webpack_require__2(92605).draw;
	            module2.exports = function calcAutorange(gd) {
	              var fullLayout = gd._fullLayout;
	              var annotationList = Lib.filterVisible(fullLayout.annotations);
	              if (annotationList.length && gd._fullData.length) {
	                return Lib.syncOrAsync([draw, annAutorange], gd);
	              }
	            };
	            function annAutorange(gd) {
	              var fullLayout = gd._fullLayout;
	              Lib.filterVisible(fullLayout.annotations).forEach(function(ann) {
	                var xa = Axes.getFromId(gd, ann.xref);
	                var ya = Axes.getFromId(gd, ann.yref);
	                var xRefType = Axes.getRefType(ann.xref);
	                var yRefType = Axes.getRefType(ann.yref);
	                ann._extremes = {};
	                if (xRefType === "range") calcAxisExpansion(ann, xa);
	                if (yRefType === "range") calcAxisExpansion(ann, ya);
	              });
	            }
	            function calcAxisExpansion(ann, ax) {
	              var axId = ax._id;
	              var letter = axId.charAt(0);
	              var pos = ann[letter];
	              var apos = ann["a" + letter];
	              var ref = ann[letter + "ref"];
	              var aref = ann["a" + letter + "ref"];
	              var padplus = ann["_" + letter + "padplus"];
	              var padminus = ann["_" + letter + "padminus"];
	              var shift = {
	                x: 1,
	                y: -1
	              }[letter] * ann[letter + "shift"];
	              var headSize = 3 * ann.arrowsize * ann.arrowwidth || 0;
	              var headPlus = headSize + shift;
	              var headMinus = headSize - shift;
	              var startHeadSize = 3 * ann.startarrowsize * ann.arrowwidth || 0;
	              var startHeadPlus = startHeadSize + shift;
	              var startHeadMinus = startHeadSize - shift;
	              var extremes;
	              if (aref === ref) {
	                var extremeArrowHead = Axes.findExtremes(ax, [ax.r2c(pos)], {
	                  ppadplus: headPlus,
	                  ppadminus: headMinus
	                });
	                var extremeText = Axes.findExtremes(ax, [ax.r2c(apos)], {
	                  ppadplus: Math.max(padplus, startHeadPlus),
	                  ppadminus: Math.max(padminus, startHeadMinus)
	                });
	                extremes = {
	                  min: [extremeArrowHead.min[0], extremeText.min[0]],
	                  max: [extremeArrowHead.max[0], extremeText.max[0]]
	                };
	              } else {
	                startHeadPlus = apos ? startHeadPlus + apos : startHeadPlus;
	                startHeadMinus = apos ? startHeadMinus - apos : startHeadMinus;
	                extremes = Axes.findExtremes(ax, [ax.r2c(pos)], {
	                  ppadplus: Math.max(padplus, headPlus, startHeadPlus),
	                  ppadminus: Math.max(padminus, headMinus, startHeadMinus)
	                });
	              }
	              ann._extremes[axId] = extremes;
	            }
	          }
	        ),
	        /***/
	        44317: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var arrayEditor = __webpack_require__2(44467).arrayEditor;
	            module2.exports = {
	              hasClickToShow,
	              onClick
	            };
	            function hasClickToShow(gd, hoverData) {
	              var sets = getToggleSets(gd, hoverData);
	              return sets.on.length > 0 || sets.explicitOff.length > 0;
	            }
	            function onClick(gd, hoverData) {
	              var toggleSets = getToggleSets(gd, hoverData);
	              var onSet = toggleSets.on;
	              var offSet = toggleSets.off.concat(toggleSets.explicitOff);
	              var update = {};
	              var annotationsOut = gd._fullLayout.annotations;
	              var i, editHelpers;
	              if (!(onSet.length || offSet.length)) return;
	              for (i = 0; i < onSet.length; i++) {
	                editHelpers = arrayEditor(gd.layout, "annotations", annotationsOut[onSet[i]]);
	                editHelpers.modifyItem("visible", true);
	                Lib.extendFlat(update, editHelpers.getUpdateObj());
	              }
	              for (i = 0; i < offSet.length; i++) {
	                editHelpers = arrayEditor(gd.layout, "annotations", annotationsOut[offSet[i]]);
	                editHelpers.modifyItem("visible", false);
	                Lib.extendFlat(update, editHelpers.getUpdateObj());
	              }
	              return Registry.call("update", gd, {}, update);
	            }
	            function getToggleSets(gd, hoverData) {
	              var annotations = gd._fullLayout.annotations;
	              var onSet = [];
	              var offSet = [];
	              var explicitOffSet = [];
	              var hoverLen = (hoverData || []).length;
	              var i, j, anni, showMode, pointj, xa, ya, toggleType;
	              for (i = 0; i < annotations.length; i++) {
	                anni = annotations[i];
	                showMode = anni.clicktoshow;
	                if (showMode) {
	                  for (j = 0; j < hoverLen; j++) {
	                    pointj = hoverData[j];
	                    xa = pointj.xaxis;
	                    ya = pointj.yaxis;
	                    if (xa._id === anni.xref && ya._id === anni.yref && xa.d2r(pointj.x) === clickData2r(anni._xclick, xa) && ya.d2r(pointj.y) === clickData2r(anni._yclick, ya)) {
	                      if (anni.visible) {
	                        if (showMode === "onout") toggleType = offSet;
	                        else toggleType = explicitOffSet;
	                      } else {
	                        toggleType = onSet;
	                      }
	                      toggleType.push(i);
	                      break;
	                    }
	                  }
	                  if (j === hoverLen) {
	                    if (anni.visible && showMode === "onout") offSet.push(i);
	                  }
	                }
	              }
	              return {
	                on: onSet,
	                off: offSet,
	                explicitOff: explicitOffSet
	              };
	            }
	            function clickData2r(d, ax) {
	              return ax.type === "log" ? ax.l2r(d) : ax.d2r(d);
	            }
	          }
	        ),
	        /***/
	        25625: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            module2.exports = function handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce) {
	              coerce("opacity");
	              var bgColor = coerce("bgcolor");
	              var borderColor = coerce("bordercolor");
	              var borderOpacity = Color.opacity(borderColor);
	              coerce("borderpad");
	              var borderWidth = coerce("borderwidth");
	              var showArrow = coerce("showarrow");
	              coerce("text", showArrow ? " " : fullLayout._dfltTitle.annotation);
	              coerce("textangle");
	              Lib.coerceFont(coerce, "font", fullLayout.font);
	              coerce("width");
	              coerce("align");
	              var h = coerce("height");
	              if (h) coerce("valign");
	              if (showArrow) {
	                var arrowside = coerce("arrowside");
	                var arrowhead;
	                var arrowsize;
	                if (arrowside.indexOf("end") !== -1) {
	                  arrowhead = coerce("arrowhead");
	                  arrowsize = coerce("arrowsize");
	                }
	                if (arrowside.indexOf("start") !== -1) {
	                  coerce("startarrowhead", arrowhead);
	                  coerce("startarrowsize", arrowsize);
	                }
	                coerce("arrowcolor", borderOpacity ? annOut.bordercolor : Color.defaultLine);
	                coerce("arrowwidth", (borderOpacity && borderWidth || 1) * 2);
	                coerce("standoff");
	                coerce("startstandoff");
	              }
	              var hoverText = coerce("hovertext");
	              var globalHoverLabel = fullLayout.hoverlabel || {};
	              if (hoverText) {
	                var hoverBG = coerce("hoverlabel.bgcolor", globalHoverLabel.bgcolor || (Color.opacity(bgColor) ? Color.rgb(bgColor) : Color.defaultLine));
	                var hoverBorder = coerce("hoverlabel.bordercolor", globalHoverLabel.bordercolor || Color.contrast(hoverBG));
	                Lib.coerceFont(coerce, "hoverlabel.font", {
	                  family: globalHoverLabel.font.family,
	                  size: globalHoverLabel.font.size,
	                  color: globalHoverLabel.font.color || hoverBorder
	                });
	              }
	              coerce("captureevents", !!hoverText);
	            };
	          }
	        ),
	        /***/
	        94128: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var toLogRange = __webpack_require__2(58163);
	            module2.exports = function convertCoords(gd, ax, newType, doExtra) {
	              ax = ax || {};
	              var toLog = newType === "log" && ax.type === "linear";
	              var fromLog = newType === "linear" && ax.type === "log";
	              if (!(toLog || fromLog)) return;
	              var annotations = gd._fullLayout.annotations;
	              var axLetter = ax._id.charAt(0);
	              var ann;
	              var attrPrefix;
	              function convert(attr) {
	                var currentVal = ann[attr];
	                var newVal = null;
	                if (toLog) newVal = toLogRange(currentVal, ax.range);
	                else newVal = Math.pow(10, currentVal);
	                if (!isNumeric(newVal)) newVal = null;
	                doExtra(attrPrefix + attr, newVal);
	              }
	              for (var i = 0; i < annotations.length; i++) {
	                ann = annotations[i];
	                attrPrefix = "annotations[" + i + "].";
	                if (ann[axLetter + "ref"] === ax._id) convert(axLetter);
	                if (ann["a" + axLetter + "ref"] === ax._id) convert("a" + axLetter);
	              }
	            };
	          }
	        ),
	        /***/
	        84046: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var handleAnnotationCommonDefaults = __webpack_require__2(25625);
	            var attributes = __webpack_require__2(50215);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              handleArrayContainerDefaults(layoutIn, layoutOut, {
	                name: "annotations",
	                handleItemDefaults: handleAnnotationDefaults
	              });
	            };
	            function handleAnnotationDefaults(annIn, annOut, fullLayout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(annIn, annOut, attributes, attr, dflt);
	              }
	              var visible = coerce("visible");
	              var clickToShow = coerce("clicktoshow");
	              if (!(visible || clickToShow)) return;
	              handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce);
	              var showArrow = annOut.showarrow;
	              var axLetters = ["x", "y"];
	              var arrowPosDflt = [-10, -30];
	              var gdMock = {
	                _fullLayout: fullLayout
	              };
	              for (var i = 0; i < 2; i++) {
	                var axLetter = axLetters[i];
	                var axRef = Axes.coerceRef(annIn, annOut, gdMock, axLetter, "", "paper");
	                if (axRef !== "paper") {
	                  var ax = Axes.getFromId(gdMock, axRef);
	                  ax._annIndices.push(annOut._index);
	                }
	                Axes.coercePosition(annOut, gdMock, coerce, axRef, axLetter, 0.5);
	                if (showArrow) {
	                  var arrowPosAttr = "a" + axLetter;
	                  var aaxRef = Axes.coerceRef(annIn, annOut, gdMock, arrowPosAttr, "pixel", ["pixel", "paper"]);
	                  if (aaxRef !== "pixel" && aaxRef !== axRef) {
	                    aaxRef = annOut[arrowPosAttr] = "pixel";
	                  }
	                  var aDflt = aaxRef === "pixel" ? arrowPosDflt[i] : 0.4;
	                  Axes.coercePosition(annOut, gdMock, coerce, aaxRef, arrowPosAttr, aDflt);
	                }
	                coerce(axLetter + "anchor");
	                coerce(axLetter + "shift");
	              }
	              Lib.noneOrAll(annIn, annOut, ["x", "y"]);
	              if (showArrow) {
	                Lib.noneOrAll(annIn, annOut, ["ax", "ay"]);
	              }
	              if (clickToShow) {
	                var xClick = coerce("xclick");
	                var yClick = coerce("yclick");
	                annOut._xclick = xClick === undefined ? annOut.x : Axes.cleanPosition(xClick, gdMock, annOut.xref);
	                annOut._yclick = yClick === undefined ? annOut.y : Axes.cleanPosition(yClick, gdMock, annOut.yref);
	              }
	            }
	          }
	        ),
	        /***/
	        92605: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Plots = __webpack_require__2(74875);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var Axes = __webpack_require__2(89298);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Fx = __webpack_require__2(30211);
	            var svgTextUtils = __webpack_require__2(63893);
	            var setCursor = __webpack_require__2(6964);
	            var dragElement = __webpack_require__2(28569);
	            var arrayEditor = __webpack_require__2(44467).arrayEditor;
	            var drawArrowHead = __webpack_require__2(13011);
	            module2.exports = {
	              draw,
	              drawOne,
	              drawRaw
	            };
	            function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              fullLayout._infolayer.selectAll(".annotation").remove();
	              for (var i = 0; i < fullLayout.annotations.length; i++) {
	                if (fullLayout.annotations[i].visible) {
	                  drawOne(gd, i);
	                }
	              }
	              return Plots.previousPromises(gd);
	            }
	            function drawOne(gd, index) {
	              var fullLayout = gd._fullLayout;
	              var options = fullLayout.annotations[index] || {};
	              var xa = Axes.getFromId(gd, options.xref);
	              var ya = Axes.getFromId(gd, options.yref);
	              if (xa) xa.setScale();
	              if (ya) ya.setScale();
	              drawRaw(gd, options, index, false, xa, ya);
	            }
	            function shiftPosition(axa, dAx, axLetter, gs, options) {
	              var optAx = options[axLetter];
	              var axRef = options[axLetter + "ref"];
	              var vertical = axLetter.indexOf("y") !== -1;
	              var axDomainRef = Axes.getRefType(axRef) === "domain";
	              var gsDim = vertical ? gs.h : gs.w;
	              if (axa) {
	                if (axDomainRef) {
	                  return optAx + (vertical ? -dAx : dAx) / axa._length;
	                } else {
	                  return axa.p2r(axa.r2p(optAx) + dAx);
	                }
	              } else {
	                return optAx + (vertical ? -dAx : dAx) / gsDim;
	              }
	            }
	            function drawRaw(gd, options, index, subplotId, xa, ya) {
	              var fullLayout = gd._fullLayout;
	              var gs = gd._fullLayout._size;
	              var edits = gd._context.edits;
	              var className, containerStr;
	              if (subplotId) {
	                className = "annotation-" + subplotId;
	                containerStr = subplotId + ".annotations";
	              } else {
	                className = "annotation";
	                containerStr = "annotations";
	              }
	              var editHelpers = arrayEditor(gd.layout, containerStr, options);
	              var modifyBase = editHelpers.modifyBase;
	              var modifyItem = editHelpers.modifyItem;
	              var getUpdateObj = editHelpers.getUpdateObj;
	              fullLayout._infolayer.selectAll("." + className + '[data-index="' + index + '"]').remove();
	              var annClipID = "clip" + fullLayout._uid + "_ann" + index;
	              if (!options._input || options.visible === false) {
	                d3.selectAll("#" + annClipID).remove();
	                return;
	              }
	              var annPosPx = {
	                x: {},
	                y: {}
	              };
	              var textangle = +options.textangle || 0;
	              var annGroup = fullLayout._infolayer.append("g").classed(className, true).attr("data-index", String(index)).style("opacity", options.opacity);
	              var annTextGroup = annGroup.append("g").classed("annotation-text-g", true);
	              var editTextPosition = edits[options.showarrow ? "annotationTail" : "annotationPosition"];
	              var textEvents = options.captureevents || edits.annotationText || editTextPosition;
	              function makeEventData(initialEvent) {
	                var eventData = {
	                  index,
	                  annotation: options._input,
	                  fullAnnotation: options,
	                  event: initialEvent
	                };
	                if (subplotId) {
	                  eventData.subplotId = subplotId;
	                }
	                return eventData;
	              }
	              var annTextGroupInner = annTextGroup.append("g").style("pointer-events", textEvents ? "all" : null).call(setCursor, "pointer").on("click", function() {
	                gd._dragging = false;
	                gd.emit("plotly_clickannotation", makeEventData(d3.event));
	              });
	              if (options.hovertext) {
	                annTextGroupInner.on("mouseover", function() {
	                  var hoverOptions = options.hoverlabel;
	                  var hoverFont = hoverOptions.font;
	                  var bBox = this.getBoundingClientRect();
	                  var bBoxRef = gd.getBoundingClientRect();
	                  Fx.loneHover({
	                    x0: bBox.left - bBoxRef.left,
	                    x1: bBox.right - bBoxRef.left,
	                    y: (bBox.top + bBox.bottom) / 2 - bBoxRef.top,
	                    text: options.hovertext,
	                    color: hoverOptions.bgcolor,
	                    borderColor: hoverOptions.bordercolor,
	                    fontFamily: hoverFont.family,
	                    fontSize: hoverFont.size,
	                    fontColor: hoverFont.color
	                  }, {
	                    container: fullLayout._hoverlayer.node(),
	                    outerContainer: fullLayout._paper.node(),
	                    gd
	                  });
	                }).on("mouseout", function() {
	                  Fx.loneUnhover(fullLayout._hoverlayer.node());
	                });
	              }
	              var borderwidth = options.borderwidth;
	              var borderpad = options.borderpad;
	              var borderfull = borderwidth + borderpad;
	              var annTextBG = annTextGroupInner.append("rect").attr("class", "bg").style("stroke-width", borderwidth + "px").call(Color.stroke, options.bordercolor).call(Color.fill, options.bgcolor);
	              var isSizeConstrained = options.width || options.height;
	              var annTextClip = fullLayout._topclips.selectAll("#" + annClipID).data(isSizeConstrained ? [0] : []);
	              annTextClip.enter().append("clipPath").classed("annclip", true).attr("id", annClipID).append("rect");
	              annTextClip.exit().remove();
	              var font = options.font;
	              var text = fullLayout._meta ? Lib.templateString(options.text, fullLayout._meta) : options.text;
	              var annText = annTextGroupInner.append("text").classed("annotation-text", true).text(text);
	              function textLayout(s) {
	                s.call(Drawing.font, font).attr({
	                  "text-anchor": {
	                    left: "start",
	                    right: "end"
	                  }[options.align] || "middle"
	                });
	                svgTextUtils.convertToTspans(s, gd, drawGraphicalElements);
	                return s;
	              }
	              function drawGraphicalElements() {
	                var anchor3 = annText.selectAll("a");
	                if (anchor3.size() === 1 && anchor3.text() === annText.text()) {
	                  var wholeLink = annTextGroupInner.insert("a", ":first-child").attr({
	                    "xlink:xlink:href": anchor3.attr("xlink:href"),
	                    "xlink:xlink:show": anchor3.attr("xlink:show")
	                  }).style({
	                    cursor: "pointer"
	                  });
	                  wholeLink.node().appendChild(annTextBG.node());
	                }
	                var mathjaxGroup = annTextGroupInner.select(".annotation-text-math-group");
	                var hasMathjax = !mathjaxGroup.empty();
	                var anntextBB = Drawing.bBox((hasMathjax ? mathjaxGroup : annText).node());
	                var textWidth = anntextBB.width;
	                var textHeight = anntextBB.height;
	                var annWidth = options.width || textWidth;
	                var annHeight = options.height || textHeight;
	                var outerWidth = Math.round(annWidth + 2 * borderfull);
	                var outerHeight = Math.round(annHeight + 2 * borderfull);
	                function shiftFraction(v, anchor2) {
	                  if (anchor2 === "auto") {
	                    if (v < 1 / 3) anchor2 = "left";
	                    else if (v > 2 / 3) anchor2 = "right";
	                    else anchor2 = "center";
	                  }
	                  return {
	                    center: 0,
	                    middle: 0,
	                    left: 0.5,
	                    bottom: -0.5,
	                    right: -0.5,
	                    top: 0.5
	                  }[anchor2];
	                }
	                var annotationIsOffscreen = false;
	                var letters = ["x", "y"];
	                for (var i = 0; i < letters.length; i++) {
	                  var axLetter = letters[i];
	                  var axRef = options[axLetter + "ref"] || axLetter;
	                  var tailRef = options["a" + axLetter + "ref"];
	                  var ax = {
	                    x: xa,
	                    y: ya
	                  }[axLetter];
	                  var dimAngle = (textangle + (axLetter === "x" ? 0 : -90)) * Math.PI / 180;
	                  var annSizeFromWidth = outerWidth * Math.cos(dimAngle);
	                  var annSizeFromHeight = outerHeight * Math.sin(dimAngle);
	                  var annSize = Math.abs(annSizeFromWidth) + Math.abs(annSizeFromHeight);
	                  var anchor = options[axLetter + "anchor"];
	                  var overallShift = options[axLetter + "shift"] * (axLetter === "x" ? 1 : -1);
	                  var posPx = annPosPx[axLetter];
	                  var basePx;
	                  var textPadShift;
	                  var alignPosition;
	                  var autoAlignFraction;
	                  var textShift;
	                  var axRefType = Axes.getRefType(axRef);
	                  if (ax && axRefType !== "domain") {
	                    var posFraction = ax.r2fraction(options[axLetter]);
	                    if (posFraction < 0 || posFraction > 1) {
	                      if (tailRef === axRef) {
	                        posFraction = ax.r2fraction(options["a" + axLetter]);
	                        if (posFraction < 0 || posFraction > 1) {
	                          annotationIsOffscreen = true;
	                        }
	                      } else {
	                        annotationIsOffscreen = true;
	                      }
	                    }
	                    basePx = ax._offset + ax.r2p(options[axLetter]);
	                    autoAlignFraction = 0.5;
	                  } else {
	                    var axRefTypeEqDomain = axRefType === "domain";
	                    if (axLetter === "x") {
	                      alignPosition = options[axLetter];
	                      basePx = axRefTypeEqDomain ? ax._offset + ax._length * alignPosition : basePx = gs.l + gs.w * alignPosition;
	                    } else {
	                      alignPosition = 1 - options[axLetter];
	                      basePx = axRefTypeEqDomain ? ax._offset + ax._length * alignPosition : basePx = gs.t + gs.h * alignPosition;
	                    }
	                    autoAlignFraction = options.showarrow ? 0.5 : alignPosition;
	                  }
	                  if (options.showarrow) {
	                    posPx.head = basePx;
	                    var arrowLength = options["a" + axLetter];
	                    textShift = annSizeFromWidth * shiftFraction(0.5, options.xanchor) - annSizeFromHeight * shiftFraction(0.5, options.yanchor);
	                    if (tailRef === axRef) {
	                      var tailRefType = Axes.getRefType(tailRef);
	                      if (tailRefType === "domain") {
	                        if (axLetter === "y") {
	                          arrowLength = 1 - arrowLength;
	                        }
	                        posPx.tail = ax._offset + ax._length * arrowLength;
	                      } else if (tailRefType === "paper") {
	                        if (axLetter === "y") {
	                          arrowLength = 1 - arrowLength;
	                          posPx.tail = gs.t + gs.h * arrowLength;
	                        } else {
	                          posPx.tail = gs.l + gs.w * arrowLength;
	                        }
	                      } else {
	                        posPx.tail = ax._offset + ax.r2p(arrowLength);
	                      }
	                      textPadShift = textShift;
	                    } else {
	                      posPx.tail = basePx + arrowLength;
	                      textPadShift = textShift + arrowLength;
	                    }
	                    posPx.text = posPx.tail + textShift;
	                    var maxPx = fullLayout[axLetter === "x" ? "width" : "height"];
	                    if (axRef === "paper") {
	                      posPx.head = Lib.constrain(posPx.head, 1, maxPx - 1);
	                    }
	                    if (tailRef === "pixel") {
	                      var shiftPlus = -Math.max(posPx.tail - 3, posPx.text);
	                      var shiftMinus = Math.min(posPx.tail + 3, posPx.text) - maxPx;
	                      if (shiftPlus > 0) {
	                        posPx.tail += shiftPlus;
	                        posPx.text += shiftPlus;
	                      } else if (shiftMinus > 0) {
	                        posPx.tail -= shiftMinus;
	                        posPx.text -= shiftMinus;
	                      }
	                    }
	                    posPx.tail += overallShift;
	                    posPx.head += overallShift;
	                  } else {
	                    textShift = annSize * shiftFraction(autoAlignFraction, anchor);
	                    textPadShift = textShift;
	                    posPx.text = basePx + textShift;
	                  }
	                  posPx.text += overallShift;
	                  textShift += overallShift;
	                  textPadShift += overallShift;
	                  options["_" + axLetter + "padplus"] = annSize / 2 + textPadShift;
	                  options["_" + axLetter + "padminus"] = annSize / 2 - textPadShift;
	                  options["_" + axLetter + "size"] = annSize;
	                  options["_" + axLetter + "shift"] = textShift;
	                }
	                if (annotationIsOffscreen) {
	                  annTextGroupInner.remove();
	                  return;
	                }
	                var xShift = 0;
	                var yShift = 0;
	                if (options.align !== "left") {
	                  xShift = (annWidth - textWidth) * (options.align === "center" ? 0.5 : 1);
	                }
	                if (options.valign !== "top") {
	                  yShift = (annHeight - textHeight) * (options.valign === "middle" ? 0.5 : 1);
	                }
	                if (hasMathjax) {
	                  mathjaxGroup.select("svg").attr({
	                    x: borderfull + xShift - 1,
	                    y: borderfull + yShift
	                  }).call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
	                } else {
	                  var texty = borderfull + yShift - anntextBB.top;
	                  var textx = borderfull + xShift - anntextBB.left;
	                  annText.call(svgTextUtils.positionText, textx, texty).call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
	                }
	                annTextClip.select("rect").call(Drawing.setRect, borderfull, borderfull, annWidth, annHeight);
	                annTextBG.call(Drawing.setRect, borderwidth / 2, borderwidth / 2, outerWidth - borderwidth, outerHeight - borderwidth);
	                annTextGroupInner.call(Drawing.setTranslate, Math.round(annPosPx.x.text - outerWidth / 2), Math.round(annPosPx.y.text - outerHeight / 2));
	                annTextGroup.attr({
	                  transform: "rotate(" + textangle + "," + annPosPx.x.text + "," + annPosPx.y.text + ")"
	                });
	                var drawArrow = function(dx, dy) {
	                  annGroup.selectAll(".annotation-arrow-g").remove();
	                  var headX = annPosPx.x.head;
	                  var headY = annPosPx.y.head;
	                  var tailX = annPosPx.x.tail + dx;
	                  var tailY = annPosPx.y.tail + dy;
	                  var textX = annPosPx.x.text + dx;
	                  var textY = annPosPx.y.text + dy;
	                  var transform = Lib.rotationXYMatrix(textangle, textX, textY);
	                  var applyTransform = Lib.apply2DTransform(transform);
	                  var applyTransform2 = Lib.apply2DTransform2(transform);
	                  var width = +annTextBG.attr("width");
	                  var height = +annTextBG.attr("height");
	                  var xLeft = textX - 0.5 * width;
	                  var xRight = xLeft + width;
	                  var yTop = textY - 0.5 * height;
	                  var yBottom = yTop + height;
	                  var edges = [[xLeft, yTop, xLeft, yBottom], [xLeft, yBottom, xRight, yBottom], [xRight, yBottom, xRight, yTop], [xRight, yTop, xLeft, yTop]].map(applyTransform2);
	                  if (edges.reduce(function(a, x) {
	                    return a ^ !!Lib.segmentsIntersect(headX, headY, headX + 1e6, headY + 1e6, x[0], x[1], x[2], x[3]);
	                  }, false)) {
	                    return;
	                  }
	                  edges.forEach(function(x) {
	                    var p = Lib.segmentsIntersect(tailX, tailY, headX, headY, x[0], x[1], x[2], x[3]);
	                    if (p) {
	                      tailX = p.x;
	                      tailY = p.y;
	                    }
	                  });
	                  var strokewidth = options.arrowwidth;
	                  var arrowColor = options.arrowcolor;
	                  var arrowSide = options.arrowside;
	                  var arrowGroup = annGroup.append("g").style({
	                    opacity: Color.opacity(arrowColor)
	                  }).classed("annotation-arrow-g", true);
	                  var arrow = arrowGroup.append("path").attr("d", "M" + tailX + "," + tailY + "L" + headX + "," + headY).style("stroke-width", strokewidth + "px").call(Color.stroke, Color.rgb(arrowColor));
	                  drawArrowHead(arrow, arrowSide, options);
	                  if (edits.annotationPosition && arrow.node().parentNode && !subplotId) {
	                    var arrowDragHeadX = headX;
	                    var arrowDragHeadY = headY;
	                    if (options.standoff) {
	                      var arrowLength2 = Math.sqrt(Math.pow(headX - tailX, 2) + Math.pow(headY - tailY, 2));
	                      arrowDragHeadX += options.standoff * (tailX - headX) / arrowLength2;
	                      arrowDragHeadY += options.standoff * (tailY - headY) / arrowLength2;
	                    }
	                    var arrowDrag = arrowGroup.append("path").classed("annotation-arrow", true).classed("anndrag", true).classed("cursor-move", true).attr({
	                      d: "M3,3H-3V-3H3ZM0,0L" + (tailX - arrowDragHeadX) + "," + (tailY - arrowDragHeadY),
	                      transform: strTranslate(arrowDragHeadX, arrowDragHeadY)
	                    }).style("stroke-width", strokewidth + 6 + "px").call(Color.stroke, "rgba(0,0,0,0)").call(Color.fill, "rgba(0,0,0,0)");
	                    var annx0, anny0;
	                    dragElement.init({
	                      element: arrowDrag.node(),
	                      gd,
	                      prepFn: function() {
	                        var pos = Drawing.getTranslate(annTextGroupInner);
	                        annx0 = pos.x;
	                        anny0 = pos.y;
	                        if (xa && xa.autorange) {
	                          modifyBase(xa._name + ".autorange", true);
	                        }
	                        if (ya && ya.autorange) {
	                          modifyBase(ya._name + ".autorange", true);
	                        }
	                      },
	                      moveFn: function(dx2, dy2) {
	                        var annxy0 = applyTransform(annx0, anny0);
	                        var xcenter = annxy0[0] + dx2;
	                        var ycenter = annxy0[1] + dy2;
	                        annTextGroupInner.call(Drawing.setTranslate, xcenter, ycenter);
	                        modifyItem("x", shiftPosition(xa, dx2, "x", gs, options));
	                        modifyItem("y", shiftPosition(ya, dy2, "y", gs, options));
	                        if (options.axref === options.xref) {
	                          modifyItem("ax", shiftPosition(xa, dx2, "ax", gs, options));
	                        }
	                        if (options.ayref === options.yref) {
	                          modifyItem("ay", shiftPosition(ya, dy2, "ay", gs, options));
	                        }
	                        arrowGroup.attr("transform", strTranslate(dx2, dy2));
	                        annTextGroup.attr({
	                          transform: "rotate(" + textangle + "," + xcenter + "," + ycenter + ")"
	                        });
	                      },
	                      doneFn: function() {
	                        Registry.call("_guiRelayout", gd, getUpdateObj());
	                        var notesBox = document.querySelector(".js-notes-box-panel");
	                        if (notesBox) notesBox.redraw(notesBox.selectedObj);
	                      }
	                    });
	                  }
	                };
	                if (options.showarrow) drawArrow(0, 0);
	                if (editTextPosition) {
	                  var baseTextTransform;
	                  dragElement.init({
	                    element: annTextGroupInner.node(),
	                    gd,
	                    prepFn: function() {
	                      baseTextTransform = annTextGroup.attr("transform");
	                    },
	                    moveFn: function(dx, dy) {
	                      var csr = "pointer";
	                      if (options.showarrow) {
	                        if (options.axref === options.xref) {
	                          modifyItem("ax", shiftPosition(xa, dx, "ax", gs, options));
	                        } else {
	                          modifyItem("ax", options.ax + dx);
	                        }
	                        if (options.ayref === options.yref) {
	                          modifyItem("ay", shiftPosition(ya, dy, "ay", gs.w, options));
	                        } else {
	                          modifyItem("ay", options.ay + dy);
	                        }
	                        drawArrow(dx, dy);
	                      } else if (!subplotId) {
	                        var xUpdate, yUpdate;
	                        if (xa) {
	                          xUpdate = shiftPosition(xa, dx, "x", gs, options);
	                        } else {
	                          var widthFraction = options._xsize / gs.w;
	                          var xLeft = options.x + (options._xshift - options.xshift) / gs.w - widthFraction / 2;
	                          xUpdate = dragElement.align(xLeft + dx / gs.w, widthFraction, 0, 1, options.xanchor);
	                        }
	                        if (ya) {
	                          yUpdate = shiftPosition(ya, dy, "y", gs, options);
	                        } else {
	                          var heightFraction = options._ysize / gs.h;
	                          var yBottom = options.y - (options._yshift + options.yshift) / gs.h - heightFraction / 2;
	                          yUpdate = dragElement.align(yBottom - dy / gs.h, heightFraction, 0, 1, options.yanchor);
	                        }
	                        modifyItem("x", xUpdate);
	                        modifyItem("y", yUpdate);
	                        if (!xa || !ya) {
	                          csr = dragElement.getCursor(xa ? 0.5 : xUpdate, ya ? 0.5 : yUpdate, options.xanchor, options.yanchor);
	                        }
	                      } else return;
	                      annTextGroup.attr({
	                        transform: strTranslate(dx, dy) + baseTextTransform
	                      });
	                      setCursor(annTextGroupInner, csr);
	                    },
	                    clickFn: function(_, initialEvent) {
	                      if (options.captureevents) {
	                        gd.emit("plotly_clickannotation", makeEventData(initialEvent));
	                      }
	                    },
	                    doneFn: function() {
	                      setCursor(annTextGroupInner);
	                      Registry.call("_guiRelayout", gd, getUpdateObj());
	                      var notesBox = document.querySelector(".js-notes-box-panel");
	                      if (notesBox) notesBox.redraw(notesBox.selectedObj);
	                    }
	                  });
	                }
	              }
	              if (edits.annotationText) {
	                annText.call(svgTextUtils.makeEditable, {
	                  delegate: annTextGroupInner,
	                  gd
	                }).call(textLayout).on("edit", function(_text) {
	                  options.text = _text;
	                  this.call(textLayout);
	                  modifyItem("text", _text);
	                  if (xa && xa.autorange) {
	                    modifyBase(xa._name + ".autorange", true);
	                  }
	                  if (ya && ya.autorange) {
	                    modifyBase(ya._name + ".autorange", true);
	                  }
	                  Registry.call("_guiRelayout", gd, getUpdateObj());
	                });
	              } else annText.call(textLayout);
	            }
	          }
	        ),
	        /***/
	        13011: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var ARROWPATHS = __webpack_require__2(82884);
	            var Lib = __webpack_require__2(71828);
	            var strScale = Lib.strScale;
	            var strRotate = Lib.strRotate;
	            var strTranslate = Lib.strTranslate;
	            module2.exports = function drawArrowHead(el3, ends, options) {
	              var el = el3.node();
	              var headStyle = ARROWPATHS[options.arrowhead || 0];
	              var startHeadStyle = ARROWPATHS[options.startarrowhead || 0];
	              var scale = (options.arrowwidth || 1) * (options.arrowsize || 1);
	              var startScale = (options.arrowwidth || 1) * (options.startarrowsize || 1);
	              var doStart = ends.indexOf("start") >= 0;
	              var doEnd = ends.indexOf("end") >= 0;
	              var backOff = headStyle.backoff * scale + options.standoff;
	              var startBackOff = startHeadStyle.backoff * startScale + options.startstandoff;
	              var start, end, startRot, endRot;
	              if (el.nodeName === "line") {
	                start = {
	                  x: +el3.attr("x1"),
	                  y: +el3.attr("y1")
	                };
	                end = {
	                  x: +el3.attr("x2"),
	                  y: +el3.attr("y2")
	                };
	                var dx = start.x - end.x;
	                var dy = start.y - end.y;
	                startRot = Math.atan2(dy, dx);
	                endRot = startRot + Math.PI;
	                if (backOff && startBackOff) {
	                  if (backOff + startBackOff > Math.sqrt(dx * dx + dy * dy)) {
	                    hideLine();
	                    return;
	                  }
	                }
	                if (backOff) {
	                  if (backOff * backOff > dx * dx + dy * dy) {
	                    hideLine();
	                    return;
	                  }
	                  var backOffX = backOff * Math.cos(startRot);
	                  var backOffY = backOff * Math.sin(startRot);
	                  end.x += backOffX;
	                  end.y += backOffY;
	                  el3.attr({
	                    x2: end.x,
	                    y2: end.y
	                  });
	                }
	                if (startBackOff) {
	                  if (startBackOff * startBackOff > dx * dx + dy * dy) {
	                    hideLine();
	                    return;
	                  }
	                  var startBackOffX = startBackOff * Math.cos(startRot);
	                  var startbackOffY = startBackOff * Math.sin(startRot);
	                  start.x -= startBackOffX;
	                  start.y -= startbackOffY;
	                  el3.attr({
	                    x1: start.x,
	                    y1: start.y
	                  });
	                }
	              } else if (el.nodeName === "path") {
	                var pathlen = el.getTotalLength();
	                var dashArray = "";
	                if (pathlen < backOff + startBackOff) {
	                  hideLine();
	                  return;
	                }
	                var start0 = el.getPointAtLength(0);
	                var dstart = el.getPointAtLength(0.1);
	                startRot = Math.atan2(start0.y - dstart.y, start0.x - dstart.x);
	                start = el.getPointAtLength(Math.min(startBackOff, pathlen));
	                dashArray = "0px," + startBackOff + "px,";
	                var end0 = el.getPointAtLength(pathlen);
	                var dend = el.getPointAtLength(pathlen - 0.1);
	                endRot = Math.atan2(end0.y - dend.y, end0.x - dend.x);
	                end = el.getPointAtLength(Math.max(0, pathlen - backOff));
	                var shortening = dashArray ? startBackOff + backOff : backOff;
	                dashArray += pathlen - shortening + "px," + pathlen + "px";
	                el3.style("stroke-dasharray", dashArray);
	              }
	              function hideLine() {
	                el3.style("stroke-dasharray", "0px,100px");
	              }
	              function drawhead(arrowHeadStyle, p, rot, arrowScale) {
	                if (!arrowHeadStyle.path) return;
	                if (arrowHeadStyle.noRotate) rot = 0;
	                d3.select(el.parentNode).append("path").attr({
	                  class: el3.attr("class"),
	                  d: arrowHeadStyle.path,
	                  transform: strTranslate(p.x, p.y) + strRotate(rot * 180 / Math.PI) + strScale(arrowScale)
	                }).style({
	                  fill: Color.rgb(options.arrowcolor),
	                  "stroke-width": 0
	                });
	              }
	              if (doStart) drawhead(startHeadStyle, start, startRot, startScale);
	              if (doEnd) drawhead(headStyle, end, endRot, scale);
	            };
	          }
	        ),
	        /***/
	        32745: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var drawModule = __webpack_require__2(92605);
	            var clickModule = __webpack_require__2(44317);
	            module2.exports = {
	              moduleType: "component",
	              name: "annotations",
	              layoutAttributes: __webpack_require__2(50215),
	              supplyLayoutDefaults: __webpack_require__2(84046),
	              includeBasePlot: __webpack_require__2(76325)("annotations"),
	              calcAutorange: __webpack_require__2(3749),
	              draw: drawModule.draw,
	              drawOne: drawModule.drawOne,
	              drawRaw: drawModule.drawRaw,
	              hasClickToShow: clickModule.hasClickToShow,
	              onClick: clickModule.onClick,
	              convertCoords: __webpack_require__2(94128)
	            };
	          }
	        ),
	        /***/
	        26997: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var annAttrs = __webpack_require__2(50215);
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            module2.exports = overrideAll(templatedArray("annotation", {
	              visible: annAttrs.visible,
	              x: {
	                valType: "any"
	              },
	              y: {
	                valType: "any"
	              },
	              z: {
	                valType: "any"
	              },
	              ax: {
	                valType: "number"
	              },
	              ay: {
	                valType: "number"
	              },
	              xanchor: annAttrs.xanchor,
	              xshift: annAttrs.xshift,
	              yanchor: annAttrs.yanchor,
	              yshift: annAttrs.yshift,
	              text: annAttrs.text,
	              textangle: annAttrs.textangle,
	              font: annAttrs.font,
	              width: annAttrs.width,
	              height: annAttrs.height,
	              opacity: annAttrs.opacity,
	              align: annAttrs.align,
	              valign: annAttrs.valign,
	              bgcolor: annAttrs.bgcolor,
	              bordercolor: annAttrs.bordercolor,
	              borderpad: annAttrs.borderpad,
	              borderwidth: annAttrs.borderwidth,
	              showarrow: annAttrs.showarrow,
	              arrowcolor: annAttrs.arrowcolor,
	              arrowhead: annAttrs.arrowhead,
	              startarrowhead: annAttrs.startarrowhead,
	              arrowside: annAttrs.arrowside,
	              arrowsize: annAttrs.arrowsize,
	              startarrowsize: annAttrs.startarrowsize,
	              arrowwidth: annAttrs.arrowwidth,
	              standoff: annAttrs.standoff,
	              startstandoff: annAttrs.startstandoff,
	              hovertext: annAttrs.hovertext,
	              hoverlabel: annAttrs.hoverlabel,
	              captureevents: annAttrs.captureevents
	              // maybes later?
	              // clicktoshow: annAttrs.clicktoshow,
	              // xclick: annAttrs.xclick,
	              // yclick: annAttrs.yclick,
	              // not needed!
	              // axref: 'pixel'
	              // ayref: 'pixel'
	              // xref: 'x'
	              // yref: 'y
	              // zref: 'z'
	            }), "calc", "from-root");
	          }
	        ),
	        /***/
	        5485: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function convert(scene) {
	              var fullSceneLayout = scene.fullSceneLayout;
	              var anns = fullSceneLayout.annotations;
	              for (var i = 0; i < anns.length; i++) {
	                mockAnnAxes(anns[i], scene);
	              }
	              scene.fullLayout._infolayer.selectAll(".annotation-" + scene.id).remove();
	            };
	            function mockAnnAxes(ann, scene) {
	              var fullSceneLayout = scene.fullSceneLayout;
	              var domain = fullSceneLayout.domain;
	              var size = scene.fullLayout._size;
	              var base = {
	                // this gets fill in on render
	                pdata: null,
	                // to get setConvert to not execute cleanly
	                type: "linear",
	                // don't try to update them on `editable: true`
	                autorange: false,
	                // set infinite range so that annotation draw routine
	                // does not try to remove 'outside-range' annotations,
	                // this case is handled in the render loop
	                range: [-Infinity, Infinity]
	              };
	              ann._xa = {};
	              Lib.extendFlat(ann._xa, base);
	              Axes.setConvert(ann._xa);
	              ann._xa._offset = size.l + domain.x[0] * size.w;
	              ann._xa.l2p = function() {
	                return 0.5 * (1 + ann._pdata[0] / ann._pdata[3]) * size.w * (domain.x[1] - domain.x[0]);
	              };
	              ann._ya = {};
	              Lib.extendFlat(ann._ya, base);
	              Axes.setConvert(ann._ya);
	              ann._ya._offset = size.t + (1 - domain.y[1]) * size.h;
	              ann._ya.l2p = function() {
	                return 0.5 * (1 - ann._pdata[1] / ann._pdata[3]) * size.h * (domain.y[1] - domain.y[0]);
	              };
	            }
	          }
	        ),
	        /***/
	        20226: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var handleAnnotationCommonDefaults = __webpack_require__2(25625);
	            var attributes = __webpack_require__2(26997);
	            module2.exports = function handleDefaults(sceneLayoutIn, sceneLayoutOut, opts) {
	              handleArrayContainerDefaults(sceneLayoutIn, sceneLayoutOut, {
	                name: "annotations",
	                handleItemDefaults: handleAnnotationDefaults,
	                fullLayout: opts.fullLayout
	              });
	            };
	            function handleAnnotationDefaults(annIn, annOut, sceneLayout, opts) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(annIn, annOut, attributes, attr, dflt);
	              }
	              function coercePosition(axLetter) {
	                var axName = axLetter + "axis";
	                var gdMock = {
	                  _fullLayout: {}
	                };
	                gdMock._fullLayout[axName] = sceneLayout[axName];
	                return Axes.coercePosition(annOut, gdMock, coerce, axLetter, axLetter, 0.5);
	              }
	              var visible = coerce("visible");
	              if (!visible) return;
	              handleAnnotationCommonDefaults(annIn, annOut, opts.fullLayout, coerce);
	              coercePosition("x");
	              coercePosition("y");
	              coercePosition("z");
	              Lib.noneOrAll(annIn, annOut, ["x", "y", "z"]);
	              annOut.xref = "x";
	              annOut.yref = "y";
	              annOut.zref = "z";
	              coerce("xanchor");
	              coerce("yanchor");
	              coerce("xshift");
	              coerce("yshift");
	              if (annOut.showarrow) {
	                annOut.axref = "pixel";
	                annOut.ayref = "pixel";
	                coerce("ax", -10);
	                coerce("ay", -30);
	                Lib.noneOrAll(annIn, annOut, ["ax", "ay"]);
	              }
	            }
	          }
	        ),
	        /***/
	        82188: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var drawRaw = __webpack_require__2(92605).drawRaw;
	            var project = __webpack_require__2(63538);
	            var axLetters = ["x", "y", "z"];
	            module2.exports = function draw(scene) {
	              var fullSceneLayout = scene.fullSceneLayout;
	              var dataScale = scene.dataScale;
	              var anns = fullSceneLayout.annotations;
	              for (var i = 0; i < anns.length; i++) {
	                var ann = anns[i];
	                var annotationIsOffscreen = false;
	                for (var j = 0; j < 3; j++) {
	                  var axLetter = axLetters[j];
	                  var pos = ann[axLetter];
	                  var ax = fullSceneLayout[axLetter + "axis"];
	                  var posFraction = ax.r2fraction(pos);
	                  if (posFraction < 0 || posFraction > 1) {
	                    annotationIsOffscreen = true;
	                    break;
	                  }
	                }
	                if (annotationIsOffscreen) {
	                  scene.fullLayout._infolayer.select(".annotation-" + scene.id + '[data-index="' + i + '"]').remove();
	                } else {
	                  ann._pdata = project(scene.glplot.cameraParams, [fullSceneLayout.xaxis.r2l(ann.x) * dataScale[0], fullSceneLayout.yaxis.r2l(ann.y) * dataScale[1], fullSceneLayout.zaxis.r2l(ann.z) * dataScale[2]]);
	                  drawRaw(scene.graphDiv, ann, i, scene.id, ann._xa, ann._ya);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        2468: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = {
	              moduleType: "component",
	              name: "annotations3d",
	              schema: {
	                subplots: {
	                  scene: {
	                    annotations: __webpack_require__2(26997)
	                  }
	                }
	              },
	              layoutAttributes: __webpack_require__2(26997),
	              handleDefaults: __webpack_require__2(20226),
	              includeBasePlot: includeGL3D,
	              convert: __webpack_require__2(5485),
	              draw: __webpack_require__2(82188)
	            };
	            function includeGL3D(layoutIn, layoutOut) {
	              var GL3D = Registry.subplotsRegistry.gl3d;
	              if (!GL3D) return;
	              var attrRegex = GL3D.attrRegex;
	              var keys = Object.keys(layoutIn);
	              for (var i = 0; i < keys.length; i++) {
	                var k = keys[i];
	                if (attrRegex.test(k) && (layoutIn[k].annotations || []).length) {
	                  Lib.pushUnique(layoutOut._basePlotModules, GL3D);
	                  Lib.pushUnique(layoutOut._subplots.gl3d, k);
	                }
	              }
	            }
	          }
	        ),
	        /***/
	        7561: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(63489);
	            __webpack_require__2(94338);
	            __webpack_require__2(3961);
	            __webpack_require__2(38751);
	            __webpack_require__2(86825);
	            __webpack_require__2(37715);
	            __webpack_require__2(99384);
	            __webpack_require__2(43805);
	            __webpack_require__2(88874);
	            __webpack_require__2(83290);
	            __webpack_require__2(29108);
	            __webpack_require__2(55422);
	            __webpack_require__2(94320);
	            __webpack_require__2(31320);
	            __webpack_require__2(51367);
	            __webpack_require__2(21457);
	          }
	        ),
	        /***/
	        72201: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var calendars = __webpack_require__2(7561);
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(50606);
	            var EPOCHJD = constants.EPOCHJD;
	            var ONEDAY = constants.ONEDAY;
	            var attributes = {
	              valType: "enumerated",
	              values: Lib.sortObjectKeys(calendars.calendars),
	              editType: "calc",
	              dflt: "gregorian"
	            };
	            var handleDefaults = function(contIn, contOut, attr, dflt) {
	              var attrs = {};
	              attrs[attr] = attributes;
	              return Lib.coerce(contIn, contOut, attrs, attr, dflt);
	            };
	            var handleTraceDefaults = function(traceIn, traceOut, coords, layout) {
	              for (var i = 0; i < coords.length; i++) {
	                handleDefaults(traceIn, traceOut, coords[i] + "calendar", layout.calendar);
	              }
	            };
	            var CANONICAL_TICK = {
	              chinese: "2000-01-01",
	              coptic: "2000-01-01",
	              discworld: "2000-01-01",
	              ethiopian: "2000-01-01",
	              hebrew: "5000-01-01",
	              islamic: "1000-01-01",
	              julian: "2000-01-01",
	              mayan: "5000-01-01",
	              nanakshahi: "1000-01-01",
	              nepali: "2000-01-01",
	              persian: "1000-01-01",
	              jalali: "1000-01-01",
	              taiwan: "1000-01-01",
	              thai: "2000-01-01",
	              ummalqura: "1400-01-01"
	            };
	            var CANONICAL_SUNDAY = {
	              chinese: "2000-01-02",
	              coptic: "2000-01-03",
	              discworld: "2000-01-03",
	              ethiopian: "2000-01-05",
	              hebrew: "5000-01-01",
	              islamic: "1000-01-02",
	              julian: "2000-01-03",
	              mayan: "5000-01-01",
	              nanakshahi: "1000-01-05",
	              nepali: "2000-01-05",
	              persian: "1000-01-01",
	              jalali: "1000-01-01",
	              taiwan: "1000-01-04",
	              thai: "2000-01-04",
	              ummalqura: "1400-01-06"
	            };
	            var DFLTRANGE = {
	              chinese: ["2000-01-01", "2001-01-01"],
	              coptic: ["1700-01-01", "1701-01-01"],
	              discworld: ["1800-01-01", "1801-01-01"],
	              ethiopian: ["2000-01-01", "2001-01-01"],
	              hebrew: ["5700-01-01", "5701-01-01"],
	              islamic: ["1400-01-01", "1401-01-01"],
	              julian: ["2000-01-01", "2001-01-01"],
	              mayan: ["5200-01-01", "5201-01-01"],
	              nanakshahi: ["0500-01-01", "0501-01-01"],
	              nepali: ["2000-01-01", "2001-01-01"],
	              persian: ["1400-01-01", "1401-01-01"],
	              jalali: ["1400-01-01", "1401-01-01"],
	              taiwan: ["0100-01-01", "0101-01-01"],
	              thai: ["2500-01-01", "2501-01-01"],
	              ummalqura: ["1400-01-01", "1401-01-01"]
	            };
	            var UNKNOWN = "##";
	            var d3ToWorldCalendars = {
	              d: {
	                0: "dd",
	                "-": "d"
	              },
	              // 2-digit or unpadded day of month
	              e: {
	                0: "d",
	                "-": "d"
	              },
	              // alternate, always unpadded day of month
	              a: {
	                0: "D",
	                "-": "D"
	              },
	              // short weekday name
	              A: {
	                0: "DD",
	                "-": "DD"
	              },
	              // full weekday name
	              j: {
	                0: "oo",
	                "-": "o"
	              },
	              // 3-digit or unpadded day of the year
	              W: {
	                0: "ww",
	                "-": "w"
	              },
	              // 2-digit or unpadded week of the year (Monday first)
	              m: {
	                0: "mm",
	                "-": "m"
	              },
	              // 2-digit or unpadded month number
	              b: {
	                0: "M",
	                "-": "M"
	              },
	              // short month name
	              B: {
	                0: "MM",
	                "-": "MM"
	              },
	              // full month name
	              y: {
	                0: "yy",
	                "-": "yy"
	              },
	              // 2-digit year (map unpadded to zero-padded)
	              Y: {
	                0: "yyyy",
	                "-": "yyyy"
	              },
	              // 4-digit year (map unpadded to zero-padded)
	              U: UNKNOWN,
	              // Sunday-first week of the year
	              w: UNKNOWN,
	              // day of the week [0(sunday),6]
	              // combined format, we replace the date part with the world-calendar version
	              // and the %X stays there for d3 to handle with time parts
	              c: {
	                0: "D M d %X yyyy",
	                "-": "D M d %X yyyy"
	              },
	              x: {
	                0: "mm/dd/yyyy",
	                "-": "mm/dd/yyyy"
	              }
	            };
	            function worldCalFmt(fmt, x, calendar) {
	              var dateJD = Math.floor((x + 0.05) / ONEDAY) + EPOCHJD;
	              var cDate = getCal(calendar).fromJD(dateJD);
	              var i = 0;
	              var modifier, directive, directiveLen, directiveObj, replacementPart;
	              while ((i = fmt.indexOf("%", i)) !== -1) {
	                modifier = fmt.charAt(i + 1);
	                if (modifier === "0" || modifier === "-" || modifier === "_") {
	                  directiveLen = 3;
	                  directive = fmt.charAt(i + 2);
	                  if (modifier === "_") modifier = "-";
	                } else {
	                  directive = modifier;
	                  modifier = "0";
	                  directiveLen = 2;
	                }
	                directiveObj = d3ToWorldCalendars[directive];
	                if (!directiveObj) {
	                  i += directiveLen;
	                } else {
	                  if (directiveObj === UNKNOWN) replacementPart = UNKNOWN;
	                  else replacementPart = cDate.formatDate(directiveObj[modifier]);
	                  fmt = fmt.substr(0, i) + replacementPart + fmt.substr(i + directiveLen);
	                  i += replacementPart.length;
	                }
	              }
	              return fmt;
	            }
	            var allCals = {};
	            function getCal(calendar) {
	              var calendarObj = allCals[calendar];
	              if (calendarObj) return calendarObj;
	              calendarObj = allCals[calendar] = calendars.instance(calendar);
	              return calendarObj;
	            }
	            function makeAttrs(description) {
	              return Lib.extendFlat({}, attributes, {
	                description
	              });
	            }
	            function makeTraceAttrsDescription(coord) {
	              return "Sets the calendar system to use with `" + coord + "` date data.";
	            }
	            var xAttrs = {
	              xcalendar: makeAttrs(makeTraceAttrsDescription("x"))
	            };
	            var xyAttrs = Lib.extendFlat({}, xAttrs, {
	              ycalendar: makeAttrs(makeTraceAttrsDescription("y"))
	            });
	            var xyzAttrs = Lib.extendFlat({}, xyAttrs, {
	              zcalendar: makeAttrs(makeTraceAttrsDescription("z"))
	            });
	            var axisAttrs = makeAttrs(["Sets the calendar system to use for `range` and `tick0`", "if this is a date axis. This does not set the calendar for", "interpreting data on this axis, that's specified in the trace", "or via the global `layout.calendar`"].join(" "));
	            module2.exports = {
	              moduleType: "component",
	              name: "calendars",
	              schema: {
	                traces: {
	                  scatter: xyAttrs,
	                  bar: xyAttrs,
	                  box: xyAttrs,
	                  heatmap: xyAttrs,
	                  contour: xyAttrs,
	                  histogram: xyAttrs,
	                  histogram2d: xyAttrs,
	                  histogram2dcontour: xyAttrs,
	                  scatter3d: xyzAttrs,
	                  surface: xyzAttrs,
	                  mesh3d: xyzAttrs,
	                  scattergl: xyAttrs,
	                  ohlc: xAttrs,
	                  candlestick: xAttrs
	                },
	                layout: {
	                  calendar: makeAttrs(["Sets the default calendar system to use for interpreting and", "displaying dates throughout the plot."].join(" "))
	                },
	                subplots: {
	                  xaxis: {
	                    calendar: axisAttrs
	                  },
	                  yaxis: {
	                    calendar: axisAttrs
	                  },
	                  scene: {
	                    xaxis: {
	                      calendar: axisAttrs
	                    },
	                    // TODO: it's actually redundant to include yaxis and zaxis here
	                    // because in the scene attributes these are the same object so merging
	                    // into one merges into them all. However, I left them in for parity with
	                    // cartesian, where yaxis is unused until we Plotschema.get() when we
	                    // use its presence or absence to determine whether to delete attributes
	                    // from yaxis if they only apply to x (rangeselector/rangeslider)
	                    yaxis: {
	                      calendar: axisAttrs
	                    },
	                    zaxis: {
	                      calendar: axisAttrs
	                    }
	                  },
	                  polar: {
	                    radialaxis: {
	                      calendar: axisAttrs
	                    }
	                  }
	                },
	                transforms: {
	                  filter: {
	                    valuecalendar: makeAttrs(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `value`, if it is a date."].join(" ")),
	                    targetcalendar: makeAttrs(["WARNING: All transforms are deprecated and may be removed from the API in next major version.", "Sets the calendar system to use for `target`, if it is an", "array of dates. If `target` is a string (eg *x*) we use the", "corresponding trace attribute (eg `xcalendar`) if it exists,", "even if `targetcalendar` is provided."].join(" "))
	                  }
	                }
	              },
	              layoutAttributes: attributes,
	              handleDefaults,
	              handleTraceDefaults,
	              CANONICAL_SUNDAY,
	              CANONICAL_TICK,
	              DFLTRANGE,
	              getCal,
	              worldCalFmt
	            };
	          }
	        ),
	        /***/
	        22399: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.defaults = [
	              "#1f77b4",
	              // muted blue
	              "#ff7f0e",
	              // safety orange
	              "#2ca02c",
	              // cooked asparagus green
	              "#d62728",
	              // brick red
	              "#9467bd",
	              // muted purple
	              "#8c564b",
	              // chestnut brown
	              "#e377c2",
	              // raspberry yogurt pink
	              "#7f7f7f",
	              // middle gray
	              "#bcbd22",
	              // curry yellow-green
	              "#17becf"
	              // blue-teal
	            ];
	            exports2.defaultLine = "#444";
	            exports2.lightLine = "#eee";
	            exports2.background = "#fff";
	            exports2.borderLine = "#BEC8D9";
	            exports2.lightFraction = 100 * (14 - 4) / (15 - 4);
	          }
	        ),
	        /***/
	        7901: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var tinycolor = __webpack_require__2(84267);
	            var isNumeric = __webpack_require__2(92770);
	            var isTypedArray = __webpack_require__2(73627).isTypedArray;
	            var color = module2.exports = {};
	            var colorAttrs = __webpack_require__2(22399);
	            color.defaults = colorAttrs.defaults;
	            var defaultLine = color.defaultLine = colorAttrs.defaultLine;
	            color.lightLine = colorAttrs.lightLine;
	            var background = color.background = colorAttrs.background;
	            color.tinyRGB = function(tc) {
	              var c = tc.toRgb();
	              return "rgb(" + Math.round(c.r) + ", " + Math.round(c.g) + ", " + Math.round(c.b) + ")";
	            };
	            color.rgb = function(cstr) {
	              return color.tinyRGB(tinycolor(cstr));
	            };
	            color.opacity = function(cstr) {
	              return cstr ? tinycolor(cstr).getAlpha() : 0;
	            };
	            color.addOpacity = function(cstr, op) {
	              var c = tinycolor(cstr).toRgb();
	              return "rgba(" + Math.round(c.r) + ", " + Math.round(c.g) + ", " + Math.round(c.b) + ", " + op + ")";
	            };
	            color.combine = function(front, back) {
	              var fc = tinycolor(front).toRgb();
	              if (fc.a === 1) return tinycolor(front).toRgbString();
	              var bc = tinycolor(back || background).toRgb();
	              var bcflat = bc.a === 1 ? bc : {
	                r: 255 * (1 - bc.a) + bc.r * bc.a,
	                g: 255 * (1 - bc.a) + bc.g * bc.a,
	                b: 255 * (1 - bc.a) + bc.b * bc.a
	              };
	              var fcflat = {
	                r: bcflat.r * (1 - fc.a) + fc.r * fc.a,
	                g: bcflat.g * (1 - fc.a) + fc.g * fc.a,
	                b: bcflat.b * (1 - fc.a) + fc.b * fc.a
	              };
	              return tinycolor(fcflat).toRgbString();
	            };
	            color.contrast = function(cstr, lightAmount, darkAmount) {
	              var tc = tinycolor(cstr);
	              if (tc.getAlpha() !== 1) tc = tinycolor(color.combine(cstr, background));
	              var newColor = tc.isDark() ? lightAmount ? tc.lighten(lightAmount) : background : darkAmount ? tc.darken(darkAmount) : defaultLine;
	              return newColor.toString();
	            };
	            color.stroke = function(s, c) {
	              var tc = tinycolor(c);
	              s.style({
	                stroke: color.tinyRGB(tc),
	                "stroke-opacity": tc.getAlpha()
	              });
	            };
	            color.fill = function(s, c) {
	              var tc = tinycolor(c);
	              s.style({
	                fill: color.tinyRGB(tc),
	                "fill-opacity": tc.getAlpha()
	              });
	            };
	            color.clean = function(container) {
	              if (!container || typeof container !== "object") return;
	              var keys = Object.keys(container);
	              var i, j, key, val;
	              for (i = 0; i < keys.length; i++) {
	                key = keys[i];
	                val = container[key];
	                if (key.substr(key.length - 5) === "color") {
	                  if (Array.isArray(val)) {
	                    for (j = 0; j < val.length; j++) val[j] = cleanOne(val[j]);
	                  } else container[key] = cleanOne(val);
	                } else if (key.substr(key.length - 10) === "colorscale" && Array.isArray(val)) {
	                  for (j = 0; j < val.length; j++) {
	                    if (Array.isArray(val[j])) val[j][1] = cleanOne(val[j][1]);
	                  }
	                } else if (Array.isArray(val)) {
	                  var el0 = val[0];
	                  if (!Array.isArray(el0) && el0 && typeof el0 === "object") {
	                    for (j = 0; j < val.length; j++) color.clean(val[j]);
	                  }
	                } else if (val && typeof val === "object" && !isTypedArray(val)) color.clean(val);
	              }
	            };
	            function cleanOne(val) {
	              if (isNumeric(val) || typeof val !== "string") return val;
	              var valTrim = val.trim();
	              if (valTrim.substr(0, 3) !== "rgb") return val;
	              var match = valTrim.match(/^rgba?\s*\(([^()]*)\)$/);
	              if (!match) return val;
	              var parts = match[1].trim().split(/\s*[\s,]\s*/);
	              var rgba = valTrim.charAt(3) === "a" && parts.length === 4;
	              if (!rgba && parts.length !== 3) return val;
	              for (var i = 0; i < parts.length; i++) {
	                if (!parts[i].length) return val;
	                parts[i] = Number(parts[i]);
	                if (!(parts[i] >= 0)) {
	                  return val;
	                }
	                if (i === 3) {
	                  if (parts[i] > 1) parts[i] = 1;
	                } else if (parts[i] >= 1) {
	                  return val;
	                }
	              }
	              var rgbStr = Math.round(parts[0] * 255) + ", " + Math.round(parts[1] * 255) + ", " + Math.round(parts[2] * 255);
	              if (rgba) return "rgba(" + rgbStr + ", " + parts[3] + ")";
	              return "rgb(" + rgbStr + ")";
	            }
	          }
	        ),
	        /***/
	        63583: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var axesAttrs = __webpack_require__2(13838);
	            var fontAttrs = __webpack_require__2(41940);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            module2.exports = overrideAll({
	              orientation: {
	                valType: "enumerated",
	                values: ["h", "v"],
	                dflt: "v"
	              },
	              thicknessmode: {
	                valType: "enumerated",
	                values: ["fraction", "pixels"],
	                dflt: "pixels"
	              },
	              thickness: {
	                valType: "number",
	                min: 0,
	                dflt: 30
	              },
	              lenmode: {
	                valType: "enumerated",
	                values: ["fraction", "pixels"],
	                dflt: "fraction"
	              },
	              len: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              x: {
	                valType: "number"
	              },
	              xref: {
	                valType: "enumerated",
	                dflt: "paper",
	                values: ["container", "paper"],
	                editType: "layoutstyle"
	              },
	              xanchor: {
	                valType: "enumerated",
	                values: ["left", "center", "right"]
	              },
	              xpad: {
	                valType: "number",
	                min: 0,
	                dflt: 10
	              },
	              y: {
	                valType: "number"
	              },
	              yref: {
	                valType: "enumerated",
	                dflt: "paper",
	                values: ["container", "paper"],
	                editType: "layoutstyle"
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["top", "middle", "bottom"]
	              },
	              ypad: {
	                valType: "number",
	                min: 0,
	                dflt: 10
	              },
	              // a possible line around the bar itself
	              outlinecolor: axesAttrs.linecolor,
	              outlinewidth: axesAttrs.linewidth,
	              // Should outlinewidth have {dflt: 0} ?
	              // another possible line outside the padding and tick labels
	              bordercolor: axesAttrs.linecolor,
	              borderwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 0
	              },
	              bgcolor: {
	                valType: "color",
	                dflt: "rgba(0,0,0,0)"
	              },
	              // tick and title properties named and function exactly as in axes
	              tickmode: axesAttrs.minor.tickmode,
	              nticks: axesAttrs.nticks,
	              tick0: axesAttrs.tick0,
	              dtick: axesAttrs.dtick,
	              tickvals: axesAttrs.tickvals,
	              ticktext: axesAttrs.ticktext,
	              ticks: extendFlat({}, axesAttrs.ticks, {
	                dflt: ""
	              }),
	              ticklabeloverflow: extendFlat({}, axesAttrs.ticklabeloverflow, {}),
	              // ticklabelposition: not used directly, as values depend on orientation
	              // left/right options are for x axes, and top/bottom options are for y axes
	              ticklabelposition: {
	                valType: "enumerated",
	                values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
	                dflt: "outside"
	              },
	              ticklen: axesAttrs.ticklen,
	              tickwidth: axesAttrs.tickwidth,
	              tickcolor: axesAttrs.tickcolor,
	              ticklabelstep: axesAttrs.ticklabelstep,
	              showticklabels: axesAttrs.showticklabels,
	              labelalias: axesAttrs.labelalias,
	              tickfont: fontAttrs({}),
	              tickangle: axesAttrs.tickangle,
	              tickformat: axesAttrs.tickformat,
	              tickformatstops: axesAttrs.tickformatstops,
	              tickprefix: axesAttrs.tickprefix,
	              showtickprefix: axesAttrs.showtickprefix,
	              ticksuffix: axesAttrs.ticksuffix,
	              showticksuffix: axesAttrs.showticksuffix,
	              separatethousands: axesAttrs.separatethousands,
	              exponentformat: axesAttrs.exponentformat,
	              minexponent: axesAttrs.minexponent,
	              showexponent: axesAttrs.showexponent,
	              title: {
	                text: {
	                  valType: "string"
	                },
	                font: fontAttrs({}),
	                side: {
	                  valType: "enumerated",
	                  values: ["right", "top", "bottom"]
	                }
	              },
	              _deprecated: {
	                title: {
	                  valType: "string"
	                },
	                titlefont: fontAttrs({}),
	                titleside: {
	                  valType: "enumerated",
	                  values: ["right", "top", "bottom"],
	                  dflt: "top"
	                }
	              }
	            }, "colorbars", "from-root");
	          }
	        ),
	        /***/
	        30939: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              cn: {
	                colorbar: "colorbar",
	                cbbg: "cbbg",
	                cbfill: "cbfill",
	                cbfills: "cbfills",
	                cbline: "cbline",
	                cblines: "cblines",
	                cbaxis: "cbaxis",
	                cbtitleunshift: "cbtitleunshift",
	                cbtitle: "cbtitle",
	                cboutline: "cboutline",
	                crisp: "crisp",
	                jsPlaceholder: "js-placeholder"
	              }
	            };
	          }
	        ),
	        /***/
	        62499: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var handleTickValueDefaults = __webpack_require__2(26218);
	            var handleTickMarkDefaults = __webpack_require__2(38701);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            var attributes = __webpack_require__2(63583);
	            module2.exports = function colorbarDefaults(containerIn, containerOut, layout) {
	              var colorbarOut = Template.newContainer(containerOut, "colorbar");
	              var colorbarIn = containerIn.colorbar || {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(colorbarIn, colorbarOut, attributes, attr, dflt);
	              }
	              var margin = layout.margin || {
	                t: 0,
	                b: 0,
	                l: 0,
	                r: 0
	              };
	              var w = layout.width - margin.l - margin.r;
	              var h = layout.height - margin.t - margin.b;
	              var orientation = coerce("orientation");
	              var isVertical = orientation === "v";
	              var thicknessmode = coerce("thicknessmode");
	              coerce("thickness", thicknessmode === "fraction" ? 30 / (isVertical ? w : h) : 30);
	              var lenmode = coerce("lenmode");
	              coerce("len", lenmode === "fraction" ? 1 : isVertical ? h : w);
	              var yref = coerce("yref");
	              var xref = coerce("xref");
	              var isPaperY = yref === "paper";
	              var isPaperX = xref === "paper";
	              var defaultX, defaultY, defaultYAnchor;
	              var defaultXAnchor = "left";
	              if (isVertical) {
	                defaultYAnchor = "middle";
	                defaultXAnchor = isPaperX ? "left" : "right";
	                defaultX = isPaperX ? 1.02 : 1;
	                defaultY = 0.5;
	              } else {
	                defaultYAnchor = isPaperY ? "bottom" : "top";
	                defaultXAnchor = "center";
	                defaultX = 0.5;
	                defaultY = isPaperY ? 1.02 : 1;
	              }
	              Lib.coerce(colorbarIn, colorbarOut, {
	                x: {
	                  valType: "number",
	                  min: isPaperX ? -2 : 0,
	                  max: isPaperX ? 3 : 1,
	                  dflt: defaultX
	                }
	              }, "x");
	              Lib.coerce(colorbarIn, colorbarOut, {
	                y: {
	                  valType: "number",
	                  min: isPaperY ? -2 : 0,
	                  max: isPaperY ? 3 : 1,
	                  dflt: defaultY
	                }
	              }, "y");
	              coerce("xanchor", defaultXAnchor);
	              coerce("xpad");
	              coerce("yanchor", defaultYAnchor);
	              coerce("ypad");
	              Lib.noneOrAll(colorbarIn, colorbarOut, ["x", "y"]);
	              coerce("outlinecolor");
	              coerce("outlinewidth");
	              coerce("bordercolor");
	              coerce("borderwidth");
	              coerce("bgcolor");
	              var ticklabelposition = Lib.coerce(colorbarIn, colorbarOut, {
	                ticklabelposition: {
	                  valType: "enumerated",
	                  dflt: "outside",
	                  values: isVertical ? ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"] : ["outside", "inside", "outside left", "inside left", "outside right", "inside right"]
	                }
	              }, "ticklabelposition");
	              coerce("ticklabeloverflow", ticklabelposition.indexOf("inside") !== -1 ? "hide past domain" : "hide past div");
	              handleTickValueDefaults(colorbarIn, colorbarOut, coerce, "linear");
	              var font = layout.font;
	              var opts = {
	                outerTicks: false,
	                font
	              };
	              if (ticklabelposition.indexOf("inside") !== -1) {
	                opts.bgColor = "black";
	              }
	              handlePrefixSuffixDefaults(colorbarIn, colorbarOut, coerce, "linear", opts);
	              handleTickLabelDefaults(colorbarIn, colorbarOut, coerce, "linear", opts);
	              handleTickMarkDefaults(colorbarIn, colorbarOut, coerce, "linear", opts);
	              coerce("title.text", layout._dfltTitle.colorbar);
	              var tickFont = colorbarOut.showticklabels ? colorbarOut.tickfont : font;
	              var dfltTitleFont = Lib.extendFlat({}, tickFont, {
	                color: font.color,
	                size: Lib.bigFont(tickFont.size)
	              });
	              Lib.coerceFont(coerce, "title.font", dfltTitleFont);
	              coerce("title.side", isVertical ? "top" : "right");
	            };
	          }
	        ),
	        /***/
	        98981: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var tinycolor = __webpack_require__2(84267);
	            var Plots = __webpack_require__2(74875);
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var dragElement = __webpack_require__2(28569);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var setCursor = __webpack_require__2(6964);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var Titles = __webpack_require__2(92998);
	            var svgTextUtils = __webpack_require__2(63893);
	            var flipScale = __webpack_require__2(52075).flipScale;
	            var handleAxisDefaults = __webpack_require__2(71453);
	            var handleAxisPositionDefaults = __webpack_require__2(52830);
	            var axisLayoutAttrs = __webpack_require__2(13838);
	            var alignmentConstants = __webpack_require__2(18783);
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var FROM_TL = alignmentConstants.FROM_TL;
	            var FROM_BR = alignmentConstants.FROM_BR;
	            var cn = __webpack_require__2(30939).cn;
	            function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              var colorBars = fullLayout._infolayer.selectAll("g." + cn.colorbar).data(makeColorBarData(gd), function(opts) {
	                return opts._id;
	              });
	              colorBars.enter().append("g").attr("class", function(opts) {
	                return opts._id;
	              }).classed(cn.colorbar, true);
	              colorBars.each(function(opts) {
	                var g = d3.select(this);
	                Lib.ensureSingle(g, "rect", cn.cbbg);
	                Lib.ensureSingle(g, "g", cn.cbfills);
	                Lib.ensureSingle(g, "g", cn.cblines);
	                Lib.ensureSingle(g, "g", cn.cbaxis, function(s) {
	                  s.classed(cn.crisp, true);
	                });
	                Lib.ensureSingle(g, "g", cn.cbtitleunshift, function(s) {
	                  s.append("g").classed(cn.cbtitle, true);
	                });
	                Lib.ensureSingle(g, "rect", cn.cboutline);
	                var done = drawColorBar(g, opts, gd);
	                if (done && done.then) (gd._promises || []).push(done);
	                if (gd._context.edits.colorbarPosition) {
	                  makeEditable(g, opts, gd);
	                }
	              });
	              colorBars.exit().each(function(opts) {
	                Plots.autoMargin(gd, opts._id);
	              }).remove();
	              colorBars.order();
	            }
	            function makeColorBarData(gd) {
	              var fullLayout = gd._fullLayout;
	              var calcdata = gd.calcdata;
	              var out = [];
	              var opts;
	              var cont;
	              var trace;
	              var cbOpt;
	              function initOpts(opts2) {
	                return extendFlat(opts2, {
	                  // fillcolor can be a d3 scale, domain is z values, range is colors
	                  // or leave it out for no fill,
	                  // or set to a string constant for single-color fill
	                  _fillcolor: null,
	                  // line.color has the same options as fillcolor
	                  _line: {
	                    color: null,
	                    width: null,
	                    dash: null
	                  },
	                  // levels of lines to draw.
	                  // note that this DOES NOT determine the extent of the bar
	                  // that's given by the domain of fillcolor
	                  // (or line.color if no fillcolor domain)
	                  _levels: {
	                    start: null,
	                    end: null,
	                    size: null
	                  },
	                  // separate fill levels (for example, heatmap coloring of a
	                  // contour map) if this is omitted, fillcolors will be
	                  // evaluated halfway between levels
	                  _filllevels: null,
	                  // for continuous colorscales: fill with a gradient instead of explicit levels
	                  // value should be the colorscale [[0, c0], [v1, c1], ..., [1, cEnd]]
	                  _fillgradient: null,
	                  // when using a gradient, we need the data range specified separately
	                  _zrange: null
	                });
	              }
	              function calcOpts() {
	                if (typeof cbOpt.calc === "function") {
	                  cbOpt.calc(gd, trace, opts);
	                } else {
	                  opts._fillgradient = cont.reversescale ? flipScale(cont.colorscale) : cont.colorscale;
	                  opts._zrange = [cont[cbOpt.min], cont[cbOpt.max]];
	                }
	              }
	              for (var i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                trace = cd[0].trace;
	                if (!trace._module) continue;
	                var moduleOpts = trace._module.colorbar;
	                if (trace.visible === true && moduleOpts) {
	                  var allowsMultiplotCbs = Array.isArray(moduleOpts);
	                  var cbOpts = allowsMultiplotCbs ? moduleOpts : [moduleOpts];
	                  for (var j = 0; j < cbOpts.length; j++) {
	                    cbOpt = cbOpts[j];
	                    var contName = cbOpt.container;
	                    cont = contName ? trace[contName] : trace;
	                    if (cont && cont.showscale) {
	                      opts = initOpts(cont.colorbar);
	                      opts._id = "cb" + trace.uid + (allowsMultiplotCbs && contName ? "-" + contName : "");
	                      opts._traceIndex = trace.index;
	                      opts._propPrefix = (contName ? contName + "." : "") + "colorbar.";
	                      opts._meta = trace._meta;
	                      calcOpts();
	                      out.push(opts);
	                    }
	                  }
	                }
	              }
	              for (var k in fullLayout._colorAxes) {
	                cont = fullLayout[k];
	                if (cont.showscale) {
	                  var colorAxOpts = fullLayout._colorAxes[k];
	                  opts = initOpts(cont.colorbar);
	                  opts._id = "cb" + k;
	                  opts._propPrefix = k + ".colorbar.";
	                  opts._meta = fullLayout._meta;
	                  cbOpt = {
	                    min: "cmin",
	                    max: "cmax"
	                  };
	                  if (colorAxOpts[0] !== "heatmap") {
	                    trace = colorAxOpts[1];
	                    cbOpt.calc = trace._module.colorbar.calc;
	                  }
	                  calcOpts();
	                  out.push(opts);
	                }
	              }
	              return out;
	            }
	            function drawColorBar(g, opts, gd) {
	              var isVertical = opts.orientation === "v";
	              var len = opts.len;
	              var lenmode = opts.lenmode;
	              var thickness = opts.thickness;
	              var thicknessmode = opts.thicknessmode;
	              var outlinewidth = opts.outlinewidth;
	              var borderwidth = opts.borderwidth;
	              var bgcolor = opts.bgcolor;
	              var xanchor = opts.xanchor;
	              var yanchor = opts.yanchor;
	              var xpad = opts.xpad;
	              var ypad = opts.ypad;
	              var optsX = opts.x;
	              var optsY = isVertical ? opts.y : 1 - opts.y;
	              var isPaperY = opts.yref === "paper";
	              var isPaperX = opts.xref === "paper";
	              var fullLayout = gd._fullLayout;
	              var gs = fullLayout._size;
	              var fillColor = opts._fillcolor;
	              var line = opts._line;
	              var title = opts.title;
	              var titleSide = title.side;
	              var zrange = opts._zrange || d3.extent((typeof fillColor === "function" ? fillColor : line.color).domain());
	              var lineColormap = typeof line.color === "function" ? line.color : function() {
	                return line.color;
	              };
	              var fillColormap = typeof fillColor === "function" ? fillColor : function() {
	                return fillColor;
	              };
	              var levelsIn = opts._levels;
	              var levelsOut = calcLevels(gd, opts, zrange);
	              var fillLevels = levelsOut.fill;
	              var lineLevels = levelsOut.line;
	              var thickPx = Math.round(thickness * (thicknessmode === "fraction" ? isVertical ? gs.w : gs.h : 1));
	              var thickFrac = thickPx / (isVertical ? gs.w : gs.h);
	              var lenPx = Math.round(len * (lenmode === "fraction" ? isVertical ? gs.h : gs.w : 1));
	              var lenFrac = lenPx / (isVertical ? gs.h : gs.w);
	              var posW = isPaperX ? gs.w : gd._fullLayout.width;
	              var posH = isPaperY ? gs.h : gd._fullLayout.height;
	              var uPx = Math.round(isVertical ? optsX * posW + xpad : optsY * posH + ypad);
	              var xRatio = {
	                center: 0.5,
	                right: 1
	              }[xanchor] || 0;
	              var yRatio = {
	                top: 1,
	                middle: 0.5
	              }[yanchor] || 0;
	              var uFrac = isVertical ? optsX - xRatio * thickFrac : optsY - yRatio * thickFrac;
	              var vFrac = isVertical ? optsY - yRatio * lenFrac : optsX - xRatio * lenFrac;
	              var vPx = Math.round(isVertical ? posH * (1 - vFrac) : posW * vFrac);
	              opts._lenFrac = lenFrac;
	              opts._thickFrac = thickFrac;
	              opts._uFrac = uFrac;
	              opts._vFrac = vFrac;
	              var ax = opts._axis = mockColorBarAxis(gd, opts, zrange);
	              ax.position = thickFrac + (isVertical ? optsX + xpad / gs.w : optsY + ypad / gs.h);
	              var topOrBottom = ["top", "bottom"].indexOf(titleSide) !== -1;
	              if (isVertical && topOrBottom) {
	                ax.title.side = titleSide;
	                ax.titlex = optsX + xpad / gs.w;
	                ax.titley = vFrac + (title.side === "top" ? lenFrac - ypad / gs.h : ypad / gs.h);
	              }
	              if (!isVertical && !topOrBottom) {
	                ax.title.side = titleSide;
	                ax.titley = optsY + ypad / gs.h;
	                ax.titlex = vFrac + xpad / gs.w;
	              }
	              if (line.color && opts.tickmode === "auto") {
	                ax.tickmode = "linear";
	                ax.tick0 = levelsIn.start;
	                var dtick = levelsIn.size;
	                var autoNtick = Lib.constrain(lenPx / 50, 4, 15) + 1;
	                var dtFactor = (zrange[1] - zrange[0]) / ((opts.nticks || autoNtick) * dtick);
	                if (dtFactor > 1) {
	                  var dtexp = Math.pow(10, Math.floor(Math.log(dtFactor) / Math.LN10));
	                  dtick *= dtexp * Lib.roundUp(dtFactor / dtexp, [2, 5, 10]);
	                  if ((Math.abs(levelsIn.start) / levelsIn.size + 1e-6) % 1 < 2e-6) {
	                    ax.tick0 = 0;
	                  }
	                }
	                ax.dtick = dtick;
	              }
	              ax.domain = isVertical ? [vFrac + ypad / gs.h, vFrac + lenFrac - ypad / gs.h] : [vFrac + xpad / gs.w, vFrac + lenFrac - xpad / gs.w];
	              ax.setScale();
	              g.attr("transform", strTranslate(Math.round(gs.l), Math.round(gs.t)));
	              var titleCont = g.select("." + cn.cbtitleunshift).attr("transform", strTranslate(-Math.round(gs.l), -Math.round(gs.t)));
	              var ticklabelposition = ax.ticklabelposition;
	              var titleFontSize = ax.title.font.size;
	              var axLayer = g.select("." + cn.cbaxis);
	              var titleEl;
	              var titleHeight = 0;
	              var titleWidth = 0;
	              function drawTitle(titleClass, titleOpts) {
	                var dfltTitleOpts = {
	                  propContainer: ax,
	                  propName: opts._propPrefix + "title",
	                  traceIndex: opts._traceIndex,
	                  _meta: opts._meta,
	                  placeholder: fullLayout._dfltTitle.colorbar,
	                  containerGroup: g.select("." + cn.cbtitle)
	                };
	                var otherClass = titleClass.charAt(0) === "h" ? titleClass.substr(1) : "h" + titleClass;
	                g.selectAll("." + otherClass + ",." + otherClass + "-math-group").remove();
	                Titles.draw(gd, titleClass, extendFlat(dfltTitleOpts, titleOpts || {}));
	              }
	              function drawDummyTitle() {
	                if (isVertical && topOrBottom || !isVertical && !topOrBottom) {
	                  var x, y;
	                  if (titleSide === "top") {
	                    x = xpad + gs.l + posW * optsX;
	                    y = ypad + gs.t + posH * (1 - vFrac - lenFrac) + 3 + titleFontSize * 0.75;
	                  }
	                  if (titleSide === "bottom") {
	                    x = xpad + gs.l + posW * optsX;
	                    y = ypad + gs.t + posH * (1 - vFrac) - 3 - titleFontSize * 0.25;
	                  }
	                  if (titleSide === "right") {
	                    y = ypad + gs.t + posH * optsY + 3 + titleFontSize * 0.75;
	                    x = xpad + gs.l + posW * vFrac;
	                  }
	                  drawTitle(ax._id + "title", {
	                    attributes: {
	                      x,
	                      y,
	                      "text-anchor": isVertical ? "start" : "middle"
	                    }
	                  });
	                }
	              }
	              function drawCbTitle() {
	                if (isVertical && !topOrBottom || !isVertical && topOrBottom) {
	                  var pos = ax.position || 0;
	                  var mid = ax._offset + ax._length / 2;
	                  var x, y;
	                  if (titleSide === "right") {
	                    y = mid;
	                    x = gs.l + posW * pos + 10 + titleFontSize * (ax.showticklabels ? 1 : 0.5);
	                  } else {
	                    x = mid;
	                    if (titleSide === "bottom") {
	                      y = gs.t + posH * pos + 10 + (ticklabelposition.indexOf("inside") === -1 ? ax.tickfont.size : 0) + (ax.ticks !== "intside" ? opts.ticklen || 0 : 0);
	                    }
	                    if (titleSide === "top") {
	                      var nlines = title.text.split("<br>").length;
	                      y = gs.t + posH * pos + 10 - thickPx - LINE_SPACING * titleFontSize * nlines;
	                    }
	                  }
	                  drawTitle((isVertical ? (
	                    // the 'h' + is a hack to get around the fact that
	                    // convertToTspans rotates any 'y...' class by 90 degrees.
	                    // TODO: find a better way to control this.
	                    "h"
	                  ) : "v") + ax._id + "title", {
	                    avoid: {
	                      selection: d3.select(gd).selectAll("g." + ax._id + "tick"),
	                      side: titleSide,
	                      offsetTop: isVertical ? 0 : gs.t,
	                      offsetLeft: isVertical ? gs.l : 0,
	                      maxShift: isVertical ? fullLayout.width : fullLayout.height
	                    },
	                    attributes: {
	                      x,
	                      y,
	                      "text-anchor": "middle"
	                    },
	                    transform: {
	                      rotate: isVertical ? -90 : 0,
	                      offset: 0
	                    }
	                  });
	                }
	              }
	              function drawAxis() {
	                if (!isVertical && !topOrBottom || isVertical && topOrBottom) {
	                  var titleGroup = g.select("." + cn.cbtitle);
	                  var titleText = titleGroup.select("text");
	                  var titleTrans = [-outlinewidth / 2, outlinewidth / 2];
	                  var mathJaxNode = titleGroup.select(".h" + ax._id + "title-math-group").node();
	                  var lineSize = 15.6;
	                  if (titleText.node()) {
	                    lineSize = parseInt(titleText.node().style.fontSize, 10) * LINE_SPACING;
	                  }
	                  var bb;
	                  if (mathJaxNode) {
	                    bb = Drawing.bBox(mathJaxNode);
	                    titleWidth = bb.width;
	                    titleHeight = bb.height;
	                    if (titleHeight > lineSize) {
	                      titleTrans[1] -= (titleHeight - lineSize) / 2;
	                    }
	                  } else if (titleText.node() && !titleText.classed(cn.jsPlaceholder)) {
	                    bb = Drawing.bBox(titleText.node());
	                    titleWidth = bb.width;
	                    titleHeight = bb.height;
	                  }
	                  if (isVertical) {
	                    if (titleHeight) {
	                      titleHeight += 5;
	                      if (titleSide === "top") {
	                        ax.domain[1] -= titleHeight / gs.h;
	                        titleTrans[1] *= -1;
	                      } else {
	                        ax.domain[0] += titleHeight / gs.h;
	                        var nlines = svgTextUtils.lineCount(titleText);
	                        titleTrans[1] += (1 - nlines) * lineSize;
	                      }
	                      titleGroup.attr("transform", strTranslate(titleTrans[0], titleTrans[1]));
	                      ax.setScale();
	                    }
	                  } else {
	                    if (titleWidth) {
	                      if (titleSide === "right") {
	                        ax.domain[0] += (titleWidth + titleFontSize / 2) / gs.w;
	                      }
	                      titleGroup.attr("transform", strTranslate(titleTrans[0], titleTrans[1]));
	                      ax.setScale();
	                    }
	                  }
	                }
	                g.selectAll("." + cn.cbfills + ",." + cn.cblines).attr("transform", isVertical ? strTranslate(0, Math.round(gs.h * (1 - ax.domain[1]))) : strTranslate(Math.round(gs.w * ax.domain[0]), 0));
	                axLayer.attr("transform", isVertical ? strTranslate(0, Math.round(-gs.t)) : strTranslate(Math.round(-gs.l), 0));
	                var fills = g.select("." + cn.cbfills).selectAll("rect." + cn.cbfill).attr("style", "").data(fillLevels);
	                fills.enter().append("rect").classed(cn.cbfill, true).attr("style", "");
	                fills.exit().remove();
	                var zBounds = zrange.map(ax.c2p).map(Math.round).sort(function(a, b) {
	                  return a - b;
	                });
	                fills.each(function(d, i) {
	                  var z = [i === 0 ? zrange[0] : (fillLevels[i] + fillLevels[i - 1]) / 2, i === fillLevels.length - 1 ? zrange[1] : (fillLevels[i] + fillLevels[i + 1]) / 2].map(ax.c2p).map(Math.round);
	                  if (isVertical) {
	                    z[1] = Lib.constrain(z[1] + (z[1] > z[0]) ? 1 : -1, zBounds[0], zBounds[1]);
	                  }
	                  var fillEl = d3.select(this).attr(isVertical ? "x" : "y", uPx).attr(isVertical ? "y" : "x", d3.min(z)).attr(isVertical ? "width" : "height", Math.max(thickPx, 2)).attr(isVertical ? "height" : "width", Math.max(d3.max(z) - d3.min(z), 2));
	                  if (opts._fillgradient) {
	                    Drawing.gradient(fillEl, gd, opts._id, isVertical ? "vertical" : "horizontalreversed", opts._fillgradient, "fill");
	                  } else {
	                    var colorString = fillColormap(d).replace("e-", "");
	                    fillEl.attr("fill", tinycolor(colorString).toHexString());
	                  }
	                });
	                var lines = g.select("." + cn.cblines).selectAll("path." + cn.cbline).data(line.color && line.width ? lineLevels : []);
	                lines.enter().append("path").classed(cn.cbline, true);
	                lines.exit().remove();
	                lines.each(function(d) {
	                  var a = uPx;
	                  var b = Math.round(ax.c2p(d)) + line.width / 2 % 1;
	                  d3.select(this).attr("d", "M" + (isVertical ? a + "," + b : b + "," + a) + (isVertical ? "h" : "v") + thickPx).call(Drawing.lineGroupStyle, line.width, lineColormap(d), line.dash);
	                });
	                axLayer.selectAll("g." + ax._id + "tick,path").remove();
	                var shift = uPx + thickPx + (outlinewidth || 0) / 2 - (opts.ticks === "outside" ? 1 : 0);
	                var vals = Axes.calcTicks(ax);
	                var tickSign = Axes.getTickSigns(ax)[2];
	                Axes.drawTicks(gd, ax, {
	                  vals: ax.ticks === "inside" ? Axes.clipEnds(ax, vals) : vals,
	                  layer: axLayer,
	                  path: Axes.makeTickPath(ax, shift, tickSign),
	                  transFn: Axes.makeTransTickFn(ax)
	                });
	                return Axes.drawLabels(gd, ax, {
	                  vals,
	                  layer: axLayer,
	                  transFn: Axes.makeTransTickLabelFn(ax),
	                  labelFns: Axes.makeLabelFns(ax, shift)
	                });
	              }
	              function positionCB() {
	                var bb;
	                var innerThickness = thickPx + outlinewidth / 2;
	                if (ticklabelposition.indexOf("inside") === -1) {
	                  bb = Drawing.bBox(axLayer.node());
	                  innerThickness += isVertical ? bb.width : bb.height;
	                }
	                titleEl = titleCont.select("text");
	                var titleWidth2 = 0;
	                var topSideVertical = isVertical && titleSide === "top";
	                var rightSideHorizontal = !isVertical && titleSide === "right";
	                var moveY = 0;
	                if (titleEl.node() && !titleEl.classed(cn.jsPlaceholder)) {
	                  var _titleHeight;
	                  var mathJaxNode = titleCont.select(".h" + ax._id + "title-math-group").node();
	                  if (mathJaxNode && (isVertical && topOrBottom || !isVertical && !topOrBottom)) {
	                    bb = Drawing.bBox(mathJaxNode);
	                    titleWidth2 = bb.width;
	                    _titleHeight = bb.height;
	                  } else {
	                    bb = Drawing.bBox(titleCont.node());
	                    titleWidth2 = bb.right - gs.l - (isVertical ? uPx : vPx);
	                    _titleHeight = bb.bottom - gs.t - (isVertical ? vPx : uPx);
	                    if (!isVertical && titleSide === "top") {
	                      innerThickness += bb.height;
	                      moveY = bb.height;
	                    }
	                  }
	                  if (rightSideHorizontal) {
	                    titleEl.attr("transform", strTranslate(titleWidth2 / 2 + titleFontSize / 2, 0));
	                    titleWidth2 *= 2;
	                  }
	                  innerThickness = Math.max(innerThickness, isVertical ? titleWidth2 : _titleHeight);
	                }
	                var outerThickness = (isVertical ? xpad : ypad) * 2 + innerThickness + borderwidth + outlinewidth / 2;
	                var hColorbarMoveTitle = 0;
	                if (!isVertical && title.text && yanchor === "bottom" && optsY <= 0) {
	                  hColorbarMoveTitle = outerThickness / 2;
	                  outerThickness += hColorbarMoveTitle;
	                  moveY += hColorbarMoveTitle;
	                }
	                fullLayout._hColorbarMoveTitle = hColorbarMoveTitle;
	                fullLayout._hColorbarMoveCBTitle = moveY;
	                var extraW = borderwidth + outlinewidth;
	                var lx = (isVertical ? uPx : vPx) - extraW / 2 - (isVertical ? xpad : 0);
	                var ly = (isVertical ? vPx : uPx) - (isVertical ? lenPx : ypad + moveY - hColorbarMoveTitle);
	                g.select("." + cn.cbbg).attr("x", lx).attr("y", ly).attr(isVertical ? "width" : "height", Math.max(outerThickness - hColorbarMoveTitle, 2)).attr(isVertical ? "height" : "width", Math.max(lenPx + extraW, 2)).call(Color.fill, bgcolor).call(Color.stroke, opts.bordercolor).style("stroke-width", borderwidth);
	                var moveX = rightSideHorizontal ? Math.max(titleWidth2 - 10, 0) : 0;
	                g.selectAll("." + cn.cboutline).attr("x", (isVertical ? uPx : vPx + xpad) + moveX).attr("y", (isVertical ? vPx + ypad - lenPx : uPx) + (topSideVertical ? titleHeight : 0)).attr(isVertical ? "width" : "height", Math.max(thickPx, 2)).attr(isVertical ? "height" : "width", Math.max(lenPx - (isVertical ? 2 * ypad + titleHeight : 2 * xpad + moveX), 2)).call(Color.stroke, opts.outlinecolor).style({
	                  fill: "none",
	                  "stroke-width": outlinewidth
	                });
	                var xShift = isVertical ? xRatio * outerThickness : 0;
	                var yShift = isVertical ? 0 : (1 - yRatio) * outerThickness - moveY;
	                xShift = isPaperX ? gs.l - xShift : -xShift;
	                yShift = isPaperY ? gs.t - yShift : -yShift;
	                g.attr("transform", strTranslate(xShift, yShift));
	                if (!isVertical && (borderwidth || tinycolor(bgcolor).getAlpha() && !tinycolor.equals(fullLayout.paper_bgcolor, bgcolor))) {
	                  var tickLabels = axLayer.selectAll("text");
	                  var numTicks = tickLabels[0].length;
	                  var border = g.select("." + cn.cbbg).node();
	                  var oBb = Drawing.bBox(border);
	                  var oTr = Drawing.getTranslate(g);
	                  var TEXTPAD = 2;
	                  tickLabels.each(function(d, i) {
	                    var first = 0;
	                    var last = numTicks - 1;
	                    if (i === first || i === last) {
	                      var iBb = Drawing.bBox(this);
	                      var iTr = Drawing.getTranslate(this);
	                      var deltaX;
	                      if (i === last) {
	                        var iRight = iBb.right + iTr.x;
	                        var oRight = oBb.right + oTr.x + vPx - borderwidth - TEXTPAD + optsX;
	                        deltaX = oRight - iRight;
	                        if (deltaX > 0) deltaX = 0;
	                      } else if (i === first) {
	                        var iLeft = iBb.left + iTr.x;
	                        var oLeft = oBb.left + oTr.x + vPx + borderwidth + TEXTPAD;
	                        deltaX = oLeft - iLeft;
	                        if (deltaX < 0) deltaX = 0;
	                      }
	                      if (deltaX) {
	                        if (numTicks < 3) {
	                          this.setAttribute("transform", "translate(" + deltaX + ",0) " + this.getAttribute("transform"));
	                        } else {
	                          this.setAttribute("visibility", "hidden");
	                        }
	                      }
	                    }
	                  });
	                }
	                var marginOpts = {};
	                var lFrac = FROM_TL[xanchor];
	                var rFrac = FROM_BR[xanchor];
	                var tFrac = FROM_TL[yanchor];
	                var bFrac = FROM_BR[yanchor];
	                var extraThickness = outerThickness - thickPx;
	                if (isVertical) {
	                  if (lenmode === "pixels") {
	                    marginOpts.y = optsY;
	                    marginOpts.t = lenPx * tFrac;
	                    marginOpts.b = lenPx * bFrac;
	                  } else {
	                    marginOpts.t = marginOpts.b = 0;
	                    marginOpts.yt = optsY + len * tFrac;
	                    marginOpts.yb = optsY - len * bFrac;
	                  }
	                  if (thicknessmode === "pixels") {
	                    marginOpts.x = optsX;
	                    marginOpts.l = outerThickness * lFrac;
	                    marginOpts.r = outerThickness * rFrac;
	                  } else {
	                    marginOpts.l = extraThickness * lFrac;
	                    marginOpts.r = extraThickness * rFrac;
	                    marginOpts.xl = optsX - thickness * lFrac;
	                    marginOpts.xr = optsX + thickness * rFrac;
	                  }
	                } else {
	                  if (lenmode === "pixels") {
	                    marginOpts.x = optsX;
	                    marginOpts.l = lenPx * lFrac;
	                    marginOpts.r = lenPx * rFrac;
	                  } else {
	                    marginOpts.l = marginOpts.r = 0;
	                    marginOpts.xl = optsX + len * lFrac;
	                    marginOpts.xr = optsX - len * rFrac;
	                  }
	                  if (thicknessmode === "pixels") {
	                    marginOpts.y = 1 - optsY;
	                    marginOpts.t = outerThickness * tFrac;
	                    marginOpts.b = outerThickness * bFrac;
	                  } else {
	                    marginOpts.t = extraThickness * tFrac;
	                    marginOpts.b = extraThickness * bFrac;
	                    marginOpts.yt = optsY - thickness * tFrac;
	                    marginOpts.yb = optsY + thickness * bFrac;
	                  }
	                }
	                var sideY = opts.y < 0.5 ? "b" : "t";
	                var sideX = opts.x < 0.5 ? "l" : "r";
	                gd._fullLayout._reservedMargin[opts._id] = {};
	                var possibleReservedMargins = {
	                  r: fullLayout.width - lx - xShift,
	                  l: lx + marginOpts.r,
	                  b: fullLayout.height - ly - yShift,
	                  t: ly + marginOpts.b
	                };
	                if (isPaperX && isPaperY) {
	                  Plots.autoMargin(gd, opts._id, marginOpts);
	                } else if (isPaperX) {
	                  gd._fullLayout._reservedMargin[opts._id][sideY] = possibleReservedMargins[sideY];
	                } else if (isPaperY) {
	                  gd._fullLayout._reservedMargin[opts._id][sideX] = possibleReservedMargins[sideX];
	                } else {
	                  if (isVertical) {
	                    gd._fullLayout._reservedMargin[opts._id][sideX] = possibleReservedMargins[sideX];
	                  } else {
	                    gd._fullLayout._reservedMargin[opts._id][sideY] = possibleReservedMargins[sideY];
	                  }
	                }
	              }
	              return Lib.syncOrAsync([Plots.previousPromises, drawDummyTitle, drawAxis, drawCbTitle, Plots.previousPromises, positionCB], gd);
	            }
	            function makeEditable(g, opts, gd) {
	              var isVertical = opts.orientation === "v";
	              var fullLayout = gd._fullLayout;
	              var gs = fullLayout._size;
	              var t0, xf, yf;
	              dragElement.init({
	                element: g.node(),
	                gd,
	                prepFn: function() {
	                  t0 = g.attr("transform");
	                  setCursor(g);
	                },
	                moveFn: function(dx, dy) {
	                  g.attr("transform", t0 + strTranslate(dx, dy));
	                  xf = dragElement.align((isVertical ? opts._uFrac : opts._vFrac) + dx / gs.w, isVertical ? opts._thickFrac : opts._lenFrac, 0, 1, opts.xanchor);
	                  yf = dragElement.align((isVertical ? opts._vFrac : 1 - opts._uFrac) - dy / gs.h, isVertical ? opts._lenFrac : opts._thickFrac, 0, 1, opts.yanchor);
	                  var csr = dragElement.getCursor(xf, yf, opts.xanchor, opts.yanchor);
	                  setCursor(g, csr);
	                },
	                doneFn: function() {
	                  setCursor(g);
	                  if (xf !== undefined && yf !== undefined) {
	                    var update = {};
	                    update[opts._propPrefix + "x"] = xf;
	                    update[opts._propPrefix + "y"] = yf;
	                    if (opts._traceIndex !== undefined) {
	                      Registry.call("_guiRestyle", gd, update, opts._traceIndex);
	                    } else {
	                      Registry.call("_guiRelayout", gd, update);
	                    }
	                  }
	                }
	              });
	            }
	            function calcLevels(gd, opts, zrange) {
	              var levelsIn = opts._levels;
	              var lineLevels = [];
	              var fillLevels = [];
	              var l;
	              var i;
	              var l0 = levelsIn.end + levelsIn.size / 100;
	              var ls = levelsIn.size;
	              var zr0 = 1.001 * zrange[0] - 1e-3 * zrange[1];
	              var zr1 = 1.001 * zrange[1] - 1e-3 * zrange[0];
	              for (i = 0; i < 1e5; i++) {
	                l = levelsIn.start + i * ls;
	                if (ls > 0 ? l >= l0 : l <= l0) break;
	                if (l > zr0 && l < zr1) lineLevels.push(l);
	              }
	              if (opts._fillgradient) {
	                fillLevels = [0];
	              } else if (typeof opts._fillcolor === "function") {
	                var fillLevelsIn = opts._filllevels;
	                if (fillLevelsIn) {
	                  l0 = fillLevelsIn.end + fillLevelsIn.size / 100;
	                  ls = fillLevelsIn.size;
	                  for (i = 0; i < 1e5; i++) {
	                    l = fillLevelsIn.start + i * ls;
	                    if (ls > 0 ? l >= l0 : l <= l0) break;
	                    if (l > zrange[0] && l < zrange[1]) fillLevels.push(l);
	                  }
	                } else {
	                  fillLevels = lineLevels.map(function(v) {
	                    return v - levelsIn.size / 2;
	                  });
	                  fillLevels.push(fillLevels[fillLevels.length - 1] + levelsIn.size);
	                }
	              } else if (opts._fillcolor && typeof opts._fillcolor === "string") {
	                fillLevels = [0];
	              }
	              if (levelsIn.size < 0) {
	                lineLevels.reverse();
	                fillLevels.reverse();
	              }
	              return {
	                line: lineLevels,
	                fill: fillLevels
	              };
	            }
	            function mockColorBarAxis(gd, opts, zrange) {
	              var fullLayout = gd._fullLayout;
	              var isVertical = opts.orientation === "v";
	              var cbAxisIn = {
	                type: "linear",
	                range: zrange,
	                tickmode: opts.tickmode,
	                nticks: opts.nticks,
	                tick0: opts.tick0,
	                dtick: opts.dtick,
	                tickvals: opts.tickvals,
	                ticktext: opts.ticktext,
	                ticks: opts.ticks,
	                ticklen: opts.ticklen,
	                tickwidth: opts.tickwidth,
	                tickcolor: opts.tickcolor,
	                showticklabels: opts.showticklabels,
	                labelalias: opts.labelalias,
	                ticklabelposition: opts.ticklabelposition,
	                ticklabeloverflow: opts.ticklabeloverflow,
	                ticklabelstep: opts.ticklabelstep,
	                tickfont: opts.tickfont,
	                tickangle: opts.tickangle,
	                tickformat: opts.tickformat,
	                exponentformat: opts.exponentformat,
	                minexponent: opts.minexponent,
	                separatethousands: opts.separatethousands,
	                showexponent: opts.showexponent,
	                showtickprefix: opts.showtickprefix,
	                tickprefix: opts.tickprefix,
	                showticksuffix: opts.showticksuffix,
	                ticksuffix: opts.ticksuffix,
	                title: opts.title,
	                showline: true,
	                anchor: "free",
	                side: isVertical ? "right" : "bottom",
	                position: 1
	              };
	              var letter = isVertical ? "y" : "x";
	              var cbAxisOut = {
	                type: "linear",
	                _id: letter + opts._id
	              };
	              var axisOptions = {
	                letter,
	                font: fullLayout.font,
	                noHover: true,
	                noTickson: true,
	                noTicklabelmode: true,
	                noInsideRange: true,
	                calendar: fullLayout.calendar
	                // not really necessary (yet?)
	              };
	              function coerce(attr, dflt) {
	                return Lib.coerce(cbAxisIn, cbAxisOut, axisLayoutAttrs, attr, dflt);
	              }
	              handleAxisDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions, fullLayout);
	              handleAxisPositionDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions);
	              return cbAxisOut;
	            }
	            module2.exports = {
	              draw
	            };
	          }
	        ),
	        /***/
	        76228: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function hasColorbar(container) {
	              return Lib.isPlainObject(container.colorbar);
	            };
	          }
	        ),
	        /***/
	        12311: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "component",
	              name: "colorbar",
	              attributes: __webpack_require__2(63583),
	              supplyDefaults: __webpack_require__2(62499),
	              draw: __webpack_require__2(98981).draw,
	              hasColorbar: __webpack_require__2(76228)
	            };
	          }
	        ),
	        /***/
	        50693: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorbarAttrs = __webpack_require__2(63583);
	            var counterRegex = __webpack_require__2(30587).counter;
	            var sortObjectKeys = __webpack_require__2(78607);
	            var palettes = __webpack_require__2(63282).scales;
	            sortObjectKeys(palettes);
	            module2.exports = function colorScaleAttrs(context, opts) {
	              context = context || "";
	              opts = opts || {};
	              var cLetter = opts.cLetter || "c";
	              "onlyIfNumerical" in opts ? opts.onlyIfNumerical : Boolean(context);
	              var noScale = "noScale" in opts ? opts.noScale : context === "marker.line";
	              var showScaleDflt = "showScaleDflt" in opts ? opts.showScaleDflt : cLetter === "z";
	              var colorscaleDflt = typeof opts.colorscaleDflt === "string" ? palettes[opts.colorscaleDflt] : null;
	              var editTypeOverride = opts.editTypeOverride || "";
	              var colorAttr;
	              if ("colorAttr" in opts) {
	                colorAttr = opts.colorAttr;
	                opts.colorAttr;
	              } else {
	                colorAttr = {
	                  z: "z",
	                  c: "color"
	                }[cLetter];
	              }
	              var auto = cLetter + "auto";
	              var min = cLetter + "min";
	              var max = cLetter + "max";
	              var mid = cLetter + "mid";
	              var autoImpliedEdits = {};
	              autoImpliedEdits[min] = autoImpliedEdits[max] = undefined;
	              var minmaxImpliedEdits = {};
	              minmaxImpliedEdits[auto] = false;
	              var attrs = {};
	              if (colorAttr === "color") {
	                attrs.color = {
	                  valType: "color",
	                  arrayOk: true,
	                  editType: editTypeOverride || "style"
	                };
	                if (opts.anim) {
	                  attrs.color.anim = true;
	                }
	              }
	              attrs[auto] = {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc",
	                impliedEdits: autoImpliedEdits
	              };
	              attrs[min] = {
	                valType: "number",
	                dflt: null,
	                editType: editTypeOverride || "plot",
	                impliedEdits: minmaxImpliedEdits
	              };
	              attrs[max] = {
	                valType: "number",
	                dflt: null,
	                editType: editTypeOverride || "plot",
	                impliedEdits: minmaxImpliedEdits
	              };
	              attrs[mid] = {
	                valType: "number",
	                dflt: null,
	                editType: "calc",
	                impliedEdits: autoImpliedEdits
	              };
	              attrs.colorscale = {
	                valType: "colorscale",
	                editType: "calc",
	                dflt: colorscaleDflt,
	                impliedEdits: {
	                  autocolorscale: false
	                }
	              };
	              attrs.autocolorscale = {
	                valType: "boolean",
	                // gets overrode in 'heatmap' & 'surface' for backwards comp.
	                dflt: opts.autoColorDflt === false ? false : true,
	                editType: "calc",
	                impliedEdits: {
	                  colorscale: undefined
	                }
	              };
	              attrs.reversescale = {
	                valType: "boolean",
	                dflt: false,
	                editType: "plot"
	              };
	              if (!noScale) {
	                attrs.showscale = {
	                  valType: "boolean",
	                  dflt: showScaleDflt,
	                  editType: "calc"
	                };
	                attrs.colorbar = colorbarAttrs;
	              }
	              if (!opts.noColorAxis) {
	                attrs.coloraxis = {
	                  valType: "subplotid",
	                  regex: counterRegex("coloraxis"),
	                  dflt: null,
	                  editType: "calc"
	                };
	              }
	              return attrs;
	            };
	          }
	        ),
	        /***/
	        78803: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var extractOpts = __webpack_require__2(52075).extractOpts;
	            module2.exports = function calc(gd, trace, opts) {
	              var fullLayout = gd._fullLayout;
	              var vals = opts.vals;
	              var containerStr = opts.containerStr;
	              var container = containerStr ? Lib.nestedProperty(trace, containerStr).get() : trace;
	              var cOpts = extractOpts(container);
	              var auto = cOpts.auto !== false;
	              var min = cOpts.min;
	              var max = cOpts.max;
	              var mid = cOpts.mid;
	              var minVal = function() {
	                return Lib.aggNums(Math.min, null, vals);
	              };
	              var maxVal = function() {
	                return Lib.aggNums(Math.max, null, vals);
	              };
	              if (min === undefined) {
	                min = minVal();
	              } else if (auto) {
	                if (container._colorAx && isNumeric(min)) {
	                  min = Math.min(min, minVal());
	                } else {
	                  min = minVal();
	                }
	              }
	              if (max === undefined) {
	                max = maxVal();
	              } else if (auto) {
	                if (container._colorAx && isNumeric(max)) {
	                  max = Math.max(max, maxVal());
	                } else {
	                  max = maxVal();
	                }
	              }
	              if (auto && mid !== undefined) {
	                if (max - mid > mid - min) {
	                  min = mid - (max - mid);
	                } else if (max - mid < mid - min) {
	                  max = mid + (mid - min);
	                }
	              }
	              if (min === max) {
	                min -= 0.5;
	                max += 0.5;
	              }
	              cOpts._sync("min", min);
	              cOpts._sync("max", max);
	              if (cOpts.autocolorscale) {
	                var scl;
	                if (min * max < 0) scl = fullLayout.colorscale.diverging;
	                else if (min >= 0) scl = fullLayout.colorscale.sequential;
	                else scl = fullLayout.colorscale.sequentialminus;
	                cOpts._sync("colorscale", scl);
	              }
	            };
	          }
	        ),
	        /***/
	        33046: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var extractOpts = __webpack_require__2(52075).extractOpts;
	            module2.exports = function crossTraceDefaults(fullData, fullLayout) {
	              function replace(cont, k2) {
	                var val = cont["_" + k2];
	                if (val !== undefined) {
	                  cont[k2] = val;
	                }
	              }
	              function relinkColorAttrs(outerCont, cbOpt) {
	                var cont = cbOpt.container ? Lib.nestedProperty(outerCont, cbOpt.container).get() : outerCont;
	                if (cont) {
	                  if (cont.coloraxis) {
	                    cont._colorAx = fullLayout[cont.coloraxis];
	                  } else {
	                    var cOpts = extractOpts(cont);
	                    var isAuto = cOpts.auto;
	                    if (isAuto || cOpts.min === undefined) {
	                      replace(cont, cbOpt.min);
	                    }
	                    if (isAuto || cOpts.max === undefined) {
	                      replace(cont, cbOpt.max);
	                    }
	                    if (cOpts.autocolorscale) {
	                      replace(cont, "colorscale");
	                    }
	                  }
	                }
	              }
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                var cbOpts = trace._module.colorbar;
	                if (cbOpts) {
	                  if (Array.isArray(cbOpts)) {
	                    for (var j = 0; j < cbOpts.length; j++) {
	                      relinkColorAttrs(trace, cbOpts[j]);
	                    }
	                  } else {
	                    relinkColorAttrs(trace, cbOpts);
	                  }
	                }
	                if (hasColorscale(trace, "marker.line")) {
	                  relinkColorAttrs(trace, {
	                    container: "marker.line",
	                    min: "cmin",
	                    max: "cmax"
	                  });
	                }
	              }
	              for (var k in fullLayout._colorAxes) {
	                relinkColorAttrs(fullLayout[k], {
	                  min: "cmin",
	                  max: "cmax"
	                });
	              }
	            };
	          }
	        ),
	        /***/
	        1586: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var hasColorbar = __webpack_require__2(76228);
	            var colorbarDefaults = __webpack_require__2(62499);
	            var isValidScale = __webpack_require__2(63282).isValid;
	            var traceIs = __webpack_require__2(73972).traceIs;
	            function npMaybe(parentCont, prefix) {
	              var containerStr = prefix.slice(0, prefix.length - 1);
	              return prefix ? Lib.nestedProperty(parentCont, containerStr).get() || {} : parentCont;
	            }
	            module2.exports = function colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts) {
	              var prefix = opts.prefix;
	              var cLetter = opts.cLetter;
	              var inTrace = "_module" in parentContOut;
	              var containerIn = npMaybe(parentContIn, prefix);
	              var containerOut = npMaybe(parentContOut, prefix);
	              var template = npMaybe(parentContOut._template || {}, prefix) || {};
	              var thisFn = function() {
	                delete parentContIn.coloraxis;
	                delete parentContOut.coloraxis;
	                return colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts);
	              };
	              if (inTrace) {
	                var colorAxes = layout._colorAxes || {};
	                var colorAx = coerce(prefix + "coloraxis");
	                if (colorAx) {
	                  var colorbarVisuals = traceIs(parentContOut, "contour") && Lib.nestedProperty(parentContOut, "contours.coloring").get() || "heatmap";
	                  var stash = colorAxes[colorAx];
	                  if (stash) {
	                    stash[2].push(thisFn);
	                    if (stash[0] !== colorbarVisuals) {
	                      stash[0] = false;
	                      Lib.warn(["Ignoring coloraxis:", colorAx, "setting", "as it is linked to incompatible colorscales."].join(" "));
	                    }
	                  } else {
	                    colorAxes[colorAx] = [colorbarVisuals, parentContOut, [thisFn]];
	                  }
	                  return;
	                }
	              }
	              var minIn = containerIn[cLetter + "min"];
	              var maxIn = containerIn[cLetter + "max"];
	              var validMinMax = isNumeric(minIn) && isNumeric(maxIn) && minIn < maxIn;
	              var auto = coerce(prefix + cLetter + "auto", !validMinMax);
	              if (auto) {
	                coerce(prefix + cLetter + "mid");
	              } else {
	                coerce(prefix + cLetter + "min");
	                coerce(prefix + cLetter + "max");
	              }
	              var sclIn = containerIn.colorscale;
	              var sclTemplate = template.colorscale;
	              var autoColorscaleDflt;
	              if (sclIn !== undefined) autoColorscaleDflt = !isValidScale(sclIn);
	              if (sclTemplate !== undefined) autoColorscaleDflt = !isValidScale(sclTemplate);
	              coerce(prefix + "autocolorscale", autoColorscaleDflt);
	              coerce(prefix + "colorscale");
	              coerce(prefix + "reversescale");
	              if (prefix !== "marker.line.") {
	                var showScaleDflt;
	                if (prefix && inTrace) showScaleDflt = hasColorbar(containerIn);
	                var showScale = coerce(prefix + "showscale", showScaleDflt);
	                if (showScale) {
	                  if (prefix && template) containerOut._template = template;
	                  colorbarDefaults(containerIn, containerOut, layout);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        52075: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var tinycolor = __webpack_require__2(84267);
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var isValidScale = __webpack_require__2(63282).isValid;
	            function hasColorscale(trace, containerStr, colorKey) {
	              var container = containerStr ? Lib.nestedProperty(trace, containerStr).get() || {} : trace;
	              var color = container[colorKey || "color"];
	              var isArrayWithOneNumber = false;
	              if (Lib.isArrayOrTypedArray(color)) {
	                for (var i = 0; i < color.length; i++) {
	                  if (isNumeric(color[i])) {
	                    isArrayWithOneNumber = true;
	                    break;
	                  }
	                }
	              }
	              return Lib.isPlainObject(container) && (isArrayWithOneNumber || container.showscale === true || isNumeric(container.cmin) && isNumeric(container.cmax) || isValidScale(container.colorscale) || Lib.isPlainObject(container.colorbar));
	            }
	            var constantAttrs = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"];
	            var letterAttrs = ["min", "max", "mid", "auto"];
	            function extractOpts(cont) {
	              var colorAx = cont._colorAx;
	              var cont2 = colorAx ? colorAx : cont;
	              var out = {};
	              var cLetter;
	              var i, k;
	              for (i = 0; i < constantAttrs.length; i++) {
	                k = constantAttrs[i];
	                out[k] = cont2[k];
	              }
	              if (colorAx) {
	                cLetter = "c";
	                for (i = 0; i < letterAttrs.length; i++) {
	                  k = letterAttrs[i];
	                  out[k] = cont2["c" + k];
	                }
	              } else {
	                var k2;
	                for (i = 0; i < letterAttrs.length; i++) {
	                  k = letterAttrs[i];
	                  k2 = "c" + k;
	                  if (k2 in cont2) {
	                    out[k] = cont2[k2];
	                    continue;
	                  }
	                  k2 = "z" + k;
	                  if (k2 in cont2) {
	                    out[k] = cont2[k2];
	                  }
	                }
	                cLetter = k2.charAt(0);
	              }
	              out._sync = function(k3, v) {
	                var k22 = letterAttrs.indexOf(k3) !== -1 ? cLetter + k3 : k3;
	                cont2[k22] = cont2["_" + k22] = v;
	              };
	              return out;
	            }
	            function extractScale(cont) {
	              var cOpts = extractOpts(cont);
	              var cmin = cOpts.min;
	              var cmax = cOpts.max;
	              var scl = cOpts.reversescale ? flipScale(cOpts.colorscale) : cOpts.colorscale;
	              var N = scl.length;
	              var domain = new Array(N);
	              var range2 = new Array(N);
	              for (var i = 0; i < N; i++) {
	                var si = scl[i];
	                domain[i] = cmin + si[0] * (cmax - cmin);
	                range2[i] = si[1];
	              }
	              return {
	                domain,
	                range: range2
	              };
	            }
	            function flipScale(scl) {
	              var N = scl.length;
	              var sclNew = new Array(N);
	              for (var i = N - 1, j = 0; i >= 0; i--, j++) {
	                var si = scl[i];
	                sclNew[j] = [1 - si[0], si[1]];
	              }
	              return sclNew;
	            }
	            function makeColorScaleFunc(specs, opts) {
	              opts = opts || {};
	              var domain = specs.domain;
	              var range2 = specs.range;
	              var N = range2.length;
	              var _range = new Array(N);
	              for (var i = 0; i < N; i++) {
	                var rgba = tinycolor(range2[i]).toRgb();
	                _range[i] = [rgba.r, rgba.g, rgba.b, rgba.a];
	              }
	              var _sclFunc = d3.scale.linear().domain(domain).range(_range).clamp(true);
	              var noNumericCheck = opts.noNumericCheck;
	              var returnArray = opts.returnArray;
	              var sclFunc;
	              if (noNumericCheck && returnArray) {
	                sclFunc = _sclFunc;
	              } else if (noNumericCheck) {
	                sclFunc = function(v) {
	                  return colorArray2rbga(_sclFunc(v));
	                };
	              } else if (returnArray) {
	                sclFunc = function(v) {
	                  if (isNumeric(v)) return _sclFunc(v);
	                  else if (tinycolor(v).isValid()) return v;
	                  else return Color.defaultLine;
	                };
	              } else {
	                sclFunc = function(v) {
	                  if (isNumeric(v)) return colorArray2rbga(_sclFunc(v));
	                  else if (tinycolor(v).isValid()) return v;
	                  else return Color.defaultLine;
	                };
	              }
	              sclFunc.domain = _sclFunc.domain;
	              sclFunc.range = function() {
	                return range2;
	              };
	              return sclFunc;
	            }
	            function makeColorScaleFuncFromTrace(trace, opts) {
	              return makeColorScaleFunc(extractScale(trace), opts);
	            }
	            function colorArray2rbga(colorArray) {
	              var colorObj = {
	                r: colorArray[0],
	                g: colorArray[1],
	                b: colorArray[2],
	                a: colorArray[3]
	              };
	              return tinycolor(colorObj).toRgbString();
	            }
	            module2.exports = {
	              hasColorscale,
	              extractOpts,
	              extractScale,
	              flipScale,
	              makeColorScaleFunc,
	              makeColorScaleFuncFromTrace
	            };
	          }
	        ),
	        /***/
	        21081: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scales = __webpack_require__2(63282);
	            var helpers = __webpack_require__2(52075);
	            module2.exports = {
	              moduleType: "component",
	              name: "colorscale",
	              attributes: __webpack_require__2(50693),
	              layoutAttributes: __webpack_require__2(72673),
	              supplyLayoutDefaults: __webpack_require__2(30959),
	              handleDefaults: __webpack_require__2(1586),
	              crossTraceDefaults: __webpack_require__2(33046),
	              calc: __webpack_require__2(78803),
	              // ./scales.js is required in lib/coerce.js ;
	              // it needs to be a separate module to avoid a circular dependency
	              scales: scales.scales,
	              defaultScale: scales.defaultScale,
	              getScale: scales.get,
	              isValidScale: scales.isValid,
	              hasColorscale: helpers.hasColorscale,
	              extractOpts: helpers.extractOpts,
	              extractScale: helpers.extractScale,
	              flipScale: helpers.flipScale,
	              makeColorScaleFunc: helpers.makeColorScaleFunc,
	              makeColorScaleFuncFromTrace: helpers.makeColorScaleFuncFromTrace
	            };
	          }
	        ),
	        /***/
	        72673: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var scales = __webpack_require__2(63282).scales;
	            module2.exports = {
	              editType: "calc",
	              colorscale: {
	                editType: "calc",
	                sequential: {
	                  valType: "colorscale",
	                  dflt: scales.Reds,
	                  editType: "calc"
	                },
	                sequentialminus: {
	                  valType: "colorscale",
	                  dflt: scales.Blues,
	                  editType: "calc"
	                },
	                diverging: {
	                  valType: "colorscale",
	                  dflt: scales.RdBu,
	                  editType: "calc"
	                }
	              },
	              coloraxis: extendFlat({
	                // not really a 'subplot' attribute container,
	                // but this is the flag we use to denote attributes that
	                // support yaxis, yaxis2, yaxis3, ... counters
	                _isSubplotObj: true,
	                editType: "calc"
	              }, colorScaleAttrs("", {
	                colorAttr: "corresponding trace color array(s)",
	                noColorAxis: true,
	                showScaleDflt: true
	              }))
	            };
	          }
	        ),
	        /***/
	        30959: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var colorScaleAttrs = __webpack_require__2(72673);
	            var colorScaleDefaults = __webpack_require__2(1586);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, colorScaleAttrs, attr, dflt);
	              }
	              coerce("colorscale.sequential");
	              coerce("colorscale.sequentialminus");
	              coerce("colorscale.diverging");
	              var colorAxes = layoutOut._colorAxes;
	              var colorAxIn, colorAxOut;
	              function coerceAx(attr, dflt) {
	                return Lib.coerce(colorAxIn, colorAxOut, colorScaleAttrs.coloraxis, attr, dflt);
	              }
	              for (var k in colorAxes) {
	                var stash = colorAxes[k];
	                if (stash[0]) {
	                  colorAxIn = layoutIn[k] || {};
	                  colorAxOut = Template.newContainer(layoutOut, k, "coloraxis");
	                  colorAxOut._name = k;
	                  colorScaleDefaults(colorAxIn, colorAxOut, layoutOut, coerceAx, {
	                    prefix: "",
	                    cLetter: "c"
	                  });
	                } else {
	                  for (var i = 0; i < stash[2].length; i++) {
	                    stash[2][i]();
	                  }
	                  delete layoutOut._colorAxes[k];
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        63282: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var tinycolor = __webpack_require__2(84267);
	            var scales = {
	              Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]],
	              YlGnBu: [[0, "rgb(8,29,88)"], [0.125, "rgb(37,52,148)"], [0.25, "rgb(34,94,168)"], [0.375, "rgb(29,145,192)"], [0.5, "rgb(65,182,196)"], [0.625, "rgb(127,205,187)"], [0.75, "rgb(199,233,180)"], [0.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]],
	              Greens: [[0, "rgb(0,68,27)"], [0.125, "rgb(0,109,44)"], [0.25, "rgb(35,139,69)"], [0.375, "rgb(65,171,93)"], [0.5, "rgb(116,196,118)"], [0.625, "rgb(161,217,155)"], [0.75, "rgb(199,233,192)"], [0.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]],
	              YlOrRd: [[0, "rgb(128,0,38)"], [0.125, "rgb(189,0,38)"], [0.25, "rgb(227,26,28)"], [0.375, "rgb(252,78,42)"], [0.5, "rgb(253,141,60)"], [0.625, "rgb(254,178,76)"], [0.75, "rgb(254,217,118)"], [0.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]],
	              Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]],
	              // modified RdBu based on
	              // http://www.kennethmoreland.com/color-maps/
	              RdBu: [[0, "rgb(5,10,172)"], [0.35, "rgb(106,137,247)"], [0.5, "rgb(190,190,190)"], [0.6, "rgb(220,170,132)"], [0.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]],
	              // Scale for non-negative numeric values
	              Reds: [[0, "rgb(220,220,220)"], [0.2, "rgb(245,195,157)"], [0.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]],
	              // Scale for non-positive numeric values
	              Blues: [[0, "rgb(5,10,172)"], [0.35, "rgb(40,60,190)"], [0.5, "rgb(70,100,245)"], [0.6, "rgb(90,120,245)"], [0.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]],
	              Picnic: [[0, "rgb(0,0,255)"], [0.1, "rgb(51,153,255)"], [0.2, "rgb(102,204,255)"], [0.3, "rgb(153,204,255)"], [0.4, "rgb(204,204,255)"], [0.5, "rgb(255,255,255)"], [0.6, "rgb(255,204,255)"], [0.7, "rgb(255,153,255)"], [0.8, "rgb(255,102,204)"], [0.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]],
	              Rainbow: [[0, "rgb(150,0,90)"], [0.125, "rgb(0,0,200)"], [0.25, "rgb(0,25,255)"], [0.375, "rgb(0,152,255)"], [0.5, "rgb(44,255,150)"], [0.625, "rgb(151,255,0)"], [0.75, "rgb(255,234,0)"], [0.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]],
	              Portland: [[0, "rgb(12,51,131)"], [0.25, "rgb(10,136,186)"], [0.5, "rgb(242,211,56)"], [0.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]],
	              Jet: [[0, "rgb(0,0,131)"], [0.125, "rgb(0,60,170)"], [0.375, "rgb(5,255,255)"], [0.625, "rgb(255,255,0)"], [0.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]],
	              Hot: [[0, "rgb(0,0,0)"], [0.3, "rgb(230,0,0)"], [0.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]],
	              Blackbody: [[0, "rgb(0,0,0)"], [0.2, "rgb(230,0,0)"], [0.4, "rgb(230,210,0)"], [0.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]],
	              Earth: [[0, "rgb(0,0,130)"], [0.1, "rgb(0,180,180)"], [0.2, "rgb(40,210,40)"], [0.4, "rgb(230,230,50)"], [0.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]],
	              Electric: [[0, "rgb(0,0,0)"], [0.15, "rgb(30,0,100)"], [0.4, "rgb(120,0,100)"], [0.6, "rgb(160,90,0)"], [0.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]],
	              Viridis: [[0, "#440154"], [0.06274509803921569, "#48186a"], [0.12549019607843137, "#472d7b"], [0.18823529411764706, "#424086"], [0.25098039215686274, "#3b528b"], [0.3137254901960784, "#33638d"], [0.3764705882352941, "#2c728e"], [0.4392156862745098, "#26828e"], [0.5019607843137255, "#21918c"], [0.5647058823529412, "#1fa088"], [0.6274509803921569, "#28ae80"], [0.6901960784313725, "#3fbc73"], [0.7529411764705882, "#5ec962"], [0.8156862745098039, "#84d44b"], [0.8784313725490196, "#addc30"], [0.9411764705882353, "#d8e219"], [1, "#fde725"]],
	              Cividis: [[0, "rgb(0,32,76)"], [0.058824, "rgb(0,42,102)"], [0.117647, "rgb(0,52,110)"], [0.176471, "rgb(39,63,108)"], [0.235294, "rgb(60,74,107)"], [0.294118, "rgb(76,85,107)"], [0.352941, "rgb(91,95,109)"], [0.411765, "rgb(104,106,112)"], [0.470588, "rgb(117,117,117)"], [0.529412, "rgb(131,129,120)"], [0.588235, "rgb(146,140,120)"], [0.647059, "rgb(161,152,118)"], [0.705882, "rgb(176,165,114)"], [0.764706, "rgb(192,177,109)"], [0.823529, "rgb(209,191,102)"], [0.882353, "rgb(225,204,92)"], [0.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]]
	            };
	            var defaultScale = scales.RdBu;
	            function getScale(scl, dflt) {
	              if (!dflt) dflt = defaultScale;
	              if (!scl) return dflt;
	              function parseScale() {
	                try {
	                  scl = scales[scl] || JSON.parse(scl);
	                } catch (e) {
	                  scl = dflt;
	                }
	              }
	              if (typeof scl === "string") {
	                parseScale();
	                if (typeof scl === "string") parseScale();
	              }
	              if (!isValidScaleArray(scl)) return dflt;
	              return scl;
	            }
	            function isValidScaleArray(scl) {
	              var highestVal = 0;
	              if (!Array.isArray(scl) || scl.length < 2) return false;
	              if (!scl[0] || !scl[scl.length - 1]) return false;
	              if (+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
	              for (var i = 0; i < scl.length; i++) {
	                var si = scl[i];
	                if (si.length !== 2 || +si[0] < highestVal || !tinycolor(si[1]).isValid()) {
	                  return false;
	                }
	                highestVal = +si[0];
	              }
	              return true;
	            }
	            function isValidScale(scl) {
	              if (scales[scl] !== undefined) return true;
	              else return isValidScaleArray(scl);
	            }
	            module2.exports = {
	              scales,
	              defaultScale,
	              get: getScale,
	              isValid: isValidScale
	            };
	          }
	        ),
	        /***/
	        92807: (
	          /***/
	          function(module2) {
	            module2.exports = function align(v, dv, v0, v1, anchor) {
	              var vmin = (v - v0) / (v1 - v0);
	              var vmax = vmin + dv / (v1 - v0);
	              var vc = (vmin + vmax) / 2;
	              if (anchor === "left" || anchor === "bottom") return vmin;
	              if (anchor === "center" || anchor === "middle") return vc;
	              if (anchor === "right" || anchor === "top") return vmax;
	              if (vmin < 2 / 3 - vc) return vmin;
	              if (vmax > 4 / 3 - vc) return vmax;
	              return vc;
	            };
	          }
	        ),
	        /***/
	        70461: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var cursorset = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];
	            module2.exports = function getCursor(x, y, xanchor, yanchor) {
	              if (xanchor === "left") x = 0;
	              else if (xanchor === "center") x = 1;
	              else if (xanchor === "right") x = 2;
	              else x = Lib.constrain(Math.floor(x * 3), 0, 2);
	              if (yanchor === "bottom") y = 0;
	              else if (yanchor === "middle") y = 1;
	              else if (yanchor === "top") y = 2;
	              else y = Lib.constrain(Math.floor(y * 3), 0, 2);
	              return cursorset[y][x];
	            };
	          }
	        ),
	        /***/
	        64505: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.selectMode = function(dragmode) {
	              return dragmode === "lasso" || dragmode === "select";
	            };
	            exports2.drawMode = function(dragmode) {
	              return dragmode === "drawclosedpath" || dragmode === "drawopenpath" || dragmode === "drawline" || dragmode === "drawrect" || dragmode === "drawcircle";
	            };
	            exports2.openMode = function(dragmode) {
	              return dragmode === "drawline" || dragmode === "drawopenpath";
	            };
	            exports2.rectMode = function(dragmode) {
	              return dragmode === "select" || dragmode === "drawline" || dragmode === "drawrect" || dragmode === "drawcircle";
	            };
	            exports2.freeMode = function(dragmode) {
	              return dragmode === "lasso" || dragmode === "drawclosedpath" || dragmode === "drawopenpath";
	            };
	            exports2.selectingOrDrawing = function(dragmode) {
	              return exports2.freeMode(dragmode) || exports2.rectMode(dragmode);
	            };
	          }
	        ),
	        /***/
	        28569: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var mouseOffset = __webpack_require__2(48956);
	            var hasHover = __webpack_require__2(57035);
	            var supportsPassive = __webpack_require__2(38520);
	            var removeElement = __webpack_require__2(71828).removeElement;
	            var constants = __webpack_require__2(85555);
	            var dragElement = module2.exports = {};
	            dragElement.align = __webpack_require__2(92807);
	            dragElement.getCursor = __webpack_require__2(70461);
	            var unhover = __webpack_require__2(26041);
	            dragElement.unhover = unhover.wrapped;
	            dragElement.unhoverRaw = unhover.raw;
	            dragElement.init = function init(options) {
	              var gd = options.gd;
	              var numClicks = 1;
	              var doubleClickDelay = gd._context.doubleClickDelay;
	              var element = options.element;
	              var startX, startY, newMouseDownTime, cursor, dragCover, initialEvent, initialTarget, rightClick;
	              if (!gd._mouseDownTime) gd._mouseDownTime = 0;
	              element.style.pointerEvents = "all";
	              element.onmousedown = onStart;
	              if (!supportsPassive) {
	                element.ontouchstart = onStart;
	              } else {
	                if (element._ontouchstart) {
	                  element.removeEventListener("touchstart", element._ontouchstart);
	                }
	                element._ontouchstart = onStart;
	                element.addEventListener("touchstart", onStart, {
	                  passive: false
	                });
	              }
	              function _clampFn(dx, dy, minDrag) {
	                if (Math.abs(dx) < minDrag) dx = 0;
	                if (Math.abs(dy) < minDrag) dy = 0;
	                return [dx, dy];
	              }
	              var clampFn = options.clampFn || _clampFn;
	              function onStart(e) {
	                gd._dragged = false;
	                gd._dragging = true;
	                var offset = pointerOffset(e);
	                startX = offset[0];
	                startY = offset[1];
	                initialTarget = e.target;
	                initialEvent = e;
	                rightClick = e.buttons === 2 || e.ctrlKey;
	                if (typeof e.clientX === "undefined" && typeof e.clientY === "undefined") {
	                  e.clientX = startX;
	                  e.clientY = startY;
	                }
	                newMouseDownTime = (/* @__PURE__ */ new Date()).getTime();
	                if (newMouseDownTime - gd._mouseDownTime < doubleClickDelay) {
	                  numClicks += 1;
	                } else {
	                  numClicks = 1;
	                  gd._mouseDownTime = newMouseDownTime;
	                }
	                if (options.prepFn) options.prepFn(e, startX, startY);
	                if (hasHover && !rightClick) {
	                  dragCover = coverSlip();
	                  dragCover.style.cursor = window.getComputedStyle(element).cursor;
	                } else if (!hasHover) {
	                  dragCover = document;
	                  cursor = window.getComputedStyle(document.documentElement).cursor;
	                  document.documentElement.style.cursor = window.getComputedStyle(element).cursor;
	                }
	                document.addEventListener("mouseup", onDone);
	                document.addEventListener("touchend", onDone);
	                if (options.dragmode !== false) {
	                  e.preventDefault();
	                  document.addEventListener("mousemove", onMove);
	                  document.addEventListener("touchmove", onMove, {
	                    passive: false
	                  });
	                }
	                return;
	              }
	              function onMove(e) {
	                e.preventDefault();
	                var offset = pointerOffset(e);
	                var minDrag = options.minDrag || constants.MINDRAG;
	                var dxdy = clampFn(offset[0] - startX, offset[1] - startY, minDrag);
	                var dx = dxdy[0];
	                var dy = dxdy[1];
	                if (dx || dy) {
	                  gd._dragged = true;
	                  dragElement.unhover(gd, e);
	                }
	                if (gd._dragged && options.moveFn && !rightClick) {
	                  gd._dragdata = {
	                    element,
	                    dx,
	                    dy
	                  };
	                  options.moveFn(dx, dy);
	                }
	                return;
	              }
	              function onDone(e) {
	                delete gd._dragdata;
	                if (options.dragmode !== false) {
	                  e.preventDefault();
	                  document.removeEventListener("mousemove", onMove);
	                  document.removeEventListener("touchmove", onMove);
	                }
	                document.removeEventListener("mouseup", onDone);
	                document.removeEventListener("touchend", onDone);
	                if (hasHover) {
	                  removeElement(dragCover);
	                } else if (cursor) {
	                  dragCover.documentElement.style.cursor = cursor;
	                  cursor = null;
	                }
	                if (!gd._dragging) {
	                  gd._dragged = false;
	                  return;
	                }
	                gd._dragging = false;
	                if ((/* @__PURE__ */ new Date()).getTime() - gd._mouseDownTime > doubleClickDelay) {
	                  numClicks = Math.max(numClicks - 1, 1);
	                }
	                if (gd._dragged) {
	                  if (options.doneFn) options.doneFn();
	                } else {
	                  if (options.clickFn) options.clickFn(numClicks, initialEvent);
	                  if (!rightClick) {
	                    var e2;
	                    try {
	                      e2 = new MouseEvent("click", e);
	                    } catch (err) {
	                      var offset = pointerOffset(e);
	                      e2 = document.createEvent("MouseEvents");
	                      e2.initMouseEvent("click", e.bubbles, e.cancelable, e.view, e.detail, e.screenX, e.screenY, offset[0], offset[1], e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
	                    }
	                    initialTarget.dispatchEvent(e2);
	                  }
	                }
	                gd._dragging = false;
	                gd._dragged = false;
	                return;
	              }
	            };
	            function coverSlip() {
	              var cover = document.createElement("div");
	              cover.className = "dragcover";
	              var cStyle = cover.style;
	              cStyle.position = "fixed";
	              cStyle.left = 0;
	              cStyle.right = 0;
	              cStyle.top = 0;
	              cStyle.bottom = 0;
	              cStyle.zIndex = 999999999;
	              cStyle.background = "none";
	              document.body.appendChild(cover);
	              return cover;
	            }
	            dragElement.coverSlip = coverSlip;
	            function pointerOffset(e) {
	              return mouseOffset(e.changedTouches ? e.changedTouches[0] : e, document.body);
	            }
	          }
	        ),
	        /***/
	        26041: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Events = __webpack_require__2(11086);
	            var throttle = __webpack_require__2(79990);
	            var getGraphDiv = __webpack_require__2(24401).getGraphDiv;
	            var hoverConstants = __webpack_require__2(26675);
	            var unhover = module2.exports = {};
	            unhover.wrapped = function(gd, evt, subplot) {
	              gd = getGraphDiv(gd);
	              if (gd._fullLayout) {
	                throttle.clear(gd._fullLayout._uid + hoverConstants.HOVERID);
	              }
	              unhover.raw(gd, evt, subplot);
	            };
	            unhover.raw = function raw(gd, evt) {
	              var fullLayout = gd._fullLayout;
	              var oldhoverdata = gd._hoverdata;
	              if (!evt) evt = {};
	              if (evt.target && !gd._dragged && Events.triggerHandler(gd, "plotly_beforehover", evt) === false) {
	                return;
	              }
	              fullLayout._hoverlayer.selectAll("g").remove();
	              fullLayout._hoverlayer.selectAll("line").remove();
	              fullLayout._hoverlayer.selectAll("circle").remove();
	              gd._hoverdata = undefined;
	              if (evt.target && oldhoverdata) {
	                gd.emit("plotly_unhover", {
	                  event: evt,
	                  points: oldhoverdata
	                });
	              }
	            };
	          }
	        ),
	        /***/
	        79952: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.P = {
	              valType: "string",
	              // string type usually doesn't take values... this one should really be
	              // a special type or at least a special coercion function, from the GUI
	              // you only get these values but elsewhere the user can supply a list of
	              // dash lengths in px, and it will be honored
	              values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"],
	              dflt: "solid",
	              editType: "style"
	            };
	            exports2.u = {
	              shape: {
	                valType: "enumerated",
	                values: ["", "/", "\\", "x", "-", "|", "+", "."],
	                dflt: "",
	                arrayOk: true,
	                editType: "style"
	              },
	              fillmode: {
	                valType: "enumerated",
	                values: ["replace", "overlay"],
	                dflt: "replace",
	                editType: "style"
	              },
	              bgcolor: {
	                valType: "color",
	                arrayOk: true,
	                editType: "style"
	              },
	              fgcolor: {
	                valType: "color",
	                arrayOk: true,
	                editType: "style"
	              },
	              fgopacity: {
	                valType: "number",
	                editType: "style",
	                min: 0,
	                max: 1
	              },
	              size: {
	                valType: "number",
	                min: 0,
	                dflt: 8,
	                arrayOk: true,
	                editType: "style"
	              },
	              solidity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0.3,
	                arrayOk: true,
	                editType: "style"
	              },
	              editType: "style"
	            };
	          }
	        ),
	        /***/
	        91424: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var numberFormat = Lib.numberFormat;
	            var isNumeric = __webpack_require__2(92770);
	            var tinycolor = __webpack_require__2(84267);
	            var Registry = __webpack_require__2(73972);
	            var Color = __webpack_require__2(7901);
	            var Colorscale = __webpack_require__2(21081);
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var alignment = __webpack_require__2(18783);
	            var LINE_SPACING = alignment.LINE_SPACING;
	            var DESELECTDIM = __webpack_require__2(37822).DESELECTDIM;
	            var subTypes = __webpack_require__2(34098);
	            var makeBubbleSizeFn = __webpack_require__2(39984);
	            var appendArrayPointValue = __webpack_require__2(23469).appendArrayPointValue;
	            var drawing = module2.exports = {};
	            drawing.font = function(s, family, size, color) {
	              if (Lib.isPlainObject(family)) {
	                color = family.color;
	                size = family.size;
	                family = family.family;
	              }
	              if (family) s.style("font-family", family);
	              if (size + 1) s.style("font-size", size + "px");
	              if (color) s.call(Color.fill, color);
	            };
	            drawing.setPosition = function(s, x, y) {
	              s.attr("x", x).attr("y", y);
	            };
	            drawing.setSize = function(s, w, h) {
	              s.attr("width", w).attr("height", h);
	            };
	            drawing.setRect = function(s, x, y, w, h) {
	              s.call(drawing.setPosition, x, y).call(drawing.setSize, w, h);
	            };
	            drawing.translatePoint = function(d, sel, xa, ya) {
	              var x = xa.c2p(d.x);
	              var y = ya.c2p(d.y);
	              if (isNumeric(x) && isNumeric(y) && sel.node()) {
	                if (sel.node().nodeName === "text") {
	                  sel.attr("x", x).attr("y", y);
	                } else {
	                  sel.attr("transform", strTranslate(x, y));
	                }
	              } else {
	                return false;
	              }
	              return true;
	            };
	            drawing.translatePoints = function(s, xa, ya) {
	              s.each(function(d) {
	                var sel = d3.select(this);
	                drawing.translatePoint(d, sel, xa, ya);
	              });
	            };
	            drawing.hideOutsideRangePoint = function(d, sel, xa, ya, xcalendar, ycalendar) {
	              sel.attr("display", xa.isPtWithinRange(d, xcalendar) && ya.isPtWithinRange(d, ycalendar) ? null : "none");
	            };
	            drawing.hideOutsideRangePoints = function(traceGroups, subplot) {
	              if (!subplot._hasClipOnAxisFalse) return;
	              var xa = subplot.xaxis;
	              var ya = subplot.yaxis;
	              traceGroups.each(function(d) {
	                var trace = d[0].trace;
	                var xcalendar = trace.xcalendar;
	                var ycalendar = trace.ycalendar;
	                var selector = Registry.traceIs(trace, "bar-like") ? ".bartext" : ".point,.textpoint";
	                traceGroups.selectAll(selector).each(function(d2) {
	                  drawing.hideOutsideRangePoint(d2, d3.select(this), xa, ya, xcalendar, ycalendar);
	                });
	              });
	            };
	            drawing.crispRound = function(gd, lineWidth, dflt) {
	              if (!lineWidth || !isNumeric(lineWidth)) return dflt || 0;
	              if (gd._context.staticPlot) return lineWidth;
	              if (lineWidth < 1) return 1;
	              return Math.round(lineWidth);
	            };
	            drawing.singleLineStyle = function(d, s, lw, lc, ld) {
	              s.style("fill", "none");
	              var line = (((d || [])[0] || {}).trace || {}).line || {};
	              var lw1 = lw || line.width || 0;
	              var dash = ld || line.dash || "";
	              Color.stroke(s, lc || line.color);
	              drawing.dashLine(s, dash, lw1);
	            };
	            drawing.lineGroupStyle = function(s, lw, lc, ld) {
	              s.style("fill", "none").each(function(d) {
	                var line = (((d || [])[0] || {}).trace || {}).line || {};
	                var lw1 = lw || line.width || 0;
	                var dash = ld || line.dash || "";
	                d3.select(this).call(Color.stroke, lc || line.color).call(drawing.dashLine, dash, lw1);
	              });
	            };
	            drawing.dashLine = function(s, dash, lineWidth) {
	              lineWidth = +lineWidth || 0;
	              dash = drawing.dashStyle(dash, lineWidth);
	              s.style({
	                "stroke-dasharray": dash,
	                "stroke-width": lineWidth + "px"
	              });
	            };
	            drawing.dashStyle = function(dash, lineWidth) {
	              lineWidth = +lineWidth || 1;
	              var dlw = Math.max(lineWidth, 3);
	              if (dash === "solid") dash = "";
	              else if (dash === "dot") dash = dlw + "px," + dlw + "px";
	              else if (dash === "dash") dash = 3 * dlw + "px," + 3 * dlw + "px";
	              else if (dash === "longdash") dash = 5 * dlw + "px," + 5 * dlw + "px";
	              else if (dash === "dashdot") {
	                dash = 3 * dlw + "px," + dlw + "px," + dlw + "px," + dlw + "px";
	              } else if (dash === "longdashdot") {
	                dash = 5 * dlw + "px," + 2 * dlw + "px," + dlw + "px," + 2 * dlw + "px";
	              }
	              return dash;
	            };
	            function setFillStyle(sel, trace, gd) {
	              var markerPattern = trace.fillpattern;
	              var patternShape = markerPattern && drawing.getPatternAttr(markerPattern.shape, 0, "");
	              if (patternShape) {
	                var patternBGColor = drawing.getPatternAttr(markerPattern.bgcolor, 0, null);
	                var patternFGColor = drawing.getPatternAttr(markerPattern.fgcolor, 0, null);
	                var patternFGOpacity = markerPattern.fgopacity;
	                var patternSize = drawing.getPatternAttr(markerPattern.size, 0, 8);
	                var patternSolidity = drawing.getPatternAttr(markerPattern.solidity, 0, 0.3);
	                var patternID = trace.uid;
	                drawing.pattern(sel, "point", gd, patternID, patternShape, patternSize, patternSolidity, undefined, markerPattern.fillmode, patternBGColor, patternFGColor, patternFGOpacity);
	              } else if (trace.fillcolor) {
	                sel.call(Color.fill, trace.fillcolor);
	              }
	            }
	            drawing.singleFillStyle = function(sel, gd) {
	              var node = d3.select(sel.node());
	              var data = node.data();
	              var trace = ((data[0] || [])[0] || {}).trace || {};
	              setFillStyle(sel, trace, gd);
	            };
	            drawing.fillGroupStyle = function(s, gd) {
	              s.style("stroke-width", 0).each(function(d) {
	                var shape = d3.select(this);
	                if (d[0].trace) {
	                  setFillStyle(shape, d[0].trace, gd);
	                }
	              });
	            };
	            var SYMBOLDEFS = __webpack_require__2(90998);
	            drawing.symbolNames = [];
	            drawing.symbolFuncs = [];
	            drawing.symbolBackOffs = [];
	            drawing.symbolNeedLines = {};
	            drawing.symbolNoDot = {};
	            drawing.symbolNoFill = {};
	            drawing.symbolList = [];
	            Object.keys(SYMBOLDEFS).forEach(function(k) {
	              var symDef = SYMBOLDEFS[k];
	              var n = symDef.n;
	              drawing.symbolList.push(n, String(n), k, n + 100, String(n + 100), k + "-open");
	              drawing.symbolNames[n] = k;
	              drawing.symbolFuncs[n] = symDef.f;
	              drawing.symbolBackOffs[n] = symDef.backoff || 0;
	              if (symDef.needLine) {
	                drawing.symbolNeedLines[n] = true;
	              }
	              if (symDef.noDot) {
	                drawing.symbolNoDot[n] = true;
	              } else {
	                drawing.symbolList.push(n + 200, String(n + 200), k + "-dot", n + 300, String(n + 300), k + "-open-dot");
	              }
	              if (symDef.noFill) {
	                drawing.symbolNoFill[n] = true;
	              }
	            });
	            var MAXSYMBOL = drawing.symbolNames.length;
	            var DOTPATH = "M0,0.5L0.5,0L0,-0.5L-0.5,0Z";
	            drawing.symbolNumber = function(v) {
	              if (isNumeric(v)) {
	                v = +v;
	              } else if (typeof v === "string") {
	                var vbase = 0;
	                if (v.indexOf("-open") > 0) {
	                  vbase = 100;
	                  v = v.replace("-open", "");
	                }
	                if (v.indexOf("-dot") > 0) {
	                  vbase += 200;
	                  v = v.replace("-dot", "");
	                }
	                v = drawing.symbolNames.indexOf(v);
	                if (v >= 0) {
	                  v += vbase;
	                }
	              }
	              return v % 100 >= MAXSYMBOL || v >= 400 ? 0 : Math.floor(Math.max(v, 0));
	            };
	            function makePointPath(symbolNumber, r, t, s) {
	              var base = symbolNumber % 100;
	              return drawing.symbolFuncs[base](r, t, s) + (symbolNumber >= 200 ? DOTPATH : "");
	            }
	            var HORZGRADIENT = {
	              x1: 1,
	              x2: 0,
	              y1: 0,
	              y2: 0
	            };
	            var VERTGRADIENT = {
	              x1: 0,
	              x2: 0,
	              y1: 1,
	              y2: 0
	            };
	            var stopFormatter = numberFormat("~f");
	            var gradientInfo = {
	              radial: {
	                node: "radialGradient"
	              },
	              radialreversed: {
	                node: "radialGradient",
	                reversed: true
	              },
	              horizontal: {
	                node: "linearGradient",
	                attrs: HORZGRADIENT
	              },
	              horizontalreversed: {
	                node: "linearGradient",
	                attrs: HORZGRADIENT,
	                reversed: true
	              },
	              vertical: {
	                node: "linearGradient",
	                attrs: VERTGRADIENT
	              },
	              verticalreversed: {
	                node: "linearGradient",
	                attrs: VERTGRADIENT,
	                reversed: true
	              }
	            };
	            drawing.gradient = function(sel, gd, gradientID, type, colorscale, prop) {
	              var len = colorscale.length;
	              var info = gradientInfo[type];
	              var colorStops = new Array(len);
	              for (var i = 0; i < len; i++) {
	                if (info.reversed) {
	                  colorStops[len - 1 - i] = [stopFormatter((1 - colorscale[i][0]) * 100), colorscale[i][1]];
	                } else {
	                  colorStops[i] = [stopFormatter(colorscale[i][0] * 100), colorscale[i][1]];
	                }
	              }
	              var fullLayout = gd._fullLayout;
	              var fullID = "g" + fullLayout._uid + "-" + gradientID;
	              var gradient = fullLayout._defs.select(".gradients").selectAll("#" + fullID).data([type + colorStops.join(";")], Lib.identity);
	              gradient.exit().remove();
	              gradient.enter().append(info.node).each(function() {
	                var el = d3.select(this);
	                if (info.attrs) el.attr(info.attrs);
	                el.attr("id", fullID);
	                var stops = el.selectAll("stop").data(colorStops);
	                stops.exit().remove();
	                stops.enter().append("stop");
	                stops.each(function(d) {
	                  var tc = tinycolor(d[1]);
	                  d3.select(this).attr({
	                    offset: d[0] + "%",
	                    "stop-color": Color.tinyRGB(tc),
	                    "stop-opacity": tc.getAlpha()
	                  });
	                });
	              });
	              sel.style(prop, getFullUrl(fullID, gd)).style(prop + "-opacity", null);
	              sel.classed("gradient_filled", true);
	            };
	            drawing.pattern = function(sel, calledBy, gd, patternID, shape, size, solidity, mcc, fillmode, bgcolor, fgcolor, fgopacity) {
	              var isLegend = calledBy === "legend";
	              if (mcc) {
	                if (fillmode === "overlay") {
	                  bgcolor = mcc;
	                  fgcolor = Color.contrast(bgcolor);
	                } else {
	                  bgcolor = undefined;
	                  fgcolor = mcc;
	                }
	              }
	              var fullLayout = gd._fullLayout;
	              var fullID = "p" + fullLayout._uid + "-" + patternID;
	              var width, height;
	              var linearFn = function(x, x0, x1, y0, y1) {
	                return y0 + (y1 - y0) * (x - x0) / (x1 - x0);
	              };
	              var path, linewidth, radius;
	              var patternTag;
	              var patternAttrs = {};
	              var fgC = tinycolor(fgcolor);
	              var fgRGB = Color.tinyRGB(fgC);
	              var fgAlpha = fgC.getAlpha();
	              var opacity = fgopacity * fgAlpha;
	              switch (shape) {
	                case "/":
	                  width = size * Math.sqrt(2);
	                  height = size * Math.sqrt(2);
	                  path = "M-" + width / 4 + "," + height / 4 + "l" + width / 2 + ",-" + height / 2 + "M0," + height + "L" + width + ",0M" + width / 4 * 3 + "," + height / 4 * 5 + "l" + width / 2 + ",-" + height / 2;
	                  linewidth = solidity * size;
	                  patternTag = "path";
	                  patternAttrs = {
	                    d: path,
	                    opacity,
	                    stroke: fgRGB,
	                    "stroke-width": linewidth + "px"
	                  };
	                  break;
	                case "\\":
	                  width = size * Math.sqrt(2);
	                  height = size * Math.sqrt(2);
	                  path = "M" + width / 4 * 3 + ",-" + height / 4 + "l" + width / 2 + "," + height / 2 + "M0,0L" + width + "," + height + "M-" + width / 4 + "," + height / 4 * 3 + "l" + width / 2 + "," + height / 2;
	                  linewidth = solidity * size;
	                  patternTag = "path";
	                  patternAttrs = {
	                    d: path,
	                    opacity,
	                    stroke: fgRGB,
	                    "stroke-width": linewidth + "px"
	                  };
	                  break;
	                case "x":
	                  width = size * Math.sqrt(2);
	                  height = size * Math.sqrt(2);
	                  path = "M-" + width / 4 + "," + height / 4 + "l" + width / 2 + ",-" + height / 2 + "M0," + height + "L" + width + ",0M" + width / 4 * 3 + "," + height / 4 * 5 + "l" + width / 2 + ",-" + height / 2 + "M" + width / 4 * 3 + ",-" + height / 4 + "l" + width / 2 + "," + height / 2 + "M0,0L" + width + "," + height + "M-" + width / 4 + "," + height / 4 * 3 + "l" + width / 2 + "," + height / 2;
	                  linewidth = size - size * Math.sqrt(1 - solidity);
	                  patternTag = "path";
	                  patternAttrs = {
	                    d: path,
	                    opacity,
	                    stroke: fgRGB,
	                    "stroke-width": linewidth + "px"
	                  };
	                  break;
	                case "|":
	                  width = size;
	                  height = size;
	                  patternTag = "path";
	                  path = "M" + width / 2 + ",0L" + width / 2 + "," + height;
	                  linewidth = solidity * size;
	                  patternTag = "path";
	                  patternAttrs = {
	                    d: path,
	                    opacity,
	                    stroke: fgRGB,
	                    "stroke-width": linewidth + "px"
	                  };
	                  break;
	                case "-":
	                  width = size;
	                  height = size;
	                  patternTag = "path";
	                  path = "M0," + height / 2 + "L" + width + "," + height / 2;
	                  linewidth = solidity * size;
	                  patternTag = "path";
	                  patternAttrs = {
	                    d: path,
	                    opacity,
	                    stroke: fgRGB,
	                    "stroke-width": linewidth + "px"
	                  };
	                  break;
	                case "+":
	                  width = size;
	                  height = size;
	                  patternTag = "path";
	                  path = "M" + width / 2 + ",0L" + width / 2 + "," + height + "M0," + height / 2 + "L" + width + "," + height / 2;
	                  linewidth = size - size * Math.sqrt(1 - solidity);
	                  patternTag = "path";
	                  patternAttrs = {
	                    d: path,
	                    opacity,
	                    stroke: fgRGB,
	                    "stroke-width": linewidth + "px"
	                  };
	                  break;
	                case ".":
	                  width = size;
	                  height = size;
	                  if (solidity < Math.PI / 4) {
	                    radius = Math.sqrt(solidity * size * size / Math.PI);
	                  } else {
	                    radius = linearFn(solidity, Math.PI / 4, 1, size / 2, size / Math.sqrt(2));
	                  }
	                  patternTag = "circle";
	                  patternAttrs = {
	                    cx: width / 2,
	                    cy: height / 2,
	                    r: radius,
	                    opacity,
	                    fill: fgRGB
	                  };
	                  break;
	              }
	              var str = [shape || "noSh", bgcolor || "noBg", fgcolor || "noFg", size, solidity].join(";");
	              var pattern = fullLayout._defs.select(".patterns").selectAll("#" + fullID).data([str], Lib.identity);
	              pattern.exit().remove();
	              pattern.enter().append("pattern").each(function() {
	                var el = d3.select(this);
	                el.attr({
	                  id: fullID,
	                  width: width + "px",
	                  height: height + "px",
	                  patternUnits: "userSpaceOnUse",
	                  // for legends scale down patterns just a bit so that default size (i.e 8) nicely fit in small icons
	                  patternTransform: isLegend ? "scale(0.8)" : ""
	                });
	                if (bgcolor) {
	                  var bgC = tinycolor(bgcolor);
	                  var bgRGB = Color.tinyRGB(bgC);
	                  var bgAlpha = bgC.getAlpha();
	                  var rects = el.selectAll("rect").data([0]);
	                  rects.exit().remove();
	                  rects.enter().append("rect").attr({
	                    width: width + "px",
	                    height: height + "px",
	                    fill: bgRGB,
	                    "fill-opacity": bgAlpha
	                  });
	                }
	                var patterns = el.selectAll(patternTag).data([0]);
	                patterns.exit().remove();
	                patterns.enter().append(patternTag).attr(patternAttrs);
	              });
	              sel.style("fill", getFullUrl(fullID, gd)).style("fill-opacity", null);
	              sel.classed("pattern_filled", true);
	            };
	            drawing.initGradients = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var gradientsGroup = Lib.ensureSingle(fullLayout._defs, "g", "gradients");
	              gradientsGroup.selectAll("linearGradient,radialGradient").remove();
	              d3.select(gd).selectAll(".gradient_filled").classed("gradient_filled", false);
	            };
	            drawing.initPatterns = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var patternsGroup = Lib.ensureSingle(fullLayout._defs, "g", "patterns");
	              patternsGroup.selectAll("pattern").remove();
	              d3.select(gd).selectAll(".pattern_filled").classed("pattern_filled", false);
	            };
	            drawing.getPatternAttr = function(mp, i, dflt) {
	              if (mp && Lib.isArrayOrTypedArray(mp)) {
	                return i < mp.length ? mp[i] : dflt;
	              }
	              return mp;
	            };
	            drawing.pointStyle = function(s, trace, gd, pt) {
	              if (!s.size()) return;
	              var fns = drawing.makePointStyleFns(trace);
	              s.each(function(d) {
	                drawing.singlePointStyle(d, d3.select(this), trace, fns, gd, pt);
	              });
	            };
	            drawing.singlePointStyle = function(d, sel, trace, fns, gd, pt) {
	              var marker = trace.marker;
	              var markerLine = marker.line;
	              if (pt && pt.i >= 0 && d.i === undefined) d.i = pt.i;
	              sel.style("opacity", fns.selectedOpacityFn ? fns.selectedOpacityFn(d) : d.mo === undefined ? marker.opacity : d.mo);
	              if (fns.ms2mrc) {
	                var r;
	                if (d.ms === "various" || marker.size === "various") {
	                  r = 3;
	                } else {
	                  r = fns.ms2mrc(d.ms);
	                }
	                d.mrc = r;
	                if (fns.selectedSizeFn) {
	                  r = d.mrc = fns.selectedSizeFn(d);
	                }
	                var x = drawing.symbolNumber(d.mx || marker.symbol) || 0;
	                d.om = x % 200 >= 100;
	                var angle = getMarkerAngle(d, trace);
	                var standoff = getMarkerStandoff(d, trace);
	                sel.attr("d", makePointPath(x, r, angle, standoff));
	              }
	              var perPointGradient = false;
	              var fillColor, lineColor, lineWidth;
	              if (d.so) {
	                lineWidth = markerLine.outlierwidth;
	                lineColor = markerLine.outliercolor;
	                fillColor = marker.outliercolor;
	              } else {
	                var markerLineWidth = (markerLine || {}).width;
	                lineWidth = (d.mlw + 1 || markerLineWidth + 1 || // TODO: we need the latter for legends... can we get rid of it?
	                (d.trace ? (d.trace.marker.line || {}).width : 0) + 1) - 1 || 0;
	                if ("mlc" in d) lineColor = d.mlcc = fns.lineScale(d.mlc);
	                else if (Lib.isArrayOrTypedArray(markerLine.color)) lineColor = Color.defaultLine;
	                else lineColor = markerLine.color;
	                if (Lib.isArrayOrTypedArray(marker.color)) {
	                  fillColor = Color.defaultLine;
	                  perPointGradient = true;
	                }
	                if ("mc" in d) {
	                  fillColor = d.mcc = fns.markerScale(d.mc);
	                } else {
	                  fillColor = marker.color || marker.colors || "rgba(0,0,0,0)";
	                }
	                if (fns.selectedColorFn) {
	                  fillColor = fns.selectedColorFn(d);
	                }
	              }
	              if (d.om) {
	                sel.call(Color.stroke, fillColor).style({
	                  "stroke-width": (lineWidth || 1) + "px",
	                  fill: "none"
	                });
	              } else {
	                sel.style("stroke-width", (d.isBlank ? 0 : lineWidth) + "px");
	                var markerGradient = marker.gradient;
	                var gradientType = d.mgt;
	                if (gradientType) perPointGradient = true;
	                else gradientType = markerGradient && markerGradient.type;
	                if (Lib.isArrayOrTypedArray(gradientType)) {
	                  gradientType = gradientType[0];
	                  if (!gradientInfo[gradientType]) gradientType = 0;
	                }
	                var markerPattern = marker.pattern;
	                var patternShape = markerPattern && drawing.getPatternAttr(markerPattern.shape, d.i, "");
	                if (gradientType && gradientType !== "none") {
	                  var gradientColor = d.mgc;
	                  if (gradientColor) perPointGradient = true;
	                  else gradientColor = markerGradient.color;
	                  var gradientID = trace.uid;
	                  if (perPointGradient) gradientID += "-" + d.i;
	                  drawing.gradient(sel, gd, gradientID, gradientType, [[0, gradientColor], [1, fillColor]], "fill");
	                } else if (patternShape) {
	                  var perPointPattern = false;
	                  var fgcolor = markerPattern.fgcolor;
	                  if (!fgcolor && pt && pt.color) {
	                    fgcolor = pt.color;
	                    perPointPattern = true;
	                  }
	                  var patternFGColor = drawing.getPatternAttr(fgcolor, d.i, pt && pt.color || null);
	                  var patternBGColor = drawing.getPatternAttr(markerPattern.bgcolor, d.i, null);
	                  var patternFGOpacity = markerPattern.fgopacity;
	                  var patternSize = drawing.getPatternAttr(markerPattern.size, d.i, 8);
	                  var patternSolidity = drawing.getPatternAttr(markerPattern.solidity, d.i, 0.3);
	                  perPointPattern = perPointPattern || d.mcc || Lib.isArrayOrTypedArray(markerPattern.shape) || Lib.isArrayOrTypedArray(markerPattern.bgcolor) || Lib.isArrayOrTypedArray(markerPattern.fgcolor) || Lib.isArrayOrTypedArray(markerPattern.size) || Lib.isArrayOrTypedArray(markerPattern.solidity);
	                  var patternID = trace.uid;
	                  if (perPointPattern) patternID += "-" + d.i;
	                  drawing.pattern(sel, "point", gd, patternID, patternShape, patternSize, patternSolidity, d.mcc, markerPattern.fillmode, patternBGColor, patternFGColor, patternFGOpacity);
	                } else {
	                  Lib.isArrayOrTypedArray(fillColor) ? Color.fill(sel, fillColor[d.i]) : Color.fill(sel, fillColor);
	                }
	                if (lineWidth) {
	                  Color.stroke(sel, lineColor);
	                }
	              }
	            };
	            drawing.makePointStyleFns = function(trace) {
	              var out = {};
	              var marker = trace.marker;
	              out.markerScale = drawing.tryColorscale(marker, "");
	              out.lineScale = drawing.tryColorscale(marker, "line");
	              if (Registry.traceIs(trace, "symbols")) {
	                out.ms2mrc = subTypes.isBubble(trace) ? makeBubbleSizeFn(trace) : function() {
	                  return (marker.size || 6) / 2;
	                };
	              }
	              if (trace.selectedpoints) {
	                Lib.extendFlat(out, drawing.makeSelectedPointStyleFns(trace));
	              }
	              return out;
	            };
	            drawing.makeSelectedPointStyleFns = function(trace) {
	              var out = {};
	              var selectedAttrs = trace.selected || {};
	              var unselectedAttrs = trace.unselected || {};
	              var marker = trace.marker || {};
	              var selectedMarker = selectedAttrs.marker || {};
	              var unselectedMarker = unselectedAttrs.marker || {};
	              var mo = marker.opacity;
	              var smo = selectedMarker.opacity;
	              var usmo = unselectedMarker.opacity;
	              var smoIsDefined = smo !== undefined;
	              var usmoIsDefined = usmo !== undefined;
	              if (Lib.isArrayOrTypedArray(mo) || smoIsDefined || usmoIsDefined) {
	                out.selectedOpacityFn = function(d) {
	                  var base = d.mo === undefined ? marker.opacity : d.mo;
	                  if (d.selected) {
	                    return smoIsDefined ? smo : base;
	                  } else {
	                    return usmoIsDefined ? usmo : DESELECTDIM * base;
	                  }
	                };
	              }
	              var mc = marker.color;
	              var smc = selectedMarker.color;
	              var usmc = unselectedMarker.color;
	              if (smc || usmc) {
	                out.selectedColorFn = function(d) {
	                  var base = d.mcc || mc;
	                  if (d.selected) {
	                    return smc || base;
	                  } else {
	                    return usmc || base;
	                  }
	                };
	              }
	              var ms = marker.size;
	              var sms = selectedMarker.size;
	              var usms = unselectedMarker.size;
	              var smsIsDefined = sms !== undefined;
	              var usmsIsDefined = usms !== undefined;
	              if (Registry.traceIs(trace, "symbols") && (smsIsDefined || usmsIsDefined)) {
	                out.selectedSizeFn = function(d) {
	                  var base = d.mrc || ms / 2;
	                  if (d.selected) {
	                    return smsIsDefined ? sms / 2 : base;
	                  } else {
	                    return usmsIsDefined ? usms / 2 : base;
	                  }
	                };
	              }
	              return out;
	            };
	            drawing.makeSelectedTextStyleFns = function(trace) {
	              var out = {};
	              var selectedAttrs = trace.selected || {};
	              var unselectedAttrs = trace.unselected || {};
	              var textFont = trace.textfont || {};
	              var selectedTextFont = selectedAttrs.textfont || {};
	              var unselectedTextFont = unselectedAttrs.textfont || {};
	              var tc = textFont.color;
	              var stc = selectedTextFont.color;
	              var utc = unselectedTextFont.color;
	              out.selectedTextColorFn = function(d) {
	                var base = d.tc || tc;
	                if (d.selected) {
	                  return stc || base;
	                } else {
	                  if (utc) return utc;
	                  else return stc ? base : Color.addOpacity(base, DESELECTDIM);
	                }
	              };
	              return out;
	            };
	            drawing.selectedPointStyle = function(s, trace) {
	              if (!s.size() || !trace.selectedpoints) return;
	              var fns = drawing.makeSelectedPointStyleFns(trace);
	              var marker = trace.marker || {};
	              var seq = [];
	              if (fns.selectedOpacityFn) {
	                seq.push(function(pt, d) {
	                  pt.style("opacity", fns.selectedOpacityFn(d));
	                });
	              }
	              if (fns.selectedColorFn) {
	                seq.push(function(pt, d) {
	                  Color.fill(pt, fns.selectedColorFn(d));
	                });
	              }
	              if (fns.selectedSizeFn) {
	                seq.push(function(pt, d) {
	                  var mx = d.mx || marker.symbol || 0;
	                  var mrc2 = fns.selectedSizeFn(d);
	                  pt.attr("d", makePointPath(drawing.symbolNumber(mx), mrc2, getMarkerAngle(d, trace), getMarkerStandoff(d, trace)));
	                  d.mrc2 = mrc2;
	                });
	              }
	              if (seq.length) {
	                s.each(function(d) {
	                  var pt = d3.select(this);
	                  for (var i = 0; i < seq.length; i++) {
	                    seq[i](pt, d);
	                  }
	                });
	              }
	            };
	            drawing.tryColorscale = function(marker, prefix) {
	              var cont = prefix ? Lib.nestedProperty(marker, prefix).get() : marker;
	              if (cont) {
	                var colorArray = cont.color;
	                if ((cont.colorscale || cont._colorAx) && Lib.isArrayOrTypedArray(colorArray)) {
	                  return Colorscale.makeColorScaleFuncFromTrace(cont);
	                }
	              }
	              return Lib.identity;
	            };
	            var TEXTOFFSETSIGN = {
	              start: 1,
	              end: -1,
	              middle: 0,
	              bottom: 1,
	              top: -1
	            };
	            function textPointPosition(s, textPosition, fontSize, markerRadius, dontTouchParent) {
	              var group = d3.select(s.node().parentNode);
	              var v = textPosition.indexOf("top") !== -1 ? "top" : textPosition.indexOf("bottom") !== -1 ? "bottom" : "middle";
	              var h = textPosition.indexOf("left") !== -1 ? "end" : textPosition.indexOf("right") !== -1 ? "start" : "middle";
	              var r = markerRadius ? markerRadius / 0.8 + 1 : 0;
	              var numLines = (svgTextUtils.lineCount(s) - 1) * LINE_SPACING + 1;
	              var dx = TEXTOFFSETSIGN[h] * r;
	              var dy = fontSize * 0.75 + TEXTOFFSETSIGN[v] * r + (TEXTOFFSETSIGN[v] - 1) * numLines * fontSize / 2;
	              s.attr("text-anchor", h);
	              if (!dontTouchParent) {
	                group.attr("transform", strTranslate(dx, dy));
	              }
	            }
	            function extracTextFontSize(d, trace) {
	              var fontSize = d.ts || trace.textfont.size;
	              return isNumeric(fontSize) && fontSize > 0 ? fontSize : 0;
	            }
	            drawing.textPointStyle = function(s, trace, gd) {
	              if (!s.size()) return;
	              var selectedTextColorFn;
	              if (trace.selectedpoints) {
	                var fns = drawing.makeSelectedTextStyleFns(trace);
	                selectedTextColorFn = fns.selectedTextColorFn;
	              }
	              var texttemplate = trace.texttemplate;
	              var fullLayout = gd._fullLayout;
	              s.each(function(d) {
	                var p = d3.select(this);
	                var text = texttemplate ? Lib.extractOption(d, trace, "txt", "texttemplate") : Lib.extractOption(d, trace, "tx", "text");
	                if (!text && text !== 0) {
	                  p.remove();
	                  return;
	                }
	                if (texttemplate) {
	                  var fn = trace._module.formatLabels;
	                  var labels = fn ? fn(d, trace, fullLayout) : {};
	                  var pointValues = {};
	                  appendArrayPointValue(pointValues, trace, d.i);
	                  var meta = trace._meta || {};
	                  text = Lib.texttemplateString(text, labels, fullLayout._d3locale, pointValues, d, meta);
	                }
	                var pos = d.tp || trace.textposition;
	                var fontSize = extracTextFontSize(d, trace);
	                var fontColor = selectedTextColorFn ? selectedTextColorFn(d) : d.tc || trace.textfont.color;
	                p.call(drawing.font, d.tf || trace.textfont.family, fontSize, fontColor).text(text).call(svgTextUtils.convertToTspans, gd).call(textPointPosition, pos, fontSize, d.mrc);
	              });
	            };
	            drawing.selectedTextStyle = function(s, trace) {
	              if (!s.size() || !trace.selectedpoints) return;
	              var fns = drawing.makeSelectedTextStyleFns(trace);
	              s.each(function(d) {
	                var tx = d3.select(this);
	                var tc = fns.selectedTextColorFn(d);
	                var tp = d.tp || trace.textposition;
	                var fontSize = extracTextFontSize(d, trace);
	                Color.fill(tx, tc);
	                var dontTouchParent = Registry.traceIs(trace, "bar-like");
	                textPointPosition(tx, tp, fontSize, d.mrc2 || d.mrc, dontTouchParent);
	              });
	            };
	            var CatmullRomExp = 0.5;
	            drawing.smoothopen = function(pts, smoothness) {
	              if (pts.length < 3) {
	                return "M" + pts.join("L");
	              }
	              var path = "M" + pts[0];
	              var tangents = [];
	              var i;
	              for (i = 1; i < pts.length - 1; i++) {
	                tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
	              }
	              path += "Q" + tangents[0][0] + " " + pts[1];
	              for (i = 2; i < pts.length - 1; i++) {
	                path += "C" + tangents[i - 2][1] + " " + tangents[i - 1][0] + " " + pts[i];
	              }
	              path += "Q" + tangents[pts.length - 3][1] + " " + pts[pts.length - 1];
	              return path;
	            };
	            drawing.smoothclosed = function(pts, smoothness) {
	              if (pts.length < 3) {
	                return "M" + pts.join("L") + "Z";
	              }
	              var path = "M" + pts[0];
	              var pLast = pts.length - 1;
	              var tangents = [makeTangent(pts[pLast], pts[0], pts[1], smoothness)];
	              var i;
	              for (i = 1; i < pLast; i++) {
	                tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
	              }
	              tangents.push(makeTangent(pts[pLast - 1], pts[pLast], pts[0], smoothness));
	              for (i = 1; i <= pLast; i++) {
	                path += "C" + tangents[i - 1][1] + " " + tangents[i][0] + " " + pts[i];
	              }
	              path += "C" + tangents[pLast][1] + " " + tangents[0][0] + " " + pts[0] + "Z";
	              return path;
	            };
	            var lastDrawnX, lastDrawnY;
	            function roundEnd(pt, isY, isLastPoint) {
	              if (isLastPoint) pt = applyBackoff(pt);
	              return isY ? roundY(pt[1]) : roundX(pt[0]);
	            }
	            function roundX(p) {
	              var v = d3.round(p, 2);
	              lastDrawnX = v;
	              return v;
	            }
	            function roundY(p) {
	              var v = d3.round(p, 2);
	              lastDrawnY = v;
	              return v;
	            }
	            function makeTangent(prevpt, thispt, nextpt, smoothness) {
	              var d1x = prevpt[0] - thispt[0];
	              var d1y = prevpt[1] - thispt[1];
	              var d2x = nextpt[0] - thispt[0];
	              var d2y = nextpt[1] - thispt[1];
	              var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
	              var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
	              var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
	              var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
	              var denom1 = 3 * d2a * (d1a + d2a);
	              var denom2 = 3 * d1a * (d1a + d2a);
	              return [[roundX(thispt[0] + (denom1 && numx / denom1)), roundY(thispt[1] + (denom1 && numy / denom1))], [roundX(thispt[0] - (denom2 && numx / denom2)), roundY(thispt[1] - (denom2 && numy / denom2))]];
	            }
	            var STEPPATH = {
	              hv: function(p0, p1, isLastPoint) {
	                return "H" + roundX(p1[0]) + "V" + roundEnd(p1, 1, isLastPoint);
	              },
	              vh: function(p0, p1, isLastPoint) {
	                return "V" + roundY(p1[1]) + "H" + roundEnd(p1, 0, isLastPoint);
	              },
	              hvh: function(p0, p1, isLastPoint) {
	                return "H" + roundX((p0[0] + p1[0]) / 2) + "V" + roundY(p1[1]) + "H" + roundEnd(p1, 0, isLastPoint);
	              },
	              vhv: function(p0, p1, isLastPoint) {
	                return "V" + roundY((p0[1] + p1[1]) / 2) + "H" + roundX(p1[0]) + "V" + roundEnd(p1, 1, isLastPoint);
	              }
	            };
	            var STEPLINEAR = function(p0, p1, isLastPoint) {
	              return "L" + roundEnd(p1, 0, isLastPoint) + "," + roundEnd(p1, 1, isLastPoint);
	            };
	            drawing.steps = function(shape) {
	              var onestep = STEPPATH[shape] || STEPLINEAR;
	              return function(pts) {
	                var path = "M" + roundX(pts[0][0]) + "," + roundY(pts[0][1]);
	                var len = pts.length;
	                for (var i = 1; i < len; i++) {
	                  path += onestep(pts[i - 1], pts[i], i === len - 1);
	                }
	                return path;
	              };
	            };
	            function applyBackoff(pt, start) {
	              var backoff = pt.backoff;
	              var trace = pt.trace;
	              var d = pt.d;
	              var i = pt.i;
	              if (backoff && trace && trace.marker && trace.marker.angle % 360 === 0 && trace.line && trace.line.shape !== "spline") {
	                var arrayBackoff = Lib.isArrayOrTypedArray(backoff);
	                var end = pt;
	                var x1 = start ? start[0] : lastDrawnX || 0;
	                var y1 = start ? start[1] : lastDrawnY || 0;
	                var x2 = end[0];
	                var y2 = end[1];
	                var dx = x2 - x1;
	                var dy = y2 - y1;
	                var t = Math.atan2(dy, dx);
	                var b = arrayBackoff ? backoff[i] : backoff;
	                if (b === "auto") {
	                  var endI = end.i;
	                  if (trace.type === "scatter") endI--;
	                  var endMarker = end.marker;
	                  var endMarkerSymbol = endMarker.symbol;
	                  if (Lib.isArrayOrTypedArray(endMarkerSymbol)) endMarkerSymbol = endMarkerSymbol[endI];
	                  var endMarkerSize = endMarker.size;
	                  if (Lib.isArrayOrTypedArray(endMarkerSize)) endMarkerSize = endMarkerSize[endI];
	                  b = endMarker ? drawing.symbolBackOffs[drawing.symbolNumber(endMarkerSymbol)] * endMarkerSize : 0;
	                  b += drawing.getMarkerStandoff(d[endI], trace) || 0;
	                }
	                var x = x2 - b * Math.cos(t);
	                var y = y2 - b * Math.sin(t);
	                if ((x <= x2 && x >= x1 || x >= x2 && x <= x1) && (y <= y2 && y >= y1 || y >= y2 && y <= y1)) {
	                  pt = [x, y];
	                }
	              }
	              return pt;
	            }
	            drawing.applyBackoff = applyBackoff;
	            drawing.makeTester = function() {
	              var tester = Lib.ensureSingleById(d3.select("body"), "svg", "js-plotly-tester", function(s) {
	                s.attr(xmlnsNamespaces.svgAttrs).style({
	                  position: "absolute",
	                  left: "-10000px",
	                  top: "-10000px",
	                  width: "9000px",
	                  height: "9000px",
	                  "z-index": "1"
	                });
	              });
	              var testref = Lib.ensureSingle(tester, "path", "js-reference-point", function(s) {
	                s.attr("d", "M0,0H1V1H0Z").style({
	                  "stroke-width": 0,
	                  fill: "black"
	                });
	              });
	              drawing.tester = tester;
	              drawing.testref = testref;
	            };
	            drawing.savedBBoxes = {};
	            var savedBBoxesCount = 0;
	            var maxSavedBBoxes = 1e4;
	            drawing.bBox = function(node, inTester, hash) {
	              if (!hash) hash = nodeHash(node);
	              var out;
	              if (hash) {
	                out = drawing.savedBBoxes[hash];
	                if (out) return Lib.extendFlat({}, out);
	              } else if (node.childNodes.length === 1) {
	                var innerNode = node.childNodes[0];
	                hash = nodeHash(innerNode);
	                if (hash) {
	                  var x = +innerNode.getAttribute("x") || 0;
	                  var y = +innerNode.getAttribute("y") || 0;
	                  var transform = innerNode.getAttribute("transform");
	                  if (!transform) {
	                    var innerBB = drawing.bBox(innerNode, false, hash);
	                    if (x) {
	                      innerBB.left += x;
	                      innerBB.right += x;
	                    }
	                    if (y) {
	                      innerBB.top += y;
	                      innerBB.bottom += y;
	                    }
	                    return innerBB;
	                  }
	                  hash += "~" + x + "~" + y + "~" + transform;
	                  out = drawing.savedBBoxes[hash];
	                  if (out) return Lib.extendFlat({}, out);
	                }
	              }
	              var testNode, tester;
	              if (inTester) {
	                testNode = node;
	              } else {
	                tester = drawing.tester.node();
	                testNode = node.cloneNode(true);
	                tester.appendChild(testNode);
	              }
	              d3.select(testNode).attr("transform", null).call(svgTextUtils.positionText, 0, 0);
	              var testRect = testNode.getBoundingClientRect();
	              var refRect = drawing.testref.node().getBoundingClientRect();
	              if (!inTester) tester.removeChild(testNode);
	              var bb = {
	                height: testRect.height,
	                width: testRect.width,
	                left: testRect.left - refRect.left,
	                top: testRect.top - refRect.top,
	                right: testRect.right - refRect.left,
	                bottom: testRect.bottom - refRect.top
	              };
	              if (savedBBoxesCount >= maxSavedBBoxes) {
	                drawing.savedBBoxes = {};
	                savedBBoxesCount = 0;
	              }
	              if (hash) drawing.savedBBoxes[hash] = bb;
	              savedBBoxesCount++;
	              return Lib.extendFlat({}, bb);
	            };
	            function nodeHash(node) {
	              var inputText = node.getAttribute("data-unformatted");
	              if (inputText === null) return;
	              return inputText + node.getAttribute("data-math") + node.getAttribute("text-anchor") + node.getAttribute("style");
	            }
	            drawing.setClipUrl = function(s, localId, gd) {
	              s.attr("clip-path", getFullUrl(localId, gd));
	            };
	            function getFullUrl(localId, gd) {
	              if (!localId) return null;
	              var context = gd._context;
	              var baseUrl = context._exportedPlot ? "" : context._baseUrl || "";
	              return baseUrl ? "url('" + baseUrl + "#" + localId + "')" : "url(#" + localId + ")";
	            }
	            drawing.getTranslate = function(element) {
	              var re = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/;
	              var getter = element.attr ? "attr" : "getAttribute";
	              var transform = element[getter]("transform") || "";
	              var translate = transform.replace(re, function(match, p1, p2) {
	                return [p1, p2].join(" ");
	              }).split(" ");
	              return {
	                x: +translate[0] || 0,
	                y: +translate[1] || 0
	              };
	            };
	            drawing.setTranslate = function(element, x, y) {
	              var re = /(\btranslate\(.*?\);?)/;
	              var getter = element.attr ? "attr" : "getAttribute";
	              var setter = element.attr ? "attr" : "setAttribute";
	              var transform = element[getter]("transform") || "";
	              x = x || 0;
	              y = y || 0;
	              transform = transform.replace(re, "").trim();
	              transform += strTranslate(x, y);
	              transform = transform.trim();
	              element[setter]("transform", transform);
	              return transform;
	            };
	            drawing.getScale = function(element) {
	              var re = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/;
	              var getter = element.attr ? "attr" : "getAttribute";
	              var transform = element[getter]("transform") || "";
	              var translate = transform.replace(re, function(match, p1, p2) {
	                return [p1, p2].join(" ");
	              }).split(" ");
	              return {
	                x: +translate[0] || 1,
	                y: +translate[1] || 1
	              };
	            };
	            drawing.setScale = function(element, x, y) {
	              var re = /(\bscale\(.*?\);?)/;
	              var getter = element.attr ? "attr" : "getAttribute";
	              var setter = element.attr ? "attr" : "setAttribute";
	              var transform = element[getter]("transform") || "";
	              x = x || 1;
	              y = y || 1;
	              transform = transform.replace(re, "").trim();
	              transform += "scale(" + x + "," + y + ")";
	              transform = transform.trim();
	              element[setter]("transform", transform);
	              return transform;
	            };
	            var SCALE_RE = /\s*sc.*/;
	            drawing.setPointGroupScale = function(selection, xScale, yScale) {
	              xScale = xScale || 1;
	              yScale = yScale || 1;
	              if (!selection) return;
	              var scale = xScale === 1 && yScale === 1 ? "" : "scale(" + xScale + "," + yScale + ")";
	              selection.each(function() {
	                var t = (this.getAttribute("transform") || "").replace(SCALE_RE, "");
	                t += scale;
	                t = t.trim();
	                this.setAttribute("transform", t);
	              });
	            };
	            var TEXT_POINT_LAST_TRANSLATION_RE = /translate\([^)]*\)\s*$/;
	            drawing.setTextPointsScale = function(selection, xScale, yScale) {
	              if (!selection) return;
	              selection.each(function() {
	                var transforms;
	                var el = d3.select(this);
	                var text = el.select("text");
	                if (!text.node()) return;
	                var x = parseFloat(text.attr("x") || 0);
	                var y = parseFloat(text.attr("y") || 0);
	                var existingTransform = (el.attr("transform") || "").match(TEXT_POINT_LAST_TRANSLATION_RE);
	                if (xScale === 1 && yScale === 1) {
	                  transforms = [];
	                } else {
	                  transforms = [strTranslate(x, y), "scale(" + xScale + "," + yScale + ")", strTranslate(-x, -y)];
	                }
	                if (existingTransform) {
	                  transforms.push(existingTransform);
	                }
	                el.attr("transform", transforms.join(""));
	              });
	            };
	            function getMarkerStandoff(d, trace) {
	              var standoff;
	              if (d) standoff = d.mf;
	              if (standoff === undefined) {
	                standoff = trace.marker ? trace.marker.standoff || 0 : 0;
	              }
	              if (!trace._geo && !trace._xA) {
	                return -standoff;
	              }
	              return standoff;
	            }
	            drawing.getMarkerStandoff = getMarkerStandoff;
	            var atan2 = Math.atan2;
	            var cos = Math.cos;
	            var sin = Math.sin;
	            function rotate(t, xy) {
	              var x = xy[0];
	              var y = xy[1];
	              return [x * cos(t) - y * sin(t), x * sin(t) + y * cos(t)];
	            }
	            var previousLon;
	            var previousLat;
	            var previousX;
	            var previousY;
	            var previousI;
	            var previousTraceUid;
	            function getMarkerAngle(d, trace) {
	              var angle = d.ma;
	              if (angle === undefined) {
	                angle = trace.marker.angle || 0;
	              }
	              var x, y;
	              var ref = trace.marker.angleref;
	              if (ref === "previous" || ref === "north") {
	                if (trace._geo) {
	                  var p = trace._geo.project(d.lonlat);
	                  x = p[0];
	                  y = p[1];
	                } else {
	                  var xa = trace._xA;
	                  var ya = trace._yA;
	                  if (xa && ya) {
	                    x = xa.c2p(d.x);
	                    y = ya.c2p(d.y);
	                  } else {
	                    return 90;
	                  }
	                }
	                if (trace._geo) {
	                  var lon = d.lonlat[0];
	                  var lat = d.lonlat[1];
	                  var north = trace._geo.project([
	                    lon,
	                    lat + 1e-5
	                    // epsilon
	                  ]);
	                  var east = trace._geo.project([
	                    lon + 1e-5,
	                    // epsilon
	                    lat
	                  ]);
	                  var u = atan2(east[1] - y, east[0] - x);
	                  var v = atan2(north[1] - y, north[0] - x);
	                  var t;
	                  if (ref === "north") {
	                    t = angle / 180 * Math.PI;
	                  } else if (ref === "previous") {
	                    var lon1 = lon / 180 * Math.PI;
	                    var lat1 = lat / 180 * Math.PI;
	                    var lon2 = previousLon / 180 * Math.PI;
	                    var lat2 = previousLat / 180 * Math.PI;
	                    var dLon = lon2 - lon1;
	                    var deltaY = cos(lat2) * sin(dLon);
	                    var deltaX = sin(lat2) * cos(lat1) - cos(lat2) * sin(lat1) * cos(dLon);
	                    t = -atan2(deltaY, deltaX) - Math.PI;
	                    previousLon = lon;
	                    previousLat = lat;
	                  }
	                  var A = rotate(u, [cos(t), 0]);
	                  var B = rotate(v, [sin(t), 0]);
	                  angle = atan2(A[1] + B[1], A[0] + B[0]) / Math.PI * 180;
	                  if (ref === "previous" && !(previousTraceUid === trace.uid && d.i === previousI + 1)) {
	                    angle = null;
	                  }
	                }
	                if (ref === "previous" && !trace._geo) {
	                  if (previousTraceUid === trace.uid && d.i === previousI + 1 && isNumeric(x) && isNumeric(y)) {
	                    var dX = x - previousX;
	                    var dY = y - previousY;
	                    var shape = trace.line ? trace.line.shape || "" : "";
	                    var lastShapeChar = shape.slice(shape.length - 1);
	                    if (lastShapeChar === "h") dY = 0;
	                    if (lastShapeChar === "v") dX = 0;
	                    angle += atan2(dY, dX) / Math.PI * 180 + 90;
	                  } else {
	                    angle = null;
	                  }
	                }
	              }
	              previousX = x;
	              previousY = y;
	              previousI = d.i;
	              previousTraceUid = trace.uid;
	              return angle;
	            }
	            drawing.getMarkerAngle = getMarkerAngle;
	          }
	        ),
	        /***/
	        90998: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parseSvgPath = __webpack_require__2(95616);
	            var round = __webpack_require__2(39898).round;
	            var emptyPath = "M0,0Z";
	            var sqrt2 = Math.sqrt(2);
	            var sqrt3 = Math.sqrt(3);
	            var PI = Math.PI;
	            var cos = Math.cos;
	            var sin = Math.sin;
	            module2.exports = {
	              circle: {
	                n: 0,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  var circle = "M" + rs + ",0A" + rs + "," + rs + " 0 1,1 0,-" + rs + "A" + rs + "," + rs + " 0 0,1 " + rs + ",0Z";
	                  return standoff ? align(angle, standoff, circle) : circle;
	                }
	              },
	              square: {
	                n: 1,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M" + rs + "," + rs + "H-" + rs + "V-" + rs + "H" + rs + "Z");
	                }
	              },
	              diamond: {
	                n: 2,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rd = round(r * 1.3, 2);
	                  return align(angle, standoff, "M" + rd + ",0L0," + rd + "L-" + rd + ",0L0,-" + rd + "Z");
	                }
	              },
	              cross: {
	                n: 3,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rc = round(r * 0.4, 2);
	                  var rc2 = round(r * 1.2, 2);
	                  return align(angle, standoff, "M" + rc2 + "," + rc + "H" + rc + "V" + rc2 + "H-" + rc + "V" + rc + "H-" + rc2 + "V-" + rc + "H-" + rc + "V-" + rc2 + "H" + rc + "V-" + rc + "H" + rc2 + "Z");
	                }
	              },
	              x: {
	                n: 4,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r * 0.8 / sqrt2, 2);
	                  var ne = "l" + rx + "," + rx;
	                  var se = "l" + rx + ",-" + rx;
	                  var sw = "l-" + rx + ",-" + rx;
	                  var nw = "l-" + rx + "," + rx;
	                  return align(angle, standoff, "M0," + rx + ne + se + sw + se + sw + nw + sw + nw + ne + nw + ne + "Z");
	                }
	              },
	              "triangle-up": {
	                n: 5,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rt = round(r * 2 / sqrt3, 2);
	                  var r2 = round(r / 2, 2);
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M-" + rt + "," + r2 + "H" + rt + "L0,-" + rs + "Z");
	                }
	              },
	              "triangle-down": {
	                n: 6,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rt = round(r * 2 / sqrt3, 2);
	                  var r2 = round(r / 2, 2);
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M-" + rt + ",-" + r2 + "H" + rt + "L0," + rs + "Z");
	                }
	              },
	              "triangle-left": {
	                n: 7,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rt = round(r * 2 / sqrt3, 2);
	                  var r2 = round(r / 2, 2);
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M" + r2 + ",-" + rt + "V" + rt + "L-" + rs + ",0Z");
	                }
	              },
	              "triangle-right": {
	                n: 8,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rt = round(r * 2 / sqrt3, 2);
	                  var r2 = round(r / 2, 2);
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M-" + r2 + ",-" + rt + "V" + rt + "L" + rs + ",0Z");
	                }
	              },
	              "triangle-ne": {
	                n: 9,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var r1 = round(r * 0.6, 2);
	                  var r2 = round(r * 1.2, 2);
	                  return align(angle, standoff, "M-" + r2 + ",-" + r1 + "H" + r1 + "V" + r2 + "Z");
	                }
	              },
	              "triangle-se": {
	                n: 10,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var r1 = round(r * 0.6, 2);
	                  var r2 = round(r * 1.2, 2);
	                  return align(angle, standoff, "M" + r1 + ",-" + r2 + "V" + r1 + "H-" + r2 + "Z");
	                }
	              },
	              "triangle-sw": {
	                n: 11,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var r1 = round(r * 0.6, 2);
	                  var r2 = round(r * 1.2, 2);
	                  return align(angle, standoff, "M" + r2 + "," + r1 + "H-" + r1 + "V-" + r2 + "Z");
	                }
	              },
	              "triangle-nw": {
	                n: 12,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var r1 = round(r * 0.6, 2);
	                  var r2 = round(r * 1.2, 2);
	                  return align(angle, standoff, "M-" + r1 + "," + r2 + "V-" + r1 + "H" + r2 + "Z");
	                }
	              },
	              pentagon: {
	                n: 13,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x1 = round(r * 0.951, 2);
	                  var x2 = round(r * 0.588, 2);
	                  var y0 = round(-r, 2);
	                  var y1 = round(r * -0.309, 2);
	                  var y2 = round(r * 0.809, 2);
	                  return align(angle, standoff, "M" + x1 + "," + y1 + "L" + x2 + "," + y2 + "H-" + x2 + "L-" + x1 + "," + y1 + "L0," + y0 + "Z");
	                }
	              },
	              hexagon: {
	                n: 14,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var y0 = round(r, 2);
	                  var y1 = round(r / 2, 2);
	                  var x = round(r * sqrt3 / 2, 2);
	                  return align(angle, standoff, "M" + x + ",-" + y1 + "V" + y1 + "L0," + y0 + "L-" + x + "," + y1 + "V-" + y1 + "L0,-" + y0 + "Z");
	                }
	              },
	              hexagon2: {
	                n: 15,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x0 = round(r, 2);
	                  var x1 = round(r / 2, 2);
	                  var y = round(r * sqrt3 / 2, 2);
	                  return align(angle, standoff, "M-" + x1 + "," + y + "H" + x1 + "L" + x0 + ",0L" + x1 + ",-" + y + "H-" + x1 + "L-" + x0 + ",0Z");
	                }
	              },
	              octagon: {
	                n: 16,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var a = round(r * 0.924, 2);
	                  var b = round(r * 0.383, 2);
	                  return align(angle, standoff, "M-" + b + ",-" + a + "H" + b + "L" + a + ",-" + b + "V" + b + "L" + b + "," + a + "H-" + b + "L-" + a + "," + b + "V-" + b + "Z");
	                }
	              },
	              star: {
	                n: 17,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = r * 1.4;
	                  var x1 = round(rs * 0.225, 2);
	                  var x2 = round(rs * 0.951, 2);
	                  var x3 = round(rs * 0.363, 2);
	                  var x4 = round(rs * 0.588, 2);
	                  var y0 = round(-rs, 2);
	                  var y1 = round(rs * -0.309, 2);
	                  var y3 = round(rs * 0.118, 2);
	                  var y4 = round(rs * 0.809, 2);
	                  var y5 = round(rs * 0.382, 2);
	                  return align(angle, standoff, "M" + x1 + "," + y1 + "H" + x2 + "L" + x3 + "," + y3 + "L" + x4 + "," + y4 + "L0," + y5 + "L-" + x4 + "," + y4 + "L-" + x3 + "," + y3 + "L-" + x2 + "," + y1 + "H-" + x1 + "L0," + y0 + "Z");
	                }
	              },
	              hexagram: {
	                n: 18,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var y = round(r * 0.66, 2);
	                  var x1 = round(r * 0.38, 2);
	                  var x2 = round(r * 0.76, 2);
	                  return align(angle, standoff, "M-" + x2 + ",0l-" + x1 + ",-" + y + "h" + x2 + "l" + x1 + ",-" + y + "l" + x1 + "," + y + "h" + x2 + "l-" + x1 + "," + y + "l" + x1 + "," + y + "h-" + x2 + "l-" + x1 + "," + y + "l-" + x1 + ",-" + y + "h-" + x2 + "Z");
	                }
	              },
	              "star-triangle-up": {
	                n: 19,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x = round(r * sqrt3 * 0.8, 2);
	                  var y1 = round(r * 0.8, 2);
	                  var y2 = round(r * 1.6, 2);
	                  var rc = round(r * 4, 2);
	                  var aPart = "A " + rc + "," + rc + " 0 0 1 ";
	                  return align(angle, standoff, "M-" + x + "," + y1 + aPart + x + "," + y1 + aPart + "0,-" + y2 + aPart + "-" + x + "," + y1 + "Z");
	                }
	              },
	              "star-triangle-down": {
	                n: 20,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x = round(r * sqrt3 * 0.8, 2);
	                  var y1 = round(r * 0.8, 2);
	                  var y2 = round(r * 1.6, 2);
	                  var rc = round(r * 4, 2);
	                  var aPart = "A " + rc + "," + rc + " 0 0 1 ";
	                  return align(angle, standoff, "M" + x + ",-" + y1 + aPart + "-" + x + ",-" + y1 + aPart + "0," + y2 + aPart + x + ",-" + y1 + "Z");
	                }
	              },
	              "star-square": {
	                n: 21,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rp = round(r * 1.1, 2);
	                  var rc = round(r * 2, 2);
	                  var aPart = "A " + rc + "," + rc + " 0 0 1 ";
	                  return align(angle, standoff, "M-" + rp + ",-" + rp + aPart + "-" + rp + "," + rp + aPart + rp + "," + rp + aPart + rp + ",-" + rp + aPart + "-" + rp + ",-" + rp + "Z");
	                }
	              },
	              "star-diamond": {
	                n: 22,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rp = round(r * 1.4, 2);
	                  var rc = round(r * 1.9, 2);
	                  var aPart = "A " + rc + "," + rc + " 0 0 1 ";
	                  return align(angle, standoff, "M-" + rp + ",0" + aPart + "0," + rp + aPart + rp + ",0" + aPart + "0,-" + rp + aPart + "-" + rp + ",0Z");
	                }
	              },
	              "diamond-tall": {
	                n: 23,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x = round(r * 0.7, 2);
	                  var y = round(r * 1.4, 2);
	                  return align(angle, standoff, "M0," + y + "L" + x + ",0L0,-" + y + "L-" + x + ",0Z");
	                }
	              },
	              "diamond-wide": {
	                n: 24,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x = round(r * 1.4, 2);
	                  var y = round(r * 0.7, 2);
	                  return align(angle, standoff, "M0," + y + "L" + x + ",0L0,-" + y + "L-" + x + ",0Z");
	                }
	              },
	              hourglass: {
	                n: 25,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M" + rs + "," + rs + "H-" + rs + "L" + rs + ",-" + rs + "H-" + rs + "Z");
	                },
	                noDot: true
	              },
	              bowtie: {
	                n: 26,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M" + rs + "," + rs + "V-" + rs + "L-" + rs + "," + rs + "V-" + rs + "Z");
	                },
	                noDot: true
	              },
	              "circle-cross": {
	                n: 27,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M0," + rs + "V-" + rs + "M" + rs + ",0H-" + rs + "M" + rs + ",0A" + rs + "," + rs + " 0 1,1 0,-" + rs + "A" + rs + "," + rs + " 0 0,1 " + rs + ",0Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              "circle-x": {
	                n: 28,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  var rc = round(r / sqrt2, 2);
	                  return align(angle, standoff, "M" + rc + "," + rc + "L-" + rc + ",-" + rc + "M" + rc + ",-" + rc + "L-" + rc + "," + rc + "M" + rs + ",0A" + rs + "," + rs + " 0 1,1 0,-" + rs + "A" + rs + "," + rs + " 0 0,1 " + rs + ",0Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              "square-cross": {
	                n: 29,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M0," + rs + "V-" + rs + "M" + rs + ",0H-" + rs + "M" + rs + "," + rs + "H-" + rs + "V-" + rs + "H" + rs + "Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              "square-x": {
	                n: 30,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rs = round(r, 2);
	                  return align(angle, standoff, "M" + rs + "," + rs + "L-" + rs + ",-" + rs + "M" + rs + ",-" + rs + "L-" + rs + "," + rs + "M" + rs + "," + rs + "H-" + rs + "V-" + rs + "H" + rs + "Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              "diamond-cross": {
	                n: 31,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rd = round(r * 1.3, 2);
	                  return align(angle, standoff, "M" + rd + ",0L0," + rd + "L-" + rd + ",0L0,-" + rd + "ZM0,-" + rd + "V" + rd + "M-" + rd + ",0H" + rd);
	                },
	                needLine: true,
	                noDot: true
	              },
	              "diamond-x": {
	                n: 32,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rd = round(r * 1.3, 2);
	                  var r2 = round(r * 0.65, 2);
	                  return align(angle, standoff, "M" + rd + ",0L0," + rd + "L-" + rd + ",0L0,-" + rd + "ZM-" + r2 + ",-" + r2 + "L" + r2 + "," + r2 + "M-" + r2 + "," + r2 + "L" + r2 + ",-" + r2);
	                },
	                needLine: true,
	                noDot: true
	              },
	              "cross-thin": {
	                n: 33,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rc = round(r * 1.4, 2);
	                  return align(angle, standoff, "M0," + rc + "V-" + rc + "M" + rc + ",0H-" + rc);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "x-thin": {
	                n: 34,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  return align(angle, standoff, "M" + rx + "," + rx + "L-" + rx + ",-" + rx + "M" + rx + ",-" + rx + "L-" + rx + "," + rx);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              asterisk: {
	                n: 35,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rc = round(r * 1.2, 2);
	                  var rs = round(r * 0.85, 2);
	                  return align(angle, standoff, "M0," + rc + "V-" + rc + "M" + rc + ",0H-" + rc + "M" + rs + "," + rs + "L-" + rs + ",-" + rs + "M" + rs + ",-" + rs + "L-" + rs + "," + rs);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              hash: {
	                n: 36,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var r1 = round(r / 2, 2);
	                  var r2 = round(r, 2);
	                  return align(angle, standoff, "M" + r1 + "," + r2 + "V-" + r2 + "M" + (r1 - r2) + ",-" + r2 + "V" + r2 + "M" + r2 + "," + r1 + "H-" + r2 + "M-" + r2 + "," + (r1 - r2) + "H" + r2);
	                },
	                needLine: true,
	                noFill: true
	              },
	              "y-up": {
	                n: 37,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x = round(r * 1.2, 2);
	                  var y0 = round(r * 1.6, 2);
	                  var y1 = round(r * 0.8, 2);
	                  return align(angle, standoff, "M-" + x + "," + y1 + "L0,0M" + x + "," + y1 + "L0,0M0,-" + y0 + "L0,0");
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "y-down": {
	                n: 38,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var x = round(r * 1.2, 2);
	                  var y0 = round(r * 1.6, 2);
	                  var y1 = round(r * 0.8, 2);
	                  return align(angle, standoff, "M-" + x + ",-" + y1 + "L0,0M" + x + ",-" + y1 + "L0,0M0," + y0 + "L0,0");
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "y-left": {
	                n: 39,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var y = round(r * 1.2, 2);
	                  var x0 = round(r * 1.6, 2);
	                  var x1 = round(r * 0.8, 2);
	                  return align(angle, standoff, "M" + x1 + "," + y + "L0,0M" + x1 + ",-" + y + "L0,0M-" + x0 + ",0L0,0");
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "y-right": {
	                n: 40,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var y = round(r * 1.2, 2);
	                  var x0 = round(r * 1.6, 2);
	                  var x1 = round(r * 0.8, 2);
	                  return align(angle, standoff, "M-" + x1 + "," + y + "L0,0M-" + x1 + ",-" + y + "L0,0M" + x0 + ",0L0,0");
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "line-ew": {
	                n: 41,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rc = round(r * 1.4, 2);
	                  return align(angle, standoff, "M" + rc + ",0H-" + rc);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "line-ns": {
	                n: 42,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rc = round(r * 1.4, 2);
	                  return align(angle, standoff, "M0," + rc + "V-" + rc);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "line-ne": {
	                n: 43,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  return align(angle, standoff, "M" + rx + ",-" + rx + "L-" + rx + "," + rx);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "line-nw": {
	                n: 44,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  return align(angle, standoff, "M" + rx + "," + rx + "L-" + rx + ",-" + rx);
	                },
	                needLine: true,
	                noDot: true,
	                noFill: true
	              },
	              "arrow-up": {
	                n: 45,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  var ry = round(r * 2, 2);
	                  return align(angle, standoff, "M0,0L-" + rx + "," + ry + "H" + rx + "Z");
	                },
	                backoff: 1,
	                noDot: true
	              },
	              "arrow-down": {
	                n: 46,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  var ry = round(r * 2, 2);
	                  return align(angle, standoff, "M0,0L-" + rx + ",-" + ry + "H" + rx + "Z");
	                },
	                noDot: true
	              },
	              "arrow-left": {
	                n: 47,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r * 2, 2);
	                  var ry = round(r, 2);
	                  return align(angle, standoff, "M0,0L" + rx + ",-" + ry + "V" + ry + "Z");
	                },
	                noDot: true
	              },
	              "arrow-right": {
	                n: 48,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r * 2, 2);
	                  var ry = round(r, 2);
	                  return align(angle, standoff, "M0,0L-" + rx + ",-" + ry + "V" + ry + "Z");
	                },
	                noDot: true
	              },
	              "arrow-bar-up": {
	                n: 49,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  var ry = round(r * 2, 2);
	                  return align(angle, standoff, "M-" + rx + ",0H" + rx + "M0,0L-" + rx + "," + ry + "H" + rx + "Z");
	                },
	                backoff: 1,
	                needLine: true,
	                noDot: true
	              },
	              "arrow-bar-down": {
	                n: 50,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r, 2);
	                  var ry = round(r * 2, 2);
	                  return align(angle, standoff, "M-" + rx + ",0H" + rx + "M0,0L-" + rx + ",-" + ry + "H" + rx + "Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              "arrow-bar-left": {
	                n: 51,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r * 2, 2);
	                  var ry = round(r, 2);
	                  return align(angle, standoff, "M0,-" + ry + "V" + ry + "M0,0L" + rx + ",-" + ry + "V" + ry + "Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              "arrow-bar-right": {
	                n: 52,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var rx = round(r * 2, 2);
	                  var ry = round(r, 2);
	                  return align(angle, standoff, "M0,-" + ry + "V" + ry + "M0,0L-" + rx + ",-" + ry + "V" + ry + "Z");
	                },
	                needLine: true,
	                noDot: true
	              },
	              arrow: {
	                n: 53,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var headAngle = PI / 2.5;
	                  var x = 2 * r * cos(headAngle);
	                  var y = 2 * r * sin(headAngle);
	                  return align(angle, standoff, "M0,0L" + -x + "," + y + "L" + x + "," + y + "Z");
	                },
	                backoff: 0.9,
	                noDot: true
	              },
	              "arrow-wide": {
	                n: 54,
	                f: function(r, angle, standoff) {
	                  if (skipAngle(angle)) return emptyPath;
	                  var headAngle = PI / 4;
	                  var x = 2 * r * cos(headAngle);
	                  var y = 2 * r * sin(headAngle);
	                  return align(angle, standoff, "M0,0L" + -x + "," + y + "A " + 2 * r + "," + 2 * r + " 0 0 1 " + x + "," + y + "Z");
	                },
	                backoff: 0.4,
	                noDot: true
	              }
	            };
	            function skipAngle(angle) {
	              return angle === null;
	            }
	            var lastPathIn, lastPathOut;
	            var lastAngle, lastStandoff;
	            function align(angle, standoff, path) {
	              if ((!angle || angle % 360 === 0) && !standoff) return path;
	              if (lastAngle === angle && lastStandoff === standoff && lastPathIn === path) return lastPathOut;
	              lastAngle = angle;
	              lastStandoff = standoff;
	              lastPathIn = path;
	              function rotate(t2, xy) {
	                var cosT = cos(t2);
	                var sinT = sin(t2);
	                var x2 = xy[0];
	                var y2 = xy[1] + (standoff || 0);
	                return [x2 * cosT - y2 * sinT, x2 * sinT + y2 * cosT];
	              }
	              var t = angle / 180 * PI;
	              var x = 0;
	              var y = 0;
	              var cmd = parseSvgPath(path);
	              var str = "";
	              for (var i = 0; i < cmd.length; i++) {
	                var cmdI = cmd[i];
	                var op = cmdI[0];
	                var x0 = x;
	                var y0 = y;
	                if (op === "M" || op === "L") {
	                  x = +cmdI[1];
	                  y = +cmdI[2];
	                } else if (op === "m" || op === "l") {
	                  x += +cmdI[1];
	                  y += +cmdI[2];
	                } else if (op === "H") {
	                  x = +cmdI[1];
	                } else if (op === "h") {
	                  x += +cmdI[1];
	                } else if (op === "V") {
	                  y = +cmdI[1];
	                } else if (op === "v") {
	                  y += +cmdI[1];
	                } else if (op === "A") {
	                  x = +cmdI[1];
	                  y = +cmdI[2];
	                  var E = rotate(t, [+cmdI[6], +cmdI[7]]);
	                  cmdI[6] = E[0];
	                  cmdI[7] = E[1];
	                  cmdI[3] = +cmdI[3] + angle;
	                }
	                if (op === "H" || op === "V") op = "L";
	                if (op === "h" || op === "v") op = "l";
	                if (op === "m" || op === "l") {
	                  x -= x0;
	                  y -= y0;
	                }
	                var B = rotate(t, [x, y]);
	                if (op === "H" || op === "V") op = "L";
	                if (op === "M" || op === "L" || op === "m" || op === "l") {
	                  cmdI[1] = B[0];
	                  cmdI[2] = B[1];
	                }
	                cmdI[0] = op;
	                str += cmdI[0] + cmdI.slice(1).join(",");
	              }
	              lastPathOut = str;
	              return str;
	            }
	          }
	        ),
	        /***/
	        25673: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              visible: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              type: {
	                valType: "enumerated",
	                values: ["percent", "constant", "sqrt", "data"],
	                editType: "calc"
	              },
	              symmetric: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              array: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              arrayminus: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              value: {
	                valType: "number",
	                min: 0,
	                dflt: 10,
	                editType: "calc"
	              },
	              valueminus: {
	                valType: "number",
	                min: 0,
	                dflt: 10,
	                editType: "calc"
	              },
	              traceref: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "style"
	              },
	              tracerefminus: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "style"
	              },
	              copy_ystyle: {
	                valType: "boolean",
	                editType: "plot"
	              },
	              copy_zstyle: {
	                valType: "boolean",
	                editType: "style"
	              },
	              color: {
	                valType: "color",
	                editType: "style"
	              },
	              thickness: {
	                valType: "number",
	                min: 0,
	                dflt: 2,
	                editType: "style"
	              },
	              width: {
	                valType: "number",
	                min: 0,
	                editType: "plot"
	              },
	              editType: "calc",
	              _deprecated: {
	                opacity: {
	                  valType: "number",
	                  editType: "style"
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        84532: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var makeComputeError = __webpack_require__2(45827);
	            module2.exports = function calc(gd) {
	              var calcdata = gd.calcdata;
	              for (var i = 0; i < calcdata.length; i++) {
	                var calcTrace = calcdata[i];
	                var trace = calcTrace[0].trace;
	                if (trace.visible === true && Registry.traceIs(trace, "errorBarsOK")) {
	                  var xa = Axes.getFromId(gd, trace.xaxis);
	                  var ya = Axes.getFromId(gd, trace.yaxis);
	                  calcOneAxis(calcTrace, trace, xa, "x");
	                  calcOneAxis(calcTrace, trace, ya, "y");
	                }
	              }
	            };
	            function calcOneAxis(calcTrace, trace, axis, coord) {
	              var opts = trace["error_" + coord] || {};
	              var isVisible = opts.visible && ["linear", "log"].indexOf(axis.type) !== -1;
	              var vals = [];
	              if (!isVisible) return;
	              var computeError = makeComputeError(opts);
	              for (var i = 0; i < calcTrace.length; i++) {
	                var calcPt = calcTrace[i];
	                var iIn = calcPt.i;
	                if (iIn === undefined) iIn = i;
	                else if (iIn === null) continue;
	                var calcCoord = calcPt[coord];
	                if (!isNumeric(axis.c2l(calcCoord))) continue;
	                var errors = computeError(calcCoord, iIn);
	                if (isNumeric(errors[0]) && isNumeric(errors[1])) {
	                  var shoe = calcPt[coord + "s"] = calcCoord - errors[0];
	                  var hat = calcPt[coord + "h"] = calcCoord + errors[1];
	                  vals.push(shoe, hat);
	                }
	              }
	              var axId = axis._id;
	              var baseExtremes = trace._extremes[axId];
	              var extremes = Axes.findExtremes(axis, vals, Lib.extendFlat({
	                tozero: baseExtremes.opts.tozero
	              }, {
	                padded: true
	              }));
	              baseExtremes.min = baseExtremes.min.concat(extremes.min);
	              baseExtremes.max = baseExtremes.max.concat(extremes.max);
	            }
	          }
	        ),
	        /***/
	        45827: (
	          /***/
	          function(module2) {
	            module2.exports = function makeComputeError(opts) {
	              var type = opts.type;
	              var symmetric = opts.symmetric;
	              if (type === "data") {
	                var array = opts.array || [];
	                if (symmetric) {
	                  return function computeError(dataPt, index) {
	                    var val = +array[index];
	                    return [val, val];
	                  };
	                } else {
	                  var arrayminus = opts.arrayminus || [];
	                  return function computeError(dataPt, index) {
	                    var val = +array[index];
	                    var valMinus = +arrayminus[index];
	                    if (!isNaN(val) || !isNaN(valMinus)) {
	                      return [valMinus || 0, val || 0];
	                    }
	                    return [NaN, NaN];
	                  };
	                }
	              } else {
	                var computeErrorValue = makeComputeErrorValue(type, opts.value);
	                var computeErrorValueMinus = makeComputeErrorValue(type, opts.valueminus);
	                if (symmetric || opts.valueminus === undefined) {
	                  return function computeError(dataPt) {
	                    var val = computeErrorValue(dataPt);
	                    return [val, val];
	                  };
	                } else {
	                  return function computeError(dataPt) {
	                    return [computeErrorValueMinus(dataPt), computeErrorValue(dataPt)];
	                  };
	                }
	              }
	            };
	            function makeComputeErrorValue(type, value) {
	              if (type === "percent") {
	                return function(dataPt) {
	                  return Math.abs(dataPt * value / 100);
	                };
	              }
	              if (type === "constant") {
	                return function() {
	                  return Math.abs(value);
	                };
	              }
	              if (type === "sqrt") {
	                return function(dataPt) {
	                  return Math.sqrt(Math.abs(dataPt));
	                };
	              }
	            }
	          }
	        ),
	        /***/
	        97587: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var attributes = __webpack_require__2(25673);
	            module2.exports = function(traceIn, traceOut, defaultColor, opts) {
	              var objName = "error_" + opts.axis;
	              var containerOut = Template.newContainer(traceOut, objName);
	              var containerIn = traceIn[objName] || {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	              }
	              var hasErrorBars = containerIn.array !== undefined || containerIn.value !== undefined || containerIn.type === "sqrt";
	              var visible = coerce("visible", hasErrorBars);
	              if (visible === false) return;
	              var type = coerce("type", "array" in containerIn ? "data" : "percent");
	              var symmetric = true;
	              if (type !== "sqrt") {
	                symmetric = coerce("symmetric", !((type === "data" ? "arrayminus" : "valueminus") in containerIn));
	              }
	              if (type === "data") {
	                coerce("array");
	                coerce("traceref");
	                if (!symmetric) {
	                  coerce("arrayminus");
	                  coerce("tracerefminus");
	                }
	              } else if (type === "percent" || type === "constant") {
	                coerce("value");
	                if (!symmetric) coerce("valueminus");
	              }
	              var copyAttr = "copy_" + opts.inherit + "style";
	              if (opts.inherit) {
	                var inheritObj = traceOut["error_" + opts.inherit];
	                if ((inheritObj || {}).visible) {
	                  coerce(copyAttr, !(containerIn.color || isNumeric(containerIn.thickness) || isNumeric(containerIn.width)));
	                }
	              }
	              if (!opts.inherit || !containerOut[copyAttr]) {
	                coerce("color", defaultColor);
	                coerce("thickness");
	                coerce("width", Registry.traceIs(traceOut, "gl3d") ? 0 : 4);
	              }
	            };
	          }
	        ),
	        /***/
	        37369: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var attributes = __webpack_require__2(25673);
	            var xyAttrs = {
	              error_x: Lib.extendFlat({}, attributes),
	              error_y: Lib.extendFlat({}, attributes)
	            };
	            delete xyAttrs.error_x.copy_zstyle;
	            delete xyAttrs.error_y.copy_zstyle;
	            delete xyAttrs.error_y.copy_ystyle;
	            var xyzAttrs = {
	              error_x: Lib.extendFlat({}, attributes),
	              error_y: Lib.extendFlat({}, attributes),
	              error_z: Lib.extendFlat({}, attributes)
	            };
	            delete xyzAttrs.error_x.copy_ystyle;
	            delete xyzAttrs.error_y.copy_ystyle;
	            delete xyzAttrs.error_z.copy_ystyle;
	            delete xyzAttrs.error_z.copy_zstyle;
	            module2.exports = {
	              moduleType: "component",
	              name: "errorbars",
	              schema: {
	                traces: {
	                  scatter: xyAttrs,
	                  bar: xyAttrs,
	                  histogram: xyAttrs,
	                  scatter3d: overrideAll(xyzAttrs, "calc", "nested"),
	                  scattergl: overrideAll(xyAttrs, "calc", "nested")
	                }
	              },
	              supplyDefaults: __webpack_require__2(97587),
	              calc: __webpack_require__2(84532),
	              makeComputeError: __webpack_require__2(45827),
	              plot: __webpack_require__2(19398),
	              style: __webpack_require__2(62662),
	              hoverInfo
	            };
	            function hoverInfo(calcPoint, trace, hoverPoint) {
	              if ((trace.error_y || {}).visible) {
	                hoverPoint.yerr = calcPoint.yh - calcPoint.y;
	                if (!trace.error_y.symmetric) hoverPoint.yerrneg = calcPoint.y - calcPoint.ys;
	              }
	              if ((trace.error_x || {}).visible) {
	                hoverPoint.xerr = calcPoint.xh - calcPoint.x;
	                if (!trace.error_x.symmetric) hoverPoint.xerrneg = calcPoint.x - calcPoint.xs;
	              }
	            }
	          }
	        ),
	        /***/
	        19398: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Drawing = __webpack_require__2(91424);
	            var subTypes = __webpack_require__2(34098);
	            module2.exports = function plot(gd, traces, plotinfo, transitionOpts) {
	              var isNew;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var hasAnimation = transitionOpts && transitionOpts.duration > 0;
	              var isStatic = gd._context.staticPlot;
	              traces.each(function(d) {
	                var trace = d[0].trace;
	                var xObj = trace.error_x || {};
	                var yObj = trace.error_y || {};
	                var keyFunc;
	                if (trace.ids) {
	                  keyFunc = function(d2) {
	                    return d2.id;
	                  };
	                }
	                var sparse = subTypes.hasMarkers(trace) && trace.marker.maxdisplayed > 0;
	                if (!yObj.visible && !xObj.visible) d = [];
	                var errorbars = d3.select(this).selectAll("g.errorbar").data(d, keyFunc);
	                errorbars.exit().remove();
	                if (!d.length) return;
	                if (!xObj.visible) errorbars.selectAll("path.xerror").remove();
	                if (!yObj.visible) errorbars.selectAll("path.yerror").remove();
	                errorbars.style("opacity", 1);
	                var enter = errorbars.enter().append("g").classed("errorbar", true);
	                if (hasAnimation) {
	                  enter.style("opacity", 0).transition().duration(transitionOpts.duration).style("opacity", 1);
	                }
	                Drawing.setClipUrl(errorbars, plotinfo.layerClipId, gd);
	                errorbars.each(function(d2) {
	                  var errorbar = d3.select(this);
	                  var coords = errorCoords(d2, xa, ya);
	                  if (sparse && !d2.vis) return;
	                  var path;
	                  var yerror = errorbar.select("path.yerror");
	                  if (yObj.visible && isNumeric(coords.x) && isNumeric(coords.yh) && isNumeric(coords.ys)) {
	                    var yw = yObj.width;
	                    path = "M" + (coords.x - yw) + "," + coords.yh + "h" + 2 * yw + // hat
	                    "m-" + yw + ",0V" + coords.ys;
	                    if (!coords.noYS) path += "m-" + yw + ",0h" + 2 * yw;
	                    isNew = !yerror.size();
	                    if (isNew) {
	                      yerror = errorbar.append("path").style("vector-effect", isStatic ? "none" : "non-scaling-stroke").classed("yerror", true);
	                    } else if (hasAnimation) {
	                      yerror = yerror.transition().duration(transitionOpts.duration).ease(transitionOpts.easing);
	                    }
	                    yerror.attr("d", path);
	                  } else yerror.remove();
	                  var xerror = errorbar.select("path.xerror");
	                  if (xObj.visible && isNumeric(coords.y) && isNumeric(coords.xh) && isNumeric(coords.xs)) {
	                    var xw = (xObj.copy_ystyle ? yObj : xObj).width;
	                    path = "M" + coords.xh + "," + (coords.y - xw) + "v" + 2 * xw + // hat
	                    "m0,-" + xw + "H" + coords.xs;
	                    if (!coords.noXS) path += "m0,-" + xw + "v" + 2 * xw;
	                    isNew = !xerror.size();
	                    if (isNew) {
	                      xerror = errorbar.append("path").style("vector-effect", isStatic ? "none" : "non-scaling-stroke").classed("xerror", true);
	                    } else if (hasAnimation) {
	                      xerror = xerror.transition().duration(transitionOpts.duration).ease(transitionOpts.easing);
	                    }
	                    xerror.attr("d", path);
	                  } else xerror.remove();
	                });
	              });
	            };
	            function errorCoords(d, xa, ya) {
	              var out = {
	                x: xa.c2p(d.x),
	                y: ya.c2p(d.y)
	              };
	              if (d.yh !== undefined) {
	                out.yh = ya.c2p(d.yh);
	                out.ys = ya.c2p(d.ys);
	                if (!isNumeric(out.ys)) {
	                  out.noYS = true;
	                  out.ys = ya.c2p(d.ys, true);
	                }
	              }
	              if (d.xh !== undefined) {
	                out.xh = xa.c2p(d.xh);
	                out.xs = xa.c2p(d.xs);
	                if (!isNumeric(out.xs)) {
	                  out.noXS = true;
	                  out.xs = xa.c2p(d.xs, true);
	                }
	              }
	              return out;
	            }
	          }
	        ),
	        /***/
	        62662: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            module2.exports = function style(traces) {
	              traces.each(function(d) {
	                var trace = d[0].trace;
	                var yObj = trace.error_y || {};
	                var xObj = trace.error_x || {};
	                var s = d3.select(this);
	                s.selectAll("path.yerror").style("stroke-width", yObj.thickness + "px").call(Color.stroke, yObj.color);
	                if (xObj.copy_ystyle) xObj = yObj;
	                s.selectAll("path.xerror").style("stroke-width", xObj.thickness + "px").call(Color.stroke, xObj.color);
	              });
	            };
	          }
	        ),
	        /***/
	        77914: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var hoverLabelAttrs = __webpack_require__2(528).hoverlabel;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = {
	              hoverlabel: {
	                bgcolor: extendFlat({}, hoverLabelAttrs.bgcolor, {
	                  arrayOk: true
	                }),
	                bordercolor: extendFlat({}, hoverLabelAttrs.bordercolor, {
	                  arrayOk: true
	                }),
	                font: fontAttrs({
	                  arrayOk: true,
	                  editType: "none"
	                }),
	                align: extendFlat({}, hoverLabelAttrs.align, {
	                  arrayOk: true
	                }),
	                namelength: extendFlat({}, hoverLabelAttrs.namelength, {
	                  arrayOk: true
	                }),
	                editType: "none"
	              }
	            };
	          }
	        ),
	        /***/
	        30732: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            module2.exports = function calc(gd) {
	              var calcdata = gd.calcdata;
	              var fullLayout = gd._fullLayout;
	              function makeCoerceHoverInfo(trace2) {
	                return function(val) {
	                  return Lib.coerceHoverinfo({
	                    hoverinfo: val
	                  }, {
	                    _module: trace2._module
	                  }, fullLayout);
	                };
	              }
	              for (var i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                var trace = cd[0].trace;
	                if (Registry.traceIs(trace, "pie-like")) continue;
	                var fillFn = Registry.traceIs(trace, "2dMap") ? paste : Lib.fillArray;
	                fillFn(trace.hoverinfo, cd, "hi", makeCoerceHoverInfo(trace));
	                if (trace.hovertemplate) fillFn(trace.hovertemplate, cd, "ht");
	                if (!trace.hoverlabel) continue;
	                fillFn(trace.hoverlabel.bgcolor, cd, "hbg");
	                fillFn(trace.hoverlabel.bordercolor, cd, "hbc");
	                fillFn(trace.hoverlabel.font.size, cd, "hts");
	                fillFn(trace.hoverlabel.font.color, cd, "htc");
	                fillFn(trace.hoverlabel.font.family, cd, "htf");
	                fillFn(trace.hoverlabel.namelength, cd, "hnl");
	                fillFn(trace.hoverlabel.align, cd, "hta");
	              }
	            };
	            function paste(traceAttr, cd, cdAttr, fn) {
	              fn = fn || Lib.identity;
	              if (Array.isArray(traceAttr)) {
	                cd[0][cdAttr] = fn(traceAttr);
	              }
	            }
	          }
	        ),
	        /***/
	        75914: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var hover = __webpack_require__2(88335).hover;
	            module2.exports = function click(gd, evt, subplot) {
	              var annotationsDone = Registry.getComponentMethod("annotations", "onClick")(gd, gd._hoverdata);
	              if (subplot !== undefined) {
	                hover(gd, evt, subplot, true);
	              }
	              function emitClick() {
	                gd.emit("plotly_click", {
	                  points: gd._hoverdata,
	                  event: evt
	                });
	              }
	              if (gd._hoverdata && evt && evt.target) {
	                if (annotationsDone && annotationsDone.then) {
	                  annotationsDone.then(emitClick);
	                } else emitClick();
	                if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
	              }
	            };
	          }
	        ),
	        /***/
	        26675: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // hover labels for multiple horizontal bars get tilted by this angle
	              YANGLE: 60,
	              // size and display constants for hover text
	              // pixel size of hover arrows
	              HOVERARROWSIZE: 6,
	              // pixels padding around text
	              HOVERTEXTPAD: 3,
	              // hover font
	              HOVERFONTSIZE: 13,
	              HOVERFONT: "Arial, sans-serif",
	              // minimum time (msec) between hover calls
	              HOVERMINTIME: 50,
	              // ID suffix (with fullLayout._uid) for hover events in the throttle cache
	              HOVERID: "-hover"
	            };
	          }
	        ),
	        /***/
	        54268: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(77914);
	            var handleHoverLabelDefaults = __webpack_require__2(38048);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var opts = Lib.extendFlat({}, layout.hoverlabel);
	              if (traceOut.hovertemplate) opts.namelength = -1;
	              handleHoverLabelDefaults(traceIn, traceOut, coerce, opts);
	            };
	          }
	        ),
	        /***/
	        23469: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            exports2.getSubplot = function(trace) {
	              return trace.subplot || trace.xaxis + trace.yaxis || trace.geo;
	            };
	            exports2.isTraceInSubplots = function(trace, subplots) {
	              if (trace.type === "splom") {
	                var xaxes = trace.xaxes || [];
	                var yaxes = trace.yaxes || [];
	                for (var i = 0; i < xaxes.length; i++) {
	                  for (var j = 0; j < yaxes.length; j++) {
	                    if (subplots.indexOf(xaxes[i] + yaxes[j]) !== -1) {
	                      return true;
	                    }
	                  }
	                }
	                return false;
	              }
	              return subplots.indexOf(exports2.getSubplot(trace)) !== -1;
	            };
	            exports2.flat = function(subplots, v) {
	              var out = new Array(subplots.length);
	              for (var i = 0; i < subplots.length; i++) {
	                out[i] = v;
	              }
	              return out;
	            };
	            exports2.p2c = function(axArray, v) {
	              var out = new Array(axArray.length);
	              for (var i = 0; i < axArray.length; i++) {
	                out[i] = axArray[i].p2c(v);
	              }
	              return out;
	            };
	            exports2.getDistanceFunction = function(mode, dx, dy, dxy) {
	              if (mode === "closest") return dxy || exports2.quadrature(dx, dy);
	              return mode.charAt(0) === "x" ? dx : dy;
	            };
	            exports2.getClosest = function(cd, distfn, pointData) {
	              if (pointData.index !== false) {
	                if (pointData.index >= 0 && pointData.index < cd.length) {
	                  pointData.distance = 0;
	                } else pointData.index = false;
	              } else {
	                for (var i = 0; i < cd.length; i++) {
	                  var newDistance = distfn(cd[i]);
	                  if (newDistance <= pointData.distance) {
	                    pointData.index = i;
	                    pointData.distance = newDistance;
	                  }
	                }
	              }
	              return pointData;
	            };
	            exports2.inbox = function(v0, v1, passVal) {
	              return v0 * v1 < 0 || v0 === 0 ? passVal : Infinity;
	            };
	            exports2.quadrature = function(dx, dy) {
	              return function(di) {
	                var x = dx(di);
	                var y = dy(di);
	                return Math.sqrt(x * x + y * y);
	              };
	            };
	            exports2.makeEventData = function(pt, trace, cd) {
	              var pointNumber = "index" in pt ? pt.index : pt.pointNumber;
	              var out = {
	                data: trace._input,
	                fullData: trace,
	                curveNumber: trace.index,
	                pointNumber
	              };
	              if (trace._indexToPoints) {
	                var pointIndices = trace._indexToPoints[pointNumber];
	                if (pointIndices.length === 1) {
	                  out.pointIndex = pointIndices[0];
	                } else {
	                  out.pointIndices = pointIndices;
	                }
	              } else {
	                out.pointIndex = pointNumber;
	              }
	              if (trace._module.eventData) {
	                out = trace._module.eventData(out, pt, trace, cd, pointNumber);
	              } else {
	                if ("xVal" in pt) out.x = pt.xVal;
	                else if ("x" in pt) out.x = pt.x;
	                if ("yVal" in pt) out.y = pt.yVal;
	                else if ("y" in pt) out.y = pt.y;
	                if (pt.xa) out.xaxis = pt.xa;
	                if (pt.ya) out.yaxis = pt.ya;
	                if (pt.zLabelVal !== undefined) out.z = pt.zLabelVal;
	              }
	              exports2.appendArrayPointValue(out, trace, pointNumber);
	              return out;
	            };
	            exports2.appendArrayPointValue = function(pointData, trace, pointNumber) {
	              var arrayAttrs = trace._arrayAttrs;
	              if (!arrayAttrs) {
	                return;
	              }
	              for (var i = 0; i < arrayAttrs.length; i++) {
	                var astr = arrayAttrs[i];
	                var key = getPointKey(astr);
	                if (pointData[key] === undefined) {
	                  var val = Lib.nestedProperty(trace, astr).get();
	                  var pointVal = getPointData(val, pointNumber);
	                  if (pointVal !== undefined) pointData[key] = pointVal;
	                }
	              }
	            };
	            exports2.appendArrayMultiPointValues = function(pointData, trace, pointNumbers) {
	              var arrayAttrs = trace._arrayAttrs;
	              if (!arrayAttrs) {
	                return;
	              }
	              for (var i = 0; i < arrayAttrs.length; i++) {
	                var astr = arrayAttrs[i];
	                var key = getPointKey(astr);
	                if (pointData[key] === undefined) {
	                  var val = Lib.nestedProperty(trace, astr).get();
	                  var keyVal = new Array(pointNumbers.length);
	                  for (var j = 0; j < pointNumbers.length; j++) {
	                    keyVal[j] = getPointData(val, pointNumbers[j]);
	                  }
	                  pointData[key] = keyVal;
	                }
	              }
	            };
	            var pointKeyMap = {
	              ids: "id",
	              locations: "location",
	              labels: "label",
	              values: "value",
	              "marker.colors": "color",
	              parents: "parent"
	            };
	            function getPointKey(astr) {
	              return pointKeyMap[astr] || astr;
	            }
	            function getPointData(val, pointNumber) {
	              if (Array.isArray(pointNumber)) {
	                if (Array.isArray(val) && Array.isArray(val[pointNumber[0]])) {
	                  return val[pointNumber[0]][pointNumber[1]];
	                }
	              } else {
	                return val[pointNumber];
	              }
	            }
	            var xyHoverMode = {
	              x: true,
	              y: true
	            };
	            var unifiedHoverMode = {
	              "x unified": true,
	              "y unified": true
	            };
	            exports2.isUnifiedHover = function(hovermode) {
	              if (typeof hovermode !== "string") return false;
	              return !!unifiedHoverMode[hovermode];
	            };
	            exports2.isXYhover = function(hovermode) {
	              if (typeof hovermode !== "string") return false;
	              return !!xyHoverMode[hovermode];
	            };
	          }
	        ),
	        /***/
	        88335: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var tinycolor = __webpack_require__2(84267);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var strRotate = Lib.strRotate;
	            var Events = __webpack_require__2(11086);
	            var svgTextUtils = __webpack_require__2(63893);
	            var overrideCursor = __webpack_require__2(39918);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var dragElement = __webpack_require__2(28569);
	            var Axes = __webpack_require__2(89298);
	            var Registry = __webpack_require__2(73972);
	            var helpers = __webpack_require__2(23469);
	            var constants = __webpack_require__2(26675);
	            var legendSupplyDefaults = __webpack_require__2(99017);
	            var legendDraw = __webpack_require__2(43969);
	            var YANGLE = constants.YANGLE;
	            var YA_RADIANS = Math.PI * YANGLE / 180;
	            var YFACTOR = 1 / Math.sin(YA_RADIANS);
	            var YSHIFTX = Math.cos(YA_RADIANS);
	            var YSHIFTY = Math.sin(YA_RADIANS);
	            var HOVERARROWSIZE = constants.HOVERARROWSIZE;
	            var HOVERTEXTPAD = constants.HOVERTEXTPAD;
	            var multipleHoverPoints = {
	              box: true,
	              ohlc: true,
	              violin: true,
	              candlestick: true
	            };
	            var cartesianScatterPoints = {
	              scatter: true,
	              scattergl: true,
	              splom: true
	            };
	            exports2.hover = function hover(gd, evt, subplot, noHoverEvent) {
	              gd = Lib.getGraphDiv(gd);
	              var eventTarget = evt.target;
	              Lib.throttle(gd._fullLayout._uid + constants.HOVERID, constants.HOVERMINTIME, function() {
	                _hover(gd, evt, subplot, noHoverEvent, eventTarget);
	              });
	            };
	            exports2.loneHover = function loneHover(hoverItems, opts) {
	              var multiHover = true;
	              if (!Array.isArray(hoverItems)) {
	                multiHover = false;
	                hoverItems = [hoverItems];
	              }
	              var gd = opts.gd;
	              var gTop = getTopOffset(gd);
	              var gLeft = getLeftOffset(gd);
	              var pointsData = hoverItems.map(function(hoverItem) {
	                var _x0 = hoverItem._x0 || hoverItem.x0 || hoverItem.x || 0;
	                var _x1 = hoverItem._x1 || hoverItem.x1 || hoverItem.x || 0;
	                var _y0 = hoverItem._y0 || hoverItem.y0 || hoverItem.y || 0;
	                var _y1 = hoverItem._y1 || hoverItem.y1 || hoverItem.y || 0;
	                var eventData = hoverItem.eventData;
	                if (eventData) {
	                  var x0 = Math.min(_x0, _x1);
	                  var x1 = Math.max(_x0, _x1);
	                  var y0 = Math.min(_y0, _y1);
	                  var y1 = Math.max(_y0, _y1);
	                  var trace = hoverItem.trace;
	                  if (Registry.traceIs(trace, "gl3d")) {
	                    var container = gd._fullLayout[trace.scene]._scene.container;
	                    var dx = container.offsetLeft;
	                    var dy = container.offsetTop;
	                    x0 += dx;
	                    x1 += dx;
	                    y0 += dy;
	                    y1 += dy;
	                  }
	                  eventData.bbox = {
	                    x0: x0 + gLeft,
	                    x1: x1 + gLeft,
	                    y0: y0 + gTop,
	                    y1: y1 + gTop
	                  };
	                  if (opts.inOut_bbox) {
	                    opts.inOut_bbox.push(eventData.bbox);
	                  }
	                } else {
	                  eventData = false;
	                }
	                return {
	                  color: hoverItem.color || Color.defaultLine,
	                  x0: hoverItem.x0 || hoverItem.x || 0,
	                  x1: hoverItem.x1 || hoverItem.x || 0,
	                  y0: hoverItem.y0 || hoverItem.y || 0,
	                  y1: hoverItem.y1 || hoverItem.y || 0,
	                  xLabel: hoverItem.xLabel,
	                  yLabel: hoverItem.yLabel,
	                  zLabel: hoverItem.zLabel,
	                  text: hoverItem.text,
	                  name: hoverItem.name,
	                  idealAlign: hoverItem.idealAlign,
	                  // optional extra bits of styling
	                  borderColor: hoverItem.borderColor,
	                  fontFamily: hoverItem.fontFamily,
	                  fontSize: hoverItem.fontSize,
	                  fontColor: hoverItem.fontColor,
	                  nameLength: hoverItem.nameLength,
	                  textAlign: hoverItem.textAlign,
	                  // filler to make createHoverText happy
	                  trace: hoverItem.trace || {
	                    index: 0,
	                    hoverinfo: ""
	                  },
	                  xa: {
	                    _offset: 0
	                  },
	                  ya: {
	                    _offset: 0
	                  },
	                  index: 0,
	                  hovertemplate: hoverItem.hovertemplate || false,
	                  hovertemplateLabels: hoverItem.hovertemplateLabels || false,
	                  eventData
	                };
	              });
	              var rotateLabels = false;
	              var hoverText = createHoverText(pointsData, {
	                gd,
	                hovermode: "closest",
	                rotateLabels,
	                bgColor: opts.bgColor || Color.background,
	                container: d3.select(opts.container),
	                outerContainer: opts.outerContainer || opts.container
	              });
	              var hoverLabel = hoverText.hoverLabels;
	              var tooltipSpacing = 5;
	              var lastBottomY = 0;
	              var anchor = 0;
	              hoverLabel.sort(function(a, b) {
	                return a.y0 - b.y0;
	              }).each(function(d, i) {
	                var topY = d.y0 - d.by / 2;
	                if (topY - tooltipSpacing < lastBottomY) {
	                  d.offset = lastBottomY - topY + tooltipSpacing;
	                } else {
	                  d.offset = 0;
	                }
	                lastBottomY = topY + d.by + d.offset;
	                if (i === opts.anchorIndex || 0) anchor = d.offset;
	              }).each(function(d) {
	                d.offset -= anchor;
	              });
	              var scaleX = gd._fullLayout._invScaleX;
	              var scaleY = gd._fullLayout._invScaleY;
	              alignHoverText(hoverLabel, rotateLabels, scaleX, scaleY);
	              return multiHover ? hoverLabel : hoverLabel.node();
	            };
	            function _hover(gd, evt, subplot, noHoverEvent, eventTarget) {
	              if (!subplot) subplot = "xy";
	              var subplots = Array.isArray(subplot) ? subplot : [subplot];
	              var fullLayout = gd._fullLayout;
	              var plots = fullLayout._plots || [];
	              var plotinfo = plots[subplot];
	              var hasCartesian = fullLayout._has("cartesian");
	              if (plotinfo) {
	                var overlayedSubplots = plotinfo.overlays.map(function(pi) {
	                  return pi.id;
	                });
	                subplots = subplots.concat(overlayedSubplots);
	              }
	              var len = subplots.length;
	              var xaArray = new Array(len);
	              var yaArray = new Array(len);
	              var supportsCompare = false;
	              for (var i = 0; i < len; i++) {
	                var spId = subplots[i];
	                if (plots[spId]) {
	                  supportsCompare = true;
	                  xaArray[i] = plots[spId].xaxis;
	                  yaArray[i] = plots[spId].yaxis;
	                } else if (fullLayout[spId] && fullLayout[spId]._subplot) {
	                  var _subplot = fullLayout[spId]._subplot;
	                  xaArray[i] = _subplot.xaxis;
	                  yaArray[i] = _subplot.yaxis;
	                } else {
	                  Lib.warn("Unrecognized subplot: " + spId);
	                  return;
	                }
	              }
	              var hovermode = evt.hovermode || fullLayout.hovermode;
	              if (hovermode && !supportsCompare) hovermode = "closest";
	              if (["x", "y", "closest", "x unified", "y unified"].indexOf(hovermode) === -1 || !gd.calcdata || gd.querySelector(".zoombox") || gd._dragging) {
	                return dragElement.unhoverRaw(gd, evt);
	              }
	              var hoverdistance = fullLayout.hoverdistance;
	              if (hoverdistance === -1) hoverdistance = Infinity;
	              var spikedistance = fullLayout.spikedistance;
	              if (spikedistance === -1) spikedistance = Infinity;
	              var hoverData = [];
	              var searchData = [];
	              var xvalArray, yvalArray;
	              var itemnum, curvenum, cd, trace, subplotId, subploti, _mode, xval, yval, pointData, closedataPreviousLength;
	              var spikePoints = {
	                hLinePoint: null,
	                vLinePoint: null
	              };
	              var hasOneHorizontalTrace = false;
	              if (Array.isArray(evt)) {
	                hovermode = "array";
	                for (itemnum = 0; itemnum < evt.length; itemnum++) {
	                  cd = gd.calcdata[evt[itemnum].curveNumber || 0];
	                  if (cd) {
	                    trace = cd[0].trace;
	                    if (cd[0].trace.hoverinfo !== "skip") {
	                      searchData.push(cd);
	                      if (trace.orientation === "h") {
	                        hasOneHorizontalTrace = true;
	                      }
	                    }
	                  }
	                }
	              } else {
	                for (curvenum = 0; curvenum < gd.calcdata.length; curvenum++) {
	                  cd = gd.calcdata[curvenum];
	                  trace = cd[0].trace;
	                  if (trace.hoverinfo !== "skip" && helpers.isTraceInSubplots(trace, subplots)) {
	                    searchData.push(cd);
	                    if (trace.orientation === "h") {
	                      hasOneHorizontalTrace = true;
	                    }
	                  }
	                }
	                var hasUserCalledHover = !eventTarget;
	                var xpx, ypx;
	                if (hasUserCalledHover) {
	                  if ("xpx" in evt) xpx = evt.xpx;
	                  else xpx = xaArray[0]._length / 2;
	                  if ("ypx" in evt) ypx = evt.ypx;
	                  else ypx = yaArray[0]._length / 2;
	                } else {
	                  if (Events.triggerHandler(gd, "plotly_beforehover", evt) === false) {
	                    return;
	                  }
	                  var dbb = eventTarget.getBoundingClientRect();
	                  xpx = evt.clientX - dbb.left;
	                  ypx = evt.clientY - dbb.top;
	                  fullLayout._calcInverseTransform(gd);
	                  var transformedCoords = Lib.apply3DTransform(fullLayout._invTransform)(xpx, ypx);
	                  xpx = transformedCoords[0];
	                  ypx = transformedCoords[1];
	                  if (xpx < 0 || xpx > xaArray[0]._length || ypx < 0 || ypx > yaArray[0]._length) {
	                    return dragElement.unhoverRaw(gd, evt);
	                  }
	                }
	                evt.pointerX = xpx + xaArray[0]._offset;
	                evt.pointerY = ypx + yaArray[0]._offset;
	                if ("xval" in evt) xvalArray = helpers.flat(subplots, evt.xval);
	                else xvalArray = helpers.p2c(xaArray, xpx);
	                if ("yval" in evt) yvalArray = helpers.flat(subplots, evt.yval);
	                else yvalArray = helpers.p2c(yaArray, ypx);
	                if (!isNumeric(xvalArray[0]) || !isNumeric(yvalArray[0])) {
	                  Lib.warn("Fx.hover failed", evt, gd);
	                  return dragElement.unhoverRaw(gd, evt);
	                }
	              }
	              var distance = Infinity;
	              function findHoverPoints(customXVal, customYVal) {
	                for (curvenum = 0; curvenum < searchData.length; curvenum++) {
	                  cd = searchData[curvenum];
	                  if (!cd || !cd[0] || !cd[0].trace) continue;
	                  trace = cd[0].trace;
	                  if (trace.visible !== true || trace._length === 0) continue;
	                  if (["carpet", "contourcarpet"].indexOf(trace._module.name) !== -1) continue;
	                  if (trace.type === "splom") {
	                    subploti = 0;
	                    subplotId = subplots[subploti];
	                  } else {
	                    subplotId = helpers.getSubplot(trace);
	                    subploti = subplots.indexOf(subplotId);
	                  }
	                  _mode = hovermode;
	                  if (helpers.isUnifiedHover(_mode)) {
	                    _mode = _mode.charAt(0);
	                  }
	                  pointData = {
	                    // trace properties
	                    cd,
	                    trace,
	                    xa: xaArray[subploti],
	                    ya: yaArray[subploti],
	                    // max distances for hover and spikes - for points that want to show but do not
	                    // want to override other points, set distance/spikeDistance equal to max*Distance
	                    // and it will not get filtered out but it will be guaranteed to have a greater
	                    // distance than any point that calculated a real distance.
	                    maxHoverDistance: hoverdistance,
	                    maxSpikeDistance: spikedistance,
	                    // point properties - override all of these
	                    index: false,
	                    // point index in trace - only used by plotly.js hoverdata consumers
	                    distance: Math.min(distance, hoverdistance),
	                    // pixel distance or pseudo-distance
	                    // distance/pseudo-distance for spikes. This distance should always be calculated
	                    // as if in "closest" mode, and should only be set if this point should
	                    // generate a spike.
	                    spikeDistance: Infinity,
	                    // in some cases the spikes have different positioning from the hover label
	                    // they don't need x0/x1, just one position
	                    xSpike: undefined,
	                    ySpike: undefined,
	                    // where and how to display the hover label
	                    color: Color.defaultLine,
	                    // trace color
	                    name: trace.name,
	                    x0: undefined,
	                    x1: undefined,
	                    y0: undefined,
	                    y1: undefined,
	                    xLabelVal: undefined,
	                    yLabelVal: undefined,
	                    zLabelVal: undefined,
	                    text: undefined
	                  };
	                  if (fullLayout[subplotId]) {
	                    pointData.subplot = fullLayout[subplotId]._subplot;
	                  }
	                  if (fullLayout._splomScenes && fullLayout._splomScenes[trace.uid]) {
	                    pointData.scene = fullLayout._splomScenes[trace.uid];
	                  }
	                  closedataPreviousLength = hoverData.length;
	                  if (_mode === "array") {
	                    var selection = evt[curvenum];
	                    if ("pointNumber" in selection) {
	                      pointData.index = selection.pointNumber;
	                      _mode = "closest";
	                    } else {
	                      _mode = "";
	                      if ("xval" in selection) {
	                        xval = selection.xval;
	                        _mode = "x";
	                      }
	                      if ("yval" in selection) {
	                        yval = selection.yval;
	                        _mode = _mode ? "closest" : "y";
	                      }
	                    }
	                  } else if (customXVal !== undefined && customYVal !== undefined) {
	                    xval = customXVal;
	                    yval = customYVal;
	                  } else {
	                    xval = xvalArray[subploti];
	                    yval = yvalArray[subploti];
	                  }
	                  if (hoverdistance !== 0) {
	                    if (trace._module && trace._module.hoverPoints) {
	                      var newPoints = trace._module.hoverPoints(pointData, xval, yval, _mode, {
	                        finiteRange: true,
	                        hoverLayer: fullLayout._hoverlayer
	                      });
	                      if (newPoints) {
	                        var newPoint;
	                        for (var newPointNum = 0; newPointNum < newPoints.length; newPointNum++) {
	                          newPoint = newPoints[newPointNum];
	                          if (isNumeric(newPoint.x0) && isNumeric(newPoint.y0)) {
	                            hoverData.push(cleanPoint(newPoint, hovermode));
	                          }
	                        }
	                      }
	                    } else {
	                      Lib.log("Unrecognized trace type in hover:", trace);
	                    }
	                  }
	                  if (hovermode === "closest" && hoverData.length > closedataPreviousLength) {
	                    hoverData.splice(0, closedataPreviousLength);
	                    distance = hoverData[0].distance;
	                  }
	                  if (hasCartesian && spikedistance !== 0) {
	                    if (hoverData.length === 0) {
	                      pointData.distance = spikedistance;
	                      pointData.index = false;
	                      var closestPoints = trace._module.hoverPoints(pointData, xval, yval, "closest", {
	                        hoverLayer: fullLayout._hoverlayer
	                      });
	                      if (closestPoints) {
	                        closestPoints = closestPoints.filter(function(point) {
	                          return point.spikeDistance <= spikedistance;
	                        });
	                      }
	                      if (closestPoints && closestPoints.length) {
	                        var tmpPoint;
	                        var closestVPoints = closestPoints.filter(function(point) {
	                          return point.xa.showspikes && point.xa.spikesnap !== "hovered data";
	                        });
	                        if (closestVPoints.length) {
	                          var closestVPt = closestVPoints[0];
	                          if (isNumeric(closestVPt.x0) && isNumeric(closestVPt.y0)) {
	                            tmpPoint = fillSpikePoint(closestVPt);
	                            if (!spikePoints.vLinePoint || spikePoints.vLinePoint.spikeDistance > tmpPoint.spikeDistance) {
	                              spikePoints.vLinePoint = tmpPoint;
	                            }
	                          }
	                        }
	                        var closestHPoints = closestPoints.filter(function(point) {
	                          return point.ya.showspikes && point.ya.spikesnap !== "hovered data";
	                        });
	                        if (closestHPoints.length) {
	                          var closestHPt = closestHPoints[0];
	                          if (isNumeric(closestHPt.x0) && isNumeric(closestHPt.y0)) {
	                            tmpPoint = fillSpikePoint(closestHPt);
	                            if (!spikePoints.hLinePoint || spikePoints.hLinePoint.spikeDistance > tmpPoint.spikeDistance) {
	                              spikePoints.hLinePoint = tmpPoint;
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	              findHoverPoints();
	              function selectClosestPoint(pointsData, spikedistance2, spikeOnWinning2) {
	                var resultPoint = null;
	                var minDistance = Infinity;
	                var thisSpikeDistance;
	                for (var i2 = 0; i2 < pointsData.length; i2++) {
	                  thisSpikeDistance = pointsData[i2].spikeDistance;
	                  if (spikeOnWinning2 && i2 === 0) thisSpikeDistance = -Infinity;
	                  if (thisSpikeDistance <= minDistance && thisSpikeDistance <= spikedistance2) {
	                    resultPoint = pointsData[i2];
	                    minDistance = thisSpikeDistance;
	                  }
	                }
	                return resultPoint;
	              }
	              function fillSpikePoint(point) {
	                if (!point) return null;
	                return {
	                  xa: point.xa,
	                  ya: point.ya,
	                  x: point.xSpike !== undefined ? point.xSpike : (point.x0 + point.x1) / 2,
	                  y: point.ySpike !== undefined ? point.ySpike : (point.y0 + point.y1) / 2,
	                  distance: point.distance,
	                  spikeDistance: point.spikeDistance,
	                  curveNumber: point.trace.index,
	                  color: point.color,
	                  pointNumber: point.index
	                };
	              }
	              var spikelineOpts = {
	                fullLayout,
	                container: fullLayout._hoverlayer,
	                event: evt
	              };
	              gd._spikepoints;
	              var newspikepoints = {
	                vLinePoint: spikePoints.vLinePoint,
	                hLinePoint: spikePoints.hLinePoint
	              };
	              gd._spikepoints = newspikepoints;
	              var sortHoverData = function() {
	                hoverData.sort(function(d1, d2) {
	                  return d1.distance - d2.distance;
	                });
	                hoverData = orderRangePoints(hoverData, hovermode);
	              };
	              sortHoverData();
	              var axLetter = hovermode.charAt(0);
	              var spikeOnWinning = (axLetter === "x" || axLetter === "y") && hoverData[0] && cartesianScatterPoints[hoverData[0].trace.type];
	              if (hasCartesian && spikedistance !== 0) {
	                if (hoverData.length !== 0) {
	                  var tmpHPointData = hoverData.filter(function(point) {
	                    return point.ya.showspikes;
	                  });
	                  var tmpHPoint = selectClosestPoint(tmpHPointData, spikedistance, spikeOnWinning);
	                  spikePoints.hLinePoint = fillSpikePoint(tmpHPoint);
	                  var tmpVPointData = hoverData.filter(function(point) {
	                    return point.xa.showspikes;
	                  });
	                  var tmpVPoint = selectClosestPoint(tmpVPointData, spikedistance, spikeOnWinning);
	                  spikePoints.vLinePoint = fillSpikePoint(tmpVPoint);
	                }
	              }
	              if (hoverData.length === 0) {
	                var result = dragElement.unhoverRaw(gd, evt);
	                if (hasCartesian && (spikePoints.hLinePoint !== null || spikePoints.vLinePoint !== null)) {
	                  if (spikesChanged()) {
	                    createSpikelines(gd, spikePoints, spikelineOpts);
	                  }
	                }
	                return result;
	              }
	              if (hasCartesian) {
	                if (spikesChanged()) {
	                  createSpikelines(gd, spikePoints, spikelineOpts);
	                }
	              }
	              if (helpers.isXYhover(_mode) && hoverData[0].length !== 0 && hoverData[0].trace.type !== "splom") {
	                var winningPoint = hoverData[0];
	                if (multipleHoverPoints[winningPoint.trace.type]) {
	                  hoverData = hoverData.filter(function(d) {
	                    return d.trace.index === winningPoint.trace.index;
	                  });
	                } else {
	                  hoverData = [winningPoint];
	                }
	                var initLen = hoverData.length;
	                var winX = getCoord("x", winningPoint, fullLayout);
	                var winY = getCoord("y", winningPoint, fullLayout);
	                findHoverPoints(winX, winY);
	                var finalPoints = [];
	                var seen = {};
	                var id = 0;
	                var insert = function(newHd) {
	                  var key = multipleHoverPoints[newHd.trace.type] ? hoverDataKey(newHd) : newHd.trace.index;
	                  if (!seen[key]) {
	                    id++;
	                    seen[key] = id;
	                    finalPoints.push(newHd);
	                  } else {
	                    var oldId = seen[key] - 1;
	                    var oldHd = finalPoints[oldId];
	                    if (oldId > 0 && Math.abs(newHd.distance) < Math.abs(oldHd.distance)) {
	                      finalPoints[oldId] = newHd;
	                    }
	                  }
	                };
	                var k;
	                for (k = 0; k < initLen; k++) {
	                  insert(hoverData[k]);
	                }
	                for (k = hoverData.length - 1; k > initLen - 1; k--) {
	                  insert(hoverData[k]);
	                }
	                hoverData = finalPoints;
	                sortHoverData();
	              }
	              var oldhoverdata = gd._hoverdata;
	              var newhoverdata = [];
	              var gTop = getTopOffset(gd);
	              var gLeft = getLeftOffset(gd);
	              for (itemnum = 0; itemnum < hoverData.length; itemnum++) {
	                var pt = hoverData[itemnum];
	                var eventData = helpers.makeEventData(pt, pt.trace, pt.cd);
	                if (pt.hovertemplate !== false) {
	                  var ht = false;
	                  if (pt.cd[pt.index] && pt.cd[pt.index].ht) {
	                    ht = pt.cd[pt.index].ht;
	                  }
	                  pt.hovertemplate = ht || pt.trace.hovertemplate || false;
	                }
	                if (pt.xa && pt.ya) {
	                  var _x0 = pt.x0 + pt.xa._offset;
	                  var _x1 = pt.x1 + pt.xa._offset;
	                  var _y0 = pt.y0 + pt.ya._offset;
	                  var _y1 = pt.y1 + pt.ya._offset;
	                  var x0 = Math.min(_x0, _x1);
	                  var x1 = Math.max(_x0, _x1);
	                  var y0 = Math.min(_y0, _y1);
	                  var y1 = Math.max(_y0, _y1);
	                  eventData.bbox = {
	                    x0: x0 + gLeft,
	                    x1: x1 + gLeft,
	                    y0: y0 + gTop,
	                    y1: y1 + gTop
	                  };
	                }
	                pt.eventData = [eventData];
	                newhoverdata.push(eventData);
	              }
	              gd._hoverdata = newhoverdata;
	              var rotateLabels = hovermode === "y" && (searchData.length > 1 || hoverData.length > 1) || hovermode === "closest" && hasOneHorizontalTrace && hoverData.length > 1;
	              var bgColor = Color.combine(fullLayout.plot_bgcolor || Color.background, fullLayout.paper_bgcolor);
	              var hoverText = createHoverText(hoverData, {
	                gd,
	                hovermode,
	                rotateLabels,
	                bgColor,
	                container: fullLayout._hoverlayer,
	                outerContainer: fullLayout._paper.node(),
	                commonLabelOpts: fullLayout.hoverlabel,
	                hoverdistance: fullLayout.hoverdistance
	              });
	              var hoverLabels = hoverText.hoverLabels;
	              if (!helpers.isUnifiedHover(hovermode)) {
	                hoverAvoidOverlaps(hoverLabels, rotateLabels, fullLayout, hoverText.commonLabelBoundingBox);
	                alignHoverText(hoverLabels, rotateLabels, fullLayout._invScaleX, fullLayout._invScaleY);
	              }
	              if (eventTarget && eventTarget.tagName) {
	                var hasClickToShow = Registry.getComponentMethod("annotations", "hasClickToShow")(gd, newhoverdata);
	                overrideCursor(d3.select(eventTarget), hasClickToShow ? "pointer" : "");
	              }
	              if (!eventTarget || noHoverEvent || !hoverChanged(gd, evt, oldhoverdata)) return;
	              if (oldhoverdata) {
	                gd.emit("plotly_unhover", {
	                  event: evt,
	                  points: oldhoverdata
	                });
	              }
	              gd.emit("plotly_hover", {
	                event: evt,
	                points: gd._hoverdata,
	                xaxes: xaArray,
	                yaxes: yaArray,
	                xvals: xvalArray,
	                yvals: yvalArray
	              });
	            }
	            function hoverDataKey(d) {
	              return [d.trace.index, d.index, d.x0, d.y0, d.name, d.attr, d.xa ? d.xa._id : "", d.ya ? d.ya._id : ""].join(",");
	            }
	            var EXTRA_STRING_REGEX = /<extra>([\s\S]*)<\/extra>/;
	            function createHoverText(hoverData, opts) {
	              var gd = opts.gd;
	              var fullLayout = gd._fullLayout;
	              var hovermode = opts.hovermode;
	              var rotateLabels = opts.rotateLabels;
	              var bgColor = opts.bgColor;
	              var container = opts.container;
	              var outerContainer = opts.outerContainer;
	              var commonLabelOpts = opts.commonLabelOpts || {};
	              if (hoverData.length === 0) return [[]];
	              var fontFamily = opts.fontFamily || constants.HOVERFONT;
	              var fontSize = opts.fontSize || constants.HOVERFONTSIZE;
	              var c0 = hoverData[0];
	              var xa = c0.xa;
	              var ya = c0.ya;
	              var axLetter = hovermode.charAt(0);
	              var axLabel = axLetter + "Label";
	              var t0 = c0[axLabel];
	              if (t0 === undefined && xa.type === "multicategory") {
	                for (var q = 0; q < hoverData.length; q++) {
	                  t0 = hoverData[q][axLabel];
	                  if (t0 !== undefined) break;
	                }
	              }
	              var outerContainerBB = getBoundingClientRect(gd, outerContainer);
	              var outerTop = outerContainerBB.top;
	              var outerWidth = outerContainerBB.width;
	              var outerHeight = outerContainerBB.height;
	              var showCommonLabel = t0 !== undefined && c0.distance <= opts.hoverdistance && (hovermode === "x" || hovermode === "y");
	              if (showCommonLabel) {
	                var allHaveZ = true;
	                var i, traceHoverinfo;
	                for (i = 0; i < hoverData.length; i++) {
	                  if (allHaveZ && hoverData[i].zLabel === undefined) allHaveZ = false;
	                  traceHoverinfo = hoverData[i].hoverinfo || hoverData[i].trace.hoverinfo;
	                  if (traceHoverinfo) {
	                    var parts = Array.isArray(traceHoverinfo) ? traceHoverinfo : traceHoverinfo.split("+");
	                    if (parts.indexOf("all") === -1 && parts.indexOf(hovermode) === -1) {
	                      showCommonLabel = false;
	                      break;
	                    }
	                  }
	                }
	                if (allHaveZ) showCommonLabel = false;
	              }
	              var commonLabel = container.selectAll("g.axistext").data(showCommonLabel ? [0] : []);
	              commonLabel.enter().append("g").classed("axistext", true);
	              commonLabel.exit().remove();
	              var commonLabelRect = {
	                minX: 0,
	                maxX: 0,
	                minY: 0,
	                maxY: 0
	              };
	              commonLabel.each(function() {
	                var label = d3.select(this);
	                var lpath = Lib.ensureSingle(label, "path", "", function(s) {
	                  s.style({
	                    "stroke-width": "1px"
	                  });
	                });
	                var ltext = Lib.ensureSingle(label, "text", "", function(s) {
	                  s.attr("data-notex", 1);
	                });
	                var commonBgColor = commonLabelOpts.bgcolor || Color.defaultLine;
	                var commonStroke = commonLabelOpts.bordercolor || Color.contrast(commonBgColor);
	                var contrastColor = Color.contrast(commonBgColor);
	                var commonLabelFont = {
	                  family: commonLabelOpts.font.family || fontFamily,
	                  size: commonLabelOpts.font.size || fontSize,
	                  color: commonLabelOpts.font.color || contrastColor
	                };
	                lpath.style({
	                  fill: commonBgColor,
	                  stroke: commonStroke
	                });
	                ltext.text(t0).call(Drawing.font, commonLabelFont).call(svgTextUtils.positionText, 0, 0).call(svgTextUtils.convertToTspans, gd);
	                label.attr("transform", "");
	                var tbb2 = getBoundingClientRect(gd, ltext.node());
	                var lx2, ly2;
	                if (hovermode === "x") {
	                  var topsign = xa.side === "top" ? "-" : "";
	                  ltext.attr("text-anchor", "middle").call(svgTextUtils.positionText, 0, xa.side === "top" ? outerTop - tbb2.bottom - HOVERARROWSIZE - HOVERTEXTPAD : outerTop - tbb2.top + HOVERARROWSIZE + HOVERTEXTPAD);
	                  lx2 = xa._offset + (c0.x0 + c0.x1) / 2;
	                  ly2 = ya._offset + (xa.side === "top" ? 0 : ya._length);
	                  var halfWidth = tbb2.width / 2 + HOVERTEXTPAD;
	                  if (lx2 < halfWidth) {
	                    lx2 = halfWidth;
	                    lpath.attr("d", "M-" + (halfWidth - HOVERARROWSIZE) + ",0L-" + (halfWidth - HOVERARROWSIZE * 2) + "," + topsign + HOVERARROWSIZE + "H" + halfWidth + "v" + topsign + (HOVERTEXTPAD * 2 + tbb2.height) + "H-" + halfWidth + "V" + topsign + HOVERARROWSIZE + "Z");
	                  } else if (lx2 > fullLayout.width - halfWidth) {
	                    lx2 = fullLayout.width - halfWidth;
	                    lpath.attr("d", "M" + (halfWidth - HOVERARROWSIZE) + ",0L" + halfWidth + "," + topsign + HOVERARROWSIZE + "v" + topsign + (HOVERTEXTPAD * 2 + tbb2.height) + "H-" + halfWidth + "V" + topsign + HOVERARROWSIZE + "H" + (halfWidth - HOVERARROWSIZE * 2) + "Z");
	                  } else {
	                    lpath.attr("d", "M0,0L" + HOVERARROWSIZE + "," + topsign + HOVERARROWSIZE + "H" + halfWidth + "v" + topsign + (HOVERTEXTPAD * 2 + tbb2.height) + "H-" + halfWidth + "V" + topsign + HOVERARROWSIZE + "H-" + HOVERARROWSIZE + "Z");
	                  }
	                  commonLabelRect.minX = lx2 - halfWidth;
	                  commonLabelRect.maxX = lx2 + halfWidth;
	                  if (xa.side === "top") {
	                    commonLabelRect.minY = ly2 - (HOVERTEXTPAD * 2 + tbb2.height);
	                    commonLabelRect.maxY = ly2 - HOVERTEXTPAD;
	                  } else {
	                    commonLabelRect.minY = ly2 + HOVERTEXTPAD;
	                    commonLabelRect.maxY = ly2 + (HOVERTEXTPAD * 2 + tbb2.height);
	                  }
	                } else {
	                  var anchor;
	                  var sgn;
	                  var leftsign;
	                  if (ya.side === "right") {
	                    anchor = "start";
	                    sgn = 1;
	                    leftsign = "";
	                    lx2 = xa._offset + xa._length;
	                  } else {
	                    anchor = "end";
	                    sgn = -1;
	                    leftsign = "-";
	                    lx2 = xa._offset;
	                  }
	                  ly2 = ya._offset + (c0.y0 + c0.y1) / 2;
	                  ltext.attr("text-anchor", anchor);
	                  lpath.attr("d", "M0,0L" + leftsign + HOVERARROWSIZE + "," + HOVERARROWSIZE + "V" + (HOVERTEXTPAD + tbb2.height / 2) + "h" + leftsign + (HOVERTEXTPAD * 2 + tbb2.width) + "V-" + (HOVERTEXTPAD + tbb2.height / 2) + "H" + leftsign + HOVERARROWSIZE + "V-" + HOVERARROWSIZE + "Z");
	                  commonLabelRect.minY = ly2 - (HOVERTEXTPAD + tbb2.height / 2);
	                  commonLabelRect.maxY = ly2 + (HOVERTEXTPAD + tbb2.height / 2);
	                  if (ya.side === "right") {
	                    commonLabelRect.minX = lx2 + HOVERARROWSIZE;
	                    commonLabelRect.maxX = lx2 + HOVERARROWSIZE + (HOVERTEXTPAD * 2 + tbb2.width);
	                  } else {
	                    commonLabelRect.minX = lx2 - HOVERARROWSIZE - (HOVERTEXTPAD * 2 + tbb2.width);
	                    commonLabelRect.maxX = lx2 - HOVERARROWSIZE;
	                  }
	                  var halfHeight = tbb2.height / 2;
	                  var lty = outerTop - tbb2.top - halfHeight;
	                  var clipId = "clip" + fullLayout._uid + "commonlabel" + ya._id;
	                  var clipPath;
	                  if (lx2 < tbb2.width + 2 * HOVERTEXTPAD + HOVERARROWSIZE) {
	                    clipPath = "M-" + (HOVERARROWSIZE + HOVERTEXTPAD) + "-" + halfHeight + "h-" + (tbb2.width - HOVERTEXTPAD) + "V" + halfHeight + "h" + (tbb2.width - HOVERTEXTPAD) + "Z";
	                    var ltx = tbb2.width - lx2 + HOVERTEXTPAD;
	                    svgTextUtils.positionText(ltext, ltx, lty);
	                    if (anchor === "end") {
	                      ltext.selectAll("tspan").each(function() {
	                        var s = d3.select(this);
	                        var dummy = Drawing.tester.append("text").text(s.text()).call(Drawing.font, commonLabelFont);
	                        var dummyBB = getBoundingClientRect(gd, dummy.node());
	                        if (Math.round(dummyBB.width) < Math.round(tbb2.width)) {
	                          s.attr("x", ltx - dummyBB.width);
	                        }
	                        dummy.remove();
	                      });
	                    }
	                  } else {
	                    svgTextUtils.positionText(ltext, sgn * (HOVERTEXTPAD + HOVERARROWSIZE), lty);
	                    clipPath = null;
	                  }
	                  var textClip = fullLayout._topclips.selectAll("#" + clipId).data(clipPath ? [0] : []);
	                  textClip.enter().append("clipPath").attr("id", clipId).append("path");
	                  textClip.exit().remove();
	                  textClip.select("path").attr("d", clipPath);
	                  Drawing.setClipUrl(ltext, clipPath ? clipId : null, gd);
	                }
	                label.attr("transform", strTranslate(lx2, ly2));
	              });
	              if (helpers.isUnifiedHover(hovermode)) {
	                container.selectAll("g.hovertext").remove();
	                var groupedHoverData = hoverData.filter(function(data) {
	                  return data.hoverinfo !== "none";
	                });
	                if (groupedHoverData.length === 0) return [];
	                var hoverlabel = fullLayout.hoverlabel;
	                var font = hoverlabel.font;
	                var mockLayoutIn = {
	                  showlegend: true,
	                  legend: {
	                    title: {
	                      text: t0,
	                      font
	                    },
	                    font,
	                    bgcolor: hoverlabel.bgcolor,
	                    bordercolor: hoverlabel.bordercolor,
	                    borderwidth: 1,
	                    tracegroupgap: 7,
	                    traceorder: fullLayout.legend ? fullLayout.legend.traceorder : undefined,
	                    orientation: "v"
	                  }
	                };
	                var mockLayoutOut = {
	                  font
	                };
	                legendSupplyDefaults(mockLayoutIn, mockLayoutOut, gd._fullData);
	                var mockLegend = mockLayoutOut.legend;
	                mockLegend.entries = [];
	                for (var j = 0; j < groupedHoverData.length; j++) {
	                  var pt = groupedHoverData[j];
	                  if (pt.hoverinfo === "none") continue;
	                  var texts = getHoverLabelText(pt, true, hovermode, fullLayout, t0);
	                  var text = texts[0];
	                  var name2 = texts[1];
	                  pt.name = name2;
	                  if (name2 !== "") {
	                    pt.text = name2 + " : " + text;
	                  } else {
	                    pt.text = text;
	                  }
	                  var cd = pt.cd[pt.index];
	                  if (cd) {
	                    if (cd.mc) pt.mc = cd.mc;
	                    if (cd.mcc) pt.mc = cd.mcc;
	                    if (cd.mlc) pt.mlc = cd.mlc;
	                    if (cd.mlcc) pt.mlc = cd.mlcc;
	                    if (cd.mlw) pt.mlw = cd.mlw;
	                    if (cd.mrc) pt.mrc = cd.mrc;
	                    if (cd.dir) pt.dir = cd.dir;
	                  }
	                  pt._distinct = true;
	                  mockLegend.entries.push([pt]);
	                }
	                mockLegend.entries.sort(function(a, b) {
	                  return a[0].trace.index - b[0].trace.index;
	                });
	                mockLegend.layer = container;
	                mockLegend._inHover = true;
	                mockLegend._groupTitleFont = hoverlabel.grouptitlefont;
	                legendDraw(gd, mockLegend);
	                var legendContainer = container.select("g.legend");
	                var tbb = getBoundingClientRect(gd, legendContainer.node());
	                var tWidth = tbb.width + 2 * HOVERTEXTPAD;
	                var tHeight = tbb.height + 2 * HOVERTEXTPAD;
	                var winningPoint = groupedHoverData[0];
	                var avgX = (winningPoint.x0 + winningPoint.x1) / 2;
	                var avgY = (winningPoint.y0 + winningPoint.y1) / 2;
	                var pointWon = !(Registry.traceIs(winningPoint.trace, "bar-like") || Registry.traceIs(winningPoint.trace, "box-violin"));
	                var lyBottom, lyTop;
	                if (axLetter === "y") {
	                  if (pointWon) {
	                    lyTop = avgY - HOVERTEXTPAD;
	                    lyBottom = avgY + HOVERTEXTPAD;
	                  } else {
	                    lyTop = Math.min.apply(null, groupedHoverData.map(function(c) {
	                      return Math.min(c.y0, c.y1);
	                    }));
	                    lyBottom = Math.max.apply(null, groupedHoverData.map(function(c) {
	                      return Math.max(c.y0, c.y1);
	                    }));
	                  }
	                } else {
	                  lyTop = lyBottom = Lib.mean(groupedHoverData.map(function(c) {
	                    return (c.y0 + c.y1) / 2;
	                  })) - tHeight / 2;
	                }
	                var lxRight, lxLeft;
	                if (axLetter === "x") {
	                  if (pointWon) {
	                    lxRight = avgX + HOVERTEXTPAD;
	                    lxLeft = avgX - HOVERTEXTPAD;
	                  } else {
	                    lxRight = Math.max.apply(null, groupedHoverData.map(function(c) {
	                      return Math.max(c.x0, c.x1);
	                    }));
	                    lxLeft = Math.min.apply(null, groupedHoverData.map(function(c) {
	                      return Math.min(c.x0, c.x1);
	                    }));
	                  }
	                } else {
	                  lxRight = lxLeft = Lib.mean(groupedHoverData.map(function(c) {
	                    return (c.x0 + c.x1) / 2;
	                  })) - tWidth / 2;
	                }
	                var xOffset = xa._offset;
	                var yOffset = ya._offset;
	                lyBottom += yOffset;
	                lxRight += xOffset;
	                lxLeft += xOffset - tWidth;
	                lyTop += yOffset - tHeight;
	                var lx, ly;
	                if (lxRight + tWidth < outerWidth && lxRight >= 0) {
	                  lx = lxRight;
	                } else if (lxLeft + tWidth < outerWidth && lxLeft >= 0) {
	                  lx = lxLeft;
	                } else if (xOffset + tWidth < outerWidth) {
	                  lx = xOffset;
	                } else {
	                  if (lxRight - avgX < avgX - lxLeft + tWidth) {
	                    lx = outerWidth - tWidth;
	                  } else {
	                    lx = 0;
	                  }
	                }
	                lx += HOVERTEXTPAD;
	                if (lyBottom + tHeight < outerHeight && lyBottom >= 0) {
	                  ly = lyBottom;
	                } else if (lyTop + tHeight < outerHeight && lyTop >= 0) {
	                  ly = lyTop;
	                } else if (yOffset + tHeight < outerHeight) {
	                  ly = yOffset;
	                } else {
	                  if (lyBottom - avgY < avgY - lyTop + tHeight) {
	                    ly = outerHeight - tHeight;
	                  } else {
	                    ly = 0;
	                  }
	                }
	                ly += HOVERTEXTPAD;
	                legendContainer.attr("transform", strTranslate(lx - 1, ly - 1));
	                return legendContainer;
	              }
	              var hoverLabels = container.selectAll("g.hovertext").data(hoverData, function(d) {
	                return hoverDataKey(d);
	              });
	              hoverLabels.enter().append("g").classed("hovertext", true).each(function() {
	                var g = d3.select(this);
	                g.append("rect").call(Color.fill, Color.addOpacity(bgColor, 0.8));
	                g.append("text").classed("name", true);
	                g.append("path").style("stroke-width", "1px");
	                g.append("text").classed("nums", true).call(Drawing.font, fontFamily, fontSize);
	              });
	              hoverLabels.exit().remove();
	              hoverLabels.each(function(d) {
	                var g = d3.select(this).attr("transform", "");
	                var dColor = d.color;
	                if (Array.isArray(dColor)) {
	                  dColor = dColor[d.eventData[0].pointNumber];
	                }
	                var color0 = d.bgcolor || dColor;
	                var numsColor = Color.combine(Color.opacity(color0) ? color0 : Color.defaultLine, bgColor);
	                var nameColor = Color.combine(Color.opacity(dColor) ? dColor : Color.defaultLine, bgColor);
	                var contrastColor = d.borderColor || Color.contrast(numsColor);
	                var texts2 = getHoverLabelText(d, showCommonLabel, hovermode, fullLayout, t0, g);
	                var text2 = texts2[0];
	                var name3 = texts2[1];
	                var tx = g.select("text.nums").call(Drawing.font, d.fontFamily || fontFamily, d.fontSize || fontSize, d.fontColor || contrastColor).text(text2).attr("data-notex", 1).call(svgTextUtils.positionText, 0, 0).call(svgTextUtils.convertToTspans, gd);
	                var tx2 = g.select("text.name");
	                var tx2width = 0;
	                var tx2height = 0;
	                if (name3 && name3 !== text2) {
	                  tx2.call(Drawing.font, d.fontFamily || fontFamily, d.fontSize || fontSize, nameColor).text(name3).attr("data-notex", 1).call(svgTextUtils.positionText, 0, 0).call(svgTextUtils.convertToTspans, gd);
	                  var t2bb = getBoundingClientRect(gd, tx2.node());
	                  tx2width = t2bb.width + 2 * HOVERTEXTPAD;
	                  tx2height = t2bb.height + 2 * HOVERTEXTPAD;
	                } else {
	                  tx2.remove();
	                  g.select("rect").remove();
	                }
	                g.select("path").style({
	                  fill: numsColor,
	                  stroke: contrastColor
	                });
	                var htx = d.xa._offset + (d.x0 + d.x1) / 2;
	                var hty = d.ya._offset + (d.y0 + d.y1) / 2;
	                var dx = Math.abs(d.x1 - d.x0);
	                var dy = Math.abs(d.y1 - d.y0);
	                var tbb2 = getBoundingClientRect(gd, tx.node());
	                var tbbWidth = tbb2.width / fullLayout._invScaleX;
	                var tbbHeight = tbb2.height / fullLayout._invScaleY;
	                d.ty0 = (outerTop - tbb2.top) / fullLayout._invScaleY;
	                d.bx = tbbWidth + 2 * HOVERTEXTPAD;
	                d.by = Math.max(tbbHeight + 2 * HOVERTEXTPAD, tx2height);
	                d.anchor = "start";
	                d.txwidth = tbbWidth;
	                d.tx2width = tx2width;
	                d.offset = 0;
	                var txTotalWidth = (tbbWidth + HOVERARROWSIZE + HOVERTEXTPAD + tx2width) * fullLayout._invScaleX;
	                var anchorStartOK, anchorEndOK;
	                if (rotateLabels) {
	                  d.pos = htx;
	                  anchorStartOK = hty + dy / 2 + txTotalWidth <= outerHeight;
	                  anchorEndOK = hty - dy / 2 - txTotalWidth >= 0;
	                  if ((d.idealAlign === "top" || !anchorStartOK) && anchorEndOK) {
	                    hty -= dy / 2;
	                    d.anchor = "end";
	                  } else if (anchorStartOK) {
	                    hty += dy / 2;
	                    d.anchor = "start";
	                  } else {
	                    d.anchor = "middle";
	                  }
	                  d.crossPos = hty;
	                } else {
	                  d.pos = hty;
	                  anchorStartOK = htx + dx / 2 + txTotalWidth <= outerWidth;
	                  anchorEndOK = htx - dx / 2 - txTotalWidth >= 0;
	                  if ((d.idealAlign === "left" || !anchorStartOK) && anchorEndOK) {
	                    htx -= dx / 2;
	                    d.anchor = "end";
	                  } else if (anchorStartOK) {
	                    htx += dx / 2;
	                    d.anchor = "start";
	                  } else {
	                    d.anchor = "middle";
	                    var txHalfWidth = txTotalWidth / 2;
	                    var overflowR = htx + txHalfWidth - outerWidth;
	                    var overflowL = htx - txHalfWidth;
	                    if (overflowR > 0) htx -= overflowR;
	                    if (overflowL < 0) htx += -overflowL;
	                  }
	                  d.crossPos = htx;
	                }
	                tx.attr("text-anchor", d.anchor);
	                if (tx2width) tx2.attr("text-anchor", d.anchor);
	                g.attr("transform", strTranslate(htx, hty) + (rotateLabels ? strRotate(YANGLE) : ""));
	              });
	              return {
	                hoverLabels,
	                commonLabelBoundingBox: commonLabelRect
	              };
	            }
	            function getHoverLabelText(d, showCommonLabel, hovermode, fullLayout, t0, g) {
	              var name2 = "";
	              var text = "";
	              if (d.nameOverride !== undefined) d.name = d.nameOverride;
	              if (d.name) {
	                if (d.trace._meta) {
	                  d.name = Lib.templateString(d.name, d.trace._meta);
	                }
	                name2 = plainText(d.name, d.nameLength);
	              }
	              var h0 = hovermode.charAt(0);
	              var h1 = h0 === "x" ? "y" : "x";
	              if (d.zLabel !== undefined) {
	                if (d.xLabel !== undefined) text += "x: " + d.xLabel + "<br>";
	                if (d.yLabel !== undefined) text += "y: " + d.yLabel + "<br>";
	                if (d.trace.type !== "choropleth" && d.trace.type !== "choroplethmapbox") {
	                  text += (text ? "z: " : "") + d.zLabel;
	                }
	              } else if (showCommonLabel && d[h0 + "Label"] === t0) {
	                text = d[h1 + "Label"] || "";
	              } else if (d.xLabel === undefined) {
	                if (d.yLabel !== undefined && d.trace.type !== "scattercarpet") {
	                  text = d.yLabel;
	                }
	              } else if (d.yLabel === undefined) text = d.xLabel;
	              else text = "(" + d.xLabel + ", " + d.yLabel + ")";
	              if ((d.text || d.text === 0) && !Array.isArray(d.text)) {
	                text += (text ? "<br>" : "") + d.text;
	              }
	              if (d.extraText !== undefined) text += (text ? "<br>" : "") + d.extraText;
	              if (g && text === "" && !d.hovertemplate) {
	                if (name2 === "") g.remove();
	                text = name2;
	              }
	              var hovertemplate = d.hovertemplate || false;
	              if (hovertemplate) {
	                var labels = d.hovertemplateLabels || d;
	                if (d[h0 + "Label"] !== t0) {
	                  labels[h0 + "other"] = labels[h0 + "Val"];
	                  labels[h0 + "otherLabel"] = labels[h0 + "Label"];
	                }
	                text = Lib.hovertemplateString(hovertemplate, labels, fullLayout._d3locale, d.eventData[0] || {}, d.trace._meta);
	                text = text.replace(EXTRA_STRING_REGEX, function(match, extra) {
	                  name2 = plainText(extra, d.nameLength);
	                  return "";
	                });
	              }
	              return [text, name2];
	            }
	            function hoverAvoidOverlaps(hoverLabels, rotateLabels, fullLayout, commonLabelBoundingBox) {
	              var axKey = rotateLabels ? "xa" : "ya";
	              var crossAxKey = rotateLabels ? "ya" : "xa";
	              var nummoves = 0;
	              var axSign = 1;
	              var nLabels = hoverLabels.size();
	              var pointgroups = new Array(nLabels);
	              var k = 0;
	              var axisLabelMinX = commonLabelBoundingBox.minX;
	              var axisLabelMaxX = commonLabelBoundingBox.maxX;
	              var axisLabelMinY = commonLabelBoundingBox.minY;
	              var axisLabelMaxY = commonLabelBoundingBox.maxY;
	              var pX = function(x) {
	                return x * fullLayout._invScaleX;
	              };
	              var pY = function(y) {
	                return y * fullLayout._invScaleY;
	              };
	              hoverLabels.each(function(d) {
	                var ax = d[axKey];
	                var crossAx = d[crossAxKey];
	                var axIsX = ax._id.charAt(0) === "x";
	                var rng = ax.range;
	                if (k === 0 && rng && rng[0] > rng[1] !== axIsX) {
	                  axSign = -1;
	                }
	                var pmin = 0;
	                var pmax = axIsX ? fullLayout.width : fullLayout.height;
	                if (fullLayout.hovermode === "x" || fullLayout.hovermode === "y") {
	                  var offsets = getHoverLabelOffsets(d, rotateLabels);
	                  var anchor = d.anchor;
	                  var horzSign = anchor === "end" ? -1 : 1;
	                  var labelMin;
	                  var labelMax;
	                  if (anchor === "middle") {
	                    labelMin = d.crossPos + (axIsX ? pY(offsets.y - d.by / 2) : pX(d.bx / 2 + d.tx2width / 2));
	                    labelMax = labelMin + (axIsX ? pY(d.by) : pX(d.bx));
	                  } else {
	                    if (axIsX) {
	                      labelMin = d.crossPos + pY(HOVERARROWSIZE + offsets.y) - pY(d.by / 2 - HOVERARROWSIZE);
	                      labelMax = labelMin + pY(d.by);
	                    } else {
	                      var startX = pX(horzSign * HOVERARROWSIZE + offsets.x);
	                      var endX = startX + pX(horzSign * d.bx);
	                      labelMin = d.crossPos + Math.min(startX, endX);
	                      labelMax = d.crossPos + Math.max(startX, endX);
	                    }
	                  }
	                  if (axIsX) {
	                    if (axisLabelMinY !== undefined && axisLabelMaxY !== undefined && Math.min(labelMax, axisLabelMaxY) - Math.max(labelMin, axisLabelMinY) > 1) {
	                      if (crossAx.side === "left") {
	                        pmin = crossAx._mainLinePosition;
	                        pmax = fullLayout.width;
	                      } else {
	                        pmax = crossAx._mainLinePosition;
	                      }
	                    }
	                  } else {
	                    if (axisLabelMinX !== undefined && axisLabelMaxX !== undefined && Math.min(labelMax, axisLabelMaxX) - Math.max(labelMin, axisLabelMinX) > 1) {
	                      if (crossAx.side === "top") {
	                        pmin = crossAx._mainLinePosition;
	                        pmax = fullLayout.height;
	                      } else {
	                        pmax = crossAx._mainLinePosition;
	                      }
	                    }
	                  }
	                }
	                pointgroups[k++] = [{
	                  datum: d,
	                  traceIndex: d.trace.index,
	                  dp: 0,
	                  pos: d.pos,
	                  posref: d.posref,
	                  size: d.by * (axIsX ? YFACTOR : 1) / 2,
	                  pmin,
	                  pmax
	                }];
	              });
	              pointgroups.sort(function(a, b) {
	                return a[0].posref - b[0].posref || // for equal positions, sort trace indices increasing or decreasing
	                // depending on whether the axis is reversed or not... so stacked
	                // traces will generally keep their order even if one trace adds
	                // nothing to the stack.
	                axSign * (b[0].traceIndex - a[0].traceIndex);
	              });
	              var donepositioning, topOverlap, bottomOverlap, i, j, pti, sumdp;
	              function constrainGroup(grp2) {
	                var minPt = grp2[0];
	                var maxPt = grp2[grp2.length - 1];
	                topOverlap = minPt.pmin - minPt.pos - minPt.dp + minPt.size;
	                bottomOverlap = maxPt.pos + maxPt.dp + maxPt.size - minPt.pmax;
	                if (topOverlap > 0.01) {
	                  for (j = grp2.length - 1; j >= 0; j--) grp2[j].dp += topOverlap;
	                  donepositioning = false;
	                }
	                if (bottomOverlap < 0.01) return;
	                if (topOverlap < -0.01) {
	                  for (j = grp2.length - 1; j >= 0; j--) grp2[j].dp -= bottomOverlap;
	                  donepositioning = false;
	                }
	                if (!donepositioning) return;
	                var deleteCount = 0;
	                for (i = 0; i < grp2.length; i++) {
	                  pti = grp2[i];
	                  if (pti.pos + pti.dp + pti.size > minPt.pmax) deleteCount++;
	                }
	                for (i = grp2.length - 1; i >= 0; i--) {
	                  if (deleteCount <= 0) break;
	                  pti = grp2[i];
	                  if (pti.pos > minPt.pmax - 1) {
	                    pti.del = true;
	                    deleteCount--;
	                  }
	                }
	                for (i = 0; i < grp2.length; i++) {
	                  if (deleteCount <= 0) break;
	                  pti = grp2[i];
	                  if (pti.pos < minPt.pmin + 1) {
	                    pti.del = true;
	                    deleteCount--;
	                    bottomOverlap = pti.size * 2;
	                    for (j = grp2.length - 1; j >= 0; j--) grp2[j].dp -= bottomOverlap;
	                  }
	                }
	                for (i = grp2.length - 1; i >= 0; i--) {
	                  if (deleteCount <= 0) break;
	                  pti = grp2[i];
	                  if (pti.pos + pti.dp + pti.size > minPt.pmax) {
	                    pti.del = true;
	                    deleteCount--;
	                  }
	                }
	              }
	              while (!donepositioning && nummoves <= nLabels) {
	                nummoves++;
	                donepositioning = true;
	                i = 0;
	                while (i < pointgroups.length - 1) {
	                  var g0 = pointgroups[i];
	                  var g1 = pointgroups[i + 1];
	                  var p0 = g0[g0.length - 1];
	                  var p1 = g1[0];
	                  topOverlap = p0.pos + p0.dp + p0.size - p1.pos - p1.dp + p1.size;
	                  if (topOverlap > 0.01 && p0.pmin === p1.pmin && p0.pmax === p1.pmax) {
	                    for (j = g1.length - 1; j >= 0; j--) g1[j].dp += topOverlap;
	                    g0.push.apply(g0, g1);
	                    pointgroups.splice(i + 1, 1);
	                    sumdp = 0;
	                    for (j = g0.length - 1; j >= 0; j--) sumdp += g0[j].dp;
	                    bottomOverlap = sumdp / g0.length;
	                    for (j = g0.length - 1; j >= 0; j--) g0[j].dp -= bottomOverlap;
	                    donepositioning = false;
	                  } else i++;
	                }
	                pointgroups.forEach(constrainGroup);
	              }
	              for (i = pointgroups.length - 1; i >= 0; i--) {
	                var grp = pointgroups[i];
	                for (j = grp.length - 1; j >= 0; j--) {
	                  var pt = grp[j];
	                  var hoverPt = pt.datum;
	                  hoverPt.offset = pt.dp;
	                  hoverPt.del = pt.del;
	                }
	              }
	            }
	            function getHoverLabelOffsets(hoverLabel, rotateLabels) {
	              var offsetX = 0;
	              var offsetY = hoverLabel.offset;
	              if (rotateLabels) {
	                offsetY *= -YSHIFTY;
	                offsetX = hoverLabel.offset * YSHIFTX;
	              }
	              return {
	                x: offsetX,
	                y: offsetY
	              };
	            }
	            function getTextShiftX(hoverLabel) {
	              var alignShift = {
	                start: 1,
	                end: -1,
	                middle: 0
	              }[hoverLabel.anchor];
	              var textShiftX = alignShift * (HOVERARROWSIZE + HOVERTEXTPAD);
	              var text2ShiftX = textShiftX + alignShift * (hoverLabel.txwidth + HOVERTEXTPAD);
	              var isMiddle = hoverLabel.anchor === "middle";
	              if (isMiddle) {
	                textShiftX -= hoverLabel.tx2width / 2;
	                text2ShiftX += hoverLabel.txwidth / 2 + HOVERTEXTPAD;
	              }
	              return {
	                alignShift,
	                textShiftX,
	                text2ShiftX
	              };
	            }
	            function alignHoverText(hoverLabels, rotateLabels, scaleX, scaleY) {
	              var pX = function(x) {
	                return x * scaleX;
	              };
	              var pY = function(y) {
	                return y * scaleY;
	              };
	              hoverLabels.each(function(d) {
	                var g = d3.select(this);
	                if (d.del) return g.remove();
	                var tx = g.select("text.nums");
	                var anchor = d.anchor;
	                var horzSign = anchor === "end" ? -1 : 1;
	                var shiftX = getTextShiftX(d);
	                var offsets = getHoverLabelOffsets(d, rotateLabels);
	                var offsetX = offsets.x;
	                var offsetY = offsets.y;
	                var isMiddle = anchor === "middle";
	                g.select("path").attr("d", isMiddle ? (
	                  // middle aligned: rect centered on data
	                  "M-" + pX(d.bx / 2 + d.tx2width / 2) + "," + pY(offsetY - d.by / 2) + "h" + pX(d.bx) + "v" + pY(d.by) + "h-" + pX(d.bx) + "Z"
	                ) : (
	                  // left or right aligned: side rect with arrow to data
	                  "M0,0L" + pX(horzSign * HOVERARROWSIZE + offsetX) + "," + pY(HOVERARROWSIZE + offsetY) + "v" + pY(d.by / 2 - HOVERARROWSIZE) + "h" + pX(horzSign * d.bx) + "v-" + pY(d.by) + "H" + pX(horzSign * HOVERARROWSIZE + offsetX) + "V" + pY(offsetY - HOVERARROWSIZE) + "Z"
	                ));
	                var posX = offsetX + shiftX.textShiftX;
	                var posY = offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD;
	                var textAlign = d.textAlign || "auto";
	                if (textAlign !== "auto") {
	                  if (textAlign === "left" && anchor !== "start") {
	                    tx.attr("text-anchor", "start");
	                    posX = isMiddle ? -d.bx / 2 - d.tx2width / 2 + HOVERTEXTPAD : -d.bx - HOVERTEXTPAD;
	                  } else if (textAlign === "right" && anchor !== "end") {
	                    tx.attr("text-anchor", "end");
	                    posX = isMiddle ? d.bx / 2 - d.tx2width / 2 - HOVERTEXTPAD : d.bx + HOVERTEXTPAD;
	                  }
	                }
	                tx.call(svgTextUtils.positionText, pX(posX), pY(posY));
	                if (d.tx2width) {
	                  g.select("text.name").call(svgTextUtils.positionText, pX(shiftX.text2ShiftX + shiftX.alignShift * HOVERTEXTPAD + offsetX), pY(offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD));
	                  g.select("rect").call(Drawing.setRect, pX(shiftX.text2ShiftX + (shiftX.alignShift - 1) * d.tx2width / 2 + offsetX), pY(offsetY - d.by / 2 - 1), pX(d.tx2width), pY(d.by + 2));
	                }
	              });
	            }
	            function cleanPoint(d, hovermode) {
	              var index = d.index;
	              var trace = d.trace || {};
	              var cd0 = d.cd[0];
	              var cd = d.cd[index] || {};
	              function pass(v) {
	                return v || isNumeric(v) && v === 0;
	              }
	              var getVal = Array.isArray(index) ? function(calcKey, traceKey) {
	                var v = Lib.castOption(cd0, index, calcKey);
	                return pass(v) ? v : Lib.extractOption({}, trace, "", traceKey);
	              } : function(calcKey, traceKey) {
	                return Lib.extractOption(cd, trace, calcKey, traceKey);
	              };
	              function fill(key, calcKey, traceKey) {
	                var val = getVal(calcKey, traceKey);
	                if (pass(val)) d[key] = val;
	              }
	              fill("hoverinfo", "hi", "hoverinfo");
	              fill("bgcolor", "hbg", "hoverlabel.bgcolor");
	              fill("borderColor", "hbc", "hoverlabel.bordercolor");
	              fill("fontFamily", "htf", "hoverlabel.font.family");
	              fill("fontSize", "hts", "hoverlabel.font.size");
	              fill("fontColor", "htc", "hoverlabel.font.color");
	              fill("nameLength", "hnl", "hoverlabel.namelength");
	              fill("textAlign", "hta", "hoverlabel.align");
	              d.posref = hovermode === "y" || hovermode === "closest" && trace.orientation === "h" ? d.xa._offset + (d.x0 + d.x1) / 2 : d.ya._offset + (d.y0 + d.y1) / 2;
	              d.x0 = Lib.constrain(d.x0, 0, d.xa._length);
	              d.x1 = Lib.constrain(d.x1, 0, d.xa._length);
	              d.y0 = Lib.constrain(d.y0, 0, d.ya._length);
	              d.y1 = Lib.constrain(d.y1, 0, d.ya._length);
	              if (d.xLabelVal !== undefined) {
	                d.xLabel = "xLabel" in d ? d.xLabel : Axes.hoverLabelText(d.xa, d.xLabelVal, trace.xhoverformat);
	                d.xVal = d.xa.c2d(d.xLabelVal);
	              }
	              if (d.yLabelVal !== undefined) {
	                d.yLabel = "yLabel" in d ? d.yLabel : Axes.hoverLabelText(d.ya, d.yLabelVal, trace.yhoverformat);
	                d.yVal = d.ya.c2d(d.yLabelVal);
	              }
	              if (d.zLabelVal !== undefined && d.zLabel === undefined) {
	                d.zLabel = String(d.zLabelVal);
	              }
	              if (!isNaN(d.xerr) && !(d.xa.type === "log" && d.xerr <= 0)) {
	                var xeText = Axes.tickText(d.xa, d.xa.c2l(d.xerr), "hover").text;
	                if (d.xerrneg !== undefined) {
	                  d.xLabel += " +" + xeText + " / -" + Axes.tickText(d.xa, d.xa.c2l(d.xerrneg), "hover").text;
	                } else d.xLabel += " ± " + xeText;
	                if (hovermode === "x") d.distance += 1;
	              }
	              if (!isNaN(d.yerr) && !(d.ya.type === "log" && d.yerr <= 0)) {
	                var yeText = Axes.tickText(d.ya, d.ya.c2l(d.yerr), "hover").text;
	                if (d.yerrneg !== undefined) {
	                  d.yLabel += " +" + yeText + " / -" + Axes.tickText(d.ya, d.ya.c2l(d.yerrneg), "hover").text;
	                } else d.yLabel += " ± " + yeText;
	                if (hovermode === "y") d.distance += 1;
	              }
	              var infomode = d.hoverinfo || d.trace.hoverinfo;
	              if (infomode && infomode !== "all") {
	                infomode = Array.isArray(infomode) ? infomode : infomode.split("+");
	                if (infomode.indexOf("x") === -1) d.xLabel = undefined;
	                if (infomode.indexOf("y") === -1) d.yLabel = undefined;
	                if (infomode.indexOf("z") === -1) d.zLabel = undefined;
	                if (infomode.indexOf("text") === -1) d.text = undefined;
	                if (infomode.indexOf("name") === -1) d.name = undefined;
	              }
	              return d;
	            }
	            function createSpikelines(gd, closestPoints, opts) {
	              var container = opts.container;
	              var fullLayout = opts.fullLayout;
	              var gs = fullLayout._size;
	              var evt = opts.event;
	              var showY = !!closestPoints.hLinePoint;
	              var showX = !!closestPoints.vLinePoint;
	              var xa, ya;
	              container.selectAll(".spikeline").remove();
	              if (!(showX || showY)) return;
	              var contrastColor = Color.combine(fullLayout.plot_bgcolor, fullLayout.paper_bgcolor);
	              if (showY) {
	                var hLinePoint = closestPoints.hLinePoint;
	                var hLinePointX, hLinePointY;
	                xa = hLinePoint && hLinePoint.xa;
	                ya = hLinePoint && hLinePoint.ya;
	                var ySnap = ya.spikesnap;
	                if (ySnap === "cursor") {
	                  hLinePointX = evt.pointerX;
	                  hLinePointY = evt.pointerY;
	                } else {
	                  hLinePointX = xa._offset + hLinePoint.x;
	                  hLinePointY = ya._offset + hLinePoint.y;
	                }
	                var dfltHLineColor = tinycolor.readability(hLinePoint.color, contrastColor) < 1.5 ? Color.contrast(contrastColor) : hLinePoint.color;
	                var yMode = ya.spikemode;
	                var yThickness = ya.spikethickness;
	                var yColor = ya.spikecolor || dfltHLineColor;
	                var xEdge = Axes.getPxPosition(gd, ya);
	                var xBase, xEndSpike;
	                if (yMode.indexOf("toaxis") !== -1 || yMode.indexOf("across") !== -1) {
	                  if (yMode.indexOf("toaxis") !== -1) {
	                    xBase = xEdge;
	                    xEndSpike = hLinePointX;
	                  }
	                  if (yMode.indexOf("across") !== -1) {
	                    var xAcross0 = ya._counterDomainMin;
	                    var xAcross1 = ya._counterDomainMax;
	                    if (ya.anchor === "free") {
	                      xAcross0 = Math.min(xAcross0, ya.position);
	                      xAcross1 = Math.max(xAcross1, ya.position);
	                    }
	                    xBase = gs.l + xAcross0 * gs.w;
	                    xEndSpike = gs.l + xAcross1 * gs.w;
	                  }
	                  container.insert("line", ":first-child").attr({
	                    x1: xBase,
	                    x2: xEndSpike,
	                    y1: hLinePointY,
	                    y2: hLinePointY,
	                    "stroke-width": yThickness,
	                    stroke: yColor,
	                    "stroke-dasharray": Drawing.dashStyle(ya.spikedash, yThickness)
	                  }).classed("spikeline", true).classed("crisp", true);
	                  container.insert("line", ":first-child").attr({
	                    x1: xBase,
	                    x2: xEndSpike,
	                    y1: hLinePointY,
	                    y2: hLinePointY,
	                    "stroke-width": yThickness + 2,
	                    stroke: contrastColor
	                  }).classed("spikeline", true).classed("crisp", true);
	                }
	                if (yMode.indexOf("marker") !== -1) {
	                  container.insert("circle", ":first-child").attr({
	                    cx: xEdge + (ya.side !== "right" ? yThickness : -yThickness),
	                    cy: hLinePointY,
	                    r: yThickness,
	                    fill: yColor
	                  }).classed("spikeline", true);
	                }
	              }
	              if (showX) {
	                var vLinePoint = closestPoints.vLinePoint;
	                var vLinePointX, vLinePointY;
	                xa = vLinePoint && vLinePoint.xa;
	                ya = vLinePoint && vLinePoint.ya;
	                var xSnap = xa.spikesnap;
	                if (xSnap === "cursor") {
	                  vLinePointX = evt.pointerX;
	                  vLinePointY = evt.pointerY;
	                } else {
	                  vLinePointX = xa._offset + vLinePoint.x;
	                  vLinePointY = ya._offset + vLinePoint.y;
	                }
	                var dfltVLineColor = tinycolor.readability(vLinePoint.color, contrastColor) < 1.5 ? Color.contrast(contrastColor) : vLinePoint.color;
	                var xMode = xa.spikemode;
	                var xThickness = xa.spikethickness;
	                var xColor = xa.spikecolor || dfltVLineColor;
	                var yEdge = Axes.getPxPosition(gd, xa);
	                var yBase, yEndSpike;
	                if (xMode.indexOf("toaxis") !== -1 || xMode.indexOf("across") !== -1) {
	                  if (xMode.indexOf("toaxis") !== -1) {
	                    yBase = yEdge;
	                    yEndSpike = vLinePointY;
	                  }
	                  if (xMode.indexOf("across") !== -1) {
	                    var yAcross0 = xa._counterDomainMin;
	                    var yAcross1 = xa._counterDomainMax;
	                    if (xa.anchor === "free") {
	                      yAcross0 = Math.min(yAcross0, xa.position);
	                      yAcross1 = Math.max(yAcross1, xa.position);
	                    }
	                    yBase = gs.t + (1 - yAcross1) * gs.h;
	                    yEndSpike = gs.t + (1 - yAcross0) * gs.h;
	                  }
	                  container.insert("line", ":first-child").attr({
	                    x1: vLinePointX,
	                    x2: vLinePointX,
	                    y1: yBase,
	                    y2: yEndSpike,
	                    "stroke-width": xThickness,
	                    stroke: xColor,
	                    "stroke-dasharray": Drawing.dashStyle(xa.spikedash, xThickness)
	                  }).classed("spikeline", true).classed("crisp", true);
	                  container.insert("line", ":first-child").attr({
	                    x1: vLinePointX,
	                    x2: vLinePointX,
	                    y1: yBase,
	                    y2: yEndSpike,
	                    "stroke-width": xThickness + 2,
	                    stroke: contrastColor
	                  }).classed("spikeline", true).classed("crisp", true);
	                }
	                if (xMode.indexOf("marker") !== -1) {
	                  container.insert("circle", ":first-child").attr({
	                    cx: vLinePointX,
	                    cy: yEdge - (xa.side !== "top" ? xThickness : -xThickness),
	                    r: xThickness,
	                    fill: xColor
	                  }).classed("spikeline", true);
	                }
	              }
	            }
	            function hoverChanged(gd, evt, oldhoverdata) {
	              if (!oldhoverdata || oldhoverdata.length !== gd._hoverdata.length) return true;
	              for (var i = oldhoverdata.length - 1; i >= 0; i--) {
	                var oldPt = oldhoverdata[i];
	                var newPt = gd._hoverdata[i];
	                if (oldPt.curveNumber !== newPt.curveNumber || String(oldPt.pointNumber) !== String(newPt.pointNumber) || String(oldPt.pointNumbers) !== String(newPt.pointNumbers)) {
	                  return true;
	                }
	              }
	              return false;
	            }
	            function spikesChanged(gd, oldspikepoints) {
	              return true;
	            }
	            function plainText(s, len) {
	              return svgTextUtils.plainText(s || "", {
	                len,
	                allowedTags: ["br", "sub", "sup", "b", "i", "em"]
	              });
	            }
	            function orderRangePoints(hoverData, hovermode) {
	              var axLetter = hovermode.charAt(0);
	              var first = [];
	              var second = [];
	              var last = [];
	              for (var i = 0; i < hoverData.length; i++) {
	                var d = hoverData[i];
	                if (Registry.traceIs(d.trace, "bar-like") || Registry.traceIs(d.trace, "box-violin")) {
	                  last.push(d);
	                } else if (d.trace[axLetter + "period"]) {
	                  second.push(d);
	                } else {
	                  first.push(d);
	                }
	              }
	              return first.concat(second).concat(last);
	            }
	            function getCoord(axLetter, winningPoint, fullLayout) {
	              var ax = winningPoint[axLetter + "a"];
	              var val = winningPoint[axLetter + "Val"];
	              var cd0 = winningPoint.cd[0];
	              if (ax.type === "category" || ax.type === "multicategory") val = ax._categoriesMap[val];
	              else if (ax.type === "date") {
	                var periodalignment = winningPoint.trace[axLetter + "periodalignment"];
	                if (periodalignment) {
	                  var d = winningPoint.cd[winningPoint.index];
	                  var start = d[axLetter + "Start"];
	                  if (start === undefined) start = d[axLetter];
	                  var end = d[axLetter + "End"];
	                  if (end === undefined) end = d[axLetter];
	                  var diff = end - start;
	                  if (periodalignment === "end") {
	                    val += diff;
	                  } else if (periodalignment === "middle") {
	                    val += diff / 2;
	                  }
	                }
	                val = ax.d2c(val);
	              }
	              if (cd0 && cd0.t && cd0.t.posLetter === ax._id) {
	                if (fullLayout.boxmode === "group" || fullLayout.violinmode === "group") {
	                  val += cd0.t.dPos;
	                }
	              }
	              return val;
	            }
	            function getTopOffset(gd) {
	              return gd.offsetTop + gd.clientTop;
	            }
	            function getLeftOffset(gd) {
	              return gd.offsetLeft + gd.clientLeft;
	            }
	            function getBoundingClientRect(gd, node) {
	              var fullLayout = gd._fullLayout;
	              var rect = node.getBoundingClientRect();
	              var x0 = rect.left;
	              var y0 = rect.top;
	              var x1 = x0 + rect.width;
	              var y1 = y0 + rect.height;
	              var A = Lib.apply3DTransform(fullLayout._invTransform)(x0, y0);
	              var B = Lib.apply3DTransform(fullLayout._invTransform)(x1, y1);
	              var Ax = A[0];
	              var Ay = A[1];
	              var Bx = B[0];
	              var By = B[1];
	              return {
	                x: Ax,
	                y: Ay,
	                width: Bx - Ax,
	                height: By - Ay,
	                top: Math.min(Ay, By),
	                left: Math.min(Ax, Bx),
	                right: Math.max(Ax, Bx),
	                bottom: Math.max(Ay, By)
	              };
	            }
	          }
	        ),
	        /***/
	        38048: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var isUnifiedHover = __webpack_require__2(23469).isUnifiedHover;
	            module2.exports = function handleHoverLabelDefaults(contIn, contOut, coerce, opts) {
	              opts = opts || {};
	              var hasLegend = contOut.legend;
	              function inheritFontAttr(attr) {
	                if (!opts.font[attr]) {
	                  opts.font[attr] = hasLegend ? contOut.legend.font[attr] : contOut.font[attr];
	                }
	              }
	              if (contOut && isUnifiedHover(contOut.hovermode)) {
	                if (!opts.font) opts.font = {};
	                inheritFontAttr("size");
	                inheritFontAttr("family");
	                inheritFontAttr("color");
	                if (hasLegend) {
	                  if (!opts.bgcolor) opts.bgcolor = Color.combine(contOut.legend.bgcolor, contOut.paper_bgcolor);
	                  if (!opts.bordercolor) opts.bordercolor = contOut.legend.bordercolor;
	                } else {
	                  if (!opts.bgcolor) opts.bgcolor = contOut.paper_bgcolor;
	                }
	              }
	              coerce("hoverlabel.bgcolor", opts.bgcolor);
	              coerce("hoverlabel.bordercolor", opts.bordercolor);
	              coerce("hoverlabel.namelength", opts.namelength);
	              Lib.coerceFont(coerce, "hoverlabel.font", opts.font);
	              coerce("hoverlabel.align", opts.align);
	            };
	          }
	        ),
	        /***/
	        98212: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(528);
	            module2.exports = function handleHoverModeDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                if (layoutOut[attr] !== undefined) return layoutOut[attr];
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              coerce("clickmode");
	              return coerce("hovermode");
	            };
	          }
	        ),
	        /***/
	        30211: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var dragElement = __webpack_require__2(28569);
	            var helpers = __webpack_require__2(23469);
	            var layoutAttributes = __webpack_require__2(528);
	            var hoverModule = __webpack_require__2(88335);
	            module2.exports = {
	              moduleType: "component",
	              name: "fx",
	              constants: __webpack_require__2(26675),
	              schema: {
	                layout: layoutAttributes
	              },
	              attributes: __webpack_require__2(77914),
	              layoutAttributes,
	              supplyLayoutGlobalDefaults: __webpack_require__2(22774),
	              supplyDefaults: __webpack_require__2(54268),
	              supplyLayoutDefaults: __webpack_require__2(34938),
	              calc: __webpack_require__2(30732),
	              getDistanceFunction: helpers.getDistanceFunction,
	              getClosest: helpers.getClosest,
	              inbox: helpers.inbox,
	              quadrature: helpers.quadrature,
	              appendArrayPointValue: helpers.appendArrayPointValue,
	              castHoverOption,
	              castHoverinfo,
	              hover: hoverModule.hover,
	              unhover: dragElement.unhover,
	              loneHover: hoverModule.loneHover,
	              loneUnhover,
	              click: __webpack_require__2(75914)
	            };
	            function loneUnhover(containerOrSelection) {
	              var selection = Lib.isD3Selection(containerOrSelection) ? containerOrSelection : d3.select(containerOrSelection);
	              selection.selectAll("g.hovertext").remove();
	              selection.selectAll(".spikeline").remove();
	            }
	            function castHoverOption(trace, ptNumber, attr) {
	              return Lib.castOption(trace, ptNumber, "hoverlabel." + attr);
	            }
	            function castHoverinfo(trace, fullLayout, ptNumber) {
	              function _coerce(val) {
	                return Lib.coerceHoverinfo({
	                  hoverinfo: val
	                }, {
	                  _module: trace._module
	                }, fullLayout);
	              }
	              return Lib.castOption(trace, ptNumber, "hoverinfo", _coerce);
	            }
	          }
	        ),
	        /***/
	        528: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var constants = __webpack_require__2(26675);
	            var fontAttrs = __webpack_require__2(41940);
	            var font = fontAttrs({
	              editType: "none"
	            });
	            font.family.dflt = constants.HOVERFONT;
	            font.size.dflt = constants.HOVERFONTSIZE;
	            module2.exports = {
	              clickmode: {
	                valType: "flaglist",
	                flags: ["event", "select"],
	                dflt: "event",
	                editType: "plot",
	                extras: ["none"]
	              },
	              dragmode: {
	                valType: "enumerated",
	                values: ["zoom", "pan", "select", "lasso", "drawclosedpath", "drawopenpath", "drawline", "drawrect", "drawcircle", "orbit", "turntable", false],
	                dflt: "zoom",
	                editType: "modebar"
	              },
	              hovermode: {
	                valType: "enumerated",
	                values: ["x", "y", "closest", false, "x unified", "y unified"],
	                dflt: "closest",
	                editType: "modebar"
	              },
	              hoverdistance: {
	                valType: "integer",
	                min: -1,
	                dflt: 20,
	                editType: "none"
	              },
	              spikedistance: {
	                valType: "integer",
	                min: -1,
	                dflt: -1,
	                editType: "none"
	              },
	              hoverlabel: {
	                bgcolor: {
	                  valType: "color",
	                  editType: "none"
	                },
	                bordercolor: {
	                  valType: "color",
	                  editType: "none"
	                },
	                font,
	                grouptitlefont: fontAttrs({
	                  editType: "none"
	                }),
	                align: {
	                  valType: "enumerated",
	                  values: ["left", "right", "auto"],
	                  dflt: "auto",
	                  editType: "none"
	                },
	                namelength: {
	                  valType: "integer",
	                  min: -1,
	                  dflt: 15,
	                  editType: "none"
	                },
	                editType: "none"
	              },
	              selectdirection: {
	                valType: "enumerated",
	                values: ["h", "v", "d", "any"],
	                dflt: "any",
	                editType: "none"
	              }
	            };
	          }
	        ),
	        /***/
	        34938: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(528);
	            var handleHoverModeDefaults = __webpack_require__2(98212);
	            var handleHoverLabelDefaults = __webpack_require__2(38048);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              var hoverMode = handleHoverModeDefaults(layoutIn, layoutOut);
	              if (hoverMode) {
	                coerce("hoverdistance");
	                coerce("spikedistance");
	              }
	              var dragMode = coerce("dragmode");
	              if (dragMode === "select") coerce("selectdirection");
	              var hasMapbox = layoutOut._has("mapbox");
	              var hasGeo = layoutOut._has("geo");
	              var len = layoutOut._basePlotModules.length;
	              if (layoutOut.dragmode === "zoom" && ((hasMapbox || hasGeo) && len === 1 || hasMapbox && hasGeo && len === 2)) {
	                layoutOut.dragmode = "pan";
	              }
	              handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
	              Lib.coerceFont(coerce, "hoverlabel.grouptitlefont", layoutOut.hoverlabel.font);
	            };
	          }
	        ),
	        /***/
	        22774: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleHoverLabelDefaults = __webpack_require__2(38048);
	            var layoutAttributes = __webpack_require__2(528);
	            module2.exports = function supplyLayoutGlobalDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
	            };
	          }
	        ),
	        /***/
	        83312: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var counterRegex = __webpack_require__2(30587).counter;
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var cartesianIdRegex = __webpack_require__2(85555).idRegex;
	            var Template = __webpack_require__2(44467);
	            var gridAttrs = {
	              rows: {
	                valType: "integer",
	                min: 1,
	                editType: "plot"
	              },
	              roworder: {
	                valType: "enumerated",
	                values: ["top to bottom", "bottom to top"],
	                dflt: "top to bottom",
	                editType: "plot"
	              },
	              columns: {
	                valType: "integer",
	                min: 1,
	                editType: "plot"
	              },
	              subplots: {
	                valType: "info_array",
	                freeLength: true,
	                dimensions: 2,
	                items: {
	                  valType: "enumerated",
	                  values: [counterRegex("xy").toString(), ""],
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              xaxes: {
	                valType: "info_array",
	                freeLength: true,
	                items: {
	                  valType: "enumerated",
	                  values: [cartesianIdRegex.x.toString(), ""],
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              yaxes: {
	                valType: "info_array",
	                freeLength: true,
	                items: {
	                  valType: "enumerated",
	                  values: [cartesianIdRegex.y.toString(), ""],
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              pattern: {
	                valType: "enumerated",
	                values: ["independent", "coupled"],
	                dflt: "coupled",
	                editType: "plot"
	              },
	              xgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "plot"
	              },
	              ygap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "plot"
	              },
	              domain: domainAttrs({
	                name: "grid",
	                editType: "plot",
	                noGridCell: true
	              }, {}),
	              xside: {
	                valType: "enumerated",
	                values: ["bottom", "bottom plot", "top plot", "top"],
	                dflt: "bottom plot",
	                editType: "plot"
	              },
	              yside: {
	                valType: "enumerated",
	                values: ["left", "left plot", "right plot", "right"],
	                dflt: "left plot",
	                editType: "plot"
	              },
	              editType: "plot"
	            };
	            function getAxes(layout, grid, axLetter) {
	              var gridVal = grid[axLetter + "axes"];
	              var splomVal = Object.keys((layout._splomAxes || {})[axLetter] || {});
	              if (Array.isArray(gridVal)) return gridVal;
	              if (splomVal.length) return splomVal;
	            }
	            function sizeDefaults(layoutIn, layoutOut) {
	              var gridIn = layoutIn.grid || {};
	              var xAxes = getAxes(layoutOut, gridIn, "x");
	              var yAxes = getAxes(layoutOut, gridIn, "y");
	              if (!layoutIn.grid && !xAxes && !yAxes) return;
	              var hasSubplotGrid = Array.isArray(gridIn.subplots) && Array.isArray(gridIn.subplots[0]);
	              var hasXaxes = Array.isArray(xAxes);
	              var hasYaxes = Array.isArray(yAxes);
	              var isSplomGenerated = hasXaxes && xAxes !== gridIn.xaxes && hasYaxes && yAxes !== gridIn.yaxes;
	              var dfltRows, dfltColumns;
	              if (hasSubplotGrid) {
	                dfltRows = gridIn.subplots.length;
	                dfltColumns = gridIn.subplots[0].length;
	              } else {
	                if (hasYaxes) dfltRows = yAxes.length;
	                if (hasXaxes) dfltColumns = xAxes.length;
	              }
	              var gridOut = Template.newContainer(layoutOut, "grid");
	              function coerce(attr, dflt) {
	                return Lib.coerce(gridIn, gridOut, gridAttrs, attr, dflt);
	              }
	              var rows = coerce("rows", dfltRows);
	              var columns = coerce("columns", dfltColumns);
	              if (!(rows * columns > 1)) {
	                delete layoutOut.grid;
	                return;
	              }
	              if (!hasSubplotGrid && !hasXaxes && !hasYaxes) {
	                var useDefaultSubplots = coerce("pattern") === "independent";
	                if (useDefaultSubplots) hasSubplotGrid = true;
	              }
	              gridOut._hasSubplotGrid = hasSubplotGrid;
	              var rowOrder = coerce("roworder");
	              var reversed = rowOrder === "top to bottom";
	              var dfltGapX = hasSubplotGrid ? 0.2 : 0.1;
	              var dfltGapY = hasSubplotGrid ? 0.3 : 0.1;
	              var dfltSideX, dfltSideY;
	              if (isSplomGenerated && layoutOut._splomGridDflt) {
	                dfltSideX = layoutOut._splomGridDflt.xside;
	                dfltSideY = layoutOut._splomGridDflt.yside;
	              }
	              gridOut._domains = {
	                x: fillGridPositions("x", coerce, dfltGapX, dfltSideX, columns),
	                y: fillGridPositions("y", coerce, dfltGapY, dfltSideY, rows, reversed)
	              };
	            }
	            function fillGridPositions(axLetter, coerce, dfltGap, dfltSide, len, reversed) {
	              var dirGap = coerce(axLetter + "gap", dfltGap);
	              var domain = coerce("domain." + axLetter);
	              coerce(axLetter + "side", dfltSide);
	              var out = new Array(len);
	              var start = domain[0];
	              var step = (domain[1] - start) / (len - dirGap);
	              var cellDomain = step * (1 - dirGap);
	              for (var i = 0; i < len; i++) {
	                var cellStart = start + step * i;
	                out[reversed ? len - 1 - i : i] = [cellStart, cellStart + cellDomain];
	              }
	              return out;
	            }
	            function contentDefaults(layoutIn, layoutOut) {
	              var gridOut = layoutOut.grid;
	              if (!gridOut || !gridOut._domains) return;
	              var gridIn = layoutIn.grid || {};
	              var subplots = layoutOut._subplots;
	              var hasSubplotGrid = gridOut._hasSubplotGrid;
	              var rows = gridOut.rows;
	              var columns = gridOut.columns;
	              var useDefaultSubplots = gridOut.pattern === "independent";
	              var i, j, xId, yId, subplotId, subplotsOut, yPos;
	              var axisMap = gridOut._axisMap = {};
	              if (hasSubplotGrid) {
	                var subplotsIn = gridIn.subplots || [];
	                subplotsOut = gridOut.subplots = new Array(rows);
	                var index = 1;
	                for (i = 0; i < rows; i++) {
	                  var rowOut = subplotsOut[i] = new Array(columns);
	                  var rowIn = subplotsIn[i] || [];
	                  for (j = 0; j < columns; j++) {
	                    if (useDefaultSubplots) {
	                      subplotId = index === 1 ? "xy" : "x" + index + "y" + index;
	                      index++;
	                    } else subplotId = rowIn[j];
	                    rowOut[j] = "";
	                    if (subplots.cartesian.indexOf(subplotId) !== -1) {
	                      yPos = subplotId.indexOf("y");
	                      xId = subplotId.slice(0, yPos);
	                      yId = subplotId.slice(yPos);
	                      if (axisMap[xId] !== undefined && axisMap[xId] !== j || axisMap[yId] !== undefined && axisMap[yId] !== i) {
	                        continue;
	                      }
	                      rowOut[j] = subplotId;
	                      axisMap[xId] = j;
	                      axisMap[yId] = i;
	                    }
	                  }
	                }
	              } else {
	                var xAxes = getAxes(layoutOut, gridIn, "x");
	                var yAxes = getAxes(layoutOut, gridIn, "y");
	                gridOut.xaxes = fillGridAxes(xAxes, subplots.xaxis, columns, axisMap, "x");
	                gridOut.yaxes = fillGridAxes(yAxes, subplots.yaxis, rows, axisMap, "y");
	              }
	              var anchors = gridOut._anchors = {};
	              var reversed = gridOut.roworder === "top to bottom";
	              for (var axisId in axisMap) {
	                var axLetter = axisId.charAt(0);
	                var side = gridOut[axLetter + "side"];
	                var i0, inc, iFinal;
	                if (side.length < 8) {
	                  anchors[axisId] = "free";
	                } else if (axLetter === "x") {
	                  if (side.charAt(0) === "t" === reversed) {
	                    i0 = 0;
	                    inc = 1;
	                    iFinal = rows;
	                  } else {
	                    i0 = rows - 1;
	                    inc = -1;
	                    iFinal = -1;
	                  }
	                  if (hasSubplotGrid) {
	                    var column = axisMap[axisId];
	                    for (i = i0; i !== iFinal; i += inc) {
	                      subplotId = subplotsOut[i][column];
	                      if (!subplotId) continue;
	                      yPos = subplotId.indexOf("y");
	                      if (subplotId.slice(0, yPos) === axisId) {
	                        anchors[axisId] = subplotId.slice(yPos);
	                        break;
	                      }
	                    }
	                  } else {
	                    for (i = i0; i !== iFinal; i += inc) {
	                      yId = gridOut.yaxes[i];
	                      if (subplots.cartesian.indexOf(axisId + yId) !== -1) {
	                        anchors[axisId] = yId;
	                        break;
	                      }
	                    }
	                  }
	                } else {
	                  if (side.charAt(0) === "l") {
	                    i0 = 0;
	                    inc = 1;
	                    iFinal = columns;
	                  } else {
	                    i0 = columns - 1;
	                    inc = -1;
	                    iFinal = -1;
	                  }
	                  if (hasSubplotGrid) {
	                    var row = axisMap[axisId];
	                    for (i = i0; i !== iFinal; i += inc) {
	                      subplotId = subplotsOut[row][i];
	                      if (!subplotId) continue;
	                      yPos = subplotId.indexOf("y");
	                      if (subplotId.slice(yPos) === axisId) {
	                        anchors[axisId] = subplotId.slice(0, yPos);
	                        break;
	                      }
	                    }
	                  } else {
	                    for (i = i0; i !== iFinal; i += inc) {
	                      xId = gridOut.xaxes[i];
	                      if (subplots.cartesian.indexOf(xId + axisId) !== -1) {
	                        anchors[axisId] = xId;
	                        break;
	                      }
	                    }
	                  }
	                }
	              }
	            }
	            function fillGridAxes(axesIn, axesAllowed, len, axisMap, axLetter) {
	              var out = new Array(len);
	              var i;
	              function fillOneAxis(i2, axisId) {
	                if (axesAllowed.indexOf(axisId) !== -1 && axisMap[axisId] === undefined) {
	                  out[i2] = axisId;
	                  axisMap[axisId] = i2;
	                } else out[i2] = "";
	              }
	              if (Array.isArray(axesIn)) {
	                for (i = 0; i < len; i++) {
	                  fillOneAxis(i, axesIn[i]);
	                }
	              } else {
	                fillOneAxis(0, axLetter);
	                for (i = 1; i < len; i++) {
	                  fillOneAxis(i, axLetter + (i + 1));
	                }
	              }
	              return out;
	            }
	            module2.exports = {
	              moduleType: "component",
	              name: "grid",
	              schema: {
	                layout: {
	                  grid: gridAttrs
	                }
	              },
	              layoutAttributes: gridAttrs,
	              sizeDefaults,
	              contentDefaults
	            };
	          }
	        ),
	        /***/
	        69819: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var cartesianConstants = __webpack_require__2(85555);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            __webpack_require__2(24695);
	            module2.exports = templatedArray("image", {
	              visible: {
	                valType: "boolean",
	                dflt: true,
	                editType: "arraydraw"
	              },
	              source: {
	                valType: "string",
	                editType: "arraydraw"
	              },
	              layer: {
	                valType: "enumerated",
	                values: ["below", "above"],
	                dflt: "above",
	                editType: "arraydraw"
	              },
	              sizex: {
	                valType: "number",
	                dflt: 0,
	                editType: "arraydraw"
	              },
	              sizey: {
	                valType: "number",
	                dflt: 0,
	                editType: "arraydraw"
	              },
	              sizing: {
	                valType: "enumerated",
	                values: ["fill", "contain", "stretch"],
	                dflt: "contain",
	                editType: "arraydraw"
	              },
	              opacity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 1,
	                editType: "arraydraw"
	              },
	              x: {
	                valType: "any",
	                dflt: 0,
	                editType: "arraydraw"
	              },
	              y: {
	                valType: "any",
	                dflt: 0,
	                editType: "arraydraw"
	              },
	              xanchor: {
	                valType: "enumerated",
	                values: ["left", "center", "right"],
	                dflt: "left",
	                editType: "arraydraw"
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["top", "middle", "bottom"],
	                dflt: "top",
	                editType: "arraydraw"
	              },
	              xref: {
	                valType: "enumerated",
	                values: ["paper", cartesianConstants.idRegex.x.toString()],
	                dflt: "paper",
	                editType: "arraydraw"
	              },
	              yref: {
	                valType: "enumerated",
	                values: ["paper", cartesianConstants.idRegex.y.toString()],
	                dflt: "paper",
	                editType: "arraydraw"
	              },
	              editType: "arraydraw"
	            });
	          }
	        ),
	        /***/
	        75378: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var toLogRange = __webpack_require__2(58163);
	            module2.exports = function convertCoords(gd, ax, newType, doExtra) {
	              ax = ax || {};
	              var toLog = newType === "log" && ax.type === "linear";
	              var fromLog = newType === "linear" && ax.type === "log";
	              if (!(toLog || fromLog)) return;
	              var images = gd._fullLayout.images;
	              var axLetter = ax._id.charAt(0);
	              var image;
	              var attrPrefix;
	              for (var i = 0; i < images.length; i++) {
	                image = images[i];
	                attrPrefix = "images[" + i + "].";
	                if (image[axLetter + "ref"] === ax._id) {
	                  var currentPos = image[axLetter];
	                  var currentSize = image["size" + axLetter];
	                  var newPos = null;
	                  var newSize = null;
	                  if (toLog) {
	                    newPos = toLogRange(currentPos, ax.range);
	                    var dx = currentSize / Math.pow(10, newPos) / 2;
	                    newSize = 2 * Math.log(dx + Math.sqrt(1 + dx * dx)) / Math.LN10;
	                  } else {
	                    newPos = Math.pow(10, currentPos);
	                    newSize = newPos * (Math.pow(10, currentSize / 2) - Math.pow(10, -currentSize / 2));
	                  }
	                  if (!isNumeric(newPos)) {
	                    newPos = null;
	                    newSize = null;
	                  } else if (!isNumeric(newSize)) newSize = null;
	                  doExtra(attrPrefix + axLetter, newPos);
	                  doExtra(attrPrefix + "size" + axLetter, newSize);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        81603: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(69819);
	            var name2 = "images";
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              var opts = {
	                name: name2,
	                handleItemDefaults: imageDefaults
	              };
	              handleArrayContainerDefaults(layoutIn, layoutOut, opts);
	            };
	            function imageDefaults(imageIn, imageOut, fullLayout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(imageIn, imageOut, attributes, attr, dflt);
	              }
	              var source = coerce("source");
	              var visible = coerce("visible", !!source);
	              if (!visible) return imageOut;
	              coerce("layer");
	              coerce("xanchor");
	              coerce("yanchor");
	              coerce("sizex");
	              coerce("sizey");
	              coerce("sizing");
	              coerce("opacity");
	              var gdMock = {
	                _fullLayout: fullLayout
	              };
	              var axLetters = ["x", "y"];
	              for (var i = 0; i < 2; i++) {
	                var axLetter = axLetters[i];
	                var axRef = Axes.coerceRef(imageIn, imageOut, gdMock, axLetter, "paper", undefined);
	                if (axRef !== "paper") {
	                  var ax = Axes.getFromId(gdMock, axRef);
	                  ax._imgIndices.push(imageOut._index);
	                }
	                Axes.coercePosition(imageOut, gdMock, coerce, axRef, axLetter, 0);
	              }
	              return imageOut;
	            }
	          }
	        ),
	        /***/
	        80750: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Axes = __webpack_require__2(89298);
	            var axisIds = __webpack_require__2(41675);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            module2.exports = function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              var imageDataAbove = [];
	              var imageDataSubplot = {};
	              var imageDataBelow = [];
	              var subplot;
	              var i;
	              for (i = 0; i < fullLayout.images.length; i++) {
	                var img = fullLayout.images[i];
	                if (img.visible) {
	                  if (img.layer === "below" && img.xref !== "paper" && img.yref !== "paper") {
	                    subplot = axisIds.ref2id(img.xref) + axisIds.ref2id(img.yref);
	                    var plotinfo = fullLayout._plots[subplot];
	                    if (!plotinfo) {
	                      imageDataBelow.push(img);
	                      continue;
	                    }
	                    if (plotinfo.mainplot) {
	                      subplot = plotinfo.mainplot.id;
	                    }
	                    if (!imageDataSubplot[subplot]) {
	                      imageDataSubplot[subplot] = [];
	                    }
	                    imageDataSubplot[subplot].push(img);
	                  } else if (img.layer === "above") {
	                    imageDataAbove.push(img);
	                  } else {
	                    imageDataBelow.push(img);
	                  }
	                }
	              }
	              var anchors = {
	                x: {
	                  left: {
	                    sizing: "xMin",
	                    offset: 0
	                  },
	                  center: {
	                    sizing: "xMid",
	                    offset: -1 / 2
	                  },
	                  right: {
	                    sizing: "xMax",
	                    offset: -1
	                  }
	                },
	                y: {
	                  top: {
	                    sizing: "YMin",
	                    offset: 0
	                  },
	                  middle: {
	                    sizing: "YMid",
	                    offset: -1 / 2
	                  },
	                  bottom: {
	                    sizing: "YMax",
	                    offset: -1
	                  }
	                }
	              };
	              function setImage(d) {
	                var thisImage = d3.select(this);
	                if (this._imgSrc === d.source) {
	                  return;
	                }
	                thisImage.attr("xmlns", xmlnsNamespaces.svg);
	                if (d.source && d.source.slice(0, 5) === "data:") {
	                  thisImage.attr("xlink:href", d.source);
	                  this._imgSrc = d.source;
	                } else {
	                  var imagePromise = new Promise(function(resolve) {
	                    var img2 = new Image();
	                    this.img = img2;
	                    img2.setAttribute("crossOrigin", "anonymous");
	                    img2.onerror = errorHandler;
	                    img2.onload = function() {
	                      var canvas = document.createElement("canvas");
	                      canvas.width = this.width;
	                      canvas.height = this.height;
	                      var ctx = canvas.getContext("2d", {
	                        willReadFrequently: true
	                      });
	                      ctx.drawImage(this, 0, 0);
	                      var dataURL = canvas.toDataURL("image/png");
	                      thisImage.attr("xlink:href", dataURL);
	                      resolve();
	                    };
	                    thisImage.on("error", errorHandler);
	                    img2.src = d.source;
	                    this._imgSrc = d.source;
	                    function errorHandler() {
	                      thisImage.remove();
	                      resolve();
	                    }
	                  }.bind(this));
	                  gd._promises.push(imagePromise);
	                }
	              }
	              function applyAttributes(d) {
	                var thisImage = d3.select(this);
	                var xa = Axes.getFromId(gd, d.xref);
	                var ya = Axes.getFromId(gd, d.yref);
	                var xIsDomain = Axes.getRefType(d.xref) === "domain";
	                var yIsDomain = Axes.getRefType(d.yref) === "domain";
	                var size = fullLayout._size;
	                var width, height;
	                if (xa !== undefined) {
	                  width = typeof d.xref === "string" && xIsDomain ? xa._length * d.sizex : Math.abs(xa.l2p(d.sizex) - xa.l2p(0));
	                } else {
	                  width = d.sizex * size.w;
	                }
	                if (ya !== undefined) {
	                  height = typeof d.yref === "string" && yIsDomain ? ya._length * d.sizey : Math.abs(ya.l2p(d.sizey) - ya.l2p(0));
	                } else {
	                  height = d.sizey * size.h;
	                }
	                var xOffset = width * anchors.x[d.xanchor].offset;
	                var yOffset = height * anchors.y[d.yanchor].offset;
	                var sizing = anchors.x[d.xanchor].sizing + anchors.y[d.yanchor].sizing;
	                var xPos, yPos;
	                if (xa !== undefined) {
	                  xPos = typeof d.xref === "string" && xIsDomain ? xa._length * d.x + xa._offset : xa.r2p(d.x) + xa._offset;
	                } else {
	                  xPos = d.x * size.w + size.l;
	                }
	                xPos += xOffset;
	                if (ya !== undefined) {
	                  yPos = typeof d.yref === "string" && yIsDomain ? (
	                    // consistent with "paper" yref value, where positive values
	                    // move up the page
	                    ya._length * (1 - d.y) + ya._offset
	                  ) : ya.r2p(d.y) + ya._offset;
	                } else {
	                  yPos = size.h - d.y * size.h + size.t;
	                }
	                yPos += yOffset;
	                switch (d.sizing) {
	                  case "fill":
	                    sizing += " slice";
	                    break;
	                  case "stretch":
	                    sizing = "none";
	                    break;
	                }
	                thisImage.attr({
	                  x: xPos,
	                  y: yPos,
	                  width,
	                  height,
	                  preserveAspectRatio: sizing,
	                  opacity: d.opacity
	                });
	                var xId = xa && Axes.getRefType(d.xref) !== "domain" ? xa._id : "";
	                var yId = ya && Axes.getRefType(d.yref) !== "domain" ? ya._id : "";
	                var clipAxes = xId + yId;
	                Drawing.setClipUrl(thisImage, clipAxes ? "clip" + fullLayout._uid + clipAxes : null, gd);
	              }
	              var imagesBelow = fullLayout._imageLowerLayer.selectAll("image").data(imageDataBelow);
	              var imagesAbove = fullLayout._imageUpperLayer.selectAll("image").data(imageDataAbove);
	              imagesBelow.enter().append("image");
	              imagesAbove.enter().append("image");
	              imagesBelow.exit().remove();
	              imagesAbove.exit().remove();
	              imagesBelow.each(function(d) {
	                setImage.bind(this)(d);
	                applyAttributes.bind(this)(d);
	              });
	              imagesAbove.each(function(d) {
	                setImage.bind(this)(d);
	                applyAttributes.bind(this)(d);
	              });
	              var allSubplots = Object.keys(fullLayout._plots);
	              for (i = 0; i < allSubplots.length; i++) {
	                subplot = allSubplots[i];
	                var subplotObj = fullLayout._plots[subplot];
	                if (!subplotObj.imagelayer) continue;
	                var imagesOnSubplot = subplotObj.imagelayer.selectAll("image").data(imageDataSubplot[subplot] || []);
	                imagesOnSubplot.enter().append("image");
	                imagesOnSubplot.exit().remove();
	                imagesOnSubplot.each(function(d) {
	                  setImage.bind(this)(d);
	                  applyAttributes.bind(this)(d);
	                });
	              }
	            };
	          }
	        ),
	        /***/
	        68804: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "component",
	              name: "images",
	              layoutAttributes: __webpack_require__2(69819),
	              supplyLayoutDefaults: __webpack_require__2(81603),
	              includeBasePlot: __webpack_require__2(76325)("images"),
	              draw: __webpack_require__2(80750),
	              convertCoords: __webpack_require__2(75378)
	            };
	          }
	        ),
	        /***/
	        33030: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            module2.exports = {
	              // not really a 'subplot' attribute container,
	              // but this is the flag we use to denote attributes that
	              // support yaxis, yaxis2, yaxis3, ... counters
	              _isSubplotObj: true,
	              visible: {
	                valType: "boolean",
	                dflt: true,
	                editType: "legend"
	              },
	              bgcolor: {
	                valType: "color",
	                editType: "legend"
	              },
	              bordercolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "legend"
	              },
	              borderwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 0,
	                editType: "legend"
	              },
	              font: fontAttrs({
	                editType: "legend"
	              }),
	              grouptitlefont: fontAttrs({
	                editType: "legend"
	              }),
	              orientation: {
	                valType: "enumerated",
	                values: ["v", "h"],
	                dflt: "v",
	                editType: "legend"
	              },
	              traceorder: {
	                valType: "flaglist",
	                flags: ["reversed", "grouped"],
	                extras: ["normal"],
	                editType: "legend"
	              },
	              tracegroupgap: {
	                valType: "number",
	                min: 0,
	                dflt: 10,
	                editType: "legend"
	              },
	              entrywidth: {
	                valType: "number",
	                min: 0,
	                editType: "legend"
	              },
	              entrywidthmode: {
	                valType: "enumerated",
	                values: ["fraction", "pixels"],
	                dflt: "pixels",
	                editType: "legend"
	              },
	              itemsizing: {
	                valType: "enumerated",
	                values: ["trace", "constant"],
	                dflt: "trace",
	                editType: "legend"
	              },
	              itemwidth: {
	                valType: "number",
	                min: 30,
	                dflt: 30,
	                editType: "legend"
	              },
	              itemclick: {
	                valType: "enumerated",
	                values: ["toggle", "toggleothers", false],
	                dflt: "toggle",
	                editType: "legend"
	              },
	              itemdoubleclick: {
	                valType: "enumerated",
	                values: ["toggle", "toggleothers", false],
	                dflt: "toggleothers",
	                editType: "legend"
	              },
	              groupclick: {
	                valType: "enumerated",
	                values: ["toggleitem", "togglegroup"],
	                dflt: "togglegroup",
	                editType: "legend"
	              },
	              x: {
	                valType: "number",
	                editType: "legend"
	              },
	              xref: {
	                valType: "enumerated",
	                dflt: "paper",
	                values: ["container", "paper"],
	                editType: "layoutstyle"
	              },
	              xanchor: {
	                valType: "enumerated",
	                values: ["auto", "left", "center", "right"],
	                dflt: "left",
	                editType: "legend"
	              },
	              y: {
	                valType: "number",
	                editType: "legend"
	              },
	              yref: {
	                valType: "enumerated",
	                dflt: "paper",
	                values: ["container", "paper"],
	                editType: "layoutstyle"
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["auto", "top", "middle", "bottom"],
	                editType: "legend"
	              },
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              valign: {
	                valType: "enumerated",
	                values: ["top", "middle", "bottom"],
	                dflt: "middle",
	                editType: "legend"
	              },
	              title: {
	                text: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "legend"
	                },
	                font: fontAttrs({
	                  editType: "legend"
	                }),
	                side: {
	                  valType: "enumerated",
	                  values: ["top", "left", "top left", "top center", "top right"],
	                  editType: "legend"
	                },
	                editType: "legend"
	              },
	              editType: "legend"
	            };
	          }
	        ),
	        /***/
	        14928: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              scrollBarWidth: 6,
	              scrollBarMinHeight: 20,
	              scrollBarColor: "#808BA4",
	              scrollBarMargin: 4,
	              scrollBarEnterAttrs: {
	                rx: 20,
	                ry: 3,
	                width: 0,
	                height: 0
	              },
	              // number of px between legend title and (left) side of legend (always in x direction and from inner border)
	              titlePad: 2,
	              // number of px between each legend item (x and/or y direction)
	              itemGap: 5
	            };
	          }
	        ),
	        /***/
	        99017: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var plotsAttrs = __webpack_require__2(9012);
	            var attributes = __webpack_require__2(33030);
	            var basePlotLayoutAttributes = __webpack_require__2(10820);
	            var helpers = __webpack_require__2(10130);
	            function groupDefaults(legendId, layoutIn, layoutOut, fullData) {
	              var containerIn = layoutIn[legendId] || {};
	              var containerOut = Template.newContainer(layoutOut, legendId);
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	              }
	              var itemFont = Lib.coerceFont(coerce, "font", layoutOut.font);
	              coerce("bgcolor", layoutOut.paper_bgcolor);
	              coerce("bordercolor");
	              var visible = coerce("visible");
	              if (!visible) return;
	              var trace;
	              var traceCoerce = function(attr, dflt) {
	                var traceIn = trace._input;
	                var traceOut = trace;
	                return Lib.coerce(traceIn, traceOut, plotsAttrs, attr, dflt);
	              };
	              var globalFont = layoutOut.font || {};
	              var grouptitlefont = Lib.coerceFont(coerce, "grouptitlefont", Lib.extendFlat({}, globalFont, {
	                size: Math.round(globalFont.size * 1.1)
	              }));
	              var legendTraceCount = 0;
	              var legendReallyHasATrace = false;
	              var defaultOrder = "normal";
	              var shapesWithLegend = (layoutOut.shapes || []).filter(function(d) {
	                return d.showlegend;
	              });
	              var allLegendItems = fullData.concat(shapesWithLegend).filter(function(d) {
	                return legendId === (d.legend || "legend");
	              });
	              for (var i = 0; i < allLegendItems.length; i++) {
	                trace = allLegendItems[i];
	                if (!trace.visible) continue;
	                var isShape = trace._isShape;
	                if (trace.showlegend || trace._dfltShowLegend && !(trace._module && trace._module.attributes && trace._module.attributes.showlegend && trace._module.attributes.showlegend.dflt === false)) {
	                  legendTraceCount++;
	                  if (trace.showlegend) {
	                    legendReallyHasATrace = true;
	                    if (!isShape && Registry.traceIs(trace, "pie-like") || trace._input.showlegend === true) {
	                      legendTraceCount++;
	                    }
	                  }
	                  Lib.coerceFont(traceCoerce, "legendgrouptitle.font", grouptitlefont);
	                }
	                if (!isShape && Registry.traceIs(trace, "bar") && layoutOut.barmode === "stack" || ["tonextx", "tonexty"].indexOf(trace.fill) !== -1) {
	                  defaultOrder = helpers.isGrouped({
	                    traceorder: defaultOrder
	                  }) ? "grouped+reversed" : "reversed";
	                }
	                if (trace.legendgroup !== undefined && trace.legendgroup !== "") {
	                  defaultOrder = helpers.isReversed({
	                    traceorder: defaultOrder
	                  }) ? "reversed+grouped" : "grouped";
	                }
	              }
	              var showLegend = Lib.coerce(layoutIn, layoutOut, basePlotLayoutAttributes, "showlegend", legendReallyHasATrace && legendTraceCount > (legendId === "legend" ? 1 : 0));
	              if (showLegend === false) layoutOut[legendId] = undefined;
	              if (showLegend === false && !containerIn.uirevision) return;
	              coerce("uirevision", layoutOut.uirevision);
	              if (showLegend === false) return;
	              coerce("borderwidth");
	              var orientation = coerce("orientation");
	              var yref = coerce("yref");
	              var xref = coerce("xref");
	              var isHorizontal = orientation === "h";
	              var isPaperY = yref === "paper";
	              var isPaperX = xref === "paper";
	              var defaultX, defaultY, defaultYAnchor;
	              var defaultXAnchor = "left";
	              if (isHorizontal) {
	                defaultX = 0;
	                if (Registry.getComponentMethod("rangeslider", "isVisible")(layoutIn.xaxis)) {
	                  if (isPaperY) {
	                    defaultY = 1.1;
	                    defaultYAnchor = "bottom";
	                  } else {
	                    defaultY = 1;
	                    defaultYAnchor = "top";
	                  }
	                } else {
	                  if (isPaperY) {
	                    defaultY = -0.1;
	                    defaultYAnchor = "top";
	                  } else {
	                    defaultY = 0;
	                    defaultYAnchor = "bottom";
	                  }
	                }
	              } else {
	                defaultY = 1;
	                defaultYAnchor = "auto";
	                if (isPaperX) {
	                  defaultX = 1.02;
	                } else {
	                  defaultX = 1;
	                  defaultXAnchor = "right";
	                }
	              }
	              Lib.coerce(containerIn, containerOut, {
	                x: {
	                  valType: "number",
	                  editType: "legend",
	                  min: isPaperX ? -2 : 0,
	                  max: isPaperX ? 3 : 1,
	                  dflt: defaultX
	                }
	              }, "x");
	              Lib.coerce(containerIn, containerOut, {
	                y: {
	                  valType: "number",
	                  editType: "legend",
	                  min: isPaperY ? -2 : 0,
	                  max: isPaperY ? 3 : 1,
	                  dflt: defaultY
	                }
	              }, "y");
	              coerce("traceorder", defaultOrder);
	              if (helpers.isGrouped(layoutOut[legendId])) coerce("tracegroupgap");
	              coerce("entrywidth");
	              coerce("entrywidthmode");
	              coerce("itemsizing");
	              coerce("itemwidth");
	              coerce("itemclick");
	              coerce("itemdoubleclick");
	              coerce("groupclick");
	              coerce("xanchor", defaultXAnchor);
	              coerce("yanchor", defaultYAnchor);
	              coerce("valign");
	              Lib.noneOrAll(containerIn, containerOut, ["x", "y"]);
	              var titleText = coerce("title.text");
	              if (titleText) {
	                coerce("title.side", isHorizontal ? "left" : "top");
	                var dfltTitleFont = Lib.extendFlat({}, itemFont, {
	                  size: Lib.bigFont(itemFont.size)
	                });
	                Lib.coerceFont(coerce, "title.font", dfltTitleFont);
	              }
	            }
	            module2.exports = function legendDefaults(layoutIn, layoutOut, fullData) {
	              var i;
	              var allLegendsData = fullData.slice();
	              var shapes = layoutOut.shapes;
	              if (shapes) {
	                for (i = 0; i < shapes.length; i++) {
	                  var shape = shapes[i];
	                  if (!shape.showlegend) continue;
	                  var mockTrace = {
	                    _input: shape._input,
	                    visible: shape.visible,
	                    showlegend: shape.showlegend,
	                    legend: shape.legend
	                  };
	                  allLegendsData.push(mockTrace);
	                }
	              }
	              var legends = ["legend"];
	              for (i = 0; i < allLegendsData.length; i++) {
	                Lib.pushUnique(legends, allLegendsData[i].legend);
	              }
	              layoutOut._legends = [];
	              for (i = 0; i < legends.length; i++) {
	                var legendId = legends[i];
	                groupDefaults(legendId, layoutIn, layoutOut, allLegendsData);
	                if (layoutOut[legendId] && layoutOut[legendId].visible) {
	                  layoutOut[legendId]._id = legendId;
	                }
	                layoutOut._legends.push(legendId);
	              }
	            };
	          }
	        ),
	        /***/
	        43969: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Plots = __webpack_require__2(74875);
	            var Registry = __webpack_require__2(73972);
	            var Events = __webpack_require__2(11086);
	            var dragElement = __webpack_require__2(28569);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var svgTextUtils = __webpack_require__2(63893);
	            var handleClick = __webpack_require__2(85167);
	            var constants = __webpack_require__2(14928);
	            var alignmentConstants = __webpack_require__2(18783);
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var FROM_TL = alignmentConstants.FROM_TL;
	            var FROM_BR = alignmentConstants.FROM_BR;
	            var getLegendData = __webpack_require__2(82424);
	            var style = __webpack_require__2(53630);
	            var helpers = __webpack_require__2(10130);
	            var MAIN_TITLE = 1;
	            var LEGEND_PATTERN = /^legend[0-9]*$/;
	            module2.exports = function draw(gd, opts) {
	              if (opts) {
	                drawOne(gd, opts);
	              } else {
	                var fullLayout = gd._fullLayout;
	                var newLegends = fullLayout._legends;
	                var oldLegends = fullLayout._infolayer.selectAll('[class^="legend"]');
	                oldLegends.each(function() {
	                  var el = d3.select(this);
	                  var classes = el.attr("class");
	                  var cls = classes.split(" ")[0];
	                  if (cls.match(LEGEND_PATTERN) && newLegends.indexOf(cls) === -1) {
	                    el.remove();
	                  }
	                });
	                for (var i = 0; i < newLegends.length; i++) {
	                  var legendId = newLegends[i];
	                  var legendObj = gd._fullLayout[legendId];
	                  drawOne(gd, legendObj);
	                }
	              }
	            };
	            function horizontalAlignTitle(titleEl, legendObj, bw) {
	              if (legendObj.title.side !== "top center" && legendObj.title.side !== "top right") return;
	              var font = legendObj.title.font;
	              var lineHeight = font.size * LINE_SPACING;
	              var titleOffset = 0;
	              var textNode = titleEl.node();
	              var width = Drawing.bBox(textNode).width;
	              if (legendObj.title.side === "top center") {
	                titleOffset = 0.5 * (legendObj._width - 2 * bw - 2 * constants.titlePad - width);
	              } else if (legendObj.title.side === "top right") {
	                titleOffset = legendObj._width - 2 * bw - 2 * constants.titlePad - width;
	              }
	              svgTextUtils.positionText(titleEl, bw + constants.titlePad + titleOffset, bw + lineHeight);
	            }
	            function drawOne(gd, opts) {
	              var legendObj = opts || {};
	              var fullLayout = gd._fullLayout;
	              var legendId = getId(legendObj);
	              var clipId, layer;
	              var inHover = legendObj._inHover;
	              if (inHover) {
	                layer = legendObj.layer;
	                clipId = "hover";
	              } else {
	                layer = fullLayout._infolayer;
	                clipId = legendId;
	              }
	              if (!layer) return;
	              clipId += fullLayout._uid;
	              if (!gd._legendMouseDownTime) gd._legendMouseDownTime = 0;
	              var legendData;
	              if (!inHover) {
	                var calcdata = (gd.calcdata || []).slice();
	                var shapes = fullLayout.shapes;
	                for (var i = 0; i < shapes.length; i++) {
	                  var shape = shapes[i];
	                  if (!shape.showlegend) continue;
	                  var shapeLegend = {
	                    _isShape: true,
	                    _fullInput: shape,
	                    index: shape._index,
	                    name: shape.name || shape.label.text || "shape " + shape._index,
	                    legend: shape.legend,
	                    legendgroup: shape.legendgroup,
	                    legendgrouptitle: shape.legendgrouptitle,
	                    legendrank: shape.legendrank,
	                    legendwidth: shape.legendwidth,
	                    showlegend: shape.showlegend,
	                    visible: shape.visible,
	                    opacity: shape.opacity,
	                    mode: shape.type === "line" ? "lines" : "markers",
	                    line: shape.line,
	                    marker: {
	                      line: shape.line,
	                      color: shape.fillcolor,
	                      size: 12,
	                      symbol: shape.type === "rect" ? "square" : shape.type === "circle" ? "circle" : (
	                        // case of path
	                        "hexagon2"
	                      )
	                    }
	                  };
	                  calcdata.push([{
	                    trace: shapeLegend
	                  }]);
	                }
	                legendData = fullLayout.showlegend && getLegendData(calcdata, legendObj, fullLayout._legends.length > 1);
	              } else {
	                if (!legendObj.entries) return;
	                legendData = getLegendData(legendObj.entries, legendObj);
	              }
	              var hiddenSlices = fullLayout.hiddenlabels || [];
	              if (!inHover && (!fullLayout.showlegend || !legendData.length)) {
	                layer.selectAll("." + legendId).remove();
	                fullLayout._topdefs.select("#" + clipId).remove();
	                return Plots.autoMargin(gd, legendId);
	              }
	              var legend = Lib.ensureSingle(layer, "g", legendId, function(s) {
	                if (!inHover) s.attr("pointer-events", "all");
	              });
	              var clipPath = Lib.ensureSingleById(fullLayout._topdefs, "clipPath", clipId, function(s) {
	                s.append("rect");
	              });
	              var bg = Lib.ensureSingle(legend, "rect", "bg", function(s) {
	                s.attr("shape-rendering", "crispEdges");
	              });
	              bg.call(Color.stroke, legendObj.bordercolor).call(Color.fill, legendObj.bgcolor).style("stroke-width", legendObj.borderwidth + "px");
	              var scrollBox = Lib.ensureSingle(legend, "g", "scrollbox");
	              var title = legendObj.title;
	              legendObj._titleWidth = 0;
	              legendObj._titleHeight = 0;
	              var titleEl;
	              if (title.text) {
	                titleEl = Lib.ensureSingle(scrollBox, "text", legendId + "titletext");
	                titleEl.attr("text-anchor", "start").call(Drawing.font, title.font).text(title.text);
	                textLayout(titleEl, scrollBox, gd, legendObj, MAIN_TITLE);
	              } else {
	                scrollBox.selectAll("." + legendId + "titletext").remove();
	              }
	              var scrollBar = Lib.ensureSingle(legend, "rect", "scrollbar", function(s) {
	                s.attr(constants.scrollBarEnterAttrs).call(Color.fill, constants.scrollBarColor);
	              });
	              var groups = scrollBox.selectAll("g.groups").data(legendData);
	              groups.enter().append("g").attr("class", "groups");
	              groups.exit().remove();
	              var traces = groups.selectAll("g.traces").data(Lib.identity);
	              traces.enter().append("g").attr("class", "traces");
	              traces.exit().remove();
	              traces.style("opacity", function(d) {
	                var trace = d[0].trace;
	                if (Registry.traceIs(trace, "pie-like")) {
	                  return hiddenSlices.indexOf(d[0].label) !== -1 ? 0.5 : 1;
	                } else {
	                  return trace.visible === "legendonly" ? 0.5 : 1;
	                }
	              }).each(function() {
	                d3.select(this).call(drawTexts, gd, legendObj);
	              }).call(style, gd, legendObj).each(function() {
	                if (!inHover) d3.select(this).call(setupTraceToggle, gd, legendId);
	              });
	              Lib.syncOrAsync([Plots.previousPromises, function() {
	                return computeLegendDimensions(gd, groups, traces, legendObj);
	              }, function() {
	                var gs = fullLayout._size;
	                var bw = legendObj.borderwidth;
	                var isPaperX = legendObj.xref === "paper";
	                var isPaperY = legendObj.yref === "paper";
	                if (title.text) {
	                  horizontalAlignTitle(titleEl, legendObj, bw);
	                }
	                if (!inHover) {
	                  var lx, ly;
	                  if (isPaperX) {
	                    lx = gs.l + gs.w * legendObj.x - FROM_TL[getXanchor(legendObj)] * legendObj._width;
	                  } else {
	                    lx = fullLayout.width * legendObj.x - FROM_TL[getXanchor(legendObj)] * legendObj._width;
	                  }
	                  if (isPaperY) {
	                    ly = gs.t + gs.h * (1 - legendObj.y) - FROM_TL[getYanchor(legendObj)] * legendObj._effHeight;
	                  } else {
	                    ly = fullLayout.height * (1 - legendObj.y) - FROM_TL[getYanchor(legendObj)] * legendObj._effHeight;
	                  }
	                  var expMargin = expandMargin(gd, legendId, lx, ly);
	                  if (expMargin) return;
	                  if (fullLayout.margin.autoexpand) {
	                    var lx0 = lx;
	                    var ly0 = ly;
	                    lx = isPaperX ? Lib.constrain(lx, 0, fullLayout.width - legendObj._width) : lx0;
	                    ly = isPaperY ? Lib.constrain(ly, 0, fullLayout.height - legendObj._effHeight) : ly0;
	                    if (lx !== lx0) {
	                      Lib.log("Constrain " + legendId + ".x to make legend fit inside graph");
	                    }
	                    if (ly !== ly0) {
	                      Lib.log("Constrain " + legendId + ".y to make legend fit inside graph");
	                    }
	                  }
	                  Drawing.setTranslate(legend, lx, ly);
	                }
	                scrollBar.on(".drag", null);
	                legend.on("wheel", null);
	                if (inHover || legendObj._height <= legendObj._maxHeight || gd._context.staticPlot) {
	                  var height = legendObj._effHeight;
	                  if (inHover) height = legendObj._height;
	                  bg.attr({
	                    width: legendObj._width - bw,
	                    height: height - bw,
	                    x: bw / 2,
	                    y: bw / 2
	                  });
	                  Drawing.setTranslate(scrollBox, 0, 0);
	                  clipPath.select("rect").attr({
	                    width: legendObj._width - 2 * bw,
	                    height: height - 2 * bw,
	                    x: bw,
	                    y: bw
	                  });
	                  Drawing.setClipUrl(scrollBox, clipId, gd);
	                  Drawing.setRect(scrollBar, 0, 0, 0, 0);
	                  delete legendObj._scrollY;
	                } else {
	                  var scrollBarHeight = Math.max(constants.scrollBarMinHeight, legendObj._effHeight * legendObj._effHeight / legendObj._height);
	                  var scrollBarYMax = legendObj._effHeight - scrollBarHeight - 2 * constants.scrollBarMargin;
	                  var scrollBoxYMax = legendObj._height - legendObj._effHeight;
	                  var scrollRatio = scrollBarYMax / scrollBoxYMax;
	                  var scrollBoxY = Math.min(legendObj._scrollY || 0, scrollBoxYMax);
	                  bg.attr({
	                    width: legendObj._width - 2 * bw + constants.scrollBarWidth + constants.scrollBarMargin,
	                    height: legendObj._effHeight - bw,
	                    x: bw / 2,
	                    y: bw / 2
	                  });
	                  clipPath.select("rect").attr({
	                    width: legendObj._width - 2 * bw + constants.scrollBarWidth + constants.scrollBarMargin,
	                    height: legendObj._effHeight - 2 * bw,
	                    x: bw,
	                    y: bw + scrollBoxY
	                  });
	                  Drawing.setClipUrl(scrollBox, clipId, gd);
	                  scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                  legend.on("wheel", function() {
	                    scrollBoxY = Lib.constrain(legendObj._scrollY + d3.event.deltaY / scrollBarYMax * scrollBoxYMax, 0, scrollBoxYMax);
	                    scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                    if (scrollBoxY !== 0 && scrollBoxY !== scrollBoxYMax) {
	                      d3.event.preventDefault();
	                    }
	                  });
	                  var eventY0, eventY1, scrollBoxY0;
	                  var getScrollBarDragY = function(scrollBoxY02, eventY02, eventY12) {
	                    var y = (eventY12 - eventY02) / scrollRatio + scrollBoxY02;
	                    return Lib.constrain(y, 0, scrollBoxYMax);
	                  };
	                  var getNaturalDragY = function(scrollBoxY02, eventY02, eventY12) {
	                    var y = (eventY02 - eventY12) / scrollRatio + scrollBoxY02;
	                    return Lib.constrain(y, 0, scrollBoxYMax);
	                  };
	                  var scrollBarDrag = d3.behavior.drag().on("dragstart", function() {
	                    var e = d3.event.sourceEvent;
	                    if (e.type === "touchstart") {
	                      eventY0 = e.changedTouches[0].clientY;
	                    } else {
	                      eventY0 = e.clientY;
	                    }
	                    scrollBoxY0 = scrollBoxY;
	                  }).on("drag", function() {
	                    var e = d3.event.sourceEvent;
	                    if (e.buttons === 2 || e.ctrlKey) return;
	                    if (e.type === "touchmove") {
	                      eventY1 = e.changedTouches[0].clientY;
	                    } else {
	                      eventY1 = e.clientY;
	                    }
	                    scrollBoxY = getScrollBarDragY(scrollBoxY0, eventY0, eventY1);
	                    scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                  });
	                  scrollBar.call(scrollBarDrag);
	                  var scrollBoxTouchDrag = d3.behavior.drag().on("dragstart", function() {
	                    var e = d3.event.sourceEvent;
	                    if (e.type === "touchstart") {
	                      eventY0 = e.changedTouches[0].clientY;
	                      scrollBoxY0 = scrollBoxY;
	                    }
	                  }).on("drag", function() {
	                    var e = d3.event.sourceEvent;
	                    if (e.type === "touchmove") {
	                      eventY1 = e.changedTouches[0].clientY;
	                      scrollBoxY = getNaturalDragY(scrollBoxY0, eventY0, eventY1);
	                      scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
	                    }
	                  });
	                  scrollBox.call(scrollBoxTouchDrag);
	                }
	                function scrollHandler(scrollBoxY2, scrollBarHeight2, scrollRatio2) {
	                  legendObj._scrollY = gd._fullLayout[legendId]._scrollY = scrollBoxY2;
	                  Drawing.setTranslate(scrollBox, 0, -scrollBoxY2);
	                  Drawing.setRect(scrollBar, legendObj._width, constants.scrollBarMargin + scrollBoxY2 * scrollRatio2, constants.scrollBarWidth, scrollBarHeight2);
	                  clipPath.select("rect").attr("y", bw + scrollBoxY2);
	                }
	                if (gd._context.edits.legendPosition) {
	                  var xf, yf, x0, y0;
	                  legend.classed("cursor-move", true);
	                  dragElement.init({
	                    element: legend.node(),
	                    gd,
	                    prepFn: function() {
	                      var transform = Drawing.getTranslate(legend);
	                      x0 = transform.x;
	                      y0 = transform.y;
	                    },
	                    moveFn: function(dx, dy) {
	                      var newX = x0 + dx;
	                      var newY = y0 + dy;
	                      Drawing.setTranslate(legend, newX, newY);
	                      xf = dragElement.align(newX, legendObj._width, gs.l, gs.l + gs.w, legendObj.xanchor);
	                      yf = dragElement.align(newY + legendObj._height, -legendObj._height, gs.t + gs.h, gs.t, legendObj.yanchor);
	                    },
	                    doneFn: function() {
	                      if (xf !== undefined && yf !== undefined) {
	                        var obj = {};
	                        obj[legendId + ".x"] = xf;
	                        obj[legendId + ".y"] = yf;
	                        Registry.call("_guiRelayout", gd, obj);
	                      }
	                    },
	                    clickFn: function(numClicks, e) {
	                      var clickedTrace = layer.selectAll("g.traces").filter(function() {
	                        var bbox = this.getBoundingClientRect();
	                        return e.clientX >= bbox.left && e.clientX <= bbox.right && e.clientY >= bbox.top && e.clientY <= bbox.bottom;
	                      });
	                      if (clickedTrace.size() > 0) {
	                        clickOrDoubleClick(gd, legend, clickedTrace, numClicks, e);
	                      }
	                    }
	                  });
	                }
	              }], gd);
	            }
	            function getTraceWidth(d, legendObj, textGap) {
	              var legendItem = d[0];
	              var legendWidth = legendItem.width;
	              var mode = legendObj.entrywidthmode;
	              var traceLegendWidth = legendItem.trace.legendwidth || legendObj.entrywidth;
	              if (mode === "fraction") return legendObj._maxWidth * traceLegendWidth;
	              return textGap + (traceLegendWidth || legendWidth);
	            }
	            function clickOrDoubleClick(gd, legend, legendItem, numClicks, evt) {
	              var trace = legendItem.data()[0][0].trace;
	              var evtData = {
	                event: evt,
	                node: legendItem.node(),
	                curveNumber: trace.index,
	                expandedIndex: trace._expandedIndex,
	                data: gd.data,
	                layout: gd.layout,
	                frames: gd._transitionData._frames,
	                config: gd._context,
	                fullData: gd._fullData,
	                fullLayout: gd._fullLayout
	              };
	              if (trace._group) {
	                evtData.group = trace._group;
	              }
	              if (Registry.traceIs(trace, "pie-like")) {
	                evtData.label = legendItem.datum()[0].label;
	              }
	              var clickVal = Events.triggerHandler(gd, "plotly_legendclick", evtData);
	              if (numClicks === 1) {
	                if (clickVal === false) return;
	                legend._clickTimeout = setTimeout(function() {
	                  if (!gd._fullLayout) return;
	                  handleClick(legendItem, gd, numClicks);
	                }, gd._context.doubleClickDelay);
	              } else if (numClicks === 2) {
	                if (legend._clickTimeout) clearTimeout(legend._clickTimeout);
	                gd._legendMouseDownTime = 0;
	                var dblClickVal = Events.triggerHandler(gd, "plotly_legenddoubleclick", evtData);
	                if (dblClickVal !== false && clickVal !== false) handleClick(legendItem, gd, numClicks);
	              }
	            }
	            function drawTexts(g, gd, legendObj) {
	              var legendId = getId(legendObj);
	              var legendItem = g.data()[0][0];
	              var trace = legendItem.trace;
	              var isPieLike = Registry.traceIs(trace, "pie-like");
	              var isEditable = !legendObj._inHover && gd._context.edits.legendText && !isPieLike;
	              var maxNameLength = legendObj._maxNameLength;
	              var name2, font;
	              if (legendItem.groupTitle) {
	                name2 = legendItem.groupTitle.text;
	                font = legendItem.groupTitle.font;
	              } else {
	                font = legendObj.font;
	                if (!legendObj.entries) {
	                  name2 = isPieLike ? legendItem.label : trace.name;
	                  if (trace._meta) {
	                    name2 = Lib.templateString(name2, trace._meta);
	                  }
	                } else {
	                  name2 = legendItem.text;
	                }
	              }
	              var textEl = Lib.ensureSingle(g, "text", legendId + "text");
	              textEl.attr("text-anchor", "start").call(Drawing.font, font).text(isEditable ? ensureLength(name2, maxNameLength) : name2);
	              var textGap = legendObj.itemwidth + constants.itemGap * 2;
	              svgTextUtils.positionText(textEl, textGap, 0);
	              if (isEditable) {
	                textEl.call(svgTextUtils.makeEditable, {
	                  gd,
	                  text: name2
	                }).call(textLayout, g, gd, legendObj).on("edit", function(newName) {
	                  this.text(ensureLength(newName, maxNameLength)).call(textLayout, g, gd, legendObj);
	                  var fullInput = legendItem.trace._fullInput || {};
	                  var update = {};
	                  if (Registry.hasTransform(fullInput, "groupby")) {
	                    var groupbyIndices = Registry.getTransformIndices(fullInput, "groupby");
	                    var _index = groupbyIndices[groupbyIndices.length - 1];
	                    var kcont = Lib.keyedContainer(fullInput, "transforms[" + _index + "].styles", "target", "value.name");
	                    kcont.set(legendItem.trace._group, newName);
	                    update = kcont.constructUpdate();
	                  } else {
	                    update.name = newName;
	                  }
	                  if (fullInput._isShape) {
	                    return Registry.call("_guiRelayout", gd, "shapes[" + trace.index + "].name", update.name);
	                  } else {
	                    return Registry.call("_guiRestyle", gd, update, trace.index);
	                  }
	                });
	              } else {
	                textLayout(textEl, g, gd, legendObj);
	              }
	            }
	            function ensureLength(str, maxLength) {
	              var targetLength = Math.max(4, maxLength);
	              if (str && str.trim().length >= targetLength / 2) return str;
	              str = str || "";
	              for (var i = targetLength - str.length; i > 0; i--) str += " ";
	              return str;
	            }
	            function setupTraceToggle(g, gd, legendId) {
	              var doubleClickDelay = gd._context.doubleClickDelay;
	              var newMouseDownTime;
	              var numClicks = 1;
	              var traceToggle = Lib.ensureSingle(g, "rect", legendId + "toggle", function(s) {
	                if (!gd._context.staticPlot) {
	                  s.style("cursor", "pointer").attr("pointer-events", "all");
	                }
	                s.call(Color.fill, "rgba(0,0,0,0)");
	              });
	              if (gd._context.staticPlot) return;
	              traceToggle.on("mousedown", function() {
	                newMouseDownTime = (/* @__PURE__ */ new Date()).getTime();
	                if (newMouseDownTime - gd._legendMouseDownTime < doubleClickDelay) {
	                  numClicks += 1;
	                } else {
	                  numClicks = 1;
	                  gd._legendMouseDownTime = newMouseDownTime;
	                }
	              });
	              traceToggle.on("mouseup", function() {
	                if (gd._dragged || gd._editing) return;
	                var legend = gd._fullLayout[legendId];
	                if ((/* @__PURE__ */ new Date()).getTime() - gd._legendMouseDownTime > doubleClickDelay) {
	                  numClicks = Math.max(numClicks - 1, 1);
	                }
	                clickOrDoubleClick(gd, legend, g, numClicks, d3.event);
	              });
	            }
	            function textLayout(s, g, gd, legendObj, aTitle) {
	              if (legendObj._inHover) s.attr("data-notex", true);
	              svgTextUtils.convertToTspans(s, gd, function() {
	                computeTextDimensions(g, gd, legendObj, aTitle);
	              });
	            }
	            function computeTextDimensions(g, gd, legendObj, aTitle) {
	              var legendItem = g.data()[0][0];
	              if (!legendObj._inHover && legendItem && !legendItem.trace.showlegend) {
	                g.remove();
	                return;
	              }
	              var mathjaxGroup = g.select("g[class*=math-group]");
	              var mathjaxNode = mathjaxGroup.node();
	              var legendId = getId(legendObj);
	              if (!legendObj) {
	                legendObj = gd._fullLayout[legendId];
	              }
	              var bw = legendObj.borderwidth;
	              var font;
	              if (aTitle === MAIN_TITLE) {
	                font = legendObj.title.font;
	              } else if (legendItem.groupTitle) {
	                font = legendItem.groupTitle.font;
	              } else {
	                font = legendObj.font;
	              }
	              var lineHeight = font.size * LINE_SPACING;
	              var height, width;
	              if (mathjaxNode) {
	                var mathjaxBB = Drawing.bBox(mathjaxNode);
	                height = mathjaxBB.height;
	                width = mathjaxBB.width;
	                if (aTitle === MAIN_TITLE) {
	                  Drawing.setTranslate(mathjaxGroup, bw, bw + height * 0.75);
	                } else {
	                  Drawing.setTranslate(mathjaxGroup, 0, height * 0.25);
	                }
	              } else {
	                var cls = "." + legendId + (aTitle === MAIN_TITLE ? "title" : "") + "text";
	                var textEl = g.select(cls);
	                var textLines = svgTextUtils.lineCount(textEl);
	                var textNode = textEl.node();
	                height = lineHeight * textLines;
	                width = textNode ? Drawing.bBox(textNode).width : 0;
	                if (aTitle === MAIN_TITLE) {
	                  if (legendObj.title.side === "left") {
	                    width += constants.itemGap * 2;
	                  }
	                  svgTextUtils.positionText(textEl, bw + constants.titlePad, bw + lineHeight);
	                } else {
	                  var x = constants.itemGap * 2 + legendObj.itemwidth;
	                  if (legendItem.groupTitle) {
	                    x = constants.itemGap;
	                    width -= legendObj.itemwidth;
	                  }
	                  svgTextUtils.positionText(textEl, x, -lineHeight * ((textLines - 1) / 2 - 0.3));
	                }
	              }
	              if (aTitle === MAIN_TITLE) {
	                legendObj._titleWidth = width;
	                legendObj._titleHeight = height;
	              } else {
	                legendItem.lineHeight = lineHeight;
	                legendItem.height = Math.max(height, 16) + 3;
	                legendItem.width = width;
	              }
	            }
	            function getTitleSize(legendObj) {
	              var w = 0;
	              var h = 0;
	              var side = legendObj.title.side;
	              if (side) {
	                if (side.indexOf("left") !== -1) {
	                  w = legendObj._titleWidth;
	                }
	                if (side.indexOf("top") !== -1) {
	                  h = legendObj._titleHeight;
	                }
	              }
	              return [w, h];
	            }
	            function computeLegendDimensions(gd, groups, traces, legendObj) {
	              var fullLayout = gd._fullLayout;
	              var legendId = getId(legendObj);
	              if (!legendObj) {
	                legendObj = fullLayout[legendId];
	              }
	              var gs = fullLayout._size;
	              var isVertical = helpers.isVertical(legendObj);
	              var isGrouped = helpers.isGrouped(legendObj);
	              var isFraction = legendObj.entrywidthmode === "fraction";
	              var bw = legendObj.borderwidth;
	              var bw2 = 2 * bw;
	              var itemGap = constants.itemGap;
	              var textGap = legendObj.itemwidth + itemGap * 2;
	              var endPad = 2 * (bw + itemGap);
	              var yanchor = getYanchor(legendObj);
	              var isBelowPlotArea = legendObj.y < 0 || legendObj.y === 0 && yanchor === "top";
	              var isAbovePlotArea = legendObj.y > 1 || legendObj.y === 1 && yanchor === "bottom";
	              var traceGroupGap = legendObj.tracegroupgap;
	              var legendGroupWidths = {};
	              legendObj._maxHeight = Math.max(isBelowPlotArea || isAbovePlotArea ? fullLayout.height / 2 : gs.h, 30);
	              var toggleRectWidth = 0;
	              legendObj._width = 0;
	              legendObj._height = 0;
	              var titleSize = getTitleSize(legendObj);
	              if (isVertical) {
	                traces.each(function(d) {
	                  var h = d[0].height;
	                  Drawing.setTranslate(this, bw + titleSize[0], bw + titleSize[1] + legendObj._height + h / 2 + itemGap);
	                  legendObj._height += h;
	                  legendObj._width = Math.max(legendObj._width, d[0].width);
	                });
	                toggleRectWidth = textGap + legendObj._width;
	                legendObj._width += itemGap + textGap + bw2;
	                legendObj._height += endPad;
	                if (isGrouped) {
	                  groups.each(function(d, i) {
	                    Drawing.setTranslate(this, 0, i * legendObj.tracegroupgap);
	                  });
	                  legendObj._height += (legendObj._lgroupsLength - 1) * legendObj.tracegroupgap;
	                }
	              } else {
	                var xanchor = getXanchor(legendObj);
	                var isLeftOfPlotArea = legendObj.x < 0 || legendObj.x === 0 && xanchor === "right";
	                var isRightOfPlotArea = legendObj.x > 1 || legendObj.x === 1 && xanchor === "left";
	                var isBeyondPlotAreaY = isAbovePlotArea || isBelowPlotArea;
	                var hw = fullLayout.width / 2;
	                legendObj._maxWidth = Math.max(isLeftOfPlotArea ? isBeyondPlotAreaY && xanchor === "left" ? gs.l + gs.w : hw : isRightOfPlotArea ? isBeyondPlotAreaY && xanchor === "right" ? gs.r + gs.w : hw : gs.w, 2 * textGap);
	                var maxItemWidth = 0;
	                var combinedItemWidth = 0;
	                traces.each(function(d) {
	                  var w = getTraceWidth(d, legendObj, textGap);
	                  maxItemWidth = Math.max(maxItemWidth, w);
	                  combinedItemWidth += w;
	                });
	                toggleRectWidth = null;
	                var maxRowWidth = 0;
	                if (isGrouped) {
	                  var maxGroupHeightInRow = 0;
	                  var groupOffsetX = 0;
	                  var groupOffsetY = 0;
	                  groups.each(function() {
	                    var maxWidthInGroup = 0;
	                    var offsetY2 = 0;
	                    d3.select(this).selectAll("g.traces").each(function(d) {
	                      var w = getTraceWidth(d, legendObj, textGap);
	                      var h = d[0].height;
	                      Drawing.setTranslate(this, titleSize[0], titleSize[1] + bw + itemGap + h / 2 + offsetY2);
	                      offsetY2 += h;
	                      maxWidthInGroup = Math.max(maxWidthInGroup, w);
	                      legendGroupWidths[d[0].trace.legendgroup] = maxWidthInGroup;
	                    });
	                    var next = maxWidthInGroup + itemGap;
	                    if (
	                      // not on the first column already
	                      groupOffsetX > 0 && // goes beyound limit
	                      next + bw + groupOffsetX > legendObj._maxWidth
	                    ) {
	                      maxRowWidth = Math.max(maxRowWidth, groupOffsetX);
	                      groupOffsetX = 0;
	                      groupOffsetY += maxGroupHeightInRow + traceGroupGap;
	                      maxGroupHeightInRow = offsetY2;
	                    } else {
	                      maxGroupHeightInRow = Math.max(maxGroupHeightInRow, offsetY2);
	                    }
	                    Drawing.setTranslate(this, groupOffsetX, groupOffsetY);
	                    groupOffsetX += next;
	                  });
	                  legendObj._width = Math.max(maxRowWidth, groupOffsetX) + bw;
	                  legendObj._height = groupOffsetY + maxGroupHeightInRow + endPad;
	                } else {
	                  var nTraces = traces.size();
	                  var oneRowLegend = combinedItemWidth + bw2 + (nTraces - 1) * itemGap < legendObj._maxWidth;
	                  var maxItemHeightInRow = 0;
	                  var offsetX = 0;
	                  var offsetY = 0;
	                  var rowWidth = 0;
	                  traces.each(function(d) {
	                    var h = d[0].height;
	                    var w = getTraceWidth(d, legendObj, textGap);
	                    var next = oneRowLegend ? w : maxItemWidth;
	                    if (!isFraction) {
	                      next += itemGap;
	                    }
	                    if (next + bw + offsetX - itemGap >= legendObj._maxWidth) {
	                      maxRowWidth = Math.max(maxRowWidth, rowWidth);
	                      offsetX = 0;
	                      offsetY += maxItemHeightInRow;
	                      legendObj._height += maxItemHeightInRow;
	                      maxItemHeightInRow = 0;
	                    }
	                    Drawing.setTranslate(this, titleSize[0] + bw + offsetX, titleSize[1] + bw + offsetY + h / 2 + itemGap);
	                    rowWidth = offsetX + w + itemGap;
	                    offsetX += next;
	                    maxItemHeightInRow = Math.max(maxItemHeightInRow, h);
	                  });
	                  if (oneRowLegend) {
	                    legendObj._width = offsetX + bw2;
	                    legendObj._height = maxItemHeightInRow + endPad;
	                  } else {
	                    legendObj._width = Math.max(maxRowWidth, rowWidth) + bw2;
	                    legendObj._height += maxItemHeightInRow + endPad;
	                  }
	                }
	              }
	              legendObj._width = Math.ceil(Math.max(legendObj._width + titleSize[0], legendObj._titleWidth + 2 * (bw + constants.titlePad)));
	              legendObj._height = Math.ceil(Math.max(legendObj._height + titleSize[1], legendObj._titleHeight + 2 * (bw + constants.itemGap)));
	              legendObj._effHeight = Math.min(legendObj._height, legendObj._maxHeight);
	              var edits = gd._context.edits;
	              var isEditable = edits.legendText || edits.legendPosition;
	              traces.each(function(d) {
	                var traceToggle = d3.select(this).select("." + legendId + "toggle");
	                var h = d[0].height;
	                var legendgroup = d[0].trace.legendgroup;
	                var traceWidth = getTraceWidth(d, legendObj, textGap);
	                if (isGrouped && legendgroup !== "") {
	                  traceWidth = legendGroupWidths[legendgroup];
	                }
	                var w = isEditable ? textGap : toggleRectWidth || traceWidth;
	                if (!isVertical && !isFraction) {
	                  w += itemGap / 2;
	                }
	                Drawing.setRect(traceToggle, 0, -h / 2, w, h);
	              });
	            }
	            function expandMargin(gd, legendId, lx, ly) {
	              var fullLayout = gd._fullLayout;
	              var legendObj = fullLayout[legendId];
	              var xanchor = getXanchor(legendObj);
	              var yanchor = getYanchor(legendObj);
	              var isPaperX = legendObj.xref === "paper";
	              var isPaperY = legendObj.yref === "paper";
	              gd._fullLayout._reservedMargin[legendId] = {};
	              var sideY = legendObj.y < 0.5 ? "b" : "t";
	              var sideX = legendObj.x < 0.5 ? "l" : "r";
	              var possibleReservedMargins = {
	                r: fullLayout.width - lx,
	                l: lx + legendObj._width,
	                b: fullLayout.height - ly,
	                t: ly + legendObj._effHeight
	              };
	              if (isPaperX && isPaperY) {
	                return Plots.autoMargin(gd, legendId, {
	                  x: legendObj.x,
	                  y: legendObj.y,
	                  l: legendObj._width * FROM_TL[xanchor],
	                  r: legendObj._width * FROM_BR[xanchor],
	                  b: legendObj._effHeight * FROM_BR[yanchor],
	                  t: legendObj._effHeight * FROM_TL[yanchor]
	                });
	              } else if (isPaperX) {
	                gd._fullLayout._reservedMargin[legendId][sideY] = possibleReservedMargins[sideY];
	              } else if (isPaperY) {
	                gd._fullLayout._reservedMargin[legendId][sideX] = possibleReservedMargins[sideX];
	              } else {
	                if (legendObj.orientation === "v") {
	                  gd._fullLayout._reservedMargin[legendId][sideX] = possibleReservedMargins[sideX];
	                } else {
	                  gd._fullLayout._reservedMargin[legendId][sideY] = possibleReservedMargins[sideY];
	                }
	              }
	            }
	            function getXanchor(legendObj) {
	              return Lib.isRightAnchor(legendObj) ? "right" : Lib.isCenterAnchor(legendObj) ? "center" : "left";
	            }
	            function getYanchor(legendObj) {
	              return Lib.isBottomAnchor(legendObj) ? "bottom" : Lib.isMiddleAnchor(legendObj) ? "middle" : "top";
	            }
	            function getId(legendObj) {
	              return legendObj._id || "legend";
	            }
	          }
	        ),
	        /***/
	        82424: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var helpers = __webpack_require__2(10130);
	            module2.exports = function getLegendData(calcdata, opts, hasMultipleLegends) {
	              var inHover = opts._inHover;
	              var grouped = helpers.isGrouped(opts);
	              var reversed = helpers.isReversed(opts);
	              var lgroupToTraces = {};
	              var lgroups = [];
	              var hasOneNonBlankGroup = false;
	              var slicesShown = {};
	              var lgroupi = 0;
	              var maxNameLength = 0;
	              var i, j;
	              function addOneItem(legendId, legendGroup, legendItem) {
	                if (opts.visible === false) return;
	                if (hasMultipleLegends && legendId !== opts._id) return;
	                if (legendGroup === "" || !helpers.isGrouped(opts)) {
	                  var uniqueGroup = "~~i" + lgroupi;
	                  lgroups.push(uniqueGroup);
	                  lgroupToTraces[uniqueGroup] = [legendItem];
	                  lgroupi++;
	                } else if (lgroups.indexOf(legendGroup) === -1) {
	                  lgroups.push(legendGroup);
	                  hasOneNonBlankGroup = true;
	                  lgroupToTraces[legendGroup] = [legendItem];
	                } else {
	                  lgroupToTraces[legendGroup].push(legendItem);
	                }
	              }
	              for (i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var lid = trace.legend;
	                var lgroup = trace.legendgroup;
	                if (!inHover && (!trace.visible || !trace.showlegend)) continue;
	                if (Registry.traceIs(trace, "pie-like")) {
	                  if (!slicesShown[lgroup]) slicesShown[lgroup] = {};
	                  for (j = 0; j < cd.length; j++) {
	                    var labelj = cd[j].label;
	                    if (!slicesShown[lgroup][labelj]) {
	                      addOneItem(lid, lgroup, {
	                        label: labelj,
	                        color: cd[j].color,
	                        i: cd[j].i,
	                        trace,
	                        pts: cd[j].pts
	                      });
	                      slicesShown[lgroup][labelj] = true;
	                      maxNameLength = Math.max(maxNameLength, (labelj || "").length);
	                    }
	                  }
	                } else {
	                  addOneItem(lid, lgroup, cd0);
	                  maxNameLength = Math.max(maxNameLength, (trace.name || "").length);
	                }
	              }
	              if (!lgroups.length) return [];
	              var shouldCollapse = !hasOneNonBlankGroup || !grouped;
	              var legendData = [];
	              for (i = 0; i < lgroups.length; i++) {
	                var t = lgroupToTraces[lgroups[i]];
	                if (shouldCollapse) {
	                  legendData.push(t[0]);
	                } else {
	                  legendData.push(t);
	                }
	              }
	              if (shouldCollapse) legendData = [legendData];
	              for (i = 0; i < legendData.length; i++) {
	                var groupMinRank = Infinity;
	                for (j = 0; j < legendData[i].length; j++) {
	                  var rank = legendData[i][j].trace.legendrank;
	                  if (groupMinRank > rank) groupMinRank = rank;
	                }
	                legendData[i][0]._groupMinRank = groupMinRank;
	                legendData[i][0]._preGroupSort = i;
	              }
	              var orderFn1 = function(a, b) {
	                return a[0]._groupMinRank - b[0]._groupMinRank || a[0]._preGroupSort - b[0]._preGroupSort;
	              };
	              var orderFn2 = function(a, b) {
	                return a.trace.legendrank - b.trace.legendrank || a._preSort - b._preSort;
	              };
	              legendData.forEach(function(a, k) {
	                a[0]._preGroupSort = k;
	              });
	              legendData.sort(orderFn1);
	              for (i = 0; i < legendData.length; i++) {
	                legendData[i].forEach(function(a, k) {
	                  a._preSort = k;
	                });
	                legendData[i].sort(orderFn2);
	                var firstItemTrace = legendData[i][0].trace;
	                var groupTitle = null;
	                for (j = 0; j < legendData[i].length; j++) {
	                  var gt = legendData[i][j].trace.legendgrouptitle;
	                  if (gt && gt.text) {
	                    groupTitle = gt;
	                    if (inHover) gt.font = opts._groupTitleFont;
	                    break;
	                  }
	                }
	                if (reversed) legendData[i].reverse();
	                if (groupTitle) {
	                  var hasPieLike = false;
	                  for (j = 0; j < legendData[i].length; j++) {
	                    if (Registry.traceIs(legendData[i][j].trace, "pie-like")) {
	                      hasPieLike = true;
	                      break;
	                    }
	                  }
	                  legendData[i].unshift({
	                    i: -1,
	                    groupTitle,
	                    noClick: hasPieLike,
	                    trace: {
	                      showlegend: firstItemTrace.showlegend,
	                      legendgroup: firstItemTrace.legendgroup,
	                      visible: opts.groupclick === "toggleitem" ? true : firstItemTrace.visible
	                    }
	                  });
	                }
	                for (j = 0; j < legendData[i].length; j++) {
	                  legendData[i][j] = [legendData[i][j]];
	                }
	              }
	              opts._lgroupsLength = legendData.length;
	              opts._maxNameLength = maxNameLength;
	              return legendData;
	            };
	          }
	        ),
	        /***/
	        85167: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var pushUnique = Lib.pushUnique;
	            var SHOWISOLATETIP = true;
	            module2.exports = function handleClick(g, gd, numClicks) {
	              var fullLayout = gd._fullLayout;
	              if (gd._dragged || gd._editing) return;
	              var itemClick = fullLayout.legend.itemclick;
	              var itemDoubleClick = fullLayout.legend.itemdoubleclick;
	              var groupClick = fullLayout.legend.groupclick;
	              if (numClicks === 1 && itemClick === "toggle" && itemDoubleClick === "toggleothers" && SHOWISOLATETIP && gd.data && gd._context.showTips) {
	                Lib.notifier(Lib._(gd, "Double-click on legend to isolate one trace"), "long");
	                SHOWISOLATETIP = false;
	              } else {
	                SHOWISOLATETIP = false;
	              }
	              var mode;
	              if (numClicks === 1) mode = itemClick;
	              else if (numClicks === 2) mode = itemDoubleClick;
	              if (!mode) return;
	              var toggleGroup = groupClick === "togglegroup";
	              var hiddenSlices = fullLayout.hiddenlabels ? fullLayout.hiddenlabels.slice() : [];
	              var legendItem = g.data()[0][0];
	              if (legendItem.groupTitle && legendItem.noClick) return;
	              var fullData = gd._fullData;
	              var shapesWithLegend = (fullLayout.shapes || []).filter(function(d2) {
	                return d2.showlegend;
	              });
	              var allLegendItems = fullData.concat(shapesWithLegend);
	              var fullTrace = legendItem.trace;
	              if (fullTrace._isShape) {
	                fullTrace = fullTrace._fullInput;
	              }
	              var legendgroup = fullTrace.legendgroup;
	              var i, j, kcont, key, keys, val;
	              var dataUpdate = {};
	              var dataIndices = [];
	              var carrs = [];
	              var carrIdx = [];
	              function insertDataUpdate(traceIndex, value) {
	                var attrIndex = dataIndices.indexOf(traceIndex);
	                var valueArray = dataUpdate.visible;
	                if (!valueArray) {
	                  valueArray = dataUpdate.visible = [];
	                }
	                if (dataIndices.indexOf(traceIndex) === -1) {
	                  dataIndices.push(traceIndex);
	                  attrIndex = dataIndices.length - 1;
	                }
	                valueArray[attrIndex] = value;
	                return attrIndex;
	              }
	              var updatedShapes = (fullLayout.shapes || []).map(function(d2) {
	                return d2._input;
	              });
	              var shapesUpdated = false;
	              function insertShapesUpdate(shapeIndex, value) {
	                updatedShapes[shapeIndex].visible = value;
	                shapesUpdated = true;
	              }
	              function setVisibility(fullTrace2, visibility) {
	                if (legendItem.groupTitle && !toggleGroup) return;
	                var fullInput2 = fullTrace2._fullInput || fullTrace2;
	                var isShape2 = fullInput2._isShape;
	                var index = fullInput2.index;
	                if (index === undefined) index = fullInput2._index;
	                if (Registry.hasTransform(fullInput2, "groupby")) {
	                  var kcont2 = carrs[index];
	                  if (!kcont2) {
	                    var groupbyIndices = Registry.getTransformIndices(fullInput2, "groupby");
	                    var lastGroupbyIndex = groupbyIndices[groupbyIndices.length - 1];
	                    kcont2 = Lib.keyedContainer(fullInput2, "transforms[" + lastGroupbyIndex + "].styles", "target", "value.visible");
	                    carrs[index] = kcont2;
	                  }
	                  var curState = kcont2.get(fullTrace2._group);
	                  if (curState === undefined) {
	                    curState = true;
	                  }
	                  if (curState !== false) {
	                    kcont2.set(fullTrace2._group, visibility);
	                  }
	                  carrIdx[index] = insertDataUpdate(index, fullInput2.visible === false ? false : true);
	                } else {
	                  var nextVisibility2 = fullInput2.visible === false ? false : visibility;
	                  if (isShape2) {
	                    insertShapesUpdate(index, nextVisibility2);
	                  } else {
	                    insertDataUpdate(index, nextVisibility2);
	                  }
	                }
	              }
	              var thisLegend = fullTrace.legend;
	              var fullInput = fullTrace._fullInput;
	              var isShape = fullInput && fullInput._isShape;
	              if (!isShape && Registry.traceIs(fullTrace, "pie-like")) {
	                var thisLabel = legendItem.label;
	                var thisLabelIndex = hiddenSlices.indexOf(thisLabel);
	                if (mode === "toggle") {
	                  if (thisLabelIndex === -1) hiddenSlices.push(thisLabel);
	                  else hiddenSlices.splice(thisLabelIndex, 1);
	                } else if (mode === "toggleothers") {
	                  var changed = thisLabelIndex !== -1;
	                  var unhideList = [];
	                  for (i = 0; i < gd.calcdata.length; i++) {
	                    var cdi = gd.calcdata[i];
	                    for (j = 0; j < cdi.length; j++) {
	                      var d = cdi[j];
	                      var dLabel = d.label;
	                      if (thisLegend === cdi[0].trace.legend) {
	                        if (thisLabel !== dLabel) {
	                          if (hiddenSlices.indexOf(dLabel) === -1) changed = true;
	                          pushUnique(hiddenSlices, dLabel);
	                          unhideList.push(dLabel);
	                        }
	                      }
	                    }
	                  }
	                  if (!changed) {
	                    for (var q = 0; q < unhideList.length; q++) {
	                      var pos = hiddenSlices.indexOf(unhideList[q]);
	                      if (pos !== -1) {
	                        hiddenSlices.splice(pos, 1);
	                      }
	                    }
	                  }
	                }
	                Registry.call("_guiRelayout", gd, "hiddenlabels", hiddenSlices);
	              } else {
	                var hasLegendgroup = legendgroup && legendgroup.length;
	                var traceIndicesInGroup = [];
	                var tracei;
	                if (hasLegendgroup) {
	                  for (i = 0; i < allLegendItems.length; i++) {
	                    tracei = allLegendItems[i];
	                    if (!tracei.visible) continue;
	                    if (tracei.legendgroup === legendgroup) {
	                      traceIndicesInGroup.push(i);
	                    }
	                  }
	                }
	                if (mode === "toggle") {
	                  var nextVisibility;
	                  switch (fullTrace.visible) {
	                    case true:
	                      nextVisibility = "legendonly";
	                      break;
	                    case false:
	                      nextVisibility = false;
	                      break;
	                    case "legendonly":
	                      nextVisibility = true;
	                      break;
	                  }
	                  if (hasLegendgroup) {
	                    if (toggleGroup) {
	                      for (i = 0; i < allLegendItems.length; i++) {
	                        var item = allLegendItems[i];
	                        if (item.visible !== false && item.legendgroup === legendgroup) {
	                          setVisibility(item, nextVisibility);
	                        }
	                      }
	                    } else {
	                      setVisibility(fullTrace, nextVisibility);
	                    }
	                  } else {
	                    setVisibility(fullTrace, nextVisibility);
	                  }
	                } else if (mode === "toggleothers") {
	                  var isClicked, isInGroup, notInLegend, otherState, _item;
	                  var isIsolated = true;
	                  for (i = 0; i < allLegendItems.length; i++) {
	                    _item = allLegendItems[i];
	                    isClicked = _item === fullTrace;
	                    notInLegend = _item.showlegend !== true;
	                    if (isClicked || notInLegend) continue;
	                    isInGroup = hasLegendgroup && _item.legendgroup === legendgroup;
	                    if (!isInGroup && _item.legend === thisLegend && _item.visible === true && !Registry.traceIs(_item, "notLegendIsolatable")) {
	                      isIsolated = false;
	                      break;
	                    }
	                  }
	                  for (i = 0; i < allLegendItems.length; i++) {
	                    _item = allLegendItems[i];
	                    if (_item.visible === false || _item.legend !== thisLegend) continue;
	                    if (Registry.traceIs(_item, "notLegendIsolatable")) {
	                      continue;
	                    }
	                    switch (fullTrace.visible) {
	                      case "legendonly":
	                        setVisibility(_item, true);
	                        break;
	                      case true:
	                        otherState = isIsolated ? true : "legendonly";
	                        isClicked = _item === fullTrace;
	                        notInLegend = _item.showlegend !== true && !_item.legendgroup;
	                        isInGroup = isClicked || hasLegendgroup && _item.legendgroup === legendgroup;
	                        setVisibility(_item, isInGroup || notInLegend ? true : otherState);
	                        break;
	                    }
	                  }
	                }
	                for (i = 0; i < carrs.length; i++) {
	                  kcont = carrs[i];
	                  if (!kcont) continue;
	                  var update = kcont.constructUpdate();
	                  var updateKeys = Object.keys(update);
	                  for (j = 0; j < updateKeys.length; j++) {
	                    key = updateKeys[j];
	                    val = dataUpdate[key] = dataUpdate[key] || [];
	                    val[carrIdx[i]] = update[key];
	                  }
	                }
	                keys = Object.keys(dataUpdate);
	                for (i = 0; i < keys.length; i++) {
	                  key = keys[i];
	                  for (j = 0; j < dataIndices.length; j++) {
	                    if (!dataUpdate[key].hasOwnProperty(j)) {
	                      dataUpdate[key][j] = undefined;
	                    }
	                  }
	                }
	                if (shapesUpdated) {
	                  Registry.call("_guiUpdate", gd, dataUpdate, {
	                    shapes: updatedShapes
	                  }, dataIndices);
	                } else {
	                  Registry.call("_guiRestyle", gd, dataUpdate, dataIndices);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        10130: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.isGrouped = function isGrouped(legendLayout) {
	              return (legendLayout.traceorder || "").indexOf("grouped") !== -1;
	            };
	            exports2.isVertical = function isVertical(legendLayout) {
	              return legendLayout.orientation !== "h";
	            };
	            exports2.isReversed = function isReversed(legendLayout) {
	              return (legendLayout.traceorder || "").indexOf("reversed") !== -1;
	            };
	          }
	        ),
	        /***/
	        2199: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "component",
	              name: "legend",
	              layoutAttributes: __webpack_require__2(33030),
	              supplyLayoutDefaults: __webpack_require__2(99017),
	              draw: __webpack_require__2(43969),
	              style: __webpack_require__2(53630)
	            };
	          }
	        ),
	        /***/
	        53630: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var extractOpts = __webpack_require__2(52075).extractOpts;
	            var subTypes = __webpack_require__2(34098);
	            var stylePie = __webpack_require__2(63463);
	            var pieCastOption = __webpack_require__2(53581).castOption;
	            var constants = __webpack_require__2(14928);
	            var CST_MARKER_SIZE = 12;
	            var CST_LINE_WIDTH = 5;
	            var CST_MARKER_LINE_WIDTH = 2;
	            var MAX_LINE_WIDTH = 10;
	            var MAX_MARKER_LINE_WIDTH = 5;
	            module2.exports = function style(s, gd, legend) {
	              var fullLayout = gd._fullLayout;
	              if (!legend) legend = fullLayout.legend;
	              var constantItemSizing = legend.itemsizing === "constant";
	              var itemWidth = legend.itemwidth;
	              var centerPos = (itemWidth + constants.itemGap * 2) / 2;
	              var centerTransform = strTranslate(centerPos, 0);
	              var boundLineWidth = function(mlw, cont, max, cst) {
	                var v;
	                if (mlw + 1) {
	                  v = mlw;
	                } else if (cont && cont.width > 0) {
	                  v = cont.width;
	                } else {
	                  return 0;
	                }
	                return constantItemSizing ? cst : Math.min(v, max);
	              };
	              s.each(function(d) {
	                var traceGroup = d3.select(this);
	                var layers = Lib.ensureSingle(traceGroup, "g", "layers");
	                layers.style("opacity", d[0].trace.opacity);
	                var valign = legend.valign;
	                var lineHeight = d[0].lineHeight;
	                var height = d[0].height;
	                if (valign === "middle" || !lineHeight || !height) {
	                  layers.attr("transform", null);
	                } else {
	                  var factor = {
	                    top: 1,
	                    bottom: -1
	                  }[valign];
	                  var markerOffsetY = factor * (0.5 * (lineHeight - height + 3));
	                  layers.attr("transform", strTranslate(0, markerOffsetY));
	                }
	                var fill = layers.selectAll("g.legendfill").data([d]);
	                fill.enter().append("g").classed("legendfill", true);
	                var line = layers.selectAll("g.legendlines").data([d]);
	                line.enter().append("g").classed("legendlines", true);
	                var symbol = layers.selectAll("g.legendsymbols").data([d]);
	                symbol.enter().append("g").classed("legendsymbols", true);
	                symbol.selectAll("g.legendpoints").data([d]).enter().append("g").classed("legendpoints", true);
	              }).each(styleSpatial).each(styleWaterfalls).each(styleFunnels).each(styleBars).each(styleBoxes).each(styleFunnelareas).each(stylePies).each(styleLines).each(stylePoints).each(styleCandles).each(styleOHLC);
	              function styleLines(d) {
	                var styleGuide = getStyleGuide(d);
	                var showFill = styleGuide.showFill;
	                var showLine = styleGuide.showLine;
	                var showGradientLine = styleGuide.showGradientLine;
	                var showGradientFill = styleGuide.showGradientFill;
	                var anyFill = styleGuide.anyFill;
	                var anyLine = styleGuide.anyLine;
	                var d0 = d[0];
	                var trace = d0.trace;
	                var dMod, tMod;
	                var cOpts = extractOpts(trace);
	                var colorscale = cOpts.colorscale;
	                var reversescale = cOpts.reversescale;
	                var fillStyle = function(s2) {
	                  if (s2.size()) {
	                    if (showFill) {
	                      Drawing.fillGroupStyle(s2, gd);
	                    } else {
	                      var gradientID = "legendfill-" + trace.uid;
	                      Drawing.gradient(s2, gd, gradientID, getGradientDirection(reversescale), colorscale, "fill");
	                    }
	                  }
	                };
	                var lineGradient = function(s2) {
	                  if (s2.size()) {
	                    var gradientID = "legendline-" + trace.uid;
	                    Drawing.lineGroupStyle(s2);
	                    Drawing.gradient(s2, gd, gradientID, getGradientDirection(reversescale), colorscale, "stroke");
	                  }
	                };
	                var pathStart = subTypes.hasMarkers(trace) || !anyFill ? "M5,0" : (
	                  // with a line leave it slightly below center, to leave room for the
	                  // line thickness and because the line is usually more prominent
	                  anyLine ? "M5,-2" : "M5,-3"
	                );
	                var this3 = d3.select(this);
	                var fill = this3.select(".legendfill").selectAll("path").data(showFill || showGradientFill ? [d] : []);
	                fill.enter().append("path").classed("js-fill", true);
	                fill.exit().remove();
	                fill.attr("d", pathStart + "h" + itemWidth + "v6h-" + itemWidth + "z").call(fillStyle);
	                if (showLine || showGradientLine) {
	                  var lw = boundLineWidth(undefined, trace.line, MAX_LINE_WIDTH, CST_LINE_WIDTH);
	                  tMod = Lib.minExtend(trace, {
	                    line: {
	                      width: lw
	                    }
	                  });
	                  dMod = [Lib.minExtend(d0, {
	                    trace: tMod
	                  })];
	                }
	                var line = this3.select(".legendlines").selectAll("path").data(showLine || showGradientLine ? [dMod] : []);
	                line.enter().append("path").classed("js-line", true);
	                line.exit().remove();
	                line.attr("d", pathStart + (showGradientLine ? "l" + itemWidth + ",0.0001" : "h" + itemWidth)).call(showLine ? Drawing.lineGroupStyle : lineGradient);
	              }
	              function stylePoints(d) {
	                var styleGuide = getStyleGuide(d);
	                var anyFill = styleGuide.anyFill;
	                var anyLine = styleGuide.anyLine;
	                var showLine = styleGuide.showLine;
	                var showMarker = styleGuide.showMarker;
	                var d0 = d[0];
	                var trace = d0.trace;
	                var showText = !showMarker && !anyLine && !anyFill && subTypes.hasText(trace);
	                var dMod, tMod;
	                function boundVal(attrIn, arrayToValFn, bounds, cst) {
	                  var valIn = Lib.nestedProperty(trace, attrIn).get();
	                  var valToBound = Lib.isArrayOrTypedArray(valIn) && arrayToValFn ? arrayToValFn(valIn) : valIn;
	                  if (constantItemSizing && valToBound && cst !== undefined) {
	                    valToBound = cst;
	                  }
	                  if (bounds) {
	                    if (valToBound < bounds[0]) return bounds[0];
	                    else if (valToBound > bounds[1]) return bounds[1];
	                  }
	                  return valToBound;
	                }
	                function pickFirst(array) {
	                  if (d0._distinct && d0.index && array[d0.index]) return array[d0.index];
	                  return array[0];
	                }
	                if (showMarker || showText || showLine) {
	                  var dEdit = {};
	                  var tEdit = {};
	                  if (showMarker) {
	                    dEdit.mc = boundVal("marker.color", pickFirst);
	                    dEdit.mx = boundVal("marker.symbol", pickFirst);
	                    dEdit.mo = boundVal("marker.opacity", Lib.mean, [0.2, 1]);
	                    dEdit.mlc = boundVal("marker.line.color", pickFirst);
	                    dEdit.mlw = boundVal("marker.line.width", Lib.mean, [0, 5], CST_MARKER_LINE_WIDTH);
	                    tEdit.marker = {
	                      sizeref: 1,
	                      sizemin: 1,
	                      sizemode: "diameter"
	                    };
	                    var ms = boundVal("marker.size", Lib.mean, [2, 16], CST_MARKER_SIZE);
	                    dEdit.ms = ms;
	                    tEdit.marker.size = ms;
	                  }
	                  if (showLine) {
	                    tEdit.line = {
	                      width: boundVal("line.width", pickFirst, [0, 10], CST_LINE_WIDTH)
	                    };
	                  }
	                  if (showText) {
	                    dEdit.tx = "Aa";
	                    dEdit.tp = boundVal("textposition", pickFirst);
	                    dEdit.ts = 10;
	                    dEdit.tc = boundVal("textfont.color", pickFirst);
	                    dEdit.tf = boundVal("textfont.family", pickFirst);
	                  }
	                  dMod = [Lib.minExtend(d0, dEdit)];
	                  tMod = Lib.minExtend(trace, tEdit);
	                  tMod.selectedpoints = null;
	                  tMod.texttemplate = null;
	                }
	                var ptgroup = d3.select(this).select("g.legendpoints");
	                var pts = ptgroup.selectAll("path.scatterpts").data(showMarker ? dMod : []);
	                pts.enter().insert("path", ":first-child").classed("scatterpts", true).attr("transform", centerTransform);
	                pts.exit().remove();
	                pts.call(Drawing.pointStyle, tMod, gd);
	                if (showMarker) dMod[0].mrc = 3;
	                var txt = ptgroup.selectAll("g.pointtext").data(showText ? dMod : []);
	                txt.enter().append("g").classed("pointtext", true).append("text").attr("transform", centerTransform);
	                txt.exit().remove();
	                txt.selectAll("text").call(Drawing.textPointStyle, tMod, gd);
	              }
	              function styleWaterfalls(d) {
	                var trace = d[0].trace;
	                var isWaterfall = trace.type === "waterfall";
	                if (d[0]._distinct && isWaterfall) {
	                  var cont = d[0].trace[d[0].dir].marker;
	                  d[0].mc = cont.color;
	                  d[0].mlw = cont.line.width;
	                  d[0].mlc = cont.line.color;
	                  return styleBarLike(d, this, "waterfall");
	                }
	                var ptsData = [];
	                if (trace.visible && isWaterfall) {
	                  ptsData = d[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]];
	                }
	                var pts = d3.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(ptsData);
	                pts.enter().append("path").classed("legendwaterfall", true).attr("transform", centerTransform).style("stroke-miterlimit", 1);
	                pts.exit().remove();
	                pts.each(function(dd) {
	                  var pt = d3.select(this);
	                  var cont2 = trace[dd[0]].marker;
	                  var lw = boundLineWidth(undefined, cont2.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	                  pt.attr("d", dd[1]).style("stroke-width", lw + "px").call(Color.fill, cont2.color);
	                  if (lw) {
	                    pt.call(Color.stroke, cont2.line.color);
	                  }
	                });
	              }
	              function styleBars(d) {
	                styleBarLike(d, this);
	              }
	              function styleFunnels(d) {
	                styleBarLike(d, this, "funnel");
	              }
	              function styleBarLike(d, lThis, desiredType) {
	                var trace = d[0].trace;
	                var marker = trace.marker || {};
	                var markerLine = marker.line || {};
	                var isVisible = !desiredType ? Registry.traceIs(trace, "bar") : trace.visible && trace.type === desiredType;
	                var barpath = d3.select(lThis).select("g.legendpoints").selectAll("path.legend" + desiredType).data(isVisible ? [d] : []);
	                barpath.enter().append("path").classed("legend" + desiredType, true).attr("d", "M6,6H-6V-6H6Z").attr("transform", centerTransform);
	                barpath.exit().remove();
	                barpath.each(function(d2) {
	                  var p = d3.select(this);
	                  var d0 = d2[0];
	                  var w = boundLineWidth(d0.mlw, marker.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	                  p.style("stroke-width", w + "px");
	                  var mcc = d0.mcc;
	                  if (!legend._inHover && "mc" in d0) {
	                    var cOpts = extractOpts(marker);
	                    var mid = cOpts.mid;
	                    if (mid === undefined) mid = (cOpts.max + cOpts.min) / 2;
	                    mcc = Drawing.tryColorscale(marker, "")(mid);
	                  }
	                  var fillColor = mcc || d0.mc || marker.color;
	                  var markerPattern = marker.pattern;
	                  var patternShape = markerPattern && Drawing.getPatternAttr(markerPattern.shape, 0, "");
	                  if (patternShape) {
	                    var patternBGColor = Drawing.getPatternAttr(markerPattern.bgcolor, 0, null);
	                    var patternFGColor = Drawing.getPatternAttr(markerPattern.fgcolor, 0, null);
	                    var patternFGOpacity = markerPattern.fgopacity;
	                    var patternSize = dimAttr(markerPattern.size, 8, 10);
	                    var patternSolidity = dimAttr(markerPattern.solidity, 0.5, 1);
	                    var patternID = "legend-" + trace.uid;
	                    p.call(Drawing.pattern, "legend", gd, patternID, patternShape, patternSize, patternSolidity, mcc, markerPattern.fillmode, patternBGColor, patternFGColor, patternFGOpacity);
	                  } else {
	                    p.call(Color.fill, fillColor);
	                  }
	                  if (w) Color.stroke(p, d0.mlc || markerLine.color);
	                });
	              }
	              function styleBoxes(d) {
	                var trace = d[0].trace;
	                var pts = d3.select(this).select("g.legendpoints").selectAll("path.legendbox").data(trace.visible && Registry.traceIs(trace, "box-violin") ? [d] : []);
	                pts.enter().append("path").classed("legendbox", true).attr("d", "M6,6H-6V-6H6Z").attr("transform", centerTransform);
	                pts.exit().remove();
	                pts.each(function() {
	                  var p = d3.select(this);
	                  if ((trace.boxpoints === "all" || trace.points === "all") && Color.opacity(trace.fillcolor) === 0 && Color.opacity((trace.line || {}).color) === 0) {
	                    var tMod = Lib.minExtend(trace, {
	                      marker: {
	                        size: constantItemSizing ? CST_MARKER_SIZE : Lib.constrain(trace.marker.size, 2, 16),
	                        sizeref: 1,
	                        sizemin: 1,
	                        sizemode: "diameter"
	                      }
	                    });
	                    pts.call(Drawing.pointStyle, tMod, gd);
	                  } else {
	                    var w = boundLineWidth(undefined, trace.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	                    p.style("stroke-width", w + "px").call(Color.fill, trace.fillcolor);
	                    if (w) Color.stroke(p, trace.line.color);
	                  }
	                });
	              }
	              function styleCandles(d) {
	                var trace = d[0].trace;
	                var pts = d3.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(trace.visible && trace.type === "candlestick" ? [d, d] : []);
	                pts.enter().append("path").classed("legendcandle", true).attr("d", function(_, i) {
	                  if (i) return "M-15,0H-8M-8,6V-6H8Z";
	                  return "M15,0H8M8,-6V6H-8Z";
	                }).attr("transform", centerTransform).style("stroke-miterlimit", 1);
	                pts.exit().remove();
	                pts.each(function(_, i) {
	                  var p = d3.select(this);
	                  var cont = trace[i ? "increasing" : "decreasing"];
	                  var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	                  p.style("stroke-width", w + "px").call(Color.fill, cont.fillcolor);
	                  if (w) Color.stroke(p, cont.line.color);
	                });
	              }
	              function styleOHLC(d) {
	                var trace = d[0].trace;
	                var pts = d3.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(trace.visible && trace.type === "ohlc" ? [d, d] : []);
	                pts.enter().append("path").classed("legendohlc", true).attr("d", function(_, i) {
	                  if (i) return "M-15,0H0M-8,-6V0";
	                  return "M15,0H0M8,6V0";
	                }).attr("transform", centerTransform).style("stroke-miterlimit", 1);
	                pts.exit().remove();
	                pts.each(function(_, i) {
	                  var p = d3.select(this);
	                  var cont = trace[i ? "increasing" : "decreasing"];
	                  var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	                  p.style("fill", "none").call(Drawing.dashLine, cont.line.dash, w);
	                  if (w) Color.stroke(p, cont.line.color);
	                });
	              }
	              function stylePies(d) {
	                stylePieLike(d, this, "pie");
	              }
	              function styleFunnelareas(d) {
	                stylePieLike(d, this, "funnelarea");
	              }
	              function stylePieLike(d, lThis, desiredType) {
	                var d0 = d[0];
	                var trace = d0.trace;
	                var isVisible = !desiredType ? Registry.traceIs(trace, desiredType) : trace.visible && trace.type === desiredType;
	                var pts = d3.select(lThis).select("g.legendpoints").selectAll("path.legend" + desiredType).data(isVisible ? [d] : []);
	                pts.enter().append("path").classed("legend" + desiredType, true).attr("d", "M6,6H-6V-6H6Z").attr("transform", centerTransform);
	                pts.exit().remove();
	                if (pts.size()) {
	                  var cont = trace.marker || {};
	                  var lw = boundLineWidth(pieCastOption(cont.line.width, d0.pts), cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
	                  var opt = "pieLike";
	                  var tMod = Lib.minExtend(trace, {
	                    marker: {
	                      line: {
	                        width: lw
	                      }
	                    }
	                  }, opt);
	                  var d0Mod = Lib.minExtend(d0, {
	                    trace: tMod
	                  }, opt);
	                  stylePie(pts, d0Mod, tMod, gd);
	                }
	              }
	              function styleSpatial(d) {
	                var trace = d[0].trace;
	                var useGradient;
	                var ptsData = [];
	                if (trace.visible) {
	                  switch (trace.type) {
	                    case "histogram2d":
	                    case "heatmap":
	                      ptsData = [
	                        ["M-15,-2V4H15V-2Z"]
	                        // similar to contour
	                      ];
	                      useGradient = true;
	                      break;
	                    case "choropleth":
	                    case "choroplethmapbox":
	                      ptsData = [["M-6,-6V6H6V-6Z"]];
	                      useGradient = true;
	                      break;
	                    case "densitymapbox":
	                      ptsData = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]];
	                      useGradient = "radial";
	                      break;
	                    case "cone":
	                      ptsData = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]];
	                      useGradient = false;
	                      break;
	                    case "streamtube":
	                      ptsData = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]];
	                      useGradient = false;
	                      break;
	                    case "surface":
	                      ptsData = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]];
	                      useGradient = true;
	                      break;
	                    case "mesh3d":
	                      ptsData = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]];
	                      useGradient = false;
	                      break;
	                    case "volume":
	                      ptsData = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]];
	                      useGradient = true;
	                      break;
	                    case "isosurface":
	                      ptsData = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]];
	                      useGradient = false;
	                      break;
	                  }
	                }
	                var pts = d3.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(ptsData);
	                pts.enter().append("path").classed("legend3dandfriends", true).attr("transform", centerTransform).style("stroke-miterlimit", 1);
	                pts.exit().remove();
	                pts.each(function(dd, i) {
	                  var pt = d3.select(this);
	                  var cOpts = extractOpts(trace);
	                  var colorscale = cOpts.colorscale;
	                  var reversescale = cOpts.reversescale;
	                  var fillGradient = function(s2) {
	                    if (s2.size()) {
	                      var gradientID = "legendfill-" + trace.uid;
	                      Drawing.gradient(s2, gd, gradientID, getGradientDirection(reversescale, useGradient === "radial"), colorscale, "fill");
	                    }
	                  };
	                  var fillColor;
	                  if (!colorscale) {
	                    var color = trace.vertexcolor || trace.facecolor || trace.color;
	                    fillColor = Lib.isArrayOrTypedArray(color) ? color[i] || color[0] : color;
	                  } else {
	                    if (!useGradient) {
	                      var len = colorscale.length;
	                      fillColor = i === 0 ? colorscale[reversescale ? len - 1 : 0][1] : (
	                        // minimum
	                        i === 1 ? colorscale[reversescale ? 0 : len - 1][1] : (
	                          // maximum
	                          colorscale[Math.floor((len - 1) / 2)][1]
	                        )
	                      );
	                    }
	                  }
	                  pt.attr("d", dd[0]);
	                  if (fillColor) {
	                    pt.call(Color.fill, fillColor);
	                  } else {
	                    pt.call(fillGradient);
	                  }
	                });
	              }
	            };
	            function getGradientDirection(reversescale, isRadial) {
	              var str = isRadial ? "radial" : "horizontal";
	              return str + (reversescale ? "" : "reversed");
	            }
	            function getStyleGuide(d) {
	              var trace = d[0].trace;
	              var contours = trace.contours;
	              var showLine = subTypes.hasLines(trace);
	              var showMarker = subTypes.hasMarkers(trace);
	              var showFill = trace.visible && trace.fill && trace.fill !== "none";
	              var showGradientLine = false;
	              var showGradientFill = false;
	              if (contours) {
	                var coloring = contours.coloring;
	                if (coloring === "lines") {
	                  showGradientLine = true;
	                } else {
	                  showLine = coloring === "none" || coloring === "heatmap" || contours.showlines;
	                }
	                if (contours.type === "constraint") {
	                  showFill = contours._operation !== "=";
	                } else if (coloring === "fill" || coloring === "heatmap") {
	                  showGradientFill = true;
	                }
	              }
	              return {
	                showMarker,
	                showLine,
	                showFill,
	                showGradientLine,
	                showGradientFill,
	                anyLine: showLine || showGradientLine,
	                anyFill: showFill || showGradientFill
	              };
	            }
	            function dimAttr(v, dflt, max) {
	              if (v && Lib.isArrayOrTypedArray(v)) return dflt;
	              if (v > max) return max;
	              return v;
	            }
	          }
	        ),
	        /***/
	        42068: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            __webpack_require__2(93348);
	            module2.exports = {
	              editType: "modebar",
	              orientation: {
	                valType: "enumerated",
	                values: ["v", "h"],
	                dflt: "h",
	                editType: "modebar"
	              },
	              bgcolor: {
	                valType: "color",
	                editType: "modebar"
	              },
	              color: {
	                valType: "color",
	                editType: "modebar"
	              },
	              activecolor: {
	                valType: "color",
	                editType: "modebar"
	              },
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              add: {
	                valType: "string",
	                arrayOk: true,
	                dflt: "",
	                editType: "modebar"
	              },
	              remove: {
	                valType: "string",
	                arrayOk: true,
	                dflt: "",
	                editType: "modebar"
	              }
	            };
	          }
	        ),
	        /***/
	        26023: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Plots = __webpack_require__2(74875);
	            var axisIds = __webpack_require__2(41675);
	            var Icons = __webpack_require__2(24255);
	            var eraseActiveShape = __webpack_require__2(34031).eraseActiveShape;
	            var Lib = __webpack_require__2(71828);
	            var _ = Lib._;
	            var modeBarButtons = module2.exports = {};
	            modeBarButtons.toImage = {
	              name: "toImage",
	              title: function(gd) {
	                var opts = gd._context.toImageButtonOptions || {};
	                var format = opts.format || "png";
	                return format === "png" ? _(gd, "Download plot as a png") : (
	                  // legacy text
	                  _(gd, "Download plot")
	                );
	              },
	              icon: Icons.camera,
	              click: function(gd) {
	                var toImageButtonOptions = gd._context.toImageButtonOptions;
	                var opts = {
	                  format: toImageButtonOptions.format || "png"
	                };
	                Lib.notifier(_(gd, "Taking snapshot - this may take a few seconds"), "long");
	                if (opts.format !== "svg" && Lib.isIE()) {
	                  Lib.notifier(_(gd, "IE only supports svg.  Changing format to svg."), "long");
	                  opts.format = "svg";
	                }
	                ["filename", "width", "height", "scale"].forEach(function(key) {
	                  if (key in toImageButtonOptions) {
	                    opts[key] = toImageButtonOptions[key];
	                  }
	                });
	                Registry.call("downloadImage", gd, opts).then(function(filename) {
	                  Lib.notifier(_(gd, "Snapshot succeeded") + " - " + filename, "long");
	                }).catch(function() {
	                  Lib.notifier(_(gd, "Sorry, there was a problem downloading your snapshot!"), "long");
	                });
	              }
	            };
	            modeBarButtons.sendDataToCloud = {
	              name: "sendDataToCloud",
	              title: function(gd) {
	                return _(gd, "Edit in Chart Studio");
	              },
	              icon: Icons.disk,
	              click: function(gd) {
	                Plots.sendDataToCloud(gd);
	              }
	            };
	            modeBarButtons.editInChartStudio = {
	              name: "editInChartStudio",
	              title: function(gd) {
	                return _(gd, "Edit in Chart Studio");
	              },
	              icon: Icons.pencil,
	              click: function(gd) {
	                Plots.sendDataToCloud(gd);
	              }
	            };
	            modeBarButtons.zoom2d = {
	              name: "zoom2d",
	              _cat: "zoom",
	              title: function(gd) {
	                return _(gd, "Zoom");
	              },
	              attr: "dragmode",
	              val: "zoom",
	              icon: Icons.zoombox,
	              click: handleCartesian
	            };
	            modeBarButtons.pan2d = {
	              name: "pan2d",
	              _cat: "pan",
	              title: function(gd) {
	                return _(gd, "Pan");
	              },
	              attr: "dragmode",
	              val: "pan",
	              icon: Icons.pan,
	              click: handleCartesian
	            };
	            modeBarButtons.select2d = {
	              name: "select2d",
	              _cat: "select",
	              title: function(gd) {
	                return _(gd, "Box Select");
	              },
	              attr: "dragmode",
	              val: "select",
	              icon: Icons.selectbox,
	              click: handleCartesian
	            };
	            modeBarButtons.lasso2d = {
	              name: "lasso2d",
	              _cat: "lasso",
	              title: function(gd) {
	                return _(gd, "Lasso Select");
	              },
	              attr: "dragmode",
	              val: "lasso",
	              icon: Icons.lasso,
	              click: handleCartesian
	            };
	            modeBarButtons.drawclosedpath = {
	              name: "drawclosedpath",
	              title: function(gd) {
	                return _(gd, "Draw closed freeform");
	              },
	              attr: "dragmode",
	              val: "drawclosedpath",
	              icon: Icons.drawclosedpath,
	              click: handleCartesian
	            };
	            modeBarButtons.drawopenpath = {
	              name: "drawopenpath",
	              title: function(gd) {
	                return _(gd, "Draw open freeform");
	              },
	              attr: "dragmode",
	              val: "drawopenpath",
	              icon: Icons.drawopenpath,
	              click: handleCartesian
	            };
	            modeBarButtons.drawline = {
	              name: "drawline",
	              title: function(gd) {
	                return _(gd, "Draw line");
	              },
	              attr: "dragmode",
	              val: "drawline",
	              icon: Icons.drawline,
	              click: handleCartesian
	            };
	            modeBarButtons.drawrect = {
	              name: "drawrect",
	              title: function(gd) {
	                return _(gd, "Draw rectangle");
	              },
	              attr: "dragmode",
	              val: "drawrect",
	              icon: Icons.drawrect,
	              click: handleCartesian
	            };
	            modeBarButtons.drawcircle = {
	              name: "drawcircle",
	              title: function(gd) {
	                return _(gd, "Draw circle");
	              },
	              attr: "dragmode",
	              val: "drawcircle",
	              icon: Icons.drawcircle,
	              click: handleCartesian
	            };
	            modeBarButtons.eraseshape = {
	              name: "eraseshape",
	              title: function(gd) {
	                return _(gd, "Erase active shape");
	              },
	              icon: Icons.eraseshape,
	              click: eraseActiveShape
	            };
	            modeBarButtons.zoomIn2d = {
	              name: "zoomIn2d",
	              _cat: "zoomin",
	              title: function(gd) {
	                return _(gd, "Zoom in");
	              },
	              attr: "zoom",
	              val: "in",
	              icon: Icons.zoom_plus,
	              click: handleCartesian
	            };
	            modeBarButtons.zoomOut2d = {
	              name: "zoomOut2d",
	              _cat: "zoomout",
	              title: function(gd) {
	                return _(gd, "Zoom out");
	              },
	              attr: "zoom",
	              val: "out",
	              icon: Icons.zoom_minus,
	              click: handleCartesian
	            };
	            modeBarButtons.autoScale2d = {
	              name: "autoScale2d",
	              _cat: "autoscale",
	              title: function(gd) {
	                return _(gd, "Autoscale");
	              },
	              attr: "zoom",
	              val: "auto",
	              icon: Icons.autoscale,
	              click: handleCartesian
	            };
	            modeBarButtons.resetScale2d = {
	              name: "resetScale2d",
	              _cat: "resetscale",
	              title: function(gd) {
	                return _(gd, "Reset axes");
	              },
	              attr: "zoom",
	              val: "reset",
	              icon: Icons.home,
	              click: handleCartesian
	            };
	            modeBarButtons.hoverClosestCartesian = {
	              name: "hoverClosestCartesian",
	              _cat: "hoverclosest",
	              title: function(gd) {
	                return _(gd, "Show closest data on hover");
	              },
	              attr: "hovermode",
	              val: "closest",
	              icon: Icons.tooltip_basic,
	              gravity: "ne",
	              click: handleCartesian
	            };
	            modeBarButtons.hoverCompareCartesian = {
	              name: "hoverCompareCartesian",
	              _cat: "hoverCompare",
	              title: function(gd) {
	                return _(gd, "Compare data on hover");
	              },
	              attr: "hovermode",
	              val: function(gd) {
	                return gd._fullLayout._isHoriz ? "y" : "x";
	              },
	              icon: Icons.tooltip_compare,
	              gravity: "ne",
	              click: handleCartesian
	            };
	            function handleCartesian(gd, ev) {
	              var button = ev.currentTarget;
	              var astr = button.getAttribute("data-attr");
	              var val = button.getAttribute("data-val") || true;
	              var fullLayout = gd._fullLayout;
	              var aobj = {};
	              var axList = axisIds.list(gd, null, true);
	              var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
	              var ax, i;
	              if (astr === "zoom") {
	                var mag = val === "in" ? 0.5 : 2;
	                var r0 = (1 + mag) / 2;
	                var r1 = (1 - mag) / 2;
	                var axName;
	                for (i = 0; i < axList.length; i++) {
	                  ax = axList[i];
	                  if (!ax.fixedrange) {
	                    axName = ax._name;
	                    if (val === "auto") {
	                      aobj[axName + ".autorange"] = true;
	                    } else if (val === "reset") {
	                      if (ax._rangeInitial0 === undefined && ax._rangeInitial1 === undefined) {
	                        aobj[axName + ".autorange"] = true;
	                      } else if (ax._rangeInitial0 === undefined) {
	                        aobj[axName + ".autorange"] = ax._autorangeInitial;
	                        aobj[axName + ".range"] = [null, ax._rangeInitial1];
	                      } else if (ax._rangeInitial1 === undefined) {
	                        aobj[axName + ".range"] = [ax._rangeInitial0, null];
	                        aobj[axName + ".autorange"] = ax._autorangeInitial;
	                      } else {
	                        aobj[axName + ".range"] = [ax._rangeInitial0, ax._rangeInitial1];
	                      }
	                      if (ax._showSpikeInitial !== undefined) {
	                        aobj[axName + ".showspikes"] = ax._showSpikeInitial;
	                        if (allSpikesEnabled === "on" && !ax._showSpikeInitial) {
	                          allSpikesEnabled = "off";
	                        }
	                      }
	                    } else {
	                      var rangeNow = [ax.r2l(ax.range[0]), ax.r2l(ax.range[1])];
	                      var rangeNew = [r0 * rangeNow[0] + r1 * rangeNow[1], r0 * rangeNow[1] + r1 * rangeNow[0]];
	                      aobj[axName + ".range[0]"] = ax.l2r(rangeNew[0]);
	                      aobj[axName + ".range[1]"] = ax.l2r(rangeNew[1]);
	                    }
	                  }
	                }
	              } else {
	                if (astr === "hovermode" && (val === "x" || val === "y")) {
	                  val = fullLayout._isHoriz ? "y" : "x";
	                  button.setAttribute("data-val", val);
	                }
	                aobj[astr] = val;
	              }
	              fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
	              Registry.call("_guiRelayout", gd, aobj);
	            }
	            modeBarButtons.zoom3d = {
	              name: "zoom3d",
	              _cat: "zoom",
	              title: function(gd) {
	                return _(gd, "Zoom");
	              },
	              attr: "scene.dragmode",
	              val: "zoom",
	              icon: Icons.zoombox,
	              click: handleDrag3d
	            };
	            modeBarButtons.pan3d = {
	              name: "pan3d",
	              _cat: "pan",
	              title: function(gd) {
	                return _(gd, "Pan");
	              },
	              attr: "scene.dragmode",
	              val: "pan",
	              icon: Icons.pan,
	              click: handleDrag3d
	            };
	            modeBarButtons.orbitRotation = {
	              name: "orbitRotation",
	              title: function(gd) {
	                return _(gd, "Orbital rotation");
	              },
	              attr: "scene.dragmode",
	              val: "orbit",
	              icon: Icons["3d_rotate"],
	              click: handleDrag3d
	            };
	            modeBarButtons.tableRotation = {
	              name: "tableRotation",
	              title: function(gd) {
	                return _(gd, "Turntable rotation");
	              },
	              attr: "scene.dragmode",
	              val: "turntable",
	              icon: Icons["z-axis"],
	              click: handleDrag3d
	            };
	            function handleDrag3d(gd, ev) {
	              var button = ev.currentTarget;
	              var attr = button.getAttribute("data-attr");
	              var val = button.getAttribute("data-val") || true;
	              var sceneIds = gd._fullLayout._subplots.gl3d || [];
	              var layoutUpdate = {};
	              var parts = attr.split(".");
	              for (var i = 0; i < sceneIds.length; i++) {
	                layoutUpdate[sceneIds[i] + "." + parts[1]] = val;
	              }
	              var val2d = val === "pan" ? val : "zoom";
	              layoutUpdate.dragmode = val2d;
	              Registry.call("_guiRelayout", gd, layoutUpdate);
	            }
	            modeBarButtons.resetCameraDefault3d = {
	              name: "resetCameraDefault3d",
	              _cat: "resetCameraDefault",
	              title: function(gd) {
	                return _(gd, "Reset camera to default");
	              },
	              attr: "resetDefault",
	              icon: Icons.home,
	              click: handleCamera3d
	            };
	            modeBarButtons.resetCameraLastSave3d = {
	              name: "resetCameraLastSave3d",
	              _cat: "resetCameraLastSave",
	              title: function(gd) {
	                return _(gd, "Reset camera to last save");
	              },
	              attr: "resetLastSave",
	              icon: Icons.movie,
	              click: handleCamera3d
	            };
	            function handleCamera3d(gd, ev) {
	              var button = ev.currentTarget;
	              var attr = button.getAttribute("data-attr");
	              var resetLastSave = attr === "resetLastSave";
	              var resetDefault = attr === "resetDefault";
	              var fullLayout = gd._fullLayout;
	              var sceneIds = fullLayout._subplots.gl3d || [];
	              var aobj = {};
	              for (var i = 0; i < sceneIds.length; i++) {
	                var sceneId = sceneIds[i];
	                var camera = sceneId + ".camera";
	                var aspectratio = sceneId + ".aspectratio";
	                var aspectmode = sceneId + ".aspectmode";
	                var scene = fullLayout[sceneId]._scene;
	                var didUpdate;
	                if (resetLastSave) {
	                  aobj[camera + ".up"] = scene.viewInitial.up;
	                  aobj[camera + ".eye"] = scene.viewInitial.eye;
	                  aobj[camera + ".center"] = scene.viewInitial.center;
	                  didUpdate = true;
	                } else if (resetDefault) {
	                  aobj[camera + ".up"] = null;
	                  aobj[camera + ".eye"] = null;
	                  aobj[camera + ".center"] = null;
	                  didUpdate = true;
	                }
	                if (didUpdate) {
	                  aobj[aspectratio + ".x"] = scene.viewInitial.aspectratio.x;
	                  aobj[aspectratio + ".y"] = scene.viewInitial.aspectratio.y;
	                  aobj[aspectratio + ".z"] = scene.viewInitial.aspectratio.z;
	                  aobj[aspectmode] = scene.viewInitial.aspectmode;
	                }
	              }
	              Registry.call("_guiRelayout", gd, aobj);
	            }
	            modeBarButtons.hoverClosest3d = {
	              name: "hoverClosest3d",
	              _cat: "hoverclosest",
	              title: function(gd) {
	                return _(gd, "Toggle show closest data on hover");
	              },
	              attr: "hovermode",
	              val: null,
	              toggle: true,
	              icon: Icons.tooltip_basic,
	              gravity: "ne",
	              click: handleHover3d
	            };
	            function getNextHover3d(gd, ev) {
	              var button = ev.currentTarget;
	              var val = button._previousVal;
	              var fullLayout = gd._fullLayout;
	              var sceneIds = fullLayout._subplots.gl3d || [];
	              var axes = ["xaxis", "yaxis", "zaxis"];
	              var currentSpikes = {};
	              var layoutUpdate = {};
	              if (val) {
	                layoutUpdate = val;
	                button._previousVal = null;
	              } else {
	                for (var i = 0; i < sceneIds.length; i++) {
	                  var sceneId = sceneIds[i];
	                  var sceneLayout = fullLayout[sceneId];
	                  var hovermodeAStr = sceneId + ".hovermode";
	                  currentSpikes[hovermodeAStr] = sceneLayout.hovermode;
	                  layoutUpdate[hovermodeAStr] = false;
	                  for (var j = 0; j < 3; j++) {
	                    var axis = axes[j];
	                    var spikeAStr = sceneId + "." + axis + ".showspikes";
	                    layoutUpdate[spikeAStr] = false;
	                    currentSpikes[spikeAStr] = sceneLayout[axis].showspikes;
	                  }
	                }
	                button._previousVal = currentSpikes;
	              }
	              return layoutUpdate;
	            }
	            function handleHover3d(gd, ev) {
	              var layoutUpdate = getNextHover3d(gd, ev);
	              Registry.call("_guiRelayout", gd, layoutUpdate);
	            }
	            modeBarButtons.zoomInGeo = {
	              name: "zoomInGeo",
	              _cat: "zoomin",
	              title: function(gd) {
	                return _(gd, "Zoom in");
	              },
	              attr: "zoom",
	              val: "in",
	              icon: Icons.zoom_plus,
	              click: handleGeo
	            };
	            modeBarButtons.zoomOutGeo = {
	              name: "zoomOutGeo",
	              _cat: "zoomout",
	              title: function(gd) {
	                return _(gd, "Zoom out");
	              },
	              attr: "zoom",
	              val: "out",
	              icon: Icons.zoom_minus,
	              click: handleGeo
	            };
	            modeBarButtons.resetGeo = {
	              name: "resetGeo",
	              _cat: "reset",
	              title: function(gd) {
	                return _(gd, "Reset");
	              },
	              attr: "reset",
	              val: null,
	              icon: Icons.autoscale,
	              click: handleGeo
	            };
	            modeBarButtons.hoverClosestGeo = {
	              name: "hoverClosestGeo",
	              _cat: "hoverclosest",
	              title: function(gd) {
	                return _(gd, "Toggle show closest data on hover");
	              },
	              attr: "hovermode",
	              val: null,
	              toggle: true,
	              icon: Icons.tooltip_basic,
	              gravity: "ne",
	              click: toggleHover
	            };
	            function handleGeo(gd, ev) {
	              var button = ev.currentTarget;
	              var attr = button.getAttribute("data-attr");
	              var val = button.getAttribute("data-val") || true;
	              var fullLayout = gd._fullLayout;
	              var geoIds = fullLayout._subplots.geo || [];
	              for (var i = 0; i < geoIds.length; i++) {
	                var id = geoIds[i];
	                var geoLayout = fullLayout[id];
	                if (attr === "zoom") {
	                  var scale = geoLayout.projection.scale;
	                  var newScale = val === "in" ? 2 * scale : 0.5 * scale;
	                  Registry.call("_guiRelayout", gd, id + ".projection.scale", newScale);
	                }
	              }
	              if (attr === "reset") {
	                resetView(gd, "geo");
	              }
	            }
	            modeBarButtons.hoverClosestGl2d = {
	              name: "hoverClosestGl2d",
	              _cat: "hoverclosest",
	              title: function(gd) {
	                return _(gd, "Toggle show closest data on hover");
	              },
	              attr: "hovermode",
	              val: null,
	              toggle: true,
	              icon: Icons.tooltip_basic,
	              gravity: "ne",
	              click: toggleHover
	            };
	            modeBarButtons.hoverClosestPie = {
	              name: "hoverClosestPie",
	              _cat: "hoverclosest",
	              title: function(gd) {
	                return _(gd, "Toggle show closest data on hover");
	              },
	              attr: "hovermode",
	              val: "closest",
	              icon: Icons.tooltip_basic,
	              gravity: "ne",
	              click: toggleHover
	            };
	            function getNextHover(gd) {
	              var fullLayout = gd._fullLayout;
	              if (fullLayout.hovermode) return false;
	              if (fullLayout._has("cartesian")) {
	                return fullLayout._isHoriz ? "y" : "x";
	              }
	              return "closest";
	            }
	            function toggleHover(gd) {
	              var newHover = getNextHover(gd);
	              Registry.call("_guiRelayout", gd, "hovermode", newHover);
	            }
	            modeBarButtons.resetViewSankey = {
	              name: "resetSankeyGroup",
	              title: function(gd) {
	                return _(gd, "Reset view");
	              },
	              icon: Icons.home,
	              click: function(gd) {
	                var aObj = {
	                  "node.groups": [],
	                  "node.x": [],
	                  "node.y": []
	                };
	                for (var i = 0; i < gd._fullData.length; i++) {
	                  var viewInitial = gd._fullData[i]._viewInitial;
	                  aObj["node.groups"].push(viewInitial.node.groups.slice());
	                  aObj["node.x"].push(viewInitial.node.x.slice());
	                  aObj["node.y"].push(viewInitial.node.y.slice());
	                }
	                Registry.call("restyle", gd, aObj);
	              }
	            };
	            modeBarButtons.toggleHover = {
	              name: "toggleHover",
	              title: function(gd) {
	                return _(gd, "Toggle show closest data on hover");
	              },
	              attr: "hovermode",
	              val: null,
	              toggle: true,
	              icon: Icons.tooltip_basic,
	              gravity: "ne",
	              click: function(gd, ev) {
	                var layoutUpdate = getNextHover3d(gd, ev);
	                layoutUpdate.hovermode = getNextHover(gd);
	                Registry.call("_guiRelayout", gd, layoutUpdate);
	              }
	            };
	            modeBarButtons.resetViews = {
	              name: "resetViews",
	              title: function(gd) {
	                return _(gd, "Reset views");
	              },
	              icon: Icons.home,
	              click: function(gd, ev) {
	                var button = ev.currentTarget;
	                button.setAttribute("data-attr", "zoom");
	                button.setAttribute("data-val", "reset");
	                handleCartesian(gd, ev);
	                button.setAttribute("data-attr", "resetLastSave");
	                handleCamera3d(gd, ev);
	                resetView(gd, "geo");
	                resetView(gd, "mapbox");
	              }
	            };
	            modeBarButtons.toggleSpikelines = {
	              name: "toggleSpikelines",
	              title: function(gd) {
	                return _(gd, "Toggle Spike Lines");
	              },
	              icon: Icons.spikeline,
	              attr: "_cartesianSpikesEnabled",
	              val: "on",
	              click: function(gd) {
	                var fullLayout = gd._fullLayout;
	                var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
	                fullLayout._cartesianSpikesEnabled = allSpikesEnabled === "on" ? "off" : "on";
	                Registry.call("_guiRelayout", gd, setSpikelineVisibility(gd));
	              }
	            };
	            function setSpikelineVisibility(gd) {
	              var fullLayout = gd._fullLayout;
	              var areSpikesOn = fullLayout._cartesianSpikesEnabled === "on";
	              var axList = axisIds.list(gd, null, true);
	              var aobj = {};
	              for (var i = 0; i < axList.length; i++) {
	                var ax = axList[i];
	                aobj[ax._name + ".showspikes"] = areSpikesOn ? true : ax._showSpikeInitial;
	              }
	              return aobj;
	            }
	            modeBarButtons.resetViewMapbox = {
	              name: "resetViewMapbox",
	              _cat: "resetView",
	              title: function(gd) {
	                return _(gd, "Reset view");
	              },
	              attr: "reset",
	              icon: Icons.home,
	              click: function(gd) {
	                resetView(gd, "mapbox");
	              }
	            };
	            modeBarButtons.zoomInMapbox = {
	              name: "zoomInMapbox",
	              _cat: "zoomin",
	              title: function(gd) {
	                return _(gd, "Zoom in");
	              },
	              attr: "zoom",
	              val: "in",
	              icon: Icons.zoom_plus,
	              click: handleMapboxZoom
	            };
	            modeBarButtons.zoomOutMapbox = {
	              name: "zoomOutMapbox",
	              _cat: "zoomout",
	              title: function(gd) {
	                return _(gd, "Zoom out");
	              },
	              attr: "zoom",
	              val: "out",
	              icon: Icons.zoom_minus,
	              click: handleMapboxZoom
	            };
	            function handleMapboxZoom(gd, ev) {
	              var button = ev.currentTarget;
	              var val = button.getAttribute("data-val");
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots.mapbox || [];
	              var scalar = 1.05;
	              var aObj = {};
	              for (var i = 0; i < subplotIds.length; i++) {
	                var id = subplotIds[i];
	                var current = fullLayout[id].zoom;
	                var next = val === "in" ? scalar * current : current / scalar;
	                aObj[id + ".zoom"] = next;
	              }
	              Registry.call("_guiRelayout", gd, aObj);
	            }
	            function resetView(gd, subplotType) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots[subplotType] || [];
	              var aObj = {};
	              for (var i = 0; i < subplotIds.length; i++) {
	                var id = subplotIds[i];
	                var subplotObj = fullLayout[id]._subplot;
	                var viewInitial = subplotObj.viewInitial;
	                var viewKeys = Object.keys(viewInitial);
	                for (var j = 0; j < viewKeys.length; j++) {
	                  var key = viewKeys[j];
	                  aObj[id + "." + key] = viewInitial[key];
	                }
	              }
	              Registry.call("_guiRelayout", gd, aObj);
	            }
	          }
	        ),
	        /***/
	        93348: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var modeBarButtons = __webpack_require__2(26023);
	            var buttonList = Object.keys(modeBarButtons);
	            var DRAW_MODES = ["drawline", "drawopenpath", "drawclosedpath", "drawcircle", "drawrect", "eraseshape"];
	            var backButtons = ["v1hovermode", "hoverclosest", "hovercompare", "togglehover", "togglespikelines"].concat(DRAW_MODES);
	            var foreButtons = [];
	            var addToForeButtons = function(b) {
	              if (backButtons.indexOf(b._cat || b.name) !== -1) return;
	              var name2 = b.name;
	              var _cat = (b._cat || b.name).toLowerCase();
	              if (foreButtons.indexOf(name2) === -1) foreButtons.push(name2);
	              if (foreButtons.indexOf(_cat) === -1) foreButtons.push(_cat);
	            };
	            buttonList.forEach(function(k) {
	              addToForeButtons(modeBarButtons[k]);
	            });
	            foreButtons.sort();
	            module2.exports = {
	              DRAW_MODES,
	              backButtons,
	              foreButtons
	            };
	          }
	        ),
	        /***/
	        35750: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Template = __webpack_require__2(44467);
	            var attributes = __webpack_require__2(42068);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              var containerIn = layoutIn.modebar || {};
	              var containerOut = Template.newContainer(layoutOut, "modebar");
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	              }
	              coerce("orientation");
	              coerce("bgcolor", Color.addOpacity(layoutOut.paper_bgcolor, 0.5));
	              var defaultColor = Color.contrast(Color.rgb(layoutOut.modebar.bgcolor));
	              coerce("color", Color.addOpacity(defaultColor, 0.3));
	              coerce("activecolor", Color.addOpacity(defaultColor, 0.7));
	              coerce("uirevision", layoutOut.uirevision);
	              coerce("add");
	              coerce("remove");
	            };
	          }
	        ),
	        /***/
	        64168: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "component",
	              name: "modebar",
	              layoutAttributes: __webpack_require__2(42068),
	              supplyLayoutDefaults: __webpack_require__2(35750),
	              manage: __webpack_require__2(14192)
	            };
	          }
	        ),
	        /***/
	        14192: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var axisIds = __webpack_require__2(41675);
	            var scatterSubTypes = __webpack_require__2(34098);
	            var Registry = __webpack_require__2(73972);
	            var isUnifiedHover = __webpack_require__2(23469).isUnifiedHover;
	            var createModeBar = __webpack_require__2(37676);
	            var modeBarButtons = __webpack_require__2(26023);
	            var DRAW_MODES = __webpack_require__2(93348).DRAW_MODES;
	            var extendDeep = __webpack_require__2(71828).extendDeep;
	            module2.exports = function manageModeBar(gd) {
	              var fullLayout = gd._fullLayout;
	              var context = gd._context;
	              var modeBar = fullLayout._modeBar;
	              if (!context.displayModeBar && !context.watermark) {
	                if (modeBar) {
	                  modeBar.destroy();
	                  delete fullLayout._modeBar;
	                }
	                return;
	              }
	              if (!Array.isArray(context.modeBarButtonsToRemove)) {
	                throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
	              }
	              if (!Array.isArray(context.modeBarButtonsToAdd)) {
	                throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
	              }
	              var customButtons = context.modeBarButtons;
	              var buttonGroups;
	              if (Array.isArray(customButtons) && customButtons.length) {
	                buttonGroups = fillCustomButton(customButtons);
	              } else if (!context.displayModeBar && context.watermark) {
	                buttonGroups = [];
	              } else {
	                buttonGroups = getButtonGroups(gd);
	              }
	              if (modeBar) modeBar.update(gd, buttonGroups);
	              else fullLayout._modeBar = createModeBar(gd, buttonGroups);
	            };
	            function getButtonGroups(gd) {
	              var fullLayout = gd._fullLayout;
	              var fullData = gd._fullData;
	              var context = gd._context;
	              function match(name2, B) {
	                if (typeof B === "string") {
	                  if (B.toLowerCase() === name2.toLowerCase()) return true;
	                } else {
	                  var v0 = B.name;
	                  var v1 = B._cat || B.name;
	                  if (v0 === name2 || v1 === name2.toLowerCase()) return true;
	                }
	                return false;
	              }
	              var layoutAdd = fullLayout.modebar.add;
	              if (typeof layoutAdd === "string") layoutAdd = [layoutAdd];
	              var layoutRemove = fullLayout.modebar.remove;
	              if (typeof layoutRemove === "string") layoutRemove = [layoutRemove];
	              var buttonsToAdd = context.modeBarButtonsToAdd.concat(layoutAdd.filter(function(e) {
	                for (var i2 = 0; i2 < context.modeBarButtonsToRemove.length; i2++) {
	                  if (match(e, context.modeBarButtonsToRemove[i2])) return false;
	                }
	                return true;
	              }));
	              var buttonsToRemove = context.modeBarButtonsToRemove.concat(layoutRemove.filter(function(e) {
	                for (var i2 = 0; i2 < context.modeBarButtonsToAdd.length; i2++) {
	                  if (match(e, context.modeBarButtonsToAdd[i2])) return false;
	                }
	                return true;
	              }));
	              var hasCartesian = fullLayout._has("cartesian");
	              var hasGL3D = fullLayout._has("gl3d");
	              var hasGeo = fullLayout._has("geo");
	              var hasPie = fullLayout._has("pie");
	              var hasFunnelarea = fullLayout._has("funnelarea");
	              var hasGL2D = fullLayout._has("gl2d");
	              var hasTernary = fullLayout._has("ternary");
	              var hasMapbox = fullLayout._has("mapbox");
	              var hasPolar = fullLayout._has("polar");
	              var hasSmith = fullLayout._has("smith");
	              var hasSankey = fullLayout._has("sankey");
	              var allAxesFixed = areAllAxesFixed(fullLayout);
	              var hasUnifiedHoverLabel = isUnifiedHover(fullLayout.hovermode);
	              var groups = [];
	              function addGroup(newGroup) {
	                if (!newGroup.length) return;
	                var out = [];
	                for (var i2 = 0; i2 < newGroup.length; i2++) {
	                  var name2 = newGroup[i2];
	                  var B = modeBarButtons[name2];
	                  var v0 = B.name.toLowerCase();
	                  var v1 = (B._cat || B.name).toLowerCase();
	                  var found = false;
	                  for (var q = 0; q < buttonsToRemove.length; q++) {
	                    var t = buttonsToRemove[q].toLowerCase();
	                    if (t === v0 || t === v1) {
	                      found = true;
	                      break;
	                    }
	                  }
	                  if (found) continue;
	                  out.push(modeBarButtons[name2]);
	                }
	                groups.push(out);
	              }
	              var commonGroup = ["toImage"];
	              if (context.showEditInChartStudio) commonGroup.push("editInChartStudio");
	              else if (context.showSendToCloud) commonGroup.push("sendDataToCloud");
	              addGroup(commonGroup);
	              var zoomGroup = [];
	              var hoverGroup = [];
	              var resetGroup = [];
	              var dragModeGroup = [];
	              if ((hasCartesian || hasGL2D || hasPie || hasFunnelarea || hasTernary) + hasGeo + hasGL3D + hasMapbox + hasPolar + hasSmith > 1) {
	                hoverGroup = ["toggleHover"];
	                resetGroup = ["resetViews"];
	              } else if (hasGeo) {
	                zoomGroup = ["zoomInGeo", "zoomOutGeo"];
	                hoverGroup = ["hoverClosestGeo"];
	                resetGroup = ["resetGeo"];
	              } else if (hasGL3D) {
	                hoverGroup = ["hoverClosest3d"];
	                resetGroup = ["resetCameraDefault3d", "resetCameraLastSave3d"];
	              } else if (hasMapbox) {
	                zoomGroup = ["zoomInMapbox", "zoomOutMapbox"];
	                hoverGroup = ["toggleHover"];
	                resetGroup = ["resetViewMapbox"];
	              } else if (hasGL2D) {
	                hoverGroup = ["hoverClosestGl2d"];
	              } else if (hasPie) {
	                hoverGroup = ["hoverClosestPie"];
	              } else if (hasSankey) {
	                hoverGroup = ["hoverClosestCartesian", "hoverCompareCartesian"];
	                resetGroup = ["resetViewSankey"];
	              } else {
	                hoverGroup = ["toggleHover"];
	              }
	              if (hasCartesian) {
	                hoverGroup = ["toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"];
	              }
	              if (hasNoHover(fullData) || hasUnifiedHoverLabel) {
	                hoverGroup = [];
	              }
	              if ((hasCartesian || hasGL2D) && !allAxesFixed) {
	                zoomGroup = ["zoomIn2d", "zoomOut2d", "autoScale2d"];
	                if (resetGroup[0] !== "resetViews") resetGroup = ["resetScale2d"];
	              }
	              if (hasGL3D) {
	                dragModeGroup = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"];
	              } else if ((hasCartesian || hasGL2D) && !allAxesFixed || hasTernary) {
	                dragModeGroup = ["zoom2d", "pan2d"];
	              } else if (hasMapbox || hasGeo) {
	                dragModeGroup = ["pan2d"];
	              } else if (hasPolar) {
	                dragModeGroup = ["zoom2d"];
	              }
	              if (isSelectable(fullData)) {
	                dragModeGroup.push("select2d", "lasso2d");
	              }
	              var enabledHoverGroup = [];
	              var enableHover = function(a) {
	                if (enabledHoverGroup.indexOf(a) !== -1) return;
	                if (hoverGroup.indexOf(a) !== -1) {
	                  enabledHoverGroup.push(a);
	                }
	              };
	              if (Array.isArray(buttonsToAdd)) {
	                var newList = [];
	                for (var i = 0; i < buttonsToAdd.length; i++) {
	                  var b = buttonsToAdd[i];
	                  if (typeof b === "string") {
	                    b = b.toLowerCase();
	                    if (DRAW_MODES.indexOf(b) !== -1) {
	                      if (fullLayout._has("mapbox") || // draw shapes in paper coordinate (could be improved in future to support data coordinate, when there is no pitch)
	                      fullLayout._has("cartesian")) {
	                        dragModeGroup.push(b);
	                      }
	                    } else if (b === "togglespikelines") {
	                      enableHover("toggleSpikelines");
	                    } else if (b === "togglehover") {
	                      enableHover("toggleHover");
	                    } else if (b === "hovercompare") {
	                      enableHover("hoverCompareCartesian");
	                    } else if (b === "hoverclosest") {
	                      enableHover("hoverClosestCartesian");
	                      enableHover("hoverClosestGeo");
	                      enableHover("hoverClosest3d");
	                      enableHover("hoverClosestGl2d");
	                      enableHover("hoverClosestPie");
	                    } else if (b === "v1hovermode") {
	                      enableHover("toggleHover");
	                      enableHover("hoverClosestCartesian");
	                      enableHover("hoverCompareCartesian");
	                      enableHover("hoverClosestGeo");
	                      enableHover("hoverClosest3d");
	                      enableHover("hoverClosestGl2d");
	                      enableHover("hoverClosestPie");
	                    }
	                  } else newList.push(b);
	                }
	                buttonsToAdd = newList;
	              }
	              addGroup(dragModeGroup);
	              addGroup(zoomGroup.concat(resetGroup));
	              addGroup(enabledHoverGroup);
	              return appendButtonsToGroups(groups, buttonsToAdd);
	            }
	            function areAllAxesFixed(fullLayout) {
	              var axList = axisIds.list({
	                _fullLayout: fullLayout
	              }, null, true);
	              for (var i = 0; i < axList.length; i++) {
	                if (!axList[i].fixedrange) {
	                  return false;
	                }
	              }
	              return true;
	            }
	            function isSelectable(fullData) {
	              var selectable = false;
	              for (var i = 0; i < fullData.length; i++) {
	                if (selectable) break;
	                var trace = fullData[i];
	                if (!trace._module || !trace._module.selectPoints) continue;
	                if (Registry.traceIs(trace, "scatter-like")) {
	                  if (scatterSubTypes.hasMarkers(trace) || scatterSubTypes.hasText(trace)) {
	                    selectable = true;
	                  }
	                } else if (Registry.traceIs(trace, "box-violin")) {
	                  if (trace.boxpoints === "all" || trace.points === "all") {
	                    selectable = true;
	                  }
	                } else {
	                  selectable = true;
	                }
	              }
	              return selectable;
	            }
	            function hasNoHover(fullData) {
	              for (var i = 0; i < fullData.length; i++) {
	                if (!Registry.traceIs(fullData[i], "noHover")) return false;
	              }
	              return true;
	            }
	            function appendButtonsToGroups(groups, buttons) {
	              if (buttons.length) {
	                if (Array.isArray(buttons[0])) {
	                  for (var i = 0; i < buttons.length; i++) {
	                    groups.push(buttons[i]);
	                  }
	                } else groups.push(buttons);
	              }
	              return groups;
	            }
	            function fillCustomButton(originalModeBarButtons) {
	              var customButtons = extendDeep([], originalModeBarButtons);
	              for (var i = 0; i < customButtons.length; i++) {
	                var buttonGroup = customButtons[i];
	                for (var j = 0; j < buttonGroup.length; j++) {
	                  var button = buttonGroup[j];
	                  if (typeof button === "string") {
	                    if (modeBarButtons[button] !== undefined) {
	                      customButtons[i][j] = modeBarButtons[button];
	                    } else {
	                      throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
	                    }
	                  }
	                }
	              }
	              return customButtons;
	            }
	          }
	        ),
	        /***/
	        37676: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Icons = __webpack_require__2(24255);
	            var version = __webpack_require__2(11506).version;
	            var Parser = new DOMParser();
	            function ModeBar(opts) {
	              this.container = opts.container;
	              this.element = document.createElement("div");
	              this.update(opts.graphInfo, opts.buttons);
	              this.container.appendChild(this.element);
	            }
	            var proto = ModeBar.prototype;
	            proto.update = function(graphInfo, buttons) {
	              this.graphInfo = graphInfo;
	              var context = this.graphInfo._context;
	              var fullLayout = this.graphInfo._fullLayout;
	              var modeBarId = "modebar-" + fullLayout._uid;
	              this.element.setAttribute("id", modeBarId);
	              this._uid = modeBarId;
	              this.element.className = "modebar";
	              if (context.displayModeBar === "hover") this.element.className += " modebar--hover ease-bg";
	              if (fullLayout.modebar.orientation === "v") {
	                this.element.className += " vertical";
	                buttons = buttons.reverse();
	              }
	              var style = fullLayout.modebar;
	              var bgSelector = context.displayModeBar === "hover" ? ".js-plotly-plot .plotly:hover " : "";
	              Lib.deleteRelatedStyleRule(modeBarId);
	              Lib.addRelatedStyleRule(modeBarId, bgSelector + "#" + modeBarId + " .modebar-group", "background-color: " + style.bgcolor);
	              Lib.addRelatedStyleRule(modeBarId, "#" + modeBarId + " .modebar-btn .icon path", "fill: " + style.color);
	              Lib.addRelatedStyleRule(modeBarId, "#" + modeBarId + " .modebar-btn:hover .icon path", "fill: " + style.activecolor);
	              Lib.addRelatedStyleRule(modeBarId, "#" + modeBarId + " .modebar-btn.active .icon path", "fill: " + style.activecolor);
	              var needsNewButtons = !this.hasButtons(buttons);
	              var needsNewLogo = this.hasLogo !== context.displaylogo;
	              var needsNewLocale = this.locale !== context.locale;
	              this.locale = context.locale;
	              if (needsNewButtons || needsNewLogo || needsNewLocale) {
	                this.removeAllButtons();
	                this.updateButtons(buttons);
	                if (context.watermark || context.displaylogo) {
	                  var logoGroup = this.getLogo();
	                  if (context.watermark) {
	                    logoGroup.className = logoGroup.className + " watermark";
	                  }
	                  if (fullLayout.modebar.orientation === "v") {
	                    this.element.insertBefore(logoGroup, this.element.childNodes[0]);
	                  } else {
	                    this.element.appendChild(logoGroup);
	                  }
	                  this.hasLogo = true;
	                }
	              }
	              this.updateActiveButton();
	            };
	            proto.updateButtons = function(buttons) {
	              var _this = this;
	              this.buttons = buttons;
	              this.buttonElements = [];
	              this.buttonsNames = [];
	              this.buttons.forEach(function(buttonGroup) {
	                var group = _this.createGroup();
	                buttonGroup.forEach(function(buttonConfig) {
	                  var buttonName = buttonConfig.name;
	                  if (!buttonName) {
	                    throw new Error("must provide button 'name' in button config");
	                  }
	                  if (_this.buttonsNames.indexOf(buttonName) !== -1) {
	                    throw new Error("button name '" + buttonName + "' is taken");
	                  }
	                  _this.buttonsNames.push(buttonName);
	                  var button = _this.createButton(buttonConfig);
	                  _this.buttonElements.push(button);
	                  group.appendChild(button);
	                });
	                _this.element.appendChild(group);
	              });
	            };
	            proto.createGroup = function() {
	              var group = document.createElement("div");
	              group.className = "modebar-group";
	              return group;
	            };
	            proto.createButton = function(config) {
	              var _this = this;
	              var button = document.createElement("a");
	              button.setAttribute("rel", "tooltip");
	              button.className = "modebar-btn";
	              var title = config.title;
	              if (title === undefined) title = config.name;
	              else if (typeof title === "function") title = title(this.graphInfo);
	              if (title || title === 0) button.setAttribute("data-title", title);
	              if (config.attr !== undefined) button.setAttribute("data-attr", config.attr);
	              var val = config.val;
	              if (val !== undefined) {
	                if (typeof val === "function") val = val(this.graphInfo);
	                button.setAttribute("data-val", val);
	              }
	              var click = config.click;
	              if (typeof click !== "function") {
	                throw new Error("must provide button 'click' function in button config");
	              } else {
	                button.addEventListener("click", function(ev) {
	                  config.click(_this.graphInfo, ev);
	                  _this.updateActiveButton(ev.currentTarget);
	                });
	              }
	              button.setAttribute("data-toggle", config.toggle || false);
	              if (config.toggle) d3.select(button).classed("active", true);
	              var icon = config.icon;
	              if (typeof icon === "function") {
	                button.appendChild(icon());
	              } else {
	                button.appendChild(this.createIcon(icon || Icons.question));
	              }
	              button.setAttribute("data-gravity", config.gravity || "n");
	              return button;
	            };
	            proto.createIcon = function(thisIcon) {
	              var iconHeight = isNumeric(thisIcon.height) ? Number(thisIcon.height) : thisIcon.ascent - thisIcon.descent;
	              var svgNS = "http://www.w3.org/2000/svg";
	              var icon;
	              if (thisIcon.path) {
	                icon = document.createElementNS(svgNS, "svg");
	                icon.setAttribute("viewBox", [0, 0, thisIcon.width, iconHeight].join(" "));
	                icon.setAttribute("class", "icon");
	                var path = document.createElementNS(svgNS, "path");
	                path.setAttribute("d", thisIcon.path);
	                if (thisIcon.transform) {
	                  path.setAttribute("transform", thisIcon.transform);
	                } else if (thisIcon.ascent !== undefined) {
	                  path.setAttribute("transform", "matrix(1 0 0 -1 0 " + thisIcon.ascent + ")");
	                }
	                icon.appendChild(path);
	              }
	              if (thisIcon.svg) {
	                var svgDoc = Parser.parseFromString(thisIcon.svg, "application/xml");
	                icon = svgDoc.childNodes[0];
	              }
	              icon.setAttribute("height", "1em");
	              icon.setAttribute("width", "1em");
	              return icon;
	            };
	            proto.updateActiveButton = function(buttonClicked) {
	              var fullLayout = this.graphInfo._fullLayout;
	              var dataAttrClicked = buttonClicked !== undefined ? buttonClicked.getAttribute("data-attr") : null;
	              this.buttonElements.forEach(function(button) {
	                var thisval = button.getAttribute("data-val") || true;
	                var dataAttr = button.getAttribute("data-attr");
	                var isToggleButton = button.getAttribute("data-toggle") === "true";
	                var button3 = d3.select(button);
	                if (isToggleButton) {
	                  if (dataAttr === dataAttrClicked) {
	                    button3.classed("active", !button3.classed("active"));
	                  }
	                } else {
	                  var val = dataAttr === null ? dataAttr : Lib.nestedProperty(fullLayout, dataAttr).get();
	                  button3.classed("active", val === thisval);
	                }
	              });
	            };
	            proto.hasButtons = function(buttons) {
	              var currentButtons = this.buttons;
	              if (!currentButtons) return false;
	              if (buttons.length !== currentButtons.length) return false;
	              for (var i = 0; i < buttons.length; ++i) {
	                if (buttons[i].length !== currentButtons[i].length) return false;
	                for (var j = 0; j < buttons[i].length; j++) {
	                  if (buttons[i][j].name !== currentButtons[i][j].name) return false;
	                }
	              }
	              return true;
	            };
	            function jsVersion(str) {
	              return str + " (v" + version + ")";
	            }
	            proto.getLogo = function() {
	              var group = this.createGroup();
	              var a = document.createElement("a");
	              a.href = "https://plotly.com/";
	              a.target = "_blank";
	              a.setAttribute("data-title", jsVersion(Lib._(this.graphInfo, "Produced with Plotly.js")));
	              a.className = "modebar-btn plotlyjsicon modebar-btn--logo";
	              a.appendChild(this.createIcon(Icons.newplotlylogo));
	              group.appendChild(a);
	              return group;
	            };
	            proto.removeAllButtons = function() {
	              while (this.element.firstChild) {
	                this.element.removeChild(this.element.firstChild);
	              }
	              this.hasLogo = false;
	            };
	            proto.destroy = function() {
	              Lib.removeElement(this.container.querySelector(".modebar"));
	              Lib.deleteRelatedStyleRule(this._uid);
	            };
	            function createModeBar(gd, buttons) {
	              var fullLayout = gd._fullLayout;
	              var modeBar = new ModeBar({
	                graphInfo: gd,
	                container: fullLayout._modebardiv.node(),
	                buttons
	              });
	              if (fullLayout._privateplot) {
	                d3.select(modeBar.element).append("span").classed("badge-private float--left", true).text("PRIVATE");
	              }
	              return modeBar;
	            }
	            module2.exports = createModeBar;
	          }
	        ),
	        /***/
	        37113: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var buttonAttrs = templatedArray("button", {
	              visible: {
	                valType: "boolean",
	                dflt: true,
	                editType: "plot"
	              },
	              step: {
	                valType: "enumerated",
	                values: ["month", "year", "day", "hour", "minute", "second", "all"],
	                dflt: "month",
	                editType: "plot"
	              },
	              stepmode: {
	                valType: "enumerated",
	                values: ["backward", "todate"],
	                dflt: "backward",
	                editType: "plot"
	              },
	              count: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "plot"
	              },
	              label: {
	                valType: "string",
	                editType: "plot"
	              },
	              editType: "plot"
	            });
	            module2.exports = {
	              visible: {
	                valType: "boolean",
	                editType: "plot"
	              },
	              buttons: buttonAttrs,
	              x: {
	                valType: "number",
	                min: -2,
	                max: 3,
	                editType: "plot"
	              },
	              xanchor: {
	                valType: "enumerated",
	                values: ["auto", "left", "center", "right"],
	                dflt: "left",
	                editType: "plot"
	              },
	              y: {
	                valType: "number",
	                min: -2,
	                max: 3,
	                editType: "plot"
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["auto", "top", "middle", "bottom"],
	                dflt: "bottom",
	                editType: "plot"
	              },
	              font: fontAttrs({
	                editType: "plot"
	              }),
	              bgcolor: {
	                valType: "color",
	                dflt: colorAttrs.lightLine,
	                editType: "plot"
	              },
	              activecolor: {
	                valType: "color",
	                editType: "plot"
	              },
	              bordercolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "plot"
	              },
	              borderwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 0,
	                editType: "plot"
	              },
	              editType: "plot"
	            };
	          }
	        ),
	        /***/
	        89573: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // 'y' position pad above counter axis domain
	              yPad: 0.02,
	              // minimum button width (regardless of text size)
	              minButtonWidth: 30,
	              // buttons rect radii
	              rx: 3,
	              ry: 3,
	              // light fraction used to compute the 'activecolor' default
	              lightAmount: 25,
	              darkAmount: 10
	            };
	          }
	        ),
	        /***/
	        28674: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Template = __webpack_require__2(44467);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(37113);
	            var constants = __webpack_require__2(89573);
	            module2.exports = function handleDefaults(containerIn, containerOut, layout, counterAxes, calendar) {
	              var selectorIn = containerIn.rangeselector || {};
	              var selectorOut = Template.newContainer(containerOut, "rangeselector");
	              function coerce(attr, dflt) {
	                return Lib.coerce(selectorIn, selectorOut, attributes, attr, dflt);
	              }
	              var buttons = handleArrayContainerDefaults(selectorIn, selectorOut, {
	                name: "buttons",
	                handleItemDefaults: buttonDefaults,
	                calendar
	              });
	              var visible = coerce("visible", buttons.length > 0);
	              if (visible) {
	                var posDflt = getPosDflt(containerOut, layout, counterAxes);
	                coerce("x", posDflt[0]);
	                coerce("y", posDflt[1]);
	                Lib.noneOrAll(containerIn, containerOut, ["x", "y"]);
	                coerce("xanchor");
	                coerce("yanchor");
	                Lib.coerceFont(coerce, "font", layout.font);
	                var bgColor = coerce("bgcolor");
	                coerce("activecolor", Color.contrast(bgColor, constants.lightAmount, constants.darkAmount));
	                coerce("bordercolor");
	                coerce("borderwidth");
	              }
	            };
	            function buttonDefaults(buttonIn, buttonOut, selectorOut, opts) {
	              var calendar = opts.calendar;
	              function coerce(attr, dflt) {
	                return Lib.coerce(buttonIn, buttonOut, attributes.buttons, attr, dflt);
	              }
	              var visible = coerce("visible");
	              if (visible) {
	                var step = coerce("step");
	                if (step !== "all") {
	                  if (calendar && calendar !== "gregorian" && (step === "month" || step === "year")) {
	                    buttonOut.stepmode = "backward";
	                  } else {
	                    coerce("stepmode");
	                  }
	                  coerce("count");
	                }
	                coerce("label");
	              }
	            }
	            function getPosDflt(containerOut, layout, counterAxes) {
	              var anchoredList = counterAxes.filter(function(ax) {
	                return layout[ax].anchor === containerOut._id;
	              });
	              var posY = 0;
	              for (var i = 0; i < anchoredList.length; i++) {
	                var domain = layout[anchoredList[i]].domain;
	                if (domain) posY = Math.max(domain[1], posY);
	              }
	              return [containerOut.domain[0], posY + constants.yPad];
	            }
	          }
	        ),
	        /***/
	        21598: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Plots = __webpack_require__2(74875);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var axisIds = __webpack_require__2(41675);
	            var alignmentConstants = __webpack_require__2(18783);
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var FROM_TL = alignmentConstants.FROM_TL;
	            var FROM_BR = alignmentConstants.FROM_BR;
	            var constants = __webpack_require__2(89573);
	            var getUpdateObject = __webpack_require__2(70565);
	            module2.exports = function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              var selectors = fullLayout._infolayer.selectAll(".rangeselector").data(makeSelectorData(gd), selectorKeyFunc);
	              selectors.enter().append("g").classed("rangeselector", true);
	              selectors.exit().remove();
	              selectors.style({
	                cursor: "pointer",
	                "pointer-events": "all"
	              });
	              selectors.each(function(d) {
	                var selector = d3.select(this);
	                var axisLayout = d;
	                var selectorLayout = axisLayout.rangeselector;
	                var buttons = selector.selectAll("g.button").data(Lib.filterVisible(selectorLayout.buttons));
	                buttons.enter().append("g").classed("button", true);
	                buttons.exit().remove();
	                buttons.each(function(d2) {
	                  var button = d3.select(this);
	                  var update = getUpdateObject(axisLayout, d2);
	                  d2._isActive = isActive(axisLayout, d2, update);
	                  button.call(drawButtonRect, selectorLayout, d2);
	                  button.call(drawButtonText, selectorLayout, d2, gd);
	                  button.on("click", function() {
	                    if (gd._dragged) return;
	                    Registry.call("_guiRelayout", gd, update);
	                  });
	                  button.on("mouseover", function() {
	                    d2._isHovered = true;
	                    button.call(drawButtonRect, selectorLayout, d2);
	                  });
	                  button.on("mouseout", function() {
	                    d2._isHovered = false;
	                    button.call(drawButtonRect, selectorLayout, d2);
	                  });
	                });
	                reposition(gd, buttons, selectorLayout, axisLayout._name, selector);
	              });
	            };
	            function makeSelectorData(gd) {
	              var axes = axisIds.list(gd, "x", true);
	              var data = [];
	              for (var i = 0; i < axes.length; i++) {
	                var axis = axes[i];
	                if (axis.rangeselector && axis.rangeselector.visible) {
	                  data.push(axis);
	                }
	              }
	              return data;
	            }
	            function selectorKeyFunc(d) {
	              return d._id;
	            }
	            function isActive(axisLayout, opts, update) {
	              if (opts.step === "all") {
	                return axisLayout.autorange === true;
	              } else {
	                var keys = Object.keys(update);
	                return axisLayout.range[0] === update[keys[0]] && axisLayout.range[1] === update[keys[1]];
	              }
	            }
	            function drawButtonRect(button, selectorLayout, d) {
	              var rect = Lib.ensureSingle(button, "rect", "selector-rect", function(s) {
	                s.attr("shape-rendering", "crispEdges");
	              });
	              rect.attr({
	                rx: constants.rx,
	                ry: constants.ry
	              });
	              rect.call(Color.stroke, selectorLayout.bordercolor).call(Color.fill, getFillColor(selectorLayout, d)).style("stroke-width", selectorLayout.borderwidth + "px");
	            }
	            function getFillColor(selectorLayout, d) {
	              return d._isActive || d._isHovered ? selectorLayout.activecolor : selectorLayout.bgcolor;
	            }
	            function drawButtonText(button, selectorLayout, d, gd) {
	              function textLayout(s) {
	                svgTextUtils.convertToTspans(s, gd);
	              }
	              var text = Lib.ensureSingle(button, "text", "selector-text", function(s) {
	                s.attr("text-anchor", "middle");
	              });
	              text.call(Drawing.font, selectorLayout.font).text(getLabel(d, gd._fullLayout._meta)).call(textLayout);
	            }
	            function getLabel(opts, _meta) {
	              if (opts.label) {
	                return _meta ? Lib.templateString(opts.label, _meta) : opts.label;
	              }
	              if (opts.step === "all") return "all";
	              return opts.count + opts.step.charAt(0);
	            }
	            function reposition(gd, buttons, opts, axName, selector) {
	              var width = 0;
	              var height = 0;
	              var borderWidth = opts.borderwidth;
	              buttons.each(function() {
	                var button = d3.select(this);
	                var text = button.select(".selector-text");
	                var tHeight = opts.font.size * LINE_SPACING;
	                var hEff = Math.max(tHeight * svgTextUtils.lineCount(text), 16) + 3;
	                height = Math.max(height, hEff);
	              });
	              buttons.each(function() {
	                var button = d3.select(this);
	                var rect = button.select(".selector-rect");
	                var text = button.select(".selector-text");
	                var tWidth = text.node() && Drawing.bBox(text.node()).width;
	                var tHeight = opts.font.size * LINE_SPACING;
	                var tLines = svgTextUtils.lineCount(text);
	                var wEff = Math.max(tWidth + 10, constants.minButtonWidth);
	                button.attr("transform", strTranslate(borderWidth + width, borderWidth));
	                rect.attr({
	                  x: 0,
	                  y: 0,
	                  width: wEff,
	                  height
	                });
	                svgTextUtils.positionText(text, wEff / 2, height / 2 - (tLines - 1) * tHeight / 2 + 3);
	                width += wEff + 5;
	              });
	              var graphSize = gd._fullLayout._size;
	              var lx = graphSize.l + graphSize.w * opts.x;
	              var ly = graphSize.t + graphSize.h * (1 - opts.y);
	              var xanchor = "left";
	              if (Lib.isRightAnchor(opts)) {
	                lx -= width;
	                xanchor = "right";
	              }
	              if (Lib.isCenterAnchor(opts)) {
	                lx -= width / 2;
	                xanchor = "center";
	              }
	              var yanchor = "top";
	              if (Lib.isBottomAnchor(opts)) {
	                ly -= height;
	                yanchor = "bottom";
	              }
	              if (Lib.isMiddleAnchor(opts)) {
	                ly -= height / 2;
	                yanchor = "middle";
	              }
	              width = Math.ceil(width);
	              height = Math.ceil(height);
	              lx = Math.round(lx);
	              ly = Math.round(ly);
	              Plots.autoMargin(gd, axName + "-range-selector", {
	                x: opts.x,
	                y: opts.y,
	                l: width * FROM_TL[xanchor],
	                r: width * FROM_BR[xanchor],
	                b: height * FROM_BR[yanchor],
	                t: height * FROM_TL[yanchor]
	              });
	              selector.attr("transform", strTranslate(lx, ly));
	            }
	          }
	        ),
	        /***/
	        70565: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3Time = __webpack_require__2(81041);
	            var titleCase = __webpack_require__2(71828).titleCase;
	            module2.exports = function getUpdateObject(axisLayout, buttonLayout) {
	              var axName = axisLayout._name;
	              var update = {};
	              if (buttonLayout.step === "all") {
	                update[axName + ".autorange"] = true;
	              } else {
	                var xrange = getXRange(axisLayout, buttonLayout);
	                update[axName + ".range[0]"] = xrange[0];
	                update[axName + ".range[1]"] = xrange[1];
	              }
	              return update;
	            };
	            function getXRange(axisLayout, buttonLayout) {
	              var currentRange = axisLayout.range;
	              var base = new Date(axisLayout.r2l(currentRange[1]));
	              var step = buttonLayout.step;
	              var utcStep = d3Time["utc" + titleCase(step)];
	              var count = buttonLayout.count;
	              var range0;
	              switch (buttonLayout.stepmode) {
	                case "backward":
	                  range0 = axisLayout.l2r(+utcStep.offset(base, -count));
	                  break;
	                case "todate":
	                  var base2 = utcStep.offset(base, -count);
	                  range0 = axisLayout.l2r(+utcStep.ceil(base2));
	                  break;
	              }
	              var range1 = currentRange[1];
	              return [range0, range1];
	            }
	          }
	        ),
	        /***/
	        97218: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "component",
	              name: "rangeselector",
	              schema: {
	                subplots: {
	                  xaxis: {
	                    rangeselector: __webpack_require__2(37113)
	                  }
	                }
	              },
	              layoutAttributes: __webpack_require__2(37113),
	              handleDefaults: __webpack_require__2(28674),
	              draw: __webpack_require__2(21598)
	            };
	          }
	        ),
	        /***/
	        75148: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorAttributes = __webpack_require__2(22399);
	            module2.exports = {
	              bgcolor: {
	                valType: "color",
	                dflt: colorAttributes.background,
	                editType: "plot"
	              },
	              bordercolor: {
	                valType: "color",
	                dflt: colorAttributes.defaultLine,
	                editType: "plot"
	              },
	              borderwidth: {
	                valType: "integer",
	                dflt: 0,
	                min: 0,
	                editType: "plot"
	              },
	              autorange: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc",
	                impliedEdits: {
	                  "range[0]": undefined,
	                  "range[1]": undefined
	                }
	              },
	              range: {
	                valType: "info_array",
	                items: [{
	                  valType: "any",
	                  editType: "calc",
	                  impliedEdits: {
	                    "^autorange": false
	                  }
	                }, {
	                  valType: "any",
	                  editType: "calc",
	                  impliedEdits: {
	                    "^autorange": false
	                  }
	                }],
	                editType: "calc",
	                impliedEdits: {
	                  autorange: false
	                }
	              },
	              thickness: {
	                valType: "number",
	                dflt: 0.15,
	                min: 0,
	                max: 1,
	                editType: "plot"
	              },
	              visible: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              editType: "calc"
	            };
	          }
	        ),
	        /***/
	        88443: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var listAxes = __webpack_require__2(41675).list;
	            var getAutoRange = __webpack_require__2(71739).getAutoRange;
	            var constants = __webpack_require__2(73251);
	            module2.exports = function calcAutorange(gd) {
	              var axes = listAxes(gd, "x", true);
	              for (var i = 0; i < axes.length; i++) {
	                var ax = axes[i];
	                var opts = ax[constants.name];
	                if (opts && opts.visible && opts.autorange) {
	                  opts._input.autorange = true;
	                  opts._input.range = opts.range = getAutoRange(gd, ax);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        73251: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // attribute container name
	              name: "rangeslider",
	              // class names
	              containerClassName: "rangeslider-container",
	              bgClassName: "rangeslider-bg",
	              rangePlotClassName: "rangeslider-rangeplot",
	              maskMinClassName: "rangeslider-mask-min",
	              maskMaxClassName: "rangeslider-mask-max",
	              slideBoxClassName: "rangeslider-slidebox",
	              grabberMinClassName: "rangeslider-grabber-min",
	              grabAreaMinClassName: "rangeslider-grabarea-min",
	              handleMinClassName: "rangeslider-handle-min",
	              grabberMaxClassName: "rangeslider-grabber-max",
	              grabAreaMaxClassName: "rangeslider-grabarea-max",
	              handleMaxClassName: "rangeslider-handle-max",
	              maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
	              maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
	              // style constants
	              maskColor: "rgba(0,0,0,0.4)",
	              maskOppAxisColor: "rgba(0,0,0,0.2)",
	              slideBoxFill: "transparent",
	              slideBoxCursor: "ew-resize",
	              grabAreaFill: "transparent",
	              grabAreaCursor: "col-resize",
	              grabAreaWidth: 10,
	              handleWidth: 4,
	              handleRadius: 1,
	              handleStrokeWidth: 1,
	              extraPad: 15
	            };
	          }
	        ),
	        /***/
	        26377: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var axisIds = __webpack_require__2(41675);
	            var attributes = __webpack_require__2(75148);
	            var oppAxisAttrs = __webpack_require__2(47850);
	            module2.exports = function handleDefaults(layoutIn, layoutOut, axName) {
	              var axIn = layoutIn[axName];
	              var axOut = layoutOut[axName];
	              if (!(axIn.rangeslider || layoutOut._requestRangeslider[axOut._id])) return;
	              if (!Lib.isPlainObject(axIn.rangeslider)) {
	                axIn.rangeslider = {};
	              }
	              var containerIn = axIn.rangeslider;
	              var containerOut = Template.newContainer(axOut, "rangeslider");
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	              }
	              var rangeContainerIn, rangeContainerOut;
	              function coerceRange(attr, dflt) {
	                return Lib.coerce(rangeContainerIn, rangeContainerOut, oppAxisAttrs, attr, dflt);
	              }
	              var visible = coerce("visible");
	              if (!visible) return;
	              coerce("bgcolor", layoutOut.plot_bgcolor);
	              coerce("bordercolor");
	              coerce("borderwidth");
	              coerce("thickness");
	              coerce("autorange", !axOut.isValidRange(containerIn.range));
	              coerce("range");
	              var subplots = layoutOut._subplots;
	              if (subplots) {
	                var yIds = subplots.cartesian.filter(function(subplotId) {
	                  return subplotId.substr(0, subplotId.indexOf("y")) === axisIds.name2id(axName);
	                }).map(function(subplotId) {
	                  return subplotId.substr(subplotId.indexOf("y"), subplotId.length);
	                });
	                var yNames = Lib.simpleMap(yIds, axisIds.id2name);
	                for (var i = 0; i < yNames.length; i++) {
	                  var yName = yNames[i];
	                  rangeContainerIn = containerIn[yName] || {};
	                  rangeContainerOut = Template.newContainer(containerOut, yName, "yaxis");
	                  var yAxOut = layoutOut[yName];
	                  var rangemodeDflt;
	                  if (rangeContainerIn.range && yAxOut.isValidRange(rangeContainerIn.range)) {
	                    rangemodeDflt = "fixed";
	                  }
	                  var rangeMode = coerceRange("rangemode", rangemodeDflt);
	                  if (rangeMode !== "match") {
	                    coerceRange("range", yAxOut.range.slice());
	                  }
	                }
	              }
	              containerOut._input = containerIn;
	            };
	          }
	        ),
	        /***/
	        72413: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Plots = __webpack_require__2(74875);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var Titles = __webpack_require__2(92998);
	            var Cartesian = __webpack_require__2(93612);
	            var axisIDs = __webpack_require__2(41675);
	            var dragElement = __webpack_require__2(28569);
	            var setCursor = __webpack_require__2(6964);
	            var constants = __webpack_require__2(73251);
	            module2.exports = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var rangeSliderData = fullLayout._rangeSliderData;
	              for (var i = 0; i < rangeSliderData.length; i++) {
	                var opts = rangeSliderData[i][constants.name];
	                opts._clipId = opts._id + "-" + fullLayout._uid;
	              }
	              function keyFunction(axisOpts) {
	                return axisOpts._name;
	              }
	              var rangeSliders = fullLayout._infolayer.selectAll("g." + constants.containerClassName).data(rangeSliderData, keyFunction);
	              rangeSliders.exit().each(function(axisOpts) {
	                var opts2 = axisOpts[constants.name];
	                fullLayout._topdefs.select("#" + opts2._clipId).remove();
	              }).remove();
	              if (rangeSliderData.length === 0) return;
	              rangeSliders.enter().append("g").classed(constants.containerClassName, true).attr("pointer-events", "all");
	              rangeSliders.each(function(axisOpts) {
	                var rangeSlider = d3.select(this);
	                var opts2 = axisOpts[constants.name];
	                var oppAxisOpts = fullLayout[axisIDs.id2name(axisOpts.anchor)];
	                var oppAxisRangeOpts = opts2[axisIDs.id2name(axisOpts.anchor)];
	                if (opts2.range) {
	                  var rng = Lib.simpleMap(opts2.range, axisOpts.r2l);
	                  var axRng = Lib.simpleMap(axisOpts.range, axisOpts.r2l);
	                  var newRng;
	                  if (axRng[0] < axRng[1]) {
	                    newRng = [Math.min(rng[0], axRng[0]), Math.max(rng[1], axRng[1])];
	                  } else {
	                    newRng = [Math.max(rng[0], axRng[0]), Math.min(rng[1], axRng[1])];
	                  }
	                  opts2.range = opts2._input.range = Lib.simpleMap(newRng, axisOpts.l2r);
	                }
	                axisOpts.cleanRange("rangeslider.range");
	                var gs = fullLayout._size;
	                var domain = axisOpts.domain;
	                opts2._width = gs.w * (domain[1] - domain[0]);
	                var x = Math.round(gs.l + gs.w * domain[0]);
	                var y = Math.round(gs.t + gs.h * (1 - axisOpts._counterDomainMin) + (axisOpts.side === "bottom" ? axisOpts._depth : 0) + opts2._offsetShift + constants.extraPad);
	                rangeSlider.attr("transform", strTranslate(x, y));
	                opts2._rl = Lib.simpleMap(opts2.range, axisOpts.r2l);
	                var rl0 = opts2._rl[0];
	                var rl1 = opts2._rl[1];
	                var drl = rl1 - rl0;
	                opts2.p2d = function(v) {
	                  return v / opts2._width * drl + rl0;
	                };
	                opts2.d2p = function(v) {
	                  return (v - rl0) / drl * opts2._width;
	                };
	                if (axisOpts.rangebreaks) {
	                  var rsBreaks = axisOpts.locateBreaks(rl0, rl1);
	                  if (rsBreaks.length) {
	                    var j, brk;
	                    var lBreaks = 0;
	                    for (j = 0; j < rsBreaks.length; j++) {
	                      brk = rsBreaks[j];
	                      lBreaks += brk.max - brk.min;
	                    }
	                    var m2 = opts2._width / (rl1 - rl0 - lBreaks);
	                    var _B = [-m2 * rl0];
	                    for (j = 0; j < rsBreaks.length; j++) {
	                      brk = rsBreaks[j];
	                      _B.push(_B[_B.length - 1] - m2 * (brk.max - brk.min));
	                    }
	                    opts2.d2p = function(v) {
	                      var b = _B[0];
	                      for (var j2 = 0; j2 < rsBreaks.length; j2++) {
	                        var brk2 = rsBreaks[j2];
	                        if (v >= brk2.max) b = _B[j2 + 1];
	                        else if (v < brk2.min) break;
	                      }
	                      return b + m2 * v;
	                    };
	                    for (j = 0; j < rsBreaks.length; j++) {
	                      brk = rsBreaks[j];
	                      brk.pmin = opts2.d2p(brk.min);
	                      brk.pmax = opts2.d2p(brk.max);
	                    }
	                    opts2.p2d = function(v) {
	                      var b = _B[0];
	                      for (var j2 = 0; j2 < rsBreaks.length; j2++) {
	                        var brk2 = rsBreaks[j2];
	                        if (v >= brk2.pmax) b = _B[j2 + 1];
	                        else if (v < brk2.pmin) break;
	                      }
	                      return (v - b) / m2;
	                    };
	                  }
	                }
	                if (oppAxisRangeOpts.rangemode !== "match") {
	                  var range0OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[0]);
	                  var range1OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[1]);
	                  var distOppAxis = range1OppAxis - range0OppAxis;
	                  opts2.d2pOppAxis = function(v) {
	                    return (v - range0OppAxis) / distOppAxis * opts2._height;
	                  };
	                }
	                rangeSlider.call(drawBg, gd, axisOpts, opts2).call(addClipPath, gd, axisOpts, opts2).call(drawRangePlot, gd, axisOpts, opts2).call(drawMasks, gd, axisOpts, opts2, oppAxisRangeOpts).call(drawSlideBox, gd, axisOpts, opts2).call(drawGrabbers, gd, axisOpts, opts2);
	                setupDragElement(rangeSlider, gd, axisOpts, opts2);
	                setPixelRange(rangeSlider, gd, axisOpts, opts2, oppAxisOpts, oppAxisRangeOpts);
	                if (axisOpts.side === "bottom") {
	                  Titles.draw(gd, axisOpts._id + "title", {
	                    propContainer: axisOpts,
	                    propName: axisOpts._name + ".title",
	                    placeholder: fullLayout._dfltTitle.x,
	                    attributes: {
	                      x: axisOpts._offset + axisOpts._length / 2,
	                      y: y + opts2._height + opts2._offsetShift + 10 + 1.5 * axisOpts.title.font.size,
	                      "text-anchor": "middle"
	                    }
	                  });
	                }
	              });
	            };
	            function setupDragElement(rangeSlider, gd, axisOpts, opts) {
	              if (gd._context.staticPlot) return;
	              var slideBox = rangeSlider.select("rect." + constants.slideBoxClassName).node();
	              var grabAreaMin = rangeSlider.select("rect." + constants.grabAreaMinClassName).node();
	              var grabAreaMax = rangeSlider.select("rect." + constants.grabAreaMaxClassName).node();
	              function mouseDownHandler() {
	                var event = d3.event;
	                var target = event.target;
	                var startX = event.clientX || event.touches[0].clientX;
	                var offsetX = startX - rangeSlider.node().getBoundingClientRect().left;
	                var minVal = opts.d2p(axisOpts._rl[0]);
	                var maxVal = opts.d2p(axisOpts._rl[1]);
	                var dragCover = dragElement.coverSlip();
	                this.addEventListener("touchmove", mouseMove);
	                this.addEventListener("touchend", mouseUp);
	                dragCover.addEventListener("mousemove", mouseMove);
	                dragCover.addEventListener("mouseup", mouseUp);
	                function mouseMove(e) {
	                  var clientX = e.clientX || e.touches[0].clientX;
	                  var delta = +clientX - startX;
	                  var pixelMin, pixelMax, cursor;
	                  switch (target) {
	                    case slideBox:
	                      cursor = "ew-resize";
	                      if (minVal + delta > axisOpts._length || maxVal + delta < 0) {
	                        return;
	                      }
	                      pixelMin = minVal + delta;
	                      pixelMax = maxVal + delta;
	                      break;
	                    case grabAreaMin:
	                      cursor = "col-resize";
	                      if (minVal + delta > axisOpts._length) {
	                        return;
	                      }
	                      pixelMin = minVal + delta;
	                      pixelMax = maxVal;
	                      break;
	                    case grabAreaMax:
	                      cursor = "col-resize";
	                      if (maxVal + delta < 0) {
	                        return;
	                      }
	                      pixelMin = minVal;
	                      pixelMax = maxVal + delta;
	                      break;
	                    default:
	                      cursor = "ew-resize";
	                      pixelMin = offsetX;
	                      pixelMax = offsetX + delta;
	                      break;
	                  }
	                  if (pixelMax < pixelMin) {
	                    var tmp = pixelMax;
	                    pixelMax = pixelMin;
	                    pixelMin = tmp;
	                  }
	                  opts._pixelMin = pixelMin;
	                  opts._pixelMax = pixelMax;
	                  setCursor(d3.select(dragCover), cursor);
	                  setDataRange(rangeSlider, gd, axisOpts, opts);
	                }
	                function mouseUp() {
	                  dragCover.removeEventListener("mousemove", mouseMove);
	                  dragCover.removeEventListener("mouseup", mouseUp);
	                  this.removeEventListener("touchmove", mouseMove);
	                  this.removeEventListener("touchend", mouseUp);
	                  Lib.removeElement(dragCover);
	                }
	              }
	              rangeSlider.on("mousedown", mouseDownHandler);
	              rangeSlider.on("touchstart", mouseDownHandler);
	            }
	            function setDataRange(rangeSlider, gd, axisOpts, opts) {
	              function clamp(v) {
	                return axisOpts.l2r(Lib.constrain(v, opts._rl[0], opts._rl[1]));
	              }
	              var dataMin = clamp(opts.p2d(opts._pixelMin));
	              var dataMax = clamp(opts.p2d(opts._pixelMax));
	              window.requestAnimationFrame(function() {
	                Registry.call("_guiRelayout", gd, axisOpts._name + ".range", [dataMin, dataMax]);
	              });
	            }
	            function setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts) {
	              var hw2 = constants.handleWidth / 2;
	              function clamp(v) {
	                return Lib.constrain(v, 0, opts._width);
	              }
	              function clampOppAxis(v) {
	                return Lib.constrain(v, 0, opts._height);
	              }
	              function clampHandle(v) {
	                return Lib.constrain(v, -hw2, opts._width + hw2);
	              }
	              var pixelMin = clamp(opts.d2p(axisOpts._rl[0]));
	              var pixelMax = clamp(opts.d2p(axisOpts._rl[1]));
	              rangeSlider.select("rect." + constants.slideBoxClassName).attr("x", pixelMin).attr("width", pixelMax - pixelMin);
	              rangeSlider.select("rect." + constants.maskMinClassName).attr("width", pixelMin);
	              rangeSlider.select("rect." + constants.maskMaxClassName).attr("x", pixelMax).attr("width", opts._width - pixelMax);
	              if (oppAxisRangeOpts.rangemode !== "match") {
	                var pixelMinOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[1]));
	                var pixelMaxOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[0]));
	                rangeSlider.select("rect." + constants.maskMinOppAxisClassName).attr("x", pixelMin).attr("height", pixelMinOppAxis).attr("width", pixelMax - pixelMin);
	                rangeSlider.select("rect." + constants.maskMaxOppAxisClassName).attr("x", pixelMin).attr("y", pixelMaxOppAxis).attr("height", opts._height - pixelMaxOppAxis).attr("width", pixelMax - pixelMin);
	                rangeSlider.select("rect." + constants.slideBoxClassName).attr("y", pixelMinOppAxis).attr("height", pixelMaxOppAxis - pixelMinOppAxis);
	              }
	              var offset = 0.5;
	              var xMin = Math.round(clampHandle(pixelMin - hw2)) - offset;
	              var xMax = Math.round(clampHandle(pixelMax - hw2)) + offset;
	              rangeSlider.select("g." + constants.grabberMinClassName).attr("transform", strTranslate(xMin, offset));
	              rangeSlider.select("g." + constants.grabberMaxClassName).attr("transform", strTranslate(xMax, offset));
	            }
	            function drawBg(rangeSlider, gd, axisOpts, opts) {
	              var bg = Lib.ensureSingle(rangeSlider, "rect", constants.bgClassName, function(s) {
	                s.attr({
	                  x: 0,
	                  y: 0,
	                  "shape-rendering": "crispEdges"
	                });
	              });
	              var borderCorrect = opts.borderwidth % 2 === 0 ? opts.borderwidth : opts.borderwidth - 1;
	              var offsetShift = -opts._offsetShift;
	              var lw = Drawing.crispRound(gd, opts.borderwidth);
	              bg.attr({
	                width: opts._width + borderCorrect,
	                height: opts._height + borderCorrect,
	                transform: strTranslate(offsetShift, offsetShift),
	                "stroke-width": lw
	              }).call(Color.stroke, opts.bordercolor).call(Color.fill, opts.bgcolor);
	            }
	            function addClipPath(rangeSlider, gd, axisOpts, opts) {
	              var fullLayout = gd._fullLayout;
	              var clipPath = Lib.ensureSingleById(fullLayout._topdefs, "clipPath", opts._clipId, function(s) {
	                s.append("rect").attr({
	                  x: 0,
	                  y: 0
	                });
	              });
	              clipPath.select("rect").attr({
	                width: opts._width,
	                height: opts._height
	              });
	            }
	            function drawRangePlot(rangeSlider, gd, axisOpts, opts) {
	              var calcData = gd.calcdata;
	              var rangePlots = rangeSlider.selectAll("g." + constants.rangePlotClassName).data(axisOpts._subplotsWith, Lib.identity);
	              rangePlots.enter().append("g").attr("class", function(id) {
	                return constants.rangePlotClassName + " " + id;
	              }).call(Drawing.setClipUrl, opts._clipId, gd);
	              rangePlots.order();
	              rangePlots.exit().remove();
	              var mainplotinfo;
	              rangePlots.each(function(id, i) {
	                var plotgroup = d3.select(this);
	                var isMainPlot = i === 0;
	                var oppAxisOpts = axisIDs.getFromId(gd, id, "y");
	                var oppAxisName = oppAxisOpts._name;
	                var oppAxisRangeOpts = opts[oppAxisName];
	                var mockFigure = {
	                  data: [],
	                  layout: {
	                    xaxis: {
	                      type: axisOpts.type,
	                      domain: [0, 1],
	                      range: opts.range.slice(),
	                      calendar: axisOpts.calendar
	                    },
	                    width: opts._width,
	                    height: opts._height,
	                    margin: {
	                      t: 0,
	                      b: 0,
	                      l: 0,
	                      r: 0
	                    }
	                  },
	                  _context: gd._context
	                };
	                if (axisOpts.rangebreaks) {
	                  mockFigure.layout.xaxis.rangebreaks = axisOpts.rangebreaks;
	                }
	                mockFigure.layout[oppAxisName] = {
	                  type: oppAxisOpts.type,
	                  domain: [0, 1],
	                  range: oppAxisRangeOpts.rangemode !== "match" ? oppAxisRangeOpts.range.slice() : oppAxisOpts.range.slice(),
	                  calendar: oppAxisOpts.calendar
	                };
	                if (oppAxisOpts.rangebreaks) {
	                  mockFigure.layout[oppAxisName].rangebreaks = oppAxisOpts.rangebreaks;
	                }
	                Plots.supplyDefaults(mockFigure);
	                var xa = mockFigure._fullLayout.xaxis;
	                var ya = mockFigure._fullLayout[oppAxisName];
	                xa.clearCalc();
	                xa.setScale();
	                ya.clearCalc();
	                ya.setScale();
	                var plotinfo = {
	                  id,
	                  plotgroup,
	                  xaxis: xa,
	                  yaxis: ya,
	                  isRangePlot: true
	                };
	                if (isMainPlot) mainplotinfo = plotinfo;
	                else {
	                  plotinfo.mainplot = "xy";
	                  plotinfo.mainplotinfo = mainplotinfo;
	                }
	                Cartesian.rangePlot(gd, plotinfo, filterRangePlotCalcData(calcData, id));
	              });
	            }
	            function filterRangePlotCalcData(calcData, subplotId) {
	              var out = [];
	              for (var i = 0; i < calcData.length; i++) {
	                var calcTrace = calcData[i];
	                var trace = calcTrace[0].trace;
	                if (trace.xaxis + trace.yaxis === subplotId) {
	                  out.push(calcTrace);
	                }
	              }
	              return out;
	            }
	            function drawMasks(rangeSlider, gd, axisOpts, opts, oppAxisRangeOpts) {
	              var maskMin = Lib.ensureSingle(rangeSlider, "rect", constants.maskMinClassName, function(s) {
	                s.attr({
	                  x: 0,
	                  y: 0,
	                  "shape-rendering": "crispEdges"
	                });
	              });
	              maskMin.attr("height", opts._height).call(Color.fill, constants.maskColor);
	              var maskMax = Lib.ensureSingle(rangeSlider, "rect", constants.maskMaxClassName, function(s) {
	                s.attr({
	                  y: 0,
	                  "shape-rendering": "crispEdges"
	                });
	              });
	              maskMax.attr("height", opts._height).call(Color.fill, constants.maskColor);
	              if (oppAxisRangeOpts.rangemode !== "match") {
	                var maskMinOppAxis = Lib.ensureSingle(rangeSlider, "rect", constants.maskMinOppAxisClassName, function(s) {
	                  s.attr({
	                    y: 0,
	                    "shape-rendering": "crispEdges"
	                  });
	                });
	                maskMinOppAxis.attr("width", opts._width).call(Color.fill, constants.maskOppAxisColor);
	                var maskMaxOppAxis = Lib.ensureSingle(rangeSlider, "rect", constants.maskMaxOppAxisClassName, function(s) {
	                  s.attr({
	                    y: 0,
	                    "shape-rendering": "crispEdges"
	                  });
	                });
	                maskMaxOppAxis.attr("width", opts._width).style("border-top", constants.maskOppBorder).call(Color.fill, constants.maskOppAxisColor);
	              }
	            }
	            function drawSlideBox(rangeSlider, gd, axisOpts, opts) {
	              if (gd._context.staticPlot) return;
	              var slideBox = Lib.ensureSingle(rangeSlider, "rect", constants.slideBoxClassName, function(s) {
	                s.attr({
	                  y: 0,
	                  cursor: constants.slideBoxCursor,
	                  "shape-rendering": "crispEdges"
	                });
	              });
	              slideBox.attr({
	                height: opts._height,
	                fill: constants.slideBoxFill
	              });
	            }
	            function drawGrabbers(rangeSlider, gd, axisOpts, opts) {
	              var grabberMin = Lib.ensureSingle(rangeSlider, "g", constants.grabberMinClassName);
	              var grabberMax = Lib.ensureSingle(rangeSlider, "g", constants.grabberMaxClassName);
	              var handleFixAttrs = {
	                x: 0,
	                width: constants.handleWidth,
	                rx: constants.handleRadius,
	                fill: Color.background,
	                stroke: Color.defaultLine,
	                "stroke-width": constants.handleStrokeWidth,
	                "shape-rendering": "crispEdges"
	              };
	              var handleDynamicAttrs = {
	                y: Math.round(opts._height / 4),
	                height: Math.round(opts._height / 2)
	              };
	              var handleMin = Lib.ensureSingle(grabberMin, "rect", constants.handleMinClassName, function(s) {
	                s.attr(handleFixAttrs);
	              });
	              handleMin.attr(handleDynamicAttrs);
	              var handleMax = Lib.ensureSingle(grabberMax, "rect", constants.handleMaxClassName, function(s) {
	                s.attr(handleFixAttrs);
	              });
	              handleMax.attr(handleDynamicAttrs);
	              var grabAreaFixAttrs = {
	                width: constants.grabAreaWidth,
	                x: 0,
	                y: 0,
	                fill: constants.grabAreaFill,
	                cursor: !gd._context.staticPlot ? constants.grabAreaCursor : undefined
	              };
	              var grabAreaMin = Lib.ensureSingle(grabberMin, "rect", constants.grabAreaMinClassName, function(s) {
	                s.attr(grabAreaFixAttrs);
	              });
	              grabAreaMin.attr("height", opts._height);
	              var grabAreaMax = Lib.ensureSingle(grabberMax, "rect", constants.grabAreaMaxClassName, function(s) {
	                s.attr(grabAreaFixAttrs);
	              });
	              grabAreaMax.attr("height", opts._height);
	            }
	          }
	        ),
	        /***/
	        549: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var axisIDs = __webpack_require__2(41675);
	            var svgTextUtils = __webpack_require__2(63893);
	            var constants = __webpack_require__2(73251);
	            var LINE_SPACING = __webpack_require__2(18783).LINE_SPACING;
	            var name2 = constants.name;
	            function isVisible(ax) {
	              var rangeSlider = ax && ax[name2];
	              return rangeSlider && rangeSlider.visible;
	            }
	            exports2.isVisible = isVisible;
	            exports2.makeData = function(fullLayout) {
	              var axes = axisIDs.list({
	                _fullLayout: fullLayout
	              }, "x", true);
	              var margin = fullLayout.margin;
	              var rangeSliderData = [];
	              if (!fullLayout._has("gl2d")) {
	                for (var i = 0; i < axes.length; i++) {
	                  var ax = axes[i];
	                  if (isVisible(ax)) {
	                    rangeSliderData.push(ax);
	                    var opts = ax[name2];
	                    opts._id = name2 + ax._id;
	                    opts._height = (fullLayout.height - margin.b - margin.t) * opts.thickness;
	                    opts._offsetShift = Math.floor(opts.borderwidth / 2);
	                  }
	                }
	              }
	              fullLayout._rangeSliderData = rangeSliderData;
	            };
	            exports2.autoMarginOpts = function(gd, ax) {
	              var fullLayout = gd._fullLayout;
	              var opts = ax[name2];
	              var axLetter = ax._id.charAt(0);
	              var bottomDepth = 0;
	              var titleHeight = 0;
	              if (ax.side === "bottom") {
	                bottomDepth = ax._depth;
	                if (ax.title.text !== fullLayout._dfltTitle[axLetter]) {
	                  titleHeight = 1.5 * ax.title.font.size + 10 + opts._offsetShift;
	                  var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
	                  titleHeight += extraLines * ax.title.font.size * LINE_SPACING;
	                }
	              }
	              return {
	                x: 0,
	                y: ax._counterDomainMin,
	                l: 0,
	                r: 0,
	                t: 0,
	                b: opts._height + bottomDepth + Math.max(fullLayout.margin.b, titleHeight),
	                pad: constants.extraPad + opts._offsetShift * 2
	              };
	            };
	          }
	        ),
	        /***/
	        13137: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attrs = __webpack_require__2(75148);
	            var oppAxisAttrs = __webpack_require__2(47850);
	            var helpers = __webpack_require__2(549);
	            module2.exports = {
	              moduleType: "component",
	              name: "rangeslider",
	              schema: {
	                subplots: {
	                  xaxis: {
	                    rangeslider: Lib.extendFlat({}, attrs, {
	                      yaxis: oppAxisAttrs
	                    })
	                  }
	                }
	              },
	              layoutAttributes: __webpack_require__2(75148),
	              handleDefaults: __webpack_require__2(26377),
	              calcAutorange: __webpack_require__2(88443),
	              draw: __webpack_require__2(72413),
	              isVisible: helpers.isVisible,
	              makeData: helpers.makeData,
	              autoMarginOpts: helpers.autoMarginOpts
	            };
	          }
	        ),
	        /***/
	        47850: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // not really a 'subplot' attribute container,
	              // but this is the flag we use to denote attributes that
	              // support yaxis, yaxis2, yaxis3, ... counters
	              _isSubplotObj: true,
	              rangemode: {
	                valType: "enumerated",
	                values: ["auto", "fixed", "match"],
	                dflt: "match",
	                editType: "calc"
	              },
	              range: {
	                valType: "info_array",
	                items: [{
	                  valType: "any",
	                  editType: "plot"
	                }, {
	                  valType: "any",
	                  editType: "plot"
	                }],
	                editType: "plot"
	              },
	              editType: "calc"
	            };
	          }
	        ),
	        /***/
	        8389: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var annAttrs = __webpack_require__2(50215);
	            var scatterLineAttrs = __webpack_require__2(82196).line;
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            __webpack_require__2(24695);
	            module2.exports = overrideAll(templatedArray("selection", {
	              type: {
	                valType: "enumerated",
	                values: ["rect", "path"]
	              },
	              xref: extendFlat({}, annAttrs.xref, {}),
	              yref: extendFlat({}, annAttrs.yref, {}),
	              x0: {
	                valType: "any"
	              },
	              x1: {
	                valType: "any"
	              },
	              y0: {
	                valType: "any"
	              },
	              y1: {
	                valType: "any"
	              },
	              path: {
	                valType: "string",
	                editType: "arraydraw"
	              },
	              opacity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0.7,
	                editType: "arraydraw"
	              },
	              line: {
	                color: scatterLineAttrs.color,
	                width: extendFlat({}, scatterLineAttrs.width, {
	                  min: 1,
	                  dflt: 1
	                }),
	                dash: extendFlat({}, dash, {
	                  dflt: "dot"
	                })
	              }
	            }), "arraydraw", "from-root");
	          }
	        ),
	        /***/
	        34122: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // max pixels off straight before a lasso select line counts as bent
	              BENDPX: 1.5,
	              // smallest dimension allowed for a select box
	              MINSELECT: 12,
	              // throttling limit (ms) for selectPoints calls
	              SELECTDELAY: 100,
	              // cache ID suffix for throttle
	              SELECTID: "-select"
	            };
	          }
	        ),
	        /***/
	        59402: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(8389);
	            var helpers = __webpack_require__2(30477);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              handleArrayContainerDefaults(layoutIn, layoutOut, {
	                name: "selections",
	                handleItemDefaults: handleSelectionDefaults
	              });
	              var selections = layoutOut.selections;
	              for (var i = 0; i < selections.length; i++) {
	                var selection = selections[i];
	                if (!selection) continue;
	                if (selection.path === undefined) {
	                  if (selection.x0 === undefined || selection.x1 === undefined || selection.y0 === undefined || selection.y1 === undefined) {
	                    layoutOut.selections[i] = null;
	                  }
	                }
	              }
	            };
	            function handleSelectionDefaults(selectionIn, selectionOut, fullLayout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(selectionIn, selectionOut, attributes, attr, dflt);
	              }
	              var path = coerce("path");
	              var dfltType = path ? "path" : "rect";
	              var selectionType = coerce("type", dfltType);
	              var noPath = selectionType !== "path";
	              if (noPath) delete selectionOut.path;
	              coerce("opacity");
	              coerce("line.color");
	              coerce("line.width");
	              coerce("line.dash");
	              var axLetters = ["x", "y"];
	              for (var i = 0; i < 2; i++) {
	                var axLetter = axLetters[i];
	                var gdMock = {
	                  _fullLayout: fullLayout
	                };
	                var ax;
	                var pos2r;
	                var r2pos;
	                var axRef = Axes.coerceRef(selectionIn, selectionOut, gdMock, axLetter);
	                ax = Axes.getFromId(gdMock, axRef);
	                ax._selectionIndices.push(selectionOut._index);
	                r2pos = helpers.rangeToShapePosition(ax);
	                pos2r = helpers.shapePositionToRange(ax);
	                if (noPath) {
	                  var attr0 = axLetter + "0";
	                  var attr1 = axLetter + "1";
	                  var in0 = selectionIn[attr0];
	                  var in1 = selectionIn[attr1];
	                  selectionIn[attr0] = pos2r(selectionIn[attr0], true);
	                  selectionIn[attr1] = pos2r(selectionIn[attr1], true);
	                  Axes.coercePosition(selectionOut, gdMock, coerce, axRef, attr0);
	                  Axes.coercePosition(selectionOut, gdMock, coerce, axRef, attr1);
	                  var p0 = selectionOut[attr0];
	                  var p1 = selectionOut[attr1];
	                  if (p0 !== undefined && p1 !== undefined) {
	                    selectionOut[attr0] = r2pos(p0);
	                    selectionOut[attr1] = r2pos(p1);
	                    selectionIn[attr0] = in0;
	                    selectionIn[attr1] = in1;
	                  }
	                }
	              }
	              if (noPath) {
	                Lib.noneOrAll(selectionIn, selectionOut, ["x0", "x1", "y0", "y1"]);
	              }
	            }
	          }
	        ),
	        /***/
	        32485: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var readPaths = __webpack_require__2(60165).readPaths;
	            var displayOutlines = __webpack_require__2(42359);
	            var clearOutlineControllers = __webpack_require__2(51873).clearOutlineControllers;
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var arrayEditor = __webpack_require__2(44467).arrayEditor;
	            var helpers = __webpack_require__2(30477);
	            var getPathString = helpers.getPathString;
	            module2.exports = {
	              draw,
	              drawOne,
	              activateLastSelection
	            };
	            function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              clearOutlineControllers(gd);
	              fullLayout._selectionLayer.selectAll("path").remove();
	              for (var k in fullLayout._plots) {
	                var selectionLayer = fullLayout._plots[k].selectionLayer;
	                if (selectionLayer) selectionLayer.selectAll("path").remove();
	              }
	              for (var i = 0; i < fullLayout.selections.length; i++) {
	                drawOne(gd, i);
	              }
	            }
	            function couldHaveActiveSelection(gd) {
	              return gd._context.editSelection;
	            }
	            function drawOne(gd, index) {
	              gd._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + index + '"]').remove();
	              var o = helpers.makeSelectionsOptionsAndPlotinfo(gd, index);
	              var options = o.options;
	              var plotinfo = o.plotinfo;
	              if (!options._input) return;
	              drawSelection(gd._fullLayout._selectionLayer);
	              function drawSelection(selectionLayer) {
	                var d = getPathString(gd, options);
	                var attrs = {
	                  "data-index": index,
	                  "fill-rule": "evenodd",
	                  d
	                };
	                var opacity = options.opacity;
	                var fillColor = "rgba(0,0,0,0)";
	                var lineColor = options.line.color || Color.contrast(gd._fullLayout.plot_bgcolor);
	                var lineWidth = options.line.width;
	                var lineDash = options.line.dash;
	                if (!lineWidth) {
	                  lineWidth = 5;
	                  lineDash = "solid";
	                }
	                var isActiveSelection = couldHaveActiveSelection(gd) && gd._fullLayout._activeSelectionIndex === index;
	                if (isActiveSelection) {
	                  fillColor = gd._fullLayout.activeselection.fillcolor;
	                  opacity = gd._fullLayout.activeselection.opacity;
	                }
	                var allPaths = [];
	                for (var sensory = 1; sensory >= 0; sensory--) {
	                  var path = selectionLayer.append("path").attr(attrs).style("opacity", sensory ? 0.1 : opacity).call(Color.stroke, lineColor).call(Color.fill, fillColor).call(Drawing.dashLine, sensory ? "solid" : lineDash, sensory ? 4 + lineWidth : lineWidth);
	                  setClipPath(path, gd, options);
	                  if (isActiveSelection) {
	                    var editHelpers = arrayEditor(gd.layout, "selections", options);
	                    path.style({
	                      cursor: "move"
	                    });
	                    var dragOptions = {
	                      element: path.node(),
	                      plotinfo,
	                      gd,
	                      editHelpers,
	                      isActiveSelection: true
	                      // i.e. to enable controllers
	                    };
	                    var polygons = readPaths(d, gd);
	                    displayOutlines(polygons, path, dragOptions);
	                  } else {
	                    path.style("pointer-events", sensory ? "all" : "none");
	                  }
	                  allPaths[sensory] = path;
	                }
	                var forePath = allPaths[0];
	                var backPath = allPaths[1];
	                backPath.node().addEventListener("click", function() {
	                  return activateSelection(gd, forePath);
	                });
	              }
	            }
	            function setClipPath(selectionPath, gd, selectionOptions) {
	              var clipAxes = selectionOptions.xref + selectionOptions.yref;
	              Drawing.setClipUrl(selectionPath, "clip" + gd._fullLayout._uid + clipAxes, gd);
	            }
	            function activateSelection(gd, path) {
	              if (!couldHaveActiveSelection(gd)) return;
	              var element = path.node();
	              var id = +element.getAttribute("data-index");
	              if (id >= 0) {
	                if (id === gd._fullLayout._activeSelectionIndex) {
	                  deactivateSelection(gd);
	                  return;
	                }
	                gd._fullLayout._activeSelectionIndex = id;
	                gd._fullLayout._deactivateSelection = deactivateSelection;
	                draw(gd);
	              }
	            }
	            function activateLastSelection(gd) {
	              if (!couldHaveActiveSelection(gd)) return;
	              var id = gd._fullLayout.selections.length - 1;
	              gd._fullLayout._activeSelectionIndex = id;
	              gd._fullLayout._deactivateSelection = deactivateSelection;
	              draw(gd);
	            }
	            function deactivateSelection(gd) {
	              if (!couldHaveActiveSelection(gd)) return;
	              var id = gd._fullLayout._activeSelectionIndex;
	              if (id >= 0) {
	                clearOutlineControllers(gd);
	                delete gd._fullLayout._activeSelectionIndex;
	                draw(gd);
	              }
	            }
	          }
	        ),
	        /***/
	        53777: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = {
	              newselection: {
	                mode: {
	                  valType: "enumerated",
	                  values: ["immediate", "gradual"],
	                  dflt: "immediate",
	                  editType: "none"
	                },
	                line: {
	                  color: {
	                    valType: "color",
	                    editType: "none"
	                  },
	                  width: {
	                    valType: "number",
	                    min: 1,
	                    dflt: 1,
	                    editType: "none"
	                  },
	                  dash: extendFlat({}, dash, {
	                    dflt: "dot",
	                    editType: "none"
	                  }),
	                  editType: "none"
	                },
	                // no drawdirection here noting that layout.selectdirection is used instead.
	                editType: "none"
	              },
	              activeselection: {
	                fillcolor: {
	                  valType: "color",
	                  dflt: "rgba(0,0,0,0)",
	                  editType: "none"
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.5,
	                  editType: "none"
	                },
	                editType: "none"
	              }
	            };
	          }
	        ),
	        /***/
	        90849: (
	          /***/
	          function(module2) {
	            module2.exports = function supplyDrawNewSelectionDefaults(layoutIn, layoutOut, coerce) {
	              coerce("newselection.mode");
	              var newselectionLineWidth = coerce("newselection.line.width");
	              if (newselectionLineWidth) {
	                coerce("newselection.line.color");
	                coerce("newselection.line.dash");
	              }
	              coerce("activeselection.fillcolor");
	              coerce("activeselection.opacity");
	            };
	          }
	        ),
	        /***/
	        35855: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dragHelpers = __webpack_require__2(64505);
	            var selectMode = dragHelpers.selectMode;
	            var handleOutline = __webpack_require__2(51873);
	            var clearOutline = handleOutline.clearOutline;
	            var helpers = __webpack_require__2(60165);
	            var readPaths = helpers.readPaths;
	            var writePaths = helpers.writePaths;
	            var fixDatesForPaths = helpers.fixDatesForPaths;
	            module2.exports = function newSelections(outlines, dragOptions) {
	              if (!outlines.length) return;
	              var e = outlines[0][0];
	              if (!e) return;
	              var d = e.getAttribute("d");
	              var gd = dragOptions.gd;
	              var newStyle = gd._fullLayout.newselection;
	              var plotinfo = dragOptions.plotinfo;
	              var xaxis = plotinfo.xaxis;
	              var yaxis = plotinfo.yaxis;
	              var isActiveSelection = dragOptions.isActiveSelection;
	              var dragmode = dragOptions.dragmode;
	              var selections = (gd.layout || {}).selections || [];
	              if (!selectMode(dragmode) && isActiveSelection !== undefined) {
	                var id = gd._fullLayout._activeSelectionIndex;
	                if (id < selections.length) {
	                  switch (gd._fullLayout.selections[id].type) {
	                    case "rect":
	                      dragmode = "select";
	                      break;
	                    case "path":
	                      dragmode = "lasso";
	                      break;
	                  }
	                }
	              }
	              var polygons = readPaths(d, gd, plotinfo, isActiveSelection);
	              var newSelection = {
	                xref: xaxis._id,
	                yref: yaxis._id,
	                opacity: newStyle.opacity,
	                line: {
	                  color: newStyle.line.color,
	                  width: newStyle.line.width,
	                  dash: newStyle.line.dash
	                }
	              };
	              var cell;
	              if (polygons.length === 1) cell = polygons[0];
	              if (cell && cell.length === 5 && // ensure we only have 4 corners for a rect
	              dragmode === "select") {
	                newSelection.type = "rect";
	                newSelection.x0 = cell[0][1];
	                newSelection.y0 = cell[0][2];
	                newSelection.x1 = cell[2][1];
	                newSelection.y1 = cell[2][2];
	              } else {
	                newSelection.type = "path";
	                if (xaxis && yaxis) fixDatesForPaths(polygons, xaxis, yaxis);
	                newSelection.path = writePaths(polygons);
	                cell = null;
	              }
	              clearOutline(gd);
	              var editHelpers = dragOptions.editHelpers;
	              var modifyItem = (editHelpers || {}).modifyItem;
	              var allSelections = [];
	              for (var q = 0; q < selections.length; q++) {
	                var beforeEdit = gd._fullLayout.selections[q];
	                if (!beforeEdit) {
	                  allSelections[q] = beforeEdit;
	                  continue;
	                }
	                allSelections[q] = beforeEdit._input;
	                if (isActiveSelection !== undefined && q === gd._fullLayout._activeSelectionIndex) {
	                  var afterEdit = newSelection;
	                  switch (beforeEdit.type) {
	                    case "rect":
	                      modifyItem("x0", afterEdit.x0);
	                      modifyItem("x1", afterEdit.x1);
	                      modifyItem("y0", afterEdit.y0);
	                      modifyItem("y1", afterEdit.y1);
	                      break;
	                    case "path":
	                      modifyItem("path", afterEdit.path);
	                      break;
	                  }
	                }
	              }
	              if (isActiveSelection === undefined) {
	                allSelections.push(newSelection);
	                return allSelections;
	              }
	              return editHelpers ? editHelpers.getUpdateObj() : {};
	            };
	          }
	        ),
	        /***/
	        75549: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var strTranslate = __webpack_require__2(71828).strTranslate;
	            function p2r(ax, v) {
	              switch (ax.type) {
	                case "log":
	                  return ax.p2d(v);
	                case "date":
	                  return ax.p2r(v, 0, ax.calendar);
	                default:
	                  return ax.p2r(v);
	              }
	            }
	            function r2p(ax, v) {
	              switch (ax.type) {
	                case "log":
	                  return ax.d2p(v);
	                case "date":
	                  return ax.r2p(v, 0, ax.calendar);
	                default:
	                  return ax.r2p(v);
	              }
	            }
	            function axValue(ax) {
	              var index = ax._id.charAt(0) === "y" ? 1 : 0;
	              return function(v) {
	                return p2r(ax, v[index]);
	              };
	            }
	            function getTransform(plotinfo) {
	              return strTranslate(plotinfo.xaxis._offset, plotinfo.yaxis._offset);
	            }
	            module2.exports = {
	              p2r,
	              r2p,
	              axValue,
	              getTransform
	            };
	          }
	        ),
	        /***/
	        47322: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var drawModule = __webpack_require__2(32485);
	            var select = __webpack_require__2(3937);
	            module2.exports = {
	              moduleType: "component",
	              name: "selections",
	              layoutAttributes: __webpack_require__2(8389),
	              supplyLayoutDefaults: __webpack_require__2(59402),
	              supplyDrawNewSelectionDefaults: __webpack_require__2(90849),
	              includeBasePlot: __webpack_require__2(76325)("selections"),
	              draw: drawModule.draw,
	              drawOne: drawModule.drawOne,
	              reselect: select.reselect,
	              prepSelect: select.prepSelect,
	              clearOutline: select.clearOutline,
	              clearSelectionsCache: select.clearSelectionsCache,
	              selectOnClick: select.selectOnClick
	            };
	          }
	        ),
	        /***/
	        3937: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var polybool = __webpack_require__2(52142);
	            var pointInPolygon = __webpack_require__2(38258);
	            var Registry = __webpack_require__2(73972);
	            var dashStyle = __webpack_require__2(91424).dashStyle;
	            var Color = __webpack_require__2(7901);
	            var Fx = __webpack_require__2(30211);
	            var makeEventData = __webpack_require__2(23469).makeEventData;
	            var dragHelpers = __webpack_require__2(64505);
	            var freeMode = dragHelpers.freeMode;
	            var rectMode = dragHelpers.rectMode;
	            var drawMode = dragHelpers.drawMode;
	            var openMode = dragHelpers.openMode;
	            var selectMode = dragHelpers.selectMode;
	            var shapeHelpers = __webpack_require__2(30477);
	            var shapeConstants = __webpack_require__2(21459);
	            var displayOutlines = __webpack_require__2(42359);
	            var clearOutline = __webpack_require__2(51873).clearOutline;
	            var newShapeHelpers = __webpack_require__2(60165);
	            var handleEllipse = newShapeHelpers.handleEllipse;
	            var readPaths = newShapeHelpers.readPaths;
	            var newShapes = __webpack_require__2(90551).newShapes;
	            var newSelections = __webpack_require__2(35855);
	            var activateLastSelection = __webpack_require__2(32485).activateLastSelection;
	            var Lib = __webpack_require__2(71828);
	            var ascending2 = Lib.sorterAsc;
	            var libPolygon = __webpack_require__2(61082);
	            var throttle = __webpack_require__2(79990);
	            var getFromId = __webpack_require__2(41675).getFromId;
	            var clearGlCanvases = __webpack_require__2(33306);
	            var redrawReglTraces = __webpack_require__2(61549).redrawReglTraces;
	            var constants = __webpack_require__2(34122);
	            var MINSELECT = constants.MINSELECT;
	            var filteredPolygon = libPolygon.filter;
	            var polygonTester = libPolygon.tester;
	            var helpers = __webpack_require__2(75549);
	            var p2r = helpers.p2r;
	            var axValue = helpers.axValue;
	            var getTransform = helpers.getTransform;
	            function hasSubplot(dragOptions) {
	              return dragOptions.subplot !== undefined;
	            }
	            function prepSelect(evt, startX, startY, dragOptions, mode) {
	              var isCartesian = !hasSubplot(dragOptions);
	              var isFreeMode = freeMode(mode);
	              var isRectMode = rectMode(mode);
	              var isOpenMode = openMode(mode);
	              var isDrawMode = drawMode(mode);
	              var isSelectMode = selectMode(mode);
	              var isLine = mode === "drawline";
	              var isEllipse = mode === "drawcircle";
	              var isLineOrEllipse = isLine || isEllipse;
	              var gd = dragOptions.gd;
	              var fullLayout = gd._fullLayout;
	              var immediateSelect = isSelectMode && fullLayout.newselection.mode === "immediate" && isCartesian;
	              var zoomLayer = fullLayout._zoomlayer;
	              var dragBBox = dragOptions.element.getBoundingClientRect();
	              var plotinfo = dragOptions.plotinfo;
	              var transform = getTransform(plotinfo);
	              var x0 = startX - dragBBox.left;
	              var y0 = startY - dragBBox.top;
	              fullLayout._calcInverseTransform(gd);
	              var transformedCoords = Lib.apply3DTransform(fullLayout._invTransform)(x0, y0);
	              x0 = transformedCoords[0];
	              y0 = transformedCoords[1];
	              var scaleX = fullLayout._invScaleX;
	              var scaleY = fullLayout._invScaleY;
	              var x1 = x0;
	              var y1 = y0;
	              var path0 = "M" + x0 + "," + y0;
	              var xAxis = dragOptions.xaxes[0];
	              var yAxis = dragOptions.yaxes[0];
	              var pw = xAxis._length;
	              var ph = yAxis._length;
	              var subtract = evt.altKey && !(drawMode(mode) && isOpenMode);
	              var filterPoly, selectionTesters, mergedPolygons, currentPolygon;
	              var i, searchInfo, eventData;
	              coerceSelectionsCache(evt, gd, dragOptions);
	              if (isFreeMode) {
	                filterPoly = filteredPolygon([[x0, y0]], constants.BENDPX);
	              }
	              var outlines = zoomLayer.selectAll("path.select-outline-" + plotinfo.id).data([1]);
	              var newStyle = isDrawMode ? fullLayout.newshape : fullLayout.newselection;
	              if (isDrawMode) {
	                dragOptions.hasText = newStyle.label.text || newStyle.label.texttemplate;
	              }
	              var fillC = isDrawMode && !isOpenMode ? newStyle.fillcolor : "rgba(0,0,0,0)";
	              var strokeC = newStyle.line.color || (isCartesian ? Color.contrast(gd._fullLayout.plot_bgcolor) : "#7f7f7f");
	              outlines.enter().append("path").attr("class", "select-outline select-outline-" + plotinfo.id).style({
	                opacity: isDrawMode ? newStyle.opacity / 2 : 1,
	                "stroke-dasharray": dashStyle(newStyle.line.dash, newStyle.line.width),
	                "stroke-width": newStyle.line.width + "px",
	                "shape-rendering": "crispEdges"
	              }).call(Color.stroke, strokeC).call(Color.fill, fillC).attr("fill-rule", "evenodd").classed("cursor-move", isDrawMode ? true : false).attr("transform", transform).attr("d", path0 + "Z");
	              var corners = zoomLayer.append("path").attr("class", "zoombox-corners").style({
	                fill: Color.background,
	                stroke: Color.defaultLine,
	                "stroke-width": 1
	              }).attr("transform", transform).attr("d", "M0,0Z");
	              if (isDrawMode && dragOptions.hasText) {
	                var shapeGroup = zoomLayer.select(".label-temp");
	                if (shapeGroup.empty()) {
	                  shapeGroup = zoomLayer.append("g").classed("label-temp", true).classed("select-outline", true).style({
	                    opacity: 0.8
	                  });
	                }
	              }
	              var throttleID = fullLayout._uid + constants.SELECTID;
	              var selection = [];
	              var searchTraces = determineSearchTraces(gd, dragOptions.xaxes, dragOptions.yaxes, dragOptions.subplot);
	              if (immediateSelect && !evt.shiftKey) {
	                dragOptions._clearSubplotSelections = function() {
	                  if (!isCartesian) return;
	                  var xRef = xAxis._id;
	                  var yRef = yAxis._id;
	                  deselectSubplot(gd, xRef, yRef, searchTraces);
	                  var selections = (gd.layout || {}).selections || [];
	                  var list = [];
	                  var selectionErased = false;
	                  for (var q = 0; q < selections.length; q++) {
	                    var s = fullLayout.selections[q];
	                    if (s.xref !== xRef || s.yref !== yRef) {
	                      list.push(selections[q]);
	                    } else {
	                      selectionErased = true;
	                    }
	                  }
	                  if (selectionErased) {
	                    gd._fullLayout._noEmitSelectedAtStart = true;
	                    Registry.call("_guiRelayout", gd, {
	                      selections: list
	                    });
	                  }
	                };
	              }
	              var fillRangeItems = getFillRangeItems(dragOptions);
	              dragOptions.moveFn = function(dx0, dy0) {
	                if (dragOptions._clearSubplotSelections) {
	                  dragOptions._clearSubplotSelections();
	                  dragOptions._clearSubplotSelections = undefined;
	                }
	                x1 = Math.max(0, Math.min(pw, scaleX * dx0 + x0));
	                y1 = Math.max(0, Math.min(ph, scaleY * dy0 + y0));
	                var dx = Math.abs(x1 - x0);
	                var dy = Math.abs(y1 - y0);
	                if (isRectMode) {
	                  var direction;
	                  var start, end;
	                  if (isSelectMode) {
	                    var q = fullLayout.selectdirection;
	                    if (q === "any") {
	                      if (dy < Math.min(dx * 0.6, MINSELECT)) {
	                        direction = "h";
	                      } else if (dx < Math.min(dy * 0.6, MINSELECT)) {
	                        direction = "v";
	                      } else {
	                        direction = "d";
	                      }
	                    } else {
	                      direction = q;
	                    }
	                    switch (direction) {
	                      case "h":
	                        start = isEllipse ? ph / 2 : 0;
	                        end = ph;
	                        break;
	                      case "v":
	                        start = isEllipse ? pw / 2 : 0;
	                        end = pw;
	                        break;
	                    }
	                  }
	                  if (isDrawMode) {
	                    switch (fullLayout.newshape.drawdirection) {
	                      case "vertical":
	                        direction = "h";
	                        start = isEllipse ? ph / 2 : 0;
	                        end = ph;
	                        break;
	                      case "horizontal":
	                        direction = "v";
	                        start = isEllipse ? pw / 2 : 0;
	                        end = pw;
	                        break;
	                      case "ortho":
	                        if (dx < dy) {
	                          direction = "h";
	                          start = y0;
	                          end = y1;
	                        } else {
	                          direction = "v";
	                          start = x0;
	                          end = x1;
	                        }
	                        break;
	                      default:
	                        direction = "d";
	                    }
	                  }
	                  if (direction === "h") {
	                    currentPolygon = isLineOrEllipse ? handleEllipse(isEllipse, [x1, start], [x1, end]) : (
	                      // using x1 instead of x0 allows adjusting the line while drawing
	                      [[x0, start], [x0, end], [x1, end], [x1, start]]
	                    );
	                    currentPolygon.xmin = isLineOrEllipse ? x1 : Math.min(x0, x1);
	                    currentPolygon.xmax = isLineOrEllipse ? x1 : Math.max(x0, x1);
	                    currentPolygon.ymin = Math.min(start, end);
	                    currentPolygon.ymax = Math.max(start, end);
	                    corners.attr("d", "M" + currentPolygon.xmin + "," + (y0 - MINSELECT) + "h-4v" + 2 * MINSELECT + "h4ZM" + (currentPolygon.xmax - 1) + "," + (y0 - MINSELECT) + "h4v" + 2 * MINSELECT + "h-4Z");
	                  } else if (direction === "v") {
	                    currentPolygon = isLineOrEllipse ? handleEllipse(isEllipse, [start, y1], [end, y1]) : (
	                      // using y1 instead of y0 allows adjusting the line while drawing
	                      [[start, y0], [start, y1], [end, y1], [end, y0]]
	                    );
	                    currentPolygon.xmin = Math.min(start, end);
	                    currentPolygon.xmax = Math.max(start, end);
	                    currentPolygon.ymin = isLineOrEllipse ? y1 : Math.min(y0, y1);
	                    currentPolygon.ymax = isLineOrEllipse ? y1 : Math.max(y0, y1);
	                    corners.attr("d", "M" + (x0 - MINSELECT) + "," + currentPolygon.ymin + "v-4h" + 2 * MINSELECT + "v4ZM" + (x0 - MINSELECT) + "," + (currentPolygon.ymax - 1) + "v4h" + 2 * MINSELECT + "v-4Z");
	                  } else if (direction === "d") {
	                    currentPolygon = isLineOrEllipse ? handleEllipse(isEllipse, [x0, y0], [x1, y1]) : [[x0, y0], [x0, y1], [x1, y1], [x1, y0]];
	                    currentPolygon.xmin = Math.min(x0, x1);
	                    currentPolygon.xmax = Math.max(x0, x1);
	                    currentPolygon.ymin = Math.min(y0, y1);
	                    currentPolygon.ymax = Math.max(y0, y1);
	                    corners.attr("d", "M0,0Z");
	                  }
	                } else if (isFreeMode) {
	                  filterPoly.addPt([x1, y1]);
	                  currentPolygon = filterPoly.filtered;
	                }
	                if (dragOptions.selectionDefs && dragOptions.selectionDefs.length) {
	                  mergedPolygons = mergePolygons(dragOptions.mergedPolygons, currentPolygon, subtract);
	                  currentPolygon.subtract = subtract;
	                  selectionTesters = multiTester(dragOptions.selectionDefs.concat([currentPolygon]));
	                } else {
	                  mergedPolygons = [currentPolygon];
	                  selectionTesters = polygonTester(currentPolygon);
	                }
	                displayOutlines(convertPoly(mergedPolygons, isOpenMode), outlines, dragOptions);
	                if (isSelectMode) {
	                  var _res = reselect(gd, false);
	                  var extraPoints = _res.eventData ? _res.eventData.points.slice() : [];
	                  _res = reselect(gd, false, selectionTesters, searchTraces, dragOptions);
	                  selectionTesters = _res.selectionTesters;
	                  eventData = _res.eventData;
	                  var poly;
	                  if (filterPoly) {
	                    poly = filterPoly.filtered;
	                  } else {
	                    poly = castMultiPolygon(mergedPolygons);
	                  }
	                  throttle.throttle(throttleID, constants.SELECTDELAY, function() {
	                    selection = _doSelect(selectionTesters, searchTraces);
	                    var newPoints = selection.slice();
	                    for (var w = 0; w < extraPoints.length; w++) {
	                      var p = extraPoints[w];
	                      var found = false;
	                      for (var u = 0; u < newPoints.length; u++) {
	                        if (newPoints[u].curveNumber === p.curveNumber && newPoints[u].pointNumber === p.pointNumber) {
	                          found = true;
	                          break;
	                        }
	                      }
	                      if (!found) newPoints.push(p);
	                    }
	                    if (newPoints.length) {
	                      if (!eventData) eventData = {};
	                      eventData.points = newPoints;
	                    }
	                    fillRangeItems(eventData, poly);
	                    emitSelecting(gd, eventData);
	                  });
	                }
	              };
	              dragOptions.clickFn = function(numClicks, evt2) {
	                corners.remove();
	                if (gd._fullLayout._activeShapeIndex >= 0) {
	                  gd._fullLayout._deactivateShape(gd);
	                  return;
	                }
	                if (isDrawMode) return;
	                var clickmode = fullLayout.clickmode;
	                throttle.done(throttleID).then(function() {
	                  throttle.clear(throttleID);
	                  if (numClicks === 2) {
	                    outlines.remove();
	                    for (i = 0; i < searchTraces.length; i++) {
	                      searchInfo = searchTraces[i];
	                      searchInfo._module.selectPoints(searchInfo, false);
	                    }
	                    updateSelectedState(gd, searchTraces);
	                    clearSelectionsCache(dragOptions);
	                    emitDeselect(gd);
	                    if (searchTraces.length) {
	                      var clickedXaxis = searchTraces[0].xaxis;
	                      var clickedYaxis = searchTraces[0].yaxis;
	                      if (clickedXaxis && clickedYaxis) {
	                        var subSelections = [];
	                        var allSelections = gd._fullLayout.selections;
	                        for (var k = 0; k < allSelections.length; k++) {
	                          var s = allSelections[k];
	                          if (!s) continue;
	                          if (s.xref !== clickedXaxis._id || s.yref !== clickedYaxis._id) {
	                            subSelections.push(s);
	                          }
	                        }
	                        if (subSelections.length < allSelections.length) {
	                          gd._fullLayout._noEmitSelectedAtStart = true;
	                          Registry.call("_guiRelayout", gd, {
	                            selections: subSelections
	                          });
	                        }
	                      }
	                    }
	                  } else {
	                    if (clickmode.indexOf("select") > -1) {
	                      selectOnClick(evt2, gd, dragOptions.xaxes, dragOptions.yaxes, dragOptions.subplot, dragOptions, outlines);
	                    }
	                    if (clickmode === "event") {
	                      emitSelected(gd, undefined);
	                    }
	                  }
	                  Fx.click(gd, evt2, plotinfo.id);
	                }).catch(Lib.error);
	              };
	              dragOptions.doneFn = function() {
	                corners.remove();
	                throttle.done(throttleID).then(function() {
	                  throttle.clear(throttleID);
	                  if (!immediateSelect && currentPolygon && dragOptions.selectionDefs) {
	                    currentPolygon.subtract = subtract;
	                    dragOptions.selectionDefs.push(currentPolygon);
	                    dragOptions.mergedPolygons.length = 0;
	                    [].push.apply(dragOptions.mergedPolygons, mergedPolygons);
	                  }
	                  if (immediateSelect || isDrawMode) {
	                    clearSelectionsCache(dragOptions, immediateSelect);
	                  }
	                  if (dragOptions.doneFnCompleted) {
	                    dragOptions.doneFnCompleted(selection);
	                  }
	                  if (isSelectMode) {
	                    emitSelected(gd, eventData);
	                  }
	                }).catch(Lib.error);
	              };
	            }
	            function selectOnClick(evt, gd, xAxes, yAxes, subplot, dragOptions, polygonOutlines) {
	              var hoverData = gd._hoverdata;
	              var fullLayout = gd._fullLayout;
	              var clickmode = fullLayout.clickmode;
	              var sendEvents = clickmode.indexOf("event") > -1;
	              var selection = [];
	              var searchTraces, searchInfo, currentSelectionDef, selectionTesters, traceSelection;
	              var thisTracesSelection, pointOrBinSelected, subtract, eventData, i;
	              if (isHoverDataSet(hoverData)) {
	                coerceSelectionsCache(evt, gd, dragOptions);
	                searchTraces = determineSearchTraces(gd, xAxes, yAxes, subplot);
	                var clickedPtInfo = extractClickedPtInfo(hoverData, searchTraces);
	                var isBinnedTrace = clickedPtInfo.pointNumbers.length > 0;
	                if (isBinnedTrace ? isOnlyThisBinSelected(searchTraces, clickedPtInfo) : isOnlyOnePointSelected(searchTraces) && (pointOrBinSelected = isPointOrBinSelected(clickedPtInfo))) {
	                  if (polygonOutlines) polygonOutlines.remove();
	                  for (i = 0; i < searchTraces.length; i++) {
	                    searchInfo = searchTraces[i];
	                    searchInfo._module.selectPoints(searchInfo, false);
	                  }
	                  updateSelectedState(gd, searchTraces);
	                  clearSelectionsCache(dragOptions);
	                  if (sendEvents) {
	                    emitDeselect(gd);
	                  }
	                } else {
	                  subtract = evt.shiftKey && (pointOrBinSelected !== undefined ? pointOrBinSelected : isPointOrBinSelected(clickedPtInfo));
	                  currentSelectionDef = newPointSelectionDef(clickedPtInfo.pointNumber, clickedPtInfo.searchInfo, subtract);
	                  var allSelectionDefs = dragOptions.selectionDefs.concat([currentSelectionDef]);
	                  selectionTesters = multiTester(allSelectionDefs);
	                  for (i = 0; i < searchTraces.length; i++) {
	                    traceSelection = searchTraces[i]._module.selectPoints(searchTraces[i], selectionTesters);
	                    thisTracesSelection = fillSelectionItem(traceSelection, searchTraces[i]);
	                    if (selection.length) {
	                      for (var j = 0; j < thisTracesSelection.length; j++) {
	                        selection.push(thisTracesSelection[j]);
	                      }
	                    } else selection = thisTracesSelection;
	                  }
	                  eventData = {
	                    points: selection
	                  };
	                  updateSelectedState(gd, searchTraces, eventData);
	                  if (currentSelectionDef && dragOptions) {
	                    dragOptions.selectionDefs.push(currentSelectionDef);
	                  }
	                  if (polygonOutlines) {
	                    var polygons = dragOptions.mergedPolygons;
	                    var isOpenMode = openMode(dragOptions.dragmode);
	                    displayOutlines(convertPoly(polygons, isOpenMode), polygonOutlines, dragOptions);
	                  }
	                  if (sendEvents) {
	                    emitSelected(gd, eventData);
	                  }
	                }
	              }
	            }
	            function newPointSelectionDef(pointNumber, searchInfo, subtract) {
	              return {
	                pointNumber,
	                searchInfo,
	                subtract: !!subtract
	              };
	            }
	            function isPointSelectionDef(o) {
	              return "pointNumber" in o && "searchInfo" in o;
	            }
	            function newPointNumTester(pointSelectionDef) {
	              return {
	                xmin: 0,
	                xmax: 0,
	                ymin: 0,
	                ymax: 0,
	                pts: [],
	                contains: function(pt, omitFirstEdge, pointNumber, searchInfo) {
	                  var idxWantedTrace = pointSelectionDef.searchInfo.cd[0].trace._expandedIndex;
	                  var idxActualTrace = searchInfo.cd[0].trace._expandedIndex;
	                  return idxActualTrace === idxWantedTrace && pointNumber === pointSelectionDef.pointNumber;
	                },
	                isRect: false,
	                degenerate: false,
	                subtract: !!pointSelectionDef.subtract
	              };
	            }
	            function multiTester(list) {
	              if (!list.length) return;
	              var testers = [];
	              var xmin = isPointSelectionDef(list[0]) ? 0 : list[0][0][0];
	              var xmax = xmin;
	              var ymin = isPointSelectionDef(list[0]) ? 0 : list[0][0][1];
	              var ymax = ymin;
	              for (var i = 0; i < list.length; i++) {
	                if (isPointSelectionDef(list[i])) {
	                  testers.push(newPointNumTester(list[i]));
	                } else {
	                  var tester = polygonTester(list[i]);
	                  tester.subtract = !!list[i].subtract;
	                  testers.push(tester);
	                  xmin = Math.min(xmin, tester.xmin);
	                  xmax = Math.max(xmax, tester.xmax);
	                  ymin = Math.min(ymin, tester.ymin);
	                  ymax = Math.max(ymax, tester.ymax);
	                }
	              }
	              function contains(pt, arg, pointNumber, searchInfo) {
	                var contained = false;
	                for (var i2 = 0; i2 < testers.length; i2++) {
	                  if (testers[i2].contains(pt, arg, pointNumber, searchInfo)) {
	                    contained = !testers[i2].subtract;
	                  }
	                }
	                return contained;
	              }
	              return {
	                xmin,
	                xmax,
	                ymin,
	                ymax,
	                pts: [],
	                contains,
	                isRect: false,
	                degenerate: false
	              };
	            }
	            function coerceSelectionsCache(evt, gd, dragOptions) {
	              var fullLayout = gd._fullLayout;
	              var plotinfo = dragOptions.plotinfo;
	              var dragmode = dragOptions.dragmode;
	              var selectingOnSameSubplot = fullLayout._lastSelectedSubplot && fullLayout._lastSelectedSubplot === plotinfo.id;
	              var hasModifierKey = (evt.shiftKey || evt.altKey) && !(drawMode(dragmode) && openMode(dragmode));
	              if (selectingOnSameSubplot && hasModifierKey && plotinfo.selection && plotinfo.selection.selectionDefs && !dragOptions.selectionDefs) {
	                dragOptions.selectionDefs = plotinfo.selection.selectionDefs;
	                dragOptions.mergedPolygons = plotinfo.selection.mergedPolygons;
	              } else if (!hasModifierKey || !plotinfo.selection) {
	                clearSelectionsCache(dragOptions);
	              }
	              if (!selectingOnSameSubplot) {
	                clearOutline(gd);
	                fullLayout._lastSelectedSubplot = plotinfo.id;
	              }
	            }
	            function hasActiveShape(gd) {
	              return gd._fullLayout._activeShapeIndex >= 0;
	            }
	            function hasActiveSelection(gd) {
	              return gd._fullLayout._activeSelectionIndex >= 0;
	            }
	            function clearSelectionsCache(dragOptions, immediateSelect) {
	              var dragmode = dragOptions.dragmode;
	              var plotinfo = dragOptions.plotinfo;
	              var gd = dragOptions.gd;
	              if (hasActiveShape(gd)) {
	                gd._fullLayout._deactivateShape(gd);
	              }
	              if (hasActiveSelection(gd)) {
	                gd._fullLayout._deactivateSelection(gd);
	              }
	              var fullLayout = gd._fullLayout;
	              var zoomLayer = fullLayout._zoomlayer;
	              var isDrawMode = drawMode(dragmode);
	              var isSelectMode = selectMode(dragmode);
	              if (isDrawMode || isSelectMode) {
	                var outlines = zoomLayer.selectAll(".select-outline-" + plotinfo.id);
	                if (outlines && gd._fullLayout._outlining) {
	                  var shapes;
	                  if (isDrawMode) {
	                    shapes = newShapes(outlines, dragOptions);
	                  }
	                  if (shapes) {
	                    Registry.call("_guiRelayout", gd, {
	                      shapes
	                    });
	                  }
	                  var selections;
	                  if (isSelectMode && !hasSubplot(dragOptions)) {
	                    selections = newSelections(outlines, dragOptions);
	                  }
	                  if (selections) {
	                    gd._fullLayout._noEmitSelectedAtStart = true;
	                    Registry.call("_guiRelayout", gd, {
	                      selections
	                    }).then(function() {
	                      if (immediateSelect) {
	                        activateLastSelection(gd);
	                      }
	                    });
	                  }
	                  gd._fullLayout._outlining = false;
	                }
	              }
	              plotinfo.selection = {};
	              plotinfo.selection.selectionDefs = dragOptions.selectionDefs = [];
	              plotinfo.selection.mergedPolygons = dragOptions.mergedPolygons = [];
	            }
	            function getAxId(ax) {
	              return ax._id;
	            }
	            function determineSearchTraces(gd, xAxes, yAxes, subplot) {
	              if (!gd.calcdata) return [];
	              var searchTraces = [];
	              var xAxisIds = xAxes.map(getAxId);
	              var yAxisIds = yAxes.map(getAxId);
	              var cd, trace, i;
	              for (i = 0; i < gd.calcdata.length; i++) {
	                cd = gd.calcdata[i];
	                trace = cd[0].trace;
	                if (trace.visible !== true || !trace._module || !trace._module.selectPoints) continue;
	                if (hasSubplot({
	                  subplot
	                }) && (trace.subplot === subplot || trace.geo === subplot)) {
	                  searchTraces.push(createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]));
	                } else if (trace.type === "splom") {
	                  if (trace._xaxes[xAxisIds[0]] && trace._yaxes[yAxisIds[0]]) {
	                    var info = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
	                    info.scene = gd._fullLayout._splomScenes[trace.uid];
	                    searchTraces.push(info);
	                  }
	                } else if (trace.type === "sankey") {
	                  var sankeyInfo = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
	                  searchTraces.push(sankeyInfo);
	                } else {
	                  if (xAxisIds.indexOf(trace.xaxis) === -1) continue;
	                  if (yAxisIds.indexOf(trace.yaxis) === -1) continue;
	                  searchTraces.push(createSearchInfo(trace._module, cd, getFromId(gd, trace.xaxis), getFromId(gd, trace.yaxis)));
	                }
	              }
	              return searchTraces;
	            }
	            function createSearchInfo(module3, calcData, xaxis, yaxis) {
	              return {
	                _module: module3,
	                cd: calcData,
	                xaxis,
	                yaxis
	              };
	            }
	            function isHoverDataSet(hoverData) {
	              return hoverData && Array.isArray(hoverData) && hoverData[0].hoverOnBox !== true;
	            }
	            function extractClickedPtInfo(hoverData, searchTraces) {
	              var hoverDatum = hoverData[0];
	              var pointNumber = -1;
	              var pointNumbers = [];
	              var searchInfo, i;
	              for (i = 0; i < searchTraces.length; i++) {
	                searchInfo = searchTraces[i];
	                if (hoverDatum.fullData._expandedIndex === searchInfo.cd[0].trace._expandedIndex) {
	                  if (hoverDatum.hoverOnBox === true) {
	                    break;
	                  }
	                  if (hoverDatum.pointNumber !== undefined) {
	                    pointNumber = hoverDatum.pointNumber;
	                  } else if (hoverDatum.binNumber !== undefined) {
	                    pointNumber = hoverDatum.binNumber;
	                    pointNumbers = hoverDatum.pointNumbers;
	                  }
	                  break;
	                }
	              }
	              return {
	                pointNumber,
	                pointNumbers,
	                searchInfo
	              };
	            }
	            function isPointOrBinSelected(clickedPtInfo) {
	              var trace = clickedPtInfo.searchInfo.cd[0].trace;
	              var ptNum = clickedPtInfo.pointNumber;
	              var ptNums = clickedPtInfo.pointNumbers;
	              var ptNumsSet = ptNums.length > 0;
	              var ptNumToTest = ptNumsSet ? ptNums[0] : ptNum;
	              return trace.selectedpoints ? trace.selectedpoints.indexOf(ptNumToTest) > -1 : false;
	            }
	            function isOnlyThisBinSelected(searchTraces, clickedPtInfo) {
	              var tracesWithSelectedPts = [];
	              var searchInfo, trace, isSameTrace, i;
	              for (i = 0; i < searchTraces.length; i++) {
	                searchInfo = searchTraces[i];
	                if (searchInfo.cd[0].trace.selectedpoints && searchInfo.cd[0].trace.selectedpoints.length > 0) {
	                  tracesWithSelectedPts.push(searchInfo);
	                }
	              }
	              if (tracesWithSelectedPts.length === 1) {
	                isSameTrace = tracesWithSelectedPts[0] === clickedPtInfo.searchInfo;
	                if (isSameTrace) {
	                  trace = clickedPtInfo.searchInfo.cd[0].trace;
	                  if (trace.selectedpoints.length === clickedPtInfo.pointNumbers.length) {
	                    for (i = 0; i < clickedPtInfo.pointNumbers.length; i++) {
	                      if (trace.selectedpoints.indexOf(clickedPtInfo.pointNumbers[i]) < 0) {
	                        return false;
	                      }
	                    }
	                    return true;
	                  }
	                }
	              }
	              return false;
	            }
	            function isOnlyOnePointSelected(searchTraces) {
	              var len = 0;
	              var searchInfo, trace, i;
	              for (i = 0; i < searchTraces.length; i++) {
	                searchInfo = searchTraces[i];
	                trace = searchInfo.cd[0].trace;
	                if (trace.selectedpoints) {
	                  if (trace.selectedpoints.length > 1) return false;
	                  len += trace.selectedpoints.length;
	                  if (len > 1) return false;
	                }
	              }
	              return len === 1;
	            }
	            function updateSelectedState(gd, searchTraces, eventData) {
	              var i;
	              for (i = 0; i < searchTraces.length; i++) {
	                var fullInputTrace = searchTraces[i].cd[0].trace._fullInput;
	                var tracePreGUI = gd._fullLayout._tracePreGUI[fullInputTrace.uid] || {};
	                if (tracePreGUI.selectedpoints === undefined) {
	                  tracePreGUI.selectedpoints = fullInputTrace._input.selectedpoints || null;
	                }
	              }
	              var trace;
	              if (eventData) {
	                var pts = eventData.points || [];
	                for (i = 0; i < searchTraces.length; i++) {
	                  trace = searchTraces[i].cd[0].trace;
	                  trace._input.selectedpoints = trace._fullInput.selectedpoints = [];
	                  if (trace._fullInput !== trace) trace.selectedpoints = [];
	                }
	                for (var k = 0; k < pts.length; k++) {
	                  var pt = pts[k];
	                  var data = pt.data;
	                  var fullData = pt.fullData;
	                  var pointIndex = pt.pointIndex;
	                  var pointIndices = pt.pointIndices;
	                  if (pointIndices) {
	                    [].push.apply(data.selectedpoints, pointIndices);
	                    if (trace._fullInput !== trace) {
	                      [].push.apply(fullData.selectedpoints, pointIndices);
	                    }
	                  } else {
	                    data.selectedpoints.push(pointIndex);
	                    if (trace._fullInput !== trace) {
	                      fullData.selectedpoints.push(pointIndex);
	                    }
	                  }
	                }
	              } else {
	                for (i = 0; i < searchTraces.length; i++) {
	                  trace = searchTraces[i].cd[0].trace;
	                  delete trace.selectedpoints;
	                  delete trace._input.selectedpoints;
	                  if (trace._fullInput !== trace) {
	                    delete trace._fullInput.selectedpoints;
	                  }
	                }
	              }
	              updateReglSelectedState(gd, searchTraces);
	            }
	            function updateReglSelectedState(gd, searchTraces) {
	              var hasRegl = false;
	              for (var i = 0; i < searchTraces.length; i++) {
	                var searchInfo = searchTraces[i];
	                var cd = searchInfo.cd;
	                if (Registry.traceIs(cd[0].trace, "regl")) {
	                  hasRegl = true;
	                }
	                var _module = searchInfo._module;
	                var fn = _module.styleOnSelect || _module.style;
	                if (fn) {
	                  fn(gd, cd, cd[0].node3);
	                  if (cd[0].nodeRangePlot3) fn(gd, cd, cd[0].nodeRangePlot3);
	                }
	              }
	              if (hasRegl) {
	                clearGlCanvases(gd);
	                redrawReglTraces(gd);
	              }
	            }
	            function mergePolygons(list, poly, subtract) {
	              var fn = subtract ? polybool.difference : polybool.union;
	              var res = fn({
	                regions: list
	              }, {
	                regions: [poly]
	              });
	              var allPolygons = res.regions.reverse();
	              for (var i = 0; i < allPolygons.length; i++) {
	                var polygon = allPolygons[i];
	                polygon.subtract = getSubtract(polygon, allPolygons.slice(0, i));
	              }
	              return allPolygons;
	            }
	            function fillSelectionItem(selection, searchInfo) {
	              if (Array.isArray(selection)) {
	                var cd = searchInfo.cd;
	                var trace = searchInfo.cd[0].trace;
	                for (var i = 0; i < selection.length; i++) {
	                  selection[i] = makeEventData(selection[i], trace, cd);
	                }
	              }
	              return selection;
	            }
	            function convertPoly(polygonsIn, isOpenMode) {
	              var polygonsOut = [];
	              for (var i = 0; i < polygonsIn.length; i++) {
	                polygonsOut[i] = [];
	                for (var j = 0; j < polygonsIn[i].length; j++) {
	                  polygonsOut[i][j] = [];
	                  polygonsOut[i][j][0] = j ? "L" : "M";
	                  for (var k = 0; k < polygonsIn[i][j].length; k++) {
	                    polygonsOut[i][j].push(polygonsIn[i][j][k]);
	                  }
	                }
	                if (!isOpenMode) {
	                  polygonsOut[i].push([
	                    "Z",
	                    polygonsOut[i][0][1],
	                    // initial x
	                    polygonsOut[i][0][2]
	                    // initial y
	                  ]);
	                }
	              }
	              return polygonsOut;
	            }
	            function _doSelect(selectionTesters, searchTraces) {
	              var allSelections = [];
	              var thisSelection;
	              var traceSelection;
	              for (var i = 0; i < searchTraces.length; i++) {
	                var searchInfo = searchTraces[i];
	                traceSelection = searchInfo._module.selectPoints(searchInfo, selectionTesters);
	                thisSelection = fillSelectionItem(traceSelection, searchInfo);
	                allSelections = allSelections.concat(thisSelection);
	              }
	              return allSelections;
	            }
	            function reselect(gd, mayEmitSelected, selectionTesters, searchTraces, dragOptions) {
	              var hadSearchTraces = !!searchTraces;
	              var plotinfo, xRef, yRef;
	              if (dragOptions) {
	                plotinfo = dragOptions.plotinfo;
	                xRef = dragOptions.xaxes[0]._id;
	                yRef = dragOptions.yaxes[0]._id;
	              }
	              var allSelections = [];
	              var allSearchTraces = [];
	              var layoutPolygons = getLayoutPolygons(gd);
	              var fullLayout = gd._fullLayout;
	              if (plotinfo) {
	                var zoomLayer = fullLayout._zoomlayer;
	                var mode = fullLayout.dragmode;
	                var isDrawMode = drawMode(mode);
	                var isSelectMode = selectMode(mode);
	                if (isDrawMode || isSelectMode) {
	                  var xaxis = getFromId(gd, xRef, "x");
	                  var yaxis = getFromId(gd, yRef, "y");
	                  if (xaxis && yaxis) {
	                    var outlines = zoomLayer.selectAll(".select-outline-" + plotinfo.id);
	                    if (outlines && gd._fullLayout._outlining) {
	                      if (outlines.length) {
	                        var e = outlines[0][0];
	                        var d = e.getAttribute("d");
	                        var outlinePolys = readPaths(d, gd, plotinfo);
	                        var draftPolygons = [];
	                        for (var u = 0; u < outlinePolys.length; u++) {
	                          var p = outlinePolys[u];
	                          var polygon = [];
	                          for (var t = 0; t < p.length; t++) {
	                            polygon.push([convert(xaxis, p[t][1]), convert(yaxis, p[t][2])]);
	                          }
	                          polygon.xref = xRef;
	                          polygon.yref = yRef;
	                          polygon.subtract = getSubtract(polygon, draftPolygons);
	                          draftPolygons.push(polygon);
	                        }
	                        layoutPolygons = layoutPolygons.concat(draftPolygons);
	                      }
	                    }
	                  }
	                }
	              }
	              var subplots = xRef && yRef ? [xRef + yRef] : fullLayout._subplots.cartesian;
	              epmtySplomSelectionBatch(gd);
	              var seenSplom = {};
	              for (var i = 0; i < subplots.length; i++) {
	                var subplot = subplots[i];
	                var yAt = subplot.indexOf("y");
	                var _xRef = subplot.slice(0, yAt);
	                var _yRef = subplot.slice(yAt);
	                var _selectionTesters = xRef && yRef ? selectionTesters : undefined;
	                _selectionTesters = addTester(layoutPolygons, _xRef, _yRef, _selectionTesters);
	                if (_selectionTesters) {
	                  var _searchTraces = searchTraces;
	                  if (!hadSearchTraces) {
	                    var _xA = getFromId(gd, _xRef, "x");
	                    var _yA = getFromId(gd, _yRef, "y");
	                    _searchTraces = determineSearchTraces(gd, [_xA], [_yA], subplot);
	                    for (var w = 0; w < _searchTraces.length; w++) {
	                      var s = _searchTraces[w];
	                      var cd0 = s.cd[0];
	                      var trace = cd0.trace;
	                      if (s._module.name === "scattergl" && !cd0.t.xpx) {
	                        var x = trace.x;
	                        var y = trace.y;
	                        var len = trace._length;
	                        cd0.t.xpx = [];
	                        cd0.t.ypx = [];
	                        for (var j = 0; j < len; j++) {
	                          cd0.t.xpx[j] = _xA.c2p(x[j]);
	                          cd0.t.ypx[j] = _yA.c2p(y[j]);
	                        }
	                      }
	                      if (s._module.name === "splom") {
	                        if (!seenSplom[trace.uid]) {
	                          seenSplom[trace.uid] = true;
	                        }
	                      }
	                    }
	                  }
	                  var selection = _doSelect(_selectionTesters, _searchTraces);
	                  allSelections = allSelections.concat(selection);
	                  allSearchTraces = allSearchTraces.concat(_searchTraces);
	                }
	              }
	              var eventData = {
	                points: allSelections
	              };
	              updateSelectedState(gd, allSearchTraces, eventData);
	              var clickmode = fullLayout.clickmode;
	              var sendEvents = clickmode.indexOf("event") > -1 && mayEmitSelected;
	              if (!plotinfo && // get called from plot_api & plots
	              mayEmitSelected) {
	                var activePolygons = getLayoutPolygons(gd, true);
	                if (activePolygons.length) {
	                  var xref = activePolygons[0].xref;
	                  var yref = activePolygons[0].yref;
	                  if (xref && yref) {
	                    var poly = castMultiPolygon(activePolygons);
	                    var fillRangeItems = makeFillRangeItems([getFromId(gd, xref, "x"), getFromId(gd, yref, "y")]);
	                    fillRangeItems(eventData, poly);
	                  }
	                }
	                if (gd._fullLayout._noEmitSelectedAtStart) {
	                  gd._fullLayout._noEmitSelectedAtStart = false;
	                } else {
	                  if (sendEvents) emitSelected(gd, eventData);
	                }
	                fullLayout._reselect = false;
	              }
	              if (!plotinfo && // get called from plot_api & plots
	              fullLayout._deselect) {
	                var deselect = fullLayout._deselect;
	                xRef = deselect.xref;
	                yRef = deselect.yref;
	                if (!subplotSelected(xRef, yRef, allSearchTraces)) {
	                  deselectSubplot(gd, xRef, yRef, searchTraces);
	                }
	                if (sendEvents) {
	                  if (eventData.points.length) {
	                    emitSelected(gd, eventData);
	                  } else {
	                    emitDeselect(gd);
	                  }
	                }
	                fullLayout._deselect = false;
	              }
	              return {
	                eventData,
	                selectionTesters
	              };
	            }
	            function epmtySplomSelectionBatch(gd) {
	              var cd = gd.calcdata;
	              if (!cd) return;
	              for (var i = 0; i < cd.length; i++) {
	                var cd0 = cd[i][0];
	                var trace = cd0.trace;
	                var splomScenes = gd._fullLayout._splomScenes;
	                if (splomScenes) {
	                  var scene = splomScenes[trace.uid];
	                  if (scene) {
	                    scene.selectBatch = [];
	                  }
	                }
	              }
	            }
	            function subplotSelected(xRef, yRef, searchTraces) {
	              for (var i = 0; i < searchTraces.length; i++) {
	                var s = searchTraces[i];
	                if (s.xaxis && s.xaxis._id === xRef && s.yaxis && s.yaxis._id === yRef) {
	                  return true;
	                }
	              }
	              return false;
	            }
	            function deselectSubplot(gd, xRef, yRef, searchTraces) {
	              searchTraces = determineSearchTraces(gd, [getFromId(gd, xRef, "x")], [getFromId(gd, yRef, "y")], xRef + yRef);
	              for (var k = 0; k < searchTraces.length; k++) {
	                var searchInfo = searchTraces[k];
	                searchInfo._module.selectPoints(searchInfo, false);
	              }
	              updateSelectedState(gd, searchTraces);
	            }
	            function addTester(layoutPolygons, xRef, yRef, selectionTesters) {
	              var mergedPolygons;
	              for (var i = 0; i < layoutPolygons.length; i++) {
	                var currentPolygon = layoutPolygons[i];
	                if (xRef !== currentPolygon.xref || yRef !== currentPolygon.yref) continue;
	                if (mergedPolygons) {
	                  var subtract = !!currentPolygon.subtract;
	                  mergedPolygons = mergePolygons(mergedPolygons, currentPolygon, subtract);
	                  selectionTesters = multiTester(mergedPolygons);
	                } else {
	                  mergedPolygons = [currentPolygon];
	                  selectionTesters = polygonTester(currentPolygon);
	                }
	              }
	              return selectionTesters;
	            }
	            function getLayoutPolygons(gd, onlyActiveOnes) {
	              var allPolygons = [];
	              var fullLayout = gd._fullLayout;
	              var allSelections = fullLayout.selections;
	              var len = allSelections.length;
	              for (var i = 0; i < len; i++) {
	                if (onlyActiveOnes && i !== fullLayout._activeSelectionIndex) continue;
	                var selection = allSelections[i];
	                if (!selection) continue;
	                var xref = selection.xref;
	                var yref = selection.yref;
	                var xaxis = getFromId(gd, xref, "x");
	                var yaxis = getFromId(gd, yref, "y");
	                var xmin, xmax, ymin, ymax;
	                var polygon;
	                if (selection.type === "rect") {
	                  polygon = [];
	                  var x0 = convert(xaxis, selection.x0);
	                  var x1 = convert(xaxis, selection.x1);
	                  var y0 = convert(yaxis, selection.y0);
	                  var y1 = convert(yaxis, selection.y1);
	                  polygon = [[x0, y0], [x0, y1], [x1, y1], [x1, y0]];
	                  xmin = Math.min(x0, x1);
	                  xmax = Math.max(x0, x1);
	                  ymin = Math.min(y0, y1);
	                  ymax = Math.max(y0, y1);
	                  polygon.xmin = xmin;
	                  polygon.xmax = xmax;
	                  polygon.ymin = ymin;
	                  polygon.ymax = ymax;
	                  polygon.xref = xref;
	                  polygon.yref = yref;
	                  polygon.subtract = false;
	                  polygon.isRect = true;
	                  allPolygons.push(polygon);
	                } else if (selection.type === "path") {
	                  var segments = selection.path.split("Z");
	                  var multiPolygons = [];
	                  for (var j = 0; j < segments.length; j++) {
	                    var path = segments[j];
	                    if (!path) continue;
	                    path += "Z";
	                    var allX = shapeHelpers.extractPathCoords(path, shapeConstants.paramIsX, "raw");
	                    var allY = shapeHelpers.extractPathCoords(path, shapeConstants.paramIsY, "raw");
	                    xmin = Infinity;
	                    xmax = -Infinity;
	                    ymin = Infinity;
	                    ymax = -Infinity;
	                    polygon = [];
	                    for (var k = 0; k < allX.length; k++) {
	                      var x = convert(xaxis, allX[k]);
	                      var y = convert(yaxis, allY[k]);
	                      polygon.push([x, y]);
	                      xmin = Math.min(x, xmin);
	                      xmax = Math.max(x, xmax);
	                      ymin = Math.min(y, ymin);
	                      ymax = Math.max(y, ymax);
	                    }
	                    polygon.xmin = xmin;
	                    polygon.xmax = xmax;
	                    polygon.ymin = ymin;
	                    polygon.ymax = ymax;
	                    polygon.xref = xref;
	                    polygon.yref = yref;
	                    polygon.subtract = getSubtract(polygon, multiPolygons);
	                    multiPolygons.push(polygon);
	                    allPolygons.push(polygon);
	                  }
	                }
	              }
	              return allPolygons;
	            }
	            function getSubtract(polygon, previousPolygons) {
	              var subtract = false;
	              for (var i = 0; i < previousPolygons.length; i++) {
	                var previousPolygon = previousPolygons[i];
	                for (var k = 0; k < polygon.length; k++) {
	                  if (pointInPolygon(polygon[k], previousPolygon)) {
	                    subtract = !subtract;
	                    break;
	                  }
	                }
	              }
	              return subtract;
	            }
	            function convert(ax, d) {
	              if (ax.type === "date") d = d.replace("_", " ");
	              return ax.type === "log" ? ax.c2p(d) : ax.r2p(d, null, ax.calendar);
	            }
	            function castMultiPolygon(allPolygons) {
	              var len = allPolygons.length;
	              var p = [];
	              for (var i = 0; i < len; i++) {
	                var polygon = allPolygons[i];
	                p = p.concat(polygon);
	                p = p.concat([polygon[0]]);
	              }
	              return computeRectAndRanges(p);
	            }
	            function computeRectAndRanges(poly) {
	              poly.isRect = poly.length === 5 && poly[0][0] === poly[4][0] && poly[0][1] === poly[4][1] && poly[0][0] === poly[1][0] && poly[2][0] === poly[3][0] && poly[0][1] === poly[3][1] && poly[1][1] === poly[2][1] || poly[0][1] === poly[1][1] && poly[2][1] === poly[3][1] && poly[0][0] === poly[3][0] && poly[1][0] === poly[2][0];
	              if (poly.isRect) {
	                poly.xmin = Math.min(poly[0][0], poly[2][0]);
	                poly.xmax = Math.max(poly[0][0], poly[2][0]);
	                poly.ymin = Math.min(poly[0][1], poly[2][1]);
	                poly.ymax = Math.max(poly[0][1], poly[2][1]);
	              }
	              return poly;
	            }
	            function makeFillRangeItems(allAxes) {
	              return function(eventData, poly) {
	                var range2;
	                var lassoPoints;
	                for (var i = 0; i < allAxes.length; i++) {
	                  var ax = allAxes[i];
	                  var id = ax._id;
	                  var axLetter = id.charAt(0);
	                  if (poly.isRect) {
	                    if (!range2) range2 = {};
	                    var min = poly[axLetter + "min"];
	                    var max = poly[axLetter + "max"];
	                    if (min !== undefined && max !== undefined) {
	                      range2[id] = [p2r(ax, min), p2r(ax, max)].sort(ascending2);
	                    }
	                  } else {
	                    if (!lassoPoints) lassoPoints = {};
	                    lassoPoints[id] = poly.map(axValue(ax));
	                  }
	                }
	                if (range2) {
	                  eventData.range = range2;
	                }
	                if (lassoPoints) {
	                  eventData.lassoPoints = lassoPoints;
	                }
	              };
	            }
	            function getFillRangeItems(dragOptions) {
	              var plotinfo = dragOptions.plotinfo;
	              return plotinfo.fillRangeItems || // allow subplots (i.e. geo, mapbox, sankey) to override fillRangeItems routine
	              makeFillRangeItems(dragOptions.xaxes.concat(dragOptions.yaxes));
	            }
	            function emitSelecting(gd, eventData) {
	              gd.emit("plotly_selecting", eventData);
	            }
	            function emitSelected(gd, eventData) {
	              if (eventData) {
	                eventData.selections = (gd.layout || {}).selections || [];
	              }
	              gd.emit("plotly_selected", eventData);
	            }
	            function emitDeselect(gd) {
	              gd.emit("plotly_deselect", null);
	            }
	            module2.exports = {
	              reselect,
	              prepSelect,
	              clearOutline,
	              clearSelectionsCache,
	              selectOnClick
	            };
	          }
	        ),
	        /***/
	        89827: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var annAttrs = __webpack_require__2(50215);
	            var fontAttrs = __webpack_require__2(41940);
	            var scatterLineAttrs = __webpack_require__2(82196).line;
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            __webpack_require__2(24695);
	            var basePlotAttributes = __webpack_require__2(9012);
	            var shapeTexttemplateAttrs = __webpack_require__2(5386).R;
	            var shapeLabelTexttemplateVars = __webpack_require__2(37281);
	            module2.exports = templatedArray("shape", {
	              visible: extendFlat({}, basePlotAttributes.visible, {
	                editType: "calc+arraydraw"
	              }),
	              showlegend: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc+arraydraw"
	              },
	              legend: extendFlat({}, basePlotAttributes.legend, {
	                editType: "calc+arraydraw"
	              }),
	              legendgroup: extendFlat({}, basePlotAttributes.legendgroup, {
	                editType: "calc+arraydraw"
	              }),
	              legendgrouptitle: {
	                text: extendFlat({}, basePlotAttributes.legendgrouptitle.text, {
	                  editType: "calc+arraydraw"
	                }),
	                font: fontAttrs({
	                  editType: "calc+arraydraw"
	                }),
	                editType: "calc+arraydraw"
	              },
	              legendrank: extendFlat({}, basePlotAttributes.legendrank, {
	                editType: "calc+arraydraw"
	              }),
	              legendwidth: extendFlat({}, basePlotAttributes.legendwidth, {
	                editType: "calc+arraydraw"
	              }),
	              type: {
	                valType: "enumerated",
	                values: ["circle", "rect", "path", "line"],
	                editType: "calc+arraydraw"
	              },
	              layer: {
	                valType: "enumerated",
	                values: ["below", "above"],
	                dflt: "above",
	                editType: "arraydraw"
	              },
	              xref: extendFlat({}, annAttrs.xref, {}),
	              xsizemode: {
	                valType: "enumerated",
	                values: ["scaled", "pixel"],
	                dflt: "scaled",
	                editType: "calc+arraydraw"
	              },
	              xanchor: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              x0: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              x1: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              yref: extendFlat({}, annAttrs.yref, {}),
	              ysizemode: {
	                valType: "enumerated",
	                values: ["scaled", "pixel"],
	                dflt: "scaled",
	                editType: "calc+arraydraw"
	              },
	              yanchor: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              y0: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              y1: {
	                valType: "any",
	                editType: "calc+arraydraw"
	              },
	              path: {
	                valType: "string",
	                editType: "calc+arraydraw"
	              },
	              opacity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 1,
	                editType: "arraydraw"
	              },
	              line: {
	                color: extendFlat({}, scatterLineAttrs.color, {
	                  editType: "arraydraw"
	                }),
	                width: extendFlat({}, scatterLineAttrs.width, {
	                  editType: "calc+arraydraw"
	                }),
	                dash: extendFlat({}, dash, {
	                  editType: "arraydraw"
	                }),
	                editType: "calc+arraydraw"
	              },
	              fillcolor: {
	                valType: "color",
	                dflt: "rgba(0,0,0,0)",
	                editType: "arraydraw"
	              },
	              fillrule: {
	                valType: "enumerated",
	                values: ["evenodd", "nonzero"],
	                dflt: "evenodd",
	                editType: "arraydraw"
	              },
	              editable: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc+arraydraw"
	              },
	              label: {
	                text: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "arraydraw"
	                },
	                texttemplate: shapeTexttemplateAttrs({}, {
	                  keys: Object.keys(shapeLabelTexttemplateVars)
	                }),
	                font: fontAttrs({
	                  editType: "calc+arraydraw",
	                  colorEditType: "arraydraw"
	                }),
	                textposition: {
	                  valType: "enumerated",
	                  values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"],
	                  editType: "arraydraw"
	                },
	                textangle: {
	                  valType: "angle",
	                  dflt: "auto",
	                  editType: "calc+arraydraw"
	                },
	                xanchor: {
	                  valType: "enumerated",
	                  values: ["auto", "left", "center", "right"],
	                  dflt: "auto",
	                  editType: "calc+arraydraw"
	                },
	                yanchor: {
	                  valType: "enumerated",
	                  values: ["top", "middle", "bottom"],
	                  editType: "calc+arraydraw"
	                },
	                padding: {
	                  valType: "number",
	                  dflt: 3,
	                  min: 0,
	                  editType: "arraydraw"
	                },
	                editType: "arraydraw"
	              },
	              editType: "arraydraw"
	            });
	          }
	        ),
	        /***/
	        5627: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var constants = __webpack_require__2(21459);
	            var helpers = __webpack_require__2(30477);
	            module2.exports = function calcAutorange(gd) {
	              var fullLayout = gd._fullLayout;
	              var shapeList = Lib.filterVisible(fullLayout.shapes);
	              if (!shapeList.length || !gd._fullData.length) return;
	              for (var i = 0; i < shapeList.length; i++) {
	                var shape = shapeList[i];
	                shape._extremes = {};
	                var ax;
	                var bounds;
	                var xRefType = Axes.getRefType(shape.xref);
	                var yRefType = Axes.getRefType(shape.yref);
	                if (shape.xref !== "paper" && xRefType !== "domain") {
	                  var vx0 = shape.xsizemode === "pixel" ? shape.xanchor : shape.x0;
	                  var vx1 = shape.xsizemode === "pixel" ? shape.xanchor : shape.x1;
	                  ax = Axes.getFromId(gd, shape.xref);
	                  bounds = shapeBounds(ax, vx0, vx1, shape.path, constants.paramIsX);
	                  if (bounds) {
	                    shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcXPaddingOptions(shape));
	                  }
	                }
	                if (shape.yref !== "paper" && yRefType !== "domain") {
	                  var vy0 = shape.ysizemode === "pixel" ? shape.yanchor : shape.y0;
	                  var vy1 = shape.ysizemode === "pixel" ? shape.yanchor : shape.y1;
	                  ax = Axes.getFromId(gd, shape.yref);
	                  bounds = shapeBounds(ax, vy0, vy1, shape.path, constants.paramIsY);
	                  if (bounds) {
	                    shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcYPaddingOptions(shape));
	                  }
	                }
	              }
	            };
	            function calcXPaddingOptions(shape) {
	              return calcPaddingOptions(shape.line.width, shape.xsizemode, shape.x0, shape.x1, shape.path, false);
	            }
	            function calcYPaddingOptions(shape) {
	              return calcPaddingOptions(shape.line.width, shape.ysizemode, shape.y0, shape.y1, shape.path, true);
	            }
	            function calcPaddingOptions(lineWidth, sizeMode, v0, v1, path, isYAxis) {
	              var ppad = lineWidth / 2;
	              var axisDirectionReverted = isYAxis;
	              if (sizeMode === "pixel") {
	                var coords = path ? helpers.extractPathCoords(path, isYAxis ? constants.paramIsY : constants.paramIsX) : [v0, v1];
	                var maxValue = Lib.aggNums(Math.max, null, coords);
	                var minValue = Lib.aggNums(Math.min, null, coords);
	                var beforePad = minValue < 0 ? Math.abs(minValue) + ppad : ppad;
	                var afterPad = maxValue > 0 ? maxValue + ppad : ppad;
	                return {
	                  ppad,
	                  ppadplus: axisDirectionReverted ? beforePad : afterPad,
	                  ppadminus: axisDirectionReverted ? afterPad : beforePad
	                };
	              } else {
	                return {
	                  ppad
	                };
	              }
	            }
	            function shapeBounds(ax, v0, v1, path, paramsToUse) {
	              var convertVal = ax.type === "category" || ax.type === "multicategory" ? ax.r2c : ax.d2c;
	              if (v0 !== undefined) return [convertVal(v0), convertVal(v1)];
	              if (!path) return;
	              var min = Infinity;
	              var max = -Infinity;
	              var segments = path.match(constants.segmentRE);
	              var i;
	              var segment;
	              var drawnParam;
	              var params;
	              var val;
	              if (ax.type === "date") convertVal = helpers.decodeDate(convertVal);
	              for (i = 0; i < segments.length; i++) {
	                segment = segments[i];
	                drawnParam = paramsToUse[segment.charAt(0)].drawn;
	                if (drawnParam === undefined) continue;
	                params = segments[i].substr(1).match(constants.paramRE);
	                if (!params || params.length < drawnParam) continue;
	                val = convertVal(params[drawnParam]);
	                if (val < min) min = val;
	                if (val > max) max = val;
	              }
	              if (max >= min) return [min, max];
	            }
	          }
	        ),
	        /***/
	        21459: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
	              paramRE: /[^\s,]+/g,
	              // which numbers in each path segment are x (or y) values
	              // drawn is which param is a drawn point, as opposed to a
	              // control point (which doesn't count toward autorange.
	              // TODO: this means curved paths could extend beyond the
	              // autorange bounds. This is a bit tricky to get right
	              // unless we revert to bounding boxes, but perhaps there's
	              // a calculation we could do...)
	              paramIsX: {
	                M: {
	                  0: true,
	                  drawn: 0
	                },
	                L: {
	                  0: true,
	                  drawn: 0
	                },
	                H: {
	                  0: true,
	                  drawn: 0
	                },
	                V: {},
	                Q: {
	                  0: true,
	                  2: true,
	                  drawn: 2
	                },
	                C: {
	                  0: true,
	                  2: true,
	                  4: true,
	                  drawn: 4
	                },
	                T: {
	                  0: true,
	                  drawn: 0
	                },
	                S: {
	                  0: true,
	                  2: true,
	                  drawn: 2
	                },
	                // A: {0: true, 5: true},
	                Z: {}
	              },
	              paramIsY: {
	                M: {
	                  1: true,
	                  drawn: 1
	                },
	                L: {
	                  1: true,
	                  drawn: 1
	                },
	                H: {},
	                V: {
	                  0: true,
	                  drawn: 0
	                },
	                Q: {
	                  1: true,
	                  3: true,
	                  drawn: 3
	                },
	                C: {
	                  1: true,
	                  3: true,
	                  5: true,
	                  drawn: 5
	                },
	                T: {
	                  1: true,
	                  drawn: 1
	                },
	                S: {
	                  1: true,
	                  3: true,
	                  drawn: 5
	                },
	                // A: {1: true, 6: true},
	                Z: {}
	              },
	              numParams: {
	                M: 2,
	                L: 2,
	                H: 1,
	                V: 1,
	                Q: 4,
	                C: 6,
	                T: 2,
	                S: 4,
	                // A: 7,
	                Z: 0
	              }
	            };
	          }
	        ),
	        /***/
	        84726: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(89827);
	            var helpers = __webpack_require__2(30477);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              handleArrayContainerDefaults(layoutIn, layoutOut, {
	                name: "shapes",
	                handleItemDefaults: handleShapeDefaults
	              });
	            };
	            function dfltLabelYanchor(isLine, labelTextPosition) {
	              return isLine ? "bottom" : labelTextPosition.indexOf("top") !== -1 ? "top" : labelTextPosition.indexOf("bottom") !== -1 ? "bottom" : "middle";
	            }
	            function handleShapeDefaults(shapeIn, shapeOut, fullLayout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(shapeIn, shapeOut, attributes, attr, dflt);
	              }
	              shapeOut._isShape = true;
	              var visible = coerce("visible");
	              if (!visible) return;
	              var showlegend = coerce("showlegend");
	              if (showlegend) {
	                coerce("legend");
	                coerce("legendwidth");
	                coerce("legendgroup");
	                coerce("legendgrouptitle.text");
	                Lib.coerceFont(coerce, "legendgrouptitle.font");
	                coerce("legendrank");
	              }
	              var path = coerce("path");
	              var dfltType = path ? "path" : "rect";
	              var shapeType = coerce("type", dfltType);
	              var noPath = shapeType !== "path";
	              if (noPath) delete shapeOut.path;
	              coerce("editable");
	              coerce("layer");
	              coerce("opacity");
	              coerce("fillcolor");
	              coerce("fillrule");
	              var lineWidth = coerce("line.width");
	              if (lineWidth) {
	                coerce("line.color");
	                coerce("line.dash");
	              }
	              var xSizeMode = coerce("xsizemode");
	              var ySizeMode = coerce("ysizemode");
	              var axLetters = ["x", "y"];
	              for (var i = 0; i < 2; i++) {
	                var axLetter = axLetters[i];
	                var attrAnchor = axLetter + "anchor";
	                var sizeMode = axLetter === "x" ? xSizeMode : ySizeMode;
	                var gdMock = {
	                  _fullLayout: fullLayout
	                };
	                var ax;
	                var pos2r;
	                var r2pos;
	                var axRef = Axes.coerceRef(shapeIn, shapeOut, gdMock, axLetter, undefined, "paper");
	                var axRefType = Axes.getRefType(axRef);
	                if (axRefType === "range") {
	                  ax = Axes.getFromId(gdMock, axRef);
	                  ax._shapeIndices.push(shapeOut._index);
	                  r2pos = helpers.rangeToShapePosition(ax);
	                  pos2r = helpers.shapePositionToRange(ax);
	                } else {
	                  pos2r = r2pos = Lib.identity;
	                }
	                if (noPath) {
	                  var dflt0 = 0.25;
	                  var dflt1 = 0.75;
	                  var attr0 = axLetter + "0";
	                  var attr1 = axLetter + "1";
	                  var in0 = shapeIn[attr0];
	                  var in1 = shapeIn[attr1];
	                  shapeIn[attr0] = pos2r(shapeIn[attr0], true);
	                  shapeIn[attr1] = pos2r(shapeIn[attr1], true);
	                  if (sizeMode === "pixel") {
	                    coerce(attr0, 0);
	                    coerce(attr1, 10);
	                  } else {
	                    Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr0, dflt0);
	                    Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr1, dflt1);
	                  }
	                  shapeOut[attr0] = r2pos(shapeOut[attr0]);
	                  shapeOut[attr1] = r2pos(shapeOut[attr1]);
	                  shapeIn[attr0] = in0;
	                  shapeIn[attr1] = in1;
	                }
	                if (sizeMode === "pixel") {
	                  var inAnchor = shapeIn[attrAnchor];
	                  shapeIn[attrAnchor] = pos2r(shapeIn[attrAnchor], true);
	                  Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attrAnchor, 0.25);
	                  shapeOut[attrAnchor] = r2pos(shapeOut[attrAnchor]);
	                  shapeIn[attrAnchor] = inAnchor;
	                }
	              }
	              if (noPath) {
	                Lib.noneOrAll(shapeIn, shapeOut, ["x0", "x1", "y0", "y1"]);
	              }
	              var isLine = shapeType === "line";
	              var labelTextTemplate, labelText;
	              if (noPath) {
	                labelTextTemplate = coerce("label.texttemplate");
	              }
	              if (!labelTextTemplate) {
	                labelText = coerce("label.text");
	              }
	              if (labelText || labelTextTemplate) {
	                coerce("label.textangle");
	                var labelTextPosition = coerce("label.textposition", isLine ? "middle" : "middle center");
	                coerce("label.xanchor");
	                coerce("label.yanchor", dfltLabelYanchor(isLine, labelTextPosition));
	                coerce("label.padding");
	                Lib.coerceFont(coerce, "label.font", fullLayout.font);
	              }
	            }
	          }
	        ),
	        /***/
	        48100: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var svgTextUtils = __webpack_require__2(63893);
	            var Drawing = __webpack_require__2(91424);
	            var readPaths = __webpack_require__2(60165).readPaths;
	            var helpers = __webpack_require__2(30477);
	            var getPathString = helpers.getPathString;
	            var shapeLabelTexttemplateVars = __webpack_require__2(37281);
	            var FROM_TL = __webpack_require__2(18783).FROM_TL;
	            module2.exports = function drawLabel(gd, index, options, shapeGroup) {
	              shapeGroup.selectAll(".shape-label").remove();
	              if (!(options.label.text || options.label.texttemplate)) return;
	              var text;
	              if (options.label.texttemplate) {
	                var templateValues = {};
	                if (options.type !== "path") {
	                  var _xa = Axes.getFromId(gd, options.xref);
	                  var _ya = Axes.getFromId(gd, options.yref);
	                  for (var key in shapeLabelTexttemplateVars) {
	                    var val = shapeLabelTexttemplateVars[key](options, _xa, _ya);
	                    if (val !== undefined) templateValues[key] = val;
	                  }
	                }
	                text = Lib.texttemplateStringForShapes(options.label.texttemplate, {}, gd._fullLayout._d3locale, templateValues);
	              } else {
	                text = options.label.text;
	              }
	              var labelGroupAttrs = {
	                "data-index": index
	              };
	              var font = options.label.font;
	              var labelTextAttrs = {
	                "data-notex": 1
	              };
	              var labelGroup = shapeGroup.append("g").attr(labelGroupAttrs).classed("shape-label", true);
	              var labelText = labelGroup.append("text").attr(labelTextAttrs).classed("shape-label-text", true).text(text);
	              var shapex0, shapex1, shapey0, shapey1;
	              if (options.path) {
	                var d = getPathString(gd, options);
	                var polygons = readPaths(d, gd);
	                shapex0 = Infinity;
	                shapey0 = Infinity;
	                shapex1 = -Infinity;
	                shapey1 = -Infinity;
	                for (var i = 0; i < polygons.length; i++) {
	                  for (var j = 0; j < polygons[i].length; j++) {
	                    var p = polygons[i][j];
	                    for (var k = 1; k < p.length; k += 2) {
	                      var _x = p[k];
	                      var _y = p[k + 1];
	                      shapex0 = Math.min(shapex0, _x);
	                      shapex1 = Math.max(shapex1, _x);
	                      shapey0 = Math.min(shapey0, _y);
	                      shapey1 = Math.max(shapey1, _y);
	                    }
	                  }
	                }
	              } else {
	                var xa = Axes.getFromId(gd, options.xref);
	                var xRefType = Axes.getRefType(options.xref);
	                var ya = Axes.getFromId(gd, options.yref);
	                var yRefType = Axes.getRefType(options.yref);
	                var x2p = helpers.getDataToPixel(gd, xa, false, xRefType);
	                var y2p = helpers.getDataToPixel(gd, ya, true, yRefType);
	                shapex0 = x2p(options.x0);
	                shapex1 = x2p(options.x1);
	                shapey0 = y2p(options.y0);
	                shapey1 = y2p(options.y1);
	              }
	              var textangle = options.label.textangle;
	              if (textangle === "auto") {
	                if (options.type === "line") {
	                  textangle = calcTextAngle(shapex0, shapey0, shapex1, shapey1);
	                } else {
	                  textangle = 0;
	                }
	              }
	              labelText.call(function(s) {
	                s.call(Drawing.font, font).attr({});
	                svgTextUtils.convertToTspans(s, gd);
	                return s;
	              });
	              var textBB = Drawing.bBox(labelText.node());
	              var textPos = calcTextPosition(shapex0, shapey0, shapex1, shapey1, options, textangle, textBB);
	              var textx = textPos.textx;
	              var texty = textPos.texty;
	              var xanchor = textPos.xanchor;
	              labelText.attr({
	                "text-anchor": {
	                  left: "start",
	                  center: "middle",
	                  right: "end"
	                }[xanchor],
	                y: texty,
	                x: textx,
	                transform: "rotate(" + textangle + "," + textx + "," + texty + ")"
	              }).call(svgTextUtils.positionText, textx, texty);
	            };
	            function calcTextAngle(shapex0, shapey0, shapex1, shapey1) {
	              var dy, dx;
	              dx = Math.abs(shapex1 - shapex0);
	              if (shapex1 >= shapex0) {
	                dy = shapey0 - shapey1;
	              } else {
	                dy = shapey1 - shapey0;
	              }
	              return -180 / Math.PI * Math.atan2(dy, dx);
	            }
	            function calcTextPosition(shapex0, shapey0, shapex1, shapey1, shapeOptions, actualTextAngle, textBB) {
	              var textPosition = shapeOptions.label.textposition;
	              var textAngle = shapeOptions.label.textangle;
	              var textPadding = shapeOptions.label.padding;
	              var shapeType = shapeOptions.type;
	              var textAngleRad = Math.PI / 180 * actualTextAngle;
	              var sinA = Math.sin(textAngleRad);
	              var cosA = Math.cos(textAngleRad);
	              var xanchor = shapeOptions.label.xanchor;
	              var yanchor = shapeOptions.label.yanchor;
	              var textx, texty, paddingX, paddingY;
	              if (shapeType === "line") {
	                if (textPosition === "start") {
	                  textx = shapex0;
	                  texty = shapey0;
	                } else if (textPosition === "end") {
	                  textx = shapex1;
	                  texty = shapey1;
	                } else {
	                  textx = (shapex0 + shapex1) / 2;
	                  texty = (shapey0 + shapey1) / 2;
	                }
	                if (xanchor === "auto") {
	                  if (textPosition === "start") {
	                    if (textAngle === "auto") {
	                      if (shapex1 > shapex0) xanchor = "left";
	                      else if (shapex1 < shapex0) xanchor = "right";
	                      else xanchor = "center";
	                    } else {
	                      if (shapex1 > shapex0) xanchor = "right";
	                      else if (shapex1 < shapex0) xanchor = "left";
	                      else xanchor = "center";
	                    }
	                  } else if (textPosition === "end") {
	                    if (textAngle === "auto") {
	                      if (shapex1 > shapex0) xanchor = "right";
	                      else if (shapex1 < shapex0) xanchor = "left";
	                      else xanchor = "center";
	                    } else {
	                      if (shapex1 > shapex0) xanchor = "left";
	                      else if (shapex1 < shapex0) xanchor = "right";
	                      else xanchor = "center";
	                    }
	                  } else {
	                    xanchor = "center";
	                  }
	                }
	                var paddingConstantsX = {
	                  left: 1,
	                  center: 0,
	                  right: -1
	                };
	                var paddingConstantsY = {
	                  bottom: -1,
	                  middle: 0,
	                  top: 1
	                };
	                if (textAngle === "auto") {
	                  var paddingDirection = paddingConstantsY[yanchor];
	                  paddingX = -textPadding * sinA * paddingDirection;
	                  paddingY = textPadding * cosA * paddingDirection;
	                } else {
	                  var paddingDirectionX = paddingConstantsX[xanchor];
	                  var paddingDirectionY = paddingConstantsY[yanchor];
	                  paddingX = textPadding * paddingDirectionX;
	                  paddingY = textPadding * paddingDirectionY;
	                }
	                textx = textx + paddingX;
	                texty = texty + paddingY;
	              } else {
	                paddingX = textPadding + 3;
	                if (textPosition.indexOf("right") !== -1) {
	                  textx = Math.max(shapex0, shapex1) - paddingX;
	                  if (xanchor === "auto") xanchor = "right";
	                } else if (textPosition.indexOf("left") !== -1) {
	                  textx = Math.min(shapex0, shapex1) + paddingX;
	                  if (xanchor === "auto") xanchor = "left";
	                } else {
	                  textx = (shapex0 + shapex1) / 2;
	                  if (xanchor === "auto") xanchor = "center";
	                }
	                if (textPosition.indexOf("top") !== -1) {
	                  texty = Math.min(shapey0, shapey1);
	                } else if (textPosition.indexOf("bottom") !== -1) {
	                  texty = Math.max(shapey0, shapey1);
	                } else {
	                  texty = (shapey0 + shapey1) / 2;
	                }
	                paddingY = textPadding;
	                if (yanchor === "bottom") {
	                  texty = texty - paddingY;
	                } else if (yanchor === "top") {
	                  texty = texty + paddingY;
	                }
	              }
	              var shiftFraction = FROM_TL[yanchor];
	              var baselineAdjust = shapeOptions.label.font.size;
	              var textHeight = textBB.height;
	              var xshift = (textHeight * shiftFraction - baselineAdjust) * sinA;
	              var yshift = -(textHeight * shiftFraction - baselineAdjust) * cosA;
	              return {
	                textx: textx + xshift,
	                texty: texty + yshift,
	                xanchor
	              };
	            }
	          }
	        ),
	        /***/
	        42359: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var dragElement = __webpack_require__2(28569);
	            var dragHelpers = __webpack_require__2(64505);
	            var drawMode = dragHelpers.drawMode;
	            var selectMode = dragHelpers.selectMode;
	            var Registry = __webpack_require__2(73972);
	            var Color = __webpack_require__2(7901);
	            var constants = __webpack_require__2(89995);
	            var i000 = constants.i000;
	            var i090 = constants.i090;
	            var i180 = constants.i180;
	            var i270 = constants.i270;
	            var handleOutline = __webpack_require__2(51873);
	            var clearOutlineControllers = handleOutline.clearOutlineControllers;
	            var helpers = __webpack_require__2(60165);
	            var pointsOnRectangle = helpers.pointsOnRectangle;
	            var pointsOnEllipse = helpers.pointsOnEllipse;
	            var writePaths = helpers.writePaths;
	            var newShapes = __webpack_require__2(90551).newShapes;
	            var createShapeObj = __webpack_require__2(90551).createShapeObj;
	            var newSelections = __webpack_require__2(35855);
	            var drawLabel = __webpack_require__2(48100);
	            module2.exports = function displayOutlines(polygons, outlines, dragOptions, nCalls) {
	              if (!nCalls) nCalls = 0;
	              var gd = dragOptions.gd;
	              function redraw() {
	                displayOutlines(polygons, outlines, dragOptions, nCalls++);
	                if (pointsOnEllipse(polygons[0]) || dragOptions.hasText) {
	                  update({
	                    redrawing: true
	                  });
	                }
	              }
	              function update(opts) {
	                var updateObject = {};
	                if (dragOptions.isActiveShape !== undefined) {
	                  dragOptions.isActiveShape = false;
	                  updateObject = newShapes(outlines, dragOptions);
	                }
	                if (dragOptions.isActiveSelection !== undefined) {
	                  dragOptions.isActiveSelection = false;
	                  updateObject = newSelections(outlines, dragOptions);
	                  gd._fullLayout._reselect = true;
	                }
	                if (Object.keys(updateObject).length) {
	                  Registry.call((opts || {}).redrawing ? "relayout" : "_guiRelayout", gd, updateObject);
	                }
	              }
	              var fullLayout = gd._fullLayout;
	              var zoomLayer = fullLayout._zoomlayer;
	              var dragmode = dragOptions.dragmode;
	              var isDrawMode = drawMode(dragmode);
	              var isSelectMode = selectMode(dragmode);
	              if (isDrawMode || isSelectMode) {
	                gd._fullLayout._outlining = true;
	              }
	              clearOutlineControllers(gd);
	              outlines.attr("d", writePaths(polygons));
	              var vertexDragOptions;
	              var groupDragOptions;
	              var indexI;
	              var indexJ;
	              var copyPolygons;
	              if (!nCalls && (dragOptions.isActiveShape || dragOptions.isActiveSelection)) {
	                copyPolygons = recordPositions([], polygons);
	                var g = zoomLayer.append("g").attr("class", "outline-controllers");
	                addVertexControllers(g);
	                addGroupControllers();
	              }
	              if (isDrawMode && dragOptions.hasText) {
	                var shapeGroup = zoomLayer.select(".label-temp");
	                var shapeOptions = createShapeObj(outlines, dragOptions, dragOptions.dragmode);
	                drawLabel(gd, "label-temp", shapeOptions, shapeGroup);
	              }
	              function startDragVertex(evt) {
	                indexI = +evt.srcElement.getAttribute("data-i");
	                indexJ = +evt.srcElement.getAttribute("data-j");
	                vertexDragOptions[indexI][indexJ].moveFn = moveVertexController;
	              }
	              function moveVertexController(dx, dy) {
	                if (!polygons.length) return;
	                var x0 = copyPolygons[indexI][indexJ][1];
	                var y0 = copyPolygons[indexI][indexJ][2];
	                var cell = polygons[indexI];
	                var len = cell.length;
	                if (pointsOnRectangle(cell)) {
	                  var _dx = dx;
	                  var _dy = dy;
	                  if (dragOptions.isActiveSelection) {
	                    var nextPoint = getNextPoint(cell, indexJ);
	                    if (nextPoint[1] === cell[indexJ][1]) {
	                      _dy = 0;
	                    } else {
	                      _dx = 0;
	                    }
	                  }
	                  for (var q = 0; q < len; q++) {
	                    if (q === indexJ) continue;
	                    var pos = cell[q];
	                    if (pos[1] === cell[indexJ][1]) {
	                      pos[1] = x0 + _dx;
	                    }
	                    if (pos[2] === cell[indexJ][2]) {
	                      pos[2] = y0 + _dy;
	                    }
	                  }
	                  cell[indexJ][1] = x0 + _dx;
	                  cell[indexJ][2] = y0 + _dy;
	                  if (!pointsOnRectangle(cell)) {
	                    for (var j = 0; j < len; j++) {
	                      for (var k = 0; k < cell[j].length; k++) {
	                        cell[j][k] = copyPolygons[indexI][j][k];
	                      }
	                    }
	                  }
	                } else {
	                  cell[indexJ][1] = x0 + dx;
	                  cell[indexJ][2] = y0 + dy;
	                }
	                redraw();
	              }
	              function endDragVertexController() {
	                update();
	              }
	              function removeVertex() {
	                if (!polygons.length) return;
	                if (!polygons[indexI]) return;
	                if (!polygons[indexI].length) return;
	                var newPolygon = [];
	                for (var j = 0; j < polygons[indexI].length; j++) {
	                  if (j !== indexJ) {
	                    newPolygon.push(polygons[indexI][j]);
	                  }
	                }
	                if (newPolygon.length > 1 && !(newPolygon.length === 2 && newPolygon[1][0] === "Z")) {
	                  if (indexJ === 0) {
	                    newPolygon[0][0] = "M";
	                  }
	                  polygons[indexI] = newPolygon;
	                  redraw();
	                  update();
	                }
	              }
	              function clickVertexController(numClicks, evt) {
	                if (numClicks === 2) {
	                  indexI = +evt.srcElement.getAttribute("data-i");
	                  indexJ = +evt.srcElement.getAttribute("data-j");
	                  var cell = polygons[indexI];
	                  if (!pointsOnRectangle(cell) && !pointsOnEllipse(cell)) {
	                    removeVertex();
	                  }
	                }
	              }
	              function addVertexControllers(g2) {
	                vertexDragOptions = [];
	                for (var i = 0; i < polygons.length; i++) {
	                  var cell = polygons[i];
	                  var onRect = pointsOnRectangle(cell);
	                  var onEllipse = !onRect && pointsOnEllipse(cell);
	                  vertexDragOptions[i] = [];
	                  var len = cell.length;
	                  for (var j = 0; j < len; j++) {
	                    if (cell[j][0] === "Z") continue;
	                    if (onEllipse && j !== i000 && j !== i090 && j !== i180 && j !== i270) {
	                      continue;
	                    }
	                    var rectSelection = onRect && dragOptions.isActiveSelection;
	                    var nextPoint;
	                    if (rectSelection) nextPoint = getNextPoint(cell, j);
	                    var x = cell[j][1];
	                    var y = cell[j][2];
	                    var vertex = g2.append(rectSelection ? "rect" : "circle").attr("data-i", i).attr("data-j", j).style({
	                      fill: Color.background,
	                      stroke: Color.defaultLine,
	                      "stroke-width": 1,
	                      "shape-rendering": "crispEdges"
	                    });
	                    if (rectSelection) {
	                      var dx = nextPoint[1] - x;
	                      var dy = nextPoint[2] - y;
	                      var width = dy ? 5 : Math.max(Math.min(25, Math.abs(dx) - 5), 5);
	                      var height = dx ? 5 : Math.max(Math.min(25, Math.abs(dy) - 5), 5);
	                      vertex.classed(dy ? "cursor-ew-resize" : "cursor-ns-resize", true).attr("width", width).attr("height", height).attr("x", x - width / 2).attr("y", y - height / 2).attr("transform", strTranslate(dx / 2, dy / 2));
	                    } else {
	                      vertex.classed("cursor-grab", true).attr("r", 5).attr("cx", x).attr("cy", y);
	                    }
	                    vertexDragOptions[i][j] = {
	                      element: vertex.node(),
	                      gd,
	                      prepFn: startDragVertex,
	                      doneFn: endDragVertexController,
	                      clickFn: clickVertexController
	                    };
	                    dragElement.init(vertexDragOptions[i][j]);
	                  }
	                }
	              }
	              function moveGroup(dx, dy) {
	                if (!polygons.length) return;
	                for (var i = 0; i < polygons.length; i++) {
	                  for (var j = 0; j < polygons[i].length; j++) {
	                    for (var k = 0; k + 2 < polygons[i][j].length; k += 2) {
	                      polygons[i][j][k + 1] = copyPolygons[i][j][k + 1] + dx;
	                      polygons[i][j][k + 2] = copyPolygons[i][j][k + 2] + dy;
	                    }
	                  }
	                }
	              }
	              function moveGroupController(dx, dy) {
	                moveGroup(dx, dy);
	                redraw();
	              }
	              function startDragGroupController(evt) {
	                indexI = +evt.srcElement.getAttribute("data-i");
	                if (!indexI) indexI = 0;
	                groupDragOptions[indexI].moveFn = moveGroupController;
	              }
	              function endDragGroupController() {
	                update();
	              }
	              function clickGroupController(numClicks) {
	                if (numClicks === 2) {
	                  eraseActiveSelection(gd);
	                }
	              }
	              function addGroupControllers() {
	                groupDragOptions = [];
	                if (!polygons.length) return;
	                var i = 0;
	                groupDragOptions[i] = {
	                  element: outlines[0][0],
	                  gd,
	                  prepFn: startDragGroupController,
	                  doneFn: endDragGroupController,
	                  clickFn: clickGroupController
	                };
	                dragElement.init(groupDragOptions[i]);
	              }
	            };
	            function recordPositions(polygonsOut, polygonsIn) {
	              for (var i = 0; i < polygonsIn.length; i++) {
	                var cell = polygonsIn[i];
	                polygonsOut[i] = [];
	                for (var j = 0; j < cell.length; j++) {
	                  polygonsOut[i][j] = [];
	                  for (var k = 0; k < cell[j].length; k++) {
	                    polygonsOut[i][j][k] = cell[j][k];
	                  }
	                }
	              }
	              return polygonsOut;
	            }
	            function getNextPoint(cell, j) {
	              var x = cell[j][1];
	              var y = cell[j][2];
	              var len = cell.length;
	              var nextJ, nextX, nextY;
	              nextJ = (j + 1) % len;
	              nextX = cell[nextJ][1];
	              nextY = cell[nextJ][2];
	              if (nextX === x && nextY === y) {
	                nextJ = (j + 2) % len;
	                nextX = cell[nextJ][1];
	                nextY = cell[nextJ][2];
	              }
	              return [nextJ, nextX, nextY];
	            }
	            function eraseActiveSelection(gd) {
	              if (!selectMode(gd._fullLayout.dragmode)) return;
	              clearOutlineControllers(gd);
	              var id = gd._fullLayout._activeSelectionIndex;
	              var selections = (gd.layout || {}).selections || [];
	              if (id < selections.length) {
	                var list = [];
	                for (var q = 0; q < selections.length; q++) {
	                  if (q !== id) {
	                    list.push(selections[q]);
	                  }
	                }
	                delete gd._fullLayout._activeSelectionIndex;
	                var erasedSelection = gd._fullLayout.selections[id];
	                gd._fullLayout._deselect = {
	                  xref: erasedSelection.xref,
	                  yref: erasedSelection.yref
	                };
	                Registry.call("_guiRelayout", gd, {
	                  selections: list
	                });
	              }
	            }
	          }
	        ),
	        /***/
	        34031: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var readPaths = __webpack_require__2(60165).readPaths;
	            var displayOutlines = __webpack_require__2(42359);
	            var drawLabel = __webpack_require__2(48100);
	            var clearOutlineControllers = __webpack_require__2(51873).clearOutlineControllers;
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var arrayEditor = __webpack_require__2(44467).arrayEditor;
	            var dragElement = __webpack_require__2(28569);
	            var setCursor = __webpack_require__2(6964);
	            var constants = __webpack_require__2(21459);
	            var helpers = __webpack_require__2(30477);
	            var getPathString = helpers.getPathString;
	            module2.exports = {
	              draw,
	              drawOne,
	              eraseActiveShape,
	              drawLabel
	            };
	            function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              fullLayout._shapeUpperLayer.selectAll("path").remove();
	              fullLayout._shapeLowerLayer.selectAll("path").remove();
	              fullLayout._shapeUpperLayer.selectAll("text").remove();
	              fullLayout._shapeLowerLayer.selectAll("text").remove();
	              for (var k in fullLayout._plots) {
	                var shapelayer = fullLayout._plots[k].shapelayer;
	                if (shapelayer) {
	                  shapelayer.selectAll("path").remove();
	                  shapelayer.selectAll("text").remove();
	                }
	              }
	              for (var i = 0; i < fullLayout.shapes.length; i++) {
	                if (fullLayout.shapes[i].visible === true) {
	                  drawOne(gd, i);
	                }
	              }
	            }
	            function shouldSkipEdits(gd) {
	              return !!gd._fullLayout._outlining;
	            }
	            function couldHaveActiveShape(gd) {
	              return !gd._context.edits.shapePosition;
	            }
	            function drawOne(gd, index) {
	              gd._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + index + '"]').remove();
	              var o = helpers.makeShapesOptionsAndPlotinfo(gd, index);
	              var options = o.options;
	              var plotinfo = o.plotinfo;
	              if (!options._input || options.visible !== true) return;
	              if (options.layer !== "below") {
	                drawShape(gd._fullLayout._shapeUpperLayer);
	              } else if (options.xref === "paper" || options.yref === "paper") {
	                drawShape(gd._fullLayout._shapeLowerLayer);
	              } else {
	                if (plotinfo._hadPlotinfo) {
	                  var mainPlot = plotinfo.mainplotinfo || plotinfo;
	                  drawShape(mainPlot.shapelayer);
	                } else {
	                  drawShape(gd._fullLayout._shapeLowerLayer);
	                }
	              }
	              function drawShape(shapeLayer) {
	                var d = getPathString(gd, options);
	                var attrs = {
	                  "data-index": index,
	                  "fill-rule": options.fillrule,
	                  d
	                };
	                var opacity = options.opacity;
	                var fillColor = options.fillcolor;
	                var lineColor = options.line.width ? options.line.color : "rgba(0,0,0,0)";
	                var lineWidth = options.line.width;
	                var lineDash = options.line.dash;
	                if (!lineWidth && options.editable === true) {
	                  lineWidth = 5;
	                  lineDash = "solid";
	                }
	                var isOpen = d[d.length - 1] !== "Z";
	                var isActiveShape = couldHaveActiveShape(gd) && options.editable && gd._fullLayout._activeShapeIndex === index;
	                if (isActiveShape) {
	                  fillColor = isOpen ? "rgba(0,0,0,0)" : gd._fullLayout.activeshape.fillcolor;
	                  opacity = gd._fullLayout.activeshape.opacity;
	                }
	                var shapeGroup = shapeLayer.append("g").classed("shape-group", true).attr({
	                  "data-index": index
	                });
	                var path = shapeGroup.append("path").attr(attrs).style("opacity", opacity).call(Color.stroke, lineColor).call(Color.fill, fillColor).call(Drawing.dashLine, lineDash, lineWidth);
	                setClipPath(shapeGroup, gd, options);
	                drawLabel(gd, index, options, shapeGroup);
	                var editHelpers;
	                if (isActiveShape || gd._context.edits.shapePosition) editHelpers = arrayEditor(gd.layout, "shapes", options);
	                if (isActiveShape) {
	                  path.style({
	                    cursor: "move"
	                  });
	                  var dragOptions = {
	                    element: path.node(),
	                    plotinfo,
	                    gd,
	                    editHelpers,
	                    hasText: options.label.text || options.label.texttemplate,
	                    isActiveShape: true
	                    // i.e. to enable controllers
	                  };
	                  var polygons = readPaths(d, gd);
	                  displayOutlines(polygons, path, dragOptions);
	                } else {
	                  if (gd._context.edits.shapePosition) {
	                    setupDragElement(gd, path, options, index, shapeLayer, editHelpers);
	                  } else if (options.editable === true) {
	                    path.style("pointer-events", isOpen || Color.opacity(fillColor) * opacity <= 0.5 ? "stroke" : "all");
	                  }
	                }
	                path.node().addEventListener("click", function() {
	                  return activateShape(gd, path);
	                });
	              }
	            }
	            function setClipPath(shapePath, gd, shapeOptions) {
	              var clipAxes = (shapeOptions.xref + shapeOptions.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
	              Drawing.setClipUrl(shapePath, clipAxes ? "clip" + gd._fullLayout._uid + clipAxes : null, gd);
	            }
	            function setupDragElement(gd, shapePath, shapeOptions, index, shapeLayer, editHelpers) {
	              var MINWIDTH = 10;
	              var MINHEIGHT = 10;
	              var xPixelSized = shapeOptions.xsizemode === "pixel";
	              var yPixelSized = shapeOptions.ysizemode === "pixel";
	              var isLine = shapeOptions.type === "line";
	              var isPath = shapeOptions.type === "path";
	              var modifyItem = editHelpers.modifyItem;
	              var x0, y0, x1, y1, xAnchor, yAnchor;
	              var n0, s0, w0, e0, optN, optS, optW, optE;
	              var pathIn;
	              var shapeGroup = d3.select(shapePath.node().parentNode);
	              var xa = Axes.getFromId(gd, shapeOptions.xref);
	              var xRefType = Axes.getRefType(shapeOptions.xref);
	              var ya = Axes.getFromId(gd, shapeOptions.yref);
	              var yRefType = Axes.getRefType(shapeOptions.yref);
	              var x2p = helpers.getDataToPixel(gd, xa, false, xRefType);
	              var y2p = helpers.getDataToPixel(gd, ya, true, yRefType);
	              var p2x = helpers.getPixelToData(gd, xa, false, xRefType);
	              var p2y = helpers.getPixelToData(gd, ya, true, yRefType);
	              var sensoryElement = obtainSensoryElement();
	              var dragOptions = {
	                element: sensoryElement.node(),
	                gd,
	                prepFn: startDrag,
	                doneFn: endDrag,
	                clickFn: abortDrag
	              };
	              var dragMode;
	              dragElement.init(dragOptions);
	              sensoryElement.node().onmousemove = updateDragMode;
	              function obtainSensoryElement() {
	                return isLine ? createLineDragHandles() : shapePath;
	              }
	              function createLineDragHandles() {
	                var minSensoryWidth = 10;
	                var sensoryWidth = Math.max(shapeOptions.line.width, minSensoryWidth);
	                var g = shapeLayer.append("g").attr("data-index", index).attr("drag-helper", true);
	                g.append("path").attr("d", shapePath.attr("d")).style({
	                  cursor: "move",
	                  "stroke-width": sensoryWidth,
	                  "stroke-opacity": "0"
	                  // ensure not visible
	                });
	                var circleStyle = {
	                  "fill-opacity": "0"
	                  // ensure not visible
	                };
	                var circleRadius = Math.max(sensoryWidth / 2, minSensoryWidth);
	                g.append("circle").attr({
	                  "data-line-point": "start-point",
	                  cx: xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x0 : x2p(shapeOptions.x0),
	                  cy: yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y0 : y2p(shapeOptions.y0),
	                  r: circleRadius
	                }).style(circleStyle).classed("cursor-grab", true);
	                g.append("circle").attr({
	                  "data-line-point": "end-point",
	                  cx: xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x1 : x2p(shapeOptions.x1),
	                  cy: yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y1 : y2p(shapeOptions.y1),
	                  r: circleRadius
	                }).style(circleStyle).classed("cursor-grab", true);
	                return g;
	              }
	              function updateDragMode(evt) {
	                if (shouldSkipEdits(gd)) {
	                  dragMode = null;
	                  return;
	                }
	                if (isLine) {
	                  if (evt.target.tagName === "path") {
	                    dragMode = "move";
	                  } else {
	                    dragMode = evt.target.attributes["data-line-point"].value === "start-point" ? "resize-over-start-point" : "resize-over-end-point";
	                  }
	                } else {
	                  var dragBBox = dragOptions.element.getBoundingClientRect();
	                  var w = dragBBox.right - dragBBox.left;
	                  var h = dragBBox.bottom - dragBBox.top;
	                  var x = evt.clientX - dragBBox.left;
	                  var y = evt.clientY - dragBBox.top;
	                  var cursor = !isPath && w > MINWIDTH && h > MINHEIGHT && !evt.shiftKey ? dragElement.getCursor(x / w, 1 - y / h) : "move";
	                  setCursor(shapePath, cursor);
	                  dragMode = cursor.split("-")[0];
	                }
	              }
	              function startDrag(evt) {
	                if (shouldSkipEdits(gd)) return;
	                if (xPixelSized) {
	                  xAnchor = x2p(shapeOptions.xanchor);
	                }
	                if (yPixelSized) {
	                  yAnchor = y2p(shapeOptions.yanchor);
	                }
	                if (shapeOptions.type === "path") {
	                  pathIn = shapeOptions.path;
	                } else {
	                  x0 = xPixelSized ? shapeOptions.x0 : x2p(shapeOptions.x0);
	                  y0 = yPixelSized ? shapeOptions.y0 : y2p(shapeOptions.y0);
	                  x1 = xPixelSized ? shapeOptions.x1 : x2p(shapeOptions.x1);
	                  y1 = yPixelSized ? shapeOptions.y1 : y2p(shapeOptions.y1);
	                }
	                if (x0 < x1) {
	                  w0 = x0;
	                  optW = "x0";
	                  e0 = x1;
	                  optE = "x1";
	                } else {
	                  w0 = x1;
	                  optW = "x1";
	                  e0 = x0;
	                  optE = "x0";
	                }
	                if (!yPixelSized && y0 < y1 || yPixelSized && y0 > y1) {
	                  n0 = y0;
	                  optN = "y0";
	                  s0 = y1;
	                  optS = "y1";
	                } else {
	                  n0 = y1;
	                  optN = "y1";
	                  s0 = y0;
	                  optS = "y0";
	                }
	                updateDragMode(evt);
	                renderVisualCues(shapeLayer, shapeOptions);
	                deactivateClipPathTemporarily(shapePath, shapeOptions, gd);
	                dragOptions.moveFn = dragMode === "move" ? moveShape : resizeShape;
	                dragOptions.altKey = evt.altKey;
	              }
	              function endDrag() {
	                if (shouldSkipEdits(gd)) return;
	                setCursor(shapePath);
	                removeVisualCues(shapeLayer);
	                setClipPath(shapePath, gd, shapeOptions);
	                Registry.call("_guiRelayout", gd, editHelpers.getUpdateObj());
	              }
	              function abortDrag() {
	                if (shouldSkipEdits(gd)) return;
	                removeVisualCues(shapeLayer);
	              }
	              function moveShape(dx, dy) {
	                if (shapeOptions.type === "path") {
	                  var noOp = function(coord) {
	                    return coord;
	                  };
	                  var moveX = noOp;
	                  var moveY = noOp;
	                  if (xPixelSized) {
	                    modifyItem("xanchor", shapeOptions.xanchor = p2x(xAnchor + dx));
	                  } else {
	                    moveX = function moveX2(x) {
	                      return p2x(x2p(x) + dx);
	                    };
	                    if (xa && xa.type === "date") moveX = helpers.encodeDate(moveX);
	                  }
	                  if (yPixelSized) {
	                    modifyItem("yanchor", shapeOptions.yanchor = p2y(yAnchor + dy));
	                  } else {
	                    moveY = function moveY2(y) {
	                      return p2y(y2p(y) + dy);
	                    };
	                    if (ya && ya.type === "date") moveY = helpers.encodeDate(moveY);
	                  }
	                  modifyItem("path", shapeOptions.path = movePath(pathIn, moveX, moveY));
	                } else {
	                  if (xPixelSized) {
	                    modifyItem("xanchor", shapeOptions.xanchor = p2x(xAnchor + dx));
	                  } else {
	                    modifyItem("x0", shapeOptions.x0 = p2x(x0 + dx));
	                    modifyItem("x1", shapeOptions.x1 = p2x(x1 + dx));
	                  }
	                  if (yPixelSized) {
	                    modifyItem("yanchor", shapeOptions.yanchor = p2y(yAnchor + dy));
	                  } else {
	                    modifyItem("y0", shapeOptions.y0 = p2y(y0 + dy));
	                    modifyItem("y1", shapeOptions.y1 = p2y(y1 + dy));
	                  }
	                }
	                shapePath.attr("d", getPathString(gd, shapeOptions));
	                renderVisualCues(shapeLayer, shapeOptions);
	                drawLabel(gd, index, shapeOptions, shapeGroup);
	              }
	              function resizeShape(dx, dy) {
	                if (isPath) {
	                  var noOp = function(coord) {
	                    return coord;
	                  };
	                  var moveX = noOp;
	                  var moveY = noOp;
	                  if (xPixelSized) {
	                    modifyItem("xanchor", shapeOptions.xanchor = p2x(xAnchor + dx));
	                  } else {
	                    moveX = function moveX2(x) {
	                      return p2x(x2p(x) + dx);
	                    };
	                    if (xa && xa.type === "date") moveX = helpers.encodeDate(moveX);
	                  }
	                  if (yPixelSized) {
	                    modifyItem("yanchor", shapeOptions.yanchor = p2y(yAnchor + dy));
	                  } else {
	                    moveY = function moveY2(y) {
	                      return p2y(y2p(y) + dy);
	                    };
	                    if (ya && ya.type === "date") moveY = helpers.encodeDate(moveY);
	                  }
	                  modifyItem("path", shapeOptions.path = movePath(pathIn, moveX, moveY));
	                } else if (isLine) {
	                  if (dragMode === "resize-over-start-point") {
	                    var newX0 = x0 + dx;
	                    var newY0 = yPixelSized ? y0 - dy : y0 + dy;
	                    modifyItem("x0", shapeOptions.x0 = xPixelSized ? newX0 : p2x(newX0));
	                    modifyItem("y0", shapeOptions.y0 = yPixelSized ? newY0 : p2y(newY0));
	                  } else if (dragMode === "resize-over-end-point") {
	                    var newX1 = x1 + dx;
	                    var newY1 = yPixelSized ? y1 - dy : y1 + dy;
	                    modifyItem("x1", shapeOptions.x1 = xPixelSized ? newX1 : p2x(newX1));
	                    modifyItem("y1", shapeOptions.y1 = yPixelSized ? newY1 : p2y(newY1));
	                  }
	                } else {
	                  var has = function(str) {
	                    return dragMode.indexOf(str) !== -1;
	                  };
	                  var hasN = has("n");
	                  var hasS = has("s");
	                  var hasW = has("w");
	                  var hasE = has("e");
	                  var newN = hasN ? n0 + dy : n0;
	                  var newS = hasS ? s0 + dy : s0;
	                  var newW = hasW ? w0 + dx : w0;
	                  var newE = hasE ? e0 + dx : e0;
	                  if (yPixelSized) {
	                    if (hasN) newN = n0 - dy;
	                    if (hasS) newS = s0 - dy;
	                  }
	                  if (!yPixelSized && newS - newN > MINHEIGHT || yPixelSized && newN - newS > MINHEIGHT) {
	                    modifyItem(optN, shapeOptions[optN] = yPixelSized ? newN : p2y(newN));
	                    modifyItem(optS, shapeOptions[optS] = yPixelSized ? newS : p2y(newS));
	                  }
	                  if (newE - newW > MINWIDTH) {
	                    modifyItem(optW, shapeOptions[optW] = xPixelSized ? newW : p2x(newW));
	                    modifyItem(optE, shapeOptions[optE] = xPixelSized ? newE : p2x(newE));
	                  }
	                }
	                shapePath.attr("d", getPathString(gd, shapeOptions));
	                renderVisualCues(shapeLayer, shapeOptions);
	                drawLabel(gd, index, shapeOptions, shapeGroup);
	              }
	              function renderVisualCues(shapeLayer2, shapeOptions2) {
	                if (xPixelSized || yPixelSized) {
	                  renderAnchor();
	                }
	                function renderAnchor() {
	                  var isNotPath = shapeOptions2.type !== "path";
	                  var visualCues = shapeLayer2.selectAll(".visual-cue").data([0]);
	                  var strokeWidth = 1;
	                  visualCues.enter().append("path").attr({
	                    fill: "#fff",
	                    "fill-rule": "evenodd",
	                    stroke: "#000",
	                    "stroke-width": strokeWidth
	                  }).classed("visual-cue", true);
	                  var posX = x2p(xPixelSized ? shapeOptions2.xanchor : Lib.midRange(isNotPath ? [shapeOptions2.x0, shapeOptions2.x1] : helpers.extractPathCoords(shapeOptions2.path, constants.paramIsX)));
	                  var posY = y2p(yPixelSized ? shapeOptions2.yanchor : Lib.midRange(isNotPath ? [shapeOptions2.y0, shapeOptions2.y1] : helpers.extractPathCoords(shapeOptions2.path, constants.paramIsY)));
	                  posX = helpers.roundPositionForSharpStrokeRendering(posX, strokeWidth);
	                  posY = helpers.roundPositionForSharpStrokeRendering(posY, strokeWidth);
	                  if (xPixelSized && yPixelSized) {
	                    var crossPath = "M" + (posX - 1 - strokeWidth) + "," + (posY - 1 - strokeWidth) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
	                    visualCues.attr("d", crossPath);
	                  } else if (xPixelSized) {
	                    var vBarPath = "M" + (posX - 1 - strokeWidth) + "," + (posY - 9 - strokeWidth) + "v18 h2 v-18 Z";
	                    visualCues.attr("d", vBarPath);
	                  } else {
	                    var hBarPath = "M" + (posX - 9 - strokeWidth) + "," + (posY - 1 - strokeWidth) + "h18 v2 h-18 Z";
	                    visualCues.attr("d", hBarPath);
	                  }
	                }
	              }
	              function removeVisualCues(shapeLayer2) {
	                shapeLayer2.selectAll(".visual-cue").remove();
	              }
	              function deactivateClipPathTemporarily(shapePath2, shapeOptions2, gd2) {
	                var xref = shapeOptions2.xref;
	                var yref = shapeOptions2.yref;
	                var xa2 = Axes.getFromId(gd2, xref);
	                var ya2 = Axes.getFromId(gd2, yref);
	                var clipAxes = "";
	                if (xref !== "paper" && !xa2.autorange) clipAxes += xref;
	                if (yref !== "paper" && !ya2.autorange) clipAxes += yref;
	                Drawing.setClipUrl(shapePath2, clipAxes ? "clip" + gd2._fullLayout._uid + clipAxes : null, gd2);
	              }
	            }
	            function movePath(pathIn, moveX, moveY) {
	              return pathIn.replace(constants.segmentRE, function(segment) {
	                var paramNumber = 0;
	                var segmentType = segment.charAt(0);
	                var xParams = constants.paramIsX[segmentType];
	                var yParams = constants.paramIsY[segmentType];
	                var nParams = constants.numParams[segmentType];
	                var paramString = segment.substr(1).replace(constants.paramRE, function(param) {
	                  if (paramNumber >= nParams) return param;
	                  if (xParams[paramNumber]) param = moveX(param);
	                  else if (yParams[paramNumber]) param = moveY(param);
	                  paramNumber++;
	                  return param;
	                });
	                return segmentType + paramString;
	              });
	            }
	            function activateShape(gd, path) {
	              if (!couldHaveActiveShape(gd)) return;
	              var element = path.node();
	              var id = +element.getAttribute("data-index");
	              if (id >= 0) {
	                if (id === gd._fullLayout._activeShapeIndex) {
	                  deactivateShape(gd);
	                  return;
	                }
	                gd._fullLayout._activeShapeIndex = id;
	                gd._fullLayout._deactivateShape = deactivateShape;
	                draw(gd);
	              }
	            }
	            function deactivateShape(gd) {
	              if (!couldHaveActiveShape(gd)) return;
	              var id = gd._fullLayout._activeShapeIndex;
	              if (id >= 0) {
	                clearOutlineControllers(gd);
	                delete gd._fullLayout._activeShapeIndex;
	                draw(gd);
	              }
	            }
	            function eraseActiveShape(gd) {
	              if (!couldHaveActiveShape(gd)) return;
	              clearOutlineControllers(gd);
	              var id = gd._fullLayout._activeShapeIndex;
	              var shapes = (gd.layout || {}).shapes || [];
	              if (id < shapes.length) {
	                var list = [];
	                for (var q = 0; q < shapes.length; q++) {
	                  if (q !== id) {
	                    list.push(shapes[q]);
	                  }
	                }
	                delete gd._fullLayout._activeShapeIndex;
	                return Registry.call("_guiRelayout", gd, {
	                  shapes: list
	                });
	              }
	            }
	          }
	        ),
	        /***/
	        29241: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var basePlotAttributes = __webpack_require__2(9012);
	            var fontAttrs = __webpack_require__2(41940);
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var shapeTexttemplateAttrs = __webpack_require__2(5386).R;
	            var shapeLabelTexttemplateVars = __webpack_require__2(37281);
	            module2.exports = overrideAll({
	              newshape: {
	                visible: extendFlat({}, basePlotAttributes.visible, {}),
	                showlegend: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                legend: extendFlat({}, basePlotAttributes.legend, {}),
	                legendgroup: extendFlat({}, basePlotAttributes.legendgroup, {}),
	                legendgrouptitle: {
	                  text: extendFlat({}, basePlotAttributes.legendgrouptitle.text, {}),
	                  font: fontAttrs({})
	                },
	                legendrank: extendFlat({}, basePlotAttributes.legendrank, {}),
	                legendwidth: extendFlat({}, basePlotAttributes.legendwidth, {}),
	                line: {
	                  color: {
	                    valType: "color"
	                  },
	                  width: {
	                    valType: "number",
	                    min: 0,
	                    dflt: 4
	                  },
	                  dash: extendFlat({}, dash, {
	                    dflt: "solid"
	                  })
	                },
	                fillcolor: {
	                  valType: "color",
	                  dflt: "rgba(0,0,0,0)"
	                },
	                fillrule: {
	                  valType: "enumerated",
	                  values: ["evenodd", "nonzero"],
	                  dflt: "evenodd"
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                },
	                layer: {
	                  valType: "enumerated",
	                  values: ["below", "above"],
	                  dflt: "above"
	                },
	                drawdirection: {
	                  valType: "enumerated",
	                  values: ["ortho", "horizontal", "vertical", "diagonal"],
	                  dflt: "diagonal"
	                },
	                name: extendFlat({}, basePlotAttributes.name, {}),
	                label: {
	                  text: {
	                    valType: "string",
	                    dflt: ""
	                  },
	                  texttemplate: shapeTexttemplateAttrs({
	                    newshape: true
	                  }, {
	                    keys: Object.keys(shapeLabelTexttemplateVars)
	                  }),
	                  font: fontAttrs({}),
	                  textposition: {
	                    valType: "enumerated",
	                    values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"]
	                  },
	                  textangle: {
	                    valType: "angle",
	                    dflt: "auto"
	                  },
	                  xanchor: {
	                    valType: "enumerated",
	                    values: ["auto", "left", "center", "right"],
	                    dflt: "auto"
	                  },
	                  yanchor: {
	                    valType: "enumerated",
	                    values: ["top", "middle", "bottom"]
	                  },
	                  padding: {
	                    valType: "number",
	                    dflt: 3,
	                    min: 0
	                  }
	                }
	              },
	              activeshape: {
	                fillcolor: {
	                  valType: "color",
	                  dflt: "rgb(255,0,255)"
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.5
	                }
	              }
	            }, "none", "from-root");
	          }
	        ),
	        /***/
	        89995: (
	          /***/
	          function(module2) {
	            var CIRCLE_SIDES = 32;
	            module2.exports = {
	              CIRCLE_SIDES,
	              i000: 0,
	              i090: CIRCLE_SIDES / 4,
	              i180: CIRCLE_SIDES / 2,
	              i270: CIRCLE_SIDES / 4 * 3,
	              cos45: Math.cos(Math.PI / 4),
	              sin45: Math.sin(Math.PI / 4),
	              SQRT2: Math.sqrt(2)
	            };
	          }
	        ),
	        /***/
	        45547: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var Lib = __webpack_require__2(71828);
	            function dfltLabelYanchor(isLine, labelTextPosition) {
	              return isLine ? "bottom" : labelTextPosition.indexOf("top") !== -1 ? "top" : labelTextPosition.indexOf("bottom") !== -1 ? "bottom" : "middle";
	            }
	            module2.exports = function supplyDrawNewShapeDefaults(layoutIn, layoutOut, coerce) {
	              coerce("newshape.visible");
	              coerce("newshape.name");
	              coerce("newshape.showlegend");
	              coerce("newshape.legend");
	              coerce("newshape.legendwidth");
	              coerce("newshape.legendgroup");
	              coerce("newshape.legendgrouptitle.text");
	              Lib.coerceFont(coerce, "newshape.legendgrouptitle.font");
	              coerce("newshape.legendrank");
	              coerce("newshape.drawdirection");
	              coerce("newshape.layer");
	              coerce("newshape.fillcolor");
	              coerce("newshape.fillrule");
	              coerce("newshape.opacity");
	              var newshapeLineWidth = coerce("newshape.line.width");
	              if (newshapeLineWidth) {
	                var bgcolor = (layoutIn || {}).plot_bgcolor || "#FFF";
	                coerce("newshape.line.color", Color.contrast(bgcolor));
	                coerce("newshape.line.dash");
	              }
	              var isLine = layoutIn.dragmode === "drawline";
	              var labelText = coerce("newshape.label.text");
	              var labelTextTemplate = coerce("newshape.label.texttemplate");
	              if (labelText || labelTextTemplate) {
	                coerce("newshape.label.textangle");
	                var labelTextPosition = coerce("newshape.label.textposition", isLine ? "middle" : "middle center");
	                coerce("newshape.label.xanchor");
	                coerce("newshape.label.yanchor", dfltLabelYanchor(isLine, labelTextPosition));
	                coerce("newshape.label.padding");
	                Lib.coerceFont(coerce, "newshape.label.font", layoutOut.font);
	              }
	              coerce("activeshape.fillcolor");
	              coerce("activeshape.opacity");
	            };
	          }
	        ),
	        /***/
	        60165: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var parseSvgPath = __webpack_require__2(95616);
	            var constants = __webpack_require__2(89995);
	            var CIRCLE_SIDES = constants.CIRCLE_SIDES;
	            var SQRT2 = constants.SQRT2;
	            var cartesianHelpers = __webpack_require__2(75549);
	            var p2r = cartesianHelpers.p2r;
	            var r2p = cartesianHelpers.r2p;
	            var iC = [0, 3, 4, 5, 6, 1, 2];
	            var iQS = [0, 3, 4, 1, 2];
	            exports2.writePaths = function(polygons) {
	              var nI = polygons.length;
	              if (!nI) return "M0,0Z";
	              var str = "";
	              for (var i = 0; i < nI; i++) {
	                var nJ = polygons[i].length;
	                for (var j = 0; j < nJ; j++) {
	                  var w = polygons[i][j][0];
	                  if (w === "Z") {
	                    str += "Z";
	                  } else {
	                    var nK = polygons[i][j].length;
	                    for (var k = 0; k < nK; k++) {
	                      var realK = k;
	                      if (w === "Q" || w === "S") {
	                        realK = iQS[k];
	                      } else if (w === "C") {
	                        realK = iC[k];
	                      }
	                      str += polygons[i][j][realK];
	                      if (k > 0 && k < nK - 1) {
	                        str += ",";
	                      }
	                    }
	                  }
	                }
	              }
	              return str;
	            };
	            exports2.readPaths = function(str, gd, plotinfo, isActiveShape) {
	              var cmd = parseSvgPath(str);
	              var polys = [];
	              var n = -1;
	              var newPoly = function() {
	                n++;
	                polys[n] = [];
	              };
	              var k;
	              var x = 0;
	              var y = 0;
	              var initX;
	              var initY;
	              var recStart = function() {
	                initX = x;
	                initY = y;
	              };
	              recStart();
	              for (var i = 0; i < cmd.length; i++) {
	                var newPos = [];
	                var x1, x2, y1, y2;
	                var c = cmd[i][0];
	                var w = c;
	                switch (c) {
	                  case "M":
	                    newPoly();
	                    x = +cmd[i][1];
	                    y = +cmd[i][2];
	                    newPos.push([w, x, y]);
	                    recStart();
	                    break;
	                  case "Q":
	                  case "S":
	                    x1 = +cmd[i][1];
	                    y1 = +cmd[i][2];
	                    x = +cmd[i][3];
	                    y = +cmd[i][4];
	                    newPos.push([w, x, y, x1, y1]);
	                    break;
	                  case "C":
	                    x1 = +cmd[i][1];
	                    y1 = +cmd[i][2];
	                    x2 = +cmd[i][3];
	                    y2 = +cmd[i][4];
	                    x = +cmd[i][5];
	                    y = +cmd[i][6];
	                    newPos.push([w, x, y, x1, y1, x2, y2]);
	                    break;
	                  case "T":
	                  case "L":
	                    x = +cmd[i][1];
	                    y = +cmd[i][2];
	                    newPos.push([w, x, y]);
	                    break;
	                  case "H":
	                    w = "L";
	                    x = +cmd[i][1];
	                    newPos.push([w, x, y]);
	                    break;
	                  case "V":
	                    w = "L";
	                    y = +cmd[i][1];
	                    newPos.push([w, x, y]);
	                    break;
	                  case "A":
	                    w = "L";
	                    var rx = +cmd[i][1];
	                    var ry = +cmd[i][2];
	                    if (!+cmd[i][4]) {
	                      rx = -rx;
	                      ry = -ry;
	                    }
	                    var cenX = x - rx;
	                    var cenY = y;
	                    for (k = 1; k <= CIRCLE_SIDES / 2; k++) {
	                      var t = 2 * Math.PI * k / CIRCLE_SIDES;
	                      newPos.push([w, cenX + rx * Math.cos(t), cenY + ry * Math.sin(t)]);
	                    }
	                    break;
	                  case "Z":
	                    if (x !== initX || y !== initY) {
	                      x = initX;
	                      y = initY;
	                      newPos.push([w, x, y]);
	                    }
	                    break;
	                }
	                var domain = (plotinfo || {}).domain;
	                var size = gd._fullLayout._size;
	                var xPixelSized = plotinfo && plotinfo.xsizemode === "pixel";
	                var yPixelSized = plotinfo && plotinfo.ysizemode === "pixel";
	                var noOffset = isActiveShape === false;
	                for (var j = 0; j < newPos.length; j++) {
	                  for (k = 0; k + 2 < 7; k += 2) {
	                    var _x = newPos[j][k + 1];
	                    var _y = newPos[j][k + 2];
	                    if (_x === undefined || _y === undefined) continue;
	                    x = _x;
	                    y = _y;
	                    if (plotinfo) {
	                      if (plotinfo.xaxis && plotinfo.xaxis.p2r) {
	                        if (noOffset) _x -= plotinfo.xaxis._offset;
	                        if (xPixelSized) {
	                          _x = r2p(plotinfo.xaxis, plotinfo.xanchor) + _x;
	                        } else {
	                          _x = p2r(plotinfo.xaxis, _x);
	                        }
	                      } else {
	                        if (noOffset) _x -= size.l;
	                        if (domain) _x = domain.x[0] + _x / size.w;
	                        else _x = _x / size.w;
	                      }
	                      if (plotinfo.yaxis && plotinfo.yaxis.p2r) {
	                        if (noOffset) _y -= plotinfo.yaxis._offset;
	                        if (yPixelSized) {
	                          _y = r2p(plotinfo.yaxis, plotinfo.yanchor) - _y;
	                        } else {
	                          _y = p2r(plotinfo.yaxis, _y);
	                        }
	                      } else {
	                        if (noOffset) _y -= size.t;
	                        if (domain) _y = domain.y[1] - _y / size.h;
	                        else _y = 1 - _y / size.h;
	                      }
	                    }
	                    newPos[j][k + 1] = _x;
	                    newPos[j][k + 2] = _y;
	                  }
	                  polys[n].push(newPos[j].slice());
	                }
	              }
	              return polys;
	            };
	            function almostEq(a, b) {
	              return Math.abs(a - b) <= 1e-6;
	            }
	            function dist(a, b) {
	              var dx = b[1] - a[1];
	              var dy = b[2] - a[2];
	              return Math.sqrt(dx * dx + dy * dy);
	            }
	            exports2.pointsOnRectangle = function(cell) {
	              var len = cell.length;
	              if (len !== 5) return false;
	              for (var j = 1; j < 3; j++) {
	                var e01 = cell[0][j] - cell[1][j];
	                var e32 = cell[3][j] - cell[2][j];
	                if (!almostEq(e01, e32)) return false;
	                var e03 = cell[0][j] - cell[3][j];
	                var e12 = cell[1][j] - cell[2][j];
	                if (!almostEq(e03, e12)) return false;
	              }
	              if (!almostEq(cell[0][1], cell[1][1]) && !almostEq(cell[0][1], cell[3][1])) return false;
	              return !!(dist(cell[0], cell[1]) * dist(cell[0], cell[3]));
	            };
	            exports2.pointsOnEllipse = function(cell) {
	              var len = cell.length;
	              if (len !== CIRCLE_SIDES + 1) return false;
	              len = CIRCLE_SIDES;
	              for (var i = 0; i < len; i++) {
	                var k = (len * 2 - i) % len;
	                var k2 = (len / 2 + k) % len;
	                var i2 = (len / 2 + i) % len;
	                if (!almostEq(dist(cell[i], cell[i2]), dist(cell[k], cell[k2]))) return false;
	              }
	              return true;
	            };
	            exports2.handleEllipse = function(isEllipse, start, end) {
	              if (!isEllipse) return [start, end];
	              var pos = exports2.ellipseOver({
	                x0: start[0],
	                y0: start[1],
	                x1: end[0],
	                y1: end[1]
	              });
	              var cx = (pos.x1 + pos.x0) / 2;
	              var cy = (pos.y1 + pos.y0) / 2;
	              var rx = (pos.x1 - pos.x0) / 2;
	              var ry = (pos.y1 - pos.y0) / 2;
	              if (!rx) rx = ry = ry / SQRT2;
	              if (!ry) ry = rx = rx / SQRT2;
	              var cell = [];
	              for (var i = 0; i < CIRCLE_SIDES; i++) {
	                var t = i * 2 * Math.PI / CIRCLE_SIDES;
	                cell.push([cx + rx * Math.cos(t), cy + ry * Math.sin(t)]);
	              }
	              return cell;
	            };
	            exports2.ellipseOver = function(pos) {
	              var x0 = pos.x0;
	              var y0 = pos.y0;
	              var x1 = pos.x1;
	              var y1 = pos.y1;
	              var dx = x1 - x0;
	              var dy = y1 - y0;
	              x0 -= dx;
	              y0 -= dy;
	              var cx = (x0 + x1) / 2;
	              var cy = (y0 + y1) / 2;
	              var scale = SQRT2;
	              dx *= scale;
	              dy *= scale;
	              return {
	                x0: cx - dx,
	                y0: cy - dy,
	                x1: cx + dx,
	                y1: cy + dy
	              };
	            };
	            exports2.fixDatesForPaths = function(polygons, xaxis, yaxis) {
	              var xIsDate = xaxis.type === "date";
	              var yIsDate = yaxis.type === "date";
	              if (!xIsDate && !yIsDate) return polygons;
	              for (var i = 0; i < polygons.length; i++) {
	                for (var j = 0; j < polygons[i].length; j++) {
	                  for (var k = 0; k + 2 < polygons[i][j].length; k += 2) {
	                    if (xIsDate) polygons[i][j][k + 1] = polygons[i][j][k + 1].replace(" ", "_");
	                    if (yIsDate) polygons[i][j][k + 2] = polygons[i][j][k + 2].replace(" ", "_");
	                  }
	                }
	              }
	              return polygons;
	            };
	          }
	        ),
	        /***/
	        90551: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dragHelpers = __webpack_require__2(64505);
	            var drawMode = dragHelpers.drawMode;
	            var openMode = dragHelpers.openMode;
	            var constants = __webpack_require__2(89995);
	            var i000 = constants.i000;
	            var i090 = constants.i090;
	            var i180 = constants.i180;
	            var i270 = constants.i270;
	            var cos45 = constants.cos45;
	            var sin45 = constants.sin45;
	            var cartesianHelpers = __webpack_require__2(75549);
	            var p2r = cartesianHelpers.p2r;
	            var r2p = cartesianHelpers.r2p;
	            var handleOutline = __webpack_require__2(51873);
	            var clearOutline = handleOutline.clearOutline;
	            var helpers = __webpack_require__2(60165);
	            var readPaths = helpers.readPaths;
	            var writePaths = helpers.writePaths;
	            var ellipseOver = helpers.ellipseOver;
	            var fixDatesForPaths = helpers.fixDatesForPaths;
	            function newShapes(outlines, dragOptions) {
	              if (!outlines.length) return;
	              var e = outlines[0][0];
	              if (!e) return;
	              var gd = dragOptions.gd;
	              var isActiveShape = dragOptions.isActiveShape;
	              var dragmode = dragOptions.dragmode;
	              var shapes = (gd.layout || {}).shapes || [];
	              if (!drawMode(dragmode) && isActiveShape !== undefined) {
	                var id = gd._fullLayout._activeShapeIndex;
	                if (id < shapes.length) {
	                  switch (gd._fullLayout.shapes[id].type) {
	                    case "rect":
	                      dragmode = "drawrect";
	                      break;
	                    case "circle":
	                      dragmode = "drawcircle";
	                      break;
	                    case "line":
	                      dragmode = "drawline";
	                      break;
	                    case "path":
	                      var path = shapes[id].path || "";
	                      if (path[path.length - 1] === "Z") {
	                        dragmode = "drawclosedpath";
	                      } else {
	                        dragmode = "drawopenpath";
	                      }
	                      break;
	                  }
	                }
	              }
	              var newShape = createShapeObj(outlines, dragOptions, dragmode);
	              clearOutline(gd);
	              var editHelpers = dragOptions.editHelpers;
	              var modifyItem = (editHelpers || {}).modifyItem;
	              var allShapes = [];
	              for (var q = 0; q < shapes.length; q++) {
	                var beforeEdit = gd._fullLayout.shapes[q];
	                allShapes[q] = beforeEdit._input;
	                if (isActiveShape !== undefined && q === gd._fullLayout._activeShapeIndex) {
	                  var afterEdit = newShape;
	                  switch (beforeEdit.type) {
	                    case "line":
	                    case "rect":
	                    case "circle":
	                      modifyItem("x0", afterEdit.x0);
	                      modifyItem("x1", afterEdit.x1);
	                      modifyItem("y0", afterEdit.y0);
	                      modifyItem("y1", afterEdit.y1);
	                      break;
	                    case "path":
	                      modifyItem("path", afterEdit.path);
	                      break;
	                  }
	                }
	              }
	              if (isActiveShape === undefined) {
	                allShapes.push(newShape);
	                return allShapes;
	              }
	              return editHelpers ? editHelpers.getUpdateObj() : {};
	            }
	            function createShapeObj(outlines, dragOptions, dragmode) {
	              var e = outlines[0][0];
	              var gd = dragOptions.gd;
	              var d = e.getAttribute("d");
	              var newStyle = gd._fullLayout.newshape;
	              var plotinfo = dragOptions.plotinfo;
	              var isActiveShape = dragOptions.isActiveShape;
	              var xaxis = plotinfo.xaxis;
	              var yaxis = plotinfo.yaxis;
	              var xPaper = !!plotinfo.domain || !plotinfo.xaxis;
	              var yPaper = !!plotinfo.domain || !plotinfo.yaxis;
	              var isOpenMode = openMode(dragmode);
	              var polygons = readPaths(d, gd, plotinfo, isActiveShape);
	              var newShape = {
	                editable: true,
	                visible: newStyle.visible,
	                name: newStyle.name,
	                showlegend: newStyle.showlegend,
	                legend: newStyle.legend,
	                legendwidth: newStyle.legendwidth,
	                legendgroup: newStyle.legendgroup,
	                legendgrouptitle: {
	                  text: newStyle.legendgrouptitle.text,
	                  font: newStyle.legendgrouptitle.font
	                },
	                legendrank: newStyle.legendrank,
	                label: newStyle.label,
	                xref: xPaper ? "paper" : xaxis._id,
	                yref: yPaper ? "paper" : yaxis._id,
	                layer: newStyle.layer,
	                opacity: newStyle.opacity,
	                line: {
	                  color: newStyle.line.color,
	                  width: newStyle.line.width,
	                  dash: newStyle.line.dash
	                }
	              };
	              if (!isOpenMode) {
	                newShape.fillcolor = newStyle.fillcolor;
	                newShape.fillrule = newStyle.fillrule;
	              }
	              var cell;
	              if (polygons.length === 1) cell = polygons[0];
	              if (cell && cell.length === 5 && // ensure we only have 4 corners for a rect
	              dragmode === "drawrect") {
	                newShape.type = "rect";
	                newShape.x0 = cell[0][1];
	                newShape.y0 = cell[0][2];
	                newShape.x1 = cell[2][1];
	                newShape.y1 = cell[2][2];
	              } else if (cell && dragmode === "drawline") {
	                newShape.type = "line";
	                newShape.x0 = cell[0][1];
	                newShape.y0 = cell[0][2];
	                newShape.x1 = cell[1][1];
	                newShape.y1 = cell[1][2];
	              } else if (cell && dragmode === "drawcircle") {
	                newShape.type = "circle";
	                var xA = cell[i000][1];
	                var xB = cell[i090][1];
	                var xC = cell[i180][1];
	                var xD = cell[i270][1];
	                var yA = cell[i000][2];
	                var yB = cell[i090][2];
	                var yC = cell[i180][2];
	                var yD = cell[i270][2];
	                var xDateOrLog = plotinfo.xaxis && (plotinfo.xaxis.type === "date" || plotinfo.xaxis.type === "log");
	                var yDateOrLog = plotinfo.yaxis && (plotinfo.yaxis.type === "date" || plotinfo.yaxis.type === "log");
	                if (xDateOrLog) {
	                  xA = r2p(plotinfo.xaxis, xA);
	                  xB = r2p(plotinfo.xaxis, xB);
	                  xC = r2p(plotinfo.xaxis, xC);
	                  xD = r2p(plotinfo.xaxis, xD);
	                }
	                if (yDateOrLog) {
	                  yA = r2p(plotinfo.yaxis, yA);
	                  yB = r2p(plotinfo.yaxis, yB);
	                  yC = r2p(plotinfo.yaxis, yC);
	                  yD = r2p(plotinfo.yaxis, yD);
	                }
	                var x0 = (xB + xD) / 2;
	                var y0 = (yA + yC) / 2;
	                var rx = (xD - xB + xC - xA) / 2;
	                var ry = (yD - yB + yC - yA) / 2;
	                var pos = ellipseOver({
	                  x0,
	                  y0,
	                  x1: x0 + rx * cos45,
	                  y1: y0 + ry * sin45
	                });
	                if (xDateOrLog) {
	                  pos.x0 = p2r(plotinfo.xaxis, pos.x0);
	                  pos.x1 = p2r(plotinfo.xaxis, pos.x1);
	                }
	                if (yDateOrLog) {
	                  pos.y0 = p2r(plotinfo.yaxis, pos.y0);
	                  pos.y1 = p2r(plotinfo.yaxis, pos.y1);
	                }
	                newShape.x0 = pos.x0;
	                newShape.y0 = pos.y0;
	                newShape.x1 = pos.x1;
	                newShape.y1 = pos.y1;
	              } else {
	                newShape.type = "path";
	                if (xaxis && yaxis) fixDatesForPaths(polygons, xaxis, yaxis);
	                newShape.path = writePaths(polygons);
	                cell = null;
	              }
	              return newShape;
	            }
	            module2.exports = {
	              newShapes,
	              createShapeObj
	            };
	          }
	        ),
	        /***/
	        51873: (
	          /***/
	          function(module2) {
	            function clearOutlineControllers(gd) {
	              var zoomLayer = gd._fullLayout._zoomlayer;
	              if (zoomLayer) {
	                zoomLayer.selectAll(".outline-controllers").remove();
	              }
	            }
	            function clearOutline(gd) {
	              var zoomLayer = gd._fullLayout._zoomlayer;
	              if (zoomLayer) {
	                zoomLayer.selectAll(".select-outline").remove();
	              }
	              gd._fullLayout._outlining = false;
	            }
	            module2.exports = {
	              clearOutlineControllers,
	              clearOutline
	            };
	          }
	        ),
	        /***/
	        30477: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var constants = __webpack_require__2(21459);
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            exports2.rangeToShapePosition = function(ax) {
	              return ax.type === "log" ? ax.r2d : function(v) {
	                return v;
	              };
	            };
	            exports2.shapePositionToRange = function(ax) {
	              return ax.type === "log" ? ax.d2r : function(v) {
	                return v;
	              };
	            };
	            exports2.decodeDate = function(convertToPx) {
	              return function(v) {
	                if (v.replace) v = v.replace("_", " ");
	                return convertToPx(v);
	              };
	            };
	            exports2.encodeDate = function(convertToDate) {
	              return function(v) {
	                return convertToDate(v).replace(" ", "_");
	              };
	            };
	            exports2.extractPathCoords = function(path, paramsToUse, isRaw) {
	              var extractedCoordinates = [];
	              var segments = path.match(constants.segmentRE);
	              segments.forEach(function(segment) {
	                var relevantParamIdx = paramsToUse[segment.charAt(0)].drawn;
	                if (relevantParamIdx === undefined) return;
	                var params = segment.substr(1).match(constants.paramRE);
	                if (!params || params.length < relevantParamIdx) return;
	                var str = params[relevantParamIdx];
	                var pos = isRaw ? str : Lib.cleanNumber(str);
	                extractedCoordinates.push(pos);
	              });
	              return extractedCoordinates;
	            };
	            exports2.getDataToPixel = function(gd, axis, isVertical, refType) {
	              var gs = gd._fullLayout._size;
	              var dataToPixel;
	              if (axis) {
	                if (refType === "domain") {
	                  dataToPixel = function(v) {
	                    return axis._length * (isVertical ? 1 - v : v) + axis._offset;
	                  };
	                } else {
	                  var d2r = exports2.shapePositionToRange(axis);
	                  dataToPixel = function(v) {
	                    return axis._offset + axis.r2p(d2r(v, true));
	                  };
	                  if (axis.type === "date") dataToPixel = exports2.decodeDate(dataToPixel);
	                }
	              } else if (isVertical) {
	                dataToPixel = function(v) {
	                  return gs.t + gs.h * (1 - v);
	                };
	              } else {
	                dataToPixel = function(v) {
	                  return gs.l + gs.w * v;
	                };
	              }
	              return dataToPixel;
	            };
	            exports2.getPixelToData = function(gd, axis, isVertical, opt) {
	              var gs = gd._fullLayout._size;
	              var pixelToData;
	              if (axis) {
	                if (opt === "domain") {
	                  pixelToData = function(p) {
	                    var q = (p - axis._offset) / axis._length;
	                    return isVertical ? 1 - q : q;
	                  };
	                } else {
	                  var r2d = exports2.rangeToShapePosition(axis);
	                  pixelToData = function(p) {
	                    return r2d(axis.p2r(p - axis._offset));
	                  };
	                }
	              } else if (isVertical) {
	                pixelToData = function(p) {
	                  return 1 - (p - gs.t) / gs.h;
	                };
	              } else {
	                pixelToData = function(p) {
	                  return (p - gs.l) / gs.w;
	                };
	              }
	              return pixelToData;
	            };
	            exports2.roundPositionForSharpStrokeRendering = function(pos, strokeWidth) {
	              var strokeWidthIsOdd = Math.round(strokeWidth % 2) === 1;
	              var posValAsInt = Math.round(pos);
	              return strokeWidthIsOdd ? posValAsInt + 0.5 : posValAsInt;
	            };
	            exports2.makeShapesOptionsAndPlotinfo = function(gd, index) {
	              var options = gd._fullLayout.shapes[index] || {};
	              var plotinfo = gd._fullLayout._plots[options.xref + options.yref];
	              var hasPlotinfo = !!plotinfo;
	              if (hasPlotinfo) {
	                plotinfo._hadPlotinfo = true;
	              } else {
	                plotinfo = {};
	                if (options.xref && options.xref !== "paper") plotinfo.xaxis = gd._fullLayout[options.xref + "axis"];
	                if (options.yref && options.yref !== "paper") plotinfo.yaxis = gd._fullLayout[options.yref + "axis"];
	              }
	              plotinfo.xsizemode = options.xsizemode;
	              plotinfo.ysizemode = options.ysizemode;
	              plotinfo.xanchor = options.xanchor;
	              plotinfo.yanchor = options.yanchor;
	              return {
	                options,
	                plotinfo
	              };
	            };
	            exports2.makeSelectionsOptionsAndPlotinfo = function(gd, index) {
	              var options = gd._fullLayout.selections[index] || {};
	              var plotinfo = gd._fullLayout._plots[options.xref + options.yref];
	              var hasPlotinfo = !!plotinfo;
	              if (hasPlotinfo) {
	                plotinfo._hadPlotinfo = true;
	              } else {
	                plotinfo = {};
	                if (options.xref) plotinfo.xaxis = gd._fullLayout[options.xref + "axis"];
	                if (options.yref) plotinfo.yaxis = gd._fullLayout[options.yref + "axis"];
	              }
	              return {
	                options,
	                plotinfo
	              };
	            };
	            exports2.getPathString = function(gd, options) {
	              var type = options.type;
	              var xRefType = Axes.getRefType(options.xref);
	              var yRefType = Axes.getRefType(options.yref);
	              var xa = Axes.getFromId(gd, options.xref);
	              var ya = Axes.getFromId(gd, options.yref);
	              var gs = gd._fullLayout._size;
	              var x2r, x2p, y2r, y2p;
	              var x0, x1, y0, y1;
	              if (xa) {
	                if (xRefType === "domain") {
	                  x2p = function(v) {
	                    return xa._offset + xa._length * v;
	                  };
	                } else {
	                  x2r = exports2.shapePositionToRange(xa);
	                  x2p = function(v) {
	                    return xa._offset + xa.r2p(x2r(v, true));
	                  };
	                }
	              } else {
	                x2p = function(v) {
	                  return gs.l + gs.w * v;
	                };
	              }
	              if (ya) {
	                if (yRefType === "domain") {
	                  y2p = function(v) {
	                    return ya._offset + ya._length * (1 - v);
	                  };
	                } else {
	                  y2r = exports2.shapePositionToRange(ya);
	                  y2p = function(v) {
	                    return ya._offset + ya.r2p(y2r(v, true));
	                  };
	                }
	              } else {
	                y2p = function(v) {
	                  return gs.t + gs.h * (1 - v);
	                };
	              }
	              if (type === "path") {
	                if (xa && xa.type === "date") x2p = exports2.decodeDate(x2p);
	                if (ya && ya.type === "date") y2p = exports2.decodeDate(y2p);
	                return convertPath(options, x2p, y2p);
	              }
	              if (options.xsizemode === "pixel") {
	                var xAnchorPos = x2p(options.xanchor);
	                x0 = xAnchorPos + options.x0;
	                x1 = xAnchorPos + options.x1;
	              } else {
	                x0 = x2p(options.x0);
	                x1 = x2p(options.x1);
	              }
	              if (options.ysizemode === "pixel") {
	                var yAnchorPos = y2p(options.yanchor);
	                y0 = yAnchorPos - options.y0;
	                y1 = yAnchorPos - options.y1;
	              } else {
	                y0 = y2p(options.y0);
	                y1 = y2p(options.y1);
	              }
	              if (type === "line") return "M" + x0 + "," + y0 + "L" + x1 + "," + y1;
	              if (type === "rect") return "M" + x0 + "," + y0 + "H" + x1 + "V" + y1 + "H" + x0 + "Z";
	              var cx = (x0 + x1) / 2;
	              var cy = (y0 + y1) / 2;
	              var rx = Math.abs(cx - x0);
	              var ry = Math.abs(cy - y0);
	              var rArc = "A" + rx + "," + ry;
	              var rightPt = cx + rx + "," + cy;
	              var topPt = cx + "," + (cy - ry);
	              return "M" + rightPt + rArc + " 0 1,1 " + topPt + rArc + " 0 0,1 " + rightPt + "Z";
	            };
	            function convertPath(options, x2p, y2p) {
	              var pathIn = options.path;
	              var xSizemode = options.xsizemode;
	              var ySizemode = options.ysizemode;
	              var xAnchor = options.xanchor;
	              var yAnchor = options.yanchor;
	              return pathIn.replace(constants.segmentRE, function(segment) {
	                var paramNumber = 0;
	                var segmentType = segment.charAt(0);
	                var xParams = constants.paramIsX[segmentType];
	                var yParams = constants.paramIsY[segmentType];
	                var nParams = constants.numParams[segmentType];
	                var paramString = segment.substr(1).replace(constants.paramRE, function(param) {
	                  if (xParams[paramNumber]) {
	                    if (xSizemode === "pixel") param = x2p(xAnchor) + Number(param);
	                    else param = x2p(param);
	                  } else if (yParams[paramNumber]) {
	                    if (ySizemode === "pixel") param = y2p(yAnchor) - Number(param);
	                    else param = y2p(param);
	                  }
	                  paramNumber++;
	                  if (paramNumber > nParams) param = "X";
	                  return param;
	                });
	                if (paramNumber > nParams) {
	                  paramString = paramString.replace(/[\s,]*X.*/, "");
	                  Lib.log("Ignoring extra params in segment " + segment);
	                }
	                return segmentType + paramString;
	              });
	            }
	          }
	        ),
	        /***/
	        89853: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var drawModule = __webpack_require__2(34031);
	            module2.exports = {
	              moduleType: "component",
	              name: "shapes",
	              layoutAttributes: __webpack_require__2(89827),
	              supplyLayoutDefaults: __webpack_require__2(84726),
	              supplyDrawNewShapeDefaults: __webpack_require__2(45547),
	              includeBasePlot: __webpack_require__2(76325)("shapes"),
	              calcAutorange: __webpack_require__2(5627),
	              draw: drawModule.draw,
	              drawOne: drawModule.drawOne
	            };
	          }
	        ),
	        /***/
	        37281: (
	          /***/
	          function(module2) {
	            function d2l(v, axis) {
	              return axis ? axis.d2l(v) : v;
	            }
	            function l2d(v, axis) {
	              return axis ? axis.l2d(v) : v;
	            }
	            function x0Fn(shape) {
	              return shape.x0;
	            }
	            function x1Fn(shape) {
	              return shape.x1;
	            }
	            function y0Fn(shape) {
	              return shape.y0;
	            }
	            function y1Fn(shape) {
	              return shape.y1;
	            }
	            function dxFn(shape, xa) {
	              return d2l(shape.x1, xa) - d2l(shape.x0, xa);
	            }
	            function dyFn(shape, xa, ya) {
	              return d2l(shape.y1, ya) - d2l(shape.y0, ya);
	            }
	            function widthFn(shape, xa) {
	              return Math.abs(dxFn(shape, xa));
	            }
	            function heightFn(shape, xa, ya) {
	              return Math.abs(dyFn(shape, xa, ya));
	            }
	            function lengthFn(shape, xa, ya) {
	              return shape.type !== "line" ? undefined : Math.sqrt(Math.pow(dxFn(shape, xa), 2) + Math.pow(dyFn(shape, xa, ya), 2));
	            }
	            function xcenterFn(shape, xa) {
	              return l2d((d2l(shape.x1, xa) + d2l(shape.x0, xa)) / 2, xa);
	            }
	            function ycenterFn(shape, xa, ya) {
	              return l2d((d2l(shape.y1, ya) + d2l(shape.y0, ya)) / 2, ya);
	            }
	            function slopeFn(shape, xa, ya) {
	              return shape.type !== "line" ? undefined : dyFn(shape, xa, ya) / dxFn(shape, xa);
	            }
	            module2.exports = {
	              x0: x0Fn,
	              x1: x1Fn,
	              y0: y0Fn,
	              y1: y1Fn,
	              slope: slopeFn,
	              dx: dxFn,
	              dy: dyFn,
	              width: widthFn,
	              height: heightFn,
	              length: lengthFn,
	              xcenter: xcenterFn,
	              ycenter: ycenterFn
	            };
	          }
	        ),
	        /***/
	        75067: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var padAttrs = __webpack_require__2(35025);
	            var extendDeepAll = __webpack_require__2(1426).extendDeepAll;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var animationAttrs = __webpack_require__2(85594);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var constants = __webpack_require__2(98292);
	            var stepsAttrs = templatedArray("step", {
	              visible: {
	                valType: "boolean",
	                dflt: true
	              },
	              method: {
	                valType: "enumerated",
	                values: ["restyle", "relayout", "animate", "update", "skip"],
	                dflt: "restyle"
	              },
	              args: {
	                valType: "info_array",
	                freeLength: true,
	                items: [{
	                  valType: "any"
	                }, {
	                  valType: "any"
	                }, {
	                  valType: "any"
	                }]
	              },
	              label: {
	                valType: "string"
	              },
	              value: {
	                valType: "string"
	              },
	              execute: {
	                valType: "boolean",
	                dflt: true
	              }
	            });
	            module2.exports = overrideAll(templatedArray("slider", {
	              visible: {
	                valType: "boolean",
	                dflt: true
	              },
	              active: {
	                valType: "number",
	                min: 0,
	                dflt: 0
	              },
	              steps: stepsAttrs,
	              lenmode: {
	                valType: "enumerated",
	                values: ["fraction", "pixels"],
	                dflt: "fraction"
	              },
	              len: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              x: {
	                valType: "number",
	                min: -2,
	                max: 3,
	                dflt: 0
	              },
	              pad: extendDeepAll(padAttrs({
	                editType: "arraydraw"
	              }), {}, {
	                t: {
	                  dflt: 20
	                }
	              }),
	              xanchor: {
	                valType: "enumerated",
	                values: ["auto", "left", "center", "right"],
	                dflt: "left"
	              },
	              y: {
	                valType: "number",
	                min: -2,
	                max: 3,
	                dflt: 0
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["auto", "top", "middle", "bottom"],
	                dflt: "top"
	              },
	              transition: {
	                duration: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 150
	                },
	                easing: {
	                  valType: "enumerated",
	                  values: animationAttrs.transition.easing.values,
	                  dflt: "cubic-in-out"
	                }
	              },
	              currentvalue: {
	                visible: {
	                  valType: "boolean",
	                  dflt: true
	                },
	                xanchor: {
	                  valType: "enumerated",
	                  values: ["left", "center", "right"],
	                  dflt: "left"
	                },
	                offset: {
	                  valType: "number",
	                  dflt: 10
	                },
	                prefix: {
	                  valType: "string"
	                },
	                suffix: {
	                  valType: "string"
	                },
	                font: fontAttrs({})
	              },
	              font: fontAttrs({}),
	              activebgcolor: {
	                valType: "color",
	                dflt: constants.gripBgActiveColor
	              },
	              bgcolor: {
	                valType: "color",
	                dflt: constants.railBgColor
	              },
	              bordercolor: {
	                valType: "color",
	                dflt: constants.railBorderColor
	              },
	              borderwidth: {
	                valType: "number",
	                min: 0,
	                dflt: constants.railBorderWidth
	              },
	              ticklen: {
	                valType: "number",
	                min: 0,
	                dflt: constants.tickLength
	              },
	              tickcolor: {
	                valType: "color",
	                dflt: constants.tickColor
	              },
	              tickwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              minorticklen: {
	                valType: "number",
	                min: 0,
	                dflt: constants.minorTickLength
	              }
	            }), "arraydraw", "from-root");
	          }
	        ),
	        /***/
	        98292: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // layout attribute name
	              name: "sliders",
	              // class names
	              containerClassName: "slider-container",
	              groupClassName: "slider-group",
	              inputAreaClass: "slider-input-area",
	              railRectClass: "slider-rail-rect",
	              railTouchRectClass: "slider-rail-touch-rect",
	              gripRectClass: "slider-grip-rect",
	              tickRectClass: "slider-tick-rect",
	              inputProxyClass: "slider-input-proxy",
	              labelsClass: "slider-labels",
	              labelGroupClass: "slider-label-group",
	              labelClass: "slider-label",
	              currentValueClass: "slider-current-value",
	              railHeight: 5,
	              // DOM attribute name in button group keeping track
	              // of active update menu
	              menuIndexAttrName: "slider-active-index",
	              // id root pass to Plots.autoMargin
	              autoMarginIdRoot: "slider-",
	              // min item width / height
	              minWidth: 30,
	              minHeight: 30,
	              // padding around item text
	              textPadX: 40,
	              // arrow offset off right edge
	              arrowOffsetX: 4,
	              railRadius: 2,
	              railWidth: 5,
	              railBorder: 4,
	              railBorderWidth: 1,
	              railBorderColor: "#bec8d9",
	              railBgColor: "#f8fafc",
	              // The distance of the rail from the edge of the touchable area
	              // Slightly less than the step inset because of the curved edges
	              // of the rail
	              railInset: 8,
	              // The distance from the extremal tick marks to the edge of the
	              // touchable area. This is basically the same as the grip radius,
	              // but for other styles it wouldn't really need to be.
	              stepInset: 10,
	              gripRadius: 10,
	              gripWidth: 20,
	              gripHeight: 20,
	              gripBorder: 20,
	              gripBorderWidth: 1,
	              gripBorderColor: "#bec8d9",
	              gripBgColor: "#f6f8fa",
	              gripBgActiveColor: "#dbdde0",
	              labelPadding: 8,
	              labelOffset: 0,
	              tickWidth: 1,
	              tickColor: "#333",
	              tickOffset: 25,
	              tickLength: 7,
	              minorTickOffset: 25,
	              minorTickColor: "#333",
	              minorTickLength: 4,
	              // Extra space below the current value label:
	              currentValuePadding: 8,
	              currentValueInset: 0
	            };
	          }
	        ),
	        /***/
	        12343: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(75067);
	            var constants = __webpack_require__2(98292);
	            var name2 = constants.name;
	            var stepAttrs = attributes.steps;
	            module2.exports = function slidersDefaults(layoutIn, layoutOut) {
	              handleArrayContainerDefaults(layoutIn, layoutOut, {
	                name: name2,
	                handleItemDefaults: sliderDefaults
	              });
	            };
	            function sliderDefaults(sliderIn, sliderOut, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(sliderIn, sliderOut, attributes, attr, dflt);
	              }
	              var steps = handleArrayContainerDefaults(sliderIn, sliderOut, {
	                name: "steps",
	                handleItemDefaults: stepDefaults
	              });
	              var stepCount = 0;
	              for (var i = 0; i < steps.length; i++) {
	                if (steps[i].visible) stepCount++;
	              }
	              var visible;
	              if (stepCount < 2) visible = sliderOut.visible = false;
	              else visible = coerce("visible");
	              if (!visible) return;
	              sliderOut._stepCount = stepCount;
	              var visSteps = sliderOut._visibleSteps = Lib.filterVisible(steps);
	              var active = coerce("active");
	              if (!(steps[active] || {}).visible) sliderOut.active = visSteps[0]._index;
	              coerce("x");
	              coerce("y");
	              Lib.noneOrAll(sliderIn, sliderOut, ["x", "y"]);
	              coerce("xanchor");
	              coerce("yanchor");
	              coerce("len");
	              coerce("lenmode");
	              coerce("pad.t");
	              coerce("pad.r");
	              coerce("pad.b");
	              coerce("pad.l");
	              Lib.coerceFont(coerce, "font", layoutOut.font);
	              var currentValueIsVisible = coerce("currentvalue.visible");
	              if (currentValueIsVisible) {
	                coerce("currentvalue.xanchor");
	                coerce("currentvalue.prefix");
	                coerce("currentvalue.suffix");
	                coerce("currentvalue.offset");
	                Lib.coerceFont(coerce, "currentvalue.font", sliderOut.font);
	              }
	              coerce("transition.duration");
	              coerce("transition.easing");
	              coerce("bgcolor");
	              coerce("activebgcolor");
	              coerce("bordercolor");
	              coerce("borderwidth");
	              coerce("ticklen");
	              coerce("tickwidth");
	              coerce("tickcolor");
	              coerce("minorticklen");
	            }
	            function stepDefaults(valueIn, valueOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(valueIn, valueOut, stepAttrs, attr, dflt);
	              }
	              var visible;
	              if (valueIn.method !== "skip" && !Array.isArray(valueIn.args)) {
	                visible = valueOut.visible = false;
	              } else visible = coerce("visible");
	              if (visible) {
	                coerce("method");
	                coerce("args");
	                var label = coerce("label", "step-" + valueOut._index);
	                coerce("value", label);
	                coerce("execute");
	              }
	            }
	          }
	        ),
	        /***/
	        44504: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Plots = __webpack_require__2(74875);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var arrayEditor = __webpack_require__2(44467).arrayEditor;
	            var constants = __webpack_require__2(98292);
	            var alignmentConstants = __webpack_require__2(18783);
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var FROM_TL = alignmentConstants.FROM_TL;
	            var FROM_BR = alignmentConstants.FROM_BR;
	            module2.exports = function draw(gd) {
	              var staticPlot = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var sliderData = makeSliderData(fullLayout, gd);
	              var sliders = fullLayout._infolayer.selectAll("g." + constants.containerClassName).data(sliderData.length > 0 ? [0] : []);
	              sliders.enter().append("g").classed(constants.containerClassName, true).style("cursor", staticPlot ? null : "ew-resize");
	              function clearSlider(sliderOpts2) {
	                if (sliderOpts2._commandObserver) {
	                  sliderOpts2._commandObserver.remove();
	                  delete sliderOpts2._commandObserver;
	                }
	                Plots.autoMargin(gd, autoMarginId(sliderOpts2));
	              }
	              sliders.exit().each(function() {
	                d3.select(this).selectAll("g." + constants.groupClassName).each(clearSlider);
	              }).remove();
	              if (sliderData.length === 0) return;
	              var sliderGroups = sliders.selectAll("g." + constants.groupClassName).data(sliderData, keyFunction);
	              sliderGroups.enter().append("g").classed(constants.groupClassName, true);
	              sliderGroups.exit().each(clearSlider).remove();
	              for (var i = 0; i < sliderData.length; i++) {
	                var sliderOpts = sliderData[i];
	                findDimensions(gd, sliderOpts);
	              }
	              sliderGroups.each(function(sliderOpts2) {
	                var gSlider = d3.select(this);
	                computeLabelSteps(sliderOpts2);
	                Plots.manageCommandObserver(gd, sliderOpts2, sliderOpts2._visibleSteps, function(data) {
	                  var opts = gSlider.data()[0];
	                  if (opts.active === data.index) return;
	                  if (opts._dragging) return;
	                  setActive(gd, gSlider, opts, data.index, false, true);
	                });
	                drawSlider(gd, d3.select(this), sliderOpts2);
	              });
	            };
	            function autoMarginId(sliderOpts) {
	              return constants.autoMarginIdRoot + sliderOpts._index;
	            }
	            function makeSliderData(fullLayout, gd) {
	              var contOpts = fullLayout[constants.name];
	              var sliderData = [];
	              for (var i = 0; i < contOpts.length; i++) {
	                var item = contOpts[i];
	                if (!item.visible) continue;
	                item._gd = gd;
	                sliderData.push(item);
	              }
	              return sliderData;
	            }
	            function keyFunction(opts) {
	              return opts._index;
	            }
	            function findDimensions(gd, sliderOpts) {
	              var sliderLabels = Drawing.tester.selectAll("g." + constants.labelGroupClass).data(sliderOpts._visibleSteps);
	              sliderLabels.enter().append("g").classed(constants.labelGroupClass, true);
	              var maxLabelWidth = 0;
	              var labelHeight = 0;
	              sliderLabels.each(function(stepOpts) {
	                var labelGroup = d3.select(this);
	                var text = drawLabel(labelGroup, {
	                  step: stepOpts
	                }, sliderOpts);
	                var textNode = text.node();
	                if (textNode) {
	                  var bBox = Drawing.bBox(textNode);
	                  labelHeight = Math.max(labelHeight, bBox.height);
	                  maxLabelWidth = Math.max(maxLabelWidth, bBox.width);
	                }
	              });
	              sliderLabels.remove();
	              var dims = sliderOpts._dims = {};
	              dims.inputAreaWidth = Math.max(constants.railWidth, constants.gripHeight);
	              var graphSize = gd._fullLayout._size;
	              dims.lx = graphSize.l + graphSize.w * sliderOpts.x;
	              dims.ly = graphSize.t + graphSize.h * (1 - sliderOpts.y);
	              if (sliderOpts.lenmode === "fraction") {
	                dims.outerLength = Math.round(graphSize.w * sliderOpts.len);
	              } else {
	                dims.outerLength = sliderOpts.len;
	              }
	              dims.inputAreaStart = 0;
	              dims.inputAreaLength = Math.round(dims.outerLength - sliderOpts.pad.l - sliderOpts.pad.r);
	              var textableInputLength = dims.inputAreaLength - 2 * constants.stepInset;
	              var availableSpacePerLabel = textableInputLength / (sliderOpts._stepCount - 1);
	              var computedSpacePerLabel = maxLabelWidth + constants.labelPadding;
	              dims.labelStride = Math.max(1, Math.ceil(computedSpacePerLabel / availableSpacePerLabel));
	              dims.labelHeight = labelHeight;
	              dims.currentValueMaxWidth = 0;
	              dims.currentValueHeight = 0;
	              dims.currentValueTotalHeight = 0;
	              dims.currentValueMaxLines = 1;
	              if (sliderOpts.currentvalue.visible) {
	                var dummyGroup = Drawing.tester.append("g");
	                sliderLabels.each(function(stepOpts) {
	                  var curValPrefix = drawCurrentValue(dummyGroup, sliderOpts, stepOpts.label);
	                  var curValSize = curValPrefix.node() && Drawing.bBox(curValPrefix.node()) || {
	                    width: 0,
	                    height: 0
	                  };
	                  var lines = svgTextUtils.lineCount(curValPrefix);
	                  dims.currentValueMaxWidth = Math.max(dims.currentValueMaxWidth, Math.ceil(curValSize.width));
	                  dims.currentValueHeight = Math.max(dims.currentValueHeight, Math.ceil(curValSize.height));
	                  dims.currentValueMaxLines = Math.max(dims.currentValueMaxLines, lines);
	                });
	                dims.currentValueTotalHeight = dims.currentValueHeight + sliderOpts.currentvalue.offset;
	                dummyGroup.remove();
	              }
	              dims.height = dims.currentValueTotalHeight + constants.tickOffset + sliderOpts.ticklen + constants.labelOffset + dims.labelHeight + sliderOpts.pad.t + sliderOpts.pad.b;
	              var xanchor = "left";
	              if (Lib.isRightAnchor(sliderOpts)) {
	                dims.lx -= dims.outerLength;
	                xanchor = "right";
	              }
	              if (Lib.isCenterAnchor(sliderOpts)) {
	                dims.lx -= dims.outerLength / 2;
	                xanchor = "center";
	              }
	              var yanchor = "top";
	              if (Lib.isBottomAnchor(sliderOpts)) {
	                dims.ly -= dims.height;
	                yanchor = "bottom";
	              }
	              if (Lib.isMiddleAnchor(sliderOpts)) {
	                dims.ly -= dims.height / 2;
	                yanchor = "middle";
	              }
	              dims.outerLength = Math.ceil(dims.outerLength);
	              dims.height = Math.ceil(dims.height);
	              dims.lx = Math.round(dims.lx);
	              dims.ly = Math.round(dims.ly);
	              var marginOpts = {
	                y: sliderOpts.y,
	                b: dims.height * FROM_BR[yanchor],
	                t: dims.height * FROM_TL[yanchor]
	              };
	              if (sliderOpts.lenmode === "fraction") {
	                marginOpts.l = 0;
	                marginOpts.xl = sliderOpts.x - sliderOpts.len * FROM_TL[xanchor];
	                marginOpts.r = 0;
	                marginOpts.xr = sliderOpts.x + sliderOpts.len * FROM_BR[xanchor];
	              } else {
	                marginOpts.x = sliderOpts.x;
	                marginOpts.l = dims.outerLength * FROM_TL[xanchor];
	                marginOpts.r = dims.outerLength * FROM_BR[xanchor];
	              }
	              Plots.autoMargin(gd, autoMarginId(sliderOpts), marginOpts);
	            }
	            function drawSlider(gd, sliderGroup, sliderOpts) {
	              if (!(sliderOpts.steps[sliderOpts.active] || {}).visible) {
	                sliderOpts.active = sliderOpts._visibleSteps[0]._index;
	              }
	              sliderGroup.call(drawCurrentValue, sliderOpts).call(drawRail, sliderOpts).call(drawLabelGroup, sliderOpts).call(drawTicks, sliderOpts).call(drawTouchRect, gd, sliderOpts).call(drawGrip, gd, sliderOpts);
	              var dims = sliderOpts._dims;
	              Drawing.setTranslate(sliderGroup, dims.lx + sliderOpts.pad.l, dims.ly + sliderOpts.pad.t);
	              sliderGroup.call(setGripPosition, sliderOpts, false);
	              sliderGroup.call(drawCurrentValue, sliderOpts);
	            }
	            function drawCurrentValue(sliderGroup, sliderOpts, valueOverride) {
	              if (!sliderOpts.currentvalue.visible) return;
	              var dims = sliderOpts._dims;
	              var x0, textAnchor;
	              switch (sliderOpts.currentvalue.xanchor) {
	                case "right":
	                  x0 = dims.inputAreaLength - constants.currentValueInset - dims.currentValueMaxWidth;
	                  textAnchor = "left";
	                  break;
	                case "center":
	                  x0 = dims.inputAreaLength * 0.5;
	                  textAnchor = "middle";
	                  break;
	                default:
	                  x0 = constants.currentValueInset;
	                  textAnchor = "left";
	              }
	              var text = Lib.ensureSingle(sliderGroup, "text", constants.labelClass, function(s) {
	                s.attr({
	                  "text-anchor": textAnchor,
	                  "data-notex": 1
	                });
	              });
	              var str = sliderOpts.currentvalue.prefix ? sliderOpts.currentvalue.prefix : "";
	              if (typeof valueOverride === "string") {
	                str += valueOverride;
	              } else {
	                var curVal = sliderOpts.steps[sliderOpts.active].label;
	                var _meta = sliderOpts._gd._fullLayout._meta;
	                if (_meta) curVal = Lib.templateString(curVal, _meta);
	                str += curVal;
	              }
	              if (sliderOpts.currentvalue.suffix) {
	                str += sliderOpts.currentvalue.suffix;
	              }
	              text.call(Drawing.font, sliderOpts.currentvalue.font).text(str).call(svgTextUtils.convertToTspans, sliderOpts._gd);
	              var lines = svgTextUtils.lineCount(text);
	              var y0 = (dims.currentValueMaxLines + 1 - lines) * sliderOpts.currentvalue.font.size * LINE_SPACING;
	              svgTextUtils.positionText(text, x0, y0);
	              return text;
	            }
	            function drawGrip(sliderGroup, gd, sliderOpts) {
	              var grip = Lib.ensureSingle(sliderGroup, "rect", constants.gripRectClass, function(s) {
	                s.call(attachGripEvents, gd, sliderGroup, sliderOpts).style("pointer-events", "all");
	              });
	              grip.attr({
	                width: constants.gripWidth,
	                height: constants.gripHeight,
	                rx: constants.gripRadius,
	                ry: constants.gripRadius
	              }).call(Color.stroke, sliderOpts.bordercolor).call(Color.fill, sliderOpts.bgcolor).style("stroke-width", sliderOpts.borderwidth + "px");
	            }
	            function drawLabel(item, data, sliderOpts) {
	              var text = Lib.ensureSingle(item, "text", constants.labelClass, function(s) {
	                s.attr({
	                  "text-anchor": "middle",
	                  "data-notex": 1
	                });
	              });
	              var tx = data.step.label;
	              var _meta = sliderOpts._gd._fullLayout._meta;
	              if (_meta) tx = Lib.templateString(tx, _meta);
	              text.call(Drawing.font, sliderOpts.font).text(tx).call(svgTextUtils.convertToTspans, sliderOpts._gd);
	              return text;
	            }
	            function drawLabelGroup(sliderGroup, sliderOpts) {
	              var labels = Lib.ensureSingle(sliderGroup, "g", constants.labelsClass);
	              var dims = sliderOpts._dims;
	              var labelItems = labels.selectAll("g." + constants.labelGroupClass).data(dims.labelSteps);
	              labelItems.enter().append("g").classed(constants.labelGroupClass, true);
	              labelItems.exit().remove();
	              labelItems.each(function(d) {
	                var item = d3.select(this);
	                item.call(drawLabel, d, sliderOpts);
	                Drawing.setTranslate(item, normalizedValueToPosition(sliderOpts, d.fraction), constants.tickOffset + sliderOpts.ticklen + // position is the baseline of the top line of text only, even
	                // if the label spans multiple lines
	                sliderOpts.font.size * LINE_SPACING + constants.labelOffset + dims.currentValueTotalHeight);
	              });
	            }
	            function handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, doTransition) {
	              var quantizedPosition = Math.round(normalizedPosition * (sliderOpts._stepCount - 1));
	              var quantizedIndex = sliderOpts._visibleSteps[quantizedPosition]._index;
	              if (quantizedIndex !== sliderOpts.active) {
	                setActive(gd, sliderGroup, sliderOpts, quantizedIndex, true, doTransition);
	              }
	            }
	            function setActive(gd, sliderGroup, sliderOpts, index, doCallback, doTransition) {
	              var previousActive = sliderOpts.active;
	              sliderOpts.active = index;
	              arrayEditor(gd.layout, constants.name, sliderOpts).applyUpdate("active", index);
	              var step = sliderOpts.steps[sliderOpts.active];
	              sliderGroup.call(setGripPosition, sliderOpts, doTransition);
	              sliderGroup.call(drawCurrentValue, sliderOpts);
	              gd.emit("plotly_sliderchange", {
	                slider: sliderOpts,
	                step: sliderOpts.steps[sliderOpts.active],
	                interaction: doCallback,
	                previousActive
	              });
	              if (step && step.method && doCallback) {
	                if (sliderGroup._nextMethod) {
	                  sliderGroup._nextMethod.step = step;
	                  sliderGroup._nextMethod.doCallback = doCallback;
	                  sliderGroup._nextMethod.doTransition = doTransition;
	                } else {
	                  sliderGroup._nextMethod = {
	                    step,
	                    doCallback,
	                    doTransition
	                  };
	                  sliderGroup._nextMethodRaf = window.requestAnimationFrame(function() {
	                    var _step = sliderGroup._nextMethod.step;
	                    if (!_step.method) return;
	                    if (_step.execute) {
	                      Plots.executeAPICommand(gd, _step.method, _step.args);
	                    }
	                    sliderGroup._nextMethod = null;
	                    sliderGroup._nextMethodRaf = null;
	                  });
	                }
	              }
	            }
	            function attachGripEvents(item, gd, sliderGroup) {
	              if (gd._context.staticPlot) return;
	              var node = sliderGroup.node();
	              var $gd = d3.select(gd);
	              function getSliderOpts() {
	                return sliderGroup.data()[0];
	              }
	              function mouseDownHandler() {
	                var sliderOpts = getSliderOpts();
	                gd.emit("plotly_sliderstart", {
	                  slider: sliderOpts
	                });
	                var grip = sliderGroup.select("." + constants.gripRectClass);
	                d3.event.stopPropagation();
	                d3.event.preventDefault();
	                grip.call(Color.fill, sliderOpts.activebgcolor);
	                var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
	                handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, true);
	                sliderOpts._dragging = true;
	                function mouseMoveHandler() {
	                  var sliderOpts2 = getSliderOpts();
	                  var normalizedPosition2 = positionToNormalizedValue(sliderOpts2, d3.mouse(node)[0]);
	                  handleInput(gd, sliderGroup, sliderOpts2, normalizedPosition2, false);
	                }
	                $gd.on("mousemove", mouseMoveHandler);
	                $gd.on("touchmove", mouseMoveHandler);
	                function mouseUpHandler() {
	                  var sliderOpts2 = getSliderOpts();
	                  sliderOpts2._dragging = false;
	                  grip.call(Color.fill, sliderOpts2.bgcolor);
	                  $gd.on("mouseup", null);
	                  $gd.on("mousemove", null);
	                  $gd.on("touchend", null);
	                  $gd.on("touchmove", null);
	                  gd.emit("plotly_sliderend", {
	                    slider: sliderOpts2,
	                    step: sliderOpts2.steps[sliderOpts2.active]
	                  });
	                }
	                $gd.on("mouseup", mouseUpHandler);
	                $gd.on("touchend", mouseUpHandler);
	              }
	              item.on("mousedown", mouseDownHandler);
	              item.on("touchstart", mouseDownHandler);
	            }
	            function drawTicks(sliderGroup, sliderOpts) {
	              var tick = sliderGroup.selectAll("rect." + constants.tickRectClass).data(sliderOpts._visibleSteps);
	              var dims = sliderOpts._dims;
	              tick.enter().append("rect").classed(constants.tickRectClass, true);
	              tick.exit().remove();
	              tick.attr({
	                width: sliderOpts.tickwidth + "px",
	                "shape-rendering": "crispEdges"
	              });
	              tick.each(function(d, i) {
	                var isMajor = i % dims.labelStride === 0;
	                var item = d3.select(this);
	                item.attr({
	                  height: isMajor ? sliderOpts.ticklen : sliderOpts.minorticklen
	                }).call(Color.fill, isMajor ? sliderOpts.tickcolor : sliderOpts.tickcolor);
	                Drawing.setTranslate(item, normalizedValueToPosition(sliderOpts, i / (sliderOpts._stepCount - 1)) - 0.5 * sliderOpts.tickwidth, (isMajor ? constants.tickOffset : constants.minorTickOffset) + dims.currentValueTotalHeight);
	              });
	            }
	            function computeLabelSteps(sliderOpts) {
	              var dims = sliderOpts._dims;
	              dims.labelSteps = [];
	              var nsteps = sliderOpts._stepCount;
	              for (var i = 0; i < nsteps; i += dims.labelStride) {
	                dims.labelSteps.push({
	                  fraction: i / (nsteps - 1),
	                  step: sliderOpts._visibleSteps[i]
	                });
	              }
	            }
	            function setGripPosition(sliderGroup, sliderOpts, doTransition) {
	              var grip = sliderGroup.select("rect." + constants.gripRectClass);
	              var quantizedIndex = 0;
	              for (var i = 0; i < sliderOpts._stepCount; i++) {
	                if (sliderOpts._visibleSteps[i]._index === sliderOpts.active) {
	                  quantizedIndex = i;
	                  break;
	                }
	              }
	              var x = normalizedValueToPosition(sliderOpts, quantizedIndex / (sliderOpts._stepCount - 1));
	              if (sliderOpts._invokingCommand) return;
	              var el = grip;
	              if (doTransition && sliderOpts.transition.duration > 0) {
	                el = el.transition().duration(sliderOpts.transition.duration).ease(sliderOpts.transition.easing);
	              }
	              el.attr("transform", strTranslate(x - constants.gripWidth * 0.5, sliderOpts._dims.currentValueTotalHeight));
	            }
	            function normalizedValueToPosition(sliderOpts, normalizedPosition) {
	              var dims = sliderOpts._dims;
	              return dims.inputAreaStart + constants.stepInset + (dims.inputAreaLength - 2 * constants.stepInset) * Math.min(1, Math.max(0, normalizedPosition));
	            }
	            function positionToNormalizedValue(sliderOpts, position) {
	              var dims = sliderOpts._dims;
	              return Math.min(1, Math.max(0, (position - constants.stepInset - dims.inputAreaStart) / (dims.inputAreaLength - 2 * constants.stepInset - 2 * dims.inputAreaStart)));
	            }
	            function drawTouchRect(sliderGroup, gd, sliderOpts) {
	              var dims = sliderOpts._dims;
	              var rect = Lib.ensureSingle(sliderGroup, "rect", constants.railTouchRectClass, function(s) {
	                s.call(attachGripEvents, gd, sliderGroup, sliderOpts).style("pointer-events", "all");
	              });
	              rect.attr({
	                width: dims.inputAreaLength,
	                height: Math.max(dims.inputAreaWidth, constants.tickOffset + sliderOpts.ticklen + dims.labelHeight)
	              }).call(Color.fill, sliderOpts.bgcolor).attr("opacity", 0);
	              Drawing.setTranslate(rect, 0, dims.currentValueTotalHeight);
	            }
	            function drawRail(sliderGroup, sliderOpts) {
	              var dims = sliderOpts._dims;
	              var computedLength = dims.inputAreaLength - constants.railInset * 2;
	              var rect = Lib.ensureSingle(sliderGroup, "rect", constants.railRectClass);
	              rect.attr({
	                width: computedLength,
	                height: constants.railWidth,
	                rx: constants.railRadius,
	                ry: constants.railRadius,
	                "shape-rendering": "crispEdges"
	              }).call(Color.stroke, sliderOpts.bordercolor).call(Color.fill, sliderOpts.bgcolor).style("stroke-width", sliderOpts.borderwidth + "px");
	              Drawing.setTranslate(rect, constants.railInset, (dims.inputAreaWidth - constants.railWidth) * 0.5 + dims.currentValueTotalHeight);
	            }
	          }
	        ),
	        /***/
	        23243: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var constants = __webpack_require__2(98292);
	            module2.exports = {
	              moduleType: "component",
	              name: constants.name,
	              layoutAttributes: __webpack_require__2(75067),
	              supplyLayoutDefaults: __webpack_require__2(12343),
	              draw: __webpack_require__2(44504)
	            };
	          }
	        ),
	        /***/
	        92998: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Plots = __webpack_require__2(74875);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var svgTextUtils = __webpack_require__2(63893);
	            var interactConstants = __webpack_require__2(37822);
	            var OPPOSITE_SIDE = __webpack_require__2(18783).OPPOSITE_SIDE;
	            var numStripRE = / [XY][0-9]* /;
	            function draw(gd, titleClass, options) {
	              var cont = options.propContainer;
	              var prop = options.propName;
	              var placeholder = options.placeholder;
	              var traceIndex = options.traceIndex;
	              var avoid = options.avoid || {};
	              var attributes = options.attributes;
	              var transform = options.transform;
	              var group = options.containerGroup;
	              var fullLayout = gd._fullLayout;
	              var opacity = 1;
	              var isplaceholder = false;
	              var title = cont.title;
	              var txt = (title && title.text ? title.text : "").trim();
	              var font = title && title.font ? title.font : {};
	              var fontFamily = font.family;
	              var fontSize = font.size;
	              var fontColor = font.color;
	              var editAttr;
	              if (prop === "title.text") editAttr = "titleText";
	              else if (prop.indexOf("axis") !== -1) editAttr = "axisTitleText";
	              else if (prop.indexOf("colorbar" !== -1)) editAttr = "colorbarTitleText";
	              var editable = gd._context.edits[editAttr];
	              if (txt === "") opacity = 0;
	              else if (txt.replace(numStripRE, " % ") === placeholder.replace(numStripRE, " % ")) {
	                opacity = 0.2;
	                isplaceholder = true;
	                if (!editable) txt = "";
	              }
	              if (options._meta) {
	                txt = Lib.templateString(txt, options._meta);
	              } else if (fullLayout._meta) {
	                txt = Lib.templateString(txt, fullLayout._meta);
	              }
	              var elShouldExist = txt || editable;
	              var hColorbarMoveTitle;
	              if (!group) {
	                group = Lib.ensureSingle(fullLayout._infolayer, "g", "g-" + titleClass);
	                hColorbarMoveTitle = fullLayout._hColorbarMoveTitle;
	              }
	              var el = group.selectAll("text").data(elShouldExist ? [0] : []);
	              el.enter().append("text");
	              el.text(txt).attr("class", titleClass);
	              el.exit().remove();
	              if (!elShouldExist) return group;
	              function titleLayout(titleEl) {
	                Lib.syncOrAsync([drawTitle, scootTitle], titleEl);
	              }
	              function drawTitle(titleEl) {
	                var transformVal;
	                if (!transform && hColorbarMoveTitle) {
	                  transform = {};
	                }
	                if (transform) {
	                  transformVal = "";
	                  if (transform.rotate) {
	                    transformVal += "rotate(" + [transform.rotate, attributes.x, attributes.y] + ")";
	                  }
	                  if (transform.offset || hColorbarMoveTitle) {
	                    transformVal += strTranslate(0, (transform.offset || 0) - (hColorbarMoveTitle || 0));
	                  }
	                } else {
	                  transformVal = null;
	                }
	                titleEl.attr("transform", transformVal);
	                titleEl.style({
	                  "font-family": fontFamily,
	                  "font-size": d3.round(fontSize, 2) + "px",
	                  fill: Color.rgb(fontColor),
	                  opacity: opacity * Color.opacity(fontColor),
	                  "font-weight": Plots.fontWeight
	                }).attr(attributes).call(svgTextUtils.convertToTspans, gd);
	                return Plots.previousPromises(gd);
	              }
	              function scootTitle(titleElIn) {
	                var titleGroup = d3.select(titleElIn.node().parentNode);
	                if (avoid.selection && avoid.side && txt) {
	                  titleGroup.attr("transform", null);
	                  var backside = OPPOSITE_SIDE[avoid.side];
	                  var shiftSign = avoid.side === "left" || avoid.side === "top" ? -1 : 1;
	                  var pad = isNumeric(avoid.pad) ? avoid.pad : 2;
	                  var titlebb = Drawing.bBox(titleGroup.node());
	                  var reservedMargins = {
	                    t: 0,
	                    b: 0,
	                    l: 0,
	                    r: 0
	                  };
	                  var margins = gd._fullLayout._reservedMargin;
	                  for (var key in margins) {
	                    for (var side in margins[key]) {
	                      var val = margins[key][side];
	                      reservedMargins[side] = Math.max(reservedMargins[side], val);
	                    }
	                  }
	                  var paperbb = {
	                    left: reservedMargins.l,
	                    top: reservedMargins.t,
	                    right: fullLayout.width - reservedMargins.r,
	                    bottom: fullLayout.height - reservedMargins.b
	                  };
	                  var maxshift = avoid.maxShift || shiftSign * (paperbb[avoid.side] - titlebb[avoid.side]);
	                  var shift = 0;
	                  if (maxshift < 0) {
	                    shift = maxshift;
	                  } else {
	                    var offsetLeft = avoid.offsetLeft || 0;
	                    var offsetTop = avoid.offsetTop || 0;
	                    titlebb.left -= offsetLeft;
	                    titlebb.right -= offsetLeft;
	                    titlebb.top -= offsetTop;
	                    titlebb.bottom -= offsetTop;
	                    avoid.selection.each(function() {
	                      var avoidbb = Drawing.bBox(this);
	                      if (Lib.bBoxIntersect(titlebb, avoidbb, pad)) {
	                        shift = Math.max(shift, shiftSign * (avoidbb[avoid.side] - titlebb[backside]) + pad);
	                      }
	                    });
	                    shift = Math.min(maxshift, shift);
	                    cont._titleScoot = Math.abs(shift);
	                  }
	                  if (shift > 0 || maxshift < 0) {
	                    var shiftTemplate = {
	                      left: [-shift, 0],
	                      right: [shift, 0],
	                      top: [0, -shift],
	                      bottom: [0, shift]
	                    }[avoid.side];
	                    titleGroup.attr("transform", strTranslate(shiftTemplate[0], shiftTemplate[1]));
	                  }
	                }
	              }
	              el.call(titleLayout);
	              function setPlaceholder() {
	                opacity = 0;
	                isplaceholder = true;
	                el.text(placeholder).on("mouseover.opacity", function() {
	                  d3.select(this).transition().duration(interactConstants.SHOW_PLACEHOLDER).style("opacity", 1);
	                }).on("mouseout.opacity", function() {
	                  d3.select(this).transition().duration(interactConstants.HIDE_PLACEHOLDER).style("opacity", 0);
	                });
	              }
	              if (editable) {
	                if (!txt) setPlaceholder();
	                else el.on(".opacity", null);
	                el.call(svgTextUtils.makeEditable, {
	                  gd
	                }).on("edit", function(text) {
	                  if (traceIndex !== undefined) {
	                    Registry.call("_guiRestyle", gd, prop, text, traceIndex);
	                  } else {
	                    Registry.call("_guiRelayout", gd, prop, text);
	                  }
	                }).on("cancel", function() {
	                  this.text(this.attr("data-unformatted")).call(titleLayout);
	                }).on("input", function(d) {
	                  this.text(d || " ").call(svgTextUtils.positionText, attributes.x, attributes.y);
	                });
	              }
	              el.classed("js-placeholder", isplaceholder);
	              return group;
	            }
	            module2.exports = {
	              draw
	            };
	          }
	        ),
	        /***/
	        7163: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var padAttrs = __webpack_require__2(35025);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var buttonsAttrs = templatedArray("button", {
	              visible: {
	                valType: "boolean"
	              },
	              method: {
	                valType: "enumerated",
	                values: ["restyle", "relayout", "animate", "update", "skip"],
	                dflt: "restyle"
	              },
	              args: {
	                valType: "info_array",
	                freeLength: true,
	                items: [{
	                  valType: "any"
	                }, {
	                  valType: "any"
	                }, {
	                  valType: "any"
	                }]
	              },
	              args2: {
	                valType: "info_array",
	                freeLength: true,
	                items: [{
	                  valType: "any"
	                }, {
	                  valType: "any"
	                }, {
	                  valType: "any"
	                }]
	              },
	              label: {
	                valType: "string",
	                dflt: ""
	              },
	              execute: {
	                valType: "boolean",
	                dflt: true
	              }
	            });
	            module2.exports = overrideAll(templatedArray("updatemenu", {
	              _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
	              visible: {
	                valType: "boolean"
	              },
	              type: {
	                valType: "enumerated",
	                values: ["dropdown", "buttons"],
	                dflt: "dropdown"
	              },
	              direction: {
	                valType: "enumerated",
	                values: ["left", "right", "up", "down"],
	                dflt: "down"
	              },
	              active: {
	                valType: "integer",
	                min: -1,
	                dflt: 0
	              },
	              showactive: {
	                valType: "boolean",
	                dflt: true
	              },
	              buttons: buttonsAttrs,
	              x: {
	                valType: "number",
	                min: -2,
	                max: 3,
	                dflt: -0.05
	              },
	              xanchor: {
	                valType: "enumerated",
	                values: ["auto", "left", "center", "right"],
	                dflt: "right"
	              },
	              y: {
	                valType: "number",
	                min: -2,
	                max: 3,
	                dflt: 1
	              },
	              yanchor: {
	                valType: "enumerated",
	                values: ["auto", "top", "middle", "bottom"],
	                dflt: "top"
	              },
	              pad: extendFlat(padAttrs({
	                editType: "arraydraw"
	              }), {}),
	              font: fontAttrs({}),
	              bgcolor: {
	                valType: "color"
	              },
	              bordercolor: {
	                valType: "color",
	                dflt: colorAttrs.borderLine
	              },
	              borderwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "arraydraw"
	              }
	            }), "arraydraw", "from-root");
	          }
	        ),
	        /***/
	        75909: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // layout attribute name
	              name: "updatemenus",
	              // class names
	              containerClassName: "updatemenu-container",
	              headerGroupClassName: "updatemenu-header-group",
	              headerClassName: "updatemenu-header",
	              headerArrowClassName: "updatemenu-header-arrow",
	              dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
	              dropdownButtonClassName: "updatemenu-dropdown-button",
	              buttonClassName: "updatemenu-button",
	              itemRectClassName: "updatemenu-item-rect",
	              itemTextClassName: "updatemenu-item-text",
	              // DOM attribute name in button group keeping track
	              // of active update menu
	              menuIndexAttrName: "updatemenu-active-index",
	              // id root pass to Plots.autoMargin
	              autoMarginIdRoot: "updatemenu-",
	              // options when 'active: -1'
	              blankHeaderOpts: {
	                label: "  "
	              },
	              // min item width / height
	              minWidth: 30,
	              minHeight: 30,
	              // padding around item text
	              textPadX: 24,
	              arrowPadX: 16,
	              // item rect radii
	              rx: 2,
	              ry: 2,
	              // item  text x offset off left edge
	              textOffsetX: 12,
	              // item  text y offset (w.r.t. middle)
	              textOffsetY: 3,
	              // arrow offset off right edge
	              arrowOffsetX: 4,
	              // gap between header and buttons
	              gapButtonHeader: 5,
	              // gap between between buttons
	              gapButton: 2,
	              // color given to active buttons
	              activeColor: "#F4FAFF",
	              // color given to hovered buttons
	              hoverColor: "#F4FAFF",
	              // symbol for menu open arrow
	              arrowSymbol: {
	                left: "◄",
	                right: "►",
	                up: "▲",
	                down: "▼"
	              }
	            };
	          }
	        ),
	        /***/
	        64897: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(7163);
	            var constants = __webpack_require__2(75909);
	            var name2 = constants.name;
	            var buttonAttrs = attributes.buttons;
	            module2.exports = function updateMenusDefaults(layoutIn, layoutOut) {
	              var opts = {
	                name: name2,
	                handleItemDefaults: menuDefaults
	              };
	              handleArrayContainerDefaults(layoutIn, layoutOut, opts);
	            };
	            function menuDefaults(menuIn, menuOut, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(menuIn, menuOut, attributes, attr, dflt);
	              }
	              var buttons = handleArrayContainerDefaults(menuIn, menuOut, {
	                name: "buttons",
	                handleItemDefaults: buttonDefaults
	              });
	              var visible = coerce("visible", buttons.length > 0);
	              if (!visible) return;
	              coerce("active");
	              coerce("direction");
	              coerce("type");
	              coerce("showactive");
	              coerce("x");
	              coerce("y");
	              Lib.noneOrAll(menuIn, menuOut, ["x", "y"]);
	              coerce("xanchor");
	              coerce("yanchor");
	              coerce("pad.t");
	              coerce("pad.r");
	              coerce("pad.b");
	              coerce("pad.l");
	              Lib.coerceFont(coerce, "font", layoutOut.font);
	              coerce("bgcolor", layoutOut.paper_bgcolor);
	              coerce("bordercolor");
	              coerce("borderwidth");
	            }
	            function buttonDefaults(buttonIn, buttonOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(buttonIn, buttonOut, buttonAttrs, attr, dflt);
	              }
	              var visible = coerce("visible", buttonIn.method === "skip" || Array.isArray(buttonIn.args));
	              if (visible) {
	                coerce("method");
	                coerce("args");
	                coerce("args2");
	                coerce("label");
	                coerce("execute");
	              }
	            }
	          }
	        ),
	        /***/
	        13689: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Plots = __webpack_require__2(74875);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var svgTextUtils = __webpack_require__2(63893);
	            var arrayEditor = __webpack_require__2(44467).arrayEditor;
	            var LINE_SPACING = __webpack_require__2(18783).LINE_SPACING;
	            var constants = __webpack_require__2(75909);
	            var ScrollBox = __webpack_require__2(25849);
	            module2.exports = function draw(gd) {
	              var fullLayout = gd._fullLayout;
	              var menuData = Lib.filterVisible(fullLayout[constants.name]);
	              function clearAutoMargin(menuOpts2) {
	                Plots.autoMargin(gd, autoMarginId(menuOpts2));
	              }
	              var menus = fullLayout._menulayer.selectAll("g." + constants.containerClassName).data(menuData.length > 0 ? [0] : []);
	              menus.enter().append("g").classed(constants.containerClassName, true).style("cursor", "pointer");
	              menus.exit().each(function() {
	                d3.select(this).selectAll("g." + constants.headerGroupClassName).each(clearAutoMargin);
	              }).remove();
	              if (menuData.length === 0) return;
	              var headerGroups = menus.selectAll("g." + constants.headerGroupClassName).data(menuData, keyFunction);
	              headerGroups.enter().append("g").classed(constants.headerGroupClassName, true);
	              var gButton = Lib.ensureSingle(menus, "g", constants.dropdownButtonGroupClassName, function(s) {
	                s.style("pointer-events", "all");
	              });
	              for (var i = 0; i < menuData.length; i++) {
	                var menuOpts = menuData[i];
	                findDimensions(gd, menuOpts);
	              }
	              var scrollBoxId = "updatemenus" + fullLayout._uid;
	              var scrollBox = new ScrollBox(gd, gButton, scrollBoxId);
	              if (headerGroups.enter().size()) {
	                gButton.node().parentNode.appendChild(gButton.node());
	                gButton.call(removeAllButtons);
	              }
	              headerGroups.exit().each(function(menuOpts2) {
	                gButton.call(removeAllButtons);
	                clearAutoMargin(menuOpts2);
	              }).remove();
	              headerGroups.each(function(menuOpts2) {
	                var gHeader = d3.select(this);
	                var _gButton = menuOpts2.type === "dropdown" ? gButton : null;
	                Plots.manageCommandObserver(gd, menuOpts2, menuOpts2.buttons, function(data) {
	                  setActive(gd, menuOpts2, menuOpts2.buttons[data.index], gHeader, _gButton, scrollBox, data.index, true);
	                });
	                if (menuOpts2.type === "dropdown") {
	                  drawHeader(gd, gHeader, gButton, scrollBox, menuOpts2);
	                  if (isActive(gButton, menuOpts2)) {
	                    drawButtons(gd, gHeader, gButton, scrollBox, menuOpts2);
	                  }
	                } else {
	                  drawButtons(gd, gHeader, null, null, menuOpts2);
	                }
	              });
	            };
	            function keyFunction(menuOpts) {
	              return menuOpts._index;
	            }
	            function isFolded(gButton) {
	              return +gButton.attr(constants.menuIndexAttrName) === -1;
	            }
	            function isActive(gButton, menuOpts) {
	              return +gButton.attr(constants.menuIndexAttrName) === menuOpts._index;
	            }
	            function setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex, isSilentUpdate) {
	              menuOpts.active = buttonIndex;
	              arrayEditor(gd.layout, constants.name, menuOpts).applyUpdate("active", buttonIndex);
	              if (menuOpts.type === "buttons") {
	                drawButtons(gd, gHeader, null, null, menuOpts);
	              } else if (menuOpts.type === "dropdown") {
	                gButton.attr(constants.menuIndexAttrName, "-1");
	                drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);
	                if (!isSilentUpdate) {
	                  drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
	                }
	              }
	            }
	            function drawHeader(gd, gHeader, gButton, scrollBox, menuOpts) {
	              var header = Lib.ensureSingle(gHeader, "g", constants.headerClassName, function(s) {
	                s.style("pointer-events", "all");
	              });
	              var dims = menuOpts._dims;
	              var active = menuOpts.active;
	              var headerOpts = menuOpts.buttons[active] || constants.blankHeaderOpts;
	              var posOpts = {
	                y: menuOpts.pad.t,
	                yPad: 0,
	                x: menuOpts.pad.l,
	                xPad: 0,
	                index: 0
	              };
	              var positionOverrides = {
	                width: dims.headerWidth,
	                height: dims.headerHeight
	              };
	              header.call(drawItem, menuOpts, headerOpts, gd).call(setItemPosition, menuOpts, posOpts, positionOverrides);
	              var arrow = Lib.ensureSingle(gHeader, "text", constants.headerArrowClassName, function(s) {
	                s.attr("text-anchor", "end").call(Drawing.font, menuOpts.font).text(constants.arrowSymbol[menuOpts.direction]);
	              });
	              arrow.attr({
	                x: dims.headerWidth - constants.arrowOffsetX + menuOpts.pad.l,
	                y: dims.headerHeight / 2 + constants.textOffsetY + menuOpts.pad.t
	              });
	              header.on("click", function() {
	                gButton.call(removeAllButtons, String(isActive(gButton, menuOpts) ? -1 : menuOpts._index));
	                drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
	              });
	              header.on("mouseover", function() {
	                header.call(styleOnMouseOver);
	              });
	              header.on("mouseout", function() {
	                header.call(styleOnMouseOut, menuOpts);
	              });
	              Drawing.setTranslate(gHeader, dims.lx, dims.ly);
	            }
	            function drawButtons(gd, gHeader, gButton, scrollBox, menuOpts) {
	              if (!gButton) {
	                gButton = gHeader;
	                gButton.attr("pointer-events", "all");
	              }
	              var buttonData = !isFolded(gButton) || menuOpts.type === "buttons" ? menuOpts.buttons : [];
	              var klass = menuOpts.type === "dropdown" ? constants.dropdownButtonClassName : constants.buttonClassName;
	              var buttons = gButton.selectAll("g." + klass).data(Lib.filterVisible(buttonData));
	              var enter = buttons.enter().append("g").classed(klass, true);
	              var exit = buttons.exit();
	              if (menuOpts.type === "dropdown") {
	                enter.attr("opacity", "0").transition().attr("opacity", "1");
	                exit.transition().attr("opacity", "0").remove();
	              } else {
	                exit.remove();
	              }
	              var x0 = 0;
	              var y0 = 0;
	              var dims = menuOpts._dims;
	              var isVertical = ["up", "down"].indexOf(menuOpts.direction) !== -1;
	              if (menuOpts.type === "dropdown") {
	                if (isVertical) {
	                  y0 = dims.headerHeight + constants.gapButtonHeader;
	                } else {
	                  x0 = dims.headerWidth + constants.gapButtonHeader;
	                }
	              }
	              if (menuOpts.type === "dropdown" && menuOpts.direction === "up") {
	                y0 = -constants.gapButtonHeader + constants.gapButton - dims.openHeight;
	              }
	              if (menuOpts.type === "dropdown" && menuOpts.direction === "left") {
	                x0 = -constants.gapButtonHeader + constants.gapButton - dims.openWidth;
	              }
	              var posOpts = {
	                x: dims.lx + x0 + menuOpts.pad.l,
	                y: dims.ly + y0 + menuOpts.pad.t,
	                yPad: constants.gapButton,
	                xPad: constants.gapButton,
	                index: 0
	              };
	              var scrollBoxPosition = {
	                l: posOpts.x + menuOpts.borderwidth,
	                t: posOpts.y + menuOpts.borderwidth
	              };
	              buttons.each(function(buttonOpts, buttonIndex) {
	                var button = d3.select(this);
	                button.call(drawItem, menuOpts, buttonOpts, gd).call(setItemPosition, menuOpts, posOpts);
	                button.on("click", function() {
	                  if (d3.event.defaultPrevented) return;
	                  if (buttonOpts.execute) {
	                    if (buttonOpts.args2 && menuOpts.active === buttonIndex) {
	                      setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, -1);
	                      Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args2);
	                    } else {
	                      setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex);
	                      Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args);
	                    }
	                  }
	                  gd.emit("plotly_buttonclicked", {
	                    menu: menuOpts,
	                    button: buttonOpts,
	                    active: menuOpts.active
	                  });
	                });
	                button.on("mouseover", function() {
	                  button.call(styleOnMouseOver);
	                });
	                button.on("mouseout", function() {
	                  button.call(styleOnMouseOut, menuOpts);
	                  buttons.call(styleButtons, menuOpts);
	                });
	              });
	              buttons.call(styleButtons, menuOpts);
	              if (isVertical) {
	                scrollBoxPosition.w = Math.max(dims.openWidth, dims.headerWidth);
	                scrollBoxPosition.h = posOpts.y - scrollBoxPosition.t;
	              } else {
	                scrollBoxPosition.w = posOpts.x - scrollBoxPosition.l;
	                scrollBoxPosition.h = Math.max(dims.openHeight, dims.headerHeight);
	              }
	              scrollBoxPosition.direction = menuOpts.direction;
	              if (scrollBox) {
	                if (buttons.size()) {
	                  drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, scrollBoxPosition);
	                } else {
	                  hideScrollBox(scrollBox);
	                }
	              }
	            }
	            function drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, position) {
	              var direction = menuOpts.direction;
	              var isVertical = direction === "up" || direction === "down";
	              var dims = menuOpts._dims;
	              var active = menuOpts.active;
	              var translateX, translateY;
	              var i;
	              if (isVertical) {
	                translateY = 0;
	                for (i = 0; i < active; i++) {
	                  translateY += dims.heights[i] + constants.gapButton;
	                }
	              } else {
	                translateX = 0;
	                for (i = 0; i < active; i++) {
	                  translateX += dims.widths[i] + constants.gapButton;
	                }
	              }
	              scrollBox.enable(position, translateX, translateY);
	              if (scrollBox.hbar) {
	                scrollBox.hbar.attr("opacity", "0").transition().attr("opacity", "1");
	              }
	              if (scrollBox.vbar) {
	                scrollBox.vbar.attr("opacity", "0").transition().attr("opacity", "1");
	              }
	            }
	            function hideScrollBox(scrollBox) {
	              var hasHBar = !!scrollBox.hbar;
	              var hasVBar = !!scrollBox.vbar;
	              if (hasHBar) {
	                scrollBox.hbar.transition().attr("opacity", "0").each("end", function() {
	                  hasHBar = false;
	                  if (!hasVBar) scrollBox.disable();
	                });
	              }
	              if (hasVBar) {
	                scrollBox.vbar.transition().attr("opacity", "0").each("end", function() {
	                  hasVBar = false;
	                  if (!hasHBar) scrollBox.disable();
	                });
	              }
	            }
	            function drawItem(item, menuOpts, itemOpts, gd) {
	              item.call(drawItemRect, menuOpts).call(drawItemText, menuOpts, itemOpts, gd);
	            }
	            function drawItemRect(item, menuOpts) {
	              var rect = Lib.ensureSingle(item, "rect", constants.itemRectClassName, function(s) {
	                s.attr({
	                  rx: constants.rx,
	                  ry: constants.ry,
	                  "shape-rendering": "crispEdges"
	                });
	              });
	              rect.call(Color.stroke, menuOpts.bordercolor).call(Color.fill, menuOpts.bgcolor).style("stroke-width", menuOpts.borderwidth + "px");
	            }
	            function drawItemText(item, menuOpts, itemOpts, gd) {
	              var text = Lib.ensureSingle(item, "text", constants.itemTextClassName, function(s) {
	                s.attr({
	                  "text-anchor": "start",
	                  "data-notex": 1
	                });
	              });
	              var tx = itemOpts.label;
	              var _meta = gd._fullLayout._meta;
	              if (_meta) tx = Lib.templateString(tx, _meta);
	              text.call(Drawing.font, menuOpts.font).text(tx).call(svgTextUtils.convertToTspans, gd);
	            }
	            function styleButtons(buttons, menuOpts) {
	              var active = menuOpts.active;
	              buttons.each(function(buttonOpts, i) {
	                var button = d3.select(this);
	                if (i === active && menuOpts.showactive) {
	                  button.select("rect." + constants.itemRectClassName).call(Color.fill, constants.activeColor);
	                }
	              });
	            }
	            function styleOnMouseOver(item) {
	              item.select("rect." + constants.itemRectClassName).call(Color.fill, constants.hoverColor);
	            }
	            function styleOnMouseOut(item, menuOpts) {
	              item.select("rect." + constants.itemRectClassName).call(Color.fill, menuOpts.bgcolor);
	            }
	            function findDimensions(gd, menuOpts) {
	              var dims = menuOpts._dims = {
	                width1: 0,
	                height1: 0,
	                heights: [],
	                widths: [],
	                totalWidth: 0,
	                totalHeight: 0,
	                openWidth: 0,
	                openHeight: 0,
	                lx: 0,
	                ly: 0
	              };
	              var fakeButtons = Drawing.tester.selectAll("g." + constants.dropdownButtonClassName).data(Lib.filterVisible(menuOpts.buttons));
	              fakeButtons.enter().append("g").classed(constants.dropdownButtonClassName, true);
	              var isVertical = ["up", "down"].indexOf(menuOpts.direction) !== -1;
	              fakeButtons.each(function(buttonOpts, i) {
	                var button = d3.select(this);
	                button.call(drawItem, menuOpts, buttonOpts, gd);
	                var text = button.select("." + constants.itemTextClassName);
	                var tWidth = text.node() && Drawing.bBox(text.node()).width;
	                var wEff = Math.max(tWidth + constants.textPadX, constants.minWidth);
	                var tHeight = menuOpts.font.size * LINE_SPACING;
	                var tLines = svgTextUtils.lineCount(text);
	                var hEff = Math.max(tHeight * tLines, constants.minHeight) + constants.textOffsetY;
	                hEff = Math.ceil(hEff);
	                wEff = Math.ceil(wEff);
	                dims.widths[i] = wEff;
	                dims.heights[i] = hEff;
	                dims.height1 = Math.max(dims.height1, hEff);
	                dims.width1 = Math.max(dims.width1, wEff);
	                if (isVertical) {
	                  dims.totalWidth = Math.max(dims.totalWidth, wEff);
	                  dims.openWidth = dims.totalWidth;
	                  dims.totalHeight += hEff + constants.gapButton;
	                  dims.openHeight += hEff + constants.gapButton;
	                } else {
	                  dims.totalWidth += wEff + constants.gapButton;
	                  dims.openWidth += wEff + constants.gapButton;
	                  dims.totalHeight = Math.max(dims.totalHeight, hEff);
	                  dims.openHeight = dims.totalHeight;
	                }
	              });
	              if (isVertical) {
	                dims.totalHeight -= constants.gapButton;
	              } else {
	                dims.totalWidth -= constants.gapButton;
	              }
	              dims.headerWidth = dims.width1 + constants.arrowPadX;
	              dims.headerHeight = dims.height1;
	              if (menuOpts.type === "dropdown") {
	                if (isVertical) {
	                  dims.width1 += constants.arrowPadX;
	                  dims.totalHeight = dims.height1;
	                } else {
	                  dims.totalWidth = dims.width1;
	                }
	                dims.totalWidth += constants.arrowPadX;
	              }
	              fakeButtons.remove();
	              var paddedWidth = dims.totalWidth + menuOpts.pad.l + menuOpts.pad.r;
	              var paddedHeight = dims.totalHeight + menuOpts.pad.t + menuOpts.pad.b;
	              var graphSize = gd._fullLayout._size;
	              dims.lx = graphSize.l + graphSize.w * menuOpts.x;
	              dims.ly = graphSize.t + graphSize.h * (1 - menuOpts.y);
	              var xanchor = "left";
	              if (Lib.isRightAnchor(menuOpts)) {
	                dims.lx -= paddedWidth;
	                xanchor = "right";
	              }
	              if (Lib.isCenterAnchor(menuOpts)) {
	                dims.lx -= paddedWidth / 2;
	                xanchor = "center";
	              }
	              var yanchor = "top";
	              if (Lib.isBottomAnchor(menuOpts)) {
	                dims.ly -= paddedHeight;
	                yanchor = "bottom";
	              }
	              if (Lib.isMiddleAnchor(menuOpts)) {
	                dims.ly -= paddedHeight / 2;
	                yanchor = "middle";
	              }
	              dims.totalWidth = Math.ceil(dims.totalWidth);
	              dims.totalHeight = Math.ceil(dims.totalHeight);
	              dims.lx = Math.round(dims.lx);
	              dims.ly = Math.round(dims.ly);
	              Plots.autoMargin(gd, autoMarginId(menuOpts), {
	                x: menuOpts.x,
	                y: menuOpts.y,
	                l: paddedWidth * ({
	                  right: 1,
	                  center: 0.5
	                }[xanchor] || 0),
	                r: paddedWidth * ({
	                  left: 1,
	                  center: 0.5
	                }[xanchor] || 0),
	                b: paddedHeight * ({
	                  top: 1,
	                  middle: 0.5
	                }[yanchor] || 0),
	                t: paddedHeight * ({
	                  bottom: 1,
	                  middle: 0.5
	                }[yanchor] || 0)
	              });
	            }
	            function autoMarginId(menuOpts) {
	              return constants.autoMarginIdRoot + menuOpts._index;
	            }
	            function setItemPosition(item, menuOpts, posOpts, overrideOpts) {
	              overrideOpts = overrideOpts || {};
	              var rect = item.select("." + constants.itemRectClassName);
	              var text = item.select("." + constants.itemTextClassName);
	              var borderWidth = menuOpts.borderwidth;
	              var index = posOpts.index;
	              var dims = menuOpts._dims;
	              Drawing.setTranslate(item, borderWidth + posOpts.x, borderWidth + posOpts.y);
	              var isVertical = ["up", "down"].indexOf(menuOpts.direction) !== -1;
	              var finalHeight = overrideOpts.height || (isVertical ? dims.heights[index] : dims.height1);
	              rect.attr({
	                x: 0,
	                y: 0,
	                width: overrideOpts.width || (isVertical ? dims.width1 : dims.widths[index]),
	                height: finalHeight
	              });
	              var tHeight = menuOpts.font.size * LINE_SPACING;
	              var tLines = svgTextUtils.lineCount(text);
	              var spanOffset = (tLines - 1) * tHeight / 2;
	              svgTextUtils.positionText(text, constants.textOffsetX, finalHeight / 2 - spanOffset + constants.textOffsetY);
	              if (isVertical) {
	                posOpts.y += dims.heights[index] + posOpts.yPad;
	              } else {
	                posOpts.x += dims.widths[index] + posOpts.xPad;
	              }
	              posOpts.index++;
	            }
	            function removeAllButtons(gButton, newMenuIndexAttr) {
	              gButton.attr(constants.menuIndexAttrName, newMenuIndexAttr || "-1").selectAll("g." + constants.dropdownButtonClassName).remove();
	            }
	          }
	        ),
	        /***/
	        20763: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var constants = __webpack_require__2(75909);
	            module2.exports = {
	              moduleType: "component",
	              name: constants.name,
	              layoutAttributes: __webpack_require__2(7163),
	              supplyLayoutDefaults: __webpack_require__2(64897),
	              draw: __webpack_require__2(13689)
	            };
	          }
	        ),
	        /***/
	        25849: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = ScrollBox;
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            function ScrollBox(gd, container, id) {
	              this.gd = gd;
	              this.container = container;
	              this.id = id;
	              this.position = null;
	              this.translateX = null;
	              this.translateY = null;
	              this.hbar = null;
	              this.vbar = null;
	              this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]);
	              this.bg.exit().on(".drag", null).on("wheel", null).remove();
	              this.bg.enter().append("rect").classed("scrollbox-bg", true).style("pointer-events", "all").attr({
	                opacity: 0,
	                x: 0,
	                y: 0,
	                width: 0,
	                height: 0
	              });
	            }
	            ScrollBox.barWidth = 2;
	            ScrollBox.barLength = 20;
	            ScrollBox.barRadius = 2;
	            ScrollBox.barPad = 1;
	            ScrollBox.barColor = "#808BA4";
	            ScrollBox.prototype.enable = function enable(position, translateX, translateY) {
	              var fullLayout = this.gd._fullLayout;
	              var fullWidth = fullLayout.width;
	              var fullHeight = fullLayout.height;
	              this.position = position;
	              var l = this.position.l;
	              var w = this.position.w;
	              var t = this.position.t;
	              var h = this.position.h;
	              var direction = this.position.direction;
	              var isDown = direction === "down";
	              var isLeft = direction === "left";
	              var isRight = direction === "right";
	              var isUp = direction === "up";
	              var boxW = w;
	              var boxH = h;
	              var boxL, boxR;
	              var boxT, boxB;
	              if (!isDown && !isLeft && !isRight && !isUp) {
	                this.position.direction = "down";
	                isDown = true;
	              }
	              var isVertical = isDown || isUp;
	              if (isVertical) {
	                boxL = l;
	                boxR = boxL + boxW;
	                if (isDown) {
	                  boxT = t;
	                  boxB = Math.min(boxT + boxH, fullHeight);
	                  boxH = boxB - boxT;
	                } else {
	                  boxB = t + boxH;
	                  boxT = Math.max(boxB - boxH, 0);
	                  boxH = boxB - boxT;
	                }
	              } else {
	                boxT = t;
	                boxB = boxT + boxH;
	                if (isLeft) {
	                  boxR = l + boxW;
	                  boxL = Math.max(boxR - boxW, 0);
	                  boxW = boxR - boxL;
	                } else {
	                  boxL = l;
	                  boxR = Math.min(boxL + boxW, fullWidth);
	                  boxW = boxR - boxL;
	                }
	              }
	              this._box = {
	                l: boxL,
	                t: boxT,
	                w: boxW,
	                h: boxH
	              };
	              var needsHorizontalScrollBar = w > boxW;
	              var hbarW = ScrollBox.barLength + 2 * ScrollBox.barPad;
	              var hbarH = ScrollBox.barWidth + 2 * ScrollBox.barPad;
	              var hbarL = l;
	              var hbarT = t + h;
	              if (hbarT + hbarH > fullHeight) hbarT = fullHeight - hbarH;
	              var hbar = this.container.selectAll("rect.scrollbar-horizontal").data(needsHorizontalScrollBar ? [0] : []);
	              hbar.exit().on(".drag", null).remove();
	              hbar.enter().append("rect").classed("scrollbar-horizontal", true).call(Color.fill, ScrollBox.barColor);
	              if (needsHorizontalScrollBar) {
	                this.hbar = hbar.attr({
	                  rx: ScrollBox.barRadius,
	                  ry: ScrollBox.barRadius,
	                  x: hbarL,
	                  y: hbarT,
	                  width: hbarW,
	                  height: hbarH
	                });
	                this._hbarXMin = hbarL + hbarW / 2;
	                this._hbarTranslateMax = boxW - hbarW;
	              } else {
	                delete this.hbar;
	                delete this._hbarXMin;
	                delete this._hbarTranslateMax;
	              }
	              var needsVerticalScrollBar = h > boxH;
	              var vbarW = ScrollBox.barWidth + 2 * ScrollBox.barPad;
	              var vbarH = ScrollBox.barLength + 2 * ScrollBox.barPad;
	              var vbarL = l + w;
	              var vbarT = t;
	              if (vbarL + vbarW > fullWidth) vbarL = fullWidth - vbarW;
	              var vbar = this.container.selectAll("rect.scrollbar-vertical").data(needsVerticalScrollBar ? [0] : []);
	              vbar.exit().on(".drag", null).remove();
	              vbar.enter().append("rect").classed("scrollbar-vertical", true).call(Color.fill, ScrollBox.barColor);
	              if (needsVerticalScrollBar) {
	                this.vbar = vbar.attr({
	                  rx: ScrollBox.barRadius,
	                  ry: ScrollBox.barRadius,
	                  x: vbarL,
	                  y: vbarT,
	                  width: vbarW,
	                  height: vbarH
	                });
	                this._vbarYMin = vbarT + vbarH / 2;
	                this._vbarTranslateMax = boxH - vbarH;
	              } else {
	                delete this.vbar;
	                delete this._vbarYMin;
	                delete this._vbarTranslateMax;
	              }
	              var clipId = this.id;
	              var clipL = boxL - 0.5;
	              var clipR = needsVerticalScrollBar ? boxR + vbarW + 0.5 : boxR + 0.5;
	              var clipT = boxT - 0.5;
	              var clipB = needsHorizontalScrollBar ? boxB + hbarH + 0.5 : boxB + 0.5;
	              var clipPath = fullLayout._topdefs.selectAll("#" + clipId).data(needsHorizontalScrollBar || needsVerticalScrollBar ? [0] : []);
	              clipPath.exit().remove();
	              clipPath.enter().append("clipPath").attr("id", clipId).append("rect");
	              if (needsHorizontalScrollBar || needsVerticalScrollBar) {
	                this._clipRect = clipPath.select("rect").attr({
	                  x: Math.floor(clipL),
	                  y: Math.floor(clipT),
	                  width: Math.ceil(clipR) - Math.floor(clipL),
	                  height: Math.ceil(clipB) - Math.floor(clipT)
	                });
	                this.container.call(Drawing.setClipUrl, clipId, this.gd);
	                this.bg.attr({
	                  x: l,
	                  y: t,
	                  width: w,
	                  height: h
	                });
	              } else {
	                this.bg.attr({
	                  width: 0,
	                  height: 0
	                });
	                this.container.on("wheel", null).on(".drag", null).call(Drawing.setClipUrl, null);
	                delete this._clipRect;
	              }
	              if (needsHorizontalScrollBar || needsVerticalScrollBar) {
	                var onBoxDrag = d3.behavior.drag().on("dragstart", function() {
	                  d3.event.sourceEvent.preventDefault();
	                }).on("drag", this._onBoxDrag.bind(this));
	                this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(onBoxDrag);
	                var onBarDrag = d3.behavior.drag().on("dragstart", function() {
	                  d3.event.sourceEvent.preventDefault();
	                  d3.event.sourceEvent.stopPropagation();
	                }).on("drag", this._onBarDrag.bind(this));
	                if (needsHorizontalScrollBar) {
	                  this.hbar.on(".drag", null).call(onBarDrag);
	                }
	                if (needsVerticalScrollBar) {
	                  this.vbar.on(".drag", null).call(onBarDrag);
	                }
	              }
	              this.setTranslate(translateX, translateY);
	            };
	            ScrollBox.prototype.disable = function disable() {
	              if (this.hbar || this.vbar) {
	                this.bg.attr({
	                  width: 0,
	                  height: 0
	                });
	                this.container.on("wheel", null).on(".drag", null).call(Drawing.setClipUrl, null);
	                delete this._clipRect;
	              }
	              if (this.hbar) {
	                this.hbar.on(".drag", null);
	                this.hbar.remove();
	                delete this.hbar;
	                delete this._hbarXMin;
	                delete this._hbarTranslateMax;
	              }
	              if (this.vbar) {
	                this.vbar.on(".drag", null);
	                this.vbar.remove();
	                delete this.vbar;
	                delete this._vbarYMin;
	                delete this._vbarTranslateMax;
	              }
	            };
	            ScrollBox.prototype._onBoxDrag = function _onBoxDrag() {
	              var translateX = this.translateX;
	              var translateY = this.translateY;
	              if (this.hbar) {
	                translateX -= d3.event.dx;
	              }
	              if (this.vbar) {
	                translateY -= d3.event.dy;
	              }
	              this.setTranslate(translateX, translateY);
	            };
	            ScrollBox.prototype._onBoxWheel = function _onBoxWheel() {
	              var translateX = this.translateX;
	              var translateY = this.translateY;
	              if (this.hbar) {
	                translateX += d3.event.deltaY;
	              }
	              if (this.vbar) {
	                translateY += d3.event.deltaY;
	              }
	              this.setTranslate(translateX, translateY);
	            };
	            ScrollBox.prototype._onBarDrag = function _onBarDrag() {
	              var translateX = this.translateX;
	              var translateY = this.translateY;
	              if (this.hbar) {
	                var xMin = translateX + this._hbarXMin;
	                var xMax = xMin + this._hbarTranslateMax;
	                var x = Lib.constrain(d3.event.x, xMin, xMax);
	                var xf = (x - xMin) / (xMax - xMin);
	                var translateXMax = this.position.w - this._box.w;
	                translateX = xf * translateXMax;
	              }
	              if (this.vbar) {
	                var yMin = translateY + this._vbarYMin;
	                var yMax = yMin + this._vbarTranslateMax;
	                var y = Lib.constrain(d3.event.y, yMin, yMax);
	                var yf = (y - yMin) / (yMax - yMin);
	                var translateYMax = this.position.h - this._box.h;
	                translateY = yf * translateYMax;
	              }
	              this.setTranslate(translateX, translateY);
	            };
	            ScrollBox.prototype.setTranslate = function setTranslate(translateX, translateY) {
	              var translateXMax = this.position.w - this._box.w;
	              var translateYMax = this.position.h - this._box.h;
	              translateX = Lib.constrain(translateX || 0, 0, translateXMax);
	              translateY = Lib.constrain(translateY || 0, 0, translateYMax);
	              this.translateX = translateX;
	              this.translateY = translateY;
	              this.container.call(Drawing.setTranslate, this._box.l - this.position.l - translateX, this._box.t - this.position.t - translateY);
	              if (this._clipRect) {
	                this._clipRect.attr({
	                  x: Math.floor(this.position.l + translateX - 0.5),
	                  y: Math.floor(this.position.t + translateY - 0.5)
	                });
	              }
	              if (this.hbar) {
	                var xf = translateX / translateXMax;
	                this.hbar.call(Drawing.setTranslate, translateX + xf * this._hbarTranslateMax, translateY);
	              }
	              if (this.vbar) {
	                var yf = translateY / translateYMax;
	                this.vbar.call(Drawing.setTranslate, translateX, translateY + yf * this._vbarTranslateMax);
	              }
	            };
	          }
	        ),
	        /***/
	        18783: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // from bottom left: this is the origin of our paper-reference
	              // positioning system
	              FROM_BL: {
	                left: 0,
	                center: 0.5,
	                right: 1,
	                bottom: 0,
	                middle: 0.5,
	                top: 1
	              },
	              // from top left: this is the screen pixel positioning origin
	              FROM_TL: {
	                left: 0,
	                center: 0.5,
	                right: 1,
	                bottom: 1,
	                middle: 0.5,
	                top: 0
	              },
	              // from bottom right: sometimes you just need the opposite of ^^
	              FROM_BR: {
	                left: 1,
	                center: 0.5,
	                right: 0,
	                bottom: 0,
	                middle: 0.5,
	                top: 1
	              },
	              // multiple of fontSize to get the vertical offset between lines
	              LINE_SPACING: 1.3,
	              // multiple of fontSize to shift from the baseline
	              // to the cap (captical letter) line
	              // (to use when we don't calculate this shift from Drawing.bBox)
	              // This is an approximation since in reality cap height can differ
	              // from font to font. However, according to Wikipedia
	              //   an "average" font might have a cap height of 70% of the em
	              // https://en.wikipedia.org/wiki/Em_(typography)#History
	              CAP_SHIFT: 0.7,
	              // half the cap height (distance between baseline and cap line)
	              // of an "average" font (for more info see above).
	              MID_SHIFT: 0.35,
	              OPPOSITE_SIDE: {
	                left: "right",
	                right: "left",
	                top: "bottom",
	                bottom: "top"
	              }
	            };
	          }
	        ),
	        /***/
	        24695: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              axisRefDescription: function(axisname, lower, upper) {
	                return ["If set to a", axisname, "axis id (e.g. *" + axisname + "* or", "*" + axisname + "2*), the `" + axisname + "` position refers to a", axisname, "coordinate. If set to *paper*, the `" + axisname + "`", "position refers to the distance from the", lower, "of the plotting", "area in normalized coordinates where *0* (*1*) corresponds to the", lower, "(" + upper + "). If set to a", axisname, "axis ID followed by", "*domain* (separated by a space), the position behaves like for", "*paper*, but refers to the distance in fractions of the domain", "length from the", lower, "of the domain of that axis: e.g.,", "*" + axisname + "2 domain* refers to the domain of the second", axisname, " axis and a", axisname, "position of 0.5 refers to the", "point between the", lower, "and the", upper, "of the domain of the", "second", axisname, "axis."].join(" ");
	              }
	            };
	          }
	        ),
	        /***/
	        22372: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              INCREASING: {
	                COLOR: "#3D9970",
	                SYMBOL: "▲"
	              },
	              DECREASING: {
	                COLOR: "#FF4136",
	                SYMBOL: "▼"
	              }
	            };
	          }
	        ),
	        /***/
	        31562: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
	              DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
	            };
	          }
	        ),
	        /***/
	        74808: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              COMPARISON_OPS: ["=", "!=", "<", ">=", ">", "<="],
	              COMPARISON_OPS2: ["=", "<", ">=", ">", "<="],
	              INTERVAL_OPS: ["[]", "()", "[)", "(]", "][", ")(", "](", ")["],
	              SET_OPS: ["{}", "}{"],
	              CONSTRAINT_REDUCTION: {
	                // for contour constraints, open/closed endpoints are equivalent
	                "=": "=",
	                "<": "<",
	                "<=": "<",
	                ">": ">",
	                ">=": ">",
	                "[]": "[]",
	                "()": "[]",
	                "[)": "[]",
	                "(]": "[]",
	                "][": "][",
	                ")(": "][",
	                "](": "][",
	                ")[": "]["
	              }
	            };
	          }
	        ),
	        /***/
	        29659: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              solid: [[], 0],
	              dot: [[0.5, 1], 200],
	              dash: [[0.5, 1], 50],
	              longdash: [[0.5, 1], 10],
	              dashdot: [[0.5, 0.625, 0.875, 1], 50],
	              longdashdot: [[0.5, 0.7, 0.8, 1], 10]
	            };
	          }
	        ),
	        /***/
	        87381: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              circle: "●",
	              "circle-open": "○",
	              square: "■",
	              "square-open": "□",
	              diamond: "◆",
	              "diamond-open": "◇",
	              cross: "+",
	              x: "❌"
	            };
	          }
	        ),
	        /***/
	        37822: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              /**
	               * Timing information for interactive elements
	               */
	              SHOW_PLACEHOLDER: 100,
	              HIDE_PLACEHOLDER: 1e3,
	              // opacity dimming fraction for points that are not in selection
	              DESELECTDIM: 0.2
	            };
	          }
	        ),
	        /***/
	        50606: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              /**
	               * Standardize all missing data in calcdata to use undefined
	               * never null or NaN.
	               * That way we can use !==undefined, or !== BADNUM,
	               * to test for real data
	               */
	              BADNUM: undefined,
	              /*
	               * Limit certain operations to well below floating point max value
	               * to avoid glitches: Make sure that even when you multiply it by the
	               * number of pixels on a giant screen it still works
	               */
	              FP_SAFE: Number.MAX_VALUE * 1e-4,
	              /*
	               * conversion of date units to milliseconds
	               * year and month constants are marked "AVG"
	               * to remind us that not all years and months
	               * have the same length
	               */
	              ONEMAXYEAR: 316224e5,
	              // 366 * ONEDAY
	              ONEAVGYEAR: 315576e5,
	              // 365.25 days
	              ONEMINYEAR: 31536e6,
	              // 365 * ONEDAY
	              ONEMAXQUARTER: 79488e5,
	              // 92 * ONEDAY
	              ONEAVGQUARTER: 78894e5,
	              // 1/4 of ONEAVGYEAR
	              ONEMINQUARTER: 76896e5,
	              // 89 * ONEDAY
	              ONEMAXMONTH: 26784e5,
	              // 31 * ONEDAY
	              ONEAVGMONTH: 26298e5,
	              // 1/12 of ONEAVGYEAR
	              ONEMINMONTH: 24192e5,
	              // 28 * ONEDAY
	              ONEWEEK: 6048e5,
	              // 7 * ONEDAY
	              ONEDAY: 864e5,
	              // 24 * ONEHOUR
	              ONEHOUR: 36e5,
	              ONEMIN: 6e4,
	              ONESEC: 1e3,
	              /*
	               * For fast conversion btwn world calendars and epoch ms, the Julian Day Number
	               * of the unix epoch. From calendars.instance().newDate(1970, 1, 1).toJD()
	               */
	              EPOCHJD: 24405875e-1,
	              /*
	               * Are two values nearly equal? Compare to 1PPM
	               */
	              ALMOST_EQUAL: 1 - 1e-6,
	              /*
	               * If we're asked to clip a non-positive log value, how far off-screen
	               * do we put it?
	               */
	              LOG_CLIP: 10,
	              /*
	               * not a number, but for displaying numbers: the "minus sign" symbol is
	               * wider than the regular ascii dash "-"
	               */
	              MINUS_SIGN: "−"
	            };
	          }
	        ),
	        /***/
	        32396: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.CSS_DECLARATIONS = [["image-rendering", "optimizeSpeed"], ["image-rendering", "-moz-crisp-edges"], ["image-rendering", "-o-crisp-edges"], ["image-rendering", "-webkit-optimize-contrast"], ["image-rendering", "optimize-contrast"], ["image-rendering", "crisp-edges"], ["image-rendering", "pixelated"]];
	            exports2.STYLE = exports2.CSS_DECLARATIONS.map(function(d) {
	              return d.join(": ") + "; ";
	            }).join("");
	          }
	        ),
	        /***/
	        77922: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.xmlns = "http://www.w3.org/2000/xmlns/";
	            exports2.svg = "http://www.w3.org/2000/svg";
	            exports2.xlink = "http://www.w3.org/1999/xlink";
	            exports2.svgAttrs = {
	              xmlns: exports2.svg,
	              "xmlns:xlink": exports2.xlink
	            };
	          }
	        ),
	        /***/
	        8729: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            exports2.version = __webpack_require__2(11506).version;
	            __webpack_require__2(7417);
	            __webpack_require__2(98847);
	            var Registry = __webpack_require__2(73972);
	            var register = exports2.register = Registry.register;
	            var plotApi = __webpack_require__2(10641);
	            var methodNames = Object.keys(plotApi);
	            for (var i = 0; i < methodNames.length; i++) {
	              var name2 = methodNames[i];
	              if (name2.charAt(0) !== "_") exports2[name2] = plotApi[name2];
	              register({
	                moduleType: "apiMethod",
	                name: name2,
	                fn: plotApi[name2]
	              });
	            }
	            register(__webpack_require__2(67368));
	            register([
	              __webpack_require__2(32745),
	              __webpack_require__2(2468),
	              __webpack_require__2(47322),
	              __webpack_require__2(89853),
	              __webpack_require__2(68804),
	              __webpack_require__2(20763),
	              __webpack_require__2(23243),
	              __webpack_require__2(13137),
	              __webpack_require__2(97218),
	              __webpack_require__2(83312),
	              __webpack_require__2(37369),
	              __webpack_require__2(21081),
	              __webpack_require__2(12311),
	              __webpack_require__2(2199),
	              // legend needs to come after shape | legend defaults depends on shapes
	              __webpack_require__2(30211),
	              // fx needs to come after legend | unified hover defaults depends on legends
	              __webpack_require__2(64168)
	            ]);
	            register([__webpack_require__2(92177), __webpack_require__2(37815)]);
	            if (window.PlotlyLocales && Array.isArray(window.PlotlyLocales)) {
	              register(window.PlotlyLocales);
	              delete window.PlotlyLocales;
	            }
	            exports2.Icons = __webpack_require__2(24255);
	            var Fx = __webpack_require__2(30211);
	            var Plots = __webpack_require__2(74875);
	            exports2.Plots = {
	              resize: Plots.resize,
	              graphJson: Plots.graphJson,
	              sendDataToCloud: Plots.sendDataToCloud
	            };
	            exports2.Fx = {
	              hover: Fx.hover,
	              unhover: Fx.unhover,
	              loneHover: Fx.loneHover,
	              loneUnhover: Fx.loneUnhover
	            };
	            exports2.Snapshot = __webpack_require__2(44511);
	            exports2.PlotSchema = __webpack_require__2(86281);
	          }
	        ),
	        /***/
	        24255: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              undo: {
	                width: 857.1,
	                height: 1e3,
	                path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              home: {
	                width: 928.6,
	                height: 1e3,
	                path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              "camera-retro": {
	                width: 1e3,
	                height: 1e3,
	                path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              zoombox: {
	                width: 1e3,
	                height: 1e3,
	                path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              pan: {
	                width: 1e3,
	                height: 1e3,
	                path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              zoom_plus: {
	                width: 875,
	                height: 1e3,
	                path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              zoom_minus: {
	                width: 875,
	                height: 1e3,
	                path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              autoscale: {
	                width: 1e3,
	                height: 1e3,
	                path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              tooltip_basic: {
	                width: 1500,
	                height: 1e3,
	                path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              tooltip_compare: {
	                width: 1125,
	                height: 1e3,
	                path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              plotlylogo: {
	                width: 1542,
	                height: 1e3,
	                path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              "z-axis": {
	                width: 1e3,
	                height: 1e3,
	                path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              "3d_rotate": {
	                width: 1e3,
	                height: 1e3,
	                path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              camera: {
	                width: 1e3,
	                height: 1e3,
	                path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              movie: {
	                width: 1e3,
	                height: 1e3,
	                path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              question: {
	                width: 857.1,
	                height: 1e3,
	                path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              disk: {
	                width: 857.1,
	                height: 1e3,
	                path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              drawopenpath: {
	                width: 70,
	                height: 70,
	                path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
	                transform: "matrix(1 0 0 1 -15 -15)"
	              },
	              drawclosedpath: {
	                width: 90,
	                height: 90,
	                path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
	                transform: "matrix(1 0 0 1 -5 -5)"
	              },
	              lasso: {
	                width: 1031,
	                height: 1e3,
	                path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              selectbox: {
	                width: 1e3,
	                height: 1e3,
	                path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
	                transform: "matrix(1 0 0 -1 0 850)"
	              },
	              drawline: {
	                width: 70,
	                height: 70,
	                path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
	                transform: "matrix(1 0 0 1 -15 -15)"
	              },
	              drawrect: {
	                width: 80,
	                height: 80,
	                path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
	                transform: "matrix(1 0 0 1 -10 -10)"
	              },
	              drawcircle: {
	                width: 80,
	                height: 80,
	                path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
	                transform: "matrix(1 0 0 1 -10 -10)"
	              },
	              eraseshape: {
	                width: 80,
	                height: 80,
	                path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
	                transform: "matrix(1 0 0 1 -10 -10)"
	              },
	              spikeline: {
	                width: 1e3,
	                height: 1e3,
	                path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
	                transform: "matrix(1.5 0 0 -1.5 0 850)"
	              },
	              pencil: {
	                width: 1792,
	                height: 1792,
	                path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
	                transform: "matrix(1 0 0 1 0 1)"
	              },
	              newplotlylogo: {
	                name: "newplotlylogo",
	                svg: ["<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>", "<defs>", " <style>", "  .cls-0{fill:#000;}", "  .cls-1{fill:#FFF;}", "  .cls-2{fill:#F26;}", "  .cls-3{fill:#D69;}", "  .cls-4{fill:#BAC;}", "  .cls-5{fill:#9EF;}", " </style>", "</defs>", " <title>plotly-logomark</title>", " <g id='symbol'>", "  <rect class='cls-0' x='0' y='0' width='132' height='132' rx='18' ry='18'/>", "  <circle class='cls-5' cx='102' cy='30' r='6'/>", "  <circle class='cls-4' cx='78' cy='30' r='6'/>", "  <circle class='cls-4' cx='78' cy='54' r='6'/>", "  <circle class='cls-3' cx='54' cy='30' r='6'/>", "  <circle class='cls-2' cx='30' cy='30' r='6'/>", "  <circle class='cls-2' cx='30' cy='54' r='6'/>", "  <path class='cls-1' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>", "  <path class='cls-1' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>", "  <path class='cls-1' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>", "  <path class='cls-1' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>", " </g>", "</svg>"].join("")
	              }
	            };
	          }
	        ),
	        /***/
	        99863: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.isLeftAnchor = function isLeftAnchor(opts) {
	              return opts.xanchor === "left" || opts.xanchor === "auto" && opts.x <= 1 / 3;
	            };
	            exports2.isCenterAnchor = function isCenterAnchor(opts) {
	              return opts.xanchor === "center" || opts.xanchor === "auto" && opts.x > 1 / 3 && opts.x < 2 / 3;
	            };
	            exports2.isRightAnchor = function isRightAnchor(opts) {
	              return opts.xanchor === "right" || opts.xanchor === "auto" && opts.x >= 2 / 3;
	            };
	            exports2.isTopAnchor = function isTopAnchor(opts) {
	              return opts.yanchor === "top" || opts.yanchor === "auto" && opts.y >= 2 / 3;
	            };
	            exports2.isMiddleAnchor = function isMiddleAnchor(opts) {
	              return opts.yanchor === "middle" || opts.yanchor === "auto" && opts.y > 1 / 3 && opts.y < 2 / 3;
	            };
	            exports2.isBottomAnchor = function isBottomAnchor(opts) {
	              return opts.yanchor === "bottom" || opts.yanchor === "auto" && opts.y <= 1 / 3;
	            };
	          }
	        ),
	        /***/
	        26348: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var modModule = __webpack_require__2(64872);
	            var mod = modModule.mod;
	            var modHalf = modModule.modHalf;
	            var PI = Math.PI;
	            var twoPI = 2 * PI;
	            function deg2rad(deg) {
	              return deg / 180 * PI;
	            }
	            function rad2deg(rad) {
	              return rad / PI * 180;
	            }
	            function isFullCircle(aBnds) {
	              return Math.abs(aBnds[1] - aBnds[0]) > twoPI - 1e-14;
	            }
	            function angleDelta(a, b) {
	              return modHalf(b - a, twoPI);
	            }
	            function angleDist(a, b) {
	              return Math.abs(angleDelta(a, b));
	            }
	            function isAngleInsideSector(a, aBnds) {
	              if (isFullCircle(aBnds)) return true;
	              var s0, s1;
	              if (aBnds[0] < aBnds[1]) {
	                s0 = aBnds[0];
	                s1 = aBnds[1];
	              } else {
	                s0 = aBnds[1];
	                s1 = aBnds[0];
	              }
	              s0 = mod(s0, twoPI);
	              s1 = mod(s1, twoPI);
	              if (s0 > s1) s1 += twoPI;
	              var a0 = mod(a, twoPI);
	              var a1 = a0 + twoPI;
	              return a0 >= s0 && a0 <= s1 || a1 >= s0 && a1 <= s1;
	            }
	            function isPtInsideSector(r, a, rBnds, aBnds) {
	              if (!isAngleInsideSector(a, aBnds)) return false;
	              var r0, r1;
	              if (rBnds[0] < rBnds[1]) {
	                r0 = rBnds[0];
	                r1 = rBnds[1];
	              } else {
	                r0 = rBnds[1];
	                r1 = rBnds[0];
	              }
	              return r >= r0 && r <= r1;
	            }
	            function _path(r0, r1, a0, a1, cx, cy, isClosed) {
	              cx = cx || 0;
	              cy = cy || 0;
	              var isCircle = isFullCircle([a0, a1]);
	              var aStart, aMid, aEnd;
	              var rStart, rEnd;
	              if (isCircle) {
	                aStart = 0;
	                aMid = PI;
	                aEnd = twoPI;
	              } else {
	                if (a0 < a1) {
	                  aStart = a0;
	                  aEnd = a1;
	                } else {
	                  aStart = a1;
	                  aEnd = a0;
	                }
	              }
	              if (r0 < r1) {
	                rStart = r0;
	                rEnd = r1;
	              } else {
	                rStart = r1;
	                rEnd = r0;
	              }
	              function pt(r, a) {
	                return [r * Math.cos(a) + cx, cy - r * Math.sin(a)];
	              }
	              var largeArc = Math.abs(aEnd - aStart) <= PI ? 0 : 1;
	              function arc(r, a, cw) {
	                return "A" + [r, r] + " " + [0, largeArc, cw] + " " + pt(r, a);
	              }
	              var p;
	              if (isCircle) {
	                if (rStart === null) {
	                  p = "M" + pt(rEnd, aStart) + arc(rEnd, aMid, 0) + arc(rEnd, aEnd, 0) + "Z";
	                } else {
	                  p = "M" + pt(rStart, aStart) + arc(rStart, aMid, 0) + arc(rStart, aEnd, 0) + "ZM" + pt(rEnd, aStart) + arc(rEnd, aMid, 1) + arc(rEnd, aEnd, 1) + "Z";
	                }
	              } else {
	                if (rStart === null) {
	                  p = "M" + pt(rEnd, aStart) + arc(rEnd, aEnd, 0);
	                  if (isClosed) p += "L0,0Z";
	                } else {
	                  p = "M" + pt(rStart, aStart) + "L" + pt(rEnd, aStart) + arc(rEnd, aEnd, 0) + "L" + pt(rStart, aEnd) + arc(rStart, aStart, 1) + "Z";
	                }
	              }
	              return p;
	            }
	            function pathArc(r, a0, a1, cx, cy) {
	              return _path(null, r, a0, a1, cx, cy, 0);
	            }
	            function pathSector(r, a0, a1, cx, cy) {
	              return _path(null, r, a0, a1, cx, cy, 1);
	            }
	            function pathAnnulus(r0, r1, a0, a1, cx, cy) {
	              return _path(r0, r1, a0, a1, cx, cy, 1);
	            }
	            module2.exports = {
	              deg2rad,
	              rad2deg,
	              angleDelta,
	              angleDist,
	              isFullCircle,
	              isAngleInsideSector,
	              isPtInsideSector,
	              pathArc,
	              pathSector,
	              pathAnnulus
	            };
	          }
	        ),
	        /***/
	        73627: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            var isArray = Array.isArray;
	            var ab = ArrayBuffer;
	            var dv = DataView;
	            function isTypedArray(a) {
	              return ab.isView(a) && !(a instanceof dv);
	            }
	            exports2.isTypedArray = isTypedArray;
	            function isArrayOrTypedArray(a) {
	              return isArray(a) || isTypedArray(a);
	            }
	            exports2.isArrayOrTypedArray = isArrayOrTypedArray;
	            function isArray1D(a) {
	              return !isArrayOrTypedArray(a[0]);
	            }
	            exports2.isArray1D = isArray1D;
	            exports2.ensureArray = function(out, n) {
	              if (!isArray(out)) out = [];
	              out.length = n;
	              return out;
	            };
	            exports2.concat = function() {
	              var args = [];
	              var allArray = true;
	              var totalLen = 0;
	              var _constructor, arg0, i, argi, posi, leni, out, j;
	              for (i = 0; i < arguments.length; i++) {
	                argi = arguments[i];
	                leni = argi.length;
	                if (leni) {
	                  if (arg0) args.push(argi);
	                  else {
	                    arg0 = argi;
	                    posi = leni;
	                  }
	                  if (isArray(argi)) {
	                    _constructor = false;
	                  } else {
	                    allArray = false;
	                    if (!totalLen) {
	                      _constructor = argi.constructor;
	                    } else if (_constructor !== argi.constructor) {
	                      _constructor = false;
	                    }
	                  }
	                  totalLen += leni;
	                }
	              }
	              if (!totalLen) return [];
	              if (!args.length) return arg0;
	              if (allArray) return arg0.concat.apply(arg0, args);
	              if (_constructor) {
	                out = new _constructor(totalLen);
	                out.set(arg0);
	                for (i = 0; i < args.length; i++) {
	                  argi = args[i];
	                  out.set(argi, posi);
	                  posi += argi.length;
	                }
	                return out;
	              }
	              out = new Array(totalLen);
	              for (j = 0; j < arg0.length; j++) out[j] = arg0[j];
	              for (i = 0; i < args.length; i++) {
	                argi = args[i];
	                for (j = 0; j < argi.length; j++) out[posi + j] = argi[j];
	                posi += j;
	              }
	              return out;
	            };
	            exports2.maxRowLength = function(z) {
	              return _rowLength(z, Math.max, 0);
	            };
	            exports2.minRowLength = function(z) {
	              return _rowLength(z, Math.min, Infinity);
	            };
	            function _rowLength(z, fn, len0) {
	              if (isArrayOrTypedArray(z)) {
	                if (isArrayOrTypedArray(z[0])) {
	                  var len = len0;
	                  for (var i = 0; i < z.length; i++) {
	                    len = fn(len, z[i].length);
	                  }
	                  return len;
	                } else {
	                  return z.length;
	                }
	              }
	              return 0;
	            }
	          }
	        ),
	        /***/
	        95218: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var JUNK = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
	            module2.exports = function cleanNumber(v) {
	              if (typeof v === "string") {
	                v = v.replace(JUNK, "");
	              }
	              if (isNumeric(v)) return Number(v);
	              return BADNUM;
	            };
	          }
	        ),
	        /***/
	        33306: (
	          /***/
	          function(module2) {
	            module2.exports = function clearGlCanvases(gd) {
	              var fullLayout = gd._fullLayout;
	              if (fullLayout._glcanvas && fullLayout._glcanvas.size()) {
	                fullLayout._glcanvas.each(function(d) {
	                  if (d.regl) d.regl.clear({
	                    color: true,
	                    depth: true
	                  });
	                });
	              }
	            };
	          }
	        ),
	        /***/
	        86367: (
	          /***/
	          function(module2) {
	            module2.exports = function clearResponsive(gd) {
	              if (gd._responsiveChartHandler) {
	                window.removeEventListener("resize", gd._responsiveChartHandler);
	                delete gd._responsiveChartHandler;
	              }
	            };
	          }
	        ),
	        /***/
	        96554: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var tinycolor = __webpack_require__2(84267);
	            var baseTraceAttrs = __webpack_require__2(9012);
	            var colorscales = __webpack_require__2(63282);
	            var Color = __webpack_require__2(7901);
	            var DESELECTDIM = __webpack_require__2(37822).DESELECTDIM;
	            var nestedProperty = __webpack_require__2(65487);
	            var counterRegex = __webpack_require__2(30587).counter;
	            var modHalf = __webpack_require__2(64872).modHalf;
	            var isArrayOrTypedArray = __webpack_require__2(73627).isArrayOrTypedArray;
	            exports2.valObjectMeta = {
	              data_array: {
	                // You can use *dflt=[] to force said array to exist though.
	                coerceFunction: function(v, propOut, dflt) {
	                  if (isArrayOrTypedArray(v)) propOut.set(v);
	                  else if (dflt !== undefined) propOut.set(dflt);
	                }
	              },
	              enumerated: {
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  if (opts.coerceNumber) v = +v;
	                  if (opts.values.indexOf(v) === -1) propOut.set(dflt);
	                  else propOut.set(v);
	                },
	                validateFunction: function(v, opts) {
	                  if (opts.coerceNumber) v = +v;
	                  var values = opts.values;
	                  for (var i = 0; i < values.length; i++) {
	                    var k = String(values[i]);
	                    if (k.charAt(0) === "/" && k.charAt(k.length - 1) === "/") {
	                      var regex = new RegExp(k.substr(1, k.length - 2));
	                      if (regex.test(v)) return true;
	                    } else if (v === values[i]) return true;
	                  }
	                  return false;
	                }
	              },
	              boolean: {
	                coerceFunction: function(v, propOut, dflt) {
	                  if (v === true || v === false) propOut.set(v);
	                  else propOut.set(dflt);
	                }
	              },
	              number: {
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  if (!isNumeric(v) || opts.min !== undefined && v < opts.min || opts.max !== undefined && v > opts.max) {
	                    propOut.set(dflt);
	                  } else propOut.set(+v);
	                }
	              },
	              integer: {
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  if (v % 1 || !isNumeric(v) || opts.min !== undefined && v < opts.min || opts.max !== undefined && v > opts.max) {
	                    propOut.set(dflt);
	                  } else propOut.set(+v);
	                }
	              },
	              string: {
	                // TODO 'values shouldn't be in there (edge case: 'dash' in Scatter)
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  if (typeof v !== "string") {
	                    var okToCoerce = typeof v === "number";
	                    if (opts.strict === true || !okToCoerce) propOut.set(dflt);
	                    else propOut.set(String(v));
	                  } else if (opts.noBlank && !v) propOut.set(dflt);
	                  else propOut.set(v);
	                }
	              },
	              color: {
	                coerceFunction: function(v, propOut, dflt) {
	                  if (tinycolor(v).isValid()) propOut.set(v);
	                  else propOut.set(dflt);
	                }
	              },
	              colorlist: {
	                coerceFunction: function(v, propOut, dflt) {
	                  function isColor(color) {
	                    return tinycolor(color).isValid();
	                  }
	                  if (!Array.isArray(v) || !v.length) propOut.set(dflt);
	                  else if (v.every(isColor)) propOut.set(v);
	                  else propOut.set(dflt);
	                }
	              },
	              colorscale: {
	                coerceFunction: function(v, propOut, dflt) {
	                  propOut.set(colorscales.get(v, dflt));
	                }
	              },
	              angle: {
	                coerceFunction: function(v, propOut, dflt) {
	                  if (v === "auto") propOut.set("auto");
	                  else if (!isNumeric(v)) propOut.set(dflt);
	                  else propOut.set(modHalf(+v, 360));
	                }
	              },
	              subplotid: {
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  var regex = opts.regex || counterRegex(dflt);
	                  if (typeof v === "string" && regex.test(v)) {
	                    propOut.set(v);
	                    return;
	                  }
	                  propOut.set(dflt);
	                },
	                validateFunction: function(v, opts) {
	                  var dflt = opts.dflt;
	                  if (v === dflt) return true;
	                  if (typeof v !== "string") return false;
	                  if (counterRegex(dflt).test(v)) return true;
	                  return false;
	                }
	              },
	              flaglist: {
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  if ((opts.extras || []).indexOf(v) !== -1) {
	                    propOut.set(v);
	                    return;
	                  }
	                  if (typeof v !== "string") {
	                    propOut.set(dflt);
	                    return;
	                  }
	                  var vParts = v.split("+");
	                  var i = 0;
	                  while (i < vParts.length) {
	                    var vi = vParts[i];
	                    if (opts.flags.indexOf(vi) === -1 || vParts.indexOf(vi) < i) {
	                      vParts.splice(i, 1);
	                    } else i++;
	                  }
	                  if (!vParts.length) propOut.set(dflt);
	                  else propOut.set(vParts.join("+"));
	                }
	              },
	              any: {
	                coerceFunction: function(v, propOut, dflt) {
	                  if (v === undefined) propOut.set(dflt);
	                  else propOut.set(v);
	                }
	              },
	              info_array: {
	                // set `dimensions=2` for a 2D array or '1-2' for either
	                // `items` may be a single object instead of an array, in which case
	                // `freeLength` must be true.
	                // if `dimensions='1-2'` and items is a 1D array, then the value can
	                // either be a matching 1D array or an array of such matching 1D arrays
	                coerceFunction: function(v, propOut, dflt, opts) {
	                  function coercePart(v2, opts2, dflt2) {
	                    var out;
	                    var propPart = {
	                      set: function(v3) {
	                        out = v3;
	                      }
	                    };
	                    if (dflt2 === undefined) dflt2 = opts2.dflt;
	                    exports2.valObjectMeta[opts2.valType].coerceFunction(v2, propPart, dflt2, opts2);
	                    return out;
	                  }
	                  var twoD = opts.dimensions === 2 || opts.dimensions === "1-2" && Array.isArray(v) && Array.isArray(v[0]);
	                  if (!Array.isArray(v)) {
	                    propOut.set(dflt);
	                    return;
	                  }
	                  var items = opts.items;
	                  var vOut = [];
	                  var arrayItems = Array.isArray(items);
	                  var arrayItems2D = arrayItems && twoD && Array.isArray(items[0]);
	                  var innerItemsOnly = twoD && arrayItems && !arrayItems2D;
	                  var len = arrayItems && !innerItemsOnly ? items.length : v.length;
	                  var i, j, row, item, len2, vNew;
	                  dflt = Array.isArray(dflt) ? dflt : [];
	                  if (twoD) {
	                    for (i = 0; i < len; i++) {
	                      vOut[i] = [];
	                      row = Array.isArray(v[i]) ? v[i] : [];
	                      if (innerItemsOnly) len2 = items.length;
	                      else if (arrayItems) len2 = items[i].length;
	                      else len2 = row.length;
	                      for (j = 0; j < len2; j++) {
	                        if (innerItemsOnly) item = items[j];
	                        else if (arrayItems) item = items[i][j];
	                        else item = items;
	                        vNew = coercePart(row[j], item, (dflt[i] || [])[j]);
	                        if (vNew !== undefined) vOut[i][j] = vNew;
	                      }
	                    }
	                  } else {
	                    for (i = 0; i < len; i++) {
	                      vNew = coercePart(v[i], arrayItems ? items[i] : items, dflt[i]);
	                      if (vNew !== undefined) vOut[i] = vNew;
	                    }
	                  }
	                  propOut.set(vOut);
	                },
	                validateFunction: function(v, opts) {
	                  if (!Array.isArray(v)) return false;
	                  var items = opts.items;
	                  var arrayItems = Array.isArray(items);
	                  var twoD = opts.dimensions === 2;
	                  if (!opts.freeLength && v.length !== items.length) return false;
	                  for (var i = 0; i < v.length; i++) {
	                    if (twoD) {
	                      if (!Array.isArray(v[i]) || !opts.freeLength && v[i].length !== items[i].length) {
	                        return false;
	                      }
	                      for (var j = 0; j < v[i].length; j++) {
	                        if (!validate(v[i][j], arrayItems ? items[i][j] : items)) {
	                          return false;
	                        }
	                      }
	                    } else if (!validate(v[i], arrayItems ? items[i] : items)) return false;
	                  }
	                  return true;
	                }
	              }
	            };
	            exports2.coerce = function(containerIn, containerOut, attributes, attribute, dflt) {
	              var opts = nestedProperty(attributes, attribute).get();
	              var propIn = nestedProperty(containerIn, attribute);
	              var propOut = nestedProperty(containerOut, attribute);
	              var v = propIn.get();
	              var template = containerOut._template;
	              if (v === undefined && template) {
	                v = nestedProperty(template, attribute).get();
	                template = 0;
	              }
	              if (dflt === undefined) dflt = opts.dflt;
	              if (opts.arrayOk && isArrayOrTypedArray(v)) {
	                propOut.set(v);
	                return v;
	              }
	              var coerceFunction = exports2.valObjectMeta[opts.valType].coerceFunction;
	              coerceFunction(v, propOut, dflt, opts);
	              var out = propOut.get();
	              if (template && out === dflt && !validate(v, opts)) {
	                v = nestedProperty(template, attribute).get();
	                coerceFunction(v, propOut, dflt, opts);
	                out = propOut.get();
	              }
	              return out;
	            };
	            exports2.coerce2 = function(containerIn, containerOut, attributes, attribute, dflt) {
	              var propIn = nestedProperty(containerIn, attribute);
	              var propOut = exports2.coerce(containerIn, containerOut, attributes, attribute, dflt);
	              var valIn = propIn.get();
	              return valIn !== undefined && valIn !== null ? propOut : false;
	            };
	            exports2.coerceFont = function(coerce, attr, dfltObj) {
	              var out = {};
	              dfltObj = dfltObj || {};
	              out.family = coerce(attr + ".family", dfltObj.family);
	              out.size = coerce(attr + ".size", dfltObj.size);
	              out.color = coerce(attr + ".color", dfltObj.color);
	              return out;
	            };
	            exports2.coercePattern = function(coerce, attr, markerColor, hasMarkerColorscale) {
	              var shape = coerce(attr + ".shape");
	              if (shape) {
	                coerce(attr + ".solidity");
	                coerce(attr + ".size");
	                var fillmode = coerce(attr + ".fillmode");
	                var isOverlay = fillmode === "overlay";
	                if (!hasMarkerColorscale) {
	                  var bgcolor = coerce(attr + ".bgcolor", isOverlay ? markerColor : undefined);
	                  coerce(attr + ".fgcolor", isOverlay ? Color.contrast(bgcolor) : markerColor);
	                }
	                coerce(attr + ".fgopacity", isOverlay ? 0.5 : 1);
	              }
	            };
	            exports2.coerceHoverinfo = function(traceIn, traceOut, layoutOut) {
	              var moduleAttrs = traceOut._module.attributes;
	              var attrs = moduleAttrs.hoverinfo ? moduleAttrs : baseTraceAttrs;
	              var valObj = attrs.hoverinfo;
	              var dflt;
	              if (layoutOut._dataLength === 1) {
	                var flags = valObj.dflt === "all" ? valObj.flags.slice() : valObj.dflt.split("+");
	                flags.splice(flags.indexOf("name"), 1);
	                dflt = flags.join("+");
	              }
	              return exports2.coerce(traceIn, traceOut, attrs, "hoverinfo", dflt);
	            };
	            exports2.coerceSelectionMarkerOpacity = function(traceOut, coerce) {
	              if (!traceOut.marker) return;
	              var mo = traceOut.marker.opacity;
	              if (mo === undefined) return;
	              var smoDflt;
	              var usmoDflt;
	              if (!isArrayOrTypedArray(mo) && !traceOut.selected && !traceOut.unselected) {
	                smoDflt = mo;
	                usmoDflt = DESELECTDIM * mo;
	              }
	              coerce("selected.marker.opacity", smoDflt);
	              coerce("unselected.marker.opacity", usmoDflt);
	            };
	            function validate(value, opts) {
	              var valObjectDef = exports2.valObjectMeta[opts.valType];
	              if (opts.arrayOk && isArrayOrTypedArray(value)) return true;
	              if (valObjectDef.validateFunction) {
	                return valObjectDef.validateFunction(value, opts);
	              }
	              var failed = {};
	              var out = failed;
	              var propMock = {
	                set: function(v) {
	                  out = v;
	                }
	              };
	              valObjectDef.coerceFunction(value, propMock, failed, opts);
	              return out !== failed;
	            }
	            exports2.validate = validate;
	          }
	        ),
	        /***/
	        41631: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var timeFormat = __webpack_require__2(84096).i$;
	            var isNumeric = __webpack_require__2(92770);
	            var Loggers = __webpack_require__2(47769);
	            var mod = __webpack_require__2(64872).mod;
	            var constants = __webpack_require__2(50606);
	            var BADNUM = constants.BADNUM;
	            var ONEDAY = constants.ONEDAY;
	            var ONEHOUR = constants.ONEHOUR;
	            var ONEMIN = constants.ONEMIN;
	            var ONESEC = constants.ONESEC;
	            var EPOCHJD = constants.EPOCHJD;
	            var Registry = __webpack_require__2(73972);
	            var utcFormat = __webpack_require__2(84096).g0;
	            var DATETIME_REGEXP = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m;
	            var DATETIME_REGEXP_CN = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m;
	            var YFIRST = (/* @__PURE__ */ new Date()).getFullYear() - 70;
	            function isWorldCalendar(calendar) {
	              return calendar && Registry.componentsRegistry.calendars && typeof calendar === "string" && calendar !== "gregorian";
	            }
	            exports2.dateTick0 = function(calendar, dayOfWeek) {
	              var tick0 = _dateTick0(calendar, !!dayOfWeek);
	              if (dayOfWeek < 2) return tick0;
	              var v = exports2.dateTime2ms(tick0, calendar);
	              v += ONEDAY * (dayOfWeek - 1);
	              return exports2.ms2DateTime(v, 0, calendar);
	            };
	            function _dateTick0(calendar, sunday) {
	              if (isWorldCalendar(calendar)) {
	                return sunday ? Registry.getComponentMethod("calendars", "CANONICAL_SUNDAY")[calendar] : Registry.getComponentMethod("calendars", "CANONICAL_TICK")[calendar];
	              } else {
	                return sunday ? "2000-01-02" : "2000-01-01";
	              }
	            }
	            exports2.dfltRange = function(calendar) {
	              if (isWorldCalendar(calendar)) {
	                return Registry.getComponentMethod("calendars", "DFLTRANGE")[calendar];
	              } else {
	                return ["2000-01-01", "2001-01-01"];
	              }
	            };
	            exports2.isJSDate = function(v) {
	              return typeof v === "object" && v !== null && typeof v.getTime === "function";
	            };
	            var MIN_MS, MAX_MS;
	            exports2.dateTime2ms = function(s, calendar) {
	              if (exports2.isJSDate(s)) {
	                var tzOffset = s.getTimezoneOffset() * ONEMIN;
	                var offsetTweak = (s.getUTCMinutes() - s.getMinutes()) * ONEMIN + (s.getUTCSeconds() - s.getSeconds()) * ONESEC + (s.getUTCMilliseconds() - s.getMilliseconds());
	                if (offsetTweak) {
	                  var comb = 3 * ONEMIN;
	                  tzOffset = tzOffset - comb / 2 + mod(offsetTweak - tzOffset + comb / 2, comb);
	                }
	                s = Number(s) - tzOffset;
	                if (s >= MIN_MS && s <= MAX_MS) return s;
	                return BADNUM;
	              }
	              if (typeof s !== "string" && typeof s !== "number") return BADNUM;
	              s = String(s);
	              var isWorld = isWorldCalendar(calendar);
	              var s0 = s.charAt(0);
	              if (isWorld && (s0 === "G" || s0 === "g")) {
	                s = s.substr(1);
	                calendar = "";
	              }
	              var isChinese = isWorld && calendar.substr(0, 7) === "chinese";
	              var match = s.match(isChinese ? DATETIME_REGEXP_CN : DATETIME_REGEXP);
	              if (!match) return BADNUM;
	              var y = match[1];
	              var m = match[3] || "1";
	              var d = Number(match[5] || 1);
	              var H = Number(match[7] || 0);
	              var M = Number(match[9] || 0);
	              var S = Number(match[11] || 0);
	              if (isWorld) {
	                if (y.length === 2) return BADNUM;
	                y = Number(y);
	                var cDate;
	                try {
	                  var calInstance = Registry.getComponentMethod("calendars", "getCal")(calendar);
	                  if (isChinese) {
	                    var isIntercalary = m.charAt(m.length - 1) === "i";
	                    m = parseInt(m, 10);
	                    cDate = calInstance.newDate(y, calInstance.toMonthIndex(y, m, isIntercalary), d);
	                  } else {
	                    cDate = calInstance.newDate(y, Number(m), d);
	                  }
	                } catch (e) {
	                  return BADNUM;
	                }
	                if (!cDate) return BADNUM;
	                return (cDate.toJD() - EPOCHJD) * ONEDAY + H * ONEHOUR + M * ONEMIN + S * ONESEC;
	              }
	              if (y.length === 2) {
	                y = (Number(y) + 2e3 - YFIRST) % 100 + YFIRST;
	              } else y = Number(y);
	              m -= 1;
	              var date = new Date(Date.UTC(2e3, m, d, H, M));
	              date.setUTCFullYear(y);
	              if (date.getUTCMonth() !== m) return BADNUM;
	              if (date.getUTCDate() !== d) return BADNUM;
	              return date.getTime() + S * ONESEC;
	            };
	            MIN_MS = exports2.MIN_MS = exports2.dateTime2ms("-9999");
	            MAX_MS = exports2.MAX_MS = exports2.dateTime2ms("9999-12-31 23:59:59.9999");
	            exports2.isDateTime = function(s, calendar) {
	              return exports2.dateTime2ms(s, calendar) !== BADNUM;
	            };
	            function lpad(val, digits) {
	              return String(val + Math.pow(10, digits)).substr(1);
	            }
	            var NINETYDAYS = 90 * ONEDAY;
	            var THREEHOURS = 3 * ONEHOUR;
	            var FIVEMIN = 5 * ONEMIN;
	            exports2.ms2DateTime = function(ms, r, calendar) {
	              if (typeof ms !== "number" || !(ms >= MIN_MS && ms <= MAX_MS)) return BADNUM;
	              if (!r) r = 0;
	              var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
	              var msRounded = Math.round(ms - msecTenths / 10);
	              var dateStr, h, m, s, msec10, d;
	              if (isWorldCalendar(calendar)) {
	                var dateJD = Math.floor(msRounded / ONEDAY) + EPOCHJD;
	                var timeMs = Math.floor(mod(ms, ONEDAY));
	                try {
	                  dateStr = Registry.getComponentMethod("calendars", "getCal")(calendar).fromJD(dateJD).formatDate("yyyy-mm-dd");
	                } catch (e) {
	                  dateStr = utcFormat("G%Y-%m-%d")(new Date(msRounded));
	                }
	                if (dateStr.charAt(0) === "-") {
	                  while (dateStr.length < 11) dateStr = "-0" + dateStr.substr(1);
	                } else {
	                  while (dateStr.length < 10) dateStr = "0" + dateStr;
	                }
	                h = r < NINETYDAYS ? Math.floor(timeMs / ONEHOUR) : 0;
	                m = r < NINETYDAYS ? Math.floor(timeMs % ONEHOUR / ONEMIN) : 0;
	                s = r < THREEHOURS ? Math.floor(timeMs % ONEMIN / ONESEC) : 0;
	                msec10 = r < FIVEMIN ? timeMs % ONESEC * 10 + msecTenths : 0;
	              } else {
	                d = new Date(msRounded);
	                dateStr = utcFormat("%Y-%m-%d")(d);
	                h = r < NINETYDAYS ? d.getUTCHours() : 0;
	                m = r < NINETYDAYS ? d.getUTCMinutes() : 0;
	                s = r < THREEHOURS ? d.getUTCSeconds() : 0;
	                msec10 = r < FIVEMIN ? d.getUTCMilliseconds() * 10 + msecTenths : 0;
	              }
	              return includeTime(dateStr, h, m, s, msec10);
	            };
	            exports2.ms2DateTimeLocal = function(ms) {
	              if (!(ms >= MIN_MS + ONEDAY && ms <= MAX_MS - ONEDAY)) return BADNUM;
	              var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
	              var d = new Date(Math.round(ms - msecTenths / 10));
	              var dateStr = timeFormat("%Y-%m-%d")(d);
	              var h = d.getHours();
	              var m = d.getMinutes();
	              var s = d.getSeconds();
	              var msec10 = d.getUTCMilliseconds() * 10 + msecTenths;
	              return includeTime(dateStr, h, m, s, msec10);
	            };
	            function includeTime(dateStr, h, m, s, msec10) {
	              if (h || m || s || msec10) {
	                dateStr += " " + lpad(h, 2) + ":" + lpad(m, 2);
	                if (s || msec10) {
	                  dateStr += ":" + lpad(s, 2);
	                  if (msec10) {
	                    var digits = 4;
	                    while (msec10 % 10 === 0) {
	                      digits -= 1;
	                      msec10 /= 10;
	                    }
	                    dateStr += "." + lpad(msec10, digits);
	                  }
	                }
	              }
	              return dateStr;
	            }
	            exports2.cleanDate = function(v, dflt, calendar) {
	              if (v === BADNUM) return dflt;
	              if (exports2.isJSDate(v) || typeof v === "number" && isFinite(v)) {
	                if (isWorldCalendar(calendar)) {
	                  Loggers.error("JS Dates and milliseconds are incompatible with world calendars", v);
	                  return dflt;
	                }
	                v = exports2.ms2DateTimeLocal(+v);
	                if (!v && dflt !== undefined) return dflt;
	              } else if (!exports2.isDateTime(v, calendar)) {
	                Loggers.error("unrecognized date", v);
	                return dflt;
	              }
	              return v;
	            };
	            var fracMatch = /%\d?f/g;
	            var halfYearMatch = /%h/g;
	            var quarterToHalfYear = {
	              1: "1",
	              2: "1",
	              3: "2",
	              4: "2"
	            };
	            function modDateFormat(fmt, x, formatter, calendar) {
	              fmt = fmt.replace(fracMatch, function(match) {
	                var digits = Math.min(+match.charAt(1) || 6, 6);
	                var fracSecs = (x / 1e3 % 1 + 2).toFixed(digits).substr(2).replace(/0+$/, "") || "0";
	                return fracSecs;
	              });
	              var d = new Date(Math.floor(x + 0.05));
	              fmt = fmt.replace(halfYearMatch, function() {
	                return quarterToHalfYear[formatter("%q")(d)];
	              });
	              if (isWorldCalendar(calendar)) {
	                try {
	                  fmt = Registry.getComponentMethod("calendars", "worldCalFmt")(fmt, x, calendar);
	                } catch (e) {
	                  return "Invalid";
	                }
	              }
	              return formatter(fmt)(d);
	            }
	            var MAXSECONDS = [59, 59.9, 59.99, 59.999, 59.9999];
	            function formatTime(x, tr) {
	              var timePart = mod(x + 0.05, ONEDAY);
	              var timeStr = lpad(Math.floor(timePart / ONEHOUR), 2) + ":" + lpad(mod(Math.floor(timePart / ONEMIN), 60), 2);
	              if (tr !== "M") {
	                if (!isNumeric(tr)) tr = 0;
	                var sec = Math.min(mod(x / ONESEC, 60), MAXSECONDS[tr]);
	                var secStr = (100 + sec).toFixed(tr).substr(1);
	                if (tr > 0) {
	                  secStr = secStr.replace(/0+$/, "").replace(/[\.]$/, "");
	                }
	                timeStr += ":" + secStr;
	              }
	              return timeStr;
	            }
	            exports2.formatDate = function(x, fmt, tr, formatter, calendar, extraFormat) {
	              calendar = isWorldCalendar(calendar) && calendar;
	              if (!fmt) {
	                if (tr === "y") fmt = extraFormat.year;
	                else if (tr === "m") fmt = extraFormat.month;
	                else if (tr === "d") {
	                  fmt = extraFormat.dayMonth + "\n" + extraFormat.year;
	                } else {
	                  return formatTime(x, tr) + "\n" + modDateFormat(extraFormat.dayMonthYear, x, formatter, calendar);
	                }
	              }
	              return modDateFormat(fmt, x, formatter, calendar);
	            };
	            var THREEDAYS = 3 * ONEDAY;
	            exports2.incrementMonth = function(ms, dMonth, calendar) {
	              calendar = isWorldCalendar(calendar) && calendar;
	              var timeMs = mod(ms, ONEDAY);
	              ms = Math.round(ms - timeMs);
	              if (calendar) {
	                try {
	                  var dateJD = Math.round(ms / ONEDAY) + EPOCHJD;
	                  var calInstance = Registry.getComponentMethod("calendars", "getCal")(calendar);
	                  var cDate = calInstance.fromJD(dateJD);
	                  if (dMonth % 12) calInstance.add(cDate, dMonth, "m");
	                  else calInstance.add(cDate, dMonth / 12, "y");
	                  return (cDate.toJD() - EPOCHJD) * ONEDAY + timeMs;
	                } catch (e) {
	                  Loggers.error("invalid ms " + ms + " in calendar " + calendar);
	                }
	              }
	              var y = new Date(ms + THREEDAYS);
	              return y.setUTCMonth(y.getUTCMonth() + dMonth) + timeMs - THREEDAYS;
	            };
	            exports2.findExactDates = function(data, calendar) {
	              var exactYears = 0;
	              var exactMonths = 0;
	              var exactDays = 0;
	              var blankCount = 0;
	              var d;
	              var di;
	              var calInstance = isWorldCalendar(calendar) && Registry.getComponentMethod("calendars", "getCal")(calendar);
	              for (var i = 0; i < data.length; i++) {
	                di = data[i];
	                if (!isNumeric(di)) {
	                  blankCount++;
	                  continue;
	                }
	                if (di % ONEDAY) continue;
	                if (calInstance) {
	                  try {
	                    d = calInstance.fromJD(di / ONEDAY + EPOCHJD);
	                    if (d.day() === 1) {
	                      if (d.month() === 1) exactYears++;
	                      else exactMonths++;
	                    } else exactDays++;
	                  } catch (e) {
	                  }
	                } else {
	                  d = new Date(di);
	                  if (d.getUTCDate() === 1) {
	                    if (d.getUTCMonth() === 0) exactYears++;
	                    else exactMonths++;
	                  } else exactDays++;
	                }
	              }
	              exactMonths += exactYears;
	              exactDays += exactMonths;
	              var dataCount = data.length - blankCount;
	              return {
	                exactYears: exactYears / dataCount,
	                exactMonths: exactMonths / dataCount,
	                exactDays: exactDays / dataCount
	              };
	            };
	          }
	        ),
	        /***/
	        24401: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var loggers = __webpack_require__2(47769);
	            var matrix = __webpack_require__2(35657);
	            var mat4X4 = __webpack_require__2(79576);
	            function getGraphDiv(gd) {
	              var gdElement;
	              if (typeof gd === "string") {
	                gdElement = document.getElementById(gd);
	                if (gdElement === null) {
	                  throw new Error("No DOM element with id '" + gd + "' exists on the page.");
	                }
	                return gdElement;
	              } else if (gd === null || gd === undefined) {
	                throw new Error("DOM element provided is null or undefined");
	              }
	              return gd;
	            }
	            function isPlotDiv(el) {
	              var el3 = d3.select(el);
	              return el3.node() instanceof HTMLElement && el3.size() && el3.classed("js-plotly-plot");
	            }
	            function removeElement(el) {
	              var elParent = el && el.parentNode;
	              if (elParent) elParent.removeChild(el);
	            }
	            function addStyleRule(selector, styleString) {
	              addRelatedStyleRule("global", selector, styleString);
	            }
	            function addRelatedStyleRule(uid, selector, styleString) {
	              var id = "plotly.js-style-" + uid;
	              var style = document.getElementById(id);
	              if (!style) {
	                style = document.createElement("style");
	                style.setAttribute("id", id);
	                style.appendChild(document.createTextNode(""));
	                document.head.appendChild(style);
	              }
	              var styleSheet = style.sheet;
	              if (styleSheet.insertRule) {
	                styleSheet.insertRule(selector + "{" + styleString + "}", 0);
	              } else if (styleSheet.addRule) {
	                styleSheet.addRule(selector, styleString, 0);
	              } else loggers.warn("addStyleRule failed");
	            }
	            function deleteRelatedStyleRule(uid) {
	              var id = "plotly.js-style-" + uid;
	              var style = document.getElementById(id);
	              if (style) removeElement(style);
	            }
	            function getFullTransformMatrix(element) {
	              var allElements = getElementAndAncestors(element);
	              var out = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	              allElements.forEach(function(e) {
	                var t = getElementTransformMatrix(e);
	                if (t) {
	                  var m = matrix.convertCssMatrix(t);
	                  out = mat4X4.multiply(out, out, m);
	                }
	              });
	              return out;
	            }
	            function getElementTransformMatrix(element) {
	              var style = window.getComputedStyle(element, null);
	              var transform = style.getPropertyValue("-webkit-transform") || style.getPropertyValue("-moz-transform") || style.getPropertyValue("-ms-transform") || style.getPropertyValue("-o-transform") || style.getPropertyValue("transform");
	              if (transform === "none") return null;
	              return transform.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function(n) {
	                return +n;
	              });
	            }
	            function getElementAndAncestors(element) {
	              var allElements = [];
	              while (isTransformableElement(element)) {
	                allElements.push(element);
	                element = element.parentNode;
	              }
	              return allElements;
	            }
	            function isTransformableElement(element) {
	              return element && (element instanceof Element || element instanceof HTMLElement);
	            }
	            function equalDomRects(a, b) {
	              return a && b && a.top === b.top && a.left === b.left && a.right === b.right && a.bottom === b.bottom;
	            }
	            module2.exports = {
	              getGraphDiv,
	              isPlotDiv,
	              removeElement,
	              addStyleRule,
	              addRelatedStyleRule,
	              deleteRelatedStyleRule,
	              getFullTransformMatrix,
	              getElementTransformMatrix,
	              getElementAndAncestors,
	              equalDomRects
	            };
	          }
	        ),
	        /***/
	        11086: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var EventEmitter = __webpack_require__2(15398).EventEmitter;
	            var Events = {
	              init: function(plotObj) {
	                if (plotObj._ev instanceof EventEmitter) return plotObj;
	                var ev = new EventEmitter();
	                var internalEv = new EventEmitter();
	                plotObj._ev = ev;
	                plotObj._internalEv = internalEv;
	                plotObj.on = ev.on.bind(ev);
	                plotObj.once = ev.once.bind(ev);
	                plotObj.removeListener = ev.removeListener.bind(ev);
	                plotObj.removeAllListeners = ev.removeAllListeners.bind(ev);
	                plotObj._internalOn = internalEv.on.bind(internalEv);
	                plotObj._internalOnce = internalEv.once.bind(internalEv);
	                plotObj._removeInternalListener = internalEv.removeListener.bind(internalEv);
	                plotObj._removeAllInternalListeners = internalEv.removeAllListeners.bind(internalEv);
	                plotObj.emit = function(event, data) {
	                  if (typeof jQuery !== "undefined") {
	                    jQuery(plotObj).trigger(event, data);
	                  }
	                  ev.emit(event, data);
	                  internalEv.emit(event, data);
	                };
	                return plotObj;
	              },
	              /*
	               * This function behaves like jQuery's triggerHandler. It calls
	               * all handlers for a particular event and returns the return value
	               * of the LAST handler. This function also triggers jQuery's
	               * triggerHandler for backwards compatibility.
	               */
	              triggerHandler: function(plotObj, event, data) {
	                var jQueryHandlerValue;
	                var nodeEventHandlerValue;
	                if (typeof jQuery !== "undefined") {
	                  jQueryHandlerValue = jQuery(plotObj).triggerHandler(event, data);
	                }
	                var ev = plotObj._ev;
	                if (!ev) return jQueryHandlerValue;
	                var handlers = ev._events[event];
	                if (!handlers) return jQueryHandlerValue;
	                function apply(handler) {
	                  if (handler.listener) {
	                    ev.removeListener(event, handler.listener);
	                    if (!handler.fired) {
	                      handler.fired = true;
	                      return handler.listener.apply(ev, [data]);
	                    }
	                  } else {
	                    return handler.apply(ev, [data]);
	                  }
	                }
	                handlers = Array.isArray(handlers) ? handlers : [handlers];
	                var i;
	                for (i = 0; i < handlers.length - 1; i++) {
	                  apply(handlers[i]);
	                }
	                nodeEventHandlerValue = apply(handlers[i]);
	                return jQueryHandlerValue !== undefined ? jQueryHandlerValue : nodeEventHandlerValue;
	              },
	              purge: function(plotObj) {
	                delete plotObj._ev;
	                delete plotObj.on;
	                delete plotObj.once;
	                delete plotObj.removeListener;
	                delete plotObj.removeAllListeners;
	                delete plotObj.emit;
	                delete plotObj._ev;
	                delete plotObj._internalEv;
	                delete plotObj._internalOn;
	                delete plotObj._internalOnce;
	                delete plotObj._removeInternalListener;
	                delete plotObj._removeAllInternalListeners;
	                return plotObj;
	              }
	            };
	            module2.exports = Events;
	          }
	        ),
	        /***/
	        1426: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isPlainObject = __webpack_require__2(41965);
	            var isArray = Array.isArray;
	            function primitivesLoopSplice(source, target) {
	              var i, value;
	              for (i = 0; i < source.length; i++) {
	                value = source[i];
	                if (value !== null && typeof value === "object") {
	                  return false;
	                }
	                if (value !== undefined) {
	                  target[i] = value;
	                }
	              }
	              return true;
	            }
	            exports2.extendFlat = function() {
	              return _extend(arguments, false, false, false);
	            };
	            exports2.extendDeep = function() {
	              return _extend(arguments, true, false, false);
	            };
	            exports2.extendDeepAll = function() {
	              return _extend(arguments, true, true, false);
	            };
	            exports2.extendDeepNoArrays = function() {
	              return _extend(arguments, true, false, true);
	            };
	            function _extend(inputs, isDeep, keepAllKeys, noArrayCopies) {
	              var target = inputs[0];
	              var length = inputs.length;
	              var input, key, src, copy, copyIsArray, clone, allPrimitives;
	              if (length === 2 && isArray(target) && isArray(inputs[1]) && target.length === 0) {
	                allPrimitives = primitivesLoopSplice(inputs[1], target);
	                if (allPrimitives) {
	                  return target;
	                } else {
	                  target.splice(0, target.length);
	                }
	              }
	              for (var i = 1; i < length; i++) {
	                input = inputs[i];
	                for (key in input) {
	                  src = target[key];
	                  copy = input[key];
	                  if (noArrayCopies && isArray(copy)) {
	                    target[key] = copy;
	                  } else if (isDeep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
	                    if (copyIsArray) {
	                      copyIsArray = false;
	                      clone = src && isArray(src) ? src : [];
	                    } else {
	                      clone = src && isPlainObject(src) ? src : {};
	                    }
	                    target[key] = _extend([clone, copy], isDeep, keepAllKeys, noArrayCopies);
	                  } else if (typeof copy !== "undefined" || keepAllKeys) {
	                    target[key] = copy;
	                  }
	                }
	              }
	              return target;
	            }
	          }
	        ),
	        /***/
	        75744: (
	          /***/
	          function(module2) {
	            module2.exports = function filterUnique(array) {
	              var seen = {};
	              var out = [];
	              var j = 0;
	              for (var i = 0; i < array.length; i++) {
	                var item = array[i];
	                if (seen[item] !== 1) {
	                  seen[item] = 1;
	                  out[j++] = item;
	                }
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        76756: (
	          /***/
	          function(module2) {
	            module2.exports = function filterVisible(container) {
	              var filterFn = isCalcData(container) ? calcDataFilter : baseFilter;
	              var out = [];
	              for (var i = 0; i < container.length; i++) {
	                var item = container[i];
	                if (filterFn(item)) out.push(item);
	              }
	              return out;
	            };
	            function baseFilter(item) {
	              return item.visible === true;
	            }
	            function calcDataFilter(item) {
	              var trace = item[0].trace;
	              return trace.visible === true && trace._length !== 0;
	            }
	            function isCalcData(cont) {
	              return Array.isArray(cont) && Array.isArray(cont[0]) && cont[0][0] && cont[0][0].trace;
	            }
	          }
	        ),
	        /***/
	        41327: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var countryRegex = __webpack_require__2(24138);
	            var turfArea = __webpack_require__2(30774);
	            var turfCentroid = __webpack_require__2(29261);
	            var turfBbox = __webpack_require__2(85268);
	            var identity2 = __webpack_require__2(23389);
	            var loggers = __webpack_require__2(47769);
	            var isPlainObject = __webpack_require__2(41965);
	            var nestedProperty = __webpack_require__2(65487);
	            var polygon = __webpack_require__2(61082);
	            var countryIds = Object.keys(countryRegex);
	            var locationmodeToIdFinder = {
	              "ISO-3": identity2,
	              "USA-states": identity2,
	              "country names": countryNameToISO3
	            };
	            function countryNameToISO3(countryName) {
	              for (var i = 0; i < countryIds.length; i++) {
	                var iso3 = countryIds[i];
	                var regex = new RegExp(countryRegex[iso3]);
	                if (regex.test(countryName.trim().toLowerCase())) return iso3;
	              }
	              loggers.log("Unrecognized country name: " + countryName + ".");
	              return false;
	            }
	            function locationToFeature(locationmode, location, features) {
	              if (!location || typeof location !== "string") return false;
	              var locationId = locationmodeToIdFinder[locationmode](location);
	              var filteredFeatures;
	              var f, i;
	              if (locationId) {
	                if (locationmode === "USA-states") {
	                  filteredFeatures = [];
	                  for (i = 0; i < features.length; i++) {
	                    f = features[i];
	                    if (f.properties && f.properties.gu && f.properties.gu === "USA") {
	                      filteredFeatures.push(f);
	                    }
	                  }
	                } else {
	                  filteredFeatures = features;
	                }
	                for (i = 0; i < filteredFeatures.length; i++) {
	                  f = filteredFeatures[i];
	                  if (f.id === locationId) return f;
	                }
	                loggers.log(["Location with id", locationId, "does not have a matching topojson feature at this resolution."].join(" "));
	              }
	              return false;
	            }
	            function feature2polygons(feature) {
	              var geometry = feature.geometry;
	              var coords = geometry.coordinates;
	              var loc = feature.id;
	              var polygons = [];
	              var appendPolygon, j, k, m;
	              function doesCrossAntiMerdian(pts) {
	                for (var l = 0; l < pts.length - 1; l++) {
	                  if (pts[l][0] > 0 && pts[l + 1][0] < 0) return l;
	                }
	                return null;
	              }
	              if (loc === "RUS" || loc === "FJI") {
	                appendPolygon = function(_pts) {
	                  var pts;
	                  if (doesCrossAntiMerdian(_pts) === null) {
	                    pts = _pts;
	                  } else {
	                    pts = new Array(_pts.length);
	                    for (m = 0; m < _pts.length; m++) {
	                      pts[m] = [_pts[m][0] < 0 ? _pts[m][0] + 360 : _pts[m][0], _pts[m][1]];
	                    }
	                  }
	                  polygons.push(polygon.tester(pts));
	                };
	              } else if (loc === "ATA") {
	                appendPolygon = function(pts) {
	                  var crossAntiMeridianIndex = doesCrossAntiMerdian(pts);
	                  if (crossAntiMeridianIndex === null) {
	                    return polygons.push(polygon.tester(pts));
	                  }
	                  var stitch = new Array(pts.length + 1);
	                  var si = 0;
	                  for (m = 0; m < pts.length; m++) {
	                    if (m > crossAntiMeridianIndex) {
	                      stitch[si++] = [pts[m][0] + 360, pts[m][1]];
	                    } else if (m === crossAntiMeridianIndex) {
	                      stitch[si++] = pts[m];
	                      stitch[si++] = [pts[m][0], -90];
	                    } else {
	                      stitch[si++] = pts[m];
	                    }
	                  }
	                  var tester = polygon.tester(stitch);
	                  tester.pts.pop();
	                  polygons.push(tester);
	                };
	              } else {
	                appendPolygon = function(pts) {
	                  polygons.push(polygon.tester(pts));
	                };
	              }
	              switch (geometry.type) {
	                case "MultiPolygon":
	                  for (j = 0; j < coords.length; j++) {
	                    for (k = 0; k < coords[j].length; k++) {
	                      appendPolygon(coords[j][k]);
	                    }
	                  }
	                  break;
	                case "Polygon":
	                  for (j = 0; j < coords.length; j++) {
	                    appendPolygon(coords[j]);
	                  }
	                  break;
	              }
	              return polygons;
	            }
	            function getTraceGeojson(trace) {
	              var g = trace.geojson;
	              var PlotlyGeoAssets2 = window.PlotlyGeoAssets || {};
	              var geojsonIn = typeof g === "string" ? PlotlyGeoAssets2[g] : g;
	              if (!isPlainObject(geojsonIn)) {
	                loggers.error("Oops ... something went wrong when fetching " + g);
	                return false;
	              }
	              return geojsonIn;
	            }
	            function extractTraceFeature(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var geojsonIn = getTraceGeojson(trace);
	              if (!geojsonIn) return false;
	              var lookup = {};
	              var featuresOut = [];
	              var i;
	              for (i = 0; i < trace._length; i++) {
	                var cdi = calcTrace[i];
	                if (cdi.loc || cdi.loc === 0) {
	                  lookup[cdi.loc] = cdi;
	                }
	              }
	              function appendFeature(fIn) {
	                var id = nestedProperty(fIn, trace.featureidkey || "id").get();
	                var cdi2 = lookup[id];
	                if (cdi2) {
	                  var geometry = fIn.geometry;
	                  if (geometry.type === "Polygon" || geometry.type === "MultiPolygon") {
	                    var fOut = {
	                      type: "Feature",
	                      id,
	                      geometry,
	                      properties: {}
	                    };
	                    fOut.properties.ct = findCentroid(fOut);
	                    cdi2.fIn = fIn;
	                    cdi2.fOut = fOut;
	                    featuresOut.push(fOut);
	                  } else {
	                    loggers.log(["Location", cdi2.loc, "does not have a valid GeoJSON geometry.", "Traces with locationmode *geojson-id* only support", "*Polygon* and *MultiPolygon* geometries."].join(" "));
	                  }
	                }
	                delete lookup[id];
	              }
	              switch (geojsonIn.type) {
	                case "FeatureCollection":
	                  var featuresIn = geojsonIn.features;
	                  for (i = 0; i < featuresIn.length; i++) {
	                    appendFeature(featuresIn[i]);
	                  }
	                  break;
	                case "Feature":
	                  appendFeature(geojsonIn);
	                  break;
	                default:
	                  loggers.warn(["Invalid GeoJSON type", (geojsonIn.type || "none") + ".", "Traces with locationmode *geojson-id* only support", "*FeatureCollection* and *Feature* types."].join(" "));
	                  return false;
	              }
	              for (var loc in lookup) {
	                loggers.log(["Location *" + loc + "*", "does not have a matching feature with id-key", "*" + trace.featureidkey + "*."].join(" "));
	              }
	              return featuresOut;
	            }
	            function findCentroid(feature) {
	              var geometry = feature.geometry;
	              var poly;
	              if (geometry.type === "MultiPolygon") {
	                var coords = geometry.coordinates;
	                var maxArea = 0;
	                for (var i = 0; i < coords.length; i++) {
	                  var polyi = {
	                    type: "Polygon",
	                    coordinates: coords[i]
	                  };
	                  var area = turfArea.default(polyi);
	                  if (area > maxArea) {
	                    maxArea = area;
	                    poly = polyi;
	                  }
	                }
	              } else {
	                poly = geometry;
	              }
	              return turfCentroid.default(poly).geometry.coordinates;
	            }
	            function fetchTraceGeoData(calcData) {
	              var PlotlyGeoAssets2 = window.PlotlyGeoAssets || {};
	              var promises = [];
	              function fetch(url2) {
	                return new Promise(function(resolve, reject) {
	                  d3.json(url2, function(err, d) {
	                    if (err) {
	                      delete PlotlyGeoAssets2[url2];
	                      var msg = err.status === 404 ? 'GeoJSON at URL "' + url2 + '" does not exist.' : "Unexpected error while fetching from " + url2;
	                      return reject(new Error(msg));
	                    }
	                    PlotlyGeoAssets2[url2] = d;
	                    return resolve(d);
	                  });
	                });
	              }
	              function wait(url2) {
	                return new Promise(function(resolve, reject) {
	                  var cnt = 0;
	                  var interval = setInterval(function() {
	                    if (PlotlyGeoAssets2[url2] && PlotlyGeoAssets2[url2] !== "pending") {
	                      clearInterval(interval);
	                      return resolve(PlotlyGeoAssets2[url2]);
	                    }
	                    if (cnt > 100) {
	                      clearInterval(interval);
	                      return reject("Unexpected error while fetching from " + url2);
	                    }
	                    cnt++;
	                  }, 50);
	                });
	              }
	              for (var i = 0; i < calcData.length; i++) {
	                var trace = calcData[i][0].trace;
	                var url = trace.geojson;
	                if (typeof url === "string") {
	                  if (!PlotlyGeoAssets2[url]) {
	                    PlotlyGeoAssets2[url] = "pending";
	                    promises.push(fetch(url));
	                  } else if (PlotlyGeoAssets2[url] === "pending") {
	                    promises.push(wait(url));
	                  }
	                }
	              }
	              return promises;
	            }
	            function computeBbox(d) {
	              return turfBbox.default(d);
	            }
	            module2.exports = {
	              locationToFeature,
	              feature2polygons,
	              getTraceGeojson,
	              extractTraceFeature,
	              fetchTraceGeoData,
	              computeBbox
	            };
	          }
	        ),
	        /***/
	        18214: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            exports2.calcTraceToLineCoords = function(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var connectgaps = trace.connectgaps;
	              var coords = [];
	              var lineString = [];
	              for (var i = 0; i < calcTrace.length; i++) {
	                var calcPt = calcTrace[i];
	                var lonlat = calcPt.lonlat;
	                if (lonlat[0] !== BADNUM) {
	                  lineString.push(lonlat);
	                } else if (!connectgaps && lineString.length > 0) {
	                  coords.push(lineString);
	                  lineString = [];
	                }
	              }
	              if (lineString.length > 0) {
	                coords.push(lineString);
	              }
	              return coords;
	            };
	            exports2.makeLine = function(coords) {
	              if (coords.length === 1) {
	                return {
	                  type: "LineString",
	                  coordinates: coords[0]
	                };
	              } else {
	                return {
	                  type: "MultiLineString",
	                  coordinates: coords
	                };
	              }
	            };
	            exports2.makePolygon = function(coords) {
	              if (coords.length === 1) {
	                return {
	                  type: "Polygon",
	                  coordinates: coords
	                };
	              } else {
	                var _coords = new Array(coords.length);
	                for (var i = 0; i < coords.length; i++) {
	                  _coords[i] = [coords[i]];
	                }
	                return {
	                  type: "MultiPolygon",
	                  coordinates: _coords
	                };
	              }
	            };
	            exports2.makeBlank = function() {
	              return {
	                type: "Point",
	                coordinates: []
	              };
	            };
	          }
	        ),
	        /***/
	        87642: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var mod = __webpack_require__2(64872).mod;
	            exports2.segmentsIntersect = segmentsIntersect;
	            function segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	              var a = x2 - x1;
	              var b = x3 - x1;
	              var c = x4 - x3;
	              var d = y2 - y1;
	              var e = y3 - y1;
	              var f = y4 - y3;
	              var det = a * f - c * d;
	              if (det === 0) return null;
	              var t = (b * f - c * e) / det;
	              var u = (b * d - a * e) / det;
	              if (u < 0 || u > 1 || t < 0 || t > 1) return null;
	              return {
	                x: x1 + a * t,
	                y: y1 + d * t
	              };
	            }
	            exports2.segmentDistance = function segmentDistance(x1, y1, x2, y2, x3, y3, x4, y4) {
	              if (segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4)) return 0;
	              var x12 = x2 - x1;
	              var y12 = y2 - y1;
	              var x34 = x4 - x3;
	              var y34 = y4 - y3;
	              var ll12 = x12 * x12 + y12 * y12;
	              var ll34 = x34 * x34 + y34 * y34;
	              var dist2 = Math.min(perpDistance2(x12, y12, ll12, x3 - x1, y3 - y1), perpDistance2(x12, y12, ll12, x4 - x1, y4 - y1), perpDistance2(x34, y34, ll34, x1 - x3, y1 - y3), perpDistance2(x34, y34, ll34, x2 - x3, y2 - y3));
	              return Math.sqrt(dist2);
	            };
	            function perpDistance2(xab, yab, llab, xac, yac) {
	              var fcAB = xac * xab + yac * yab;
	              if (fcAB < 0) {
	                return xac * xac + yac * yac;
	              } else if (fcAB > llab) {
	                var xbc = xac - xab;
	                var ybc = yac - yab;
	                return xbc * xbc + ybc * ybc;
	              } else {
	                var crossProduct = xac * yab - yac * xab;
	                return crossProduct * crossProduct / llab;
	              }
	            }
	            var locationCache, workingPath, workingTextWidth;
	            exports2.getTextLocation = function getTextLocation(path, totalPathLen, positionOnPath, textWidth) {
	              if (path !== workingPath || textWidth !== workingTextWidth) {
	                locationCache = {};
	                workingPath = path;
	                workingTextWidth = textWidth;
	              }
	              if (locationCache[positionOnPath]) {
	                return locationCache[positionOnPath];
	              }
	              var p0 = path.getPointAtLength(mod(positionOnPath - textWidth / 2, totalPathLen));
	              var p1 = path.getPointAtLength(mod(positionOnPath + textWidth / 2, totalPathLen));
	              var theta = Math.atan((p1.y - p0.y) / (p1.x - p0.x));
	              var pCenter = path.getPointAtLength(mod(positionOnPath, totalPathLen));
	              var x = (pCenter.x * 4 + p0.x + p1.x) / 6;
	              var y = (pCenter.y * 4 + p0.y + p1.y) / 6;
	              var out = {
	                x,
	                y,
	                theta
	              };
	              locationCache[positionOnPath] = out;
	              return out;
	            };
	            exports2.clearLocationCache = function() {
	              workingPath = null;
	            };
	            exports2.getVisibleSegment = function getVisibleSegment(path, bounds, buffer) {
	              var left = bounds.left;
	              var right = bounds.right;
	              var top = bounds.top;
	              var bottom = bounds.bottom;
	              var pMin = 0;
	              var pTotal = path.getTotalLength();
	              var pMax = pTotal;
	              var pt0, ptTotal;
	              function getDistToPlot(len) {
	                var pt = path.getPointAtLength(len);
	                if (len === 0) pt0 = pt;
	                else if (len === pTotal) ptTotal = pt;
	                var dx = pt.x < left ? left - pt.x : pt.x > right ? pt.x - right : 0;
	                var dy = pt.y < top ? top - pt.y : pt.y > bottom ? pt.y - bottom : 0;
	                return Math.sqrt(dx * dx + dy * dy);
	              }
	              var distToPlot = getDistToPlot(pMin);
	              while (distToPlot) {
	                pMin += distToPlot + buffer;
	                if (pMin > pMax) return;
	                distToPlot = getDistToPlot(pMin);
	              }
	              distToPlot = getDistToPlot(pMax);
	              while (distToPlot) {
	                pMax -= distToPlot + buffer;
	                if (pMin > pMax) return;
	                distToPlot = getDistToPlot(pMax);
	              }
	              return {
	                min: pMin,
	                max: pMax,
	                len: pMax - pMin,
	                total: pTotal,
	                isClosed: pMin === 0 && pMax === pTotal && Math.abs(pt0.x - ptTotal.x) < 0.1 && Math.abs(pt0.y - ptTotal.y) < 0.1
	              };
	            };
	            exports2.findPointOnPath = function findPointOnPath(path, val, coord, opts) {
	              opts = opts || {};
	              var pathLength = opts.pathLength || path.getTotalLength();
	              var tolerance = opts.tolerance || 1e-3;
	              var iterationLimit = opts.iterationLimit || 30;
	              var mul = path.getPointAtLength(0)[coord] > path.getPointAtLength(pathLength)[coord] ? -1 : 1;
	              var i = 0;
	              var b0 = 0;
	              var b1 = pathLength;
	              var mid;
	              var pt;
	              var diff;
	              while (i < iterationLimit) {
	                mid = (b0 + b1) / 2;
	                pt = path.getPointAtLength(mid);
	                diff = pt[coord] - val;
	                if (Math.abs(diff) < tolerance) {
	                  return pt;
	                } else {
	                  if (mul * diff > 0) {
	                    b1 = mid;
	                  } else {
	                    b0 = mid;
	                  }
	                  i++;
	                }
	              }
	              return pt;
	            };
	          }
	        ),
	        /***/
	        81697: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var tinycolor = __webpack_require__2(84267);
	            var rgba = __webpack_require__2(25075);
	            var Colorscale = __webpack_require__2(21081);
	            var colorDflt = __webpack_require__2(22399).defaultLine;
	            var isArrayOrTypedArray = __webpack_require__2(73627).isArrayOrTypedArray;
	            var colorDfltRgba = rgba(colorDflt);
	            var opacityDflt = 1;
	            function calculateColor(colorIn, opacityIn) {
	              var colorOut = colorIn;
	              colorOut[3] *= opacityIn;
	              return colorOut;
	            }
	            function validateColor(colorIn) {
	              if (isNumeric(colorIn)) return colorDfltRgba;
	              var colorOut = rgba(colorIn);
	              return colorOut.length ? colorOut : colorDfltRgba;
	            }
	            function validateOpacity(opacityIn) {
	              return isNumeric(opacityIn) ? opacityIn : opacityDflt;
	            }
	            function formatColor(containerIn, opacityIn, len) {
	              var colorIn = containerIn.color;
	              var isArrayColorIn = isArrayOrTypedArray(colorIn);
	              var isArrayOpacityIn = isArrayOrTypedArray(opacityIn);
	              var cOpts = Colorscale.extractOpts(containerIn);
	              var colorOut = [];
	              var sclFunc, getColor, getOpacity, colori, opacityi;
	              if (cOpts.colorscale !== undefined) {
	                sclFunc = Colorscale.makeColorScaleFuncFromTrace(containerIn);
	              } else {
	                sclFunc = validateColor;
	              }
	              if (isArrayColorIn) {
	                getColor = function(c, i2) {
	                  return c[i2] === undefined ? colorDfltRgba : rgba(sclFunc(c[i2]));
	                };
	              } else getColor = validateColor;
	              if (isArrayOpacityIn) {
	                getOpacity = function(o, i2) {
	                  return o[i2] === undefined ? opacityDflt : validateOpacity(o[i2]);
	                };
	              } else getOpacity = validateOpacity;
	              if (isArrayColorIn || isArrayOpacityIn) {
	                for (var i = 0; i < len; i++) {
	                  colori = getColor(colorIn, i);
	                  opacityi = getOpacity(opacityIn, i);
	                  colorOut[i] = calculateColor(colori, opacityi);
	                }
	              } else colorOut = calculateColor(rgba(colorIn), opacityIn);
	              return colorOut;
	            }
	            function parseColorScale(cont) {
	              var cOpts = Colorscale.extractOpts(cont);
	              var colorscale = cOpts.colorscale;
	              if (cOpts.reversescale) colorscale = Colorscale.flipScale(cOpts.colorscale);
	              return colorscale.map(function(elem) {
	                var index = elem[0];
	                var color = tinycolor(elem[1]);
	                var rgb = color.toRgb();
	                return {
	                  index,
	                  rgb: [rgb.r, rgb.g, rgb.b, rgb.a]
	                };
	              });
	            }
	            module2.exports = {
	              formatColor,
	              parseColorScale
	            };
	          }
	        ),
	        /***/
	        28984: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var identity2 = __webpack_require__2(23389);
	            function wrap(d) {
	              return [d];
	            }
	            module2.exports = {
	              // The D3 data binding concept and the General Update Pattern promotes the idea of
	              // traversing into the scenegraph by using the `.data(fun, keyFun)` call.
	              // The `fun` is most often a `repeat`, ie. the elements beneath a `<g>` element need
	              // access to the same data, or a `descend`, which fans a scenegraph node into a bunch of
	              // of elements, e.g. points, lines, rows, requiring an array as input.
	              // The role of the `keyFun` is to identify what elements are being entered/exited/updated,
	              // otherwise D3 reverts to using a plain index which would screw up `transition`s.
	              keyFun: function(d) {
	                return d.key;
	              },
	              repeat: wrap,
	              descend: identity2,
	              // Plotly.js uses a convention of storing the actual contents of the `calcData` as the
	              // element zero of a container array. These helpers are just used for clarity as a
	              // newcomer to the codebase may not know what the `[0]` is, and whether there can be further
	              // elements (not atm).
	              wrap,
	              unwrap: function(d) {
	                return d[0];
	              }
	            };
	          }
	        ),
	        /***/
	        23389: (
	          /***/
	          function(module2) {
	            module2.exports = function identity2(d) {
	              return d;
	            };
	          }
	        ),
	        /***/
	        39240: (
	          /***/
	          function(module2) {
	            module2.exports = function incrementNumeric(x, delta) {
	              if (!delta) return x;
	              var scale = 1 / Math.abs(delta);
	              var newX = scale > 1 ? (scale * x + scale * delta) / scale : x + delta;
	              var lenX1 = String(newX).length;
	              if (lenX1 > 16) {
	                var lenDt = String(delta).length;
	                var lenX0 = String(x).length;
	                if (lenX1 >= lenX0 + lenDt) {
	                  var s = parseFloat(newX).toPrecision(12);
	                  if (s.indexOf("e+") === -1) newX = +s;
	                }
	              }
	              return newX;
	            };
	          }
	        ),
	        /***/
	        71828: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var utcFormat = __webpack_require__2(84096).g0;
	            var d3Format = __webpack_require__2(60721).WU;
	            var isNumeric = __webpack_require__2(92770);
	            var numConstants = __webpack_require__2(50606);
	            var MAX_SAFE = numConstants.FP_SAFE;
	            var MIN_SAFE = -MAX_SAFE;
	            var BADNUM = numConstants.BADNUM;
	            var lib = module2.exports = {};
	            lib.adjustFormat = function adjustFormat(formatStr) {
	              if (!formatStr || /^\d[.]\df/.test(formatStr) || /[.]\d%/.test(formatStr)) return formatStr;
	              if (formatStr === "0.f") return "~f";
	              if (/^\d%/.test(formatStr)) return "~%";
	              if (/^\ds/.test(formatStr)) return "~s";
	              if (!/^[~,.0$]/.test(formatStr) && /[&fps]/.test(formatStr)) return "~" + formatStr;
	              return formatStr;
	            };
	            var seenBadFormats = {};
	            lib.warnBadFormat = function(f) {
	              var key = String(f);
	              if (!seenBadFormats[key]) {
	                seenBadFormats[key] = 1;
	                lib.warn('encountered bad format: "' + key + '"');
	              }
	            };
	            lib.noFormat = function(value) {
	              return String(value);
	            };
	            lib.numberFormat = function(formatStr) {
	              var fn;
	              try {
	                fn = d3Format(lib.adjustFormat(formatStr));
	              } catch (e) {
	                lib.warnBadFormat(formatStr);
	                return lib.noFormat;
	              }
	              return fn;
	            };
	            lib.nestedProperty = __webpack_require__2(65487);
	            lib.keyedContainer = __webpack_require__2(66636);
	            lib.relativeAttr = __webpack_require__2(6962);
	            lib.isPlainObject = __webpack_require__2(41965);
	            lib.toLogRange = __webpack_require__2(58163);
	            lib.relinkPrivateKeys = __webpack_require__2(51332);
	            var arrayModule = __webpack_require__2(73627);
	            lib.isTypedArray = arrayModule.isTypedArray;
	            lib.isArrayOrTypedArray = arrayModule.isArrayOrTypedArray;
	            lib.isArray1D = arrayModule.isArray1D;
	            lib.ensureArray = arrayModule.ensureArray;
	            lib.concat = arrayModule.concat;
	            lib.maxRowLength = arrayModule.maxRowLength;
	            lib.minRowLength = arrayModule.minRowLength;
	            var modModule = __webpack_require__2(64872);
	            lib.mod = modModule.mod;
	            lib.modHalf = modModule.modHalf;
	            var coerceModule = __webpack_require__2(96554);
	            lib.valObjectMeta = coerceModule.valObjectMeta;
	            lib.coerce = coerceModule.coerce;
	            lib.coerce2 = coerceModule.coerce2;
	            lib.coerceFont = coerceModule.coerceFont;
	            lib.coercePattern = coerceModule.coercePattern;
	            lib.coerceHoverinfo = coerceModule.coerceHoverinfo;
	            lib.coerceSelectionMarkerOpacity = coerceModule.coerceSelectionMarkerOpacity;
	            lib.validate = coerceModule.validate;
	            var datesModule = __webpack_require__2(41631);
	            lib.dateTime2ms = datesModule.dateTime2ms;
	            lib.isDateTime = datesModule.isDateTime;
	            lib.ms2DateTime = datesModule.ms2DateTime;
	            lib.ms2DateTimeLocal = datesModule.ms2DateTimeLocal;
	            lib.cleanDate = datesModule.cleanDate;
	            lib.isJSDate = datesModule.isJSDate;
	            lib.formatDate = datesModule.formatDate;
	            lib.incrementMonth = datesModule.incrementMonth;
	            lib.dateTick0 = datesModule.dateTick0;
	            lib.dfltRange = datesModule.dfltRange;
	            lib.findExactDates = datesModule.findExactDates;
	            lib.MIN_MS = datesModule.MIN_MS;
	            lib.MAX_MS = datesModule.MAX_MS;
	            var searchModule = __webpack_require__2(65888);
	            lib.findBin = searchModule.findBin;
	            lib.sorterAsc = searchModule.sorterAsc;
	            lib.sorterDes = searchModule.sorterDes;
	            lib.distinctVals = searchModule.distinctVals;
	            lib.roundUp = searchModule.roundUp;
	            lib.sort = searchModule.sort;
	            lib.findIndexOfMin = searchModule.findIndexOfMin;
	            lib.sortObjectKeys = __webpack_require__2(78607);
	            var statsModule = __webpack_require__2(80038);
	            lib.aggNums = statsModule.aggNums;
	            lib.len = statsModule.len;
	            lib.mean = statsModule.mean;
	            lib.median = statsModule.median;
	            lib.midRange = statsModule.midRange;
	            lib.variance = statsModule.variance;
	            lib.stdev = statsModule.stdev;
	            lib.interp = statsModule.interp;
	            var matrixModule = __webpack_require__2(35657);
	            lib.init2dArray = matrixModule.init2dArray;
	            lib.transposeRagged = matrixModule.transposeRagged;
	            lib.dot = matrixModule.dot;
	            lib.translationMatrix = matrixModule.translationMatrix;
	            lib.rotationMatrix = matrixModule.rotationMatrix;
	            lib.rotationXYMatrix = matrixModule.rotationXYMatrix;
	            lib.apply3DTransform = matrixModule.apply3DTransform;
	            lib.apply2DTransform = matrixModule.apply2DTransform;
	            lib.apply2DTransform2 = matrixModule.apply2DTransform2;
	            lib.convertCssMatrix = matrixModule.convertCssMatrix;
	            lib.inverseTransformMatrix = matrixModule.inverseTransformMatrix;
	            var anglesModule = __webpack_require__2(26348);
	            lib.deg2rad = anglesModule.deg2rad;
	            lib.rad2deg = anglesModule.rad2deg;
	            lib.angleDelta = anglesModule.angleDelta;
	            lib.angleDist = anglesModule.angleDist;
	            lib.isFullCircle = anglesModule.isFullCircle;
	            lib.isAngleInsideSector = anglesModule.isAngleInsideSector;
	            lib.isPtInsideSector = anglesModule.isPtInsideSector;
	            lib.pathArc = anglesModule.pathArc;
	            lib.pathSector = anglesModule.pathSector;
	            lib.pathAnnulus = anglesModule.pathAnnulus;
	            var anchorUtils = __webpack_require__2(99863);
	            lib.isLeftAnchor = anchorUtils.isLeftAnchor;
	            lib.isCenterAnchor = anchorUtils.isCenterAnchor;
	            lib.isRightAnchor = anchorUtils.isRightAnchor;
	            lib.isTopAnchor = anchorUtils.isTopAnchor;
	            lib.isMiddleAnchor = anchorUtils.isMiddleAnchor;
	            lib.isBottomAnchor = anchorUtils.isBottomAnchor;
	            var geom2dModule = __webpack_require__2(87642);
	            lib.segmentsIntersect = geom2dModule.segmentsIntersect;
	            lib.segmentDistance = geom2dModule.segmentDistance;
	            lib.getTextLocation = geom2dModule.getTextLocation;
	            lib.clearLocationCache = geom2dModule.clearLocationCache;
	            lib.getVisibleSegment = geom2dModule.getVisibleSegment;
	            lib.findPointOnPath = geom2dModule.findPointOnPath;
	            var extendModule = __webpack_require__2(1426);
	            lib.extendFlat = extendModule.extendFlat;
	            lib.extendDeep = extendModule.extendDeep;
	            lib.extendDeepAll = extendModule.extendDeepAll;
	            lib.extendDeepNoArrays = extendModule.extendDeepNoArrays;
	            var loggersModule = __webpack_require__2(47769);
	            lib.log = loggersModule.log;
	            lib.warn = loggersModule.warn;
	            lib.error = loggersModule.error;
	            var regexModule = __webpack_require__2(30587);
	            lib.counterRegex = regexModule.counter;
	            var throttleModule = __webpack_require__2(79990);
	            lib.throttle = throttleModule.throttle;
	            lib.throttleDone = throttleModule.done;
	            lib.clearThrottle = throttleModule.clear;
	            var domModule = __webpack_require__2(24401);
	            lib.getGraphDiv = domModule.getGraphDiv;
	            lib.isPlotDiv = domModule.isPlotDiv;
	            lib.removeElement = domModule.removeElement;
	            lib.addStyleRule = domModule.addStyleRule;
	            lib.addRelatedStyleRule = domModule.addRelatedStyleRule;
	            lib.deleteRelatedStyleRule = domModule.deleteRelatedStyleRule;
	            lib.getFullTransformMatrix = domModule.getFullTransformMatrix;
	            lib.getElementTransformMatrix = domModule.getElementTransformMatrix;
	            lib.getElementAndAncestors = domModule.getElementAndAncestors;
	            lib.equalDomRects = domModule.equalDomRects;
	            lib.clearResponsive = __webpack_require__2(86367);
	            lib.preserveDrawingBuffer = __webpack_require__2(45142);
	            lib.makeTraceGroups = __webpack_require__2(77310);
	            lib._ = __webpack_require__2(15867);
	            lib.notifier = __webpack_require__2(75046);
	            lib.filterUnique = __webpack_require__2(75744);
	            lib.filterVisible = __webpack_require__2(76756);
	            lib.pushUnique = __webpack_require__2(75138);
	            lib.increment = __webpack_require__2(39240);
	            lib.cleanNumber = __webpack_require__2(95218);
	            lib.ensureNumber = function ensureNumber(v) {
	              if (!isNumeric(v)) return BADNUM;
	              v = Number(v);
	              return v > MAX_SAFE || v < MIN_SAFE ? BADNUM : v;
	            };
	            lib.isIndex = function(v, len) {
	              if (len !== undefined && v >= len) return false;
	              return isNumeric(v) && v >= 0 && v % 1 === 0;
	            };
	            lib.noop = __webpack_require__2(64213);
	            lib.identity = __webpack_require__2(23389);
	            lib.repeat = function(v, cnt) {
	              var out = new Array(cnt);
	              for (var i = 0; i < cnt; i++) {
	                out[i] = v;
	              }
	              return out;
	            };
	            lib.swapAttrs = function(cont, attrList, part1, part2) {
	              if (!part1) part1 = "x";
	              if (!part2) part2 = "y";
	              for (var i = 0; i < attrList.length; i++) {
	                var attr = attrList[i];
	                var xp = lib.nestedProperty(cont, attr.replace("?", part1));
	                var yp = lib.nestedProperty(cont, attr.replace("?", part2));
	                var temp = xp.get();
	                xp.set(yp.get());
	                yp.set(temp);
	              }
	            };
	            lib.raiseToTop = function raiseToTop(elem) {
	              elem.parentNode.appendChild(elem);
	            };
	            lib.cancelTransition = function(selection) {
	              return selection.transition().duration(0);
	            };
	            lib.constrain = function(v, v0, v1) {
	              if (v0 > v1) return Math.max(v1, Math.min(v0, v));
	              return Math.max(v0, Math.min(v1, v));
	            };
	            lib.bBoxIntersect = function(a, b, pad) {
	              pad = pad || 0;
	              return a.left <= b.right + pad && b.left <= a.right + pad && a.top <= b.bottom + pad && b.top <= a.bottom + pad;
	            };
	            lib.simpleMap = function(array, func, x1, x2, opts) {
	              var len = array.length;
	              var out = new Array(len);
	              for (var i = 0; i < len; i++) out[i] = func(array[i], x1, x2, opts);
	              return out;
	            };
	            lib.randstr = function randstr(existing, bits, base, _recursion) {
	              if (!base) base = 16;
	              if (bits === undefined) bits = 24;
	              if (bits <= 0) return "0";
	              var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
	              var res = "";
	              var i, b, x;
	              for (i = 2; digits === Infinity; i *= 2) {
	                digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
	              }
	              var rem = digits - Math.floor(digits);
	              for (i = 0; i < Math.floor(digits); i++) {
	                x = Math.floor(Math.random() * base).toString(base);
	                res = x + res;
	              }
	              if (rem) {
	                b = Math.pow(base, rem);
	                x = Math.floor(Math.random() * b).toString(base);
	                res = x + res;
	              }
	              var parsed = parseInt(res, base);
	              if (existing && existing[res] || parsed !== Infinity && parsed >= Math.pow(2, bits)) {
	                if (_recursion > 10) {
	                  lib.warn("randstr failed uniqueness");
	                  return res;
	                }
	                return randstr(existing, bits, base, (_recursion || 0) + 1);
	              } else return res;
	            };
	            lib.OptionControl = function(opt, optname) {
	              if (!opt) opt = {};
	              if (!optname) optname = "opt";
	              var self2 = {};
	              self2.optionList = [];
	              self2._newoption = function(optObj) {
	                optObj[optname] = opt;
	                self2[optObj.name] = optObj;
	                self2.optionList.push(optObj);
	              };
	              self2["_" + optname] = opt;
	              return self2;
	            };
	            lib.smooth = function(arrayIn, FWHM) {
	              FWHM = Math.round(FWHM) || 0;
	              if (FWHM < 2) return arrayIn;
	              var alen = arrayIn.length;
	              var alen2 = 2 * alen;
	              var wlen = 2 * FWHM - 1;
	              var w = new Array(wlen);
	              var arrayOut = new Array(alen);
	              var i;
	              var j;
	              var k;
	              var v;
	              for (i = 0; i < wlen; i++) {
	                w[i] = (1 - Math.cos(Math.PI * (i + 1) / FWHM)) / (2 * FWHM);
	              }
	              for (i = 0; i < alen; i++) {
	                v = 0;
	                for (j = 0; j < wlen; j++) {
	                  k = i + j + 1 - FWHM;
	                  if (k < -alen) k -= alen2 * Math.round(k / alen2);
	                  else if (k >= alen2) k -= alen2 * Math.floor(k / alen2);
	                  if (k < 0) k = -1 - k;
	                  else if (k >= alen) k = alen2 - 1 - k;
	                  v += arrayIn[k] * w[j];
	                }
	                arrayOut[i] = v;
	              }
	              return arrayOut;
	            };
	            lib.syncOrAsync = function(sequence, arg, finalStep) {
	              var ret, fni;
	              function continueAsync() {
	                return lib.syncOrAsync(sequence, arg, finalStep);
	              }
	              while (sequence.length) {
	                fni = sequence.splice(0, 1)[0];
	                ret = fni(arg);
	                if (ret && ret.then) {
	                  return ret.then(continueAsync);
	                }
	              }
	              return finalStep && finalStep(arg);
	            };
	            lib.stripTrailingSlash = function(str) {
	              if (str.substr(-1) === "/") return str.substr(0, str.length - 1);
	              return str;
	            };
	            lib.noneOrAll = function(containerIn, containerOut, attrList) {
	              if (!containerIn) return;
	              var hasAny = false;
	              var hasAll = true;
	              var i;
	              var val;
	              for (i = 0; i < attrList.length; i++) {
	                val = containerIn[attrList[i]];
	                if (val !== undefined && val !== null) hasAny = true;
	                else hasAll = false;
	              }
	              if (hasAny && !hasAll) {
	                for (i = 0; i < attrList.length; i++) {
	                  containerIn[attrList[i]] = containerOut[attrList[i]];
	                }
	              }
	            };
	            lib.mergeArray = function(traceAttr, cd, cdAttr, fn) {
	              var hasFn = typeof fn === "function";
	              if (lib.isArrayOrTypedArray(traceAttr)) {
	                var imax = Math.min(traceAttr.length, cd.length);
	                for (var i = 0; i < imax; i++) {
	                  var v = traceAttr[i];
	                  cd[i][cdAttr] = hasFn ? fn(v) : v;
	                }
	              }
	            };
	            lib.mergeArrayCastPositive = function(traceAttr, cd, cdAttr) {
	              return lib.mergeArray(traceAttr, cd, cdAttr, function(v) {
	                var w = +v;
	                return !isFinite(w) ? 0 : w > 0 ? w : 0;
	              });
	            };
	            lib.fillArray = function(traceAttr, cd, cdAttr, fn) {
	              fn = fn || lib.identity;
	              if (lib.isArrayOrTypedArray(traceAttr)) {
	                for (var i = 0; i < cd.length; i++) {
	                  cd[i][cdAttr] = fn(traceAttr[i]);
	                }
	              }
	            };
	            lib.castOption = function(trace, ptNumber, astr, fn) {
	              fn = fn || lib.identity;
	              var val = lib.nestedProperty(trace, astr).get();
	              if (lib.isArrayOrTypedArray(val)) {
	                if (Array.isArray(ptNumber) && lib.isArrayOrTypedArray(val[ptNumber[0]])) {
	                  return fn(val[ptNumber[0]][ptNumber[1]]);
	                } else {
	                  return fn(val[ptNumber]);
	                }
	              } else {
	                return val;
	              }
	            };
	            lib.extractOption = function(calcPt, trace, calcKey, traceKey) {
	              if (calcKey in calcPt) return calcPt[calcKey];
	              var traceVal = lib.nestedProperty(trace, traceKey).get();
	              if (!Array.isArray(traceVal)) return traceVal;
	            };
	            function makePtIndex2PtNumber(indexToPoints) {
	              var ptIndex2ptNumber = {};
	              for (var k in indexToPoints) {
	                var pts = indexToPoints[k];
	                for (var j = 0; j < pts.length; j++) {
	                  ptIndex2ptNumber[pts[j]] = +k;
	                }
	              }
	              return ptIndex2ptNumber;
	            }
	            lib.tagSelected = function(calcTrace, trace, ptNumber2cdIndex) {
	              var selectedpoints = trace.selectedpoints;
	              var indexToPoints = trace._indexToPoints;
	              var ptIndex2ptNumber;
	              if (indexToPoints) {
	                ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
	              }
	              function isCdIndexValid(v) {
	                return v !== undefined && v < calcTrace.length;
	              }
	              for (var i = 0; i < selectedpoints.length; i++) {
	                var ptIndex = selectedpoints[i];
	                if (lib.isIndex(ptIndex) || lib.isArrayOrTypedArray(ptIndex) && lib.isIndex(ptIndex[0]) && lib.isIndex(ptIndex[1])) {
	                  var ptNumber = ptIndex2ptNumber ? ptIndex2ptNumber[ptIndex] : ptIndex;
	                  var cdIndex = ptNumber2cdIndex ? ptNumber2cdIndex[ptNumber] : ptNumber;
	                  if (isCdIndexValid(cdIndex)) {
	                    calcTrace[cdIndex].selected = 1;
	                  }
	                }
	              }
	            };
	            lib.selIndices2selPoints = function(trace) {
	              var selectedpoints = trace.selectedpoints;
	              var indexToPoints = trace._indexToPoints;
	              if (indexToPoints) {
	                var ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
	                var out = [];
	                for (var i = 0; i < selectedpoints.length; i++) {
	                  var ptIndex = selectedpoints[i];
	                  if (lib.isIndex(ptIndex)) {
	                    var ptNumber = ptIndex2ptNumber[ptIndex];
	                    if (lib.isIndex(ptNumber)) {
	                      out.push(ptNumber);
	                    }
	                  }
	                }
	                return out;
	              } else {
	                return selectedpoints;
	              }
	            };
	            lib.getTargetArray = function(trace, transformOpts) {
	              var target = transformOpts.target;
	              if (typeof target === "string" && target) {
	                var array = lib.nestedProperty(trace, target).get();
	                return Array.isArray(array) ? array : false;
	              } else if (Array.isArray(target)) {
	                return target;
	              }
	              return false;
	            };
	            function minExtend(obj1, obj2, opt) {
	              var objOut = {};
	              if (typeof obj2 !== "object") obj2 = {};
	              var arrayLen = opt === "pieLike" ? -1 : 3;
	              var keys = Object.keys(obj1);
	              var i, k, v;
	              for (i = 0; i < keys.length; i++) {
	                k = keys[i];
	                v = obj1[k];
	                if (k.charAt(0) === "_" || typeof v === "function") continue;
	                else if (k === "module") objOut[k] = v;
	                else if (Array.isArray(v)) {
	                  if (k === "colorscale" || arrayLen === -1) {
	                    objOut[k] = v.slice();
	                  } else {
	                    objOut[k] = v.slice(0, arrayLen);
	                  }
	                } else if (lib.isTypedArray(v)) {
	                  if (arrayLen === -1) {
	                    objOut[k] = v.subarray();
	                  } else {
	                    objOut[k] = v.subarray(0, arrayLen);
	                  }
	                } else if (v && typeof v === "object") objOut[k] = minExtend(obj1[k], obj2[k], opt);
	                else objOut[k] = v;
	              }
	              keys = Object.keys(obj2);
	              for (i = 0; i < keys.length; i++) {
	                k = keys[i];
	                v = obj2[k];
	                if (typeof v !== "object" || !(k in objOut) || typeof objOut[k] !== "object") {
	                  objOut[k] = v;
	                }
	              }
	              return objOut;
	            }
	            lib.minExtend = minExtend;
	            lib.titleCase = function(s) {
	              return s.charAt(0).toUpperCase() + s.substr(1);
	            };
	            lib.containsAny = function(s, fragments) {
	              for (var i = 0; i < fragments.length; i++) {
	                if (s.indexOf(fragments[i]) !== -1) return true;
	              }
	              return false;
	            };
	            lib.isIE = function() {
	              return typeof window.navigator.msSaveBlob !== "undefined";
	            };
	            var IS_SAFARI_REGEX = /Version\/[\d\.]+.*Safari/;
	            lib.isSafari = function() {
	              return IS_SAFARI_REGEX.test(window.navigator.userAgent);
	            };
	            var IS_IOS_REGEX = /iPad|iPhone|iPod/;
	            lib.isIOS = function() {
	              return IS_IOS_REGEX.test(window.navigator.userAgent);
	            };
	            var FIREFOX_VERSION_REGEX = /Firefox\/(\d+)\.\d+/;
	            lib.getFirefoxVersion = function() {
	              var match = FIREFOX_VERSION_REGEX.exec(window.navigator.userAgent);
	              if (match && match.length === 2) {
	                var versionInt = parseInt(match[1]);
	                if (!isNaN(versionInt)) {
	                  return versionInt;
	                }
	              }
	              return null;
	            };
	            lib.isD3Selection = function(obj) {
	              return obj instanceof d3.selection;
	            };
	            lib.ensureSingle = function(parent, nodeType, className, enterFn) {
	              var sel = parent.select(nodeType + (className ? "." + className : ""));
	              if (sel.size()) return sel;
	              var layer = parent.append(nodeType);
	              if (className) layer.classed(className, true);
	              if (enterFn) layer.call(enterFn);
	              return layer;
	            };
	            lib.ensureSingleById = function(parent, nodeType, id, enterFn) {
	              var sel = parent.select(nodeType + "#" + id);
	              if (sel.size()) return sel;
	              var layer = parent.append(nodeType).attr("id", id);
	              if (enterFn) layer.call(enterFn);
	              return layer;
	            };
	            lib.objectFromPath = function(path, value) {
	              var keys = path.split(".");
	              var tmpObj;
	              var obj = tmpObj = {};
	              for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var el = null;
	                var parts = keys[i].match(/(.*)\[([0-9]+)\]/);
	                if (parts) {
	                  key = parts[1];
	                  el = parts[2];
	                  tmpObj = tmpObj[key] = [];
	                  if (i === keys.length - 1) {
	                    tmpObj[el] = value;
	                  } else {
	                    tmpObj[el] = {};
	                  }
	                  tmpObj = tmpObj[el];
	                } else {
	                  if (i === keys.length - 1) {
	                    tmpObj[key] = value;
	                  } else {
	                    tmpObj[key] = {};
	                  }
	                  tmpObj = tmpObj[key];
	                }
	              }
	              return obj;
	            };
	            var dottedPropertyRegex = /^([^\[\.]+)\.(.+)?/;
	            var indexedPropertyRegex = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
	            function notValid(prop) {
	              return prop.slice(0, 2) === "__";
	            }
	            lib.expandObjectPaths = function(data) {
	              var match, key, prop, datum, idx, dest, trailingPath;
	              if (typeof data === "object" && !Array.isArray(data)) {
	                for (key in data) {
	                  if (data.hasOwnProperty(key)) {
	                    if (match = key.match(dottedPropertyRegex)) {
	                      datum = data[key];
	                      prop = match[1];
	                      if (notValid(prop)) continue;
	                      delete data[key];
	                      data[prop] = lib.extendDeepNoArrays(data[prop] || {}, lib.objectFromPath(key, lib.expandObjectPaths(datum))[prop]);
	                    } else if (match = key.match(indexedPropertyRegex)) {
	                      datum = data[key];
	                      prop = match[1];
	                      if (notValid(prop)) continue;
	                      idx = parseInt(match[2]);
	                      delete data[key];
	                      data[prop] = data[prop] || [];
	                      if (match[3] === ".") {
	                        trailingPath = match[4];
	                        dest = data[prop][idx] = data[prop][idx] || {};
	                        lib.extendDeepNoArrays(dest, lib.objectFromPath(trailingPath, lib.expandObjectPaths(datum)));
	                      } else {
	                        if (notValid(prop)) continue;
	                        data[prop][idx] = lib.expandObjectPaths(datum);
	                      }
	                    } else {
	                      if (notValid(key)) continue;
	                      data[key] = lib.expandObjectPaths(data[key]);
	                    }
	                  }
	                }
	              }
	              return data;
	            };
	            lib.numSeparate = function(value, separators, separatethousands) {
	              if (!separatethousands) separatethousands = false;
	              if (typeof separators !== "string" || separators.length === 0) {
	                throw new Error("Separator string required for formatting!");
	              }
	              if (typeof value === "number") {
	                value = String(value);
	              }
	              var thousandsRe = /(\d+)(\d{3})/;
	              var decimalSep = separators.charAt(0);
	              var thouSep = separators.charAt(1);
	              var x = value.split(".");
	              var x1 = x[0];
	              var x2 = x.length > 1 ? decimalSep + x[1] : "";
	              if (thouSep && (x.length > 1 || x1.length > 4 || separatethousands)) {
	                while (thousandsRe.test(x1)) {
	                  x1 = x1.replace(thousandsRe, "$1" + thouSep + "$2");
	                }
	              }
	              return x1 + x2;
	            };
	            lib.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
	            var SIMPLE_PROPERTY_REGEX = /^\w*$/;
	            lib.templateString = function(string, obj) {
	              var getterCache = {};
	              return string.replace(lib.TEMPLATE_STRING_REGEX, function(dummy, key) {
	                var v;
	                if (SIMPLE_PROPERTY_REGEX.test(key)) {
	                  v = obj[key];
	                } else {
	                  getterCache[key] = getterCache[key] || lib.nestedProperty(obj, key).get;
	                  v = getterCache[key]();
	                }
	                return lib.isValidTextValue(v) ? v : "";
	              });
	            };
	            var hovertemplateWarnings = {
	              max: 10,
	              count: 0,
	              name: "hovertemplate"
	            };
	            lib.hovertemplateString = function() {
	              return templateFormatString.apply(hovertemplateWarnings, arguments);
	            };
	            var texttemplateWarnings = {
	              max: 10,
	              count: 0,
	              name: "texttemplate"
	            };
	            lib.texttemplateString = function() {
	              return templateFormatString.apply(texttemplateWarnings, arguments);
	            };
	            var MULT_DIV_REGEX = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/;
	            function multDivParser(inputStr) {
	              var match = inputStr.match(MULT_DIV_REGEX);
	              if (match) return {
	                key: match[1],
	                op: match[2],
	                number: Number(match[3])
	              };
	              return {
	                key: inputStr,
	                op: null,
	                number: null
	              };
	            }
	            var texttemplateWarningsForShapes = {
	              max: 10,
	              count: 0,
	              name: "texttemplate",
	              parseMultDiv: true
	            };
	            lib.texttemplateStringForShapes = function() {
	              return templateFormatString.apply(texttemplateWarningsForShapes, arguments);
	            };
	            var TEMPLATE_STRING_FORMAT_SEPARATOR = /^[:|\|]/;
	            function templateFormatString(string, labels, d3locale) {
	              var opts = this;
	              var args = arguments;
	              if (!labels) labels = {};
	              var getterCache = {};
	              return string.replace(lib.TEMPLATE_STRING_REGEX, function(match, rawKey, format) {
	                var isOther = rawKey === "xother" || rawKey === "yother";
	                var isSpaceOther = rawKey === "_xother" || rawKey === "_yother";
	                var isSpaceOtherSpace = rawKey === "_xother_" || rawKey === "_yother_";
	                var isOtherSpace = rawKey === "xother_" || rawKey === "yother_";
	                var hasOther = isOther || isSpaceOther || isOtherSpace || isSpaceOtherSpace;
	                var key = rawKey;
	                if (isSpaceOther || isSpaceOtherSpace) key = key.substring(1);
	                if (isOtherSpace || isSpaceOtherSpace) key = key.substring(0, key.length - 1);
	                var parsedOp = null;
	                var parsedNumber = null;
	                if (opts.parseMultDiv) {
	                  var _match = multDivParser(key);
	                  key = _match.key;
	                  parsedOp = _match.op;
	                  parsedNumber = _match.number;
	                }
	                var value;
	                if (hasOther) {
	                  value = labels[key];
	                  if (value === undefined) return "";
	                } else {
	                  var obj, i;
	                  for (i = 3; i < args.length; i++) {
	                    obj = args[i];
	                    if (!obj) continue;
	                    if (obj.hasOwnProperty(key)) {
	                      value = obj[key];
	                      break;
	                    }
	                    if (!SIMPLE_PROPERTY_REGEX.test(key)) {
	                      value = lib.nestedProperty(obj, key).get();
	                      value = getterCache[key] || lib.nestedProperty(obj, key).get();
	                      if (value) getterCache[key] = value;
	                    }
	                    if (value !== undefined) break;
	                  }
	                }
	                if (value !== undefined) {
	                  if (parsedOp === "*") value *= parsedNumber;
	                  if (parsedOp === "/") value /= parsedNumber;
	                }
	                if (value === undefined && opts) {
	                  if (opts.count < opts.max) {
	                    lib.warn("Variable '" + key + "' in " + opts.name + " could not be found!");
	                    value = match;
	                  }
	                  if (opts.count === opts.max) {
	                    lib.warn("Too many " + opts.name + " warnings - additional warnings will be suppressed");
	                  }
	                  opts.count++;
	                  return match;
	                }
	                if (format) {
	                  var fmt;
	                  if (format[0] === ":") {
	                    fmt = d3locale ? d3locale.numberFormat : lib.numberFormat;
	                    value = fmt(format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ""))(value);
	                  }
	                  if (format[0] === "|") {
	                    fmt = d3locale ? d3locale.timeFormat : utcFormat;
	                    var ms = lib.dateTime2ms(value);
	                    value = lib.formatDate(ms, format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ""), false, fmt);
	                  }
	                } else {
	                  var keyLabel = key + "Label";
	                  if (labels.hasOwnProperty(keyLabel)) value = labels[keyLabel];
	                }
	                if (hasOther) {
	                  value = "(" + value + ")";
	                  if (isSpaceOther || isSpaceOtherSpace) value = " " + value;
	                  if (isOtherSpace || isSpaceOtherSpace) value = value + " ";
	                }
	                return value;
	              });
	            }
	            var char0 = 48;
	            var char9 = 57;
	            lib.subplotSort = function(a, b) {
	              var l = Math.min(a.length, b.length) + 1;
	              var numA = 0;
	              var numB = 0;
	              for (var i = 0; i < l; i++) {
	                var charA = a.charCodeAt(i) || 0;
	                var charB = b.charCodeAt(i) || 0;
	                var isNumA = charA >= char0 && charA <= char9;
	                var isNumB = charB >= char0 && charB <= char9;
	                if (isNumA) numA = 10 * numA + charA - char0;
	                if (isNumB) numB = 10 * numB + charB - char0;
	                if (!isNumA || !isNumB) {
	                  if (numA !== numB) return numA - numB;
	                  if (charA !== charB) return charA - charB;
	                }
	              }
	              return numB - numA;
	            };
	            var randSeed = 2e9;
	            lib.seedPseudoRandom = function() {
	              randSeed = 2e9;
	            };
	            lib.pseudoRandom = function() {
	              var lastVal = randSeed;
	              randSeed = (69069 * randSeed + 1) % 4294967296;
	              if (Math.abs(randSeed - lastVal) < 429496729) return lib.pseudoRandom();
	              return randSeed / 4294967296;
	            };
	            lib.fillText = function(calcPt, trace, contOut) {
	              var fill = Array.isArray(contOut) ? function(v) {
	                contOut.push(v);
	              } : function(v) {
	                contOut.text = v;
	              };
	              var htx = lib.extractOption(calcPt, trace, "htx", "hovertext");
	              if (lib.isValidTextValue(htx)) return fill(htx);
	              var tx = lib.extractOption(calcPt, trace, "tx", "text");
	              if (lib.isValidTextValue(tx)) return fill(tx);
	            };
	            lib.isValidTextValue = function(v) {
	              return v || v === 0;
	            };
	            lib.formatPercent = function(ratio, n) {
	              n = n || 0;
	              var str = (Math.round(100 * ratio * Math.pow(10, n)) * Math.pow(0.1, n)).toFixed(n) + "%";
	              for (var i = 0; i < n; i++) {
	                if (str.indexOf(".") !== -1) {
	                  str = str.replace("0%", "%");
	                  str = str.replace(".%", "%");
	                }
	              }
	              return str;
	            };
	            lib.isHidden = function(gd) {
	              var display = window.getComputedStyle(gd).display;
	              return !display || display === "none";
	            };
	            lib.strTranslate = function(x, y) {
	              return x || y ? "translate(" + x + "," + y + ")" : "";
	            };
	            lib.strRotate = function(a) {
	              return a ? "rotate(" + a + ")" : "";
	            };
	            lib.strScale = function(s) {
	              return s !== 1 ? "scale(" + s + ")" : "";
	            };
	            lib.getTextTransform = function(transform) {
	              var noCenter = transform.noCenter;
	              var textX = transform.textX;
	              var textY = transform.textY;
	              var targetX = transform.targetX;
	              var targetY = transform.targetY;
	              var anchorX = transform.anchorX || 0;
	              var anchorY = transform.anchorY || 0;
	              var rotate = transform.rotate;
	              var scale = transform.scale;
	              if (!scale) scale = 0;
	              else if (scale > 1) scale = 1;
	              return lib.strTranslate(targetX - scale * (textX + anchorX), targetY - scale * (textY + anchorY)) + lib.strScale(scale) + (rotate ? "rotate(" + rotate + (noCenter ? "" : " " + textX + " " + textY) + ")" : "");
	            };
	            lib.setTransormAndDisplay = function(s, transform) {
	              s.attr("transform", lib.getTextTransform(transform));
	              s.style("display", transform.scale ? null : "none");
	            };
	            lib.ensureUniformFontSize = function(gd, baseFont) {
	              var out = lib.extendFlat({}, baseFont);
	              out.size = Math.max(baseFont.size, gd._fullLayout.uniformtext.minsize || 0);
	              return out;
	            };
	            lib.join2 = function(arr, mainSeparator, lastSeparator) {
	              var len = arr.length;
	              if (len > 1) {
	                return arr.slice(0, -1).join(mainSeparator) + lastSeparator + arr[len - 1];
	              }
	              return arr.join(mainSeparator);
	            };
	            lib.bigFont = function(size) {
	              return Math.round(1.2 * size);
	            };
	            var firefoxVersion = lib.getFirefoxVersion();
	            var isProblematicFirefox = firefoxVersion !== null && firefoxVersion < 86;
	            lib.getPositionFromD3Event = function() {
	              if (isProblematicFirefox) {
	                return [d3.event.layerX, d3.event.layerY];
	              } else {
	                return [d3.event.offsetX, d3.event.offsetY];
	              }
	            };
	          }
	        ),
	        /***/
	        41965: (
	          /***/
	          function(module2) {
	            module2.exports = function isPlainObject(obj) {
	              if (window && window.process && window.process.versions) {
	                return Object.prototype.toString.call(obj) === "[object Object]";
	              }
	              return Object.prototype.toString.call(obj) === "[object Object]" && Object.getPrototypeOf(obj).hasOwnProperty("hasOwnProperty");
	            };
	          }
	        ),
	        /***/
	        66636: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var nestedProperty = __webpack_require__2(65487);
	            var SIMPLE_PROPERTY_REGEX = /^\w*$/;
	            var NONE = 0;
	            var NAME = 1;
	            var VALUE = 2;
	            var BOTH = 3;
	            var UNSET = 4;
	            module2.exports = function keyedContainer(baseObj, path, keyName, valueName) {
	              keyName = keyName || "name";
	              valueName = valueName || "value";
	              var i, arr, baseProp;
	              var changeTypes = {};
	              if (path && path.length) {
	                baseProp = nestedProperty(baseObj, path);
	                arr = baseProp.get();
	              } else {
	                arr = baseObj;
	              }
	              path = path || "";
	              var indexLookup = {};
	              if (arr) {
	                for (i = 0; i < arr.length; i++) {
	                  indexLookup[arr[i][keyName]] = i;
	                }
	              }
	              var isSimpleValueProp = SIMPLE_PROPERTY_REGEX.test(valueName);
	              var obj = {
	                set: function(name2, value) {
	                  var changeType = value === null ? UNSET : NONE;
	                  if (!arr) {
	                    if (!baseProp || changeType === UNSET) return;
	                    arr = [];
	                    baseProp.set(arr);
	                  }
	                  var idx = indexLookup[name2];
	                  if (idx === undefined) {
	                    if (changeType === UNSET) return;
	                    changeType = changeType | BOTH;
	                    idx = arr.length;
	                    indexLookup[name2] = idx;
	                  } else if (value !== (isSimpleValueProp ? arr[idx][valueName] : nestedProperty(arr[idx], valueName).get())) {
	                    changeType = changeType | VALUE;
	                  }
	                  var newValue = arr[idx] = arr[idx] || {};
	                  newValue[keyName] = name2;
	                  if (isSimpleValueProp) {
	                    newValue[valueName] = value;
	                  } else {
	                    nestedProperty(newValue, valueName).set(value);
	                  }
	                  if (value !== null) {
	                    changeType = changeType & -5;
	                  }
	                  changeTypes[idx] = changeTypes[idx] | changeType;
	                  return obj;
	                },
	                get: function(name2) {
	                  if (!arr) return;
	                  var idx = indexLookup[name2];
	                  if (idx === undefined) {
	                    return undefined;
	                  } else if (isSimpleValueProp) {
	                    return arr[idx][valueName];
	                  } else {
	                    return nestedProperty(arr[idx], valueName).get();
	                  }
	                },
	                rename: function(name2, newName) {
	                  var idx = indexLookup[name2];
	                  if (idx === undefined) return obj;
	                  changeTypes[idx] = changeTypes[idx] | NAME;
	                  indexLookup[newName] = idx;
	                  delete indexLookup[name2];
	                  arr[idx][keyName] = newName;
	                  return obj;
	                },
	                remove: function(name2) {
	                  var idx = indexLookup[name2];
	                  if (idx === undefined) return obj;
	                  var object = arr[idx];
	                  if (Object.keys(object).length > 2) {
	                    changeTypes[idx] = changeTypes[idx] | VALUE;
	                    return obj.set(name2, null);
	                  }
	                  if (isSimpleValueProp) {
	                    for (i = idx; i < arr.length; i++) {
	                      changeTypes[i] = changeTypes[i] | BOTH;
	                    }
	                    for (i = idx; i < arr.length; i++) {
	                      indexLookup[arr[i][keyName]]--;
	                    }
	                    arr.splice(idx, 1);
	                    delete indexLookup[name2];
	                  } else {
	                    nestedProperty(object, valueName).set(null);
	                    changeTypes[idx] = changeTypes[idx] | VALUE | UNSET;
	                  }
	                  return obj;
	                },
	                constructUpdate: function() {
	                  var astr, idx;
	                  var update = {};
	                  var changed = Object.keys(changeTypes);
	                  for (var i2 = 0; i2 < changed.length; i2++) {
	                    idx = changed[i2];
	                    astr = path + "[" + idx + "]";
	                    if (arr[idx]) {
	                      if (changeTypes[idx] & NAME) {
	                        update[astr + "." + keyName] = arr[idx][keyName];
	                      }
	                      if (changeTypes[idx] & VALUE) {
	                        if (isSimpleValueProp) {
	                          update[astr + "." + valueName] = changeTypes[idx] & UNSET ? null : arr[idx][valueName];
	                        } else {
	                          update[astr + "." + valueName] = changeTypes[idx] & UNSET ? null : nestedProperty(arr[idx], valueName).get();
	                        }
	                      }
	                    } else {
	                      update[astr] = null;
	                    }
	                  }
	                  return update;
	                }
	              };
	              return obj;
	            };
	          }
	        ),
	        /***/
	        15867: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            module2.exports = function localize(gd, s) {
	              var locale = gd._context.locale;
	              for (var i = 0; i < 2; i++) {
	                var locales = gd._context.locales;
	                for (var j = 0; j < 2; j++) {
	                  var dict = (locales[locale] || {}).dictionary;
	                  if (dict) {
	                    var out = dict[s];
	                    if (out) return out;
	                  }
	                  locales = Registry.localeRegistry;
	                }
	                var baseLocale = locale.split("-")[0];
	                if (baseLocale === locale) break;
	                locale = baseLocale;
	              }
	              return s;
	            };
	          }
	        ),
	        /***/
	        47769: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dfltConfig = __webpack_require__2(72075).dfltConfig;
	            var notifier = __webpack_require__2(75046);
	            var loggers = module2.exports = {};
	            loggers.log = function() {
	              var i;
	              if (dfltConfig.logging > 1) {
	                var messages = ["LOG:"];
	                for (i = 0; i < arguments.length; i++) {
	                  messages.push(arguments[i]);
	                }
	                console.trace.apply(console, messages);
	              }
	              if (dfltConfig.notifyOnLogging > 1) {
	                var lines = [];
	                for (i = 0; i < arguments.length; i++) {
	                  lines.push(arguments[i]);
	                }
	                notifier(lines.join("<br>"), "long");
	              }
	            };
	            loggers.warn = function() {
	              var i;
	              if (dfltConfig.logging > 0) {
	                var messages = ["WARN:"];
	                for (i = 0; i < arguments.length; i++) {
	                  messages.push(arguments[i]);
	                }
	                console.trace.apply(console, messages);
	              }
	              if (dfltConfig.notifyOnLogging > 0) {
	                var lines = [];
	                for (i = 0; i < arguments.length; i++) {
	                  lines.push(arguments[i]);
	                }
	                notifier(lines.join("<br>"), "stick");
	              }
	            };
	            loggers.error = function() {
	              var i;
	              if (dfltConfig.logging > 0) {
	                var messages = ["ERROR:"];
	                for (i = 0; i < arguments.length; i++) {
	                  messages.push(arguments[i]);
	                }
	                console.error.apply(console, messages);
	              }
	              if (dfltConfig.notifyOnLogging > 0) {
	                var lines = [];
	                for (i = 0; i < arguments.length; i++) {
	                  lines.push(arguments[i]);
	                }
	                notifier(lines.join("<br>"), "stick");
	              }
	            };
	          }
	        ),
	        /***/
	        77310: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            module2.exports = function makeTraceGroups(traceLayer, cdModule, cls) {
	              var traces = traceLayer.selectAll("g." + cls.replace(/\s/g, ".")).data(cdModule, function(cd) {
	                return cd[0].trace.uid;
	              });
	              traces.exit().remove();
	              traces.enter().append("g").attr("class", cls);
	              traces.order();
	              var k = traceLayer.classed("rangeplot") ? "nodeRangePlot3" : "node3";
	              traces.each(function(cd) {
	                cd[0][k] = d3.select(this);
	              });
	              return traces;
	            };
	          }
	        ),
	        /***/
	        35657: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var mat4X4 = __webpack_require__2(79576);
	            exports2.init2dArray = function(rowLength, colLength) {
	              var array = new Array(rowLength);
	              for (var i = 0; i < rowLength; i++) array[i] = new Array(colLength);
	              return array;
	            };
	            exports2.transposeRagged = function(z) {
	              var maxlen = 0;
	              var zlen = z.length;
	              var i, j;
	              for (i = 0; i < zlen; i++) maxlen = Math.max(maxlen, z[i].length);
	              var t = new Array(maxlen);
	              for (i = 0; i < maxlen; i++) {
	                t[i] = new Array(zlen);
	                for (j = 0; j < zlen; j++) t[i][j] = z[j][i];
	              }
	              return t;
	            };
	            exports2.dot = function(x, y) {
	              if (!(x.length && y.length) || x.length !== y.length) return null;
	              var len = x.length;
	              var out;
	              var i;
	              if (x[0].length) {
	                out = new Array(len);
	                for (i = 0; i < len; i++) out[i] = exports2.dot(x[i], y);
	              } else if (y[0].length) {
	                var yTranspose = exports2.transposeRagged(y);
	                out = new Array(yTranspose.length);
	                for (i = 0; i < yTranspose.length; i++) out[i] = exports2.dot(x, yTranspose[i]);
	              } else {
	                out = 0;
	                for (i = 0; i < len; i++) out += x[i] * y[i];
	              }
	              return out;
	            };
	            exports2.translationMatrix = function(x, y) {
	              return [[1, 0, x], [0, 1, y], [0, 0, 1]];
	            };
	            exports2.rotationMatrix = function(alpha) {
	              var a = alpha * Math.PI / 180;
	              return [[Math.cos(a), -Math.sin(a), 0], [Math.sin(a), Math.cos(a), 0], [0, 0, 1]];
	            };
	            exports2.rotationXYMatrix = function(a, x, y) {
	              return exports2.dot(exports2.dot(exports2.translationMatrix(x, y), exports2.rotationMatrix(a)), exports2.translationMatrix(-x, -y));
	            };
	            exports2.apply3DTransform = function(transform) {
	              return function() {
	                var args = arguments;
	                var xyz = arguments.length === 1 ? args[0] : [args[0], args[1], args[2] || 0];
	                return exports2.dot(transform, [xyz[0], xyz[1], xyz[2], 1]).slice(0, 3);
	              };
	            };
	            exports2.apply2DTransform = function(transform) {
	              return function() {
	                var args = arguments;
	                if (args.length === 3) {
	                  args = args[0];
	                }
	                var xy = arguments.length === 1 ? args[0] : [args[0], args[1]];
	                return exports2.dot(transform, [xy[0], xy[1], 1]).slice(0, 2);
	              };
	            };
	            exports2.apply2DTransform2 = function(transform) {
	              var at = exports2.apply2DTransform(transform);
	              return function(xys) {
	                return at(xys.slice(0, 2)).concat(at(xys.slice(2, 4)));
	              };
	            };
	            exports2.convertCssMatrix = function(m) {
	              if (m) {
	                var len = m.length;
	                if (len === 16) return m;
	                if (len === 6) {
	                  return [m[0], m[1], 0, 0, m[2], m[3], 0, 0, 0, 0, 1, 0, m[4], m[5], 0, 1];
	                }
	              }
	              return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	            };
	            exports2.inverseTransformMatrix = function(m) {
	              var out = [];
	              mat4X4.invert(out, m);
	              return [[out[0], out[1], out[2], out[3]], [out[4], out[5], out[6], out[7]], [out[8], out[9], out[10], out[11]], [out[12], out[13], out[14], out[15]]];
	            };
	          }
	        ),
	        /***/
	        64872: (
	          /***/
	          function(module2) {
	            function mod(v, d) {
	              var out = v % d;
	              return out < 0 ? out + d : out;
	            }
	            function modHalf(v, d) {
	              return Math.abs(v) > d / 2 ? v - Math.round(v / d) * d : v;
	            }
	            module2.exports = {
	              mod,
	              modHalf
	            };
	          }
	        ),
	        /***/
	        65487: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var isArrayOrTypedArray = __webpack_require__2(73627).isArrayOrTypedArray;
	            module2.exports = function nestedProperty(container, propStr) {
	              if (isNumeric(propStr)) propStr = String(propStr);
	              else if (typeof propStr !== "string" || propStr.substr(propStr.length - 4) === "[-1]") {
	                throw "bad property string";
	              }
	              var propParts = propStr.split(".");
	              var indexed;
	              var indices;
	              var i, j;
	              for (j = 0; j < propParts.length; j++) {
	                if (String(propParts[j]).slice(0, 2) === "__") {
	                  throw "bad property string";
	                }
	              }
	              j = 0;
	              while (j < propParts.length) {
	                indexed = String(propParts[j]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/);
	                if (indexed) {
	                  if (indexed[1]) propParts[j] = indexed[1];
	                  else if (j === 0) propParts.splice(0, 1);
	                  else throw "bad property string";
	                  indices = indexed[2].substr(1, indexed[2].length - 2).split("][");
	                  for (i = 0; i < indices.length; i++) {
	                    j++;
	                    propParts.splice(j, 0, Number(indices[i]));
	                  }
	                }
	                j++;
	              }
	              if (typeof container !== "object") {
	                return badContainer(container, propStr, propParts);
	              }
	              return {
	                set: npSet(container, propParts, propStr),
	                get: npGet(container, propParts),
	                astr: propStr,
	                parts: propParts,
	                obj: container
	              };
	            };
	            function npGet(cont, parts) {
	              return function() {
	                var curCont = cont;
	                var curPart;
	                var allSame;
	                var out;
	                var i;
	                var j;
	                for (i = 0; i < parts.length - 1; i++) {
	                  curPart = parts[i];
	                  if (curPart === -1) {
	                    allSame = true;
	                    out = [];
	                    for (j = 0; j < curCont.length; j++) {
	                      out[j] = npGet(curCont[j], parts.slice(i + 1))();
	                      if (out[j] !== out[0]) allSame = false;
	                    }
	                    return allSame ? out[0] : out;
	                  }
	                  if (typeof curPart === "number" && !isArrayOrTypedArray(curCont)) {
	                    return undefined;
	                  }
	                  curCont = curCont[curPart];
	                  if (typeof curCont !== "object" || curCont === null) {
	                    return undefined;
	                  }
	                }
	                if (typeof curCont !== "object" || curCont === null) return undefined;
	                out = curCont[parts[i]];
	                if (out === null) return undefined;
	                return out;
	              };
	            }
	            var ARGS_PATTERN = /(^|\.)args\[/;
	            function isDeletable(val, propStr) {
	              return val === undefined || val === null && !propStr.match(ARGS_PATTERN);
	            }
	            function npSet(cont, parts, propStr) {
	              return function(val) {
	                var curCont = cont;
	                var propPart = "";
	                var toDelete = isDeletable(val, propStr);
	                var curPart;
	                var i;
	                for (i = 0; i < parts.length - 1; i++) {
	                  curPart = parts[i];
	                  if (typeof curPart === "number" && !isArrayOrTypedArray(curCont)) {
	                    throw "array index but container is not an array";
	                  }
	                  if (curPart === -1) {
	                    toDelete = !setArrayAll(curCont, parts.slice(i + 1), val, propStr);
	                    if (toDelete) break;
	                    else return;
	                  }
	                  if (!checkNewContainer(curCont, curPart, parts[i + 1], toDelete)) {
	                    break;
	                  }
	                  curCont = curCont[curPart];
	                  if (typeof curCont !== "object" || curCont === null) {
	                    throw "container is not an object";
	                  }
	                  propPart = joinPropStr(propPart, curPart);
	                }
	                if (toDelete) {
	                  if (i === parts.length - 1) {
	                    delete curCont[parts[i]];
	                    if (Array.isArray(curCont) && +parts[i] === curCont.length - 1) {
	                      while (curCont.length && curCont[curCont.length - 1] === undefined) {
	                        curCont.pop();
	                      }
	                    }
	                  }
	                } else curCont[parts[i]] = val;
	              };
	            }
	            function joinPropStr(propStr, newPart) {
	              var toAdd = newPart;
	              if (isNumeric(newPart)) toAdd = "[" + newPart + "]";
	              else if (propStr) toAdd = "." + newPart;
	              return propStr + toAdd;
	            }
	            function setArrayAll(containerArray, innerParts, val, propStr) {
	              var arrayVal = isArrayOrTypedArray(val);
	              var allSet = true;
	              var thisVal = val;
	              var thisPropStr = propStr.replace("-1", 0);
	              var deleteThis = arrayVal ? false : isDeletable(val, thisPropStr);
	              var firstPart = innerParts[0];
	              var i;
	              for (i = 0; i < containerArray.length; i++) {
	                thisPropStr = propStr.replace("-1", i);
	                if (arrayVal) {
	                  thisVal = val[i % val.length];
	                  deleteThis = isDeletable(thisVal, thisPropStr);
	                }
	                if (deleteThis) allSet = false;
	                if (!checkNewContainer(containerArray, i, firstPart, deleteThis)) {
	                  continue;
	                }
	                npSet(containerArray[i], innerParts, propStr.replace("-1", i))(thisVal);
	              }
	              return allSet;
	            }
	            function checkNewContainer(container, part, nextPart, toDelete) {
	              if (container[part] === undefined) {
	                if (toDelete) return false;
	                if (typeof nextPart === "number") container[part] = [];
	                else container[part] = {};
	              }
	              return true;
	            }
	            function badContainer(container, propStr, propParts) {
	              return {
	                set: function() {
	                  throw "bad container";
	                },
	                get: function() {
	                },
	                astr: propStr,
	                parts: propParts,
	                obj: container
	              };
	            }
	          }
	        ),
	        /***/
	        64213: (
	          /***/
	          function(module2) {
	            module2.exports = function noop() {
	            };
	          }
	        ),
	        /***/
	        75046: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var NOTEDATA = [];
	            module2.exports = function(text, displayLength) {
	              if (NOTEDATA.indexOf(text) !== -1) return;
	              NOTEDATA.push(text);
	              var ts = 1e3;
	              if (isNumeric(displayLength)) ts = displayLength;
	              else if (displayLength === "long") ts = 3e3;
	              var notifierContainer = d3.select("body").selectAll(".plotly-notifier").data([0]);
	              notifierContainer.enter().append("div").classed("plotly-notifier", true);
	              var notes = notifierContainer.selectAll(".notifier-note").data(NOTEDATA);
	              function killNote(transition) {
	                transition.duration(700).style("opacity", 0).each("end", function(thisText) {
	                  var thisIndex = NOTEDATA.indexOf(thisText);
	                  if (thisIndex !== -1) NOTEDATA.splice(thisIndex, 1);
	                  d3.select(this).remove();
	                });
	              }
	              notes.enter().append("div").classed("notifier-note", true).style("opacity", 0).each(function(thisText) {
	                var note = d3.select(this);
	                note.append("button").classed("notifier-close", true).html("&times;").on("click", function() {
	                  note.transition().call(killNote);
	                });
	                var p = note.append("p");
	                var lines = thisText.split(/<br\s*\/?>/g);
	                for (var i = 0; i < lines.length; i++) {
	                  if (i) p.append("br");
	                  p.append("span").text(lines[i]);
	                }
	                if (displayLength === "stick") {
	                  note.transition().duration(350).style("opacity", 1);
	                } else {
	                  note.transition().duration(700).style("opacity", 1).transition().delay(ts).call(killNote);
	                }
	              });
	            };
	          }
	        ),
	        /***/
	        39918: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var setCursor = __webpack_require__2(6964);
	            var STASHATTR = "data-savedcursor";
	            var NO_CURSOR = "!!";
	            module2.exports = function overrideCursor(el3, csr) {
	              var savedCursor = el3.attr(STASHATTR);
	              if (csr) {
	                if (!savedCursor) {
	                  var classes = (el3.attr("class") || "").split(" ");
	                  for (var i = 0; i < classes.length; i++) {
	                    var cls = classes[i];
	                    if (cls.indexOf("cursor-") === 0) {
	                      el3.attr(STASHATTR, cls.substr(7)).classed(cls, false);
	                    }
	                  }
	                  if (!el3.attr(STASHATTR)) {
	                    el3.attr(STASHATTR, NO_CURSOR);
	                  }
	                }
	                setCursor(el3, csr);
	              } else if (savedCursor) {
	                el3.attr(STASHATTR, null);
	                if (savedCursor === NO_CURSOR) setCursor(el3);
	                else setCursor(el3, savedCursor);
	              }
	            };
	          }
	        ),
	        /***/
	        61082: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dot = __webpack_require__2(35657).dot;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var polygon = module2.exports = {};
	            polygon.tester = function tester(ptsIn) {
	              var pts = ptsIn.slice();
	              var xmin = pts[0][0];
	              var xmax = xmin;
	              var ymin = pts[0][1];
	              var ymax = ymin;
	              var i;
	              if (pts[pts.length - 1][0] !== pts[0][0] || pts[pts.length - 1][1] !== pts[0][1]) {
	                pts.push(pts[0]);
	              }
	              for (i = 1; i < pts.length; i++) {
	                xmin = Math.min(xmin, pts[i][0]);
	                xmax = Math.max(xmax, pts[i][0]);
	                ymin = Math.min(ymin, pts[i][1]);
	                ymax = Math.max(ymax, pts[i][1]);
	              }
	              var isRect = false;
	              var rectFirstEdgeTest;
	              if (pts.length === 5) {
	                if (pts[0][0] === pts[1][0]) {
	                  if (pts[2][0] === pts[3][0] && pts[0][1] === pts[3][1] && pts[1][1] === pts[2][1]) {
	                    isRect = true;
	                    rectFirstEdgeTest = function(pt) {
	                      return pt[0] === pts[0][0];
	                    };
	                  }
	                } else if (pts[0][1] === pts[1][1]) {
	                  if (pts[2][1] === pts[3][1] && pts[0][0] === pts[3][0] && pts[1][0] === pts[2][0]) {
	                    isRect = true;
	                    rectFirstEdgeTest = function(pt) {
	                      return pt[1] === pts[0][1];
	                    };
	                  }
	                }
	              }
	              function rectContains(pt, omitFirstEdge) {
	                var x = pt[0];
	                var y = pt[1];
	                if (x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
	                  return false;
	                }
	                if (omitFirstEdge && rectFirstEdgeTest(pt)) return false;
	                return true;
	              }
	              function contains(pt, omitFirstEdge) {
	                var x = pt[0];
	                var y = pt[1];
	                if (x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
	                  return false;
	                }
	                var imax = pts.length;
	                var x1 = pts[0][0];
	                var y1 = pts[0][1];
	                var crossings = 0;
	                var i2;
	                var x0;
	                var y0;
	                var xmini;
	                var ycross;
	                for (i2 = 1; i2 < imax; i2++) {
	                  x0 = x1;
	                  y0 = y1;
	                  x1 = pts[i2][0];
	                  y1 = pts[i2][1];
	                  xmini = Math.min(x0, x1);
	                  if (x < xmini || x > Math.max(x0, x1) || y > Math.max(y0, y1)) {
	                    continue;
	                  } else if (y < Math.min(y0, y1)) {
	                    if (x !== xmini) crossings++;
	                  } else {
	                    if (x1 === x0) ycross = y;
	                    else ycross = y0 + (x - x0) * (y1 - y0) / (x1 - x0);
	                    if (y === ycross) {
	                      if (i2 === 1 && omitFirstEdge) return false;
	                      return true;
	                    }
	                    if (y <= ycross && x !== xmini) crossings++;
	                  }
	                }
	                return crossings % 2 === 1;
	              }
	              var degenerate = true;
	              var lastPt = pts[0];
	              for (i = 1; i < pts.length; i++) {
	                if (lastPt[0] !== pts[i][0] || lastPt[1] !== pts[i][1]) {
	                  degenerate = false;
	                  break;
	                }
	              }
	              return {
	                xmin,
	                xmax,
	                ymin,
	                ymax,
	                pts,
	                contains: isRect ? rectContains : contains,
	                isRect,
	                degenerate
	              };
	            };
	            polygon.isSegmentBent = function isSegmentBent(pts, start, end, tolerance) {
	              var startPt = pts[start];
	              var segment = [pts[end][0] - startPt[0], pts[end][1] - startPt[1]];
	              var segmentSquared = dot(segment, segment);
	              var segmentLen = Math.sqrt(segmentSquared);
	              var unitPerp = [-segment[1] / segmentLen, segment[0] / segmentLen];
	              var i;
	              var part;
	              var partParallel;
	              for (i = start + 1; i < end; i++) {
	                part = [pts[i][0] - startPt[0], pts[i][1] - startPt[1]];
	                partParallel = dot(part, segment);
	                if (partParallel < 0 || partParallel > segmentSquared || Math.abs(dot(part, unitPerp)) > tolerance) return true;
	              }
	              return false;
	            };
	            polygon.filter = function filter(pts, tolerance) {
	              var ptsFiltered = [pts[0]];
	              var doneRawIndex = 0;
	              var doneFilteredIndex = 0;
	              function addPt(pt) {
	                pts.push(pt);
	                var prevFilterLen = ptsFiltered.length;
	                var iLast = doneRawIndex;
	                ptsFiltered.splice(doneFilteredIndex + 1);
	                for (var i = iLast + 1; i < pts.length; i++) {
	                  if (i === pts.length - 1 || polygon.isSegmentBent(pts, iLast, i + 1, tolerance)) {
	                    ptsFiltered.push(pts[i]);
	                    if (ptsFiltered.length < prevFilterLen - 2) {
	                      doneRawIndex = i;
	                      doneFilteredIndex = ptsFiltered.length - 1;
	                    }
	                    iLast = i;
	                  }
	                }
	              }
	              if (pts.length > 1) {
	                var lastPt = pts.pop();
	                addPt(lastPt);
	              }
	              return {
	                addPt,
	                raw: pts,
	                filtered: ptsFiltered
	              };
	            };
	          }
	        ),
	        /***/
	        79749: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var showNoWebGlMsg = __webpack_require__2(58617);
	            var createRegl = __webpack_require__2(98580);
	            module2.exports = function prepareRegl(gd, extensions, reglPrecompiled) {
	              var fullLayout = gd._fullLayout;
	              var success = true;
	              fullLayout._glcanvas.each(function(d) {
	                if (d.regl) {
	                  d.regl.preloadCachedCode(reglPrecompiled);
	                  return;
	                }
	                if (d.pick && !fullLayout._has("parcoords")) return;
	                try {
	                  d.regl = createRegl({
	                    canvas: this,
	                    attributes: {
	                      antialias: !d.pick,
	                      preserveDrawingBuffer: true
	                    },
	                    pixelRatio: gd._context.plotGlPixelRatio || __webpack_require__2.g.devicePixelRatio,
	                    extensions: extensions || [],
	                    cachedCode: reglPrecompiled || {}
	                  });
	                } catch (e) {
	                  success = false;
	                }
	                if (!d.regl) success = false;
	                if (success) {
	                  this.addEventListener("webglcontextlost", function(event) {
	                    if (gd && gd.emit) {
	                      gd.emit("plotly_webglcontextlost", {
	                        event,
	                        layer: d.key
	                      });
	                    }
	                  }, false);
	                }
	              });
	              if (!success) {
	                showNoWebGlMsg({
	                  container: fullLayout._glcontainer.node()
	                });
	              }
	              return success;
	            };
	          }
	        ),
	        /***/
	        45142: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var isMobileOrTablet = __webpack_require__2(35791);
	            module2.exports = function preserveDrawingBuffer(opts) {
	              var ua;
	              if (opts && opts.hasOwnProperty("userAgent")) {
	                ua = opts.userAgent;
	              } else {
	                ua = getUserAgent();
	              }
	              if (typeof ua !== "string") return true;
	              var enable = isMobileOrTablet({
	                ua: {
	                  headers: {
	                    "user-agent": ua
	                  }
	                },
	                tablet: true,
	                featureDetect: false
	              });
	              if (!enable) {
	                var allParts = ua.split(" ");
	                for (var i = 1; i < allParts.length; i++) {
	                  var part = allParts[i];
	                  if (part.indexOf("Safari") !== -1) {
	                    for (var k = i - 1; k > -1; k--) {
	                      var prevPart = allParts[k];
	                      if (prevPart.substr(0, 8) === "Version/") {
	                        var v = prevPart.substr(8).split(".")[0];
	                        if (isNumeric(v)) v = +v;
	                        if (v >= 13) return true;
	                      }
	                    }
	                  }
	                }
	              }
	              return enable;
	            };
	            function getUserAgent() {
	              var ua;
	              if (typeof navigator !== "undefined") {
	                ua = navigator.userAgent;
	              }
	              if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
	                ua = ua.headers["user-agent"];
	              }
	              return ua;
	            }
	          }
	        ),
	        /***/
	        75138: (
	          /***/
	          function(module2) {
	            module2.exports = function pushUnique(array, item) {
	              if (item instanceof RegExp) {
	                var itemStr = item.toString();
	                for (var i = 0; i < array.length; i++) {
	                  if (array[i] instanceof RegExp && array[i].toString() === itemStr) {
	                    return array;
	                  }
	                }
	                array.push(item);
	              } else if ((item || item === 0) && array.indexOf(item) === -1) array.push(item);
	              return array;
	            };
	          }
	        ),
	        /***/
	        10847: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var dfltConfig = __webpack_require__2(72075).dfltConfig;
	            function copyArgArray(gd, args) {
	              var copy = [];
	              var arg;
	              for (var i = 0; i < args.length; i++) {
	                arg = args[i];
	                if (arg === gd) copy[i] = arg;
	                else if (typeof arg === "object") {
	                  copy[i] = Array.isArray(arg) ? Lib.extendDeep([], arg) : Lib.extendDeepAll({}, arg);
	                } else copy[i] = arg;
	              }
	              return copy;
	            }
	            var queue = {};
	            queue.add = function(gd, undoFunc, undoArgs, redoFunc, redoArgs) {
	              var queueObj, queueIndex;
	              gd.undoQueue = gd.undoQueue || {
	                index: 0,
	                queue: [],
	                sequence: false
	              };
	              queueIndex = gd.undoQueue.index;
	              if (gd.autoplay) {
	                if (!gd.undoQueue.inSequence) gd.autoplay = false;
	                return;
	              }
	              if (!gd.undoQueue.sequence || gd.undoQueue.beginSequence) {
	                queueObj = {
	                  undo: {
	                    calls: [],
	                    args: []
	                  },
	                  redo: {
	                    calls: [],
	                    args: []
	                  }
	                };
	                gd.undoQueue.queue.splice(queueIndex, gd.undoQueue.queue.length - queueIndex, queueObj);
	                gd.undoQueue.index += 1;
	              } else {
	                queueObj = gd.undoQueue.queue[queueIndex - 1];
	              }
	              gd.undoQueue.beginSequence = false;
	              if (queueObj) {
	                queueObj.undo.calls.unshift(undoFunc);
	                queueObj.undo.args.unshift(undoArgs);
	                queueObj.redo.calls.push(redoFunc);
	                queueObj.redo.args.push(redoArgs);
	              }
	              if (gd.undoQueue.queue.length > dfltConfig.queueLength) {
	                gd.undoQueue.queue.shift();
	                gd.undoQueue.index--;
	              }
	            };
	            queue.startSequence = function(gd) {
	              gd.undoQueue = gd.undoQueue || {
	                index: 0,
	                queue: [],
	                sequence: false
	              };
	              gd.undoQueue.sequence = true;
	              gd.undoQueue.beginSequence = true;
	            };
	            queue.stopSequence = function(gd) {
	              gd.undoQueue = gd.undoQueue || {
	                index: 0,
	                queue: [],
	                sequence: false
	              };
	              gd.undoQueue.sequence = false;
	              gd.undoQueue.beginSequence = false;
	            };
	            queue.undo = function undo(gd) {
	              var queueObj, i;
	              if (gd.undoQueue === undefined || isNaN(gd.undoQueue.index) || gd.undoQueue.index <= 0) {
	                return;
	              }
	              gd.undoQueue.index--;
	              queueObj = gd.undoQueue.queue[gd.undoQueue.index];
	              gd.undoQueue.inSequence = true;
	              for (i = 0; i < queueObj.undo.calls.length; i++) {
	                queue.plotDo(gd, queueObj.undo.calls[i], queueObj.undo.args[i]);
	              }
	              gd.undoQueue.inSequence = false;
	              gd.autoplay = false;
	            };
	            queue.redo = function redo(gd) {
	              var queueObj, i;
	              if (gd.undoQueue === undefined || isNaN(gd.undoQueue.index) || gd.undoQueue.index >= gd.undoQueue.queue.length) {
	                return;
	              }
	              queueObj = gd.undoQueue.queue[gd.undoQueue.index];
	              gd.undoQueue.inSequence = true;
	              for (i = 0; i < queueObj.redo.calls.length; i++) {
	                queue.plotDo(gd, queueObj.redo.calls[i], queueObj.redo.args[i]);
	              }
	              gd.undoQueue.inSequence = false;
	              gd.autoplay = false;
	              gd.undoQueue.index++;
	            };
	            queue.plotDo = function(gd, func, args) {
	              gd.autoplay = true;
	              args = copyArgArray(gd, args);
	              func.apply(null, args);
	            };
	            module2.exports = queue;
	          }
	        ),
	        /***/
	        30587: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.counter = function(head, tail, openEnded, matchBeginning) {
	              var fullTail = (tail || "") + (openEnded ? "" : "$");
	              var startWithPrefix = matchBeginning === false ? "" : "^";
	              if (head === "xy") {
	                return new RegExp(startWithPrefix + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + fullTail);
	              }
	              return new RegExp(startWithPrefix + head + "([2-9]|[1-9][0-9]+)?" + fullTail);
	            };
	          }
	        ),
	        /***/
	        6962: (
	          /***/
	          function(module2) {
	            var ASCEND = /^(.*)(\.[^\.\[\]]+|\[\d\])$/;
	            var SIMPLEATTR = /^[^\.\[\]]+$/;
	            module2.exports = function(baseAttr, relativeAttr) {
	              while (relativeAttr) {
	                var match = baseAttr.match(ASCEND);
	                if (match) baseAttr = match[1];
	                else if (baseAttr.match(SIMPLEATTR)) baseAttr = "";
	                else throw new Error("bad relativeAttr call:" + [baseAttr, relativeAttr]);
	                if (relativeAttr.charAt(0) === "^") relativeAttr = relativeAttr.slice(1);
	                else break;
	              }
	              if (baseAttr && relativeAttr.charAt(0) !== "[") {
	                return baseAttr + "." + relativeAttr;
	              }
	              return baseAttr + relativeAttr;
	            };
	          }
	        ),
	        /***/
	        51332: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(73627).isArrayOrTypedArray;
	            var isPlainObject = __webpack_require__2(41965);
	            module2.exports = function relinkPrivateKeys(toContainer, fromContainer) {
	              for (var k in fromContainer) {
	                var fromVal = fromContainer[k];
	                var toVal = toContainer[k];
	                if (toVal === fromVal) continue;
	                if (k.charAt(0) === "_" || typeof fromVal === "function") {
	                  if (k in toContainer) continue;
	                  toContainer[k] = fromVal;
	                } else if (isArrayOrTypedArray(fromVal) && isArrayOrTypedArray(toVal) && isPlainObject(fromVal[0])) {
	                  if (k === "customdata" || k === "ids") continue;
	                  var minLen = Math.min(fromVal.length, toVal.length);
	                  for (var j = 0; j < minLen; j++) {
	                    if (toVal[j] !== fromVal[j] && isPlainObject(fromVal[j]) && isPlainObject(toVal[j])) {
	                      relinkPrivateKeys(toVal[j], fromVal[j]);
	                    }
	                  }
	                } else if (isPlainObject(fromVal) && isPlainObject(toVal)) {
	                  relinkPrivateKeys(toVal, fromVal);
	                  if (!Object.keys(toVal).length) delete toContainer[k];
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        65888: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var loggers = __webpack_require__2(47769);
	            var identity2 = __webpack_require__2(23389);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var roundingError = 1e-9;
	            exports2.findBin = function(val, bins, linelow) {
	              if (isNumeric(bins.start)) {
	                return linelow ? Math.ceil((val - bins.start) / bins.size - roundingError) - 1 : Math.floor((val - bins.start) / bins.size + roundingError);
	              } else {
	                var n1 = 0;
	                var n2 = bins.length;
	                var c = 0;
	                var binSize = n2 > 1 ? (bins[n2 - 1] - bins[0]) / (n2 - 1) : 1;
	                var n, test;
	                if (binSize >= 0) {
	                  test = linelow ? lessThan : lessOrEqual;
	                } else {
	                  test = linelow ? greaterOrEqual : greaterThan;
	                }
	                val += binSize * roundingError * (linelow ? -1 : 1) * (binSize >= 0 ? 1 : -1);
	                while (n1 < n2 && c++ < 100) {
	                  n = Math.floor((n1 + n2) / 2);
	                  if (test(bins[n], val)) n1 = n + 1;
	                  else n2 = n;
	                }
	                if (c > 90) loggers.log("Long binary search...");
	                return n1 - 1;
	              }
	            };
	            function lessThan(a, b) {
	              return a < b;
	            }
	            function lessOrEqual(a, b) {
	              return a <= b;
	            }
	            function greaterThan(a, b) {
	              return a > b;
	            }
	            function greaterOrEqual(a, b) {
	              return a >= b;
	            }
	            exports2.sorterAsc = function(a, b) {
	              return a - b;
	            };
	            exports2.sorterDes = function(a, b) {
	              return b - a;
	            };
	            exports2.distinctVals = function(valsIn) {
	              var vals = valsIn.slice();
	              vals.sort(exports2.sorterAsc);
	              var last;
	              for (last = vals.length - 1; last > -1; last--) {
	                if (vals[last] !== BADNUM) break;
	              }
	              var minDiff = vals[last] - vals[0] || 1;
	              var errDiff = minDiff / (last || 1) / 1e4;
	              var newVals = [];
	              var preV;
	              for (var i = 0; i <= last; i++) {
	                var v = vals[i];
	                var diff = v - preV;
	                if (preV === undefined) {
	                  newVals.push(v);
	                  preV = v;
	                } else if (diff > errDiff) {
	                  minDiff = Math.min(minDiff, diff);
	                  newVals.push(v);
	                  preV = v;
	                }
	              }
	              return {
	                vals: newVals,
	                minDiff
	              };
	            };
	            exports2.roundUp = function(val, arrayIn, reverse) {
	              var low = 0;
	              var high = arrayIn.length - 1;
	              var mid;
	              var c = 0;
	              var dlow = reverse ? 0 : 1;
	              var dhigh = reverse ? 1 : 0;
	              var rounded = reverse ? Math.ceil : Math.floor;
	              while (low < high && c++ < 100) {
	                mid = rounded((low + high) / 2);
	                if (arrayIn[mid] <= val) low = mid + dlow;
	                else high = mid - dhigh;
	              }
	              return arrayIn[low];
	            };
	            exports2.sort = function(array, sortFn) {
	              var notOrdered = 0;
	              var notReversed = 0;
	              for (var i = 1; i < array.length; i++) {
	                var pairOrder = sortFn(array[i], array[i - 1]);
	                if (pairOrder < 0) notOrdered = 1;
	                else if (pairOrder > 0) notReversed = 1;
	                if (notOrdered && notReversed) return array.sort(sortFn);
	              }
	              return notReversed ? array : array.reverse();
	            };
	            exports2.findIndexOfMin = function(arr, fn) {
	              fn = fn || identity2;
	              var min = Infinity;
	              var ind;
	              for (var i = 0; i < arr.length; i++) {
	                var v = fn(arr[i]);
	                if (v < min) {
	                  min = v;
	                  ind = i;
	                }
	              }
	              return ind;
	            };
	          }
	        ),
	        /***/
	        6964: (
	          /***/
	          function(module2) {
	            module2.exports = function setCursor(el3, csr) {
	              (el3.attr("class") || "").split(" ").forEach(function(cls) {
	                if (cls.indexOf("cursor-") === 0) el3.classed(cls, false);
	              });
	              if (csr) el3.classed("cursor-" + csr, true);
	            };
	          }
	        ),
	        /***/
	        58617: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var noop = function() {
	            };
	            module2.exports = function showNoWebGlMsg(scene) {
	              for (var prop in scene) {
	                if (typeof scene[prop] === "function") scene[prop] = noop;
	              }
	              scene.destroy = function() {
	                scene.container.parentNode.removeChild(scene.container);
	              };
	              var div = document.createElement("div");
	              div.className = "no-webgl";
	              div.style.cursor = "pointer";
	              div.style.fontSize = "24px";
	              div.style.color = Color.defaults[0];
	              div.style.position = "absolute";
	              div.style.left = div.style.top = "0px";
	              div.style.width = div.style.height = "100%";
	              div.style["background-color"] = Color.lightLine;
	              div.style["z-index"] = 30;
	              var p = document.createElement("p");
	              p.textContent = "WebGL is not supported by your browser - visit https://get.webgl.org for more info";
	              p.style.position = "relative";
	              p.style.top = "50%";
	              p.style.left = "50%";
	              p.style.height = "30%";
	              p.style.width = "50%";
	              p.style.margin = "-15% 0 0 -25%";
	              div.appendChild(p);
	              scene.container.appendChild(div);
	              scene.container.style.background = "#FFFFFF";
	              scene.container.onclick = function() {
	                window.open("https://get.webgl.org");
	              };
	              return false;
	            };
	          }
	        ),
	        /***/
	        78607: (
	          /***/
	          function(module2) {
	            module2.exports = function sortObjectKeys(obj) {
	              return Object.keys(obj).sort();
	            };
	          }
	        ),
	        /***/
	        80038: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var isArrayOrTypedArray = __webpack_require__2(73627).isArrayOrTypedArray;
	            exports2.aggNums = function(f, v, a, len) {
	              var i, b;
	              if (!len || len > a.length) len = a.length;
	              if (!isNumeric(v)) v = false;
	              if (isArrayOrTypedArray(a[0])) {
	                b = new Array(len);
	                for (i = 0; i < len; i++) b[i] = exports2.aggNums(f, v, a[i]);
	                a = b;
	              }
	              for (i = 0; i < len; i++) {
	                if (!isNumeric(v)) v = a[i];
	                else if (isNumeric(a[i])) v = f(+v, +a[i]);
	              }
	              return v;
	            };
	            exports2.len = function(data) {
	              return exports2.aggNums(function(a) {
	                return a + 1;
	              }, 0, data);
	            };
	            exports2.mean = function(data, len) {
	              if (!len) len = exports2.len(data);
	              return exports2.aggNums(function(a, b) {
	                return a + b;
	              }, 0, data) / len;
	            };
	            exports2.midRange = function(numArr) {
	              if (numArr === undefined || numArr.length === 0) return undefined;
	              return (exports2.aggNums(Math.max, null, numArr) + exports2.aggNums(Math.min, null, numArr)) / 2;
	            };
	            exports2.variance = function(data, len, mean) {
	              if (!len) len = exports2.len(data);
	              if (!isNumeric(mean)) mean = exports2.mean(data, len);
	              return exports2.aggNums(function(a, b) {
	                return a + Math.pow(b - mean, 2);
	              }, 0, data) / len;
	            };
	            exports2.stdev = function(data, len, mean) {
	              return Math.sqrt(exports2.variance(data, len, mean));
	            };
	            exports2.median = function(data) {
	              var b = data.slice().sort();
	              return exports2.interp(b, 0.5);
	            };
	            exports2.interp = function(arr, n) {
	              if (!isNumeric(n)) throw "n should be a finite number";
	              n = n * arr.length - 0.5;
	              if (n < 0) return arr[0];
	              if (n > arr.length - 1) return arr[arr.length - 1];
	              var frac = n % 1;
	              return frac * arr[Math.ceil(n)] + (1 - frac) * arr[Math.floor(n)];
	            };
	          }
	        ),
	        /***/
	        78614: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var rgba = __webpack_require__2(25075);
	            function str2RgbaArray(color) {
	              if (!color) return [0, 0, 0, 1];
	              return rgba(color);
	            }
	            module2.exports = str2RgbaArray;
	          }
	        ),
	        /***/
	        3883: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var constants = __webpack_require__2(32396);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var _supportsPixelated = null;
	            function supportsPixelatedImage() {
	              if (_supportsPixelated !== null) {
	                return _supportsPixelated;
	              }
	              _supportsPixelated = false;
	              var unsupportedBrowser = Lib.isIE() || Lib.isSafari() || Lib.isIOS();
	              if (window.navigator.userAgent && !unsupportedBrowser) {
	                var declarations = Array.from(constants.CSS_DECLARATIONS).reverse();
	                var supports = window.CSS && window.CSS.supports || window.supportsCSS;
	                if (typeof supports === "function") {
	                  _supportsPixelated = declarations.some(function(d) {
	                    return supports.apply(null, d);
	                  });
	                } else {
	                  var image3 = Drawing.tester.append("image").attr("style", constants.STYLE);
	                  var cStyles = window.getComputedStyle(image3.node());
	                  var imageRendering = cStyles.imageRendering;
	                  _supportsPixelated = declarations.some(function(d) {
	                    var value = d[1];
	                    return imageRendering === value || imageRendering === value.toLowerCase();
	                  });
	                  image3.remove();
	                }
	              }
	              return _supportsPixelated;
	            }
	            module2.exports = supportsPixelatedImage;
	          }
	        ),
	        /***/
	        63893: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var LINE_SPACING = __webpack_require__2(18783).LINE_SPACING;
	            var FIND_TEX = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
	            exports2.convertToTspans = function(_context, gd, _callback) {
	              var str = _context.text();
	              var tex = !_context.attr("data-notex") && gd && gd._context.typesetMath && typeof MathJax !== "undefined" && str.match(FIND_TEX);
	              var parent = d3.select(_context.node().parentNode);
	              if (parent.empty()) return;
	              var svgClass = _context.attr("class") ? _context.attr("class").split(" ")[0] : "text";
	              svgClass += "-math";
	              parent.selectAll("svg." + svgClass).remove();
	              parent.selectAll("g." + svgClass + "-group").remove();
	              _context.style("display", null).attr({
	                // some callers use data-unformatted *from the <text> element* in 'cancel'
	                // so we need it here even if we're going to turn it into math
	                // these two (plus style and text-anchor attributes) form the key we're
	                // going to use for Drawing.bBox
	                "data-unformatted": str,
	                "data-math": "N"
	              });
	              function showText() {
	                if (!parent.empty()) {
	                  svgClass = _context.attr("class") + "-math";
	                  parent.select("svg." + svgClass).remove();
	                }
	                _context.text("").style("white-space", "pre");
	                var hasLink = buildSVGText(_context.node(), str);
	                if (hasLink) {
	                  _context.style("pointer-events", "all");
	                }
	                exports2.positionText(_context);
	                if (_callback) _callback.call(_context);
	              }
	              if (tex) {
	                (gd && gd._promises || []).push(new Promise(function(resolve) {
	                  _context.style("display", "none");
	                  var fontSize = parseInt(_context.node().style.fontSize, 10);
	                  var config = {
	                    fontSize
	                  };
	                  texToSVG(tex[2], config, function(_svgEl, _glyphDefs, _svgBBox) {
	                    parent.selectAll("svg." + svgClass).remove();
	                    parent.selectAll("g." + svgClass + "-group").remove();
	                    var newSvg = _svgEl && _svgEl.select("svg");
	                    if (!newSvg || !newSvg.node()) {
	                      showText();
	                      resolve();
	                      return;
	                    }
	                    var mathjaxGroup = parent.append("g").classed(svgClass + "-group", true).attr({
	                      "pointer-events": "none",
	                      "data-unformatted": str,
	                      "data-math": "Y"
	                    });
	                    mathjaxGroup.node().appendChild(newSvg.node());
	                    if (_glyphDefs && _glyphDefs.node()) {
	                      newSvg.node().insertBefore(_glyphDefs.node().cloneNode(true), newSvg.node().firstChild);
	                    }
	                    var w0 = _svgBBox.width;
	                    var h0 = _svgBBox.height;
	                    newSvg.attr({
	                      class: svgClass,
	                      height: h0,
	                      preserveAspectRatio: "xMinYMin meet"
	                    }).style({
	                      overflow: "visible",
	                      "pointer-events": "none"
	                    });
	                    var fill = _context.node().style.fill || "black";
	                    var g = newSvg.select("g");
	                    g.attr({
	                      fill,
	                      stroke: fill
	                    });
	                    var bb = g.node().getBoundingClientRect();
	                    var w = bb.width;
	                    var h = bb.height;
	                    if (w > w0 || h > h0) {
	                      newSvg.style("overflow", "hidden");
	                      bb = newSvg.node().getBoundingClientRect();
	                      w = bb.width;
	                      h = bb.height;
	                    }
	                    var x = +_context.attr("x");
	                    var y = +_context.attr("y");
	                    var textHeight = fontSize || _context.node().getBoundingClientRect().height;
	                    var dy = -textHeight / 4;
	                    if (svgClass[0] === "y") {
	                      mathjaxGroup.attr({
	                        transform: "rotate(" + [-90, x, y] + ")" + strTranslate(-w / 2, dy - h / 2)
	                      });
	                    } else if (svgClass[0] === "l") {
	                      y = dy - h / 2;
	                    } else if (svgClass[0] === "a" && svgClass.indexOf("atitle") !== 0) {
	                      x = 0;
	                      y = dy;
	                    } else {
	                      var anchor = _context.attr("text-anchor");
	                      x = x - w * (anchor === "middle" ? 0.5 : anchor === "end" ? 1 : 0);
	                      y = y + dy - h / 2;
	                    }
	                    newSvg.attr({
	                      x,
	                      y
	                    });
	                    if (_callback) _callback.call(_context, mathjaxGroup);
	                    resolve(mathjaxGroup);
	                  });
	                }));
	              } else showText();
	              return _context;
	            };
	            var LT_MATCH = /(<|&lt;|&#60;)/g;
	            var GT_MATCH = /(>|&gt;|&#62;)/g;
	            function cleanEscapesForTex(s) {
	              return s.replace(LT_MATCH, "\\lt ").replace(GT_MATCH, "\\gt ");
	            }
	            var inlineMath = [["$", "$"], ["\\(", "\\)"]];
	            function texToSVG(_texString, _config, _callback) {
	              var MathJaxVersion = parseInt((MathJax.version || "").split(".")[0]);
	              if (MathJaxVersion !== 2 && MathJaxVersion !== 3) {
	                Lib.warn("No MathJax version:", MathJax.version);
	                return;
	              }
	              var originalRenderer, originalConfig, originalProcessSectionDelay, tmpDiv;
	              var setConfig2 = function() {
	                originalConfig = Lib.extendDeepAll({}, MathJax.Hub.config);
	                originalProcessSectionDelay = MathJax.Hub.processSectionDelay;
	                if (MathJax.Hub.processSectionDelay !== undefined) {
	                  MathJax.Hub.processSectionDelay = 0;
	                }
	                return MathJax.Hub.Config({
	                  messageStyle: "none",
	                  tex2jax: {
	                    inlineMath
	                  },
	                  displayAlign: "left"
	                });
	              };
	              var setConfig3 = function() {
	                originalConfig = Lib.extendDeepAll({}, MathJax.config);
	                if (!MathJax.config.tex) {
	                  MathJax.config.tex = {};
	                }
	                MathJax.config.tex.inlineMath = inlineMath;
	              };
	              var setRenderer2 = function() {
	                originalRenderer = MathJax.Hub.config.menuSettings.renderer;
	                if (originalRenderer !== "SVG") {
	                  return MathJax.Hub.setRenderer("SVG");
	                }
	              };
	              var setRenderer3 = function() {
	                originalRenderer = MathJax.config.startup.output;
	                if (originalRenderer !== "svg") {
	                  MathJax.config.startup.output = "svg";
	                }
	              };
	              var initiateMathJax = function() {
	                var randomID = "math-output-" + Lib.randstr({}, 64);
	                tmpDiv = d3.select("body").append("div").attr({
	                  id: randomID
	                }).style({
	                  visibility: "hidden",
	                  position: "absolute",
	                  "font-size": _config.fontSize + "px"
	                }).text(cleanEscapesForTex(_texString));
	                var tmpNode = tmpDiv.node();
	                return MathJaxVersion === 2 ? MathJax.Hub.Typeset(tmpNode) : MathJax.typeset([tmpNode]);
	              };
	              var finalizeMathJax = function() {
	                var sel = tmpDiv.select(MathJaxVersion === 2 ? ".MathJax_SVG" : ".MathJax");
	                var node = !sel.empty() && tmpDiv.select("svg").node();
	                if (!node) {
	                  Lib.log("There was an error in the tex syntax.", _texString);
	                  _callback();
	                } else {
	                  var nodeBBox = node.getBoundingClientRect();
	                  var glyphDefs;
	                  if (MathJaxVersion === 2) {
	                    glyphDefs = d3.select("body").select("#MathJax_SVG_glyphs");
	                  } else {
	                    glyphDefs = sel.select("defs");
	                  }
	                  _callback(sel, glyphDefs, nodeBBox);
	                }
	                tmpDiv.remove();
	              };
	              var resetRenderer2 = function() {
	                if (originalRenderer !== "SVG") {
	                  return MathJax.Hub.setRenderer(originalRenderer);
	                }
	              };
	              var resetRenderer3 = function() {
	                if (originalRenderer !== "svg") {
	                  MathJax.config.startup.output = originalRenderer;
	                }
	              };
	              var resetConfig2 = function() {
	                if (originalProcessSectionDelay !== undefined) {
	                  MathJax.Hub.processSectionDelay = originalProcessSectionDelay;
	                }
	                return MathJax.Hub.Config(originalConfig);
	              };
	              var resetConfig3 = function() {
	                MathJax.config = originalConfig;
	              };
	              if (MathJaxVersion === 2) {
	                MathJax.Hub.Queue(setConfig2, setRenderer2, initiateMathJax, finalizeMathJax, resetRenderer2, resetConfig2);
	              } else if (MathJaxVersion === 3) {
	                setConfig3();
	                setRenderer3();
	                MathJax.startup.defaultReady();
	                MathJax.startup.promise.then(function() {
	                  initiateMathJax();
	                  finalizeMathJax();
	                  resetRenderer3();
	                  resetConfig3();
	                });
	              }
	            }
	            var TAG_STYLES = {
	              // would like to use baseline-shift for sub/sup but FF doesn't support it
	              // so we need to use dy along with the uber hacky shift-back-to
	              // baseline below
	              sup: "font-size:70%",
	              sub: "font-size:70%",
	              b: "font-weight:bold",
	              i: "font-style:italic",
	              a: "cursor:pointer",
	              span: "",
	              em: "font-style:italic;font-weight:bold"
	            };
	            var SHIFT_DY = {
	              sub: "0.3em",
	              sup: "-0.6em"
	            };
	            var RESET_DY = {
	              sub: "-0.21em",
	              sup: "0.42em"
	            };
	            var ZERO_WIDTH_SPACE = "​";
	            var PROTOCOLS = ["http:", "https:", "mailto:", "", undefined, ":"];
	            var NEWLINES = exports2.NEWLINES = /(\r\n?|\n)/g;
	            var SPLIT_TAGS = /(<[^<>]*>)/;
	            var ONE_TAG = /<(\/?)([^ >]*)(\s+(.*))?>/i;
	            var BR_TAG = /<br(\s+.*)?>/i;
	            exports2.BR_TAG_ALL = /<br(\s+.*)?>/gi;
	            var STYLEMATCH = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i;
	            var HREFMATCH = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i;
	            var TARGETMATCH = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i;
	            var POPUPMATCH = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
	            function getQuotedMatch(_str, re) {
	              if (!_str) return null;
	              var match = _str.match(re);
	              var result = match && (match[3] || match[4]);
	              return result && convertEntities(result);
	            }
	            var COLORMATCH = /(^|;)\s*color:/;
	            exports2.plainText = function(_str, opts) {
	              opts = opts || {};
	              var len = opts.len !== undefined && opts.len !== -1 ? opts.len : Infinity;
	              var allowedTags = opts.allowedTags !== undefined ? opts.allowedTags : ["br"];
	              var ellipsis = "...";
	              var eLen = ellipsis.length;
	              var oldParts = _str.split(SPLIT_TAGS);
	              var newParts = [];
	              var prevTag = "";
	              var l = 0;
	              for (var i = 0; i < oldParts.length; i++) {
	                var p = oldParts[i];
	                var match = p.match(ONE_TAG);
	                var tagType = match && match[2].toLowerCase();
	                if (tagType) {
	                  if (allowedTags.indexOf(tagType) !== -1) {
	                    newParts.push(p);
	                    prevTag = tagType;
	                  }
	                } else {
	                  var pLen = p.length;
	                  if (l + pLen < len) {
	                    newParts.push(p);
	                    l += pLen;
	                  } else if (l < len) {
	                    var pLen2 = len - l;
	                    if (prevTag && (prevTag !== "br" || pLen2 <= eLen || pLen <= eLen)) {
	                      newParts.pop();
	                    }
	                    if (len > eLen) {
	                      newParts.push(p.substr(0, pLen2 - eLen) + ellipsis);
	                    } else {
	                      newParts.push(p.substr(0, pLen2));
	                    }
	                    break;
	                  }
	                  prevTag = "";
	                }
	              }
	              return newParts.join("");
	            };
	            var entityToUnicode = {
	              mu: "μ",
	              amp: "&",
	              lt: "<",
	              gt: ">",
	              nbsp: " ",
	              times: "×",
	              plusmn: "±",
	              deg: "°"
	            };
	            var ENTITY_MATCH = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
	            function convertEntities(_str) {
	              return _str.replace(ENTITY_MATCH, function(fullMatch, innerMatch) {
	                var outChar;
	                if (innerMatch.charAt(0) === "#") {
	                  outChar = fromCodePoint(innerMatch.charAt(1) === "x" ? parseInt(innerMatch.substr(2), 16) : parseInt(innerMatch.substr(1), 10));
	                } else outChar = entityToUnicode[innerMatch];
	                return outChar || fullMatch;
	              });
	            }
	            exports2.convertEntities = convertEntities;
	            function fromCodePoint(code) {
	              if (code > 1114111) return;
	              var stringFromCodePoint = String.fromCodePoint;
	              if (stringFromCodePoint) return stringFromCodePoint(code);
	              var stringFromCharCode = String.fromCharCode;
	              if (code <= 65535) return stringFromCharCode(code);
	              return stringFromCharCode((code >> 10) + 55232, code % 1024 + 56320);
	            }
	            function buildSVGText(containerNode, str) {
	              str = str.replace(NEWLINES, " ");
	              var hasLink = false;
	              var nodeStack = [];
	              var currentNode;
	              var currentLine = -1;
	              function newLine() {
	                currentLine++;
	                var lineNode = document.createElementNS(xmlnsNamespaces.svg, "tspan");
	                d3.select(lineNode).attr({
	                  class: "line",
	                  dy: currentLine * LINE_SPACING + "em"
	                });
	                containerNode.appendChild(lineNode);
	                currentNode = lineNode;
	                var oldNodeStack = nodeStack;
	                nodeStack = [{
	                  node: lineNode
	                }];
	                if (oldNodeStack.length > 1) {
	                  for (var i2 = 1; i2 < oldNodeStack.length; i2++) {
	                    enterNode(oldNodeStack[i2]);
	                  }
	                }
	              }
	              function enterNode(nodeSpec2) {
	                var type = nodeSpec2.type;
	                var nodeAttrs = {};
	                var nodeType;
	                if (type === "a") {
	                  nodeType = "a";
	                  var target = nodeSpec2.target;
	                  var href2 = nodeSpec2.href;
	                  var popup = nodeSpec2.popup;
	                  if (href2) {
	                    nodeAttrs = {
	                      "xlink:xlink:show": target === "_blank" || target.charAt(0) !== "_" ? "new" : "replace",
	                      target,
	                      "xlink:xlink:href": href2
	                    };
	                    if (popup) {
	                      nodeAttrs.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + popup + '");return false;';
	                    }
	                  }
	                } else nodeType = "tspan";
	                if (nodeSpec2.style) nodeAttrs.style = nodeSpec2.style;
	                var newNode = document.createElementNS(xmlnsNamespaces.svg, nodeType);
	                if (type === "sup" || type === "sub") {
	                  addTextNode(currentNode, ZERO_WIDTH_SPACE);
	                  currentNode.appendChild(newNode);
	                  var resetter = document.createElementNS(xmlnsNamespaces.svg, "tspan");
	                  addTextNode(resetter, ZERO_WIDTH_SPACE);
	                  d3.select(resetter).attr("dy", RESET_DY[type]);
	                  nodeAttrs.dy = SHIFT_DY[type];
	                  currentNode.appendChild(newNode);
	                  currentNode.appendChild(resetter);
	                } else {
	                  currentNode.appendChild(newNode);
	                }
	                d3.select(newNode).attr(nodeAttrs);
	                currentNode = nodeSpec2.node = newNode;
	                nodeStack.push(nodeSpec2);
	              }
	              function addTextNode(node, text) {
	                node.appendChild(document.createTextNode(text));
	              }
	              function exitNode(type) {
	                if (nodeStack.length === 1) {
	                  Lib.log("Ignoring unexpected end tag </" + type + ">.", str);
	                  return;
	                }
	                var innerNode = nodeStack.pop();
	                if (type !== innerNode.type) {
	                  Lib.log("Start tag <" + innerNode.type + "> doesnt match end tag <" + type + ">. Pretending it did match.", str);
	                }
	                currentNode = nodeStack[nodeStack.length - 1].node;
	              }
	              var hasLines = BR_TAG.test(str);
	              if (hasLines) newLine();
	              else {
	                currentNode = containerNode;
	                nodeStack = [{
	                  node: containerNode
	                }];
	              }
	              var parts = str.split(SPLIT_TAGS);
	              for (var i = 0; i < parts.length; i++) {
	                var parti = parts[i];
	                var match = parti.match(ONE_TAG);
	                var tagType = match && match[2].toLowerCase();
	                var tagStyle = TAG_STYLES[tagType];
	                if (tagType === "br") {
	                  newLine();
	                } else if (tagStyle === undefined) {
	                  addTextNode(currentNode, convertEntities(parti));
	                } else {
	                  if (match[1]) {
	                    exitNode(tagType);
	                  } else {
	                    var extra = match[4];
	                    var nodeSpec = {
	                      type: tagType
	                    };
	                    var css = getQuotedMatch(extra, STYLEMATCH);
	                    if (css) {
	                      css = css.replace(COLORMATCH, "$1 fill:");
	                      if (tagStyle) css += ";" + tagStyle;
	                    } else if (tagStyle) css = tagStyle;
	                    if (css) nodeSpec.style = css;
	                    if (tagType === "a") {
	                      hasLink = true;
	                      var href = getQuotedMatch(extra, HREFMATCH);
	                      if (href) {
	                        var safeHref = sanitizeHref(href);
	                        if (safeHref) {
	                          nodeSpec.href = safeHref;
	                          nodeSpec.target = getQuotedMatch(extra, TARGETMATCH) || "_blank";
	                          nodeSpec.popup = getQuotedMatch(extra, POPUPMATCH);
	                        }
	                      }
	                    }
	                    enterNode(nodeSpec);
	                  }
	                }
	              }
	              return hasLink;
	            }
	            function sanitizeHref(href) {
	              var decodedHref = encodeURI(decodeURI(href));
	              var dummyAnchor1 = document.createElement("a");
	              var dummyAnchor2 = document.createElement("a");
	              dummyAnchor1.href = href;
	              dummyAnchor2.href = decodedHref;
	              var p1 = dummyAnchor1.protocol;
	              var p2 = dummyAnchor2.protocol;
	              if (PROTOCOLS.indexOf(p1) !== -1 && PROTOCOLS.indexOf(p2) !== -1) {
	                return decodedHref;
	              } else {
	                return "";
	              }
	            }
	            exports2.sanitizeHTML = function sanitizeHTML(str) {
	              str = str.replace(NEWLINES, " ");
	              var rootNode = document.createElement("p");
	              var currentNode = rootNode;
	              var nodeStack = [];
	              var parts = str.split(SPLIT_TAGS);
	              for (var i = 0; i < parts.length; i++) {
	                var parti = parts[i];
	                var match = parti.match(ONE_TAG);
	                var tagType = match && match[2].toLowerCase();
	                if (tagType in TAG_STYLES) {
	                  if (match[1]) {
	                    if (nodeStack.length) {
	                      currentNode = nodeStack.pop();
	                    }
	                  } else {
	                    var extra = match[4];
	                    var css = getQuotedMatch(extra, STYLEMATCH);
	                    var nodeAttrs = css ? {
	                      style: css
	                    } : {};
	                    if (tagType === "a") {
	                      var href = getQuotedMatch(extra, HREFMATCH);
	                      if (href) {
	                        var safeHref = sanitizeHref(href);
	                        if (safeHref) {
	                          nodeAttrs.href = safeHref;
	                          var target = getQuotedMatch(extra, TARGETMATCH);
	                          if (target) {
	                            nodeAttrs.target = target;
	                          }
	                        }
	                      }
	                    }
	                    var newNode = document.createElement(tagType);
	                    currentNode.appendChild(newNode);
	                    d3.select(newNode).attr(nodeAttrs);
	                    currentNode = newNode;
	                    nodeStack.push(newNode);
	                  }
	                } else {
	                  currentNode.appendChild(document.createTextNode(convertEntities(parti)));
	                }
	              }
	              var key = "innerHTML";
	              return rootNode[key];
	            };
	            exports2.lineCount = function lineCount(s) {
	              return s.selectAll("tspan.line").size() || 1;
	            };
	            exports2.positionText = function positionText(s, x, y) {
	              return s.each(function() {
	                var text = d3.select(this);
	                function setOrGet(attr, val) {
	                  if (val === undefined) {
	                    val = text.attr(attr);
	                    if (val === null) {
	                      text.attr(attr, 0);
	                      val = 0;
	                    }
	                  } else text.attr(attr, val);
	                  return val;
	                }
	                var thisX = setOrGet("x", x);
	                var thisY = setOrGet("y", y);
	                if (this.nodeName === "text") {
	                  text.selectAll("tspan.line").attr({
	                    x: thisX,
	                    y: thisY
	                  });
	                }
	              });
	            };
	            function alignHTMLWith(_base, container, options) {
	              var alignH = options.horizontalAlign;
	              var alignV = options.verticalAlign || "top";
	              var bRect = _base.node().getBoundingClientRect();
	              var cRect = container.node().getBoundingClientRect();
	              var thisRect;
	              var getTop;
	              var getLeft;
	              if (alignV === "bottom") {
	                getTop = function() {
	                  return bRect.bottom - thisRect.height;
	                };
	              } else if (alignV === "middle") {
	                getTop = function() {
	                  return bRect.top + (bRect.height - thisRect.height) / 2;
	                };
	              } else {
	                getTop = function() {
	                  return bRect.top;
	                };
	              }
	              if (alignH === "right") {
	                getLeft = function() {
	                  return bRect.right - thisRect.width;
	                };
	              } else if (alignH === "center") {
	                getLeft = function() {
	                  return bRect.left + (bRect.width - thisRect.width) / 2;
	                };
	              } else {
	                getLeft = function() {
	                  return bRect.left;
	                };
	              }
	              return function() {
	                thisRect = this.node().getBoundingClientRect();
	                var x0 = getLeft() - cRect.left;
	                var y0 = getTop() - cRect.top;
	                var gd = options.gd || {};
	                if (options.gd) {
	                  gd._fullLayout._calcInverseTransform(gd);
	                  var transformedCoords = Lib.apply3DTransform(gd._fullLayout._invTransform)(x0, y0);
	                  x0 = transformedCoords[0];
	                  y0 = transformedCoords[1];
	                }
	                this.style({
	                  top: y0 + "px",
	                  left: x0 + "px",
	                  "z-index": 1e3
	                });
	                return this;
	              };
	            }
	            var onePx = "1px ";
	            exports2.makeTextShadow = function(color) {
	              var x = onePx;
	              var y = onePx;
	              var b = onePx;
	              return x + y + b + color + ", -" + x + "-" + y + b + color + ", " + x + "-" + y + b + color + ", -" + x + y + b + color;
	            };
	            exports2.makeEditable = function(context, options) {
	              var gd = options.gd;
	              var _delegate = options.delegate;
	              var dispatch = d3.dispatch("edit", "input", "cancel");
	              var handlerElement = _delegate || context;
	              context.style({
	                "pointer-events": _delegate ? "none" : "all"
	              });
	              if (context.size() !== 1) throw new Error("boo");
	              function handleClick() {
	                appendEditable();
	                context.style({
	                  opacity: 0
	                });
	                var svgClass = handlerElement.attr("class");
	                var mathjaxClass;
	                if (svgClass) mathjaxClass = "." + svgClass.split(" ")[0] + "-math-group";
	                else mathjaxClass = "[class*=-math-group]";
	                if (mathjaxClass) {
	                  d3.select(context.node().parentNode).select(mathjaxClass).style({
	                    opacity: 0
	                  });
	                }
	              }
	              function selectElementContents(_el) {
	                var el = _el.node();
	                var range2 = document.createRange();
	                range2.selectNodeContents(el);
	                var sel = window.getSelection();
	                sel.removeAllRanges();
	                sel.addRange(range2);
	                el.focus();
	              }
	              function appendEditable() {
	                var plotDiv = d3.select(gd);
	                var container = plotDiv.select(".svg-container");
	                var div = container.append("div");
	                var cStyle = context.node().style;
	                var fontSize = parseFloat(cStyle.fontSize || 12);
	                var initialText = options.text;
	                if (initialText === undefined) initialText = context.attr("data-unformatted");
	                div.classed("plugin-editable editable", true).style({
	                  position: "absolute",
	                  "font-family": cStyle.fontFamily || "Arial",
	                  "font-size": fontSize,
	                  color: options.fill || cStyle.fill || "black",
	                  opacity: 1,
	                  "background-color": options.background || "transparent",
	                  outline: "#ffffff33 1px solid",
	                  margin: [-fontSize / 8 + 1, 0, 0, -1].join("px ") + "px",
	                  padding: "0",
	                  "box-sizing": "border-box"
	                }).attr({
	                  contenteditable: true
	                }).text(initialText).call(alignHTMLWith(context, container, options)).on("blur", function() {
	                  gd._editing = false;
	                  context.text(this.textContent).style({
	                    opacity: 1
	                  });
	                  var svgClass = d3.select(this).attr("class");
	                  var mathjaxClass;
	                  if (svgClass) mathjaxClass = "." + svgClass.split(" ")[0] + "-math-group";
	                  else mathjaxClass = "[class*=-math-group]";
	                  if (mathjaxClass) {
	                    d3.select(context.node().parentNode).select(mathjaxClass).style({
	                      opacity: 0
	                    });
	                  }
	                  var text = this.textContent;
	                  d3.select(this).transition().duration(0).remove();
	                  d3.select(document).on("mouseup", null);
	                  dispatch.edit.call(context, text);
	                }).on("focus", function() {
	                  var editDiv = this;
	                  gd._editing = true;
	                  d3.select(document).on("mouseup", function() {
	                    if (d3.event.target === editDiv) return false;
	                    if (document.activeElement === div.node()) div.node().blur();
	                  });
	                }).on("keyup", function() {
	                  if (d3.event.which === 27) {
	                    gd._editing = false;
	                    context.style({
	                      opacity: 1
	                    });
	                    d3.select(this).style({
	                      opacity: 0
	                    }).on("blur", function() {
	                      return false;
	                    }).transition().remove();
	                    dispatch.cancel.call(context, this.textContent);
	                  } else {
	                    dispatch.input.call(context, this.textContent);
	                    d3.select(this).call(alignHTMLWith(context, container, options));
	                  }
	                }).on("keydown", function() {
	                  if (d3.event.which === 13) this.blur();
	                }).call(selectElementContents);
	              }
	              if (options.immediate) handleClick();
	              else handlerElement.on("click", handleClick);
	              return d3.rebind(context, dispatch, "on");
	            };
	          }
	        ),
	        /***/
	        79990: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            var timerCache = {};
	            exports2.throttle = function throttle(id, minInterval, callback) {
	              var cache = timerCache[id];
	              var now = Date.now();
	              if (!cache) {
	                for (var idi in timerCache) {
	                  if (timerCache[idi].ts < now - 6e4) {
	                    delete timerCache[idi];
	                  }
	                }
	                cache = timerCache[id] = {
	                  ts: 0,
	                  timer: null
	                };
	              }
	              _clearTimeout(cache);
	              function exec() {
	                callback();
	                cache.ts = Date.now();
	                if (cache.onDone) {
	                  cache.onDone();
	                  cache.onDone = null;
	                }
	              }
	              if (now > cache.ts + minInterval) {
	                exec();
	                return;
	              }
	              cache.timer = setTimeout(function() {
	                exec();
	                cache.timer = null;
	              }, minInterval);
	            };
	            exports2.done = function(id) {
	              var cache = timerCache[id];
	              if (!cache || !cache.timer) return Promise.resolve();
	              return new Promise(function(resolve) {
	                var previousOnDone = cache.onDone;
	                cache.onDone = function onDone() {
	                  if (previousOnDone) previousOnDone();
	                  resolve();
	                  cache.onDone = null;
	                };
	              });
	            };
	            exports2.clear = function(id) {
	              if (id) {
	                _clearTimeout(timerCache[id]);
	                delete timerCache[id];
	              } else {
	                for (var idi in timerCache) exports2.clear(idi);
	              }
	            };
	            function _clearTimeout(cache) {
	              if (cache && cache.timer !== null) {
	                clearTimeout(cache.timer);
	                cache.timer = null;
	              }
	            }
	          }
	        ),
	        /***/
	        58163: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            module2.exports = function toLogRange(val, range2) {
	              if (val > 0) return Math.log(val) / Math.LN10;
	              var newVal = Math.log(Math.min(range2[0], range2[1])) / Math.LN10;
	              if (!isNumeric(newVal)) newVal = Math.log(Math.max(range2[0], range2[1])) / Math.LN10 - 6;
	              return newVal;
	            };
	          }
	        ),
	        /***/
	        90973: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var topojsonUtils = module2.exports = {};
	            var locationmodeToLayer = __webpack_require__2(78776).locationmodeToLayer;
	            var topojsonFeature = __webpack_require__2(96892).zL;
	            topojsonUtils.getTopojsonName = function(geoLayout) {
	              return [geoLayout.scope.replace(/ /g, "-"), "_", geoLayout.resolution.toString(), "m"].join("");
	            };
	            topojsonUtils.getTopojsonPath = function(topojsonURL, topojsonName) {
	              return topojsonURL + topojsonName + ".json";
	            };
	            topojsonUtils.getTopojsonFeatures = function(trace, topojson) {
	              var layer = locationmodeToLayer[trace.locationmode];
	              var obj = topojson.objects[layer];
	              return topojsonFeature(topojson, obj).features;
	            };
	          }
	        ),
	        /***/
	        37815: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              moduleType: "locale",
	              name: "en-US",
	              dictionary: {
	                "Click to enter Colorscale title": "Click to enter Colorscale title"
	              },
	              format: {
	                date: "%m/%d/%Y"
	              }
	            };
	          }
	        ),
	        /***/
	        92177: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              moduleType: "locale",
	              name: "en",
	              dictionary: {
	                "Click to enter Colorscale title": "Click to enter Colourscale title"
	              },
	              format: {
	                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	                shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	                periods: ["AM", "PM"],
	                dateTime: "%a %b %e %X %Y",
	                date: "%d/%m/%Y",
	                time: "%H:%M:%S",
	                decimal: ".",
	                thousands: ",",
	                grouping: [3],
	                currency: ["$", ""],
	                year: "%Y",
	                month: "%b %Y",
	                dayMonth: "%b %-d",
	                dayMonthYear: "%b %-d, %Y"
	              }
	            };
	          }
	        ),
	        /***/
	        14458: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            module2.exports = function containerArrayMatch(astr) {
	              var rootContainers = Registry.layoutArrayContainers;
	              var regexpContainers = Registry.layoutArrayRegexes;
	              var rootPart = astr.split("[")[0];
	              var arrayStr;
	              var match;
	              for (var i = 0; i < regexpContainers.length; i++) {
	                match = astr.match(regexpContainers[i]);
	                if (match && match.index === 0) {
	                  arrayStr = match[0];
	                  break;
	                }
	              }
	              if (!arrayStr) arrayStr = rootContainers[rootContainers.indexOf(rootPart)];
	              if (!arrayStr) return false;
	              var tail = astr.substr(arrayStr.length);
	              if (!tail) return {
	                array: arrayStr,
	                index: "",
	                property: ""
	              };
	              match = tail.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/);
	              if (!match) return false;
	              return {
	                array: arrayStr,
	                index: Number(match[1]),
	                property: match[3] || ""
	              };
	            };
	          }
	        ),
	        /***/
	        30962: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var isPlainObject = __webpack_require__2(41965);
	            var traceOpts = {
	              valType: "flaglist",
	              extras: ["none"],
	              flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"]
	            };
	            var layoutOpts = {
	              valType: "flaglist",
	              extras: ["none"],
	              flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"]
	            };
	            var traceEditTypeFlags = traceOpts.flags.slice().concat(["fullReplot"]);
	            var layoutEditTypeFlags = layoutOpts.flags.slice().concat("layoutReplot");
	            module2.exports = {
	              traces: traceOpts,
	              layout: layoutOpts,
	              /*
	               * default (all false) edit flags for restyle (traces)
	               * creates a new object each call, so the caller can mutate freely
	               */
	              traceFlags: function() {
	                return falseObj(traceEditTypeFlags);
	              },
	              /*
	               * default (all false) edit flags for relayout
	               * creates a new object each call, so the caller can mutate freely
	               */
	              layoutFlags: function() {
	                return falseObj(layoutEditTypeFlags);
	              },
	              /*
	               * update `flags` with the `editType` values found in `attr`
	               */
	              update: function(flags, attr) {
	                var editType = attr.editType;
	                if (editType && editType !== "none") {
	                  var editTypeParts = editType.split("+");
	                  for (var i = 0; i < editTypeParts.length; i++) {
	                    flags[editTypeParts[i]] = true;
	                  }
	                }
	              },
	              overrideAll
	            };
	            function falseObj(keys) {
	              var out = {};
	              for (var i = 0; i < keys.length; i++) out[keys[i]] = false;
	              return out;
	            }
	            function overrideAll(attrs, editTypeOverride, overrideContainers) {
	              var out = extendFlat({}, attrs);
	              for (var key in out) {
	                var attr = out[key];
	                if (isPlainObject(attr)) {
	                  out[key] = overrideOne(attr, editTypeOverride, overrideContainers, key);
	                }
	              }
	              if (overrideContainers === "from-root") out.editType = editTypeOverride;
	              return out;
	            }
	            function overrideOne(attr, editTypeOverride, overrideContainers, key) {
	              if (attr.valType) {
	                var out = extendFlat({}, attr);
	                out.editType = editTypeOverride;
	                if (Array.isArray(attr.items)) {
	                  out.items = new Array(attr.items.length);
	                  for (var i = 0; i < attr.items.length; i++) {
	                    out.items[i] = overrideOne(attr.items[i], editTypeOverride);
	                  }
	                }
	                return out;
	              } else {
	                return overrideAll(attr, editTypeOverride, key.charAt(0) === "_" ? "nested" : "from-root");
	              }
	            }
	          }
	        ),
	        /***/
	        58377: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var m4FromQuat = __webpack_require__2(27812);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Plots = __webpack_require__2(74875);
	            var AxisIds = __webpack_require__2(41675);
	            var Color = __webpack_require__2(7901);
	            var cleanId = AxisIds.cleanId;
	            var getFromTrace = AxisIds.getFromTrace;
	            var traceIs = Registry.traceIs;
	            exports2.clearPromiseQueue = function(gd) {
	              if (Array.isArray(gd._promises) && gd._promises.length > 0) {
	                Lib.log("Clearing previous rejected promises from queue.");
	              }
	              gd._promises = [];
	            };
	            exports2.cleanLayout = function(layout) {
	              var i, j;
	              if (!layout) layout = {};
	              if (layout.xaxis1) {
	                if (!layout.xaxis) layout.xaxis = layout.xaxis1;
	                delete layout.xaxis1;
	              }
	              if (layout.yaxis1) {
	                if (!layout.yaxis) layout.yaxis = layout.yaxis1;
	                delete layout.yaxis1;
	              }
	              if (layout.scene1) {
	                if (!layout.scene) layout.scene = layout.scene1;
	                delete layout.scene1;
	              }
	              var axisAttrRegex = (Plots.subplotsRegistry.cartesian || {}).attrRegex;
	              var polarAttrRegex = (Plots.subplotsRegistry.polar || {}).attrRegex;
	              var ternaryAttrRegex = (Plots.subplotsRegistry.ternary || {}).attrRegex;
	              var sceneAttrRegex = (Plots.subplotsRegistry.gl3d || {}).attrRegex;
	              var keys = Object.keys(layout);
	              for (i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                if (axisAttrRegex && axisAttrRegex.test(key)) {
	                  var ax = layout[key];
	                  if (ax.anchor && ax.anchor !== "free") {
	                    ax.anchor = cleanId(ax.anchor);
	                  }
	                  if (ax.overlaying) ax.overlaying = cleanId(ax.overlaying);
	                  if (!ax.type) {
	                    if (ax.isdate) ax.type = "date";
	                    else if (ax.islog) ax.type = "log";
	                    else if (ax.isdate === false && ax.islog === false) ax.type = "linear";
	                  }
	                  if (ax.autorange === "withzero" || ax.autorange === "tozero") {
	                    ax.autorange = true;
	                    ax.rangemode = "tozero";
	                  }
	                  if (ax.insiderange) delete ax.range;
	                  delete ax.islog;
	                  delete ax.isdate;
	                  delete ax.categories;
	                  if (emptyContainer(ax, "domain")) delete ax.domain;
	                  if (ax.autotick !== undefined) {
	                    if (ax.tickmode === undefined) {
	                      ax.tickmode = ax.autotick ? "auto" : "linear";
	                    }
	                    delete ax.autotick;
	                  }
	                  cleanTitle(ax);
	                } else if (polarAttrRegex && polarAttrRegex.test(key)) {
	                  var polar = layout[key];
	                  cleanTitle(polar.radialaxis);
	                } else if (ternaryAttrRegex && ternaryAttrRegex.test(key)) {
	                  var ternary = layout[key];
	                  cleanTitle(ternary.aaxis);
	                  cleanTitle(ternary.baxis);
	                  cleanTitle(ternary.caxis);
	                } else if (sceneAttrRegex && sceneAttrRegex.test(key)) {
	                  var scene = layout[key];
	                  var cameraposition = scene.cameraposition;
	                  if (Array.isArray(cameraposition) && cameraposition[0].length === 4) {
	                    var rotation = cameraposition[0];
	                    var center = cameraposition[1];
	                    var radius = cameraposition[2];
	                    var mat = m4FromQuat([], rotation);
	                    var eye = [];
	                    for (j = 0; j < 3; ++j) {
	                      eye[j] = center[j] + radius * mat[2 + 4 * j];
	                    }
	                    scene.camera = {
	                      eye: {
	                        x: eye[0],
	                        y: eye[1],
	                        z: eye[2]
	                      },
	                      center: {
	                        x: center[0],
	                        y: center[1],
	                        z: center[2]
	                      },
	                      up: {
	                        x: 0,
	                        y: 0,
	                        z: 1
	                      }
	                      // we just ignore calculating camera z up in this case
	                    };
	                    delete scene.cameraposition;
	                  }
	                  cleanTitle(scene.xaxis);
	                  cleanTitle(scene.yaxis);
	                  cleanTitle(scene.zaxis);
	                }
	              }
	              var annotationsLen = Array.isArray(layout.annotations) ? layout.annotations.length : 0;
	              for (i = 0; i < annotationsLen; i++) {
	                var ann = layout.annotations[i];
	                if (!Lib.isPlainObject(ann)) continue;
	                if (ann.ref) {
	                  if (ann.ref === "paper") {
	                    ann.xref = "paper";
	                    ann.yref = "paper";
	                  } else if (ann.ref === "data") {
	                    ann.xref = "x";
	                    ann.yref = "y";
	                  }
	                  delete ann.ref;
	                }
	                cleanAxRef(ann, "xref");
	                cleanAxRef(ann, "yref");
	              }
	              var shapesLen = Array.isArray(layout.shapes) ? layout.shapes.length : 0;
	              for (i = 0; i < shapesLen; i++) {
	                var shape = layout.shapes[i];
	                if (!Lib.isPlainObject(shape)) continue;
	                cleanAxRef(shape, "xref");
	                cleanAxRef(shape, "yref");
	              }
	              var imagesLen = Array.isArray(layout.images) ? layout.images.length : 0;
	              for (i = 0; i < imagesLen; i++) {
	                var image = layout.images[i];
	                if (!Lib.isPlainObject(image)) continue;
	                cleanAxRef(image, "xref");
	                cleanAxRef(image, "yref");
	              }
	              var legend = layout.legend;
	              if (legend) {
	                if (legend.x > 3) {
	                  legend.x = 1.02;
	                  legend.xanchor = "left";
	                } else if (legend.x < -2) {
	                  legend.x = -0.02;
	                  legend.xanchor = "right";
	                }
	                if (legend.y > 3) {
	                  legend.y = 1.02;
	                  legend.yanchor = "bottom";
	                } else if (legend.y < -2) {
	                  legend.y = -0.02;
	                  legend.yanchor = "top";
	                }
	              }
	              cleanTitle(layout);
	              if (layout.dragmode === "rotate") layout.dragmode = "orbit";
	              Color.clean(layout);
	              if (layout.template && layout.template.layout) {
	                exports2.cleanLayout(layout.template.layout);
	              }
	              return layout;
	            };
	            function cleanAxRef(container, attr) {
	              var valIn = container[attr];
	              var axLetter = attr.charAt(0);
	              if (valIn && valIn !== "paper") {
	                container[attr] = cleanId(valIn, axLetter, true);
	              }
	            }
	            function cleanTitle(titleContainer) {
	              if (titleContainer) {
	                if (typeof titleContainer.title === "string" || typeof titleContainer.title === "number") {
	                  titleContainer.title = {
	                    text: titleContainer.title
	                  };
	                }
	                rewireAttr("titlefont", "font");
	                rewireAttr("titleposition", "position");
	                rewireAttr("titleside", "side");
	                rewireAttr("titleoffset", "offset");
	              }
	              function rewireAttr(oldAttrName, newAttrName) {
	                var oldAttrSet = titleContainer[oldAttrName];
	                var newAttrSet = titleContainer.title && titleContainer.title[newAttrName];
	                if (oldAttrSet && !newAttrSet) {
	                  if (!titleContainer.title) {
	                    titleContainer.title = {};
	                  }
	                  titleContainer.title[newAttrName] = titleContainer[oldAttrName];
	                  delete titleContainer[oldAttrName];
	                }
	              }
	            }
	            exports2.cleanData = function(data) {
	              for (var tracei = 0; tracei < data.length; tracei++) {
	                var trace = data[tracei];
	                var i;
	                if (trace.type === "histogramy" && "xbins" in trace && !("ybins" in trace)) {
	                  trace.ybins = trace.xbins;
	                  delete trace.xbins;
	                }
	                if (trace.error_y && "opacity" in trace.error_y) {
	                  var dc = Color.defaults;
	                  var yeColor = trace.error_y.color || (traceIs(trace, "bar") ? Color.defaultLine : dc[tracei % dc.length]);
	                  trace.error_y.color = Color.addOpacity(Color.rgb(yeColor), Color.opacity(yeColor) * trace.error_y.opacity);
	                  delete trace.error_y.opacity;
	                }
	                if ("bardir" in trace) {
	                  if (trace.bardir === "h" && (traceIs(trace, "bar") || trace.type.substr(0, 9) === "histogram")) {
	                    trace.orientation = "h";
	                    exports2.swapXYData(trace);
	                  }
	                  delete trace.bardir;
	                }
	                if (trace.type === "histogramy") exports2.swapXYData(trace);
	                if (trace.type === "histogramx" || trace.type === "histogramy") {
	                  trace.type = "histogram";
	                }
	                if ("scl" in trace && !("colorscale" in trace)) {
	                  trace.colorscale = trace.scl;
	                  delete trace.scl;
	                }
	                if ("reversescl" in trace && !("reversescale" in trace)) {
	                  trace.reversescale = trace.reversescl;
	                  delete trace.reversescl;
	                }
	                if (trace.xaxis) trace.xaxis = cleanId(trace.xaxis, "x");
	                if (trace.yaxis) trace.yaxis = cleanId(trace.yaxis, "y");
	                if (traceIs(trace, "gl3d") && trace.scene) {
	                  trace.scene = Plots.subplotsRegistry.gl3d.cleanId(trace.scene);
	                }
	                if (!traceIs(trace, "pie-like") && !traceIs(trace, "bar-like")) {
	                  if (Array.isArray(trace.textposition)) {
	                    for (i = 0; i < trace.textposition.length; i++) {
	                      trace.textposition[i] = cleanTextPosition(trace.textposition[i]);
	                    }
	                  } else if (trace.textposition) {
	                    trace.textposition = cleanTextPosition(trace.textposition);
	                  }
	                }
	                var _module = Registry.getModule(trace);
	                if (_module && _module.colorbar) {
	                  var containerName = _module.colorbar.container;
	                  var container = containerName ? trace[containerName] : trace;
	                  if (container && container.colorscale) {
	                    if (container.colorscale === "YIGnBu") container.colorscale = "YlGnBu";
	                    if (container.colorscale === "YIOrRd") container.colorscale = "YlOrRd";
	                  }
	                }
	                if (trace.type === "surface" && Lib.isPlainObject(trace.contours)) {
	                  var dims = ["x", "y", "z"];
	                  for (i = 0; i < dims.length; i++) {
	                    var opts = trace.contours[dims[i]];
	                    if (!Lib.isPlainObject(opts)) continue;
	                    if (opts.highlightColor) {
	                      opts.highlightcolor = opts.highlightColor;
	                      delete opts.highlightColor;
	                    }
	                    if (opts.highlightWidth) {
	                      opts.highlightwidth = opts.highlightWidth;
	                      delete opts.highlightWidth;
	                    }
	                  }
	                }
	                if (trace.type === "candlestick" || trace.type === "ohlc") {
	                  var increasingShowlegend = (trace.increasing || {}).showlegend !== false;
	                  var decreasingShowlegend = (trace.decreasing || {}).showlegend !== false;
	                  var increasingName = cleanFinanceDir(trace.increasing);
	                  var decreasingName = cleanFinanceDir(trace.decreasing);
	                  if (increasingName !== false && decreasingName !== false) {
	                    var newName = commonPrefix(increasingName, decreasingName, increasingShowlegend, decreasingShowlegend);
	                    if (newName) trace.name = newName;
	                  } else if ((increasingName || decreasingName) && !trace.name) {
	                    trace.name = increasingName || decreasingName;
	                  }
	                }
	                if (Array.isArray(trace.transforms)) {
	                  var transforms = trace.transforms;
	                  for (i = 0; i < transforms.length; i++) {
	                    var transform = transforms[i];
	                    if (!Lib.isPlainObject(transform)) continue;
	                    switch (transform.type) {
	                      case "filter":
	                        if (transform.filtersrc) {
	                          transform.target = transform.filtersrc;
	                          delete transform.filtersrc;
	                        }
	                        if (transform.calendar) {
	                          if (!transform.valuecalendar) {
	                            transform.valuecalendar = transform.calendar;
	                          }
	                          delete transform.calendar;
	                        }
	                        break;
	                      case "groupby":
	                        transform.styles = transform.styles || transform.style;
	                        if (transform.styles && !Array.isArray(transform.styles)) {
	                          var prevStyles = transform.styles;
	                          var styleKeys = Object.keys(prevStyles);
	                          transform.styles = [];
	                          for (var j = 0; j < styleKeys.length; j++) {
	                            transform.styles.push({
	                              target: styleKeys[j],
	                              value: prevStyles[styleKeys[j]]
	                            });
	                          }
	                        }
	                        break;
	                    }
	                  }
	                }
	                if (emptyContainer(trace, "line")) delete trace.line;
	                if ("marker" in trace) {
	                  if (emptyContainer(trace.marker, "line")) delete trace.marker.line;
	                  if (emptyContainer(trace, "marker")) delete trace.marker;
	                }
	                Color.clean(trace);
	                if (trace.autobinx) {
	                  delete trace.autobinx;
	                  delete trace.xbins;
	                }
	                if (trace.autobiny) {
	                  delete trace.autobiny;
	                  delete trace.ybins;
	                }
	                cleanTitle(trace);
	                if (trace.colorbar) cleanTitle(trace.colorbar);
	                if (trace.marker && trace.marker.colorbar) cleanTitle(trace.marker.colorbar);
	                if (trace.line && trace.line.colorbar) cleanTitle(trace.line.colorbar);
	                if (trace.aaxis) cleanTitle(trace.aaxis);
	                if (trace.baxis) cleanTitle(trace.baxis);
	              }
	            };
	            function cleanFinanceDir(dirContainer) {
	              if (!Lib.isPlainObject(dirContainer)) return false;
	              var dirName = dirContainer.name;
	              delete dirContainer.name;
	              delete dirContainer.showlegend;
	              return (typeof dirName === "string" || typeof dirName === "number") && String(dirName);
	            }
	            function commonPrefix(name1, name2, show1, show2) {
	              if (show1 && !show2) return name1;
	              if (show2 && !show1) return name2;
	              if (!name1.trim()) return name2;
	              if (!name2.trim()) return name1;
	              var minLen = Math.min(name1.length, name2.length);
	              var i;
	              for (i = 0; i < minLen; i++) {
	                if (name1.charAt(i) !== name2.charAt(i)) break;
	              }
	              var out = name1.substr(0, i);
	              return out.trim();
	            }
	            function cleanTextPosition(textposition) {
	              var posY = "middle";
	              var posX = "center";
	              if (typeof textposition === "string") {
	                if (textposition.indexOf("top") !== -1) posY = "top";
	                else if (textposition.indexOf("bottom") !== -1) posY = "bottom";
	                if (textposition.indexOf("left") !== -1) posX = "left";
	                else if (textposition.indexOf("right") !== -1) posX = "right";
	              }
	              return posY + " " + posX;
	            }
	            function emptyContainer(outer, innerStr) {
	              return innerStr in outer && typeof outer[innerStr] === "object" && Object.keys(outer[innerStr]).length === 0;
	            }
	            exports2.swapXYData = function(trace) {
	              var i;
	              Lib.swapAttrs(trace, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]);
	              if (Array.isArray(trace.z) && Array.isArray(trace.z[0])) {
	                if (trace.transpose) delete trace.transpose;
	                else trace.transpose = true;
	              }
	              if (trace.error_x && trace.error_y) {
	                var errorY = trace.error_y;
	                var copyYstyle = "copy_ystyle" in errorY ? errorY.copy_ystyle : !(errorY.color || errorY.thickness || errorY.width);
	                Lib.swapAttrs(trace, ["error_?.copy_ystyle"]);
	                if (copyYstyle) {
	                  Lib.swapAttrs(trace, ["error_?.color", "error_?.thickness", "error_?.width"]);
	                }
	              }
	              if (typeof trace.hoverinfo === "string") {
	                var hoverInfoParts = trace.hoverinfo.split("+");
	                for (i = 0; i < hoverInfoParts.length; i++) {
	                  if (hoverInfoParts[i] === "x") hoverInfoParts[i] = "y";
	                  else if (hoverInfoParts[i] === "y") hoverInfoParts[i] = "x";
	                }
	                trace.hoverinfo = hoverInfoParts.join("+");
	              }
	            };
	            exports2.coerceTraceIndices = function(gd, traceIndices) {
	              if (isNumeric(traceIndices)) {
	                return [traceIndices];
	              } else if (!Array.isArray(traceIndices) || !traceIndices.length) {
	                return gd.data.map(function(_, i2) {
	                  return i2;
	                });
	              } else if (Array.isArray(traceIndices)) {
	                var traceIndicesOut = [];
	                for (var i = 0; i < traceIndices.length; i++) {
	                  if (Lib.isIndex(traceIndices[i], gd.data.length)) {
	                    traceIndicesOut.push(traceIndices[i]);
	                  } else {
	                    Lib.warn("trace index (", traceIndices[i], ") is not a number or is out of bounds");
	                  }
	                }
	                return traceIndicesOut;
	              }
	              return traceIndices;
	            };
	            exports2.manageArrayContainers = function(np, newVal, undoit) {
	              var obj = np.obj;
	              var parts = np.parts;
	              var pLength = parts.length;
	              var pLast = parts[pLength - 1];
	              var pLastIsNumber = isNumeric(pLast);
	              if (pLastIsNumber && newVal === null) {
	                var contPath = parts.slice(0, pLength - 1).join(".");
	                var cont = Lib.nestedProperty(obj, contPath).get();
	                cont.splice(pLast, 1);
	              } else if (pLastIsNumber && np.get() === undefined) {
	                if (np.get() === undefined) undoit[np.astr] = null;
	                np.set(newVal);
	              } else {
	                np.set(newVal);
	              }
	            };
	            var ATTR_TAIL_RE = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
	            function getParent(attr) {
	              var tail = attr.search(ATTR_TAIL_RE);
	              if (tail > 0) return attr.substr(0, tail);
	            }
	            exports2.hasParent = function(aobj, attr) {
	              var attrParent = getParent(attr);
	              while (attrParent) {
	                if (attrParent in aobj) return true;
	                attrParent = getParent(attrParent);
	              }
	              return false;
	            };
	            var axLetters = ["x", "y", "z"];
	            exports2.clearAxisTypes = function(gd, traces, layoutUpdate) {
	              for (var i = 0; i < traces.length; i++) {
	                var trace = gd._fullData[i];
	                for (var j = 0; j < 3; j++) {
	                  var ax = getFromTrace(gd, trace, axLetters[j]);
	                  if (ax && ax.type !== "log") {
	                    var axAttr = ax._name;
	                    var sceneName = ax._id.substr(1);
	                    if (sceneName.substr(0, 5) === "scene") {
	                      if (layoutUpdate[sceneName] !== undefined) continue;
	                      axAttr = sceneName + "." + axAttr;
	                    }
	                    var typeAttr = axAttr + ".type";
	                    if (layoutUpdate[axAttr] === undefined && layoutUpdate[typeAttr] === undefined) {
	                      Lib.nestedProperty(gd.layout, typeAttr).set(null);
	                    }
	                  }
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        10641: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var main = __webpack_require__2(72391);
	            exports2._doPlot = main._doPlot;
	            exports2.newPlot = main.newPlot;
	            exports2.restyle = main.restyle;
	            exports2.relayout = main.relayout;
	            exports2.redraw = main.redraw;
	            exports2.update = main.update;
	            exports2._guiRestyle = main._guiRestyle;
	            exports2._guiRelayout = main._guiRelayout;
	            exports2._guiUpdate = main._guiUpdate;
	            exports2._storeDirectGUIEdit = main._storeDirectGUIEdit;
	            exports2.react = main.react;
	            exports2.extendTraces = main.extendTraces;
	            exports2.prependTraces = main.prependTraces;
	            exports2.addTraces = main.addTraces;
	            exports2.deleteTraces = main.deleteTraces;
	            exports2.moveTraces = main.moveTraces;
	            exports2.purge = main.purge;
	            exports2.addFrames = main.addFrames;
	            exports2.deleteFrames = main.deleteFrames;
	            exports2.animate = main.animate;
	            exports2.setPlotConfig = main.setPlotConfig;
	            var getGraphDiv = __webpack_require__2(24401).getGraphDiv;
	            var eraseActiveShape = __webpack_require__2(34031).eraseActiveShape;
	            exports2.deleteActiveShape = function(gd) {
	              return eraseActiveShape(getGraphDiv(gd));
	            };
	            exports2.toImage = __webpack_require__2(403);
	            exports2.validate = __webpack_require__2(84936);
	            exports2.downloadImage = __webpack_require__2(7239);
	            var templateApi = __webpack_require__2(96318);
	            exports2.makeTemplate = templateApi.makeTemplate;
	            exports2.validateTemplate = templateApi.validateTemplate;
	          }
	        ),
	        /***/
	        6611: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isPlainObject = __webpack_require__2(41965);
	            var noop = __webpack_require__2(64213);
	            var Loggers = __webpack_require__2(47769);
	            var sorterAsc = __webpack_require__2(65888).sorterAsc;
	            var Registry = __webpack_require__2(73972);
	            exports2.containerArrayMatch = __webpack_require__2(14458);
	            var isAddVal = exports2.isAddVal = function isAddVal2(val) {
	              return val === "add" || isPlainObject(val);
	            };
	            var isRemoveVal = exports2.isRemoveVal = function isRemoveVal2(val) {
	              return val === null || val === "remove";
	            };
	            exports2.applyContainerArrayChanges = function applyContainerArrayChanges(gd, np, edits, flags, _nestedProperty) {
	              var componentType = np.astr;
	              var supplyComponentDefaults = Registry.getComponentMethod(componentType, "supplyLayoutDefaults");
	              var draw = Registry.getComponentMethod(componentType, "draw");
	              var drawOne = Registry.getComponentMethod(componentType, "drawOne");
	              var replotLater = flags.replot || flags.recalc || supplyComponentDefaults === noop || draw === noop;
	              var layout = gd.layout;
	              var fullLayout = gd._fullLayout;
	              if (edits[""]) {
	                if (Object.keys(edits).length > 1) {
	                  Loggers.warn("Full array edits are incompatible with other edits", componentType);
	                }
	                var fullVal = edits[""][""];
	                if (isRemoveVal(fullVal)) np.set(null);
	                else if (Array.isArray(fullVal)) np.set(fullVal);
	                else {
	                  Loggers.warn("Unrecognized full array edit value", componentType, fullVal);
	                  return true;
	                }
	                if (replotLater) return false;
	                supplyComponentDefaults(layout, fullLayout);
	                draw(gd);
	                return true;
	              }
	              var componentNums = Object.keys(edits).map(Number).sort(sorterAsc);
	              var componentArrayIn = np.get();
	              var componentArray = componentArrayIn || [];
	              var componentArrayFull = _nestedProperty(fullLayout, componentType).get();
	              var deletes = [];
	              var firstIndexChange = -1;
	              var maxIndex = componentArray.length;
	              var i;
	              var j;
	              var componentNum;
	              var objEdits;
	              var objKeys;
	              var objVal;
	              var adding, prefix;
	              for (i = 0; i < componentNums.length; i++) {
	                componentNum = componentNums[i];
	                objEdits = edits[componentNum];
	                objKeys = Object.keys(objEdits);
	                objVal = objEdits[""], adding = isAddVal(objVal);
	                if (componentNum < 0 || componentNum > componentArray.length - (adding ? 0 : 1)) {
	                  Loggers.warn("index out of range", componentType, componentNum);
	                  continue;
	                }
	                if (objVal !== undefined) {
	                  if (objKeys.length > 1) {
	                    Loggers.warn("Insertion & removal are incompatible with edits to the same index.", componentType, componentNum);
	                  }
	                  if (isRemoveVal(objVal)) {
	                    deletes.push(componentNum);
	                  } else if (adding) {
	                    if (objVal === "add") objVal = {};
	                    componentArray.splice(componentNum, 0, objVal);
	                    if (componentArrayFull) componentArrayFull.splice(componentNum, 0, {});
	                  } else {
	                    Loggers.warn("Unrecognized full object edit value", componentType, componentNum, objVal);
	                  }
	                  if (firstIndexChange === -1) firstIndexChange = componentNum;
	                } else {
	                  for (j = 0; j < objKeys.length; j++) {
	                    prefix = componentType + "[" + componentNum + "].";
	                    _nestedProperty(componentArray[componentNum], objKeys[j], prefix).set(objEdits[objKeys[j]]);
	                  }
	                }
	              }
	              for (i = deletes.length - 1; i >= 0; i--) {
	                componentArray.splice(deletes[i], 1);
	                if (componentArrayFull) componentArrayFull.splice(deletes[i], 1);
	              }
	              if (!componentArray.length) np.set(null);
	              else if (!componentArrayIn) np.set(componentArray);
	              if (replotLater) return false;
	              supplyComponentDefaults(layout, fullLayout);
	              if (drawOne !== noop) {
	                var indicesToDraw;
	                if (firstIndexChange === -1) {
	                  indicesToDraw = componentNums;
	                } else {
	                  maxIndex = Math.max(componentArray.length, maxIndex);
	                  indicesToDraw = [];
	                  for (i = 0; i < componentNums.length; i++) {
	                    componentNum = componentNums[i];
	                    if (componentNum >= firstIndexChange) break;
	                    indicesToDraw.push(componentNum);
	                  }
	                  for (i = firstIndexChange; i < maxIndex; i++) {
	                    indicesToDraw.push(i);
	                  }
	                }
	                for (i = 0; i < indicesToDraw.length; i++) {
	                  drawOne(gd, indicesToDraw[i]);
	                }
	              } else draw(gd);
	              return true;
	            };
	          }
	        ),
	        /***/
	        72391: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var hasHover = __webpack_require__2(57035);
	            var Lib = __webpack_require__2(71828);
	            var nestedProperty = Lib.nestedProperty;
	            var Events = __webpack_require__2(11086);
	            var Queue = __webpack_require__2(10847);
	            var Registry = __webpack_require__2(73972);
	            var PlotSchema = __webpack_require__2(86281);
	            var Plots = __webpack_require__2(74875);
	            var Axes = __webpack_require__2(89298);
	            var handleRangeDefaults = __webpack_require__2(23608);
	            var cartesianLayoutAttributes = __webpack_require__2(13838);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var initInteractions = __webpack_require__2(4305).initInteractions;
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var clearOutline = __webpack_require__2(47322).clearOutline;
	            var dfltConfig = __webpack_require__2(72075).dfltConfig;
	            var manageArrays = __webpack_require__2(6611);
	            var helpers = __webpack_require__2(58377);
	            var subroutines = __webpack_require__2(61549);
	            var editTypes = __webpack_require__2(30962);
	            var AX_NAME_PATTERN = __webpack_require__2(85555).AX_NAME_PATTERN;
	            var numericNameWarningCount = 0;
	            var numericNameWarningCountLimit = 5;
	            function _doPlot(gd, data, layout, config) {
	              var frames;
	              gd = Lib.getGraphDiv(gd);
	              Events.init(gd);
	              if (Lib.isPlainObject(data)) {
	                var obj = data;
	                data = obj.data;
	                layout = obj.layout;
	                config = obj.config;
	                frames = obj.frames;
	              }
	              var okToPlot = Events.triggerHandler(gd, "plotly_beforeplot", [data, layout, config]);
	              if (okToPlot === false) return Promise.reject();
	              if (!data && !layout && !Lib.isPlotDiv(gd)) {
	                Lib.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", gd);
	              }
	              function addFrames2() {
	                if (frames) {
	                  return exports2.addFrames(gd, frames);
	                }
	              }
	              setPlotContext(gd, config);
	              if (!layout) layout = {};
	              d3.select(gd).classed("js-plotly-plot", true);
	              Drawing.makeTester();
	              if (!Array.isArray(gd._promises)) gd._promises = [];
	              var graphWasEmpty = (gd.data || []).length === 0 && Array.isArray(data);
	              if (Array.isArray(data)) {
	                helpers.cleanData(data);
	                if (graphWasEmpty) gd.data = data;
	                else gd.data.push.apply(gd.data, data);
	                gd.empty = false;
	              }
	              if (!gd.layout || graphWasEmpty) {
	                gd.layout = helpers.cleanLayout(layout);
	              }
	              Plots.supplyDefaults(gd);
	              var fullLayout = gd._fullLayout;
	              var hasCartesian = fullLayout._has("cartesian");
	              fullLayout._replotting = true;
	              if (graphWasEmpty || fullLayout._shouldCreateBgLayer) {
	                makePlotFramework(gd);
	                if (fullLayout._shouldCreateBgLayer) {
	                  delete fullLayout._shouldCreateBgLayer;
	                }
	              }
	              Drawing.initGradients(gd);
	              Drawing.initPatterns(gd);
	              if (graphWasEmpty) Axes.saveShowSpikeInitial(gd);
	              var recalc = !gd.calcdata || gd.calcdata.length !== (gd._fullData || []).length;
	              if (recalc) Plots.doCalcdata(gd);
	              for (var i = 0; i < gd.calcdata.length; i++) {
	                gd.calcdata[i][0].trace = gd._fullData[i];
	              }
	              if (gd._context.responsive) {
	                if (!gd._responsiveChartHandler) {
	                  gd._responsiveChartHandler = function() {
	                    if (!Lib.isHidden(gd)) Plots.resize(gd);
	                  };
	                  window.addEventListener("resize", gd._responsiveChartHandler);
	                }
	              } else {
	                Lib.clearResponsive(gd);
	              }
	              var oldMargins = Lib.extendFlat({}, fullLayout._size);
	              var drawFrameworkCalls = 0;
	              function drawFramework() {
	                var basePlotModules = fullLayout._basePlotModules;
	                for (var i2 = 0; i2 < basePlotModules.length; i2++) {
	                  if (basePlotModules[i2].drawFramework) {
	                    basePlotModules[i2].drawFramework(gd);
	                  }
	                }
	                if (!fullLayout._glcanvas && fullLayout._has("gl")) {
	                  fullLayout._glcanvas = fullLayout._glcontainer.selectAll(".gl-canvas").data([{
	                    key: "contextLayer",
	                    context: true,
	                    pick: false
	                  }, {
	                    key: "focusLayer",
	                    context: false,
	                    pick: false
	                  }, {
	                    key: "pickLayer",
	                    context: false,
	                    pick: true
	                  }], function(d) {
	                    return d.key;
	                  });
	                  fullLayout._glcanvas.enter().append("canvas").attr("class", function(d) {
	                    return "gl-canvas gl-canvas-" + d.key.replace("Layer", "");
	                  }).style({
	                    position: "absolute",
	                    top: 0,
	                    left: 0,
	                    overflow: "visible",
	                    "pointer-events": "none"
	                  });
	                }
	                var plotGlPixelRatio = gd._context.plotGlPixelRatio;
	                if (fullLayout._glcanvas) {
	                  fullLayout._glcanvas.attr("width", fullLayout.width * plotGlPixelRatio).attr("height", fullLayout.height * plotGlPixelRatio).style("width", fullLayout.width + "px").style("height", fullLayout.height + "px");
	                  var regl = fullLayout._glcanvas.data()[0].regl;
	                  if (regl) {
	                    if (Math.floor(fullLayout.width * plotGlPixelRatio) !== regl._gl.drawingBufferWidth || Math.floor(fullLayout.height * plotGlPixelRatio) !== regl._gl.drawingBufferHeight) {
	                      var msg = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
	                      if (drawFrameworkCalls) {
	                        Lib.error(msg);
	                      } else {
	                        Lib.log(msg + " Clearing graph and plotting again.");
	                        Plots.cleanPlot([], {}, gd._fullData, fullLayout);
	                        Plots.supplyDefaults(gd);
	                        fullLayout = gd._fullLayout;
	                        Plots.doCalcdata(gd);
	                        drawFrameworkCalls++;
	                        return drawFramework();
	                      }
	                    }
	                  }
	                }
	                if (fullLayout.modebar.orientation === "h") {
	                  fullLayout._modebardiv.style("height", null).style("width", "100%");
	                } else {
	                  fullLayout._modebardiv.style("width", null).style("height", fullLayout.height + "px");
	                }
	                return Plots.previousPromises(gd);
	              }
	              function marginPushers() {
	                Plots.clearAutoMarginIds(gd);
	                subroutines.drawMarginPushers(gd);
	                Axes.allowAutoMargin(gd);
	                if (gd._fullLayout.title.text && gd._fullLayout.title.automargin) Plots.allowAutoMargin(gd, "title.automargin");
	                if (fullLayout._has("pie")) {
	                  var fullData = gd._fullData;
	                  for (var i2 = 0; i2 < fullData.length; i2++) {
	                    var trace = fullData[i2];
	                    if (trace.type === "pie" && trace.automargin) {
	                      Plots.allowAutoMargin(gd, "pie." + trace.uid + ".automargin");
	                    }
	                  }
	                }
	                Plots.doAutoMargin(gd);
	                return Plots.previousPromises(gd);
	              }
	              function marginPushersAgain() {
	                if (!Plots.didMarginChange(oldMargins, fullLayout._size)) return;
	                return Lib.syncOrAsync([marginPushers, subroutines.layoutStyles], gd);
	              }
	              function positionAndAutorange() {
	                if (!recalc) {
	                  doAutoRangeAndConstraints();
	                  return;
	                }
	                return Lib.syncOrAsync([Registry.getComponentMethod("shapes", "calcAutorange"), Registry.getComponentMethod("annotations", "calcAutorange"), doAutoRangeAndConstraints], gd);
	              }
	              function doAutoRangeAndConstraints() {
	                if (gd._transitioning) return;
	                subroutines.doAutoRangeAndConstraints(gd);
	                if (graphWasEmpty) Axes.saveRangeInitial(gd);
	                Registry.getComponentMethod("rangeslider", "calcAutorange")(gd);
	              }
	              function drawAxes() {
	                return Axes.draw(gd, graphWasEmpty ? "" : "redraw");
	              }
	              var seq = [Plots.previousPromises, addFrames2, drawFramework, marginPushers, marginPushersAgain];
	              if (hasCartesian) seq.push(positionAndAutorange);
	              seq.push(subroutines.layoutStyles);
	              if (hasCartesian) {
	                seq.push(drawAxes, function insideTickLabelsAutorange(gd2) {
	                  var insideTickLabelsUpdaterange = gd2._fullLayout._insideTickLabelsUpdaterange;
	                  if (insideTickLabelsUpdaterange) {
	                    gd2._fullLayout._insideTickLabelsUpdaterange = undefined;
	                    return relayout(gd2, insideTickLabelsUpdaterange).then(function() {
	                      Axes.saveRangeInitial(gd2, true);
	                    });
	                  }
	                });
	              }
	              seq.push(
	                subroutines.drawData,
	                subroutines.finalDraw,
	                initInteractions,
	                Plots.addLinks,
	                Plots.rehover,
	                Plots.redrag,
	                Plots.reselect,
	                // TODO: doAutoMargin is only needed here for axis automargin, which
	                // happens outside of marginPushers where all the other automargins are
	                // calculated. Would be much better to separate margin calculations from
	                // component drawing - see https://github.com/plotly/plotly.js/issues/2704
	                Plots.doAutoMargin,
	                Plots.previousPromises
	              );
	              var plotDone = Lib.syncOrAsync(seq, gd);
	              if (!plotDone || !plotDone.then) plotDone = Promise.resolve();
	              return plotDone.then(function() {
	                emitAfterPlot(gd);
	                return gd;
	              });
	            }
	            function emitAfterPlot(gd) {
	              var fullLayout = gd._fullLayout;
	              if (fullLayout._redrawFromAutoMarginCount) {
	                fullLayout._redrawFromAutoMarginCount--;
	              } else {
	                gd.emit("plotly_afterplot");
	              }
	            }
	            function setPlotConfig(obj) {
	              return Lib.extendFlat(dfltConfig, obj);
	            }
	            function setBackground(gd, bgColor) {
	              try {
	                gd._fullLayout._paper.style("background", bgColor);
	              } catch (e) {
	                Lib.error(e);
	              }
	            }
	            function opaqueSetBackground(gd, bgColor) {
	              var blend = Color.combine(bgColor, "white");
	              setBackground(gd, blend);
	            }
	            function setPlotContext(gd, config) {
	              if (!gd._context) {
	                gd._context = Lib.extendDeep({}, dfltConfig);
	                var base = d3.select("base");
	                gd._context._baseUrl = base.size() && base.attr("href") ? window.location.href.split("#")[0] : "";
	              }
	              var context = gd._context;
	              var i, keys, key;
	              if (config) {
	                keys = Object.keys(config);
	                for (i = 0; i < keys.length; i++) {
	                  key = keys[i];
	                  if (key === "editable" || key === "edits") continue;
	                  if (key in context) {
	                    if (key === "setBackground" && config[key] === "opaque") {
	                      context[key] = opaqueSetBackground;
	                    } else {
	                      context[key] = config[key];
	                    }
	                  }
	                }
	                if (config.plot3dPixelRatio && !context.plotGlPixelRatio) {
	                  context.plotGlPixelRatio = context.plot3dPixelRatio;
	                }
	                var editable = config.editable;
	                if (editable !== undefined) {
	                  context.editable = editable;
	                  keys = Object.keys(context.edits);
	                  for (i = 0; i < keys.length; i++) {
	                    context.edits[keys[i]] = editable;
	                  }
	                }
	                if (config.edits) {
	                  keys = Object.keys(config.edits);
	                  for (i = 0; i < keys.length; i++) {
	                    key = keys[i];
	                    if (key in context.edits) {
	                      context.edits[key] = config.edits[key];
	                    }
	                  }
	                }
	                context._exportedPlot = config._exportedPlot;
	              }
	              if (context.staticPlot) {
	                context.editable = false;
	                context.edits = {};
	                context.autosizable = false;
	                context.scrollZoom = false;
	                context.doubleClick = false;
	                context.showTips = false;
	                context.showLink = false;
	                context.displayModeBar = false;
	              }
	              if (context.displayModeBar === "hover" && !hasHover) {
	                context.displayModeBar = true;
	              }
	              if (context.setBackground === "transparent" || typeof context.setBackground !== "function") {
	                context.setBackground = setBackground;
	              }
	              context._hasZeroHeight = context._hasZeroHeight || gd.clientHeight === 0;
	              context._hasZeroWidth = context._hasZeroWidth || gd.clientWidth === 0;
	              var szIn = context.scrollZoom;
	              var szOut = context._scrollZoom = {};
	              if (szIn === true) {
	                szOut.cartesian = 1;
	                szOut.gl3d = 1;
	                szOut.geo = 1;
	                szOut.mapbox = 1;
	              } else if (typeof szIn === "string") {
	                var parts = szIn.split("+");
	                for (i = 0; i < parts.length; i++) {
	                  szOut[parts[i]] = 1;
	                }
	              } else if (szIn !== false) {
	                szOut.gl3d = 1;
	                szOut.geo = 1;
	                szOut.mapbox = 1;
	              }
	            }
	            function redraw(gd) {
	              gd = Lib.getGraphDiv(gd);
	              if (!Lib.isPlotDiv(gd)) {
	                throw new Error("This element is not a Plotly plot: " + gd);
	              }
	              helpers.cleanData(gd.data);
	              helpers.cleanLayout(gd.layout);
	              gd.calcdata = undefined;
	              return exports2._doPlot(gd).then(function() {
	                gd.emit("plotly_redraw");
	                return gd;
	              });
	            }
	            function newPlot(gd, data, layout, config) {
	              gd = Lib.getGraphDiv(gd);
	              Plots.cleanPlot([], {}, gd._fullData || [], gd._fullLayout || {});
	              Plots.purge(gd);
	              return exports2._doPlot(gd, data, layout, config);
	            }
	            function positivifyIndices(indices, maxIndex) {
	              var parentLength = maxIndex + 1;
	              var positiveIndices = [];
	              var i;
	              var index;
	              for (i = 0; i < indices.length; i++) {
	                index = indices[i];
	                if (index < 0) {
	                  positiveIndices.push(parentLength + index);
	                } else {
	                  positiveIndices.push(index);
	                }
	              }
	              return positiveIndices;
	            }
	            function assertIndexArray(gd, indices, arrayName) {
	              var i, index;
	              for (i = 0; i < indices.length; i++) {
	                index = indices[i];
	                if (index !== parseInt(index, 10)) {
	                  throw new Error("all values in " + arrayName + " must be integers");
	                }
	                if (index >= gd.data.length || index < -gd.data.length) {
	                  throw new Error(arrayName + " must be valid indices for gd.data.");
	                }
	                if (indices.indexOf(index, i + 1) > -1 || index >= 0 && indices.indexOf(-gd.data.length + index) > -1 || index < 0 && indices.indexOf(gd.data.length + index) > -1) {
	                  throw new Error("each index in " + arrayName + " must be unique.");
	                }
	              }
	            }
	            function checkMoveTracesArgs(gd, currentIndices, newIndices) {
	              if (!Array.isArray(gd.data)) {
	                throw new Error("gd.data must be an array.");
	              }
	              if (typeof currentIndices === "undefined") {
	                throw new Error("currentIndices is a required argument.");
	              } else if (!Array.isArray(currentIndices)) {
	                currentIndices = [currentIndices];
	              }
	              assertIndexArray(gd, currentIndices, "currentIndices");
	              if (typeof newIndices !== "undefined" && !Array.isArray(newIndices)) {
	                newIndices = [newIndices];
	              }
	              if (typeof newIndices !== "undefined") {
	                assertIndexArray(gd, newIndices, "newIndices");
	              }
	              if (typeof newIndices !== "undefined" && currentIndices.length !== newIndices.length) {
	                throw new Error("current and new indices must be of equal length.");
	              }
	            }
	            function checkAddTracesArgs(gd, traces, newIndices) {
	              var i, value;
	              if (!Array.isArray(gd.data)) {
	                throw new Error("gd.data must be an array.");
	              }
	              if (typeof traces === "undefined") {
	                throw new Error("traces must be defined.");
	              }
	              if (!Array.isArray(traces)) {
	                traces = [traces];
	              }
	              for (i = 0; i < traces.length; i++) {
	                value = traces[i];
	                if (typeof value !== "object" || Array.isArray(value) || value === null) {
	                  throw new Error("all values in traces array must be non-array objects");
	                }
	              }
	              if (typeof newIndices !== "undefined" && !Array.isArray(newIndices)) {
	                newIndices = [newIndices];
	              }
	              if (typeof newIndices !== "undefined" && newIndices.length !== traces.length) {
	                throw new Error("if indices is specified, traces.length must equal indices.length");
	              }
	            }
	            function assertExtendTracesArgs(gd, update2, indices, maxPoints) {
	              var maxPointsIsObject = Lib.isPlainObject(maxPoints);
	              if (!Array.isArray(gd.data)) {
	                throw new Error("gd.data must be an array");
	              }
	              if (!Lib.isPlainObject(update2)) {
	                throw new Error("update must be a key:value object");
	              }
	              if (typeof indices === "undefined") {
	                throw new Error("indices must be an integer or array of integers");
	              }
	              assertIndexArray(gd, indices, "indices");
	              for (var key in update2) {
	                if (!Array.isArray(update2[key]) || update2[key].length !== indices.length) {
	                  throw new Error("attribute " + key + " must be an array of length equal to indices array length");
	                }
	                if (maxPointsIsObject && (!(key in maxPoints) || !Array.isArray(maxPoints[key]) || maxPoints[key].length !== update2[key].length)) {
	                  throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
	                }
	              }
	            }
	            function getExtendProperties(gd, update2, indices, maxPoints) {
	              var maxPointsIsObject = Lib.isPlainObject(maxPoints);
	              var updateProps = [];
	              var trace, target, prop, insert, maxp;
	              if (!Array.isArray(indices)) indices = [indices];
	              indices = positivifyIndices(indices, gd.data.length - 1);
	              for (var key in update2) {
	                for (var j = 0; j < indices.length; j++) {
	                  trace = gd.data[indices[j]];
	                  prop = nestedProperty(trace, key);
	                  target = prop.get();
	                  insert = update2[key][j];
	                  if (!Lib.isArrayOrTypedArray(insert)) {
	                    throw new Error("attribute: " + key + " index: " + j + " must be an array");
	                  }
	                  if (!Lib.isArrayOrTypedArray(target)) {
	                    throw new Error("cannot extend missing or non-array attribute: " + key);
	                  }
	                  if (target.constructor !== insert.constructor) {
	                    throw new Error("cannot extend array with an array of a different type: " + key);
	                  }
	                  maxp = maxPointsIsObject ? maxPoints[key][j] : maxPoints;
	                  if (!isNumeric(maxp)) maxp = -1;
	                  updateProps.push({
	                    prop,
	                    target,
	                    insert,
	                    maxp: Math.floor(maxp)
	                  });
	                }
	              }
	              return updateProps;
	            }
	            function spliceTraces(gd, update2, indices, maxPoints, updateArray) {
	              assertExtendTracesArgs(gd, update2, indices, maxPoints);
	              var updateProps = getExtendProperties(gd, update2, indices, maxPoints);
	              var undoUpdate = {};
	              var undoPoints = {};
	              for (var i = 0; i < updateProps.length; i++) {
	                var prop = updateProps[i].prop;
	                var maxp = updateProps[i].maxp;
	                var out = updateArray(updateProps[i].target, updateProps[i].insert, maxp);
	                prop.set(out[0]);
	                if (!Array.isArray(undoUpdate[prop.astr])) undoUpdate[prop.astr] = [];
	                undoUpdate[prop.astr].push(out[1]);
	                if (!Array.isArray(undoPoints[prop.astr])) undoPoints[prop.astr] = [];
	                undoPoints[prop.astr].push(updateProps[i].target.length);
	              }
	              return {
	                update: undoUpdate,
	                maxPoints: undoPoints
	              };
	            }
	            function concatTypedArray(arr0, arr1) {
	              var arr2 = new arr0.constructor(arr0.length + arr1.length);
	              arr2.set(arr0);
	              arr2.set(arr1, arr0.length);
	              return arr2;
	            }
	            function extendTraces(gd, update2, indices, maxPoints) {
	              gd = Lib.getGraphDiv(gd);
	              function updateArray(target, insert, maxp) {
	                var newArray, remainder;
	                if (Lib.isTypedArray(target)) {
	                  if (maxp < 0) {
	                    var none = new target.constructor(0);
	                    var both = concatTypedArray(target, insert);
	                    if (maxp < 0) {
	                      newArray = both;
	                      remainder = none;
	                    } else {
	                      newArray = none;
	                      remainder = both;
	                    }
	                  } else {
	                    newArray = new target.constructor(maxp);
	                    remainder = new target.constructor(target.length + insert.length - maxp);
	                    if (maxp === insert.length) {
	                      newArray.set(insert);
	                      remainder.set(target);
	                    } else if (maxp < insert.length) {
	                      var numberOfItemsFromInsert = insert.length - maxp;
	                      newArray.set(insert.subarray(numberOfItemsFromInsert));
	                      remainder.set(target);
	                      remainder.set(insert.subarray(0, numberOfItemsFromInsert), target.length);
	                    } else {
	                      var numberOfItemsFromTarget = maxp - insert.length;
	                      var targetBegin = target.length - numberOfItemsFromTarget;
	                      newArray.set(target.subarray(targetBegin));
	                      newArray.set(insert, numberOfItemsFromTarget);
	                      remainder.set(target.subarray(0, targetBegin));
	                    }
	                  }
	                } else {
	                  newArray = target.concat(insert);
	                  remainder = maxp >= 0 && maxp < newArray.length ? newArray.splice(0, newArray.length - maxp) : [];
	                }
	                return [newArray, remainder];
	              }
	              var undo = spliceTraces(gd, update2, indices, maxPoints, updateArray);
	              var promise = exports2.redraw(gd);
	              var undoArgs = [gd, undo.update, indices, undo.maxPoints];
	              Queue.add(gd, exports2.prependTraces, undoArgs, extendTraces, arguments);
	              return promise;
	            }
	            function prependTraces(gd, update2, indices, maxPoints) {
	              gd = Lib.getGraphDiv(gd);
	              function updateArray(target, insert, maxp) {
	                var newArray, remainder;
	                if (Lib.isTypedArray(target)) {
	                  if (maxp <= 0) {
	                    var none = new target.constructor(0);
	                    var both = concatTypedArray(insert, target);
	                    if (maxp < 0) {
	                      newArray = both;
	                      remainder = none;
	                    } else {
	                      newArray = none;
	                      remainder = both;
	                    }
	                  } else {
	                    newArray = new target.constructor(maxp);
	                    remainder = new target.constructor(target.length + insert.length - maxp);
	                    if (maxp === insert.length) {
	                      newArray.set(insert);
	                      remainder.set(target);
	                    } else if (maxp < insert.length) {
	                      var numberOfItemsFromInsert = insert.length - maxp;
	                      newArray.set(insert.subarray(0, numberOfItemsFromInsert));
	                      remainder.set(insert.subarray(numberOfItemsFromInsert));
	                      remainder.set(target, numberOfItemsFromInsert);
	                    } else {
	                      var numberOfItemsFromTarget = maxp - insert.length;
	                      newArray.set(insert);
	                      newArray.set(target.subarray(0, numberOfItemsFromTarget), insert.length);
	                      remainder.set(target.subarray(numberOfItemsFromTarget));
	                    }
	                  }
	                } else {
	                  newArray = insert.concat(target);
	                  remainder = maxp >= 0 && maxp < newArray.length ? newArray.splice(maxp, newArray.length) : [];
	                }
	                return [newArray, remainder];
	              }
	              var undo = spliceTraces(gd, update2, indices, maxPoints, updateArray);
	              var promise = exports2.redraw(gd);
	              var undoArgs = [gd, undo.update, indices, undo.maxPoints];
	              Queue.add(gd, exports2.extendTraces, undoArgs, prependTraces, arguments);
	              return promise;
	            }
	            function addTraces(gd, traces, newIndices) {
	              gd = Lib.getGraphDiv(gd);
	              var currentIndices = [];
	              var undoFunc = exports2.deleteTraces;
	              var redoFunc = addTraces;
	              var undoArgs = [gd, currentIndices];
	              var redoArgs = [gd, traces];
	              var i;
	              var promise;
	              checkAddTracesArgs(gd, traces, newIndices);
	              if (!Array.isArray(traces)) {
	                traces = [traces];
	              }
	              traces = traces.map(function(trace) {
	                return Lib.extendFlat({}, trace);
	              });
	              helpers.cleanData(traces);
	              for (i = 0; i < traces.length; i++) {
	                gd.data.push(traces[i]);
	              }
	              for (i = 0; i < traces.length; i++) {
	                currentIndices.push(-traces.length + i);
	              }
	              if (typeof newIndices === "undefined") {
	                promise = exports2.redraw(gd);
	                Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	                return promise;
	              }
	              if (!Array.isArray(newIndices)) {
	                newIndices = [newIndices];
	              }
	              try {
	                checkMoveTracesArgs(gd, currentIndices, newIndices);
	              } catch (error) {
	                gd.data.splice(gd.data.length - traces.length, traces.length);
	                throw error;
	              }
	              Queue.startSequence(gd);
	              Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	              promise = exports2.moveTraces(gd, currentIndices, newIndices);
	              Queue.stopSequence(gd);
	              return promise;
	            }
	            function deleteTraces(gd, indices) {
	              gd = Lib.getGraphDiv(gd);
	              var traces = [];
	              var undoFunc = exports2.addTraces;
	              var redoFunc = deleteTraces;
	              var undoArgs = [gd, traces, indices];
	              var redoArgs = [gd, indices];
	              var i;
	              var deletedTrace;
	              if (typeof indices === "undefined") {
	                throw new Error("indices must be an integer or array of integers.");
	              } else if (!Array.isArray(indices)) {
	                indices = [indices];
	              }
	              assertIndexArray(gd, indices, "indices");
	              indices = positivifyIndices(indices, gd.data.length - 1);
	              indices.sort(Lib.sorterDes);
	              for (i = 0; i < indices.length; i += 1) {
	                deletedTrace = gd.data.splice(indices[i], 1)[0];
	                traces.push(deletedTrace);
	              }
	              var promise = exports2.redraw(gd);
	              Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	              return promise;
	            }
	            function moveTraces(gd, currentIndices, newIndices) {
	              gd = Lib.getGraphDiv(gd);
	              var newData = [];
	              var movingTraceMap = [];
	              var undoFunc = moveTraces;
	              var redoFunc = moveTraces;
	              var undoArgs = [gd, newIndices, currentIndices];
	              var redoArgs = [gd, currentIndices, newIndices];
	              var i;
	              checkMoveTracesArgs(gd, currentIndices, newIndices);
	              currentIndices = Array.isArray(currentIndices) ? currentIndices : [currentIndices];
	              if (typeof newIndices === "undefined") {
	                newIndices = [];
	                for (i = 0; i < currentIndices.length; i++) {
	                  newIndices.push(-currentIndices.length + i);
	                }
	              }
	              newIndices = Array.isArray(newIndices) ? newIndices : [newIndices];
	              currentIndices = positivifyIndices(currentIndices, gd.data.length - 1);
	              newIndices = positivifyIndices(newIndices, gd.data.length - 1);
	              for (i = 0; i < gd.data.length; i++) {
	                if (currentIndices.indexOf(i) === -1) {
	                  newData.push(gd.data[i]);
	                }
	              }
	              for (i = 0; i < currentIndices.length; i++) {
	                movingTraceMap.push({
	                  newIndex: newIndices[i],
	                  trace: gd.data[currentIndices[i]]
	                });
	              }
	              movingTraceMap.sort(function(a, b) {
	                return a.newIndex - b.newIndex;
	              });
	              for (i = 0; i < movingTraceMap.length; i += 1) {
	                newData.splice(movingTraceMap[i].newIndex, 0, movingTraceMap[i].trace);
	              }
	              gd.data = newData;
	              var promise = exports2.redraw(gd);
	              Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	              return promise;
	            }
	            function restyle(gd, astr, val, _traces) {
	              gd = Lib.getGraphDiv(gd);
	              helpers.clearPromiseQueue(gd);
	              var aobj = {};
	              if (typeof astr === "string") aobj[astr] = val;
	              else if (Lib.isPlainObject(astr)) {
	                aobj = Lib.extendFlat({}, astr);
	                if (_traces === undefined) _traces = val;
	              } else {
	                Lib.warn("Restyle fail.", astr, val, _traces);
	                return Promise.reject();
	              }
	              if (Object.keys(aobj).length) gd.changed = true;
	              var traces = helpers.coerceTraceIndices(gd, _traces);
	              var specs = _restyle(gd, aobj, traces);
	              var flags = specs.flags;
	              if (flags.calc) gd.calcdata = undefined;
	              if (flags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, {});
	              var seq = [];
	              if (flags.fullReplot) {
	                seq.push(exports2._doPlot);
	              } else {
	                seq.push(Plots.previousPromises);
	                Plots.supplyDefaults(gd);
	                if (flags.markerSize) {
	                  Plots.doCalcdata(gd);
	                  addAxRangeSequence(seq);
	                }
	                if (flags.style) seq.push(subroutines.doTraceStyle);
	                if (flags.colorbars) seq.push(subroutines.doColorBars);
	                seq.push(emitAfterPlot);
	              }
	              seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
	              Queue.add(gd, restyle, [gd, specs.undoit, specs.traces], restyle, [gd, specs.redoit, specs.traces]);
	              var plotDone = Lib.syncOrAsync(seq, gd);
	              if (!plotDone || !plotDone.then) plotDone = Promise.resolve();
	              return plotDone.then(function() {
	                gd.emit("plotly_restyle", specs.eventData);
	                return gd;
	              });
	            }
	            function undefinedToNull(val) {
	              if (val === undefined) return null;
	              return val;
	            }
	            function makeNP(preGUI, guiEditFlag) {
	              if (!guiEditFlag) return nestedProperty;
	              return function(container, attr, prefix) {
	                var np = nestedProperty(container, attr);
	                var npSet = np.set;
	                np.set = function(val) {
	                  var fullAttr = (prefix || "") + attr;
	                  storeCurrent(fullAttr, np.get(), val, preGUI);
	                  npSet(val);
	                };
	                return np;
	              };
	            }
	            function storeCurrent(attr, val, newVal, preGUI) {
	              if (Array.isArray(val) || Array.isArray(newVal)) {
	                var arrayVal = Array.isArray(val) ? val : [];
	                var arrayNew = Array.isArray(newVal) ? newVal : [];
	                var maxLen = Math.max(arrayVal.length, arrayNew.length);
	                for (var i = 0; i < maxLen; i++) {
	                  storeCurrent(attr + "[" + i + "]", arrayVal[i], arrayNew[i], preGUI);
	                }
	              } else if (Lib.isPlainObject(val) || Lib.isPlainObject(newVal)) {
	                var objVal = Lib.isPlainObject(val) ? val : {};
	                var objNew = Lib.isPlainObject(newVal) ? newVal : {};
	                var objBoth = Lib.extendFlat({}, objVal, objNew);
	                for (var key in objBoth) {
	                  storeCurrent(attr + "." + key, objVal[key], objNew[key], preGUI);
	                }
	              } else if (preGUI[attr] === undefined) {
	                preGUI[attr] = undefinedToNull(val);
	              }
	            }
	            function _storeDirectGUIEdit(container, preGUI, edits) {
	              for (var attr in edits) {
	                var np = nestedProperty(container, attr);
	                storeCurrent(attr, np.get(), edits[attr], preGUI);
	              }
	            }
	            function _restyle(gd, aobj, traces) {
	              var fullLayout = gd._fullLayout;
	              var fullData = gd._fullData;
	              var data = gd.data;
	              var guiEditFlag = fullLayout._guiEditing;
	              var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
	              var eventData = Lib.extendDeepAll({}, aobj);
	              var i;
	              cleanDeprecatedAttributeKeys(aobj);
	              var flags = editTypes.traceFlags();
	              var redoit = {};
	              var undoit = {};
	              var axlist;
	              function a0() {
	                return traces.map(function() {
	                  return undefined;
	                });
	              }
	              function addToAxlist(axid) {
	                var axName = Axes.id2name(axid);
	                if (axlist.indexOf(axName) === -1) axlist.push(axName);
	              }
	              function autorangeAttr(axName) {
	                return "LAYOUT" + axName + ".autorange";
	              }
	              function rangeAttr(axName) {
	                return "LAYOUT" + axName + ".range";
	              }
	              function getFullTrace(traceIndex) {
	                for (var j = traceIndex; j < fullData.length; j++) {
	                  if (fullData[j]._input === data[traceIndex]) return fullData[j];
	                }
	              }
	              function doextra(attr, val, i2) {
	                if (Array.isArray(attr)) {
	                  attr.forEach(function(a) {
	                    doextra(a, val, i2);
	                  });
	                  return;
	                }
	                if (attr in aobj || helpers.hasParent(aobj, attr)) return;
	                var extraparam;
	                if (attr.substr(0, 6) === "LAYOUT") {
	                  extraparam = layoutNP(gd.layout, attr.replace("LAYOUT", ""));
	                } else {
	                  var tracei = traces[i2];
	                  var preGUI2 = fullLayout._tracePreGUI[getFullTrace(tracei)._fullInput.uid];
	                  extraparam = makeNP(preGUI2, guiEditFlag)(data[tracei], attr);
	                }
	                if (!(attr in undoit)) {
	                  undoit[attr] = a0();
	                }
	                if (undoit[attr][i2] === undefined) {
	                  undoit[attr][i2] = undefinedToNull(extraparam.get());
	                }
	                if (val !== undefined) {
	                  extraparam.set(val);
	                }
	              }
	              function allBins(binAttr) {
	                return function(j) {
	                  return fullData[j][binAttr];
	                };
	              }
	              function arrayBins(binAttr) {
	                return function(vij, j) {
	                  return vij === false ? fullData[traces[j]][binAttr] : null;
	                };
	              }
	              for (var ai in aobj) {
	                if (helpers.hasParent(aobj, ai)) {
	                  throw new Error("cannot set " + ai + " and a parent attribute simultaneously");
	                }
	                var vi = aobj[ai];
	                var cont;
	                var contFull;
	                var param;
	                var oldVal;
	                var newVal;
	                var valObject;
	                if (ai === "autobinx" || ai === "autobiny") {
	                  ai = ai.charAt(ai.length - 1) + "bins";
	                  if (Array.isArray(vi)) vi = vi.map(arrayBins(ai));
	                  else if (vi === false) vi = traces.map(allBins(ai));
	                  else vi = null;
	                }
	                redoit[ai] = vi;
	                if (ai.substr(0, 6) === "LAYOUT") {
	                  param = layoutNP(gd.layout, ai.replace("LAYOUT", ""));
	                  undoit[ai] = [undefinedToNull(param.get())];
	                  param.set(Array.isArray(vi) ? vi[0] : vi);
	                  flags.calc = true;
	                  continue;
	                }
	                undoit[ai] = a0();
	                for (i = 0; i < traces.length; i++) {
	                  cont = data[traces[i]];
	                  contFull = getFullTrace(traces[i]);
	                  var preGUI = fullLayout._tracePreGUI[contFull._fullInput.uid];
	                  param = makeNP(preGUI, guiEditFlag)(cont, ai);
	                  oldVal = param.get();
	                  newVal = Array.isArray(vi) ? vi[i % vi.length] : vi;
	                  if (newVal === undefined) continue;
	                  var finalPart = param.parts[param.parts.length - 1];
	                  var prefix = ai.substr(0, ai.length - finalPart.length - 1);
	                  var prefixDot = prefix ? prefix + "." : "";
	                  var innerContFull = prefix ? nestedProperty(contFull, prefix).get() : contFull;
	                  valObject = PlotSchema.getTraceValObject(contFull, param.parts);
	                  if (valObject && valObject.impliedEdits && newVal !== null) {
	                    for (var impliedKey in valObject.impliedEdits) {
	                      doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey], i);
	                    }
	                  } else if ((finalPart === "thicknessmode" || finalPart === "lenmode") && oldVal !== newVal && (newVal === "fraction" || newVal === "pixels") && innerContFull) {
	                    var gs = fullLayout._size;
	                    var orient = innerContFull.orient;
	                    var topOrBottom = orient === "top" || orient === "bottom";
	                    if (finalPart === "thicknessmode") {
	                      var thicknorm = topOrBottom ? gs.h : gs.w;
	                      doextra(prefixDot + "thickness", innerContFull.thickness * (newVal === "fraction" ? 1 / thicknorm : thicknorm), i);
	                    } else {
	                      var lennorm = topOrBottom ? gs.w : gs.h;
	                      doextra(prefixDot + "len", innerContFull.len * (newVal === "fraction" ? 1 / lennorm : lennorm), i);
	                    }
	                  } else if (ai === "type" && (newVal === "pie" !== (oldVal === "pie") || newVal === "funnelarea" !== (oldVal === "funnelarea"))) {
	                    var labelsTo = "x";
	                    var valuesTo = "y";
	                    if ((newVal === "bar" || oldVal === "bar") && cont.orientation === "h") {
	                      labelsTo = "y";
	                      valuesTo = "x";
	                    }
	                    Lib.swapAttrs(cont, ["?", "?src"], "labels", labelsTo);
	                    Lib.swapAttrs(cont, ["d?", "?0"], "label", labelsTo);
	                    Lib.swapAttrs(cont, ["?", "?src"], "values", valuesTo);
	                    if (oldVal === "pie" || oldVal === "funnelarea") {
	                      nestedProperty(cont, "marker.color").set(nestedProperty(cont, "marker.colors").get());
	                      fullLayout._pielayer.selectAll("g.trace").remove();
	                    } else if (Registry.traceIs(cont, "cartesian")) {
	                      nestedProperty(cont, "marker.colors").set(nestedProperty(cont, "marker.color").get());
	                    }
	                  }
	                  undoit[ai][i] = undefinedToNull(oldVal);
	                  var swapAttrs = ["swapxy", "swapxyaxes", "orientation", "orientationaxes"];
	                  if (swapAttrs.indexOf(ai) !== -1) {
	                    if (ai === "orientation") {
	                      param.set(newVal);
	                      var defaultOrientation = cont.x && !cont.y ? "h" : "v";
	                      if ((param.get() || defaultOrientation) === contFull.orientation) {
	                        continue;
	                      }
	                    } else if (ai === "orientationaxes") {
	                      cont.orientation = {
	                        v: "h",
	                        h: "v"
	                      }[contFull.orientation];
	                    }
	                    helpers.swapXYData(cont);
	                    flags.calc = flags.clearAxisTypes = true;
	                  } else if (Plots.dataArrayContainers.indexOf(param.parts[0]) !== -1) {
	                    helpers.manageArrayContainers(param, newVal, undoit);
	                    flags.calc = true;
	                  } else {
	                    if (valObject) {
	                      if (valObject.arrayOk && !Registry.traceIs(contFull, "regl") && (Lib.isArrayOrTypedArray(newVal) || Lib.isArrayOrTypedArray(oldVal))) {
	                        flags.calc = true;
	                      } else editTypes.update(flags, valObject);
	                    } else {
	                      flags.calc = true;
	                    }
	                    param.set(newVal);
	                  }
	                }
	                if (["swapxyaxes", "orientationaxes"].indexOf(ai) !== -1) {
	                  Axes.swap(gd, traces);
	                }
	                if (ai === "orientationaxes") {
	                  var hovermode = nestedProperty(gd.layout, "hovermode");
	                  var h = hovermode.get();
	                  if (h === "x") {
	                    hovermode.set("y");
	                  } else if (h === "y") {
	                    hovermode.set("x");
	                  } else if (h === "x unified") {
	                    hovermode.set("y unified");
	                  } else if (h === "y unified") {
	                    hovermode.set("x unified");
	                  }
	                }
	                if (["orientation", "type"].indexOf(ai) !== -1) {
	                  axlist = [];
	                  for (i = 0; i < traces.length; i++) {
	                    var trace = data[traces[i]];
	                    if (Registry.traceIs(trace, "cartesian")) {
	                      addToAxlist(trace.xaxis || "x");
	                      addToAxlist(trace.yaxis || "y");
	                    }
	                  }
	                  doextra(axlist.map(autorangeAttr), true, 0);
	                  doextra(axlist.map(rangeAttr), [0, 1], 0);
	                }
	              }
	              if (flags.calc || flags.plot) {
	                flags.fullReplot = true;
	              }
	              return {
	                flags,
	                undoit,
	                redoit,
	                traces,
	                eventData: Lib.extendDeepNoArrays([], [eventData, traces])
	              };
	            }
	            function cleanDeprecatedAttributeKeys(aobj) {
	              var oldAxisTitleRegex = Lib.counterRegex("axis", ".title", false, false);
	              var colorbarRegex = /colorbar\.title$/;
	              var keys = Object.keys(aobj);
	              var i, key, value;
	              for (i = 0; i < keys.length; i++) {
	                key = keys[i];
	                value = aobj[key];
	                if ((key === "title" || oldAxisTitleRegex.test(key) || colorbarRegex.test(key)) && (typeof value === "string" || typeof value === "number")) {
	                  replace(key, key.replace("title", "title.text"));
	                } else if (key.indexOf("titlefont") > -1 && key.indexOf("grouptitlefont") === -1) {
	                  replace(key, key.replace("titlefont", "title.font"));
	                } else if (key.indexOf("titleposition") > -1) {
	                  replace(key, key.replace("titleposition", "title.position"));
	                } else if (key.indexOf("titleside") > -1) {
	                  replace(key, key.replace("titleside", "title.side"));
	                } else if (key.indexOf("titleoffset") > -1) {
	                  replace(key, key.replace("titleoffset", "title.offset"));
	                }
	              }
	              function replace(oldAttrStr, newAttrStr) {
	                aobj[newAttrStr] = aobj[oldAttrStr];
	                delete aobj[oldAttrStr];
	              }
	            }
	            function relayout(gd, astr, val) {
	              gd = Lib.getGraphDiv(gd);
	              helpers.clearPromiseQueue(gd);
	              var aobj = {};
	              if (typeof astr === "string") {
	                aobj[astr] = val;
	              } else if (Lib.isPlainObject(astr)) {
	                aobj = Lib.extendFlat({}, astr);
	              } else {
	                Lib.warn("Relayout fail.", astr, val);
	                return Promise.reject();
	              }
	              if (Object.keys(aobj).length) gd.changed = true;
	              var specs = _relayout(gd, aobj);
	              var flags = specs.flags;
	              if (flags.calc) gd.calcdata = undefined;
	              var seq = [Plots.previousPromises];
	              if (flags.layoutReplot) {
	                seq.push(subroutines.layoutReplot);
	              } else if (Object.keys(aobj).length) {
	                axRangeSupplyDefaultsByPass(gd, flags, specs) || Plots.supplyDefaults(gd);
	                if (flags.legend) seq.push(subroutines.doLegend);
	                if (flags.layoutstyle) seq.push(subroutines.layoutStyles);
	                if (flags.axrange) addAxRangeSequence(seq, specs.rangesAltered);
	                if (flags.ticks) seq.push(subroutines.doTicksRelayout);
	                if (flags.modebar) seq.push(subroutines.doModeBar);
	                if (flags.camera) seq.push(subroutines.doCamera);
	                if (flags.colorbars) seq.push(subroutines.doColorBars);
	                seq.push(emitAfterPlot);
	              }
	              seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
	              Queue.add(gd, relayout, [gd, specs.undoit], relayout, [gd, specs.redoit]);
	              var plotDone = Lib.syncOrAsync(seq, gd);
	              if (!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
	              return plotDone.then(function() {
	                gd.emit("plotly_relayout", specs.eventData);
	                return gd;
	              });
	            }
	            function axRangeSupplyDefaultsByPass(gd, flags, specs) {
	              var fullLayout = gd._fullLayout;
	              if (!flags.axrange) return false;
	              for (var k in flags) {
	                if (k !== "axrange" && flags[k]) return false;
	              }
	              var axIn, axOut;
	              var coerce = function(attr, dflt) {
	                return Lib.coerce(axIn, axOut, cartesianLayoutAttributes, attr, dflt);
	              };
	              var options = {};
	              for (var axId in specs.rangesAltered) {
	                var axName = Axes.id2name(axId);
	                axIn = gd.layout[axName];
	                axOut = fullLayout[axName];
	                handleRangeDefaults(axIn, axOut, coerce, options);
	                if (axOut._matchGroup) {
	                  for (var axId2 in axOut._matchGroup) {
	                    if (axId2 !== axId) {
	                      var ax2 = fullLayout[Axes.id2name(axId2)];
	                      ax2.autorange = axOut.autorange;
	                      ax2.range = axOut.range.slice();
	                      ax2._input.range = axOut.range.slice();
	                    }
	                  }
	                }
	              }
	              return true;
	            }
	            function addAxRangeSequence(seq, rangesAltered) {
	              var drawAxes = rangesAltered ? function(gd) {
	                var axIds = [];
	                var skipTitle = true;
	                for (var id in rangesAltered) {
	                  var ax = Axes.getFromId(gd, id);
	                  axIds.push(id);
	                  if ((ax.ticklabelposition || "").indexOf("inside") !== -1) {
	                    if (ax._anchorAxis) {
	                      axIds.push(ax._anchorAxis._id);
	                    }
	                  }
	                  if (ax._matchGroup) {
	                    for (var id2 in ax._matchGroup) {
	                      if (!rangesAltered[id2]) {
	                        axIds.push(id2);
	                      }
	                    }
	                  }
	                }
	                return Axes.draw(gd, axIds, {
	                  skipTitle
	                });
	              } : function(gd) {
	                return Axes.draw(gd, "redraw");
	              };
	              seq.push(clearOutline, subroutines.doAutoRangeAndConstraints, drawAxes, subroutines.drawData, subroutines.finalDraw);
	            }
	            var AX_RANGE_RE = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/;
	            var AX_AUTORANGE_RE = /^[xyz]axis[0-9]*\.autorange$/;
	            var AX_DOMAIN_RE = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
	            function _relayout(gd, aobj) {
	              var layout = gd.layout;
	              var fullLayout = gd._fullLayout;
	              var guiEditFlag = fullLayout._guiEditing;
	              var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
	              var keys = Object.keys(aobj);
	              var axes = Axes.list(gd);
	              var eventData = Lib.extendDeepAll({}, aobj);
	              var arrayEdits = {};
	              var arrayStr, i, j;
	              cleanDeprecatedAttributeKeys(aobj);
	              keys = Object.keys(aobj);
	              for (i = 0; i < keys.length; i++) {
	                if (keys[i].indexOf("allaxes") === 0) {
	                  for (j = 0; j < axes.length; j++) {
	                    var scene = axes[j]._id.substr(1);
	                    var axisAttr = scene.indexOf("scene") !== -1 ? scene + "." : "";
	                    var newkey = keys[i].replace("allaxes", axisAttr + axes[j]._name);
	                    if (!aobj[newkey]) aobj[newkey] = aobj[keys[i]];
	                  }
	                  delete aobj[keys[i]];
	                }
	              }
	              var flags = editTypes.layoutFlags();
	              var redoit = {};
	              var undoit = {};
	              function doextra(attr, val) {
	                if (Array.isArray(attr)) {
	                  attr.forEach(function(a) {
	                    doextra(a, val);
	                  });
	                  return;
	                }
	                if (attr in aobj || helpers.hasParent(aobj, attr)) return;
	                var p2 = layoutNP(layout, attr);
	                if (!(attr in undoit)) {
	                  undoit[attr] = undefinedToNull(p2.get());
	                }
	                if (val !== undefined) p2.set(val);
	              }
	              var rangesAltered = {};
	              var ax;
	              function recordAlteredAxis(pleafPlus2) {
	                var axId2 = Axes.name2id(pleafPlus2.split(".")[0]);
	                rangesAltered[axId2] = 1;
	                return axId2;
	              }
	              for (var ai in aobj) {
	                if (helpers.hasParent(aobj, ai)) {
	                  throw new Error("cannot set " + ai + " and a parent attribute simultaneously");
	                }
	                var p = layoutNP(layout, ai);
	                var vi = aobj[ai];
	                var plen = p.parts.length;
	                var pend = plen - 1;
	                while (pend > 0 && typeof p.parts[pend] !== "string") pend--;
	                var pleaf = p.parts[pend];
	                var pleafPlus = p.parts[pend - 1] + "." + pleaf;
	                var ptrunk = p.parts.slice(0, pend).join(".");
	                var parentIn = nestedProperty(gd.layout, ptrunk).get();
	                var parentFull = nestedProperty(fullLayout, ptrunk).get();
	                var vOld = p.get();
	                if (vi === undefined) continue;
	                redoit[ai] = vi;
	                undoit[ai] = pleaf === "reverse" ? vi : undefinedToNull(vOld);
	                var valObject = PlotSchema.getLayoutValObject(fullLayout, p.parts);
	                if (valObject && valObject.impliedEdits && vi !== null) {
	                  for (var impliedKey in valObject.impliedEdits) {
	                    doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey]);
	                  }
	                }
	                if (["width", "height"].indexOf(ai) !== -1) {
	                  if (vi) {
	                    doextra("autosize", null);
	                    var oppositeAttr = ai === "height" ? "width" : "height";
	                    doextra(oppositeAttr, fullLayout[oppositeAttr]);
	                  } else {
	                    fullLayout[ai] = gd._initialAutoSize[ai];
	                  }
	                } else if (ai === "autosize") {
	                  doextra("width", vi ? null : fullLayout.width);
	                  doextra("height", vi ? null : fullLayout.height);
	                } else if (pleafPlus.match(AX_RANGE_RE)) {
	                  recordAlteredAxis(pleafPlus);
	                  nestedProperty(fullLayout, ptrunk + "._inputRange").set(null);
	                } else if (pleafPlus.match(AX_AUTORANGE_RE)) {
	                  recordAlteredAxis(pleafPlus);
	                  nestedProperty(fullLayout, ptrunk + "._inputRange").set(null);
	                  var axFull = nestedProperty(fullLayout, ptrunk).get();
	                  if (axFull._inputDomain) {
	                    axFull._input.domain = axFull._inputDomain.slice();
	                  }
	                } else if (pleafPlus.match(AX_DOMAIN_RE)) {
	                  nestedProperty(fullLayout, ptrunk + "._inputDomain").set(null);
	                }
	                if (pleaf === "type") {
	                  ax = parentIn;
	                  var toLog = parentFull.type === "linear" && vi === "log";
	                  var fromLog = parentFull.type === "log" && vi === "linear";
	                  if (toLog || fromLog) {
	                    if (!ax || !ax.range) {
	                      doextra(ptrunk + ".autorange", true);
	                    } else if (!parentFull.autorange) {
	                      var r0 = ax.range[0];
	                      var r1 = ax.range[1];
	                      if (toLog) {
	                        if (r0 <= 0 && r1 <= 0) {
	                          doextra(ptrunk + ".autorange", true);
	                        }
	                        if (r0 <= 0) r0 = r1 / 1e6;
	                        else if (r1 <= 0) r1 = r0 / 1e6;
	                        doextra(ptrunk + ".range[0]", Math.log(r0) / Math.LN10);
	                        doextra(ptrunk + ".range[1]", Math.log(r1) / Math.LN10);
	                      } else {
	                        doextra(ptrunk + ".range[0]", Math.pow(10, r0));
	                        doextra(ptrunk + ".range[1]", Math.pow(10, r1));
	                      }
	                    } else if (toLog) {
	                      ax.range = ax.range[1] > ax.range[0] ? [1, 2] : [2, 1];
	                    }
	                    if (Array.isArray(fullLayout._subplots.polar) && fullLayout._subplots.polar.length && fullLayout[p.parts[0]] && p.parts[1] === "radialaxis") {
	                      delete fullLayout[p.parts[0]]._subplot.viewInitial["radialaxis.range"];
	                    }
	                    Registry.getComponentMethod("annotations", "convertCoords")(gd, parentFull, vi, doextra);
	                    Registry.getComponentMethod("images", "convertCoords")(gd, parentFull, vi, doextra);
	                  } else {
	                    doextra(ptrunk + ".autorange", true);
	                    doextra(ptrunk + ".range", null);
	                  }
	                  nestedProperty(fullLayout, ptrunk + "._inputRange").set(null);
	                } else if (pleaf.match(AX_NAME_PATTERN)) {
	                  var fullProp = nestedProperty(fullLayout, ai).get();
	                  var newType = (vi || {}).type;
	                  if (!newType || newType === "-") newType = "linear";
	                  Registry.getComponentMethod("annotations", "convertCoords")(gd, fullProp, newType, doextra);
	                  Registry.getComponentMethod("images", "convertCoords")(gd, fullProp, newType, doextra);
	                }
	                var containerArrayMatch = manageArrays.containerArrayMatch(ai);
	                if (containerArrayMatch) {
	                  arrayStr = containerArrayMatch.array;
	                  i = containerArrayMatch.index;
	                  var propStr = containerArrayMatch.property;
	                  var updateValObject = valObject || {
	                    editType: "calc"
	                  };
	                  if (i !== "" && propStr === "") {
	                    if (manageArrays.isAddVal(vi)) {
	                      undoit[ai] = null;
	                    } else if (manageArrays.isRemoveVal(vi)) {
	                      undoit[ai] = (nestedProperty(layout, arrayStr).get() || [])[i];
	                    } else {
	                      Lib.warn("unrecognized full object value", aobj);
	                    }
	                  }
	                  editTypes.update(flags, updateValObject);
	                  if (!arrayEdits[arrayStr]) arrayEdits[arrayStr] = {};
	                  var objEdits = arrayEdits[arrayStr][i];
	                  if (!objEdits) objEdits = arrayEdits[arrayStr][i] = {};
	                  objEdits[propStr] = vi;
	                  delete aobj[ai];
	                } else if (pleaf === "reverse") {
	                  if (parentIn.range) parentIn.range.reverse();
	                  else {
	                    doextra(ptrunk + ".autorange", true);
	                    parentIn.range = [1, 0];
	                  }
	                  if (parentFull.autorange) flags.calc = true;
	                  else flags.plot = true;
	                } else {
	                  if (ai === "dragmode" && (vi === false && vOld !== false || vi !== false && vOld === false)) {
	                    flags.plot = true;
	                  } else if (fullLayout._has("scatter-like") && fullLayout._has("regl") && ai === "dragmode" && (vi === "lasso" || vi === "select") && !(vOld === "lasso" || vOld === "select")) {
	                    flags.plot = true;
	                  } else if (fullLayout._has("gl2d")) {
	                    flags.plot = true;
	                  } else if (valObject) editTypes.update(flags, valObject);
	                  else flags.calc = true;
	                  p.set(vi);
	                }
	              }
	              for (arrayStr in arrayEdits) {
	                var finished = manageArrays.applyContainerArrayChanges(gd, layoutNP(layout, arrayStr), arrayEdits[arrayStr], flags, layoutNP);
	                if (!finished) flags.plot = true;
	              }
	              for (var axId in rangesAltered) {
	                ax = Axes.getFromId(gd, axId);
	                var group = ax && ax._constraintGroup;
	                if (group) {
	                  flags.calc = true;
	                  for (var groupAxId in group) {
	                    if (!rangesAltered[groupAxId]) {
	                      Axes.getFromId(gd, groupAxId)._constraintShrinkable = true;
	                    }
	                  }
	                }
	              }
	              if (updateAutosize(gd) || aobj.height || aobj.width) flags.plot = true;
	              var shapes = fullLayout.shapes;
	              for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].showlegend) {
	                  flags.calc = true;
	                  break;
	                }
	              }
	              if (flags.plot || flags.calc) {
	                flags.layoutReplot = true;
	              }
	              return {
	                flags,
	                rangesAltered,
	                undoit,
	                redoit,
	                eventData
	              };
	            }
	            function updateAutosize(gd) {
	              var fullLayout = gd._fullLayout;
	              var oldWidth = fullLayout.width;
	              var oldHeight = fullLayout.height;
	              if (gd.layout.autosize) Plots.plotAutoSize(gd, gd.layout, fullLayout);
	              return fullLayout.width !== oldWidth || fullLayout.height !== oldHeight;
	            }
	            function update(gd, traceUpdate, layoutUpdate, _traces) {
	              gd = Lib.getGraphDiv(gd);
	              helpers.clearPromiseQueue(gd);
	              if (!Lib.isPlainObject(traceUpdate)) traceUpdate = {};
	              if (!Lib.isPlainObject(layoutUpdate)) layoutUpdate = {};
	              if (Object.keys(traceUpdate).length) gd.changed = true;
	              if (Object.keys(layoutUpdate).length) gd.changed = true;
	              var traces = helpers.coerceTraceIndices(gd, _traces);
	              var restyleSpecs = _restyle(gd, Lib.extendFlat({}, traceUpdate), traces);
	              var restyleFlags = restyleSpecs.flags;
	              var relayoutSpecs = _relayout(gd, Lib.extendFlat({}, layoutUpdate));
	              var relayoutFlags = relayoutSpecs.flags;
	              if (restyleFlags.calc || relayoutFlags.calc) gd.calcdata = undefined;
	              if (restyleFlags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, layoutUpdate);
	              var seq = [];
	              if (relayoutFlags.layoutReplot) {
	                seq.push(subroutines.layoutReplot);
	              } else if (restyleFlags.fullReplot) {
	                seq.push(exports2._doPlot);
	              } else {
	                seq.push(Plots.previousPromises);
	                axRangeSupplyDefaultsByPass(gd, relayoutFlags, relayoutSpecs) || Plots.supplyDefaults(gd);
	                if (restyleFlags.style) seq.push(subroutines.doTraceStyle);
	                if (restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
	                if (relayoutFlags.legend) seq.push(subroutines.doLegend);
	                if (relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
	                if (relayoutFlags.axrange) addAxRangeSequence(seq, relayoutSpecs.rangesAltered);
	                if (relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
	                if (relayoutFlags.modebar) seq.push(subroutines.doModeBar);
	                if (relayoutFlags.camera) seq.push(subroutines.doCamera);
	                seq.push(emitAfterPlot);
	              }
	              seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
	              Queue.add(gd, update, [gd, restyleSpecs.undoit, relayoutSpecs.undoit, restyleSpecs.traces], update, [gd, restyleSpecs.redoit, relayoutSpecs.redoit, restyleSpecs.traces]);
	              var plotDone = Lib.syncOrAsync(seq, gd);
	              if (!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
	              return plotDone.then(function() {
	                gd.emit("plotly_update", {
	                  data: restyleSpecs.eventData,
	                  layout: relayoutSpecs.eventData
	                });
	                return gd;
	              });
	            }
	            function guiEdit(func) {
	              return function wrappedEdit(gd) {
	                gd._fullLayout._guiEditing = true;
	                var p = func.apply(null, arguments);
	                gd._fullLayout._guiEditing = false;
	                return p;
	              };
	            }
	            var layoutUIControlPatterns = [
	              {
	                pattern: /^hiddenlabels/,
	                attr: "legend.uirevision"
	              },
	              {
	                pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
	              },
	              // showspikes and modes include those nested inside scenes
	              {
	                pattern: /axis\d*\.showspikes$/,
	                attr: "modebar.uirevision"
	              },
	              {
	                pattern: /(hover|drag)mode$/,
	                attr: "modebar.uirevision"
	              },
	              {
	                pattern: /^(scene\d*)\.camera/
	              },
	              {
	                pattern: /^(geo\d*)\.(projection|center|fitbounds)/
	              },
	              {
	                pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
	              },
	              {
	                pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
	              },
	              {
	                pattern: /^(polar\d*\.angularaxis)\.rotation/
	              },
	              {
	                pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
	              },
	              {
	                pattern: /^legend\.(x|y)$/,
	                attr: "editrevision"
	              },
	              {
	                pattern: /^(shapes|annotations)/,
	                attr: "editrevision"
	              },
	              {
	                pattern: /^title\.text$/,
	                attr: "editrevision"
	              }
	            ];
	            var traceUIControlPatterns = [
	              {
	                pattern: /^selectedpoints$/,
	                attr: "selectionrevision"
	              },
	              // "visible" includes trace.transforms[i].styles[j].value.visible
	              {
	                pattern: /(^|value\.)visible$/,
	                attr: "legend.uirevision"
	              },
	              {
	                pattern: /^dimensions\[\d+\]\.constraintrange/
	              },
	              {
	                pattern: /^node\.(x|y|groups)/
	              },
	              // for Sankey nodes
	              {
	                pattern: /^level$/
	              },
	              // for Sunburst, Treemap and Icicle traces
	              // below this you must be in editable: true mode
	              // TODO: I still put name and title with `trace.uirevision`
	              // reasonable or should these be `editrevision`?
	              // Also applies to axis titles up in the layout section
	              // "name" also includes transform.styles
	              {
	                pattern: /(^|value\.)name$/
	              },
	              // including nested colorbar attributes (ie marker.colorbar)
	              {
	                pattern: /colorbar\.title\.text$/
	              },
	              {
	                pattern: /colorbar\.(x|y)$/,
	                attr: "editrevision"
	              }
	            ];
	            function findUIPattern(key, patternSpecs) {
	              for (var i = 0; i < patternSpecs.length; i++) {
	                var spec = patternSpecs[i];
	                var match = key.match(spec.pattern);
	                if (match) {
	                  var head = match[1] || "";
	                  return {
	                    head,
	                    tail: key.substr(head.length + 1),
	                    attr: spec.attr
	                  };
	                }
	              }
	            }
	            function getNewRev(revAttr, container) {
	              var newRev = nestedProperty(container, revAttr).get();
	              if (newRev !== undefined) return newRev;
	              var parts = revAttr.split(".");
	              parts.pop();
	              while (parts.length > 1) {
	                parts.pop();
	                newRev = nestedProperty(container, parts.join(".") + ".uirevision").get();
	                if (newRev !== undefined) return newRev;
	              }
	              return container.uirevision;
	            }
	            function getFullTraceIndexFromUid(uid, fullData) {
	              for (var i = 0; i < fullData.length; i++) {
	                if (fullData[i]._fullInput.uid === uid) return i;
	              }
	              return -1;
	            }
	            function getTraceIndexFromUid(uid, data, tracei) {
	              for (var i = 0; i < data.length; i++) {
	                if (data[i].uid === uid) return i;
	              }
	              return !data[tracei] || data[tracei].uid ? -1 : tracei;
	            }
	            function valsMatch(v1, v2) {
	              var v1IsObj = Lib.isPlainObject(v1);
	              var v1IsArray = Array.isArray(v1);
	              if (v1IsObj || v1IsArray) {
	                return (v1IsObj && Lib.isPlainObject(v2) || v1IsArray && Array.isArray(v2)) && JSON.stringify(v1) === JSON.stringify(v2);
	              }
	              return v1 === v2;
	            }
	            function applyUIRevisions(data, layout, oldFullData, oldFullLayout) {
	              var layoutPreGUI = oldFullLayout._preGUI;
	              var key, revAttr, oldRev, newRev, match, preGUIVal, newNP, newVal, head, tail;
	              var bothInheritAutorange = [];
	              var newAutorangeIn = {};
	              var newRangeAccepted = {};
	              for (key in layoutPreGUI) {
	                match = findUIPattern(key, layoutUIControlPatterns);
	                if (match) {
	                  head = match.head;
	                  tail = match.tail;
	                  revAttr = match.attr || head + ".uirevision";
	                  oldRev = nestedProperty(oldFullLayout, revAttr).get();
	                  newRev = oldRev && getNewRev(revAttr, layout);
	                  if (newRev && newRev === oldRev) {
	                    preGUIVal = layoutPreGUI[key];
	                    if (preGUIVal === null) preGUIVal = undefined;
	                    newNP = nestedProperty(layout, key);
	                    newVal = newNP.get();
	                    if (valsMatch(newVal, preGUIVal)) {
	                      if (newVal === undefined && tail === "autorange") {
	                        bothInheritAutorange.push(head);
	                      }
	                      newNP.set(undefinedToNull(nestedProperty(oldFullLayout, key).get()));
	                      continue;
	                    } else if (tail === "autorange" || tail.substr(0, 6) === "range[") {
	                      var pre0 = layoutPreGUI[head + ".range[0]"];
	                      var pre1 = layoutPreGUI[head + ".range[1]"];
	                      var preAuto = layoutPreGUI[head + ".autorange"];
	                      if (preAuto || preAuto === null && pre0 === null && pre1 === null) {
	                        if (!(head in newAutorangeIn)) {
	                          var newContainer = nestedProperty(layout, head).get();
	                          newAutorangeIn[head] = newContainer && (newContainer.autorange || newContainer.autorange !== false && (!newContainer.range || newContainer.range.length !== 2));
	                        }
	                        if (newAutorangeIn[head]) {
	                          newNP.set(undefinedToNull(nestedProperty(oldFullLayout, key).get()));
	                          continue;
	                        }
	                      }
	                    }
	                  }
	                } else {
	                  Lib.warn("unrecognized GUI edit: " + key);
	                }
	                delete layoutPreGUI[key];
	                if (match && match.tail.substr(0, 6) === "range[") {
	                  newRangeAccepted[match.head] = 1;
	                }
	              }
	              for (var i = 0; i < bothInheritAutorange.length; i++) {
	                var axAttr = bothInheritAutorange[i];
	                if (newRangeAccepted[axAttr]) {
	                  var newAx = nestedProperty(layout, axAttr).get();
	                  if (newAx) delete newAx.autorange;
	                }
	              }
	              var allTracePreGUI = oldFullLayout._tracePreGUI;
	              for (var uid in allTracePreGUI) {
	                var tracePreGUI = allTracePreGUI[uid];
	                var newTrace = null;
	                var fullInput;
	                for (key in tracePreGUI) {
	                  if (!newTrace) {
	                    var fulli = getFullTraceIndexFromUid(uid, oldFullData);
	                    if (fulli < 0) {
	                      delete allTracePreGUI[uid];
	                      break;
	                    }
	                    var fullTrace = oldFullData[fulli];
	                    fullInput = fullTrace._fullInput;
	                    var newTracei = getTraceIndexFromUid(uid, data, fullInput.index);
	                    if (newTracei < 0) {
	                      delete allTracePreGUI[uid];
	                      break;
	                    }
	                    newTrace = data[newTracei];
	                  }
	                  match = findUIPattern(key, traceUIControlPatterns);
	                  if (match) {
	                    if (match.attr) {
	                      oldRev = nestedProperty(oldFullLayout, match.attr).get();
	                      newRev = oldRev && getNewRev(match.attr, layout);
	                    } else {
	                      oldRev = fullInput.uirevision;
	                      newRev = newTrace.uirevision;
	                      if (newRev === undefined) newRev = layout.uirevision;
	                    }
	                    if (newRev && newRev === oldRev) {
	                      preGUIVal = tracePreGUI[key];
	                      if (preGUIVal === null) preGUIVal = undefined;
	                      newNP = nestedProperty(newTrace, key);
	                      newVal = newNP.get();
	                      if (valsMatch(newVal, preGUIVal)) {
	                        newNP.set(undefinedToNull(nestedProperty(fullInput, key).get()));
	                        continue;
	                      }
	                    }
	                  } else {
	                    Lib.warn("unrecognized GUI edit: " + key + " in trace uid " + uid);
	                  }
	                  delete tracePreGUI[key];
	                }
	              }
	            }
	            function react(gd, data, layout, config) {
	              var frames, plotDone;
	              function addFrames2() {
	                return exports2.addFrames(gd, frames);
	              }
	              gd = Lib.getGraphDiv(gd);
	              helpers.clearPromiseQueue(gd);
	              var oldFullData = gd._fullData;
	              var oldFullLayout = gd._fullLayout;
	              if (!Lib.isPlotDiv(gd) || !oldFullData || !oldFullLayout) {
	                plotDone = exports2.newPlot(gd, data, layout, config);
	              } else {
	                if (Lib.isPlainObject(data)) {
	                  var obj = data;
	                  data = obj.data;
	                  layout = obj.layout;
	                  config = obj.config;
	                  frames = obj.frames;
	                }
	                var configChanged = false;
	                if (config) {
	                  var oldConfig = Lib.extendDeep({}, gd._context);
	                  gd._context = undefined;
	                  setPlotContext(gd, config);
	                  configChanged = diffConfig(oldConfig, gd._context);
	                }
	                gd.data = data || [];
	                helpers.cleanData(gd.data);
	                gd.layout = layout || {};
	                helpers.cleanLayout(gd.layout);
	                applyUIRevisions(gd.data, gd.layout, oldFullData, oldFullLayout);
	                Plots.supplyDefaults(gd, {
	                  skipUpdateCalc: true
	                });
	                var newFullData = gd._fullData;
	                var newFullLayout = gd._fullLayout;
	                var immutable = newFullLayout.datarevision === undefined;
	                var transition = newFullLayout.transition;
	                var relayoutFlags = diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition);
	                var newDataRevision = relayoutFlags.newDataRevision;
	                var restyleFlags = diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision);
	                if (updateAutosize(gd)) relayoutFlags.layoutReplot = true;
	                if (restyleFlags.calc || relayoutFlags.calc) {
	                  gd.calcdata = undefined;
	                  var allNames = Object.getOwnPropertyNames(newFullLayout);
	                  for (var q = 0; q < allNames.length; q++) {
	                    var name2 = allNames[q];
	                    var start = name2.substring(0, 5);
	                    if (start === "xaxis" || start === "yaxis") {
	                      var emptyCategories = newFullLayout[name2]._emptyCategories;
	                      if (emptyCategories) emptyCategories();
	                    }
	                  }
	                } else {
	                  Plots.supplyDefaultsUpdateCalc(gd.calcdata, newFullData);
	                }
	                var seq = [];
	                if (frames) {
	                  gd._transitionData = {};
	                  Plots.createTransitionData(gd);
	                  seq.push(addFrames2);
	                }
	                if (newFullLayout.transition && !configChanged && (restyleFlags.anim || relayoutFlags.anim)) {
	                  if (relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
	                  Plots.doCalcdata(gd);
	                  subroutines.doAutoRangeAndConstraints(gd);
	                  seq.push(function() {
	                    return Plots.transitionFromReact(gd, restyleFlags, relayoutFlags, oldFullLayout);
	                  });
	                } else if (restyleFlags.fullReplot || relayoutFlags.layoutReplot || configChanged) {
	                  gd._fullLayout._skipDefaults = true;
	                  seq.push(exports2._doPlot);
	                } else {
	                  for (var componentType in relayoutFlags.arrays) {
	                    var indices = relayoutFlags.arrays[componentType];
	                    if (indices.length) {
	                      var drawOne = Registry.getComponentMethod(componentType, "drawOne");
	                      if (drawOne !== Lib.noop) {
	                        for (var i = 0; i < indices.length; i++) {
	                          drawOne(gd, indices[i]);
	                        }
	                      } else {
	                        var draw = Registry.getComponentMethod(componentType, "draw");
	                        if (draw === Lib.noop) {
	                          throw new Error("cannot draw components: " + componentType);
	                        }
	                        draw(gd);
	                      }
	                    }
	                  }
	                  seq.push(Plots.previousPromises);
	                  if (restyleFlags.style) seq.push(subroutines.doTraceStyle);
	                  if (restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
	                  if (relayoutFlags.legend) seq.push(subroutines.doLegend);
	                  if (relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
	                  if (relayoutFlags.axrange) addAxRangeSequence(seq);
	                  if (relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
	                  if (relayoutFlags.modebar) seq.push(subroutines.doModeBar);
	                  if (relayoutFlags.camera) seq.push(subroutines.doCamera);
	                  seq.push(emitAfterPlot);
	                }
	                seq.push(Plots.rehover, Plots.redrag, Plots.reselect);
	                plotDone = Lib.syncOrAsync(seq, gd);
	                if (!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
	              }
	              return plotDone.then(function() {
	                gd.emit("plotly_react", {
	                  data,
	                  layout
	                });
	                return gd;
	              });
	            }
	            function diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision) {
	              var sameTraceLength = oldFullData.length === newFullData.length;
	              if (!transition && !sameTraceLength) {
	                return {
	                  fullReplot: true,
	                  calc: true
	                };
	              }
	              var flags = editTypes.traceFlags();
	              flags.arrays = {};
	              flags.nChanges = 0;
	              flags.nChangesAnim = 0;
	              var i, trace;
	              function getTraceValObject(parts) {
	                var out = PlotSchema.getTraceValObject(trace, parts);
	                if (!trace._module.animatable && out.anim) {
	                  out.anim = false;
	                }
	                return out;
	              }
	              var diffOpts = {
	                getValObject: getTraceValObject,
	                flags,
	                immutable,
	                transition,
	                newDataRevision,
	                gd
	              };
	              var seenUIDs = {};
	              for (i = 0; i < oldFullData.length; i++) {
	                if (newFullData[i]) {
	                  trace = newFullData[i]._fullInput;
	                  if (Plots.hasMakesDataTransform(trace)) trace = newFullData[i];
	                  if (seenUIDs[trace.uid]) continue;
	                  seenUIDs[trace.uid] = 1;
	                  getDiffFlags(oldFullData[i]._fullInput, trace, [], diffOpts);
	                }
	              }
	              if (flags.calc || flags.plot) {
	                flags.fullReplot = true;
	              }
	              if (transition && flags.nChanges && flags.nChangesAnim) {
	                flags.anim = flags.nChanges === flags.nChangesAnim && sameTraceLength ? "all" : "some";
	              }
	              return flags;
	            }
	            function diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition) {
	              var flags = editTypes.layoutFlags();
	              flags.arrays = {};
	              flags.rangesAltered = {};
	              flags.nChanges = 0;
	              flags.nChangesAnim = 0;
	              function getLayoutValObject(parts) {
	                return PlotSchema.getLayoutValObject(newFullLayout, parts);
	              }
	              var diffOpts = {
	                getValObject: getLayoutValObject,
	                flags,
	                immutable,
	                transition,
	                gd
	              };
	              getDiffFlags(oldFullLayout, newFullLayout, [], diffOpts);
	              if (flags.plot || flags.calc) {
	                flags.layoutReplot = true;
	              }
	              if (transition && flags.nChanges && flags.nChangesAnim) {
	                flags.anim = flags.nChanges === flags.nChangesAnim ? "all" : "some";
	              }
	              return flags;
	            }
	            function getDiffFlags(oldContainer, newContainer, outerparts, opts) {
	              var valObject, key, astr;
	              var getValObject = opts.getValObject;
	              var flags = opts.flags;
	              var immutable = opts.immutable;
	              var inArray = opts.inArray;
	              var arrayIndex = opts.arrayIndex;
	              function changed() {
	                var editType = valObject.editType;
	                if (inArray && editType.indexOf("arraydraw") !== -1) {
	                  Lib.pushUnique(flags.arrays[inArray], arrayIndex);
	                  return;
	                }
	                editTypes.update(flags, valObject);
	                if (editType !== "none") {
	                  flags.nChanges++;
	                }
	                if (opts.transition && valObject.anim) {
	                  flags.nChangesAnim++;
	                }
	                if (AX_RANGE_RE.test(astr) || AX_AUTORANGE_RE.test(astr)) {
	                  flags.rangesAltered[outerparts[0]] = 1;
	                }
	                if (AX_DOMAIN_RE.test(astr)) {
	                  nestedProperty(newContainer, "_inputDomain").set(null);
	                }
	                if (key === "datarevision") {
	                  flags.newDataRevision = 1;
	                }
	              }
	              function valObjectCanBeDataArray(valObject2) {
	                return valObject2.valType === "data_array" || valObject2.arrayOk;
	              }
	              for (key in oldContainer) {
	                if (flags.calc && !opts.transition) return;
	                var oldVal = oldContainer[key];
	                var newVal = newContainer[key];
	                var parts = outerparts.concat(key);
	                astr = parts.join(".");
	                if (key.charAt(0) === "_" || typeof oldVal === "function" || oldVal === newVal) continue;
	                if ((key === "tick0" || key === "dtick") && outerparts[0] !== "geo") {
	                  var tickMode = newContainer.tickmode;
	                  if (tickMode === "auto" || tickMode === "array" || !tickMode) continue;
	                }
	                if (key === "range" && newContainer.autorange) continue;
	                if ((key === "zmin" || key === "zmax") && newContainer.type === "contourcarpet") continue;
	                valObject = getValObject(parts);
	                if (!valObject) continue;
	                if (valObject._compareAsJSON && JSON.stringify(oldVal) === JSON.stringify(newVal)) continue;
	                var valType = valObject.valType;
	                var i;
	                var canBeDataArray = valObjectCanBeDataArray(valObject);
	                var wasArray = Array.isArray(oldVal);
	                var nowArray = Array.isArray(newVal);
	                if (wasArray && nowArray) {
	                  var inputKey = "_input_" + key;
	                  var oldValIn = oldContainer[inputKey];
	                  var newValIn = newContainer[inputKey];
	                  if (Array.isArray(oldValIn) && oldValIn === newValIn) continue;
	                }
	                if (newVal === undefined) {
	                  if (canBeDataArray && wasArray) flags.calc = true;
	                  else changed();
	                } else if (valObject._isLinkedToArray) {
	                  var arrayEditIndices = [];
	                  var extraIndices = false;
	                  if (!inArray) flags.arrays[key] = arrayEditIndices;
	                  var minLen = Math.min(oldVal.length, newVal.length);
	                  var maxLen = Math.max(oldVal.length, newVal.length);
	                  if (minLen !== maxLen) {
	                    if (valObject.editType === "arraydraw") {
	                      extraIndices = true;
	                    } else {
	                      changed();
	                      continue;
	                    }
	                  }
	                  for (i = 0; i < minLen; i++) {
	                    getDiffFlags(
	                      oldVal[i],
	                      newVal[i],
	                      parts.concat(i),
	                      // add array indices, but not if we're already in an array
	                      Lib.extendFlat({
	                        inArray: key,
	                        arrayIndex: i
	                      }, opts)
	                    );
	                  }
	                  if (extraIndices) {
	                    for (i = minLen; i < maxLen; i++) {
	                      arrayEditIndices.push(i);
	                    }
	                  }
	                } else if (!valType && Lib.isPlainObject(oldVal)) {
	                  getDiffFlags(oldVal, newVal, parts, opts);
	                } else if (canBeDataArray) {
	                  if (wasArray && nowArray) {
	                    if (immutable) {
	                      flags.calc = true;
	                    }
	                    if (immutable || opts.newDataRevision) {
	                      changed();
	                    }
	                  } else if (wasArray !== nowArray) {
	                    flags.calc = true;
	                  } else changed();
	                } else if (wasArray && nowArray) {
	                  if (oldVal.length !== newVal.length || String(oldVal) !== String(newVal)) {
	                    changed();
	                  }
	                } else {
	                  changed();
	                }
	              }
	              for (key in newContainer) {
	                if (!(key in oldContainer || key.charAt(0) === "_" || typeof newContainer[key] === "function")) {
	                  valObject = getValObject(outerparts.concat(key));
	                  if (valObjectCanBeDataArray(valObject) && Array.isArray(newContainer[key])) {
	                    flags.calc = true;
	                    return;
	                  } else changed();
	                }
	              }
	            }
	            function diffConfig(oldConfig, newConfig) {
	              var key;
	              for (key in oldConfig) {
	                if (key.charAt(0) === "_") continue;
	                var oldVal = oldConfig[key];
	                var newVal = newConfig[key];
	                if (oldVal !== newVal) {
	                  if (Lib.isPlainObject(oldVal) && Lib.isPlainObject(newVal)) {
	                    if (diffConfig(oldVal, newVal)) {
	                      return true;
	                    }
	                  } else if (Array.isArray(oldVal) && Array.isArray(newVal)) {
	                    if (oldVal.length !== newVal.length) {
	                      return true;
	                    }
	                    for (var i = 0; i < oldVal.length; i++) {
	                      if (oldVal[i] !== newVal[i]) {
	                        if (Lib.isPlainObject(oldVal[i]) && Lib.isPlainObject(newVal[i])) {
	                          if (diffConfig(oldVal[i], newVal[i])) {
	                            return true;
	                          }
	                        } else {
	                          return true;
	                        }
	                      }
	                    }
	                  } else {
	                    return true;
	                  }
	                }
	              }
	            }
	            function animate(gd, frameOrGroupNameOrFrameList, animationOpts) {
	              gd = Lib.getGraphDiv(gd);
	              if (!Lib.isPlotDiv(gd)) {
	                throw new Error("This element is not a Plotly plot: " + gd + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
	              }
	              var trans = gd._transitionData;
	              if (!trans._frameQueue) {
	                trans._frameQueue = [];
	              }
	              animationOpts = Plots.supplyAnimationDefaults(animationOpts);
	              var transitionOpts = animationOpts.transition;
	              var frameOpts = animationOpts.frame;
	              if (trans._frameWaitingCnt === undefined) {
	                trans._frameWaitingCnt = 0;
	              }
	              function getTransitionOpts(i) {
	                if (Array.isArray(transitionOpts)) {
	                  if (i >= transitionOpts.length) {
	                    return transitionOpts[0];
	                  } else {
	                    return transitionOpts[i];
	                  }
	                } else {
	                  return transitionOpts;
	                }
	              }
	              function getFrameOpts(i) {
	                if (Array.isArray(frameOpts)) {
	                  if (i >= frameOpts.length) {
	                    return frameOpts[0];
	                  } else {
	                    return frameOpts[i];
	                  }
	                } else {
	                  return frameOpts;
	                }
	              }
	              function callbackOnNthTime(cb, n) {
	                var cnt = 0;
	                return function() {
	                  if (cb && ++cnt === n) {
	                    return cb();
	                  }
	                };
	              }
	              return new Promise(function(resolve, reject) {
	                function discardExistingFrames() {
	                  if (trans._frameQueue.length === 0) {
	                    return;
	                  }
	                  while (trans._frameQueue.length) {
	                    var next = trans._frameQueue.pop();
	                    if (next.onInterrupt) {
	                      next.onInterrupt();
	                    }
	                  }
	                  gd.emit("plotly_animationinterrupted", []);
	                }
	                function queueFrames(frameList2) {
	                  if (frameList2.length === 0) return;
	                  for (var i2 = 0; i2 < frameList2.length; i2++) {
	                    var computedFrame;
	                    if (frameList2[i2].type === "byname") {
	                      computedFrame = Plots.computeFrame(gd, frameList2[i2].name);
	                    } else {
	                      computedFrame = frameList2[i2].data;
	                    }
	                    var frameOpts2 = getFrameOpts(i2);
	                    var transitionOpts2 = getTransitionOpts(i2);
	                    transitionOpts2.duration = Math.min(transitionOpts2.duration, frameOpts2.duration);
	                    var nextFrame2 = {
	                      frame: computedFrame,
	                      name: frameList2[i2].name,
	                      frameOpts: frameOpts2,
	                      transitionOpts: transitionOpts2
	                    };
	                    if (i2 === frameList2.length - 1) {
	                      nextFrame2.onComplete = callbackOnNthTime(resolve, 2);
	                      nextFrame2.onInterrupt = reject;
	                    }
	                    trans._frameQueue.push(nextFrame2);
	                  }
	                  if (animationOpts.mode === "immediate") {
	                    trans._lastFrameAt = -Infinity;
	                  }
	                  if (!trans._animationRaf) {
	                    beginAnimationLoop();
	                  }
	                }
	                function stopAnimationLoop() {
	                  gd.emit("plotly_animated");
	                  window.cancelAnimationFrame(trans._animationRaf);
	                  trans._animationRaf = null;
	                }
	                function nextFrame() {
	                  if (trans._currentFrame && trans._currentFrame.onComplete) {
	                    trans._currentFrame.onComplete();
	                  }
	                  var newFrame = trans._currentFrame = trans._frameQueue.shift();
	                  if (newFrame) {
	                    var stringName = newFrame.name ? newFrame.name.toString() : null;
	                    gd._fullLayout._currentFrame = stringName;
	                    trans._lastFrameAt = Date.now();
	                    trans._timeToNext = newFrame.frameOpts.duration;
	                    Plots.transition(gd, newFrame.frame.data, newFrame.frame.layout, helpers.coerceTraceIndices(gd, newFrame.frame.traces), newFrame.frameOpts, newFrame.transitionOpts).then(function() {
	                      if (newFrame.onComplete) {
	                        newFrame.onComplete();
	                      }
	                    });
	                    gd.emit("plotly_animatingframe", {
	                      name: stringName,
	                      frame: newFrame.frame,
	                      animation: {
	                        frame: newFrame.frameOpts,
	                        transition: newFrame.transitionOpts
	                      }
	                    });
	                  } else {
	                    stopAnimationLoop();
	                  }
	                }
	                function beginAnimationLoop() {
	                  gd.emit("plotly_animating");
	                  trans._lastFrameAt = -Infinity;
	                  trans._timeToNext = 0;
	                  trans._runningTransitions = 0;
	                  trans._currentFrame = null;
	                  var doFrame = function() {
	                    trans._animationRaf = window.requestAnimationFrame(doFrame);
	                    if (Date.now() - trans._lastFrameAt > trans._timeToNext) {
	                      nextFrame();
	                    }
	                  };
	                  doFrame();
	                }
	                var configCounter = 0;
	                function setTransitionConfig(frame2) {
	                  if (Array.isArray(transitionOpts)) {
	                    if (configCounter >= transitionOpts.length) {
	                      frame2.transitionOpts = transitionOpts[configCounter];
	                    } else {
	                      frame2.transitionOpts = transitionOpts[0];
	                    }
	                  } else {
	                    frame2.transitionOpts = transitionOpts;
	                  }
	                  configCounter++;
	                  return frame2;
	                }
	                var i, frame;
	                var frameList = [];
	                var allFrames = frameOrGroupNameOrFrameList === undefined || frameOrGroupNameOrFrameList === null;
	                var isFrameArray = Array.isArray(frameOrGroupNameOrFrameList);
	                var isSingleFrame = !allFrames && !isFrameArray && Lib.isPlainObject(frameOrGroupNameOrFrameList);
	                if (isSingleFrame) {
	                  frameList.push({
	                    type: "object",
	                    data: setTransitionConfig(Lib.extendFlat({}, frameOrGroupNameOrFrameList))
	                  });
	                } else if (allFrames || ["string", "number"].indexOf(typeof frameOrGroupNameOrFrameList) !== -1) {
	                  for (i = 0; i < trans._frames.length; i++) {
	                    frame = trans._frames[i];
	                    if (!frame) continue;
	                    if (allFrames || String(frame.group) === String(frameOrGroupNameOrFrameList)) {
	                      frameList.push({
	                        type: "byname",
	                        name: String(frame.name),
	                        data: setTransitionConfig({
	                          name: frame.name
	                        })
	                      });
	                    }
	                  }
	                } else if (isFrameArray) {
	                  for (i = 0; i < frameOrGroupNameOrFrameList.length; i++) {
	                    var frameOrName = frameOrGroupNameOrFrameList[i];
	                    if (["number", "string"].indexOf(typeof frameOrName) !== -1) {
	                      frameOrName = String(frameOrName);
	                      frameList.push({
	                        type: "byname",
	                        name: frameOrName,
	                        data: setTransitionConfig({
	                          name: frameOrName
	                        })
	                      });
	                    } else if (Lib.isPlainObject(frameOrName)) {
	                      frameList.push({
	                        type: "object",
	                        data: setTransitionConfig(Lib.extendFlat({}, frameOrName))
	                      });
	                    }
	                  }
	                }
	                for (i = 0; i < frameList.length; i++) {
	                  frame = frameList[i];
	                  if (frame.type === "byname" && !trans._frameHash[frame.data.name]) {
	                    Lib.warn('animate failure: frame not found: "' + frame.data.name + '"');
	                    reject();
	                    return;
	                  }
	                }
	                if (["next", "immediate"].indexOf(animationOpts.mode) !== -1) {
	                  discardExistingFrames();
	                }
	                if (animationOpts.direction === "reverse") {
	                  frameList.reverse();
	                }
	                var currentFrame = gd._fullLayout._currentFrame;
	                if (currentFrame && animationOpts.fromcurrent) {
	                  var idx = -1;
	                  for (i = 0; i < frameList.length; i++) {
	                    frame = frameList[i];
	                    if (frame.type === "byname" && frame.name === currentFrame) {
	                      idx = i;
	                      break;
	                    }
	                  }
	                  if (idx > 0 && idx < frameList.length - 1) {
	                    var filteredFrameList = [];
	                    for (i = 0; i < frameList.length; i++) {
	                      frame = frameList[i];
	                      if (frameList[i].type !== "byname" || i > idx) {
	                        filteredFrameList.push(frame);
	                      }
	                    }
	                    frameList = filteredFrameList;
	                  }
	                }
	                if (frameList.length > 0) {
	                  queueFrames(frameList);
	                } else {
	                  gd.emit("plotly_animated");
	                  resolve();
	                }
	              });
	            }
	            function addFrames(gd, frameList, indices) {
	              gd = Lib.getGraphDiv(gd);
	              if (frameList === null || frameList === undefined) {
	                return Promise.resolve();
	              }
	              if (!Lib.isPlotDiv(gd)) {
	                throw new Error("This element is not a Plotly plot: " + gd + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
	              }
	              var i, frame, j, idx;
	              var _frames = gd._transitionData._frames;
	              var _frameHash = gd._transitionData._frameHash;
	              if (!Array.isArray(frameList)) {
	                throw new Error("addFrames failure: frameList must be an Array of frame definitions" + frameList);
	              }
	              var bigIndex = _frames.length + frameList.length * 2;
	              var insertions = [];
	              var _frameHashLocal = {};
	              for (i = frameList.length - 1; i >= 0; i--) {
	                if (!Lib.isPlainObject(frameList[i])) continue;
	                var lookupName = frameList[i].name;
	                var name2 = (_frameHash[lookupName] || _frameHashLocal[lookupName] || {}).name;
	                var newName = frameList[i].name;
	                var collisionPresent = _frameHash[name2] || _frameHashLocal[name2];
	                if (name2 && newName && typeof newName === "number" && collisionPresent && numericNameWarningCount < numericNameWarningCountLimit) {
	                  numericNameWarningCount++;
	                  Lib.warn('addFrames: overwriting frame "' + (_frameHash[name2] || _frameHashLocal[name2]).name + '" with a frame whose name of type "number" also equates to "' + name2 + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.');
	                  if (numericNameWarningCount === numericNameWarningCountLimit) {
	                    Lib.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.");
	                  }
	                }
	                _frameHashLocal[lookupName] = {
	                  name: lookupName
	                };
	                insertions.push({
	                  frame: Plots.supplyFrameDefaults(frameList[i]),
	                  index: indices && indices[i] !== undefined && indices[i] !== null ? indices[i] : bigIndex + i
	                });
	              }
	              insertions.sort(function(a, b) {
	                if (a.index > b.index) return -1;
	                if (a.index < b.index) return 1;
	                return 0;
	              });
	              var ops = [];
	              var revops = [];
	              var frameCount = _frames.length;
	              for (i = insertions.length - 1; i >= 0; i--) {
	                frame = insertions[i].frame;
	                if (typeof frame.name === "number") {
	                  Lib.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings");
	                }
	                if (!frame.name) {
	                  while (_frameHash[frame.name = "frame " + gd._transitionData._counter++]) ;
	                }
	                if (_frameHash[frame.name]) {
	                  for (j = 0; j < _frames.length; j++) {
	                    if ((_frames[j] || {}).name === frame.name) break;
	                  }
	                  ops.push({
	                    type: "replace",
	                    index: j,
	                    value: frame
	                  });
	                  revops.unshift({
	                    type: "replace",
	                    index: j,
	                    value: _frames[j]
	                  });
	                } else {
	                  idx = Math.max(0, Math.min(insertions[i].index, frameCount));
	                  ops.push({
	                    type: "insert",
	                    index: idx,
	                    value: frame
	                  });
	                  revops.unshift({
	                    type: "delete",
	                    index: idx
	                  });
	                  frameCount++;
	                }
	              }
	              var undoFunc = Plots.modifyFrames;
	              var redoFunc = Plots.modifyFrames;
	              var undoArgs = [gd, revops];
	              var redoArgs = [gd, ops];
	              if (Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	              return Plots.modifyFrames(gd, ops);
	            }
	            function deleteFrames(gd, frameList) {
	              gd = Lib.getGraphDiv(gd);
	              if (!Lib.isPlotDiv(gd)) {
	                throw new Error("This element is not a Plotly plot: " + gd);
	              }
	              var i, idx;
	              var _frames = gd._transitionData._frames;
	              var ops = [];
	              var revops = [];
	              if (!frameList) {
	                frameList = [];
	                for (i = 0; i < _frames.length; i++) {
	                  frameList.push(i);
	                }
	              }
	              frameList = frameList.slice();
	              frameList.sort();
	              for (i = frameList.length - 1; i >= 0; i--) {
	                idx = frameList[i];
	                ops.push({
	                  type: "delete",
	                  index: idx
	                });
	                revops.unshift({
	                  type: "insert",
	                  index: idx,
	                  value: _frames[idx]
	                });
	              }
	              var undoFunc = Plots.modifyFrames;
	              var redoFunc = Plots.modifyFrames;
	              var undoArgs = [gd, revops];
	              var redoArgs = [gd, ops];
	              if (Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
	              return Plots.modifyFrames(gd, ops);
	            }
	            function purge(gd) {
	              gd = Lib.getGraphDiv(gd);
	              var fullLayout = gd._fullLayout || {};
	              var fullData = gd._fullData || [];
	              Plots.cleanPlot([], {}, fullData, fullLayout);
	              Plots.purge(gd);
	              Events.purge(gd);
	              if (fullLayout._container) fullLayout._container.remove();
	              delete gd._context;
	              return gd;
	            }
	            function calcInverseTransform(gd) {
	              var fullLayout = gd._fullLayout;
	              var newBBox = gd.getBoundingClientRect();
	              if (Lib.equalDomRects(newBBox, fullLayout._lastBBox)) return;
	              var m = fullLayout._invTransform = Lib.inverseTransformMatrix(Lib.getFullTransformMatrix(gd));
	              fullLayout._invScaleX = Math.sqrt(m[0][0] * m[0][0] + m[0][1] * m[0][1] + m[0][2] * m[0][2]);
	              fullLayout._invScaleY = Math.sqrt(m[1][0] * m[1][0] + m[1][1] * m[1][1] + m[1][2] * m[1][2]);
	              fullLayout._lastBBox = newBBox;
	            }
	            function makePlotFramework(gd) {
	              var gd3 = d3.select(gd);
	              var fullLayout = gd._fullLayout;
	              fullLayout._calcInverseTransform = calcInverseTransform;
	              fullLayout._calcInverseTransform(gd);
	              fullLayout._container = gd3.selectAll(".plot-container").data([0]);
	              fullLayout._container.enter().insert("div", ":first-child").classed("plot-container", true).classed("plotly", true);
	              fullLayout._paperdiv = fullLayout._container.selectAll(".svg-container").data([0]);
	              fullLayout._paperdiv.enter().append("div").classed("user-select-none", true).classed("svg-container", true).style("position", "relative");
	              fullLayout._glcontainer = fullLayout._paperdiv.selectAll(".gl-container").data([{}]);
	              fullLayout._glcontainer.enter().append("div").classed("gl-container", true);
	              fullLayout._paperdiv.selectAll(".main-svg").remove();
	              fullLayout._paperdiv.select(".modebar-container").remove();
	              fullLayout._paper = fullLayout._paperdiv.insert("svg", ":first-child").classed("main-svg", true);
	              fullLayout._toppaper = fullLayout._paperdiv.append("svg").classed("main-svg", true);
	              fullLayout._modebardiv = fullLayout._paperdiv.append("div");
	              delete fullLayout._modeBar;
	              fullLayout._hoverpaper = fullLayout._paperdiv.append("svg").classed("main-svg", true);
	              if (!fullLayout._uid) {
	                var otherUids = {};
	                d3.selectAll("defs").each(function() {
	                  if (this.id) otherUids[this.id.split("-")[1]] = 1;
	                });
	                fullLayout._uid = Lib.randstr(otherUids);
	              }
	              fullLayout._paperdiv.selectAll(".main-svg").attr(xmlnsNamespaces.svgAttrs);
	              fullLayout._defs = fullLayout._paper.append("defs").attr("id", "defs-" + fullLayout._uid);
	              fullLayout._clips = fullLayout._defs.append("g").classed("clips", true);
	              fullLayout._topdefs = fullLayout._toppaper.append("defs").attr("id", "topdefs-" + fullLayout._uid);
	              fullLayout._topclips = fullLayout._topdefs.append("g").classed("clips", true);
	              fullLayout._bgLayer = fullLayout._paper.append("g").classed("bglayer", true);
	              fullLayout._draggers = fullLayout._paper.append("g").classed("draglayer", true);
	              var layerBelow = fullLayout._paper.append("g").classed("layer-below", true);
	              fullLayout._imageLowerLayer = layerBelow.append("g").classed("imagelayer", true);
	              fullLayout._shapeLowerLayer = layerBelow.append("g").classed("shapelayer", true);
	              fullLayout._cartesianlayer = fullLayout._paper.append("g").classed("cartesianlayer", true);
	              fullLayout._polarlayer = fullLayout._paper.append("g").classed("polarlayer", true);
	              fullLayout._smithlayer = fullLayout._paper.append("g").classed("smithlayer", true);
	              fullLayout._ternarylayer = fullLayout._paper.append("g").classed("ternarylayer", true);
	              fullLayout._geolayer = fullLayout._paper.append("g").classed("geolayer", true);
	              fullLayout._funnelarealayer = fullLayout._paper.append("g").classed("funnelarealayer", true);
	              fullLayout._pielayer = fullLayout._paper.append("g").classed("pielayer", true);
	              fullLayout._iciclelayer = fullLayout._paper.append("g").classed("iciclelayer", true);
	              fullLayout._treemaplayer = fullLayout._paper.append("g").classed("treemaplayer", true);
	              fullLayout._sunburstlayer = fullLayout._paper.append("g").classed("sunburstlayer", true);
	              fullLayout._indicatorlayer = fullLayout._toppaper.append("g").classed("indicatorlayer", true);
	              fullLayout._glimages = fullLayout._paper.append("g").classed("glimages", true);
	              var layerAbove = fullLayout._toppaper.append("g").classed("layer-above", true);
	              fullLayout._imageUpperLayer = layerAbove.append("g").classed("imagelayer", true);
	              fullLayout._shapeUpperLayer = layerAbove.append("g").classed("shapelayer", true);
	              fullLayout._selectionLayer = fullLayout._toppaper.append("g").classed("selectionlayer", true);
	              fullLayout._infolayer = fullLayout._toppaper.append("g").classed("infolayer", true);
	              fullLayout._menulayer = fullLayout._toppaper.append("g").classed("menulayer", true);
	              fullLayout._zoomlayer = fullLayout._toppaper.append("g").classed("zoomlayer", true);
	              fullLayout._hoverlayer = fullLayout._hoverpaper.append("g").classed("hoverlayer", true);
	              fullLayout._modebardiv.classed("modebar-container", true).style("position", "absolute").style("top", "0px").style("right", "0px");
	              gd.emit("plotly_framework");
	            }
	            exports2.animate = animate;
	            exports2.addFrames = addFrames;
	            exports2.deleteFrames = deleteFrames;
	            exports2.addTraces = addTraces;
	            exports2.deleteTraces = deleteTraces;
	            exports2.extendTraces = extendTraces;
	            exports2.moveTraces = moveTraces;
	            exports2.prependTraces = prependTraces;
	            exports2.newPlot = newPlot;
	            exports2._doPlot = _doPlot;
	            exports2.purge = purge;
	            exports2.react = react;
	            exports2.redraw = redraw;
	            exports2.relayout = relayout;
	            exports2.restyle = restyle;
	            exports2.setPlotConfig = setPlotConfig;
	            exports2.update = update;
	            exports2._guiRelayout = guiEdit(relayout);
	            exports2._guiRestyle = guiEdit(restyle);
	            exports2._guiUpdate = guiEdit(update);
	            exports2._storeDirectGUIEdit = _storeDirectGUIEdit;
	          }
	        ),
	        /***/
	        72075: (
	          /***/
	          function(module2) {
	            var configAttributes = {
	              staticPlot: {
	                valType: "boolean",
	                dflt: false
	              },
	              typesetMath: {
	                valType: "boolean",
	                dflt: true
	              },
	              plotlyServerURL: {
	                valType: "string",
	                dflt: ""
	              },
	              editable: {
	                valType: "boolean",
	                dflt: false
	              },
	              edits: {
	                annotationPosition: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                annotationTail: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                annotationText: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                axisTitleText: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                colorbarPosition: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                colorbarTitleText: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                legendPosition: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                legendText: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                shapePosition: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                titleText: {
	                  valType: "boolean",
	                  dflt: false
	                }
	              },
	              editSelection: {
	                valType: "boolean",
	                dflt: true
	              },
	              autosizable: {
	                valType: "boolean",
	                dflt: false
	              },
	              responsive: {
	                valType: "boolean",
	                dflt: false
	              },
	              fillFrame: {
	                valType: "boolean",
	                dflt: false
	              },
	              frameMargins: {
	                valType: "number",
	                dflt: 0,
	                min: 0,
	                max: 0.5
	              },
	              scrollZoom: {
	                valType: "flaglist",
	                flags: ["cartesian", "gl3d", "geo", "mapbox"],
	                extras: [true, false],
	                dflt: "gl3d+geo+mapbox"
	              },
	              doubleClick: {
	                valType: "enumerated",
	                values: [false, "reset", "autosize", "reset+autosize"],
	                dflt: "reset+autosize"
	              },
	              doubleClickDelay: {
	                valType: "number",
	                dflt: 300,
	                min: 0
	              },
	              showAxisDragHandles: {
	                valType: "boolean",
	                dflt: true
	              },
	              showAxisRangeEntryBoxes: {
	                valType: "boolean",
	                dflt: true
	              },
	              showTips: {
	                valType: "boolean",
	                dflt: true
	              },
	              showLink: {
	                valType: "boolean",
	                dflt: false
	              },
	              linkText: {
	                valType: "string",
	                dflt: "Edit chart",
	                noBlank: true
	              },
	              sendData: {
	                valType: "boolean",
	                dflt: true
	              },
	              showSources: {
	                valType: "any",
	                dflt: false
	              },
	              displayModeBar: {
	                valType: "enumerated",
	                values: ["hover", true, false],
	                dflt: "hover"
	              },
	              showSendToCloud: {
	                valType: "boolean",
	                dflt: false
	              },
	              showEditInChartStudio: {
	                valType: "boolean",
	                dflt: false
	              },
	              modeBarButtonsToRemove: {
	                valType: "any",
	                dflt: []
	              },
	              modeBarButtonsToAdd: {
	                valType: "any",
	                dflt: []
	              },
	              modeBarButtons: {
	                valType: "any",
	                dflt: false
	              },
	              toImageButtonOptions: {
	                valType: "any",
	                dflt: {}
	              },
	              displaylogo: {
	                valType: "boolean",
	                dflt: true
	              },
	              watermark: {
	                valType: "boolean",
	                dflt: false
	              },
	              plotGlPixelRatio: {
	                valType: "number",
	                dflt: 2,
	                min: 1,
	                max: 4
	              },
	              setBackground: {
	                valType: "any",
	                dflt: "transparent"
	              },
	              topojsonURL: {
	                valType: "string",
	                noBlank: true,
	                dflt: "https://cdn.plot.ly/"
	              },
	              mapboxAccessToken: {
	                valType: "string",
	                dflt: null
	              },
	              logging: {
	                valType: "integer",
	                min: 0,
	                max: 2,
	                dflt: 1
	              },
	              notifyOnLogging: {
	                valType: "integer",
	                min: 0,
	                max: 2,
	                dflt: 0
	              },
	              queueLength: {
	                valType: "integer",
	                min: 0,
	                dflt: 0
	              },
	              globalTransforms: {
	                valType: "any",
	                dflt: []
	              },
	              locale: {
	                valType: "string",
	                dflt: "en-US"
	              },
	              locales: {
	                valType: "any",
	                dflt: {}
	              }
	            };
	            var dfltConfig = {};
	            function crawl(src, target) {
	              for (var k in src) {
	                var obj = src[k];
	                if (obj.valType) {
	                  target[k] = obj.dflt;
	                } else {
	                  if (!target[k]) {
	                    target[k] = {};
	                  }
	                  crawl(obj, target[k]);
	                }
	              }
	            }
	            crawl(configAttributes, dfltConfig);
	            module2.exports = {
	              configAttributes,
	              dfltConfig
	            };
	          }
	        ),
	        /***/
	        86281: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var baseAttributes = __webpack_require__2(9012);
	            var baseLayoutAttributes = __webpack_require__2(10820);
	            var frameAttributes = __webpack_require__2(31391);
	            var animationAttributes = __webpack_require__2(85594);
	            var configAttributes = __webpack_require__2(72075).configAttributes;
	            var editTypes = __webpack_require__2(30962);
	            var extendDeepAll = Lib.extendDeepAll;
	            var isPlainObject = Lib.isPlainObject;
	            var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	            var nestedProperty = Lib.nestedProperty;
	            var valObjectMeta = Lib.valObjectMeta;
	            var IS_SUBPLOT_OBJ = "_isSubplotObj";
	            var IS_LINKED_TO_ARRAY = "_isLinkedToArray";
	            var ARRAY_ATTR_REGEXPS = "_arrayAttrRegexps";
	            var DEPRECATED = "_deprecated";
	            var UNDERSCORE_ATTRS = [IS_SUBPLOT_OBJ, IS_LINKED_TO_ARRAY, ARRAY_ATTR_REGEXPS, DEPRECATED];
	            exports2.IS_SUBPLOT_OBJ = IS_SUBPLOT_OBJ;
	            exports2.IS_LINKED_TO_ARRAY = IS_LINKED_TO_ARRAY;
	            exports2.DEPRECATED = DEPRECATED;
	            exports2.UNDERSCORE_ATTRS = UNDERSCORE_ATTRS;
	            exports2.get = function() {
	              var traces = {};
	              Registry.allTypes.forEach(function(type) {
	                traces[type] = getTraceAttributes(type);
	              });
	              var transforms = {};
	              Object.keys(Registry.transformsRegistry).forEach(function(type) {
	                transforms[type] = getTransformAttributes(type);
	              });
	              return {
	                defs: {
	                  valObjects: valObjectMeta,
	                  metaKeys: UNDERSCORE_ATTRS.concat(["description", "role", "editType", "impliedEdits"]),
	                  editType: {
	                    traces: editTypes.traces,
	                    layout: editTypes.layout
	                  },
	                  impliedEdits: {}
	                },
	                traces,
	                layout: getLayoutAttributes(),
	                transforms,
	                frames: getFramesAttributes(),
	                animation: formatAttributes(animationAttributes),
	                config: formatAttributes(configAttributes)
	              };
	            };
	            exports2.crawl = function(attrs, callback, specifiedLevel, attrString) {
	              var level = specifiedLevel || 0;
	              attrString = attrString || "";
	              Object.keys(attrs).forEach(function(attrName) {
	                var attr = attrs[attrName];
	                if (UNDERSCORE_ATTRS.indexOf(attrName) !== -1) return;
	                var fullAttrString = (attrString ? attrString + "." : "") + attrName;
	                callback(attr, attrName, attrs, level, fullAttrString);
	                if (exports2.isValObject(attr)) return;
	                if (isPlainObject(attr) && attrName !== "impliedEdits") {
	                  exports2.crawl(attr, callback, level + 1, fullAttrString);
	                }
	              });
	            };
	            exports2.isValObject = function(obj) {
	              return obj && obj.valType !== undefined;
	            };
	            exports2.findArrayAttributes = function(trace) {
	              var arrayAttributes = [];
	              var stack = [];
	              var isArrayStack = [];
	              var baseContainer, baseAttrName;
	              function callback(attr, attrName, attrs, level) {
	                stack = stack.slice(0, level).concat([attrName]);
	                isArrayStack = isArrayStack.slice(0, level).concat([attr && attr._isLinkedToArray]);
	                var splittableAttr = attr && (attr.valType === "data_array" || attr.arrayOk === true) && !(stack[level - 1] === "colorbar" && (attrName === "ticktext" || attrName === "tickvals"));
	                if (!splittableAttr) return;
	                crawlIntoTrace(baseContainer, 0, "");
	              }
	              function crawlIntoTrace(container, i2, astrPartial) {
	                var item = container[stack[i2]];
	                var newAstrPartial = astrPartial + stack[i2];
	                if (i2 === stack.length - 1) {
	                  if (isArrayOrTypedArray(item)) {
	                    arrayAttributes.push(baseAttrName + newAstrPartial);
	                  }
	                } else {
	                  if (isArrayStack[i2]) {
	                    if (Array.isArray(item)) {
	                      for (var j = 0; j < item.length; j++) {
	                        if (isPlainObject(item[j])) {
	                          crawlIntoTrace(item[j], i2 + 1, newAstrPartial + "[" + j + "].");
	                        }
	                      }
	                    }
	                  } else if (isPlainObject(item)) {
	                    crawlIntoTrace(item, i2 + 1, newAstrPartial + ".");
	                  }
	                }
	              }
	              baseContainer = trace;
	              baseAttrName = "";
	              exports2.crawl(baseAttributes, callback);
	              if (trace._module && trace._module.attributes) {
	                exports2.crawl(trace._module.attributes, callback);
	              }
	              var transforms = trace.transforms;
	              if (transforms) {
	                for (var i = 0; i < transforms.length; i++) {
	                  var transform = transforms[i];
	                  var module2 = transform._module;
	                  if (module2) {
	                    baseAttrName = "transforms[" + i + "].";
	                    baseContainer = transform;
	                    exports2.crawl(module2.attributes, callback);
	                  }
	                }
	              }
	              return arrayAttributes;
	            };
	            exports2.getTraceValObject = function(trace, parts) {
	              var head = parts[0];
	              var i = 1;
	              var moduleAttrs, valObject;
	              if (head === "transforms") {
	                if (parts.length === 1) {
	                  return baseAttributes.transforms;
	                }
	                var transforms = trace.transforms;
	                if (!Array.isArray(transforms) || !transforms.length) return false;
	                var tNum = parts[1];
	                if (!isIndex(tNum) || tNum >= transforms.length) {
	                  return false;
	                }
	                moduleAttrs = (Registry.transformsRegistry[transforms[tNum].type] || {}).attributes;
	                valObject = moduleAttrs && moduleAttrs[parts[2]];
	                i = 3;
	              } else {
	                var _module = trace._module;
	                if (!_module) _module = (Registry.modules[trace.type || baseAttributes.type.dflt] || {})._module;
	                if (!_module) return false;
	                moduleAttrs = _module.attributes;
	                valObject = moduleAttrs && moduleAttrs[head];
	                if (!valObject) {
	                  var subplotModule = _module.basePlotModule;
	                  if (subplotModule && subplotModule.attributes) {
	                    valObject = subplotModule.attributes[head];
	                  }
	                }
	                if (!valObject) valObject = baseAttributes[head];
	              }
	              return recurseIntoValObject(valObject, parts, i);
	            };
	            exports2.getLayoutValObject = function(fullLayout, parts) {
	              var valObject = layoutHeadAttr(fullLayout, parts[0]);
	              return recurseIntoValObject(valObject, parts, 1);
	            };
	            function layoutHeadAttr(fullLayout, head) {
	              var i, key, _module, attributes;
	              var basePlotModules = fullLayout._basePlotModules;
	              if (basePlotModules) {
	                var out;
	                for (i = 0; i < basePlotModules.length; i++) {
	                  _module = basePlotModules[i];
	                  if (_module.attrRegex && _module.attrRegex.test(head)) {
	                    if (_module.layoutAttrOverrides) return _module.layoutAttrOverrides;
	                    if (!out && _module.layoutAttributes) out = _module.layoutAttributes;
	                  }
	                  var baseOverrides = _module.baseLayoutAttrOverrides;
	                  if (baseOverrides && head in baseOverrides) return baseOverrides[head];
	                }
	                if (out) return out;
	              }
	              var modules = fullLayout._modules;
	              if (modules) {
	                for (i = 0; i < modules.length; i++) {
	                  attributes = modules[i].layoutAttributes;
	                  if (attributes && head in attributes) {
	                    return attributes[head];
	                  }
	                }
	              }
	              for (key in Registry.componentsRegistry) {
	                _module = Registry.componentsRegistry[key];
	                if (_module.name === "colorscale" && head.indexOf("coloraxis") === 0) {
	                  return _module.layoutAttributes[head];
	                } else if (!_module.schema && head === _module.name) {
	                  return _module.layoutAttributes;
	                }
	              }
	              if (head in baseLayoutAttributes) return baseLayoutAttributes[head];
	              return false;
	            }
	            function recurseIntoValObject(valObject, parts, i) {
	              if (!valObject) return false;
	              if (valObject._isLinkedToArray) {
	                if (isIndex(parts[i])) i++;
	                else if (i < parts.length) return false;
	              }
	              for (; i < parts.length; i++) {
	                var newValObject = valObject[parts[i]];
	                if (isPlainObject(newValObject)) valObject = newValObject;
	                else break;
	                if (i === parts.length - 1) break;
	                if (valObject._isLinkedToArray) {
	                  i++;
	                  if (!isIndex(parts[i])) return false;
	                } else if (valObject.valType === "info_array") {
	                  i++;
	                  var index = parts[i];
	                  if (!isIndex(index)) return false;
	                  var items = valObject.items;
	                  if (Array.isArray(items)) {
	                    if (index >= items.length) return false;
	                    if (valObject.dimensions === 2) {
	                      i++;
	                      if (parts.length === i) return valObject;
	                      var index2 = parts[i];
	                      if (!isIndex(index2)) return false;
	                      valObject = items[index][index2];
	                    } else valObject = items[index];
	                  } else {
	                    valObject = items;
	                  }
	                }
	              }
	              return valObject;
	            }
	            function isIndex(val) {
	              return val === Math.round(val) && val >= 0;
	            }
	            function getTraceAttributes(type) {
	              var _module, basePlotModule;
	              _module = Registry.modules[type]._module, basePlotModule = _module.basePlotModule;
	              var attributes = {};
	              attributes.type = null;
	              var copyBaseAttributes = extendDeepAll({}, baseAttributes);
	              var copyModuleAttributes = extendDeepAll({}, _module.attributes);
	              exports2.crawl(copyModuleAttributes, function(attr, attrName, attrs, level, fullAttrString) {
	                nestedProperty(copyBaseAttributes, fullAttrString).set(undefined);
	                if (attr === undefined) nestedProperty(copyModuleAttributes, fullAttrString).set(undefined);
	              });
	              extendDeepAll(attributes, copyBaseAttributes);
	              if (Registry.traceIs(type, "noOpacity")) {
	                delete attributes.opacity;
	              }
	              if (!Registry.traceIs(type, "showLegend")) {
	                delete attributes.showlegend;
	                delete attributes.legendgroup;
	              }
	              if (Registry.traceIs(type, "noHover")) {
	                delete attributes.hoverinfo;
	                delete attributes.hoverlabel;
	              }
	              if (!_module.selectPoints) {
	                delete attributes.selectedpoints;
	              }
	              extendDeepAll(attributes, copyModuleAttributes);
	              if (basePlotModule.attributes) {
	                extendDeepAll(attributes, basePlotModule.attributes);
	              }
	              attributes.type = type;
	              var out = {
	                meta: _module.meta || {},
	                categories: _module.categories || {},
	                animatable: Boolean(_module.animatable),
	                type,
	                attributes: formatAttributes(attributes)
	              };
	              if (_module.layoutAttributes) {
	                var layoutAttributes = {};
	                extendDeepAll(layoutAttributes, _module.layoutAttributes);
	                out.layoutAttributes = formatAttributes(layoutAttributes);
	              }
	              if (!_module.animatable) {
	                exports2.crawl(out, function(attr) {
	                  if (exports2.isValObject(attr) && "anim" in attr) {
	                    delete attr.anim;
	                  }
	                });
	              }
	              return out;
	            }
	            function getLayoutAttributes() {
	              var layoutAttributes = {};
	              var key, _module;
	              extendDeepAll(layoutAttributes, baseLayoutAttributes);
	              for (key in Registry.subplotsRegistry) {
	                _module = Registry.subplotsRegistry[key];
	                if (!_module.layoutAttributes) continue;
	                if (Array.isArray(_module.attr)) {
	                  for (var i = 0; i < _module.attr.length; i++) {
	                    handleBasePlotModule(layoutAttributes, _module, _module.attr[i]);
	                  }
	                } else {
	                  var astr = _module.attr === "subplot" ? _module.name : _module.attr;
	                  handleBasePlotModule(layoutAttributes, _module, astr);
	                }
	              }
	              for (key in Registry.componentsRegistry) {
	                _module = Registry.componentsRegistry[key];
	                var schema = _module.schema;
	                if (schema && (schema.subplots || schema.layout)) {
	                  var subplots = schema.subplots;
	                  if (subplots && subplots.xaxis && !subplots.yaxis) {
	                    for (var xkey in subplots.xaxis) {
	                      delete layoutAttributes.yaxis[xkey];
	                    }
	                  }
	                  delete layoutAttributes.xaxis.shift;
	                  delete layoutAttributes.xaxis.autoshift;
	                } else if (_module.name === "colorscale") {
	                  extendDeepAll(layoutAttributes, _module.layoutAttributes);
	                } else if (_module.layoutAttributes) {
	                  insertAttrs(layoutAttributes, _module.layoutAttributes, _module.name);
	                }
	              }
	              return {
	                layoutAttributes: formatAttributes(layoutAttributes)
	              };
	            }
	            function getTransformAttributes(type) {
	              var _module = Registry.transformsRegistry[type];
	              var attributes = extendDeepAll({}, _module.attributes);
	              Object.keys(Registry.componentsRegistry).forEach(function(k) {
	                var _module2 = Registry.componentsRegistry[k];
	                if (_module2.schema && _module2.schema.transforms && _module2.schema.transforms[type]) {
	                  Object.keys(_module2.schema.transforms[type]).forEach(function(v) {
	                    insertAttrs(attributes, _module2.schema.transforms[type][v], v);
	                  });
	                }
	              });
	              return {
	                attributes: formatAttributes(attributes)
	              };
	            }
	            function getFramesAttributes() {
	              var attrs = {
	                frames: extendDeepAll({}, frameAttributes)
	              };
	              formatAttributes(attrs);
	              return attrs.frames;
	            }
	            function formatAttributes(attrs) {
	              mergeValTypeAndRole(attrs);
	              formatArrayContainers(attrs);
	              stringify(attrs);
	              return attrs;
	            }
	            function mergeValTypeAndRole(attrs) {
	              function makeSrcAttr(attrName) {
	                return {
	                  valType: "string",
	                  editType: "none"
	                };
	              }
	              function callback(attr, attrName, attrs2) {
	                if (exports2.isValObject(attr)) {
	                  if (attr.arrayOk === true || attr.valType === "data_array") {
	                    attrs2[attrName + "src"] = makeSrcAttr();
	                  }
	                } else if (isPlainObject(attr)) {
	                  attr.role = "object";
	                }
	              }
	              exports2.crawl(attrs, callback);
	            }
	            function formatArrayContainers(attrs) {
	              function callback(attr, attrName, attrs2) {
	                if (!attr) return;
	                var itemName = attr[IS_LINKED_TO_ARRAY];
	                if (!itemName) return;
	                delete attr[IS_LINKED_TO_ARRAY];
	                attrs2[attrName] = {
	                  items: {}
	                };
	                attrs2[attrName].items[itemName] = attr;
	                attrs2[attrName].role = "object";
	              }
	              exports2.crawl(attrs, callback);
	            }
	            function stringify(attrs) {
	              function walk(attr) {
	                for (var k in attr) {
	                  if (isPlainObject(attr[k])) {
	                    walk(attr[k]);
	                  } else if (Array.isArray(attr[k])) {
	                    for (var i = 0; i < attr[k].length; i++) {
	                      walk(attr[k][i]);
	                    }
	                  } else {
	                    if (attr[k] instanceof RegExp) {
	                      attr[k] = attr[k].toString();
	                    }
	                  }
	                }
	              }
	              walk(attrs);
	            }
	            function handleBasePlotModule(layoutAttributes, _module, astr) {
	              var np = nestedProperty(layoutAttributes, astr);
	              var attrs = extendDeepAll({}, _module.layoutAttributes);
	              attrs[IS_SUBPLOT_OBJ] = true;
	              np.set(attrs);
	            }
	            function insertAttrs(baseAttrs, newAttrs, astr) {
	              var np = nestedProperty(baseAttrs, astr);
	              np.set(extendDeepAll(np.get() || {}, newAttrs));
	            }
	          }
	        ),
	        /***/
	        44467: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var plotAttributes = __webpack_require__2(9012);
	            var TEMPLATEITEMNAME = "templateitemname";
	            var templateAttrs = {
	              name: {
	                valType: "string",
	                editType: "none"
	              }
	            };
	            templateAttrs[TEMPLATEITEMNAME] = {
	              valType: "string",
	              editType: "calc"
	            };
	            exports2.templatedArray = function(name2, attrs) {
	              attrs._isLinkedToArray = name2;
	              attrs.name = templateAttrs.name;
	              attrs[TEMPLATEITEMNAME] = templateAttrs[TEMPLATEITEMNAME];
	              return attrs;
	            };
	            exports2.traceTemplater = function(dataTemplate) {
	              var traceCounts = {};
	              var traceType, typeTemplates;
	              for (traceType in dataTemplate) {
	                typeTemplates = dataTemplate[traceType];
	                if (Array.isArray(typeTemplates) && typeTemplates.length) {
	                  traceCounts[traceType] = 0;
	                }
	              }
	              function newTrace(traceIn) {
	                traceType = Lib.coerce(traceIn, {}, plotAttributes, "type");
	                var traceOut = {
	                  type: traceType,
	                  _template: null
	                };
	                if (traceType in traceCounts) {
	                  typeTemplates = dataTemplate[traceType];
	                  var typei = traceCounts[traceType] % typeTemplates.length;
	                  traceCounts[traceType]++;
	                  traceOut._template = typeTemplates[typei];
	                }
	                return traceOut;
	              }
	              return {
	                newTrace
	                // TODO: function to figure out what's left & what didn't work
	              };
	            };
	            exports2.newContainer = function(container, name2, baseName) {
	              var template = container._template;
	              var part = template && (template[name2] || baseName && template[baseName]);
	              if (!Lib.isPlainObject(part)) part = null;
	              var out = container[name2] = {
	                _template: part
	              };
	              return out;
	            };
	            exports2.arrayTemplater = function(container, name2, inclusionAttr) {
	              var template = container._template;
	              var defaultsTemplate = template && template[arrayDefaultKey(name2)];
	              var templateItems = template && template[name2];
	              if (!Array.isArray(templateItems) || !templateItems.length) {
	                templateItems = [];
	              }
	              var usedNames = {};
	              function newItem(itemIn) {
	                var out = {
	                  name: itemIn.name,
	                  _input: itemIn
	                };
	                var templateItemName = out[TEMPLATEITEMNAME] = itemIn[TEMPLATEITEMNAME];
	                if (!validItemName(templateItemName)) {
	                  out._template = defaultsTemplate;
	                  return out;
	                }
	                for (var i = 0; i < templateItems.length; i++) {
	                  var templateItem = templateItems[i];
	                  if (templateItem.name === templateItemName) {
	                    usedNames[templateItemName] = 1;
	                    out._template = templateItem;
	                    return out;
	                  }
	                }
	                out[inclusionAttr] = itemIn[inclusionAttr] || false;
	                out._template = false;
	                return out;
	              }
	              function defaultItems() {
	                var out = [];
	                for (var i = 0; i < templateItems.length; i++) {
	                  var templateItem = templateItems[i];
	                  var name3 = templateItem.name;
	                  if (validItemName(name3) && !usedNames[name3]) {
	                    var outi = {
	                      _template: templateItem,
	                      name: name3,
	                      _input: {
	                        _templateitemname: name3
	                      }
	                    };
	                    outi[TEMPLATEITEMNAME] = templateItem[TEMPLATEITEMNAME];
	                    out.push(outi);
	                    usedNames[name3] = 1;
	                  }
	                }
	                return out;
	              }
	              return {
	                newItem,
	                defaultItems
	              };
	            };
	            function validItemName(name2) {
	              return name2 && typeof name2 === "string";
	            }
	            function arrayDefaultKey(name2) {
	              var lastChar = name2.length - 1;
	              if (name2.charAt(lastChar) !== "s") {
	                Lib.warn("bad argument to arrayDefaultKey: " + name2);
	              }
	              return name2.substr(0, name2.length - 1) + "defaults";
	            }
	            exports2.arrayDefaultKey = arrayDefaultKey;
	            exports2.arrayEditor = function(parentIn, containerStr, itemOut) {
	              var lengthIn = (Lib.nestedProperty(parentIn, containerStr).get() || []).length;
	              var index = itemOut._index;
	              var templateItemName = index >= lengthIn && (itemOut._input || {})._templateitemname;
	              if (templateItemName) index = lengthIn;
	              var itemStr = containerStr + "[" + index + "]";
	              var update;
	              function resetUpdate() {
	                update = {};
	                if (templateItemName) {
	                  update[itemStr] = {};
	                  update[itemStr][TEMPLATEITEMNAME] = templateItemName;
	                }
	              }
	              resetUpdate();
	              function modifyBase(attr, value) {
	                update[attr] = value;
	              }
	              function modifyItem(attr, value) {
	                if (templateItemName) {
	                  Lib.nestedProperty(update[itemStr], attr).set(value);
	                } else {
	                  update[itemStr + "." + attr] = value;
	                }
	              }
	              function getUpdateObj() {
	                var updateOut = update;
	                resetUpdate();
	                return updateOut;
	              }
	              function applyUpdate(attr, value) {
	                if (attr) modifyItem(attr, value);
	                var updateToApply = getUpdateObj();
	                for (var key in updateToApply) {
	                  Lib.nestedProperty(parentIn, key).set(updateToApply[key]);
	                }
	              }
	              return {
	                modifyBase,
	                modifyItem,
	                getUpdateObj,
	                applyUpdate
	              };
	            };
	          }
	        ),
	        /***/
	        61549: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Plots = __webpack_require__2(74875);
	            var Lib = __webpack_require__2(71828);
	            var svgTextUtils = __webpack_require__2(63893);
	            var clearGlCanvases = __webpack_require__2(33306);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Titles = __webpack_require__2(92998);
	            var ModeBar = __webpack_require__2(64168);
	            var Axes = __webpack_require__2(89298);
	            var alignmentConstants = __webpack_require__2(18783);
	            var axisConstraints = __webpack_require__2(99082);
	            var enforceAxisConstraints = axisConstraints.enforce;
	            var cleanAxisConstraints = axisConstraints.clean;
	            var doAutoRange = __webpack_require__2(71739).doAutoRange;
	            var SVG_TEXT_ANCHOR_START = "start";
	            var SVG_TEXT_ANCHOR_MIDDLE = "middle";
	            var SVG_TEXT_ANCHOR_END = "end";
	            exports2.layoutStyles = function(gd) {
	              return Lib.syncOrAsync([Plots.doAutoMargin, lsInner], gd);
	            };
	            function overlappingDomain(xDomain, yDomain, domains) {
	              for (var i = 0; i < domains.length; i++) {
	                var existingX = domains[i][0];
	                var existingY = domains[i][1];
	                if (existingX[0] >= xDomain[1] || existingX[1] <= xDomain[0]) {
	                  continue;
	                }
	                if (existingY[0] < yDomain[1] && existingY[1] > yDomain[0]) {
	                  return true;
	                }
	              }
	              return false;
	            }
	            function lsInner(gd) {
	              var fullLayout = gd._fullLayout;
	              var gs = fullLayout._size;
	              var pad = gs.p;
	              var axList = Axes.list(gd, "", true);
	              var i, subplot, plotinfo, ax, xa, ya;
	              fullLayout._paperdiv.style({
	                width: gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroWidth && !gd.layout.width ? "100%" : fullLayout.width + "px",
	                height: gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroHeight && !gd.layout.height ? "100%" : fullLayout.height + "px"
	              }).selectAll(".main-svg").call(Drawing.setSize, fullLayout.width, fullLayout.height);
	              gd._context.setBackground(gd, fullLayout.paper_bgcolor);
	              exports2.drawMainTitle(gd);
	              ModeBar.manage(gd);
	              if (!fullLayout._has("cartesian")) {
	                return Plots.previousPromises(gd);
	              }
	              function getLinePosition(ax2, counterAx2, side) {
	                var lwHalf = ax2._lw / 2;
	                if (ax2._id.charAt(0) === "x") {
	                  if (!counterAx2) return gs.t + gs.h * (1 - (ax2.position || 0)) + lwHalf % 1;
	                  else if (side === "top") return counterAx2._offset - pad - lwHalf;
	                  return counterAx2._offset + counterAx2._length + pad + lwHalf;
	                }
	                if (!counterAx2) return gs.l + gs.w * (ax2.position || 0) + lwHalf % 1;
	                else if (side === "right") return counterAx2._offset + counterAx2._length + pad + lwHalf;
	                return counterAx2._offset - pad - lwHalf;
	              }
	              for (i = 0; i < axList.length; i++) {
	                ax = axList[i];
	                var counterAx = ax._anchorAxis;
	                ax._linepositions = {};
	                ax._lw = Drawing.crispRound(gd, ax.linewidth, 1);
	                ax._mainLinePosition = getLinePosition(ax, counterAx, ax.side);
	                ax._mainMirrorPosition = ax.mirror && counterAx ? getLinePosition(ax, counterAx, alignmentConstants.OPPOSITE_SIDE[ax.side]) : null;
	              }
	              var lowerBackgroundIDs = [];
	              var backgroundIds = [];
	              var lowerDomains = [];
	              var noNeedForBg = Color.opacity(fullLayout.paper_bgcolor) === 1 && Color.opacity(fullLayout.plot_bgcolor) === 1 && fullLayout.paper_bgcolor === fullLayout.plot_bgcolor;
	              for (subplot in fullLayout._plots) {
	                plotinfo = fullLayout._plots[subplot];
	                if (plotinfo.mainplot) {
	                  if (plotinfo.bg) {
	                    plotinfo.bg.remove();
	                  }
	                  plotinfo.bg = undefined;
	                } else {
	                  var xDomain = plotinfo.xaxis.domain;
	                  var yDomain = plotinfo.yaxis.domain;
	                  var plotgroup = plotinfo.plotgroup;
	                  if (overlappingDomain(xDomain, yDomain, lowerDomains)) {
	                    var pgNode = plotgroup.node();
	                    var plotgroupBg = plotinfo.bg = Lib.ensureSingle(plotgroup, "rect", "bg");
	                    pgNode.insertBefore(plotgroupBg.node(), pgNode.childNodes[0]);
	                    backgroundIds.push(subplot);
	                  } else {
	                    plotgroup.select("rect.bg").remove();
	                    lowerDomains.push([xDomain, yDomain]);
	                    if (!noNeedForBg) {
	                      lowerBackgroundIDs.push(subplot);
	                      backgroundIds.push(subplot);
	                    }
	                  }
	                }
	              }
	              var lowerBackgrounds = fullLayout._bgLayer.selectAll(".bg").data(lowerBackgroundIDs);
	              lowerBackgrounds.enter().append("rect").classed("bg", true);
	              lowerBackgrounds.exit().remove();
	              lowerBackgrounds.each(function(subplot2) {
	                fullLayout._plots[subplot2].bg = d3.select(this);
	              });
	              for (i = 0; i < backgroundIds.length; i++) {
	                plotinfo = fullLayout._plots[backgroundIds[i]];
	                xa = plotinfo.xaxis;
	                ya = plotinfo.yaxis;
	                if (plotinfo.bg && xa._offset !== undefined && ya._offset !== undefined) {
	                  plotinfo.bg.call(Drawing.setRect, xa._offset - pad, ya._offset - pad, xa._length + 2 * pad, ya._length + 2 * pad).call(Color.fill, fullLayout.plot_bgcolor).style("stroke-width", 0);
	                }
	              }
	              if (!fullLayout._hasOnlyLargeSploms) {
	                for (subplot in fullLayout._plots) {
	                  plotinfo = fullLayout._plots[subplot];
	                  xa = plotinfo.xaxis;
	                  ya = plotinfo.yaxis;
	                  var clipId = plotinfo.clipId = "clip" + fullLayout._uid + subplot + "plot";
	                  var plotClip = Lib.ensureSingleById(fullLayout._clips, "clipPath", clipId, function(s) {
	                    s.classed("plotclip", true).append("rect");
	                  });
	                  plotinfo.clipRect = plotClip.select("rect").attr({
	                    width: xa._length,
	                    height: ya._length
	                  });
	                  Drawing.setTranslate(plotinfo.plot, xa._offset, ya._offset);
	                  var plotClipId;
	                  var layerClipId;
	                  if (plotinfo._hasClipOnAxisFalse) {
	                    plotClipId = null;
	                    layerClipId = clipId;
	                  } else {
	                    plotClipId = clipId;
	                    layerClipId = null;
	                  }
	                  Drawing.setClipUrl(plotinfo.plot, plotClipId, gd);
	                  plotinfo.layerClipId = layerClipId;
	                }
	              }
	              var xLinesXLeft, xLinesXRight, xLinesYBottom, xLinesYTop, leftYLineWidth, rightYLineWidth;
	              var yLinesYBottom, yLinesYTop, yLinesXLeft, yLinesXRight, connectYBottom, connectYTop;
	              var extraSubplot;
	              function xLinePath(y) {
	                return "M" + xLinesXLeft + "," + y + "H" + xLinesXRight;
	              }
	              function xLinePathFree(y) {
	                return "M" + xa._offset + "," + y + "h" + xa._length;
	              }
	              function yLinePath(x) {
	                return "M" + x + "," + yLinesYTop + "V" + yLinesYBottom;
	              }
	              function yLinePathFree(x) {
	                if (ya._shift !== undefined) {
	                  x += ya._shift;
	                }
	                return "M" + x + "," + ya._offset + "v" + ya._length;
	              }
	              function mainPath(ax2, pathFn, pathFnFree) {
	                if (!ax2.showline || subplot !== ax2._mainSubplot) return "";
	                if (!ax2._anchorAxis) return pathFnFree(ax2._mainLinePosition);
	                var out = pathFn(ax2._mainLinePosition);
	                if (ax2.mirror) out += pathFn(ax2._mainMirrorPosition);
	                return out;
	              }
	              for (subplot in fullLayout._plots) {
	                plotinfo = fullLayout._plots[subplot];
	                xa = plotinfo.xaxis;
	                ya = plotinfo.yaxis;
	                var xPath = "M0,0";
	                if (shouldShowLinesOrTicks(xa, subplot)) {
	                  leftYLineWidth = findCounterAxisLineWidth(xa, "left", ya, axList);
	                  xLinesXLeft = xa._offset - (leftYLineWidth ? pad + leftYLineWidth : 0);
	                  rightYLineWidth = findCounterAxisLineWidth(xa, "right", ya, axList);
	                  xLinesXRight = xa._offset + xa._length + (rightYLineWidth ? pad + rightYLineWidth : 0);
	                  xLinesYBottom = getLinePosition(xa, ya, "bottom");
	                  xLinesYTop = getLinePosition(xa, ya, "top");
	                  extraSubplot = !xa._anchorAxis || subplot !== xa._mainSubplot;
	                  if (extraSubplot && (xa.mirror === "allticks" || xa.mirror === "all")) {
	                    xa._linepositions[subplot] = [xLinesYBottom, xLinesYTop];
	                  }
	                  xPath = mainPath(xa, xLinePath, xLinePathFree);
	                  if (extraSubplot && xa.showline && (xa.mirror === "all" || xa.mirror === "allticks")) {
	                    xPath += xLinePath(xLinesYBottom) + xLinePath(xLinesYTop);
	                  }
	                  plotinfo.xlines.style("stroke-width", xa._lw + "px").call(Color.stroke, xa.showline ? xa.linecolor : "rgba(0,0,0,0)");
	                }
	                plotinfo.xlines.attr("d", xPath);
	                var yPath = "M0,0";
	                if (shouldShowLinesOrTicks(ya, subplot)) {
	                  connectYBottom = findCounterAxisLineWidth(ya, "bottom", xa, axList);
	                  yLinesYBottom = ya._offset + ya._length + (connectYBottom ? pad : 0);
	                  connectYTop = findCounterAxisLineWidth(ya, "top", xa, axList);
	                  yLinesYTop = ya._offset - (connectYTop ? pad : 0);
	                  yLinesXLeft = getLinePosition(ya, xa, "left");
	                  yLinesXRight = getLinePosition(ya, xa, "right");
	                  extraSubplot = !ya._anchorAxis || subplot !== ya._mainSubplot;
	                  if (extraSubplot && (ya.mirror === "allticks" || ya.mirror === "all")) {
	                    ya._linepositions[subplot] = [yLinesXLeft, yLinesXRight];
	                  }
	                  yPath = mainPath(ya, yLinePath, yLinePathFree);
	                  if (extraSubplot && ya.showline && (ya.mirror === "all" || ya.mirror === "allticks")) {
	                    yPath += yLinePath(yLinesXLeft) + yLinePath(yLinesXRight);
	                  }
	                  plotinfo.ylines.style("stroke-width", ya._lw + "px").call(Color.stroke, ya.showline ? ya.linecolor : "rgba(0,0,0,0)");
	                }
	                plotinfo.ylines.attr("d", yPath);
	              }
	              Axes.makeClipPaths(gd);
	              return Plots.previousPromises(gd);
	            }
	            function shouldShowLinesOrTicks(ax, subplot) {
	              return (ax.ticks || ax.showline) && (subplot === ax._mainSubplot || ax.mirror === "all" || ax.mirror === "allticks");
	            }
	            function shouldShowLineThisSide(ax, side, counterAx) {
	              if (!counterAx.showline || !counterAx._lw) return false;
	              if (counterAx.mirror === "all" || counterAx.mirror === "allticks") return true;
	              var anchorAx = counterAx._anchorAxis;
	              if (!anchorAx) return false;
	              var sideIndex = alignmentConstants.FROM_BL[side];
	              if (counterAx.side === side) {
	                return anchorAx.domain[sideIndex] === ax.domain[sideIndex];
	              }
	              return counterAx.mirror && anchorAx.domain[1 - sideIndex] === ax.domain[1 - sideIndex];
	            }
	            function findCounterAxisLineWidth(ax, side, counterAx, axList) {
	              if (shouldShowLineThisSide(ax, side, counterAx)) {
	                return counterAx._lw;
	              }
	              for (var i = 0; i < axList.length; i++) {
	                var axi = axList[i];
	                if (axi._mainAxis === counterAx._mainAxis && shouldShowLineThisSide(ax, side, axi)) {
	                  return axi._lw;
	                }
	              }
	              return 0;
	            }
	            exports2.drawMainTitle = function(gd) {
	              var title = gd._fullLayout.title;
	              var fullLayout = gd._fullLayout;
	              var textAnchor = getMainTitleTextAnchor(fullLayout);
	              var dy = getMainTitleDy(fullLayout);
	              var y = getMainTitleY(fullLayout, dy);
	              var x = getMainTitleX(fullLayout, textAnchor);
	              Titles.draw(gd, "gtitle", {
	                propContainer: fullLayout,
	                propName: "title.text",
	                placeholder: fullLayout._dfltTitle.plot,
	                attributes: {
	                  x,
	                  y,
	                  "text-anchor": textAnchor,
	                  dy
	                }
	              });
	              if (title.text && title.automargin) {
	                var titleObj = d3.selectAll(".gtitle");
	                var titleHeight = Drawing.bBox(titleObj.node()).height;
	                var pushMargin = needsMarginPush(gd, title, titleHeight);
	                if (pushMargin > 0) {
	                  applyTitleAutoMargin(gd, y, pushMargin, titleHeight);
	                  titleObj.attr({
	                    x,
	                    y,
	                    "text-anchor": textAnchor,
	                    dy: getMainTitleDyAdj(title.yanchor)
	                  }).call(svgTextUtils.positionText, x, y);
	                  var extraLines = (title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
	                  if (extraLines) {
	                    var delta = alignmentConstants.LINE_SPACING * extraLines + alignmentConstants.MID_SHIFT;
	                    if (title.y === 0) {
	                      delta = -delta;
	                    }
	                    titleObj.selectAll(".line").each(function() {
	                      var newDy = +this.getAttribute("dy").slice(0, -2) - delta + "em";
	                      this.setAttribute("dy", newDy);
	                    });
	                  }
	                }
	              }
	            };
	            function isOutsideContainer(gd, title, position, y, titleHeight) {
	              var plotHeight = title.yref === "paper" ? gd._fullLayout._size.h : gd._fullLayout.height;
	              var yPosTop = Lib.isTopAnchor(title) ? y : y - titleHeight;
	              var yPosRel = position === "b" ? plotHeight - yPosTop : yPosTop;
	              if (Lib.isTopAnchor(title) && position === "t" || Lib.isBottomAnchor(title) && position === "b") {
	                return false;
	              } else {
	                return yPosRel < titleHeight;
	              }
	            }
	            function containerPushVal(position, titleY, titleYanchor, height, titleDepth) {
	              var push = 0;
	              if (titleYanchor === "middle") {
	                push += titleDepth / 2;
	              }
	              if (position === "t") {
	                if (titleYanchor === "top") {
	                  push += titleDepth;
	                }
	                push += height - titleY * height;
	              } else {
	                if (titleYanchor === "bottom") {
	                  push += titleDepth;
	                }
	                push += titleY * height;
	              }
	              return push;
	            }
	            function needsMarginPush(gd, title, titleHeight) {
	              var titleY = title.y;
	              var titleYanchor = title.yanchor;
	              var position = titleY > 0.5 ? "t" : "b";
	              var curMargin = gd._fullLayout.margin[position];
	              var pushMargin = 0;
	              if (title.yref === "paper") {
	                pushMargin = titleHeight + title.pad.t + title.pad.b;
	              } else if (title.yref === "container") {
	                pushMargin = containerPushVal(position, titleY, titleYanchor, gd._fullLayout.height, titleHeight) + title.pad.t + title.pad.b;
	              }
	              if (pushMargin > curMargin) {
	                return pushMargin;
	              }
	              return 0;
	            }
	            function applyTitleAutoMargin(gd, y, pushMargin, titleHeight) {
	              var titleID = "title.automargin";
	              var title = gd._fullLayout.title;
	              var position = title.y > 0.5 ? "t" : "b";
	              var push = {
	                x: title.x,
	                y: title.y,
	                t: 0,
	                b: 0
	              };
	              var reservedPush = {};
	              if (title.yref === "paper" && isOutsideContainer(gd, title, position, y, titleHeight)) {
	                push[position] = pushMargin;
	              } else if (title.yref === "container") {
	                reservedPush[position] = pushMargin;
	                gd._fullLayout._reservedMargin[titleID] = reservedPush;
	              }
	              Plots.allowAutoMargin(gd, titleID);
	              Plots.autoMargin(gd, titleID, push);
	            }
	            function getMainTitleX(fullLayout, textAnchor) {
	              var title = fullLayout.title;
	              var gs = fullLayout._size;
	              var hPadShift = 0;
	              if (textAnchor === SVG_TEXT_ANCHOR_START) {
	                hPadShift = title.pad.l;
	              } else if (textAnchor === SVG_TEXT_ANCHOR_END) {
	                hPadShift = -title.pad.r;
	              }
	              switch (title.xref) {
	                case "paper":
	                  return gs.l + gs.w * title.x + hPadShift;
	                case "container":
	                default:
	                  return fullLayout.width * title.x + hPadShift;
	              }
	            }
	            function getMainTitleY(fullLayout, dy) {
	              var title = fullLayout.title;
	              var gs = fullLayout._size;
	              var vPadShift = 0;
	              if (dy === "0em" || !dy) {
	                vPadShift = -title.pad.b;
	              } else if (dy === alignmentConstants.CAP_SHIFT + "em") {
	                vPadShift = title.pad.t;
	              }
	              if (title.y === "auto") {
	                return gs.t / 2;
	              } else {
	                switch (title.yref) {
	                  case "paper":
	                    return gs.t + gs.h - gs.h * title.y + vPadShift;
	                  case "container":
	                  default:
	                    return fullLayout.height - fullLayout.height * title.y + vPadShift;
	                }
	              }
	            }
	            function getMainTitleDyAdj(yanchor) {
	              if (yanchor === "top") {
	                return alignmentConstants.CAP_SHIFT + 0.3 + "em";
	              } else if (yanchor === "bottom") {
	                return "-0.3em";
	              } else {
	                return alignmentConstants.MID_SHIFT + "em";
	              }
	            }
	            function getMainTitleTextAnchor(fullLayout) {
	              var title = fullLayout.title;
	              var textAnchor = SVG_TEXT_ANCHOR_MIDDLE;
	              if (Lib.isRightAnchor(title)) {
	                textAnchor = SVG_TEXT_ANCHOR_END;
	              } else if (Lib.isLeftAnchor(title)) {
	                textAnchor = SVG_TEXT_ANCHOR_START;
	              }
	              return textAnchor;
	            }
	            function getMainTitleDy(fullLayout) {
	              var title = fullLayout.title;
	              var dy = "0em";
	              if (Lib.isTopAnchor(title)) {
	                dy = alignmentConstants.CAP_SHIFT + "em";
	              } else if (Lib.isMiddleAnchor(title)) {
	                dy = alignmentConstants.MID_SHIFT + "em";
	              }
	              return dy;
	            }
	            exports2.doTraceStyle = function(gd) {
	              var calcdata = gd.calcdata;
	              var editStyleCalls = [];
	              var i;
	              for (i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                var cd0 = cd[0] || {};
	                var trace = cd0.trace || {};
	                var _module = trace._module || {};
	                var arraysToCalcdata = _module.arraysToCalcdata;
	                if (arraysToCalcdata) arraysToCalcdata(cd, trace);
	                var editStyle = _module.editStyle;
	                if (editStyle) editStyleCalls.push({
	                  fn: editStyle,
	                  cd0
	                });
	              }
	              if (editStyleCalls.length) {
	                for (i = 0; i < editStyleCalls.length; i++) {
	                  var edit = editStyleCalls[i];
	                  edit.fn(gd, edit.cd0);
	                }
	                clearGlCanvases(gd);
	                exports2.redrawReglTraces(gd);
	              }
	              Plots.style(gd);
	              Registry.getComponentMethod("legend", "draw")(gd);
	              return Plots.previousPromises(gd);
	            };
	            exports2.doColorBars = function(gd) {
	              Registry.getComponentMethod("colorbar", "draw")(gd);
	              return Plots.previousPromises(gd);
	            };
	            exports2.layoutReplot = function(gd) {
	              var layout = gd.layout;
	              gd.layout = undefined;
	              return Registry.call("_doPlot", gd, "", layout);
	            };
	            exports2.doLegend = function(gd) {
	              Registry.getComponentMethod("legend", "draw")(gd);
	              return Plots.previousPromises(gd);
	            };
	            exports2.doTicksRelayout = function(gd) {
	              Axes.draw(gd, "redraw");
	              if (gd._fullLayout._hasOnlyLargeSploms) {
	                Registry.subplotsRegistry.splom.updateGrid(gd);
	                clearGlCanvases(gd);
	                exports2.redrawReglTraces(gd);
	              }
	              exports2.drawMainTitle(gd);
	              return Plots.previousPromises(gd);
	            };
	            exports2.doModeBar = function(gd) {
	              var fullLayout = gd._fullLayout;
	              ModeBar.manage(gd);
	              for (var i = 0; i < fullLayout._basePlotModules.length; i++) {
	                var updateFx = fullLayout._basePlotModules[i].updateFx;
	                if (updateFx) updateFx(gd);
	              }
	              return Plots.previousPromises(gd);
	            };
	            exports2.doCamera = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var sceneIds = fullLayout._subplots.gl3d;
	              for (var i = 0; i < sceneIds.length; i++) {
	                var sceneLayout = fullLayout[sceneIds[i]];
	                var scene = sceneLayout._scene;
	                scene.setViewport(sceneLayout);
	              }
	            };
	            exports2.drawData = function(gd) {
	              var fullLayout = gd._fullLayout;
	              clearGlCanvases(gd);
	              var basePlotModules = fullLayout._basePlotModules;
	              for (var i = 0; i < basePlotModules.length; i++) {
	                basePlotModules[i].plot(gd);
	              }
	              exports2.redrawReglTraces(gd);
	              Plots.style(gd);
	              Registry.getComponentMethod("selections", "draw")(gd);
	              Registry.getComponentMethod("shapes", "draw")(gd);
	              Registry.getComponentMethod("annotations", "draw")(gd);
	              Registry.getComponentMethod("images", "draw")(gd);
	              fullLayout._replotting = false;
	              return Plots.previousPromises(gd);
	            };
	            exports2.redrawReglTraces = function(gd) {
	              var fullLayout = gd._fullLayout;
	              if (fullLayout._has("regl")) {
	                var fullData = gd._fullData;
	                var cartesianIds = [];
	                var polarIds = [];
	                var i, sp;
	                if (fullLayout._hasOnlyLargeSploms) {
	                  fullLayout._splomGrid.draw();
	                }
	                for (i = 0; i < fullData.length; i++) {
	                  var trace = fullData[i];
	                  if (trace.visible === true && trace._length !== 0) {
	                    if (trace.type === "splom") {
	                      fullLayout._splomScenes[trace.uid].draw();
	                    } else if (trace.type === "scattergl") {
	                      Lib.pushUnique(cartesianIds, trace.xaxis + trace.yaxis);
	                    } else if (trace.type === "scatterpolargl") {
	                      Lib.pushUnique(polarIds, trace.subplot);
	                    }
	                  }
	                }
	                for (i = 0; i < cartesianIds.length; i++) {
	                  sp = fullLayout._plots[cartesianIds[i]];
	                  if (sp._scene) sp._scene.draw();
	                }
	                for (i = 0; i < polarIds.length; i++) {
	                  sp = fullLayout[polarIds[i]]._subplot;
	                  if (sp._scene) sp._scene.draw();
	                }
	              }
	            };
	            exports2.doAutoRangeAndConstraints = function(gd) {
	              var axList = Axes.list(gd, "", true);
	              var ax;
	              var autoRangeDone = {};
	              for (var i = 0; i < axList.length; i++) {
	                ax = axList[i];
	                if (!autoRangeDone[ax._id]) {
	                  autoRangeDone[ax._id] = 1;
	                  cleanAxisConstraints(gd, ax);
	                  doAutoRange(gd, ax);
	                  var matchGroup = ax._matchGroup;
	                  if (matchGroup) {
	                    for (var id2 in matchGroup) {
	                      var ax2 = Axes.getFromId(gd, id2);
	                      doAutoRange(gd, ax2, ax.range);
	                      autoRangeDone[id2] = 1;
	                    }
	                  }
	                }
	              }
	              enforceAxisConstraints(gd);
	            };
	            exports2.finalDraw = function(gd) {
	              Registry.getComponentMethod("rangeslider", "draw")(gd);
	              Registry.getComponentMethod("rangeselector", "draw")(gd);
	            };
	            exports2.drawMarginPushers = function(gd) {
	              Registry.getComponentMethod("legend", "draw")(gd);
	              Registry.getComponentMethod("rangeselector", "draw")(gd);
	              Registry.getComponentMethod("sliders", "draw")(gd);
	              Registry.getComponentMethod("updatemenus", "draw")(gd);
	              Registry.getComponentMethod("colorbar", "draw")(gd);
	            };
	          }
	        ),
	        /***/
	        96318: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var isPlainObject = Lib.isPlainObject;
	            var PlotSchema = __webpack_require__2(86281);
	            var Plots = __webpack_require__2(74875);
	            var plotAttributes = __webpack_require__2(9012);
	            var Template = __webpack_require__2(44467);
	            var dfltConfig = __webpack_require__2(72075).dfltConfig;
	            exports2.makeTemplate = function(figure) {
	              figure = Lib.isPlainObject(figure) ? figure : Lib.getGraphDiv(figure);
	              figure = Lib.extendDeep({
	                _context: dfltConfig
	              }, {
	                data: figure.data,
	                layout: figure.layout
	              });
	              Plots.supplyDefaults(figure);
	              var data = figure.data || [];
	              var layout = figure.layout || {};
	              layout._basePlotModules = figure._fullLayout._basePlotModules;
	              layout._modules = figure._fullLayout._modules;
	              var template = {
	                data: {},
	                layout: {}
	              };
	              data.forEach(function(trace) {
	                var traceTemplate = {};
	                walkStyleKeys(trace, traceTemplate, getTraceInfo.bind(null, trace));
	                var traceType2 = Lib.coerce(trace, {}, plotAttributes, "type");
	                var typeTemplates2 = template.data[traceType2];
	                if (!typeTemplates2) typeTemplates2 = template.data[traceType2] = [];
	                typeTemplates2.push(traceTemplate);
	              });
	              walkStyleKeys(layout, template.layout, getLayoutInfo.bind(null, layout));
	              delete template.layout.template;
	              var oldTemplate = layout.template;
	              if (isPlainObject(oldTemplate)) {
	                var oldLayoutTemplate = oldTemplate.layout;
	                var i, traceType, oldTypeTemplates, oldTypeLen, typeTemplates, typeLen;
	                if (isPlainObject(oldLayoutTemplate)) {
	                  mergeTemplates(oldLayoutTemplate, template.layout);
	                }
	                var oldDataTemplate = oldTemplate.data;
	                if (isPlainObject(oldDataTemplate)) {
	                  for (traceType in template.data) {
	                    oldTypeTemplates = oldDataTemplate[traceType];
	                    if (Array.isArray(oldTypeTemplates)) {
	                      typeTemplates = template.data[traceType];
	                      typeLen = typeTemplates.length;
	                      oldTypeLen = oldTypeTemplates.length;
	                      for (i = 0; i < typeLen; i++) {
	                        mergeTemplates(oldTypeTemplates[i % oldTypeLen], typeTemplates[i]);
	                      }
	                      for (i = typeLen; i < oldTypeLen; i++) {
	                        typeTemplates.push(Lib.extendDeep({}, oldTypeTemplates[i]));
	                      }
	                    }
	                  }
	                  for (traceType in oldDataTemplate) {
	                    if (!(traceType in template.data)) {
	                      template.data[traceType] = Lib.extendDeep([], oldDataTemplate[traceType]);
	                    }
	                  }
	                }
	              }
	              return template;
	            };
	            function mergeTemplates(oldTemplate, newTemplate) {
	              oldTemplate = Lib.extendDeep({}, oldTemplate);
	              var oldKeys = Object.keys(oldTemplate).sort();
	              var i, j;
	              function mergeOne(oldVal2, newVal, key3) {
	                if (isPlainObject(newVal) && isPlainObject(oldVal2)) {
	                  mergeTemplates(oldVal2, newVal);
	                } else if (Array.isArray(newVal) && Array.isArray(oldVal2)) {
	                  var templater = Template.arrayTemplater({
	                    _template: oldTemplate
	                  }, key3);
	                  for (j = 0; j < newVal.length; j++) {
	                    var item = newVal[j];
	                    var oldItem = templater.newItem(item)._template;
	                    if (oldItem) mergeTemplates(oldItem, item);
	                  }
	                  var defaultItems = templater.defaultItems();
	                  for (j = 0; j < defaultItems.length; j++) newVal.push(defaultItems[j]._template);
	                  for (j = 0; j < newVal.length; j++) delete newVal[j].templateitemname;
	                }
	              }
	              for (i = 0; i < oldKeys.length; i++) {
	                var key = oldKeys[i];
	                var oldVal = oldTemplate[key];
	                if (key in newTemplate) {
	                  mergeOne(oldVal, newTemplate[key], key);
	                } else newTemplate[key] = oldVal;
	                if (getBaseKey(key) === key) {
	                  for (var key2 in newTemplate) {
	                    var baseKey2 = getBaseKey(key2);
	                    if (key2 !== baseKey2 && baseKey2 === key && !(key2 in oldTemplate)) {
	                      mergeOne(oldVal, newTemplate[key2], key);
	                    }
	                  }
	                }
	              }
	            }
	            function getBaseKey(key) {
	              return key.replace(/[0-9]+$/, "");
	            }
	            function walkStyleKeys(parent, templateOut, getAttributeInfo, path, basePath) {
	              var pathAttr = basePath && getAttributeInfo(basePath);
	              for (var key in parent) {
	                var child = parent[key];
	                var nextPath = getNextPath(parent, key, path);
	                var nextBasePath = getNextPath(parent, key, basePath);
	                var attr = getAttributeInfo(nextBasePath);
	                if (!attr) {
	                  var baseKey = getBaseKey(key);
	                  if (baseKey !== key) {
	                    nextBasePath = getNextPath(parent, baseKey, basePath);
	                    attr = getAttributeInfo(nextBasePath);
	                  }
	                }
	                if (pathAttr && pathAttr === attr) continue;
	                if (!attr || attr._noTemplating || attr.valType === "data_array" || attr.arrayOk && Array.isArray(child)) {
	                  continue;
	                }
	                if (!attr.valType && isPlainObject(child)) {
	                  walkStyleKeys(child, templateOut, getAttributeInfo, nextPath, nextBasePath);
	                } else if (attr._isLinkedToArray && Array.isArray(child)) {
	                  var dfltDone = false;
	                  var namedIndex = 0;
	                  var usedNames = {};
	                  for (var i = 0; i < child.length; i++) {
	                    var item = child[i];
	                    if (isPlainObject(item)) {
	                      var name2 = item.name;
	                      if (name2) {
	                        if (!usedNames[name2]) {
	                          walkStyleKeys(item, templateOut, getAttributeInfo, getNextPath(child, namedIndex, nextPath), getNextPath(child, namedIndex, nextBasePath));
	                          namedIndex++;
	                          usedNames[name2] = 1;
	                        }
	                      } else if (!dfltDone) {
	                        var dfltKey = Template.arrayDefaultKey(key);
	                        var dfltPath = getNextPath(parent, dfltKey, path);
	                        var pathInArray = getNextPath(child, namedIndex, nextPath);
	                        walkStyleKeys(item, templateOut, getAttributeInfo, pathInArray, getNextPath(child, namedIndex, nextBasePath));
	                        var itemPropInArray = Lib.nestedProperty(templateOut, pathInArray);
	                        var dfltProp = Lib.nestedProperty(templateOut, dfltPath);
	                        dfltProp.set(itemPropInArray.get());
	                        itemPropInArray.set(null);
	                        dfltDone = true;
	                      }
	                    }
	                  }
	                } else {
	                  var templateProp = Lib.nestedProperty(templateOut, nextPath);
	                  templateProp.set(child);
	                }
	              }
	            }
	            function getLayoutInfo(layout, path) {
	              return PlotSchema.getLayoutValObject(layout, Lib.nestedProperty({}, path).parts);
	            }
	            function getTraceInfo(trace, path) {
	              return PlotSchema.getTraceValObject(trace, Lib.nestedProperty({}, path).parts);
	            }
	            function getNextPath(parent, key, path) {
	              var nextPath;
	              if (!path) nextPath = key;
	              else if (Array.isArray(parent)) nextPath = path + "[" + key + "]";
	              else nextPath = path + "." + key;
	              return nextPath;
	            }
	            exports2.validateTemplate = function(figureIn, template) {
	              var figure = Lib.extendDeep({}, {
	                _context: dfltConfig,
	                data: figureIn.data,
	                layout: figureIn.layout
	              });
	              var layout = figure.layout || {};
	              if (!isPlainObject(template)) template = layout.template || {};
	              var layoutTemplate = template.layout;
	              var dataTemplate = template.data;
	              var errorList = [];
	              figure.layout = layout;
	              figure.layout.template = template;
	              Plots.supplyDefaults(figure);
	              var fullLayout = figure._fullLayout;
	              var fullData = figure._fullData;
	              var layoutPaths = {};
	              function crawlLayoutForContainers(obj, paths) {
	                for (var key in obj) {
	                  if (key.charAt(0) !== "_" && isPlainObject(obj[key])) {
	                    var baseKey = getBaseKey(key);
	                    var nextPaths = [];
	                    var i2;
	                    for (i2 = 0; i2 < paths.length; i2++) {
	                      nextPaths.push(getNextPath(obj, key, paths[i2]));
	                      if (baseKey !== key) nextPaths.push(getNextPath(obj, baseKey, paths[i2]));
	                    }
	                    for (i2 = 0; i2 < nextPaths.length; i2++) {
	                      layoutPaths[nextPaths[i2]] = 1;
	                    }
	                    crawlLayoutForContainers(obj[key], nextPaths);
	                  }
	                }
	              }
	              function crawlLayoutTemplateForContainers(obj, path) {
	                for (var key in obj) {
	                  if (key.indexOf("defaults") === -1 && isPlainObject(obj[key])) {
	                    var nextPath = getNextPath(obj, key, path);
	                    if (layoutPaths[nextPath]) {
	                      crawlLayoutTemplateForContainers(obj[key], nextPath);
	                    } else {
	                      errorList.push({
	                        code: "unused",
	                        path: nextPath
	                      });
	                    }
	                  }
	                }
	              }
	              if (!isPlainObject(layoutTemplate)) {
	                errorList.push({
	                  code: "layout"
	                });
	              } else {
	                crawlLayoutForContainers(fullLayout, ["layout"]);
	                crawlLayoutTemplateForContainers(layoutTemplate, "layout");
	              }
	              if (!isPlainObject(dataTemplate)) {
	                errorList.push({
	                  code: "data"
	                });
	              } else {
	                var typeCount = {};
	                var traceType;
	                for (var i = 0; i < fullData.length; i++) {
	                  var fullTrace = fullData[i];
	                  traceType = fullTrace.type;
	                  typeCount[traceType] = (typeCount[traceType] || 0) + 1;
	                  if (!fullTrace._fullInput._template) {
	                    errorList.push({
	                      code: "missing",
	                      index: fullTrace._fullInput.index,
	                      traceType
	                    });
	                  }
	                }
	                for (traceType in dataTemplate) {
	                  var templateCount = dataTemplate[traceType].length;
	                  var dataCount = typeCount[traceType] || 0;
	                  if (templateCount > dataCount) {
	                    errorList.push({
	                      code: "unused",
	                      traceType,
	                      templateCount,
	                      dataCount
	                    });
	                  } else if (dataCount > templateCount) {
	                    errorList.push({
	                      code: "reused",
	                      traceType,
	                      templateCount,
	                      dataCount
	                    });
	                  }
	                }
	              }
	              function crawlForMissingTemplates(obj, path) {
	                for (var key in obj) {
	                  if (key.charAt(0) === "_") continue;
	                  var val = obj[key];
	                  var nextPath = getNextPath(obj, key, path);
	                  if (isPlainObject(val)) {
	                    if (Array.isArray(obj) && val._template === false && val.templateitemname) {
	                      errorList.push({
	                        code: "missing",
	                        path: nextPath,
	                        templateitemname: val.templateitemname
	                      });
	                    }
	                    crawlForMissingTemplates(val, nextPath);
	                  } else if (Array.isArray(val) && hasPlainObject(val)) {
	                    crawlForMissingTemplates(val, nextPath);
	                  }
	                }
	              }
	              crawlForMissingTemplates({
	                data: fullData,
	                layout: fullLayout
	              }, "");
	              if (errorList.length) return errorList.map(format);
	            };
	            function hasPlainObject(arr) {
	              for (var i = 0; i < arr.length; i++) {
	                if (isPlainObject(arr[i])) return true;
	              }
	            }
	            function format(opts) {
	              var msg;
	              switch (opts.code) {
	                case "data":
	                  msg = "The template has no key data.";
	                  break;
	                case "layout":
	                  msg = "The template has no key layout.";
	                  break;
	                case "missing":
	                  if (opts.path) {
	                    msg = "There are no templates for item " + opts.path + " with name " + opts.templateitemname;
	                  } else {
	                    msg = "There are no templates for trace " + opts.index + ", of type " + opts.traceType + ".";
	                  }
	                  break;
	                case "unused":
	                  if (opts.path) {
	                    msg = "The template item at " + opts.path + " was not used in constructing the plot.";
	                  } else if (opts.dataCount) {
	                    msg = "Some of the templates of type " + opts.traceType + " were not used. The template has " + opts.templateCount + " traces, the data only has " + opts.dataCount + " of this type.";
	                  } else {
	                    msg = "The template has " + opts.templateCount + " traces of type " + opts.traceType + " but there are none in the data.";
	                  }
	                  break;
	                case "reused":
	                  msg = "Some of the templates of type " + opts.traceType + " were used more than once. The template has " + opts.templateCount + " traces, the data has " + opts.dataCount + " of this type.";
	                  break;
	              }
	              opts.msg = msg;
	              return opts;
	            }
	          }
	        ),
	        /***/
	        403: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var plotApi = __webpack_require__2(72391);
	            var plots = __webpack_require__2(74875);
	            var Lib = __webpack_require__2(71828);
	            var helpers = __webpack_require__2(25095);
	            var toSVG = __webpack_require__2(5900);
	            var svgToImg = __webpack_require__2(70942);
	            var version = __webpack_require__2(11506).version;
	            var attrs = {
	              format: {
	                valType: "enumerated",
	                values: ["png", "jpeg", "webp", "svg", "full-json"],
	                dflt: "png"
	              },
	              width: {
	                valType: "number",
	                min: 1
	              },
	              height: {
	                valType: "number",
	                min: 1
	              },
	              scale: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              setBackground: {
	                valType: "any",
	                dflt: false
	              },
	              imageDataOnly: {
	                valType: "boolean",
	                dflt: false
	              }
	            };
	            function toImage(gd, opts) {
	              opts = opts || {};
	              var data;
	              var layout;
	              var config;
	              var fullLayout;
	              if (Lib.isPlainObject(gd)) {
	                data = gd.data || [];
	                layout = gd.layout || {};
	                config = gd.config || {};
	                fullLayout = {};
	              } else {
	                gd = Lib.getGraphDiv(gd);
	                data = Lib.extendDeep([], gd.data);
	                layout = Lib.extendDeep({}, gd.layout);
	                config = gd._context;
	                fullLayout = gd._fullLayout || {};
	              }
	              function isImpliedOrValid(attr) {
	                return !(attr in opts) || Lib.validate(opts[attr], attrs[attr]);
	              }
	              if (!isImpliedOrValid("width") && opts.width !== null || !isImpliedOrValid("height") && opts.height !== null) {
	                throw new Error("Height and width should be pixel values.");
	              }
	              if (!isImpliedOrValid("format")) {
	                throw new Error("Export format is not " + Lib.join2(attrs.format.values, ", ", " or ") + ".");
	              }
	              var fullOpts = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(opts, fullOpts, attrs, attr, dflt);
	              }
	              var format = coerce("format");
	              var width = coerce("width");
	              var height = coerce("height");
	              var scale = coerce("scale");
	              var setBackground = coerce("setBackground");
	              var imageDataOnly = coerce("imageDataOnly");
	              var clonedGd = document.createElement("div");
	              clonedGd.style.position = "absolute";
	              clonedGd.style.left = "-5000px";
	              document.body.appendChild(clonedGd);
	              var layoutImage = Lib.extendFlat({}, layout);
	              if (width) {
	                layoutImage.width = width;
	              } else if (opts.width === null && isNumeric(fullLayout.width)) {
	                layoutImage.width = fullLayout.width;
	              }
	              if (height) {
	                layoutImage.height = height;
	              } else if (opts.height === null && isNumeric(fullLayout.height)) {
	                layoutImage.height = fullLayout.height;
	              }
	              var configImage = Lib.extendFlat({}, config, {
	                _exportedPlot: true,
	                staticPlot: true,
	                setBackground
	              });
	              var redrawFunc = helpers.getRedrawFunc(clonedGd);
	              function wait() {
	                return new Promise(function(resolve) {
	                  setTimeout(resolve, helpers.getDelay(clonedGd._fullLayout));
	                });
	              }
	              function convert() {
	                return new Promise(function(resolve, reject) {
	                  var svg = toSVG(clonedGd, format, scale);
	                  var width2 = clonedGd._fullLayout.width;
	                  var height2 = clonedGd._fullLayout.height;
	                  function cleanup() {
	                    plotApi.purge(clonedGd);
	                    document.body.removeChild(clonedGd);
	                  }
	                  if (format === "full-json") {
	                    var json = plots.graphJson(clonedGd, false, "keepdata", "object", true, true);
	                    json.version = version;
	                    json = JSON.stringify(json);
	                    cleanup();
	                    if (imageDataOnly) {
	                      return resolve(json);
	                    } else {
	                      return resolve(helpers.encodeJSON(json));
	                    }
	                  }
	                  cleanup();
	                  if (format === "svg") {
	                    if (imageDataOnly) {
	                      return resolve(svg);
	                    } else {
	                      return resolve(helpers.encodeSVG(svg));
	                    }
	                  }
	                  var canvas = document.createElement("canvas");
	                  canvas.id = Lib.randstr();
	                  svgToImg({
	                    format,
	                    width: width2,
	                    height: height2,
	                    scale,
	                    canvas,
	                    svg,
	                    // ask svgToImg to return a Promise
	                    //  rather than EventEmitter
	                    //  leave EventEmitter for backward
	                    //  compatibility
	                    promise: true
	                  }).then(resolve).catch(reject);
	                });
	              }
	              function urlToImageData(url) {
	                if (imageDataOnly) {
	                  return url.replace(helpers.IMAGE_URL_PREFIX, "");
	                } else {
	                  return url;
	                }
	              }
	              return new Promise(function(resolve, reject) {
	                plotApi.newPlot(clonedGd, data, layoutImage, configImage).then(redrawFunc).then(wait).then(convert).then(function(url) {
	                  resolve(urlToImageData(url));
	                }).catch(function(err) {
	                  reject(err);
	                });
	              });
	            }
	            module2.exports = toImage;
	          }
	        ),
	        /***/
	        84936: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Plots = __webpack_require__2(74875);
	            var PlotSchema = __webpack_require__2(86281);
	            var dfltConfig = __webpack_require__2(72075).dfltConfig;
	            var isPlainObject = Lib.isPlainObject;
	            var isArray = Array.isArray;
	            var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	            module2.exports = function validate(data, layout) {
	              if (data === undefined) data = [];
	              if (layout === undefined) layout = {};
	              var schema = PlotSchema.get();
	              var errorList = [];
	              var gd = {
	                _context: Lib.extendFlat({}, dfltConfig)
	              };
	              var dataIn, layoutIn;
	              if (isArray(data)) {
	                gd.data = Lib.extendDeep([], data);
	                dataIn = data;
	              } else {
	                gd.data = [];
	                dataIn = [];
	                errorList.push(format("array", "data"));
	              }
	              if (isPlainObject(layout)) {
	                gd.layout = Lib.extendDeep({}, layout);
	                layoutIn = layout;
	              } else {
	                gd.layout = {};
	                layoutIn = {};
	                if (arguments.length > 1) {
	                  errorList.push(format("object", "layout"));
	                }
	              }
	              Plots.supplyDefaults(gd);
	              var dataOut = gd._fullData;
	              var len = dataIn.length;
	              for (var i = 0; i < len; i++) {
	                var traceIn = dataIn[i];
	                var base = ["data", i];
	                if (!isPlainObject(traceIn)) {
	                  errorList.push(format("object", base));
	                  continue;
	                }
	                var traceOut = dataOut[i];
	                var traceType = traceOut.type;
	                var traceSchema = schema.traces[traceType].attributes;
	                traceSchema.type = {
	                  valType: "enumerated",
	                  values: [traceType]
	                };
	                if (traceOut.visible === false && traceIn.visible !== false) {
	                  errorList.push(format("invisible", base));
	                }
	                crawl(traceIn, traceOut, traceSchema, errorList, base);
	                var transformsIn = traceIn.transforms;
	                var transformsOut = traceOut.transforms;
	                if (transformsIn) {
	                  if (!isArray(transformsIn)) {
	                    errorList.push(format("array", base, ["transforms"]));
	                  }
	                  base.push("transforms");
	                  for (var j = 0; j < transformsIn.length; j++) {
	                    var path = ["transforms", j];
	                    var transformType = transformsIn[j].type;
	                    if (!isPlainObject(transformsIn[j])) {
	                      errorList.push(format("object", base, path));
	                      continue;
	                    }
	                    var transformSchema = schema.transforms[transformType] ? schema.transforms[transformType].attributes : {};
	                    transformSchema.type = {
	                      valType: "enumerated",
	                      values: Object.keys(schema.transforms)
	                    };
	                    crawl(transformsIn[j], transformsOut[j], transformSchema, errorList, base, path);
	                  }
	                }
	              }
	              var layoutOut = gd._fullLayout;
	              var layoutSchema = fillLayoutSchema(schema, dataOut);
	              crawl(layoutIn, layoutOut, layoutSchema, errorList, "layout");
	              return errorList.length === 0 ? undefined : errorList;
	            };
	            function crawl(objIn, objOut, schema, list, base, path) {
	              path = path || [];
	              var keys = Object.keys(objIn);
	              for (var i = 0; i < keys.length; i++) {
	                var k = keys[i];
	                if (k === "transforms") continue;
	                var p = path.slice();
	                p.push(k);
	                var valIn = objIn[k];
	                var valOut = objOut[k];
	                var nestedSchema = getNestedSchema(schema, k);
	                var nestedValType = (nestedSchema || {}).valType;
	                var isInfoArray = nestedValType === "info_array";
	                var isColorscale = nestedValType === "colorscale";
	                var items = (nestedSchema || {}).items;
	                if (!isInSchema(schema, k)) {
	                  list.push(format("schema", base, p));
	                } else if (isPlainObject(valIn) && isPlainObject(valOut) && nestedValType !== "any") {
	                  crawl(valIn, valOut, nestedSchema, list, base, p);
	                } else if (isInfoArray && isArray(valIn)) {
	                  if (valIn.length > valOut.length) {
	                    list.push(format("unused", base, p.concat(valOut.length)));
	                  }
	                  var len = valOut.length;
	                  var arrayItems = Array.isArray(items);
	                  if (arrayItems) len = Math.min(len, items.length);
	                  var m, n, item, valInPart, valOutPart;
	                  if (nestedSchema.dimensions === 2) {
	                    for (n = 0; n < len; n++) {
	                      if (isArray(valIn[n])) {
	                        if (valIn[n].length > valOut[n].length) {
	                          list.push(format("unused", base, p.concat(n, valOut[n].length)));
	                        }
	                        var len2 = valOut[n].length;
	                        for (m = 0; m < (arrayItems ? Math.min(len2, items[n].length) : len2); m++) {
	                          item = arrayItems ? items[n][m] : items;
	                          valInPart = valIn[n][m];
	                          valOutPart = valOut[n][m];
	                          if (!Lib.validate(valInPart, item)) {
	                            list.push(format("value", base, p.concat(n, m), valInPart));
	                          } else if (valOutPart !== valInPart && valOutPart !== +valInPart) {
	                            list.push(format("dynamic", base, p.concat(n, m), valInPart, valOutPart));
	                          }
	                        }
	                      } else {
	                        list.push(format("array", base, p.concat(n), valIn[n]));
	                      }
	                    }
	                  } else {
	                    for (n = 0; n < len; n++) {
	                      item = arrayItems ? items[n] : items;
	                      valInPart = valIn[n];
	                      valOutPart = valOut[n];
	                      if (!Lib.validate(valInPart, item)) {
	                        list.push(format("value", base, p.concat(n), valInPart));
	                      } else if (valOutPart !== valInPart && valOutPart !== +valInPart) {
	                        list.push(format("dynamic", base, p.concat(n), valInPart, valOutPart));
	                      }
	                    }
	                  }
	                } else if (nestedSchema.items && !isInfoArray && isArray(valIn)) {
	                  var _nestedSchema = items[Object.keys(items)[0]];
	                  var indexList = [];
	                  var j, _p;
	                  for (j = 0; j < valOut.length; j++) {
	                    var _index = valOut[j]._index || j;
	                    _p = p.slice();
	                    _p.push(_index);
	                    if (isPlainObject(valIn[_index]) && isPlainObject(valOut[j])) {
	                      indexList.push(_index);
	                      var valInj = valIn[_index];
	                      var valOutj = valOut[j];
	                      if (isPlainObject(valInj) && valInj.visible !== false && valOutj.visible === false) {
	                        list.push(format("invisible", base, _p));
	                      } else crawl(valInj, valOutj, _nestedSchema, list, base, _p);
	                    }
	                  }
	                  for (j = 0; j < valIn.length; j++) {
	                    _p = p.slice();
	                    _p.push(j);
	                    if (!isPlainObject(valIn[j])) {
	                      list.push(format("object", base, _p, valIn[j]));
	                    } else if (indexList.indexOf(j) === -1) {
	                      list.push(format("unused", base, _p));
	                    }
	                  }
	                } else if (!isPlainObject(valIn) && isPlainObject(valOut)) {
	                  list.push(format("object", base, p, valIn));
	                } else if (!isArrayOrTypedArray(valIn) && isArrayOrTypedArray(valOut) && !isInfoArray && !isColorscale) {
	                  list.push(format("array", base, p, valIn));
	                } else if (!(k in objOut)) {
	                  list.push(format("unused", base, p, valIn));
	                } else if (!Lib.validate(valIn, nestedSchema)) {
	                  list.push(format("value", base, p, valIn));
	                } else if (nestedSchema.valType === "enumerated" && (nestedSchema.coerceNumber && valIn !== +valOut || valIn !== valOut)) {
	                  list.push(format("dynamic", base, p, valIn, valOut));
	                }
	              }
	              return list;
	            }
	            function fillLayoutSchema(schema, dataOut) {
	              var layoutSchema = schema.layout.layoutAttributes;
	              for (var i = 0; i < dataOut.length; i++) {
	                var traceOut = dataOut[i];
	                var traceSchema = schema.traces[traceOut.type];
	                var traceLayoutAttr = traceSchema.layoutAttributes;
	                if (traceLayoutAttr) {
	                  if (traceOut.subplot) {
	                    Lib.extendFlat(layoutSchema[traceSchema.attributes.subplot.dflt], traceLayoutAttr);
	                  } else {
	                    Lib.extendFlat(layoutSchema, traceLayoutAttr);
	                  }
	                }
	              }
	              return layoutSchema;
	            }
	            var code2msgFunc = {
	              object: function(base, astr) {
	                var prefix;
	                if (base === "layout" && astr === "") prefix = "The layout argument";
	                else if (base[0] === "data" && astr === "") {
	                  prefix = "Trace " + base[1] + " in the data argument";
	                } else prefix = inBase(base) + "key " + astr;
	                return prefix + " must be linked to an object container";
	              },
	              array: function(base, astr) {
	                var prefix;
	                if (base === "data") prefix = "The data argument";
	                else prefix = inBase(base) + "key " + astr;
	                return prefix + " must be linked to an array container";
	              },
	              schema: function(base, astr) {
	                return inBase(base) + "key " + astr + " is not part of the schema";
	              },
	              unused: function(base, astr, valIn) {
	                var target = isPlainObject(valIn) ? "container" : "key";
	                return inBase(base) + target + " " + astr + " did not get coerced";
	              },
	              dynamic: function(base, astr, valIn, valOut) {
	                return [inBase(base) + "key", astr, "(set to '" + valIn + "')", "got reset to", "'" + valOut + "'", "during defaults."].join(" ");
	              },
	              invisible: function(base, astr) {
	                return (astr ? inBase(base) + "item " + astr : "Trace " + base[1]) + " got defaulted to be not visible";
	              },
	              value: function(base, astr, valIn) {
	                return [inBase(base) + "key " + astr, "is set to an invalid value (" + valIn + ")"].join(" ");
	              }
	            };
	            function inBase(base) {
	              if (isArray(base)) return "In data trace " + base[1] + ", ";
	              return "In " + base + ", ";
	            }
	            function format(code, base, path, valIn, valOut) {
	              path = path || "";
	              var container, trace;
	              if (isArray(base)) {
	                container = base[0];
	                trace = base[1];
	              } else {
	                container = base;
	                trace = null;
	              }
	              var astr = convertPathToAttributeString(path);
	              var msg = code2msgFunc[code](base, astr, valIn, valOut);
	              Lib.log(msg);
	              return {
	                code,
	                container,
	                trace,
	                path,
	                astr,
	                msg
	              };
	            }
	            function isInSchema(schema, key) {
	              var parts = splitKey(key);
	              var keyMinusId = parts.keyMinusId;
	              var id = parts.id;
	              if (keyMinusId in schema && schema[keyMinusId]._isSubplotObj && id) {
	                return true;
	              }
	              return key in schema;
	            }
	            function getNestedSchema(schema, key) {
	              if (key in schema) return schema[key];
	              var parts = splitKey(key);
	              return schema[parts.keyMinusId];
	            }
	            var idRegex = Lib.counterRegex("([a-z]+)");
	            function splitKey(key) {
	              var idMatch = key.match(idRegex);
	              return {
	                keyMinusId: idMatch && idMatch[1],
	                id: idMatch && idMatch[2]
	              };
	            }
	            function convertPathToAttributeString(path) {
	              if (!isArray(path)) return String(path);
	              var astr = "";
	              for (var i = 0; i < path.length; i++) {
	                var p = path[i];
	                if (typeof p === "number") {
	                  astr = astr.substr(0, astr.length - 1) + "[" + p + "]";
	                } else {
	                  astr += p;
	                }
	                if (i < path.length - 1) astr += ".";
	              }
	              return astr;
	            }
	          }
	        ),
	        /***/
	        85594: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              mode: {
	                valType: "enumerated",
	                dflt: "afterall",
	                values: ["immediate", "next", "afterall"]
	              },
	              direction: {
	                valType: "enumerated",
	                values: ["forward", "reverse"],
	                dflt: "forward"
	              },
	              fromcurrent: {
	                valType: "boolean",
	                dflt: false
	              },
	              frame: {
	                duration: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 500
	                },
	                redraw: {
	                  valType: "boolean",
	                  dflt: true
	                }
	              },
	              transition: {
	                duration: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 500,
	                  editType: "none"
	                },
	                easing: {
	                  valType: "enumerated",
	                  dflt: "cubic-in-out",
	                  values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"],
	                  editType: "none"
	                },
	                ordering: {
	                  valType: "enumerated",
	                  values: ["layout first", "traces first"],
	                  dflt: "layout first",
	                  editType: "none"
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        85501: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            module2.exports = function handleArrayContainerDefaults(parentObjIn, parentObjOut, opts) {
	              var name2 = opts.name;
	              var inclusionAttr = opts.inclusionAttr || "visible";
	              var previousContOut = parentObjOut[name2];
	              var contIn = Lib.isArrayOrTypedArray(parentObjIn[name2]) ? parentObjIn[name2] : [];
	              var contOut = parentObjOut[name2] = [];
	              var templater = Template.arrayTemplater(parentObjOut, name2, inclusionAttr);
	              var i, itemOut;
	              for (i = 0; i < contIn.length; i++) {
	                var itemIn = contIn[i];
	                if (!Lib.isPlainObject(itemIn)) {
	                  itemOut = templater.newItem({});
	                  itemOut[inclusionAttr] = false;
	                } else {
	                  itemOut = templater.newItem(itemIn);
	                }
	                itemOut._index = i;
	                if (itemOut[inclusionAttr] !== false) {
	                  opts.handleItemDefaults(itemIn, itemOut, parentObjOut, opts);
	                }
	                contOut.push(itemOut);
	              }
	              var defaultItems = templater.defaultItems();
	              for (i = 0; i < defaultItems.length; i++) {
	                itemOut = defaultItems[i];
	                itemOut._index = contOut.length;
	                opts.handleItemDefaults({}, itemOut, parentObjOut, opts, {});
	                contOut.push(itemOut);
	              }
	              if (Lib.isArrayOrTypedArray(previousContOut)) {
	                var len = Math.min(previousContOut.length, contOut.length);
	                for (i = 0; i < len; i++) {
	                  Lib.relinkPrivateKeys(contOut[i], previousContOut[i]);
	                }
	              }
	              return contOut;
	            };
	          }
	        ),
	        /***/
	        9012: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var fxAttrs = __webpack_require__2(77914);
	            module2.exports = {
	              type: {
	                valType: "enumerated",
	                values: [],
	                // listed dynamically
	                dflt: "scatter",
	                editType: "calc+clearAxisTypes",
	                _noTemplating: true
	                // we handle this at a higher level
	              },
	              visible: {
	                valType: "enumerated",
	                values: [true, false, "legendonly"],
	                dflt: true,
	                editType: "calc"
	              },
	              showlegend: {
	                valType: "boolean",
	                dflt: true,
	                editType: "style"
	              },
	              legend: {
	                valType: "subplotid",
	                dflt: "legend",
	                editType: "style"
	              },
	              legendgroup: {
	                valType: "string",
	                dflt: "",
	                editType: "style"
	              },
	              legendgrouptitle: {
	                text: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "style"
	                },
	                font: fontAttrs({
	                  editType: "style"
	                }),
	                editType: "style"
	              },
	              legendrank: {
	                valType: "number",
	                dflt: 1e3,
	                editType: "style"
	              },
	              legendwidth: {
	                valType: "number",
	                min: 0,
	                editType: "style"
	              },
	              opacity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 1,
	                editType: "style"
	              },
	              name: {
	                valType: "string",
	                editType: "style"
	              },
	              uid: {
	                valType: "string",
	                editType: "plot",
	                anim: true
	              },
	              ids: {
	                valType: "data_array",
	                editType: "calc",
	                anim: true
	              },
	              customdata: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              meta: {
	                valType: "any",
	                arrayOk: true,
	                editType: "plot"
	              },
	              // N.B. these cannot be 'data_array' as they do not have the same length as
	              // other data arrays and arrayOk attributes in general
	              //
	              // Maybe add another valType:
	              // https://github.com/plotly/plotly.js/issues/1894
	              selectedpoints: {
	                valType: "any",
	                editType: "calc"
	              },
	              hoverinfo: {
	                valType: "flaglist",
	                flags: ["x", "y", "z", "text", "name"],
	                extras: ["all", "none", "skip"],
	                arrayOk: true,
	                dflt: "all",
	                editType: "none"
	              },
	              hoverlabel: fxAttrs.hoverlabel,
	              stream: {
	                token: {
	                  valType: "string",
	                  noBlank: true,
	                  strict: true,
	                  editType: "calc"
	                },
	                maxpoints: {
	                  valType: "number",
	                  min: 0,
	                  max: 1e4,
	                  dflt: 500,
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              transforms: {
	                _isLinkedToArray: "transform",
	                editType: "calc"
	              },
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              }
	            };
	          }
	        ),
	        /***/
	        42973: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var dateTime2ms = Lib.dateTime2ms;
	            var incrementMonth = Lib.incrementMonth;
	            var constants = __webpack_require__2(50606);
	            var ONEAVGMONTH = constants.ONEAVGMONTH;
	            module2.exports = function alignPeriod(trace, ax, axLetter, vals) {
	              if (ax.type !== "date") return {
	                vals
	              };
	              var alignment = trace[axLetter + "periodalignment"];
	              if (!alignment) return {
	                vals
	              };
	              var period = trace[axLetter + "period"];
	              var mPeriod;
	              if (isNumeric(period)) {
	                period = +period;
	                if (period <= 0) return {
	                  vals
	                };
	              } else if (typeof period === "string" && period.charAt(0) === "M") {
	                var n = +period.substring(1);
	                if (n > 0 && Math.round(n) === n) {
	                  mPeriod = n;
	                } else return {
	                  vals
	                };
	              }
	              var calendar = ax.calendar;
	              var isStart = "start" === alignment;
	              var isEnd = "end" === alignment;
	              var period0 = trace[axLetter + "period0"];
	              var base = dateTime2ms(period0, calendar) || 0;
	              var newVals = [];
	              var starts = [];
	              var ends = [];
	              var len = vals.length;
	              for (var i = 0; i < len; i++) {
	                var v = vals[i];
	                var nEstimated, startTime, endTime;
	                if (mPeriod) {
	                  nEstimated = Math.round((v - base) / (mPeriod * ONEAVGMONTH));
	                  endTime = incrementMonth(base, mPeriod * nEstimated, calendar);
	                  while (endTime > v) {
	                    endTime = incrementMonth(endTime, -mPeriod, calendar);
	                  }
	                  while (endTime <= v) {
	                    endTime = incrementMonth(endTime, mPeriod, calendar);
	                  }
	                  startTime = incrementMonth(endTime, -mPeriod, calendar);
	                } else {
	                  nEstimated = Math.round((v - base) / period);
	                  endTime = base + nEstimated * period;
	                  while (endTime > v) {
	                    endTime -= period;
	                  }
	                  while (endTime <= v) {
	                    endTime += period;
	                  }
	                  startTime = endTime - period;
	                }
	                newVals[i] = isStart ? startTime : isEnd ? endTime : (startTime + endTime) / 2;
	                starts[i] = startTime;
	                ends[i] = endTime;
	              }
	              return {
	                vals: newVals,
	                starts,
	                ends
	              };
	            };
	          }
	        ),
	        /***/
	        89502: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              xaxis: {
	                valType: "subplotid",
	                dflt: "x",
	                editType: "calc+clearAxisTypes"
	              },
	              yaxis: {
	                valType: "subplotid",
	                dflt: "y",
	                editType: "calc+clearAxisTypes"
	              }
	            };
	          }
	        ),
	        /***/
	        71739: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var FP_SAFE = __webpack_require__2(50606).FP_SAFE;
	            var Registry = __webpack_require__2(73972);
	            var Drawing = __webpack_require__2(91424);
	            var axIds = __webpack_require__2(41675);
	            var getFromId = axIds.getFromId;
	            var isLinked = axIds.isLinked;
	            module2.exports = {
	              applyAutorangeOptions,
	              getAutoRange,
	              makePadFn,
	              doAutoRange,
	              findExtremes,
	              concatExtremes
	            };
	            function getAutoRange(gd, ax) {
	              var i, j;
	              var newRange = [];
	              var fullLayout = gd._fullLayout;
	              var getPadMin = makePadFn(fullLayout, ax, 0);
	              var getPadMax = makePadFn(fullLayout, ax, 1);
	              var extremes = concatExtremes(gd, ax);
	              var minArray = extremes.min;
	              var maxArray = extremes.max;
	              if (minArray.length === 0 || maxArray.length === 0) {
	                return Lib.simpleMap(ax.range, ax.r2l);
	              }
	              var minmin = minArray[0].val;
	              var maxmax = maxArray[0].val;
	              for (i = 1; i < minArray.length; i++) {
	                if (minmin !== maxmax) break;
	                minmin = Math.min(minmin, minArray[i].val);
	              }
	              for (i = 1; i < maxArray.length; i++) {
	                if (minmin !== maxmax) break;
	                maxmax = Math.max(maxmax, maxArray[i].val);
	              }
	              var autorange = ax.autorange;
	              var axReverse = autorange === "reversed" || autorange === "min reversed" || autorange === "max reversed";
	              if (!axReverse && ax.range) {
	                var rng = Lib.simpleMap(ax.range, ax.r2l);
	                axReverse = rng[1] < rng[0];
	              }
	              if (ax.autorange === "reversed") {
	                ax.autorange = true;
	              }
	              var rangeMode = ax.rangemode;
	              var toZero = rangeMode === "tozero";
	              var nonNegative = rangeMode === "nonnegative";
	              var axLen = ax._length;
	              var minSpan = axLen / 10;
	              var mbest = 0;
	              var minpt, maxpt, minbest, maxbest, dp, dv;
	              for (i = 0; i < minArray.length; i++) {
	                minpt = minArray[i];
	                for (j = 0; j < maxArray.length; j++) {
	                  maxpt = maxArray[j];
	                  dv = maxpt.val - minpt.val - calcBreaksLength(ax, minpt.val, maxpt.val);
	                  if (dv > 0) {
	                    dp = axLen - getPadMin(minpt) - getPadMax(maxpt);
	                    if (dp > minSpan) {
	                      if (dv / dp > mbest) {
	                        minbest = minpt;
	                        maxbest = maxpt;
	                        mbest = dv / dp;
	                      }
	                    } else if (dv / axLen > mbest) {
	                      minbest = {
	                        val: minpt.val,
	                        nopad: 1
	                      };
	                      maxbest = {
	                        val: maxpt.val,
	                        nopad: 1
	                      };
	                      mbest = dv / axLen;
	                    }
	                  }
	                }
	              }
	              function maximumPad(prev, pt) {
	                return Math.max(prev, getPadMax(pt));
	              }
	              if (minmin === maxmax) {
	                var lower = minmin - 1;
	                var upper = minmin + 1;
	                if (toZero) {
	                  if (minmin === 0) {
	                    newRange = [0, 1];
	                  } else {
	                    var maxPad = (minmin > 0 ? maxArray : minArray).reduce(maximumPad, 0);
	                    var rangeEnd = minmin / (1 - Math.min(0.5, maxPad / axLen));
	                    newRange = minmin > 0 ? [0, rangeEnd] : [rangeEnd, 0];
	                  }
	                } else if (nonNegative) {
	                  newRange = [Math.max(0, lower), Math.max(1, upper)];
	                } else {
	                  newRange = [lower, upper];
	                }
	              } else {
	                if (toZero) {
	                  if (minbest.val >= 0) {
	                    minbest = {
	                      val: 0,
	                      nopad: 1
	                    };
	                  }
	                  if (maxbest.val <= 0) {
	                    maxbest = {
	                      val: 0,
	                      nopad: 1
	                    };
	                  }
	                } else if (nonNegative) {
	                  if (minbest.val - mbest * getPadMin(minbest) < 0) {
	                    minbest = {
	                      val: 0,
	                      nopad: 1
	                    };
	                  }
	                  if (maxbest.val <= 0) {
	                    maxbest = {
	                      val: 1,
	                      nopad: 1
	                    };
	                  }
	                }
	                mbest = (maxbest.val - minbest.val - calcBreaksLength(ax, minpt.val, maxpt.val)) / (axLen - getPadMin(minbest) - getPadMax(maxbest));
	                newRange = [minbest.val - mbest * getPadMin(minbest), maxbest.val + mbest * getPadMax(maxbest)];
	              }
	              newRange = applyAutorangeOptions(newRange, ax);
	              if (ax.limitRange) ax.limitRange();
	              if (axReverse) newRange.reverse();
	              return Lib.simpleMap(newRange, ax.l2r || Number);
	            }
	            function calcBreaksLength(ax, v0, v1) {
	              var lBreaks = 0;
	              if (ax.rangebreaks) {
	                var rangebreaksOut = ax.locateBreaks(v0, v1);
	                for (var i = 0; i < rangebreaksOut.length; i++) {
	                  var brk = rangebreaksOut[i];
	                  lBreaks += brk.max - brk.min;
	                }
	              }
	              return lBreaks;
	            }
	            function makePadFn(fullLayout, ax, max) {
	              var extrappad = 0.05 * ax._length;
	              var anchorAxis = ax._anchorAxis || {};
	              if ((ax.ticklabelposition || "").indexOf("inside") !== -1 || (anchorAxis.ticklabelposition || "").indexOf("inside") !== -1) {
	                var axReverse = ax.isReversed();
	                if (!axReverse) {
	                  var rng = Lib.simpleMap(ax.range, ax.r2l);
	                  axReverse = rng[1] < rng[0];
	                }
	                if (axReverse) max = !max;
	              }
	              var zero = 0;
	              if (!isLinked(fullLayout, ax._id)) {
	                zero = padInsideLabelsOnAnchorAxis(fullLayout, ax, max);
	              }
	              extrappad = Math.max(zero, extrappad);
	              if (ax.constrain === "domain" && ax._inputDomain) {
	                extrappad *= (ax._inputDomain[1] - ax._inputDomain[0]) / (ax.domain[1] - ax.domain[0]);
	              }
	              return function getPad(pt) {
	                if (pt.nopad) return 0;
	                return pt.pad + (pt.extrapad ? extrappad : zero);
	              };
	            }
	            var TEXTPAD = 3;
	            function padInsideLabelsOnAnchorAxis(fullLayout, ax, max) {
	              var pad = 0;
	              var isX = ax._id.charAt(0) === "x";
	              for (var subplot in fullLayout._plots) {
	                var plotinfo = fullLayout._plots[subplot];
	                if (ax._id !== plotinfo.xaxis._id && ax._id !== plotinfo.yaxis._id) continue;
	                var anchorAxis = (isX ? plotinfo.yaxis : plotinfo.xaxis) || {};
	                if ((anchorAxis.ticklabelposition || "").indexOf("inside") !== -1) {
	                  if (!max && (anchorAxis.side === "left" || anchorAxis.side === "bottom") || max && (anchorAxis.side === "top" || anchorAxis.side === "right")) {
	                    if (anchorAxis._vals) {
	                      var rad = Lib.deg2rad(anchorAxis._tickAngles[anchorAxis._id + "tick"] || 0);
	                      var cosA = Math.abs(Math.cos(rad));
	                      var sinA = Math.abs(Math.sin(rad));
	                      if (!anchorAxis._vals[0].bb) {
	                        var cls = anchorAxis._id + "tick";
	                        var tickLabels = anchorAxis._selections[cls];
	                        tickLabels.each(function(d) {
	                          var thisLabel = d3.select(this);
	                          var mathjaxGroup = thisLabel.select(".text-math-group");
	                          if (mathjaxGroup.empty()) {
	                            d.bb = Drawing.bBox(thisLabel.node());
	                          }
	                        });
	                      }
	                      for (var i = 0; i < anchorAxis._vals.length; i++) {
	                        var t = anchorAxis._vals[i];
	                        var bb = t.bb;
	                        if (bb) {
	                          var w = 2 * TEXTPAD + bb.width;
	                          var h = 2 * TEXTPAD + bb.height;
	                          pad = Math.max(pad, isX ? Math.max(w * cosA, h * sinA) : Math.max(h * cosA, w * sinA));
	                        }
	                      }
	                    }
	                    if (anchorAxis.ticks === "inside" && anchorAxis.ticklabelposition === "inside") {
	                      pad += anchorAxis.ticklen || 0;
	                    }
	                  }
	                }
	              }
	              return pad;
	            }
	            function concatExtremes(gd, ax, noMatch) {
	              var axId = ax._id;
	              var fullData = gd._fullData;
	              var fullLayout = gd._fullLayout;
	              var minArray = [];
	              var maxArray = [];
	              var i, j, d;
	              function _concat(cont, indices) {
	                for (i = 0; i < indices.length; i++) {
	                  var item = cont[indices[i]];
	                  var extremes = (item._extremes || {})[axId];
	                  if (item.visible === true && extremes) {
	                    for (j = 0; j < extremes.min.length; j++) {
	                      d = extremes.min[j];
	                      collapseMinArray(minArray, d.val, d.pad, {
	                        extrapad: d.extrapad
	                      });
	                    }
	                    for (j = 0; j < extremes.max.length; j++) {
	                      d = extremes.max[j];
	                      collapseMaxArray(maxArray, d.val, d.pad, {
	                        extrapad: d.extrapad
	                      });
	                    }
	                  }
	                }
	              }
	              _concat(fullData, ax._traceIndices);
	              _concat(fullLayout.annotations || [], ax._annIndices || []);
	              _concat(fullLayout.shapes || [], ax._shapeIndices || []);
	              if (ax._matchGroup && !noMatch) {
	                for (var axId2 in ax._matchGroup) {
	                  if (axId2 !== ax._id) {
	                    var ax2 = getFromId(gd, axId2);
	                    var extremes2 = concatExtremes(gd, ax2, true);
	                    var lenRatio = ax._length / ax2._length;
	                    for (j = 0; j < extremes2.min.length; j++) {
	                      d = extremes2.min[j];
	                      collapseMinArray(minArray, d.val, d.pad * lenRatio, {
	                        extrapad: d.extrapad
	                      });
	                    }
	                    for (j = 0; j < extremes2.max.length; j++) {
	                      d = extremes2.max[j];
	                      collapseMaxArray(maxArray, d.val, d.pad * lenRatio, {
	                        extrapad: d.extrapad
	                      });
	                    }
	                  }
	                }
	              }
	              return {
	                min: minArray,
	                max: maxArray
	              };
	            }
	            function doAutoRange(gd, ax, presetRange) {
	              ax.setScale();
	              if (ax.autorange) {
	                ax.range = presetRange ? presetRange.slice() : getAutoRange(gd, ax);
	                ax._r = ax.range.slice();
	                ax._rl = Lib.simpleMap(ax._r, ax.r2l);
	                var axIn = ax._input;
	                var edits = {};
	                edits[ax._attr + ".range"] = ax.range;
	                edits[ax._attr + ".autorange"] = ax.autorange;
	                Registry.call("_storeDirectGUIEdit", gd.layout, gd._fullLayout._preGUI, edits);
	                axIn.range = ax.range.slice();
	                axIn.autorange = ax.autorange;
	              }
	              var anchorAx = ax._anchorAxis;
	              if (anchorAx && anchorAx.rangeslider) {
	                var axeRangeOpts = anchorAx.rangeslider[ax._name];
	                if (axeRangeOpts) {
	                  if (axeRangeOpts.rangemode === "auto") {
	                    axeRangeOpts.range = getAutoRange(gd, ax);
	                  }
	                }
	                anchorAx._input.rangeslider[ax._name] = Lib.extendFlat({}, axeRangeOpts);
	              }
	            }
	            function findExtremes(ax, data, opts) {
	              if (!opts) opts = {};
	              if (!ax._m) ax.setScale();
	              var minArray = [];
	              var maxArray = [];
	              var len = data.length;
	              var extrapad = opts.padded || false;
	              var tozero = opts.tozero && (ax.type === "linear" || ax.type === "-");
	              var isLog = ax.type === "log";
	              var hasArrayOption = false;
	              var vpadLinearized = opts.vpadLinearized || false;
	              var i, v, di, dmin, dmax, ppadiplus, ppadiminus, vmin, vmax;
	              function makePadAccessor(item) {
	                if (Array.isArray(item)) {
	                  hasArrayOption = true;
	                  return function(i2) {
	                    return Math.max(Number(item[i2] || 0), 0);
	                  };
	                } else {
	                  var v2 = Math.max(Number(item || 0), 0);
	                  return function() {
	                    return v2;
	                  };
	                }
	              }
	              var ppadplus = makePadAccessor((ax._m > 0 ? opts.ppadplus : opts.ppadminus) || opts.ppad || 0);
	              var ppadminus = makePadAccessor((ax._m > 0 ? opts.ppadminus : opts.ppadplus) || opts.ppad || 0);
	              var vpadplus = makePadAccessor(opts.vpadplus || opts.vpad);
	              var vpadminus = makePadAccessor(opts.vpadminus || opts.vpad);
	              if (!hasArrayOption) {
	                vmin = Infinity;
	                vmax = -Infinity;
	                if (isLog) {
	                  for (i = 0; i < len; i++) {
	                    v = data[i];
	                    if (v < vmin && v > 0) vmin = v;
	                    if (v > vmax && v < FP_SAFE) vmax = v;
	                  }
	                } else {
	                  for (i = 0; i < len; i++) {
	                    v = data[i];
	                    if (v < vmin && v > -FP_SAFE) vmin = v;
	                    if (v > vmax && v < FP_SAFE) vmax = v;
	                  }
	                }
	                data = [vmin, vmax];
	                len = 2;
	              }
	              var collapseOpts = {
	                tozero,
	                extrapad
	              };
	              function addItem(i2) {
	                di = data[i2];
	                if (!isNumeric(di)) return;
	                ppadiplus = ppadplus(i2);
	                ppadiminus = ppadminus(i2);
	                if (vpadLinearized) {
	                  dmin = ax.c2l(di) - vpadminus(i2);
	                  dmax = ax.c2l(di) + vpadplus(i2);
	                } else {
	                  vmin = di - vpadminus(i2);
	                  vmax = di + vpadplus(i2);
	                  if (isLog && vmin < vmax / 10) vmin = vmax / 10;
	                  dmin = ax.c2l(vmin);
	                  dmax = ax.c2l(vmax);
	                }
	                if (tozero) {
	                  dmin = Math.min(0, dmin);
	                  dmax = Math.max(0, dmax);
	                }
	                if (goodNumber(dmin)) {
	                  collapseMinArray(minArray, dmin, ppadiminus, collapseOpts);
	                }
	                if (goodNumber(dmax)) {
	                  collapseMaxArray(maxArray, dmax, ppadiplus, collapseOpts);
	                }
	              }
	              var iMax = Math.min(6, len);
	              for (i = 0; i < iMax; i++) addItem(i);
	              for (i = len - 1; i >= iMax; i--) addItem(i);
	              return {
	                min: minArray,
	                max: maxArray,
	                opts
	              };
	            }
	            function collapseMinArray(array, newVal, newPad, opts) {
	              collapseArray(array, newVal, newPad, opts, lessOrEqual);
	            }
	            function collapseMaxArray(array, newVal, newPad, opts) {
	              collapseArray(array, newVal, newPad, opts, greaterOrEqual);
	            }
	            function collapseArray(array, newVal, newPad, opts, atLeastAsExtreme) {
	              var tozero = opts.tozero;
	              var extrapad = opts.extrapad;
	              var includeThis = true;
	              for (var j = 0; j < array.length && includeThis; j++) {
	                var v = array[j];
	                if (atLeastAsExtreme(v.val, newVal) && v.pad >= newPad && (v.extrapad || !extrapad)) {
	                  includeThis = false;
	                  break;
	                } else if (atLeastAsExtreme(newVal, v.val) && v.pad <= newPad && (extrapad || !v.extrapad)) {
	                  array.splice(j, 1);
	                  j--;
	                }
	              }
	              if (includeThis) {
	                var clipAtZero = tozero && newVal === 0;
	                array.push({
	                  val: newVal,
	                  pad: clipAtZero ? 0 : newPad,
	                  extrapad: clipAtZero ? false : extrapad
	                });
	              }
	            }
	            function goodNumber(v) {
	              return isNumeric(v) && Math.abs(v) < FP_SAFE;
	            }
	            function lessOrEqual(v0, v1) {
	              return v0 <= v1;
	            }
	            function greaterOrEqual(v0, v1) {
	              return v0 >= v1;
	            }
	            function applyAutorangeMinOptions(v, ax) {
	              var autorangeoptions = ax.autorangeoptions;
	              if (autorangeoptions && autorangeoptions.minallowed !== undefined && hasValidMinAndMax(ax, autorangeoptions.minallowed, autorangeoptions.maxallowed)) {
	                return autorangeoptions.minallowed;
	              }
	              if (autorangeoptions && autorangeoptions.clipmin !== undefined && hasValidMinAndMax(ax, autorangeoptions.clipmin, autorangeoptions.clipmax)) {
	                return Math.max(v, ax.d2l(autorangeoptions.clipmin));
	              }
	              return v;
	            }
	            function applyAutorangeMaxOptions(v, ax) {
	              var autorangeoptions = ax.autorangeoptions;
	              if (autorangeoptions && autorangeoptions.maxallowed !== undefined && hasValidMinAndMax(ax, autorangeoptions.minallowed, autorangeoptions.maxallowed)) {
	                return autorangeoptions.maxallowed;
	              }
	              if (autorangeoptions && autorangeoptions.clipmax !== undefined && hasValidMinAndMax(ax, autorangeoptions.clipmin, autorangeoptions.clipmax)) {
	                return Math.min(v, ax.d2l(autorangeoptions.clipmax));
	              }
	              return v;
	            }
	            function hasValidMinAndMax(ax, min, max) {
	              if (min !== undefined && max !== undefined) {
	                min = ax.d2l(min);
	                max = ax.d2l(max);
	                return min < max;
	              }
	              return true;
	            }
	            function applyAutorangeOptions(range2, ax) {
	              if (!ax || !ax.autorangeoptions) return range2;
	              var min = range2[0];
	              var max = range2[1];
	              var include = ax.autorangeoptions.include;
	              if (include !== undefined) {
	                var lMin = ax.d2l(min);
	                var lMax = ax.d2l(max);
	                if (!Lib.isArrayOrTypedArray(include)) include = [include];
	                for (var i = 0; i < include.length; i++) {
	                  var v = ax.d2l(include[i]);
	                  if (lMin >= v) {
	                    lMin = v;
	                    min = v;
	                  }
	                  if (lMax <= v) {
	                    lMax = v;
	                    max = v;
	                  }
	                }
	              }
	              min = applyAutorangeMinOptions(min, ax);
	              max = applyAutorangeMaxOptions(max, ax);
	              return [min, max];
	            }
	          }
	        ),
	        /***/
	        23074: (
	          /***/
	          function(module2) {
	            module2.exports = function handleAutorangeOptionsDefaults(coerce, autorange, range2) {
	              var minRange, maxRange;
	              if (range2) {
	                var isReversed = autorange === "reversed" || autorange === "min reversed" || autorange === "max reversed";
	                minRange = range2[isReversed ? 1 : 0];
	                maxRange = range2[isReversed ? 0 : 1];
	              }
	              var minallowed = coerce("autorangeoptions.minallowed", maxRange === null ? minRange : undefined);
	              var maxallowed = coerce("autorangeoptions.maxallowed", minRange === null ? maxRange : undefined);
	              if (minallowed === undefined) coerce("autorangeoptions.clipmin");
	              if (maxallowed === undefined) coerce("autorangeoptions.clipmax");
	              coerce("autorangeoptions.include");
	            };
	          }
	        ),
	        /***/
	        89298: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Plots = __webpack_require__2(74875);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var Titles = __webpack_require__2(92998);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var axAttrs = __webpack_require__2(13838);
	            var cleanTicks = __webpack_require__2(66287);
	            var constants = __webpack_require__2(50606);
	            var ONEMAXYEAR = constants.ONEMAXYEAR;
	            var ONEAVGYEAR = constants.ONEAVGYEAR;
	            var ONEMINYEAR = constants.ONEMINYEAR;
	            var ONEMAXQUARTER = constants.ONEMAXQUARTER;
	            var ONEAVGQUARTER = constants.ONEAVGQUARTER;
	            var ONEMINQUARTER = constants.ONEMINQUARTER;
	            var ONEMAXMONTH = constants.ONEMAXMONTH;
	            var ONEAVGMONTH = constants.ONEAVGMONTH;
	            var ONEMINMONTH = constants.ONEMINMONTH;
	            var ONEWEEK = constants.ONEWEEK;
	            var ONEDAY = constants.ONEDAY;
	            var HALFDAY = ONEDAY / 2;
	            var ONEHOUR = constants.ONEHOUR;
	            var ONEMIN = constants.ONEMIN;
	            var ONESEC = constants.ONESEC;
	            var MINUS_SIGN = constants.MINUS_SIGN;
	            var BADNUM = constants.BADNUM;
	            var ZERO_PATH = {
	              K: "zeroline"
	            };
	            var GRID_PATH = {
	              K: "gridline",
	              L: "path"
	            };
	            var MINORGRID_PATH = {
	              K: "minor-gridline",
	              L: "path"
	            };
	            var TICK_PATH = {
	              K: "tick",
	              L: "path"
	            };
	            var TICK_TEXT = {
	              K: "tick",
	              L: "text"
	            };
	            var MARGIN_MAPPING = {
	              width: ["x", "r", "l", "xl", "xr"],
	              height: ["y", "t", "b", "yt", "yb"],
	              right: ["r", "xr"],
	              left: ["l", "xl"],
	              top: ["t", "yt"],
	              bottom: ["b", "yb"]
	            };
	            var alignmentConstants = __webpack_require__2(18783);
	            var MID_SHIFT = alignmentConstants.MID_SHIFT;
	            var CAP_SHIFT = alignmentConstants.CAP_SHIFT;
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var OPPOSITE_SIDE = alignmentConstants.OPPOSITE_SIDE;
	            var TEXTPAD = 3;
	            var axes = module2.exports = {};
	            axes.setConvert = __webpack_require__2(21994);
	            var autoType = __webpack_require__2(4322);
	            var axisIds = __webpack_require__2(41675);
	            var idSort = axisIds.idSort;
	            var isLinked = axisIds.isLinked;
	            axes.id2name = axisIds.id2name;
	            axes.name2id = axisIds.name2id;
	            axes.cleanId = axisIds.cleanId;
	            axes.list = axisIds.list;
	            axes.listIds = axisIds.listIds;
	            axes.getFromId = axisIds.getFromId;
	            axes.getFromTrace = axisIds.getFromTrace;
	            var autorange = __webpack_require__2(71739);
	            axes.getAutoRange = autorange.getAutoRange;
	            axes.findExtremes = autorange.findExtremes;
	            var epsilon = 1e-4;
	            function expandRange(range2) {
	              var delta = (range2[1] - range2[0]) * epsilon;
	              return [range2[0] - delta, range2[1] + delta];
	            }
	            axes.coerceRef = function(containerIn, containerOut, gd, attr, dflt, extraOption) {
	              var axLetter = attr.charAt(attr.length - 1);
	              var axlist = gd._fullLayout._subplots[axLetter + "axis"];
	              var refAttr = attr + "ref";
	              var attrDef = {};
	              if (!dflt) dflt = axlist[0] || (typeof extraOption === "string" ? extraOption : extraOption[0]);
	              if (!extraOption) extraOption = dflt;
	              axlist = axlist.concat(axlist.map(function(x) {
	                return x + " domain";
	              }));
	              attrDef[refAttr] = {
	                valType: "enumerated",
	                values: axlist.concat(extraOption ? typeof extraOption === "string" ? [extraOption] : extraOption : []),
	                dflt
	              };
	              return Lib.coerce(containerIn, containerOut, attrDef, refAttr);
	            };
	            axes.getRefType = function(ar) {
	              if (ar === undefined) {
	                return ar;
	              }
	              if (ar === "paper") {
	                return "paper";
	              }
	              if (ar === "pixel") {
	                return "pixel";
	              }
	              if (/( domain)$/.test(ar)) {
	                return "domain";
	              } else {
	                return "range";
	              }
	            };
	            axes.coercePosition = function(containerOut, gd, coerce, axRef, attr, dflt) {
	              var cleanPos, pos;
	              var axRefType = axes.getRefType(axRef);
	              if (axRefType !== "range") {
	                cleanPos = Lib.ensureNumber;
	                pos = coerce(attr, dflt);
	              } else {
	                var ax = axes.getFromId(gd, axRef);
	                dflt = ax.fraction2r(dflt);
	                pos = coerce(attr, dflt);
	                cleanPos = ax.cleanPos;
	              }
	              containerOut[attr] = cleanPos(pos);
	            };
	            axes.cleanPosition = function(pos, gd, axRef) {
	              var cleanPos = axRef === "paper" || axRef === "pixel" ? Lib.ensureNumber : axes.getFromId(gd, axRef).cleanPos;
	              return cleanPos(pos);
	            };
	            axes.redrawComponents = function(gd, axIds) {
	              axIds = axIds ? axIds : axes.listIds(gd);
	              var fullLayout = gd._fullLayout;
	              function _redrawOneComp(moduleName, methodName, stashName, shortCircuit) {
	                var method = Registry.getComponentMethod(moduleName, methodName);
	                var stash = {};
	                for (var i = 0; i < axIds.length; i++) {
	                  var ax = fullLayout[axes.id2name(axIds[i])];
	                  var indices = ax[stashName];
	                  for (var j = 0; j < indices.length; j++) {
	                    var ind = indices[j];
	                    if (!stash[ind]) {
	                      method(gd, ind);
	                      stash[ind] = 1;
	                      if (shortCircuit) return;
	                    }
	                  }
	                }
	              }
	              _redrawOneComp("annotations", "drawOne", "_annIndices");
	              _redrawOneComp("shapes", "drawOne", "_shapeIndices");
	              _redrawOneComp("images", "draw", "_imgIndices", true);
	              _redrawOneComp("selections", "drawOne", "_selectionIndices");
	            };
	            var getDataConversions = axes.getDataConversions = function(gd, trace, target, targetArray) {
	              var ax;
	              var d2cTarget = target === "x" || target === "y" || target === "z" ? target : targetArray;
	              if (Array.isArray(d2cTarget)) {
	                ax = {
	                  type: autoType(targetArray, undefined, {
	                    autotypenumbers: gd._fullLayout.autotypenumbers
	                  }),
	                  _categories: []
	                };
	                axes.setConvert(ax);
	                if (ax.type === "category") {
	                  for (var i = 0; i < targetArray.length; i++) {
	                    ax.d2c(targetArray[i]);
	                  }
	                }
	              } else {
	                ax = axes.getFromTrace(gd, trace, d2cTarget);
	              }
	              if (ax) return {
	                d2c: ax.d2c,
	                c2d: ax.c2d
	              };
	              if (d2cTarget === "ids") return {
	                d2c: toString,
	                c2d: toString
	              };
	              return {
	                d2c: toNum,
	                c2d: toNum
	              };
	            };
	            function toNum(v) {
	              return +v;
	            }
	            function toString(v) {
	              return String(v);
	            }
	            axes.getDataToCoordFunc = function(gd, trace, target, targetArray) {
	              return getDataConversions(gd, trace, target, targetArray).d2c;
	            };
	            axes.counterLetter = function(id) {
	              var axLetter = id.charAt(0);
	              if (axLetter === "x") return "y";
	              if (axLetter === "y") return "x";
	            };
	            axes.minDtick = function(ax, newDiff, newFirst, allow) {
	              if (["log", "category", "multicategory"].indexOf(ax.type) !== -1 || !allow) {
	                ax._minDtick = 0;
	              } else if (ax._minDtick === undefined) {
	                ax._minDtick = newDiff;
	                ax._forceTick0 = newFirst;
	              } else if (ax._minDtick) {
	                if ((ax._minDtick / newDiff + 1e-6) % 1 < 2e-6 && // existing minDtick is an integer multiple of newDiff
	                // (within rounding err)
	                // and forceTick0 can be shifted to newFirst
	                ((newFirst - ax._forceTick0) / newDiff % 1 + 1.000001) % 1 < 2e-6) {
	                  ax._minDtick = newDiff;
	                  ax._forceTick0 = newFirst;
	                } else if ((newDiff / ax._minDtick + 1e-6) % 1 > 2e-6 || // if the converse is true (newDiff is a multiple of minDtick and
	                // newFirst can be shifted to forceTick0) then do nothing - same
	                // forcing stands. Otherwise, cancel forced minimum
	                ((newFirst - ax._forceTick0) / ax._minDtick % 1 + 1.000001) % 1 > 2e-6) {
	                  ax._minDtick = 0;
	                }
	              }
	            };
	            axes.saveRangeInitial = function(gd, overwrite) {
	              var axList = axes.list(gd, "", true);
	              var hasOneAxisChanged = false;
	              for (var i = 0; i < axList.length; i++) {
	                var ax = axList[i];
	                var isNew = ax._rangeInitial0 === undefined && ax._rangeInitial1 === undefined;
	                var hasChanged = isNew || ax.range[0] !== ax._rangeInitial0 || ax.range[1] !== ax._rangeInitial1;
	                var autorange2 = ax.autorange;
	                if (isNew && autorange2 !== true || overwrite && hasChanged) {
	                  ax._rangeInitial0 = autorange2 === "min" || autorange2 === "max reversed" ? undefined : ax.range[0];
	                  ax._rangeInitial1 = autorange2 === "max" || autorange2 === "min reversed" ? undefined : ax.range[1];
	                  ax._autorangeInitial = autorange2;
	                  hasOneAxisChanged = true;
	                }
	              }
	              return hasOneAxisChanged;
	            };
	            axes.saveShowSpikeInitial = function(gd, overwrite) {
	              var axList = axes.list(gd, "", true);
	              var hasOneAxisChanged = false;
	              var allSpikesEnabled = "on";
	              for (var i = 0; i < axList.length; i++) {
	                var ax = axList[i];
	                var isNew = ax._showSpikeInitial === undefined;
	                var hasChanged = isNew || !(ax.showspikes === ax._showspikes);
	                if (isNew || overwrite && hasChanged) {
	                  ax._showSpikeInitial = ax.showspikes;
	                  hasOneAxisChanged = true;
	                }
	                if (allSpikesEnabled === "on" && !ax.showspikes) {
	                  allSpikesEnabled = "off";
	                }
	              }
	              gd._fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
	              return hasOneAxisChanged;
	            };
	            axes.autoBin = function(data, ax, nbins, is2d, calendar, size) {
	              var dataMin = Lib.aggNums(Math.min, null, data);
	              var dataMax = Lib.aggNums(Math.max, null, data);
	              if (ax.type === "category" || ax.type === "multicategory") {
	                return {
	                  start: dataMin - 0.5,
	                  end: dataMax + 0.5,
	                  size: Math.max(1, Math.round(size) || 1),
	                  _dataSpan: dataMax - dataMin
	                };
	              }
	              if (!calendar) calendar = ax.calendar;
	              var dummyAx;
	              if (ax.type === "log") {
	                dummyAx = {
	                  type: "linear",
	                  range: [dataMin, dataMax]
	                };
	              } else {
	                dummyAx = {
	                  type: ax.type,
	                  range: Lib.simpleMap([dataMin, dataMax], ax.c2r, 0, calendar),
	                  calendar
	                };
	              }
	              axes.setConvert(dummyAx);
	              size = size && cleanTicks.dtick(size, dummyAx.type);
	              if (size) {
	                dummyAx.dtick = size;
	                dummyAx.tick0 = cleanTicks.tick0(undefined, dummyAx.type, calendar);
	              } else {
	                var size0;
	                if (nbins) size0 = (dataMax - dataMin) / nbins;
	                else {
	                  var distinctData = Lib.distinctVals(data);
	                  var msexp = Math.pow(10, Math.floor(Math.log(distinctData.minDiff) / Math.LN10));
	                  var minSize = msexp * Lib.roundUp(distinctData.minDiff / msexp, [0.9, 1.9, 4.9, 9.9], true);
	                  size0 = Math.max(minSize, 2 * Lib.stdev(data) / Math.pow(data.length, is2d ? 0.25 : 0.4));
	                  if (!isNumeric(size0)) size0 = 1;
	                }
	                axes.autoTicks(dummyAx, size0);
	              }
	              var finalSize = dummyAx.dtick;
	              var binStart = axes.tickIncrement(axes.tickFirst(dummyAx), finalSize, "reverse", calendar);
	              var binEnd, bincount;
	              if (typeof finalSize === "number") {
	                binStart = autoShiftNumericBins(binStart, data, dummyAx, dataMin, dataMax);
	                bincount = 1 + Math.floor((dataMax - binStart) / finalSize);
	                binEnd = binStart + bincount * finalSize;
	              } else {
	                if (dummyAx.dtick.charAt(0) === "M") {
	                  binStart = autoShiftMonthBins(binStart, data, finalSize, dataMin, calendar);
	                }
	                binEnd = binStart;
	                bincount = 0;
	                while (binEnd <= dataMax) {
	                  binEnd = axes.tickIncrement(binEnd, finalSize, false, calendar);
	                  bincount++;
	                }
	              }
	              return {
	                start: ax.c2r(binStart, 0, calendar),
	                end: ax.c2r(binEnd, 0, calendar),
	                size: finalSize,
	                _dataSpan: dataMax - dataMin
	              };
	            };
	            function autoShiftNumericBins(binStart, data, ax, dataMin, dataMax) {
	              var edgecount = 0;
	              var midcount = 0;
	              var intcount = 0;
	              var blankCount = 0;
	              function nearEdge(v) {
	                return (1 + (v - binStart) * 100 / ax.dtick) % 100 < 2;
	              }
	              for (var i = 0; i < data.length; i++) {
	                if (data[i] % 1 === 0) intcount++;
	                else if (!isNumeric(data[i])) blankCount++;
	                if (nearEdge(data[i])) edgecount++;
	                if (nearEdge(data[i] + ax.dtick / 2)) midcount++;
	              }
	              var dataCount = data.length - blankCount;
	              if (intcount === dataCount && ax.type !== "date") {
	                if (ax.dtick < 1) {
	                  binStart = dataMin - 0.5 * ax.dtick;
	                } else {
	                  binStart -= 0.5;
	                  if (binStart + ax.dtick < dataMin) binStart += ax.dtick;
	                }
	              } else if (midcount < dataCount * 0.1) {
	                if (edgecount > dataCount * 0.3 || nearEdge(dataMin) || nearEdge(dataMax)) {
	                  var binshift = ax.dtick / 2;
	                  binStart += binStart + binshift < dataMin ? binshift : -binshift;
	                }
	              }
	              return binStart;
	            }
	            function autoShiftMonthBins(binStart, data, dtick, dataMin, calendar) {
	              var stats = Lib.findExactDates(data, calendar);
	              var threshold = 0.8;
	              if (stats.exactDays > threshold) {
	                var numMonths = Number(dtick.substr(1));
	                if (stats.exactYears > threshold && numMonths % 12 === 0) {
	                  binStart = axes.tickIncrement(binStart, "M6", "reverse") + ONEDAY * 1.5;
	                } else if (stats.exactMonths > threshold) {
	                  binStart = axes.tickIncrement(binStart, "M1", "reverse") + ONEDAY * 15.5;
	                } else {
	                  binStart -= HALFDAY;
	                }
	                var nextBinStart = axes.tickIncrement(binStart, dtick);
	                if (nextBinStart <= dataMin) return nextBinStart;
	              }
	              return binStart;
	            }
	            axes.prepMinorTicks = function(mockAx, ax, opts) {
	              if (!ax.minor.dtick) {
	                delete mockAx.dtick;
	                var hasMajor = ax.dtick && isNumeric(ax._tmin);
	                var mockMinorRange;
	                if (hasMajor) {
	                  var tick2 = axes.tickIncrement(ax._tmin, ax.dtick, true);
	                  mockMinorRange = [ax._tmin, tick2 * 0.99 + ax._tmin * 0.01];
	                } else {
	                  var rl = Lib.simpleMap(ax.range, ax.r2l);
	                  mockMinorRange = [rl[0], 0.8 * rl[0] + 0.2 * rl[1]];
	                }
	                mockAx.range = Lib.simpleMap(mockMinorRange, ax.l2r);
	                mockAx._isMinor = true;
	                axes.prepTicks(mockAx, opts);
	                if (hasMajor) {
	                  var numericMajor = isNumeric(ax.dtick);
	                  var numericMinor = isNumeric(mockAx.dtick);
	                  var majorNum = numericMajor ? ax.dtick : +ax.dtick.substring(1);
	                  var minorNum = numericMinor ? mockAx.dtick : +mockAx.dtick.substring(1);
	                  if (numericMajor && numericMinor) {
	                    if (!isMultiple(majorNum, minorNum)) {
	                      if (majorNum === 2 * ONEWEEK && minorNum === 3 * ONEDAY) {
	                        mockAx.dtick = ONEWEEK;
	                      } else if (majorNum === ONEWEEK && !(ax._input.minor || {}).nticks) {
	                        mockAx.dtick = ONEDAY;
	                      } else if (isClose(majorNum / minorNum, 2.5)) {
	                        mockAx.dtick = majorNum / 2;
	                      } else {
	                        mockAx.dtick = majorNum;
	                      }
	                    } else if (majorNum === 2 * ONEWEEK && minorNum === 2 * ONEDAY) {
	                      mockAx.dtick = ONEWEEK;
	                    }
	                  } else if (String(ax.dtick).charAt(0) === "M") {
	                    if (numericMinor) {
	                      mockAx.dtick = "M1";
	                    } else {
	                      if (!isMultiple(majorNum, minorNum)) {
	                        mockAx.dtick = ax.dtick;
	                      } else if (majorNum >= 12 && minorNum === 2) {
	                        mockAx.dtick = "M3";
	                      }
	                    }
	                  } else if (String(mockAx.dtick).charAt(0) === "L") {
	                    if (String(ax.dtick).charAt(0) === "L") {
	                      if (!isMultiple(majorNum, minorNum)) {
	                        mockAx.dtick = isClose(majorNum / minorNum, 2.5) ? ax.dtick / 2 : ax.dtick;
	                      }
	                    } else {
	                      mockAx.dtick = "D1";
	                    }
	                  } else if (mockAx.dtick === "D2" && +ax.dtick > 1) {
	                    mockAx.dtick = 1;
	                  }
	                }
	                mockAx.range = ax.range;
	              }
	              if (ax.minor._tick0Init === undefined) {
	                mockAx.tick0 = ax.tick0;
	              }
	            };
	            function isMultiple(bigger, smaller) {
	              return Math.abs((bigger / smaller + 0.5) % 1 - 0.5) < 1e-3;
	            }
	            function isClose(a, b) {
	              return Math.abs(a / b - 1) < 1e-3;
	            }
	            axes.prepTicks = function(ax, opts) {
	              var rng = Lib.simpleMap(ax.range, ax.r2l, undefined, undefined, opts);
	              if (ax.tickmode === "auto" || !ax.dtick) {
	                var nt = ax.nticks;
	                var minPx;
	                if (!nt) {
	                  if (ax.type === "category" || ax.type === "multicategory") {
	                    minPx = ax.tickfont ? Lib.bigFont(ax.tickfont.size || 12) : 15;
	                    nt = ax._length / minPx;
	                  } else {
	                    minPx = ax._id.charAt(0) === "y" ? 40 : 80;
	                    nt = Lib.constrain(ax._length / minPx, 4, 9) + 1;
	                  }
	                  if (ax._name === "radialaxis") nt *= 2;
	                }
	                if (!(ax.minor && ax.minor.tickmode !== "array")) {
	                  if (ax.tickmode === "array") nt *= 100;
	                }
	                ax._roughDTick = Math.abs(rng[1] - rng[0]) / nt;
	                axes.autoTicks(ax, ax._roughDTick);
	                if (ax._minDtick > 0 && ax.dtick < ax._minDtick * 2) {
	                  ax.dtick = ax._minDtick;
	                  ax.tick0 = ax.l2r(ax._forceTick0);
	                }
	              }
	              if (ax.ticklabelmode === "period") {
	                adjustPeriodDelta(ax);
	              }
	              if (!ax.tick0) {
	                ax.tick0 = ax.type === "date" ? "2000-01-01" : 0;
	              }
	              if (ax.type === "date" && ax.dtick < 0.1) ax.dtick = 0.1;
	              autoTickRound(ax);
	            };
	            function nMonths(dtick) {
	              return +dtick.substring(1);
	            }
	            function adjustPeriodDelta(ax) {
	              var definedDelta;
	              function mDate() {
	                return !(isNumeric(ax.dtick) || ax.dtick.charAt(0) !== "M");
	              }
	              var isMDate = mDate();
	              var tickformat = axes.getTickFormat(ax);
	              if (tickformat) {
	                var noDtick = ax._dtickInit !== ax.dtick;
	                if (!/%[fLQsSMX]/.test(tickformat)) {
	                  if (/%[HI]/.test(tickformat)) {
	                    definedDelta = ONEHOUR;
	                    if (noDtick && !isMDate && ax.dtick < ONEHOUR) ax.dtick = ONEHOUR;
	                  } else if (/%p/.test(tickformat)) {
	                    definedDelta = HALFDAY;
	                    if (noDtick && !isMDate && ax.dtick < HALFDAY) ax.dtick = HALFDAY;
	                  } else if (/%[Aadejuwx]/.test(tickformat)) {
	                    definedDelta = ONEDAY;
	                    if (noDtick && !isMDate && ax.dtick < ONEDAY) ax.dtick = ONEDAY;
	                  } else if (/%[UVW]/.test(tickformat)) {
	                    definedDelta = ONEWEEK;
	                    if (noDtick && !isMDate && ax.dtick < ONEWEEK) ax.dtick = ONEWEEK;
	                  } else if (/%[Bbm]/.test(tickformat)) {
	                    definedDelta = ONEAVGMONTH;
	                    if (noDtick && (isMDate ? nMonths(ax.dtick) < 1 : ax.dtick < ONEMINMONTH)) ax.dtick = "M1";
	                  } else if (/%[q]/.test(tickformat)) {
	                    definedDelta = ONEAVGQUARTER;
	                    if (noDtick && (isMDate ? nMonths(ax.dtick) < 3 : ax.dtick < ONEMINQUARTER)) ax.dtick = "M3";
	                  } else if (/%[Yy]/.test(tickformat)) {
	                    definedDelta = ONEAVGYEAR;
	                    if (noDtick && (isMDate ? nMonths(ax.dtick) < 12 : ax.dtick < ONEMINYEAR)) ax.dtick = "M12";
	                  }
	                }
	              }
	              isMDate = mDate();
	              if (isMDate && ax.tick0 === ax._dowTick0) {
	                ax.tick0 = ax._rawTick0;
	              }
	              ax._definedDelta = definedDelta;
	            }
	            function positionPeriodTicks(tickVals, ax, definedDelta) {
	              for (var i = 0; i < tickVals.length; i++) {
	                var v = tickVals[i].value;
	                var a = i;
	                var b = i + 1;
	                if (i < tickVals.length - 1) {
	                  a = i;
	                  b = i + 1;
	                } else if (i > 0) {
	                  a = i - 1;
	                  b = i;
	                } else {
	                  a = i;
	                  b = i;
	                }
	                var A = tickVals[a].value;
	                var B = tickVals[b].value;
	                var actualDelta = Math.abs(B - A);
	                var delta = definedDelta || actualDelta;
	                var periodLength = 0;
	                if (delta >= ONEMINYEAR) {
	                  if (actualDelta >= ONEMINYEAR && actualDelta <= ONEMAXYEAR) {
	                    periodLength = actualDelta;
	                  } else {
	                    periodLength = ONEAVGYEAR;
	                  }
	                } else if (definedDelta === ONEAVGQUARTER && delta >= ONEMINQUARTER) {
	                  if (actualDelta >= ONEMINQUARTER && actualDelta <= ONEMAXQUARTER) {
	                    periodLength = actualDelta;
	                  } else {
	                    periodLength = ONEAVGQUARTER;
	                  }
	                } else if (delta >= ONEMINMONTH) {
	                  if (actualDelta >= ONEMINMONTH && actualDelta <= ONEMAXMONTH) {
	                    periodLength = actualDelta;
	                  } else {
	                    periodLength = ONEAVGMONTH;
	                  }
	                } else if (definedDelta === ONEWEEK && delta >= ONEWEEK) {
	                  periodLength = ONEWEEK;
	                } else if (delta >= ONEDAY) {
	                  periodLength = ONEDAY;
	                } else if (definedDelta === HALFDAY && delta >= HALFDAY) {
	                  periodLength = HALFDAY;
	                } else if (definedDelta === ONEHOUR && delta >= ONEHOUR) {
	                  periodLength = ONEHOUR;
	                }
	                var inBetween;
	                if (periodLength >= actualDelta) {
	                  periodLength = actualDelta;
	                  inBetween = true;
	                }
	                var endPeriod = v + periodLength;
	                if (ax.rangebreaks && periodLength > 0) {
	                  var nAll = 84;
	                  var n = 0;
	                  for (var c = 0; c < nAll; c++) {
	                    var r = (c + 0.5) / nAll;
	                    if (ax.maskBreaks(v * (1 - r) + r * endPeriod) !== BADNUM) n++;
	                  }
	                  periodLength *= n / nAll;
	                  if (!periodLength) {
	                    tickVals[i].drop = true;
	                  }
	                  if (inBetween && actualDelta > ONEWEEK) periodLength = actualDelta;
	                }
	                if (periodLength > 0 || // not instant
	                i === 0) {
	                  tickVals[i].periodX = v + periodLength / 2;
	                }
	              }
	            }
	            axes.calcTicks = function calcTicks(ax, opts) {
	              var type = ax.type;
	              var calendar = ax.calendar;
	              var ticklabelstep = ax.ticklabelstep;
	              var isPeriod = ax.ticklabelmode === "period";
	              var rng = Lib.simpleMap(ax.range, ax.r2l, undefined, undefined, opts);
	              var axrev = rng[1] < rng[0];
	              var minRange = Math.min(rng[0], rng[1]);
	              var maxRange = Math.max(rng[0], rng[1]);
	              var maxTicks = Math.max(1e3, ax._length || 0);
	              var ticksOut = [];
	              var minorTicks = [];
	              var tickVals = [];
	              var minorTickVals = [];
	              var hasMinor = ax.minor && (ax.minor.ticks || ax.minor.showgrid);
	              for (var major = 1; major >= (hasMinor ? 0 : 1); major--) {
	                var isMinor = !major;
	                if (major) {
	                  ax._dtickInit = ax.dtick;
	                  ax._tick0Init = ax.tick0;
	                } else {
	                  ax.minor._dtickInit = ax.minor.dtick;
	                  ax.minor._tick0Init = ax.minor.tick0;
	                }
	                var mockAx = major ? ax : Lib.extendFlat({}, ax, ax.minor);
	                if (isMinor) {
	                  axes.prepMinorTicks(mockAx, ax, opts);
	                } else {
	                  axes.prepTicks(mockAx, opts);
	                }
	                if (mockAx.tickmode === "array") {
	                  if (major) {
	                    tickVals = [];
	                    ticksOut = arrayTicks(ax);
	                  } else {
	                    minorTickVals = [];
	                    minorTicks = arrayTicks(ax);
	                  }
	                  continue;
	                }
	                if (mockAx.tickmode === "sync") {
	                  tickVals = [];
	                  ticksOut = syncTicks(ax);
	                  continue;
	                }
	                var exRng = expandRange(rng);
	                var startTick = exRng[0];
	                var endTick = exRng[1];
	                var numDtick = isNumeric(mockAx.dtick);
	                var isDLog = type === "log" && !(numDtick || mockAx.dtick.charAt(0) === "L");
	                var x0 = axes.tickFirst(mockAx, opts);
	                if (major) {
	                  ax._tmin = x0;
	                  if (x0 < startTick !== axrev) break;
	                  if (type === "category" || type === "multicategory") {
	                    endTick = axrev ? Math.max(-0.5, endTick) : Math.min(ax._categories.length - 0.5, endTick);
	                  }
	                }
	                var prevX = null;
	                var x = x0;
	                var majorId;
	                if (major) {
	                  var _dTick;
	                  if (numDtick) {
	                    _dTick = ax.dtick;
	                  } else {
	                    if (type === "date") {
	                      if (typeof ax.dtick === "string" && ax.dtick.charAt(0) === "M") {
	                        _dTick = ONEAVGMONTH * ax.dtick.substring(1);
	                      }
	                    } else {
	                      _dTick = ax._roughDTick;
	                    }
	                  }
	                  majorId = Math.round((ax.r2l(x) - ax.r2l(ax.tick0)) / _dTick) - 1;
	                }
	                var dtick = mockAx.dtick;
	                if (mockAx.rangebreaks && mockAx._tick0Init !== mockAx.tick0) {
	                  x = moveOutsideBreak(x, ax);
	                  if (!axrev) {
	                    x = axes.tickIncrement(x, dtick, !axrev, calendar);
	                  }
	                }
	                if (major && isPeriod) {
	                  x = axes.tickIncrement(x, dtick, !axrev, calendar);
	                  majorId--;
	                }
	                for (; axrev ? x >= endTick : x <= endTick; x = axes.tickIncrement(x, dtick, axrev, calendar)) {
	                  if (major) majorId++;
	                  if (mockAx.rangebreaks) {
	                    if (!axrev) {
	                      if (x < startTick) continue;
	                      if (mockAx.maskBreaks(x) === BADNUM && moveOutsideBreak(x, mockAx) >= maxRange) break;
	                    }
	                  }
	                  if (tickVals.length > maxTicks || x === prevX) break;
	                  prevX = x;
	                  var obj = {
	                    value: x
	                  };
	                  if (major) {
	                    if (isDLog && x !== (x | 0)) {
	                      obj.simpleLabel = true;
	                    }
	                    if (ticklabelstep > 1 && majorId % ticklabelstep) {
	                      obj.skipLabel = true;
	                    }
	                    tickVals.push(obj);
	                  } else {
	                    obj.minor = true;
	                    minorTickVals.push(obj);
	                  }
	                }
	              }
	              if (hasMinor) {
	                var canOverlap = ax.minor.ticks === "inside" && ax.ticks === "outside" || ax.minor.ticks === "outside" && ax.ticks === "inside";
	                if (!canOverlap) {
	                  var majorValues = tickVals.map(function(d) {
	                    return d.value;
	                  });
	                  var list = [];
	                  for (var k = 0; k < minorTickVals.length; k++) {
	                    var T = minorTickVals[k];
	                    var v = T.value;
	                    if (majorValues.indexOf(v) !== -1) {
	                      continue;
	                    }
	                    var found = false;
	                    for (var q = 0; !found && q < tickVals.length; q++) {
	                      if (
	                        // add 10e6 to eliminate problematic digits
	                        1e7 + tickVals[q].value === 1e7 + v
	                      ) {
	                        found = true;
	                      }
	                    }
	                    if (!found) list.push(T);
	                  }
	                  minorTickVals = list;
	                }
	              }
	              if (isPeriod) positionPeriodTicks(tickVals, ax, ax._definedDelta);
	              var i;
	              if (ax.rangebreaks) {
	                var flip = ax._id.charAt(0) === "y";
	                var fontSize = 1;
	                if (ax.tickmode === "auto") {
	                  fontSize = ax.tickfont ? ax.tickfont.size : 12;
	                }
	                var prevL = NaN;
	                for (i = tickVals.length - 1; i > -1; i--) {
	                  if (tickVals[i].drop) {
	                    tickVals.splice(i, 1);
	                    continue;
	                  }
	                  tickVals[i].value = moveOutsideBreak(tickVals[i].value, ax);
	                  var l = ax.c2p(tickVals[i].value);
	                  if (flip ? prevL > l - fontSize : prevL < l + fontSize) {
	                    tickVals.splice(axrev ? i + 1 : i, 1);
	                  } else {
	                    prevL = l;
	                  }
	                }
	              }
	              if (isAngular(ax) && Math.abs(rng[1] - rng[0]) === 360) {
	                tickVals.pop();
	              }
	              ax._tmax = (tickVals[tickVals.length - 1] || {}).value;
	              ax._prevDateHead = "";
	              ax._inCalcTicks = true;
	              var lastVisibleHead;
	              var hideLabel = function(tick) {
	                tick.text = "";
	                ax._prevDateHead = lastVisibleHead;
	              };
	              tickVals = tickVals.concat(minorTickVals);
	              var t, p;
	              for (i = 0; i < tickVals.length; i++) {
	                var _minor = tickVals[i].minor;
	                var _value = tickVals[i].value;
	                if (_minor) {
	                  minorTicks.push({
	                    x: _value,
	                    minor: true
	                  });
	                } else {
	                  lastVisibleHead = ax._prevDateHead;
	                  t = axes.tickText(
	                    ax,
	                    _value,
	                    false,
	                    // hover
	                    tickVals[i].simpleLabel
	                    // noSuffixPrefix
	                  );
	                  p = tickVals[i].periodX;
	                  if (p !== undefined) {
	                    t.periodX = p;
	                    if (p > maxRange || p < minRange) {
	                      if (p > maxRange) t.periodX = maxRange;
	                      if (p < minRange) t.periodX = minRange;
	                      hideLabel(t);
	                    }
	                  }
	                  if (tickVals[i].skipLabel) {
	                    hideLabel(t);
	                  }
	                  ticksOut.push(t);
	                }
	              }
	              ticksOut = ticksOut.concat(minorTicks);
	              ax._inCalcTicks = false;
	              if (isPeriod && ticksOut.length) {
	                ticksOut[0].noTick = true;
	              }
	              return ticksOut;
	            };
	            function filterRangeBreaks(ax, ticksOut) {
	              if (ax.rangebreaks) {
	                ticksOut = ticksOut.filter(function(d) {
	                  return ax.maskBreaks(d.x) !== BADNUM;
	                });
	              }
	              return ticksOut;
	            }
	            function syncTicks(ax) {
	              var baseAxis = ax._mainAxis;
	              var ticksOut = [];
	              if (baseAxis._vals) {
	                for (var i = 0; i < baseAxis._vals.length; i++) {
	                  if (baseAxis._vals[i].noTick) {
	                    continue;
	                  }
	                  var pos = baseAxis.l2p(baseAxis._vals[i].x);
	                  var vali = ax.p2l(pos);
	                  var obj = axes.tickText(ax, vali);
	                  if (baseAxis._vals[i].minor) {
	                    obj.minor = true;
	                    obj.text = "";
	                  }
	                  ticksOut.push(obj);
	                }
	              }
	              ticksOut = filterRangeBreaks(ax, ticksOut);
	              return ticksOut;
	            }
	            function arrayTicks(ax) {
	              var rng = Lib.simpleMap(ax.range, ax.r2l);
	              var exRng = expandRange(rng);
	              var tickMin = Math.min(exRng[0], exRng[1]);
	              var tickMax = Math.max(exRng[0], exRng[1]);
	              var tickVal2l = ax.type === "category" ? ax.d2l_noadd : ax.d2l;
	              if (ax.type === "log" && String(ax.dtick).charAt(0) !== "L") {
	                ax.dtick = "L" + Math.pow(10, Math.floor(Math.min(ax.range[0], ax.range[1])) - 1);
	              }
	              var ticksOut = [];
	              for (var isMinor = 0; isMinor <= 1; isMinor++) {
	                if (isMinor && !ax.minor) continue;
	                var vals = !isMinor ? ax.tickvals : ax.minor.tickvals;
	                var text = !isMinor ? ax.ticktext : [];
	                if (!vals) continue;
	                if (!Array.isArray(text)) text = [];
	                for (var i = 0; i < vals.length; i++) {
	                  var vali = tickVal2l(vals[i]);
	                  if (vali > tickMin && vali < tickMax) {
	                    var obj = text[i] === undefined ? axes.tickText(ax, vali) : tickTextObj(ax, vali, String(text[i]));
	                    if (isMinor) {
	                      obj.minor = true;
	                      obj.text = "";
	                    }
	                    ticksOut.push(obj);
	                  }
	                }
	              }
	              ticksOut = filterRangeBreaks(ax, ticksOut);
	              return ticksOut;
	            }
	            var roundBase10 = [2, 5, 10];
	            var roundBase24 = [1, 2, 3, 6, 12];
	            var roundBase60 = [1, 2, 5, 10, 15, 30];
	            var roundDays = [1, 2, 3, 7, 14];
	            var roundLog1 = [-0.046, 0, 0.301, 0.477, 0.602, 0.699, 0.778, 0.845, 0.903, 0.954, 1];
	            var roundLog2 = [-0.301, 0, 0.301, 0.699, 1];
	            var roundAngles = [15, 30, 45, 90, 180];
	            function roundDTick(roughDTick, base, roundingSet) {
	              return base * Lib.roundUp(roughDTick / base, roundingSet);
	            }
	            axes.autoTicks = function(ax, roughDTick, isMinor) {
	              var base;
	              function getBase(v) {
	                return Math.pow(v, Math.floor(Math.log(roughDTick) / Math.LN10));
	              }
	              if (ax.type === "date") {
	                ax.tick0 = Lib.dateTick0(ax.calendar, 0);
	                var roughX2 = 2 * roughDTick;
	                if (roughX2 > ONEAVGYEAR) {
	                  roughDTick /= ONEAVGYEAR;
	                  base = getBase(10);
	                  ax.dtick = "M" + 12 * roundDTick(roughDTick, base, roundBase10);
	                } else if (roughX2 > ONEAVGMONTH) {
	                  roughDTick /= ONEAVGMONTH;
	                  ax.dtick = "M" + roundDTick(roughDTick, 1, roundBase24);
	                } else if (roughX2 > ONEDAY) {
	                  ax.dtick = roundDTick(roughDTick, ONEDAY, ax._hasDayOfWeekBreaks ? [1, 2, 7, 14] : roundDays);
	                  if (!isMinor) {
	                    var tickformat = axes.getTickFormat(ax);
	                    var isPeriod = ax.ticklabelmode === "period";
	                    if (isPeriod) ax._rawTick0 = ax.tick0;
	                    if (/%[uVW]/.test(tickformat)) {
	                      ax.tick0 = Lib.dateTick0(ax.calendar, 2);
	                    } else {
	                      ax.tick0 = Lib.dateTick0(ax.calendar, 1);
	                    }
	                    if (isPeriod) ax._dowTick0 = ax.tick0;
	                  }
	                } else if (roughX2 > ONEHOUR) {
	                  ax.dtick = roundDTick(roughDTick, ONEHOUR, roundBase24);
	                } else if (roughX2 > ONEMIN) {
	                  ax.dtick = roundDTick(roughDTick, ONEMIN, roundBase60);
	                } else if (roughX2 > ONESEC) {
	                  ax.dtick = roundDTick(roughDTick, ONESEC, roundBase60);
	                } else {
	                  base = getBase(10);
	                  ax.dtick = roundDTick(roughDTick, base, roundBase10);
	                }
	              } else if (ax.type === "log") {
	                ax.tick0 = 0;
	                var rng = Lib.simpleMap(ax.range, ax.r2l);
	                if (ax._isMinor) {
	                  roughDTick *= 1.5;
	                }
	                if (roughDTick > 0.7) {
	                  ax.dtick = Math.ceil(roughDTick);
	                } else if (Math.abs(rng[1] - rng[0]) < 1) {
	                  var nt = 1.5 * Math.abs((rng[1] - rng[0]) / roughDTick);
	                  roughDTick = Math.abs(Math.pow(10, rng[1]) - Math.pow(10, rng[0])) / nt;
	                  base = getBase(10);
	                  ax.dtick = "L" + roundDTick(roughDTick, base, roundBase10);
	                } else {
	                  ax.dtick = roughDTick > 0.3 ? "D2" : "D1";
	                }
	              } else if (ax.type === "category" || ax.type === "multicategory") {
	                ax.tick0 = 0;
	                ax.dtick = Math.ceil(Math.max(roughDTick, 1));
	              } else if (isAngular(ax)) {
	                ax.tick0 = 0;
	                base = 1;
	                ax.dtick = roundDTick(roughDTick, base, roundAngles);
	              } else {
	                ax.tick0 = 0;
	                base = getBase(10);
	                ax.dtick = roundDTick(roughDTick, base, roundBase10);
	              }
	              if (ax.dtick === 0) ax.dtick = 1;
	              if (!isNumeric(ax.dtick) && typeof ax.dtick !== "string") {
	                var olddtick = ax.dtick;
	                ax.dtick = 1;
	                throw "ax.dtick error: " + String(olddtick);
	              }
	            };
	            function autoTickRound(ax) {
	              var dtick = ax.dtick;
	              ax._tickexponent = 0;
	              if (!isNumeric(dtick) && typeof dtick !== "string") {
	                dtick = 1;
	              }
	              if (ax.type === "category" || ax.type === "multicategory") {
	                ax._tickround = null;
	              }
	              if (ax.type === "date") {
	                var tick0ms = ax.r2l(ax.tick0);
	                var tick0str = ax.l2r(tick0ms).replace(/(^-|i)/g, "");
	                var tick0len = tick0str.length;
	                if (String(dtick).charAt(0) === "M") {
	                  if (tick0len > 10 || tick0str.substr(5) !== "01-01") ax._tickround = "d";
	                  else ax._tickround = +dtick.substr(1) % 12 === 0 ? "y" : "m";
	                } else if (dtick >= ONEDAY && tick0len <= 10 || dtick >= ONEDAY * 15) ax._tickround = "d";
	                else if (dtick >= ONEMIN && tick0len <= 16 || dtick >= ONEHOUR) ax._tickround = "M";
	                else if (dtick >= ONESEC && tick0len <= 19 || dtick >= ONEMIN) ax._tickround = "S";
	                else {
	                  var tick1len = ax.l2r(tick0ms + dtick).replace(/^-/, "").length;
	                  ax._tickround = Math.max(tick0len, tick1len) - 20;
	                  if (ax._tickround < 0) ax._tickround = 4;
	                }
	              } else if (isNumeric(dtick) || dtick.charAt(0) === "L") {
	                var rng = ax.range.map(ax.r2d || Number);
	                if (!isNumeric(dtick)) dtick = Number(dtick.substr(1));
	                ax._tickround = 2 - Math.floor(Math.log(dtick) / Math.LN10 + 0.01);
	                var maxend = Math.max(Math.abs(rng[0]), Math.abs(rng[1]));
	                var rangeexp = Math.floor(Math.log(maxend) / Math.LN10 + 0.01);
	                var minexponent = ax.minexponent === undefined ? 3 : ax.minexponent;
	                if (Math.abs(rangeexp) > minexponent) {
	                  if (isSIFormat(ax.exponentformat) && !beyondSI(rangeexp)) {
	                    ax._tickexponent = 3 * Math.round((rangeexp - 1) / 3);
	                  } else ax._tickexponent = rangeexp;
	                }
	              } else {
	                ax._tickround = null;
	              }
	            }
	            axes.tickIncrement = function(x, dtick, axrev, calendar) {
	              var axSign = axrev ? -1 : 1;
	              if (isNumeric(dtick)) return Lib.increment(x, axSign * dtick);
	              var tType = dtick.charAt(0);
	              var dtSigned = axSign * Number(dtick.substr(1));
	              if (tType === "M") return Lib.incrementMonth(x, dtSigned, calendar);
	              if (tType === "L") return Math.log(Math.pow(10, x) + dtSigned) / Math.LN10;
	              if (tType === "D") {
	                var tickset = dtick === "D2" ? roundLog2 : roundLog1;
	                var x2 = x + axSign * 0.01;
	                var frac = Lib.roundUp(Lib.mod(x2, 1), tickset, axrev);
	                return Math.floor(x2) + Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
	              }
	              throw "unrecognized dtick " + String(dtick);
	            };
	            axes.tickFirst = function(ax, opts) {
	              var r2l = ax.r2l || Number;
	              var rng = Lib.simpleMap(ax.range, r2l, undefined, undefined, opts);
	              var axrev = rng[1] < rng[0];
	              var sRound = axrev ? Math.floor : Math.ceil;
	              var r0 = expandRange(rng)[0];
	              var dtick = ax.dtick;
	              var tick0 = r2l(ax.tick0);
	              if (isNumeric(dtick)) {
	                var tmin = sRound((r0 - tick0) / dtick) * dtick + tick0;
	                if (ax.type === "category" || ax.type === "multicategory") {
	                  tmin = Lib.constrain(tmin, 0, ax._categories.length - 1);
	                }
	                return tmin;
	              }
	              var tType = dtick.charAt(0);
	              var dtNum = Number(dtick.substr(1));
	              if (tType === "M") {
	                var cnt = 0;
	                var t0 = tick0;
	                var t1, mult, newDTick;
	                while (cnt < 10) {
	                  t1 = axes.tickIncrement(t0, dtick, axrev, ax.calendar);
	                  if ((t1 - r0) * (t0 - r0) <= 0) {
	                    if (axrev) return Math.min(t0, t1);
	                    return Math.max(t0, t1);
	                  }
	                  mult = (r0 - (t0 + t1) / 2) / (t1 - t0);
	                  newDTick = tType + (Math.abs(Math.round(mult)) || 1) * dtNum;
	                  t0 = axes.tickIncrement(t0, newDTick, mult < 0 ? !axrev : axrev, ax.calendar);
	                  cnt++;
	                }
	                Lib.error("tickFirst did not converge", ax);
	                return t0;
	              } else if (tType === "L") {
	                return Math.log(sRound((Math.pow(10, r0) - tick0) / dtNum) * dtNum + tick0) / Math.LN10;
	              } else if (tType === "D") {
	                var tickset = dtick === "D2" ? roundLog2 : roundLog1;
	                var frac = Lib.roundUp(Lib.mod(r0, 1), tickset, axrev);
	                return Math.floor(r0) + Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
	              } else throw "unrecognized dtick " + String(dtick);
	            };
	            axes.tickText = function(ax, x, hover, noSuffixPrefix) {
	              var out = tickTextObj(ax, x);
	              var arrayMode = ax.tickmode === "array";
	              var extraPrecision = hover || arrayMode;
	              var axType = ax.type;
	              var tickVal2l = axType === "category" ? ax.d2l_noadd : ax.d2l;
	              var i;
	              if (arrayMode && Array.isArray(ax.ticktext)) {
	                var rng = Lib.simpleMap(ax.range, ax.r2l);
	                var minDiff = (Math.abs(rng[1] - rng[0]) - (ax._lBreaks || 0)) / 1e4;
	                for (i = 0; i < ax.ticktext.length; i++) {
	                  if (Math.abs(x - tickVal2l(ax.tickvals[i])) < minDiff) break;
	                }
	                if (i < ax.ticktext.length) {
	                  out.text = String(ax.ticktext[i]);
	                  return out;
	                }
	              }
	              function isHidden(showAttr) {
	                if (showAttr === undefined) return true;
	                if (hover) return showAttr === "none";
	                var firstOrLast = {
	                  first: ax._tmin,
	                  last: ax._tmax
	                }[showAttr];
	                return showAttr !== "all" && x !== firstOrLast;
	              }
	              var hideexp = hover ? "never" : ax.exponentformat !== "none" && isHidden(ax.showexponent) ? "hide" : "";
	              if (axType === "date") formatDate(ax, out, hover, extraPrecision);
	              else if (axType === "log") formatLog(ax, out, hover, extraPrecision, hideexp);
	              else if (axType === "category") formatCategory(ax, out);
	              else if (axType === "multicategory") formatMultiCategory(ax, out, hover);
	              else if (isAngular(ax)) formatAngle(ax, out, hover, extraPrecision, hideexp);
	              else formatLinear(ax, out, hover, extraPrecision, hideexp);
	              if (!noSuffixPrefix) {
	                if (ax.tickprefix && !isHidden(ax.showtickprefix)) out.text = ax.tickprefix + out.text;
	                if (ax.ticksuffix && !isHidden(ax.showticksuffix)) out.text += ax.ticksuffix;
	              }
	              if (ax.labelalias && ax.labelalias.hasOwnProperty(out.text)) {
	                var t = ax.labelalias[out.text];
	                if (typeof t === "string") out.text = t;
	              }
	              if (ax.tickson === "boundaries" || ax.showdividers) {
	                var inbounds = function(v) {
	                  var p = ax.l2p(v);
	                  return p >= 0 && p <= ax._length ? v : null;
	                };
	                out.xbnd = [inbounds(out.x - 0.5), inbounds(out.x + ax.dtick - 0.5)];
	              }
	              return out;
	            };
	            axes.hoverLabelText = function(ax, values, hoverformat) {
	              if (hoverformat) ax = Lib.extendFlat({}, ax, {
	                hoverformat
	              });
	              var val = Array.isArray(values) ? values[0] : values;
	              var val2 = Array.isArray(values) ? values[1] : undefined;
	              if (val2 !== undefined && val2 !== val) {
	                return axes.hoverLabelText(ax, val, hoverformat) + " - " + axes.hoverLabelText(ax, val2, hoverformat);
	              }
	              var logOffScale = ax.type === "log" && val <= 0;
	              var tx = axes.tickText(ax, ax.c2l(logOffScale ? -val : val), "hover").text;
	              if (logOffScale) {
	                return val === 0 ? "0" : MINUS_SIGN + tx;
	              }
	              return tx;
	            };
	            function tickTextObj(ax, x, text) {
	              var tf = ax.tickfont || {};
	              return {
	                x,
	                dx: 0,
	                dy: 0,
	                text: text || "",
	                fontSize: tf.size,
	                font: tf.family,
	                fontColor: tf.color
	              };
	            }
	            function formatDate(ax, out, hover, extraPrecision) {
	              var tr = ax._tickround;
	              var fmt = hover && ax.hoverformat || axes.getTickFormat(ax);
	              extraPrecision = !fmt && extraPrecision;
	              if (extraPrecision) {
	                if (isNumeric(tr)) tr = 4;
	                else tr = {
	                  y: "m",
	                  m: "d",
	                  d: "M",
	                  M: "S",
	                  S: 4
	                }[tr];
	              }
	              var dateStr = Lib.formatDate(out.x, fmt, tr, ax._dateFormat, ax.calendar, ax._extraFormat);
	              var headStr;
	              var splitIndex = dateStr.indexOf("\n");
	              if (splitIndex !== -1) {
	                headStr = dateStr.substr(splitIndex + 1);
	                dateStr = dateStr.substr(0, splitIndex);
	              }
	              if (extraPrecision) {
	                if (headStr !== undefined && (dateStr === "00:00:00" || dateStr === "00:00")) {
	                  dateStr = headStr;
	                  headStr = "";
	                } else if (dateStr.length === 8) {
	                  dateStr = dateStr.replace(/:00$/, "");
	                }
	              }
	              if (headStr) {
	                if (hover) {
	                  if (tr === "d") dateStr += ", " + headStr;
	                  else dateStr = headStr + (dateStr ? ", " + dateStr : "");
	                } else {
	                  if (!ax._inCalcTicks || ax._prevDateHead !== headStr) {
	                    ax._prevDateHead = headStr;
	                    dateStr += "<br>" + headStr;
	                  } else {
	                    var isInside = insideTicklabelposition(ax);
	                    var side = ax._trueSide || ax.side;
	                    if (!isInside && side === "top" || isInside && side === "bottom") {
	                      dateStr += "<br> ";
	                    }
	                  }
	                }
	              }
	              out.text = dateStr;
	            }
	            function formatLog(ax, out, hover, extraPrecision, hideexp) {
	              var dtick = ax.dtick;
	              var x = out.x;
	              var tickformat = ax.tickformat;
	              var dtChar0 = typeof dtick === "string" && dtick.charAt(0);
	              if (hideexp === "never") {
	                hideexp = "";
	              }
	              if (extraPrecision && dtChar0 !== "L") {
	                dtick = "L3";
	                dtChar0 = "L";
	              }
	              if (tickformat || dtChar0 === "L") {
	                out.text = numFormat(Math.pow(10, x), ax, hideexp, extraPrecision);
	              } else if (isNumeric(dtick) || dtChar0 === "D" && Lib.mod(x + 0.01, 1) < 0.1) {
	                var p = Math.round(x);
	                var absP = Math.abs(p);
	                var exponentFormat = ax.exponentformat;
	                if (exponentFormat === "power" || isSIFormat(exponentFormat) && beyondSI(p)) {
	                  if (p === 0) out.text = 1;
	                  else if (p === 1) out.text = "10";
	                  else out.text = "10<sup>" + (p > 1 ? "" : MINUS_SIGN) + absP + "</sup>";
	                  out.fontSize *= 1.25;
	                } else if ((exponentFormat === "e" || exponentFormat === "E") && absP > 2) {
	                  out.text = "1" + exponentFormat + (p > 0 ? "+" : MINUS_SIGN) + absP;
	                } else {
	                  out.text = numFormat(Math.pow(10, x), ax, "", "fakehover");
	                  if (dtick === "D1" && ax._id.charAt(0) === "y") {
	                    out.dy -= out.fontSize / 6;
	                  }
	                }
	              } else if (dtChar0 === "D") {
	                out.text = String(Math.round(Math.pow(10, Lib.mod(x, 1))));
	                out.fontSize *= 0.75;
	              } else throw "unrecognized dtick " + String(dtick);
	              if (ax.dtick === "D1") {
	                var firstChar = String(out.text).charAt(0);
	                if (firstChar === "0" || firstChar === "1") {
	                  if (ax._id.charAt(0) === "y") {
	                    out.dx -= out.fontSize / 4;
	                  } else {
	                    out.dy += out.fontSize / 2;
	                    out.dx += (ax.range[1] > ax.range[0] ? 1 : -1) * out.fontSize * (x < 0 ? 0.5 : 0.25);
	                  }
	                }
	              }
	            }
	            function formatCategory(ax, out) {
	              var tt = ax._categories[Math.round(out.x)];
	              if (tt === undefined) tt = "";
	              out.text = String(tt);
	            }
	            function formatMultiCategory(ax, out, hover) {
	              var v = Math.round(out.x);
	              var cats = ax._categories[v] || [];
	              var tt = cats[1] === undefined ? "" : String(cats[1]);
	              var tt2 = cats[0] === undefined ? "" : String(cats[0]);
	              if (hover) {
	                out.text = tt2 + " - " + tt;
	              } else {
	                out.text = tt;
	                out.text2 = tt2;
	              }
	            }
	            function formatLinear(ax, out, hover, extraPrecision, hideexp) {
	              if (hideexp === "never") {
	                hideexp = "";
	              } else if (ax.showexponent === "all" && Math.abs(out.x / ax.dtick) < 1e-6) {
	                hideexp = "hide";
	              }
	              out.text = numFormat(out.x, ax, hideexp, extraPrecision);
	            }
	            function formatAngle(ax, out, hover, extraPrecision, hideexp) {
	              if (ax.thetaunit === "radians" && !hover) {
	                var num = out.x / 180;
	                if (num === 0) {
	                  out.text = "0";
	                } else {
	                  var frac = num2frac(num);
	                  if (frac[1] >= 100) {
	                    out.text = numFormat(Lib.deg2rad(out.x), ax, hideexp, extraPrecision);
	                  } else {
	                    var isNeg = out.x < 0;
	                    if (frac[1] === 1) {
	                      if (frac[0] === 1) out.text = "π";
	                      else out.text = frac[0] + "π";
	                    } else {
	                      out.text = ["<sup>", frac[0], "</sup>", "⁄", "<sub>", frac[1], "</sub>", "π"].join("");
	                    }
	                    if (isNeg) out.text = MINUS_SIGN + out.text;
	                  }
	                }
	              } else {
	                out.text = numFormat(out.x, ax, hideexp, extraPrecision);
	              }
	            }
	            function num2frac(num) {
	              function almostEq(a, b) {
	                return Math.abs(a - b) <= 1e-6;
	              }
	              function findGCD(a, b) {
	                return almostEq(b, 0) ? a : findGCD(b, a % b);
	              }
	              function findPrecision(n) {
	                var e = 1;
	                while (!almostEq(Math.round(n * e) / e, n)) {
	                  e *= 10;
	                }
	                return e;
	              }
	              var precision = findPrecision(num);
	              var number2 = num * precision;
	              var gcd = Math.abs(findGCD(number2, precision));
	              return [
	                // numerator
	                Math.round(number2 / gcd),
	                // denominator
	                Math.round(precision / gcd)
	              ];
	            }
	            var SIPREFIXES = ["f", "p", "n", "μ", "m", "", "k", "M", "G", "T"];
	            function isSIFormat(exponentFormat) {
	              return exponentFormat === "SI" || exponentFormat === "B";
	            }
	            function beyondSI(exponent) {
	              return exponent > 14 || exponent < -15;
	            }
	            function numFormat(v, ax, fmtoverride, hover) {
	              var isNeg = v < 0;
	              var tickRound = ax._tickround;
	              var exponentFormat = fmtoverride || ax.exponentformat || "B";
	              var exponent = ax._tickexponent;
	              var tickformat = axes.getTickFormat(ax);
	              var separatethousands = ax.separatethousands;
	              if (hover) {
	                var ah = {
	                  exponentformat: exponentFormat,
	                  minexponent: ax.minexponent,
	                  dtick: ax.showexponent === "none" ? ax.dtick : isNumeric(v) ? Math.abs(v) || 1 : 1,
	                  // if not showing any exponents, don't change the exponent
	                  // from what we calculate
	                  range: ax.showexponent === "none" ? ax.range.map(ax.r2d) : [0, v || 1]
	                };
	                autoTickRound(ah);
	                tickRound = (Number(ah._tickround) || 0) + 4;
	                exponent = ah._tickexponent;
	                if (ax.hoverformat) tickformat = ax.hoverformat;
	              }
	              if (tickformat) return ax._numFormat(tickformat)(v).replace(/-/g, MINUS_SIGN);
	              var e = Math.pow(10, -tickRound) / 2;
	              if (exponentFormat === "none") exponent = 0;
	              v = Math.abs(v);
	              if (v < e) {
	                v = "0";
	                isNeg = false;
	              } else {
	                v += e;
	                if (exponent) {
	                  v *= Math.pow(10, -exponent);
	                  tickRound += exponent;
	                }
	                if (tickRound === 0) v = String(Math.floor(v));
	                else if (tickRound < 0) {
	                  v = String(Math.round(v));
	                  v = v.substr(0, v.length + tickRound);
	                  for (var i = tickRound; i < 0; i++) v += "0";
	                } else {
	                  v = String(v);
	                  var dp = v.indexOf(".") + 1;
	                  if (dp) v = v.substr(0, dp + tickRound).replace(/\.?0+$/, "");
	                }
	                v = Lib.numSeparate(v, ax._separators, separatethousands);
	              }
	              if (exponent && exponentFormat !== "hide") {
	                if (isSIFormat(exponentFormat) && beyondSI(exponent)) exponentFormat = "power";
	                var signedExponent;
	                if (exponent < 0) signedExponent = MINUS_SIGN + -exponent;
	                else if (exponentFormat !== "power") signedExponent = "+" + exponent;
	                else signedExponent = String(exponent);
	                if (exponentFormat === "e" || exponentFormat === "E") {
	                  v += exponentFormat + signedExponent;
	                } else if (exponentFormat === "power") {
	                  v += "×10<sup>" + signedExponent + "</sup>";
	                } else if (exponentFormat === "B" && exponent === 9) {
	                  v += "B";
	                } else if (isSIFormat(exponentFormat)) {
	                  v += SIPREFIXES[exponent / 3 + 5];
	                }
	              }
	              if (isNeg) return MINUS_SIGN + v;
	              return v;
	            }
	            axes.getTickFormat = function(ax) {
	              var i;
	              function convertToMs(dtick) {
	                return typeof dtick !== "string" ? dtick : Number(dtick.replace("M", "")) * ONEAVGMONTH;
	              }
	              function compareLogTicks(left, right) {
	                var priority = ["L", "D"];
	                if (typeof left === typeof right) {
	                  if (typeof left === "number") {
	                    return left - right;
	                  } else {
	                    var leftPriority = priority.indexOf(left.charAt(0));
	                    var rightPriority = priority.indexOf(right.charAt(0));
	                    if (leftPriority === rightPriority) {
	                      return Number(left.replace(/(L|D)/g, "")) - Number(right.replace(/(L|D)/g, ""));
	                    } else {
	                      return leftPriority - rightPriority;
	                    }
	                  }
	                } else {
	                  return typeof left === "number" ? 1 : -1;
	                }
	              }
	              function isProperStop(dtick, range2, convert) {
	                var convertFn = convert;
	                var leftDtick = range2[0];
	                var rightDtick = range2[1];
	                return (!leftDtick && typeof leftDtick !== "number" || convertFn(leftDtick) <= convertFn(dtick)) && (!rightDtick && typeof rightDtick !== "number" || convertFn(rightDtick) >= convertFn(dtick));
	              }
	              function isProperLogStop(dtick, range2) {
	                var isLeftDtickNull = range2[0] === null;
	                var isRightDtickNull = range2[1] === null;
	                var isDtickInRangeLeft = compareLogTicks(dtick, range2[0]) >= 0;
	                var isDtickInRangeRight = compareLogTicks(dtick, range2[1]) <= 0;
	                return (isLeftDtickNull || isDtickInRangeLeft) && (isRightDtickNull || isDtickInRangeRight);
	              }
	              var tickstop, stopi;
	              if (ax.tickformatstops && ax.tickformatstops.length > 0) {
	                switch (ax.type) {
	                  case "date":
	                  case "linear": {
	                    for (i = 0; i < ax.tickformatstops.length; i++) {
	                      stopi = ax.tickformatstops[i];
	                      if (stopi.enabled && isProperStop(ax.dtick, stopi.dtickrange, convertToMs)) {
	                        tickstop = stopi;
	                        break;
	                      }
	                    }
	                    break;
	                  }
	                  case "log": {
	                    for (i = 0; i < ax.tickformatstops.length; i++) {
	                      stopi = ax.tickformatstops[i];
	                      if (stopi.enabled && isProperLogStop(ax.dtick, stopi.dtickrange)) {
	                        tickstop = stopi;
	                        break;
	                      }
	                    }
	                    break;
	                  }
	                }
	              }
	              return tickstop ? tickstop.value : ax.tickformat;
	            };
	            axes.getSubplots = function(gd, ax) {
	              var subplotObj = gd._fullLayout._subplots;
	              var allSubplots = subplotObj.cartesian.concat(subplotObj.gl2d || []);
	              var out = ax ? axes.findSubplotsWithAxis(allSubplots, ax) : allSubplots;
	              out.sort(function(a, b) {
	                var aParts = a.substr(1).split("y");
	                var bParts = b.substr(1).split("y");
	                if (aParts[0] === bParts[0]) return +aParts[1] - +bParts[1];
	                return +aParts[0] - +bParts[0];
	              });
	              return out;
	            };
	            axes.findSubplotsWithAxis = function(subplots, ax) {
	              var axMatch = new RegExp(ax._id.charAt(0) === "x" ? "^" + ax._id + "y" : ax._id + "$");
	              var subplotsWithAx = [];
	              for (var i = 0; i < subplots.length; i++) {
	                var sp = subplots[i];
	                if (axMatch.test(sp)) subplotsWithAx.push(sp);
	              }
	              return subplotsWithAx;
	            };
	            axes.makeClipPaths = function(gd) {
	              var fullLayout = gd._fullLayout;
	              if (fullLayout._hasOnlyLargeSploms) return;
	              var fullWidth = {
	                _offset: 0,
	                _length: fullLayout.width,
	                _id: ""
	              };
	              var fullHeight = {
	                _offset: 0,
	                _length: fullLayout.height,
	                _id: ""
	              };
	              var xaList = axes.list(gd, "x", true);
	              var yaList = axes.list(gd, "y", true);
	              var clipList = [];
	              var i, j;
	              for (i = 0; i < xaList.length; i++) {
	                clipList.push({
	                  x: xaList[i],
	                  y: fullHeight
	                });
	                for (j = 0; j < yaList.length; j++) {
	                  if (i === 0) clipList.push({
	                    x: fullWidth,
	                    y: yaList[j]
	                  });
	                  clipList.push({
	                    x: xaList[i],
	                    y: yaList[j]
	                  });
	                }
	              }
	              var axClips = fullLayout._clips.selectAll(".axesclip").data(clipList, function(d) {
	                return d.x._id + d.y._id;
	              });
	              axClips.enter().append("clipPath").classed("axesclip", true).attr("id", function(d) {
	                return "clip" + fullLayout._uid + d.x._id + d.y._id;
	              }).append("rect");
	              axClips.exit().remove();
	              axClips.each(function(d) {
	                d3.select(this).select("rect").attr({
	                  x: d.x._offset || 0,
	                  y: d.y._offset || 0,
	                  width: d.x._length || 1,
	                  height: d.y._length || 1
	                });
	              });
	            };
	            axes.draw = function(gd, arg, opts) {
	              var fullLayout = gd._fullLayout;
	              if (arg === "redraw") {
	                fullLayout._paper.selectAll("g.subplot").each(function(d) {
	                  var id = d[0];
	                  var plotinfo = fullLayout._plots[id];
	                  if (plotinfo) {
	                    var xa = plotinfo.xaxis;
	                    var ya = plotinfo.yaxis;
	                    plotinfo.xaxislayer.selectAll("." + xa._id + "tick").remove();
	                    plotinfo.yaxislayer.selectAll("." + ya._id + "tick").remove();
	                    plotinfo.xaxislayer.selectAll("." + xa._id + "tick2").remove();
	                    plotinfo.yaxislayer.selectAll("." + ya._id + "tick2").remove();
	                    plotinfo.xaxislayer.selectAll("." + xa._id + "divider").remove();
	                    plotinfo.yaxislayer.selectAll("." + ya._id + "divider").remove();
	                    if (plotinfo.minorGridlayer) plotinfo.minorGridlayer.selectAll("path").remove();
	                    if (plotinfo.gridlayer) plotinfo.gridlayer.selectAll("path").remove();
	                    if (plotinfo.zerolinelayer) plotinfo.zerolinelayer.selectAll("path").remove();
	                    fullLayout._infolayer.select(".g-" + xa._id + "title").remove();
	                    fullLayout._infolayer.select(".g-" + ya._id + "title").remove();
	                  }
	                });
	              }
	              var axList = !arg || arg === "redraw" ? axes.listIds(gd) : arg;
	              var fullAxList = axes.list(gd);
	              var overlayingShiftedAx = fullAxList.filter(function(ax) {
	                return ax.autoshift;
	              }).map(function(ax) {
	                return ax.overlaying;
	              });
	              axList.map(function(axId) {
	                var ax = axes.getFromId(gd, axId);
	                if (ax.tickmode === "sync" && ax.overlaying) {
	                  var overlayingIndex = axList.findIndex(function(axis) {
	                    return axis === ax.overlaying;
	                  });
	                  if (overlayingIndex >= 0) {
	                    axList.unshift(axList.splice(overlayingIndex, 1).shift());
	                  }
	                }
	              });
	              var axShifts = {
	                false: {
	                  left: 0,
	                  right: 0
	                }
	              };
	              return Lib.syncOrAsync(axList.map(function(axId) {
	                return function() {
	                  if (!axId) return;
	                  var ax = axes.getFromId(gd, axId);
	                  if (!opts) opts = {};
	                  opts.axShifts = axShifts;
	                  opts.overlayingShiftedAx = overlayingShiftedAx;
	                  var axDone = axes.drawOne(gd, ax, opts);
	                  if (ax._shiftPusher) {
	                    incrementShift(ax, ax._fullDepth || 0, axShifts, true);
	                  }
	                  ax._r = ax.range.slice();
	                  ax._rl = Lib.simpleMap(ax._r, ax.r2l);
	                  return axDone;
	                };
	              }));
	            };
	            axes.drawOne = function(gd, ax, opts) {
	              opts = opts || {};
	              var axShifts = opts.axShifts || {};
	              var overlayingShiftedAx = opts.overlayingShiftedAx || [];
	              var i, sp, plotinfo;
	              ax.setScale();
	              var fullLayout = gd._fullLayout;
	              var axId = ax._id;
	              var axLetter = axId.charAt(0);
	              var counterLetter = axes.counterLetter(axId);
	              var mainPlotinfo = fullLayout._plots[ax._mainSubplot];
	              if (!mainPlotinfo) return;
	              ax._shiftPusher = ax.autoshift || overlayingShiftedAx.indexOf(ax._id) !== -1 || overlayingShiftedAx.indexOf(ax.overlaying) !== -1;
	              if (ax._shiftPusher & ax.anchor === "free") {
	                var selfPush = ax.linewidth / 2 || 0;
	                if (ax.ticks === "inside") {
	                  selfPush += ax.ticklen;
	                }
	                incrementShift(ax, selfPush, axShifts, true);
	                incrementShift(ax, ax.shift || 0, axShifts, false);
	              }
	              if (opts.skipTitle !== true || ax._shift === undefined) ax._shift = setShiftVal(ax, axShifts);
	              var mainAxLayer = mainPlotinfo[axLetter + "axislayer"];
	              var mainLinePosition = ax._mainLinePosition;
	              var mainLinePositionShift = mainLinePosition += ax._shift;
	              var mainMirrorPosition = ax._mainMirrorPosition;
	              var vals = ax._vals = axes.calcTicks(ax);
	              var axInfo = [ax.mirror, mainLinePositionShift, mainMirrorPosition].join("_");
	              for (i = 0; i < vals.length; i++) {
	                vals[i].axInfo = axInfo;
	              }
	              ax._selections = {};
	              if (ax._tickAngles) ax._prevTickAngles = ax._tickAngles;
	              ax._tickAngles = {};
	              ax._depth = null;
	              var llbboxes = {};
	              function getLabelLevelBbox(suffix) {
	                var cls = axId + (suffix || "tick");
	                if (!llbboxes[cls]) llbboxes[cls] = calcLabelLevelBbox(ax, cls);
	                return llbboxes[cls];
	              }
	              if (!ax.visible) return;
	              var transTickFn = axes.makeTransTickFn(ax);
	              var transTickLabelFn = axes.makeTransTickLabelFn(ax);
	              var tickVals;
	              var valsClipped;
	              var insideTicks = ax.ticks === "inside";
	              var outsideTicks = ax.ticks === "outside";
	              if (ax.tickson === "boundaries") {
	                var boundaryVals = getBoundaryVals(ax, vals);
	                valsClipped = axes.clipEnds(ax, boundaryVals);
	                tickVals = insideTicks ? valsClipped : boundaryVals;
	              } else {
	                valsClipped = axes.clipEnds(ax, vals);
	                tickVals = insideTicks && ax.ticklabelmode !== "period" ? valsClipped : vals;
	              }
	              var gridVals = ax._gridVals = valsClipped;
	              var dividerVals = getDividerVals(ax, vals);
	              if (!fullLayout._hasOnlyLargeSploms) {
	                var subplotsWithAx = ax._subplotsWith;
	                var finishedGrids = {};
	                for (i = 0; i < subplotsWithAx.length; i++) {
	                  sp = subplotsWithAx[i];
	                  plotinfo = fullLayout._plots[sp];
	                  var counterAxis = plotinfo[counterLetter + "axis"];
	                  var mainCounterID = counterAxis._mainAxis._id;
	                  if (finishedGrids[mainCounterID]) continue;
	                  finishedGrids[mainCounterID] = 1;
	                  var gridPath = axLetter === "x" ? "M0," + counterAxis._offset + "v" + counterAxis._length : "M" + counterAxis._offset + ",0h" + counterAxis._length;
	                  axes.drawGrid(gd, ax, {
	                    vals: gridVals,
	                    counterAxis,
	                    layer: plotinfo.gridlayer.select("." + axId),
	                    minorLayer: plotinfo.minorGridlayer.select("." + axId),
	                    path: gridPath,
	                    transFn: transTickFn
	                  });
	                  axes.drawZeroLine(gd, ax, {
	                    counterAxis,
	                    layer: plotinfo.zerolinelayer,
	                    path: gridPath,
	                    transFn: transTickFn
	                  });
	                }
	              }
	              var tickPath;
	              var majorTickSigns = axes.getTickSigns(ax);
	              var minorTickSigns = axes.getTickSigns(ax, "minor");
	              if (ax.ticks || ax.minor && ax.minor.ticks) {
	                var majorTickPath = axes.makeTickPath(ax, mainLinePositionShift, majorTickSigns[2]);
	                var minorTickPath = axes.makeTickPath(ax, mainLinePositionShift, minorTickSigns[2], {
	                  minor: true
	                });
	                var mirrorMajorTickPath;
	                var mirrorMinorTickPath;
	                var fullMajorTickPath;
	                var fullMinorTickPath;
	                if (ax._anchorAxis && ax.mirror && ax.mirror !== true) {
	                  mirrorMajorTickPath = axes.makeTickPath(ax, mainMirrorPosition, majorTickSigns[3]);
	                  mirrorMinorTickPath = axes.makeTickPath(ax, mainMirrorPosition, minorTickSigns[3], {
	                    minor: true
	                  });
	                  fullMajorTickPath = majorTickPath + mirrorMajorTickPath;
	                  fullMinorTickPath = minorTickPath + mirrorMinorTickPath;
	                } else {
	                  mirrorMajorTickPath = "";
	                  mirrorMinorTickPath = "";
	                  fullMajorTickPath = majorTickPath;
	                  fullMinorTickPath = minorTickPath;
	                }
	                if (ax.showdividers && outsideTicks && ax.tickson === "boundaries") {
	                  var dividerLookup = {};
	                  for (i = 0; i < dividerVals.length; i++) {
	                    dividerLookup[dividerVals[i].x] = 1;
	                  }
	                  tickPath = function(d) {
	                    return dividerLookup[d.x] ? mirrorMajorTickPath : fullMajorTickPath;
	                  };
	                } else {
	                  tickPath = function(d) {
	                    return d.minor ? fullMinorTickPath : fullMajorTickPath;
	                  };
	                }
	              }
	              axes.drawTicks(gd, ax, {
	                vals: tickVals,
	                layer: mainAxLayer,
	                path: tickPath,
	                transFn: transTickFn
	              });
	              if (ax.mirror === "allticks") {
	                var tickSubplots = Object.keys(ax._linepositions || {});
	                for (i = 0; i < tickSubplots.length; i++) {
	                  sp = tickSubplots[i];
	                  plotinfo = fullLayout._plots[sp];
	                  var linepositions = ax._linepositions[sp] || [];
	                  var p0 = linepositions[0];
	                  var p1 = linepositions[1];
	                  var isMinor = linepositions[2];
	                  var spTickPath = axes.makeTickPath(ax, p0, isMinor ? majorTickSigns[0] : minorTickSigns[0], {
	                    minor: isMinor
	                  }) + axes.makeTickPath(ax, p1, isMinor ? majorTickSigns[1] : minorTickSigns[1], {
	                    minor: isMinor
	                  });
	                  axes.drawTicks(gd, ax, {
	                    vals: tickVals,
	                    layer: plotinfo[axLetter + "axislayer"],
	                    path: spTickPath,
	                    transFn: transTickFn
	                  });
	                }
	              }
	              var seq = [];
	              seq.push(function() {
	                return axes.drawLabels(gd, ax, {
	                  vals,
	                  layer: mainAxLayer,
	                  plotinfo,
	                  transFn: transTickLabelFn,
	                  labelFns: axes.makeLabelFns(ax, mainLinePositionShift)
	                });
	              });
	              if (ax.type === "multicategory") {
	                var pad = {
	                  x: 2,
	                  y: 10
	                }[axLetter];
	                seq.push(function() {
	                  var bboxKey = {
	                    x: "height",
	                    y: "width"
	                  }[axLetter];
	                  var standoff = getLabelLevelBbox()[bboxKey] + pad + (ax._tickAngles[axId + "tick"] ? ax.tickfont.size * LINE_SPACING : 0);
	                  return axes.drawLabels(gd, ax, {
	                    vals: getSecondaryLabelVals(ax, vals),
	                    layer: mainAxLayer,
	                    cls: axId + "tick2",
	                    repositionOnUpdate: true,
	                    secondary: true,
	                    transFn: transTickFn,
	                    labelFns: axes.makeLabelFns(ax, mainLinePositionShift + standoff * majorTickSigns[4])
	                  });
	                });
	                seq.push(function() {
	                  ax._depth = majorTickSigns[4] * (getLabelLevelBbox("tick2")[ax.side] - mainLinePositionShift);
	                  return drawDividers(gd, ax, {
	                    vals: dividerVals,
	                    layer: mainAxLayer,
	                    path: axes.makeTickPath(ax, mainLinePositionShift, majorTickSigns[4], {
	                      len: ax._depth
	                    }),
	                    transFn: transTickFn
	                  });
	                });
	              } else if (ax.title.hasOwnProperty("standoff")) {
	                seq.push(function() {
	                  ax._depth = majorTickSigns[4] * (getLabelLevelBbox()[ax.side] - mainLinePositionShift);
	                });
	              }
	              var hasRangeSlider = Registry.getComponentMethod("rangeslider", "isVisible")(ax);
	              if (!opts.skipTitle && !(hasRangeSlider && ax.side === "bottom")) {
	                seq.push(function() {
	                  return drawTitle(gd, ax);
	                });
	              }
	              seq.push(function() {
	                var s = ax.side.charAt(0);
	                var sMirror = OPPOSITE_SIDE[ax.side].charAt(0);
	                var pos = axes.getPxPosition(gd, ax);
	                var outsideTickLen = outsideTicks ? ax.ticklen : 0;
	                var llbbox;
	                var push;
	                var mirrorPush;
	                var rangeSliderPush;
	                if (ax.automargin || hasRangeSlider || ax._shiftPusher) {
	                  if (ax.type === "multicategory") {
	                    llbbox = getLabelLevelBbox("tick2");
	                  } else {
	                    llbbox = getLabelLevelBbox();
	                    if (axLetter === "x" && s === "b") {
	                      ax._depth = Math.max(llbbox.width > 0 ? llbbox.bottom - pos : 0, outsideTickLen);
	                    }
	                  }
	                }
	                var axDepth = 0;
	                var titleDepth = 0;
	                if (ax._shiftPusher) {
	                  axDepth = Math.max(outsideTickLen, llbbox.height > 0 ? s === "l" ? pos - llbbox.left : llbbox.right - pos : 0);
	                  if (ax.title.text !== fullLayout._dfltTitle[axLetter]) {
	                    titleDepth = (ax._titleStandoff || 0) + (ax._titleScoot || 0);
	                    if (s === "l") {
	                      titleDepth += approxTitleDepth(ax);
	                    }
	                  }
	                  ax._fullDepth = Math.max(axDepth, titleDepth);
	                }
	                if (ax.automargin) {
	                  push = {
	                    x: 0,
	                    y: 0,
	                    r: 0,
	                    l: 0,
	                    t: 0,
	                    b: 0
	                  };
	                  var domainIndices = [0, 1];
	                  var shift = typeof ax._shift === "number" ? ax._shift : 0;
	                  if (axLetter === "x") {
	                    if (s === "b") {
	                      push[s] = ax._depth;
	                    } else {
	                      push[s] = ax._depth = Math.max(llbbox.width > 0 ? pos - llbbox.top : 0, outsideTickLen);
	                      domainIndices.reverse();
	                    }
	                    if (llbbox.width > 0) {
	                      var rExtra = llbbox.right - (ax._offset + ax._length);
	                      if (rExtra > 0) {
	                        push.xr = 1;
	                        push.r = rExtra;
	                      }
	                      var lExtra = ax._offset - llbbox.left;
	                      if (lExtra > 0) {
	                        push.xl = 0;
	                        push.l = lExtra;
	                      }
	                    }
	                  } else {
	                    if (s === "l") {
	                      ax._depth = Math.max(llbbox.height > 0 ? pos - llbbox.left : 0, outsideTickLen);
	                      push[s] = ax._depth - shift;
	                    } else {
	                      ax._depth = Math.max(llbbox.height > 0 ? llbbox.right - pos : 0, outsideTickLen);
	                      push[s] = ax._depth + shift;
	                      domainIndices.reverse();
	                    }
	                    if (llbbox.height > 0) {
	                      var bExtra = llbbox.bottom - (ax._offset + ax._length);
	                      if (bExtra > 0) {
	                        push.yb = 0;
	                        push.b = bExtra;
	                      }
	                      var tExtra = ax._offset - llbbox.top;
	                      if (tExtra > 0) {
	                        push.yt = 1;
	                        push.t = tExtra;
	                      }
	                    }
	                  }
	                  push[counterLetter] = ax.anchor === "free" ? ax.position : ax._anchorAxis.domain[domainIndices[0]];
	                  if (ax.title.text !== fullLayout._dfltTitle[axLetter]) {
	                    push[s] += approxTitleDepth(ax) + (ax.title.standoff || 0);
	                  }
	                  if (ax.mirror && ax.anchor !== "free") {
	                    mirrorPush = {
	                      x: 0,
	                      y: 0,
	                      r: 0,
	                      l: 0,
	                      t: 0,
	                      b: 0
	                    };
	                    mirrorPush[sMirror] = ax.linewidth;
	                    if (ax.mirror && ax.mirror !== true) mirrorPush[sMirror] += outsideTickLen;
	                    if (ax.mirror === true || ax.mirror === "ticks") {
	                      mirrorPush[counterLetter] = ax._anchorAxis.domain[domainIndices[1]];
	                    } else if (ax.mirror === "all" || ax.mirror === "allticks") {
	                      mirrorPush[counterLetter] = [ax._counterDomainMin, ax._counterDomainMax][domainIndices[1]];
	                    }
	                  }
	                }
	                if (hasRangeSlider) {
	                  rangeSliderPush = Registry.getComponentMethod("rangeslider", "autoMarginOpts")(gd, ax);
	                }
	                if (typeof ax.automargin === "string") {
	                  filterPush(push, ax.automargin);
	                  filterPush(mirrorPush, ax.automargin);
	                }
	                Plots.autoMargin(gd, axAutoMarginID(ax), push);
	                Plots.autoMargin(gd, axMirrorAutoMarginID(ax), mirrorPush);
	                Plots.autoMargin(gd, rangeSliderAutoMarginID(ax), rangeSliderPush);
	              });
	              return Lib.syncOrAsync(seq);
	            };
	            function filterPush(push, automargin) {
	              if (!push) return;
	              var keepMargin = Object.keys(MARGIN_MAPPING).reduce(function(data, nextKey) {
	                if (automargin.indexOf(nextKey) !== -1) {
	                  MARGIN_MAPPING[nextKey].forEach(function(key) {
	                    data[key] = 1;
	                  });
	                }
	                return data;
	              }, {});
	              Object.keys(push).forEach(function(key) {
	                if (!keepMargin[key]) {
	                  if (key.length === 1) push[key] = 0;
	                  else delete push[key];
	                }
	              });
	            }
	            function getBoundaryVals(ax, vals) {
	              var out = [];
	              var i;
	              var _push = function(d, bndIndex) {
	                var xb = d.xbnd[bndIndex];
	                if (xb !== null) {
	                  out.push(Lib.extendFlat({}, d, {
	                    x: xb
	                  }));
	                }
	              };
	              if (vals.length) {
	                for (i = 0; i < vals.length; i++) {
	                  _push(vals[i], 0);
	                }
	                _push(vals[i - 1], 1);
	              }
	              return out;
	            }
	            function getSecondaryLabelVals(ax, vals) {
	              var out = [];
	              var lookup = {};
	              for (var i = 0; i < vals.length; i++) {
	                var d = vals[i];
	                if (lookup[d.text2]) {
	                  lookup[d.text2].push(d.x);
	                } else {
	                  lookup[d.text2] = [d.x];
	                }
	              }
	              for (var k in lookup) {
	                out.push(tickTextObj(ax, Lib.interp(lookup[k], 0.5), k));
	              }
	              return out;
	            }
	            function getDividerVals(ax, vals) {
	              var out = [];
	              var i, current;
	              var reversed = vals.length && vals[vals.length - 1].x < vals[0].x;
	              var _push = function(d2, bndIndex) {
	                var xb = d2.xbnd[bndIndex];
	                if (xb !== null) {
	                  out.push(Lib.extendFlat({}, d2, {
	                    x: xb
	                  }));
	                }
	              };
	              if (ax.showdividers && vals.length) {
	                for (i = 0; i < vals.length; i++) {
	                  var d = vals[i];
	                  if (d.text2 !== current) {
	                    _push(d, reversed ? 1 : 0);
	                  }
	                  current = d.text2;
	                }
	                _push(vals[i - 1], reversed ? 0 : 1);
	              }
	              return out;
	            }
	            function calcLabelLevelBbox(ax, cls) {
	              var top, bottom;
	              var left, right;
	              if (ax._selections[cls].size()) {
	                top = Infinity;
	                bottom = -Infinity;
	                left = Infinity;
	                right = -Infinity;
	                ax._selections[cls].each(function() {
	                  var thisLabel = selectTickLabel(this);
	                  var bb = Drawing.bBox(thisLabel.node().parentNode);
	                  top = Math.min(top, bb.top);
	                  bottom = Math.max(bottom, bb.bottom);
	                  left = Math.min(left, bb.left);
	                  right = Math.max(right, bb.right);
	                });
	              } else {
	                top = 0;
	                bottom = 0;
	                left = 0;
	                right = 0;
	              }
	              return {
	                top,
	                bottom,
	                left,
	                right,
	                height: bottom - top,
	                width: right - left
	              };
	            }
	            axes.getTickSigns = function(ax, minor) {
	              var axLetter = ax._id.charAt(0);
	              var sideOpposite = {
	                x: "top",
	                y: "right"
	              }[axLetter];
	              var main = ax.side === sideOpposite ? 1 : -1;
	              var out = [-1, 1, main, -main];
	              var ticks = minor ? (ax.minor || {}).ticks : ax.ticks;
	              if (ticks !== "inside" === (axLetter === "x")) {
	                out = out.map(function(v) {
	                  return -v;
	                });
	              }
	              if (ax.side) {
	                out.push({
	                  l: -1,
	                  t: -1,
	                  r: 1,
	                  b: 1
	                }[ax.side.charAt(0)]);
	              }
	              return out;
	            };
	            axes.makeTransTickFn = function(ax) {
	              return ax._id.charAt(0) === "x" ? function(d) {
	                return strTranslate(ax._offset + ax.l2p(d.x), 0);
	              } : function(d) {
	                return strTranslate(0, ax._offset + ax.l2p(d.x));
	              };
	            };
	            axes.makeTransTickLabelFn = function(ax) {
	              var uv = getTickLabelUV(ax);
	              var u = uv[0];
	              var v = uv[1];
	              return ax._id.charAt(0) === "x" ? function(d) {
	                return strTranslate(u + ax._offset + ax.l2p(getPosX(d)), v);
	              } : function(d) {
	                return strTranslate(v, u + ax._offset + ax.l2p(getPosX(d)));
	              };
	            };
	            function getPosX(d) {
	              return d.periodX !== undefined ? d.periodX : d.x;
	            }
	            function getTickLabelUV(ax) {
	              var ticklabelposition = ax.ticklabelposition || "";
	              var has = function(str) {
	                return ticklabelposition.indexOf(str) !== -1;
	              };
	              var isTop = has("top");
	              var isLeft = has("left");
	              var isRight = has("right");
	              var isBottom = has("bottom");
	              var isInside = has("inside");
	              var isAligned = isBottom || isLeft || isTop || isRight;
	              if (!isAligned && !isInside) return [0, 0];
	              var side = ax.side;
	              var u = isAligned ? (ax.tickwidth || 0) / 2 : 0;
	              var v = TEXTPAD;
	              var fontSize = ax.tickfont ? ax.tickfont.size : 12;
	              if (isBottom || isTop) {
	                u += fontSize * CAP_SHIFT;
	                v += (ax.linewidth || 0) / 2;
	              }
	              if (isLeft || isRight) {
	                u += (ax.linewidth || 0) / 2;
	                v += TEXTPAD;
	              }
	              if (isInside && side === "top") {
	                v -= fontSize * (1 - CAP_SHIFT);
	              }
	              if (isLeft || isTop) u = -u;
	              if (side === "bottom" || side === "right") v = -v;
	              return [isAligned ? u : 0, isInside ? v : 0];
	            }
	            axes.makeTickPath = function(ax, shift, sgn, opts) {
	              if (!opts) opts = {};
	              var minor = opts.minor;
	              if (minor && !ax.minor) return "";
	              var len = opts.len !== undefined ? opts.len : minor ? ax.minor.ticklen : ax.ticklen;
	              var axLetter = ax._id.charAt(0);
	              var pad = (ax.linewidth || 1) / 2;
	              return axLetter === "x" ? "M0," + (shift + pad * sgn) + "v" + len * sgn : "M" + (shift + pad * sgn) + ",0h" + len * sgn;
	            };
	            axes.makeLabelFns = function(ax, shift, angle) {
	              var ticklabelposition = ax.ticklabelposition || "";
	              var has = function(str) {
	                return ticklabelposition.indexOf(str) !== -1;
	              };
	              var isTop = has("top");
	              var isLeft = has("left");
	              var isRight = has("right");
	              var isBottom = has("bottom");
	              var isAligned = isBottom || isLeft || isTop || isRight;
	              var insideTickLabels = has("inside");
	              var labelsOverTicks = ticklabelposition === "inside" && ax.ticks === "inside" || !insideTickLabels && ax.ticks === "outside" && ax.tickson !== "boundaries";
	              var labelStandoff = 0;
	              var labelShift = 0;
	              var tickLen = labelsOverTicks ? ax.ticklen : 0;
	              if (insideTickLabels) {
	                tickLen *= -1;
	              } else if (isAligned) {
	                tickLen = 0;
	              }
	              if (labelsOverTicks) {
	                labelStandoff += tickLen;
	                if (angle) {
	                  var rad = Lib.deg2rad(angle);
	                  labelStandoff = tickLen * Math.cos(rad) + 1;
	                  labelShift = tickLen * Math.sin(rad);
	                }
	              }
	              if (ax.showticklabels && (labelsOverTicks || ax.showline)) {
	                labelStandoff += 0.2 * ax.tickfont.size;
	              }
	              labelStandoff += (ax.linewidth || 1) / 2 * (insideTickLabels ? -1 : 1);
	              var out = {
	                labelStandoff,
	                labelShift
	              };
	              var x0, y0, ff, flipIt;
	              var xQ = 0;
	              var side = ax.side;
	              var axLetter = ax._id.charAt(0);
	              var tickangle = ax.tickangle;
	              var endSide;
	              if (axLetter === "x") {
	                endSide = !insideTickLabels && side === "bottom" || insideTickLabels && side === "top";
	                flipIt = endSide ? 1 : -1;
	                if (insideTickLabels) flipIt *= -1;
	                x0 = labelShift * flipIt;
	                y0 = shift + labelStandoff * flipIt;
	                ff = endSide ? 1 : -0.2;
	                if (Math.abs(tickangle) === 90) {
	                  if (insideTickLabels) {
	                    ff += MID_SHIFT;
	                  } else {
	                    if (tickangle === -90 && side === "bottom") {
	                      ff = CAP_SHIFT;
	                    } else if (tickangle === 90 && side === "top") {
	                      ff = MID_SHIFT;
	                    } else {
	                      ff = 0.5;
	                    }
	                  }
	                  xQ = MID_SHIFT / 2 * (tickangle / 90);
	                }
	                out.xFn = function(d) {
	                  return d.dx + x0 + xQ * d.fontSize;
	                };
	                out.yFn = function(d) {
	                  return d.dy + y0 + d.fontSize * ff;
	                };
	                out.anchorFn = function(d, a) {
	                  if (isAligned) {
	                    if (isLeft) return "end";
	                    if (isRight) return "start";
	                  }
	                  if (!isNumeric(a) || a === 0 || a === 180) {
	                    return "middle";
	                  }
	                  return a * flipIt < 0 !== insideTickLabels ? "end" : "start";
	                };
	                out.heightFn = function(d, a, h) {
	                  return a < -60 || a > 60 ? -0.5 * h : ax.side === "top" !== insideTickLabels ? -h : 0;
	                };
	              } else if (axLetter === "y") {
	                endSide = !insideTickLabels && side === "left" || insideTickLabels && side === "right";
	                flipIt = endSide ? 1 : -1;
	                if (insideTickLabels) flipIt *= -1;
	                x0 = labelStandoff;
	                y0 = labelShift * flipIt;
	                ff = 0;
	                if (!insideTickLabels && Math.abs(tickangle) === 90) {
	                  if (tickangle === -90 && side === "left" || tickangle === 90 && side === "right") {
	                    ff = CAP_SHIFT;
	                  } else {
	                    ff = 0.5;
	                  }
	                }
	                if (insideTickLabels) {
	                  var ang = isNumeric(tickangle) ? +tickangle : 0;
	                  if (ang !== 0) {
	                    var rA = Lib.deg2rad(ang);
	                    xQ = Math.abs(Math.sin(rA)) * CAP_SHIFT * flipIt;
	                    ff = 0;
	                  }
	                }
	                out.xFn = function(d) {
	                  return d.dx + shift - (x0 + d.fontSize * ff) * flipIt + xQ * d.fontSize;
	                };
	                out.yFn = function(d) {
	                  return d.dy + y0 + d.fontSize * MID_SHIFT;
	                };
	                out.anchorFn = function(d, a) {
	                  if (isNumeric(a) && Math.abs(a) === 90) {
	                    return "middle";
	                  }
	                  return endSide ? "end" : "start";
	                };
	                out.heightFn = function(d, a, h) {
	                  if (ax.side === "right") a *= -1;
	                  return a < -30 ? -h : a < 30 ? -0.5 * h : 0;
	                };
	              }
	              return out;
	            };
	            function tickDataFn(d) {
	              return [d.text, d.x, d.axInfo, d.font, d.fontSize, d.fontColor].join("_");
	            }
	            axes.drawTicks = function(gd, ax, opts) {
	              opts = opts || {};
	              var cls = ax._id + "tick";
	              var vals = [].concat(ax.minor && ax.minor.ticks ? (
	                // minor vals
	                opts.vals.filter(function(d) {
	                  return d.minor && !d.noTick;
	                })
	              ) : []).concat(ax.ticks ? (
	                // major vals
	                opts.vals.filter(function(d) {
	                  return !d.minor && !d.noTick;
	                })
	              ) : []);
	              var ticks = opts.layer.selectAll("path." + cls).data(vals, tickDataFn);
	              ticks.exit().remove();
	              ticks.enter().append("path").classed(cls, 1).classed("ticks", 1).classed("crisp", opts.crisp !== false).each(function(d) {
	                return Color.stroke(d3.select(this), d.minor ? ax.minor.tickcolor : ax.tickcolor);
	              }).style("stroke-width", function(d) {
	                return Drawing.crispRound(gd, d.minor ? ax.minor.tickwidth : ax.tickwidth, 1) + "px";
	              }).attr("d", opts.path).style("display", null);
	              hideCounterAxisInsideTickLabels(ax, [TICK_PATH]);
	              ticks.attr("transform", opts.transFn);
	            };
	            axes.drawGrid = function(gd, ax, opts) {
	              opts = opts || {};
	              if (ax.tickmode === "sync") {
	                return;
	              }
	              var cls = ax._id + "grid";
	              var hasMinor = ax.minor && ax.minor.showgrid;
	              var minorVals = hasMinor ? opts.vals.filter(function(d) {
	                return d.minor;
	              }) : [];
	              var majorVals = ax.showgrid ? opts.vals.filter(function(d) {
	                return !d.minor;
	              }) : [];
	              var counterAx = opts.counterAxis;
	              if (counterAx && axes.shouldShowZeroLine(gd, ax, counterAx)) {
	                var isArrayMode = ax.tickmode === "array";
	                for (var i = 0; i < majorVals.length; i++) {
	                  var xi = majorVals[i].x;
	                  if (isArrayMode ? !xi : Math.abs(xi) < ax.dtick / 100) {
	                    majorVals = majorVals.slice(0, i).concat(majorVals.slice(i + 1));
	                    if (isArrayMode) i--;
	                    else break;
	                  }
	                }
	              }
	              ax._gw = Drawing.crispRound(gd, ax.gridwidth, 1);
	              var wMinor = !hasMinor ? 0 : Drawing.crispRound(gd, ax.minor.gridwidth, 1);
	              var majorLayer = opts.layer;
	              var minorLayer = opts.minorLayer;
	              for (var major = 1; major >= 0; major--) {
	                var layer = major ? majorLayer : minorLayer;
	                if (!layer) continue;
	                var grid = layer.selectAll("path." + cls).data(major ? majorVals : minorVals, tickDataFn);
	                grid.exit().remove();
	                grid.enter().append("path").classed(cls, 1).classed("crisp", opts.crisp !== false);
	                grid.attr("transform", opts.transFn).attr("d", opts.path).each(function(d) {
	                  return Color.stroke(d3.select(this), d.minor ? ax.minor.gridcolor : ax.gridcolor || "#ddd");
	                }).style("stroke-dasharray", function(d) {
	                  return Drawing.dashStyle(d.minor ? ax.minor.griddash : ax.griddash, d.minor ? ax.minor.gridwidth : ax.gridwidth);
	                }).style("stroke-width", function(d) {
	                  return (d.minor ? wMinor : ax._gw) + "px";
	                }).style("display", null);
	                if (typeof opts.path === "function") grid.attr("d", opts.path);
	              }
	              hideCounterAxisInsideTickLabels(ax, [GRID_PATH, MINORGRID_PATH]);
	            };
	            axes.drawZeroLine = function(gd, ax, opts) {
	              opts = opts || opts;
	              var cls = ax._id + "zl";
	              var show = axes.shouldShowZeroLine(gd, ax, opts.counterAxis);
	              var zl = opts.layer.selectAll("path." + cls).data(show ? [{
	                x: 0,
	                id: ax._id
	              }] : []);
	              zl.exit().remove();
	              zl.enter().append("path").classed(cls, 1).classed("zl", 1).classed("crisp", opts.crisp !== false).each(function() {
	                opts.layer.selectAll("path").sort(function(da, db) {
	                  return idSort(da.id, db.id);
	                });
	              });
	              zl.attr("transform", opts.transFn).attr("d", opts.path).call(Color.stroke, ax.zerolinecolor || Color.defaultLine).style("stroke-width", Drawing.crispRound(gd, ax.zerolinewidth, ax._gw || 1) + "px").style("display", null);
	              hideCounterAxisInsideTickLabels(ax, [ZERO_PATH]);
	            };
	            axes.drawLabels = function(gd, ax, opts) {
	              opts = opts || {};
	              var fullLayout = gd._fullLayout;
	              var axId = ax._id;
	              var axLetter = axId.charAt(0);
	              var cls = opts.cls || axId + "tick";
	              var vals = opts.vals.filter(function(d) {
	                return d.text;
	              });
	              var labelFns = opts.labelFns;
	              var tickAngle = opts.secondary ? 0 : ax.tickangle;
	              var prevAngle = (ax._prevTickAngles || {})[cls];
	              var tickLabels = opts.layer.selectAll("g." + cls).data(ax.showticklabels ? vals : [], tickDataFn);
	              var labelsReady = [];
	              tickLabels.enter().append("g").classed(cls, 1).append("text").attr("text-anchor", "middle").each(function(d) {
	                var thisLabel = d3.select(this);
	                var newPromise = gd._promises.length;
	                thisLabel.call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d)).call(Drawing.font, d.font, d.fontSize, d.fontColor).text(d.text).call(svgTextUtils.convertToTspans, gd);
	                if (gd._promises[newPromise]) {
	                  labelsReady.push(gd._promises.pop().then(function() {
	                    positionLabels(thisLabel, tickAngle);
	                  }));
	                } else {
	                  positionLabels(thisLabel, tickAngle);
	                }
	              });
	              hideCounterAxisInsideTickLabels(ax, [TICK_TEXT]);
	              tickLabels.exit().remove();
	              if (opts.repositionOnUpdate) {
	                tickLabels.each(function(d) {
	                  d3.select(this).select("text").call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d));
	                });
	              }
	              function positionLabels(s, angle) {
	                s.each(function(d) {
	                  var thisLabel = d3.select(this);
	                  var mathjaxGroup = thisLabel.select(".text-math-group");
	                  var anchor = labelFns.anchorFn(d, angle);
	                  var transform = opts.transFn.call(thisLabel.node(), d) + (isNumeric(angle) && +angle !== 0 ? " rotate(" + angle + "," + labelFns.xFn(d) + "," + (labelFns.yFn(d) - d.fontSize / 2) + ")" : "");
	                  var nLines = svgTextUtils.lineCount(thisLabel);
	                  var lineHeight = LINE_SPACING * d.fontSize;
	                  var anchorHeight = labelFns.heightFn(d, isNumeric(angle) ? +angle : 0, (nLines - 1) * lineHeight);
	                  if (anchorHeight) {
	                    transform += strTranslate(0, anchorHeight);
	                  }
	                  if (mathjaxGroup.empty()) {
	                    var thisText = thisLabel.select("text");
	                    thisText.attr({
	                      transform,
	                      "text-anchor": anchor
	                    });
	                    thisText.style("opacity", 1);
	                    if (ax._adjustTickLabelsOverflow) {
	                      ax._adjustTickLabelsOverflow();
	                    }
	                  } else {
	                    var mjWidth = Drawing.bBox(mathjaxGroup.node()).width;
	                    var mjShift = mjWidth * {
	                      end: -0.5,
	                      start: 0.5
	                    }[anchor];
	                    mathjaxGroup.attr("transform", transform + strTranslate(mjShift, 0));
	                  }
	                });
	              }
	              ax._adjustTickLabelsOverflow = function() {
	                var ticklabeloverflow = ax.ticklabeloverflow;
	                if (!ticklabeloverflow || ticklabeloverflow === "allow") return;
	                var hideOverflow = ticklabeloverflow.indexOf("hide") !== -1;
	                var isX = ax._id.charAt(0) === "x";
	                var p02 = 0;
	                var p12 = isX ? gd._fullLayout.width : gd._fullLayout.height;
	                if (ticklabeloverflow.indexOf("domain") !== -1) {
	                  var rl = Lib.simpleMap(ax.range, ax.r2l);
	                  p02 = ax.l2p(rl[0]) + ax._offset;
	                  p12 = ax.l2p(rl[1]) + ax._offset;
	                }
	                var min = Math.min(p02, p12);
	                var max = Math.max(p02, p12);
	                var side = ax.side;
	                var visibleLabelMin = Infinity;
	                var visibleLabelMax = -Infinity;
	                tickLabels.each(function(d) {
	                  var thisLabel = d3.select(this);
	                  var mathjaxGroup = thisLabel.select(".text-math-group");
	                  if (mathjaxGroup.empty()) {
	                    var bb = Drawing.bBox(thisLabel.node());
	                    var adjust = 0;
	                    if (isX) {
	                      if (bb.right > max) adjust = 1;
	                      else if (bb.left < min) adjust = 1;
	                    } else {
	                      if (bb.bottom > max) adjust = 1;
	                      else if (bb.top + (ax.tickangle ? 0 : d.fontSize / 4) < min) adjust = 1;
	                    }
	                    var t = thisLabel.select("text");
	                    if (adjust) {
	                      if (hideOverflow) t.style("opacity", 0);
	                    } else {
	                      t.style("opacity", 1);
	                      if (side === "bottom" || side === "right") {
	                        visibleLabelMin = Math.min(visibleLabelMin, isX ? bb.top : bb.left);
	                      } else {
	                        visibleLabelMin = -Infinity;
	                      }
	                      if (side === "top" || side === "left") {
	                        visibleLabelMax = Math.max(visibleLabelMax, isX ? bb.bottom : bb.right);
	                      } else {
	                        visibleLabelMax = Infinity;
	                      }
	                    }
	                  }
	                });
	                for (var subplot in fullLayout._plots) {
	                  var plotinfo = fullLayout._plots[subplot];
	                  if (ax._id !== plotinfo.xaxis._id && ax._id !== plotinfo.yaxis._id) continue;
	                  var anchorAx2 = isX ? plotinfo.yaxis : plotinfo.xaxis;
	                  if (anchorAx2) {
	                    anchorAx2["_visibleLabelMin_" + ax._id] = visibleLabelMin;
	                    anchorAx2["_visibleLabelMax_" + ax._id] = visibleLabelMax;
	                  }
	                }
	              };
	              ax._hideCounterAxisInsideTickLabels = function(partialOpts) {
	                var isX = ax._id.charAt(0) === "x";
	                var anchoredAxes = [];
	                for (var subplot in fullLayout._plots) {
	                  var plotinfo = fullLayout._plots[subplot];
	                  if (ax._id !== plotinfo.xaxis._id && ax._id !== plotinfo.yaxis._id) continue;
	                  anchoredAxes.push(isX ? plotinfo.yaxis : plotinfo.xaxis);
	                }
	                anchoredAxes.forEach(function(anchorAx2, idx) {
	                  if (anchorAx2 && insideTicklabelposition(anchorAx2)) {
	                    (partialOpts || [ZERO_PATH, MINORGRID_PATH, GRID_PATH, TICK_PATH, TICK_TEXT]).forEach(function(e) {
	                      var isPeriodLabel = e.K === "tick" && e.L === "text" && ax.ticklabelmode === "period";
	                      var mainPlotinfo = fullLayout._plots[ax._mainSubplot];
	                      var sel;
	                      if (e.K === ZERO_PATH.K) sel = mainPlotinfo.zerolinelayer.selectAll("." + ax._id + "zl");
	                      else if (e.K === MINORGRID_PATH.K) sel = mainPlotinfo.minorGridlayer.selectAll("." + ax._id);
	                      else if (e.K === GRID_PATH.K) sel = mainPlotinfo.gridlayer.selectAll("." + ax._id);
	                      else sel = mainPlotinfo[ax._id.charAt(0) + "axislayer"];
	                      sel.each(function() {
	                        var w = d3.select(this);
	                        if (e.L) w = w.selectAll(e.L);
	                        w.each(function(d) {
	                          var q = ax.l2p(isPeriodLabel ? getPosX(d) : d.x) + ax._offset;
	                          var t = d3.select(this);
	                          if (q < ax["_visibleLabelMax_" + anchorAx2._id] && q > ax["_visibleLabelMin_" + anchorAx2._id]) {
	                            t.style("display", "none");
	                          } else if (e.K === "tick" && !idx) {
	                            t.style("display", null);
	                          }
	                        });
	                      });
	                    });
	                  }
	                });
	              };
	              positionLabels(tickLabels, prevAngle + 1 ? prevAngle : tickAngle);
	              function allLabelsReady() {
	                return labelsReady.length && Promise.all(labelsReady);
	              }
	              var autoangle = null;
	              function fixLabelOverlaps() {
	                positionLabels(tickLabels, tickAngle);
	                if (vals.length && axLetter === "x" && !isNumeric(tickAngle) && (ax.type !== "log" || String(ax.dtick).charAt(0) !== "D")) {
	                  autoangle = 0;
	                  var maxFontSize = 0;
	                  var lbbArray = [];
	                  var i;
	                  tickLabels.each(function(d) {
	                    maxFontSize = Math.max(maxFontSize, d.fontSize);
	                    var x = ax.l2p(d.x);
	                    var thisLabel = selectTickLabel(this);
	                    var bb = Drawing.bBox(thisLabel.node());
	                    lbbArray.push({
	                      // ignore about y, just deal with x overlaps
	                      top: 0,
	                      bottom: 10,
	                      height: 10,
	                      left: x - bb.width / 2,
	                      // impose a 2px gap
	                      right: x + bb.width / 2 + 2,
	                      width: bb.width + 2
	                    });
	                  });
	                  if ((ax.tickson === "boundaries" || ax.showdividers) && !opts.secondary) {
	                    var gap = 2;
	                    if (ax.ticks) gap += ax.tickwidth / 2;
	                    for (i = 0; i < lbbArray.length; i++) {
	                      var xbnd = vals[i].xbnd;
	                      var lbb = lbbArray[i];
	                      if (xbnd[0] !== null && lbb.left - ax.l2p(xbnd[0]) < gap || xbnd[1] !== null && ax.l2p(xbnd[1]) - lbb.right < gap) {
	                        autoangle = 90;
	                        break;
	                      }
	                    }
	                  } else {
	                    var vLen = vals.length;
	                    var tickSpacing = Math.abs((vals[vLen - 1].x - vals[0].x) * ax._m) / (vLen - 1);
	                    var ticklabelposition = ax.ticklabelposition || "";
	                    var has = function(str) {
	                      return ticklabelposition.indexOf(str) !== -1;
	                    };
	                    var isTop = has("top");
	                    var isLeft = has("left");
	                    var isRight = has("right");
	                    var isBottom = has("bottom");
	                    var isAligned = isBottom || isLeft || isTop || isRight;
	                    var pad = !isAligned ? 0 : (ax.tickwidth || 0) + 2 * TEXTPAD;
	                    var rotate90 = tickSpacing < maxFontSize * 2.5 || ax.type === "multicategory" || ax._name === "realaxis";
	                    for (i = 0; i < lbbArray.length - 1; i++) {
	                      if (Lib.bBoxIntersect(lbbArray[i], lbbArray[i + 1], pad)) {
	                        autoangle = rotate90 ? 90 : 30;
	                        break;
	                      }
	                    }
	                  }
	                  if (autoangle) {
	                    positionLabels(tickLabels, autoangle);
	                  }
	                }
	              }
	              if (ax._selections) {
	                ax._selections[cls] = tickLabels;
	              }
	              var seq = [allLabelsReady];
	              if (ax.automargin && fullLayout._redrawFromAutoMarginCount && prevAngle === 90) {
	                autoangle = 90;
	                seq.push(function() {
	                  positionLabels(tickLabels, prevAngle);
	                });
	              } else {
	                seq.push(fixLabelOverlaps);
	              }
	              if (ax._tickAngles) {
	                seq.push(function() {
	                  ax._tickAngles[cls] = autoangle === null ? isNumeric(tickAngle) ? tickAngle : 0 : autoangle;
	                });
	              }
	              var computeTickLabelBoundingBoxes = function() {
	                var labelsMaxW = 0;
	                var labelsMaxH = 0;
	                tickLabels.each(function(d, i) {
	                  var thisLabel = selectTickLabel(this);
	                  var mathjaxGroup = thisLabel.select(".text-math-group");
	                  if (mathjaxGroup.empty()) {
	                    var bb;
	                    if (ax._vals[i]) {
	                      bb = ax._vals[i].bb || Drawing.bBox(thisLabel.node());
	                      ax._vals[i].bb = bb;
	                    }
	                    labelsMaxW = Math.max(labelsMaxW, bb.width);
	                    labelsMaxH = Math.max(labelsMaxH, bb.height);
	                  }
	                });
	                return {
	                  labelsMaxW,
	                  labelsMaxH
	                };
	              };
	              var anchorAx = ax._anchorAxis;
	              if (anchorAx && (anchorAx.autorange || anchorAx.insiderange) && insideTicklabelposition(ax) && !isLinked(fullLayout, ax._id)) {
	                if (!fullLayout._insideTickLabelsUpdaterange) {
	                  fullLayout._insideTickLabelsUpdaterange = {};
	                }
	                if (anchorAx.autorange) {
	                  fullLayout._insideTickLabelsUpdaterange[anchorAx._name + ".autorange"] = anchorAx.autorange;
	                  seq.push(computeTickLabelBoundingBoxes);
	                }
	                if (anchorAx.insiderange) {
	                  var BBs = computeTickLabelBoundingBoxes();
	                  var move = ax._id.charAt(0) === "y" ? BBs.labelsMaxW : BBs.labelsMaxH;
	                  move += 2 * TEXTPAD;
	                  if (ax.ticklabelposition === "inside") {
	                    move += ax.ticklen || 0;
	                  }
	                  var sgn = ax.side === "right" || ax.side === "top" ? 1 : -1;
	                  var index = sgn === 1 ? 1 : 0;
	                  var otherIndex = sgn === 1 ? 0 : 1;
	                  var newRange = [];
	                  newRange[otherIndex] = anchorAx.range[otherIndex];
	                  var p0 = anchorAx.d2p(anchorAx.range[index]);
	                  var p1 = anchorAx.d2p(anchorAx.range[otherIndex]);
	                  var dist = Math.abs(p1 - p0);
	                  if (dist - move > 0) {
	                    dist -= move;
	                    move *= 1 + move / dist;
	                  } else {
	                    move = 0;
	                  }
	                  if (ax._id.charAt(0) !== "y") move = -move;
	                  newRange[index] = anchorAx.p2d(anchorAx.d2p(anchorAx.range[index]) + sgn * move);
	                  if (anchorAx.autorange === "min" || anchorAx.autorange === "max reversed") {
	                    newRange[0] = null;
	                    anchorAx._rangeInitial0 = undefined;
	                    anchorAx._rangeInitial1 = undefined;
	                  } else if (anchorAx.autorange === "max" || anchorAx.autorange === "min reversed") {
	                    newRange[1] = null;
	                    anchorAx._rangeInitial0 = undefined;
	                    anchorAx._rangeInitial1 = undefined;
	                  }
	                  fullLayout._insideTickLabelsUpdaterange[anchorAx._name + ".range"] = newRange;
	                }
	              }
	              var done = Lib.syncOrAsync(seq);
	              if (done && done.then) gd._promises.push(done);
	              return done;
	            };
	            function drawDividers(gd, ax, opts) {
	              var cls = ax._id + "divider";
	              var vals = opts.vals;
	              var dividers = opts.layer.selectAll("path." + cls).data(vals, tickDataFn);
	              dividers.exit().remove();
	              dividers.enter().insert("path", ":first-child").classed(cls, 1).classed("crisp", 1).call(Color.stroke, ax.dividercolor).style("stroke-width", Drawing.crispRound(gd, ax.dividerwidth, 1) + "px");
	              dividers.attr("transform", opts.transFn).attr("d", opts.path);
	            }
	            axes.getPxPosition = function(gd, ax) {
	              var gs = gd._fullLayout._size;
	              var axLetter = ax._id.charAt(0);
	              var side = ax.side;
	              var anchorAxis;
	              if (ax.anchor !== "free") {
	                anchorAxis = ax._anchorAxis;
	              } else if (axLetter === "x") {
	                anchorAxis = {
	                  _offset: gs.t + (1 - (ax.position || 0)) * gs.h,
	                  _length: 0
	                };
	              } else if (axLetter === "y") {
	                anchorAxis = {
	                  _offset: gs.l + (ax.position || 0) * gs.w + ax._shift,
	                  _length: 0
	                };
	              }
	              if (side === "top" || side === "left") {
	                return anchorAxis._offset;
	              } else if (side === "bottom" || side === "right") {
	                return anchorAxis._offset + anchorAxis._length;
	              }
	            };
	            function approxTitleDepth(ax) {
	              var fontSize = ax.title.font.size;
	              var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
	              if (ax.title.hasOwnProperty("standoff")) {
	                return extraLines ? fontSize * (CAP_SHIFT + extraLines * LINE_SPACING) : fontSize * CAP_SHIFT;
	              } else {
	                return extraLines ? fontSize * (extraLines + 1) * LINE_SPACING : fontSize;
	              }
	            }
	            function drawTitle(gd, ax) {
	              var fullLayout = gd._fullLayout;
	              var axId = ax._id;
	              var axLetter = axId.charAt(0);
	              var fontSize = ax.title.font.size;
	              var titleStandoff;
	              if (ax.title.hasOwnProperty("standoff")) {
	                titleStandoff = ax._depth + ax.title.standoff + approxTitleDepth(ax);
	              } else {
	                var isInside = insideTicklabelposition(ax);
	                if (ax.type === "multicategory") {
	                  titleStandoff = ax._depth;
	                } else {
	                  var offsetBase = 1.5 * fontSize;
	                  if (isInside) {
	                    offsetBase = 0.5 * fontSize;
	                    if (ax.ticks === "outside") {
	                      offsetBase += ax.ticklen;
	                    }
	                  }
	                  titleStandoff = 10 + offsetBase + (ax.linewidth ? ax.linewidth - 1 : 0);
	                }
	                if (!isInside) {
	                  if (axLetter === "x") {
	                    titleStandoff += ax.side === "top" ? fontSize * (ax.showticklabels ? 1 : 0) : fontSize * (ax.showticklabels ? 1.5 : 0.5);
	                  } else {
	                    titleStandoff += ax.side === "right" ? fontSize * (ax.showticklabels ? 1 : 0.5) : fontSize * (ax.showticklabels ? 0.5 : 0);
	                  }
	                }
	              }
	              var pos = axes.getPxPosition(gd, ax);
	              var transform, x, y;
	              if (axLetter === "x") {
	                x = ax._offset + ax._length / 2;
	                y = ax.side === "top" ? pos - titleStandoff : pos + titleStandoff;
	              } else {
	                y = ax._offset + ax._length / 2;
	                x = ax.side === "right" ? pos + titleStandoff : pos - titleStandoff;
	                transform = {
	                  rotate: "-90",
	                  offset: 0
	                };
	              }
	              var avoid;
	              if (ax.type !== "multicategory") {
	                var tickLabels = ax._selections[ax._id + "tick"];
	                avoid = {
	                  selection: tickLabels,
	                  side: ax.side
	                };
	                if (tickLabels && tickLabels.node() && tickLabels.node().parentNode) {
	                  var translation = Drawing.getTranslate(tickLabels.node().parentNode);
	                  avoid.offsetLeft = translation.x;
	                  avoid.offsetTop = translation.y;
	                }
	                if (ax.title.hasOwnProperty("standoff")) {
	                  avoid.pad = 0;
	                }
	              }
	              ax._titleStandoff = titleStandoff;
	              return Titles.draw(gd, axId + "title", {
	                propContainer: ax,
	                propName: ax._name + ".title.text",
	                placeholder: fullLayout._dfltTitle[axLetter],
	                avoid,
	                transform,
	                attributes: {
	                  x,
	                  y,
	                  "text-anchor": "middle"
	                }
	              });
	            }
	            axes.shouldShowZeroLine = function(gd, ax, counterAxis) {
	              var rng = Lib.simpleMap(ax.range, ax.r2l);
	              return rng[0] * rng[1] <= 0 && ax.zeroline && (ax.type === "linear" || ax.type === "-") && !(ax.rangebreaks && ax.maskBreaks(0) === BADNUM) && (clipEnds(ax, 0) || !anyCounterAxLineAtZero(gd, ax, counterAxis, rng) || hasBarsOrFill(gd, ax));
	            };
	            axes.clipEnds = function(ax, vals) {
	              return vals.filter(function(d) {
	                return clipEnds(ax, d.x);
	              });
	            };
	            function clipEnds(ax, l) {
	              var p = ax.l2p(l);
	              return p > 1 && p < ax._length - 1;
	            }
	            function anyCounterAxLineAtZero(gd, ax, counterAxis, rng) {
	              var mainCounterAxis = counterAxis._mainAxis;
	              if (!mainCounterAxis) return;
	              var fullLayout = gd._fullLayout;
	              var axLetter = ax._id.charAt(0);
	              var counterLetter = axes.counterLetter(ax._id);
	              var zeroPosition = ax._offset + (Math.abs(rng[0]) < Math.abs(rng[1]) === (axLetter === "x") ? 0 : ax._length);
	              function lineNearZero(ax2) {
	                if (!ax2.showline || !ax2.linewidth) return false;
	                var tolerance = Math.max((ax2.linewidth + ax.zerolinewidth) / 2, 1);
	                function closeEnough(pos2) {
	                  return typeof pos2 === "number" && Math.abs(pos2 - zeroPosition) < tolerance;
	                }
	                if (closeEnough(ax2._mainLinePosition) || closeEnough(ax2._mainMirrorPosition)) {
	                  return true;
	                }
	                var linePositions = ax2._linepositions || {};
	                for (var k in linePositions) {
	                  if (closeEnough(linePositions[k][0]) || closeEnough(linePositions[k][1])) {
	                    return true;
	                  }
	                }
	              }
	              var plotinfo = fullLayout._plots[counterAxis._mainSubplot];
	              if (!(plotinfo.mainplotinfo || plotinfo).overlays.length) {
	                return lineNearZero(counterAxis);
	              }
	              var counterLetterAxes = axes.list(gd, counterLetter);
	              for (var i = 0; i < counterLetterAxes.length; i++) {
	                var counterAxis2 = counterLetterAxes[i];
	                if (counterAxis2._mainAxis === mainCounterAxis && lineNearZero(counterAxis2)) {
	                  return true;
	                }
	              }
	            }
	            function hasBarsOrFill(gd, ax) {
	              var fullData = gd._fullData;
	              var subplot = ax._mainSubplot;
	              var axLetter = ax._id.charAt(0);
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (trace.visible === true && trace.xaxis + trace.yaxis === subplot) {
	                  if (Registry.traceIs(trace, "bar-like") && trace.orientation === {
	                    x: "h",
	                    y: "v"
	                  }[axLetter]) return true;
	                  if (trace.fill && trace.fill.charAt(trace.fill.length - 1) === axLetter) return true;
	                }
	              }
	              return false;
	            }
	            function selectTickLabel(gTick) {
	              var s = d3.select(gTick);
	              var mj = s.select(".text-math-group");
	              return mj.empty() ? s.select("text") : mj;
	            }
	            axes.allowAutoMargin = function(gd) {
	              var axList = axes.list(gd, "", true);
	              for (var i = 0; i < axList.length; i++) {
	                var ax = axList[i];
	                if (ax.automargin) {
	                  Plots.allowAutoMargin(gd, axAutoMarginID(ax));
	                  if (ax.mirror) {
	                    Plots.allowAutoMargin(gd, axMirrorAutoMarginID(ax));
	                  }
	                }
	                if (Registry.getComponentMethod("rangeslider", "isVisible")(ax)) {
	                  Plots.allowAutoMargin(gd, rangeSliderAutoMarginID(ax));
	                }
	              }
	            };
	            function axAutoMarginID(ax) {
	              return ax._id + ".automargin";
	            }
	            function axMirrorAutoMarginID(ax) {
	              return axAutoMarginID(ax) + ".mirror";
	            }
	            function rangeSliderAutoMarginID(ax) {
	              return ax._id + ".rangeslider";
	            }
	            axes.swap = function(gd, traces) {
	              var axGroups = makeAxisGroups(gd, traces);
	              for (var i = 0; i < axGroups.length; i++) {
	                swapAxisGroup(gd, axGroups[i].x, axGroups[i].y);
	              }
	            };
	            function makeAxisGroups(gd, traces) {
	              var groups = [];
	              var i, j;
	              for (i = 0; i < traces.length; i++) {
	                var groupsi = [];
	                var xi = gd._fullData[traces[i]].xaxis;
	                var yi = gd._fullData[traces[i]].yaxis;
	                if (!xi || !yi) continue;
	                for (j = 0; j < groups.length; j++) {
	                  if (groups[j].x.indexOf(xi) !== -1 || groups[j].y.indexOf(yi) !== -1) {
	                    groupsi.push(j);
	                  }
	                }
	                if (!groupsi.length) {
	                  groups.push({
	                    x: [xi],
	                    y: [yi]
	                  });
	                  continue;
	                }
	                var group0 = groups[groupsi[0]];
	                var groupj;
	                if (groupsi.length > 1) {
	                  for (j = 1; j < groupsi.length; j++) {
	                    groupj = groups[groupsi[j]];
	                    mergeAxisGroups(group0.x, groupj.x);
	                    mergeAxisGroups(group0.y, groupj.y);
	                  }
	                }
	                mergeAxisGroups(group0.x, [xi]);
	                mergeAxisGroups(group0.y, [yi]);
	              }
	              return groups;
	            }
	            function mergeAxisGroups(intoSet, fromSet) {
	              for (var i = 0; i < fromSet.length; i++) {
	                if (intoSet.indexOf(fromSet[i]) === -1) intoSet.push(fromSet[i]);
	              }
	            }
	            function swapAxisGroup(gd, xIds, yIds) {
	              var xFullAxes = [];
	              var yFullAxes = [];
	              var layout = gd.layout;
	              var i, j;
	              for (i = 0; i < xIds.length; i++) xFullAxes.push(axes.getFromId(gd, xIds[i]));
	              for (i = 0; i < yIds.length; i++) yFullAxes.push(axes.getFromId(gd, yIds[i]));
	              var allAxKeys = Object.keys(axAttrs);
	              var noSwapAttrs = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"];
	              var numericTypes = ["linear", "log"];
	              for (i = 0; i < allAxKeys.length; i++) {
	                var keyi = allAxKeys[i];
	                var xVal = xFullAxes[0][keyi];
	                var yVal = yFullAxes[0][keyi];
	                var allEqual = true;
	                var coerceLinearX = false;
	                var coerceLinearY = false;
	                if (keyi.charAt(0) === "_" || typeof xVal === "function" || noSwapAttrs.indexOf(keyi) !== -1) {
	                  continue;
	                }
	                for (j = 1; j < xFullAxes.length && allEqual; j++) {
	                  var xVali = xFullAxes[j][keyi];
	                  if (keyi === "type" && numericTypes.indexOf(xVal) !== -1 && numericTypes.indexOf(xVali) !== -1 && xVal !== xVali) {
	                    coerceLinearX = true;
	                  } else if (xVali !== xVal) allEqual = false;
	                }
	                for (j = 1; j < yFullAxes.length && allEqual; j++) {
	                  var yVali = yFullAxes[j][keyi];
	                  if (keyi === "type" && numericTypes.indexOf(yVal) !== -1 && numericTypes.indexOf(yVali) !== -1 && yVal !== yVali) {
	                    coerceLinearY = true;
	                  } else if (yFullAxes[j][keyi] !== yVal) allEqual = false;
	                }
	                if (allEqual) {
	                  if (coerceLinearX) layout[xFullAxes[0]._name].type = "linear";
	                  if (coerceLinearY) layout[yFullAxes[0]._name].type = "linear";
	                  swapAxisAttrs(layout, keyi, xFullAxes, yFullAxes, gd._fullLayout._dfltTitle);
	                }
	              }
	              for (i = 0; i < gd._fullLayout.annotations.length; i++) {
	                var ann = gd._fullLayout.annotations[i];
	                if (xIds.indexOf(ann.xref) !== -1 && yIds.indexOf(ann.yref) !== -1) {
	                  Lib.swapAttrs(layout.annotations[i], ["?"]);
	                }
	              }
	            }
	            function swapAxisAttrs(layout, key, xFullAxes, yFullAxes, dfltTitle) {
	              var np = Lib.nestedProperty;
	              var xVal = np(layout[xFullAxes[0]._name], key).get();
	              var yVal = np(layout[yFullAxes[0]._name], key).get();
	              var i;
	              if (key === "title") {
	                if (xVal && xVal.text === dfltTitle.x) {
	                  xVal.text = dfltTitle.y;
	                }
	                if (yVal && yVal.text === dfltTitle.y) {
	                  yVal.text = dfltTitle.x;
	                }
	              }
	              for (i = 0; i < xFullAxes.length; i++) {
	                np(layout, xFullAxes[i]._name + "." + key).set(yVal);
	              }
	              for (i = 0; i < yFullAxes.length; i++) {
	                np(layout, yFullAxes[i]._name + "." + key).set(xVal);
	              }
	            }
	            function isAngular(ax) {
	              return ax._id === "angularaxis";
	            }
	            function moveOutsideBreak(v, ax) {
	              var len = ax._rangebreaks.length;
	              for (var k = 0; k < len; k++) {
	                var brk = ax._rangebreaks[k];
	                if (v >= brk.min && v < brk.max) {
	                  return brk.max;
	                }
	              }
	              return v;
	            }
	            function insideTicklabelposition(ax) {
	              return (ax.ticklabelposition || "").indexOf("inside") !== -1;
	            }
	            function hideCounterAxisInsideTickLabels(ax, opts) {
	              if (insideTicklabelposition(ax._anchorAxis || {})) {
	                if (ax._hideCounterAxisInsideTickLabels) {
	                  ax._hideCounterAxisInsideTickLabels(opts);
	                }
	              }
	            }
	            function incrementShift(ax, shiftVal, axShifts, normalize) {
	              var overlay = ax.anchor !== "free" && (ax.overlaying === undefined || ax.overlaying === false) ? ax._id : ax.overlaying;
	              var shiftValAdj;
	              if (normalize) {
	                shiftValAdj = ax.side === "right" ? shiftVal : -shiftVal;
	              } else {
	                shiftValAdj = shiftVal;
	              }
	              if (!(overlay in axShifts)) {
	                axShifts[overlay] = {};
	              }
	              if (!(ax.side in axShifts[overlay])) {
	                axShifts[overlay][ax.side] = 0;
	              }
	              axShifts[overlay][ax.side] += shiftValAdj;
	            }
	            function setShiftVal(ax, axShifts) {
	              return ax.autoshift ? axShifts[ax.overlaying][ax.side] : ax.shift || 0;
	            }
	          }
	        ),
	        /***/
	        4322: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	            var isDateTime = Lib.isDateTime;
	            var cleanNumber = Lib.cleanNumber;
	            var round = Math.round;
	            module2.exports = function autoType(array, calendar, opts) {
	              var a = array;
	              var noMultiCategory = opts.noMultiCategory;
	              if (isArrayOrTypedArray(a) && !a.length) return "-";
	              if (!noMultiCategory && multiCategory(a)) return "multicategory";
	              if (noMultiCategory && Array.isArray(a[0])) {
	                var b = [];
	                for (var i = 0; i < a.length; i++) {
	                  if (isArrayOrTypedArray(a[i])) {
	                    for (var j = 0; j < a[i].length; j++) {
	                      b.push(a[i][j]);
	                    }
	                  }
	                }
	                a = b;
	              }
	              if (moreDates(a, calendar)) return "date";
	              var convertNumeric = opts.autotypenumbers !== "strict";
	              if (category(a, convertNumeric)) return "category";
	              if (linearOK(a, convertNumeric)) return "linear";
	              return "-";
	            };
	            function hasTypeNumber(v, convertNumeric) {
	              return convertNumeric ? isNumeric(v) : typeof v === "number";
	            }
	            function linearOK(a, convertNumeric) {
	              var len = a.length;
	              for (var i = 0; i < len; i++) {
	                if (hasTypeNumber(a[i], convertNumeric)) return true;
	              }
	              return false;
	            }
	            function moreDates(a, calendar) {
	              var len = a.length;
	              var inc = getIncrement(len);
	              var dats = 0;
	              var nums = 0;
	              var seen = {};
	              for (var f = 0; f < len; f += inc) {
	                var i = round(f);
	                var ai = a[i];
	                var stri = String(ai);
	                if (seen[stri]) continue;
	                seen[stri] = 1;
	                if (isDateTime(ai, calendar)) dats++;
	                if (isNumeric(ai)) nums++;
	              }
	              return dats > nums * 2;
	            }
	            function getIncrement(len) {
	              return Math.max(1, (len - 1) / 1e3);
	            }
	            function category(a, convertNumeric) {
	              var len = a.length;
	              var inc = getIncrement(len);
	              var nums = 0;
	              var cats = 0;
	              var seen = {};
	              for (var f = 0; f < len; f += inc) {
	                var i = round(f);
	                var ai = a[i];
	                var stri = String(ai);
	                if (seen[stri]) continue;
	                seen[stri] = 1;
	                var t = typeof ai;
	                if (t === "boolean") cats++;
	                else if (convertNumeric ? cleanNumber(ai) !== BADNUM : t === "number") nums++;
	                else if (t === "string") cats++;
	              }
	              return cats > nums * 2;
	            }
	            function multiCategory(a) {
	              return isArrayOrTypedArray(a[0]) && isArrayOrTypedArray(a[1]);
	            }
	          }
	        ),
	        /***/
	        71453: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var layoutAttributes = __webpack_require__2(13838);
	            var handleTickValueDefaults = __webpack_require__2(26218);
	            var handleTickMarkDefaults = __webpack_require__2(38701);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            var handleCategoryOrderDefaults = __webpack_require__2(15258);
	            var handleLineGridDefaults = __webpack_require__2(92128);
	            var handleRangeDefaults = __webpack_require__2(23608);
	            var setConvert = __webpack_require__2(21994);
	            var DAY_OF_WEEK = __webpack_require__2(85555).WEEKDAY_PATTERN;
	            var HOUR = __webpack_require__2(85555).HOUR_PATTERN;
	            module2.exports = function handleAxisDefaults(containerIn, containerOut, coerce, options, layoutOut) {
	              var letter = options.letter;
	              var font = options.font || {};
	              var splomStash = options.splomStash || {};
	              var visible = coerce("visible", !options.visibleDflt);
	              var axTemplate = containerOut._template || {};
	              var axType = containerOut.type || axTemplate.type || "-";
	              var ticklabelmode;
	              if (axType === "date") {
	                var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleDefaults");
	                handleCalendarDefaults(containerIn, containerOut, "calendar", options.calendar);
	                if (!options.noTicklabelmode) {
	                  ticklabelmode = coerce("ticklabelmode");
	                }
	              }
	              var ticklabelposition = "";
	              if (!options.noTicklabelposition || axType === "multicategory") {
	                ticklabelposition = Lib.coerce(containerIn, containerOut, {
	                  ticklabelposition: {
	                    valType: "enumerated",
	                    dflt: "outside",
	                    values: ticklabelmode === "period" ? ["outside", "inside"] : letter === "x" ? ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] : ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"]
	                  }
	                }, "ticklabelposition");
	              }
	              if (!options.noTicklabeloverflow) {
	                coerce("ticklabeloverflow", ticklabelposition.indexOf("inside") !== -1 ? "hide past domain" : axType === "category" || axType === "multicategory" ? "allow" : "hide past div");
	              }
	              setConvert(containerOut, layoutOut);
	              handleRangeDefaults(containerIn, containerOut, coerce, options);
	              handleCategoryOrderDefaults(containerIn, containerOut, coerce, options);
	              if (axType !== "category" && !options.noHover) coerce("hoverformat");
	              var dfltColor = coerce("color");
	              var dfltFontColor = dfltColor !== layoutAttributes.color.dflt ? dfltColor : font.color;
	              var dfltTitle = splomStash.label || layoutOut._dfltTitle[letter];
	              handlePrefixSuffixDefaults(containerIn, containerOut, coerce, axType, options);
	              if (!visible) return containerOut;
	              coerce("title.text", dfltTitle);
	              Lib.coerceFont(coerce, "title.font", {
	                family: font.family,
	                size: Lib.bigFont(font.size),
	                color: dfltFontColor
	              });
	              handleTickValueDefaults(containerIn, containerOut, coerce, axType);
	              var hasMinor = options.hasMinor;
	              if (hasMinor) {
	                Template.newContainer(containerOut, "minor");
	                handleTickValueDefaults(containerIn, containerOut, coerce, axType, {
	                  isMinor: true
	                });
	              }
	              handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options);
	              handleTickMarkDefaults(containerIn, containerOut, coerce, options);
	              if (hasMinor) {
	                var keepIsMinor = options.isMinor;
	                options.isMinor = true;
	                handleTickMarkDefaults(containerIn, containerOut, coerce, options);
	                options.isMinor = keepIsMinor;
	              }
	              handleLineGridDefaults(containerIn, containerOut, coerce, {
	                dfltColor,
	                bgColor: options.bgColor,
	                showGrid: options.showGrid,
	                hasMinor,
	                attributes: layoutAttributes
	              });
	              if (hasMinor && !containerOut.minor.ticks && !containerOut.minor.showgrid) {
	                delete containerOut.minor;
	              }
	              if (containerOut.showline || containerOut.ticks) coerce("mirror");
	              var isMultiCategory = axType === "multicategory";
	              if (!options.noTickson && (axType === "category" || isMultiCategory) && (containerOut.ticks || containerOut.showgrid)) {
	                var ticksonDflt;
	                if (isMultiCategory) ticksonDflt = "boundaries";
	                var tickson = coerce("tickson", ticksonDflt);
	                if (tickson === "boundaries") {
	                  delete containerOut.ticklabelposition;
	                }
	              }
	              if (isMultiCategory) {
	                var showDividers = coerce("showdividers");
	                if (showDividers) {
	                  coerce("dividercolor");
	                  coerce("dividerwidth");
	                }
	              }
	              if (axType === "date") {
	                handleArrayContainerDefaults(containerIn, containerOut, {
	                  name: "rangebreaks",
	                  inclusionAttr: "enabled",
	                  handleItemDefaults: rangebreaksDefaults
	                });
	                if (!containerOut.rangebreaks.length) {
	                  delete containerOut.rangebreaks;
	                } else {
	                  for (var k = 0; k < containerOut.rangebreaks.length; k++) {
	                    if (containerOut.rangebreaks[k].pattern === DAY_OF_WEEK) {
	                      containerOut._hasDayOfWeekBreaks = true;
	                      break;
	                    }
	                  }
	                  setConvert(containerOut, layoutOut);
	                  if (layoutOut._has("scattergl") || layoutOut._has("splom")) {
	                    for (var i = 0; i < options.data.length; i++) {
	                      var trace = options.data[i];
	                      if (trace.type === "scattergl" || trace.type === "splom") {
	                        trace.visible = false;
	                        Lib.warn(trace.type + " traces do not work on axes with rangebreaks. Setting trace " + trace.index + " to `visible: false`.");
	                      }
	                    }
	                  }
	                }
	              }
	              return containerOut;
	            };
	            function rangebreaksDefaults(itemIn, itemOut, containerOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(itemIn, itemOut, layoutAttributes.rangebreaks, attr, dflt);
	              }
	              var enabled = coerce("enabled");
	              if (enabled) {
	                var bnds = coerce("bounds");
	                if (bnds && bnds.length >= 2) {
	                  var dfltPattern = "";
	                  var i, q;
	                  if (bnds.length === 2) {
	                    for (i = 0; i < 2; i++) {
	                      q = indexOfDay(bnds[i]);
	                      if (q) {
	                        dfltPattern = DAY_OF_WEEK;
	                        break;
	                      }
	                    }
	                  }
	                  var pattern = coerce("pattern", dfltPattern);
	                  if (pattern === DAY_OF_WEEK) {
	                    for (i = 0; i < 2; i++) {
	                      q = indexOfDay(bnds[i]);
	                      if (q) {
	                        itemOut.bounds[i] = bnds[i] = q - 1;
	                      }
	                    }
	                  }
	                  if (pattern) {
	                    for (i = 0; i < 2; i++) {
	                      q = bnds[i];
	                      switch (pattern) {
	                        case DAY_OF_WEEK:
	                          if (!isNumeric(q)) {
	                            itemOut.enabled = false;
	                            return;
	                          }
	                          q = +q;
	                          if (q !== Math.floor(q) || // don't accept fractional days for mow
	                          q < 0 || q >= 7) {
	                            itemOut.enabled = false;
	                            return;
	                          }
	                          itemOut.bounds[i] = bnds[i] = q;
	                          break;
	                        case HOUR:
	                          if (!isNumeric(q)) {
	                            itemOut.enabled = false;
	                            return;
	                          }
	                          q = +q;
	                          if (q < 0 || q > 24) {
	                            itemOut.enabled = false;
	                            return;
	                          }
	                          itemOut.bounds[i] = bnds[i] = q;
	                          break;
	                      }
	                    }
	                  }
	                  if (containerOut.autorange === false) {
	                    var rng = containerOut.range;
	                    if (rng[0] < rng[1]) {
	                      if (bnds[0] < rng[0] && bnds[1] > rng[1]) {
	                        itemOut.enabled = false;
	                        return;
	                      }
	                    } else if (bnds[0] > rng[0] && bnds[1] < rng[1]) {
	                      itemOut.enabled = false;
	                      return;
	                    }
	                  }
	                } else {
	                  var values = coerce("values");
	                  if (values && values.length) {
	                    coerce("dvalue");
	                  } else {
	                    itemOut.enabled = false;
	                    return;
	                  }
	                }
	              }
	            }
	            var dayStrToNum = {
	              sun: 1,
	              mon: 2,
	              tue: 3,
	              wed: 4,
	              thu: 5,
	              fri: 6,
	              sat: 7
	            };
	            function indexOfDay(v) {
	              if (typeof v !== "string") return;
	              return dayStrToNum[v.substr(0, 3).toLowerCase()];
	            }
	          }
	        ),
	        /***/
	        12663: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var docs = __webpack_require__2(31562);
	            var FORMAT_LINK = docs.FORMAT_LINK;
	            var DATE_FORMAT_LINK = docs.DATE_FORMAT_LINK;
	            function axisHoverFormat(x, noDates) {
	              return {
	                valType: "string",
	                dflt: "",
	                editType: "none",
	                description: (noDates ? descriptionOnlyNumbers : descriptionWithDates)("hover text", x) + ["By default the values are formatted using " + (noDates ? "generic number format" : "`" + x + "axis.hoverformat`") + "."].join(" ")
	              };
	            }
	            function descriptionOnlyNumbers(label, x) {
	              return ["Sets the " + label + " formatting rule" + (x ? "for `" + x + "` " : ""), "using d3 formatting mini-languages", "which are very similar to those in Python. For numbers, see: " + FORMAT_LINK + "."].join(" ");
	            }
	            function descriptionWithDates(label, x) {
	              return descriptionOnlyNumbers(label, x) + [" And for dates see: " + DATE_FORMAT_LINK + ".", "We add two items to d3's date formatter:", "*%h* for half of the year as a decimal number as well as", "*%{n}f* for fractional seconds", "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat", "*%H~%M~%S.%2f* would display *09~15~23.46*"].join(" ");
	            }
	            module2.exports = {
	              axisHoverFormat,
	              descriptionOnlyNumbers,
	              descriptionWithDates
	            };
	          }
	        ),
	        /***/
	        41675: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var constants = __webpack_require__2(85555);
	            exports2.id2name = function id2name(id) {
	              if (typeof id !== "string" || !id.match(constants.AX_ID_PATTERN)) return;
	              var axNum = id.split(" ")[0].substr(1);
	              if (axNum === "1") axNum = "";
	              return id.charAt(0) + "axis" + axNum;
	            };
	            exports2.name2id = function name2id(name2) {
	              if (!name2.match(constants.AX_NAME_PATTERN)) return;
	              var axNum = name2.substr(5);
	              if (axNum === "1") axNum = "";
	              return name2.charAt(0) + axNum;
	            };
	            exports2.cleanId = function cleanId(id, axLetter, domainId) {
	              var domainTest = /( domain)$/.test(id);
	              if (typeof id !== "string" || !id.match(constants.AX_ID_PATTERN)) return;
	              if (axLetter && id.charAt(0) !== axLetter) return;
	              if (domainTest && !domainId) return;
	              var axNum = id.split(" ")[0].substr(1).replace(/^0+/, "");
	              if (axNum === "1") axNum = "";
	              return id.charAt(0) + axNum + (domainTest && domainId ? " domain" : "");
	            };
	            exports2.list = function(gd, axLetter, only2d) {
	              var fullLayout = gd._fullLayout;
	              if (!fullLayout) return [];
	              var idList = exports2.listIds(gd, axLetter);
	              var out = new Array(idList.length);
	              var i;
	              for (i = 0; i < idList.length; i++) {
	                var idi = idList[i];
	                out[i] = fullLayout[idi.charAt(0) + "axis" + idi.substr(1)];
	              }
	              if (!only2d) {
	                var sceneIds3D = fullLayout._subplots.gl3d || [];
	                for (i = 0; i < sceneIds3D.length; i++) {
	                  var scene = fullLayout[sceneIds3D[i]];
	                  if (axLetter) out.push(scene[axLetter + "axis"]);
	                  else out.push(scene.xaxis, scene.yaxis, scene.zaxis);
	                }
	              }
	              return out;
	            };
	            exports2.listIds = function(gd, axLetter) {
	              var fullLayout = gd._fullLayout;
	              if (!fullLayout) return [];
	              var subplotLists = fullLayout._subplots;
	              if (axLetter) return subplotLists[axLetter + "axis"];
	              return subplotLists.xaxis.concat(subplotLists.yaxis);
	            };
	            exports2.getFromId = function(gd, id, type) {
	              var fullLayout = gd._fullLayout;
	              id = id === undefined || typeof id !== "string" ? id : id.replace(" domain", "");
	              if (type === "x") id = id.replace(/y[0-9]*/, "");
	              else if (type === "y") id = id.replace(/x[0-9]*/, "");
	              return fullLayout[exports2.id2name(id)];
	            };
	            exports2.getFromTrace = function(gd, fullTrace, type) {
	              var fullLayout = gd._fullLayout;
	              var ax = null;
	              if (Registry.traceIs(fullTrace, "gl3d")) {
	                var scene = fullTrace.scene;
	                if (scene.substr(0, 5) === "scene") {
	                  ax = fullLayout[scene][type + "axis"];
	                }
	              } else {
	                ax = exports2.getFromId(gd, fullTrace[type + "axis"] || type);
	              }
	              return ax;
	            };
	            exports2.idSort = function(id1, id2) {
	              var letter1 = id1.charAt(0);
	              var letter2 = id2.charAt(0);
	              if (letter1 !== letter2) return letter1 > letter2 ? 1 : -1;
	              return +(id1.substr(1) || 1) - +(id2.substr(1) || 1);
	            };
	            exports2.ref2id = function(ar) {
	              return /^[xyz]/.test(ar) ? ar.split(" ")[0] : false;
	            };
	            function isFound(axId, list) {
	              if (list && list.length) {
	                for (var i = 0; i < list.length; i++) {
	                  if (list[i][axId]) return true;
	                }
	              }
	              return false;
	            }
	            exports2.isLinked = function(fullLayout, axId) {
	              return isFound(axId, fullLayout._axisMatchGroups) || isFound(axId, fullLayout._axisConstraintGroups);
	            };
	          }
	        ),
	        /***/
	        15258: (
	          /***/
	          function(module2) {
	            function findCategories(ax, opts) {
	              var dataAttr = opts.dataAttr || ax._id.charAt(0);
	              var lookup = {};
	              var axData;
	              var i, j;
	              if (opts.axData) {
	                axData = opts.axData;
	              } else {
	                axData = [];
	                for (i = 0; i < opts.data.length; i++) {
	                  var trace = opts.data[i];
	                  if (trace[dataAttr + "axis"] === ax._id) {
	                    axData.push(trace);
	                  }
	                }
	              }
	              for (i = 0; i < axData.length; i++) {
	                var vals = axData[i][dataAttr];
	                for (j = 0; j < vals.length; j++) {
	                  var v = vals[j];
	                  if (v !== null && v !== undefined) {
	                    lookup[v] = 1;
	                  }
	                }
	              }
	              return Object.keys(lookup);
	            }
	            module2.exports = function handleCategoryOrderDefaults(containerIn, containerOut, coerce, opts) {
	              if (containerOut.type !== "category") return;
	              var arrayIn = containerIn.categoryarray;
	              var isValidArray = Array.isArray(arrayIn) && arrayIn.length > 0;
	              var orderDefault;
	              if (isValidArray) orderDefault = "array";
	              var order = coerce("categoryorder", orderDefault);
	              var array;
	              if (order === "array") {
	                array = coerce("categoryarray");
	              }
	              if (!isValidArray && order === "array") {
	                order = containerOut.categoryorder = "trace";
	              }
	              if (order === "trace") {
	                containerOut._initialCategories = [];
	              } else if (order === "array") {
	                containerOut._initialCategories = array.slice();
	              } else {
	                array = findCategories(containerOut, opts).sort();
	                if (order === "category ascending") {
	                  containerOut._initialCategories = array;
	                } else if (order === "category descending") {
	                  containerOut._initialCategories = array.reverse();
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        66287: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(50606);
	            var ONEDAY = constants.ONEDAY;
	            var ONEWEEK = constants.ONEWEEK;
	            exports2.dtick = function(dtick, axType) {
	              var isLog = axType === "log";
	              var isDate = axType === "date";
	              var isCat = axType === "category";
	              var dtickDflt = isDate ? ONEDAY : 1;
	              if (!dtick) return dtickDflt;
	              if (isNumeric(dtick)) {
	                dtick = Number(dtick);
	                if (dtick <= 0) return dtickDflt;
	                if (isCat) {
	                  return Math.max(1, Math.round(dtick));
	                }
	                if (isDate) {
	                  return Math.max(0.1, dtick);
	                }
	                return dtick;
	              }
	              if (typeof dtick !== "string" || !(isDate || isLog)) {
	                return dtickDflt;
	              }
	              var prefix = dtick.charAt(0);
	              var dtickNum = dtick.substr(1);
	              dtickNum = isNumeric(dtickNum) ? Number(dtickNum) : 0;
	              if (dtickNum <= 0 || !// "M<n>" gives ticks every (integer) n months
	              (isDate && prefix === "M" && dtickNum === Math.round(dtickNum) || // "L<f>" gives ticks linearly spaced in data (not in position) every (float) f
	              isLog && prefix === "L" || // "D1" gives powers of 10 with all small digits between, "D2" gives only 2 and 5
	              isLog && prefix === "D" && (dtickNum === 1 || dtickNum === 2))) {
	                return dtickDflt;
	              }
	              return dtick;
	            };
	            exports2.tick0 = function(tick0, axType, calendar, dtick) {
	              if (axType === "date") {
	                return Lib.cleanDate(tick0, Lib.dateTick0(calendar, dtick % ONEWEEK === 0 ? 1 : 0));
	              }
	              if (dtick === "D1" || dtick === "D2") {
	                return undefined;
	              }
	              return isNumeric(tick0) ? Number(tick0) : 0;
	            };
	          }
	        ),
	        /***/
	        85555: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var counterRegex = __webpack_require__2(30587).counter;
	            module2.exports = {
	              idRegex: {
	                x: counterRegex("x", "( domain)?"),
	                y: counterRegex("y", "( domain)?")
	              },
	              attrRegex: counterRegex("[xy]axis"),
	              // axis match regular expression
	              xAxisMatch: counterRegex("xaxis"),
	              yAxisMatch: counterRegex("yaxis"),
	              // pattern matching axis ids and names
	              // note that this is more permissive than counterRegex, as
	              // id2name, name2id, and cleanId accept "x1" etc
	              AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
	              AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
	              // and for 2D subplots
	              SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
	              HOUR_PATTERN: "hour",
	              WEEKDAY_PATTERN: "day of week",
	              // pixels to move mouse before you stop clamping to starting point
	              MINDRAG: 8,
	              // smallest dimension allowed for a zoombox
	              MINZOOM: 20,
	              // width of axis drag regions
	              DRAGGERSIZE: 20,
	              // delay before a redraw (relayout) after smooth panning and zooming
	              REDRAWDELAY: 50,
	              // last resort axis ranges for x and y axes if we have no data
	              DFLTRANGEX: [-1, 6],
	              DFLTRANGEY: [-1, 4],
	              // Layers to keep trace types in the right order
	              // N.B. each  'unique' plot method must have its own layer
	              traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"],
	              clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"],
	              layerValue2layerClass: {
	                "above traces": "above",
	                "below traces": "below"
	              }
	            };
	          }
	        ),
	        /***/
	        99082: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var autorange = __webpack_require__2(71739);
	            var id2name = __webpack_require__2(41675).id2name;
	            var layoutAttributes = __webpack_require__2(13838);
	            var scaleZoom = __webpack_require__2(42449);
	            var setConvert = __webpack_require__2(21994);
	            var ALMOST_EQUAL = __webpack_require__2(50606).ALMOST_EQUAL;
	            var FROM_BL = __webpack_require__2(18783).FROM_BL;
	            exports2.handleDefaults = function(layoutIn, layoutOut, opts) {
	              var axIds = opts.axIds;
	              var axHasImage = opts.axHasImage;
	              var constraintGroups = layoutOut._axisConstraintGroups = [];
	              var matchGroups = layoutOut._axisMatchGroups = [];
	              var i, group, axId, axName, axIn, axOut, attr, val;
	              for (i = 0; i < axIds.length; i++) {
	                axName = id2name(axIds[i]);
	                axIn = layoutIn[axName];
	                axOut = layoutOut[axName];
	                handleOneAxDefaults(axIn, axOut, {
	                  axIds,
	                  layoutOut,
	                  hasImage: axHasImage[axName]
	                });
	              }
	              function stash(groups, stashAttr) {
	                for (i = 0; i < groups.length; i++) {
	                  group = groups[i];
	                  for (axId in group) {
	                    layoutOut[id2name(axId)][stashAttr] = group;
	                  }
	                }
	              }
	              stash(matchGroups, "_matchGroup");
	              for (i = 0; i < constraintGroups.length; i++) {
	                group = constraintGroups[i];
	                for (axId in group) {
	                  axOut = layoutOut[id2name(axId)];
	                  if (axOut.fixedrange) {
	                    for (var axId2 in group) {
	                      var axName2 = id2name(axId2);
	                      if ((layoutIn[axName2] || {}).fixedrange === false) {
	                        Lib.warn("fixedrange was specified as false for axis " + axName2 + " but was overridden because another axis in its constraint group has fixedrange true");
	                      }
	                      layoutOut[axName2].fixedrange = true;
	                    }
	                    break;
	                  }
	                }
	              }
	              i = 0;
	              while (i < constraintGroups.length) {
	                group = constraintGroups[i];
	                for (axId in group) {
	                  axOut = layoutOut[id2name(axId)];
	                  if (axOut._matchGroup && Object.keys(axOut._matchGroup).length === Object.keys(group).length) {
	                    constraintGroups.splice(i, 1);
	                    i--;
	                  }
	                  break;
	                }
	                i++;
	              }
	              stash(constraintGroups, "_constraintGroup");
	              var matchAttrs = ["constrain", "range", "autorange", "rangemode", "rangebreaks", "categoryorder", "categoryarray"];
	              var hasRange = false;
	              var hasDayOfWeekBreaks = false;
	              function setAttrVal() {
	                val = axOut[attr];
	                if (attr === "rangebreaks") {
	                  hasDayOfWeekBreaks = axOut._hasDayOfWeekBreaks;
	                }
	              }
	              for (i = 0; i < matchGroups.length; i++) {
	                group = matchGroups[i];
	                for (var j = 0; j < matchAttrs.length; j++) {
	                  attr = matchAttrs[j];
	                  val = null;
	                  var baseAx;
	                  for (axId in group) {
	                    axName = id2name(axId);
	                    axIn = layoutIn[axName];
	                    axOut = layoutOut[axName];
	                    if (!(attr in axOut)) {
	                      continue;
	                    }
	                    if (!axOut.matches) {
	                      baseAx = axOut;
	                      if (attr in axIn) {
	                        setAttrVal();
	                        break;
	                      }
	                    }
	                    if (val === null && attr in axIn) {
	                      setAttrVal();
	                    }
	                  }
	                  if (attr === "range" && val && axIn.range && axIn.range.length === 2 && axIn.range[0] !== null && axIn.range[1] !== null) {
	                    hasRange = true;
	                  }
	                  if (attr === "autorange" && val === null && hasRange) {
	                    val = false;
	                  }
	                  if (val === null && attr in baseAx) {
	                    val = baseAx[attr];
	                  }
	                  if (val !== null) {
	                    for (axId in group) {
	                      axOut = layoutOut[id2name(axId)];
	                      axOut[attr] = attr === "range" ? val.slice() : val;
	                      if (attr === "rangebreaks") {
	                        axOut._hasDayOfWeekBreaks = hasDayOfWeekBreaks;
	                        setConvert(axOut, layoutOut);
	                      }
	                    }
	                  }
	                }
	              }
	            };
	            function handleOneAxDefaults(axIn, axOut, opts) {
	              var axIds = opts.axIds;
	              var layoutOut = opts.layoutOut;
	              var hasImage = opts.hasImage;
	              var constraintGroups = layoutOut._axisConstraintGroups;
	              var matchGroups = layoutOut._axisMatchGroups;
	              var axId = axOut._id;
	              var axLetter = axId.charAt(0);
	              var splomStash = ((layoutOut._splomAxes || {})[axLetter] || {})[axId] || {};
	              var thisID = axOut._id;
	              var isX = thisID.charAt(0) === "x";
	              axOut._matchGroup = null;
	              axOut._constraintGroup = null;
	              function coerce(attr, dflt) {
	                return Lib.coerce(axIn, axOut, layoutAttributes, attr, dflt);
	              }
	              coerce("constrain", hasImage ? "domain" : "range");
	              Lib.coerce(axIn, axOut, {
	                constraintoward: {
	                  valType: "enumerated",
	                  values: isX ? ["left", "center", "right"] : ["bottom", "middle", "top"],
	                  dflt: isX ? "center" : "middle"
	                }
	              }, "constraintoward");
	              var thisType = axOut.type;
	              var i, idi;
	              var linkableAxes = [];
	              for (i = 0; i < axIds.length; i++) {
	                idi = axIds[i];
	                if (idi === thisID) continue;
	                var axi = layoutOut[id2name(idi)];
	                if (axi.type === thisType) {
	                  linkableAxes.push(idi);
	                }
	              }
	              var thisGroup = getConstraintGroup(constraintGroups, thisID);
	              if (thisGroup) {
	                var linkableAxesNoLoops = [];
	                for (i = 0; i < linkableAxes.length; i++) {
	                  idi = linkableAxes[i];
	                  if (!thisGroup[idi]) linkableAxesNoLoops.push(idi);
	                }
	                linkableAxes = linkableAxesNoLoops;
	              }
	              var canLink = linkableAxes.length;
	              var matches, scaleanchor;
	              if (canLink && (axIn.matches || splomStash.matches)) {
	                matches = Lib.coerce(axIn, axOut, {
	                  matches: {
	                    valType: "enumerated",
	                    values: linkableAxes,
	                    dflt: linkableAxes.indexOf(splomStash.matches) !== -1 ? splomStash.matches : undefined
	                  }
	                }, "matches");
	              }
	              var scaleanchorDflt = hasImage && !isX ? axOut.anchor : undefined;
	              if (canLink && !matches && (axIn.scaleanchor || scaleanchorDflt)) {
	                scaleanchor = Lib.coerce(axIn, axOut, {
	                  scaleanchor: {
	                    valType: "enumerated",
	                    values: linkableAxes.concat([false])
	                  }
	                }, "scaleanchor", scaleanchorDflt);
	              }
	              if (matches) {
	                axOut._matchGroup = updateConstraintGroups(matchGroups, thisID, matches, 1);
	                var matchedAx = layoutOut[id2name(matches)];
	                var matchRatio = extent2(layoutOut, axOut) / extent2(layoutOut, matchedAx);
	                if (isX !== (matches.charAt(0) === "x")) {
	                  matchRatio = (isX ? "x" : "y") + matchRatio;
	                }
	                updateConstraintGroups(constraintGroups, thisID, matches, matchRatio);
	              } else if (axIn.matches && axIds.indexOf(axIn.matches) !== -1) {
	                Lib.warn("ignored " + axOut._name + '.matches: "' + axIn.matches + '" to avoid an infinite loop');
	              }
	              if (scaleanchor) {
	                var scaleratio = coerce("scaleratio");
	                if (!scaleratio) scaleratio = axOut.scaleratio = 1;
	                updateConstraintGroups(constraintGroups, thisID, scaleanchor, scaleratio);
	              } else if (axIn.scaleanchor && axIds.indexOf(axIn.scaleanchor) !== -1) {
	                Lib.warn("ignored " + axOut._name + '.scaleanchor: "' + axIn.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
	              }
	            }
	            function extent2(layoutOut, ax) {
	              var domain = ax.domain;
	              if (!domain) {
	                domain = layoutOut[id2name(ax.overlaying)].domain;
	              }
	              return domain[1] - domain[0];
	            }
	            function getConstraintGroup(groups, thisID) {
	              for (var i = 0; i < groups.length; i++) {
	                if (groups[i][thisID]) {
	                  return groups[i];
	                }
	              }
	              return null;
	            }
	            function updateConstraintGroups(constraintGroups, thisID, thatID, scaleratio) {
	              var i, j, groupi, keyj, thisGroupIndex;
	              var thisGroup = getConstraintGroup(constraintGroups, thisID);
	              if (thisGroup === null) {
	                thisGroup = {};
	                thisGroup[thisID] = 1;
	                thisGroupIndex = constraintGroups.length;
	                constraintGroups.push(thisGroup);
	              } else {
	                thisGroupIndex = constraintGroups.indexOf(thisGroup);
	              }
	              var thisGroupKeys = Object.keys(thisGroup);
	              for (i = 0; i < constraintGroups.length; i++) {
	                groupi = constraintGroups[i];
	                if (i !== thisGroupIndex && groupi[thatID]) {
	                  var baseScale = groupi[thatID];
	                  for (j = 0; j < thisGroupKeys.length; j++) {
	                    keyj = thisGroupKeys[j];
	                    groupi[keyj] = multiplyScales(baseScale, multiplyScales(scaleratio, thisGroup[keyj]));
	                  }
	                  constraintGroups.splice(thisGroupIndex, 1);
	                  return;
	                }
	              }
	              if (scaleratio !== 1) {
	                for (j = 0; j < thisGroupKeys.length; j++) {
	                  var key = thisGroupKeys[j];
	                  thisGroup[key] = multiplyScales(scaleratio, thisGroup[key]);
	                }
	              }
	              thisGroup[thatID] = 1;
	            }
	            function multiplyScales(a, b) {
	              var aPrefix = "";
	              var bPrefix = "";
	              var aLen, bLen;
	              if (typeof a === "string") {
	                aPrefix = a.match(/^[xy]*/)[0];
	                aLen = aPrefix.length;
	                a = +a.substr(aLen);
	              }
	              if (typeof b === "string") {
	                bPrefix = b.match(/^[xy]*/)[0];
	                bLen = bPrefix.length;
	                b = +b.substr(bLen);
	              }
	              var c = a * b;
	              if (!aLen && !bLen) {
	                return c;
	              }
	              if (!aLen || !bLen || aPrefix.charAt(0) === bPrefix.charAt(0)) {
	                return aPrefix + bPrefix + a * b;
	              }
	              if (aLen === bLen) {
	                return c;
	              }
	              return (aLen > bLen ? aPrefix.substr(bLen) : bPrefix.substr(aLen)) + c;
	            }
	            function finalRatios(group, fullLayout) {
	              var size = fullLayout._size;
	              var yRatio = size.h / size.w;
	              var out = {};
	              var keys = Object.keys(group);
	              for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var val = group[key];
	                if (typeof val === "string") {
	                  var prefix = val.match(/^[xy]*/)[0];
	                  var pLen = prefix.length;
	                  val = +val.substr(pLen);
	                  var mult = prefix.charAt(0) === "y" ? yRatio : 1 / yRatio;
	                  for (var j = 0; j < pLen; j++) {
	                    val *= mult;
	                  }
	                }
	                out[key] = val;
	              }
	              return out;
	            }
	            exports2.enforce = function enforce(gd) {
	              var fullLayout = gd._fullLayout;
	              var constraintGroups = fullLayout._axisConstraintGroups || [];
	              var i, j, group, axisID, ax, normScale, mode, factor;
	              for (i = 0; i < constraintGroups.length; i++) {
	                group = finalRatios(constraintGroups[i], fullLayout);
	                var axisIDs = Object.keys(group);
	                var minScale = Infinity;
	                var maxScale = 0;
	                var matchScale = Infinity;
	                var normScales = {};
	                var axes = {};
	                var hasAnyDomainConstraint = false;
	                for (j = 0; j < axisIDs.length; j++) {
	                  axisID = axisIDs[j];
	                  axes[axisID] = ax = fullLayout[id2name(axisID)];
	                  if (ax._inputDomain) ax.domain = ax._inputDomain.slice();
	                  else ax._inputDomain = ax.domain.slice();
	                  if (!ax._inputRange) ax._inputRange = ax.range.slice();
	                  ax.setScale();
	                  normScales[axisID] = normScale = Math.abs(ax._m) / group[axisID];
	                  minScale = Math.min(minScale, normScale);
	                  if (ax.constrain === "domain" || !ax._constraintShrinkable) {
	                    matchScale = Math.min(matchScale, normScale);
	                  }
	                  delete ax._constraintShrinkable;
	                  maxScale = Math.max(maxScale, normScale);
	                  if (ax.constrain === "domain") hasAnyDomainConstraint = true;
	                }
	                if (minScale > ALMOST_EQUAL * maxScale && !hasAnyDomainConstraint) continue;
	                for (j = 0; j < axisIDs.length; j++) {
	                  axisID = axisIDs[j];
	                  normScale = normScales[axisID];
	                  ax = axes[axisID];
	                  mode = ax.constrain;
	                  if (normScale !== matchScale || mode === "domain") {
	                    factor = normScale / matchScale;
	                    if (mode === "range") {
	                      scaleZoom(ax, factor);
	                    } else {
	                      var inputDomain = ax._inputDomain;
	                      var domainShrunk = (ax.domain[1] - ax.domain[0]) / (inputDomain[1] - inputDomain[0]);
	                      var rangeShrunk = (ax.r2l(ax.range[1]) - ax.r2l(ax.range[0])) / (ax.r2l(ax._inputRange[1]) - ax.r2l(ax._inputRange[0]));
	                      factor /= domainShrunk;
	                      if (factor * rangeShrunk < 1) {
	                        ax.domain = ax._input.domain = inputDomain.slice();
	                        scaleZoom(ax, factor);
	                        continue;
	                      }
	                      if (rangeShrunk < 1) {
	                        ax.range = ax._input.range = ax._inputRange.slice();
	                        factor *= rangeShrunk;
	                      }
	                      if (ax.autorange) {
	                        var rl0 = ax.r2l(ax.range[0]);
	                        var rl1 = ax.r2l(ax.range[1]);
	                        var rangeCenter = (rl0 + rl1) / 2;
	                        var rangeMin = rangeCenter;
	                        var rangeMax = rangeCenter;
	                        var halfRange = Math.abs(rl1 - rangeCenter);
	                        var outerMin = rangeCenter - halfRange * factor * 1.0001;
	                        var outerMax = rangeCenter + halfRange * factor * 1.0001;
	                        var getPadMin = autorange.makePadFn(fullLayout, ax, 0);
	                        var getPadMax = autorange.makePadFn(fullLayout, ax, 1);
	                        updateDomain(ax, factor);
	                        var m = Math.abs(ax._m);
	                        var extremes = autorange.concatExtremes(gd, ax);
	                        var minArray = extremes.min;
	                        var maxArray = extremes.max;
	                        var newVal;
	                        var k;
	                        for (k = 0; k < minArray.length; k++) {
	                          newVal = minArray[k].val - getPadMin(minArray[k]) / m;
	                          if (newVal > outerMin && newVal < rangeMin) {
	                            rangeMin = newVal;
	                          }
	                        }
	                        for (k = 0; k < maxArray.length; k++) {
	                          newVal = maxArray[k].val + getPadMax(maxArray[k]) / m;
	                          if (newVal < outerMax && newVal > rangeMax) {
	                            rangeMax = newVal;
	                          }
	                        }
	                        var domainExpand = (rangeMax - rangeMin) / (2 * halfRange);
	                        factor /= domainExpand;
	                        rangeMin = ax.l2r(rangeMin);
	                        rangeMax = ax.l2r(rangeMax);
	                        ax.range = ax._input.range = rl0 < rl1 ? [rangeMin, rangeMax] : [rangeMax, rangeMin];
	                      }
	                      updateDomain(ax, factor);
	                    }
	                  }
	                }
	              }
	            };
	            exports2.getAxisGroup = function getAxisGroup(fullLayout, axId) {
	              var matchGroups = fullLayout._axisMatchGroups;
	              for (var i = 0; i < matchGroups.length; i++) {
	                var group = matchGroups[i];
	                if (group[axId]) return "g" + i;
	              }
	              return axId;
	            };
	            exports2.clean = function clean(gd, ax) {
	              if (ax._inputDomain) {
	                var isConstrained = false;
	                var axId = ax._id;
	                var constraintGroups = gd._fullLayout._axisConstraintGroups;
	                for (var j = 0; j < constraintGroups.length; j++) {
	                  if (constraintGroups[j][axId]) {
	                    isConstrained = true;
	                    break;
	                  }
	                }
	                if (!isConstrained || ax.constrain !== "domain") {
	                  ax._input.domain = ax.domain = ax._inputDomain;
	                  delete ax._inputDomain;
	                }
	              }
	            };
	            function updateDomain(ax, factor) {
	              var inputDomain = ax._inputDomain;
	              var centerFraction = FROM_BL[ax.constraintoward];
	              var center = inputDomain[0] + (inputDomain[1] - inputDomain[0]) * centerFraction;
	              ax.domain = ax._input.domain = [center + (inputDomain[0] - center) / factor, center + (inputDomain[1] - center) / factor];
	              ax.setScale();
	            }
	          }
	        ),
	        /***/
	        29323: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var numberFormat = Lib.numberFormat;
	            var tinycolor = __webpack_require__2(84267);
	            var supportsPassive = __webpack_require__2(38520);
	            var Registry = __webpack_require__2(73972);
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Fx = __webpack_require__2(30211);
	            var Axes = __webpack_require__2(89298);
	            var setCursor = __webpack_require__2(6964);
	            var dragElement = __webpack_require__2(28569);
	            var helpers = __webpack_require__2(64505);
	            var selectingOrDrawing = helpers.selectingOrDrawing;
	            var freeMode = helpers.freeMode;
	            var FROM_TL = __webpack_require__2(18783).FROM_TL;
	            var clearGlCanvases = __webpack_require__2(33306);
	            var redrawReglTraces = __webpack_require__2(61549).redrawReglTraces;
	            var Plots = __webpack_require__2(74875);
	            var getFromId = __webpack_require__2(41675).getFromId;
	            var prepSelect = __webpack_require__2(47322).prepSelect;
	            var clearOutline = __webpack_require__2(47322).clearOutline;
	            var selectOnClick = __webpack_require__2(47322).selectOnClick;
	            var scaleZoom = __webpack_require__2(42449);
	            var constants = __webpack_require__2(85555);
	            var MINDRAG = constants.MINDRAG;
	            var MINZOOM = constants.MINZOOM;
	            var SHOWZOOMOUTTIP = true;
	            function makeDragBox(gd, plotinfo, x, y, w, h, ns, ew) {
	              var zoomlayer = gd._fullLayout._zoomlayer;
	              var isMainDrag = ns + ew === "nsew";
	              var singleEnd = (ns + ew).length === 1;
	              var xa0, ya0;
	              var xaHash, yaHash;
	              var xaxes, yaxes;
	              var xs, ys;
	              var pw, ph;
	              var links;
	              var matches;
	              var xActive, yActive;
	              var allFixedRanges;
	              var editX, editY;
	              var hasScatterGl, hasSplom, hasSVG;
	              var updates;
	              var scaleX;
	              var scaleY;
	              x += plotinfo.yaxis._shift;
	              function recomputeAxisLists() {
	                xa0 = plotinfo.xaxis;
	                ya0 = plotinfo.yaxis;
	                pw = xa0._length;
	                ph = ya0._length;
	                xs = xa0._offset;
	                ys = ya0._offset;
	                xaHash = {};
	                xaHash[xa0._id] = xa0;
	                yaHash = {};
	                yaHash[ya0._id] = ya0;
	                if (ns && ew) {
	                  var overlays = plotinfo.overlays;
	                  for (var i = 0; i < overlays.length; i++) {
	                    var xa = overlays[i].xaxis;
	                    xaHash[xa._id] = xa;
	                    var ya = overlays[i].yaxis;
	                    yaHash[ya._id] = ya;
	                  }
	                }
	                xaxes = hashValues(xaHash);
	                yaxes = hashValues(yaHash);
	                xActive = isDirectionActive(xaxes, ew);
	                yActive = isDirectionActive(yaxes, ns);
	                allFixedRanges = !yActive && !xActive;
	                matches = calcLinks(gd, gd._fullLayout._axisMatchGroups, xaHash, yaHash);
	                links = calcLinks(gd, gd._fullLayout._axisConstraintGroups, xaHash, yaHash, matches);
	                var spConstrained = links.isSubplotConstrained || matches.isSubplotConstrained;
	                editX = ew || spConstrained;
	                editY = ns || spConstrained;
	                var fullLayout = gd._fullLayout;
	                hasScatterGl = fullLayout._has("scattergl");
	                hasSplom = fullLayout._has("splom");
	                hasSVG = fullLayout._has("svg");
	              }
	              recomputeAxisLists();
	              var cursor = getDragCursor(yActive + xActive, gd._fullLayout.dragmode, isMainDrag);
	              var dragger = makeRectDragger(plotinfo, ns + ew + "drag", cursor, x, y, w, h);
	              if (allFixedRanges && !isMainDrag) {
	                dragger.onmousedown = null;
	                dragger.style.pointerEvents = "none";
	                return dragger;
	              }
	              var dragOptions = {
	                element: dragger,
	                gd,
	                plotinfo
	              };
	              dragOptions.prepFn = function(e, startX, startY) {
	                var dragModePrev = dragOptions.dragmode;
	                var dragModeNow = gd._fullLayout.dragmode;
	                if (dragModeNow !== dragModePrev) {
	                  dragOptions.dragmode = dragModeNow;
	                }
	                recomputeAxisLists();
	                scaleX = gd._fullLayout._invScaleX;
	                scaleY = gd._fullLayout._invScaleY;
	                if (!allFixedRanges) {
	                  if (isMainDrag) {
	                    if (e.shiftKey) {
	                      if (dragModeNow === "pan") dragModeNow = "zoom";
	                      else if (!selectingOrDrawing(dragModeNow)) dragModeNow = "pan";
	                    } else if (e.ctrlKey) {
	                      dragModeNow = "pan";
	                    }
	                  } else {
	                    dragModeNow = "pan";
	                  }
	                }
	                if (freeMode(dragModeNow)) dragOptions.minDrag = 1;
	                else dragOptions.minDrag = undefined;
	                if (selectingOrDrawing(dragModeNow)) {
	                  dragOptions.xaxes = xaxes;
	                  dragOptions.yaxes = yaxes;
	                  prepSelect(e, startX, startY, dragOptions, dragModeNow);
	                } else {
	                  dragOptions.clickFn = clickFn;
	                  if (selectingOrDrawing(dragModePrev)) {
	                    clearAndResetSelect();
	                  }
	                  if (!allFixedRanges) {
	                    if (dragModeNow === "zoom") {
	                      dragOptions.moveFn = zoomMove;
	                      dragOptions.doneFn = zoomDone;
	                      dragOptions.minDrag = 1;
	                      zoomPrep(e, startX, startY);
	                    } else if (dragModeNow === "pan") {
	                      dragOptions.moveFn = plotDrag;
	                      dragOptions.doneFn = dragTail;
	                    }
	                  }
	                }
	                gd._fullLayout._redrag = function() {
	                  var dragDataNow = gd._dragdata;
	                  if (dragDataNow && dragDataNow.element === dragger) {
	                    var dragModeNow2 = gd._fullLayout.dragmode;
	                    if (!selectingOrDrawing(dragModeNow2)) {
	                      recomputeAxisLists();
	                      updateSubplots([0, 0, pw, ph]);
	                      dragOptions.moveFn(dragDataNow.dx, dragDataNow.dy);
	                    }
	                  }
	                };
	              };
	              function clearAndResetSelect() {
	                dragOptions.plotinfo.selection = false;
	                clearOutline(gd);
	              }
	              function clickFn(numClicks, evt) {
	                var gd2 = dragOptions.gd;
	                if (gd2._fullLayout._activeShapeIndex >= 0) {
	                  gd2._fullLayout._deactivateShape(gd2);
	                  return;
	                }
	                var clickmode = gd2._fullLayout.clickmode;
	                removeZoombox(gd2);
	                if (numClicks === 2 && !singleEnd) doubleClick();
	                if (isMainDrag) {
	                  if (clickmode.indexOf("select") > -1) {
	                    selectOnClick(evt, gd2, xaxes, yaxes, plotinfo.id, dragOptions);
	                  }
	                  if (clickmode.indexOf("event") > -1) {
	                    Fx.click(gd2, evt, plotinfo.id);
	                  }
	                } else if (numClicks === 1 && singleEnd) {
	                  var ax = ns ? ya0 : xa0;
	                  var end = ns === "s" || ew === "w" ? 0 : 1;
	                  var attrStr = ax._name + ".range[" + end + "]";
	                  var initialText = getEndText(ax, end);
	                  var hAlign = "left";
	                  var vAlign = "middle";
	                  if (ax.fixedrange) return;
	                  if (ns) {
	                    vAlign = ns === "n" ? "top" : "bottom";
	                    if (ax.side === "right") hAlign = "right";
	                  } else if (ew === "e") hAlign = "right";
	                  if (gd2._context.showAxisRangeEntryBoxes) {
	                    d3.select(dragger).call(svgTextUtils.makeEditable, {
	                      gd: gd2,
	                      immediate: true,
	                      background: gd2._fullLayout.paper_bgcolor,
	                      text: String(initialText),
	                      fill: ax.tickfont ? ax.tickfont.color : "#444",
	                      horizontalAlign: hAlign,
	                      verticalAlign: vAlign
	                    }).on("edit", function(text) {
	                      var v = ax.d2r(text);
	                      if (v !== undefined) {
	                        Registry.call("_guiRelayout", gd2, attrStr, v);
	                      }
	                    });
	                  }
	                }
	              }
	              dragElement.init(dragOptions);
	              var x0, y0;
	              var box;
	              var lum;
	              var path0;
	              var dimmed;
	              var zoomMode;
	              var zb;
	              var corners;
	              var zoomDragged;
	              function zoomPrep(e, startX, startY) {
	                var dragBBox = dragger.getBoundingClientRect();
	                x0 = startX - dragBBox.left;
	                y0 = startY - dragBBox.top;
	                gd._fullLayout._calcInverseTransform(gd);
	                var transformedCoords = Lib.apply3DTransform(gd._fullLayout._invTransform)(x0, y0);
	                x0 = transformedCoords[0];
	                y0 = transformedCoords[1];
	                box = {
	                  l: x0,
	                  r: x0,
	                  w: 0,
	                  t: y0,
	                  b: y0,
	                  h: 0
	                };
	                lum = gd._hmpixcount ? gd._hmlumcount / gd._hmpixcount : tinycolor(gd._fullLayout.plot_bgcolor).getLuminance();
	                path0 = "M0,0H" + pw + "V" + ph + "H0V0";
	                dimmed = false;
	                zoomMode = "xy";
	                zoomDragged = false;
	                zb = makeZoombox(zoomlayer, lum, xs, ys, path0);
	                corners = makeCorners(zoomlayer, xs, ys);
	              }
	              function zoomMove(dx0, dy0) {
	                if (gd._transitioningWithDuration) {
	                  return false;
	                }
	                var x1 = Math.max(0, Math.min(pw, scaleX * dx0 + x0));
	                var y1 = Math.max(0, Math.min(ph, scaleY * dy0 + y0));
	                var dx = Math.abs(x1 - x0);
	                var dy = Math.abs(y1 - y0);
	                box.l = Math.min(x0, x1);
	                box.r = Math.max(x0, x1);
	                box.t = Math.min(y0, y1);
	                box.b = Math.max(y0, y1);
	                function noZoom() {
	                  zoomMode = "";
	                  box.r = box.l;
	                  box.t = box.b;
	                  corners.attr("d", "M0,0Z");
	                }
	                if (links.isSubplotConstrained) {
	                  if (dx > MINZOOM || dy > MINZOOM) {
	                    zoomMode = "xy";
	                    if (dx / pw > dy / ph) {
	                      dy = dx * ph / pw;
	                      if (y0 > y1) box.t = y0 - dy;
	                      else box.b = y0 + dy;
	                    } else {
	                      dx = dy * pw / ph;
	                      if (x0 > x1) box.l = x0 - dx;
	                      else box.r = x0 + dx;
	                    }
	                    corners.attr("d", xyCorners(box));
	                  } else {
	                    noZoom();
	                  }
	                } else if (matches.isSubplotConstrained) {
	                  if (dx > MINZOOM || dy > MINZOOM) {
	                    zoomMode = "xy";
	                    var r0 = Math.min(box.l / pw, (ph - box.b) / ph);
	                    var r1 = Math.max(box.r / pw, (ph - box.t) / ph);
	                    box.l = r0 * pw;
	                    box.r = r1 * pw;
	                    box.b = (1 - r0) * ph;
	                    box.t = (1 - r1) * ph;
	                    corners.attr("d", xyCorners(box));
	                  } else {
	                    noZoom();
	                  }
	                } else if (!yActive || dy < Math.min(Math.max(dx * 0.6, MINDRAG), MINZOOM)) {
	                  if (dx < MINDRAG || !xActive) {
	                    noZoom();
	                  } else {
	                    box.t = 0;
	                    box.b = ph;
	                    zoomMode = "x";
	                    corners.attr("d", xCorners(box, y0));
	                  }
	                } else if (!xActive || dx < Math.min(dy * 0.6, MINZOOM)) {
	                  box.l = 0;
	                  box.r = pw;
	                  zoomMode = "y";
	                  corners.attr("d", yCorners(box, x0));
	                } else {
	                  zoomMode = "xy";
	                  corners.attr("d", xyCorners(box));
	                }
	                box.w = box.r - box.l;
	                box.h = box.b - box.t;
	                if (zoomMode) zoomDragged = true;
	                gd._dragged = zoomDragged;
	                updateZoombox(zb, corners, box, path0, dimmed, lum);
	                computeZoomUpdates();
	                gd.emit("plotly_relayouting", updates);
	                dimmed = true;
	              }
	              function computeZoomUpdates() {
	                updates = {};
	                if (zoomMode === "xy" || zoomMode === "x") {
	                  zoomAxRanges(xaxes, box.l / pw, box.r / pw, updates, links.xaxes);
	                  updateMatchedAxRange("x", updates);
	                }
	                if (zoomMode === "xy" || zoomMode === "y") {
	                  zoomAxRanges(yaxes, (ph - box.b) / ph, (ph - box.t) / ph, updates, links.yaxes);
	                  updateMatchedAxRange("y", updates);
	                }
	              }
	              function zoomDone() {
	                computeZoomUpdates();
	                removeZoombox(gd);
	                dragTail();
	                showDoubleClickNotifier(gd);
	              }
	              var scrollViewBox = [0, 0, pw, ph];
	              var redrawTimer = null;
	              var REDRAWDELAY = constants.REDRAWDELAY;
	              var mainplot = plotinfo.mainplot ? gd._fullLayout._plots[plotinfo.mainplot] : plotinfo;
	              function zoomWheel(e) {
	                if (!gd._context._scrollZoom.cartesian && !gd._fullLayout._enablescrollzoom) {
	                  return;
	                }
	                clearAndResetSelect();
	                if (gd._transitioningWithDuration) {
	                  e.preventDefault();
	                  e.stopPropagation();
	                  return;
	                }
	                recomputeAxisLists();
	                clearTimeout(redrawTimer);
	                var wheelDelta = -e.deltaY;
	                if (!isFinite(wheelDelta)) wheelDelta = e.wheelDelta / 10;
	                if (!isFinite(wheelDelta)) {
	                  Lib.log("Did not find wheel motion attributes: ", e);
	                  return;
	                }
	                var zoom = Math.exp(-Math.min(Math.max(wheelDelta, -20), 20) / 200);
	                var gbb = mainplot.draglayer.select(".nsewdrag").node().getBoundingClientRect();
	                var xfrac = (e.clientX - gbb.left) / gbb.width;
	                var yfrac = (gbb.bottom - e.clientY) / gbb.height;
	                var i;
	                function zoomWheelOneAxis(ax, centerFraction, zoom2) {
	                  if (ax.fixedrange) return;
	                  var axRange = Lib.simpleMap(ax.range, ax.r2l);
	                  var v0 = axRange[0] + (axRange[1] - axRange[0]) * centerFraction;
	                  function doZoom(v) {
	                    return ax.l2r(v0 + (v - v0) * zoom2);
	                  }
	                  ax.range = axRange.map(doZoom);
	                }
	                if (editX) {
	                  if (!ew) xfrac = 0.5;
	                  for (i = 0; i < xaxes.length; i++) {
	                    zoomWheelOneAxis(xaxes[i], xfrac, zoom);
	                  }
	                  updateMatchedAxRange("x");
	                  scrollViewBox[2] *= zoom;
	                  scrollViewBox[0] += scrollViewBox[2] * xfrac * (1 / zoom - 1);
	                }
	                if (editY) {
	                  if (!ns) yfrac = 0.5;
	                  for (i = 0; i < yaxes.length; i++) {
	                    zoomWheelOneAxis(yaxes[i], yfrac, zoom);
	                  }
	                  updateMatchedAxRange("y");
	                  scrollViewBox[3] *= zoom;
	                  scrollViewBox[1] += scrollViewBox[3] * (1 - yfrac) * (1 / zoom - 1);
	                }
	                updateSubplots(scrollViewBox);
	                ticksAndAnnotations();
	                gd.emit("plotly_relayouting", updates);
	                redrawTimer = setTimeout(function() {
	                  if (!gd._fullLayout) return;
	                  scrollViewBox = [0, 0, pw, ph];
	                  dragTail();
	                }, REDRAWDELAY);
	                e.preventDefault();
	                return;
	              }
	              if (ns.length * ew.length !== 1) {
	                attachWheelEventHandler(dragger, zoomWheel);
	              }
	              function plotDrag(dx, dy) {
	                dx = dx * scaleX;
	                dy = dy * scaleY;
	                if (gd._transitioningWithDuration) {
	                  return;
	                }
	                gd._fullLayout._replotting = true;
	                if (xActive === "ew" || yActive === "ns") {
	                  var spDx = xActive ? -dx : 0;
	                  var spDy = yActive ? -dy : 0;
	                  if (matches.isSubplotConstrained) {
	                    if (xActive && yActive) {
	                      var frac = (dx / pw - dy / ph) / 2;
	                      dx = frac * pw;
	                      dy = -frac * ph;
	                      spDx = -dx;
	                      spDy = -dy;
	                    }
	                    if (yActive) {
	                      spDx = -spDy * pw / ph;
	                    } else {
	                      spDy = -spDx * ph / pw;
	                    }
	                  }
	                  if (xActive) {
	                    dragAxList(xaxes, dx);
	                    updateMatchedAxRange("x");
	                  }
	                  if (yActive) {
	                    dragAxList(yaxes, dy);
	                    updateMatchedAxRange("y");
	                  }
	                  updateSubplots([spDx, spDy, pw, ph]);
	                  ticksAndAnnotations();
	                  gd.emit("plotly_relayouting", updates);
	                  return;
	                }
	                function dz(axArray, end, d) {
	                  var otherEnd = 1 - end;
	                  var movedAx;
	                  var newLinearizedEnd;
	                  for (var i2 = 0; i2 < axArray.length; i2++) {
	                    var axi = axArray[i2];
	                    if (axi.fixedrange) continue;
	                    movedAx = axi;
	                    newLinearizedEnd = axi._rl[otherEnd] + (axi._rl[end] - axi._rl[otherEnd]) / dZoom(d / axi._length);
	                    var newEnd = axi.l2r(newLinearizedEnd);
	                    if (newEnd !== false && newEnd !== undefined) axi.range[end] = newEnd;
	                  }
	                  return movedAx._length * (movedAx._rl[end] - newLinearizedEnd) / (movedAx._rl[end] - movedAx._rl[otherEnd]);
	                }
	                var dxySign = xActive === "w" === (yActive === "n") ? 1 : -1;
	                if (xActive && yActive && (links.isSubplotConstrained || matches.isSubplotConstrained)) {
	                  var dxyFraction = (dx / pw + dxySign * dy / ph) / 2;
	                  dx = dxyFraction * pw;
	                  dy = dxySign * dxyFraction * ph;
	                }
	                var xStart, yStart;
	                if (xActive === "w") dx = dz(xaxes, 0, dx);
	                else if (xActive === "e") dx = dz(xaxes, 1, -dx);
	                else if (!xActive) dx = 0;
	                if (yActive === "n") dy = dz(yaxes, 1, dy);
	                else if (yActive === "s") dy = dz(yaxes, 0, -dy);
	                else if (!yActive) dy = 0;
	                xStart = xActive === "w" ? dx : 0;
	                yStart = yActive === "n" ? dy : 0;
	                if (links.isSubplotConstrained && !matches.isSubplotConstrained || // NW or SE on matching axes - create a symmetric zoom
	                matches.isSubplotConstrained && xActive && yActive && dxySign > 0) {
	                  var i;
	                  if (matches.isSubplotConstrained || !xActive && yActive.length === 1) {
	                    for (i = 0; i < xaxes.length; i++) {
	                      xaxes[i].range = xaxes[i]._r.slice();
	                      scaleZoom(xaxes[i], 1 - dy / ph);
	                    }
	                    dx = dy * pw / ph;
	                    xStart = dx / 2;
	                  }
	                  if (matches.isSubplotConstrained || !yActive && xActive.length === 1) {
	                    for (i = 0; i < yaxes.length; i++) {
	                      yaxes[i].range = yaxes[i]._r.slice();
	                      scaleZoom(yaxes[i], 1 - dx / pw);
	                    }
	                    dy = dx * ph / pw;
	                    yStart = dy / 2;
	                  }
	                }
	                if (!matches.isSubplotConstrained || !yActive) {
	                  updateMatchedAxRange("x");
	                }
	                if (!matches.isSubplotConstrained || !xActive) {
	                  updateMatchedAxRange("y");
	                }
	                var xSize = pw - dx;
	                var ySize = ph - dy;
	                if (matches.isSubplotConstrained && !(xActive && yActive)) {
	                  if (xActive) {
	                    yStart = xStart ? 0 : dx * ph / pw;
	                    ySize = xSize * ph / pw;
	                  } else {
	                    xStart = yStart ? 0 : dy * pw / ph;
	                    xSize = ySize * pw / ph;
	                  }
	                }
	                updateSubplots([xStart, yStart, xSize, ySize]);
	                ticksAndAnnotations();
	                gd.emit("plotly_relayouting", updates);
	              }
	              function updateMatchedAxRange(axLetter, out) {
	                var matchedAxes = matches.isSubplotConstrained ? {
	                  x: yaxes,
	                  y: xaxes
	                }[axLetter] : matches[axLetter + "axes"];
	                var constrainedAxes = matches.isSubplotConstrained ? {
	                  x: xaxes,
	                  y: yaxes
	                }[axLetter] : [];
	                for (var i = 0; i < matchedAxes.length; i++) {
	                  var ax = matchedAxes[i];
	                  var axId = ax._id;
	                  var axId2 = matches.xLinks[axId] || matches.yLinks[axId];
	                  var ax2 = constrainedAxes[0] || xaHash[axId2] || yaHash[axId2];
	                  if (ax2) {
	                    if (out) {
	                      out[ax._name + ".range[0]"] = out[ax2._name + ".range[0]"];
	                      out[ax._name + ".range[1]"] = out[ax2._name + ".range[1]"];
	                    } else {
	                      ax.range = ax2.range.slice();
	                    }
	                  }
	                }
	              }
	              function ticksAndAnnotations() {
	                var activeAxIds = [];
	                var i;
	                function pushActiveAxIds(axList) {
	                  for (i = 0; i < axList.length; i++) {
	                    if (!axList[i].fixedrange) activeAxIds.push(axList[i]._id);
	                  }
	                }
	                function pushActiveAxIdsSynced(axList, axisType) {
	                  for (i = 0; i < axList.length; i++) {
	                    var axListI = axList[i];
	                    var axListIType = axListI[axisType];
	                    if (!axListI.fixedrange && axListIType.tickmode === "sync") activeAxIds.push(axListIType._id);
	                  }
	                }
	                if (editX) {
	                  pushActiveAxIds(xaxes);
	                  pushActiveAxIds(links.xaxes);
	                  pushActiveAxIds(matches.xaxes);
	                  pushActiveAxIdsSynced(plotinfo.overlays, "xaxis");
	                }
	                if (editY) {
	                  pushActiveAxIds(yaxes);
	                  pushActiveAxIds(links.yaxes);
	                  pushActiveAxIds(matches.yaxes);
	                  pushActiveAxIdsSynced(plotinfo.overlays, "yaxis");
	                }
	                updates = {};
	                for (i = 0; i < activeAxIds.length; i++) {
	                  var axId = activeAxIds[i];
	                  var ax = getFromId(gd, axId);
	                  Axes.drawOne(gd, ax, {
	                    skipTitle: true
	                  });
	                  updates[ax._name + ".range[0]"] = ax.range[0];
	                  updates[ax._name + ".range[1]"] = ax.range[1];
	                }
	                Axes.redrawComponents(gd, activeAxIds);
	              }
	              function doubleClick() {
	                if (gd._transitioningWithDuration) return;
	                var doubleClickConfig = gd._context.doubleClick;
	                var axList = [];
	                if (xActive) axList = axList.concat(xaxes);
	                if (yActive) axList = axList.concat(yaxes);
	                if (matches.xaxes) axList = axList.concat(matches.xaxes);
	                if (matches.yaxes) axList = axList.concat(matches.yaxes);
	                var attrs = {};
	                var ax, i;
	                if (doubleClickConfig === "reset+autosize") {
	                  doubleClickConfig = "autosize";
	                  for (i = 0; i < axList.length; i++) {
	                    ax = axList[i];
	                    var r0 = ax._rangeInitial0;
	                    var r1 = ax._rangeInitial1;
	                    var hasRangeInitial = r0 !== undefined || r1 !== undefined;
	                    if (hasRangeInitial && (r0 !== undefined && r0 !== ax.range[0] || r1 !== undefined && r1 !== ax.range[1]) || !hasRangeInitial && ax.autorange !== true) {
	                      doubleClickConfig = "reset";
	                      break;
	                    }
	                  }
	                }
	                if (doubleClickConfig === "autosize") {
	                  for (i = 0; i < axList.length; i++) {
	                    ax = axList[i];
	                    if (!ax.fixedrange) attrs[ax._name + ".autorange"] = true;
	                  }
	                } else if (doubleClickConfig === "reset") {
	                  if (xActive || links.isSubplotConstrained) axList = axList.concat(links.xaxes);
	                  if (yActive && !links.isSubplotConstrained) axList = axList.concat(links.yaxes);
	                  if (links.isSubplotConstrained) {
	                    if (!xActive) axList = axList.concat(xaxes);
	                    else if (!yActive) axList = axList.concat(yaxes);
	                  }
	                  for (i = 0; i < axList.length; i++) {
	                    ax = axList[i];
	                    if (!ax.fixedrange) {
	                      var axName = ax._name;
	                      var autorangeInitial = ax._autorangeInitial;
	                      if (ax._rangeInitial0 === undefined && ax._rangeInitial1 === undefined) {
	                        attrs[axName + ".autorange"] = true;
	                      } else if (ax._rangeInitial0 === undefined) {
	                        attrs[axName + ".autorange"] = autorangeInitial;
	                        attrs[axName + ".range"] = [null, ax._rangeInitial1];
	                      } else if (ax._rangeInitial1 === undefined) {
	                        attrs[axName + ".range"] = [ax._rangeInitial0, null];
	                        attrs[axName + ".autorange"] = autorangeInitial;
	                      } else {
	                        attrs[axName + ".range"] = [ax._rangeInitial0, ax._rangeInitial1];
	                      }
	                    }
	                  }
	                }
	                gd.emit("plotly_doubleclick", null);
	                Registry.call("_guiRelayout", gd, attrs);
	              }
	              function dragTail() {
	                updateSubplots([0, 0, pw, ph]);
	                Lib.syncOrAsync([Plots.previousPromises, function() {
	                  gd._fullLayout._replotting = false;
	                  Registry.call("_guiRelayout", gd, updates);
	                }], gd);
	              }
	              function updateSubplots(viewBox) {
	                var fullLayout = gd._fullLayout;
	                var plotinfos = fullLayout._plots;
	                var subplots = fullLayout._subplots.cartesian;
	                var i, sp, xa, ya;
	                if (hasSplom) {
	                  Registry.subplotsRegistry.splom.drag(gd);
	                }
	                if (hasScatterGl) {
	                  for (i = 0; i < subplots.length; i++) {
	                    sp = plotinfos[subplots[i]];
	                    xa = sp.xaxis;
	                    ya = sp.yaxis;
	                    if (sp._scene) {
	                      var xrng = Lib.simpleMap(xa.range, xa.r2l);
	                      var yrng = Lib.simpleMap(ya.range, ya.r2l);
	                      if (xa.limitRange) xa.limitRange();
	                      if (ya.limitRange) ya.limitRange();
	                      xrng = xa.range;
	                      yrng = ya.range;
	                      sp._scene.update({
	                        range: [xrng[0], yrng[0], xrng[1], yrng[1]]
	                      });
	                    }
	                  }
	                }
	                if (hasSplom || hasScatterGl) {
	                  clearGlCanvases(gd);
	                  redrawReglTraces(gd);
	                }
	                if (hasSVG) {
	                  var xScaleFactor = viewBox[2] / xa0._length;
	                  var yScaleFactor = viewBox[3] / ya0._length;
	                  for (i = 0; i < subplots.length; i++) {
	                    sp = plotinfos[subplots[i]];
	                    xa = sp.xaxis;
	                    ya = sp.yaxis;
	                    var editX2 = (editX || matches.isSubplotConstrained) && !xa.fixedrange && xaHash[xa._id];
	                    var editY2 = (editY || matches.isSubplotConstrained) && !ya.fixedrange && yaHash[ya._id];
	                    var xScaleFactor2, yScaleFactor2;
	                    var clipDx, clipDy;
	                    if (editX2) {
	                      xScaleFactor2 = xScaleFactor;
	                      clipDx = ew || matches.isSubplotConstrained ? viewBox[0] : getShift(xa, xScaleFactor2);
	                    } else if (matches.xaHash[xa._id]) {
	                      xScaleFactor2 = xScaleFactor;
	                      clipDx = viewBox[0] * xa._length / xa0._length;
	                    } else if (matches.yaHash[xa._id]) {
	                      xScaleFactor2 = yScaleFactor;
	                      clipDx = yActive === "ns" ? -viewBox[1] * xa._length / ya0._length : getShift(xa, xScaleFactor2, {
	                        n: "top",
	                        s: "bottom"
	                      }[yActive]);
	                    } else {
	                      xScaleFactor2 = getLinkedScaleFactor(xa, xScaleFactor, yScaleFactor);
	                      clipDx = scaleAndGetShift(xa, xScaleFactor2);
	                    }
	                    if (xScaleFactor2 > 1 && (xa.maxallowed !== undefined && editX === (xa.range[0] < xa.range[1] ? "e" : "w") || xa.minallowed !== undefined && editX === (xa.range[0] < xa.range[1] ? "w" : "e"))) {
	                      xScaleFactor2 = 1;
	                      clipDx = 0;
	                    }
	                    if (editY2) {
	                      yScaleFactor2 = yScaleFactor;
	                      clipDy = ns || matches.isSubplotConstrained ? viewBox[1] : getShift(ya, yScaleFactor2);
	                    } else if (matches.yaHash[ya._id]) {
	                      yScaleFactor2 = yScaleFactor;
	                      clipDy = viewBox[1] * ya._length / ya0._length;
	                    } else if (matches.xaHash[ya._id]) {
	                      yScaleFactor2 = xScaleFactor;
	                      clipDy = xActive === "ew" ? -viewBox[0] * ya._length / xa0._length : getShift(ya, yScaleFactor2, {
	                        e: "right",
	                        w: "left"
	                      }[xActive]);
	                    } else {
	                      yScaleFactor2 = getLinkedScaleFactor(ya, xScaleFactor, yScaleFactor);
	                      clipDy = scaleAndGetShift(ya, yScaleFactor2);
	                    }
	                    if (yScaleFactor2 > 1 && (ya.maxallowed !== undefined && editY === (ya.range[0] < ya.range[1] ? "n" : "s") || ya.minallowed !== undefined && editY === (ya.range[0] < ya.range[1] ? "s" : "n"))) {
	                      yScaleFactor2 = 1;
	                      clipDy = 0;
	                    }
	                    if (!xScaleFactor2 && !yScaleFactor2) {
	                      continue;
	                    }
	                    if (!xScaleFactor2) xScaleFactor2 = 1;
	                    if (!yScaleFactor2) yScaleFactor2 = 1;
	                    var plotDx = xa._offset - clipDx / xScaleFactor2;
	                    var plotDy = ya._offset - clipDy / yScaleFactor2;
	                    sp.clipRect.call(Drawing.setTranslate, clipDx, clipDy).call(Drawing.setScale, xScaleFactor2, yScaleFactor2);
	                    sp.plot.call(Drawing.setTranslate, plotDx, plotDy).call(Drawing.setScale, 1 / xScaleFactor2, 1 / yScaleFactor2);
	                    if (xScaleFactor2 !== sp.xScaleFactor || yScaleFactor2 !== sp.yScaleFactor) {
	                      Drawing.setPointGroupScale(sp.zoomScalePts, xScaleFactor2, yScaleFactor2);
	                      Drawing.setTextPointsScale(sp.zoomScaleTxt, xScaleFactor2, yScaleFactor2);
	                    }
	                    Drawing.hideOutsideRangePoints(sp.clipOnAxisFalseTraces, sp);
	                    sp.xScaleFactor = xScaleFactor2;
	                    sp.yScaleFactor = yScaleFactor2;
	                  }
	                }
	              }
	              function getLinkedScaleFactor(ax, xScaleFactor, yScaleFactor) {
	                if (ax.fixedrange) return 0;
	                if (editX && links.xaHash[ax._id]) {
	                  return xScaleFactor;
	                }
	                if (editY && (links.isSubplotConstrained ? links.xaHash : links.yaHash)[ax._id]) {
	                  return yScaleFactor;
	                }
	                return 0;
	              }
	              function scaleAndGetShift(ax, scaleFactor) {
	                if (scaleFactor) {
	                  ax.range = ax._r.slice();
	                  scaleZoom(ax, scaleFactor);
	                  return getShift(ax, scaleFactor);
	                }
	                return 0;
	              }
	              function getShift(ax, scaleFactor, from) {
	                return ax._length * (1 - scaleFactor) * FROM_TL[from || ax.constraintoward || "middle"];
	              }
	              return dragger;
	            }
	            function makeDragger(plotinfo, nodeName, dragClass, cursor) {
	              var dragger3 = Lib.ensureSingle(plotinfo.draglayer, nodeName, dragClass, function(s) {
	                s.classed("drag", true).style({
	                  fill: "transparent",
	                  "stroke-width": 0
	                }).attr("data-subplot", plotinfo.id);
	              });
	              dragger3.call(setCursor, cursor);
	              return dragger3.node();
	            }
	            function makeRectDragger(plotinfo, dragClass, cursor, x, y, w, h) {
	              var dragger = makeDragger(plotinfo, "rect", dragClass, cursor);
	              d3.select(dragger).call(Drawing.setRect, x, y, w, h);
	              return dragger;
	            }
	            function isDirectionActive(axList, activeVal) {
	              for (var i = 0; i < axList.length; i++) {
	                if (!axList[i].fixedrange) return activeVal;
	              }
	              return "";
	            }
	            function getEndText(ax, end) {
	              var initialVal = ax.range[end];
	              var diff = Math.abs(initialVal - ax.range[1 - end]);
	              var dig;
	              if (ax.type === "date") {
	                return initialVal;
	              } else if (ax.type === "log") {
	                dig = Math.ceil(Math.max(0, -Math.log(diff) / Math.LN10)) + 3;
	                return numberFormat("." + dig + "g")(Math.pow(10, initialVal));
	              } else {
	                dig = Math.floor(Math.log(Math.abs(initialVal)) / Math.LN10) - Math.floor(Math.log(diff) / Math.LN10) + 4;
	                return numberFormat("." + String(dig) + "g")(initialVal);
	              }
	            }
	            function zoomAxRanges(axList, r0Fraction, r1Fraction, updates, linkedAxes) {
	              for (var i = 0; i < axList.length; i++) {
	                var axi = axList[i];
	                if (axi.fixedrange) continue;
	                if (axi.rangebreaks) {
	                  var isY = axi._id.charAt(0) === "y";
	                  var r0F = isY ? 1 - r0Fraction : r0Fraction;
	                  var r1F = isY ? 1 - r1Fraction : r1Fraction;
	                  updates[axi._name + ".range[0]"] = axi.l2r(axi.p2l(r0F * axi._length));
	                  updates[axi._name + ".range[1]"] = axi.l2r(axi.p2l(r1F * axi._length));
	                } else {
	                  var axRangeLinear0 = axi._rl[0];
	                  var axRangeLinearSpan = axi._rl[1] - axRangeLinear0;
	                  updates[axi._name + ".range[0]"] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r0Fraction);
	                  updates[axi._name + ".range[1]"] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r1Fraction);
	                }
	              }
	              if (linkedAxes && linkedAxes.length) {
	                var linkedR0Fraction = (r0Fraction + (1 - r1Fraction)) / 2;
	                zoomAxRanges(linkedAxes, linkedR0Fraction, 1 - linkedR0Fraction, updates, []);
	              }
	            }
	            function dragAxList(axList, pix) {
	              for (var i = 0; i < axList.length; i++) {
	                var axi = axList[i];
	                if (!axi.fixedrange) {
	                  if (axi.rangebreaks) {
	                    var p0 = 0;
	                    var p1 = axi._length;
	                    var d0 = axi.p2l(p0 + pix) - axi.p2l(p0);
	                    var d1 = axi.p2l(p1 + pix) - axi.p2l(p1);
	                    var delta = (d0 + d1) / 2;
	                    axi.range = [axi.l2r(axi._rl[0] - delta), axi.l2r(axi._rl[1] - delta)];
	                  } else {
	                    axi.range = [axi.l2r(axi._rl[0] - pix / axi._m), axi.l2r(axi._rl[1] - pix / axi._m)];
	                  }
	                  if (axi.limitRange) axi.limitRange();
	                }
	              }
	            }
	            function dZoom(d) {
	              return 1 - (d >= 0 ? Math.min(d, 0.9) : 1 / (1 / Math.max(d, -0.3) + 3.222));
	            }
	            function getDragCursor(nsew, dragmode, isMainDrag) {
	              if (!nsew) return "pointer";
	              if (nsew === "nsew") {
	                if (isMainDrag) return "";
	                if (dragmode === "pan") return "move";
	                return "crosshair";
	              }
	              return nsew.toLowerCase() + "-resize";
	            }
	            function makeZoombox(zoomlayer, lum, xs, ys, path0) {
	              return zoomlayer.append("path").attr("class", "zoombox").style({
	                fill: lum > 0.2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
	                "stroke-width": 0
	              }).attr("transform", strTranslate(xs, ys)).attr("d", path0 + "Z");
	            }
	            function makeCorners(zoomlayer, xs, ys) {
	              return zoomlayer.append("path").attr("class", "zoombox-corners").style({
	                fill: Color.background,
	                stroke: Color.defaultLine,
	                "stroke-width": 1,
	                opacity: 0
	              }).attr("transform", strTranslate(xs, ys)).attr("d", "M0,0Z");
	            }
	            function updateZoombox(zb, corners, box, path0, dimmed, lum) {
	              zb.attr("d", path0 + "M" + box.l + "," + box.t + "v" + box.h + "h" + box.w + "v-" + box.h + "h-" + box.w + "Z");
	              transitionZoombox(zb, corners, dimmed, lum);
	            }
	            function transitionZoombox(zb, corners, dimmed, lum) {
	              if (!dimmed) {
	                zb.transition().style("fill", lum > 0.2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200);
	                corners.transition().style("opacity", 1).duration(200);
	              }
	            }
	            function removeZoombox(gd) {
	              d3.select(gd).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
	            }
	            function showDoubleClickNotifier(gd) {
	              if (SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
	                Lib.notifier(Lib._(gd, "Double-click to zoom back out"), "long");
	                SHOWZOOMOUTTIP = false;
	              }
	            }
	            function xCorners(box, y0) {
	              return "M" + (box.l - 0.5) + "," + (y0 - MINZOOM - 0.5) + "h-3v" + (2 * MINZOOM + 1) + "h3ZM" + (box.r + 0.5) + "," + (y0 - MINZOOM - 0.5) + "h3v" + (2 * MINZOOM + 1) + "h-3Z";
	            }
	            function yCorners(box, x0) {
	              return "M" + (x0 - MINZOOM - 0.5) + "," + (box.t - 0.5) + "v-3h" + (2 * MINZOOM + 1) + "v3ZM" + (x0 - MINZOOM - 0.5) + "," + (box.b + 0.5) + "v3h" + (2 * MINZOOM + 1) + "v-3Z";
	            }
	            function xyCorners(box) {
	              var clen = Math.floor(Math.min(box.b - box.t, box.r - box.l, MINZOOM) / 2);
	              return "M" + (box.l - 3.5) + "," + (box.t - 0.5 + clen) + "h3v" + -clen + "h" + clen + "v-3h-" + (clen + 3) + "ZM" + (box.r + 3.5) + "," + (box.t - 0.5 + clen) + "h-3v" + -clen + "h" + -clen + "v-3h" + (clen + 3) + "ZM" + (box.r + 3.5) + "," + (box.b + 0.5 - clen) + "h-3v" + clen + "h" + -clen + "v3h" + (clen + 3) + "ZM" + (box.l - 3.5) + "," + (box.b + 0.5 - clen) + "h3v" + clen + "h" + clen + "v3h-" + (clen + 3) + "Z";
	            }
	            function calcLinks(gd, groups, xaHash, yaHash, exclude) {
	              var isSubplotConstrained = false;
	              var xLinks = {};
	              var yLinks = {};
	              var xID, yID, xLinkID, yLinkID;
	              var xExclude = (exclude || {}).xaHash;
	              var yExclude = (exclude || {}).yaHash;
	              for (var i = 0; i < groups.length; i++) {
	                var group = groups[i];
	                for (xID in xaHash) {
	                  if (group[xID]) {
	                    for (xLinkID in group) {
	                      if (!(exclude && (xExclude[xLinkID] || yExclude[xLinkID])) && !(xLinkID.charAt(0) === "x" ? xaHash : yaHash)[xLinkID]) {
	                        xLinks[xLinkID] = xID;
	                      }
	                    }
	                    for (yID in yaHash) {
	                      if (!(exclude && (xExclude[yID] || yExclude[yID])) && group[yID]) {
	                        isSubplotConstrained = true;
	                      }
	                    }
	                  }
	                }
	                for (yID in yaHash) {
	                  if (group[yID]) {
	                    for (yLinkID in group) {
	                      if (!(exclude && (xExclude[yLinkID] || yExclude[yLinkID])) && !(yLinkID.charAt(0) === "x" ? xaHash : yaHash)[yLinkID]) {
	                        yLinks[yLinkID] = yID;
	                      }
	                    }
	                  }
	                }
	              }
	              if (isSubplotConstrained) {
	                Lib.extendFlat(xLinks, yLinks);
	                yLinks = {};
	              }
	              var xaHashLinked = {};
	              var xaxesLinked = [];
	              for (xLinkID in xLinks) {
	                var xa = getFromId(gd, xLinkID);
	                xaxesLinked.push(xa);
	                xaHashLinked[xa._id] = xa;
	              }
	              var yaHashLinked = {};
	              var yaxesLinked = [];
	              for (yLinkID in yLinks) {
	                var ya = getFromId(gd, yLinkID);
	                yaxesLinked.push(ya);
	                yaHashLinked[ya._id] = ya;
	              }
	              return {
	                xaHash: xaHashLinked,
	                yaHash: yaHashLinked,
	                xaxes: xaxesLinked,
	                yaxes: yaxesLinked,
	                xLinks,
	                yLinks,
	                isSubplotConstrained
	              };
	            }
	            function attachWheelEventHandler(element, handler) {
	              if (!supportsPassive) {
	                if (element.onwheel !== undefined) element.onwheel = handler;
	                else if (element.onmousewheel !== undefined) element.onmousewheel = handler;
	                else if (!element.isAddedWheelEvent) {
	                  element.isAddedWheelEvent = true;
	                  element.addEventListener("wheel", handler, {
	                    passive: false
	                  });
	                }
	              } else {
	                var wheelEventName = element.onwheel !== undefined ? "wheel" : "mousewheel";
	                if (element._onwheel) {
	                  element.removeEventListener(wheelEventName, element._onwheel);
	                }
	                element._onwheel = handler;
	                element.addEventListener(wheelEventName, handler, {
	                  passive: false
	                });
	              }
	            }
	            function hashValues(hash) {
	              var out = [];
	              for (var k in hash) out.push(hash[k]);
	              return out;
	            }
	            module2.exports = {
	              makeDragBox,
	              makeDragger,
	              makeRectDragger,
	              makeZoombox,
	              makeCorners,
	              updateZoombox,
	              xyCorners,
	              transitionZoombox,
	              removeZoombox,
	              showDoubleClickNotifier,
	              attachWheelEventHandler
	            };
	          }
	        ),
	        /***/
	        4305: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Fx = __webpack_require__2(30211);
	            var dragElement = __webpack_require__2(28569);
	            var setCursor = __webpack_require__2(6964);
	            var makeDragBox = __webpack_require__2(29323).makeDragBox;
	            var DRAGGERSIZE = __webpack_require__2(85555).DRAGGERSIZE;
	            exports2.initInteractions = function initInteractions(gd) {
	              var fullLayout = gd._fullLayout;
	              if (gd._context.staticPlot) {
	                d3.select(gd).selectAll(".drag").remove();
	                return;
	              }
	              if (!fullLayout._has("cartesian") && !fullLayout._has("splom")) return;
	              var subplots = Object.keys(fullLayout._plots || {}).sort(function(a, b) {
	                if ((fullLayout._plots[a].mainplot && true) === (fullLayout._plots[b].mainplot && true)) {
	                  var aParts = a.split("y");
	                  var bParts = b.split("y");
	                  return aParts[0] === bParts[0] ? Number(aParts[1] || 1) - Number(bParts[1] || 1) : Number(aParts[0] || 1) - Number(bParts[0] || 1);
	                }
	                return fullLayout._plots[a].mainplot ? 1 : -1;
	              });
	              subplots.forEach(function(subplot) {
	                var plotinfo = fullLayout._plots[subplot];
	                var xa = plotinfo.xaxis;
	                var ya = plotinfo.yaxis;
	                if (!plotinfo.mainplot) {
	                  var maindrag = makeDragBox(gd, plotinfo, xa._offset, ya._offset, xa._length, ya._length, "ns", "ew");
	                  maindrag.onmousemove = function(evt) {
	                    gd._fullLayout._rehover = function() {
	                      if (gd._fullLayout._hoversubplot === subplot && gd._fullLayout._plots[subplot]) {
	                        Fx.hover(gd, evt, subplot);
	                      }
	                    };
	                    Fx.hover(gd, evt, subplot);
	                    gd._fullLayout._lasthover = maindrag;
	                    gd._fullLayout._hoversubplot = subplot;
	                  };
	                  maindrag.onmouseout = function(evt) {
	                    if (gd._dragging) return;
	                    gd._fullLayout._hoversubplot = null;
	                    dragElement.unhover(gd, evt);
	                  };
	                  if (gd._context.showAxisDragHandles) {
	                    makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset - DRAGGERSIZE, DRAGGERSIZE, DRAGGERSIZE, "n", "w");
	                    makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset - DRAGGERSIZE, DRAGGERSIZE, DRAGGERSIZE, "n", "e");
	                    makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset + ya._length, DRAGGERSIZE, DRAGGERSIZE, "s", "w");
	                    makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset + ya._length, DRAGGERSIZE, DRAGGERSIZE, "s", "e");
	                  }
	                }
	                if (gd._context.showAxisDragHandles) {
	                  if (subplot === xa._mainSubplot) {
	                    var y0 = xa._mainLinePosition;
	                    if (xa.side === "top") y0 -= DRAGGERSIZE;
	                    makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.1, y0, xa._length * 0.8, DRAGGERSIZE, "", "ew");
	                    makeDragBox(gd, plotinfo, xa._offset, y0, xa._length * 0.1, DRAGGERSIZE, "", "w");
	                    makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.9, y0, xa._length * 0.1, DRAGGERSIZE, "", "e");
	                  }
	                  if (subplot === ya._mainSubplot) {
	                    var x0 = ya._mainLinePosition;
	                    if (ya.side !== "right") x0 -= DRAGGERSIZE;
	                    makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.1, DRAGGERSIZE, ya._length * 0.8, "ns", "");
	                    makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.9, DRAGGERSIZE, ya._length * 0.1, "s", "");
	                    makeDragBox(gd, plotinfo, x0, ya._offset, DRAGGERSIZE, ya._length * 0.1, "n", "");
	                  }
	                }
	              });
	              var hoverLayer = fullLayout._hoverlayer.node();
	              hoverLayer.onmousemove = function(evt) {
	                evt.target = gd._fullLayout._lasthover;
	                Fx.hover(gd, evt, fullLayout._hoversubplot);
	              };
	              hoverLayer.onclick = function(evt) {
	                evt.target = gd._fullLayout._lasthover;
	                Fx.click(gd, evt);
	              };
	              hoverLayer.onmousedown = function(evt) {
	                gd._fullLayout._lasthover.onmousedown(evt);
	              };
	              exports2.updateFx(gd);
	            };
	            exports2.updateFx = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var cursor = fullLayout.dragmode === "pan" ? "move" : "crosshair";
	              setCursor(fullLayout._draggers, cursor);
	            };
	          }
	        ),
	        /***/
	        76325: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var axisIds = __webpack_require__2(41675);
	            module2.exports = function makeIncludeComponents(containerArrayName) {
	              return function includeComponents(layoutIn, layoutOut) {
	                var array = layoutIn[containerArrayName];
	                if (!Array.isArray(array)) return;
	                var Cartesian = Registry.subplotsRegistry.cartesian;
	                var idRegex = Cartesian.idRegex;
	                var subplots = layoutOut._subplots;
	                var xaList = subplots.xaxis;
	                var yaList = subplots.yaxis;
	                var cartesianList = subplots.cartesian;
	                var hasCartesianOrGL2D = layoutOut._has("cartesian") || layoutOut._has("gl2d");
	                for (var i = 0; i < array.length; i++) {
	                  var itemi = array[i];
	                  if (!Lib.isPlainObject(itemi)) continue;
	                  var xref = axisIds.cleanId(itemi.xref, "x", false);
	                  var yref = axisIds.cleanId(itemi.yref, "y", false);
	                  var hasXref = idRegex.x.test(xref);
	                  var hasYref = idRegex.y.test(yref);
	                  if (hasXref || hasYref) {
	                    if (!hasCartesianOrGL2D) Lib.pushUnique(layoutOut._basePlotModules, Cartesian);
	                    var newAxis = false;
	                    if (hasXref && xaList.indexOf(xref) === -1) {
	                      xaList.push(xref);
	                      newAxis = true;
	                    }
	                    if (hasYref && yaList.indexOf(yref) === -1) {
	                      yaList.push(yref);
	                      newAxis = true;
	                    }
	                    if (newAxis && hasXref && hasYref) {
	                      cartesianList.push(xref + yref);
	                    }
	                  }
	                }
	              };
	            };
	          }
	        ),
	        /***/
	        93612: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Plots = __webpack_require__2(74875);
	            var Drawing = __webpack_require__2(91424);
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var axisIds = __webpack_require__2(41675);
	            var constants = __webpack_require__2(85555);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var ensureSingle = Lib.ensureSingle;
	            function ensureSingleAndAddDatum(parent, nodeType, className) {
	              return Lib.ensureSingle(parent, nodeType, className, function(s) {
	                s.datum(className);
	              });
	            }
	            exports2.name = "cartesian";
	            exports2.attr = ["xaxis", "yaxis"];
	            exports2.idRoot = ["x", "y"];
	            exports2.idRegex = constants.idRegex;
	            exports2.attrRegex = constants.attrRegex;
	            exports2.attributes = __webpack_require__2(89502);
	            exports2.layoutAttributes = __webpack_require__2(13838);
	            exports2.supplyLayoutDefaults = __webpack_require__2(86763);
	            exports2.transitionAxes = __webpack_require__2(66847);
	            exports2.finalizeSubplots = function(layoutIn, layoutOut) {
	              var subplots = layoutOut._subplots;
	              var xList = subplots.xaxis;
	              var yList = subplots.yaxis;
	              var spSVG = subplots.cartesian;
	              var spAll = spSVG.concat(subplots.gl2d || []);
	              var allX = {};
	              var allY = {};
	              var i, xi, yi;
	              for (i = 0; i < spAll.length; i++) {
	                var parts = spAll[i].split("y");
	                allX[parts[0]] = 1;
	                allY["y" + parts[1]] = 1;
	              }
	              for (i = 0; i < xList.length; i++) {
	                xi = xList[i];
	                if (!allX[xi]) {
	                  yi = (layoutIn[axisIds.id2name(xi)] || {}).anchor;
	                  if (!constants.idRegex.y.test(yi)) yi = "y";
	                  spSVG.push(xi + yi);
	                  spAll.push(xi + yi);
	                  if (!allY[yi]) {
	                    allY[yi] = 1;
	                    Lib.pushUnique(yList, yi);
	                  }
	                }
	              }
	              for (i = 0; i < yList.length; i++) {
	                yi = yList[i];
	                if (!allY[yi]) {
	                  xi = (layoutIn[axisIds.id2name(yi)] || {}).anchor;
	                  if (!constants.idRegex.x.test(xi)) xi = "x";
	                  spSVG.push(xi + yi);
	                  spAll.push(xi + yi);
	                  if (!allX[xi]) {
	                    allX[xi] = 1;
	                    Lib.pushUnique(xList, xi);
	                  }
	                }
	              }
	              if (!spAll.length) {
	                xi = "";
	                yi = "";
	                for (var ki in layoutIn) {
	                  if (constants.attrRegex.test(ki)) {
	                    var axLetter = ki.charAt(0);
	                    if (axLetter === "x") {
	                      if (!xi || +ki.substr(5) < +xi.substr(5)) {
	                        xi = ki;
	                      }
	                    } else if (!yi || +ki.substr(5) < +yi.substr(5)) {
	                      yi = ki;
	                    }
	                  }
	                }
	                xi = xi ? axisIds.name2id(xi) : "x";
	                yi = yi ? axisIds.name2id(yi) : "y";
	                xList.push(xi);
	                yList.push(yi);
	                spSVG.push(xi + yi);
	              }
	            };
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              var fullLayout = gd._fullLayout;
	              var subplots = fullLayout._subplots.cartesian;
	              var calcdata = gd.calcdata;
	              var i;
	              if (!Array.isArray(traces)) {
	                traces = [];
	                for (i = 0; i < calcdata.length; i++) traces.push(i);
	              }
	              for (i = 0; i < subplots.length; i++) {
	                var subplot = subplots[i];
	                var subplotInfo = fullLayout._plots[subplot];
	                var cdSubplot = [];
	                var pcd;
	                for (var j = 0; j < calcdata.length; j++) {
	                  var cd = calcdata[j];
	                  var trace = cd[0].trace;
	                  if (trace.xaxis + trace.yaxis === subplot) {
	                    if (traces.indexOf(trace.index) !== -1 || trace.carpet) {
	                      if (pcd && pcd[0].trace.xaxis + pcd[0].trace.yaxis === subplot && ["tonextx", "tonexty", "tonext"].indexOf(trace.fill) !== -1 && cdSubplot.indexOf(pcd) === -1) {
	                        cdSubplot.push(pcd);
	                      }
	                      cdSubplot.push(cd);
	                    }
	                    pcd = cd;
	                  }
	                }
	                plotOne(gd, subplotInfo, cdSubplot, transitionOpts, makeOnCompleteCallback);
	              }
	            };
	            function plotOne(gd, plotinfo, cdSubplot, transitionOpts, makeOnCompleteCallback) {
	              var traceLayerClasses = constants.traceLayerClasses;
	              var fullLayout = gd._fullLayout;
	              var modules = fullLayout._modules;
	              var _module, cdModuleAndOthers, cdModule;
	              var layerData = [];
	              var zoomScaleQueryParts = [];
	              for (var i = 0; i < modules.length; i++) {
	                _module = modules[i];
	                var name2 = _module.name;
	                var categories = Registry.modules[name2].categories;
	                if (categories.svg) {
	                  var className = _module.layerName || name2 + "layer";
	                  var plotMethod = _module.plot;
	                  cdModuleAndOthers = getModuleCalcData(cdSubplot, plotMethod);
	                  cdModule = cdModuleAndOthers[0];
	                  cdSubplot = cdModuleAndOthers[1];
	                  if (cdModule.length) {
	                    layerData.push({
	                      i: traceLayerClasses.indexOf(className),
	                      className,
	                      plotMethod,
	                      cdModule
	                    });
	                  }
	                  if (categories.zoomScale) {
	                    zoomScaleQueryParts.push("." + className);
	                  }
	                }
	              }
	              layerData.sort(function(a, b) {
	                return a.i - b.i;
	              });
	              var layers = plotinfo.plot.selectAll("g.mlayer").data(layerData, function(d) {
	                return d.className;
	              });
	              layers.enter().append("g").attr("class", function(d) {
	                return d.className;
	              }).classed("mlayer", true).classed("rangeplot", plotinfo.isRangePlot);
	              layers.exit().remove();
	              layers.order();
	              layers.each(function(d) {
	                var sel = d3.select(this);
	                var className2 = d.className;
	                d.plotMethod(gd, plotinfo, d.cdModule, sel, transitionOpts, makeOnCompleteCallback);
	                if (constants.clipOnAxisFalseQuery.indexOf("." + className2) === -1) {
	                  Drawing.setClipUrl(sel, plotinfo.layerClipId, gd);
	                }
	              });
	              if (fullLayout._has("scattergl")) {
	                _module = Registry.getModule("scattergl");
	                cdModule = getModuleCalcData(cdSubplot, _module)[0];
	                _module.plot(gd, plotinfo, cdModule);
	              }
	              if (!gd._context.staticPlot) {
	                if (plotinfo._hasClipOnAxisFalse) {
	                  plotinfo.clipOnAxisFalseTraces = plotinfo.plot.selectAll(constants.clipOnAxisFalseQuery.join(",")).selectAll(".trace");
	                }
	                if (zoomScaleQueryParts.length) {
	                  var traces = plotinfo.plot.selectAll(zoomScaleQueryParts.join(",")).selectAll(".trace");
	                  plotinfo.zoomScalePts = traces.selectAll("path.point");
	                  plotinfo.zoomScaleTxt = traces.selectAll(".textpoint");
	                }
	              }
	            }
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldPlots = oldFullLayout._plots || {};
	              var newPlots = newFullLayout._plots || {};
	              var oldSubplotList = oldFullLayout._subplots || {};
	              var plotinfo;
	              var i, k;
	              if (oldFullLayout._hasOnlyLargeSploms && !newFullLayout._hasOnlyLargeSploms) {
	                for (k in oldPlots) {
	                  plotinfo = oldPlots[k];
	                  if (plotinfo.plotgroup) plotinfo.plotgroup.remove();
	                }
	              }
	              var hadGl = oldFullLayout._has && oldFullLayout._has("gl");
	              var hasGl = newFullLayout._has && newFullLayout._has("gl");
	              if (hadGl && !hasGl) {
	                for (k in oldPlots) {
	                  plotinfo = oldPlots[k];
	                  if (plotinfo._scene) plotinfo._scene.destroy();
	                }
	              }
	              if (oldSubplotList.xaxis && oldSubplotList.yaxis) {
	                var oldAxIDs = axisIds.listIds({
	                  _fullLayout: oldFullLayout
	                });
	                for (i = 0; i < oldAxIDs.length; i++) {
	                  var oldAxId = oldAxIDs[i];
	                  if (!newFullLayout[axisIds.id2name(oldAxId)]) {
	                    oldFullLayout._infolayer.selectAll(".g-" + oldAxId + "title").remove();
	                  }
	                }
	              }
	              var hadCartesian = oldFullLayout._has && oldFullLayout._has("cartesian");
	              var hasCartesian = newFullLayout._has && newFullLayout._has("cartesian");
	              if (hadCartesian && !hasCartesian) {
	                purgeSubplotLayers(oldFullLayout._cartesianlayer.selectAll(".subplot"), oldFullLayout);
	                oldFullLayout._defs.selectAll(".axesclip").remove();
	                delete oldFullLayout._axisConstraintGroups;
	                delete oldFullLayout._axisMatchGroups;
	              } else if (oldSubplotList.cartesian) {
	                for (i = 0; i < oldSubplotList.cartesian.length; i++) {
	                  var oldSubplotId = oldSubplotList.cartesian[i];
	                  if (!newPlots[oldSubplotId]) {
	                    var selector = "." + oldSubplotId + ",." + oldSubplotId + "-x,." + oldSubplotId + "-y";
	                    oldFullLayout._cartesianlayer.selectAll(selector).remove();
	                    removeSubplotExtras(oldSubplotId, oldFullLayout);
	                  }
	                }
	              }
	            };
	            exports2.drawFramework = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotData = makeSubplotData(gd);
	              var subplotLayers = fullLayout._cartesianlayer.selectAll(".subplot").data(subplotData, String);
	              subplotLayers.enter().append("g").attr("class", function(d) {
	                return "subplot " + d[0];
	              });
	              subplotLayers.order();
	              subplotLayers.exit().call(purgeSubplotLayers, fullLayout);
	              subplotLayers.each(function(d) {
	                var id = d[0];
	                var plotinfo = fullLayout._plots[id];
	                plotinfo.plotgroup = d3.select(this);
	                makeSubplotLayer(gd, plotinfo);
	                plotinfo.draglayer = ensureSingle(fullLayout._draggers, "g", id);
	              });
	            };
	            exports2.rangePlot = function(gd, plotinfo, cdSubplot) {
	              makeSubplotLayer(gd, plotinfo);
	              plotOne(gd, plotinfo, cdSubplot);
	              Plots.style(gd);
	            };
	            function makeSubplotData(gd) {
	              var fullLayout = gd._fullLayout;
	              var ids = fullLayout._subplots.cartesian;
	              var len = ids.length;
	              var i, j, id, plotinfo, xa, ya;
	              var regulars = [];
	              var overlays = [];
	              for (i = 0; i < len; i++) {
	                id = ids[i];
	                plotinfo = fullLayout._plots[id];
	                xa = plotinfo.xaxis;
	                ya = plotinfo.yaxis;
	                var xa2 = xa._mainAxis;
	                var ya2 = ya._mainAxis;
	                var mainplot = xa2._id + ya2._id;
	                var mainplotinfo = fullLayout._plots[mainplot];
	                plotinfo.overlays = [];
	                if (mainplot !== id && mainplotinfo) {
	                  plotinfo.mainplot = mainplot;
	                  plotinfo.mainplotinfo = mainplotinfo;
	                  overlays.push(id);
	                } else {
	                  plotinfo.mainplot = undefined;
	                  plotinfo.mainplotinfo = undefined;
	                  regulars.push(id);
	                }
	              }
	              for (i = 0; i < overlays.length; i++) {
	                id = overlays[i];
	                plotinfo = fullLayout._plots[id];
	                plotinfo.mainplotinfo.overlays.push(plotinfo);
	              }
	              var subplotIds = regulars.concat(overlays);
	              var subplotData = new Array(len);
	              for (i = 0; i < len; i++) {
	                id = subplotIds[i];
	                plotinfo = fullLayout._plots[id];
	                xa = plotinfo.xaxis;
	                ya = plotinfo.yaxis;
	                var d = [id, xa.layer, ya.layer, xa.overlaying || "", ya.overlaying || ""];
	                for (j = 0; j < plotinfo.overlays.length; j++) {
	                  d.push(plotinfo.overlays[j].id);
	                }
	                subplotData[i] = d;
	              }
	              return subplotData;
	            }
	            function makeSubplotLayer(gd, plotinfo) {
	              var plotgroup = plotinfo.plotgroup;
	              var id = plotinfo.id;
	              var xLayer = constants.layerValue2layerClass[plotinfo.xaxis.layer];
	              var yLayer = constants.layerValue2layerClass[plotinfo.yaxis.layer];
	              var hasOnlyLargeSploms = gd._fullLayout._hasOnlyLargeSploms;
	              if (!plotinfo.mainplot) {
	                if (hasOnlyLargeSploms) {
	                  plotinfo.xlines = ensureSingle(plotgroup, "path", "xlines-above");
	                  plotinfo.ylines = ensureSingle(plotgroup, "path", "ylines-above");
	                  plotinfo.xaxislayer = ensureSingle(plotgroup, "g", "xaxislayer-above");
	                  plotinfo.yaxislayer = ensureSingle(plotgroup, "g", "yaxislayer-above");
	                } else {
	                  var backLayer = ensureSingle(plotgroup, "g", "layer-subplot");
	                  plotinfo.shapelayer = ensureSingle(backLayer, "g", "shapelayer");
	                  plotinfo.imagelayer = ensureSingle(backLayer, "g", "imagelayer");
	                  plotinfo.minorGridlayer = ensureSingle(plotgroup, "g", "minor-gridlayer");
	                  plotinfo.gridlayer = ensureSingle(plotgroup, "g", "gridlayer");
	                  plotinfo.zerolinelayer = ensureSingle(plotgroup, "g", "zerolinelayer");
	                  ensureSingle(plotgroup, "path", "xlines-below");
	                  ensureSingle(plotgroup, "path", "ylines-below");
	                  plotinfo.overlinesBelow = ensureSingle(plotgroup, "g", "overlines-below");
	                  ensureSingle(plotgroup, "g", "xaxislayer-below");
	                  ensureSingle(plotgroup, "g", "yaxislayer-below");
	                  plotinfo.overaxesBelow = ensureSingle(plotgroup, "g", "overaxes-below");
	                  plotinfo.plot = ensureSingle(plotgroup, "g", "plot");
	                  plotinfo.overplot = ensureSingle(plotgroup, "g", "overplot");
	                  plotinfo.xlines = ensureSingle(plotgroup, "path", "xlines-above");
	                  plotinfo.ylines = ensureSingle(plotgroup, "path", "ylines-above");
	                  plotinfo.overlinesAbove = ensureSingle(plotgroup, "g", "overlines-above");
	                  ensureSingle(plotgroup, "g", "xaxislayer-above");
	                  ensureSingle(plotgroup, "g", "yaxislayer-above");
	                  plotinfo.overaxesAbove = ensureSingle(plotgroup, "g", "overaxes-above");
	                  plotinfo.xlines = plotgroup.select(".xlines-" + xLayer);
	                  plotinfo.ylines = plotgroup.select(".ylines-" + yLayer);
	                  plotinfo.xaxislayer = plotgroup.select(".xaxislayer-" + xLayer);
	                  plotinfo.yaxislayer = plotgroup.select(".yaxislayer-" + yLayer);
	                }
	              } else {
	                var mainplotinfo = plotinfo.mainplotinfo;
	                var mainplotgroup = mainplotinfo.plotgroup;
	                var xId = id + "-x";
	                var yId = id + "-y";
	                plotinfo.minorGridlayer = mainplotinfo.minorGridlayer;
	                plotinfo.gridlayer = mainplotinfo.gridlayer;
	                plotinfo.zerolinelayer = mainplotinfo.zerolinelayer;
	                ensureSingle(mainplotinfo.overlinesBelow, "path", xId);
	                ensureSingle(mainplotinfo.overlinesBelow, "path", yId);
	                ensureSingle(mainplotinfo.overaxesBelow, "g", xId);
	                ensureSingle(mainplotinfo.overaxesBelow, "g", yId);
	                plotinfo.plot = ensureSingle(mainplotinfo.overplot, "g", id);
	                ensureSingle(mainplotinfo.overlinesAbove, "path", xId);
	                ensureSingle(mainplotinfo.overlinesAbove, "path", yId);
	                ensureSingle(mainplotinfo.overaxesAbove, "g", xId);
	                ensureSingle(mainplotinfo.overaxesAbove, "g", yId);
	                plotinfo.xlines = mainplotgroup.select(".overlines-" + xLayer).select("." + xId);
	                plotinfo.ylines = mainplotgroup.select(".overlines-" + yLayer).select("." + yId);
	                plotinfo.xaxislayer = mainplotgroup.select(".overaxes-" + xLayer).select("." + xId);
	                plotinfo.yaxislayer = mainplotgroup.select(".overaxes-" + yLayer).select("." + yId);
	              }
	              if (!hasOnlyLargeSploms) {
	                ensureSingleAndAddDatum(plotinfo.minorGridlayer, "g", plotinfo.xaxis._id);
	                ensureSingleAndAddDatum(plotinfo.minorGridlayer, "g", plotinfo.yaxis._id);
	                plotinfo.minorGridlayer.selectAll("g").map(function(d) {
	                  return d[0];
	                }).sort(axisIds.idSort);
	                ensureSingleAndAddDatum(plotinfo.gridlayer, "g", plotinfo.xaxis._id);
	                ensureSingleAndAddDatum(plotinfo.gridlayer, "g", plotinfo.yaxis._id);
	                plotinfo.gridlayer.selectAll("g").map(function(d) {
	                  return d[0];
	                }).sort(axisIds.idSort);
	              }
	              plotinfo.xlines.style("fill", "none").classed("crisp", true);
	              plotinfo.ylines.style("fill", "none").classed("crisp", true);
	            }
	            function purgeSubplotLayers(layers, fullLayout) {
	              if (!layers) return;
	              var overlayIdsToRemove = {};
	              layers.each(function(d) {
	                var id = d[0];
	                var plotgroup = d3.select(this);
	                plotgroup.remove();
	                removeSubplotExtras(id, fullLayout);
	                overlayIdsToRemove[id] = true;
	              });
	              for (var k in fullLayout._plots) {
	                var subplotInfo = fullLayout._plots[k];
	                var overlays = subplotInfo.overlays || [];
	                for (var j = 0; j < overlays.length; j++) {
	                  var overlayInfo = overlays[j];
	                  if (overlayIdsToRemove[overlayInfo.id]) {
	                    overlayInfo.plot.selectAll(".trace").remove();
	                  }
	                }
	              }
	            }
	            function removeSubplotExtras(subplotId, fullLayout) {
	              fullLayout._draggers.selectAll("g." + subplotId).remove();
	              fullLayout._defs.select("#clip" + fullLayout._uid + subplotId + "plot").remove();
	            }
	            exports2.toSVG = function(gd) {
	              var imageRoot = gd._fullLayout._glimages;
	              var root = d3.select(gd).selectAll(".svg-container");
	              var canvases = root.filter(function(d, i) {
	                return i === root.size() - 1;
	              }).selectAll(".gl-canvas-context, .gl-canvas-focus");
	              function canvasToImage() {
	                var canvas = this;
	                var imageData = canvas.toDataURL("image/png");
	                var image = imageRoot.append("svg:image");
	                image.attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  "xlink:href": imageData,
	                  preserveAspectRatio: "none",
	                  x: 0,
	                  y: 0,
	                  width: canvas.style.width,
	                  height: canvas.style.height
	                });
	              }
	              canvases.each(canvasToImage);
	            };
	            exports2.updateFx = __webpack_require__2(4305).updateFx;
	          }
	        ),
	        /***/
	        13838: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var descriptionWithDates = __webpack_require__2(12663).descriptionWithDates;
	            var ONEDAY = __webpack_require__2(50606).ONEDAY;
	            var constants = __webpack_require__2(85555);
	            var HOUR = constants.HOUR_PATTERN;
	            var DAY_OF_WEEK = constants.WEEKDAY_PATTERN;
	            var minorTickmode = {
	              valType: "enumerated",
	              values: ["auto", "linear", "array"],
	              editType: "ticks",
	              impliedEdits: {
	                tick0: undefined,
	                dtick: undefined
	              }
	            };
	            var tickmode = extendFlat({}, minorTickmode, {
	              values: minorTickmode.values.slice().concat(["sync"])
	            });
	            function makeNticks(minor) {
	              return {
	                valType: "integer",
	                min: 0,
	                dflt: minor ? 5 : 0,
	                editType: "ticks"
	              };
	            }
	            var tick0 = {
	              valType: "any",
	              editType: "ticks",
	              impliedEdits: {
	                tickmode: "linear"
	              }
	            };
	            var dtick = {
	              valType: "any",
	              editType: "ticks",
	              impliedEdits: {
	                tickmode: "linear"
	              }
	            };
	            var tickvals = {
	              valType: "data_array",
	              editType: "ticks"
	            };
	            var ticks = {
	              valType: "enumerated",
	              values: ["outside", "inside", ""],
	              editType: "ticks"
	            };
	            function makeTicklen(minor) {
	              var obj = {
	                valType: "number",
	                min: 0,
	                editType: "ticks"
	              };
	              if (!minor) obj.dflt = 5;
	              return obj;
	            }
	            function makeTickwidth(minor) {
	              var obj = {
	                valType: "number",
	                min: 0,
	                editType: "ticks"
	              };
	              if (!minor) obj.dflt = 1;
	              return obj;
	            }
	            var tickcolor = {
	              valType: "color",
	              dflt: colorAttrs.defaultLine,
	              editType: "ticks"
	            };
	            var gridcolor = {
	              valType: "color",
	              dflt: colorAttrs.lightLine,
	              editType: "ticks"
	            };
	            function makeGridwidth(minor) {
	              var obj = {
	                valType: "number",
	                min: 0,
	                editType: "ticks"
	              };
	              if (!minor) obj.dflt = 1;
	              return obj;
	            }
	            var griddash = extendFlat({}, dash, {
	              editType: "ticks"
	            });
	            var showgrid = {
	              valType: "boolean",
	              editType: "ticks"
	            };
	            module2.exports = {
	              visible: {
	                valType: "boolean",
	                editType: "plot"
	              },
	              color: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "ticks"
	              },
	              title: {
	                text: {
	                  valType: "string",
	                  editType: "ticks"
	                },
	                font: fontAttrs({
	                  editType: "ticks"
	                }),
	                standoff: {
	                  valType: "number",
	                  min: 0,
	                  editType: "ticks"
	                },
	                editType: "ticks"
	              },
	              type: {
	                valType: "enumerated",
	                // '-' means we haven't yet run autotype or couldn't find any data
	                // it gets turned into linear in gd._fullLayout but not copied back
	                // to gd.data like the others are.
	                values: ["-", "linear", "log", "date", "category", "multicategory"],
	                dflt: "-",
	                editType: "calc",
	                // we forget when an axis has been autotyped, just writing the auto
	                // value back to the input - so it doesn't make sense to template this.
	                // Note: we do NOT prohibit this in `coerce`, so if someone enters a
	                // type in the template explicitly it will be honored as the default.
	                _noTemplating: true
	              },
	              autotypenumbers: {
	                valType: "enumerated",
	                values: ["convert types", "strict"],
	                dflt: "convert types",
	                editType: "calc"
	              },
	              autorange: {
	                valType: "enumerated",
	                values: [true, false, "reversed", "min reversed", "max reversed", "min", "max"],
	                dflt: true,
	                editType: "axrange",
	                impliedEdits: {
	                  "range[0]": undefined,
	                  "range[1]": undefined
	                }
	              },
	              autorangeoptions: {
	                minallowed: {
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "range[0]": undefined,
	                    "range[1]": undefined
	                  }
	                },
	                maxallowed: {
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "range[0]": undefined,
	                    "range[1]": undefined
	                  }
	                },
	                clipmin: {
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "range[0]": undefined,
	                    "range[1]": undefined
	                  }
	                },
	                clipmax: {
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "range[0]": undefined,
	                    "range[1]": undefined
	                  }
	                },
	                include: {
	                  valType: "any",
	                  arrayOk: true,
	                  editType: "plot",
	                  impliedEdits: {
	                    "range[0]": undefined,
	                    "range[1]": undefined
	                  }
	                },
	                editType: "plot"
	              },
	              rangemode: {
	                valType: "enumerated",
	                values: ["normal", "tozero", "nonnegative"],
	                dflt: "normal",
	                editType: "plot"
	              },
	              range: {
	                valType: "info_array",
	                items: [{
	                  valType: "any",
	                  editType: "axrange",
	                  impliedEdits: {
	                    "^autorange": false
	                  },
	                  anim: true
	                }, {
	                  valType: "any",
	                  editType: "axrange",
	                  impliedEdits: {
	                    "^autorange": false
	                  },
	                  anim: true
	                }],
	                editType: "axrange",
	                impliedEdits: {
	                  autorange: false
	                },
	                anim: true
	              },
	              minallowed: {
	                valType: "any",
	                editType: "plot",
	                impliedEdits: {
	                  "^autorange": false
	                }
	              },
	              maxallowed: {
	                valType: "any",
	                editType: "plot",
	                impliedEdits: {
	                  "^autorange": false
	                }
	              },
	              fixedrange: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              insiderange: {
	                valType: "info_array",
	                items: [{
	                  valType: "any",
	                  editType: "plot"
	                }, {
	                  valType: "any",
	                  editType: "plot"
	                }],
	                editType: "plot"
	              },
	              // scaleanchor: not used directly, just put here for reference
	              // values are any opposite-letter axis id, or `false`.
	              scaleanchor: {
	                valType: "enumerated",
	                values: [constants.idRegex.x.toString(), constants.idRegex.y.toString(), false],
	                editType: "plot"
	              },
	              scaleratio: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "plot"
	              },
	              constrain: {
	                valType: "enumerated",
	                values: ["range", "domain"],
	                editType: "plot"
	              },
	              // constraintoward: not used directly, just put here for reference
	              constraintoward: {
	                valType: "enumerated",
	                values: ["left", "center", "right", "top", "middle", "bottom"],
	                editType: "plot"
	              },
	              matches: {
	                valType: "enumerated",
	                values: [constants.idRegex.x.toString(), constants.idRegex.y.toString()],
	                editType: "calc"
	              },
	              rangebreaks: templatedArray("rangebreak", {
	                enabled: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "calc"
	                },
	                bounds: {
	                  valType: "info_array",
	                  items: [{
	                    valType: "any",
	                    editType: "calc"
	                  }, {
	                    valType: "any",
	                    editType: "calc"
	                  }],
	                  editType: "calc"
	                },
	                pattern: {
	                  valType: "enumerated",
	                  values: [DAY_OF_WEEK, HOUR, ""],
	                  editType: "calc"
	                },
	                values: {
	                  valType: "info_array",
	                  freeLength: true,
	                  editType: "calc",
	                  items: {
	                    valType: "any",
	                    editType: "calc"
	                  }
	                },
	                dvalue: {
	                  // TODO could become 'any' to add support for 'months', 'years'
	                  valType: "number",
	                  editType: "calc",
	                  min: 0,
	                  dflt: ONEDAY
	                },
	                /*
	                gap: {
	                    valType: 'number',
	                    min: 0,
	                    dflt: 0, // for *date* axes, maybe something else for *linear*
	                    editType: 'calc',
	                },
	                gapmode: {
	                    valType: 'enumerated',
	                    values: ['pixels', 'fraction'],
	                    dflt: 'pixels',
	                    editType: 'calc',
	                },
	                */
	                // To complete https://github.com/plotly/plotly.js/issues/4210
	                // we additionally need `gap` and make this work on *linear*, and
	                // possibly all other cartesian axis types. We possibly would also need
	                // some style attributes controlling the zig-zag on the corresponding
	                // axis.
	                editType: "calc"
	              }),
	              // ticks
	              tickmode,
	              nticks: makeNticks(),
	              tick0,
	              dtick,
	              ticklabelstep: {
	                valType: "integer",
	                min: 1,
	                dflt: 1,
	                editType: "ticks"
	              },
	              tickvals,
	              ticktext: {
	                valType: "data_array",
	                editType: "ticks"
	              },
	              ticks,
	              tickson: {
	                valType: "enumerated",
	                values: ["labels", "boundaries"],
	                dflt: "labels",
	                editType: "ticks"
	              },
	              ticklabelmode: {
	                valType: "enumerated",
	                values: ["instant", "period"],
	                dflt: "instant",
	                editType: "ticks"
	              },
	              // ticklabelposition: not used directly, as values depend on direction (similar to side)
	              // left/right options are for x axes, and top/bottom options are for y axes
	              ticklabelposition: {
	                valType: "enumerated",
	                values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"],
	                dflt: "outside",
	                editType: "calc"
	              },
	              ticklabeloverflow: {
	                valType: "enumerated",
	                values: ["allow", "hide past div", "hide past domain"],
	                editType: "calc"
	              },
	              mirror: {
	                valType: "enumerated",
	                values: [true, "ticks", false, "all", "allticks"],
	                dflt: false,
	                editType: "ticks+layoutstyle"
	              },
	              ticklen: makeTicklen(),
	              tickwidth: makeTickwidth(),
	              tickcolor,
	              showticklabels: {
	                valType: "boolean",
	                dflt: true,
	                editType: "ticks"
	              },
	              labelalias: {
	                valType: "any",
	                dflt: false,
	                editType: "ticks"
	              },
	              automargin: {
	                valType: "flaglist",
	                flags: ["height", "width", "left", "right", "top", "bottom"],
	                extras: [true, false],
	                dflt: false,
	                editType: "ticks"
	              },
	              showspikes: {
	                valType: "boolean",
	                dflt: false,
	                editType: "modebar"
	              },
	              spikecolor: {
	                valType: "color",
	                dflt: null,
	                editType: "none"
	              },
	              spikethickness: {
	                valType: "number",
	                dflt: 3,
	                editType: "none"
	              },
	              spikedash: extendFlat({}, dash, {
	                dflt: "dash",
	                editType: "none"
	              }),
	              spikemode: {
	                valType: "flaglist",
	                flags: ["toaxis", "across", "marker"],
	                dflt: "toaxis",
	                editType: "none"
	              },
	              spikesnap: {
	                valType: "enumerated",
	                values: ["data", "cursor", "hovered data"],
	                dflt: "hovered data",
	                editType: "none"
	              },
	              tickfont: fontAttrs({
	                editType: "ticks"
	              }),
	              tickangle: {
	                valType: "angle",
	                dflt: "auto",
	                editType: "ticks"
	              },
	              tickprefix: {
	                valType: "string",
	                dflt: "",
	                editType: "ticks"
	              },
	              showtickprefix: {
	                valType: "enumerated",
	                values: ["all", "first", "last", "none"],
	                dflt: "all",
	                editType: "ticks"
	              },
	              ticksuffix: {
	                valType: "string",
	                dflt: "",
	                editType: "ticks"
	              },
	              showticksuffix: {
	                valType: "enumerated",
	                values: ["all", "first", "last", "none"],
	                dflt: "all",
	                editType: "ticks"
	              },
	              showexponent: {
	                valType: "enumerated",
	                values: ["all", "first", "last", "none"],
	                dflt: "all",
	                editType: "ticks"
	              },
	              exponentformat: {
	                valType: "enumerated",
	                values: ["none", "e", "E", "power", "SI", "B"],
	                dflt: "B",
	                editType: "ticks"
	              },
	              minexponent: {
	                valType: "number",
	                dflt: 3,
	                min: 0,
	                editType: "ticks"
	              },
	              separatethousands: {
	                valType: "boolean",
	                dflt: false,
	                editType: "ticks"
	              },
	              tickformat: {
	                valType: "string",
	                dflt: "",
	                editType: "ticks",
	                description: descriptionWithDates("tick label")
	              },
	              tickformatstops: templatedArray("tickformatstop", {
	                enabled: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "ticks"
	                },
	                dtickrange: {
	                  valType: "info_array",
	                  items: [{
	                    valType: "any",
	                    editType: "ticks"
	                  }, {
	                    valType: "any",
	                    editType: "ticks"
	                  }],
	                  editType: "ticks"
	                },
	                value: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "ticks"
	                },
	                editType: "ticks"
	              }),
	              hoverformat: {
	                valType: "string",
	                dflt: "",
	                editType: "none",
	                description: descriptionWithDates("hover text")
	              },
	              // lines and grids
	              showline: {
	                valType: "boolean",
	                dflt: false,
	                editType: "ticks+layoutstyle"
	              },
	              linecolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "layoutstyle"
	              },
	              linewidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "ticks+layoutstyle"
	              },
	              showgrid,
	              gridcolor,
	              gridwidth: makeGridwidth(),
	              griddash,
	              zeroline: {
	                valType: "boolean",
	                editType: "ticks"
	              },
	              zerolinecolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "ticks"
	              },
	              zerolinewidth: {
	                valType: "number",
	                dflt: 1,
	                editType: "ticks"
	              },
	              showdividers: {
	                valType: "boolean",
	                dflt: true,
	                editType: "ticks"
	              },
	              dividercolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "ticks"
	              },
	              dividerwidth: {
	                valType: "number",
	                dflt: 1,
	                editType: "ticks"
	              },
	              // TODO dividerlen: that would override "to label base" length?
	              // positioning attributes
	              // anchor: not used directly, just put here for reference
	              // values are any opposite-letter axis id
	              anchor: {
	                valType: "enumerated",
	                values: ["free", constants.idRegex.x.toString(), constants.idRegex.y.toString()],
	                editType: "plot"
	              },
	              // side: not used directly, as values depend on direction
	              // values are top, bottom for x axes, and left, right for y
	              side: {
	                valType: "enumerated",
	                values: ["top", "bottom", "left", "right"],
	                editType: "plot"
	              },
	              // overlaying: not used directly, just put here for reference
	              // values are false and any other same-letter axis id that's not
	              // itself overlaying anything
	              overlaying: {
	                valType: "enumerated",
	                values: ["free", constants.idRegex.x.toString(), constants.idRegex.y.toString()],
	                editType: "plot"
	              },
	              minor: {
	                tickmode: minorTickmode,
	                nticks: makeNticks("minor"),
	                tick0,
	                dtick,
	                tickvals,
	                ticks,
	                ticklen: makeTicklen("minor"),
	                tickwidth: makeTickwidth("minor"),
	                tickcolor,
	                gridcolor,
	                gridwidth: makeGridwidth("minor"),
	                griddash,
	                showgrid,
	                editType: "ticks"
	              },
	              layer: {
	                valType: "enumerated",
	                values: ["above traces", "below traces"],
	                dflt: "above traces",
	                editType: "plot"
	              },
	              domain: {
	                valType: "info_array",
	                items: [{
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  editType: "plot"
	                }, {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  editType: "plot"
	                }],
	                dflt: [0, 1],
	                editType: "plot"
	              },
	              position: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                editType: "plot"
	              },
	              autoshift: {
	                valType: "boolean",
	                dflt: false,
	                editType: "plot"
	              },
	              shift: {
	                valType: "number",
	                editType: "plot"
	              },
	              categoryorder: {
	                valType: "enumerated",
	                values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "median ascending", "median descending"],
	                dflt: "trace",
	                editType: "calc"
	              },
	              categoryarray: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              editType: "calc",
	              _deprecated: {
	                autotick: {
	                  valType: "boolean",
	                  editType: "ticks"
	                },
	                title: {
	                  valType: "string",
	                  editType: "ticks"
	                },
	                titlefont: fontAttrs({
	                  editType: "ticks"
	                })
	              }
	            };
	          }
	        ),
	        /***/
	        86763: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var isUnifiedHover = __webpack_require__2(23469).isUnifiedHover;
	            var handleHoverModeDefaults = __webpack_require__2(98212);
	            var Template = __webpack_require__2(44467);
	            var basePlotLayoutAttributes = __webpack_require__2(10820);
	            var layoutAttributes = __webpack_require__2(13838);
	            var handleTypeDefaults = __webpack_require__2(951);
	            var handleAxisDefaults = __webpack_require__2(71453);
	            var constraints = __webpack_require__2(99082);
	            var handlePositionDefaults = __webpack_require__2(52830);
	            var axisIds = __webpack_require__2(41675);
	            var id2name = axisIds.id2name;
	            var name2id = axisIds.name2id;
	            var AX_ID_PATTERN = __webpack_require__2(85555).AX_ID_PATTERN;
	            var Registry = __webpack_require__2(73972);
	            var traceIs = Registry.traceIs;
	            var getComponentMethod = Registry.getComponentMethod;
	            function appendList(cont, k, item) {
	              if (Array.isArray(cont[k])) cont[k].push(item);
	              else cont[k] = [item];
	            }
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              var autotypenumbersDflt = layoutOut.autotypenumbers;
	              var ax2traces = {};
	              var xaMayHide = {};
	              var yaMayHide = {};
	              var xaMustDisplay = {};
	              var yaMustDisplay = {};
	              var yaMustNotReverse = {};
	              var yaMayReverse = {};
	              var axHasImage = {};
	              var outerTicks = {};
	              var noGrids = {};
	              var i, j;
	              for (i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (!traceIs(trace, "cartesian") && !traceIs(trace, "gl2d")) continue;
	                var xaName;
	                if (trace.xaxis) {
	                  xaName = id2name(trace.xaxis);
	                  appendList(ax2traces, xaName, trace);
	                } else if (trace.xaxes) {
	                  for (j = 0; j < trace.xaxes.length; j++) {
	                    appendList(ax2traces, id2name(trace.xaxes[j]), trace);
	                  }
	                }
	                var yaName;
	                if (trace.yaxis) {
	                  yaName = id2name(trace.yaxis);
	                  appendList(ax2traces, yaName, trace);
	                } else if (trace.yaxes) {
	                  for (j = 0; j < trace.yaxes.length; j++) {
	                    appendList(ax2traces, id2name(trace.yaxes[j]), trace);
	                  }
	                }
	                if (trace.type === "funnel") {
	                  if (trace.orientation === "h") {
	                    if (xaName) xaMayHide[xaName] = true;
	                    if (yaName) yaMayReverse[yaName] = true;
	                  } else {
	                    if (yaName) yaMayHide[yaName] = true;
	                  }
	                } else if (trace.type === "image") {
	                  if (yaName) axHasImage[yaName] = true;
	                  if (xaName) axHasImage[xaName] = true;
	                } else {
	                  if (yaName) {
	                    yaMustDisplay[yaName] = true;
	                    yaMustNotReverse[yaName] = true;
	                  }
	                  if (!traceIs(trace, "carpet") || trace.type === "carpet" && !trace._cheater) {
	                    if (xaName) xaMustDisplay[xaName] = true;
	                  }
	                }
	                if (trace.type === "carpet" && trace._cheater) {
	                  if (xaName) xaMayHide[xaName] = true;
	                }
	                if (traceIs(trace, "2dMap")) {
	                  outerTicks[xaName] = true;
	                  outerTicks[yaName] = true;
	                }
	                if (traceIs(trace, "oriented")) {
	                  var positionAxis = trace.orientation === "h" ? yaName : xaName;
	                  noGrids[positionAxis] = true;
	                }
	              }
	              var subplots = layoutOut._subplots;
	              var xIds = subplots.xaxis;
	              var yIds = subplots.yaxis;
	              var xNames = Lib.simpleMap(xIds, id2name);
	              var yNames = Lib.simpleMap(yIds, id2name);
	              var axNames = xNames.concat(yNames);
	              var plotBgColor = Color.background;
	              if (xIds.length && yIds.length) {
	                plotBgColor = Lib.coerce(layoutIn, layoutOut, basePlotLayoutAttributes, "plot_bgcolor");
	              }
	              var bgColor = Color.combine(plotBgColor, layoutOut.paper_bgcolor);
	              var axName;
	              var axId;
	              var axLetter;
	              var axLayoutIn;
	              var axLayoutOut;
	              function newAxLayoutOut() {
	                var traces = ax2traces[axName] || [];
	                axLayoutOut._traceIndices = traces.map(function(t) {
	                  return t._expandedIndex;
	                });
	                axLayoutOut._annIndices = [];
	                axLayoutOut._shapeIndices = [];
	                axLayoutOut._selectionIndices = [];
	                axLayoutOut._imgIndices = [];
	                axLayoutOut._subplotsWith = [];
	                axLayoutOut._counterAxes = [];
	                axLayoutOut._name = axLayoutOut._attr = axName;
	                axLayoutOut._id = axId;
	              }
	              function coerce(attr, dflt) {
	                return Lib.coerce(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
	              }
	              function coerce2(attr, dflt) {
	                return Lib.coerce2(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
	              }
	              function getCounterAxes(axLetter2) {
	                return axLetter2 === "x" ? yIds : xIds;
	              }
	              function getOverlayableAxes(axLetter2, axName2) {
	                var list = axLetter2 === "x" ? xNames : yNames;
	                var out = [];
	                for (var j2 = 0; j2 < list.length; j2++) {
	                  var axName22 = list[j2];
	                  if (axName22 !== axName2 && !(layoutIn[axName22] || {}).overlaying) {
	                    out.push(name2id(axName22));
	                  }
	                }
	                return out;
	              }
	              var counterAxes = {
	                x: getCounterAxes("x"),
	                y: getCounterAxes("y")
	              };
	              var allAxisIds = counterAxes.x.concat(counterAxes.y);
	              var missingMatchedAxisIdsLookup = {};
	              var missingMatchedAxisIds = [];
	              function addMissingMatchedAxis() {
	                var matchesIn = axLayoutIn.matches;
	                if (AX_ID_PATTERN.test(matchesIn) && allAxisIds.indexOf(matchesIn) === -1) {
	                  missingMatchedAxisIdsLookup[matchesIn] = axLayoutIn.type;
	                  missingMatchedAxisIds = Object.keys(missingMatchedAxisIdsLookup);
	                }
	              }
	              var hovermode = handleHoverModeDefaults(layoutIn, layoutOut);
	              var unifiedHover = isUnifiedHover(hovermode);
	              for (i = 0; i < axNames.length; i++) {
	                axName = axNames[i];
	                axId = name2id(axName);
	                axLetter = axName.charAt(0);
	                if (!Lib.isPlainObject(layoutIn[axName])) {
	                  layoutIn[axName] = {};
	                }
	                axLayoutIn = layoutIn[axName];
	                axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + "axis");
	                newAxLayoutOut();
	                var visibleDflt = axLetter === "x" && !xaMustDisplay[axName] && xaMayHide[axName] || axLetter === "y" && !yaMustDisplay[axName] && yaMayHide[axName];
	                var reverseDflt = axLetter === "y" && (!yaMustNotReverse[axName] && yaMayReverse[axName] || axHasImage[axName]);
	                var defaultOptions = {
	                  hasMinor: true,
	                  letter: axLetter,
	                  font: layoutOut.font,
	                  outerTicks: outerTicks[axName],
	                  showGrid: !noGrids[axName],
	                  data: ax2traces[axName] || [],
	                  bgColor,
	                  calendar: layoutOut.calendar,
	                  automargin: true,
	                  visibleDflt,
	                  reverseDflt,
	                  autotypenumbersDflt,
	                  splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[axId]
	                };
	                coerce("uirevision", layoutOut.uirevision);
	                handleTypeDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions);
	                handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions, layoutOut);
	                var unifiedSpike = unifiedHover && axLetter === hovermode.charAt(0);
	                var spikecolor = coerce2("spikecolor", unifiedHover ? axLayoutOut.color : undefined);
	                var spikethickness = coerce2("spikethickness", unifiedHover ? 1.5 : undefined);
	                var spikedash = coerce2("spikedash", unifiedHover ? "dot" : undefined);
	                var spikemode = coerce2("spikemode", unifiedHover ? "across" : undefined);
	                var spikesnap = coerce2("spikesnap");
	                var showSpikes = coerce("showspikes", !!unifiedSpike || !!spikecolor || !!spikethickness || !!spikedash || !!spikemode || !!spikesnap);
	                if (!showSpikes) {
	                  delete axLayoutOut.spikecolor;
	                  delete axLayoutOut.spikethickness;
	                  delete axLayoutOut.spikedash;
	                  delete axLayoutOut.spikemode;
	                  delete axLayoutOut.spikesnap;
	                }
	                var overlayingAxis = id2name(axLayoutIn.overlaying);
	                var overlayingAnchorDomain = [0, 1];
	                if (layoutOut[overlayingAxis] !== undefined) {
	                  var overlayingAnchor = id2name(layoutOut[overlayingAxis].anchor);
	                  if (layoutOut[overlayingAnchor] !== undefined) {
	                    overlayingAnchorDomain = layoutOut[overlayingAnchor].domain;
	                  }
	                }
	                handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
	                  letter: axLetter,
	                  counterAxes: counterAxes[axLetter],
	                  overlayableAxes: getOverlayableAxes(axLetter, axName),
	                  grid: layoutOut.grid,
	                  overlayingDomain: overlayingAnchorDomain
	                });
	                coerce("title.standoff");
	                addMissingMatchedAxis();
	                axLayoutOut._input = axLayoutIn;
	              }
	              i = 0;
	              while (i < missingMatchedAxisIds.length) {
	                axId = missingMatchedAxisIds[i++];
	                axName = id2name(axId);
	                axLetter = axName.charAt(0);
	                if (!Lib.isPlainObject(layoutIn[axName])) {
	                  layoutIn[axName] = {};
	                }
	                axLayoutIn = layoutIn[axName];
	                axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + "axis");
	                newAxLayoutOut();
	                var defaultOptions2 = {
	                  letter: axLetter,
	                  font: layoutOut.font,
	                  outerTicks: outerTicks[axName],
	                  showGrid: !noGrids[axName],
	                  data: [],
	                  bgColor,
	                  calendar: layoutOut.calendar,
	                  automargin: true,
	                  visibleDflt: false,
	                  reverseDflt: false,
	                  autotypenumbersDflt,
	                  splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[axId]
	                };
	                coerce("uirevision", layoutOut.uirevision);
	                axLayoutOut.type = missingMatchedAxisIdsLookup[axId] || "linear";
	                handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions2, layoutOut);
	                handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
	                  letter: axLetter,
	                  counterAxes: counterAxes[axLetter],
	                  overlayableAxes: getOverlayableAxes(axLetter, axName),
	                  grid: layoutOut.grid
	                });
	                coerce("fixedrange");
	                addMissingMatchedAxis();
	                axLayoutOut._input = axLayoutIn;
	              }
	              var rangeSliderDefaults = getComponentMethod("rangeslider", "handleDefaults");
	              var rangeSelectorDefaults = getComponentMethod("rangeselector", "handleDefaults");
	              for (i = 0; i < xNames.length; i++) {
	                axName = xNames[i];
	                axLayoutIn = layoutIn[axName];
	                axLayoutOut = layoutOut[axName];
	                rangeSliderDefaults(layoutIn, layoutOut, axName);
	                if (axLayoutOut.type === "date") {
	                  rangeSelectorDefaults(axLayoutIn, axLayoutOut, layoutOut, yNames, axLayoutOut.calendar);
	                }
	                coerce("fixedrange");
	              }
	              for (i = 0; i < yNames.length; i++) {
	                axName = yNames[i];
	                axLayoutIn = layoutIn[axName];
	                axLayoutOut = layoutOut[axName];
	                var anchoredAxis = layoutOut[id2name(axLayoutOut.anchor)];
	                var fixedRangeDflt = getComponentMethod("rangeslider", "isVisible")(anchoredAxis);
	                coerce("fixedrange", fixedRangeDflt);
	              }
	              constraints.handleDefaults(layoutIn, layoutOut, {
	                axIds: allAxisIds.concat(missingMatchedAxisIds).sort(axisIds.idSort),
	                axHasImage
	              });
	            };
	          }
	        ),
	        /***/
	        92128: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorMix = __webpack_require__2(84267).mix;
	            var colorAttrs = __webpack_require__2(22399);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function handleLineGridDefaults(containerIn, containerOut, coerce, opts) {
	              opts = opts || {};
	              var dfltColor = opts.dfltColor;
	              function coerce2(attr, dflt) {
	                return Lib.coerce2(containerIn, containerOut, opts.attributes, attr, dflt);
	              }
	              var lineColor = coerce2("linecolor", dfltColor);
	              var lineWidth = coerce2("linewidth");
	              var showLine = coerce("showline", opts.showLine || !!lineColor || !!lineWidth);
	              if (!showLine) {
	                delete containerOut.linecolor;
	                delete containerOut.linewidth;
	              }
	              var gridColorDflt = colorMix(dfltColor, opts.bgColor, opts.blend || colorAttrs.lightFraction).toRgbString();
	              var gridColor = coerce2("gridcolor", gridColorDflt);
	              var gridWidth = coerce2("gridwidth");
	              var gridDash = coerce2("griddash");
	              var showGridLines = coerce("showgrid", opts.showGrid || !!gridColor || !!gridWidth || !!gridDash);
	              if (!showGridLines) {
	                delete containerOut.gridcolor;
	                delete containerOut.gridwidth;
	                delete containerOut.griddash;
	              }
	              if (opts.hasMinor) {
	                var minorGridColorDflt = colorMix(containerOut.gridcolor, opts.bgColor, 67).toRgbString();
	                var minorGridColor = coerce2("minor.gridcolor", minorGridColorDflt);
	                var minorGridWidth = coerce2("minor.gridwidth", containerOut.gridwidth || 1);
	                var minorGridDash = coerce2("minor.griddash", containerOut.griddash || "solid");
	                var minorShowGridLines = coerce("minor.showgrid", !!minorGridColor || !!minorGridWidth || !!minorGridDash);
	                if (!minorShowGridLines) {
	                  delete containerOut.minor.gridcolor;
	                  delete containerOut.minor.gridwidth;
	                  delete containerOut.minor.griddash;
	                }
	              }
	              if (!opts.noZeroLine) {
	                var zeroLineColor = coerce2("zerolinecolor", dfltColor);
	                var zeroLineWidth = coerce2("zerolinewidth");
	                var showZeroLine = coerce("zeroline", opts.showGrid || !!zeroLineColor || !!zeroLineWidth);
	                if (!showZeroLine) {
	                  delete containerOut.zerolinecolor;
	                  delete containerOut.zerolinewidth;
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        52830: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function handlePositionDefaults(containerIn, containerOut, coerce, options) {
	              var counterAxes = options.counterAxes || [];
	              var overlayableAxes = options.overlayableAxes || [];
	              var letter = options.letter;
	              var grid = options.grid;
	              var overlayingDomain = options.overlayingDomain;
	              var dfltAnchor, dfltDomain, dfltSide, dfltPosition, dfltShift, dfltAutomargin;
	              if (grid) {
	                dfltDomain = grid._domains[letter][grid._axisMap[containerOut._id]];
	                dfltAnchor = grid._anchors[containerOut._id];
	                if (dfltDomain) {
	                  dfltSide = grid[letter + "side"].split(" ")[0];
	                  dfltPosition = grid.domain[letter][dfltSide === "right" || dfltSide === "top" ? 1 : 0];
	                }
	              }
	              dfltDomain = dfltDomain || [0, 1];
	              dfltAnchor = dfltAnchor || (isNumeric(containerIn.position) ? "free" : counterAxes[0] || "free");
	              dfltSide = dfltSide || (letter === "x" ? "bottom" : "left");
	              dfltPosition = dfltPosition || 0;
	              dfltShift = 0;
	              dfltAutomargin = false;
	              var anchor = Lib.coerce(containerIn, containerOut, {
	                anchor: {
	                  valType: "enumerated",
	                  values: ["free"].concat(counterAxes),
	                  dflt: dfltAnchor
	                }
	              }, "anchor");
	              var side = Lib.coerce(containerIn, containerOut, {
	                side: {
	                  valType: "enumerated",
	                  values: letter === "x" ? ["bottom", "top"] : ["left", "right"],
	                  dflt: dfltSide
	                }
	              }, "side");
	              if (anchor === "free") {
	                if (letter === "y") {
	                  var autoshift = coerce("autoshift");
	                  if (autoshift) {
	                    dfltPosition = side === "left" ? overlayingDomain[0] : overlayingDomain[1];
	                    dfltAutomargin = containerOut.automargin ? containerOut.automargin : true;
	                    dfltShift = side === "left" ? -3 : 3;
	                  }
	                  coerce("shift", dfltShift);
	                }
	                coerce("position", dfltPosition);
	              }
	              coerce("automargin", dfltAutomargin);
	              var overlaying = false;
	              if (overlayableAxes.length) {
	                overlaying = Lib.coerce(containerIn, containerOut, {
	                  overlaying: {
	                    valType: "enumerated",
	                    values: [false].concat(overlayableAxes),
	                    dflt: false
	                  }
	                }, "overlaying");
	              }
	              if (!overlaying) {
	                var domain = coerce("domain", dfltDomain);
	                if (domain[0] > domain[1] - 1 / 4096) containerOut.domain = dfltDomain;
	                Lib.noneOrAll(containerIn.domain, containerOut.domain, dfltDomain);
	                if (containerOut.tickmode === "sync") {
	                  containerOut.tickmode = "auto";
	                }
	              }
	              coerce("layer");
	              return containerOut;
	            };
	          }
	        ),
	        /***/
	        89426: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getShowAttrDflt = __webpack_require__2(59652);
	            module2.exports = function handlePrefixSuffixDefaults(containerIn, containerOut, coerce, axType, options) {
	              if (!options) options = {};
	              var tickSuffixDflt = options.tickSuffixDflt;
	              var showAttrDflt = getShowAttrDflt(containerIn);
	              var tickPrefix = coerce("tickprefix");
	              if (tickPrefix) coerce("showtickprefix", showAttrDflt);
	              var tickSuffix = coerce("ticksuffix", tickSuffixDflt);
	              if (tickSuffix) coerce("showticksuffix", showAttrDflt);
	            };
	          }
	        ),
	        /***/
	        23608: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var handleAutorangeOptionsDefaults = __webpack_require__2(23074);
	            module2.exports = function handleRangeDefaults(containerIn, containerOut, coerce, options) {
	              var axTemplate = containerOut._template || {};
	              var axType = containerOut.type || axTemplate.type || "-";
	              coerce("minallowed");
	              coerce("maxallowed");
	              var range2 = coerce("range");
	              if (!range2) {
	                var insiderange;
	                if (!options.noInsiderange && axType !== "log") {
	                  insiderange = coerce("insiderange");
	                  if (insiderange && (insiderange[0] === null || insiderange[1] === null)) {
	                    containerOut.insiderange = false;
	                    insiderange = undefined;
	                  }
	                  if (insiderange) range2 = coerce("range", insiderange);
	                }
	              }
	              var autorangeDflt = containerOut.getAutorangeDflt(range2, options);
	              var autorange = coerce("autorange", autorangeDflt);
	              var shouldAutorange;
	              if (range2 && (range2[0] === null && range2[1] === null || (range2[0] === null || range2[1] === null) && (autorange === "reversed" || autorange === true) || range2[0] !== null && (autorange === "min" || autorange === "max reversed") || range2[1] !== null && (autorange === "max" || autorange === "min reversed"))) {
	                range2 = undefined;
	                delete containerOut.range;
	                containerOut.autorange = true;
	                shouldAutorange = true;
	              }
	              if (!shouldAutorange) {
	                autorangeDflt = containerOut.getAutorangeDflt(range2, options);
	                autorange = coerce("autorange", autorangeDflt);
	              }
	              if (autorange) {
	                handleAutorangeOptionsDefaults(coerce, autorange, range2);
	                if (axType === "linear" || axType === "-") coerce("rangemode");
	              }
	              containerOut.cleanRange();
	            };
	          }
	        ),
	        /***/
	        42449: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var FROM_BL = __webpack_require__2(18783).FROM_BL;
	            module2.exports = function scaleZoom(ax, factor, centerFraction) {
	              if (centerFraction === undefined) {
	                centerFraction = FROM_BL[ax.constraintoward || "center"];
	              }
	              var rangeLinear = [ax.r2l(ax.range[0]), ax.r2l(ax.range[1])];
	              var center = rangeLinear[0] + (rangeLinear[1] - rangeLinear[0]) * centerFraction;
	              ax.range = ax._input.range = [ax.l2r(center + (rangeLinear[0] - center) * factor), ax.l2r(center + (rangeLinear[1] - center) * factor)];
	              ax.setScale();
	            };
	          }
	        ),
	        /***/
	        21994: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var utcFormat = __webpack_require__2(84096).g0;
	            var Lib = __webpack_require__2(71828);
	            var numberFormat = Lib.numberFormat;
	            var isNumeric = __webpack_require__2(92770);
	            var cleanNumber = Lib.cleanNumber;
	            var ms2DateTime = Lib.ms2DateTime;
	            var dateTime2ms = Lib.dateTime2ms;
	            var ensureNumber = Lib.ensureNumber;
	            var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	            var numConstants = __webpack_require__2(50606);
	            var FP_SAFE = numConstants.FP_SAFE;
	            var BADNUM = numConstants.BADNUM;
	            var LOG_CLIP = numConstants.LOG_CLIP;
	            var ONEWEEK = numConstants.ONEWEEK;
	            var ONEDAY = numConstants.ONEDAY;
	            var ONEHOUR = numConstants.ONEHOUR;
	            var ONEMIN = numConstants.ONEMIN;
	            var ONESEC = numConstants.ONESEC;
	            var axisIds = __webpack_require__2(41675);
	            var constants = __webpack_require__2(85555);
	            var HOUR_PATTERN = constants.HOUR_PATTERN;
	            var WEEKDAY_PATTERN = constants.WEEKDAY_PATTERN;
	            function fromLog(v) {
	              return Math.pow(10, v);
	            }
	            function isValidCategory(v) {
	              return v !== null && v !== undefined;
	            }
	            module2.exports = function setConvert(ax, fullLayout) {
	              fullLayout = fullLayout || {};
	              var axId = ax._id || "x";
	              var axLetter = axId.charAt(0);
	              function toLog(v, clip) {
	                if (v > 0) return Math.log(v) / Math.LN10;
	                else if (v <= 0 && clip && ax.range && ax.range.length === 2) {
	                  var r0 = ax.range[0];
	                  var r1 = ax.range[1];
	                  return 0.5 * (r0 + r1 - 2 * LOG_CLIP * Math.abs(r0 - r1));
	                } else return BADNUM;
	              }
	              function dt2ms(v, _, calendar, opts) {
	                if ((opts || {}).msUTC && isNumeric(v)) {
	                  return +v;
	                }
	                var ms = dateTime2ms(v, calendar || ax.calendar);
	                if (ms === BADNUM) {
	                  if (isNumeric(v)) {
	                    v = +v;
	                    var msecTenths = Math.floor(Lib.mod(v + 0.05, 1) * 10);
	                    var msRounded = Math.round(v - msecTenths / 10);
	                    ms = dateTime2ms(new Date(msRounded)) + msecTenths / 10;
	                  } else return BADNUM;
	                }
	                return ms;
	              }
	              function ms2dt(v, r, calendar) {
	                return ms2DateTime(v, r, calendar || ax.calendar);
	              }
	              function getCategoryName(v) {
	                return ax._categories[Math.round(v)];
	              }
	              function setCategoryIndex(v) {
	                if (isValidCategory(v)) {
	                  if (ax._categoriesMap === undefined) {
	                    ax._categoriesMap = {};
	                  }
	                  if (ax._categoriesMap[v] !== undefined) {
	                    return ax._categoriesMap[v];
	                  } else {
	                    ax._categories.push(typeof v === "number" ? String(v) : v);
	                    var curLength = ax._categories.length - 1;
	                    ax._categoriesMap[v] = curLength;
	                    return curLength;
	                  }
	                }
	                return BADNUM;
	              }
	              function setMultiCategoryIndex(arrayIn, len) {
	                var arrayOut = new Array(len);
	                for (var i = 0; i < len; i++) {
	                  var v0 = (arrayIn[0] || [])[i];
	                  var v1 = (arrayIn[1] || [])[i];
	                  arrayOut[i] = getCategoryIndex([v0, v1]);
	                }
	                return arrayOut;
	              }
	              function getCategoryIndex(v) {
	                if (ax._categoriesMap) {
	                  return ax._categoriesMap[v];
	                }
	              }
	              function getCategoryPosition(v) {
	                var index = getCategoryIndex(v);
	                if (index !== undefined) return index;
	                if (isNumeric(v)) return +v;
	              }
	              function getRangePosition(v) {
	                return isNumeric(v) ? +v : getCategoryIndex(v);
	              }
	              function _l2p(v, m, b) {
	                return d3.round(b + m * v, 2);
	              }
	              function _p2l(px, m, b) {
	                return (px - b) / m;
	              }
	              var l2p = function l2p2(v) {
	                if (!isNumeric(v)) return BADNUM;
	                return _l2p(v, ax._m, ax._b);
	              };
	              var p2l = function(px) {
	                return _p2l(px, ax._m, ax._b);
	              };
	              if (ax.rangebreaks) {
	                var isY = axLetter === "y";
	                l2p = function(v) {
	                  if (!isNumeric(v)) return BADNUM;
	                  var len = ax._rangebreaks.length;
	                  if (!len) return _l2p(v, ax._m, ax._b);
	                  var flip = isY;
	                  if (ax.range[0] > ax.range[1]) flip = !flip;
	                  var signAx = flip ? -1 : 1;
	                  var pos = signAx * v;
	                  var q = 0;
	                  for (var i = 0; i < len; i++) {
	                    var min = signAx * ax._rangebreaks[i].min;
	                    var max = signAx * ax._rangebreaks[i].max;
	                    if (pos < min) break;
	                    if (pos > max) q = i + 1;
	                    else {
	                      q = pos < (min + max) / 2 ? i : i + 1;
	                      break;
	                    }
	                  }
	                  var b2 = ax._B[q] || 0;
	                  if (!isFinite(b2)) return 0;
	                  return _l2p(v, ax._m2, b2);
	                };
	                p2l = function(px) {
	                  var len = ax._rangebreaks.length;
	                  if (!len) return _p2l(px, ax._m, ax._b);
	                  var q = 0;
	                  for (var i = 0; i < len; i++) {
	                    if (px < ax._rangebreaks[i].pmin) break;
	                    if (px > ax._rangebreaks[i].pmax) q = i + 1;
	                  }
	                  return _p2l(px, ax._m2, ax._B[q]);
	                };
	              }
	              ax.c2l = ax.type === "log" ? toLog : ensureNumber;
	              ax.l2c = ax.type === "log" ? fromLog : ensureNumber;
	              ax.l2p = l2p;
	              ax.p2l = p2l;
	              ax.c2p = ax.type === "log" ? function(v, clip) {
	                return l2p(toLog(v, clip));
	              } : l2p;
	              ax.p2c = ax.type === "log" ? function(px) {
	                return fromLog(p2l(px));
	              } : p2l;
	              if (["linear", "-"].indexOf(ax.type) !== -1) {
	                ax.d2r = ax.r2d = ax.d2c = ax.r2c = ax.d2l = ax.r2l = cleanNumber;
	                ax.c2d = ax.c2r = ax.l2d = ax.l2r = ensureNumber;
	                ax.d2p = ax.r2p = function(v) {
	                  return ax.l2p(cleanNumber(v));
	                };
	                ax.p2d = ax.p2r = p2l;
	                ax.cleanPos = ensureNumber;
	              } else if (ax.type === "log") {
	                ax.d2r = ax.d2l = function(v, clip) {
	                  return toLog(cleanNumber(v), clip);
	                };
	                ax.r2d = ax.r2c = function(v) {
	                  return fromLog(cleanNumber(v));
	                };
	                ax.d2c = ax.r2l = cleanNumber;
	                ax.c2d = ax.l2r = ensureNumber;
	                ax.c2r = toLog;
	                ax.l2d = fromLog;
	                ax.d2p = function(v, clip) {
	                  return ax.l2p(ax.d2r(v, clip));
	                };
	                ax.p2d = function(px) {
	                  return fromLog(p2l(px));
	                };
	                ax.r2p = function(v) {
	                  return ax.l2p(cleanNumber(v));
	                };
	                ax.p2r = p2l;
	                ax.cleanPos = ensureNumber;
	              } else if (ax.type === "date") {
	                ax.d2r = ax.r2d = Lib.identity;
	                ax.d2c = ax.r2c = ax.d2l = ax.r2l = dt2ms;
	                ax.c2d = ax.c2r = ax.l2d = ax.l2r = ms2dt;
	                ax.d2p = ax.r2p = function(v, _, calendar) {
	                  return ax.l2p(dt2ms(v, 0, calendar));
	                };
	                ax.p2d = ax.p2r = function(px, r, calendar) {
	                  return ms2dt(p2l(px), r, calendar);
	                };
	                ax.cleanPos = function(v) {
	                  return Lib.cleanDate(v, BADNUM, ax.calendar);
	                };
	              } else if (ax.type === "category") {
	                ax.d2c = ax.d2l = setCategoryIndex;
	                ax.r2d = ax.c2d = ax.l2d = getCategoryName;
	                ax.d2r = ax.d2l_noadd = getCategoryPosition;
	                ax.r2c = function(v) {
	                  var index = getRangePosition(v);
	                  return index !== undefined ? index : ax.fraction2r(0.5);
	                };
	                ax.l2r = ax.c2r = ensureNumber;
	                ax.r2l = getRangePosition;
	                ax.d2p = function(v) {
	                  return ax.l2p(ax.r2c(v));
	                };
	                ax.p2d = function(px) {
	                  return getCategoryName(p2l(px));
	                };
	                ax.r2p = ax.d2p;
	                ax.p2r = p2l;
	                ax.cleanPos = function(v) {
	                  if (typeof v === "string" && v !== "") return v;
	                  return ensureNumber(v);
	                };
	              } else if (ax.type === "multicategory") {
	                ax.r2d = ax.c2d = ax.l2d = getCategoryName;
	                ax.d2r = ax.d2l_noadd = getCategoryPosition;
	                ax.r2c = function(v) {
	                  var index = getCategoryPosition(v);
	                  return index !== undefined ? index : ax.fraction2r(0.5);
	                };
	                ax.r2c_just_indices = getCategoryIndex;
	                ax.l2r = ax.c2r = ensureNumber;
	                ax.r2l = getCategoryPosition;
	                ax.d2p = function(v) {
	                  return ax.l2p(ax.r2c(v));
	                };
	                ax.p2d = function(px) {
	                  return getCategoryName(p2l(px));
	                };
	                ax.r2p = ax.d2p;
	                ax.p2r = p2l;
	                ax.cleanPos = function(v) {
	                  if (Array.isArray(v) || typeof v === "string" && v !== "") return v;
	                  return ensureNumber(v);
	                };
	                ax.setupMultiCategory = function(fullData) {
	                  var traceIndices = ax._traceIndices;
	                  var i, j;
	                  var group = ax._matchGroup;
	                  if (group && ax._categories.length === 0) {
	                    for (var axId2 in group) {
	                      if (axId2 !== axId) {
	                        var ax2 = fullLayout[axisIds.id2name(axId2)];
	                        traceIndices = traceIndices.concat(ax2._traceIndices);
	                      }
	                    }
	                  }
	                  var seen = [[0, {}], [0, {}]];
	                  var list = [];
	                  for (i = 0; i < traceIndices.length; i++) {
	                    var trace = fullData[traceIndices[i]];
	                    if (axLetter in trace) {
	                      var arrayIn = trace[axLetter];
	                      var len = trace._length || Lib.minRowLength(arrayIn);
	                      if (isArrayOrTypedArray(arrayIn[0]) && isArrayOrTypedArray(arrayIn[1])) {
	                        for (j = 0; j < len; j++) {
	                          var v0 = arrayIn[0][j];
	                          var v1 = arrayIn[1][j];
	                          if (isValidCategory(v0) && isValidCategory(v1)) {
	                            list.push([v0, v1]);
	                            if (!(v0 in seen[0][1])) {
	                              seen[0][1][v0] = seen[0][0]++;
	                            }
	                            if (!(v1 in seen[1][1])) {
	                              seen[1][1][v1] = seen[1][0]++;
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                  list.sort(function(a, b) {
	                    var ind0 = seen[0][1];
	                    var d = ind0[a[0]] - ind0[b[0]];
	                    if (d) return d;
	                    var ind1 = seen[1][1];
	                    return ind1[a[1]] - ind1[b[1]];
	                  });
	                  for (i = 0; i < list.length; i++) {
	                    setCategoryIndex(list[i]);
	                  }
	                };
	              }
	              ax.fraction2r = function(v) {
	                var rl0 = ax.r2l(ax.range[0]);
	                var rl1 = ax.r2l(ax.range[1]);
	                return ax.l2r(rl0 + v * (rl1 - rl0));
	              };
	              ax.r2fraction = function(v) {
	                var rl0 = ax.r2l(ax.range[0]);
	                var rl1 = ax.r2l(ax.range[1]);
	                return (ax.r2l(v) - rl0) / (rl1 - rl0);
	              };
	              ax.limitRange = function(rangeAttr) {
	                var minallowed = ax.minallowed;
	                var maxallowed = ax.maxallowed;
	                if (minallowed === undefined && maxallowed === undefined) return;
	                if (!rangeAttr) rangeAttr = "range";
	                var range2 = Lib.nestedProperty(ax, rangeAttr).get();
	                var rng = Lib.simpleMap(range2, ax.r2l);
	                var axrev = rng[1] < rng[0];
	                if (axrev) rng.reverse();
	                var bounds = Lib.simpleMap([minallowed, maxallowed], ax.r2l);
	                if (minallowed !== undefined && rng[0] < bounds[0]) range2[axrev ? 1 : 0] = minallowed;
	                if (maxallowed !== undefined && rng[1] > bounds[1]) range2[axrev ? 0 : 1] = maxallowed;
	              };
	              ax.cleanRange = function(rangeAttr, opts) {
	                ax._cleanRange(rangeAttr, opts);
	                ax.limitRange(rangeAttr);
	              };
	              ax._cleanRange = function(rangeAttr, opts) {
	                if (!opts) opts = {};
	                if (!rangeAttr) rangeAttr = "range";
	                var range2 = Lib.nestedProperty(ax, rangeAttr).get();
	                var i, dflt;
	                if (ax.type === "date") dflt = Lib.dfltRange(ax.calendar);
	                else if (axLetter === "y") dflt = constants.DFLTRANGEY;
	                else if (ax._name === "realaxis") dflt = [0, 1];
	                else dflt = opts.dfltRange || constants.DFLTRANGEX;
	                dflt = dflt.slice();
	                if (ax.rangemode === "tozero" || ax.rangemode === "nonnegative") {
	                  dflt[0] = 0;
	                }
	                if (!range2 || range2.length !== 2) {
	                  Lib.nestedProperty(ax, rangeAttr).set(dflt);
	                  return;
	                }
	                var nullRange0 = range2[0] === null;
	                var nullRange1 = range2[1] === null;
	                if (ax.type === "date" && !ax.autorange) {
	                  range2[0] = Lib.cleanDate(range2[0], BADNUM, ax.calendar);
	                  range2[1] = Lib.cleanDate(range2[1], BADNUM, ax.calendar);
	                }
	                for (i = 0; i < 2; i++) {
	                  if (ax.type === "date") {
	                    if (!Lib.isDateTime(range2[i], ax.calendar)) {
	                      ax[rangeAttr] = dflt;
	                      break;
	                    }
	                    if (ax.r2l(range2[0]) === ax.r2l(range2[1])) {
	                      var linCenter = Lib.constrain(ax.r2l(range2[0]), Lib.MIN_MS + 1e3, Lib.MAX_MS - 1e3);
	                      range2[0] = ax.l2r(linCenter - 1e3);
	                      range2[1] = ax.l2r(linCenter + 1e3);
	                      break;
	                    }
	                  } else {
	                    if (!isNumeric(range2[i])) {
	                      if (!(nullRange0 || nullRange1) && isNumeric(range2[1 - i])) {
	                        range2[i] = range2[1 - i] * (i ? 10 : 0.1);
	                      } else {
	                        ax[rangeAttr] = dflt;
	                        break;
	                      }
	                    }
	                    if (range2[i] < -FP_SAFE) range2[i] = -FP_SAFE;
	                    else if (range2[i] > FP_SAFE) range2[i] = FP_SAFE;
	                    if (range2[0] === range2[1]) {
	                      var inc = Math.max(1, Math.abs(range2[0] * 1e-6));
	                      range2[0] -= inc;
	                      range2[1] += inc;
	                    }
	                  }
	                }
	              };
	              ax.setScale = function(usePrivateRange) {
	                var gs = fullLayout._size;
	                if (ax.overlaying) {
	                  var ax2 = axisIds.getFromId({
	                    _fullLayout: fullLayout
	                  }, ax.overlaying);
	                  ax.domain = ax2.domain;
	                }
	                var rangeAttr = usePrivateRange && ax._r ? "_r" : "range";
	                var calendar = ax.calendar;
	                ax.cleanRange(rangeAttr);
	                var rl0 = ax.r2l(ax[rangeAttr][0], calendar);
	                var rl1 = ax.r2l(ax[rangeAttr][1], calendar);
	                var isY2 = axLetter === "y";
	                if (isY2) {
	                  ax._offset = gs.t + (1 - ax.domain[1]) * gs.h;
	                  ax._length = gs.h * (ax.domain[1] - ax.domain[0]);
	                  ax._m = ax._length / (rl0 - rl1);
	                  ax._b = -ax._m * rl1;
	                } else {
	                  ax._offset = gs.l + ax.domain[0] * gs.w;
	                  ax._length = gs.w * (ax.domain[1] - ax.domain[0]);
	                  ax._m = ax._length / (rl1 - rl0);
	                  ax._b = -ax._m * rl0;
	                }
	                ax._rangebreaks = [];
	                ax._lBreaks = 0;
	                ax._m2 = 0;
	                ax._B = [];
	                if (ax.rangebreaks) {
	                  var i, brk;
	                  ax._rangebreaks = ax.locateBreaks(Math.min(rl0, rl1), Math.max(rl0, rl1));
	                  if (ax._rangebreaks.length) {
	                    for (i = 0; i < ax._rangebreaks.length; i++) {
	                      brk = ax._rangebreaks[i];
	                      ax._lBreaks += Math.abs(brk.max - brk.min);
	                    }
	                    var flip = isY2;
	                    if (rl0 > rl1) flip = !flip;
	                    if (flip) ax._rangebreaks.reverse();
	                    var sign = flip ? -1 : 1;
	                    ax._m2 = sign * ax._length / (Math.abs(rl1 - rl0) - ax._lBreaks);
	                    ax._B.push(-ax._m2 * (isY2 ? rl1 : rl0));
	                    for (i = 0; i < ax._rangebreaks.length; i++) {
	                      brk = ax._rangebreaks[i];
	                      ax._B.push(ax._B[ax._B.length - 1] - sign * ax._m2 * (brk.max - brk.min));
	                    }
	                    for (i = 0; i < ax._rangebreaks.length; i++) {
	                      brk = ax._rangebreaks[i];
	                      brk.pmin = l2p(brk.min);
	                      brk.pmax = l2p(brk.max);
	                    }
	                  }
	                }
	                if (!isFinite(ax._m) || !isFinite(ax._b) || ax._length < 0) {
	                  fullLayout._replotting = false;
	                  throw new Error("Something went wrong with axis scaling");
	                }
	              };
	              ax.maskBreaks = function(v) {
	                var rangebreaksIn = ax.rangebreaks || [];
	                var bnds, b0, b1, vb, vDate;
	                if (!rangebreaksIn._cachedPatterns) {
	                  rangebreaksIn._cachedPatterns = rangebreaksIn.map(function(brk2) {
	                    return brk2.enabled && brk2.bounds ? Lib.simpleMap(
	                      brk2.bounds,
	                      brk2.pattern ? cleanNumber : ax.d2c
	                      // case of pattern: ''
	                    ) : null;
	                  });
	                }
	                if (!rangebreaksIn._cachedValues) {
	                  rangebreaksIn._cachedValues = rangebreaksIn.map(function(brk2) {
	                    return brk2.enabled && brk2.values ? Lib.simpleMap(brk2.values, ax.d2c).sort(Lib.sorterAsc) : null;
	                  });
	                }
	                for (var i = 0; i < rangebreaksIn.length; i++) {
	                  var brk = rangebreaksIn[i];
	                  if (brk.enabled) {
	                    if (brk.bounds) {
	                      var pattern = brk.pattern;
	                      bnds = rangebreaksIn._cachedPatterns[i];
	                      b0 = bnds[0];
	                      b1 = bnds[1];
	                      switch (pattern) {
	                        case WEEKDAY_PATTERN:
	                          vDate = new Date(v);
	                          vb = vDate.getUTCDay();
	                          if (b0 > b1) {
	                            b1 += 7;
	                            if (vb < b0) vb += 7;
	                          }
	                          break;
	                        case HOUR_PATTERN:
	                          vDate = new Date(v);
	                          var hours = vDate.getUTCHours();
	                          var minutes = vDate.getUTCMinutes();
	                          var seconds = vDate.getUTCSeconds();
	                          var milliseconds = vDate.getUTCMilliseconds();
	                          vb = hours + (minutes / 60 + seconds / 3600 + milliseconds / 36e5);
	                          if (b0 > b1) {
	                            b1 += 24;
	                            if (vb < b0) vb += 24;
	                          }
	                          break;
	                        case "":
	                          vb = v;
	                          break;
	                      }
	                      if (vb >= b0 && vb < b1) return BADNUM;
	                    } else {
	                      var vals = rangebreaksIn._cachedValues[i];
	                      for (var j = 0; j < vals.length; j++) {
	                        b0 = vals[j];
	                        b1 = b0 + brk.dvalue;
	                        if (v >= b0 && v < b1) return BADNUM;
	                      }
	                    }
	                  }
	                }
	                return v;
	              };
	              ax.locateBreaks = function(r0, r1) {
	                var i, bnds, b0, b1;
	                var rangebreaksOut = [];
	                if (!ax.rangebreaks) return rangebreaksOut;
	                var rangebreaksIn = ax.rangebreaks.slice().sort(function(a, b) {
	                  if (a.pattern === WEEKDAY_PATTERN && b.pattern === HOUR_PATTERN) return -1;
	                  if (b.pattern === WEEKDAY_PATTERN && a.pattern === HOUR_PATTERN) return 1;
	                  return 0;
	                });
	                var addBreak = function(min, max) {
	                  min = Lib.constrain(min, r0, r1);
	                  max = Lib.constrain(max, r0, r1);
	                  if (min === max) return;
	                  var isNewBreak = true;
	                  for (var j2 = 0; j2 < rangebreaksOut.length; j2++) {
	                    var brkj = rangebreaksOut[j2];
	                    if (min < brkj.max && max >= brkj.min) {
	                      if (min < brkj.min) {
	                        brkj.min = min;
	                      }
	                      if (max > brkj.max) {
	                        brkj.max = max;
	                      }
	                      isNewBreak = false;
	                    }
	                  }
	                  if (isNewBreak) {
	                    rangebreaksOut.push({
	                      min,
	                      max
	                    });
	                  }
	                };
	                for (i = 0; i < rangebreaksIn.length; i++) {
	                  var brk = rangebreaksIn[i];
	                  if (brk.enabled) {
	                    if (brk.bounds) {
	                      var t0 = r0;
	                      var t1 = r1;
	                      if (brk.pattern) {
	                        t0 = Math.floor(t0);
	                      }
	                      bnds = Lib.simpleMap(brk.bounds, brk.pattern ? cleanNumber : ax.r2l);
	                      b0 = bnds[0];
	                      b1 = bnds[1];
	                      var t0Date = new Date(t0);
	                      var bndDelta;
	                      var step;
	                      switch (brk.pattern) {
	                        case WEEKDAY_PATTERN:
	                          step = ONEWEEK;
	                          bndDelta = ((b1 < b0 ? 7 : 0) + (b1 - b0)) * ONEDAY;
	                          t0 += b0 * ONEDAY - (t0Date.getUTCDay() * ONEDAY + t0Date.getUTCHours() * ONEHOUR + t0Date.getUTCMinutes() * ONEMIN + t0Date.getUTCSeconds() * ONESEC + t0Date.getUTCMilliseconds());
	                          break;
	                        case HOUR_PATTERN:
	                          step = ONEDAY;
	                          bndDelta = ((b1 < b0 ? 24 : 0) + (b1 - b0)) * ONEHOUR;
	                          t0 += b0 * ONEHOUR - (t0Date.getUTCHours() * ONEHOUR + t0Date.getUTCMinutes() * ONEMIN + t0Date.getUTCSeconds() * ONESEC + t0Date.getUTCMilliseconds());
	                          break;
	                        default:
	                          t0 = Math.min(bnds[0], bnds[1]);
	                          t1 = Math.max(bnds[0], bnds[1]);
	                          step = t1 - t0;
	                          bndDelta = step;
	                      }
	                      for (var t = t0; t < t1; t += step) {
	                        addBreak(t, t + bndDelta);
	                      }
	                    } else {
	                      var vals = Lib.simpleMap(brk.values, ax.d2c);
	                      for (var j = 0; j < vals.length; j++) {
	                        b0 = vals[j];
	                        b1 = b0 + brk.dvalue;
	                        addBreak(b0, b1);
	                      }
	                    }
	                  }
	                }
	                rangebreaksOut.sort(function(a, b) {
	                  return a.min - b.min;
	                });
	                return rangebreaksOut;
	              };
	              ax.makeCalcdata = function(trace, axLetter2, opts) {
	                var arrayIn, arrayOut, i, len;
	                var axType = ax.type;
	                var cal = axType === "date" && trace[axLetter2 + "calendar"];
	                if (axLetter2 in trace) {
	                  arrayIn = trace[axLetter2];
	                  len = trace._length || Lib.minRowLength(arrayIn);
	                  if (Lib.isTypedArray(arrayIn) && (axType === "linear" || axType === "log")) {
	                    if (len === arrayIn.length) {
	                      return arrayIn;
	                    } else if (arrayIn.subarray) {
	                      return arrayIn.subarray(0, len);
	                    }
	                  }
	                  if (axType === "multicategory") {
	                    return setMultiCategoryIndex(arrayIn, len);
	                  }
	                  arrayOut = new Array(len);
	                  for (i = 0; i < len; i++) {
	                    arrayOut[i] = ax.d2c(arrayIn[i], 0, cal, opts);
	                  }
	                } else {
	                  var v0 = axLetter2 + "0" in trace ? ax.d2c(trace[axLetter2 + "0"], 0, cal) : 0;
	                  var dv = trace["d" + axLetter2] ? Number(trace["d" + axLetter2]) : 1;
	                  arrayIn = trace[{
	                    x: "y",
	                    y: "x"
	                  }[axLetter2]];
	                  len = trace._length || arrayIn.length;
	                  arrayOut = new Array(len);
	                  for (i = 0; i < len; i++) {
	                    arrayOut[i] = v0 + i * dv;
	                  }
	                }
	                if (ax.rangebreaks) {
	                  for (i = 0; i < len; i++) {
	                    arrayOut[i] = ax.maskBreaks(arrayOut[i]);
	                  }
	                }
	                return arrayOut;
	              };
	              ax.isValidRange = function(range2, nullOk) {
	                return Array.isArray(range2) && range2.length === 2 && (nullOk && range2[0] === null || isNumeric(ax.r2l(range2[0]))) && (nullOk && range2[1] === null || isNumeric(ax.r2l(range2[1])));
	              };
	              ax.getAutorangeDflt = function(range2, options) {
	                var autorangeDflt = !ax.isValidRange(range2, "nullOk");
	                if (autorangeDflt && options && options.reverseDflt) autorangeDflt = "reversed";
	                else if (range2) {
	                  if (range2[0] === null && range2[1] === null) {
	                    autorangeDflt = true;
	                  } else if (range2[0] === null && range2[1] !== null) {
	                    autorangeDflt = "min";
	                  } else if (range2[0] !== null && range2[1] === null) {
	                    autorangeDflt = "max";
	                  }
	                }
	                return autorangeDflt;
	              };
	              ax.isReversed = function() {
	                var autorange = ax.autorange;
	                return autorange === "reversed" || autorange === "min reversed" || autorange === "max reversed";
	              };
	              ax.isPtWithinRange = function(d, calendar) {
	                var coord = ax.c2l(d[axLetter], null, calendar);
	                var r0 = ax.r2l(ax.range[0]);
	                var r1 = ax.r2l(ax.range[1]);
	                if (r0 < r1) {
	                  return r0 <= coord && coord <= r1;
	                } else {
	                  return r1 <= coord && coord <= r0;
	                }
	              };
	              ax._emptyCategories = function() {
	                ax._categories = [];
	                ax._categoriesMap = {};
	              };
	              ax.clearCalc = function() {
	                var group = ax._matchGroup;
	                if (group) {
	                  var categories = null;
	                  var categoriesMap = null;
	                  for (var axId2 in group) {
	                    var ax2 = fullLayout[axisIds.id2name(axId2)];
	                    if (ax2._categories) {
	                      categories = ax2._categories;
	                      categoriesMap = ax2._categoriesMap;
	                      break;
	                    }
	                  }
	                  if (categories && categoriesMap) {
	                    ax._categories = categories;
	                    ax._categoriesMap = categoriesMap;
	                  } else {
	                    ax._emptyCategories();
	                  }
	                } else {
	                  ax._emptyCategories();
	                }
	                if (ax._initialCategories) {
	                  for (var j = 0; j < ax._initialCategories.length; j++) {
	                    setCategoryIndex(ax._initialCategories[j]);
	                  }
	                }
	              };
	              ax.sortByInitialCategories = function() {
	                var affectedTraces = [];
	                ax._emptyCategories();
	                if (ax._initialCategories) {
	                  for (var j = 0; j < ax._initialCategories.length; j++) {
	                    setCategoryIndex(ax._initialCategories[j]);
	                  }
	                }
	                affectedTraces = affectedTraces.concat(ax._traceIndices);
	                var group = ax._matchGroup;
	                for (var axId2 in group) {
	                  if (axId === axId2) continue;
	                  var ax2 = fullLayout[axisIds.id2name(axId2)];
	                  ax2._categories = ax._categories;
	                  ax2._categoriesMap = ax._categoriesMap;
	                  affectedTraces = affectedTraces.concat(ax2._traceIndices);
	                }
	                return affectedTraces;
	              };
	              var locale = fullLayout._d3locale;
	              if (ax.type === "date") {
	                ax._dateFormat = locale ? locale.timeFormat : utcFormat;
	                ax._extraFormat = fullLayout._extraFormat;
	              }
	              ax._separators = fullLayout.separators;
	              ax._numFormat = locale ? locale.numberFormat : numberFormat;
	              delete ax._minDtick;
	              delete ax._forceTick0;
	            };
	          }
	        ),
	        /***/
	        59652: (
	          /***/
	          function(module2) {
	            module2.exports = function getShowAttrDflt(containerIn) {
	              var showAttrsAll = ["showexponent", "showtickprefix", "showticksuffix"];
	              var showAttrs = showAttrsAll.filter(function(a) {
	                return containerIn[a] !== undefined;
	              });
	              var sameVal = function(a) {
	                return containerIn[a] === containerIn[showAttrs[0]];
	              };
	              if (showAttrs.every(sameVal) || showAttrs.length === 1) {
	                return containerIn[showAttrs[0]];
	              }
	            };
	          }
	        ),
	        /***/
	        96115: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var contrast = __webpack_require__2(7901).contrast;
	            var layoutAttributes = __webpack_require__2(13838);
	            var getShowAttrDflt = __webpack_require__2(59652);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            module2.exports = function handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options) {
	              if (!options) options = {};
	              var labelalias = coerce("labelalias");
	              if (!Lib.isPlainObject(labelalias)) delete containerOut.labelalias;
	              var showAttrDflt = getShowAttrDflt(containerIn);
	              var showTickLabels = coerce("showticklabels");
	              if (showTickLabels) {
	                var font = options.font || {};
	                var contColor = containerOut.color;
	                var position = containerOut.ticklabelposition || "";
	                var dfltFontColor = position.indexOf("inside") !== -1 ? contrast(options.bgColor) : (
	                  // as with titlefont.color, inherit axis.color only if one was
	                  // explicitly provided
	                  contColor && contColor !== layoutAttributes.color.dflt ? contColor : font.color
	                );
	                Lib.coerceFont(coerce, "tickfont", {
	                  family: font.family,
	                  size: font.size,
	                  color: dfltFontColor
	                });
	                if (!options.noTicklabelstep && axType !== "multicategory" && axType !== "log") {
	                  coerce("ticklabelstep");
	                }
	                if (!options.noAng) coerce("tickangle");
	                if (axType !== "category") {
	                  var tickFormat = coerce("tickformat");
	                  handleArrayContainerDefaults(containerIn, containerOut, {
	                    name: "tickformatstops",
	                    inclusionAttr: "enabled",
	                    handleItemDefaults: tickformatstopDefaults
	                  });
	                  if (!containerOut.tickformatstops.length) {
	                    delete containerOut.tickformatstops;
	                  }
	                  if (!options.noExp && !tickFormat && axType !== "date") {
	                    coerce("showexponent", showAttrDflt);
	                    coerce("exponentformat");
	                    coerce("minexponent");
	                    coerce("separatethousands");
	                  }
	                }
	              }
	            };
	            function tickformatstopDefaults(valueIn, valueOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(valueIn, valueOut, layoutAttributes.tickformatstops, attr, dflt);
	              }
	              var enabled = coerce("enabled");
	              if (enabled) {
	                coerce("dtickrange");
	                coerce("value");
	              }
	            }
	          }
	        ),
	        /***/
	        38701: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(13838);
	            module2.exports = function handleTickMarkDefaults(containerIn, containerOut, coerce, options) {
	              var isMinor = options.isMinor;
	              var cIn = isMinor ? containerIn.minor || {} : containerIn;
	              var cOut = isMinor ? containerOut.minor : containerOut;
	              var lAttr = isMinor ? layoutAttributes.minor : layoutAttributes;
	              var prefix = isMinor ? "minor." : "";
	              var tickLen = Lib.coerce2(cIn, cOut, lAttr, "ticklen", isMinor ? (containerOut.ticklen || 5) * 0.6 : undefined);
	              var tickWidth = Lib.coerce2(cIn, cOut, lAttr, "tickwidth", isMinor ? containerOut.tickwidth || 1 : undefined);
	              var tickColor = Lib.coerce2(cIn, cOut, lAttr, "tickcolor", (isMinor ? containerOut.tickcolor : undefined) || cOut.color);
	              var showTicks = coerce(prefix + "ticks", !isMinor && options.outerTicks || tickLen || tickWidth || tickColor ? "outside" : "");
	              if (!showTicks) {
	                delete cOut.ticklen;
	                delete cOut.tickwidth;
	                delete cOut.tickcolor;
	              }
	            };
	          }
	        ),
	        /***/
	        26218: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var cleanTicks = __webpack_require__2(66287);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function handleTickValueDefaults(containerIn, containerOut, coerce, axType, opts) {
	              if (!opts) opts = {};
	              var isMinor = opts.isMinor;
	              var cIn = isMinor ? containerIn.minor || {} : containerIn;
	              var cOut = isMinor ? containerOut.minor : containerOut;
	              var prefix = isMinor ? "minor." : "";
	              function readInput(attr) {
	                var v = cIn[attr];
	                return v !== undefined ? v : (cOut._template || {})[attr];
	              }
	              var _tick0 = readInput("tick0");
	              var _dtick = readInput("dtick");
	              var _tickvals = readInput("tickvals");
	              var tickmodeDefault = isArrayOrTypedArray(_tickvals) ? "array" : _dtick ? "linear" : "auto";
	              var tickmode = coerce(prefix + "tickmode", tickmodeDefault);
	              if (tickmode === "auto" || tickmode === "sync") {
	                coerce(prefix + "nticks");
	              } else if (tickmode === "linear") {
	                var dtick = cOut.dtick = cleanTicks.dtick(_dtick, axType);
	                cOut.tick0 = cleanTicks.tick0(_tick0, axType, containerOut.calendar, dtick);
	              } else if (axType !== "multicategory") {
	                var tickvals = coerce(prefix + "tickvals");
	                if (tickvals === undefined) cOut.tickmode = "auto";
	                else if (!isMinor) coerce("ticktext");
	              }
	            };
	          }
	        ),
	        /***/
	        66847: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function transitionAxes(gd, edits, transitionOpts, makeOnCompleteCallback) {
	              var fullLayout = gd._fullLayout;
	              if (edits.length === 0) {
	                Axes.redrawComponents(gd);
	                return;
	              }
	              function unsetSubplotTransform(subplot) {
	                var xa = subplot.xaxis;
	                var ya = subplot.yaxis;
	                fullLayout._defs.select("#" + subplot.clipId + "> rect").call(Drawing.setTranslate, 0, 0).call(Drawing.setScale, 1, 1);
	                subplot.plot.call(Drawing.setTranslate, xa._offset, ya._offset).call(Drawing.setScale, 1, 1);
	                var traceGroups = subplot.plot.selectAll(".scatterlayer .trace");
	                traceGroups.selectAll(".point").call(Drawing.setPointGroupScale, 1, 1);
	                traceGroups.selectAll(".textpoint").call(Drawing.setTextPointsScale, 1, 1);
	                traceGroups.call(Drawing.hideOutsideRangePoints, subplot);
	              }
	              function updateSubplot(edit, progress) {
	                var plotinfo = edit.plotinfo;
	                var xa = plotinfo.xaxis;
	                var ya = plotinfo.yaxis;
	                var xlen = xa._length;
	                var ylen = ya._length;
	                var editX = !!edit.xr1;
	                var editY = !!edit.yr1;
	                var viewBox = [];
	                if (editX) {
	                  var xr0 = Lib.simpleMap(edit.xr0, xa.r2l);
	                  var xr1 = Lib.simpleMap(edit.xr1, xa.r2l);
	                  var dx0 = xr0[1] - xr0[0];
	                  var dx1 = xr1[1] - xr1[0];
	                  viewBox[0] = (xr0[0] * (1 - progress) + progress * xr1[0] - xr0[0]) / (xr0[1] - xr0[0]) * xlen;
	                  viewBox[2] = xlen * (1 - progress + progress * dx1 / dx0);
	                  xa.range[0] = xa.l2r(xr0[0] * (1 - progress) + progress * xr1[0]);
	                  xa.range[1] = xa.l2r(xr0[1] * (1 - progress) + progress * xr1[1]);
	                } else {
	                  viewBox[0] = 0;
	                  viewBox[2] = xlen;
	                }
	                if (editY) {
	                  var yr0 = Lib.simpleMap(edit.yr0, ya.r2l);
	                  var yr1 = Lib.simpleMap(edit.yr1, ya.r2l);
	                  var dy0 = yr0[1] - yr0[0];
	                  var dy1 = yr1[1] - yr1[0];
	                  viewBox[1] = (yr0[1] * (1 - progress) + progress * yr1[1] - yr0[1]) / (yr0[0] - yr0[1]) * ylen;
	                  viewBox[3] = ylen * (1 - progress + progress * dy1 / dy0);
	                  ya.range[0] = xa.l2r(yr0[0] * (1 - progress) + progress * yr1[0]);
	                  ya.range[1] = ya.l2r(yr0[1] * (1 - progress) + progress * yr1[1]);
	                } else {
	                  viewBox[1] = 0;
	                  viewBox[3] = ylen;
	                }
	                Axes.drawOne(gd, xa, {
	                  skipTitle: true
	                });
	                Axes.drawOne(gd, ya, {
	                  skipTitle: true
	                });
	                Axes.redrawComponents(gd, [xa._id, ya._id]);
	                var xScaleFactor = editX ? xlen / viewBox[2] : 1;
	                var yScaleFactor = editY ? ylen / viewBox[3] : 1;
	                var clipDx = editX ? viewBox[0] : 0;
	                var clipDy = editY ? viewBox[1] : 0;
	                var fracDx = editX ? viewBox[0] / viewBox[2] * xlen : 0;
	                var fracDy = editY ? viewBox[1] / viewBox[3] * ylen : 0;
	                var plotDx = xa._offset - fracDx;
	                var plotDy = ya._offset - fracDy;
	                plotinfo.clipRect.call(Drawing.setTranslate, clipDx, clipDy).call(Drawing.setScale, 1 / xScaleFactor, 1 / yScaleFactor);
	                plotinfo.plot.call(Drawing.setTranslate, plotDx, plotDy).call(Drawing.setScale, xScaleFactor, yScaleFactor);
	                Drawing.setPointGroupScale(plotinfo.zoomScalePts, 1 / xScaleFactor, 1 / yScaleFactor);
	                Drawing.setTextPointsScale(plotinfo.zoomScaleTxt, 1 / xScaleFactor, 1 / yScaleFactor);
	              }
	              var onComplete;
	              if (makeOnCompleteCallback) {
	                onComplete = makeOnCompleteCallback();
	              }
	              function transitionComplete() {
	                var aobj = {};
	                for (var i = 0; i < edits.length; i++) {
	                  var edit = edits[i];
	                  var xa = edit.plotinfo.xaxis;
	                  var ya = edit.plotinfo.yaxis;
	                  if (edit.xr1) aobj[xa._name + ".range"] = edit.xr1.slice();
	                  if (edit.yr1) aobj[ya._name + ".range"] = edit.yr1.slice();
	                }
	                onComplete && onComplete();
	                return Registry.call("relayout", gd, aobj).then(function() {
	                  for (var i2 = 0; i2 < edits.length; i2++) {
	                    unsetSubplotTransform(edits[i2].plotinfo);
	                  }
	                });
	              }
	              function transitionInterrupt() {
	                var aobj = {};
	                for (var i = 0; i < edits.length; i++) {
	                  var edit = edits[i];
	                  var xa = edit.plotinfo.xaxis;
	                  var ya = edit.plotinfo.yaxis;
	                  if (edit.xr0) aobj[xa._name + ".range"] = edit.xr0.slice();
	                  if (edit.yr0) aobj[ya._name + ".range"] = edit.yr0.slice();
	                }
	                return Registry.call("relayout", gd, aobj).then(function() {
	                  for (var i2 = 0; i2 < edits.length; i2++) {
	                    unsetSubplotTransform(edits[i2].plotinfo);
	                  }
	                });
	              }
	              var t1, t2, raf;
	              var easeFn = d3.ease(transitionOpts.easing);
	              gd._transitionData._interruptCallbacks.push(function() {
	                window.cancelAnimationFrame(raf);
	                raf = null;
	                return transitionInterrupt();
	              });
	              function doFrame() {
	                t2 = Date.now();
	                var tInterp = Math.min(1, (t2 - t1) / transitionOpts.duration);
	                var progress = easeFn(tInterp);
	                for (var i = 0; i < edits.length; i++) {
	                  updateSubplot(edits[i], progress);
	                }
	                if (t2 - t1 > transitionOpts.duration) {
	                  transitionComplete();
	                  raf = window.cancelAnimationFrame(doFrame);
	                } else {
	                  raf = window.requestAnimationFrame(doFrame);
	                }
	              }
	              t1 = Date.now();
	              raf = window.requestAnimationFrame(doFrame);
	              return Promise.resolve();
	            };
	          }
	        ),
	        /***/
	        951: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var traceIs = __webpack_require__2(73972).traceIs;
	            var autoType = __webpack_require__2(4322);
	            module2.exports = function handleTypeDefaults(containerIn, containerOut, coerce, options) {
	              coerce("autotypenumbers", options.autotypenumbersDflt);
	              var axType = coerce("type", (options.splomStash || {}).type);
	              if (axType === "-") {
	                setAutoType(containerOut, options.data);
	                if (containerOut.type === "-") {
	                  containerOut.type = "linear";
	                } else {
	                  containerIn.type = containerOut.type;
	                }
	              }
	            };
	            function setAutoType(ax, data) {
	              if (ax.type !== "-") return;
	              var id = ax._id;
	              var axLetter = id.charAt(0);
	              var i;
	              if (id.indexOf("scene") !== -1) id = axLetter;
	              var d0 = getFirstNonEmptyTrace(data, id, axLetter);
	              if (!d0) return;
	              if (d0.type === "histogram" && axLetter === {
	                v: "y",
	                h: "x"
	              }[d0.orientation || "v"]) {
	                ax.type = "linear";
	                return;
	              }
	              var calAttr = axLetter + "calendar";
	              var calendar = d0[calAttr];
	              var opts = {
	                noMultiCategory: !traceIs(d0, "cartesian") || traceIs(d0, "noMultiCategory")
	              };
	              if (d0.type === "box" && d0._hasPreCompStats && axLetter === {
	                h: "x",
	                v: "y"
	              }[d0.orientation || "v"]) {
	                opts.noMultiCategory = true;
	              }
	              opts.autotypenumbers = ax.autotypenumbers;
	              if (isBoxWithoutPositionCoords(d0, axLetter)) {
	                var posLetter = getBoxPosLetter(d0);
	                var boxPositions = [];
	                for (i = 0; i < data.length; i++) {
	                  var trace = data[i];
	                  if (!traceIs(trace, "box-violin") || (trace[axLetter + "axis"] || axLetter) !== id) continue;
	                  if (trace[posLetter] !== undefined) boxPositions.push(trace[posLetter][0]);
	                  else if (trace.name !== undefined) boxPositions.push(trace.name);
	                  else boxPositions.push("text");
	                  if (trace[calAttr] !== calendar) calendar = undefined;
	                }
	                ax.type = autoType(boxPositions, calendar, opts);
	              } else if (d0.type === "splom") {
	                var dimensions = d0.dimensions;
	                var dim = dimensions[d0._axesDim[id]];
	                if (dim.visible) ax.type = autoType(dim.values, calendar, opts);
	              } else {
	                ax.type = autoType(d0[axLetter] || [d0[axLetter + "0"]], calendar, opts);
	              }
	            }
	            function getFirstNonEmptyTrace(data, id, axLetter) {
	              for (var i = 0; i < data.length; i++) {
	                var trace = data[i];
	                if (trace.type === "splom" && trace._length > 0 && (trace["_" + axLetter + "axes"] || {})[id]) {
	                  return trace;
	                }
	                if ((trace[axLetter + "axis"] || axLetter) === id) {
	                  if (isBoxWithoutPositionCoords(trace, axLetter)) {
	                    return trace;
	                  } else if ((trace[axLetter] || []).length || trace[axLetter + "0"]) {
	                    return trace;
	                  }
	                }
	              }
	            }
	            function getBoxPosLetter(trace) {
	              return {
	                v: "x",
	                h: "y"
	              }[trace.orientation || "v"];
	            }
	            function isBoxWithoutPositionCoords(trace, axLetter) {
	              var posLetter = getBoxPosLetter(trace);
	              var isBox = traceIs(trace, "box-violin");
	              var isCandlestick = traceIs(trace._fullInput || {}, "candlestick");
	              return isBox && !isCandlestick && axLetter === posLetter && trace[posLetter] === undefined && trace[posLetter + "0"] === undefined;
	            }
	          }
	        ),
	        /***/
	        31137: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            exports2.manageCommandObserver = function(gd, container, commandList, onchange) {
	              var ret = {};
	              var enabled = true;
	              if (container && container._commandObserver) {
	                ret = container._commandObserver;
	              }
	              if (!ret.cache) {
	                ret.cache = {};
	              }
	              ret.lookupTable = {};
	              var binding = exports2.hasSimpleAPICommandBindings(gd, commandList, ret.lookupTable);
	              if (container && container._commandObserver) {
	                if (!binding) {
	                  if (container._commandObserver.remove) {
	                    container._commandObserver.remove();
	                    container._commandObserver = null;
	                    return ret;
	                  }
	                } else {
	                  return ret;
	                }
	              }
	              if (binding) {
	                bindingValueHasChanged(gd, binding, ret.cache);
	                ret.check = function check() {
	                  if (!enabled) return;
	                  var update = bindingValueHasChanged(gd, binding, ret.cache);
	                  if (update.changed && onchange) {
	                    if (ret.lookupTable[update.value] !== undefined) {
	                      ret.disable();
	                      Promise.resolve(onchange({
	                        value: update.value,
	                        type: binding.type,
	                        prop: binding.prop,
	                        traces: binding.traces,
	                        index: ret.lookupTable[update.value]
	                      })).then(ret.enable, ret.enable);
	                    }
	                  }
	                  return update.changed;
	                };
	                var checkEvents = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"];
	                for (var i = 0; i < checkEvents.length; i++) {
	                  gd._internalOn(checkEvents[i], ret.check);
	                }
	                ret.remove = function() {
	                  for (var i2 = 0; i2 < checkEvents.length; i2++) {
	                    gd._removeInternalListener(checkEvents[i2], ret.check);
	                  }
	                };
	              } else {
	                Lib.log("Unable to automatically bind plot updates to API command");
	                ret.lookupTable = {};
	                ret.remove = function() {
	                };
	              }
	              ret.disable = function disable() {
	                enabled = false;
	              };
	              ret.enable = function enable() {
	                enabled = true;
	              };
	              if (container) {
	                container._commandObserver = ret;
	              }
	              return ret;
	            };
	            exports2.hasSimpleAPICommandBindings = function(gd, commandList, bindingsByValue) {
	              var i;
	              var n = commandList.length;
	              var refBinding;
	              for (i = 0; i < n; i++) {
	                var binding;
	                var command = commandList[i];
	                var method = command.method;
	                var args = command.args;
	                if (!Array.isArray(args)) args = [];
	                if (!method) {
	                  return false;
	                }
	                var bindings = exports2.computeAPICommandBindings(gd, method, args);
	                if (bindings.length !== 1) {
	                  return false;
	                }
	                if (!refBinding) {
	                  refBinding = bindings[0];
	                  if (Array.isArray(refBinding.traces)) {
	                    refBinding.traces.sort();
	                  }
	                } else {
	                  binding = bindings[0];
	                  if (binding.type !== refBinding.type) {
	                    return false;
	                  }
	                  if (binding.prop !== refBinding.prop) {
	                    return false;
	                  }
	                  if (Array.isArray(refBinding.traces)) {
	                    if (Array.isArray(binding.traces)) {
	                      binding.traces.sort();
	                      for (var j = 0; j < refBinding.traces.length; j++) {
	                        if (refBinding.traces[j] !== binding.traces[j]) {
	                          return false;
	                        }
	                      }
	                    } else {
	                      return false;
	                    }
	                  } else {
	                    if (binding.prop !== refBinding.prop) {
	                      return false;
	                    }
	                  }
	                }
	                binding = bindings[0];
	                var value = binding.value;
	                if (Array.isArray(value)) {
	                  if (value.length === 1) {
	                    value = value[0];
	                  } else {
	                    return false;
	                  }
	                }
	                if (bindingsByValue) {
	                  bindingsByValue[value] = i;
	                }
	              }
	              return refBinding;
	            };
	            function bindingValueHasChanged(gd, binding, cache) {
	              var container, value, obj;
	              var changed = false;
	              if (binding.type === "data") {
	                container = gd._fullData[binding.traces !== null ? binding.traces[0] : 0];
	              } else if (binding.type === "layout") {
	                container = gd._fullLayout;
	              } else {
	                return false;
	              }
	              value = Lib.nestedProperty(container, binding.prop).get();
	              obj = cache[binding.type] = cache[binding.type] || {};
	              if (obj.hasOwnProperty(binding.prop)) {
	                if (obj[binding.prop] !== value) {
	                  changed = true;
	                }
	              }
	              obj[binding.prop] = value;
	              return {
	                changed,
	                value
	              };
	            }
	            exports2.executeAPICommand = function(gd, method, args) {
	              if (method === "skip") return Promise.resolve();
	              var _method = Registry.apiMethodRegistry[method];
	              var allArgs = [gd];
	              if (!Array.isArray(args)) args = [];
	              for (var i = 0; i < args.length; i++) {
	                allArgs.push(args[i]);
	              }
	              return _method.apply(null, allArgs).catch(function(err) {
	                Lib.warn("API call to Plotly." + method + " rejected.", err);
	                return Promise.reject(err);
	              });
	            };
	            exports2.computeAPICommandBindings = function(gd, method, args) {
	              var bindings;
	              if (!Array.isArray(args)) args = [];
	              switch (method) {
	                case "restyle":
	                  bindings = computeDataBindings(gd, args);
	                  break;
	                case "relayout":
	                  bindings = computeLayoutBindings(gd, args);
	                  break;
	                case "update":
	                  bindings = computeDataBindings(gd, [args[0], args[2]]).concat(computeLayoutBindings(gd, [args[1]]));
	                  break;
	                case "animate":
	                  bindings = computeAnimateBindings(gd, args);
	                  break;
	                default:
	                  bindings = [];
	              }
	              return bindings;
	            };
	            function computeAnimateBindings(gd, args) {
	              if (Array.isArray(args[0]) && args[0].length === 1 && ["string", "number"].indexOf(typeof args[0][0]) !== -1) {
	                return [{
	                  type: "layout",
	                  prop: "_currentFrame",
	                  value: args[0][0].toString()
	                }];
	              } else {
	                return [];
	              }
	            }
	            function computeLayoutBindings(gd, args) {
	              var bindings = [];
	              var astr = args[0];
	              var aobj = {};
	              if (typeof astr === "string") {
	                aobj[astr] = args[1];
	              } else if (Lib.isPlainObject(astr)) {
	                aobj = astr;
	              } else {
	                return bindings;
	              }
	              crawl(aobj, function(path, attrName, attr) {
	                bindings.push({
	                  type: "layout",
	                  prop: path,
	                  value: attr
	                });
	              }, "", 0);
	              return bindings;
	            }
	            function computeDataBindings(gd, args) {
	              var traces, astr, val, aobj;
	              var bindings = [];
	              astr = args[0];
	              val = args[1];
	              traces = args[2];
	              aobj = {};
	              if (typeof astr === "string") {
	                aobj[astr] = val;
	              } else if (Lib.isPlainObject(astr)) {
	                aobj = astr;
	                if (traces === undefined) {
	                  traces = val;
	                }
	              } else {
	                return bindings;
	              }
	              if (traces === undefined) {
	                traces = null;
	              }
	              crawl(aobj, function(path, attrName, _attr) {
	                var thisTraces;
	                var attr;
	                if (Array.isArray(_attr)) {
	                  attr = _attr.slice();
	                  var nAttr = Math.min(attr.length, gd.data.length);
	                  if (traces) {
	                    nAttr = Math.min(nAttr, traces.length);
	                  }
	                  thisTraces = [];
	                  for (var j = 0; j < nAttr; j++) {
	                    thisTraces[j] = traces ? traces[j] : j;
	                  }
	                } else {
	                  attr = _attr;
	                  thisTraces = traces ? traces.slice() : null;
	                }
	                if (thisTraces === null) {
	                  if (Array.isArray(attr)) {
	                    attr = attr[0];
	                  }
	                } else if (Array.isArray(thisTraces)) {
	                  if (!Array.isArray(attr)) {
	                    var tmp = attr;
	                    attr = [];
	                    for (var i = 0; i < thisTraces.length; i++) {
	                      attr[i] = tmp;
	                    }
	                  }
	                  attr.length = Math.min(thisTraces.length, attr.length);
	                }
	                bindings.push({
	                  type: "data",
	                  prop: path,
	                  traces: thisTraces,
	                  value: attr
	                });
	              }, "", 0);
	              return bindings;
	            }
	            function crawl(attrs, callback, path, depth) {
	              Object.keys(attrs).forEach(function(attrName) {
	                var attr = attrs[attrName];
	                if (attrName[0] === "_") return;
	                var thisPath = path + (depth > 0 ? "." : "") + attrName;
	                if (Lib.isPlainObject(attr)) {
	                  crawl(attr, callback, thisPath, depth + 1);
	                } else {
	                  callback(thisPath, attrName, attr);
	                }
	              });
	            }
	          }
	        ),
	        /***/
	        27670: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            exports2.Y = function(opts, extra) {
	              opts = opts || {};
	              extra = extra || {};
	              var base = {
	                valType: "info_array",
	                editType: opts.editType,
	                items: [{
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  editType: opts.editType
	                }, {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  editType: opts.editType
	                }],
	                dflt: [0, 1]
	              };
	              opts.name ? opts.name + " " : "";
	              opts.trace ? "trace " : "subplot ";
	              extra.description ? " " + extra.description : "";
	              var out = {
	                x: extendFlat({}, base, {}),
	                y: extendFlat({}, base, {}),
	                editType: opts.editType
	              };
	              if (!opts.noGridCell) {
	                out.row = {
	                  valType: "integer",
	                  min: 0,
	                  dflt: 0,
	                  editType: opts.editType
	                };
	                out.column = {
	                  valType: "integer",
	                  min: 0,
	                  dflt: 0,
	                  editType: opts.editType
	                };
	              }
	              return out;
	            };
	            exports2.c = function(containerOut, layout, coerce, dfltDomains) {
	              var dfltX = dfltDomains && dfltDomains.x || [0, 1];
	              var dfltY = dfltDomains && dfltDomains.y || [0, 1];
	              var grid = layout.grid;
	              if (grid) {
	                var column = coerce("domain.column");
	                if (column !== undefined) {
	                  if (column < grid.columns) dfltX = grid._domains.x[column];
	                  else delete containerOut.domain.column;
	                }
	                var row = coerce("domain.row");
	                if (row !== undefined) {
	                  if (row < grid.rows) dfltY = grid._domains.y[row];
	                  else delete containerOut.domain.row;
	                }
	              }
	              var x = coerce("domain.x", dfltX);
	              var y = coerce("domain.y", dfltY);
	              if (!(x[0] < x[1])) containerOut.domain.x = dfltX.slice();
	              if (!(y[0] < y[1])) containerOut.domain.y = dfltY.slice();
	            };
	          }
	        ),
	        /***/
	        41940: (
	          /***/
	          function(module2) {
	            module2.exports = function(opts) {
	              var editType = opts.editType;
	              var colorEditType = opts.colorEditType;
	              if (colorEditType === undefined) colorEditType = editType;
	              var attrs = {
	                family: {
	                  valType: "string",
	                  noBlank: true,
	                  strict: true,
	                  editType
	                },
	                size: {
	                  valType: "number",
	                  min: 1,
	                  editType
	                },
	                color: {
	                  valType: "color",
	                  editType: colorEditType
	                },
	                editType
	                // blank strings so compress_attributes can remove
	                // TODO - that's uber hacky... better solution?
	              };
	              if (opts.autoSize) attrs.size.dflt = "auto";
	              if (opts.autoColor) attrs.color.dflt = "auto";
	              if (opts.arrayOk) {
	                attrs.family.arrayOk = true;
	                attrs.size.arrayOk = true;
	                attrs.color.arrayOk = true;
	              }
	              return attrs;
	            };
	          }
	        ),
	        /***/
	        31391: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              _isLinkedToArray: "frames_entry",
	              group: {
	                valType: "string"
	              },
	              name: {
	                valType: "string"
	              },
	              traces: {
	                valType: "any"
	              },
	              baseframe: {
	                valType: "string"
	              },
	              data: {
	                valType: "any"
	              },
	              layout: {
	                valType: "any"
	              }
	            };
	          }
	        ),
	        /***/
	        78776: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.projNames = {
	              airy: "airy",
	              aitoff: "aitoff",
	              "albers usa": "albersUsa",
	              albers: "albers",
	              // 'armadillo': 'armadillo',
	              august: "august",
	              "azimuthal equal area": "azimuthalEqualArea",
	              "azimuthal equidistant": "azimuthalEquidistant",
	              baker: "baker",
	              // 'berghaus': 'berghaus',
	              bertin1953: "bertin1953",
	              boggs: "boggs",
	              bonne: "bonne",
	              bottomley: "bottomley",
	              bromley: "bromley",
	              // 'chamberlin africa': 'chamberlinAfrica',
	              // 'chamberlin': 'chamberlin',
	              collignon: "collignon",
	              "conic conformal": "conicConformal",
	              "conic equal area": "conicEqualArea",
	              "conic equidistant": "conicEquidistant",
	              craig: "craig",
	              craster: "craster",
	              "cylindrical equal area": "cylindricalEqualArea",
	              "cylindrical stereographic": "cylindricalStereographic",
	              eckert1: "eckert1",
	              eckert2: "eckert2",
	              eckert3: "eckert3",
	              eckert4: "eckert4",
	              eckert5: "eckert5",
	              eckert6: "eckert6",
	              eisenlohr: "eisenlohr",
	              "equal earth": "equalEarth",
	              equirectangular: "equirectangular",
	              fahey: "fahey",
	              "foucaut sinusoidal": "foucautSinusoidal",
	              foucaut: "foucaut",
	              // 'gilbert': 'gilbert',
	              // 'gingery': 'gingery',
	              ginzburg4: "ginzburg4",
	              ginzburg5: "ginzburg5",
	              ginzburg6: "ginzburg6",
	              ginzburg8: "ginzburg8",
	              ginzburg9: "ginzburg9",
	              gnomonic: "gnomonic",
	              "gringorten quincuncial": "gringortenQuincuncial",
	              gringorten: "gringorten",
	              guyou: "guyou",
	              // 'hammer retroazimuthal': 'hammerRetroazimuthal',
	              hammer: "hammer",
	              // 'healpix': 'healpix',
	              hill: "hill",
	              homolosine: "homolosine",
	              hufnagel: "hufnagel",
	              hyperelliptical: "hyperelliptical",
	              // 'interrupted boggs': 'interruptedBoggs',
	              // 'interrupted homolosine': 'interruptedHomolosine',
	              // 'interrupted mollweide hemispheres': 'interruptedMollweideHemispheres',
	              // 'interrupted mollweide': 'interruptedMollweide',
	              // 'interrupted quartic authalic': 'interruptedQuarticAuthalic',
	              // 'interrupted sinu mollweide': 'interruptedSinuMollweide',
	              // 'interrupted sinusoidal': 'interruptedSinusoidal',
	              kavrayskiy7: "kavrayskiy7",
	              lagrange: "lagrange",
	              larrivee: "larrivee",
	              laskowski: "laskowski",
	              // 'littrow': 'littrow',
	              loximuthal: "loximuthal",
	              mercator: "mercator",
	              miller: "miller",
	              // 'modified stereographic alaska': 'modifiedStereographicAlaska',
	              // 'modified stereographic gs48': 'modifiedStereographicGs48',
	              // 'modified stereographic gs50': 'modifiedStereographicGs50',
	              // 'modified stereographic lee': 'modifiedStereographicLee',
	              // 'modified stereographic miller': 'modifiedStereographicMiller',
	              // 'modified stereographic': 'modifiedStereographic',
	              mollweide: "mollweide",
	              "mt flat polar parabolic": "mtFlatPolarParabolic",
	              "mt flat polar quartic": "mtFlatPolarQuartic",
	              "mt flat polar sinusoidal": "mtFlatPolarSinusoidal",
	              "natural earth": "naturalEarth",
	              "natural earth1": "naturalEarth1",
	              "natural earth2": "naturalEarth2",
	              "nell hammer": "nellHammer",
	              nicolosi: "nicolosi",
	              orthographic: "orthographic",
	              patterson: "patterson",
	              "peirce quincuncial": "peirceQuincuncial",
	              polyconic: "polyconic",
	              // 'polyhedral butterfly': 'polyhedralButterfly',
	              // 'polyhedral collignon': 'polyhedralCollignon',
	              // 'polyhedral waterman': 'polyhedralWaterman',
	              "rectangular polyconic": "rectangularPolyconic",
	              robinson: "robinson",
	              satellite: "satellite",
	              "sinu mollweide": "sinuMollweide",
	              sinusoidal: "sinusoidal",
	              stereographic: "stereographic",
	              times: "times",
	              "transverse mercator": "transverseMercator",
	              // 'two point azimuthalUsa': 'twoPointAzimuthalUsa',
	              // 'two point azimuthal': 'twoPointAzimuthal',
	              // 'two point equidistantUsa': 'twoPointEquidistantUsa',
	              // 'two point equidistant': 'twoPointEquidistant',
	              "van der grinten": "vanDerGrinten",
	              "van der grinten2": "vanDerGrinten2",
	              "van der grinten3": "vanDerGrinten3",
	              "van der grinten4": "vanDerGrinten4",
	              wagner4: "wagner4",
	              wagner6: "wagner6",
	              // 'wagner7': 'wagner7',
	              // 'wagner': 'wagner',
	              wiechel: "wiechel",
	              "winkel tripel": "winkel3",
	              winkel3: "winkel3"
	            };
	            exports2.axesNames = ["lonaxis", "lataxis"];
	            exports2.lonaxisSpan = {
	              orthographic: 180,
	              "azimuthal equal area": 360,
	              "azimuthal equidistant": 360,
	              "conic conformal": 180,
	              gnomonic: 160,
	              stereographic: 180,
	              "transverse mercator": 180,
	              "*": 360
	            };
	            exports2.lataxisSpan = {
	              "conic conformal": 150,
	              stereographic: 179.5,
	              "*": 180
	            };
	            exports2.scopeDefaults = {
	              world: {
	                lonaxisRange: [-180, 180],
	                lataxisRange: [-90, 90],
	                projType: "equirectangular",
	                projRotate: [0, 0, 0]
	              },
	              usa: {
	                lonaxisRange: [-180, -50],
	                lataxisRange: [15, 80],
	                projType: "albers usa"
	              },
	              europe: {
	                lonaxisRange: [-30, 60],
	                lataxisRange: [30, 85],
	                projType: "conic conformal",
	                projRotate: [15, 0, 0],
	                projParallels: [0, 60]
	              },
	              asia: {
	                lonaxisRange: [22, 160],
	                lataxisRange: [-15, 55],
	                projType: "mercator",
	                projRotate: [0, 0, 0]
	              },
	              africa: {
	                lonaxisRange: [-30, 60],
	                lataxisRange: [-40, 40],
	                projType: "mercator",
	                projRotate: [0, 0, 0]
	              },
	              "north america": {
	                lonaxisRange: [-180, -45],
	                lataxisRange: [5, 85],
	                projType: "conic conformal",
	                projRotate: [-100, 0, 0],
	                projParallels: [29.5, 45.5]
	              },
	              "south america": {
	                lonaxisRange: [-100, -30],
	                lataxisRange: [-60, 15],
	                projType: "mercator",
	                projRotate: [0, 0, 0]
	              }
	            };
	            exports2.clipPad = 1e-3;
	            exports2.precision = 0.1;
	            exports2.landColor = "#F0DC82";
	            exports2.waterColor = "#3399FF";
	            exports2.locationmodeToLayer = {
	              "ISO-3": "countries",
	              "USA-states": "subunits",
	              "country names": "countries"
	            };
	            exports2.sphereSVG = {
	              type: "Sphere"
	            };
	            exports2.fillLayers = {
	              ocean: 1,
	              land: 1,
	              lakes: 1
	            };
	            exports2.lineLayers = {
	              subunits: 1,
	              countries: 1,
	              coastlines: 1,
	              rivers: 1,
	              frame: 1
	            };
	            exports2.layers = ["bg", "ocean", "land", "lakes", "subunits", "countries", "coastlines", "rivers", "lataxis", "lonaxis", "frame", "backplot", "frontplot"];
	            exports2.layersForChoropleth = ["bg", "ocean", "land", "subunits", "countries", "coastlines", "lataxis", "lonaxis", "frame", "backplot", "rivers", "lakes", "frontplot"];
	            exports2.layerNameToAdjective = {
	              ocean: "ocean",
	              land: "land",
	              lakes: "lake",
	              subunits: "subunit",
	              countries: "country",
	              coastlines: "coastline",
	              rivers: "river",
	              frame: "frame"
	            };
	          }
	        ),
	        /***/
	        69082: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var geo = __webpack_require__2(27362);
	            var geoPath = geo.geoPath;
	            var geoDistance = geo.geoDistance;
	            var geoProjection = __webpack_require__2(65704);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Fx = __webpack_require__2(30211);
	            var Plots = __webpack_require__2(74875);
	            var Axes = __webpack_require__2(89298);
	            var getAutoRange = __webpack_require__2(71739).getAutoRange;
	            var dragElement = __webpack_require__2(28569);
	            var prepSelect = __webpack_require__2(47322).prepSelect;
	            var clearOutline = __webpack_require__2(47322).clearOutline;
	            var selectOnClick = __webpack_require__2(47322).selectOnClick;
	            var createGeoZoom = __webpack_require__2(74455);
	            var constants = __webpack_require__2(78776);
	            var geoUtils = __webpack_require__2(41327);
	            var topojsonUtils = __webpack_require__2(90973);
	            var topojsonFeature = __webpack_require__2(96892).zL;
	            function Geo(opts) {
	              this.id = opts.id;
	              this.graphDiv = opts.graphDiv;
	              this.container = opts.container;
	              this.topojsonURL = opts.topojsonURL;
	              this.isStatic = opts.staticPlot;
	              this.topojsonName = null;
	              this.topojson = null;
	              this.projection = null;
	              this.scope = null;
	              this.viewInitial = null;
	              this.fitScale = null;
	              this.bounds = null;
	              this.midPt = null;
	              this.hasChoropleth = false;
	              this.traceHash = {};
	              this.layers = {};
	              this.basePaths = {};
	              this.dataPaths = {};
	              this.dataPoints = {};
	              this.clipDef = null;
	              this.clipRect = null;
	              this.bgRect = null;
	              this.makeFramework();
	            }
	            var proto = Geo.prototype;
	            module2.exports = function createGeo(opts) {
	              return new Geo(opts);
	            };
	            proto.plot = function(geoCalcData, fullLayout, promises, replot) {
	              var _this = this;
	              if (replot) return _this.update(geoCalcData, fullLayout, true);
	              _this._geoCalcData = geoCalcData;
	              _this._fullLayout = fullLayout;
	              var geoLayout = fullLayout[this.id];
	              var geoPromises = [];
	              var needsTopojson = false;
	              for (var k in constants.layerNameToAdjective) {
	                if (k !== "frame" && geoLayout["show" + k]) {
	                  needsTopojson = true;
	                  break;
	                }
	              }
	              var hasMarkerAngles = false;
	              for (var i = 0; i < geoCalcData.length; i++) {
	                var trace = geoCalcData[0][0].trace;
	                trace._geo = _this;
	                if (trace.locationmode) {
	                  needsTopojson = true;
	                }
	                var marker = trace.marker;
	                if (marker) {
	                  var angle = marker.angle;
	                  var angleref = marker.angleref;
	                  if (angle || angleref === "north" || angleref === "previous") hasMarkerAngles = true;
	                }
	              }
	              this._hasMarkerAngles = hasMarkerAngles;
	              if (needsTopojson) {
	                var topojsonNameNew = topojsonUtils.getTopojsonName(geoLayout);
	                if (_this.topojson === null || topojsonNameNew !== _this.topojsonName) {
	                  _this.topojsonName = topojsonNameNew;
	                  if (PlotlyGeoAssets.topojson[_this.topojsonName] === undefined) {
	                    geoPromises.push(_this.fetchTopojson());
	                  }
	                }
	              }
	              geoPromises = geoPromises.concat(geoUtils.fetchTraceGeoData(geoCalcData));
	              promises.push(new Promise(function(resolve, reject) {
	                Promise.all(geoPromises).then(function() {
	                  _this.topojson = PlotlyGeoAssets.topojson[_this.topojsonName];
	                  _this.update(geoCalcData, fullLayout);
	                  resolve();
	                }).catch(reject);
	              }));
	            };
	            proto.fetchTopojson = function() {
	              var _this = this;
	              var topojsonPath = topojsonUtils.getTopojsonPath(_this.topojsonURL, _this.topojsonName);
	              return new Promise(function(resolve, reject) {
	                d3.json(topojsonPath, function(err, topojson) {
	                  if (err) {
	                    if (err.status === 404) {
	                      return reject(new Error(["plotly.js could not find topojson file at", topojsonPath + ".", "Make sure the *topojsonURL* plot config option", "is set properly."].join(" ")));
	                    } else {
	                      return reject(new Error(["unexpected error while fetching topojson file at", topojsonPath].join(" ")));
	                    }
	                  }
	                  PlotlyGeoAssets.topojson[_this.topojsonName] = topojson;
	                  resolve();
	                });
	              });
	            };
	            proto.update = function(geoCalcData, fullLayout, replot) {
	              var geoLayout = fullLayout[this.id];
	              this.hasChoropleth = false;
	              for (var i = 0; i < geoCalcData.length; i++) {
	                var calcTrace = geoCalcData[i];
	                var trace = calcTrace[0].trace;
	                if (trace.type === "choropleth") {
	                  this.hasChoropleth = true;
	                }
	                if (trace.visible === true && trace._length > 0) {
	                  trace._module.calcGeoJSON(calcTrace, fullLayout);
	                }
	              }
	              if (!replot) {
	                var hasInvalidBounds = this.updateProjection(geoCalcData, fullLayout);
	                if (hasInvalidBounds) return;
	                if (!this.viewInitial || this.scope !== geoLayout.scope) {
	                  this.saveViewInitial(geoLayout);
	                }
	              }
	              this.scope = geoLayout.scope;
	              this.updateBaseLayers(fullLayout, geoLayout);
	              this.updateDims(fullLayout, geoLayout);
	              this.updateFx(fullLayout, geoLayout);
	              Plots.generalUpdatePerTraceModule(this.graphDiv, this, geoCalcData, geoLayout);
	              var scatterLayer = this.layers.frontplot.select(".scatterlayer");
	              this.dataPoints.point = scatterLayer.selectAll(".point");
	              this.dataPoints.text = scatterLayer.selectAll("text");
	              this.dataPaths.line = scatterLayer.selectAll(".js-line");
	              var choroplethLayer = this.layers.backplot.select(".choroplethlayer");
	              this.dataPaths.choropleth = choroplethLayer.selectAll("path");
	              this._render();
	            };
	            proto.updateProjection = function(geoCalcData, fullLayout) {
	              var gd = this.graphDiv;
	              var geoLayout = fullLayout[this.id];
	              var gs = fullLayout._size;
	              var domain = geoLayout.domain;
	              var projLayout = geoLayout.projection;
	              var lonaxis = geoLayout.lonaxis;
	              var lataxis = geoLayout.lataxis;
	              var axLon = lonaxis._ax;
	              var axLat = lataxis._ax;
	              var projection = this.projection = getProjection(geoLayout);
	              var extent2 = [[gs.l + gs.w * domain.x[0], gs.t + gs.h * (1 - domain.y[1])], [gs.l + gs.w * domain.x[1], gs.t + gs.h * (1 - domain.y[0])]];
	              var center = geoLayout.center || {};
	              var rotation = projLayout.rotation || {};
	              var lonaxisRange = lonaxis.range || [];
	              var lataxisRange = lataxis.range || [];
	              if (geoLayout.fitbounds) {
	                axLon._length = extent2[1][0] - extent2[0][0];
	                axLat._length = extent2[1][1] - extent2[0][1];
	                axLon.range = getAutoRange(gd, axLon);
	                axLat.range = getAutoRange(gd, axLat);
	                var midLon = (axLon.range[0] + axLon.range[1]) / 2;
	                var midLat = (axLat.range[0] + axLat.range[1]) / 2;
	                if (geoLayout._isScoped) {
	                  center = {
	                    lon: midLon,
	                    lat: midLat
	                  };
	                } else if (geoLayout._isClipped) {
	                  center = {
	                    lon: midLon,
	                    lat: midLat
	                  };
	                  rotation = {
	                    lon: midLon,
	                    lat: midLat,
	                    roll: rotation.roll
	                  };
	                  var projType = projLayout.type;
	                  var lonHalfSpan = constants.lonaxisSpan[projType] / 2 || 180;
	                  var latHalfSpan = constants.lataxisSpan[projType] / 2 || 90;
	                  lonaxisRange = [midLon - lonHalfSpan, midLon + lonHalfSpan];
	                  lataxisRange = [midLat - latHalfSpan, midLat + latHalfSpan];
	                } else {
	                  center = {
	                    lon: midLon,
	                    lat: midLat
	                  };
	                  rotation = {
	                    lon: midLon,
	                    lat: rotation.lat,
	                    roll: rotation.roll
	                  };
	                }
	              }
	              projection.center([center.lon - rotation.lon, center.lat - rotation.lat]).rotate([-rotation.lon, -rotation.lat, rotation.roll]).parallels(projLayout.parallels);
	              var rangeBox = makeRangeBox(lonaxisRange, lataxisRange);
	              projection.fitExtent(extent2, rangeBox);
	              var b = this.bounds = projection.getBounds(rangeBox);
	              var s = this.fitScale = projection.scale();
	              var t = projection.translate();
	              if (geoLayout.fitbounds) {
	                var b2 = projection.getBounds(makeRangeBox(axLon.range, axLat.range));
	                var k2 = Math.min((b[1][0] - b[0][0]) / (b2[1][0] - b2[0][0]), (b[1][1] - b[0][1]) / (b2[1][1] - b2[0][1]));
	                if (isFinite(k2)) {
	                  projection.scale(k2 * s);
	                } else {
	                  Lib.warn("Something went wrong during" + this.id + "fitbounds computations.");
	                }
	              } else {
	                projection.scale(projLayout.scale * s);
	              }
	              var midPt = this.midPt = [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2];
	              projection.translate([t[0] + (midPt[0] - t[0]), t[1] + (midPt[1] - t[1])]).clipExtent(b);
	              if (geoLayout._isAlbersUsa) {
	                var centerPx = projection([center.lon, center.lat]);
	                var tt = projection.translate();
	                projection.translate([tt[0] - (centerPx[0] - tt[0]), tt[1] - (centerPx[1] - tt[1])]);
	              }
	            };
	            proto.updateBaseLayers = function(fullLayout, geoLayout) {
	              var _this = this;
	              var topojson = _this.topojson;
	              var layers = _this.layers;
	              var basePaths = _this.basePaths;
	              function isAxisLayer(d) {
	                return d === "lonaxis" || d === "lataxis";
	              }
	              function isLineLayer(d) {
	                return Boolean(constants.lineLayers[d]);
	              }
	              function isFillLayer(d) {
	                return Boolean(constants.fillLayers[d]);
	              }
	              var allLayers = this.hasChoropleth ? constants.layersForChoropleth : constants.layers;
	              var layerData = allLayers.filter(function(d) {
	                return isLineLayer(d) || isFillLayer(d) ? geoLayout["show" + d] : isAxisLayer(d) ? geoLayout[d].showgrid : true;
	              });
	              var join = _this.framework.selectAll(".layer").data(layerData, String);
	              join.exit().each(function(d) {
	                delete layers[d];
	                delete basePaths[d];
	                d3.select(this).remove();
	              });
	              join.enter().append("g").attr("class", function(d) {
	                return "layer " + d;
	              }).each(function(d) {
	                var layer = layers[d] = d3.select(this);
	                if (d === "bg") {
	                  _this.bgRect = layer.append("rect").style("pointer-events", "all");
	                } else if (isAxisLayer(d)) {
	                  basePaths[d] = layer.append("path").style("fill", "none");
	                } else if (d === "backplot") {
	                  layer.append("g").classed("choroplethlayer", true);
	                } else if (d === "frontplot") {
	                  layer.append("g").classed("scatterlayer", true);
	                } else if (isLineLayer(d)) {
	                  basePaths[d] = layer.append("path").style("fill", "none").style("stroke-miterlimit", 2);
	                } else if (isFillLayer(d)) {
	                  basePaths[d] = layer.append("path").style("stroke", "none");
	                }
	              });
	              join.order();
	              join.each(function(d) {
	                var path = basePaths[d];
	                var adj = constants.layerNameToAdjective[d];
	                if (d === "frame") {
	                  path.datum(constants.sphereSVG);
	                } else if (isLineLayer(d) || isFillLayer(d)) {
	                  path.datum(topojsonFeature(topojson, topojson.objects[d]));
	                } else if (isAxisLayer(d)) {
	                  path.datum(makeGraticule(d, geoLayout, fullLayout)).call(Color.stroke, geoLayout[d].gridcolor).call(Drawing.dashLine, geoLayout[d].griddash, geoLayout[d].gridwidth);
	                }
	                if (isLineLayer(d)) {
	                  path.call(Color.stroke, geoLayout[adj + "color"]).call(Drawing.dashLine, "", geoLayout[adj + "width"]);
	                } else if (isFillLayer(d)) {
	                  path.call(Color.fill, geoLayout[adj + "color"]);
	                }
	              });
	            };
	            proto.updateDims = function(fullLayout, geoLayout) {
	              var b = this.bounds;
	              var hFrameWidth = (geoLayout.framewidth || 0) / 2;
	              var l = b[0][0] - hFrameWidth;
	              var t = b[0][1] - hFrameWidth;
	              var w = b[1][0] - l + hFrameWidth;
	              var h = b[1][1] - t + hFrameWidth;
	              Drawing.setRect(this.clipRect, l, t, w, h);
	              this.bgRect.call(Drawing.setRect, l, t, w, h).call(Color.fill, geoLayout.bgcolor);
	              this.xaxis._offset = l;
	              this.xaxis._length = w;
	              this.yaxis._offset = t;
	              this.yaxis._length = h;
	            };
	            proto.updateFx = function(fullLayout, geoLayout) {
	              var _this = this;
	              var gd = _this.graphDiv;
	              var bgRect = _this.bgRect;
	              var dragMode = fullLayout.dragmode;
	              var clickMode = fullLayout.clickmode;
	              if (_this.isStatic) return;
	              function zoomReset() {
	                var viewInitial = _this.viewInitial;
	                var updateObj = {};
	                for (var k in viewInitial) {
	                  updateObj[_this.id + "." + k] = viewInitial[k];
	                }
	                Registry.call("_guiRelayout", gd, updateObj);
	                gd.emit("plotly_doubleclick", null);
	              }
	              function invert(lonlat) {
	                return _this.projection.invert([lonlat[0] + _this.xaxis._offset, lonlat[1] + _this.yaxis._offset]);
	              }
	              var fillRangeItems = function(eventData, poly) {
	                if (poly.isRect) {
	                  var ranges = eventData.range = {};
	                  ranges[_this.id] = [invert([poly.xmin, poly.ymin]), invert([poly.xmax, poly.ymax])];
	                } else {
	                  var dataPts = eventData.lassoPoints = {};
	                  dataPts[_this.id] = poly.map(invert);
	                }
	              };
	              var dragOptions = {
	                element: _this.bgRect.node(),
	                gd,
	                plotinfo: {
	                  id: _this.id,
	                  xaxis: _this.xaxis,
	                  yaxis: _this.yaxis,
	                  fillRangeItems
	                },
	                xaxes: [_this.xaxis],
	                yaxes: [_this.yaxis],
	                subplot: _this.id,
	                clickFn: function(numClicks) {
	                  if (numClicks === 2) {
	                    clearOutline(gd);
	                  }
	                }
	              };
	              if (dragMode === "pan") {
	                bgRect.node().onmousedown = null;
	                bgRect.call(createGeoZoom(_this, geoLayout));
	                bgRect.on("dblclick.zoom", zoomReset);
	                if (!gd._context._scrollZoom.geo) {
	                  bgRect.on("wheel.zoom", null);
	                }
	              } else if (dragMode === "select" || dragMode === "lasso") {
	                bgRect.on(".zoom", null);
	                dragOptions.prepFn = function(e, startX, startY) {
	                  prepSelect(e, startX, startY, dragOptions, dragMode);
	                };
	                dragElement.init(dragOptions);
	              }
	              bgRect.on("mousemove", function() {
	                var lonlat = _this.projection.invert(Lib.getPositionFromD3Event());
	                if (!lonlat) {
	                  return dragElement.unhover(gd, d3.event);
	                }
	                _this.xaxis.p2c = function() {
	                  return lonlat[0];
	                };
	                _this.yaxis.p2c = function() {
	                  return lonlat[1];
	                };
	                Fx.hover(gd, d3.event, _this.id);
	              });
	              bgRect.on("mouseout", function() {
	                if (gd._dragging) return;
	                dragElement.unhover(gd, d3.event);
	              });
	              bgRect.on("click", function() {
	                if (dragMode !== "select" && dragMode !== "lasso") {
	                  if (clickMode.indexOf("select") > -1) {
	                    selectOnClick(d3.event, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOptions);
	                  }
	                  if (clickMode.indexOf("event") > -1) {
	                    Fx.click(gd, d3.event);
	                  }
	                }
	              });
	            };
	            proto.makeFramework = function() {
	              var _this = this;
	              var gd = _this.graphDiv;
	              var fullLayout = gd._fullLayout;
	              var clipId = "clip" + fullLayout._uid + _this.id;
	              _this.clipDef = fullLayout._clips.append("clipPath").attr("id", clipId);
	              _this.clipRect = _this.clipDef.append("rect");
	              _this.framework = d3.select(_this.container).append("g").attr("class", "geo " + _this.id).call(Drawing.setClipUrl, clipId, gd);
	              _this.project = function(v) {
	                var px = _this.projection(v);
	                return px ? [px[0] - _this.xaxis._offset, px[1] - _this.yaxis._offset] : [null, null];
	              };
	              _this.xaxis = {
	                _id: "x",
	                c2p: function(v) {
	                  return _this.project(v)[0];
	                }
	              };
	              _this.yaxis = {
	                _id: "y",
	                c2p: function(v) {
	                  return _this.project(v)[1];
	                }
	              };
	              _this.mockAxis = {
	                type: "linear",
	                showexponent: "all",
	                exponentformat: "B"
	              };
	              Axes.setConvert(_this.mockAxis, fullLayout);
	            };
	            proto.saveViewInitial = function(geoLayout) {
	              var center = geoLayout.center || {};
	              var projLayout = geoLayout.projection;
	              var rotation = projLayout.rotation || {};
	              this.viewInitial = {
	                fitbounds: geoLayout.fitbounds,
	                "projection.scale": projLayout.scale
	              };
	              var extra;
	              if (geoLayout._isScoped) {
	                extra = {
	                  "center.lon": center.lon,
	                  "center.lat": center.lat
	                };
	              } else if (geoLayout._isClipped) {
	                extra = {
	                  "projection.rotation.lon": rotation.lon,
	                  "projection.rotation.lat": rotation.lat
	                };
	              } else {
	                extra = {
	                  "center.lon": center.lon,
	                  "center.lat": center.lat,
	                  "projection.rotation.lon": rotation.lon
	                };
	              }
	              Lib.extendFlat(this.viewInitial, extra);
	            };
	            proto.render = function(mayRedrawOnUpdates) {
	              if (this._hasMarkerAngles && mayRedrawOnUpdates) {
	                this.plot(this._geoCalcData, this._fullLayout, [], true);
	              } else {
	                this._render();
	              }
	            };
	            proto._render = function() {
	              var projection = this.projection;
	              var pathFn = projection.getPath();
	              var k;
	              function translatePoints(d) {
	                var lonlatPx = projection(d.lonlat);
	                return lonlatPx ? strTranslate(lonlatPx[0], lonlatPx[1]) : null;
	              }
	              function hideShowPoints(d) {
	                return projection.isLonLatOverEdges(d.lonlat) ? "none" : null;
	              }
	              for (k in this.basePaths) {
	                this.basePaths[k].attr("d", pathFn);
	              }
	              for (k in this.dataPaths) {
	                this.dataPaths[k].attr("d", function(d) {
	                  return pathFn(d.geojson);
	                });
	              }
	              for (k in this.dataPoints) {
	                this.dataPoints[k].attr("display", hideShowPoints).attr("transform", translatePoints);
	              }
	            };
	            function getProjection(geoLayout) {
	              var projLayout = geoLayout.projection;
	              var projType = projLayout.type;
	              var projName = constants.projNames[projType];
	              projName = "geo" + Lib.titleCase(projName);
	              var projFn = geo[projName] || geoProjection[projName];
	              var projection = projFn();
	              var clipAngle = geoLayout._isSatellite ? Math.acos(1 / projLayout.distance) * 180 / Math.PI : geoLayout._isClipped ? constants.lonaxisSpan[projType] / 2 : null;
	              var methods = ["center", "rotate", "parallels", "clipExtent"];
	              var dummyFn = function(_) {
	                return _ ? projection : [];
	              };
	              for (var i = 0; i < methods.length; i++) {
	                var m = methods[i];
	                if (typeof projection[m] !== "function") {
	                  projection[m] = dummyFn;
	                }
	              }
	              projection.isLonLatOverEdges = function(lonlat) {
	                if (projection(lonlat) === null) {
	                  return true;
	                }
	                if (clipAngle) {
	                  var r = projection.rotate();
	                  var angle = geoDistance(lonlat, [-r[0], -r[1]]);
	                  var maxAngle = clipAngle * Math.PI / 180;
	                  return angle > maxAngle;
	                } else {
	                  return false;
	                }
	              };
	              projection.getPath = function() {
	                return geoPath().projection(projection);
	              };
	              projection.getBounds = function(object) {
	                return projection.getPath().bounds(object);
	              };
	              projection.precision(constants.precision);
	              if (geoLayout._isSatellite) {
	                projection.tilt(projLayout.tilt).distance(projLayout.distance);
	              }
	              if (clipAngle) {
	                projection.clipAngle(clipAngle - constants.clipPad);
	              }
	              return projection;
	            }
	            function makeGraticule(axisName, geoLayout, fullLayout) {
	              var epsilon = 1e-6;
	              var precision = 2.5;
	              var axLayout = geoLayout[axisName];
	              var scopeDefaults = constants.scopeDefaults[geoLayout.scope];
	              var rng;
	              var oppRng;
	              var coordFn;
	              if (axisName === "lonaxis") {
	                rng = scopeDefaults.lonaxisRange;
	                oppRng = scopeDefaults.lataxisRange;
	                coordFn = function(v2, l2) {
	                  return [v2, l2];
	                };
	              } else if (axisName === "lataxis") {
	                rng = scopeDefaults.lataxisRange;
	                oppRng = scopeDefaults.lonaxisRange;
	                coordFn = function(v2, l2) {
	                  return [l2, v2];
	                };
	              }
	              var dummyAx = {
	                type: "linear",
	                range: [rng[0], rng[1] - epsilon],
	                tick0: axLayout.tick0,
	                dtick: axLayout.dtick
	              };
	              Axes.setConvert(dummyAx, fullLayout);
	              var vals = Axes.calcTicks(dummyAx);
	              if (!geoLayout.isScoped && axisName === "lonaxis") {
	                vals.pop();
	              }
	              var len = vals.length;
	              var coords = new Array(len);
	              for (var i = 0; i < len; i++) {
	                var v = vals[i].x;
	                var line = coords[i] = [];
	                for (var l = oppRng[0]; l < oppRng[1] + precision; l += precision) {
	                  line.push(coordFn(v, l));
	                }
	              }
	              return {
	                type: "MultiLineString",
	                coordinates: coords
	              };
	            }
	            function makeRangeBox(lon, lat) {
	              var clipPad = constants.clipPad;
	              var lon0 = lon[0] + clipPad;
	              var lon1 = lon[1] - clipPad;
	              var lat0 = lat[0] + clipPad;
	              var lat1 = lat[1] - clipPad;
	              if (lon0 > 0 && lon1 < 0) lon1 += 360;
	              var dlon4 = (lon1 - lon0) / 4;
	              return {
	                type: "Polygon",
	                coordinates: [[[lon0, lat0], [lon0, lat1], [lon0 + dlon4, lat1], [lon0 + 2 * dlon4, lat1], [lon0 + 3 * dlon4, lat1], [lon1, lat1], [lon1, lat0], [lon1 - dlon4, lat0], [lon1 - 2 * dlon4, lat0], [lon1 - 3 * dlon4, lat0], [lon0, lat0]]]
	              };
	            }
	          }
	        ),
	        /***/
	        44622: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getSubplotCalcData = __webpack_require__2(27659).AU;
	            var counterRegex = __webpack_require__2(71828).counterRegex;
	            var createGeo = __webpack_require__2(69082);
	            var GEO = "geo";
	            var counter = counterRegex(GEO);
	            var attributes = {};
	            attributes[GEO] = {
	              valType: "subplotid",
	              dflt: GEO,
	              editType: "calc"
	            };
	            function plotGeo(gd) {
	              var fullLayout = gd._fullLayout;
	              var calcData = gd.calcdata;
	              var geoIds = fullLayout._subplots[GEO];
	              for (var i = 0; i < geoIds.length; i++) {
	                var geoId = geoIds[i];
	                var geoCalcData = getSubplotCalcData(calcData, GEO, geoId);
	                var geoLayout = fullLayout[geoId];
	                var geo = geoLayout._subplot;
	                if (!geo) {
	                  geo = createGeo({
	                    id: geoId,
	                    graphDiv: gd,
	                    container: fullLayout._geolayer.node(),
	                    topojsonURL: gd._context.topojsonURL,
	                    staticPlot: gd._context.staticPlot
	                  });
	                  fullLayout[geoId]._subplot = geo;
	                }
	                geo.plot(geoCalcData, fullLayout, gd._promises);
	              }
	            }
	            function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldGeoKeys = oldFullLayout._subplots[GEO] || [];
	              for (var i = 0; i < oldGeoKeys.length; i++) {
	                var oldGeoKey = oldGeoKeys[i];
	                var oldGeo = oldFullLayout[oldGeoKey]._subplot;
	                if (!newFullLayout[oldGeoKey] && !!oldGeo) {
	                  oldGeo.framework.remove();
	                  oldGeo.clipDef.remove();
	                }
	              }
	            }
	            function updateFx(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots[GEO];
	              for (var i = 0; i < subplotIds.length; i++) {
	                var subplotLayout = fullLayout[subplotIds[i]];
	                var subplotObj = subplotLayout._subplot;
	                subplotObj.updateFx(fullLayout, subplotLayout);
	              }
	            }
	            module2.exports = {
	              attr: GEO,
	              name: GEO,
	              idRoot: GEO,
	              idRegex: counter,
	              attrRegex: counter,
	              attributes,
	              layoutAttributes: __webpack_require__2(77519),
	              supplyLayoutDefaults: __webpack_require__2(82161),
	              plot: plotGeo,
	              updateFx,
	              clean
	            };
	          }
	        ),
	        /***/
	        77519: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorAttrs = __webpack_require__2(22399);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var dash = __webpack_require__2(79952).P;
	            var constants = __webpack_require__2(78776);
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var sortObjectKeys = __webpack_require__2(78607);
	            var geoAxesAttrs = {
	              range: {
	                valType: "info_array",
	                items: [{
	                  valType: "number"
	                }, {
	                  valType: "number"
	                }]
	              },
	              showgrid: {
	                valType: "boolean",
	                dflt: false
	              },
	              tick0: {
	                valType: "number",
	                dflt: 0
	              },
	              dtick: {
	                valType: "number"
	              },
	              gridcolor: {
	                valType: "color",
	                dflt: colorAttrs.lightLine
	              },
	              gridwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              griddash: dash
	            };
	            var attrs = module2.exports = overrideAll({
	              domain: domainAttrs({
	                name: "geo"
	              }, {}),
	              fitbounds: {
	                valType: "enumerated",
	                values: [false, "locations", "geojson"],
	                dflt: false,
	                editType: "plot"
	              },
	              resolution: {
	                valType: "enumerated",
	                values: [110, 50],
	                dflt: 110,
	                coerceNumber: true
	              },
	              scope: {
	                valType: "enumerated",
	                values: sortObjectKeys(constants.scopeDefaults),
	                dflt: "world"
	              },
	              projection: {
	                type: {
	                  valType: "enumerated",
	                  values: sortObjectKeys(constants.projNames)
	                },
	                rotation: {
	                  lon: {
	                    valType: "number"
	                  },
	                  lat: {
	                    valType: "number"
	                  },
	                  roll: {
	                    valType: "number"
	                  }
	                },
	                tilt: {
	                  valType: "number",
	                  dflt: 0
	                },
	                distance: {
	                  valType: "number",
	                  min: 1.001,
	                  dflt: 2
	                },
	                parallels: {
	                  valType: "info_array",
	                  items: [{
	                    valType: "number"
	                  }, {
	                    valType: "number"
	                  }]
	                },
	                scale: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 1
	                }
	              },
	              center: {
	                lon: {
	                  valType: "number"
	                },
	                lat: {
	                  valType: "number"
	                }
	              },
	              visible: {
	                valType: "boolean",
	                dflt: true
	              },
	              showcoastlines: {
	                valType: "boolean"
	              },
	              coastlinecolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine
	              },
	              coastlinewidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              showland: {
	                valType: "boolean",
	                dflt: false
	              },
	              landcolor: {
	                valType: "color",
	                dflt: constants.landColor
	              },
	              showocean: {
	                valType: "boolean",
	                dflt: false
	              },
	              oceancolor: {
	                valType: "color",
	                dflt: constants.waterColor
	              },
	              showlakes: {
	                valType: "boolean",
	                dflt: false
	              },
	              lakecolor: {
	                valType: "color",
	                dflt: constants.waterColor
	              },
	              showrivers: {
	                valType: "boolean",
	                dflt: false
	              },
	              rivercolor: {
	                valType: "color",
	                dflt: constants.waterColor
	              },
	              riverwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              showcountries: {
	                valType: "boolean"
	              },
	              countrycolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine
	              },
	              countrywidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              showsubunits: {
	                valType: "boolean"
	              },
	              subunitcolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine
	              },
	              subunitwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              showframe: {
	                valType: "boolean"
	              },
	              framecolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine
	              },
	              framewidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1
	              },
	              bgcolor: {
	                valType: "color",
	                dflt: colorAttrs.background
	              },
	              lonaxis: geoAxesAttrs,
	              lataxis: geoAxesAttrs
	            }, "plot", "from-root");
	            attrs.uirevision = {
	              valType: "any",
	              editType: "none"
	            };
	          }
	        ),
	        /***/
	        82161: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleSubplotDefaults = __webpack_require__2(49119);
	            var getSubplotData = __webpack_require__2(27659).NG;
	            var constants = __webpack_require__2(78776);
	            var layoutAttributes = __webpack_require__2(77519);
	            var axesNames = constants.axesNames;
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	                type: "geo",
	                attributes: layoutAttributes,
	                handleDefaults: handleGeoDefaults,
	                fullData,
	                partition: "y"
	              });
	            };
	            function handleGeoDefaults(geoLayoutIn, geoLayoutOut, coerce, opts) {
	              var subplotData = getSubplotData(opts.fullData, "geo", opts.id);
	              var traceIndices = subplotData.map(function(t) {
	                return t._expandedIndex;
	              });
	              var resolution = coerce("resolution");
	              var scope = coerce("scope");
	              var scopeParams = constants.scopeDefaults[scope];
	              var projType = coerce("projection.type", scopeParams.projType);
	              var isAlbersUsa = geoLayoutOut._isAlbersUsa = projType === "albers usa";
	              if (isAlbersUsa) scope = geoLayoutOut.scope = "usa";
	              var isScoped = geoLayoutOut._isScoped = scope !== "world";
	              var isSatellite = geoLayoutOut._isSatellite = projType === "satellite";
	              var isConic = geoLayoutOut._isConic = projType.indexOf("conic") !== -1 || projType === "albers";
	              var isClipped = geoLayoutOut._isClipped = !!constants.lonaxisSpan[projType];
	              if (geoLayoutIn.visible === false) {
	                var newTemplate = Lib.extendDeep({}, geoLayoutOut._template);
	                newTemplate.showcoastlines = false;
	                newTemplate.showcountries = false;
	                newTemplate.showframe = false;
	                newTemplate.showlakes = false;
	                newTemplate.showland = false;
	                newTemplate.showocean = false;
	                newTemplate.showrivers = false;
	                newTemplate.showsubunits = false;
	                if (newTemplate.lonaxis) newTemplate.lonaxis.showgrid = false;
	                if (newTemplate.lataxis) newTemplate.lataxis.showgrid = false;
	                geoLayoutOut._template = newTemplate;
	              }
	              var visible = coerce("visible");
	              var show;
	              for (var i = 0; i < axesNames.length; i++) {
	                var axisName = axesNames[i];
	                var dtickDflt = [30, 10][i];
	                var rangeDflt;
	                if (isScoped) {
	                  rangeDflt = scopeParams[axisName + "Range"];
	                } else {
	                  var dfltSpans = constants[axisName + "Span"];
	                  var hSpan = (dfltSpans[projType] || dfltSpans["*"]) / 2;
	                  var rot = coerce("projection.rotation." + axisName.substr(0, 3), scopeParams.projRotate[i]);
	                  rangeDflt = [rot - hSpan, rot + hSpan];
	                }
	                var range2 = coerce(axisName + ".range", rangeDflt);
	                coerce(axisName + ".tick0");
	                coerce(axisName + ".dtick", dtickDflt);
	                show = coerce(axisName + ".showgrid", !visible ? false : undefined);
	                if (show) {
	                  coerce(axisName + ".gridcolor");
	                  coerce(axisName + ".gridwidth");
	                  coerce(axisName + ".griddash");
	                }
	                geoLayoutOut[axisName]._ax = {
	                  type: "linear",
	                  _id: axisName.slice(0, 3),
	                  _traceIndices: traceIndices,
	                  setScale: Lib.identity,
	                  c2l: Lib.identity,
	                  r2l: Lib.identity,
	                  autorange: true,
	                  range: range2.slice(),
	                  _m: 1,
	                  _input: {}
	                };
	              }
	              var lonRange = geoLayoutOut.lonaxis.range;
	              var latRange = geoLayoutOut.lataxis.range;
	              var lon0 = lonRange[0];
	              var lon1 = lonRange[1];
	              if (lon0 > 0 && lon1 < 0) lon1 += 360;
	              var centerLon = (lon0 + lon1) / 2;
	              var projLon;
	              if (!isAlbersUsa) {
	                var dfltProjRotate = isScoped ? scopeParams.projRotate : [centerLon, 0, 0];
	                projLon = coerce("projection.rotation.lon", dfltProjRotate[0]);
	                coerce("projection.rotation.lat", dfltProjRotate[1]);
	                coerce("projection.rotation.roll", dfltProjRotate[2]);
	                show = coerce("showcoastlines", !isScoped && visible);
	                if (show) {
	                  coerce("coastlinecolor");
	                  coerce("coastlinewidth");
	                }
	                show = coerce("showocean", !visible ? false : undefined);
	                if (show) coerce("oceancolor");
	              }
	              var centerLonDflt;
	              var centerLatDflt;
	              if (isAlbersUsa) {
	                centerLonDflt = -96.6;
	                centerLatDflt = 38.7;
	              } else {
	                centerLonDflt = isScoped ? centerLon : projLon;
	                centerLatDflt = (latRange[0] + latRange[1]) / 2;
	              }
	              coerce("center.lon", centerLonDflt);
	              coerce("center.lat", centerLatDflt);
	              if (isSatellite) {
	                coerce("projection.tilt");
	                coerce("projection.distance");
	              }
	              if (isConic) {
	                var dfltProjParallels = scopeParams.projParallels || [0, 60];
	                coerce("projection.parallels", dfltProjParallels);
	              }
	              coerce("projection.scale");
	              show = coerce("showland", !visible ? false : undefined);
	              if (show) coerce("landcolor");
	              show = coerce("showlakes", !visible ? false : undefined);
	              if (show) coerce("lakecolor");
	              show = coerce("showrivers", !visible ? false : undefined);
	              if (show) {
	                coerce("rivercolor");
	                coerce("riverwidth");
	              }
	              show = coerce("showcountries", isScoped && scope !== "usa" && visible);
	              if (show) {
	                coerce("countrycolor");
	                coerce("countrywidth");
	              }
	              if (scope === "usa" || scope === "north america" && resolution === 50) {
	                coerce("showsubunits", visible);
	                coerce("subunitcolor");
	                coerce("subunitwidth");
	              }
	              if (!isScoped) {
	                show = coerce("showframe", visible);
	                if (show) {
	                  coerce("framecolor");
	                  coerce("framewidth");
	                }
	              }
	              coerce("bgcolor");
	              var fitBounds = coerce("fitbounds");
	              if (fitBounds) {
	                delete geoLayoutOut.projection.scale;
	                if (isScoped) {
	                  delete geoLayoutOut.center.lon;
	                  delete geoLayoutOut.center.lat;
	                } else if (isClipped) {
	                  delete geoLayoutOut.center.lon;
	                  delete geoLayoutOut.center.lat;
	                  delete geoLayoutOut.projection.rotation.lon;
	                  delete geoLayoutOut.projection.rotation.lat;
	                  delete geoLayoutOut.lonaxis.range;
	                  delete geoLayoutOut.lataxis.range;
	                } else {
	                  delete geoLayoutOut.center.lon;
	                  delete geoLayoutOut.center.lat;
	                  delete geoLayoutOut.projection.rotation.lon;
	                }
	              }
	            }
	          }
	        ),
	        /***/
	        74455: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var radians = Math.PI / 180;
	            var degrees = 180 / Math.PI;
	            var zoomstartStyle = {
	              cursor: "pointer"
	            };
	            var zoomendStyle = {
	              cursor: "auto"
	            };
	            function createGeoZoom(geo, geoLayout) {
	              var projection = geo.projection;
	              var zoomConstructor;
	              if (geoLayout._isScoped) {
	                zoomConstructor = zoomScoped;
	              } else if (geoLayout._isClipped) {
	                zoomConstructor = zoomClipped;
	              } else {
	                zoomConstructor = zoomNonClipped;
	              }
	              return zoomConstructor(geo, projection);
	            }
	            module2.exports = createGeoZoom;
	            function initZoom(geo, projection) {
	              return d3.behavior.zoom().translate(projection.translate()).scale(projection.scale());
	            }
	            function sync(geo, projection, cb) {
	              var id = geo.id;
	              var gd = geo.graphDiv;
	              var layout = gd.layout;
	              var userOpts = layout[id];
	              var fullLayout = gd._fullLayout;
	              var fullOpts = fullLayout[id];
	              var preGUI = {};
	              var eventData = {};
	              function set(propStr, val) {
	                preGUI[id + "." + propStr] = Lib.nestedProperty(userOpts, propStr).get();
	                Registry.call("_storeDirectGUIEdit", layout, fullLayout._preGUI, preGUI);
	                var fullNp = Lib.nestedProperty(fullOpts, propStr);
	                if (fullNp.get() !== val) {
	                  fullNp.set(val);
	                  Lib.nestedProperty(userOpts, propStr).set(val);
	                  eventData[id + "." + propStr] = val;
	                }
	              }
	              cb(set);
	              set("projection.scale", projection.scale() / geo.fitScale);
	              set("fitbounds", false);
	              gd.emit("plotly_relayout", eventData);
	            }
	            function zoomScoped(geo, projection) {
	              var zoom = initZoom(geo, projection);
	              function handleZoomstart() {
	                d3.select(this).style(zoomstartStyle);
	              }
	              function handleZoom() {
	                projection.scale(d3.event.scale).translate(d3.event.translate);
	                geo.render(true);
	                var center = projection.invert(geo.midPt);
	                geo.graphDiv.emit("plotly_relayouting", {
	                  "geo.projection.scale": projection.scale() / geo.fitScale,
	                  "geo.center.lon": center[0],
	                  "geo.center.lat": center[1]
	                });
	              }
	              function syncCb(set) {
	                var center = projection.invert(geo.midPt);
	                set("center.lon", center[0]);
	                set("center.lat", center[1]);
	              }
	              function handleZoomend() {
	                d3.select(this).style(zoomendStyle);
	                sync(geo, projection, syncCb);
	              }
	              zoom.on("zoomstart", handleZoomstart).on("zoom", handleZoom).on("zoomend", handleZoomend);
	              return zoom;
	            }
	            function zoomNonClipped(geo, projection) {
	              var zoom = initZoom(geo, projection);
	              var INSIDETOLORANCEPXS = 2;
	              var mouse0, rotate0, translate0, lastRotate, zoomPoint, mouse1, rotate1, point1, didZoom;
	              function position2(x) {
	                return projection.invert(x);
	              }
	              function outside(x) {
	                var pos = position2(x);
	                if (!pos) return true;
	                var pt = projection(pos);
	                return Math.abs(pt[0] - x[0]) > INSIDETOLORANCEPXS || Math.abs(pt[1] - x[1]) > INSIDETOLORANCEPXS;
	              }
	              function handleZoomstart() {
	                d3.select(this).style(zoomstartStyle);
	                mouse0 = d3.mouse(this);
	                rotate0 = projection.rotate();
	                translate0 = projection.translate();
	                lastRotate = rotate0;
	                zoomPoint = position2(mouse0);
	              }
	              function handleZoom() {
	                mouse1 = d3.mouse(this);
	                if (outside(mouse0)) {
	                  zoom.scale(projection.scale());
	                  zoom.translate(projection.translate());
	                  return;
	                }
	                projection.scale(d3.event.scale);
	                projection.translate([translate0[0], d3.event.translate[1]]);
	                if (!zoomPoint) {
	                  mouse0 = mouse1;
	                  zoomPoint = position2(mouse0);
	                } else if (position2(mouse1)) {
	                  point1 = position2(mouse1);
	                  rotate1 = [lastRotate[0] + (point1[0] - zoomPoint[0]), rotate0[1], rotate0[2]];
	                  projection.rotate(rotate1);
	                  lastRotate = rotate1;
	                }
	                didZoom = true;
	                geo.render(true);
	                var rotate = projection.rotate();
	                var center = projection.invert(geo.midPt);
	                geo.graphDiv.emit("plotly_relayouting", {
	                  "geo.projection.scale": projection.scale() / geo.fitScale,
	                  "geo.center.lon": center[0],
	                  "geo.center.lat": center[1],
	                  "geo.projection.rotation.lon": -rotate[0]
	                });
	              }
	              function handleZoomend() {
	                d3.select(this).style(zoomendStyle);
	                if (didZoom) sync(geo, projection, syncCb);
	              }
	              function syncCb(set) {
	                var rotate = projection.rotate();
	                var center = projection.invert(geo.midPt);
	                set("projection.rotation.lon", -rotate[0]);
	                set("center.lon", center[0]);
	                set("center.lat", center[1]);
	              }
	              zoom.on("zoomstart", handleZoomstart).on("zoom", handleZoom).on("zoomend", handleZoomend);
	              return zoom;
	            }
	            function zoomClipped(geo, projection) {
	              ({
	                r: projection.rotate(),
	                k: projection.scale()
	              });
	              var zoom = initZoom(geo, projection);
	              var event = d3eventDispatch(zoom, "zoomstart", "zoom", "zoomend");
	              var zooming = 0;
	              var zoomOn = zoom.on;
	              var zoomPoint;
	              zoom.on("zoomstart", function() {
	                d3.select(this).style(zoomstartStyle);
	                var mouse0 = d3.mouse(this);
	                var rotate0 = projection.rotate();
	                var lastRotate = rotate0;
	                var translate0 = projection.translate();
	                var q = quaternionFromEuler(rotate0);
	                zoomPoint = position(projection, mouse0);
	                zoomOn.call(zoom, "zoom", function() {
	                  var mouse1 = d3.mouse(this);
	                  projection.scale(d3.event.scale);
	                  if (!zoomPoint) {
	                    mouse0 = mouse1;
	                    zoomPoint = position(projection, mouse0);
	                  } else if (position(projection, mouse1)) {
	                    projection.rotate(rotate0).translate(translate0);
	                    var point1 = position(projection, mouse1);
	                    var between = rotateBetween(zoomPoint, point1);
	                    var newEuler = eulerFromQuaternion(multiply(q, between));
	                    var rotateAngles = unRoll(newEuler, zoomPoint, lastRotate);
	                    if (!isFinite(rotateAngles[0]) || !isFinite(rotateAngles[1]) || !isFinite(rotateAngles[2])) {
	                      rotateAngles = lastRotate;
	                    }
	                    projection.rotate(rotateAngles);
	                    lastRotate = rotateAngles;
	                  }
	                  zoomed(event.of(this, arguments));
	                });
	                zoomstarted(event.of(this, arguments));
	              }).on("zoomend", function() {
	                d3.select(this).style(zoomendStyle);
	                zoomOn.call(zoom, "zoom", null);
	                zoomended(event.of(this, arguments));
	                sync(geo, projection, syncCb);
	              }).on("zoom.redraw", function() {
	                geo.render(true);
	                var _rotate = projection.rotate();
	                geo.graphDiv.emit("plotly_relayouting", {
	                  "geo.projection.scale": projection.scale() / geo.fitScale,
	                  "geo.projection.rotation.lon": -_rotate[0],
	                  "geo.projection.rotation.lat": -_rotate[1]
	                });
	              });
	              function zoomstarted(dispatch) {
	                if (!zooming++) dispatch({
	                  type: "zoomstart"
	                });
	              }
	              function zoomed(dispatch) {
	                dispatch({
	                  type: "zoom"
	                });
	              }
	              function zoomended(dispatch) {
	                if (!--zooming) dispatch({
	                  type: "zoomend"
	                });
	              }
	              function syncCb(set) {
	                var _rotate = projection.rotate();
	                set("projection.rotation.lon", -_rotate[0]);
	                set("projection.rotation.lat", -_rotate[1]);
	              }
	              return d3.rebind(zoom, event, "on");
	            }
	            function position(projection, point) {
	              var spherical = projection.invert(point);
	              return spherical && isFinite(spherical[0]) && isFinite(spherical[1]) && cartesian(spherical);
	            }
	            function quaternionFromEuler(euler) {
	              var lambda = 0.5 * euler[0] * radians;
	              var phi = 0.5 * euler[1] * radians;
	              var gamma = 0.5 * euler[2] * radians;
	              var sinLambda = Math.sin(lambda);
	              var cosLambda = Math.cos(lambda);
	              var sinPhi = Math.sin(phi);
	              var cosPhi = Math.cos(phi);
	              var sinGamma = Math.sin(gamma);
	              var cosGamma = Math.cos(gamma);
	              return [cosLambda * cosPhi * cosGamma + sinLambda * sinPhi * sinGamma, sinLambda * cosPhi * cosGamma - cosLambda * sinPhi * sinGamma, cosLambda * sinPhi * cosGamma + sinLambda * cosPhi * sinGamma, cosLambda * cosPhi * sinGamma - sinLambda * sinPhi * cosGamma];
	            }
	            function multiply(a, b) {
	              var a0 = a[0];
	              var a1 = a[1];
	              var a2 = a[2];
	              var a3 = a[3];
	              var b0 = b[0];
	              var b1 = b[1];
	              var b2 = b[2];
	              var b3 = b[3];
	              return [a0 * b0 - a1 * b1 - a2 * b2 - a3 * b3, a0 * b1 + a1 * b0 + a2 * b3 - a3 * b2, a0 * b2 - a1 * b3 + a2 * b0 + a3 * b1, a0 * b3 + a1 * b2 - a2 * b1 + a3 * b0];
	            }
	            function rotateBetween(a, b) {
	              if (!a || !b) return;
	              var axis = cross(a, b);
	              var norm = Math.sqrt(dot(axis, axis));
	              var halfgamma = 0.5 * Math.acos(Math.max(-1, Math.min(1, dot(a, b))));
	              var k = Math.sin(halfgamma) / norm;
	              return norm && [Math.cos(halfgamma), axis[2] * k, -axis[1] * k, axis[0] * k];
	            }
	            function unRoll(rotateAngles, pt, lastRotate) {
	              var ptRotated = rotateCartesian(pt, 2, rotateAngles[0]);
	              ptRotated = rotateCartesian(ptRotated, 1, rotateAngles[1]);
	              ptRotated = rotateCartesian(ptRotated, 0, rotateAngles[2] - lastRotate[2]);
	              var x = pt[0];
	              var y = pt[1];
	              var z = pt[2];
	              var f = ptRotated[0];
	              var g = ptRotated[1];
	              var h = ptRotated[2];
	              var theta = Math.atan2(y, x) * degrees;
	              var a = Math.sqrt(x * x + y * y);
	              var b;
	              var newYaw1;
	              if (Math.abs(g) > a) {
	                newYaw1 = (g > 0 ? 90 : -90) - theta;
	                b = 0;
	              } else {
	                newYaw1 = Math.asin(g / a) * degrees - theta;
	                b = Math.sqrt(a * a - g * g);
	              }
	              var newYaw2 = 180 - newYaw1 - 2 * theta;
	              var newPitch1 = (Math.atan2(h, f) - Math.atan2(z, b)) * degrees;
	              var newPitch2 = (Math.atan2(h, f) - Math.atan2(z, -b)) * degrees;
	              var dist1 = angleDistance(lastRotate[0], lastRotate[1], newYaw1, newPitch1);
	              var dist2 = angleDistance(lastRotate[0], lastRotate[1], newYaw2, newPitch2);
	              if (dist1 <= dist2) return [newYaw1, newPitch1, lastRotate[2]];
	              else return [newYaw2, newPitch2, lastRotate[2]];
	            }
	            function angleDistance(yaw0, pitch0, yaw1, pitch1) {
	              var dYaw = angleMod(yaw1 - yaw0);
	              var dPitch = angleMod(pitch1 - pitch0);
	              return Math.sqrt(dYaw * dYaw + dPitch * dPitch);
	            }
	            function angleMod(angle) {
	              return (angle % 360 + 540) % 360 - 180;
	            }
	            function rotateCartesian(vector, axis, angle) {
	              var angleRads = angle * radians;
	              var vectorOut = vector.slice();
	              var ax1 = axis === 0 ? 1 : 0;
	              var ax2 = axis === 2 ? 1 : 2;
	              var cosa = Math.cos(angleRads);
	              var sina = Math.sin(angleRads);
	              vectorOut[ax1] = vector[ax1] * cosa - vector[ax2] * sina;
	              vectorOut[ax2] = vector[ax2] * cosa + vector[ax1] * sina;
	              return vectorOut;
	            }
	            function eulerFromQuaternion(q) {
	              return [Math.atan2(2 * (q[0] * q[1] + q[2] * q[3]), 1 - 2 * (q[1] * q[1] + q[2] * q[2])) * degrees, Math.asin(Math.max(-1, Math.min(1, 2 * (q[0] * q[2] - q[3] * q[1])))) * degrees, Math.atan2(2 * (q[0] * q[3] + q[1] * q[2]), 1 - 2 * (q[2] * q[2] + q[3] * q[3])) * degrees];
	            }
	            function cartesian(spherical) {
	              var lambda = spherical[0] * radians;
	              var phi = spherical[1] * radians;
	              var cosPhi = Math.cos(phi);
	              return [cosPhi * Math.cos(lambda), cosPhi * Math.sin(lambda), Math.sin(phi)];
	            }
	            function dot(a, b) {
	              var s = 0;
	              for (var i = 0, n = a.length; i < n; ++i) s += a[i] * b[i];
	              return s;
	            }
	            function cross(a, b) {
	              return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	            }
	            function d3eventDispatch(target) {
	              var i = 0;
	              var n = arguments.length;
	              var argumentz = [];
	              while (++i < n) argumentz.push(arguments[i]);
	              var dispatch = d3.dispatch.apply(null, argumentz);
	              dispatch.of = function(thiz, argumentz2) {
	                return function(e1) {
	                  var e0;
	                  try {
	                    e0 = e1.sourceEvent = d3.event;
	                    e1.target = target;
	                    d3.event = e1;
	                    dispatch[e1.type].apply(thiz, argumentz2);
	                  } finally {
	                    d3.event = e0;
	                  }
	                };
	              };
	              return dispatch;
	            }
	          }
	        ),
	        /***/
	        27659: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var SUBPLOT_PATTERN = __webpack_require__2(85555).SUBPLOT_PATTERN;
	            exports2.AU = function(calcData, type, subplotId) {
	              var basePlotModule = Registry.subplotsRegistry[type];
	              if (!basePlotModule) return [];
	              var attr = basePlotModule.attr;
	              var subplotCalcData = [];
	              for (var i = 0; i < calcData.length; i++) {
	                var calcTrace = calcData[i];
	                var trace = calcTrace[0].trace;
	                if (trace[attr] === subplotId) subplotCalcData.push(calcTrace);
	              }
	              return subplotCalcData;
	            };
	            exports2.a0 = function(calcdata, arg1) {
	              var moduleCalcData = [];
	              var remainingCalcData = [];
	              var plotMethod;
	              if (typeof arg1 === "string") {
	                plotMethod = Registry.getModule(arg1).plot;
	              } else if (typeof arg1 === "function") {
	                plotMethod = arg1;
	              } else {
	                plotMethod = arg1.plot;
	              }
	              if (!plotMethod) {
	                return [moduleCalcData, calcdata];
	              }
	              for (var i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                var trace = cd[0].trace;
	                if (trace.visible !== true || trace._length === 0) continue;
	                if (trace._module && trace._module.plot === plotMethod) {
	                  moduleCalcData.push(cd);
	                } else {
	                  remainingCalcData.push(cd);
	                }
	              }
	              return [moduleCalcData, remainingCalcData];
	            };
	            exports2.NG = function getSubplotData(data, type, subplotId) {
	              if (!Registry.subplotsRegistry[type]) return [];
	              var attr = Registry.subplotsRegistry[type].attr;
	              var subplotData = [];
	              var trace, subplotX, subplotY;
	              if (type === "gl2d") {
	                var spmatch = subplotId.match(SUBPLOT_PATTERN);
	                subplotX = "x" + spmatch[1];
	                subplotY = "y" + spmatch[2];
	              }
	              for (var i = 0; i < data.length; i++) {
	                trace = data[i];
	                if (type === "gl2d" && Registry.traceIs(trace, "gl2d")) {
	                  if (trace[attr[0]] === subplotX && trace[attr[1]] === subplotY) {
	                    subplotData.push(trace);
	                  }
	                } else {
	                  if (trace[attr] === subplotId) subplotData.push(trace);
	                }
	              }
	              return subplotData;
	            };
	          }
	        ),
	        /***/
	        75071: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var mouseChange = __webpack_require__2(16825);
	            var mouseWheel = __webpack_require__2(1195);
	            var mouseOffset = __webpack_require__2(48956);
	            var cartesianConstants = __webpack_require__2(85555);
	            var hasPassive = __webpack_require__2(38520);
	            module2.exports = createCamera;
	            function Camera2D(element, plot) {
	              this.element = element;
	              this.plot = plot;
	              this.mouseListener = null;
	              this.wheelListener = null;
	              this.lastInputTime = Date.now();
	              this.lastPos = [0, 0];
	              this.boxEnabled = false;
	              this.boxInited = false;
	              this.boxStart = [0, 0];
	              this.boxEnd = [0, 0];
	              this.dragStart = [0, 0];
	            }
	            function createCamera(scene) {
	              var element = scene.mouseContainer;
	              var plot = scene.glplot;
	              var result = new Camera2D(element, plot);
	              function unSetAutoRange() {
	                scene.xaxis.autorange = false;
	                scene.yaxis.autorange = false;
	              }
	              function getSubplotConstraint() {
	                var constraints = scene.graphDiv._fullLayout._axisConstraintGroups;
	                var xaId = scene.xaxis._id;
	                var yaId = scene.yaxis._id;
	                for (var i = 0; i < constraints.length; i++) {
	                  if (constraints[i][xaId] !== -1) {
	                    if (constraints[i][yaId] !== -1) return true;
	                    break;
	                  }
	                }
	                return false;
	              }
	              result.mouseListener = mouseChange(element, handleInteraction);
	              element.addEventListener("touchstart", function(ev) {
	                var xy = mouseOffset(ev.changedTouches[0], element);
	                handleInteraction(0, xy[0], xy[1]);
	                handleInteraction(1, xy[0], xy[1]);
	                ev.preventDefault();
	              }, hasPassive ? {
	                passive: false
	              } : false);
	              element.addEventListener("touchmove", function(ev) {
	                ev.preventDefault();
	                var xy = mouseOffset(ev.changedTouches[0], element);
	                handleInteraction(1, xy[0], xy[1]);
	                ev.preventDefault();
	              }, hasPassive ? {
	                passive: false
	              } : false);
	              element.addEventListener("touchend", function(ev) {
	                handleInteraction(0, result.lastPos[0], result.lastPos[1]);
	                ev.preventDefault();
	              }, hasPassive ? {
	                passive: false
	              } : false);
	              function handleInteraction(buttons, x, y) {
	                var dataBox = scene.calcDataBox();
	                var viewBox = plot.viewBox;
	                var lastX = result.lastPos[0];
	                var lastY = result.lastPos[1];
	                var MINDRAG = cartesianConstants.MINDRAG * plot.pixelRatio;
	                var MINZOOM = cartesianConstants.MINZOOM * plot.pixelRatio;
	                var dx, dy;
	                x *= plot.pixelRatio;
	                y *= plot.pixelRatio;
	                y = viewBox[3] - viewBox[1] - y;
	                function updateRange(i0, start, end) {
	                  var range0 = Math.min(start, end);
	                  var range1 = Math.max(start, end);
	                  if (range0 !== range1) {
	                    dataBox[i0] = range0;
	                    dataBox[i0 + 2] = range1;
	                    result.dataBox = dataBox;
	                    scene.setRanges(dataBox);
	                  } else {
	                    scene.selectBox.selectBox = [0, 0, 1, 1];
	                    scene.glplot.setDirty();
	                  }
	                }
	                switch (scene.fullLayout.dragmode) {
	                  case "zoom":
	                    if (buttons) {
	                      var dataX = x / (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) + dataBox[0];
	                      var dataY = y / (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) + dataBox[1];
	                      if (!result.boxInited) {
	                        result.boxStart[0] = dataX;
	                        result.boxStart[1] = dataY;
	                        result.dragStart[0] = x;
	                        result.dragStart[1] = y;
	                      }
	                      result.boxEnd[0] = dataX;
	                      result.boxEnd[1] = dataY;
	                      result.boxInited = true;
	                      if (!result.boxEnabled && (result.boxStart[0] !== result.boxEnd[0] || result.boxStart[1] !== result.boxEnd[1])) {
	                        result.boxEnabled = true;
	                      }
	                      var smallDx = Math.abs(result.dragStart[0] - x) < MINZOOM;
	                      var smallDy = Math.abs(result.dragStart[1] - y) < MINZOOM;
	                      if (getSubplotConstraint() && !(smallDx && smallDy)) {
	                        dx = result.boxEnd[0] - result.boxStart[0];
	                        dy = result.boxEnd[1] - result.boxStart[1];
	                        var dydx = (dataBox[3] - dataBox[1]) / (dataBox[2] - dataBox[0]);
	                        if (Math.abs(dx * dydx) > Math.abs(dy)) {
	                          result.boxEnd[1] = result.boxStart[1] + Math.abs(dx) * dydx * (dy >= 0 ? 1 : -1);
	                          if (result.boxEnd[1] < dataBox[1]) {
	                            result.boxEnd[1] = dataBox[1];
	                            result.boxEnd[0] = result.boxStart[0] + (dataBox[1] - result.boxStart[1]) / Math.abs(dydx);
	                          } else if (result.boxEnd[1] > dataBox[3]) {
	                            result.boxEnd[1] = dataBox[3];
	                            result.boxEnd[0] = result.boxStart[0] + (dataBox[3] - result.boxStart[1]) / Math.abs(dydx);
	                          }
	                        } else {
	                          result.boxEnd[0] = result.boxStart[0] + Math.abs(dy) / dydx * (dx >= 0 ? 1 : -1);
	                          if (result.boxEnd[0] < dataBox[0]) {
	                            result.boxEnd[0] = dataBox[0];
	                            result.boxEnd[1] = result.boxStart[1] + (dataBox[0] - result.boxStart[0]) * Math.abs(dydx);
	                          } else if (result.boxEnd[0] > dataBox[2]) {
	                            result.boxEnd[0] = dataBox[2];
	                            result.boxEnd[1] = result.boxStart[1] + (dataBox[2] - result.boxStart[0]) * Math.abs(dydx);
	                          }
	                        }
	                      } else {
	                        if (smallDx) result.boxEnd[0] = result.boxStart[0];
	                        if (smallDy) result.boxEnd[1] = result.boxStart[1];
	                      }
	                    } else if (result.boxEnabled) {
	                      dx = result.boxStart[0] !== result.boxEnd[0];
	                      dy = result.boxStart[1] !== result.boxEnd[1];
	                      if (dx || dy) {
	                        if (dx) {
	                          updateRange(0, result.boxStart[0], result.boxEnd[0]);
	                          scene.xaxis.autorange = false;
	                        }
	                        if (dy) {
	                          updateRange(1, result.boxStart[1], result.boxEnd[1]);
	                          scene.yaxis.autorange = false;
	                        }
	                        scene.relayoutCallback();
	                      } else {
	                        scene.glplot.setDirty();
	                      }
	                      result.boxEnabled = false;
	                      result.boxInited = false;
	                    } else if (result.boxInited) {
	                      result.boxInited = false;
	                    }
	                    break;
	                  case "pan":
	                    result.boxEnabled = false;
	                    result.boxInited = false;
	                    if (buttons) {
	                      if (!result.panning) {
	                        result.dragStart[0] = x;
	                        result.dragStart[1] = y;
	                      }
	                      if (Math.abs(result.dragStart[0] - x) < MINDRAG) x = result.dragStart[0];
	                      if (Math.abs(result.dragStart[1] - y) < MINDRAG) y = result.dragStart[1];
	                      dx = (lastX - x) * (dataBox[2] - dataBox[0]) / (plot.viewBox[2] - plot.viewBox[0]);
	                      dy = (lastY - y) * (dataBox[3] - dataBox[1]) / (plot.viewBox[3] - plot.viewBox[1]);
	                      dataBox[0] += dx;
	                      dataBox[2] += dx;
	                      dataBox[1] += dy;
	                      dataBox[3] += dy;
	                      scene.setRanges(dataBox);
	                      result.panning = true;
	                      result.lastInputTime = Date.now();
	                      unSetAutoRange();
	                      scene.cameraChanged();
	                      scene.handleAnnotations();
	                    } else if (result.panning) {
	                      result.panning = false;
	                      scene.relayoutCallback();
	                    }
	                    break;
	                }
	                result.lastPos[0] = x;
	                result.lastPos[1] = y;
	              }
	              result.wheelListener = mouseWheel(element, function(dx, dy) {
	                if (!scene.scrollZoom) return false;
	                var dataBox = scene.calcDataBox();
	                var viewBox = plot.viewBox;
	                var lastX = result.lastPos[0];
	                var lastY = result.lastPos[1];
	                var scale = Math.exp(5 * dy / (viewBox[3] - viewBox[1]));
	                var cx = lastX / (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) + dataBox[0];
	                var cy = lastY / (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) + dataBox[1];
	                dataBox[0] = (dataBox[0] - cx) * scale + cx;
	                dataBox[2] = (dataBox[2] - cx) * scale + cx;
	                dataBox[1] = (dataBox[1] - cy) * scale + cy;
	                dataBox[3] = (dataBox[3] - cy) * scale + cy;
	                scene.setRanges(dataBox);
	                result.lastInputTime = Date.now();
	                unSetAutoRange();
	                scene.cameraChanged();
	                scene.handleAnnotations();
	                scene.relayoutCallback();
	                return true;
	              }, true);
	              return result;
	            }
	          }
	        ),
	        /***/
	        82961: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var str2RGBArray = __webpack_require__2(78614);
	            function Axes2DOptions(scene) {
	              this.scene = scene;
	              this.gl = scene.gl;
	              this.pixelRatio = scene.pixelRatio;
	              this.screenBox = [0, 0, 1, 1];
	              this.viewBox = [0, 0, 1, 1];
	              this.dataBox = [-1, -1, 1, 1];
	              this.borderLineEnable = [false, false, false, false];
	              this.borderLineWidth = [1, 1, 1, 1];
	              this.borderLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.ticks = [[], []];
	              this.tickEnable = [true, true, false, false];
	              this.tickPad = [15, 15, 15, 15];
	              this.tickAngle = [0, 0, 0, 0];
	              this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.tickMarkLength = [0, 0, 0, 0];
	              this.tickMarkWidth = [0, 0, 0, 0];
	              this.tickMarkColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.labels = ["x", "y"];
	              this.labelEnable = [true, true, false, false];
	              this.labelAngle = [0, Math.PI / 2, 0, 3 * Math.PI / 2];
	              this.labelPad = [15, 15, 15, 15];
	              this.labelSize = [12, 12];
	              this.labelFont = ["sans-serif", "sans-serif"];
	              this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.title = "";
	              this.titleEnable = true;
	              this.titleCenter = [0, 0, 0, 0];
	              this.titleAngle = 0;
	              this.titleColor = [0, 0, 0, 1];
	              this.titleFont = "sans-serif";
	              this.titleSize = 18;
	              this.gridLineEnable = [true, true];
	              this.gridLineColor = [[0, 0, 0, 0.5], [0, 0, 0, 0.5]];
	              this.gridLineWidth = [1, 1];
	              this.zeroLineEnable = [true, true];
	              this.zeroLineWidth = [1, 1];
	              this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]];
	              this.borderColor = [0, 0, 0, 0];
	              this.backgroundColor = [0, 0, 0, 0];
	              this.static = this.scene.staticPlot;
	            }
	            var proto = Axes2DOptions.prototype;
	            var AXES = ["xaxis", "yaxis"];
	            proto.merge = function(options) {
	              this.titleEnable = false;
	              this.backgroundColor = str2RGBArray(options.plot_bgcolor);
	              var axisName, ax, axTitle, axMirror;
	              var hasAxisInDfltPos, hasAxisInAltrPos, hasSharedAxis, mirrorLines, mirrorTicks;
	              var i, j;
	              for (i = 0; i < 2; ++i) {
	                axisName = AXES[i];
	                var axisLetter = axisName.charAt(0);
	                ax = options[this.scene[axisName]._name];
	                axTitle = ax.title.text === this.scene.fullLayout._dfltTitle[axisLetter] ? "" : ax.title.text;
	                for (j = 0; j <= 2; j += 2) {
	                  this.labelEnable[i + j] = false;
	                  this.labels[i + j] = axTitle;
	                  this.labelColor[i + j] = str2RGBArray(ax.title.font.color);
	                  this.labelFont[i + j] = ax.title.font.family;
	                  this.labelSize[i + j] = ax.title.font.size;
	                  this.labelPad[i + j] = this.getLabelPad(axisName, ax);
	                  this.tickEnable[i + j] = false;
	                  this.tickColor[i + j] = str2RGBArray((ax.tickfont || {}).color);
	                  this.tickAngle[i + j] = ax.tickangle === "auto" ? 0 : Math.PI * -ax.tickangle / 180;
	                  this.tickPad[i + j] = this.getTickPad(ax);
	                  this.tickMarkLength[i + j] = 0;
	                  this.tickMarkWidth[i + j] = ax.tickwidth || 0;
	                  this.tickMarkColor[i + j] = str2RGBArray(ax.tickcolor);
	                  this.borderLineEnable[i + j] = false;
	                  this.borderLineColor[i + j] = str2RGBArray(ax.linecolor);
	                  this.borderLineWidth[i + j] = ax.linewidth || 0;
	                }
	                hasSharedAxis = this.hasSharedAxis(ax);
	                hasAxisInDfltPos = this.hasAxisInDfltPos(axisName, ax) && !hasSharedAxis;
	                hasAxisInAltrPos = this.hasAxisInAltrPos(axisName, ax) && !hasSharedAxis;
	                axMirror = ax.mirror || false;
	                mirrorLines = hasSharedAxis ? String(axMirror).indexOf("all") !== -1 : (
	                  // 'all' or 'allticks'
	                  !!axMirror
	                );
	                mirrorTicks = hasSharedAxis ? axMirror === "allticks" : String(axMirror).indexOf("ticks") !== -1;
	                if (hasAxisInDfltPos) this.labelEnable[i] = true;
	                else if (hasAxisInAltrPos) this.labelEnable[i + 2] = true;
	                if (hasAxisInDfltPos) this.tickEnable[i] = ax.showticklabels;
	                else if (hasAxisInAltrPos) this.tickEnable[i + 2] = ax.showticklabels;
	                if (hasAxisInDfltPos || mirrorLines) this.borderLineEnable[i] = ax.showline;
	                if (hasAxisInAltrPos || mirrorLines) this.borderLineEnable[i + 2] = ax.showline;
	                if (hasAxisInDfltPos || mirrorTicks) this.tickMarkLength[i] = this.getTickMarkLength(ax);
	                if (hasAxisInAltrPos || mirrorTicks) this.tickMarkLength[i + 2] = this.getTickMarkLength(ax);
	                this.gridLineEnable[i] = ax.showgrid;
	                this.gridLineColor[i] = str2RGBArray(ax.gridcolor);
	                this.gridLineWidth[i] = ax.gridwidth;
	                this.zeroLineEnable[i] = ax.zeroline;
	                this.zeroLineColor[i] = str2RGBArray(ax.zerolinecolor);
	                this.zeroLineWidth[i] = ax.zerolinewidth;
	              }
	            };
	            proto.hasSharedAxis = function(ax) {
	              var scene = this.scene;
	              var subplotIds = scene.fullLayout._subplots.gl2d;
	              var list = Axes.findSubplotsWithAxis(subplotIds, ax);
	              return list.indexOf(scene.id) !== 0;
	            };
	            proto.hasAxisInDfltPos = function(axisName, ax) {
	              var axSide = ax.side;
	              if (axisName === "xaxis") return axSide === "bottom";
	              else if (axisName === "yaxis") return axSide === "left";
	            };
	            proto.hasAxisInAltrPos = function(axisName, ax) {
	              var axSide = ax.side;
	              if (axisName === "xaxis") return axSide === "top";
	              else if (axisName === "yaxis") return axSide === "right";
	            };
	            proto.getLabelPad = function(axisName, ax) {
	              var offsetBase = 1.5;
	              var fontSize = ax.title.font.size;
	              var showticklabels = ax.showticklabels;
	              if (axisName === "xaxis") {
	                return ax.side === "top" ? -10 + fontSize * (offsetBase + (showticklabels ? 1 : 0)) : -10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
	              } else if (axisName === "yaxis") {
	                return ax.side === "right" ? 10 + fontSize * (offsetBase + (showticklabels ? 1 : 0.5)) : 10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
	              }
	            };
	            proto.getTickPad = function(ax) {
	              return ax.ticks === "outside" ? 10 + ax.ticklen : 15;
	            };
	            proto.getTickMarkLength = function(ax) {
	              if (!ax.ticks) return 0;
	              var ticklen = ax.ticklen;
	              return ax.ticks === "inside" ? -ticklen : ticklen;
	            };
	            function createAxes2D(scene) {
	              return new Axes2DOptions(scene);
	            }
	            module2.exports = createAxes2D;
	          }
	        ),
	        /***/
	        4796: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var Scene2D = __webpack_require__2(92918);
	            var layoutGlobalAttrs = __webpack_require__2(10820);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var constants = __webpack_require__2(85555);
	            var Cartesian = __webpack_require__2(93612);
	            var fxAttrs = __webpack_require__2(528);
	            var getSubplotData = __webpack_require__2(27659).NG;
	            exports2.name = "gl2d";
	            exports2.attr = ["xaxis", "yaxis"];
	            exports2.idRoot = ["x", "y"];
	            exports2.idRegex = constants.idRegex;
	            exports2.attrRegex = constants.attrRegex;
	            exports2.attributes = __webpack_require__2(89502);
	            exports2.supplyLayoutDefaults = function(layoutIn, layoutOut, fullData) {
	              if (!layoutOut._has("cartesian")) {
	                Cartesian.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	              }
	            };
	            exports2.layoutAttrOverrides = overrideAll(Cartesian.layoutAttributes, "plot", "from-root");
	            exports2.baseLayoutAttrOverrides = overrideAll({
	              plot_bgcolor: layoutGlobalAttrs.plot_bgcolor,
	              hoverlabel: fxAttrs.hoverlabel
	              // dragmode needs calc but only when transitioning TO lasso or select
	              // so for now it's left inside _relayout
	              // dragmode: fxAttrs.dragmode
	            }, "plot", "nested");
	            exports2.plot = function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var fullData = gd._fullData;
	              var subplotIds = fullLayout._subplots.gl2d;
	              for (var i = 0; i < subplotIds.length; i++) {
	                var subplotId = subplotIds[i];
	                var subplotObj = fullLayout._plots[subplotId];
	                var fullSubplotData = getSubplotData(fullData, "gl2d", subplotId);
	                var scene = subplotObj._scene2d;
	                if (scene === undefined) {
	                  scene = new Scene2D({
	                    id: subplotId,
	                    graphDiv: gd,
	                    container: gd.querySelector(".gl-container"),
	                    staticPlot: gd._context.staticPlot,
	                    plotGlPixelRatio: gd._context.plotGlPixelRatio
	                  }, fullLayout);
	                  subplotObj._scene2d = scene;
	                }
	                scene.plot(fullSubplotData, gd.calcdata, fullLayout, gd.layout);
	              }
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldSceneKeys = oldFullLayout._subplots.gl2d || [];
	              for (var i = 0; i < oldSceneKeys.length; i++) {
	                var id = oldSceneKeys[i];
	                var oldSubplot = oldFullLayout._plots[id];
	                if (!oldSubplot._scene2d) continue;
	                var subplotData = getSubplotData(newFullData, "gl2d", id);
	                if (subplotData.length === 0) {
	                  oldSubplot._scene2d.destroy();
	                  delete oldFullLayout._plots[id];
	                }
	              }
	              Cartesian.clean.apply(this, arguments);
	            };
	            exports2.drawFramework = function(gd) {
	              if (!gd._context.staticPlot) {
	                Cartesian.drawFramework(gd);
	              }
	            };
	            exports2.toSVG = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots.gl2d;
	              for (var i = 0; i < subplotIds.length; i++) {
	                var subplot = fullLayout._plots[subplotIds[i]];
	                var scene = subplot._scene2d;
	                var imageData = scene.toImage("png");
	                var image = fullLayout._glimages.append("svg:image");
	                image.attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  "xlink:href": imageData,
	                  x: 0,
	                  y: 0,
	                  width: "100%",
	                  height: "100%",
	                  preserveAspectRatio: "none"
	                });
	                scene.destroy();
	              }
	            };
	            exports2.updateFx = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots.gl2d;
	              for (var i = 0; i < subplotIds.length; i++) {
	                var subplotObj = fullLayout._plots[subplotIds[i]]._scene2d;
	                subplotObj.updateFx(fullLayout.dragmode);
	              }
	            };
	          }
	        ),
	        /***/
	        92918: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var Fx = __webpack_require__2(30211);
	            var createPlot2D = __webpack_require__2(9330).gl_plot2d;
	            var createSpikes = __webpack_require__2(9330).gl_spikes2d;
	            var createSelectBox = __webpack_require__2(9330).gl_select_box;
	            var getContext = __webpack_require__2(40372);
	            var createOptions = __webpack_require__2(82961);
	            var createCamera = __webpack_require__2(75071);
	            var showNoWebGlMsg = __webpack_require__2(58617);
	            var axisConstraints = __webpack_require__2(99082);
	            var enforceAxisConstraints = axisConstraints.enforce;
	            var cleanAxisConstraints = axisConstraints.clean;
	            var doAutoRange = __webpack_require__2(71739).doAutoRange;
	            var dragHelpers = __webpack_require__2(64505);
	            var drawMode = dragHelpers.drawMode;
	            var selectMode = dragHelpers.selectMode;
	            var AXES = ["xaxis", "yaxis"];
	            var STATIC_CANVAS, STATIC_CONTEXT;
	            var SUBPLOT_PATTERN = __webpack_require__2(85555).SUBPLOT_PATTERN;
	            function Scene2D(options, fullLayout) {
	              this.container = options.container;
	              this.graphDiv = options.graphDiv;
	              this.pixelRatio = options.plotGlPixelRatio || window.devicePixelRatio;
	              this.id = options.id;
	              this.staticPlot = !!options.staticPlot;
	              this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian;
	              this.fullData = null;
	              this.updateRefs(fullLayout);
	              this.makeFramework();
	              if (this.stopped) return;
	              this.glplotOptions = createOptions(this);
	              this.glplotOptions.merge(fullLayout);
	              this.glplot = createPlot2D(this.glplotOptions);
	              this.camera = createCamera(this);
	              this.traces = {};
	              this.spikes = createSpikes(this.glplot);
	              this.selectBox = createSelectBox(this.glplot, {
	                innerFill: false,
	                outerFill: true
	              });
	              this.lastButtonState = 0;
	              this.pickResult = null;
	              this.isMouseOver = true;
	              this.stopped = false;
	              this.redraw = this.draw.bind(this);
	              this.redraw();
	            }
	            module2.exports = Scene2D;
	            var proto = Scene2D.prototype;
	            proto.makeFramework = function() {
	              if (this.staticPlot) {
	                if (!STATIC_CONTEXT) {
	                  STATIC_CANVAS = document.createElement("canvas");
	                  STATIC_CONTEXT = getContext({
	                    canvas: STATIC_CANVAS,
	                    preserveDrawingBuffer: false,
	                    premultipliedAlpha: true,
	                    antialias: true
	                  });
	                  if (!STATIC_CONTEXT) {
	                    throw new Error("Error creating static canvas/context for image server");
	                  }
	                }
	                this.canvas = STATIC_CANVAS;
	                this.gl = STATIC_CONTEXT;
	              } else {
	                var liveCanvas = this.container.querySelector(".gl-canvas-focus");
	                var gl2 = getContext({
	                  canvas: liveCanvas,
	                  preserveDrawingBuffer: true,
	                  premultipliedAlpha: true
	                });
	                if (!gl2) {
	                  showNoWebGlMsg(this);
	                  this.stopped = true;
	                  return;
	                }
	                this.canvas = liveCanvas;
	                this.gl = gl2;
	              }
	              var canvas = this.canvas;
	              canvas.style.width = "100%";
	              canvas.style.height = "100%";
	              canvas.style.position = "absolute";
	              canvas.style.top = "0px";
	              canvas.style.left = "0px";
	              canvas.style["pointer-events"] = "none";
	              this.updateSize(canvas);
	              var svgContainer = this.svgContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	              svgContainer.style.position = "absolute";
	              svgContainer.style.top = svgContainer.style.left = "0px";
	              svgContainer.style.width = svgContainer.style.height = "100%";
	              svgContainer.style["z-index"] = 20;
	              svgContainer.style["pointer-events"] = "none";
	              var mouseContainer = this.mouseContainer = document.createElement("div");
	              mouseContainer.style.position = "absolute";
	              mouseContainer.style["pointer-events"] = "auto";
	              this.pickCanvas = this.container.querySelector(".gl-canvas-pick");
	              var container = this.container;
	              container.appendChild(svgContainer);
	              container.appendChild(mouseContainer);
	              var self2 = this;
	              mouseContainer.addEventListener("mouseout", function() {
	                self2.isMouseOver = false;
	                self2.unhover();
	              });
	              mouseContainer.addEventListener("mouseover", function() {
	                self2.isMouseOver = true;
	              });
	            };
	            proto.toImage = function(format) {
	              if (!format) format = "png";
	              this.stopped = true;
	              if (this.staticPlot) this.container.appendChild(STATIC_CANVAS);
	              this.updateSize(this.canvas);
	              var gl2 = this.glplot.gl;
	              var w = gl2.drawingBufferWidth;
	              var h = gl2.drawingBufferHeight;
	              gl2.clearColor(1, 1, 1, 0);
	              gl2.clear(gl2.COLOR_BUFFER_BIT | gl2.DEPTH_BUFFER_BIT);
	              this.glplot.setDirty();
	              this.glplot.draw();
	              gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	              var pixels = new Uint8Array(w * h * 4);
	              gl2.readPixels(0, 0, w, h, gl2.RGBA, gl2.UNSIGNED_BYTE, pixels);
	              for (var j = 0, k = h - 1; j < k; ++j, --k) {
	                for (var i = 0; i < w; ++i) {
	                  for (var l = 0; l < 4; ++l) {
	                    var tmp = pixels[4 * (w * j + i) + l];
	                    pixels[4 * (w * j + i) + l] = pixels[4 * (w * k + i) + l];
	                    pixels[4 * (w * k + i) + l] = tmp;
	                  }
	                }
	              }
	              var canvas = document.createElement("canvas");
	              canvas.width = w;
	              canvas.height = h;
	              var context = canvas.getContext("2d", {
	                willReadFrequently: true
	              });
	              var imageData = context.createImageData(w, h);
	              imageData.data.set(pixels);
	              context.putImageData(imageData, 0, 0);
	              var dataURL;
	              switch (format) {
	                case "jpeg":
	                  dataURL = canvas.toDataURL("image/jpeg");
	                  break;
	                case "webp":
	                  dataURL = canvas.toDataURL("image/webp");
	                  break;
	                default:
	                  dataURL = canvas.toDataURL("image/png");
	              }
	              if (this.staticPlot) this.container.removeChild(STATIC_CANVAS);
	              return dataURL;
	            };
	            proto.updateSize = function(canvas) {
	              if (!canvas) canvas = this.canvas;
	              var pixelRatio = this.pixelRatio;
	              var fullLayout = this.fullLayout;
	              var width = fullLayout.width;
	              var height = fullLayout.height;
	              var pixelWidth = Math.ceil(pixelRatio * width) | 0;
	              var pixelHeight = Math.ceil(pixelRatio * height) | 0;
	              if (canvas.width !== pixelWidth || canvas.height !== pixelHeight) {
	                canvas.width = pixelWidth;
	                canvas.height = pixelHeight;
	              }
	              return canvas;
	            };
	            proto.computeTickMarks = function() {
	              this.xaxis.setScale();
	              this.yaxis.setScale();
	              var nextTicks = [Axes.calcTicks(this.xaxis), Axes.calcTicks(this.yaxis)];
	              for (var j = 0; j < 2; ++j) {
	                for (var i = 0; i < nextTicks[j].length; ++i) {
	                  nextTicks[j][i].text = nextTicks[j][i].text + "";
	                }
	              }
	              return nextTicks;
	            };
	            function compareTicks(a, b) {
	              for (var i = 0; i < 2; ++i) {
	                var aticks = a[i];
	                var bticks = b[i];
	                if (aticks.length !== bticks.length) return true;
	                for (var j = 0; j < aticks.length; ++j) {
	                  if (aticks[j].x !== bticks[j].x) return true;
	                }
	              }
	              return false;
	            }
	            proto.updateRefs = function(newFullLayout) {
	              this.fullLayout = newFullLayout;
	              var spmatch = this.id.match(SUBPLOT_PATTERN);
	              var xaxisName = "xaxis" + spmatch[1];
	              var yaxisName = "yaxis" + spmatch[2];
	              this.xaxis = this.fullLayout[xaxisName];
	              this.yaxis = this.fullLayout[yaxisName];
	            };
	            proto.relayoutCallback = function() {
	              var graphDiv = this.graphDiv;
	              var xaxis = this.xaxis;
	              var yaxis = this.yaxis;
	              var layout = graphDiv.layout;
	              var update = {};
	              var xrange = update[xaxis._name + ".range"] = xaxis.range.slice();
	              var yrange = update[yaxis._name + ".range"] = yaxis.range.slice();
	              update[xaxis._name + ".autorange"] = xaxis.autorange;
	              update[yaxis._name + ".autorange"] = yaxis.autorange;
	              Registry.call("_storeDirectGUIEdit", graphDiv.layout, graphDiv._fullLayout._preGUI, update);
	              var xaIn = layout[xaxis._name];
	              xaIn.range = xrange;
	              xaIn.autorange = xaxis.autorange;
	              var yaIn = layout[yaxis._name];
	              yaIn.range = yrange;
	              yaIn.autorange = yaxis.autorange;
	              update.lastInputTime = this.camera.lastInputTime;
	              graphDiv.emit("plotly_relayout", update);
	            };
	            proto.cameraChanged = function() {
	              var camera = this.camera;
	              this.glplot.setDataBox(this.calcDataBox());
	              var nextTicks = this.computeTickMarks();
	              var curTicks = this.glplotOptions.ticks;
	              if (compareTicks(nextTicks, curTicks)) {
	                this.glplotOptions.ticks = nextTicks;
	                this.glplotOptions.dataBox = camera.dataBox;
	                this.glplot.update(this.glplotOptions);
	                this.handleAnnotations();
	              }
	            };
	            proto.handleAnnotations = function() {
	              var gd = this.graphDiv;
	              var annotations = this.fullLayout.annotations;
	              for (var i = 0; i < annotations.length; i++) {
	                var ann = annotations[i];
	                if (ann.xref === this.xaxis._id && ann.yref === this.yaxis._id) {
	                  Registry.getComponentMethod("annotations", "drawOne")(gd, i);
	                }
	              }
	            };
	            proto.destroy = function() {
	              if (!this.glplot) return;
	              var traces = this.traces;
	              if (traces) {
	                Object.keys(traces).map(function(key) {
	                  traces[key].dispose();
	                  delete traces[key];
	                });
	              }
	              this.glplot.dispose();
	              this.container.removeChild(this.svgContainer);
	              this.container.removeChild(this.mouseContainer);
	              this.fullData = null;
	              this.glplot = null;
	              this.stopped = true;
	              this.camera.mouseListener.enabled = false;
	              this.mouseContainer.removeEventListener("wheel", this.camera.wheelListener);
	              this.camera = null;
	            };
	            proto.plot = function(fullData, calcData, fullLayout) {
	              var glplot = this.glplot;
	              this.updateRefs(fullLayout);
	              this.xaxis.clearCalc();
	              this.yaxis.clearCalc();
	              this.updateTraces(fullData, calcData);
	              this.updateFx(fullLayout.dragmode);
	              var width = fullLayout.width;
	              var height = fullLayout.height;
	              this.updateSize(this.canvas);
	              var options = this.glplotOptions;
	              options.merge(fullLayout);
	              options.screenBox = [0, 0, width, height];
	              var mockGraphDiv = {
	                _fullLayout: {
	                  _axisConstraintGroups: fullLayout._axisConstraintGroups,
	                  xaxis: this.xaxis,
	                  yaxis: this.yaxis,
	                  _size: fullLayout._size
	                }
	              };
	              cleanAxisConstraints(mockGraphDiv, this.xaxis);
	              cleanAxisConstraints(mockGraphDiv, this.yaxis);
	              var size = fullLayout._size;
	              var domainX = this.xaxis.domain;
	              var domainY = this.yaxis.domain;
	              options.viewBox = [size.l + domainX[0] * size.w, size.b + domainY[0] * size.h, width - size.r - (1 - domainX[1]) * size.w, height - size.t - (1 - domainY[1]) * size.h];
	              this.mouseContainer.style.width = size.w * (domainX[1] - domainX[0]) + "px";
	              this.mouseContainer.style.height = size.h * (domainY[1] - domainY[0]) + "px";
	              this.mouseContainer.height = size.h * (domainY[1] - domainY[0]);
	              this.mouseContainer.style.left = size.l + domainX[0] * size.w + "px";
	              this.mouseContainer.style.top = size.t + (1 - domainY[1]) * size.h + "px";
	              var ax, i;
	              for (i = 0; i < 2; ++i) {
	                ax = this[AXES[i]];
	                ax._length = options.viewBox[i + 2] - options.viewBox[i];
	                doAutoRange(this.graphDiv, ax);
	                ax.setScale();
	              }
	              enforceAxisConstraints(mockGraphDiv);
	              options.ticks = this.computeTickMarks();
	              options.dataBox = this.calcDataBox();
	              options.merge(fullLayout);
	              glplot.update(options);
	              this.glplot.draw();
	            };
	            proto.calcDataBox = function() {
	              var xaxis = this.xaxis;
	              var yaxis = this.yaxis;
	              var xrange = xaxis.range;
	              var yrange = yaxis.range;
	              var xr2l = xaxis.r2l;
	              var yr2l = yaxis.r2l;
	              return [xr2l(xrange[0]), yr2l(yrange[0]), xr2l(xrange[1]), yr2l(yrange[1])];
	            };
	            proto.setRanges = function(dataBox) {
	              var xaxis = this.xaxis;
	              var yaxis = this.yaxis;
	              var xl2r = xaxis.l2r;
	              var yl2r = yaxis.l2r;
	              xaxis.range = [xl2r(dataBox[0]), xl2r(dataBox[2])];
	              yaxis.range = [yl2r(dataBox[1]), yl2r(dataBox[3])];
	            };
	            proto.updateTraces = function(fullData, calcData) {
	              var traceIds = Object.keys(this.traces);
	              var i, j, fullTrace;
	              this.fullData = fullData;
	              traceIdLoop: for (i = 0; i < traceIds.length; i++) {
	                var oldUid = traceIds[i];
	                var oldTrace = this.traces[oldUid];
	                for (j = 0; j < fullData.length; j++) {
	                  fullTrace = fullData[j];
	                  if (fullTrace.uid === oldUid && fullTrace.type === oldTrace.type) {
	                    continue traceIdLoop;
	                  }
	                }
	                oldTrace.dispose();
	                delete this.traces[oldUid];
	              }
	              for (i = 0; i < fullData.length; i++) {
	                fullTrace = fullData[i];
	                var calcTrace = calcData[i];
	                var traceObj = this.traces[fullTrace.uid];
	                if (traceObj) traceObj.update(fullTrace, calcTrace);
	                else {
	                  traceObj = fullTrace._module.plot(this, fullTrace, calcTrace);
	                  this.traces[fullTrace.uid] = traceObj;
	                }
	              }
	              this.glplot.objects.sort(function(a, b) {
	                return a._trace.index - b._trace.index;
	              });
	            };
	            proto.updateFx = function(dragmode) {
	              if (selectMode(dragmode) || drawMode(dragmode)) {
	                this.pickCanvas.style["pointer-events"] = "none";
	                this.mouseContainer.style["pointer-events"] = "none";
	              } else {
	                this.pickCanvas.style["pointer-events"] = "auto";
	                this.mouseContainer.style["pointer-events"] = "auto";
	              }
	              if (dragmode === "pan") {
	                this.mouseContainer.style.cursor = "move";
	              } else if (dragmode === "zoom") {
	                this.mouseContainer.style.cursor = "crosshair";
	              } else {
	                this.mouseContainer.style.cursor = null;
	              }
	            };
	            proto.emitPointAction = function(nextSelection, eventType) {
	              var uid = nextSelection.trace.uid;
	              var ptNumber = nextSelection.pointIndex;
	              var trace;
	              for (var i = 0; i < this.fullData.length; i++) {
	                if (this.fullData[i].uid === uid) {
	                  trace = this.fullData[i];
	                }
	              }
	              var pointData = {
	                x: nextSelection.traceCoord[0],
	                y: nextSelection.traceCoord[1],
	                curveNumber: trace.index,
	                pointNumber: ptNumber,
	                data: trace._input,
	                fullData: this.fullData,
	                xaxis: this.xaxis,
	                yaxis: this.yaxis
	              };
	              Fx.appendArrayPointValue(pointData, trace, ptNumber);
	              this.graphDiv.emit(eventType, {
	                points: [pointData]
	              });
	            };
	            proto.draw = function() {
	              if (this.stopped) return;
	              requestAnimationFrame(this.redraw);
	              var glplot = this.glplot;
	              var camera = this.camera;
	              var mouseListener = camera.mouseListener;
	              var mouseUp = this.lastButtonState === 1 && mouseListener.buttons === 0;
	              var fullLayout = this.fullLayout;
	              this.lastButtonState = mouseListener.buttons;
	              this.cameraChanged();
	              var x = mouseListener.x * glplot.pixelRatio;
	              var y = this.canvas.height - glplot.pixelRatio * mouseListener.y;
	              var result;
	              if (camera.boxEnabled && fullLayout.dragmode === "zoom") {
	                this.selectBox.enabled = true;
	                var selectBox = this.selectBox.selectBox = [Math.min(camera.boxStart[0], camera.boxEnd[0]), Math.min(camera.boxStart[1], camera.boxEnd[1]), Math.max(camera.boxStart[0], camera.boxEnd[0]), Math.max(camera.boxStart[1], camera.boxEnd[1])];
	                for (var i = 0; i < 2; i++) {
	                  if (camera.boxStart[i] === camera.boxEnd[i]) {
	                    selectBox[i] = glplot.dataBox[i];
	                    selectBox[i + 2] = glplot.dataBox[i + 2];
	                  }
	                }
	                glplot.setDirty();
	              } else if (!camera.panning && this.isMouseOver) {
	                this.selectBox.enabled = false;
	                var size = fullLayout._size;
	                var domainX = this.xaxis.domain;
	                var domainY = this.yaxis.domain;
	                result = glplot.pick(x / glplot.pixelRatio + size.l + domainX[0] * size.w, y / glplot.pixelRatio - (size.t + (1 - domainY[1]) * size.h));
	                var nextSelection = result && result.object._trace.handlePick(result);
	                if (nextSelection && mouseUp) {
	                  this.emitPointAction(nextSelection, "plotly_click");
	                }
	                if (result && result.object._trace.hoverinfo !== "skip" && fullLayout.hovermode) {
	                  if (nextSelection && (!this.lastPickResult || this.lastPickResult.traceUid !== nextSelection.trace.uid || this.lastPickResult.dataCoord[0] !== nextSelection.dataCoord[0] || this.lastPickResult.dataCoord[1] !== nextSelection.dataCoord[1])) {
	                    var selection = nextSelection;
	                    this.lastPickResult = {
	                      traceUid: nextSelection.trace ? nextSelection.trace.uid : null,
	                      dataCoord: nextSelection.dataCoord.slice()
	                    };
	                    this.spikes.update({
	                      center: result.dataCoord
	                    });
	                    selection.screenCoord = [((glplot.viewBox[2] - glplot.viewBox[0]) * (result.dataCoord[0] - glplot.dataBox[0]) / (glplot.dataBox[2] - glplot.dataBox[0]) + glplot.viewBox[0]) / glplot.pixelRatio, (this.canvas.height - (glplot.viewBox[3] - glplot.viewBox[1]) * (result.dataCoord[1] - glplot.dataBox[1]) / (glplot.dataBox[3] - glplot.dataBox[1]) - glplot.viewBox[1]) / glplot.pixelRatio];
	                    this.emitPointAction(nextSelection, "plotly_hover");
	                    var trace = this.fullData[selection.trace.index] || {};
	                    var ptNumber = selection.pointIndex;
	                    var hoverinfo = Fx.castHoverinfo(trace, fullLayout, ptNumber);
	                    if (hoverinfo && hoverinfo !== "all") {
	                      var parts = hoverinfo.split("+");
	                      if (parts.indexOf("x") === -1) selection.traceCoord[0] = undefined;
	                      if (parts.indexOf("y") === -1) selection.traceCoord[1] = undefined;
	                      if (parts.indexOf("z") === -1) selection.traceCoord[2] = undefined;
	                      if (parts.indexOf("text") === -1) selection.textLabel = undefined;
	                      if (parts.indexOf("name") === -1) selection.name = undefined;
	                    }
	                    Fx.loneHover({
	                      x: selection.screenCoord[0],
	                      y: selection.screenCoord[1],
	                      xLabel: this.hoverFormatter("xaxis", selection.traceCoord[0]),
	                      yLabel: this.hoverFormatter("yaxis", selection.traceCoord[1]),
	                      zLabel: selection.traceCoord[2],
	                      text: selection.textLabel,
	                      name: selection.name,
	                      color: Fx.castHoverOption(trace, ptNumber, "bgcolor") || selection.color,
	                      borderColor: Fx.castHoverOption(trace, ptNumber, "bordercolor"),
	                      fontFamily: Fx.castHoverOption(trace, ptNumber, "font.family"),
	                      fontSize: Fx.castHoverOption(trace, ptNumber, "font.size"),
	                      fontColor: Fx.castHoverOption(trace, ptNumber, "font.color"),
	                      nameLength: Fx.castHoverOption(trace, ptNumber, "namelength"),
	                      textAlign: Fx.castHoverOption(trace, ptNumber, "align")
	                    }, {
	                      container: this.svgContainer,
	                      gd: this.graphDiv
	                    });
	                  }
	                }
	              }
	              if (!result) {
	                this.unhover();
	              }
	              glplot.draw();
	            };
	            proto.unhover = function() {
	              if (this.lastPickResult) {
	                this.spikes.update({});
	                this.lastPickResult = null;
	                this.graphDiv.emit("plotly_unhover");
	                Fx.loneUnhover(this.svgContainer);
	              }
	            };
	            proto.hoverFormatter = function(axisName, val) {
	              if (val === undefined) return undefined;
	              var axis = this[axisName];
	              return Axes.tickText(axis, axis.c2l(val), "hover").text;
	            };
	          }
	        ),
	        /***/
	        58547: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var fxAttrs = __webpack_require__2(528);
	            var Scene = __webpack_require__2(33539);
	            var getSubplotData = __webpack_require__2(27659).NG;
	            var Lib = __webpack_require__2(71828);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var GL3D = "gl3d";
	            var SCENE = "scene";
	            exports2.name = GL3D;
	            exports2.attr = SCENE;
	            exports2.idRoot = SCENE;
	            exports2.idRegex = exports2.attrRegex = Lib.counterRegex("scene");
	            exports2.attributes = __webpack_require__2(59084);
	            exports2.layoutAttributes = __webpack_require__2(65500);
	            exports2.baseLayoutAttrOverrides = overrideAll({
	              hoverlabel: fxAttrs.hoverlabel
	            }, "plot", "nested");
	            exports2.supplyLayoutDefaults = __webpack_require__2(24682);
	            exports2.plot = function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var fullData = gd._fullData;
	              var sceneIds = fullLayout._subplots[GL3D];
	              for (var i = 0; i < sceneIds.length; i++) {
	                var sceneId = sceneIds[i];
	                var fullSceneData = getSubplotData(fullData, GL3D, sceneId);
	                var sceneLayout = fullLayout[sceneId];
	                var camera = sceneLayout.camera;
	                var scene = sceneLayout._scene;
	                if (!scene) {
	                  scene = new Scene({
	                    id: sceneId,
	                    graphDiv: gd,
	                    container: gd.querySelector(".gl-container"),
	                    staticPlot: gd._context.staticPlot,
	                    plotGlPixelRatio: gd._context.plotGlPixelRatio,
	                    camera
	                  }, fullLayout);
	                  sceneLayout._scene = scene;
	                }
	                if (!scene.viewInitial) {
	                  scene.viewInitial = {
	                    up: {
	                      x: camera.up.x,
	                      y: camera.up.y,
	                      z: camera.up.z
	                    },
	                    eye: {
	                      x: camera.eye.x,
	                      y: camera.eye.y,
	                      z: camera.eye.z
	                    },
	                    center: {
	                      x: camera.center.x,
	                      y: camera.center.y,
	                      z: camera.center.z
	                    }
	                  };
	                }
	                scene.plot(fullSceneData, fullLayout, gd.layout);
	              }
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldSceneKeys = oldFullLayout._subplots[GL3D] || [];
	              for (var i = 0; i < oldSceneKeys.length; i++) {
	                var oldSceneKey = oldSceneKeys[i];
	                if (!newFullLayout[oldSceneKey] && !!oldFullLayout[oldSceneKey]._scene) {
	                  oldFullLayout[oldSceneKey]._scene.destroy();
	                  if (oldFullLayout._infolayer) {
	                    oldFullLayout._infolayer.selectAll(".annotation-" + oldSceneKey).remove();
	                  }
	                }
	              }
	            };
	            exports2.toSVG = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var sceneIds = fullLayout._subplots[GL3D];
	              var size = fullLayout._size;
	              for (var i = 0; i < sceneIds.length; i++) {
	                var sceneLayout = fullLayout[sceneIds[i]];
	                var domain = sceneLayout.domain;
	                var scene = sceneLayout._scene;
	                var imageData = scene.toImage("png");
	                var image = fullLayout._glimages.append("svg:image");
	                image.attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  "xlink:href": imageData,
	                  x: size.l + size.w * domain.x[0],
	                  y: size.t + size.h * (1 - domain.y[1]),
	                  width: size.w * (domain.x[1] - domain.x[0]),
	                  height: size.h * (domain.y[1] - domain.y[0]),
	                  preserveAspectRatio: "none"
	                });
	                scene.destroy();
	              }
	            };
	            exports2.cleanId = function cleanId(id) {
	              if (!id.match(/^scene[0-9]*$/)) return;
	              var sceneNum = id.substr(5);
	              if (sceneNum === "1") sceneNum = "";
	              return SCENE + sceneNum;
	            };
	            exports2.updateFx = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots[GL3D];
	              for (var i = 0; i < subplotIds.length; i++) {
	                var subplotObj = fullLayout[subplotIds[i]]._scene;
	                subplotObj.updateFx(fullLayout.dragmode, fullLayout.hovermode);
	              }
	            };
	          }
	        ),
	        /***/
	        59084: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              scene: {
	                valType: "subplotid",
	                dflt: "scene",
	                editType: "calc+clearAxisTypes"
	              }
	            };
	          }
	        ),
	        /***/
	        77894: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var axesAttrs = __webpack_require__2(13838);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            module2.exports = overrideAll({
	              visible: axesAttrs.visible,
	              showspikes: {
	                valType: "boolean",
	                dflt: true
	              },
	              spikesides: {
	                valType: "boolean",
	                dflt: true
	              },
	              spikethickness: {
	                valType: "number",
	                min: 0,
	                dflt: 2
	              },
	              spikecolor: {
	                valType: "color",
	                dflt: Color.defaultLine
	              },
	              showbackground: {
	                valType: "boolean",
	                dflt: false
	              },
	              backgroundcolor: {
	                valType: "color",
	                dflt: "rgba(204, 204, 204, 0.5)"
	              },
	              showaxeslabels: {
	                valType: "boolean",
	                dflt: true
	              },
	              color: axesAttrs.color,
	              categoryorder: axesAttrs.categoryorder,
	              categoryarray: axesAttrs.categoryarray,
	              title: {
	                text: axesAttrs.title.text,
	                font: axesAttrs.title.font
	              },
	              type: extendFlat({}, axesAttrs.type, {
	                values: ["-", "linear", "log", "date", "category"]
	              }),
	              autotypenumbers: axesAttrs.autotypenumbers,
	              autorange: axesAttrs.autorange,
	              autorangeoptions: {
	                minallowed: axesAttrs.autorangeoptions.minallowed,
	                maxallowed: axesAttrs.autorangeoptions.maxallowed,
	                clipmin: axesAttrs.autorangeoptions.clipmin,
	                clipmax: axesAttrs.autorangeoptions.clipmax,
	                include: axesAttrs.autorangeoptions.include,
	                editType: "plot"
	              },
	              rangemode: axesAttrs.rangemode,
	              minallowed: axesAttrs.minallowed,
	              maxallowed: axesAttrs.maxallowed,
	              range: extendFlat({}, axesAttrs.range, {
	                items: [{
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autorange": false
	                  }
	                }, {
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autorange": false
	                  }
	                }],
	                anim: false
	              }),
	              // ticks
	              tickmode: axesAttrs.minor.tickmode,
	              nticks: axesAttrs.nticks,
	              tick0: axesAttrs.tick0,
	              dtick: axesAttrs.dtick,
	              tickvals: axesAttrs.tickvals,
	              ticktext: axesAttrs.ticktext,
	              ticks: axesAttrs.ticks,
	              mirror: axesAttrs.mirror,
	              ticklen: axesAttrs.ticklen,
	              tickwidth: axesAttrs.tickwidth,
	              tickcolor: axesAttrs.tickcolor,
	              showticklabels: axesAttrs.showticklabels,
	              labelalias: axesAttrs.labelalias,
	              tickfont: axesAttrs.tickfont,
	              tickangle: axesAttrs.tickangle,
	              tickprefix: axesAttrs.tickprefix,
	              showtickprefix: axesAttrs.showtickprefix,
	              ticksuffix: axesAttrs.ticksuffix,
	              showticksuffix: axesAttrs.showticksuffix,
	              showexponent: axesAttrs.showexponent,
	              exponentformat: axesAttrs.exponentformat,
	              minexponent: axesAttrs.minexponent,
	              separatethousands: axesAttrs.separatethousands,
	              tickformat: axesAttrs.tickformat,
	              tickformatstops: axesAttrs.tickformatstops,
	              hoverformat: axesAttrs.hoverformat,
	              // lines and grids
	              showline: axesAttrs.showline,
	              linecolor: axesAttrs.linecolor,
	              linewidth: axesAttrs.linewidth,
	              showgrid: axesAttrs.showgrid,
	              gridcolor: extendFlat(
	                {},
	                axesAttrs.gridcolor,
	                // shouldn't this be on-par with 2D?
	                {
	                  dflt: "rgb(204, 204, 204)"
	                }
	              ),
	              gridwidth: axesAttrs.gridwidth,
	              zeroline: axesAttrs.zeroline,
	              zerolinecolor: axesAttrs.zerolinecolor,
	              zerolinewidth: axesAttrs.zerolinewidth,
	              _deprecated: {
	                title: axesAttrs._deprecated.title,
	                titlefont: axesAttrs._deprecated.titlefont
	              }
	            }, "plot", "from-root");
	          }
	        ),
	        /***/
	        3277: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorMix = __webpack_require__2(84267).mix;
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var layoutAttributes = __webpack_require__2(77894);
	            var handleTypeDefaults = __webpack_require__2(951);
	            var handleAxisDefaults = __webpack_require__2(71453);
	            var axesNames = ["xaxis", "yaxis", "zaxis"];
	            var gridLightness = 100 * (204 - 68) / (255 - 68);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, options) {
	              var containerIn, containerOut;
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, layoutAttributes, attr, dflt);
	              }
	              for (var j = 0; j < axesNames.length; j++) {
	                var axName = axesNames[j];
	                containerIn = layoutIn[axName] || {};
	                containerOut = Template.newContainer(layoutOut, axName);
	                containerOut._id = axName[0] + options.scene;
	                containerOut._name = axName;
	                handleTypeDefaults(containerIn, containerOut, coerce, options);
	                handleAxisDefaults(containerIn, containerOut, coerce, {
	                  font: options.font,
	                  letter: axName[0],
	                  data: options.data,
	                  showGrid: true,
	                  noTickson: true,
	                  noTicklabelmode: true,
	                  noTicklabelstep: true,
	                  noTicklabelposition: true,
	                  noTicklabeloverflow: true,
	                  noInsiderange: true,
	                  bgColor: options.bgColor,
	                  calendar: options.calendar
	                }, options.fullLayout);
	                coerce("gridcolor", colorMix(containerOut.color, options.bgColor, gridLightness).toRgbString());
	                coerce("title.text", axName[0]);
	                containerOut.setScale = Lib.noop;
	                if (coerce("showspikes")) {
	                  coerce("spikesides");
	                  coerce("spikethickness");
	                  coerce("spikecolor", containerOut.color);
	                }
	                coerce("showaxeslabels");
	                if (coerce("showbackground")) coerce("backgroundcolor");
	              }
	            };
	          }
	        ),
	        /***/
	        30422: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2RgbaArray = __webpack_require__2(78614);
	            var Lib = __webpack_require__2(71828);
	            var AXES_NAMES = ["xaxis", "yaxis", "zaxis"];
	            function AxesOptions() {
	              this.bounds = [[-10, -10, -10], [10, 10, 10]];
	              this.ticks = [[], [], []];
	              this.tickEnable = [true, true, true];
	              this.tickFont = ["sans-serif", "sans-serif", "sans-serif"];
	              this.tickSize = [12, 12, 12];
	              this.tickAngle = [0, 0, 0];
	              this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.tickPad = [18, 18, 18];
	              this.labels = ["x", "y", "z"];
	              this.labelEnable = [true, true, true];
	              this.labelFont = ["Open Sans", "Open Sans", "Open Sans"];
	              this.labelSize = [20, 20, 20];
	              this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.labelPad = [30, 30, 30];
	              this.lineEnable = [true, true, true];
	              this.lineMirror = [false, false, false];
	              this.lineWidth = [1, 1, 1];
	              this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.lineTickEnable = [true, true, true];
	              this.lineTickMirror = [false, false, false];
	              this.lineTickLength = [10, 10, 10];
	              this.lineTickWidth = [1, 1, 1];
	              this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.gridEnable = [true, true, true];
	              this.gridWidth = [1, 1, 1];
	              this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.zeroEnable = [true, true, true];
	              this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.zeroLineWidth = [2, 2, 2];
	              this.backgroundEnable = [true, true, true];
	              this.backgroundColor = [[0.8, 0.8, 0.8, 0.5], [0.8, 0.8, 0.8, 0.5], [0.8, 0.8, 0.8, 0.5]];
	              this._defaultTickPad = this.tickPad.slice();
	              this._defaultLabelPad = this.labelPad.slice();
	              this._defaultLineTickLength = this.lineTickLength.slice();
	            }
	            var proto = AxesOptions.prototype;
	            proto.merge = function(fullLayout, sceneLayout) {
	              var opts = this;
	              for (var i = 0; i < 3; ++i) {
	                var axes = sceneLayout[AXES_NAMES[i]];
	                if (!axes.visible) {
	                  opts.tickEnable[i] = false;
	                  opts.labelEnable[i] = false;
	                  opts.lineEnable[i] = false;
	                  opts.lineTickEnable[i] = false;
	                  opts.gridEnable[i] = false;
	                  opts.zeroEnable[i] = false;
	                  opts.backgroundEnable[i] = false;
	                  continue;
	                }
	                opts.labels[i] = fullLayout._meta ? Lib.templateString(axes.title.text, fullLayout._meta) : axes.title.text;
	                if ("font" in axes.title) {
	                  if (axes.title.font.color) opts.labelColor[i] = str2RgbaArray(axes.title.font.color);
	                  if (axes.title.font.family) opts.labelFont[i] = axes.title.font.family;
	                  if (axes.title.font.size) opts.labelSize[i] = axes.title.font.size;
	                }
	                if ("showline" in axes) opts.lineEnable[i] = axes.showline;
	                if ("linecolor" in axes) opts.lineColor[i] = str2RgbaArray(axes.linecolor);
	                if ("linewidth" in axes) opts.lineWidth[i] = axes.linewidth;
	                if ("showgrid" in axes) opts.gridEnable[i] = axes.showgrid;
	                if ("gridcolor" in axes) opts.gridColor[i] = str2RgbaArray(axes.gridcolor);
	                if ("gridwidth" in axes) opts.gridWidth[i] = axes.gridwidth;
	                if (axes.type === "log") opts.zeroEnable[i] = false;
	                else if ("zeroline" in axes) opts.zeroEnable[i] = axes.zeroline;
	                if ("zerolinecolor" in axes) opts.zeroLineColor[i] = str2RgbaArray(axes.zerolinecolor);
	                if ("zerolinewidth" in axes) opts.zeroLineWidth[i] = axes.zerolinewidth;
	                if ("ticks" in axes && !!axes.ticks) opts.lineTickEnable[i] = true;
	                else opts.lineTickEnable[i] = false;
	                if ("ticklen" in axes) {
	                  opts.lineTickLength[i] = opts._defaultLineTickLength[i] = axes.ticklen;
	                }
	                if ("tickcolor" in axes) opts.lineTickColor[i] = str2RgbaArray(axes.tickcolor);
	                if ("tickwidth" in axes) opts.lineTickWidth[i] = axes.tickwidth;
	                if ("tickangle" in axes) {
	                  opts.tickAngle[i] = axes.tickangle === "auto" ? -3600 : (
	                    // i.e. special number to set auto option
	                    Math.PI * -axes.tickangle / 180
	                  );
	                }
	                if ("showticklabels" in axes) opts.tickEnable[i] = axes.showticklabels;
	                if ("tickfont" in axes) {
	                  if (axes.tickfont.color) opts.tickColor[i] = str2RgbaArray(axes.tickfont.color);
	                  if (axes.tickfont.family) opts.tickFont[i] = axes.tickfont.family;
	                  if (axes.tickfont.size) opts.tickSize[i] = axes.tickfont.size;
	                }
	                if ("mirror" in axes) {
	                  if (["ticks", "all", "allticks"].indexOf(axes.mirror) !== -1) {
	                    opts.lineTickMirror[i] = true;
	                    opts.lineMirror[i] = true;
	                  } else if (axes.mirror === true) {
	                    opts.lineTickMirror[i] = false;
	                    opts.lineMirror[i] = true;
	                  } else {
	                    opts.lineTickMirror[i] = false;
	                    opts.lineMirror[i] = false;
	                  }
	                } else opts.lineMirror[i] = false;
	                if ("showbackground" in axes && axes.showbackground !== false) {
	                  opts.backgroundEnable[i] = true;
	                  opts.backgroundColor[i] = str2RgbaArray(axes.backgroundcolor);
	                } else opts.backgroundEnable[i] = false;
	              }
	            };
	            function createAxesOptions(fullLayout, sceneLayout) {
	              var result = new AxesOptions();
	              result.merge(fullLayout, sceneLayout);
	              return result;
	            }
	            module2.exports = createAxesOptions;
	          }
	        ),
	        /***/
	        24682: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Registry = __webpack_require__2(73972);
	            var handleSubplotDefaults = __webpack_require__2(49119);
	            var supplyGl3dAxisLayoutDefaults = __webpack_require__2(3277);
	            var layoutAttributes = __webpack_require__2(65500);
	            var getSubplotData = __webpack_require__2(27659).NG;
	            var GL3D = "gl3d";
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              var hasNon3D = layoutOut._basePlotModules.length > 1;
	              function getDfltFromLayout(attr) {
	                if (hasNon3D) return;
	                var isValid = Lib.validate(layoutIn[attr], layoutAttributes[attr]);
	                if (isValid) return layoutIn[attr];
	              }
	              handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	                type: GL3D,
	                attributes: layoutAttributes,
	                handleDefaults: handleGl3dDefaults,
	                fullLayout: layoutOut,
	                font: layoutOut.font,
	                fullData,
	                getDfltFromLayout,
	                autotypenumbersDflt: layoutOut.autotypenumbers,
	                paper_bgcolor: layoutOut.paper_bgcolor,
	                calendar: layoutOut.calendar
	              });
	            };
	            function handleGl3dDefaults(sceneLayoutIn, sceneLayoutOut, coerce, opts) {
	              var bgcolor = coerce("bgcolor");
	              var bgColorCombined = Color.combine(bgcolor, opts.paper_bgcolor);
	              var cameraKeys = ["up", "center", "eye"];
	              for (var j = 0; j < cameraKeys.length; j++) {
	                coerce("camera." + cameraKeys[j] + ".x");
	                coerce("camera." + cameraKeys[j] + ".y");
	                coerce("camera." + cameraKeys[j] + ".z");
	              }
	              coerce("camera.projection.type");
	              var hasAspect = !!coerce("aspectratio.x") && !!coerce("aspectratio.y") && !!coerce("aspectratio.z");
	              var defaultAspectMode = hasAspect ? "manual" : "auto";
	              var aspectMode = coerce("aspectmode", defaultAspectMode);
	              if (!hasAspect) {
	                sceneLayoutIn.aspectratio = sceneLayoutOut.aspectratio = {
	                  x: 1,
	                  y: 1,
	                  z: 1
	                };
	                if (aspectMode === "manual") sceneLayoutOut.aspectmode = "auto";
	                sceneLayoutIn.aspectmode = sceneLayoutOut.aspectmode;
	              }
	              var fullGl3dData = getSubplotData(opts.fullData, GL3D, opts.id);
	              supplyGl3dAxisLayoutDefaults(sceneLayoutIn, sceneLayoutOut, {
	                font: opts.font,
	                scene: opts.id,
	                data: fullGl3dData,
	                bgColor: bgColorCombined,
	                calendar: opts.calendar,
	                autotypenumbersDflt: opts.autotypenumbersDflt,
	                fullLayout: opts.fullLayout
	              });
	              Registry.getComponentMethod("annotations3d", "handleDefaults")(sceneLayoutIn, sceneLayoutOut, opts);
	              var dragmode = opts.getDfltFromLayout("dragmode");
	              if (dragmode !== false) {
	                if (!dragmode) {
	                  dragmode = "orbit";
	                  if (sceneLayoutIn.camera && sceneLayoutIn.camera.up) {
	                    var x = sceneLayoutIn.camera.up.x;
	                    var y = sceneLayoutIn.camera.up.y;
	                    var z = sceneLayoutIn.camera.up.z;
	                    if (z !== 0) {
	                      if (!x || !y || !z) {
	                        dragmode = "turntable";
	                      } else if (z / Math.sqrt(x * x + y * y + z * z) > 0.999) {
	                        dragmode = "turntable";
	                      }
	                    }
	                  } else {
	                    dragmode = "turntable";
	                  }
	                }
	              }
	              coerce("dragmode", dragmode);
	              coerce("hovermode", opts.getDfltFromLayout("hovermode"));
	            }
	          }
	        ),
	        /***/
	        65500: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var gl3dAxisAttrs = __webpack_require__2(77894);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var counterRegex = __webpack_require__2(71828).counterRegex;
	            function makeCameraVector(x, y, z) {
	              return {
	                x: {
	                  valType: "number",
	                  dflt: x,
	                  editType: "camera"
	                },
	                y: {
	                  valType: "number",
	                  dflt: y,
	                  editType: "camera"
	                },
	                z: {
	                  valType: "number",
	                  dflt: z,
	                  editType: "camera"
	                },
	                editType: "camera"
	              };
	            }
	            module2.exports = {
	              _arrayAttrRegexps: [counterRegex("scene", ".annotations", true)],
	              bgcolor: {
	                valType: "color",
	                dflt: "rgba(0,0,0,0)",
	                editType: "plot"
	              },
	              camera: {
	                up: extendFlat(makeCameraVector(0, 0, 1), {}),
	                center: extendFlat(makeCameraVector(0, 0, 0), {}),
	                eye: extendFlat(makeCameraVector(1.25, 1.25, 1.25), {}),
	                projection: {
	                  type: {
	                    valType: "enumerated",
	                    values: ["perspective", "orthographic"],
	                    dflt: "perspective",
	                    editType: "calc"
	                  },
	                  editType: "calc"
	                },
	                editType: "camera"
	              },
	              domain: domainAttrs({
	                name: "scene",
	                editType: "plot"
	              }),
	              aspectmode: {
	                valType: "enumerated",
	                values: ["auto", "cube", "data", "manual"],
	                dflt: "auto",
	                editType: "plot",
	                impliedEdits: {
	                  "aspectratio.x": undefined,
	                  "aspectratio.y": undefined,
	                  "aspectratio.z": undefined
	                }
	              },
	              aspectratio: {
	                // must be positive (0's are coerced to 1)
	                x: {
	                  valType: "number",
	                  min: 0,
	                  editType: "plot",
	                  impliedEdits: {
	                    "^aspectmode": "manual"
	                  }
	                },
	                y: {
	                  valType: "number",
	                  min: 0,
	                  editType: "plot",
	                  impliedEdits: {
	                    "^aspectmode": "manual"
	                  }
	                },
	                z: {
	                  valType: "number",
	                  min: 0,
	                  editType: "plot",
	                  impliedEdits: {
	                    "^aspectmode": "manual"
	                  }
	                },
	                editType: "plot",
	                impliedEdits: {
	                  aspectmode: "manual"
	                }
	              },
	              xaxis: gl3dAxisAttrs,
	              yaxis: gl3dAxisAttrs,
	              zaxis: gl3dAxisAttrs,
	              dragmode: {
	                valType: "enumerated",
	                values: ["orbit", "turntable", "zoom", "pan", false],
	                editType: "plot"
	              },
	              hovermode: {
	                valType: "enumerated",
	                values: ["closest", false],
	                dflt: "closest",
	                editType: "modebar"
	              },
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              editType: "plot",
	              _deprecated: {
	                cameraposition: {
	                  valType: "info_array",
	                  editType: "camera"
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        13133: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2RGBArray = __webpack_require__2(78614);
	            var AXES_NAMES = ["xaxis", "yaxis", "zaxis"];
	            function SpikeOptions() {
	              this.enabled = [true, true, true];
	              this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	              this.drawSides = [true, true, true];
	              this.lineWidth = [1, 1, 1];
	            }
	            var proto = SpikeOptions.prototype;
	            proto.merge = function(sceneLayout) {
	              for (var i = 0; i < 3; ++i) {
	                var axes = sceneLayout[AXES_NAMES[i]];
	                if (!axes.visible) {
	                  this.enabled[i] = false;
	                  this.drawSides[i] = false;
	                  continue;
	                }
	                this.enabled[i] = axes.showspikes;
	                this.colors[i] = str2RGBArray(axes.spikecolor);
	                this.drawSides[i] = axes.spikesides;
	                this.lineWidth[i] = axes.spikethickness;
	              }
	            };
	            function createSpikeOptions(layout) {
	              var result = new SpikeOptions();
	              result.merge(layout);
	              return result;
	            }
	            module2.exports = createSpikeOptions;
	          }
	        ),
	        /***/
	        96085: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = computeTickMarks;
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var AXES_NAMES = ["xaxis", "yaxis", "zaxis"];
	            function contourLevelsFromTicks(ticks) {
	              var result = new Array(3);
	              for (var i = 0; i < 3; ++i) {
	                var tlevel = ticks[i];
	                var clevel = new Array(tlevel.length);
	                for (var j = 0; j < tlevel.length; ++j) {
	                  clevel[j] = tlevel[j].x;
	                }
	                result[i] = clevel;
	              }
	              return result;
	            }
	            function computeTickMarks(scene) {
	              var axesOptions = scene.axesOptions;
	              var glRange = scene.glplot.axesPixels;
	              var sceneLayout = scene.fullSceneLayout;
	              var ticks = [[], [], []];
	              for (var i = 0; i < 3; ++i) {
	                var axes = sceneLayout[AXES_NAMES[i]];
	                axes._length = (glRange[i].hi - glRange[i].lo) * glRange[i].pixelsPerDataUnit / scene.dataScale[i];
	                if (Math.abs(axes._length) === Infinity || isNaN(axes._length)) {
	                  ticks[i] = [];
	                } else {
	                  axes._input_range = axes.range.slice();
	                  axes.range[0] = glRange[i].lo / scene.dataScale[i];
	                  axes.range[1] = glRange[i].hi / scene.dataScale[i];
	                  axes._m = 1 / (scene.dataScale[i] * glRange[i].pixelsPerDataUnit);
	                  if (axes.range[0] === axes.range[1]) {
	                    axes.range[0] -= 1;
	                    axes.range[1] += 1;
	                  }
	                  var tickModeCached = axes.tickmode;
	                  if (axes.tickmode === "auto") {
	                    axes.tickmode = "linear";
	                    var nticks = axes.nticks || Lib.constrain(axes._length / 40, 4, 9);
	                    Axes.autoTicks(axes, Math.abs(axes.range[1] - axes.range[0]) / nticks);
	                  }
	                  var dataTicks = Axes.calcTicks(axes, {
	                    msUTC: true
	                  });
	                  for (var j = 0; j < dataTicks.length; ++j) {
	                    dataTicks[j].x = dataTicks[j].x * scene.dataScale[i];
	                    if (axes.type === "date") {
	                      dataTicks[j].text = dataTicks[j].text.replace(/\<br\>/g, " ");
	                    }
	                  }
	                  ticks[i] = dataTicks;
	                  axes.tickmode = tickModeCached;
	                }
	              }
	              axesOptions.ticks = ticks;
	              for (var i = 0; i < 3; ++i) {
	                0.5 * (scene.glplot.bounds[0][i] + scene.glplot.bounds[1][i]);
	                for (var j = 0; j < 2; ++j) {
	                  axesOptions.bounds[j][i] = scene.glplot.bounds[j][i];
	                }
	              }
	              scene.contourLevels = contourLevelsFromTicks(ticks);
	            }
	          }
	        ),
	        /***/
	        63538: (
	          /***/
	          function(module2) {
	            function xformMatrix(m, v) {
	              var out = [0, 0, 0, 0];
	              var i, j;
	              for (i = 0; i < 4; ++i) {
	                for (j = 0; j < 4; ++j) {
	                  out[j] += m[4 * i + j] * v[i];
	                }
	              }
	              return out;
	            }
	            function project(camera, v) {
	              var p = xformMatrix(camera.projection, xformMatrix(camera.view, xformMatrix(camera.model, [v[0], v[1], v[2], 1])));
	              return p;
	            }
	            module2.exports = project;
	          }
	        ),
	        /***/
	        33539: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var glPlot3d = __webpack_require__2(9330).gl_plot3d;
	            var createCamera = glPlot3d.createCamera;
	            var createPlot = glPlot3d.createScene;
	            var getContext = __webpack_require__2(40372);
	            var passiveSupported = __webpack_require__2(38520);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var preserveDrawingBuffer = Lib.preserveDrawingBuffer();
	            var Axes = __webpack_require__2(89298);
	            var Fx = __webpack_require__2(30211);
	            var str2RGBAarray = __webpack_require__2(78614);
	            var showNoWebGlMsg = __webpack_require__2(58617);
	            var project = __webpack_require__2(63538);
	            var createAxesOptions = __webpack_require__2(30422);
	            var createSpikeOptions = __webpack_require__2(13133);
	            var computeTickMarks = __webpack_require__2(96085);
	            var applyAutorangeOptions = __webpack_require__2(71739).applyAutorangeOptions;
	            var STATIC_CANVAS, STATIC_CONTEXT;
	            var tabletmode = false;
	            function Scene(options, fullLayout) {
	              var sceneContainer = document.createElement("div");
	              var plotContainer = options.container;
	              this.graphDiv = options.graphDiv;
	              var svgContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	              svgContainer.style.position = "absolute";
	              svgContainer.style.top = svgContainer.style.left = "0px";
	              svgContainer.style.width = svgContainer.style.height = "100%";
	              svgContainer.style["z-index"] = 20;
	              svgContainer.style["pointer-events"] = "none";
	              sceneContainer.appendChild(svgContainer);
	              this.svgContainer = svgContainer;
	              sceneContainer.id = options.id;
	              sceneContainer.style.position = "absolute";
	              sceneContainer.style.top = sceneContainer.style.left = "0px";
	              sceneContainer.style.width = sceneContainer.style.height = "100%";
	              plotContainer.appendChild(sceneContainer);
	              this.fullLayout = fullLayout;
	              this.id = options.id || "scene";
	              this.fullSceneLayout = fullLayout[this.id];
	              this.plotArgs = [[], {}, {}];
	              this.axesOptions = createAxesOptions(fullLayout, fullLayout[this.id]);
	              this.spikeOptions = createSpikeOptions(fullLayout[this.id]);
	              this.container = sceneContainer;
	              this.staticMode = !!options.staticPlot;
	              this.pixelRatio = this.pixelRatio || options.plotGlPixelRatio || 2;
	              this.dataScale = [1, 1, 1];
	              this.contourLevels = [[], [], []];
	              this.convertAnnotations = Registry.getComponentMethod("annotations3d", "convert");
	              this.drawAnnotations = Registry.getComponentMethod("annotations3d", "draw");
	              this.initializeGLPlot();
	            }
	            var proto = Scene.prototype;
	            proto.prepareOptions = function() {
	              var scene = this;
	              var opts = {
	                canvas: scene.canvas,
	                gl: scene.gl,
	                glOptions: {
	                  preserveDrawingBuffer,
	                  premultipliedAlpha: true,
	                  antialias: true
	                },
	                container: scene.container,
	                axes: scene.axesOptions,
	                spikes: scene.spikeOptions,
	                pickRadius: 10,
	                snapToData: true,
	                autoScale: true,
	                autoBounds: false,
	                cameraObject: scene.camera,
	                pixelRatio: scene.pixelRatio
	              };
	              if (scene.staticMode) {
	                if (!STATIC_CONTEXT) {
	                  STATIC_CANVAS = document.createElement("canvas");
	                  STATIC_CONTEXT = getContext({
	                    canvas: STATIC_CANVAS,
	                    preserveDrawingBuffer: true,
	                    premultipliedAlpha: true,
	                    antialias: true
	                  });
	                  if (!STATIC_CONTEXT) {
	                    throw new Error("error creating static canvas/context for image server");
	                  }
	                }
	                opts.gl = STATIC_CONTEXT;
	                opts.canvas = STATIC_CANVAS;
	              }
	              return opts;
	            };
	            var firstInit = true;
	            proto.tryCreatePlot = function() {
	              var scene = this;
	              var opts = scene.prepareOptions();
	              var success = true;
	              try {
	                scene.glplot = createPlot(opts);
	              } catch (e) {
	                if (scene.staticMode || !firstInit || preserveDrawingBuffer) {
	                  success = false;
	                } else {
	                  Lib.warn(["webgl setup failed possibly due to", "false preserveDrawingBuffer config.", "The mobile/tablet device may not be detected by is-mobile module.", "Enabling preserveDrawingBuffer in second attempt to create webgl scene..."].join(" "));
	                  try {
	                    preserveDrawingBuffer = opts.glOptions.preserveDrawingBuffer = true;
	                    scene.glplot = createPlot(opts);
	                  } catch (e2) {
	                    preserveDrawingBuffer = opts.glOptions.preserveDrawingBuffer = false;
	                    success = false;
	                  }
	                }
	              }
	              firstInit = false;
	              return success;
	            };
	            proto.initializeGLCamera = function() {
	              var scene = this;
	              var cameraData = scene.fullSceneLayout.camera;
	              var isOrtho = cameraData.projection.type === "orthographic";
	              scene.camera = createCamera(scene.container, {
	                center: [cameraData.center.x, cameraData.center.y, cameraData.center.z],
	                eye: [cameraData.eye.x, cameraData.eye.y, cameraData.eye.z],
	                up: [cameraData.up.x, cameraData.up.y, cameraData.up.z],
	                _ortho: isOrtho,
	                zoomMin: 0.01,
	                zoomMax: 100,
	                mode: "orbit"
	              });
	            };
	            proto.initializeGLPlot = function() {
	              var scene = this;
	              scene.initializeGLCamera();
	              var success = scene.tryCreatePlot();
	              if (!success) return showNoWebGlMsg(scene);
	              scene.traces = {};
	              scene.make4thDimension();
	              var gd = scene.graphDiv;
	              var layout = gd.layout;
	              var makeUpdate = function() {
	                var update = {};
	                if (scene.isCameraChanged(layout)) {
	                  update[scene.id + ".camera"] = scene.getCamera();
	                }
	                if (scene.isAspectChanged(layout)) {
	                  update[scene.id + ".aspectratio"] = scene.glplot.getAspectratio();
	                  if (layout[scene.id].aspectmode !== "manual") {
	                    scene.fullSceneLayout.aspectmode = layout[scene.id].aspectmode = update[scene.id + ".aspectmode"] = "manual";
	                  }
	                }
	                return update;
	              };
	              var relayoutCallback = function(scene2) {
	                if (scene2.fullSceneLayout.dragmode === false) return;
	                var update = makeUpdate();
	                scene2.saveLayout(layout);
	                scene2.graphDiv.emit("plotly_relayout", update);
	              };
	              if (scene.glplot.canvas) {
	                scene.glplot.canvas.addEventListener("mouseup", function() {
	                  relayoutCallback(scene);
	                });
	                scene.glplot.canvas.addEventListener("touchstart", function() {
	                  tabletmode = true;
	                });
	                scene.glplot.canvas.addEventListener("wheel", function(e) {
	                  if (gd._context._scrollZoom.gl3d) {
	                    if (scene.camera._ortho) {
	                      var s = e.deltaX > e.deltaY ? 1.1 : 1 / 1.1;
	                      var o = scene.glplot.getAspectratio();
	                      scene.glplot.setAspectratio({
	                        x: s * o.x,
	                        y: s * o.y,
	                        z: s * o.z
	                      });
	                    }
	                    relayoutCallback(scene);
	                  }
	                }, passiveSupported ? {
	                  passive: false
	                } : false);
	                scene.glplot.canvas.addEventListener("mousemove", function() {
	                  if (scene.fullSceneLayout.dragmode === false) return;
	                  if (scene.camera.mouseListener.buttons === 0) return;
	                  var update = makeUpdate();
	                  scene.graphDiv.emit("plotly_relayouting", update);
	                });
	                if (!scene.staticMode) {
	                  scene.glplot.canvas.addEventListener("webglcontextlost", function(event) {
	                    if (gd && gd.emit) {
	                      gd.emit("plotly_webglcontextlost", {
	                        event,
	                        layer: scene.id
	                      });
	                    }
	                  }, false);
	                }
	              }
	              scene.glplot.oncontextloss = function() {
	                scene.recoverContext();
	              };
	              scene.glplot.onrender = function() {
	                scene.render();
	              };
	              return true;
	            };
	            proto.render = function() {
	              var scene = this;
	              var gd = scene.graphDiv;
	              var trace;
	              var svgContainer = scene.svgContainer;
	              var clientRect = scene.container.getBoundingClientRect();
	              gd._fullLayout._calcInverseTransform(gd);
	              var scaleX = gd._fullLayout._invScaleX;
	              var scaleY = gd._fullLayout._invScaleY;
	              var width = clientRect.width * scaleX;
	              var height = clientRect.height * scaleY;
	              svgContainer.setAttributeNS(null, "viewBox", "0 0 " + width + " " + height);
	              svgContainer.setAttributeNS(null, "width", width);
	              svgContainer.setAttributeNS(null, "height", height);
	              computeTickMarks(scene);
	              scene.glplot.axes.update(scene.axesOptions);
	              var keys = Object.keys(scene.traces);
	              var lastPicked = null;
	              var selection = scene.glplot.selection;
	              for (var i = 0; i < keys.length; ++i) {
	                trace = scene.traces[keys[i]];
	                if (trace.data.hoverinfo !== "skip" && trace.handlePick(selection)) {
	                  lastPicked = trace;
	                }
	                if (trace.setContourLevels) trace.setContourLevels();
	              }
	              function formatter(axLetter, val, hoverformat) {
	                var ax = scene.fullSceneLayout[axLetter + "axis"];
	                if (ax.type !== "log") {
	                  val = ax.d2l(val);
	                }
	                return Axes.hoverLabelText(ax, val, hoverformat);
	              }
	              if (lastPicked !== null) {
	                var pdata = project(scene.glplot.cameraParams, selection.dataCoordinate);
	                trace = lastPicked.data;
	                var traceNow = gd._fullData[trace.index];
	                var ptNumber = selection.index;
	                var labels = {
	                  xLabel: formatter("x", selection.traceCoordinate[0], trace.xhoverformat),
	                  yLabel: formatter("y", selection.traceCoordinate[1], trace.yhoverformat),
	                  zLabel: formatter("z", selection.traceCoordinate[2], trace.zhoverformat)
	                };
	                var hoverinfo = Fx.castHoverinfo(traceNow, scene.fullLayout, ptNumber);
	                var hoverinfoParts = (hoverinfo || "").split("+");
	                var isHoverinfoAll = hoverinfo && hoverinfo === "all";
	                if (!traceNow.hovertemplate && !isHoverinfoAll) {
	                  if (hoverinfoParts.indexOf("x") === -1) labels.xLabel = undefined;
	                  if (hoverinfoParts.indexOf("y") === -1) labels.yLabel = undefined;
	                  if (hoverinfoParts.indexOf("z") === -1) labels.zLabel = undefined;
	                  if (hoverinfoParts.indexOf("text") === -1) selection.textLabel = undefined;
	                  if (hoverinfoParts.indexOf("name") === -1) lastPicked.name = undefined;
	                }
	                var tx;
	                var vectorTx = [];
	                if (trace.type === "cone" || trace.type === "streamtube") {
	                  labels.uLabel = formatter("x", selection.traceCoordinate[3], trace.uhoverformat);
	                  if (isHoverinfoAll || hoverinfoParts.indexOf("u") !== -1) {
	                    vectorTx.push("u: " + labels.uLabel);
	                  }
	                  labels.vLabel = formatter("y", selection.traceCoordinate[4], trace.vhoverformat);
	                  if (isHoverinfoAll || hoverinfoParts.indexOf("v") !== -1) {
	                    vectorTx.push("v: " + labels.vLabel);
	                  }
	                  labels.wLabel = formatter("z", selection.traceCoordinate[5], trace.whoverformat);
	                  if (isHoverinfoAll || hoverinfoParts.indexOf("w") !== -1) {
	                    vectorTx.push("w: " + labels.wLabel);
	                  }
	                  labels.normLabel = selection.traceCoordinate[6].toPrecision(3);
	                  if (isHoverinfoAll || hoverinfoParts.indexOf("norm") !== -1) {
	                    vectorTx.push("norm: " + labels.normLabel);
	                  }
	                  if (trace.type === "streamtube") {
	                    labels.divergenceLabel = selection.traceCoordinate[7].toPrecision(3);
	                    if (isHoverinfoAll || hoverinfoParts.indexOf("divergence") !== -1) {
	                      vectorTx.push("divergence: " + labels.divergenceLabel);
	                    }
	                  }
	                  if (selection.textLabel) {
	                    vectorTx.push(selection.textLabel);
	                  }
	                  tx = vectorTx.join("<br>");
	                } else if (trace.type === "isosurface" || trace.type === "volume") {
	                  labels.valueLabel = Axes.hoverLabelText(scene._mockAxis, scene._mockAxis.d2l(selection.traceCoordinate[3]), trace.valuehoverformat);
	                  vectorTx.push("value: " + labels.valueLabel);
	                  if (selection.textLabel) {
	                    vectorTx.push(selection.textLabel);
	                  }
	                  tx = vectorTx.join("<br>");
	                } else {
	                  tx = selection.textLabel;
	                }
	                var pointData = {
	                  x: selection.traceCoordinate[0],
	                  y: selection.traceCoordinate[1],
	                  z: selection.traceCoordinate[2],
	                  data: traceNow._input,
	                  fullData: traceNow,
	                  curveNumber: traceNow.index,
	                  pointNumber: ptNumber
	                };
	                Fx.appendArrayPointValue(pointData, traceNow, ptNumber);
	                if (trace._module.eventData) {
	                  pointData = traceNow._module.eventData(pointData, selection, traceNow, {}, ptNumber);
	                }
	                var eventData = {
	                  points: [pointData]
	                };
	                if (scene.fullSceneLayout.hovermode) {
	                  var bbox = [];
	                  Fx.loneHover({
	                    trace: traceNow,
	                    x: (0.5 + 0.5 * pdata[0] / pdata[3]) * width,
	                    y: (0.5 - 0.5 * pdata[1] / pdata[3]) * height,
	                    xLabel: labels.xLabel,
	                    yLabel: labels.yLabel,
	                    zLabel: labels.zLabel,
	                    text: tx,
	                    name: lastPicked.name,
	                    color: Fx.castHoverOption(traceNow, ptNumber, "bgcolor") || lastPicked.color,
	                    borderColor: Fx.castHoverOption(traceNow, ptNumber, "bordercolor"),
	                    fontFamily: Fx.castHoverOption(traceNow, ptNumber, "font.family"),
	                    fontSize: Fx.castHoverOption(traceNow, ptNumber, "font.size"),
	                    fontColor: Fx.castHoverOption(traceNow, ptNumber, "font.color"),
	                    nameLength: Fx.castHoverOption(traceNow, ptNumber, "namelength"),
	                    textAlign: Fx.castHoverOption(traceNow, ptNumber, "align"),
	                    hovertemplate: Lib.castOption(traceNow, ptNumber, "hovertemplate"),
	                    hovertemplateLabels: Lib.extendFlat({}, pointData, labels),
	                    eventData: [pointData]
	                  }, {
	                    container: svgContainer,
	                    gd,
	                    inOut_bbox: bbox
	                  });
	                  pointData.bbox = bbox[0];
	                }
	                if (selection.distance < 5 && (selection.buttons || tabletmode)) {
	                  gd.emit("plotly_click", eventData);
	                } else {
	                  gd.emit("plotly_hover", eventData);
	                }
	                this.oldEventData = eventData;
	              } else {
	                Fx.loneUnhover(svgContainer);
	                if (this.oldEventData) gd.emit("plotly_unhover", this.oldEventData);
	                this.oldEventData = undefined;
	              }
	              scene.drawAnnotations(scene);
	            };
	            proto.recoverContext = function() {
	              var scene = this;
	              scene.glplot.dispose();
	              var tryRecover = function() {
	                if (scene.glplot.gl.isContextLost()) {
	                  requestAnimationFrame(tryRecover);
	                  return;
	                }
	                if (!scene.initializeGLPlot()) {
	                  Lib.error("Catastrophic and unrecoverable WebGL error. Context lost.");
	                  return;
	                }
	                scene.plot.apply(scene, scene.plotArgs);
	              };
	              requestAnimationFrame(tryRecover);
	            };
	            var axisProperties = ["xaxis", "yaxis", "zaxis"];
	            function computeTraceBounds(scene, trace, bounds) {
	              var fullSceneLayout = scene.fullSceneLayout;
	              for (var d = 0; d < 3; d++) {
	                var axisName = axisProperties[d];
	                var axLetter = axisName.charAt(0);
	                var ax = fullSceneLayout[axisName];
	                var coords = trace[axLetter];
	                var calendar = trace[axLetter + "calendar"];
	                var len = trace["_" + axLetter + "length"];
	                if (!Lib.isArrayOrTypedArray(coords)) {
	                  bounds[0][d] = Math.min(bounds[0][d], 0);
	                  bounds[1][d] = Math.max(bounds[1][d], len - 1);
	                } else {
	                  var v;
	                  for (var i = 0; i < (len || coords.length); i++) {
	                    if (Lib.isArrayOrTypedArray(coords[i])) {
	                      for (var j = 0; j < coords[i].length; ++j) {
	                        v = ax.d2l(coords[i][j], 0, calendar);
	                        if (!isNaN(v) && isFinite(v)) {
	                          bounds[0][d] = Math.min(bounds[0][d], v);
	                          bounds[1][d] = Math.max(bounds[1][d], v);
	                        }
	                      }
	                    } else {
	                      v = ax.d2l(coords[i], 0, calendar);
	                      if (!isNaN(v) && isFinite(v)) {
	                        bounds[0][d] = Math.min(bounds[0][d], v);
	                        bounds[1][d] = Math.max(bounds[1][d], v);
	                      }
	                    }
	                  }
	                }
	              }
	            }
	            function computeAnnotationBounds(scene, bounds) {
	              var fullSceneLayout = scene.fullSceneLayout;
	              var annotations = fullSceneLayout.annotations || [];
	              for (var d = 0; d < 3; d++) {
	                var axisName = axisProperties[d];
	                var axLetter = axisName.charAt(0);
	                var ax = fullSceneLayout[axisName];
	                for (var j = 0; j < annotations.length; j++) {
	                  var ann = annotations[j];
	                  if (ann.visible) {
	                    var pos = ax.r2l(ann[axLetter]);
	                    if (!isNaN(pos) && isFinite(pos)) {
	                      bounds[0][d] = Math.min(bounds[0][d], pos);
	                      bounds[1][d] = Math.max(bounds[1][d], pos);
	                    }
	                  }
	                }
	              }
	            }
	            proto.plot = function(sceneData, fullLayout, layout) {
	              var scene = this;
	              scene.plotArgs = [sceneData, fullLayout, layout];
	              if (scene.glplot.contextLost) return;
	              var data, trace;
	              var i, j, axis, axisType;
	              var fullSceneLayout = fullLayout[scene.id];
	              var sceneLayout = layout[scene.id];
	              scene.fullLayout = fullLayout;
	              scene.fullSceneLayout = fullSceneLayout;
	              scene.axesOptions.merge(fullLayout, fullSceneLayout);
	              scene.spikeOptions.merge(fullSceneLayout);
	              scene.setViewport(fullSceneLayout);
	              scene.updateFx(fullSceneLayout.dragmode, fullSceneLayout.hovermode);
	              scene.camera.enableWheel = scene.graphDiv._context._scrollZoom.gl3d;
	              scene.glplot.setClearColor(str2RGBAarray(fullSceneLayout.bgcolor));
	              scene.setConvert(axis);
	              if (!sceneData) sceneData = [];
	              else if (!Array.isArray(sceneData)) sceneData = [sceneData];
	              var dataBounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	              for (i = 0; i < sceneData.length; ++i) {
	                data = sceneData[i];
	                if (data.visible !== true || data._length === 0) continue;
	                computeTraceBounds(this, data, dataBounds);
	              }
	              computeAnnotationBounds(this, dataBounds);
	              var dataScale = [1, 1, 1];
	              for (j = 0; j < 3; ++j) {
	                if (dataBounds[1][j] === dataBounds[0][j]) {
	                  dataScale[j] = 1;
	                } else {
	                  dataScale[j] = 1 / (dataBounds[1][j] - dataBounds[0][j]);
	                }
	              }
	              scene.dataScale = dataScale;
	              scene.convertAnnotations(this);
	              for (i = 0; i < sceneData.length; ++i) {
	                data = sceneData[i];
	                if (data.visible !== true || data._length === 0) {
	                  continue;
	                }
	                trace = scene.traces[data.uid];
	                if (trace) {
	                  if (trace.data.type === data.type) {
	                    trace.update(data);
	                  } else {
	                    trace.dispose();
	                    trace = data._module.plot(this, data);
	                    scene.traces[data.uid] = trace;
	                  }
	                } else {
	                  trace = data._module.plot(this, data);
	                  scene.traces[data.uid] = trace;
	                }
	                trace.name = data.name;
	              }
	              var traceIds = Object.keys(scene.traces);
	              traceIdLoop: for (i = 0; i < traceIds.length; ++i) {
	                for (j = 0; j < sceneData.length; ++j) {
	                  if (sceneData[j].uid === traceIds[i] && sceneData[j].visible === true && sceneData[j]._length !== 0) {
	                    continue traceIdLoop;
	                  }
	                }
	                trace = scene.traces[traceIds[i]];
	                trace.dispose();
	                delete scene.traces[traceIds[i]];
	              }
	              scene.glplot.objects.sort(function(a, b) {
	                return a._trace.data.index - b._trace.data.index;
	              });
	              var sceneBounds = [[0, 0, 0], [0, 0, 0]];
	              var axisTypeRatios = {};
	              for (i = 0; i < 3; ++i) {
	                axis = fullSceneLayout[axisProperties[i]];
	                axisType = axis.type;
	                if (axisType in axisTypeRatios) {
	                  axisTypeRatios[axisType].acc *= dataScale[i];
	                  axisTypeRatios[axisType].count += 1;
	                } else {
	                  axisTypeRatios[axisType] = {
	                    acc: dataScale[i],
	                    count: 1
	                  };
	                }
	                var range2;
	                if (axis.autorange) {
	                  sceneBounds[0][i] = Infinity;
	                  sceneBounds[1][i] = -Infinity;
	                  var objects = scene.glplot.objects;
	                  var annotations = scene.fullSceneLayout.annotations || [];
	                  var axLetter = axis._name.charAt(0);
	                  for (j = 0; j < objects.length; j++) {
	                    var obj = objects[j];
	                    var objBounds = obj.bounds;
	                    var pad = obj._trace.data._pad || 0;
	                    if (obj.constructor.name === "ErrorBars" && axis._lowerLogErrorBound) {
	                      sceneBounds[0][i] = Math.min(sceneBounds[0][i], axis._lowerLogErrorBound);
	                    } else {
	                      sceneBounds[0][i] = Math.min(sceneBounds[0][i], objBounds[0][i] / dataScale[i] - pad);
	                    }
	                    sceneBounds[1][i] = Math.max(sceneBounds[1][i], objBounds[1][i] / dataScale[i] + pad);
	                  }
	                  for (j = 0; j < annotations.length; j++) {
	                    var ann = annotations[j];
	                    if (ann.visible) {
	                      var pos = axis.r2l(ann[axLetter]);
	                      sceneBounds[0][i] = Math.min(sceneBounds[0][i], pos);
	                      sceneBounds[1][i] = Math.max(sceneBounds[1][i], pos);
	                    }
	                  }
	                  if ("rangemode" in axis && axis.rangemode === "tozero") {
	                    sceneBounds[0][i] = Math.min(sceneBounds[0][i], 0);
	                    sceneBounds[1][i] = Math.max(sceneBounds[1][i], 0);
	                  }
	                  if (sceneBounds[0][i] > sceneBounds[1][i]) {
	                    sceneBounds[0][i] = -1;
	                    sceneBounds[1][i] = 1;
	                  } else {
	                    var d = sceneBounds[1][i] - sceneBounds[0][i];
	                    sceneBounds[0][i] -= d / 32;
	                    sceneBounds[1][i] += d / 32;
	                  }
	                  range2 = [sceneBounds[0][i], sceneBounds[1][i]];
	                  range2 = applyAutorangeOptions(range2, axis);
	                  sceneBounds[0][i] = range2[0];
	                  sceneBounds[1][i] = range2[1];
	                  if (axis.isReversed()) {
	                    var tmp = sceneBounds[0][i];
	                    sceneBounds[0][i] = sceneBounds[1][i];
	                    sceneBounds[1][i] = tmp;
	                  }
	                } else {
	                  range2 = axis.range;
	                  sceneBounds[0][i] = axis.r2l(range2[0]);
	                  sceneBounds[1][i] = axis.r2l(range2[1]);
	                }
	                if (sceneBounds[0][i] === sceneBounds[1][i]) {
	                  sceneBounds[0][i] -= 1;
	                  sceneBounds[1][i] += 1;
	                }
	                axis.range = [sceneBounds[0][i], sceneBounds[1][i]];
	                axis.limitRange();
	                scene.glplot.setBounds(i, {
	                  min: axis.range[0] * dataScale[i],
	                  max: axis.range[1] * dataScale[i]
	                });
	              }
	              var aspectRatio;
	              var aspectmode = fullSceneLayout.aspectmode;
	              if (aspectmode === "cube") {
	                aspectRatio = [1, 1, 1];
	              } else if (aspectmode === "manual") {
	                var userRatio = fullSceneLayout.aspectratio;
	                aspectRatio = [userRatio.x, userRatio.y, userRatio.z];
	              } else if (aspectmode === "auto" || aspectmode === "data") {
	                var axesScaleRatio = [1, 1, 1];
	                for (i = 0; i < 3; ++i) {
	                  axis = fullSceneLayout[axisProperties[i]];
	                  axisType = axis.type;
	                  var axisRatio = axisTypeRatios[axisType];
	                  axesScaleRatio[i] = Math.pow(axisRatio.acc, 1 / axisRatio.count) / dataScale[i];
	                }
	                if (aspectmode === "data") {
	                  aspectRatio = axesScaleRatio;
	                } else {
	                  if (Math.max.apply(null, axesScaleRatio) / Math.min.apply(null, axesScaleRatio) <= 4) {
	                    aspectRatio = axesScaleRatio;
	                  } else {
	                    aspectRatio = [1, 1, 1];
	                  }
	                }
	              } else {
	                throw new Error("scene.js aspectRatio was not one of the enumerated types");
	              }
	              fullSceneLayout.aspectratio.x = sceneLayout.aspectratio.x = aspectRatio[0];
	              fullSceneLayout.aspectratio.y = sceneLayout.aspectratio.y = aspectRatio[1];
	              fullSceneLayout.aspectratio.z = sceneLayout.aspectratio.z = aspectRatio[2];
	              scene.glplot.setAspectratio(fullSceneLayout.aspectratio);
	              if (!scene.viewInitial.aspectratio) {
	                scene.viewInitial.aspectratio = {
	                  x: fullSceneLayout.aspectratio.x,
	                  y: fullSceneLayout.aspectratio.y,
	                  z: fullSceneLayout.aspectratio.z
	                };
	              }
	              if (!scene.viewInitial.aspectmode) {
	                scene.viewInitial.aspectmode = fullSceneLayout.aspectmode;
	              }
	              var domain = fullSceneLayout.domain || null;
	              var size = fullLayout._size || null;
	              if (domain && size) {
	                var containerStyle = scene.container.style;
	                containerStyle.position = "absolute";
	                containerStyle.left = size.l + domain.x[0] * size.w + "px";
	                containerStyle.top = size.t + (1 - domain.y[1]) * size.h + "px";
	                containerStyle.width = size.w * (domain.x[1] - domain.x[0]) + "px";
	                containerStyle.height = size.h * (domain.y[1] - domain.y[0]) + "px";
	              }
	              scene.glplot.redraw();
	            };
	            proto.destroy = function() {
	              var scene = this;
	              if (!scene.glplot) return;
	              scene.camera.mouseListener.enabled = false;
	              scene.container.removeEventListener("wheel", scene.camera.wheelListener);
	              scene.camera = null;
	              scene.glplot.dispose();
	              scene.container.parentNode.removeChild(scene.container);
	              scene.glplot = null;
	            };
	            function getCameraArrays(camera) {
	              return [[camera.eye.x, camera.eye.y, camera.eye.z], [camera.center.x, camera.center.y, camera.center.z], [camera.up.x, camera.up.y, camera.up.z]];
	            }
	            function getLayoutCamera(camera) {
	              return {
	                up: {
	                  x: camera.up[0],
	                  y: camera.up[1],
	                  z: camera.up[2]
	                },
	                center: {
	                  x: camera.center[0],
	                  y: camera.center[1],
	                  z: camera.center[2]
	                },
	                eye: {
	                  x: camera.eye[0],
	                  y: camera.eye[1],
	                  z: camera.eye[2]
	                },
	                projection: {
	                  type: camera._ortho === true ? "orthographic" : "perspective"
	                }
	              };
	            }
	            proto.getCamera = function() {
	              var scene = this;
	              scene.camera.view.recalcMatrix(scene.camera.view.lastT());
	              return getLayoutCamera(scene.camera);
	            };
	            proto.setViewport = function(sceneLayout) {
	              var scene = this;
	              var cameraData = sceneLayout.camera;
	              scene.camera.lookAt.apply(this, getCameraArrays(cameraData));
	              scene.glplot.setAspectratio(sceneLayout.aspectratio);
	              var newOrtho = cameraData.projection.type === "orthographic";
	              var oldOrtho = scene.camera._ortho;
	              if (newOrtho !== oldOrtho) {
	                scene.glplot.redraw();
	                scene.glplot.clearRGBA();
	                scene.glplot.dispose();
	                scene.initializeGLPlot();
	              }
	            };
	            proto.isCameraChanged = function(layout) {
	              var scene = this;
	              var cameraData = scene.getCamera();
	              var cameraNestedProp = Lib.nestedProperty(layout, scene.id + ".camera");
	              var cameraDataLastSave = cameraNestedProp.get();
	              function same(x, y, i2, j2) {
	                var vectors = ["up", "center", "eye"];
	                var components = ["x", "y", "z"];
	                return y[vectors[i2]] && x[vectors[i2]][components[j2]] === y[vectors[i2]][components[j2]];
	              }
	              var changed = false;
	              if (cameraDataLastSave === undefined) {
	                changed = true;
	              } else {
	                for (var i = 0; i < 3; i++) {
	                  for (var j = 0; j < 3; j++) {
	                    if (!same(cameraData, cameraDataLastSave, i, j)) {
	                      changed = true;
	                      break;
	                    }
	                  }
	                }
	                if (!cameraDataLastSave.projection || cameraData.projection && cameraData.projection.type !== cameraDataLastSave.projection.type) {
	                  changed = true;
	                }
	              }
	              return changed;
	            };
	            proto.isAspectChanged = function(layout) {
	              var scene = this;
	              var aspectData = scene.glplot.getAspectratio();
	              var aspectNestedProp = Lib.nestedProperty(layout, scene.id + ".aspectratio");
	              var aspectDataLastSave = aspectNestedProp.get();
	              return aspectDataLastSave === undefined || aspectDataLastSave.x !== aspectData.x || aspectDataLastSave.y !== aspectData.y || aspectDataLastSave.z !== aspectData.z;
	            };
	            proto.saveLayout = function(layout) {
	              var scene = this;
	              var fullLayout = scene.fullLayout;
	              var cameraData;
	              var cameraNestedProp;
	              var cameraDataLastSave;
	              var aspectData;
	              var aspectNestedProp;
	              var aspectDataLastSave;
	              var cameraChanged = scene.isCameraChanged(layout);
	              var aspectChanged = scene.isAspectChanged(layout);
	              var hasChanged = cameraChanged || aspectChanged;
	              if (hasChanged) {
	                var preGUI = {};
	                if (cameraChanged) {
	                  cameraData = scene.getCamera();
	                  cameraNestedProp = Lib.nestedProperty(layout, scene.id + ".camera");
	                  cameraDataLastSave = cameraNestedProp.get();
	                  preGUI[scene.id + ".camera"] = cameraDataLastSave;
	                }
	                if (aspectChanged) {
	                  aspectData = scene.glplot.getAspectratio();
	                  aspectNestedProp = Lib.nestedProperty(layout, scene.id + ".aspectratio");
	                  aspectDataLastSave = aspectNestedProp.get();
	                  preGUI[scene.id + ".aspectratio"] = aspectDataLastSave;
	                }
	                Registry.call("_storeDirectGUIEdit", layout, fullLayout._preGUI, preGUI);
	                if (cameraChanged) {
	                  cameraNestedProp.set(cameraData);
	                  var cameraFullNP = Lib.nestedProperty(fullLayout, scene.id + ".camera");
	                  cameraFullNP.set(cameraData);
	                }
	                if (aspectChanged) {
	                  aspectNestedProp.set(aspectData);
	                  var aspectFullNP = Lib.nestedProperty(fullLayout, scene.id + ".aspectratio");
	                  aspectFullNP.set(aspectData);
	                  scene.glplot.redraw();
	                }
	              }
	              return hasChanged;
	            };
	            proto.updateFx = function(dragmode, hovermode) {
	              var scene = this;
	              var camera = scene.camera;
	              if (camera) {
	                if (dragmode === "orbit") {
	                  camera.mode = "orbit";
	                  camera.keyBindingMode = "rotate";
	                } else if (dragmode === "turntable") {
	                  camera.up = [0, 0, 1];
	                  camera.mode = "turntable";
	                  camera.keyBindingMode = "rotate";
	                  var gd = scene.graphDiv;
	                  var fullLayout = gd._fullLayout;
	                  var fullCamera = scene.fullSceneLayout.camera;
	                  var x = fullCamera.up.x;
	                  var y = fullCamera.up.y;
	                  var z = fullCamera.up.z;
	                  if (z / Math.sqrt(x * x + y * y + z * z) < 0.999) {
	                    var attr = scene.id + ".camera.up";
	                    var zUp = {
	                      x: 0,
	                      y: 0,
	                      z: 1
	                    };
	                    var edits = {};
	                    edits[attr] = zUp;
	                    var layout = gd.layout;
	                    Registry.call("_storeDirectGUIEdit", layout, fullLayout._preGUI, edits);
	                    fullCamera.up = zUp;
	                    Lib.nestedProperty(layout, attr).set(zUp);
	                  }
	                } else {
	                  camera.keyBindingMode = dragmode;
	                }
	              }
	              scene.fullSceneLayout.hovermode = hovermode;
	            };
	            function flipPixels(pixels, w, h) {
	              for (var i = 0, q = h - 1; i < q; ++i, --q) {
	                for (var j = 0; j < w; ++j) {
	                  for (var k = 0; k < 4; ++k) {
	                    var a = 4 * (w * i + j) + k;
	                    var b = 4 * (w * q + j) + k;
	                    var tmp = pixels[a];
	                    pixels[a] = pixels[b];
	                    pixels[b] = tmp;
	                  }
	                }
	              }
	            }
	            function correctRGB(pixels, w, h) {
	              for (var i = 0; i < h; ++i) {
	                for (var j = 0; j < w; ++j) {
	                  var k = 4 * (w * i + j);
	                  var a = pixels[k + 3];
	                  if (a > 0) {
	                    var q = 255 / a;
	                    for (var l = 0; l < 3; ++l) {
	                      pixels[k + l] = Math.min(q * pixels[k + l], 255);
	                    }
	                  }
	                }
	              }
	            }
	            proto.toImage = function(format) {
	              var scene = this;
	              if (!format) format = "png";
	              if (scene.staticMode) scene.container.appendChild(STATIC_CANVAS);
	              scene.glplot.redraw();
	              var gl2 = scene.glplot.gl;
	              var w = gl2.drawingBufferWidth;
	              var h = gl2.drawingBufferHeight;
	              gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	              var pixels = new Uint8Array(w * h * 4);
	              gl2.readPixels(0, 0, w, h, gl2.RGBA, gl2.UNSIGNED_BYTE, pixels);
	              flipPixels(pixels, w, h);
	              correctRGB(pixels, w, h);
	              var canvas = document.createElement("canvas");
	              canvas.width = w;
	              canvas.height = h;
	              var context = canvas.getContext("2d", {
	                willReadFrequently: true
	              });
	              var imageData = context.createImageData(w, h);
	              imageData.data.set(pixels);
	              context.putImageData(imageData, 0, 0);
	              var dataURL;
	              switch (format) {
	                case "jpeg":
	                  dataURL = canvas.toDataURL("image/jpeg");
	                  break;
	                case "webp":
	                  dataURL = canvas.toDataURL("image/webp");
	                  break;
	                default:
	                  dataURL = canvas.toDataURL("image/png");
	              }
	              if (scene.staticMode) scene.container.removeChild(STATIC_CANVAS);
	              return dataURL;
	            };
	            proto.setConvert = function() {
	              var scene = this;
	              for (var i = 0; i < 3; i++) {
	                var ax = scene.fullSceneLayout[axisProperties[i]];
	                Axes.setConvert(ax, scene.fullLayout);
	                ax.setScale = Lib.noop;
	              }
	            };
	            proto.make4thDimension = function() {
	              var scene = this;
	              var gd = scene.graphDiv;
	              var fullLayout = gd._fullLayout;
	              scene._mockAxis = {
	                type: "linear",
	                showexponent: "all",
	                exponentformat: "B"
	              };
	              Axes.setConvert(scene._mockAxis, fullLayout);
	            };
	            module2.exports = Scene;
	          }
	        ),
	        /***/
	        90060: (
	          /***/
	          function(module2) {
	            module2.exports = function zip3(x, y, z, len) {
	              len = len || x.length;
	              var result = new Array(len);
	              for (var i = 0; i < len; i++) {
	                result[i] = [x[i], y[i], z[i]];
	              }
	              return result;
	            };
	          }
	        ),
	        /***/
	        10820: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var animationAttrs = __webpack_require__2(85594);
	            var colorAttrs = __webpack_require__2(22399);
	            var drawNewShapeAttrs = __webpack_require__2(29241);
	            var drawNewSelectionAttrs = __webpack_require__2(53777);
	            var padAttrs = __webpack_require__2(35025);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var globalFont = fontAttrs({
	              editType: "calc"
	            });
	            globalFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
	            globalFont.size.dflt = 12;
	            globalFont.color.dflt = colorAttrs.defaultLine;
	            module2.exports = {
	              font: globalFont,
	              title: {
	                text: {
	                  valType: "string",
	                  editType: "layoutstyle"
	                },
	                font: fontAttrs({
	                  editType: "layoutstyle"
	                }),
	                xref: {
	                  valType: "enumerated",
	                  dflt: "container",
	                  values: ["container", "paper"],
	                  editType: "layoutstyle"
	                },
	                yref: {
	                  valType: "enumerated",
	                  dflt: "container",
	                  values: ["container", "paper"],
	                  editType: "layoutstyle"
	                },
	                x: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.5,
	                  editType: "layoutstyle"
	                },
	                y: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: "auto",
	                  editType: "layoutstyle"
	                },
	                xanchor: {
	                  valType: "enumerated",
	                  dflt: "auto",
	                  values: ["auto", "left", "center", "right"],
	                  editType: "layoutstyle"
	                },
	                yanchor: {
	                  valType: "enumerated",
	                  dflt: "auto",
	                  values: ["auto", "top", "middle", "bottom"],
	                  editType: "layoutstyle"
	                },
	                pad: extendFlat(padAttrs({
	                  editType: "layoutstyle"
	                }), {}),
	                automargin: {
	                  valType: "boolean",
	                  dflt: false,
	                  editType: "plot"
	                },
	                editType: "layoutstyle"
	              },
	              uniformtext: {
	                mode: {
	                  valType: "enumerated",
	                  values: [false, "hide", "show"],
	                  dflt: false,
	                  editType: "plot"
	                },
	                minsize: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              autosize: {
	                valType: "boolean",
	                dflt: false,
	                // autosize, width, and height get special editType treatment in _relayout
	                // so we can handle noop resizes more efficiently
	                editType: "none"
	              },
	              width: {
	                valType: "number",
	                min: 10,
	                dflt: 700,
	                editType: "plot"
	              },
	              height: {
	                valType: "number",
	                min: 10,
	                dflt: 450,
	                editType: "plot"
	              },
	              minreducedwidth: {
	                valType: "number",
	                min: 2,
	                dflt: 64,
	                editType: "plot"
	              },
	              minreducedheight: {
	                valType: "number",
	                min: 2,
	                dflt: 64,
	                editType: "plot"
	              },
	              margin: {
	                l: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 80,
	                  editType: "plot"
	                },
	                r: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 80,
	                  editType: "plot"
	                },
	                t: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 100,
	                  editType: "plot"
	                },
	                b: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 80,
	                  editType: "plot"
	                },
	                pad: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "plot"
	                },
	                autoexpand: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              computed: {
	                valType: "any",
	                editType: "none"
	              },
	              paper_bgcolor: {
	                valType: "color",
	                dflt: colorAttrs.background,
	                editType: "plot"
	              },
	              plot_bgcolor: {
	                // defined here, but set in cartesian.supplyLayoutDefaults
	                // because it needs to know if there are (2D) axes or not
	                valType: "color",
	                dflt: colorAttrs.background,
	                editType: "layoutstyle"
	              },
	              autotypenumbers: {
	                valType: "enumerated",
	                values: ["convert types", "strict"],
	                dflt: "convert types",
	                editType: "calc"
	              },
	              separators: {
	                valType: "string",
	                editType: "plot"
	              },
	              hidesources: {
	                valType: "boolean",
	                dflt: false,
	                editType: "plot"
	              },
	              showlegend: {
	                // handled in legend.supplyLayoutDefaults
	                // but included here because it's not in the legend object
	                valType: "boolean",
	                editType: "legend"
	              },
	              colorway: {
	                valType: "colorlist",
	                dflt: colorAttrs.defaults,
	                editType: "calc"
	              },
	              datarevision: {
	                valType: "any",
	                editType: "calc"
	              },
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              editrevision: {
	                valType: "any",
	                editType: "none"
	              },
	              selectionrevision: {
	                valType: "any",
	                editType: "none"
	              },
	              template: {
	                valType: "any",
	                editType: "calc"
	              },
	              newshape: drawNewShapeAttrs.newshape,
	              activeshape: drawNewShapeAttrs.activeshape,
	              newselection: drawNewSelectionAttrs.newselection,
	              activeselection: drawNewSelectionAttrs.activeselection,
	              meta: {
	                valType: "any",
	                arrayOk: true,
	                editType: "plot"
	              },
	              transition: extendFlat({}, animationAttrs.transition, {
	                editType: "none"
	              }),
	              _deprecated: {
	                title: {
	                  valType: "string",
	                  editType: "layoutstyle"
	                },
	                titlefont: fontAttrs({
	                  editType: "layoutstyle"
	                })
	              }
	            };
	          }
	        ),
	        /***/
	        77734: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var sortObjectKeys = __webpack_require__2(78607);
	            var requiredVersion = "1.10.1";
	            var OSM = '© <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
	            var carto = ['© <a target="_blank" href="https://carto.com/">Carto</a>', OSM].join(" ");
	            var stamenTerrainOrToner = ['Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>', 'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>', "|", 'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors', 'under <a target="_blank" href="https://www.openstreetmap.org/copyright">ODbL</a>'].join(" ");
	            var stamenWaterColor = ['Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>', 'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>', "|", 'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors', 'under <a target="_blank" href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'].join(" ");
	            var stylesNonMapbox = {
	              "open-street-map": {
	                id: "osm",
	                version: 8,
	                sources: {
	                  "plotly-osm-tiles": {
	                    type: "raster",
	                    attribution: OSM,
	                    tiles: ["https://a.tile.openstreetmap.org/{z}/{x}/{y}.png", "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"],
	                    tileSize: 256
	                  }
	                },
	                layers: [{
	                  id: "plotly-osm-tiles",
	                  type: "raster",
	                  source: "plotly-osm-tiles",
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              },
	              "white-bg": {
	                id: "white-bg",
	                version: 8,
	                sources: {},
	                layers: [{
	                  id: "white-bg",
	                  type: "background",
	                  paint: {
	                    "background-color": "#FFFFFF"
	                  },
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              },
	              "carto-positron": {
	                id: "carto-positron",
	                version: 8,
	                sources: {
	                  "plotly-carto-positron": {
	                    type: "raster",
	                    attribution: carto,
	                    tiles: ["https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"],
	                    tileSize: 256
	                  }
	                },
	                layers: [{
	                  id: "plotly-carto-positron",
	                  type: "raster",
	                  source: "plotly-carto-positron",
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              },
	              "carto-darkmatter": {
	                id: "carto-darkmatter",
	                version: 8,
	                sources: {
	                  "plotly-carto-darkmatter": {
	                    type: "raster",
	                    attribution: carto,
	                    tiles: ["https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png"],
	                    tileSize: 256
	                  }
	                },
	                layers: [{
	                  id: "plotly-carto-darkmatter",
	                  type: "raster",
	                  source: "plotly-carto-darkmatter",
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              },
	              "stamen-terrain": {
	                id: "stamen-terrain",
	                version: 8,
	                sources: {
	                  "plotly-stamen-terrain": {
	                    type: "raster",
	                    attribution: stamenTerrainOrToner,
	                    tiles: ["https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}.png?api_key="],
	                    tileSize: 256
	                  }
	                },
	                layers: [{
	                  id: "plotly-stamen-terrain",
	                  type: "raster",
	                  source: "plotly-stamen-terrain",
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              },
	              "stamen-toner": {
	                id: "stamen-toner",
	                version: 8,
	                sources: {
	                  "plotly-stamen-toner": {
	                    type: "raster",
	                    attribution: stamenTerrainOrToner,
	                    tiles: ["https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png?api_key="],
	                    tileSize: 256
	                  }
	                },
	                layers: [{
	                  id: "plotly-stamen-toner",
	                  type: "raster",
	                  source: "plotly-stamen-toner",
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              },
	              "stamen-watercolor": {
	                id: "stamen-watercolor",
	                version: 8,
	                sources: {
	                  "plotly-stamen-watercolor": {
	                    type: "raster",
	                    attribution: stamenWaterColor,
	                    tiles: ["https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg?api_key="],
	                    tileSize: 256
	                  }
	                },
	                layers: [{
	                  id: "plotly-stamen-watercolor",
	                  type: "raster",
	                  source: "plotly-stamen-watercolor",
	                  minzoom: 0,
	                  maxzoom: 22
	                }],
	                glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
	              }
	            };
	            var styleValuesNonMapbox = sortObjectKeys(stylesNonMapbox);
	            module2.exports = {
	              requiredVersion,
	              styleUrlPrefix: "mapbox://styles/mapbox/",
	              styleUrlSuffix: "v9",
	              styleValuesMapbox: ["basic", "streets", "outdoors", "light", "dark", "satellite", "satellite-streets"],
	              styleValueDflt: "basic",
	              stylesNonMapbox,
	              styleValuesNonMapbox,
	              traceLayerPrefix: "plotly-trace-layer-",
	              layoutLayerPrefix: "plotly-layout-layer-",
	              wrongVersionErrorMsg: ["Your custom plotly.js bundle is not using the correct mapbox-gl version", "Please install mapbox-gl@" + requiredVersion + "."].join("\n"),
	              noAccessTokenErrorMsg: ["Missing Mapbox access token.", "Mapbox trace type require a Mapbox access token to be registered.", "For example:", "  Plotly.newPlot(gd, data, layout, { mapboxAccessToken: 'my-access-token' });", "More info here: https://www.mapbox.com/help/define-access-token/"].join("\n"),
	              missingStyleErrorMsg: ["No valid mapbox style found, please set `mapbox.style` to one of:", styleValuesNonMapbox.join(", "), "or register a Mapbox access token to use a Mapbox-served style."].join("\n"),
	              multipleTokensErrorMsg: ["Set multiple mapbox access token across different mapbox subplot,", "using first token found as mapbox-gl does not allow multipleaccess tokens on the same page."].join("\n"),
	              mapOnErrorMsg: "Mapbox error.",
	              // Mapbox logo for static export
	              mapboxLogo: {
	                path0: "m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z",
	                path1: "M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z",
	                path2: "M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z",
	                polygon: "11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34"
	              },
	              // a subset of node_modules/mapbox-gl/dist/mapbox-gl.css
	              styleRules: {
	                map: "overflow:hidden;position:relative;",
	                "missing-css": "display:none;",
	                canary: "background-color:salmon;",
	                // Reusing CSS directives from: https://api.tiles.mapbox.com/mapbox-gl-js/v1.1.1/mapbox-gl.css
	                "ctrl-bottom-left": "position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;",
	                "ctrl-bottom-right": "position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;",
	                ctrl: "clear: both; pointer-events: auto; transform: translate(0, 0);",
	                // Compact ctrl
	                "ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner": "display: none;",
	                "ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner": "display: block; margin-top:2px",
	                "ctrl-attrib.mapboxgl-compact:hover": "padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;",
	                "ctrl-attrib.mapboxgl-compact::after": `content: ""; cursor: pointer; position: absolute; background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;`,
	                "ctrl-attrib.mapboxgl-compact": "min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;",
	                "ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; right: 0",
	                "ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; left: 0",
	                "ctrl-bottom-left .mapboxgl-ctrl": "margin: 0 0 10px 10px; float: left;",
	                "ctrl-bottom-right .mapboxgl-ctrl": "margin: 0 10px 10px 0; float: right;",
	                "ctrl-attrib": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
	                "ctrl-attrib a": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
	                "ctrl-attrib a:hover": "color: inherit; text-decoration: underline;",
	                "ctrl-attrib .mapbox-improve-map": "font-weight: bold; margin-left: 2px;",
	                "attrib-empty": "display: none;",
	                // Compact Mapbox logo without text
	                "ctrl-logo": `display:block; width: 21px; height: 21px; background-image: url('data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E')`
	                // Mapbox logo WITH text below (commented out for now)
	                // 'ctrl-logo': 'width: 85px; height: 21px; margin: 0 0 -3px -3px; display: block; background-repeat: no-repeat; cursor: pointer; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E%3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84.49 21" style="enable-background:new 0 0 84.49 21;" xml:space="preserve"%3E%3Cg%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M83.25,14.26c0,0.12-0.09,0.21-0.21,0.21h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39l-1.44,2.39 c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68L76.2,6.84 c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.4-2.35 c0.06-0.11,0.18-0.17,0.3-0.17H83c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.37,3.63l2.43,3.67 C83.24,14.18,83.25,14.22,83.25,14.26z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M66.24,9.59c-0.39-1.88-1.96-3.28-3.84-3.28c-1.03,0-2.03,0.42-2.73,1.18V3.51c0-0.13-0.1-0.23-0.23-0.23h-1.4 c-0.13,0-0.23,0.11-0.23,0.23v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.11,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.73,1.18 c1.88,0,3.45-1.41,3.84-3.29C66.37,10.79,66.37,10.18,66.24,9.59L66.24,9.59z M62.08,13c-1.32,0-2.39-1.11-2.41-2.48v-0.06 c0.02-1.38,1.09-2.48,2.41-2.48s2.42,1.12,2.42,2.51S63.41,13,62.08,13z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M71.67,6.32c-1.98-0.01-3.72,1.35-4.16,3.29c-0.13,0.59-0.13,1.19,0,1.77c0.44,1.94,2.17,3.32,4.17,3.3 c2.35,0,4.26-1.87,4.26-4.19S74.04,6.32,71.67,6.32z M71.65,13.01c-1.33,0-2.42-1.12-2.42-2.51s1.08-2.52,2.42-2.52 c1.33,0,2.42,1.12,2.42,2.51S72.99,13,71.65,13.01L71.65,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M62.08,7.98c-1.32,0-2.39,1.11-2.41,2.48v0.06C59.68,11.9,60.75,13,62.08,13s2.42-1.12,2.42-2.51 S63.41,7.98,62.08,7.98z M62.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25 c0.63,0,1.17,0.57,1.17,1.27C63.24,11.2,62.73,11.76,62.08,11.76z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M71.65,7.98c-1.33,0-2.42,1.12-2.42,2.51S70.32,13,71.65,13s2.42-1.12,2.42-2.51S72.99,7.98,71.65,7.98z M71.65,11.76c-0.64,0-1.17-0.57-1.17-1.27c0-0.7,0.53-1.26,1.17-1.26s1.17,0.57,1.17,1.27C72.82,11.21,72.29,11.76,71.65,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M45.74,6.53h-1.4c-0.13,0-0.23,0.11-0.23,0.23v0.73c-0.71-0.75-1.7-1.18-2.73-1.18 c-2.17,0-3.94,1.87-3.94,4.19s1.77,4.19,3.94,4.19c1.04,0,2.03-0.43,2.73-1.19v0.73c0,0.13,0.1,0.23,0.23,0.23h1.4 c0.13,0,0.23-0.11,0.23-0.23V6.74c0-0.12-0.09-0.22-0.22-0.22C45.75,6.53,45.75,6.53,45.74,6.53z M44.12,10.53 C44.11,11.9,43.03,13,41.71,13s-2.42-1.12-2.42-2.51s1.08-2.52,2.4-2.52c1.33,0,2.39,1.11,2.41,2.48L44.12,10.53z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M41.71,7.98c-1.33,0-2.42,1.12-2.42,2.51S40.37,13,41.71,13s2.39-1.11,2.41-2.48v-0.06 C44.1,9.09,43.03,7.98,41.71,7.98z M40.55,10.49c0-0.7,0.52-1.27,1.17-1.27c0.64,0,1.14,0.56,1.17,1.25v0.04 c-0.01,0.68-0.53,1.24-1.17,1.24C41.08,11.75,40.55,11.19,40.55,10.49z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M52.41,6.32c-1.03,0-2.03,0.42-2.73,1.18V6.75c0-0.13-0.1-0.23-0.23-0.23h-1.4c-0.13,0-0.23,0.11-0.23,0.23 v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.1,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.74,1.18c2.17,0,3.94-1.87,3.94-4.19 S54.58,6.32,52.41,6.32z M52.08,13.01c-1.32,0-2.39-1.11-2.42-2.48v-0.07c0.02-1.38,1.09-2.49,2.4-2.49c1.32,0,2.41,1.12,2.41,2.51 S53.4,13,52.08,13.01L52.08,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M52.08,7.98c-1.32,0-2.39,1.11-2.42,2.48v0.06c0.03,1.38,1.1,2.48,2.42,2.48s2.41-1.12,2.41-2.51 S53.4,7.98,52.08,7.98z M52.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25c0.63,0,1.17,0.58,1.17,1.27 S52.72,11.76,52.08,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M36.08,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68c0-0.98-0.74-1.71-1.62-1.71 c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.11,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V6.74 c0.01-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03c1.09,0,2.09,0.6,2.6,1.55 c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78L36.08,14.24z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M84.34,13.59l-0.07-0.13l-1.96-2.99l1.94-2.95c0.44-0.67,0.26-1.56-0.41-2.02c-0.02,0-0.03,0-0.04-0.01 c-0.23-0.15-0.5-0.22-0.78-0.22h-1.61c-0.56,0-1.08,0.29-1.37,0.78L79.72,6.6l-0.34-0.56C79.09,5.56,78.57,5.27,78,5.27h-1.6 c-0.6,0-1.13,0.37-1.35,0.92c-2.19-1.66-5.28-1.47-7.26,0.45c-0.35,0.34-0.65,0.72-0.89,1.14c-0.9-1.62-2.58-2.72-4.5-2.72 c-0.5,0-1.01,0.07-1.48,0.23V3.51c0-0.82-0.66-1.48-1.47-1.48h-1.4c-0.81,0-1.47,0.66-1.47,1.47v3.75 c-0.95-1.36-2.5-2.18-4.17-2.19c-0.74,0-1.46,0.16-2.12,0.47c-0.24-0.17-0.54-0.26-0.84-0.26h-1.4c-0.45,0-0.87,0.21-1.15,0.56 c-0.02-0.03-0.04-0.05-0.07-0.08c-0.28-0.3-0.68-0.47-1.09-0.47h-1.39c-0.3,0-0.6,0.09-0.84,0.26c-0.67-0.3-1.39-0.46-2.12-0.46 c-1.83,0-3.43,1-4.37,2.5c-0.2-0.46-0.48-0.89-0.83-1.25c-0.8-0.81-1.89-1.25-3.02-1.25h-0.01c-0.89,0.01-1.75,0.33-2.46,0.88 c-0.74-0.57-1.64-0.88-2.57-0.88H28.1c-0.29,0-0.58,0.03-0.86,0.11c-0.28,0.06-0.56,0.16-0.82,0.28c-0.21-0.12-0.45-0.18-0.7-0.18 h-1.4c-0.82,0-1.47,0.66-1.47,1.47v7.5c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.48-0.66,1.48-1.48l0,0V9.79 c0.03-0.36,0.23-0.59,0.36-0.59c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41c0.82,0,1.47-0.66,1.47-1.47 l-0.01-4.57c0.06-0.32,0.25-0.47,0.35-0.47c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41 c0.82,0,1.47-0.66,1.47-1.47v-0.38c0.96,1.29,2.46,2.06,4.06,2.06c0.74,0,1.46-0.16,2.12-0.47c0.24,0.17,0.54,0.26,0.84,0.26h1.39 c0.3,0,0.6-0.09,0.84-0.26v2.01c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.47-0.66,1.47-1.47v-1.77c0.48,0.15,0.99,0.23,1.49,0.22 c1.7,0,3.22-0.87,4.17-2.2v0.52c0,0.82,0.66,1.47,1.47,1.47h1.4c0.3,0,0.6-0.09,0.84-0.26c0.66,0.31,1.39,0.47,2.12,0.47 c1.92,0,3.6-1.1,4.49-2.73c1.54,2.65,4.95,3.53,7.58,1.98c0.18-0.11,0.36-0.22,0.53-0.36c0.22,0.55,0.76,0.91,1.35,0.9H78 c0.56,0,1.08-0.29,1.37-0.78l0.37-0.61l0.37,0.61c0.29,0.48,0.81,0.78,1.38,0.78h1.6c0.81,0,1.46-0.66,1.45-1.46 C84.49,14.02,84.44,13.8,84.34,13.59L84.34,13.59z M35.86,14.47h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23 V9.68c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23 V6.74c0.01-0.13,0.11-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03 c1.09,0,2.09,0.6,2.6,1.55c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78l0.01,5.16C36.09,14.36,35.98,14.46,35.86,14.47 L35.86,14.47z M45.97,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V13.5c-0.7,0.76-1.69,1.18-2.72,1.18 c-2.17,0-3.94-1.87-3.94-4.19s1.77-4.19,3.94-4.19c1.03,0,2.02,0.43,2.73,1.18V6.74c0-0.13,0.1-0.23,0.23-0.23h1.4 c0.12-0.01,0.22,0.08,0.23,0.21c0,0.01,0,0.01,0,0.02v7.51h-0.01V14.24z M52.41,14.67c-1.03,0-2.02-0.43-2.73-1.18v3.97 c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.1-0.23-0.23V6.75c0-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.23,0.11,0.23,0.23v0.73 c0.71-0.76,1.7-1.18,2.73-1.18c2.17,0,3.94,1.86,3.94,4.18S54.58,14.67,52.41,14.67z M66.24,11.39c-0.39,1.87-1.96,3.29-3.84,3.29 c-1.03,0-2.02-0.43-2.73-1.18v0.73c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V3.51c0-0.13,0.1-0.23,0.23-0.23 h1.4c0.13,0,0.23,0.11,0.23,0.23v3.97c0.71-0.75,1.7-1.18,2.73-1.17c1.88,0,3.45,1.4,3.84,3.28C66.37,10.19,66.37,10.8,66.24,11.39 L66.24,11.39L66.24,11.39z M71.67,14.68c-2,0.01-3.73-1.35-4.17-3.3c-0.13-0.59-0.13-1.19,0-1.77c0.44-1.94,2.17-3.31,4.17-3.3 c2.36,0,4.26,1.87,4.26,4.19S74.03,14.68,71.67,14.68L71.67,14.68z M83.04,14.47h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39 l-1.44,2.39c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68 L76.2,6.84c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.41-2.36 c0.06-0.11,0.18-0.17,0.3-0.17h1.61c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.38,3.64l2.43,3.67 c0.02,0.03,0.03,0.07,0.03,0.12C83.25,14.38,83.16,14.47,83.04,14.47L83.04,14.47L83.04,14.47z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M10.5,1.24c-5.11,0-9.25,4.15-9.25,9.25s4.15,9.25,9.25,9.25s9.25-4.15,9.25-9.25 C19.75,5.38,15.61,1.24,10.5,1.24z M14.89,12.77c-1.93,1.93-4.78,2.31-6.7,2.31c-0.7,0-1.41-0.05-2.1-0.16c0,0-1.02-5.64,2.14-8.81 c0.83-0.83,1.95-1.28,3.13-1.28c1.27,0,2.49,0.51,3.39,1.42C16.59,8.09,16.64,11,14.89,12.77z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M10.5-0.01C4.7-0.01,0,4.7,0,10.49s4.7,10.5,10.5,10.5S21,16.29,21,10.49C20.99,4.7,16.3-0.01,10.5-0.01z M10.5,19.74c-5.11,0-9.25-4.15-9.25-9.25s4.14-9.26,9.25-9.26s9.25,4.15,9.25,9.25C19.75,15.61,15.61,19.74,10.5,19.74z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M14.74,6.25C12.9,4.41,9.98,4.35,8.23,6.1c-3.16,3.17-2.14,8.81-2.14,8.81s5.64,1.02,8.81-2.14 C16.64,11,16.59,8.09,14.74,6.25z M12.47,10.34l-0.91,1.87l-0.9-1.87L8.8,9.43l1.86-0.9l0.9-1.87l0.91,1.87l1.86,0.9L12.47,10.34z"/%3E %3Cpolygon class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" points="14.33,9.43 12.47,10.34 11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 "/%3E%3C/g%3E%3C/svg%3E\');'
	              }
	            };
	          }
	        ),
	        /***/
	        13056: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function convertTextOpts(textposition, iconSize) {
	              var parts = textposition.split(" ");
	              var vPos = parts[0];
	              var hPos = parts[1];
	              var factor = Lib.isArrayOrTypedArray(iconSize) ? Lib.mean(iconSize) : iconSize;
	              var xInc = 0.5 + factor / 100;
	              var yInc = 1.5 + factor / 100;
	              var anchorVals = ["", ""];
	              var offset = [0, 0];
	              switch (vPos) {
	                case "top":
	                  anchorVals[0] = "top";
	                  offset[1] = -yInc;
	                  break;
	                case "bottom":
	                  anchorVals[0] = "bottom";
	                  offset[1] = yInc;
	                  break;
	              }
	              switch (hPos) {
	                case "left":
	                  anchorVals[1] = "right";
	                  offset[0] = -xInc;
	                  break;
	                case "right":
	                  anchorVals[1] = "left";
	                  offset[0] = xInc;
	                  break;
	              }
	              var anchor;
	              if (anchorVals[0] && anchorVals[1]) anchor = anchorVals.join("-");
	              else if (anchorVals[0]) anchor = anchorVals[0];
	              else if (anchorVals[1]) anchor = anchorVals[1];
	              else anchor = "center";
	              return {
	                anchor,
	                offset
	              };
	            };
	          }
	        ),
	        /***/
	        50101: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var mapboxgl = __webpack_require__2(44517);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var strScale = Lib.strScale;
	            var getSubplotCalcData = __webpack_require__2(27659).AU;
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var svgTextUtils = __webpack_require__2(63893);
	            var Mapbox = __webpack_require__2(10481);
	            var MAPBOX = "mapbox";
	            var constants = exports2.constants = __webpack_require__2(77734);
	            exports2.name = MAPBOX;
	            exports2.attr = "subplot";
	            exports2.idRoot = MAPBOX;
	            exports2.idRegex = exports2.attrRegex = Lib.counterRegex(MAPBOX);
	            exports2.attributes = {
	              subplot: {
	                valType: "subplotid",
	                dflt: "mapbox",
	                editType: "calc"
	              }
	            };
	            exports2.layoutAttributes = __webpack_require__2(23585);
	            exports2.supplyLayoutDefaults = __webpack_require__2(77882);
	            exports2.plot = function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var calcData = gd.calcdata;
	              var mapboxIds = fullLayout._subplots[MAPBOX];
	              if (mapboxgl.version !== constants.requiredVersion) {
	                throw new Error(constants.wrongVersionErrorMsg);
	              }
	              var accessToken = findAccessToken(gd, mapboxIds);
	              mapboxgl.accessToken = accessToken;
	              for (var i = 0; i < mapboxIds.length; i++) {
	                var id = mapboxIds[i];
	                var subplotCalcData = getSubplotCalcData(calcData, MAPBOX, id);
	                var opts = fullLayout[id];
	                var mapbox = opts._subplot;
	                if (!mapbox) {
	                  mapbox = new Mapbox(gd, id);
	                  fullLayout[id]._subplot = mapbox;
	                }
	                if (!mapbox.viewInitial) {
	                  mapbox.viewInitial = {
	                    center: Lib.extendFlat({}, opts.center),
	                    zoom: opts.zoom,
	                    bearing: opts.bearing,
	                    pitch: opts.pitch
	                  };
	                }
	                mapbox.plot(subplotCalcData, fullLayout, gd._promises);
	              }
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldMapboxKeys = oldFullLayout._subplots[MAPBOX] || [];
	              for (var i = 0; i < oldMapboxKeys.length; i++) {
	                var oldMapboxKey = oldMapboxKeys[i];
	                if (!newFullLayout[oldMapboxKey] && !!oldFullLayout[oldMapboxKey]._subplot) {
	                  oldFullLayout[oldMapboxKey]._subplot.destroy();
	                }
	              }
	            };
	            exports2.toSVG = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots[MAPBOX];
	              var size = fullLayout._size;
	              for (var i = 0; i < subplotIds.length; i++) {
	                var opts = fullLayout[subplotIds[i]];
	                var domain = opts.domain;
	                var mapbox = opts._subplot;
	                var imageData = mapbox.toImage("png");
	                var image = fullLayout._glimages.append("svg:image");
	                image.attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  "xlink:href": imageData,
	                  x: size.l + size.w * domain.x[0],
	                  y: size.t + size.h * (1 - domain.y[1]),
	                  width: size.w * (domain.x[1] - domain.x[0]),
	                  height: size.h * (domain.y[1] - domain.y[0]),
	                  preserveAspectRatio: "none"
	                });
	                var subplotDiv = d3.select(opts._subplot.div);
	                var hidden = subplotDiv.select(".mapboxgl-ctrl-logo").node().offsetParent === null;
	                if (!hidden) {
	                  var logo = fullLayout._glimages.append("g");
	                  logo.attr("transform", strTranslate(size.l + size.w * domain.x[0] + 10, size.t + size.h * (1 - domain.y[0]) - 31));
	                  logo.append("path").attr("d", constants.mapboxLogo.path0).style({
	                    opacity: 0.9,
	                    fill: "#ffffff",
	                    "enable-background": "new"
	                  });
	                  logo.append("path").attr("d", constants.mapboxLogo.path1).style("opacity", 0.35).style("enable-background", "new");
	                  logo.append("path").attr("d", constants.mapboxLogo.path2).style("opacity", 0.35).style("enable-background", "new");
	                  logo.append("polygon").attr("points", constants.mapboxLogo.polygon).style({
	                    opacity: 0.9,
	                    fill: "#ffffff",
	                    "enable-background": "new"
	                  });
	                }
	                var attributions = subplotDiv.select(".mapboxgl-ctrl-attrib").text().replace("Improve this map", "");
	                var attributionGroup = fullLayout._glimages.append("g");
	                var attributionText = attributionGroup.append("text");
	                attributionText.text(attributions).classed("static-attribution", true).attr({
	                  "font-size": 12,
	                  "font-family": "Arial",
	                  color: "rgba(0, 0, 0, 0.75)",
	                  "text-anchor": "end",
	                  "data-unformatted": attributions
	                });
	                var bBox = Drawing.bBox(attributionText.node());
	                var maxWidth = size.w * (domain.x[1] - domain.x[0]);
	                if (bBox.width > maxWidth / 2) {
	                  var multilineAttributions = attributions.split("|").join("<br>");
	                  attributionText.text(multilineAttributions).attr("data-unformatted", multilineAttributions).call(svgTextUtils.convertToTspans, gd);
	                  bBox = Drawing.bBox(attributionText.node());
	                }
	                attributionText.attr("transform", strTranslate(-3, -bBox.height + 8));
	                attributionGroup.insert("rect", ".static-attribution").attr({
	                  x: -bBox.width - 6,
	                  y: -bBox.height - 3,
	                  width: bBox.width + 6,
	                  height: bBox.height + 3,
	                  fill: "rgba(255, 255, 255, 0.75)"
	                });
	                var scaleRatio = 1;
	                if (bBox.width + 6 > maxWidth) scaleRatio = maxWidth / (bBox.width + 6);
	                var offset = [size.l + size.w * domain.x[1], size.t + size.h * (1 - domain.y[0])];
	                attributionGroup.attr("transform", strTranslate(offset[0], offset[1]) + strScale(scaleRatio));
	              }
	            };
	            function findAccessToken(gd, mapboxIds) {
	              var fullLayout = gd._fullLayout;
	              var context = gd._context;
	              if (context.mapboxAccessToken === "") return "";
	              var tokensUseful = [];
	              var tokensListed = [];
	              var hasOneSetMapboxStyle = false;
	              var wontWork = false;
	              for (var i = 0; i < mapboxIds.length; i++) {
	                var opts = fullLayout[mapboxIds[i]];
	                var token = opts.accesstoken;
	                if (isStyleRequireAccessToken(opts.style)) {
	                  if (token) {
	                    Lib.pushUnique(tokensUseful, token);
	                  } else {
	                    if (isStyleRequireAccessToken(opts._input.style)) {
	                      Lib.error("Uses Mapbox map style, but did not set an access token.");
	                      hasOneSetMapboxStyle = true;
	                    }
	                    wontWork = true;
	                  }
	                }
	                if (token) {
	                  Lib.pushUnique(tokensListed, token);
	                }
	              }
	              if (wontWork) {
	                var msg = hasOneSetMapboxStyle ? constants.noAccessTokenErrorMsg : constants.missingStyleErrorMsg;
	                Lib.error(msg);
	                throw new Error(msg);
	              }
	              if (tokensUseful.length) {
	                if (tokensUseful.length > 1) {
	                  Lib.warn(constants.multipleTokensErrorMsg);
	                }
	                return tokensUseful[0];
	              } else {
	                if (tokensListed.length) {
	                  Lib.log(["Listed mapbox access token(s)", tokensListed.join(","), "but did not use a Mapbox map style, ignoring token(s)."].join(" "));
	                }
	                return "";
	              }
	            }
	            function isStyleRequireAccessToken(s) {
	              return typeof s === "string" && (constants.styleValuesMapbox.indexOf(s) !== -1 || s.indexOf("mapbox://") === 0 || s.indexOf("stamen") === 0);
	            }
	            exports2.updateFx = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var subplotIds = fullLayout._subplots[MAPBOX];
	              for (var i = 0; i < subplotIds.length; i++) {
	                var subplotObj = fullLayout[subplotIds[i]]._subplot;
	                subplotObj.updateFx(fullLayout);
	              }
	            };
	          }
	        ),
	        /***/
	        67911: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var sanitizeHTML = __webpack_require__2(63893).sanitizeHTML;
	            var convertTextOpts = __webpack_require__2(13056);
	            var constants = __webpack_require__2(77734);
	            function MapboxLayer(subplot, index) {
	              this.subplot = subplot;
	              this.uid = subplot.uid + "-" + index;
	              this.index = index;
	              this.idSource = "source-" + this.uid;
	              this.idLayer = constants.layoutLayerPrefix + this.uid;
	              this.sourceType = null;
	              this.source = null;
	              this.layerType = null;
	              this.below = null;
	              this.visible = false;
	            }
	            var proto = MapboxLayer.prototype;
	            proto.update = function update(opts) {
	              if (!this.visible) {
	                this.updateSource(opts);
	                this.updateLayer(opts);
	              } else if (this.needsNewImage(opts)) {
	                this.updateImage(opts);
	              } else if (this.needsNewSource(opts)) {
	                this.removeLayer();
	                this.updateSource(opts);
	                this.updateLayer(opts);
	              } else if (this.needsNewLayer(opts)) {
	                this.updateLayer(opts);
	              } else {
	                this.updateStyle(opts);
	              }
	              this.visible = isVisible(opts);
	            };
	            proto.needsNewImage = function(opts) {
	              var map2 = this.subplot.map;
	              return map2.getSource(this.idSource) && this.sourceType === "image" && opts.sourcetype === "image" && (this.source !== opts.source || JSON.stringify(this.coordinates) !== JSON.stringify(opts.coordinates));
	            };
	            proto.needsNewSource = function(opts) {
	              return this.sourceType !== opts.sourcetype || JSON.stringify(this.source) !== JSON.stringify(opts.source) || this.layerType !== opts.type;
	            };
	            proto.needsNewLayer = function(opts) {
	              return this.layerType !== opts.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
	            };
	            proto.lookupBelow = function() {
	              return this.subplot.belowLookup["layout-" + this.index];
	            };
	            proto.updateImage = function(opts) {
	              var map2 = this.subplot.map;
	              map2.getSource(this.idSource).updateImage({
	                url: opts.source,
	                coordinates: opts.coordinates
	              });
	              var _below = this.findFollowingMapboxLayerId(this.lookupBelow());
	              if (_below !== null) {
	                this.subplot.map.moveLayer(this.idLayer, _below);
	              }
	            };
	            proto.updateSource = function(opts) {
	              var map2 = this.subplot.map;
	              if (map2.getSource(this.idSource)) map2.removeSource(this.idSource);
	              this.sourceType = opts.sourcetype;
	              this.source = opts.source;
	              if (!isVisible(opts)) return;
	              var sourceOpts = convertSourceOpts(opts);
	              map2.addSource(this.idSource, sourceOpts);
	            };
	            proto.findFollowingMapboxLayerId = function(below) {
	              if (below === "traces") {
	                var mapLayers = this.subplot.getMapLayers();
	                for (var i = 0; i < mapLayers.length; i++) {
	                  var layerId = mapLayers[i].id;
	                  if (typeof layerId === "string" && layerId.indexOf(constants.traceLayerPrefix) === 0) {
	                    below = layerId;
	                    break;
	                  }
	                }
	              }
	              return below;
	            };
	            proto.updateLayer = function(opts) {
	              var subplot = this.subplot;
	              var convertedOpts = convertOpts(opts);
	              var below = this.lookupBelow();
	              var _below = this.findFollowingMapboxLayerId(below);
	              this.removeLayer();
	              if (isVisible(opts)) {
	                subplot.addLayer({
	                  id: this.idLayer,
	                  source: this.idSource,
	                  "source-layer": opts.sourcelayer || "",
	                  type: opts.type,
	                  minzoom: opts.minzoom,
	                  maxzoom: opts.maxzoom,
	                  layout: convertedOpts.layout,
	                  paint: convertedOpts.paint
	                }, _below);
	              }
	              this.layerType = opts.type;
	              this.below = below;
	            };
	            proto.updateStyle = function(opts) {
	              if (isVisible(opts)) {
	                var convertedOpts = convertOpts(opts);
	                this.subplot.setOptions(this.idLayer, "setLayoutProperty", convertedOpts.layout);
	                this.subplot.setOptions(this.idLayer, "setPaintProperty", convertedOpts.paint);
	              }
	            };
	            proto.removeLayer = function() {
	              var map2 = this.subplot.map;
	              if (map2.getLayer(this.idLayer)) {
	                map2.removeLayer(this.idLayer);
	              }
	            };
	            proto.dispose = function() {
	              var map2 = this.subplot.map;
	              if (map2.getLayer(this.idLayer)) map2.removeLayer(this.idLayer);
	              if (map2.getSource(this.idSource)) map2.removeSource(this.idSource);
	            };
	            function isVisible(opts) {
	              if (!opts.visible) return false;
	              var source = opts.source;
	              if (Array.isArray(source) && source.length > 0) {
	                for (var i = 0; i < source.length; i++) {
	                  if (typeof source[i] !== "string" || source[i].length === 0) {
	                    return false;
	                  }
	                }
	                return true;
	              }
	              return Lib.isPlainObject(source) || typeof source === "string" && source.length > 0;
	            }
	            function convertOpts(opts) {
	              var layout = {};
	              var paint = {};
	              switch (opts.type) {
	                case "circle":
	                  Lib.extendFlat(paint, {
	                    "circle-radius": opts.circle.radius,
	                    "circle-color": opts.color,
	                    "circle-opacity": opts.opacity
	                  });
	                  break;
	                case "line":
	                  Lib.extendFlat(paint, {
	                    "line-width": opts.line.width,
	                    "line-color": opts.color,
	                    "line-opacity": opts.opacity,
	                    "line-dasharray": opts.line.dash
	                  });
	                  break;
	                case "fill":
	                  Lib.extendFlat(paint, {
	                    "fill-color": opts.color,
	                    "fill-outline-color": opts.fill.outlinecolor,
	                    "fill-opacity": opts.opacity
	                    // no way to pass specify outline width at the moment
	                  });
	                  break;
	                case "symbol":
	                  var symbol = opts.symbol;
	                  var textOpts = convertTextOpts(symbol.textposition, symbol.iconsize);
	                  Lib.extendFlat(layout, {
	                    "icon-image": symbol.icon + "-15",
	                    "icon-size": symbol.iconsize / 10,
	                    "text-field": symbol.text,
	                    "text-size": symbol.textfont.size,
	                    "text-anchor": textOpts.anchor,
	                    "text-offset": textOpts.offset,
	                    "symbol-placement": symbol.placement
	                    // TODO font family
	                    // 'text-font': symbol.textfont.family.split(', '),
	                  });
	                  Lib.extendFlat(paint, {
	                    "icon-color": opts.color,
	                    "text-color": symbol.textfont.color,
	                    "text-opacity": opts.opacity
	                  });
	                  break;
	                case "raster":
	                  Lib.extendFlat(paint, {
	                    "raster-fade-duration": 0,
	                    "raster-opacity": opts.opacity
	                  });
	                  break;
	              }
	              return {
	                layout,
	                paint
	              };
	            }
	            function convertSourceOpts(opts) {
	              var sourceType = opts.sourcetype;
	              var source = opts.source;
	              var sourceOpts = {
	                type: sourceType
	              };
	              var field;
	              if (sourceType === "geojson") {
	                field = "data";
	              } else if (sourceType === "vector") {
	                field = typeof source === "string" ? "url" : "tiles";
	              } else if (sourceType === "raster") {
	                field = "tiles";
	                sourceOpts.tileSize = 256;
	              } else if (sourceType === "image") {
	                field = "url";
	                sourceOpts.coordinates = opts.coordinates;
	              }
	              sourceOpts[field] = source;
	              if (opts.sourceattribution) {
	                sourceOpts.attribution = sanitizeHTML(opts.sourceattribution);
	              }
	              return sourceOpts;
	            }
	            module2.exports = function createMapboxLayer(subplot, index, opts) {
	              var mapboxLayer = new MapboxLayer(subplot, index);
	              mapboxLayer.update(opts);
	              return mapboxLayer;
	            };
	          }
	        ),
	        /***/
	        23585: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var defaultLine = __webpack_require__2(7901).defaultLine;
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var fontAttrs = __webpack_require__2(41940);
	            var textposition = __webpack_require__2(82196).textposition;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var constants = __webpack_require__2(77734);
	            var fontAttr = fontAttrs({});
	            fontAttr.family.dflt = "Open Sans Regular, Arial Unicode MS Regular";
	            var attrs = module2.exports = overrideAll({
	              _arrayAttrRegexps: [Lib.counterRegex("mapbox", ".layers", true)],
	              domain: domainAttrs({
	                name: "mapbox"
	              }),
	              accesstoken: {
	                valType: "string",
	                noBlank: true,
	                strict: true
	              },
	              style: {
	                valType: "any",
	                values: constants.styleValuesMapbox.concat(constants.styleValuesNonMapbox),
	                dflt: constants.styleValueDflt
	              },
	              center: {
	                lon: {
	                  valType: "number",
	                  dflt: 0
	                },
	                lat: {
	                  valType: "number",
	                  dflt: 0
	                }
	              },
	              zoom: {
	                valType: "number",
	                dflt: 1
	              },
	              bearing: {
	                valType: "number",
	                dflt: 0
	              },
	              pitch: {
	                valType: "number",
	                dflt: 0
	              },
	              bounds: {
	                west: {
	                  valType: "number"
	                },
	                east: {
	                  valType: "number"
	                },
	                south: {
	                  valType: "number"
	                },
	                north: {
	                  valType: "number"
	                }
	              },
	              layers: templatedArray("layer", {
	                visible: {
	                  valType: "boolean",
	                  dflt: true
	                },
	                sourcetype: {
	                  valType: "enumerated",
	                  values: ["geojson", "vector", "raster", "image"],
	                  dflt: "geojson"
	                },
	                source: {
	                  valType: "any"
	                },
	                sourcelayer: {
	                  valType: "string",
	                  dflt: ""
	                },
	                sourceattribution: {
	                  valType: "string"
	                },
	                type: {
	                  valType: "enumerated",
	                  values: ["circle", "line", "fill", "symbol", "raster"],
	                  dflt: "circle"
	                },
	                coordinates: {
	                  valType: "any"
	                },
	                // attributes shared between all types
	                below: {
	                  valType: "string"
	                },
	                color: {
	                  valType: "color",
	                  dflt: defaultLine
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                },
	                minzoom: {
	                  valType: "number",
	                  min: 0,
	                  max: 24,
	                  dflt: 0
	                },
	                maxzoom: {
	                  valType: "number",
	                  min: 0,
	                  max: 24,
	                  dflt: 24
	                },
	                // type-specific style attributes
	                circle: {
	                  radius: {
	                    valType: "number",
	                    dflt: 15
	                  }
	                },
	                line: {
	                  width: {
	                    valType: "number",
	                    dflt: 2
	                  },
	                  dash: {
	                    valType: "data_array"
	                  }
	                },
	                fill: {
	                  outlinecolor: {
	                    valType: "color",
	                    dflt: defaultLine
	                  }
	                },
	                symbol: {
	                  icon: {
	                    valType: "string",
	                    dflt: "marker"
	                  },
	                  iconsize: {
	                    valType: "number",
	                    dflt: 10
	                  },
	                  text: {
	                    valType: "string",
	                    dflt: ""
	                  },
	                  placement: {
	                    valType: "enumerated",
	                    values: ["point", "line", "line-center"],
	                    dflt: "point"
	                  },
	                  textfont: fontAttr,
	                  textposition: Lib.extendFlat({}, textposition, {
	                    arrayOk: false
	                  })
	                }
	              })
	            }, "plot", "from-root");
	            attrs.uirevision = {
	              valType: "any",
	              editType: "none"
	            };
	          }
	        ),
	        /***/
	        77882: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleSubplotDefaults = __webpack_require__2(49119);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var layoutAttributes = __webpack_require__2(23585);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	                type: "mapbox",
	                attributes: layoutAttributes,
	                handleDefaults,
	                partition: "y",
	                accessToken: layoutOut._mapboxAccessToken
	              });
	            };
	            function handleDefaults(containerIn, containerOut, coerce, opts) {
	              coerce("accesstoken", opts.accessToken);
	              coerce("style");
	              coerce("center.lon");
	              coerce("center.lat");
	              coerce("zoom");
	              coerce("bearing");
	              coerce("pitch");
	              var west = coerce("bounds.west");
	              var east = coerce("bounds.east");
	              var south = coerce("bounds.south");
	              var north = coerce("bounds.north");
	              if (west === undefined || east === undefined || south === undefined || north === undefined) {
	                delete containerOut.bounds;
	              }
	              handleArrayContainerDefaults(containerIn, containerOut, {
	                name: "layers",
	                handleItemDefaults: handleLayerDefaults
	              });
	              containerOut._input = containerIn;
	            }
	            function handleLayerDefaults(layerIn, layerOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layerIn, layerOut, layoutAttributes.layers, attr, dflt);
	              }
	              var visible = coerce("visible");
	              if (visible) {
	                var sourceType = coerce("sourcetype");
	                var mustBeRasterLayer = sourceType === "raster" || sourceType === "image";
	                coerce("source");
	                coerce("sourceattribution");
	                if (sourceType === "vector") {
	                  coerce("sourcelayer");
	                }
	                if (sourceType === "image") {
	                  coerce("coordinates");
	                }
	                var typeDflt;
	                if (mustBeRasterLayer) typeDflt = "raster";
	                var type = coerce("type", typeDflt);
	                if (mustBeRasterLayer && type !== "raster") {
	                  type = layerOut.type = "raster";
	                  Lib.log("Source types *raster* and *image* must drawn *raster* layer type.");
	                }
	                coerce("below");
	                coerce("color");
	                coerce("opacity");
	                coerce("minzoom");
	                coerce("maxzoom");
	                if (type === "circle") {
	                  coerce("circle.radius");
	                }
	                if (type === "line") {
	                  coerce("line.width");
	                  coerce("line.dash");
	                }
	                if (type === "fill") {
	                  coerce("fill.outlinecolor");
	                }
	                if (type === "symbol") {
	                  coerce("symbol.icon");
	                  coerce("symbol.iconsize");
	                  coerce("symbol.text");
	                  Lib.coerceFont(coerce, "symbol.textfont");
	                  coerce("symbol.textposition");
	                  coerce("symbol.placement");
	                }
	              }
	            }
	          }
	        ),
	        /***/
	        10481: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var mapboxgl = __webpack_require__2(44517);
	            var Lib = __webpack_require__2(71828);
	            var geoUtils = __webpack_require__2(41327);
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var dragElement = __webpack_require__2(28569);
	            var Fx = __webpack_require__2(30211);
	            var dragHelpers = __webpack_require__2(64505);
	            var drawMode = dragHelpers.drawMode;
	            var selectMode = dragHelpers.selectMode;
	            var prepSelect = __webpack_require__2(47322).prepSelect;
	            var clearOutline = __webpack_require__2(47322).clearOutline;
	            var clearSelectionsCache = __webpack_require__2(47322).clearSelectionsCache;
	            var selectOnClick = __webpack_require__2(47322).selectOnClick;
	            var constants = __webpack_require__2(77734);
	            var createMapboxLayer = __webpack_require__2(67911);
	            function Mapbox(gd, id) {
	              this.id = id;
	              this.gd = gd;
	              var fullLayout = gd._fullLayout;
	              var context = gd._context;
	              this.container = fullLayout._glcontainer.node();
	              this.isStatic = context.staticPlot;
	              this.uid = fullLayout._uid + "-" + this.id;
	              this.div = null;
	              this.xaxis = null;
	              this.yaxis = null;
	              this.createFramework(fullLayout);
	              this.map = null;
	              this.accessToken = null;
	              this.styleObj = null;
	              this.traceHash = {};
	              this.layerList = [];
	              this.belowLookup = {};
	              this.dragging = false;
	              this.wheeling = false;
	            }
	            var proto = Mapbox.prototype;
	            proto.plot = function(calcData, fullLayout, promises) {
	              var self2 = this;
	              var opts = fullLayout[self2.id];
	              if (self2.map && opts.accesstoken !== self2.accessToken) {
	                self2.map.remove();
	                self2.map = null;
	                self2.styleObj = null;
	                self2.traceHash = {};
	                self2.layerList = [];
	              }
	              var promise;
	              if (!self2.map) {
	                promise = new Promise(function(resolve, reject) {
	                  self2.createMap(calcData, fullLayout, resolve, reject);
	                });
	              } else {
	                promise = new Promise(function(resolve, reject) {
	                  self2.updateMap(calcData, fullLayout, resolve, reject);
	                });
	              }
	              promises.push(promise);
	            };
	            proto.createMap = function(calcData, fullLayout, resolve, reject) {
	              var self2 = this;
	              var opts = fullLayout[self2.id];
	              var styleObj = self2.styleObj = getStyleObj(opts.style, fullLayout);
	              self2.accessToken = opts.accesstoken;
	              var bounds = opts.bounds;
	              var maxBounds = bounds ? [[bounds.west, bounds.south], [bounds.east, bounds.north]] : null;
	              var map2 = self2.map = new mapboxgl.Map({
	                container: self2.div,
	                style: styleObj.style,
	                center: convertCenter(opts.center),
	                zoom: opts.zoom,
	                bearing: opts.bearing,
	                pitch: opts.pitch,
	                maxBounds,
	                interactive: !self2.isStatic,
	                preserveDrawingBuffer: self2.isStatic,
	                doubleClickZoom: false,
	                boxZoom: false,
	                attributionControl: false
	              }).addControl(new mapboxgl.AttributionControl({
	                compact: true
	              }));
	              map2._canvas.style.left = "0px";
	              map2._canvas.style.top = "0px";
	              self2.rejectOnError(reject);
	              if (!self2.isStatic) {
	                self2.initFx(calcData, fullLayout);
	              }
	              var promises = [];
	              promises.push(new Promise(function(resolve2) {
	                map2.once("load", resolve2);
	              }));
	              promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
	              Promise.all(promises).then(function() {
	                self2.fillBelowLookup(calcData, fullLayout);
	                self2.updateData(calcData);
	                self2.updateLayout(fullLayout);
	                self2.resolveOnRender(resolve);
	              }).catch(reject);
	            };
	            proto.updateMap = function(calcData, fullLayout, resolve, reject) {
	              var self2 = this;
	              var map2 = self2.map;
	              var opts = fullLayout[this.id];
	              self2.rejectOnError(reject);
	              var promises = [];
	              var styleObj = getStyleObj(opts.style, fullLayout);
	              if (JSON.stringify(self2.styleObj) !== JSON.stringify(styleObj)) {
	                self2.styleObj = styleObj;
	                map2.setStyle(styleObj.style);
	                self2.traceHash = {};
	                promises.push(new Promise(function(resolve2) {
	                  map2.once("styledata", resolve2);
	                }));
	              }
	              promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
	              Promise.all(promises).then(function() {
	                self2.fillBelowLookup(calcData, fullLayout);
	                self2.updateData(calcData);
	                self2.updateLayout(fullLayout);
	                self2.resolveOnRender(resolve);
	              }).catch(reject);
	            };
	            proto.fillBelowLookup = function(calcData, fullLayout) {
	              var opts = fullLayout[this.id];
	              var layers = opts.layers;
	              var i, val;
	              var belowLookup = this.belowLookup = {};
	              var hasTraceAtTop = false;
	              for (i = 0; i < calcData.length; i++) {
	                var trace = calcData[i][0].trace;
	                var _module = trace._module;
	                if (typeof trace.below === "string") {
	                  val = trace.below;
	                } else if (_module.getBelow) {
	                  val = _module.getBelow(trace, this);
	                }
	                if (val === "") {
	                  hasTraceAtTop = true;
	                }
	                belowLookup["trace-" + trace.uid] = val || "";
	              }
	              for (i = 0; i < layers.length; i++) {
	                var item = layers[i];
	                if (typeof item.below === "string") {
	                  val = item.below;
	                } else if (hasTraceAtTop) {
	                  val = "traces";
	                } else {
	                  val = "";
	                }
	                belowLookup["layout-" + i] = val;
	              }
	              var val2list = {};
	              var k, id;
	              for (k in belowLookup) {
	                val = belowLookup[k];
	                if (val2list[val]) {
	                  val2list[val].push(k);
	                } else {
	                  val2list[val] = [k];
	                }
	              }
	              for (val in val2list) {
	                var list = val2list[val];
	                if (list.length > 1) {
	                  for (i = 0; i < list.length; i++) {
	                    k = list[i];
	                    if (k.indexOf("trace-") === 0) {
	                      id = k.split("trace-")[1];
	                      if (this.traceHash[id]) {
	                        this.traceHash[id].below = null;
	                      }
	                    } else if (k.indexOf("layout-") === 0) {
	                      id = k.split("layout-")[1];
	                      if (this.layerList[id]) {
	                        this.layerList[id].below = null;
	                      }
	                    }
	                  }
	                }
	              }
	            };
	            var traceType2orderIndex = {
	              choroplethmapbox: 0,
	              densitymapbox: 1,
	              scattermapbox: 2
	            };
	            proto.updateData = function(calcData) {
	              var traceHash = this.traceHash;
	              var traceObj, trace, i, j;
	              var calcDataSorted = calcData.slice().sort(function(a, b) {
	                return traceType2orderIndex[a[0].trace.type] - traceType2orderIndex[b[0].trace.type];
	              });
	              for (i = 0; i < calcDataSorted.length; i++) {
	                var calcTrace = calcDataSorted[i];
	                trace = calcTrace[0].trace;
	                traceObj = traceHash[trace.uid];
	                var didUpdate = false;
	                if (traceObj) {
	                  if (traceObj.type === trace.type) {
	                    traceObj.update(calcTrace);
	                    didUpdate = true;
	                  } else {
	                    traceObj.dispose();
	                  }
	                }
	                if (!didUpdate && trace._module) {
	                  traceHash[trace.uid] = trace._module.plot(this, calcTrace);
	                }
	              }
	              var ids = Object.keys(traceHash);
	              idLoop: for (i = 0; i < ids.length; i++) {
	                var id = ids[i];
	                for (j = 0; j < calcData.length; j++) {
	                  trace = calcData[j][0].trace;
	                  if (id === trace.uid) continue idLoop;
	                }
	                traceObj = traceHash[id];
	                traceObj.dispose();
	                delete traceHash[id];
	              }
	            };
	            proto.updateLayout = function(fullLayout) {
	              var map2 = this.map;
	              var opts = fullLayout[this.id];
	              if (!this.dragging && !this.wheeling) {
	                map2.setCenter(convertCenter(opts.center));
	                map2.setZoom(opts.zoom);
	                map2.setBearing(opts.bearing);
	                map2.setPitch(opts.pitch);
	              }
	              this.updateLayers(fullLayout);
	              this.updateFramework(fullLayout);
	              this.updateFx(fullLayout);
	              this.map.resize();
	              if (this.gd._context._scrollZoom.mapbox) {
	                map2.scrollZoom.enable();
	              } else {
	                map2.scrollZoom.disable();
	              }
	            };
	            proto.resolveOnRender = function(resolve) {
	              var map2 = this.map;
	              map2.on("render", function onRender() {
	                if (map2.loaded()) {
	                  map2.off("render", onRender);
	                  setTimeout(resolve, 10);
	                }
	              });
	            };
	            proto.rejectOnError = function(reject) {
	              var map2 = this.map;
	              function handler() {
	                reject(new Error(constants.mapOnErrorMsg));
	              }
	              map2.once("error", handler);
	              map2.once("style.error", handler);
	              map2.once("source.error", handler);
	              map2.once("tile.error", handler);
	              map2.once("layer.error", handler);
	            };
	            proto.createFramework = function(fullLayout) {
	              var self2 = this;
	              var div = self2.div = document.createElement("div");
	              div.id = self2.uid;
	              div.style.position = "absolute";
	              self2.container.appendChild(div);
	              self2.xaxis = {
	                _id: "x",
	                c2p: function(v) {
	                  return self2.project(v).x;
	                }
	              };
	              self2.yaxis = {
	                _id: "y",
	                c2p: function(v) {
	                  return self2.project(v).y;
	                }
	              };
	              self2.updateFramework(fullLayout);
	              self2.mockAxis = {
	                type: "linear",
	                showexponent: "all",
	                exponentformat: "B"
	              };
	              Axes.setConvert(self2.mockAxis, fullLayout);
	            };
	            proto.initFx = function(calcData, fullLayout) {
	              var self2 = this;
	              var gd = self2.gd;
	              var map2 = self2.map;
	              map2.on("moveend", function(evt) {
	                if (!self2.map) return;
	                var fullLayoutNow = gd._fullLayout;
	                if (evt.originalEvent || self2.wheeling) {
	                  var optsNow = fullLayoutNow[self2.id];
	                  Registry.call("_storeDirectGUIEdit", gd.layout, fullLayoutNow._preGUI, self2.getViewEdits(optsNow));
	                  var viewNow = self2.getView();
	                  optsNow._input.center = optsNow.center = viewNow.center;
	                  optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
	                  optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
	                  optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
	                  gd.emit("plotly_relayout", self2.getViewEditsWithDerived(viewNow));
	                }
	                if (evt.originalEvent && evt.originalEvent.type === "mouseup") {
	                  self2.dragging = false;
	                } else if (self2.wheeling) {
	                  self2.wheeling = false;
	                }
	                if (fullLayoutNow._rehover) {
	                  fullLayoutNow._rehover();
	                }
	              });
	              map2.on("wheel", function() {
	                self2.wheeling = true;
	              });
	              map2.on("mousemove", function(evt) {
	                var bb = self2.div.getBoundingClientRect();
	                var xy = [evt.originalEvent.offsetX, evt.originalEvent.offsetY];
	                evt.target.getBoundingClientRect = function() {
	                  return bb;
	                };
	                self2.xaxis.p2c = function() {
	                  return map2.unproject(xy).lng;
	                };
	                self2.yaxis.p2c = function() {
	                  return map2.unproject(xy).lat;
	                };
	                gd._fullLayout._rehover = function() {
	                  if (gd._fullLayout._hoversubplot === self2.id && gd._fullLayout[self2.id]) {
	                    Fx.hover(gd, evt, self2.id);
	                  }
	                };
	                Fx.hover(gd, evt, self2.id);
	                gd._fullLayout._hoversubplot = self2.id;
	              });
	              function unhover() {
	                Fx.loneUnhover(fullLayout._hoverlayer);
	              }
	              map2.on("dragstart", function() {
	                self2.dragging = true;
	                unhover();
	              });
	              map2.on("zoomstart", unhover);
	              map2.on("mouseout", function() {
	                gd._fullLayout._hoversubplot = null;
	              });
	              function emitUpdate() {
	                var viewNow = self2.getView();
	                gd.emit("plotly_relayouting", self2.getViewEditsWithDerived(viewNow));
	              }
	              map2.on("drag", emitUpdate);
	              map2.on("zoom", emitUpdate);
	              map2.on("dblclick", function() {
	                var optsNow = gd._fullLayout[self2.id];
	                Registry.call("_storeDirectGUIEdit", gd.layout, gd._fullLayout._preGUI, self2.getViewEdits(optsNow));
	                var viewInitial = self2.viewInitial;
	                map2.setCenter(convertCenter(viewInitial.center));
	                map2.setZoom(viewInitial.zoom);
	                map2.setBearing(viewInitial.bearing);
	                map2.setPitch(viewInitial.pitch);
	                var viewNow = self2.getView();
	                optsNow._input.center = optsNow.center = viewNow.center;
	                optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
	                optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
	                optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
	                gd.emit("plotly_doubleclick", null);
	                gd.emit("plotly_relayout", self2.getViewEditsWithDerived(viewNow));
	              });
	              self2.clearOutline = function() {
	                clearSelectionsCache(self2.dragOptions);
	                clearOutline(self2.dragOptions.gd);
	              };
	              self2.onClickInPanFn = function(dragOptions) {
	                return function(evt) {
	                  var clickMode = gd._fullLayout.clickmode;
	                  if (clickMode.indexOf("select") > -1) {
	                    selectOnClick(evt.originalEvent, gd, [self2.xaxis], [self2.yaxis], self2.id, dragOptions);
	                  }
	                  if (clickMode.indexOf("event") > -1) {
	                    Fx.click(gd, evt.originalEvent);
	                  }
	                };
	              };
	            };
	            proto.updateFx = function(fullLayout) {
	              var self2 = this;
	              var map2 = self2.map;
	              var gd = self2.gd;
	              if (self2.isStatic) return;
	              function invert(pxpy) {
	                var obj = self2.map.unproject(pxpy);
	                return [obj.lng, obj.lat];
	              }
	              var dragMode = fullLayout.dragmode;
	              var fillRangeItems;
	              fillRangeItems = function(eventData, poly) {
	                if (poly.isRect) {
	                  var ranges = eventData.range = {};
	                  ranges[self2.id] = [invert([poly.xmin, poly.ymin]), invert([poly.xmax, poly.ymax])];
	                } else {
	                  var dataPts = eventData.lassoPoints = {};
	                  dataPts[self2.id] = poly.map(invert);
	                }
	              };
	              var oldDragOptions = self2.dragOptions;
	              self2.dragOptions = Lib.extendDeep(oldDragOptions || {}, {
	                dragmode: fullLayout.dragmode,
	                element: self2.div,
	                gd,
	                plotinfo: {
	                  id: self2.id,
	                  domain: fullLayout[self2.id].domain,
	                  xaxis: self2.xaxis,
	                  yaxis: self2.yaxis,
	                  fillRangeItems
	                },
	                xaxes: [self2.xaxis],
	                yaxes: [self2.yaxis],
	                subplot: self2.id
	              });
	              map2.off("click", self2.onClickInPanHandler);
	              if (selectMode(dragMode) || drawMode(dragMode)) {
	                map2.dragPan.disable();
	                map2.on("zoomstart", self2.clearOutline);
	                self2.dragOptions.prepFn = function(e, startX, startY) {
	                  prepSelect(e, startX, startY, self2.dragOptions, dragMode);
	                };
	                dragElement.init(self2.dragOptions);
	              } else {
	                map2.dragPan.enable();
	                map2.off("zoomstart", self2.clearOutline);
	                self2.div.onmousedown = null;
	                self2.div.ontouchstart = null;
	                self2.div.removeEventListener("touchstart", self2.div._ontouchstart);
	                self2.onClickInPanHandler = self2.onClickInPanFn(self2.dragOptions);
	                map2.on("click", self2.onClickInPanHandler);
	              }
	            };
	            proto.updateFramework = function(fullLayout) {
	              var domain = fullLayout[this.id].domain;
	              var size = fullLayout._size;
	              var style = this.div.style;
	              style.width = size.w * (domain.x[1] - domain.x[0]) + "px";
	              style.height = size.h * (domain.y[1] - domain.y[0]) + "px";
	              style.left = size.l + domain.x[0] * size.w + "px";
	              style.top = size.t + (1 - domain.y[1]) * size.h + "px";
	              this.xaxis._offset = size.l + domain.x[0] * size.w;
	              this.xaxis._length = size.w * (domain.x[1] - domain.x[0]);
	              this.yaxis._offset = size.t + (1 - domain.y[1]) * size.h;
	              this.yaxis._length = size.h * (domain.y[1] - domain.y[0]);
	            };
	            proto.updateLayers = function(fullLayout) {
	              var opts = fullLayout[this.id];
	              var layers = opts.layers;
	              var layerList = this.layerList;
	              var i;
	              if (layers.length !== layerList.length) {
	                for (i = 0; i < layerList.length; i++) {
	                  layerList[i].dispose();
	                }
	                layerList = this.layerList = [];
	                for (i = 0; i < layers.length; i++) {
	                  layerList.push(createMapboxLayer(this, i, layers[i]));
	                }
	              } else {
	                for (i = 0; i < layers.length; i++) {
	                  layerList[i].update(layers[i]);
	                }
	              }
	            };
	            proto.destroy = function() {
	              if (this.map) {
	                this.map.remove();
	                this.map = null;
	                this.container.removeChild(this.div);
	              }
	            };
	            proto.toImage = function() {
	              this.map.stop();
	              return this.map.getCanvas().toDataURL();
	            };
	            proto.setOptions = function(id, methodName, opts) {
	              for (var k in opts) {
	                this.map[methodName](id, k, opts[k]);
	              }
	            };
	            proto.getMapLayers = function() {
	              return this.map.getStyle().layers;
	            };
	            proto.addLayer = function(opts, below) {
	              var map2 = this.map;
	              if (typeof below === "string") {
	                if (below === "") {
	                  map2.addLayer(opts, below);
	                  return;
	                }
	                var mapLayers = this.getMapLayers();
	                for (var i = 0; i < mapLayers.length; i++) {
	                  if (below === mapLayers[i].id) {
	                    map2.addLayer(opts, below);
	                    return;
	                  }
	                }
	                Lib.warn(["Trying to add layer with *below* value", below, "referencing a layer that does not exist", "or that does not yet exist."].join(" "));
	              }
	              map2.addLayer(opts);
	            };
	            proto.project = function(v) {
	              return this.map.project(new mapboxgl.LngLat(v[0], v[1]));
	            };
	            proto.getView = function() {
	              var map2 = this.map;
	              var mapCenter = map2.getCenter();
	              var lon = mapCenter.lng;
	              var lat = mapCenter.lat;
	              var center = {
	                lon,
	                lat
	              };
	              var canvas = map2.getCanvas();
	              var w = parseInt(canvas.style.width);
	              var h = parseInt(canvas.style.height);
	              return {
	                center,
	                zoom: map2.getZoom(),
	                bearing: map2.getBearing(),
	                pitch: map2.getPitch(),
	                _derived: {
	                  coordinates: [map2.unproject([0, 0]).toArray(), map2.unproject([w, 0]).toArray(), map2.unproject([w, h]).toArray(), map2.unproject([0, h]).toArray()]
	                }
	              };
	            };
	            proto.getViewEdits = function(cont) {
	              var id = this.id;
	              var keys = ["center", "zoom", "bearing", "pitch"];
	              var obj = {};
	              for (var i = 0; i < keys.length; i++) {
	                var k = keys[i];
	                obj[id + "." + k] = cont[k];
	              }
	              return obj;
	            };
	            proto.getViewEditsWithDerived = function(cont) {
	              var id = this.id;
	              var obj = this.getViewEdits(cont);
	              obj[id + "._derived"] = cont._derived;
	              return obj;
	            };
	            function getStyleObj(val, fullLayout) {
	              var styleObj = {};
	              if (Lib.isPlainObject(val)) {
	                styleObj.id = val.id;
	                styleObj.style = val;
	              } else if (typeof val === "string") {
	                styleObj.id = val;
	                if (constants.styleValuesMapbox.indexOf(val) !== -1) {
	                  styleObj.style = convertStyleVal(val);
	                } else if (constants.stylesNonMapbox[val]) {
	                  styleObj.style = constants.stylesNonMapbox[val];
	                  var spec = styleObj.style.sources["plotly-" + val];
	                  var tiles = spec ? spec.tiles : undefined;
	                  if (tiles && tiles[0] && tiles[0].slice(-9) === "?api_key=") {
	                    tiles[0] += fullLayout._mapboxAccessToken;
	                  }
	                } else {
	                  styleObj.style = val;
	                }
	              } else {
	                styleObj.id = constants.styleValueDflt;
	                styleObj.style = convertStyleVal(constants.styleValueDflt);
	              }
	              styleObj.transition = {
	                duration: 0,
	                delay: 0
	              };
	              return styleObj;
	            }
	            function convertStyleVal(val) {
	              return constants.styleUrlPrefix + val + "-" + constants.styleUrlSuffix;
	            }
	            function convertCenter(center) {
	              return [center.lon, center.lat];
	            }
	            module2.exports = Mapbox;
	          }
	        ),
	        /***/
	        35025: (
	          /***/
	          function(module2) {
	            module2.exports = function(opts) {
	              var editType = opts.editType;
	              return {
	                t: {
	                  valType: "number",
	                  dflt: 0,
	                  editType
	                },
	                r: {
	                  valType: "number",
	                  dflt: 0,
	                  editType
	                },
	                b: {
	                  valType: "number",
	                  dflt: 0,
	                  editType
	                },
	                l: {
	                  valType: "number",
	                  dflt: 0,
	                  editType
	                },
	                editType
	              };
	            };
	          }
	        ),
	        /***/
	        74875: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var timeFormatLocale = __webpack_require__2(84096).Dq;
	            var formatLocale = __webpack_require__2(60721).FF;
	            var isNumeric = __webpack_require__2(92770);
	            var Registry = __webpack_require__2(73972);
	            var PlotSchema = __webpack_require__2(86281);
	            var Template = __webpack_require__2(44467);
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var axisIDs = __webpack_require__2(41675);
	            var clearOutline = __webpack_require__2(51873).clearOutline;
	            var scatterAttrs = __webpack_require__2(21479);
	            var animationAttrs = __webpack_require__2(85594);
	            var frameAttrs = __webpack_require__2(31391);
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var relinkPrivateKeys = Lib.relinkPrivateKeys;
	            var _ = Lib._;
	            var plots = module2.exports = {};
	            Lib.extendFlat(plots, Registry);
	            plots.attributes = __webpack_require__2(9012);
	            plots.attributes.type.values = plots.allTypes;
	            plots.fontAttrs = __webpack_require__2(41940);
	            plots.layoutAttributes = __webpack_require__2(10820);
	            plots.fontWeight = "normal";
	            var transformsRegistry = plots.transformsRegistry;
	            var commandModule = __webpack_require__2(31137);
	            plots.executeAPICommand = commandModule.executeAPICommand;
	            plots.computeAPICommandBindings = commandModule.computeAPICommandBindings;
	            plots.manageCommandObserver = commandModule.manageCommandObserver;
	            plots.hasSimpleAPICommandBindings = commandModule.hasSimpleAPICommandBindings;
	            plots.redrawText = function(gd) {
	              gd = Lib.getGraphDiv(gd);
	              return new Promise(function(resolve) {
	                setTimeout(function() {
	                  if (!gd._fullLayout) return;
	                  Registry.getComponentMethod("annotations", "draw")(gd);
	                  Registry.getComponentMethod("legend", "draw")(gd);
	                  Registry.getComponentMethod("colorbar", "draw")(gd);
	                  resolve(plots.previousPromises(gd));
	                }, 300);
	              });
	            };
	            plots.resize = function(gd) {
	              gd = Lib.getGraphDiv(gd);
	              var resolveLastResize;
	              var p = new Promise(function(resolve, reject) {
	                if (!gd || Lib.isHidden(gd)) {
	                  reject(new Error("Resize must be passed a displayed plot div element."));
	                }
	                if (gd._redrawTimer) clearTimeout(gd._redrawTimer);
	                if (gd._resolveResize) resolveLastResize = gd._resolveResize;
	                gd._resolveResize = resolve;
	                gd._redrawTimer = setTimeout(function() {
	                  if (!gd.layout || gd.layout.width && gd.layout.height || Lib.isHidden(gd)) {
	                    resolve(gd);
	                    return;
	                  }
	                  delete gd.layout.width;
	                  delete gd.layout.height;
	                  var oldchanged = gd.changed;
	                  gd.autoplay = true;
	                  Registry.call("relayout", gd, {
	                    autosize: true
	                  }).then(function() {
	                    gd.changed = oldchanged;
	                    if (gd._resolveResize === resolve) {
	                      delete gd._resolveResize;
	                      resolve(gd);
	                    }
	                  });
	                }, 100);
	              });
	              if (resolveLastResize) resolveLastResize(p);
	              return p;
	            };
	            plots.previousPromises = function(gd) {
	              if ((gd._promises || []).length) {
	                return Promise.all(gd._promises).then(function() {
	                  gd._promises = [];
	                });
	              }
	            };
	            plots.addLinks = function(gd) {
	              if (!gd._context.showLink && !gd._context.showSources) return;
	              var fullLayout = gd._fullLayout;
	              var linkContainer = Lib.ensureSingle(fullLayout._paper, "text", "js-plot-link-container", function(s) {
	                s.style({
	                  "font-family": '"Open Sans", Arial, sans-serif',
	                  "font-size": "12px",
	                  fill: Color.defaultLine,
	                  "pointer-events": "all"
	                }).each(function() {
	                  var links = d3.select(this);
	                  links.append("tspan").classed("js-link-to-tool", true);
	                  links.append("tspan").classed("js-link-spacer", true);
	                  links.append("tspan").classed("js-sourcelinks", true);
	                });
	              });
	              var text = linkContainer.node();
	              var attrs = {
	                y: fullLayout._paper.attr("height") - 9
	              };
	              if (document.body.contains(text) && text.getComputedTextLength() >= fullLayout.width - 20) {
	                attrs["text-anchor"] = "start";
	                attrs.x = 5;
	              } else {
	                attrs["text-anchor"] = "end";
	                attrs.x = fullLayout._paper.attr("width") - 7;
	              }
	              linkContainer.attr(attrs);
	              var toolspan = linkContainer.select(".js-link-to-tool");
	              var spacespan = linkContainer.select(".js-link-spacer");
	              var sourcespan = linkContainer.select(".js-sourcelinks");
	              if (gd._context.showSources) gd._context.showSources(gd);
	              if (gd._context.showLink) positionPlayWithData(gd, toolspan);
	              spacespan.text(toolspan.text() && sourcespan.text() ? " - " : "");
	            };
	            function positionPlayWithData(gd, container) {
	              container.text("");
	              var link = container.append("a").attr({
	                "xlink:xlink:href": "#",
	                class: "link--impt link--embedview",
	                "font-weight": "bold"
	              }).text(gd._context.linkText + " " + String.fromCharCode(187));
	              if (gd._context.sendData) {
	                link.on("click", function() {
	                  plots.sendDataToCloud(gd);
	                });
	              } else {
	                var path = window.location.pathname.split("/");
	                var query = window.location.search;
	                link.attr({
	                  "xlink:xlink:show": "new",
	                  "xlink:xlink:href": "/" + path[2].split(".")[0] + "/" + path[1] + query
	                });
	              }
	            }
	            plots.sendDataToCloud = function(gd) {
	              var baseUrl = (window.PLOTLYENV || {}).BASE_URL || gd._context.plotlyServerURL;
	              if (!baseUrl) return;
	              gd.emit("plotly_beforeexport");
	              var hiddenformDiv = d3.select(gd).append("div").attr("id", "hiddenform").style("display", "none");
	              var hiddenform = hiddenformDiv.append("form").attr({
	                action: baseUrl + "/external",
	                method: "post",
	                target: "_blank"
	              });
	              var hiddenformInput = hiddenform.append("input").attr({
	                type: "text",
	                name: "data"
	              });
	              hiddenformInput.node().value = plots.graphJson(gd, false, "keepdata");
	              hiddenform.node().submit();
	              hiddenformDiv.remove();
	              gd.emit("plotly_afterexport");
	              return false;
	            };
	            var d3FormatKeys = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"];
	            var extraFormatKeys = ["year", "month", "dayMonth", "dayMonthYear"];
	            plots.supplyDefaults = function(gd, opts) {
	              var skipUpdateCalc = opts && opts.skipUpdateCalc;
	              var oldFullLayout = gd._fullLayout || {};
	              if (oldFullLayout._skipDefaults) {
	                delete oldFullLayout._skipDefaults;
	                return;
	              }
	              var newFullLayout = gd._fullLayout = {};
	              var newLayout = gd.layout || {};
	              var oldFullData = gd._fullData || [];
	              var newFullData = gd._fullData = [];
	              var newData = gd.data || [];
	              var oldCalcdata = gd.calcdata || [];
	              var context = gd._context || {};
	              var i;
	              if (!gd._transitionData) plots.createTransitionData(gd);
	              newFullLayout._dfltTitle = {
	                plot: _(gd, "Click to enter Plot title"),
	                x: _(gd, "Click to enter X axis title"),
	                y: _(gd, "Click to enter Y axis title"),
	                colorbar: _(gd, "Click to enter Colorscale title"),
	                annotation: _(gd, "new text")
	              };
	              newFullLayout._traceWord = _(gd, "trace");
	              var formatObj = getFormatObj(gd, d3FormatKeys);
	              newFullLayout._mapboxAccessToken = context.mapboxAccessToken;
	              if (oldFullLayout._initialAutoSizeIsDone) {
	                var oldWidth = oldFullLayout.width;
	                var oldHeight = oldFullLayout.height;
	                plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
	                if (!newLayout.width) newFullLayout.width = oldWidth;
	                if (!newLayout.height) newFullLayout.height = oldHeight;
	                plots.sanitizeMargins(newFullLayout);
	              } else {
	                plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
	                var missingWidthOrHeight = !newLayout.width || !newLayout.height;
	                var autosize = newFullLayout.autosize;
	                var autosizable = context.autosizable;
	                var initialAutoSize = missingWidthOrHeight && (autosize || autosizable);
	                if (initialAutoSize) plots.plotAutoSize(gd, newLayout, newFullLayout);
	                else if (missingWidthOrHeight) plots.sanitizeMargins(newFullLayout);
	                if (!autosize && missingWidthOrHeight) {
	                  newLayout.width = newFullLayout.width;
	                  newLayout.height = newFullLayout.height;
	                }
	              }
	              newFullLayout._d3locale = getFormatter(formatObj, newFullLayout.separators);
	              newFullLayout._extraFormat = getFormatObj(gd, extraFormatKeys);
	              newFullLayout._initialAutoSizeIsDone = true;
	              newFullLayout._dataLength = newData.length;
	              newFullLayout._modules = [];
	              newFullLayout._visibleModules = [];
	              newFullLayout._basePlotModules = [];
	              var subplots = newFullLayout._subplots = emptySubplotLists();
	              var splomAxes = newFullLayout._splomAxes = {
	                x: {},
	                y: {}
	              };
	              var splomSubplots = newFullLayout._splomSubplots = {};
	              newFullLayout._splomGridDflt = {};
	              newFullLayout._scatterStackOpts = {};
	              newFullLayout._firstScatter = {};
	              newFullLayout._alignmentOpts = {};
	              newFullLayout._colorAxes = {};
	              newFullLayout._requestRangeslider = {};
	              newFullLayout._traceUids = getTraceUids(oldFullData, newData);
	              newFullLayout._globalTransforms = (gd._context || {}).globalTransforms;
	              plots.supplyDataDefaults(newData, newFullData, newLayout, newFullLayout);
	              var splomXa = Object.keys(splomAxes.x);
	              var splomYa = Object.keys(splomAxes.y);
	              if (splomXa.length > 1 && splomYa.length > 1) {
	                Registry.getComponentMethod("grid", "sizeDefaults")(newLayout, newFullLayout);
	                for (i = 0; i < splomXa.length; i++) {
	                  Lib.pushUnique(subplots.xaxis, splomXa[i]);
	                }
	                for (i = 0; i < splomYa.length; i++) {
	                  Lib.pushUnique(subplots.yaxis, splomYa[i]);
	                }
	                for (var k in splomSubplots) {
	                  Lib.pushUnique(subplots.cartesian, k);
	                }
	              }
	              newFullLayout._has = plots._hasPlotType.bind(newFullLayout);
	              if (oldFullData.length === newFullData.length) {
	                for (i = 0; i < newFullData.length; i++) {
	                  relinkPrivateKeys(newFullData[i], oldFullData[i]);
	                }
	              }
	              plots.supplyLayoutModuleDefaults(newLayout, newFullLayout, newFullData, gd._transitionData);
	              var _modules = newFullLayout._visibleModules;
	              var crossTraceDefaultsFuncs = [];
	              for (i = 0; i < _modules.length; i++) {
	                var funci = _modules[i].crossTraceDefaults;
	                if (funci) Lib.pushUnique(crossTraceDefaultsFuncs, funci);
	              }
	              for (i = 0; i < crossTraceDefaultsFuncs.length; i++) {
	                crossTraceDefaultsFuncs[i](newFullData, newFullLayout);
	              }
	              newFullLayout._hasOnlyLargeSploms = newFullLayout._basePlotModules.length === 1 && newFullLayout._basePlotModules[0].name === "splom" && splomXa.length > 15 && splomYa.length > 15 && newFullLayout.shapes.length === 0 && newFullLayout.images.length === 0;
	              plots.linkSubplots(newFullData, newFullLayout, oldFullData, oldFullLayout);
	              plots.cleanPlot(newFullData, newFullLayout, oldFullData, oldFullLayout);
	              var hadGL2D = !!(oldFullLayout._has && oldFullLayout._has("gl2d"));
	              var hasGL2D = !!(newFullLayout._has && newFullLayout._has("gl2d"));
	              var hadCartesian = !!(oldFullLayout._has && oldFullLayout._has("cartesian"));
	              var hasCartesian = !!(newFullLayout._has && newFullLayout._has("cartesian"));
	              var hadBgLayer = hadCartesian || hadGL2D;
	              var hasBgLayer = hasCartesian || hasGL2D;
	              if (hadBgLayer && !hasBgLayer) {
	                oldFullLayout._bgLayer.remove();
	              } else if (hasBgLayer && !hadBgLayer) {
	                newFullLayout._shouldCreateBgLayer = true;
	              }
	              if (oldFullLayout._zoomlayer && !gd._dragging) {
	                clearOutline({
	                  // mock old gd
	                  _fullLayout: oldFullLayout
	                });
	              }
	              fillMetaTextHelpers(newFullData, newFullLayout);
	              relinkPrivateKeys(newFullLayout, oldFullLayout);
	              Registry.getComponentMethod("colorscale", "crossTraceDefaults")(newFullData, newFullLayout);
	              if (!newFullLayout._preGUI) newFullLayout._preGUI = {};
	              if (!newFullLayout._tracePreGUI) newFullLayout._tracePreGUI = {};
	              var tracePreGUI = newFullLayout._tracePreGUI;
	              var uids = {};
	              var uid;
	              for (uid in tracePreGUI) uids[uid] = "old";
	              for (i = 0; i < newFullData.length; i++) {
	                uid = newFullData[i]._fullInput.uid;
	                if (!uids[uid]) tracePreGUI[uid] = {};
	                uids[uid] = "new";
	              }
	              for (uid in uids) {
	                if (uids[uid] === "old") delete tracePreGUI[uid];
	              }
	              initMargins(newFullLayout);
	              Registry.getComponentMethod("rangeslider", "makeData")(newFullLayout);
	              if (!skipUpdateCalc && oldCalcdata.length === newFullData.length) {
	                plots.supplyDefaultsUpdateCalc(oldCalcdata, newFullData);
	              }
	            };
	            plots.supplyDefaultsUpdateCalc = function(oldCalcdata, newFullData) {
	              for (var i = 0; i < newFullData.length; i++) {
	                var newTrace = newFullData[i];
	                var cd0 = (oldCalcdata[i] || [])[0];
	                if (cd0 && cd0.trace) {
	                  var oldTrace = cd0.trace;
	                  if (oldTrace._hasCalcTransform) {
	                    var arrayAttrs = oldTrace._arrayAttrs;
	                    var j, astr, oldArrayVal;
	                    for (j = 0; j < arrayAttrs.length; j++) {
	                      astr = arrayAttrs[j];
	                      oldArrayVal = Lib.nestedProperty(oldTrace, astr).get().slice();
	                      Lib.nestedProperty(newTrace, astr).set(oldArrayVal);
	                    }
	                  }
	                  cd0.trace = newTrace;
	                }
	              }
	            };
	            function getTraceUids(oldFullData, newData) {
	              var len = newData.length;
	              var oldFullInput = [];
	              var i, prevFullInput;
	              for (i = 0; i < oldFullData.length; i++) {
	                var thisFullInput = oldFullData[i]._fullInput;
	                if (thisFullInput !== prevFullInput) oldFullInput.push(thisFullInput);
	                prevFullInput = thisFullInput;
	              }
	              var oldLen = oldFullInput.length;
	              var out = new Array(len);
	              var seenUids = {};
	              function setUid(uid, i2) {
	                out[i2] = uid;
	                seenUids[uid] = 1;
	              }
	              function tryUid(uid, i2) {
	                if (uid && typeof uid === "string" && !seenUids[uid]) {
	                  setUid(uid, i2);
	                  return true;
	                }
	              }
	              for (i = 0; i < len; i++) {
	                var newUid = newData[i].uid;
	                if (typeof newUid === "number") newUid = String(newUid);
	                if (tryUid(newUid, i)) continue;
	                if (i < oldLen && tryUid(oldFullInput[i].uid, i)) continue;
	                setUid(Lib.randstr(seenUids), i);
	              }
	              return out;
	            }
	            function emptySubplotLists() {
	              var collectableSubplotTypes = Registry.collectableSubplotTypes;
	              var out = {};
	              var i, j;
	              if (!collectableSubplotTypes) {
	                collectableSubplotTypes = [];
	                var subplotsRegistry = Registry.subplotsRegistry;
	                for (var subplotType in subplotsRegistry) {
	                  var subplotModule = subplotsRegistry[subplotType];
	                  var subplotAttr = subplotModule.attr;
	                  if (subplotAttr) {
	                    collectableSubplotTypes.push(subplotType);
	                    if (Array.isArray(subplotAttr)) {
	                      for (j = 0; j < subplotAttr.length; j++) {
	                        Lib.pushUnique(collectableSubplotTypes, subplotAttr[j]);
	                      }
	                    }
	                  }
	                }
	              }
	              for (i = 0; i < collectableSubplotTypes.length; i++) {
	                out[collectableSubplotTypes[i]] = [];
	              }
	              return out;
	            }
	            function getFormatObj(gd, formatKeys) {
	              var locale = gd._context.locale;
	              if (!locale) locale = "en-US";
	              var formatDone = false;
	              var formatObj = {};
	              function includeFormat(newFormat) {
	                var formatFinished = true;
	                for (var i2 = 0; i2 < formatKeys.length; i2++) {
	                  var formatKey = formatKeys[i2];
	                  if (!formatObj[formatKey]) {
	                    if (newFormat[formatKey]) {
	                      formatObj[formatKey] = newFormat[formatKey];
	                    } else formatFinished = false;
	                  }
	                }
	                if (formatFinished) formatDone = true;
	              }
	              for (var i = 0; i < 2; i++) {
	                var locales = gd._context.locales;
	                for (var j = 0; j < 2; j++) {
	                  var formatj = (locales[locale] || {}).format;
	                  if (formatj) {
	                    includeFormat(formatj);
	                    if (formatDone) break;
	                  }
	                  locales = Registry.localeRegistry;
	                }
	                var baseLocale = locale.split("-")[0];
	                if (formatDone || baseLocale === locale) break;
	                locale = baseLocale;
	              }
	              if (!formatDone) includeFormat(Registry.localeRegistry.en.format);
	              return formatObj;
	            }
	            function getFormatter(formatObj, separators) {
	              formatObj.decimal = separators.charAt(0);
	              formatObj.thousands = separators.charAt(1);
	              return {
	                numberFormat: function(formatStr) {
	                  try {
	                    formatStr = formatLocale(formatObj).format(Lib.adjustFormat(formatStr));
	                  } catch (e) {
	                    Lib.warnBadFormat(formatStr);
	                    return Lib.noFormat;
	                  }
	                  return formatStr;
	                },
	                timeFormat: timeFormatLocale(formatObj).utcFormat
	              };
	            }
	            function fillMetaTextHelpers(newFullData, newFullLayout) {
	              var _meta;
	              var meta4data = [];
	              if (newFullLayout.meta) {
	                _meta = newFullLayout._meta = {
	                  meta: newFullLayout.meta,
	                  layout: {
	                    meta: newFullLayout.meta
	                  }
	                };
	              }
	              for (var i = 0; i < newFullData.length; i++) {
	                var trace = newFullData[i];
	                if (trace.meta) {
	                  meta4data[trace.index] = trace._meta = {
	                    meta: trace.meta
	                  };
	                } else if (newFullLayout.meta) {
	                  trace._meta = {
	                    meta: newFullLayout.meta
	                  };
	                }
	                if (newFullLayout.meta) {
	                  trace._meta.layout = {
	                    meta: newFullLayout.meta
	                  };
	                }
	              }
	              if (meta4data.length) {
	                if (!_meta) {
	                  _meta = newFullLayout._meta = {};
	                }
	                _meta.data = meta4data;
	              }
	            }
	            plots.createTransitionData = function(gd) {
	              if (!gd._transitionData) {
	                gd._transitionData = {};
	              }
	              if (!gd._transitionData._frames) {
	                gd._transitionData._frames = [];
	              }
	              if (!gd._transitionData._frameHash) {
	                gd._transitionData._frameHash = {};
	              }
	              if (!gd._transitionData._counter) {
	                gd._transitionData._counter = 0;
	              }
	              if (!gd._transitionData._interruptCallbacks) {
	                gd._transitionData._interruptCallbacks = [];
	              }
	            };
	            plots._hasPlotType = function(category) {
	              var i;
	              var basePlotModules = this._basePlotModules || [];
	              for (i = 0; i < basePlotModules.length; i++) {
	                if (basePlotModules[i].name === category) return true;
	              }
	              var modules = this._modules || [];
	              for (i = 0; i < modules.length; i++) {
	                var name2 = modules[i].name;
	                if (name2 === category) return true;
	                var _module = Registry.modules[name2];
	                if (_module && _module.categories[category]) return true;
	              }
	              return false;
	            };
	            plots.cleanPlot = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var i, j;
	              var basePlotModules = oldFullLayout._basePlotModules || [];
	              for (i = 0; i < basePlotModules.length; i++) {
	                var _module = basePlotModules[i];
	                if (_module.clean) {
	                  _module.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
	                }
	              }
	              var hadGl = oldFullLayout._has && oldFullLayout._has("gl");
	              var hasGl = newFullLayout._has && newFullLayout._has("gl");
	              if (hadGl && !hasGl) {
	                if (oldFullLayout._glcontainer !== undefined) {
	                  oldFullLayout._glcontainer.selectAll(".gl-canvas").remove();
	                  oldFullLayout._glcontainer.selectAll(".no-webgl").remove();
	                  oldFullLayout._glcanvas = null;
	                }
	              }
	              var hasInfoLayer = !!oldFullLayout._infolayer;
	              oldLoop: for (i = 0; i < oldFullData.length; i++) {
	                var oldTrace = oldFullData[i];
	                var oldUid = oldTrace.uid;
	                for (j = 0; j < newFullData.length; j++) {
	                  var newTrace = newFullData[j];
	                  if (oldUid === newTrace.uid) continue oldLoop;
	                }
	                if (hasInfoLayer) {
	                  oldFullLayout._infolayer.select(".cb" + oldUid).remove();
	                }
	              }
	            };
	            plots.linkSubplots = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var i, j;
	              var oldSubplots = oldFullLayout._plots || {};
	              var newSubplots = newFullLayout._plots = {};
	              var newSubplotList = newFullLayout._subplots;
	              var mockGd = {
	                _fullData: newFullData,
	                _fullLayout: newFullLayout
	              };
	              var ids = newSubplotList.cartesian.concat(newSubplotList.gl2d || []);
	              for (i = 0; i < ids.length; i++) {
	                var id = ids[i];
	                var oldSubplot = oldSubplots[id];
	                var xaxis = axisIDs.getFromId(mockGd, id, "x");
	                var yaxis = axisIDs.getFromId(mockGd, id, "y");
	                var plotinfo;
	                if (oldSubplot) {
	                  plotinfo = newSubplots[id] = oldSubplot;
	                } else {
	                  plotinfo = newSubplots[id] = {};
	                  plotinfo.id = id;
	                }
	                xaxis._counterAxes.push(yaxis._id);
	                yaxis._counterAxes.push(xaxis._id);
	                xaxis._subplotsWith.push(id);
	                yaxis._subplotsWith.push(id);
	                plotinfo.xaxis = xaxis;
	                plotinfo.yaxis = yaxis;
	                plotinfo._hasClipOnAxisFalse = false;
	                for (j = 0; j < newFullData.length; j++) {
	                  var trace = newFullData[j];
	                  if (trace.xaxis === plotinfo.xaxis._id && trace.yaxis === plotinfo.yaxis._id && trace.cliponaxis === false) {
	                    plotinfo._hasClipOnAxisFalse = true;
	                    break;
	                  }
	                }
	              }
	              var axList = axisIDs.list(mockGd, null, true);
	              var ax;
	              for (i = 0; i < axList.length; i++) {
	                ax = axList[i];
	                var mainAx = null;
	                if (ax.overlaying) {
	                  mainAx = axisIDs.getFromId(mockGd, ax.overlaying);
	                  if (mainAx && mainAx.overlaying) {
	                    ax.overlaying = false;
	                    mainAx = null;
	                  }
	                }
	                ax._mainAxis = mainAx || ax;
	                if (mainAx) ax.domain = mainAx.domain.slice();
	                ax._anchorAxis = ax.anchor === "free" ? null : axisIDs.getFromId(mockGd, ax.anchor);
	              }
	              for (i = 0; i < axList.length; i++) {
	                ax = axList[i];
	                ax._counterAxes.sort(axisIDs.idSort);
	                ax._subplotsWith.sort(Lib.subplotSort);
	                ax._mainSubplot = findMainSubplot(ax, newFullLayout);
	                if (ax._counterAxes.length && (ax.spikemode && ax.spikemode.indexOf("across") !== -1 || ax.automargin && ax.mirror && ax.anchor !== "free" || Registry.getComponentMethod("rangeslider", "isVisible")(ax))) {
	                  var min = 1;
	                  var max = 0;
	                  for (j = 0; j < ax._counterAxes.length; j++) {
	                    var ax2 = axisIDs.getFromId(mockGd, ax._counterAxes[j]);
	                    min = Math.min(min, ax2.domain[0]);
	                    max = Math.max(max, ax2.domain[1]);
	                  }
	                  if (min < max) {
	                    ax._counterDomainMin = min;
	                    ax._counterDomainMax = max;
	                  }
	                }
	              }
	            };
	            function findMainSubplot(ax, fullLayout) {
	              var mockGd = {
	                _fullLayout: fullLayout
	              };
	              var isX = ax._id.charAt(0) === "x";
	              var anchorAx = ax._mainAxis._anchorAxis;
	              var mainSubplotID = "";
	              var nextBestMainSubplotID = "";
	              var anchorID = "";
	              if (anchorAx) {
	                anchorID = anchorAx._mainAxis._id;
	                mainSubplotID = isX ? ax._id + anchorID : anchorID + ax._id;
	              }
	              if (!mainSubplotID || !fullLayout._plots[mainSubplotID]) {
	                mainSubplotID = "";
	                var counterIDs = ax._counterAxes;
	                for (var j = 0; j < counterIDs.length; j++) {
	                  var counterPart = counterIDs[j];
	                  var id = isX ? ax._id + counterPart : counterPart + ax._id;
	                  if (!nextBestMainSubplotID) nextBestMainSubplotID = id;
	                  var counterAx = axisIDs.getFromId(mockGd, counterPart);
	                  if (anchorID && counterAx.overlaying === anchorID) {
	                    mainSubplotID = id;
	                    break;
	                  }
	                }
	              }
	              return mainSubplotID || nextBestMainSubplotID;
	            }
	            plots.clearExpandedTraceDefaultColors = function(trace) {
	              var colorAttrs, path, i;
	              function locateColorAttrs(attr, attrName, attrs, level) {
	                path[level] = attrName;
	                path.length = level + 1;
	                if (attr.valType === "color" && attr.dflt === undefined) {
	                  colorAttrs.push(path.join("."));
	                }
	              }
	              path = [];
	              colorAttrs = trace._module._colorAttrs;
	              if (!colorAttrs) {
	                trace._module._colorAttrs = colorAttrs = [];
	                PlotSchema.crawl(trace._module.attributes, locateColorAttrs);
	              }
	              for (i = 0; i < colorAttrs.length; i++) {
	                var origprop = Lib.nestedProperty(trace, "_input." + colorAttrs[i]);
	                if (!origprop.get()) {
	                  Lib.nestedProperty(trace, colorAttrs[i]).set(null);
	                }
	              }
	            };
	            plots.supplyDataDefaults = function(dataIn, dataOut, layout, fullLayout) {
	              var modules = fullLayout._modules;
	              var visibleModules = fullLayout._visibleModules;
	              var basePlotModules = fullLayout._basePlotModules;
	              var cnt = 0;
	              var colorCnt = 0;
	              var i, fullTrace, trace;
	              fullLayout._transformModules = [];
	              function pushModule(fullTrace2) {
	                dataOut.push(fullTrace2);
	                var _module = fullTrace2._module;
	                if (!_module) return;
	                Lib.pushUnique(modules, _module);
	                if (fullTrace2.visible === true) Lib.pushUnique(visibleModules, _module);
	                Lib.pushUnique(basePlotModules, fullTrace2._module.basePlotModule);
	                cnt++;
	                if (fullTrace2._input.visible !== false) colorCnt++;
	              }
	              var carpetIndex = {};
	              var carpetDependents = [];
	              var dataTemplate = (layout.template || {}).data || {};
	              var templater = Template.traceTemplater(dataTemplate);
	              for (i = 0; i < dataIn.length; i++) {
	                trace = dataIn[i];
	                fullTrace = templater.newTrace(trace);
	                fullTrace.uid = fullLayout._traceUids[i];
	                plots.supplyTraceDefaults(trace, fullTrace, colorCnt, fullLayout, i);
	                fullTrace.index = i;
	                fullTrace._input = trace;
	                fullTrace._expandedIndex = cnt;
	                if (fullTrace.transforms && fullTrace.transforms.length) {
	                  var sdInvisible = trace.visible !== false && fullTrace.visible === false;
	                  var expandedTraces = applyTransforms(fullTrace, dataOut, layout, fullLayout);
	                  for (var j = 0; j < expandedTraces.length; j++) {
	                    var expandedTrace = expandedTraces[j];
	                    var fullExpandedTrace = {
	                      _template: fullTrace._template,
	                      type: fullTrace.type,
	                      // set uid using parent uid and expanded index
	                      // to promote consistency between update calls
	                      uid: fullTrace.uid + j
	                    };
	                    if (sdInvisible && expandedTrace.visible === false) {
	                      delete expandedTrace.visible;
	                    }
	                    plots.supplyTraceDefaults(expandedTrace, fullExpandedTrace, cnt, fullLayout, i);
	                    relinkPrivateKeys(fullExpandedTrace, expandedTrace);
	                    fullExpandedTrace.index = i;
	                    fullExpandedTrace._input = trace;
	                    fullExpandedTrace._fullInput = fullTrace;
	                    fullExpandedTrace._expandedIndex = cnt;
	                    fullExpandedTrace._expandedInput = expandedTrace;
	                    pushModule(fullExpandedTrace);
	                  }
	                } else {
	                  fullTrace._fullInput = fullTrace;
	                  fullTrace._expandedInput = fullTrace;
	                  pushModule(fullTrace);
	                }
	                if (Registry.traceIs(fullTrace, "carpetAxis")) {
	                  carpetIndex[fullTrace.carpet] = fullTrace;
	                }
	                if (Registry.traceIs(fullTrace, "carpetDependent")) {
	                  carpetDependents.push(i);
	                }
	              }
	              for (i = 0; i < carpetDependents.length; i++) {
	                fullTrace = dataOut[carpetDependents[i]];
	                if (!fullTrace.visible) continue;
	                var carpetAxis = carpetIndex[fullTrace.carpet];
	                fullTrace._carpet = carpetAxis;
	                if (!carpetAxis || !carpetAxis.visible) {
	                  fullTrace.visible = false;
	                  continue;
	                }
	                fullTrace.xaxis = carpetAxis.xaxis;
	                fullTrace.yaxis = carpetAxis.yaxis;
	              }
	            };
	            plots.supplyAnimationDefaults = function(opts) {
	              opts = opts || {};
	              var i;
	              var optsOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(opts || {}, optsOut, animationAttrs, attr, dflt);
	              }
	              coerce("mode");
	              coerce("direction");
	              coerce("fromcurrent");
	              if (Array.isArray(opts.frame)) {
	                optsOut.frame = [];
	                for (i = 0; i < opts.frame.length; i++) {
	                  optsOut.frame[i] = plots.supplyAnimationFrameDefaults(opts.frame[i] || {});
	                }
	              } else {
	                optsOut.frame = plots.supplyAnimationFrameDefaults(opts.frame || {});
	              }
	              if (Array.isArray(opts.transition)) {
	                optsOut.transition = [];
	                for (i = 0; i < opts.transition.length; i++) {
	                  optsOut.transition[i] = plots.supplyAnimationTransitionDefaults(opts.transition[i] || {});
	                }
	              } else {
	                optsOut.transition = plots.supplyAnimationTransitionDefaults(opts.transition || {});
	              }
	              return optsOut;
	            };
	            plots.supplyAnimationFrameDefaults = function(opts) {
	              var optsOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(opts || {}, optsOut, animationAttrs.frame, attr, dflt);
	              }
	              coerce("duration");
	              coerce("redraw");
	              return optsOut;
	            };
	            plots.supplyAnimationTransitionDefaults = function(opts) {
	              var optsOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(opts || {}, optsOut, animationAttrs.transition, attr, dflt);
	              }
	              coerce("duration");
	              coerce("easing");
	              return optsOut;
	            };
	            plots.supplyFrameDefaults = function(frameIn) {
	              var frameOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(frameIn, frameOut, frameAttrs, attr, dflt);
	              }
	              coerce("group");
	              coerce("name");
	              coerce("traces");
	              coerce("baseframe");
	              coerce("data");
	              coerce("layout");
	              return frameOut;
	            };
	            plots.supplyTraceDefaults = function(traceIn, traceOut, colorIndex, layout, traceInIndex) {
	              var colorway = layout.colorway || Color.defaults;
	              var defaultColor = colorway[colorIndex % colorway.length];
	              var i;
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, plots.attributes, attr, dflt);
	              }
	              var visible = coerce("visible");
	              coerce("type");
	              coerce("name", layout._traceWord + " " + traceInIndex);
	              coerce("uirevision", layout.uirevision);
	              var _module = plots.getModule(traceOut);
	              traceOut._module = _module;
	              if (_module) {
	                var basePlotModule = _module.basePlotModule;
	                var subplotAttr = basePlotModule.attr;
	                var subplotAttrs = basePlotModule.attributes;
	                if (subplotAttr && subplotAttrs) {
	                  var subplots = layout._subplots;
	                  var subplotId = "";
	                  if (visible || basePlotModule.name !== "gl2d") {
	                    if (Array.isArray(subplotAttr)) {
	                      for (i = 0; i < subplotAttr.length; i++) {
	                        var attri = subplotAttr[i];
	                        var vali = Lib.coerce(traceIn, traceOut, subplotAttrs, attri);
	                        if (subplots[attri]) Lib.pushUnique(subplots[attri], vali);
	                        subplotId += vali;
	                      }
	                    } else {
	                      subplotId = Lib.coerce(traceIn, traceOut, subplotAttrs, subplotAttr);
	                    }
	                    if (subplots[basePlotModule.name]) {
	                      Lib.pushUnique(subplots[basePlotModule.name], subplotId);
	                    }
	                  }
	                }
	              }
	              if (visible) {
	                coerce("customdata");
	                coerce("ids");
	                coerce("meta");
	                if (Registry.traceIs(traceOut, "showLegend")) {
	                  Lib.coerce(traceIn, traceOut, _module.attributes.showlegend ? _module.attributes : plots.attributes, "showlegend");
	                  coerce("legend");
	                  coerce("legendwidth");
	                  coerce("legendgroup");
	                  coerce("legendgrouptitle.text");
	                  coerce("legendrank");
	                  traceOut._dfltShowLegend = true;
	                } else {
	                  traceOut._dfltShowLegend = false;
	                }
	                if (_module) {
	                  _module.supplyDefaults(traceIn, traceOut, defaultColor, layout);
	                }
	                if (!Registry.traceIs(traceOut, "noOpacity")) {
	                  coerce("opacity");
	                }
	                if (Registry.traceIs(traceOut, "notLegendIsolatable")) {
	                  traceOut.visible = !!traceOut.visible;
	                }
	                if (!Registry.traceIs(traceOut, "noHover")) {
	                  if (!traceOut.hovertemplate) Lib.coerceHoverinfo(traceIn, traceOut, layout);
	                  if (traceOut.type !== "parcats") {
	                    Registry.getComponentMethod("fx", "supplyDefaults")(traceIn, traceOut, defaultColor, layout);
	                  }
	                }
	                if (_module && _module.selectPoints) {
	                  coerce("selectedpoints");
	                }
	                plots.supplyTransformDefaults(traceIn, traceOut, layout);
	              }
	              return traceOut;
	            };
	            function hasMakesDataTransform(trace) {
	              var transforms = trace.transforms;
	              if (Array.isArray(transforms) && transforms.length) {
	                for (var i = 0; i < transforms.length; i++) {
	                  var ti = transforms[i];
	                  var _module = ti._module || transformsRegistry[ti.type];
	                  if (_module && _module.makesData) return true;
	                }
	              }
	              return false;
	            }
	            plots.hasMakesDataTransform = hasMakesDataTransform;
	            plots.supplyTransformDefaults = function(traceIn, traceOut, layout) {
	              if (!(traceOut._length || hasMakesDataTransform(traceIn))) return;
	              var globalTransforms = layout._globalTransforms || [];
	              var transformModules = layout._transformModules || [];
	              if (!Array.isArray(traceIn.transforms) && globalTransforms.length === 0) return;
	              var containerIn = traceIn.transforms || [];
	              var transformList = globalTransforms.concat(containerIn);
	              var containerOut = traceOut.transforms = [];
	              for (var i = 0; i < transformList.length; i++) {
	                var transformIn = transformList[i];
	                var type = transformIn.type;
	                var _module = transformsRegistry[type];
	                var transformOut;
	                var isFirstStage = !(transformIn._module && transformIn._module === _module);
	                var doLaterStages = _module && typeof _module.transform === "function";
	                if (!_module) Lib.warn("Unrecognized transform type " + type + ".");
	                if (_module && _module.supplyDefaults && (isFirstStage || doLaterStages)) {
	                  transformOut = _module.supplyDefaults(transformIn, traceOut, layout, traceIn);
	                  transformOut.type = type;
	                  transformOut._module = _module;
	                  Lib.pushUnique(transformModules, _module);
	                } else {
	                  transformOut = Lib.extendFlat({}, transformIn);
	                }
	                containerOut.push(transformOut);
	              }
	            };
	            function applyTransforms(fullTrace, fullData, layout, fullLayout) {
	              var container = fullTrace.transforms;
	              var dataOut = [fullTrace];
	              for (var i = 0; i < container.length; i++) {
	                var transform = container[i];
	                var _module = transformsRegistry[transform.type];
	                if (_module && _module.transform) {
	                  dataOut = _module.transform(dataOut, {
	                    transform,
	                    fullTrace,
	                    fullData,
	                    layout,
	                    fullLayout,
	                    transformIndex: i
	                  });
	                }
	              }
	              return dataOut;
	            }
	            plots.supplyLayoutGlobalDefaults = function(layoutIn, layoutOut, formatObj) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, plots.layoutAttributes, attr, dflt);
	              }
	              var template = layoutIn.template;
	              if (Lib.isPlainObject(template)) {
	                layoutOut.template = template;
	                layoutOut._template = template.layout;
	                layoutOut._dataTemplate = template.data;
	              }
	              coerce("autotypenumbers");
	              var font = Lib.coerceFont(coerce, "font");
	              var fontSize = font.size;
	              Lib.coerceFont(coerce, "title.font", Lib.extendFlat({}, font, {
	                size: Math.round(fontSize * 1.4)
	              }));
	              coerce("title.text", layoutOut._dfltTitle.plot);
	              coerce("title.xref");
	              var titleYref = coerce("title.yref");
	              coerce("title.pad.t");
	              coerce("title.pad.r");
	              coerce("title.pad.b");
	              coerce("title.pad.l");
	              var titleAutomargin = coerce("title.automargin");
	              coerce("title.x");
	              coerce("title.xanchor");
	              coerce("title.y");
	              coerce("title.yanchor");
	              if (titleAutomargin) {
	                if (titleYref === "paper") {
	                  if (layoutOut.title.y !== 0) layoutOut.title.y = 1;
	                  if (layoutOut.title.yanchor === "auto") {
	                    layoutOut.title.yanchor = layoutOut.title.y === 0 ? "top" : "bottom";
	                  }
	                }
	                if (titleYref === "container") {
	                  if (layoutOut.title.y === "auto") layoutOut.title.y = 1;
	                  if (layoutOut.title.yanchor === "auto") {
	                    layoutOut.title.yanchor = layoutOut.title.y < 0.5 ? "bottom" : "top";
	                  }
	                }
	              }
	              var uniformtextMode = coerce("uniformtext.mode");
	              if (uniformtextMode) {
	                coerce("uniformtext.minsize");
	              }
	              coerce("autosize", !(layoutIn.width && layoutIn.height));
	              coerce("width");
	              coerce("height");
	              coerce("minreducedwidth");
	              coerce("minreducedheight");
	              coerce("margin.l");
	              coerce("margin.r");
	              coerce("margin.t");
	              coerce("margin.b");
	              coerce("margin.pad");
	              coerce("margin.autoexpand");
	              if (layoutIn.width && layoutIn.height) plots.sanitizeMargins(layoutOut);
	              Registry.getComponentMethod("grid", "sizeDefaults")(layoutIn, layoutOut);
	              coerce("paper_bgcolor");
	              coerce("separators", formatObj.decimal + formatObj.thousands);
	              coerce("hidesources");
	              coerce("colorway");
	              coerce("datarevision");
	              var uirevision = coerce("uirevision");
	              coerce("editrevision", uirevision);
	              coerce("selectionrevision", uirevision);
	              Registry.getComponentMethod("modebar", "supplyLayoutDefaults")(layoutIn, layoutOut);
	              Registry.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(layoutIn, layoutOut, coerce);
	              Registry.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(layoutIn, layoutOut, coerce);
	              coerce("meta");
	              if (Lib.isPlainObject(layoutIn.transition)) {
	                coerce("transition.duration");
	                coerce("transition.easing");
	                coerce("transition.ordering");
	              }
	              Registry.getComponentMethod("calendars", "handleDefaults")(layoutIn, layoutOut, "calendar");
	              Registry.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(layoutIn, layoutOut, coerce);
	              Lib.coerce(layoutIn, layoutOut, scatterAttrs, "scattermode");
	            };
	            function getComputedSize(attr) {
	              return typeof attr === "string" && attr.substr(attr.length - 2) === "px" && parseFloat(attr);
	            }
	            plots.plotAutoSize = function plotAutoSize(gd, layout, fullLayout) {
	              var context = gd._context || {};
	              var frameMargins = context.frameMargins;
	              var newWidth;
	              var newHeight;
	              var isPlotDiv = Lib.isPlotDiv(gd);
	              if (isPlotDiv) gd.emit("plotly_autosize");
	              if (context.fillFrame) {
	                newWidth = window.innerWidth;
	                newHeight = window.innerHeight;
	                document.body.style.overflow = "hidden";
	              } else {
	                var computedStyle = isPlotDiv ? window.getComputedStyle(gd) : {};
	                newWidth = getComputedSize(computedStyle.width) || getComputedSize(computedStyle.maxWidth) || fullLayout.width;
	                newHeight = getComputedSize(computedStyle.height) || getComputedSize(computedStyle.maxHeight) || fullLayout.height;
	                if (isNumeric(frameMargins) && frameMargins > 0) {
	                  var factor = 1 - 2 * frameMargins;
	                  newWidth = Math.round(factor * newWidth);
	                  newHeight = Math.round(factor * newHeight);
	                }
	              }
	              var minWidth = plots.layoutAttributes.width.min;
	              var minHeight = plots.layoutAttributes.height.min;
	              if (newWidth < minWidth) newWidth = minWidth;
	              if (newHeight < minHeight) newHeight = minHeight;
	              var widthHasChanged = !layout.width && Math.abs(fullLayout.width - newWidth) > 1;
	              var heightHasChanged = !layout.height && Math.abs(fullLayout.height - newHeight) > 1;
	              if (heightHasChanged || widthHasChanged) {
	                if (widthHasChanged) fullLayout.width = newWidth;
	                if (heightHasChanged) fullLayout.height = newHeight;
	              }
	              if (!gd._initialAutoSize) {
	                gd._initialAutoSize = {
	                  width: newWidth,
	                  height: newHeight
	                };
	              }
	              plots.sanitizeMargins(fullLayout);
	            };
	            plots.supplyLayoutModuleDefaults = function(layoutIn, layoutOut, fullData, transitionData) {
	              var componentsRegistry = Registry.componentsRegistry;
	              var basePlotModules = layoutOut._basePlotModules;
	              var component, i, _module;
	              var Cartesian = Registry.subplotsRegistry.cartesian;
	              for (component in componentsRegistry) {
	                _module = componentsRegistry[component];
	                if (_module.includeBasePlot) {
	                  _module.includeBasePlot(layoutIn, layoutOut);
	                }
	              }
	              if (!basePlotModules.length) {
	                basePlotModules.push(Cartesian);
	              }
	              if (layoutOut._has("cartesian")) {
	                Registry.getComponentMethod("grid", "contentDefaults")(layoutIn, layoutOut);
	                Cartesian.finalizeSubplots(layoutIn, layoutOut);
	              }
	              for (var subplotType in layoutOut._subplots) {
	                layoutOut._subplots[subplotType].sort(Lib.subplotSort);
	              }
	              for (i = 0; i < basePlotModules.length; i++) {
	                _module = basePlotModules[i];
	                if (_module.supplyLayoutDefaults) {
	                  _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	                }
	              }
	              var modules = layoutOut._modules;
	              for (i = 0; i < modules.length; i++) {
	                _module = modules[i];
	                if (_module.supplyLayoutDefaults) {
	                  _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	                }
	              }
	              var transformModules = layoutOut._transformModules;
	              for (i = 0; i < transformModules.length; i++) {
	                _module = transformModules[i];
	                if (_module.supplyLayoutDefaults) {
	                  _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData, transitionData);
	                }
	              }
	              for (component in componentsRegistry) {
	                _module = componentsRegistry[component];
	                if (_module.supplyLayoutDefaults) {
	                  _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
	                }
	              }
	            };
	            plots.purge = function(gd) {
	              var fullLayout = gd._fullLayout || {};
	              if (fullLayout._glcontainer !== undefined) {
	                fullLayout._glcontainer.selectAll(".gl-canvas").remove();
	                fullLayout._glcontainer.remove();
	                fullLayout._glcanvas = null;
	              }
	              if (fullLayout._modeBar) fullLayout._modeBar.destroy();
	              if (gd._transitionData) {
	                if (gd._transitionData._interruptCallbacks) {
	                  gd._transitionData._interruptCallbacks.length = 0;
	                }
	                if (gd._transitionData._animationRaf) {
	                  window.cancelAnimationFrame(gd._transitionData._animationRaf);
	                }
	              }
	              Lib.clearThrottle();
	              Lib.clearResponsive(gd);
	              delete gd.data;
	              delete gd.layout;
	              delete gd._fullData;
	              delete gd._fullLayout;
	              delete gd.calcdata;
	              delete gd.empty;
	              delete gd.fid;
	              delete gd.undoqueue;
	              delete gd.undonum;
	              delete gd.autoplay;
	              delete gd.changed;
	              delete gd._promises;
	              delete gd._redrawTimer;
	              delete gd._hmlumcount;
	              delete gd._hmpixcount;
	              delete gd._transitionData;
	              delete gd._transitioning;
	              delete gd._initialAutoSize;
	              delete gd._transitioningWithDuration;
	              delete gd._dragging;
	              delete gd._dragged;
	              delete gd._dragdata;
	              delete gd._hoverdata;
	              delete gd._snapshotInProgress;
	              delete gd._editing;
	              delete gd._mouseDownTime;
	              delete gd._legendMouseDownTime;
	              if (gd.removeAllListeners) gd.removeAllListeners();
	            };
	            plots.style = function(gd) {
	              var _modules = gd._fullLayout._visibleModules;
	              var styleModules = [];
	              var i;
	              for (i = 0; i < _modules.length; i++) {
	                var _module = _modules[i];
	                if (_module.style) {
	                  Lib.pushUnique(styleModules, _module.style);
	                }
	              }
	              for (i = 0; i < styleModules.length; i++) {
	                styleModules[i](gd);
	              }
	            };
	            plots.sanitizeMargins = function(fullLayout) {
	              if (!fullLayout || !fullLayout.margin) return;
	              var width = fullLayout.width;
	              var height = fullLayout.height;
	              var margin = fullLayout.margin;
	              var plotWidth = width - (margin.l + margin.r);
	              var plotHeight = height - (margin.t + margin.b);
	              var correction;
	              if (plotWidth < 0) {
	                correction = (width - 1) / (margin.l + margin.r);
	                margin.l = Math.floor(correction * margin.l);
	                margin.r = Math.floor(correction * margin.r);
	              }
	              if (plotHeight < 0) {
	                correction = (height - 1) / (margin.t + margin.b);
	                margin.t = Math.floor(correction * margin.t);
	                margin.b = Math.floor(correction * margin.b);
	              }
	            };
	            plots.clearAutoMarginIds = function(gd) {
	              gd._fullLayout._pushmarginIds = {};
	            };
	            plots.allowAutoMargin = function(gd, id) {
	              gd._fullLayout._pushmarginIds[id] = 1;
	            };
	            function initMargins(fullLayout) {
	              var margin = fullLayout.margin;
	              if (!fullLayout._size) {
	                var gs = fullLayout._size = {
	                  l: Math.round(margin.l),
	                  r: Math.round(margin.r),
	                  t: Math.round(margin.t),
	                  b: Math.round(margin.b),
	                  p: Math.round(margin.pad)
	                };
	                gs.w = Math.round(fullLayout.width) - gs.l - gs.r;
	                gs.h = Math.round(fullLayout.height) - gs.t - gs.b;
	              }
	              if (!fullLayout._pushmargin) fullLayout._pushmargin = {};
	              if (!fullLayout._pushmarginIds) fullLayout._pushmarginIds = {};
	              if (!fullLayout._reservedMargin) fullLayout._reservedMargin = {};
	            }
	            var MIN_SPECIFIED_WIDTH = 2;
	            var MIN_SPECIFIED_HEIGHT = 2;
	            plots.autoMargin = function(gd, id, o) {
	              var fullLayout = gd._fullLayout;
	              var width = fullLayout.width;
	              var height = fullLayout.height;
	              var margin = fullLayout.margin;
	              var minreducedwidth = fullLayout.minreducedwidth;
	              var minreducedheight = fullLayout.minreducedheight;
	              var minFinalWidth = Lib.constrain(width - margin.l - margin.r, MIN_SPECIFIED_WIDTH, minreducedwidth);
	              var minFinalHeight = Lib.constrain(height - margin.t - margin.b, MIN_SPECIFIED_HEIGHT, minreducedheight);
	              var maxSpaceW = Math.max(0, width - minFinalWidth);
	              var maxSpaceH = Math.max(0, height - minFinalHeight);
	              var pushMargin = fullLayout._pushmargin;
	              var pushMarginIds = fullLayout._pushmarginIds;
	              if (margin.autoexpand !== false) {
	                if (!o) {
	                  delete pushMargin[id];
	                  delete pushMarginIds[id];
	                } else {
	                  var pad = o.pad;
	                  if (pad === undefined) {
	                    pad = Math.min(12, margin.l, margin.r, margin.t, margin.b);
	                  }
	                  if (maxSpaceW) {
	                    var rW = (o.l + o.r) / maxSpaceW;
	                    if (rW > 1) {
	                      o.l /= rW;
	                      o.r /= rW;
	                    }
	                  }
	                  if (maxSpaceH) {
	                    var rH = (o.t + o.b) / maxSpaceH;
	                    if (rH > 1) {
	                      o.t /= rH;
	                      o.b /= rH;
	                    }
	                  }
	                  var xl = o.xl !== undefined ? o.xl : o.x;
	                  var xr = o.xr !== undefined ? o.xr : o.x;
	                  var yt = o.yt !== undefined ? o.yt : o.y;
	                  var yb = o.yb !== undefined ? o.yb : o.y;
	                  pushMargin[id] = {
	                    l: {
	                      val: xl,
	                      size: o.l + pad
	                    },
	                    r: {
	                      val: xr,
	                      size: o.r + pad
	                    },
	                    b: {
	                      val: yb,
	                      size: o.b + pad
	                    },
	                    t: {
	                      val: yt,
	                      size: o.t + pad
	                    }
	                  };
	                  pushMarginIds[id] = 1;
	                }
	                if (!fullLayout._replotting) {
	                  return plots.doAutoMargin(gd);
	                }
	              }
	            };
	            function needsRedrawForShift(gd) {
	              if ("_redrawFromAutoMarginCount" in gd._fullLayout) {
	                return false;
	              }
	              var axList = axisIDs.list(gd, "", true);
	              for (var ax in axList) {
	                if (axList[ax].autoshift || axList[ax].shift) return true;
	              }
	              return false;
	            }
	            plots.doAutoMargin = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var width = fullLayout.width;
	              var height = fullLayout.height;
	              if (!fullLayout._size) fullLayout._size = {};
	              initMargins(fullLayout);
	              var gs = fullLayout._size;
	              var margin = fullLayout.margin;
	              var reservedMargins = {
	                t: 0,
	                b: 0,
	                l: 0,
	                r: 0
	              };
	              var oldMargins = Lib.extendFlat({}, gs);
	              var ml = margin.l;
	              var mr = margin.r;
	              var mt = margin.t;
	              var mb = margin.b;
	              var pushMargin = fullLayout._pushmargin;
	              var pushMarginIds = fullLayout._pushmarginIds;
	              var minreducedwidth = fullLayout.minreducedwidth;
	              var minreducedheight = fullLayout.minreducedheight;
	              if (margin.autoexpand !== false) {
	                for (var k in pushMargin) {
	                  if (!pushMarginIds[k]) delete pushMargin[k];
	                }
	                var margins = gd._fullLayout._reservedMargin;
	                for (var key in margins) {
	                  for (var side in margins[key]) {
	                    var val = margins[key][side];
	                    reservedMargins[side] = Math.max(reservedMargins[side], val);
	                  }
	                }
	                pushMargin.base = {
	                  l: {
	                    val: 0,
	                    size: ml
	                  },
	                  r: {
	                    val: 1,
	                    size: mr
	                  },
	                  t: {
	                    val: 1,
	                    size: mt
	                  },
	                  b: {
	                    val: 0,
	                    size: mb
	                  }
	                };
	                for (var s in reservedMargins) {
	                  var autoMarginPush = 0;
	                  for (var m in pushMargin) {
	                    if (m !== "base") {
	                      if (isNumeric(pushMargin[m][s].size)) {
	                        autoMarginPush = pushMargin[m][s].size > autoMarginPush ? pushMargin[m][s].size : autoMarginPush;
	                      }
	                    }
	                  }
	                  var extraMargin = Math.max(0, margin[s] - autoMarginPush);
	                  reservedMargins[s] = Math.max(0, reservedMargins[s] - extraMargin);
	                }
	                for (var k1 in pushMargin) {
	                  var pushleft = pushMargin[k1].l || {};
	                  var pushbottom = pushMargin[k1].b || {};
	                  var fl = pushleft.val;
	                  var pl = pushleft.size;
	                  var fb = pushbottom.val;
	                  var pb = pushbottom.size;
	                  var availableWidth = width - reservedMargins.r - reservedMargins.l;
	                  var availableHeight = height - reservedMargins.t - reservedMargins.b;
	                  for (var k2 in pushMargin) {
	                    if (isNumeric(pl) && pushMargin[k2].r) {
	                      var fr = pushMargin[k2].r.val;
	                      var pr = pushMargin[k2].r.size;
	                      if (fr > fl) {
	                        var newL = (pl * fr + (pr - availableWidth) * fl) / (fr - fl);
	                        var newR = (pr * (1 - fl) + (pl - availableWidth) * (1 - fr)) / (fr - fl);
	                        if (newL + newR > ml + mr) {
	                          ml = newL;
	                          mr = newR;
	                        }
	                      }
	                    }
	                    if (isNumeric(pb) && pushMargin[k2].t) {
	                      var ft = pushMargin[k2].t.val;
	                      var pt = pushMargin[k2].t.size;
	                      if (ft > fb) {
	                        var newB = (pb * ft + (pt - availableHeight) * fb) / (ft - fb);
	                        var newT = (pt * (1 - fb) + (pb - availableHeight) * (1 - ft)) / (ft - fb);
	                        if (newB + newT > mb + mt) {
	                          mb = newB;
	                          mt = newT;
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	              var minFinalWidth = Lib.constrain(width - margin.l - margin.r, MIN_SPECIFIED_WIDTH, minreducedwidth);
	              var minFinalHeight = Lib.constrain(height - margin.t - margin.b, MIN_SPECIFIED_HEIGHT, minreducedheight);
	              var maxSpaceW = Math.max(0, width - minFinalWidth);
	              var maxSpaceH = Math.max(0, height - minFinalHeight);
	              if (maxSpaceW) {
	                var rW = (ml + mr) / maxSpaceW;
	                if (rW > 1) {
	                  ml /= rW;
	                  mr /= rW;
	                }
	              }
	              if (maxSpaceH) {
	                var rH = (mb + mt) / maxSpaceH;
	                if (rH > 1) {
	                  mb /= rH;
	                  mt /= rH;
	                }
	              }
	              gs.l = Math.round(ml) + reservedMargins.l;
	              gs.r = Math.round(mr) + reservedMargins.r;
	              gs.t = Math.round(mt) + reservedMargins.t;
	              gs.b = Math.round(mb) + reservedMargins.b;
	              gs.p = Math.round(margin.pad);
	              gs.w = Math.round(width) - gs.l - gs.r;
	              gs.h = Math.round(height) - gs.t - gs.b;
	              if (!fullLayout._replotting && (plots.didMarginChange(oldMargins, gs) || needsRedrawForShift(gd))) {
	                if ("_redrawFromAutoMarginCount" in fullLayout) {
	                  fullLayout._redrawFromAutoMarginCount++;
	                } else {
	                  fullLayout._redrawFromAutoMarginCount = 1;
	                }
	                var maxNumberOfRedraws = 3 * (1 + Object.keys(pushMarginIds).length);
	                if (fullLayout._redrawFromAutoMarginCount < maxNumberOfRedraws) {
	                  return Registry.call("_doPlot", gd);
	                } else {
	                  fullLayout._size = oldMargins;
	                  Lib.warn("Too many auto-margin redraws.");
	                }
	              }
	              refineTicks(gd);
	            };
	            function refineTicks(gd) {
	              var axList = axisIDs.list(gd, "", true);
	              ["_adjustTickLabelsOverflow", "_hideCounterAxisInsideTickLabels"].forEach(function(k) {
	                for (var i = 0; i < axList.length; i++) {
	                  var hideFn = axList[i][k];
	                  if (hideFn) hideFn();
	                }
	              });
	            }
	            var marginKeys = ["l", "r", "t", "b", "p", "w", "h"];
	            plots.didMarginChange = function(margin0, margin1) {
	              for (var i = 0; i < marginKeys.length; i++) {
	                var k = marginKeys[i];
	                var m0 = margin0[k];
	                var m1 = margin1[k];
	                if (!isNumeric(m0) || Math.abs(m1 - m0) > 1) {
	                  return true;
	                }
	              }
	              return false;
	            };
	            plots.graphJson = function(gd, dataonly, mode, output, useDefaults, includeConfig) {
	              if (useDefaults && dataonly && !gd._fullData || useDefaults && !dataonly && !gd._fullLayout) {
	                plots.supplyDefaults(gd);
	              }
	              var data = useDefaults ? gd._fullData : gd.data;
	              var layout = useDefaults ? gd._fullLayout : gd.layout;
	              var frames = (gd._transitionData || {})._frames;
	              function stripObj(d, keepFunction) {
	                if (typeof d === "function") {
	                  return keepFunction ? "_function_" : null;
	                }
	                if (Lib.isPlainObject(d)) {
	                  var o = {};
	                  var src;
	                  Object.keys(d).sort().forEach(function(v) {
	                    if (["_", "["].indexOf(v.charAt(0)) !== -1) return;
	                    if (typeof d[v] === "function") {
	                      if (keepFunction) o[v] = "_function";
	                      return;
	                    }
	                    if (mode === "keepdata") {
	                      if (v.substr(v.length - 3) === "src") {
	                        return;
	                      }
	                    } else if (mode === "keepstream") {
	                      src = d[v + "src"];
	                      if (typeof src === "string" && src.indexOf(":") > 0) {
	                        if (!Lib.isPlainObject(d.stream)) {
	                          return;
	                        }
	                      }
	                    } else if (mode !== "keepall") {
	                      src = d[v + "src"];
	                      if (typeof src === "string" && src.indexOf(":") > 0) {
	                        return;
	                      }
	                    }
	                    o[v] = stripObj(d[v], keepFunction);
	                  });
	                  return o;
	                }
	                if (Array.isArray(d)) {
	                  return d.map(function(x) {
	                    return stripObj(x, keepFunction);
	                  });
	                }
	                if (Lib.isTypedArray(d)) {
	                  return Lib.simpleMap(d, Lib.identity);
	                }
	                if (Lib.isJSDate(d)) return Lib.ms2DateTimeLocal(+d);
	                return d;
	              }
	              var obj = {
	                data: (data || []).map(function(v) {
	                  var d = stripObj(v);
	                  if (dataonly) {
	                    delete d.fit;
	                  }
	                  return d;
	                })
	              };
	              if (!dataonly) {
	                obj.layout = stripObj(layout);
	                if (useDefaults) {
	                  var gs = layout._size;
	                  obj.layout.computed = {
	                    margin: {
	                      b: gs.b,
	                      l: gs.l,
	                      r: gs.r,
	                      t: gs.t
	                    }
	                  };
	                }
	              }
	              if (frames) obj.frames = stripObj(frames);
	              if (includeConfig) obj.config = stripObj(gd._context, true);
	              return output === "object" ? obj : JSON.stringify(obj);
	            };
	            plots.modifyFrames = function(gd, operations) {
	              var i, op, frame;
	              var _frames = gd._transitionData._frames;
	              var _frameHash = gd._transitionData._frameHash;
	              for (i = 0; i < operations.length; i++) {
	                op = operations[i];
	                switch (op.type) {
	                  case "replace":
	                    frame = op.value;
	                    var oldName = (_frames[op.index] || {}).name;
	                    var newName = frame.name;
	                    _frames[op.index] = _frameHash[newName] = frame;
	                    if (newName !== oldName) {
	                      delete _frameHash[oldName];
	                      _frameHash[newName] = frame;
	                    }
	                    break;
	                  case "insert":
	                    frame = op.value;
	                    _frameHash[frame.name] = frame;
	                    _frames.splice(op.index, 0, frame);
	                    break;
	                  case "delete":
	                    frame = _frames[op.index];
	                    delete _frameHash[frame.name];
	                    _frames.splice(op.index, 1);
	                    break;
	                }
	              }
	              return Promise.resolve();
	            };
	            plots.computeFrame = function(gd, frameName) {
	              var frameLookup = gd._transitionData._frameHash;
	              var i, traceIndices, traceIndex, destIndex;
	              if (!frameName) {
	                throw new Error("computeFrame must be given a string frame name");
	              }
	              var framePtr = frameLookup[frameName.toString()];
	              if (!framePtr) {
	                return false;
	              }
	              var frameStack = [framePtr];
	              var frameNameStack = [framePtr.name];
	              while (framePtr.baseframe && (framePtr = frameLookup[framePtr.baseframe.toString()])) {
	                if (frameNameStack.indexOf(framePtr.name) !== -1) break;
	                frameStack.push(framePtr);
	                frameNameStack.push(framePtr.name);
	              }
	              var result = {};
	              while (framePtr = frameStack.pop()) {
	                if (framePtr.layout) {
	                  result.layout = plots.extendLayout(result.layout, framePtr.layout);
	                }
	                if (framePtr.data) {
	                  if (!result.data) {
	                    result.data = [];
	                  }
	                  traceIndices = framePtr.traces;
	                  if (!traceIndices) {
	                    traceIndices = [];
	                    for (i = 0; i < framePtr.data.length; i++) {
	                      traceIndices[i] = i;
	                    }
	                  }
	                  if (!result.traces) {
	                    result.traces = [];
	                  }
	                  for (i = 0; i < framePtr.data.length; i++) {
	                    traceIndex = traceIndices[i];
	                    if (traceIndex === undefined || traceIndex === null) {
	                      continue;
	                    }
	                    destIndex = result.traces.indexOf(traceIndex);
	                    if (destIndex === -1) {
	                      destIndex = result.data.length;
	                      result.traces[destIndex] = traceIndex;
	                    }
	                    result.data[destIndex] = plots.extendTrace(result.data[destIndex], framePtr.data[i]);
	                  }
	                }
	              }
	              return result;
	            };
	            plots.recomputeFrameHash = function(gd) {
	              var hash = gd._transitionData._frameHash = {};
	              var frames = gd._transitionData._frames;
	              for (var i = 0; i < frames.length; i++) {
	                var frame = frames[i];
	                if (frame && frame.name) {
	                  hash[frame.name] = frame;
	                }
	              }
	            };
	            plots.extendObjectWithContainers = function(dest, src, containerPaths) {
	              var containerProp, containerVal, i, j, srcProp, destProp, srcContainer, destContainer;
	              var copy = Lib.extendDeepNoArrays({}, src || {});
	              var expandedObj = Lib.expandObjectPaths(copy);
	              var containerObj = {};
	              if (containerPaths && containerPaths.length) {
	                for (i = 0; i < containerPaths.length; i++) {
	                  containerProp = Lib.nestedProperty(expandedObj, containerPaths[i]);
	                  containerVal = containerProp.get();
	                  if (containerVal === undefined) {
	                    Lib.nestedProperty(containerObj, containerPaths[i]).set(null);
	                  } else {
	                    containerProp.set(null);
	                    Lib.nestedProperty(containerObj, containerPaths[i]).set(containerVal);
	                  }
	                }
	              }
	              dest = Lib.extendDeepNoArrays(dest || {}, expandedObj);
	              if (containerPaths && containerPaths.length) {
	                for (i = 0; i < containerPaths.length; i++) {
	                  srcProp = Lib.nestedProperty(containerObj, containerPaths[i]);
	                  srcContainer = srcProp.get();
	                  if (!srcContainer) continue;
	                  destProp = Lib.nestedProperty(dest, containerPaths[i]);
	                  destContainer = destProp.get();
	                  if (!Array.isArray(destContainer)) {
	                    destContainer = [];
	                    destProp.set(destContainer);
	                  }
	                  for (j = 0; j < srcContainer.length; j++) {
	                    var srcObj = srcContainer[j];
	                    if (srcObj === null) destContainer[j] = null;
	                    else {
	                      destContainer[j] = plots.extendObjectWithContainers(destContainer[j], srcObj);
	                    }
	                  }
	                  destProp.set(destContainer);
	                }
	              }
	              return dest;
	            };
	            plots.dataArrayContainers = ["transforms", "dimensions"];
	            plots.layoutArrayContainers = Registry.layoutArrayContainers;
	            plots.extendTrace = function(destTrace, srcTrace) {
	              return plots.extendObjectWithContainers(destTrace, srcTrace, plots.dataArrayContainers);
	            };
	            plots.extendLayout = function(destLayout, srcLayout) {
	              return plots.extendObjectWithContainers(destLayout, srcLayout, plots.layoutArrayContainers);
	            };
	            plots.transition = function(gd, data, layout, traces, frameOpts, transitionOpts) {
	              var opts = {
	                redraw: frameOpts.redraw
	              };
	              var transitionedTraces = {};
	              var axEdits = [];
	              opts.prepareFn = function() {
	                var dataLength = Array.isArray(data) ? data.length : 0;
	                var traceIndices = traces.slice(0, dataLength);
	                for (var i = 0; i < traceIndices.length; i++) {
	                  var traceIdx = traceIndices[i];
	                  var trace = gd._fullData[traceIdx];
	                  var _module = trace._module;
	                  if (!_module) continue;
	                  if (_module.animatable) {
	                    var n = _module.basePlotModule.name;
	                    if (!transitionedTraces[n]) transitionedTraces[n] = [];
	                    transitionedTraces[n].push(traceIdx);
	                  }
	                  gd.data[traceIndices[i]] = plots.extendTrace(gd.data[traceIndices[i]], data[i]);
	                }
	                var layoutUpdate = Lib.expandObjectPaths(Lib.extendDeepNoArrays({}, layout));
	                var axisAttrRe = /^[xy]axis[0-9]*$/;
	                for (var attr in layoutUpdate) {
	                  if (!axisAttrRe.test(attr)) continue;
	                  delete layoutUpdate[attr].range;
	                }
	                plots.extendLayout(gd.layout, layoutUpdate);
	                delete gd.calcdata;
	                plots.supplyDefaults(gd);
	                plots.doCalcdata(gd);
	                var newLayout = Lib.expandObjectPaths(layout);
	                if (newLayout) {
	                  var subplots = gd._fullLayout._plots;
	                  for (var k in subplots) {
	                    var plotinfo = subplots[k];
	                    var xa = plotinfo.xaxis;
	                    var ya = plotinfo.yaxis;
	                    var xr0 = xa.range.slice();
	                    var yr0 = ya.range.slice();
	                    var xr1 = null;
	                    var yr1 = null;
	                    var editX = null;
	                    var editY = null;
	                    if (Array.isArray(newLayout[xa._name + ".range"])) {
	                      xr1 = newLayout[xa._name + ".range"].slice();
	                    } else if (Array.isArray((newLayout[xa._name] || {}).range)) {
	                      xr1 = newLayout[xa._name].range.slice();
	                    }
	                    if (Array.isArray(newLayout[ya._name + ".range"])) {
	                      yr1 = newLayout[ya._name + ".range"].slice();
	                    } else if (Array.isArray((newLayout[ya._name] || {}).range)) {
	                      yr1 = newLayout[ya._name].range.slice();
	                    }
	                    if (xr0 && xr1 && (xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1]))) {
	                      editX = {
	                        xr0,
	                        xr1
	                      };
	                    }
	                    if (yr0 && yr1 && (ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1]))) {
	                      editY = {
	                        yr0,
	                        yr1
	                      };
	                    }
	                    if (editX || editY) {
	                      axEdits.push(Lib.extendFlat({
	                        plotinfo
	                      }, editX, editY));
	                    }
	                  }
	                }
	                return Promise.resolve();
	              };
	              opts.runFn = function(makeCallback) {
	                var traceTransitionOpts;
	                var basePlotModules = gd._fullLayout._basePlotModules;
	                var hasAxisTransition = axEdits.length;
	                var i;
	                if (layout) {
	                  for (i = 0; i < basePlotModules.length; i++) {
	                    if (basePlotModules[i].transitionAxes) {
	                      basePlotModules[i].transitionAxes(gd, axEdits, transitionOpts, makeCallback);
	                    }
	                  }
	                }
	                if (hasAxisTransition) {
	                  traceTransitionOpts = Lib.extendFlat({}, transitionOpts);
	                  traceTransitionOpts.duration = 0;
	                  delete transitionedTraces.cartesian;
	                } else {
	                  traceTransitionOpts = transitionOpts;
	                }
	                for (var n in transitionedTraces) {
	                  var traceIndices = transitionedTraces[n];
	                  var _module = gd._fullData[traceIndices[0]]._module;
	                  _module.basePlotModule.plot(gd, traceIndices, traceTransitionOpts, makeCallback);
	                }
	              };
	              return _transition(gd, transitionOpts, opts);
	            };
	            plots.transitionFromReact = function(gd, restyleFlags, relayoutFlags, oldFullLayout) {
	              var fullLayout = gd._fullLayout;
	              var transitionOpts = fullLayout.transition;
	              var opts = {};
	              var axEdits = [];
	              opts.prepareFn = function() {
	                var subplots = fullLayout._plots;
	                opts.redraw = false;
	                if (restyleFlags.anim === "some") opts.redraw = true;
	                if (relayoutFlags.anim === "some") opts.redraw = true;
	                for (var k in subplots) {
	                  var plotinfo = subplots[k];
	                  var xa = plotinfo.xaxis;
	                  var ya = plotinfo.yaxis;
	                  var xr0 = oldFullLayout[xa._name].range.slice();
	                  var yr0 = oldFullLayout[ya._name].range.slice();
	                  var xr1 = xa.range.slice();
	                  var yr1 = ya.range.slice();
	                  xa.setScale();
	                  ya.setScale();
	                  var editX = null;
	                  var editY = null;
	                  if (xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1])) {
	                    editX = {
	                      xr0,
	                      xr1
	                    };
	                  }
	                  if (ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1])) {
	                    editY = {
	                      yr0,
	                      yr1
	                    };
	                  }
	                  if (editX || editY) {
	                    axEdits.push(Lib.extendFlat({
	                      plotinfo
	                    }, editX, editY));
	                  }
	                }
	                return Promise.resolve();
	              };
	              opts.runFn = function(makeCallback) {
	                var fullData = gd._fullData;
	                var fullLayout2 = gd._fullLayout;
	                var basePlotModules = fullLayout2._basePlotModules;
	                var axisTransitionOpts;
	                var traceTransitionOpts;
	                var transitionedTraces;
	                var allTraceIndices = [];
	                for (var i = 0; i < fullData.length; i++) {
	                  allTraceIndices.push(i);
	                }
	                function transitionAxes() {
	                  if (!gd._fullLayout) return;
	                  for (var j = 0; j < basePlotModules.length; j++) {
	                    if (basePlotModules[j].transitionAxes) {
	                      basePlotModules[j].transitionAxes(gd, axEdits, axisTransitionOpts, makeCallback);
	                    }
	                  }
	                }
	                function transitionTraces() {
	                  if (!gd._fullLayout) return;
	                  for (var j = 0; j < basePlotModules.length; j++) {
	                    basePlotModules[j].plot(gd, transitionedTraces, traceTransitionOpts, makeCallback);
	                  }
	                }
	                if (axEdits.length && restyleFlags.anim) {
	                  if (transitionOpts.ordering === "traces first") {
	                    axisTransitionOpts = Lib.extendFlat({}, transitionOpts, {
	                      duration: 0
	                    });
	                    transitionedTraces = allTraceIndices;
	                    traceTransitionOpts = transitionOpts;
	                    setTimeout(transitionAxes, transitionOpts.duration);
	                    transitionTraces();
	                  } else {
	                    axisTransitionOpts = transitionOpts;
	                    transitionedTraces = null;
	                    traceTransitionOpts = Lib.extendFlat({}, transitionOpts, {
	                      duration: 0
	                    });
	                    setTimeout(transitionTraces, axisTransitionOpts.duration);
	                    transitionAxes();
	                  }
	                } else if (axEdits.length) {
	                  axisTransitionOpts = transitionOpts;
	                  transitionAxes();
	                } else if (restyleFlags.anim) {
	                  transitionedTraces = allTraceIndices;
	                  traceTransitionOpts = transitionOpts;
	                  transitionTraces();
	                }
	              };
	              return _transition(gd, transitionOpts, opts);
	            };
	            function _transition(gd, transitionOpts, opts) {
	              var aborted = false;
	              function executeCallbacks(list) {
	                var p = Promise.resolve();
	                if (!list) return p;
	                while (list.length) {
	                  p = p.then(list.shift());
	                }
	                return p;
	              }
	              function flushCallbacks(list) {
	                if (!list) return;
	                while (list.length) {
	                  list.shift();
	                }
	              }
	              function executeTransitions() {
	                gd.emit("plotly_transitioning", []);
	                return new Promise(function(resolve) {
	                  gd._transitioning = true;
	                  if (transitionOpts.duration > 0) {
	                    gd._transitioningWithDuration = true;
	                  }
	                  gd._transitionData._interruptCallbacks.push(function() {
	                    aborted = true;
	                  });
	                  if (opts.redraw) {
	                    gd._transitionData._interruptCallbacks.push(function() {
	                      return Registry.call("redraw", gd);
	                    });
	                  }
	                  gd._transitionData._interruptCallbacks.push(function() {
	                    gd.emit("plotly_transitioninterrupted", []);
	                  });
	                  var numCallbacks = 0;
	                  var numCompleted = 0;
	                  function makeCallback() {
	                    numCallbacks++;
	                    return function() {
	                      numCompleted++;
	                      if (!aborted && numCompleted === numCallbacks) {
	                        completeTransition(resolve);
	                      }
	                    };
	                  }
	                  opts.runFn(makeCallback);
	                  setTimeout(makeCallback());
	                });
	              }
	              function completeTransition(callback) {
	                if (!gd._transitionData) return;
	                flushCallbacks(gd._transitionData._interruptCallbacks);
	                return Promise.resolve().then(function() {
	                  if (opts.redraw) {
	                    return Registry.call("redraw", gd);
	                  }
	                }).then(function() {
	                  gd._transitioning = false;
	                  gd._transitioningWithDuration = false;
	                  gd.emit("plotly_transitioned", []);
	                }).then(callback);
	              }
	              function interruptPreviousTransitions() {
	                if (!gd._transitionData) return;
	                gd._transitioning = false;
	                return executeCallbacks(gd._transitionData._interruptCallbacks);
	              }
	              var seq = [plots.previousPromises, interruptPreviousTransitions, opts.prepareFn, plots.rehover, plots.reselect, executeTransitions];
	              var transitionStarting = Lib.syncOrAsync(seq, gd);
	              if (!transitionStarting || !transitionStarting.then) {
	                transitionStarting = Promise.resolve();
	              }
	              return transitionStarting.then(function() {
	                return gd;
	              });
	            }
	            plots.doCalcdata = function(gd, traces) {
	              var axList = axisIDs.list(gd);
	              var fullData = gd._fullData;
	              var fullLayout = gd._fullLayout;
	              var trace, _module, i, j;
	              var calcdata = new Array(fullData.length);
	              var oldCalcdata = (gd.calcdata || []).slice();
	              gd.calcdata = calcdata;
	              fullLayout._numBoxes = 0;
	              fullLayout._numViolins = 0;
	              fullLayout._violinScaleGroupStats = {};
	              gd._hmpixcount = 0;
	              gd._hmlumcount = 0;
	              fullLayout._piecolormap = {};
	              fullLayout._sunburstcolormap = {};
	              fullLayout._treemapcolormap = {};
	              fullLayout._iciclecolormap = {};
	              fullLayout._funnelareacolormap = {};
	              for (i = 0; i < fullData.length; i++) {
	                if (Array.isArray(traces) && traces.indexOf(i) === -1) {
	                  calcdata[i] = oldCalcdata[i];
	                  continue;
	                }
	              }
	              for (i = 0; i < fullData.length; i++) {
	                trace = fullData[i];
	                trace._arrayAttrs = PlotSchema.findArrayAttributes(trace);
	                trace._extremes = {};
	              }
	              var polarIds = fullLayout._subplots.polar || [];
	              for (i = 0; i < polarIds.length; i++) {
	                axList.push(fullLayout[polarIds[i]].radialaxis, fullLayout[polarIds[i]].angularaxis);
	              }
	              for (var k in fullLayout._colorAxes) {
	                var cOpts = fullLayout[k];
	                if (cOpts.cauto !== false) {
	                  delete cOpts.cmin;
	                  delete cOpts.cmax;
	                }
	              }
	              var hasCalcTransform = false;
	              function transformCalci(i2) {
	                trace = fullData[i2];
	                _module = trace._module;
	                if (trace.visible === true && trace.transforms) {
	                  if (_module && _module.calc) {
	                    var cdi = _module.calc(gd, trace);
	                    if (cdi[0] && cdi[0].t && cdi[0].t._scene) {
	                      delete cdi[0].t._scene.dirty;
	                    }
	                  }
	                  for (j = 0; j < trace.transforms.length; j++) {
	                    var transform = trace.transforms[j];
	                    _module = transformsRegistry[transform.type];
	                    if (_module && _module.calcTransform) {
	                      trace._hasCalcTransform = true;
	                      hasCalcTransform = true;
	                      _module.calcTransform(gd, trace, transform);
	                    }
	                  }
	                }
	              }
	              function calci(i2, isContainer) {
	                trace = fullData[i2];
	                _module = trace._module;
	                if (!!_module.isContainer !== isContainer) return;
	                var cd = [];
	                if (trace.visible === true && trace._length !== 0) {
	                  delete trace._indexToPoints;
	                  var transforms = trace.transforms || [];
	                  for (j = transforms.length - 1; j >= 0; j--) {
	                    if (transforms[j].enabled) {
	                      trace._indexToPoints = transforms[j]._indexToPoints;
	                      break;
	                    }
	                  }
	                  if (_module && _module.calc) {
	                    cd = _module.calc(gd, trace);
	                  }
	                }
	                if (!Array.isArray(cd) || !cd[0]) {
	                  cd = [{
	                    x: BADNUM,
	                    y: BADNUM
	                  }];
	                }
	                if (!cd[0].t) cd[0].t = {};
	                cd[0].trace = trace;
	                calcdata[i2] = cd;
	              }
	              setupAxisCategories(axList, fullData, fullLayout);
	              for (i = 0; i < fullData.length; i++) calci(i, true);
	              for (i = 0; i < fullData.length; i++) transformCalci(i);
	              if (hasCalcTransform) setupAxisCategories(axList, fullData, fullLayout);
	              for (i = 0; i < fullData.length; i++) calci(i, true);
	              for (i = 0; i < fullData.length; i++) calci(i, false);
	              doCrossTraceCalc(gd);
	              var sorted = sortAxisCategoriesByValue(axList, gd);
	              if (sorted.length) {
	                fullLayout._numBoxes = 0;
	                fullLayout._numViolins = 0;
	                for (i = 0; i < sorted.length; i++) calci(sorted[i], true);
	                for (i = 0; i < sorted.length; i++) calci(sorted[i], false);
	                doCrossTraceCalc(gd);
	              }
	              Registry.getComponentMethod("fx", "calc")(gd);
	              Registry.getComponentMethod("errorbars", "calc")(gd);
	            };
	            var sortAxisCategoriesByValueRegex = /(total|sum|min|max|mean|median) (ascending|descending)/;
	            function sortAxisCategoriesByValue(axList, gd) {
	              var affectedTraces = [];
	              var i, j, k, l, o;
	              function zMapCategory(type2, ax2, value2) {
	                var axLetter2 = ax2._id.charAt(0);
	                if (type2 === "histogram2dcontour") {
	                  var counterAxLetter = ax2._counterAxes[0];
	                  var counterAx = axisIDs.getFromId(gd, counterAxLetter);
	                  var xCategorical = axLetter2 === "x" || counterAxLetter === "x" && counterAx.type === "category";
	                  var yCategorical = axLetter2 === "y" || counterAxLetter === "y" && counterAx.type === "category";
	                  return function(o2, l2) {
	                    if (o2 === 0 || l2 === 0) return -1;
	                    if (xCategorical && o2 === value2[l2].length - 1) return -1;
	                    if (yCategorical && l2 === value2.length - 1) return -1;
	                    return (axLetter2 === "y" ? l2 : o2) - 1;
	                  };
	                } else {
	                  return function(o2, l2) {
	                    return axLetter2 === "y" ? l2 : o2;
	                  };
	                }
	              }
	              var aggFn = {
	                min: function(values) {
	                  return Lib.aggNums(Math.min, null, values);
	                },
	                max: function(values) {
	                  return Lib.aggNums(Math.max, null, values);
	                },
	                sum: function(values) {
	                  return Lib.aggNums(function(a, b) {
	                    return a + b;
	                  }, null, values);
	                },
	                total: function(values) {
	                  return Lib.aggNums(function(a, b) {
	                    return a + b;
	                  }, null, values);
	                },
	                mean: function(values) {
	                  return Lib.mean(values);
	                },
	                median: function(values) {
	                  return Lib.median(values);
	                }
	              };
	              function sortAscending(a, b) {
	                return a[1] - b[1];
	              }
	              function sortDescending(a, b) {
	                return b[1] - a[1];
	              }
	              for (i = 0; i < axList.length; i++) {
	                var ax = axList[i];
	                if (ax.type !== "category") continue;
	                var match = ax.categoryorder.match(sortAxisCategoriesByValueRegex);
	                if (match) {
	                  var aggregator = match[1];
	                  var order = match[2];
	                  var axLetter = ax._id.charAt(0);
	                  var isX = axLetter === "x";
	                  var categoriesValue = [];
	                  for (j = 0; j < ax._categories.length; j++) {
	                    categoriesValue.push([ax._categories[j], []]);
	                  }
	                  for (j = 0; j < ax._traceIndices.length; j++) {
	                    var traceIndex = ax._traceIndices[j];
	                    var fullTrace = gd._fullData[traceIndex];
	                    if (fullTrace.visible !== true) continue;
	                    var type = fullTrace.type;
	                    if (Registry.traceIs(fullTrace, "histogram")) {
	                      delete fullTrace._xautoBinFinished;
	                      delete fullTrace._yautoBinFinished;
	                    }
	                    var isSplom = type === "splom";
	                    var isScattergl = type === "scattergl";
	                    var cd = gd.calcdata[traceIndex];
	                    for (k = 0; k < cd.length; k++) {
	                      var cdi = cd[k];
	                      var catIndex, value;
	                      if (isSplom) {
	                        var currentDimensionIndex = fullTrace._axesDim[ax._id];
	                        if (!isX) {
	                          var associatedXAxisID = fullTrace._diag[currentDimensionIndex][0];
	                          if (associatedXAxisID) ax = gd._fullLayout[axisIDs.id2name(associatedXAxisID)];
	                        }
	                        var categories = cdi.trace.dimensions[currentDimensionIndex].values;
	                        for (l = 0; l < categories.length; l++) {
	                          catIndex = ax._categoriesMap[categories[l]];
	                          for (o = 0; o < cdi.trace.dimensions.length; o++) {
	                            if (o === currentDimensionIndex) continue;
	                            var dimension = cdi.trace.dimensions[o];
	                            categoriesValue[catIndex][1].push(dimension.values[l]);
	                          }
	                        }
	                      } else if (isScattergl) {
	                        for (l = 0; l < cdi.t.x.length; l++) {
	                          if (isX) {
	                            catIndex = cdi.t.x[l];
	                            value = cdi.t.y[l];
	                          } else {
	                            catIndex = cdi.t.y[l];
	                            value = cdi.t.x[l];
	                          }
	                          categoriesValue[catIndex][1].push(value);
	                        }
	                        if (cdi.t && cdi.t._scene) {
	                          delete cdi.t._scene.dirty;
	                        }
	                      } else if (cdi.hasOwnProperty("z")) {
	                        value = cdi.z;
	                        var mapping = zMapCategory(fullTrace.type, ax, value);
	                        for (l = 0; l < value.length; l++) {
	                          for (o = 0; o < value[l].length; o++) {
	                            catIndex = mapping(o, l);
	                            if (catIndex + 1) categoriesValue[catIndex][1].push(value[l][o]);
	                          }
	                        }
	                      } else {
	                        catIndex = cdi.p;
	                        if (catIndex === undefined) catIndex = cdi[axLetter];
	                        value = cdi.s;
	                        if (value === undefined) value = cdi.v;
	                        if (value === undefined) value = isX ? cdi.y : cdi.x;
	                        if (!Array.isArray(value)) {
	                          if (value === undefined) value = [];
	                          else value = [value];
	                        }
	                        for (l = 0; l < value.length; l++) {
	                          categoriesValue[catIndex][1].push(value[l]);
	                        }
	                      }
	                    }
	                  }
	                  ax._categoriesValue = categoriesValue;
	                  var categoriesAggregatedValue = [];
	                  for (j = 0; j < categoriesValue.length; j++) {
	                    categoriesAggregatedValue.push([categoriesValue[j][0], aggFn[aggregator](categoriesValue[j][1])]);
	                  }
	                  categoriesAggregatedValue.sort(order === "descending" ? sortDescending : sortAscending);
	                  ax._categoriesAggregatedValue = categoriesAggregatedValue;
	                  ax._initialCategories = categoriesAggregatedValue.map(function(c) {
	                    return c[0];
	                  });
	                  affectedTraces = affectedTraces.concat(ax.sortByInitialCategories());
	                }
	              }
	              return affectedTraces;
	            }
	            function setupAxisCategories(axList, fullData, fullLayout) {
	              var axLookup = {};
	              function setupOne(ax) {
	                ax.clearCalc();
	                if (ax.type === "multicategory") {
	                  ax.setupMultiCategory(fullData);
	                }
	                axLookup[ax._id] = 1;
	              }
	              Lib.simpleMap(axList, setupOne);
	              var matchGroups = fullLayout._axisMatchGroups || [];
	              for (var i = 0; i < matchGroups.length; i++) {
	                for (var axId in matchGroups[i]) {
	                  if (!axLookup[axId]) {
	                    setupOne(fullLayout[axisIDs.id2name(axId)]);
	                  }
	                }
	              }
	            }
	            function doCrossTraceCalc(gd) {
	              var fullLayout = gd._fullLayout;
	              var modules = fullLayout._visibleModules;
	              var hash = {};
	              var i, j, k;
	              for (j = 0; j < modules.length; j++) {
	                var _module = modules[j];
	                var fn = _module.crossTraceCalc;
	                if (fn) {
	                  var spType = _module.basePlotModule.name;
	                  if (hash[spType]) {
	                    Lib.pushUnique(hash[spType], fn);
	                  } else {
	                    hash[spType] = [fn];
	                  }
	                }
	              }
	              for (k in hash) {
	                var methods = hash[k];
	                var subplots = fullLayout._subplots[k];
	                if (Array.isArray(subplots)) {
	                  for (i = 0; i < subplots.length; i++) {
	                    var sp = subplots[i];
	                    var spInfo = k === "cartesian" ? fullLayout._plots[sp] : fullLayout[sp];
	                    for (j = 0; j < methods.length; j++) {
	                      methods[j](gd, spInfo, sp);
	                    }
	                  }
	                } else {
	                  for (j = 0; j < methods.length; j++) {
	                    methods[j](gd);
	                  }
	                }
	              }
	            }
	            plots.rehover = function(gd) {
	              if (gd._fullLayout._rehover) {
	                gd._fullLayout._rehover();
	              }
	            };
	            plots.redrag = function(gd) {
	              if (gd._fullLayout._redrag) {
	                gd._fullLayout._redrag();
	              }
	            };
	            plots.reselect = function(gd) {
	              var fullLayout = gd._fullLayout;
	              var A = (gd.layout || {}).selections;
	              var B = fullLayout._previousSelections;
	              fullLayout._previousSelections = A;
	              var mayEmitSelected = fullLayout._reselect || JSON.stringify(A) !== JSON.stringify(B);
	              Registry.getComponentMethod("selections", "reselect")(gd, mayEmitSelected);
	            };
	            plots.generalUpdatePerTraceModule = function(gd, subplot, subplotCalcData, subplotLayout) {
	              var traceHashOld = subplot.traceHash;
	              var traceHash = {};
	              var i;
	              for (i = 0; i < subplotCalcData.length; i++) {
	                var calcTraces = subplotCalcData[i];
	                var trace = calcTraces[0].trace;
	                if (trace.visible) {
	                  traceHash[trace.type] = traceHash[trace.type] || [];
	                  traceHash[trace.type].push(calcTraces);
	                }
	              }
	              for (var moduleNameOld in traceHashOld) {
	                if (!traceHash[moduleNameOld]) {
	                  var fakeCalcTrace = traceHashOld[moduleNameOld][0];
	                  var fakeTrace = fakeCalcTrace[0].trace;
	                  fakeTrace.visible = false;
	                  traceHash[moduleNameOld] = [fakeCalcTrace];
	                }
	              }
	              for (var moduleName in traceHash) {
	                var moduleCalcData = traceHash[moduleName];
	                var _module = moduleCalcData[0][0].trace._module;
	                _module.plot(gd, subplot, Lib.filterVisible(moduleCalcData), subplotLayout);
	              }
	              subplot.traceHash = traceHash;
	            };
	            plots.plotBasePlot = function(desiredType, gd, traces, transitionOpts, makeOnCompleteCallback) {
	              var _module = Registry.getModule(desiredType);
	              var cdmodule = getModuleCalcData(gd.calcdata, _module)[0];
	              _module.plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback);
	            };
	            plots.cleanBasePlot = function(desiredType, newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var had = oldFullLayout._has && oldFullLayout._has(desiredType);
	              var has = newFullLayout._has && newFullLayout._has(desiredType);
	              if (had && !has) {
	                oldFullLayout["_" + desiredType + "layer"].selectAll("g.trace").remove();
	              }
	            };
	          }
	        ),
	        /***/
	        9813: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              attr: "subplot",
	              name: "polar",
	              axisNames: ["angularaxis", "radialaxis"],
	              axisName2dataArray: {
	                angularaxis: "theta",
	                radialaxis: "r"
	              },
	              layerNames: ["draglayer", "plotbg", "backplot", "angular-grid", "radial-grid", "frontplot", "angular-line", "radial-line", "angular-axis", "radial-axis"],
	              radialDragBoxSize: 50,
	              angularDragBoxSize: 30,
	              cornerLen: 25,
	              cornerHalfWidth: 2,
	              // pixels to move mouse before you stop clamping to starting point
	              MINDRAG: 8,
	              // smallest radial distance [px] allowed for a zoombox
	              MINZOOM: 20,
	              // distance [px] off (r=0) or (r=radius) where we transition
	              // from single-sided to two-sided radial zoom
	              OFFEDGE: 20
	            };
	          }
	        ),
	        /***/
	        10869: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var polygonTester = __webpack_require__2(61082).tester;
	            var findIndexOfMin = Lib.findIndexOfMin;
	            var isAngleInsideSector = Lib.isAngleInsideSector;
	            var angleDelta = Lib.angleDelta;
	            var angleDist = Lib.angleDist;
	            function isPtInsidePolygon(r, a, rBnds, aBnds, vangles) {
	              if (!isAngleInsideSector(a, aBnds)) return false;
	              var r0, r1;
	              if (rBnds[0] < rBnds[1]) {
	                r0 = rBnds[0];
	                r1 = rBnds[1];
	              } else {
	                r0 = rBnds[1];
	                r1 = rBnds[0];
	              }
	              var polygonIn = polygonTester(makePolygon(r0, aBnds[0], aBnds[1], vangles));
	              var polygonOut = polygonTester(makePolygon(r1, aBnds[0], aBnds[1], vangles));
	              var xy = [r * Math.cos(a), r * Math.sin(a)];
	              return polygonOut.contains(xy) && !polygonIn.contains(xy);
	            }
	            function findIntersectionXY(v0, v1, a, xpyp) {
	              var xstar, ystar;
	              var xp = xpyp[0];
	              var yp = xpyp[1];
	              var dsin = clampTiny(Math.sin(v1) - Math.sin(v0));
	              var dcos = clampTiny(Math.cos(v1) - Math.cos(v0));
	              var tanA = Math.tan(a);
	              var cotanA = clampTiny(1 / tanA);
	              var m = dsin / dcos;
	              var b = yp - m * xp;
	              if (cotanA) {
	                if (dsin && dcos) {
	                  xstar = b / (tanA - m);
	                  ystar = tanA * xstar;
	                } else if (dcos) {
	                  xstar = yp * cotanA;
	                  ystar = yp;
	                } else {
	                  xstar = xp;
	                  ystar = xp * tanA;
	                }
	              } else {
	                if (dsin && dcos) {
	                  xstar = 0;
	                  ystar = b;
	                } else if (dcos) {
	                  xstar = 0;
	                  ystar = yp;
	                } else {
	                  xstar = ystar = NaN;
	                }
	              }
	              return [xstar, ystar];
	            }
	            function findXYatLength(l, m, xp, yp) {
	              var t = -m * xp;
	              var a = m * m + 1;
	              var b = 2 * (m * t - xp);
	              var c = t * t + xp * xp - l * l;
	              var del = Math.sqrt(b * b - 4 * a * c);
	              var x0 = (-b + del) / (2 * a);
	              var x1 = (-b - del) / (2 * a);
	              return [[x0, m * x0 + t + yp], [x1, m * x1 + t + yp]];
	            }
	            function makeRegularPolygon(r, vangles) {
	              var len = vangles.length;
	              var vertices = new Array(len + 1);
	              var i;
	              for (i = 0; i < len; i++) {
	                var va = vangles[i];
	                vertices[i] = [r * Math.cos(va), r * Math.sin(va)];
	              }
	              vertices[i] = vertices[0].slice();
	              return vertices;
	            }
	            function makeClippedPolygon(r, a0, a1, vangles) {
	              var len = vangles.length;
	              var vertices = [];
	              var i, j;
	              function a2xy(a) {
	                return [r * Math.cos(a), r * Math.sin(a)];
	              }
	              function findXY(va0, va1, s) {
	                return findIntersectionXY(va0, va1, s, a2xy(va0));
	              }
	              function cycleIndex(ind) {
	                return Lib.mod(ind, len);
	              }
	              function isInside(v) {
	                return isAngleInsideSector(v, [a0, a1]);
	              }
	              var i0 = findIndexOfMin(vangles, function(v) {
	                return isInside(v) ? angleDist(v, a0) : Infinity;
	              });
	              var xy0 = findXY(vangles[i0], vangles[cycleIndex(i0 - 1)], a0);
	              vertices.push(xy0);
	              for (i = i0, j = 0; j < len; i++, j++) {
	                var va = vangles[cycleIndex(i)];
	                if (!isInside(va)) break;
	                vertices.push(a2xy(va));
	              }
	              var iN = findIndexOfMin(vangles, function(v) {
	                return isInside(v) ? angleDist(v, a1) : Infinity;
	              });
	              var xyN = findXY(vangles[iN], vangles[cycleIndex(iN + 1)], a1);
	              vertices.push(xyN);
	              vertices.push([0, 0]);
	              vertices.push(vertices[0].slice());
	              return vertices;
	            }
	            function makePolygon(r, a0, a1, vangles) {
	              return Lib.isFullCircle([a0, a1]) ? makeRegularPolygon(r, vangles) : makeClippedPolygon(r, a0, a1, vangles);
	            }
	            function findPolygonOffset(r, a0, a1, vangles) {
	              var minX = Infinity;
	              var minY = Infinity;
	              var vertices = makePolygon(r, a0, a1, vangles);
	              for (var i = 0; i < vertices.length; i++) {
	                var v = vertices[i];
	                minX = Math.min(minX, v[0]);
	                minY = Math.min(minY, -v[1]);
	              }
	              return [minX, minY];
	            }
	            function findEnclosingVertexAngles(a, vangles) {
	              var minFn = function(v) {
	                var adelta = angleDelta(v, a);
	                return adelta > 0 ? adelta : Infinity;
	              };
	              var i0 = findIndexOfMin(vangles, minFn);
	              var i1 = Lib.mod(i0 + 1, vangles.length);
	              return [vangles[i0], vangles[i1]];
	            }
	            function clampTiny(v) {
	              return Math.abs(v) > 1e-10 ? v : 0;
	            }
	            function transformForSVG(pts0, cx, cy) {
	              cx = cx || 0;
	              cy = cy || 0;
	              var len = pts0.length;
	              var pts1 = new Array(len);
	              for (var i = 0; i < len; i++) {
	                var pt = pts0[i];
	                pts1[i] = [cx + pt[0], cy - pt[1]];
	              }
	              return pts1;
	            }
	            function pathPolygon(r, a0, a1, vangles, cx, cy) {
	              var poly = makePolygon(r, a0, a1, vangles);
	              return "M" + transformForSVG(poly, cx, cy).join("L");
	            }
	            function pathPolygonAnnulus(r0, r1, a0, a1, vangles, cx, cy) {
	              var rStart, rEnd;
	              if (r0 < r1) {
	                rStart = r0;
	                rEnd = r1;
	              } else {
	                rStart = r1;
	                rEnd = r0;
	              }
	              var inner = transformForSVG(makePolygon(rStart, a0, a1, vangles), cx, cy);
	              var outer = transformForSVG(makePolygon(rEnd, a0, a1, vangles), cx, cy);
	              return "M" + outer.reverse().join("L") + "M" + inner.join("L");
	            }
	            module2.exports = {
	              isPtInsidePolygon,
	              findPolygonOffset,
	              findEnclosingVertexAngles,
	              findIntersectionXY,
	              findXYatLength,
	              clampTiny,
	              pathPolygon,
	              pathPolygonAnnulus
	            };
	          }
	        ),
	        /***/
	        23580: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getSubplotCalcData = __webpack_require__2(27659).AU;
	            var counterRegex = __webpack_require__2(71828).counterRegex;
	            var createPolar = __webpack_require__2(77997);
	            var constants = __webpack_require__2(9813);
	            var attr = constants.attr;
	            var name2 = constants.name;
	            var counter = counterRegex(name2);
	            var attributes = {};
	            attributes[attr] = {
	              valType: "subplotid",
	              dflt: name2,
	              editType: "calc"
	            };
	            function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var calcData = gd.calcdata;
	              var subplotIds = fullLayout._subplots[name2];
	              for (var i = 0; i < subplotIds.length; i++) {
	                var id = subplotIds[i];
	                var subplotCalcData = getSubplotCalcData(calcData, name2, id);
	                var subplot = fullLayout[id]._subplot;
	                if (!subplot) {
	                  subplot = createPolar(gd, id);
	                  fullLayout[id]._subplot = subplot;
	                }
	                subplot.plot(subplotCalcData, fullLayout, gd._promises);
	              }
	            }
	            function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldIds = oldFullLayout._subplots[name2] || [];
	              var hadGl = oldFullLayout._has && oldFullLayout._has("gl");
	              var hasGl = newFullLayout._has && newFullLayout._has("gl");
	              var mustCleanScene = hadGl && !hasGl;
	              for (var i = 0; i < oldIds.length; i++) {
	                var id = oldIds[i];
	                var oldSubplot = oldFullLayout[id]._subplot;
	                if (!newFullLayout[id] && !!oldSubplot) {
	                  oldSubplot.framework.remove();
	                  oldSubplot.layers["radial-axis-title"].remove();
	                  for (var k in oldSubplot.clipPaths) {
	                    oldSubplot.clipPaths[k].remove();
	                  }
	                }
	                if (mustCleanScene && oldSubplot._scene) {
	                  oldSubplot._scene.destroy();
	                  oldSubplot._scene = null;
	                }
	              }
	            }
	            module2.exports = {
	              attr,
	              name: name2,
	              idRoot: name2,
	              idRegex: counter,
	              attrRegex: counter,
	              attributes,
	              layoutAttributes: __webpack_require__2(73812),
	              supplyLayoutDefaults: __webpack_require__2(68993),
	              plot,
	              clean,
	              toSVG: __webpack_require__2(93612).toSVG
	            };
	          }
	        ),
	        /***/
	        73812: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorAttrs = __webpack_require__2(22399);
	            var axesAttrs = __webpack_require__2(13838);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var extendFlat = __webpack_require__2(71828).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var axisLineGridAttr = overrideAll({
	              color: axesAttrs.color,
	              showline: extendFlat({}, axesAttrs.showline, {
	                dflt: true
	              }),
	              linecolor: axesAttrs.linecolor,
	              linewidth: axesAttrs.linewidth,
	              showgrid: extendFlat({}, axesAttrs.showgrid, {
	                dflt: true
	              }),
	              gridcolor: axesAttrs.gridcolor,
	              gridwidth: axesAttrs.gridwidth,
	              griddash: axesAttrs.griddash
	              // TODO add spike* attributes down the road
	              // should we add zeroline* attributes?
	            }, "plot", "from-root");
	            var axisTickAttrs = overrideAll({
	              tickmode: axesAttrs.minor.tickmode,
	              nticks: axesAttrs.nticks,
	              tick0: axesAttrs.tick0,
	              dtick: axesAttrs.dtick,
	              tickvals: axesAttrs.tickvals,
	              ticktext: axesAttrs.ticktext,
	              ticks: axesAttrs.ticks,
	              ticklen: axesAttrs.ticklen,
	              tickwidth: axesAttrs.tickwidth,
	              tickcolor: axesAttrs.tickcolor,
	              ticklabelstep: axesAttrs.ticklabelstep,
	              showticklabels: axesAttrs.showticklabels,
	              labelalias: axesAttrs.labelalias,
	              showtickprefix: axesAttrs.showtickprefix,
	              tickprefix: axesAttrs.tickprefix,
	              showticksuffix: axesAttrs.showticksuffix,
	              ticksuffix: axesAttrs.ticksuffix,
	              showexponent: axesAttrs.showexponent,
	              exponentformat: axesAttrs.exponentformat,
	              minexponent: axesAttrs.minexponent,
	              separatethousands: axesAttrs.separatethousands,
	              tickfont: axesAttrs.tickfont,
	              tickangle: axesAttrs.tickangle,
	              tickformat: axesAttrs.tickformat,
	              tickformatstops: axesAttrs.tickformatstops,
	              layer: axesAttrs.layer
	            }, "plot", "from-root");
	            var radialAxisAttrs = {
	              visible: extendFlat({}, axesAttrs.visible, {
	                dflt: true
	              }),
	              type: extendFlat({}, axesAttrs.type, {
	                values: ["-", "linear", "log", "date", "category"]
	              }),
	              autotypenumbers: axesAttrs.autotypenumbers,
	              autorangeoptions: {
	                minallowed: axesAttrs.autorangeoptions.minallowed,
	                maxallowed: axesAttrs.autorangeoptions.maxallowed,
	                clipmin: axesAttrs.autorangeoptions.clipmin,
	                clipmax: axesAttrs.autorangeoptions.clipmax,
	                include: axesAttrs.autorangeoptions.include,
	                editType: "plot"
	              },
	              autorange: extendFlat({}, axesAttrs.autorange, {
	                editType: "plot"
	              }),
	              rangemode: {
	                valType: "enumerated",
	                values: ["tozero", "nonnegative", "normal"],
	                dflt: "tozero",
	                editType: "calc"
	              },
	              minallowed: extendFlat({}, axesAttrs.minallowed, {
	                editType: "plot"
	              }),
	              maxallowed: extendFlat({}, axesAttrs.maxallowed, {
	                editType: "plot"
	              }),
	              range: extendFlat({}, axesAttrs.range, {
	                items: [{
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autorange": false
	                  }
	                }, {
	                  valType: "any",
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autorange": false
	                  }
	                }],
	                editType: "plot"
	              }),
	              categoryorder: axesAttrs.categoryorder,
	              categoryarray: axesAttrs.categoryarray,
	              angle: {
	                valType: "angle",
	                editType: "plot"
	              },
	              side: {
	                valType: "enumerated",
	                // TODO add 'center' for `showline: false` radial axes
	                values: ["clockwise", "counterclockwise"],
	                dflt: "clockwise",
	                editType: "plot"
	              },
	              title: {
	                // radial title is not gui-editable at the moment,
	                // so it needs dflt: '', similar to carpet axes.
	                text: extendFlat({}, axesAttrs.title.text, {
	                  editType: "plot",
	                  dflt: ""
	                }),
	                font: extendFlat({}, axesAttrs.title.font, {
	                  editType: "plot"
	                }),
	                // TODO
	                // - might need a 'titleside' and even 'titledirection' down the road
	                // - what about standoff ??
	                editType: "plot"
	              },
	              hoverformat: axesAttrs.hoverformat,
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              editType: "calc",
	              _deprecated: {
	                title: axesAttrs._deprecated.title,
	                titlefont: axesAttrs._deprecated.titlefont
	              }
	            };
	            extendFlat(
	              radialAxisAttrs,
	              // N.B. radialaxis grid lines are circular,
	              // but radialaxis lines are straight from circle center to outer bound
	              axisLineGridAttr,
	              axisTickAttrs
	            );
	            var angularAxisAttrs = {
	              visible: extendFlat({}, axesAttrs.visible, {
	                dflt: true
	              }),
	              type: {
	                valType: "enumerated",
	                // 'linear' should maybe be called 'angle' or 'angular' here
	                // to make clear that axis here is periodic and more tightly match
	                // `thetaunit`?
	                //
	                // skip 'date' for first push
	                // no 'log' for now
	                values: ["-", "linear", "category"],
	                dflt: "-",
	                editType: "calc",
	                _noTemplating: true
	              },
	              autotypenumbers: axesAttrs.autotypenumbers,
	              categoryorder: axesAttrs.categoryorder,
	              categoryarray: axesAttrs.categoryarray,
	              thetaunit: {
	                valType: "enumerated",
	                values: ["radians", "degrees"],
	                dflt: "degrees",
	                editType: "calc"
	              },
	              period: {
	                valType: "number",
	                editType: "calc",
	                min: 0
	                // Examples for date axes:
	                //
	                // - period that equals the timeseries length
	                //  http://flowingdata.com/2017/01/24/one-dataset-visualized-25-ways/18-polar-coordinates/
	                // - and 1-year periods (focusing on seasonal change0
	                //  http://otexts.org/fpp2/seasonal-plots.html
	                //  https://blogs.scientificamerican.com/sa-visual/why-are-so-many-babies-born-around-8-00-a-m/
	                //  http://www.seasonaladjustment.com/2012/09/05/clock-plot-visualising-seasonality-using-r-and-ggplot2-part-3/
	                //  https://i.pinimg.com/736x/49/b9/72/49b972ccb3206a1a6d6f870dac543280.jpg
	                //  https://www.climate-lab-book.ac.uk/spirals/
	              },
	              direction: {
	                valType: "enumerated",
	                values: ["counterclockwise", "clockwise"],
	                dflt: "counterclockwise",
	                editType: "calc"
	              },
	              rotation: {
	                valType: "angle",
	                editType: "calc"
	              },
	              hoverformat: axesAttrs.hoverformat,
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              editType: "calc"
	            };
	            extendFlat(
	              angularAxisAttrs,
	              // N.B. angular grid lines are straight lines from circle center to outer bound
	              // the angular line is circular bounding the polar plot area.
	              axisLineGridAttr,
	              // N.B. ticksuffix defaults to '°' for angular axes with `thetaunit: 'degrees'`
	              axisTickAttrs
	            );
	            module2.exports = {
	              // TODO for x/y/zoom system for paper-based zooming:
	              // x: {},
	              // y: {},
	              // zoom: {},
	              domain: domainAttrs({
	                name: "polar",
	                editType: "plot"
	              }),
	              sector: {
	                valType: "info_array",
	                items: [{
	                  valType: "number",
	                  editType: "plot"
	                }, {
	                  valType: "number",
	                  editType: "plot"
	                }],
	                dflt: [0, 360],
	                editType: "plot"
	              },
	              hole: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                editType: "plot"
	              },
	              bgcolor: {
	                valType: "color",
	                editType: "plot",
	                dflt: colorAttrs.background
	              },
	              radialaxis: radialAxisAttrs,
	              angularaxis: angularAxisAttrs,
	              gridshape: {
	                valType: "enumerated",
	                values: ["circular", "linear"],
	                dflt: "circular",
	                editType: "plot"
	              },
	              // TODO maybe?
	              // annotations:
	              uirevision: {
	                valType: "any",
	                editType: "none"
	              },
	              editType: "calc"
	            };
	          }
	        ),
	        /***/
	        68993: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Template = __webpack_require__2(44467);
	            var handleSubplotDefaults = __webpack_require__2(49119);
	            var getSubplotData = __webpack_require__2(27659).NG;
	            var handleTickValueDefaults = __webpack_require__2(26218);
	            var handleTickMarkDefaults = __webpack_require__2(38701);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            var handleCategoryOrderDefaults = __webpack_require__2(15258);
	            var handleLineGridDefaults = __webpack_require__2(92128);
	            var handleAutorangeOptionsDefaults = __webpack_require__2(23074);
	            var autoType = __webpack_require__2(4322);
	            var layoutAttributes = __webpack_require__2(73812);
	            var setConvert = __webpack_require__2(12101);
	            var constants = __webpack_require__2(9813);
	            var axisNames = constants.axisNames;
	            function handleDefaults(contIn, contOut, coerce, opts) {
	              var bgColor = coerce("bgcolor");
	              opts.bgColor = Color.combine(bgColor, opts.paper_bgcolor);
	              var sector = coerce("sector");
	              coerce("hole");
	              var subplotData = getSubplotData(opts.fullData, constants.name, opts.id);
	              var layoutOut = opts.layoutOut;
	              var axName;
	              function coerceAxis(attr, dflt) {
	                return coerce(axName + "." + attr, dflt);
	              }
	              for (var i = 0; i < axisNames.length; i++) {
	                axName = axisNames[i];
	                if (!Lib.isPlainObject(contIn[axName])) {
	                  contIn[axName] = {};
	                }
	                var axIn = contIn[axName];
	                var axOut = Template.newContainer(contOut, axName);
	                axOut._id = axOut._name = axName;
	                axOut._attr = opts.id + "." + axName;
	                axOut._traceIndices = subplotData.map(function(t) {
	                  return t._expandedIndex;
	                });
	                var dataAttr = constants.axisName2dataArray[axName];
	                var axType = handleAxisTypeDefaults(axIn, axOut, coerceAxis, subplotData, dataAttr, opts);
	                handleCategoryOrderDefaults(axIn, axOut, coerceAxis, {
	                  axData: subplotData,
	                  dataAttr
	                });
	                var visible = coerceAxis("visible");
	                setConvert(axOut, contOut, layoutOut);
	                coerceAxis("uirevision", contOut.uirevision);
	                axOut._m = 1;
	                switch (axName) {
	                  case "radialaxis":
	                    coerceAxis("minallowed");
	                    coerceAxis("maxallowed");
	                    var range2 = coerceAxis("range");
	                    var autorangeDflt = axOut.getAutorangeDflt(range2);
	                    var autorange = coerceAxis("autorange", autorangeDflt);
	                    var shouldAutorange;
	                    if (range2 && (range2[0] === null && range2[1] === null || (range2[0] === null || range2[1] === null) && (autorange === "reversed" || autorange === true) || range2[0] !== null && (autorange === "min" || autorange === "max reversed") || range2[1] !== null && (autorange === "max" || autorange === "min reversed"))) {
	                      range2 = undefined;
	                      delete axOut.range;
	                      axOut.autorange = true;
	                      shouldAutorange = true;
	                    }
	                    if (!shouldAutorange) {
	                      autorangeDflt = axOut.getAutorangeDflt(range2);
	                      autorange = coerceAxis("autorange", autorangeDflt);
	                    }
	                    axIn.autorange = autorange;
	                    if (autorange) {
	                      handleAutorangeOptionsDefaults(coerceAxis, autorange, range2);
	                      if (axType === "linear" || axType === "-") coerceAxis("rangemode");
	                      if (axOut.isReversed()) axOut._m = -1;
	                    }
	                    axOut.cleanRange("range", {
	                      dfltRange: [0, 1]
	                    });
	                    break;
	                  case "angularaxis":
	                    if (axType === "date") {
	                      Lib.log("Polar plots do not support date angular axes yet.");
	                      for (var j = 0; j < subplotData.length; j++) {
	                        subplotData[j].visible = false;
	                      }
	                      axType = axIn.type = axOut.type = "linear";
	                    }
	                    if (axType === "linear") {
	                      coerceAxis("thetaunit");
	                    } else {
	                      coerceAxis("period");
	                    }
	                    var direction = coerceAxis("direction");
	                    coerceAxis("rotation", {
	                      counterclockwise: 0,
	                      clockwise: 90
	                    }[direction]);
	                    break;
	                }
	                handlePrefixSuffixDefaults(axIn, axOut, coerceAxis, axOut.type, {
	                  tickSuffixDflt: axOut.thetaunit === "degrees" ? "°" : undefined
	                });
	                if (visible) {
	                  var dfltColor;
	                  var dfltFontColor;
	                  var dfltFontSize;
	                  var dfltFontFamily;
	                  var font = opts.font || {};
	                  dfltColor = coerceAxis("color");
	                  dfltFontColor = dfltColor === axIn.color ? dfltColor : font.color;
	                  dfltFontSize = font.size;
	                  dfltFontFamily = font.family;
	                  handleTickValueDefaults(axIn, axOut, coerceAxis, axOut.type);
	                  handleTickLabelDefaults(axIn, axOut, coerceAxis, axOut.type, {
	                    font: {
	                      color: dfltFontColor,
	                      size: dfltFontSize,
	                      family: dfltFontFamily
	                    }
	                  });
	                  handleTickMarkDefaults(axIn, axOut, coerceAxis, {
	                    outerTicks: true
	                  });
	                  handleLineGridDefaults(axIn, axOut, coerceAxis, {
	                    dfltColor,
	                    bgColor: opts.bgColor,
	                    // default grid color is darker here (60%, vs cartesian default ~91%)
	                    // because the grid is not square so the eye needs heavier cues to follow
	                    blend: 60,
	                    showLine: true,
	                    showGrid: true,
	                    noZeroLine: true,
	                    attributes: layoutAttributes[axName]
	                  });
	                  coerceAxis("layer");
	                  if (axName === "radialaxis") {
	                    coerceAxis("side");
	                    coerceAxis("angle", sector[0]);
	                    coerceAxis("title.text");
	                    Lib.coerceFont(coerceAxis, "title.font", {
	                      color: dfltFontColor,
	                      size: Lib.bigFont(dfltFontSize),
	                      family: dfltFontFamily
	                    });
	                  }
	                }
	                if (axType !== "category") coerceAxis("hoverformat");
	                axOut._input = axIn;
	              }
	              if (contOut.angularaxis.type === "category") {
	                coerce("gridshape");
	              }
	            }
	            function handleAxisTypeDefaults(axIn, axOut, coerce, subplotData, dataAttr, options) {
	              var autotypenumbers = coerce("autotypenumbers", options.autotypenumbersDflt);
	              var axType = coerce("type");
	              if (axType === "-") {
	                var trace;
	                for (var i = 0; i < subplotData.length; i++) {
	                  if (subplotData[i].visible) {
	                    trace = subplotData[i];
	                    break;
	                  }
	                }
	                if (trace && trace[dataAttr]) {
	                  axOut.type = autoType(trace[dataAttr], "gregorian", {
	                    noMultiCategory: true,
	                    autotypenumbers
	                  });
	                }
	                if (axOut.type === "-") {
	                  axOut.type = "linear";
	                } else {
	                  axIn.type = axOut.type;
	                }
	              }
	              return axOut.type;
	            }
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	                type: constants.name,
	                attributes: layoutAttributes,
	                handleDefaults,
	                font: layoutOut.font,
	                autotypenumbersDflt: layoutOut.autotypenumbers,
	                paper_bgcolor: layoutOut.paper_bgcolor,
	                fullData,
	                layoutOut
	              });
	            };
	          }
	        ),
	        /***/
	        77997: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var tinycolor = __webpack_require__2(84267);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var strRotate = Lib.strRotate;
	            var strTranslate = Lib.strTranslate;
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Plots = __webpack_require__2(74875);
	            var Axes = __webpack_require__2(89298);
	            var setConvertCartesian = __webpack_require__2(21994);
	            var setConvertPolar = __webpack_require__2(12101);
	            var doAutoRange = __webpack_require__2(71739).doAutoRange;
	            var dragBox = __webpack_require__2(29323);
	            var dragElement = __webpack_require__2(28569);
	            var Fx = __webpack_require__2(30211);
	            var Titles = __webpack_require__2(92998);
	            var prepSelect = __webpack_require__2(47322).prepSelect;
	            var selectOnClick = __webpack_require__2(47322).selectOnClick;
	            var clearOutline = __webpack_require__2(47322).clearOutline;
	            var setCursor = __webpack_require__2(6964);
	            var clearGlCanvases = __webpack_require__2(33306);
	            var redrawReglTraces = __webpack_require__2(61549).redrawReglTraces;
	            var MID_SHIFT = __webpack_require__2(18783).MID_SHIFT;
	            var constants = __webpack_require__2(9813);
	            var helpers = __webpack_require__2(10869);
	            var smithHelpers = __webpack_require__2(23893);
	            var smith = smithHelpers.smith;
	            var reactanceArc = smithHelpers.reactanceArc;
	            var resistanceArc = smithHelpers.resistanceArc;
	            var smithTransform = smithHelpers.smithTransform;
	            var _ = Lib._;
	            var mod = Lib.mod;
	            var deg2rad = Lib.deg2rad;
	            var rad2deg = Lib.rad2deg;
	            function Polar(gd, id, isSmith) {
	              this.isSmith = isSmith || false;
	              this.id = id;
	              this.gd = gd;
	              this._hasClipOnAxisFalse = null;
	              this.vangles = null;
	              this.radialAxisAngle = null;
	              this.traceHash = {};
	              this.layers = {};
	              this.clipPaths = {};
	              this.clipIds = {};
	              this.viewInitial = {};
	              var fullLayout = gd._fullLayout;
	              var clipIdBase = "clip" + fullLayout._uid + id;
	              this.clipIds.forTraces = clipIdBase + "-for-traces";
	              this.clipPaths.forTraces = fullLayout._clips.append("clipPath").attr("id", this.clipIds.forTraces);
	              this.clipPaths.forTraces.append("path");
	              this.framework = fullLayout["_" + (isSmith ? "smith" : "polar") + "layer"].append("g").attr("class", id);
	              this.getHole = function(s) {
	                return this.isSmith ? 0 : s.hole;
	              };
	              this.getSector = function(s) {
	                return this.isSmith ? [0, 360] : s.sector;
	              };
	              this.getRadial = function(s) {
	                return this.isSmith ? s.realaxis : s.radialaxis;
	              };
	              this.getAngular = function(s) {
	                return this.isSmith ? s.imaginaryaxis : s.angularaxis;
	              };
	              if (!isSmith) {
	                this.radialTickLayout = null;
	                this.angularTickLayout = null;
	              }
	            }
	            var proto = Polar.prototype;
	            module2.exports = function createPolar(gd, id, isSmith) {
	              return new Polar(gd, id, isSmith);
	            };
	            proto.plot = function(polarCalcData, fullLayout) {
	              var _this = this;
	              var polarLayout = fullLayout[_this.id];
	              var found = false;
	              for (var i = 0; i < polarCalcData.length; i++) {
	                var trace = polarCalcData[i][0].trace;
	                if (trace.cliponaxis === false) {
	                  found = true;
	                  break;
	                }
	              }
	              _this._hasClipOnAxisFalse = found;
	              _this.updateLayers(fullLayout, polarLayout);
	              _this.updateLayout(fullLayout, polarLayout);
	              Plots.generalUpdatePerTraceModule(_this.gd, _this, polarCalcData, polarLayout);
	              _this.updateFx(fullLayout, polarLayout);
	              if (_this.isSmith) {
	                delete polarLayout.realaxis.range;
	                delete polarLayout.imaginaryaxis.range;
	              }
	            };
	            proto.updateLayers = function(fullLayout, polarLayout) {
	              var _this = this;
	              var isSmith = _this.isSmith;
	              var layers = _this.layers;
	              var radialLayout = _this.getRadial(polarLayout);
	              var angularLayout = _this.getAngular(polarLayout);
	              var layerNames = constants.layerNames;
	              var frontPlotIndex = layerNames.indexOf("frontplot");
	              var layerData = layerNames.slice(0, frontPlotIndex);
	              var isAngularAxisBelowTraces = angularLayout.layer === "below traces";
	              var isRadialAxisBelowTraces = radialLayout.layer === "below traces";
	              if (isAngularAxisBelowTraces) layerData.push("angular-line");
	              if (isRadialAxisBelowTraces) layerData.push("radial-line");
	              if (isAngularAxisBelowTraces) layerData.push("angular-axis");
	              if (isRadialAxisBelowTraces) layerData.push("radial-axis");
	              layerData.push("frontplot");
	              if (!isAngularAxisBelowTraces) layerData.push("angular-line");
	              if (!isRadialAxisBelowTraces) layerData.push("radial-line");
	              if (!isAngularAxisBelowTraces) layerData.push("angular-axis");
	              if (!isRadialAxisBelowTraces) layerData.push("radial-axis");
	              var subLayer = (isSmith ? "smith" : "polar") + "sublayer";
	              var join = _this.framework.selectAll("." + subLayer).data(layerData, String);
	              join.enter().append("g").attr("class", function(d) {
	                return subLayer + " " + d;
	              }).each(function(d) {
	                var sel = layers[d] = d3.select(this);
	                switch (d) {
	                  case "frontplot":
	                    if (!isSmith) {
	                      sel.append("g").classed("barlayer", true);
	                    }
	                    sel.append("g").classed("scatterlayer", true);
	                    break;
	                  case "backplot":
	                    sel.append("g").classed("maplayer", true);
	                    break;
	                  case "plotbg":
	                    layers.bg = sel.append("path");
	                    break;
	                  case "radial-grid":
	                    sel.style("fill", "none");
	                    break;
	                  case "angular-grid":
	                    sel.style("fill", "none");
	                    break;
	                  case "radial-line":
	                    sel.append("line").style("fill", "none");
	                    break;
	                  case "angular-line":
	                    sel.append("path").style("fill", "none");
	                    break;
	                }
	              });
	              join.order();
	            };
	            proto.updateLayout = function(fullLayout, polarLayout) {
	              var _this = this;
	              var layers = _this.layers;
	              var gs = fullLayout._size;
	              var radialLayout = _this.getRadial(polarLayout);
	              var angularLayout = _this.getAngular(polarLayout);
	              var xDomain = polarLayout.domain.x;
	              var yDomain = polarLayout.domain.y;
	              _this.xOffset = gs.l + gs.w * xDomain[0];
	              _this.yOffset = gs.t + gs.h * (1 - yDomain[1]);
	              var xLength = _this.xLength = gs.w * (xDomain[1] - xDomain[0]);
	              var yLength = _this.yLength = gs.h * (yDomain[1] - yDomain[0]);
	              var sector = _this.getSector(polarLayout);
	              _this.sectorInRad = sector.map(deg2rad);
	              var sectorBBox = _this.sectorBBox = computeSectorBBox(sector);
	              var dxSectorBBox = sectorBBox[2] - sectorBBox[0];
	              var dySectorBBox = sectorBBox[3] - sectorBBox[1];
	              var arDomain = yLength / xLength;
	              var arSector = Math.abs(dySectorBBox / dxSectorBBox);
	              var xLength2, yLength2;
	              var xDomain2, yDomain2;
	              var gap;
	              if (arDomain > arSector) {
	                xLength2 = xLength;
	                yLength2 = xLength * arSector;
	                gap = (yLength - yLength2) / gs.h / 2;
	                xDomain2 = [xDomain[0], xDomain[1]];
	                yDomain2 = [yDomain[0] + gap, yDomain[1] - gap];
	              } else {
	                xLength2 = yLength / arSector;
	                yLength2 = yLength;
	                gap = (xLength - xLength2) / gs.w / 2;
	                xDomain2 = [xDomain[0] + gap, xDomain[1] - gap];
	                yDomain2 = [yDomain[0], yDomain[1]];
	              }
	              _this.xLength2 = xLength2;
	              _this.yLength2 = yLength2;
	              _this.xDomain2 = xDomain2;
	              _this.yDomain2 = yDomain2;
	              var xOffset2 = _this.xOffset2 = gs.l + gs.w * xDomain2[0];
	              var yOffset2 = _this.yOffset2 = gs.t + gs.h * (1 - yDomain2[1]);
	              var radius = _this.radius = xLength2 / dxSectorBBox;
	              var innerRadius = _this.innerRadius = _this.getHole(polarLayout) * radius;
	              var cx = _this.cx = xOffset2 - radius * sectorBBox[0];
	              var cy = _this.cy = yOffset2 + radius * sectorBBox[3];
	              var cxx = _this.cxx = cx - xOffset2;
	              var cyy = _this.cyy = cy - yOffset2;
	              var side = radialLayout.side;
	              var trueSide;
	              if (side === "counterclockwise") {
	                trueSide = side;
	                side = "top";
	              } else if (side === "clockwise") {
	                trueSide = side;
	                side = "bottom";
	              }
	              _this.radialAxis = _this.mockAxis(fullLayout, polarLayout, radialLayout, {
	                // make this an 'x' axis to make positioning (especially rotation) easier
	                _id: "x",
	                // convert to 'x' axis equivalent
	                side,
	                // keep track of real side
	                _trueSide: trueSide,
	                // spans length 1 radius
	                domain: [innerRadius / gs.w, radius / gs.w]
	              });
	              _this.angularAxis = _this.mockAxis(fullLayout, polarLayout, angularLayout, {
	                side: "right",
	                // to get auto nticks right
	                domain: [0, Math.PI],
	                // don't pass through autorange logic
	                autorange: false
	              });
	              _this.doAutoRange(fullLayout, polarLayout);
	              _this.updateAngularAxis(fullLayout, polarLayout);
	              _this.updateRadialAxis(fullLayout, polarLayout);
	              _this.updateRadialAxisTitle(fullLayout, polarLayout);
	              _this.xaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
	                _id: "x",
	                domain: xDomain2
	              });
	              _this.yaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
	                _id: "y",
	                domain: yDomain2
	              });
	              var dPath = _this.pathSubplot();
	              _this.clipPaths.forTraces.select("path").attr("d", dPath).attr("transform", strTranslate(cxx, cyy));
	              layers.frontplot.attr("transform", strTranslate(xOffset2, yOffset2)).call(Drawing.setClipUrl, _this._hasClipOnAxisFalse ? null : _this.clipIds.forTraces, _this.gd);
	              layers.bg.attr("d", dPath).attr("transform", strTranslate(cx, cy)).call(Color.fill, polarLayout.bgcolor);
	            };
	            proto.mockAxis = function(fullLayout, polarLayout, axLayout, opts) {
	              var ax = Lib.extendFlat({}, axLayout, opts);
	              setConvertPolar(ax, polarLayout, fullLayout);
	              return ax;
	            };
	            proto.mockCartesianAxis = function(fullLayout, polarLayout, opts) {
	              var _this = this;
	              var isSmith = _this.isSmith;
	              var axId = opts._id;
	              var ax = Lib.extendFlat({
	                type: "linear"
	              }, opts);
	              setConvertCartesian(ax, fullLayout);
	              var bboxIndices = {
	                x: [0, 2],
	                y: [1, 3]
	              };
	              ax.setRange = function() {
	                var sectorBBox = _this.sectorBBox;
	                var ind = bboxIndices[axId];
	                var rl = _this.radialAxis._rl;
	                var drl = (rl[1] - rl[0]) / (1 - _this.getHole(polarLayout));
	                ax.range = [sectorBBox[ind[0]] * drl, sectorBBox[ind[1]] * drl];
	              };
	              ax.isPtWithinRange = axId === "x" && !isSmith ? function(d) {
	                return _this.isPtInside(d);
	              } : function() {
	                return true;
	              };
	              ax.setRange();
	              ax.setScale();
	              return ax;
	            };
	            proto.doAutoRange = function(fullLayout, polarLayout) {
	              var _this = this;
	              var gd = _this.gd;
	              var radialAxis = _this.radialAxis;
	              var radialLayout = _this.getRadial(polarLayout);
	              doAutoRange(gd, radialAxis);
	              var rng = radialAxis.range;
	              radialLayout.range = rng.slice();
	              radialLayout._input.range = rng.slice();
	              radialAxis._rl = [radialAxis.r2l(rng[0], null, "gregorian"), radialAxis.r2l(rng[1], null, "gregorian")];
	            };
	            proto.updateRadialAxis = function(fullLayout, polarLayout) {
	              var _this = this;
	              var gd = _this.gd;
	              var layers = _this.layers;
	              var radius = _this.radius;
	              var innerRadius = _this.innerRadius;
	              var cx = _this.cx;
	              var cy = _this.cy;
	              var radialLayout = _this.getRadial(polarLayout);
	              var a0 = mod(_this.getSector(polarLayout)[0], 360);
	              var ax = _this.radialAxis;
	              var hasRoomForIt = innerRadius < radius;
	              var isSmith = _this.isSmith;
	              if (!isSmith) {
	                _this.fillViewInitialKey("radialaxis.angle", radialLayout.angle);
	                _this.fillViewInitialKey("radialaxis.range", ax.range.slice());
	                ax.setGeometry();
	              }
	              if (ax.tickangle === "auto" && a0 > 90 && a0 <= 270) {
	                ax.tickangle = 180;
	              }
	              var transFn = isSmith ? function(d) {
	                var t = smithTransform(_this, smith([d.x, 0]));
	                return strTranslate(t[0] - cx, t[1] - cy);
	              } : function(d) {
	                return strTranslate(ax.l2p(d.x) + innerRadius, 0);
	              };
	              var gridPathFn = isSmith ? function(d) {
	                return resistanceArc(_this, d.x, -Infinity, Infinity);
	              } : function(d) {
	                return _this.pathArc(ax.r2p(d.x) + innerRadius);
	              };
	              var newTickLayout = strTickLayout(radialLayout);
	              if (_this.radialTickLayout !== newTickLayout) {
	                layers["radial-axis"].selectAll(".xtick").remove();
	                _this.radialTickLayout = newTickLayout;
	              }
	              if (hasRoomForIt) {
	                ax.setScale();
	                var labelShift = 0;
	                var vals = isSmith ? (ax.tickvals || []).filter(function(x) {
	                  return x >= 0;
	                }).map(function(x) {
	                  return Axes.tickText(ax, x, true, false);
	                }) : Axes.calcTicks(ax);
	                var valsClipped = isSmith ? vals : Axes.clipEnds(ax, vals);
	                var tickSign = Axes.getTickSigns(ax)[2];
	                if (isSmith) {
	                  if (ax.ticks === "top" && ax.side === "bottom" || ax.ticks === "bottom" && ax.side === "top") {
	                    tickSign = -tickSign;
	                  }
	                  if (ax.ticks === "top" && ax.side === "top") labelShift = -ax.ticklen;
	                  if (ax.ticks === "bottom" && ax.side === "bottom") labelShift = ax.ticklen;
	                }
	                Axes.drawTicks(gd, ax, {
	                  vals,
	                  layer: layers["radial-axis"],
	                  path: Axes.makeTickPath(ax, 0, tickSign),
	                  transFn,
	                  crisp: false
	                });
	                Axes.drawGrid(gd, ax, {
	                  vals: valsClipped,
	                  layer: layers["radial-grid"],
	                  path: gridPathFn,
	                  transFn: Lib.noop,
	                  crisp: false
	                });
	                Axes.drawLabels(gd, ax, {
	                  vals,
	                  layer: layers["radial-axis"],
	                  transFn,
	                  labelFns: Axes.makeLabelFns(ax, labelShift)
	                });
	              }
	              var angle = _this.radialAxisAngle = _this.vangles ? rad2deg(snapToVertexAngle(deg2rad(radialLayout.angle), _this.vangles)) : radialLayout.angle;
	              var tLayer = strTranslate(cx, cy);
	              var tLayer2 = tLayer + strRotate(-angle);
	              updateElement(layers["radial-axis"], hasRoomForIt && (radialLayout.showticklabels || radialLayout.ticks), {
	                transform: tLayer2
	              });
	              updateElement(layers["radial-grid"], hasRoomForIt && radialLayout.showgrid, {
	                transform: isSmith ? "" : tLayer
	              });
	              updateElement(layers["radial-line"].select("line"), hasRoomForIt && radialLayout.showline, {
	                x1: isSmith ? -radius : innerRadius,
	                y1: 0,
	                x2: radius,
	                y2: 0,
	                transform: tLayer2
	              }).attr("stroke-width", radialLayout.linewidth).call(Color.stroke, radialLayout.linecolor);
	            };
	            proto.updateRadialAxisTitle = function(fullLayout, polarLayout, _angle) {
	              if (this.isSmith) return;
	              var _this = this;
	              var gd = _this.gd;
	              var radius = _this.radius;
	              var cx = _this.cx;
	              var cy = _this.cy;
	              var radialLayout = _this.getRadial(polarLayout);
	              var titleClass = _this.id + "title";
	              var pad = 0;
	              if (radialLayout.title) {
	                var h = Drawing.bBox(_this.layers["radial-axis"].node()).height;
	                var ts = radialLayout.title.font.size;
	                var side = radialLayout.side;
	                pad = side === "top" ? ts : side === "counterclockwise" ? -(h + ts * 0.4) : h + ts * 0.8;
	              }
	              var angle = _angle !== undefined ? _angle : _this.radialAxisAngle;
	              var angleRad = deg2rad(angle);
	              var cosa = Math.cos(angleRad);
	              var sina = Math.sin(angleRad);
	              var x = cx + radius / 2 * cosa + pad * sina;
	              var y = cy - radius / 2 * sina + pad * cosa;
	              _this.layers["radial-axis-title"] = Titles.draw(gd, titleClass, {
	                propContainer: radialLayout,
	                propName: _this.id + ".radialaxis.title",
	                placeholder: _(gd, "Click to enter radial axis title"),
	                attributes: {
	                  x,
	                  y,
	                  "text-anchor": "middle"
	                },
	                transform: {
	                  rotate: -angle
	                }
	              });
	            };
	            proto.updateAngularAxis = function(fullLayout, polarLayout) {
	              var _this = this;
	              var gd = _this.gd;
	              var layers = _this.layers;
	              var radius = _this.radius;
	              var innerRadius = _this.innerRadius;
	              var cx = _this.cx;
	              var cy = _this.cy;
	              var angularLayout = _this.getAngular(polarLayout);
	              var ax = _this.angularAxis;
	              var isSmith = _this.isSmith;
	              if (!isSmith) {
	                _this.fillViewInitialKey("angularaxis.rotation", angularLayout.rotation);
	                ax.setGeometry();
	                ax.setScale();
	              }
	              var t2g = isSmith ? function(d) {
	                var t = smithTransform(_this, smith([0, d.x]));
	                return Math.atan2(t[0] - cx, t[1] - cy) - Math.PI / 2;
	              } : function(d) {
	                return ax.t2g(d.x);
	              };
	              if (ax.type === "linear" && ax.thetaunit === "radians") {
	                ax.tick0 = rad2deg(ax.tick0);
	                ax.dtick = rad2deg(ax.dtick);
	              }
	              var _transFn = function(rad) {
	                return strTranslate(cx + radius * Math.cos(rad), cy - radius * Math.sin(rad));
	              };
	              var transFn = isSmith ? function(d) {
	                var t = smithTransform(_this, smith([0, d.x]));
	                return strTranslate(t[0], t[1]);
	              } : function(d) {
	                return _transFn(t2g(d));
	              };
	              var transFn2 = isSmith ? function(d) {
	                var t = smithTransform(_this, smith([0, d.x]));
	                var rad = Math.atan2(t[0] - cx, t[1] - cy) - Math.PI / 2;
	                return strTranslate(t[0], t[1]) + strRotate(-rad2deg(rad));
	              } : function(d) {
	                var rad = t2g(d);
	                return _transFn(rad) + strRotate(-rad2deg(rad));
	              };
	              var gridPathFn = isSmith ? function(d) {
	                return reactanceArc(_this, d.x, 0, Infinity);
	              } : function(d) {
	                var rad = t2g(d);
	                var cosRad = Math.cos(rad);
	                var sinRad = Math.sin(rad);
	                return "M" + [cx + innerRadius * cosRad, cy - innerRadius * sinRad] + "L" + [cx + radius * cosRad, cy - radius * sinRad];
	              };
	              var out = Axes.makeLabelFns(ax, 0);
	              var labelStandoff = out.labelStandoff;
	              var labelFns = {};
	              labelFns.xFn = function(d) {
	                var rad = t2g(d);
	                return Math.cos(rad) * labelStandoff;
	              };
	              labelFns.yFn = function(d) {
	                var rad = t2g(d);
	                var ff = Math.sin(rad) > 0 ? 0.2 : 1;
	                return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) + Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
	              };
	              labelFns.anchorFn = function(d) {
	                var rad = t2g(d);
	                var cos = Math.cos(rad);
	                return Math.abs(cos) < 0.1 ? "middle" : cos > 0 ? "start" : "end";
	              };
	              labelFns.heightFn = function(d, a, h) {
	                var rad = t2g(d);
	                return -0.5 * (1 + Math.sin(rad)) * h;
	              };
	              var newTickLayout = strTickLayout(angularLayout);
	              if (_this.angularTickLayout !== newTickLayout) {
	                layers["angular-axis"].selectAll("." + ax._id + "tick").remove();
	                _this.angularTickLayout = newTickLayout;
	              }
	              var vals = isSmith ? [Infinity].concat(ax.tickvals || []).map(function(x) {
	                return Axes.tickText(ax, x, true, false);
	              }) : Axes.calcTicks(ax);
	              if (isSmith) {
	                vals[0].text = "∞";
	                vals[0].fontSize *= 1.75;
	              }
	              var vangles;
	              if (polarLayout.gridshape === "linear") {
	                vangles = vals.map(t2g);
	                if (Lib.angleDelta(vangles[0], vangles[1]) < 0) {
	                  vangles = vangles.slice().reverse();
	                }
	              } else {
	                vangles = null;
	              }
	              _this.vangles = vangles;
	              if (ax.type === "category") {
	                vals = vals.filter(function(d) {
	                  return Lib.isAngleInsideSector(t2g(d), _this.sectorInRad);
	                });
	              }
	              if (ax.visible) {
	                var tickSign = ax.ticks === "inside" ? -1 : 1;
	                var pad = (ax.linewidth || 1) / 2;
	                Axes.drawTicks(gd, ax, {
	                  vals,
	                  layer: layers["angular-axis"],
	                  path: "M" + tickSign * pad + ",0h" + tickSign * ax.ticklen,
	                  transFn: transFn2,
	                  crisp: false
	                });
	                Axes.drawGrid(gd, ax, {
	                  vals,
	                  layer: layers["angular-grid"],
	                  path: gridPathFn,
	                  transFn: Lib.noop,
	                  crisp: false
	                });
	                Axes.drawLabels(gd, ax, {
	                  vals,
	                  layer: layers["angular-axis"],
	                  repositionOnUpdate: true,
	                  transFn,
	                  labelFns
	                });
	              }
	              updateElement(layers["angular-line"].select("path"), angularLayout.showline, {
	                d: _this.pathSubplot(),
	                transform: strTranslate(cx, cy)
	              }).attr("stroke-width", angularLayout.linewidth).call(Color.stroke, angularLayout.linecolor);
	            };
	            proto.updateFx = function(fullLayout, polarLayout) {
	              if (!this.gd._context.staticPlot) {
	                var hasDrag = !this.isSmith;
	                if (hasDrag) {
	                  this.updateAngularDrag(fullLayout);
	                  this.updateRadialDrag(fullLayout, polarLayout, 0);
	                  this.updateRadialDrag(fullLayout, polarLayout, 1);
	                }
	                this.updateHoverAndMainDrag(fullLayout);
	              }
	            };
	            proto.updateHoverAndMainDrag = function(fullLayout) {
	              var _this = this;
	              var isSmith = _this.isSmith;
	              var gd = _this.gd;
	              var layers = _this.layers;
	              var zoomlayer = fullLayout._zoomlayer;
	              var MINZOOM = constants.MINZOOM;
	              var OFFEDGE = constants.OFFEDGE;
	              var radius = _this.radius;
	              var innerRadius = _this.innerRadius;
	              var cx = _this.cx;
	              var cy = _this.cy;
	              var cxx = _this.cxx;
	              var cyy = _this.cyy;
	              var sectorInRad = _this.sectorInRad;
	              var vangles = _this.vangles;
	              var radialAxis = _this.radialAxis;
	              var clampTiny = helpers.clampTiny;
	              var findXYatLength = helpers.findXYatLength;
	              var findEnclosingVertexAngles = helpers.findEnclosingVertexAngles;
	              var chw = constants.cornerHalfWidth;
	              var chl = constants.cornerLen / 2;
	              var scaleX;
	              var scaleY;
	              var mainDrag = dragBox.makeDragger(layers, "path", "maindrag", fullLayout.dragmode === false ? "none" : "crosshair");
	              d3.select(mainDrag).attr("d", _this.pathSubplot()).attr("transform", strTranslate(cx, cy));
	              mainDrag.onmousemove = function(evt) {
	                Fx.hover(gd, evt, _this.id);
	                gd._fullLayout._lasthover = mainDrag;
	                gd._fullLayout._hoversubplot = _this.id;
	              };
	              mainDrag.onmouseout = function(evt) {
	                if (gd._dragging) return;
	                dragElement.unhover(gd, evt);
	              };
	              var dragOpts = {
	                element: mainDrag,
	                gd,
	                subplot: _this.id,
	                plotinfo: {
	                  id: _this.id,
	                  xaxis: _this.xaxis,
	                  yaxis: _this.yaxis
	                },
	                xaxes: [_this.xaxis],
	                yaxes: [_this.yaxis]
	              };
	              var x0, y0;
	              var r0, r1;
	              var path0, dimmed, lum;
	              var zb, corners;
	              function norm(x, y) {
	                return Math.sqrt(x * x + y * y);
	              }
	              function xy2r(x, y) {
	                return norm(x - cxx, y - cyy);
	              }
	              function xy2a(x, y) {
	                return Math.atan2(cyy - y, x - cxx);
	              }
	              function ra2xy(r, a) {
	                return [r * Math.cos(a), r * Math.sin(-a)];
	              }
	              function pathCorner(r, a) {
	                if (r === 0) return _this.pathSector(2 * chw);
	                var da = chl / r;
	                var am = a - da;
	                var ap = a + da;
	                var rb = Math.max(0, Math.min(r, radius));
	                var rm = rb - chw;
	                var rp = rb + chw;
	                return "M" + ra2xy(rm, am) + "A" + [rm, rm] + " 0,0,0 " + ra2xy(rm, ap) + "L" + ra2xy(rp, ap) + "A" + [rp, rp] + " 0,0,1 " + ra2xy(rp, am) + "Z";
	              }
	              function pathCornerForPolygons(r, va0, va1) {
	                if (r === 0) return _this.pathSector(2 * chw);
	                var xy0 = ra2xy(r, va0);
	                var xy1 = ra2xy(r, va1);
	                var x = clampTiny((xy0[0] + xy1[0]) / 2);
	                var y = clampTiny((xy0[1] + xy1[1]) / 2);
	                var innerPts, outerPts;
	                if (x && y) {
	                  var m = y / x;
	                  var mperp = -1 / m;
	                  var midPts = findXYatLength(chw, m, x, y);
	                  innerPts = findXYatLength(chl, mperp, midPts[0][0], midPts[0][1]);
	                  outerPts = findXYatLength(chl, mperp, midPts[1][0], midPts[1][1]);
	                } else {
	                  var dx, dy;
	                  if (y) {
	                    dx = chl;
	                    dy = chw;
	                  } else {
	                    dx = chw;
	                    dy = chl;
	                  }
	                  innerPts = [[x - dx, y - dy], [x + dx, y - dy]];
	                  outerPts = [[x - dx, y + dy], [x + dx, y + dy]];
	                }
	                return "M" + innerPts.join("L") + "L" + outerPts.reverse().join("L") + "Z";
	              }
	              function zoomPrep() {
	                r0 = null;
	                r1 = null;
	                path0 = _this.pathSubplot();
	                dimmed = false;
	                var polarLayoutNow = gd._fullLayout[_this.id];
	                lum = tinycolor(polarLayoutNow.bgcolor).getLuminance();
	                zb = dragBox.makeZoombox(zoomlayer, lum, cx, cy, path0);
	                zb.attr("fill-rule", "evenodd");
	                corners = dragBox.makeCorners(zoomlayer, cx, cy);
	                clearOutline(gd);
	              }
	              function clampAndSetR0R1(rr0, rr1) {
	                rr1 = Math.max(Math.min(rr1, radius), innerRadius);
	                if (rr0 < OFFEDGE) rr0 = 0;
	                else if (radius - rr0 < OFFEDGE) rr0 = radius;
	                else if (rr1 < OFFEDGE) rr1 = 0;
	                else if (radius - rr1 < OFFEDGE) rr1 = radius;
	                if (Math.abs(rr1 - rr0) > MINZOOM) {
	                  if (rr0 < rr1) {
	                    r0 = rr0;
	                    r1 = rr1;
	                  } else {
	                    r0 = rr1;
	                    r1 = rr0;
	                  }
	                  return true;
	                } else {
	                  r0 = null;
	                  r1 = null;
	                  return false;
	                }
	              }
	              function applyZoomMove(path1, cpath) {
	                path1 = path1 || path0;
	                cpath = cpath || "M0,0Z";
	                zb.attr("d", path1);
	                corners.attr("d", cpath);
	                dragBox.transitionZoombox(zb, corners, dimmed, lum);
	                dimmed = true;
	                var updateObj = {};
	                computeZoomUpdates(updateObj);
	                gd.emit("plotly_relayouting", updateObj);
	              }
	              function zoomMove(dx, dy) {
	                dx = dx * scaleX;
	                dy = dy * scaleY;
	                var x1 = x0 + dx;
	                var y1 = y0 + dy;
	                var rr0 = xy2r(x0, y0);
	                var rr1 = Math.min(xy2r(x1, y1), radius);
	                var a0 = xy2a(x0, y0);
	                var path1;
	                var cpath;
	                if (clampAndSetR0R1(rr0, rr1)) {
	                  path1 = path0 + _this.pathSector(r1);
	                  if (r0) path1 += _this.pathSector(r0);
	                  cpath = pathCorner(r0, a0) + pathCorner(r1, a0);
	                }
	                applyZoomMove(path1, cpath);
	              }
	              function findPolygonRadius(x, y, va0, va1) {
	                var xy = helpers.findIntersectionXY(va0, va1, va0, [x - cxx, cyy - y]);
	                return norm(xy[0], xy[1]);
	              }
	              function zoomMoveForPolygons(dx, dy) {
	                var x1 = x0 + dx;
	                var y1 = y0 + dy;
	                var a0 = xy2a(x0, y0);
	                var a1 = xy2a(x1, y1);
	                var vangles0 = findEnclosingVertexAngles(a0, vangles);
	                var vangles1 = findEnclosingVertexAngles(a1, vangles);
	                var rr0 = findPolygonRadius(x0, y0, vangles0[0], vangles0[1]);
	                var rr1 = Math.min(findPolygonRadius(x1, y1, vangles1[0], vangles1[1]), radius);
	                var path1;
	                var cpath;
	                if (clampAndSetR0R1(rr0, rr1)) {
	                  path1 = path0 + _this.pathSector(r1);
	                  if (r0) path1 += _this.pathSector(r0);
	                  cpath = [pathCornerForPolygons(r0, vangles0[0], vangles0[1]), pathCornerForPolygons(r1, vangles0[0], vangles0[1])].join(" ");
	                }
	                applyZoomMove(path1, cpath);
	              }
	              function zoomDone() {
	                dragBox.removeZoombox(gd);
	                if (r0 === null || r1 === null) return;
	                var updateObj = {};
	                computeZoomUpdates(updateObj);
	                dragBox.showDoubleClickNotifier(gd);
	                Registry.call("_guiRelayout", gd, updateObj);
	              }
	              function computeZoomUpdates(update) {
	                var rl = radialAxis._rl;
	                var m = (rl[1] - rl[0]) / (1 - innerRadius / radius) / radius;
	                var newRng = [rl[0] + (r0 - innerRadius) * m, rl[0] + (r1 - innerRadius) * m];
	                update[_this.id + ".radialaxis.range"] = newRng;
	              }
	              function zoomClick(numClicks, evt) {
	                var clickMode = gd._fullLayout.clickmode;
	                dragBox.removeZoombox(gd);
	                if (numClicks === 2) {
	                  var updateObj = {};
	                  for (var k in _this.viewInitial) {
	                    updateObj[_this.id + "." + k] = _this.viewInitial[k];
	                  }
	                  gd.emit("plotly_doubleclick", null);
	                  Registry.call("_guiRelayout", gd, updateObj);
	                }
	                if (clickMode.indexOf("select") > -1 && numClicks === 1) {
	                  selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOpts);
	                }
	                if (clickMode.indexOf("event") > -1) {
	                  Fx.click(gd, evt, _this.id);
	                }
	              }
	              dragOpts.prepFn = function(evt, startX, startY) {
	                var dragModeNow = gd._fullLayout.dragmode;
	                var bbox = mainDrag.getBoundingClientRect();
	                gd._fullLayout._calcInverseTransform(gd);
	                var inverse = gd._fullLayout._invTransform;
	                scaleX = gd._fullLayout._invScaleX;
	                scaleY = gd._fullLayout._invScaleY;
	                var transformedCoords = Lib.apply3DTransform(inverse)(startX - bbox.left, startY - bbox.top);
	                x0 = transformedCoords[0];
	                y0 = transformedCoords[1];
	                if (vangles) {
	                  var offset = helpers.findPolygonOffset(radius, sectorInRad[0], sectorInRad[1], vangles);
	                  x0 += cxx + offset[0];
	                  y0 += cyy + offset[1];
	                }
	                switch (dragModeNow) {
	                  case "zoom":
	                    dragOpts.clickFn = zoomClick;
	                    if (!isSmith) {
	                      if (vangles) {
	                        dragOpts.moveFn = zoomMoveForPolygons;
	                      } else {
	                        dragOpts.moveFn = zoomMove;
	                      }
	                      dragOpts.doneFn = zoomDone;
	                      zoomPrep();
	                    }
	                    break;
	                  case "select":
	                  case "lasso":
	                    prepSelect(evt, startX, startY, dragOpts, dragModeNow);
	                    break;
	                }
	              };
	              dragElement.init(dragOpts);
	            };
	            proto.updateRadialDrag = function(fullLayout, polarLayout, rngIndex) {
	              var _this = this;
	              var gd = _this.gd;
	              var layers = _this.layers;
	              var radius = _this.radius;
	              var innerRadius = _this.innerRadius;
	              var cx = _this.cx;
	              var cy = _this.cy;
	              var radialAxis = _this.radialAxis;
	              var bl = constants.radialDragBoxSize;
	              var bl2 = bl / 2;
	              if (!radialAxis.visible) return;
	              var angle0 = deg2rad(_this.radialAxisAngle);
	              var rl = radialAxis._rl;
	              var rl0 = rl[0];
	              var rl1 = rl[1];
	              var rbase = rl[rngIndex];
	              var m = 0.75 * (rl[1] - rl[0]) / (1 - _this.getHole(polarLayout)) / radius;
	              var tx, ty, className;
	              if (rngIndex) {
	                tx = cx + (radius + bl2) * Math.cos(angle0);
	                ty = cy - (radius + bl2) * Math.sin(angle0);
	                className = "radialdrag";
	              } else {
	                tx = cx + (innerRadius - bl2) * Math.cos(angle0);
	                ty = cy - (innerRadius - bl2) * Math.sin(angle0);
	                className = "radialdrag-inner";
	              }
	              var radialDrag = dragBox.makeRectDragger(layers, className, "crosshair", -bl2, -bl2, bl, bl);
	              var dragOpts = {
	                element: radialDrag,
	                gd
	              };
	              if (fullLayout.dragmode === false) {
	                dragOpts.dragmode = false;
	              }
	              updateElement(d3.select(radialDrag), radialAxis.visible && innerRadius < radius, {
	                transform: strTranslate(tx, ty)
	              });
	              var moveFn2;
	              var angle1;
	              var rprime;
	              function moveFn(dx, dy) {
	                if (moveFn2) {
	                  moveFn2(dx, dy);
	                } else {
	                  var dvec = [dx, -dy];
	                  var rvec = [Math.cos(angle0), Math.sin(angle0)];
	                  var comp = Math.abs(Lib.dot(dvec, rvec) / Math.sqrt(Lib.dot(dvec, dvec)));
	                  if (!isNaN(comp)) {
	                    moveFn2 = comp < 0.5 ? rotateMove : rerangeMove;
	                  }
	                }
	                var update = {};
	                computeRadialAxisUpdates(update);
	                gd.emit("plotly_relayouting", update);
	              }
	              function computeRadialAxisUpdates(update) {
	                if (angle1 !== null) {
	                  update[_this.id + ".radialaxis.angle"] = angle1;
	                } else if (rprime !== null) {
	                  update[_this.id + ".radialaxis.range[" + rngIndex + "]"] = rprime;
	                }
	              }
	              function doneFn() {
	                if (angle1 !== null) {
	                  Registry.call("_guiRelayout", gd, _this.id + ".radialaxis.angle", angle1);
	                } else if (rprime !== null) {
	                  Registry.call("_guiRelayout", gd, _this.id + ".radialaxis.range[" + rngIndex + "]", rprime);
	                }
	              }
	              function rotateMove(dx, dy) {
	                if (rngIndex === 0) return;
	                var x1 = tx + dx;
	                var y1 = ty + dy;
	                angle1 = Math.atan2(cy - y1, x1 - cx);
	                if (_this.vangles) angle1 = snapToVertexAngle(angle1, _this.vangles);
	                angle1 = rad2deg(angle1);
	                var transform = strTranslate(cx, cy) + strRotate(-angle1);
	                layers["radial-axis"].attr("transform", transform);
	                layers["radial-line"].select("line").attr("transform", transform);
	                var fullLayoutNow = _this.gd._fullLayout;
	                var polarLayoutNow = fullLayoutNow[_this.id];
	                _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, angle1);
	              }
	              function rerangeMove(dx, dy) {
	                var dr = Lib.dot([dx, -dy], [Math.cos(angle0), Math.sin(angle0)]);
	                rprime = rbase - m * dr;
	                if (m > 0 !== (rngIndex ? rprime > rl0 : rprime < rl1)) {
	                  rprime = null;
	                  return;
	                }
	                var fullLayoutNow = gd._fullLayout;
	                var polarLayoutNow = fullLayoutNow[_this.id];
	                radialAxis.range[rngIndex] = rprime;
	                radialAxis._rl[rngIndex] = rprime;
	                _this.updateRadialAxis(fullLayoutNow, polarLayoutNow);
	                _this.xaxis.setRange();
	                _this.xaxis.setScale();
	                _this.yaxis.setRange();
	                _this.yaxis.setScale();
	                var hasRegl = false;
	                for (var traceType in _this.traceHash) {
	                  var moduleCalcData = _this.traceHash[traceType];
	                  var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
	                  var _module = moduleCalcData[0][0].trace._module;
	                  _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
	                  if (Registry.traceIs(traceType, "gl") && moduleCalcDataVisible.length) hasRegl = true;
	                }
	                if (hasRegl) {
	                  clearGlCanvases(gd);
	                  redrawReglTraces(gd);
	                }
	              }
	              dragOpts.prepFn = function() {
	                moveFn2 = null;
	                angle1 = null;
	                rprime = null;
	                dragOpts.moveFn = moveFn;
	                dragOpts.doneFn = doneFn;
	                clearOutline(gd);
	              };
	              dragOpts.clampFn = function(dx, dy) {
	                if (Math.sqrt(dx * dx + dy * dy) < constants.MINDRAG) {
	                  dx = 0;
	                  dy = 0;
	                }
	                return [dx, dy];
	              };
	              dragElement.init(dragOpts);
	            };
	            proto.updateAngularDrag = function(fullLayout) {
	              var _this = this;
	              var gd = _this.gd;
	              var layers = _this.layers;
	              var radius = _this.radius;
	              var angularAxis = _this.angularAxis;
	              var cx = _this.cx;
	              var cy = _this.cy;
	              var cxx = _this.cxx;
	              var cyy = _this.cyy;
	              var dbs = constants.angularDragBoxSize;
	              var angularDrag = dragBox.makeDragger(layers, "path", "angulardrag", fullLayout.dragmode === false ? "none" : "move");
	              var dragOpts = {
	                element: angularDrag,
	                gd
	              };
	              if (fullLayout.dragmode === false) {
	                dragOpts.dragmode = false;
	              } else {
	                d3.select(angularDrag).attr("d", _this.pathAnnulus(radius, radius + dbs)).attr("transform", strTranslate(cx, cy)).call(setCursor, "move");
	              }
	              function xy2a(x, y) {
	                return Math.atan2(cyy + dbs - y, x - cxx - dbs);
	              }
	              var scatterTraces = layers.frontplot.select(".scatterlayer").selectAll(".trace");
	              var scatterPoints = scatterTraces.selectAll(".point");
	              var scatterTextPoints = scatterTraces.selectAll(".textpoint");
	              var x0, y0;
	              var rot0, rot1;
	              var rrot1;
	              var a0;
	              function moveFn(dx, dy) {
	                var fullLayoutNow = _this.gd._fullLayout;
	                var polarLayoutNow = fullLayoutNow[_this.id];
	                var x1 = x0 + dx * fullLayout._invScaleX;
	                var y1 = y0 + dy * fullLayout._invScaleY;
	                var a1 = xy2a(x1, y1);
	                var da = rad2deg(a1 - a0);
	                rot1 = rot0 + da;
	                layers.frontplot.attr("transform", strTranslate(_this.xOffset2, _this.yOffset2) + strRotate([-da, cxx, cyy]));
	                if (_this.vangles) {
	                  rrot1 = _this.radialAxisAngle + da;
	                  var trans = strTranslate(cx, cy) + strRotate(-da);
	                  var trans2 = strTranslate(cx, cy) + strRotate(-rrot1);
	                  layers.bg.attr("transform", trans);
	                  layers["radial-grid"].attr("transform", trans);
	                  layers["radial-axis"].attr("transform", trans2);
	                  layers["radial-line"].select("line").attr("transform", trans2);
	                  _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, rrot1);
	                } else {
	                  _this.clipPaths.forTraces.select("path").attr("transform", strTranslate(cxx, cyy) + strRotate(da));
	                }
	                scatterPoints.each(function() {
	                  var sel = d3.select(this);
	                  var xy = Drawing.getTranslate(sel);
	                  sel.attr("transform", strTranslate(xy.x, xy.y) + strRotate([da]));
	                });
	                scatterTextPoints.each(function() {
	                  var sel = d3.select(this);
	                  var tx = sel.select("text");
	                  var xy = Drawing.getTranslate(sel);
	                  sel.attr("transform", strRotate([da, tx.attr("x"), tx.attr("y")]) + strTranslate(xy.x, xy.y));
	                });
	                angularAxis.rotation = Lib.modHalf(rot1, 360);
	                _this.updateAngularAxis(fullLayoutNow, polarLayoutNow);
	                if (_this._hasClipOnAxisFalse && !Lib.isFullCircle(_this.sectorInRad)) {
	                  scatterTraces.call(Drawing.hideOutsideRangePoints, _this);
	                }
	                var hasRegl = false;
	                for (var traceType in _this.traceHash) {
	                  if (Registry.traceIs(traceType, "gl")) {
	                    var moduleCalcData = _this.traceHash[traceType];
	                    var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
	                    var _module = moduleCalcData[0][0].trace._module;
	                    _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
	                    if (moduleCalcDataVisible.length) hasRegl = true;
	                  }
	                }
	                if (hasRegl) {
	                  clearGlCanvases(gd);
	                  redrawReglTraces(gd);
	                }
	                var update = {};
	                computeRotationUpdates(update);
	                gd.emit("plotly_relayouting", update);
	              }
	              function computeRotationUpdates(updateObj) {
	                updateObj[_this.id + ".angularaxis.rotation"] = rot1;
	                if (_this.vangles) {
	                  updateObj[_this.id + ".radialaxis.angle"] = rrot1;
	                }
	              }
	              function doneFn() {
	                scatterTextPoints.select("text").attr("transform", null);
	                var updateObj = {};
	                computeRotationUpdates(updateObj);
	                Registry.call("_guiRelayout", gd, updateObj);
	              }
	              dragOpts.prepFn = function(evt, startX, startY) {
	                var polarLayoutNow = fullLayout[_this.id];
	                rot0 = polarLayoutNow.angularaxis.rotation;
	                var bbox = angularDrag.getBoundingClientRect();
	                x0 = startX - bbox.left;
	                y0 = startY - bbox.top;
	                gd._fullLayout._calcInverseTransform(gd);
	                var transformedCoords = Lib.apply3DTransform(fullLayout._invTransform)(x0, y0);
	                x0 = transformedCoords[0];
	                y0 = transformedCoords[1];
	                a0 = xy2a(x0, y0);
	                dragOpts.moveFn = moveFn;
	                dragOpts.doneFn = doneFn;
	                clearOutline(gd);
	              };
	              if (_this.vangles && !Lib.isFullCircle(_this.sectorInRad)) {
	                dragOpts.prepFn = Lib.noop;
	                setCursor(d3.select(angularDrag), null);
	              }
	              dragElement.init(dragOpts);
	            };
	            proto.isPtInside = function(d) {
	              if (this.isSmith) return true;
	              var sectorInRad = this.sectorInRad;
	              var vangles = this.vangles;
	              var thetag = this.angularAxis.c2g(d.theta);
	              var radialAxis = this.radialAxis;
	              var r = radialAxis.c2l(d.r);
	              var rl = radialAxis._rl;
	              var fn = vangles ? helpers.isPtInsidePolygon : Lib.isPtInsideSector;
	              return fn(r, thetag, rl, sectorInRad, vangles);
	            };
	            proto.pathArc = function(r) {
	              var sectorInRad = this.sectorInRad;
	              var vangles = this.vangles;
	              var fn = vangles ? helpers.pathPolygon : Lib.pathArc;
	              return fn(r, sectorInRad[0], sectorInRad[1], vangles);
	            };
	            proto.pathSector = function(r) {
	              var sectorInRad = this.sectorInRad;
	              var vangles = this.vangles;
	              var fn = vangles ? helpers.pathPolygon : Lib.pathSector;
	              return fn(r, sectorInRad[0], sectorInRad[1], vangles);
	            };
	            proto.pathAnnulus = function(r0, r1) {
	              var sectorInRad = this.sectorInRad;
	              var vangles = this.vangles;
	              var fn = vangles ? helpers.pathPolygonAnnulus : Lib.pathAnnulus;
	              return fn(r0, r1, sectorInRad[0], sectorInRad[1], vangles);
	            };
	            proto.pathSubplot = function() {
	              var r0 = this.innerRadius;
	              var r1 = this.radius;
	              return r0 ? this.pathAnnulus(r0, r1) : this.pathSector(r1);
	            };
	            proto.fillViewInitialKey = function(key, val) {
	              if (!(key in this.viewInitial)) {
	                this.viewInitial[key] = val;
	              }
	            };
	            function strTickLayout(axLayout) {
	              var out = axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
	              if ("side" in axLayout) out += axLayout.side;
	              return out;
	            }
	            function computeSectorBBox(sector) {
	              var s0 = sector[0];
	              var s1 = sector[1];
	              var arc = s1 - s0;
	              var a0 = mod(s0, 360);
	              var a1 = a0 + arc;
	              var ax0 = Math.cos(deg2rad(a0));
	              var ay0 = Math.sin(deg2rad(a0));
	              var ax1 = Math.cos(deg2rad(a1));
	              var ay1 = Math.sin(deg2rad(a1));
	              var x0, y0, x1, y1;
	              if (a0 <= 90 && a1 >= 90 || a0 > 90 && a1 >= 450) {
	                y1 = 1;
	              } else if (ay0 <= 0 && ay1 <= 0) {
	                y1 = 0;
	              } else {
	                y1 = Math.max(ay0, ay1);
	              }
	              if (a0 <= 180 && a1 >= 180 || a0 > 180 && a1 >= 540) {
	                x0 = -1;
	              } else if (ax0 >= 0 && ax1 >= 0) {
	                x0 = 0;
	              } else {
	                x0 = Math.min(ax0, ax1);
	              }
	              if (a0 <= 270 && a1 >= 270 || a0 > 270 && a1 >= 630) {
	                y0 = -1;
	              } else if (ay0 >= 0 && ay1 >= 0) {
	                y0 = 0;
	              } else {
	                y0 = Math.min(ay0, ay1);
	              }
	              if (a1 >= 360) {
	                x1 = 1;
	              } else if (ax0 <= 0 && ax1 <= 0) {
	                x1 = 0;
	              } else {
	                x1 = Math.max(ax0, ax1);
	              }
	              return [x0, y0, x1, y1];
	            }
	            function snapToVertexAngle(a, vangles) {
	              var fn = function(v) {
	                return Lib.angleDist(a, v);
	              };
	              var ind = Lib.findIndexOfMin(vangles, fn);
	              return vangles[ind];
	            }
	            function updateElement(sel, showAttr, attrs) {
	              if (showAttr) {
	                sel.attr("display", null);
	                sel.attr(attrs);
	              } else if (sel) {
	                sel.attr("display", "none");
	              }
	              return sel;
	            }
	          }
	        ),
	        /***/
	        12101: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var setConvertCartesian = __webpack_require__2(21994);
	            var deg2rad = Lib.deg2rad;
	            var rad2deg = Lib.rad2deg;
	            module2.exports = function setConvert(ax, polarLayout, fullLayout) {
	              setConvertCartesian(ax, fullLayout);
	              switch (ax._id) {
	                case "x":
	                case "radialaxis":
	                  setConvertRadial(ax, polarLayout);
	                  break;
	                case "angularaxis":
	                  setConvertAngular(ax, polarLayout);
	                  break;
	              }
	            };
	            function setConvertRadial(ax, polarLayout) {
	              var subplot = polarLayout._subplot;
	              ax.setGeometry = function() {
	                var rl0 = ax._rl[0];
	                var rl1 = ax._rl[1];
	                var b = subplot.innerRadius;
	                var m = (subplot.radius - b) / (rl1 - rl0);
	                var b2 = b / m;
	                var rFilter = rl0 > rl1 ? function(v) {
	                  return v <= 0;
	                } : function(v) {
	                  return v >= 0;
	                };
	                ax.c2g = function(v) {
	                  var r = ax.c2l(v) - rl0;
	                  return (rFilter(r) ? r : 0) + b2;
	                };
	                ax.g2c = function(v) {
	                  return ax.l2c(v + rl0 - b2);
	                };
	                ax.g2p = function(v) {
	                  return v * m;
	                };
	                ax.c2p = function(v) {
	                  return ax.g2p(ax.c2g(v));
	                };
	              };
	            }
	            function toRadians(v, unit) {
	              return unit === "degrees" ? deg2rad(v) : v;
	            }
	            function fromRadians(v, unit) {
	              return unit === "degrees" ? rad2deg(v) : v;
	            }
	            function setConvertAngular(ax, polarLayout) {
	              var axType = ax.type;
	              if (axType === "linear") {
	                var _d2c = ax.d2c;
	                var _c2d = ax.c2d;
	                ax.d2c = function(v, unit) {
	                  return toRadians(_d2c(v), unit);
	                };
	                ax.c2d = function(v, unit) {
	                  return _c2d(fromRadians(v, unit));
	                };
	              }
	              ax.makeCalcdata = function(trace, coord) {
	                var arrayIn = trace[coord];
	                var len = trace._length;
	                var arrayOut, i;
	                var _d2c2 = function(v) {
	                  return ax.d2c(v, trace.thetaunit);
	                };
	                if (arrayIn) {
	                  if (Lib.isTypedArray(arrayIn) && axType === "linear") {
	                    if (len === arrayIn.length) {
	                      return arrayIn;
	                    } else if (arrayIn.subarray) {
	                      return arrayIn.subarray(0, len);
	                    }
	                  }
	                  arrayOut = new Array(len);
	                  for (i = 0; i < len; i++) {
	                    arrayOut[i] = _d2c2(arrayIn[i]);
	                  }
	                } else {
	                  var coord0 = coord + "0";
	                  var dcoord = "d" + coord;
	                  var v0 = coord0 in trace ? _d2c2(trace[coord0]) : 0;
	                  var dv = trace[dcoord] ? _d2c2(trace[dcoord]) : (ax.period || 2 * Math.PI) / len;
	                  arrayOut = new Array(len);
	                  for (i = 0; i < len; i++) {
	                    arrayOut[i] = v0 + i * dv;
	                  }
	                }
	                return arrayOut;
	              };
	              ax.setGeometry = function() {
	                var sector = polarLayout.sector;
	                var sectorInRad = sector.map(deg2rad);
	                var dir = {
	                  clockwise: -1,
	                  counterclockwise: 1
	                }[ax.direction];
	                var rot = deg2rad(ax.rotation);
	                var rad2g = function(v) {
	                  return dir * v + rot;
	                };
	                var g2rad = function(v) {
	                  return (v - rot) / dir;
	                };
	                var rad2c, c2rad;
	                var rad2t, t2rad;
	                switch (axType) {
	                  case "linear":
	                    c2rad = rad2c = Lib.identity;
	                    t2rad = deg2rad;
	                    rad2t = rad2deg;
	                    ax.range = Lib.isFullCircle(sectorInRad) ? [sector[0], sector[0] + 360] : sectorInRad.map(g2rad).map(rad2deg);
	                    break;
	                  case "category":
	                    var catLen = ax._categories.length;
	                    var _period = ax.period ? Math.max(ax.period, catLen) : catLen;
	                    if (_period === 0) _period = 1;
	                    c2rad = t2rad = function(v) {
	                      return v * 2 * Math.PI / _period;
	                    };
	                    rad2c = rad2t = function(v) {
	                      return v * _period / Math.PI / 2;
	                    };
	                    ax.range = [0, _period];
	                    break;
	                }
	                ax.c2g = function(v) {
	                  return rad2g(c2rad(v));
	                };
	                ax.g2c = function(v) {
	                  return rad2c(g2rad(v));
	                };
	                ax.t2g = function(v) {
	                  return rad2g(t2rad(v));
	                };
	                ax.g2t = function(v) {
	                  return rad2t(g2rad(v));
	                };
	              };
	            }
	          }
	        ),
	        /***/
	        39779: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              attr: "subplot",
	              name: "smith",
	              axisNames: [
	                "realaxis",
	                "imaginaryaxis"
	                // imaginary axis should be second here so that the `tickvals` defaults could be inherited from realaxis
	              ],
	              axisName2dataArray: {
	                imaginaryaxis: "imag",
	                realaxis: "real"
	              }
	            };
	          }
	        ),
	        /***/
	        23893: (
	          /***/
	          function(module2) {
	            function sign(x) {
	              return x < 0 ? -1 : x > 0 ? 1 : 0;
	            }
	            function smith(a) {
	              var R = a[0];
	              var X = a[1];
	              if (!isFinite(R) || !isFinite(X)) return [1, 0];
	              var D = (R + 1) * (R + 1) + X * X;
	              return [(R * R + X * X - 1) / D, 2 * X / D];
	            }
	            function transform(subplot, a) {
	              var x = a[0];
	              var y = a[1];
	              return [x * subplot.radius + subplot.cx, -y * subplot.radius + subplot.cy];
	            }
	            function scale(subplot, r) {
	              return r * subplot.radius;
	            }
	            function reactanceArc(subplot, X, R1, R2) {
	              var t1 = transform(subplot, smith([R1, X]));
	              var x1 = t1[0];
	              var y1 = t1[1];
	              var t2 = transform(subplot, smith([R2, X]));
	              var x2 = t2[0];
	              var y2 = t2[1];
	              if (X === 0) {
	                return ["M" + x1 + "," + y1, "L" + x2 + "," + y2].join(" ");
	              }
	              var r = scale(subplot, 1 / Math.abs(X));
	              return ["M" + x1 + "," + y1, "A" + r + "," + r + " 0 0," + (X < 0 ? 1 : 0) + " " + x2 + "," + y2].join(" ");
	            }
	            function resistanceArc(subplot, R, X1, X2) {
	              var r = scale(subplot, 1 / (R + 1));
	              var t1 = transform(subplot, smith([R, X1]));
	              var x1 = t1[0];
	              var y1 = t1[1];
	              var t2 = transform(subplot, smith([R, X2]));
	              var x2 = t2[0];
	              var y2 = t2[1];
	              if (sign(X1) !== sign(X2)) {
	                var t0 = transform(subplot, smith([R, 0]));
	                var x0 = t0[0];
	                var y0 = t0[1];
	                return ["M" + x1 + "," + y1, "A" + r + "," + r + " 0 0," + (0 < X1 ? 0 : 1) + " " + x0 + "," + y0, "A" + r + "," + r + " 0 0," + (X2 < 0 ? 0 : 1) + x2 + "," + y2].join(" ");
	              }
	              return ["M" + x1 + "," + y1, "A" + r + "," + r + " 0 0," + (X2 < X1 ? 0 : 1) + " " + x2 + "," + y2].join(" ");
	            }
	            module2.exports = {
	              smith,
	              reactanceArc,
	              resistanceArc,
	              smithTransform: transform
	            };
	          }
	        ),
	        /***/
	        7504: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getSubplotCalcData = __webpack_require__2(27659).AU;
	            var counterRegex = __webpack_require__2(71828).counterRegex;
	            var createPolar = __webpack_require__2(77997);
	            var constants = __webpack_require__2(39779);
	            var attr = constants.attr;
	            var name2 = constants.name;
	            var counter = counterRegex(name2);
	            var attributes = {};
	            attributes[attr] = {
	              valType: "subplotid",
	              dflt: name2,
	              editType: "calc"
	            };
	            function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var calcData = gd.calcdata;
	              var subplotIds = fullLayout._subplots[name2];
	              for (var i = 0; i < subplotIds.length; i++) {
	                var id = subplotIds[i];
	                var subplotCalcData = getSubplotCalcData(calcData, name2, id);
	                var subplot = fullLayout[id]._subplot;
	                if (!subplot) {
	                  subplot = createPolar(gd, id, true);
	                  fullLayout[id]._subplot = subplot;
	                }
	                subplot.plot(subplotCalcData, fullLayout, gd._promises);
	              }
	            }
	            function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldIds = oldFullLayout._subplots[name2] || [];
	              for (var i = 0; i < oldIds.length; i++) {
	                var id = oldIds[i];
	                var oldSubplot = oldFullLayout[id]._subplot;
	                if (!newFullLayout[id] && !!oldSubplot) {
	                  oldSubplot.framework.remove();
	                  for (var k in oldSubplot.clipPaths) {
	                    oldSubplot.clipPaths[k].remove();
	                  }
	                }
	              }
	            }
	            module2.exports = {
	              attr,
	              name: name2,
	              idRoot: name2,
	              idRegex: counter,
	              attrRegex: counter,
	              attributes,
	              layoutAttributes: __webpack_require__2(33419),
	              supplyLayoutDefaults: __webpack_require__2(9558),
	              plot,
	              clean,
	              toSVG: __webpack_require__2(93612).toSVG
	            };
	          }
	        ),
	        /***/
	        33419: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorAttrs = __webpack_require__2(22399);
	            var axesAttrs = __webpack_require__2(13838);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var extendFlat = __webpack_require__2(71828).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var axisLineGridAttr = overrideAll({
	              color: axesAttrs.color,
	              showline: extendFlat({}, axesAttrs.showline, {
	                dflt: true
	              }),
	              linecolor: axesAttrs.linecolor,
	              linewidth: axesAttrs.linewidth,
	              showgrid: extendFlat({}, axesAttrs.showgrid, {
	                dflt: true
	              }),
	              gridcolor: axesAttrs.gridcolor,
	              gridwidth: axesAttrs.gridwidth,
	              griddash: axesAttrs.griddash
	            }, "plot", "from-root");
	            var axisTickAttrs = overrideAll({
	              ticklen: axesAttrs.ticklen,
	              tickwidth: extendFlat({}, axesAttrs.tickwidth, {
	                dflt: 2
	              }),
	              tickcolor: axesAttrs.tickcolor,
	              showticklabels: axesAttrs.showticklabels,
	              labelalias: axesAttrs.labelalias,
	              showtickprefix: axesAttrs.showtickprefix,
	              tickprefix: axesAttrs.tickprefix,
	              showticksuffix: axesAttrs.showticksuffix,
	              ticksuffix: axesAttrs.ticksuffix,
	              tickfont: axesAttrs.tickfont,
	              tickformat: axesAttrs.tickformat,
	              hoverformat: axesAttrs.hoverformat,
	              layer: axesAttrs.layer
	            }, "plot", "from-root");
	            var realAxisAttrs = extendFlat({
	              visible: extendFlat({}, axesAttrs.visible, {
	                dflt: true
	              }),
	              tickvals: {
	                dflt: [0.2, 0.5, 1, 2, 5],
	                valType: "data_array",
	                editType: "plot"
	              },
	              tickangle: extendFlat({}, axesAttrs.tickangle, {
	                dflt: 90
	              }),
	              ticks: {
	                valType: "enumerated",
	                values: ["top", "bottom", ""],
	                editType: "ticks"
	              },
	              side: {
	                valType: "enumerated",
	                values: ["top", "bottom"],
	                dflt: "top",
	                editType: "plot"
	              },
	              editType: "calc"
	            }, axisLineGridAttr, axisTickAttrs);
	            var imaginaryAxisAttrs = extendFlat({
	              visible: extendFlat({}, axesAttrs.visible, {
	                dflt: true
	              }),
	              tickvals: {
	                valType: "data_array",
	                editType: "plot"
	              },
	              ticks: axesAttrs.ticks,
	              editType: "calc"
	            }, axisLineGridAttr, axisTickAttrs);
	            module2.exports = {
	              domain: domainAttrs({
	                name: "smith",
	                editType: "plot"
	              }),
	              bgcolor: {
	                valType: "color",
	                editType: "plot",
	                dflt: colorAttrs.background
	              },
	              realaxis: realAxisAttrs,
	              imaginaryaxis: imaginaryAxisAttrs,
	              editType: "calc"
	            };
	          }
	        ),
	        /***/
	        9558: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Template = __webpack_require__2(44467);
	            var handleSubplotDefaults = __webpack_require__2(49119);
	            var getSubplotData = __webpack_require__2(27659).NG;
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handleLineGridDefaults = __webpack_require__2(92128);
	            var setConvertCartesian = __webpack_require__2(21994);
	            var layoutAttributes = __webpack_require__2(33419);
	            var constants = __webpack_require__2(39779);
	            var axisNames = constants.axisNames;
	            var makeImagDflt = memoize(function(realTickvals) {
	              return realTickvals.slice().reverse().map(function(x) {
	                return -x;
	              }).concat([0]).concat(realTickvals);
	            }, String);
	            function handleDefaults(contIn, contOut, coerce, opts) {
	              var bgColor = coerce("bgcolor");
	              opts.bgColor = Color.combine(bgColor, opts.paper_bgcolor);
	              var subplotData = getSubplotData(opts.fullData, constants.name, opts.id);
	              var layoutOut = opts.layoutOut;
	              var axName;
	              function coerceAxis(attr, dflt) {
	                return coerce(axName + "." + attr, dflt);
	              }
	              for (var i = 0; i < axisNames.length; i++) {
	                axName = axisNames[i];
	                if (!Lib.isPlainObject(contIn[axName])) {
	                  contIn[axName] = {};
	                }
	                var axIn = contIn[axName];
	                var axOut = Template.newContainer(contOut, axName);
	                axOut._id = axOut._name = axName;
	                axOut._attr = opts.id + "." + axName;
	                axOut._traceIndices = subplotData.map(function(t) {
	                  return t._expandedIndex;
	                });
	                var visible = coerceAxis("visible");
	                axOut.type = "linear";
	                setConvertCartesian(axOut, layoutOut);
	                handlePrefixSuffixDefaults(axIn, axOut, coerceAxis, axOut.type);
	                if (visible) {
	                  var isRealAxis = axName === "realaxis";
	                  if (isRealAxis) coerceAxis("side");
	                  if (isRealAxis) {
	                    coerceAxis("tickvals");
	                  } else {
	                    var imagTickvalsDflt = makeImagDflt(contOut.realaxis.tickvals || layoutAttributes.realaxis.tickvals.dflt);
	                    coerceAxis("tickvals", imagTickvalsDflt);
	                  }
	                  var dfltColor;
	                  var dfltFontColor;
	                  var dfltFontSize;
	                  var dfltFontFamily;
	                  var font = opts.font || {};
	                  if (visible) {
	                    dfltColor = coerceAxis("color");
	                    dfltFontColor = dfltColor === axIn.color ? dfltColor : font.color;
	                    dfltFontSize = font.size;
	                    dfltFontFamily = font.family;
	                  }
	                  handleTickLabelDefaults(axIn, axOut, coerceAxis, axOut.type, {
	                    noTicklabelstep: true,
	                    noAng: !isRealAxis,
	                    noExp: true,
	                    font: {
	                      color: dfltFontColor,
	                      size: dfltFontSize,
	                      family: dfltFontFamily
	                    }
	                  });
	                  Lib.coerce2(contIn, contOut, layoutAttributes, axName + ".ticklen");
	                  Lib.coerce2(contIn, contOut, layoutAttributes, axName + ".tickwidth");
	                  Lib.coerce2(contIn, contOut, layoutAttributes, axName + ".tickcolor", contOut.color);
	                  var showTicks = coerceAxis("ticks");
	                  if (!showTicks) {
	                    delete contOut[axName].ticklen;
	                    delete contOut[axName].tickwidth;
	                    delete contOut[axName].tickcolor;
	                  }
	                  handleLineGridDefaults(axIn, axOut, coerceAxis, {
	                    dfltColor,
	                    bgColor: opts.bgColor,
	                    // default grid color is darker here (60%, vs cartesian default ~91%)
	                    // because the grid is not square so the eye needs heavier cues to follow
	                    blend: 60,
	                    showLine: true,
	                    showGrid: true,
	                    noZeroLine: true,
	                    attributes: layoutAttributes[axName]
	                  });
	                  coerceAxis("layer");
	                }
	                coerceAxis("hoverformat");
	                delete axOut.type;
	                axOut._input = axIn;
	              }
	            }
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	                noUirevision: true,
	                type: constants.name,
	                attributes: layoutAttributes,
	                handleDefaults,
	                font: layoutOut.font,
	                paper_bgcolor: layoutOut.paper_bgcolor,
	                fullData,
	                layoutOut
	              });
	            };
	            function memoize(fn, keyFn) {
	              var cache = {};
	              return function(val) {
	                var newKey = keyFn ? keyFn(val) : val;
	                if (newKey in cache) {
	                  return cache[newKey];
	                }
	                var out = fn(val);
	                cache[newKey] = out;
	                return out;
	              };
	            }
	          }
	        ),
	        /***/
	        49119: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Template = __webpack_require__2(44467);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            module2.exports = function handleSubplotDefaults(layoutIn, layoutOut, fullData, opts) {
	              var subplotType = opts.type;
	              var subplotAttributes = opts.attributes;
	              var handleDefaults = opts.handleDefaults;
	              var partition = opts.partition || "x";
	              var ids = layoutOut._subplots[subplotType];
	              var idsLength = ids.length;
	              var baseId = idsLength && ids[0].replace(/\d+$/, "");
	              var subplotLayoutIn, subplotLayoutOut;
	              function coerce(attr, dflt) {
	                return Lib.coerce(subplotLayoutIn, subplotLayoutOut, subplotAttributes, attr, dflt);
	              }
	              for (var i = 0; i < idsLength; i++) {
	                var id = ids[i];
	                if (layoutIn[id]) subplotLayoutIn = layoutIn[id];
	                else subplotLayoutIn = layoutIn[id] = {};
	                subplotLayoutOut = Template.newContainer(layoutOut, id, baseId);
	                if (!opts.noUirevision) coerce("uirevision", layoutOut.uirevision);
	                var dfltDomains = {};
	                dfltDomains[partition] = [i / idsLength, (i + 1) / idsLength];
	                handleDomainDefaults(subplotLayoutOut, layoutOut, coerce, dfltDomains);
	                opts.id = id;
	                handleDefaults(subplotLayoutIn, subplotLayoutOut, coerce, opts);
	              }
	            };
	          }
	        ),
	        /***/
	        5386: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var docs = __webpack_require__2(31562);
	            docs.FORMAT_LINK;
	            docs.DATE_FORMAT_LINK;
	            function describeVariables(extra) {
	              var descPart = extra.description ? " " + extra.description : "";
	              var keys = extra.keys || [];
	              if (keys.length > 0) {
	                var quotedKeys = [];
	                for (var i = 0; i < keys.length; i++) {
	                  quotedKeys[i] = "`" + keys[i] + "`";
	                }
	                descPart = descPart + "Finally, the template string has access to ";
	                if (keys.length === 1) {
	                  descPart = descPart + "variable " + quotedKeys[0];
	                } else {
	                  descPart = descPart + "variables " + quotedKeys.slice(0, -1).join(", ") + " and " + quotedKeys.slice(-1) + ".";
	                }
	              }
	              return descPart;
	            }
	            exports2.fF = function(opts, extra) {
	              opts = opts || {};
	              extra = extra || {};
	              describeVariables(extra);
	              var hovertemplate = {
	                valType: "string",
	                dflt: "",
	                editType: opts.editType || "none"
	              };
	              if (opts.arrayOk !== false) {
	                hovertemplate.arrayOk = true;
	              }
	              return hovertemplate;
	            };
	            exports2.si = function(opts, extra) {
	              opts = opts || {};
	              extra = extra || {};
	              describeVariables(extra);
	              var texttemplate = {
	                valType: "string",
	                dflt: "",
	                editType: opts.editType || "calc"
	              };
	              if (opts.arrayOk !== false) {
	                texttemplate.arrayOk = true;
	              }
	              return texttemplate;
	            };
	            exports2.R = function(opts, extra) {
	              opts = opts || {};
	              extra = extra || {};
	              opts.newshape ? "new " : "";
	              describeVariables(extra);
	              var texttemplate = {
	                valType: "string",
	                dflt: "",
	                editType: opts.editType || "arraydraw"
	              };
	              return texttemplate;
	            };
	          }
	        ),
	        /***/
	        61639: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Ternary = __webpack_require__2(64380);
	            var getSubplotCalcData = __webpack_require__2(27659).AU;
	            var counterRegex = __webpack_require__2(71828).counterRegex;
	            var TERNARY = "ternary";
	            exports2.name = TERNARY;
	            var attr = exports2.attr = "subplot";
	            exports2.idRoot = TERNARY;
	            exports2.idRegex = exports2.attrRegex = counterRegex(TERNARY);
	            var attributes = exports2.attributes = {};
	            attributes[attr] = {
	              valType: "subplotid",
	              dflt: "ternary",
	              editType: "calc"
	            };
	            exports2.layoutAttributes = __webpack_require__2(81367);
	            exports2.supplyLayoutDefaults = __webpack_require__2(25369);
	            exports2.plot = function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var calcData = gd.calcdata;
	              var ternaryIds = fullLayout._subplots[TERNARY];
	              for (var i = 0; i < ternaryIds.length; i++) {
	                var ternaryId = ternaryIds[i];
	                var ternaryCalcData = getSubplotCalcData(calcData, TERNARY, ternaryId);
	                var ternary = fullLayout[ternaryId]._subplot;
	                if (!ternary) {
	                  ternary = new Ternary({
	                    id: ternaryId,
	                    graphDiv: gd,
	                    container: fullLayout._ternarylayer.node()
	                  }, fullLayout);
	                  fullLayout[ternaryId]._subplot = ternary;
	                }
	                ternary.plot(ternaryCalcData, fullLayout, gd._promises);
	              }
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var oldTernaryKeys = oldFullLayout._subplots[TERNARY] || [];
	              for (var i = 0; i < oldTernaryKeys.length; i++) {
	                var oldTernaryKey = oldTernaryKeys[i];
	                var oldTernary = oldFullLayout[oldTernaryKey]._subplot;
	                if (!newFullLayout[oldTernaryKey] && !!oldTernary) {
	                  oldTernary.plotContainer.remove();
	                  oldTernary.clipDef.remove();
	                  oldTernary.clipDefRelative.remove();
	                  oldTernary.layers["a-title"].remove();
	                  oldTernary.layers["b-title"].remove();
	                  oldTernary.layers["c-title"].remove();
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        81367: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorAttrs = __webpack_require__2(22399);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var axesAttrs = __webpack_require__2(13838);
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var ternaryAxesAttrs = {
	              title: {
	                text: axesAttrs.title.text,
	                font: axesAttrs.title.font
	                // TODO does standoff here make sense?
	              },
	              color: axesAttrs.color,
	              // ticks
	              tickmode: axesAttrs.minor.tickmode,
	              nticks: extendFlat({}, axesAttrs.nticks, {
	                dflt: 6,
	                min: 1
	              }),
	              tick0: axesAttrs.tick0,
	              dtick: axesAttrs.dtick,
	              tickvals: axesAttrs.tickvals,
	              ticktext: axesAttrs.ticktext,
	              ticks: axesAttrs.ticks,
	              ticklen: axesAttrs.ticklen,
	              tickwidth: axesAttrs.tickwidth,
	              tickcolor: axesAttrs.tickcolor,
	              ticklabelstep: axesAttrs.ticklabelstep,
	              showticklabels: axesAttrs.showticklabels,
	              labelalias: axesAttrs.labelalias,
	              showtickprefix: axesAttrs.showtickprefix,
	              tickprefix: axesAttrs.tickprefix,
	              showticksuffix: axesAttrs.showticksuffix,
	              ticksuffix: axesAttrs.ticksuffix,
	              showexponent: axesAttrs.showexponent,
	              exponentformat: axesAttrs.exponentformat,
	              minexponent: axesAttrs.minexponent,
	              separatethousands: axesAttrs.separatethousands,
	              tickfont: axesAttrs.tickfont,
	              tickangle: axesAttrs.tickangle,
	              tickformat: axesAttrs.tickformat,
	              tickformatstops: axesAttrs.tickformatstops,
	              hoverformat: axesAttrs.hoverformat,
	              // lines and grids
	              showline: extendFlat({}, axesAttrs.showline, {
	                dflt: true
	              }),
	              linecolor: axesAttrs.linecolor,
	              linewidth: axesAttrs.linewidth,
	              showgrid: extendFlat({}, axesAttrs.showgrid, {
	                dflt: true
	              }),
	              gridcolor: axesAttrs.gridcolor,
	              gridwidth: axesAttrs.gridwidth,
	              griddash: axesAttrs.griddash,
	              layer: axesAttrs.layer,
	              // range
	              min: {
	                valType: "number",
	                dflt: 0,
	                min: 0
	              },
	              _deprecated: {
	                title: axesAttrs._deprecated.title,
	                titlefont: axesAttrs._deprecated.titlefont
	              }
	            };
	            var attrs = module2.exports = overrideAll({
	              domain: domainAttrs({
	                name: "ternary"
	              }),
	              bgcolor: {
	                valType: "color",
	                dflt: colorAttrs.background
	              },
	              sum: {
	                valType: "number",
	                dflt: 1,
	                min: 0
	              },
	              aaxis: ternaryAxesAttrs,
	              baxis: ternaryAxesAttrs,
	              caxis: ternaryAxesAttrs
	            }, "plot", "from-root");
	            attrs.uirevision = {
	              valType: "any",
	              editType: "none"
	            };
	            attrs.aaxis.uirevision = attrs.baxis.uirevision = attrs.caxis.uirevision = {
	              valType: "any",
	              editType: "none"
	            };
	          }
	        ),
	        /***/
	        25369: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var Template = __webpack_require__2(44467);
	            var Lib = __webpack_require__2(71828);
	            var handleSubplotDefaults = __webpack_require__2(49119);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            var handleTickMarkDefaults = __webpack_require__2(38701);
	            var handleTickValueDefaults = __webpack_require__2(26218);
	            var handleLineGridDefaults = __webpack_require__2(92128);
	            var layoutAttributes = __webpack_require__2(81367);
	            var axesNames = ["aaxis", "baxis", "caxis"];
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              handleSubplotDefaults(layoutIn, layoutOut, fullData, {
	                type: "ternary",
	                attributes: layoutAttributes,
	                handleDefaults: handleTernaryDefaults,
	                font: layoutOut.font,
	                paper_bgcolor: layoutOut.paper_bgcolor
	              });
	            };
	            function handleTernaryDefaults(ternaryLayoutIn, ternaryLayoutOut, coerce, options) {
	              var bgColor = coerce("bgcolor");
	              var sum = coerce("sum");
	              options.bgColor = Color.combine(bgColor, options.paper_bgcolor);
	              var axName, containerIn, containerOut;
	              for (var j = 0; j < axesNames.length; j++) {
	                axName = axesNames[j];
	                containerIn = ternaryLayoutIn[axName] || {};
	                containerOut = Template.newContainer(ternaryLayoutOut, axName);
	                containerOut._name = axName;
	                handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut);
	              }
	              var aaxis = ternaryLayoutOut.aaxis;
	              var baxis = ternaryLayoutOut.baxis;
	              var caxis = ternaryLayoutOut.caxis;
	              if (aaxis.min + baxis.min + caxis.min >= sum) {
	                aaxis.min = 0;
	                baxis.min = 0;
	                caxis.min = 0;
	                if (ternaryLayoutIn.aaxis) delete ternaryLayoutIn.aaxis.min;
	                if (ternaryLayoutIn.baxis) delete ternaryLayoutIn.baxis.min;
	                if (ternaryLayoutIn.caxis) delete ternaryLayoutIn.caxis.min;
	              }
	            }
	            function handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut) {
	              var axAttrs = layoutAttributes[containerOut._name];
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, axAttrs, attr, dflt);
	              }
	              coerce("uirevision", ternaryLayoutOut.uirevision);
	              containerOut.type = "linear";
	              var dfltColor = coerce("color");
	              var dfltFontColor = dfltColor !== axAttrs.color.dflt ? dfltColor : options.font.color;
	              var axName = containerOut._name;
	              var letterUpper = axName.charAt(0).toUpperCase();
	              var dfltTitle = "Component " + letterUpper;
	              var title = coerce("title.text", dfltTitle);
	              containerOut._hovertitle = title === dfltTitle ? title : letterUpper;
	              Lib.coerceFont(coerce, "title.font", {
	                family: options.font.family,
	                size: Lib.bigFont(options.font.size),
	                color: dfltFontColor
	              });
	              coerce("min");
	              handleTickValueDefaults(containerIn, containerOut, coerce, "linear");
	              handlePrefixSuffixDefaults(containerIn, containerOut, coerce, "linear");
	              handleTickLabelDefaults(containerIn, containerOut, coerce, "linear");
	              handleTickMarkDefaults(containerIn, containerOut, coerce, {
	                outerTicks: true
	              });
	              var showTickLabels = coerce("showticklabels");
	              if (showTickLabels) {
	                Lib.coerceFont(coerce, "tickfont", {
	                  family: options.font.family,
	                  size: options.font.size,
	                  color: dfltFontColor
	                });
	                coerce("tickangle");
	                coerce("tickformat");
	              }
	              handleLineGridDefaults(containerIn, containerOut, coerce, {
	                dfltColor,
	                bgColor: options.bgColor,
	                // default grid color is darker here (60%, vs cartesian default ~91%)
	                // because the grid is not square so the eye needs heavier cues to follow
	                blend: 60,
	                showLine: true,
	                showGrid: true,
	                noZeroLine: true,
	                attributes: axAttrs
	              });
	              coerce("hoverformat");
	              coerce("layer");
	            }
	          }
	        ),
	        /***/
	        64380: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var tinycolor = __webpack_require__2(84267);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var _ = Lib._;
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var setConvert = __webpack_require__2(21994);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var Plots = __webpack_require__2(74875);
	            var Axes = __webpack_require__2(89298);
	            var dragElement = __webpack_require__2(28569);
	            var Fx = __webpack_require__2(30211);
	            var dragHelpers = __webpack_require__2(64505);
	            var freeMode = dragHelpers.freeMode;
	            var rectMode = dragHelpers.rectMode;
	            var Titles = __webpack_require__2(92998);
	            var prepSelect = __webpack_require__2(47322).prepSelect;
	            var selectOnClick = __webpack_require__2(47322).selectOnClick;
	            var clearOutline = __webpack_require__2(47322).clearOutline;
	            var clearSelectionsCache = __webpack_require__2(47322).clearSelectionsCache;
	            var constants = __webpack_require__2(85555);
	            function Ternary(options, fullLayout) {
	              this.id = options.id;
	              this.graphDiv = options.graphDiv;
	              this.init(fullLayout);
	              this.makeFramework(fullLayout);
	              this.aTickLayout = null;
	              this.bTickLayout = null;
	              this.cTickLayout = null;
	            }
	            module2.exports = Ternary;
	            var proto = Ternary.prototype;
	            proto.init = function(fullLayout) {
	              this.container = fullLayout._ternarylayer;
	              this.defs = fullLayout._defs;
	              this.layoutId = fullLayout._uid;
	              this.traceHash = {};
	              this.layers = {};
	            };
	            proto.plot = function(ternaryCalcData, fullLayout) {
	              var _this = this;
	              var ternaryLayout = fullLayout[_this.id];
	              var graphSize = fullLayout._size;
	              _this._hasClipOnAxisFalse = false;
	              for (var i = 0; i < ternaryCalcData.length; i++) {
	                var trace = ternaryCalcData[i][0].trace;
	                if (trace.cliponaxis === false) {
	                  _this._hasClipOnAxisFalse = true;
	                  break;
	                }
	              }
	              _this.updateLayers(ternaryLayout);
	              _this.adjustLayout(ternaryLayout, graphSize);
	              Plots.generalUpdatePerTraceModule(_this.graphDiv, _this, ternaryCalcData, ternaryLayout);
	              _this.layers.plotbg.select("path").call(Color.fill, ternaryLayout.bgcolor);
	            };
	            proto.makeFramework = function(fullLayout) {
	              var _this = this;
	              var gd = _this.graphDiv;
	              var ternaryLayout = fullLayout[_this.id];
	              var clipId = _this.clipId = "clip" + _this.layoutId + _this.id;
	              var clipIdRelative = _this.clipIdRelative = "clip-relative" + _this.layoutId + _this.id;
	              _this.clipDef = Lib.ensureSingleById(fullLayout._clips, "clipPath", clipId, function(s) {
	                s.append("path").attr("d", "M0,0Z");
	              });
	              _this.clipDefRelative = Lib.ensureSingleById(fullLayout._clips, "clipPath", clipIdRelative, function(s) {
	                s.append("path").attr("d", "M0,0Z");
	              });
	              _this.plotContainer = Lib.ensureSingle(_this.container, "g", _this.id);
	              _this.updateLayers(ternaryLayout);
	              Drawing.setClipUrl(_this.layers.backplot, clipId, gd);
	              Drawing.setClipUrl(_this.layers.grids, clipId, gd);
	            };
	            proto.updateLayers = function(ternaryLayout) {
	              var _this = this;
	              var layers = _this.layers;
	              var plotLayers = ["draglayer", "plotbg", "backplot", "grids"];
	              if (ternaryLayout.aaxis.layer === "below traces") {
	                plotLayers.push("aaxis", "aline");
	              }
	              if (ternaryLayout.baxis.layer === "below traces") {
	                plotLayers.push("baxis", "bline");
	              }
	              if (ternaryLayout.caxis.layer === "below traces") {
	                plotLayers.push("caxis", "cline");
	              }
	              plotLayers.push("frontplot");
	              if (ternaryLayout.aaxis.layer === "above traces") {
	                plotLayers.push("aaxis", "aline");
	              }
	              if (ternaryLayout.baxis.layer === "above traces") {
	                plotLayers.push("baxis", "bline");
	              }
	              if (ternaryLayout.caxis.layer === "above traces") {
	                plotLayers.push("caxis", "cline");
	              }
	              var toplevel = _this.plotContainer.selectAll("g.toplevel").data(plotLayers, String);
	              var grids = ["agrid", "bgrid", "cgrid"];
	              toplevel.enter().append("g").attr("class", function(d) {
	                return "toplevel " + d;
	              }).each(function(d) {
	                var s = d3.select(this);
	                layers[d] = s;
	                if (d === "frontplot") {
	                  s.append("g").classed("scatterlayer", true);
	                } else if (d === "backplot") {
	                  s.append("g").classed("maplayer", true);
	                } else if (d === "plotbg") {
	                  s.append("path").attr("d", "M0,0Z");
	                } else if (d === "aline" || d === "bline" || d === "cline") {
	                  s.append("path");
	                } else if (d === "grids") {
	                  grids.forEach(function(d2) {
	                    layers[d2] = s.append("g").classed("grid " + d2, true);
	                  });
	                }
	              });
	              toplevel.order();
	            };
	            var whRatio = Math.sqrt(4 / 3);
	            proto.adjustLayout = function(ternaryLayout, graphSize) {
	              var _this = this;
	              var domain = ternaryLayout.domain;
	              var xDomainCenter = (domain.x[0] + domain.x[1]) / 2;
	              var yDomainCenter = (domain.y[0] + domain.y[1]) / 2;
	              var xDomain = domain.x[1] - domain.x[0];
	              var yDomain = domain.y[1] - domain.y[0];
	              var wmax = xDomain * graphSize.w;
	              var hmax = yDomain * graphSize.h;
	              var sum = ternaryLayout.sum;
	              var amin = ternaryLayout.aaxis.min;
	              var bmin = ternaryLayout.baxis.min;
	              var cmin = ternaryLayout.caxis.min;
	              var x0, y0, w, h, xDomainFinal, yDomainFinal;
	              if (wmax > whRatio * hmax) {
	                h = hmax;
	                w = h * whRatio;
	              } else {
	                w = wmax;
	                h = w / whRatio;
	              }
	              xDomainFinal = xDomain * w / wmax;
	              yDomainFinal = yDomain * h / hmax;
	              x0 = graphSize.l + graphSize.w * xDomainCenter - w / 2;
	              y0 = graphSize.t + graphSize.h * (1 - yDomainCenter) - h / 2;
	              _this.x0 = x0;
	              _this.y0 = y0;
	              _this.w = w;
	              _this.h = h;
	              _this.sum = sum;
	              _this.xaxis = {
	                type: "linear",
	                range: [amin + 2 * cmin - sum, sum - amin - 2 * bmin],
	                domain: [xDomainCenter - xDomainFinal / 2, xDomainCenter + xDomainFinal / 2],
	                _id: "x"
	              };
	              setConvert(_this.xaxis, _this.graphDiv._fullLayout);
	              _this.xaxis.setScale();
	              _this.xaxis.isPtWithinRange = function(d) {
	                return d.a >= _this.aaxis.range[0] && d.a <= _this.aaxis.range[1] && d.b >= _this.baxis.range[1] && d.b <= _this.baxis.range[0] && d.c >= _this.caxis.range[1] && d.c <= _this.caxis.range[0];
	              };
	              _this.yaxis = {
	                type: "linear",
	                range: [amin, sum - bmin - cmin],
	                domain: [yDomainCenter - yDomainFinal / 2, yDomainCenter + yDomainFinal / 2],
	                _id: "y"
	              };
	              setConvert(_this.yaxis, _this.graphDiv._fullLayout);
	              _this.yaxis.setScale();
	              _this.yaxis.isPtWithinRange = function() {
	                return true;
	              };
	              var yDomain0 = _this.yaxis.domain[0];
	              var aaxis = _this.aaxis = extendFlat({}, ternaryLayout.aaxis, {
	                range: [amin, sum - bmin - cmin],
	                side: "left",
	                // tickangle = 'auto' means 0 anyway for a y axis, need to coerce to 0 here
	                // so we can shift by 30.
	                tickangle: (+ternaryLayout.aaxis.tickangle || 0) - 30,
	                domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
	                anchor: "free",
	                position: 0,
	                _id: "y",
	                _length: w
	              });
	              setConvert(aaxis, _this.graphDiv._fullLayout);
	              aaxis.setScale();
	              var baxis = _this.baxis = extendFlat({}, ternaryLayout.baxis, {
	                range: [sum - amin - cmin, bmin],
	                side: "bottom",
	                domain: _this.xaxis.domain,
	                anchor: "free",
	                position: 0,
	                _id: "x",
	                _length: w
	              });
	              setConvert(baxis, _this.graphDiv._fullLayout);
	              baxis.setScale();
	              var caxis = _this.caxis = extendFlat({}, ternaryLayout.caxis, {
	                range: [sum - amin - bmin, cmin],
	                side: "right",
	                tickangle: (+ternaryLayout.caxis.tickangle || 0) + 30,
	                domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
	                anchor: "free",
	                position: 0,
	                _id: "y",
	                _length: w
	              });
	              setConvert(caxis, _this.graphDiv._fullLayout);
	              caxis.setScale();
	              var triangleClip = "M" + x0 + "," + (y0 + h) + "h" + w + "l-" + w / 2 + ",-" + h + "Z";
	              _this.clipDef.select("path").attr("d", triangleClip);
	              _this.layers.plotbg.select("path").attr("d", triangleClip);
	              var triangleClipRelative = "M0," + h + "h" + w + "l-" + w / 2 + ",-" + h + "Z";
	              _this.clipDefRelative.select("path").attr("d", triangleClipRelative);
	              var plotTransform = strTranslate(x0, y0);
	              _this.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", plotTransform);
	              _this.clipDefRelative.select("path").attr("transform", null);
	              var bTransform = strTranslate(x0 - baxis._offset, y0 + h);
	              _this.layers.baxis.attr("transform", bTransform);
	              _this.layers.bgrid.attr("transform", bTransform);
	              var aTransform = strTranslate(x0 + w / 2, y0) + "rotate(30)" + strTranslate(0, -aaxis._offset);
	              _this.layers.aaxis.attr("transform", aTransform);
	              _this.layers.agrid.attr("transform", aTransform);
	              var cTransform = strTranslate(x0 + w / 2, y0) + "rotate(-30)" + strTranslate(0, -caxis._offset);
	              _this.layers.caxis.attr("transform", cTransform);
	              _this.layers.cgrid.attr("transform", cTransform);
	              _this.drawAxes(true);
	              _this.layers.aline.select("path").attr("d", aaxis.showline ? "M" + x0 + "," + (y0 + h) + "l" + w / 2 + ",-" + h : "M0,0").call(Color.stroke, aaxis.linecolor || "#000").style("stroke-width", (aaxis.linewidth || 0) + "px");
	              _this.layers.bline.select("path").attr("d", baxis.showline ? "M" + x0 + "," + (y0 + h) + "h" + w : "M0,0").call(Color.stroke, baxis.linecolor || "#000").style("stroke-width", (baxis.linewidth || 0) + "px");
	              _this.layers.cline.select("path").attr("d", caxis.showline ? "M" + (x0 + w / 2) + "," + y0 + "l" + w / 2 + "," + h : "M0,0").call(Color.stroke, caxis.linecolor || "#000").style("stroke-width", (caxis.linewidth || 0) + "px");
	              if (!_this.graphDiv._context.staticPlot) {
	                _this.initInteractions();
	              }
	              Drawing.setClipUrl(_this.layers.frontplot, _this._hasClipOnAxisFalse ? null : _this.clipId, _this.graphDiv);
	            };
	            proto.drawAxes = function(doTitles) {
	              var _this = this;
	              var gd = _this.graphDiv;
	              var titlesuffix = _this.id.substr(7) + "title";
	              var layers = _this.layers;
	              var aaxis = _this.aaxis;
	              var baxis = _this.baxis;
	              var caxis = _this.caxis;
	              _this.drawAx(aaxis);
	              _this.drawAx(baxis);
	              _this.drawAx(caxis);
	              if (doTitles) {
	                var apad = Math.max(aaxis.showticklabels ? aaxis.tickfont.size / 2 : 0, (caxis.showticklabels ? caxis.tickfont.size * 0.75 : 0) + (caxis.ticks === "outside" ? caxis.ticklen * 0.87 : 0));
	                var bpad = (baxis.showticklabels ? baxis.tickfont.size : 0) + (baxis.ticks === "outside" ? baxis.ticklen : 0) + 3;
	                layers["a-title"] = Titles.draw(gd, "a" + titlesuffix, {
	                  propContainer: aaxis,
	                  propName: _this.id + ".aaxis.title",
	                  placeholder: _(gd, "Click to enter Component A title"),
	                  attributes: {
	                    x: _this.x0 + _this.w / 2,
	                    y: _this.y0 - aaxis.title.font.size / 3 - apad,
	                    "text-anchor": "middle"
	                  }
	                });
	                layers["b-title"] = Titles.draw(gd, "b" + titlesuffix, {
	                  propContainer: baxis,
	                  propName: _this.id + ".baxis.title",
	                  placeholder: _(gd, "Click to enter Component B title"),
	                  attributes: {
	                    x: _this.x0 - bpad,
	                    y: _this.y0 + _this.h + baxis.title.font.size * 0.83 + bpad,
	                    "text-anchor": "middle"
	                  }
	                });
	                layers["c-title"] = Titles.draw(gd, "c" + titlesuffix, {
	                  propContainer: caxis,
	                  propName: _this.id + ".caxis.title",
	                  placeholder: _(gd, "Click to enter Component C title"),
	                  attributes: {
	                    x: _this.x0 + _this.w + bpad,
	                    y: _this.y0 + _this.h + caxis.title.font.size * 0.83 + bpad,
	                    "text-anchor": "middle"
	                  }
	                });
	              }
	            };
	            proto.drawAx = function(ax) {
	              var _this = this;
	              var gd = _this.graphDiv;
	              var axName = ax._name;
	              var axLetter = axName.charAt(0);
	              var axId = ax._id;
	              var axLayer = _this.layers[axName];
	              var counterAngle = 30;
	              var stashKey = axLetter + "tickLayout";
	              var newTickLayout = strTickLayout(ax);
	              if (_this[stashKey] !== newTickLayout) {
	                axLayer.selectAll("." + axId + "tick").remove();
	                _this[stashKey] = newTickLayout;
	              }
	              ax.setScale();
	              var vals = Axes.calcTicks(ax);
	              var valsClipped = Axes.clipEnds(ax, vals);
	              var transFn = Axes.makeTransTickFn(ax);
	              var tickSign = Axes.getTickSigns(ax)[2];
	              var caRad = Lib.deg2rad(counterAngle);
	              var pad = tickSign * (ax.linewidth || 1) / 2;
	              var len = tickSign * ax.ticklen;
	              var w = _this.w;
	              var h = _this.h;
	              var tickPath = axLetter === "b" ? "M0," + pad + "l" + Math.sin(caRad) * len + "," + Math.cos(caRad) * len : "M" + pad + ",0l" + Math.cos(caRad) * len + "," + -Math.sin(caRad) * len;
	              var gridPath = {
	                a: "M0,0l" + h + ",-" + w / 2,
	                b: "M0,0l-" + w / 2 + ",-" + h,
	                c: "M0,0l-" + h + "," + w / 2
	              }[axLetter];
	              Axes.drawTicks(gd, ax, {
	                vals: ax.ticks === "inside" ? valsClipped : vals,
	                layer: axLayer,
	                path: tickPath,
	                transFn,
	                crisp: false
	              });
	              Axes.drawGrid(gd, ax, {
	                vals: valsClipped,
	                layer: _this.layers[axLetter + "grid"],
	                path: gridPath,
	                transFn,
	                crisp: false
	              });
	              Axes.drawLabels(gd, ax, {
	                vals,
	                layer: axLayer,
	                transFn,
	                labelFns: Axes.makeLabelFns(ax, 0, counterAngle)
	              });
	            };
	            function strTickLayout(axLayout) {
	              return axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
	            }
	            var CLEN = constants.MINZOOM / 2 + 0.87;
	            var BLPATH = "m-0.87,.5h" + CLEN + "v3h-" + (CLEN + 5.2) + "l" + (CLEN / 2 + 2.6) + ",-" + (CLEN * 0.87 + 4.5) + "l2.6,1.5l-" + CLEN / 2 + "," + CLEN * 0.87 + "Z";
	            var BRPATH = "m0.87,.5h-" + CLEN + "v3h" + (CLEN + 5.2) + "l-" + (CLEN / 2 + 2.6) + ",-" + (CLEN * 0.87 + 4.5) + "l-2.6,1.5l" + CLEN / 2 + "," + CLEN * 0.87 + "Z";
	            var TOPPATH = "m0,1l" + CLEN / 2 + "," + CLEN * 0.87 + "l2.6,-1.5l-" + (CLEN / 2 + 2.6) + ",-" + (CLEN * 0.87 + 4.5) + "l-" + (CLEN / 2 + 2.6) + "," + (CLEN * 0.87 + 4.5) + "l2.6,1.5l" + CLEN / 2 + ",-" + CLEN * 0.87 + "Z";
	            var STARTMARKER = "m0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2Z";
	            var SHOWZOOMOUTTIP = true;
	            proto.clearOutline = function() {
	              clearSelectionsCache(this.dragOptions);
	              clearOutline(this.dragOptions.gd);
	            };
	            proto.initInteractions = function() {
	              var _this = this;
	              var dragger = _this.layers.plotbg.select("path").node();
	              var gd = _this.graphDiv;
	              var zoomLayer = gd._fullLayout._zoomlayer;
	              var scaleX;
	              var scaleY;
	              this.dragOptions = {
	                element: dragger,
	                gd,
	                plotinfo: {
	                  id: _this.id,
	                  domain: gd._fullLayout[_this.id].domain,
	                  xaxis: _this.xaxis,
	                  yaxis: _this.yaxis
	                },
	                subplot: _this.id,
	                prepFn: function(e, startX, startY) {
	                  _this.dragOptions.xaxes = [_this.xaxis];
	                  _this.dragOptions.yaxes = [_this.yaxis];
	                  scaleX = gd._fullLayout._invScaleX;
	                  scaleY = gd._fullLayout._invScaleY;
	                  var dragModeNow = _this.dragOptions.dragmode = gd._fullLayout.dragmode;
	                  if (freeMode(dragModeNow)) _this.dragOptions.minDrag = 1;
	                  else _this.dragOptions.minDrag = undefined;
	                  if (dragModeNow === "zoom") {
	                    _this.dragOptions.moveFn = zoomMove;
	                    _this.dragOptions.clickFn = clickZoomPan;
	                    _this.dragOptions.doneFn = zoomDone;
	                    zoomPrep(e, startX, startY);
	                  } else if (dragModeNow === "pan") {
	                    _this.dragOptions.moveFn = plotDrag;
	                    _this.dragOptions.clickFn = clickZoomPan;
	                    _this.dragOptions.doneFn = dragDone;
	                    panPrep();
	                    _this.clearOutline(gd);
	                  } else if (rectMode(dragModeNow) || freeMode(dragModeNow)) {
	                    prepSelect(e, startX, startY, _this.dragOptions, dragModeNow);
	                  }
	                }
	              };
	              var x0, y0, mins0, span0, mins, lum, path0, dimmed, zb, corners;
	              function makeUpdate(_mins) {
	                var attrs = {};
	                attrs[_this.id + ".aaxis.min"] = _mins.a;
	                attrs[_this.id + ".baxis.min"] = _mins.b;
	                attrs[_this.id + ".caxis.min"] = _mins.c;
	                return attrs;
	              }
	              function clickZoomPan(numClicks, evt) {
	                var clickMode = gd._fullLayout.clickmode;
	                removeZoombox(gd);
	                if (numClicks === 2) {
	                  gd.emit("plotly_doubleclick", null);
	                  Registry.call("_guiRelayout", gd, makeUpdate({
	                    a: 0,
	                    b: 0,
	                    c: 0
	                  }));
	                }
	                if (clickMode.indexOf("select") > -1 && numClicks === 1) {
	                  selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, _this.dragOptions);
	                }
	                if (clickMode.indexOf("event") > -1) {
	                  Fx.click(gd, evt, _this.id);
	                }
	              }
	              function zoomPrep(e, startX, startY) {
	                var dragBBox = dragger.getBoundingClientRect();
	                x0 = startX - dragBBox.left;
	                y0 = startY - dragBBox.top;
	                gd._fullLayout._calcInverseTransform(gd);
	                var inverse = gd._fullLayout._invTransform;
	                var transformedCoords = Lib.apply3DTransform(inverse)(x0, y0);
	                x0 = transformedCoords[0];
	                y0 = transformedCoords[1];
	                mins0 = {
	                  a: _this.aaxis.range[0],
	                  b: _this.baxis.range[1],
	                  c: _this.caxis.range[1]
	                };
	                mins = mins0;
	                span0 = _this.aaxis.range[1] - mins0.a;
	                lum = tinycolor(_this.graphDiv._fullLayout[_this.id].bgcolor).getLuminance();
	                path0 = "M0," + _this.h + "L" + _this.w / 2 + ", 0L" + _this.w + "," + _this.h + "Z";
	                dimmed = false;
	                zb = zoomLayer.append("path").attr("class", "zoombox").attr("transform", strTranslate(_this.x0, _this.y0)).style({
	                  fill: lum > 0.2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
	                  "stroke-width": 0
	                }).attr("d", path0);
	                corners = zoomLayer.append("path").attr("class", "zoombox-corners").attr("transform", strTranslate(_this.x0, _this.y0)).style({
	                  fill: Color.background,
	                  stroke: Color.defaultLine,
	                  "stroke-width": 1,
	                  opacity: 0
	                }).attr("d", "M0,0Z");
	                _this.clearOutline(gd);
	              }
	              function getAFrac(x, y) {
	                return 1 - y / _this.h;
	              }
	              function getBFrac(x, y) {
	                return 1 - (x + (_this.h - y) / Math.sqrt(3)) / _this.w;
	              }
	              function getCFrac(x, y) {
	                return (x - (_this.h - y) / Math.sqrt(3)) / _this.w;
	              }
	              function zoomMove(dx0, dy0) {
	                var x1 = x0 + dx0 * scaleX;
	                var y1 = y0 + dy0 * scaleY;
	                var afrac = Math.max(0, Math.min(1, getAFrac(x0, y0), getAFrac(x1, y1)));
	                var bfrac = Math.max(0, Math.min(1, getBFrac(x0, y0), getBFrac(x1, y1)));
	                var cfrac = Math.max(0, Math.min(1, getCFrac(x0, y0), getCFrac(x1, y1)));
	                var xLeft = (afrac / 2 + cfrac) * _this.w;
	                var xRight = (1 - afrac / 2 - bfrac) * _this.w;
	                var xCenter = (xLeft + xRight) / 2;
	                var xSpan = xRight - xLeft;
	                var yBottom = (1 - afrac) * _this.h;
	                var yTop = yBottom - xSpan / whRatio;
	                if (xSpan < constants.MINZOOM) {
	                  mins = mins0;
	                  zb.attr("d", path0);
	                  corners.attr("d", "M0,0Z");
	                } else {
	                  mins = {
	                    a: mins0.a + afrac * span0,
	                    b: mins0.b + bfrac * span0,
	                    c: mins0.c + cfrac * span0
	                  };
	                  zb.attr("d", path0 + "M" + xLeft + "," + yBottom + "H" + xRight + "L" + xCenter + "," + yTop + "L" + xLeft + "," + yBottom + "Z");
	                  corners.attr("d", "M" + x0 + "," + y0 + STARTMARKER + "M" + xLeft + "," + yBottom + BLPATH + "M" + xRight + "," + yBottom + BRPATH + "M" + xCenter + "," + yTop + TOPPATH);
	                }
	                if (!dimmed) {
	                  zb.transition().style("fill", lum > 0.2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200);
	                  corners.transition().style("opacity", 1).duration(200);
	                  dimmed = true;
	                }
	                gd.emit("plotly_relayouting", makeUpdate(mins));
	              }
	              function zoomDone() {
	                removeZoombox(gd);
	                if (mins === mins0) return;
	                Registry.call("_guiRelayout", gd, makeUpdate(mins));
	                if (SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
	                  Lib.notifier(_(gd, "Double-click to zoom back out"), "long");
	                  SHOWZOOMOUTTIP = false;
	                }
	              }
	              function panPrep() {
	                mins0 = {
	                  a: _this.aaxis.range[0],
	                  b: _this.baxis.range[1],
	                  c: _this.caxis.range[1]
	                };
	                mins = mins0;
	              }
	              function plotDrag(dx, dy) {
	                var dxScaled = dx / _this.xaxis._m;
	                var dyScaled = dy / _this.yaxis._m;
	                mins = {
	                  a: mins0.a - dyScaled,
	                  b: mins0.b + (dxScaled + dyScaled) / 2,
	                  c: mins0.c - (dxScaled - dyScaled) / 2
	                };
	                var minsorted = [mins.a, mins.b, mins.c].sort(Lib.sorterAsc);
	                var minindices = {
	                  a: minsorted.indexOf(mins.a),
	                  b: minsorted.indexOf(mins.b),
	                  c: minsorted.indexOf(mins.c)
	                };
	                if (minsorted[0] < 0) {
	                  if (minsorted[1] + minsorted[0] / 2 < 0) {
	                    minsorted[2] += minsorted[0] + minsorted[1];
	                    minsorted[0] = minsorted[1] = 0;
	                  } else {
	                    minsorted[2] += minsorted[0] / 2;
	                    minsorted[1] += minsorted[0] / 2;
	                    minsorted[0] = 0;
	                  }
	                  mins = {
	                    a: minsorted[minindices.a],
	                    b: minsorted[minindices.b],
	                    c: minsorted[minindices.c]
	                  };
	                  dy = (mins0.a - mins.a) * _this.yaxis._m;
	                  dx = (mins0.c - mins.c - mins0.b + mins.b) * _this.xaxis._m;
	                }
	                var plotTransform = strTranslate(_this.x0 + dx, _this.y0 + dy);
	                _this.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", plotTransform);
	                var plotTransform2 = strTranslate(-dx, -dy);
	                _this.clipDefRelative.select("path").attr("transform", plotTransform2);
	                _this.aaxis.range = [mins.a, _this.sum - mins.b - mins.c];
	                _this.baxis.range = [_this.sum - mins.a - mins.c, mins.b];
	                _this.caxis.range = [_this.sum - mins.a - mins.b, mins.c];
	                _this.drawAxes(false);
	                if (_this._hasClipOnAxisFalse) {
	                  _this.plotContainer.select(".scatterlayer").selectAll(".trace").call(Drawing.hideOutsideRangePoints, _this);
	                }
	                gd.emit("plotly_relayouting", makeUpdate(mins));
	              }
	              function dragDone() {
	                Registry.call("_guiRelayout", gd, makeUpdate(mins));
	              }
	              dragger.onmousemove = function(evt) {
	                Fx.hover(gd, evt, _this.id);
	                gd._fullLayout._lasthover = dragger;
	                gd._fullLayout._hoversubplot = _this.id;
	              };
	              dragger.onmouseout = function(evt) {
	                if (gd._dragging) return;
	                dragElement.unhover(gd, evt);
	              };
	              dragElement.init(this.dragOptions);
	            };
	            function removeZoombox(gd) {
	              d3.select(gd).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
	            }
	          }
	        ),
	        /***/
	        73972: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Loggers = __webpack_require__2(47769);
	            var noop = __webpack_require__2(64213);
	            var pushUnique = __webpack_require__2(75138);
	            var isPlainObject = __webpack_require__2(41965);
	            var addStyleRule = __webpack_require__2(24401).addStyleRule;
	            var ExtendModule = __webpack_require__2(1426);
	            var basePlotAttributes = __webpack_require__2(9012);
	            var baseLayoutAttributes = __webpack_require__2(10820);
	            var extendFlat = ExtendModule.extendFlat;
	            var extendDeepAll = ExtendModule.extendDeepAll;
	            exports2.modules = {};
	            exports2.allCategories = {};
	            exports2.allTypes = [];
	            exports2.subplotsRegistry = {};
	            exports2.transformsRegistry = {};
	            exports2.componentsRegistry = {};
	            exports2.layoutArrayContainers = [];
	            exports2.layoutArrayRegexes = [];
	            exports2.traceLayoutAttributes = {};
	            exports2.localeRegistry = {};
	            exports2.apiMethodRegistry = {};
	            exports2.collectableSubplotTypes = null;
	            exports2.register = function register(_modules) {
	              exports2.collectableSubplotTypes = null;
	              if (!_modules) {
	                throw new Error("No argument passed to Plotly.register.");
	              } else if (_modules && !Array.isArray(_modules)) {
	                _modules = [_modules];
	              }
	              for (var i = 0; i < _modules.length; i++) {
	                var newModule = _modules[i];
	                if (!newModule) {
	                  throw new Error("Invalid module was attempted to be registered!");
	                }
	                switch (newModule.moduleType) {
	                  case "trace":
	                    registerTraceModule(newModule);
	                    break;
	                  case "transform":
	                    registerTransformModule(newModule);
	                    break;
	                  case "component":
	                    registerComponentModule(newModule);
	                    break;
	                  case "locale":
	                    registerLocale(newModule);
	                    break;
	                  case "apiMethod":
	                    var name2 = newModule.name;
	                    exports2.apiMethodRegistry[name2] = newModule.fn;
	                    break;
	                  default:
	                    throw new Error("Invalid module was attempted to be registered!");
	                }
	              }
	            };
	            exports2.getModule = function(trace) {
	              var _module = exports2.modules[getTraceType(trace)];
	              if (!_module) return false;
	              return _module._module;
	            };
	            exports2.traceIs = function(traceType, category) {
	              traceType = getTraceType(traceType);
	              if (traceType === "various") return false;
	              var _module = exports2.modules[traceType];
	              if (!_module) {
	                if (traceType) {
	                  Loggers.log("Unrecognized trace type " + traceType + ".");
	                }
	                _module = exports2.modules[basePlotAttributes.type.dflt];
	              }
	              return !!_module.categories[category];
	            };
	            exports2.getTransformIndices = function(data, type) {
	              var indices = [];
	              var transforms = data.transforms || [];
	              for (var i = 0; i < transforms.length; i++) {
	                if (transforms[i].type === type) {
	                  indices.push(i);
	                }
	              }
	              return indices;
	            };
	            exports2.hasTransform = function(data, type) {
	              var transforms = data.transforms || [];
	              for (var i = 0; i < transforms.length; i++) {
	                if (transforms[i].type === type) {
	                  return true;
	                }
	              }
	              return false;
	            };
	            exports2.getComponentMethod = function(name2, method) {
	              var _module = exports2.componentsRegistry[name2];
	              if (!_module) return noop;
	              return _module[method] || noop;
	            };
	            exports2.call = function() {
	              var name2 = arguments[0];
	              var args = [].slice.call(arguments, 1);
	              return exports2.apiMethodRegistry[name2].apply(null, args);
	            };
	            function registerTraceModule(_module) {
	              var thisType = _module.name;
	              var categoriesIn = _module.categories;
	              var meta = _module.meta;
	              if (exports2.modules[thisType]) {
	                Loggers.log("Type " + thisType + " already registered");
	                return;
	              }
	              if (!exports2.subplotsRegistry[_module.basePlotModule.name]) {
	                registerSubplot(_module.basePlotModule);
	              }
	              var categoryObj = {};
	              for (var i = 0; i < categoriesIn.length; i++) {
	                categoryObj[categoriesIn[i]] = true;
	                exports2.allCategories[categoriesIn[i]] = true;
	              }
	              exports2.modules[thisType] = {
	                _module,
	                categories: categoryObj
	              };
	              if (meta && Object.keys(meta).length) {
	                exports2.modules[thisType].meta = meta;
	              }
	              exports2.allTypes.push(thisType);
	              for (var componentName in exports2.componentsRegistry) {
	                mergeComponentAttrsToTrace(componentName, thisType);
	              }
	              if (_module.layoutAttributes) {
	                extendFlat(exports2.traceLayoutAttributes, _module.layoutAttributes);
	              }
	              var basePlotModule = _module.basePlotModule;
	              var bpmName = basePlotModule.name;
	              if (bpmName === "mapbox") {
	                var styleRules = basePlotModule.constants.styleRules;
	                for (var k in styleRules) {
	                  addStyleRule(".js-plotly-plot .plotly .mapboxgl-" + k, styleRules[k]);
	                }
	              }
	              if ((bpmName === "geo" || bpmName === "mapbox") && window.PlotlyGeoAssets === undefined) {
	                window.PlotlyGeoAssets = {
	                  topojson: {}
	                };
	              }
	            }
	            function registerSubplot(_module) {
	              var plotType = _module.name;
	              if (exports2.subplotsRegistry[plotType]) {
	                Loggers.log("Plot type " + plotType + " already registered.");
	                return;
	              }
	              findArrayRegexps(_module);
	              exports2.subplotsRegistry[plotType] = _module;
	              for (var componentName in exports2.componentsRegistry) {
	                mergeComponentAttrsToSubplot(componentName, _module.name);
	              }
	            }
	            function registerComponentModule(_module) {
	              if (typeof _module.name !== "string") {
	                throw new Error("Component module *name* must be a string.");
	              }
	              var name2 = _module.name;
	              exports2.componentsRegistry[name2] = _module;
	              if (_module.layoutAttributes) {
	                if (_module.layoutAttributes._isLinkedToArray) {
	                  pushUnique(exports2.layoutArrayContainers, name2);
	                }
	                findArrayRegexps(_module);
	              }
	              for (var traceType in exports2.modules) {
	                mergeComponentAttrsToTrace(name2, traceType);
	              }
	              for (var subplotName in exports2.subplotsRegistry) {
	                mergeComponentAttrsToSubplot(name2, subplotName);
	              }
	              for (var transformType in exports2.transformsRegistry) {
	                mergeComponentAttrsToTransform(name2, transformType);
	              }
	              if (_module.schema && _module.schema.layout) {
	                extendDeepAll(baseLayoutAttributes, _module.schema.layout);
	              }
	            }
	            function registerTransformModule(_module) {
	              if (typeof _module.name !== "string") {
	                throw new Error("Transform module *name* must be a string.");
	              }
	              var prefix = "Transform module " + _module.name;
	              var hasTransform = typeof _module.transform === "function";
	              var hasCalcTransform = typeof _module.calcTransform === "function";
	              if (!hasTransform && !hasCalcTransform) {
	                throw new Error(prefix + " is missing a *transform* or *calcTransform* method.");
	              }
	              if (hasTransform && hasCalcTransform) {
	                Loggers.log([prefix + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" "));
	              }
	              if (!isPlainObject(_module.attributes)) {
	                Loggers.log(prefix + " registered without an *attributes* object.");
	              }
	              if (typeof _module.supplyDefaults !== "function") {
	                Loggers.log(prefix + " registered without a *supplyDefaults* method.");
	              }
	              exports2.transformsRegistry[_module.name] = _module;
	              for (var componentName in exports2.componentsRegistry) {
	                mergeComponentAttrsToTransform(componentName, _module.name);
	              }
	            }
	            function registerLocale(_module) {
	              var locale = _module.name;
	              var baseLocale = locale.split("-")[0];
	              var newDict = _module.dictionary;
	              var newFormat = _module.format;
	              var hasDict = newDict && Object.keys(newDict).length;
	              var hasFormat = newFormat && Object.keys(newFormat).length;
	              var locales = exports2.localeRegistry;
	              var localeObj = locales[locale];
	              if (!localeObj) locales[locale] = localeObj = {};
	              if (baseLocale !== locale) {
	                var baseLocaleObj = locales[baseLocale];
	                if (!baseLocaleObj) locales[baseLocale] = baseLocaleObj = {};
	                if (hasDict && baseLocaleObj.dictionary === localeObj.dictionary) {
	                  baseLocaleObj.dictionary = newDict;
	                }
	                if (hasFormat && baseLocaleObj.format === localeObj.format) {
	                  baseLocaleObj.format = newFormat;
	                }
	              }
	              if (hasDict) localeObj.dictionary = newDict;
	              if (hasFormat) localeObj.format = newFormat;
	            }
	            function findArrayRegexps(_module) {
	              if (_module.layoutAttributes) {
	                var arrayAttrRegexps = _module.layoutAttributes._arrayAttrRegexps;
	                if (arrayAttrRegexps) {
	                  for (var i = 0; i < arrayAttrRegexps.length; i++) {
	                    pushUnique(exports2.layoutArrayRegexes, arrayAttrRegexps[i]);
	                  }
	                }
	              }
	            }
	            function mergeComponentAttrsToTrace(componentName, traceType) {
	              var componentSchema = exports2.componentsRegistry[componentName].schema;
	              if (!componentSchema || !componentSchema.traces) return;
	              var traceAttrs = componentSchema.traces[traceType];
	              if (traceAttrs) {
	                extendDeepAll(exports2.modules[traceType]._module.attributes, traceAttrs);
	              }
	            }
	            function mergeComponentAttrsToTransform(componentName, transformType) {
	              var componentSchema = exports2.componentsRegistry[componentName].schema;
	              if (!componentSchema || !componentSchema.transforms) return;
	              var transformAttrs = componentSchema.transforms[transformType];
	              if (transformAttrs) {
	                extendDeepAll(exports2.transformsRegistry[transformType].attributes, transformAttrs);
	              }
	            }
	            function mergeComponentAttrsToSubplot(componentName, subplotName) {
	              var componentSchema = exports2.componentsRegistry[componentName].schema;
	              if (!componentSchema || !componentSchema.subplots) return;
	              var subplotModule = exports2.subplotsRegistry[subplotName];
	              var subplotAttrs = subplotModule.layoutAttributes;
	              var subplotAttr = subplotModule.attr === "subplot" ? subplotModule.name : subplotModule.attr;
	              if (Array.isArray(subplotAttr)) subplotAttr = subplotAttr[0];
	              var componentLayoutAttrs = componentSchema.subplots[subplotAttr];
	              if (subplotAttrs && componentLayoutAttrs) {
	                extendDeepAll(subplotAttrs, componentLayoutAttrs);
	              }
	            }
	            function getTraceType(traceType) {
	              if (typeof traceType === "object") traceType = traceType.type;
	              return traceType;
	            }
	          }
	        ),
	        /***/
	        61914: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var extendFlat = Lib.extendFlat;
	            var extendDeep = Lib.extendDeep;
	            function cloneLayoutOverride(tileClass) {
	              var override;
	              switch (tileClass) {
	                case "themes__thumb":
	                  override = {
	                    autosize: true,
	                    width: 150,
	                    height: 150,
	                    title: {
	                      text: ""
	                    },
	                    showlegend: false,
	                    margin: {
	                      l: 5,
	                      r: 5,
	                      t: 5,
	                      b: 5,
	                      pad: 0
	                    },
	                    annotations: []
	                  };
	                  break;
	                case "thumbnail":
	                  override = {
	                    title: {
	                      text: ""
	                    },
	                    hidesources: true,
	                    showlegend: false,
	                    borderwidth: 0,
	                    bordercolor: "",
	                    margin: {
	                      l: 1,
	                      r: 1,
	                      t: 1,
	                      b: 1,
	                      pad: 0
	                    },
	                    annotations: []
	                  };
	                  break;
	                default:
	                  override = {};
	              }
	              return override;
	            }
	            function keyIsAxis(keyName) {
	              var types = ["xaxis", "yaxis", "zaxis"];
	              return types.indexOf(keyName.slice(0, 5)) > -1;
	            }
	            module2.exports = function clonePlot(graphObj, options) {
	              var i;
	              var oldData = graphObj.data;
	              var oldLayout = graphObj.layout;
	              var newData = extendDeep([], oldData);
	              var newLayout = extendDeep({}, oldLayout, cloneLayoutOverride(options.tileClass));
	              var context = graphObj._context || {};
	              if (options.width) newLayout.width = options.width;
	              if (options.height) newLayout.height = options.height;
	              if (options.tileClass === "thumbnail" || options.tileClass === "themes__thumb") {
	                newLayout.annotations = [];
	                var keys = Object.keys(newLayout);
	                for (i = 0; i < keys.length; i++) {
	                  if (keyIsAxis(keys[i])) {
	                    newLayout[keys[i]].title = {
	                      text: ""
	                    };
	                  }
	                }
	                for (i = 0; i < newData.length; i++) {
	                  var trace = newData[i];
	                  trace.showscale = false;
	                  if (trace.marker) trace.marker.showscale = false;
	                  if (Registry.traceIs(trace, "pie-like")) trace.textposition = "none";
	                }
	              }
	              if (Array.isArray(options.annotations)) {
	                for (i = 0; i < options.annotations.length; i++) {
	                  newLayout.annotations.push(options.annotations[i]);
	                }
	              }
	              var sceneIds = Object.keys(newLayout).filter(function(key) {
	                return key.match(/^scene\d*$/);
	              });
	              if (sceneIds.length) {
	                var axesImageOverride = {};
	                if (options.tileClass === "thumbnail") {
	                  axesImageOverride = {
	                    title: {
	                      text: ""
	                    },
	                    showaxeslabels: false,
	                    showticklabels: false,
	                    linetickenable: false
	                  };
	                }
	                for (i = 0; i < sceneIds.length; i++) {
	                  var scene = newLayout[sceneIds[i]];
	                  if (!scene.xaxis) {
	                    scene.xaxis = {};
	                  }
	                  if (!scene.yaxis) {
	                    scene.yaxis = {};
	                  }
	                  if (!scene.zaxis) {
	                    scene.zaxis = {};
	                  }
	                  extendFlat(scene.xaxis, axesImageOverride);
	                  extendFlat(scene.yaxis, axesImageOverride);
	                  extendFlat(scene.zaxis, axesImageOverride);
	                  scene._scene = null;
	                }
	              }
	              var gd = document.createElement("div");
	              if (options.tileClass) gd.className = options.tileClass;
	              var plotTile = {
	                gd,
	                td: gd,
	                // for external (image server) compatibility
	                layout: newLayout,
	                data: newData,
	                config: {
	                  staticPlot: options.staticPlot === undefined ? true : options.staticPlot,
	                  plotGlPixelRatio: options.plotGlPixelRatio === undefined ? 2 : options.plotGlPixelRatio,
	                  displaylogo: options.displaylogo || false,
	                  showLink: options.showLink || false,
	                  showTips: options.showTips || false,
	                  mapboxAccessToken: context.mapboxAccessToken
	                }
	              };
	              if (options.setBackground !== "transparent") {
	                plotTile.config.setBackground = options.setBackground || "opaque";
	              }
	              plotTile.gd.defaultLayout = cloneLayoutOverride(options.tileClass);
	              return plotTile;
	            };
	          }
	        ),
	        /***/
	        7239: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var toImage = __webpack_require__2(403);
	            var fileSaver = __webpack_require__2(22435);
	            var helpers = __webpack_require__2(25095);
	            function downloadImage(gd, opts) {
	              var _gd;
	              if (!Lib.isPlainObject(gd)) _gd = Lib.getGraphDiv(gd);
	              opts = opts || {};
	              opts.format = opts.format || "png";
	              opts.width = opts.width || null;
	              opts.height = opts.height || null;
	              opts.imageDataOnly = true;
	              return new Promise(function(resolve, reject) {
	                if (_gd && _gd._snapshotInProgress) {
	                  reject(new Error("Snapshotting already in progress."));
	                }
	                if (Lib.isIE() && opts.format !== "svg") {
	                  reject(new Error(helpers.MSG_IE_BAD_FORMAT));
	                }
	                if (_gd) _gd._snapshotInProgress = true;
	                var promise = toImage(gd, opts);
	                var filename = opts.filename || gd.fn || "newplot";
	                filename += "." + opts.format.replace("-", ".");
	                promise.then(function(result) {
	                  if (_gd) _gd._snapshotInProgress = false;
	                  return fileSaver(result, filename, opts.format);
	                }).then(function(name2) {
	                  resolve(name2);
	                }).catch(function(err) {
	                  if (_gd) _gd._snapshotInProgress = false;
	                  reject(err);
	                });
	              });
	            }
	            module2.exports = downloadImage;
	          }
	        ),
	        /***/
	        22435: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var helpers = __webpack_require__2(25095);
	            function fileSaver(url, name2, format) {
	              var saveLink = document.createElement("a");
	              var canUseSaveLink = "download" in saveLink;
	              var promise = new Promise(function(resolve, reject) {
	                var blob;
	                var objectUrl;
	                if (Lib.isIE()) {
	                  blob = helpers.createBlob(url, "svg");
	                  window.navigator.msSaveBlob(blob, name2);
	                  blob = null;
	                  return resolve(name2);
	                }
	                if (canUseSaveLink) {
	                  blob = helpers.createBlob(url, format);
	                  objectUrl = helpers.createObjectURL(blob);
	                  saveLink.href = objectUrl;
	                  saveLink.download = name2;
	                  document.body.appendChild(saveLink);
	                  saveLink.click();
	                  document.body.removeChild(saveLink);
	                  helpers.revokeObjectURL(objectUrl);
	                  blob = null;
	                  return resolve(name2);
	                }
	                if (Lib.isSafari()) {
	                  var prefix = format === "svg" ? "," : ";base64,";
	                  helpers.octetStream(prefix + encodeURIComponent(url));
	                  return resolve(name2);
	                }
	                reject(new Error("download error"));
	              });
	              return promise;
	            }
	            module2.exports = fileSaver;
	          }
	        ),
	        /***/
	        25095: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            exports2.getDelay = function(fullLayout) {
	              if (!fullLayout._has) return 0;
	              return fullLayout._has("gl3d") || fullLayout._has("gl2d") || fullLayout._has("mapbox") ? 500 : 0;
	            };
	            exports2.getRedrawFunc = function(gd) {
	              return function() {
	                Registry.getComponentMethod("colorbar", "draw")(gd);
	              };
	            };
	            exports2.encodeSVG = function(svg) {
	              return "data:image/svg+xml," + encodeURIComponent(svg);
	            };
	            exports2.encodeJSON = function(json) {
	              return "data:application/json," + encodeURIComponent(json);
	            };
	            var DOM_URL = window.URL || window.webkitURL;
	            exports2.createObjectURL = function(blob) {
	              return DOM_URL.createObjectURL(blob);
	            };
	            exports2.revokeObjectURL = function(url) {
	              return DOM_URL.revokeObjectURL(url);
	            };
	            exports2.createBlob = function(url, format) {
	              if (format === "svg") {
	                return new window.Blob([url], {
	                  type: "image/svg+xml;charset=utf-8"
	                });
	              } else if (format === "full-json") {
	                return new window.Blob([url], {
	                  type: "application/json;charset=utf-8"
	                });
	              } else {
	                var binary = fixBinary(window.atob(url));
	                return new window.Blob([binary], {
	                  type: "image/" + format
	                });
	              }
	            };
	            exports2.octetStream = function(s) {
	              document.location.href = "data:application/octet-stream" + s;
	            };
	            function fixBinary(b) {
	              var len = b.length;
	              var buf = new ArrayBuffer(len);
	              var arr = new Uint8Array(buf);
	              for (var i = 0; i < len; i++) {
	                arr[i] = b.charCodeAt(i);
	              }
	              return buf;
	            }
	            exports2.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
	            exports2.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
	          }
	        ),
	        /***/
	        44511: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var helpers = __webpack_require__2(25095);
	            var Snapshot = {
	              getDelay: helpers.getDelay,
	              getRedrawFunc: helpers.getRedrawFunc,
	              clone: __webpack_require__2(61914),
	              toSVG: __webpack_require__2(5900),
	              svgToImg: __webpack_require__2(70942),
	              toImage: __webpack_require__2(56395),
	              downloadImage: __webpack_require__2(7239)
	            };
	            module2.exports = Snapshot;
	          }
	        ),
	        /***/
	        70942: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var EventEmitter = __webpack_require__2(15398).EventEmitter;
	            var helpers = __webpack_require__2(25095);
	            function svgToImg(opts) {
	              var ev = opts.emitter || new EventEmitter();
	              var promise = new Promise(function(resolve, reject) {
	                var Image2 = window.Image;
	                var svg = opts.svg;
	                var format = opts.format || "png";
	                if (Lib.isIE() && format !== "svg") {
	                  var ieSvgError = new Error(helpers.MSG_IE_BAD_FORMAT);
	                  reject(ieSvgError);
	                  if (!opts.promise) {
	                    return ev.emit("error", ieSvgError);
	                  } else {
	                    return promise;
	                  }
	                }
	                var canvas = opts.canvas;
	                var scale = opts.scale || 1;
	                var w0 = opts.width || 300;
	                var h0 = opts.height || 150;
	                var w1 = scale * w0;
	                var h1 = scale * h0;
	                var ctx = canvas.getContext("2d", {
	                  willReadFrequently: true
	                });
	                var img = new Image2();
	                var svgBlob, url;
	                if (format === "svg" || Lib.isSafari()) {
	                  url = helpers.encodeSVG(svg);
	                } else {
	                  svgBlob = helpers.createBlob(svg, "svg");
	                  url = helpers.createObjectURL(svgBlob);
	                }
	                canvas.width = w1;
	                canvas.height = h1;
	                img.onload = function() {
	                  var imgData;
	                  svgBlob = null;
	                  helpers.revokeObjectURL(url);
	                  if (format !== "svg") {
	                    ctx.drawImage(img, 0, 0, w1, h1);
	                  }
	                  switch (format) {
	                    case "jpeg":
	                      imgData = canvas.toDataURL("image/jpeg");
	                      break;
	                    case "png":
	                      imgData = canvas.toDataURL("image/png");
	                      break;
	                    case "webp":
	                      imgData = canvas.toDataURL("image/webp");
	                      break;
	                    case "svg":
	                      imgData = url;
	                      break;
	                    default:
	                      var errorMsg = "Image format is not jpeg, png, svg or webp.";
	                      reject(new Error(errorMsg));
	                      if (!opts.promise) {
	                        return ev.emit("error", errorMsg);
	                      }
	                  }
	                  resolve(imgData);
	                  if (!opts.promise) {
	                    ev.emit("success", imgData);
	                  }
	                };
	                img.onerror = function(err) {
	                  svgBlob = null;
	                  helpers.revokeObjectURL(url);
	                  reject(err);
	                  if (!opts.promise) {
	                    return ev.emit("error", err);
	                  }
	                };
	                img.src = url;
	              });
	              if (opts.promise) {
	                return promise;
	              }
	              return ev;
	            }
	            module2.exports = svgToImg;
	          }
	        ),
	        /***/
	        56395: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var EventEmitter = __webpack_require__2(15398).EventEmitter;
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var helpers = __webpack_require__2(25095);
	            var clonePlot = __webpack_require__2(61914);
	            var toSVG = __webpack_require__2(5900);
	            var svgToImg = __webpack_require__2(70942);
	            function toImage(gd, opts) {
	              var ev = new EventEmitter();
	              var clone = clonePlot(gd, {
	                format: "png"
	              });
	              var clonedGd = clone.gd;
	              clonedGd.style.position = "absolute";
	              clonedGd.style.left = "-5000px";
	              document.body.appendChild(clonedGd);
	              function wait() {
	                var delay = helpers.getDelay(clonedGd._fullLayout);
	                setTimeout(function() {
	                  var svg = toSVG(clonedGd);
	                  var canvas = document.createElement("canvas");
	                  canvas.id = Lib.randstr();
	                  ev = svgToImg({
	                    format: opts.format,
	                    width: clonedGd._fullLayout.width,
	                    height: clonedGd._fullLayout.height,
	                    canvas,
	                    emitter: ev,
	                    svg
	                  });
	                  ev.clean = function() {
	                    if (clonedGd) document.body.removeChild(clonedGd);
	                  };
	                }, delay);
	              }
	              var redrawFunc = helpers.getRedrawFunc(clonedGd);
	              Registry.call("_doPlot", clonedGd, clone.data, clone.layout, clone.config).then(redrawFunc).then(wait).catch(function(err) {
	                ev.emit("error", err);
	              });
	              return ev;
	            }
	            module2.exports = toImage;
	          }
	        ),
	        /***/
	        5900: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var DOUBLEQUOTE_REGEX = /"/g;
	            var DUMMY_SUB = "TOBESTRIPPED";
	            var DUMMY_REGEX = new RegExp('("' + DUMMY_SUB + ")|(" + DUMMY_SUB + '")', "g");
	            function htmlEntityDecode(s) {
	              var hiddenDiv = d3.select("body").append("div").style({
	                display: "none"
	              }).html("");
	              var replaced = s.replace(/(&[^;]*;)/gi, function(d) {
	                if (d === "&lt;") {
	                  return "&#60;";
	                }
	                if (d === "&rt;") {
	                  return "&#62;";
	                }
	                if (d.indexOf("<") !== -1 || d.indexOf(">") !== -1) {
	                  return "";
	                }
	                return hiddenDiv.html(d).text();
	              });
	              hiddenDiv.remove();
	              return replaced;
	            }
	            function xmlEntityEncode(str) {
	              return str.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;");
	            }
	            module2.exports = function toSVG(gd, format, scale) {
	              var fullLayout = gd._fullLayout;
	              var svg = fullLayout._paper;
	              var toppaper = fullLayout._toppaper;
	              var width = fullLayout.width;
	              var height = fullLayout.height;
	              var i;
	              svg.insert("rect", ":first-child").call(Drawing.setRect, 0, 0, width, height).call(Color.fill, fullLayout.paper_bgcolor);
	              var basePlotModules = fullLayout._basePlotModules || [];
	              for (i = 0; i < basePlotModules.length; i++) {
	                var _module = basePlotModules[i];
	                if (_module.toSVG) _module.toSVG(gd);
	              }
	              if (toppaper) {
	                var nodes = toppaper.node().childNodes;
	                var topGroups = Array.prototype.slice.call(nodes);
	                for (i = 0; i < topGroups.length; i++) {
	                  var topGroup = topGroups[i];
	                  if (topGroup.childNodes.length) svg.node().appendChild(topGroup);
	                }
	              }
	              if (fullLayout._draggers) {
	                fullLayout._draggers.remove();
	              }
	              svg.node().style.background = "";
	              svg.selectAll("text").attr({
	                "data-unformatted": null,
	                "data-math": null
	              }).each(function() {
	                var txt = d3.select(this);
	                if (this.style.visibility === "hidden" || this.style.display === "none") {
	                  txt.remove();
	                  return;
	                } else {
	                  txt.style({
	                    visibility: null,
	                    display: null
	                  });
	                }
	                var ff = this.style.fontFamily;
	                if (ff && ff.indexOf('"') !== -1) {
	                  txt.style("font-family", ff.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
	                }
	              });
	              svg.selectAll(".gradient_filled,.pattern_filled").each(function() {
	                var pt = d3.select(this);
	                var fill = this.style.fill;
	                if (fill && fill.indexOf("url(") !== -1) {
	                  pt.style("fill", fill.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
	                }
	                var stroke = this.style.stroke;
	                if (stroke && stroke.indexOf("url(") !== -1) {
	                  pt.style("stroke", stroke.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
	                }
	              });
	              if (format === "pdf" || format === "eps") {
	                svg.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0);
	              }
	              svg.node().setAttributeNS(xmlnsNamespaces.xmlns, "xmlns", xmlnsNamespaces.svg);
	              svg.node().setAttributeNS(xmlnsNamespaces.xmlns, "xmlns:xlink", xmlnsNamespaces.xlink);
	              if (format === "svg" && scale) {
	                svg.attr("width", scale * width);
	                svg.attr("height", scale * height);
	                svg.attr("viewBox", "0 0 " + width + " " + height);
	              }
	              var s = new window.XMLSerializer().serializeToString(svg.node());
	              s = htmlEntityDecode(s);
	              s = xmlEntityEncode(s);
	              s = s.replace(DUMMY_REGEX, "'");
	              if (Lib.isIE()) {
	                s = s.replace(/"/gi, "'");
	                s = s.replace(/(\('#)([^']*)('\))/gi, '("#$2")');
	                s = s.replace(/(\\')/gi, '"');
	              }
	              return s;
	            };
	          }
	        ),
	        /***/
	        75341: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function arraysToCalcdata(cd, trace) {
	              for (var i = 0; i < cd.length; i++) cd[i].i = i;
	              Lib.mergeArray(trace.text, cd, "tx");
	              Lib.mergeArray(trace.hovertext, cd, "htx");
	              var marker = trace.marker;
	              if (marker) {
	                Lib.mergeArray(marker.opacity, cd, "mo", true);
	                Lib.mergeArray(marker.color, cd, "mc");
	                var markerLine = marker.line;
	                if (markerLine) {
	                  Lib.mergeArray(markerLine.color, cd, "mlc");
	                  Lib.mergeArrayCastPositive(markerLine.width, cd, "mlw");
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        1486: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterAttrs = __webpack_require__2(82196);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var fontAttrs = __webpack_require__2(41940);
	            var constants = __webpack_require__2(97313);
	            var pattern = __webpack_require__2(79952).u;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var textFontAttrs = fontAttrs({
	              editType: "calc",
	              arrayOk: true,
	              colorEditType: "style"
	            });
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            var markerLineWidth = extendFlat({}, scatterMarkerLineAttrs.width, {
	              dflt: 0
	            });
	            var markerLine = extendFlat({
	              width: markerLineWidth,
	              editType: "calc"
	            }, colorScaleAttrs("marker.line"));
	            var marker = extendFlat({
	              line: markerLine,
	              editType: "calc"
	            }, colorScaleAttrs("marker"), {
	              opacity: {
	                valType: "number",
	                arrayOk: true,
	                dflt: 1,
	                min: 0,
	                max: 1,
	                editType: "style"
	              },
	              pattern
	            });
	            module2.exports = {
	              x: scatterAttrs.x,
	              x0: scatterAttrs.x0,
	              dx: scatterAttrs.dx,
	              y: scatterAttrs.y,
	              y0: scatterAttrs.y0,
	              dy: scatterAttrs.dy,
	              xperiod: scatterAttrs.xperiod,
	              yperiod: scatterAttrs.yperiod,
	              xperiod0: scatterAttrs.xperiod0,
	              yperiod0: scatterAttrs.yperiod0,
	              xperiodalignment: scatterAttrs.xperiodalignment,
	              yperiodalignment: scatterAttrs.yperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              text: scatterAttrs.text,
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: constants.eventDataKeys
	              }),
	              hovertext: scatterAttrs.hovertext,
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              textposition: {
	                valType: "enumerated",
	                values: ["inside", "outside", "auto", "none"],
	                dflt: "auto",
	                arrayOk: true,
	                editType: "calc"
	              },
	              insidetextanchor: {
	                valType: "enumerated",
	                values: ["end", "middle", "start"],
	                dflt: "end",
	                editType: "plot"
	              },
	              textangle: {
	                valType: "angle",
	                dflt: "auto",
	                editType: "plot"
	              },
	              textfont: extendFlat({}, textFontAttrs, {}),
	              insidetextfont: extendFlat({}, textFontAttrs, {}),
	              outsidetextfont: extendFlat({}, textFontAttrs, {}),
	              constraintext: {
	                valType: "enumerated",
	                values: ["inside", "outside", "both", "none"],
	                dflt: "both",
	                editType: "calc"
	              },
	              cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {}),
	              orientation: {
	                valType: "enumerated",
	                values: ["v", "h"],
	                editType: "calc+clearAxisTypes"
	              },
	              base: {
	                valType: "any",
	                dflt: null,
	                arrayOk: true,
	                editType: "calc"
	              },
	              offset: {
	                valType: "number",
	                dflt: null,
	                arrayOk: true,
	                editType: "calc"
	              },
	              width: {
	                valType: "number",
	                dflt: null,
	                min: 0,
	                arrayOk: true,
	                editType: "calc"
	              },
	              marker,
	              offsetgroup: scatterAttrs.offsetgroup,
	              alignmentgroup: scatterAttrs.alignmentgroup,
	              selected: {
	                marker: {
	                  opacity: scatterAttrs.selected.marker.opacity,
	                  color: scatterAttrs.selected.marker.color,
	                  editType: "style"
	                },
	                textfont: scatterAttrs.selected.textfont,
	                editType: "style"
	              },
	              unselected: {
	                marker: {
	                  opacity: scatterAttrs.unselected.marker.opacity,
	                  color: scatterAttrs.unselected.marker.color,
	                  editType: "style"
	                },
	                textfont: scatterAttrs.unselected.textfont,
	                editType: "style"
	              },
	              _deprecated: {
	                bardir: {
	                  valType: "enumerated",
	                  editType: "calc",
	                  values: ["v", "h"]
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        92290: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleCalc = __webpack_require__2(78803);
	            var arraysToCalcdata = __webpack_require__2(75341);
	            var calcSelection = __webpack_require__2(66279);
	            module2.exports = function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis || "x");
	              var ya = Axes.getFromId(gd, trace.yaxis || "y");
	              var size, pos, origPos, pObj, hasPeriod, pLetter;
	              var sizeOpts = {
	                msUTC: !!(trace.base || trace.base === 0)
	              };
	              if (trace.orientation === "h") {
	                size = xa.makeCalcdata(trace, "x", sizeOpts);
	                origPos = ya.makeCalcdata(trace, "y");
	                pObj = alignPeriod(trace, ya, "y", origPos);
	                hasPeriod = !!trace.yperiodalignment;
	                pLetter = "y";
	              } else {
	                size = ya.makeCalcdata(trace, "y", sizeOpts);
	                origPos = xa.makeCalcdata(trace, "x");
	                pObj = alignPeriod(trace, xa, "x", origPos);
	                hasPeriod = !!trace.xperiodalignment;
	                pLetter = "x";
	              }
	              pos = pObj.vals;
	              var serieslen = Math.min(pos.length, size.length);
	              var cd = new Array(serieslen);
	              for (var i = 0; i < serieslen; i++) {
	                cd[i] = {
	                  p: pos[i],
	                  s: size[i]
	                };
	                if (hasPeriod) {
	                  cd[i].orig_p = origPos[i];
	                  cd[i][pLetter + "End"] = pObj.ends[i];
	                  cd[i][pLetter + "Start"] = pObj.starts[i];
	                }
	                if (trace.ids) {
	                  cd[i].id = String(trace.ids[i]);
	                }
	              }
	              if (hasColorscale(trace, "marker")) {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.marker.color,
	                  containerStr: "marker",
	                  cLetter: "c"
	                });
	              }
	              if (hasColorscale(trace, "marker.line")) {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.marker.line.color,
	                  containerStr: "marker.line",
	                  cLetter: "c"
	                });
	              }
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        97313: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // padding in pixels around text
	              TEXTPAD: 3,
	              // 'value' and 'label' are not really necessary for bar traces,
	              // but they were made available to `texttemplate` (maybe by accident)
	              // via tokens `%{value}` and `%{label}` starting in 1.50.0,
	              // so let's include them in the event data also.
	              eventDataKeys: ["value", "label"]
	            };
	          }
	        ),
	        /***/
	        11661: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var getAxisGroup = __webpack_require__2(99082).getAxisGroup;
	            var Sieve = __webpack_require__2(61546);
	            function crossTraceCalc(gd, plotinfo) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var fullLayout = gd._fullLayout;
	              var fullTraces = gd._fullData;
	              var calcTraces = gd.calcdata;
	              var calcTracesHorz = [];
	              var calcTracesVert = [];
	              for (var i = 0; i < fullTraces.length; i++) {
	                var fullTrace = fullTraces[i];
	                if (fullTrace.visible === true && Registry.traceIs(fullTrace, "bar") && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id) {
	                  if (fullTrace.orientation === "h") {
	                    calcTracesHorz.push(calcTraces[i]);
	                  } else {
	                    calcTracesVert.push(calcTraces[i]);
	                  }
	                  if (fullTrace._computePh) {
	                    var cd = gd.calcdata[i];
	                    for (var j = 0; j < cd.length; j++) {
	                      if (typeof cd[j].ph0 === "function") cd[j].ph0 = cd[j].ph0();
	                      if (typeof cd[j].ph1 === "function") cd[j].ph1 = cd[j].ph1();
	                    }
	                  }
	                }
	              }
	              var opts = {
	                xCat: xa.type === "category" || xa.type === "multicategory",
	                yCat: ya.type === "category" || ya.type === "multicategory",
	                mode: fullLayout.barmode,
	                norm: fullLayout.barnorm,
	                gap: fullLayout.bargap,
	                groupgap: fullLayout.bargroupgap
	              };
	              setGroupPositions(gd, xa, ya, calcTracesVert, opts);
	              setGroupPositions(gd, ya, xa, calcTracesHorz, opts);
	            }
	            function setGroupPositions(gd, pa, sa, calcTraces, opts) {
	              if (!calcTraces.length) return;
	              var excluded;
	              var included;
	              var i, calcTrace, fullTrace;
	              initBase(sa, calcTraces);
	              switch (opts.mode) {
	                case "overlay":
	                  setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts);
	                  break;
	                case "group":
	                  excluded = [];
	                  included = [];
	                  for (i = 0; i < calcTraces.length; i++) {
	                    calcTrace = calcTraces[i];
	                    fullTrace = calcTrace[0].trace;
	                    if (fullTrace.offset === undefined) included.push(calcTrace);
	                    else excluded.push(calcTrace);
	                  }
	                  if (included.length) {
	                    setGroupPositionsInGroupMode(gd, pa, sa, included, opts);
	                  }
	                  if (excluded.length) {
	                    setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
	                  }
	                  break;
	                case "stack":
	                case "relative":
	                  excluded = [];
	                  included = [];
	                  for (i = 0; i < calcTraces.length; i++) {
	                    calcTrace = calcTraces[i];
	                    fullTrace = calcTrace[0].trace;
	                    if (fullTrace.base === undefined) included.push(calcTrace);
	                    else excluded.push(calcTrace);
	                  }
	                  if (included.length) {
	                    setGroupPositionsInStackOrRelativeMode(gd, pa, sa, included, opts);
	                  }
	                  if (excluded.length) {
	                    setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
	                  }
	                  break;
	              }
	              collectExtents(calcTraces, pa);
	            }
	            function initBase(sa, calcTraces) {
	              var i, j;
	              for (i = 0; i < calcTraces.length; i++) {
	                var cd = calcTraces[i];
	                var trace = cd[0].trace;
	                var base = trace.type === "funnel" ? trace._base : trace.base;
	                var b;
	                var scalendar = trace.orientation === "h" ? trace.xcalendar : trace.ycalendar;
	                var d2c = sa.type === "category" || sa.type === "multicategory" ? function() {
	                  return null;
	                } : sa.d2c;
	                if (isArrayOrTypedArray(base)) {
	                  for (j = 0; j < Math.min(base.length, cd.length); j++) {
	                    b = d2c(base[j], 0, scalendar);
	                    if (isNumeric(b)) {
	                      cd[j].b = +b;
	                      cd[j].hasB = 1;
	                    } else cd[j].b = 0;
	                  }
	                  for (; j < cd.length; j++) {
	                    cd[j].b = 0;
	                  }
	                } else {
	                  b = d2c(base, 0, scalendar);
	                  var hasBase = isNumeric(b);
	                  b = hasBase ? b : 0;
	                  for (j = 0; j < cd.length; j++) {
	                    cd[j].b = b;
	                    if (hasBase) cd[j].hasB = 1;
	                  }
	                }
	              }
	            }
	            function setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts) {
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var sieve = new Sieve([calcTrace], {
	                  posAxis: pa,
	                  sepNegVal: false,
	                  overlapNoMerge: !opts.norm
	                });
	                setOffsetAndWidth(pa, sieve, opts);
	                if (opts.norm) {
	                  sieveBars(sieve);
	                  normalizeBars(sa, sieve, opts);
	                } else {
	                  setBaseAndTop(sa, sieve);
	                }
	              }
	            }
	            function setGroupPositionsInGroupMode(gd, pa, sa, calcTraces, opts) {
	              var sieve = new Sieve(calcTraces, {
	                posAxis: pa,
	                sepNegVal: false,
	                overlapNoMerge: !opts.norm
	              });
	              setOffsetAndWidthInGroupMode(gd, pa, sieve, opts);
	              unhideBarsWithinTrace(sieve, pa);
	              if (opts.norm) {
	                sieveBars(sieve);
	                normalizeBars(sa, sieve, opts);
	              } else {
	                setBaseAndTop(sa, sieve);
	              }
	            }
	            function setGroupPositionsInStackOrRelativeMode(gd, pa, sa, calcTraces, opts) {
	              var sieve = new Sieve(calcTraces, {
	                posAxis: pa,
	                sepNegVal: opts.mode === "relative",
	                overlapNoMerge: !(opts.norm || opts.mode === "stack" || opts.mode === "relative")
	              });
	              setOffsetAndWidth(pa, sieve, opts);
	              stackBars(sa, sieve, opts);
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                for (var j = 0; j < calcTrace.length; j++) {
	                  var bar = calcTrace[j];
	                  if (bar.s !== BADNUM) {
	                    var isOutmostBar = bar.b + bar.s === sieve.get(bar.p, bar.s);
	                    if (isOutmostBar) bar._outmost = true;
	                  }
	                }
	              }
	              if (opts.norm) normalizeBars(sa, sieve, opts);
	            }
	            function setOffsetAndWidth(pa, sieve, opts) {
	              var minDiff = sieve.minDiff;
	              var calcTraces = sieve.traces;
	              var barGroupWidth = minDiff * (1 - opts.gap);
	              var barWidthPlusGap = barGroupWidth;
	              var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
	              var offsetFromCenter = -barWidth / 2;
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var t = calcTrace[0].t;
	                t.barwidth = barWidth;
	                t.poffset = offsetFromCenter;
	                t.bargroupwidth = barGroupWidth;
	                t.bardelta = minDiff;
	              }
	              sieve.binWidth = calcTraces[0][0].t.barwidth / 100;
	              applyAttributes(sieve);
	              setBarCenterAndWidth(pa, sieve);
	              updatePositionAxis(pa, sieve);
	            }
	            function setOffsetAndWidthInGroupMode(gd, pa, sieve, opts) {
	              var fullLayout = gd._fullLayout;
	              var positions = sieve.positions;
	              var distinctPositions = sieve.distinctPositions;
	              var minDiff = sieve.minDiff;
	              var calcTraces = sieve.traces;
	              var nTraces = calcTraces.length;
	              var overlap = positions.length !== distinctPositions.length;
	              var barGroupWidth = minDiff * (1 - opts.gap);
	              var groupId = getAxisGroup(fullLayout, pa._id) + calcTraces[0][0].trace.orientation;
	              var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
	              for (var i = 0; i < nTraces; i++) {
	                var calcTrace = calcTraces[i];
	                var trace = calcTrace[0].trace;
	                var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
	                var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
	                var barWidthPlusGap;
	                if (nOffsetGroups) {
	                  barWidthPlusGap = barGroupWidth / nOffsetGroups;
	                } else {
	                  barWidthPlusGap = overlap ? barGroupWidth / nTraces : barGroupWidth;
	                }
	                var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
	                var offsetFromCenter;
	                if (nOffsetGroups) {
	                  offsetFromCenter = ((2 * trace._offsetIndex + 1 - nOffsetGroups) * barWidthPlusGap - barWidth) / 2;
	                } else {
	                  offsetFromCenter = overlap ? ((2 * i + 1 - nTraces) * barWidthPlusGap - barWidth) / 2 : -barWidth / 2;
	                }
	                var t = calcTrace[0].t;
	                t.barwidth = barWidth;
	                t.poffset = offsetFromCenter;
	                t.bargroupwidth = barGroupWidth;
	                t.bardelta = minDiff;
	              }
	              sieve.binWidth = calcTraces[0][0].t.barwidth / 100;
	              applyAttributes(sieve);
	              setBarCenterAndWidth(pa, sieve);
	              updatePositionAxis(pa, sieve, overlap);
	            }
	            function applyAttributes(sieve) {
	              var calcTraces = sieve.traces;
	              var i, j;
	              for (i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var calcTrace0 = calcTrace[0];
	                var fullTrace = calcTrace0.trace;
	                var t = calcTrace0.t;
	                var offset = fullTrace._offset || fullTrace.offset;
	                var initialPoffset = t.poffset;
	                var newPoffset;
	                if (isArrayOrTypedArray(offset)) {
	                  newPoffset = Array.prototype.slice.call(offset, 0, calcTrace.length);
	                  for (j = 0; j < newPoffset.length; j++) {
	                    if (!isNumeric(newPoffset[j])) {
	                      newPoffset[j] = initialPoffset;
	                    }
	                  }
	                  for (j = newPoffset.length; j < calcTrace.length; j++) {
	                    newPoffset.push(initialPoffset);
	                  }
	                  t.poffset = newPoffset;
	                } else if (offset !== undefined) {
	                  t.poffset = offset;
	                }
	                var width = fullTrace._width || fullTrace.width;
	                var initialBarwidth = t.barwidth;
	                if (isArrayOrTypedArray(width)) {
	                  var newBarwidth = Array.prototype.slice.call(width, 0, calcTrace.length);
	                  for (j = 0; j < newBarwidth.length; j++) {
	                    if (!isNumeric(newBarwidth[j])) newBarwidth[j] = initialBarwidth;
	                  }
	                  for (j = newBarwidth.length; j < calcTrace.length; j++) {
	                    newBarwidth.push(initialBarwidth);
	                  }
	                  t.barwidth = newBarwidth;
	                  if (offset === undefined) {
	                    newPoffset = [];
	                    for (j = 0; j < calcTrace.length; j++) {
	                      newPoffset.push(initialPoffset + (initialBarwidth - newBarwidth[j]) / 2);
	                    }
	                    t.poffset = newPoffset;
	                  }
	                } else if (width !== undefined) {
	                  t.barwidth = width;
	                  if (offset === undefined) {
	                    t.poffset = initialPoffset + (initialBarwidth - width) / 2;
	                  }
	                }
	              }
	            }
	            function setBarCenterAndWidth(pa, sieve) {
	              var calcTraces = sieve.traces;
	              var pLetter = getAxisLetter(pa);
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var t = calcTrace[0].t;
	                var poffset = t.poffset;
	                var poffsetIsArray = Array.isArray(poffset);
	                var barwidth = t.barwidth;
	                var barwidthIsArray = Array.isArray(barwidth);
	                for (var j = 0; j < calcTrace.length; j++) {
	                  var calcBar = calcTrace[j];
	                  var width = calcBar.w = barwidthIsArray ? barwidth[j] : barwidth;
	                  if (calcBar.p === undefined) {
	                    calcBar.p = calcBar[pLetter];
	                    calcBar["orig_" + pLetter] = calcBar[pLetter];
	                  }
	                  var delta = (poffsetIsArray ? poffset[j] : poffset) + width / 2;
	                  calcBar[pLetter] = calcBar.p + delta;
	                }
	              }
	            }
	            function updatePositionAxis(pa, sieve, allowMinDtick) {
	              var calcTraces = sieve.traces;
	              var minDiff = sieve.minDiff;
	              var vpad = minDiff / 2;
	              Axes.minDtick(pa, sieve.minDiff, sieve.distinctPositions[0], allowMinDtick);
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var calcTrace0 = calcTrace[0];
	                var fullTrace = calcTrace0.trace;
	                var pts = [];
	                var bar, l, r, j;
	                for (j = 0; j < calcTrace.length; j++) {
	                  bar = calcTrace[j];
	                  l = bar.p - vpad;
	                  r = bar.p + vpad;
	                  pts.push(l, r);
	                }
	                if (fullTrace.width || fullTrace.offset) {
	                  var t = calcTrace0.t;
	                  var poffset = t.poffset;
	                  var barwidth = t.barwidth;
	                  var poffsetIsArray = Array.isArray(poffset);
	                  var barwidthIsArray = Array.isArray(barwidth);
	                  for (j = 0; j < calcTrace.length; j++) {
	                    bar = calcTrace[j];
	                    var calcBarOffset = poffsetIsArray ? poffset[j] : poffset;
	                    var calcBarWidth = barwidthIsArray ? barwidth[j] : barwidth;
	                    l = bar.p + calcBarOffset;
	                    r = l + calcBarWidth;
	                    pts.push(l, r);
	                  }
	                }
	                fullTrace._extremes[pa._id] = Axes.findExtremes(pa, pts, {
	                  padded: false
	                });
	              }
	            }
	            function setBaseAndTop(sa, sieve) {
	              var calcTraces = sieve.traces;
	              var sLetter = getAxisLetter(sa);
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var fullTrace = calcTrace[0].trace;
	                var isScatter = fullTrace.type === "scatter";
	                var isVertical = fullTrace.orientation === "v";
	                var pts = [];
	                var tozero = false;
	                for (var j = 0; j < calcTrace.length; j++) {
	                  var bar = calcTrace[j];
	                  var base = isScatter ? 0 : bar.b;
	                  var top = isScatter ? isVertical ? bar.y : bar.x : base + bar.s;
	                  bar[sLetter] = top;
	                  pts.push(top);
	                  if (bar.hasB) pts.push(base);
	                  if (!bar.hasB || !bar.b) {
	                    tozero = true;
	                  }
	                }
	                fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
	                  tozero,
	                  padded: true
	                });
	              }
	            }
	            function stackBars(sa, sieve, opts) {
	              var sLetter = getAxisLetter(sa);
	              var calcTraces = sieve.traces;
	              var calcTrace;
	              var fullTrace;
	              var isFunnel;
	              var i, j;
	              var bar;
	              for (i = 0; i < calcTraces.length; i++) {
	                calcTrace = calcTraces[i];
	                fullTrace = calcTrace[0].trace;
	                if (fullTrace.type === "funnel") {
	                  for (j = 0; j < calcTrace.length; j++) {
	                    bar = calcTrace[j];
	                    if (bar.s !== BADNUM) {
	                      sieve.put(bar.p, -0.5 * bar.s);
	                    }
	                  }
	                }
	              }
	              for (i = 0; i < calcTraces.length; i++) {
	                calcTrace = calcTraces[i];
	                fullTrace = calcTrace[0].trace;
	                isFunnel = fullTrace.type === "funnel";
	                var pts = [];
	                for (j = 0; j < calcTrace.length; j++) {
	                  bar = calcTrace[j];
	                  if (bar.s !== BADNUM) {
	                    var value;
	                    if (isFunnel) {
	                      value = bar.s;
	                    } else {
	                      value = bar.s + bar.b;
	                    }
	                    var base = sieve.put(bar.p, value);
	                    var top = base + value;
	                    bar.b = base;
	                    bar[sLetter] = top;
	                    if (!opts.norm) {
	                      pts.push(top);
	                      if (bar.hasB) {
	                        pts.push(base);
	                      }
	                    }
	                  }
	                }
	                if (!opts.norm) {
	                  fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
	                    // N.B. we don't stack base with 'base',
	                    // so set tozero:true always!
	                    tozero: true,
	                    padded: true
	                  });
	                }
	              }
	            }
	            function sieveBars(sieve) {
	              var calcTraces = sieve.traces;
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                for (var j = 0; j < calcTrace.length; j++) {
	                  var bar = calcTrace[j];
	                  if (bar.s !== BADNUM) {
	                    sieve.put(bar.p, bar.b + bar.s);
	                  }
	                }
	              }
	            }
	            function unhideBarsWithinTrace(sieve, pa) {
	              var calcTraces = sieve.traces;
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var fullTrace = calcTrace[0].trace;
	                if (fullTrace.base === undefined) {
	                  var inTraceSieve = new Sieve([calcTrace], {
	                    posAxis: pa,
	                    sepNegVal: true,
	                    overlapNoMerge: true
	                  });
	                  for (var j = 0; j < calcTrace.length; j++) {
	                    var bar = calcTrace[j];
	                    if (bar.p !== BADNUM) {
	                      var base = inTraceSieve.put(bar.p, bar.b + bar.s);
	                      if (base) bar.b = base;
	                    }
	                  }
	                }
	              }
	            }
	            function normalizeBars(sa, sieve, opts) {
	              var calcTraces = sieve.traces;
	              var sLetter = getAxisLetter(sa);
	              var sTop = opts.norm === "fraction" ? 1 : 100;
	              var sTiny = sTop / 1e9;
	              var sMin = sa.l2c(sa.c2l(0));
	              var sMax = opts.mode === "stack" ? sTop : sMin;
	              function needsPadding(v) {
	                return isNumeric(sa.c2l(v)) && (v < sMin - sTiny || v > sMax + sTiny || !isNumeric(sMin));
	              }
	              for (var i = 0; i < calcTraces.length; i++) {
	                var calcTrace = calcTraces[i];
	                var fullTrace = calcTrace[0].trace;
	                var pts = [];
	                var tozero = false;
	                var padded = false;
	                for (var j = 0; j < calcTrace.length; j++) {
	                  var bar = calcTrace[j];
	                  if (bar.s !== BADNUM) {
	                    var scale = Math.abs(sTop / sieve.get(bar.p, bar.s));
	                    bar.b *= scale;
	                    bar.s *= scale;
	                    var base = bar.b;
	                    var top = base + bar.s;
	                    bar[sLetter] = top;
	                    pts.push(top);
	                    padded = padded || needsPadding(top);
	                    if (bar.hasB) {
	                      pts.push(base);
	                      padded = padded || needsPadding(base);
	                    }
	                    if (!bar.hasB || !bar.b) {
	                      tozero = true;
	                    }
	                  }
	                }
	                fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
	                  tozero,
	                  padded
	                });
	              }
	            }
	            function collectExtents(calcTraces, pa) {
	              var pLetter = getAxisLetter(pa);
	              var extents = {};
	              var i, j, cd;
	              var pMin = Infinity;
	              var pMax = -Infinity;
	              for (i = 0; i < calcTraces.length; i++) {
	                cd = calcTraces[i];
	                for (j = 0; j < cd.length; j++) {
	                  var p = cd[j].p;
	                  if (isNumeric(p)) {
	                    pMin = Math.min(pMin, p);
	                    pMax = Math.max(pMax, p);
	                  }
	                }
	              }
	              var roundFactor = 1e4 / (pMax - pMin);
	              var round = extents.round = function(p2) {
	                return String(Math.round(roundFactor * (p2 - pMin)));
	              };
	              for (i = 0; i < calcTraces.length; i++) {
	                cd = calcTraces[i];
	                cd[0].t.extents = extents;
	                var poffset = cd[0].t.poffset;
	                var poffsetIsArray = Array.isArray(poffset);
	                for (j = 0; j < cd.length; j++) {
	                  var di = cd[j];
	                  var p0 = di[pLetter] - di.w / 2;
	                  if (isNumeric(p0)) {
	                    var p1 = di[pLetter] + di.w / 2;
	                    var pVal = round(di.p);
	                    if (extents[pVal]) {
	                      extents[pVal] = [Math.min(p0, extents[pVal][0]), Math.max(p1, extents[pVal][1])];
	                    } else {
	                      extents[pVal] = [p0, p1];
	                    }
	                  }
	                  di.p0 = di.p + (poffsetIsArray ? poffset[j] : poffset);
	                  di.p1 = di.p0 + di.w;
	                  di.s0 = di.b;
	                  di.s1 = di.s0 + di.s;
	                }
	              }
	            }
	            function getAxisLetter(ax) {
	              return ax._id.charAt(0);
	            }
	            module2.exports = {
	              crossTraceCalc,
	              setGroupPositions
	            };
	          }
	        ),
	        /***/
	        90769: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Registry = __webpack_require__2(73972);
	            var handleXYDefaults = __webpack_require__2(67513);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var handleStyleDefaults = __webpack_require__2(98340);
	            var handleGroupingDefaults = __webpack_require__2(26125);
	            var attributes = __webpack_require__2(1486);
	            var coerceFont = Lib.coerceFont;
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("orientation", traceOut.x && !traceOut.y ? "h" : "v");
	              coerce("base");
	              coerce("offset");
	              coerce("width");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var textposition = coerce("textposition");
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                moduleHasSelected: true,
	                moduleHasUnselected: true,
	                moduleHasConstrain: true,
	                moduleHasCliponaxis: true,
	                moduleHasTextangle: true,
	                moduleHasInsideanchor: true
	              });
	              handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
	              var lineColor = (traceOut.marker.line || {}).color;
	              var errorBarsSupplyDefaults = Registry.getComponentMethod("errorbars", "supplyDefaults");
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
	                axis: "y"
	              });
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
	                axis: "x",
	                inherit: "y"
	              });
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            }
	            function crossTraceDefaults(fullData, fullLayout) {
	              var traceIn, traceOut;
	              function coerce(attr) {
	                return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	              }
	              if (fullLayout.barmode === "group") {
	                for (var i = 0; i < fullData.length; i++) {
	                  traceOut = fullData[i];
	                  if (traceOut.type === "bar") {
	                    traceIn = traceOut._input;
	                    handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	                  }
	                }
	              }
	            }
	            function handleText(traceIn, traceOut, layout, coerce, textposition, opts) {
	              opts = opts || {};
	              var moduleHasSelected = !(opts.moduleHasSelected === false);
	              var moduleHasUnselected = !(opts.moduleHasUnselected === false);
	              var moduleHasConstrain = !(opts.moduleHasConstrain === false);
	              var moduleHasCliponaxis = !(opts.moduleHasCliponaxis === false);
	              var moduleHasTextangle = !(opts.moduleHasTextangle === false);
	              var moduleHasInsideanchor = !(opts.moduleHasInsideanchor === false);
	              var hasPathbar = !!opts.hasPathbar;
	              var hasBoth = Array.isArray(textposition) || textposition === "auto";
	              var hasInside = hasBoth || textposition === "inside";
	              var hasOutside = hasBoth || textposition === "outside";
	              if (hasInside || hasOutside) {
	                var dfltFont = coerceFont(coerce, "textfont", layout.font);
	                var insideTextFontDefault = Lib.extendFlat({}, dfltFont);
	                var isTraceTextfontColorSet = traceIn.textfont && traceIn.textfont.color;
	                var isColorInheritedFromLayoutFont = !isTraceTextfontColorSet;
	                if (isColorInheritedFromLayoutFont) {
	                  delete insideTextFontDefault.color;
	                }
	                coerceFont(coerce, "insidetextfont", insideTextFontDefault);
	                if (hasPathbar) {
	                  var pathbarTextFontDefault = Lib.extendFlat({}, dfltFont);
	                  if (isColorInheritedFromLayoutFont) {
	                    delete pathbarTextFontDefault.color;
	                  }
	                  coerceFont(coerce, "pathbar.textfont", pathbarTextFontDefault);
	                }
	                if (hasOutside) coerceFont(coerce, "outsidetextfont", dfltFont);
	                if (moduleHasSelected) coerce("selected.textfont.color");
	                if (moduleHasUnselected) coerce("unselected.textfont.color");
	                if (moduleHasConstrain) coerce("constraintext");
	                if (moduleHasCliponaxis) coerce("cliponaxis");
	                if (moduleHasTextangle) coerce("textangle");
	                coerce("texttemplate");
	              }
	              if (hasInside) {
	                if (moduleHasInsideanchor) coerce("insidetextanchor");
	              }
	            }
	            module2.exports = {
	              supplyDefaults,
	              crossTraceDefaults,
	              handleText
	            };
	          }
	        ),
	        /***/
	        58065: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt, trace) {
	              out.x = "xVal" in pt ? pt.xVal : pt.x;
	              out.y = "yVal" in pt ? pt.yVal : pt.y;
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              if (trace.orientation === "h") {
	                out.label = out.y;
	                out.value = out.x;
	              } else {
	                out.label = out.x;
	                out.value = out.y;
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        69383: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var tinycolor = __webpack_require__2(84267);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            exports2.coerceString = function(attributeDefinition, value, defaultValue) {
	              if (typeof value === "string") {
	                if (value || !attributeDefinition.noBlank) return value;
	              } else if (typeof value === "number" || value === true) {
	                if (!attributeDefinition.strict) return String(value);
	              }
	              return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
	            };
	            exports2.coerceNumber = function(attributeDefinition, value, defaultValue) {
	              if (isNumeric(value)) {
	                value = +value;
	                var min = attributeDefinition.min;
	                var max = attributeDefinition.max;
	                var isOutOfBounds = min !== undefined && value < min || max !== undefined && value > max;
	                if (!isOutOfBounds) return value;
	              }
	              return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
	            };
	            exports2.coerceColor = function(attributeDefinition, value, defaultValue) {
	              if (tinycolor(value).isValid()) return value;
	              return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
	            };
	            exports2.coerceEnumerated = function(attributeDefinition, value, defaultValue) {
	              if (attributeDefinition.coerceNumber) value = +value;
	              if (attributeDefinition.values.indexOf(value) !== -1) return value;
	              return defaultValue !== undefined ? defaultValue : attributeDefinition.dflt;
	            };
	            exports2.getValue = function(arrayOrScalar, index) {
	              var value;
	              if (!Array.isArray(arrayOrScalar)) value = arrayOrScalar;
	              else if (index < arrayOrScalar.length) value = arrayOrScalar[index];
	              return value;
	            };
	            exports2.getLineWidth = function(trace, di) {
	              var w = 0 < di.mlw ? di.mlw : !isArrayOrTypedArray(trace.marker.line.width) ? trace.marker.line.width : 0;
	              return w;
	            };
	          }
	        ),
	        /***/
	        95423: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Fx = __webpack_require__2(30211);
	            var Registry = __webpack_require__2(73972);
	            var Color = __webpack_require__2(7901);
	            var fillText = __webpack_require__2(71828).fillText;
	            var getLineWidth = __webpack_require__2(69383).getLineWidth;
	            var hoverLabelText = __webpack_require__2(89298).hoverLabelText;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              var barPointData = hoverOnBars(pointData, xval, yval, hovermode, opts);
	              if (barPointData) {
	                var cd = barPointData.cd;
	                var trace = cd[0].trace;
	                var di = cd[barPointData.index];
	                barPointData.color = getTraceColor(trace, di);
	                Registry.getComponentMethod("errorbars", "hoverInfo")(di, trace, barPointData);
	                return [barPointData];
	              }
	            }
	            function hoverOnBars(pointData, xval, yval, hovermode, opts) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var t = cd[0].t;
	              var isClosest = hovermode === "closest";
	              var isWaterfall = trace.type === "waterfall";
	              var maxHoverDistance = pointData.maxHoverDistance;
	              var maxSpikeDistance = pointData.maxSpikeDistance;
	              var posVal, sizeVal, posLetter, sizeLetter, dx, dy, pRangeCalc;
	              if (trace.orientation === "h") {
	                posVal = yval;
	                sizeVal = xval;
	                posLetter = "y";
	                sizeLetter = "x";
	                dx = sizeFn;
	                dy = positionFn;
	              } else {
	                posVal = xval;
	                sizeVal = yval;
	                posLetter = "x";
	                sizeLetter = "y";
	                dy = sizeFn;
	                dx = positionFn;
	              }
	              var period = trace[posLetter + "period"];
	              var isClosestOrPeriod = isClosest || period;
	              function thisBarMinPos(di2) {
	                return thisBarExtPos(di2, -1);
	              }
	              function thisBarMaxPos(di2) {
	                return thisBarExtPos(di2, 1);
	              }
	              function thisBarExtPos(di2, sgn) {
	                var w = di2.w;
	                return di2[posLetter] + sgn * w / 2;
	              }
	              function periodLength(di2) {
	                return di2[posLetter + "End"] - di2[posLetter + "Start"];
	              }
	              var minPos = isClosest ? thisBarMinPos : period ? function(di2) {
	                return di2.p - periodLength(di2) / 2;
	              } : function(di2) {
	                return Math.min(thisBarMinPos(di2), di2.p - t.bardelta / 2);
	              };
	              var maxPos = isClosest ? thisBarMaxPos : period ? function(di2) {
	                return di2.p + periodLength(di2) / 2;
	              } : function(di2) {
	                return Math.max(thisBarMaxPos(di2), di2.p + t.bardelta / 2);
	              };
	              function inbox(_minPos, _maxPos, maxDistance) {
	                if (opts.finiteRange) maxDistance = 0;
	                return Fx.inbox(_minPos - posVal, _maxPos - posVal, maxDistance + Math.min(1, Math.abs(_maxPos - _minPos) / pRangeCalc) - 1);
	              }
	              function positionFn(di2) {
	                return inbox(minPos(di2), maxPos(di2), maxHoverDistance);
	              }
	              function thisBarPositionFn(di2) {
	                return inbox(thisBarMinPos(di2), thisBarMaxPos(di2), maxSpikeDistance);
	              }
	              function getSize(di2) {
	                var s = di2[sizeLetter];
	                if (isWaterfall) {
	                  var rawS = Math.abs(di2.rawS) || 0;
	                  if (sizeVal > 0) {
	                    s += rawS;
	                  } else if (sizeVal < 0) {
	                    s -= rawS;
	                  }
	                }
	                return s;
	              }
	              function sizeFn(di2) {
	                var v = sizeVal;
	                var b = di2.b;
	                var s = getSize(di2);
	                return Fx.inbox(b - v, s - v, maxHoverDistance + (s - v) / (s - b) - 1);
	              }
	              function thisBarSizeFn(di2) {
	                var v = sizeVal;
	                var b = di2.b;
	                var s = getSize(di2);
	                return Fx.inbox(b - v, s - v, maxSpikeDistance + (s - v) / (s - b) - 1);
	              }
	              var pa = pointData[posLetter + "a"];
	              var sa = pointData[sizeLetter + "a"];
	              pRangeCalc = Math.abs(pa.r2c(pa.range[1]) - pa.r2c(pa.range[0]));
	              function dxy(di2) {
	                return (dx(di2) + dy(di2)) / 2;
	              }
	              var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	              Fx.getClosest(cd, distfn, pointData);
	              if (pointData.index === false) return;
	              if (cd[pointData.index].p === BADNUM) return;
	              if (!isClosestOrPeriod) {
	                minPos = function(di2) {
	                  return Math.min(thisBarMinPos(di2), di2.p - t.bargroupwidth / 2);
	                };
	                maxPos = function(di2) {
	                  return Math.max(thisBarMaxPos(di2), di2.p + t.bargroupwidth / 2);
	                };
	              }
	              var index = pointData.index;
	              var di = cd[index];
	              var size = trace.base ? di.b + di.s : di.s;
	              pointData[sizeLetter + "0"] = pointData[sizeLetter + "1"] = sa.c2p(di[sizeLetter], true);
	              pointData[sizeLetter + "LabelVal"] = size;
	              var extent2 = t.extents[t.extents.round(di.p)];
	              pointData[posLetter + "0"] = pa.c2p(isClosest ? minPos(di) : extent2[0], true);
	              pointData[posLetter + "1"] = pa.c2p(isClosest ? maxPos(di) : extent2[1], true);
	              var hasPeriod = di.orig_p !== undefined;
	              pointData[posLetter + "LabelVal"] = hasPeriod ? di.orig_p : di.p;
	              pointData.labelLabel = hoverLabelText(pa, pointData[posLetter + "LabelVal"], trace[posLetter + "hoverformat"]);
	              pointData.valueLabel = hoverLabelText(sa, pointData[sizeLetter + "LabelVal"], trace[sizeLetter + "hoverformat"]);
	              pointData.baseLabel = hoverLabelText(sa, di.b, trace[sizeLetter + "hoverformat"]);
	              pointData.spikeDistance = (thisBarSizeFn(di) + thisBarPositionFn(di)) / 2;
	              pointData[posLetter + "Spike"] = pa.c2p(di.p, true);
	              fillText(di, trace, pointData);
	              pointData.hovertemplate = trace.hovertemplate;
	              return pointData;
	            }
	            function getTraceColor(trace, di) {
	              var mc = di.mcc || trace.marker.color;
	              var mlc = di.mlcc || trace.marker.line.color;
	              var mlw = getLineWidth(trace, di);
	              if (Color.opacity(mc)) return mc;
	              else if (Color.opacity(mlc) && mlw) return mlc;
	            }
	            module2.exports = {
	              hoverPoints,
	              hoverOnBars,
	              getTraceColor
	            };
	          }
	        ),
	        /***/
	        60822: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(1486),
	              layoutAttributes: __webpack_require__2(43641),
	              supplyDefaults: __webpack_require__2(90769).supplyDefaults,
	              crossTraceDefaults: __webpack_require__2(90769).crossTraceDefaults,
	              supplyLayoutDefaults: __webpack_require__2(13957),
	              calc: __webpack_require__2(92290),
	              crossTraceCalc: __webpack_require__2(11661).crossTraceCalc,
	              colorbar: __webpack_require__2(4898),
	              arraysToCalcdata: __webpack_require__2(75341),
	              plot: __webpack_require__2(17295).plot,
	              style: __webpack_require__2(16688).style,
	              styleOnSelect: __webpack_require__2(16688).styleOnSelect,
	              hoverPoints: __webpack_require__2(95423).hoverPoints,
	              eventData: __webpack_require__2(58065),
	              selectPoints: __webpack_require__2(81974),
	              moduleType: "trace",
	              name: "bar",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["bar-like", "cartesian", "svg", "bar", "oriented", "errorBarsOK", "showLegend", "zoomScale"],
	              animatable: true,
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        43641: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              barmode: {
	                valType: "enumerated",
	                values: ["stack", "group", "overlay", "relative"],
	                dflt: "group",
	                editType: "calc"
	              },
	              barnorm: {
	                valType: "enumerated",
	                values: ["", "fraction", "percent"],
	                dflt: "",
	                editType: "calc"
	              },
	              bargap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "calc"
	              },
	              bargroupgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        13957: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(43641);
	            module2.exports = function(layoutIn, layoutOut, fullData) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              var hasBars = false;
	              var shouldBeGapless = false;
	              var gappedAnyway = false;
	              var usedSubplots = {};
	              var mode = coerce("barmode");
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (Registry.traceIs(trace, "bar") && trace.visible) hasBars = true;
	                else continue;
	                if (mode === "group") {
	                  var subploti = trace.xaxis + trace.yaxis;
	                  if (usedSubplots[subploti]) gappedAnyway = true;
	                  usedSubplots[subploti] = true;
	                }
	                if (trace.visible && trace.type === "histogram") {
	                  var pa = Axes.getFromId({
	                    _fullLayout: layoutOut
	                  }, trace[trace.orientation === "v" ? "xaxis" : "yaxis"]);
	                  if (pa.type !== "category") shouldBeGapless = true;
	                }
	              }
	              if (!hasBars) {
	                delete layoutOut.barmode;
	                return;
	              }
	              if (mode !== "overlay") coerce("barnorm");
	              coerce("bargap", shouldBeGapless && !gappedAnyway ? 0 : 0.2);
	              coerce("bargroupgap");
	            };
	          }
	        ),
	        /***/
	        17295: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var svgTextUtils = __webpack_require__2(63893);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Registry = __webpack_require__2(73972);
	            var tickText = __webpack_require__2(89298).tickText;
	            var uniformText = __webpack_require__2(72597);
	            var recordMinTextSize = uniformText.recordMinTextSize;
	            var clearMinTextSize = uniformText.clearMinTextSize;
	            var style = __webpack_require__2(16688);
	            var helpers = __webpack_require__2(69383);
	            var constants = __webpack_require__2(97313);
	            var attributes = __webpack_require__2(1486);
	            var attributeText = attributes.text;
	            var attributeTextPosition = attributes.textposition;
	            var appendArrayPointValue = __webpack_require__2(23469).appendArrayPointValue;
	            var TEXTPAD = constants.TEXTPAD;
	            function keyFunc(d) {
	              return d.id;
	            }
	            function getKeyFunc(trace) {
	              if (trace.ids) {
	                return keyFunc;
	              }
	            }
	            function dirSign(a, b) {
	              return a < b ? 1 : -1;
	            }
	            function getXY(di, xa, ya, isHorizontal) {
	              var s = [];
	              var p = [];
	              var sAxis = isHorizontal ? xa : ya;
	              var pAxis = isHorizontal ? ya : xa;
	              s[0] = sAxis.c2p(di.s0, true);
	              p[0] = pAxis.c2p(di.p0, true);
	              s[1] = sAxis.c2p(di.s1, true);
	              p[1] = pAxis.c2p(di.p1, true);
	              return isHorizontal ? [s, p] : [p, s];
	            }
	            function transition(selection, fullLayout, opts, makeOnCompleteCallback) {
	              if (!fullLayout.uniformtext.mode && hasTransition(opts)) {
	                var onComplete;
	                if (makeOnCompleteCallback) {
	                  onComplete = makeOnCompleteCallback();
	                }
	                return selection.transition().duration(opts.duration).ease(opts.easing).each("end", function() {
	                  onComplete && onComplete();
	                }).each("interrupt", function() {
	                  onComplete && onComplete();
	                });
	              } else {
	                return selection;
	              }
	            }
	            function hasTransition(transitionOpts) {
	              return transitionOpts && transitionOpts.duration > 0;
	            }
	            function plot(gd, plotinfo, cdModule, traceLayer, opts, makeOnCompleteCallback) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var fullLayout = gd._fullLayout;
	              var isStatic = gd._context.staticPlot;
	              if (!opts) {
	                opts = {
	                  mode: fullLayout.barmode,
	                  norm: fullLayout.barmode,
	                  gap: fullLayout.bargap,
	                  groupgap: fullLayout.bargroupgap
	                };
	                clearMinTextSize("bar", fullLayout);
	              }
	              var bartraces = Lib.makeTraceGroups(traceLayer, cdModule, "trace bars").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var trace = cd[0].trace;
	                var isWaterfall = trace.type === "waterfall";
	                var isFunnel = trace.type === "funnel";
	                var isBar = trace.type === "bar";
	                var shouldDisplayZeros = isBar || isFunnel;
	                var adjustPixel = 0;
	                if (isWaterfall && trace.connector.visible && trace.connector.mode === "between") {
	                  adjustPixel = trace.connector.line.width / 2;
	                }
	                var isHorizontal = trace.orientation === "h";
	                var withTransition = hasTransition(opts);
	                var pointGroup = Lib.ensureSingle(plotGroup, "g", "points");
	                var keyFunc2 = getKeyFunc(trace);
	                var bars = pointGroup.selectAll("g.point").data(Lib.identity, keyFunc2);
	                bars.enter().append("g").classed("point", true);
	                bars.exit().remove();
	                bars.each(function(di, i) {
	                  var bar = d3.select(this);
	                  var xy = getXY(di, xa, ya, isHorizontal);
	                  var x0 = xy[0][0];
	                  var x1 = xy[0][1];
	                  var y0 = xy[1][0];
	                  var y1 = xy[1][1];
	                  var isBlank = (isHorizontal ? x1 - x0 : y1 - y0) === 0;
	                  if (isBlank && shouldDisplayZeros && helpers.getLineWidth(trace, di)) {
	                    isBlank = false;
	                  }
	                  if (!isBlank) {
	                    isBlank = !isNumeric(x0) || !isNumeric(x1) || !isNumeric(y0) || !isNumeric(y1);
	                  }
	                  di.isBlank = isBlank;
	                  if (isBlank) {
	                    if (isHorizontal) {
	                      x1 = x0;
	                    } else {
	                      y1 = y0;
	                    }
	                  }
	                  if (adjustPixel && !isBlank) {
	                    if (isHorizontal) {
	                      x0 -= dirSign(x0, x1) * adjustPixel;
	                      x1 += dirSign(x0, x1) * adjustPixel;
	                    } else {
	                      y0 -= dirSign(y0, y1) * adjustPixel;
	                      y1 += dirSign(y0, y1) * adjustPixel;
	                    }
	                  }
	                  var lw;
	                  var mc;
	                  if (trace.type === "waterfall") {
	                    if (!isBlank) {
	                      var cont = trace[di.dir].marker;
	                      lw = cont.line.width;
	                      mc = cont.color;
	                    }
	                  } else {
	                    lw = helpers.getLineWidth(trace, di);
	                    mc = di.mc || trace.marker.color;
	                  }
	                  function roundWithLine(v) {
	                    var offset = d3.round(lw / 2 % 1, 2);
	                    return opts.gap === 0 && opts.groupgap === 0 ? d3.round(Math.round(v) - offset, 2) : v;
	                  }
	                  function expandToVisible(v, vc, hideZeroSpan) {
	                    if (hideZeroSpan && v === vc) {
	                      return v;
	                    }
	                    return Math.abs(v - vc) >= 2 ? roundWithLine(v) : (
	                      // but if it's very thin, expand it so it's
	                      // necessarily visible, even if it might overlap
	                      // its neighbor
	                      v > vc ? Math.ceil(v) : Math.floor(v)
	                    );
	                  }
	                  if (!gd._context.staticPlot) {
	                    var op = Color.opacity(mc);
	                    var fixpx = op < 1 || lw > 0.01 ? roundWithLine : expandToVisible;
	                    x0 = fixpx(x0, x1, isHorizontal);
	                    x1 = fixpx(x1, x0, isHorizontal);
	                    y0 = fixpx(y0, y1, !isHorizontal);
	                    y1 = fixpx(y1, y0, !isHorizontal);
	                  }
	                  var sel = transition(Lib.ensureSingle(bar, "path"), fullLayout, opts, makeOnCompleteCallback);
	                  sel.style("vector-effect", isStatic ? "none" : "non-scaling-stroke").attr("d", isNaN((x1 - x0) * (y1 - y0)) || isBlank && gd._context.staticPlot ? "M0,0Z" : "M" + x0 + "," + y0 + "V" + y1 + "H" + x1 + "V" + y0 + "Z").call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	                  if (!fullLayout.uniformtext.mode && withTransition) {
	                    var styleFns = Drawing.makePointStyleFns(trace);
	                    Drawing.singlePointStyle(di, sel, trace, styleFns, gd);
	                  }
	                  appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, opts, makeOnCompleteCallback);
	                  if (plotinfo.layerClipId) {
	                    Drawing.hideOutsideRangePoint(di, bar.select("text"), xa, ya, trace.xcalendar, trace.ycalendar);
	                  }
	                });
	                var hasClipOnAxisFalse = trace.cliponaxis === false;
	                Drawing.setClipUrl(plotGroup, hasClipOnAxisFalse ? null : plotinfo.layerClipId, gd);
	              });
	              Registry.getComponentMethod("errorbars", "plot")(gd, bartraces, plotinfo, opts);
	            }
	            function appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, opts, makeOnCompleteCallback) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var fullLayout = gd._fullLayout;
	              var textPosition;
	              function appendTextNode(bar2, text2, font2) {
	                var textSelection2 = Lib.ensureSingle(bar2, "text").text(text2).attr({
	                  class: "bartext bartext-" + textPosition,
	                  "text-anchor": "middle",
	                  // prohibit tex interpretation until we can handle
	                  // tex and regular text together
	                  "data-notex": 1
	                }).call(Drawing.font, font2).call(svgTextUtils.convertToTspans, gd);
	                return textSelection2;
	              }
	              var trace = cd[0].trace;
	              var isHorizontal = trace.orientation === "h";
	              var text = getText(fullLayout, cd, i, xa, ya);
	              textPosition = getTextPosition(trace, i);
	              var inStackOrRelativeMode = opts.mode === "stack" || opts.mode === "relative";
	              var calcBar = cd[i];
	              var isOutmostBar = !inStackOrRelativeMode || calcBar._outmost;
	              if (!text || textPosition === "none" || (calcBar.isBlank || x0 === x1 || y0 === y1) && (textPosition === "auto" || textPosition === "inside")) {
	                bar.select("text").remove();
	                return;
	              }
	              var layoutFont = fullLayout.font;
	              var barColor = style.getBarColor(cd[i], trace);
	              var insideTextFont = style.getInsideTextFont(trace, i, layoutFont, barColor);
	              var outsideTextFont = style.getOutsideTextFont(trace, i, layoutFont);
	              var di = bar.datum();
	              if (isHorizontal) {
	                if (xa.type === "log" && di.s0 <= 0) {
	                  if (xa.range[0] < xa.range[1]) {
	                    x0 = 0;
	                  } else {
	                    x0 = xa._length;
	                  }
	                }
	              } else {
	                if (ya.type === "log" && di.s0 <= 0) {
	                  if (ya.range[0] < ya.range[1]) {
	                    y0 = ya._length;
	                  } else {
	                    y0 = 0;
	                  }
	                }
	              }
	              var barWidth = Math.abs(x1 - x0) - 2 * TEXTPAD;
	              var barHeight = Math.abs(y1 - y0) - 2 * TEXTPAD;
	              var textSelection;
	              var textBB;
	              var textWidth;
	              var textHeight;
	              var font;
	              if (textPosition === "outside") {
	                if (!isOutmostBar && !calcBar.hasB) textPosition = "inside";
	              }
	              if (textPosition === "auto") {
	                if (isOutmostBar) {
	                  textPosition = "inside";
	                  font = Lib.ensureUniformFontSize(gd, insideTextFont);
	                  textSelection = appendTextNode(bar, text, font);
	                  textBB = Drawing.bBox(textSelection.node()), textWidth = textBB.width, textHeight = textBB.height;
	                  var textHasSize = textWidth > 0 && textHeight > 0;
	                  var fitsInside = textWidth <= barWidth && textHeight <= barHeight;
	                  var fitsInsideIfRotated = textWidth <= barHeight && textHeight <= barWidth;
	                  var fitsInsideIfShrunk = isHorizontal ? barWidth >= textWidth * (barHeight / textHeight) : barHeight >= textHeight * (barWidth / textWidth);
	                  if (textHasSize && (fitsInside || fitsInsideIfRotated || fitsInsideIfShrunk)) {
	                    textPosition = "inside";
	                  } else {
	                    textPosition = "outside";
	                    textSelection.remove();
	                    textSelection = null;
	                  }
	                } else {
	                  textPosition = "inside";
	                }
	              }
	              if (!textSelection) {
	                font = Lib.ensureUniformFontSize(gd, textPosition === "outside" ? outsideTextFont : insideTextFont);
	                textSelection = appendTextNode(bar, text, font);
	                var currentTransform = textSelection.attr("transform");
	                textSelection.attr("transform", "");
	                textBB = Drawing.bBox(textSelection.node()), textWidth = textBB.width, textHeight = textBB.height;
	                textSelection.attr("transform", currentTransform);
	                if (textWidth <= 0 || textHeight <= 0) {
	                  textSelection.remove();
	                  return;
	                }
	              }
	              var angle = trace.textangle;
	              var transform, constrained;
	              if (textPosition === "outside") {
	                constrained = trace.constraintext === "both" || trace.constraintext === "outside";
	                transform = toMoveOutsideBar(x0, x1, y0, y1, textBB, {
	                  isHorizontal,
	                  constrained,
	                  angle
	                });
	              } else {
	                constrained = trace.constraintext === "both" || trace.constraintext === "inside";
	                transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
	                  isHorizontal,
	                  constrained,
	                  angle,
	                  anchor: trace.insidetextanchor
	                });
	              }
	              transform.fontSize = font.size;
	              recordMinTextSize(trace.type === "histogram" ? "bar" : trace.type, transform, fullLayout);
	              calcBar.transform = transform;
	              var s = transition(textSelection, fullLayout, opts, makeOnCompleteCallback);
	              Lib.setTransormAndDisplay(s, transform);
	            }
	            function getRotateFromAngle(angle) {
	              return angle === "auto" ? 0 : angle;
	            }
	            function getRotatedTextSize(textBB, rotate) {
	              var a = Math.PI / 180 * rotate;
	              var absSin = Math.abs(Math.sin(a));
	              var absCos = Math.abs(Math.cos(a));
	              return {
	                x: textBB.width * absCos + textBB.height * absSin,
	                y: textBB.width * absSin + textBB.height * absCos
	              };
	            }
	            function toMoveInsideBar(x0, x1, y0, y1, textBB, opts) {
	              var isHorizontal = !!opts.isHorizontal;
	              var constrained = !!opts.constrained;
	              var angle = opts.angle || 0;
	              var anchor = opts.anchor || "end";
	              var isEnd = anchor === "end";
	              var isStart = anchor === "start";
	              var leftToRight = opts.leftToRight || 0;
	              var toRight = (leftToRight + 1) / 2;
	              var toLeft = 1 - toRight;
	              var textWidth = textBB.width;
	              var textHeight = textBB.height;
	              var lx = Math.abs(x1 - x0);
	              var ly = Math.abs(y1 - y0);
	              var textpad = lx > 2 * TEXTPAD && ly > 2 * TEXTPAD ? TEXTPAD : 0;
	              lx -= 2 * textpad;
	              ly -= 2 * textpad;
	              var rotate = getRotateFromAngle(angle);
	              if (angle === "auto" && !(textWidth <= lx && textHeight <= ly) && (textWidth > lx || textHeight > ly) && (!(textWidth > ly || textHeight > lx) || textWidth < textHeight !== lx < ly)) {
	                rotate += 90;
	              }
	              var t = getRotatedTextSize(textBB, rotate);
	              var scale = 1;
	              if (constrained) {
	                scale = Math.min(1, lx / t.x, ly / t.y);
	              }
	              var textX = textBB.left * toLeft + textBB.right * toRight;
	              var textY = (textBB.top + textBB.bottom) / 2;
	              var targetX = (x0 + TEXTPAD) * toLeft + (x1 - TEXTPAD) * toRight;
	              var targetY = (y0 + y1) / 2;
	              var anchorX = 0;
	              var anchorY = 0;
	              if (isStart || isEnd) {
	                var extrapad = (isHorizontal ? t.x : t.y) / 2;
	                var dir = isHorizontal ? dirSign(x0, x1) : dirSign(y0, y1);
	                if (isHorizontal) {
	                  if (isStart) {
	                    targetX = x0 + dir * textpad;
	                    anchorX = -dir * extrapad;
	                  } else {
	                    targetX = x1 - dir * textpad;
	                    anchorX = dir * extrapad;
	                  }
	                } else {
	                  if (isStart) {
	                    targetY = y0 + dir * textpad;
	                    anchorY = -dir * extrapad;
	                  } else {
	                    targetY = y1 - dir * textpad;
	                    anchorY = dir * extrapad;
	                  }
	                }
	              }
	              return {
	                textX,
	                textY,
	                targetX,
	                targetY,
	                anchorX,
	                anchorY,
	                scale,
	                rotate
	              };
	            }
	            function toMoveOutsideBar(x0, x1, y0, y1, textBB, opts) {
	              var isHorizontal = !!opts.isHorizontal;
	              var constrained = !!opts.constrained;
	              var angle = opts.angle || 0;
	              var textWidth = textBB.width;
	              var textHeight = textBB.height;
	              var lx = Math.abs(x1 - x0);
	              var ly = Math.abs(y1 - y0);
	              var textpad;
	              if (isHorizontal) {
	                textpad = ly > 2 * TEXTPAD ? TEXTPAD : 0;
	              } else {
	                textpad = lx > 2 * TEXTPAD ? TEXTPAD : 0;
	              }
	              var scale = 1;
	              if (constrained) {
	                scale = isHorizontal ? Math.min(1, ly / textHeight) : Math.min(1, lx / textWidth);
	              }
	              var rotate = getRotateFromAngle(angle);
	              var t = getRotatedTextSize(textBB, rotate);
	              var extrapad = (isHorizontal ? t.x : t.y) / 2;
	              var textX = (textBB.left + textBB.right) / 2;
	              var textY = (textBB.top + textBB.bottom) / 2;
	              var targetX = (x0 + x1) / 2;
	              var targetY = (y0 + y1) / 2;
	              var anchorX = 0;
	              var anchorY = 0;
	              var dir = isHorizontal ? dirSign(x1, x0) : dirSign(y0, y1);
	              if (isHorizontal) {
	                targetX = x1 - dir * textpad;
	                anchorX = dir * extrapad;
	              } else {
	                targetY = y1 + dir * textpad;
	                anchorY = -dir * extrapad;
	              }
	              return {
	                textX,
	                textY,
	                targetX,
	                targetY,
	                anchorX,
	                anchorY,
	                scale,
	                rotate
	              };
	            }
	            function getText(fullLayout, cd, index, xa, ya) {
	              var trace = cd[0].trace;
	              var texttemplate = trace.texttemplate;
	              var value;
	              if (texttemplate) {
	                value = calcTexttemplate(fullLayout, cd, index, xa, ya);
	              } else if (trace.textinfo) {
	                value = calcTextinfo(cd, index, xa, ya);
	              } else {
	                value = helpers.getValue(trace.text, index);
	              }
	              return helpers.coerceString(attributeText, value);
	            }
	            function getTextPosition(trace, index) {
	              var value = helpers.getValue(trace.textposition, index);
	              return helpers.coerceEnumerated(attributeTextPosition, value);
	            }
	            function calcTexttemplate(fullLayout, cd, index, xa, ya) {
	              var trace = cd[0].trace;
	              var texttemplate = Lib.castOption(trace, index, "texttemplate");
	              if (!texttemplate) return "";
	              var isHistogram = trace.type === "histogram";
	              var isWaterfall = trace.type === "waterfall";
	              var isFunnel = trace.type === "funnel";
	              var isHorizontal = trace.orientation === "h";
	              var pLetter, pAxis;
	              var vLetter, vAxis;
	              if (isHorizontal) {
	                pLetter = "y";
	                pAxis = ya;
	                vLetter = "x";
	                vAxis = xa;
	              } else {
	                pLetter = "x";
	                pAxis = xa;
	                vLetter = "y";
	                vAxis = ya;
	              }
	              function formatLabel(u) {
	                return tickText(pAxis, pAxis.c2l(u), true).text;
	              }
	              function formatNumber(v) {
	                return tickText(vAxis, vAxis.c2l(v), true).text;
	              }
	              var cdi = cd[index];
	              var obj = {};
	              obj.label = cdi.p;
	              obj.labelLabel = obj[pLetter + "Label"] = formatLabel(cdi.p);
	              var tx = Lib.castOption(trace, cdi.i, "text");
	              if (tx === 0 || tx) obj.text = tx;
	              obj.value = cdi.s;
	              obj.valueLabel = obj[vLetter + "Label"] = formatNumber(cdi.s);
	              var pt = {};
	              appendArrayPointValue(pt, trace, cdi.i);
	              if (isHistogram || pt.x === undefined) pt.x = isHorizontal ? obj.value : obj.label;
	              if (isHistogram || pt.y === undefined) pt.y = isHorizontal ? obj.label : obj.value;
	              if (isHistogram || pt.xLabel === undefined) pt.xLabel = isHorizontal ? obj.valueLabel : obj.labelLabel;
	              if (isHistogram || pt.yLabel === undefined) pt.yLabel = isHorizontal ? obj.labelLabel : obj.valueLabel;
	              if (isWaterfall) {
	                obj.delta = +cdi.rawS || cdi.s;
	                obj.deltaLabel = formatNumber(obj.delta);
	                obj.final = cdi.v;
	                obj.finalLabel = formatNumber(obj.final);
	                obj.initial = obj.final - obj.delta;
	                obj.initialLabel = formatNumber(obj.initial);
	              }
	              if (isFunnel) {
	                obj.value = cdi.s;
	                obj.valueLabel = formatNumber(obj.value);
	                obj.percentInitial = cdi.begR;
	                obj.percentInitialLabel = Lib.formatPercent(cdi.begR);
	                obj.percentPrevious = cdi.difR;
	                obj.percentPreviousLabel = Lib.formatPercent(cdi.difR);
	                obj.percentTotal = cdi.sumR;
	                obj.percenTotalLabel = Lib.formatPercent(cdi.sumR);
	              }
	              var customdata = Lib.castOption(trace, cdi.i, "customdata");
	              if (customdata) obj.customdata = customdata;
	              return Lib.texttemplateString(texttemplate, obj, fullLayout._d3locale, pt, obj, trace._meta || {});
	            }
	            function calcTextinfo(cd, index, xa, ya) {
	              var trace = cd[0].trace;
	              var isHorizontal = trace.orientation === "h";
	              var isWaterfall = trace.type === "waterfall";
	              var isFunnel = trace.type === "funnel";
	              function formatLabel(u) {
	                var pAxis = isHorizontal ? ya : xa;
	                return tickText(pAxis, u, true).text;
	              }
	              function formatNumber(v) {
	                var sAxis = isHorizontal ? xa : ya;
	                return tickText(sAxis, +v, true).text;
	              }
	              var textinfo = trace.textinfo;
	              var cdi = cd[index];
	              var parts = textinfo.split("+");
	              var text = [];
	              var tx;
	              var hasFlag = function(flag) {
	                return parts.indexOf(flag) !== -1;
	              };
	              if (hasFlag("label")) {
	                text.push(formatLabel(cd[index].p));
	              }
	              if (hasFlag("text")) {
	                tx = Lib.castOption(trace, cdi.i, "text");
	                if (tx === 0 || tx) text.push(tx);
	              }
	              if (isWaterfall) {
	                var delta = +cdi.rawS || cdi.s;
	                var final = cdi.v;
	                var initial = final - delta;
	                if (hasFlag("initial")) text.push(formatNumber(initial));
	                if (hasFlag("delta")) text.push(formatNumber(delta));
	                if (hasFlag("final")) text.push(formatNumber(final));
	              }
	              if (isFunnel) {
	                if (hasFlag("value")) text.push(formatNumber(cdi.s));
	                var nPercent = 0;
	                if (hasFlag("percent initial")) nPercent++;
	                if (hasFlag("percent previous")) nPercent++;
	                if (hasFlag("percent total")) nPercent++;
	                var hasMultiplePercents = nPercent > 1;
	                if (hasFlag("percent initial")) {
	                  tx = Lib.formatPercent(cdi.begR);
	                  if (hasMultiplePercents) tx += " of initial";
	                  text.push(tx);
	                }
	                if (hasFlag("percent previous")) {
	                  tx = Lib.formatPercent(cdi.difR);
	                  if (hasMultiplePercents) tx += " of previous";
	                  text.push(tx);
	                }
	                if (hasFlag("percent total")) {
	                  tx = Lib.formatPercent(cdi.sumR);
	                  if (hasMultiplePercents) tx += " of total";
	                  text.push(tx);
	                }
	              }
	              return text.join("<br>");
	            }
	            module2.exports = {
	              plot,
	              toMoveInsideBar
	            };
	          }
	        ),
	        /***/
	        81974: (
	          /***/
	          function(module2) {
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var trace = cd[0].trace;
	              var isFunnel = trace.type === "funnel";
	              var isHorizontal = trace.orientation === "h";
	              var selection = [];
	              var i;
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  cd[i].selected = 0;
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  var di = cd[i];
	                  var ct = "ct" in di ? di.ct : getCentroid(di, xa, ya, isHorizontal, isFunnel);
	                  if (selectionTester.contains(ct, false, i, searchInfo)) {
	                    selection.push({
	                      pointNumber: i,
	                      x: xa.c2d(di.x),
	                      y: ya.c2d(di.y)
	                    });
	                    di.selected = 1;
	                  } else {
	                    di.selected = 0;
	                  }
	                }
	              }
	              return selection;
	            };
	            function getCentroid(d, xa, ya, isHorizontal, isFunnel) {
	              var x0 = xa.c2p(isHorizontal ? d.s0 : d.p0, true);
	              var x1 = xa.c2p(isHorizontal ? d.s1 : d.p1, true);
	              var y0 = ya.c2p(isHorizontal ? d.p0 : d.s0, true);
	              var y1 = ya.c2p(isHorizontal ? d.p1 : d.s1, true);
	              if (isFunnel) {
	                return [(x0 + x1) / 2, (y0 + y1) / 2];
	              } else {
	                if (isHorizontal) {
	                  return [x1, (y0 + y1) / 2];
	                } else {
	                  return [(x0 + x1) / 2, y1];
	                }
	              }
	            }
	          }
	        ),
	        /***/
	        61546: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = Sieve;
	            var distinctVals = __webpack_require__2(71828).distinctVals;
	            function Sieve(traces, opts) {
	              this.traces = traces;
	              this.sepNegVal = opts.sepNegVal;
	              this.overlapNoMerge = opts.overlapNoMerge;
	              var width1 = Infinity;
	              var axLetter = opts.posAxis._id.charAt(0);
	              var positions = [];
	              for (var i = 0; i < traces.length; i++) {
	                var trace = traces[i];
	                for (var j = 0; j < trace.length; j++) {
	                  var bar = trace[j];
	                  var pos = bar.p;
	                  if (pos === undefined) {
	                    pos = bar[axLetter];
	                  }
	                  if (pos !== undefined) positions.push(pos);
	                }
	                if (trace[0] && trace[0].width1) {
	                  width1 = Math.min(trace[0].width1, width1);
	                }
	              }
	              this.positions = positions;
	              var dv = distinctVals(positions);
	              this.distinctPositions = dv.vals;
	              if (dv.vals.length === 1 && width1 !== Infinity) this.minDiff = width1;
	              else this.minDiff = Math.min(dv.minDiff, width1);
	              var type = (opts.posAxis || {}).type;
	              if (type === "category" || type === "multicategory") {
	                this.minDiff = 1;
	              }
	              this.binWidth = this.minDiff;
	              this.bins = {};
	            }
	            Sieve.prototype.put = function put(position, value) {
	              var label = this.getLabel(position, value);
	              var oldValue = this.bins[label] || 0;
	              this.bins[label] = oldValue + value;
	              return oldValue;
	            };
	            Sieve.prototype.get = function get(position, value) {
	              var label = this.getLabel(position, value);
	              return this.bins[label] || 0;
	            };
	            Sieve.prototype.getLabel = function getLabel(position, value) {
	              var prefix = value < 0 && this.sepNegVal ? "v" : "^";
	              var label = this.overlapNoMerge ? position : Math.round(position / this.binWidth);
	              return prefix + label;
	            };
	          }
	        ),
	        /***/
	        16688: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            var attributes = __webpack_require__2(1486);
	            var attributeTextFont = attributes.textfont;
	            var attributeInsideTextFont = attributes.insidetextfont;
	            var attributeOutsideTextFont = attributes.outsidetextfont;
	            var helpers = __webpack_require__2(69383);
	            function style(gd) {
	              var s = d3.select(gd).selectAll("g.barlayer").selectAll("g.trace");
	              resizeText(gd, s, "bar");
	              var barcount = s.size();
	              var fullLayout = gd._fullLayout;
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              }).each(function(d) {
	                if (fullLayout.barmode === "stack" && barcount > 1 || fullLayout.bargap === 0 && fullLayout.bargroupgap === 0 && !d[0].trace.marker.line.width) {
	                  d3.select(this).attr("shape-rendering", "crispEdges");
	                }
	              });
	              s.selectAll("g.points").each(function(d) {
	                var sel = d3.select(this);
	                var trace = d[0].trace;
	                stylePoints(sel, trace, gd);
	              });
	              Registry.getComponentMethod("errorbars", "style")(s);
	            }
	            function stylePoints(sel, trace, gd) {
	              Drawing.pointStyle(sel.selectAll("path"), trace, gd);
	              styleTextPoints(sel, trace, gd);
	            }
	            function styleTextPoints(sel, trace, gd) {
	              sel.selectAll("text").each(function(d) {
	                var tx = d3.select(this);
	                var font = Lib.ensureUniformFontSize(gd, determineFont(tx, d, trace, gd));
	                Drawing.font(tx, font);
	              });
	            }
	            function styleOnSelect(gd, cd, sel) {
	              var trace = cd[0].trace;
	              if (trace.selectedpoints) {
	                stylePointsInSelectionMode(sel, trace, gd);
	              } else {
	                stylePoints(sel, trace, gd);
	                Registry.getComponentMethod("errorbars", "style")(sel);
	              }
	            }
	            function stylePointsInSelectionMode(s, trace, gd) {
	              Drawing.selectedPointStyle(s.selectAll("path"), trace);
	              styleTextInSelectionMode(s.selectAll("text"), trace, gd);
	            }
	            function styleTextInSelectionMode(txs, trace, gd) {
	              txs.each(function(d) {
	                var tx = d3.select(this);
	                var font;
	                if (d.selected) {
	                  font = Lib.ensureUniformFontSize(gd, determineFont(tx, d, trace, gd));
	                  var selectedFontColor = trace.selected.textfont && trace.selected.textfont.color;
	                  if (selectedFontColor) {
	                    font.color = selectedFontColor;
	                  }
	                  Drawing.font(tx, font);
	                } else {
	                  Drawing.selectedTextStyle(tx, trace);
	                }
	              });
	            }
	            function determineFont(tx, d, trace, gd) {
	              var layoutFont = gd._fullLayout.font;
	              var textFont = trace.textfont;
	              if (tx.classed("bartext-inside")) {
	                var barColor = getBarColor(d, trace);
	                textFont = getInsideTextFont(trace, d.i, layoutFont, barColor);
	              } else if (tx.classed("bartext-outside")) {
	                textFont = getOutsideTextFont(trace, d.i, layoutFont);
	              }
	              return textFont;
	            }
	            function getTextFont(trace, index, defaultValue) {
	              return getFontValue(attributeTextFont, trace.textfont, index, defaultValue);
	            }
	            function getInsideTextFont(trace, index, layoutFont, barColor) {
	              var defaultFont = getTextFont(trace, index, layoutFont);
	              var wouldFallBackToLayoutFont = trace._input.textfont === undefined || trace._input.textfont.color === undefined || Array.isArray(trace.textfont.color) && trace.textfont.color[index] === undefined;
	              if (wouldFallBackToLayoutFont) {
	                defaultFont = {
	                  color: Color.contrast(barColor),
	                  family: defaultFont.family,
	                  size: defaultFont.size
	                };
	              }
	              return getFontValue(attributeInsideTextFont, trace.insidetextfont, index, defaultFont);
	            }
	            function getOutsideTextFont(trace, index, layoutFont) {
	              var defaultFont = getTextFont(trace, index, layoutFont);
	              return getFontValue(attributeOutsideTextFont, trace.outsidetextfont, index, defaultFont);
	            }
	            function getFontValue(attributeDefinition, attributeValue, index, defaultValue) {
	              attributeValue = attributeValue || {};
	              var familyValue = helpers.getValue(attributeValue.family, index);
	              var sizeValue = helpers.getValue(attributeValue.size, index);
	              var colorValue = helpers.getValue(attributeValue.color, index);
	              return {
	                family: helpers.coerceString(attributeDefinition.family, familyValue, defaultValue.family),
	                size: helpers.coerceNumber(attributeDefinition.size, sizeValue, defaultValue.size),
	                color: helpers.coerceColor(attributeDefinition.color, colorValue, defaultValue.color)
	              };
	            }
	            function getBarColor(cd, trace) {
	              if (trace.type === "waterfall") {
	                return trace[cd.dir].marker.color;
	              }
	              return cd.mcc || cd.mc || trace.marker.color;
	            }
	            module2.exports = {
	              style,
	              styleTextPoints,
	              styleOnSelect,
	              getInsideTextFont,
	              getOutsideTextFont,
	              getBarColor,
	              resizeText
	            };
	          }
	        ),
	        /***/
	        98340: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var coercePattern = __webpack_require__2(71828).coercePattern;
	            module2.exports = function handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout) {
	              var markerColor = coerce("marker.color", defaultColor);
	              var hasMarkerColorscale = hasColorscale(traceIn, "marker");
	              if (hasMarkerColorscale) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "marker.",
	                  cLetter: "c"
	                });
	              }
	              coerce("marker.line.color", Color.defaultLine);
	              if (hasColorscale(traceIn, "marker.line")) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "marker.line.",
	                  cLetter: "c"
	                });
	              }
	              coerce("marker.line.width");
	              coerce("marker.opacity");
	              coercePattern(coerce, "marker.pattern", markerColor, hasMarkerColorscale);
	              coerce("selected.marker.color");
	              coerce("unselected.marker.color");
	            };
	          }
	        ),
	        /***/
	        72597: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            function resizeText(gd, gTrace, traceType) {
	              var fullLayout = gd._fullLayout;
	              var minSize = fullLayout["_" + traceType + "Text_minsize"];
	              if (minSize) {
	                var shouldHide = fullLayout.uniformtext.mode === "hide";
	                var selector;
	                switch (traceType) {
	                  case "funnelarea":
	                  case "pie":
	                  case "sunburst":
	                    selector = "g.slice";
	                    break;
	                  case "treemap":
	                  case "icicle":
	                    selector = "g.slice, g.pathbar";
	                    break;
	                  default:
	                    selector = "g.points > g.point";
	                }
	                gTrace.selectAll(selector).each(function(d) {
	                  var transform = d.transform;
	                  if (transform) {
	                    transform.scale = shouldHide && transform.hide ? 0 : minSize / transform.fontSize;
	                    var el = d3.select(this).select("text");
	                    Lib.setTransormAndDisplay(el, transform);
	                  }
	                });
	              }
	            }
	            function recordMinTextSize(traceType, transform, fullLayout) {
	              if (fullLayout.uniformtext.mode) {
	                var minKey = getMinKey(traceType);
	                var minSize = fullLayout.uniformtext.minsize;
	                var size = transform.scale * transform.fontSize;
	                transform.hide = size < minSize;
	                fullLayout[minKey] = fullLayout[minKey] || Infinity;
	                if (!transform.hide) {
	                  fullLayout[minKey] = Math.min(fullLayout[minKey], Math.max(size, minSize));
	                }
	              }
	            }
	            function clearMinTextSize(traceType, fullLayout) {
	              var minKey = getMinKey(traceType);
	              fullLayout[minKey] = undefined;
	            }
	            function getMinKey(traceType) {
	              return "_" + traceType + "Text_minsize";
	            }
	            module2.exports = {
	              recordMinTextSize,
	              clearMinTextSize,
	              resizeText
	            };
	          }
	        ),
	        /***/
	        55023: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterPolarAttrs = __webpack_require__2(81245);
	            var barAttrs = __webpack_require__2(1486);
	            module2.exports = {
	              r: scatterPolarAttrs.r,
	              theta: scatterPolarAttrs.theta,
	              r0: scatterPolarAttrs.r0,
	              dr: scatterPolarAttrs.dr,
	              theta0: scatterPolarAttrs.theta0,
	              dtheta: scatterPolarAttrs.dtheta,
	              thetaunit: scatterPolarAttrs.thetaunit,
	              // orientation: {
	              //     valType: 'enumerated',
	              //     values: ['radial', 'angular'],
	              //     editType: 'calc+clearAxisTypes',
	              //
	              // },
	              base: extendFlat({}, barAttrs.base, {}),
	              offset: extendFlat({}, barAttrs.offset, {}),
	              width: extendFlat({}, barAttrs.width, {}),
	              text: extendFlat({}, barAttrs.text, {}),
	              hovertext: extendFlat({}, barAttrs.hovertext, {}),
	              // textposition: {},
	              // textfont: {},
	              // insidetextfont: {},
	              // outsidetextfont: {},
	              // constraintext: {},
	              // cliponaxis: extendFlat({}, barAttrs.cliponaxis, {dflt: false}),
	              marker: barAttrs.marker,
	              hoverinfo: scatterPolarAttrs.hoverinfo,
	              hovertemplate: hovertemplateAttrs(),
	              selected: barAttrs.selected,
	              unselected: barAttrs.unselected
	              // error_x (error_r, error_theta)
	              // error_y
	            };
	          }
	        ),
	        /***/
	        74692: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleCalc = __webpack_require__2(78803);
	            var arraysToCalcdata = __webpack_require__2(75341);
	            var setGroupPositions = __webpack_require__2(11661).setGroupPositions;
	            var calcSelection = __webpack_require__2(66279);
	            var traceIs = __webpack_require__2(73972).traceIs;
	            var extendFlat = __webpack_require__2(71828).extendFlat;
	            function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var subplotId = trace.subplot;
	              var radialAxis = fullLayout[subplotId].radialaxis;
	              var angularAxis = fullLayout[subplotId].angularaxis;
	              var rArray = radialAxis.makeCalcdata(trace, "r");
	              var thetaArray = angularAxis.makeCalcdata(trace, "theta");
	              var len = trace._length;
	              var cd = new Array(len);
	              var sArray = rArray;
	              var pArray = thetaArray;
	              for (var i = 0; i < len; i++) {
	                cd[i] = {
	                  p: pArray[i],
	                  s: sArray[i]
	                };
	              }
	              function d2c(attr) {
	                var val = trace[attr];
	                if (val !== undefined) {
	                  trace["_" + attr] = Array.isArray(val) ? angularAxis.makeCalcdata(trace, attr) : angularAxis.d2c(val, trace.thetaunit);
	                }
	              }
	              if (angularAxis.type === "linear") {
	                d2c("width");
	                d2c("offset");
	              }
	              if (hasColorscale(trace, "marker")) {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.marker.color,
	                  containerStr: "marker",
	                  cLetter: "c"
	                });
	              }
	              if (hasColorscale(trace, "marker.line")) {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.marker.line.color,
	                  containerStr: "marker.line",
	                  cLetter: "c"
	                });
	              }
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            }
	            function crossTraceCalc(gd, polarLayout, subplotId) {
	              var calcdata = gd.calcdata;
	              var barPolarCd = [];
	              for (var i = 0; i < calcdata.length; i++) {
	                var cdi = calcdata[i];
	                var trace = cdi[0].trace;
	                if (trace.visible === true && traceIs(trace, "bar") && trace.subplot === subplotId) {
	                  barPolarCd.push(cdi);
	                }
	              }
	              var rAxis = extendFlat({}, polarLayout.radialaxis, {
	                _id: "x"
	              });
	              var aAxis = polarLayout.angularaxis;
	              setGroupPositions(gd, aAxis, rAxis, barPolarCd, {
	                mode: polarLayout.barmode,
	                norm: polarLayout.barnorm,
	                gap: polarLayout.bargap,
	                groupgap: polarLayout.bargroupgap
	              });
	            }
	            module2.exports = {
	              calc,
	              crossTraceCalc
	            };
	          }
	        ),
	        /***/
	        6135: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleRThetaDefaults = __webpack_require__2(22184).handleRThetaDefaults;
	            var handleStyleDefaults = __webpack_require__2(98340);
	            var attributes = __webpack_require__2(55023);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("thetaunit");
	              coerce("base");
	              coerce("offset");
	              coerce("width");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        27379: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Fx = __webpack_require__2(30211);
	            var Lib = __webpack_require__2(71828);
	            var getTraceColor = __webpack_require__2(95423).getTraceColor;
	            var fillText = Lib.fillText;
	            var makeHoverPointText = __webpack_require__2(59150).makeHoverPointText;
	            var isPtInsidePolygon = __webpack_require__2(10869).isPtInsidePolygon;
	            module2.exports = function hoverPoints(pointData, xval, yval) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var subplot = pointData.subplot;
	              var radialAxis = subplot.radialAxis;
	              var angularAxis = subplot.angularAxis;
	              var vangles = subplot.vangles;
	              var inboxFn = vangles ? isPtInsidePolygon : Lib.isPtInsideSector;
	              var maxHoverDistance = pointData.maxHoverDistance;
	              var period = angularAxis._period || 2 * Math.PI;
	              var rVal = Math.abs(radialAxis.g2p(Math.sqrt(xval * xval + yval * yval)));
	              var thetaVal = Math.atan2(yval, xval);
	              if (radialAxis.range[0] > radialAxis.range[1]) {
	                thetaVal += Math.PI;
	              }
	              var distFn = function(di) {
	                if (inboxFn(rVal, thetaVal, [di.rp0, di.rp1], [di.thetag0, di.thetag1], vangles)) {
	                  return maxHoverDistance + // add a little to the pseudo-distance for wider bars, so that like scatter,
	                  // if you are over two overlapping bars, the narrower one wins.
	                  Math.min(1, Math.abs(di.thetag1 - di.thetag0) / period) - 1 + // add a gradient so hovering near the end of a
	                  // bar makes it a little closer match
	                  (di.rp1 - rVal) / (di.rp1 - di.rp0) - 1;
	                } else {
	                  return Infinity;
	                }
	              };
	              Fx.getClosest(cd, distFn, pointData);
	              if (pointData.index === false) return;
	              var index = pointData.index;
	              var cdi = cd[index];
	              pointData.x0 = pointData.x1 = cdi.ct[0];
	              pointData.y0 = pointData.y1 = cdi.ct[1];
	              var _cdi = Lib.extendFlat({}, cdi, {
	                r: cdi.s,
	                theta: cdi.p
	              });
	              fillText(cdi, trace, pointData);
	              makeHoverPointText(_cdi, trace, subplot, pointData);
	              pointData.hovertemplate = trace.hovertemplate;
	              pointData.color = getTraceColor(trace, cdi);
	              pointData.xLabelVal = pointData.yLabelVal = undefined;
	              if (cdi.s < 0) {
	                pointData.idealAlign = "left";
	              }
	              return [pointData];
	            };
	          }
	        ),
	        /***/
	        23381: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "barpolar",
	              basePlotModule: __webpack_require__2(23580),
	              categories: ["polar", "bar", "showLegend"],
	              attributes: __webpack_require__2(55023),
	              layoutAttributes: __webpack_require__2(40151),
	              supplyDefaults: __webpack_require__2(6135),
	              supplyLayoutDefaults: __webpack_require__2(19860),
	              calc: __webpack_require__2(74692).calc,
	              crossTraceCalc: __webpack_require__2(74692).crossTraceCalc,
	              plot: __webpack_require__2(60173),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(98608),
	              style: __webpack_require__2(16688).style,
	              styleOnSelect: __webpack_require__2(16688).styleOnSelect,
	              hoverPoints: __webpack_require__2(27379),
	              selectPoints: __webpack_require__2(81974),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        40151: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              barmode: {
	                valType: "enumerated",
	                values: ["stack", "overlay"],
	                dflt: "stack",
	                editType: "calc"
	              },
	              bargap: {
	                valType: "number",
	                dflt: 0.1,
	                min: 0,
	                max: 1,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        19860: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attrs = __webpack_require__2(40151);
	            module2.exports = function(layoutIn, layoutOut, fullData) {
	              var subplotsDone = {};
	              var sp;
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn[sp] || {}, layoutOut[sp], attrs, attr, dflt);
	              }
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (trace.type === "barpolar" && trace.visible === true) {
	                  sp = trace.subplot;
	                  if (!subplotsDone[sp]) {
	                    coerce("barmode");
	                    coerce("bargap");
	                    subplotsDone[sp] = 1;
	                  }
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        60173: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var helpers = __webpack_require__2(10869);
	            module2.exports = function plot(gd, subplot, cdbar) {
	              var isStatic = gd._context.staticPlot;
	              var xa = subplot.xaxis;
	              var ya = subplot.yaxis;
	              var radialAxis = subplot.radialAxis;
	              var angularAxis = subplot.angularAxis;
	              var pathFn = makePathFn(subplot);
	              var barLayer = subplot.layers.frontplot.select("g.barlayer");
	              Lib.makeTraceGroups(barLayer, cdbar, "trace bars").each(function() {
	                var plotGroup = d3.select(this);
	                var pointGroup = Lib.ensureSingle(plotGroup, "g", "points");
	                var bars = pointGroup.selectAll("g.point").data(Lib.identity);
	                bars.enter().append("g").style("vector-effect", isStatic ? "none" : "non-scaling-stroke").style("stroke-miterlimit", 2).classed("point", true);
	                bars.exit().remove();
	                bars.each(function(di) {
	                  var bar = d3.select(this);
	                  var rp0 = di.rp0 = radialAxis.c2p(di.s0);
	                  var rp1 = di.rp1 = radialAxis.c2p(di.s1);
	                  var thetag0 = di.thetag0 = angularAxis.c2g(di.p0);
	                  var thetag1 = di.thetag1 = angularAxis.c2g(di.p1);
	                  var dPath;
	                  if (!isNumeric(rp0) || !isNumeric(rp1) || !isNumeric(thetag0) || !isNumeric(thetag1) || rp0 === rp1 || thetag0 === thetag1) {
	                    dPath = "M0,0Z";
	                  } else {
	                    var rg1 = radialAxis.c2g(di.s1);
	                    var thetagMid = (thetag0 + thetag1) / 2;
	                    di.ct = [xa.c2p(rg1 * Math.cos(thetagMid)), ya.c2p(rg1 * Math.sin(thetagMid))];
	                    dPath = pathFn(rp0, rp1, thetag0, thetag1);
	                  }
	                  Lib.ensureSingle(bar, "path").attr("d", dPath);
	                });
	                Drawing.setClipUrl(plotGroup, subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null, gd);
	              });
	            };
	            function makePathFn(subplot) {
	              var cxx = subplot.cxx;
	              var cyy = subplot.cyy;
	              if (subplot.vangles) {
	                return function(r0, r1, _a0, _a1) {
	                  var a0, a1;
	                  if (Lib.angleDelta(_a0, _a1) > 0) {
	                    a0 = _a0;
	                    a1 = _a1;
	                  } else {
	                    a0 = _a1;
	                    a1 = _a0;
	                  }
	                  var va0 = helpers.findEnclosingVertexAngles(a0, subplot.vangles)[0];
	                  var va1 = helpers.findEnclosingVertexAngles(a1, subplot.vangles)[1];
	                  var vaBar = [va0, (a0 + a1) / 2, va1];
	                  return helpers.pathPolygonAnnulus(r0, r1, a0, a1, vaBar, cxx, cyy);
	                };
	              }
	              return function(r0, r1, a0, a1) {
	                return Lib.pathAnnulus(r0, r1, a0, a1, cxx, cyy);
	              };
	            }
	          }
	        ),
	        /***/
	        53522: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterAttrs = __webpack_require__2(82196);
	            var barAttrs = __webpack_require__2(1486);
	            var colorAttrs = __webpack_require__2(22399);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            module2.exports = {
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              x0: {
	                valType: "any",
	                editType: "calc+clearAxisTypes"
	              },
	              y0: {
	                valType: "any",
	                editType: "calc+clearAxisTypes"
	              },
	              dx: {
	                valType: "number",
	                editType: "calc"
	              },
	              dy: {
	                valType: "number",
	                editType: "calc"
	              },
	              xperiod: scatterAttrs.xperiod,
	              yperiod: scatterAttrs.yperiod,
	              xperiod0: scatterAttrs.xperiod0,
	              yperiod0: scatterAttrs.yperiod0,
	              xperiodalignment: scatterAttrs.xperiodalignment,
	              yperiodalignment: scatterAttrs.yperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              name: {
	                valType: "string",
	                editType: "calc+clearAxisTypes"
	              },
	              q1: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              median: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              q3: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              lowerfence: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              upperfence: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              notched: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              notchwidth: {
	                valType: "number",
	                min: 0,
	                max: 0.5,
	                dflt: 0.25,
	                editType: "calc"
	              },
	              notchspan: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              // TODO
	              // maybe add
	              // - loweroutlierbound / upperoutlierbound
	              // - lowersuspectedoutlierbound / uppersuspectedoutlierbound
	              boxpoints: {
	                valType: "enumerated",
	                values: ["all", "outliers", "suspectedoutliers", false],
	                editType: "calc"
	              },
	              jitter: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "calc"
	              },
	              pointpos: {
	                valType: "number",
	                min: -2,
	                max: 2,
	                editType: "calc"
	              },
	              sdmultiple: {
	                valType: "number",
	                min: 0,
	                editType: "calc",
	                dflt: 1
	              },
	              sizemode: {
	                valType: "enumerated",
	                values: ["quartiles", "sd"],
	                editType: "calc",
	                dflt: "quartiles"
	              },
	              boxmean: {
	                valType: "enumerated",
	                values: [true, "sd", false],
	                editType: "calc"
	              },
	              mean: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              sd: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              orientation: {
	                valType: "enumerated",
	                values: ["v", "h"],
	                editType: "calc+clearAxisTypes"
	              },
	              quartilemethod: {
	                valType: "enumerated",
	                values: ["linear", "exclusive", "inclusive"],
	                dflt: "linear",
	                editType: "calc"
	              },
	              width: {
	                valType: "number",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              marker: {
	                outliercolor: {
	                  valType: "color",
	                  dflt: "rgba(0, 0, 0, 0)",
	                  editType: "style"
	                },
	                symbol: extendFlat({}, scatterMarkerAttrs.symbol, {
	                  arrayOk: false,
	                  editType: "plot"
	                }),
	                opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
	                  arrayOk: false,
	                  dflt: 1,
	                  editType: "style"
	                }),
	                angle: extendFlat({}, scatterMarkerAttrs.angle, {
	                  arrayOk: false,
	                  editType: "calc"
	                }),
	                size: extendFlat({}, scatterMarkerAttrs.size, {
	                  arrayOk: false,
	                  editType: "calc"
	                }),
	                color: extendFlat({}, scatterMarkerAttrs.color, {
	                  arrayOk: false,
	                  editType: "style"
	                }),
	                line: {
	                  color: extendFlat({}, scatterMarkerLineAttrs.color, {
	                    arrayOk: false,
	                    dflt: colorAttrs.defaultLine,
	                    editType: "style"
	                  }),
	                  width: extendFlat({}, scatterMarkerLineAttrs.width, {
	                    arrayOk: false,
	                    dflt: 0,
	                    editType: "style"
	                  }),
	                  outliercolor: {
	                    valType: "color",
	                    editType: "style"
	                  },
	                  outlierwidth: {
	                    valType: "number",
	                    min: 0,
	                    dflt: 1,
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                editType: "plot"
	              },
	              line: {
	                color: {
	                  valType: "color",
	                  editType: "style"
	                },
	                width: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 2,
	                  editType: "style"
	                },
	                editType: "plot"
	              },
	              fillcolor: scatterAttrs.fillcolor,
	              whiskerwidth: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0.5,
	                editType: "calc"
	              },
	              showwhiskers: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              offsetgroup: barAttrs.offsetgroup,
	              alignmentgroup: barAttrs.alignmentgroup,
	              selected: {
	                marker: scatterAttrs.selected.marker,
	                editType: "style"
	              },
	              unselected: {
	                marker: scatterAttrs.unselected.marker,
	                editType: "style"
	              },
	              text: extendFlat({}, scatterAttrs.text, {}),
	              hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
	              hovertemplate: hovertemplateAttrs({}),
	              hoveron: {
	                valType: "flaglist",
	                flags: ["boxes", "points"],
	                dflt: "boxes+points",
	                editType: "style"
	              }
	            };
	          }
	        ),
	        /***/
	        48518: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var Lib = __webpack_require__2(71828);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var _ = Lib._;
	            module2.exports = function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var xa = Axes.getFromId(gd, trace.xaxis || "x");
	              var ya = Axes.getFromId(gd, trace.yaxis || "y");
	              var cd = [];
	              var numKey = trace.type === "violin" ? "_numViolins" : "_numBoxes";
	              var i, j;
	              var valAxis, valLetter;
	              var posAxis, posLetter;
	              var hasPeriod;
	              if (trace.orientation === "h") {
	                valAxis = xa;
	                valLetter = "x";
	                posAxis = ya;
	                posLetter = "y";
	                hasPeriod = !!trace.yperiodalignment;
	              } else {
	                valAxis = ya;
	                valLetter = "y";
	                posAxis = xa;
	                posLetter = "x";
	                hasPeriod = !!trace.xperiodalignment;
	              }
	              var allPosArrays = getPosArrays(trace, posLetter, posAxis, fullLayout[numKey]);
	              var posArray = allPosArrays[0];
	              var origPos = allPosArrays[1];
	              var dv = Lib.distinctVals(posArray, posAxis);
	              var posDistinct = dv.vals;
	              var dPos = dv.minDiff / 2;
	              var cdi;
	              var pts;
	              var boxVals;
	              var N;
	              var pt;
	              var v;
	              var ptFilterFn = (trace.boxpoints || trace.points) === "all" ? Lib.identity : function(pt2) {
	                return pt2.v < cdi.lf || pt2.v > cdi.uf;
	              };
	              if (trace._hasPreCompStats) {
	                var valArrayRaw = trace[valLetter];
	                var d2c = function(k) {
	                  return valAxis.d2c((trace[k] || [])[i]);
	                };
	                var minVal = Infinity;
	                var maxVal = -Infinity;
	                for (i = 0; i < trace._length; i++) {
	                  var posi = posArray[i];
	                  if (!isNumeric(posi)) continue;
	                  cdi = {};
	                  cdi.pos = cdi[posLetter] = posi;
	                  if (hasPeriod && origPos) {
	                    cdi.orig_p = origPos[i];
	                  }
	                  cdi.q1 = d2c("q1");
	                  cdi.med = d2c("median");
	                  cdi.q3 = d2c("q3");
	                  pts = [];
	                  if (valArrayRaw && Lib.isArrayOrTypedArray(valArrayRaw[i])) {
	                    for (j = 0; j < valArrayRaw[i].length; j++) {
	                      v = valAxis.d2c(valArrayRaw[i][j]);
	                      if (v !== BADNUM) {
	                        pt = {
	                          v,
	                          i: [i, j]
	                        };
	                        arraysToCalcdata(pt, trace, [i, j]);
	                        pts.push(pt);
	                      }
	                    }
	                  }
	                  cdi.pts = pts.sort(sortByVal);
	                  boxVals = cdi[valLetter] = pts.map(extractVal);
	                  N = boxVals.length;
	                  if (cdi.med !== BADNUM && cdi.q1 !== BADNUM && cdi.q3 !== BADNUM && cdi.med >= cdi.q1 && cdi.q3 >= cdi.med) {
	                    var lf = d2c("lowerfence");
	                    cdi.lf = lf !== BADNUM && lf <= cdi.q1 ? lf : computeLowerFence(cdi, boxVals, N);
	                    var uf = d2c("upperfence");
	                    cdi.uf = uf !== BADNUM && uf >= cdi.q3 ? uf : computeUpperFence(cdi, boxVals, N);
	                    var mean = d2c("mean");
	                    cdi.mean = mean !== BADNUM ? mean : N ? Lib.mean(boxVals, N) : (cdi.q1 + cdi.q3) / 2;
	                    var sd = d2c("sd");
	                    cdi.sd = mean !== BADNUM && sd >= 0 ? sd : N ? Lib.stdev(boxVals, N, cdi.mean) : cdi.q3 - cdi.q1;
	                    cdi.lo = computeLowerOutlierBound(cdi);
	                    cdi.uo = computeUpperOutlierBound(cdi);
	                    var ns = d2c("notchspan");
	                    ns = ns !== BADNUM && ns > 0 ? ns : computeNotchSpan(cdi, N);
	                    cdi.ln = cdi.med - ns;
	                    cdi.un = cdi.med + ns;
	                    var imin = cdi.lf;
	                    var imax = cdi.uf;
	                    if (trace.boxpoints && boxVals.length) {
	                      imin = Math.min(imin, boxVals[0]);
	                      imax = Math.max(imax, boxVals[N - 1]);
	                    }
	                    if (trace.notched) {
	                      imin = Math.min(imin, cdi.ln);
	                      imax = Math.max(imax, cdi.un);
	                    }
	                    cdi.min = imin;
	                    cdi.max = imax;
	                  } else {
	                    Lib.warn(["Invalid input - make sure that q1 <= median <= q3", "q1 = " + cdi.q1, "median = " + cdi.med, "q3 = " + cdi.q3].join("\n"));
	                    var v0;
	                    if (cdi.med !== BADNUM) {
	                      v0 = cdi.med;
	                    } else if (cdi.q1 !== BADNUM) {
	                      if (cdi.q3 !== BADNUM) v0 = (cdi.q1 + cdi.q3) / 2;
	                      else v0 = cdi.q1;
	                    } else if (cdi.q3 !== BADNUM) {
	                      v0 = cdi.q3;
	                    } else {
	                      v0 = 0;
	                    }
	                    cdi.med = v0;
	                    cdi.q1 = cdi.q3 = v0;
	                    cdi.lf = cdi.uf = v0;
	                    cdi.mean = cdi.sd = v0;
	                    cdi.ln = cdi.un = v0;
	                    cdi.min = cdi.max = v0;
	                  }
	                  minVal = Math.min(minVal, cdi.min);
	                  maxVal = Math.max(maxVal, cdi.max);
	                  cdi.pts2 = pts.filter(ptFilterFn);
	                  cd.push(cdi);
	                }
	                trace._extremes[valAxis._id] = Axes.findExtremes(valAxis, [minVal, maxVal], {
	                  padded: true
	                });
	              } else {
	                var valArray = valAxis.makeCalcdata(trace, valLetter);
	                var posBins = makeBins(posDistinct, dPos);
	                var pLen = posDistinct.length;
	                var ptsPerBin = initNestedArray(pLen);
	                for (i = 0; i < trace._length; i++) {
	                  v = valArray[i];
	                  if (!isNumeric(v)) continue;
	                  var n = Lib.findBin(posArray[i], posBins);
	                  if (n >= 0 && n < pLen) {
	                    pt = {
	                      v,
	                      i
	                    };
	                    arraysToCalcdata(pt, trace, i);
	                    ptsPerBin[n].push(pt);
	                  }
	                }
	                var minLowerNotch = Infinity;
	                var maxUpperNotch = -Infinity;
	                var quartilemethod = trace.quartilemethod;
	                var usesExclusive = quartilemethod === "exclusive";
	                var usesInclusive = quartilemethod === "inclusive";
	                for (i = 0; i < pLen; i++) {
	                  if (ptsPerBin[i].length > 0) {
	                    cdi = {};
	                    cdi.pos = cdi[posLetter] = posDistinct[i];
	                    pts = cdi.pts = ptsPerBin[i].sort(sortByVal);
	                    boxVals = cdi[valLetter] = pts.map(extractVal);
	                    N = boxVals.length;
	                    cdi.min = boxVals[0];
	                    cdi.max = boxVals[N - 1];
	                    cdi.mean = Lib.mean(boxVals, N);
	                    cdi.sd = Lib.stdev(boxVals, N, cdi.mean) * trace.sdmultiple;
	                    cdi.med = Lib.interp(boxVals, 0.5);
	                    if (N % 2 && (usesExclusive || usesInclusive)) {
	                      var lower;
	                      var upper;
	                      if (usesExclusive) {
	                        lower = boxVals.slice(0, N / 2);
	                        upper = boxVals.slice(N / 2 + 1);
	                      } else if (usesInclusive) {
	                        lower = boxVals.slice(0, N / 2 + 1);
	                        upper = boxVals.slice(N / 2);
	                      }
	                      cdi.q1 = Lib.interp(lower, 0.5);
	                      cdi.q3 = Lib.interp(upper, 0.5);
	                    } else {
	                      cdi.q1 = Lib.interp(boxVals, 0.25);
	                      cdi.q3 = Lib.interp(boxVals, 0.75);
	                    }
	                    cdi.lf = computeLowerFence(cdi, boxVals, N);
	                    cdi.uf = computeUpperFence(cdi, boxVals, N);
	                    cdi.lo = computeLowerOutlierBound(cdi);
	                    cdi.uo = computeUpperOutlierBound(cdi);
	                    var mci = computeNotchSpan(cdi, N);
	                    cdi.ln = cdi.med - mci;
	                    cdi.un = cdi.med + mci;
	                    minLowerNotch = Math.min(minLowerNotch, cdi.ln);
	                    maxUpperNotch = Math.max(maxUpperNotch, cdi.un);
	                    cdi.pts2 = pts.filter(ptFilterFn);
	                    cd.push(cdi);
	                  }
	                }
	                trace._extremes[valAxis._id] = Axes.findExtremes(valAxis, trace.notched ? valArray.concat([minLowerNotch, maxUpperNotch]) : valArray, {
	                  padded: true
	                });
	              }
	              calcSelection(cd, trace);
	              if (cd.length > 0) {
	                cd[0].t = {
	                  num: fullLayout[numKey],
	                  dPos,
	                  posLetter,
	                  valLetter,
	                  labels: {
	                    med: _(gd, "median:"),
	                    min: _(gd, "min:"),
	                    q1: _(gd, "q1:"),
	                    q3: _(gd, "q3:"),
	                    max: _(gd, "max:"),
	                    mean: trace.boxmean === "sd" || trace.sizemode === "sd" ? _(gd, "mean ± σ:").replace("σ", trace.sdmultiple === 1 ? "σ" : trace.sdmultiple + "σ") : (
	                      // displaying mean +- Nσ whilst supporting translations
	                      _(gd, "mean:")
	                    ),
	                    lf: _(gd, "lower fence:"),
	                    uf: _(gd, "upper fence:")
	                  }
	                };
	                fullLayout[numKey]++;
	                return cd;
	              } else {
	                return [{
	                  t: {
	                    empty: true
	                  }
	                }];
	              }
	            };
	            function getPosArrays(trace, posLetter, posAxis, num) {
	              var hasPosArray = posLetter in trace;
	              var hasPos0 = posLetter + "0" in trace;
	              var hasPosStep = "d" + posLetter in trace;
	              if (hasPosArray || hasPos0 && hasPosStep) {
	                var origPos = posAxis.makeCalcdata(trace, posLetter);
	                var pos = alignPeriod(trace, posAxis, posLetter, origPos).vals;
	                return [pos, origPos];
	              }
	              var pos0;
	              if (hasPos0) {
	                pos0 = trace[posLetter + "0"];
	              } else if ("name" in trace && (posAxis.type === "category" || isNumeric(trace.name) && ["linear", "log"].indexOf(posAxis.type) !== -1 || Lib.isDateTime(trace.name) && posAxis.type === "date")) {
	                pos0 = trace.name;
	              } else {
	                pos0 = num;
	              }
	              var pos0c = posAxis.type === "multicategory" ? posAxis.r2c_just_indices(pos0) : posAxis.d2c(pos0, 0, trace[posLetter + "calendar"]);
	              var len = trace._length;
	              var out = new Array(len);
	              for (var i = 0; i < len; i++) out[i] = pos0c;
	              return [out];
	            }
	            function makeBins(x, dx) {
	              var len = x.length;
	              var bins = new Array(len + 1);
	              for (var i = 0; i < len; i++) {
	                bins[i] = x[i] - dx;
	              }
	              bins[len] = x[len - 1] + dx;
	              return bins;
	            }
	            function initNestedArray(len) {
	              var arr = new Array(len);
	              for (var i = 0; i < len; i++) {
	                arr[i] = [];
	              }
	              return arr;
	            }
	            var TRACE_TO_CALC = {
	              text: "tx",
	              hovertext: "htx"
	            };
	            function arraysToCalcdata(pt, trace, ptNumber) {
	              for (var k in TRACE_TO_CALC) {
	                if (Lib.isArrayOrTypedArray(trace[k])) {
	                  if (Array.isArray(ptNumber)) {
	                    if (Lib.isArrayOrTypedArray(trace[k][ptNumber[0]])) {
	                      pt[TRACE_TO_CALC[k]] = trace[k][ptNumber[0]][ptNumber[1]];
	                    }
	                  } else {
	                    pt[TRACE_TO_CALC[k]] = trace[k][ptNumber];
	                  }
	                }
	              }
	            }
	            function calcSelection(cd, trace) {
	              if (Lib.isArrayOrTypedArray(trace.selectedpoints)) {
	                for (var i = 0; i < cd.length; i++) {
	                  var pts = cd[i].pts || [];
	                  var ptNumber2cdIndex = {};
	                  for (var j = 0; j < pts.length; j++) {
	                    ptNumber2cdIndex[pts[j].i] = j;
	                  }
	                  Lib.tagSelected(pts, trace, ptNumber2cdIndex);
	                }
	              }
	            }
	            function sortByVal(a, b) {
	              return a.v - b.v;
	            }
	            function extractVal(o) {
	              return o.v;
	            }
	            function computeLowerFence(cdi, boxVals, N) {
	              if (N === 0) return cdi.q1;
	              return Math.min(cdi.q1, boxVals[Math.min(Lib.findBin(2.5 * cdi.q1 - 1.5 * cdi.q3, boxVals, true) + 1, N - 1)]);
	            }
	            function computeUpperFence(cdi, boxVals, N) {
	              if (N === 0) return cdi.q3;
	              return Math.max(cdi.q3, boxVals[Math.max(Lib.findBin(2.5 * cdi.q3 - 1.5 * cdi.q1, boxVals), 0)]);
	            }
	            function computeLowerOutlierBound(cdi) {
	              return 4 * cdi.q1 - 3 * cdi.q3;
	            }
	            function computeUpperOutlierBound(cdi) {
	              return 4 * cdi.q3 - 3 * cdi.q1;
	            }
	            function computeNotchSpan(cdi, N) {
	              if (N === 0) return 0;
	              return 1.57 * (cdi.q3 - cdi.q1) / Math.sqrt(N);
	            }
	          }
	        ),
	        /***/
	        37188: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var getAxisGroup = __webpack_require__2(99082).getAxisGroup;
	            var orientations = ["v", "h"];
	            function crossTraceCalc(gd, plotinfo) {
	              var calcdata = gd.calcdata;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              for (var i = 0; i < orientations.length; i++) {
	                var orientation = orientations[i];
	                var posAxis = orientation === "h" ? ya : xa;
	                var boxList = [];
	                for (var j = 0; j < calcdata.length; j++) {
	                  var cd = calcdata[j];
	                  var t = cd[0].t;
	                  var trace = cd[0].trace;
	                  if (trace.visible === true && (trace.type === "box" || trace.type === "candlestick") && !t.empty && (trace.orientation || "v") === orientation && trace.xaxis === xa._id && trace.yaxis === ya._id) {
	                    boxList.push(j);
	                  }
	                }
	                setPositionOffset("box", gd, boxList, posAxis);
	              }
	            }
	            function setPositionOffset(traceType, gd, boxList, posAxis) {
	              var calcdata = gd.calcdata;
	              var fullLayout = gd._fullLayout;
	              var axId = posAxis._id;
	              var axLetter = axId.charAt(0);
	              var i, j, calcTrace;
	              var pointList = [];
	              var shownPts = 0;
	              for (i = 0; i < boxList.length; i++) {
	                calcTrace = calcdata[boxList[i]];
	                for (j = 0; j < calcTrace.length; j++) {
	                  pointList.push(posAxis.c2l(calcTrace[j].pos, true));
	                  shownPts += (calcTrace[j].pts2 || []).length;
	                }
	              }
	              if (!pointList.length) return;
	              var boxdv = Lib.distinctVals(pointList);
	              if (posAxis.type === "category" || posAxis.type === "multicategory") {
	                boxdv.minDiff = 1;
	              }
	              var dPos0 = boxdv.minDiff / 2;
	              Axes.minDtick(posAxis, boxdv.minDiff, boxdv.vals[0], true);
	              var numKey = traceType === "violin" ? "_numViolins" : "_numBoxes";
	              var numTotal = fullLayout[numKey];
	              var group = fullLayout[traceType + "mode"] === "group" && numTotal > 1;
	              var groupFraction = 1 - fullLayout[traceType + "gap"];
	              var groupGapFraction = 1 - fullLayout[traceType + "groupgap"];
	              for (i = 0; i < boxList.length; i++) {
	                calcTrace = calcdata[boxList[i]];
	                var trace = calcTrace[0].trace;
	                var t = calcTrace[0].t;
	                var width = trace.width;
	                var side = trace.side;
	                var dPos;
	                var bdPos;
	                var bPos;
	                var wHover;
	                if (width) {
	                  dPos = bdPos = wHover = width / 2;
	                  bPos = 0;
	                } else {
	                  dPos = dPos0;
	                  if (group) {
	                    var groupId = getAxisGroup(fullLayout, posAxis._id) + trace.orientation;
	                    var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
	                    var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
	                    var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
	                    var num = nOffsetGroups || numTotal;
	                    var shift = nOffsetGroups ? trace._offsetIndex : t.num;
	                    bdPos = dPos * groupFraction * groupGapFraction / num;
	                    bPos = 2 * dPos * (-0.5 + (shift + 0.5) / num) * groupFraction;
	                    wHover = dPos * groupFraction / num;
	                  } else {
	                    bdPos = dPos * groupFraction * groupGapFraction;
	                    bPos = 0;
	                    wHover = dPos;
	                  }
	                }
	                t.dPos = dPos;
	                t.bPos = bPos;
	                t.bdPos = bdPos;
	                t.wHover = wHover;
	                var pushplus;
	                var pushminus;
	                var edge = bPos + bdPos;
	                var edgeplus;
	                var edgeminus;
	                var vpadplus;
	                var vpadminus;
	                var ppadplus;
	                var ppadminus;
	                var padded = Boolean(width);
	                var hasPts = (trace.boxpoints || trace.points) && shownPts > 0;
	                if (side === "positive") {
	                  pushplus = dPos * (width ? 1 : 0.5);
	                  edgeplus = edge;
	                  pushminus = edgeplus = bPos;
	                } else if (side === "negative") {
	                  pushplus = edgeplus = bPos;
	                  pushminus = dPos * (width ? 1 : 0.5);
	                  edgeminus = edge;
	                } else {
	                  pushplus = pushminus = dPos;
	                  edgeplus = edgeminus = edge;
	                }
	                if (hasPts) {
	                  var pointpos = trace.pointpos;
	                  var jitter = trace.jitter;
	                  var ms = trace.marker.size / 2;
	                  var pp = 0;
	                  if (pointpos + jitter >= 0) {
	                    pp = edge * (pointpos + jitter);
	                    if (pp > pushplus) {
	                      padded = true;
	                      ppadplus = ms;
	                      vpadplus = pp;
	                    } else if (pp > edgeplus) {
	                      ppadplus = ms;
	                      vpadplus = pushplus;
	                    }
	                  }
	                  if (pp <= pushplus) {
	                    vpadplus = pushplus;
	                  }
	                  var pm = 0;
	                  if (pointpos - jitter <= 0) {
	                    pm = -edge * (pointpos - jitter);
	                    if (pm > pushminus) {
	                      padded = true;
	                      ppadminus = ms;
	                      vpadminus = pm;
	                    } else if (pm > edgeminus) {
	                      ppadminus = ms;
	                      vpadminus = pushminus;
	                    }
	                  }
	                  if (pm <= pushminus) {
	                    vpadminus = pushminus;
	                  }
	                } else {
	                  vpadplus = pushplus;
	                  vpadminus = pushminus;
	                }
	                var pos = new Array(calcTrace.length);
	                for (j = 0; j < calcTrace.length; j++) {
	                  pos[j] = calcTrace[j].pos;
	                }
	                trace._extremes[axId] = Axes.findExtremes(posAxis, pos, {
	                  padded,
	                  vpadminus,
	                  vpadplus,
	                  vpadLinearized: true,
	                  // N.B. SVG px-space positive/negative
	                  ppadminus: {
	                    x: ppadminus,
	                    y: ppadplus
	                  }[axLetter],
	                  ppadplus: {
	                    x: ppadplus,
	                    y: ppadminus
	                  }[axLetter]
	                });
	              }
	            }
	            module2.exports = {
	              crossTraceCalc,
	              setPositionOffset
	            };
	          }
	        ),
	        /***/
	        36411: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var Color = __webpack_require__2(7901);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var handleGroupingDefaults = __webpack_require__2(26125);
	            var autoType = __webpack_require__2(4322);
	            var attributes = __webpack_require__2(53522);
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              handleSampleDefaults(traceIn, traceOut, coerce, layout);
	              if (traceOut.visible === false) return;
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              var hasPreCompStats = traceOut._hasPreCompStats;
	              if (hasPreCompStats) {
	                coerce("lowerfence");
	                coerce("upperfence");
	              }
	              coerce("line.color", (traceIn.marker || {}).color || defaultColor);
	              coerce("line.width");
	              coerce("fillcolor", Color.addOpacity(traceOut.line.color, 0.5));
	              var boxmeanDflt = false;
	              if (hasPreCompStats) {
	                var mean = coerce("mean");
	                var sd = coerce("sd");
	                if (mean && mean.length) {
	                  boxmeanDflt = true;
	                  if (sd && sd.length) boxmeanDflt = "sd";
	                }
	              }
	              coerce("whiskerwidth");
	              var sizemode = coerce("sizemode");
	              var boxmean;
	              if (sizemode === "quartiles") {
	                boxmean = coerce("boxmean", boxmeanDflt);
	              }
	              coerce("showwhiskers", sizemode === "quartiles");
	              if (sizemode === "sd" || boxmean === "sd") {
	                coerce("sdmultiple");
	              }
	              coerce("width");
	              coerce("quartilemethod");
	              var notchedDflt = false;
	              if (hasPreCompStats) {
	                var notchspan = coerce("notchspan");
	                if (notchspan && notchspan.length) {
	                  notchedDflt = true;
	                }
	              } else if (Lib.validate(traceIn.notchwidth, attributes.notchwidth)) {
	                notchedDflt = true;
	              }
	              var notched = coerce("notched", notchedDflt);
	              if (notched) coerce("notchwidth");
	              handlePointsDefaults(traceIn, traceOut, coerce, {
	                prefix: "box"
	              });
	            }
	            function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
	              function getDims(arr) {
	                var dims = 0;
	                if (arr && arr.length) {
	                  dims += 1;
	                  if (Lib.isArrayOrTypedArray(arr[0]) && arr[0].length) {
	                    dims += 1;
	                  }
	                }
	                return dims;
	              }
	              function valid(astr) {
	                return Lib.validate(traceIn[astr], attributes[astr]);
	              }
	              var y = coerce("y");
	              var x = coerce("x");
	              var sLen;
	              if (traceOut.type === "box") {
	                var q1 = coerce("q1");
	                var median = coerce("median");
	                var q3 = coerce("q3");
	                traceOut._hasPreCompStats = q1 && q1.length && median && median.length && q3 && q3.length;
	                sLen = Math.min(Lib.minRowLength(q1), Lib.minRowLength(median), Lib.minRowLength(q3));
	              }
	              var yDims = getDims(y);
	              var xDims = getDims(x);
	              var yLen = yDims && Lib.minRowLength(y);
	              var xLen = xDims && Lib.minRowLength(x);
	              var calendar = layout.calendar;
	              var opts = {
	                autotypenumbers: layout.autotypenumbers
	              };
	              var defaultOrientation, len;
	              if (traceOut._hasPreCompStats) {
	                switch (String(xDims) + String(yDims)) {
	                  case "00":
	                    var setInX = valid("x0") || valid("dx");
	                    var setInY = valid("y0") || valid("dy");
	                    if (setInY && !setInX) {
	                      defaultOrientation = "h";
	                    } else {
	                      defaultOrientation = "v";
	                    }
	                    len = sLen;
	                    break;
	                  case "10":
	                    defaultOrientation = "v";
	                    len = Math.min(sLen, xLen);
	                    break;
	                  case "20":
	                    defaultOrientation = "h";
	                    len = Math.min(sLen, x.length);
	                    break;
	                  case "01":
	                    defaultOrientation = "h";
	                    len = Math.min(sLen, yLen);
	                    break;
	                  case "02":
	                    defaultOrientation = "v";
	                    len = Math.min(sLen, y.length);
	                    break;
	                  case "12":
	                    defaultOrientation = "v";
	                    len = Math.min(sLen, xLen, y.length);
	                    break;
	                  case "21":
	                    defaultOrientation = "h";
	                    len = Math.min(sLen, x.length, yLen);
	                    break;
	                  case "11":
	                    len = 0;
	                    break;
	                  case "22":
	                    var hasCategories = false;
	                    var i;
	                    for (i = 0; i < x.length; i++) {
	                      if (autoType(x[i], calendar, opts) === "category") {
	                        hasCategories = true;
	                        break;
	                      }
	                    }
	                    if (hasCategories) {
	                      defaultOrientation = "v";
	                      len = Math.min(sLen, xLen, y.length);
	                    } else {
	                      for (i = 0; i < y.length; i++) {
	                        if (autoType(y[i], calendar, opts) === "category") {
	                          hasCategories = true;
	                          break;
	                        }
	                      }
	                      if (hasCategories) {
	                        defaultOrientation = "h";
	                        len = Math.min(sLen, x.length, yLen);
	                      } else {
	                        defaultOrientation = "v";
	                        len = Math.min(sLen, xLen, y.length);
	                      }
	                    }
	                    break;
	                }
	              } else if (yDims > 0) {
	                defaultOrientation = "v";
	                if (xDims > 0) {
	                  len = Math.min(xLen, yLen);
	                } else {
	                  len = Math.min(yLen);
	                }
	              } else if (xDims > 0) {
	                defaultOrientation = "h";
	                len = Math.min(xLen);
	              } else {
	                len = 0;
	              }
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              var orientation = coerce("orientation", defaultOrientation);
	              if (traceOut._hasPreCompStats) {
	                if (orientation === "v" && xDims === 0) {
	                  coerce("x0", 0);
	                  coerce("dx", 1);
	                } else if (orientation === "h" && yDims === 0) {
	                  coerce("y0", 0);
	                  coerce("dy", 1);
	                }
	              } else {
	                if (orientation === "v" && xDims === 0) {
	                  coerce("x0");
	                } else if (orientation === "h" && yDims === 0) {
	                  coerce("y0");
	                }
	              }
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y"], layout);
	            }
	            function handlePointsDefaults(traceIn, traceOut, coerce, opts) {
	              var prefix = opts.prefix;
	              var outlierColorDflt = Lib.coerce2(traceIn, traceOut, attributes, "marker.outliercolor");
	              var lineoutliercolor = coerce("marker.line.outliercolor");
	              var modeDflt = "outliers";
	              if (traceOut._hasPreCompStats) {
	                modeDflt = "all";
	              } else if (outlierColorDflt || lineoutliercolor) {
	                modeDflt = "suspectedoutliers";
	              }
	              var mode = coerce(prefix + "points", modeDflt);
	              if (mode) {
	                coerce("jitter", mode === "all" ? 0.3 : 0);
	                coerce("pointpos", mode === "all" ? -1.5 : 0);
	                coerce("marker.symbol");
	                coerce("marker.opacity");
	                coerce("marker.size");
	                coerce("marker.angle");
	                coerce("marker.color", traceOut.line.color);
	                coerce("marker.line.color");
	                coerce("marker.line.width");
	                if (mode === "suspectedoutliers") {
	                  coerce("marker.line.outliercolor", traceOut.marker.color);
	                  coerce("marker.line.outlierwidth");
	                }
	                coerce("selected.marker.color");
	                coerce("unselected.marker.color");
	                coerce("selected.marker.size");
	                coerce("unselected.marker.size");
	                coerce("text");
	                coerce("hovertext");
	              } else {
	                delete traceOut.marker;
	              }
	              var hoveron = coerce("hoveron");
	              if (hoveron === "all" || hoveron.indexOf("points") !== -1) {
	                coerce("hovertemplate");
	              }
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            }
	            function crossTraceDefaults(fullData, fullLayout) {
	              var traceIn, traceOut;
	              function coerce(attr) {
	                return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	              }
	              for (var i = 0; i < fullData.length; i++) {
	                traceOut = fullData[i];
	                var traceType = traceOut.type;
	                if (traceType === "box" || traceType === "violin") {
	                  traceIn = traceOut._input;
	                  if (fullLayout[traceType + "mode"] === "group") {
	                    handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	                  }
	                }
	              }
	            }
	            module2.exports = {
	              supplyDefaults,
	              crossTraceDefaults,
	              handleSampleDefaults,
	              handlePointsDefaults
	            };
	          }
	        ),
	        /***/
	        74907: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt) {
	              if (pt.hoverOnBox) out.hoverOnBox = pt.hoverOnBox;
	              if ("xVal" in pt) out.x = pt.xVal;
	              if ("yVal" in pt) out.y = pt.yVal;
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              return out;
	            };
	          }
	        ),
	        /***/
	        41868: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var Fx = __webpack_require__2(30211);
	            var Color = __webpack_require__2(7901);
	            var fillText = Lib.fillText;
	            function hoverPoints(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var hoveron = trace.hoveron;
	              var closeBoxData = [];
	              var closePtData;
	              if (hoveron.indexOf("boxes") !== -1) {
	                closeBoxData = closeBoxData.concat(hoverOnBoxes(pointData, xval, yval, hovermode));
	              }
	              if (hoveron.indexOf("points") !== -1) {
	                closePtData = hoverOnPoints(pointData, xval, yval);
	              }
	              if (hovermode === "closest") {
	                if (closePtData) return [closePtData];
	                return closeBoxData;
	              }
	              if (closePtData) {
	                closeBoxData.push(closePtData);
	                return closeBoxData;
	              }
	              return closeBoxData;
	            }
	            function hoverOnBoxes(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var trace = cd[0].trace;
	              var t = cd[0].t;
	              var isViolin = trace.type === "violin";
	              var pLetter, vLetter, pAxis, vAxis, vVal, pVal, dx, dy, dPos, hoverPseudoDistance, spikePseudoDistance;
	              var boxDelta = t.bdPos;
	              var boxDeltaPos, boxDeltaNeg;
	              var posAcceptance = t.wHover;
	              var shiftPos = function(di2) {
	                return pAxis.c2l(di2.pos) + t.bPos - pAxis.c2l(pVal);
	              };
	              if (isViolin && trace.side !== "both") {
	                if (trace.side === "positive") {
	                  dPos = function(di2) {
	                    var pos = shiftPos(di2);
	                    return Fx.inbox(pos, pos + posAcceptance, hoverPseudoDistance);
	                  };
	                  boxDeltaPos = boxDelta;
	                  boxDeltaNeg = 0;
	                }
	                if (trace.side === "negative") {
	                  dPos = function(di2) {
	                    var pos = shiftPos(di2);
	                    return Fx.inbox(pos - posAcceptance, pos, hoverPseudoDistance);
	                  };
	                  boxDeltaPos = 0;
	                  boxDeltaNeg = boxDelta;
	                }
	              } else {
	                dPos = function(di2) {
	                  var pos = shiftPos(di2);
	                  return Fx.inbox(pos - posAcceptance, pos + posAcceptance, hoverPseudoDistance);
	                };
	                boxDeltaPos = boxDeltaNeg = boxDelta;
	              }
	              var dVal;
	              if (isViolin) {
	                dVal = function(di2) {
	                  return Fx.inbox(di2.span[0] - vVal, di2.span[1] - vVal, hoverPseudoDistance);
	                };
	              } else {
	                dVal = function(di2) {
	                  return Fx.inbox(di2.min - vVal, di2.max - vVal, hoverPseudoDistance);
	                };
	              }
	              if (trace.orientation === "h") {
	                vVal = xval;
	                pVal = yval;
	                dx = dVal;
	                dy = dPos;
	                pLetter = "y";
	                pAxis = ya;
	                vLetter = "x";
	                vAxis = xa;
	              } else {
	                vVal = yval;
	                pVal = xval;
	                dx = dPos;
	                dy = dVal;
	                pLetter = "x";
	                pAxis = xa;
	                vLetter = "y";
	                vAxis = ya;
	              }
	              var pseudoDistance = Math.min(1, boxDelta / Math.abs(pAxis.r2c(pAxis.range[1]) - pAxis.r2c(pAxis.range[0])));
	              hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
	              spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
	              function dxy(di2) {
	                return (dx(di2) + dy(di2)) / 2;
	              }
	              var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	              Fx.getClosest(cd, distfn, pointData);
	              if (pointData.index === false) return [];
	              var di = cd[pointData.index];
	              var lc = trace.line.color;
	              var mc = (trace.marker || {}).color;
	              if (Color.opacity(lc) && trace.line.width) pointData.color = lc;
	              else if (Color.opacity(mc) && trace.boxpoints) pointData.color = mc;
	              else pointData.color = trace.fillcolor;
	              pointData[pLetter + "0"] = pAxis.c2p(di.pos + t.bPos - boxDeltaNeg, true);
	              pointData[pLetter + "1"] = pAxis.c2p(di.pos + t.bPos + boxDeltaPos, true);
	              pointData[pLetter + "LabelVal"] = di.orig_p !== undefined ? di.orig_p : di.pos;
	              var spikePosAttr = pLetter + "Spike";
	              pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
	              pointData[spikePosAttr] = pAxis.c2p(di.pos, true);
	              var hasMean = trace.boxmean || trace.sizemode === "sd" || (trace.meanline || {}).visible;
	              var hasFences = trace.boxpoints || trace.points;
	              var attrs = hasFences && hasMean ? ["max", "uf", "q3", "med", "mean", "q1", "lf", "min"] : hasFences && !hasMean ? ["max", "uf", "q3", "med", "q1", "lf", "min"] : !hasFences && hasMean ? ["max", "q3", "med", "mean", "q1", "min"] : ["max", "q3", "med", "q1", "min"];
	              var rev = vAxis.range[1] < vAxis.range[0];
	              if (trace.orientation === (rev ? "v" : "h")) {
	                attrs.reverse();
	              }
	              var spikeDistance = pointData.spikeDistance;
	              var spikePosition = pointData[spikePosAttr];
	              var closeBoxData = [];
	              for (var i = 0; i < attrs.length; i++) {
	                var attr = attrs[i];
	                if (!(attr in di)) continue;
	                var val = di[attr];
	                var valPx = vAxis.c2p(val, true);
	                var pointData2 = Lib.extendFlat({}, pointData);
	                pointData2.attr = attr;
	                pointData2[vLetter + "0"] = pointData2[vLetter + "1"] = valPx;
	                pointData2[vLetter + "LabelVal"] = val;
	                pointData2[vLetter + "Label"] = (t.labels ? t.labels[attr] + " " : "") + Axes.hoverLabelText(vAxis, val, trace[vLetter + "hoverformat"]);
	                pointData2.hoverOnBox = true;
	                if (attr === "mean" && "sd" in di && (trace.boxmean === "sd" || trace.sizemode === "sd")) {
	                  pointData2[vLetter + "err"] = di.sd;
	                }
	                pointData2.hovertemplate = false;
	                closeBoxData.push(pointData2);
	              }
	              pointData.name = "";
	              pointData.spikeDistance = undefined;
	              pointData[spikePosAttr] = undefined;
	              for (var k = 0; k < closeBoxData.length; k++) {
	                if (closeBoxData[k].attr !== "med") {
	                  closeBoxData[k].name = "";
	                  closeBoxData[k].spikeDistance = undefined;
	                  closeBoxData[k][spikePosAttr] = undefined;
	                } else {
	                  closeBoxData[k].spikeDistance = spikeDistance;
	                  closeBoxData[k][spikePosAttr] = spikePosition;
	                }
	              }
	              return closeBoxData;
	            }
	            function hoverOnPoints(pointData, xval, yval) {
	              var cd = pointData.cd;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var trace = cd[0].trace;
	              var xPx = xa.c2p(xval);
	              var yPx = ya.c2p(yval);
	              var closePtData;
	              var dx = function(di2) {
	                var rad2 = Math.max(3, di2.mrc || 0);
	                return Math.max(Math.abs(xa.c2p(di2.x) - xPx) - rad2, 1 - 3 / rad2);
	              };
	              var dy = function(di2) {
	                var rad2 = Math.max(3, di2.mrc || 0);
	                return Math.max(Math.abs(ya.c2p(di2.y) - yPx) - rad2, 1 - 3 / rad2);
	              };
	              var distfn = Fx.quadrature(dx, dy);
	              var ijClosest = false;
	              var di, pt;
	              for (var i = 0; i < cd.length; i++) {
	                di = cd[i];
	                for (var j = 0; j < (di.pts || []).length; j++) {
	                  pt = di.pts[j];
	                  var newDistance = distfn(pt);
	                  if (newDistance <= pointData.distance) {
	                    pointData.distance = newDistance;
	                    ijClosest = [i, j];
	                  }
	                }
	              }
	              if (!ijClosest) return false;
	              di = cd[ijClosest[0]];
	              pt = di.pts[ijClosest[1]];
	              var xc = xa.c2p(pt.x, true);
	              var yc = ya.c2p(pt.y, true);
	              var rad = pt.mrc || 1;
	              closePtData = Lib.extendFlat({}, pointData, {
	                // corresponds to index in x/y input data array
	                index: pt.i,
	                color: (trace.marker || {}).color,
	                name: trace.name,
	                x0: xc - rad,
	                x1: xc + rad,
	                y0: yc - rad,
	                y1: yc + rad,
	                spikeDistance: pointData.distance,
	                hovertemplate: trace.hovertemplate
	              });
	              var origPos = di.orig_p;
	              var pos = origPos !== undefined ? origPos : di.pos;
	              var pa;
	              if (trace.orientation === "h") {
	                pa = ya;
	                closePtData.xLabelVal = pt.x;
	                closePtData.yLabelVal = pos;
	              } else {
	                pa = xa;
	                closePtData.xLabelVal = pos;
	                closePtData.yLabelVal = pt.y;
	              }
	              var pLetter = pa._id.charAt(0);
	              closePtData[pLetter + "Spike"] = pa.c2p(di.pos, true);
	              fillText(pt, trace, closePtData);
	              return closePtData;
	            }
	            module2.exports = {
	              hoverPoints,
	              hoverOnBoxes,
	              hoverOnPoints
	            };
	          }
	        ),
	        /***/
	        83832: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(53522),
	              layoutAttributes: __webpack_require__2(40094),
	              supplyDefaults: __webpack_require__2(36411).supplyDefaults,
	              crossTraceDefaults: __webpack_require__2(36411).crossTraceDefaults,
	              supplyLayoutDefaults: __webpack_require__2(4199).supplyLayoutDefaults,
	              calc: __webpack_require__2(48518),
	              crossTraceCalc: __webpack_require__2(37188).crossTraceCalc,
	              plot: __webpack_require__2(86047).plot,
	              style: __webpack_require__2(58063).style,
	              styleOnSelect: __webpack_require__2(58063).styleOnSelect,
	              hoverPoints: __webpack_require__2(41868).hoverPoints,
	              eventData: __webpack_require__2(74907),
	              selectPoints: __webpack_require__2(24626),
	              moduleType: "trace",
	              name: "box",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "symbols", "oriented", "box-violin", "showLegend", "boxLayout", "zoomScale"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        40094: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              boxmode: {
	                valType: "enumerated",
	                values: ["group", "overlay"],
	                dflt: "overlay",
	                editType: "calc"
	              },
	              boxgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0.3,
	                editType: "calc"
	              },
	              boxgroupgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0.3,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        4199: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(40094);
	            function _supply(layoutIn, layoutOut, fullData, coerce, traceType) {
	              var category = traceType + "Layout";
	              var hasTraceType = false;
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (Registry.traceIs(trace, category)) {
	                  hasTraceType = true;
	                  break;
	                }
	              }
	              if (!hasTraceType) return;
	              coerce(traceType + "mode");
	              coerce(traceType + "gap");
	              coerce(traceType + "groupgap");
	            }
	            function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              _supply(layoutIn, layoutOut, fullData, coerce, "box");
	            }
	            module2.exports = {
	              supplyLayoutDefaults,
	              _supply
	            };
	          }
	        ),
	        /***/
	        86047: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var JITTERCOUNT = 5;
	            var JITTERSPREAD = 0.01;
	            function plot(gd, plotinfo, cdbox, boxLayer) {
	              var isStatic = gd._context.staticPlot;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(boxLayer, cdbox, "trace boxes").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var t = cd0.t;
	                var trace = cd0.trace;
	                t.wdPos = t.bdPos * trace.whiskerwidth;
	                if (trace.visible !== true || t.empty) {
	                  plotGroup.remove();
	                  return;
	                }
	                var posAxis, valAxis;
	                if (trace.orientation === "h") {
	                  posAxis = ya;
	                  valAxis = xa;
	                } else {
	                  posAxis = xa;
	                  valAxis = ya;
	                }
	                plotBoxAndWhiskers(plotGroup, {
	                  pos: posAxis,
	                  val: valAxis
	                }, trace, t, isStatic);
	                plotPoints(plotGroup, {
	                  x: xa,
	                  y: ya
	                }, trace, t);
	                plotBoxMean(plotGroup, {
	                  pos: posAxis,
	                  val: valAxis
	                }, trace, t);
	              });
	            }
	            function plotBoxAndWhiskers(sel, axes, trace, t, isStatic) {
	              var isHorizontal = trace.orientation === "h";
	              var valAxis = axes.val;
	              var posAxis = axes.pos;
	              var posHasRangeBreaks = !!posAxis.rangebreaks;
	              var bPos = t.bPos;
	              var wdPos = t.wdPos || 0;
	              var bPosPxOffset = t.bPosPxOffset || 0;
	              var whiskerWidth = trace.whiskerwidth || 0;
	              var showWhiskers = trace.showwhiskers !== false;
	              var notched = trace.notched || false;
	              var nw = notched ? 1 - 2 * trace.notchwidth : 1;
	              var bdPos0;
	              var bdPos1;
	              if (Array.isArray(t.bdPos)) {
	                bdPos0 = t.bdPos[0];
	                bdPos1 = t.bdPos[1];
	              } else {
	                bdPos0 = t.bdPos;
	                bdPos1 = t.bdPos;
	              }
	              var paths = sel.selectAll("path.box").data(trace.type !== "violin" || trace.box.visible ? Lib.identity : []);
	              paths.enter().append("path").style("vector-effect", isStatic ? "none" : "non-scaling-stroke").attr("class", "box");
	              paths.exit().remove();
	              paths.each(function(d) {
	                if (d.empty) return d3.select(this).attr("d", "M0,0Z");
	                var lcenter = posAxis.c2l(d.pos + bPos, true);
	                var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
	                var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
	                var posc = posHasRangeBreaks ? (pos0 + pos1) / 2 : posAxis.l2p(lcenter) + bPosPxOffset;
	                var r = trace.whiskerwidth;
	                var posw0 = posHasRangeBreaks ? pos0 * r + (1 - r) * posc : posAxis.l2p(lcenter - wdPos) + bPosPxOffset;
	                var posw1 = posHasRangeBreaks ? pos1 * r + (1 - r) * posc : posAxis.l2p(lcenter + wdPos) + bPosPxOffset;
	                var posm0 = posAxis.l2p(lcenter - bdPos0 * nw) + bPosPxOffset;
	                var posm1 = posAxis.l2p(lcenter + bdPos1 * nw) + bPosPxOffset;
	                var sdmode = trace.sizemode === "sd";
	                var q1 = valAxis.c2p(sdmode ? d.mean - d.sd : d.q1, true);
	                var q3 = sdmode ? valAxis.c2p(d.mean + d.sd, true) : valAxis.c2p(d.q3, true);
	                var m = Lib.constrain(sdmode ? valAxis.c2p(d.mean, true) : valAxis.c2p(d.med, true), Math.min(q1, q3) + 1, Math.max(q1, q3) - 1);
	                var useExtremes = d.lf === undefined || trace.boxpoints === false || sdmode;
	                var lf = valAxis.c2p(useExtremes ? d.min : d.lf, true);
	                var uf = valAxis.c2p(useExtremes ? d.max : d.uf, true);
	                var ln = valAxis.c2p(d.ln, true);
	                var un = valAxis.c2p(d.un, true);
	                if (isHorizontal) {
	                  d3.select(this).attr("d", "M" + m + "," + posm0 + "V" + posm1 + // median line
	                  "M" + q1 + "," + pos0 + "V" + pos1 + // left edge
	                  (notched ? "H" + ln + "L" + m + "," + posm1 + "L" + un + "," + pos1 : "") + // top notched edge
	                  "H" + q3 + // end of the top edge
	                  "V" + pos0 + // right edge
	                  (notched ? "H" + un + "L" + m + "," + posm0 + "L" + ln + "," + pos0 : "") + // bottom notched edge
	                  "Z" + // end of the box
	                  (showWhiskers ? "M" + q1 + "," + posc + "H" + lf + "M" + q3 + "," + posc + "H" + uf + // whiskers
	                  (whiskerWidth === 0 ? "" : (
	                    // whisker caps
	                    "M" + lf + "," + posw0 + "V" + posw1 + "M" + uf + "," + posw0 + "V" + posw1
	                  )) : ""));
	                } else {
	                  d3.select(this).attr("d", "M" + posm0 + "," + m + "H" + posm1 + // median line
	                  "M" + pos0 + "," + q1 + "H" + pos1 + // top of the box
	                  (notched ? "V" + ln + "L" + posm1 + "," + m + "L" + pos1 + "," + un : "") + // notched right edge
	                  "V" + q3 + // end of the right edge
	                  "H" + pos0 + // bottom of the box
	                  (notched ? "V" + un + "L" + posm0 + "," + m + "L" + pos0 + "," + ln : "") + // notched left edge
	                  "Z" + // end of the box
	                  (showWhiskers ? "M" + posc + "," + q1 + "V" + lf + "M" + posc + "," + q3 + "V" + uf + // whiskers
	                  (whiskerWidth === 0 ? "" : (
	                    // whisker caps
	                    "M" + posw0 + "," + lf + "H" + posw1 + "M" + posw0 + "," + uf + "H" + posw1
	                  )) : ""));
	                }
	              });
	            }
	            function plotPoints(sel, axes, trace, t) {
	              var xa = axes.x;
	              var ya = axes.y;
	              var bdPos = t.bdPos;
	              var bPos = t.bPos;
	              var mode = trace.boxpoints || trace.points;
	              Lib.seedPseudoRandom();
	              var fn = function(d) {
	                d.forEach(function(v) {
	                  v.t = t;
	                  v.trace = trace;
	                });
	                return d;
	              };
	              var gPoints = sel.selectAll("g.points").data(mode ? fn : []);
	              gPoints.enter().append("g").attr("class", "points");
	              gPoints.exit().remove();
	              var paths = gPoints.selectAll("path").data(function(d) {
	                var i;
	                var pts = d.pts2;
	                var typicalSpread = Math.max((d.max - d.min) / 10, d.q3 - d.q1);
	                var minSpread = typicalSpread * 1e-9;
	                var spreadLimit = typicalSpread * JITTERSPREAD;
	                var jitterFactors = [];
	                var maxJitterFactor = 0;
	                var newJitter;
	                if (trace.jitter) {
	                  if (typicalSpread === 0) {
	                    maxJitterFactor = 1;
	                    jitterFactors = new Array(pts.length);
	                    for (i = 0; i < pts.length; i++) {
	                      jitterFactors[i] = 1;
	                    }
	                  } else {
	                    for (i = 0; i < pts.length; i++) {
	                      var i0 = Math.max(0, i - JITTERCOUNT);
	                      var pmin = pts[i0].v;
	                      var i1 = Math.min(pts.length - 1, i + JITTERCOUNT);
	                      var pmax = pts[i1].v;
	                      if (mode !== "all") {
	                        if (pts[i].v < d.lf) pmax = Math.min(pmax, d.lf);
	                        else pmin = Math.max(pmin, d.uf);
	                      }
	                      var jitterFactor = Math.sqrt(spreadLimit * (i1 - i0) / (pmax - pmin + minSpread)) || 0;
	                      jitterFactor = Lib.constrain(Math.abs(jitterFactor), 0, 1);
	                      jitterFactors.push(jitterFactor);
	                      maxJitterFactor = Math.max(jitterFactor, maxJitterFactor);
	                    }
	                  }
	                  newJitter = trace.jitter * 2 / (maxJitterFactor || 1);
	                }
	                for (i = 0; i < pts.length; i++) {
	                  var pt = pts[i];
	                  var v = pt.v;
	                  var jitterOffset = trace.jitter ? newJitter * jitterFactors[i] * (Lib.pseudoRandom() - 0.5) : 0;
	                  var posPx = d.pos + bPos + bdPos * (trace.pointpos + jitterOffset);
	                  if (trace.orientation === "h") {
	                    pt.y = posPx;
	                    pt.x = v;
	                  } else {
	                    pt.x = posPx;
	                    pt.y = v;
	                  }
	                  if (mode === "suspectedoutliers" && v < d.uo && v > d.lo) {
	                    pt.so = true;
	                  }
	                }
	                return pts;
	              });
	              paths.enter().append("path").classed("point", true);
	              paths.exit().remove();
	              paths.call(Drawing.translatePoints, xa, ya);
	            }
	            function plotBoxMean(sel, axes, trace, t) {
	              var valAxis = axes.val;
	              var posAxis = axes.pos;
	              var posHasRangeBreaks = !!posAxis.rangebreaks;
	              var bPos = t.bPos;
	              var bPosPxOffset = t.bPosPxOffset || 0;
	              var mode = trace.boxmean || (trace.meanline || {}).visible;
	              var bdPos0;
	              var bdPos1;
	              if (Array.isArray(t.bdPos)) {
	                bdPos0 = t.bdPos[0];
	                bdPos1 = t.bdPos[1];
	              } else {
	                bdPos0 = t.bdPos;
	                bdPos1 = t.bdPos;
	              }
	              var paths = sel.selectAll("path.mean").data(trace.type === "box" && trace.boxmean || trace.type === "violin" && trace.box.visible && trace.meanline.visible ? Lib.identity : []);
	              paths.enter().append("path").attr("class", "mean").style({
	                fill: "none",
	                "vector-effect": "non-scaling-stroke"
	              });
	              paths.exit().remove();
	              paths.each(function(d) {
	                var lcenter = posAxis.c2l(d.pos + bPos, true);
	                var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
	                var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
	                var posc = posHasRangeBreaks ? (pos0 + pos1) / 2 : posAxis.l2p(lcenter) + bPosPxOffset;
	                var m = valAxis.c2p(d.mean, true);
	                var sl = valAxis.c2p(d.mean - d.sd, true);
	                var sh = valAxis.c2p(d.mean + d.sd, true);
	                if (trace.orientation === "h") {
	                  d3.select(this).attr("d", "M" + m + "," + pos0 + "V" + pos1 + (mode === "sd" ? "m0,0L" + sl + "," + posc + "L" + m + "," + pos0 + "L" + sh + "," + posc + "Z" : ""));
	                } else {
	                  d3.select(this).attr("d", "M" + pos0 + "," + m + "H" + pos1 + (mode === "sd" ? "m0,0L" + posc + "," + sl + "L" + pos0 + "," + m + "L" + posc + "," + sh + "Z" : ""));
	                }
	              });
	            }
	            module2.exports = {
	              plot,
	              plotBoxAndWhiskers,
	              plotPoints,
	              plotBoxMean
	            };
	          }
	        ),
	        /***/
	        24626: (
	          /***/
	          function(module2) {
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var i, j;
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  for (j = 0; j < (cd[i].pts || []).length; j++) {
	                    cd[i].pts[j].selected = 0;
	                  }
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  for (j = 0; j < (cd[i].pts || []).length; j++) {
	                    var pt = cd[i].pts[j];
	                    var x = xa.c2p(pt.x);
	                    var y = ya.c2p(pt.y);
	                    if (selectionTester.contains([x, y], null, pt.i, searchInfo)) {
	                      selection.push({
	                        pointNumber: pt.i,
	                        x: xa.c2d(pt.x),
	                        y: ya.c2d(pt.y)
	                      });
	                      pt.selected = 1;
	                    } else {
	                      pt.selected = 0;
	                    }
	                  }
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        58063: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            function style(gd, cd, sel) {
	              var s = sel ? sel : d3.select(gd).selectAll("g.trace.boxes");
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              s.each(function(d) {
	                var el = d3.select(this);
	                var trace = d[0].trace;
	                var lineWidth = trace.line.width;
	                function styleBox(boxSel, lineWidth2, lineColor, fillColor) {
	                  boxSel.style("stroke-width", lineWidth2 + "px").call(Color.stroke, lineColor).call(Color.fill, fillColor);
	                }
	                var allBoxes = el.selectAll("path.box");
	                if (trace.type === "candlestick") {
	                  allBoxes.each(function(boxData) {
	                    if (boxData.empty) return;
	                    var thisBox = d3.select(this);
	                    var container = trace[boxData.dir];
	                    styleBox(thisBox, container.line.width, container.line.color, container.fillcolor);
	                    thisBox.style("opacity", trace.selectedpoints && !boxData.selected ? 0.3 : 1);
	                  });
	                } else {
	                  styleBox(allBoxes, lineWidth, trace.line.color, trace.fillcolor);
	                  el.selectAll("path.mean").style({
	                    "stroke-width": lineWidth,
	                    "stroke-dasharray": 2 * lineWidth + "px," + lineWidth + "px"
	                  }).call(Color.stroke, trace.line.color);
	                  var pts = el.selectAll("path.point");
	                  Drawing.pointStyle(pts, trace, gd);
	                }
	              });
	            }
	            function styleOnSelect(gd, cd, sel) {
	              var trace = cd[0].trace;
	              var pts = sel.selectAll("path.point");
	              if (trace.selectedpoints) {
	                Drawing.selectedPointStyle(pts, trace);
	              } else {
	                Drawing.pointStyle(pts, trace, gd);
	              }
	            }
	            module2.exports = {
	              style,
	              styleOnSelect
	            };
	          }
	        ),
	        /***/
	        75343: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(71828).extendFlat;
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var OHLCattrs = __webpack_require__2(2522);
	            var boxAttrs = __webpack_require__2(53522);
	            function directionAttrs(lineColorDefault) {
	              return {
	                line: {
	                  color: extendFlat({}, boxAttrs.line.color, {
	                    dflt: lineColorDefault
	                  }),
	                  width: boxAttrs.line.width,
	                  editType: "style"
	                },
	                fillcolor: boxAttrs.fillcolor,
	                editType: "style"
	              };
	            }
	            module2.exports = {
	              xperiod: OHLCattrs.xperiod,
	              xperiod0: OHLCattrs.xperiod0,
	              xperiodalignment: OHLCattrs.xperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              x: OHLCattrs.x,
	              open: OHLCattrs.open,
	              high: OHLCattrs.high,
	              low: OHLCattrs.low,
	              close: OHLCattrs.close,
	              line: {
	                width: extendFlat({}, boxAttrs.line.width, {}),
	                editType: "style"
	              },
	              increasing: directionAttrs(OHLCattrs.increasing.line.color.dflt),
	              decreasing: directionAttrs(OHLCattrs.decreasing.line.color.dflt),
	              text: OHLCattrs.text,
	              hovertext: OHLCattrs.hovertext,
	              whiskerwidth: extendFlat({}, boxAttrs.whiskerwidth, {
	                dflt: 0
	              }),
	              hoverlabel: OHLCattrs.hoverlabel
	            };
	          }
	        ),
	        /***/
	        41197: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var calcCommon = __webpack_require__2(3485).calcCommon;
	            module2.exports = function(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var xa = Axes.getFromId(gd, trace.xaxis);
	              var ya = Axes.getFromId(gd, trace.yaxis);
	              var origX = xa.makeCalcdata(trace, "x");
	              var x = alignPeriod(trace, xa, "x", origX).vals;
	              var cd = calcCommon(gd, trace, origX, x, ya, ptFunc);
	              if (cd.length) {
	                Lib.extendFlat(cd[0].t, {
	                  num: fullLayout._numBoxes,
	                  dPos: Lib.distinctVals(x).minDiff / 2,
	                  posLetter: "x",
	                  valLetter: "y"
	                });
	                fullLayout._numBoxes++;
	                return cd;
	              } else {
	                return [{
	                  t: {
	                    empty: true
	                  }
	                }];
	              }
	            };
	            function ptFunc(o, h, l, c) {
	              return {
	                min: l,
	                q1: Math.min(o, c),
	                med: c,
	                q3: Math.max(o, c),
	                max: h
	              };
	            }
	          }
	        ),
	        /***/
	        1026: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var handleOHLC = __webpack_require__2(14555);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var attributes = __webpack_require__2(75343);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleOHLC(traceIn, traceOut, coerce, layout);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce, {
	                x: true
	              });
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("line.width");
	              handleDirection(traceIn, traceOut, coerce, "increasing");
	              handleDirection(traceIn, traceOut, coerce, "decreasing");
	              coerce("text");
	              coerce("hovertext");
	              coerce("whiskerwidth");
	              layout._requestRangeslider[traceOut.xaxis] = true;
	            };
	            function handleDirection(traceIn, traceOut, coerce, direction) {
	              var lineColor = coerce(direction + ".line.color");
	              coerce(direction + ".line.width", traceOut.line.width);
	              coerce(direction + ".fillcolor", Color.addOpacity(lineColor, 0.5));
	            }
	          }
	        ),
	        /***/
	        91815: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "candlestick",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "showLegend", "candlestick", "boxLayout"],
	              meta: {},
	              attributes: __webpack_require__2(75343),
	              layoutAttributes: __webpack_require__2(40094),
	              supplyLayoutDefaults: __webpack_require__2(4199).supplyLayoutDefaults,
	              crossTraceCalc: __webpack_require__2(37188).crossTraceCalc,
	              supplyDefaults: __webpack_require__2(1026),
	              calc: __webpack_require__2(41197),
	              plot: __webpack_require__2(86047).plot,
	              layerName: "boxlayer",
	              style: __webpack_require__2(58063).style,
	              hoverPoints: __webpack_require__2(66449).hoverPoints,
	              selectPoints: __webpack_require__2(67324)
	            };
	          }
	        ),
	        /***/
	        13145: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var handleAxisDefaults = __webpack_require__2(11500);
	            var Template = __webpack_require__2(44467);
	            module2.exports = function handleABDefaults(traceIn, traceOut, fullLayout, coerce, dfltColor) {
	              var a = coerce("a");
	              if (!a) {
	                coerce("da");
	                coerce("a0");
	              }
	              var b = coerce("b");
	              if (!b) {
	                coerce("db");
	                coerce("b0");
	              }
	              mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor);
	            };
	            function mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor) {
	              var axesList = ["aaxis", "baxis"];
	              axesList.forEach(function(axName) {
	                var axLetter = axName.charAt(0);
	                var axIn = traceIn[axName] || {};
	                var axOut = Template.newContainer(traceOut, axName);
	                var defaultOptions = {
	                  noTicklabelstep: true,
	                  tickfont: "x",
	                  id: axLetter + "axis",
	                  letter: axLetter,
	                  font: traceOut.font,
	                  name: axName,
	                  data: traceIn[axLetter],
	                  calendar: traceOut.calendar,
	                  dfltColor,
	                  bgColor: fullLayout.paper_bgcolor,
	                  autotypenumbersDflt: fullLayout.autotypenumbers,
	                  fullLayout
	                };
	                handleAxisDefaults(axIn, axOut, defaultOptions);
	                axOut._categories = axOut._categories || [];
	                if (!traceIn[axName] && axIn.type !== "-") {
	                  traceIn[axName] = {
	                    type: axIn.type
	                  };
	                }
	              });
	            }
	          }
	        ),
	        /***/
	        402: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function(a) {
	              return minMax(a, 0);
	            };
	            function minMax(a, depth) {
	              if (!isArrayOrTypedArray(a) || depth >= 10) {
	                return null;
	              }
	              var min = Infinity;
	              var max = -Infinity;
	              var n = a.length;
	              for (var i = 0; i < n; i++) {
	                var datum = a[i];
	                if (isArrayOrTypedArray(datum)) {
	                  var result = minMax(datum, depth + 1);
	                  if (result) {
	                    min = Math.min(result[0], min);
	                    max = Math.max(result[1], max);
	                  }
	                } else {
	                  min = Math.min(datum, min);
	                  max = Math.max(datum, max);
	                }
	              }
	              return [min, max];
	            }
	          }
	        ),
	        /***/
	        99798: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var axisAttrs = __webpack_require__2(1928);
	            var colorAttrs = __webpack_require__2(22399);
	            var carpetFont = fontAttrs({
	              editType: "calc"
	            });
	            carpetFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
	            carpetFont.size.dflt = 12;
	            carpetFont.color.dflt = colorAttrs.defaultLine;
	            module2.exports = {
	              carpet: {
	                valType: "string",
	                editType: "calc"
	              },
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              a: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              a0: {
	                valType: "number",
	                dflt: 0,
	                editType: "calc"
	              },
	              da: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              b: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              b0: {
	                valType: "number",
	                dflt: 0,
	                editType: "calc"
	              },
	              db: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              cheaterslope: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              aaxis: axisAttrs,
	              baxis: axisAttrs,
	              font: carpetFont,
	              color: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "plot"
	              },
	              transforms: undefined
	            };
	          }
	        ),
	        /***/
	        4536: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function(carpet, carpetcd, a, b) {
	              var idx, tangent, tanIsoIdx, tanIsoPar, segment, refidx;
	              var p0, p1, v0, v1, start, end, range2;
	              var axis = isArrayOrTypedArray(a) ? "a" : "b";
	              var ax = axis === "a" ? carpet.aaxis : carpet.baxis;
	              var smoothing = ax.smoothing;
	              var toIdx = axis === "a" ? carpet.a2i : carpet.b2j;
	              var pt = axis === "a" ? a : b;
	              var iso = axis === "a" ? b : a;
	              var n = axis === "a" ? carpetcd.a.length : carpetcd.b.length;
	              var m = axis === "a" ? carpetcd.b.length : carpetcd.a.length;
	              var isoIdx = Math.floor(axis === "a" ? carpet.b2j(iso) : carpet.a2i(iso));
	              var xy = axis === "a" ? function(value) {
	                return carpet.evalxy([], value, isoIdx);
	              } : function(value) {
	                return carpet.evalxy([], isoIdx, value);
	              };
	              if (smoothing) {
	                tanIsoIdx = Math.max(0, Math.min(m - 2, isoIdx));
	                tanIsoPar = isoIdx - tanIsoIdx;
	                tangent = axis === "a" ? function(i, ti) {
	                  return carpet.dxydi([], i, tanIsoIdx, ti, tanIsoPar);
	                } : function(j, tj) {
	                  return carpet.dxydj([], tanIsoIdx, j, tanIsoPar, tj);
	                };
	              }
	              var vstart = toIdx(pt[0]);
	              var vend = toIdx(pt[1]);
	              var dir = vstart < vend ? 1 : -1;
	              var tol = (vend - vstart) * 1e-8;
	              var dirfloor = dir > 0 ? Math.floor : Math.ceil;
	              var dirceil = dir > 0 ? Math.ceil : Math.floor;
	              var dirmin = dir > 0 ? Math.min : Math.max;
	              var dirmax = dir > 0 ? Math.max : Math.min;
	              var idx0 = dirfloor(vstart + tol);
	              var idx1 = dirceil(vend - tol);
	              p0 = xy(vstart);
	              var segments = [[p0]];
	              for (idx = idx0; idx * dir < idx1 * dir; idx += dir) {
	                segment = [];
	                start = dirmax(vstart, idx);
	                end = dirmin(vend, idx + dir);
	                range2 = end - start;
	                refidx = Math.max(0, Math.min(n - 2, Math.floor(0.5 * (start + end))));
	                p1 = xy(end);
	                if (smoothing) {
	                  v0 = tangent(refidx, start - refidx);
	                  v1 = tangent(refidx, end - refidx);
	                  segment.push([p0[0] + v0[0] / 3 * range2, p0[1] + v0[1] / 3 * range2]);
	                  segment.push([p1[0] - v1[0] / 3 * range2, p1[1] - v1[1] / 3 * range2]);
	                }
	                segment.push(p1);
	                segments.push(segment);
	                p0 = p1;
	              }
	              return segments;
	            };
	          }
	        ),
	        /***/
	        1928: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            var axesAttrs = __webpack_require__2(13838);
	            var descriptionWithDates = __webpack_require__2(12663).descriptionWithDates;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = {
	              color: {
	                valType: "color",
	                editType: "calc"
	              },
	              smoothing: {
	                valType: "number",
	                dflt: 1,
	                min: 0,
	                max: 1.3,
	                editType: "calc"
	              },
	              title: {
	                text: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "calc"
	                },
	                font: fontAttrs({
	                  editType: "calc"
	                }),
	                // TODO how is this different than `title.standoff`
	                offset: {
	                  valType: "number",
	                  dflt: 10,
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              type: {
	                valType: "enumerated",
	                // '-' means we haven't yet run autotype or couldn't find any data
	                // it gets turned into linear in gd._fullLayout but not copied back
	                // to gd.data like the others are.
	                values: ["-", "linear", "date", "category"],
	                dflt: "-",
	                editType: "calc"
	              },
	              autotypenumbers: axesAttrs.autotypenumbers,
	              autorange: {
	                valType: "enumerated",
	                values: [true, false, "reversed"],
	                dflt: true,
	                editType: "calc"
	              },
	              rangemode: {
	                valType: "enumerated",
	                values: ["normal", "tozero", "nonnegative"],
	                dflt: "normal",
	                editType: "calc"
	              },
	              range: {
	                valType: "info_array",
	                editType: "calc",
	                items: [{
	                  valType: "any",
	                  editType: "calc"
	                }, {
	                  valType: "any",
	                  editType: "calc"
	                }]
	              },
	              fixedrange: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              cheatertype: {
	                valType: "enumerated",
	                values: ["index", "value"],
	                dflt: "value",
	                editType: "calc"
	              },
	              tickmode: {
	                valType: "enumerated",
	                values: ["linear", "array"],
	                dflt: "array",
	                editType: "calc"
	              },
	              nticks: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              tickvals: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              ticktext: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              showticklabels: {
	                valType: "enumerated",
	                values: ["start", "end", "both", "none"],
	                dflt: "start",
	                editType: "calc"
	              },
	              labelalias: extendFlat({}, axesAttrs.labelalias, {
	                editType: "calc"
	              }),
	              tickfont: fontAttrs({
	                editType: "calc"
	              }),
	              tickangle: {
	                valType: "angle",
	                dflt: "auto",
	                editType: "calc"
	              },
	              tickprefix: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              showtickprefix: {
	                valType: "enumerated",
	                values: ["all", "first", "last", "none"],
	                dflt: "all",
	                editType: "calc"
	              },
	              ticksuffix: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              showticksuffix: {
	                valType: "enumerated",
	                values: ["all", "first", "last", "none"],
	                dflt: "all",
	                editType: "calc"
	              },
	              showexponent: {
	                valType: "enumerated",
	                values: ["all", "first", "last", "none"],
	                dflt: "all",
	                editType: "calc"
	              },
	              exponentformat: {
	                valType: "enumerated",
	                values: ["none", "e", "E", "power", "SI", "B"],
	                dflt: "B",
	                editType: "calc"
	              },
	              minexponent: {
	                valType: "number",
	                dflt: 3,
	                min: 0,
	                editType: "calc"
	              },
	              separatethousands: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              tickformat: {
	                valType: "string",
	                dflt: "",
	                editType: "calc",
	                description: descriptionWithDates("tick label")
	              },
	              tickformatstops: overrideAll(axesAttrs.tickformatstops, "calc", "from-root"),
	              categoryorder: {
	                valType: "enumerated",
	                values: [
	                  "trace",
	                  "category ascending",
	                  "category descending",
	                  "array"
	                  /* , 'value ascending', 'value descending'*/
	                  // value ascending / descending to be implemented later
	                ],
	                dflt: "trace",
	                editType: "calc"
	              },
	              categoryarray: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              labelpadding: {
	                valType: "integer",
	                dflt: 10,
	                editType: "calc"
	              },
	              labelprefix: {
	                valType: "string",
	                editType: "calc"
	              },
	              labelsuffix: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              // lines and grids
	              showline: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              linecolor: {
	                valType: "color",
	                dflt: colorAttrs.defaultLine,
	                editType: "calc"
	              },
	              linewidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "calc"
	              },
	              gridcolor: {
	                valType: "color",
	                editType: "calc"
	              },
	              gridwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "calc"
	              },
	              griddash: extendFlat({}, dash, {
	                editType: "calc"
	              }),
	              showgrid: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              minorgridcount: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              minorgridwidth: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "calc"
	              },
	              minorgriddash: extendFlat({}, dash, {
	                editType: "calc"
	              }),
	              minorgridcolor: {
	                valType: "color",
	                dflt: colorAttrs.lightLine,
	                editType: "calc"
	              },
	              startline: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              startlinecolor: {
	                valType: "color",
	                editType: "calc"
	              },
	              startlinewidth: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              endline: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              endlinewidth: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              endlinecolor: {
	                valType: "color",
	                editType: "calc"
	              },
	              tick0: {
	                valType: "number",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              dtick: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "calc"
	              },
	              arraytick0: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              arraydtick: {
	                valType: "integer",
	                min: 1,
	                dflt: 1,
	                editType: "calc"
	              },
	              _deprecated: {
	                title: {
	                  valType: "string",
	                  editType: "calc"
	                },
	                titlefont: fontAttrs({
	                  editType: "calc"
	                }),
	                titleoffset: {
	                  valType: "number",
	                  dflt: 10,
	                  editType: "calc"
	                }
	              },
	              editType: "calc"
	            };
	          }
	        ),
	        /***/
	        11500: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var carpetAttrs = __webpack_require__2(99798);
	            var addOpacity = __webpack_require__2(7901).addOpacity;
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var handleTickValueDefaults = __webpack_require__2(26218);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            var handleCategoryOrderDefaults = __webpack_require__2(15258);
	            var setConvert = __webpack_require__2(21994);
	            var autoType = __webpack_require__2(4322);
	            module2.exports = function handleAxisDefaults(containerIn, containerOut, options) {
	              var letter = options.letter;
	              var font = options.font || {};
	              var attributes = carpetAttrs[letter + "axis"];
	              function coerce(attr, dflt) {
	                return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
	              }
	              function coerce2(attr, dflt) {
	                return Lib.coerce2(containerIn, containerOut, attributes, attr, dflt);
	              }
	              if (options.name) {
	                containerOut._name = options.name;
	                containerOut._id = options.name;
	              }
	              coerce("autotypenumbers", options.autotypenumbersDflt);
	              var axType = coerce("type");
	              if (axType === "-") {
	                if (options.data) setAutoType(containerOut, options.data);
	                if (containerOut.type === "-") {
	                  containerOut.type = "linear";
	                } else {
	                  axType = containerIn.type = containerOut.type;
	                }
	              }
	              coerce("smoothing");
	              coerce("cheatertype");
	              coerce("showticklabels");
	              coerce("labelprefix", letter + " = ");
	              coerce("labelsuffix");
	              coerce("showtickprefix");
	              coerce("showticksuffix");
	              coerce("separatethousands");
	              coerce("tickformat");
	              coerce("exponentformat");
	              coerce("minexponent");
	              coerce("showexponent");
	              coerce("categoryorder");
	              coerce("tickmode");
	              coerce("tickvals");
	              coerce("ticktext");
	              coerce("tick0");
	              coerce("dtick");
	              if (containerOut.tickmode === "array") {
	                coerce("arraytick0");
	                coerce("arraydtick");
	              }
	              coerce("labelpadding");
	              containerOut._hovertitle = letter;
	              if (axType === "date") {
	                var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleDefaults");
	                handleCalendarDefaults(containerIn, containerOut, "calendar", options.calendar);
	              }
	              setConvert(containerOut, options.fullLayout);
	              containerOut.c2p = Lib.identity;
	              var dfltColor = coerce("color", options.dfltColor);
	              var dfltFontColor = dfltColor === containerIn.color ? dfltColor : font.color;
	              var title = coerce("title.text");
	              if (title) {
	                Lib.coerceFont(coerce, "title.font", {
	                  family: font.family,
	                  size: Lib.bigFont(font.size),
	                  color: dfltFontColor
	                });
	                coerce("title.offset");
	              }
	              coerce("tickangle");
	              var autoRange = coerce("autorange", !containerOut.isValidRange(containerIn.range));
	              if (autoRange) coerce("rangemode");
	              coerce("range");
	              containerOut.cleanRange();
	              coerce("fixedrange");
	              handleTickValueDefaults(containerIn, containerOut, coerce, axType);
	              handlePrefixSuffixDefaults(containerIn, containerOut, coerce, axType, options);
	              handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options);
	              handleCategoryOrderDefaults(containerIn, containerOut, coerce, {
	                data: options.data,
	                dataAttr: letter
	              });
	              var gridColor = coerce2("gridcolor", addOpacity(dfltColor, 0.3));
	              var gridWidth = coerce2("gridwidth");
	              var gridDash = coerce2("griddash");
	              var showGrid = coerce("showgrid");
	              if (!showGrid) {
	                delete containerOut.gridcolor;
	                delete containerOut.gridwidth;
	                delete containerOut.griddash;
	              }
	              var startLineColor = coerce2("startlinecolor", dfltColor);
	              var startLineWidth = coerce2("startlinewidth", gridWidth);
	              var showStartLine = coerce("startline", containerOut.showgrid || !!startLineColor || !!startLineWidth);
	              if (!showStartLine) {
	                delete containerOut.startlinecolor;
	                delete containerOut.startlinewidth;
	              }
	              var endLineColor = coerce2("endlinecolor", dfltColor);
	              var endLineWidth = coerce2("endlinewidth", gridWidth);
	              var showEndLine = coerce("endline", containerOut.showgrid || !!endLineColor || !!endLineWidth);
	              if (!showEndLine) {
	                delete containerOut.endlinecolor;
	                delete containerOut.endlinewidth;
	              }
	              if (!showGrid) {
	                delete containerOut.gridcolor;
	                delete containerOut.gridwidth;
	                delete containerOut.griddash;
	              } else {
	                coerce("minorgridcount");
	                coerce("minorgridwidth", gridWidth);
	                coerce("minorgriddash", gridDash);
	                coerce("minorgridcolor", addOpacity(gridColor, 0.06));
	                if (!containerOut.minorgridcount) {
	                  delete containerOut.minorgridwidth;
	                  delete containerOut.minorgriddash;
	                  delete containerOut.minorgridcolor;
	                }
	              }
	              if (containerOut.showticklabels === "none") {
	                delete containerOut.tickfont;
	                delete containerOut.tickangle;
	                delete containerOut.showexponent;
	                delete containerOut.exponentformat;
	                delete containerOut.minexponent;
	                delete containerOut.tickformat;
	                delete containerOut.showticksuffix;
	                delete containerOut.showtickprefix;
	              }
	              if (!containerOut.showticksuffix) {
	                delete containerOut.ticksuffix;
	              }
	              if (!containerOut.showtickprefix) {
	                delete containerOut.tickprefix;
	              }
	              coerce("tickmode");
	              return containerOut;
	            };
	            function setAutoType(ax, data) {
	              if (ax.type !== "-") return;
	              var id = ax._id;
	              var axLetter = id.charAt(0);
	              var calAttr = axLetter + "calendar";
	              var calendar = ax[calAttr];
	              ax.type = autoType(data, calendar, {
	                autotypenumbers: ax.autotypenumbers
	              });
	            }
	          }
	        ),
	        /***/
	        25281: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var isArray1D = __webpack_require__2(71828).isArray1D;
	            var cheaterBasis = __webpack_require__2(53824);
	            var arrayMinmax = __webpack_require__2(402);
	            var calcGridlines = __webpack_require__2(20347);
	            var calcLabels = __webpack_require__2(83311);
	            var calcClipPath = __webpack_require__2(44807);
	            var clean2dArray = __webpack_require__2(4742);
	            var smoothFill2dArray = __webpack_require__2(72505);
	            var convertColumnData = __webpack_require__2(68296);
	            var setConvert = __webpack_require__2(11435);
	            module2.exports = function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis);
	              var ya = Axes.getFromId(gd, trace.yaxis);
	              var aax = trace.aaxis;
	              var bax = trace.baxis;
	              var x = trace.x;
	              var y = trace.y;
	              var cols = [];
	              if (x && isArray1D(x)) cols.push("x");
	              if (y && isArray1D(y)) cols.push("y");
	              if (cols.length) {
	                convertColumnData(trace, aax, bax, "a", "b", cols);
	              }
	              var a = trace._a = trace._a || trace.a;
	              var b = trace._b = trace._b || trace.b;
	              x = trace._x || trace.x;
	              y = trace._y || trace.y;
	              var t = {};
	              if (trace._cheater) {
	                var avals = aax.cheatertype === "index" ? a.length : a;
	                var bvals = bax.cheatertype === "index" ? b.length : b;
	                x = cheaterBasis(avals, bvals, trace.cheaterslope);
	              }
	              trace._x = x = clean2dArray(x);
	              trace._y = y = clean2dArray(y);
	              smoothFill2dArray(x, a, b);
	              smoothFill2dArray(y, a, b);
	              setConvert(trace);
	              trace.setScale();
	              var xrange = arrayMinmax(x);
	              var yrange = arrayMinmax(y);
	              var dx = 0.5 * (xrange[1] - xrange[0]);
	              var xc = 0.5 * (xrange[1] + xrange[0]);
	              var dy = 0.5 * (yrange[1] - yrange[0]);
	              var yc = 0.5 * (yrange[1] + yrange[0]);
	              var grow = 1.3;
	              xrange = [xc - dx * grow, xc + dx * grow];
	              yrange = [yc - dy * grow, yc + dy * grow];
	              trace._extremes[xa._id] = Axes.findExtremes(xa, xrange, {
	                padded: true
	              });
	              trace._extremes[ya._id] = Axes.findExtremes(ya, yrange, {
	                padded: true
	              });
	              calcGridlines(trace, "a", "b");
	              calcGridlines(trace, "b", "a");
	              calcLabels(trace, aax);
	              calcLabels(trace, bax);
	              t.clipsegments = calcClipPath(trace._xctrl, trace._yctrl, aax, bax);
	              t.x = x;
	              t.y = y;
	              t.a = a;
	              t.b = b;
	              return [t];
	            };
	          }
	        ),
	        /***/
	        44807: (
	          /***/
	          function(module2) {
	            module2.exports = function makeClipPath(xctrl, yctrl, aax, bax) {
	              var i, x, y;
	              var segments = [];
	              var asmoothing = !!aax.smoothing;
	              var bsmoothing = !!bax.smoothing;
	              var nea1 = xctrl[0].length - 1;
	              var neb1 = xctrl.length - 1;
	              for (i = 0, x = [], y = []; i <= nea1; i++) {
	                x[i] = xctrl[0][i];
	                y[i] = yctrl[0][i];
	              }
	              segments.push({
	                x,
	                y,
	                bicubic: asmoothing
	              });
	              for (i = 0, x = [], y = []; i <= neb1; i++) {
	                x[i] = xctrl[i][nea1];
	                y[i] = yctrl[i][nea1];
	              }
	              segments.push({
	                x,
	                y,
	                bicubic: bsmoothing
	              });
	              for (i = nea1, x = [], y = []; i >= 0; i--) {
	                x[nea1 - i] = xctrl[neb1][i];
	                y[nea1 - i] = yctrl[neb1][i];
	              }
	              segments.push({
	                x,
	                y,
	                bicubic: asmoothing
	              });
	              for (i = neb1, x = [], y = []; i >= 0; i--) {
	                x[neb1 - i] = xctrl[i][0];
	                y[neb1 - i] = yctrl[i][0];
	              }
	              segments.push({
	                x,
	                y,
	                bicubic: bsmoothing
	              });
	              return segments;
	            };
	          }
	        ),
	        /***/
	        20347: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = function calcGridlines(trace, axisLetter, crossAxisLetter) {
	              var i, j, j0;
	              var eps, bounds, n1, n2, n, value, v;
	              var j1, v0, v1, d;
	              var data = trace["_" + axisLetter];
	              var axis = trace[axisLetter + "axis"];
	              var gridlines = axis._gridlines = [];
	              var minorgridlines = axis._minorgridlines = [];
	              var boundarylines = axis._boundarylines = [];
	              var crossData = trace["_" + crossAxisLetter];
	              var crossAxis = trace[crossAxisLetter + "axis"];
	              if (axis.tickmode === "array") {
	                axis.tickvals = data.slice();
	              }
	              var xcp = trace._xctrl;
	              var ycp = trace._yctrl;
	              var nea = xcp[0].length;
	              var neb = xcp.length;
	              var na = trace._a.length;
	              var nb = trace._b.length;
	              Axes.prepTicks(axis);
	              if (axis.tickmode === "array") delete axis.tickvals;
	              var stride = axis.smoothing ? 3 : 1;
	              function constructValueGridline(value2) {
	                var i2, j2, j02, tj, pxy, i0, ti, xy, dxydi0, dxydi1, dxydj0, dxydj1;
	                var xpoints = [];
	                var ypoints = [];
	                var ret = {};
	                if (axisLetter === "b") {
	                  j2 = trace.b2j(value2);
	                  j02 = Math.floor(Math.max(0, Math.min(nb - 2, j2)));
	                  tj = j2 - j02;
	                  ret.length = nb;
	                  ret.crossLength = na;
	                  ret.xy = function(i3) {
	                    return trace.evalxy([], i3, j2);
	                  };
	                  ret.dxy = function(i02, ti2) {
	                    return trace.dxydi([], i02, j02, ti2, tj);
	                  };
	                  for (i2 = 0; i2 < na; i2++) {
	                    i0 = Math.min(na - 2, i2);
	                    ti = i2 - i0;
	                    xy = trace.evalxy([], i2, j2);
	                    if (crossAxis.smoothing && i2 > 0) {
	                      dxydi0 = trace.dxydi([], i2 - 1, j02, 0, tj);
	                      xpoints.push(pxy[0] + dxydi0[0] / 3);
	                      ypoints.push(pxy[1] + dxydi0[1] / 3);
	                      dxydi1 = trace.dxydi([], i2 - 1, j02, 1, tj);
	                      xpoints.push(xy[0] - dxydi1[0] / 3);
	                      ypoints.push(xy[1] - dxydi1[1] / 3);
	                    }
	                    xpoints.push(xy[0]);
	                    ypoints.push(xy[1]);
	                    pxy = xy;
	                  }
	                } else {
	                  i2 = trace.a2i(value2);
	                  i0 = Math.floor(Math.max(0, Math.min(na - 2, i2)));
	                  ti = i2 - i0;
	                  ret.length = na;
	                  ret.crossLength = nb;
	                  ret.xy = function(j3) {
	                    return trace.evalxy([], i2, j3);
	                  };
	                  ret.dxy = function(j03, tj2) {
	                    return trace.dxydj([], i0, j03, ti, tj2);
	                  };
	                  for (j2 = 0; j2 < nb; j2++) {
	                    j02 = Math.min(nb - 2, j2);
	                    tj = j2 - j02;
	                    xy = trace.evalxy([], i2, j2);
	                    if (crossAxis.smoothing && j2 > 0) {
	                      dxydj0 = trace.dxydj([], i0, j2 - 1, ti, 0);
	                      xpoints.push(pxy[0] + dxydj0[0] / 3);
	                      ypoints.push(pxy[1] + dxydj0[1] / 3);
	                      dxydj1 = trace.dxydj([], i0, j2 - 1, ti, 1);
	                      xpoints.push(xy[0] - dxydj1[0] / 3);
	                      ypoints.push(xy[1] - dxydj1[1] / 3);
	                    }
	                    xpoints.push(xy[0]);
	                    ypoints.push(xy[1]);
	                    pxy = xy;
	                  }
	                }
	                ret.axisLetter = axisLetter;
	                ret.axis = axis;
	                ret.crossAxis = crossAxis;
	                ret.value = value2;
	                ret.constvar = crossAxisLetter;
	                ret.index = n;
	                ret.x = xpoints;
	                ret.y = ypoints;
	                ret.smoothing = crossAxis.smoothing;
	                return ret;
	              }
	              function constructArrayGridline(idx) {
	                var j2, i0, j02, ti, tj;
	                var xpoints = [];
	                var ypoints = [];
	                var ret = {};
	                ret.length = data.length;
	                ret.crossLength = crossData.length;
	                if (axisLetter === "b") {
	                  j02 = Math.max(0, Math.min(nb - 2, idx));
	                  tj = Math.min(1, Math.max(0, idx - j02));
	                  ret.xy = function(i2) {
	                    return trace.evalxy([], i2, idx);
	                  };
	                  ret.dxy = function(i02, ti2) {
	                    return trace.dxydi([], i02, j02, ti2, tj);
	                  };
	                  for (j2 = 0; j2 < nea; j2++) {
	                    xpoints[j2] = xcp[idx * stride][j2];
	                    ypoints[j2] = ycp[idx * stride][j2];
	                  }
	                } else {
	                  i0 = Math.max(0, Math.min(na - 2, idx));
	                  ti = Math.min(1, Math.max(0, idx - i0));
	                  ret.xy = function(j3) {
	                    return trace.evalxy([], idx, j3);
	                  };
	                  ret.dxy = function(j03, tj2) {
	                    return trace.dxydj([], i0, j03, ti, tj2);
	                  };
	                  for (j2 = 0; j2 < neb; j2++) {
	                    xpoints[j2] = xcp[j2][idx * stride];
	                    ypoints[j2] = ycp[j2][idx * stride];
	                  }
	                }
	                ret.axisLetter = axisLetter;
	                ret.axis = axis;
	                ret.crossAxis = crossAxis;
	                ret.value = data[idx];
	                ret.constvar = crossAxisLetter;
	                ret.index = idx;
	                ret.x = xpoints;
	                ret.y = ypoints;
	                ret.smoothing = crossAxis.smoothing;
	                return ret;
	              }
	              if (axis.tickmode === "array") {
	                eps = 5e-15;
	                bounds = [Math.floor((data.length - 1 - axis.arraytick0) / axis.arraydtick * (1 + eps)), Math.ceil(-axis.arraytick0 / axis.arraydtick / (1 + eps))].sort(function(a, b) {
	                  return a - b;
	                });
	                n1 = bounds[0] - 1;
	                n2 = bounds[1] + 1;
	                for (n = n1; n < n2; n++) {
	                  j = axis.arraytick0 + axis.arraydtick * n;
	                  if (j < 0 || j > data.length - 1) continue;
	                  gridlines.push(extendFlat(constructArrayGridline(j), {
	                    color: axis.gridcolor,
	                    width: axis.gridwidth,
	                    dash: axis.griddash
	                  }));
	                }
	                for (n = n1; n < n2; n++) {
	                  j0 = axis.arraytick0 + axis.arraydtick * n;
	                  j1 = Math.min(j0 + axis.arraydtick, data.length - 1);
	                  if (j0 < 0 || j0 > data.length - 1) continue;
	                  if (j1 < 0 || j1 > data.length - 1) continue;
	                  v0 = data[j0];
	                  v1 = data[j1];
	                  for (i = 0; i < axis.minorgridcount; i++) {
	                    d = j1 - j0;
	                    if (d <= 0) continue;
	                    v = v0 + (v1 - v0) * (i + 1) / (axis.minorgridcount + 1) * (axis.arraydtick / d);
	                    if (v < data[0] || v > data[data.length - 1]) continue;
	                    minorgridlines.push(extendFlat(constructValueGridline(v), {
	                      color: axis.minorgridcolor,
	                      width: axis.minorgridwidth,
	                      dash: axis.minorgriddash
	                    }));
	                  }
	                }
	                if (axis.startline) {
	                  boundarylines.push(extendFlat(constructArrayGridline(0), {
	                    color: axis.startlinecolor,
	                    width: axis.startlinewidth
	                  }));
	                }
	                if (axis.endline) {
	                  boundarylines.push(extendFlat(constructArrayGridline(data.length - 1), {
	                    color: axis.endlinecolor,
	                    width: axis.endlinewidth
	                  }));
	                }
	              } else {
	                eps = 5e-15;
	                bounds = [Math.floor((data[data.length - 1] - axis.tick0) / axis.dtick * (1 + eps)), Math.ceil((data[0] - axis.tick0) / axis.dtick / (1 + eps))].sort(function(a, b) {
	                  return a - b;
	                });
	                n1 = bounds[0];
	                n2 = bounds[1];
	                for (n = n1; n <= n2; n++) {
	                  value = axis.tick0 + axis.dtick * n;
	                  gridlines.push(extendFlat(constructValueGridline(value), {
	                    color: axis.gridcolor,
	                    width: axis.gridwidth,
	                    dash: axis.griddash
	                  }));
	                }
	                for (n = n1 - 1; n < n2 + 1; n++) {
	                  value = axis.tick0 + axis.dtick * n;
	                  for (i = 0; i < axis.minorgridcount; i++) {
	                    v = value + axis.dtick * (i + 1) / (axis.minorgridcount + 1);
	                    if (v < data[0] || v > data[data.length - 1]) continue;
	                    minorgridlines.push(extendFlat(constructValueGridline(v), {
	                      color: axis.minorgridcolor,
	                      width: axis.minorgridwidth,
	                      dash: axis.minorgriddash
	                    }));
	                  }
	                }
	                if (axis.startline) {
	                  boundarylines.push(extendFlat(constructValueGridline(data[0]), {
	                    color: axis.startlinecolor,
	                    width: axis.startlinewidth
	                  }));
	                }
	                if (axis.endline) {
	                  boundarylines.push(extendFlat(constructValueGridline(data[data.length - 1]), {
	                    color: axis.endlinecolor,
	                    width: axis.endlinewidth
	                  }));
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        83311: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = function calcLabels(trace, axis) {
	              var i, tobj, prefix, suffix, gridline;
	              var labels = axis._labels = [];
	              var gridlines = axis._gridlines;
	              for (i = 0; i < gridlines.length; i++) {
	                gridline = gridlines[i];
	                if (["start", "both"].indexOf(axis.showticklabels) !== -1) {
	                  tobj = Axes.tickText(axis, gridline.value);
	                  extendFlat(tobj, {
	                    prefix,
	                    suffix,
	                    endAnchor: true,
	                    xy: gridline.xy(0),
	                    dxy: gridline.dxy(0, 0),
	                    axis: gridline.axis,
	                    length: gridline.crossAxis.length,
	                    font: gridline.axis.tickfont,
	                    isFirst: i === 0,
	                    isLast: i === gridlines.length - 1
	                  });
	                  labels.push(tobj);
	                }
	                if (["end", "both"].indexOf(axis.showticklabels) !== -1) {
	                  tobj = Axes.tickText(axis, gridline.value);
	                  extendFlat(tobj, {
	                    endAnchor: false,
	                    xy: gridline.xy(gridline.crossLength - 1),
	                    dxy: gridline.dxy(gridline.crossLength - 2, 1),
	                    axis: gridline.axis,
	                    length: gridline.crossAxis.length,
	                    font: gridline.axis.tickfont,
	                    isFirst: i === 0,
	                    isLast: i === gridlines.length - 1
	                  });
	                  labels.push(tobj);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        42048: (
	          /***/
	          function(module2) {
	            var CatmullRomExp = 0.5;
	            module2.exports = function makeControlPoints(p0, p1, p2, smoothness) {
	              var d1x = p0[0] - p1[0];
	              var d1y = p0[1] - p1[1];
	              var d2x = p2[0] - p1[0];
	              var d2y = p2[1] - p1[1];
	              var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
	              var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
	              var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
	              var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
	              var denom1 = d2a * (d1a + d2a) * 3;
	              var denom2 = d1a * (d1a + d2a) * 3;
	              return [[p1[0] + (denom1 && numx / denom1), p1[1] + (denom1 && numy / denom1)], [p1[0] - (denom2 && numx / denom2), p1[1] - (denom2 && numy / denom2)]];
	            };
	          }
	        ),
	        /***/
	        53824: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function(a, b, cheaterslope) {
	              var i, j, ascal, bscal, aval, bval;
	              var data = [];
	              var na = isArrayOrTypedArray(a) ? a.length : a;
	              var nb = isArrayOrTypedArray(b) ? b.length : b;
	              var adata = isArrayOrTypedArray(a) ? a : null;
	              var bdata = isArrayOrTypedArray(b) ? b : null;
	              if (adata) {
	                ascal = (adata.length - 1) / (adata[adata.length - 1] - adata[0]) / (na - 1);
	              }
	              if (bdata) {
	                bscal = (bdata.length - 1) / (bdata[bdata.length - 1] - bdata[0]) / (nb - 1);
	              }
	              var xval;
	              var xmin = Infinity;
	              var xmax = -Infinity;
	              for (j = 0; j < nb; j++) {
	                data[j] = [];
	                bval = bdata ? (bdata[j] - bdata[0]) * bscal : j / (nb - 1);
	                for (i = 0; i < na; i++) {
	                  aval = adata ? (adata[i] - adata[0]) * ascal : i / (na - 1);
	                  xval = aval - bval * cheaterslope;
	                  xmin = Math.min(xval, xmin);
	                  xmax = Math.max(xval, xmax);
	                  data[j][i] = xval;
	                }
	              }
	              var slope = 1 / (xmax - xmin);
	              var offset = -xmin * slope;
	              for (j = 0; j < nb; j++) {
	                for (i = 0; i < na; i++) {
	                  data[j][i] = slope * data[j][i] + offset;
	                }
	              }
	              return data;
	            };
	          }
	        ),
	        /***/
	        45664: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var makeControlPoints = __webpack_require__2(42048);
	            var ensureArray = __webpack_require__2(71828).ensureArray;
	            function inferCubicControlPoint(p0, p2, p3) {
	              var p2e0 = -0.5 * p3[0] + 1.5 * p2[0];
	              var p2e1 = -0.5 * p3[1] + 1.5 * p2[1];
	              return [(2 * p2e0 + p0[0]) / 3, (2 * p2e1 + p0[1]) / 3];
	            }
	            module2.exports = function computeControlPoints(xe, ye, x, y, asmoothing, bsmoothing) {
	              var i, j, ie, je, xej, yej, xj, yj, cp, p1;
	              var na = x[0].length;
	              var nb = x.length;
	              var nea = asmoothing ? 3 * na - 2 : na;
	              var neb = bsmoothing ? 3 * nb - 2 : nb;
	              xe = ensureArray(xe, neb);
	              ye = ensureArray(ye, neb);
	              for (ie = 0; ie < neb; ie++) {
	                xe[ie] = ensureArray(xe[ie], nea);
	                ye[ie] = ensureArray(ye[ie], nea);
	              }
	              for (j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
	                xej = xe[je];
	                yej = ye[je];
	                xj = x[j];
	                yj = y[j];
	                for (i = 0, ie = 0; i < na; i++, ie += asmoothing ? 3 : 1) {
	                  xej[ie] = xj[i];
	                  yej[ie] = yj[i];
	                }
	              }
	              if (asmoothing) {
	                for (j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
	                  for (i = 1, ie = 3; i < na - 1; i++, ie += 3) {
	                    cp = makeControlPoints([x[j][i - 1], y[j][i - 1]], [x[j][i], y[j][i]], [x[j][i + 1], y[j][i + 1]], asmoothing);
	                    xe[je][ie - 1] = cp[0][0];
	                    ye[je][ie - 1] = cp[0][1];
	                    xe[je][ie + 1] = cp[1][0];
	                    ye[je][ie + 1] = cp[1][1];
	                  }
	                  p1 = inferCubicControlPoint([xe[je][0], ye[je][0]], [xe[je][2], ye[je][2]], [xe[je][3], ye[je][3]]);
	                  xe[je][1] = p1[0];
	                  ye[je][1] = p1[1];
	                  p1 = inferCubicControlPoint([xe[je][nea - 1], ye[je][nea - 1]], [xe[je][nea - 3], ye[je][nea - 3]], [xe[je][nea - 4], ye[je][nea - 4]]);
	                  xe[je][nea - 2] = p1[0];
	                  ye[je][nea - 2] = p1[1];
	                }
	              }
	              if (bsmoothing) {
	                for (ie = 0; ie < nea; ie++) {
	                  for (je = 3; je < neb - 3; je += 3) {
	                    cp = makeControlPoints([xe[je - 3][ie], ye[je - 3][ie]], [xe[je][ie], ye[je][ie]], [xe[je + 3][ie], ye[je + 3][ie]], bsmoothing);
	                    xe[je - 1][ie] = cp[0][0];
	                    ye[je - 1][ie] = cp[0][1];
	                    xe[je + 1][ie] = cp[1][0];
	                    ye[je + 1][ie] = cp[1][1];
	                  }
	                  p1 = inferCubicControlPoint([xe[0][ie], ye[0][ie]], [xe[2][ie], ye[2][ie]], [xe[3][ie], ye[3][ie]]);
	                  xe[1][ie] = p1[0];
	                  ye[1][ie] = p1[1];
	                  p1 = inferCubicControlPoint([xe[neb - 1][ie], ye[neb - 1][ie]], [xe[neb - 3][ie], ye[neb - 3][ie]], [xe[neb - 4][ie], ye[neb - 4][ie]]);
	                  xe[neb - 2][ie] = p1[0];
	                  ye[neb - 2][ie] = p1[1];
	                }
	              }
	              if (asmoothing && bsmoothing) {
	                for (je = 1; je < neb; je += (je + 1) % 3 === 0 ? 2 : 1) {
	                  for (ie = 3; ie < nea - 3; ie += 3) {
	                    cp = makeControlPoints([xe[je][ie - 3], ye[je][ie - 3]], [xe[je][ie], ye[je][ie]], [xe[je][ie + 3], ye[je][ie + 3]], asmoothing);
	                    xe[je][ie - 1] = 0.5 * (xe[je][ie - 1] + cp[0][0]);
	                    ye[je][ie - 1] = 0.5 * (ye[je][ie - 1] + cp[0][1]);
	                    xe[je][ie + 1] = 0.5 * (xe[je][ie + 1] + cp[1][0]);
	                    ye[je][ie + 1] = 0.5 * (ye[je][ie + 1] + cp[1][1]);
	                  }
	                  p1 = inferCubicControlPoint([xe[je][0], ye[je][0]], [xe[je][2], ye[je][2]], [xe[je][3], ye[je][3]]);
	                  xe[je][1] = 0.5 * (xe[je][1] + p1[0]);
	                  ye[je][1] = 0.5 * (ye[je][1] + p1[1]);
	                  p1 = inferCubicControlPoint([xe[je][nea - 1], ye[je][nea - 1]], [xe[je][nea - 3], ye[je][nea - 3]], [xe[je][nea - 4], ye[je][nea - 4]]);
	                  xe[je][nea - 2] = 0.5 * (xe[je][nea - 2] + p1[0]);
	                  ye[je][nea - 2] = 0.5 * (ye[je][nea - 2] + p1[1]);
	                }
	              }
	              return [xe, ye];
	            };
	          }
	        ),
	        /***/
	        35509: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              RELATIVE_CULL_TOLERANCE: 1e-6
	            };
	          }
	        ),
	        /***/
	        54495: (
	          /***/
	          function(module2) {
	            module2.exports = function(arrays, asmoothing, bsmoothing) {
	              if (asmoothing && bsmoothing) {
	                return function(out, i0, j0, u, v) {
	                  if (!out) out = [];
	                  var f0, f1, f2, f3, ak, k;
	                  i0 *= 3;
	                  j0 *= 3;
	                  var u2 = u * u;
	                  var ou = 1 - u;
	                  var ou2 = ou * ou;
	                  var ouu2 = ou * u * 2;
	                  var a = -3 * ou2;
	                  var b = 3 * (ou2 - ouu2);
	                  var c = 3 * (ouu2 - u2);
	                  var d = 3 * u2;
	                  var v2 = v * v;
	                  var v3 = v2 * v;
	                  var ov = 1 - v;
	                  var ov2 = ov * ov;
	                  var ov3 = ov2 * ov;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = a * ak[j0][i0] + b * ak[j0][i0 + 1] + c * ak[j0][i0 + 2] + d * ak[j0][i0 + 3];
	                    f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
	                    f2 = a * ak[j0 + 2][i0] + b * ak[j0 + 2][i0 + 1] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 2][i0 + 3];
	                    f3 = a * ak[j0 + 3][i0] + b * ak[j0 + 3][i0 + 1] + c * ak[j0 + 3][i0 + 2] + d * ak[j0 + 3][i0 + 3];
	                    out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	                  }
	                  return out;
	                };
	              } else if (asmoothing) {
	                return function(out, i0, j0, u, v) {
	                  if (!out) out = [];
	                  var f0, f1, k, ak;
	                  i0 *= 3;
	                  var u2 = u * u;
	                  var ou = 1 - u;
	                  var ou2 = ou * ou;
	                  var ouu2 = ou * u * 2;
	                  var a = -3 * ou2;
	                  var b = 3 * (ou2 - ouu2);
	                  var c = 3 * (ouu2 - u2);
	                  var d = 3 * u2;
	                  var ov = 1 - v;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = a * ak[j0][i0] + b * ak[j0][i0 + 1] + c * ak[j0][i0 + 2] + d * ak[j0][i0 + 3];
	                    f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
	                    out[k] = ov * f0 + v * f1;
	                  }
	                  return out;
	                };
	              } else if (bsmoothing) {
	                return function(out, i0, j0, u, v) {
	                  if (!out) out = [];
	                  var f0, f1, f2, f3, k, ak;
	                  j0 *= 3;
	                  var v2 = v * v;
	                  var v3 = v2 * v;
	                  var ov = 1 - v;
	                  var ov2 = ov * ov;
	                  var ov3 = ov2 * ov;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ak[j0][i0 + 1] - ak[j0][i0];
	                    f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
	                    f2 = ak[j0 + 2][i0 + 1] - ak[j0 + 2][i0];
	                    f3 = ak[j0 + 3][i0 + 1] - ak[j0 + 3][i0];
	                    out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	                  }
	                  return out;
	                };
	              } else {
	                return function(out, i0, j0, u, v) {
	                  if (!out) out = [];
	                  var f0, f1, k, ak;
	                  var ov = 1 - v;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ak[j0][i0 + 1] - ak[j0][i0];
	                    f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
	                    out[k] = ov * f0 + v * f1;
	                  }
	                  return out;
	                };
	              }
	            };
	          }
	        ),
	        /***/
	        73057: (
	          /***/
	          function(module2) {
	            module2.exports = function(arrays, asmoothing, bsmoothing) {
	              if (asmoothing && bsmoothing) {
	                return function(out, i0, j0, u, v) {
	                  if (!out) out = [];
	                  var f0, f1, f2, f3, ak, k;
	                  i0 *= 3;
	                  j0 *= 3;
	                  var u2 = u * u;
	                  var u3 = u2 * u;
	                  var ou = 1 - u;
	                  var ou2 = ou * ou;
	                  var ou3 = ou2 * ou;
	                  var v2 = v * v;
	                  var ov = 1 - v;
	                  var ov2 = ov * ov;
	                  var ovv2 = ov * v * 2;
	                  var a = -3 * ov2;
	                  var b = 3 * (ov2 - ovv2);
	                  var c = 3 * (ovv2 - v2);
	                  var d = 3 * v2;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
	                    f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
	                    f2 = a * ak[j0][i0 + 2] + b * ak[j0 + 1][i0 + 2] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 3][i0 + 2];
	                    f3 = a * ak[j0][i0 + 3] + b * ak[j0 + 1][i0 + 3] + c * ak[j0 + 2][i0 + 3] + d * ak[j0 + 3][i0 + 3];
	                    out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
	                  }
	                  return out;
	                };
	              } else if (asmoothing) {
	                return function(out, i0, j0, v, u) {
	                  if (!out) out = [];
	                  var f0, f1, f2, f3, k, ak;
	                  i0 *= 3;
	                  var u2 = u * u;
	                  var u3 = u2 * u;
	                  var ou = 1 - u;
	                  var ou2 = ou * ou;
	                  var ou3 = ou2 * ou;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ak[j0 + 1][i0] - ak[j0][i0];
	                    f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
	                    f2 = ak[j0 + 1][i0 + 2] - ak[j0][i0 + 2];
	                    f3 = ak[j0 + 1][i0 + 3] - ak[j0][i0 + 3];
	                    out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
	                  }
	                  return out;
	                };
	              } else if (bsmoothing) {
	                return function(out, i0, j0, u, v) {
	                  if (!out) out = [];
	                  var f0, f1, k, ak;
	                  j0 *= 3;
	                  var ou = 1 - u;
	                  var v2 = v * v;
	                  var ov = 1 - v;
	                  var ov2 = ov * ov;
	                  var ovv2 = ov * v * 2;
	                  var a = -3 * ov2;
	                  var b = 3 * (ov2 - ovv2);
	                  var c = 3 * (ovv2 - v2);
	                  var d = 3 * v2;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
	                    f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
	                    out[k] = ou * f0 + u * f1;
	                  }
	                  return out;
	                };
	              } else {
	                return function(out, i0, j0, v, u) {
	                  if (!out) out = [];
	                  var f0, f1, k, ak;
	                  var ov = 1 - v;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ak[j0 + 1][i0] - ak[j0][i0];
	                    f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
	                    out[k] = ov * f0 + v * f1;
	                  }
	                  return out;
	                };
	              }
	            };
	          }
	        ),
	        /***/
	        20349: (
	          /***/
	          function(module2) {
	            module2.exports = function(arrays, na, nb, asmoothing, bsmoothing) {
	              var imax = na - 2;
	              var jmax = nb - 2;
	              if (asmoothing && bsmoothing) {
	                return function(out, i, j) {
	                  if (!out) out = [];
	                  var f0, f1, f2, f3, ak, k;
	                  var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	                  var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	                  var u = Math.max(0, Math.min(1, i - i0));
	                  var v = Math.max(0, Math.min(1, j - j0));
	                  i0 *= 3;
	                  j0 *= 3;
	                  var u2 = u * u;
	                  var u3 = u2 * u;
	                  var ou = 1 - u;
	                  var ou2 = ou * ou;
	                  var ou3 = ou2 * ou;
	                  var v2 = v * v;
	                  var v3 = v2 * v;
	                  var ov = 1 - v;
	                  var ov2 = ov * ov;
	                  var ov3 = ov2 * ov;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ou3 * ak[j0][i0] + 3 * (ou2 * u * ak[j0][i0 + 1] + ou * u2 * ak[j0][i0 + 2]) + u3 * ak[j0][i0 + 3];
	                    f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
	                    f2 = ou3 * ak[j0 + 2][i0] + 3 * (ou2 * u * ak[j0 + 2][i0 + 1] + ou * u2 * ak[j0 + 2][i0 + 2]) + u3 * ak[j0 + 2][i0 + 3];
	                    f3 = ou3 * ak[j0 + 3][i0] + 3 * (ou2 * u * ak[j0 + 3][i0 + 1] + ou * u2 * ak[j0 + 3][i0 + 2]) + u3 * ak[j0 + 3][i0 + 3];
	                    out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	                  }
	                  return out;
	                };
	              } else if (asmoothing) {
	                return function(out, i, j) {
	                  if (!out) out = [];
	                  var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	                  var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	                  var u = Math.max(0, Math.min(1, i - i0));
	                  var v = Math.max(0, Math.min(1, j - j0));
	                  var f0, f1, f2, f3, k, ak;
	                  i0 *= 3;
	                  var u2 = u * u;
	                  var u3 = u2 * u;
	                  var ou = 1 - u;
	                  var ou2 = ou * ou;
	                  var ou3 = ou2 * ou;
	                  var ov = 1 - v;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ov * ak[j0][i0] + v * ak[j0 + 1][i0];
	                    f1 = ov * ak[j0][i0 + 1] + v * ak[j0 + 1][i0 + 1];
	                    f2 = ov * ak[j0][i0 + 2] + v * ak[j0 + 1][i0 + 1];
	                    f3 = ov * ak[j0][i0 + 3] + v * ak[j0 + 1][i0 + 1];
	                    out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
	                  }
	                  return out;
	                };
	              } else if (bsmoothing) {
	                return function(out, i, j) {
	                  if (!out) out = [];
	                  var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	                  var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	                  var u = Math.max(0, Math.min(1, i - i0));
	                  var v = Math.max(0, Math.min(1, j - j0));
	                  var f0, f1, f2, f3, k, ak;
	                  j0 *= 3;
	                  var v2 = v * v;
	                  var v3 = v2 * v;
	                  var ov = 1 - v;
	                  var ov2 = ov * ov;
	                  var ov3 = ov2 * ov;
	                  var ou = 1 - u;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
	                    f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
	                    f2 = ou * ak[j0 + 2][i0] + u * ak[j0 + 2][i0 + 1];
	                    f3 = ou * ak[j0 + 3][i0] + u * ak[j0 + 3][i0 + 1];
	                    out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
	                  }
	                  return out;
	                };
	              } else {
	                return function(out, i, j) {
	                  if (!out) out = [];
	                  var i0 = Math.max(0, Math.min(Math.floor(i), imax));
	                  var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
	                  var u = Math.max(0, Math.min(1, i - i0));
	                  var v = Math.max(0, Math.min(1, j - j0));
	                  var f0, f1, k, ak;
	                  var ov = 1 - v;
	                  var ou = 1 - u;
	                  for (k = 0; k < arrays.length; k++) {
	                    ak = arrays[k];
	                    f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
	                    f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
	                    out[k] = ov * f0 + v * f1;
	                  }
	                  return out;
	                };
	              }
	            };
	          }
	        ),
	        /***/
	        92087: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleXYDefaults = __webpack_require__2(19237);
	            var handleABDefaults = __webpack_require__2(13145);
	            var attributes = __webpack_require__2(99798);
	            var colorAttrs = __webpack_require__2(22399);
	            module2.exports = function supplyDefaults(traceIn, traceOut, dfltColor, fullLayout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              traceOut._clipPathId = "clip" + traceOut.uid + "carpet";
	              var defaultColor = coerce("color", colorAttrs.defaultLine);
	              Lib.coerceFont(coerce, "font");
	              coerce("carpet");
	              handleABDefaults(traceIn, traceOut, fullLayout, coerce, defaultColor);
	              if (!traceOut.a || !traceOut.b) {
	                traceOut.visible = false;
	                return;
	              }
	              if (traceOut.a.length < 3) {
	                traceOut.aaxis.smoothing = 0;
	              }
	              if (traceOut.b.length < 3) {
	                traceOut.baxis.smoothing = 0;
	              }
	              var validData = handleXYDefaults(traceIn, traceOut, coerce);
	              if (!validData) {
	                traceOut.visible = false;
	              }
	              if (traceOut._cheater) {
	                coerce("cheaterslope");
	              }
	            };
	          }
	        ),
	        /***/
	        21462: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(99798),
	              supplyDefaults: __webpack_require__2(92087),
	              plot: __webpack_require__2(89740),
	              calc: __webpack_require__2(25281),
	              animatable: true,
	              isContainer: true,
	              // so carpet traces get `calc` before other traces
	              moduleType: "trace",
	              name: "carpet",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "carpet", "carpetAxis", "notLegendIsolatable", "noMultiCategory", "noHover", "noSortingByValue"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        22882: (
	          /***/
	          function(module2) {
	            module2.exports = function(gd, trace) {
	              var n = gd._fullData.length;
	              var firstAxis;
	              for (var i = 0; i < n; i++) {
	                var maybeCarpet = gd._fullData[i];
	                if (maybeCarpet.index === trace.index) continue;
	                if (maybeCarpet.type === "carpet") {
	                  if (!firstAxis) {
	                    firstAxis = maybeCarpet;
	                  }
	                  if (maybeCarpet.carpet === trace.carpet) {
	                    return maybeCarpet;
	                  }
	                }
	              }
	              return firstAxis;
	            };
	          }
	        ),
	        /***/
	        67961: (
	          /***/
	          function(module2) {
	            module2.exports = function makePath(xp, yp, isBicubic) {
	              if (xp.length === 0) return "";
	              var i;
	              var path = [];
	              var stride = isBicubic ? 3 : 1;
	              for (i = 0; i < xp.length; i += stride) {
	                path.push(xp[i] + "," + yp[i]);
	                if (isBicubic && i < xp.length - stride) {
	                  path.push("C");
	                  path.push([xp[i + 1] + "," + yp[i + 1], xp[i + 2] + "," + yp[i + 2] + " "].join(" "));
	                }
	              }
	              return path.join(isBicubic ? "" : "L");
	            };
	          }
	        ),
	        /***/
	        27669: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function mapArray(out, data, func) {
	              var i;
	              if (!isArrayOrTypedArray(out)) {
	                out = [];
	              } else if (out.length > data.length) {
	                out = out.slice(0, data.length);
	              }
	              for (i = 0; i < data.length; i++) {
	                out[i] = func(data[i]);
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        11651: (
	          /***/
	          function(module2) {
	            module2.exports = function orientText(trace, xaxis, yaxis, xy, dxy, refDxy) {
	              var dx = dxy[0] * trace.dpdx(xaxis);
	              var dy = dxy[1] * trace.dpdy(yaxis);
	              var flip = 1;
	              var offsetMultiplier = 1;
	              if (refDxy) {
	                var l1 = Math.sqrt(dxy[0] * dxy[0] + dxy[1] * dxy[1]);
	                var l2 = Math.sqrt(refDxy[0] * refDxy[0] + refDxy[1] * refDxy[1]);
	                var dot = (dxy[0] * refDxy[0] + dxy[1] * refDxy[1]) / l1 / l2;
	                offsetMultiplier = Math.max(0, dot);
	              }
	              var angle = Math.atan2(dy, dx) * 180 / Math.PI;
	              if (angle < -90) {
	                angle += 180;
	                flip = -flip;
	              } else if (angle > 90) {
	                angle -= 180;
	                flip = -flip;
	              }
	              return {
	                angle,
	                flip,
	                p: trace.c2p(xy, xaxis, yaxis),
	                offsetMultplier: offsetMultiplier
	              };
	            };
	          }
	        ),
	        /***/
	        89740: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var map1dArray = __webpack_require__2(27669);
	            var makepath = __webpack_require__2(67961);
	            var orientText = __webpack_require__2(11651);
	            var svgTextUtils = __webpack_require__2(63893);
	            var Lib = __webpack_require__2(71828);
	            var strRotate = Lib.strRotate;
	            var strTranslate = Lib.strTranslate;
	            var alignmentConstants = __webpack_require__2(18783);
	            module2.exports = function plot(gd, plotinfo, cdcarpet, carpetLayer) {
	              var isStatic = gd._context.staticPlot;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var fullLayout = gd._fullLayout;
	              var clipLayer = fullLayout._clips;
	              Lib.makeTraceGroups(carpetLayer, cdcarpet, "trace").each(function(cd) {
	                var axisLayer = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var aax = trace.aaxis;
	                var bax = trace.baxis;
	                var minorLayer = Lib.ensureSingle(axisLayer, "g", "minorlayer");
	                var majorLayer = Lib.ensureSingle(axisLayer, "g", "majorlayer");
	                var boundaryLayer = Lib.ensureSingle(axisLayer, "g", "boundarylayer");
	                var labelLayer = Lib.ensureSingle(axisLayer, "g", "labellayer");
	                axisLayer.style("opacity", trace.opacity);
	                drawGridLines(xa, ya, majorLayer, aax, "a", aax._gridlines, true);
	                drawGridLines(xa, ya, majorLayer, bax, "b", bax._gridlines, true);
	                drawGridLines(xa, ya, minorLayer, aax, "a", aax._minorgridlines, true);
	                drawGridLines(xa, ya, minorLayer, bax, "b", bax._minorgridlines, true);
	                drawGridLines(xa, ya, boundaryLayer, aax, "a-boundary", aax._boundarylines, isStatic);
	                drawGridLines(xa, ya, boundaryLayer, bax, "b-boundary", bax._boundarylines, isStatic);
	                var labelOrientationA = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, aax._labels, "a-label");
	                var labelOrientationB = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, bax._labels, "b-label");
	                drawAxisTitles(gd, labelLayer, trace, cd0, xa, ya, labelOrientationA, labelOrientationB);
	                drawClipPath(trace, cd0, clipLayer, xa, ya);
	              });
	            };
	            function drawClipPath(trace, t, layer, xaxis, yaxis) {
	              var seg, xp, yp, i;
	              var clip = layer.select("#" + trace._clipPathId);
	              if (!clip.size()) {
	                clip = layer.append("clipPath").classed("carpetclip", true);
	              }
	              var path = Lib.ensureSingle(clip, "path", "carpetboundary");
	              var segments = t.clipsegments;
	              var segs = [];
	              for (i = 0; i < segments.length; i++) {
	                seg = segments[i];
	                xp = map1dArray([], seg.x, xaxis.c2p);
	                yp = map1dArray([], seg.y, yaxis.c2p);
	                segs.push(makepath(xp, yp, seg.bicubic));
	              }
	              var clipPathData = "M" + segs.join("L") + "Z";
	              clip.attr("id", trace._clipPathId);
	              path.attr("d", clipPathData);
	            }
	            function drawGridLines(xaxis, yaxis, layer, axis, axisLetter, gridlines, isStatic) {
	              var lineClass = "const-" + axisLetter + "-lines";
	              var gridJoin = layer.selectAll("." + lineClass).data(gridlines);
	              gridJoin.enter().append("path").classed(lineClass, true).style("vector-effect", isStatic ? "none" : "non-scaling-stroke");
	              gridJoin.each(function(d) {
	                var gridline = d;
	                var x = gridline.x;
	                var y = gridline.y;
	                var xp = map1dArray([], x, xaxis.c2p);
	                var yp = map1dArray([], y, yaxis.c2p);
	                var path = "M" + makepath(xp, yp, gridline.smoothing);
	                var el = d3.select(this);
	                el.attr("d", path).style("stroke-width", gridline.width).style("stroke", gridline.color).style("stroke-dasharray", Drawing.dashStyle(gridline.dash, gridline.width)).style("fill", "none");
	              });
	              gridJoin.exit().remove();
	            }
	            function drawAxisLabels(gd, xaxis, yaxis, trace, t, layer, labels, labelClass) {
	              var labelJoin = layer.selectAll("text." + labelClass).data(labels);
	              labelJoin.enter().append("text").classed(labelClass, true);
	              var maxExtent = 0;
	              var labelOrientation = {};
	              labelJoin.each(function(label, i) {
	                var orientation;
	                if (label.axis.tickangle === "auto") {
	                  orientation = orientText(trace, xaxis, yaxis, label.xy, label.dxy);
	                } else {
	                  var angle = (label.axis.tickangle + 180) * Math.PI / 180;
	                  orientation = orientText(trace, xaxis, yaxis, label.xy, [Math.cos(angle), Math.sin(angle)]);
	                }
	                if (!i) {
	                  labelOrientation = {
	                    angle: orientation.angle,
	                    flip: orientation.flip
	                  };
	                }
	                var direction = (label.endAnchor ? -1 : 1) * orientation.flip;
	                var labelEl = d3.select(this).attr({
	                  "text-anchor": direction > 0 ? "start" : "end",
	                  "data-notex": 1
	                }).call(Drawing.font, label.font).text(label.text).call(svgTextUtils.convertToTspans, gd);
	                var bbox = Drawing.bBox(this);
	                labelEl.attr(
	                  "transform",
	                  // Translate to the correct point:
	                  strTranslate(orientation.p[0], orientation.p[1]) + // Rotate to line up with grid line tangent:
	                  strRotate(orientation.angle) + // Adjust the baseline and indentation:
	                  strTranslate(label.axis.labelpadding * direction, bbox.height * 0.3)
	                );
	                maxExtent = Math.max(maxExtent, bbox.width + label.axis.labelpadding);
	              });
	              labelJoin.exit().remove();
	              labelOrientation.maxExtent = maxExtent;
	              return labelOrientation;
	            }
	            function drawAxisTitles(gd, layer, trace, t, xa, ya, labelOrientationA, labelOrientationB) {
	              var a, b, xy, dxy;
	              var aMin = Lib.aggNums(Math.min, null, trace.a);
	              var aMax = Lib.aggNums(Math.max, null, trace.a);
	              var bMin = Lib.aggNums(Math.min, null, trace.b);
	              var bMax = Lib.aggNums(Math.max, null, trace.b);
	              a = 0.5 * (aMin + aMax);
	              b = bMin;
	              xy = trace.ab2xy(a, b, true);
	              dxy = trace.dxyda_rough(a, b);
	              if (labelOrientationA.angle === undefined) {
	                Lib.extendFlat(labelOrientationA, orientText(trace, xa, ya, xy, trace.dxydb_rough(a, b)));
	              }
	              drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.aaxis, xa, ya, labelOrientationA, "a-title");
	              a = aMin;
	              b = 0.5 * (bMin + bMax);
	              xy = trace.ab2xy(a, b, true);
	              dxy = trace.dxydb_rough(a, b);
	              if (labelOrientationB.angle === undefined) {
	                Lib.extendFlat(labelOrientationB, orientText(trace, xa, ya, xy, trace.dxyda_rough(a, b)));
	              }
	              drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.baxis, xa, ya, labelOrientationB, "b-title");
	            }
	            var lineSpacing = alignmentConstants.LINE_SPACING;
	            var midShift = (1 - alignmentConstants.MID_SHIFT) / lineSpacing + 1;
	            function drawAxisTitle(gd, layer, trace, t, xy, dxy, axis, xa, ya, labelOrientation, labelClass) {
	              var data = [];
	              if (axis.title.text) data.push(axis.title.text);
	              var titleJoin = layer.selectAll("text." + labelClass).data(data);
	              var offset = labelOrientation.maxExtent;
	              titleJoin.enter().append("text").classed(labelClass, true);
	              titleJoin.each(function() {
	                var orientation = orientText(trace, xa, ya, xy, dxy);
	                if (["start", "both"].indexOf(axis.showticklabels) === -1) {
	                  offset = 0;
	                }
	                var titleSize = axis.title.font.size;
	                offset += titleSize + axis.title.offset;
	                var labelNorm = labelOrientation.angle + (labelOrientation.flip < 0 ? 180 : 0);
	                var angleDiff = (labelNorm - orientation.angle + 450) % 360;
	                var reverseTitle = angleDiff > 90 && angleDiff < 270;
	                var el = d3.select(this);
	                el.text(axis.title.text).call(svgTextUtils.convertToTspans, gd);
	                if (reverseTitle) {
	                  offset = (-svgTextUtils.lineCount(el) + midShift) * lineSpacing * titleSize - offset;
	                }
	                el.attr("transform", strTranslate(orientation.p[0], orientation.p[1]) + strRotate(orientation.angle) + strTranslate(0, offset)).attr("text-anchor", "middle").call(Drawing.font, axis.title.font);
	              });
	              titleJoin.exit().remove();
	            }
	          }
	        ),
	        /***/
	        11435: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var constants = __webpack_require__2(35509);
	            var search = __webpack_require__2(65888).findBin;
	            var computeControlPoints = __webpack_require__2(45664);
	            var createSplineEvaluator = __webpack_require__2(20349);
	            var createIDerivativeEvaluator = __webpack_require__2(54495);
	            var createJDerivativeEvaluator = __webpack_require__2(73057);
	            module2.exports = function setConvert(trace) {
	              var a = trace._a;
	              var b = trace._b;
	              var na = a.length;
	              var nb = b.length;
	              var aax = trace.aaxis;
	              var bax = trace.baxis;
	              var amin = a[0];
	              var amax = a[na - 1];
	              var bmin = b[0];
	              var bmax = b[nb - 1];
	              var arange = a[a.length - 1] - a[0];
	              var brange = b[b.length - 1] - b[0];
	              var atol = arange * constants.RELATIVE_CULL_TOLERANCE;
	              var btol = brange * constants.RELATIVE_CULL_TOLERANCE;
	              amin -= atol;
	              amax += atol;
	              bmin -= btol;
	              bmax += btol;
	              trace.isVisible = function(a2, b2) {
	                return a2 > amin && a2 < amax && b2 > bmin && b2 < bmax;
	              };
	              trace.isOccluded = function(a2, b2) {
	                return a2 < amin || a2 > amax || b2 < bmin || b2 > bmax;
	              };
	              trace.setScale = function() {
	                var x = trace._x;
	                var y = trace._y;
	                var result = computeControlPoints(trace._xctrl, trace._yctrl, x, y, aax.smoothing, bax.smoothing);
	                trace._xctrl = result[0];
	                trace._yctrl = result[1];
	                trace.evalxy = createSplineEvaluator([trace._xctrl, trace._yctrl], na, nb, aax.smoothing, bax.smoothing);
	                trace.dxydi = createIDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
	                trace.dxydj = createJDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
	              };
	              trace.i2a = function(i) {
	                var i0 = Math.max(0, Math.floor(i[0]), na - 2);
	                var ti = i[0] - i0;
	                return (1 - ti) * a[i0] + ti * a[i0 + 1];
	              };
	              trace.j2b = function(j) {
	                var j0 = Math.max(0, Math.floor(j[1]), na - 2);
	                var tj = j[1] - j0;
	                return (1 - tj) * b[j0] + tj * b[j0 + 1];
	              };
	              trace.ij2ab = function(ij) {
	                return [trace.i2a(ij[0]), trace.j2b(ij[1])];
	              };
	              trace.a2i = function(aval) {
	                var i0 = Math.max(0, Math.min(search(aval, a), na - 2));
	                var a0 = a[i0];
	                var a1 = a[i0 + 1];
	                return Math.max(0, Math.min(na - 1, i0 + (aval - a0) / (a1 - a0)));
	              };
	              trace.b2j = function(bval) {
	                var j0 = Math.max(0, Math.min(search(bval, b), nb - 2));
	                var b0 = b[j0];
	                var b1 = b[j0 + 1];
	                return Math.max(0, Math.min(nb - 1, j0 + (bval - b0) / (b1 - b0)));
	              };
	              trace.ab2ij = function(ab) {
	                return [trace.a2i(ab[0]), trace.b2j(ab[1])];
	              };
	              trace.i2c = function(i, j) {
	                return trace.evalxy([], i, j);
	              };
	              trace.ab2xy = function(aval, bval, extrapolate) {
	                if (!extrapolate && (aval < a[0] || aval > a[na - 1] | bval < b[0] || bval > b[nb - 1])) {
	                  return [false, false];
	                }
	                var i = trace.a2i(aval);
	                var j = trace.b2j(bval);
	                var pt = trace.evalxy([], i, j);
	                if (extrapolate) {
	                  var iex = 0;
	                  var jex = 0;
	                  var der = [];
	                  var i0, ti, j0, tj;
	                  if (aval < a[0]) {
	                    i0 = 0;
	                    ti = 0;
	                    iex = (aval - a[0]) / (a[1] - a[0]);
	                  } else if (aval > a[na - 1]) {
	                    i0 = na - 2;
	                    ti = 1;
	                    iex = (aval - a[na - 1]) / (a[na - 1] - a[na - 2]);
	                  } else {
	                    i0 = Math.max(0, Math.min(na - 2, Math.floor(i)));
	                    ti = i - i0;
	                  }
	                  if (bval < b[0]) {
	                    j0 = 0;
	                    tj = 0;
	                    jex = (bval - b[0]) / (b[1] - b[0]);
	                  } else if (bval > b[nb - 1]) {
	                    j0 = nb - 2;
	                    tj = 1;
	                    jex = (bval - b[nb - 1]) / (b[nb - 1] - b[nb - 2]);
	                  } else {
	                    j0 = Math.max(0, Math.min(nb - 2, Math.floor(j)));
	                    tj = j - j0;
	                  }
	                  if (iex) {
	                    trace.dxydi(der, i0, j0, ti, tj);
	                    pt[0] += der[0] * iex;
	                    pt[1] += der[1] * iex;
	                  }
	                  if (jex) {
	                    trace.dxydj(der, i0, j0, ti, tj);
	                    pt[0] += der[0] * jex;
	                    pt[1] += der[1] * jex;
	                  }
	                }
	                return pt;
	              };
	              trace.c2p = function(xy, xa, ya) {
	                return [xa.c2p(xy[0]), ya.c2p(xy[1])];
	              };
	              trace.p2x = function(p, xa, ya) {
	                return [xa.p2c(p[0]), ya.p2c(p[1])];
	              };
	              trace.dadi = function(i) {
	                var i0 = Math.max(0, Math.min(a.length - 2, i));
	                return a[i0 + 1] - a[i0];
	              };
	              trace.dbdj = function(j) {
	                var j0 = Math.max(0, Math.min(b.length - 2, j));
	                return b[j0 + 1] - b[j0];
	              };
	              trace.dxyda = function(i0, j0, u, v) {
	                var dxydi = trace.dxydi(null, i0, j0, u, v);
	                var dadi = trace.dadi(i0, u);
	                return [dxydi[0] / dadi, dxydi[1] / dadi];
	              };
	              trace.dxydb = function(i0, j0, u, v) {
	                var dxydj = trace.dxydj(null, i0, j0, u, v);
	                var dbdj = trace.dbdj(j0, v);
	                return [dxydj[0] / dbdj, dxydj[1] / dbdj];
	              };
	              trace.dxyda_rough = function(a2, b2, reldiff) {
	                var h = arange * (reldiff || 0.1);
	                var plus = trace.ab2xy(a2 + h, b2, true);
	                var minus = trace.ab2xy(a2 - h, b2, true);
	                return [(plus[0] - minus[0]) * 0.5 / h, (plus[1] - minus[1]) * 0.5 / h];
	              };
	              trace.dxydb_rough = function(a2, b2, reldiff) {
	                var h = brange * (reldiff || 0.1);
	                var plus = trace.ab2xy(a2, b2 + h, true);
	                var minus = trace.ab2xy(a2, b2 - h, true);
	                return [(plus[0] - minus[0]) * 0.5 / h, (plus[1] - minus[1]) * 0.5 / h];
	              };
	              trace.dpdx = function(xa) {
	                return xa._m;
	              };
	              trace.dpdy = function(ya) {
	                return ya._m;
	              };
	            };
	          }
	        ),
	        /***/
	        72505: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function smoothFill2dArray(data, a, b) {
	              var i, j, k;
	              var ip = [];
	              var jp = [];
	              var ni = data[0].length;
	              var nj = data.length;
	              function avgSurrounding(i2, j2) {
	                var sum = 0;
	                var val;
	                var cnt = 0;
	                if (i2 > 0 && (val = data[j2][i2 - 1]) !== undefined) {
	                  cnt++;
	                  sum += val;
	                }
	                if (i2 < ni - 1 && (val = data[j2][i2 + 1]) !== undefined) {
	                  cnt++;
	                  sum += val;
	                }
	                if (j2 > 0 && (val = data[j2 - 1][i2]) !== undefined) {
	                  cnt++;
	                  sum += val;
	                }
	                if (j2 < nj - 1 && (val = data[j2 + 1][i2]) !== undefined) {
	                  cnt++;
	                  sum += val;
	                }
	                return sum / Math.max(1, cnt);
	              }
	              var dmax = 0;
	              for (i = 0; i < ni; i++) {
	                for (j = 0; j < nj; j++) {
	                  if (data[j][i] === undefined) {
	                    ip.push(i);
	                    jp.push(j);
	                    data[j][i] = avgSurrounding(i, j);
	                  }
	                  dmax = Math.max(dmax, Math.abs(data[j][i]));
	                }
	              }
	              if (!ip.length) return data;
	              var dxp, dxm, dap, dam, dbp, dbm, c, d, diff, reldiff, overrelaxation;
	              var tol = 1e-5;
	              var resid = 0;
	              var itermax = 100;
	              var iter = 0;
	              var n = ip.length;
	              do {
	                resid = 0;
	                for (k = 0; k < n; k++) {
	                  i = ip[k];
	                  j = jp[k];
	                  var boundaryCnt = 0;
	                  var newVal = 0;
	                  var d0, d1, x0, x1, i0, j0;
	                  if (i === 0) {
	                    i0 = Math.min(ni - 1, 2);
	                    x0 = a[i0];
	                    x1 = a[1];
	                    d0 = data[j][i0];
	                    d1 = data[j][1];
	                    newVal += d1 + (d1 - d0) * (a[0] - x1) / (x1 - x0);
	                    boundaryCnt++;
	                  } else if (i === ni - 1) {
	                    i0 = Math.max(0, ni - 3);
	                    x0 = a[i0];
	                    x1 = a[ni - 2];
	                    d0 = data[j][i0];
	                    d1 = data[j][ni - 2];
	                    newVal += d1 + (d1 - d0) * (a[ni - 1] - x1) / (x1 - x0);
	                    boundaryCnt++;
	                  }
	                  if ((i === 0 || i === ni - 1) && j > 0 && j < nj - 1) {
	                    dxp = b[j + 1] - b[j];
	                    dxm = b[j] - b[j - 1];
	                    newVal += (dxm * data[j + 1][i] + dxp * data[j - 1][i]) / (dxm + dxp);
	                    boundaryCnt++;
	                  }
	                  if (j === 0) {
	                    j0 = Math.min(nj - 1, 2);
	                    x0 = b[j0];
	                    x1 = b[1];
	                    d0 = data[j0][i];
	                    d1 = data[1][i];
	                    newVal += d1 + (d1 - d0) * (b[0] - x1) / (x1 - x0);
	                    boundaryCnt++;
	                  } else if (j === nj - 1) {
	                    j0 = Math.max(0, nj - 3);
	                    x0 = b[j0];
	                    x1 = b[nj - 2];
	                    d0 = data[j0][i];
	                    d1 = data[nj - 2][i];
	                    newVal += d1 + (d1 - d0) * (b[nj - 1] - x1) / (x1 - x0);
	                    boundaryCnt++;
	                  }
	                  if ((j === 0 || j === nj - 1) && i > 0 && i < ni - 1) {
	                    dxp = a[i + 1] - a[i];
	                    dxm = a[i] - a[i - 1];
	                    newVal += (dxm * data[j][i + 1] + dxp * data[j][i - 1]) / (dxm + dxp);
	                    boundaryCnt++;
	                  }
	                  if (!boundaryCnt) {
	                    dap = a[i + 1] - a[i];
	                    dam = a[i] - a[i - 1];
	                    dbp = b[j + 1] - b[j];
	                    dbm = b[j] - b[j - 1];
	                    c = dap * dam * (dap + dam);
	                    d = dbp * dbm * (dbp + dbm);
	                    newVal = (c * (dbm * data[j + 1][i] + dbp * data[j - 1][i]) + d * (dam * data[j][i + 1] + dap * data[j][i - 1])) / (d * (dam + dap) + c * (dbm + dbp));
	                  } else {
	                    newVal /= boundaryCnt;
	                  }
	                  diff = newVal - data[j][i];
	                  reldiff = diff / dmax;
	                  resid += reldiff * reldiff;
	                  overrelaxation = boundaryCnt ? 0 : 0.85;
	                  data[j][i] += diff * (1 + overrelaxation);
	                }
	                resid = Math.sqrt(resid);
	              } while (iter++ < itermax && resid > tol);
	              Lib.log("Smoother converged to", resid, "after", iter, "iterations");
	              return data;
	            };
	          }
	        ),
	        /***/
	        19237: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArray1D = __webpack_require__2(71828).isArray1D;
	            module2.exports = function handleXYDefaults(traceIn, traceOut, coerce) {
	              var x = coerce("x");
	              var hasX = x && x.length;
	              var y = coerce("y");
	              var hasY = y && y.length;
	              if (!hasX && !hasY) return false;
	              traceOut._cheater = !x;
	              if ((!hasX || isArray1D(x)) && (!hasY || isArray1D(y))) {
	                var len = hasX ? x.length : Infinity;
	                if (hasY) len = Math.min(len, y.length);
	                if (traceOut.a && traceOut.a.length) len = Math.min(len, traceOut.a.length);
	                if (traceOut.b && traceOut.b.length) len = Math.min(len, traceOut.b.length);
	                traceOut._length = len;
	              } else traceOut._length = null;
	              return true;
	            };
	          }
	        ),
	        /***/
	        69568: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var scatterGeoAttrs = __webpack_require__2(19316);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var baseAttrs = __webpack_require__2(9012);
	            var defaultLine = __webpack_require__2(22399).defaultLine;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterGeoMarkerLineAttrs = scatterGeoAttrs.marker.line;
	            module2.exports = extendFlat({
	              locations: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              locationmode: scatterGeoAttrs.locationmode,
	              z: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              geojson: extendFlat({}, scatterGeoAttrs.geojson, {}),
	              featureidkey: scatterGeoAttrs.featureidkey,
	              text: extendFlat({}, scatterGeoAttrs.text, {}),
	              hovertext: extendFlat({}, scatterGeoAttrs.hovertext, {}),
	              marker: {
	                line: {
	                  color: extendFlat({}, scatterGeoMarkerLineAttrs.color, {
	                    dflt: defaultLine
	                  }),
	                  width: extendFlat({}, scatterGeoMarkerLineAttrs.width, {
	                    dflt: 1
	                  }),
	                  editType: "calc"
	                },
	                opacity: {
	                  valType: "number",
	                  arrayOk: true,
	                  min: 0,
	                  max: 1,
	                  dflt: 1,
	                  editType: "style"
	                },
	                editType: "calc"
	              },
	              selected: {
	                marker: {
	                  opacity: scatterGeoAttrs.selected.marker.opacity,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              unselected: {
	                marker: {
	                  opacity: scatterGeoAttrs.unselected.marker.opacity,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                editType: "calc",
	                flags: ["location", "z", "text", "name"]
	              }),
	              hovertemplate: hovertemplateAttrs(),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              editTypeOverride: "calc"
	            }));
	          }
	        ),
	        /***/
	        38675: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var colorscaleCalc = __webpack_require__2(78803);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            function isNonBlankString(v) {
	              return v && typeof v === "string";
	            }
	            module2.exports = function calc(gd, trace) {
	              var len = trace._length;
	              var calcTrace = new Array(len);
	              var isValidLoc;
	              if (trace.geojson) {
	                isValidLoc = function(v) {
	                  return isNonBlankString(v) || isNumeric(v);
	                };
	              } else {
	                isValidLoc = isNonBlankString;
	              }
	              for (var i = 0; i < len; i++) {
	                var calcPt = calcTrace[i] = {};
	                var loc = trace.locations[i];
	                var z = trace.z[i];
	                if (isValidLoc(loc) && isNumeric(z)) {
	                  calcPt.loc = loc;
	                  calcPt.z = z;
	                } else {
	                  calcPt.loc = null;
	                  calcPt.z = BADNUM;
	                }
	                calcPt.index = i;
	              }
	              arraysToCalcdata(calcTrace, trace);
	              colorscaleCalc(gd, trace, {
	                vals: trace.z,
	                containerStr: "",
	                cLetter: "z"
	              });
	              calcSelection(calcTrace, trace);
	              return calcTrace;
	            };
	          }
	        ),
	        /***/
	        61869: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(69568);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var locations = coerce("locations");
	              var z = coerce("z");
	              if (!(locations && locations.length && Lib.isArrayOrTypedArray(z) && z.length)) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = Math.min(locations.length, z.length);
	              var geojson = coerce("geojson");
	              var locationmodeDflt;
	              if (typeof geojson === "string" && geojson !== "" || Lib.isPlainObject(geojson)) {
	                locationmodeDflt = "geojson-id";
	              }
	              var locationMode = coerce("locationmode", locationmodeDflt);
	              if (locationMode === "geojson-id") {
	                coerce("featureidkey");
	              }
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var mlw = coerce("marker.line.width");
	              if (mlw) coerce("marker.line.color");
	              coerce("marker.opacity");
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "z"
	              });
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        92069: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt, trace, cd, pointNumber) {
	              out.location = pt.location;
	              out.z = pt.z;
	              var cdi = cd[pointNumber];
	              if (cdi.fIn && cdi.fIn.properties) {
	                out.properties = cdi.fIn.properties;
	              }
	              out.ct = cdi.ct;
	              return out;
	            };
	          }
	        ),
	        /***/
	        42300: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var attributes = __webpack_require__2(69568);
	            var fillText = __webpack_require__2(71828).fillText;
	            module2.exports = function hoverPoints(pointData, xval, yval) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var geo = pointData.subplot;
	              var pt, i, j, isInside;
	              var xy = [xval, yval];
	              var altXy = [xval + 360, yval];
	              for (i = 0; i < cd.length; i++) {
	                pt = cd[i];
	                isInside = false;
	                if (pt._polygons) {
	                  for (j = 0; j < pt._polygons.length; j++) {
	                    if (pt._polygons[j].contains(xy)) {
	                      isInside = !isInside;
	                    }
	                    if (pt._polygons[j].contains(altXy)) {
	                      isInside = !isInside;
	                    }
	                  }
	                  if (isInside) break;
	                }
	              }
	              if (!isInside || !pt) return;
	              pointData.x0 = pointData.x1 = pointData.xa.c2p(pt.ct);
	              pointData.y0 = pointData.y1 = pointData.ya.c2p(pt.ct);
	              pointData.index = pt.index;
	              pointData.location = pt.loc;
	              pointData.z = pt.z;
	              pointData.zLabel = Axes.tickText(geo.mockAxis, geo.mockAxis.c2l(pt.z), "hover").text;
	              pointData.hovertemplate = pt.hovertemplate;
	              makeHoverInfo(pointData, trace, pt);
	              return [pointData];
	            };
	            function makeHoverInfo(pointData, trace, pt) {
	              if (trace.hovertemplate) return;
	              var hoverinfo = pt.hi || trace.hoverinfo;
	              var loc = String(pt.loc);
	              var parts = hoverinfo === "all" ? attributes.hoverinfo.flags : hoverinfo.split("+");
	              var hasName = parts.indexOf("name") !== -1;
	              var hasLocation = parts.indexOf("location") !== -1;
	              var hasZ = parts.indexOf("z") !== -1;
	              var hasText = parts.indexOf("text") !== -1;
	              var hasIdAsNameLabel = !hasName && hasLocation;
	              var text = [];
	              if (hasIdAsNameLabel) {
	                pointData.nameOverride = loc;
	              } else {
	                if (hasName) pointData.nameOverride = trace.name;
	                if (hasLocation) text.push(loc);
	              }
	              if (hasZ) {
	                text.push(pointData.zLabel);
	              }
	              if (hasText) {
	                fillText(pt, trace, text);
	              }
	              pointData.extraText = text.join("<br>");
	            }
	          }
	        ),
	        /***/
	        51319: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(69568),
	              supplyDefaults: __webpack_require__2(61869),
	              colorbar: __webpack_require__2(61243),
	              calc: __webpack_require__2(38675),
	              calcGeoJSON: __webpack_require__2(99841).calcGeoJSON,
	              plot: __webpack_require__2(99841).plot,
	              style: __webpack_require__2(99636).style,
	              styleOnSelect: __webpack_require__2(99636).styleOnSelect,
	              hoverPoints: __webpack_require__2(42300),
	              eventData: __webpack_require__2(92069),
	              selectPoints: __webpack_require__2(81253),
	              moduleType: "trace",
	              name: "choropleth",
	              basePlotModule: __webpack_require__2(44622),
	              categories: ["geo", "noOpacity", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        99841: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var geoUtils = __webpack_require__2(41327);
	            var getTopojsonFeatures = __webpack_require__2(90973).getTopojsonFeatures;
	            var findExtremes = __webpack_require__2(71739).findExtremes;
	            var style = __webpack_require__2(99636).style;
	            function plot(gd, geo, calcData) {
	              var choroplethLayer = geo.layers.backplot.select(".choroplethlayer");
	              Lib.makeTraceGroups(choroplethLayer, calcData, "trace choropleth").each(function(calcTrace) {
	                var sel = d3.select(this);
	                var paths = sel.selectAll("path.choroplethlocation").data(Lib.identity);
	                paths.enter().append("path").classed("choroplethlocation", true);
	                paths.exit().remove();
	                style(gd, calcTrace);
	              });
	            }
	            function calcGeoJSON(calcTrace, fullLayout) {
	              var trace = calcTrace[0].trace;
	              var geoLayout = fullLayout[trace.geo];
	              var geo = geoLayout._subplot;
	              var locationmode = trace.locationmode;
	              var len = trace._length;
	              var features = locationmode === "geojson-id" ? geoUtils.extractTraceFeature(calcTrace) : getTopojsonFeatures(trace, geo.topojson);
	              var lonArray = [];
	              var latArray = [];
	              for (var i = 0; i < len; i++) {
	                var calcPt = calcTrace[i];
	                var feature = locationmode === "geojson-id" ? calcPt.fOut : geoUtils.locationToFeature(locationmode, calcPt.loc, features);
	                if (feature) {
	                  calcPt.geojson = feature;
	                  calcPt.ct = feature.properties.ct;
	                  calcPt._polygons = geoUtils.feature2polygons(feature);
	                  var bboxFeature = geoUtils.computeBbox(feature);
	                  lonArray.push(bboxFeature[0], bboxFeature[2]);
	                  latArray.push(bboxFeature[1], bboxFeature[3]);
	                } else {
	                  calcPt.geojson = null;
	                }
	              }
	              if (geoLayout.fitbounds === "geojson" && locationmode === "geojson-id") {
	                var bboxGeojson = geoUtils.computeBbox(geoUtils.getTraceGeojson(trace));
	                lonArray = [bboxGeojson[0], bboxGeojson[2]];
	                latArray = [bboxGeojson[1], bboxGeojson[3]];
	              }
	              var opts = {
	                padded: true
	              };
	              trace._extremes.lon = findExtremes(geoLayout.lonaxis._ax, lonArray, opts);
	              trace._extremes.lat = findExtremes(geoLayout.lataxis._ax, latArray, opts);
	            }
	            module2.exports = {
	              calcGeoJSON,
	              plot
	            };
	          }
	        ),
	        /***/
	        81253: (
	          /***/
	          function(module2) {
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var i, di, ct, x, y;
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  cd[i].selected = 0;
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  di = cd[i];
	                  ct = di.ct;
	                  if (!ct) continue;
	                  x = xa.c2p(ct);
	                  y = ya.c2p(ct);
	                  if (selectionTester.contains([x, y], null, i, searchInfo)) {
	                    selection.push({
	                      pointNumber: i,
	                      lon: ct[0],
	                      lat: ct[1]
	                    });
	                    di.selected = 1;
	                  } else {
	                    di.selected = 0;
	                  }
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        99636: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Colorscale = __webpack_require__2(21081);
	            function style(gd, calcTrace) {
	              if (calcTrace) styleTrace(gd, calcTrace);
	            }
	            function styleTrace(gd, calcTrace) {
	              var trace = calcTrace[0].trace;
	              var s = calcTrace[0].node3;
	              var locs = s.selectAll(".choroplethlocation");
	              var marker = trace.marker || {};
	              var markerLine = marker.line || {};
	              var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
	              locs.each(function(d) {
	                d3.select(this).attr("fill", sclFunc(d.z)).call(Color.stroke, d.mlc || markerLine.color).call(Drawing.dashLine, "", d.mlw || markerLine.width || 0).style("opacity", marker.opacity);
	              });
	              Drawing.selectedPointStyle(locs, trace);
	            }
	            function styleOnSelect(gd, calcTrace) {
	              var s = calcTrace[0].node3;
	              var trace = calcTrace[0].trace;
	              if (trace.selectedpoints) {
	                Drawing.selectedPointStyle(s.selectAll(".choroplethlocation"), trace);
	              } else {
	                styleTrace(gd, calcTrace);
	              }
	            }
	            module2.exports = {
	              style,
	              styleOnSelect
	            };
	          }
	        ),
	        /***/
	        64496: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var choroplethAttrs = __webpack_require__2(69568);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = extendFlat({
	              locations: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              // TODO
	              // Maybe start with only one value (that we could name e.g. 'geojson-id'),
	              // but eventually:
	              // - we could also support for our own dist/topojson/*
	              //   .. and locationmode: choroplethAttrs.locationmode,
	              z: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              // TODO maybe we could also set a "key" to dig out values out of the
	              // GeoJSON feature `properties` fields?
	              geojson: {
	                valType: "any",
	                editType: "calc"
	              },
	              featureidkey: extendFlat({}, choroplethAttrs.featureidkey, {}),
	              // TODO agree on name / behaviour
	              //
	              // 'below' is used currently for layout.mapbox.layers,
	              // even though it's not very plotly-esque.
	              //
	              // Note also, that the mapbox-gl style don't all have the same layers,
	              // see https://codepen.io/etpinard/pen/ydVMwM for full list
	              below: {
	                valType: "string",
	                editType: "plot"
	              },
	              text: choroplethAttrs.text,
	              hovertext: choroplethAttrs.hovertext,
	              marker: {
	                line: {
	                  color: extendFlat({}, choroplethAttrs.marker.line.color, {
	                    editType: "plot"
	                  }),
	                  width: extendFlat({}, choroplethAttrs.marker.line.width, {
	                    editType: "plot"
	                  }),
	                  editType: "calc"
	                },
	                // TODO maybe having a dflt less than 1, together with `below:''` would be better?
	                opacity: extendFlat({}, choroplethAttrs.marker.opacity, {
	                  editType: "plot"
	                }),
	                editType: "calc"
	              },
	              selected: {
	                marker: {
	                  opacity: extendFlat({}, choroplethAttrs.selected.marker.opacity, {
	                    editType: "plot"
	                  }),
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              unselected: {
	                marker: {
	                  opacity: extendFlat({}, choroplethAttrs.unselected.marker.opacity, {
	                    editType: "plot"
	                  }),
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              hoverinfo: choroplethAttrs.hoverinfo,
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: ["properties"]
	              }),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              editTypeOverride: "calc"
	            }));
	          }
	        ),
	        /***/
	        82004: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Colorscale = __webpack_require__2(21081);
	            var Drawing = __webpack_require__2(91424);
	            var makeBlank = __webpack_require__2(18214).makeBlank;
	            var geoUtils = __webpack_require__2(41327);
	            function convert(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var isVisible = trace.visible === true && trace._length !== 0;
	              var fill = {
	                layout: {
	                  visibility: "none"
	                },
	                paint: {}
	              };
	              var line = {
	                layout: {
	                  visibility: "none"
	                },
	                paint: {}
	              };
	              var opts = trace._opts = {
	                fill,
	                line,
	                geojson: makeBlank()
	              };
	              if (!isVisible) return opts;
	              var features = geoUtils.extractTraceFeature(calcTrace);
	              if (!features) return opts;
	              var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
	              var marker = trace.marker;
	              var markerLine = marker.line || {};
	              var opacityFn;
	              if (Lib.isArrayOrTypedArray(marker.opacity)) {
	                opacityFn = function(d) {
	                  var mo = d.mo;
	                  return isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
	                };
	              }
	              var lineColorFn;
	              if (Lib.isArrayOrTypedArray(markerLine.color)) {
	                lineColorFn = function(d) {
	                  return d.mlc;
	                };
	              }
	              var lineWidthFn;
	              if (Lib.isArrayOrTypedArray(markerLine.width)) {
	                lineWidthFn = function(d) {
	                  return d.mlw;
	                };
	              }
	              for (var i = 0; i < calcTrace.length; i++) {
	                var cdi = calcTrace[i];
	                var fOut = cdi.fOut;
	                if (fOut) {
	                  var props = fOut.properties;
	                  props.fc = sclFunc(cdi.z);
	                  if (opacityFn) props.mo = opacityFn(cdi);
	                  if (lineColorFn) props.mlc = lineColorFn(cdi);
	                  if (lineWidthFn) props.mlw = lineWidthFn(cdi);
	                  cdi.ct = props.ct;
	                  cdi._polygons = geoUtils.feature2polygons(fOut);
	                }
	              }
	              var opacitySetting = opacityFn ? {
	                type: "identity",
	                property: "mo"
	              } : marker.opacity;
	              Lib.extendFlat(fill.paint, {
	                "fill-color": {
	                  type: "identity",
	                  property: "fc"
	                },
	                "fill-opacity": opacitySetting
	              });
	              Lib.extendFlat(line.paint, {
	                "line-color": lineColorFn ? {
	                  type: "identity",
	                  property: "mlc"
	                } : markerLine.color,
	                "line-width": lineWidthFn ? {
	                  type: "identity",
	                  property: "mlw"
	                } : markerLine.width,
	                "line-opacity": opacitySetting
	              });
	              fill.layout.visibility = "visible";
	              line.layout.visibility = "visible";
	              opts.geojson = {
	                type: "FeatureCollection",
	                features
	              };
	              convertOnSelect(calcTrace);
	              return opts;
	            }
	            function convertOnSelect(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var opts = trace._opts;
	              var opacitySetting;
	              if (trace.selectedpoints) {
	                var fns = Drawing.makeSelectedPointStyleFns(trace);
	                for (var i = 0; i < calcTrace.length; i++) {
	                  var cdi = calcTrace[i];
	                  if (cdi.fOut) {
	                    cdi.fOut.properties.mo2 = fns.selectedOpacityFn(cdi);
	                  }
	                }
	                opacitySetting = {
	                  type: "identity",
	                  property: "mo2"
	                };
	              } else {
	                opacitySetting = Lib.isArrayOrTypedArray(trace.marker.opacity) ? {
	                  type: "identity",
	                  property: "mo"
	                } : trace.marker.opacity;
	              }
	              Lib.extendFlat(opts.fill.paint, {
	                "fill-opacity": opacitySetting
	              });
	              Lib.extendFlat(opts.line.paint, {
	                "line-opacity": opacitySetting
	              });
	              return opts;
	            }
	            module2.exports = {
	              convert,
	              convertOnSelect
	            };
	          }
	        ),
	        /***/
	        22654: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(64496);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var locations = coerce("locations");
	              var z = coerce("z");
	              var geojson = coerce("geojson");
	              if (!Lib.isArrayOrTypedArray(locations) || !locations.length || !Lib.isArrayOrTypedArray(z) || !z.length || !(typeof geojson === "string" && geojson !== "" || Lib.isPlainObject(geojson))) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("featureidkey");
	              traceOut._length = Math.min(locations.length, z.length);
	              coerce("below");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var mlw = coerce("marker.line.width");
	              if (mlw) coerce("marker.line.color");
	              coerce("marker.opacity");
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "z"
	              });
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        57516: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(64496),
	              supplyDefaults: __webpack_require__2(22654),
	              colorbar: __webpack_require__2(61243),
	              calc: __webpack_require__2(38675),
	              plot: __webpack_require__2(7852),
	              hoverPoints: __webpack_require__2(42300),
	              eventData: __webpack_require__2(92069),
	              selectPoints: __webpack_require__2(81253),
	              styleOnSelect: function(_, cd) {
	                if (cd) {
	                  var trace = cd[0].trace;
	                  trace._glTrace.updateOnSelect(cd);
	                }
	              },
	              getBelow: function(trace, subplot) {
	                var mapLayers = subplot.getMapLayers();
	                for (var i = mapLayers.length - 2; i >= 0; i--) {
	                  var layerId = mapLayers[i].id;
	                  if (typeof layerId === "string" && layerId.indexOf("water") === 0) {
	                    for (var j = i + 1; j < mapLayers.length; j++) {
	                      layerId = mapLayers[j].id;
	                      if (typeof layerId === "string" && layerId.indexOf("plotly-") === -1) {
	                        return layerId;
	                      }
	                    }
	                  }
	                }
	              },
	              moduleType: "trace",
	              name: "choroplethmapbox",
	              basePlotModule: __webpack_require__2(50101),
	              categories: ["mapbox", "gl", "noOpacity", "showLegend"],
	              meta: {
	                hr_name: "choropleth_mapbox"
	              }
	            };
	          }
	        ),
	        /***/
	        7852: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var convert = __webpack_require__2(82004).convert;
	            var convertOnSelect = __webpack_require__2(82004).convertOnSelect;
	            var LAYER_PREFIX = __webpack_require__2(77734).traceLayerPrefix;
	            function ChoroplethMapbox(subplot, uid) {
	              this.type = "choroplethmapbox";
	              this.subplot = subplot;
	              this.uid = uid;
	              this.sourceId = "source-" + uid;
	              this.layerList = [["fill", LAYER_PREFIX + uid + "-fill"], ["line", LAYER_PREFIX + uid + "-line"]];
	              this.below = null;
	            }
	            var proto = ChoroplethMapbox.prototype;
	            proto.update = function(calcTrace) {
	              this._update(convert(calcTrace));
	              calcTrace[0].trace._glTrace = this;
	            };
	            proto.updateOnSelect = function(calcTrace) {
	              this._update(convertOnSelect(calcTrace));
	            };
	            proto._update = function(optsAll) {
	              var subplot = this.subplot;
	              var layerList = this.layerList;
	              var below = subplot.belowLookup["trace-" + this.uid];
	              subplot.map.getSource(this.sourceId).setData(optsAll.geojson);
	              if (below !== this.below) {
	                this._removeLayers();
	                this._addLayers(optsAll, below);
	                this.below = below;
	              }
	              for (var i = 0; i < layerList.length; i++) {
	                var item = layerList[i];
	                var k = item[0];
	                var id = item[1];
	                var opts = optsAll[k];
	                subplot.setOptions(id, "setLayoutProperty", opts.layout);
	                if (opts.layout.visibility === "visible") {
	                  subplot.setOptions(id, "setPaintProperty", opts.paint);
	                }
	              }
	            };
	            proto._addLayers = function(optsAll, below) {
	              var subplot = this.subplot;
	              var layerList = this.layerList;
	              var sourceId = this.sourceId;
	              for (var i = 0; i < layerList.length; i++) {
	                var item = layerList[i];
	                var k = item[0];
	                var opts = optsAll[k];
	                subplot.addLayer({
	                  type: k,
	                  id: item[1],
	                  source: sourceId,
	                  layout: opts.layout,
	                  paint: opts.paint
	                }, below);
	              }
	            };
	            proto._removeLayers = function() {
	              var map2 = this.subplot.map;
	              var layerList = this.layerList;
	              for (var i = layerList.length - 1; i >= 0; i--) {
	                map2.removeLayer(layerList[i][1]);
	              }
	            };
	            proto.dispose = function() {
	              var map2 = this.subplot.map;
	              this._removeLayers();
	              map2.removeSource(this.sourceId);
	            };
	            module2.exports = function createChoroplethMapbox(subplot, calcTrace) {
	              var trace = calcTrace[0].trace;
	              var choroplethMapbox = new ChoroplethMapbox(subplot, trace.uid);
	              var sourceId = choroplethMapbox.sourceId;
	              var optsAll = convert(calcTrace);
	              var below = choroplethMapbox.below = subplot.belowLookup["trace-" + trace.uid];
	              subplot.map.addSource(sourceId, {
	                type: "geojson",
	                data: optsAll.geojson
	              });
	              choroplethMapbox._addLayers(optsAll, below);
	              calcTrace[0].trace._glTrace = choroplethMapbox;
	              return choroplethMapbox;
	            };
	          }
	        ),
	        /***/
	        12674: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var mesh3dAttrs = __webpack_require__2(2418);
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var attrs = {
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              z: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              u: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              v: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              w: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              // TODO add way to specify cone positions independently of the vector field
	              // provided, similar to MATLAB's coneplot Cx/Cy/Cz meshgrids,
	              // see https://www.mathworks.com/help/matlab/ref/coneplot.html
	              //
	              // Alternatively, if our goal is only to 'fill in gaps' in the vector data,
	              // we could try to extend the heatmap 'connectgaps' algorithm to 3D.
	              // From AJ: this particular algorithm which amounts to a Poisson equation,
	              // both for interpolation and extrapolation - is the right one to use for
	              // cones too.  It makes a field with zero divergence, which is a good
	              // baseline assumption for vector fields.
	              //
	              // cones: {
	              //     // potential attributes to add:
	              //     //
	              //     // - meshmode: 'cartesian-product', 'pts', 'grid'
	              //     //
	              //     // under `meshmode: 'grid'`
	              //     // - (x|y|z)grid.start
	              //     // - (x|y|z)grid.end
	              //     // - (x|y|z)grid.size
	              //
	              //     x: {
	              //         valType: 'data_array',
	              //         editType: 'calc',
	              //
	              //     },
	              //     y: {
	              //         valType: 'data_array',
	              //         editType: 'calc',
	              //
	              //     },
	              //     z: {
	              //         valType: 'data_array',
	              //         editType: 'calc',
	              //
	              //     },
	              //
	              //     editType: 'calc',
	              //
	              // },
	              sizemode: {
	                valType: "enumerated",
	                values: ["scaled", "absolute"],
	                editType: "calc",
	                dflt: "scaled"
	              },
	              sizeref: {
	                valType: "number",
	                editType: "calc",
	                min: 0
	              },
	              anchor: {
	                valType: "enumerated",
	                editType: "calc",
	                values: ["tip", "tail", "cm", "center"],
	                dflt: "cm"
	              },
	              text: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              hovertemplate: hovertemplateAttrs({
	                editType: "calc"
	              }, {
	                keys: ["norm"]
	              }),
	              uhoverformat: axisHoverFormat("u", 1),
	              vhoverformat: axisHoverFormat("v", 1),
	              whoverformat: axisHoverFormat("w", 1),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z"),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            };
	            extendFlat(attrs, colorScaleAttrs("", {
	              colorAttr: "u/v/w norm",
	              showScaleDflt: true,
	              editTypeOverride: "calc"
	            }));
	            var fromMesh3d = ["opacity", "lightposition", "lighting"];
	            fromMesh3d.forEach(function(k) {
	              attrs[k] = mesh3dAttrs[k];
	            });
	            attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
	              editType: "calc",
	              flags: ["x", "y", "z", "u", "v", "w", "norm", "text", "name"],
	              dflt: "x+y+z+norm+text+name"
	            });
	            attrs.transforms = undefined;
	            module2.exports = attrs;
	          }
	        ),
	        /***/
	        31371: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorscaleCalc = __webpack_require__2(78803);
	            module2.exports = function calc(gd, trace) {
	              var u = trace.u;
	              var v = trace.v;
	              var w = trace.w;
	              var len = Math.min(trace.x.length, trace.y.length, trace.z.length, u.length, v.length, w.length);
	              var normMax = -Infinity;
	              var normMin = Infinity;
	              for (var i = 0; i < len; i++) {
	                var uu = u[i];
	                var vv = v[i];
	                var ww = w[i];
	                var norm = Math.sqrt(uu * uu + vv * vv + ww * ww);
	                normMax = Math.max(normMax, norm);
	                normMin = Math.min(normMin, norm);
	              }
	              trace._len = len;
	              trace._normMax = normMax;
	              colorscaleCalc(gd, trace, {
	                vals: [normMin, normMax],
	                containerStr: "",
	                cLetter: "c"
	              });
	            };
	          }
	        ),
	        /***/
	        5453: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var conePlot = __webpack_require__2(9330).gl_cone3d;
	            var createConeMesh = __webpack_require__2(9330).gl_cone3d.createConeMesh;
	            var simpleMap = __webpack_require__2(71828).simpleMap;
	            var parseColorScale = __webpack_require__2(81697).parseColorScale;
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            var zip3 = __webpack_require__2(90060);
	            function Cone(scene, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.mesh = null;
	              this.data = null;
	            }
	            var proto = Cone.prototype;
	            proto.handlePick = function(selection) {
	              if (selection.object === this.mesh) {
	                var selectIndex = selection.index = selection.data.index;
	                var xx = this.data.x[selectIndex];
	                var yy = this.data.y[selectIndex];
	                var zz = this.data.z[selectIndex];
	                var uu = this.data.u[selectIndex];
	                var vv = this.data.v[selectIndex];
	                var ww = this.data.w[selectIndex];
	                selection.traceCoordinate = [xx, yy, zz, uu, vv, ww, Math.sqrt(uu * uu + vv * vv + ww * ww)];
	                var text = this.data.hovertext || this.data.text;
	                if (Array.isArray(text) && text[selectIndex] !== undefined) {
	                  selection.textLabel = text[selectIndex];
	                } else if (text) {
	                  selection.textLabel = text;
	                }
	                return true;
	              }
	            };
	            var axisName2scaleIndex = {
	              xaxis: 0,
	              yaxis: 1,
	              zaxis: 2
	            };
	            var anchor2coneOffset = {
	              tip: 1,
	              tail: 0,
	              cm: 0.25,
	              center: 0.5
	            };
	            var anchor2coneSpan = {
	              tip: 1,
	              tail: 1,
	              cm: 0.75,
	              center: 0.5
	            };
	            function convert(scene, trace) {
	              var sceneLayout = scene.fullSceneLayout;
	              var dataScale = scene.dataScale;
	              var coneOpts = {};
	              function toDataCoords(arr, axisName) {
	                var ax = sceneLayout[axisName];
	                var scale = dataScale[axisName2scaleIndex[axisName]];
	                return simpleMap(arr, function(v) {
	                  return ax.d2l(v) * scale;
	                });
	              }
	              coneOpts.vectors = zip3(toDataCoords(trace.u, "xaxis"), toDataCoords(trace.v, "yaxis"), toDataCoords(trace.w, "zaxis"), trace._len);
	              coneOpts.positions = zip3(toDataCoords(trace.x, "xaxis"), toDataCoords(trace.y, "yaxis"), toDataCoords(trace.z, "zaxis"), trace._len);
	              var cOpts = extractOpts(trace);
	              coneOpts.colormap = parseColorScale(trace);
	              coneOpts.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
	              coneOpts.coneOffset = anchor2coneOffset[trace.anchor];
	              if (trace.sizemode === "scaled") {
	                coneOpts.coneSize = trace.sizeref || 0.5;
	              } else {
	                coneOpts.coneSize = trace.sizeref && trace._normMax ? trace.sizeref / trace._normMax : 0.5;
	              }
	              var meshData = conePlot(coneOpts);
	              var lp = trace.lightposition;
	              meshData.lightPosition = [lp.x, lp.y, lp.z];
	              meshData.ambient = trace.lighting.ambient;
	              meshData.diffuse = trace.lighting.diffuse;
	              meshData.specular = trace.lighting.specular;
	              meshData.roughness = trace.lighting.roughness;
	              meshData.fresnel = trace.lighting.fresnel;
	              meshData.opacity = trace.opacity;
	              trace._pad = anchor2coneSpan[trace.anchor] * meshData.vectorScale * meshData.coneScale * trace._normMax;
	              return meshData;
	            }
	            proto.update = function(data) {
	              this.data = data;
	              var meshData = convert(this.scene, data);
	              this.mesh.update(meshData);
	            };
	            proto.dispose = function() {
	              this.scene.glplot.remove(this.mesh);
	              this.mesh.dispose();
	            };
	            function createConeTrace(scene, data) {
	              var gl2 = scene.glplot.gl;
	              var meshData = convert(scene, data);
	              var mesh = createConeMesh(gl2, meshData);
	              var cone = new Cone(scene, data.uid);
	              cone.mesh = mesh;
	              cone.data = data;
	              mesh._trace = cone;
	              scene.glplot.add(mesh);
	              return cone;
	            }
	            module2.exports = createConeTrace;
	          }
	        ),
	        /***/
	        91750: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(12674);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var u = coerce("u");
	              var v = coerce("v");
	              var w = coerce("w");
	              var x = coerce("x");
	              var y = coerce("y");
	              var z = coerce("z");
	              if (!u || !u.length || !v || !v.length || !w || !w.length || !x || !x.length || !y || !y.length || !z || !z.length) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("sizeref");
	              coerce("sizemode");
	              coerce("anchor");
	              coerce("lighting.ambient");
	              coerce("lighting.diffuse");
	              coerce("lighting.specular");
	              coerce("lighting.roughness");
	              coerce("lighting.fresnel");
	              coerce("lightposition.x");
	              coerce("lightposition.y");
	              coerce("lightposition.z");
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "c"
	              });
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("uhoverformat");
	              coerce("vhoverformat");
	              coerce("whoverformat");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("zhoverformat");
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        98128: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "cone",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "showLegend"],
	              attributes: __webpack_require__2(12674),
	              supplyDefaults: __webpack_require__2(91750),
	              colorbar: {
	                min: "cmin",
	                max: "cmax"
	              },
	              calc: __webpack_require__2(31371),
	              plot: __webpack_require__2(5453),
	              eventData: function(out, pt) {
	                out.norm = pt.traceCoordinate[6];
	                return out;
	              },
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        70600: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var heatmapAttrs = __webpack_require__2(21606);
	            var scatterAttrs = __webpack_require__2(82196);
	            var axisFormat = __webpack_require__2(12663);
	            var axisHoverFormat = axisFormat.axisHoverFormat;
	            var descriptionOnlyNumbers = axisFormat.descriptionOnlyNumbers;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var dash = __webpack_require__2(79952).P;
	            var fontAttrs = __webpack_require__2(41940);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var filterOps = __webpack_require__2(74808);
	            var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
	            var INTERVAL_OPS = filterOps.INTERVAL_OPS;
	            var scatterLineAttrs = scatterAttrs.line;
	            module2.exports = extendFlat({
	              z: heatmapAttrs.z,
	              x: heatmapAttrs.x,
	              x0: heatmapAttrs.x0,
	              dx: heatmapAttrs.dx,
	              y: heatmapAttrs.y,
	              y0: heatmapAttrs.y0,
	              dy: heatmapAttrs.dy,
	              xperiod: heatmapAttrs.xperiod,
	              yperiod: heatmapAttrs.yperiod,
	              xperiod0: scatterAttrs.xperiod0,
	              yperiod0: scatterAttrs.yperiod0,
	              xperiodalignment: heatmapAttrs.xperiodalignment,
	              yperiodalignment: heatmapAttrs.yperiodalignment,
	              text: heatmapAttrs.text,
	              hovertext: heatmapAttrs.hovertext,
	              transpose: heatmapAttrs.transpose,
	              xtype: heatmapAttrs.xtype,
	              ytype: heatmapAttrs.ytype,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z", 1),
	              hovertemplate: heatmapAttrs.hovertemplate,
	              texttemplate: extendFlat({}, heatmapAttrs.texttemplate, {}),
	              textfont: extendFlat({}, heatmapAttrs.textfont, {}),
	              hoverongaps: heatmapAttrs.hoverongaps,
	              connectgaps: extendFlat({}, heatmapAttrs.connectgaps, {}),
	              fillcolor: {
	                valType: "color",
	                editType: "calc"
	              },
	              autocontour: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc",
	                impliedEdits: {
	                  "contours.start": undefined,
	                  "contours.end": undefined,
	                  "contours.size": undefined
	                }
	              },
	              ncontours: {
	                valType: "integer",
	                dflt: 15,
	                min: 1,
	                editType: "calc"
	              },
	              contours: {
	                type: {
	                  valType: "enumerated",
	                  values: ["levels", "constraint"],
	                  dflt: "levels",
	                  editType: "calc"
	                },
	                start: {
	                  valType: "number",
	                  dflt: null,
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autocontour": false
	                  }
	                },
	                end: {
	                  valType: "number",
	                  dflt: null,
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autocontour": false
	                  }
	                },
	                size: {
	                  valType: "number",
	                  dflt: null,
	                  min: 0,
	                  editType: "plot",
	                  impliedEdits: {
	                    "^autocontour": false
	                  }
	                },
	                coloring: {
	                  valType: "enumerated",
	                  values: ["fill", "heatmap", "lines", "none"],
	                  dflt: "fill",
	                  editType: "calc"
	                },
	                showlines: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                showlabels: {
	                  valType: "boolean",
	                  dflt: false,
	                  editType: "plot"
	                },
	                labelfont: fontAttrs({
	                  editType: "plot",
	                  colorEditType: "style"
	                }),
	                labelformat: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot",
	                  description: descriptionOnlyNumbers("contour label")
	                },
	                operation: {
	                  valType: "enumerated",
	                  values: [].concat(COMPARISON_OPS2).concat(INTERVAL_OPS),
	                  dflt: "=",
	                  editType: "calc"
	                },
	                value: {
	                  valType: "any",
	                  dflt: 0,
	                  editType: "calc"
	                },
	                editType: "calc",
	                impliedEdits: {
	                  autocontour: false
	                }
	              },
	              line: {
	                color: extendFlat({}, scatterLineAttrs.color, {
	                  editType: "style+colorbars"
	                }),
	                width: {
	                  valType: "number",
	                  min: 0,
	                  editType: "style+colorbars"
	                },
	                dash,
	                smoothing: extendFlat({}, scatterLineAttrs.smoothing, {}),
	                editType: "plot"
	              }
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              autoColorDflt: false,
	              editTypeOverride: "calc"
	            }));
	          }
	        ),
	        /***/
	        27529: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Colorscale = __webpack_require__2(21081);
	            var heatmapCalc = __webpack_require__2(90757);
	            var setContours = __webpack_require__2(18670);
	            var endPlus = __webpack_require__2(53572);
	            module2.exports = function calc(gd, trace) {
	              var cd = heatmapCalc(gd, trace);
	              var zOut = cd[0].z;
	              setContours(trace, zOut);
	              var contours = trace.contours;
	              var cOpts = Colorscale.extractOpts(trace);
	              var cVals;
	              if (contours.coloring === "heatmap" && cOpts.auto && trace.autocontour === false) {
	                var start = contours.start;
	                var end = endPlus(contours);
	                var cs = contours.size || 1;
	                var nc = Math.floor((end - start) / cs) + 1;
	                if (!isFinite(cs)) {
	                  cs = 1;
	                  nc = 1;
	                }
	                var min0 = start - cs / 2;
	                var max0 = min0 + nc * cs;
	                cVals = [min0, max0];
	              } else {
	                cVals = zOut;
	              }
	              Colorscale.calc(gd, trace, {
	                vals: cVals,
	                cLetter: "z"
	              });
	              return cd;
	            };
	          }
	        ),
	        /***/
	        20083: (
	          /***/
	          function(module2) {
	            module2.exports = function(pathinfo, contours) {
	              var pi0 = pathinfo[0];
	              var z = pi0.z;
	              var i;
	              switch (contours.type) {
	                case "levels":
	                  var edgeVal2 = Math.min(z[0][0], z[0][1]);
	                  for (i = 0; i < pathinfo.length; i++) {
	                    var pi = pathinfo[i];
	                    pi.prefixBoundary = !pi.edgepaths.length && (edgeVal2 > pi.level || pi.starts.length && edgeVal2 === pi.level);
	                  }
	                  break;
	                case "constraint":
	                  pi0.prefixBoundary = false;
	                  if (pi0.edgepaths.length) return;
	                  var na = pi0.x.length;
	                  var nb = pi0.y.length;
	                  var boundaryMax = -Infinity;
	                  var boundaryMin = Infinity;
	                  for (i = 0; i < nb; i++) {
	                    boundaryMin = Math.min(boundaryMin, z[i][0]);
	                    boundaryMin = Math.min(boundaryMin, z[i][na - 1]);
	                    boundaryMax = Math.max(boundaryMax, z[i][0]);
	                    boundaryMax = Math.max(boundaryMax, z[i][na - 1]);
	                  }
	                  for (i = 1; i < na - 1; i++) {
	                    boundaryMin = Math.min(boundaryMin, z[0][i]);
	                    boundaryMin = Math.min(boundaryMin, z[nb - 1][i]);
	                    boundaryMax = Math.max(boundaryMax, z[0][i]);
	                    boundaryMax = Math.max(boundaryMax, z[nb - 1][i]);
	                  }
	                  var contoursValue = contours.value;
	                  var v1, v2;
	                  switch (contours._operation) {
	                    case ">":
	                      if (contoursValue > boundaryMax) {
	                        pi0.prefixBoundary = true;
	                      }
	                      break;
	                    case "<":
	                      if (contoursValue < boundaryMin || pi0.starts.length && contoursValue === boundaryMin) {
	                        pi0.prefixBoundary = true;
	                      }
	                      break;
	                    case "[]":
	                      v1 = Math.min(contoursValue[0], contoursValue[1]);
	                      v2 = Math.max(contoursValue[0], contoursValue[1]);
	                      if (v2 < boundaryMin || v1 > boundaryMax || pi0.starts.length && v2 === boundaryMin) {
	                        pi0.prefixBoundary = true;
	                      }
	                      break;
	                    case "][":
	                      v1 = Math.min(contoursValue[0], contoursValue[1]);
	                      v2 = Math.max(contoursValue[0], contoursValue[1]);
	                      if (v1 < boundaryMin && v2 > boundaryMax) {
	                        pi0.prefixBoundary = true;
	                      }
	                      break;
	                  }
	                  break;
	              }
	            };
	          }
	        ),
	        /***/
	        90654: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Colorscale = __webpack_require__2(21081);
	            var makeColorMap = __webpack_require__2(86068);
	            var endPlus = __webpack_require__2(53572);
	            function calc(gd, trace, opts) {
	              var contours = trace.contours;
	              var line = trace.line;
	              var cs = contours.size || 1;
	              var coloring = contours.coloring;
	              var colorMap = makeColorMap(trace, {
	                isColorbar: true
	              });
	              if (coloring === "heatmap") {
	                var cOpts = Colorscale.extractOpts(trace);
	                opts._fillgradient = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;
	                opts._zrange = [cOpts.min, cOpts.max];
	              } else if (coloring === "fill") {
	                opts._fillcolor = colorMap;
	              }
	              opts._line = {
	                color: coloring === "lines" ? colorMap : line.color,
	                width: contours.showlines !== false ? line.width : 0,
	                dash: line.dash
	              };
	              opts._levels = {
	                start: contours.start,
	                end: endPlus(contours),
	                size: cs
	              };
	            }
	            module2.exports = {
	              min: "zmin",
	              max: "zmax",
	              calc
	            };
	          }
	        ),
	        /***/
	        36914: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // some constants to help with marching squares algorithm
	              // where does the path start for each index?
	              BOTTOMSTART: [1, 9, 13, 104, 713],
	              TOPSTART: [4, 6, 7, 104, 713],
	              LEFTSTART: [8, 12, 14, 208, 1114],
	              RIGHTSTART: [2, 3, 11, 208, 1114],
	              // which way [dx,dy] do we leave a given index?
	              // saddles are already disambiguated
	              NEWDELTA: [null, [-1, 0], [0, -1], [-1, 0], [1, 0], null, [0, -1], [-1, 0], [0, 1], [0, 1], null, [0, 1], [1, 0], [1, 0], [0, -1]],
	              // for each saddle, the first index here is used
	              // for dx||dy<0, the second for dx||dy>0
	              CHOOSESADDLE: {
	                104: [4, 1],
	                208: [2, 8],
	                713: [7, 13],
	                1114: [11, 14]
	              },
	              // after one index has been used for a saddle, which do we
	              // substitute to be used up later?
	              SADDLEREMAINDER: {
	                1: 4,
	                2: 8,
	                4: 1,
	                7: 13,
	                8: 2,
	                11: 14,
	                13: 7,
	                14: 11
	              },
	              // length of a contour, as a multiple of the plot area diagonal, per label
	              LABELDISTANCE: 2,
	              // number of contour levels after which we start increasing the number of
	              // labels we draw. Many contours means they will generally be close
	              // together, so it will be harder to follow a long way to find a label
	              LABELINCREASE: 10,
	              // minimum length of a contour line, as a multiple of the label length,
	              // at which we draw *any* labels
	              LABELMIN: 3,
	              // max number of labels to draw on a single contour path, no matter how long
	              LABELMAX: 10,
	              // constants for the label position cost function
	              LABELOPTIMIZER: {
	                // weight given to edge proximity
	                EDGECOST: 1,
	                // weight given to the angle off horizontal
	                ANGLECOST: 1,
	                // weight given to distance from already-placed labels
	                NEIGHBORCOST: 5,
	                // cost multiplier for labels on the same level
	                SAMELEVELFACTOR: 10,
	                // minimum distance (as a multiple of the label length)
	                // for labels on the same level
	                SAMELEVELDISTANCE: 5,
	                // maximum cost before we won't even place the label
	                MAXCOST: 100,
	                // number of evenly spaced points to look at in the first
	                // iteration of the search
	                INITIALSEARCHPOINTS: 10,
	                // number of binary search iterations after the initial wide search
	                ITERATIONS: 5
	              }
	            };
	          }
	        ),
	        /***/
	        83179: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var handleLabelDefaults = __webpack_require__2(14523);
	            var Color = __webpack_require__2(7901);
	            var addOpacity = Color.addOpacity;
	            var opacity = Color.opacity;
	            var filterOps = __webpack_require__2(74808);
	            var CONSTRAINT_REDUCTION = filterOps.CONSTRAINT_REDUCTION;
	            var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
	            module2.exports = function handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, opts) {
	              var contours = traceOut.contours;
	              var showLines, lineColor, fillColor;
	              var operation = coerce("contours.operation");
	              contours._operation = CONSTRAINT_REDUCTION[operation];
	              handleConstraintValueDefaults(coerce, contours);
	              if (operation === "=") {
	                showLines = contours.showlines = true;
	              } else {
	                showLines = coerce("contours.showlines");
	                fillColor = coerce("fillcolor", addOpacity((traceIn.line || {}).color || defaultColor, 0.5));
	              }
	              if (showLines) {
	                var lineDfltColor = fillColor && opacity(fillColor) ? addOpacity(traceOut.fillcolor, 1) : defaultColor;
	                lineColor = coerce("line.color", lineDfltColor);
	                coerce("line.width", 2);
	                coerce("line.dash");
	              }
	              coerce("line.smoothing");
	              handleLabelDefaults(coerce, layout, lineColor, opts);
	            };
	            function handleConstraintValueDefaults(coerce, contours) {
	              var zvalue;
	              if (COMPARISON_OPS2.indexOf(contours.operation) === -1) {
	                coerce("contours.value", [0, 1]);
	                if (!Array.isArray(contours.value)) {
	                  if (isNumeric(contours.value)) {
	                    zvalue = parseFloat(contours.value);
	                    contours.value = [zvalue, zvalue + 1];
	                  }
	                } else if (contours.value.length > 2) {
	                  contours.value = contours.value.slice(2);
	                } else if (contours.length === 0) {
	                  contours.value = [0, 1];
	                } else if (contours.length < 2) {
	                  zvalue = parseFloat(contours.value[0]);
	                  contours.value = [zvalue, zvalue + 1];
	                } else {
	                  contours.value = [parseFloat(contours.value[0]), parseFloat(contours.value[1])];
	                }
	              } else {
	                coerce("contours.value", 0);
	                if (!isNumeric(contours.value)) {
	                  if (Array.isArray(contours.value)) {
	                    contours.value = parseFloat(contours.value[0]);
	                  } else {
	                    contours.value = 0;
	                  }
	                }
	              }
	            }
	          }
	        ),
	        /***/
	        64237: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var filterOps = __webpack_require__2(74808);
	            var isNumeric = __webpack_require__2(92770);
	            module2.exports = {
	              "[]": makeRangeSettings("[]"),
	              "][": makeRangeSettings("]["),
	              ">": makeInequalitySettings(">"),
	              "<": makeInequalitySettings("<"),
	              "=": makeInequalitySettings("=")
	            };
	            function coerceValue(operation, value) {
	              var hasArrayValue = Array.isArray(value);
	              var coercedValue;
	              function coerce(value2) {
	                return isNumeric(value2) ? +value2 : null;
	              }
	              if (filterOps.COMPARISON_OPS2.indexOf(operation) !== -1) {
	                coercedValue = hasArrayValue ? coerce(value[0]) : coerce(value);
	              } else if (filterOps.INTERVAL_OPS.indexOf(operation) !== -1) {
	                coercedValue = hasArrayValue ? [coerce(value[0]), coerce(value[1])] : [coerce(value), coerce(value)];
	              } else if (filterOps.SET_OPS.indexOf(operation) !== -1) {
	                coercedValue = hasArrayValue ? value.map(coerce) : [coerce(value)];
	              }
	              return coercedValue;
	            }
	            function makeRangeSettings(operation) {
	              return function(value) {
	                value = coerceValue(operation, value);
	                var min = Math.min(value[0], value[1]);
	                var max = Math.max(value[0], value[1]);
	                return {
	                  start: min,
	                  end: max,
	                  size: max - min
	                };
	              };
	            }
	            function makeInequalitySettings(operation) {
	              return function(value) {
	                value = coerceValue(operation, value);
	                return {
	                  start: value,
	                  end: Infinity,
	                  size: Infinity
	                };
	              };
	            }
	          }
	        ),
	        /***/
	        67217: (
	          /***/
	          function(module2) {
	            module2.exports = function handleContourDefaults(traceIn, traceOut, coerce, coerce2) {
	              var contourStart = coerce2("contours.start");
	              var contourEnd = coerce2("contours.end");
	              var missingEnd = contourStart === false || contourEnd === false;
	              var contourSize = coerce("contours.size");
	              var autoContour;
	              if (missingEnd) autoContour = traceOut.autocontour = true;
	              else autoContour = coerce("autocontour", false);
	              if (autoContour || !contourSize) coerce("ncontours");
	            };
	          }
	        ),
	        /***/
	        84857: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function(pathinfo, operation) {
	              var i, pi0, pi1;
	              var op0 = function(arr) {
	                return arr.reverse();
	              };
	              var op1 = function(arr) {
	                return arr;
	              };
	              switch (operation) {
	                case "=":
	                case "<":
	                  return pathinfo;
	                case ">":
	                  if (pathinfo.length !== 1) {
	                    Lib.warn("Contour data invalid for the specified inequality operation.");
	                  }
	                  pi0 = pathinfo[0];
	                  for (i = 0; i < pi0.edgepaths.length; i++) {
	                    pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
	                  }
	                  for (i = 0; i < pi0.paths.length; i++) {
	                    pi0.paths[i] = op0(pi0.paths[i]);
	                  }
	                  for (i = 0; i < pi0.starts.length; i++) {
	                    pi0.starts[i] = op0(pi0.starts[i]);
	                  }
	                  return pathinfo;
	                case "][":
	                  var tmp = op0;
	                  op0 = op1;
	                  op1 = tmp;
	                case "[]":
	                  if (pathinfo.length !== 2) {
	                    Lib.warn("Contour data invalid for the specified inequality range operation.");
	                  }
	                  pi0 = copyPathinfo(pathinfo[0]);
	                  pi1 = copyPathinfo(pathinfo[1]);
	                  for (i = 0; i < pi0.edgepaths.length; i++) {
	                    pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
	                  }
	                  for (i = 0; i < pi0.paths.length; i++) {
	                    pi0.paths[i] = op0(pi0.paths[i]);
	                  }
	                  for (i = 0; i < pi0.starts.length; i++) {
	                    pi0.starts[i] = op0(pi0.starts[i]);
	                  }
	                  while (pi1.edgepaths.length) {
	                    pi0.edgepaths.push(op1(pi1.edgepaths.shift()));
	                  }
	                  while (pi1.paths.length) {
	                    pi0.paths.push(op1(pi1.paths.shift()));
	                  }
	                  while (pi1.starts.length) {
	                    pi0.starts.push(op1(pi1.starts.shift()));
	                  }
	                  return [pi0];
	              }
	            };
	            function copyPathinfo(pi) {
	              return Lib.extendFlat({}, pi, {
	                edgepaths: Lib.extendDeep([], pi.edgepaths),
	                paths: Lib.extendDeep([], pi.paths),
	                starts: Lib.extendDeep([], pi.starts)
	              });
	            }
	          }
	        ),
	        /***/
	        13031: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleXYZDefaults = __webpack_require__2(67684);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var handleConstraintDefaults = __webpack_require__2(83179);
	            var handleContoursDefaults = __webpack_require__2(67217);
	            var handleStyleDefaults = __webpack_require__2(8724);
	            var handleHeatmapLabelDefaults = __webpack_require__2(58623);
	            var attributes = __webpack_require__2(70600);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              function coerce2(attr) {
	                return Lib.coerce2(traceIn, traceOut, attributes, attr);
	              }
	              var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hoverongaps");
	              coerce("hovertemplate");
	              var isConstraint = coerce("contours.type") === "constraint";
	              coerce("connectgaps", Lib.isArray1D(traceOut.z));
	              if (isConstraint) {
	                handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor);
	              } else {
	                handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
	                handleStyleDefaults(traceIn, traceOut, coerce, layout);
	              }
	              if (traceOut.contours && traceOut.contours.coloring === "heatmap") {
	                handleHeatmapLabelDefaults(coerce, layout);
	              }
	            };
	          }
	        ),
	        /***/
	        87558: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var constraintMapping = __webpack_require__2(64237);
	            var endPlus = __webpack_require__2(53572);
	            module2.exports = function emptyPathinfo(contours, plotinfo, cd0) {
	              var contoursFinal = contours.type === "constraint" ? constraintMapping[contours._operation](contours.value) : contours;
	              var cs = contoursFinal.size;
	              var pathinfo = [];
	              var end = endPlus(contoursFinal);
	              var carpet = cd0.trace._carpetTrace;
	              var basePathinfo = carpet ? {
	                // store axes so we can convert to px
	                xaxis: carpet.aaxis,
	                yaxis: carpet.baxis,
	                // full data arrays to use for interpolation
	                x: cd0.a,
	                y: cd0.b
	              } : {
	                xaxis: plotinfo.xaxis,
	                yaxis: plotinfo.yaxis,
	                x: cd0.x,
	                y: cd0.y
	              };
	              for (var ci = contoursFinal.start; ci < end; ci += cs) {
	                pathinfo.push(Lib.extendFlat({
	                  level: ci,
	                  // all the cells with nontrivial marching index
	                  crossings: {},
	                  // starting points on the edges of the lattice for each contour
	                  starts: [],
	                  // all unclosed paths (may have less items than starts,
	                  // if a path is closed by rounding)
	                  edgepaths: [],
	                  // all closed paths
	                  paths: [],
	                  z: cd0.z,
	                  smoothing: cd0.trace.line.smoothing
	                }, basePathinfo));
	                if (pathinfo.length > 1e3) {
	                  Lib.warn("Too many contours, clipping at 1000", contours);
	                  break;
	                }
	              }
	              return pathinfo;
	            };
	          }
	        ),
	        /***/
	        53572: (
	          /***/
	          function(module2) {
	            module2.exports = function endPlus(contours) {
	              return contours.end + contours.size / 1e6;
	            };
	          }
	        ),
	        /***/
	        81696: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(36914);
	            module2.exports = function findAllPaths(pathinfo, xtol, ytol) {
	              var cnt, startLoc, i, pi, j;
	              xtol = xtol || 0.01;
	              ytol = ytol || 0.01;
	              for (i = 0; i < pathinfo.length; i++) {
	                pi = pathinfo[i];
	                for (j = 0; j < pi.starts.length; j++) {
	                  startLoc = pi.starts[j];
	                  makePath(pi, startLoc, "edge", xtol, ytol);
	                }
	                cnt = 0;
	                while (Object.keys(pi.crossings).length && cnt < 1e4) {
	                  cnt++;
	                  startLoc = Object.keys(pi.crossings)[0].split(",").map(Number);
	                  makePath(pi, startLoc, undefined, xtol, ytol);
	                }
	                if (cnt === 1e4) Lib.log("Infinite loop in contour?");
	              }
	            };
	            function equalPts(pt1, pt2, xtol, ytol) {
	              return Math.abs(pt1[0] - pt2[0]) < xtol && Math.abs(pt1[1] - pt2[1]) < ytol;
	            }
	            function ptDist(pt1, pt2) {
	              var dx = pt1[2] - pt2[2];
	              var dy = pt1[3] - pt2[3];
	              return Math.sqrt(dx * dx + dy * dy);
	            }
	            function makePath(pi, loc, edgeflag, xtol, ytol) {
	              var locStr = loc.join(",");
	              var mi = pi.crossings[locStr];
	              var marchStep = getStartStep(mi, edgeflag, loc);
	              var pts = [getInterpPx(pi, loc, [-marchStep[0], -marchStep[1]])];
	              var m = pi.z.length;
	              var n = pi.z[0].length;
	              var startLoc = loc.slice();
	              var startStep = marchStep.slice();
	              var cnt;
	              for (cnt = 0; cnt < 1e4; cnt++) {
	                if (mi > 20) {
	                  mi = constants.CHOOSESADDLE[mi][(marchStep[0] || marchStep[1]) < 0 ? 0 : 1];
	                  pi.crossings[locStr] = constants.SADDLEREMAINDER[mi];
	                } else {
	                  delete pi.crossings[locStr];
	                }
	                marchStep = constants.NEWDELTA[mi];
	                if (!marchStep) {
	                  Lib.log("Found bad marching index:", mi, loc, pi.level);
	                  break;
	                }
	                pts.push(getInterpPx(pi, loc, marchStep));
	                loc[0] += marchStep[0];
	                loc[1] += marchStep[1];
	                locStr = loc.join(",");
	                if (equalPts(pts[pts.length - 1], pts[pts.length - 2], xtol, ytol)) pts.pop();
	                var atEdge = marchStep[0] && (loc[0] < 0 || loc[0] > n - 2) || marchStep[1] && (loc[1] < 0 || loc[1] > m - 2);
	                var closedLoop = loc[0] === startLoc[0] && loc[1] === startLoc[1] && marchStep[0] === startStep[0] && marchStep[1] === startStep[1];
	                if (closedLoop || edgeflag && atEdge) break;
	                mi = pi.crossings[locStr];
	              }
	              if (cnt === 1e4) {
	                Lib.log("Infinite loop in contour?");
	              }
	              var closedpath = equalPts(pts[0], pts[pts.length - 1], xtol, ytol);
	              var totaldist = 0;
	              var distThresholdFactor = 0.2 * pi.smoothing;
	              var alldists = [];
	              var cropstart = 0;
	              var distgroup, cnt2, cnt3, newpt, ptcnt, ptavg, thisdist, i, j, edgepathi, edgepathj;
	              for (cnt = 1; cnt < pts.length; cnt++) {
	                thisdist = ptDist(pts[cnt], pts[cnt - 1]);
	                totaldist += thisdist;
	                alldists.push(thisdist);
	              }
	              var distThreshold = totaldist / alldists.length * distThresholdFactor;
	              function getpt(i2) {
	                return pts[i2 % pts.length];
	              }
	              for (cnt = pts.length - 2; cnt >= cropstart; cnt--) {
	                distgroup = alldists[cnt];
	                if (distgroup < distThreshold) {
	                  cnt3 = 0;
	                  for (cnt2 = cnt - 1; cnt2 >= cropstart; cnt2--) {
	                    if (distgroup + alldists[cnt2] < distThreshold) {
	                      distgroup += alldists[cnt2];
	                    } else break;
	                  }
	                  if (closedpath && cnt === pts.length - 2) {
	                    for (cnt3 = 0; cnt3 < cnt2; cnt3++) {
	                      if (distgroup + alldists[cnt3] < distThreshold) {
	                        distgroup += alldists[cnt3];
	                      } else break;
	                    }
	                  }
	                  ptcnt = cnt - cnt2 + cnt3 + 1;
	                  ptavg = Math.floor((cnt + cnt2 + cnt3 + 2) / 2);
	                  if (!closedpath && cnt === pts.length - 2) newpt = pts[pts.length - 1];
	                  else if (!closedpath && cnt2 === -1) newpt = pts[0];
	                  else if (ptcnt % 2) newpt = getpt(ptavg);
	                  else {
	                    newpt = [(getpt(ptavg)[0] + getpt(ptavg + 1)[0]) / 2, (getpt(ptavg)[1] + getpt(ptavg + 1)[1]) / 2];
	                  }
	                  pts.splice(cnt2 + 1, cnt - cnt2 + 1, newpt);
	                  cnt = cnt2 + 1;
	                  if (cnt3) cropstart = cnt3;
	                  if (closedpath) {
	                    if (cnt === pts.length - 2) pts[cnt3] = pts[pts.length - 1];
	                    else if (cnt === 0) pts[pts.length - 1] = pts[0];
	                  }
	                }
	              }
	              pts.splice(0, cropstart);
	              for (cnt = 0; cnt < pts.length; cnt++) pts[cnt].length = 2;
	              if (pts.length < 2) return;
	              else if (closedpath) {
	                pts.pop();
	                pi.paths.push(pts);
	              } else {
	                if (!edgeflag) {
	                  Lib.log("Unclosed interior contour?", pi.level, startLoc.join(","), pts.join("L"));
	                }
	                var merged = false;
	                for (i = 0; i < pi.edgepaths.length; i++) {
	                  edgepathi = pi.edgepaths[i];
	                  if (!merged && equalPts(edgepathi[0], pts[pts.length - 1], xtol, ytol)) {
	                    pts.pop();
	                    merged = true;
	                    var doublemerged = false;
	                    for (j = 0; j < pi.edgepaths.length; j++) {
	                      edgepathj = pi.edgepaths[j];
	                      if (equalPts(edgepathj[edgepathj.length - 1], pts[0], xtol, ytol)) {
	                        doublemerged = true;
	                        pts.shift();
	                        pi.edgepaths.splice(i, 1);
	                        if (j === i) {
	                          pi.paths.push(pts.concat(edgepathj));
	                        } else {
	                          if (j > i) j--;
	                          pi.edgepaths[j] = edgepathj.concat(pts, edgepathi);
	                        }
	                        break;
	                      }
	                    }
	                    if (!doublemerged) {
	                      pi.edgepaths[i] = pts.concat(edgepathi);
	                    }
	                  }
	                }
	                for (i = 0; i < pi.edgepaths.length; i++) {
	                  if (merged) break;
	                  edgepathi = pi.edgepaths[i];
	                  if (equalPts(edgepathi[edgepathi.length - 1], pts[0], xtol, ytol)) {
	                    pts.shift();
	                    pi.edgepaths[i] = edgepathi.concat(pts);
	                    merged = true;
	                  }
	                }
	                if (!merged) pi.edgepaths.push(pts);
	              }
	            }
	            function getStartStep(mi, edgeflag, loc) {
	              var dx = 0;
	              var dy = 0;
	              if (mi > 20 && edgeflag) {
	                if (mi === 208 || mi === 1114) {
	                  dx = loc[0] === 0 ? 1 : -1;
	                } else {
	                  dy = loc[1] === 0 ? 1 : -1;
	                }
	              } else if (constants.BOTTOMSTART.indexOf(mi) !== -1) dy = 1;
	              else if (constants.LEFTSTART.indexOf(mi) !== -1) dx = 1;
	              else if (constants.TOPSTART.indexOf(mi) !== -1) dy = -1;
	              else dx = -1;
	              return [dx, dy];
	            }
	            function getInterpPx(pi, loc, step) {
	              var locx = loc[0] + Math.max(step[0], 0);
	              var locy = loc[1] + Math.max(step[1], 0);
	              var zxy = pi.z[locy][locx];
	              var xa = pi.xaxis;
	              var ya = pi.yaxis;
	              if (step[1]) {
	                var dx = (pi.level - zxy) / (pi.z[locy][locx + 1] - zxy);
	                var dxl = (dx !== 1 ? (1 - dx) * xa.c2l(pi.x[locx]) : 0) + (dx !== 0 ? dx * xa.c2l(pi.x[locx + 1]) : 0);
	                return [xa.c2p(xa.l2c(dxl), true), ya.c2p(pi.y[locy], true), locx + dx, locy];
	              } else {
	                var dy = (pi.level - zxy) / (pi.z[locy + 1][locx] - zxy);
	                var dyl = (dy !== 1 ? (1 - dy) * ya.c2l(pi.y[locy]) : 0) + (dy !== 0 ? dy * ya.c2l(pi.y[locy + 1]) : 0);
	                return [xa.c2p(pi.x[locx], true), ya.c2p(ya.l2c(dyl), true), locx, locy + dy];
	              }
	            }
	          }
	        ),
	        /***/
	        52421: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var heatmapHoverPoints = __webpack_require__2(46248);
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              if (!opts) opts = {};
	              opts.isContour = true;
	              var hoverData = heatmapHoverPoints(pointData, xval, yval, hovermode, opts);
	              if (hoverData) {
	                hoverData.forEach(function(hoverPt) {
	                  var trace = hoverPt.trace;
	                  if (trace.contours.type === "constraint") {
	                    if (trace.fillcolor && Color.opacity(trace.fillcolor)) {
	                      hoverPt.color = Color.addOpacity(trace.fillcolor, 1);
	                    } else if (trace.contours.showlines && Color.opacity(trace.line.color)) {
	                      hoverPt.color = Color.addOpacity(trace.line.color, 1);
	                    }
	                  }
	                });
	              }
	              return hoverData;
	            };
	          }
	        ),
	        /***/
	        99442: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(70600),
	              supplyDefaults: __webpack_require__2(13031),
	              calc: __webpack_require__2(27529),
	              plot: __webpack_require__2(29854).plot,
	              style: __webpack_require__2(84426),
	              colorbar: __webpack_require__2(90654),
	              hoverPoints: __webpack_require__2(52421),
	              moduleType: "trace",
	              name: "contour",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "2dMap", "contour", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        14523: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function handleLabelDefaults(coerce, layout, lineColor, opts) {
	              if (!opts) opts = {};
	              var showLabels = coerce("contours.showlabels");
	              if (showLabels) {
	                var globalFont = layout.font;
	                Lib.coerceFont(coerce, "contours.labelfont", {
	                  family: globalFont.family,
	                  size: globalFont.size,
	                  color: lineColor
	                });
	                coerce("contours.labelformat");
	              }
	              if (opts.hasHover !== false) coerce("zhoverformat");
	            };
	          }
	        ),
	        /***/
	        86068: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Colorscale = __webpack_require__2(21081);
	            var endPlus = __webpack_require__2(53572);
	            module2.exports = function makeColorMap(trace) {
	              var contours = trace.contours;
	              var start = contours.start;
	              var end = endPlus(contours);
	              var cs = contours.size || 1;
	              var nc = Math.floor((end - start) / cs) + 1;
	              var extra = contours.coloring === "lines" ? 0 : 1;
	              var cOpts = Colorscale.extractOpts(trace);
	              if (!isFinite(cs)) {
	                cs = 1;
	                nc = 1;
	              }
	              var scl = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;
	              var len = scl.length;
	              var domain = new Array(len);
	              var range2 = new Array(len);
	              var si, i;
	              var zmin0 = cOpts.min;
	              var zmax0 = cOpts.max;
	              if (contours.coloring === "heatmap") {
	                for (i = 0; i < len; i++) {
	                  si = scl[i];
	                  domain[i] = si[0] * (zmax0 - zmin0) + zmin0;
	                  range2[i] = si[1];
	                }
	                var zRange = d3.extent([zmin0, zmax0, contours.start, contours.start + cs * (nc - 1)]);
	                var zmin = zRange[zmin0 < zmax0 ? 0 : 1];
	                var zmax = zRange[zmin0 < zmax0 ? 1 : 0];
	                if (zmin !== zmin0) {
	                  domain.splice(0, 0, zmin);
	                  range2.splice(0, 0, range2[0]);
	                }
	                if (zmax !== zmax0) {
	                  domain.push(zmax);
	                  range2.push(range2[range2.length - 1]);
	                }
	              } else {
	                var zRangeInput = trace._input && typeof trace._input.zmin === "number" && typeof trace._input.zmax === "number";
	                if (zRangeInput && (start <= zmin0 || end >= zmax0)) {
	                  if (start <= zmin0) start = zmin0;
	                  if (end >= zmax0) end = zmax0;
	                  nc = Math.floor((end - start) / cs) + 1;
	                  extra = 0;
	                }
	                for (i = 0; i < len; i++) {
	                  si = scl[i];
	                  domain[i] = (si[0] * (nc + extra - 1) - extra / 2) * cs + start;
	                  range2[i] = si[1];
	                }
	                if (zRangeInput || trace.autocontour) {
	                  if (domain[0] > zmin0) {
	                    domain.unshift(zmin0);
	                    range2.unshift(range2[0]);
	                  }
	                  if (domain[domain.length - 1] < zmax0) {
	                    domain.push(zmax0);
	                    range2.push(range2[range2.length - 1]);
	                  }
	                }
	              }
	              return Colorscale.makeColorScaleFunc({
	                domain,
	                range: range2
	              }, {
	                noNumericCheck: true
	              });
	            };
	          }
	        ),
	        /***/
	        87678: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var constants = __webpack_require__2(36914);
	            module2.exports = function makeCrossings(pathinfo) {
	              var z = pathinfo[0].z;
	              var m = z.length;
	              var n = z[0].length;
	              var twoWide = m === 2 || n === 2;
	              var xi;
	              var yi;
	              var startIndices;
	              var ystartIndices;
	              var label;
	              var corners;
	              var mi;
	              var pi;
	              var i;
	              for (yi = 0; yi < m - 1; yi++) {
	                ystartIndices = [];
	                if (yi === 0) ystartIndices = ystartIndices.concat(constants.BOTTOMSTART);
	                if (yi === m - 2) ystartIndices = ystartIndices.concat(constants.TOPSTART);
	                for (xi = 0; xi < n - 1; xi++) {
	                  startIndices = ystartIndices.slice();
	                  if (xi === 0) startIndices = startIndices.concat(constants.LEFTSTART);
	                  if (xi === n - 2) startIndices = startIndices.concat(constants.RIGHTSTART);
	                  label = xi + "," + yi;
	                  corners = [[z[yi][xi], z[yi][xi + 1]], [z[yi + 1][xi], z[yi + 1][xi + 1]]];
	                  for (i = 0; i < pathinfo.length; i++) {
	                    pi = pathinfo[i];
	                    mi = getMarchingIndex(pi.level, corners);
	                    if (!mi) continue;
	                    pi.crossings[label] = mi;
	                    if (startIndices.indexOf(mi) !== -1) {
	                      pi.starts.push([xi, yi]);
	                      if (twoWide && startIndices.indexOf(mi, startIndices.indexOf(mi) + 1) !== -1) {
	                        pi.starts.push([xi, yi]);
	                      }
	                    }
	                  }
	                }
	              }
	            };
	            function getMarchingIndex(val, corners) {
	              var mi = (corners[0][0] > val ? 0 : 1) + (corners[0][1] > val ? 0 : 2) + (corners[1][1] > val ? 0 : 4) + (corners[1][0] > val ? 0 : 8);
	              if (mi === 5 || mi === 10) {
	                var avg = (corners[0][0] + corners[0][1] + corners[1][0] + corners[1][1]) / 4;
	                if (val > avg) return mi === 5 ? 713 : 1114;
	                return mi === 5 ? 104 : 208;
	              }
	              return mi === 15 ? 0 : mi;
	            }
	          }
	        ),
	        /***/
	        29854: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var Colorscale = __webpack_require__2(21081);
	            var svgTextUtils = __webpack_require__2(63893);
	            var Axes = __webpack_require__2(89298);
	            var setConvert = __webpack_require__2(21994);
	            var heatmapPlot = __webpack_require__2(50347);
	            var makeCrossings = __webpack_require__2(87678);
	            var findAllPaths = __webpack_require__2(81696);
	            var emptyPathinfo = __webpack_require__2(87558);
	            var convertToConstraints = __webpack_require__2(84857);
	            var closeBoundaries = __webpack_require__2(20083);
	            var constants = __webpack_require__2(36914);
	            var costConstants = constants.LABELOPTIMIZER;
	            exports2.plot = function plot(gd, plotinfo, cdcontours, contourLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(contourLayer, cdcontours, "contour").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var x = cd0.x;
	                var y = cd0.y;
	                var contours = trace.contours;
	                var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
	                var heatmapColoringLayer = Lib.ensureSingle(plotGroup, "g", "heatmapcoloring");
	                var cdheatmaps = [];
	                if (contours.coloring === "heatmap") {
	                  cdheatmaps = [cd];
	                }
	                heatmapPlot(gd, plotinfo, cdheatmaps, heatmapColoringLayer);
	                makeCrossings(pathinfo);
	                findAllPaths(pathinfo);
	                var leftedge = xa.c2p(x[0], true);
	                var rightedge = xa.c2p(x[x.length - 1], true);
	                var bottomedge = ya.c2p(y[0], true);
	                var topedge = ya.c2p(y[y.length - 1], true);
	                var perimeter = [[leftedge, topedge], [rightedge, topedge], [rightedge, bottomedge], [leftedge, bottomedge]];
	                var fillPathinfo = pathinfo;
	                if (contours.type === "constraint") {
	                  fillPathinfo = convertToConstraints(pathinfo, contours._operation);
	                }
	                makeBackground(plotGroup, perimeter, contours);
	                makeFills(plotGroup, fillPathinfo, perimeter, contours);
	                makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours);
	                clipGaps(plotGroup, plotinfo, gd, cd0, perimeter);
	              });
	            };
	            function makeBackground(plotgroup, perimeter, contours) {
	              var bggroup = Lib.ensureSingle(plotgroup, "g", "contourbg");
	              var bgfill = bggroup.selectAll("path").data(contours.coloring === "fill" ? [0] : []);
	              bgfill.enter().append("path");
	              bgfill.exit().remove();
	              bgfill.attr("d", "M" + perimeter.join("L") + "Z").style("stroke", "none");
	            }
	            function makeFills(plotgroup, pathinfo, perimeter, contours) {
	              var hasFills = contours.coloring === "fill" || contours.type === "constraint" && contours._operation !== "=";
	              var boundaryPath = "M" + perimeter.join("L") + "Z";
	              if (hasFills) {
	                closeBoundaries(pathinfo, contours);
	              }
	              var fillgroup = Lib.ensureSingle(plotgroup, "g", "contourfill");
	              var fillitems = fillgroup.selectAll("path").data(hasFills ? pathinfo : []);
	              fillitems.enter().append("path");
	              fillitems.exit().remove();
	              fillitems.each(function(pi) {
	                var fullpath = (pi.prefixBoundary ? boundaryPath : "") + joinAllPaths(pi, perimeter);
	                if (!fullpath) {
	                  d3.select(this).remove();
	                } else {
	                  d3.select(this).attr("d", fullpath).style("stroke", "none");
	                }
	              });
	            }
	            function joinAllPaths(pi, perimeter) {
	              var fullpath = "";
	              var i = 0;
	              var startsleft = pi.edgepaths.map(function(v, i2) {
	                return i2;
	              });
	              var newloop = true;
	              var endpt;
	              var newendpt;
	              var cnt;
	              var nexti;
	              var possiblei;
	              var addpath;
	              function istop(pt) {
	                return Math.abs(pt[1] - perimeter[0][1]) < 0.01;
	              }
	              function isbottom(pt) {
	                return Math.abs(pt[1] - perimeter[2][1]) < 0.01;
	              }
	              function isleft(pt) {
	                return Math.abs(pt[0] - perimeter[0][0]) < 0.01;
	              }
	              function isright(pt) {
	                return Math.abs(pt[0] - perimeter[2][0]) < 0.01;
	              }
	              while (startsleft.length) {
	                addpath = Drawing.smoothopen(pi.edgepaths[i], pi.smoothing);
	                fullpath += newloop ? addpath : addpath.replace(/^M/, "L");
	                startsleft.splice(startsleft.indexOf(i), 1);
	                endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
	                nexti = -1;
	                for (cnt = 0; cnt < 4; cnt++) {
	                  if (!endpt) {
	                    Lib.log("Missing end?", i, pi);
	                    break;
	                  }
	                  if (istop(endpt) && !isright(endpt)) newendpt = perimeter[1];
	                  else if (isleft(endpt)) newendpt = perimeter[0];
	                  else if (isbottom(endpt)) newendpt = perimeter[3];
	                  else if (isright(endpt)) newendpt = perimeter[2];
	                  for (possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
	                    var ptNew = pi.edgepaths[possiblei][0];
	                    if (Math.abs(endpt[0] - newendpt[0]) < 0.01) {
	                      if (Math.abs(endpt[0] - ptNew[0]) < 0.01 && (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                      }
	                    } else if (Math.abs(endpt[1] - newendpt[1]) < 0.01) {
	                      if (Math.abs(endpt[1] - ptNew[1]) < 0.01 && (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                      }
	                    } else {
	                      Lib.log("endpt to newendpt is not vert. or horz.", endpt, newendpt, ptNew);
	                    }
	                  }
	                  endpt = newendpt;
	                  if (nexti >= 0) break;
	                  fullpath += "L" + newendpt;
	                }
	                if (nexti === pi.edgepaths.length) {
	                  Lib.log("unclosed perimeter path");
	                  break;
	                }
	                i = nexti;
	                newloop = startsleft.indexOf(i) === -1;
	                if (newloop) {
	                  i = startsleft[0];
	                  fullpath += "Z";
	                }
	              }
	              for (i = 0; i < pi.paths.length; i++) {
	                fullpath += Drawing.smoothclosed(pi.paths[i], pi.smoothing);
	              }
	              return fullpath;
	            }
	            function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours) {
	              var isStatic = gd._context.staticPlot;
	              var lineContainer = Lib.ensureSingle(plotgroup, "g", "contourlines");
	              var showLines = contours.showlines !== false;
	              var showLabels = contours.showlabels;
	              var clipLinesForLabels = showLines && showLabels;
	              var linegroup = exports2.createLines(lineContainer, showLines || showLabels, pathinfo, isStatic);
	              var lineClip = exports2.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
	              var labelGroup = plotgroup.selectAll("g.contourlabels").data(showLabels ? [0] : []);
	              labelGroup.exit().remove();
	              labelGroup.enter().append("g").classed("contourlabels", true);
	              if (showLabels) {
	                var labelClipPathData = [];
	                var labelData = [];
	                Lib.clearLocationCache();
	                var contourFormat = exports2.labelFormatter(gd, cd0);
	                var dummyText = Drawing.tester.append("text").attr("data-notex", 1).call(Drawing.font, contours.labelfont);
	                var xa = pathinfo[0].xaxis;
	                var ya = pathinfo[0].yaxis;
	                var xLen = xa._length;
	                var yLen = ya._length;
	                var xRng = xa.range;
	                var yRng = ya.range;
	                var xMin = Lib.aggNums(Math.min, null, cd0.x);
	                var xMax = Lib.aggNums(Math.max, null, cd0.x);
	                var yMin = Lib.aggNums(Math.min, null, cd0.y);
	                var yMax = Lib.aggNums(Math.max, null, cd0.y);
	                var x0 = Math.max(xa.c2p(xMin, true), 0);
	                var x1 = Math.min(xa.c2p(xMax, true), xLen);
	                var y0 = Math.max(ya.c2p(yMax, true), 0);
	                var y1 = Math.min(ya.c2p(yMin, true), yLen);
	                var bounds = {};
	                if (xRng[0] < xRng[1]) {
	                  bounds.left = x0;
	                  bounds.right = x1;
	                } else {
	                  bounds.left = x1;
	                  bounds.right = x0;
	                }
	                if (yRng[0] < yRng[1]) {
	                  bounds.top = y0;
	                  bounds.bottom = y1;
	                } else {
	                  bounds.top = y1;
	                  bounds.bottom = y0;
	                }
	                bounds.middle = (bounds.top + bounds.bottom) / 2;
	                bounds.center = (bounds.left + bounds.right) / 2;
	                labelClipPathData.push([[bounds.left, bounds.top], [bounds.right, bounds.top], [bounds.right, bounds.bottom], [bounds.left, bounds.bottom]]);
	                var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);
	                var normLength = constants.LABELDISTANCE * plotDiagonal / Math.max(1, pathinfo.length / constants.LABELINCREASE);
	                linegroup.each(function(d) {
	                  var textOpts = exports2.calcTextOpts(d.level, contourFormat, dummyText, gd);
	                  d3.select(this).selectAll("path").each(function() {
	                    var path = this;
	                    var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
	                    if (!pathBounds) return;
	                    if (pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
	                    var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength), constants.LABELMAX);
	                    for (var i = 0; i < maxLabels; i++) {
	                      var loc = exports2.findBestTextLocation(path, pathBounds, textOpts, labelData, bounds);
	                      if (!loc) break;
	                      exports2.addLabelData(loc, textOpts, labelData, labelClipPathData);
	                    }
	                  });
	                });
	                dummyText.remove();
	                exports2.drawLabels(labelGroup, labelData, gd, lineClip, clipLinesForLabels ? labelClipPathData : null);
	              }
	              if (showLabels && !showLines) linegroup.remove();
	            }
	            exports2.createLines = function(lineContainer, makeLines, pathinfo, isStatic) {
	              var smoothing = pathinfo[0].smoothing;
	              var linegroup = lineContainer.selectAll("g.contourlevel").data(makeLines ? pathinfo : []);
	              linegroup.exit().remove();
	              linegroup.enter().append("g").classed("contourlevel", true);
	              if (makeLines) {
	                var opencontourlines = linegroup.selectAll("path.openline").data(function(d) {
	                  return d.pedgepaths || d.edgepaths;
	                });
	                opencontourlines.exit().remove();
	                opencontourlines.enter().append("path").classed("openline", true);
	                opencontourlines.attr("d", function(d) {
	                  return Drawing.smoothopen(d, smoothing);
	                }).style("stroke-miterlimit", 1).style("vector-effect", isStatic ? "none" : "non-scaling-stroke");
	                var closedcontourlines = linegroup.selectAll("path.closedline").data(function(d) {
	                  return d.ppaths || d.paths;
	                });
	                closedcontourlines.exit().remove();
	                closedcontourlines.enter().append("path").classed("closedline", true);
	                closedcontourlines.attr("d", function(d) {
	                  return Drawing.smoothclosed(d, smoothing);
	                }).style("stroke-miterlimit", 1).style("vector-effect", isStatic ? "none" : "non-scaling-stroke");
	              }
	              return linegroup;
	            };
	            exports2.createLineClip = function(lineContainer, clipLinesForLabels, gd, uid) {
	              var clips = gd._fullLayout._clips;
	              var clipId = clipLinesForLabels ? "clipline" + uid : null;
	              var lineClip = clips.selectAll("#" + clipId).data(clipLinesForLabels ? [0] : []);
	              lineClip.exit().remove();
	              lineClip.enter().append("clipPath").classed("contourlineclip", true).attr("id", clipId);
	              Drawing.setClipUrl(lineContainer, clipId, gd);
	              return lineClip;
	            };
	            exports2.labelFormatter = function(gd, cd0) {
	              var fullLayout = gd._fullLayout;
	              var trace = cd0.trace;
	              var contours = trace.contours;
	              var formatAxis = {
	                type: "linear",
	                _id: "ycontour",
	                showexponent: "all",
	                exponentformat: "B"
	              };
	              if (contours.labelformat) {
	                formatAxis.tickformat = contours.labelformat;
	                setConvert(formatAxis, fullLayout);
	              } else {
	                var cOpts = Colorscale.extractOpts(trace);
	                if (cOpts && cOpts.colorbar && cOpts.colorbar._axis) {
	                  formatAxis = cOpts.colorbar._axis;
	                } else {
	                  if (contours.type === "constraint") {
	                    var value = contours.value;
	                    if (Array.isArray(value)) {
	                      formatAxis.range = [value[0], value[value.length - 1]];
	                    } else formatAxis.range = [value, value];
	                  } else {
	                    formatAxis.range = [contours.start, contours.end];
	                    formatAxis.nticks = (contours.end - contours.start) / contours.size;
	                  }
	                  if (formatAxis.range[0] === formatAxis.range[1]) {
	                    formatAxis.range[1] += formatAxis.range[0] || 1;
	                  }
	                  if (!formatAxis.nticks) formatAxis.nticks = 1e3;
	                  setConvert(formatAxis, fullLayout);
	                  Axes.prepTicks(formatAxis);
	                  formatAxis._tmin = null;
	                  formatAxis._tmax = null;
	                }
	              }
	              return function(v) {
	                return Axes.tickText(formatAxis, v).text;
	              };
	            };
	            exports2.calcTextOpts = function(level, contourFormat, dummyText, gd) {
	              var text = contourFormat(level);
	              dummyText.text(text).call(svgTextUtils.convertToTspans, gd);
	              var el = dummyText.node();
	              var bBox = Drawing.bBox(el, true);
	              return {
	                text,
	                width: bBox.width,
	                height: bBox.height,
	                fontSize: +el.style["font-size"].replace("px", ""),
	                level,
	                dy: (bBox.top + bBox.bottom) / 2
	              };
	            };
	            exports2.findBestTextLocation = function(path, pathBounds, textOpts, labelData, plotBounds) {
	              var textWidth = textOpts.width;
	              var p0, dp, pMax, pMin, loc;
	              if (pathBounds.isClosed) {
	                dp = pathBounds.len / costConstants.INITIALSEARCHPOINTS;
	                p0 = pathBounds.min + dp / 2;
	                pMax = pathBounds.max;
	              } else {
	                dp = (pathBounds.len - textWidth) / (costConstants.INITIALSEARCHPOINTS + 1);
	                p0 = pathBounds.min + dp + textWidth / 2;
	                pMax = pathBounds.max - (dp + textWidth) / 2;
	              }
	              var cost = Infinity;
	              for (var j = 0; j < costConstants.ITERATIONS; j++) {
	                for (var p = p0; p < pMax; p += dp) {
	                  var newLocation = Lib.getTextLocation(path, pathBounds.total, p, textWidth);
	                  var newCost = locationCost(newLocation, textOpts, labelData, plotBounds);
	                  if (newCost < cost) {
	                    cost = newCost;
	                    loc = newLocation;
	                    pMin = p;
	                  }
	                }
	                if (cost > costConstants.MAXCOST * 2) break;
	                if (j) dp /= 2;
	                p0 = pMin - dp / 2;
	                pMax = p0 + dp * 1.5;
	              }
	              if (cost <= costConstants.MAXCOST) return loc;
	            };
	            function locationCost(loc, textOpts, labelData, bounds) {
	              var halfWidth = textOpts.width / 2;
	              var halfHeight = textOpts.height / 2;
	              var x = loc.x;
	              var y = loc.y;
	              var theta = loc.theta;
	              var dx = Math.cos(theta) * halfWidth;
	              var dy = Math.sin(theta) * halfWidth;
	              var normX = (x > bounds.center ? bounds.right - x : x - bounds.left) / (dx + Math.abs(Math.sin(theta) * halfHeight));
	              var normY = (y > bounds.middle ? bounds.bottom - y : y - bounds.top) / (Math.abs(dy) + Math.cos(theta) * halfHeight);
	              if (normX < 1 || normY < 1) return Infinity;
	              var cost = costConstants.EDGECOST * (1 / (normX - 1) + 1 / (normY - 1));
	              cost += costConstants.ANGLECOST * theta * theta;
	              var x1 = x - dx;
	              var y1 = y - dy;
	              var x2 = x + dx;
	              var y2 = y + dy;
	              for (var i = 0; i < labelData.length; i++) {
	                var labeli = labelData[i];
	                var dxd = Math.cos(labeli.theta) * labeli.width / 2;
	                var dyd = Math.sin(labeli.theta) * labeli.width / 2;
	                var dist = Lib.segmentDistance(x1, y1, x2, y2, labeli.x - dxd, labeli.y - dyd, labeli.x + dxd, labeli.y + dyd) * 2 / (textOpts.height + labeli.height);
	                var sameLevel = labeli.level === textOpts.level;
	                var distOffset = sameLevel ? costConstants.SAMELEVELDISTANCE : 1;
	                if (dist <= distOffset) return Infinity;
	                var distFactor = costConstants.NEIGHBORCOST * (sameLevel ? costConstants.SAMELEVELFACTOR : 1);
	                cost += distFactor / (dist - distOffset);
	              }
	              return cost;
	            }
	            exports2.addLabelData = function(loc, textOpts, labelData, labelClipPathData) {
	              var fontSize = textOpts.fontSize;
	              var w = textOpts.width + fontSize / 3;
	              var h = Math.max(0, textOpts.height - fontSize / 3);
	              var x = loc.x;
	              var y = loc.y;
	              var theta = loc.theta;
	              var sin = Math.sin(theta);
	              var cos = Math.cos(theta);
	              var rotateXY = function(dx, dy) {
	                return [x + dx * cos - dy * sin, y + dx * sin + dy * cos];
	              };
	              var bBoxPts = [rotateXY(-w / 2, -h / 2), rotateXY(-w / 2, h / 2), rotateXY(w / 2, h / 2), rotateXY(w / 2, -h / 2)];
	              labelData.push({
	                text: textOpts.text,
	                x,
	                y,
	                dy: textOpts.dy,
	                theta,
	                level: textOpts.level,
	                width: w,
	                height: h
	              });
	              labelClipPathData.push(bBoxPts);
	            };
	            exports2.drawLabels = function(labelGroup, labelData, gd, lineClip, labelClipPathData) {
	              var labels = labelGroup.selectAll("text").data(labelData, function(d) {
	                return d.text + "," + d.x + "," + d.y + "," + d.theta;
	              });
	              labels.exit().remove();
	              labels.enter().append("text").attr({
	                "data-notex": 1,
	                "text-anchor": "middle"
	              }).each(function(d) {
	                var x = d.x + Math.sin(d.theta) * d.dy;
	                var y = d.y - Math.cos(d.theta) * d.dy;
	                d3.select(this).text(d.text).attr({
	                  x,
	                  y,
	                  transform: "rotate(" + 180 * d.theta / Math.PI + " " + x + " " + y + ")"
	                }).call(svgTextUtils.convertToTspans, gd);
	              });
	              if (labelClipPathData) {
	                var clipPath = "";
	                for (var i = 0; i < labelClipPathData.length; i++) {
	                  clipPath += "M" + labelClipPathData[i].join("L") + "Z";
	                }
	                var lineClipPath = Lib.ensureSingle(lineClip, "path", "");
	                lineClipPath.attr("d", clipPath);
	              }
	            };
	            function clipGaps(plotGroup, plotinfo, gd, cd0, perimeter) {
	              var trace = cd0.trace;
	              var clips = gd._fullLayout._clips;
	              var clipId = "clip" + trace.uid;
	              var clipPath = clips.selectAll("#" + clipId).data(trace.connectgaps ? [] : [0]);
	              clipPath.enter().append("clipPath").classed("contourclip", true).attr("id", clipId);
	              clipPath.exit().remove();
	              if (trace.connectgaps === false) {
	                var clipPathInfo = {
	                  // fraction of the way from missing to present point
	                  // to draw the boundary.
	                  // if you make this 1 (or 1-epsilon) then a point in
	                  // a sea of missing data will disappear entirely.
	                  level: 0.9,
	                  crossings: {},
	                  starts: [],
	                  edgepaths: [],
	                  paths: [],
	                  xaxis: plotinfo.xaxis,
	                  yaxis: plotinfo.yaxis,
	                  x: cd0.x,
	                  y: cd0.y,
	                  // 0 = no data, 1 = data
	                  z: makeClipMask(cd0),
	                  smoothing: 0
	                };
	                makeCrossings([clipPathInfo]);
	                findAllPaths([clipPathInfo]);
	                closeBoundaries([clipPathInfo], {
	                  type: "levels"
	                });
	                var path = Lib.ensureSingle(clipPath, "path", "");
	                path.attr("d", (clipPathInfo.prefixBoundary ? "M" + perimeter.join("L") + "Z" : "") + joinAllPaths(clipPathInfo, perimeter));
	              } else clipId = null;
	              Drawing.setClipUrl(plotGroup, clipId, gd);
	            }
	            function makeClipMask(cd0) {
	              var empties = cd0.trace._emptypoints;
	              var z = [];
	              var m = cd0.z.length;
	              var n = cd0.z[0].length;
	              var i;
	              var row = [];
	              var emptyPoint;
	              for (i = 0; i < n; i++) row.push(1);
	              for (i = 0; i < m; i++) z.push(row.slice());
	              for (i = 0; i < empties.length; i++) {
	                emptyPoint = empties[i];
	                z[emptyPoint[0]][emptyPoint[1]] = 0;
	              }
	              cd0.zmask = z;
	              return z;
	            }
	          }
	        ),
	        /***/
	        18670: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function setContours(trace, vals) {
	              var contours = trace.contours;
	              if (trace.autocontour) {
	                var zmin = trace.zmin;
	                var zmax = trace.zmax;
	                if (trace.zauto || zmin === undefined) {
	                  zmin = Lib.aggNums(Math.min, null, vals);
	                }
	                if (trace.zauto || zmax === undefined) {
	                  zmax = Lib.aggNums(Math.max, null, vals);
	                }
	                var dummyAx = autoContours(zmin, zmax, trace.ncontours);
	                contours.size = dummyAx.dtick;
	                contours.start = Axes.tickFirst(dummyAx);
	                dummyAx.range.reverse();
	                contours.end = Axes.tickFirst(dummyAx);
	                if (contours.start === zmin) contours.start += contours.size;
	                if (contours.end === zmax) contours.end -= contours.size;
	                if (contours.start > contours.end) {
	                  contours.start = contours.end = (contours.start + contours.end) / 2;
	                }
	                if (!trace._input.contours) trace._input.contours = {};
	                Lib.extendFlat(trace._input.contours, {
	                  start: contours.start,
	                  end: contours.end,
	                  size: contours.size
	                });
	                trace._input.autocontour = true;
	              } else if (contours.type !== "constraint") {
	                var start = contours.start;
	                var end = contours.end;
	                var inputContours = trace._input.contours;
	                if (start > end) {
	                  contours.start = inputContours.start = end;
	                  end = contours.end = inputContours.end = start;
	                  start = contours.start;
	                }
	                if (!(contours.size > 0)) {
	                  var sizeOut;
	                  if (start === end) sizeOut = 1;
	                  else sizeOut = autoContours(start, end, trace.ncontours).dtick;
	                  inputContours.size = contours.size = sizeOut;
	                }
	              }
	            };
	            function autoContours(start, end, ncontours) {
	              var dummyAx = {
	                type: "linear",
	                range: [start, end]
	              };
	              Axes.autoTicks(dummyAx, (end - start) / (ncontours || 15));
	              return dummyAx;
	            }
	          }
	        ),
	        /***/
	        84426: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var heatmapStyle = __webpack_require__2(70035);
	            var makeColorMap = __webpack_require__2(86068);
	            module2.exports = function style(gd) {
	              var contours = d3.select(gd).selectAll("g.contour");
	              contours.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              contours.each(function(d) {
	                var c = d3.select(this);
	                var trace = d[0].trace;
	                var contours2 = trace.contours;
	                var line = trace.line;
	                var cs = contours2.size || 1;
	                var start = contours2.start;
	                var isConstraintType = contours2.type === "constraint";
	                var colorLines = !isConstraintType && contours2.coloring === "lines";
	                var colorFills = !isConstraintType && contours2.coloring === "fill";
	                var colorMap = colorLines || colorFills ? makeColorMap(trace) : null;
	                c.selectAll("g.contourlevel").each(function(d2) {
	                  d3.select(this).selectAll("path").call(Drawing.lineGroupStyle, line.width, colorLines ? colorMap(d2.level) : line.color, line.dash);
	                });
	                var labelFont = contours2.labelfont;
	                c.selectAll("g.contourlabels text").each(function(d2) {
	                  Drawing.font(d3.select(this), {
	                    family: labelFont.family,
	                    size: labelFont.size,
	                    color: labelFont.color || (colorLines ? colorMap(d2.level) : line.color)
	                  });
	                });
	                if (isConstraintType) {
	                  c.selectAll("g.contourfill path").style("fill", trace.fillcolor);
	                } else if (colorFills) {
	                  var firstFill;
	                  c.selectAll("g.contourfill path").style("fill", function(d2) {
	                    if (firstFill === undefined) firstFill = d2.level;
	                    return colorMap(d2.level + 0.5 * cs);
	                  });
	                  if (firstFill === undefined) firstFill = start;
	                  c.selectAll("g.contourbg path").style("fill", colorMap(firstFill - 0.5 * cs));
	                }
	              });
	              heatmapStyle(gd);
	            };
	          }
	        ),
	        /***/
	        8724: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var handleLabelDefaults = __webpack_require__2(14523);
	            module2.exports = function handleStyleDefaults(traceIn, traceOut, coerce, layout, opts) {
	              var coloring = coerce("contours.coloring");
	              var showLines;
	              var lineColor = "";
	              if (coloring === "fill") showLines = coerce("contours.showlines");
	              if (showLines !== false) {
	                if (coloring !== "lines") lineColor = coerce("line.color", "#000");
	                coerce("line.width", 0.5);
	                coerce("line.dash");
	              }
	              if (coloring !== "none") {
	                if (traceIn.showlegend !== true) traceOut.showlegend = false;
	                traceOut._dfltShowLegend = false;
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "",
	                  cLetter: "z"
	                });
	              }
	              coerce("line.smoothing");
	              handleLabelDefaults(coerce, layout, lineColor, opts);
	            };
	          }
	        ),
	        /***/
	        88085: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var heatmapAttrs = __webpack_require__2(21606);
	            var contourAttrs = __webpack_require__2(70600);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var contourContourAttrs = contourAttrs.contours;
	            module2.exports = extendFlat({
	              carpet: {
	                valType: "string",
	                editType: "calc"
	              },
	              z: heatmapAttrs.z,
	              a: heatmapAttrs.x,
	              a0: heatmapAttrs.x0,
	              da: heatmapAttrs.dx,
	              b: heatmapAttrs.y,
	              b0: heatmapAttrs.y0,
	              db: heatmapAttrs.dy,
	              text: heatmapAttrs.text,
	              hovertext: heatmapAttrs.hovertext,
	              transpose: heatmapAttrs.transpose,
	              atype: heatmapAttrs.xtype,
	              btype: heatmapAttrs.ytype,
	              fillcolor: contourAttrs.fillcolor,
	              autocontour: contourAttrs.autocontour,
	              ncontours: contourAttrs.ncontours,
	              contours: {
	                type: contourContourAttrs.type,
	                start: contourContourAttrs.start,
	                end: contourContourAttrs.end,
	                size: contourContourAttrs.size,
	                coloring: {
	                  // from contourAttrs.contours.coloring but no 'heatmap' option
	                  valType: "enumerated",
	                  values: ["fill", "lines", "none"],
	                  dflt: "fill",
	                  editType: "calc"
	                },
	                showlines: contourContourAttrs.showlines,
	                showlabels: contourContourAttrs.showlabels,
	                labelfont: contourContourAttrs.labelfont,
	                labelformat: contourContourAttrs.labelformat,
	                operation: contourContourAttrs.operation,
	                value: contourContourAttrs.value,
	                editType: "calc",
	                impliedEdits: {
	                  autocontour: false
	                }
	              },
	              line: {
	                color: contourAttrs.line.color,
	                width: contourAttrs.line.width,
	                dash: contourAttrs.line.dash,
	                smoothing: contourAttrs.line.smoothing,
	                editType: "plot"
	              },
	              transforms: undefined
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              autoColorDflt: false
	            }));
	          }
	        ),
	        /***/
	        59885: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorscaleCalc = __webpack_require__2(78803);
	            var Lib = __webpack_require__2(71828);
	            var convertColumnData = __webpack_require__2(68296);
	            var clean2dArray = __webpack_require__2(4742);
	            var interp2d = __webpack_require__2(824);
	            var findEmpties = __webpack_require__2(43907);
	            var makeBoundArray = __webpack_require__2(70769);
	            var supplyDefaults = __webpack_require__2(75005);
	            var lookupCarpet = __webpack_require__2(22882);
	            var setContours = __webpack_require__2(18670);
	            module2.exports = function calc(gd, trace) {
	              var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
	              if (!carpet || !carpet.visible || carpet.visible === "legendonly") return;
	              if (!trace.a || !trace.b) {
	                var carpetdata = gd.data[carpet.index];
	                var tracedata = gd.data[trace.index];
	                if (!tracedata.a) tracedata.a = carpetdata.a;
	                if (!tracedata.b) tracedata.b = carpetdata.b;
	                supplyDefaults(tracedata, trace, trace._defaultColor, gd._fullLayout);
	              }
	              var cd = heatmappishCalc(gd, trace);
	              setContours(trace, trace._z);
	              return cd;
	            };
	            function heatmappishCalc(gd, trace) {
	              var carpet = trace._carpetTrace;
	              var aax = carpet.aaxis;
	              var bax = carpet.baxis;
	              var a, a0, da, b, b0, db, z;
	              aax._minDtick = 0;
	              bax._minDtick = 0;
	              if (Lib.isArray1D(trace.z)) convertColumnData(trace, aax, bax, "a", "b", ["z"]);
	              a = trace._a = trace._a || trace.a;
	              b = trace._b = trace._b || trace.b;
	              a = a ? aax.makeCalcdata(trace, "_a") : [];
	              b = b ? bax.makeCalcdata(trace, "_b") : [];
	              a0 = trace.a0 || 0;
	              da = trace.da || 1;
	              b0 = trace.b0 || 0;
	              db = trace.db || 1;
	              z = trace._z = clean2dArray(trace._z || trace.z, trace.transpose);
	              trace._emptypoints = findEmpties(z);
	              interp2d(z, trace._emptypoints);
	              var xlen = Lib.maxRowLength(z);
	              var xIn = trace.xtype === "scaled" ? "" : a;
	              var xArray = makeBoundArray(trace, xIn, a0, da, xlen, aax);
	              var yIn = trace.ytype === "scaled" ? "" : b;
	              var yArray = makeBoundArray(trace, yIn, b0, db, z.length, bax);
	              var cd0 = {
	                a: xArray,
	                b: yArray,
	                z
	              };
	              if (trace.contours.type === "levels" && trace.contours.coloring !== "none") {
	                colorscaleCalc(gd, trace, {
	                  vals: z,
	                  containerStr: "",
	                  cLetter: "z"
	                });
	              }
	              return [cd0];
	            }
	          }
	        ),
	        /***/
	        75005: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleXYZDefaults = __webpack_require__2(67684);
	            var attributes = __webpack_require__2(88085);
	            var handleConstraintDefaults = __webpack_require__2(83179);
	            var handleContoursDefaults = __webpack_require__2(67217);
	            var handleStyleDefaults = __webpack_require__2(8724);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              function coerce2(attr) {
	                return Lib.coerce2(traceIn, traceOut, attributes, attr);
	              }
	              coerce("carpet");
	              if (traceIn.a && traceIn.b) {
	                var len = handleXYZDefaults(traceIn, traceOut, coerce, layout, "a", "b");
	                if (!len) {
	                  traceOut.visible = false;
	                  return;
	                }
	                coerce("text");
	                var isConstraint = coerce("contours.type") === "constraint";
	                if (isConstraint) {
	                  handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, {
	                    hasHover: false
	                  });
	                } else {
	                  handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
	                  handleStyleDefaults(traceIn, traceOut, coerce, layout, {
	                    hasHover: false
	                  });
	                }
	              } else {
	                traceOut._defaultColor = defaultColor;
	                traceOut._length = null;
	              }
	            };
	          }
	        ),
	        /***/
	        93740: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(88085),
	              supplyDefaults: __webpack_require__2(75005),
	              colorbar: __webpack_require__2(90654),
	              calc: __webpack_require__2(59885),
	              plot: __webpack_require__2(51048),
	              style: __webpack_require__2(84426),
	              moduleType: "trace",
	              name: "contourcarpet",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "carpet", "contour", "symbols", "showLegend", "hasLines", "carpetDependent", "noHover", "noSortingByValue"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        51048: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var map1dArray = __webpack_require__2(27669);
	            var makepath = __webpack_require__2(67961);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var makeCrossings = __webpack_require__2(87678);
	            var findAllPaths = __webpack_require__2(81696);
	            var contourPlot = __webpack_require__2(29854);
	            var constants = __webpack_require__2(36914);
	            var convertToConstraints = __webpack_require__2(84857);
	            var emptyPathinfo = __webpack_require__2(87558);
	            var closeBoundaries = __webpack_require__2(20083);
	            var lookupCarpet = __webpack_require__2(22882);
	            var axisAlignedLine = __webpack_require__2(4536);
	            module2.exports = function plot(gd, plotinfo, cdcontours, contourcarpetLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(contourcarpetLayer, cdcontours, "contour").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
	                var carpetcd = gd.calcdata[carpet.index][0];
	                if (!carpet.visible || carpet.visible === "legendonly") return;
	                var a = cd0.a;
	                var b = cd0.b;
	                var contours = trace.contours;
	                var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
	                var isConstraint = contours.type === "constraint";
	                var operation = contours._operation;
	                var coloring = isConstraint ? operation === "=" ? "lines" : "fill" : contours.coloring;
	                function ab2p(ab) {
	                  var pt = carpet.ab2xy(ab[0], ab[1], true);
	                  return [xa.c2p(pt[0]), ya.c2p(pt[1])];
	                }
	                var perimeter = [[a[0], b[b.length - 1]], [a[a.length - 1], b[b.length - 1]], [a[a.length - 1], b[0]], [a[0], b[0]]];
	                makeCrossings(pathinfo);
	                var atol = (a[a.length - 1] - a[0]) * 1e-8;
	                var btol = (b[b.length - 1] - b[0]) * 1e-8;
	                findAllPaths(pathinfo, atol, btol);
	                var fillPathinfo = pathinfo;
	                if (contours.type === "constraint") {
	                  fillPathinfo = convertToConstraints(pathinfo, operation);
	                }
	                mapPathinfo(pathinfo, ab2p);
	                var seg, xp, yp, i;
	                var segs = [];
	                for (i = carpetcd.clipsegments.length - 1; i >= 0; i--) {
	                  seg = carpetcd.clipsegments[i];
	                  xp = map1dArray([], seg.x, xa.c2p);
	                  yp = map1dArray([], seg.y, ya.c2p);
	                  xp.reverse();
	                  yp.reverse();
	                  segs.push(makepath(xp, yp, seg.bicubic));
	                }
	                var boundaryPath = "M" + segs.join("L") + "Z";
	                makeBackground(plotGroup, carpetcd.clipsegments, xa, ya, isConstraint, coloring);
	                makeFills(trace, plotGroup, xa, ya, fillPathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath);
	                makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours, plotinfo, carpet);
	                Drawing.setClipUrl(plotGroup, carpet._clipPathId, gd);
	              });
	            };
	            function mapPathinfo(pathinfo, map2) {
	              var i, j, k, pi, pedgepaths, ppaths, pedgepath, ppath, path;
	              for (i = 0; i < pathinfo.length; i++) {
	                pi = pathinfo[i];
	                pedgepaths = pi.pedgepaths = [];
	                ppaths = pi.ppaths = [];
	                for (j = 0; j < pi.edgepaths.length; j++) {
	                  path = pi.edgepaths[j];
	                  pedgepath = [];
	                  for (k = 0; k < path.length; k++) {
	                    pedgepath[k] = map2(path[k]);
	                  }
	                  pedgepaths.push(pedgepath);
	                }
	                for (j = 0; j < pi.paths.length; j++) {
	                  path = pi.paths[j];
	                  ppath = [];
	                  for (k = 0; k < path.length; k++) {
	                    ppath[k] = map2(path[k]);
	                  }
	                  ppaths.push(ppath);
	                }
	              }
	            }
	            function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours, plotinfo, carpet) {
	              var isStatic = gd._context.staticPlot;
	              var lineContainer = Lib.ensureSingle(plotgroup, "g", "contourlines");
	              var showLines = contours.showlines !== false;
	              var showLabels = contours.showlabels;
	              var clipLinesForLabels = showLines && showLabels;
	              var linegroup = contourPlot.createLines(lineContainer, showLines || showLabels, pathinfo, isStatic);
	              var lineClip = contourPlot.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
	              var labelGroup = plotgroup.selectAll("g.contourlabels").data(showLabels ? [0] : []);
	              labelGroup.exit().remove();
	              labelGroup.enter().append("g").classed("contourlabels", true);
	              if (showLabels) {
	                var xa = plotinfo.xaxis;
	                var ya = plotinfo.yaxis;
	                var xLen = xa._length;
	                var yLen = ya._length;
	                var labelClipPathData = [[[0, 0], [xLen, 0], [xLen, yLen], [0, yLen]]];
	                var labelData = [];
	                Lib.clearLocationCache();
	                var contourFormat = contourPlot.labelFormatter(gd, cd0);
	                var dummyText = Drawing.tester.append("text").attr("data-notex", 1).call(Drawing.font, contours.labelfont);
	                var bounds = {
	                  left: 0,
	                  right: xLen,
	                  center: xLen / 2,
	                  top: 0,
	                  bottom: yLen,
	                  middle: yLen / 2
	                };
	                var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);
	                var normLength = constants.LABELDISTANCE * plotDiagonal / Math.max(1, pathinfo.length / constants.LABELINCREASE);
	                linegroup.each(function(d) {
	                  var textOpts = contourPlot.calcTextOpts(d.level, contourFormat, dummyText, gd);
	                  d3.select(this).selectAll("path").each(function(pathData) {
	                    var path = this;
	                    var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
	                    if (!pathBounds) return;
	                    constrainToCarpet(path, pathData, d, pathBounds, carpet, textOpts.height);
	                    if (pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
	                    var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength), constants.LABELMAX);
	                    for (var i = 0; i < maxLabels; i++) {
	                      var loc = contourPlot.findBestTextLocation(path, pathBounds, textOpts, labelData, bounds);
	                      if (!loc) break;
	                      contourPlot.addLabelData(loc, textOpts, labelData, labelClipPathData);
	                    }
	                  });
	                });
	                dummyText.remove();
	                contourPlot.drawLabels(labelGroup, labelData, gd, lineClip, clipLinesForLabels ? labelClipPathData : null);
	              }
	              if (showLabels && !showLines) linegroup.remove();
	            }
	            function constrainToCarpet(path, pathData, levelData, pathBounds, carpet, textHeight) {
	              var pathABData;
	              for (var i = 0; i < levelData.pedgepaths.length; i++) {
	                if (pathData === levelData.pedgepaths[i]) {
	                  pathABData = levelData.edgepaths[i];
	                }
	              }
	              if (!pathABData) return;
	              var aMin = carpet.a[0];
	              var aMax = carpet.a[carpet.a.length - 1];
	              var bMin = carpet.b[0];
	              var bMax = carpet.b[carpet.b.length - 1];
	              function getOffset(abPt, pathVector) {
	                var offset = 0;
	                var edgeVector;
	                var dAB = 0.1;
	                if (Math.abs(abPt[0] - aMin) < dAB || Math.abs(abPt[0] - aMax) < dAB) {
	                  edgeVector = normalizeVector(carpet.dxydb_rough(abPt[0], abPt[1], dAB));
	                  offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
	                }
	                if (Math.abs(abPt[1] - bMin) < dAB || Math.abs(abPt[1] - bMax) < dAB) {
	                  edgeVector = normalizeVector(carpet.dxyda_rough(abPt[0], abPt[1], dAB));
	                  offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
	                }
	                return offset;
	              }
	              var startVector = getUnitVector(path, 0, 1);
	              var endVector = getUnitVector(path, pathBounds.total, pathBounds.total - 1);
	              var minStart = getOffset(pathABData[0], startVector);
	              var maxEnd = pathBounds.total - getOffset(pathABData[pathABData.length - 1], endVector);
	              if (pathBounds.min < minStart) pathBounds.min = minStart;
	              if (pathBounds.max > maxEnd) pathBounds.max = maxEnd;
	              pathBounds.len = pathBounds.max - pathBounds.min;
	            }
	            function getUnitVector(path, p0, p1) {
	              var pt0 = path.getPointAtLength(p0);
	              var pt1 = path.getPointAtLength(p1);
	              var dx = pt1.x - pt0.x;
	              var dy = pt1.y - pt0.y;
	              var len = Math.sqrt(dx * dx + dy * dy);
	              return [dx / len, dy / len];
	            }
	            function normalizeVector(v) {
	              var len = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	              return [v[0] / len, v[1] / len];
	            }
	            function vectorTan(v0, v1) {
	              var cos = Math.abs(v0[0] * v1[0] + v0[1] * v1[1]);
	              var sin = Math.sqrt(1 - cos * cos);
	              return sin / cos;
	            }
	            function makeBackground(plotgroup, clipsegments, xaxis, yaxis, isConstraint, coloring) {
	              var seg, xp, yp, i;
	              var bggroup = Lib.ensureSingle(plotgroup, "g", "contourbg");
	              var bgfill = bggroup.selectAll("path").data(coloring === "fill" && !isConstraint ? [0] : []);
	              bgfill.enter().append("path");
	              bgfill.exit().remove();
	              var segs = [];
	              for (i = 0; i < clipsegments.length; i++) {
	                seg = clipsegments[i];
	                xp = map1dArray([], seg.x, xaxis.c2p);
	                yp = map1dArray([], seg.y, yaxis.c2p);
	                segs.push(makepath(xp, yp, seg.bicubic));
	              }
	              bgfill.attr("d", "M" + segs.join("L") + "Z").style("stroke", "none");
	            }
	            function makeFills(trace, plotgroup, xa, ya, pathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath) {
	              var hasFills = coloring === "fill";
	              if (hasFills) {
	                closeBoundaries(pathinfo, trace.contours);
	              }
	              var fillgroup = Lib.ensureSingle(plotgroup, "g", "contourfill");
	              var fillitems = fillgroup.selectAll("path").data(hasFills ? pathinfo : []);
	              fillitems.enter().append("path");
	              fillitems.exit().remove();
	              fillitems.each(function(pi) {
	                var fullpath = (pi.prefixBoundary ? boundaryPath : "") + joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya);
	                if (!fullpath) {
	                  d3.select(this).remove();
	                } else {
	                  d3.select(this).attr("d", fullpath).style("stroke", "none");
	                }
	              });
	            }
	            function joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya) {
	              var i;
	              var fullpath = "";
	              var startsleft = pi.edgepaths.map(function(v, i2) {
	                return i2;
	              });
	              var newloop = true;
	              var endpt, newendpt, cnt, nexti, possiblei, addpath;
	              var atol = Math.abs(perimeter[0][0] - perimeter[2][0]) * 1e-4;
	              var btol = Math.abs(perimeter[0][1] - perimeter[2][1]) * 1e-4;
	              function istop(pt) {
	                return Math.abs(pt[1] - perimeter[0][1]) < btol;
	              }
	              function isbottom(pt) {
	                return Math.abs(pt[1] - perimeter[2][1]) < btol;
	              }
	              function isleft(pt) {
	                return Math.abs(pt[0] - perimeter[0][0]) < atol;
	              }
	              function isright(pt) {
	                return Math.abs(pt[0] - perimeter[2][0]) < atol;
	              }
	              function pathto(pt0, pt1) {
	                var i2, j, segments, axis;
	                var path = "";
	                if (istop(pt0) && !isright(pt0) || isbottom(pt0) && !isleft(pt0)) {
	                  axis = carpet.aaxis;
	                  segments = axisAlignedLine(carpet, carpetcd, [pt0[0], pt1[0]], 0.5 * (pt0[1] + pt1[1]));
	                } else {
	                  axis = carpet.baxis;
	                  segments = axisAlignedLine(carpet, carpetcd, 0.5 * (pt0[0] + pt1[0]), [pt0[1], pt1[1]]);
	                }
	                for (i2 = 1; i2 < segments.length; i2++) {
	                  path += axis.smoothing ? "C" : "L";
	                  for (j = 0; j < segments[i2].length; j++) {
	                    var pt = segments[i2][j];
	                    path += [xa.c2p(pt[0]), ya.c2p(pt[1])] + " ";
	                  }
	                }
	                return path;
	              }
	              i = 0;
	              endpt = null;
	              while (startsleft.length) {
	                var startpt = pi.edgepaths[i][0];
	                if (endpt) {
	                  fullpath += pathto(endpt, startpt);
	                }
	                addpath = Drawing.smoothopen(pi.edgepaths[i].map(ab2p), pi.smoothing);
	                fullpath += newloop ? addpath : addpath.replace(/^M/, "L");
	                startsleft.splice(startsleft.indexOf(i), 1);
	                endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
	                nexti = -1;
	                for (cnt = 0; cnt < 4; cnt++) {
	                  if (!endpt) {
	                    Lib.log("Missing end?", i, pi);
	                    break;
	                  }
	                  if (istop(endpt) && !isright(endpt)) {
	                    newendpt = perimeter[1];
	                  } else if (isleft(endpt)) {
	                    newendpt = perimeter[0];
	                  } else if (isbottom(endpt)) {
	                    newendpt = perimeter[3];
	                  } else if (isright(endpt)) {
	                    newendpt = perimeter[2];
	                  }
	                  for (possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
	                    var ptNew = pi.edgepaths[possiblei][0];
	                    if (Math.abs(endpt[0] - newendpt[0]) < atol) {
	                      if (Math.abs(endpt[0] - ptNew[0]) < atol && (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                      }
	                    } else if (Math.abs(endpt[1] - newendpt[1]) < btol) {
	                      if (Math.abs(endpt[1] - ptNew[1]) < btol && (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
	                        newendpt = ptNew;
	                        nexti = possiblei;
	                      }
	                    } else {
	                      Lib.log("endpt to newendpt is not vert. or horz.", endpt, newendpt, ptNew);
	                    }
	                  }
	                  if (nexti >= 0) break;
	                  fullpath += pathto(endpt, newendpt);
	                  endpt = newendpt;
	                }
	                if (nexti === pi.edgepaths.length) {
	                  Lib.log("unclosed perimeter path");
	                  break;
	                }
	                i = nexti;
	                newloop = startsleft.indexOf(i) === -1;
	                if (newloop) {
	                  i = startsleft[0];
	                  fullpath += pathto(endpt, newendpt) + "Z";
	                  endpt = null;
	                }
	              }
	              for (i = 0; i < pi.paths.length; i++) {
	                fullpath += Drawing.smoothclosed(pi.paths[i].map(ab2p), pi.smoothing);
	              }
	              return fullpath;
	            }
	          }
	        ),
	        /***/
	        64096: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var baseAttrs = __webpack_require__2(9012);
	            var scatterMapboxAttrs = __webpack_require__2(99181);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = extendFlat({
	              lon: scatterMapboxAttrs.lon,
	              lat: scatterMapboxAttrs.lat,
	              z: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              radius: {
	                valType: "number",
	                editType: "plot",
	                arrayOk: true,
	                min: 1,
	                dflt: 30
	              },
	              below: {
	                valType: "string",
	                editType: "plot"
	              },
	              text: scatterMapboxAttrs.text,
	              hovertext: scatterMapboxAttrs.hovertext,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["lon", "lat", "z", "text", "name"]
	              }),
	              hovertemplate: hovertemplateAttrs(),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              editTypeOverride: "calc"
	            }));
	          }
	        ),
	        /***/
	        85070: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var colorscaleCalc = __webpack_require__2(78803);
	            var _ = __webpack_require__2(71828)._;
	            module2.exports = function calc(gd, trace) {
	              var len = trace._length;
	              var calcTrace = new Array(len);
	              var z = trace.z;
	              var hasZ = isArrayOrTypedArray(z) && z.length;
	              for (var i = 0; i < len; i++) {
	                var cdi = calcTrace[i] = {};
	                var lon = trace.lon[i];
	                var lat = trace.lat[i];
	                cdi.lonlat = isNumeric(lon) && isNumeric(lat) ? [+lon, +lat] : [BADNUM, BADNUM];
	                if (hasZ) {
	                  var zi = z[i];
	                  cdi.z = isNumeric(zi) ? zi : BADNUM;
	                }
	              }
	              colorscaleCalc(gd, trace, {
	                vals: hasZ ? z : [0, 1],
	                containerStr: "",
	                cLetter: "z"
	              });
	              if (len) {
	                calcTrace[0].t = {
	                  labels: {
	                    lat: _(gd, "lat:") + " ",
	                    lon: _(gd, "lon:") + " "
	                  }
	                };
	              }
	              return calcTrace;
	            };
	          }
	        ),
	        /***/
	        52414: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var Colorscale = __webpack_require__2(21081);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var makeBlank = __webpack_require__2(18214).makeBlank;
	            module2.exports = function convert(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var isVisible = trace.visible === true && trace._length !== 0;
	              var heatmap = {
	                layout: {
	                  visibility: "none"
	                },
	                paint: {}
	              };
	              var opts = trace._opts = {
	                heatmap,
	                geojson: makeBlank()
	              };
	              if (!isVisible) return opts;
	              var features = [];
	              var i;
	              var z = trace.z;
	              var radius = trace.radius;
	              var hasZ = Lib.isArrayOrTypedArray(z) && z.length;
	              var hasArrayRadius = Lib.isArrayOrTypedArray(radius);
	              for (i = 0; i < calcTrace.length; i++) {
	                var cdi = calcTrace[i];
	                var lonlat = cdi.lonlat;
	                if (lonlat[0] !== BADNUM) {
	                  var props = {};
	                  if (hasZ) {
	                    var zi = cdi.z;
	                    props.z = zi !== BADNUM ? zi : 0;
	                  }
	                  if (hasArrayRadius) {
	                    props.r = isNumeric(radius[i]) && radius[i] > 0 ? +radius[i] : 0;
	                  }
	                  features.push({
	                    type: "Feature",
	                    geometry: {
	                      type: "Point",
	                      coordinates: lonlat
	                    },
	                    properties: props
	                  });
	                }
	              }
	              var cOpts = Colorscale.extractOpts(trace);
	              var scl = cOpts.reversescale ? Colorscale.flipScale(cOpts.colorscale) : cOpts.colorscale;
	              var scl01 = scl[0][1];
	              var color0 = Color.opacity(scl01) < 1 ? scl01 : Color.addOpacity(scl01, 0);
	              var heatmapColor = ["interpolate", ["linear"], ["heatmap-density"], 0, color0];
	              for (i = 1; i < scl.length; i++) {
	                heatmapColor.push(scl[i][0], scl[i][1]);
	              }
	              var zExp = ["interpolate", ["linear"], ["get", "z"], cOpts.min, 0, cOpts.max, 1];
	              Lib.extendFlat(opts.heatmap.paint, {
	                "heatmap-weight": hasZ ? zExp : 1 / (cOpts.max - cOpts.min),
	                "heatmap-color": heatmapColor,
	                "heatmap-radius": hasArrayRadius ? {
	                  type: "identity",
	                  property: "r"
	                } : trace.radius,
	                "heatmap-opacity": trace.opacity
	              });
	              opts.geojson = {
	                type: "FeatureCollection",
	                features
	              };
	              opts.heatmap.layout.visibility = "visible";
	              return opts;
	            };
	          }
	        ),
	        /***/
	        79429: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(64096);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var lon = coerce("lon") || [];
	              var lat = coerce("lat") || [];
	              var len = Math.min(lon.length, lat.length);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              coerce("z");
	              coerce("radius");
	              coerce("below");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "z"
	              });
	            };
	          }
	        ),
	        /***/
	        62474: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt) {
	              out.lon = pt.lon;
	              out.lat = pt.lat;
	              out.z = pt.z;
	              return out;
	            };
	          }
	        ),
	        /***/
	        84684: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var scatterMapboxHoverPoints = __webpack_require__2(28178).hoverPoints;
	            var getExtraText = __webpack_require__2(28178).getExtraText;
	            module2.exports = function hoverPoints(pointData, xval, yval) {
	              var pts = scatterMapboxHoverPoints(pointData, xval, yval);
	              if (!pts) return;
	              var newPointData = pts[0];
	              var cd = newPointData.cd;
	              var trace = cd[0].trace;
	              var di = cd[newPointData.index];
	              delete newPointData.color;
	              if ("z" in di) {
	                var ax = newPointData.subplot.mockAxis;
	                newPointData.z = di.z;
	                newPointData.zLabel = Axes.tickText(ax, ax.c2l(di.z), "hover").text;
	              }
	              newPointData.extraText = getExtraText(trace, di, cd[0].t.labels);
	              return [newPointData];
	            };
	          }
	        ),
	        /***/
	        93814: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(64096),
	              supplyDefaults: __webpack_require__2(79429),
	              colorbar: __webpack_require__2(61243),
	              formatLabels: __webpack_require__2(15636),
	              calc: __webpack_require__2(85070),
	              plot: __webpack_require__2(7336),
	              hoverPoints: __webpack_require__2(84684),
	              eventData: __webpack_require__2(62474),
	              getBelow: function(trace, subplot) {
	                var mapLayers = subplot.getMapLayers();
	                for (var i = 0; i < mapLayers.length; i++) {
	                  var layer = mapLayers[i];
	                  var layerId = layer.id;
	                  if (layer.type === "symbol" && typeof layerId === "string" && layerId.indexOf("plotly-") === -1) {
	                    return layerId;
	                  }
	                }
	              },
	              moduleType: "trace",
	              name: "densitymapbox",
	              basePlotModule: __webpack_require__2(50101),
	              categories: ["mapbox", "gl", "showLegend"],
	              meta: {
	                hr_name: "density_mapbox"
	              }
	            };
	          }
	        ),
	        /***/
	        7336: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var convert = __webpack_require__2(52414);
	            var LAYER_PREFIX = __webpack_require__2(77734).traceLayerPrefix;
	            function DensityMapbox(subplot, uid) {
	              this.type = "densitymapbox";
	              this.subplot = subplot;
	              this.uid = uid;
	              this.sourceId = "source-" + uid;
	              this.layerList = [["heatmap", LAYER_PREFIX + uid + "-heatmap"]];
	              this.below = null;
	            }
	            var proto = DensityMapbox.prototype;
	            proto.update = function(calcTrace) {
	              var subplot = this.subplot;
	              var layerList = this.layerList;
	              var optsAll = convert(calcTrace);
	              var below = subplot.belowLookup["trace-" + this.uid];
	              subplot.map.getSource(this.sourceId).setData(optsAll.geojson);
	              if (below !== this.below) {
	                this._removeLayers();
	                this._addLayers(optsAll, below);
	                this.below = below;
	              }
	              for (var i = 0; i < layerList.length; i++) {
	                var item = layerList[i];
	                var k = item[0];
	                var id = item[1];
	                var opts = optsAll[k];
	                subplot.setOptions(id, "setLayoutProperty", opts.layout);
	                if (opts.layout.visibility === "visible") {
	                  subplot.setOptions(id, "setPaintProperty", opts.paint);
	                }
	              }
	            };
	            proto._addLayers = function(optsAll, below) {
	              var subplot = this.subplot;
	              var layerList = this.layerList;
	              var sourceId = this.sourceId;
	              for (var i = 0; i < layerList.length; i++) {
	                var item = layerList[i];
	                var k = item[0];
	                var opts = optsAll[k];
	                subplot.addLayer({
	                  type: k,
	                  id: item[1],
	                  source: sourceId,
	                  layout: opts.layout,
	                  paint: opts.paint
	                }, below);
	              }
	            };
	            proto._removeLayers = function() {
	              var map2 = this.subplot.map;
	              var layerList = this.layerList;
	              for (var i = layerList.length - 1; i >= 0; i--) {
	                map2.removeLayer(layerList[i][1]);
	              }
	            };
	            proto.dispose = function() {
	              var map2 = this.subplot.map;
	              this._removeLayers();
	              map2.removeSource(this.sourceId);
	            };
	            module2.exports = function createDensityMapbox(subplot, calcTrace) {
	              var trace = calcTrace[0].trace;
	              var densityMapbox = new DensityMapbox(subplot, trace.uid);
	              var sourceId = densityMapbox.sourceId;
	              var optsAll = convert(calcTrace);
	              var below = densityMapbox.below = subplot.belowLookup["trace-" + trace.uid];
	              subplot.map.addSource(sourceId, {
	                type: "geojson",
	                data: optsAll.geojson
	              });
	              densityMapbox._addLayers(optsAll, below);
	              return densityMapbox;
	            };
	          }
	        ),
	        /***/
	        49789: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function arraysToCalcdata(cd, trace) {
	              for (var i = 0; i < cd.length; i++) cd[i].i = i;
	              Lib.mergeArray(trace.text, cd, "tx");
	              Lib.mergeArray(trace.hovertext, cd, "htx");
	              var marker = trace.marker;
	              if (marker) {
	                Lib.mergeArray(marker.opacity, cd, "mo");
	                Lib.mergeArray(marker.color, cd, "mc");
	                var markerLine = marker.line;
	                if (markerLine) {
	                  Lib.mergeArray(markerLine.color, cd, "mlc");
	                  Lib.mergeArrayCastPositive(markerLine.width, cd, "mlw");
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        1285: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var barAttrs = __webpack_require__2(1486);
	            var lineAttrs = __webpack_require__2(82196).line;
	            var baseAttrs = __webpack_require__2(9012);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var constants = __webpack_require__2(18517);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var Color = __webpack_require__2(7901);
	            module2.exports = {
	              x: barAttrs.x,
	              x0: barAttrs.x0,
	              dx: barAttrs.dx,
	              y: barAttrs.y,
	              y0: barAttrs.y0,
	              dy: barAttrs.dy,
	              xperiod: barAttrs.xperiod,
	              yperiod: barAttrs.yperiod,
	              xperiod0: barAttrs.xperiod0,
	              yperiod0: barAttrs.yperiod0,
	              xperiodalignment: barAttrs.xperiodalignment,
	              yperiodalignment: barAttrs.yperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              hovertext: barAttrs.hovertext,
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["name", "x", "y", "text", "percent initial", "percent previous", "percent total"]
	              }),
	              textinfo: {
	                valType: "flaglist",
	                flags: ["label", "text", "percent initial", "percent previous", "percent total", "value"],
	                extras: ["none"],
	                editType: "plot",
	                arrayOk: false
	              },
	              // TODO: incorporate `label` and `value` in the eventData
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: constants.eventDataKeys.concat(["label", "value"])
	              }),
	              text: barAttrs.text,
	              textposition: barAttrs.textposition,
	              insidetextanchor: extendFlat({}, barAttrs.insidetextanchor, {
	                dflt: "middle"
	              }),
	              textangle: extendFlat({}, barAttrs.textangle, {
	                dflt: 0
	              }),
	              textfont: barAttrs.textfont,
	              insidetextfont: barAttrs.insidetextfont,
	              outsidetextfont: barAttrs.outsidetextfont,
	              constraintext: barAttrs.constraintext,
	              cliponaxis: barAttrs.cliponaxis,
	              orientation: extendFlat({}, barAttrs.orientation, {}),
	              offset: extendFlat({}, barAttrs.offset, {
	                arrayOk: false
	              }),
	              width: extendFlat({}, barAttrs.width, {
	                arrayOk: false
	              }),
	              marker: funnelMarker(),
	              connector: {
	                fillcolor: {
	                  valType: "color",
	                  editType: "style"
	                },
	                line: {
	                  color: extendFlat({}, lineAttrs.color, {
	                    dflt: Color.defaultLine
	                  }),
	                  width: extendFlat({}, lineAttrs.width, {
	                    dflt: 0,
	                    editType: "plot"
	                  }),
	                  dash: lineAttrs.dash,
	                  editType: "style"
	                },
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              offsetgroup: barAttrs.offsetgroup,
	              alignmentgroup: barAttrs.alignmentgroup
	            };
	            function funnelMarker() {
	              var marker = extendFlat({}, barAttrs.marker);
	              delete marker.pattern;
	              return marker;
	            }
	          }
	        ),
	        /***/
	        9532: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var arraysToCalcdata = __webpack_require__2(49789);
	            var calcSelection = __webpack_require__2(66279);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis || "x");
	              var ya = Axes.getFromId(gd, trace.yaxis || "y");
	              var size, pos, origPos, pObj, hasPeriod, pLetter, i, cdi;
	              if (trace.orientation === "h") {
	                size = xa.makeCalcdata(trace, "x");
	                origPos = ya.makeCalcdata(trace, "y");
	                pObj = alignPeriod(trace, ya, "y", origPos);
	                hasPeriod = !!trace.yperiodalignment;
	                pLetter = "y";
	              } else {
	                size = ya.makeCalcdata(trace, "y");
	                origPos = xa.makeCalcdata(trace, "x");
	                pObj = alignPeriod(trace, xa, "x", origPos);
	                hasPeriod = !!trace.xperiodalignment;
	                pLetter = "x";
	              }
	              pos = pObj.vals;
	              var serieslen = Math.min(pos.length, size.length);
	              var cd = new Array(serieslen);
	              trace._base = [];
	              for (i = 0; i < serieslen; i++) {
	                if (size[i] < 0) size[i] = BADNUM;
	                var connectToNext = false;
	                if (size[i] !== BADNUM) {
	                  if (i + 1 < serieslen && size[i + 1] !== BADNUM) {
	                    connectToNext = true;
	                  }
	                }
	                cdi = cd[i] = {
	                  p: pos[i],
	                  s: size[i],
	                  cNext: connectToNext
	                };
	                trace._base[i] = -0.5 * cdi.s;
	                if (hasPeriod) {
	                  cd[i].orig_p = origPos[i];
	                  cd[i][pLetter + "End"] = pObj.ends[i];
	                  cd[i][pLetter + "Start"] = pObj.starts[i];
	                }
	                if (trace.ids) {
	                  cdi.id = String(trace.ids[i]);
	                }
	                if (i === 0) cd[0].vTotal = 0;
	                cd[0].vTotal += fixNum(cdi.s);
	                cdi.begR = fixNum(cdi.s) / fixNum(cd[0].s);
	              }
	              var prevGoodNum;
	              for (i = 0; i < serieslen; i++) {
	                cdi = cd[i];
	                if (cdi.s === BADNUM) continue;
	                cdi.sumR = cdi.s / cd[0].vTotal;
	                cdi.difR = prevGoodNum !== undefined ? cdi.s / prevGoodNum : 1;
	                prevGoodNum = cdi.s;
	              }
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            };
	            function fixNum(a) {
	              return a === BADNUM ? 0 : a;
	            }
	          }
	        ),
	        /***/
	        18517: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              eventDataKeys: ["percentInitial", "percentPrevious", "percentTotal"]
	            };
	          }
	        ),
	        /***/
	        8984: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var setGroupPositions = __webpack_require__2(11661).setGroupPositions;
	            module2.exports = function crossTraceCalc(gd, plotinfo) {
	              var fullLayout = gd._fullLayout;
	              var fullData = gd._fullData;
	              var calcdata = gd.calcdata;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var funnels = [];
	              var funnelsVert = [];
	              var funnelsHorz = [];
	              var cd, i;
	              for (i = 0; i < fullData.length; i++) {
	                var fullTrace = fullData[i];
	                var isHorizontal = fullTrace.orientation === "h";
	                if (fullTrace.visible === true && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id && fullTrace.type === "funnel") {
	                  cd = calcdata[i];
	                  if (isHorizontal) {
	                    funnelsHorz.push(cd);
	                  } else {
	                    funnelsVert.push(cd);
	                  }
	                  funnels.push(cd);
	                }
	              }
	              var opts = {
	                mode: fullLayout.funnelmode,
	                norm: fullLayout.funnelnorm,
	                gap: fullLayout.funnelgap,
	                groupgap: fullLayout.funnelgroupgap
	              };
	              setGroupPositions(gd, xa, ya, funnelsVert, opts);
	              setGroupPositions(gd, ya, xa, funnelsHorz, opts);
	              for (i = 0; i < funnels.length; i++) {
	                cd = funnels[i];
	                for (var j = 0; j < cd.length; j++) {
	                  if (j + 1 < cd.length) {
	                    cd[j].nextP0 = cd[j + 1].p0;
	                    cd[j].nextS0 = cd[j + 1].s0;
	                    cd[j].nextP1 = cd[j + 1].p1;
	                    cd[j].nextS1 = cd[j + 1].s1;
	                  }
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        26199: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleGroupingDefaults = __webpack_require__2(26125);
	            var handleText = __webpack_require__2(90769).handleText;
	            var handleXYDefaults = __webpack_require__2(67513);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var attributes = __webpack_require__2(1285);
	            var Color = __webpack_require__2(7901);
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("orientation", traceOut.y && !traceOut.x ? "v" : "h");
	              coerce("offset");
	              coerce("width");
	              var text = coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var textposition = coerce("textposition");
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                moduleHasSelected: false,
	                moduleHasUnselected: false,
	                moduleHasConstrain: true,
	                moduleHasCliponaxis: true,
	                moduleHasTextangle: true,
	                moduleHasInsideanchor: true
	              });
	              if (traceOut.textposition !== "none" && !traceOut.texttemplate) {
	                coerce("textinfo", Array.isArray(text) ? "text+value" : "value");
	              }
	              var markerColor = coerce("marker.color", defaultColor);
	              coerce("marker.line.color", Color.defaultLine);
	              coerce("marker.line.width");
	              var connectorVisible = coerce("connector.visible");
	              if (connectorVisible) {
	                coerce("connector.fillcolor", defaultFillColor(markerColor));
	                var connectorLineWidth = coerce("connector.line.width");
	                if (connectorLineWidth) {
	                  coerce("connector.line.color");
	                  coerce("connector.line.dash");
	                }
	              }
	            }
	            function defaultFillColor(markerColor) {
	              var cBase = Lib.isArrayOrTypedArray(markerColor) ? "#000" : markerColor;
	              return Color.addOpacity(cBase, 0.5 * Color.opacity(cBase));
	            }
	            function crossTraceDefaults(fullData, fullLayout) {
	              var traceIn, traceOut;
	              function coerce(attr) {
	                return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	              }
	              if (fullLayout.funnelmode === "group") {
	                for (var i = 0; i < fullData.length; i++) {
	                  traceOut = fullData[i];
	                  traceIn = traceOut._input;
	                  handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	                }
	              }
	            }
	            module2.exports = {
	              supplyDefaults,
	              crossTraceDefaults
	            };
	          }
	        ),
	        /***/
	        34598: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt) {
	              out.x = "xVal" in pt ? pt.xVal : pt.x;
	              out.y = "yVal" in pt ? pt.yVal : pt.y;
	              if ("percentInitial" in pt) out.percentInitial = pt.percentInitial;
	              if ("percentPrevious" in pt) out.percentPrevious = pt.percentPrevious;
	              if ("percentTotal" in pt) out.percentTotal = pt.percentTotal;
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              return out;
	            };
	          }
	        ),
	        /***/
	        63341: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var opacity = __webpack_require__2(7901).opacity;
	            var hoverOnBars = __webpack_require__2(95423).hoverOnBars;
	            var formatPercent = __webpack_require__2(71828).formatPercent;
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              var point = hoverOnBars(pointData, xval, yval, hovermode, opts);
	              if (!point) return;
	              var cd = point.cd;
	              var trace = cd[0].trace;
	              var isHorizontal = trace.orientation === "h";
	              var index = point.index;
	              var di = cd[index];
	              var sizeLetter = isHorizontal ? "x" : "y";
	              point[sizeLetter + "LabelVal"] = di.s;
	              point.percentInitial = di.begR;
	              point.percentInitialLabel = formatPercent(di.begR, 1);
	              point.percentPrevious = di.difR;
	              point.percentPreviousLabel = formatPercent(di.difR, 1);
	              point.percentTotal = di.sumR;
	              point.percentTotalLabel = formatPercent(di.sumR, 1);
	              var hoverinfo = di.hi || trace.hoverinfo;
	              var text = [];
	              if (hoverinfo && hoverinfo !== "none" && hoverinfo !== "skip") {
	                var isAll = hoverinfo === "all";
	                var parts = hoverinfo.split("+");
	                var hasFlag = function(flag) {
	                  return isAll || parts.indexOf(flag) !== -1;
	                };
	                if (hasFlag("percent initial")) {
	                  text.push(point.percentInitialLabel + " of initial");
	                }
	                if (hasFlag("percent previous")) {
	                  text.push(point.percentPreviousLabel + " of previous");
	                }
	                if (hasFlag("percent total")) {
	                  text.push(point.percentTotalLabel + " of total");
	                }
	              }
	              point.extraText = text.join("<br>");
	              point.color = getTraceColor(trace, di);
	              return [point];
	            };
	            function getTraceColor(trace, di) {
	              var cont = trace.marker;
	              var mc = di.mc || cont.color;
	              var mlc = di.mlc || cont.line.color;
	              var mlw = di.mlw || cont.line.width;
	              if (opacity(mc)) return mc;
	              else if (opacity(mlc) && mlw) return mlc;
	            }
	          }
	        ),
	        /***/
	        51759: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(1285),
	              layoutAttributes: __webpack_require__2(10440),
	              supplyDefaults: __webpack_require__2(26199).supplyDefaults,
	              crossTraceDefaults: __webpack_require__2(26199).crossTraceDefaults,
	              supplyLayoutDefaults: __webpack_require__2(93138),
	              calc: __webpack_require__2(9532),
	              crossTraceCalc: __webpack_require__2(8984),
	              plot: __webpack_require__2(80461),
	              style: __webpack_require__2(68266).style,
	              hoverPoints: __webpack_require__2(63341),
	              eventData: __webpack_require__2(34598),
	              selectPoints: __webpack_require__2(81974),
	              moduleType: "trace",
	              name: "funnel",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["bar-like", "cartesian", "svg", "oriented", "showLegend", "zoomScale"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        10440: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              funnelmode: {
	                valType: "enumerated",
	                values: ["stack", "group", "overlay"],
	                dflt: "stack",
	                editType: "calc"
	              },
	              funnelgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "calc"
	              },
	              funnelgroupgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        93138: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(10440);
	            module2.exports = function(layoutIn, layoutOut, fullData) {
	              var hasTraceType = false;
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (trace.visible && trace.type === "funnel") {
	                  hasTraceType = true;
	                  break;
	                }
	              }
	              if (hasTraceType) {
	                coerce("funnelmode");
	                coerce("funnelgap", 0.2);
	                coerce("funnelgroupgap");
	              }
	            };
	          }
	        ),
	        /***/
	        80461: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var barPlot = __webpack_require__2(17295);
	            var clearMinTextSize = __webpack_require__2(72597).clearMinTextSize;
	            module2.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
	              var fullLayout = gd._fullLayout;
	              clearMinTextSize("funnel", fullLayout);
	              plotConnectorRegions(gd, plotinfo, cdModule, traceLayer);
	              plotConnectorLines(gd, plotinfo, cdModule, traceLayer);
	              barPlot.plot(gd, plotinfo, cdModule, traceLayer, {
	                mode: fullLayout.funnelmode,
	                norm: fullLayout.funnelmode,
	                gap: fullLayout.funnelgap,
	                groupgap: fullLayout.funnelgroupgap
	              });
	            };
	            function plotConnectorRegions(gd, plotinfo, cdModule, traceLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(traceLayer, cdModule, "trace bars").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var trace = cd[0].trace;
	                var group = Lib.ensureSingle(plotGroup, "g", "regions");
	                if (!trace.connector || !trace.connector.visible) {
	                  group.remove();
	                  return;
	                }
	                var isHorizontal = trace.orientation === "h";
	                var connectors = group.selectAll("g.region").data(Lib.identity);
	                connectors.enter().append("g").classed("region", true);
	                connectors.exit().remove();
	                var len = connectors.size();
	                connectors.each(function(di, i) {
	                  if (i !== len - 1 && !di.cNext) return;
	                  var xy = getXY(di, xa, ya, isHorizontal);
	                  var x = xy[0];
	                  var y = xy[1];
	                  var shape = "";
	                  if (x[0] !== BADNUM && y[0] !== BADNUM && x[1] !== BADNUM && y[1] !== BADNUM && x[2] !== BADNUM && y[2] !== BADNUM && x[3] !== BADNUM && y[3] !== BADNUM) {
	                    if (isHorizontal) {
	                      shape += "M" + x[0] + "," + y[1] + "L" + x[2] + "," + y[2] + "H" + x[3] + "L" + x[1] + "," + y[1] + "Z";
	                    } else {
	                      shape += "M" + x[1] + "," + y[1] + "L" + x[2] + "," + y[3] + "V" + y[2] + "L" + x[1] + "," + y[0] + "Z";
	                    }
	                  }
	                  if (shape === "") shape = "M0,0Z";
	                  Lib.ensureSingle(d3.select(this), "path").attr("d", shape).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	                });
	              });
	            }
	            function plotConnectorLines(gd, plotinfo, cdModule, traceLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(traceLayer, cdModule, "trace bars").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var trace = cd[0].trace;
	                var group = Lib.ensureSingle(plotGroup, "g", "lines");
	                if (!trace.connector || !trace.connector.visible || !trace.connector.line.width) {
	                  group.remove();
	                  return;
	                }
	                var isHorizontal = trace.orientation === "h";
	                var connectors = group.selectAll("g.line").data(Lib.identity);
	                connectors.enter().append("g").classed("line", true);
	                connectors.exit().remove();
	                var len = connectors.size();
	                connectors.each(function(di, i) {
	                  if (i !== len - 1 && !di.cNext) return;
	                  var xy = getXY(di, xa, ya, isHorizontal);
	                  var x = xy[0];
	                  var y = xy[1];
	                  var shape = "";
	                  if (x[3] !== undefined && y[3] !== undefined) {
	                    if (isHorizontal) {
	                      shape += "M" + x[0] + "," + y[1] + "L" + x[2] + "," + y[2];
	                      shape += "M" + x[1] + "," + y[1] + "L" + x[3] + "," + y[2];
	                    } else {
	                      shape += "M" + x[1] + "," + y[1] + "L" + x[2] + "," + y[3];
	                      shape += "M" + x[1] + "," + y[0] + "L" + x[2] + "," + y[2];
	                    }
	                  }
	                  if (shape === "") shape = "M0,0Z";
	                  Lib.ensureSingle(d3.select(this), "path").attr("d", shape).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	                });
	              });
	            }
	            function getXY(di, xa, ya, isHorizontal) {
	              var s = [];
	              var p = [];
	              var sAxis = isHorizontal ? xa : ya;
	              var pAxis = isHorizontal ? ya : xa;
	              s[0] = sAxis.c2p(di.s0, true);
	              p[0] = pAxis.c2p(di.p0, true);
	              s[1] = sAxis.c2p(di.s1, true);
	              p[1] = pAxis.c2p(di.p1, true);
	              s[2] = sAxis.c2p(di.nextS0, true);
	              p[2] = pAxis.c2p(di.nextP0, true);
	              s[3] = sAxis.c2p(di.nextS1, true);
	              p[3] = pAxis.c2p(di.nextP1, true);
	              return isHorizontal ? [s, p] : [p, s];
	            }
	          }
	        ),
	        /***/
	        68266: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var DESELECTDIM = __webpack_require__2(37822).DESELECTDIM;
	            var barStyle = __webpack_require__2(16688);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            var styleTextPoints = barStyle.styleTextPoints;
	            function style(gd, cd, sel) {
	              var s = sel ? sel : d3.select(gd).selectAll("g.funnellayer").selectAll("g.trace");
	              resizeText(gd, s, "funnel");
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              s.each(function(d) {
	                var gTrace = d3.select(this);
	                var trace = d[0].trace;
	                gTrace.selectAll(".point > path").each(function(di) {
	                  if (!di.isBlank) {
	                    var cont = trace.marker;
	                    d3.select(this).call(Color.fill, di.mc || cont.color).call(Color.stroke, di.mlc || cont.line.color).call(Drawing.dashLine, cont.line.dash, di.mlw || cont.line.width).style("opacity", trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
	                  }
	                });
	                styleTextPoints(gTrace, trace, gd);
	                gTrace.selectAll(".regions").each(function() {
	                  d3.select(this).selectAll("path").style("stroke-width", 0).call(Color.fill, trace.connector.fillcolor);
	                });
	                gTrace.selectAll(".lines").each(function() {
	                  var cont = trace.connector.line;
	                  Drawing.lineGroupStyle(d3.select(this).selectAll("path"), cont.width, cont.color, cont.dash);
	                });
	              });
	            }
	            module2.exports = {
	              style
	            };
	          }
	        ),
	        /***/
	        86807: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var pieAttrs = __webpack_require__2(34e3);
	            var baseAttrs = __webpack_require__2(9012);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = {
	              labels: pieAttrs.labels,
	              // equivalent of x0 and dx, if label is missing
	              label0: pieAttrs.label0,
	              dlabel: pieAttrs.dlabel,
	              values: pieAttrs.values,
	              marker: {
	                colors: pieAttrs.marker.colors,
	                line: {
	                  color: extendFlat({}, pieAttrs.marker.line.color, {
	                    dflt: null
	                  }),
	                  width: extendFlat({}, pieAttrs.marker.line.width, {
	                    dflt: 1
	                  }),
	                  editType: "calc"
	                },
	                pattern: pieAttrs.marker.pattern,
	                editType: "calc"
	              },
	              text: pieAttrs.text,
	              hovertext: pieAttrs.hovertext,
	              scalegroup: extendFlat({}, pieAttrs.scalegroup, {}),
	              textinfo: extendFlat({}, pieAttrs.textinfo, {
	                flags: ["label", "text", "value", "percent"]
	              }),
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["label", "color", "value", "text", "percent"]
	              }),
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["label", "text", "value", "percent", "name"]
	              }),
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: ["label", "color", "value", "text", "percent"]
	              }),
	              textposition: extendFlat({}, pieAttrs.textposition, {
	                values: ["inside", "none"],
	                dflt: "inside"
	              }),
	              textfont: pieAttrs.textfont,
	              insidetextfont: pieAttrs.insidetextfont,
	              title: {
	                text: pieAttrs.title.text,
	                font: pieAttrs.title.font,
	                position: extendFlat({}, pieAttrs.title.position, {
	                  values: ["top left", "top center", "top right"],
	                  dflt: "top center"
	                }),
	                editType: "plot"
	              },
	              domain: domainAttrs({
	                name: "funnelarea",
	                trace: true,
	                editType: "calc"
	              }),
	              aspectratio: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                editType: "plot"
	              },
	              baseratio: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0.333,
	                editType: "plot"
	              }
	            };
	          }
	        ),
	        /***/
	        6452: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var plots = __webpack_require__2(74875);
	            exports2.name = "funnelarea";
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              plots.plotBasePlot(exports2.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              plots.cleanBasePlot(exports2.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	            };
	          }
	        ),
	        /***/
	        89574: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var pieCalc = __webpack_require__2(32354);
	            function calc(gd, trace) {
	              return pieCalc.calc(gd, trace);
	            }
	            function crossTraceCalc(gd) {
	              pieCalc.crossTraceCalc(gd, {
	                type: "funnelarea"
	              });
	            }
	            module2.exports = {
	              calc,
	              crossTraceCalc
	            };
	          }
	        ),
	        /***/
	        86282: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(86807);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleText = __webpack_require__2(90769).handleText;
	            var handleLabelsAndValues = __webpack_require__2(37434).handleLabelsAndValues;
	            var handleMarkerDefaults = __webpack_require__2(37434).handleMarkerDefaults;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var labels = coerce("labels");
	              var values = coerce("values");
	              var res = handleLabelsAndValues(labels, values);
	              var len = res.len;
	              traceOut._hasLabels = res.hasLabels;
	              traceOut._hasValues = res.hasValues;
	              if (!traceOut._hasLabels && traceOut._hasValues) {
	                coerce("label0");
	                coerce("dlabel");
	              }
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              handleMarkerDefaults(traceIn, traceOut, layout, coerce);
	              coerce("scalegroup");
	              var textData = coerce("text");
	              var textTemplate = coerce("texttemplate");
	              var textInfo;
	              if (!textTemplate) textInfo = coerce("textinfo", Array.isArray(textData) ? "text+percent" : "percent");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              if (textTemplate || textInfo && textInfo !== "none") {
	                var textposition = coerce("textposition");
	                handleText(traceIn, traceOut, layout, coerce, textposition, {
	                  moduleHasSelected: false,
	                  moduleHasUnselected: false,
	                  moduleHasConstrain: false,
	                  moduleHasCliponaxis: false,
	                  moduleHasTextangle: false,
	                  moduleHasInsideanchor: false
	                });
	              }
	              handleDomainDefaults(traceOut, layout, coerce);
	              var title = coerce("title.text");
	              if (title) {
	                coerce("title.position");
	                Lib.coerceFont(coerce, "title.font", layout.font);
	              }
	              coerce("aspectratio");
	              coerce("baseratio");
	            };
	          }
	        ),
	        /***/
	        10421: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "funnelarea",
	              basePlotModule: __webpack_require__2(6452),
	              categories: ["pie-like", "funnelarea", "showLegend"],
	              attributes: __webpack_require__2(86807),
	              layoutAttributes: __webpack_require__2(80097),
	              supplyDefaults: __webpack_require__2(86282),
	              supplyLayoutDefaults: __webpack_require__2(57402),
	              calc: __webpack_require__2(89574).calc,
	              crossTraceCalc: __webpack_require__2(89574).crossTraceCalc,
	              plot: __webpack_require__2(79187),
	              style: __webpack_require__2(71858),
	              styleOne: __webpack_require__2(63463),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        80097: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hiddenlabels = __webpack_require__2(92774).hiddenlabels;
	            module2.exports = {
	              hiddenlabels,
	              funnelareacolorway: {
	                valType: "colorlist",
	                editType: "calc"
	              },
	              extendfunnelareacolors: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        57402: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(80097);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              coerce("hiddenlabels");
	              coerce("funnelareacolorway", layoutOut.colorway);
	              coerce("extendfunnelareacolors");
	            };
	          }
	        ),
	        /***/
	        79187: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var strScale = Lib.strScale;
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var barPlot = __webpack_require__2(17295);
	            var toMoveInsideBar = barPlot.toMoveInsideBar;
	            var uniformText = __webpack_require__2(72597);
	            var recordMinTextSize = uniformText.recordMinTextSize;
	            var clearMinTextSize = uniformText.clearMinTextSize;
	            var pieHelpers = __webpack_require__2(53581);
	            var piePlot = __webpack_require__2(14575);
	            var attachFxHandlers = piePlot.attachFxHandlers;
	            var determineInsideTextFont = piePlot.determineInsideTextFont;
	            var layoutAreas = piePlot.layoutAreas;
	            var prerenderTitles = piePlot.prerenderTitles;
	            var positionTitleOutside = piePlot.positionTitleOutside;
	            var formatSliceLabel = piePlot.formatSliceLabel;
	            module2.exports = function plot(gd, cdModule) {
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              clearMinTextSize("funnelarea", fullLayout);
	              prerenderTitles(cdModule, gd);
	              layoutAreas(cdModule, fullLayout._size);
	              Lib.makeTraceGroups(fullLayout._funnelarealayer, cdModule, "trace").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                setCoords(cd);
	                plotGroup.each(function() {
	                  var slices = d3.select(this).selectAll("g.slice").data(cd);
	                  slices.enter().append("g").classed("slice", true);
	                  slices.exit().remove();
	                  slices.each(function(pt, i) {
	                    if (pt.hidden) {
	                      d3.select(this).selectAll("path,g").remove();
	                      return;
	                    }
	                    pt.pointNumber = pt.i;
	                    pt.curveNumber = trace.index;
	                    var cx = cd0.cx;
	                    var cy = cd0.cy;
	                    var sliceTop = d3.select(this);
	                    var slicePath = sliceTop.selectAll("path.surface").data([pt]);
	                    slicePath.enter().append("path").classed("surface", true).style({
	                      "pointer-events": isStatic ? "none" : "all"
	                    });
	                    sliceTop.call(attachFxHandlers, gd, cd);
	                    var shape = "M" + (cx + pt.TR[0]) + "," + (cy + pt.TR[1]) + line(pt.TR, pt.BR) + line(pt.BR, pt.BL) + line(pt.BL, pt.TL) + "Z";
	                    slicePath.attr("d", shape);
	                    formatSliceLabel(gd, pt, cd0);
	                    var textPosition = pieHelpers.castOption(trace.textposition, pt.pts);
	                    var sliceTextGroup = sliceTop.selectAll("g.slicetext").data(pt.text && textPosition !== "none" ? [0] : []);
	                    sliceTextGroup.enter().append("g").classed("slicetext", true);
	                    sliceTextGroup.exit().remove();
	                    sliceTextGroup.each(function() {
	                      var sliceText = Lib.ensureSingle(d3.select(this), "text", "", function(s) {
	                        s.attr("data-notex", 1);
	                      });
	                      var font = Lib.ensureUniformFontSize(gd, determineInsideTextFont(trace, pt, fullLayout.font));
	                      sliceText.text(pt.text).attr({
	                        class: "slicetext",
	                        transform: "",
	                        "text-anchor": "middle"
	                      }).call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
	                      var textBB = Drawing.bBox(sliceText.node());
	                      var transform;
	                      var x0, x1;
	                      var y0 = Math.min(pt.BL[1], pt.BR[1]) + cy;
	                      var y1 = Math.max(pt.TL[1], pt.TR[1]) + cy;
	                      x0 = Math.max(pt.TL[0], pt.BL[0]) + cx;
	                      x1 = Math.min(pt.TR[0], pt.BR[0]) + cx;
	                      transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
	                        isHorizontal: true,
	                        constrained: true,
	                        angle: 0,
	                        anchor: "middle"
	                      });
	                      transform.fontSize = font.size;
	                      recordMinTextSize(trace.type, transform, fullLayout);
	                      cd[i].transform = transform;
	                      Lib.setTransormAndDisplay(sliceText, transform);
	                    });
	                  });
	                  var titleTextGroup = d3.select(this).selectAll("g.titletext").data(trace.title.text ? [0] : []);
	                  titleTextGroup.enter().append("g").classed("titletext", true);
	                  titleTextGroup.exit().remove();
	                  titleTextGroup.each(function() {
	                    var titleText = Lib.ensureSingle(d3.select(this), "text", "", function(s) {
	                      s.attr("data-notex", 1);
	                    });
	                    var txt = trace.title.text;
	                    if (trace._meta) {
	                      txt = Lib.templateString(txt, trace._meta);
	                    }
	                    titleText.text(txt).attr({
	                      class: "titletext",
	                      transform: "",
	                      "text-anchor": "middle"
	                    }).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
	                    var transform = positionTitleOutside(cd0, fullLayout._size);
	                    titleText.attr("transform", strTranslate(transform.x, transform.y) + strScale(Math.min(1, transform.scale)) + strTranslate(transform.tx, transform.ty));
	                  });
	                });
	              });
	            };
	            function line(a, b) {
	              var dx = b[0] - a[0];
	              var dy = b[1] - a[1];
	              return "l" + dx + "," + dy;
	            }
	            function getBetween(a, b) {
	              return [0.5 * (a[0] + b[0]), 0.5 * (a[1] + b[1])];
	            }
	            function setCoords(cd) {
	              if (!cd.length) return;
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var aspectratio = trace.aspectratio;
	              var h = trace.baseratio;
	              if (h > 0.999) h = 0.999;
	              var h2 = Math.pow(h, 2);
	              var v1 = cd0.vTotal;
	              var v0 = v1 * h2 / (1 - h2);
	              var totalValues = v1;
	              var sumSteps = v0 / v1;
	              function calcPos() {
	                var q = Math.sqrt(sumSteps);
	                return {
	                  x: q,
	                  y: -q
	                };
	              }
	              function getPoint() {
	                var pos = calcPos();
	                return [pos.x, pos.y];
	              }
	              var p;
	              var allPoints = [];
	              allPoints.push(getPoint());
	              var i, cdi;
	              for (i = cd.length - 1; i > -1; i--) {
	                cdi = cd[i];
	                if (cdi.hidden) continue;
	                var step = cdi.v / totalValues;
	                sumSteps += step;
	                allPoints.push(getPoint());
	              }
	              var minY = Infinity;
	              var maxY = -Infinity;
	              for (i = 0; i < allPoints.length; i++) {
	                p = allPoints[i];
	                minY = Math.min(minY, p[1]);
	                maxY = Math.max(maxY, p[1]);
	              }
	              for (i = 0; i < allPoints.length; i++) {
	                allPoints[i][1] -= (maxY + minY) / 2;
	              }
	              var lastX = allPoints[allPoints.length - 1][0];
	              var r = cd0.r;
	              var rY = (maxY - minY) / 2;
	              var scaleX = r / lastX;
	              var scaleY = r / rY * aspectratio;
	              cd0.r = scaleY * rY;
	              for (i = 0; i < allPoints.length; i++) {
	                allPoints[i][0] *= scaleX;
	                allPoints[i][1] *= scaleY;
	              }
	              p = allPoints[0];
	              var prevLeft = [-p[0], p[1]];
	              var prevRight = [p[0], p[1]];
	              var n = 0;
	              for (i = cd.length - 1; i > -1; i--) {
	                cdi = cd[i];
	                if (cdi.hidden) continue;
	                n += 1;
	                var x = allPoints[n][0];
	                var y = allPoints[n][1];
	                cdi.TL = [-x, y];
	                cdi.TR = [x, y];
	                cdi.BL = prevLeft;
	                cdi.BR = prevRight;
	                cdi.pxmid = getBetween(cdi.TR, cdi.BR);
	                prevLeft = cdi.TL;
	                prevRight = cdi.TR;
	              }
	            }
	          }
	        ),
	        /***/
	        71858: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var styleOne = __webpack_require__2(63463);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            module2.exports = function style(gd) {
	              var s = gd._fullLayout._funnelarealayer.selectAll(".trace");
	              resizeText(gd, s, "funnelarea");
	              s.each(function(cd) {
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var traceSelection = d3.select(this);
	                traceSelection.style({
	                  opacity: trace.opacity
	                });
	                traceSelection.selectAll("path.surface").each(function(pt) {
	                  d3.select(this).call(styleOne, pt, trace, gd);
	                });
	              });
	            };
	          }
	        ),
	        /***/
	        21606: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterAttrs = __webpack_require__2(82196);
	            var baseAttrs = __webpack_require__2(9012);
	            var fontAttrs = __webpack_require__2(41940);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = extendFlat({
	              z: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              x: extendFlat({}, scatterAttrs.x, {
	                impliedEdits: {
	                  xtype: "array"
	                }
	              }),
	              x0: extendFlat({}, scatterAttrs.x0, {
	                impliedEdits: {
	                  xtype: "scaled"
	                }
	              }),
	              dx: extendFlat({}, scatterAttrs.dx, {
	                impliedEdits: {
	                  xtype: "scaled"
	                }
	              }),
	              y: extendFlat({}, scatterAttrs.y, {
	                impliedEdits: {
	                  ytype: "array"
	                }
	              }),
	              y0: extendFlat({}, scatterAttrs.y0, {
	                impliedEdits: {
	                  ytype: "scaled"
	                }
	              }),
	              dy: extendFlat({}, scatterAttrs.dy, {
	                impliedEdits: {
	                  ytype: "scaled"
	                }
	              }),
	              xperiod: extendFlat({}, scatterAttrs.xperiod, {
	                impliedEdits: {
	                  xtype: "scaled"
	                }
	              }),
	              yperiod: extendFlat({}, scatterAttrs.yperiod, {
	                impliedEdits: {
	                  ytype: "scaled"
	                }
	              }),
	              xperiod0: extendFlat({}, scatterAttrs.xperiod0, {
	                impliedEdits: {
	                  xtype: "scaled"
	                }
	              }),
	              yperiod0: extendFlat({}, scatterAttrs.yperiod0, {
	                impliedEdits: {
	                  ytype: "scaled"
	                }
	              }),
	              xperiodalignment: extendFlat({}, scatterAttrs.xperiodalignment, {
	                impliedEdits: {
	                  xtype: "scaled"
	                }
	              }),
	              yperiodalignment: extendFlat({}, scatterAttrs.yperiodalignment, {
	                impliedEdits: {
	                  ytype: "scaled"
	                }
	              }),
	              text: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              hovertext: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              transpose: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              xtype: {
	                valType: "enumerated",
	                values: ["array", "scaled"],
	                editType: "calc+clearAxisTypes"
	              },
	              ytype: {
	                valType: "enumerated",
	                values: ["array", "scaled"],
	                editType: "calc+clearAxisTypes"
	              },
	              zsmooth: {
	                valType: "enumerated",
	                values: ["fast", "best", false],
	                dflt: false,
	                editType: "calc"
	              },
	              hoverongaps: {
	                valType: "boolean",
	                dflt: true,
	                editType: "none"
	              },
	              connectgaps: {
	                valType: "boolean",
	                editType: "calc"
	              },
	              xgap: {
	                valType: "number",
	                dflt: 0,
	                min: 0,
	                editType: "plot"
	              },
	              ygap: {
	                valType: "number",
	                dflt: 0,
	                min: 0,
	                editType: "plot"
	              },
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z", 1),
	              hovertemplate: hovertemplateAttrs(),
	              texttemplate: texttemplateAttrs({
	                arrayOk: false,
	                editType: "plot"
	              }, {
	                keys: ["x", "y", "z", "text"]
	              }),
	              textfont: fontAttrs({
	                editType: "plot",
	                autoSize: true,
	                autoColor: true,
	                colorEditType: "style"
	              }),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }, {
	              transforms: undefined
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              autoColorDflt: false
	            }));
	          }
	        ),
	        /***/
	        90757: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var histogram2dCalc = __webpack_require__2(17562);
	            var colorscaleCalc = __webpack_require__2(78803);
	            var convertColumnData = __webpack_require__2(68296);
	            var clean2dArray = __webpack_require__2(4742);
	            var interp2d = __webpack_require__2(824);
	            var findEmpties = __webpack_require__2(43907);
	            var makeBoundArray = __webpack_require__2(70769);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis || "x");
	              var ya = Axes.getFromId(gd, trace.yaxis || "y");
	              var isContour = Registry.traceIs(trace, "contour");
	              var isHist = Registry.traceIs(trace, "histogram");
	              var isGL2D = Registry.traceIs(trace, "gl2d");
	              var zsmooth = isContour ? "best" : trace.zsmooth;
	              var x, x0, dx, origX;
	              var y, y0, dy, origY;
	              var z, i, binned;
	              xa._minDtick = 0;
	              ya._minDtick = 0;
	              if (isHist) {
	                binned = histogram2dCalc(gd, trace);
	                origX = binned.orig_x;
	                x = binned.x;
	                x0 = binned.x0;
	                dx = binned.dx;
	                origY = binned.orig_y;
	                y = binned.y;
	                y0 = binned.y0;
	                dy = binned.dy;
	                z = binned.z;
	              } else {
	                var zIn = trace.z;
	                if (Lib.isArray1D(zIn)) {
	                  convertColumnData(trace, xa, ya, "x", "y", ["z"]);
	                  x = trace._x;
	                  y = trace._y;
	                  zIn = trace._z;
	                } else {
	                  origX = trace.x ? xa.makeCalcdata(trace, "x") : [];
	                  origY = trace.y ? ya.makeCalcdata(trace, "y") : [];
	                  x = alignPeriod(trace, xa, "x", origX).vals;
	                  y = alignPeriod(trace, ya, "y", origY).vals;
	                  trace._x = x;
	                  trace._y = y;
	                }
	                x0 = trace.x0;
	                dx = trace.dx;
	                y0 = trace.y0;
	                dy = trace.dy;
	                z = clean2dArray(zIn, trace, xa, ya);
	              }
	              if (xa.rangebreaks || ya.rangebreaks) {
	                z = dropZonBreaks(x, y, z);
	                if (!isHist) {
	                  x = skipBreaks(x);
	                  y = skipBreaks(y);
	                  trace._x = x;
	                  trace._y = y;
	                }
	              }
	              if (!isHist && (isContour || trace.connectgaps)) {
	                trace._emptypoints = findEmpties(z);
	                interp2d(z, trace._emptypoints);
	              }
	              function noZsmooth(msg) {
	                zsmooth = trace._input.zsmooth = trace.zsmooth = false;
	                Lib.warn('cannot use zsmooth: "fast": ' + msg);
	              }
	              function scaleIsLinear(s) {
	                if (s.length > 1) {
	                  var avgdx = (s[s.length - 1] - s[0]) / (s.length - 1);
	                  var maxErrX = Math.abs(avgdx / 100);
	                  for (i = 0; i < s.length - 1; i++) {
	                    if (Math.abs(s[i + 1] - s[i] - avgdx) > maxErrX) {
	                      return false;
	                    }
	                  }
	                }
	                return true;
	              }
	              trace._islinear = false;
	              if (xa.type === "log" || ya.type === "log") {
	                if (zsmooth === "fast") {
	                  noZsmooth("log axis found");
	                }
	              } else if (!scaleIsLinear(x)) {
	                if (zsmooth === "fast") noZsmooth("x scale is not linear");
	              } else if (!scaleIsLinear(y)) {
	                if (zsmooth === "fast") noZsmooth("y scale is not linear");
	              } else {
	                trace._islinear = true;
	              }
	              var xlen = Lib.maxRowLength(z);
	              var xIn = trace.xtype === "scaled" ? "" : x;
	              var xArray = makeBoundArray(trace, xIn, x0, dx, xlen, xa);
	              var yIn = trace.ytype === "scaled" ? "" : y;
	              var yArray = makeBoundArray(trace, yIn, y0, dy, z.length, ya);
	              if (!isGL2D) {
	                trace._extremes[xa._id] = Axes.findExtremes(xa, xArray);
	                trace._extremes[ya._id] = Axes.findExtremes(ya, yArray);
	              }
	              var cd0 = {
	                x: xArray,
	                y: yArray,
	                z,
	                text: trace._text || trace.text,
	                hovertext: trace._hovertext || trace.hovertext
	              };
	              if (trace.xperiodalignment && origX) {
	                cd0.orig_x = origX;
	              }
	              if (trace.yperiodalignment && origY) {
	                cd0.orig_y = origY;
	              }
	              if (xIn && xIn.length === xArray.length - 1) cd0.xCenter = xIn;
	              if (yIn && yIn.length === yArray.length - 1) cd0.yCenter = yIn;
	              if (isHist) {
	                cd0.xRanges = binned.xRanges;
	                cd0.yRanges = binned.yRanges;
	                cd0.pts = binned.pts;
	              }
	              if (!isContour) {
	                colorscaleCalc(gd, trace, {
	                  vals: z,
	                  cLetter: "z"
	                });
	              }
	              if (isContour && trace.contours && trace.contours.coloring === "heatmap") {
	                var dummyTrace = {
	                  type: trace.type === "contour" ? "heatmap" : "histogram2d",
	                  xcalendar: trace.xcalendar,
	                  ycalendar: trace.ycalendar
	                };
	                cd0.xfill = makeBoundArray(dummyTrace, xIn, x0, dx, xlen, xa);
	                cd0.yfill = makeBoundArray(dummyTrace, yIn, y0, dy, z.length, ya);
	              }
	              return [cd0];
	            };
	            function skipBreaks(a) {
	              var b = [];
	              var len = a.length;
	              for (var i = 0; i < len; i++) {
	                var v = a[i];
	                if (v !== BADNUM) b.push(v);
	              }
	              return b;
	            }
	            function dropZonBreaks(x, y, z) {
	              var newZ = [];
	              var k = -1;
	              for (var i = 0; i < z.length; i++) {
	                if (y[i] === BADNUM) continue;
	                k++;
	                newZ[k] = [];
	                for (var j = 0; j < z[i].length; j++) {
	                  if (x[j] === BADNUM) continue;
	                  newZ[k].push(z[i][j]);
	                }
	              }
	              return newZ;
	            }
	          }
	        ),
	        /***/
	        4742: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function clean2dArray(zOld, trace, xa, ya) {
	              var rowlen, collen, getCollen, old2new, i, j;
	              function cleanZvalue(v) {
	                if (!isNumeric(v)) return undefined;
	                return +v;
	              }
	              if (trace && trace.transpose) {
	                rowlen = 0;
	                for (i = 0; i < zOld.length; i++) rowlen = Math.max(rowlen, zOld[i].length);
	                if (rowlen === 0) return false;
	                getCollen = function(zOld2) {
	                  return zOld2.length;
	                };
	                old2new = function(zOld2, i2, j2) {
	                  return (zOld2[j2] || [])[i2];
	                };
	              } else {
	                rowlen = zOld.length;
	                getCollen = function(zOld2, i2) {
	                  return zOld2[i2].length;
	                };
	                old2new = function(zOld2, i2, j2) {
	                  return (zOld2[i2] || [])[j2];
	                };
	              }
	              var padOld2new = function(zOld2, i2, j2) {
	                if (i2 === BADNUM || j2 === BADNUM) return BADNUM;
	                return old2new(zOld2, i2, j2);
	              };
	              function axisMapping(ax) {
	                if (trace && trace.type !== "carpet" && trace.type !== "contourcarpet" && ax && ax.type === "category" && trace["_" + ax._id.charAt(0)].length) {
	                  var axLetter = ax._id.charAt(0);
	                  var axMapping = {};
	                  var traceCategories = trace["_" + axLetter + "CategoryMap"] || trace[axLetter];
	                  for (i = 0; i < traceCategories.length; i++) {
	                    axMapping[traceCategories[i]] = i;
	                  }
	                  return function(i2) {
	                    var ind = axMapping[ax._categories[i2]];
	                    return ind + 1 ? ind : BADNUM;
	                  };
	                } else {
	                  return Lib.identity;
	                }
	              }
	              var xMap = axisMapping(xa);
	              var yMap = axisMapping(ya);
	              if (ya && ya.type === "category") rowlen = ya._categories.length;
	              var zNew = new Array(rowlen);
	              for (i = 0; i < rowlen; i++) {
	                if (xa && xa.type === "category") {
	                  collen = xa._categories.length;
	                } else {
	                  collen = getCollen(zOld, i);
	                }
	                zNew[i] = new Array(collen);
	                for (j = 0; j < collen; j++) zNew[i][j] = cleanZvalue(padOld2new(zOld, yMap(i), xMap(j)));
	              }
	              return zNew;
	            };
	          }
	        ),
	        /***/
	        61243: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              min: "zmin",
	              max: "zmax"
	            };
	          }
	        ),
	        /***/
	        68296: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var alignPeriod = __webpack_require__2(42973);
	            module2.exports = function convertColumnData(trace, ax1, ax2, var1Name, var2Name, arrayVarNames) {
	              var colLen = trace._length;
	              var col1 = ax1.makeCalcdata(trace, var1Name);
	              var col2 = ax2.makeCalcdata(trace, var2Name);
	              col1 = alignPeriod(trace, ax1, var1Name, col1).vals;
	              col2 = alignPeriod(trace, ax2, var2Name, col2).vals;
	              var textCol = trace.text;
	              var hasColumnText = textCol !== undefined && Lib.isArray1D(textCol);
	              var hoverTextCol = trace.hovertext;
	              var hasColumnHoverText = hoverTextCol !== undefined && Lib.isArray1D(hoverTextCol);
	              var i, j;
	              var col1dv = Lib.distinctVals(col1);
	              var col1vals = col1dv.vals;
	              var col2dv = Lib.distinctVals(col2);
	              var col2vals = col2dv.vals;
	              var newArrays = [];
	              var text;
	              var hovertext;
	              var nI = col2vals.length;
	              var nJ = col1vals.length;
	              for (i = 0; i < arrayVarNames.length; i++) {
	                newArrays[i] = Lib.init2dArray(nI, nJ);
	              }
	              if (hasColumnText) {
	                text = Lib.init2dArray(nI, nJ);
	              }
	              if (hasColumnHoverText) {
	                hovertext = Lib.init2dArray(nI, nJ);
	              }
	              var after2before = Lib.init2dArray(nI, nJ);
	              for (i = 0; i < colLen; i++) {
	                if (col1[i] !== BADNUM && col2[i] !== BADNUM) {
	                  var i1 = Lib.findBin(col1[i] + col1dv.minDiff / 2, col1vals);
	                  var i2 = Lib.findBin(col2[i] + col2dv.minDiff / 2, col2vals);
	                  for (j = 0; j < arrayVarNames.length; j++) {
	                    var arrayVarName = arrayVarNames[j];
	                    var arrayVar = trace[arrayVarName];
	                    var newArray = newArrays[j];
	                    newArray[i2][i1] = arrayVar[i];
	                    after2before[i2][i1] = i;
	                  }
	                  if (hasColumnText) text[i2][i1] = textCol[i];
	                  if (hasColumnHoverText) hovertext[i2][i1] = hoverTextCol[i];
	                }
	              }
	              trace["_" + var1Name] = col1vals;
	              trace["_" + var2Name] = col2vals;
	              for (j = 0; j < arrayVarNames.length; j++) {
	                trace["_" + arrayVarNames[j]] = newArrays[j];
	              }
	              if (hasColumnText) trace._text = text;
	              if (hasColumnHoverText) trace._hovertext = hovertext;
	              if (ax1 && ax1.type === "category") {
	                trace["_" + var1Name + "CategoryMap"] = col1vals.map(function(v) {
	                  return ax1._categories[v];
	                });
	              }
	              if (ax2 && ax2.type === "category") {
	                trace["_" + var2Name + "CategoryMap"] = col2vals.map(function(v) {
	                  return ax2._categories[v];
	                });
	              }
	              trace._after2before = after2before;
	            };
	          }
	        ),
	        /***/
	        76382: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleXYZDefaults = __webpack_require__2(67684);
	            var handleHeatmapLabelDefaults = __webpack_require__2(58623);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var handleStyleDefaults = __webpack_require__2(49901);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(21606);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	              if (!validData) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              handleHeatmapLabelDefaults(coerce, layout);
	              handleStyleDefaults(traceIn, traceOut, coerce, layout);
	              coerce("hoverongaps");
	              coerce("connectgaps", Lib.isArray1D(traceOut.z) && traceOut.zsmooth !== false);
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "z"
	              });
	            };
	          }
	        ),
	        /***/
	        43907: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var maxRowLength = __webpack_require__2(71828).maxRowLength;
	            module2.exports = function findEmpties(z) {
	              var empties = [];
	              var neighborHash = {};
	              var noNeighborList = [];
	              var nextRow = z[0];
	              var row = [];
	              var blank = [0, 0, 0];
	              var rowLength = maxRowLength(z);
	              var prevRow;
	              var i;
	              var j;
	              var thisPt;
	              var p;
	              var neighborCount;
	              var newNeighborHash;
	              var foundNewNeighbors;
	              for (i = 0; i < z.length; i++) {
	                prevRow = row;
	                row = nextRow;
	                nextRow = z[i + 1] || [];
	                for (j = 0; j < rowLength; j++) {
	                  if (row[j] === undefined) {
	                    neighborCount = (row[j - 1] !== undefined ? 1 : 0) + (row[j + 1] !== undefined ? 1 : 0) + (prevRow[j] !== undefined ? 1 : 0) + (nextRow[j] !== undefined ? 1 : 0);
	                    if (neighborCount) {
	                      if (i === 0) neighborCount++;
	                      if (j === 0) neighborCount++;
	                      if (i === z.length - 1) neighborCount++;
	                      if (j === row.length - 1) neighborCount++;
	                      if (neighborCount < 4) {
	                        neighborHash[[i, j]] = [i, j, neighborCount];
	                      }
	                      empties.push([i, j, neighborCount]);
	                    } else noNeighborList.push([i, j]);
	                  }
	                }
	              }
	              while (noNeighborList.length) {
	                newNeighborHash = {};
	                foundNewNeighbors = false;
	                for (p = noNeighborList.length - 1; p >= 0; p--) {
	                  thisPt = noNeighborList[p];
	                  i = thisPt[0];
	                  j = thisPt[1];
	                  neighborCount = ((neighborHash[[i - 1, j]] || blank)[2] + (neighborHash[[i + 1, j]] || blank)[2] + (neighborHash[[i, j - 1]] || blank)[2] + (neighborHash[[i, j + 1]] || blank)[2]) / 20;
	                  if (neighborCount) {
	                    newNeighborHash[thisPt] = [i, j, neighborCount];
	                    noNeighborList.splice(p, 1);
	                    foundNewNeighbors = true;
	                  }
	                }
	                if (!foundNewNeighbors) {
	                  throw "findEmpties iterated with no new neighbors";
	                }
	                for (thisPt in newNeighborHash) {
	                  neighborHash[thisPt] = newNeighborHash[thisPt];
	                  empties.push(newNeighborHash[thisPt]);
	                }
	              }
	              return empties.sort(function(a, b) {
	                return b[2] - a[2];
	              });
	            };
	          }
	        ),
	        /***/
	        46248: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Fx = __webpack_require__2(30211);
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              if (!opts) opts = {};
	              var isContour = opts.isContour;
	              var cd0 = pointData.cd[0];
	              var trace = cd0.trace;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var x = cd0.x;
	              var y = cd0.y;
	              var z = cd0.z;
	              var xc = cd0.xCenter;
	              var yc = cd0.yCenter;
	              var zmask = cd0.zmask;
	              var zhoverformat = trace.zhoverformat;
	              var x2 = x;
	              var y2 = y;
	              var xl, yl, nx, ny;
	              if (pointData.index !== false) {
	                try {
	                  nx = Math.round(pointData.index[1]);
	                  ny = Math.round(pointData.index[0]);
	                } catch (e) {
	                  Lib.error("Error hovering on heatmap, pointNumber must be [row,col], found:", pointData.index);
	                  return;
	                }
	                if (nx < 0 || nx >= z[0].length || ny < 0 || ny > z.length) {
	                  return;
	                }
	              } else if (Fx.inbox(xval - x[0], xval - x[x.length - 1], 0) > 0 || Fx.inbox(yval - y[0], yval - y[y.length - 1], 0) > 0) {
	                return;
	              } else {
	                if (isContour) {
	                  var i2;
	                  x2 = [2 * x[0] - x[1]];
	                  for (i2 = 1; i2 < x.length; i2++) {
	                    x2.push((x[i2] + x[i2 - 1]) / 2);
	                  }
	                  x2.push([2 * x[x.length - 1] - x[x.length - 2]]);
	                  y2 = [2 * y[0] - y[1]];
	                  for (i2 = 1; i2 < y.length; i2++) {
	                    y2.push((y[i2] + y[i2 - 1]) / 2);
	                  }
	                  y2.push([2 * y[y.length - 1] - y[y.length - 2]]);
	                }
	                nx = Math.max(0, Math.min(x2.length - 2, Lib.findBin(xval, x2)));
	                ny = Math.max(0, Math.min(y2.length - 2, Lib.findBin(yval, y2)));
	              }
	              var x0 = xa.c2p(x[nx]);
	              var x1 = xa.c2p(x[nx + 1]);
	              var y0 = ya.c2p(y[ny]);
	              var y1 = ya.c2p(y[ny + 1]);
	              var _x, _y;
	              if (isContour) {
	                _x = cd0.orig_x || x;
	                _y = cd0.orig_y || y;
	                x1 = x0;
	                xl = _x[nx];
	                y1 = y0;
	                yl = _y[ny];
	              } else {
	                _x = cd0.orig_x || xc || x;
	                _y = cd0.orig_y || yc || y;
	                xl = xc ? _x[nx] : (_x[nx] + _x[nx + 1]) / 2;
	                yl = yc ? _y[ny] : (_y[ny] + _y[ny + 1]) / 2;
	                if (xa && xa.type === "category") xl = x[nx];
	                if (ya && ya.type === "category") yl = y[ny];
	                if (trace.zsmooth) {
	                  x0 = x1 = xa.c2p(xl);
	                  y0 = y1 = ya.c2p(yl);
	                }
	              }
	              var zVal = z[ny][nx];
	              if (zmask && !zmask[ny][nx]) zVal = undefined;
	              if (zVal === undefined && !trace.hoverongaps) return;
	              var text;
	              if (Array.isArray(cd0.hovertext) && Array.isArray(cd0.hovertext[ny])) {
	                text = cd0.hovertext[ny][nx];
	              } else if (Array.isArray(cd0.text) && Array.isArray(cd0.text[ny])) {
	                text = cd0.text[ny][nx];
	              }
	              var cOpts = extractOpts(trace);
	              var dummyAx = {
	                type: "linear",
	                range: [cOpts.min, cOpts.max],
	                hoverformat: zhoverformat,
	                _separators: xa._separators,
	                _numFormat: xa._numFormat
	              };
	              var zLabel = Axes.tickText(dummyAx, zVal, "hover").text;
	              return [Lib.extendFlat(pointData, {
	                index: trace._after2before ? trace._after2before[ny][nx] : [ny, nx],
	                // never let a 2D override 1D type as closest point
	                distance: pointData.maxHoverDistance,
	                spikeDistance: pointData.maxSpikeDistance,
	                x0,
	                x1,
	                y0,
	                y1,
	                xLabelVal: xl,
	                yLabelVal: yl,
	                zLabelVal: zVal,
	                zLabel,
	                text
	              })];
	            };
	          }
	        ),
	        /***/
	        92165: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(21606),
	              supplyDefaults: __webpack_require__2(76382),
	              calc: __webpack_require__2(90757),
	              plot: __webpack_require__2(50347),
	              colorbar: __webpack_require__2(61243),
	              style: __webpack_require__2(70035),
	              hoverPoints: __webpack_require__2(46248),
	              moduleType: "trace",
	              name: "heatmap",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "2dMap", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        824: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var INTERPTHRESHOLD = 0.01;
	            var NEIGHBORSHIFTS = [[-1, 0], [1, 0], [0, -1], [0, 1]];
	            function correctionOvershoot(maxFractionalChange) {
	              return 0.5 - 0.25 * Math.min(1, maxFractionalChange * 0.5);
	            }
	            module2.exports = function interp2d(z, emptyPoints) {
	              var maxFractionalChange = 1;
	              var i;
	              iterateInterp2d(z, emptyPoints);
	              for (i = 0; i < emptyPoints.length; i++) {
	                if (emptyPoints[i][2] < 4) break;
	              }
	              emptyPoints = emptyPoints.slice(i);
	              for (i = 0; i < 100 && maxFractionalChange > INTERPTHRESHOLD; i++) {
	                maxFractionalChange = iterateInterp2d(z, emptyPoints, correctionOvershoot(maxFractionalChange));
	              }
	              if (maxFractionalChange > INTERPTHRESHOLD) {
	                Lib.log("interp2d didn't converge quickly", maxFractionalChange);
	              }
	              return z;
	            };
	            function iterateInterp2d(z, emptyPoints, overshoot) {
	              var maxFractionalChange = 0;
	              var thisPt;
	              var i;
	              var j;
	              var p;
	              var q;
	              var neighborShift;
	              var neighborRow;
	              var neighborVal;
	              var neighborCount;
	              var neighborSum;
	              var initialVal;
	              var minNeighbor;
	              var maxNeighbor;
	              for (p = 0; p < emptyPoints.length; p++) {
	                thisPt = emptyPoints[p];
	                i = thisPt[0];
	                j = thisPt[1];
	                initialVal = z[i][j];
	                neighborSum = 0;
	                neighborCount = 0;
	                for (q = 0; q < 4; q++) {
	                  neighborShift = NEIGHBORSHIFTS[q];
	                  neighborRow = z[i + neighborShift[0]];
	                  if (!neighborRow) continue;
	                  neighborVal = neighborRow[j + neighborShift[1]];
	                  if (neighborVal !== undefined) {
	                    if (neighborSum === 0) {
	                      minNeighbor = maxNeighbor = neighborVal;
	                    } else {
	                      minNeighbor = Math.min(minNeighbor, neighborVal);
	                      maxNeighbor = Math.max(maxNeighbor, neighborVal);
	                    }
	                    neighborCount++;
	                    neighborSum += neighborVal;
	                  }
	                }
	                if (neighborCount === 0) {
	                  throw "iterateInterp2d order is wrong: no defined neighbors";
	                }
	                z[i][j] = neighborSum / neighborCount;
	                if (initialVal === undefined) {
	                  if (neighborCount < 4) maxFractionalChange = 1;
	                } else {
	                  z[i][j] = (1 + overshoot) * z[i][j] - overshoot * initialVal;
	                  if (maxNeighbor > minNeighbor) {
	                    maxFractionalChange = Math.max(maxFractionalChange, Math.abs(z[i][j] - initialVal) / (maxNeighbor - minNeighbor));
	                  }
	                }
	              }
	              return maxFractionalChange;
	            }
	          }
	        ),
	        /***/
	        58623: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function handleHeatmapLabelDefaults(coerce, layout) {
	              coerce("texttemplate");
	              var fontDflt = Lib.extendFlat({}, layout.font, {
	                color: "auto",
	                size: "auto"
	              });
	              Lib.coerceFont(coerce, "textfont", fontDflt);
	            };
	          }
	        ),
	        /***/
	        70769: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function makeBoundArray(trace, arrayIn, v0In, dvIn, numbricks, ax) {
	              var arrayOut = [];
	              var isContour = Registry.traceIs(trace, "contour");
	              var isHist = Registry.traceIs(trace, "histogram");
	              var isGL2D = Registry.traceIs(trace, "gl2d");
	              var v0;
	              var dv;
	              var i;
	              var isArrayOfTwoItemsOrMore = isArrayOrTypedArray(arrayIn) && arrayIn.length > 1;
	              if (isArrayOfTwoItemsOrMore && !isHist && ax.type !== "category") {
	                var len = arrayIn.length;
	                if (len <= numbricks) {
	                  if (isContour || isGL2D) arrayOut = arrayIn.slice(0, numbricks);
	                  else if (numbricks === 1) {
	                    arrayOut = [arrayIn[0] - 0.5, arrayIn[0] + 0.5];
	                  } else {
	                    arrayOut = [1.5 * arrayIn[0] - 0.5 * arrayIn[1]];
	                    for (i = 1; i < len; i++) {
	                      arrayOut.push((arrayIn[i - 1] + arrayIn[i]) * 0.5);
	                    }
	                    arrayOut.push(1.5 * arrayIn[len - 1] - 0.5 * arrayIn[len - 2]);
	                  }
	                  if (len < numbricks) {
	                    var lastPt = arrayOut[arrayOut.length - 1];
	                    var delta = lastPt - arrayOut[arrayOut.length - 2];
	                    for (i = len; i < numbricks; i++) {
	                      lastPt += delta;
	                      arrayOut.push(lastPt);
	                    }
	                  }
	                } else {
	                  return isContour ? arrayIn.slice(0, numbricks) : (
	                    // we must be strict for contours
	                    arrayIn.slice(0, numbricks + 1)
	                  );
	                }
	              } else {
	                var calendar = trace[ax._id.charAt(0) + "calendar"];
	                if (isHist) {
	                  v0 = ax.r2c(v0In, 0, calendar);
	                } else {
	                  if (isArrayOrTypedArray(arrayIn) && arrayIn.length === 1) {
	                    v0 = arrayIn[0];
	                  } else if (v0In === undefined) {
	                    v0 = 0;
	                  } else {
	                    var fn = ax.type === "log" ? ax.d2c : ax.r2c;
	                    v0 = fn(v0In, 0, calendar);
	                  }
	                }
	                dv = dvIn || 1;
	                for (i = isContour || isGL2D ? 0 : -0.5; i < numbricks; i++) {
	                  arrayOut.push(v0 + dv * i);
	                }
	              }
	              return arrayOut;
	            };
	          }
	        ),
	        /***/
	        50347: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var tinycolor = __webpack_require__2(84267);
	            var Registry = __webpack_require__2(73972);
	            var Drawing = __webpack_require__2(91424);
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var svgTextUtils = __webpack_require__2(63893);
	            var formatLabels = __webpack_require__2(8225);
	            var Color = __webpack_require__2(7901);
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            var makeColorScaleFuncFromTrace = __webpack_require__2(21081).makeColorScaleFuncFromTrace;
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var alignmentConstants = __webpack_require__2(18783);
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var supportsPixelatedImage = __webpack_require__2(3883);
	            var PIXELATED_IMAGE_STYLE = __webpack_require__2(32396).STYLE;
	            var labelClass = "heatmap-label";
	            function selectLabels(plotGroup) {
	              return plotGroup.selectAll("g." + labelClass);
	            }
	            function removeLabels(plotGroup) {
	              selectLabels(plotGroup).remove();
	            }
	            module2.exports = function(gd, plotinfo, cdheatmaps, heatmapLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(heatmapLayer, cdheatmaps, "hm").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var xGap = trace.xgap || 0;
	                var yGap = trace.ygap || 0;
	                var z = cd0.z;
	                var x = cd0.x;
	                var y = cd0.y;
	                var xc = cd0.xCenter;
	                var yc = cd0.yCenter;
	                var isContour = Registry.traceIs(trace, "contour");
	                var zsmooth = isContour ? "best" : trace.zsmooth;
	                var m = z.length;
	                var n = Lib.maxRowLength(z);
	                var xrev = false;
	                var yrev = false;
	                var left, right, temp, top, bottom, i, j, k;
	                i = 0;
	                while (left === undefined && i < x.length - 1) {
	                  left = xa.c2p(x[i]);
	                  i++;
	                }
	                i = x.length - 1;
	                while (right === undefined && i > 0) {
	                  right = xa.c2p(x[i]);
	                  i--;
	                }
	                if (right < left) {
	                  temp = right;
	                  right = left;
	                  left = temp;
	                  xrev = true;
	                }
	                i = 0;
	                while (top === undefined && i < y.length - 1) {
	                  top = ya.c2p(y[i]);
	                  i++;
	                }
	                i = y.length - 1;
	                while (bottom === undefined && i > 0) {
	                  bottom = ya.c2p(y[i]);
	                  i--;
	                }
	                if (bottom < top) {
	                  temp = top;
	                  top = bottom;
	                  bottom = temp;
	                  yrev = true;
	                }
	                if (isContour) {
	                  xc = x;
	                  yc = y;
	                  x = cd0.xfill;
	                  y = cd0.yfill;
	                }
	                var drawingMethod = "default";
	                if (zsmooth) {
	                  drawingMethod = zsmooth === "best" ? "smooth" : "fast";
	                } else if (trace._islinear && xGap === 0 && yGap === 0 && supportsPixelatedImage()) {
	                  drawingMethod = "fast";
	                }
	                if (drawingMethod !== "fast") {
	                  var extra = zsmooth === "best" ? 0 : 0.5;
	                  left = Math.max(-extra * xa._length, left);
	                  right = Math.min((1 + extra) * xa._length, right);
	                  top = Math.max(-extra * ya._length, top);
	                  bottom = Math.min((1 + extra) * ya._length, bottom);
	                }
	                var imageWidth = Math.round(right - left);
	                var imageHeight = Math.round(bottom - top);
	                var isOffScreen = left >= xa._length || right <= 0 || top >= ya._length || bottom <= 0;
	                if (isOffScreen) {
	                  var noImage = plotGroup.selectAll("image").data([]);
	                  noImage.exit().remove();
	                  removeLabels(plotGroup);
	                  return;
	                }
	                var canvasW, canvasH;
	                if (drawingMethod === "fast") {
	                  canvasW = n;
	                  canvasH = m;
	                } else {
	                  canvasW = imageWidth;
	                  canvasH = imageHeight;
	                }
	                var canvas = document.createElement("canvas");
	                canvas.width = canvasW;
	                canvas.height = canvasH;
	                var context = canvas.getContext("2d", {
	                  willReadFrequently: true
	                });
	                var sclFunc = makeColorScaleFuncFromTrace(trace, {
	                  noNumericCheck: true,
	                  returnArray: true
	                });
	                var xpx, ypx;
	                if (drawingMethod === "fast") {
	                  xpx = xrev ? function(index) {
	                    return n - 1 - index;
	                  } : Lib.identity;
	                  ypx = yrev ? function(index) {
	                    return m - 1 - index;
	                  } : Lib.identity;
	                } else {
	                  xpx = function(index) {
	                    return Lib.constrain(Math.round(xa.c2p(x[index]) - left), 0, imageWidth);
	                  };
	                  ypx = function(index) {
	                    return Lib.constrain(Math.round(ya.c2p(y[index]) - top), 0, imageHeight);
	                  };
	                }
	                var yi = ypx(0);
	                var yb = [yi, yi];
	                var xbi = xrev ? 0 : 1;
	                var ybi = yrev ? 0 : 1;
	                var pixcount = 0;
	                var rcount = 0;
	                var gcount = 0;
	                var bcount = 0;
	                var xb, xi, v, row, c;
	                function setColor(v2, pixsize) {
	                  if (v2 !== undefined) {
	                    var c2 = sclFunc(v2);
	                    c2[0] = Math.round(c2[0]);
	                    c2[1] = Math.round(c2[1]);
	                    c2[2] = Math.round(c2[2]);
	                    pixcount += pixsize;
	                    rcount += c2[0] * pixsize;
	                    gcount += c2[1] * pixsize;
	                    bcount += c2[2] * pixsize;
	                    return c2;
	                  }
	                  return [0, 0, 0, 0];
	                }
	                function interpColor(r02, r12, xinterp, yinterp2) {
	                  var z00 = r02[xinterp.bin0];
	                  if (z00 === undefined) return setColor(undefined, 1);
	                  var z01 = r02[xinterp.bin1];
	                  var z10 = r12[xinterp.bin0];
	                  var z11 = r12[xinterp.bin1];
	                  var dx2 = z01 - z00 || 0;
	                  var dy2 = z10 - z00 || 0;
	                  var dxy;
	                  if (z01 === undefined) {
	                    if (z11 === undefined) dxy = 0;
	                    else if (z10 === undefined) dxy = 2 * (z11 - z00);
	                    else dxy = (2 * z11 - z10 - z00) * 2 / 3;
	                  } else if (z11 === undefined) {
	                    if (z10 === undefined) dxy = 0;
	                    else dxy = (2 * z00 - z01 - z10) * 2 / 3;
	                  } else if (z10 === undefined) dxy = (2 * z11 - z01 - z00) * 2 / 3;
	                  else dxy = z11 + z00 - z01 - z10;
	                  return setColor(z00 + xinterp.frac * dx2 + yinterp2.frac * (dy2 + xinterp.frac * dxy));
	                }
	                if (drawingMethod !== "default") {
	                  var pxIndex = 0;
	                  var pixels;
	                  try {
	                    pixels = new Uint8Array(canvasW * canvasH * 4);
	                  } catch (e) {
	                    pixels = new Array(canvasW * canvasH * 4);
	                  }
	                  if (drawingMethod === "smooth") {
	                    var xForPx = xc || x;
	                    var yForPx = yc || y;
	                    var xPixArray = new Array(xForPx.length);
	                    var yPixArray = new Array(yForPx.length);
	                    var xinterpArray = new Array(imageWidth);
	                    var findInterpX = xc ? findInterpFromCenters : findInterp;
	                    var findInterpY = yc ? findInterpFromCenters : findInterp;
	                    var yinterp, r0, r1;
	                    for (i = 0; i < xForPx.length; i++) xPixArray[i] = Math.round(xa.c2p(xForPx[i]) - left);
	                    for (i = 0; i < yForPx.length; i++) yPixArray[i] = Math.round(ya.c2p(yForPx[i]) - top);
	                    for (i = 0; i < imageWidth; i++) xinterpArray[i] = findInterpX(i, xPixArray);
	                    for (j = 0; j < imageHeight; j++) {
	                      yinterp = findInterpY(j, yPixArray);
	                      r0 = z[yinterp.bin0];
	                      r1 = z[yinterp.bin1];
	                      for (i = 0; i < imageWidth; i++, pxIndex += 4) {
	                        c = interpColor(r0, r1, xinterpArray[i], yinterp);
	                        putColor(pixels, pxIndex, c);
	                      }
	                    }
	                  } else {
	                    for (j = 0; j < m; j++) {
	                      row = z[j];
	                      yb = ypx(j);
	                      for (i = 0; i < n; i++) {
	                        c = setColor(row[i], 1);
	                        pxIndex = (yb * n + xpx(i)) * 4;
	                        putColor(pixels, pxIndex, c);
	                      }
	                    }
	                  }
	                  var imageData = context.createImageData(canvasW, canvasH);
	                  try {
	                    imageData.data.set(pixels);
	                  } catch (e) {
	                    var pxArray = imageData.data;
	                    var dlen = pxArray.length;
	                    for (j = 0; j < dlen; j++) {
	                      pxArray[j] = pixels[j];
	                    }
	                  }
	                  context.putImageData(imageData, 0, 0);
	                } else {
	                  var xGapLeft = Math.floor(xGap / 2);
	                  var yGapTop = Math.floor(yGap / 2);
	                  for (j = 0; j < m; j++) {
	                    row = z[j];
	                    yb.reverse();
	                    yb[ybi] = ypx(j + 1);
	                    if (yb[0] === yb[1] || yb[0] === undefined || yb[1] === undefined) {
	                      continue;
	                    }
	                    xi = xpx(0);
	                    xb = [xi, xi];
	                    for (i = 0; i < n; i++) {
	                      xb.reverse();
	                      xb[xbi] = xpx(i + 1);
	                      if (xb[0] === xb[1] || xb[0] === undefined || xb[1] === undefined) {
	                        continue;
	                      }
	                      v = row[i];
	                      c = setColor(v, (xb[1] - xb[0]) * (yb[1] - yb[0]));
	                      context.fillStyle = "rgba(" + c.join(",") + ")";
	                      context.fillRect(xb[0] + xGapLeft, yb[0] + yGapTop, xb[1] - xb[0] - xGap, yb[1] - yb[0] - yGap);
	                    }
	                  }
	                }
	                rcount = Math.round(rcount / pixcount);
	                gcount = Math.round(gcount / pixcount);
	                bcount = Math.round(bcount / pixcount);
	                var avgColor = tinycolor("rgb(" + rcount + "," + gcount + "," + bcount + ")");
	                gd._hmpixcount = (gd._hmpixcount || 0) + pixcount;
	                gd._hmlumcount = (gd._hmlumcount || 0) + pixcount * avgColor.getLuminance();
	                var image3 = plotGroup.selectAll("image").data(cd);
	                image3.enter().append("svg:image").attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  preserveAspectRatio: "none"
	                });
	                image3.attr({
	                  height: imageHeight,
	                  width: imageWidth,
	                  x: left,
	                  y: top,
	                  "xlink:href": canvas.toDataURL("image/png")
	                });
	                if (drawingMethod === "fast" && !zsmooth) {
	                  image3.attr("style", PIXELATED_IMAGE_STYLE);
	                }
	                removeLabels(plotGroup);
	                var texttemplate = trace.texttemplate;
	                if (texttemplate) {
	                  var cOpts = extractOpts(trace);
	                  var dummyAx = {
	                    type: "linear",
	                    range: [cOpts.min, cOpts.max],
	                    _separators: xa._separators,
	                    _numFormat: xa._numFormat
	                  };
	                  var aHistogram2dContour = trace.type === "histogram2dcontour";
	                  var aContour = trace.type === "contour";
	                  var iStart = aContour ? 1 : 0;
	                  var iStop = aContour ? m - 1 : m;
	                  var jStart = aContour ? 1 : 0;
	                  var jStop = aContour ? n - 1 : n;
	                  var textData = [];
	                  for (i = iStart; i < iStop; i++) {
	                    var yVal;
	                    if (aContour) {
	                      yVal = cd0.y[i];
	                    } else if (aHistogram2dContour) {
	                      if (i === 0 || i === m - 1) continue;
	                      yVal = cd0.y[i];
	                    } else if (cd0.yCenter) {
	                      yVal = cd0.yCenter[i];
	                    } else {
	                      if (i + 1 === m && cd0.y[i + 1] === undefined) continue;
	                      yVal = (cd0.y[i] + cd0.y[i + 1]) / 2;
	                    }
	                    var _y = Math.round(ya.c2p(yVal));
	                    if (0 > _y || _y > ya._length) continue;
	                    for (j = jStart; j < jStop; j++) {
	                      var xVal;
	                      if (aContour) {
	                        xVal = cd0.x[j];
	                      } else if (aHistogram2dContour) {
	                        if (j === 0 || j === n - 1) continue;
	                        xVal = cd0.x[j];
	                      } else if (cd0.xCenter) {
	                        xVal = cd0.xCenter[j];
	                      } else {
	                        if (j + 1 === n && cd0.x[j + 1] === undefined) continue;
	                        xVal = (cd0.x[j] + cd0.x[j + 1]) / 2;
	                      }
	                      var _x = Math.round(xa.c2p(xVal));
	                      if (0 > _x || _x > xa._length) continue;
	                      var obj = formatLabels({
	                        x: xVal,
	                        y: yVal
	                      }, trace, gd._fullLayout);
	                      obj.x = xVal;
	                      obj.y = yVal;
	                      var zVal = cd0.z[i][j];
	                      if (zVal === undefined) {
	                        obj.z = "";
	                        obj.zLabel = "";
	                      } else {
	                        obj.z = zVal;
	                        obj.zLabel = Axes.tickText(dummyAx, zVal, "hover").text;
	                      }
	                      var theText = cd0.text && cd0.text[i] && cd0.text[i][j];
	                      if (theText === undefined || theText === false) theText = "";
	                      obj.text = theText;
	                      var _t = Lib.texttemplateString(texttemplate, obj, gd._fullLayout._d3locale, obj, trace._meta || {});
	                      if (!_t) continue;
	                      var lines = _t.split("<br>");
	                      var nL = lines.length;
	                      var nC = 0;
	                      for (k = 0; k < nL; k++) {
	                        nC = Math.max(nC, lines[k].length);
	                      }
	                      textData.push({
	                        l: nL,
	                        // number of lines
	                        c: nC,
	                        // maximum number of chars in a line
	                        t: _t,
	                        // text
	                        x: _x,
	                        y: _y,
	                        z: zVal
	                      });
	                    }
	                  }
	                  var font = trace.textfont;
	                  var fontFamily = font.family;
	                  var fontSize = font.size;
	                  var globalFontSize = gd._fullLayout.font.size;
	                  if (!fontSize || fontSize === "auto") {
	                    var minW = Infinity;
	                    var minH = Infinity;
	                    var maxL = 0;
	                    var maxC = 0;
	                    for (k = 0; k < textData.length; k++) {
	                      var d = textData[k];
	                      maxL = Math.max(maxL, d.l);
	                      maxC = Math.max(maxC, d.c);
	                      if (k < textData.length - 1) {
	                        var nextD = textData[k + 1];
	                        var dx = Math.abs(nextD.x - d.x);
	                        var dy = Math.abs(nextD.y - d.y);
	                        if (dx) minW = Math.min(minW, dx);
	                        if (dy) minH = Math.min(minH, dy);
	                      }
	                    }
	                    if (!isFinite(minW) || !isFinite(minH)) {
	                      fontSize = globalFontSize;
	                    } else {
	                      minW -= xGap;
	                      minH -= yGap;
	                      minW /= maxC;
	                      minH /= maxL;
	                      minW /= LINE_SPACING / 2;
	                      minH /= LINE_SPACING;
	                      fontSize = Math.min(Math.floor(minW), Math.floor(minH), globalFontSize);
	                    }
	                  }
	                  if (fontSize <= 0 || !isFinite(fontSize)) return;
	                  var xFn = function(d2) {
	                    return d2.x;
	                  };
	                  var yFn = function(d2) {
	                    return d2.y - fontSize * (d2.l * LINE_SPACING / 2 - 1);
	                  };
	                  var labels = selectLabels(plotGroup).data(textData);
	                  labels.enter().append("g").classed(labelClass, 1).append("text").attr("text-anchor", "middle").each(function(d2) {
	                    var thisLabel = d3.select(this);
	                    var fontColor = font.color;
	                    if (!fontColor || fontColor === "auto") {
	                      fontColor = Color.contrast("rgba(" + sclFunc(d2.z).join() + ")");
	                    }
	                    thisLabel.attr("data-notex", 1).call(svgTextUtils.positionText, xFn(d2), yFn(d2)).call(Drawing.font, fontFamily, fontSize, fontColor).text(d2.t).call(svgTextUtils.convertToTspans, gd);
	                  });
	                }
	              });
	            };
	            function findInterp(pixel, pixArray) {
	              var maxBin = pixArray.length - 2;
	              var bin = Lib.constrain(Lib.findBin(pixel, pixArray), 0, maxBin);
	              var pix0 = pixArray[bin];
	              var pix1 = pixArray[bin + 1];
	              var interp = Lib.constrain(bin + (pixel - pix0) / (pix1 - pix0) - 0.5, 0, maxBin);
	              var bin0 = Math.round(interp);
	              var frac = Math.abs(interp - bin0);
	              if (!interp || interp === maxBin || !frac) {
	                return {
	                  bin0,
	                  bin1: bin0,
	                  frac: 0
	                };
	              }
	              return {
	                bin0,
	                frac,
	                bin1: Math.round(bin0 + frac / (interp - bin0))
	              };
	            }
	            function findInterpFromCenters(pixel, centerPixArray) {
	              var maxBin = centerPixArray.length - 1;
	              var bin = Lib.constrain(Lib.findBin(pixel, centerPixArray), 0, maxBin);
	              var pix0 = centerPixArray[bin];
	              var pix1 = centerPixArray[bin + 1];
	              var frac = (pixel - pix0) / (pix1 - pix0) || 0;
	              if (frac <= 0) {
	                return {
	                  bin0: bin,
	                  bin1: bin,
	                  frac: 0
	                };
	              }
	              if (frac < 0.5) {
	                return {
	                  bin0: bin,
	                  bin1: bin + 1,
	                  frac
	                };
	              }
	              return {
	                bin0: bin + 1,
	                bin1: bin,
	                frac: 1 - frac
	              };
	            }
	            function putColor(pixels, pxIndex, c) {
	              pixels[pxIndex] = c[0];
	              pixels[pxIndex + 1] = c[1];
	              pixels[pxIndex + 2] = c[2];
	              pixels[pxIndex + 3] = Math.round(c[3] * 255);
	            }
	          }
	        ),
	        /***/
	        70035: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            module2.exports = function style(gd) {
	              d3.select(gd).selectAll(".hm image").style("opacity", function(d) {
	                return d.trace.opacity;
	              });
	            };
	          }
	        ),
	        /***/
	        49901: (
	          /***/
	          function(module2) {
	            module2.exports = function handleStyleDefaults(traceIn, traceOut, coerce) {
	              var zsmooth = coerce("zsmooth");
	              if (zsmooth === false) {
	                coerce("xgap");
	                coerce("ygap");
	              }
	              coerce("zhoverformat");
	            };
	          }
	        ),
	        /***/
	        67684: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            module2.exports = function handleXYZDefaults(traceIn, traceOut, coerce, layout, xName, yName) {
	              var z = coerce("z");
	              xName = xName || "x";
	              yName = yName || "y";
	              var x, y;
	              if (z === undefined || !z.length) return 0;
	              if (Lib.isArray1D(traceIn.z)) {
	                x = coerce(xName);
	                y = coerce(yName);
	                var xlen = Lib.minRowLength(x);
	                var ylen = Lib.minRowLength(y);
	                if (xlen === 0 || ylen === 0) return 0;
	                traceOut._length = Math.min(xlen, ylen, z.length);
	              } else {
	                x = coordDefaults(xName, coerce);
	                y = coordDefaults(yName, coerce);
	                if (!isValidZ(z)) return 0;
	                coerce("transpose");
	                traceOut._length = null;
	              }
	              if (traceIn.type === "heatmapgl") return true;
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, [xName, yName], layout);
	              return true;
	            };
	            function coordDefaults(coordStr, coerce) {
	              var coord = coerce(coordStr);
	              var coordType = coord ? coerce(coordStr + "type", "array") : "scaled";
	              if (coordType === "scaled") {
	                coerce(coordStr + "0");
	                coerce("d" + coordStr);
	              }
	              return coord;
	            }
	            function isValidZ(z) {
	              var allRowsAreArrays = true;
	              var oneRowIsFilled = false;
	              var hasOneNumber = false;
	              var zi;
	              for (var i = 0; i < z.length; i++) {
	                zi = z[i];
	                if (!Lib.isArrayOrTypedArray(zi)) {
	                  allRowsAreArrays = false;
	                  break;
	                }
	                if (zi.length > 0) oneRowIsFilled = true;
	                for (var j = 0; j < zi.length; j++) {
	                  if (isNumeric(zi[j])) {
	                    hasOneNumber = true;
	                    break;
	                  }
	                }
	              }
	              return allRowsAreArrays && oneRowIsFilled && hasOneNumber;
	            }
	          }
	        ),
	        /***/
	        16063: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var heatmapAttrs = __webpack_require__2(21606);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var commonList = ["z", "x", "x0", "dx", "y", "y0", "dy", "text", "transpose", "xtype", "ytype"];
	            var attrs = {};
	            for (var i = 0; i < commonList.length; i++) {
	              var k = commonList[i];
	              attrs[k] = heatmapAttrs[k];
	            }
	            attrs.zsmooth = {
	              valType: "enumerated",
	              values: ["fast", false],
	              dflt: "fast",
	              editType: "calc"
	            };
	            extendFlat(attrs, colorScaleAttrs("", {
	              cLetter: "z",
	              autoColorDflt: false
	            }));
	            module2.exports = overrideAll(attrs, "calc", "nested");
	          }
	        ),
	        /***/
	        59560: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createHeatmap2D = __webpack_require__2(9330).gl_heatmap2d;
	            var Axes = __webpack_require__2(89298);
	            var str2RGBArray = __webpack_require__2(78614);
	            function Heatmap(scene, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.type = "heatmapgl";
	              this.name = "";
	              this.hoverinfo = "all";
	              this.xData = [];
	              this.yData = [];
	              this.zData = [];
	              this.textLabels = [];
	              this.idToIndex = [];
	              this.bounds = [0, 0, 0, 0];
	              this.options = {
	                zsmooth: "fast",
	                z: [],
	                x: [],
	                y: [],
	                shape: [0, 0],
	                colorLevels: [0],
	                colorValues: [0, 0, 0, 1]
	              };
	              this.heatmap = createHeatmap2D(scene.glplot, this.options);
	              this.heatmap._trace = this;
	            }
	            var proto = Heatmap.prototype;
	            proto.handlePick = function(pickResult) {
	              var options = this.options;
	              var shape = options.shape;
	              var index = pickResult.pointId;
	              var xIndex = index % shape[0];
	              var yIndex = Math.floor(index / shape[0]);
	              var zIndex = index;
	              return {
	                trace: this,
	                dataCoord: pickResult.dataCoord,
	                traceCoord: [options.x[xIndex], options.y[yIndex], options.z[zIndex]],
	                textLabel: this.textLabels[index],
	                name: this.name,
	                pointIndex: [yIndex, xIndex],
	                hoverinfo: this.hoverinfo
	              };
	            };
	            proto.update = function(fullTrace, calcTrace) {
	              var calcPt = calcTrace[0];
	              this.index = fullTrace.index;
	              this.name = fullTrace.name;
	              this.hoverinfo = fullTrace.hoverinfo;
	              var z = calcPt.z;
	              this.options.z = [].concat.apply([], z);
	              var rowLen = z[0].length;
	              var colLen = z.length;
	              this.options.shape = [rowLen, colLen];
	              this.options.x = calcPt.x;
	              this.options.y = calcPt.y;
	              this.options.zsmooth = fullTrace.zsmooth;
	              var colorOptions = convertColorscale(fullTrace);
	              this.options.colorLevels = colorOptions.colorLevels;
	              this.options.colorValues = colorOptions.colorValues;
	              this.textLabels = [].concat.apply([], fullTrace.text);
	              this.heatmap.update(this.options);
	              var xa = this.scene.xaxis;
	              var ya = this.scene.yaxis;
	              var xOpts, yOpts;
	              if (fullTrace.zsmooth === false) {
	                xOpts = {
	                  ppad: calcPt.x[1] - calcPt.x[0]
	                };
	                yOpts = {
	                  ppad: calcPt.y[1] - calcPt.y[0]
	                };
	              }
	              fullTrace._extremes[xa._id] = Axes.findExtremes(xa, calcPt.x, xOpts);
	              fullTrace._extremes[ya._id] = Axes.findExtremes(ya, calcPt.y, yOpts);
	            };
	            proto.dispose = function() {
	              this.heatmap.dispose();
	            };
	            function convertColorscale(fullTrace) {
	              var scl = fullTrace.colorscale;
	              var zmin = fullTrace.zmin;
	              var zmax = fullTrace.zmax;
	              var N = scl.length;
	              var domain = new Array(N);
	              var range2 = new Array(4 * N);
	              for (var i = 0; i < N; i++) {
	                var si = scl[i];
	                var color = str2RGBArray(si[1]);
	                domain[i] = zmin + si[0] * (zmax - zmin);
	                for (var j = 0; j < 4; j++) {
	                  range2[4 * i + j] = color[j];
	                }
	              }
	              return {
	                colorLevels: domain,
	                colorValues: range2
	              };
	            }
	            function createHeatmap(scene, fullTrace, calcTrace) {
	              var plot = new Heatmap(scene, fullTrace.uid);
	              plot.update(fullTrace, calcTrace);
	              return plot;
	            }
	            module2.exports = createHeatmap;
	          }
	        ),
	        /***/
	        19600: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleXYZDefaults = __webpack_require__2(67684);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(16063);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	              if (!validData) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("text");
	              coerce("zsmooth");
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "z"
	              });
	            };
	          }
	        ),
	        /***/
	        3325: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(16063),
	              supplyDefaults: __webpack_require__2(19600),
	              colorbar: __webpack_require__2(61243),
	              calc: __webpack_require__2(90757),
	              plot: __webpack_require__2(59560),
	              moduleType: "trace",
	              name: "heatmapgl",
	              basePlotModule: __webpack_require__2(4796),
	              categories: ["gl", "gl2d", "2dMap"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        7745: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var barAttrs = __webpack_require__2(1486);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var fontAttrs = __webpack_require__2(41940);
	            var makeBinAttrs = __webpack_require__2(17656);
	            var constants = __webpack_require__2(72406);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = {
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              text: extendFlat({}, barAttrs.text, {}),
	              hovertext: extendFlat({}, barAttrs.hovertext, {}),
	              orientation: barAttrs.orientation,
	              histfunc: {
	                valType: "enumerated",
	                values: ["count", "sum", "avg", "min", "max"],
	                dflt: "count",
	                editType: "calc"
	              },
	              histnorm: {
	                valType: "enumerated",
	                values: ["", "percent", "probability", "density", "probability density"],
	                dflt: "",
	                editType: "calc"
	              },
	              cumulative: {
	                enabled: {
	                  valType: "boolean",
	                  dflt: false,
	                  editType: "calc"
	                },
	                direction: {
	                  valType: "enumerated",
	                  values: ["increasing", "decreasing"],
	                  dflt: "increasing",
	                  editType: "calc"
	                },
	                currentbin: {
	                  valType: "enumerated",
	                  values: ["include", "exclude", "half"],
	                  dflt: "include",
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              nbinsx: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              xbins: makeBinAttrs("x", true),
	              nbinsy: {
	                valType: "integer",
	                min: 0,
	                dflt: 0,
	                editType: "calc"
	              },
	              ybins: makeBinAttrs("y", true),
	              autobinx: {
	                valType: "boolean",
	                dflt: null,
	                editType: "calc"
	              },
	              autobiny: {
	                valType: "boolean",
	                dflt: null,
	                editType: "calc"
	              },
	              bingroup: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              texttemplate: texttemplateAttrs({
	                arrayOk: false,
	                editType: "plot"
	              }, {
	                keys: ["label", "value"]
	              }),
	              textposition: extendFlat({}, barAttrs.textposition, {
	                arrayOk: false
	              }),
	              textfont: fontAttrs({
	                arrayOk: false,
	                editType: "plot",
	                colorEditType: "style"
	              }),
	              outsidetextfont: fontAttrs({
	                arrayOk: false,
	                editType: "plot",
	                colorEditType: "style"
	              }),
	              insidetextfont: fontAttrs({
	                arrayOk: false,
	                editType: "plot",
	                colorEditType: "style"
	              }),
	              insidetextanchor: barAttrs.insidetextanchor,
	              textangle: barAttrs.textangle,
	              cliponaxis: barAttrs.cliponaxis,
	              constraintext: barAttrs.constraintext,
	              marker: barAttrs.marker,
	              offsetgroup: barAttrs.offsetgroup,
	              alignmentgroup: barAttrs.alignmentgroup,
	              selected: barAttrs.selected,
	              unselected: barAttrs.unselected,
	              _deprecated: {
	                bardir: barAttrs._deprecated.bardir
	              }
	            };
	          }
	        ),
	        /***/
	        42174: (
	          /***/
	          function(module2) {
	            module2.exports = function doAvg(size, counts) {
	              var nMax = size.length;
	              var total = 0;
	              for (var i = 0; i < nMax; i++) {
	                if (counts[i]) {
	                  size[i] /= counts[i];
	                  total += size[i];
	                } else size[i] = null;
	              }
	              return total;
	            };
	          }
	        ),
	        /***/
	        17656: (
	          /***/
	          function(module2) {
	            module2.exports = function makeBinAttrs(axLetter, match) {
	              return {
	                start: {
	                  valType: "any",
	                  // for date axes
	                  editType: "calc"
	                },
	                end: {
	                  valType: "any",
	                  // for date axes
	                  editType: "calc"
	                },
	                size: {
	                  valType: "any",
	                  // for date axes
	                  editType: "calc"
	                },
	                editType: "calc"
	              };
	            };
	          }
	        ),
	        /***/
	        59575: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            module2.exports = {
	              count: function(n, i, size) {
	                size[n]++;
	                return 1;
	              },
	              sum: function(n, i, size, counterData) {
	                var v = counterData[i];
	                if (isNumeric(v)) {
	                  v = Number(v);
	                  size[n] += v;
	                  return v;
	                }
	                return 0;
	              },
	              avg: function(n, i, size, counterData, counts) {
	                var v = counterData[i];
	                if (isNumeric(v)) {
	                  v = Number(v);
	                  size[n] += v;
	                  counts[n]++;
	                }
	                return 0;
	              },
	              min: function(n, i, size, counterData) {
	                var v = counterData[i];
	                if (isNumeric(v)) {
	                  v = Number(v);
	                  if (!isNumeric(size[n])) {
	                    size[n] = v;
	                    return v;
	                  } else if (size[n] > v) {
	                    var delta = v - size[n];
	                    size[n] = v;
	                    return delta;
	                  }
	                }
	                return 0;
	              },
	              max: function(n, i, size, counterData) {
	                var v = counterData[i];
	                if (isNumeric(v)) {
	                  v = Number(v);
	                  if (!isNumeric(size[n])) {
	                    size[n] = v;
	                    return v;
	                  } else if (size[n] < v) {
	                    var delta = v - size[n];
	                    size[n] = v;
	                    return delta;
	                  }
	                }
	                return 0;
	              }
	            };
	          }
	        ),
	        /***/
	        40965: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var numConstants = __webpack_require__2(50606);
	            var oneYear = numConstants.ONEAVGYEAR;
	            var oneMonth = numConstants.ONEAVGMONTH;
	            var oneDay = numConstants.ONEDAY;
	            var oneHour = numConstants.ONEHOUR;
	            var oneMin = numConstants.ONEMIN;
	            var oneSec = numConstants.ONESEC;
	            var tickIncrement = __webpack_require__2(89298).tickIncrement;
	            module2.exports = function getBinSpanLabelRound(leftGap, rightGap, binEdges, pa, calendar) {
	              var dv0 = -1.1 * rightGap;
	              var dv1 = -0.1 * rightGap;
	              var dv2 = leftGap - dv1;
	              var edge0 = binEdges[0];
	              var edge1 = binEdges[1];
	              var leftDigit = Math.min(biggestDigitChanged(edge0 + dv1, edge0 + dv2, pa, calendar), biggestDigitChanged(edge1 + dv1, edge1 + dv2, pa, calendar));
	              var rightDigit = Math.min(biggestDigitChanged(edge0 + dv0, edge0 + dv1, pa, calendar), biggestDigitChanged(edge1 + dv0, edge1 + dv1, pa, calendar));
	              var digit, disambiguateEdges;
	              if (leftDigit > rightDigit && rightDigit < Math.abs(edge1 - edge0) / 4e3) {
	                digit = leftDigit;
	                disambiguateEdges = false;
	              } else {
	                digit = Math.min(leftDigit, rightDigit);
	                disambiguateEdges = true;
	              }
	              if (pa.type === "date" && digit > oneDay) {
	                var dashExclude = digit === oneYear ? 1 : 6;
	                var increment = digit === oneYear ? "M12" : "M1";
	                return function(v, isRightEdge) {
	                  var dateStr = pa.c2d(v, oneYear, calendar);
	                  var dashPos = dateStr.indexOf("-", dashExclude);
	                  if (dashPos > 0) dateStr = dateStr.substr(0, dashPos);
	                  var roundedV = pa.d2c(dateStr, 0, calendar);
	                  if (roundedV < v) {
	                    var nextV = tickIncrement(roundedV, increment, false, calendar);
	                    if ((roundedV + nextV) / 2 < v + leftGap) roundedV = nextV;
	                  }
	                  if (isRightEdge && disambiguateEdges) {
	                    return tickIncrement(roundedV, increment, true, calendar);
	                  }
	                  return roundedV;
	                };
	              }
	              return function(v, isRightEdge) {
	                var roundedV = digit * Math.round(v / digit);
	                if (roundedV + digit / 10 < v && roundedV + digit * 0.9 < v + leftGap) {
	                  roundedV += digit;
	                }
	                if (isRightEdge && disambiguateEdges) {
	                  roundedV -= digit;
	                }
	                return roundedV;
	              };
	            };
	            function biggestDigitChanged(v1, v2, pa, calendar) {
	              if (v1 * v2 <= 0) return Infinity;
	              var dv = Math.abs(v2 - v1);
	              var isDate = pa.type === "date";
	              var digit = biggestGuaranteedDigitChanged(dv, isDate);
	              for (var i = 0; i < 10; i++) {
	                var nextDigit = biggestGuaranteedDigitChanged(digit * 80, isDate);
	                if (digit === nextDigit) break;
	                if (didDigitChange(nextDigit, v1, v2, isDate, pa, calendar)) digit = nextDigit;
	                else break;
	              }
	              return digit;
	            }
	            function biggestGuaranteedDigitChanged(dv, isDate) {
	              if (isDate && dv > oneSec) {
	                if (dv > oneDay) {
	                  if (dv > oneYear * 1.1) return oneYear;
	                  if (dv > oneMonth * 1.1) return oneMonth;
	                  return oneDay;
	                }
	                if (dv > oneHour) return oneHour;
	                if (dv > oneMin) return oneMin;
	                return oneSec;
	              }
	              return Math.pow(10, Math.floor(Math.log(dv) / Math.LN10));
	            }
	            function didDigitChange(digit, v1, v2, isDate, pa, calendar) {
	              if (isDate && digit > oneDay) {
	                var dateParts1 = dateParts(v1, pa, calendar);
	                var dateParts2 = dateParts(v2, pa, calendar);
	                var parti = digit === oneYear ? 0 : 1;
	                return dateParts1[parti] !== dateParts2[parti];
	              }
	              return Math.floor(v2 / digit) - Math.floor(v1 / digit) > 0.1;
	            }
	            function dateParts(v, pa, calendar) {
	              var parts = pa.c2d(v, oneYear, calendar).split("-");
	              if (parts[0] === "") {
	                parts.unshift();
	                parts[0] = "-" + parts[0];
	              }
	              return parts;
	            }
	          }
	        ),
	        /***/
	        72138: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var arraysToCalcdata = __webpack_require__2(75341);
	            var binFunctions = __webpack_require__2(59575);
	            var normFunctions = __webpack_require__2(36362);
	            var doAvg = __webpack_require__2(42174);
	            var getBinSpanLabelRound = __webpack_require__2(40965);
	            function calc(gd, trace) {
	              var pos = [];
	              var size = [];
	              var isHorizontal = trace.orientation === "h";
	              var pa = Axes.getFromId(gd, isHorizontal ? trace.yaxis : trace.xaxis);
	              var mainData = isHorizontal ? "y" : "x";
	              var counterData = {
	                x: "y",
	                y: "x"
	              }[mainData];
	              var calendar = trace[mainData + "calendar"];
	              var cumulativeSpec = trace.cumulative;
	              var i;
	              var binsAndPos = calcAllAutoBins(gd, trace, pa, mainData);
	              var binSpec = binsAndPos[0];
	              var pos0 = binsAndPos[1];
	              var nonuniformBins = typeof binSpec.size === "string";
	              var binEdges = [];
	              var bins = nonuniformBins ? binEdges : binSpec;
	              var inc = [];
	              var counts = [];
	              var inputPoints = [];
	              var total = 0;
	              var norm = trace.histnorm;
	              var func = trace.histfunc;
	              var densityNorm = norm.indexOf("density") !== -1;
	              var i2, binEnd, n;
	              if (cumulativeSpec.enabled && densityNorm) {
	                norm = norm.replace(/ ?density$/, "");
	                densityNorm = false;
	              }
	              var extremeFunc = func === "max" || func === "min";
	              var sizeInit = extremeFunc ? null : 0;
	              var binFunc = binFunctions.count;
	              var normFunc = normFunctions[norm];
	              var isAvg = false;
	              var pr2c = function(v) {
	                return pa.r2c(v, 0, calendar);
	              };
	              var rawCounterData;
	              if (Lib.isArrayOrTypedArray(trace[counterData]) && func !== "count") {
	                rawCounterData = trace[counterData];
	                isAvg = func === "avg";
	                binFunc = binFunctions[func];
	              }
	              i = pr2c(binSpec.start);
	              binEnd = pr2c(binSpec.end) + (i - Axes.tickIncrement(i, binSpec.size, false, calendar)) / 1e6;
	              while (i < binEnd && pos.length < 1e6) {
	                i2 = Axes.tickIncrement(i, binSpec.size, false, calendar);
	                pos.push((i + i2) / 2);
	                size.push(sizeInit);
	                inputPoints.push([]);
	                binEdges.push(i);
	                if (densityNorm) inc.push(1 / (i2 - i));
	                if (isAvg) counts.push(0);
	                if (i2 <= i) break;
	                i = i2;
	              }
	              binEdges.push(i);
	              if (!nonuniformBins && pa.type === "date") {
	                bins = {
	                  start: pr2c(bins.start),
	                  end: pr2c(bins.end),
	                  size: bins.size
	                };
	              }
	              if (!gd._fullLayout._roundFnOpts) gd._fullLayout._roundFnOpts = {};
	              var groupName = trace["_" + mainData + "bingroup"];
	              var roundFnOpts = {
	                leftGap: Infinity,
	                rightGap: Infinity
	              };
	              if (groupName) {
	                if (!gd._fullLayout._roundFnOpts[groupName]) gd._fullLayout._roundFnOpts[groupName] = roundFnOpts;
	                roundFnOpts = gd._fullLayout._roundFnOpts[groupName];
	              }
	              var nMax = size.length;
	              var uniqueValsPerBin = true;
	              var leftGap = roundFnOpts.leftGap;
	              var rightGap = roundFnOpts.rightGap;
	              var ptNumber2cdIndex = {};
	              for (i = 0; i < pos0.length; i++) {
	                var posi = pos0[i];
	                n = Lib.findBin(posi, bins);
	                if (n >= 0 && n < nMax) {
	                  total += binFunc(n, i, size, rawCounterData, counts);
	                  if (uniqueValsPerBin && inputPoints[n].length && posi !== pos0[inputPoints[n][0]]) {
	                    uniqueValsPerBin = false;
	                  }
	                  inputPoints[n].push(i);
	                  ptNumber2cdIndex[i] = n;
	                  leftGap = Math.min(leftGap, posi - binEdges[n]);
	                  rightGap = Math.min(rightGap, binEdges[n + 1] - posi);
	                }
	              }
	              roundFnOpts.leftGap = leftGap;
	              roundFnOpts.rightGap = rightGap;
	              var roundFn;
	              if (!uniqueValsPerBin) {
	                roundFn = function(v, isRightEdge) {
	                  return function() {
	                    var roundFnOpts2 = gd._fullLayout._roundFnOpts[groupName];
	                    return getBinSpanLabelRound(roundFnOpts2.leftGap, roundFnOpts2.rightGap, binEdges, pa, calendar)(v, isRightEdge);
	                  };
	                };
	              }
	              if (isAvg) total = doAvg(size, counts);
	              if (normFunc) normFunc(size, total, inc);
	              if (cumulativeSpec.enabled) cdf(size, cumulativeSpec.direction, cumulativeSpec.currentbin);
	              var seriesLen = Math.min(pos.length, size.length);
	              var cd = [];
	              var firstNonzero = 0;
	              var lastNonzero = seriesLen - 1;
	              for (i = 0; i < seriesLen; i++) {
	                if (size[i]) {
	                  firstNonzero = i;
	                  break;
	                }
	              }
	              for (i = seriesLen - 1; i >= firstNonzero; i--) {
	                if (size[i]) {
	                  lastNonzero = i;
	                  break;
	                }
	              }
	              for (i = firstNonzero; i <= lastNonzero; i++) {
	                if (isNumeric(pos[i]) && isNumeric(size[i])) {
	                  var cdi = {
	                    p: pos[i],
	                    s: size[i],
	                    b: 0
	                  };
	                  if (!cumulativeSpec.enabled) {
	                    cdi.pts = inputPoints[i];
	                    if (uniqueValsPerBin) {
	                      cdi.ph0 = cdi.ph1 = inputPoints[i].length ? pos0[inputPoints[i][0]] : pos[i];
	                    } else {
	                      trace._computePh = true;
	                      cdi.ph0 = roundFn(binEdges[i]);
	                      cdi.ph1 = roundFn(binEdges[i + 1], true);
	                    }
	                  }
	                  cd.push(cdi);
	                }
	              }
	              if (cd.length === 1) {
	                cd[0].width1 = Axes.tickIncrement(cd[0].p, binSpec.size, false, calendar) - cd[0].p;
	              }
	              arraysToCalcdata(cd, trace);
	              if (Lib.isArrayOrTypedArray(trace.selectedpoints)) {
	                Lib.tagSelected(cd, trace, ptNumber2cdIndex);
	              }
	              return cd;
	            }
	            function calcAllAutoBins(gd, trace, pa, mainData, _overlayEdgeCase) {
	              var binAttr = mainData + "bins";
	              var fullLayout = gd._fullLayout;
	              var groupName = trace["_" + mainData + "bingroup"];
	              var binOpts = fullLayout._histogramBinOpts[groupName];
	              var isOverlay = fullLayout.barmode === "overlay";
	              var i, traces, tracei, calendar, pos0, autoVals, cumulativeSpec;
	              var r2c = function(v) {
	                return pa.r2c(v, 0, calendar);
	              };
	              var c2r = function(v) {
	                return pa.c2r(v, 0, calendar);
	              };
	              var cleanBound = pa.type === "date" ? function(v) {
	                return v || v === 0 ? Lib.cleanDate(v, null, calendar) : null;
	              } : function(v) {
	                return isNumeric(v) ? Number(v) : null;
	              };
	              function setBound(attr, bins, newBins) {
	                if (bins[attr + "Found"]) {
	                  bins[attr] = cleanBound(bins[attr]);
	                  if (bins[attr] === null) bins[attr] = newBins[attr];
	                } else {
	                  autoVals[attr] = bins[attr] = newBins[attr];
	                  Lib.nestedProperty(traces[0], binAttr + "." + attr).set(newBins[attr]);
	                }
	              }
	              if (trace["_" + mainData + "autoBinFinished"]) {
	                delete trace["_" + mainData + "autoBinFinished"];
	              } else {
	                traces = binOpts.traces;
	                var allPos = [];
	                var isFirstVisible = true;
	                var has2dMap = false;
	                var hasHist2dContour = false;
	                for (i = 0; i < traces.length; i++) {
	                  tracei = traces[i];
	                  if (tracei.visible) {
	                    var mainDatai = binOpts.dirs[i];
	                    pos0 = tracei["_" + mainDatai + "pos0"] = pa.makeCalcdata(tracei, mainDatai);
	                    allPos = Lib.concat(allPos, pos0);
	                    delete tracei["_" + mainData + "autoBinFinished"];
	                    if (trace.visible === true) {
	                      if (isFirstVisible) {
	                        isFirstVisible = false;
	                      } else {
	                        delete tracei._autoBin;
	                        tracei["_" + mainData + "autoBinFinished"] = 1;
	                      }
	                      if (Registry.traceIs(tracei, "2dMap")) {
	                        has2dMap = true;
	                      }
	                      if (tracei.type === "histogram2dcontour") {
	                        hasHist2dContour = true;
	                      }
	                    }
	                  }
	                }
	                calendar = traces[0][mainData + "calendar"];
	                var newBinSpec = Axes.autoBin(allPos, pa, binOpts.nbins, has2dMap, calendar, binOpts.sizeFound && binOpts.size);
	                var autoBin = traces[0]._autoBin = {};
	                autoVals = autoBin[binOpts.dirs[0]] = {};
	                if (hasHist2dContour) {
	                  if (!binOpts.size) {
	                    newBinSpec.start = c2r(Axes.tickIncrement(r2c(newBinSpec.start), newBinSpec.size, true, calendar));
	                  }
	                  if (binOpts.end === undefined) {
	                    newBinSpec.end = c2r(Axes.tickIncrement(r2c(newBinSpec.end), newBinSpec.size, false, calendar));
	                  }
	                }
	                if (isOverlay && !Registry.traceIs(trace, "2dMap") && newBinSpec._dataSpan === 0 && pa.type !== "category" && pa.type !== "multicategory" && trace.bingroup === "" && typeof trace.xbins === "undefined") {
	                  if (_overlayEdgeCase) return [newBinSpec, pos0, true];
	                  newBinSpec = handleSingleValueOverlays(gd, trace, pa, mainData, binAttr);
	                }
	                cumulativeSpec = tracei.cumulative || {};
	                if (cumulativeSpec.enabled && cumulativeSpec.currentbin !== "include") {
	                  if (cumulativeSpec.direction === "decreasing") {
	                    newBinSpec.start = c2r(Axes.tickIncrement(r2c(newBinSpec.start), newBinSpec.size, true, calendar));
	                  } else {
	                    newBinSpec.end = c2r(Axes.tickIncrement(r2c(newBinSpec.end), newBinSpec.size, false, calendar));
	                  }
	                }
	                binOpts.size = newBinSpec.size;
	                if (!binOpts.sizeFound) {
	                  autoVals.size = newBinSpec.size;
	                  Lib.nestedProperty(traces[0], binAttr + ".size").set(newBinSpec.size);
	                }
	                setBound("start", binOpts, newBinSpec);
	                setBound("end", binOpts, newBinSpec);
	              }
	              pos0 = trace["_" + mainData + "pos0"];
	              delete trace["_" + mainData + "pos0"];
	              var traceInputBins = trace._input[binAttr] || {};
	              var traceBinOptsCalc = Lib.extendFlat({}, binOpts);
	              var mainStart = binOpts.start;
	              var startIn = pa.r2l(traceInputBins.start);
	              var hasStart = startIn !== undefined;
	              if ((binOpts.startFound || hasStart) && startIn !== pa.r2l(mainStart)) {
	                var traceStart = hasStart ? startIn : Lib.aggNums(Math.min, null, pos0);
	                var dummyAx = {
	                  type: pa.type === "category" || pa.type === "multicategory" ? "linear" : pa.type,
	                  r2l: pa.r2l,
	                  dtick: binOpts.size,
	                  tick0: mainStart,
	                  calendar,
	                  range: [traceStart, Axes.tickIncrement(traceStart, binOpts.size, false, calendar)].map(pa.l2r)
	                };
	                var newStart = Axes.tickFirst(dummyAx);
	                if (newStart > pa.r2l(traceStart)) {
	                  newStart = Axes.tickIncrement(newStart, binOpts.size, true, calendar);
	                }
	                traceBinOptsCalc.start = pa.l2r(newStart);
	                if (!hasStart) Lib.nestedProperty(trace, binAttr + ".start").set(traceBinOptsCalc.start);
	              }
	              var mainEnd = binOpts.end;
	              var endIn = pa.r2l(traceInputBins.end);
	              var hasEnd = endIn !== undefined;
	              if ((binOpts.endFound || hasEnd) && endIn !== pa.r2l(mainEnd)) {
	                var traceEnd = hasEnd ? endIn : Lib.aggNums(Math.max, null, pos0);
	                traceBinOptsCalc.end = pa.l2r(traceEnd);
	                if (!hasEnd) Lib.nestedProperty(trace, binAttr + ".start").set(traceBinOptsCalc.end);
	              }
	              var autoBinAttr = "autobin" + mainData;
	              if (trace._input[autoBinAttr] === false) {
	                trace._input[binAttr] = Lib.extendFlat({}, trace[binAttr] || {});
	                delete trace._input[autoBinAttr];
	                delete trace[autoBinAttr];
	              }
	              return [traceBinOptsCalc, pos0];
	            }
	            function handleSingleValueOverlays(gd, trace, pa, mainData, binAttr) {
	              var fullLayout = gd._fullLayout;
	              var overlaidTraceGroup = getConnectedHistograms(gd, trace);
	              var pastThisTrace = false;
	              var minSize = Infinity;
	              var singleValuedTraces = [trace];
	              var i, tracei, binOpts;
	              for (i = 0; i < overlaidTraceGroup.length; i++) {
	                tracei = overlaidTraceGroup[i];
	                if (tracei === trace) {
	                  pastThisTrace = true;
	                } else if (!pastThisTrace) {
	                  binOpts = fullLayout._histogramBinOpts[tracei["_" + mainData + "bingroup"]];
	                  minSize = Math.min(minSize, binOpts.size || tracei[binAttr].size);
	                } else {
	                  var resulti = calcAllAutoBins(gd, tracei, pa, mainData, true);
	                  var binSpeci = resulti[0];
	                  var isSingleValued = resulti[2];
	                  tracei["_" + mainData + "autoBinFinished"] = 1;
	                  tracei["_" + mainData + "pos0"] = resulti[1];
	                  if (isSingleValued) {
	                    singleValuedTraces.push(tracei);
	                  } else {
	                    minSize = Math.min(minSize, binSpeci.size);
	                  }
	                }
	              }
	              var dataVals = new Array(singleValuedTraces.length);
	              for (i = 0; i < singleValuedTraces.length; i++) {
	                var pos0 = singleValuedTraces[i]["_" + mainData + "pos0"];
	                for (var j = 0; j < pos0.length; j++) {
	                  if (pos0[j] !== undefined) {
	                    dataVals[i] = pos0[j];
	                    break;
	                  }
	                }
	              }
	              if (!isFinite(minSize)) {
	                minSize = Lib.distinctVals(dataVals).minDiff;
	              }
	              for (i = 0; i < singleValuedTraces.length; i++) {
	                tracei = singleValuedTraces[i];
	                var calendar = tracei[mainData + "calendar"];
	                var newBins = {
	                  start: pa.c2r(dataVals[i] - minSize / 2, 0, calendar),
	                  end: pa.c2r(dataVals[i] + minSize / 2, 0, calendar),
	                  size: minSize
	                };
	                tracei._input[binAttr] = tracei[binAttr] = newBins;
	                binOpts = fullLayout._histogramBinOpts[tracei["_" + mainData + "bingroup"]];
	                if (binOpts) Lib.extendFlat(binOpts, newBins);
	              }
	              return trace[binAttr];
	            }
	            function getConnectedHistograms(gd, trace) {
	              var xid = trace.xaxis;
	              var yid = trace.yaxis;
	              var orientation = trace.orientation;
	              var out = [];
	              var fullData = gd._fullData;
	              for (var i = 0; i < fullData.length; i++) {
	                var tracei = fullData[i];
	                if (tracei.type === "histogram" && tracei.visible === true && tracei.orientation === orientation && tracei.xaxis === xid && tracei.yaxis === yid) {
	                  out.push(tracei);
	                }
	              }
	              return out;
	            }
	            function cdf(size, direction, currentBin) {
	              var i, vi, prevSum;
	              function firstHalfPoint(i2) {
	                prevSum = size[i2];
	                size[i2] /= 2;
	              }
	              function nextHalfPoint(i2) {
	                vi = size[i2];
	                size[i2] = prevSum + vi / 2;
	                prevSum += vi;
	              }
	              if (currentBin === "half") {
	                if (direction === "increasing") {
	                  firstHalfPoint(0);
	                  for (i = 1; i < size.length; i++) {
	                    nextHalfPoint(i);
	                  }
	                } else {
	                  firstHalfPoint(size.length - 1);
	                  for (i = size.length - 2; i >= 0; i--) {
	                    nextHalfPoint(i);
	                  }
	                }
	              } else if (direction === "increasing") {
	                for (i = 1; i < size.length; i++) {
	                  size[i] += size[i - 1];
	                }
	                if (currentBin === "exclude") {
	                  size.unshift(0);
	                  size.pop();
	                }
	              } else {
	                for (i = size.length - 2; i >= 0; i--) {
	                  size[i] += size[i + 1];
	                }
	                if (currentBin === "exclude") {
	                  size.push(0);
	                  size.shift();
	                }
	              }
	            }
	            module2.exports = {
	              calc,
	              calcAllAutoBins
	            };
	          }
	        ),
	        /***/
	        72406: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              eventDataKeys: ["binNumber"]
	            };
	          }
	        ),
	        /***/
	        82222: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var axisIds = __webpack_require__2(41675);
	            var traceIs = __webpack_require__2(73972).traceIs;
	            var handleGroupingDefaults = __webpack_require__2(26125);
	            var nestedProperty = Lib.nestedProperty;
	            var getAxisGroup = __webpack_require__2(99082).getAxisGroup;
	            var BINATTRS = [{
	              aStr: {
	                x: "xbins.start",
	                y: "ybins.start"
	              },
	              name: "start"
	            }, {
	              aStr: {
	                x: "xbins.end",
	                y: "ybins.end"
	              },
	              name: "end"
	            }, {
	              aStr: {
	                x: "xbins.size",
	                y: "ybins.size"
	              },
	              name: "size"
	            }, {
	              aStr: {
	                x: "nbinsx",
	                y: "nbinsy"
	              },
	              name: "nbins"
	            }];
	            var BINDIRECTIONS = ["x", "y"];
	            module2.exports = function crossTraceDefaults(fullData, fullLayout) {
	              var allBinOpts = fullLayout._histogramBinOpts = {};
	              var histTraces = [];
	              var mustMatchTracesLookup = {};
	              var otherTracesList = [];
	              var traceOut, traces, groupName, binDir;
	              var i, j, k;
	              function coerce(attr2, dflt) {
	                return Lib.coerce(traceOut._input, traceOut, traceOut._module.attributes, attr2, dflt);
	              }
	              function orientation2binDir(traceOut2) {
	                return traceOut2.orientation === "v" ? "x" : "y";
	              }
	              function getAxisType(traceOut2, binDir2) {
	                var ax = axisIds.getFromTrace({
	                  _fullLayout: fullLayout
	                }, traceOut2, binDir2);
	                return ax.type;
	              }
	              function fillBinOpts(traceOut2, groupName2, binDir2) {
	                var fallbackGroupName = traceOut2.uid + "__" + binDir2;
	                if (!groupName2) groupName2 = fallbackGroupName;
	                var axType = getAxisType(traceOut2, binDir2);
	                var calendar = traceOut2[binDir2 + "calendar"] || "";
	                var binOpts2 = allBinOpts[groupName2];
	                var needsNewItem = true;
	                if (binOpts2) {
	                  if (axType === binOpts2.axType && calendar === binOpts2.calendar) {
	                    needsNewItem = false;
	                    binOpts2.traces.push(traceOut2);
	                    binOpts2.dirs.push(binDir2);
	                  } else {
	                    groupName2 = fallbackGroupName;
	                    if (axType !== binOpts2.axType) {
	                      Lib.warn(["Attempted to group the bins of trace", traceOut2.index, "set on a", "type:" + axType, "axis", "with bins on", "type:" + binOpts2.axType, "axis."].join(" "));
	                    }
	                    if (calendar !== binOpts2.calendar) {
	                      Lib.warn(["Attempted to group the bins of trace", traceOut2.index, "set with a", calendar, "calendar", "with bins", binOpts2.calendar ? "on a " + binOpts2.calendar + " calendar" : "w/o a set calendar"].join(" "));
	                    }
	                  }
	                }
	                if (needsNewItem) {
	                  allBinOpts[groupName2] = {
	                    traces: [traceOut2],
	                    dirs: [binDir2],
	                    axType,
	                    calendar: traceOut2[binDir2 + "calendar"] || ""
	                  };
	                }
	                traceOut2["_" + binDir2 + "bingroup"] = groupName2;
	              }
	              for (i = 0; i < fullData.length; i++) {
	                traceOut = fullData[i];
	                if (traceIs(traceOut, "histogram")) {
	                  histTraces.push(traceOut);
	                  delete traceOut._xautoBinFinished;
	                  delete traceOut._yautoBinFinished;
	                  if (!traceIs(traceOut, "2dMap")) {
	                    handleGroupingDefaults(traceOut._input, traceOut, fullLayout, coerce);
	                  }
	                }
	              }
	              var alignmentOpts = fullLayout._alignmentOpts || {};
	              for (i = 0; i < histTraces.length; i++) {
	                traceOut = histTraces[i];
	                groupName = "";
	                if (!traceIs(traceOut, "2dMap")) {
	                  binDir = orientation2binDir(traceOut);
	                  if (fullLayout.barmode === "group" && traceOut.alignmentgroup) {
	                    var pa = traceOut[binDir + "axis"];
	                    var aGroupId = getAxisGroup(fullLayout, pa) + traceOut.orientation;
	                    if ((alignmentOpts[aGroupId] || {})[traceOut.alignmentgroup]) {
	                      groupName = aGroupId;
	                    }
	                  }
	                  if (!groupName && fullLayout.barmode !== "overlay") {
	                    groupName = getAxisGroup(fullLayout, traceOut.xaxis) + getAxisGroup(fullLayout, traceOut.yaxis) + orientation2binDir(traceOut);
	                  }
	                }
	                if (groupName) {
	                  if (!mustMatchTracesLookup[groupName]) {
	                    mustMatchTracesLookup[groupName] = [];
	                  }
	                  mustMatchTracesLookup[groupName].push(traceOut);
	                } else {
	                  otherTracesList.push(traceOut);
	                }
	              }
	              for (groupName in mustMatchTracesLookup) {
	                traces = mustMatchTracesLookup[groupName];
	                if (traces.length === 1) {
	                  otherTracesList.push(traces[0]);
	                  continue;
	                }
	                var binGroupFound = false;
	                if (traces.length) {
	                  traceOut = traces[0];
	                  binGroupFound = coerce("bingroup");
	                }
	                groupName = binGroupFound || groupName;
	                for (i = 0; i < traces.length; i++) {
	                  traceOut = traces[i];
	                  var bingroupIn = traceOut._input.bingroup;
	                  if (bingroupIn && bingroupIn !== groupName) {
	                    Lib.warn(["Trace", traceOut.index, "must match", "within bingroup", groupName + ".", "Ignoring its bingroup:", bingroupIn, "setting."].join(" "));
	                  }
	                  traceOut.bingroup = groupName;
	                  fillBinOpts(traceOut, groupName, orientation2binDir(traceOut));
	                }
	              }
	              for (i = 0; i < otherTracesList.length; i++) {
	                traceOut = otherTracesList[i];
	                var binGroup = coerce("bingroup");
	                if (traceIs(traceOut, "2dMap")) {
	                  for (k = 0; k < 2; k++) {
	                    binDir = BINDIRECTIONS[k];
	                    var binGroupInDir = coerce(binDir + "bingroup", binGroup ? binGroup + "__" + binDir : null);
	                    fillBinOpts(traceOut, binGroupInDir, binDir);
	                  }
	                } else {
	                  fillBinOpts(traceOut, binGroup, orientation2binDir(traceOut));
	                }
	              }
	              for (groupName in allBinOpts) {
	                var binOpts = allBinOpts[groupName];
	                traces = binOpts.traces;
	                for (j = 0; j < BINATTRS.length; j++) {
	                  var attrSpec = BINATTRS[j];
	                  var attr = attrSpec.name;
	                  var aStr;
	                  var autoVals;
	                  if (attr === "nbins" && binOpts.sizeFound) continue;
	                  for (i = 0; i < traces.length; i++) {
	                    traceOut = traces[i];
	                    binDir = binOpts.dirs[i];
	                    aStr = attrSpec.aStr[binDir];
	                    if (nestedProperty(traceOut._input, aStr).get() !== undefined) {
	                      binOpts[attr] = coerce(aStr);
	                      binOpts[attr + "Found"] = true;
	                      break;
	                    }
	                    autoVals = (traceOut._autoBin || {})[binDir] || {};
	                    if (autoVals[attr]) {
	                      nestedProperty(traceOut, aStr).set(autoVals[attr]);
	                    }
	                  }
	                  if (attr === "start" || attr === "end") {
	                    for (; i < traces.length; i++) {
	                      traceOut = traces[i];
	                      if (traceOut["_" + binDir + "bingroup"]) {
	                        autoVals = (traceOut._autoBin || {})[binDir] || {};
	                        coerce(aStr, autoVals[attr]);
	                      }
	                    }
	                  }
	                  if (attr === "nbins" && !binOpts.sizeFound && !binOpts.nbinsFound) {
	                    traceOut = traces[0];
	                    binOpts[attr] = coerce(aStr);
	                  }
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        11385: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var handleText = __webpack_require__2(90769).handleText;
	            var handleStyleDefaults = __webpack_require__2(98340);
	            var attributes = __webpack_require__2(7745);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var x = coerce("x");
	              var y = coerce("y");
	              var cumulative = coerce("cumulative.enabled");
	              if (cumulative) {
	                coerce("cumulative.direction");
	                coerce("cumulative.currentbin");
	              }
	              coerce("text");
	              var textposition = coerce("textposition");
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                moduleHasSelected: true,
	                moduleHasUnselected: true,
	                moduleHasConstrain: true,
	                moduleHasCliponaxis: true,
	                moduleHasTextangle: true,
	                moduleHasInsideanchor: true
	              });
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              var orientation = coerce("orientation", y && !x ? "h" : "v");
	              var sampleLetter = orientation === "v" ? "x" : "y";
	              var aggLetter = orientation === "v" ? "y" : "x";
	              var len = x && y ? Math.min(Lib.minRowLength(x) && Lib.minRowLength(y)) : Lib.minRowLength(traceOut[sampleLetter] || []);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y"], layout);
	              var hasAggregationData = traceOut[aggLetter];
	              if (hasAggregationData) coerce("histfunc");
	              coerce("histnorm");
	              coerce("autobin" + sampleLetter);
	              handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	              var lineColor = (traceOut.marker.line || {}).color;
	              var errorBarsSupplyDefaults = Registry.getComponentMethod("errorbars", "supplyDefaults");
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
	                axis: "y"
	              });
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {
	                axis: "x",
	                inherit: "y"
	              });
	            };
	          }
	        ),
	        /***/
	        84402: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt, trace, cd, pointNumber) {
	              out.x = "xVal" in pt ? pt.xVal : pt.x;
	              out.y = "yVal" in pt ? pt.yVal : pt.y;
	              if ("zLabelVal" in pt) out.z = pt.zLabelVal;
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              if (!(trace.cumulative || {}).enabled) {
	                var pts = Array.isArray(pointNumber) ? cd[0].pts[pointNumber[0]][pointNumber[1]] : cd[pointNumber].pts;
	                out.pointNumbers = pts;
	                out.binNumber = out.pointNumber;
	                delete out.pointNumber;
	                delete out.pointIndex;
	                var pointIndices;
	                if (trace._indexToPoints) {
	                  pointIndices = [];
	                  for (var i = 0; i < pts.length; i++) {
	                    pointIndices = pointIndices.concat(trace._indexToPoints[pts[i]]);
	                  }
	                } else {
	                  pointIndices = pts;
	                }
	                out.pointIndices = pointIndices;
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        76440: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var barHover = __webpack_require__2(95423).hoverPoints;
	            var hoverLabelText = __webpack_require__2(89298).hoverLabelText;
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              var pts = barHover(pointData, xval, yval, hovermode, opts);
	              if (!pts) return;
	              pointData = pts[0];
	              var di = pointData.cd[pointData.index];
	              var trace = pointData.cd[0].trace;
	              if (!trace.cumulative.enabled) {
	                var posLetter = trace.orientation === "h" ? "y" : "x";
	                pointData[posLetter + "Label"] = hoverLabelText(pointData[posLetter + "a"], [di.ph0, di.ph1], trace[posLetter + "hoverformat"]);
	              }
	              return pts;
	            };
	          }
	        ),
	        /***/
	        36071: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(7745),
	              layoutAttributes: __webpack_require__2(43641),
	              supplyDefaults: __webpack_require__2(11385),
	              crossTraceDefaults: __webpack_require__2(82222),
	              supplyLayoutDefaults: __webpack_require__2(13957),
	              calc: __webpack_require__2(72138).calc,
	              crossTraceCalc: __webpack_require__2(11661).crossTraceCalc,
	              plot: __webpack_require__2(17295).plot,
	              layerName: "barlayer",
	              style: __webpack_require__2(16688).style,
	              styleOnSelect: __webpack_require__2(16688).styleOnSelect,
	              colorbar: __webpack_require__2(4898),
	              hoverPoints: __webpack_require__2(76440),
	              selectPoints: __webpack_require__2(81974),
	              eventData: __webpack_require__2(84402),
	              moduleType: "trace",
	              name: "histogram",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["bar-like", "cartesian", "svg", "bar", "histogram", "oriented", "errorBarsOK", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        36362: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              percent: function(size, total) {
	                var nMax = size.length;
	                var norm = 100 / total;
	                for (var n = 0; n < nMax; n++) size[n] *= norm;
	              },
	              probability: function(size, total) {
	                var nMax = size.length;
	                for (var n = 0; n < nMax; n++) size[n] /= total;
	              },
	              density: function(size, total, inc, yinc) {
	                var nMax = size.length;
	                yinc = yinc || 1;
	                for (var n = 0; n < nMax; n++) size[n] *= inc[n] * yinc;
	              },
	              "probability density": function(size, total, inc, yinc) {
	                var nMax = size.length;
	                if (yinc) total /= yinc;
	                for (var n = 0; n < nMax; n++) size[n] *= inc[n] / total;
	              }
	            };
	          }
	        ),
	        /***/
	        35361: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var histogramAttrs = __webpack_require__2(7745);
	            var makeBinAttrs = __webpack_require__2(17656);
	            var heatmapAttrs = __webpack_require__2(21606);
	            var baseAttrs = __webpack_require__2(9012);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = extendFlat({
	              x: histogramAttrs.x,
	              y: histogramAttrs.y,
	              z: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              marker: {
	                color: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              histnorm: histogramAttrs.histnorm,
	              histfunc: histogramAttrs.histfunc,
	              nbinsx: histogramAttrs.nbinsx,
	              xbins: makeBinAttrs("x"),
	              nbinsy: histogramAttrs.nbinsy,
	              ybins: makeBinAttrs("y"),
	              autobinx: histogramAttrs.autobinx,
	              autobiny: histogramAttrs.autobiny,
	              bingroup: extendFlat({}, histogramAttrs.bingroup, {}),
	              xbingroup: extendFlat({}, histogramAttrs.bingroup, {}),
	              ybingroup: extendFlat({}, histogramAttrs.bingroup, {}),
	              xgap: heatmapAttrs.xgap,
	              ygap: heatmapAttrs.ygap,
	              zsmooth: heatmapAttrs.zsmooth,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z", 1),
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: "z"
	              }),
	              texttemplate: texttemplateAttrs({
	                arrayOk: false,
	                editType: "plot"
	              }, {
	                keys: "z"
	              }),
	              textfont: heatmapAttrs.textfont,
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              autoColorDflt: false
	            }));
	          }
	        ),
	        /***/
	        17562: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var binFunctions = __webpack_require__2(59575);
	            var normFunctions = __webpack_require__2(36362);
	            var doAvg = __webpack_require__2(42174);
	            var getBinSpanLabelRound = __webpack_require__2(40965);
	            var calcAllAutoBins = __webpack_require__2(72138).calcAllAutoBins;
	            module2.exports = function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis);
	              var ya = Axes.getFromId(gd, trace.yaxis);
	              var xcalendar = trace.xcalendar;
	              var ycalendar = trace.ycalendar;
	              var xr2c = function(v) {
	                return xa.r2c(v, 0, xcalendar);
	              };
	              var yr2c = function(v) {
	                return ya.r2c(v, 0, ycalendar);
	              };
	              var xc2r = function(v) {
	                return xa.c2r(v, 0, xcalendar);
	              };
	              var yc2r = function(v) {
	                return ya.c2r(v, 0, ycalendar);
	              };
	              var i, j, n, m;
	              var xBinsAndPos = calcAllAutoBins(gd, trace, xa, "x");
	              var xBinSpec = xBinsAndPos[0];
	              var xPos0 = xBinsAndPos[1];
	              var yBinsAndPos = calcAllAutoBins(gd, trace, ya, "y");
	              var yBinSpec = yBinsAndPos[0];
	              var yPos0 = yBinsAndPos[1];
	              var serieslen = trace._length;
	              if (xPos0.length > serieslen) xPos0.splice(serieslen, xPos0.length - serieslen);
	              if (yPos0.length > serieslen) yPos0.splice(serieslen, yPos0.length - serieslen);
	              var z = [];
	              var onecol = [];
	              var zerocol = [];
	              var nonuniformBinsX = typeof xBinSpec.size === "string";
	              var nonuniformBinsY = typeof yBinSpec.size === "string";
	              var xEdges = [];
	              var yEdges = [];
	              var xbins = nonuniformBinsX ? xEdges : xBinSpec;
	              var ybins = nonuniformBinsY ? yEdges : yBinSpec;
	              var total = 0;
	              var counts = [];
	              var inputPoints = [];
	              var norm = trace.histnorm;
	              var func = trace.histfunc;
	              var densitynorm = norm.indexOf("density") !== -1;
	              var extremefunc = func === "max" || func === "min";
	              var sizeinit = extremefunc ? null : 0;
	              var binfunc = binFunctions.count;
	              var normfunc = normFunctions[norm];
	              var doavg = false;
	              var xinc = [];
	              var yinc = [];
	              var rawCounterData = "z" in trace ? trace.z : "marker" in trace && Array.isArray(trace.marker.color) ? trace.marker.color : "";
	              if (rawCounterData && func !== "count") {
	                doavg = func === "avg";
	                binfunc = binFunctions[func];
	              }
	              var xBinSize = xBinSpec.size;
	              var xBinStart = xr2c(xBinSpec.start);
	              var xBinEnd = xr2c(xBinSpec.end) + (xBinStart - Axes.tickIncrement(xBinStart, xBinSize, false, xcalendar)) / 1e6;
	              for (i = xBinStart; i < xBinEnd; i = Axes.tickIncrement(i, xBinSize, false, xcalendar)) {
	                onecol.push(sizeinit);
	                xEdges.push(i);
	                if (doavg) zerocol.push(0);
	              }
	              xEdges.push(i);
	              var nx = onecol.length;
	              var dx = (i - xBinStart) / nx;
	              var x0 = xc2r(xBinStart + dx / 2);
	              var yBinSize = yBinSpec.size;
	              var yBinStart = yr2c(yBinSpec.start);
	              var yBinEnd = yr2c(yBinSpec.end) + (yBinStart - Axes.tickIncrement(yBinStart, yBinSize, false, ycalendar)) / 1e6;
	              for (i = yBinStart; i < yBinEnd; i = Axes.tickIncrement(i, yBinSize, false, ycalendar)) {
	                z.push(onecol.slice());
	                yEdges.push(i);
	                var ipCol = new Array(nx);
	                for (j = 0; j < nx; j++) ipCol[j] = [];
	                inputPoints.push(ipCol);
	                if (doavg) counts.push(zerocol.slice());
	              }
	              yEdges.push(i);
	              var ny = z.length;
	              var dy = (i - yBinStart) / ny;
	              var y0 = yc2r(yBinStart + dy / 2);
	              if (densitynorm) {
	                xinc = makeIncrements(onecol.length, xbins, dx, nonuniformBinsX);
	                yinc = makeIncrements(z.length, ybins, dy, nonuniformBinsY);
	              }
	              if (!nonuniformBinsX && xa.type === "date") xbins = binsToCalc(xr2c, xbins);
	              if (!nonuniformBinsY && ya.type === "date") ybins = binsToCalc(yr2c, ybins);
	              var uniqueValsPerX = true;
	              var uniqueValsPerY = true;
	              var xVals = new Array(nx);
	              var yVals = new Array(ny);
	              var xGapLow = Infinity;
	              var xGapHigh = Infinity;
	              var yGapLow = Infinity;
	              var yGapHigh = Infinity;
	              for (i = 0; i < serieslen; i++) {
	                var xi = xPos0[i];
	                var yi = yPos0[i];
	                n = Lib.findBin(xi, xbins);
	                m = Lib.findBin(yi, ybins);
	                if (n >= 0 && n < nx && m >= 0 && m < ny) {
	                  total += binfunc(n, i, z[m], rawCounterData, counts[m]);
	                  inputPoints[m][n].push(i);
	                  if (uniqueValsPerX) {
	                    if (xVals[n] === undefined) xVals[n] = xi;
	                    else if (xVals[n] !== xi) uniqueValsPerX = false;
	                  }
	                  if (uniqueValsPerY) {
	                    if (yVals[m] === undefined) yVals[m] = yi;
	                    else if (yVals[m] !== yi) uniqueValsPerY = false;
	                  }
	                  xGapLow = Math.min(xGapLow, xi - xEdges[n]);
	                  xGapHigh = Math.min(xGapHigh, xEdges[n + 1] - xi);
	                  yGapLow = Math.min(yGapLow, yi - yEdges[m]);
	                  yGapHigh = Math.min(yGapHigh, yEdges[m + 1] - yi);
	                }
	              }
	              if (doavg) {
	                for (m = 0; m < ny; m++) total += doAvg(z[m], counts[m]);
	              }
	              if (normfunc) {
	                for (m = 0; m < ny; m++) normfunc(z[m], total, xinc, yinc[m]);
	              }
	              return {
	                x: xPos0,
	                xRanges: getRanges(xEdges, uniqueValsPerX && xVals, xGapLow, xGapHigh, xa, xcalendar),
	                x0,
	                dx,
	                y: yPos0,
	                yRanges: getRanges(yEdges, uniqueValsPerY && yVals, yGapLow, yGapHigh, ya, ycalendar),
	                y0,
	                dy,
	                z,
	                pts: inputPoints
	              };
	            };
	            function makeIncrements(len, bins, dv, nonuniform) {
	              var out = new Array(len);
	              var i;
	              if (nonuniform) {
	                for (i = 0; i < len; i++) out[i] = 1 / (bins[i + 1] - bins[i]);
	              } else {
	                var inc = 1 / dv;
	                for (i = 0; i < len; i++) out[i] = inc;
	              }
	              return out;
	            }
	            function binsToCalc(r2c, bins) {
	              return {
	                start: r2c(bins.start),
	                end: r2c(bins.end),
	                size: bins.size
	              };
	            }
	            function getRanges(edges, uniqueVals, gapLow, gapHigh, ax, calendar) {
	              var i;
	              var len = edges.length - 1;
	              var out = new Array(len);
	              var roundFn = getBinSpanLabelRound(gapLow, gapHigh, edges, ax, calendar);
	              for (i = 0; i < len; i++) {
	                var v = (uniqueVals || [])[i];
	                out[i] = v === undefined ? [roundFn(edges[i]), roundFn(edges[i + 1], true)] : [v, v];
	              }
	              return out;
	            }
	          }
	        ),
	        /***/
	        93888: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleSampleDefaults = __webpack_require__2(75238);
	            var handleStyleDefaults = __webpack_require__2(49901);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var handleHeatmapLabelDefaults = __webpack_require__2(58623);
	            var attributes = __webpack_require__2(35361);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              handleSampleDefaults(traceIn, traceOut, coerce, layout);
	              if (traceOut.visible === false) return;
	              handleStyleDefaults(traceIn, traceOut, coerce, layout);
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "z"
	              });
	              coerce("hovertemplate");
	              handleHeatmapLabelDefaults(coerce, layout);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	            };
	          }
	        ),
	        /***/
	        76128: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var heatmapHover = __webpack_require__2(46248);
	            var hoverLabelText = __webpack_require__2(89298).hoverLabelText;
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              var pts = heatmapHover(pointData, xval, yval, hovermode, opts);
	              if (!pts) return;
	              pointData = pts[0];
	              var indices = pointData.index;
	              var ny = indices[0];
	              var nx = indices[1];
	              var cd0 = pointData.cd[0];
	              var trace = cd0.trace;
	              var xRange = cd0.xRanges[nx];
	              var yRange = cd0.yRanges[ny];
	              pointData.xLabel = hoverLabelText(pointData.xa, [xRange[0], xRange[1]], trace.xhoverformat);
	              pointData.yLabel = hoverLabelText(pointData.ya, [yRange[0], yRange[1]], trace.yhoverformat);
	              return pts;
	            };
	          }
	        ),
	        /***/
	        43905: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(35361),
	              supplyDefaults: __webpack_require__2(93888),
	              crossTraceDefaults: __webpack_require__2(82222),
	              calc: __webpack_require__2(90757),
	              plot: __webpack_require__2(50347),
	              layerName: "heatmaplayer",
	              colorbar: __webpack_require__2(61243),
	              style: __webpack_require__2(70035),
	              hoverPoints: __webpack_require__2(76128),
	              eventData: __webpack_require__2(84402),
	              moduleType: "trace",
	              name: "histogram2d",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "2dMap", "histogram", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        75238: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
	              var x = coerce("x");
	              var y = coerce("y");
	              var xlen = Lib.minRowLength(x);
	              var ylen = Lib.minRowLength(y);
	              if (!xlen || !ylen) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = Math.min(xlen, ylen);
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y"], layout);
	              var hasAggregationData = coerce("z") || coerce("marker.color");
	              if (hasAggregationData) coerce("histfunc");
	              coerce("histnorm");
	              coerce("autobinx");
	              coerce("autobiny");
	            };
	          }
	        ),
	        /***/
	        99066: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var histogram2dAttrs = __webpack_require__2(35361);
	            var contourAttrs = __webpack_require__2(70600);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = extendFlat({
	              x: histogram2dAttrs.x,
	              y: histogram2dAttrs.y,
	              z: histogram2dAttrs.z,
	              marker: histogram2dAttrs.marker,
	              histnorm: histogram2dAttrs.histnorm,
	              histfunc: histogram2dAttrs.histfunc,
	              nbinsx: histogram2dAttrs.nbinsx,
	              xbins: histogram2dAttrs.xbins,
	              nbinsy: histogram2dAttrs.nbinsy,
	              ybins: histogram2dAttrs.ybins,
	              autobinx: histogram2dAttrs.autobinx,
	              autobiny: histogram2dAttrs.autobiny,
	              bingroup: histogram2dAttrs.bingroup,
	              xbingroup: histogram2dAttrs.xbingroup,
	              ybingroup: histogram2dAttrs.ybingroup,
	              autocontour: contourAttrs.autocontour,
	              ncontours: contourAttrs.ncontours,
	              contours: contourAttrs.contours,
	              line: {
	                color: contourAttrs.line.color,
	                width: extendFlat({}, contourAttrs.line.width, {
	                  dflt: 0.5
	                }),
	                dash: contourAttrs.line.dash,
	                smoothing: contourAttrs.line.smoothing,
	                editType: "plot"
	              },
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z", 1),
	              hovertemplate: histogram2dAttrs.hovertemplate,
	              texttemplate: contourAttrs.texttemplate,
	              textfont: contourAttrs.textfont
	            }, colorScaleAttrs("", {
	              cLetter: "z",
	              editTypeOverride: "calc"
	            }));
	          }
	        ),
	        /***/
	        62654: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleSampleDefaults = __webpack_require__2(75238);
	            var handleContoursDefaults = __webpack_require__2(67217);
	            var handleStyleDefaults = __webpack_require__2(8724);
	            var handleHeatmapLabelDefaults = __webpack_require__2(58623);
	            var attributes = __webpack_require__2(99066);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              function coerce2(attr) {
	                return Lib.coerce2(traceIn, traceOut, attributes, attr);
	              }
	              handleSampleDefaults(traceIn, traceOut, coerce, layout);
	              if (traceOut.visible === false) return;
	              handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
	              handleStyleDefaults(traceIn, traceOut, coerce, layout);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("hovertemplate");
	              if (traceOut.contours && traceOut.contours.coloring === "heatmap") {
	                handleHeatmapLabelDefaults(coerce, layout);
	              }
	            };
	          }
	        ),
	        /***/
	        35902: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(99066),
	              supplyDefaults: __webpack_require__2(62654),
	              crossTraceDefaults: __webpack_require__2(82222),
	              calc: __webpack_require__2(27529),
	              plot: __webpack_require__2(29854).plot,
	              layerName: "contourlayer",
	              style: __webpack_require__2(84426),
	              colorbar: __webpack_require__2(90654),
	              hoverPoints: __webpack_require__2(52421),
	              moduleType: "trace",
	              name: "histogram2dcontour",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "2dMap", "contour", "histogram", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        46291: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var pieAttrs = __webpack_require__2(34e3);
	            var sunburstAttrs = __webpack_require__2(57564);
	            var treemapAttrs = __webpack_require__2(45802);
	            var constants = __webpack_require__2(43473);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var pattern = __webpack_require__2(79952).u;
	            module2.exports = {
	              labels: sunburstAttrs.labels,
	              parents: sunburstAttrs.parents,
	              values: sunburstAttrs.values,
	              branchvalues: sunburstAttrs.branchvalues,
	              count: sunburstAttrs.count,
	              level: sunburstAttrs.level,
	              maxdepth: sunburstAttrs.maxdepth,
	              tiling: {
	                orientation: {
	                  valType: "enumerated",
	                  values: ["v", "h"],
	                  dflt: "h",
	                  editType: "plot"
	                },
	                flip: treemapAttrs.tiling.flip,
	                pad: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "plot"
	                },
	                editType: "calc"
	              },
	              marker: extendFlat({
	                colors: sunburstAttrs.marker.colors,
	                line: sunburstAttrs.marker.line,
	                pattern,
	                editType: "calc"
	              }, colorScaleAttrs("marker", {
	                colorAttr: "colors",
	                anim: false
	                // TODO: set to anim: true?
	              })),
	              leaf: sunburstAttrs.leaf,
	              pathbar: treemapAttrs.pathbar,
	              text: pieAttrs.text,
	              textinfo: sunburstAttrs.textinfo,
	              // TODO: incorporate `label` and `value` in the eventData
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: constants.eventDataKeys.concat(["label", "value"])
	              }),
	              hovertext: pieAttrs.hovertext,
	              hoverinfo: sunburstAttrs.hoverinfo,
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              textfont: pieAttrs.textfont,
	              insidetextfont: pieAttrs.insidetextfont,
	              outsidetextfont: treemapAttrs.outsidetextfont,
	              textposition: treemapAttrs.textposition,
	              sort: pieAttrs.sort,
	              root: sunburstAttrs.root,
	              domain: domainAttrs({
	                name: "icicle",
	                trace: true,
	                editType: "calc"
	              })
	            };
	          }
	        ),
	        /***/
	        96346: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var plots = __webpack_require__2(74875);
	            exports2.name = "icicle";
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              plots.plotBasePlot(exports2.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              plots.cleanBasePlot(exports2.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	            };
	          }
	        ),
	        /***/
	        46584: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var calc = __webpack_require__2(52147);
	            exports2.y = function(gd, trace) {
	              return calc.calc(gd, trace);
	            };
	            exports2.T = function(gd) {
	              return calc._runCrossTraceCalc("icicle", gd);
	            };
	          }
	        ),
	        /***/
	        56524: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(46291);
	            var Color = __webpack_require__2(7901);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleText = __webpack_require__2(90769).handleText;
	            var TEXTPAD = __webpack_require__2(97313).TEXTPAD;
	            var handleMarkerDefaults = __webpack_require__2(37434).handleMarkerDefaults;
	            var Colorscale = __webpack_require__2(21081);
	            var hasColorscale = Colorscale.hasColorscale;
	            var colorscaleDefaults = Colorscale.handleDefaults;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var labels = coerce("labels");
	              var parents = coerce("parents");
	              if (!labels || !labels.length || !parents || !parents.length) {
	                traceOut.visible = false;
	                return;
	              }
	              var vals = coerce("values");
	              if (vals && vals.length) {
	                coerce("branchvalues");
	              } else {
	                coerce("count");
	              }
	              coerce("level");
	              coerce("maxdepth");
	              coerce("tiling.orientation");
	              coerce("tiling.flip");
	              coerce("tiling.pad");
	              var text = coerce("text");
	              coerce("texttemplate");
	              if (!traceOut.texttemplate) coerce("textinfo", Array.isArray(text) ? "text+label" : "label");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var hasPathbar = coerce("pathbar.visible");
	              var textposition = "auto";
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                hasPathbar,
	                moduleHasSelected: false,
	                moduleHasUnselected: false,
	                moduleHasConstrain: false,
	                moduleHasCliponaxis: false,
	                moduleHasTextangle: false,
	                moduleHasInsideanchor: false
	              });
	              coerce("textposition");
	              handleMarkerDefaults(traceIn, traceOut, layout, coerce);
	              var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, "marker", "colors") || (traceIn.marker || {}).coloraxis;
	              if (withColorscale) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "marker.",
	                  cLetter: "c"
	                });
	              }
	              coerce("leaf.opacity", withColorscale ? 1 : 0.7);
	              traceOut._hovered = {
	                marker: {
	                  line: {
	                    width: 2,
	                    color: Color.contrast(layout.paper_bgcolor)
	                  }
	                }
	              };
	              if (hasPathbar) {
	                coerce("pathbar.thickness", traceOut.pathbar.textfont.size + 2 * TEXTPAD);
	                coerce("pathbar.side");
	                coerce("pathbar.edgeshape");
	              }
	              coerce("sort");
	              coerce("root.color");
	              handleDomainDefaults(traceOut, layout, coerce);
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        90666: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var svgTextUtils = __webpack_require__2(63893);
	            var partition = __webpack_require__2(21538);
	            var styleOne = __webpack_require__2(82454).styleOne;
	            var constants = __webpack_require__2(43473);
	            var helpers = __webpack_require__2(2791);
	            var attachFxHandlers = __webpack_require__2(83523);
	            var formatSliceLabel = __webpack_require__2(24714).formatSliceLabel;
	            var onPathbar = false;
	            module2.exports = function drawDescendants(gd, cd, entry, slices, opts) {
	              var width = opts.width;
	              var height = opts.height;
	              var viewX = opts.viewX;
	              var viewY = opts.viewY;
	              var pathSlice = opts.pathSlice;
	              var toMoveInsideSlice = opts.toMoveInsideSlice;
	              var strTransform = opts.strTransform;
	              var hasTransition = opts.hasTransition;
	              var handleSlicesExit = opts.handleSlicesExit;
	              var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
	              var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
	              var prevEntry = opts.prevEntry;
	              var refRect = {};
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var hasLeft = trace.textposition.indexOf("left") !== -1;
	              var hasRight = trace.textposition.indexOf("right") !== -1;
	              var hasBottom = trace.textposition.indexOf("bottom") !== -1;
	              var allData = partition(entry, [width, height], {
	                flipX: trace.tiling.flip.indexOf("x") > -1,
	                flipY: trace.tiling.flip.indexOf("y") > -1,
	                orientation: trace.tiling.orientation,
	                pad: {
	                  inner: trace.tiling.pad
	                },
	                maxDepth: trace._maxDepth
	              });
	              var sliceData = allData.descendants();
	              var minVisibleDepth = Infinity;
	              var maxVisibleDepth = -Infinity;
	              sliceData.forEach(function(pt) {
	                var depth = pt.depth;
	                if (depth >= trace._maxDepth) {
	                  pt.x0 = pt.x1 = (pt.x0 + pt.x1) / 2;
	                  pt.y0 = pt.y1 = (pt.y0 + pt.y1) / 2;
	                } else {
	                  minVisibleDepth = Math.min(minVisibleDepth, depth);
	                  maxVisibleDepth = Math.max(maxVisibleDepth, depth);
	                }
	              });
	              slices = slices.data(sliceData, helpers.getPtId);
	              trace._maxVisibleLayers = isFinite(maxVisibleDepth) ? maxVisibleDepth - minVisibleDepth + 1 : 0;
	              slices.enter().append("g").classed("slice", true);
	              handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
	              slices.order();
	              var nextOfPrevEntry = null;
	              if (hasTransition && prevEntry) {
	                var prevEntryId = helpers.getPtId(prevEntry);
	                slices.each(function(pt) {
	                  if (nextOfPrevEntry === null && helpers.getPtId(pt) === prevEntryId) {
	                    nextOfPrevEntry = {
	                      x0: pt.x0,
	                      x1: pt.x1,
	                      y0: pt.y0,
	                      y1: pt.y1
	                    };
	                  }
	                });
	              }
	              var getRefRect = function() {
	                return nextOfPrevEntry || {
	                  x0: 0,
	                  x1: width,
	                  y0: 0,
	                  y1: height
	                };
	              };
	              var updateSlices = slices;
	              if (hasTransition) {
	                updateSlices = updateSlices.transition().each("end", function() {
	                  var sliceTop = d3.select(this);
	                  helpers.setSliceCursor(sliceTop, gd, {
	                    hideOnRoot: true,
	                    hideOnLeaves: false,
	                    isTransitioning: false
	                  });
	                });
	              }
	              updateSlices.each(function(pt) {
	                pt._x0 = viewX(pt.x0);
	                pt._x1 = viewX(pt.x1);
	                pt._y0 = viewY(pt.y0);
	                pt._y1 = viewY(pt.y1);
	                pt._hoverX = viewX(pt.x1 - trace.tiling.pad), pt._hoverY = hasBottom ? viewY(pt.y1 - trace.tiling.pad / 2) : viewY(pt.y0 + trace.tiling.pad / 2);
	                var sliceTop = d3.select(this);
	                var slicePath = Lib.ensureSingle(sliceTop, "path", "surface", function(s) {
	                  s.style("pointer-events", isStatic ? "none" : "all");
	                });
	                if (hasTransition) {
	                  slicePath.transition().attrTween("d", function(pt2) {
	                    var interp = makeUpdateSliceInterpolator(pt2, onPathbar, getRefRect(), [width, height], {
	                      orientation: trace.tiling.orientation,
	                      flipX: trace.tiling.flip.indexOf("x") > -1,
	                      flipY: trace.tiling.flip.indexOf("y") > -1
	                    });
	                    return function(t) {
	                      return pathSlice(interp(t));
	                    };
	                  });
	                } else {
	                  slicePath.attr("d", pathSlice);
	                }
	                sliceTop.call(attachFxHandlers, entry, gd, cd, {
	                  styleOne,
	                  eventDataKeys: constants.eventDataKeys,
	                  transitionTime: constants.CLICK_TRANSITION_TIME,
	                  transitionEasing: constants.CLICK_TRANSITION_EASING
	                }).call(helpers.setSliceCursor, gd, {
	                  isTransitioning: gd._transitioning
	                });
	                slicePath.call(styleOne, pt, trace, gd, {
	                  hovered: false
	                });
	                if (pt.x0 === pt.x1 || pt.y0 === pt.y1) {
	                  pt._text = "";
	                } else {
	                  pt._text = formatSliceLabel(pt, entry, trace, cd, fullLayout) || "";
	                }
	                var sliceTextGroup = Lib.ensureSingle(sliceTop, "g", "slicetext");
	                var sliceText = Lib.ensureSingle(sliceTextGroup, "text", "", function(s) {
	                  s.attr("data-notex", 1);
	                });
	                var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
	                sliceText.text(pt._text || " ").classed("slicetext", true).attr("text-anchor", hasRight ? "end" : hasLeft ? "start" : "middle").call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
	                pt.textBB = Drawing.bBox(sliceText.node());
	                pt.transform = toMoveInsideSlice(pt, {
	                  fontSize: font.size
	                });
	                pt.transform.fontSize = font.size;
	                if (hasTransition) {
	                  sliceText.transition().attrTween("transform", function(pt2) {
	                    var interp = makeUpdateTextInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
	                    return function(t) {
	                      return strTransform(interp(t));
	                    };
	                  });
	                } else {
	                  sliceText.attr("transform", strTransform(pt));
	                }
	              });
	              return nextOfPrevEntry;
	            };
	          }
	        ),
	        /***/
	        69816: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "icicle",
	              basePlotModule: __webpack_require__2(96346),
	              categories: [],
	              animatable: true,
	              attributes: __webpack_require__2(46291),
	              layoutAttributes: __webpack_require__2(92894),
	              supplyDefaults: __webpack_require__2(56524),
	              supplyLayoutDefaults: __webpack_require__2(21070),
	              calc: __webpack_require__2(46584).y,
	              crossTraceCalc: __webpack_require__2(46584).T,
	              plot: __webpack_require__2(85596),
	              style: __webpack_require__2(82454).style,
	              colorbar: __webpack_require__2(4898),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        92894: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              iciclecolorway: {
	                valType: "colorlist",
	                editType: "calc"
	              },
	              extendiciclecolors: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        21070: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(92894);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              coerce("iciclecolorway", layoutOut.colorway);
	              coerce("extendiciclecolors");
	            };
	          }
	        ),
	        /***/
	        21538: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3Hierarchy = __webpack_require__2(674);
	            var flipTree = __webpack_require__2(14102);
	            module2.exports = function partition(entry, size, opts) {
	              var flipX = opts.flipX;
	              var flipY = opts.flipY;
	              var swapXY = opts.orientation === "h";
	              var maxDepth = opts.maxDepth;
	              var newWidth = size[0];
	              var newHeight = size[1];
	              if (maxDepth) {
	                newWidth = (entry.height + 1) * size[0] / Math.min(entry.height + 1, maxDepth);
	                newHeight = (entry.height + 1) * size[1] / Math.min(entry.height + 1, maxDepth);
	              }
	              var result = d3Hierarchy.partition().padding(opts.pad.inner).size(swapXY ? [size[1], newWidth] : [size[0], newHeight])(entry);
	              if (swapXY || flipX || flipY) {
	                flipTree(result, size, {
	                  swapXY,
	                  flipX,
	                  flipY
	                });
	              }
	              return result;
	            };
	          }
	        ),
	        /***/
	        85596: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var draw = __webpack_require__2(80694);
	            var drawDescendants = __webpack_require__2(90666);
	            module2.exports = function _plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
	              return draw(gd, cdmodule, transitionOpts, makeOnCompleteCallback, {
	                type: "icicle",
	                drawDescendants
	              });
	            };
	          }
	        ),
	        /***/
	        82454: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Lib = __webpack_require__2(71828);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            var fillOne = __webpack_require__2(43467);
	            function style(gd) {
	              var s = gd._fullLayout._iciclelayer.selectAll(".trace");
	              resizeText(gd, s, "icicle");
	              s.each(function(cd) {
	                var gTrace = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                gTrace.style("opacity", trace.opacity);
	                gTrace.selectAll("path.surface").each(function(pt) {
	                  d3.select(this).call(styleOne, pt, trace, gd);
	                });
	              });
	            }
	            function styleOne(s, pt, trace, gd) {
	              var cdi = pt.data.data;
	              var isLeaf = !pt.children;
	              var ptNumber = cdi.i;
	              var lineColor = Lib.castOption(trace, ptNumber, "marker.line.color") || Color.defaultLine;
	              var lineWidth = Lib.castOption(trace, ptNumber, "marker.line.width") || 0;
	              s.call(fillOne, pt, trace, gd).style("stroke-width", lineWidth).call(Color.stroke, lineColor).style("opacity", isLeaf ? trace.leaf.opacity : null);
	            }
	            module2.exports = {
	              style,
	              styleOne
	            };
	          }
	        ),
	        /***/
	        17230: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var baseAttrs = __webpack_require__2(9012);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var colormodel = __webpack_require__2(51877).colormodel;
	            var cm = ["rgb", "rgba", "rgba256", "hsl", "hsla"];
	            var zminDesc = [];
	            var zmaxDesc = [];
	            for (var i = 0; i < cm.length; i++) {
	              var cr = colormodel[cm[i]];
	              zminDesc.push("For the `" + cm[i] + "` colormodel, it is [" + (cr.zminDflt || cr.min).join(", ") + "].");
	              zmaxDesc.push("For the `" + cm[i] + "` colormodel, it is [" + (cr.zmaxDflt || cr.max).join(", ") + "].");
	            }
	            module2.exports = extendFlat({
	              source: {
	                valType: "string",
	                editType: "calc"
	              },
	              z: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              colormodel: {
	                valType: "enumerated",
	                values: cm,
	                editType: "calc"
	              },
	              zsmooth: {
	                valType: "enumerated",
	                values: ["fast", false],
	                dflt: false,
	                editType: "plot"
	              },
	              zmin: {
	                valType: "info_array",
	                items: [{
	                  valType: "number",
	                  editType: "calc"
	                }, {
	                  valType: "number",
	                  editType: "calc"
	                }, {
	                  valType: "number",
	                  editType: "calc"
	                }, {
	                  valType: "number",
	                  editType: "calc"
	                }],
	                editType: "calc"
	              },
	              zmax: {
	                valType: "info_array",
	                items: [{
	                  valType: "number",
	                  editType: "calc"
	                }, {
	                  valType: "number",
	                  editType: "calc"
	                }, {
	                  valType: "number",
	                  editType: "calc"
	                }, {
	                  valType: "number",
	                  editType: "calc"
	                }],
	                editType: "calc"
	              },
	              x0: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc+clearAxisTypes"
	              },
	              y0: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc+clearAxisTypes"
	              },
	              dx: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              dy: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              text: {
	                valType: "data_array",
	                editType: "plot"
	              },
	              hovertext: {
	                valType: "data_array",
	                editType: "plot"
	              },
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["x", "y", "z", "color", "name", "text"],
	                dflt: "x+y+z+text+name"
	              }),
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: ["z", "color", "colormodel"]
	              }),
	              transforms: undefined
	            });
	          }
	        ),
	        /***/
	        71113: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(51877);
	            var isNumeric = __webpack_require__2(92770);
	            var Axes = __webpack_require__2(89298);
	            var maxRowLength = __webpack_require__2(71828).maxRowLength;
	            var getImageSize = __webpack_require__2(67395).A;
	            module2.exports = function calc(gd, trace) {
	              var h;
	              var w;
	              if (trace._hasZ) {
	                h = trace.z.length;
	                w = maxRowLength(trace.z);
	              } else if (trace._hasSource) {
	                var size = getImageSize(trace.source);
	                h = size.height;
	                w = size.width;
	              }
	              var xa = Axes.getFromId(gd, trace.xaxis || "x");
	              var ya = Axes.getFromId(gd, trace.yaxis || "y");
	              var x0 = xa.d2c(trace.x0) - trace.dx / 2;
	              var y0 = ya.d2c(trace.y0) - trace.dy / 2;
	              var i;
	              var xrange = [x0, x0 + w * trace.dx];
	              var yrange = [y0, y0 + h * trace.dy];
	              if (xa && xa.type === "log") for (i = 0; i < w; i++) xrange.push(x0 + i * trace.dx);
	              if (ya && ya.type === "log") for (i = 0; i < h; i++) yrange.push(y0 + i * trace.dy);
	              trace._extremes[xa._id] = Axes.findExtremes(xa, xrange);
	              trace._extremes[ya._id] = Axes.findExtremes(ya, yrange);
	              trace._scaler = makeScaler(trace);
	              var cd0 = {
	                x0,
	                y0,
	                z: trace.z,
	                w,
	                h
	              };
	              return [cd0];
	            };
	            function scale(zero, ratio, min, max) {
	              return function(c) {
	                return Lib.constrain((c - zero) * ratio, min, max);
	              };
	            }
	            function constrain(min, max) {
	              return function(c) {
	                return Lib.constrain(c, min, max);
	              };
	            }
	            function makeScaler(trace) {
	              var cr = constants.colormodel[trace.colormodel];
	              var colormodel = cr.colormodel || trace.colormodel;
	              var n = colormodel.length;
	              trace._sArray = [];
	              for (var k = 0; k < n; k++) {
	                if (cr.min[k] !== trace.zmin[k] || cr.max[k] !== trace.zmax[k]) {
	                  trace._sArray.push(scale(trace.zmin[k], (cr.max[k] - cr.min[k]) / (trace.zmax[k] - trace.zmin[k]), cr.min[k], cr.max[k]));
	                } else {
	                  trace._sArray.push(constrain(cr.min[k], cr.max[k]));
	                }
	              }
	              return function(pixel) {
	                var c = pixel.slice(0, n);
	                for (var k2 = 0; k2 < n; k2++) {
	                  var ck = c[k2];
	                  if (!isNumeric(ck)) return false;
	                  c[k2] = trace._sArray[k2](ck);
	                }
	                return c;
	              };
	            }
	          }
	        ),
	        /***/
	        51877: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              colormodel: {
	                // min and max define the numerical range accepted in CSS
	                // If z(min|max)Dflt are not defined, z(min|max) will default to min/max
	                rgb: {
	                  min: [0, 0, 0],
	                  max: [255, 255, 255],
	                  fmt: function(c) {
	                    return c.slice(0, 3);
	                  },
	                  suffix: ["", "", ""]
	                },
	                rgba: {
	                  min: [0, 0, 0, 0],
	                  max: [255, 255, 255, 1],
	                  fmt: function(c) {
	                    return c.slice(0, 4);
	                  },
	                  suffix: ["", "", "", ""]
	                },
	                rgba256: {
	                  colormodel: "rgba",
	                  // because rgba256 is not an accept colormodel in CSS
	                  zminDflt: [0, 0, 0, 0],
	                  zmaxDflt: [255, 255, 255, 255],
	                  min: [0, 0, 0, 0],
	                  max: [255, 255, 255, 1],
	                  fmt: function(c) {
	                    return c.slice(0, 4);
	                  },
	                  suffix: ["", "", "", ""]
	                },
	                hsl: {
	                  min: [0, 0, 0],
	                  max: [360, 100, 100],
	                  fmt: function(c) {
	                    var p = c.slice(0, 3);
	                    p[1] = p[1] + "%";
	                    p[2] = p[2] + "%";
	                    return p;
	                  },
	                  suffix: ["°", "%", "%"]
	                },
	                hsla: {
	                  min: [0, 0, 0, 0],
	                  max: [360, 100, 100, 1],
	                  fmt: function(c) {
	                    var p = c.slice(0, 4);
	                    p[1] = p[1] + "%";
	                    p[2] = p[2] + "%";
	                    return p;
	                  },
	                  suffix: ["°", "%", "%", ""]
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        13245: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(17230);
	            var constants = __webpack_require__2(51877);
	            var dataUri = __webpack_require__2(25095).IMAGE_URL_PREFIX;
	            module2.exports = function supplyDefaults(traceIn, traceOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              coerce("source");
	              if (traceOut.source && !traceOut.source.match(dataUri)) delete traceOut.source;
	              traceOut._hasSource = !!traceOut.source;
	              var z = coerce("z");
	              traceOut._hasZ = !(z === undefined || !z.length || !z[0] || !z[0].length);
	              if (!traceOut._hasZ && !traceOut._hasSource) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("x0");
	              coerce("y0");
	              coerce("dx");
	              coerce("dy");
	              var cm;
	              if (traceOut._hasZ) {
	                coerce("colormodel", "rgb");
	                cm = constants.colormodel[traceOut.colormodel];
	                coerce("zmin", cm.zminDflt || cm.min);
	                coerce("zmax", cm.zmaxDflt || cm.max);
	              } else if (traceOut._hasSource) {
	                traceOut.colormodel = "rgba256";
	                cm = constants.colormodel[traceOut.colormodel];
	                traceOut.zmin = cm.zminDflt;
	                traceOut.zmax = cm.zmaxDflt;
	              }
	              coerce("zsmooth");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        30835: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt) {
	              if ("xVal" in pt) out.x = pt.xVal;
	              if ("yVal" in pt) out.y = pt.yVal;
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              out.color = pt.color;
	              out.colormodel = pt.trace.colormodel;
	              if (!out.z) out.z = pt.color;
	              return out;
	            };
	          }
	        ),
	        /***/
	        67395: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var probeSync = __webpack_require__2(33575);
	            var dataUri = __webpack_require__2(25095).IMAGE_URL_PREFIX;
	            var Buffer2 = __webpack_require__2(12856).Buffer;
	            exports2.A = function(src) {
	              var data = src.replace(dataUri, "");
	              var buff = new Buffer2(data, "base64");
	              return probeSync(buff);
	            };
	          }
	        ),
	        /***/
	        28749: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Fx = __webpack_require__2(30211);
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(51877);
	            module2.exports = function hoverPoints(pointData, xval, yval) {
	              var cd0 = pointData.cd[0];
	              var trace = cd0.trace;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              if (Fx.inbox(xval - cd0.x0, xval - (cd0.x0 + cd0.w * trace.dx), 0) > 0 || Fx.inbox(yval - cd0.y0, yval - (cd0.y0 + cd0.h * trace.dy), 0) > 0) {
	                return;
	              }
	              var nx = Math.floor((xval - cd0.x0) / trace.dx);
	              var ny = Math.floor(Math.abs(yval - cd0.y0) / trace.dy);
	              var pixel;
	              if (trace._hasZ) {
	                pixel = cd0.z[ny][nx];
	              } else if (trace._hasSource) {
	                pixel = trace._canvas.el.getContext("2d", {
	                  willReadFrequently: true
	                }).getImageData(nx, ny, 1, 1).data;
	              }
	              if (!pixel) return;
	              var hoverinfo = cd0.hi || trace.hoverinfo;
	              var fmtColor;
	              if (hoverinfo) {
	                var parts = hoverinfo.split("+");
	                if (parts.indexOf("all") !== -1) parts = ["color"];
	                if (parts.indexOf("color") !== -1) fmtColor = true;
	              }
	              var cr = constants.colormodel[trace.colormodel];
	              var colormodel = cr.colormodel || trace.colormodel;
	              var dims = colormodel.length;
	              var c = trace._scaler(pixel);
	              var s = cr.suffix;
	              var colorstring = [];
	              if (trace.hovertemplate || fmtColor) {
	                colorstring.push("[" + [c[0] + s[0], c[1] + s[1], c[2] + s[2]].join(", "));
	                if (dims === 4) colorstring.push(", " + c[3] + s[3]);
	                colorstring.push("]");
	                colorstring = colorstring.join("");
	                pointData.extraText = colormodel.toUpperCase() + ": " + colorstring;
	              }
	              var text;
	              if (Array.isArray(trace.hovertext) && Array.isArray(trace.hovertext[ny])) {
	                text = trace.hovertext[ny][nx];
	              } else if (Array.isArray(trace.text) && Array.isArray(trace.text[ny])) {
	                text = trace.text[ny][nx];
	              }
	              var py = ya.c2p(cd0.y0 + (ny + 0.5) * trace.dy);
	              var xVal = cd0.x0 + (nx + 0.5) * trace.dx;
	              var yVal = cd0.y0 + (ny + 0.5) * trace.dy;
	              var zLabel = "[" + pixel.slice(0, trace.colormodel.length).join(", ") + "]";
	              return [Lib.extendFlat(pointData, {
	                index: [ny, nx],
	                x0: xa.c2p(cd0.x0 + nx * trace.dx),
	                x1: xa.c2p(cd0.x0 + (nx + 1) * trace.dx),
	                y0: py,
	                y1: py,
	                color: c,
	                xVal,
	                xLabelVal: xVal,
	                yVal,
	                yLabelVal: yVal,
	                zLabelVal: zLabel,
	                text,
	                hovertemplateLabels: {
	                  zLabel,
	                  colorLabel: colorstring,
	                  "color[0]Label": c[0] + s[0],
	                  "color[1]Label": c[1] + s[1],
	                  "color[2]Label": c[2] + s[2],
	                  "color[3]Label": c[3] + s[3]
	                }
	              })];
	            };
	          }
	        ),
	        /***/
	        94507: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(17230),
	              supplyDefaults: __webpack_require__2(13245),
	              calc: __webpack_require__2(71113),
	              plot: __webpack_require__2(60775),
	              style: __webpack_require__2(12826),
	              hoverPoints: __webpack_require__2(28749),
	              eventData: __webpack_require__2(30835),
	              moduleType: "trace",
	              name: "image",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "2dMap", "noSortingByValue"],
	              animatable: false,
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        60775: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            var constants = __webpack_require__2(51877);
	            var supportsPixelatedImage = __webpack_require__2(3883);
	            var PIXELATED_IMAGE_STYLE = __webpack_require__2(32396).STYLE;
	            module2.exports = function plot(gd, plotinfo, cdimage, imageLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var supportsPixelated = !gd._context._exportedPlot && supportsPixelatedImage();
	              Lib.makeTraceGroups(imageLayer, cdimage, "im").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var realImage = (trace.zsmooth === "fast" || trace.zsmooth === false && supportsPixelated) && !trace._hasZ && trace._hasSource && xa.type === "linear" && ya.type === "linear";
	                trace._realImage = realImage;
	                var z = cd0.z;
	                var x0 = cd0.x0;
	                var y0 = cd0.y0;
	                var w = cd0.w;
	                var h = cd0.h;
	                var dx = trace.dx;
	                var dy = trace.dy;
	                var left, right, temp, top, bottom, i;
	                i = 0;
	                while (left === undefined && i < w) {
	                  left = xa.c2p(x0 + i * dx);
	                  i++;
	                }
	                i = w;
	                while (right === undefined && i > 0) {
	                  right = xa.c2p(x0 + i * dx);
	                  i--;
	                }
	                i = 0;
	                while (top === undefined && i < h) {
	                  top = ya.c2p(y0 + i * dy);
	                  i++;
	                }
	                i = h;
	                while (bottom === undefined && i > 0) {
	                  bottom = ya.c2p(y0 + i * dy);
	                  i--;
	                }
	                if (right < left) {
	                  temp = right;
	                  right = left;
	                  left = temp;
	                }
	                if (bottom < top) {
	                  temp = top;
	                  top = bottom;
	                  bottom = temp;
	                }
	                if (!realImage) {
	                  var extra = 0.5;
	                  left = Math.max(-extra * xa._length, left);
	                  right = Math.min((1 + extra) * xa._length, right);
	                  top = Math.max(-extra * ya._length, top);
	                  bottom = Math.min((1 + extra) * ya._length, bottom);
	                }
	                var imageWidth = Math.round(right - left);
	                var imageHeight = Math.round(bottom - top);
	                var isOffScreen = imageWidth <= 0 || imageHeight <= 0;
	                if (isOffScreen) {
	                  var noImage = plotGroup.selectAll("image").data([]);
	                  noImage.exit().remove();
	                  return;
	                }
	                function drawMagnifiedPixelsOnCanvas(readPixel) {
	                  var canvas = document.createElement("canvas");
	                  canvas.width = imageWidth;
	                  canvas.height = imageHeight;
	                  var context = canvas.getContext("2d", {
	                    willReadFrequently: true
	                  });
	                  var ipx = function(i2) {
	                    return Lib.constrain(Math.round(xa.c2p(x0 + i2 * dx) - left), 0, imageWidth);
	                  };
	                  var jpx = function(j2) {
	                    return Lib.constrain(Math.round(ya.c2p(y0 + j2 * dy) - top), 0, imageHeight);
	                  };
	                  var cr = constants.colormodel[trace.colormodel];
	                  var colormodel = cr.colormodel || trace.colormodel;
	                  var fmt = cr.fmt;
	                  var c;
	                  for (i = 0; i < cd0.w; i++) {
	                    var ipx0 = ipx(i);
	                    var ipx1 = ipx(i + 1);
	                    if (ipx1 === ipx0 || isNaN(ipx1) || isNaN(ipx0)) continue;
	                    for (var j = 0; j < cd0.h; j++) {
	                      var jpx0 = jpx(j);
	                      var jpx1 = jpx(j + 1);
	                      if (jpx1 === jpx0 || isNaN(jpx1) || isNaN(jpx0) || !readPixel(i, j)) continue;
	                      c = trace._scaler(readPixel(i, j));
	                      if (c) {
	                        context.fillStyle = colormodel + "(" + fmt(c).join(",") + ")";
	                      } else {
	                        context.fillStyle = "rgba(0,0,0,0)";
	                      }
	                      context.fillRect(ipx0, jpx0, ipx1 - ipx0, jpx1 - jpx0);
	                    }
	                  }
	                  return canvas;
	                }
	                var image3 = plotGroup.selectAll("image").data([cd]);
	                image3.enter().append("svg:image").attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  preserveAspectRatio: "none"
	                });
	                image3.exit().remove();
	                var style = trace.zsmooth === false ? PIXELATED_IMAGE_STYLE : "";
	                if (realImage) {
	                  var xRange = Lib.simpleMap(xa.range, xa.r2l);
	                  var yRange = Lib.simpleMap(ya.range, ya.r2l);
	                  var flipX = xRange[1] < xRange[0];
	                  var flipY = yRange[1] > yRange[0];
	                  if (flipX || flipY) {
	                    var tx = left + imageWidth / 2;
	                    var ty = top + imageHeight / 2;
	                    style += "transform:" + strTranslate(tx + "px", ty + "px") + "scale(" + (flipX ? -1 : 1) + "," + (flipY ? -1 : 1) + ")" + strTranslate(-tx + "px", -ty + "px") + ";";
	                  }
	                }
	                image3.attr("style", style);
	                var p = new Promise(function(resolve) {
	                  if (trace._hasZ) {
	                    resolve();
	                  } else if (trace._hasSource) {
	                    if (trace._canvas && trace._canvas.el.width === w && trace._canvas.el.height === h && trace._canvas.source === trace.source) {
	                      resolve();
	                    } else {
	                      var canvas = document.createElement("canvas");
	                      canvas.width = w;
	                      canvas.height = h;
	                      var context = canvas.getContext("2d", {
	                        willReadFrequently: true
	                      });
	                      trace._image = trace._image || new Image();
	                      var image = trace._image;
	                      image.onload = function() {
	                        context.drawImage(image, 0, 0);
	                        trace._canvas = {
	                          el: canvas,
	                          source: trace.source
	                        };
	                        resolve();
	                      };
	                      image.setAttribute("src", trace.source);
	                    }
	                  }
	                }).then(function() {
	                  var href, canvas;
	                  if (trace._hasZ) {
	                    canvas = drawMagnifiedPixelsOnCanvas(function(i2, j) {
	                      return z[j][i2];
	                    });
	                    href = canvas.toDataURL("image/png");
	                  } else if (trace._hasSource) {
	                    if (realImage) {
	                      href = trace.source;
	                    } else {
	                      var context = trace._canvas.el.getContext("2d", {
	                        willReadFrequently: true
	                      });
	                      var data = context.getImageData(0, 0, w, h).data;
	                      canvas = drawMagnifiedPixelsOnCanvas(function(i2, j) {
	                        var index = 4 * (j * w + i2);
	                        return [data[index], data[index + 1], data[index + 2], data[index + 3]];
	                      });
	                      href = canvas.toDataURL("image/png");
	                    }
	                  }
	                  image3.attr({
	                    "xlink:href": href,
	                    height: imageHeight,
	                    width: imageWidth,
	                    x: left,
	                    y: top
	                  });
	                });
	                gd._promises.push(p);
	              });
	            };
	          }
	        ),
	        /***/
	        12826: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            module2.exports = function style(gd) {
	              d3.select(gd).selectAll(".im image").style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	            };
	          }
	        ),
	        /***/
	        54846: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var extendDeep = __webpack_require__2(1426).extendDeep;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var axesAttrs = __webpack_require__2(13838);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var delta = __webpack_require__2(22372);
	            var descriptionOnlyNumbers = __webpack_require__2(12663).descriptionOnlyNumbers;
	            var textFontAttrs = fontAttrs({
	              editType: "plot",
	              colorEditType: "plot"
	            });
	            var gaugeBarAttrs = {
	              color: {
	                valType: "color",
	                editType: "plot"
	              },
	              line: {
	                color: {
	                  valType: "color",
	                  dflt: colorAttrs.defaultLine,
	                  editType: "plot"
	                },
	                width: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "plot"
	                },
	                editType: "calc"
	              },
	              thickness: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 1,
	                editType: "plot"
	              },
	              editType: "calc"
	            };
	            var rangeAttr = {
	              valType: "info_array",
	              items: [{
	                valType: "number",
	                editType: "plot"
	              }, {
	                valType: "number",
	                editType: "plot"
	              }],
	              editType: "plot"
	            };
	            var stepsAttrs = templatedArray("step", extendDeep({}, gaugeBarAttrs, {
	              range: rangeAttr
	            }));
	            module2.exports = {
	              mode: {
	                valType: "flaglist",
	                editType: "calc",
	                flags: ["number", "delta", "gauge"],
	                dflt: "number"
	              },
	              value: {
	                valType: "number",
	                editType: "calc",
	                anim: true
	              },
	              align: {
	                valType: "enumerated",
	                values: ["left", "center", "right"],
	                editType: "plot"
	              },
	              // position
	              domain: domainAttrs({
	                name: "indicator",
	                trace: true,
	                editType: "calc"
	              }),
	              title: {
	                text: {
	                  valType: "string",
	                  editType: "plot"
	                },
	                align: {
	                  valType: "enumerated",
	                  values: ["left", "center", "right"],
	                  editType: "plot"
	                },
	                font: extendFlat({}, textFontAttrs, {}),
	                editType: "plot"
	              },
	              number: {
	                valueformat: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot",
	                  description: descriptionOnlyNumbers("value")
	                },
	                font: extendFlat({}, textFontAttrs, {}),
	                prefix: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot"
	                },
	                suffix: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              delta: {
	                reference: {
	                  valType: "number",
	                  editType: "calc"
	                },
	                position: {
	                  valType: "enumerated",
	                  values: ["top", "bottom", "left", "right"],
	                  dflt: "bottom",
	                  editType: "plot"
	                },
	                relative: {
	                  valType: "boolean",
	                  editType: "plot",
	                  dflt: false
	                },
	                valueformat: {
	                  valType: "string",
	                  editType: "plot",
	                  description: descriptionOnlyNumbers("value")
	                },
	                increasing: {
	                  symbol: {
	                    valType: "string",
	                    dflt: delta.INCREASING.SYMBOL,
	                    editType: "plot"
	                  },
	                  color: {
	                    valType: "color",
	                    dflt: delta.INCREASING.COLOR,
	                    editType: "plot"
	                  },
	                  // TODO: add attribute to show sign
	                  editType: "plot"
	                },
	                decreasing: {
	                  symbol: {
	                    valType: "string",
	                    dflt: delta.DECREASING.SYMBOL,
	                    editType: "plot"
	                  },
	                  color: {
	                    valType: "color",
	                    dflt: delta.DECREASING.COLOR,
	                    editType: "plot"
	                  },
	                  // TODO: add attribute to hide sign
	                  editType: "plot"
	                },
	                font: extendFlat({}, textFontAttrs, {}),
	                prefix: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot"
	                },
	                suffix: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot"
	                },
	                editType: "calc"
	              },
	              gauge: {
	                shape: {
	                  valType: "enumerated",
	                  editType: "plot",
	                  dflt: "angular",
	                  values: ["angular", "bullet"]
	                },
	                bar: extendDeep({}, gaugeBarAttrs, {
	                  color: {
	                    dflt: "green"
	                  }
	                }),
	                // Background of the gauge
	                bgcolor: {
	                  valType: "color",
	                  editType: "plot"
	                },
	                bordercolor: {
	                  valType: "color",
	                  dflt: colorAttrs.defaultLine,
	                  editType: "plot"
	                },
	                borderwidth: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 1,
	                  editType: "plot"
	                },
	                axis: overrideAll({
	                  range: rangeAttr,
	                  visible: extendFlat({}, axesAttrs.visible, {
	                    dflt: true
	                  }),
	                  // tick and title properties named and function exactly as in axes
	                  tickmode: axesAttrs.minor.tickmode,
	                  nticks: axesAttrs.nticks,
	                  tick0: axesAttrs.tick0,
	                  dtick: axesAttrs.dtick,
	                  tickvals: axesAttrs.tickvals,
	                  ticktext: axesAttrs.ticktext,
	                  ticks: extendFlat({}, axesAttrs.ticks, {
	                    dflt: "outside"
	                  }),
	                  ticklen: axesAttrs.ticklen,
	                  tickwidth: axesAttrs.tickwidth,
	                  tickcolor: axesAttrs.tickcolor,
	                  ticklabelstep: axesAttrs.ticklabelstep,
	                  showticklabels: axesAttrs.showticklabels,
	                  labelalias: axesAttrs.labelalias,
	                  tickfont: fontAttrs({}),
	                  tickangle: axesAttrs.tickangle,
	                  tickformat: axesAttrs.tickformat,
	                  tickformatstops: axesAttrs.tickformatstops,
	                  tickprefix: axesAttrs.tickprefix,
	                  showtickprefix: axesAttrs.showtickprefix,
	                  ticksuffix: axesAttrs.ticksuffix,
	                  showticksuffix: axesAttrs.showticksuffix,
	                  separatethousands: axesAttrs.separatethousands,
	                  exponentformat: axesAttrs.exponentformat,
	                  minexponent: axesAttrs.minexponent,
	                  showexponent: axesAttrs.showexponent,
	                  editType: "plot"
	                }, "plot"),
	                // Steps (or ranges) and thresholds
	                steps: stepsAttrs,
	                threshold: {
	                  line: {
	                    color: extendFlat({}, gaugeBarAttrs.line.color, {}),
	                    width: extendFlat({}, gaugeBarAttrs.line.width, {
	                      dflt: 1
	                    }),
	                    editType: "plot"
	                  },
	                  thickness: extendFlat({}, gaugeBarAttrs.thickness, {
	                    dflt: 0.85
	                  }),
	                  value: {
	                    valType: "number",
	                    editType: "calc",
	                    dflt: false
	                  },
	                  editType: "plot"
	                },
	                editType: "plot"
	                // TODO: in future version, add marker: (bar|needle)
	              }
	            };
	          }
	        ),
	        /***/
	        15970: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var plots = __webpack_require__2(74875);
	            exports2.name = "indicator";
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              plots.plotBasePlot(exports2.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              plots.cleanBasePlot(exports2.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	            };
	          }
	        ),
	        /***/
	        24667: (
	          /***/
	          function(module2) {
	            function calc(gd, trace) {
	              var cd = [];
	              var lastReading = trace.value;
	              if (!(typeof trace._lastValue === "number")) trace._lastValue = trace.value;
	              var secondLastReading = trace._lastValue;
	              var deltaRef = secondLastReading;
	              if (trace._hasDelta && typeof trace.delta.reference === "number") {
	                deltaRef = trace.delta.reference;
	              }
	              cd[0] = {
	                y: lastReading,
	                lastY: secondLastReading,
	                delta: lastReading - deltaRef,
	                relativeDelta: (lastReading - deltaRef) / deltaRef
	              };
	              return cd;
	            }
	            module2.exports = {
	              calc
	            };
	          }
	        ),
	        /***/
	        84577: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              // Defaults for delta
	              defaultNumberFontSize: 80,
	              bulletNumberDomainSize: 0.25,
	              bulletPadding: 0.025,
	              innerRadius: 0.75,
	              valueThickness: 0.5,
	              // thickness of value bars relative to full thickness,
	              titlePadding: 5,
	              horizontalPadding: 10
	            };
	          }
	        ),
	        /***/
	        94425: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(54846);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var Template = __webpack_require__2(44467);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var cn = __webpack_require__2(84577);
	            var handleTickValueDefaults = __webpack_require__2(26218);
	            var handleTickMarkDefaults = __webpack_require__2(38701);
	            var handleTickLabelDefaults = __webpack_require__2(96115);
	            var handlePrefixSuffixDefaults = __webpack_require__2(89426);
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              handleDomainDefaults(traceOut, layout, coerce);
	              coerce("mode");
	              traceOut._hasNumber = traceOut.mode.indexOf("number") !== -1;
	              traceOut._hasDelta = traceOut.mode.indexOf("delta") !== -1;
	              traceOut._hasGauge = traceOut.mode.indexOf("gauge") !== -1;
	              var value = coerce("value");
	              traceOut._range = [0, typeof value === "number" ? 1.5 * value : 1];
	              var auto = new Array(2);
	              var bignumberFontSize;
	              if (traceOut._hasNumber) {
	                coerce("number.valueformat");
	                coerce("number.font.color", layout.font.color);
	                coerce("number.font.family", layout.font.family);
	                coerce("number.font.size");
	                if (traceOut.number.font.size === undefined) {
	                  traceOut.number.font.size = cn.defaultNumberFontSize;
	                  auto[0] = true;
	                }
	                coerce("number.prefix");
	                coerce("number.suffix");
	                bignumberFontSize = traceOut.number.font.size;
	              }
	              var deltaFontSize;
	              if (traceOut._hasDelta) {
	                coerce("delta.font.color", layout.font.color);
	                coerce("delta.font.family", layout.font.family);
	                coerce("delta.font.size");
	                if (traceOut.delta.font.size === undefined) {
	                  traceOut.delta.font.size = (traceOut._hasNumber ? 0.5 : 1) * (bignumberFontSize || cn.defaultNumberFontSize);
	                  auto[1] = true;
	                }
	                coerce("delta.reference", traceOut.value);
	                coerce("delta.relative");
	                coerce("delta.valueformat", traceOut.delta.relative ? "2%" : "");
	                coerce("delta.increasing.symbol");
	                coerce("delta.increasing.color");
	                coerce("delta.decreasing.symbol");
	                coerce("delta.decreasing.color");
	                coerce("delta.position");
	                coerce("delta.prefix");
	                coerce("delta.suffix");
	                deltaFontSize = traceOut.delta.font.size;
	              }
	              traceOut._scaleNumbers = (!traceOut._hasNumber || auto[0]) && (!traceOut._hasDelta || auto[1]) || false;
	              coerce("title.font.color", layout.font.color);
	              coerce("title.font.family", layout.font.family);
	              coerce("title.font.size", 0.25 * (bignumberFontSize || deltaFontSize || cn.defaultNumberFontSize));
	              coerce("title.text");
	              var gaugeIn, gaugeOut, axisIn, axisOut;
	              function coerceGauge(attr, dflt) {
	                return Lib.coerce(gaugeIn, gaugeOut, attributes.gauge, attr, dflt);
	              }
	              function coerceGaugeAxis(attr, dflt) {
	                return Lib.coerce(axisIn, axisOut, attributes.gauge.axis, attr, dflt);
	              }
	              if (traceOut._hasGauge) {
	                gaugeIn = traceIn.gauge;
	                if (!gaugeIn) gaugeIn = {};
	                gaugeOut = Template.newContainer(traceOut, "gauge");
	                coerceGauge("shape");
	                var isBullet = traceOut._isBullet = traceOut.gauge.shape === "bullet";
	                if (!isBullet) {
	                  coerce("title.align", "center");
	                }
	                var isAngular = traceOut._isAngular = traceOut.gauge.shape === "angular";
	                if (!isAngular) {
	                  coerce("align", "center");
	                }
	                coerceGauge("bgcolor", layout.paper_bgcolor);
	                coerceGauge("borderwidth");
	                coerceGauge("bordercolor");
	                coerceGauge("bar.color");
	                coerceGauge("bar.line.color");
	                coerceGauge("bar.line.width");
	                var defaultBarThickness = cn.valueThickness * (traceOut.gauge.shape === "bullet" ? 0.5 : 1);
	                coerceGauge("bar.thickness", defaultBarThickness);
	                handleArrayContainerDefaults(gaugeIn, gaugeOut, {
	                  name: "steps",
	                  handleItemDefaults: stepDefaults
	                });
	                coerceGauge("threshold.value");
	                coerceGauge("threshold.thickness");
	                coerceGauge("threshold.line.width");
	                coerceGauge("threshold.line.color");
	                axisIn = {};
	                if (gaugeIn) axisIn = gaugeIn.axis || {};
	                axisOut = Template.newContainer(gaugeOut, "axis");
	                coerceGaugeAxis("visible");
	                traceOut._range = coerceGaugeAxis("range", traceOut._range);
	                var opts = {
	                  outerTicks: true
	                };
	                handleTickValueDefaults(axisIn, axisOut, coerceGaugeAxis, "linear");
	                handlePrefixSuffixDefaults(axisIn, axisOut, coerceGaugeAxis, "linear", opts);
	                handleTickLabelDefaults(axisIn, axisOut, coerceGaugeAxis, "linear", opts);
	                handleTickMarkDefaults(axisIn, axisOut, coerceGaugeAxis, opts);
	              } else {
	                coerce("title.align", "center");
	                coerce("align", "center");
	                traceOut._isAngular = traceOut._isBullet = false;
	              }
	              traceOut._length = null;
	            }
	            function stepDefaults(stepIn, stepOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(stepIn, stepOut, attributes.gauge.steps, attr, dflt);
	              }
	              coerce("color");
	              coerce("line.color");
	              coerce("line.width");
	              coerce("range");
	              coerce("thickness");
	            }
	            module2.exports = {
	              supplyDefaults
	            };
	          }
	        ),
	        /***/
	        15154: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "indicator",
	              basePlotModule: __webpack_require__2(15970),
	              categories: ["svg", "noOpacity", "noHover"],
	              animatable: true,
	              attributes: __webpack_require__2(54846),
	              supplyDefaults: __webpack_require__2(94425).supplyDefaults,
	              calc: __webpack_require__2(24667).calc,
	              plot: __webpack_require__2(75634),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        75634: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var interpolate = __webpack_require__2(81684).sX;
	            var interpolateNumber = __webpack_require__2(81684).k4;
	            var Lib = __webpack_require__2(71828);
	            var strScale = Lib.strScale;
	            var strTranslate = Lib.strTranslate;
	            var rad2deg = Lib.rad2deg;
	            var MID_SHIFT = __webpack_require__2(18783).MID_SHIFT;
	            var Drawing = __webpack_require__2(91424);
	            var cn = __webpack_require__2(84577);
	            var svgTextUtils = __webpack_require__2(63893);
	            var Axes = __webpack_require__2(89298);
	            var handleAxisDefaults = __webpack_require__2(71453);
	            var handleAxisPositionDefaults = __webpack_require__2(52830);
	            var axisLayoutAttrs = __webpack_require__2(13838);
	            var Color = __webpack_require__2(7901);
	            var anchor = {
	              left: "start",
	              center: "middle",
	              right: "end"
	            };
	            var position = {
	              left: 0,
	              center: 0.5,
	              right: 1
	            };
	            var SI_PREFIX = /[yzafpnµmkMGTPEZY]/;
	            function hasTransition(transitionOpts) {
	              return transitionOpts && transitionOpts.duration > 0;
	            }
	            module2.exports = function plot(gd, cdModule, transitionOpts, makeOnCompleteCallback) {
	              var fullLayout = gd._fullLayout;
	              var onComplete;
	              if (hasTransition(transitionOpts)) {
	                if (makeOnCompleteCallback) {
	                  onComplete = makeOnCompleteCallback();
	                }
	              }
	              Lib.makeTraceGroups(fullLayout._indicatorlayer, cdModule, "trace").each(function(cd) {
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var plotGroup = d3.select(this);
	                var hasGauge = trace._hasGauge;
	                var isAngular = trace._isAngular;
	                var isBullet = trace._isBullet;
	                var domain = trace.domain;
	                var size = {
	                  w: fullLayout._size.w * (domain.x[1] - domain.x[0]),
	                  h: fullLayout._size.h * (domain.y[1] - domain.y[0]),
	                  l: fullLayout._size.l + fullLayout._size.w * domain.x[0],
	                  r: fullLayout._size.r + fullLayout._size.w * (1 - domain.x[1]),
	                  t: fullLayout._size.t + fullLayout._size.h * (1 - domain.y[1]),
	                  b: fullLayout._size.b + fullLayout._size.h * domain.y[0]
	                };
	                var centerX = size.l + size.w / 2;
	                var centerY = size.t + size.h / 2;
	                var radius = Math.min(size.w / 2, size.h);
	                var innerRadius = cn.innerRadius * radius;
	                var numbersX, numbersY, numbersScaler;
	                var numbersAlign = trace.align || "center";
	                numbersY = centerY;
	                if (!hasGauge) {
	                  numbersX = size.l + position[numbersAlign] * size.w;
	                  numbersScaler = function(el) {
	                    return fitTextInsideBox(el, size.w, size.h);
	                  };
	                } else {
	                  if (isAngular) {
	                    numbersX = centerX;
	                    numbersY = centerY + radius / 2;
	                    numbersScaler = function(el) {
	                      return fitTextInsideCircle(el, 0.9 * innerRadius);
	                    };
	                  }
	                  if (isBullet) {
	                    var padding = cn.bulletPadding;
	                    var p = 1 - cn.bulletNumberDomainSize + padding;
	                    numbersX = size.l + (p + (1 - p) * position[numbersAlign]) * size.w;
	                    numbersScaler = function(el) {
	                      return fitTextInsideBox(el, (cn.bulletNumberDomainSize - padding) * size.w, size.h);
	                    };
	                  }
	                }
	                drawNumbers(gd, plotGroup, cd, {
	                  numbersX,
	                  numbersY,
	                  numbersScaler,
	                  transitionOpts,
	                  onComplete
	                });
	                var gaugeBg, gaugeOutline;
	                if (hasGauge) {
	                  gaugeBg = {
	                    range: trace.gauge.axis.range,
	                    color: trace.gauge.bgcolor,
	                    line: {
	                      color: trace.gauge.bordercolor,
	                      width: 0
	                    },
	                    thickness: 1
	                  };
	                  gaugeOutline = {
	                    range: trace.gauge.axis.range,
	                    color: "rgba(0, 0, 0, 0)",
	                    line: {
	                      color: trace.gauge.bordercolor,
	                      width: trace.gauge.borderwidth
	                    },
	                    thickness: 1
	                  };
	                }
	                var angularGauge = plotGroup.selectAll("g.angular").data(isAngular ? cd : []);
	                angularGauge.exit().remove();
	                var angularaxisLayer = plotGroup.selectAll("g.angularaxis").data(isAngular ? cd : []);
	                angularaxisLayer.exit().remove();
	                if (isAngular) {
	                  drawAngularGauge(gd, plotGroup, cd, {
	                    radius,
	                    innerRadius,
	                    gauge: angularGauge,
	                    layer: angularaxisLayer,
	                    size,
	                    gaugeBg,
	                    gaugeOutline,
	                    transitionOpts,
	                    onComplete
	                  });
	                }
	                var bulletGauge = plotGroup.selectAll("g.bullet").data(isBullet ? cd : []);
	                bulletGauge.exit().remove();
	                var bulletaxisLayer = plotGroup.selectAll("g.bulletaxis").data(isBullet ? cd : []);
	                bulletaxisLayer.exit().remove();
	                if (isBullet) {
	                  drawBulletGauge(gd, plotGroup, cd, {
	                    gauge: bulletGauge,
	                    layer: bulletaxisLayer,
	                    size,
	                    gaugeBg,
	                    gaugeOutline,
	                    transitionOpts,
	                    onComplete
	                  });
	                }
	                var title = plotGroup.selectAll("text.title").data(cd);
	                title.exit().remove();
	                title.enter().append("text").classed("title", true);
	                title.attr("text-anchor", function() {
	                  return isBullet ? anchor.right : anchor[trace.title.align];
	                }).text(trace.title.text).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
	                title.attr("transform", function() {
	                  var titleX = size.l + size.w * position[trace.title.align];
	                  var titleY;
	                  var titlePadding = cn.titlePadding;
	                  var titlebBox = Drawing.bBox(title.node());
	                  if (hasGauge) {
	                    if (isAngular) {
	                      if (trace.gauge.axis.visible) {
	                        var bBox = Drawing.bBox(angularaxisLayer.node());
	                        titleY = bBox.top - titlePadding - titlebBox.bottom;
	                      } else {
	                        titleY = size.t + size.h / 2 - radius / 2 - titlebBox.bottom - titlePadding;
	                      }
	                    }
	                    if (isBullet) {
	                      titleY = numbersY - (titlebBox.top + titlebBox.bottom) / 2;
	                      titleX = size.l - cn.bulletPadding * size.w;
	                    }
	                  } else {
	                    titleY = trace._numbersTop - titlePadding - titlebBox.bottom;
	                  }
	                  return strTranslate(titleX, titleY);
	                });
	              });
	            };
	            function drawBulletGauge(gd, plotGroup, cd, opts) {
	              var trace = cd[0].trace;
	              var bullet = opts.gauge;
	              var axisLayer = opts.layer;
	              var gaugeBg = opts.gaugeBg;
	              var gaugeOutline = opts.gaugeOutline;
	              var size = opts.size;
	              var domain = trace.domain;
	              var transitionOpts = opts.transitionOpts;
	              var onComplete = opts.onComplete;
	              var ax, vals, transFn, tickSign, shift;
	              bullet.enter().append("g").classed("bullet", true);
	              bullet.attr("transform", strTranslate(size.l, size.t));
	              axisLayer.enter().append("g").classed("bulletaxis", true).classed("crisp", true);
	              axisLayer.selectAll("g.xbulletaxistick,path,text").remove();
	              var bulletHeight = size.h;
	              var innerBulletHeight = trace.gauge.bar.thickness * bulletHeight;
	              var bulletLeft = domain.x[0];
	              var bulletRight = domain.x[0] + (domain.x[1] - domain.x[0]) * (trace._hasNumber || trace._hasDelta ? 1 - cn.bulletNumberDomainSize : 1);
	              ax = mockAxis(gd, trace.gauge.axis);
	              ax._id = "xbulletaxis";
	              ax.domain = [bulletLeft, bulletRight];
	              ax.setScale();
	              vals = Axes.calcTicks(ax);
	              transFn = Axes.makeTransTickFn(ax);
	              tickSign = Axes.getTickSigns(ax)[2];
	              shift = size.t + size.h;
	              if (ax.visible) {
	                Axes.drawTicks(gd, ax, {
	                  vals: ax.ticks === "inside" ? Axes.clipEnds(ax, vals) : vals,
	                  layer: axisLayer,
	                  path: Axes.makeTickPath(ax, shift, tickSign),
	                  transFn
	                });
	                Axes.drawLabels(gd, ax, {
	                  vals,
	                  layer: axisLayer,
	                  transFn,
	                  labelFns: Axes.makeLabelFns(ax, shift)
	                });
	              }
	              function drawRect(s) {
	                s.attr("width", function(d) {
	                  return Math.max(0, ax.c2p(d.range[1]) - ax.c2p(d.range[0]));
	                }).attr("x", function(d) {
	                  return ax.c2p(d.range[0]);
	                }).attr("y", function(d) {
	                  return 0.5 * (1 - d.thickness) * bulletHeight;
	                }).attr("height", function(d) {
	                  return d.thickness * bulletHeight;
	                });
	              }
	              var boxes = [gaugeBg].concat(trace.gauge.steps);
	              var bgBullet = bullet.selectAll("g.bg-bullet").data(boxes);
	              bgBullet.enter().append("g").classed("bg-bullet", true).append("rect");
	              bgBullet.select("rect").call(drawRect).call(styleShape);
	              bgBullet.exit().remove();
	              var fgBullet = bullet.selectAll("g.value-bullet").data([trace.gauge.bar]);
	              fgBullet.enter().append("g").classed("value-bullet", true).append("rect");
	              fgBullet.select("rect").attr("height", innerBulletHeight).attr("y", (bulletHeight - innerBulletHeight) / 2).call(styleShape);
	              if (hasTransition(transitionOpts)) {
	                fgBullet.select("rect").transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each("end", function() {
	                  onComplete && onComplete();
	                }).each("interrupt", function() {
	                  onComplete && onComplete();
	                }).attr("width", Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))));
	              } else {
	                fgBullet.select("rect").attr("width", typeof cd[0].y === "number" ? Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))) : 0);
	              }
	              fgBullet.exit().remove();
	              var data = cd.filter(function() {
	                return trace.gauge.threshold.value || trace.gauge.threshold.value === 0;
	              });
	              var threshold = bullet.selectAll("g.threshold-bullet").data(data);
	              threshold.enter().append("g").classed("threshold-bullet", true).append("line");
	              threshold.select("line").attr("x1", ax.c2p(trace.gauge.threshold.value)).attr("x2", ax.c2p(trace.gauge.threshold.value)).attr("y1", (1 - trace.gauge.threshold.thickness) / 2 * bulletHeight).attr("y2", (1 - (1 - trace.gauge.threshold.thickness) / 2) * bulletHeight).call(Color.stroke, trace.gauge.threshold.line.color).style("stroke-width", trace.gauge.threshold.line.width);
	              threshold.exit().remove();
	              var bulletOutline = bullet.selectAll("g.gauge-outline").data([gaugeOutline]);
	              bulletOutline.enter().append("g").classed("gauge-outline", true).append("rect");
	              bulletOutline.select("rect").call(drawRect).call(styleShape);
	              bulletOutline.exit().remove();
	            }
	            function drawAngularGauge(gd, plotGroup, cd, opts) {
	              var trace = cd[0].trace;
	              var size = opts.size;
	              var radius = opts.radius;
	              var innerRadius = opts.innerRadius;
	              var gaugeBg = opts.gaugeBg;
	              var gaugeOutline = opts.gaugeOutline;
	              var gaugePosition = [size.l + size.w / 2, size.t + size.h / 2 + radius / 2];
	              var gauge = opts.gauge;
	              var axisLayer = opts.layer;
	              var transitionOpts = opts.transitionOpts;
	              var onComplete = opts.onComplete;
	              var theta = Math.PI / 2;
	              function valueToAngle(v2) {
	                var min = trace.gauge.axis.range[0];
	                var max = trace.gauge.axis.range[1];
	                var angle = (v2 - min) / (max - min) * Math.PI - theta;
	                if (angle < -theta) return -theta;
	                if (angle > theta) return theta;
	                return angle;
	              }
	              function arcPathGenerator(size2) {
	                return d3.svg.arc().innerRadius((innerRadius + radius) / 2 - size2 / 2 * (radius - innerRadius)).outerRadius((innerRadius + radius) / 2 + size2 / 2 * (radius - innerRadius)).startAngle(-theta);
	              }
	              function drawArc(p) {
	                p.attr("d", function(d) {
	                  return arcPathGenerator(d.thickness).startAngle(valueToAngle(d.range[0])).endAngle(valueToAngle(d.range[1]))();
	                });
	              }
	              var ax, vals, transFn, tickSign;
	              gauge.enter().append("g").classed("angular", true);
	              gauge.attr("transform", strTranslate(gaugePosition[0], gaugePosition[1]));
	              axisLayer.enter().append("g").classed("angularaxis", true).classed("crisp", true);
	              axisLayer.selectAll("g.xangularaxistick,path,text").remove();
	              ax = mockAxis(gd, trace.gauge.axis);
	              ax.type = "linear";
	              ax.range = trace.gauge.axis.range;
	              ax._id = "xangularaxis";
	              ax.ticklabeloverflow = "allow";
	              ax.setScale();
	              var t2g = function(d) {
	                return (ax.range[0] - d.x) / (ax.range[1] - ax.range[0]) * Math.PI + Math.PI;
	              };
	              var labelFns = {};
	              var out = Axes.makeLabelFns(ax, 0);
	              var labelStandoff = out.labelStandoff;
	              labelFns.xFn = function(d) {
	                var rad = t2g(d);
	                return Math.cos(rad) * labelStandoff;
	              };
	              labelFns.yFn = function(d) {
	                var rad = t2g(d);
	                var ff = Math.sin(rad) > 0 ? 0.2 : 1;
	                return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) + Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
	              };
	              labelFns.anchorFn = function(d) {
	                var rad = t2g(d);
	                var cos = Math.cos(rad);
	                return Math.abs(cos) < 0.1 ? "middle" : cos > 0 ? "start" : "end";
	              };
	              labelFns.heightFn = function(d, a, h) {
	                var rad = t2g(d);
	                return -0.5 * (1 + Math.sin(rad)) * h;
	              };
	              var _transFn = function(rad) {
	                return strTranslate(gaugePosition[0] + radius * Math.cos(rad), gaugePosition[1] - radius * Math.sin(rad));
	              };
	              transFn = function(d) {
	                return _transFn(t2g(d));
	              };
	              var transFn2 = function(d) {
	                var rad = t2g(d);
	                return _transFn(rad) + "rotate(" + -rad2deg(rad) + ")";
	              };
	              vals = Axes.calcTicks(ax);
	              tickSign = Axes.getTickSigns(ax)[2];
	              if (ax.visible) {
	                tickSign = ax.ticks === "inside" ? -1 : 1;
	                var pad = (ax.linewidth || 1) / 2;
	                Axes.drawTicks(gd, ax, {
	                  vals,
	                  layer: axisLayer,
	                  path: "M" + tickSign * pad + ",0h" + tickSign * ax.ticklen,
	                  transFn: transFn2
	                });
	                Axes.drawLabels(gd, ax, {
	                  vals,
	                  layer: axisLayer,
	                  transFn,
	                  labelFns
	                });
	              }
	              var arcs = [gaugeBg].concat(trace.gauge.steps);
	              var bgArc = gauge.selectAll("g.bg-arc").data(arcs);
	              bgArc.enter().append("g").classed("bg-arc", true).append("path");
	              bgArc.select("path").call(drawArc).call(styleShape);
	              bgArc.exit().remove();
	              var valueArcPathGenerator = arcPathGenerator(trace.gauge.bar.thickness);
	              var valueArc = gauge.selectAll("g.value-arc").data([trace.gauge.bar]);
	              valueArc.enter().append("g").classed("value-arc", true).append("path");
	              var valueArcPath = valueArc.select("path");
	              if (hasTransition(transitionOpts)) {
	                valueArcPath.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each("end", function() {
	                  onComplete && onComplete();
	                }).each("interrupt", function() {
	                  onComplete && onComplete();
	                }).attrTween("d", arcTween(valueArcPathGenerator, valueToAngle(cd[0].lastY), valueToAngle(cd[0].y)));
	                trace._lastValue = cd[0].y;
	              } else {
	                valueArcPath.attr("d", typeof cd[0].y === "number" ? valueArcPathGenerator.endAngle(valueToAngle(cd[0].y)) : "M0,0Z");
	              }
	              valueArcPath.call(styleShape);
	              valueArc.exit().remove();
	              arcs = [];
	              var v = trace.gauge.threshold.value;
	              if (v || v === 0) {
	                arcs.push({
	                  range: [v, v],
	                  color: trace.gauge.threshold.color,
	                  line: {
	                    color: trace.gauge.threshold.line.color,
	                    width: trace.gauge.threshold.line.width
	                  },
	                  thickness: trace.gauge.threshold.thickness
	                });
	              }
	              var thresholdArc = gauge.selectAll("g.threshold-arc").data(arcs);
	              thresholdArc.enter().append("g").classed("threshold-arc", true).append("path");
	              thresholdArc.select("path").call(drawArc).call(styleShape);
	              thresholdArc.exit().remove();
	              var gaugeBorder = gauge.selectAll("g.gauge-outline").data([gaugeOutline]);
	              gaugeBorder.enter().append("g").classed("gauge-outline", true).append("path");
	              gaugeBorder.select("path").call(drawArc).call(styleShape);
	              gaugeBorder.exit().remove();
	            }
	            function drawNumbers(gd, plotGroup, cd, opts) {
	              var trace = cd[0].trace;
	              var numbersX = opts.numbersX;
	              var numbersY = opts.numbersY;
	              var numbersAlign = trace.align || "center";
	              var numbersAnchor = anchor[numbersAlign];
	              var transitionOpts = opts.transitionOpts;
	              var onComplete = opts.onComplete;
	              var numbers = Lib.ensureSingle(plotGroup, "g", "numbers");
	              var bignumberbBox, deltabBox;
	              var numbersbBox;
	              var data = [];
	              if (trace._hasNumber) data.push("number");
	              if (trace._hasDelta) {
	                data.push("delta");
	                if (trace.delta.position === "left") data.reverse();
	              }
	              var sel = numbers.selectAll("text").data(data);
	              sel.enter().append("text");
	              sel.attr("text-anchor", function() {
	                return numbersAnchor;
	              }).attr("class", function(d) {
	                return d;
	              }).attr("x", null).attr("y", null).attr("dx", null).attr("dy", null);
	              sel.exit().remove();
	              function transitionFormat(valueformat, fmt, from, to) {
	                if (valueformat.match("s") && // If using SI prefix
	                from >= 0 !== to >= 0 && // If sign change
	                !fmt(from).slice(-1).match(SI_PREFIX) && !fmt(to).slice(-1).match(SI_PREFIX)) {
	                  var transitionValueFormat = valueformat.slice().replace("s", "f").replace(/\d+/, function(m) {
	                    return parseInt(m) - 1;
	                  });
	                  var transitionAx = mockAxis(gd, {
	                    tickformat: transitionValueFormat
	                  });
	                  return function(v) {
	                    if (Math.abs(v) < 1) return Axes.tickText(transitionAx, v).text;
	                    return fmt(v);
	                  };
	                } else {
	                  return fmt;
	                }
	              }
	              function drawBignumber() {
	                var bignumberAx = mockAxis(gd, {
	                  tickformat: trace.number.valueformat
	                }, trace._range);
	                bignumberAx.setScale();
	                Axes.prepTicks(bignumberAx);
	                var bignumberFmt = function(v) {
	                  return Axes.tickText(bignumberAx, v).text;
	                };
	                var bignumberSuffix = trace.number.suffix;
	                var bignumberPrefix = trace.number.prefix;
	                var number2 = numbers.select("text.number");
	                function writeNumber() {
	                  var txt = typeof cd[0].y === "number" ? bignumberPrefix + bignumberFmt(cd[0].y) + bignumberSuffix : "-";
	                  number2.text(txt).call(Drawing.font, trace.number.font).call(svgTextUtils.convertToTspans, gd);
	                }
	                if (hasTransition(transitionOpts)) {
	                  number2.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each("end", function() {
	                    writeNumber();
	                    onComplete && onComplete();
	                  }).each("interrupt", function() {
	                    writeNumber();
	                    onComplete && onComplete();
	                  }).attrTween("text", function() {
	                    var that = d3.select(this);
	                    var interpolator = interpolateNumber(cd[0].lastY, cd[0].y);
	                    trace._lastValue = cd[0].y;
	                    var transitionFmt = transitionFormat(trace.number.valueformat, bignumberFmt, cd[0].lastY, cd[0].y);
	                    return function(t) {
	                      that.text(bignumberPrefix + transitionFmt(interpolator(t)) + bignumberSuffix);
	                    };
	                  });
	                } else {
	                  writeNumber();
	                }
	                bignumberbBox = measureText(bignumberPrefix + bignumberFmt(cd[0].y) + bignumberSuffix, trace.number.font, numbersAnchor, gd);
	                return number2;
	              }
	              function drawDelta() {
	                var deltaAx = mockAxis(gd, {
	                  tickformat: trace.delta.valueformat
	                }, trace._range);
	                deltaAx.setScale();
	                Axes.prepTicks(deltaAx);
	                var deltaFmt = function(v) {
	                  return Axes.tickText(deltaAx, v).text;
	                };
	                var deltaSuffix = trace.delta.suffix;
	                var deltaPrefix = trace.delta.prefix;
	                var deltaValue = function(d) {
	                  var value = trace.delta.relative ? d.relativeDelta : d.delta;
	                  return value;
	                };
	                var deltaFormatText = function(value, numberFmt) {
	                  if (value === 0 || typeof value !== "number" || isNaN(value)) return "-";
	                  return (value > 0 ? trace.delta.increasing.symbol : trace.delta.decreasing.symbol) + deltaPrefix + numberFmt(value) + deltaSuffix;
	                };
	                var deltaFill = function(d) {
	                  return d.delta >= 0 ? trace.delta.increasing.color : trace.delta.decreasing.color;
	                };
	                if (trace._deltaLastValue === undefined) {
	                  trace._deltaLastValue = deltaValue(cd[0]);
	                }
	                var delta2 = numbers.select("text.delta");
	                delta2.call(Drawing.font, trace.delta.font).call(Color.fill, deltaFill({
	                  delta: trace._deltaLastValue
	                }));
	                function writeDelta() {
	                  delta2.text(deltaFormatText(deltaValue(cd[0]), deltaFmt)).call(Color.fill, deltaFill(cd[0])).call(svgTextUtils.convertToTspans, gd);
	                }
	                if (hasTransition(transitionOpts)) {
	                  delta2.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).tween("text", function() {
	                    var that = d3.select(this);
	                    var to = deltaValue(cd[0]);
	                    var from = trace._deltaLastValue;
	                    var transitionFmt = transitionFormat(trace.delta.valueformat, deltaFmt, from, to);
	                    var interpolator = interpolateNumber(from, to);
	                    trace._deltaLastValue = to;
	                    return function(t) {
	                      that.text(deltaFormatText(interpolator(t), transitionFmt));
	                      that.call(Color.fill, deltaFill({
	                        delta: interpolator(t)
	                      }));
	                    };
	                  }).each("end", function() {
	                    writeDelta();
	                    onComplete && onComplete();
	                  }).each("interrupt", function() {
	                    writeDelta();
	                    onComplete && onComplete();
	                  });
	                } else {
	                  writeDelta();
	                }
	                deltabBox = measureText(deltaFormatText(deltaValue(cd[0]), deltaFmt), trace.delta.font, numbersAnchor, gd);
	                return delta2;
	              }
	              var key = trace.mode + trace.align;
	              var delta;
	              if (trace._hasDelta) {
	                delta = drawDelta();
	                key += trace.delta.position + trace.delta.font.size + trace.delta.font.family + trace.delta.valueformat;
	                key += trace.delta.increasing.symbol + trace.delta.decreasing.symbol;
	                numbersbBox = deltabBox;
	              }
	              if (trace._hasNumber) {
	                drawBignumber();
	                key += trace.number.font.size + trace.number.font.family + trace.number.valueformat + trace.number.suffix + trace.number.prefix;
	                numbersbBox = bignumberbBox;
	              }
	              if (trace._hasDelta && trace._hasNumber) {
	                var bignumberCenter = [(bignumberbBox.left + bignumberbBox.right) / 2, (bignumberbBox.top + bignumberbBox.bottom) / 2];
	                var deltaCenter = [(deltabBox.left + deltabBox.right) / 2, (deltabBox.top + deltabBox.bottom) / 2];
	                var dx, dy;
	                var padding = 0.75 * trace.delta.font.size;
	                if (trace.delta.position === "left") {
	                  dx = cache(trace, "deltaPos", 0, -1 * (bignumberbBox.width * position[trace.align] + deltabBox.width * (1 - position[trace.align]) + padding), key, Math.min);
	                  dy = bignumberCenter[1] - deltaCenter[1];
	                  numbersbBox = {
	                    width: bignumberbBox.width + deltabBox.width + padding,
	                    height: Math.max(bignumberbBox.height, deltabBox.height),
	                    left: deltabBox.left + dx,
	                    right: bignumberbBox.right,
	                    top: Math.min(bignumberbBox.top, deltabBox.top + dy),
	                    bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
	                  };
	                }
	                if (trace.delta.position === "right") {
	                  dx = cache(trace, "deltaPos", 0, bignumberbBox.width * (1 - position[trace.align]) + deltabBox.width * position[trace.align] + padding, key, Math.max);
	                  dy = bignumberCenter[1] - deltaCenter[1];
	                  numbersbBox = {
	                    width: bignumberbBox.width + deltabBox.width + padding,
	                    height: Math.max(bignumberbBox.height, deltabBox.height),
	                    left: bignumberbBox.left,
	                    right: deltabBox.right + dx,
	                    top: Math.min(bignumberbBox.top, deltabBox.top + dy),
	                    bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
	                  };
	                }
	                if (trace.delta.position === "bottom") {
	                  dx = null;
	                  dy = deltabBox.height;
	                  numbersbBox = {
	                    width: Math.max(bignumberbBox.width, deltabBox.width),
	                    height: bignumberbBox.height + deltabBox.height,
	                    left: Math.min(bignumberbBox.left, deltabBox.left),
	                    right: Math.max(bignumberbBox.right, deltabBox.right),
	                    top: bignumberbBox.bottom - bignumberbBox.height,
	                    bottom: bignumberbBox.bottom + deltabBox.height
	                  };
	                }
	                if (trace.delta.position === "top") {
	                  dx = null;
	                  dy = bignumberbBox.top;
	                  numbersbBox = {
	                    width: Math.max(bignumberbBox.width, deltabBox.width),
	                    height: bignumberbBox.height + deltabBox.height,
	                    left: Math.min(bignumberbBox.left, deltabBox.left),
	                    right: Math.max(bignumberbBox.right, deltabBox.right),
	                    top: bignumberbBox.bottom - bignumberbBox.height - deltabBox.height,
	                    bottom: bignumberbBox.bottom
	                  };
	                }
	                delta.attr({
	                  dx,
	                  dy
	                });
	              }
	              if (trace._hasNumber || trace._hasDelta) {
	                numbers.attr("transform", function() {
	                  var m = opts.numbersScaler(numbersbBox);
	                  key += m[2];
	                  var scaleRatio = cache(trace, "numbersScale", 1, m[0], key, Math.min);
	                  var translateY;
	                  if (!trace._scaleNumbers) scaleRatio = 1;
	                  if (trace._isAngular) {
	                    translateY = numbersY - scaleRatio * numbersbBox.bottom;
	                  } else {
	                    translateY = numbersY - scaleRatio * (numbersbBox.top + numbersbBox.bottom) / 2;
	                  }
	                  trace._numbersTop = scaleRatio * numbersbBox.top + translateY;
	                  var ref = numbersbBox[numbersAlign];
	                  if (numbersAlign === "center") ref = (numbersbBox.left + numbersbBox.right) / 2;
	                  var translateX = numbersX - scaleRatio * ref;
	                  translateX = cache(trace, "numbersTranslate", 0, translateX, key, Math.max);
	                  return strTranslate(translateX, translateY) + strScale(scaleRatio);
	                });
	              }
	            }
	            function styleShape(p) {
	              p.each(function(d) {
	                Color.stroke(d3.select(this), d.line.color);
	              }).each(function(d) {
	                Color.fill(d3.select(this), d.color);
	              }).style("stroke-width", function(d) {
	                return d.line.width;
	              });
	            }
	            function arcTween(arc, endAngle, newAngle) {
	              return function() {
	                var interp = interpolate(endAngle, newAngle);
	                return function(t) {
	                  return arc.endAngle(interp(t))();
	                };
	              };
	            }
	            function mockAxis(gd, opts, zrange) {
	              var fullLayout = gd._fullLayout;
	              var axisIn = Lib.extendFlat({
	                type: "linear",
	                ticks: "outside",
	                range: zrange,
	                showline: true
	              }, opts);
	              var axisOut = {
	                type: "linear",
	                _id: "x" + opts._id
	              };
	              var axisOptions = {
	                letter: "x",
	                font: fullLayout.font,
	                noHover: true,
	                noTickson: true
	              };
	              function coerce(attr, dflt) {
	                return Lib.coerce(axisIn, axisOut, axisLayoutAttrs, attr, dflt);
	              }
	              handleAxisDefaults(axisIn, axisOut, coerce, axisOptions, fullLayout);
	              handleAxisPositionDefaults(axisIn, axisOut, coerce, axisOptions);
	              return axisOut;
	            }
	            function fitTextInsideBox(textBB, width, height) {
	              var ratio = Math.min(width / textBB.width, height / textBB.height);
	              return [ratio, textBB, width + "x" + height];
	            }
	            function fitTextInsideCircle(textBB, radius) {
	              var elRadius = Math.sqrt(textBB.width / 2 * (textBB.width / 2) + textBB.height * textBB.height);
	              var ratio = radius / elRadius;
	              return [ratio, textBB, radius];
	            }
	            function measureText(txt, font, textAnchor, gd) {
	              var element = document.createElementNS("http://www.w3.org/2000/svg", "text");
	              var sel = d3.select(element);
	              sel.text(txt).attr("x", 0).attr("y", 0).attr("text-anchor", textAnchor).attr("data-unformatted", txt).call(svgTextUtils.convertToTspans, gd).call(Drawing.font, font);
	              return Drawing.bBox(sel.node());
	            }
	            function cache(trace, name2, initialValue, value, key, fn) {
	              var objName = "_cache" + name2;
	              if (!(trace[objName] && trace[objName].key === key)) {
	                trace[objName] = {
	                  key,
	                  value: initialValue
	                };
	              }
	              var v = Lib.aggNums(fn, null, [trace[objName].value, value], 2);
	              trace[objName].value = v;
	              return v;
	            }
	          }
	        ),
	        /***/
	        16249: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var meshAttrs = __webpack_require__2(2418);
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            function makeSliceAttr(axLetter) {
	              return {
	                show: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                locations: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                fill: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                }
	              };
	            }
	            function makeCapAttr(axLetter) {
	              return {
	                show: {
	                  valType: "boolean",
	                  dflt: true
	                },
	                fill: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                }
	              };
	            }
	            var attrs = module2.exports = overrideAll(extendFlat({
	              x: {
	                valType: "data_array"
	              },
	              y: {
	                valType: "data_array"
	              },
	              z: {
	                valType: "data_array"
	              },
	              value: {
	                valType: "data_array"
	              },
	              isomin: {
	                valType: "number"
	              },
	              isomax: {
	                valType: "number"
	              },
	              surface: {
	                show: {
	                  valType: "boolean",
	                  dflt: true
	                },
	                count: {
	                  valType: "integer",
	                  dflt: 2,
	                  min: 1
	                },
	                fill: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                },
	                pattern: {
	                  valType: "flaglist",
	                  flags: ["A", "B", "C", "D", "E"],
	                  extras: ["all", "odd", "even"],
	                  dflt: "all"
	                }
	              },
	              spaceframe: {
	                show: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                fill: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.15
	                }
	              },
	              slices: {
	                x: makeSliceAttr(),
	                y: makeSliceAttr(),
	                z: makeSliceAttr()
	              },
	              caps: {
	                x: makeCapAttr(),
	                y: makeCapAttr(),
	                z: makeCapAttr()
	              },
	              text: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true
	              },
	              hovertemplate: hovertemplateAttrs(),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z"),
	              valuehoverformat: axisHoverFormat("value", 1),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }, colorScaleAttrs("", {
	              colorAttr: "`value`",
	              showScaleDflt: true,
	              editTypeOverride: "calc"
	            }), {
	              opacity: meshAttrs.opacity,
	              lightposition: meshAttrs.lightposition,
	              lighting: meshAttrs.lighting,
	              flatshading: meshAttrs.flatshading,
	              contour: meshAttrs.contour,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
	            }), "calc", "nested");
	            attrs.flatshading.dflt = true;
	            attrs.lighting.facenormalsepsilon.dflt = 0;
	            attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = "calc+clearAxisTypes";
	            attrs.transforms = undefined;
	          }
	        ),
	        /***/
	        56959: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorscaleCalc = __webpack_require__2(78803);
	            var processGrid = __webpack_require__2(88489).processGrid;
	            var filter = __webpack_require__2(88489).filter;
	            module2.exports = function calc(gd, trace) {
	              trace._len = Math.min(trace.x.length, trace.y.length, trace.z.length, trace.value.length);
	              trace._x = filter(trace.x, trace._len);
	              trace._y = filter(trace.y, trace._len);
	              trace._z = filter(trace.z, trace._len);
	              trace._value = filter(trace.value, trace._len);
	              var grid = processGrid(trace);
	              trace._gridFill = grid.fill;
	              trace._Xs = grid.Xs;
	              trace._Ys = grid.Ys;
	              trace._Zs = grid.Zs;
	              trace._len = grid.len;
	              var min = Infinity;
	              var max = -Infinity;
	              for (var i = 0; i < trace._len; i++) {
	                var v = trace._value[i];
	                min = Math.min(min, v);
	                max = Math.max(max, v);
	              }
	              trace._minValues = min;
	              trace._maxValues = max;
	              trace._vMin = trace.isomin === undefined || trace.isomin === null ? min : trace.isomin;
	              trace._vMax = trace.isomax === undefined || trace.isomin === null ? max : trace.isomax;
	              colorscaleCalc(gd, trace, {
	                vals: [trace._vMin, trace._vMax],
	                containerStr: "",
	                cLetter: "c"
	              });
	            };
	          }
	        ),
	        /***/
	        22674: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createMesh = __webpack_require__2(9330).gl_mesh3d;
	            var parseColorScale = __webpack_require__2(81697).parseColorScale;
	            var str2RgbaArray = __webpack_require__2(78614);
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            var zip3 = __webpack_require__2(90060);
	            var findNearestOnAxis = function(w, arr) {
	              for (var q = arr.length - 1; q > 0; q--) {
	                var min = Math.min(arr[q], arr[q - 1]);
	                var max = Math.max(arr[q], arr[q - 1]);
	                if (max > min && min < w && w <= max) {
	                  return {
	                    id: q,
	                    distRatio: (max - w) / (max - min)
	                  };
	                }
	              }
	              return {
	                id: 0,
	                distRatio: 0
	              };
	            };
	            function IsosurfaceTrace(scene, mesh, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.mesh = mesh;
	              this.name = "";
	              this.data = null;
	              this.showContour = false;
	            }
	            var proto = IsosurfaceTrace.prototype;
	            proto.handlePick = function(selection) {
	              if (selection.object === this.mesh) {
	                var rawId = selection.data.index;
	                var x = this.data._meshX[rawId];
	                var y = this.data._meshY[rawId];
	                var z = this.data._meshZ[rawId];
	                var height = this.data._Ys.length;
	                var depth = this.data._Zs.length;
	                var i = findNearestOnAxis(x, this.data._Xs).id;
	                var j = findNearestOnAxis(y, this.data._Ys).id;
	                var k = findNearestOnAxis(z, this.data._Zs).id;
	                var selectIndex = selection.index = k + depth * j + depth * height * i;
	                selection.traceCoordinate = [this.data._meshX[selectIndex], this.data._meshY[selectIndex], this.data._meshZ[selectIndex], this.data._value[selectIndex]];
	                var text = this.data.hovertext || this.data.text;
	                if (Array.isArray(text) && text[selectIndex] !== undefined) {
	                  selection.textLabel = text[selectIndex];
	                } else if (text) {
	                  selection.textLabel = text;
	                }
	                return true;
	              }
	            };
	            proto.update = function(data) {
	              var scene = this.scene;
	              var layout = scene.fullSceneLayout;
	              this.data = generateIsoMeshes(data);
	              function toDataCoords(axis, coord, scale, calendar) {
	                return coord.map(function(x) {
	                  return axis.d2l(x, 0, calendar) * scale;
	                });
	              }
	              var positions = zip3(toDataCoords(layout.xaxis, data._meshX, scene.dataScale[0], data.xcalendar), toDataCoords(layout.yaxis, data._meshY, scene.dataScale[1], data.ycalendar), toDataCoords(layout.zaxis, data._meshZ, scene.dataScale[2], data.zcalendar));
	              var cells = zip3(data._meshI, data._meshJ, data._meshK);
	              var config = {
	                positions,
	                cells,
	                lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
	                ambient: data.lighting.ambient,
	                diffuse: data.lighting.diffuse,
	                specular: data.lighting.specular,
	                roughness: data.lighting.roughness,
	                fresnel: data.lighting.fresnel,
	                vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
	                faceNormalsEpsilon: data.lighting.facenormalsepsilon,
	                opacity: data.opacity,
	                contourEnable: data.contour.show,
	                contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
	                contourWidth: data.contour.width,
	                useFacetNormals: data.flatshading
	              };
	              var cOpts = extractOpts(data);
	              config.vertexIntensity = data._meshIntensity;
	              config.vertexIntensityBounds = [cOpts.min, cOpts.max];
	              config.colormap = parseColorScale(data);
	              this.mesh.update(config);
	            };
	            proto.dispose = function() {
	              this.scene.glplot.remove(this.mesh);
	              this.mesh.dispose();
	            };
	            var GRID_TYPES = ["xyz", "xzy", "yxz", "yzx", "zxy", "zyx"];
	            function generateIsoMeshes(data) {
	              data._meshI = [];
	              data._meshJ = [];
	              data._meshK = [];
	              var showSurface = data.surface.show;
	              var showSpaceframe = data.spaceframe.show;
	              var surfaceFill = data.surface.fill;
	              var spaceframeFill = data.spaceframe.fill;
	              var drawingSurface = false;
	              var drawingSpaceframe = false;
	              var numFaces = 0;
	              var numVertices;
	              var beginVertextLength;
	              var Xs = data._Xs;
	              var Ys = data._Ys;
	              var Zs = data._Zs;
	              var width = Xs.length;
	              var height = Ys.length;
	              var depth = Zs.length;
	              var filled = GRID_TYPES.indexOf(data._gridFill.replace(/-/g, "").replace(/\+/g, ""));
	              var getIndex = function(i, j, k) {
	                switch (filled) {
	                  case 5:
	                    return k + depth * j + depth * height * i;
	                  case 4:
	                    return k + depth * i + depth * width * j;
	                  case 3:
	                    return j + height * k + height * depth * i;
	                  case 2:
	                    return j + height * i + height * width * k;
	                  case 1:
	                    return i + width * k + width * depth * j;
	                  default:
	                    return i + width * j + width * height * k;
	                }
	              };
	              var minValues = data._minValues;
	              var maxValues = data._maxValues;
	              var vMin = data._vMin;
	              var vMax = data._vMax;
	              var allXs;
	              var allYs;
	              var allZs;
	              var allVs;
	              function findVertexId(x, y, z) {
	                var len = allVs.length;
	                for (var f = beginVertextLength; f < len; f++) {
	                  if (x === allXs[f] && y === allYs[f] && z === allZs[f]) {
	                    return f;
	                  }
	                }
	                return -1;
	              }
	              function beginGroup() {
	                beginVertextLength = numVertices;
	              }
	              function emptyVertices() {
	                allXs = [];
	                allYs = [];
	                allZs = [];
	                allVs = [];
	                numVertices = 0;
	                beginGroup();
	              }
	              function addVertex(x, y, z, v) {
	                allXs.push(x);
	                allYs.push(y);
	                allZs.push(z);
	                allVs.push(v);
	                numVertices++;
	                return numVertices - 1;
	              }
	              function addFace(a, b, c) {
	                data._meshI.push(a);
	                data._meshJ.push(b);
	                data._meshK.push(c);
	                numFaces++;
	                return numFaces - 1;
	              }
	              function getCenter(A, B, C) {
	                var M = [];
	                for (var i = 0; i < A.length; i++) {
	                  M[i] = (A[i] + B[i] + C[i]) / 3;
	                }
	                return M;
	              }
	              function getBetween(A, B, r) {
	                var M = [];
	                for (var i = 0; i < A.length; i++) {
	                  M[i] = A[i] * (1 - r) + r * B[i];
	                }
	                return M;
	              }
	              var activeFill;
	              function setFill(fill) {
	                activeFill = fill;
	              }
	              function createOpenTri(xyzv, abc) {
	                var A = xyzv[0];
	                var B = xyzv[1];
	                var C = xyzv[2];
	                var G = getCenter(A, B, C);
	                var r = Math.sqrt(1 - activeFill);
	                var p1 = getBetween(G, A, r);
	                var p2 = getBetween(G, B, r);
	                var p3 = getBetween(G, C, r);
	                var a = abc[0];
	                var b = abc[1];
	                var c = abc[2];
	                return {
	                  xyzv: [[A, B, p2], [p2, p1, A], [B, C, p3], [p3, p2, B], [C, A, p1], [p1, p3, C]],
	                  abc: [[a, b, -1], [-1, -1, a], [b, c, -1], [-1, -1, b], [c, a, -1], [-1, -1, c]]
	                };
	              }
	              function styleIncludes(style, char) {
	                if (style === "all" || style === null) return true;
	                return style.indexOf(char) > -1;
	              }
	              function mapValue(style, value) {
	                if (style === null) return value;
	                return style;
	              }
	              function drawTri(style, xyzv, abc) {
	                beginGroup();
	                var allXYZVs = [xyzv];
	                var allABCs = [abc];
	                if (activeFill >= 1) {
	                  allXYZVs = [xyzv];
	                  allABCs = [abc];
	                } else if (activeFill > 0) {
	                  var openTri = createOpenTri(xyzv, abc);
	                  allXYZVs = openTri.xyzv;
	                  allABCs = openTri.abc;
	                }
	                for (var f = 0; f < allXYZVs.length; f++) {
	                  xyzv = allXYZVs[f];
	                  abc = allABCs[f];
	                  var pnts = [];
	                  for (var i = 0; i < 3; i++) {
	                    var x = xyzv[i][0];
	                    var y = xyzv[i][1];
	                    var z = xyzv[i][2];
	                    var v = xyzv[i][3];
	                    var id = abc[i] > -1 ? abc[i] : findVertexId(x, y, z);
	                    if (id > -1) {
	                      pnts[i] = id;
	                    } else {
	                      pnts[i] = addVertex(x, y, z, mapValue(style, v));
	                    }
	                  }
	                  addFace(pnts[0], pnts[1], pnts[2]);
	                }
	              }
	              function drawQuad(style, xyzv, abcd) {
	                var makeTri = function(i, j, k) {
	                  drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
	                };
	                makeTri(0, 1, 2);
	                makeTri(2, 3, 0);
	              }
	              function drawTetra(style, xyzv, abcd) {
	                var makeTri = function(i, j, k) {
	                  drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
	                };
	                makeTri(0, 1, 2);
	                makeTri(3, 0, 1);
	                makeTri(2, 3, 0);
	                makeTri(1, 2, 3);
	              }
	              function calcIntersection(pointOut, pointIn, min, max) {
	                var value = pointOut[3];
	                if (value < min) value = min;
	                if (value > max) value = max;
	                var ratio = (pointOut[3] - value) / (pointOut[3] - pointIn[3] + 1e-9);
	                var result = [];
	                for (var s = 0; s < 4; s++) {
	                  result[s] = (1 - ratio) * pointOut[s] + ratio * pointIn[s];
	                }
	                return result;
	              }
	              function inRange(value, min, max) {
	                return value >= min && value <= max;
	              }
	              function almostInFinalRange(value) {
	                var vErr = 1e-3 * (vMax - vMin);
	                return value >= vMin - vErr && value <= vMax + vErr;
	              }
	              function getXYZV(indecies) {
	                var xyzv = [];
	                for (var q = 0; q < 4; q++) {
	                  var index = indecies[q];
	                  xyzv.push([data._x[index], data._y[index], data._z[index], data._value[index]]);
	                }
	                return xyzv;
	              }
	              var MAX_PASS = 3;
	              function tryCreateTri(style, xyzv, abc, min, max, nPass) {
	                if (!nPass) nPass = 1;
	                abc = [-1, -1, -1];
	                var result = false;
	                var ok = [inRange(xyzv[0][3], min, max), inRange(xyzv[1][3], min, max), inRange(xyzv[2][3], min, max)];
	                if (!ok[0] && !ok[1] && !ok[2]) {
	                  return false;
	                }
	                var tryDrawTri = function(style2, xyzv2, abc2) {
	                  if (
	                    // we check here if the points are in `real` iso-min/max range
	                    almostInFinalRange(xyzv2[0][3]) && almostInFinalRange(xyzv2[1][3]) && almostInFinalRange(xyzv2[2][3])
	                  ) {
	                    drawTri(style2, xyzv2, abc2);
	                    return true;
	                  } else if (nPass < MAX_PASS) {
	                    return tryCreateTri(style2, xyzv2, abc2, vMin, vMax, ++nPass);
	                  }
	                  return false;
	                };
	                if (ok[0] && ok[1] && ok[2]) {
	                  return tryDrawTri(style, xyzv, abc) || result;
	                }
	                var interpolated = false;
	                [[0, 1, 2], [2, 0, 1], [1, 2, 0]].forEach(function(e) {
	                  if (ok[e[0]] && ok[e[1]] && !ok[e[2]]) {
	                    var A = xyzv[e[0]];
	                    var B = xyzv[e[1]];
	                    var C = xyzv[e[2]];
	                    var p1 = calcIntersection(C, A, min, max);
	                    var p2 = calcIntersection(C, B, min, max);
	                    result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
	                    result = tryDrawTri(style, [A, B, p2], [abc[e[0]], abc[e[1]], -1]) || result;
	                    interpolated = true;
	                  }
	                });
	                if (interpolated) return result;
	                [[0, 1, 2], [1, 2, 0], [2, 0, 1]].forEach(function(e) {
	                  if (ok[e[0]] && !ok[e[1]] && !ok[e[2]]) {
	                    var A = xyzv[e[0]];
	                    var B = xyzv[e[1]];
	                    var C = xyzv[e[2]];
	                    var p1 = calcIntersection(B, A, min, max);
	                    var p2 = calcIntersection(C, A, min, max);
	                    result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
	                    interpolated = true;
	                  }
	                });
	                return result;
	              }
	              function tryCreateTetra(style, abcd, min, max) {
	                var result = false;
	                var xyzv = getXYZV(abcd);
	                var ok = [inRange(xyzv[0][3], min, max), inRange(xyzv[1][3], min, max), inRange(xyzv[2][3], min, max), inRange(xyzv[3][3], min, max)];
	                if (!ok[0] && !ok[1] && !ok[2] && !ok[3]) {
	                  return result;
	                }
	                if (ok[0] && ok[1] && ok[2] && ok[3]) {
	                  if (drawingSpaceframe) {
	                    result = drawTetra(style, xyzv, abcd) || result;
	                  }
	                  return result;
	                }
	                var interpolated = false;
	                [[0, 1, 2, 3], [3, 0, 1, 2], [2, 3, 0, 1], [1, 2, 3, 0]].forEach(function(e) {
	                  if (ok[e[0]] && ok[e[1]] && ok[e[2]] && !ok[e[3]]) {
	                    var A = xyzv[e[0]];
	                    var B = xyzv[e[1]];
	                    var C = xyzv[e[2]];
	                    var D = xyzv[e[3]];
	                    if (drawingSpaceframe) {
	                      result = drawTri(style, [A, B, C], [abcd[e[0]], abcd[e[1]], abcd[e[2]]]) || result;
	                    } else {
	                      var p1 = calcIntersection(D, A, min, max);
	                      var p2 = calcIntersection(D, B, min, max);
	                      var p3 = calcIntersection(D, C, min, max);
	                      result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
	                    }
	                    interpolated = true;
	                  }
	                });
	                if (interpolated) return result;
	                [[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2], [0, 2, 3, 1], [1, 3, 2, 0]].forEach(function(e) {
	                  if (ok[e[0]] && ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
	                    var A = xyzv[e[0]];
	                    var B = xyzv[e[1]];
	                    var C = xyzv[e[2]];
	                    var D = xyzv[e[3]];
	                    var p1 = calcIntersection(C, A, min, max);
	                    var p2 = calcIntersection(C, B, min, max);
	                    var p3 = calcIntersection(D, B, min, max);
	                    var p4 = calcIntersection(D, A, min, max);
	                    if (drawingSpaceframe) {
	                      result = drawTri(style, [A, p4, p1], [abcd[e[0]], -1, -1]) || result;
	                      result = drawTri(style, [B, p2, p3], [abcd[e[1]], -1, -1]) || result;
	                    } else {
	                      result = drawQuad(null, [p1, p2, p3, p4], [-1, -1, -1, -1]) || result;
	                    }
	                    interpolated = true;
	                  }
	                });
	                if (interpolated) return result;
	                [[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2]].forEach(function(e) {
	                  if (ok[e[0]] && !ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
	                    var A = xyzv[e[0]];
	                    var B = xyzv[e[1]];
	                    var C = xyzv[e[2]];
	                    var D = xyzv[e[3]];
	                    var p1 = calcIntersection(B, A, min, max);
	                    var p2 = calcIntersection(C, A, min, max);
	                    var p3 = calcIntersection(D, A, min, max);
	                    if (drawingSpaceframe) {
	                      result = drawTri(style, [A, p1, p2], [abcd[e[0]], -1, -1]) || result;
	                      result = drawTri(style, [A, p2, p3], [abcd[e[0]], -1, -1]) || result;
	                      result = drawTri(style, [A, p3, p1], [abcd[e[0]], -1, -1]) || result;
	                    } else {
	                      result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
	                    }
	                    interpolated = true;
	                  }
	                });
	                return result;
	              }
	              function addCube(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max) {
	                var result = false;
	                if (drawingSurface) {
	                  if (styleIncludes(style, "A")) {
	                    result = tryCreateTetra(null, [p000, p001, p010, p100], min, max) || result;
	                  }
	                  if (styleIncludes(style, "B")) {
	                    result = tryCreateTetra(null, [p001, p010, p011, p111], min, max) || result;
	                  }
	                  if (styleIncludes(style, "C")) {
	                    result = tryCreateTetra(null, [p001, p100, p101, p111], min, max) || result;
	                  }
	                  if (styleIncludes(style, "D")) {
	                    result = tryCreateTetra(null, [p010, p100, p110, p111], min, max) || result;
	                  }
	                  if (styleIncludes(style, "E")) {
	                    result = tryCreateTetra(null, [p001, p010, p100, p111], min, max) || result;
	                  }
	                }
	                if (drawingSpaceframe) {
	                  result = tryCreateTetra(style, [p001, p010, p100, p111], min, max) || result;
	                }
	                return result;
	              }
	              function addRect(style, a, b, c, d, min, max, previousResult) {
	                return [previousResult[0] === true ? true : tryCreateTri(style, getXYZV([a, b, c]), [a, b, c], min, max), previousResult[1] === true ? true : tryCreateTri(style, getXYZV([c, d, a]), [c, d, a], min, max)];
	              }
	              function begin2dCell(style, p00, p01, p10, p11, min, max, isEven, previousResult) {
	                if (isEven) {
	                  return addRect(style, p00, p01, p11, p10, min, max, previousResult);
	                } else {
	                  return addRect(style, p01, p11, p10, p00, min, max, previousResult);
	                }
	              }
	              function beginSection(style, i, j, k, min, max, distRatios) {
	                var result = false;
	                var A, B, C, D;
	                var makeSection = function() {
	                  result = tryCreateTri(style, [A, B, C], [-1, -1, -1], min, max) || result;
	                  result = tryCreateTri(style, [C, D, A], [-1, -1, -1], min, max) || result;
	                };
	                var rX = distRatios[0];
	                var rY = distRatios[1];
	                var rZ = distRatios[2];
	                if (rX) {
	                  A = getBetween(getXYZV([getIndex(i, j - 0, k - 0)])[0], getXYZV([getIndex(i - 1, j - 0, k - 0)])[0], rX);
	                  B = getBetween(getXYZV([getIndex(i, j - 0, k - 1)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rX);
	                  C = getBetween(getXYZV([getIndex(i, j - 1, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rX);
	                  D = getBetween(getXYZV([getIndex(i, j - 1, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rX);
	                  makeSection();
	                }
	                if (rY) {
	                  A = getBetween(getXYZV([getIndex(i - 0, j, k - 0)])[0], getXYZV([getIndex(i - 0, j - 1, k - 0)])[0], rY);
	                  B = getBetween(getXYZV([getIndex(i - 0, j, k - 1)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rY);
	                  C = getBetween(getXYZV([getIndex(i - 1, j, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rY);
	                  D = getBetween(getXYZV([getIndex(i - 1, j, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rY);
	                  makeSection();
	                }
	                if (rZ) {
	                  A = getBetween(getXYZV([getIndex(i - 0, j - 0, k)])[0], getXYZV([getIndex(i - 0, j - 0, k - 1)])[0], rZ);
	                  B = getBetween(getXYZV([getIndex(i - 0, j - 1, k)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rZ);
	                  C = getBetween(getXYZV([getIndex(i - 1, j - 1, k)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rZ);
	                  D = getBetween(getXYZV([getIndex(i - 1, j - 0, k)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rZ);
	                  makeSection();
	                }
	                return result;
	              }
	              function begin3dCell(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max, isEven) {
	                var cellStyle = style;
	                if (isEven) {
	                  if (drawingSurface && style === "even") cellStyle = null;
	                  return addCube(cellStyle, p000, p001, p010, p011, p100, p101, p110, p111, min, max);
	                } else {
	                  if (drawingSurface && style === "odd") cellStyle = null;
	                  return addCube(cellStyle, p111, p110, p101, p100, p011, p010, p001, p000, min, max);
	                }
	              }
	              function draw2dX(style, items, min, max, previousResult) {
	                var result = [];
	                var n = 0;
	                for (var q = 0; q < items.length; q++) {
	                  var i = items[q];
	                  for (var k = 1; k < depth; k++) {
	                    for (var j = 1; j < height; j++) {
	                      result.push(begin2dCell(style, getIndex(i, j - 1, k - 1), getIndex(i, j - 1, k), getIndex(i, j, k - 1), getIndex(i, j, k), min, max, (i + j + k) % 2, previousResult && previousResult[n] ? previousResult[n] : []));
	                      n++;
	                    }
	                  }
	                }
	                return result;
	              }
	              function draw2dY(style, items, min, max, previousResult) {
	                var result = [];
	                var n = 0;
	                for (var q = 0; q < items.length; q++) {
	                  var j = items[q];
	                  for (var i = 1; i < width; i++) {
	                    for (var k = 1; k < depth; k++) {
	                      result.push(begin2dCell(style, getIndex(i - 1, j, k - 1), getIndex(i, j, k - 1), getIndex(i - 1, j, k), getIndex(i, j, k), min, max, (i + j + k) % 2, previousResult && previousResult[n] ? previousResult[n] : []));
	                      n++;
	                    }
	                  }
	                }
	                return result;
	              }
	              function draw2dZ(style, items, min, max, previousResult) {
	                var result = [];
	                var n = 0;
	                for (var q = 0; q < items.length; q++) {
	                  var k = items[q];
	                  for (var j = 1; j < height; j++) {
	                    for (var i = 1; i < width; i++) {
	                      result.push(begin2dCell(style, getIndex(i - 1, j - 1, k), getIndex(i - 1, j, k), getIndex(i, j - 1, k), getIndex(i, j, k), min, max, (i + j + k) % 2, previousResult && previousResult[n] ? previousResult[n] : []));
	                      n++;
	                    }
	                  }
	                }
	                return result;
	              }
	              function draw3d(style, min, max) {
	                for (var k = 1; k < depth; k++) {
	                  for (var j = 1; j < height; j++) {
	                    for (var i = 1; i < width; i++) {
	                      begin3dCell(style, getIndex(i - 1, j - 1, k - 1), getIndex(i - 1, j - 1, k), getIndex(i - 1, j, k - 1), getIndex(i - 1, j, k), getIndex(i, j - 1, k - 1), getIndex(i, j - 1, k), getIndex(i, j, k - 1), getIndex(i, j, k), min, max, (i + j + k) % 2);
	                    }
	                  }
	                }
	              }
	              function drawSpaceframe(style, min, max) {
	                drawingSpaceframe = true;
	                draw3d(style, min, max);
	                drawingSpaceframe = false;
	              }
	              function drawSurface(style, min, max) {
	                drawingSurface = true;
	                draw3d(style, min, max);
	                drawingSurface = false;
	              }
	              function drawSectionX(style, items, min, max, distRatios, previousResult) {
	                var result = [];
	                var n = 0;
	                for (var q = 0; q < items.length; q++) {
	                  var i = items[q];
	                  for (var k = 1; k < depth; k++) {
	                    for (var j = 1; j < height; j++) {
	                      result.push(beginSection(style, i, j, k, min, max, distRatios[q], previousResult && previousResult[n] ? previousResult[n] : []));
	                      n++;
	                    }
	                  }
	                }
	                return result;
	              }
	              function drawSectionY(style, items, min, max, distRatios, previousResult) {
	                var result = [];
	                var n = 0;
	                for (var q = 0; q < items.length; q++) {
	                  var j = items[q];
	                  for (var i = 1; i < width; i++) {
	                    for (var k = 1; k < depth; k++) {
	                      result.push(beginSection(style, i, j, k, min, max, distRatios[q], previousResult && previousResult[n] ? previousResult[n] : []));
	                      n++;
	                    }
	                  }
	                }
	                return result;
	              }
	              function drawSectionZ(style, items, min, max, distRatios, previousResult) {
	                var result = [];
	                var n = 0;
	                for (var q = 0; q < items.length; q++) {
	                  var k = items[q];
	                  for (var j = 1; j < height; j++) {
	                    for (var i = 1; i < width; i++) {
	                      result.push(beginSection(style, i, j, k, min, max, distRatios[q], previousResult && previousResult[n] ? previousResult[n] : []));
	                      n++;
	                    }
	                  }
	                }
	                return result;
	              }
	              function createRange(a, b) {
	                var range2 = [];
	                for (var q = a; q < b; q++) {
	                  range2.push(q);
	                }
	                return range2;
	              }
	              function insertGridPoints() {
	                for (var i = 0; i < width; i++) {
	                  for (var j = 0; j < height; j++) {
	                    for (var k = 0; k < depth; k++) {
	                      var index = getIndex(i, j, k);
	                      addVertex(data._x[index], data._y[index], data._z[index], data._value[index]);
	                    }
	                  }
	                }
	              }
	              function drawAll() {
	                emptyVertices();
	                insertGridPoints();
	                var activeStyle = null;
	                if (showSpaceframe && spaceframeFill) {
	                  setFill(spaceframeFill);
	                  drawSpaceframe(activeStyle, vMin, vMax);
	                }
	                if (showSurface && surfaceFill) {
	                  setFill(surfaceFill);
	                  var surfacePattern = data.surface.pattern;
	                  var surfaceCount = data.surface.count;
	                  for (var q = 0; q < surfaceCount; q++) {
	                    var ratio = surfaceCount === 1 ? 0.5 : q / (surfaceCount - 1);
	                    var level = (1 - ratio) * vMin + ratio * vMax;
	                    var d1 = Math.abs(level - minValues);
	                    var d2 = Math.abs(level - maxValues);
	                    var ranges = d1 > d2 ? [minValues, level] : [level, maxValues];
	                    drawSurface(surfacePattern, ranges[0], ranges[1]);
	                  }
	                }
	                var setupMinMax = [[Math.min(vMin, maxValues), Math.max(vMin, maxValues)], [Math.min(minValues, vMax), Math.max(minValues, vMax)]];
	                ["x", "y", "z"].forEach(function(e) {
	                  var preRes = [];
	                  for (var s = 0; s < setupMinMax.length; s++) {
	                    var count = 0;
	                    var activeMin = setupMinMax[s][0];
	                    var activeMax = setupMinMax[s][1];
	                    var slice2 = data.slices[e];
	                    if (slice2.show && slice2.fill) {
	                      setFill(slice2.fill);
	                      var exactIndices = [];
	                      var ceilIndices = [];
	                      var distRatios = [];
	                      if (slice2.locations.length) {
	                        for (var q2 = 0; q2 < slice2.locations.length; q2++) {
	                          var near = findNearestOnAxis(slice2.locations[q2], e === "x" ? Xs : e === "y" ? Ys : Zs);
	                          if (near.distRatio === 0) {
	                            exactIndices.push(near.id);
	                          } else if (near.id > 0) {
	                            ceilIndices.push(near.id);
	                            if (e === "x") {
	                              distRatios.push([near.distRatio, 0, 0]);
	                            } else if (e === "y") {
	                              distRatios.push([0, near.distRatio, 0]);
	                            } else {
	                              distRatios.push([0, 0, near.distRatio]);
	                            }
	                          }
	                        }
	                      } else {
	                        if (e === "x") {
	                          exactIndices = createRange(1, width - 1);
	                        } else if (e === "y") {
	                          exactIndices = createRange(1, height - 1);
	                        } else {
	                          exactIndices = createRange(1, depth - 1);
	                        }
	                      }
	                      if (ceilIndices.length > 0) {
	                        if (e === "x") {
	                          preRes[count] = drawSectionX(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
	                        } else if (e === "y") {
	                          preRes[count] = drawSectionY(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
	                        } else {
	                          preRes[count] = drawSectionZ(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
	                        }
	                        count++;
	                      }
	                      if (exactIndices.length > 0) {
	                        if (e === "x") {
	                          preRes[count] = draw2dX(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
	                        } else if (e === "y") {
	                          preRes[count] = draw2dY(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
	                        } else {
	                          preRes[count] = draw2dZ(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
	                        }
	                        count++;
	                      }
	                    }
	                    var cap = data.caps[e];
	                    if (cap.show && cap.fill) {
	                      setFill(cap.fill);
	                      if (e === "x") {
	                        preRes[count] = draw2dX(activeStyle, [0, width - 1], activeMin, activeMax, preRes[count]);
	                      } else if (e === "y") {
	                        preRes[count] = draw2dY(activeStyle, [0, height - 1], activeMin, activeMax, preRes[count]);
	                      } else {
	                        preRes[count] = draw2dZ(activeStyle, [0, depth - 1], activeMin, activeMax, preRes[count]);
	                      }
	                      count++;
	                    }
	                  }
	                });
	                if (numFaces === 0) {
	                  emptyVertices();
	                }
	                data._meshX = allXs;
	                data._meshY = allYs;
	                data._meshZ = allZs;
	                data._meshIntensity = allVs;
	                data._Xs = Xs;
	                data._Ys = Ys;
	                data._Zs = Zs;
	              }
	              drawAll();
	              return data;
	            }
	            function createIsosurfaceTrace(scene, data) {
	              var gl2 = scene.glplot.gl;
	              var mesh = createMesh({
	                gl: gl2
	              });
	              var result = new IsosurfaceTrace(scene, mesh, data.uid);
	              mesh._trace = result;
	              result.update(data);
	              scene.glplot.add(mesh);
	              return result;
	            }
	            module2.exports = {
	              findNearestOnAxis,
	              generateIsoMeshes,
	              createIsosurfaceTrace
	            };
	          }
	        ),
	        /***/
	        82738: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var attributes = __webpack_require__2(16249);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	            }
	            function supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
	              var isomin = coerce("isomin");
	              var isomax = coerce("isomax");
	              if (isomax !== undefined && isomax !== null && isomin !== undefined && isomin !== null && isomin > isomax) {
	                traceOut.isomin = null;
	                traceOut.isomax = null;
	              }
	              var x = coerce("x");
	              var y = coerce("y");
	              var z = coerce("z");
	              var value = coerce("value");
	              if (!x || !x.length || !y || !y.length || !z || !z.length || !value || !value.length) {
	                traceOut.visible = false;
	                return;
	              }
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y", "z"], layout);
	              coerce("valuehoverformat");
	              ["x", "y", "z"].forEach(function(dim) {
	                coerce(dim + "hoverformat");
	                var capDim = "caps." + dim;
	                var showCap = coerce(capDim + ".show");
	                if (showCap) {
	                  coerce(capDim + ".fill");
	                }
	                var sliceDim = "slices." + dim;
	                var showSlice = coerce(sliceDim + ".show");
	                if (showSlice) {
	                  coerce(sliceDim + ".fill");
	                  coerce(sliceDim + ".locations");
	                }
	              });
	              var showSpaceframe = coerce("spaceframe.show");
	              if (showSpaceframe) {
	                coerce("spaceframe.fill");
	              }
	              var showSurface = coerce("surface.show");
	              if (showSurface) {
	                coerce("surface.count");
	                coerce("surface.fill");
	                coerce("surface.pattern");
	              }
	              var showContour = coerce("contour.show");
	              if (showContour) {
	                coerce("contour.color");
	                coerce("contour.width");
	              }
	              ["text", "hovertext", "hovertemplate", "lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lighting.vertexnormalsepsilon", "lighting.facenormalsepsilon", "lightposition.x", "lightposition.y", "lightposition.z", "flatshading", "opacity"].forEach(function(x2) {
	                coerce(x2);
	              });
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "c"
	              });
	              traceOut._length = null;
	            }
	            module2.exports = {
	              supplyDefaults,
	              supplyIsoDefaults
	            };
	          }
	        ),
	        /***/
	        64943: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(16249),
	              supplyDefaults: __webpack_require__2(82738).supplyDefaults,
	              calc: __webpack_require__2(56959),
	              colorbar: {
	                min: "cmin",
	                max: "cmax"
	              },
	              plot: __webpack_require__2(22674).createIsosurfaceTrace,
	              moduleType: "trace",
	              name: "isosurface",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        2418: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var surfaceAttrs = __webpack_require__2(54532);
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            module2.exports = extendFlat({
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              z: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              i: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              j: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              k: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              text: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              hovertemplate: hovertemplateAttrs({
	                editType: "calc"
	              }),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z"),
	              delaunayaxis: {
	                valType: "enumerated",
	                values: ["x", "y", "z"],
	                dflt: "z",
	                editType: "calc"
	              },
	              alphahull: {
	                valType: "number",
	                dflt: -1,
	                editType: "calc"
	              },
	              intensity: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              intensitymode: {
	                valType: "enumerated",
	                values: ["vertex", "cell"],
	                dflt: "vertex",
	                editType: "calc"
	              },
	              // Color field
	              color: {
	                valType: "color",
	                editType: "calc"
	              },
	              vertexcolor: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              facecolor: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              transforms: undefined
	            }, colorScaleAttrs("", {
	              colorAttr: "`intensity`",
	              showScaleDflt: true,
	              editTypeOverride: "calc"
	            }), {
	              opacity: surfaceAttrs.opacity,
	              // Flat shaded mode
	              flatshading: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              contour: {
	                show: extendFlat({}, surfaceAttrs.contours.x.show, {}),
	                color: surfaceAttrs.contours.x.color,
	                width: surfaceAttrs.contours.x.width,
	                editType: "calc"
	              },
	              lightposition: {
	                x: extendFlat({}, surfaceAttrs.lightposition.x, {
	                  dflt: 1e5
	                }),
	                y: extendFlat({}, surfaceAttrs.lightposition.y, {
	                  dflt: 1e5
	                }),
	                z: extendFlat({}, surfaceAttrs.lightposition.z, {
	                  dflt: 0
	                }),
	                editType: "calc"
	              },
	              lighting: extendFlat({
	                vertexnormalsepsilon: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1e-12,
	                  // otherwise finely tessellated things eg. the brain will have no specular light reflection
	                  editType: "calc"
	                },
	                facenormalsepsilon: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1e-6,
	                  // even the brain model doesn't appear to need finer than this
	                  editType: "calc"
	                },
	                editType: "calc"
	              }, surfaceAttrs.lighting),
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                editType: "calc"
	              }),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            });
	          }
	        ),
	        /***/
	        82932: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorscaleCalc = __webpack_require__2(78803);
	            module2.exports = function calc(gd, trace) {
	              if (trace.intensity) {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.intensity,
	                  containerStr: "",
	                  cLetter: "c"
	                });
	              }
	            };
	          }
	        ),
	        /***/
	        91134: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createMesh = __webpack_require__2(9330).gl_mesh3d;
	            var triangulate = __webpack_require__2(9330).delaunay_triangulate;
	            var alphaShape = __webpack_require__2(9330).alpha_shape;
	            var convexHull = __webpack_require__2(9330).convex_hull;
	            var parseColorScale = __webpack_require__2(81697).parseColorScale;
	            var str2RgbaArray = __webpack_require__2(78614);
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            var zip3 = __webpack_require__2(90060);
	            function Mesh3DTrace(scene, mesh, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.mesh = mesh;
	              this.name = "";
	              this.color = "#fff";
	              this.data = null;
	              this.showContour = false;
	            }
	            var proto = Mesh3DTrace.prototype;
	            proto.handlePick = function(selection) {
	              if (selection.object === this.mesh) {
	                var selectIndex = selection.index = selection.data.index;
	                if (selection.data._cellCenter) {
	                  selection.traceCoordinate = selection.data.dataCoordinate;
	                } else {
	                  selection.traceCoordinate = [this.data.x[selectIndex], this.data.y[selectIndex], this.data.z[selectIndex]];
	                }
	                var text = this.data.hovertext || this.data.text;
	                if (Array.isArray(text) && text[selectIndex] !== undefined) {
	                  selection.textLabel = text[selectIndex];
	                } else if (text) {
	                  selection.textLabel = text;
	                }
	                return true;
	              }
	            };
	            function parseColorArray(colors) {
	              var b = [];
	              var len = colors.length;
	              for (var i = 0; i < len; i++) {
	                b[i] = str2RgbaArray(colors[i]);
	              }
	              return b;
	            }
	            function toDataCoords(axis, coord, scale, calendar) {
	              var b = [];
	              var len = coord.length;
	              for (var i = 0; i < len; i++) {
	                b[i] = axis.d2l(coord[i], 0, calendar) * scale;
	              }
	              return b;
	            }
	            function toRoundIndex(a) {
	              var b = [];
	              var len = a.length;
	              for (var i = 0; i < len; i++) {
	                b[i] = Math.round(a[i]);
	              }
	              return b;
	            }
	            function delaunayCells(delaunayaxis, positions) {
	              var d = ["x", "y", "z"].indexOf(delaunayaxis);
	              var b = [];
	              var len = positions.length;
	              for (var i = 0; i < len; i++) {
	                b[i] = [positions[i][(d + 1) % 3], positions[i][(d + 2) % 3]];
	              }
	              return triangulate(b);
	            }
	            function hasValidIndices(list, numVertices) {
	              var len = list.length;
	              for (var i = 0; i < len; i++) {
	                if (list[i] <= -0.5 || list[i] >= numVertices - 0.5) {
	                  return false;
	                }
	              }
	              return true;
	            }
	            proto.update = function(data) {
	              var scene = this.scene;
	              var layout = scene.fullSceneLayout;
	              this.data = data;
	              var numVertices = data.x.length;
	              var positions = zip3(toDataCoords(layout.xaxis, data.x, scene.dataScale[0], data.xcalendar), toDataCoords(layout.yaxis, data.y, scene.dataScale[1], data.ycalendar), toDataCoords(layout.zaxis, data.z, scene.dataScale[2], data.zcalendar));
	              var cells;
	              if (data.i && data.j && data.k) {
	                if (data.i.length !== data.j.length || data.j.length !== data.k.length || !hasValidIndices(data.i, numVertices) || !hasValidIndices(data.j, numVertices) || !hasValidIndices(data.k, numVertices)) {
	                  return;
	                }
	                cells = zip3(toRoundIndex(data.i), toRoundIndex(data.j), toRoundIndex(data.k));
	              } else if (data.alphahull === 0) {
	                cells = convexHull(positions);
	              } else if (data.alphahull > 0) {
	                cells = alphaShape(data.alphahull, positions);
	              } else {
	                cells = delaunayCells(data.delaunayaxis, positions);
	              }
	              var config = {
	                positions,
	                cells,
	                lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
	                ambient: data.lighting.ambient,
	                diffuse: data.lighting.diffuse,
	                specular: data.lighting.specular,
	                roughness: data.lighting.roughness,
	                fresnel: data.lighting.fresnel,
	                vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
	                faceNormalsEpsilon: data.lighting.facenormalsepsilon,
	                opacity: data.opacity,
	                contourEnable: data.contour.show,
	                contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
	                contourWidth: data.contour.width,
	                useFacetNormals: data.flatshading
	              };
	              if (data.intensity) {
	                var cOpts = extractOpts(data);
	                this.color = "#fff";
	                var mode = data.intensitymode;
	                config[mode + "Intensity"] = data.intensity;
	                config[mode + "IntensityBounds"] = [cOpts.min, cOpts.max];
	                config.colormap = parseColorScale(data);
	              } else if (data.vertexcolor) {
	                this.color = data.vertexcolor[0];
	                config.vertexColors = parseColorArray(data.vertexcolor);
	              } else if (data.facecolor) {
	                this.color = data.facecolor[0];
	                config.cellColors = parseColorArray(data.facecolor);
	              } else {
	                this.color = data.color;
	                config.meshColor = str2RgbaArray(data.color);
	              }
	              this.mesh.update(config);
	            };
	            proto.dispose = function() {
	              this.scene.glplot.remove(this.mesh);
	              this.mesh.dispose();
	            };
	            function createMesh3DTrace(scene, data) {
	              var gl2 = scene.glplot.gl;
	              var mesh = createMesh({
	                gl: gl2
	              });
	              var result = new Mesh3DTrace(scene, mesh, data.uid);
	              mesh._trace = result;
	              result.update(data);
	              scene.glplot.add(mesh);
	              return result;
	            }
	            module2.exports = createMesh3DTrace;
	          }
	        ),
	        /***/
	        58669: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(2418);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              function readComponents(array) {
	                var ret = array.map(function(attr) {
	                  var result = coerce(attr);
	                  if (result && Lib.isArrayOrTypedArray(result)) return result;
	                  return null;
	                });
	                return ret.every(function(x) {
	                  return x && x.length === ret[0].length;
	                }) && ret;
	              }
	              var coords = readComponents(["x", "y", "z"]);
	              if (!coords) {
	                traceOut.visible = false;
	                return;
	              }
	              readComponents(["i", "j", "k"]);
	              if (traceOut.i && (!traceOut.j || !traceOut.k) || traceOut.j && (!traceOut.k || !traceOut.i) || traceOut.k && (!traceOut.i || !traceOut.j)) {
	                traceOut.visible = false;
	                return;
	              }
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y", "z"], layout);
	              ["lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lighting.vertexnormalsepsilon", "lighting.facenormalsepsilon", "lightposition.x", "lightposition.y", "lightposition.z", "flatshading", "alphahull", "delaunayaxis", "opacity"].forEach(function(x) {
	                coerce(x);
	              });
	              var showContour = coerce("contour.show");
	              if (showContour) {
	                coerce("contour.color");
	                coerce("contour.width");
	              }
	              if ("intensity" in traceIn) {
	                coerce("intensity");
	                coerce("intensitymode");
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "",
	                  cLetter: "c"
	                });
	              } else {
	                traceOut.showscale = false;
	                if ("facecolor" in traceIn) coerce("facecolor");
	                else if ("vertexcolor" in traceIn) coerce("vertexcolor");
	                else coerce("color", defaultColor);
	              }
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("zhoverformat");
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        21164: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(2418),
	              supplyDefaults: __webpack_require__2(58669),
	              calc: __webpack_require__2(82932),
	              colorbar: {
	                min: "cmin",
	                max: "cmax"
	              },
	              plot: __webpack_require__2(91134),
	              moduleType: "trace",
	              name: "mesh3d",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        2522: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(71828).extendFlat;
	            var scatterAttrs = __webpack_require__2(82196);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var dash = __webpack_require__2(79952).P;
	            var fxAttrs = __webpack_require__2(77914);
	            var delta = __webpack_require__2(22372);
	            var INCREASING_COLOR = delta.INCREASING.COLOR;
	            var DECREASING_COLOR = delta.DECREASING.COLOR;
	            var lineAttrs = scatterAttrs.line;
	            function directionAttrs(lineColorDefault) {
	              return {
	                line: {
	                  color: extendFlat({}, lineAttrs.color, {
	                    dflt: lineColorDefault
	                  }),
	                  width: lineAttrs.width,
	                  dash,
	                  editType: "style"
	                },
	                editType: "style"
	              };
	            }
	            module2.exports = {
	              xperiod: scatterAttrs.xperiod,
	              xperiod0: scatterAttrs.xperiod0,
	              xperiodalignment: scatterAttrs.xperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              open: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              high: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              low: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              close: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              line: {
	                width: extendFlat({}, lineAttrs.width, {}),
	                dash: extendFlat({}, dash, {}),
	                editType: "style"
	              },
	              increasing: directionAttrs(INCREASING_COLOR),
	              decreasing: directionAttrs(DECREASING_COLOR),
	              text: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              tickwidth: {
	                valType: "number",
	                min: 0,
	                max: 0.5,
	                dflt: 0.3,
	                editType: "calc"
	              },
	              hoverlabel: extendFlat({}, fxAttrs.hoverlabel, {
	                split: {
	                  valType: "boolean",
	                  dflt: false,
	                  editType: "style"
	                }
	              })
	            };
	          }
	        ),
	        /***/
	        3485: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var _ = Lib._;
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis);
	              var ya = Axes.getFromId(gd, trace.yaxis);
	              var tickLen = convertTickWidth(gd, xa, trace);
	              var minDiff = trace._minDiff;
	              trace._minDiff = null;
	              var origX = trace._origX;
	              trace._origX = null;
	              var x = trace._xcalc;
	              trace._xcalc = null;
	              var cd = calcCommon(gd, trace, origX, x, ya, ptFunc);
	              trace._extremes[xa._id] = Axes.findExtremes(xa, x, {
	                vpad: minDiff / 2
	              });
	              if (cd.length) {
	                Lib.extendFlat(cd[0].t, {
	                  wHover: minDiff / 2,
	                  tickLen
	                });
	                return cd;
	              } else {
	                return [{
	                  t: {
	                    empty: true
	                  }
	                }];
	              }
	            }
	            function ptFunc(o, h, l, c) {
	              return {
	                o,
	                h,
	                l,
	                c
	              };
	            }
	            function calcCommon(gd, trace, origX, x, ya, ptFunc2) {
	              var o = ya.makeCalcdata(trace, "open");
	              var h = ya.makeCalcdata(trace, "high");
	              var l = ya.makeCalcdata(trace, "low");
	              var c = ya.makeCalcdata(trace, "close");
	              var hasTextArray = Array.isArray(trace.text);
	              var hasHovertextArray = Array.isArray(trace.hovertext);
	              var increasing = true;
	              var cPrev = null;
	              var hasPeriod = !!trace.xperiodalignment;
	              var cd = [];
	              for (var i = 0; i < x.length; i++) {
	                var xi = x[i];
	                var oi = o[i];
	                var hi = h[i];
	                var li = l[i];
	                var ci = c[i];
	                if (xi !== BADNUM && oi !== BADNUM && hi !== BADNUM && li !== BADNUM && ci !== BADNUM) {
	                  if (ci === oi) {
	                    if (cPrev !== null && ci !== cPrev) increasing = ci > cPrev;
	                  } else increasing = ci > oi;
	                  cPrev = ci;
	                  var pt = ptFunc2(oi, hi, li, ci);
	                  pt.pos = xi;
	                  pt.yc = (oi + ci) / 2;
	                  pt.i = i;
	                  pt.dir = increasing ? "increasing" : "decreasing";
	                  pt.x = pt.pos;
	                  pt.y = [li, hi];
	                  if (hasPeriod) pt.orig_p = origX[i];
	                  if (hasTextArray) pt.tx = trace.text[i];
	                  if (hasHovertextArray) pt.htx = trace.hovertext[i];
	                  cd.push(pt);
	                } else {
	                  cd.push({
	                    pos: xi,
	                    empty: true
	                  });
	                }
	              }
	              trace._extremes[ya._id] = Axes.findExtremes(ya, Lib.concat(l, h), {
	                padded: true
	              });
	              if (cd.length) {
	                cd[0].t = {
	                  labels: {
	                    open: _(gd, "open:") + " ",
	                    high: _(gd, "high:") + " ",
	                    low: _(gd, "low:") + " ",
	                    close: _(gd, "close:") + " "
	                  }
	                };
	              }
	              return cd;
	            }
	            function convertTickWidth(gd, xa, trace) {
	              var minDiff = trace._minDiff;
	              if (!minDiff) {
	                var fullData = gd._fullData;
	                var ohlcTracesOnThisXaxis = [];
	                minDiff = Infinity;
	                var i;
	                for (i = 0; i < fullData.length; i++) {
	                  var tracei = fullData[i];
	                  if (tracei.type === "ohlc" && tracei.visible === true && tracei.xaxis === xa._id) {
	                    ohlcTracesOnThisXaxis.push(tracei);
	                    var origX = xa.makeCalcdata(tracei, "x");
	                    tracei._origX = origX;
	                    var xcalc = alignPeriod(trace, xa, "x", origX).vals;
	                    tracei._xcalc = xcalc;
	                    var _minDiff = Lib.distinctVals(xcalc).minDiff;
	                    if (_minDiff && isFinite(_minDiff)) {
	                      minDiff = Math.min(minDiff, _minDiff);
	                    }
	                  }
	                }
	                if (minDiff === Infinity) minDiff = 1;
	                for (i = 0; i < ohlcTracesOnThisXaxis.length; i++) {
	                  ohlcTracesOnThisXaxis[i]._minDiff = minDiff;
	                }
	              }
	              return minDiff * trace.tickwidth;
	            }
	            module2.exports = {
	              calc,
	              calcCommon
	            };
	          }
	        ),
	        /***/
	        16169: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleOHLC = __webpack_require__2(14555);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var attributes = __webpack_require__2(2522);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleOHLC(traceIn, traceOut, coerce, layout);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce, {
	                x: true
	              });
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("line.width");
	              coerce("line.dash");
	              handleDirection(traceIn, traceOut, coerce, "increasing");
	              handleDirection(traceIn, traceOut, coerce, "decreasing");
	              coerce("text");
	              coerce("hovertext");
	              coerce("tickwidth");
	              layout._requestRangeslider[traceOut.xaxis] = true;
	            };
	            function handleDirection(traceIn, traceOut, coerce, direction) {
	              coerce(direction + ".line.color");
	              coerce(direction + ".line.width", traceOut.line.width);
	              coerce(direction + ".line.dash", traceOut.line.dash);
	            }
	          }
	        ),
	        /***/
	        66449: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var Fx = __webpack_require__2(30211);
	            var Color = __webpack_require__2(7901);
	            var fillText = __webpack_require__2(71828).fillText;
	            var delta = __webpack_require__2(22372);
	            var DIRSYMBOL = {
	              increasing: delta.INCREASING.SYMBOL,
	              decreasing: delta.DECREASING.SYMBOL
	            };
	            function hoverPoints(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              if (trace.hoverlabel.split) {
	                return hoverSplit(pointData, xval, yval, hovermode);
	              }
	              return hoverOnPoints(pointData, xval, yval, hovermode);
	            }
	            function _getClosestPoint(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var xa = pointData.xa;
	              var trace = cd[0].trace;
	              var t = cd[0].t;
	              var type = trace.type;
	              var minAttr = type === "ohlc" ? "l" : "min";
	              var maxAttr = type === "ohlc" ? "h" : "max";
	              var hoverPseudoDistance, spikePseudoDistance;
	              var centerShift = t.bPos || 0;
	              var shiftPos = function(di2) {
	                return di2.pos + centerShift - xval;
	              };
	              var displayHalfWidth = t.bdPos || t.tickLen;
	              var hoverHalfWidth = t.wHover;
	              var pseudoDistance = Math.min(1, displayHalfWidth / Math.abs(xa.r2c(xa.range[1]) - xa.r2c(xa.range[0])));
	              hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
	              spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
	              function dx(di2) {
	                var pos = shiftPos(di2);
	                return Fx.inbox(pos - hoverHalfWidth, pos + hoverHalfWidth, hoverPseudoDistance);
	              }
	              function dy(di2) {
	                var min = di2[minAttr];
	                var max = di2[maxAttr];
	                return min === max || Fx.inbox(min - yval, max - yval, hoverPseudoDistance);
	              }
	              function dxy(di2) {
	                return (dx(di2) + dy(di2)) / 2;
	              }
	              var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	              Fx.getClosest(cd, distfn, pointData);
	              if (pointData.index === false) return null;
	              var di = cd[pointData.index];
	              if (di.empty) return null;
	              var dir = di.dir;
	              var container = trace[dir];
	              var lc = container.line.color;
	              if (Color.opacity(lc) && container.line.width) pointData.color = lc;
	              else pointData.color = container.fillcolor;
	              pointData.x0 = xa.c2p(di.pos + centerShift - displayHalfWidth, true);
	              pointData.x1 = xa.c2p(di.pos + centerShift + displayHalfWidth, true);
	              pointData.xLabelVal = di.orig_p !== undefined ? di.orig_p : di.pos;
	              pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
	              pointData.xSpike = xa.c2p(di.pos, true);
	              return pointData;
	            }
	            function hoverSplit(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var ya = pointData.ya;
	              var trace = cd[0].trace;
	              var t = cd[0].t;
	              var closeBoxData = [];
	              var closestPoint = _getClosestPoint(pointData, xval, yval, hovermode);
	              if (!closestPoint) return [];
	              var cdIndex = closestPoint.index;
	              var di = cd[cdIndex];
	              var hoverinfo = di.hi || trace.hoverinfo;
	              var hoverParts = hoverinfo.split("+");
	              var isAll = hoverinfo === "all";
	              var hasY = isAll || hoverParts.indexOf("y") !== -1;
	              if (!hasY) return [];
	              var attrs = ["high", "open", "close", "low"];
	              var usedVals = {};
	              for (var i = 0; i < attrs.length; i++) {
	                var attr = attrs[i];
	                var val = trace[attr][closestPoint.index];
	                var valPx = ya.c2p(val, true);
	                var pointData2;
	                if (val in usedVals) {
	                  pointData2 = usedVals[val];
	                  pointData2.yLabel += "<br>" + t.labels[attr] + Axes.hoverLabelText(ya, val, trace.yhoverformat);
	                } else {
	                  pointData2 = Lib.extendFlat({}, closestPoint);
	                  pointData2.y0 = pointData2.y1 = valPx;
	                  pointData2.yLabelVal = val;
	                  pointData2.yLabel = t.labels[attr] + Axes.hoverLabelText(ya, val, trace.yhoverformat);
	                  pointData2.name = "";
	                  closeBoxData.push(pointData2);
	                  usedVals[val] = pointData2;
	                }
	              }
	              return closeBoxData;
	            }
	            function hoverOnPoints(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var ya = pointData.ya;
	              var trace = cd[0].trace;
	              var t = cd[0].t;
	              var closestPoint = _getClosestPoint(pointData, xval, yval, hovermode);
	              if (!closestPoint) return [];
	              var cdIndex = closestPoint.index;
	              var di = cd[cdIndex];
	              var i = closestPoint.index = di.i;
	              var dir = di.dir;
	              function getLabelLine(attr) {
	                return t.labels[attr] + Axes.hoverLabelText(ya, trace[attr][i], trace.yhoverformat);
	              }
	              var hoverinfo = di.hi || trace.hoverinfo;
	              var hoverParts = hoverinfo.split("+");
	              var isAll = hoverinfo === "all";
	              var hasY = isAll || hoverParts.indexOf("y") !== -1;
	              var hasText = isAll || hoverParts.indexOf("text") !== -1;
	              var textParts = hasY ? [getLabelLine("open"), getLabelLine("high"), getLabelLine("low"), getLabelLine("close") + "  " + DIRSYMBOL[dir]] : [];
	              if (hasText) fillText(di, trace, textParts);
	              closestPoint.extraText = textParts.join("<br>");
	              closestPoint.y0 = closestPoint.y1 = ya.c2p(di.yc, true);
	              return [closestPoint];
	            }
	            module2.exports = {
	              hoverPoints,
	              hoverSplit,
	              hoverOnPoints
	            };
	          }
	        ),
	        /***/
	        54186: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "ohlc",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "showLegend"],
	              meta: {},
	              attributes: __webpack_require__2(2522),
	              supplyDefaults: __webpack_require__2(16169),
	              calc: __webpack_require__2(3485).calc,
	              plot: __webpack_require__2(72314),
	              style: __webpack_require__2(53101),
	              hoverPoints: __webpack_require__2(66449).hoverPoints,
	              selectPoints: __webpack_require__2(67324)
	            };
	          }
	        ),
	        /***/
	        14555: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function handleOHLC(traceIn, traceOut, coerce, layout) {
	              var x = coerce("x");
	              var open = coerce("open");
	              var high = coerce("high");
	              var low = coerce("low");
	              var close = coerce("close");
	              coerce("hoverlabel.split");
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x"], layout);
	              if (!(open && high && low && close)) return;
	              var len = Math.min(open.length, high.length, low.length, close.length);
	              if (x) len = Math.min(len, Lib.minRowLength(x));
	              traceOut._length = len;
	              return len;
	            };
	          }
	        ),
	        /***/
	        72314: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function plot(gd, plotinfo, cdOHLC, ohlcLayer) {
	              var ya = plotinfo.yaxis;
	              var xa = plotinfo.xaxis;
	              var posHasRangeBreaks = !!xa.rangebreaks;
	              Lib.makeTraceGroups(ohlcLayer, cdOHLC, "trace ohlc").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var t = cd0.t;
	                var trace = cd0.trace;
	                if (trace.visible !== true || t.empty) {
	                  plotGroup.remove();
	                  return;
	                }
	                var tickLen = t.tickLen;
	                var paths = plotGroup.selectAll("path").data(Lib.identity);
	                paths.enter().append("path");
	                paths.exit().remove();
	                paths.attr("d", function(d) {
	                  if (d.empty) return "M0,0Z";
	                  var xo = xa.c2p(d.pos - tickLen, true);
	                  var xc = xa.c2p(d.pos + tickLen, true);
	                  var x = posHasRangeBreaks ? (xo + xc) / 2 : xa.c2p(d.pos, true);
	                  var yo = ya.c2p(d.o, true);
	                  var yh = ya.c2p(d.h, true);
	                  var yl = ya.c2p(d.l, true);
	                  var yc = ya.c2p(d.c, true);
	                  return "M" + xo + "," + yo + "H" + x + "M" + x + "," + yh + "V" + yl + "M" + xc + "," + yc + "H" + x;
	                });
	              });
	            };
	          }
	        ),
	        /***/
	        67324: (
	          /***/
	          function(module2) {
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var i;
	              var posOffset = cd[0].t.bPos || 0;
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  cd[i].selected = 0;
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  var di = cd[i];
	                  if (selectionTester.contains([xa.c2p(di.pos + posOffset), ya.c2p(di.yc)], null, di.i, searchInfo)) {
	                    selection.push({
	                      pointNumber: di.i,
	                      x: xa.c2d(di.pos),
	                      y: ya.c2d(di.yc)
	                    });
	                    di.selected = 1;
	                  } else {
	                    di.selected = 0;
	                  }
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        53101: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            module2.exports = function style(gd, cd, sel) {
	              var s = sel ? sel : d3.select(gd).selectAll("g.ohlclayer").selectAll("g.trace");
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              s.each(function(d) {
	                var trace = d[0].trace;
	                d3.select(this).selectAll("path").each(function(di) {
	                  if (di.empty) return;
	                  var dirLine = trace[di.dir].line;
	                  d3.select(this).style("fill", "none").call(Color.stroke, dirLine.color).call(Drawing.dashLine, dirLine.dash, dirLine.width).style("opacity", trace.selectedpoints && !di.selected ? 0.3 : 1);
	                });
	              });
	            };
	          }
	        ),
	        /***/
	        99506: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var baseAttrs = __webpack_require__2(9012);
	            var fontAttrs = __webpack_require__2(41940);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var line = extendFlat({
	              editType: "calc"
	            }, colorScaleAttrs("line", {
	              editTypeOverride: "calc"
	            }), {
	              shape: {
	                valType: "enumerated",
	                values: ["linear", "hspline"],
	                dflt: "linear",
	                editType: "plot"
	              },
	              hovertemplate: hovertemplateAttrs({
	                editType: "plot",
	                arrayOk: false
	              }, {
	                keys: ["count", "probability"]
	              })
	            });
	            module2.exports = {
	              domain: domainAttrs({
	                name: "parcats",
	                trace: true,
	                editType: "calc"
	              }),
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["count", "probability"],
	                editType: "plot",
	                arrayOk: false
	              }),
	              hoveron: {
	                valType: "enumerated",
	                values: ["category", "color", "dimension"],
	                dflt: "category",
	                editType: "plot"
	              },
	              hovertemplate: hovertemplateAttrs({
	                editType: "plot",
	                arrayOk: false
	              }, {
	                keys: ["count", "probability", "category", "categorycount", "colorcount", "bandcolorcount"]
	              }),
	              arrangement: {
	                valType: "enumerated",
	                values: ["perpendicular", "freeform", "fixed"],
	                dflt: "perpendicular",
	                editType: "plot"
	              },
	              bundlecolors: {
	                valType: "boolean",
	                dflt: true,
	                editType: "plot"
	              },
	              sortpaths: {
	                valType: "enumerated",
	                values: ["forward", "backward"],
	                dflt: "forward",
	                editType: "plot"
	              },
	              labelfont: fontAttrs({
	                editType: "calc"
	              }),
	              tickfont: fontAttrs({
	                editType: "calc"
	              }),
	              dimensions: {
	                _isLinkedToArray: "dimension",
	                label: {
	                  valType: "string",
	                  editType: "calc"
	                },
	                categoryorder: {
	                  valType: "enumerated",
	                  values: ["trace", "category ascending", "category descending", "array"],
	                  dflt: "trace",
	                  editType: "calc"
	                },
	                categoryarray: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                ticktext: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                values: {
	                  valType: "data_array",
	                  dflt: [],
	                  editType: "calc"
	                },
	                displayindex: {
	                  valType: "integer",
	                  editType: "calc"
	                },
	                editType: "calc",
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "calc"
	                }
	              },
	              line,
	              counts: {
	                valType: "number",
	                min: 0,
	                dflt: 1,
	                arrayOk: true,
	                editType: "calc"
	              },
	              // Hide unsupported top-level properties from plot-schema
	              customdata: undefined,
	              hoverlabel: undefined,
	              ids: undefined,
	              legend: undefined,
	              legendgroup: undefined,
	              legendrank: undefined,
	              opacity: undefined,
	              selectedpoints: undefined,
	              showlegend: undefined
	            };
	          }
	        ),
	        /***/
	        27677: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var parcatsPlot = __webpack_require__2(45784);
	            var PARCATS = "parcats";
	            exports2.name = PARCATS;
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              var cdModuleAndOthers = getModuleCalcData(gd.calcdata, PARCATS);
	              if (cdModuleAndOthers.length) {
	                var calcData = cdModuleAndOthers[0];
	                parcatsPlot(gd, calcData, transitionOpts, makeOnCompleteCallback);
	              }
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var hadTable = oldFullLayout._has && oldFullLayout._has("parcats");
	              var hasTable = newFullLayout._has && newFullLayout._has("parcats");
	              if (hadTable && !hasTable) {
	                oldFullLayout._paperdiv.selectAll(".parcats").remove();
	              }
	            };
	          }
	        ),
	        /***/
	        28699: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var wrap = __webpack_require__2(28984).wrap;
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleCalc = __webpack_require__2(78803);
	            var filterUnique = __webpack_require__2(75744);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var isNumeric = __webpack_require__2(92770);
	            module2.exports = function calc(gd, trace) {
	              var visibleDims = Lib.filterVisible(trace.dimensions);
	              if (visibleDims.length === 0) return [];
	              var uniqueInfoDims = visibleDims.map(function(dim) {
	                var categoryValues;
	                if (dim.categoryorder === "trace") {
	                  categoryValues = null;
	                } else if (dim.categoryorder === "array") {
	                  categoryValues = dim.categoryarray;
	                } else {
	                  categoryValues = filterUnique(dim.values);
	                  var allNumeric = true;
	                  for (var i = 0; i < categoryValues.length; i++) {
	                    if (!isNumeric(categoryValues[i])) {
	                      allNumeric = false;
	                      break;
	                    }
	                  }
	                  categoryValues.sort(allNumeric ? Lib.sorterAsc : undefined);
	                  if (dim.categoryorder === "category descending") {
	                    categoryValues = categoryValues.reverse();
	                  }
	                }
	                return getUniqueInfo(dim.values, categoryValues);
	              });
	              var counts, count, totalCount;
	              if (Lib.isArrayOrTypedArray(trace.counts)) {
	                counts = trace.counts;
	              } else {
	                counts = [trace.counts];
	              }
	              validateDimensionDisplayInds(visibleDims);
	              visibleDims.forEach(function(dim, dimInd) {
	                validateCategoryProperties(dim, uniqueInfoDims[dimInd]);
	              });
	              var line = trace.line;
	              var markerColorscale;
	              if (line) {
	                if (hasColorscale(trace, "line")) {
	                  colorscaleCalc(gd, trace, {
	                    vals: trace.line.color,
	                    containerStr: "line",
	                    cLetter: "c"
	                  });
	                }
	                markerColorscale = Drawing.tryColorscale(line);
	              } else {
	                markerColorscale = Lib.identity;
	              }
	              function getMarkerColorInfo(index) {
	                var value, rawColor;
	                if (Lib.isArrayOrTypedArray(line.color)) {
	                  value = line.color[index % line.color.length];
	                  rawColor = value;
	                } else {
	                  value = line.color;
	                }
	                return {
	                  color: markerColorscale(value),
	                  rawColor
	                };
	              }
	              var numValues = visibleDims[0].values.length;
	              var pathModels = {};
	              var categoryIndsDims = uniqueInfoDims.map(function(di) {
	                return di.inds;
	              });
	              totalCount = 0;
	              var valueInd;
	              var d;
	              for (valueInd = 0; valueInd < numValues; valueInd++) {
	                var categoryIndsPath = [];
	                for (d = 0; d < categoryIndsDims.length; d++) {
	                  categoryIndsPath.push(categoryIndsDims[d][valueInd]);
	                }
	                count = counts[valueInd % counts.length];
	                totalCount += count;
	                var pathColorInfo = getMarkerColorInfo(valueInd);
	                var pathKey = categoryIndsPath + "-" + pathColorInfo.rawColor;
	                if (pathModels[pathKey] === undefined) {
	                  pathModels[pathKey] = createPathModel(categoryIndsPath, pathColorInfo.color, pathColorInfo.rawColor);
	                }
	                updatePathModel(pathModels[pathKey], valueInd, count);
	              }
	              var dimensionModels = visibleDims.map(function(di, i) {
	                return createDimensionModel(i, di._index, di._displayindex, di.label, totalCount);
	              });
	              for (valueInd = 0; valueInd < numValues; valueInd++) {
	                count = counts[valueInd % counts.length];
	                for (d = 0; d < dimensionModels.length; d++) {
	                  var containerInd = dimensionModels[d].containerInd;
	                  var catInd = uniqueInfoDims[d].inds[valueInd];
	                  var cats = dimensionModels[d].categories;
	                  if (cats[catInd] === undefined) {
	                    var catValue = trace.dimensions[containerInd]._categoryarray[catInd];
	                    var catLabel = trace.dimensions[containerInd]._ticktext[catInd];
	                    cats[catInd] = createCategoryModel(d, catInd, catValue, catLabel);
	                  }
	                  updateCategoryModel(cats[catInd], valueInd, count);
	                }
	              }
	              return wrap(createParcatsModel(dimensionModels, pathModels, totalCount));
	            };
	            function createParcatsModel(dimensions, paths, count) {
	              var maxCats = dimensions.map(function(d) {
	                return d.categories.length;
	              }).reduce(function(v1, v2) {
	                return Math.max(v1, v2);
	              });
	              return {
	                dimensions,
	                paths,
	                trace: undefined,
	                maxCats,
	                count
	              };
	            }
	            function createDimensionModel(dimensionInd, containerInd, displayInd, dimensionLabel, count) {
	              return {
	                dimensionInd,
	                containerInd,
	                displayInd,
	                dimensionLabel,
	                count,
	                categories: [],
	                dragX: null
	              };
	            }
	            function createCategoryModel(dimensionInd, categoryInd, categoryValue, categoryLabel) {
	              return {
	                dimensionInd,
	                categoryInd,
	                categoryValue,
	                displayInd: categoryInd,
	                categoryLabel,
	                valueInds: [],
	                count: 0,
	                dragY: null
	              };
	            }
	            function updateCategoryModel(categoryModel, valueInd, count) {
	              categoryModel.valueInds.push(valueInd);
	              categoryModel.count += count;
	            }
	            function createPathModel(categoryInds, color, rawColor) {
	              return {
	                categoryInds,
	                color,
	                rawColor,
	                valueInds: [],
	                count: 0
	              };
	            }
	            function updatePathModel(pathModel, valueInd, count) {
	              pathModel.valueInds.push(valueInd);
	              pathModel.count += count;
	            }
	            function getUniqueInfo(values, uniqueValues) {
	              if (uniqueValues === undefined || uniqueValues === null) {
	                uniqueValues = [];
	              } else {
	                uniqueValues = uniqueValues.map(function(e) {
	                  return e;
	                });
	              }
	              var uniqueValueCounts = {};
	              var uniqueValueInds = {};
	              var inds = [];
	              uniqueValues.forEach(function(uniqueVal, valInd) {
	                uniqueValueCounts[uniqueVal] = 0;
	                uniqueValueInds[uniqueVal] = valInd;
	              });
	              for (var i = 0; i < values.length; i++) {
	                var item = values[i];
	                var itemInd;
	                if (uniqueValueCounts[item] === undefined) {
	                  uniqueValueCounts[item] = 1;
	                  itemInd = uniqueValues.push(item) - 1;
	                  uniqueValueInds[item] = itemInd;
	                } else {
	                  uniqueValueCounts[item]++;
	                  itemInd = uniqueValueInds[item];
	                }
	                inds.push(itemInd);
	              }
	              var uniqueCounts = uniqueValues.map(function(v) {
	                return uniqueValueCounts[v];
	              });
	              return {
	                uniqueValues,
	                uniqueCounts,
	                inds
	              };
	            }
	            function validateDimensionDisplayInds(visibleDims) {
	              var displayInds = visibleDims.map(function(d) {
	                return d.displayindex;
	              });
	              var i;
	              if (isRangePermutation(displayInds)) {
	                for (i = 0; i < visibleDims.length; i++) {
	                  visibleDims[i]._displayindex = visibleDims[i].displayindex;
	                }
	              } else {
	                for (i = 0; i < visibleDims.length; i++) {
	                  visibleDims[i]._displayindex = i;
	                }
	              }
	            }
	            function validateCategoryProperties(dim, uniqueInfoDim) {
	              dim._categoryarray = uniqueInfoDim.uniqueValues;
	              if (dim.ticktext === null || dim.ticktext === undefined) {
	                dim._ticktext = [];
	              } else {
	                dim._ticktext = dim.ticktext.slice();
	              }
	              for (var i = dim._ticktext.length; i < uniqueInfoDim.uniqueValues.length; i++) {
	                dim._ticktext.push(uniqueInfoDim.uniqueValues[i]);
	              }
	            }
	            function isRangePermutation(inds) {
	              var indsSpecified = new Array(inds.length);
	              for (var i = 0; i < inds.length; i++) {
	                if (inds[i] < 0 || inds[i] >= inds.length) {
	                  return false;
	                }
	                if (indsSpecified[inds[i]] !== undefined) {
	                  return false;
	                }
	                indsSpecified[inds[i]] = true;
	              }
	              return true;
	            }
	          }
	        ),
	        /***/
	        14647: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(99506);
	            var mergeLength = __webpack_require__2(94397);
	            function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
	              coerce("line.shape");
	              coerce("line.hovertemplate");
	              var lineColor = coerce("line.color", layout.colorway[0]);
	              if (hasColorscale(traceIn, "line") && Lib.isArrayOrTypedArray(lineColor)) {
	                if (lineColor.length) {
	                  coerce("line.colorscale");
	                  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                    prefix: "line.",
	                    cLetter: "c"
	                  });
	                  return lineColor.length;
	                } else {
	                  traceOut.line.color = defaultColor;
	                }
	              }
	              return Infinity;
	            }
	            function dimensionDefaults(dimensionIn, dimensionOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
	              }
	              var values = coerce("values");
	              var visible = coerce("visible");
	              if (!(values && values.length)) {
	                visible = dimensionOut.visible = false;
	              }
	              if (visible) {
	                coerce("label");
	                coerce("displayindex", dimensionOut._index);
	                var arrayIn = dimensionIn.categoryarray;
	                var isValidArray = Array.isArray(arrayIn) && arrayIn.length > 0;
	                var orderDefault;
	                if (isValidArray) orderDefault = "array";
	                var order = coerce("categoryorder", orderDefault);
	                if (order === "array") {
	                  coerce("categoryarray");
	                  coerce("ticktext");
	                } else {
	                  delete dimensionIn.categoryarray;
	                  delete dimensionIn.ticktext;
	                }
	                if (!isValidArray && order === "array") {
	                  dimensionOut.categoryorder = "trace";
	                }
	              }
	            }
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
	                name: "dimensions",
	                handleItemDefaults: dimensionDefaults
	              });
	              var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	              handleDomainDefaults(traceOut, layout, coerce);
	              if (!Array.isArray(dimensions) || !dimensions.length) {
	                traceOut.visible = false;
	              }
	              mergeLength(traceOut, dimensions, "values", len);
	              coerce("hoveron");
	              coerce("hovertemplate");
	              coerce("arrangement");
	              coerce("bundlecolors");
	              coerce("sortpaths");
	              coerce("counts");
	              var labelfontDflt = {
	                family: layout.font.family,
	                size: Math.round(layout.font.size),
	                color: layout.font.color
	              };
	              Lib.coerceFont(coerce, "labelfont", labelfontDflt);
	              var categoryfontDefault = {
	                family: layout.font.family,
	                size: Math.round(layout.font.size / 1.2),
	                color: layout.font.color
	              };
	              Lib.coerceFont(coerce, "tickfont", categoryfontDefault);
	            };
	          }
	        ),
	        /***/
	        94873: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(99506),
	              supplyDefaults: __webpack_require__2(14647),
	              calc: __webpack_require__2(28699),
	              plot: __webpack_require__2(45784),
	              colorbar: {
	                container: "line",
	                min: "cmin",
	                max: "cmax"
	              },
	              moduleType: "trace",
	              name: "parcats",
	              basePlotModule: __webpack_require__2(27677),
	              categories: ["noOpacity"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        45460: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var interpolateNumber = __webpack_require__2(81684).k4;
	            var Plotly = __webpack_require__2(72391);
	            var Fx = __webpack_require__2(30211);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var Drawing = __webpack_require__2(91424);
	            var tinycolor = __webpack_require__2(84267);
	            var svgTextUtils = __webpack_require__2(63893);
	            function performPlot(parcatsModels, graphDiv, layout, svg) {
	              var isStatic = graphDiv._context.staticPlot;
	              var viewModels = parcatsModels.map(createParcatsViewModel.bind(0, graphDiv, layout));
	              var layerSelection = svg.selectAll("g.parcatslayer").data([null]);
	              layerSelection.enter().append("g").attr("class", "parcatslayer").style("pointer-events", isStatic ? "none" : "all");
	              var traceSelection = layerSelection.selectAll("g.trace.parcats").data(viewModels, key);
	              var traceEnter = traceSelection.enter().append("g").attr("class", "trace parcats");
	              traceSelection.attr("transform", function(d) {
	                return strTranslate(d.x, d.y);
	              });
	              traceEnter.append("g").attr("class", "paths");
	              var pathsSelection = traceSelection.select("g.paths");
	              var pathSelection = pathsSelection.selectAll("path.path").data(function(d) {
	                return d.paths;
	              }, key);
	              pathSelection.attr("fill", function(d) {
	                return d.model.color;
	              });
	              var pathSelectionEnter = pathSelection.enter().append("path").attr("class", "path").attr("stroke-opacity", 0).attr("fill", function(d) {
	                return d.model.color;
	              }).attr("fill-opacity", 0);
	              stylePathsNoHover(pathSelectionEnter);
	              pathSelection.attr("d", function(d) {
	                return d.svgD;
	              });
	              if (!pathSelectionEnter.empty()) {
	                pathSelection.sort(compareRawColor);
	              }
	              pathSelection.exit().remove();
	              pathSelection.on("mouseover", mouseoverPath).on("mouseout", mouseoutPath).on("click", clickPath);
	              traceEnter.append("g").attr("class", "dimensions");
	              var dimensionsSelection = traceSelection.select("g.dimensions");
	              var dimensionSelection = dimensionsSelection.selectAll("g.dimension").data(function(d) {
	                return d.dimensions;
	              }, key);
	              dimensionSelection.enter().append("g").attr("class", "dimension");
	              dimensionSelection.attr("transform", function(d) {
	                return strTranslate(d.x, 0);
	              });
	              dimensionSelection.exit().remove();
	              var categorySelection = dimensionSelection.selectAll("g.category").data(function(d) {
	                return d.categories;
	              }, key);
	              var categoryGroupEnterSelection = categorySelection.enter().append("g").attr("class", "category");
	              categorySelection.attr("transform", function(d) {
	                return strTranslate(0, d.y);
	              });
	              categoryGroupEnterSelection.append("rect").attr("class", "catrect").attr("pointer-events", "none");
	              categorySelection.select("rect.catrect").attr("fill", "none").attr("width", function(d) {
	                return d.width;
	              }).attr("height", function(d) {
	                return d.height;
	              });
	              styleCategoriesNoHover(categoryGroupEnterSelection);
	              var bandSelection = categorySelection.selectAll("rect.bandrect").data(
	                /** @param {CategoryViewModel} catViewModel*/
	                function(catViewModel) {
	                  return catViewModel.bands;
	                },
	                key
	              );
	              bandSelection.each(function() {
	                Lib.raiseToTop(this);
	              });
	              bandSelection.attr("fill", function(d) {
	                return d.color;
	              });
	              var bandsSelectionEnter = bandSelection.enter().append("rect").attr("class", "bandrect").attr("stroke-opacity", 0).attr("fill", function(d) {
	                return d.color;
	              }).attr("fill-opacity", 0);
	              bandSelection.attr("fill", function(d) {
	                return d.color;
	              }).attr("width", function(d) {
	                return d.width;
	              }).attr("height", function(d) {
	                return d.height;
	              }).attr("y", function(d) {
	                return d.y;
	              }).attr(
	                "cursor",
	                /** @param {CategoryBandViewModel} bandModel*/
	                function(bandModel) {
	                  if (bandModel.parcatsViewModel.arrangement === "fixed") {
	                    return "default";
	                  } else if (bandModel.parcatsViewModel.arrangement === "perpendicular") {
	                    return "ns-resize";
	                  } else {
	                    return "move";
	                  }
	                }
	              );
	              styleBandsNoHover(bandsSelectionEnter);
	              bandSelection.exit().remove();
	              categoryGroupEnterSelection.append("text").attr("class", "catlabel").attr("pointer-events", "none");
	              var paperColor = graphDiv._fullLayout.paper_bgcolor;
	              categorySelection.select("text.catlabel").attr("text-anchor", function(d) {
	                if (catInRightDim(d)) {
	                  return "start";
	                } else {
	                  return "end";
	                }
	              }).attr("alignment-baseline", "middle").style("text-shadow", svgTextUtils.makeTextShadow(paperColor)).style("fill", "rgb(0, 0, 0)").attr("x", function(d) {
	                if (catInRightDim(d)) {
	                  return d.width + 5;
	                } else {
	                  return -5;
	                }
	              }).attr("y", function(d) {
	                return d.height / 2;
	              }).text(function(d) {
	                return d.model.categoryLabel;
	              }).each(
	                /** @param {CategoryViewModel} catModel*/
	                function(catModel) {
	                  Drawing.font(d3.select(this), catModel.parcatsViewModel.categorylabelfont);
	                  svgTextUtils.convertToTspans(d3.select(this), graphDiv);
	                }
	              );
	              categoryGroupEnterSelection.append("text").attr("class", "dimlabel");
	              categorySelection.select("text.dimlabel").attr("text-anchor", "middle").attr("alignment-baseline", "baseline").attr(
	                "cursor",
	                /** @param {CategoryViewModel} catModel*/
	                function(catModel) {
	                  if (catModel.parcatsViewModel.arrangement === "fixed") {
	                    return "default";
	                  } else {
	                    return "ew-resize";
	                  }
	                }
	              ).attr("x", function(d) {
	                return d.width / 2;
	              }).attr("y", -5).text(function(d, i) {
	                if (i === 0) {
	                  return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
	                } else {
	                  return null;
	                }
	              }).each(
	                /** @param {CategoryViewModel} catModel*/
	                function(catModel) {
	                  Drawing.font(d3.select(this), catModel.parcatsViewModel.labelfont);
	                }
	              );
	              categorySelection.selectAll("rect.bandrect").on("mouseover", mouseoverCategoryBand).on("mouseout", mouseoutCategory);
	              categorySelection.exit().remove();
	              dimensionSelection.call(d3.behavior.drag().origin(function(d) {
	                return {
	                  x: d.x,
	                  y: 0
	                };
	              }).on("dragstart", dragDimensionStart).on("drag", dragDimension).on("dragend", dragDimensionEnd));
	              traceSelection.each(function(d) {
	                d.traceSelection = d3.select(this);
	                d.pathSelection = d3.select(this).selectAll("g.paths").selectAll("path.path");
	                d.dimensionSelection = d3.select(this).selectAll("g.dimensions").selectAll("g.dimension");
	              });
	              traceSelection.exit().remove();
	            }
	            module2.exports = function(graphDiv, svg, parcatsModels, layout) {
	              performPlot(parcatsModels, graphDiv, layout, svg);
	            };
	            function key(d) {
	              return d.key;
	            }
	            function catInRightDim(d) {
	              var numDims = d.parcatsViewModel.dimensions.length;
	              var leftDimInd = d.parcatsViewModel.dimensions[numDims - 1].model.dimensionInd;
	              return d.model.dimensionInd === leftDimInd;
	            }
	            function compareRawColor(a, b) {
	              if (a.model.rawColor > b.model.rawColor) {
	                return 1;
	              } else if (a.model.rawColor < b.model.rawColor) {
	                return -1;
	              } else {
	                return 0;
	              }
	            }
	            function mouseoverPath(d) {
	              if (!d.parcatsViewModel.dragDimension) {
	                if (d.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
	                  Lib.raiseToTop(this);
	                  stylePathsHover(d3.select(this));
	                  var points = buildPointsArrayForPath(d);
	                  var constraints = buildConstraintsForPath(d);
	                  d.parcatsViewModel.graphDiv.emit("plotly_hover", {
	                    points,
	                    event: d3.event,
	                    constraints
	                  });
	                  if (d.parcatsViewModel.hoverinfoItems.indexOf("none") === -1) {
	                    var hoverX = d3.mouse(this)[0];
	                    var gd = d.parcatsViewModel.graphDiv;
	                    var trace = d.parcatsViewModel.trace;
	                    var fullLayout = gd._fullLayout;
	                    var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
	                    var graphDivBBox = d.parcatsViewModel.graphDiv.getBoundingClientRect();
	                    var pathCenterX, pathCenterY, dimInd;
	                    for (dimInd = 0; dimInd < d.leftXs.length - 1; dimInd++) {
	                      if (d.leftXs[dimInd] + d.dimWidths[dimInd] - 2 <= hoverX && hoverX <= d.leftXs[dimInd + 1] + 2) {
	                        var leftDim = d.parcatsViewModel.dimensions[dimInd];
	                        var rightDim = d.parcatsViewModel.dimensions[dimInd + 1];
	                        pathCenterX = (leftDim.x + leftDim.width + rightDim.x) / 2;
	                        pathCenterY = (d.topYs[dimInd] + d.topYs[dimInd + 1] + d.height) / 2;
	                        break;
	                      }
	                    }
	                    var hoverCenterX = d.parcatsViewModel.x + pathCenterX;
	                    var hoverCenterY = d.parcatsViewModel.y + pathCenterY;
	                    var textColor = tinycolor.mostReadable(d.model.color, ["black", "white"]);
	                    var count = d.model.count;
	                    var prob = count / d.parcatsViewModel.model.count;
	                    var labels = {
	                      countLabel: count,
	                      probabilityLabel: prob.toFixed(3)
	                    };
	                    var hovertextParts = [];
	                    if (d.parcatsViewModel.hoverinfoItems.indexOf("count") !== -1) {
	                      hovertextParts.push(["Count:", labels.countLabel].join(" "));
	                    }
	                    if (d.parcatsViewModel.hoverinfoItems.indexOf("probability") !== -1) {
	                      hovertextParts.push(["P:", labels.probabilityLabel].join(" "));
	                    }
	                    var hovertext = hovertextParts.join("<br>");
	                    var mouseX = d3.mouse(gd)[0];
	                    Fx.loneHover({
	                      trace,
	                      x: hoverCenterX - rootBBox.left + graphDivBBox.left,
	                      y: hoverCenterY - rootBBox.top + graphDivBBox.top,
	                      text: hovertext,
	                      color: d.model.color,
	                      borderColor: "black",
	                      fontFamily: 'Monaco, "Courier New", monospace',
	                      fontSize: 10,
	                      fontColor: textColor,
	                      idealAlign: mouseX < hoverCenterX ? "right" : "left",
	                      hovertemplate: (trace.line || {}).hovertemplate,
	                      hovertemplateLabels: labels,
	                      eventData: [{
	                        data: trace._input,
	                        fullData: trace,
	                        count,
	                        probability: prob
	                      }]
	                    }, {
	                      container: fullLayout._hoverlayer.node(),
	                      outerContainer: fullLayout._paper.node(),
	                      gd
	                    });
	                  }
	                }
	              }
	            }
	            function mouseoutPath(d) {
	              if (!d.parcatsViewModel.dragDimension) {
	                stylePathsNoHover(d3.select(this));
	                Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
	                d.parcatsViewModel.pathSelection.sort(compareRawColor);
	                if (d.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
	                  var points = buildPointsArrayForPath(d);
	                  var constraints = buildConstraintsForPath(d);
	                  d.parcatsViewModel.graphDiv.emit("plotly_unhover", {
	                    points,
	                    event: d3.event,
	                    constraints
	                  });
	                }
	              }
	            }
	            function buildPointsArrayForPath(d) {
	              var points = [];
	              var curveNumber = getTraceIndex(d.parcatsViewModel);
	              for (var i = 0; i < d.model.valueInds.length; i++) {
	                var pointNumber = d.model.valueInds[i];
	                points.push({
	                  curveNumber,
	                  pointNumber
	                });
	              }
	              return points;
	            }
	            function buildConstraintsForPath(d) {
	              var constraints = {};
	              var dimensions = d.parcatsViewModel.model.dimensions;
	              for (var i = 0; i < dimensions.length; i++) {
	                var dimension = dimensions[i];
	                var category = dimension.categories[d.model.categoryInds[i]];
	                constraints[dimension.containerInd] = category.categoryValue;
	              }
	              if (d.model.rawColor !== undefined) {
	                constraints.color = d.model.rawColor;
	              }
	              return constraints;
	            }
	            function clickPath(d) {
	              if (d.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
	                var points = buildPointsArrayForPath(d);
	                var constraints = buildConstraintsForPath(d);
	                d.parcatsViewModel.graphDiv.emit("plotly_click", {
	                  points,
	                  event: d3.event,
	                  constraints
	                });
	              }
	            }
	            function stylePathsNoHover(pathSelection) {
	              pathSelection.attr("fill", function(d) {
	                return d.model.color;
	              }).attr("fill-opacity", 0.6).attr("stroke", "lightgray").attr("stroke-width", 0.2).attr("stroke-opacity", 1);
	            }
	            function stylePathsHover(pathSelection) {
	              pathSelection.attr("fill-opacity", 0.8).attr("stroke", function(d) {
	                return tinycolor.mostReadable(d.model.color, ["black", "white"]);
	              }).attr("stroke-width", 0.3);
	            }
	            function styleCategoryHover(categorySelection) {
	              categorySelection.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 2.5);
	            }
	            function styleCategoriesNoHover(categorySelection) {
	              categorySelection.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 1).attr("stroke-opacity", 1);
	            }
	            function styleBandsHover(bandsSelection) {
	              bandsSelection.attr("stroke", "black").attr("stroke-width", 1.5);
	            }
	            function styleBandsNoHover(bandsSelection) {
	              bandsSelection.attr("stroke", "black").attr("stroke-width", 0.2).attr("stroke-opacity", 1).attr("fill-opacity", 1);
	            }
	            function selectPathsThroughCategoryBandColor(catBandViewModel) {
	              var allPaths = catBandViewModel.parcatsViewModel.pathSelection;
	              var dimInd = catBandViewModel.categoryViewModel.model.dimensionInd;
	              var catInd = catBandViewModel.categoryViewModel.model.categoryInd;
	              return allPaths.filter(
	                /** @param {PathViewModel} pathViewModel */
	                function(pathViewModel) {
	                  return pathViewModel.model.categoryInds[dimInd] === catInd && pathViewModel.model.color === catBandViewModel.color;
	                }
	              );
	            }
	            function styleForCategoryHovermode(bandElement) {
	              var bandSel = d3.select(bandElement.parentNode).selectAll("rect.bandrect");
	              bandSel.each(function(bvm) {
	                var paths = selectPathsThroughCategoryBandColor(bvm);
	                stylePathsHover(paths);
	                paths.each(function() {
	                  Lib.raiseToTop(this);
	                });
	              });
	              styleCategoryHover(d3.select(bandElement.parentNode));
	            }
	            function styleForColorHovermode(bandElement) {
	              var bandViewModel = d3.select(bandElement).datum();
	              var catPaths = selectPathsThroughCategoryBandColor(bandViewModel);
	              stylePathsHover(catPaths);
	              catPaths.each(function() {
	                Lib.raiseToTop(this);
	              });
	              d3.select(bandElement.parentNode).selectAll("rect.bandrect").filter(function(b) {
	                return b.color === bandViewModel.color;
	              }).each(function() {
	                Lib.raiseToTop(this);
	                styleBandsHover(d3.select(this));
	              });
	            }
	            function emitPointsEventCategoryHovermode(bandElement, eventName, event) {
	              var bandViewModel = d3.select(bandElement).datum();
	              var categoryModel = bandViewModel.categoryViewModel.model;
	              var gd = bandViewModel.parcatsViewModel.graphDiv;
	              var bandSel = d3.select(bandElement.parentNode).selectAll("rect.bandrect");
	              var points = [];
	              bandSel.each(function(bvm) {
	                var paths = selectPathsThroughCategoryBandColor(bvm);
	                paths.each(function(pathViewModel) {
	                  Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
	                });
	              });
	              var constraints = {};
	              constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
	              gd.emit(eventName, {
	                points,
	                event,
	                constraints
	              });
	            }
	            function emitPointsEventColorHovermode(bandElement, eventName, event) {
	              var bandViewModel = d3.select(bandElement).datum();
	              var categoryModel = bandViewModel.categoryViewModel.model;
	              var gd = bandViewModel.parcatsViewModel.graphDiv;
	              var paths = selectPathsThroughCategoryBandColor(bandViewModel);
	              var points = [];
	              paths.each(function(pathViewModel) {
	                Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
	              });
	              var constraints = {};
	              constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
	              if (bandViewModel.rawColor !== undefined) {
	                constraints.color = bandViewModel.rawColor;
	              }
	              gd.emit(eventName, {
	                points,
	                event,
	                constraints
	              });
	            }
	            function createHoverLabelForCategoryHovermode(gd, rootBBox, bandElement) {
	              gd._fullLayout._calcInverseTransform(gd);
	              var scaleX = gd._fullLayout._invScaleX;
	              var scaleY = gd._fullLayout._invScaleY;
	              var rectSelection = d3.select(bandElement.parentNode).select("rect.catrect");
	              var rectBoundingBox = rectSelection.node().getBoundingClientRect();
	              var catViewModel = rectSelection.datum();
	              var parcatsViewModel = catViewModel.parcatsViewModel;
	              var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
	              var trace = parcatsViewModel.trace;
	              var hoverCenterY = rectBoundingBox.top + rectBoundingBox.height / 2;
	              var hoverCenterX, hoverLabelIdealAlign;
	              if (parcatsViewModel.dimensions.length > 1 && dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
	                hoverCenterX = rectBoundingBox.left;
	                hoverLabelIdealAlign = "left";
	              } else {
	                hoverCenterX = rectBoundingBox.left + rectBoundingBox.width;
	                hoverLabelIdealAlign = "right";
	              }
	              var count = catViewModel.model.count;
	              var catLabel = catViewModel.model.categoryLabel;
	              var prob = count / catViewModel.parcatsViewModel.model.count;
	              var labels = {
	                countLabel: count,
	                categoryLabel: catLabel,
	                probabilityLabel: prob.toFixed(3)
	              };
	              var hoverinfoParts = [];
	              if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf("count") !== -1) {
	                hoverinfoParts.push(["Count:", labels.countLabel].join(" "));
	              }
	              if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf("probability") !== -1) {
	                hoverinfoParts.push(["P(" + labels.categoryLabel + "):", labels.probabilityLabel].join(" "));
	              }
	              var hovertext = hoverinfoParts.join("<br>");
	              return {
	                trace,
	                x: scaleX * (hoverCenterX - rootBBox.left),
	                y: scaleY * (hoverCenterY - rootBBox.top),
	                text: hovertext,
	                color: "lightgray",
	                borderColor: "black",
	                fontFamily: 'Monaco, "Courier New", monospace',
	                fontSize: 12,
	                fontColor: "black",
	                idealAlign: hoverLabelIdealAlign,
	                hovertemplate: trace.hovertemplate,
	                hovertemplateLabels: labels,
	                eventData: [{
	                  data: trace._input,
	                  fullData: trace,
	                  count,
	                  category: catLabel,
	                  probability: prob
	                }]
	              };
	            }
	            function createHoverLabelForDimensionHovermode(gd, rootBBox, bandElement) {
	              var allHoverlabels = [];
	              d3.select(bandElement.parentNode.parentNode).selectAll("g.category").select("rect.catrect").each(function() {
	                var bandNode = this;
	                allHoverlabels.push(createHoverLabelForCategoryHovermode(gd, rootBBox, bandNode));
	              });
	              return allHoverlabels;
	            }
	            function createHoverLabelForColorHovermode(gd, rootBBox, bandElement) {
	              gd._fullLayout._calcInverseTransform(gd);
	              var scaleX = gd._fullLayout._invScaleX;
	              var scaleY = gd._fullLayout._invScaleY;
	              var bandBoundingBox = bandElement.getBoundingClientRect();
	              var bandViewModel = d3.select(bandElement).datum();
	              var catViewModel = bandViewModel.categoryViewModel;
	              var parcatsViewModel = catViewModel.parcatsViewModel;
	              var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
	              var trace = parcatsViewModel.trace;
	              var hoverCenterY = bandBoundingBox.y + bandBoundingBox.height / 2;
	              var hoverCenterX, hoverLabelIdealAlign;
	              if (parcatsViewModel.dimensions.length > 1 && dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
	                hoverCenterX = bandBoundingBox.left;
	                hoverLabelIdealAlign = "left";
	              } else {
	                hoverCenterX = bandBoundingBox.left + bandBoundingBox.width;
	                hoverLabelIdealAlign = "right";
	              }
	              var catLabel = catViewModel.model.categoryLabel;
	              var totalCount = bandViewModel.parcatsViewModel.model.count;
	              var bandColorCount = 0;
	              bandViewModel.categoryViewModel.bands.forEach(function(b) {
	                if (b.color === bandViewModel.color) {
	                  bandColorCount += b.count;
	                }
	              });
	              var catCount = catViewModel.model.count;
	              var colorCount = 0;
	              parcatsViewModel.pathSelection.each(
	                /** @param {PathViewModel} pathViewModel */
	                function(pathViewModel) {
	                  if (pathViewModel.model.color === bandViewModel.color) {
	                    colorCount += pathViewModel.model.count;
	                  }
	                }
	              );
	              var pColorAndCat = bandColorCount / totalCount;
	              var pCatGivenColor = bandColorCount / colorCount;
	              var pColorGivenCat = bandColorCount / catCount;
	              var labels = {
	                countLabel: totalCount,
	                categoryLabel: catLabel,
	                probabilityLabel: pColorAndCat.toFixed(3)
	              };
	              var hoverinfoParts = [];
	              if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf("count") !== -1) {
	                hoverinfoParts.push(["Count:", labels.countLabel].join(" "));
	              }
	              if (catViewModel.parcatsViewModel.hoverinfoItems.indexOf("probability") !== -1) {
	                hoverinfoParts.push("P(color ∩ " + catLabel + "): " + labels.probabilityLabel);
	                hoverinfoParts.push("P(" + catLabel + " | color): " + pCatGivenColor.toFixed(3));
	                hoverinfoParts.push("P(color | " + catLabel + "): " + pColorGivenCat.toFixed(3));
	              }
	              var hovertext = hoverinfoParts.join("<br>");
	              var textColor = tinycolor.mostReadable(bandViewModel.color, ["black", "white"]);
	              return {
	                trace,
	                x: scaleX * (hoverCenterX - rootBBox.left),
	                y: scaleY * (hoverCenterY - rootBBox.top),
	                // name: 'NAME',
	                text: hovertext,
	                color: bandViewModel.color,
	                borderColor: "black",
	                fontFamily: 'Monaco, "Courier New", monospace',
	                fontColor: textColor,
	                fontSize: 10,
	                idealAlign: hoverLabelIdealAlign,
	                hovertemplate: trace.hovertemplate,
	                hovertemplateLabels: labels,
	                eventData: [{
	                  data: trace._input,
	                  fullData: trace,
	                  category: catLabel,
	                  count: totalCount,
	                  probability: pColorAndCat,
	                  categorycount: catCount,
	                  colorcount: colorCount,
	                  bandcolorcount: bandColorCount
	                }]
	              };
	            }
	            function mouseoverCategoryBand(bandViewModel) {
	              if (!bandViewModel.parcatsViewModel.dragDimension) {
	                if (bandViewModel.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
	                  var mouseY = d3.mouse(this)[1];
	                  if (mouseY < -1) {
	                    return;
	                  }
	                  var gd = bandViewModel.parcatsViewModel.graphDiv;
	                  var fullLayout = gd._fullLayout;
	                  var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
	                  var hoveron = bandViewModel.parcatsViewModel.hoveron;
	                  var bandElement = this;
	                  if (hoveron === "color") {
	                    styleForColorHovermode(bandElement);
	                    emitPointsEventColorHovermode(bandElement, "plotly_hover", d3.event);
	                  } else {
	                    styleForCategoryHovermode(bandElement);
	                    emitPointsEventCategoryHovermode(bandElement, "plotly_hover", d3.event);
	                  }
	                  if (bandViewModel.parcatsViewModel.hoverinfoItems.indexOf("none") === -1) {
	                    var hoverItems;
	                    if (hoveron === "category") {
	                      hoverItems = createHoverLabelForCategoryHovermode(gd, rootBBox, bandElement);
	                    } else if (hoveron === "color") {
	                      hoverItems = createHoverLabelForColorHovermode(gd, rootBBox, bandElement);
	                    } else if (hoveron === "dimension") {
	                      hoverItems = createHoverLabelForDimensionHovermode(gd, rootBBox, bandElement);
	                    }
	                    if (hoverItems) {
	                      Fx.loneHover(hoverItems, {
	                        container: fullLayout._hoverlayer.node(),
	                        outerContainer: fullLayout._paper.node(),
	                        gd
	                      });
	                    }
	                  }
	                }
	              }
	            }
	            function mouseoutCategory(bandViewModel) {
	              var parcatsViewModel = bandViewModel.parcatsViewModel;
	              if (!parcatsViewModel.dragDimension) {
	                stylePathsNoHover(parcatsViewModel.pathSelection);
	                styleCategoriesNoHover(parcatsViewModel.dimensionSelection.selectAll("g.category"));
	                styleBandsNoHover(parcatsViewModel.dimensionSelection.selectAll("g.category").selectAll("rect.bandrect"));
	                Fx.loneUnhover(parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
	                parcatsViewModel.pathSelection.sort(compareRawColor);
	                if (parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
	                  var hoveron = bandViewModel.parcatsViewModel.hoveron;
	                  var bandElement = this;
	                  if (hoveron === "color") {
	                    emitPointsEventColorHovermode(bandElement, "plotly_unhover", d3.event);
	                  } else {
	                    emitPointsEventCategoryHovermode(bandElement, "plotly_unhover", d3.event);
	                  }
	                }
	              }
	            }
	            function dragDimensionStart(d) {
	              if (d.parcatsViewModel.arrangement === "fixed") {
	                return;
	              }
	              d.dragDimensionDisplayInd = d.model.displayInd;
	              d.initialDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function(d2) {
	                return d2.displayInd;
	              });
	              d.dragHasMoved = false;
	              d.dragCategoryDisplayInd = null;
	              d3.select(this).selectAll("g.category").select("rect.catrect").each(
	                /** @param {CategoryViewModel} catViewModel */
	                function(catViewModel) {
	                  var catMouseX = d3.mouse(this)[0];
	                  var catMouseY = d3.mouse(this)[1];
	                  if (-2 <= catMouseX && catMouseX <= catViewModel.width + 2 && -2 <= catMouseY && catMouseY <= catViewModel.height + 2) {
	                    d.dragCategoryDisplayInd = catViewModel.model.displayInd;
	                    d.initialDragCategoryDisplayInds = d.model.categories.map(function(c) {
	                      return c.displayInd;
	                    });
	                    catViewModel.model.dragY = catViewModel.y;
	                    Lib.raiseToTop(this.parentNode);
	                    d3.select(this.parentNode).selectAll("rect.bandrect").each(function(bandViewModel) {
	                      if (bandViewModel.y < catMouseY && catMouseY <= bandViewModel.y + bandViewModel.height) {
	                        d.potentialClickBand = this;
	                      }
	                    });
	                  }
	                }
	              );
	              d.parcatsViewModel.dragDimension = d;
	              Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
	            }
	            function dragDimension(d) {
	              if (d.parcatsViewModel.arrangement === "fixed") {
	                return;
	              }
	              d.dragHasMoved = true;
	              if (d.dragDimensionDisplayInd === null) {
	                return;
	              }
	              var dragDimInd = d.dragDimensionDisplayInd;
	              var prevDimInd = dragDimInd - 1;
	              var nextDimInd = dragDimInd + 1;
	              var dragDimension2 = d.parcatsViewModel.dimensions[dragDimInd];
	              if (d.dragCategoryDisplayInd !== null) {
	                var dragCategory = dragDimension2.categories[d.dragCategoryDisplayInd];
	                dragCategory.model.dragY += d3.event.dy;
	                var categoryY = dragCategory.model.dragY;
	                var catDisplayInd = dragCategory.model.displayInd;
	                var dimCategoryViews = dragDimension2.categories;
	                var catAbove = dimCategoryViews[catDisplayInd - 1];
	                var catBelow = dimCategoryViews[catDisplayInd + 1];
	                if (catAbove !== undefined) {
	                  if (categoryY < catAbove.y + catAbove.height / 2) {
	                    dragCategory.model.displayInd = catAbove.model.displayInd;
	                    catAbove.model.displayInd = catDisplayInd;
	                  }
	                }
	                if (catBelow !== undefined) {
	                  if (categoryY + dragCategory.height > catBelow.y + catBelow.height / 2) {
	                    dragCategory.model.displayInd = catBelow.model.displayInd;
	                    catBelow.model.displayInd = catDisplayInd;
	                  }
	                }
	                d.dragCategoryDisplayInd = dragCategory.model.displayInd;
	              }
	              if (d.dragCategoryDisplayInd === null || d.parcatsViewModel.arrangement === "freeform") {
	                dragDimension2.model.dragX = d3.event.x;
	                var prevDimension = d.parcatsViewModel.dimensions[prevDimInd];
	                var nextDimension = d.parcatsViewModel.dimensions[nextDimInd];
	                if (prevDimension !== undefined) {
	                  if (dragDimension2.model.dragX < prevDimension.x + prevDimension.width) {
	                    dragDimension2.model.displayInd = prevDimension.model.displayInd;
	                    prevDimension.model.displayInd = dragDimInd;
	                  }
	                }
	                if (nextDimension !== undefined) {
	                  if (dragDimension2.model.dragX + dragDimension2.width > nextDimension.x) {
	                    dragDimension2.model.displayInd = nextDimension.model.displayInd;
	                    nextDimension.model.displayInd = d.dragDimensionDisplayInd;
	                  }
	                }
	                d.dragDimensionDisplayInd = dragDimension2.model.displayInd;
	              }
	              updateDimensionViewModels(d.parcatsViewModel);
	              updatePathViewModels(d.parcatsViewModel);
	              updateSvgCategories(d.parcatsViewModel);
	              updateSvgPaths(d.parcatsViewModel);
	            }
	            function dragDimensionEnd(d) {
	              if (d.parcatsViewModel.arrangement === "fixed") {
	                return;
	              }
	              if (d.dragDimensionDisplayInd === null) {
	                return;
	              }
	              d3.select(this).selectAll("text").attr("font-weight", "normal");
	              var restyleData = {};
	              var traceInd = getTraceIndex(d.parcatsViewModel);
	              var finalDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function(d2) {
	                return d2.displayInd;
	              });
	              var anyDimsReordered = d.initialDragDimensionDisplayInds.some(function(initDimDisplay, dimInd) {
	                return initDimDisplay !== finalDragDimensionDisplayInds[dimInd];
	              });
	              if (anyDimsReordered) {
	                finalDragDimensionDisplayInds.forEach(function(finalDimDisplay, dimInd) {
	                  var containerInd = d.parcatsViewModel.model.dimensions[dimInd].containerInd;
	                  restyleData["dimensions[" + containerInd + "].displayindex"] = finalDimDisplay;
	                });
	              }
	              var anyCatsReordered = false;
	              if (d.dragCategoryDisplayInd !== null) {
	                var finalDragCategoryDisplayInds = d.model.categories.map(function(c) {
	                  return c.displayInd;
	                });
	                anyCatsReordered = d.initialDragCategoryDisplayInds.some(function(initCatDisplay, catInd) {
	                  return initCatDisplay !== finalDragCategoryDisplayInds[catInd];
	                });
	                if (anyCatsReordered) {
	                  var sortedCategoryModels = d.model.categories.slice().sort(function(a, b) {
	                    return a.displayInd - b.displayInd;
	                  });
	                  var newCategoryArray = sortedCategoryModels.map(function(v) {
	                    return v.categoryValue;
	                  });
	                  var newCategoryLabels = sortedCategoryModels.map(function(v) {
	                    return v.categoryLabel;
	                  });
	                  restyleData["dimensions[" + d.model.containerInd + "].categoryarray"] = [newCategoryArray];
	                  restyleData["dimensions[" + d.model.containerInd + "].ticktext"] = [newCategoryLabels];
	                  restyleData["dimensions[" + d.model.containerInd + "].categoryorder"] = "array";
	                }
	              }
	              if (d.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
	                if (!d.dragHasMoved && d.potentialClickBand) {
	                  if (d.parcatsViewModel.hoveron === "color") {
	                    emitPointsEventColorHovermode(d.potentialClickBand, "plotly_click", d3.event.sourceEvent);
	                  } else {
	                    emitPointsEventCategoryHovermode(d.potentialClickBand, "plotly_click", d3.event.sourceEvent);
	                  }
	                }
	              }
	              d.model.dragX = null;
	              if (d.dragCategoryDisplayInd !== null) {
	                var dragCategory = d.parcatsViewModel.dimensions[d.dragDimensionDisplayInd].categories[d.dragCategoryDisplayInd];
	                dragCategory.model.dragY = null;
	                d.dragCategoryDisplayInd = null;
	              }
	              d.dragDimensionDisplayInd = null;
	              d.parcatsViewModel.dragDimension = null;
	              d.dragHasMoved = null;
	              d.potentialClickBand = null;
	              updateDimensionViewModels(d.parcatsViewModel);
	              updatePathViewModels(d.parcatsViewModel);
	              var transition = d3.transition().duration(300).ease("cubic-in-out");
	              transition.each(function() {
	                updateSvgCategories(d.parcatsViewModel, true);
	                updateSvgPaths(d.parcatsViewModel, true);
	              }).each("end", function() {
	                if (anyDimsReordered || anyCatsReordered) {
	                  Plotly.restyle(d.parcatsViewModel.graphDiv, restyleData, [traceInd]);
	                }
	              });
	            }
	            function getTraceIndex(parcatsViewModel) {
	              var traceInd;
	              var allTraces = parcatsViewModel.graphDiv._fullData;
	              for (var i = 0; i < allTraces.length; i++) {
	                if (parcatsViewModel.key === allTraces[i].uid) {
	                  traceInd = i;
	                  break;
	                }
	              }
	              return traceInd;
	            }
	            function updateSvgPaths(parcatsViewModel, hasTransition) {
	              if (hasTransition === undefined) {
	                hasTransition = false;
	              }
	              function transition(selection) {
	                return hasTransition ? selection.transition() : selection;
	              }
	              parcatsViewModel.pathSelection.data(function(d) {
	                return d.paths;
	              }, key);
	              transition(parcatsViewModel.pathSelection).attr("d", function(d) {
	                return d.svgD;
	              });
	            }
	            function updateSvgCategories(parcatsViewModel, hasTransition) {
	              if (hasTransition === undefined) {
	                hasTransition = false;
	              }
	              function transition(selection) {
	                return hasTransition ? selection.transition() : selection;
	              }
	              parcatsViewModel.dimensionSelection.data(function(d) {
	                return d.dimensions;
	              }, key);
	              var categorySelection = parcatsViewModel.dimensionSelection.selectAll("g.category").data(function(d) {
	                return d.categories;
	              }, key);
	              transition(parcatsViewModel.dimensionSelection).attr("transform", function(d) {
	                return strTranslate(d.x, 0);
	              });
	              transition(categorySelection).attr("transform", function(d) {
	                return strTranslate(0, d.y);
	              });
	              var dimLabelSelection = categorySelection.select(".dimlabel");
	              dimLabelSelection.text(function(d, i) {
	                if (i === 0) {
	                  return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
	                } else {
	                  return null;
	                }
	              });
	              var catLabelSelection = categorySelection.select(".catlabel");
	              catLabelSelection.attr("text-anchor", function(d) {
	                if (catInRightDim(d)) {
	                  return "start";
	                } else {
	                  return "end";
	                }
	              }).attr("x", function(d) {
	                if (catInRightDim(d)) {
	                  return d.width + 5;
	                } else {
	                  return -5;
	                }
	              }).each(function(d) {
	                var newX;
	                var newAnchor;
	                if (catInRightDim(d)) {
	                  newX = d.width + 5;
	                  newAnchor = "start";
	                } else {
	                  newX = -5;
	                  newAnchor = "end";
	                }
	                d3.select(this).selectAll("tspan").attr("x", newX).attr("text-anchor", newAnchor);
	              });
	              var bandSelection = categorySelection.selectAll("rect.bandrect").data(
	                /** @param {CategoryViewModel} catViewModel*/
	                function(catViewModel) {
	                  return catViewModel.bands;
	                },
	                key
	              );
	              var bandsSelectionEnter = bandSelection.enter().append("rect").attr("class", "bandrect").attr("cursor", "move").attr("stroke-opacity", 0).attr("fill", function(d) {
	                return d.color;
	              }).attr("fill-opacity", 0);
	              bandSelection.attr("fill", function(d) {
	                return d.color;
	              }).attr("width", function(d) {
	                return d.width;
	              }).attr("height", function(d) {
	                return d.height;
	              }).attr("y", function(d) {
	                return d.y;
	              });
	              styleBandsNoHover(bandsSelectionEnter);
	              bandSelection.each(function() {
	                Lib.raiseToTop(this);
	              });
	              bandSelection.exit().remove();
	            }
	            function createParcatsViewModel(graphDiv, layout, wrappedParcatsModel) {
	              var parcatsModel = wrappedParcatsModel[0];
	              var margin = layout.margin || {
	                l: 80,
	                r: 80,
	                t: 100,
	                b: 80
	              };
	              var trace = parcatsModel.trace;
	              var domain = trace.domain;
	              var figureWidth = layout.width;
	              var figureHeight = layout.height;
	              var traceWidth = Math.floor(figureWidth * (domain.x[1] - domain.x[0]));
	              var traceHeight = Math.floor(figureHeight * (domain.y[1] - domain.y[0]));
	              var traceX = domain.x[0] * figureWidth + margin.l;
	              var traceY = layout.height - domain.y[1] * layout.height + margin.t;
	              var pathShape = trace.line.shape;
	              var hoverinfoItems;
	              if (trace.hoverinfo === "all") {
	                hoverinfoItems = ["count", "probability"];
	              } else {
	                hoverinfoItems = (trace.hoverinfo || "").split("+");
	              }
	              var parcatsViewModel = {
	                trace,
	                key: trace.uid,
	                model: parcatsModel,
	                x: traceX,
	                y: traceY,
	                width: traceWidth,
	                height: traceHeight,
	                hoveron: trace.hoveron,
	                hoverinfoItems,
	                arrangement: trace.arrangement,
	                bundlecolors: trace.bundlecolors,
	                sortpaths: trace.sortpaths,
	                labelfont: trace.labelfont,
	                categorylabelfont: trace.tickfont,
	                pathShape,
	                dragDimension: null,
	                margin,
	                paths: [],
	                dimensions: [],
	                graphDiv,
	                traceSelection: null,
	                pathSelection: null,
	                dimensionSelection: null
	              };
	              if (parcatsModel.dimensions) {
	                updateDimensionViewModels(parcatsViewModel);
	                updatePathViewModels(parcatsViewModel);
	              }
	              return parcatsViewModel;
	            }
	            function buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, curvature) {
	              var xRefPoints1 = [];
	              var xRefPoints2 = [];
	              var refInterpolator;
	              var d;
	              for (d = 0; d < dimWidths.length - 1; d++) {
	                refInterpolator = interpolateNumber(dimWidths[d] + leftXPositions[d], leftXPositions[d + 1]);
	                xRefPoints1.push(refInterpolator(curvature));
	                xRefPoints2.push(refInterpolator(1 - curvature));
	              }
	              var svgD = "M " + leftXPositions[0] + "," + pathYs[0];
	              svgD += "l" + dimWidths[0] + ",0 ";
	              for (d = 1; d < dimWidths.length; d++) {
	                svgD += "C" + xRefPoints1[d - 1] + "," + pathYs[d - 1] + " " + xRefPoints2[d - 1] + "," + pathYs[d] + " " + leftXPositions[d] + "," + pathYs[d];
	                svgD += "l" + dimWidths[d] + ",0 ";
	              }
	              svgD += "l0," + pathHeight + " ";
	              svgD += "l -" + dimWidths[dimWidths.length - 1] + ",0 ";
	              for (d = dimWidths.length - 2; d >= 0; d--) {
	                svgD += "C" + xRefPoints2[d] + "," + (pathYs[d + 1] + pathHeight) + " " + xRefPoints1[d] + "," + (pathYs[d] + pathHeight) + " " + (leftXPositions[d] + dimWidths[d]) + "," + (pathYs[d] + pathHeight);
	                svgD += "l-" + dimWidths[d] + ",0 ";
	              }
	              svgD += "Z";
	              return svgD;
	            }
	            function updatePathViewModels(parcatsViewModel) {
	              var dimensionViewModels = parcatsViewModel.dimensions;
	              var parcatsModel = parcatsViewModel.model;
	              var nextYPositions = dimensionViewModels.map(function(d2) {
	                return d2.categories.map(function(c) {
	                  return c.y;
	                });
	              });
	              var catToDisplayIndPerDim = parcatsViewModel.model.dimensions.map(function(d2) {
	                return d2.categories.map(function(c) {
	                  return c.displayInd;
	                });
	              });
	              var dimToDisplayInd = parcatsViewModel.model.dimensions.map(function(d2) {
	                return d2.displayInd;
	              });
	              var displayToDimInd = parcatsViewModel.dimensions.map(function(d2) {
	                return d2.model.dimensionInd;
	              });
	              var leftXPositions = dimensionViewModels.map(function(d2) {
	                return d2.x;
	              });
	              var dimWidths = dimensionViewModels.map(function(d2) {
	                return d2.width;
	              });
	              var pathModels = [];
	              for (var p in parcatsModel.paths) {
	                if (parcatsModel.paths.hasOwnProperty(p)) {
	                  pathModels.push(parcatsModel.paths[p]);
	                }
	              }
	              function pathDisplayCategoryInds(pathModel2) {
	                var dimensionInds = pathModel2.categoryInds.map(function(catInd2, dimInd) {
	                  return catToDisplayIndPerDim[dimInd][catInd2];
	                });
	                var displayInds = displayToDimInd.map(function(dimInd) {
	                  return dimensionInds[dimInd];
	                });
	                return displayInds;
	              }
	              pathModels.sort(function(v1, v2) {
	                var sortArray1 = pathDisplayCategoryInds(v1);
	                var sortArray2 = pathDisplayCategoryInds(v2);
	                if (parcatsViewModel.sortpaths === "backward") {
	                  sortArray1.reverse();
	                  sortArray2.reverse();
	                }
	                sortArray1.push(v1.valueInds[0]);
	                sortArray2.push(v2.valueInds[0]);
	                if (parcatsViewModel.bundlecolors) {
	                  sortArray1.unshift(v1.rawColor);
	                  sortArray2.unshift(v2.rawColor);
	                }
	                if (sortArray1 < sortArray2) {
	                  return -1;
	                }
	                if (sortArray1 > sortArray2) {
	                  return 1;
	                }
	                return 0;
	              });
	              var pathViewModels = new Array(pathModels.length);
	              var totalCount = dimensionViewModels[0].model.count;
	              var totalHeight = dimensionViewModels[0].categories.map(function(c) {
	                return c.height;
	              }).reduce(function(v1, v2) {
	                return v1 + v2;
	              });
	              for (var pathNumber = 0; pathNumber < pathModels.length; pathNumber++) {
	                var pathModel = pathModels[pathNumber];
	                var pathHeight;
	                if (totalCount > 0) {
	                  pathHeight = totalHeight * (pathModel.count / totalCount);
	                } else {
	                  pathHeight = 0;
	                }
	                var pathYs = new Array(nextYPositions.length);
	                for (var d = 0; d < pathModel.categoryInds.length; d++) {
	                  var catInd = pathModel.categoryInds[d];
	                  var catDisplayInd = catToDisplayIndPerDim[d][catInd];
	                  var dimDisplayInd = dimToDisplayInd[d];
	                  pathYs[dimDisplayInd] = nextYPositions[dimDisplayInd][catDisplayInd];
	                  nextYPositions[dimDisplayInd][catDisplayInd] += pathHeight;
	                  var catViewModle = parcatsViewModel.dimensions[dimDisplayInd].categories[catDisplayInd];
	                  var numBands = catViewModle.bands.length;
	                  var lastCatBand = catViewModle.bands[numBands - 1];
	                  if (lastCatBand === undefined || pathModel.rawColor !== lastCatBand.rawColor) {
	                    var bandY = lastCatBand === undefined ? 0 : lastCatBand.y + lastCatBand.height;
	                    catViewModle.bands.push({
	                      key: bandY,
	                      color: pathModel.color,
	                      rawColor: pathModel.rawColor,
	                      height: pathHeight,
	                      width: catViewModle.width,
	                      count: pathModel.count,
	                      y: bandY,
	                      categoryViewModel: catViewModle,
	                      parcatsViewModel
	                    });
	                  } else {
	                    var currentBand = catViewModle.bands[numBands - 1];
	                    currentBand.height += pathHeight;
	                    currentBand.count += pathModel.count;
	                  }
	                }
	                var svgD;
	                if (parcatsViewModel.pathShape === "hspline") {
	                  svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0.5);
	                } else {
	                  svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0);
	                }
	                pathViewModels[pathNumber] = {
	                  key: pathModel.valueInds[0],
	                  model: pathModel,
	                  height: pathHeight,
	                  leftXs: leftXPositions,
	                  topYs: pathYs,
	                  dimWidths,
	                  svgD,
	                  parcatsViewModel
	                };
	              }
	              parcatsViewModel.paths = pathViewModels;
	            }
	            function updateDimensionViewModels(parcatsViewModel) {
	              var dimensionsIndInfo = parcatsViewModel.model.dimensions.map(function(d) {
	                return {
	                  displayInd: d.displayInd,
	                  dimensionInd: d.dimensionInd
	                };
	              });
	              dimensionsIndInfo.sort(function(a, b) {
	                return a.displayInd - b.displayInd;
	              });
	              var dimensions = [];
	              for (var displayInd in dimensionsIndInfo) {
	                var dimensionInd = dimensionsIndInfo[displayInd].dimensionInd;
	                var dimModel = parcatsViewModel.model.dimensions[dimensionInd];
	                dimensions.push(createDimensionViewModel(parcatsViewModel, dimModel));
	              }
	              parcatsViewModel.dimensions = dimensions;
	            }
	            function createDimensionViewModel(parcatsViewModel, dimensionModel) {
	              var categoryLabelPad = 40;
	              var dimWidth = 16;
	              var numDimensions = parcatsViewModel.model.dimensions.length;
	              var displayInd = dimensionModel.displayInd;
	              var dimDx;
	              var dimX0;
	              var dimX;
	              if (numDimensions > 1) {
	                dimDx = (parcatsViewModel.width - 2 * categoryLabelPad - dimWidth) / (numDimensions - 1);
	              } else {
	                dimDx = 0;
	              }
	              dimX0 = categoryLabelPad;
	              dimX = dimX0 + dimDx * displayInd;
	              var categories = [];
	              var maxCats = parcatsViewModel.model.maxCats;
	              var numCats = dimensionModel.categories.length;
	              var catSpacing = 8;
	              var totalCount = dimensionModel.count;
	              var totalHeight = parcatsViewModel.height - catSpacing * (maxCats - 1);
	              var nextCatHeight;
	              var nextCatModel;
	              var nextCat;
	              var catInd;
	              var catDisplayInd;
	              var nextCatY = (maxCats - numCats) * catSpacing / 2;
	              var categoryIndInfo = dimensionModel.categories.map(function(c) {
	                return {
	                  displayInd: c.displayInd,
	                  categoryInd: c.categoryInd
	                };
	              });
	              categoryIndInfo.sort(function(a, b) {
	                return a.displayInd - b.displayInd;
	              });
	              for (catDisplayInd = 0; catDisplayInd < numCats; catDisplayInd++) {
	                catInd = categoryIndInfo[catDisplayInd].categoryInd;
	                nextCatModel = dimensionModel.categories[catInd];
	                if (totalCount > 0) {
	                  nextCatHeight = nextCatModel.count / totalCount * totalHeight;
	                } else {
	                  nextCatHeight = 0;
	                }
	                nextCat = {
	                  key: nextCatModel.valueInds[0],
	                  model: nextCatModel,
	                  width: dimWidth,
	                  height: nextCatHeight,
	                  y: nextCatModel.dragY !== null ? nextCatModel.dragY : nextCatY,
	                  bands: [],
	                  parcatsViewModel
	                };
	                nextCatY = nextCatY + nextCatHeight + catSpacing;
	                categories.push(nextCat);
	              }
	              return {
	                key: dimensionModel.dimensionInd,
	                x: dimensionModel.dragX !== null ? dimensionModel.dragX : dimX,
	                y: 0,
	                width: dimWidth,
	                model: dimensionModel,
	                categories,
	                parcatsViewModel,
	                dragCategoryDisplayInd: null,
	                dragDimensionDisplayInd: null,
	                initialDragDimensionDisplayInds: null,
	                initialDragCategoryDisplayInds: null,
	                dragHasMoved: null,
	                potentialClickBand: null
	              };
	            }
	          }
	        ),
	        /***/
	        45784: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parcats = __webpack_require__2(45460);
	            module2.exports = function plot(graphDiv, parcatsModels, transitionOpts, makeOnCompleteCallback) {
	              var fullLayout = graphDiv._fullLayout;
	              var svg = fullLayout._paper;
	              var size = fullLayout._size;
	              parcats(graphDiv, svg, parcatsModels, {
	                width: size.w,
	                height: size.h,
	                margin: {
	                  t: size.t,
	                  r: size.r,
	                  b: size.b,
	                  l: size.l
	                }
	              }, transitionOpts, makeOnCompleteCallback);
	            };
	          }
	        ),
	        /***/
	        73362: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axesAttrs = __webpack_require__2(13838);
	            var fontAttrs = __webpack_require__2(41940);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            module2.exports = {
	              domain: domainAttrs({
	                name: "parcoords",
	                trace: true,
	                editType: "plot"
	              }),
	              labelangle: {
	                valType: "angle",
	                dflt: 0,
	                editType: "plot"
	              },
	              labelside: {
	                valType: "enumerated",
	                values: ["top", "bottom"],
	                dflt: "top",
	                editType: "plot"
	              },
	              labelfont: fontAttrs({
	                editType: "plot"
	              }),
	              tickfont: fontAttrs({
	                editType: "plot"
	              }),
	              rangefont: fontAttrs({
	                editType: "plot"
	              }),
	              dimensions: templatedArray("dimension", {
	                label: {
	                  valType: "string",
	                  editType: "plot"
	                },
	                // TODO: better way to determine ordinal vs continuous axes,
	                // so users can use tickvals/ticktext with a continuous axis.
	                tickvals: extendFlat({}, axesAttrs.tickvals, {
	                  editType: "plot"
	                }),
	                ticktext: extendFlat({}, axesAttrs.ticktext, {
	                  editType: "plot"
	                }),
	                tickformat: extendFlat({}, axesAttrs.tickformat, {
	                  editType: "plot"
	                }),
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                range: {
	                  valType: "info_array",
	                  items: [{
	                    valType: "number",
	                    editType: "plot"
	                  }, {
	                    valType: "number",
	                    editType: "plot"
	                  }],
	                  editType: "plot"
	                },
	                constraintrange: {
	                  valType: "info_array",
	                  freeLength: true,
	                  dimensions: "1-2",
	                  items: [{
	                    valType: "any",
	                    editType: "plot"
	                  }, {
	                    valType: "any",
	                    editType: "plot"
	                  }],
	                  editType: "plot"
	                },
	                multiselect: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                values: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                editType: "calc"
	              }),
	              line: extendFlat({
	                editType: "calc"
	              }, colorScaleAttrs("line", {
	                // the default autocolorscale isn't quite usable for parcoords due to context ambiguity around 0 (grey, off-white)
	                // autocolorscale therefore defaults to false too, to avoid being overridden by the blue-white-red autocolor palette
	                colorscaleDflt: "Viridis",
	                autoColorDflt: false,
	                editTypeOverride: "calc"
	              })),
	              unselected: {
	                line: {
	                  color: {
	                    valType: "color",
	                    dflt: "#7f7f7f",
	                    editType: "plot"
	                  },
	                  opacity: {
	                    valType: "number",
	                    min: 0,
	                    max: 1,
	                    dflt: "auto",
	                    editType: "plot"
	                  },
	                  editType: "plot"
	                },
	                editType: "plot"
	              }
	            };
	          }
	        ),
	        /***/
	        57920: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var c = __webpack_require__2(25706);
	            var d3 = __webpack_require__2(39898);
	            var keyFun = __webpack_require__2(28984).keyFun;
	            var repeat = __webpack_require__2(28984).repeat;
	            var sortAsc = __webpack_require__2(71828).sorterAsc;
	            var strTranslate = __webpack_require__2(71828).strTranslate;
	            var snapRatio = c.bar.snapRatio;
	            function snapOvershoot(v, vAdjacent) {
	              return v * (1 - snapRatio) + vAdjacent * snapRatio;
	            }
	            var snapClose = c.bar.snapClose;
	            function closeToCovering(v, vAdjacent) {
	              return v * (1 - snapClose) + vAdjacent * snapClose;
	            }
	            function ordinalScaleSnap(isHigh, a, v, existingRanges) {
	              if (overlappingExisting(v, existingRanges)) return v;
	              var dir = isHigh ? -1 : 1;
	              var first = 0;
	              var last = a.length - 1;
	              if (dir < 0) {
	                var tmp = first;
	                first = last;
	                last = tmp;
	              }
	              var aHere = a[first];
	              var aPrev = aHere;
	              for (var i = first; dir * i < dir * last; i += dir) {
	                var nextI = i + dir;
	                var aNext = a[nextI];
	                if (dir * v < dir * closeToCovering(aHere, aNext)) return snapOvershoot(aHere, aPrev);
	                if (dir * v < dir * aNext || nextI === last) return snapOvershoot(aNext, aHere);
	                aPrev = aHere;
	                aHere = aNext;
	              }
	            }
	            function overlappingExisting(v, existingRanges) {
	              for (var i = 0; i < existingRanges.length; i++) {
	                if (v >= existingRanges[i][0] && v <= existingRanges[i][1]) return true;
	              }
	              return false;
	            }
	            function barHorizontalSetup(selection) {
	              selection.attr("x", -c.bar.captureWidth / 2).attr("width", c.bar.captureWidth);
	            }
	            function backgroundBarHorizontalSetup(selection) {
	              selection.attr("visibility", "visible").style("visibility", "visible").attr("fill", "yellow").attr("opacity", 0);
	            }
	            function setHighlight(d) {
	              if (!d.brush.filterSpecified) {
	                return "0," + d.height;
	              }
	              var pixelRanges = unitToPx(d.brush.filter.getConsolidated(), d.height);
	              var dashArray = [0];
	              var p, sectionHeight, iNext;
	              var currentGap = pixelRanges.length ? pixelRanges[0][0] : null;
	              for (var i = 0; i < pixelRanges.length; i++) {
	                p = pixelRanges[i];
	                sectionHeight = p[1] - p[0];
	                dashArray.push(currentGap);
	                dashArray.push(sectionHeight);
	                iNext = i + 1;
	                if (iNext < pixelRanges.length) {
	                  currentGap = pixelRanges[iNext][0] - p[1];
	                }
	              }
	              dashArray.push(d.height);
	              return dashArray;
	            }
	            function unitToPx(unitRanges, height) {
	              return unitRanges.map(function(pr) {
	                return pr.map(function(v) {
	                  return Math.max(0, v * height);
	                }).sort(sortAsc);
	              });
	            }
	            function getRegion(fPix, y) {
	              var pad = c.bar.handleHeight;
	              if (y > fPix[1] + pad || y < fPix[0] - pad) return;
	              if (y >= 0.9 * fPix[1] + 0.1 * fPix[0]) return "n";
	              if (y <= 0.9 * fPix[0] + 0.1 * fPix[1]) return "s";
	              return "ns";
	            }
	            function clearCursor() {
	              d3.select(document.body).style("cursor", null);
	            }
	            function styleHighlight(selection) {
	              selection.attr("stroke-dasharray", setHighlight);
	            }
	            function renderHighlight(root, tweenCallback) {
	              var bar = d3.select(root).selectAll(".highlight, .highlight-shadow");
	              var barToStyle = tweenCallback ? bar.transition().duration(c.bar.snapDuration).each("end", tweenCallback) : bar;
	              styleHighlight(barToStyle);
	            }
	            function getInterval(d, y) {
	              var b = d.brush;
	              var active = b.filterSpecified;
	              var closestInterval = NaN;
	              var out = {};
	              var i;
	              if (active) {
	                var height = d.height;
	                var intervals = b.filter.getConsolidated();
	                var pixIntervals = unitToPx(intervals, height);
	                var hoveredInterval = NaN;
	                var previousInterval = NaN;
	                var nextInterval = NaN;
	                for (i = 0; i <= pixIntervals.length; i++) {
	                  var p = pixIntervals[i];
	                  if (p && p[0] <= y && y <= p[1]) {
	                    hoveredInterval = i;
	                    break;
	                  } else {
	                    previousInterval = i ? i - 1 : NaN;
	                    if (p && p[0] > y) {
	                      nextInterval = i;
	                      break;
	                    }
	                  }
	                }
	                closestInterval = hoveredInterval;
	                if (isNaN(closestInterval)) {
	                  if (isNaN(previousInterval) || isNaN(nextInterval)) {
	                    closestInterval = isNaN(previousInterval) ? nextInterval : previousInterval;
	                  } else {
	                    closestInterval = y - pixIntervals[previousInterval][1] < pixIntervals[nextInterval][0] - y ? previousInterval : nextInterval;
	                  }
	                }
	                if (!isNaN(closestInterval)) {
	                  var fPix = pixIntervals[closestInterval];
	                  var region = getRegion(fPix, y);
	                  if (region) {
	                    out.interval = intervals[closestInterval];
	                    out.intervalPix = fPix;
	                    out.region = region;
	                  }
	                }
	              }
	              if (d.ordinal && !out.region) {
	                var a = d.unitTickvals;
	                var unitLocation = d.unitToPaddedPx.invert(y);
	                for (i = 0; i < a.length; i++) {
	                  var rangei = [a[Math.max(i - 1, 0)] * 0.25 + a[i] * 0.75, a[Math.min(i + 1, a.length - 1)] * 0.25 + a[i] * 0.75];
	                  if (unitLocation >= rangei[0] && unitLocation <= rangei[1]) {
	                    out.clickableOrdinalRange = rangei;
	                    break;
	                  }
	                }
	              }
	              return out;
	            }
	            function dragstart(lThis, d) {
	              d3.event.sourceEvent.stopPropagation();
	              var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
	              var unitLocation = d.unitToPaddedPx.invert(y);
	              var b = d.brush;
	              var interval = getInterval(d, y);
	              var unitRange = interval.interval;
	              var s = b.svgBrush;
	              s.wasDragged = false;
	              s.grabbingBar = interval.region === "ns";
	              if (s.grabbingBar) {
	                var pixelRange = unitRange.map(d.unitToPaddedPx);
	                s.grabPoint = y - pixelRange[0] - c.verticalPadding;
	                s.barLength = pixelRange[1] - pixelRange[0];
	              }
	              s.clickableOrdinalRange = interval.clickableOrdinalRange;
	              s.stayingIntervals = d.multiselect && b.filterSpecified ? b.filter.getConsolidated() : [];
	              if (unitRange) {
	                s.stayingIntervals = s.stayingIntervals.filter(function(int2) {
	                  return int2[0] !== unitRange[0] && int2[1] !== unitRange[1];
	                });
	              }
	              s.startExtent = interval.region ? unitRange[interval.region === "s" ? 1 : 0] : unitLocation;
	              d.parent.inBrushDrag = true;
	              s.brushStartCallback();
	            }
	            function drag(lThis, d) {
	              d3.event.sourceEvent.stopPropagation();
	              var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
	              var s = d.brush.svgBrush;
	              s.wasDragged = true;
	              s._dragging = true;
	              if (s.grabbingBar) {
	                s.newExtent = [y - s.grabPoint, y + s.barLength - s.grabPoint].map(d.unitToPaddedPx.invert);
	              } else {
	                s.newExtent = [s.startExtent, d.unitToPaddedPx.invert(y)].sort(sortAsc);
	              }
	              d.brush.filterSpecified = true;
	              s.extent = s.stayingIntervals.concat([s.newExtent]);
	              s.brushCallback(d);
	              renderHighlight(lThis.parentNode);
	            }
	            function dragend(lThis, d) {
	              var brush = d.brush;
	              var filter = brush.filter;
	              var s = brush.svgBrush;
	              if (!s._dragging) {
	                mousemove(lThis, d);
	                drag(lThis, d);
	                d.brush.svgBrush.wasDragged = false;
	              }
	              s._dragging = false;
	              var e = d3.event;
	              e.sourceEvent.stopPropagation();
	              var grabbingBar = s.grabbingBar;
	              s.grabbingBar = false;
	              s.grabLocation = undefined;
	              d.parent.inBrushDrag = false;
	              clearCursor();
	              if (!s.wasDragged) {
	                s.wasDragged = undefined;
	                if (s.clickableOrdinalRange) {
	                  if (brush.filterSpecified && d.multiselect) {
	                    s.extent.push(s.clickableOrdinalRange);
	                  } else {
	                    s.extent = [s.clickableOrdinalRange];
	                    brush.filterSpecified = true;
	                  }
	                } else if (grabbingBar) {
	                  s.extent = s.stayingIntervals;
	                  if (s.extent.length === 0) {
	                    brushClear(brush);
	                  }
	                } else {
	                  brushClear(brush);
	                }
	                s.brushCallback(d);
	                renderHighlight(lThis.parentNode);
	                s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
	                return;
	              }
	              var mergeIntervals = function() {
	                filter.set(filter.getConsolidated());
	              };
	              if (d.ordinal) {
	                var a = d.unitTickvals;
	                if (a[a.length - 1] < a[0]) a.reverse();
	                s.newExtent = [ordinalScaleSnap(0, a, s.newExtent[0], s.stayingIntervals), ordinalScaleSnap(1, a, s.newExtent[1], s.stayingIntervals)];
	                var hasNewExtent = s.newExtent[1] > s.newExtent[0];
	                s.extent = s.stayingIntervals.concat(hasNewExtent ? [s.newExtent] : []);
	                if (!s.extent.length) {
	                  brushClear(brush);
	                }
	                s.brushCallback(d);
	                if (hasNewExtent) {
	                  renderHighlight(lThis.parentNode, mergeIntervals);
	                } else {
	                  mergeIntervals();
	                  renderHighlight(lThis.parentNode);
	                }
	              } else {
	                mergeIntervals();
	              }
	              s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
	            }
	            function mousemove(lThis, d) {
	              var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
	              var interval = getInterval(d, y);
	              var cursor = "crosshair";
	              if (interval.clickableOrdinalRange) cursor = "pointer";
	              else if (interval.region) cursor = interval.region + "-resize";
	              d3.select(document.body).style("cursor", cursor);
	            }
	            function attachDragBehavior(selection) {
	              selection.on("mousemove", function(d) {
	                d3.event.preventDefault();
	                if (!d.parent.inBrushDrag) mousemove(this, d);
	              }).on("mouseleave", function(d) {
	                if (!d.parent.inBrushDrag) clearCursor();
	              }).call(d3.behavior.drag().on("dragstart", function(d) {
	                dragstart(this, d);
	              }).on("drag", function(d) {
	                drag(this, d);
	              }).on("dragend", function(d) {
	                dragend(this, d);
	              }));
	            }
	            function startAsc(a, b) {
	              return a[0] - b[0];
	            }
	            function renderAxisBrush(axisBrush, paperColor, gd) {
	              var isStatic = gd._context.staticPlot;
	              var background = axisBrush.selectAll(".background").data(repeat);
	              background.enter().append("rect").classed("background", true).call(barHorizontalSetup).call(backgroundBarHorizontalSetup).style("pointer-events", isStatic ? "none" : "auto").attr("transform", strTranslate(0, c.verticalPadding));
	              background.call(attachDragBehavior).attr("height", function(d) {
	                return d.height - c.verticalPadding;
	              });
	              var highlightShadow = axisBrush.selectAll(".highlight-shadow").data(repeat);
	              highlightShadow.enter().append("line").classed("highlight-shadow", true).attr("x", -c.bar.width / 2).attr("stroke-width", c.bar.width + c.bar.strokeWidth).attr("stroke", paperColor).attr("opacity", c.bar.strokeOpacity).attr("stroke-linecap", "butt");
	              highlightShadow.attr("y1", function(d) {
	                return d.height;
	              }).call(styleHighlight);
	              var highlight = axisBrush.selectAll(".highlight").data(repeat);
	              highlight.enter().append("line").classed("highlight", true).attr("x", -c.bar.width / 2).attr("stroke-width", c.bar.width - c.bar.strokeWidth).attr("stroke", c.bar.fillColor).attr("opacity", c.bar.fillOpacity).attr("stroke-linecap", "butt");
	              highlight.attr("y1", function(d) {
	                return d.height;
	              }).call(styleHighlight);
	            }
	            function ensureAxisBrush(axisOverlays, paperColor, gd) {
	              var axisBrush = axisOverlays.selectAll("." + c.cn.axisBrush).data(repeat, keyFun);
	              axisBrush.enter().append("g").classed(c.cn.axisBrush, true);
	              renderAxisBrush(axisBrush, paperColor, gd);
	            }
	            function getBrushExtent(brush) {
	              return brush.svgBrush.extent.map(function(e) {
	                return e.slice();
	              });
	            }
	            function brushClear(brush) {
	              brush.filterSpecified = false;
	              brush.svgBrush.extent = [[-Infinity, Infinity]];
	            }
	            function axisBrushMoved(callback) {
	              return function axisBrushMoved2(dimension) {
	                var brush = dimension.brush;
	                var extent2 = getBrushExtent(brush);
	                var newExtent = extent2.slice();
	                brush.filter.set(newExtent);
	                callback();
	              };
	            }
	            function dedupeRealRanges(intervals) {
	              var queue = intervals.slice();
	              var result = [];
	              var currentInterval;
	              var current = queue.shift();
	              while (current) {
	                currentInterval = current.slice();
	                while ((current = queue.shift()) && current[0] <= /* right-open interval would need `<` */
	                currentInterval[1]) {
	                  currentInterval[1] = Math.max(currentInterval[1], current[1]);
	                }
	                result.push(currentInterval);
	              }
	              if (result.length === 1 && result[0][0] > result[0][1]) {
	                result = [];
	              }
	              return result;
	            }
	            function makeFilter() {
	              var filter = [];
	              var consolidated;
	              var bounds;
	              return {
	                set: function(a) {
	                  filter = a.map(function(d) {
	                    return d.slice().sort(sortAsc);
	                  }).sort(startAsc);
	                  if (filter.length === 1 && filter[0][0] === -Infinity && filter[0][1] === Infinity) {
	                    filter = [[0, -1]];
	                  }
	                  consolidated = dedupeRealRanges(filter);
	                  bounds = filter.reduce(function(p, n) {
	                    return [Math.min(p[0], n[0]), Math.max(p[1], n[1])];
	                  }, [Infinity, -Infinity]);
	                },
	                get: function() {
	                  return filter.slice();
	                },
	                getConsolidated: function() {
	                  return consolidated;
	                },
	                getBounds: function() {
	                  return bounds;
	                }
	              };
	            }
	            function makeBrush(state, rangeSpecified, initialRange, brushStartCallback, brushCallback, brushEndCallback) {
	              var filter = makeFilter();
	              filter.set(initialRange);
	              return {
	                filter,
	                filterSpecified: rangeSpecified,
	                // there's a difference between not filtering and filtering a non-proper subset
	                svgBrush: {
	                  extent: [],
	                  // this is where the svgBrush writes contents into
	                  brushStartCallback,
	                  brushCallback: axisBrushMoved(brushCallback),
	                  brushEndCallback
	                }
	              };
	            }
	            function cleanRanges(ranges, dimension) {
	              if (Array.isArray(ranges[0])) {
	                ranges = ranges.map(function(ri) {
	                  return ri.sort(sortAsc);
	                });
	                if (!dimension.multiselect) ranges = [ranges[0]];
	                else ranges = dedupeRealRanges(ranges.sort(startAsc));
	              } else ranges = [ranges.sort(sortAsc)];
	              if (dimension.tickvals) {
	                var sortedTickVals = dimension.tickvals.slice().sort(sortAsc);
	                ranges = ranges.map(function(ri) {
	                  var rSnapped = [ordinalScaleSnap(0, sortedTickVals, ri[0], []), ordinalScaleSnap(1, sortedTickVals, ri[1], [])];
	                  if (rSnapped[1] > rSnapped[0]) return rSnapped;
	                }).filter(function(ri) {
	                  return ri;
	                });
	                if (!ranges.length) return;
	              }
	              return ranges.length > 1 ? ranges : ranges[0];
	            }
	            module2.exports = {
	              makeBrush,
	              ensureAxisBrush,
	              cleanRanges
	            };
	          }
	        ),
	        /***/
	        71791: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(73362),
	              supplyDefaults: __webpack_require__2(3633),
	              calc: __webpack_require__2(24639),
	              colorbar: {
	                container: "line",
	                min: "cmin",
	                max: "cmax"
	              },
	              moduleType: "trace",
	              name: "parcoords",
	              basePlotModule: __webpack_require__2(49351),
	              categories: ["gl", "regl", "noOpacity", "noHover"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        49351: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var parcoordsPlot = __webpack_require__2(21341);
	            var xmlnsNamespaces = __webpack_require__2(77922);
	            exports2.name = "parcoords";
	            exports2.plot = function(gd) {
	              var calcData = getModuleCalcData(gd.calcdata, "parcoords")[0];
	              if (calcData.length) parcoordsPlot(gd, calcData);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var hadParcoords = oldFullLayout._has && oldFullLayout._has("parcoords");
	              var hasParcoords = newFullLayout._has && newFullLayout._has("parcoords");
	              if (hadParcoords && !hasParcoords) {
	                oldFullLayout._paperdiv.selectAll(".parcoords").remove();
	                oldFullLayout._glimages.selectAll("*").remove();
	              }
	            };
	            exports2.toSVG = function(gd) {
	              var imageRoot = gd._fullLayout._glimages;
	              var root = d3.select(gd).selectAll(".svg-container");
	              var canvases = root.filter(function(d, i) {
	                return i === root.size() - 1;
	              }).selectAll(".gl-canvas-context, .gl-canvas-focus");
	              function canvasToImage() {
	                var canvas = this;
	                var imageData = canvas.toDataURL("image/png");
	                var image = imageRoot.append("svg:image");
	                image.attr({
	                  xmlns: xmlnsNamespaces.svg,
	                  "xlink:href": imageData,
	                  preserveAspectRatio: "none",
	                  x: 0,
	                  y: 0,
	                  width: canvas.style.width,
	                  height: canvas.style.height
	                });
	              }
	              canvases.each(canvasToImage);
	              window.setTimeout(function() {
	                d3.selectAll("#filterBarPattern").attr("id", "filterBarPattern");
	              }, 60);
	            };
	          }
	        ),
	        /***/
	        24639: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            var Colorscale = __webpack_require__2(21081);
	            var wrap = __webpack_require__2(28984).wrap;
	            module2.exports = function calc(gd, trace) {
	              var lineColor;
	              var cscale;
	              if (Colorscale.hasColorscale(trace, "line") && isArrayOrTypedArray(trace.line.color)) {
	                lineColor = trace.line.color;
	                cscale = Colorscale.extractOpts(trace.line).colorscale;
	                Colorscale.calc(gd, trace, {
	                  vals: lineColor,
	                  containerStr: "line",
	                  cLetter: "c"
	                });
	              } else {
	                lineColor = constHalf(trace._length);
	                cscale = [[0, trace.line.color], [1, trace.line.color]];
	              }
	              return wrap({
	                lineColor,
	                cscale
	              });
	            };
	            function constHalf(len) {
	              var out = new Array(len);
	              for (var i = 0; i < len; i++) {
	                out[i] = 0.5;
	              }
	              return out;
	            }
	          }
	        ),
	        /***/
	        25706: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              maxDimensionCount: 60,
	              // this cannot be increased without WebGL code refactoring
	              overdrag: 45,
	              verticalPadding: 2,
	              // otherwise, horizontal lines on top or bottom are of lower width
	              tickDistance: 50,
	              canvasPixelRatio: 1,
	              blockLineCount: 5e3,
	              layers: ["contextLineLayer", "focusLineLayer", "pickLineLayer"],
	              axisTitleOffset: 28,
	              axisExtentOffset: 10,
	              bar: {
	                width: 4,
	                // Visible width of the filter bar
	                captureWidth: 10,
	                // Mouse-sensitive width for interaction (Fitts law)
	                fillColor: "magenta",
	                // Color of the filter bar fill
	                fillOpacity: 1,
	                // Filter bar fill opacity
	                snapDuration: 150,
	                // tween duration in ms for brush snap for ordinal axes
	                snapRatio: 0.25,
	                // ratio of bar extension relative to the distance between two adjacent ordinal values
	                snapClose: 0.01,
	                // fraction of inter-value distance to snap to the closer one, even if you're not over it
	                strokeOpacity: 1,
	                // Filter bar side stroke opacity
	                strokeWidth: 1,
	                // Filter bar side stroke width in pixels
	                handleHeight: 8,
	                // Height of the filter bar vertical resize areas on top and bottom
	                handleOpacity: 1,
	                // Opacity of the filter bar vertical resize areas on top and bottom
	                handleOverlap: 0
	                // A larger than 0 value causes overlaps with the filter bar, represented as pixels
	              },
	              cn: {
	                axisExtentText: "axis-extent-text",
	                parcoordsLineLayers: "parcoords-line-layers",
	                parcoordsLineLayer: "parcoords-lines",
	                parcoords: "parcoords",
	                parcoordsControlView: "parcoords-control-view",
	                yAxis: "y-axis",
	                axisOverlays: "axis-overlays",
	                axis: "axis",
	                axisHeading: "axis-heading",
	                axisTitle: "axis-title",
	                axisExtent: "axis-extent",
	                axisExtentTop: "axis-extent-top",
	                axisExtentTopText: "axis-extent-top-text",
	                axisExtentBottom: "axis-extent-bottom",
	                axisExtentBottomText: "axis-extent-bottom-text",
	                axisBrush: "axis-brush"
	              },
	              id: {
	                filterBarPattern: "filter-bar-pattern"
	              }
	            };
	          }
	        ),
	        /***/
	        3633: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var Axes = __webpack_require__2(89298);
	            var attributes = __webpack_require__2(73362);
	            var axisBrush = __webpack_require__2(57920);
	            var maxDimensionCount = __webpack_require__2(25706).maxDimensionCount;
	            var mergeLength = __webpack_require__2(94397);
	            function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
	              var lineColor = coerce("line.color", defaultColor);
	              if (hasColorscale(traceIn, "line") && Lib.isArrayOrTypedArray(lineColor)) {
	                if (lineColor.length) {
	                  coerce("line.colorscale");
	                  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                    prefix: "line.",
	                    cLetter: "c"
	                  });
	                  return lineColor.length;
	                } else {
	                  traceOut.line.color = defaultColor;
	                }
	              }
	              return Infinity;
	            }
	            function dimensionDefaults(dimensionIn, dimensionOut, parentOut, opts) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
	              }
	              var values = coerce("values");
	              var visible = coerce("visible");
	              if (!(values && values.length)) {
	                visible = dimensionOut.visible = false;
	              }
	              if (visible) {
	                coerce("label");
	                coerce("tickvals");
	                coerce("ticktext");
	                coerce("tickformat");
	                var range2 = coerce("range");
	                dimensionOut._ax = {
	                  _id: "y",
	                  type: "linear",
	                  showexponent: "all",
	                  exponentformat: "B",
	                  range: range2
	                };
	                Axes.setConvert(dimensionOut._ax, opts.layout);
	                coerce("multiselect");
	                var constraintRange = coerce("constraintrange");
	                if (constraintRange) {
	                  dimensionOut.constraintrange = axisBrush.cleanRanges(constraintRange, dimensionOut);
	                }
	              }
	            }
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var dimensionsIn = traceIn.dimensions;
	              if (Array.isArray(dimensionsIn) && dimensionsIn.length > maxDimensionCount) {
	                Lib.log("parcoords traces support up to " + maxDimensionCount + " dimensions at the moment");
	                dimensionsIn.splice(maxDimensionCount);
	              }
	              var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
	                name: "dimensions",
	                layout,
	                handleItemDefaults: dimensionDefaults
	              });
	              var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	              handleDomainDefaults(traceOut, layout, coerce);
	              if (!Array.isArray(dimensions) || !dimensions.length) {
	                traceOut.visible = false;
	              }
	              mergeLength(traceOut, dimensions, "values", len);
	              var fontDflt = {
	                family: layout.font.family,
	                size: Math.round(layout.font.size / 1.2),
	                color: layout.font.color
	              };
	              Lib.coerceFont(coerce, "labelfont", fontDflt);
	              Lib.coerceFont(coerce, "tickfont", fontDflt);
	              Lib.coerceFont(coerce, "rangefont", fontDflt);
	              coerce("labelangle");
	              coerce("labelside");
	              coerce("unselected.line.color");
	              coerce("unselected.line.opacity");
	            };
	          }
	        ),
	        /***/
	        1602: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isTypedArray = __webpack_require__2(71828).isTypedArray;
	            exports2.convertTypedArray = function(a) {
	              return isTypedArray(a) ? Array.prototype.slice.call(a) : a;
	            };
	            exports2.isOrdinal = function(dimension) {
	              return !!dimension.tickvals;
	            };
	            exports2.isVisible = function(dimension) {
	              return dimension.visible || !("visible" in dimension);
	            };
	          }
	        ),
	        /***/
	        67618: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var index = __webpack_require__2(71791);
	            index.plot = __webpack_require__2(21341);
	            module2.exports = index;
	          }
	        ),
	        /***/
	        83398: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var glslify = __webpack_require__2(56068);
	            var vertexShaderSource = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nattribute vec4 p01_04, p05_08, p09_12, p13_16,\n               p17_20, p21_24, p25_28, p29_32,\n               p33_36, p37_40, p41_44, p45_48,\n               p49_52, p53_56, p57_60, colors;\n\nuniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,\n             loA, hiA, loB, hiB, loC, hiC, loD, hiD;\n\nuniform vec2 resolution, viewBoxPos, viewBoxSize;\nuniform float maskHeight;\nuniform float drwLayer; // 0: context, 1: focus, 2: pick\nuniform vec4 contextColor;\nuniform sampler2D maskTexture, palette;\n\nbool isPick    = (drwLayer > 1.5);\nbool isContext = (drwLayer < 0.5);\n\nconst vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);\nconst vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);\n\nfloat val(mat4 p, mat4 v) {\n    return dot(matrixCompMult(p, v) * UNITS, UNITS);\n}\n\nfloat axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);\n    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);\n    return y1 * (1.0 - ratio) + y2 * ratio;\n}\n\nint iMod(int a, int b) {\n    return a - b * (a / b);\n}\n\nbool fOutside(float p, float lo, float hi) {\n    return (lo < hi) && (lo > p || p > hi);\n}\n\nbool vOutside(vec4 p, vec4 lo, vec4 hi) {\n    return (\n        fOutside(p[0], lo[0], hi[0]) ||\n        fOutside(p[1], lo[1], hi[1]) ||\n        fOutside(p[2], lo[2], hi[2]) ||\n        fOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool mOutside(mat4 p, mat4 lo, mat4 hi) {\n    return (\n        vOutside(p[0], lo[0], hi[0]) ||\n        vOutside(p[1], lo[1], hi[1]) ||\n        vOutside(p[2], lo[2], hi[2]) ||\n        vOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {\n    return mOutside(A, loA, hiA) ||\n           mOutside(B, loB, hiB) ||\n           mOutside(C, loC, hiC) ||\n           mOutside(D, loD, hiD);\n}\n\nbool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {\n    mat4 pnts[4];\n    pnts[0] = A;\n    pnts[1] = B;\n    pnts[2] = C;\n    pnts[3] = D;\n\n    for(int i = 0; i < 4; ++i) {\n        for(int j = 0; j < 4; ++j) {\n            for(int k = 0; k < 4; ++k) {\n                if(0 == iMod(\n                    int(255.0 * texture2D(maskTexture,\n                        vec2(\n                            (float(i * 2 + j / 2) + 0.5) / 8.0,\n                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight\n                        ))[3]\n                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),\n                    2\n                )) return true;\n            }\n        }\n    }\n    return false;\n}\n\nvec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float x = 0.5 * sign(v) + 0.5;\n    float y = axisY(x, A, B, C, D);\n    float z = 1.0 - abs(v);\n\n    z += isContext ? 0.0 : 2.0 * float(\n        outsideBoundingBox(A, B, C, D) ||\n        outsideRasterMask(A, B, C, D)\n    );\n\n    return vec4(\n        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,\n        z,\n        1.0\n    );\n}\n\nvoid main() {\n    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);\n    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);\n    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);\n    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);\n\n    float v = colors[3];\n\n    gl_Position = position(isContext, v, A, B, C, D);\n\n    fragColor =\n        isContext ? vec4(contextColor) :\n        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));\n}\n"]);
	            var fragmentShaderSource = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n    gl_FragColor = fragColor;\n}\n"]);
	            var maxDim = __webpack_require__2(25706).maxDimensionCount;
	            var Lib = __webpack_require__2(71828);
	            var depthLimitEpsilon = 1e-6;
	            var maskHeight = 2048;
	            var dummyPixel = new Uint8Array(4);
	            var dataPixel = new Uint8Array(4);
	            var paletteTextureConfig = {
	              shape: [256, 1],
	              format: "rgba",
	              type: "uint8",
	              mag: "nearest",
	              min: "nearest"
	            };
	            function ensureDraw(regl) {
	              regl.read({
	                x: 0,
	                y: 0,
	                width: 1,
	                height: 1,
	                data: dummyPixel
	              });
	            }
	            function clear(regl, x, y, width, height) {
	              var gl2 = regl._gl;
	              gl2.enable(gl2.SCISSOR_TEST);
	              gl2.scissor(x, y, width, height);
	              regl.clear({
	                color: [0, 0, 0, 0],
	                depth: 1
	              });
	            }
	            function renderBlock(regl, glAes, renderState, blockLineCount, sampleCount, item) {
	              var rafKey = item.key;
	              function render(blockNumber) {
	                var count = Math.min(blockLineCount, sampleCount - blockNumber * blockLineCount);
	                if (blockNumber === 0) {
	                  window.cancelAnimationFrame(renderState.currentRafs[rafKey]);
	                  delete renderState.currentRafs[rafKey];
	                  clear(regl, item.scissorX, item.scissorY, item.scissorWidth, item.viewBoxSize[1]);
	                }
	                if (renderState.clearOnly) {
	                  return;
	                }
	                item.count = 2 * count;
	                item.offset = 2 * blockNumber * blockLineCount;
	                glAes(item);
	                if (blockNumber * blockLineCount + count < sampleCount) {
	                  renderState.currentRafs[rafKey] = window.requestAnimationFrame(function() {
	                    render(blockNumber + 1);
	                  });
	                }
	                renderState.drawCompleted = false;
	              }
	              if (!renderState.drawCompleted) {
	                ensureDraw(regl);
	                renderState.drawCompleted = true;
	              }
	              render(0);
	            }
	            function adjustDepth(d) {
	              return Math.max(depthLimitEpsilon, Math.min(1 - depthLimitEpsilon, d));
	            }
	            function palette(unitToColor, opacity) {
	              var result = new Array(256);
	              for (var i = 0; i < 256; i++) {
	                result[i] = unitToColor(i / 255).concat(opacity);
	              }
	              return result;
	            }
	            function calcPickColor(i, rgbIndex) {
	              return (i >>> 8 * rgbIndex) % 256 / 255;
	            }
	            function makePoints(sampleCount, dims, color) {
	              var points = new Array(sampleCount * (maxDim + 4));
	              var n = 0;
	              for (var i = 0; i < sampleCount; i++) {
	                for (var k = 0; k < maxDim; k++) {
	                  points[n++] = k < dims.length ? dims[k].paddedUnitValues[i] : 0.5;
	                }
	                points[n++] = calcPickColor(i, 2);
	                points[n++] = calcPickColor(i, 1);
	                points[n++] = calcPickColor(i, 0);
	                points[n++] = adjustDepth(color[i]);
	              }
	              return points;
	            }
	            function makeVecAttr(vecIndex, sampleCount, points) {
	              var pointPairs = new Array(sampleCount * 8);
	              var n = 0;
	              for (var i = 0; i < sampleCount; i++) {
	                for (var j = 0; j < 2; j++) {
	                  for (var k = 0; k < 4; k++) {
	                    var q = vecIndex * 4 + k;
	                    var v = points[i * 64 + q];
	                    if (q === 63 && j === 0) {
	                      v *= -1;
	                    }
	                    pointPairs[n++] = v;
	                  }
	                }
	              }
	              return pointPairs;
	            }
	            function pad2(num) {
	              var s = "0" + num;
	              return s.substr(s.length - 2);
	            }
	            function getAttrName(i) {
	              return i < maxDim ? "p" + pad2(i + 1) + "_" + pad2(i + 4) : "colors";
	            }
	            function setAttributes(attributes, sampleCount, points) {
	              for (var i = 0; i <= maxDim; i += 4) {
	                attributes[getAttrName(i)](makeVecAttr(i / 4, sampleCount, points));
	              }
	            }
	            function emptyAttributes(regl) {
	              var attributes = {};
	              for (var i = 0; i <= maxDim; i += 4) {
	                attributes[getAttrName(i)] = regl.buffer({
	                  usage: "dynamic",
	                  type: "float",
	                  data: new Uint8Array(0)
	                });
	              }
	              return attributes;
	            }
	            function makeItem(model, leftmost, rightmost, itemNumber, i0, i1, x, y, panelSizeX, panelSizeY, crossfilterDimensionIndex, drwLayer, constraints, plotGlPixelRatio) {
	              var dims = [[], []];
	              for (var k = 0; k < 64; k++) {
	                dims[0][k] = k === i0 ? 1 : 0;
	                dims[1][k] = k === i1 ? 1 : 0;
	              }
	              x *= plotGlPixelRatio;
	              y *= plotGlPixelRatio;
	              panelSizeX *= plotGlPixelRatio;
	              panelSizeY *= plotGlPixelRatio;
	              var overdrag = model.lines.canvasOverdrag * plotGlPixelRatio;
	              var domain = model.domain;
	              var canvasWidth = model.canvasWidth * plotGlPixelRatio;
	              var canvasHeight = model.canvasHeight * plotGlPixelRatio;
	              var padL = model.pad.l * plotGlPixelRatio;
	              var padB = model.pad.b * plotGlPixelRatio;
	              var layoutHeight = model.layoutHeight * plotGlPixelRatio;
	              var layoutWidth = model.layoutWidth * plotGlPixelRatio;
	              var deselectedLinesColor = model.deselectedLines.color;
	              var deselectedLinesOpacity = model.deselectedLines.opacity;
	              var itemModel = Lib.extendFlat({
	                key: crossfilterDimensionIndex,
	                resolution: [canvasWidth, canvasHeight],
	                viewBoxPos: [x + overdrag, y],
	                viewBoxSize: [panelSizeX, panelSizeY],
	                i0,
	                i1,
	                dim0A: dims[0].slice(0, 16),
	                dim0B: dims[0].slice(16, 32),
	                dim0C: dims[0].slice(32, 48),
	                dim0D: dims[0].slice(48, 64),
	                dim1A: dims[1].slice(0, 16),
	                dim1B: dims[1].slice(16, 32),
	                dim1C: dims[1].slice(32, 48),
	                dim1D: dims[1].slice(48, 64),
	                drwLayer,
	                contextColor: [deselectedLinesColor[0] / 255, deselectedLinesColor[1] / 255, deselectedLinesColor[2] / 255, deselectedLinesOpacity !== "auto" ? deselectedLinesColor[3] * deselectedLinesOpacity : Math.max(1 / 255, Math.pow(1 / model.lines.color.length, 1 / 3))],
	                scissorX: (itemNumber === leftmost ? 0 : x + overdrag) + (padL - overdrag) + layoutWidth * domain.x[0],
	                scissorWidth: (itemNumber === rightmost ? canvasWidth - x + overdrag : panelSizeX + 0.5) + (itemNumber === leftmost ? x + overdrag : 0),
	                scissorY: y + padB + layoutHeight * domain.y[0],
	                scissorHeight: panelSizeY,
	                viewportX: padL - overdrag + layoutWidth * domain.x[0],
	                viewportY: padB + layoutHeight * domain.y[0],
	                viewportWidth: canvasWidth,
	                viewportHeight: canvasHeight
	              }, constraints);
	              return itemModel;
	            }
	            function expandedPixelRange(bounds) {
	              var dh = maskHeight - 1;
	              var a = Math.max(0, Math.floor(bounds[0] * dh), 0);
	              var b = Math.min(dh, Math.ceil(bounds[1] * dh), dh);
	              return [Math.min(a, b), Math.max(a, b)];
	            }
	            module2.exports = function(canvasGL, d) {
	              var isContext = d.context;
	              var isPick = d.pick;
	              var regl = d.regl;
	              var gl2 = regl._gl;
	              var supportedLineWidth = gl2.getParameter(gl2.ALIASED_LINE_WIDTH_RANGE);
	              var plotGlPixelRatio = Math.max(supportedLineWidth[0], Math.min(supportedLineWidth[1], d.viewModel.plotGlPixelRatio));
	              var renderState = {
	                currentRafs: {},
	                drawCompleted: true,
	                clearOnly: false
	              };
	              var model;
	              var vm;
	              var initialDims;
	              var sampleCount;
	              var attributes = emptyAttributes(regl);
	              var maskTexture;
	              var paletteTexture = regl.texture(paletteTextureConfig);
	              var prevAxisOrder = [];
	              update(d);
	              var glAes = regl({
	                profile: false,
	                blend: {
	                  enable: isContext,
	                  func: {
	                    srcRGB: "src alpha",
	                    dstRGB: "one minus src alpha",
	                    srcAlpha: 1,
	                    dstAlpha: 1
	                    // 'one minus src alpha'
	                  },
	                  equation: {
	                    rgb: "add",
	                    alpha: "add"
	                  },
	                  color: [0, 0, 0, 0]
	                },
	                depth: {
	                  enable: !isContext,
	                  mask: true,
	                  func: "less",
	                  range: [0, 1]
	                },
	                // for polygons
	                cull: {
	                  enable: true,
	                  face: "back"
	                },
	                scissor: {
	                  enable: true,
	                  box: {
	                    x: regl.prop("scissorX"),
	                    y: regl.prop("scissorY"),
	                    width: regl.prop("scissorWidth"),
	                    height: regl.prop("scissorHeight")
	                  }
	                },
	                viewport: {
	                  x: regl.prop("viewportX"),
	                  y: regl.prop("viewportY"),
	                  width: regl.prop("viewportWidth"),
	                  height: regl.prop("viewportHeight")
	                },
	                dither: false,
	                vert: vertexShaderSource,
	                frag: fragmentShaderSource,
	                primitive: "lines",
	                lineWidth: plotGlPixelRatio,
	                attributes,
	                uniforms: {
	                  resolution: regl.prop("resolution"),
	                  viewBoxPos: regl.prop("viewBoxPos"),
	                  viewBoxSize: regl.prop("viewBoxSize"),
	                  dim0A: regl.prop("dim0A"),
	                  dim1A: regl.prop("dim1A"),
	                  dim0B: regl.prop("dim0B"),
	                  dim1B: regl.prop("dim1B"),
	                  dim0C: regl.prop("dim0C"),
	                  dim1C: regl.prop("dim1C"),
	                  dim0D: regl.prop("dim0D"),
	                  dim1D: regl.prop("dim1D"),
	                  loA: regl.prop("loA"),
	                  hiA: regl.prop("hiA"),
	                  loB: regl.prop("loB"),
	                  hiB: regl.prop("hiB"),
	                  loC: regl.prop("loC"),
	                  hiC: regl.prop("hiC"),
	                  loD: regl.prop("loD"),
	                  hiD: regl.prop("hiD"),
	                  palette: paletteTexture,
	                  contextColor: regl.prop("contextColor"),
	                  maskTexture: regl.prop("maskTexture"),
	                  drwLayer: regl.prop("drwLayer"),
	                  maskHeight: regl.prop("maskHeight")
	                },
	                offset: regl.prop("offset"),
	                count: regl.prop("count")
	              });
	              function update(dNew) {
	                model = dNew.model;
	                vm = dNew.viewModel;
	                initialDims = vm.dimensions.slice();
	                sampleCount = initialDims[0] ? initialDims[0].values.length : 0;
	                var lines = model.lines;
	                var color = isPick ? lines.color.map(function(_, i) {
	                  return i / lines.color.length;
	                }) : lines.color;
	                var points = makePoints(sampleCount, initialDims, color);
	                setAttributes(attributes, sampleCount, points);
	                if (!isContext && !isPick) {
	                  paletteTexture = regl.texture(Lib.extendFlat({
	                    data: palette(model.unitToColor, 255)
	                  }, paletteTextureConfig));
	                }
	              }
	              function makeConstraints(isContext2) {
	                var i, j, k;
	                var limits = [[], []];
	                for (k = 0; k < 64; k++) {
	                  var p = !isContext2 && k < initialDims.length ? initialDims[k].brush.filter.getBounds() : [-Infinity, Infinity];
	                  limits[0][k] = p[0];
	                  limits[1][k] = p[1];
	                }
	                var len = maskHeight * 8;
	                var mask = new Array(len);
	                for (i = 0; i < len; i++) {
	                  mask[i] = 255;
	                }
	                if (!isContext2) {
	                  for (i = 0; i < initialDims.length; i++) {
	                    var u = i % 8;
	                    var v = (i - u) / 8;
	                    var bitMask = Math.pow(2, u);
	                    var dim = initialDims[i];
	                    var ranges = dim.brush.filter.get();
	                    if (ranges.length < 2) continue;
	                    var prevEnd = expandedPixelRange(ranges[0])[1];
	                    for (j = 1; j < ranges.length; j++) {
	                      var nextRange = expandedPixelRange(ranges[j]);
	                      for (k = prevEnd + 1; k < nextRange[0]; k++) {
	                        mask[k * 8 + v] &= ~bitMask;
	                      }
	                      prevEnd = Math.max(prevEnd, nextRange[1]);
	                    }
	                  }
	                }
	                var textureData = {
	                  // 8 units x 8 bits = 64 bits, just sufficient for the almost 64 dimensions we support
	                  shape: [8, maskHeight],
	                  format: "alpha",
	                  type: "uint8",
	                  mag: "nearest",
	                  min: "nearest",
	                  data: mask
	                };
	                if (maskTexture) maskTexture(textureData);
	                else maskTexture = regl.texture(textureData);
	                return {
	                  maskTexture,
	                  maskHeight,
	                  loA: limits[0].slice(0, 16),
	                  loB: limits[0].slice(16, 32),
	                  loC: limits[0].slice(32, 48),
	                  loD: limits[0].slice(48, 64),
	                  hiA: limits[1].slice(0, 16),
	                  hiB: limits[1].slice(16, 32),
	                  hiC: limits[1].slice(32, 48),
	                  hiD: limits[1].slice(48, 64)
	                };
	              }
	              function renderGLParcoords(panels, setChanged, clearOnly) {
	                var panelCount = panels.length;
	                var i;
	                var leftmost;
	                var rightmost;
	                var lowestX = Infinity;
	                var highestX = -Infinity;
	                for (i = 0; i < panelCount; i++) {
	                  if (panels[i].dim0.canvasX < lowestX) {
	                    lowestX = panels[i].dim0.canvasX;
	                    leftmost = i;
	                  }
	                  if (panels[i].dim1.canvasX > highestX) {
	                    highestX = panels[i].dim1.canvasX;
	                    rightmost = i;
	                  }
	                }
	                if (panelCount === 0) {
	                  clear(regl, 0, 0, model.canvasWidth, model.canvasHeight);
	                }
	                var constraints = makeConstraints(isContext);
	                for (i = 0; i < panelCount; i++) {
	                  var p = panels[i];
	                  var i0 = p.dim0.crossfilterDimensionIndex;
	                  var i1 = p.dim1.crossfilterDimensionIndex;
	                  var x = p.canvasX;
	                  var y = p.canvasY;
	                  var nextX = x + p.panelSizeX;
	                  var plotGlPixelRatio2 = p.plotGlPixelRatio;
	                  if (setChanged || !prevAxisOrder[i0] || prevAxisOrder[i0][0] !== x || prevAxisOrder[i0][1] !== nextX) {
	                    prevAxisOrder[i0] = [x, nextX];
	                    var item = makeItem(model, leftmost, rightmost, i, i0, i1, x, y, p.panelSizeX, p.panelSizeY, p.dim0.crossfilterDimensionIndex, isContext ? 0 : isPick ? 2 : 1, constraints, plotGlPixelRatio2);
	                    renderState.clearOnly = clearOnly;
	                    var blockLineCount = setChanged ? model.lines.blockLineCount : sampleCount;
	                    renderBlock(regl, glAes, renderState, blockLineCount, sampleCount, item);
	                  }
	                }
	              }
	              function readPixel(canvasX, canvasY) {
	                regl.read({
	                  x: canvasX,
	                  y: canvasY,
	                  width: 1,
	                  height: 1,
	                  data: dataPixel
	                });
	                return dataPixel;
	              }
	              function readPixels(canvasX, canvasY, width, height) {
	                var pixelArray = new Uint8Array(4 * width * height);
	                regl.read({
	                  x: canvasX,
	                  y: canvasY,
	                  width,
	                  height,
	                  data: pixelArray
	                });
	                return pixelArray;
	              }
	              function destroy() {
	                canvasGL.style["pointer-events"] = "none";
	                paletteTexture.destroy();
	                if (maskTexture) maskTexture.destroy();
	                for (var k in attributes) attributes[k].destroy();
	              }
	              return {
	                render: renderGLParcoords,
	                readPixel,
	                readPixels,
	                destroy,
	                update
	              };
	            };
	          }
	        ),
	        /***/
	        94397: (
	          /***/
	          function(module2) {
	            module2.exports = function(traceOut, dimensions, dataAttr, len) {
	              if (!len) len = Infinity;
	              var i, dimi;
	              for (i = 0; i < dimensions.length; i++) {
	                dimi = dimensions[i];
	                if (dimi.visible) len = Math.min(len, dimi[dataAttr].length);
	              }
	              if (len === Infinity) len = 0;
	              traceOut._length = len;
	              for (i = 0; i < dimensions.length; i++) {
	                dimi = dimensions[i];
	                if (dimi.visible) dimi._length = len;
	              }
	              return len;
	            };
	          }
	        ),
	        /***/
	        17171: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var numberFormat = Lib.numberFormat;
	            var rgba = __webpack_require__2(36652);
	            var Axes = __webpack_require__2(89298);
	            var strRotate = Lib.strRotate;
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var Drawing = __webpack_require__2(91424);
	            var Colorscale = __webpack_require__2(21081);
	            var gup = __webpack_require__2(28984);
	            var keyFun = gup.keyFun;
	            var repeat = gup.repeat;
	            var unwrap = gup.unwrap;
	            var helpers = __webpack_require__2(1602);
	            var c = __webpack_require__2(25706);
	            var brush = __webpack_require__2(57920);
	            var lineLayerMaker = __webpack_require__2(83398);
	            function findExtreme(fn, values, len) {
	              return Lib.aggNums(fn, null, values, len);
	            }
	            function findExtremes(values, len) {
	              return fixExtremes(findExtreme(Math.min, values, len), findExtreme(Math.max, values, len));
	            }
	            function dimensionExtent(dimension) {
	              var range2 = dimension.range;
	              return range2 ? fixExtremes(range2[0], range2[1]) : findExtremes(dimension.values, dimension._length);
	            }
	            function fixExtremes(lo, hi) {
	              if (isNaN(lo) || !isFinite(lo)) {
	                lo = 0;
	              }
	              if (isNaN(hi) || !isFinite(hi)) {
	                hi = 0;
	              }
	              if (lo === hi) {
	                if (lo === 0) {
	                  lo -= 1;
	                  hi += 1;
	                } else {
	                  lo *= 0.9;
	                  hi *= 1.1;
	                }
	              }
	              return [lo, hi];
	            }
	            function toText(formatter, texts) {
	              if (texts) {
	                return function(v, i) {
	                  var text = texts[i];
	                  if (text === null || text === undefined) return formatter(v);
	                  return text;
	                };
	              }
	              return formatter;
	            }
	            function domainScale(height, padding, dimension, tickvals, ticktext) {
	              var extent2 = dimensionExtent(dimension);
	              if (tickvals) {
	                return d3.scale.ordinal().domain(tickvals.map(toText(numberFormat(dimension.tickformat), ticktext))).range(tickvals.map(function(d) {
	                  var unitVal = (d - extent2[0]) / (extent2[1] - extent2[0]);
	                  return height - padding + unitVal * (2 * padding - height);
	                }));
	              }
	              return d3.scale.linear().domain(extent2).range([height - padding, padding]);
	            }
	            function unitToPaddedPx(height, padding) {
	              return d3.scale.linear().range([padding, height - padding]);
	            }
	            function domainToPaddedUnitScale(dimension, padFraction) {
	              return d3.scale.linear().domain(dimensionExtent(dimension)).range([padFraction, 1 - padFraction]);
	            }
	            function ordinalScale(dimension) {
	              if (!dimension.tickvals) return;
	              var extent2 = dimensionExtent(dimension);
	              return d3.scale.ordinal().domain(dimension.tickvals).range(dimension.tickvals.map(function(d) {
	                return (d - extent2[0]) / (extent2[1] - extent2[0]);
	              }));
	            }
	            function unitToColorScale(cscale) {
	              var colorStops = cscale.map(function(d) {
	                return d[0];
	              });
	              var colorTuples = cscale.map(function(d) {
	                var RGBA = rgba(d[1]);
	                return d3.rgb("rgb(" + RGBA[0] + "," + RGBA[1] + "," + RGBA[2] + ")");
	              });
	              var prop = function(n) {
	                return function(o) {
	                  return o[n];
	                };
	              };
	              var polylinearUnitScales = "rgb".split("").map(function(key) {
	                return d3.scale.linear().clamp(true).domain(colorStops).range(colorTuples.map(prop(key)));
	              });
	              return function(d) {
	                return polylinearUnitScales.map(function(s) {
	                  return s(d);
	                });
	              };
	            }
	            function someFiltersActive(view) {
	              return view.dimensions.some(function(p) {
	                return p.brush.filterSpecified;
	              });
	            }
	            function model(layout, d, i) {
	              var cd0 = unwrap(d);
	              var trace = cd0.trace;
	              var lineColor = helpers.convertTypedArray(cd0.lineColor);
	              var line = trace.line;
	              var deselectedLines = {
	                color: rgba(trace.unselected.line.color),
	                opacity: trace.unselected.line.opacity
	              };
	              var cOpts = Colorscale.extractOpts(line);
	              var cscale = cOpts.reversescale ? Colorscale.flipScale(cd0.cscale) : cd0.cscale;
	              var domain = trace.domain;
	              var dimensions = trace.dimensions;
	              var width = layout.width;
	              var labelAngle = trace.labelangle;
	              var labelSide = trace.labelside;
	              var labelFont = trace.labelfont;
	              var tickFont = trace.tickfont;
	              var rangeFont = trace.rangefont;
	              var lines = Lib.extendDeepNoArrays({}, line, {
	                color: lineColor.map(d3.scale.linear().domain(dimensionExtent({
	                  values: lineColor,
	                  range: [cOpts.min, cOpts.max],
	                  _length: trace._length
	                }))),
	                blockLineCount: c.blockLineCount,
	                canvasOverdrag: c.overdrag * c.canvasPixelRatio
	              });
	              var groupWidth = Math.floor(width * (domain.x[1] - domain.x[0]));
	              var groupHeight = Math.floor(layout.height * (domain.y[1] - domain.y[0]));
	              var pad = layout.margin || {
	                l: 80,
	                r: 80,
	                t: 100,
	                b: 80
	              };
	              var rowContentWidth = groupWidth;
	              var rowHeight = groupHeight;
	              return {
	                key: i,
	                colCount: dimensions.filter(helpers.isVisible).length,
	                dimensions,
	                tickDistance: c.tickDistance,
	                unitToColor: unitToColorScale(cscale),
	                lines,
	                deselectedLines,
	                labelAngle,
	                labelSide,
	                labelFont,
	                tickFont,
	                rangeFont,
	                layoutWidth: width,
	                layoutHeight: layout.height,
	                domain,
	                translateX: domain.x[0] * width,
	                translateY: layout.height - domain.y[1] * layout.height,
	                pad,
	                canvasWidth: rowContentWidth * c.canvasPixelRatio + 2 * lines.canvasOverdrag,
	                canvasHeight: rowHeight * c.canvasPixelRatio,
	                width: rowContentWidth,
	                height: rowHeight,
	                canvasPixelRatio: c.canvasPixelRatio
	              };
	            }
	            function viewModel(state, callbacks, model2) {
	              var width = model2.width;
	              var height = model2.height;
	              var dimensions = model2.dimensions;
	              var canvasPixelRatio = model2.canvasPixelRatio;
	              var xScale = function(d) {
	                return width * d / Math.max(1, model2.colCount - 1);
	              };
	              var unitPad = c.verticalPadding / height;
	              var _unitToPaddedPx = unitToPaddedPx(height, c.verticalPadding);
	              var vm = {
	                key: model2.key,
	                xScale,
	                model: model2,
	                inBrushDrag: false
	                // consider factoring it out and putting it in a centralized global-ish gesture state object
	              };
	              var uniqueKeys = {};
	              vm.dimensions = dimensions.filter(helpers.isVisible).map(function(dimension, i) {
	                var domainToPaddedUnit = domainToPaddedUnitScale(dimension, unitPad);
	                var foundKey = uniqueKeys[dimension.label];
	                uniqueKeys[dimension.label] = (foundKey || 0) + 1;
	                var key = dimension.label + (foundKey ? "__" + foundKey : "");
	                var specifiedConstraint = dimension.constraintrange;
	                var filterRangeSpecified = specifiedConstraint && specifiedConstraint.length;
	                if (filterRangeSpecified && !Array.isArray(specifiedConstraint[0])) {
	                  specifiedConstraint = [specifiedConstraint];
	                }
	                var filterRange = filterRangeSpecified ? specifiedConstraint.map(function(d) {
	                  return d.map(domainToPaddedUnit);
	                }) : [[-Infinity, Infinity]];
	                var brushMove = function() {
	                  var p = vm;
	                  p.focusLayer && p.focusLayer.render(p.panels, true);
	                  var filtersActive = someFiltersActive(p);
	                  if (!state.contextShown() && filtersActive) {
	                    p.contextLayer && p.contextLayer.render(p.panels, true);
	                    state.contextShown(true);
	                  } else if (state.contextShown() && !filtersActive) {
	                    p.contextLayer && p.contextLayer.render(p.panels, true, true);
	                    state.contextShown(false);
	                  }
	                };
	                var truncatedValues = dimension.values;
	                if (truncatedValues.length > dimension._length) {
	                  truncatedValues = truncatedValues.slice(0, dimension._length);
	                }
	                var tickvals = dimension.tickvals;
	                var ticktext;
	                function makeTickItem(v, i2) {
	                  return {
	                    val: v,
	                    text: ticktext[i2]
	                  };
	                }
	                function sortTickItem(a, b) {
	                  return a.val - b.val;
	                }
	                if (Array.isArray(tickvals) && tickvals.length) {
	                  ticktext = dimension.ticktext;
	                  if (!Array.isArray(ticktext) || !ticktext.length) {
	                    ticktext = tickvals.map(numberFormat(dimension.tickformat));
	                  } else if (ticktext.length > tickvals.length) {
	                    ticktext = ticktext.slice(0, tickvals.length);
	                  } else if (tickvals.length > ticktext.length) {
	                    tickvals = tickvals.slice(0, ticktext.length);
	                  }
	                  for (var j = 1; j < tickvals.length; j++) {
	                    if (tickvals[j] < tickvals[j - 1]) {
	                      var tickItems = tickvals.map(makeTickItem).sort(sortTickItem);
	                      for (var k = 0; k < tickvals.length; k++) {
	                        tickvals[k] = tickItems[k].val;
	                        ticktext[k] = tickItems[k].text;
	                      }
	                      break;
	                    }
	                  }
	                } else tickvals = undefined;
	                truncatedValues = helpers.convertTypedArray(truncatedValues);
	                return {
	                  key,
	                  label: dimension.label,
	                  tickFormat: dimension.tickformat,
	                  tickvals,
	                  ticktext,
	                  ordinal: helpers.isOrdinal(dimension),
	                  multiselect: dimension.multiselect,
	                  xIndex: i,
	                  crossfilterDimensionIndex: i,
	                  visibleIndex: dimension._index,
	                  height,
	                  values: truncatedValues,
	                  paddedUnitValues: truncatedValues.map(domainToPaddedUnit),
	                  unitTickvals: tickvals && tickvals.map(domainToPaddedUnit),
	                  xScale,
	                  x: xScale(i),
	                  canvasX: xScale(i) * canvasPixelRatio,
	                  unitToPaddedPx: _unitToPaddedPx,
	                  domainScale: domainScale(height, c.verticalPadding, dimension, tickvals, ticktext),
	                  ordinalScale: ordinalScale(dimension),
	                  parent: vm,
	                  model: model2,
	                  brush: brush.makeBrush(state, filterRangeSpecified, filterRange, function() {
	                    state.linePickActive(false);
	                  }, brushMove, function(f) {
	                    vm.focusLayer.render(vm.panels, true);
	                    vm.pickLayer && vm.pickLayer.render(vm.panels, true);
	                    state.linePickActive(true);
	                    if (callbacks && callbacks.filterChanged) {
	                      var invScale = domainToPaddedUnit.invert;
	                      var newRanges = f.map(function(r) {
	                        return r.map(invScale).sort(Lib.sorterAsc);
	                      }).sort(function(a, b) {
	                        return a[0] - b[0];
	                      });
	                      callbacks.filterChanged(vm.key, dimension._index, newRanges);
	                    }
	                  })
	                };
	              });
	              return vm;
	            }
	            function styleExtentTexts(selection) {
	              selection.classed(c.cn.axisExtentText, true).attr("text-anchor", "middle").style("cursor", "default");
	            }
	            function parcoordsInteractionState() {
	              var linePickActive = true;
	              var contextShown = false;
	              return {
	                linePickActive: function(val) {
	                  return arguments.length ? linePickActive = !!val : linePickActive;
	                },
	                contextShown: function(val) {
	                  return arguments.length ? contextShown = !!val : contextShown;
	                }
	              };
	            }
	            function calcTilt(angle, position) {
	              var dir = position === "top" ? 1 : -1;
	              var radians = angle * Math.PI / 180;
	              var dx = Math.sin(radians);
	              var dy = Math.cos(radians);
	              return {
	                dir,
	                dx,
	                dy,
	                degrees: angle
	              };
	            }
	            function updatePanelLayout(yAxis, vm, plotGlPixelRatio) {
	              var panels = vm.panels || (vm.panels = []);
	              var data = yAxis.data();
	              for (var i = 0; i < data.length - 1; i++) {
	                var p = panels[i] || (panels[i] = {});
	                var dim0 = data[i];
	                var dim1 = data[i + 1];
	                p.dim0 = dim0;
	                p.dim1 = dim1;
	                p.canvasX = dim0.canvasX;
	                p.panelSizeX = dim1.canvasX - dim0.canvasX;
	                p.panelSizeY = vm.model.canvasHeight;
	                p.y = 0;
	                p.canvasY = 0;
	                p.plotGlPixelRatio = plotGlPixelRatio;
	              }
	            }
	            function calcAllTicks(cd) {
	              for (var i = 0; i < cd.length; i++) {
	                for (var j = 0; j < cd[i].length; j++) {
	                  var trace = cd[i][j].trace;
	                  var dimensions = trace.dimensions;
	                  for (var k = 0; k < dimensions.length; k++) {
	                    var values = dimensions[k].values;
	                    var dim = dimensions[k]._ax;
	                    if (dim) {
	                      if (!dim.range) {
	                        dim.range = findExtremes(values, trace._length);
	                      } else {
	                        dim.range = fixExtremes(dim.range[0], dim.range[1]);
	                      }
	                      if (!dim.dtick) {
	                        dim.dtick = 0.01 * (Math.abs(dim.range[1] - dim.range[0]) || 1);
	                      }
	                      dim.tickformat = dimensions[k].tickformat;
	                      Axes.calcTicks(dim);
	                      dim.cleanRange();
	                    }
	                  }
	                }
	              }
	            }
	            function linearFormat(dim, v) {
	              return Axes.tickText(dim._ax, v, false).text;
	            }
	            function extremeText(d, isTop) {
	              if (d.ordinal) return "";
	              var domain = d.domainScale.domain();
	              var v = domain[isTop ? domain.length - 1 : 0];
	              return linearFormat(d.model.dimensions[d.visibleIndex], v);
	            }
	            module2.exports = function parcoords(gd, cdModule, layout, callbacks) {
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var svg = fullLayout._toppaper;
	              var glContainer = fullLayout._glcontainer;
	              var plotGlPixelRatio = gd._context.plotGlPixelRatio;
	              var paperColor = gd._fullLayout.paper_bgcolor;
	              calcAllTicks(cdModule);
	              var state = parcoordsInteractionState();
	              var vm = cdModule.filter(function(d) {
	                return unwrap(d).trace.visible;
	              }).map(model.bind(0, layout)).map(viewModel.bind(0, state, callbacks));
	              glContainer.each(function(d, i) {
	                return Lib.extendFlat(d, vm[i]);
	              });
	              var glLayers = glContainer.selectAll(".gl-canvas").each(function(d) {
	                d.viewModel = vm[0];
	                d.viewModel.plotGlPixelRatio = plotGlPixelRatio;
	                d.viewModel.paperColor = paperColor;
	                d.model = d.viewModel ? d.viewModel.model : null;
	              });
	              var lastHovered = null;
	              var pickLayer = glLayers.filter(function(d) {
	                return d.pick;
	              });
	              pickLayer.style("pointer-events", isStatic ? "none" : "auto").on("mousemove", function(d) {
	                if (state.linePickActive() && d.lineLayer && callbacks && callbacks.hover) {
	                  var event = d3.event;
	                  var cw = this.width;
	                  var ch = this.height;
	                  var pointer = d3.mouse(this);
	                  var x = pointer[0];
	                  var y = pointer[1];
	                  if (x < 0 || y < 0 || x >= cw || y >= ch) {
	                    return;
	                  }
	                  var pixel = d.lineLayer.readPixel(x, ch - 1 - y);
	                  var found = pixel[3] !== 0;
	                  var curveNumber = found ? pixel[2] + 256 * (pixel[1] + 256 * pixel[0]) : null;
	                  var eventData = {
	                    x,
	                    y,
	                    clientX: event.clientX,
	                    clientY: event.clientY,
	                    dataIndex: d.model.key,
	                    curveNumber
	                  };
	                  if (curveNumber !== lastHovered) {
	                    if (found) {
	                      callbacks.hover(eventData);
	                    } else if (callbacks.unhover) {
	                      callbacks.unhover(eventData);
	                    }
	                    lastHovered = curveNumber;
	                  }
	                }
	              });
	              glLayers.style("opacity", function(d) {
	                return d.pick ? 0 : 1;
	              });
	              svg.style("background", "rgba(255, 255, 255, 0)");
	              var controlOverlay = svg.selectAll("." + c.cn.parcoords).data(vm, keyFun);
	              controlOverlay.exit().remove();
	              controlOverlay.enter().append("g").classed(c.cn.parcoords, true).style("shape-rendering", "crispEdges").style("pointer-events", "none");
	              controlOverlay.attr("transform", function(d) {
	                return strTranslate(d.model.translateX, d.model.translateY);
	              });
	              var parcoordsControlView = controlOverlay.selectAll("." + c.cn.parcoordsControlView).data(repeat, keyFun);
	              parcoordsControlView.enter().append("g").classed(c.cn.parcoordsControlView, true);
	              parcoordsControlView.attr("transform", function(d) {
	                return strTranslate(d.model.pad.l, d.model.pad.t);
	              });
	              var yAxis = parcoordsControlView.selectAll("." + c.cn.yAxis).data(function(p) {
	                return p.dimensions;
	              }, keyFun);
	              yAxis.enter().append("g").classed(c.cn.yAxis, true);
	              parcoordsControlView.each(function(p) {
	                updatePanelLayout(yAxis, p, plotGlPixelRatio);
	              });
	              glLayers.each(function(d) {
	                if (d.viewModel) {
	                  if (!d.lineLayer || callbacks) {
	                    d.lineLayer = lineLayerMaker(this, d);
	                  } else d.lineLayer.update(d);
	                  if (d.key || d.key === 0) d.viewModel[d.key] = d.lineLayer;
	                  var setChanged = !d.context || // don't update background
	                  callbacks;
	                  d.lineLayer.render(d.viewModel.panels, setChanged);
	                }
	              });
	              yAxis.attr("transform", function(d) {
	                return strTranslate(d.xScale(d.xIndex), 0);
	              });
	              yAxis.call(d3.behavior.drag().origin(function(d) {
	                return d;
	              }).on("drag", function(d) {
	                var p = d.parent;
	                state.linePickActive(false);
	                d.x = Math.max(-c.overdrag, Math.min(d.model.width + c.overdrag, d3.event.x));
	                d.canvasX = d.x * d.model.canvasPixelRatio;
	                yAxis.sort(function(a, b) {
	                  return a.x - b.x;
	                }).each(function(e, i) {
	                  e.xIndex = i;
	                  e.x = d === e ? e.x : e.xScale(e.xIndex);
	                  e.canvasX = e.x * e.model.canvasPixelRatio;
	                });
	                updatePanelLayout(yAxis, p, plotGlPixelRatio);
	                yAxis.filter(function(e) {
	                  return Math.abs(d.xIndex - e.xIndex) !== 0;
	                }).attr("transform", function(d2) {
	                  return strTranslate(d2.xScale(d2.xIndex), 0);
	                });
	                d3.select(this).attr("transform", strTranslate(d.x, 0));
	                yAxis.each(function(e, i0, i1) {
	                  if (i1 === d.parent.key) p.dimensions[i0] = e;
	                });
	                p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
	                p.focusLayer.render && p.focusLayer.render(p.panels);
	              }).on("dragend", function(d) {
	                var p = d.parent;
	                d.x = d.xScale(d.xIndex);
	                d.canvasX = d.x * d.model.canvasPixelRatio;
	                updatePanelLayout(yAxis, p, plotGlPixelRatio);
	                d3.select(this).attr("transform", function(d2) {
	                  return strTranslate(d2.x, 0);
	                });
	                p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
	                p.focusLayer && p.focusLayer.render(p.panels);
	                p.pickLayer && p.pickLayer.render(p.panels, true);
	                state.linePickActive(true);
	                if (callbacks && callbacks.axesMoved) {
	                  callbacks.axesMoved(p.key, p.dimensions.map(function(e) {
	                    return e.crossfilterDimensionIndex;
	                  }));
	                }
	              }));
	              yAxis.exit().remove();
	              var axisOverlays = yAxis.selectAll("." + c.cn.axisOverlays).data(repeat, keyFun);
	              axisOverlays.enter().append("g").classed(c.cn.axisOverlays, true);
	              axisOverlays.selectAll("." + c.cn.axis).remove();
	              var axis = axisOverlays.selectAll("." + c.cn.axis).data(repeat, keyFun);
	              axis.enter().append("g").classed(c.cn.axis, true);
	              axis.each(function(d) {
	                var wantedTickCount = d.model.height / d.model.tickDistance;
	                var scale = d.domainScale;
	                var sdom = scale.domain();
	                d3.select(this).call(d3.svg.axis().orient("left").tickSize(4).outerTickSize(2).ticks(wantedTickCount, d.tickFormat).tickValues(d.ordinal ? (
	                  // and this works for ordinal scales
	                  sdom
	                ) : null).tickFormat(function(v) {
	                  return helpers.isOrdinal(d) ? v : linearFormat(d.model.dimensions[d.visibleIndex], v);
	                }).scale(scale));
	                Drawing.font(axis.selectAll("text"), d.model.tickFont);
	              });
	              axis.selectAll(".domain, .tick>line").attr("fill", "none").attr("stroke", "black").attr("stroke-opacity", 0.25).attr("stroke-width", "1px");
	              axis.selectAll("text").style("text-shadow", svgTextUtils.makeTextShadow(paperColor)).style("cursor", "default");
	              var axisHeading = axisOverlays.selectAll("." + c.cn.axisHeading).data(repeat, keyFun);
	              axisHeading.enter().append("g").classed(c.cn.axisHeading, true);
	              var axisTitle = axisHeading.selectAll("." + c.cn.axisTitle).data(repeat, keyFun);
	              axisTitle.enter().append("text").classed(c.cn.axisTitle, true).attr("text-anchor", "middle").style("cursor", "ew-resize").style("pointer-events", isStatic ? "none" : "auto");
	              axisTitle.text(function(d) {
	                return d.label;
	              }).each(function(d) {
	                var e = d3.select(this);
	                Drawing.font(e, d.model.labelFont);
	                svgTextUtils.convertToTspans(e, gd);
	              }).attr("transform", function(d) {
	                var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
	                var r = c.axisTitleOffset;
	                return (tilt.dir > 0 ? "" : strTranslate(0, 2 * r + d.model.height)) + strRotate(tilt.degrees) + strTranslate(-r * tilt.dx, -r * tilt.dy);
	              }).attr("text-anchor", function(d) {
	                var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
	                var adx = Math.abs(tilt.dx);
	                var ady = Math.abs(tilt.dy);
	                if (2 * adx > ady) {
	                  return tilt.dir * tilt.dx < 0 ? "start" : "end";
	                } else {
	                  return "middle";
	                }
	              });
	              var axisExtent = axisOverlays.selectAll("." + c.cn.axisExtent).data(repeat, keyFun);
	              axisExtent.enter().append("g").classed(c.cn.axisExtent, true);
	              var axisExtentTop = axisExtent.selectAll("." + c.cn.axisExtentTop).data(repeat, keyFun);
	              axisExtentTop.enter().append("g").classed(c.cn.axisExtentTop, true);
	              axisExtentTop.attr("transform", strTranslate(0, -c.axisExtentOffset));
	              var axisExtentTopText = axisExtentTop.selectAll("." + c.cn.axisExtentTopText).data(repeat, keyFun);
	              axisExtentTopText.enter().append("text").classed(c.cn.axisExtentTopText, true).call(styleExtentTexts);
	              axisExtentTopText.text(function(d) {
	                return extremeText(d, true);
	              }).each(function(d) {
	                Drawing.font(d3.select(this), d.model.rangeFont);
	              });
	              var axisExtentBottom = axisExtent.selectAll("." + c.cn.axisExtentBottom).data(repeat, keyFun);
	              axisExtentBottom.enter().append("g").classed(c.cn.axisExtentBottom, true);
	              axisExtentBottom.attr("transform", function(d) {
	                return strTranslate(0, d.model.height + c.axisExtentOffset);
	              });
	              var axisExtentBottomText = axisExtentBottom.selectAll("." + c.cn.axisExtentBottomText).data(repeat, keyFun);
	              axisExtentBottomText.enter().append("text").classed(c.cn.axisExtentBottomText, true).attr("dy", "0.75em").call(styleExtentTexts);
	              axisExtentBottomText.text(function(d) {
	                return extremeText(d, false);
	              }).each(function(d) {
	                Drawing.font(d3.select(this), d.model.rangeFont);
	              });
	              brush.ensureAxisBrush(axisOverlays, paperColor, gd);
	            };
	          }
	        ),
	        /***/
	        21341: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parcoords = __webpack_require__2(17171);
	            var prepareRegl = __webpack_require__2(79749);
	            var isVisible = __webpack_require__2(1602).isVisible;
	            var reglPrecompiled = {};
	            function newIndex(visibleIndices, orig, dim) {
	              var origIndex = orig.indexOf(dim);
	              var currentIndex = visibleIndices.indexOf(origIndex);
	              if (currentIndex === -1) {
	                currentIndex += orig.length;
	              }
	              return currentIndex;
	            }
	            function sorter(visibleIndices, orig) {
	              return function sorter2(d1, d2) {
	                return newIndex(visibleIndices, orig, d1) - newIndex(visibleIndices, orig, d2);
	              };
	            }
	            var exports2 = module2.exports = function plot(gd, cdModule) {
	              var fullLayout = gd._fullLayout;
	              var success = prepareRegl(gd, [], reglPrecompiled);
	              if (!success) return;
	              var currentDims = {};
	              var initialDims = {};
	              var fullIndices = {};
	              var inputIndices = {};
	              var size = fullLayout._size;
	              cdModule.forEach(function(d, i) {
	                var trace = d[0].trace;
	                fullIndices[i] = trace.index;
	                var iIn = inputIndices[i] = trace._fullInput.index;
	                currentDims[i] = gd.data[iIn].dimensions;
	                initialDims[i] = gd.data[iIn].dimensions.slice();
	              });
	              var filterChanged = function(i, initialDimIndex, newRanges) {
	                var dim = initialDims[i][initialDimIndex];
	                var newConstraints = newRanges.map(function(r) {
	                  return r.slice();
	                });
	                var aStr = "dimensions[" + initialDimIndex + "].constraintrange";
	                var preGUI = fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid];
	                if (preGUI[aStr] === undefined) {
	                  var initialVal = dim.constraintrange;
	                  preGUI[aStr] = initialVal || null;
	                }
	                var fullDimension = gd._fullData[fullIndices[i]].dimensions[initialDimIndex];
	                if (!newConstraints.length) {
	                  delete dim.constraintrange;
	                  delete fullDimension.constraintrange;
	                  newConstraints = null;
	                } else {
	                  if (newConstraints.length === 1) newConstraints = newConstraints[0];
	                  dim.constraintrange = newConstraints;
	                  fullDimension.constraintrange = newConstraints.slice();
	                  newConstraints = [newConstraints];
	                }
	                var restyleData = {};
	                restyleData[aStr] = newConstraints;
	                gd.emit("plotly_restyle", [restyleData, [inputIndices[i]]]);
	              };
	              var hover = function(eventData) {
	                gd.emit("plotly_hover", eventData);
	              };
	              var unhover = function(eventData) {
	                gd.emit("plotly_unhover", eventData);
	              };
	              var axesMoved = function(i, visibleIndices) {
	                var orig = sorter(visibleIndices, initialDims[i].filter(isVisible));
	                currentDims[i].sort(orig);
	                initialDims[i].filter(function(d) {
	                  return !isVisible(d);
	                }).sort(function(d) {
	                  return initialDims[i].indexOf(d);
	                }).forEach(function(d) {
	                  currentDims[i].splice(currentDims[i].indexOf(d), 1);
	                  currentDims[i].splice(initialDims[i].indexOf(d), 0, d);
	                });
	                gd.emit("plotly_restyle", [{
	                  dimensions: [currentDims[i]]
	                }, [inputIndices[i]]]);
	              };
	              parcoords(gd, cdModule, {
	                // layout
	                width: size.w,
	                height: size.h,
	                margin: {
	                  t: size.t,
	                  r: size.r,
	                  b: size.b,
	                  l: size.l
	                }
	              }, {
	                // callbacks
	                filterChanged,
	                hover,
	                unhover,
	                axesMoved
	              });
	            };
	            exports2.reglPrecompiled = reglPrecompiled;
	          }
	        ),
	        /***/
	        34e3: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var baseAttrs = __webpack_require__2(9012);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var fontAttrs = __webpack_require__2(41940);
	            var colorAttrs = __webpack_require__2(22399);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var pattern = __webpack_require__2(79952).u;
	            var textFontAttrs = fontAttrs({
	              editType: "plot",
	              arrayOk: true,
	              colorEditType: "plot"
	            });
	            module2.exports = {
	              labels: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              // equivalent of x0 and dx, if label is missing
	              label0: {
	                valType: "number",
	                dflt: 0,
	                editType: "calc"
	              },
	              dlabel: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              values: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              marker: {
	                colors: {
	                  valType: "data_array",
	                  // TODO 'color_array' ?
	                  editType: "calc"
	                },
	                line: {
	                  color: {
	                    valType: "color",
	                    dflt: colorAttrs.defaultLine,
	                    arrayOk: true,
	                    editType: "style"
	                  },
	                  width: {
	                    valType: "number",
	                    min: 0,
	                    dflt: 0,
	                    arrayOk: true,
	                    editType: "style"
	                  },
	                  editType: "calc"
	                },
	                pattern,
	                editType: "calc"
	              },
	              text: {
	                valType: "data_array",
	                editType: "plot"
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "style"
	              },
	              // 'see eg:'
	              // 'https://www.e-education.psu.edu/natureofgeoinfo/sites/www.e-education.psu.edu.natureofgeoinfo/files/image/hisp_pies.gif',
	              // '(this example involves a map too - may someday be a whole trace type',
	              // 'of its own. but the point is the size of the whole pie is important.)'
	              scalegroup: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              // labels (legend is handled by plots.attributes.showlegend and layout.hiddenlabels)
	              textinfo: {
	                valType: "flaglist",
	                flags: ["label", "text", "value", "percent"],
	                extras: ["none"],
	                editType: "calc"
	              },
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["label", "text", "value", "percent", "name"]
	              }),
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: ["label", "color", "value", "percent", "text"]
	              }),
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["label", "color", "value", "percent", "text"]
	              }),
	              textposition: {
	                valType: "enumerated",
	                values: ["inside", "outside", "auto", "none"],
	                dflt: "auto",
	                arrayOk: true,
	                editType: "plot"
	              },
	              textfont: extendFlat({}, textFontAttrs, {}),
	              insidetextorientation: {
	                valType: "enumerated",
	                values: ["horizontal", "radial", "tangential", "auto"],
	                dflt: "auto",
	                editType: "plot"
	              },
	              insidetextfont: extendFlat({}, textFontAttrs, {}),
	              outsidetextfont: extendFlat({}, textFontAttrs, {}),
	              automargin: {
	                valType: "boolean",
	                dflt: false,
	                editType: "plot"
	              },
	              title: {
	                text: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "plot"
	                },
	                font: extendFlat({}, textFontAttrs, {}),
	                position: {
	                  valType: "enumerated",
	                  values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              // position and shape
	              domain: domainAttrs({
	                name: "pie",
	                trace: true,
	                editType: "calc"
	              }),
	              hole: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                editType: "calc"
	              },
	              // ordering and direction
	              sort: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              direction: {
	                /**
	                 * there are two common conventions, both of which place the first
	                 * (largest, if sorted) slice with its left edge at 12 o'clock but
	                 * succeeding slices follow either cw or ccw from there.
	                 *
	                 * see http://visage.co/data-visualization-101-pie-charts/
	                 */
	                valType: "enumerated",
	                values: ["clockwise", "counterclockwise"],
	                dflt: "counterclockwise",
	                editType: "calc"
	              },
	              rotation: {
	                valType: "angle",
	                dflt: 0,
	                editType: "calc"
	              },
	              pull: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                arrayOk: true,
	                editType: "calc"
	              },
	              _deprecated: {
	                title: {
	                  valType: "string",
	                  dflt: "",
	                  editType: "calc"
	                },
	                titlefont: extendFlat({}, textFontAttrs, {}),
	                titleposition: {
	                  valType: "enumerated",
	                  values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"],
	                  editType: "calc"
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        13584: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var plots = __webpack_require__2(74875);
	            exports2.name = "pie";
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              plots.plotBasePlot(exports2.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              plots.cleanBasePlot(exports2.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	            };
	          }
	        ),
	        /***/
	        32354: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var tinycolor = __webpack_require__2(84267);
	            var Color = __webpack_require__2(7901);
	            var extendedColorWayList = {};
	            function calc(gd, trace) {
	              var cd = [];
	              var fullLayout = gd._fullLayout;
	              var hiddenLabels = fullLayout.hiddenlabels || [];
	              var labels = trace.labels;
	              var colors = trace.marker.colors || [];
	              var vals = trace.values;
	              var len = trace._length;
	              var hasValues = trace._hasValues && len;
	              var i, pt;
	              if (trace.dlabel) {
	                labels = new Array(len);
	                for (i = 0; i < len; i++) {
	                  labels[i] = String(trace.label0 + i * trace.dlabel);
	                }
	              }
	              var allThisTraceLabels = {};
	              var pullColor = makePullColorFn(fullLayout["_" + trace.type + "colormap"]);
	              var vTotal = 0;
	              var isAggregated = false;
	              for (i = 0; i < len; i++) {
	                var v, label, hidden;
	                if (hasValues) {
	                  v = vals[i];
	                  if (!isNumeric(v)) continue;
	                  v = +v;
	                } else v = 1;
	                label = labels[i];
	                if (label === undefined || label === "") label = i;
	                label = String(label);
	                var thisLabelIndex = allThisTraceLabels[label];
	                if (thisLabelIndex === undefined) {
	                  allThisTraceLabels[label] = cd.length;
	                  hidden = hiddenLabels.indexOf(label) !== -1;
	                  if (!hidden) vTotal += v;
	                  cd.push({
	                    v,
	                    label,
	                    color: pullColor(colors[i], label),
	                    i,
	                    pts: [i],
	                    hidden
	                  });
	                } else {
	                  isAggregated = true;
	                  pt = cd[thisLabelIndex];
	                  pt.v += v;
	                  pt.pts.push(i);
	                  if (!pt.hidden) vTotal += v;
	                  if (pt.color === false && colors[i]) {
	                    pt.color = pullColor(colors[i], label);
	                  }
	                }
	              }
	              cd = cd.filter(function(elem) {
	                return elem.v >= 0;
	              });
	              var shouldSort = trace.type === "funnelarea" ? isAggregated : trace.sort;
	              if (shouldSort) cd.sort(function(a, b) {
	                return b.v - a.v;
	              });
	              if (cd[0]) cd[0].vTotal = vTotal;
	              return cd;
	            }
	            function makePullColorFn(colorMap) {
	              return function pullColor(color, id) {
	                if (!color) return false;
	                color = tinycolor(color);
	                if (!color.isValid()) return false;
	                color = Color.addOpacity(color, color.getAlpha());
	                if (!colorMap[id]) colorMap[id] = color;
	                return color;
	              };
	            }
	            function crossTraceCalc(gd, plotinfo) {
	              var desiredType = (plotinfo || {}).type;
	              if (!desiredType) desiredType = "pie";
	              var fullLayout = gd._fullLayout;
	              var calcdata = gd.calcdata;
	              var colorWay = fullLayout[desiredType + "colorway"];
	              var colorMap = fullLayout["_" + desiredType + "colormap"];
	              if (fullLayout["extend" + desiredType + "colors"]) {
	                colorWay = generateExtendedColors(colorWay, extendedColorWayList);
	              }
	              var dfltColorCount = 0;
	              for (var i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                var traceType = cd[0].trace.type;
	                if (traceType !== desiredType) continue;
	                for (var j = 0; j < cd.length; j++) {
	                  var pt = cd[j];
	                  if (pt.color === false) {
	                    if (colorMap[pt.label]) {
	                      pt.color = colorMap[pt.label];
	                    } else {
	                      colorMap[pt.label] = pt.color = colorWay[dfltColorCount % colorWay.length];
	                      dfltColorCount++;
	                    }
	                  }
	                }
	              }
	            }
	            function generateExtendedColors(colorList, extendedColorWays) {
	              var i;
	              var colorString = JSON.stringify(colorList);
	              var colors = extendedColorWays[colorString];
	              if (!colors) {
	                colors = colorList.slice();
	                for (i = 0; i < colorList.length; i++) {
	                  colors.push(tinycolor(colorList[i]).lighten(20).toHexString());
	                }
	                for (i = 0; i < colorList.length; i++) {
	                  colors.push(tinycolor(colorList[i]).darken(20).toHexString());
	                }
	                extendedColorWays[colorString] = colors;
	              }
	              return colors;
	            }
	            module2.exports = {
	              calc,
	              crossTraceCalc,
	              makePullColorFn,
	              generateExtendedColors
	            };
	          }
	        ),
	        /***/
	        37434: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(34e3);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleText = __webpack_require__2(90769).handleText;
	            var coercePattern = __webpack_require__2(71828).coercePattern;
	            function handleLabelsAndValues(labels, values) {
	              var hasLabels = Array.isArray(labels);
	              var hasValues = Lib.isArrayOrTypedArray(values);
	              var len = Math.min(hasLabels ? labels.length : Infinity, hasValues ? values.length : Infinity);
	              if (!isFinite(len)) len = 0;
	              if (len && hasValues) {
	                var hasPositive;
	                for (var i = 0; i < len; i++) {
	                  var v = values[i];
	                  if (isNumeric(v) && v > 0) {
	                    hasPositive = true;
	                    break;
	                  }
	                }
	                if (!hasPositive) len = 0;
	              }
	              return {
	                hasLabels,
	                hasValues,
	                len
	              };
	            }
	            function handleMarkerDefaults(traceIn, traceOut, layout, coerce, isPie) {
	              var lineWidth = coerce("marker.line.width");
	              if (lineWidth) {
	                coerce(
	                  "marker.line.color",
	                  isPie ? undefined : layout.paper_bgcolor
	                  // case of funnelarea, sunburst, icicle, treemap
	                );
	              }
	              var markerColors = coerce("marker.colors");
	              coercePattern(coerce, "marker.pattern", markerColors);
	              if (traceIn.marker && !traceOut.marker.pattern.fgcolor) traceOut.marker.pattern.fgcolor = traceIn.marker.colors;
	              if (!traceOut.marker.pattern.bgcolor) traceOut.marker.pattern.bgcolor = layout.paper_bgcolor;
	            }
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var labels = coerce("labels");
	              var values = coerce("values");
	              var res = handleLabelsAndValues(labels, values);
	              var len = res.len;
	              traceOut._hasLabels = res.hasLabels;
	              traceOut._hasValues = res.hasValues;
	              if (!traceOut._hasLabels && traceOut._hasValues) {
	                coerce("label0");
	                coerce("dlabel");
	              }
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              handleMarkerDefaults(traceIn, traceOut, layout, coerce, true);
	              coerce("scalegroup");
	              var textData = coerce("text");
	              var textTemplate = coerce("texttemplate");
	              var textInfo;
	              if (!textTemplate) textInfo = coerce("textinfo", Array.isArray(textData) ? "text+percent" : "percent");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              if (textTemplate || textInfo && textInfo !== "none") {
	                var textposition = coerce("textposition");
	                handleText(traceIn, traceOut, layout, coerce, textposition, {
	                  moduleHasSelected: false,
	                  moduleHasUnselected: false,
	                  moduleHasConstrain: false,
	                  moduleHasCliponaxis: false,
	                  moduleHasTextangle: false,
	                  moduleHasInsideanchor: false
	                });
	                var hasBoth = Array.isArray(textposition) || textposition === "auto";
	                var hasOutside = hasBoth || textposition === "outside";
	                if (hasOutside) {
	                  coerce("automargin");
	                }
	                if (textposition === "inside" || textposition === "auto" || Array.isArray(textposition)) {
	                  coerce("insidetextorientation");
	                }
	              }
	              handleDomainDefaults(traceOut, layout, coerce);
	              var hole = coerce("hole");
	              var title = coerce("title.text");
	              if (title) {
	                var titlePosition = coerce("title.position", hole ? "middle center" : "top center");
	                if (!hole && titlePosition === "middle center") traceOut.title.position = "top center";
	                Lib.coerceFont(coerce, "title.font", layout.font);
	              }
	              coerce("sort");
	              coerce("direction");
	              coerce("rotation");
	              coerce("pull");
	            }
	            module2.exports = {
	              handleLabelsAndValues,
	              handleMarkerDefaults,
	              supplyDefaults
	            };
	          }
	        ),
	        /***/
	        20007: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var appendArrayMultiPointValues = __webpack_require__2(23469).appendArrayMultiPointValues;
	            module2.exports = function eventData(pt, trace) {
	              var out = {
	                curveNumber: trace.index,
	                pointNumbers: pt.pts,
	                data: trace._input,
	                fullData: trace,
	                label: pt.label,
	                color: pt.color,
	                value: pt.v,
	                percent: pt.percent,
	                text: pt.text,
	                bbox: pt.bbox,
	                // pt.v (and pt.i below) for backward compatibility
	                v: pt.v
	              };
	              if (pt.pts.length === 1) out.pointNumber = out.i = pt.pts[0];
	              appendArrayMultiPointValues(out, trace, pt.pts);
	              if (trace.type === "funnelarea") {
	                delete out.v;
	                delete out.i;
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        22209: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            module2.exports = function fillOne(s, pt, trace, gd) {
	              var pattern = trace.marker.pattern;
	              if (pattern && pattern.shape) {
	                Drawing.pointStyle(s, trace, gd, pt);
	              } else {
	                Color.fill(s, pt.color);
	              }
	            };
	          }
	        ),
	        /***/
	        53581: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            function format(vRounded) {
	              return vRounded.indexOf("e") !== -1 ? vRounded.replace(/[.]?0+e/, "e") : vRounded.indexOf(".") !== -1 ? vRounded.replace(/[.]?0+$/, "") : vRounded;
	            }
	            exports2.formatPiePercent = function formatPiePercent(v, separators) {
	              var vRounded = format((v * 100).toPrecision(3));
	              return Lib.numSeparate(vRounded, separators) + "%";
	            };
	            exports2.formatPieValue = function formatPieValue(v, separators) {
	              var vRounded = format(v.toPrecision(10));
	              return Lib.numSeparate(vRounded, separators);
	            };
	            exports2.getFirstFilled = function getFirstFilled(array, indices) {
	              if (!Array.isArray(array)) return;
	              for (var i = 0; i < indices.length; i++) {
	                var v = array[indices[i]];
	                if (v || v === 0 || v === "") return v;
	              }
	            };
	            exports2.castOption = function castOption(item, indices) {
	              if (Array.isArray(item)) return exports2.getFirstFilled(item, indices);
	              else if (item) return item;
	            };
	            exports2.getRotationAngle = function(rotation) {
	              return (rotation === "auto" ? 0 : rotation) * Math.PI / 180;
	            };
	          }
	        ),
	        /***/
	        58810: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(34e3),
	              supplyDefaults: __webpack_require__2(37434).supplyDefaults,
	              supplyLayoutDefaults: __webpack_require__2(92097),
	              layoutAttributes: __webpack_require__2(92774),
	              calc: __webpack_require__2(32354).calc,
	              crossTraceCalc: __webpack_require__2(32354).crossTraceCalc,
	              plot: __webpack_require__2(14575).plot,
	              style: __webpack_require__2(68357),
	              styleOne: __webpack_require__2(63463),
	              moduleType: "trace",
	              name: "pie",
	              basePlotModule: __webpack_require__2(13584),
	              categories: ["pie-like", "pie", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        92774: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              hiddenlabels: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              piecolorway: {
	                valType: "colorlist",
	                editType: "calc"
	              },
	              extendpiecolors: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        92097: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(92774);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              coerce("hiddenlabels");
	              coerce("piecolorway", layoutOut.colorway);
	              coerce("extendpiecolors");
	            };
	          }
	        ),
	        /***/
	        14575: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Plots = __webpack_require__2(74875);
	            var Fx = __webpack_require__2(30211);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var strScale = Lib.strScale;
	            var strTranslate = Lib.strTranslate;
	            var svgTextUtils = __webpack_require__2(63893);
	            var uniformText = __webpack_require__2(72597);
	            var recordMinTextSize = uniformText.recordMinTextSize;
	            var clearMinTextSize = uniformText.clearMinTextSize;
	            var TEXTPAD = __webpack_require__2(97313).TEXTPAD;
	            var helpers = __webpack_require__2(53581);
	            var eventData = __webpack_require__2(20007);
	            var isValidTextValue = __webpack_require__2(71828).isValidTextValue;
	            function plot(gd, cdModule) {
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var gs = fullLayout._size;
	              clearMinTextSize("pie", fullLayout);
	              prerenderTitles(cdModule, gd);
	              layoutAreas(cdModule, gs);
	              var plotGroups = Lib.makeTraceGroups(fullLayout._pielayer, cdModule, "trace").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                setCoords(cd);
	                plotGroup.attr("stroke-linejoin", "round");
	                plotGroup.each(function() {
	                  var slices = d3.select(this).selectAll("g.slice").data(cd);
	                  slices.enter().append("g").classed("slice", true);
	                  slices.exit().remove();
	                  var quadrants = [
	                    [[], []],
	                    // y<0: x<0, x>=0
	                    [[], []]
	                    // y>=0: x<0, x>=0
	                  ];
	                  var hasOutsideText = false;
	                  slices.each(function(pt, i) {
	                    if (pt.hidden) {
	                      d3.select(this).selectAll("path,g").remove();
	                      return;
	                    }
	                    pt.pointNumber = pt.i;
	                    pt.curveNumber = trace.index;
	                    quadrants[pt.pxmid[1] < 0 ? 0 : 1][pt.pxmid[0] < 0 ? 0 : 1].push(pt);
	                    var cx = cd0.cx;
	                    var cy = cd0.cy;
	                    var sliceTop = d3.select(this);
	                    var slicePath = sliceTop.selectAll("path.surface").data([pt]);
	                    slicePath.enter().append("path").classed("surface", true).style({
	                      "pointer-events": isStatic ? "none" : "all"
	                    });
	                    sliceTop.call(attachFxHandlers, gd, cd);
	                    if (trace.pull) {
	                      var pull = +helpers.castOption(trace.pull, pt.pts) || 0;
	                      if (pull > 0) {
	                        cx += pull * pt.pxmid[0];
	                        cy += pull * pt.pxmid[1];
	                      }
	                    }
	                    pt.cxFinal = cx;
	                    pt.cyFinal = cy;
	                    function arc(start, finish, cw, scale) {
	                      var dx = scale * (finish[0] - start[0]);
	                      var dy = scale * (finish[1] - start[1]);
	                      return "a" + scale * cd0.r + "," + scale * cd0.r + " 0 " + pt.largeArc + (cw ? " 1 " : " 0 ") + dx + "," + dy;
	                    }
	                    var hole = trace.hole;
	                    if (pt.v === cd0.vTotal) {
	                      var outerCircle = "M" + (cx + pt.px0[0]) + "," + (cy + pt.px0[1]) + arc(pt.px0, pt.pxmid, true, 1) + arc(pt.pxmid, pt.px0, true, 1) + "Z";
	                      if (hole) {
	                        slicePath.attr("d", "M" + (cx + hole * pt.px0[0]) + "," + (cy + hole * pt.px0[1]) + arc(pt.px0, pt.pxmid, false, hole) + arc(pt.pxmid, pt.px0, false, hole) + "Z" + outerCircle);
	                      } else slicePath.attr("d", outerCircle);
	                    } else {
	                      var outerArc = arc(pt.px0, pt.px1, true, 1);
	                      if (hole) {
	                        var rim = 1 - hole;
	                        slicePath.attr("d", "M" + (cx + hole * pt.px1[0]) + "," + (cy + hole * pt.px1[1]) + arc(pt.px1, pt.px0, false, hole) + "l" + rim * pt.px0[0] + "," + rim * pt.px0[1] + outerArc + "Z");
	                      } else {
	                        slicePath.attr("d", "M" + cx + "," + cy + "l" + pt.px0[0] + "," + pt.px0[1] + outerArc + "Z");
	                      }
	                    }
	                    formatSliceLabel(gd, pt, cd0);
	                    var textPosition = helpers.castOption(trace.textposition, pt.pts);
	                    var sliceTextGroup = sliceTop.selectAll("g.slicetext").data(pt.text && textPosition !== "none" ? [0] : []);
	                    sliceTextGroup.enter().append("g").classed("slicetext", true);
	                    sliceTextGroup.exit().remove();
	                    sliceTextGroup.each(function() {
	                      var sliceText = Lib.ensureSingle(d3.select(this), "text", "", function(s) {
	                        s.attr("data-notex", 1);
	                      });
	                      var font = Lib.ensureUniformFontSize(gd, textPosition === "outside" ? determineOutsideTextFont(trace, pt, fullLayout.font) : determineInsideTextFont(trace, pt, fullLayout.font));
	                      sliceText.text(pt.text).attr({
	                        class: "slicetext",
	                        transform: "",
	                        "text-anchor": "middle"
	                      }).call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
	                      var textBB = Drawing.bBox(sliceText.node());
	                      var transform;
	                      if (textPosition === "outside") {
	                        transform = transformOutsideText(textBB, pt);
	                      } else {
	                        transform = transformInsideText(textBB, pt, cd0);
	                        if (textPosition === "auto" && transform.scale < 1) {
	                          var newFont = Lib.ensureUniformFontSize(gd, trace.outsidetextfont);
	                          sliceText.call(Drawing.font, newFont);
	                          textBB = Drawing.bBox(sliceText.node());
	                          transform = transformOutsideText(textBB, pt);
	                        }
	                      }
	                      var textPosAngle = transform.textPosAngle;
	                      var textXY = textPosAngle === undefined ? pt.pxmid : getCoords(cd0.r, textPosAngle);
	                      transform.targetX = cx + textXY[0] * transform.rCenter + (transform.x || 0);
	                      transform.targetY = cy + textXY[1] * transform.rCenter + (transform.y || 0);
	                      computeTransform(transform, textBB);
	                      if (transform.outside) {
	                        var targetY = transform.targetY;
	                        pt.yLabelMin = targetY - textBB.height / 2;
	                        pt.yLabelMid = targetY;
	                        pt.yLabelMax = targetY + textBB.height / 2;
	                        pt.labelExtraX = 0;
	                        pt.labelExtraY = 0;
	                        hasOutsideText = true;
	                      }
	                      transform.fontSize = font.size;
	                      recordMinTextSize(trace.type, transform, fullLayout);
	                      cd[i].transform = transform;
	                      Lib.setTransormAndDisplay(sliceText, transform);
	                    });
	                  });
	                  var titleTextGroup = d3.select(this).selectAll("g.titletext").data(trace.title.text ? [0] : []);
	                  titleTextGroup.enter().append("g").classed("titletext", true);
	                  titleTextGroup.exit().remove();
	                  titleTextGroup.each(function() {
	                    var titleText = Lib.ensureSingle(d3.select(this), "text", "", function(s) {
	                      s.attr("data-notex", 1);
	                    });
	                    var txt = trace.title.text;
	                    if (trace._meta) {
	                      txt = Lib.templateString(txt, trace._meta);
	                    }
	                    titleText.text(txt).attr({
	                      class: "titletext",
	                      transform: "",
	                      "text-anchor": "middle"
	                    }).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
	                    var transform;
	                    if (trace.title.position === "middle center") {
	                      transform = positionTitleInside(cd0);
	                    } else {
	                      transform = positionTitleOutside(cd0, gs);
	                    }
	                    titleText.attr("transform", strTranslate(transform.x, transform.y) + strScale(Math.min(1, transform.scale)) + strTranslate(transform.tx, transform.ty));
	                  });
	                  if (hasOutsideText) scootLabels(quadrants, trace);
	                  plotTextLines(slices, trace);
	                  if (hasOutsideText && trace.automargin) {
	                    var traceBbox = Drawing.bBox(plotGroup.node());
	                    var domain = trace.domain;
	                    var vpw = gs.w * (domain.x[1] - domain.x[0]);
	                    var vph = gs.h * (domain.y[1] - domain.y[0]);
	                    var xgap = (0.5 * vpw - cd0.r) / gs.w;
	                    var ygap = (0.5 * vph - cd0.r) / gs.h;
	                    Plots.autoMargin(gd, "pie." + trace.uid + ".automargin", {
	                      xl: domain.x[0] - xgap,
	                      xr: domain.x[1] + xgap,
	                      yb: domain.y[0] - ygap,
	                      yt: domain.y[1] + ygap,
	                      l: Math.max(cd0.cx - cd0.r - traceBbox.left, 0),
	                      r: Math.max(traceBbox.right - (cd0.cx + cd0.r), 0),
	                      b: Math.max(traceBbox.bottom - (cd0.cy + cd0.r), 0),
	                      t: Math.max(cd0.cy - cd0.r - traceBbox.top, 0),
	                      pad: 5
	                    });
	                  }
	                });
	              });
	              setTimeout(function() {
	                plotGroups.selectAll("tspan").each(function() {
	                  var s = d3.select(this);
	                  if (s.attr("dy")) s.attr("dy", s.attr("dy"));
	                });
	              }, 0);
	            }
	            function plotTextLines(slices, trace) {
	              slices.each(function(pt) {
	                var sliceTop = d3.select(this);
	                if (!pt.labelExtraX && !pt.labelExtraY) {
	                  sliceTop.select("path.textline").remove();
	                  return;
	                }
	                var sliceText = sliceTop.select("g.slicetext text");
	                pt.transform.targetX += pt.labelExtraX;
	                pt.transform.targetY += pt.labelExtraY;
	                Lib.setTransormAndDisplay(sliceText, pt.transform);
	                var lineStartX = pt.cxFinal + pt.pxmid[0];
	                var lineStartY = pt.cyFinal + pt.pxmid[1];
	                var textLinePath = "M" + lineStartX + "," + lineStartY;
	                var finalX = (pt.yLabelMax - pt.yLabelMin) * (pt.pxmid[0] < 0 ? -1 : 1) / 4;
	                if (pt.labelExtraX) {
	                  var yFromX = pt.labelExtraX * pt.pxmid[1] / pt.pxmid[0];
	                  var yNet = pt.yLabelMid + pt.labelExtraY - (pt.cyFinal + pt.pxmid[1]);
	                  if (Math.abs(yFromX) > Math.abs(yNet)) {
	                    textLinePath += "l" + yNet * pt.pxmid[0] / pt.pxmid[1] + "," + yNet + "H" + (lineStartX + pt.labelExtraX + finalX);
	                  } else {
	                    textLinePath += "l" + pt.labelExtraX + "," + yFromX + "v" + (yNet - yFromX) + "h" + finalX;
	                  }
	                } else {
	                  textLinePath += "V" + (pt.yLabelMid + pt.labelExtraY) + "h" + finalX;
	                }
	                Lib.ensureSingle(sliceTop, "path", "textline").call(Color.stroke, trace.outsidetextfont.color).attr({
	                  "stroke-width": Math.min(2, trace.outsidetextfont.size / 8),
	                  d: textLinePath,
	                  fill: "none"
	                });
	              });
	            }
	            function attachFxHandlers(sliceTop, gd, cd) {
	              var cd0 = cd[0];
	              var cx = cd0.cx;
	              var cy = cd0.cy;
	              var trace = cd0.trace;
	              var isFunnelArea = trace.type === "funnelarea";
	              if (!("_hasHoverLabel" in trace)) trace._hasHoverLabel = false;
	              if (!("_hasHoverEvent" in trace)) trace._hasHoverEvent = false;
	              sliceTop.on("mouseover", function(pt) {
	                var fullLayout2 = gd._fullLayout;
	                var trace2 = gd._fullData[trace.index];
	                if (gd._dragging || fullLayout2.hovermode === false) return;
	                var hoverinfo = trace2.hoverinfo;
	                if (Array.isArray(hoverinfo)) {
	                  hoverinfo = Fx.castHoverinfo({
	                    hoverinfo: [helpers.castOption(hoverinfo, pt.pts)],
	                    _module: trace._module
	                  }, fullLayout2, 0);
	                }
	                if (hoverinfo === "all") hoverinfo = "label+text+value+percent+name";
	                if (trace2.hovertemplate || hoverinfo !== "none" && hoverinfo !== "skip" && hoverinfo) {
	                  var rInscribed = pt.rInscribed || 0;
	                  var hoverCenterX = cx + pt.pxmid[0] * (1 - rInscribed);
	                  var hoverCenterY = cy + pt.pxmid[1] * (1 - rInscribed);
	                  var separators = fullLayout2.separators;
	                  var text = [];
	                  if (hoverinfo && hoverinfo.indexOf("label") !== -1) text.push(pt.label);
	                  pt.text = helpers.castOption(trace2.hovertext || trace2.text, pt.pts);
	                  if (hoverinfo && hoverinfo.indexOf("text") !== -1) {
	                    var tx = pt.text;
	                    if (Lib.isValidTextValue(tx)) text.push(tx);
	                  }
	                  pt.value = pt.v;
	                  pt.valueLabel = helpers.formatPieValue(pt.v, separators);
	                  if (hoverinfo && hoverinfo.indexOf("value") !== -1) text.push(pt.valueLabel);
	                  pt.percent = pt.v / cd0.vTotal;
	                  pt.percentLabel = helpers.formatPiePercent(pt.percent, separators);
	                  if (hoverinfo && hoverinfo.indexOf("percent") !== -1) text.push(pt.percentLabel);
	                  var hoverLabel = trace2.hoverlabel;
	                  var hoverFont = hoverLabel.font;
	                  var bbox = [];
	                  Fx.loneHover({
	                    trace,
	                    x0: hoverCenterX - rInscribed * cd0.r,
	                    x1: hoverCenterX + rInscribed * cd0.r,
	                    y: hoverCenterY,
	                    _x0: isFunnelArea ? cx + pt.TL[0] : hoverCenterX - rInscribed * cd0.r,
	                    _x1: isFunnelArea ? cx + pt.TR[0] : hoverCenterX + rInscribed * cd0.r,
	                    _y0: isFunnelArea ? cy + pt.TL[1] : hoverCenterY - rInscribed * cd0.r,
	                    _y1: isFunnelArea ? cy + pt.BL[1] : hoverCenterY + rInscribed * cd0.r,
	                    text: text.join("<br>"),
	                    name: trace2.hovertemplate || hoverinfo.indexOf("name") !== -1 ? trace2.name : undefined,
	                    idealAlign: pt.pxmid[0] < 0 ? "left" : "right",
	                    color: helpers.castOption(hoverLabel.bgcolor, pt.pts) || pt.color,
	                    borderColor: helpers.castOption(hoverLabel.bordercolor, pt.pts),
	                    fontFamily: helpers.castOption(hoverFont.family, pt.pts),
	                    fontSize: helpers.castOption(hoverFont.size, pt.pts),
	                    fontColor: helpers.castOption(hoverFont.color, pt.pts),
	                    nameLength: helpers.castOption(hoverLabel.namelength, pt.pts),
	                    textAlign: helpers.castOption(hoverLabel.align, pt.pts),
	                    hovertemplate: helpers.castOption(trace2.hovertemplate, pt.pts),
	                    hovertemplateLabels: pt,
	                    eventData: [eventData(pt, trace2)]
	                  }, {
	                    container: fullLayout2._hoverlayer.node(),
	                    outerContainer: fullLayout2._paper.node(),
	                    gd,
	                    inOut_bbox: bbox
	                  });
	                  pt.bbox = bbox[0];
	                  trace._hasHoverLabel = true;
	                }
	                trace._hasHoverEvent = true;
	                gd.emit("plotly_hover", {
	                  points: [eventData(pt, trace2)],
	                  event: d3.event
	                });
	              });
	              sliceTop.on("mouseout", function(evt) {
	                var fullLayout2 = gd._fullLayout;
	                var trace2 = gd._fullData[trace.index];
	                var pt = d3.select(this).datum();
	                if (trace._hasHoverEvent) {
	                  evt.originalEvent = d3.event;
	                  gd.emit("plotly_unhover", {
	                    points: [eventData(pt, trace2)],
	                    event: d3.event
	                  });
	                  trace._hasHoverEvent = false;
	                }
	                if (trace._hasHoverLabel) {
	                  Fx.loneUnhover(fullLayout2._hoverlayer.node());
	                  trace._hasHoverLabel = false;
	                }
	              });
	              sliceTop.on("click", function(pt) {
	                var fullLayout2 = gd._fullLayout;
	                var trace2 = gd._fullData[trace.index];
	                if (gd._dragging || fullLayout2.hovermode === false) return;
	                gd._hoverdata = [eventData(pt, trace2)];
	                Fx.click(gd, d3.event);
	              });
	            }
	            function determineOutsideTextFont(trace, pt, layoutFont) {
	              var color = helpers.castOption(trace.outsidetextfont.color, pt.pts) || helpers.castOption(trace.textfont.color, pt.pts) || layoutFont.color;
	              var family = helpers.castOption(trace.outsidetextfont.family, pt.pts) || helpers.castOption(trace.textfont.family, pt.pts) || layoutFont.family;
	              var size = helpers.castOption(trace.outsidetextfont.size, pt.pts) || helpers.castOption(trace.textfont.size, pt.pts) || layoutFont.size;
	              return {
	                color,
	                family,
	                size
	              };
	            }
	            function determineInsideTextFont(trace, pt, layoutFont) {
	              var customColor = helpers.castOption(trace.insidetextfont.color, pt.pts);
	              if (!customColor && trace._input.textfont) {
	                customColor = helpers.castOption(trace._input.textfont.color, pt.pts);
	              }
	              var family = helpers.castOption(trace.insidetextfont.family, pt.pts) || helpers.castOption(trace.textfont.family, pt.pts) || layoutFont.family;
	              var size = helpers.castOption(trace.insidetextfont.size, pt.pts) || helpers.castOption(trace.textfont.size, pt.pts) || layoutFont.size;
	              return {
	                color: customColor || Color.contrast(pt.color),
	                family,
	                size
	              };
	            }
	            function prerenderTitles(cdModule, gd) {
	              var cd0, trace;
	              for (var i = 0; i < cdModule.length; i++) {
	                cd0 = cdModule[i][0];
	                trace = cd0.trace;
	                if (trace.title.text) {
	                  var txt = trace.title.text;
	                  if (trace._meta) {
	                    txt = Lib.templateString(txt, trace._meta);
	                  }
	                  var dummyTitle = Drawing.tester.append("text").attr("data-notex", 1).text(txt).call(Drawing.font, trace.title.font).call(svgTextUtils.convertToTspans, gd);
	                  var bBox = Drawing.bBox(dummyTitle.node(), true);
	                  cd0.titleBox = {
	                    width: bBox.width,
	                    height: bBox.height
	                  };
	                  dummyTitle.remove();
	                }
	              }
	            }
	            function transformInsideText(textBB, pt, cd0) {
	              var r = cd0.r || pt.rpx1;
	              var rInscribed = pt.rInscribed;
	              var isEmpty = pt.startangle === pt.stopangle;
	              if (isEmpty) {
	                return {
	                  rCenter: 1 - rInscribed,
	                  scale: 0,
	                  rotate: 0,
	                  textPosAngle: 0
	                };
	              }
	              var ring = pt.ring;
	              var isCircle = ring === 1 && Math.abs(pt.startangle - pt.stopangle) === Math.PI * 2;
	              var halfAngle = pt.halfangle;
	              var midAngle = pt.midangle;
	              var orientation = cd0.trace.insidetextorientation;
	              var isHorizontal = orientation === "horizontal";
	              var isTangential = orientation === "tangential";
	              var isRadial = orientation === "radial";
	              var isAuto = orientation === "auto";
	              var allTransforms = [];
	              var newT;
	              if (!isAuto) {
	                var considerCrossing = function(angle, key) {
	                  if (isCrossing(pt, angle)) {
	                    var dStart = Math.abs(angle - pt.startangle);
	                    var dStop = Math.abs(angle - pt.stopangle);
	                    var closestEdge = dStart < dStop ? dStart : dStop;
	                    if (key === "tan") {
	                      newT = calcTanTransform(textBB, r, ring, closestEdge, 0);
	                    } else {
	                      newT = calcRadTransform(textBB, r, ring, closestEdge, Math.PI / 2);
	                    }
	                    newT.textPosAngle = angle;
	                    allTransforms.push(newT);
	                  }
	                };
	                var i;
	                if (isHorizontal || isTangential) {
	                  for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * i, "tan");
	                  for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 1), "tan");
	                }
	                if (isHorizontal || isRadial) {
	                  for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 1.5), "rad");
	                  for (i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 0.5), "rad");
	                }
	              }
	              if (isCircle || isAuto || isHorizontal) {
	                var textDiameter = Math.sqrt(textBB.width * textBB.width + textBB.height * textBB.height);
	                newT = {
	                  scale: rInscribed * r * 2 / textDiameter,
	                  // and the center position and rotation in this case
	                  rCenter: 1 - rInscribed,
	                  rotate: 0
	                };
	                newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
	                if (newT.scale >= 1) return newT;
	                allTransforms.push(newT);
	              }
	              if (isAuto || isRadial) {
	                newT = calcRadTransform(textBB, r, ring, halfAngle, midAngle);
	                newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
	                allTransforms.push(newT);
	              }
	              if (isAuto || isTangential) {
	                newT = calcTanTransform(textBB, r, ring, halfAngle, midAngle);
	                newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
	                allTransforms.push(newT);
	              }
	              var id = 0;
	              var maxScale = 0;
	              for (var k = 0; k < allTransforms.length; k++) {
	                var s = allTransforms[k].scale;
	                if (maxScale < s) {
	                  maxScale = s;
	                  id = k;
	                }
	                if (!isAuto && maxScale >= 1) {
	                  break;
	                }
	              }
	              return allTransforms[id];
	            }
	            function isCrossing(pt, angle) {
	              var start = pt.startangle;
	              var stop = pt.stopangle;
	              return start > angle && angle > stop || start < angle && angle < stop;
	            }
	            function calcRadTransform(textBB, r, ring, halfAngle, midAngle) {
	              r = Math.max(0, r - 2 * TEXTPAD);
	              var a = textBB.width / textBB.height;
	              var s = calcMaxHalfSize(a, halfAngle, r, ring);
	              return {
	                scale: s * 2 / textBB.height,
	                rCenter: calcRCenter(a, s / r),
	                rotate: calcRotate(midAngle)
	              };
	            }
	            function calcTanTransform(textBB, r, ring, halfAngle, midAngle) {
	              r = Math.max(0, r - 2 * TEXTPAD);
	              var a = textBB.height / textBB.width;
	              var s = calcMaxHalfSize(a, halfAngle, r, ring);
	              return {
	                scale: s * 2 / textBB.width,
	                rCenter: calcRCenter(a, s / r),
	                rotate: calcRotate(midAngle + Math.PI / 2)
	              };
	            }
	            function calcRCenter(a, b) {
	              return Math.cos(b) - a * b;
	            }
	            function calcRotate(t) {
	              return (180 / Math.PI * t + 720) % 180 - 90;
	            }
	            function calcMaxHalfSize(a, halfAngle, r, ring) {
	              var q = a + 1 / (2 * Math.tan(halfAngle));
	              return r * Math.min(1 / (Math.sqrt(q * q + 0.5) + q), ring / (Math.sqrt(a * a + ring / 2) + a));
	            }
	            function getInscribedRadiusFraction(pt, cd0) {
	              if (pt.v === cd0.vTotal && !cd0.trace.hole) return 1;
	              return Math.min(1 / (1 + 1 / Math.sin(pt.halfangle)), pt.ring / 2);
	            }
	            function transformOutsideText(textBB, pt) {
	              var x = pt.pxmid[0];
	              var y = pt.pxmid[1];
	              var dx = textBB.width / 2;
	              var dy = textBB.height / 2;
	              if (x < 0) dx *= -1;
	              if (y < 0) dy *= -1;
	              return {
	                scale: 1,
	                rCenter: 1,
	                rotate: 0,
	                x: dx + Math.abs(dy) * (dx > 0 ? 1 : -1) / 2,
	                y: dy / (1 + x * x / (y * y)),
	                outside: true
	              };
	            }
	            function positionTitleInside(cd0) {
	              var textDiameter = Math.sqrt(cd0.titleBox.width * cd0.titleBox.width + cd0.titleBox.height * cd0.titleBox.height);
	              return {
	                x: cd0.cx,
	                y: cd0.cy,
	                scale: cd0.trace.hole * cd0.r * 2 / textDiameter,
	                tx: 0,
	                ty: -cd0.titleBox.height / 2 + cd0.trace.title.font.size
	              };
	            }
	            function positionTitleOutside(cd0, plotSize) {
	              var scaleX = 1;
	              var scaleY = 1;
	              var maxPull;
	              var trace = cd0.trace;
	              var topMiddle = {
	                x: cd0.cx,
	                y: cd0.cy
	              };
	              var translate = {
	                tx: 0,
	                ty: 0
	              };
	              translate.ty += trace.title.font.size;
	              maxPull = getMaxPull(trace);
	              if (trace.title.position.indexOf("top") !== -1) {
	                topMiddle.y -= (1 + maxPull) * cd0.r;
	                translate.ty -= cd0.titleBox.height;
	              } else if (trace.title.position.indexOf("bottom") !== -1) {
	                topMiddle.y += (1 + maxPull) * cd0.r;
	              }
	              var rx = applyAspectRatio(cd0.r, cd0.trace.aspectratio);
	              var maxWidth = plotSize.w * (trace.domain.x[1] - trace.domain.x[0]) / 2;
	              if (trace.title.position.indexOf("left") !== -1) {
	                maxWidth = maxWidth + rx;
	                topMiddle.x -= (1 + maxPull) * rx;
	                translate.tx += cd0.titleBox.width / 2;
	              } else if (trace.title.position.indexOf("center") !== -1) {
	                maxWidth *= 2;
	              } else if (trace.title.position.indexOf("right") !== -1) {
	                maxWidth = maxWidth + rx;
	                topMiddle.x += (1 + maxPull) * rx;
	                translate.tx -= cd0.titleBox.width / 2;
	              }
	              scaleX = maxWidth / cd0.titleBox.width;
	              scaleY = getTitleSpace(cd0, plotSize) / cd0.titleBox.height;
	              return {
	                x: topMiddle.x,
	                y: topMiddle.y,
	                scale: Math.min(scaleX, scaleY),
	                tx: translate.tx,
	                ty: translate.ty
	              };
	            }
	            function applyAspectRatio(x, aspectratio) {
	              return x / (aspectratio === undefined ? 1 : aspectratio);
	            }
	            function getTitleSpace(cd0, plotSize) {
	              var trace = cd0.trace;
	              var pieBoxHeight = plotSize.h * (trace.domain.y[1] - trace.domain.y[0]);
	              return Math.min(cd0.titleBox.height, pieBoxHeight / 2);
	            }
	            function getMaxPull(trace) {
	              var maxPull = trace.pull;
	              if (!maxPull) return 0;
	              var j;
	              if (Array.isArray(maxPull)) {
	                maxPull = 0;
	                for (j = 0; j < trace.pull.length; j++) {
	                  if (trace.pull[j] > maxPull) maxPull = trace.pull[j];
	                }
	              }
	              return maxPull;
	            }
	            function scootLabels(quadrants, trace) {
	              var xHalf, yHalf, equatorFirst, farthestX, farthestY, xDiffSign, yDiffSign, thisQuad, oppositeQuad, wholeSide, i, thisQuadOutside, firstOppositeOutsidePt;
	              function topFirst(a, b) {
	                return a.pxmid[1] - b.pxmid[1];
	              }
	              function bottomFirst(a, b) {
	                return b.pxmid[1] - a.pxmid[1];
	              }
	              function scootOneLabel(thisPt, prevPt2) {
	                if (!prevPt2) prevPt2 = {};
	                var prevOuterY = prevPt2.labelExtraY + (yHalf ? prevPt2.yLabelMax : prevPt2.yLabelMin);
	                var thisInnerY = yHalf ? thisPt.yLabelMin : thisPt.yLabelMax;
	                var thisOuterY = yHalf ? thisPt.yLabelMax : thisPt.yLabelMin;
	                var thisSliceOuterY = thisPt.cyFinal + farthestY(thisPt.px0[1], thisPt.px1[1]);
	                var newExtraY = prevOuterY - thisInnerY;
	                var xBuffer, i2, otherPt, otherOuterY, otherOuterX, newExtraX;
	                if (newExtraY * yDiffSign > 0) thisPt.labelExtraY = newExtraY;
	                if (!Array.isArray(trace.pull)) return;
	                for (i2 = 0; i2 < wholeSide.length; i2++) {
	                  otherPt = wholeSide[i2];
	                  if (otherPt === thisPt || (helpers.castOption(trace.pull, thisPt.pts) || 0) >= (helpers.castOption(trace.pull, otherPt.pts) || 0)) {
	                    continue;
	                  }
	                  if ((thisPt.pxmid[1] - otherPt.pxmid[1]) * yDiffSign > 0) {
	                    otherOuterY = otherPt.cyFinal + farthestY(otherPt.px0[1], otherPt.px1[1]);
	                    newExtraY = otherOuterY - thisInnerY - thisPt.labelExtraY;
	                    if (newExtraY * yDiffSign > 0) thisPt.labelExtraY += newExtraY;
	                  } else if ((thisOuterY + thisPt.labelExtraY - thisSliceOuterY) * yDiffSign > 0) {
	                    xBuffer = 3 * xDiffSign * Math.abs(i2 - wholeSide.indexOf(thisPt));
	                    otherOuterX = otherPt.cxFinal + farthestX(otherPt.px0[0], otherPt.px1[0]);
	                    newExtraX = otherOuterX + xBuffer - (thisPt.cxFinal + thisPt.pxmid[0]) - thisPt.labelExtraX;
	                    if (newExtraX * xDiffSign > 0) thisPt.labelExtraX += newExtraX;
	                  }
	                }
	              }
	              for (yHalf = 0; yHalf < 2; yHalf++) {
	                equatorFirst = yHalf ? topFirst : bottomFirst;
	                farthestY = yHalf ? Math.max : Math.min;
	                yDiffSign = yHalf ? 1 : -1;
	                for (xHalf = 0; xHalf < 2; xHalf++) {
	                  farthestX = xHalf ? Math.max : Math.min;
	                  xDiffSign = xHalf ? 1 : -1;
	                  thisQuad = quadrants[yHalf][xHalf];
	                  thisQuad.sort(equatorFirst);
	                  oppositeQuad = quadrants[1 - yHalf][xHalf];
	                  wholeSide = oppositeQuad.concat(thisQuad);
	                  thisQuadOutside = [];
	                  for (i = 0; i < thisQuad.length; i++) {
	                    if (thisQuad[i].yLabelMid !== undefined) thisQuadOutside.push(thisQuad[i]);
	                  }
	                  firstOppositeOutsidePt = false;
	                  for (i = 0; yHalf && i < oppositeQuad.length; i++) {
	                    if (oppositeQuad[i].yLabelMid !== undefined) {
	                      firstOppositeOutsidePt = oppositeQuad[i];
	                      break;
	                    }
	                  }
	                  for (i = 0; i < thisQuadOutside.length; i++) {
	                    var prevPt = i && thisQuadOutside[i - 1];
	                    if (firstOppositeOutsidePt && !i) prevPt = firstOppositeOutsidePt;
	                    scootOneLabel(thisQuadOutside[i], prevPt);
	                  }
	                }
	              }
	            }
	            function layoutAreas(cdModule, plotSize) {
	              var scaleGroups = [];
	              for (var i = 0; i < cdModule.length; i++) {
	                var cd0 = cdModule[i][0];
	                var trace = cd0.trace;
	                var domain = trace.domain;
	                var width = plotSize.w * (domain.x[1] - domain.x[0]);
	                var height = plotSize.h * (domain.y[1] - domain.y[0]);
	                if (trace.title.text && trace.title.position !== "middle center") {
	                  height -= getTitleSpace(cd0, plotSize);
	                }
	                var rx = width / 2;
	                var ry = height / 2;
	                if (trace.type === "funnelarea" && !trace.scalegroup) {
	                  ry /= trace.aspectratio;
	                }
	                cd0.r = Math.min(rx, ry) / (1 + getMaxPull(trace));
	                cd0.cx = plotSize.l + plotSize.w * (trace.domain.x[1] + trace.domain.x[0]) / 2;
	                cd0.cy = plotSize.t + plotSize.h * (1 - trace.domain.y[0]) - height / 2;
	                if (trace.title.text && trace.title.position.indexOf("bottom") !== -1) {
	                  cd0.cy -= getTitleSpace(cd0, plotSize);
	                }
	                if (trace.scalegroup && scaleGroups.indexOf(trace.scalegroup) === -1) {
	                  scaleGroups.push(trace.scalegroup);
	                }
	              }
	              groupScale(cdModule, scaleGroups);
	            }
	            function groupScale(cdModule, scaleGroups) {
	              var cd0, i, trace;
	              for (var k = 0; k < scaleGroups.length; k++) {
	                var min = Infinity;
	                var g = scaleGroups[k];
	                for (i = 0; i < cdModule.length; i++) {
	                  cd0 = cdModule[i][0];
	                  trace = cd0.trace;
	                  if (trace.scalegroup === g) {
	                    var area;
	                    if (trace.type === "pie") {
	                      area = cd0.r * cd0.r;
	                    } else if (trace.type === "funnelarea") {
	                      var rx, ry;
	                      if (trace.aspectratio > 1) {
	                        rx = cd0.r;
	                        ry = rx / trace.aspectratio;
	                      } else {
	                        ry = cd0.r;
	                        rx = ry * trace.aspectratio;
	                      }
	                      rx *= (1 + trace.baseratio) / 2;
	                      area = rx * ry;
	                    }
	                    min = Math.min(min, area / cd0.vTotal);
	                  }
	                }
	                for (i = 0; i < cdModule.length; i++) {
	                  cd0 = cdModule[i][0];
	                  trace = cd0.trace;
	                  if (trace.scalegroup === g) {
	                    var v = min * cd0.vTotal;
	                    if (trace.type === "funnelarea") {
	                      v /= (1 + trace.baseratio) / 2;
	                      v /= trace.aspectratio;
	                    }
	                    cd0.r = Math.sqrt(v);
	                  }
	                }
	              }
	            }
	            function setCoords(cd) {
	              var cd0 = cd[0];
	              var r = cd0.r;
	              var trace = cd0.trace;
	              var currentAngle = helpers.getRotationAngle(trace.rotation);
	              var angleFactor = 2 * Math.PI / cd0.vTotal;
	              var firstPt = "px0";
	              var lastPt = "px1";
	              var i, cdi, currentCoords;
	              if (trace.direction === "counterclockwise") {
	                for (i = 0; i < cd.length; i++) {
	                  if (!cd[i].hidden) break;
	                }
	                if (i === cd.length) return;
	                currentAngle += angleFactor * cd[i].v;
	                angleFactor *= -1;
	                firstPt = "px1";
	                lastPt = "px0";
	              }
	              currentCoords = getCoords(r, currentAngle);
	              for (i = 0; i < cd.length; i++) {
	                cdi = cd[i];
	                if (cdi.hidden) continue;
	                cdi[firstPt] = currentCoords;
	                cdi.startangle = currentAngle;
	                currentAngle += angleFactor * cdi.v / 2;
	                cdi.pxmid = getCoords(r, currentAngle);
	                cdi.midangle = currentAngle;
	                currentAngle += angleFactor * cdi.v / 2;
	                currentCoords = getCoords(r, currentAngle);
	                cdi.stopangle = currentAngle;
	                cdi[lastPt] = currentCoords;
	                cdi.largeArc = cdi.v > cd0.vTotal / 2 ? 1 : 0;
	                cdi.halfangle = Math.PI * Math.min(cdi.v / cd0.vTotal, 0.5);
	                cdi.ring = 1 - trace.hole;
	                cdi.rInscribed = getInscribedRadiusFraction(cdi, cd0);
	              }
	            }
	            function getCoords(r, angle) {
	              return [r * Math.sin(angle), -r * Math.cos(angle)];
	            }
	            function formatSliceLabel(gd, pt, cd0) {
	              var fullLayout = gd._fullLayout;
	              var trace = cd0.trace;
	              var texttemplate = trace.texttemplate;
	              var textinfo = trace.textinfo;
	              if (!texttemplate && textinfo && textinfo !== "none") {
	                var parts = textinfo.split("+");
	                var hasFlag = function(flag) {
	                  return parts.indexOf(flag) !== -1;
	                };
	                var hasLabel = hasFlag("label");
	                var hasText = hasFlag("text");
	                var hasValue = hasFlag("value");
	                var hasPercent = hasFlag("percent");
	                var separators = fullLayout.separators;
	                var text;
	                text = hasLabel ? [pt.label] : [];
	                if (hasText) {
	                  var tx = helpers.getFirstFilled(trace.text, pt.pts);
	                  if (isValidTextValue(tx)) text.push(tx);
	                }
	                if (hasValue) text.push(helpers.formatPieValue(pt.v, separators));
	                if (hasPercent) text.push(helpers.formatPiePercent(pt.v / cd0.vTotal, separators));
	                pt.text = text.join("<br>");
	              }
	              function makeTemplateVariables(pt2) {
	                return {
	                  label: pt2.label,
	                  value: pt2.v,
	                  valueLabel: helpers.formatPieValue(pt2.v, fullLayout.separators),
	                  percent: pt2.v / cd0.vTotal,
	                  percentLabel: helpers.formatPiePercent(pt2.v / cd0.vTotal, fullLayout.separators),
	                  color: pt2.color,
	                  text: pt2.text,
	                  customdata: Lib.castOption(trace, pt2.i, "customdata")
	                };
	              }
	              if (texttemplate) {
	                var txt = Lib.castOption(trace, pt.i, "texttemplate");
	                if (!txt) {
	                  pt.text = "";
	                } else {
	                  var obj = makeTemplateVariables(pt);
	                  var ptTx = helpers.getFirstFilled(trace.text, pt.pts);
	                  if (isValidTextValue(ptTx) || ptTx === "") obj.text = ptTx;
	                  pt.text = Lib.texttemplateString(txt, obj, gd._fullLayout._d3locale, obj, trace._meta || {});
	                }
	              }
	            }
	            function computeTransform(transform, textBB) {
	              var a = transform.rotate * Math.PI / 180;
	              var cosA = Math.cos(a);
	              var sinA = Math.sin(a);
	              var midX = (textBB.left + textBB.right) / 2;
	              var midY = (textBB.top + textBB.bottom) / 2;
	              transform.textX = midX * cosA - midY * sinA;
	              transform.textY = midX * sinA + midY * cosA;
	              transform.noCenter = true;
	            }
	            module2.exports = {
	              plot,
	              formatSliceLabel,
	              transformInsideText,
	              determineInsideTextFont,
	              positionTitleOutside,
	              prerenderTitles,
	              layoutAreas,
	              attachFxHandlers,
	              computeTransform
	            };
	          }
	        ),
	        /***/
	        68357: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var styleOne = __webpack_require__2(63463);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            module2.exports = function style(gd) {
	              var s = gd._fullLayout._pielayer.selectAll(".trace");
	              resizeText(gd, s, "pie");
	              s.each(function(cd) {
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                var traceSelection = d3.select(this);
	                traceSelection.style({
	                  opacity: trace.opacity
	                });
	                traceSelection.selectAll("path.surface").each(function(pt) {
	                  d3.select(this).call(styleOne, pt, trace, gd);
	                });
	              });
	            };
	          }
	        ),
	        /***/
	        63463: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var castOption = __webpack_require__2(53581).castOption;
	            var fillOne = __webpack_require__2(22209);
	            module2.exports = function styleOne(s, pt, trace, gd) {
	              var line = trace.marker.line;
	              var lineColor = castOption(line.color, pt.pts) || Color.defaultLine;
	              var lineWidth = castOption(line.width, pt.pts) || 0;
	              s.call(fillOne, pt, trace, gd).style("stroke-width", lineWidth).call(Color.stroke, lineColor);
	            };
	          }
	        ),
	        /***/
	        10959: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterglAttrs = __webpack_require__2(82196);
	            module2.exports = {
	              x: scatterglAttrs.x,
	              y: scatterglAttrs.y,
	              xy: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              indices: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              xbounds: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              ybounds: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              text: scatterglAttrs.text,
	              marker: {
	                color: {
	                  valType: "color",
	                  arrayOk: false,
	                  editType: "calc"
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1,
	                  arrayOk: false,
	                  editType: "calc"
	                },
	                blend: {
	                  valType: "boolean",
	                  dflt: null,
	                  editType: "calc"
	                },
	                sizemin: {
	                  valType: "number",
	                  min: 0.1,
	                  max: 2,
	                  dflt: 0.5,
	                  editType: "calc"
	                },
	                sizemax: {
	                  valType: "number",
	                  min: 0.1,
	                  dflt: 20,
	                  editType: "calc"
	                },
	                border: {
	                  color: {
	                    valType: "color",
	                    arrayOk: false,
	                    editType: "calc"
	                  },
	                  arearatio: {
	                    valType: "number",
	                    min: 0,
	                    max: 1,
	                    dflt: 0,
	                    editType: "calc"
	                  },
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              transforms: undefined
	            };
	          }
	        ),
	        /***/
	        42743: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createPointCloudRenderer = __webpack_require__2(9330).gl_pointcloud2d;
	            var str2RGBArray = __webpack_require__2(78614);
	            var findExtremes = __webpack_require__2(71739).findExtremes;
	            var getTraceColor = __webpack_require__2(34603);
	            function Pointcloud(scene, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.type = "pointcloud";
	              this.pickXData = [];
	              this.pickYData = [];
	              this.xData = [];
	              this.yData = [];
	              this.textLabels = [];
	              this.color = "rgb(0, 0, 0)";
	              this.name = "";
	              this.hoverinfo = "all";
	              this.idToIndex = new Int32Array(0);
	              this.bounds = [0, 0, 0, 0];
	              this.pointcloudOptions = {
	                positions: new Float32Array(0),
	                idToIndex: this.idToIndex,
	                sizemin: 0.5,
	                sizemax: 12,
	                color: [0, 0, 0, 1],
	                areaRatio: 1,
	                borderColor: [0, 0, 0, 1]
	              };
	              this.pointcloud = createPointCloudRenderer(scene.glplot, this.pointcloudOptions);
	              this.pointcloud._trace = this;
	            }
	            var proto = Pointcloud.prototype;
	            proto.handlePick = function(pickResult) {
	              var index = this.idToIndex[pickResult.pointId];
	              return {
	                trace: this,
	                dataCoord: pickResult.dataCoord,
	                traceCoord: this.pickXYData ? [this.pickXYData[index * 2], this.pickXYData[index * 2 + 1]] : [this.pickXData[index], this.pickYData[index]],
	                textLabel: Array.isArray(this.textLabels) ? this.textLabels[index] : this.textLabels,
	                color: this.color,
	                name: this.name,
	                pointIndex: index,
	                hoverinfo: this.hoverinfo
	              };
	            };
	            proto.update = function(options) {
	              this.index = options.index;
	              this.textLabels = options.text;
	              this.name = options.name;
	              this.hoverinfo = options.hoverinfo;
	              this.bounds = [Infinity, Infinity, -Infinity, -Infinity];
	              this.updateFast(options);
	              this.color = getTraceColor(options, {});
	            };
	            proto.updateFast = function(options) {
	              var x = this.xData = this.pickXData = options.x;
	              var y = this.yData = this.pickYData = options.y;
	              var xy = this.pickXYData = options.xy;
	              var userBounds = options.xbounds && options.ybounds;
	              var index = options.indices;
	              var len;
	              var idToIndex;
	              var positions;
	              var bounds = this.bounds;
	              var xx, yy, i;
	              if (xy) {
	                positions = xy;
	                len = xy.length >>> 1;
	                if (userBounds) {
	                  bounds[0] = options.xbounds[0];
	                  bounds[2] = options.xbounds[1];
	                  bounds[1] = options.ybounds[0];
	                  bounds[3] = options.ybounds[1];
	                } else {
	                  for (i = 0; i < len; i++) {
	                    xx = positions[i * 2];
	                    yy = positions[i * 2 + 1];
	                    if (xx < bounds[0]) bounds[0] = xx;
	                    if (xx > bounds[2]) bounds[2] = xx;
	                    if (yy < bounds[1]) bounds[1] = yy;
	                    if (yy > bounds[3]) bounds[3] = yy;
	                  }
	                }
	                if (index) {
	                  idToIndex = index;
	                } else {
	                  idToIndex = new Int32Array(len);
	                  for (i = 0; i < len; i++) {
	                    idToIndex[i] = i;
	                  }
	                }
	              } else {
	                len = x.length;
	                positions = new Float32Array(2 * len);
	                idToIndex = new Int32Array(len);
	                for (i = 0; i < len; i++) {
	                  xx = x[i];
	                  yy = y[i];
	                  idToIndex[i] = i;
	                  positions[i * 2] = xx;
	                  positions[i * 2 + 1] = yy;
	                  if (xx < bounds[0]) bounds[0] = xx;
	                  if (xx > bounds[2]) bounds[2] = xx;
	                  if (yy < bounds[1]) bounds[1] = yy;
	                  if (yy > bounds[3]) bounds[3] = yy;
	                }
	              }
	              this.idToIndex = idToIndex;
	              this.pointcloudOptions.idToIndex = idToIndex;
	              this.pointcloudOptions.positions = positions;
	              var markerColor = str2RGBArray(options.marker.color);
	              var borderColor = str2RGBArray(options.marker.border.color);
	              var opacity = options.opacity * options.marker.opacity;
	              markerColor[3] *= opacity;
	              this.pointcloudOptions.color = markerColor;
	              var blend = options.marker.blend;
	              if (blend === null) {
	                var maxPoints = 100;
	                blend = x.length < maxPoints || y.length < maxPoints;
	              }
	              this.pointcloudOptions.blend = blend;
	              borderColor[3] *= opacity;
	              this.pointcloudOptions.borderColor = borderColor;
	              var markerSizeMin = options.marker.sizemin;
	              var markerSizeMax = Math.max(options.marker.sizemax, options.marker.sizemin);
	              this.pointcloudOptions.sizeMin = markerSizeMin;
	              this.pointcloudOptions.sizeMax = markerSizeMax;
	              this.pointcloudOptions.areaRatio = options.marker.border.arearatio;
	              this.pointcloud.update(this.pointcloudOptions);
	              var xa = this.scene.xaxis;
	              var ya = this.scene.yaxis;
	              var pad = markerSizeMax / 2 || 0.5;
	              options._extremes[xa._id] = findExtremes(xa, [bounds[0], bounds[2]], {
	                ppad: pad
	              });
	              options._extremes[ya._id] = findExtremes(ya, [bounds[1], bounds[3]], {
	                ppad: pad
	              });
	            };
	            proto.dispose = function() {
	              this.pointcloud.dispose();
	            };
	            function createPointcloud(scene, data) {
	              var plot = new Pointcloud(scene, data.uid);
	              plot.update(data);
	              return plot;
	            }
	            module2.exports = createPointcloud;
	          }
	        ),
	        /***/
	        33876: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(10959);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              coerce("x");
	              coerce("y");
	              coerce("xbounds");
	              coerce("ybounds");
	              if (traceIn.xy && traceIn.xy instanceof Float32Array) {
	                traceOut.xy = traceIn.xy;
	              }
	              if (traceIn.indices && traceIn.indices instanceof Int32Array) {
	                traceOut.indices = traceIn.indices;
	              }
	              coerce("text");
	              coerce("marker.color", defaultColor);
	              coerce("marker.opacity");
	              coerce("marker.blend");
	              coerce("marker.sizemin");
	              coerce("marker.sizemax");
	              coerce("marker.border.color", defaultColor);
	              coerce("marker.border.arearatio");
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        20593: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(10959),
	              supplyDefaults: __webpack_require__2(33876),
	              // reuse the Scatter3D 'dummy' calc step so that legends know what to do
	              calc: __webpack_require__2(36563),
	              plot: __webpack_require__2(42743),
	              moduleType: "trace",
	              name: "pointcloud",
	              basePlotModule: __webpack_require__2(4796),
	              categories: ["gl", "gl2d", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        39953: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var fontAttrs = __webpack_require__2(41940);
	            var baseAttrs = __webpack_require__2(9012);
	            var colorAttrs = __webpack_require__2(22399);
	            var fxAttrs = __webpack_require__2(77914);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var colorAttributes = __webpack_require__2(50693);
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var descriptionOnlyNumbers = __webpack_require__2(12663).descriptionOnlyNumbers;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var attrs = module2.exports = overrideAll({
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: [],
	                arrayOk: false
	              }),
	              hoverlabel: fxAttrs.hoverlabel,
	              domain: domainAttrs({
	                name: "sankey",
	                trace: true
	              }),
	              orientation: {
	                valType: "enumerated",
	                values: ["v", "h"],
	                dflt: "h"
	              },
	              valueformat: {
	                valType: "string",
	                dflt: ".3s",
	                description: descriptionOnlyNumbers("value")
	              },
	              valuesuffix: {
	                valType: "string",
	                dflt: ""
	              },
	              arrangement: {
	                valType: "enumerated",
	                values: ["snap", "perpendicular", "freeform", "fixed"],
	                dflt: "snap"
	              },
	              textfont: fontAttrs({}),
	              // Remove top-level customdata
	              customdata: undefined,
	              node: {
	                label: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                groups: {
	                  valType: "info_array",
	                  impliedEdits: {
	                    x: [],
	                    y: []
	                  },
	                  dimensions: 2,
	                  freeLength: true,
	                  dflt: [],
	                  items: {
	                    valType: "number",
	                    editType: "calc"
	                  }
	                },
	                x: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                y: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                color: {
	                  valType: "color",
	                  arrayOk: true
	                },
	                customdata: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                line: {
	                  color: {
	                    valType: "color",
	                    dflt: colorAttrs.defaultLine,
	                    arrayOk: true
	                  },
	                  width: {
	                    valType: "number",
	                    min: 0,
	                    dflt: 0.5,
	                    arrayOk: true
	                  }
	                },
	                pad: {
	                  valType: "number",
	                  arrayOk: false,
	                  min: 0,
	                  dflt: 20
	                },
	                thickness: {
	                  valType: "number",
	                  arrayOk: false,
	                  min: 1,
	                  dflt: 20
	                },
	                hoverinfo: {
	                  valType: "enumerated",
	                  values: ["all", "none", "skip"],
	                  dflt: "all"
	                },
	                hoverlabel: fxAttrs.hoverlabel,
	                // needs editType override,
	                hovertemplate: hovertemplateAttrs({}, {
	                  keys: ["value", "label"]
	                })
	              },
	              link: {
	                arrowlen: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0
	                },
	                label: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                color: {
	                  valType: "color",
	                  arrayOk: true
	                },
	                customdata: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                line: {
	                  color: {
	                    valType: "color",
	                    dflt: colorAttrs.defaultLine,
	                    arrayOk: true
	                  },
	                  width: {
	                    valType: "number",
	                    min: 0,
	                    dflt: 0,
	                    arrayOk: true
	                  }
	                },
	                source: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                target: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                value: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                hoverinfo: {
	                  valType: "enumerated",
	                  values: ["all", "none", "skip"],
	                  dflt: "all"
	                },
	                hoverlabel: fxAttrs.hoverlabel,
	                // needs editType override,
	                hovertemplate: hovertemplateAttrs({}, {
	                  keys: ["value", "label"]
	                }),
	                colorscales: templatedArray("concentrationscales", {
	                  editType: "calc",
	                  label: {
	                    valType: "string",
	                    editType: "calc",
	                    dflt: ""
	                  },
	                  cmax: {
	                    valType: "number",
	                    editType: "calc",
	                    dflt: 1
	                  },
	                  cmin: {
	                    valType: "number",
	                    editType: "calc",
	                    dflt: 0
	                  },
	                  colorscale: extendFlat(colorAttributes().colorscale, {
	                    dflt: [[0, "white"], [1, "black"]]
	                  })
	                })
	              }
	            }, "calc", "nested");
	            attrs.transforms = undefined;
	          }
	        ),
	        /***/
	        75536: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var plot = __webpack_require__2(60436);
	            var fxAttrs = __webpack_require__2(528);
	            var setCursor = __webpack_require__2(6964);
	            var dragElement = __webpack_require__2(28569);
	            var prepSelect = __webpack_require__2(47322).prepSelect;
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var SANKEY = "sankey";
	            exports2.name = SANKEY;
	            exports2.baseLayoutAttrOverrides = overrideAll({
	              hoverlabel: fxAttrs.hoverlabel
	            }, "plot", "nested");
	            exports2.plot = function(gd) {
	              var calcData = getModuleCalcData(gd.calcdata, SANKEY)[0];
	              plot(gd, calcData);
	              exports2.updateFx(gd);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var hadPlot = oldFullLayout._has && oldFullLayout._has(SANKEY);
	              var hasPlot = newFullLayout._has && newFullLayout._has(SANKEY);
	              if (hadPlot && !hasPlot) {
	                oldFullLayout._paperdiv.selectAll(".sankey").remove();
	                oldFullLayout._paperdiv.selectAll(".bgsankey").remove();
	              }
	            };
	            exports2.updateFx = function(gd) {
	              for (var i = 0; i < gd._fullData.length; i++) {
	                subplotUpdateFx(gd, i);
	              }
	            };
	            function subplotUpdateFx(gd, index) {
	              var trace = gd._fullData[index];
	              var fullLayout = gd._fullLayout;
	              var dragMode = fullLayout.dragmode;
	              var cursor = fullLayout.dragmode === "pan" ? "move" : "crosshair";
	              var bgRect = trace._bgRect;
	              if (!bgRect) return;
	              if (dragMode === "pan" || dragMode === "zoom") return;
	              setCursor(bgRect, cursor);
	              var xaxis = {
	                _id: "x",
	                c2p: Lib.identity,
	                _offset: trace._sankey.translateX,
	                _length: trace._sankey.width
	              };
	              var yaxis = {
	                _id: "y",
	                c2p: Lib.identity,
	                _offset: trace._sankey.translateY,
	                _length: trace._sankey.height
	              };
	              var dragOptions = {
	                gd,
	                element: bgRect.node(),
	                plotinfo: {
	                  id: index,
	                  xaxis,
	                  yaxis,
	                  fillRangeItems: Lib.noop
	                },
	                subplot: index,
	                // create mock x/y axes for hover routine
	                xaxes: [xaxis],
	                yaxes: [yaxis],
	                doneFnCompleted: function(selection) {
	                  var traceNow = gd._fullData[index];
	                  var newGroups;
	                  var oldGroups = traceNow.node.groups.slice();
	                  var newGroup = [];
	                  function findNode(pt) {
	                    var nodes = traceNow._sankey.graph.nodes;
	                    for (var i = 0; i < nodes.length; i++) {
	                      if (nodes[i].pointNumber === pt) return nodes[i];
	                    }
	                  }
	                  for (var j = 0; j < selection.length; j++) {
	                    var node = findNode(selection[j].pointNumber);
	                    if (!node) continue;
	                    if (node.group) {
	                      for (var k = 0; k < node.childrenNodes.length; k++) {
	                        newGroup.push(node.childrenNodes[k].pointNumber);
	                      }
	                      oldGroups[node.pointNumber - traceNow.node._count] = false;
	                    } else {
	                      newGroup.push(node.pointNumber);
	                    }
	                  }
	                  newGroups = oldGroups.filter(Boolean).concat([newGroup]);
	                  Registry.call("_guiRestyle", gd, {
	                    "node.groups": [newGroups]
	                  }, index);
	                }
	              };
	              dragOptions.prepFn = function(e, startX, startY) {
	                prepSelect(e, startX, startY, dragOptions, dragMode);
	              };
	              dragElement.init(dragOptions);
	            }
	          }
	        ),
	        /***/
	        92930: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var tarjan = __webpack_require__2(68664);
	            var Lib = __webpack_require__2(71828);
	            var wrap = __webpack_require__2(28984).wrap;
	            var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
	            var isIndex = Lib.isIndex;
	            var Colorscale = __webpack_require__2(21081);
	            function convertToD3Sankey(trace) {
	              var nodeSpec = trace.node;
	              var linkSpec = trace.link;
	              var links = [];
	              var hasLinkColorArray = isArrayOrTypedArray(linkSpec.color);
	              var hasLinkCustomdataArray = isArrayOrTypedArray(linkSpec.customdata);
	              var linkedNodes = {};
	              var components = {};
	              var componentCount = linkSpec.colorscales.length;
	              var i;
	              for (i = 0; i < componentCount; i++) {
	                var cscale = linkSpec.colorscales[i];
	                var specs = Colorscale.extractScale(cscale, {
	                  cLetter: "c"
	                });
	                var scale = Colorscale.makeColorScaleFunc(specs);
	                components[cscale.label] = scale;
	              }
	              var maxNodeId = 0;
	              for (i = 0; i < linkSpec.value.length; i++) {
	                if (linkSpec.source[i] > maxNodeId) maxNodeId = linkSpec.source[i];
	                if (linkSpec.target[i] > maxNodeId) maxNodeId = linkSpec.target[i];
	              }
	              var nodeCount = maxNodeId + 1;
	              trace.node._count = nodeCount;
	              var j;
	              var groups = trace.node.groups;
	              var groupLookup = {};
	              for (i = 0; i < groups.length; i++) {
	                var group = groups[i];
	                for (j = 0; j < group.length; j++) {
	                  var nodeIndex = group[j];
	                  var groupIndex = nodeCount + i;
	                  if (groupLookup.hasOwnProperty(nodeIndex)) {
	                    Lib.warn("Node " + nodeIndex + " is already part of a group.");
	                  } else {
	                    groupLookup[nodeIndex] = groupIndex;
	                  }
	                }
	              }
	              var groupedLinks = {
	                source: [],
	                target: []
	              };
	              for (i = 0; i < linkSpec.value.length; i++) {
	                var val = linkSpec.value[i];
	                var source = linkSpec.source[i];
	                var target = linkSpec.target[i];
	                if (!(val > 0 && isIndex(source, nodeCount) && isIndex(target, nodeCount))) {
	                  continue;
	                }
	                if (groupLookup.hasOwnProperty(source) && groupLookup.hasOwnProperty(target) && groupLookup[source] === groupLookup[target]) {
	                  continue;
	                }
	                if (groupLookup.hasOwnProperty(target)) {
	                  target = groupLookup[target];
	                }
	                if (groupLookup.hasOwnProperty(source)) {
	                  source = groupLookup[source];
	                }
	                source = +source;
	                target = +target;
	                linkedNodes[source] = linkedNodes[target] = true;
	                var label = "";
	                if (linkSpec.label && linkSpec.label[i]) label = linkSpec.label[i];
	                var concentrationscale = null;
	                if (label && components.hasOwnProperty(label)) concentrationscale = components[label];
	                links.push({
	                  pointNumber: i,
	                  label,
	                  color: hasLinkColorArray ? linkSpec.color[i] : linkSpec.color,
	                  customdata: hasLinkCustomdataArray ? linkSpec.customdata[i] : linkSpec.customdata,
	                  concentrationscale,
	                  source,
	                  target,
	                  value: +val
	                });
	                groupedLinks.source.push(source);
	                groupedLinks.target.push(target);
	              }
	              var totalCount = nodeCount + groups.length;
	              var hasNodeColorArray = isArrayOrTypedArray(nodeSpec.color);
	              var hasNodeCustomdataArray = isArrayOrTypedArray(nodeSpec.customdata);
	              var nodes = [];
	              for (i = 0; i < totalCount; i++) {
	                if (!linkedNodes[i]) continue;
	                var l = nodeSpec.label[i];
	                nodes.push({
	                  group: i > nodeCount - 1,
	                  childrenNodes: [],
	                  pointNumber: i,
	                  label: l,
	                  color: hasNodeColorArray ? nodeSpec.color[i] : nodeSpec.color,
	                  customdata: hasNodeCustomdataArray ? nodeSpec.customdata[i] : nodeSpec.customdata
	                });
	              }
	              var circular = false;
	              if (circularityPresent(totalCount, groupedLinks.source, groupedLinks.target)) {
	                circular = true;
	              }
	              return {
	                circular,
	                links,
	                nodes,
	                // Data structure for groups
	                groups,
	                groupLookup
	              };
	            }
	            function circularityPresent(nodeLen, sources, targets) {
	              var nodes = Lib.init2dArray(nodeLen, 0);
	              for (var i = 0; i < Math.min(sources.length, targets.length); i++) {
	                if (Lib.isIndex(sources[i], nodeLen) && Lib.isIndex(targets[i], nodeLen)) {
	                  if (sources[i] === targets[i]) {
	                    return true;
	                  }
	                  nodes[sources[i]].push(targets[i]);
	                }
	              }
	              var scc = tarjan(nodes);
	              return scc.components.some(function(c) {
	                return c.length > 1;
	              });
	            }
	            module2.exports = function calc(gd, trace) {
	              var result = convertToD3Sankey(trace);
	              return wrap({
	                circular: result.circular,
	                _nodes: result.nodes,
	                _links: result.links,
	                // Data structure for grouping
	                _groups: result.groups,
	                _groupLookup: result.groupLookup
	              });
	            };
	          }
	        ),
	        /***/
	        85247: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              nodeTextOffsetHorizontal: 4,
	              nodeTextOffsetVertical: 3,
	              nodePadAcross: 10,
	              sankeyIterations: 50,
	              forceIterations: 5,
	              forceTicksPerFrame: 10,
	              duration: 500,
	              ease: "linear",
	              cn: {
	                sankey: "sankey",
	                sankeyLinks: "sankey-links",
	                sankeyLink: "sankey-link",
	                sankeyNodeSet: "sankey-node-set",
	                sankeyNode: "sankey-node",
	                nodeRect: "node-rect",
	                nodeLabel: "node-label"
	              }
	            };
	          }
	        ),
	        /***/
	        26857: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(39953);
	            var Color = __webpack_require__2(7901);
	            var tinycolor = __webpack_require__2(84267);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleHoverLabelDefaults = __webpack_require__2(38048);
	            var Template = __webpack_require__2(44467);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var hoverlabelDefault = Lib.extendDeep(layout.hoverlabel, traceIn.hoverlabel);
	              var nodeIn = traceIn.node;
	              var nodeOut = Template.newContainer(traceOut, "node");
	              function coerceNode(attr, dflt) {
	                return Lib.coerce(nodeIn, nodeOut, attributes.node, attr, dflt);
	              }
	              coerceNode("label");
	              coerceNode("groups");
	              coerceNode("x");
	              coerceNode("y");
	              coerceNode("pad");
	              coerceNode("thickness");
	              coerceNode("line.color");
	              coerceNode("line.width");
	              coerceNode("hoverinfo", traceIn.hoverinfo);
	              handleHoverLabelDefaults(nodeIn, nodeOut, coerceNode, hoverlabelDefault);
	              coerceNode("hovertemplate");
	              var colors = layout.colorway;
	              var defaultNodePalette = function(i) {
	                return colors[i % colors.length];
	              };
	              coerceNode("color", nodeOut.label.map(function(d, i) {
	                return Color.addOpacity(defaultNodePalette(i), 0.8);
	              }));
	              coerceNode("customdata");
	              var linkIn = traceIn.link || {};
	              var linkOut = Template.newContainer(traceOut, "link");
	              function coerceLink(attr, dflt) {
	                return Lib.coerce(linkIn, linkOut, attributes.link, attr, dflt);
	              }
	              coerceLink("label");
	              coerceLink("arrowlen");
	              coerceLink("source");
	              coerceLink("target");
	              coerceLink("value");
	              coerceLink("line.color");
	              coerceLink("line.width");
	              coerceLink("hoverinfo", traceIn.hoverinfo);
	              handleHoverLabelDefaults(linkIn, linkOut, coerceLink, hoverlabelDefault);
	              coerceLink("hovertemplate");
	              var defaultLinkColor = tinycolor(layout.paper_bgcolor).getLuminance() < 0.333 ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.2)";
	              coerceLink("color", Lib.repeat(defaultLinkColor, linkOut.value.length));
	              coerceLink("customdata");
	              handleArrayContainerDefaults(linkIn, linkOut, {
	                name: "colorscales",
	                handleItemDefaults: concentrationscalesDefaults
	              });
	              handleDomainDefaults(traceOut, layout, coerce);
	              coerce("orientation");
	              coerce("valueformat");
	              coerce("valuesuffix");
	              var dfltArrangement;
	              if (nodeOut.x.length && nodeOut.y.length) {
	                dfltArrangement = "freeform";
	              }
	              coerce("arrangement", dfltArrangement);
	              Lib.coerceFont(coerce, "textfont", Lib.extendFlat({}, layout.font));
	              traceOut._length = null;
	            };
	            function concentrationscalesDefaults(In, Out) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(In, Out, attributes.link.colorscales, attr, dflt);
	              }
	              coerce("label");
	              coerce("cmin");
	              coerce("cmax");
	              coerce("colorscale");
	            }
	          }
	        ),
	        /***/
	        29396: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(39953),
	              supplyDefaults: __webpack_require__2(26857),
	              calc: __webpack_require__2(92930),
	              plot: __webpack_require__2(60436),
	              moduleType: "trace",
	              name: "sankey",
	              basePlotModule: __webpack_require__2(75536),
	              selectPoints: __webpack_require__2(84564),
	              categories: ["noOpacity"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        60436: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var numberFormat = Lib.numberFormat;
	            var render = __webpack_require__2(3393);
	            var Fx = __webpack_require__2(30211);
	            var Color = __webpack_require__2(7901);
	            var cn = __webpack_require__2(85247).cn;
	            var _ = Lib._;
	            function renderableValuePresent(d) {
	              return d !== "";
	            }
	            function ownTrace(selection, d) {
	              return selection.filter(function(s) {
	                return s.key === d.traceId;
	              });
	            }
	            function makeTranslucent(element, alpha) {
	              d3.select(element).select("path").style("fill-opacity", alpha);
	              d3.select(element).select("rect").style("fill-opacity", alpha);
	            }
	            function makeTextContrasty(element) {
	              d3.select(element).select("text.name").style("fill", "black");
	            }
	            function relatedLinks(d) {
	              return function(l) {
	                return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
	              };
	            }
	            function relatedNodes(l) {
	              return function(d) {
	                return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
	              };
	            }
	            function nodeHoveredStyle(sankeyNode, d, sankey) {
	              if (d && sankey) {
	                ownTrace(sankey, d).selectAll("." + cn.sankeyLink).filter(relatedLinks(d)).call(linkHoveredStyle.bind(0, d, sankey, false));
	              }
	            }
	            function nodeNonHoveredStyle(sankeyNode, d, sankey) {
	              if (d && sankey) {
	                ownTrace(sankey, d).selectAll("." + cn.sankeyLink).filter(relatedLinks(d)).call(linkNonHoveredStyle.bind(0, d, sankey, false));
	              }
	            }
	            function linkHoveredStyle(d, sankey, visitNodes, sankeyLink) {
	              var label = sankeyLink.datum().link.label;
	              sankeyLink.style("fill-opacity", function(l) {
	                if (!l.link.concentrationscale) {
	                  return 0.4;
	                }
	              });
	              if (label) {
	                ownTrace(sankey, d).selectAll("." + cn.sankeyLink).filter(function(l) {
	                  return l.link.label === label;
	                }).style("fill-opacity", function(l) {
	                  if (!l.link.concentrationscale) {
	                    return 0.4;
	                  }
	                });
	              }
	              if (visitNodes) {
	                ownTrace(sankey, d).selectAll("." + cn.sankeyNode).filter(relatedNodes(d)).call(nodeHoveredStyle);
	              }
	            }
	            function linkNonHoveredStyle(d, sankey, visitNodes, sankeyLink) {
	              var label = sankeyLink.datum().link.label;
	              sankeyLink.style("fill-opacity", function(d2) {
	                return d2.tinyColorAlpha;
	              });
	              if (label) {
	                ownTrace(sankey, d).selectAll("." + cn.sankeyLink).filter(function(l) {
	                  return l.link.label === label;
	                }).style("fill-opacity", function(d2) {
	                  return d2.tinyColorAlpha;
	                });
	              }
	              if (visitNodes) {
	                ownTrace(sankey, d).selectAll(cn.sankeyNode).filter(relatedNodes(d)).call(nodeNonHoveredStyle);
	              }
	            }
	            function castHoverOption(trace, attr) {
	              var labelOpts = trace.hoverlabel || {};
	              var val = Lib.nestedProperty(labelOpts, attr).get();
	              return Array.isArray(val) ? false : val;
	            }
	            module2.exports = function plot(gd, calcData) {
	              var fullLayout = gd._fullLayout;
	              var svg = fullLayout._paper;
	              var size = fullLayout._size;
	              for (var i = 0; i < gd._fullData.length; i++) {
	                if (!gd._fullData[i].visible) continue;
	                if (gd._fullData[i].type !== cn.sankey) continue;
	                if (!gd._fullData[i]._viewInitial) {
	                  var node = gd._fullData[i].node;
	                  gd._fullData[i]._viewInitial = {
	                    node: {
	                      groups: node.groups.slice(),
	                      x: node.x.slice(),
	                      y: node.y.slice()
	                    }
	                  };
	                }
	              }
	              var linkSelect = function(element, d) {
	                var evt = d.link;
	                evt.originalEvent = d3.event;
	                gd._hoverdata = [evt];
	                Fx.click(gd, {
	                  target: true
	                });
	              };
	              var linkHover = function(element, d, sankey) {
	                if (gd._fullLayout.hovermode === false) return;
	                d3.select(element).call(linkHoveredStyle.bind(0, d, sankey, true));
	                if (d.link.trace.link.hoverinfo !== "skip") {
	                  d.link.fullData = d.link.trace;
	                  gd.emit("plotly_hover", {
	                    event: d3.event,
	                    points: [d.link]
	                  });
	                }
	              };
	              var sourceLabel = _(gd, "source:") + " ";
	              var targetLabel = _(gd, "target:") + " ";
	              var concentrationLabel = _(gd, "concentration:") + " ";
	              var incomingLabel = _(gd, "incoming flow count:") + " ";
	              var outgoingLabel = _(gd, "outgoing flow count:") + " ";
	              var linkHoverFollow = function(element, d) {
	                if (gd._fullLayout.hovermode === false) return;
	                var obj = d.link.trace.link;
	                if (obj.hoverinfo === "none" || obj.hoverinfo === "skip") return;
	                var hoverItems = [];
	                function hoverCenterPosition(link2) {
	                  var hoverCenterX, hoverCenterY;
	                  if (link2.circular) {
	                    hoverCenterX = (link2.circularPathData.leftInnerExtent + link2.circularPathData.rightInnerExtent) / 2;
	                    hoverCenterY = link2.circularPathData.verticalFullExtent;
	                  } else {
	                    hoverCenterX = (link2.source.x1 + link2.target.x0) / 2;
	                    hoverCenterY = (link2.y0 + link2.y1) / 2;
	                  }
	                  var center = [hoverCenterX, hoverCenterY];
	                  if (link2.trace.orientation === "v") center.reverse();
	                  center[0] += d.parent.translateX;
	                  center[1] += d.parent.translateY;
	                  return center;
	                }
	                var anchorIndex = 0;
	                for (var i2 = 0; i2 < d.flow.links.length; i2++) {
	                  var link = d.flow.links[i2];
	                  if (gd._fullLayout.hovermode === "closest" && d.link.pointNumber !== link.pointNumber) continue;
	                  if (d.link.pointNumber === link.pointNumber) anchorIndex = i2;
	                  link.fullData = link.trace;
	                  obj = d.link.trace.link;
	                  var hoverCenter = hoverCenterPosition(link);
	                  var hovertemplateLabels = {
	                    valueLabel: numberFormat(d.valueFormat)(link.value) + d.valueSuffix
	                  };
	                  hoverItems.push({
	                    x: hoverCenter[0],
	                    y: hoverCenter[1],
	                    name: hovertemplateLabels.valueLabel,
	                    text: [link.label || "", sourceLabel + link.source.label, targetLabel + link.target.label, link.concentrationscale ? concentrationLabel + numberFormat("%0.2f")(link.flow.labelConcentration) : ""].filter(renderableValuePresent).join("<br>"),
	                    color: castHoverOption(obj, "bgcolor") || Color.addOpacity(link.color, 1),
	                    borderColor: castHoverOption(obj, "bordercolor"),
	                    fontFamily: castHoverOption(obj, "font.family"),
	                    fontSize: castHoverOption(obj, "font.size"),
	                    fontColor: castHoverOption(obj, "font.color"),
	                    nameLength: castHoverOption(obj, "namelength"),
	                    textAlign: castHoverOption(obj, "align"),
	                    idealAlign: d3.event.x < hoverCenter[0] ? "right" : "left",
	                    hovertemplate: obj.hovertemplate,
	                    hovertemplateLabels,
	                    eventData: [link]
	                  });
	                }
	                var tooltips = Fx.loneHover(hoverItems, {
	                  container: fullLayout._hoverlayer.node(),
	                  outerContainer: fullLayout._paper.node(),
	                  gd,
	                  anchorIndex
	                });
	                tooltips.each(function() {
	                  var tooltip = this;
	                  if (!d.link.concentrationscale) {
	                    makeTranslucent(tooltip, 0.65);
	                  }
	                  makeTextContrasty(tooltip);
	                });
	              };
	              var linkUnhover = function(element, d, sankey) {
	                if (gd._fullLayout.hovermode === false) return;
	                d3.select(element).call(linkNonHoveredStyle.bind(0, d, sankey, true));
	                if (d.link.trace.link.hoverinfo !== "skip") {
	                  d.link.fullData = d.link.trace;
	                  gd.emit("plotly_unhover", {
	                    event: d3.event,
	                    points: [d.link]
	                  });
	                }
	                Fx.loneUnhover(fullLayout._hoverlayer.node());
	              };
	              var nodeSelect = function(element, d, sankey) {
	                var evt = d.node;
	                evt.originalEvent = d3.event;
	                gd._hoverdata = [evt];
	                d3.select(element).call(nodeNonHoveredStyle, d, sankey);
	                Fx.click(gd, {
	                  target: true
	                });
	              };
	              var nodeHover = function(element, d, sankey) {
	                if (gd._fullLayout.hovermode === false) return;
	                d3.select(element).call(nodeHoveredStyle, d, sankey);
	                if (d.node.trace.node.hoverinfo !== "skip") {
	                  d.node.fullData = d.node.trace;
	                  gd.emit("plotly_hover", {
	                    event: d3.event,
	                    points: [d.node]
	                  });
	                }
	              };
	              var nodeHoverFollow = function(element, d) {
	                if (gd._fullLayout.hovermode === false) return;
	                var obj = d.node.trace.node;
	                if (obj.hoverinfo === "none" || obj.hoverinfo === "skip") return;
	                var nodeRect = d3.select(element).select("." + cn.nodeRect);
	                var rootBBox = gd._fullLayout._paperdiv.node().getBoundingClientRect();
	                var boundingBox = nodeRect.node().getBoundingClientRect();
	                var hoverCenterX0 = boundingBox.left - 2 - rootBBox.left;
	                var hoverCenterX1 = boundingBox.right + 2 - rootBBox.left;
	                var hoverCenterY = boundingBox.top + boundingBox.height / 4 - rootBBox.top;
	                var hovertemplateLabels = {
	                  valueLabel: numberFormat(d.valueFormat)(d.node.value) + d.valueSuffix
	                };
	                d.node.fullData = d.node.trace;
	                gd._fullLayout._calcInverseTransform(gd);
	                var scaleX = gd._fullLayout._invScaleX;
	                var scaleY = gd._fullLayout._invScaleY;
	                var tooltip = Fx.loneHover({
	                  x0: scaleX * hoverCenterX0,
	                  x1: scaleX * hoverCenterX1,
	                  y: scaleY * hoverCenterY,
	                  name: numberFormat(d.valueFormat)(d.node.value) + d.valueSuffix,
	                  text: [d.node.label, incomingLabel + d.node.targetLinks.length, outgoingLabel + d.node.sourceLinks.length].filter(renderableValuePresent).join("<br>"),
	                  color: castHoverOption(obj, "bgcolor") || d.tinyColorHue,
	                  borderColor: castHoverOption(obj, "bordercolor"),
	                  fontFamily: castHoverOption(obj, "font.family"),
	                  fontSize: castHoverOption(obj, "font.size"),
	                  fontColor: castHoverOption(obj, "font.color"),
	                  nameLength: castHoverOption(obj, "namelength"),
	                  textAlign: castHoverOption(obj, "align"),
	                  idealAlign: "left",
	                  hovertemplate: obj.hovertemplate,
	                  hovertemplateLabels,
	                  eventData: [d.node]
	                }, {
	                  container: fullLayout._hoverlayer.node(),
	                  outerContainer: fullLayout._paper.node(),
	                  gd
	                });
	                makeTranslucent(tooltip, 0.85);
	                makeTextContrasty(tooltip);
	              };
	              var nodeUnhover = function(element, d, sankey) {
	                if (gd._fullLayout.hovermode === false) return;
	                d3.select(element).call(nodeNonHoveredStyle, d, sankey);
	                if (d.node.trace.node.hoverinfo !== "skip") {
	                  d.node.fullData = d.node.trace;
	                  gd.emit("plotly_unhover", {
	                    event: d3.event,
	                    points: [d.node]
	                  });
	                }
	                Fx.loneUnhover(fullLayout._hoverlayer.node());
	              };
	              render(gd, svg, calcData, {
	                width: size.w,
	                height: size.h,
	                margin: {
	                  t: size.t,
	                  r: size.r,
	                  b: size.b,
	                  l: size.l
	                }
	              }, {
	                linkEvents: {
	                  hover: linkHover,
	                  follow: linkHoverFollow,
	                  unhover: linkUnhover,
	                  select: linkSelect
	                },
	                nodeEvents: {
	                  hover: nodeHover,
	                  follow: nodeHoverFollow,
	                  unhover: nodeUnhover,
	                  select: nodeSelect
	                }
	              });
	            };
	          }
	        ),
	        /***/
	        3393: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3Force = __webpack_require__2(49887);
	            var interpolateNumber = __webpack_require__2(81684).k4;
	            var d3 = __webpack_require__2(39898);
	            var d3Sankey = __webpack_require__2(30838);
	            var d3SankeyCircular = __webpack_require__2(86781);
	            var c = __webpack_require__2(85247);
	            var tinycolor = __webpack_require__2(84267);
	            var Color = __webpack_require__2(7901);
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var strTranslate = Lib.strTranslate;
	            var strRotate = Lib.strRotate;
	            var gup = __webpack_require__2(28984);
	            var keyFun = gup.keyFun;
	            var repeat = gup.repeat;
	            var unwrap = gup.unwrap;
	            var svgTextUtils = __webpack_require__2(63893);
	            var Registry = __webpack_require__2(73972);
	            var alignmentConstants = __webpack_require__2(18783);
	            var CAP_SHIFT = alignmentConstants.CAP_SHIFT;
	            var LINE_SPACING = alignmentConstants.LINE_SPACING;
	            var TEXTPAD = 3;
	            function sankeyModel(layout, d, traceIndex) {
	              var calcData = unwrap(d);
	              var trace = calcData.trace;
	              var domain = trace.domain;
	              var horizontal = trace.orientation === "h";
	              var nodePad = trace.node.pad;
	              var nodeThickness = trace.node.thickness;
	              var width = layout.width * (domain.x[1] - domain.x[0]);
	              var height = layout.height * (domain.y[1] - domain.y[0]);
	              var nodes = calcData._nodes;
	              var links = calcData._links;
	              var circular = calcData.circular;
	              var sankey;
	              if (circular) {
	                sankey = d3SankeyCircular.sankeyCircular().circularLinkGap(0);
	              } else {
	                sankey = d3Sankey.sankey();
	              }
	              sankey.iterations(c.sankeyIterations).size(horizontal ? [width, height] : [height, width]).nodeWidth(nodeThickness).nodePadding(nodePad).nodeId(function(d2) {
	                return d2.pointNumber;
	              }).nodes(nodes).links(links);
	              var graph = sankey();
	              if (sankey.nodePadding() < nodePad) {
	                Lib.warn("node.pad was reduced to ", sankey.nodePadding(), " to fit within the figure.");
	              }
	              var i, j, k;
	              for (var nodePointNumber in calcData._groupLookup) {
	                var groupIndex = parseInt(calcData._groupLookup[nodePointNumber]);
	                var groupingNode;
	                for (i = 0; i < graph.nodes.length; i++) {
	                  if (graph.nodes[i].pointNumber === groupIndex) {
	                    groupingNode = graph.nodes[i];
	                    break;
	                  }
	                }
	                if (!groupingNode) continue;
	                var child = {
	                  pointNumber: parseInt(nodePointNumber),
	                  x0: groupingNode.x0,
	                  x1: groupingNode.x1,
	                  y0: groupingNode.y0,
	                  y1: groupingNode.y1,
	                  partOfGroup: true,
	                  sourceLinks: [],
	                  targetLinks: []
	                };
	                graph.nodes.unshift(child);
	                groupingNode.childrenNodes.unshift(child);
	              }
	              function computeLinkConcentrations() {
	                for (i = 0; i < graph.nodes.length; i++) {
	                  var node = graph.nodes[i];
	                  var flows = {};
	                  var flowKey;
	                  var link;
	                  for (j = 0; j < node.targetLinks.length; j++) {
	                    link = node.targetLinks[j];
	                    flowKey = link.source.pointNumber + ":" + link.target.pointNumber;
	                    if (!flows.hasOwnProperty(flowKey)) flows[flowKey] = [];
	                    flows[flowKey].push(link);
	                  }
	                  var keys = Object.keys(flows);
	                  for (j = 0; j < keys.length; j++) {
	                    flowKey = keys[j];
	                    var flowLinks = flows[flowKey];
	                    var total = 0;
	                    var totalPerLabel = {};
	                    for (k = 0; k < flowLinks.length; k++) {
	                      link = flowLinks[k];
	                      if (!totalPerLabel[link.label]) totalPerLabel[link.label] = 0;
	                      totalPerLabel[link.label] += link.value;
	                      total += link.value;
	                    }
	                    for (k = 0; k < flowLinks.length; k++) {
	                      link = flowLinks[k];
	                      link.flow = {
	                        value: total,
	                        labelConcentration: totalPerLabel[link.label] / total,
	                        concentration: link.value / total,
	                        links: flowLinks
	                      };
	                      if (link.concentrationscale) {
	                        link.color = tinycolor(link.concentrationscale(link.flow.labelConcentration));
	                      }
	                    }
	                  }
	                  var totalOutflow = 0;
	                  for (j = 0; j < node.sourceLinks.length; j++) {
	                    totalOutflow += node.sourceLinks[j].value;
	                  }
	                  for (j = 0; j < node.sourceLinks.length; j++) {
	                    link = node.sourceLinks[j];
	                    link.concentrationOut = link.value / totalOutflow;
	                  }
	                  var totalInflow = 0;
	                  for (j = 0; j < node.targetLinks.length; j++) {
	                    totalInflow += node.targetLinks[j].value;
	                  }
	                  for (j = 0; j < node.targetLinks.length; j++) {
	                    link = node.targetLinks[j];
	                    link.concenrationIn = link.value / totalInflow;
	                  }
	                }
	              }
	              computeLinkConcentrations();
	              function resolveCollisionsTopToBottom(columns2) {
	                columns2.forEach(function(nodes2) {
	                  var node;
	                  var dy;
	                  var y = 0;
	                  var n = nodes2.length;
	                  var i2;
	                  nodes2.sort(function(a, b) {
	                    return a.y0 - b.y0;
	                  });
	                  for (i2 = 0; i2 < n; ++i2) {
	                    node = nodes2[i2];
	                    if (node.y0 >= y) ; else {
	                      dy = y - node.y0;
	                      if (dy > 1e-6) node.y0 += dy, node.y1 += dy;
	                    }
	                    y = node.y1 + nodePad;
	                  }
	                });
	              }
	              function snapToColumns(nodes2) {
	                var orderedNodes = nodes2.map(function(n, i2) {
	                  return {
	                    x0: n.x0,
	                    index: i2
	                  };
	                }).sort(function(a, b) {
	                  return a.x0 - b.x0;
	                });
	                var columns2 = [];
	                var colNumber = -1;
	                var colX;
	                var lastX = -Infinity;
	                var dx;
	                for (i = 0; i < orderedNodes.length; i++) {
	                  var node = nodes2[orderedNodes[i].index];
	                  if (node.x0 > lastX + nodeThickness) {
	                    colNumber += 1;
	                    colX = node.x0;
	                  }
	                  lastX = node.x0;
	                  if (!columns2[colNumber]) columns2[colNumber] = [];
	                  columns2[colNumber].push(node);
	                  dx = colX - node.x0;
	                  node.x0 += dx, node.x1 += dx;
	                }
	                return columns2;
	              }
	              if (trace.node.x.length && trace.node.y.length) {
	                for (i = 0; i < Math.min(trace.node.x.length, trace.node.y.length, graph.nodes.length); i++) {
	                  if (trace.node.x[i] && trace.node.y[i]) {
	                    var pos = [trace.node.x[i] * width, trace.node.y[i] * height];
	                    graph.nodes[i].x0 = pos[0] - nodeThickness / 2;
	                    graph.nodes[i].x1 = pos[0] + nodeThickness / 2;
	                    var nodeHeight = graph.nodes[i].y1 - graph.nodes[i].y0;
	                    graph.nodes[i].y0 = pos[1] - nodeHeight / 2;
	                    graph.nodes[i].y1 = pos[1] + nodeHeight / 2;
	                  }
	                }
	                if (trace.arrangement === "snap") {
	                  nodes = graph.nodes;
	                  var columns = snapToColumns(nodes);
	                  resolveCollisionsTopToBottom(columns);
	                }
	                sankey.update(graph);
	              }
	              return {
	                circular,
	                key: traceIndex,
	                trace,
	                guid: Lib.randstr(),
	                horizontal,
	                width,
	                height,
	                nodePad: trace.node.pad,
	                nodeLineColor: trace.node.line.color,
	                nodeLineWidth: trace.node.line.width,
	                linkLineColor: trace.link.line.color,
	                linkLineWidth: trace.link.line.width,
	                linkArrowLength: trace.link.arrowlen,
	                valueFormat: trace.valueformat,
	                valueSuffix: trace.valuesuffix,
	                textFont: trace.textfont,
	                translateX: domain.x[0] * layout.width + layout.margin.l,
	                translateY: layout.height - domain.y[1] * layout.height + layout.margin.t,
	                dragParallel: horizontal ? height : width,
	                dragPerpendicular: horizontal ? width : height,
	                arrangement: trace.arrangement,
	                sankey,
	                graph,
	                forceLayouts: {},
	                interactionState: {
	                  dragInProgress: false,
	                  hovered: false
	                }
	              };
	            }
	            function linkModel(d, l, i) {
	              var tc = tinycolor(l.color);
	              var basicKey = l.source.label + "|" + l.target.label;
	              var key = basicKey + "__" + i;
	              l.trace = d.trace;
	              l.curveNumber = d.trace.index;
	              return {
	                circular: d.circular,
	                key,
	                traceId: d.key,
	                pointNumber: l.pointNumber,
	                link: l,
	                tinyColorHue: Color.tinyRGB(tc),
	                tinyColorAlpha: tc.getAlpha(),
	                linkPath,
	                linkLineColor: d.linkLineColor,
	                linkLineWidth: d.linkLineWidth,
	                linkArrowLength: d.linkArrowLength,
	                valueFormat: d.valueFormat,
	                valueSuffix: d.valueSuffix,
	                sankey: d.sankey,
	                parent: d,
	                interactionState: d.interactionState,
	                flow: l.flow
	              };
	            }
	            function createCircularClosedPathString(link, arrowLen) {
	              var pathString = "";
	              var offset = link.width / 2;
	              var coords = link.circularPathData;
	              if (link.circularLinkType === "top") {
	                pathString = // start at the left of the target node
	                "M " + (coords.targetX - arrowLen) + " " + (coords.targetY + offset) + " L" + (coords.rightInnerExtent - arrowLen) + " " + (coords.targetY + offset) + "A" + (coords.rightLargeArcRadius + offset) + " " + (coords.rightSmallArcRadius + offset) + " 0 0 1 " + (coords.rightFullExtent - offset - arrowLen) + " " + (coords.targetY - coords.rightSmallArcRadius) + "L" + (coords.rightFullExtent - offset - arrowLen) + " " + coords.verticalRightInnerExtent + "A" + (coords.rightLargeArcRadius + offset) + " " + (coords.rightLargeArcRadius + offset) + " 0 0 1 " + (coords.rightInnerExtent - arrowLen) + " " + (coords.verticalFullExtent - offset) + "L" + coords.leftInnerExtent + " " + (coords.verticalFullExtent - offset) + "A" + (coords.leftLargeArcRadius + offset) + " " + (coords.leftLargeArcRadius + offset) + " 0 0 1 " + (coords.leftFullExtent + offset) + " " + coords.verticalLeftInnerExtent + "L" + (coords.leftFullExtent + offset) + " " + (coords.sourceY - coords.leftSmallArcRadius) + "A" + (coords.leftLargeArcRadius + offset) + " " + (coords.leftSmallArcRadius + offset) + " 0 0 1 " + coords.leftInnerExtent + " " + (coords.sourceY + offset) + "L" + coords.sourceX + " " + (coords.sourceY + offset) + // Walking back
	                "L" + coords.sourceX + " " + (coords.sourceY - offset) + "L" + coords.leftInnerExtent + " " + (coords.sourceY - offset) + "A" + (coords.leftLargeArcRadius - offset) + " " + (coords.leftSmallArcRadius - offset) + " 0 0 0 " + (coords.leftFullExtent - offset) + " " + (coords.sourceY - coords.leftSmallArcRadius) + "L" + (coords.leftFullExtent - offset) + " " + coords.verticalLeftInnerExtent + "A" + (coords.leftLargeArcRadius - offset) + " " + (coords.leftLargeArcRadius - offset) + " 0 0 0 " + coords.leftInnerExtent + " " + (coords.verticalFullExtent + offset) + "L" + (coords.rightInnerExtent - arrowLen) + " " + (coords.verticalFullExtent + offset) + "A" + (coords.rightLargeArcRadius - offset) + " " + (coords.rightLargeArcRadius - offset) + " 0 0 0 " + (coords.rightFullExtent + offset - arrowLen) + " " + coords.verticalRightInnerExtent + "L" + (coords.rightFullExtent + offset - arrowLen) + " " + (coords.targetY - coords.rightSmallArcRadius) + "A" + (coords.rightLargeArcRadius - offset) + " " + (coords.rightSmallArcRadius - offset) + " 0 0 0 " + (coords.rightInnerExtent - arrowLen) + " " + (coords.targetY - offset) + "L" + (coords.targetX - arrowLen) + " " + (coords.targetY - offset) + (arrowLen > 0 ? "L" + coords.targetX + " " + coords.targetY : "") + "Z";
	              } else {
	                pathString = // start at the left of the target node
	                "M " + (coords.targetX - arrowLen) + " " + (coords.targetY - offset) + " L" + (coords.rightInnerExtent - arrowLen) + " " + (coords.targetY - offset) + "A" + (coords.rightLargeArcRadius + offset) + " " + (coords.rightSmallArcRadius + offset) + " 0 0 0 " + (coords.rightFullExtent - offset - arrowLen) + " " + (coords.targetY + coords.rightSmallArcRadius) + "L" + (coords.rightFullExtent - offset - arrowLen) + " " + coords.verticalRightInnerExtent + "A" + (coords.rightLargeArcRadius + offset) + " " + (coords.rightLargeArcRadius + offset) + " 0 0 0 " + (coords.rightInnerExtent - arrowLen) + " " + (coords.verticalFullExtent + offset) + "L" + coords.leftInnerExtent + " " + (coords.verticalFullExtent + offset) + "A" + (coords.leftLargeArcRadius + offset) + " " + (coords.leftLargeArcRadius + offset) + " 0 0 0 " + (coords.leftFullExtent + offset) + " " + coords.verticalLeftInnerExtent + "L" + (coords.leftFullExtent + offset) + " " + (coords.sourceY + coords.leftSmallArcRadius) + "A" + (coords.leftLargeArcRadius + offset) + " " + (coords.leftSmallArcRadius + offset) + " 0 0 0 " + coords.leftInnerExtent + " " + (coords.sourceY - offset) + "L" + coords.sourceX + " " + (coords.sourceY - offset) + // Walking back
	                "L" + coords.sourceX + " " + (coords.sourceY + offset) + "L" + coords.leftInnerExtent + " " + (coords.sourceY + offset) + "A" + (coords.leftLargeArcRadius - offset) + " " + (coords.leftSmallArcRadius - offset) + " 0 0 1 " + (coords.leftFullExtent - offset) + " " + (coords.sourceY + coords.leftSmallArcRadius) + "L" + (coords.leftFullExtent - offset) + " " + coords.verticalLeftInnerExtent + "A" + (coords.leftLargeArcRadius - offset) + " " + (coords.leftLargeArcRadius - offset) + " 0 0 1 " + coords.leftInnerExtent + " " + (coords.verticalFullExtent - offset) + "L" + (coords.rightInnerExtent - arrowLen) + " " + (coords.verticalFullExtent - offset) + "A" + (coords.rightLargeArcRadius - offset) + " " + (coords.rightLargeArcRadius - offset) + " 0 0 1 " + (coords.rightFullExtent + offset - arrowLen) + " " + coords.verticalRightInnerExtent + "L" + (coords.rightFullExtent + offset - arrowLen) + " " + (coords.targetY + coords.rightSmallArcRadius) + "A" + (coords.rightLargeArcRadius - offset) + " " + (coords.rightSmallArcRadius - offset) + " 0 0 1 " + (coords.rightInnerExtent - arrowLen) + " " + (coords.targetY + offset) + "L" + (coords.targetX - arrowLen) + " " + (coords.targetY + offset) + (arrowLen > 0 ? "L" + coords.targetX + " " + coords.targetY : "") + "Z";
	              }
	              return pathString;
	            }
	            function linkPath() {
	              var curvature = 0.5;
	              function path(d) {
	                var arrowLen = d.linkArrowLength;
	                if (d.link.circular) {
	                  return createCircularClosedPathString(d.link, arrowLen);
	                } else {
	                  var maxArrowLength = Math.abs((d.link.target.x0 - d.link.source.x1) / 2);
	                  if (arrowLen > maxArrowLength) {
	                    arrowLen = maxArrowLength;
	                  }
	                  var x0 = d.link.source.x1;
	                  var x1 = d.link.target.x0 - arrowLen;
	                  var xi = interpolateNumber(x0, x1);
	                  var x2 = xi(curvature);
	                  var x3 = xi(1 - curvature);
	                  var y0a = d.link.y0 - d.link.width / 2;
	                  var y0b = d.link.y0 + d.link.width / 2;
	                  var y1a = d.link.y1 - d.link.width / 2;
	                  var y1b = d.link.y1 + d.link.width / 2;
	                  var start = "M" + x0 + "," + y0a;
	                  var upperCurve = "C" + x2 + "," + y0a + " " + x3 + "," + y1a + " " + x1 + "," + y1a;
	                  var lowerCurve = "C" + x3 + "," + y1b + " " + x2 + "," + y0b + " " + x0 + "," + y0b;
	                  var rightEnd = arrowLen > 0 ? "L" + (x1 + arrowLen) + "," + (y1a + d.link.width / 2) : "";
	                  rightEnd += "L" + x1 + "," + y1b;
	                  return start + upperCurve + rightEnd + lowerCurve + "Z";
	                }
	              }
	              return path;
	            }
	            function nodeModel(d, n) {
	              var tc = tinycolor(n.color);
	              var zoneThicknessPad = c.nodePadAcross;
	              var zoneLengthPad = d.nodePad / 2;
	              n.dx = n.x1 - n.x0;
	              n.dy = n.y1 - n.y0;
	              var visibleThickness = n.dx;
	              var visibleLength = Math.max(0.5, n.dy);
	              var key = "node_" + n.pointNumber;
	              if (n.group) {
	                key = Lib.randstr();
	              }
	              n.trace = d.trace;
	              n.curveNumber = d.trace.index;
	              return {
	                index: n.pointNumber,
	                key,
	                partOfGroup: n.partOfGroup || false,
	                group: n.group,
	                traceId: d.key,
	                trace: d.trace,
	                node: n,
	                nodePad: d.nodePad,
	                nodeLineColor: d.nodeLineColor,
	                nodeLineWidth: d.nodeLineWidth,
	                textFont: d.textFont,
	                size: d.horizontal ? d.height : d.width,
	                visibleWidth: Math.ceil(visibleThickness),
	                visibleHeight: visibleLength,
	                zoneX: -zoneThicknessPad,
	                zoneY: -zoneLengthPad,
	                zoneWidth: visibleThickness + 2 * zoneThicknessPad,
	                zoneHeight: visibleLength + 2 * zoneLengthPad,
	                labelY: d.horizontal ? n.dy / 2 + 1 : n.dx / 2 + 1,
	                left: n.originalLayer === 1,
	                sizeAcross: d.width,
	                forceLayouts: d.forceLayouts,
	                horizontal: d.horizontal,
	                darkBackground: tc.getBrightness() <= 128,
	                tinyColorHue: Color.tinyRGB(tc),
	                tinyColorAlpha: tc.getAlpha(),
	                valueFormat: d.valueFormat,
	                valueSuffix: d.valueSuffix,
	                sankey: d.sankey,
	                graph: d.graph,
	                arrangement: d.arrangement,
	                uniqueNodeLabelPathId: [d.guid, d.key, key].join("_"),
	                interactionState: d.interactionState,
	                figure: d
	              };
	            }
	            function updateNodePositions(sankeyNode) {
	              sankeyNode.attr("transform", function(d) {
	                return strTranslate(d.node.x0.toFixed(3), d.node.y0.toFixed(3));
	              });
	            }
	            function updateNodeShapes(sankeyNode) {
	              sankeyNode.call(updateNodePositions);
	            }
	            function updateShapes(sankeyNode, sankeyLink) {
	              sankeyNode.call(updateNodeShapes);
	              sankeyLink.attr("d", linkPath());
	            }
	            function sizeNode(rect) {
	              rect.attr("width", function(d) {
	                return d.node.x1 - d.node.x0;
	              }).attr("height", function(d) {
	                return d.visibleHeight;
	              });
	            }
	            function salientEnough(d) {
	              return d.link.width > 1 || d.linkLineWidth > 0;
	            }
	            function sankeyTransform(d) {
	              var offset = strTranslate(d.translateX, d.translateY);
	              return offset + (d.horizontal ? "matrix(1 0 0 1 0 0)" : "matrix(0 1 1 0 0 0)");
	            }
	            function attachPointerEvents(selection, sankey, eventSet) {
	              selection.on(".basic", null).on("mouseover.basic", function(d) {
	                if (!d.interactionState.dragInProgress && !d.partOfGroup) {
	                  eventSet.hover(this, d, sankey);
	                  d.interactionState.hovered = [this, d];
	                }
	              }).on("mousemove.basic", function(d) {
	                if (!d.interactionState.dragInProgress && !d.partOfGroup) {
	                  eventSet.follow(this, d);
	                  d.interactionState.hovered = [this, d];
	                }
	              }).on("mouseout.basic", function(d) {
	                if (!d.interactionState.dragInProgress && !d.partOfGroup) {
	                  eventSet.unhover(this, d, sankey);
	                  d.interactionState.hovered = false;
	                }
	              }).on("click.basic", function(d) {
	                if (d.interactionState.hovered) {
	                  eventSet.unhover(this, d, sankey);
	                  d.interactionState.hovered = false;
	                }
	                if (!d.interactionState.dragInProgress && !d.partOfGroup) {
	                  eventSet.select(this, d, sankey);
	                }
	              });
	            }
	            function attachDragHandler(sankeyNode, sankeyLink, callbacks, gd) {
	              var dragBehavior = d3.behavior.drag().origin(function(d) {
	                return {
	                  x: d.node.x0 + d.visibleWidth / 2,
	                  y: d.node.y0 + d.visibleHeight / 2
	                };
	              }).on("dragstart", function(d) {
	                if (d.arrangement === "fixed") return;
	                Lib.ensureSingle(gd._fullLayout._infolayer, "g", "dragcover", function(s) {
	                  gd._fullLayout._dragCover = s;
	                });
	                Lib.raiseToTop(this);
	                d.interactionState.dragInProgress = d.node;
	                saveCurrentDragPosition(d.node);
	                if (d.interactionState.hovered) {
	                  callbacks.nodeEvents.unhover.apply(0, d.interactionState.hovered);
	                  d.interactionState.hovered = false;
	                }
	                if (d.arrangement === "snap") {
	                  var forceKey = d.traceId + "|" + d.key;
	                  if (d.forceLayouts[forceKey]) {
	                    d.forceLayouts[forceKey].alpha(1);
	                  } else {
	                    attachForce(sankeyNode, forceKey, d);
	                  }
	                  startForce(sankeyNode, sankeyLink, d, forceKey, gd);
	                }
	              }).on("drag", function(d) {
	                if (d.arrangement === "fixed") return;
	                var x = d3.event.x;
	                var y = d3.event.y;
	                if (d.arrangement === "snap") {
	                  d.node.x0 = x - d.visibleWidth / 2;
	                  d.node.x1 = x + d.visibleWidth / 2;
	                  d.node.y0 = y - d.visibleHeight / 2;
	                  d.node.y1 = y + d.visibleHeight / 2;
	                } else {
	                  if (d.arrangement === "freeform") {
	                    d.node.x0 = x - d.visibleWidth / 2;
	                    d.node.x1 = x + d.visibleWidth / 2;
	                  }
	                  y = Math.max(0, Math.min(d.size - d.visibleHeight / 2, y));
	                  d.node.y0 = y - d.visibleHeight / 2;
	                  d.node.y1 = y + d.visibleHeight / 2;
	                }
	                saveCurrentDragPosition(d.node);
	                if (d.arrangement !== "snap") {
	                  d.sankey.update(d.graph);
	                  updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
	                }
	              }).on("dragend", function(d) {
	                if (d.arrangement === "fixed") return;
	                d.interactionState.dragInProgress = false;
	                for (var i = 0; i < d.node.childrenNodes.length; i++) {
	                  d.node.childrenNodes[i].x = d.node.x;
	                  d.node.childrenNodes[i].y = d.node.y;
	                }
	                if (d.arrangement !== "snap") persistFinalNodePositions(d, gd);
	              });
	              sankeyNode.on(".drag", null).call(dragBehavior);
	            }
	            function attachForce(sankeyNode, forceKey, d, gd) {
	              switchToForceFormat(d.graph.nodes);
	              var nodes = d.graph.nodes.filter(function(n) {
	                return n.originalX === d.node.originalX;
	              }).filter(function(n) {
	                return !n.partOfGroup;
	              });
	              d.forceLayouts[forceKey] = d3Force.forceSimulation(nodes).alphaDecay(0).force("collide", d3Force.forceCollide().radius(function(n) {
	                return n.dy / 2 + d.nodePad / 2;
	              }).strength(1).iterations(c.forceIterations)).force("constrain", snappingForce(sankeyNode, forceKey, nodes, d)).stop();
	            }
	            function startForce(sankeyNode, sankeyLink, d, forceKey, gd) {
	              window.requestAnimationFrame(function faster() {
	                var i;
	                for (i = 0; i < c.forceTicksPerFrame; i++) {
	                  d.forceLayouts[forceKey].tick();
	                }
	                var nodes = d.graph.nodes;
	                switchToSankeyFormat(nodes);
	                d.sankey.update(d.graph);
	                updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
	                if (d.forceLayouts[forceKey].alpha() > 0) {
	                  window.requestAnimationFrame(faster);
	                } else {
	                  var x = d.node.originalX;
	                  d.node.x0 = x - d.visibleWidth / 2;
	                  d.node.x1 = x + d.visibleWidth / 2;
	                  persistFinalNodePositions(d, gd);
	                }
	              });
	            }
	            function snappingForce(sankeyNode, forceKey, nodes, d) {
	              return function _snappingForce() {
	                var maxVelocity = 0;
	                for (var i = 0; i < nodes.length; i++) {
	                  var n = nodes[i];
	                  if (n === d.interactionState.dragInProgress) {
	                    n.x = n.lastDraggedX;
	                    n.y = n.lastDraggedY;
	                  } else {
	                    n.vx = (n.originalX - n.x) / c.forceTicksPerFrame;
	                    n.y = Math.min(d.size - n.dy / 2, Math.max(n.dy / 2, n.y));
	                  }
	                  maxVelocity = Math.max(maxVelocity, Math.abs(n.vx), Math.abs(n.vy));
	                }
	                if (!d.interactionState.dragInProgress && maxVelocity < 0.1 && d.forceLayouts[forceKey].alpha() > 0) {
	                  d.forceLayouts[forceKey].alpha(0);
	                }
	              };
	            }
	            function persistFinalNodePositions(d, gd) {
	              var x = [];
	              var y = [];
	              for (var i = 0; i < d.graph.nodes.length; i++) {
	                var nodeX = (d.graph.nodes[i].x0 + d.graph.nodes[i].x1) / 2;
	                var nodeY = (d.graph.nodes[i].y0 + d.graph.nodes[i].y1) / 2;
	                x.push(nodeX / d.figure.width);
	                y.push(nodeY / d.figure.height);
	              }
	              Registry.call("_guiRestyle", gd, {
	                "node.x": [x],
	                "node.y": [y]
	              }, d.trace.index).then(function() {
	                if (gd._fullLayout._dragCover) gd._fullLayout._dragCover.remove();
	              });
	            }
	            function persistOriginalPlace(nodes) {
	              var distinctLayerPositions = [];
	              var i;
	              for (i = 0; i < nodes.length; i++) {
	                nodes[i].originalX = (nodes[i].x0 + nodes[i].x1) / 2;
	                nodes[i].originalY = (nodes[i].y0 + nodes[i].y1) / 2;
	                if (distinctLayerPositions.indexOf(nodes[i].originalX) === -1) {
	                  distinctLayerPositions.push(nodes[i].originalX);
	                }
	              }
	              distinctLayerPositions.sort(function(a, b) {
	                return a - b;
	              });
	              for (i = 0; i < nodes.length; i++) {
	                nodes[i].originalLayerIndex = distinctLayerPositions.indexOf(nodes[i].originalX);
	                nodes[i].originalLayer = nodes[i].originalLayerIndex / (distinctLayerPositions.length - 1);
	              }
	            }
	            function saveCurrentDragPosition(d) {
	              d.lastDraggedX = d.x0 + d.dx / 2;
	              d.lastDraggedY = d.y0 + d.dy / 2;
	            }
	            function sameLayer(d) {
	              return function(n) {
	                return n.node.originalX === d.node.originalX;
	              };
	            }
	            function switchToForceFormat(nodes) {
	              for (var i = 0; i < nodes.length; i++) {
	                nodes[i].y = (nodes[i].y0 + nodes[i].y1) / 2;
	                nodes[i].x = (nodes[i].x0 + nodes[i].x1) / 2;
	              }
	            }
	            function switchToSankeyFormat(nodes) {
	              for (var i = 0; i < nodes.length; i++) {
	                nodes[i].y0 = nodes[i].y - nodes[i].dy / 2;
	                nodes[i].y1 = nodes[i].y0 + nodes[i].dy;
	                nodes[i].x0 = nodes[i].x - nodes[i].dx / 2;
	                nodes[i].x1 = nodes[i].x0 + nodes[i].dx;
	              }
	            }
	            module2.exports = function(gd, svg, calcData, layout, callbacks) {
	              var isStatic = gd._context.staticPlot;
	              var firstRender = false;
	              Lib.ensureSingle(gd._fullLayout._infolayer, "g", "first-render", function() {
	                firstRender = true;
	              });
	              var dragcover = gd._fullLayout._dragCover;
	              var styledData = calcData.filter(function(d) {
	                return unwrap(d).trace.visible;
	              }).map(sankeyModel.bind(null, layout));
	              var sankey = svg.selectAll("." + c.cn.sankey).data(styledData, keyFun);
	              sankey.exit().remove();
	              sankey.enter().append("g").classed(c.cn.sankey, true).style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("shape-rendering", "geometricPrecision").style("pointer-events", isStatic ? "none" : "auto").attr("transform", sankeyTransform);
	              sankey.each(function(d, i) {
	                gd._fullData[i]._sankey = d;
	                var dragboxClassName = "bgsankey-" + d.trace.uid + "-" + i;
	                Lib.ensureSingle(gd._fullLayout._draggers, "rect", dragboxClassName);
	                gd._fullData[i]._bgRect = d3.select("." + dragboxClassName);
	                gd._fullData[i]._bgRect.style("pointer-events", isStatic ? "none" : "all").attr("width", d.width).attr("height", d.height).attr("x", d.translateX).attr("y", d.translateY).classed("bgsankey", true).style({
	                  fill: "transparent",
	                  "stroke-width": 0
	                });
	              });
	              sankey.transition().ease(c.ease).duration(c.duration).attr("transform", sankeyTransform);
	              var sankeyLinks = sankey.selectAll("." + c.cn.sankeyLinks).data(repeat, keyFun);
	              sankeyLinks.enter().append("g").classed(c.cn.sankeyLinks, true).style("fill", "none");
	              var sankeyLink = sankeyLinks.selectAll("." + c.cn.sankeyLink).data(function(d) {
	                var links = d.graph.links;
	                return links.filter(function(l) {
	                  return l.value;
	                }).map(linkModel.bind(null, d));
	              }, keyFun);
	              sankeyLink.enter().append("path").classed(c.cn.sankeyLink, true).call(attachPointerEvents, sankey, callbacks.linkEvents);
	              sankeyLink.style("stroke", function(d) {
	                return salientEnough(d) ? Color.tinyRGB(tinycolor(d.linkLineColor)) : d.tinyColorHue;
	              }).style("stroke-opacity", function(d) {
	                return salientEnough(d) ? Color.opacity(d.linkLineColor) : d.tinyColorAlpha;
	              }).style("fill", function(d) {
	                return d.tinyColorHue;
	              }).style("fill-opacity", function(d) {
	                return d.tinyColorAlpha;
	              }).style("stroke-width", function(d) {
	                return salientEnough(d) ? d.linkLineWidth : 1;
	              }).attr("d", linkPath());
	              sankeyLink.style("opacity", function() {
	                return gd._context.staticPlot || firstRender || dragcover ? 1 : 0;
	              }).transition().ease(c.ease).duration(c.duration).style("opacity", 1);
	              sankeyLink.exit().transition().ease(c.ease).duration(c.duration).style("opacity", 0).remove();
	              var sankeyNodeSet = sankey.selectAll("." + c.cn.sankeyNodeSet).data(repeat, keyFun);
	              sankeyNodeSet.enter().append("g").classed(c.cn.sankeyNodeSet, true);
	              sankeyNodeSet.style("cursor", function(d) {
	                switch (d.arrangement) {
	                  case "fixed":
	                    return "default";
	                  case "perpendicular":
	                    return "ns-resize";
	                  default:
	                    return "move";
	                }
	              });
	              var sankeyNode = sankeyNodeSet.selectAll("." + c.cn.sankeyNode).data(function(d) {
	                var nodes = d.graph.nodes;
	                persistOriginalPlace(nodes);
	                return nodes.map(nodeModel.bind(null, d));
	              }, keyFun);
	              sankeyNode.enter().append("g").classed(c.cn.sankeyNode, true).call(updateNodePositions).style("opacity", function(n) {
	                return (gd._context.staticPlot || firstRender) && !n.partOfGroup ? 1 : 0;
	              });
	              sankeyNode.call(attachPointerEvents, sankey, callbacks.nodeEvents).call(attachDragHandler, sankeyLink, callbacks, gd);
	              sankeyNode.transition().ease(c.ease).duration(c.duration).call(updateNodePositions).style("opacity", function(n) {
	                return n.partOfGroup ? 0 : 1;
	              });
	              sankeyNode.exit().transition().ease(c.ease).duration(c.duration).style("opacity", 0).remove();
	              var nodeRect = sankeyNode.selectAll("." + c.cn.nodeRect).data(repeat);
	              nodeRect.enter().append("rect").classed(c.cn.nodeRect, true).call(sizeNode);
	              nodeRect.style("stroke-width", function(d) {
	                return d.nodeLineWidth;
	              }).style("stroke", function(d) {
	                return Color.tinyRGB(tinycolor(d.nodeLineColor));
	              }).style("stroke-opacity", function(d) {
	                return Color.opacity(d.nodeLineColor);
	              }).style("fill", function(d) {
	                return d.tinyColorHue;
	              }).style("fill-opacity", function(d) {
	                return d.tinyColorAlpha;
	              });
	              nodeRect.transition().ease(c.ease).duration(c.duration).call(sizeNode);
	              var nodeLabel = sankeyNode.selectAll("." + c.cn.nodeLabel).data(repeat);
	              nodeLabel.enter().append("text").classed(c.cn.nodeLabel, true).style("cursor", "default");
	              nodeLabel.attr("data-notex", 1).text(function(d) {
	                return d.node.label;
	              }).each(function(d) {
	                var e = d3.select(this);
	                Drawing.font(e, d.textFont);
	                svgTextUtils.convertToTspans(e, gd);
	              }).style("text-shadow", svgTextUtils.makeTextShadow(gd._fullLayout.paper_bgcolor)).attr("text-anchor", function(d) {
	                return d.horizontal && d.left ? "end" : "start";
	              }).attr("transform", function(d) {
	                var e = d3.select(this);
	                var nLines = svgTextUtils.lineCount(e);
	                var blockHeight = d.textFont.size * ((nLines - 1) * LINE_SPACING - CAP_SHIFT);
	                var posX = d.nodeLineWidth / 2 + TEXTPAD;
	                var posY = ((d.horizontal ? d.visibleHeight : d.visibleWidth) - blockHeight) / 2;
	                if (d.horizontal) {
	                  if (d.left) {
	                    posX = -posX;
	                  } else {
	                    posX += d.visibleWidth;
	                  }
	                }
	                var flipText = d.horizontal ? "" : "scale(-1,1)" + strRotate(90);
	                return strTranslate(d.horizontal ? posX : posY, d.horizontal ? posY : posX) + flipText;
	              });
	              nodeLabel.transition().ease(c.ease).duration(c.duration);
	            };
	          }
	        ),
	        /***/
	        84564: (
	          /***/
	          function(module2) {
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var selection = [];
	              var fullData = cd[0].trace;
	              var nodes = fullData._sankey.graph.nodes;
	              for (var i = 0; i < nodes.length; i++) {
	                var node = nodes[i];
	                if (node.partOfGroup) continue;
	                var pos = [(node.x0 + node.x1) / 2, (node.y0 + node.y1) / 2];
	                if (fullData.orientation === "v") pos.reverse();
	                if (selectionTester && selectionTester.contains(pos, false, i, searchInfo)) {
	                  selection.push({
	                    pointNumber: node.pointNumber
	                    // TODO: add eventData
	                  });
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        75225: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function arraysToCalcdata(cd, trace) {
	              for (var i = 0; i < cd.length; i++) cd[i].i = i;
	              Lib.mergeArray(trace.text, cd, "tx");
	              Lib.mergeArray(trace.texttemplate, cd, "txt");
	              Lib.mergeArray(trace.hovertext, cd, "htx");
	              Lib.mergeArray(trace.customdata, cd, "data");
	              Lib.mergeArray(trace.textposition, cd, "tp");
	              if (trace.textfont) {
	                Lib.mergeArrayCastPositive(trace.textfont.size, cd, "ts");
	                Lib.mergeArray(trace.textfont.color, cd, "tc");
	                Lib.mergeArray(trace.textfont.family, cd, "tf");
	              }
	              var marker = trace.marker;
	              if (marker) {
	                Lib.mergeArrayCastPositive(marker.size, cd, "ms");
	                Lib.mergeArrayCastPositive(marker.opacity, cd, "mo");
	                Lib.mergeArray(marker.symbol, cd, "mx");
	                Lib.mergeArray(marker.angle, cd, "ma");
	                Lib.mergeArray(marker.standoff, cd, "mf");
	                Lib.mergeArray(marker.color, cd, "mc");
	                var markerLine = marker.line;
	                if (marker.line) {
	                  Lib.mergeArray(markerLine.color, cd, "mlc");
	                  Lib.mergeArrayCastPositive(markerLine.width, cd, "mlw");
	                }
	                var markerGradient = marker.gradient;
	                if (markerGradient && markerGradient.type !== "none") {
	                  Lib.mergeArray(markerGradient.type, cd, "mgt");
	                  Lib.mergeArray(markerGradient.color, cd, "mgc");
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        82196: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var fontAttrs = __webpack_require__2(41940);
	            var dash = __webpack_require__2(79952).P;
	            var pattern = __webpack_require__2(79952).u;
	            var Drawing = __webpack_require__2(91424);
	            var constants = __webpack_require__2(47581);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            function axisPeriod(axis) {
	              return {
	                valType: "any",
	                dflt: 0,
	                editType: "calc"
	              };
	            }
	            function axisPeriod0(axis) {
	              return {
	                valType: "any",
	                editType: "calc"
	              };
	            }
	            function axisPeriodAlignment(axis) {
	              return {
	                valType: "enumerated",
	                values: ["start", "middle", "end"],
	                dflt: "middle",
	                editType: "calc"
	              };
	            }
	            module2.exports = {
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes",
	                anim: true
	              },
	              x0: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc+clearAxisTypes",
	                anim: true
	              },
	              dx: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc",
	                anim: true
	              },
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes",
	                anim: true
	              },
	              y0: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc+clearAxisTypes",
	                anim: true
	              },
	              dy: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc",
	                anim: true
	              },
	              xperiod: axisPeriod(),
	              yperiod: axisPeriod(),
	              xperiod0: axisPeriod0(),
	              yperiod0: axisPeriod0(),
	              xperiodalignment: axisPeriodAlignment(),
	              yperiodalignment: axisPeriodAlignment(),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              offsetgroup: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              alignmentgroup: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              stackgroup: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              orientation: {
	                valType: "enumerated",
	                values: ["v", "h"],
	                editType: "calc"
	              },
	              groupnorm: {
	                valType: "enumerated",
	                values: ["", "fraction", "percent"],
	                dflt: "",
	                editType: "calc"
	              },
	              stackgaps: {
	                valType: "enumerated",
	                values: ["infer zero", "interpolate"],
	                dflt: "infer zero",
	                editType: "calc"
	              },
	              text: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "calc"
	              },
	              texttemplate: texttemplateAttrs({}, {}),
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true,
	                editType: "style"
	              },
	              mode: {
	                valType: "flaglist",
	                flags: ["lines", "markers", "text"],
	                extras: ["none"],
	                editType: "calc"
	              },
	              hoveron: {
	                valType: "flaglist",
	                flags: ["points", "fills"],
	                editType: "style"
	              },
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              line: {
	                color: {
	                  valType: "color",
	                  editType: "style",
	                  anim: true
	                },
	                width: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 2,
	                  editType: "style",
	                  anim: true
	                },
	                shape: {
	                  valType: "enumerated",
	                  values: ["linear", "spline", "hv", "vh", "hvh", "vhv"],
	                  dflt: "linear",
	                  editType: "plot"
	                },
	                smoothing: {
	                  valType: "number",
	                  min: 0,
	                  max: 1.3,
	                  dflt: 1,
	                  editType: "plot"
	                },
	                dash: extendFlat({}, dash, {
	                  editType: "style"
	                }),
	                backoff: {
	                  // we want to have a similar option for the start of the line
	                  valType: "number",
	                  min: 0,
	                  dflt: "auto",
	                  arrayOk: true,
	                  editType: "plot"
	                },
	                simplify: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              connectgaps: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              cliponaxis: {
	                valType: "boolean",
	                dflt: true,
	                editType: "plot"
	              },
	              fill: {
	                valType: "enumerated",
	                values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"],
	                editType: "calc"
	              },
	              fillcolor: {
	                valType: "color",
	                editType: "style",
	                anim: true
	              },
	              fillpattern: pattern,
	              marker: extendFlat({
	                symbol: {
	                  valType: "enumerated",
	                  values: Drawing.symbolList,
	                  dflt: "circle",
	                  arrayOk: true,
	                  editType: "style"
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  arrayOk: true,
	                  editType: "style",
	                  anim: true
	                },
	                angle: {
	                  valType: "angle",
	                  dflt: 0,
	                  arrayOk: true,
	                  editType: "plot",
	                  anim: false
	                  // TODO: possibly set to true in future
	                },
	                angleref: {
	                  valType: "enumerated",
	                  values: ["previous", "up"],
	                  dflt: "up",
	                  editType: "plot",
	                  anim: false
	                },
	                standoff: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  arrayOk: true,
	                  editType: "plot",
	                  anim: true
	                },
	                size: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 6,
	                  arrayOk: true,
	                  editType: "calc",
	                  anim: true
	                },
	                maxdisplayed: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "plot"
	                },
	                sizeref: {
	                  valType: "number",
	                  dflt: 1,
	                  editType: "calc"
	                },
	                sizemin: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "calc"
	                },
	                sizemode: {
	                  valType: "enumerated",
	                  values: ["diameter", "area"],
	                  dflt: "diameter",
	                  editType: "calc"
	                },
	                line: extendFlat({
	                  width: {
	                    valType: "number",
	                    min: 0,
	                    arrayOk: true,
	                    editType: "style",
	                    anim: true
	                  },
	                  editType: "calc"
	                }, colorScaleAttrs("marker.line", {
	                  anim: true
	                })),
	                gradient: {
	                  type: {
	                    valType: "enumerated",
	                    values: ["radial", "horizontal", "vertical", "none"],
	                    arrayOk: true,
	                    dflt: "none",
	                    editType: "calc"
	                  },
	                  color: {
	                    valType: "color",
	                    arrayOk: true,
	                    editType: "calc"
	                  },
	                  editType: "calc"
	                },
	                editType: "calc"
	              }, colorScaleAttrs("marker", {
	                anim: true
	              })),
	              selected: {
	                marker: {
	                  opacity: {
	                    valType: "number",
	                    min: 0,
	                    max: 1,
	                    editType: "style"
	                  },
	                  color: {
	                    valType: "color",
	                    editType: "style"
	                  },
	                  size: {
	                    valType: "number",
	                    min: 0,
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                textfont: {
	                  color: {
	                    valType: "color",
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                editType: "style"
	              },
	              unselected: {
	                marker: {
	                  opacity: {
	                    valType: "number",
	                    min: 0,
	                    max: 1,
	                    editType: "style"
	                  },
	                  color: {
	                    valType: "color",
	                    editType: "style"
	                  },
	                  size: {
	                    valType: "number",
	                    min: 0,
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                textfont: {
	                  color: {
	                    valType: "color",
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                editType: "style"
	              },
	              textposition: {
	                valType: "enumerated",
	                values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
	                dflt: "middle center",
	                arrayOk: true,
	                editType: "calc"
	              },
	              textfont: fontAttrs({
	                editType: "calc",
	                colorEditType: "style",
	                arrayOk: true
	              })
	            };
	          }
	        ),
	        /***/
	        47761: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var subTypes = __webpack_require__2(34098);
	            var calcColorscale = __webpack_require__2(36922);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var xa = trace._xA = Axes.getFromId(gd, trace.xaxis || "x", "x");
	              var ya = trace._yA = Axes.getFromId(gd, trace.yaxis || "y", "y");
	              var origX = xa.makeCalcdata(trace, "x");
	              var origY = ya.makeCalcdata(trace, "y");
	              var xObj = alignPeriod(trace, xa, "x", origX);
	              var yObj = alignPeriod(trace, ya, "y", origY);
	              var x = xObj.vals;
	              var y = yObj.vals;
	              var serieslen = trace._length;
	              var cd = new Array(serieslen);
	              var ids = trace.ids;
	              var stackGroupOpts = getStackOpts(trace, fullLayout, xa, ya);
	              var interpolateGaps = false;
	              var isV, i, j, k, interpolate, vali;
	              setFirstScatter(fullLayout, trace);
	              var xAttr = "x";
	              var yAttr = "y";
	              var posAttr;
	              if (stackGroupOpts) {
	                Lib.pushUnique(stackGroupOpts.traceIndices, trace._expandedIndex);
	                isV = stackGroupOpts.orientation === "v";
	                if (isV) {
	                  yAttr = "s";
	                  posAttr = "x";
	                } else {
	                  xAttr = "s";
	                  posAttr = "y";
	                }
	                interpolate = stackGroupOpts.stackgaps === "interpolate";
	              } else {
	                var ppad = calcMarkerSize(trace, serieslen);
	                calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
	              }
	              var hasPeriodX = !!trace.xperiodalignment;
	              var hasPeriodY = !!trace.yperiodalignment;
	              for (i = 0; i < serieslen; i++) {
	                var cdi = cd[i] = {};
	                var xValid = isNumeric(x[i]);
	                var yValid = isNumeric(y[i]);
	                if (xValid && yValid) {
	                  cdi[xAttr] = x[i];
	                  cdi[yAttr] = y[i];
	                  if (hasPeriodX) {
	                    cdi.orig_x = origX[i];
	                    cdi.xEnd = xObj.ends[i];
	                    cdi.xStart = xObj.starts[i];
	                  }
	                  if (hasPeriodY) {
	                    cdi.orig_y = origY[i];
	                    cdi.yEnd = yObj.ends[i];
	                    cdi.yStart = yObj.starts[i];
	                  }
	                } else if (stackGroupOpts && (isV ? xValid : yValid)) {
	                  cdi[posAttr] = isV ? x[i] : y[i];
	                  cdi.gap = true;
	                  if (interpolate) {
	                    cdi.s = BADNUM;
	                    interpolateGaps = true;
	                  } else {
	                    cdi.s = 0;
	                  }
	                } else {
	                  cdi[xAttr] = cdi[yAttr] = BADNUM;
	                }
	                if (ids) {
	                  cdi.id = String(ids[i]);
	                }
	              }
	              arraysToCalcdata(cd, trace);
	              calcColorscale(gd, trace);
	              calcSelection(cd, trace);
	              if (stackGroupOpts) {
	                i = 0;
	                while (i < cd.length) {
	                  if (cd[i][posAttr] === BADNUM) {
	                    cd.splice(i, 1);
	                  } else i++;
	                }
	                Lib.sort(cd, function(a, b) {
	                  return a[posAttr] - b[posAttr] || a.i - b.i;
	                });
	                if (interpolateGaps) {
	                  i = 0;
	                  while (i < cd.length - 1 && cd[i].gap) {
	                    i++;
	                  }
	                  vali = cd[i].s;
	                  if (!vali) vali = cd[i].s = 0;
	                  for (j = 0; j < i; j++) {
	                    cd[j].s = vali;
	                  }
	                  k = cd.length - 1;
	                  while (k > i && cd[k].gap) {
	                    k--;
	                  }
	                  vali = cd[k].s;
	                  for (j = cd.length - 1; j > k; j--) {
	                    cd[j].s = vali;
	                  }
	                  while (i < k) {
	                    i++;
	                    if (cd[i].gap) {
	                      j = i + 1;
	                      while (cd[j].gap) {
	                        j++;
	                      }
	                      var pos0 = cd[i - 1][posAttr];
	                      var size0 = cd[i - 1].s;
	                      var m = (cd[j].s - size0) / (cd[j][posAttr] - pos0);
	                      while (i < j) {
	                        cd[i].s = size0 + (cd[i][posAttr] - pos0) * m;
	                        i++;
	                      }
	                    }
	                  }
	                }
	              }
	              return cd;
	            }
	            function calcAxisExpansion(gd, trace, xa, ya, x, y, ppad) {
	              var serieslen = trace._length;
	              var fullLayout = gd._fullLayout;
	              var xId = xa._id;
	              var yId = ya._id;
	              var firstScatter = fullLayout._firstScatter[firstScatterGroup(trace)] === trace.uid;
	              var stackOrientation = (getStackOpts(trace, fullLayout, xa, ya) || {}).orientation;
	              var fill = trace.fill;
	              xa._minDtick = 0;
	              ya._minDtick = 0;
	              var xOptions = {
	                padded: true
	              };
	              var yOptions = {
	                padded: true
	              };
	              if (ppad) {
	                xOptions.ppad = yOptions.ppad = ppad;
	              }
	              var openEnded = serieslen < 2 || x[0] !== x[serieslen - 1] || y[0] !== y[serieslen - 1];
	              if (openEnded && (fill === "tozerox" || fill === "tonextx" && (firstScatter || stackOrientation === "h"))) {
	                xOptions.tozero = true;
	              } else if (!(trace.error_y || {}).visible && // if no error bars, markers or text, or fill to y=0 remove x padding
	              (fill === "tonexty" || fill === "tozeroy" || !subTypes.hasMarkers(trace) && !subTypes.hasText(trace))) {
	                xOptions.padded = false;
	                xOptions.ppad = 0;
	              }
	              if (openEnded && (fill === "tozeroy" || fill === "tonexty" && (firstScatter || stackOrientation === "v"))) {
	                yOptions.tozero = true;
	              } else if (fill === "tonextx" || fill === "tozerox") {
	                yOptions.padded = false;
	              }
	              if (xId) trace._extremes[xId] = Axes.findExtremes(xa, x, xOptions);
	              if (yId) trace._extremes[yId] = Axes.findExtremes(ya, y, yOptions);
	            }
	            function calcMarkerSize(trace, serieslen) {
	              if (!subTypes.hasMarkers(trace)) return;
	              var marker = trace.marker;
	              var sizeref = 1.6 * (trace.marker.sizeref || 1);
	              var markerTrans;
	              if (trace.marker.sizemode === "area") {
	                markerTrans = function(v) {
	                  return Math.max(Math.sqrt((v || 0) / sizeref), 3);
	                };
	              } else {
	                markerTrans = function(v) {
	                  return Math.max((v || 0) / sizeref, 3);
	                };
	              }
	              if (Lib.isArrayOrTypedArray(marker.size)) {
	                var ax = {
	                  type: "linear"
	                };
	                Axes.setConvert(ax);
	                var s = ax.makeCalcdata(trace.marker, "size");
	                var sizeOut = new Array(serieslen);
	                for (var i = 0; i < serieslen; i++) {
	                  sizeOut[i] = markerTrans(s[i]);
	                }
	                return sizeOut;
	              } else {
	                return markerTrans(marker.size);
	              }
	            }
	            function setFirstScatter(fullLayout, trace) {
	              var group = firstScatterGroup(trace);
	              var firstScatter = fullLayout._firstScatter;
	              if (!firstScatter[group]) firstScatter[group] = trace.uid;
	            }
	            function firstScatterGroup(trace) {
	              var stackGroup = trace.stackgroup;
	              return trace.xaxis + trace.yaxis + trace.type + (stackGroup ? "-" + stackGroup : "");
	            }
	            function getStackOpts(trace, fullLayout, xa, ya) {
	              var stackGroup = trace.stackgroup;
	              if (!stackGroup) return;
	              var stackOpts = fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup];
	              var stackAx = stackOpts.orientation === "v" ? ya : xa;
	              if (stackAx.type === "linear" || stackAx.type === "log") return stackOpts;
	            }
	            module2.exports = {
	              calc,
	              calcMarkerSize,
	              calcAxisExpansion,
	              setFirstScatter,
	              getStackOpts
	            };
	          }
	        ),
	        /***/
	        66279: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function calcSelection(cd, trace) {
	              if (Lib.isArrayOrTypedArray(trace.selectedpoints)) {
	                Lib.tagSelected(cd, trace);
	              }
	            };
	          }
	        ),
	        /***/
	        36922: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var calcColorscale = __webpack_require__2(78803);
	            var subTypes = __webpack_require__2(34098);
	            module2.exports = function calcMarkerColorscale(gd, trace) {
	              if (subTypes.hasLines(trace) && hasColorscale(trace, "line")) {
	                calcColorscale(gd, trace, {
	                  vals: trace.line.color,
	                  containerStr: "line",
	                  cLetter: "c"
	                });
	              }
	              if (subTypes.hasMarkers(trace)) {
	                if (hasColorscale(trace, "marker")) {
	                  calcColorscale(gd, trace, {
	                    vals: trace.marker.color,
	                    containerStr: "marker",
	                    cLetter: "c"
	                  });
	                }
	                if (hasColorscale(trace, "marker.line")) {
	                  calcColorscale(gd, trace, {
	                    vals: trace.marker.line.color,
	                    containerStr: "marker.line",
	                    cLetter: "c"
	                  });
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        47581: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              PTS_LINESONLY: 20,
	              // fixed parameters of clustering and clipping algorithms
	              // fraction of clustering tolerance "so close we don't even consider it a new point"
	              minTolerance: 0.2,
	              // how fast does clustering tolerance increase as you get away from the visible region
	              toleranceGrowth: 10,
	              // number of viewport sizes away from the visible region
	              // at which we clip all lines to the perimeter
	              maxScreensAway: 20,
	              eventDataKeys: []
	            };
	          }
	        ),
	        /***/
	        72626: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var calc = __webpack_require__2(47761);
	            var setGroupPositions = __webpack_require__2(11661).setGroupPositions;
	            function groupCrossTraceCalc(gd, plotinfo) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var fullLayout = gd._fullLayout;
	              var fullTraces = gd._fullData;
	              var calcTraces = gd.calcdata;
	              var calcTracesHorz = [];
	              var calcTracesVert = [];
	              for (var i = 0; i < fullTraces.length; i++) {
	                var fullTrace = fullTraces[i];
	                if (fullTrace.visible === true && fullTrace.type === "scatter" && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id) {
	                  if (fullTrace.orientation === "h") {
	                    calcTracesHorz.push(calcTraces[i]);
	                  } else if (fullTrace.orientation === "v") {
	                    calcTracesVert.push(calcTraces[i]);
	                  }
	                }
	              }
	              var opts = {
	                mode: fullLayout.scattermode,
	                gap: fullLayout.scattergap
	              };
	              setGroupPositions(gd, xa, ya, calcTracesVert, opts);
	              setGroupPositions(gd, ya, xa, calcTracesHorz, opts);
	            }
	            module2.exports = function crossTraceCalc(gd, plotinfo) {
	              if (gd._fullLayout.scattermode === "group") {
	                groupCrossTraceCalc(gd, plotinfo);
	              }
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var subplot = xa._id + ya._id;
	              var subplotStackOpts = gd._fullLayout._scatterStackOpts[subplot];
	              if (!subplotStackOpts) return;
	              var calcTraces = gd.calcdata;
	              var i, j, k, i2, cd, cd0, posj, sumj, norm;
	              var groupOpts, interpolate, groupnorm, posAttr, valAttr;
	              var hasAnyBlanks;
	              for (var stackGroup in subplotStackOpts) {
	                groupOpts = subplotStackOpts[stackGroup];
	                var indices = groupOpts.traceIndices;
	                if (!indices.length) continue;
	                interpolate = groupOpts.stackgaps === "interpolate";
	                groupnorm = groupOpts.groupnorm;
	                if (groupOpts.orientation === "v") {
	                  posAttr = "x";
	                  valAttr = "y";
	                } else {
	                  posAttr = "y";
	                  valAttr = "x";
	                }
	                hasAnyBlanks = new Array(indices.length);
	                for (i = 0; i < hasAnyBlanks.length; i++) {
	                  hasAnyBlanks[i] = false;
	                }
	                cd0 = calcTraces[indices[0]];
	                var allPositions = new Array(cd0.length);
	                for (i = 0; i < cd0.length; i++) {
	                  allPositions[i] = cd0[i][posAttr];
	                }
	                for (i = 1; i < indices.length; i++) {
	                  cd = calcTraces[indices[i]];
	                  for (j = k = 0; j < cd.length; j++) {
	                    posj = cd[j][posAttr];
	                    for (; posj > allPositions[k] && k < allPositions.length; k++) {
	                      insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
	                      j++;
	                    }
	                    if (posj !== allPositions[k]) {
	                      for (i2 = 0; i2 < i; i2++) {
	                        insertBlank(calcTraces[indices[i2]], k, posj, i2, hasAnyBlanks, interpolate, posAttr);
	                      }
	                      allPositions.splice(k, 0, posj);
	                    }
	                    k++;
	                  }
	                  for (; k < allPositions.length; k++) {
	                    insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
	                    j++;
	                  }
	                }
	                var serieslen = allPositions.length;
	                for (j = 0; j < cd0.length; j++) {
	                  sumj = cd0[j][valAttr] = cd0[j].s;
	                  for (i = 1; i < indices.length; i++) {
	                    cd = calcTraces[indices[i]];
	                    cd[0].trace._rawLength = cd[0].trace._length;
	                    cd[0].trace._length = serieslen;
	                    sumj += cd[j].s;
	                    cd[j][valAttr] = sumj;
	                  }
	                  if (groupnorm) {
	                    norm = (groupnorm === "fraction" ? sumj : sumj / 100) || 1;
	                    for (i = 0; i < indices.length; i++) {
	                      var cdj = calcTraces[indices[i]][j];
	                      cdj[valAttr] /= norm;
	                      cdj.sNorm = cdj.s / norm;
	                    }
	                  }
	                }
	                for (i = 0; i < indices.length; i++) {
	                  cd = calcTraces[indices[i]];
	                  var trace = cd[0].trace;
	                  var ppad = calc.calcMarkerSize(trace, trace._rawLength);
	                  var arrayPad = Array.isArray(ppad);
	                  if (ppad && hasAnyBlanks[i] || arrayPad) {
	                    var ppadRaw = ppad;
	                    ppad = new Array(serieslen);
	                    for (j = 0; j < serieslen; j++) {
	                      ppad[j] = cd[j].gap ? 0 : arrayPad ? ppadRaw[cd[j].i] : ppadRaw;
	                    }
	                  }
	                  var x = new Array(serieslen);
	                  var y = new Array(serieslen);
	                  for (j = 0; j < serieslen; j++) {
	                    x[j] = cd[j].x;
	                    y[j] = cd[j].y;
	                  }
	                  calc.calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
	                  cd[0].t.orientation = groupOpts.orientation;
	                }
	              }
	            };
	            function insertBlank(calcTrace, index, position, traceIndex, hasAnyBlanks, interpolate, posAttr) {
	              hasAnyBlanks[traceIndex] = true;
	              var newEntry = {
	                i: null,
	                gap: true,
	                s: 0
	              };
	              newEntry[posAttr] = position;
	              calcTrace.splice(index, 0, newEntry);
	              if (index && position === calcTrace[index - 1][posAttr]) {
	                var prevEntry = calcTrace[index - 1];
	                newEntry.s = prevEntry.s;
	                newEntry.i = prevEntry.i;
	                newEntry.gap = prevEntry.gap;
	              } else if (interpolate) {
	                newEntry.s = getInterp(calcTrace, index, position, posAttr);
	              }
	              if (!index) {
	                calcTrace[0].t = calcTrace[1].t;
	                calcTrace[0].trace = calcTrace[1].trace;
	                delete calcTrace[1].t;
	                delete calcTrace[1].trace;
	              }
	            }
	            function getInterp(calcTrace, index, position, posAttr) {
	              var pt0 = calcTrace[index - 1];
	              var pt1 = calcTrace[index + 1];
	              if (!pt1) return pt0.s;
	              if (!pt0) return pt1.s;
	              return pt0.s + (pt1.s - pt0.s) * (position - pt0[posAttr]) / (pt1[posAttr] - pt0[posAttr]);
	            }
	          }
	        ),
	        /***/
	        34936: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleGroupingDefaults = __webpack_require__2(26125);
	            var attributes = __webpack_require__2(82196);
	            module2.exports = function crossTraceDefaults(fullData, fullLayout) {
	              var traceIn, traceOut, i;
	              function coerce(attr) {
	                return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	              }
	              if (fullLayout.scattermode === "group") {
	                for (i = 0; i < fullData.length; i++) {
	                  traceOut = fullData[i];
	                  if (traceOut.type === "scatter") {
	                    traceIn = traceOut._input;
	                    handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	                  }
	                }
	              }
	              for (i = 0; i < fullData.length; i++) {
	                var tracei = fullData[i];
	                if (tracei.type !== "scatter") continue;
	                var filli = tracei.fill;
	                if (filli === "none" || filli === "toself") continue;
	                tracei.opacity = undefined;
	                if (filli === "tonexty" || filli === "tonextx") {
	                  for (var j = i - 1; j >= 0; j--) {
	                    var tracej = fullData[j];
	                    if (tracej.type === "scatter" && tracej.xaxis === tracei.xaxis && tracej.yaxis === tracei.yaxis) {
	                      tracej.opacity = undefined;
	                      break;
	                    }
	                  }
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        17438: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var attributes = __webpack_require__2(82196);
	            var constants = __webpack_require__2(47581);
	            var subTypes = __webpack_require__2(34098);
	            var handleXYDefaults = __webpack_require__2(67513);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var handleStackDefaults = __webpack_require__2(565);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleLineShapeDefaults = __webpack_require__2(94039);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var coercePattern = __webpack_require__2(71828).coercePattern;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) traceOut.visible = false;
	              if (!traceOut.visible) return;
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              var stackGroupOpts = handleStackDefaults(traceIn, traceOut, layout, coerce);
	              if (layout.scattermode === "group" && traceOut.orientation === undefined) {
	                coerce("orientation", "v");
	              }
	              var defaultMode = !stackGroupOpts && len < constants.PTS_LINESONLY ? "lines+markers" : "lines";
	              coerce("text");
	              coerce("hovertext");
	              coerce("mode", defaultMode);
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  backoff: true
	                });
	                handleLineShapeDefaults(traceIn, traceOut, coerce);
	                coerce("connectgaps");
	                coerce("line.simplify");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  gradient: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              var dfltHoverOn = [];
	              if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	                coerce("cliponaxis");
	                coerce("marker.maxdisplayed");
	                dfltHoverOn.push("points");
	              }
	              coerce("fill", stackGroupOpts ? stackGroupOpts.fillDflt : "none");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	                if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	                coercePattern(coerce, "fillpattern", traceOut.fillcolor, false);
	              }
	              var lineColor = (traceOut.line || {}).color;
	              var markerColor = (traceOut.marker || {}).color;
	              if (traceOut.fill === "tonext" || traceOut.fill === "toself") {
	                dfltHoverOn.push("fills");
	              }
	              coerce("hoveron", dfltHoverOn.join("+") || "points");
	              if (traceOut.hoveron !== "fills") coerce("hovertemplate");
	              var errorBarsSupplyDefaults = Registry.getComponentMethod("errorbars", "supplyDefaults");
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "y"
	              });
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "x",
	                inherit: "y"
	              });
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        28908: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            module2.exports = function fillColorDefaults(traceIn, traceOut, defaultColor, coerce) {
	              var inheritColorFromMarker = false;
	              if (traceOut.marker) {
	                var markerColor = traceOut.marker.color;
	                var markerLineColor = (traceOut.marker.line || {}).color;
	                if (markerColor && !isArrayOrTypedArray(markerColor)) {
	                  inheritColorFromMarker = markerColor;
	                } else if (markerLineColor && !isArrayOrTypedArray(markerLineColor)) {
	                  inheritColorFromMarker = markerLineColor;
	                }
	              }
	              coerce("fillcolor", Color.addOpacity((traceOut.line || {}).color || inheritColorFromMarker || defaultColor, 0.5));
	            };
	          }
	        ),
	        /***/
	        8225: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var labels = {};
	              var mockGd = {
	                _fullLayout: fullLayout
	              };
	              var xa = Axes.getFromTrace(mockGd, trace, "x");
	              var ya = Axes.getFromTrace(mockGd, trace, "y");
	              var x = cdi.orig_x;
	              if (x === undefined) x = cdi.x;
	              var y = cdi.orig_y;
	              if (y === undefined) y = cdi.y;
	              labels.xLabel = Axes.tickText(xa, xa.c2l(x), true).text;
	              labels.yLabel = Axes.tickText(ya, ya.c2l(y), true).text;
	              return labels;
	            };
	          }
	        ),
	        /***/
	        34603: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var subtypes = __webpack_require__2(34098);
	            module2.exports = function getTraceColor(trace, di) {
	              var lc, tc;
	              if (trace.mode === "lines") {
	                lc = trace.line.color;
	                return lc && Color.opacity(lc) ? lc : trace.fillcolor;
	              } else if (trace.mode === "none") {
	                return trace.fill ? trace.fillcolor : "";
	              } else {
	                var mc = di.mcc || (trace.marker || {}).color;
	                var mlc = di.mlcc || ((trace.marker || {}).line || {}).color;
	                tc = mc && Color.opacity(mc) ? mc : mlc && Color.opacity(mlc) && (di.mlw || ((trace.marker || {}).line || {}).width) ? mlc : "";
	                if (tc) {
	                  if (Color.opacity(tc) < 0.3) {
	                    return Color.addOpacity(tc, 0.3);
	                  } else return tc;
	                } else {
	                  lc = (trace.line || {}).color;
	                  return lc && Color.opacity(lc) && subtypes.hasLines(trace) && trace.line.width ? lc : trace.fillcolor;
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        26125: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getAxisGroup = __webpack_require__2(99082).getAxisGroup;
	            module2.exports = function handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce) {
	              var orientation = traceOut.orientation;
	              var posAxId = traceOut[{
	                v: "x",
	                h: "y"
	              }[orientation] + "axis"];
	              var groupId = getAxisGroup(fullLayout, posAxId) + orientation;
	              var alignmentOpts = fullLayout._alignmentOpts || {};
	              var alignmentgroup = coerce("alignmentgroup");
	              var alignmentGroups = alignmentOpts[groupId];
	              if (!alignmentGroups) alignmentGroups = alignmentOpts[groupId] = {};
	              var alignmentGroupOpts = alignmentGroups[alignmentgroup];
	              if (alignmentGroupOpts) {
	                alignmentGroupOpts.traces.push(traceOut);
	              } else {
	                alignmentGroupOpts = alignmentGroups[alignmentgroup] = {
	                  traces: [traceOut],
	                  alignmentIndex: Object.keys(alignmentGroups).length,
	                  offsetGroups: {}
	                };
	              }
	              var offsetgroup = coerce("offsetgroup");
	              var offsetGroups = alignmentGroupOpts.offsetGroups;
	              var offsetGroupOpts = offsetGroups[offsetgroup];
	              if (offsetgroup) {
	                if (!offsetGroupOpts) {
	                  offsetGroupOpts = offsetGroups[offsetgroup] = {
	                    offsetIndex: Object.keys(offsetGroups).length
	                  };
	                }
	                traceOut._offsetIndex = offsetGroupOpts.offsetIndex;
	              }
	            };
	          }
	        ),
	        /***/
	        33720: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Fx = __webpack_require__2(30211);
	            var Registry = __webpack_require__2(73972);
	            var getTraceColor = __webpack_require__2(34603);
	            var Color = __webpack_require__2(7901);
	            var fillText = Lib.fillText;
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var xpx = xa.c2p(xval);
	              var ypx = ya.c2p(yval);
	              var pt = [xpx, ypx];
	              var hoveron = trace.hoveron || "";
	              var minRad = trace.mode.indexOf("markers") !== -1 ? 3 : 0.5;
	              var xPeriod = !!trace.xperiodalignment;
	              var yPeriod = !!trace.yperiodalignment;
	              if (hoveron.indexOf("points") !== -1) {
	                var dx = function(di2) {
	                  if (xPeriod) {
	                    var x02 = xa.c2p(di2.xStart);
	                    var x12 = xa.c2p(di2.xEnd);
	                    return xpx >= Math.min(x02, x12) && xpx <= Math.max(x02, x12) ? 0 : Infinity;
	                  }
	                  var rad2 = Math.max(3, di2.mrc || 0);
	                  var kink = 1 - 1 / rad2;
	                  var dxRaw = Math.abs(xa.c2p(di2.x) - xpx);
	                  return dxRaw < rad2 ? kink * dxRaw / rad2 : dxRaw - rad2 + kink;
	                };
	                var dy = function(di2) {
	                  if (yPeriod) {
	                    var y02 = ya.c2p(di2.yStart);
	                    var y12 = ya.c2p(di2.yEnd);
	                    return ypx >= Math.min(y02, y12) && ypx <= Math.max(y02, y12) ? 0 : Infinity;
	                  }
	                  var rad2 = Math.max(3, di2.mrc || 0);
	                  var kink = 1 - 1 / rad2;
	                  var dyRaw = Math.abs(ya.c2p(di2.y) - ypx);
	                  return dyRaw < rad2 ? kink * dyRaw / rad2 : dyRaw - rad2 + kink;
	                };
	                var dxy = function(di2) {
	                  var rad2 = Math.max(minRad, di2.mrc || 0);
	                  var dx2 = xa.c2p(di2.x) - xpx;
	                  var dy2 = ya.c2p(di2.y) - ypx;
	                  return Math.max(Math.sqrt(dx2 * dx2 + dy2 * dy2) - rad2, 1 - minRad / rad2);
	                };
	                var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
	                Fx.getClosest(cd, distfn, pointData);
	                if (pointData.index !== false) {
	                  var di = cd[pointData.index];
	                  var xc = xa.c2p(di.x, true);
	                  var yc = ya.c2p(di.y, true);
	                  var rad = di.mrc || 1;
	                  pointData.index = di.i;
	                  var orientation = cd[0].t.orientation;
	                  var sizeVal = orientation && (di.sNorm || di.s);
	                  var xLabelVal = orientation === "h" ? sizeVal : di.orig_x !== undefined ? di.orig_x : di.x;
	                  var yLabelVal = orientation === "v" ? sizeVal : di.orig_y !== undefined ? di.orig_y : di.y;
	                  Lib.extendFlat(pointData, {
	                    color: getTraceColor(trace, di),
	                    x0: xc - rad,
	                    x1: xc + rad,
	                    xLabelVal,
	                    y0: yc - rad,
	                    y1: yc + rad,
	                    yLabelVal,
	                    spikeDistance: dxy(di),
	                    hovertemplate: trace.hovertemplate
	                  });
	                  fillText(di, trace, pointData);
	                  Registry.getComponentMethod("errorbars", "hoverInfo")(di, trace, pointData);
	                  return [pointData];
	                }
	              }
	              if (hoveron.indexOf("fills") !== -1 && trace._polygons) {
	                var polygons = trace._polygons;
	                var polygonsIn = [];
	                var inside = false;
	                var xmin = Infinity;
	                var xmax = -Infinity;
	                var ymin = Infinity;
	                var ymax = -Infinity;
	                var i, j, polygon, pts, xCross, x0, x1, y0, y1;
	                for (i = 0; i < polygons.length; i++) {
	                  polygon = polygons[i];
	                  if (polygon.contains(pt)) {
	                    inside = !inside;
	                    polygonsIn.push(polygon);
	                    ymin = Math.min(ymin, polygon.ymin);
	                    ymax = Math.max(ymax, polygon.ymax);
	                  }
	                }
	                if (inside) {
	                  ymin = Math.max(ymin, 0);
	                  ymax = Math.min(ymax, ya._length);
	                  var yAvg = (ymin + ymax) / 2;
	                  for (i = 0; i < polygonsIn.length; i++) {
	                    pts = polygonsIn[i].pts;
	                    for (j = 1; j < pts.length; j++) {
	                      y0 = pts[j - 1][1];
	                      y1 = pts[j][1];
	                      if (y0 > yAvg !== y1 >= yAvg) {
	                        x0 = pts[j - 1][0];
	                        x1 = pts[j][0];
	                        if (y1 - y0) {
	                          xCross = x0 + (x1 - x0) * (yAvg - y0) / (y1 - y0);
	                          xmin = Math.min(xmin, xCross);
	                          xmax = Math.max(xmax, xCross);
	                        }
	                      }
	                    }
	                  }
	                  xmin = Math.max(xmin, 0);
	                  xmax = Math.min(xmax, xa._length);
	                  var color = Color.defaultLine;
	                  if (Color.opacity(trace.fillcolor)) color = trace.fillcolor;
	                  else if (Color.opacity((trace.line || {}).color)) {
	                    color = trace.line.color;
	                  }
	                  Lib.extendFlat(pointData, {
	                    // never let a 2D override 1D type as closest point
	                    // also: no spikeDistance, it's not allowed for fills
	                    distance: pointData.maxHoverDistance,
	                    x0: xmin,
	                    x1: xmax,
	                    y0: yAvg,
	                    y1: yAvg,
	                    color,
	                    hovertemplate: false
	                  });
	                  delete pointData.index;
	                  if (trace.text && !Array.isArray(trace.text)) {
	                    pointData.text = String(trace.text);
	                  } else pointData.text = trace.name;
	                  return [pointData];
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        67368: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var subtypes = __webpack_require__2(34098);
	            module2.exports = {
	              hasLines: subtypes.hasLines,
	              hasMarkers: subtypes.hasMarkers,
	              hasText: subtypes.hasText,
	              isBubble: subtypes.isBubble,
	              attributes: __webpack_require__2(82196),
	              layoutAttributes: __webpack_require__2(21479),
	              supplyDefaults: __webpack_require__2(17438),
	              crossTraceDefaults: __webpack_require__2(34936),
	              supplyLayoutDefaults: __webpack_require__2(79334),
	              calc: __webpack_require__2(47761).calc,
	              crossTraceCalc: __webpack_require__2(72626),
	              arraysToCalcdata: __webpack_require__2(75225),
	              plot: __webpack_require__2(32663),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(8225),
	              style: __webpack_require__2(16296).style,
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(33720),
	              selectPoints: __webpack_require__2(98002),
	              animatable: true,
	              moduleType: "trace",
	              name: "scatter",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        21479: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              scattermode: {
	                valType: "enumerated",
	                values: ["group", "overlay"],
	                dflt: "overlay",
	                editType: "calc"
	              },
	              scattergap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        79334: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(21479);
	            module2.exports = function(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              var groupBarmode = layoutOut.barmode === "group";
	              if (layoutOut.scattermode === "group") {
	                coerce("scattergap", groupBarmode ? layoutOut.bargap : 0.2);
	              }
	            };
	          }
	        ),
	        /***/
	        11058: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleDefaults = __webpack_require__2(1586);
	            module2.exports = function lineDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
	              if (!opts) opts = {};
	              var markerColor = (traceIn.marker || {}).color;
	              coerce("line.color", defaultColor);
	              if (hasColorscale(traceIn, "line")) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "line.",
	                  cLetter: "c"
	                });
	              } else {
	                var lineColorDflt = (isArrayOrTypedArray(markerColor) ? false : markerColor) || defaultColor;
	                coerce("line.color", lineColorDflt);
	              }
	              coerce("line.width");
	              if (!opts.noDash) coerce("line.dash");
	              if (opts.backoff) coerce("line.backoff");
	            };
	          }
	        ),
	        /***/
	        34621: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Drawing = __webpack_require__2(91424);
	            var numConstants = __webpack_require__2(50606);
	            var BADNUM = numConstants.BADNUM;
	            var LOG_CLIP = numConstants.LOG_CLIP;
	            var LOG_CLIP_PLUS = LOG_CLIP + 0.5;
	            var LOG_CLIP_MINUS = LOG_CLIP - 0.5;
	            var Lib = __webpack_require__2(71828);
	            var segmentsIntersect = Lib.segmentsIntersect;
	            var constrain = Lib.constrain;
	            var constants = __webpack_require__2(47581);
	            module2.exports = function linePoints(d, opts) {
	              var trace = opts.trace || {};
	              var xa = opts.xaxis;
	              var ya = opts.yaxis;
	              var xLog = xa.type === "log";
	              var yLog = ya.type === "log";
	              var xLen = xa._length;
	              var yLen = ya._length;
	              var backoff = opts.backoff;
	              var marker = trace.marker;
	              var connectGaps = opts.connectGaps;
	              var baseTolerance = opts.baseTolerance;
	              var shape = opts.shape;
	              var linear = shape === "linear";
	              var fill = trace.fill && trace.fill !== "none";
	              var segments = [];
	              var minTolerance = constants.minTolerance;
	              var len = d.length;
	              var pts = new Array(len);
	              var pti = 0;
	              var i;
	              var clusterStartPt, clusterEndPt, clusterHighPt, clusterLowPt;
	              var thisPt;
	              var clusterHighFirst;
	              var clusterUnitVector;
	              var thisVector;
	              var clusterRefDist, clusterHighVal, clusterLowVal, thisVal;
	              var clusterMinDeviation, clusterMaxDeviation, thisDeviation;
	              function getPt(index) {
	                var di = d[index];
	                if (!di) return false;
	                var x = opts.linearized ? xa.l2p(di.x) : xa.c2p(di.x);
	                var y = opts.linearized ? ya.l2p(di.y) : ya.c2p(di.y);
	                if (x === BADNUM) {
	                  if (xLog) x = xa.c2p(di.x, true);
	                  if (x === BADNUM) return false;
	                  if (yLog && y === BADNUM) {
	                    x *= Math.abs(xa._m * yLen * (xa._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS) / (ya._m * xLen * (ya._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS)));
	                  }
	                  x *= 1e3;
	                }
	                if (y === BADNUM) {
	                  if (yLog) y = ya.c2p(di.y, true);
	                  if (y === BADNUM) return false;
	                  y *= 1e3;
	                }
	                return [x, y];
	              }
	              function crossesViewport(xFrac0, yFrac0, xFrac1, yFrac1) {
	                var dx = xFrac1 - xFrac0;
	                var dy = yFrac1 - yFrac0;
	                var dx0 = 0.5 - xFrac0;
	                var dy0 = 0.5 - yFrac0;
	                var norm2 = dx * dx + dy * dy;
	                var dot = dx * dx0 + dy * dy0;
	                if (dot > 0 && dot < norm2) {
	                  var cross = dx0 * dy - dy0 * dx;
	                  if (cross * cross < norm2) return true;
	                }
	              }
	              var latestXFrac, latestYFrac;
	              function getTolerance(pt, nextPt2) {
	                var xFrac = pt[0] / xLen;
	                var yFrac = pt[1] / yLen;
	                var offScreenFraction = Math.max(0, -xFrac, xFrac - 1, -yFrac, yFrac - 1);
	                if (offScreenFraction && latestXFrac !== undefined && crossesViewport(xFrac, yFrac, latestXFrac, latestYFrac)) {
	                  offScreenFraction = 0;
	                }
	                if (offScreenFraction && nextPt2 && crossesViewport(xFrac, yFrac, nextPt2[0] / xLen, nextPt2[1] / yLen)) {
	                  offScreenFraction = 0;
	                }
	                return (1 + constants.toleranceGrowth * offScreenFraction) * baseTolerance;
	              }
	              function ptDist(pt1, pt2) {
	                var dx = pt1[0] - pt2[0];
	                var dy = pt1[1] - pt2[1];
	                return Math.sqrt(dx * dx + dy * dy);
	              }
	              var maxScreensAway = constants.maxScreensAway;
	              var xEdge0 = -xLen * maxScreensAway;
	              var xEdge1 = xLen * (1 + maxScreensAway);
	              var yEdge0 = -yLen * maxScreensAway;
	              var yEdge1 = yLen * (1 + maxScreensAway);
	              var edges = [[xEdge0, yEdge0, xEdge1, yEdge0], [xEdge1, yEdge0, xEdge1, yEdge1], [xEdge1, yEdge1, xEdge0, yEdge1], [xEdge0, yEdge1, xEdge0, yEdge0]];
	              var xEdge, yEdge, lastXEdge, lastYEdge, lastFarPt, edgePt;
	              function getLinearEdgeIntersections(pt1, pt2) {
	                var out = [];
	                var ptCount = 0;
	                for (var i2 = 0; i2 < 4; i2++) {
	                  var edge = edges[i2];
	                  var ptInt = segmentsIntersect(pt1[0], pt1[1], pt2[0], pt2[1], edge[0], edge[1], edge[2], edge[3]);
	                  if (ptInt && (!ptCount || Math.abs(ptInt.x - out[0][0]) > 1 || Math.abs(ptInt.y - out[0][1]) > 1)) {
	                    ptInt = [ptInt.x, ptInt.y];
	                    if (ptCount && ptDist(ptInt, pt1) < ptDist(out[0], pt1)) out.unshift(ptInt);
	                    else out.push(ptInt);
	                    ptCount++;
	                  }
	                }
	                return out;
	              }
	              function onlyConstrainedPoint(pt) {
	                if (pt[0] < xEdge0 || pt[0] > xEdge1 || pt[1] < yEdge0 || pt[1] > yEdge1) {
	                  return [constrain(pt[0], xEdge0, xEdge1), constrain(pt[1], yEdge0, yEdge1)];
	                }
	              }
	              function sameEdge(pt1, pt2) {
	                if (pt1[0] === pt2[0] && (pt1[0] === xEdge0 || pt1[0] === xEdge1)) return true;
	                if (pt1[1] === pt2[1] && (pt1[1] === yEdge0 || pt1[1] === yEdge1)) return true;
	              }
	              function getHVEdgeIntersections(pt1, pt2) {
	                var out = [];
	                var ptInt1 = onlyConstrainedPoint(pt1);
	                var ptInt2 = onlyConstrainedPoint(pt2);
	                if (ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
	                if (ptInt1) out.push(ptInt1);
	                if (ptInt2) out.push(ptInt2);
	                return out;
	              }
	              function getABAEdgeIntersections(dim, limit0, limit1) {
	                return function(pt1, pt2) {
	                  var ptInt1 = onlyConstrainedPoint(pt1);
	                  var ptInt2 = onlyConstrainedPoint(pt2);
	                  var out = [];
	                  if (ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
	                  if (ptInt1) out.push(ptInt1);
	                  if (ptInt2) out.push(ptInt2);
	                  var midShift = 2 * Lib.constrain((pt1[dim] + pt2[dim]) / 2, limit0, limit1) - ((ptInt1 || pt1)[dim] + (ptInt2 || pt2)[dim]);
	                  if (midShift) {
	                    var ptToAlter;
	                    if (ptInt1 && ptInt2) {
	                      ptToAlter = midShift > 0 === ptInt1[dim] > ptInt2[dim] ? ptInt1 : ptInt2;
	                    } else ptToAlter = ptInt1 || ptInt2;
	                    ptToAlter[dim] += midShift;
	                  }
	                  return out;
	                };
	              }
	              var getEdgeIntersections;
	              if (shape === "linear" || shape === "spline") {
	                getEdgeIntersections = getLinearEdgeIntersections;
	              } else if (shape === "hv" || shape === "vh") {
	                getEdgeIntersections = getHVEdgeIntersections;
	              } else if (shape === "hvh") getEdgeIntersections = getABAEdgeIntersections(0, xEdge0, xEdge1);
	              else if (shape === "vhv") getEdgeIntersections = getABAEdgeIntersections(1, yEdge0, yEdge1);
	              function getClosestCorner(pt1, pt2) {
	                var dx = pt2[0] - pt1[0];
	                var m = (pt2[1] - pt1[1]) / dx;
	                var b = (pt1[1] * pt2[0] - pt2[1] * pt1[0]) / dx;
	                if (b > 0) return [m > 0 ? xEdge0 : xEdge1, yEdge1];
	                else return [m > 0 ? xEdge1 : xEdge0, yEdge0];
	              }
	              function updateEdge(pt) {
	                var x = pt[0];
	                var y = pt[1];
	                var xSame = x === pts[pti - 1][0];
	                var ySame = y === pts[pti - 1][1];
	                if (xSame && ySame) return;
	                if (pti > 1) {
	                  var xSame2 = x === pts[pti - 2][0];
	                  var ySame2 = y === pts[pti - 2][1];
	                  if (xSame && (x === xEdge0 || x === xEdge1) && xSame2) {
	                    if (ySame2) pti--;
	                    else pts[pti - 1] = pt;
	                  } else if (ySame && (y === yEdge0 || y === yEdge1) && ySame2) {
	                    if (xSame2) pti--;
	                    else pts[pti - 1] = pt;
	                  } else pts[pti++] = pt;
	                } else pts[pti++] = pt;
	              }
	              function updateEdgesForReentry(pt) {
	                if (pts[pti - 1][0] !== pt[0] && pts[pti - 1][1] !== pt[1]) {
	                  updateEdge([lastXEdge, lastYEdge]);
	                }
	                updateEdge(pt);
	                lastFarPt = null;
	                lastXEdge = lastYEdge = 0;
	              }
	              var arrayMarker = Lib.isArrayOrTypedArray(marker);
	              function addPt(pt) {
	                if (pt && backoff) {
	                  pt.i = i;
	                  pt.d = d;
	                  pt.trace = trace;
	                  pt.marker = arrayMarker ? marker[pt.i] : marker;
	                  pt.backoff = backoff;
	                }
	                latestXFrac = pt[0] / xLen;
	                latestYFrac = pt[1] / yLen;
	                xEdge = pt[0] < xEdge0 ? xEdge0 : pt[0] > xEdge1 ? xEdge1 : 0;
	                yEdge = pt[1] < yEdge0 ? yEdge0 : pt[1] > yEdge1 ? yEdge1 : 0;
	                if (xEdge || yEdge) {
	                  if (!pti) {
	                    pts[pti++] = [xEdge || pt[0], yEdge || pt[1]];
	                  } else if (lastFarPt) {
	                    var intersections = getEdgeIntersections(lastFarPt, pt);
	                    if (intersections.length > 1) {
	                      updateEdgesForReentry(intersections[0]);
	                      pts[pti++] = intersections[1];
	                    }
	                  } else {
	                    edgePt = getEdgeIntersections(pts[pti - 1], pt)[0];
	                    pts[pti++] = edgePt;
	                  }
	                  var lastPt = pts[pti - 1];
	                  if (xEdge && yEdge && (lastPt[0] !== xEdge || lastPt[1] !== yEdge)) {
	                    if (lastFarPt) {
	                      if (lastXEdge !== xEdge && lastYEdge !== yEdge) {
	                        if (lastXEdge && lastYEdge) {
	                          updateEdge(getClosestCorner(lastFarPt, pt));
	                        } else {
	                          updateEdge([lastXEdge || xEdge, lastYEdge || yEdge]);
	                        }
	                      } else if (lastXEdge && lastYEdge) {
	                        updateEdge([lastXEdge, lastYEdge]);
	                      }
	                    }
	                    updateEdge([xEdge, yEdge]);
	                  } else if (lastXEdge - xEdge && lastYEdge - yEdge) {
	                    updateEdge([xEdge || lastXEdge, yEdge || lastYEdge]);
	                  }
	                  lastFarPt = pt;
	                  lastXEdge = xEdge;
	                  lastYEdge = yEdge;
	                } else {
	                  if (lastFarPt) {
	                    updateEdgesForReentry(getEdgeIntersections(lastFarPt, pt)[0]);
	                  }
	                  pts[pti++] = pt;
	                }
	              }
	              for (i = 0; i < len; i++) {
	                clusterStartPt = getPt(i);
	                if (!clusterStartPt) continue;
	                pti = 0;
	                lastFarPt = null;
	                addPt(clusterStartPt);
	                for (i++; i < len; i++) {
	                  clusterHighPt = getPt(i);
	                  if (!clusterHighPt) {
	                    if (connectGaps) continue;
	                    else break;
	                  }
	                  if (!linear || !opts.simplify) {
	                    addPt(clusterHighPt);
	                    continue;
	                  }
	                  var nextPt = getPt(i + 1);
	                  clusterRefDist = ptDist(clusterHighPt, clusterStartPt);
	                  if (!(fill && (pti === 0 || pti === len - 1)) && clusterRefDist < getTolerance(clusterHighPt, nextPt) * minTolerance) continue;
	                  clusterUnitVector = [(clusterHighPt[0] - clusterStartPt[0]) / clusterRefDist, (clusterHighPt[1] - clusterStartPt[1]) / clusterRefDist];
	                  clusterLowPt = clusterStartPt;
	                  clusterHighVal = clusterRefDist;
	                  clusterLowVal = clusterMinDeviation = clusterMaxDeviation = 0;
	                  clusterHighFirst = false;
	                  clusterEndPt = clusterHighPt;
	                  for (i++; i < d.length; i++) {
	                    thisPt = nextPt;
	                    nextPt = getPt(i + 1);
	                    if (!thisPt) {
	                      if (connectGaps) continue;
	                      else break;
	                    }
	                    thisVector = [thisPt[0] - clusterStartPt[0], thisPt[1] - clusterStartPt[1]];
	                    thisDeviation = thisVector[0] * clusterUnitVector[1] - thisVector[1] * clusterUnitVector[0];
	                    clusterMinDeviation = Math.min(clusterMinDeviation, thisDeviation);
	                    clusterMaxDeviation = Math.max(clusterMaxDeviation, thisDeviation);
	                    if (clusterMaxDeviation - clusterMinDeviation > getTolerance(thisPt, nextPt)) break;
	                    clusterEndPt = thisPt;
	                    thisVal = thisVector[0] * clusterUnitVector[0] + thisVector[1] * clusterUnitVector[1];
	                    if (thisVal > clusterHighVal) {
	                      clusterHighVal = thisVal;
	                      clusterHighPt = thisPt;
	                      clusterHighFirst = false;
	                    } else if (thisVal < clusterLowVal) {
	                      clusterLowVal = thisVal;
	                      clusterLowPt = thisPt;
	                      clusterHighFirst = true;
	                    }
	                  }
	                  if (clusterHighFirst) {
	                    addPt(clusterHighPt);
	                    if (clusterEndPt !== clusterLowPt) addPt(clusterLowPt);
	                  } else {
	                    if (clusterLowPt !== clusterStartPt) addPt(clusterLowPt);
	                    if (clusterEndPt !== clusterHighPt) addPt(clusterHighPt);
	                  }
	                  addPt(clusterEndPt);
	                  if (i >= d.length || !thisPt) break;
	                  addPt(thisPt);
	                  clusterStartPt = thisPt;
	                }
	                if (lastFarPt) updateEdge([lastXEdge || lastFarPt[0], lastYEdge || lastFarPt[1]]);
	                segments.push(pts.slice(0, pti));
	              }
	              var lastShapeChar = shape.slice(shape.length - 1);
	              if (backoff && lastShapeChar !== "h" && lastShapeChar !== "v") {
	                var trimmed = false;
	                var n = -1;
	                var newSegments = [];
	                for (var j = 0; j < segments.length; j++) {
	                  for (var k = 0; k < segments[j].length - 1; k++) {
	                    var start = segments[j][k];
	                    var end = segments[j][k + 1];
	                    var xy = Drawing.applyBackoff(end, start);
	                    if (xy[0] !== end[0] || xy[1] !== end[1]) {
	                      trimmed = true;
	                    }
	                    if (!newSegments[n + 1]) {
	                      n++;
	                      newSegments[n] = [start, [xy[0], xy[1]]];
	                    }
	                  }
	                }
	                return trimmed ? newSegments : segments;
	              }
	              return segments;
	            };
	          }
	        ),
	        /***/
	        94039: (
	          /***/
	          function(module2) {
	            module2.exports = function handleLineShapeDefaults(traceIn, traceOut, coerce) {
	              var shape = coerce("line.shape");
	              if (shape === "spline") coerce("line.smoothing");
	            };
	          }
	        ),
	        /***/
	        68687: (
	          /***/
	          function(module2) {
	            var LINKEDFILLS = {
	              tonextx: 1,
	              tonexty: 1,
	              tonext: 1
	            };
	            module2.exports = function linkTraces(gd, plotinfo, cdscatter) {
	              var trace, i, group, prevtrace, groupIndex;
	              var groupIndices = {};
	              var needsSort = false;
	              var prevGroupIndex = -1;
	              var nextGroupIndex = 0;
	              var prevUnstackedGroupIndex = -1;
	              for (i = 0; i < cdscatter.length; i++) {
	                trace = cdscatter[i][0].trace;
	                group = trace.stackgroup || "";
	                if (group) {
	                  if (group in groupIndices) {
	                    groupIndex = groupIndices[group];
	                  } else {
	                    groupIndex = groupIndices[group] = nextGroupIndex;
	                    nextGroupIndex++;
	                  }
	                } else if (trace.fill in LINKEDFILLS && prevUnstackedGroupIndex >= 0) {
	                  groupIndex = prevUnstackedGroupIndex;
	                } else {
	                  groupIndex = prevUnstackedGroupIndex = nextGroupIndex;
	                  nextGroupIndex++;
	                }
	                if (groupIndex < prevGroupIndex) needsSort = true;
	                trace._groupIndex = prevGroupIndex = groupIndex;
	              }
	              var cdscatterSorted = cdscatter.slice();
	              if (needsSort) {
	                cdscatterSorted.sort(function(a, b) {
	                  var traceA = a[0].trace;
	                  var traceB = b[0].trace;
	                  return traceA._groupIndex - traceB._groupIndex || traceA.index - traceB.index;
	                });
	              }
	              var prevtraces = {};
	              for (i = 0; i < cdscatterSorted.length; i++) {
	                trace = cdscatterSorted[i][0].trace;
	                group = trace.stackgroup || "";
	                if (trace.visible === true) {
	                  trace._nexttrace = null;
	                  if (trace.fill in LINKEDFILLS) {
	                    prevtrace = prevtraces[group];
	                    trace._prevtrace = prevtrace || null;
	                    if (prevtrace) {
	                      prevtrace._nexttrace = trace;
	                    }
	                  }
	                  trace._ownfill = trace.fill && (trace.fill.substr(0, 6) === "tozero" || trace.fill === "toself" || trace.fill.substr(0, 2) === "to" && !trace._prevtrace);
	                  prevtraces[group] = trace;
	                } else {
	                  trace._prevtrace = trace._nexttrace = trace._ownfill = null;
	                }
	              }
	              return cdscatterSorted;
	            };
	          }
	        ),
	        /***/
	        39984: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            module2.exports = function makeBubbleSizeFn(trace, factor) {
	              if (!factor) {
	                factor = 2;
	              }
	              var marker = trace.marker;
	              var sizeRef = marker.sizeref || 1;
	              var sizeMin = marker.sizemin || 0;
	              var baseFn = marker.sizemode === "area" ? function(v) {
	                return Math.sqrt(v / sizeRef);
	              } : function(v) {
	                return v / sizeRef;
	              };
	              return function(v) {
	                var baseSize = baseFn(v / factor);
	                return isNumeric(baseSize) && baseSize > 0 ? Math.max(baseSize, sizeMin) : 0;
	              };
	            };
	          }
	        ),
	        /***/
	        4898: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              container: "marker",
	              min: "cmin",
	              max: "cmax"
	            };
	          }
	        ),
	        /***/
	        49508: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var hasColorscale = __webpack_require__2(52075).hasColorscale;
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var subTypes = __webpack_require__2(34098);
	            module2.exports = function markerDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
	              var isBubble = subTypes.isBubble(traceIn);
	              var lineColor = (traceIn.line || {}).color;
	              var defaultMLC;
	              opts = opts || {};
	              if (lineColor) defaultColor = lineColor;
	              coerce("marker.symbol");
	              coerce("marker.opacity", isBubble ? 0.7 : 1);
	              coerce("marker.size");
	              if (!opts.noAngle) {
	                coerce("marker.angle");
	                if (!opts.noAngleRef) {
	                  coerce("marker.angleref");
	                }
	                if (!opts.noStandOff) {
	                  coerce("marker.standoff");
	                }
	              }
	              coerce("marker.color", defaultColor);
	              if (hasColorscale(traceIn, "marker")) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "marker.",
	                  cLetter: "c"
	                });
	              }
	              if (!opts.noSelect) {
	                coerce("selected.marker.color");
	                coerce("unselected.marker.color");
	                coerce("selected.marker.size");
	                coerce("unselected.marker.size");
	              }
	              if (!opts.noLine) {
	                if (lineColor && !Array.isArray(lineColor) && traceOut.marker.color !== lineColor) {
	                  defaultMLC = lineColor;
	                } else if (isBubble) defaultMLC = Color.background;
	                else defaultMLC = Color.defaultLine;
	                coerce("marker.line.color", defaultMLC);
	                if (hasColorscale(traceIn, "marker.line")) {
	                  colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                    prefix: "marker.line.",
	                    cLetter: "c"
	                  });
	                }
	                coerce("marker.line.width", isBubble ? 1 : 0);
	              }
	              if (isBubble) {
	                coerce("marker.sizeref");
	                coerce("marker.sizemin");
	                coerce("marker.sizemode");
	              }
	              if (opts.gradient) {
	                var gradientType = coerce("marker.gradient.type");
	                if (gradientType !== "none") {
	                  coerce("marker.gradient.color");
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        73927: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dateTick0 = __webpack_require__2(71828).dateTick0;
	            var numConstants = __webpack_require__2(50606);
	            var ONEWEEK = numConstants.ONEWEEK;
	            function getPeriod0Dflt(period, calendar) {
	              if (period % ONEWEEK === 0) {
	                return dateTick0(calendar, 1);
	              }
	              return dateTick0(calendar, 0);
	            }
	            module2.exports = function handlePeriodDefaults(traceIn, traceOut, layout, coerce, opts) {
	              if (!opts) {
	                opts = {
	                  x: true,
	                  y: true
	                };
	              }
	              if (opts.x) {
	                var xperiod = coerce("xperiod");
	                if (xperiod) {
	                  coerce("xperiod0", getPeriod0Dflt(xperiod, traceOut.xcalendar));
	                  coerce("xperiodalignment");
	                }
	              }
	              if (opts.y) {
	                var yperiod = coerce("yperiod");
	                if (yperiod) {
	                  coerce("yperiod0", getPeriod0Dflt(yperiod, traceOut.ycalendar));
	                  coerce("yperiodalignment");
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        32663: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var ensureSingle = Lib.ensureSingle;
	            var identity2 = Lib.identity;
	            var Drawing = __webpack_require__2(91424);
	            var subTypes = __webpack_require__2(34098);
	            var linePoints = __webpack_require__2(34621);
	            var linkTraces = __webpack_require__2(68687);
	            var polygonTester = __webpack_require__2(61082).tester;
	            module2.exports = function plot(gd, plotinfo, cdscatter, scatterLayer, transitionOpts, makeOnCompleteCallback) {
	              var join, onComplete;
	              var isFullReplot = !transitionOpts;
	              var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
	              var cdscatterSorted = linkTraces(gd, plotinfo, cdscatter);
	              join = scatterLayer.selectAll("g.trace").data(cdscatterSorted, function(d) {
	                return d[0].trace.uid;
	              });
	              join.enter().append("g").attr("class", function(d) {
	                return "trace scatter trace" + d[0].trace.uid;
	              }).style("stroke-miterlimit", 2);
	              join.order();
	              createFills(gd, join, plotinfo);
	              if (hasTransition) {
	                if (makeOnCompleteCallback) {
	                  onComplete = makeOnCompleteCallback();
	                }
	                var transition = d3.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each("end", function() {
	                  onComplete && onComplete();
	                }).each("interrupt", function() {
	                  onComplete && onComplete();
	                });
	                transition.each(function() {
	                  scatterLayer.selectAll("g.trace").each(function(d, i) {
	                    plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
	                  });
	                });
	              } else {
	                join.each(function(d, i) {
	                  plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
	                });
	              }
	              if (isFullReplot) {
	                join.exit().remove();
	              }
	              scatterLayer.selectAll("path:not([d])").remove();
	            };
	            function createFills(gd, traceJoin, plotinfo) {
	              traceJoin.each(function(d) {
	                var fills = ensureSingle(d3.select(this), "g", "fills");
	                Drawing.setClipUrl(fills, plotinfo.layerClipId, gd);
	                var trace = d[0].trace;
	                var fillData = [];
	                if (trace._ownfill) fillData.push("_ownFill");
	                if (trace._nexttrace) fillData.push("_nextFill");
	                var fillJoin = fills.selectAll("g").data(fillData, identity2);
	                fillJoin.enter().append("g");
	                fillJoin.exit().each(function(d2) {
	                  trace[d2] = null;
	                }).remove();
	                fillJoin.order().each(function(d2) {
	                  trace[d2] = ensureSingle(d3.select(this), "path", "js-fill");
	                });
	              });
	            }
	            function plotOne(gd, idx, plotinfo, cdscatter, cdscatterAll, element, transitionOpts) {
	              var isStatic = gd._context.staticPlot;
	              var i;
	              selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll);
	              var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
	              function transition(selection) {
	                return hasTransition ? selection.transition() : selection;
	              }
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var trace = cdscatter[0].trace;
	              var line = trace.line;
	              var tr = d3.select(element);
	              var errorBarGroup = ensureSingle(tr, "g", "errorbars");
	              var lines = ensureSingle(tr, "g", "lines");
	              var points = ensureSingle(tr, "g", "points");
	              var text = ensureSingle(tr, "g", "text");
	              Registry.getComponentMethod("errorbars", "plot")(gd, errorBarGroup, plotinfo, transitionOpts);
	              if (trace.visible !== true) return;
	              transition(tr).style("opacity", trace.opacity);
	              var ownFillEl3, tonext;
	              var ownFillDir = trace.fill.charAt(trace.fill.length - 1);
	              if (ownFillDir !== "x" && ownFillDir !== "y") ownFillDir = "";
	              cdscatter[0][plotinfo.isRangePlot ? "nodeRangePlot3" : "node3"] = tr;
	              var prevRevpath = "";
	              var prevPolygons = [];
	              var prevtrace = trace._prevtrace;
	              if (prevtrace) {
	                prevRevpath = prevtrace._prevRevpath || "";
	                tonext = prevtrace._nextFill;
	                prevPolygons = prevtrace._polygons;
	              }
	              var thispath;
	              var thisrevpath;
	              var fullpath = "";
	              var revpath = "";
	              var pathfn, revpathbase, revpathfn;
	              var pt0, lastSegment, pt1, thisPolygons;
	              var segments = [];
	              var makeUpdate = Lib.noop;
	              ownFillEl3 = trace._ownFill;
	              if (subTypes.hasLines(trace) || trace.fill !== "none") {
	                if (tonext) {
	                  tonext.datum(cdscatter);
	                }
	                if (["hv", "vh", "hvh", "vhv"].indexOf(line.shape) !== -1) {
	                  pathfn = Drawing.steps(line.shape);
	                  revpathbase = Drawing.steps(line.shape.split("").reverse().join(""));
	                } else if (line.shape === "spline") {
	                  pathfn = revpathbase = function(pts) {
	                    var pLast = pts[pts.length - 1];
	                    if (pts.length > 1 && pts[0][0] === pLast[0] && pts[0][1] === pLast[1]) {
	                      return Drawing.smoothclosed(pts.slice(1), line.smoothing);
	                    } else {
	                      return Drawing.smoothopen(pts, line.smoothing);
	                    }
	                  };
	                } else {
	                  pathfn = revpathbase = function(pts) {
	                    return "M" + pts.join("L");
	                  };
	                }
	                revpathfn = function(pts) {
	                  return revpathbase(pts.reverse());
	                };
	                segments = linePoints(cdscatter, {
	                  xaxis: xa,
	                  yaxis: ya,
	                  trace,
	                  connectGaps: trace.connectgaps,
	                  baseTolerance: Math.max(line.width || 1, 3) / 4,
	                  shape: line.shape,
	                  backoff: line.backoff,
	                  simplify: line.simplify,
	                  fill: trace.fill
	                });
	                thisPolygons = trace._polygons = new Array(segments.length);
	                for (i = 0; i < segments.length; i++) {
	                  trace._polygons[i] = polygonTester(segments[i]);
	                }
	                if (segments.length) {
	                  pt0 = segments[0][0];
	                  lastSegment = segments[segments.length - 1];
	                  pt1 = lastSegment[lastSegment.length - 1];
	                }
	                makeUpdate = function(isEnter) {
	                  return function(pts) {
	                    thispath = pathfn(pts);
	                    thisrevpath = revpathfn(pts);
	                    if (!fullpath) {
	                      fullpath = thispath;
	                      revpath = thisrevpath;
	                    } else if (ownFillDir) {
	                      fullpath += "L" + thispath.substr(1);
	                      revpath = thisrevpath + ("L" + revpath.substr(1));
	                    } else {
	                      fullpath += "Z" + thispath;
	                      revpath = thisrevpath + "Z" + revpath;
	                    }
	                    if (subTypes.hasLines(trace)) {
	                      var el = d3.select(this);
	                      el.datum(cdscatter);
	                      if (isEnter) {
	                        transition(el.style("opacity", 0).attr("d", thispath).call(Drawing.lineGroupStyle)).style("opacity", 1);
	                      } else {
	                        var sel = transition(el);
	                        sel.attr("d", thispath);
	                        Drawing.singleLineStyle(cdscatter, sel);
	                      }
	                    }
	                  };
	                };
	              }
	              var lineJoin = lines.selectAll(".js-line").data(segments);
	              transition(lineJoin.exit()).style("opacity", 0).remove();
	              lineJoin.each(makeUpdate(false));
	              lineJoin.enter().append("path").classed("js-line", true).style("vector-effect", isStatic ? "none" : "non-scaling-stroke").call(Drawing.lineGroupStyle).each(makeUpdate(true));
	              Drawing.setClipUrl(lineJoin, plotinfo.layerClipId, gd);
	              function clearFill(selection) {
	                transition(selection).attr("d", "M0,0Z");
	              }
	              if (segments.length) {
	                if (ownFillEl3) {
	                  ownFillEl3.datum(cdscatter);
	                  if (pt0 && pt1) {
	                    if (ownFillDir) {
	                      if (ownFillDir === "y") {
	                        pt0[1] = pt1[1] = ya.c2p(0, true);
	                      } else if (ownFillDir === "x") {
	                        pt0[0] = pt1[0] = xa.c2p(0, true);
	                      }
	                      transition(ownFillEl3).attr("d", "M" + pt1 + "L" + pt0 + "L" + fullpath.substr(1)).call(Drawing.singleFillStyle, gd);
	                    } else {
	                      transition(ownFillEl3).attr("d", fullpath + "Z").call(Drawing.singleFillStyle, gd);
	                    }
	                  }
	                } else if (tonext) {
	                  if (trace.fill.substr(0, 6) === "tonext" && fullpath && prevRevpath) {
	                    if (trace.fill === "tonext") {
	                      transition(tonext).attr("d", fullpath + "Z" + prevRevpath + "Z").call(Drawing.singleFillStyle, gd);
	                    } else {
	                      transition(tonext).attr("d", fullpath + "L" + prevRevpath.substr(1) + "Z").call(Drawing.singleFillStyle, gd);
	                    }
	                    trace._polygons = trace._polygons.concat(prevPolygons);
	                  } else {
	                    clearFill(tonext);
	                    trace._polygons = null;
	                  }
	                }
	                trace._prevRevpath = revpath;
	                trace._prevPolygons = thisPolygons;
	              } else {
	                if (ownFillEl3) clearFill(ownFillEl3);
	                else if (tonext) clearFill(tonext);
	                trace._polygons = trace._prevRevpath = trace._prevPolygons = null;
	              }
	              function visFilter(d) {
	                return d.filter(function(v) {
	                  return !v.gap && v.vis;
	                });
	              }
	              function visFilterWithGaps(d) {
	                return d.filter(function(v) {
	                  return v.vis;
	                });
	              }
	              function gapFilter(d) {
	                return d.filter(function(v) {
	                  return !v.gap;
	                });
	              }
	              function keyFunc(d) {
	                return d.id;
	              }
	              function getKeyFunc(trace2) {
	                if (trace2.ids) {
	                  return keyFunc;
	                }
	              }
	              function hideFilter() {
	                return false;
	              }
	              function makePoints(points2, text2, cdscatter2) {
	                var join, selection, hasNode;
	                var trace2 = cdscatter2[0].trace;
	                var showMarkers = subTypes.hasMarkers(trace2);
	                var showText = subTypes.hasText(trace2);
	                var keyFunc2 = getKeyFunc(trace2);
	                var markerFilter = hideFilter;
	                var textFilter = hideFilter;
	                if (showMarkers || showText) {
	                  var showFilter = identity2;
	                  var stackGroup = trace2.stackgroup;
	                  var isInferZero = stackGroup && gd._fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup].stackgaps === "infer zero";
	                  if (trace2.marker.maxdisplayed || trace2._needsCull) {
	                    showFilter = isInferZero ? visFilterWithGaps : visFilter;
	                  } else if (stackGroup && !isInferZero) {
	                    showFilter = gapFilter;
	                  }
	                  if (showMarkers) markerFilter = showFilter;
	                  if (showText) textFilter = showFilter;
	                }
	                selection = points2.selectAll("path.point");
	                join = selection.data(markerFilter, keyFunc2);
	                var enter = join.enter().append("path").classed("point", true);
	                if (hasTransition) {
	                  enter.call(Drawing.pointStyle, trace2, gd).call(Drawing.translatePoints, xa, ya).style("opacity", 0).transition().style("opacity", 1);
	                }
	                join.order();
	                var styleFns;
	                if (showMarkers) {
	                  styleFns = Drawing.makePointStyleFns(trace2);
	                }
	                join.each(function(d) {
	                  var el = d3.select(this);
	                  var sel = transition(el);
	                  hasNode = Drawing.translatePoint(d, sel, xa, ya);
	                  if (hasNode) {
	                    Drawing.singlePointStyle(d, sel, trace2, styleFns, gd);
	                    if (plotinfo.layerClipId) {
	                      Drawing.hideOutsideRangePoint(d, sel, xa, ya, trace2.xcalendar, trace2.ycalendar);
	                    }
	                    if (trace2.customdata) {
	                      el.classed("plotly-customdata", d.data !== null && d.data !== undefined);
	                    }
	                  } else {
	                    sel.remove();
	                  }
	                });
	                if (hasTransition) {
	                  join.exit().transition().style("opacity", 0).remove();
	                } else {
	                  join.exit().remove();
	                }
	                selection = text2.selectAll("g");
	                join = selection.data(textFilter, keyFunc2);
	                join.enter().append("g").classed("textpoint", true).append("text");
	                join.order();
	                join.each(function(d) {
	                  var g = d3.select(this);
	                  var sel = transition(g.select("text"));
	                  hasNode = Drawing.translatePoint(d, sel, xa, ya);
	                  if (hasNode) {
	                    if (plotinfo.layerClipId) {
	                      Drawing.hideOutsideRangePoint(d, g, xa, ya, trace2.xcalendar, trace2.ycalendar);
	                    }
	                  } else {
	                    g.remove();
	                  }
	                });
	                join.selectAll("text").call(Drawing.textPointStyle, trace2, gd).each(function(d) {
	                  var x = xa.c2p(d.x);
	                  var y = ya.c2p(d.y);
	                  d3.select(this).selectAll("tspan.line").each(function() {
	                    transition(d3.select(this)).attr({
	                      x,
	                      y
	                    });
	                  });
	                });
	                join.exit().remove();
	              }
	              points.datum(cdscatter);
	              text.datum(cdscatter);
	              makePoints(points, text, cdscatter);
	              var hasClipOnAxisFalse = trace.cliponaxis === false;
	              var clipUrl = hasClipOnAxisFalse ? null : plotinfo.layerClipId;
	              Drawing.setClipUrl(points, clipUrl, gd);
	              Drawing.setClipUrl(text, clipUrl, gd);
	            }
	            function selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var xr = d3.extent(Lib.simpleMap(xa.range, xa.r2c));
	              var yr = d3.extent(Lib.simpleMap(ya.range, ya.r2c));
	              var trace = cdscatter[0].trace;
	              if (!subTypes.hasMarkers(trace)) return;
	              var mnum = trace.marker.maxdisplayed;
	              if (mnum === 0) return;
	              var cd = cdscatter.filter(function(v) {
	                return v.x >= xr[0] && v.x <= xr[1] && v.y >= yr[0] && v.y <= yr[1];
	              });
	              var inc = Math.ceil(cd.length / mnum);
	              var tnum = 0;
	              cdscatterAll.forEach(function(cdj, j) {
	                var tracei = cdj[0].trace;
	                if (subTypes.hasMarkers(tracei) && tracei.marker.maxdisplayed > 0 && j < idx) {
	                  tnum++;
	                }
	              });
	              var i0 = Math.round(tnum * inc / 3 + Math.floor(tnum / 3) * inc / 7.1);
	              cdscatter.forEach(function(v) {
	                delete v.vis;
	              });
	              cd.forEach(function(v, i) {
	                if (Math.round((i + i0) % inc) === 0) v.vis = true;
	              });
	            }
	          }
	        ),
	        /***/
	        98002: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var subtypes = __webpack_require__2(34098);
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var trace = cd[0].trace;
	              var i;
	              var di;
	              var x;
	              var y;
	              var hasOnlyLines = !subtypes.hasMarkers(trace) && !subtypes.hasText(trace);
	              if (hasOnlyLines) return [];
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  cd[i].selected = 0;
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  di = cd[i];
	                  x = xa.c2p(di.x);
	                  y = ya.c2p(di.y);
	                  if (di.i !== null && selectionTester.contains([x, y], false, i, searchInfo)) {
	                    selection.push({
	                      pointNumber: di.i,
	                      x: xa.c2d(di.x),
	                      y: ya.c2d(di.y)
	                    });
	                    di.selected = 1;
	                  } else {
	                    di.selected = 0;
	                  }
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        565: (
	          /***/
	          function(module2) {
	            var perStackAttrs = ["orientation", "groupnorm", "stackgaps"];
	            module2.exports = function handleStackDefaults(traceIn, traceOut, layout, coerce) {
	              var stackOpts = layout._scatterStackOpts;
	              var stackGroup = coerce("stackgroup");
	              if (stackGroup) {
	                var subplot = traceOut.xaxis + traceOut.yaxis;
	                var subplotStackOpts = stackOpts[subplot];
	                if (!subplotStackOpts) subplotStackOpts = stackOpts[subplot] = {};
	                var groupOpts = subplotStackOpts[stackGroup];
	                var firstTrace = false;
	                if (groupOpts) {
	                  groupOpts.traces.push(traceOut);
	                } else {
	                  groupOpts = subplotStackOpts[stackGroup] = {
	                    // keep track of trace indices for use during stacking calculations
	                    // this will be filled in during `calc` and used during `crossTraceCalc`
	                    // so it's OK if we don't recreate it during a non-calc edit
	                    traceIndices: [],
	                    // Hold on to the whole set of prior traces
	                    // First one is most important, so we can clear defaults
	                    // there if we find explicit values only in later traces.
	                    // We're only going to *use* the values stored in groupOpts,
	                    // but for the editor and validate we want things self-consistent
	                    // The full set of traces is used only to fix `fill` default if
	                    // we find `orientation: 'h'` beyond the first trace
	                    traces: [traceOut]
	                  };
	                  firstTrace = true;
	                }
	                var dflts = {
	                  orientation: traceOut.x && !traceOut.y ? "h" : "v"
	                };
	                for (var i = 0; i < perStackAttrs.length; i++) {
	                  var attr = perStackAttrs[i];
	                  var attrFound = attr + "Found";
	                  if (!groupOpts[attrFound]) {
	                    var traceHasAttr = traceIn[attr] !== undefined;
	                    var isOrientation = attr === "orientation";
	                    if (traceHasAttr || firstTrace) {
	                      groupOpts[attr] = coerce(attr, dflts[attr]);
	                      if (isOrientation) {
	                        groupOpts.fillDflt = groupOpts[attr] === "h" ? "tonextx" : "tonexty";
	                      }
	                      if (traceHasAttr) {
	                        groupOpts[attrFound] = true;
	                        if (!firstTrace) {
	                          delete groupOpts.traces[0][attr];
	                          if (isOrientation) {
	                            for (var j = 0; j < groupOpts.traces.length - 1; j++) {
	                              var trace2 = groupOpts.traces[j];
	                              if (trace2._input.fill !== trace2.fill) {
	                                trace2.fill = groupOpts.fillDflt;
	                              }
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	                return groupOpts;
	              }
	            };
	          }
	        ),
	        /***/
	        16296: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Registry = __webpack_require__2(73972);
	            function style(gd) {
	              var s = d3.select(gd).selectAll("g.trace.scatter");
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              s.selectAll("g.points").each(function(d) {
	                var sel = d3.select(this);
	                var trace = d.trace || d[0].trace;
	                stylePoints(sel, trace, gd);
	              });
	              s.selectAll("g.text").each(function(d) {
	                var sel = d3.select(this);
	                var trace = d.trace || d[0].trace;
	                styleText(sel, trace, gd);
	              });
	              s.selectAll("g.trace path.js-line").call(Drawing.lineGroupStyle);
	              s.selectAll("g.trace path.js-fill").call(Drawing.fillGroupStyle, gd);
	              Registry.getComponentMethod("errorbars", "style")(s);
	            }
	            function stylePoints(sel, trace, gd) {
	              Drawing.pointStyle(sel.selectAll("path.point"), trace, gd);
	            }
	            function styleText(sel, trace, gd) {
	              Drawing.textPointStyle(sel.selectAll("text"), trace, gd);
	            }
	            function styleOnSelect(gd, cd, sel) {
	              var trace = cd[0].trace;
	              if (trace.selectedpoints) {
	                Drawing.selectedPointStyle(sel.selectAll("path.point"), trace);
	                Drawing.selectedTextStyle(sel.selectAll("text"), trace);
	              } else {
	                stylePoints(sel, trace, gd);
	                styleText(sel, trace, gd);
	              }
	            }
	            module2.exports = {
	              style,
	              stylePoints,
	              styleText,
	              styleOnSelect
	            };
	          }
	        ),
	        /***/
	        34098: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = {
	              hasLines: function(trace) {
	                return trace.visible && trace.mode && trace.mode.indexOf("lines") !== -1;
	              },
	              hasMarkers: function(trace) {
	                return trace.visible && (trace.mode && trace.mode.indexOf("markers") !== -1 || // until splom implements 'mode'
	                trace.type === "splom");
	              },
	              hasText: function(trace) {
	                return trace.visible && trace.mode && trace.mode.indexOf("text") !== -1;
	              },
	              isBubble: function(trace) {
	                return Lib.isPlainObject(trace.marker) && Lib.isArrayOrTypedArray(trace.marker.size);
	              }
	            };
	          }
	        ),
	        /***/
	        82410: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function(traceIn, traceOut, layout, coerce, opts) {
	              opts = opts || {};
	              coerce("textposition");
	              Lib.coerceFont(coerce, "textfont", opts.font || layout.font);
	              if (!opts.noSelect) {
	                coerce("selected.textfont.color");
	                coerce("unselected.textfont.color");
	              }
	            };
	          }
	        ),
	        /***/
	        67513: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            module2.exports = function handleXYDefaults(traceIn, traceOut, layout, coerce) {
	              var x = coerce("x");
	              var y = coerce("y");
	              var len;
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y"], layout);
	              if (x) {
	                var xlen = Lib.minRowLength(x);
	                if (y) {
	                  len = Math.min(xlen, Lib.minRowLength(y));
	                } else {
	                  len = xlen;
	                  coerce("y0");
	                  coerce("dy");
	                }
	              } else {
	                if (!y) return 0;
	                len = Lib.minRowLength(y);
	                coerce("x0");
	                coerce("dx");
	              }
	              traceOut._length = len;
	              return len;
	            };
	          }
	        ),
	        /***/
	        44542: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterAttrs = __webpack_require__2(82196);
	            var colorAttributes = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var baseAttrs = __webpack_require__2(9012);
	            var DASHES = __webpack_require__2(29659);
	            var MARKER_SYMBOLS = __webpack_require__2(87381);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var sortObjectKeys = __webpack_require__2(78607);
	            var scatterLineAttrs = scatterAttrs.line;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            var lineAttrs = extendFlat({
	              width: scatterLineAttrs.width,
	              dash: {
	                valType: "enumerated",
	                values: sortObjectKeys(DASHES),
	                dflt: "solid"
	              }
	            }, colorAttributes("line"));
	            function makeProjectionAttr(axLetter) {
	              return {
	                show: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                opacity: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                },
	                scale: {
	                  valType: "number",
	                  min: 0,
	                  max: 10,
	                  dflt: 2 / 3
	                }
	              };
	            }
	            var attrs = module2.exports = overrideAll({
	              x: scatterAttrs.x,
	              y: scatterAttrs.y,
	              z: {
	                valType: "data_array"
	              },
	              text: extendFlat({}, scatterAttrs.text, {}),
	              texttemplate: texttemplateAttrs({}, {}),
	              hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
	              hovertemplate: hovertemplateAttrs(),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z"),
	              mode: extendFlat(
	                {},
	                scatterAttrs.mode,
	                // shouldn't this be on-par with 2D?
	                {
	                  dflt: "lines+markers"
	                }
	              ),
	              surfaceaxis: {
	                valType: "enumerated",
	                values: [-1, 0, 1, 2],
	                dflt: -1
	              },
	              surfacecolor: {
	                valType: "color"
	              },
	              projection: {
	                x: makeProjectionAttr(),
	                y: makeProjectionAttr(),
	                z: makeProjectionAttr()
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              line: lineAttrs,
	              marker: extendFlat({
	                // Parity with scatter.js?
	                symbol: {
	                  valType: "enumerated",
	                  values: sortObjectKeys(MARKER_SYMBOLS),
	                  dflt: "circle",
	                  arrayOk: true
	                },
	                size: extendFlat({}, scatterMarkerAttrs.size, {
	                  dflt: 8
	                }),
	                sizeref: scatterMarkerAttrs.sizeref,
	                sizemin: scatterMarkerAttrs.sizemin,
	                sizemode: scatterMarkerAttrs.sizemode,
	                opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
	                  arrayOk: false
	                }),
	                colorbar: scatterMarkerAttrs.colorbar,
	                line: extendFlat({
	                  width: extendFlat({}, scatterMarkerLineAttrs.width, {
	                    arrayOk: false
	                  })
	                }, colorAttributes("marker.line"))
	              }, colorAttributes("marker")),
	              textposition: extendFlat({}, scatterAttrs.textposition, {
	                dflt: "top center"
	              }),
	              textfont: {
	                color: scatterAttrs.textfont.color,
	                size: scatterAttrs.textfont.size,
	                family: extendFlat({}, scatterAttrs.textfont.family, {
	                  arrayOk: false
	                })
	              },
	              opacity: baseAttrs.opacity,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
	            }, "calc", "nested");
	            attrs.x.editType = attrs.y.editType = attrs.z.editType = "calc+clearAxisTypes";
	          }
	        ),
	        /***/
	        36563: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcColorscale = __webpack_require__2(36922);
	            module2.exports = function calc(gd, trace) {
	              var cd = [{
	                x: false,
	                y: false,
	                trace,
	                t: {}
	              }];
	              arraysToCalcdata(cd, trace);
	              calcColorscale(gd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        67336: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            function calculateAxisErrors(data, params, scaleFactor, axis) {
	              if (!params || !params.visible) return null;
	              var computeError = Registry.getComponentMethod("errorbars", "makeComputeError")(params);
	              var result = new Array(data.length);
	              for (var i = 0; i < data.length; i++) {
	                var errors = computeError(+data[i], i);
	                if (axis.type === "log") {
	                  var point = axis.c2l(data[i]);
	                  var min = data[i] - errors[0];
	                  var max = data[i] + errors[1];
	                  result[i] = [(axis.c2l(min, true) - point) * scaleFactor, (axis.c2l(max, true) - point) * scaleFactor];
	                  if (min > 0) {
	                    var lower = axis.c2l(min);
	                    if (!axis._lowerLogErrorBound) axis._lowerLogErrorBound = lower;
	                    axis._lowerErrorBound = Math.min(axis._lowerLogErrorBound, lower);
	                  }
	                } else {
	                  result[i] = [-errors[0] * scaleFactor, errors[1] * scaleFactor];
	                }
	              }
	              return result;
	            }
	            function dataLength(array) {
	              for (var i = 0; i < array.length; i++) {
	                if (array[i]) return array[i].length;
	              }
	              return 0;
	            }
	            function calculateErrors(data, scaleFactor, sceneLayout) {
	              var errors = [calculateAxisErrors(data.x, data.error_x, scaleFactor[0], sceneLayout.xaxis), calculateAxisErrors(data.y, data.error_y, scaleFactor[1], sceneLayout.yaxis), calculateAxisErrors(data.z, data.error_z, scaleFactor[2], sceneLayout.zaxis)];
	              var n = dataLength(errors);
	              if (n === 0) return null;
	              var errorBounds = new Array(n);
	              for (var i = 0; i < n; i++) {
	                var bound = [[0, 0, 0], [0, 0, 0]];
	                for (var j = 0; j < 3; j++) {
	                  if (errors[j]) {
	                    for (var k = 0; k < 2; k++) {
	                      bound[k][j] = errors[j][i][k];
	                    }
	                  }
	                }
	                errorBounds[i] = bound;
	              }
	              return errorBounds;
	            }
	            module2.exports = calculateErrors;
	          }
	        ),
	        /***/
	        58925: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createLinePlot = __webpack_require__2(9330).gl_line3d;
	            var createScatterPlot = __webpack_require__2(9330).gl_scatter3d;
	            var createErrorBars = __webpack_require__2(9330).gl_error3d;
	            var createMesh = __webpack_require__2(9330).gl_mesh3d;
	            var triangulate = __webpack_require__2(9330).delaunay_triangulate;
	            var Lib = __webpack_require__2(71828);
	            var str2RgbaArray = __webpack_require__2(78614);
	            var formatColor = __webpack_require__2(81697).formatColor;
	            var makeBubbleSizeFn = __webpack_require__2(39984);
	            var DASH_PATTERNS = __webpack_require__2(29659);
	            var MARKER_SYMBOLS = __webpack_require__2(87381);
	            var Axes = __webpack_require__2(89298);
	            var appendArrayPointValue = __webpack_require__2(23469).appendArrayPointValue;
	            var calculateError = __webpack_require__2(67336);
	            function LineWithMarkers(scene, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.linePlot = null;
	              this.scatterPlot = null;
	              this.errorBars = null;
	              this.textMarkers = null;
	              this.delaunayMesh = null;
	              this.color = null;
	              this.mode = "";
	              this.dataPoints = [];
	              this.axesBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	              this.textLabels = null;
	              this.data = null;
	            }
	            var proto = LineWithMarkers.prototype;
	            proto.handlePick = function(selection) {
	              if (selection.object && (selection.object === this.linePlot || selection.object === this.delaunayMesh || selection.object === this.textMarkers || selection.object === this.scatterPlot)) {
	                var ind = selection.index = selection.data.index;
	                if (selection.object.highlight) {
	                  selection.object.highlight(null);
	                }
	                if (this.scatterPlot) {
	                  selection.object = this.scatterPlot;
	                  this.scatterPlot.highlight(selection.data);
	                }
	                selection.textLabel = "";
	                if (this.textLabels) {
	                  if (Array.isArray(this.textLabels)) {
	                    if (this.textLabels[ind] || this.textLabels[ind] === 0) {
	                      selection.textLabel = this.textLabels[ind];
	                    }
	                  } else {
	                    selection.textLabel = this.textLabels;
	                  }
	                }
	                selection.traceCoordinate = [this.data.x[ind], this.data.y[ind], this.data.z[ind]];
	                return true;
	              }
	            };
	            function constructDelaunay(points, color, axis) {
	              var u = (axis + 1) % 3;
	              var v = (axis + 2) % 3;
	              var filteredPoints = [];
	              var filteredIds = [];
	              var i;
	              for (i = 0; i < points.length; ++i) {
	                var p = points[i];
	                if (isNaN(p[u]) || !isFinite(p[u]) || isNaN(p[v]) || !isFinite(p[v])) {
	                  continue;
	                }
	                filteredPoints.push([p[u], p[v]]);
	                filteredIds.push(i);
	              }
	              var cells = triangulate(filteredPoints);
	              for (i = 0; i < cells.length; ++i) {
	                var c = cells[i];
	                for (var j = 0; j < c.length; ++j) {
	                  c[j] = filteredIds[c[j]];
	                }
	              }
	              return {
	                positions: points,
	                cells,
	                meshColor: color
	              };
	            }
	            function calculateErrorParams(errors) {
	              var capSize = [0, 0, 0];
	              var color = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
	              var lineWidth = [1, 1, 1];
	              for (var i = 0; i < 3; i++) {
	                var e = errors[i];
	                if (e && e.copy_zstyle !== false && errors[2].visible !== false) e = errors[2];
	                if (!e || !e.visible) continue;
	                capSize[i] = e.width / 2;
	                color[i] = str2RgbaArray(e.color);
	                lineWidth[i] = e.thickness;
	              }
	              return {
	                capSize,
	                color,
	                lineWidth
	              };
	            }
	            function parseAlignmentX(a) {
	              if (a === null || a === undefined) return 0;
	              return a.indexOf("left") > -1 ? -1 : a.indexOf("right") > -1 ? 1 : 0;
	            }
	            function parseAlignmentY(a) {
	              if (a === null || a === undefined) return 0;
	              return a.indexOf("top") > -1 ? -1 : a.indexOf("bottom") > -1 ? 1 : 0;
	            }
	            function calculateTextOffset(tp) {
	              var defaultAlignmentX = 0;
	              var defaultAlignmentY = 0;
	              var textOffset = [defaultAlignmentX, defaultAlignmentY];
	              if (Array.isArray(tp)) {
	                for (var i = 0; i < tp.length; i++) {
	                  textOffset[i] = [defaultAlignmentX, defaultAlignmentY];
	                  if (tp[i]) {
	                    textOffset[i][0] = parseAlignmentX(tp[i]);
	                    textOffset[i][1] = parseAlignmentY(tp[i]);
	                  }
	                }
	              } else {
	                textOffset[0] = parseAlignmentX(tp);
	                textOffset[1] = parseAlignmentY(tp);
	              }
	              return textOffset;
	            }
	            function calculateSize(sizeIn, sizeFn) {
	              return sizeFn(sizeIn * 4);
	            }
	            function calculateSymbol(symbolIn) {
	              return MARKER_SYMBOLS[symbolIn];
	            }
	            function formatParam(paramIn, len, calculate, dflt, extraFn) {
	              var paramOut = null;
	              if (Lib.isArrayOrTypedArray(paramIn)) {
	                paramOut = [];
	                for (var i = 0; i < len; i++) {
	                  if (paramIn[i] === undefined) paramOut[i] = dflt;
	                  else paramOut[i] = calculate(paramIn[i], extraFn);
	                }
	              } else paramOut = calculate(paramIn, Lib.identity);
	              return paramOut;
	            }
	            function convertPlotlyOptions(scene, data) {
	              var points = [];
	              var sceneLayout = scene.fullSceneLayout;
	              var scaleFactor = scene.dataScale;
	              var xaxis = sceneLayout.xaxis;
	              var yaxis = sceneLayout.yaxis;
	              var zaxis = sceneLayout.zaxis;
	              var marker = data.marker;
	              var line = data.line;
	              var x = data.x || [];
	              var y = data.y || [];
	              var z = data.z || [];
	              var len = x.length;
	              var xcalendar = data.xcalendar;
	              var ycalendar = data.ycalendar;
	              var zcalendar = data.zcalendar;
	              var xc, yc, zc;
	              var params, i;
	              var text;
	              for (i = 0; i < len; i++) {
	                xc = xaxis.d2l(x[i], 0, xcalendar) * scaleFactor[0];
	                yc = yaxis.d2l(y[i], 0, ycalendar) * scaleFactor[1];
	                zc = zaxis.d2l(z[i], 0, zcalendar) * scaleFactor[2];
	                points[i] = [xc, yc, zc];
	              }
	              if (Array.isArray(data.text)) text = data.text;
	              else if (data.text !== undefined) {
	                text = new Array(len);
	                for (i = 0; i < len; i++) text[i] = data.text;
	              }
	              function formatter(axName, val) {
	                var ax = sceneLayout[axName];
	                return Axes.tickText(ax, ax.d2l(val), true).text;
	              }
	              var texttemplate = data.texttemplate;
	              if (texttemplate) {
	                var fullLayout = scene.fullLayout;
	                var d3locale = fullLayout._d3locale;
	                var isArray = Array.isArray(texttemplate);
	                var N = isArray ? Math.min(texttemplate.length, len) : len;
	                var txt = isArray ? function(i2) {
	                  return texttemplate[i2];
	                } : function() {
	                  return texttemplate;
	                };
	                text = new Array(N);
	                for (i = 0; i < N; i++) {
	                  var d = {
	                    x: x[i],
	                    y: y[i],
	                    z: z[i]
	                  };
	                  var labels = {
	                    xLabel: formatter("xaxis", x[i]),
	                    yLabel: formatter("yaxis", y[i]),
	                    zLabel: formatter("zaxis", z[i])
	                  };
	                  var pointValues = {};
	                  appendArrayPointValue(pointValues, data, i);
	                  var meta = data._meta || {};
	                  text[i] = Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta);
	                }
	              }
	              params = {
	                position: points,
	                mode: data.mode,
	                text
	              };
	              if ("line" in data) {
	                params.lineColor = formatColor(line, 1, len);
	                params.lineWidth = line.width;
	                params.lineDashes = line.dash;
	              }
	              if ("marker" in data) {
	                var sizeFn = makeBubbleSizeFn(data);
	                params.scatterColor = formatColor(marker, 1, len);
	                params.scatterSize = formatParam(marker.size, len, calculateSize, 20, sizeFn);
	                params.scatterMarker = formatParam(marker.symbol, len, calculateSymbol, "●");
	                params.scatterLineWidth = marker.line.width;
	                params.scatterLineColor = formatColor(marker.line, 1, len);
	                params.scatterAngle = 0;
	              }
	              if ("textposition" in data) {
	                params.textOffset = calculateTextOffset(data.textposition);
	                params.textColor = formatColor(data.textfont, 1, len);
	                params.textSize = formatParam(data.textfont.size, len, Lib.identity, 12);
	                params.textFont = data.textfont.family;
	                params.textAngle = 0;
	              }
	              var dims = ["x", "y", "z"];
	              params.project = [false, false, false];
	              params.projectScale = [1, 1, 1];
	              params.projectOpacity = [1, 1, 1];
	              for (i = 0; i < 3; ++i) {
	                var projection = data.projection[dims[i]];
	                if (params.project[i] = projection.show) {
	                  params.projectOpacity[i] = projection.opacity;
	                  params.projectScale[i] = projection.scale;
	                }
	              }
	              params.errorBounds = calculateError(data, scaleFactor, sceneLayout);
	              var errorParams = calculateErrorParams([data.error_x, data.error_y, data.error_z]);
	              params.errorColor = errorParams.color;
	              params.errorLineWidth = errorParams.lineWidth;
	              params.errorCapSize = errorParams.capSize;
	              params.delaunayAxis = data.surfaceaxis;
	              params.delaunayColor = str2RgbaArray(data.surfacecolor);
	              return params;
	            }
	            function _arrayToColor(color) {
	              if (Lib.isArrayOrTypedArray(color)) {
	                var c = color[0];
	                if (Lib.isArrayOrTypedArray(c)) color = c;
	                return "rgb(" + color.slice(0, 3).map(function(x) {
	                  return Math.round(x * 255);
	                }) + ")";
	              }
	              return null;
	            }
	            function arrayToColor(colors) {
	              if (!Lib.isArrayOrTypedArray(colors)) {
	                return null;
	              }
	              if (colors.length === 4 && typeof colors[0] === "number") {
	                return _arrayToColor(colors);
	              }
	              return colors.map(_arrayToColor);
	            }
	            proto.update = function(data) {
	              var gl2 = this.scene.glplot.gl;
	              var lineOptions;
	              var scatterOptions;
	              var errorOptions;
	              var textOptions;
	              var dashPattern = DASH_PATTERNS.solid;
	              this.data = data;
	              var options = convertPlotlyOptions(this.scene, data);
	              if ("mode" in options) {
	                this.mode = options.mode;
	              }
	              if ("lineDashes" in options) {
	                if (options.lineDashes in DASH_PATTERNS) {
	                  dashPattern = DASH_PATTERNS[options.lineDashes];
	                }
	              }
	              this.color = arrayToColor(options.scatterColor) || arrayToColor(options.lineColor);
	              this.dataPoints = options.position;
	              lineOptions = {
	                gl: this.scene.glplot.gl,
	                position: options.position,
	                color: options.lineColor,
	                lineWidth: options.lineWidth || 1,
	                dashes: dashPattern[0],
	                dashScale: dashPattern[1],
	                opacity: data.opacity,
	                connectGaps: data.connectgaps
	              };
	              if (this.mode.indexOf("lines") !== -1) {
	                if (this.linePlot) this.linePlot.update(lineOptions);
	                else {
	                  this.linePlot = createLinePlot(lineOptions);
	                  this.linePlot._trace = this;
	                  this.scene.glplot.add(this.linePlot);
	                }
	              } else if (this.linePlot) {
	                this.scene.glplot.remove(this.linePlot);
	                this.linePlot.dispose();
	                this.linePlot = null;
	              }
	              var scatterOpacity = data.opacity;
	              if (data.marker && data.marker.opacity !== undefined) scatterOpacity *= data.marker.opacity;
	              scatterOptions = {
	                gl: this.scene.glplot.gl,
	                position: options.position,
	                color: options.scatterColor,
	                size: options.scatterSize,
	                glyph: options.scatterMarker,
	                opacity: scatterOpacity,
	                orthographic: true,
	                lineWidth: options.scatterLineWidth,
	                lineColor: options.scatterLineColor,
	                project: options.project,
	                projectScale: options.projectScale,
	                projectOpacity: options.projectOpacity
	              };
	              if (this.mode.indexOf("markers") !== -1) {
	                if (this.scatterPlot) this.scatterPlot.update(scatterOptions);
	                else {
	                  this.scatterPlot = createScatterPlot(scatterOptions);
	                  this.scatterPlot._trace = this;
	                  this.scatterPlot.highlightScale = 1;
	                  this.scene.glplot.add(this.scatterPlot);
	                }
	              } else if (this.scatterPlot) {
	                this.scene.glplot.remove(this.scatterPlot);
	                this.scatterPlot.dispose();
	                this.scatterPlot = null;
	              }
	              textOptions = {
	                gl: this.scene.glplot.gl,
	                position: options.position,
	                glyph: options.text,
	                color: options.textColor,
	                size: options.textSize,
	                angle: options.textAngle,
	                alignment: options.textOffset,
	                font: options.textFont,
	                orthographic: true,
	                lineWidth: 0,
	                project: false,
	                opacity: data.opacity
	              };
	              this.textLabels = data.hovertext || data.text;
	              if (this.mode.indexOf("text") !== -1) {
	                if (this.textMarkers) this.textMarkers.update(textOptions);
	                else {
	                  this.textMarkers = createScatterPlot(textOptions);
	                  this.textMarkers._trace = this;
	                  this.textMarkers.highlightScale = 1;
	                  this.scene.glplot.add(this.textMarkers);
	                }
	              } else if (this.textMarkers) {
	                this.scene.glplot.remove(this.textMarkers);
	                this.textMarkers.dispose();
	                this.textMarkers = null;
	              }
	              errorOptions = {
	                gl: this.scene.glplot.gl,
	                position: options.position,
	                color: options.errorColor,
	                error: options.errorBounds,
	                lineWidth: options.errorLineWidth,
	                capSize: options.errorCapSize,
	                opacity: data.opacity
	              };
	              if (this.errorBars) {
	                if (options.errorBounds) {
	                  this.errorBars.update(errorOptions);
	                } else {
	                  this.scene.glplot.remove(this.errorBars);
	                  this.errorBars.dispose();
	                  this.errorBars = null;
	                }
	              } else if (options.errorBounds) {
	                this.errorBars = createErrorBars(errorOptions);
	                this.errorBars._trace = this;
	                this.scene.glplot.add(this.errorBars);
	              }
	              if (options.delaunayAxis >= 0) {
	                var delaunayOptions = constructDelaunay(options.position, options.delaunayColor, options.delaunayAxis);
	                delaunayOptions.opacity = data.opacity;
	                if (this.delaunayMesh) {
	                  this.delaunayMesh.update(delaunayOptions);
	                } else {
	                  delaunayOptions.gl = gl2;
	                  this.delaunayMesh = createMesh(delaunayOptions);
	                  this.delaunayMesh._trace = this;
	                  this.scene.glplot.add(this.delaunayMesh);
	                }
	              } else if (this.delaunayMesh) {
	                this.scene.glplot.remove(this.delaunayMesh);
	                this.delaunayMesh.dispose();
	                this.delaunayMesh = null;
	              }
	            };
	            proto.dispose = function() {
	              if (this.linePlot) {
	                this.scene.glplot.remove(this.linePlot);
	                this.linePlot.dispose();
	              }
	              if (this.scatterPlot) {
	                this.scene.glplot.remove(this.scatterPlot);
	                this.scatterPlot.dispose();
	              }
	              if (this.errorBars) {
	                this.scene.glplot.remove(this.errorBars);
	                this.errorBars.dispose();
	              }
	              if (this.textMarkers) {
	                this.scene.glplot.remove(this.textMarkers);
	                this.textMarkers.dispose();
	              }
	              if (this.delaunayMesh) {
	                this.scene.glplot.remove(this.delaunayMesh);
	                this.delaunayMesh.dispose();
	              }
	            };
	            function createLineWithMarkers(scene, data) {
	              var plot = new LineWithMarkers(scene, data.uid);
	              plot.update(data);
	              return plot;
	            }
	            module2.exports = createLineWithMarkers;
	          }
	        ),
	        /***/
	        21428: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var attributes = __webpack_require__2(44542);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("zhoverformat");
	              coerce("mode");
	              if (subTypes.hasLines(traceOut)) {
	                coerce("connectgaps");
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  noSelect: true,
	                  noAngle: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce, {
	                  noSelect: true
	                });
	              }
	              var lineColor = (traceOut.line || {}).color;
	              var markerColor = (traceOut.marker || {}).color;
	              if (coerce("surfaceaxis") >= 0) coerce("surfacecolor", lineColor || markerColor);
	              var dims = ["x", "y", "z"];
	              for (var i = 0; i < 3; ++i) {
	                var projection = "projection." + dims[i];
	                if (coerce(projection + ".show")) {
	                  coerce(projection + ".opacity");
	                  coerce(projection + ".scale");
	                }
	              }
	              var errorBarsSupplyDefaults = Registry.getComponentMethod("errorbars", "supplyDefaults");
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "z"
	              });
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "y",
	                inherit: "z"
	              });
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "x",
	                inherit: "z"
	              });
	            };
	            function handleXYZDefaults(traceIn, traceOut, coerce, layout) {
	              var len = 0;
	              var x = coerce("x");
	              var y = coerce("y");
	              var z = coerce("z");
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y", "z"], layout);
	              if (x && y && z) {
	                len = Math.min(x.length, y.length, z.length);
	                traceOut._length = traceOut._xlength = traceOut._ylength = traceOut._zlength = len;
	              }
	              return len;
	            }
	          }
	        ),
	        /***/
	        13551: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              plot: __webpack_require__2(58925),
	              attributes: __webpack_require__2(44542),
	              markerSymbols: __webpack_require__2(87381),
	              supplyDefaults: __webpack_require__2(21428),
	              colorbar: [{
	                container: "marker",
	                min: "cmin",
	                max: "cmax"
	              }, {
	                container: "line",
	                min: "cmin",
	                max: "cmax"
	              }],
	              calc: __webpack_require__2(36563),
	              moduleType: "trace",
	              name: "scatter3d",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "symbols", "showLegend", "scatter-like"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        97001: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterAttrs = __webpack_require__2(82196);
	            var baseAttrs = __webpack_require__2(9012);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterLineAttrs = scatterAttrs.line;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            module2.exports = {
	              carpet: {
	                valType: "string",
	                editType: "calc"
	              },
	              a: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              b: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              mode: extendFlat({}, scatterAttrs.mode, {
	                dflt: "markers"
	              }),
	              text: extendFlat({}, scatterAttrs.text, {}),
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["a", "b", "text"]
	              }),
	              hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
	              line: {
	                color: scatterLineAttrs.color,
	                width: scatterLineAttrs.width,
	                dash: scatterLineAttrs.dash,
	                backoff: scatterLineAttrs.backoff,
	                shape: extendFlat({}, scatterLineAttrs.shape, {
	                  values: ["linear", "spline"]
	                }),
	                smoothing: scatterLineAttrs.smoothing,
	                editType: "calc"
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              fill: extendFlat({}, scatterAttrs.fill, {
	                values: ["none", "toself", "tonext"],
	                dflt: "none"
	              }),
	              fillcolor: scatterAttrs.fillcolor,
	              marker: extendFlat({
	                symbol: scatterMarkerAttrs.symbol,
	                opacity: scatterMarkerAttrs.opacity,
	                maxdisplayed: scatterMarkerAttrs.maxdisplayed,
	                angle: scatterMarkerAttrs.angle,
	                angleref: scatterMarkerAttrs.angleref,
	                standoff: scatterMarkerAttrs.standoff,
	                size: scatterMarkerAttrs.size,
	                sizeref: scatterMarkerAttrs.sizeref,
	                sizemin: scatterMarkerAttrs.sizemin,
	                sizemode: scatterMarkerAttrs.sizemode,
	                line: extendFlat({
	                  width: scatterMarkerLineAttrs.width,
	                  editType: "calc"
	                }, colorScaleAttrs("marker.line")),
	                gradient: scatterMarkerAttrs.gradient,
	                editType: "calc"
	              }, colorScaleAttrs("marker")),
	              textfont: scatterAttrs.textfont,
	              textposition: scatterAttrs.textposition,
	              selected: scatterAttrs.selected,
	              unselected: scatterAttrs.unselected,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["a", "b", "text", "name"]
	              }),
	              hoveron: scatterAttrs.hoveron,
	              hovertemplate: hovertemplateAttrs()
	            };
	          }
	        ),
	        /***/
	        34618: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var calcColorscale = __webpack_require__2(36922);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            var lookupCarpet = __webpack_require__2(22882);
	            module2.exports = function calc(gd, trace) {
	              var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
	              if (!carpet || !carpet.visible || carpet.visible === "legendonly") return;
	              var i;
	              trace.xaxis = carpet.xaxis;
	              trace.yaxis = carpet.yaxis;
	              var serieslen = trace._length;
	              var cd = new Array(serieslen);
	              var a, b;
	              var needsCull = false;
	              for (i = 0; i < serieslen; i++) {
	                a = trace.a[i];
	                b = trace.b[i];
	                if (isNumeric(a) && isNumeric(b)) {
	                  var xy = carpet.ab2xy(+a, +b, true);
	                  var visible = carpet.isVisible(+a, +b);
	                  if (!visible) needsCull = true;
	                  cd[i] = {
	                    x: xy[0],
	                    y: xy[1],
	                    a,
	                    b,
	                    vis: visible
	                  };
	                } else cd[i] = {
	                  x: false,
	                  y: false
	                };
	              }
	              trace._needsCull = needsCull;
	              cd[0].carpet = carpet;
	              cd[0].trace = trace;
	              calcMarkerSize(trace, serieslen);
	              calcColorscale(gd, trace);
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        98965: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(47581);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleLineShapeDefaults = __webpack_require__2(94039);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var attributes = __webpack_require__2(97001);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              coerce("carpet");
	              traceOut.xaxis = "x";
	              traceOut.yaxis = "y";
	              var a = coerce("a");
	              var b = coerce("b");
	              var len = Math.min(a.length, b.length);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              coerce("text");
	              coerce("texttemplate");
	              coerce("hovertext");
	              var defaultMode = len < constants.PTS_LINESONLY ? "lines+markers" : "lines";
	              coerce("mode", defaultMode);
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  backoff: true
	                });
	                handleLineShapeDefaults(traceIn, traceOut, coerce);
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  gradient: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              var dfltHoverOn = [];
	              if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	                coerce("marker.maxdisplayed");
	                dfltHoverOn.push("points");
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	                if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	              }
	              if (traceOut.fill === "tonext" || traceOut.fill === "toself") {
	                dfltHoverOn.push("fills");
	              }
	              var hoverOn = coerce("hoveron", dfltHoverOn.join("+") || "points");
	              if (hoverOn !== "fills") coerce("hovertemplate");
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        16165: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt, trace, cd, pointNumber) {
	              var cdi = cd[pointNumber];
	              out.a = cdi.a;
	              out.b = cdi.b;
	              out.y = cdi.y;
	              return out;
	            };
	          }
	        ),
	        /***/
	        48953: (
	          /***/
	          function(module2) {
	            module2.exports = function formatLabels(cdi, trace) {
	              var labels = {};
	              var carpet = trace._carpet;
	              var ij = carpet.ab2ij([cdi.a, cdi.b]);
	              var i0 = Math.floor(ij[0]);
	              var ti = ij[0] - i0;
	              var j0 = Math.floor(ij[1]);
	              var tj = ij[1] - j0;
	              var xy = carpet.evalxy([], i0, j0, ti, tj);
	              labels.yLabel = xy[1].toFixed(3);
	              return labels;
	            };
	          }
	        ),
	        /***/
	        22931: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterHover = __webpack_require__2(33720);
	            var fillText = __webpack_require__2(71828).fillText;
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	              var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	              if (!scatterPointData || scatterPointData[0].index === false) return;
	              var newPointData = scatterPointData[0];
	              if (newPointData.index === undefined) {
	                var yFracUp = 1 - newPointData.y0 / pointData.ya._length;
	                var xLen = pointData.xa._length;
	                var xMin = xLen * yFracUp / 2;
	                var xMax = xLen - xMin;
	                newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
	                newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
	                return scatterPointData;
	              }
	              var cdi = newPointData.cd[newPointData.index];
	              newPointData.a = cdi.a;
	              newPointData.b = cdi.b;
	              newPointData.xLabelVal = undefined;
	              newPointData.yLabelVal = undefined;
	              var trace = newPointData.trace;
	              var carpet = trace._carpet;
	              var labels = trace._module.formatLabels(cdi, trace);
	              newPointData.yLabel = labels.yLabel;
	              delete newPointData.text;
	              var text = [];
	              function textPart(ax, val) {
	                var prefix;
	                if (ax.labelprefix && ax.labelprefix.length > 0) {
	                  prefix = ax.labelprefix.replace(/ = $/, "");
	                } else {
	                  prefix = ax._hovertitle;
	                }
	                text.push(prefix + ": " + val.toFixed(3) + ax.labelsuffix);
	              }
	              if (!trace.hovertemplate) {
	                var hoverinfo = cdi.hi || trace.hoverinfo;
	                var parts = hoverinfo.split("+");
	                if (parts.indexOf("all") !== -1) parts = ["a", "b", "text"];
	                if (parts.indexOf("a") !== -1) textPart(carpet.aaxis, cdi.a);
	                if (parts.indexOf("b") !== -1) textPart(carpet.baxis, cdi.b);
	                text.push("y: " + newPointData.yLabel);
	                if (parts.indexOf("text") !== -1) {
	                  fillText(cdi, trace, text);
	                }
	                newPointData.extraText = text.join("<br>");
	              }
	              return scatterPointData;
	            };
	          }
	        ),
	        /***/
	        46858: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(97001),
	              supplyDefaults: __webpack_require__2(98965),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(48953),
	              calc: __webpack_require__2(34618),
	              plot: __webpack_require__2(1913),
	              style: __webpack_require__2(16296).style,
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(22931),
	              selectPoints: __webpack_require__2(98002),
	              eventData: __webpack_require__2(16165),
	              moduleType: "trace",
	              name: "scattercarpet",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["svg", "carpet", "symbols", "showLegend", "carpetDependent", "zoomScale"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        1913: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterPlot = __webpack_require__2(32663);
	            var Axes = __webpack_require__2(89298);
	            var Drawing = __webpack_require__2(91424);
	            module2.exports = function plot(gd, plotinfoproxy, data, layer) {
	              var i, trace, node;
	              var carpet = data[0][0].carpet;
	              var xaxis = Axes.getFromId(gd, carpet.xaxis || "x");
	              var yaxis = Axes.getFromId(gd, carpet.yaxis || "y");
	              var plotinfo = {
	                xaxis,
	                yaxis,
	                plot: plotinfoproxy.plot
	              };
	              for (i = 0; i < data.length; i++) {
	                trace = data[i][0].trace;
	                trace._xA = xaxis;
	                trace._yA = yaxis;
	              }
	              scatterPlot(gd, plotinfo, data, layer);
	              for (i = 0; i < data.length; i++) {
	                trace = data[i][0].trace;
	                node = layer.selectAll("g.trace" + trace.uid + " .js-line");
	                Drawing.setClipUrl(node, data[i][0].carpet._clipPathId, gd);
	              }
	            };
	          }
	        ),
	        /***/
	        19316: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var scatterAttrs = __webpack_require__2(82196);
	            var baseAttrs = __webpack_require__2(9012);
	            var colorAttributes = __webpack_require__2(50693);
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterLineAttrs = scatterAttrs.line;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            module2.exports = overrideAll({
	              lon: {
	                valType: "data_array"
	              },
	              lat: {
	                valType: "data_array"
	              },
	              locations: {
	                valType: "data_array"
	              },
	              locationmode: {
	                valType: "enumerated",
	                values: ["ISO-3", "USA-states", "country names", "geojson-id"],
	                dflt: "ISO-3"
	              },
	              geojson: {
	                valType: "any",
	                editType: "calc"
	              },
	              featureidkey: {
	                valType: "string",
	                editType: "calc",
	                dflt: "id"
	              },
	              mode: extendFlat({}, scatterAttrs.mode, {
	                dflt: "markers"
	              }),
	              text: extendFlat({}, scatterAttrs.text, {}),
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["lat", "lon", "location", "text"]
	              }),
	              hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
	              textfont: scatterAttrs.textfont,
	              textposition: scatterAttrs.textposition,
	              line: {
	                color: scatterLineAttrs.color,
	                width: scatterLineAttrs.width,
	                dash
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              marker: extendFlat({
	                symbol: scatterMarkerAttrs.symbol,
	                opacity: scatterMarkerAttrs.opacity,
	                angle: scatterMarkerAttrs.angle,
	                angleref: extendFlat({}, scatterMarkerAttrs.angleref, {
	                  values: ["previous", "up", "north"]
	                }),
	                standoff: scatterMarkerAttrs.standoff,
	                size: scatterMarkerAttrs.size,
	                sizeref: scatterMarkerAttrs.sizeref,
	                sizemin: scatterMarkerAttrs.sizemin,
	                sizemode: scatterMarkerAttrs.sizemode,
	                colorbar: scatterMarkerAttrs.colorbar,
	                line: extendFlat({
	                  width: scatterMarkerLineAttrs.width
	                }, colorAttributes("marker.line")),
	                gradient: scatterMarkerAttrs.gradient
	              }, colorAttributes("marker")),
	              fill: {
	                valType: "enumerated",
	                values: ["none", "toself"],
	                dflt: "none"
	              },
	              fillcolor: scatterAttrs.fillcolor,
	              selected: scatterAttrs.selected,
	              unselected: scatterAttrs.unselected,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["lon", "lat", "location", "text", "name"]
	              }),
	              hovertemplate: hovertemplateAttrs()
	            }, "calc", "nested");
	          }
	        ),
	        /***/
	        84622: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var calcMarkerColorscale = __webpack_require__2(36922);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            var _ = __webpack_require__2(71828)._;
	            function isNonBlankString(v) {
	              return v && typeof v === "string";
	            }
	            module2.exports = function calc(gd, trace) {
	              var hasLocationData = Array.isArray(trace.locations);
	              var len = hasLocationData ? trace.locations.length : trace._length;
	              var calcTrace = new Array(len);
	              var isValidLoc;
	              if (trace.geojson) {
	                isValidLoc = function(v) {
	                  return isNonBlankString(v) || isNumeric(v);
	                };
	              } else {
	                isValidLoc = isNonBlankString;
	              }
	              for (var i = 0; i < len; i++) {
	                var calcPt = calcTrace[i] = {};
	                if (hasLocationData) {
	                  var loc = trace.locations[i];
	                  calcPt.loc = isValidLoc(loc) ? loc : null;
	                } else {
	                  var lon = trace.lon[i];
	                  var lat = trace.lat[i];
	                  if (isNumeric(lon) && isNumeric(lat)) calcPt.lonlat = [+lon, +lat];
	                  else calcPt.lonlat = [BADNUM, BADNUM];
	                }
	              }
	              arraysToCalcdata(calcTrace, trace);
	              calcMarkerColorscale(gd, trace);
	              calcSelection(calcTrace, trace);
	              if (len) {
	                calcTrace[0].t = {
	                  labels: {
	                    lat: _(gd, "lat:") + " ",
	                    lon: _(gd, "lon:") + " "
	                  }
	                };
	              }
	              return calcTrace;
	            };
	          }
	        ),
	        /***/
	        10659: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var attributes = __webpack_require__2(19316);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var locations = coerce("locations");
	              var len;
	              if (locations && locations.length) {
	                var geojson = coerce("geojson");
	                var locationmodeDflt;
	                if (typeof geojson === "string" && geojson !== "" || Lib.isPlainObject(geojson)) {
	                  locationmodeDflt = "geojson-id";
	                }
	                var locationMode = coerce("locationmode", locationmodeDflt);
	                if (locationMode === "geojson-id") {
	                  coerce("featureidkey");
	                }
	                len = locations.length;
	              } else {
	                var lon = coerce("lon") || [];
	                var lat = coerce("lat") || [];
	                len = Math.min(lon.length, lat.length);
	              }
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("mode");
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  gradient: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	              }
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        84084: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt, trace, cd, pointNumber) {
	              out.lon = pt.lon;
	              out.lat = pt.lat;
	              out.location = pt.loc ? pt.loc : null;
	              var cdi = cd[pointNumber];
	              if (cdi.fIn && cdi.fIn.properties) {
	                out.properties = cdi.fIn.properties;
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        82719: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var labels = {};
	              var geo = fullLayout[trace.geo]._subplot;
	              var ax = geo.mockAxis;
	              var lonlat = cdi.lonlat;
	              labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
	              labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
	              return labels;
	            };
	          }
	        ),
	        /***/
	        14977: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Fx = __webpack_require__2(30211);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var getTraceColor = __webpack_require__2(34603);
	            var fillText = __webpack_require__2(71828).fillText;
	            var attributes = __webpack_require__2(19316);
	            module2.exports = function hoverPoints(pointData, xval, yval) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var geo = pointData.subplot;
	              var isLonLatOverEdges = geo.projection.isLonLatOverEdges;
	              var project = geo.project;
	              function distFn(d) {
	                var lonlat2 = d.lonlat;
	                if (lonlat2[0] === BADNUM) return Infinity;
	                if (isLonLatOverEdges(lonlat2)) return Infinity;
	                var pt = project(lonlat2);
	                var px = project([xval, yval]);
	                var dx = Math.abs(pt[0] - px[0]);
	                var dy = Math.abs(pt[1] - px[1]);
	                var rad2 = Math.max(3, d.mrc || 0);
	                return Math.max(Math.sqrt(dx * dx + dy * dy) - rad2, 1 - 3 / rad2);
	              }
	              Fx.getClosest(cd, distFn, pointData);
	              if (pointData.index === false) return;
	              var di = cd[pointData.index];
	              var lonlat = di.lonlat;
	              var pos = [xa.c2p(lonlat), ya.c2p(lonlat)];
	              var rad = di.mrc || 1;
	              pointData.x0 = pos[0] - rad;
	              pointData.x1 = pos[0] + rad;
	              pointData.y0 = pos[1] - rad;
	              pointData.y1 = pos[1] + rad;
	              pointData.loc = di.loc;
	              pointData.lon = lonlat[0];
	              pointData.lat = lonlat[1];
	              var fullLayout = {};
	              fullLayout[trace.geo] = {
	                _subplot: geo
	              };
	              var labels = trace._module.formatLabels(di, trace, fullLayout);
	              pointData.lonLabel = labels.lonLabel;
	              pointData.latLabel = labels.latLabel;
	              pointData.color = getTraceColor(trace, di);
	              pointData.extraText = getExtraText(trace, di, pointData, cd[0].t.labels);
	              pointData.hovertemplate = trace.hovertemplate;
	              return [pointData];
	            };
	            function getExtraText(trace, pt, pointData, labels) {
	              if (trace.hovertemplate) return;
	              var hoverinfo = pt.hi || trace.hoverinfo;
	              var parts = hoverinfo === "all" ? attributes.hoverinfo.flags : hoverinfo.split("+");
	              var hasLocation = parts.indexOf("location") !== -1 && Array.isArray(trace.locations);
	              var hasLon = parts.indexOf("lon") !== -1;
	              var hasLat = parts.indexOf("lat") !== -1;
	              var hasText = parts.indexOf("text") !== -1;
	              var text = [];
	              function format(val) {
	                return val + "°";
	              }
	              if (hasLocation) {
	                text.push(pt.loc);
	              } else if (hasLon && hasLat) {
	                text.push("(" + format(pointData.latLabel) + ", " + format(pointData.lonLabel) + ")");
	              } else if (hasLon) {
	                text.push(labels.lon + format(pointData.lonLabel));
	              } else if (hasLat) {
	                text.push(labels.lat + format(pointData.latLabel));
	              }
	              if (hasText) {
	                fillText(pt, trace, text);
	              }
	              return text.join("<br>");
	            }
	          }
	        ),
	        /***/
	        17988: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(19316),
	              supplyDefaults: __webpack_require__2(10659),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(82719),
	              calc: __webpack_require__2(84622),
	              calcGeoJSON: __webpack_require__2(89171).calcGeoJSON,
	              plot: __webpack_require__2(89171).plot,
	              style: __webpack_require__2(33095),
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(14977),
	              eventData: __webpack_require__2(84084),
	              selectPoints: __webpack_require__2(20548),
	              moduleType: "trace",
	              name: "scattergeo",
	              basePlotModule: __webpack_require__2(44622),
	              categories: ["geo", "symbols", "showLegend", "scatter-like"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        89171: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var getTopojsonFeatures = __webpack_require__2(90973).getTopojsonFeatures;
	            var geoJsonUtils = __webpack_require__2(18214);
	            var geoUtils = __webpack_require__2(41327);
	            var findExtremes = __webpack_require__2(71739).findExtremes;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            var subTypes = __webpack_require__2(34098);
	            var style = __webpack_require__2(33095);
	            function plot(gd, geo, calcData) {
	              var scatterLayer = geo.layers.frontplot.select(".scatterlayer");
	              var gTraces = Lib.makeTraceGroups(scatterLayer, calcData, "trace scattergeo");
	              function removeBADNUM(d, node) {
	                if (d.lonlat[0] === BADNUM) {
	                  d3.select(node).remove();
	                }
	              }
	              gTraces.selectAll("*").remove();
	              gTraces.each(function(calcTrace) {
	                var s = d3.select(this);
	                var trace = calcTrace[0].trace;
	                if (subTypes.hasLines(trace) || trace.fill !== "none") {
	                  var lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
	                  var lineData = trace.fill !== "none" ? geoJsonUtils.makePolygon(lineCoords) : geoJsonUtils.makeLine(lineCoords);
	                  s.selectAll("path.js-line").data([{
	                    geojson: lineData,
	                    trace
	                  }]).enter().append("path").classed("js-line", true).style("stroke-miterlimit", 2);
	                }
	                if (subTypes.hasMarkers(trace)) {
	                  s.selectAll("path.point").data(Lib.identity).enter().append("path").classed("point", true).each(function(calcPt) {
	                    removeBADNUM(calcPt, this);
	                  });
	                }
	                if (subTypes.hasText(trace)) {
	                  s.selectAll("g").data(Lib.identity).enter().append("g").append("text").each(function(calcPt) {
	                    removeBADNUM(calcPt, this);
	                  });
	                }
	                style(gd, calcTrace);
	              });
	            }
	            function calcGeoJSON(calcTrace, fullLayout) {
	              var trace = calcTrace[0].trace;
	              var geoLayout = fullLayout[trace.geo];
	              var geo = geoLayout._subplot;
	              var len = trace._length;
	              var i, calcPt;
	              if (Array.isArray(trace.locations)) {
	                var locationmode = trace.locationmode;
	                var features = locationmode === "geojson-id" ? geoUtils.extractTraceFeature(calcTrace) : getTopojsonFeatures(trace, geo.topojson);
	                for (i = 0; i < len; i++) {
	                  calcPt = calcTrace[i];
	                  var feature = locationmode === "geojson-id" ? calcPt.fOut : geoUtils.locationToFeature(locationmode, calcPt.loc, features);
	                  calcPt.lonlat = feature ? feature.properties.ct : [BADNUM, BADNUM];
	                }
	              }
	              var opts = {
	                padded: true
	              };
	              var lonArray;
	              var latArray;
	              if (geoLayout.fitbounds === "geojson" && trace.locationmode === "geojson-id") {
	                var bboxGeojson = geoUtils.computeBbox(geoUtils.getTraceGeojson(trace));
	                lonArray = [bboxGeojson[0], bboxGeojson[2]];
	                latArray = [bboxGeojson[1], bboxGeojson[3]];
	              } else {
	                lonArray = new Array(len);
	                latArray = new Array(len);
	                for (i = 0; i < len; i++) {
	                  calcPt = calcTrace[i];
	                  lonArray[i] = calcPt.lonlat[0];
	                  latArray[i] = calcPt.lonlat[1];
	                }
	                opts.ppad = calcMarkerSize(trace, len);
	              }
	              trace._extremes.lon = findExtremes(geoLayout.lonaxis._ax, lonArray, opts);
	              trace._extremes.lat = findExtremes(geoLayout.lataxis._ax, latArray, opts);
	            }
	            module2.exports = {
	              calcGeoJSON,
	              plot
	            };
	          }
	        ),
	        /***/
	        20548: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var subtypes = __webpack_require__2(34098);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var trace = cd[0].trace;
	              var di, lonlat, x, y, i;
	              var hasOnlyLines = !subtypes.hasMarkers(trace) && !subtypes.hasText(trace);
	              if (hasOnlyLines) return [];
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  cd[i].selected = 0;
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  di = cd[i];
	                  lonlat = di.lonlat;
	                  if (lonlat[0] === BADNUM) continue;
	                  x = xa.c2p(lonlat);
	                  y = ya.c2p(lonlat);
	                  if (selectionTester.contains([x, y], null, i, searchInfo)) {
	                    selection.push({
	                      pointNumber: i,
	                      lon: lonlat[0],
	                      lat: lonlat[1]
	                    });
	                    di.selected = 1;
	                  } else {
	                    di.selected = 0;
	                  }
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        33095: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var scatterStyle = __webpack_require__2(16296);
	            var stylePoints = scatterStyle.stylePoints;
	            var styleText = scatterStyle.styleText;
	            module2.exports = function style(gd, calcTrace) {
	              if (calcTrace) styleTrace(gd, calcTrace);
	            };
	            function styleTrace(gd, calcTrace) {
	              var trace = calcTrace[0].trace;
	              var s = calcTrace[0].node3;
	              s.style("opacity", calcTrace[0].trace.opacity);
	              stylePoints(s, trace, gd);
	              styleText(s, trace, gd);
	              s.selectAll("path.js-line").style("fill", "none").each(function(d) {
	                var path = d3.select(this);
	                var trace2 = d.trace;
	                var line = trace2.line || {};
	                path.call(Color.stroke, line.color).call(Drawing.dashLine, line.dash || "", line.width || 0);
	                if (trace2.fill !== "none") {
	                  path.call(Color.fill, trace2.fillcolor);
	                }
	              });
	            }
	          }
	        ),
	        /***/
	        42341: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var baseAttrs = __webpack_require__2(9012);
	            var scatterAttrs = __webpack_require__2(82196);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var sortObjectKeys = __webpack_require__2(78607);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var DASHES = __webpack_require__2(78232).DASHES;
	            var scatterLineAttrs = scatterAttrs.line;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            var attrs = module2.exports = overrideAll({
	              x: scatterAttrs.x,
	              x0: scatterAttrs.x0,
	              dx: scatterAttrs.dx,
	              y: scatterAttrs.y,
	              y0: scatterAttrs.y0,
	              dy: scatterAttrs.dy,
	              xperiod: scatterAttrs.xperiod,
	              yperiod: scatterAttrs.yperiod,
	              xperiod0: scatterAttrs.xperiod0,
	              yperiod0: scatterAttrs.yperiod0,
	              xperiodalignment: scatterAttrs.xperiodalignment,
	              yperiodalignment: scatterAttrs.yperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              text: scatterAttrs.text,
	              hovertext: scatterAttrs.hovertext,
	              textposition: scatterAttrs.textposition,
	              textfont: scatterAttrs.textfont,
	              mode: {
	                valType: "flaglist",
	                flags: ["lines", "markers", "text"],
	                extras: ["none"]
	              },
	              line: {
	                color: scatterLineAttrs.color,
	                width: scatterLineAttrs.width,
	                shape: {
	                  valType: "enumerated",
	                  values: ["linear", "hv", "vh", "hvh", "vhv"],
	                  dflt: "linear",
	                  editType: "plot"
	                },
	                dash: {
	                  valType: "enumerated",
	                  values: sortObjectKeys(DASHES),
	                  dflt: "solid"
	                }
	              },
	              marker: extendFlat({}, colorScaleAttrs("marker"), {
	                symbol: scatterMarkerAttrs.symbol,
	                angle: scatterMarkerAttrs.angle,
	                size: scatterMarkerAttrs.size,
	                sizeref: scatterMarkerAttrs.sizeref,
	                sizemin: scatterMarkerAttrs.sizemin,
	                sizemode: scatterMarkerAttrs.sizemode,
	                opacity: scatterMarkerAttrs.opacity,
	                colorbar: scatterMarkerAttrs.colorbar,
	                line: extendFlat({}, colorScaleAttrs("marker.line"), {
	                  width: scatterMarkerLineAttrs.width
	                })
	              }),
	              connectgaps: scatterAttrs.connectgaps,
	              fill: extendFlat({}, scatterAttrs.fill, {
	                dflt: "none"
	              }),
	              fillcolor: scatterAttrs.fillcolor,
	              // no hoveron
	              selected: {
	                marker: scatterAttrs.selected.marker,
	                textfont: scatterAttrs.selected.textfont
	              },
	              unselected: {
	                marker: scatterAttrs.unselected.marker,
	                textfont: scatterAttrs.unselected.textfont
	              },
	              opacity: baseAttrs.opacity
	            }, "calc", "nested");
	            attrs.x.editType = attrs.y.editType = attrs.x0.editType = attrs.y0.editType = "calc+clearAxisTypes";
	            attrs.hovertemplate = scatterAttrs.hovertemplate;
	            attrs.texttemplate = scatterAttrs.texttemplate;
	          }
	        ),
	        /***/
	        72156: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hover = __webpack_require__2(20794);
	            module2.exports = {
	              moduleType: "trace",
	              name: "scattergl",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["gl", "regl", "cartesian", "symbols", "errorBarsOK", "showLegend", "scatter-like"],
	              attributes: __webpack_require__2(42341),
	              supplyDefaults: __webpack_require__2(47148),
	              crossTraceDefaults: __webpack_require__2(34936),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(68101),
	              calc: __webpack_require__2(45032),
	              hoverPoints: hover.hoverPoints,
	              selectPoints: __webpack_require__2(58147),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        45032: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var cluster = __webpack_require__2(88294);
	            var Lib = __webpack_require__2(71828);
	            var AxisIDs = __webpack_require__2(41675);
	            var findExtremes = __webpack_require__2(71739).findExtremes;
	            var alignPeriod = __webpack_require__2(42973);
	            var scatterCalc = __webpack_require__2(47761);
	            var calcMarkerSize = scatterCalc.calcMarkerSize;
	            var calcAxisExpansion = scatterCalc.calcAxisExpansion;
	            var setFirstScatter = scatterCalc.setFirstScatter;
	            var calcColorscale = __webpack_require__2(36922);
	            var convert = __webpack_require__2(19635);
	            var sceneUpdate = __webpack_require__2(38967);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var TOO_MANY_POINTS = __webpack_require__2(78232).TOO_MANY_POINTS;
	            module2.exports = function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var xa = trace._xA = AxisIDs.getFromId(gd, trace.xaxis, "x");
	              var ya = trace._yA = AxisIDs.getFromId(gd, trace.yaxis, "y");
	              var subplot = fullLayout._plots[trace.xaxis + trace.yaxis];
	              var len = trace._length;
	              var hasTooManyPoints = len >= TOO_MANY_POINTS;
	              var len2 = len * 2;
	              var stash = {};
	              var i;
	              var origX = xa.makeCalcdata(trace, "x");
	              var origY = ya.makeCalcdata(trace, "y");
	              var xObj = alignPeriod(trace, xa, "x", origX);
	              var yObj = alignPeriod(trace, ya, "y", origY);
	              var x = xObj.vals;
	              var y = yObj.vals;
	              trace._x = x;
	              trace._y = y;
	              if (trace.xperiodalignment) {
	                trace._origX = origX;
	                trace._xStarts = xObj.starts;
	                trace._xEnds = xObj.ends;
	              }
	              if (trace.yperiodalignment) {
	                trace._origY = origY;
	                trace._yStarts = yObj.starts;
	                trace._yEnds = yObj.ends;
	              }
	              var positions = new Array(len2);
	              var _ids = new Array(len);
	              for (i = 0; i < len; i++) {
	                positions[i * 2] = x[i] === BADNUM ? NaN : x[i];
	                positions[i * 2 + 1] = y[i] === BADNUM ? NaN : y[i];
	                _ids[i] = i;
	              }
	              if (xa.type === "log") {
	                for (i = 0; i < len2; i += 2) {
	                  positions[i] = xa.c2l(positions[i]);
	                }
	              }
	              if (ya.type === "log") {
	                for (i = 1; i < len2; i += 2) {
	                  positions[i] = ya.c2l(positions[i]);
	                }
	              }
	              if (hasTooManyPoints && xa.type !== "log" && ya.type !== "log") {
	                stash.tree = cluster(positions);
	              } else {
	                stash.ids = _ids;
	              }
	              calcColorscale(gd, trace);
	              var opts = sceneOptions(gd, subplot, trace, positions, x, y);
	              var scene = sceneUpdate(gd, subplot);
	              setFirstScatter(fullLayout, trace);
	              var ppad;
	              if (!hasTooManyPoints) {
	                ppad = calcMarkerSize(trace, len);
	              } else if (opts.marker) {
	                ppad = opts.marker.sizeAvg || Math.max(opts.marker.size, 3);
	              }
	              calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
	              if (opts.errorX) expandForErrorBars(trace, xa, opts.errorX);
	              if (opts.errorY) expandForErrorBars(trace, ya, opts.errorY);
	              if (opts.fill && !scene.fill2d) scene.fill2d = true;
	              if (opts.marker && !scene.scatter2d) scene.scatter2d = true;
	              if (opts.line && !scene.line2d) scene.line2d = true;
	              if ((opts.errorX || opts.errorY) && !scene.error2d) scene.error2d = true;
	              if (opts.text && !scene.glText) scene.glText = true;
	              if (opts.marker) opts.marker.snap = len;
	              scene.lineOptions.push(opts.line);
	              scene.errorXOptions.push(opts.errorX);
	              scene.errorYOptions.push(opts.errorY);
	              scene.fillOptions.push(opts.fill);
	              scene.markerOptions.push(opts.marker);
	              scene.markerSelectedOptions.push(opts.markerSel);
	              scene.markerUnselectedOptions.push(opts.markerUnsel);
	              scene.textOptions.push(opts.text);
	              scene.textSelectedOptions.push(opts.textSel);
	              scene.textUnselectedOptions.push(opts.textUnsel);
	              scene.selectBatch.push([]);
	              scene.unselectBatch.push([]);
	              stash._scene = scene;
	              stash.index = scene.count;
	              stash.x = x;
	              stash.y = y;
	              stash.positions = positions;
	              scene.count++;
	              return [{
	                x: false,
	                y: false,
	                t: stash,
	                trace
	              }];
	            };
	            function expandForErrorBars(trace, ax, opts) {
	              var extremes = trace._extremes[ax._id];
	              var errExt = findExtremes(ax, opts._bnds, {
	                padded: true
	              });
	              extremes.min = extremes.min.concat(errExt.min);
	              extremes.max = extremes.max.concat(errExt.max);
	            }
	            function sceneOptions(gd, subplot, trace, positions, x, y) {
	              var opts = convert.style(gd, trace);
	              if (opts.marker) {
	                opts.marker.positions = positions;
	              }
	              if (opts.line && positions.length > 1) {
	                Lib.extendFlat(opts.line, convert.linePositions(gd, trace, positions));
	              }
	              if (opts.errorX || opts.errorY) {
	                var errors = convert.errorBarPositions(gd, trace, positions, x, y);
	                if (opts.errorX) {
	                  Lib.extendFlat(opts.errorX, errors.x);
	                }
	                if (opts.errorY) {
	                  Lib.extendFlat(opts.errorY, errors.y);
	                }
	              }
	              if (opts.text) {
	                Lib.extendFlat(opts.text, {
	                  positions
	                }, convert.textPosition(gd, trace, opts.text, opts.marker));
	                Lib.extendFlat(opts.textSel, {
	                  positions
	                }, convert.textPosition(gd, trace, opts.text, opts.markerSel));
	                Lib.extendFlat(opts.textUnsel, {
	                  positions
	                }, convert.textPosition(gd, trace, opts.text, opts.markerUnsel));
	              }
	              return opts;
	            }
	          }
	        ),
	        /***/
	        78232: (
	          /***/
	          function(module2) {
	            var SYMBOL_SIZE = 20;
	            module2.exports = {
	              TOO_MANY_POINTS: 1e5,
	              SYMBOL_SDF_SIZE: 200,
	              SYMBOL_SIZE,
	              SYMBOL_STROKE: SYMBOL_SIZE / 20,
	              DOT_RE: /-dot/,
	              OPEN_RE: /-open/,
	              DASHES: {
	                solid: [1],
	                dot: [1, 1],
	                dash: [4, 1],
	                longdash: [8, 1],
	                dashdot: [4, 1, 1, 1],
	                longdashdot: [8, 1, 1, 1]
	              }
	            };
	          }
	        ),
	        /***/
	        19635: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var svgSdf = __webpack_require__2(82019);
	            var rgba = __webpack_require__2(25075);
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var AxisIDs = __webpack_require__2(41675);
	            var formatColor = __webpack_require__2(81697).formatColor;
	            var subTypes = __webpack_require__2(34098);
	            var makeBubbleSizeFn = __webpack_require__2(39984);
	            var helpers = __webpack_require__2(68645);
	            var constants = __webpack_require__2(78232);
	            var DESELECTDIM = __webpack_require__2(37822).DESELECTDIM;
	            var TEXTOFFSETSIGN = {
	              start: 1,
	              left: 1,
	              end: -1,
	              right: -1,
	              middle: 0,
	              center: 0,
	              bottom: 1,
	              top: -1
	            };
	            var appendArrayPointValue = __webpack_require__2(23469).appendArrayPointValue;
	            function convertStyle(gd, trace) {
	              var i;
	              var opts = {
	                marker: undefined,
	                markerSel: undefined,
	                markerUnsel: undefined,
	                line: undefined,
	                fill: undefined,
	                errorX: undefined,
	                errorY: undefined,
	                text: undefined,
	                textSel: undefined,
	                textUnsel: undefined
	              };
	              var plotGlPixelRatio = gd._context.plotGlPixelRatio;
	              if (trace.visible !== true) return opts;
	              if (subTypes.hasText(trace)) {
	                opts.text = convertTextStyle(gd, trace);
	                opts.textSel = convertTextSelection(gd, trace, trace.selected);
	                opts.textUnsel = convertTextSelection(gd, trace, trace.unselected);
	              }
	              if (subTypes.hasMarkers(trace)) {
	                opts.marker = convertMarkerStyle(gd, trace);
	                opts.markerSel = convertMarkerSelection(gd, trace, trace.selected);
	                opts.markerUnsel = convertMarkerSelection(gd, trace, trace.unselected);
	                if (!trace.unselected && Lib.isArrayOrTypedArray(trace.marker.opacity)) {
	                  var mo = trace.marker.opacity;
	                  opts.markerUnsel.opacity = new Array(mo.length);
	                  for (i = 0; i < mo.length; i++) {
	                    opts.markerUnsel.opacity[i] = DESELECTDIM * mo[i];
	                  }
	                }
	              }
	              if (subTypes.hasLines(trace)) {
	                opts.line = {
	                  overlay: true,
	                  thickness: trace.line.width * plotGlPixelRatio,
	                  color: trace.line.color,
	                  opacity: trace.opacity
	                };
	                var dashes = (constants.DASHES[trace.line.dash] || [1]).slice();
	                for (i = 0; i < dashes.length; ++i) {
	                  dashes[i] *= trace.line.width * plotGlPixelRatio;
	                }
	                opts.line.dashes = dashes;
	              }
	              if (trace.error_x && trace.error_x.visible) {
	                opts.errorX = convertErrorBarStyle(trace, trace.error_x, plotGlPixelRatio);
	              }
	              if (trace.error_y && trace.error_y.visible) {
	                opts.errorY = convertErrorBarStyle(trace, trace.error_y, plotGlPixelRatio);
	              }
	              if (!!trace.fill && trace.fill !== "none") {
	                opts.fill = {
	                  closed: true,
	                  fill: trace.fillcolor,
	                  thickness: 0
	                };
	              }
	              return opts;
	            }
	            function convertTextStyle(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var count = trace._length;
	              var textfontIn = trace.textfont;
	              var textpositionIn = trace.textposition;
	              var textPos = Array.isArray(textpositionIn) ? textpositionIn : [textpositionIn];
	              var tfc = textfontIn.color;
	              var tfs = textfontIn.size;
	              var tff = textfontIn.family;
	              var optsOut = {};
	              var i;
	              var plotGlPixelRatio = gd._context.plotGlPixelRatio;
	              var texttemplate = trace.texttemplate;
	              if (texttemplate) {
	                optsOut.text = [];
	                var d3locale = fullLayout._d3locale;
	                var isArray = Array.isArray(texttemplate);
	                var N = isArray ? Math.min(texttemplate.length, count) : count;
	                var txt = isArray ? function(i2) {
	                  return texttemplate[i2];
	                } : function() {
	                  return texttemplate;
	                };
	                for (i = 0; i < N; i++) {
	                  var d = {
	                    i
	                  };
	                  var labels = trace._module.formatLabels(d, trace, fullLayout);
	                  var pointValues = {};
	                  appendArrayPointValue(pointValues, trace, i);
	                  var meta = trace._meta || {};
	                  optsOut.text.push(Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta));
	                }
	              } else {
	                if (Array.isArray(trace.text) && trace.text.length < count) {
	                  optsOut.text = trace.text.slice();
	                } else {
	                  optsOut.text = trace.text;
	                }
	              }
	              if (Array.isArray(optsOut.text)) {
	                for (i = optsOut.text.length; i < count; i++) {
	                  optsOut.text[i] = "";
	                }
	              }
	              optsOut.opacity = trace.opacity;
	              optsOut.font = {};
	              optsOut.align = [];
	              optsOut.baseline = [];
	              for (i = 0; i < textPos.length; i++) {
	                var tp = textPos[i].split(/\s+/);
	                switch (tp[1]) {
	                  case "left":
	                    optsOut.align.push("right");
	                    break;
	                  case "right":
	                    optsOut.align.push("left");
	                    break;
	                  default:
	                    optsOut.align.push(tp[1]);
	                }
	                switch (tp[0]) {
	                  case "top":
	                    optsOut.baseline.push("bottom");
	                    break;
	                  case "bottom":
	                    optsOut.baseline.push("top");
	                    break;
	                  default:
	                    optsOut.baseline.push(tp[0]);
	                }
	              }
	              if (Array.isArray(tfc)) {
	                optsOut.color = new Array(count);
	                for (i = 0; i < count; i++) {
	                  optsOut.color[i] = tfc[i];
	                }
	              } else {
	                optsOut.color = tfc;
	              }
	              if (Lib.isArrayOrTypedArray(tfs) || Array.isArray(tff)) {
	                optsOut.font = new Array(count);
	                for (i = 0; i < count; i++) {
	                  var fonti = optsOut.font[i] = {};
	                  fonti.size = (Lib.isTypedArray(tfs) ? tfs[i] : Array.isArray(tfs) ? isNumeric(tfs[i]) ? tfs[i] : 0 : tfs) * plotGlPixelRatio;
	                  fonti.family = Array.isArray(tff) ? tff[i] : tff;
	                }
	              } else {
	                optsOut.font = {
	                  size: tfs * plotGlPixelRatio,
	                  family: tff
	                };
	              }
	              return optsOut;
	            }
	            function convertMarkerStyle(gd, trace) {
	              var count = trace._length;
	              var optsIn = trace.marker;
	              var optsOut = {};
	              var i;
	              var multiSymbol = Lib.isArrayOrTypedArray(optsIn.symbol);
	              var multiAngle = Lib.isArrayOrTypedArray(optsIn.angle);
	              var multiColor = Lib.isArrayOrTypedArray(optsIn.color);
	              var multiLineColor = Lib.isArrayOrTypedArray(optsIn.line.color);
	              var multiOpacity = Lib.isArrayOrTypedArray(optsIn.opacity);
	              var multiSize = Lib.isArrayOrTypedArray(optsIn.size);
	              var multiLineWidth = Lib.isArrayOrTypedArray(optsIn.line.width);
	              var isOpen;
	              if (!multiSymbol) isOpen = helpers.isOpenSymbol(optsIn.symbol);
	              if (multiSymbol || multiColor || multiLineColor || multiOpacity || multiAngle) {
	                optsOut.symbols = new Array(count);
	                optsOut.angles = new Array(count);
	                optsOut.colors = new Array(count);
	                optsOut.borderColors = new Array(count);
	                var symbols = optsIn.symbol;
	                var angles = optsIn.angle;
	                var colors = formatColor(optsIn, optsIn.opacity, count);
	                var borderColors = formatColor(optsIn.line, optsIn.opacity, count);
	                if (!Array.isArray(borderColors[0])) {
	                  var borderColor = borderColors;
	                  borderColors = Array(count);
	                  for (i = 0; i < count; i++) {
	                    borderColors[i] = borderColor;
	                  }
	                }
	                if (!Array.isArray(colors[0])) {
	                  var color = colors;
	                  colors = Array(count);
	                  for (i = 0; i < count; i++) {
	                    colors[i] = color;
	                  }
	                }
	                if (!Array.isArray(symbols)) {
	                  var symbol = symbols;
	                  symbols = Array(count);
	                  for (i = 0; i < count; i++) {
	                    symbols[i] = symbol;
	                  }
	                }
	                if (!Array.isArray(angles)) {
	                  var angle = angles;
	                  angles = Array(count);
	                  for (i = 0; i < count; i++) {
	                    angles[i] = angle;
	                  }
	                }
	                optsOut.symbols = symbols;
	                optsOut.angles = angles;
	                optsOut.colors = colors;
	                optsOut.borderColors = borderColors;
	                for (i = 0; i < count; i++) {
	                  if (multiSymbol) {
	                    isOpen = helpers.isOpenSymbol(optsIn.symbol[i]);
	                  }
	                  if (isOpen) {
	                    borderColors[i] = colors[i].slice();
	                    colors[i] = colors[i].slice();
	                    colors[i][3] = 0;
	                  }
	                }
	                optsOut.opacity = trace.opacity;
	                optsOut.markers = new Array(count);
	                for (i = 0; i < count; i++) {
	                  optsOut.markers[i] = getSymbolSdf({
	                    mx: optsOut.symbols[i],
	                    ma: optsOut.angles[i]
	                  }, trace);
	                }
	              } else {
	                if (isOpen) {
	                  optsOut.color = rgba(optsIn.color, "uint8");
	                  optsOut.color[3] = 0;
	                  optsOut.borderColor = rgba(optsIn.color, "uint8");
	                } else {
	                  optsOut.color = rgba(optsIn.color, "uint8");
	                  optsOut.borderColor = rgba(optsIn.line.color, "uint8");
	                }
	                optsOut.opacity = trace.opacity * optsIn.opacity;
	                optsOut.marker = getSymbolSdf({
	                  mx: optsIn.symbol,
	                  ma: optsIn.angle
	                }, trace);
	              }
	              var sizeFactor = 1;
	              var markerSizeFunc = makeBubbleSizeFn(trace, sizeFactor);
	              var s;
	              if (multiSize || multiLineWidth) {
	                var sizes = optsOut.sizes = new Array(count);
	                var borderSizes = optsOut.borderSizes = new Array(count);
	                var sizeTotal = 0;
	                var sizeAvg;
	                if (multiSize) {
	                  for (i = 0; i < count; i++) {
	                    sizes[i] = markerSizeFunc(optsIn.size[i]);
	                    sizeTotal += sizes[i];
	                  }
	                  sizeAvg = sizeTotal / count;
	                } else {
	                  s = markerSizeFunc(optsIn.size);
	                  for (i = 0; i < count; i++) {
	                    sizes[i] = s;
	                  }
	                }
	                if (multiLineWidth) {
	                  for (i = 0; i < count; i++) {
	                    borderSizes[i] = optsIn.line.width[i];
	                  }
	                } else {
	                  s = optsIn.line.width;
	                  for (i = 0; i < count; i++) {
	                    borderSizes[i] = s;
	                  }
	                }
	                optsOut.sizeAvg = sizeAvg;
	              } else {
	                optsOut.size = markerSizeFunc(optsIn && optsIn.size || 10);
	                optsOut.borderSizes = markerSizeFunc(optsIn.line.width);
	              }
	              return optsOut;
	            }
	            function convertMarkerSelection(gd, trace, target) {
	              var optsIn = trace.marker;
	              var optsOut = {};
	              if (!target) return optsOut;
	              if (target.marker && target.marker.symbol) {
	                optsOut = convertMarkerStyle(gd, Lib.extendFlat({}, optsIn, target.marker));
	              } else if (target.marker) {
	                if (target.marker.size) optsOut.size = target.marker.size;
	                if (target.marker.color) optsOut.colors = target.marker.color;
	                if (target.marker.opacity !== undefined) optsOut.opacity = target.marker.opacity;
	              }
	              return optsOut;
	            }
	            function convertTextSelection(gd, trace, target) {
	              var optsOut = {};
	              if (!target) return optsOut;
	              if (target.textfont) {
	                var optsIn = {
	                  opacity: 1,
	                  text: trace.text,
	                  texttemplate: trace.texttemplate,
	                  textposition: trace.textposition,
	                  textfont: Lib.extendFlat({}, trace.textfont)
	                };
	                if (target.textfont) {
	                  Lib.extendFlat(optsIn.textfont, target.textfont);
	                }
	                optsOut = convertTextStyle(gd, optsIn);
	              }
	              return optsOut;
	            }
	            function convertErrorBarStyle(trace, target, plotGlPixelRatio) {
	              var optsOut = {
	                capSize: target.width * 2 * plotGlPixelRatio,
	                lineWidth: target.thickness * plotGlPixelRatio,
	                color: target.color
	              };
	              if (target.copy_ystyle) {
	                optsOut = trace.error_y;
	              }
	              return optsOut;
	            }
	            var SYMBOL_SDF_SIZE = constants.SYMBOL_SDF_SIZE;
	            var SYMBOL_SIZE = constants.SYMBOL_SIZE;
	            var SYMBOL_STROKE = constants.SYMBOL_STROKE;
	            var SYMBOL_SDF = {};
	            var SYMBOL_SVG_CIRCLE = Drawing.symbolFuncs[0](SYMBOL_SIZE * 0.05);
	            function getSymbolSdf(d, trace) {
	              var symbol = d.mx;
	              if (symbol === "circle") return null;
	              var symbolPath, symbolSdf;
	              var symbolNumber = Drawing.symbolNumber(symbol);
	              var symbolFunc = Drawing.symbolFuncs[symbolNumber % 100];
	              var symbolNoDot = !!Drawing.symbolNoDot[symbolNumber % 100];
	              var symbolNoFill = !!Drawing.symbolNoFill[symbolNumber % 100];
	              var isDot = helpers.isDotSymbol(symbol);
	              if (d.ma) symbol += "_" + d.ma;
	              if (SYMBOL_SDF[symbol]) return SYMBOL_SDF[symbol];
	              var angle = Drawing.getMarkerAngle(d, trace);
	              if (isDot && !symbolNoDot) {
	                symbolPath = symbolFunc(SYMBOL_SIZE * 1.1, angle) + SYMBOL_SVG_CIRCLE;
	              } else {
	                symbolPath = symbolFunc(SYMBOL_SIZE, angle);
	              }
	              symbolSdf = svgSdf(symbolPath, {
	                w: SYMBOL_SDF_SIZE,
	                h: SYMBOL_SDF_SIZE,
	                viewBox: [-SYMBOL_SIZE, -SYMBOL_SIZE, SYMBOL_SIZE, SYMBOL_SIZE],
	                stroke: symbolNoFill ? SYMBOL_STROKE : -SYMBOL_STROKE
	              });
	              SYMBOL_SDF[symbol] = symbolSdf;
	              return symbolSdf || null;
	            }
	            function convertLinePositions(gd, trace, positions) {
	              var len = positions.length;
	              var count = len / 2;
	              var linePositions;
	              var i;
	              if (subTypes.hasLines(trace) && count) {
	                if (trace.line.shape === "hv") {
	                  linePositions = [];
	                  for (i = 0; i < count - 1; i++) {
	                    if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
	                      linePositions.push(NaN, NaN, NaN, NaN);
	                    } else {
	                      linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                      if (!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
	                        linePositions.push(positions[i * 2 + 2], positions[i * 2 + 1]);
	                      } else {
	                        linePositions.push(NaN, NaN);
	                      }
	                    }
	                  }
	                  linePositions.push(positions[len - 2], positions[len - 1]);
	                } else if (trace.line.shape === "hvh") {
	                  linePositions = [];
	                  for (i = 0; i < count - 1; i++) {
	                    if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
	                      if (!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
	                        linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                      } else {
	                        linePositions.push(NaN, NaN);
	                      }
	                      linePositions.push(NaN, NaN);
	                    } else {
	                      var midPtX = (positions[i * 2] + positions[i * 2 + 2]) / 2;
	                      linePositions.push(positions[i * 2], positions[i * 2 + 1], midPtX, positions[i * 2 + 1], midPtX, positions[i * 2 + 3]);
	                    }
	                  }
	                  linePositions.push(positions[len - 2], positions[len - 1]);
	                } else if (trace.line.shape === "vhv") {
	                  linePositions = [];
	                  for (i = 0; i < count - 1; i++) {
	                    if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
	                      if (!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
	                        linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                      } else {
	                        linePositions.push(NaN, NaN);
	                      }
	                      linePositions.push(NaN, NaN);
	                    } else {
	                      var midPtY = (positions[i * 2 + 1] + positions[i * 2 + 3]) / 2;
	                      linePositions.push(positions[i * 2], positions[i * 2 + 1], positions[i * 2], midPtY, positions[i * 2 + 2], midPtY);
	                    }
	                  }
	                  linePositions.push(positions[len - 2], positions[len - 1]);
	                } else if (trace.line.shape === "vh") {
	                  linePositions = [];
	                  for (i = 0; i < count - 1; i++) {
	                    if (isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
	                      linePositions.push(NaN, NaN, NaN, NaN);
	                    } else {
	                      linePositions.push(positions[i * 2], positions[i * 2 + 1]);
	                      if (!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
	                        linePositions.push(positions[i * 2], positions[i * 2 + 3]);
	                      } else {
	                        linePositions.push(NaN, NaN);
	                      }
	                    }
	                  }
	                  linePositions.push(positions[len - 2], positions[len - 1]);
	                } else {
	                  linePositions = positions;
	                }
	              }
	              var hasNaN = false;
	              for (i = 0; i < linePositions.length; i++) {
	                if (isNaN(linePositions[i])) {
	                  hasNaN = true;
	                  break;
	                }
	              }
	              var join = hasNaN || linePositions.length > constants.TOO_MANY_POINTS ? "rect" : subTypes.hasMarkers(trace) ? "rect" : "round";
	              if (hasNaN && trace.connectgaps) {
	                var lastX = linePositions[0];
	                var lastY = linePositions[1];
	                for (i = 0; i < linePositions.length; i += 2) {
	                  if (isNaN(linePositions[i]) || isNaN(linePositions[i + 1])) {
	                    linePositions[i] = lastX;
	                    linePositions[i + 1] = lastY;
	                  } else {
	                    lastX = linePositions[i];
	                    lastY = linePositions[i + 1];
	                  }
	                }
	              }
	              return {
	                join,
	                positions: linePositions
	              };
	            }
	            function convertErrorBarPositions(gd, trace, positions, x, y) {
	              var makeComputeError = Registry.getComponentMethod("errorbars", "makeComputeError");
	              var xa = AxisIDs.getFromId(gd, trace.xaxis, "x");
	              var ya = AxisIDs.getFromId(gd, trace.yaxis, "y");
	              var count = positions.length / 2;
	              var out = {};
	              function convertOneAxis(coords, ax) {
	                var axLetter = ax._id.charAt(0);
	                var opts = trace["error_" + axLetter];
	                if (opts && opts.visible && (ax.type === "linear" || ax.type === "log")) {
	                  var computeError = makeComputeError(opts);
	                  var pOffset = {
	                    x: 0,
	                    y: 1
	                  }[axLetter];
	                  var eOffset = {
	                    x: [0, 1, 2, 3],
	                    y: [2, 3, 0, 1]
	                  }[axLetter];
	                  var errors = new Float64Array(4 * count);
	                  var minShoe = Infinity;
	                  var maxHat = -Infinity;
	                  for (var i = 0, j = 0; i < count; i++, j += 4) {
	                    var dc = coords[i];
	                    if (isNumeric(dc)) {
	                      var dl = positions[i * 2 + pOffset];
	                      var vals = computeError(dc, i);
	                      var lv = vals[0];
	                      var hv = vals[1];
	                      if (isNumeric(lv) && isNumeric(hv)) {
	                        var shoe = dc - lv;
	                        var hat = dc + hv;
	                        errors[j + eOffset[0]] = dl - ax.c2l(shoe);
	                        errors[j + eOffset[1]] = ax.c2l(hat) - dl;
	                        errors[j + eOffset[2]] = 0;
	                        errors[j + eOffset[3]] = 0;
	                        minShoe = Math.min(minShoe, dc - lv);
	                        maxHat = Math.max(maxHat, dc + hv);
	                      }
	                    }
	                  }
	                  out[axLetter] = {
	                    positions,
	                    errors,
	                    _bnds: [minShoe, maxHat]
	                  };
	                }
	              }
	              convertOneAxis(x, xa);
	              convertOneAxis(y, ya);
	              return out;
	            }
	            function convertTextPosition(gd, trace, textOpts, markerOpts) {
	              var count = trace._length;
	              var out = {};
	              var i;
	              if (subTypes.hasMarkers(trace)) {
	                var fontOpts = textOpts.font;
	                var align = textOpts.align;
	                var baseline = textOpts.baseline;
	                out.offset = new Array(count);
	                for (i = 0; i < count; i++) {
	                  var ms = markerOpts.sizes ? markerOpts.sizes[i] : markerOpts.size;
	                  var fs = Array.isArray(fontOpts) ? fontOpts[i].size : fontOpts.size;
	                  var a = Array.isArray(align) ? align.length > 1 ? align[i] : align[0] : align;
	                  var b = Array.isArray(baseline) ? baseline.length > 1 ? baseline[i] : baseline[0] : baseline;
	                  var hSign = TEXTOFFSETSIGN[a];
	                  var vSign = TEXTOFFSETSIGN[b];
	                  var xPad = ms ? ms / 0.8 + 1 : 0;
	                  var yPad = -vSign * xPad - vSign * 0.5;
	                  out.offset[i] = [hSign * xPad / fs, yPad / fs];
	                }
	              }
	              return out;
	            }
	            module2.exports = {
	              style: convertStyle,
	              markerStyle: convertMarkerStyle,
	              markerSelection: convertMarkerSelection,
	              linePositions: convertLinePositions,
	              errorBarPositions: convertErrorBarPositions,
	              textPosition: convertTextPosition
	            };
	          }
	        ),
	        /***/
	        47148: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var helpers = __webpack_require__2(68645);
	            var attributes = __webpack_require__2(42341);
	            var constants = __webpack_require__2(47581);
	            var subTypes = __webpack_require__2(34098);
	            var handleXYDefaults = __webpack_require__2(67513);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var handleTextDefaults = __webpack_require__2(82410);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var isOpen = traceIn.marker ? helpers.isOpenSymbol(traceIn.marker.symbol) : false;
	              var isBubble = subTypes.isBubble(traceIn);
	              var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              var defaultMode = len < constants.PTS_LINESONLY ? "lines+markers" : "lines";
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("mode", defaultMode);
	              if (subTypes.hasLines(traceOut)) {
	                coerce("connectgaps");
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	                coerce("line.shape");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  noAngleRef: true,
	                  noStandOff: true
	                });
	                coerce("marker.line.width", isOpen || isBubble ? 1 : 0);
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              var lineColor = (traceOut.line || {}).color;
	              var markerColor = (traceOut.marker || {}).color;
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	              }
	              var errorBarsSupplyDefaults = Registry.getComponentMethod("errorbars", "supplyDefaults");
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "y"
	              });
	              errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {
	                axis: "x",
	                inherit: "y"
	              });
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        5345: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var DESELECTDIM = __webpack_require__2(37822).DESELECTDIM;
	            function styleTextSelection(cd) {
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var stash = cd0.t;
	              var scene = stash._scene;
	              var index = stash.index;
	              var els = scene.selectBatch[index];
	              var unels = scene.unselectBatch[index];
	              var baseOpts = scene.textOptions[index];
	              var selOpts = scene.textSelectedOptions[index] || {};
	              var unselOpts = scene.textUnselectedOptions[index] || {};
	              var opts = Lib.extendFlat({}, baseOpts);
	              var i, j;
	              if (els.length || unels.length) {
	                var stc = selOpts.color;
	                var utc = unselOpts.color;
	                var base = baseOpts.color;
	                var hasArrayBase = Array.isArray(base);
	                opts.color = new Array(trace._length);
	                for (i = 0; i < els.length; i++) {
	                  j = els[i];
	                  opts.color[j] = stc || (hasArrayBase ? base[j] : base);
	                }
	                for (i = 0; i < unels.length; i++) {
	                  j = unels[i];
	                  var basej = hasArrayBase ? base[j] : base;
	                  opts.color[j] = utc ? utc : stc ? basej : Color.addOpacity(basej, DESELECTDIM);
	                }
	              }
	              scene.glText[index].update(opts);
	            }
	            module2.exports = {
	              styleTextSelection
	            };
	          }
	        ),
	        /***/
	        68101: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterFormatLabels = __webpack_require__2(8225);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var i = cdi.i;
	              if (!("x" in cdi)) cdi.x = trace._x[i];
	              if (!("y" in cdi)) cdi.y = trace._y[i];
	              return scatterFormatLabels(cdi, trace, fullLayout);
	            };
	          }
	        ),
	        /***/
	        68645: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var constants = __webpack_require__2(78232);
	            exports2.isOpenSymbol = function(symbol) {
	              return typeof symbol === "string" ? constants.OPEN_RE.test(symbol) : symbol % 200 > 100;
	            };
	            exports2.isDotSymbol = function(symbol) {
	              return typeof symbol === "string" ? constants.DOT_RE.test(symbol) : symbol > 200;
	            };
	          }
	        ),
	        /***/
	        20794: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var getTraceColor = __webpack_require__2(34603);
	            function hoverPoints(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var stash = cd[0].t;
	              var trace = cd[0].trace;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var x = stash.x;
	              var y = stash.y;
	              var xpx = xa.c2p(xval);
	              var ypx = ya.c2p(yval);
	              var maxDistance = pointData.distance;
	              var ids;
	              if (stash.tree) {
	                var xl = xa.p2c(xpx - maxDistance);
	                var xr = xa.p2c(xpx + maxDistance);
	                var yl = ya.p2c(ypx - maxDistance);
	                var yr = ya.p2c(ypx + maxDistance);
	                if (hovermode === "x") {
	                  ids = stash.tree.range(Math.min(xl, xr), Math.min(ya._rl[0], ya._rl[1]), Math.max(xl, xr), Math.max(ya._rl[0], ya._rl[1]));
	                } else {
	                  ids = stash.tree.range(Math.min(xl, xr), Math.min(yl, yr), Math.max(xl, xr), Math.max(yl, yr));
	                }
	              } else {
	                ids = stash.ids;
	              }
	              var k, closestId, ptx, pty, i, dx, dy, dist, dxy;
	              var minDist = maxDistance;
	              if (hovermode === "x") {
	                var xPeriod = !!trace.xperiodalignment;
	                var yPeriod = !!trace.yperiodalignment;
	                for (i = 0; i < ids.length; i++) {
	                  k = ids[i];
	                  ptx = x[k];
	                  dx = Math.abs(xa.c2p(ptx) - xpx);
	                  if (xPeriod) {
	                    var x0 = xa.c2p(trace._xStarts[k]);
	                    var x1 = xa.c2p(trace._xEnds[k]);
	                    dx = xpx >= Math.min(x0, x1) && xpx <= Math.max(x0, x1) ? 0 : Infinity;
	                  }
	                  if (dx < minDist) {
	                    minDist = dx;
	                    pty = y[k];
	                    dy = ya.c2p(pty) - ypx;
	                    if (yPeriod) {
	                      var y0 = ya.c2p(trace._yStarts[k]);
	                      var y1 = ya.c2p(trace._yEnds[k]);
	                      dy = ypx >= Math.min(y0, y1) && ypx <= Math.max(y0, y1) ? 0 : Infinity;
	                    }
	                    dxy = Math.sqrt(dx * dx + dy * dy);
	                    closestId = ids[i];
	                  }
	                }
	              } else {
	                for (i = ids.length - 1; i > -1; i--) {
	                  k = ids[i];
	                  ptx = x[k];
	                  pty = y[k];
	                  dx = xa.c2p(ptx) - xpx;
	                  dy = ya.c2p(pty) - ypx;
	                  dist = Math.sqrt(dx * dx + dy * dy);
	                  if (dist < minDist) {
	                    minDist = dxy = dist;
	                    closestId = k;
	                  }
	                }
	              }
	              pointData.index = closestId;
	              pointData.distance = minDist;
	              pointData.dxy = dxy;
	              if (closestId === undefined) return [pointData];
	              return [calcHover(pointData, x, y, trace)];
	            }
	            function calcHover(pointData, x, y, trace) {
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var minDist = pointData.distance;
	              var dxy = pointData.dxy;
	              var id = pointData.index;
	              var di = {
	                pointNumber: id,
	                x: x[id],
	                y: y[id]
	              };
	              di.tx = Array.isArray(trace.text) ? trace.text[id] : trace.text;
	              di.htx = Array.isArray(trace.hovertext) ? trace.hovertext[id] : trace.hovertext;
	              di.data = Array.isArray(trace.customdata) ? trace.customdata[id] : trace.customdata;
	              di.tp = Array.isArray(trace.textposition) ? trace.textposition[id] : trace.textposition;
	              var font = trace.textfont;
	              if (font) {
	                di.ts = Lib.isArrayOrTypedArray(font.size) ? font.size[id] : font.size;
	                di.tc = Array.isArray(font.color) ? font.color[id] : font.color;
	                di.tf = Array.isArray(font.family) ? font.family[id] : font.family;
	              }
	              var marker = trace.marker;
	              if (marker) {
	                di.ms = Lib.isArrayOrTypedArray(marker.size) ? marker.size[id] : marker.size;
	                di.mo = Lib.isArrayOrTypedArray(marker.opacity) ? marker.opacity[id] : marker.opacity;
	                di.mx = Lib.isArrayOrTypedArray(marker.symbol) ? marker.symbol[id] : marker.symbol;
	                di.ma = Lib.isArrayOrTypedArray(marker.angle) ? marker.angle[id] : marker.angle;
	                di.mc = Lib.isArrayOrTypedArray(marker.color) ? marker.color[id] : marker.color;
	              }
	              var line = marker && marker.line;
	              if (line) {
	                di.mlc = Array.isArray(line.color) ? line.color[id] : line.color;
	                di.mlw = Lib.isArrayOrTypedArray(line.width) ? line.width[id] : line.width;
	              }
	              var grad = marker && marker.gradient;
	              if (grad && grad.type !== "none") {
	                di.mgt = Array.isArray(grad.type) ? grad.type[id] : grad.type;
	                di.mgc = Array.isArray(grad.color) ? grad.color[id] : grad.color;
	              }
	              var xp = xa.c2p(di.x, true);
	              var yp = ya.c2p(di.y, true);
	              var rad = di.mrc || 1;
	              var hoverlabel = trace.hoverlabel;
	              if (hoverlabel) {
	                di.hbg = Array.isArray(hoverlabel.bgcolor) ? hoverlabel.bgcolor[id] : hoverlabel.bgcolor;
	                di.hbc = Array.isArray(hoverlabel.bordercolor) ? hoverlabel.bordercolor[id] : hoverlabel.bordercolor;
	                di.hts = Lib.isArrayOrTypedArray(hoverlabel.font.size) ? hoverlabel.font.size[id] : hoverlabel.font.size;
	                di.htc = Array.isArray(hoverlabel.font.color) ? hoverlabel.font.color[id] : hoverlabel.font.color;
	                di.htf = Array.isArray(hoverlabel.font.family) ? hoverlabel.font.family[id] : hoverlabel.font.family;
	                di.hnl = Lib.isArrayOrTypedArray(hoverlabel.namelength) ? hoverlabel.namelength[id] : hoverlabel.namelength;
	              }
	              var hoverinfo = trace.hoverinfo;
	              if (hoverinfo) {
	                di.hi = Array.isArray(hoverinfo) ? hoverinfo[id] : hoverinfo;
	              }
	              var hovertemplate = trace.hovertemplate;
	              if (hovertemplate) {
	                di.ht = Array.isArray(hovertemplate) ? hovertemplate[id] : hovertemplate;
	              }
	              var fakeCd = {};
	              fakeCd[pointData.index] = di;
	              var origX = trace._origX;
	              var origY = trace._origY;
	              var pointData2 = Lib.extendFlat({}, pointData, {
	                color: getTraceColor(trace, di),
	                x0: xp - rad,
	                x1: xp + rad,
	                xLabelVal: origX ? origX[id] : di.x,
	                y0: yp - rad,
	                y1: yp + rad,
	                yLabelVal: origY ? origY[id] : di.y,
	                cd: fakeCd,
	                distance: minDist,
	                spikeDistance: dxy,
	                hovertemplate: di.ht
	              });
	              if (di.htx) pointData2.text = di.htx;
	              else if (di.tx) pointData2.text = di.tx;
	              else if (trace.text) pointData2.text = trace.text;
	              Lib.fillText(di, trace, pointData2);
	              Registry.getComponentMethod("errorbars", "hoverInfo")(di, trace, pointData2);
	              return pointData2;
	            }
	            module2.exports = {
	              hoverPoints,
	              calcHover
	            };
	          }
	        ),
	        /***/
	        68868: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var index = __webpack_require__2(72156);
	            index.plot = __webpack_require__2(26787);
	            module2.exports = index;
	          }
	        ),
	        /***/
	        26787: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createScatter = __webpack_require__2(11870);
	            var createLine = __webpack_require__2(46075);
	            var createError = __webpack_require__2(3593);
	            var Text = __webpack_require__2(42505);
	            var Lib = __webpack_require__2(71828);
	            var selectMode = __webpack_require__2(64505).selectMode;
	            var prepareRegl = __webpack_require__2(79749);
	            var subTypes = __webpack_require__2(34098);
	            var linkTraces = __webpack_require__2(68687);
	            var styleTextSelection = __webpack_require__2(5345).styleTextSelection;
	            var reglPrecompiled = {};
	            function getViewport(fullLayout, xaxis, yaxis, plotGlPixelRatio) {
	              var gs = fullLayout._size;
	              var width = fullLayout.width * plotGlPixelRatio;
	              var height = fullLayout.height * plotGlPixelRatio;
	              var l = gs.l * plotGlPixelRatio;
	              var b = gs.b * plotGlPixelRatio;
	              var r = gs.r * plotGlPixelRatio;
	              var t = gs.t * plotGlPixelRatio;
	              var w = gs.w * plotGlPixelRatio;
	              var h = gs.h * plotGlPixelRatio;
	              return [l + xaxis.domain[0] * w, b + yaxis.domain[0] * h, width - r - (1 - xaxis.domain[1]) * w, height - t - (1 - yaxis.domain[1]) * h];
	            }
	            var exports2 = module2.exports = function plot(gd, subplot, cdata) {
	              if (!cdata.length) return;
	              var fullLayout = gd._fullLayout;
	              var scene = subplot._scene;
	              var xaxis = subplot.xaxis;
	              var yaxis = subplot.yaxis;
	              var i, j;
	              if (!scene) return;
	              var success = prepareRegl(gd, ["ANGLE_instanced_arrays", "OES_element_index_uint"], reglPrecompiled);
	              if (!success) {
	                scene.init();
	                return;
	              }
	              var count = scene.count;
	              var regl = fullLayout._glcanvas.data()[0].regl;
	              linkTraces(gd, subplot, cdata);
	              if (scene.dirty) {
	                if (scene.error2d === true) {
	                  scene.error2d = createError(regl);
	                }
	                if (scene.line2d === true) {
	                  scene.line2d = createLine(regl);
	                }
	                if (scene.scatter2d === true) {
	                  scene.scatter2d = createScatter(regl);
	                }
	                if (scene.fill2d === true) {
	                  scene.fill2d = createLine(regl);
	                }
	                if (scene.glText === true) {
	                  scene.glText = new Array(count);
	                  for (i = 0; i < count; i++) {
	                    scene.glText[i] = new Text(regl);
	                  }
	                }
	                if (scene.glText) {
	                  if (count > scene.glText.length) {
	                    var textsToAdd = count - scene.glText.length;
	                    for (i = 0; i < textsToAdd; i++) {
	                      scene.glText.push(new Text(regl));
	                    }
	                  } else if (count < scene.glText.length) {
	                    var textsToRemove = scene.glText.length - count;
	                    var removedTexts = scene.glText.splice(count, textsToRemove);
	                    removedTexts.forEach(function(text) {
	                      text.destroy();
	                    });
	                  }
	                  for (i = 0; i < count; i++) {
	                    scene.glText[i].update(scene.textOptions[i]);
	                  }
	                }
	                if (scene.line2d) {
	                  scene.line2d.update(scene.lineOptions);
	                  scene.lineOptions = scene.lineOptions.map(function(lineOptions) {
	                    if (lineOptions && lineOptions.positions) {
	                      var srcPos = lineOptions.positions;
	                      var firstptdef = 0;
	                      while (firstptdef < srcPos.length && (isNaN(srcPos[firstptdef]) || isNaN(srcPos[firstptdef + 1]))) {
	                        firstptdef += 2;
	                      }
	                      var lastptdef = srcPos.length - 2;
	                      while (lastptdef > firstptdef && (isNaN(srcPos[lastptdef]) || isNaN(srcPos[lastptdef + 1]))) {
	                        lastptdef -= 2;
	                      }
	                      lineOptions.positions = srcPos.slice(firstptdef, lastptdef + 2);
	                    }
	                    return lineOptions;
	                  });
	                  scene.line2d.update(scene.lineOptions);
	                }
	                if (scene.error2d) {
	                  var errorBatch = (scene.errorXOptions || []).concat(scene.errorYOptions || []);
	                  scene.error2d.update(errorBatch);
	                }
	                if (scene.scatter2d) {
	                  scene.scatter2d.update(scene.markerOptions);
	                }
	                scene.fillOrder = Lib.repeat(null, count);
	                if (scene.fill2d) {
	                  scene.fillOptions = scene.fillOptions.map(function(fillOptions, i2) {
	                    var cdscatter = cdata[i2];
	                    if (!fillOptions || !cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
	                    var cd = cdscatter[0];
	                    var trace2 = cd.trace;
	                    var stash2 = cd.t;
	                    var lineOptions = scene.lineOptions[i2];
	                    var last, j2;
	                    var fillData = [];
	                    if (trace2._ownfill) fillData.push(i2);
	                    if (trace2._nexttrace) fillData.push(i2 + 1);
	                    if (fillData.length) scene.fillOrder[i2] = fillData;
	                    var pos = [];
	                    var srcPos = lineOptions && lineOptions.positions || stash2.positions;
	                    var firstptdef, lastptdef;
	                    if (trace2.fill === "tozeroy") {
	                      firstptdef = 0;
	                      while (firstptdef < srcPos.length && isNaN(srcPos[firstptdef + 1])) {
	                        firstptdef += 2;
	                      }
	                      lastptdef = srcPos.length - 2;
	                      while (lastptdef > firstptdef && isNaN(srcPos[lastptdef + 1])) {
	                        lastptdef -= 2;
	                      }
	                      if (srcPos[firstptdef + 1] !== 0) {
	                        pos = [srcPos[firstptdef], 0];
	                      }
	                      pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
	                      if (srcPos[lastptdef + 1] !== 0) {
	                        pos = pos.concat([srcPos[lastptdef], 0]);
	                      }
	                    } else if (trace2.fill === "tozerox") {
	                      firstptdef = 0;
	                      while (firstptdef < srcPos.length && isNaN(srcPos[firstptdef])) {
	                        firstptdef += 2;
	                      }
	                      lastptdef = srcPos.length - 2;
	                      while (lastptdef > firstptdef && isNaN(srcPos[lastptdef])) {
	                        lastptdef -= 2;
	                      }
	                      if (srcPos[firstptdef] !== 0) {
	                        pos = [0, srcPos[firstptdef + 1]];
	                      }
	                      pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
	                      if (srcPos[lastptdef] !== 0) {
	                        pos = pos.concat([0, srcPos[lastptdef + 1]]);
	                      }
	                    } else if (trace2.fill === "toself" || trace2.fill === "tonext") {
	                      pos = [];
	                      last = 0;
	                      fillOptions.splitNull = true;
	                      for (j2 = 0; j2 < srcPos.length; j2 += 2) {
	                        if (isNaN(srcPos[j2]) || isNaN(srcPos[j2 + 1])) {
	                          pos = pos.concat(srcPos.slice(last, j2));
	                          pos.push(srcPos[last], srcPos[last + 1]);
	                          pos.push(null, null);
	                          last = j2 + 2;
	                        }
	                      }
	                      pos = pos.concat(srcPos.slice(last));
	                      if (last) {
	                        pos.push(srcPos[last], srcPos[last + 1]);
	                      }
	                    } else {
	                      var nextTrace = trace2._nexttrace;
	                      if (nextTrace) {
	                        var nextOptions = scene.lineOptions[i2 + 1];
	                        if (nextOptions) {
	                          var nextPos = nextOptions.positions;
	                          if (trace2.fill === "tonexty") {
	                            pos = srcPos.slice();
	                            for (i2 = Math.floor(nextPos.length / 2); i2--; ) {
	                              var xx = nextPos[i2 * 2];
	                              var yy = nextPos[i2 * 2 + 1];
	                              if (isNaN(xx) || isNaN(yy)) continue;
	                              pos.push(xx, yy);
	                            }
	                            fillOptions.fill = nextTrace.fillcolor;
	                          }
	                        }
	                      }
	                    }
	                    if (trace2._prevtrace && trace2._prevtrace.fill === "tonext") {
	                      var prevLinePos = scene.lineOptions[i2 - 1].positions;
	                      var offset = pos.length / 2;
	                      last = offset;
	                      var hole = [last];
	                      for (j2 = 0; j2 < prevLinePos.length; j2 += 2) {
	                        if (isNaN(prevLinePos[j2]) || isNaN(prevLinePos[j2 + 1])) {
	                          hole.push(j2 / 2 + offset + 1);
	                          last = j2 + 2;
	                        }
	                      }
	                      pos = pos.concat(prevLinePos);
	                      fillOptions.hole = hole;
	                    }
	                    fillOptions.fillmode = trace2.fill;
	                    fillOptions.opacity = trace2.opacity;
	                    fillOptions.positions = pos;
	                    return fillOptions;
	                  });
	                  scene.fill2d.update(scene.fillOptions);
	                }
	              }
	              var dragmode = fullLayout.dragmode;
	              var isSelectMode = selectMode(dragmode);
	              var clickSelectEnabled = fullLayout.clickmode.indexOf("select") > -1;
	              for (i = 0; i < count; i++) {
	                var cd0 = cdata[i][0];
	                var trace = cd0.trace;
	                var stash = cd0.t;
	                var index = stash.index;
	                var len = trace._length;
	                var x = stash.x;
	                var y = stash.y;
	                if (trace.selectedpoints || isSelectMode || clickSelectEnabled) {
	                  if (!isSelectMode) isSelectMode = true;
	                  if (trace.selectedpoints) {
	                    var selPts = scene.selectBatch[index] = Lib.selIndices2selPoints(trace);
	                    var selDict = {};
	                    for (j = 0; j < selPts.length; j++) {
	                      selDict[selPts[j]] = 1;
	                    }
	                    var unselPts = [];
	                    for (j = 0; j < len; j++) {
	                      if (!selDict[j]) unselPts.push(j);
	                    }
	                    scene.unselectBatch[index] = unselPts;
	                  }
	                  var xpx = stash.xpx = new Array(len);
	                  var ypx = stash.ypx = new Array(len);
	                  for (j = 0; j < len; j++) {
	                    xpx[j] = xaxis.c2p(x[j]);
	                    ypx[j] = yaxis.c2p(y[j]);
	                  }
	                } else {
	                  stash.xpx = stash.ypx = null;
	                }
	              }
	              if (isSelectMode) {
	                if (!scene.select2d) {
	                  scene.select2d = createScatter(fullLayout._glcanvas.data()[1].regl);
	                }
	                if (scene.scatter2d) {
	                  var unselOpts = new Array(count);
	                  for (i = 0; i < count; i++) {
	                    unselOpts[i] = scene.selectBatch[i].length || scene.unselectBatch[i].length ? scene.markerUnselectedOptions[i] : {};
	                  }
	                  scene.scatter2d.update(unselOpts);
	                }
	                if (scene.select2d) {
	                  scene.select2d.update(scene.markerOptions);
	                  scene.select2d.update(scene.markerSelectedOptions);
	                }
	                if (scene.glText) {
	                  cdata.forEach(function(cdscatter) {
	                    var trace2 = ((cdscatter || [])[0] || {}).trace || {};
	                    if (subTypes.hasText(trace2)) {
	                      styleTextSelection(cdscatter);
	                    }
	                  });
	                }
	              } else {
	                if (scene.scatter2d) {
	                  scene.scatter2d.update(scene.markerOptions);
	                }
	              }
	              var vpRange0 = {
	                viewport: getViewport(fullLayout, xaxis, yaxis, gd._context.plotGlPixelRatio),
	                // TODO do we need those fallbacks?
	                range: [(xaxis._rl || xaxis.range)[0], (yaxis._rl || yaxis.range)[0], (xaxis._rl || xaxis.range)[1], (yaxis._rl || yaxis.range)[1]]
	              };
	              var vpRange = Lib.repeat(vpRange0, scene.count);
	              if (scene.fill2d) {
	                scene.fill2d.update(vpRange);
	              }
	              if (scene.line2d) {
	                scene.line2d.update(vpRange);
	              }
	              if (scene.error2d) {
	                scene.error2d.update(vpRange.concat(vpRange));
	              }
	              if (scene.scatter2d) {
	                scene.scatter2d.update(vpRange);
	              }
	              if (scene.select2d) {
	                scene.select2d.update(vpRange);
	              }
	              if (scene.glText) {
	                scene.glText.forEach(function(text) {
	                  text.update(vpRange0);
	                });
	              }
	            };
	            exports2.reglPrecompiled = reglPrecompiled;
	          }
	        ),
	        /***/
	        38967: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function sceneUpdate(gd, subplot) {
	              var scene = subplot._scene;
	              var resetOpts = {
	                // number of traces in subplot, since scene:subplot -> 1:1
	                count: 0,
	                // whether scene requires init hook in plot call (dirty plot call)
	                dirty: true,
	                // last used options
	                lineOptions: [],
	                fillOptions: [],
	                markerOptions: [],
	                markerSelectedOptions: [],
	                markerUnselectedOptions: [],
	                errorXOptions: [],
	                errorYOptions: [],
	                textOptions: [],
	                textSelectedOptions: [],
	                textUnselectedOptions: [],
	                // selection batches
	                selectBatch: [],
	                unselectBatch: []
	              };
	              var initOpts = {
	                fill2d: false,
	                scatter2d: false,
	                error2d: false,
	                line2d: false,
	                glText: false,
	                select2d: false
	              };
	              if (!subplot._scene) {
	                scene = subplot._scene = {};
	                scene.init = function init() {
	                  Lib.extendFlat(scene, initOpts, resetOpts);
	                };
	                scene.init();
	                scene.update = function update(opt) {
	                  var opts = Lib.repeat(opt, scene.count);
	                  if (scene.fill2d) scene.fill2d.update(opts);
	                  if (scene.scatter2d) scene.scatter2d.update(opts);
	                  if (scene.line2d) scene.line2d.update(opts);
	                  if (scene.error2d) scene.error2d.update(opts.concat(opts));
	                  if (scene.select2d) scene.select2d.update(opts);
	                  if (scene.glText) {
	                    for (var i = 0; i < scene.count; i++) {
	                      scene.glText[i].update(opt);
	                    }
	                  }
	                };
	                scene.draw = function draw() {
	                  var count = scene.count;
	                  var fill2d = scene.fill2d;
	                  var error2d = scene.error2d;
	                  var line2d = scene.line2d;
	                  var scatter2d = scene.scatter2d;
	                  var glText = scene.glText;
	                  var select2d = scene.select2d;
	                  var selectBatch = scene.selectBatch;
	                  var unselectBatch = scene.unselectBatch;
	                  for (var i = 0; i < count; i++) {
	                    if (fill2d && scene.fillOrder[i]) {
	                      fill2d.draw(scene.fillOrder[i]);
	                    }
	                    if (line2d && scene.lineOptions[i]) {
	                      line2d.draw(i);
	                    }
	                    if (error2d) {
	                      if (scene.errorXOptions[i]) error2d.draw(i);
	                      if (scene.errorYOptions[i]) error2d.draw(i + count);
	                    }
	                    if (scatter2d && scene.markerOptions[i]) {
	                      if (unselectBatch[i].length) {
	                        var arg = Lib.repeat([], scene.count);
	                        arg[i] = unselectBatch[i];
	                        scatter2d.draw(arg);
	                      } else if (!selectBatch[i].length) {
	                        scatter2d.draw(i);
	                      }
	                    }
	                    if (glText[i] && scene.textOptions[i]) {
	                      glText[i].render();
	                    }
	                  }
	                  if (select2d) {
	                    select2d.draw(selectBatch);
	                  }
	                  scene.dirty = false;
	                };
	                scene.destroy = function destroy() {
	                  if (scene.fill2d && scene.fill2d.destroy) scene.fill2d.destroy();
	                  if (scene.scatter2d && scene.scatter2d.destroy) scene.scatter2d.destroy();
	                  if (scene.error2d && scene.error2d.destroy) scene.error2d.destroy();
	                  if (scene.line2d && scene.line2d.destroy) scene.line2d.destroy();
	                  if (scene.select2d && scene.select2d.destroy) scene.select2d.destroy();
	                  if (scene.glText) {
	                    scene.glText.forEach(function(text) {
	                      if (text.destroy) text.destroy();
	                    });
	                  }
	                  scene.lineOptions = null;
	                  scene.fillOptions = null;
	                  scene.markerOptions = null;
	                  scene.markerSelectedOptions = null;
	                  scene.markerUnselectedOptions = null;
	                  scene.errorXOptions = null;
	                  scene.errorYOptions = null;
	                  scene.textOptions = null;
	                  scene.textSelectedOptions = null;
	                  scene.textUnselectedOptions = null;
	                  scene.selectBatch = null;
	                  scene.unselectBatch = null;
	                  subplot._scene = null;
	                };
	              }
	              if (!scene.dirty) {
	                Lib.extendFlat(scene, resetOpts);
	              }
	              return scene;
	            };
	          }
	        ),
	        /***/
	        58147: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var subTypes = __webpack_require__2(34098);
	            var styleTextSelection = __webpack_require__2(5345).styleTextSelection;
	            module2.exports = function select(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var trace = cd[0].trace;
	              var stash = cd[0].t;
	              var len = trace._length;
	              var x = stash.x;
	              var y = stash.y;
	              var scene = stash._scene;
	              var index = stash.index;
	              if (!scene) return selection;
	              var hasText = subTypes.hasText(trace);
	              var hasMarkers = subTypes.hasMarkers(trace);
	              var hasOnlyLines = !hasMarkers && !hasText;
	              if (trace.visible !== true || hasOnlyLines) return selection;
	              var els = [];
	              var unels = [];
	              if (selectionTester !== false && !selectionTester.degenerate) {
	                for (var i = 0; i < len; i++) {
	                  if (selectionTester.contains([stash.xpx[i], stash.ypx[i]], false, i, searchInfo)) {
	                    els.push(i);
	                    selection.push({
	                      pointNumber: i,
	                      x: xa.c2d(x[i]),
	                      y: ya.c2d(y[i])
	                    });
	                  } else {
	                    unels.push(i);
	                  }
	                }
	              }
	              if (hasMarkers) {
	                var scatter2d = scene.scatter2d;
	                if (!els.length && !unels.length) {
	                  var baseOpts = new Array(scene.count);
	                  baseOpts[index] = scene.markerOptions[index];
	                  scatter2d.update.apply(scatter2d, baseOpts);
	                } else if (!scene.selectBatch[index].length && !scene.unselectBatch[index].length) {
	                  var unselOpts = new Array(scene.count);
	                  unselOpts[index] = scene.markerUnselectedOptions[index];
	                  scatter2d.update.apply(scatter2d, unselOpts);
	                }
	              }
	              scene.selectBatch[index] = els;
	              scene.unselectBatch[index] = unels;
	              if (hasText) {
	                styleTextSelection(cd);
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        99181: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var scatterGeoAttrs = __webpack_require__2(19316);
	            var scatterAttrs = __webpack_require__2(82196);
	            var mapboxAttrs = __webpack_require__2(23585);
	            var baseAttrs = __webpack_require__2(9012);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var mapboxLayoutAtributes = __webpack_require__2(23585);
	            var lineAttrs = scatterGeoAttrs.line;
	            var markerAttrs = scatterGeoAttrs.marker;
	            module2.exports = overrideAll({
	              lon: scatterGeoAttrs.lon,
	              lat: scatterGeoAttrs.lat,
	              cluster: {
	                enabled: {
	                  valType: "boolean"
	                },
	                maxzoom: extendFlat({}, mapboxLayoutAtributes.layers.maxzoom, {}),
	                step: {
	                  valType: "number",
	                  arrayOk: true,
	                  dflt: -1,
	                  min: -1
	                },
	                size: {
	                  valType: "number",
	                  arrayOk: true,
	                  dflt: 20,
	                  min: 0
	                },
	                color: {
	                  valType: "color",
	                  arrayOk: true
	                },
	                opacity: extendFlat({}, markerAttrs.opacity, {
	                  dflt: 1
	                })
	              },
	              // locations
	              // locationmode
	              mode: extendFlat({}, scatterAttrs.mode, {
	                dflt: "markers"
	              }),
	              text: extendFlat({}, scatterAttrs.text, {}),
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["lat", "lon", "text"]
	              }),
	              hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
	              line: {
	                color: lineAttrs.color,
	                width: lineAttrs.width
	                // TODO
	                // dash: dash
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              marker: extendFlat(
	                {
	                  symbol: {
	                    valType: "string",
	                    dflt: "circle",
	                    arrayOk: true
	                  },
	                  angle: {
	                    valType: "number",
	                    dflt: "auto",
	                    arrayOk: true
	                  },
	                  allowoverlap: {
	                    valType: "boolean",
	                    dflt: false
	                  },
	                  opacity: markerAttrs.opacity,
	                  size: markerAttrs.size,
	                  sizeref: markerAttrs.sizeref,
	                  sizemin: markerAttrs.sizemin,
	                  sizemode: markerAttrs.sizemode
	                },
	                colorScaleAttrs("marker")
	                // line
	              ),
	              fill: scatterGeoAttrs.fill,
	              fillcolor: scatterAttrs.fillcolor,
	              textfont: mapboxAttrs.layers.symbol.textfont,
	              textposition: mapboxAttrs.layers.symbol.textposition,
	              below: {
	                valType: "string"
	              },
	              selected: {
	                marker: scatterAttrs.selected.marker
	              },
	              unselected: {
	                marker: scatterAttrs.unselected.marker
	              },
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["lon", "lat", "text", "name"]
	              }),
	              hovertemplate: hovertemplateAttrs()
	            }, "calc", "nested");
	          }
	        ),
	        /***/
	        15790: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var geoJsonUtils = __webpack_require__2(18214);
	            var Colorscale = __webpack_require__2(21081);
	            var Drawing = __webpack_require__2(91424);
	            var makeBubbleSizeFn = __webpack_require__2(39984);
	            var subTypes = __webpack_require__2(34098);
	            var convertTextOpts = __webpack_require__2(13056);
	            var appendArrayPointValue = __webpack_require__2(23469).appendArrayPointValue;
	            var NEWLINES = __webpack_require__2(63893).NEWLINES;
	            var BR_TAG_ALL = __webpack_require__2(63893).BR_TAG_ALL;
	            module2.exports = function convert(gd, calcTrace) {
	              var trace = calcTrace[0].trace;
	              var isVisible = trace.visible === true && trace._length !== 0;
	              var hasFill = trace.fill !== "none";
	              var hasLines = subTypes.hasLines(trace);
	              var hasMarkers = subTypes.hasMarkers(trace);
	              var hasText = subTypes.hasText(trace);
	              var hasCircles = hasMarkers && trace.marker.symbol === "circle";
	              var hasSymbols = hasMarkers && trace.marker.symbol !== "circle";
	              var hasCluster = trace.cluster && trace.cluster.enabled;
	              var fill = initContainer("fill");
	              var line = initContainer("line");
	              var circle = initContainer("circle");
	              var symbol = initContainer("symbol");
	              var opts = {
	                fill,
	                line,
	                circle,
	                symbol
	              };
	              if (!isVisible) return opts;
	              var lineCoords;
	              if (hasFill || hasLines) {
	                lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
	              }
	              if (hasFill) {
	                fill.geojson = geoJsonUtils.makePolygon(lineCoords);
	                fill.layout.visibility = "visible";
	                Lib.extendFlat(fill.paint, {
	                  "fill-color": trace.fillcolor
	                });
	              }
	              if (hasLines) {
	                line.geojson = geoJsonUtils.makeLine(lineCoords);
	                line.layout.visibility = "visible";
	                Lib.extendFlat(line.paint, {
	                  "line-width": trace.line.width,
	                  "line-color": trace.line.color,
	                  "line-opacity": trace.opacity
	                });
	              }
	              if (hasCircles) {
	                var circleOpts = makeCircleOpts(calcTrace);
	                circle.geojson = circleOpts.geojson;
	                circle.layout.visibility = "visible";
	                if (hasCluster) {
	                  circle.filter = ["!", ["has", "point_count"]];
	                  opts.cluster = {
	                    type: "circle",
	                    filter: ["has", "point_count"],
	                    layout: {
	                      visibility: "visible"
	                    },
	                    paint: {
	                      "circle-color": arrayifyAttribute(trace.cluster.color, trace.cluster.step),
	                      "circle-radius": arrayifyAttribute(trace.cluster.size, trace.cluster.step),
	                      "circle-opacity": arrayifyAttribute(trace.cluster.opacity, trace.cluster.step)
	                    }
	                  };
	                  opts.clusterCount = {
	                    type: "symbol",
	                    filter: ["has", "point_count"],
	                    paint: {},
	                    layout: {
	                      "text-field": "{point_count_abbreviated}",
	                      "text-font": ["Open Sans Regular", "Arial Unicode MS Regular"],
	                      "text-size": 12
	                    }
	                  };
	                }
	                Lib.extendFlat(circle.paint, {
	                  "circle-color": circleOpts.mcc,
	                  "circle-radius": circleOpts.mrc,
	                  "circle-opacity": circleOpts.mo
	                });
	              }
	              if (hasCircles && hasCluster) {
	                circle.filter = ["!", ["has", "point_count"]];
	              }
	              if (hasSymbols || hasText) {
	                symbol.geojson = makeSymbolGeoJSON(calcTrace, gd);
	                Lib.extendFlat(symbol.layout, {
	                  visibility: "visible",
	                  "icon-image": "{symbol}-15",
	                  "text-field": "{text}"
	                });
	                if (hasSymbols) {
	                  Lib.extendFlat(symbol.layout, {
	                    "icon-size": trace.marker.size / 10
	                  });
	                  if ("angle" in trace.marker && trace.marker.angle !== "auto") {
	                    Lib.extendFlat(symbol.layout, {
	                      // unfortunately cant use {angle} do to this issue:
	                      // https://github.com/mapbox/mapbox-gl-js/issues/873
	                      "icon-rotate": {
	                        type: "identity",
	                        property: "angle"
	                      },
	                      "icon-rotation-alignment": "map"
	                    });
	                  }
	                  symbol.layout["icon-allow-overlap"] = trace.marker.allowoverlap;
	                  Lib.extendFlat(symbol.paint, {
	                    "icon-opacity": trace.opacity * trace.marker.opacity,
	                    // TODO does not work ??
	                    "icon-color": trace.marker.color
	                  });
	                }
	                if (hasText) {
	                  var iconSize = (trace.marker || {}).size;
	                  var textOpts = convertTextOpts(trace.textposition, iconSize);
	                  Lib.extendFlat(symbol.layout, {
	                    "text-size": trace.textfont.size,
	                    "text-anchor": textOpts.anchor,
	                    "text-offset": textOpts.offset,
	                    "text-font": trace.textfont.family.split(", ")
	                  });
	                  Lib.extendFlat(symbol.paint, {
	                    "text-color": trace.textfont.color,
	                    "text-opacity": trace.opacity
	                  });
	                }
	              }
	              return opts;
	            };
	            function initContainer(type) {
	              return {
	                type,
	                geojson: geoJsonUtils.makeBlank(),
	                layout: {
	                  visibility: "none"
	                },
	                filter: null,
	                paint: {}
	              };
	            }
	            function makeCircleOpts(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var marker = trace.marker;
	              var selectedpoints = trace.selectedpoints;
	              var arrayColor = Lib.isArrayOrTypedArray(marker.color);
	              var arraySize = Lib.isArrayOrTypedArray(marker.size);
	              var arrayOpacity = Lib.isArrayOrTypedArray(marker.opacity);
	              var i;
	              function addTraceOpacity(o) {
	                return trace.opacity * o;
	              }
	              function size2radius(s) {
	                return s / 2;
	              }
	              var colorFn;
	              if (arrayColor) {
	                if (Colorscale.hasColorscale(trace, "marker")) {
	                  colorFn = Colorscale.makeColorScaleFuncFromTrace(marker);
	                } else {
	                  colorFn = Lib.identity;
	                }
	              }
	              var sizeFn;
	              if (arraySize) {
	                sizeFn = makeBubbleSizeFn(trace);
	              }
	              var opacityFn;
	              if (arrayOpacity) {
	                opacityFn = function(mo) {
	                  var mo2 = isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
	                  return addTraceOpacity(mo2);
	                };
	              }
	              var features = [];
	              for (i = 0; i < calcTrace.length; i++) {
	                var calcPt = calcTrace[i];
	                var lonlat = calcPt.lonlat;
	                if (isBADNUM(lonlat)) continue;
	                var props = {};
	                if (colorFn) props.mcc = calcPt.mcc = colorFn(calcPt.mc);
	                if (sizeFn) props.mrc = calcPt.mrc = sizeFn(calcPt.ms);
	                if (opacityFn) props.mo = opacityFn(calcPt.mo);
	                if (selectedpoints) props.selected = calcPt.selected || 0;
	                features.push({
	                  type: "Feature",
	                  id: i + 1,
	                  geometry: {
	                    type: "Point",
	                    coordinates: lonlat
	                  },
	                  properties: props
	                });
	              }
	              var fns;
	              if (selectedpoints) {
	                fns = Drawing.makeSelectedPointStyleFns(trace);
	                for (i = 0; i < features.length; i++) {
	                  var d = features[i].properties;
	                  if (fns.selectedOpacityFn) {
	                    d.mo = addTraceOpacity(fns.selectedOpacityFn(d));
	                  }
	                  if (fns.selectedColorFn) {
	                    d.mcc = fns.selectedColorFn(d);
	                  }
	                  if (fns.selectedSizeFn) {
	                    d.mrc = fns.selectedSizeFn(d);
	                  }
	                }
	              }
	              return {
	                geojson: {
	                  type: "FeatureCollection",
	                  features
	                },
	                mcc: arrayColor || fns && fns.selectedColorFn ? {
	                  type: "identity",
	                  property: "mcc"
	                } : marker.color,
	                mrc: arraySize || fns && fns.selectedSizeFn ? {
	                  type: "identity",
	                  property: "mrc"
	                } : size2radius(marker.size),
	                mo: arrayOpacity || fns && fns.selectedOpacityFn ? {
	                  type: "identity",
	                  property: "mo"
	                } : addTraceOpacity(marker.opacity)
	              };
	            }
	            function makeSymbolGeoJSON(calcTrace, gd) {
	              var fullLayout = gd._fullLayout;
	              var trace = calcTrace[0].trace;
	              var marker = trace.marker || {};
	              var symbol = marker.symbol;
	              var angle = marker.angle;
	              var fillSymbol = symbol !== "circle" ? getFillFunc(symbol) : blankFillFunc;
	              var fillAngle = angle !== "auto" ? getFillFunc(angle, true) : blankFillFunc;
	              var fillText = subTypes.hasText(trace) ? getFillFunc(trace.text) : blankFillFunc;
	              var features = [];
	              for (var i = 0; i < calcTrace.length; i++) {
	                var calcPt = calcTrace[i];
	                if (isBADNUM(calcPt.lonlat)) continue;
	                var texttemplate = trace.texttemplate;
	                var text;
	                if (texttemplate) {
	                  var tt = Array.isArray(texttemplate) ? texttemplate[i] || "" : texttemplate;
	                  var labels = trace._module.formatLabels(calcPt, trace, fullLayout);
	                  var pointValues = {};
	                  appendArrayPointValue(pointValues, trace, calcPt.i);
	                  var meta = trace._meta || {};
	                  text = Lib.texttemplateString(tt, labels, fullLayout._d3locale, pointValues, calcPt, meta);
	                } else {
	                  text = fillText(i);
	                }
	                if (text) {
	                  text = text.replace(NEWLINES, "").replace(BR_TAG_ALL, "\n");
	                }
	                features.push({
	                  type: "Feature",
	                  geometry: {
	                    type: "Point",
	                    coordinates: calcPt.lonlat
	                  },
	                  properties: {
	                    symbol: fillSymbol(i),
	                    angle: fillAngle(i),
	                    text
	                  }
	                });
	              }
	              return {
	                type: "FeatureCollection",
	                features
	              };
	            }
	            function getFillFunc(attr, numeric) {
	              if (Lib.isArrayOrTypedArray(attr)) {
	                if (numeric) {
	                  return function(i) {
	                    return isNumeric(attr[i]) ? +attr[i] : 0;
	                  };
	                }
	                return function(i) {
	                  return attr[i];
	                };
	              } else if (attr) {
	                return function() {
	                  return attr;
	                };
	              } else {
	                return blankFillFunc;
	              }
	            }
	            function blankFillFunc() {
	              return "";
	            }
	            function isBADNUM(lonlat) {
	              return lonlat[0] === BADNUM;
	            }
	            function arrayifyAttribute(values, step) {
	              var newAttribute;
	              if (Lib.isArrayOrTypedArray(values) && Lib.isArrayOrTypedArray(step)) {
	                newAttribute = ["step", ["get", "point_count"], values[0]];
	                for (var idx = 1; idx < values.length; idx++) {
	                  newAttribute.push(step[idx - 1], values[idx]);
	                }
	              } else {
	                newAttribute = values;
	              }
	              return newAttribute;
	            }
	          }
	        ),
	        /***/
	        76645: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var attributes = __webpack_require__2(99181);
	            var supportedFonts = ["Metropolis Black Italic", "Metropolis Black", "Metropolis Bold Italic", "Metropolis Bold", "Metropolis Extra Bold Italic", "Metropolis Extra Bold", "Metropolis Extra Light Italic", "Metropolis Extra Light", "Metropolis Light Italic", "Metropolis Light", "Metropolis Medium Italic", "Metropolis Medium", "Metropolis Regular Italic", "Metropolis Regular", "Metropolis Semi Bold Italic", "Metropolis Semi Bold", "Metropolis Thin Italic", "Metropolis Thin", "Open Sans Bold Italic", "Open Sans Bold", "Open Sans Extra Bold Italic", "Open Sans Extra Bold", "Open Sans Italic", "Open Sans Light Italic", "Open Sans Light", "Open Sans Regular", "Open Sans Semibold Italic", "Open Sans Semibold", "Klokantech Noto Sans Bold", "Klokantech Noto Sans CJK Bold", "Klokantech Noto Sans CJK Regular", "Klokantech Noto Sans Italic", "Klokantech Noto Sans Regular"];
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              function coerce2(attr, dflt) {
	                return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleLonLatDefaults(traceIn, traceOut, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("text");
	              coerce("texttemplate");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("mode");
	              coerce("below");
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  noDash: true
	                });
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  noLine: true,
	                  noAngle: true
	                });
	                coerce("marker.allowoverlap");
	                coerce("marker.angle");
	                var marker = traceOut.marker;
	                if (marker.symbol !== "circle") {
	                  if (Lib.isArrayOrTypedArray(marker.size)) marker.size = marker.size[0];
	                  if (Lib.isArrayOrTypedArray(marker.color)) marker.color = marker.color[0];
	                }
	              }
	              var clusterMaxzoom = coerce2("cluster.maxzoom");
	              var clusterStep = coerce2("cluster.step");
	              var clusterColor = coerce2("cluster.color", traceOut.marker && traceOut.marker.color || defaultColor);
	              var clusterSize = coerce2("cluster.size");
	              var clusterOpacity = coerce2("cluster.opacity");
	              var clusterEnabledDflt = clusterMaxzoom !== false || clusterStep !== false || clusterColor !== false || clusterSize !== false || clusterOpacity !== false;
	              coerce("cluster.enabled", clusterEnabledDflt);
	              if (subTypes.hasText(traceOut)) {
	                handleTextDefaults(traceIn, traceOut, layout, coerce, {
	                  noSelect: true,
	                  font: {
	                    family: supportedFonts.indexOf(layout.font.family) !== -1 ? layout.font.family : "Open Sans Regular",
	                    size: layout.font.size,
	                    color: layout.font.color
	                  }
	                });
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	              }
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	            function handleLonLatDefaults(traceIn, traceOut, coerce) {
	              var lon = coerce("lon") || [];
	              var lat = coerce("lat") || [];
	              var len = Math.min(lon.length, lat.length);
	              traceOut._length = len;
	              return len;
	            }
	          }
	        ),
	        /***/
	        53353: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt) {
	              out.lon = pt.lon;
	              out.lat = pt.lat;
	              return out;
	            };
	          }
	        ),
	        /***/
	        15636: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var labels = {};
	              var subplot = fullLayout[trace.subplot]._subplot;
	              var ax = subplot.mockAxis;
	              var lonlat = cdi.lonlat;
	              labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
	              labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
	              return labels;
	            };
	          }
	        ),
	        /***/
	        28178: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Fx = __webpack_require__2(30211);
	            var Lib = __webpack_require__2(71828);
	            var getTraceColor = __webpack_require__2(34603);
	            var fillText = Lib.fillText;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var LAYER_PREFIX = __webpack_require__2(77734).traceLayerPrefix;
	            function hoverPoints(pointData, xval, yval) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var subplot = pointData.subplot;
	              var clusteredPointsIds = [];
	              var layer = LAYER_PREFIX + trace.uid + "-circle";
	              var hasCluster = trace.cluster && trace.cluster.enabled;
	              if (hasCluster) {
	                var elems = subplot.map.queryRenderedFeatures(null, {
	                  layers: [layer]
	                });
	                clusteredPointsIds = elems.map(function(elem) {
	                  return elem.id;
	                });
	              }
	              var winding = xval >= 0 ? Math.floor((xval + 180) / 360) : Math.ceil((xval - 180) / 360);
	              var lonShift = winding * 360;
	              var xval2 = xval - lonShift;
	              function distFn(d) {
	                var lonlat2 = d.lonlat;
	                if (lonlat2[0] === BADNUM) return Infinity;
	                if (hasCluster && clusteredPointsIds.indexOf(d.i + 1) === -1) return Infinity;
	                var lon = Lib.modHalf(lonlat2[0], 360);
	                var lat = lonlat2[1];
	                var pt = subplot.project([lon, lat]);
	                var dx = pt.x - xa.c2p([xval2, lat]);
	                var dy = pt.y - ya.c2p([lon, yval]);
	                var rad2 = Math.max(3, d.mrc || 0);
	                return Math.max(Math.sqrt(dx * dx + dy * dy) - rad2, 1 - 3 / rad2);
	              }
	              Fx.getClosest(cd, distFn, pointData);
	              if (pointData.index === false) return;
	              var di = cd[pointData.index];
	              var lonlat = di.lonlat;
	              var lonlatShifted = [Lib.modHalf(lonlat[0], 360) + lonShift, lonlat[1]];
	              var xc = xa.c2p(lonlatShifted);
	              var yc = ya.c2p(lonlatShifted);
	              var rad = di.mrc || 1;
	              pointData.x0 = xc - rad;
	              pointData.x1 = xc + rad;
	              pointData.y0 = yc - rad;
	              pointData.y1 = yc + rad;
	              var fullLayout = {};
	              fullLayout[trace.subplot] = {
	                _subplot: subplot
	              };
	              var labels = trace._module.formatLabels(di, trace, fullLayout);
	              pointData.lonLabel = labels.lonLabel;
	              pointData.latLabel = labels.latLabel;
	              pointData.color = getTraceColor(trace, di);
	              pointData.extraText = getExtraText(trace, di, cd[0].t.labels);
	              pointData.hovertemplate = trace.hovertemplate;
	              return [pointData];
	            }
	            function getExtraText(trace, di, labels) {
	              if (trace.hovertemplate) return;
	              var hoverinfo = di.hi || trace.hoverinfo;
	              var parts = hoverinfo.split("+");
	              var isAll = parts.indexOf("all") !== -1;
	              var hasLon = parts.indexOf("lon") !== -1;
	              var hasLat = parts.indexOf("lat") !== -1;
	              var lonlat = di.lonlat;
	              var text = [];
	              function format(v) {
	                return v + "°";
	              }
	              if (isAll || hasLon && hasLat) {
	                text.push("(" + format(lonlat[1]) + ", " + format(lonlat[0]) + ")");
	              } else if (hasLon) {
	                text.push(labels.lon + format(lonlat[0]));
	              } else if (hasLat) {
	                text.push(labels.lat + format(lonlat[1]));
	              }
	              if (isAll || parts.indexOf("text") !== -1) {
	                fillText(di, trace, text);
	              }
	              return text.join("<br>");
	            }
	            module2.exports = {
	              hoverPoints,
	              getExtraText
	            };
	          }
	        ),
	        /***/
	        20467: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(99181),
	              supplyDefaults: __webpack_require__2(76645),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(15636),
	              calc: __webpack_require__2(84622),
	              plot: __webpack_require__2(86951),
	              hoverPoints: __webpack_require__2(28178).hoverPoints,
	              eventData: __webpack_require__2(53353),
	              selectPoints: __webpack_require__2(86387),
	              styleOnSelect: function(_, cd) {
	                if (cd) {
	                  var trace = cd[0].trace;
	                  trace._glTrace.update(cd);
	                }
	              },
	              moduleType: "trace",
	              name: "scattermapbox",
	              basePlotModule: __webpack_require__2(50101),
	              categories: ["mapbox", "gl", "symbols", "showLegend", "scatter-like"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        86951: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var convert = __webpack_require__2(15790);
	            var LAYER_PREFIX = __webpack_require__2(77734).traceLayerPrefix;
	            var ORDER = {
	              cluster: ["cluster", "clusterCount", "circle"],
	              nonCluster: ["fill", "line", "circle", "symbol"]
	            };
	            function ScatterMapbox(subplot, uid, clusterEnabled, isHidden) {
	              this.type = "scattermapbox";
	              this.subplot = subplot;
	              this.uid = uid;
	              this.clusterEnabled = clusterEnabled;
	              this.isHidden = isHidden;
	              this.sourceIds = {
	                fill: "source-" + uid + "-fill",
	                line: "source-" + uid + "-line",
	                circle: "source-" + uid + "-circle",
	                symbol: "source-" + uid + "-symbol",
	                cluster: "source-" + uid + "-circle",
	                clusterCount: "source-" + uid + "-circle"
	              };
	              this.layerIds = {
	                fill: LAYER_PREFIX + uid + "-fill",
	                line: LAYER_PREFIX + uid + "-line",
	                circle: LAYER_PREFIX + uid + "-circle",
	                symbol: LAYER_PREFIX + uid + "-symbol",
	                cluster: LAYER_PREFIX + uid + "-cluster",
	                clusterCount: LAYER_PREFIX + uid + "-cluster-count"
	              };
	              this.below = null;
	            }
	            var proto = ScatterMapbox.prototype;
	            proto.addSource = function(k, opts, cluster) {
	              var sourceOpts = {
	                type: "geojson",
	                data: opts.geojson
	              };
	              if (cluster && cluster.enabled) {
	                Lib.extendFlat(sourceOpts, {
	                  cluster: true,
	                  clusterMaxZoom: cluster.maxzoom
	                });
	              }
	              var isSourceExists = this.subplot.map.getSource(this.sourceIds[k]);
	              if (isSourceExists) {
	                isSourceExists.setData(opts.geojson);
	              } else {
	                this.subplot.map.addSource(this.sourceIds[k], sourceOpts);
	              }
	            };
	            proto.setSourceData = function(k, opts) {
	              this.subplot.map.getSource(this.sourceIds[k]).setData(opts.geojson);
	            };
	            proto.addLayer = function(k, opts, below) {
	              var source = {
	                type: opts.type,
	                id: this.layerIds[k],
	                source: this.sourceIds[k],
	                layout: opts.layout,
	                paint: opts.paint
	              };
	              if (opts.filter) {
	                source.filter = opts.filter;
	              }
	              var currentLayerId = this.layerIds[k];
	              var layerExist;
	              var layers = this.subplot.getMapLayers();
	              for (var i = 0; i < layers.length; i++) {
	                if (layers[i].id === currentLayerId) {
	                  layerExist = true;
	                  break;
	                }
	              }
	              if (layerExist) {
	                this.subplot.setOptions(currentLayerId, "setLayoutProperty", source.layout);
	                if (source.layout.visibility === "visible") {
	                  this.subplot.setOptions(currentLayerId, "setPaintProperty", source.paint);
	                }
	              } else {
	                this.subplot.addLayer(source, below);
	              }
	            };
	            proto.update = function update(calcTrace) {
	              var trace = calcTrace[0].trace;
	              var subplot = this.subplot;
	              var map2 = subplot.map;
	              var optsAll = convert(subplot.gd, calcTrace);
	              var below = subplot.belowLookup["trace-" + this.uid];
	              var hasCluster = !!(trace.cluster && trace.cluster.enabled);
	              var hadCluster = !!this.clusterEnabled;
	              var lThis = this;
	              function addCluster(noSource) {
	                if (!noSource) lThis.addSource("circle", optsAll.circle, trace.cluster);
	                var order = ORDER.cluster;
	                for (var i = 0; i < order.length; i++) {
	                  var k = order[i];
	                  var opts = optsAll[k];
	                  lThis.addLayer(k, opts, below);
	                }
	              }
	              function removeCluster(noSource) {
	                var order = ORDER.cluster;
	                for (var i = order.length - 1; i >= 0; i--) {
	                  var k = order[i];
	                  map2.removeLayer(lThis.layerIds[k]);
	                }
	                if (!noSource) map2.removeSource(lThis.sourceIds.circle);
	              }
	              function addNonCluster(noSource) {
	                var order = ORDER.nonCluster;
	                for (var i = 0; i < order.length; i++) {
	                  var k = order[i];
	                  var opts = optsAll[k];
	                  if (!noSource) lThis.addSource(k, opts);
	                  lThis.addLayer(k, opts, below);
	                }
	              }
	              function removeNonCluster(noSource) {
	                var order = ORDER.nonCluster;
	                for (var i = order.length - 1; i >= 0; i--) {
	                  var k = order[i];
	                  map2.removeLayer(lThis.layerIds[k]);
	                  if (!noSource) map2.removeSource(lThis.sourceIds[k]);
	                }
	              }
	              function remove(noSource) {
	                if (hadCluster) removeCluster(noSource);
	                else removeNonCluster(noSource);
	              }
	              function add(noSource) {
	                if (hasCluster) addCluster(noSource);
	                else addNonCluster(noSource);
	              }
	              function repaint() {
	                var order = hasCluster ? ORDER.cluster : ORDER.nonCluster;
	                for (var i = 0; i < order.length; i++) {
	                  var k = order[i];
	                  var opts = optsAll[k];
	                  if (!opts) continue;
	                  subplot.setOptions(lThis.layerIds[k], "setLayoutProperty", opts.layout);
	                  if (opts.layout.visibility === "visible") {
	                    if (k !== "cluster") {
	                      lThis.setSourceData(k, opts);
	                    }
	                    subplot.setOptions(lThis.layerIds[k], "setPaintProperty", opts.paint);
	                  }
	                }
	              }
	              var wasHidden = this.isHidden;
	              var isHidden = trace.visible !== true;
	              if (isHidden) {
	                if (!wasHidden) remove();
	              } else if (wasHidden) {
	                if (!isHidden) add();
	              } else if (hadCluster !== hasCluster) {
	                remove();
	                add();
	              } else if (this.below !== below) {
	                remove(true);
	                add(true);
	                repaint();
	              } else {
	                repaint();
	              }
	              this.clusterEnabled = hasCluster;
	              this.isHidden = isHidden;
	              this.below = below;
	              calcTrace[0].trace._glTrace = this;
	            };
	            proto.dispose = function dispose() {
	              var map2 = this.subplot.map;
	              var order = this.clusterEnabled ? ORDER.cluster : ORDER.nonCluster;
	              for (var i = order.length - 1; i >= 0; i--) {
	                var k = order[i];
	                map2.removeLayer(this.layerIds[k]);
	                map2.removeSource(this.sourceIds[k]);
	              }
	            };
	            module2.exports = function createScatterMapbox(subplot, calcTrace) {
	              var trace = calcTrace[0].trace;
	              var hasCluster = trace.cluster && trace.cluster.enabled;
	              var isHidden = trace.visible !== true;
	              var scatterMapbox = new ScatterMapbox(subplot, trace.uid, hasCluster, isHidden);
	              var optsAll = convert(subplot.gd, calcTrace);
	              var below = scatterMapbox.below = subplot.belowLookup["trace-" + trace.uid];
	              var i, k, opts;
	              if (hasCluster) {
	                scatterMapbox.addSource("circle", optsAll.circle, trace.cluster);
	                for (i = 0; i < ORDER.cluster.length; i++) {
	                  k = ORDER.cluster[i];
	                  opts = optsAll[k];
	                  scatterMapbox.addLayer(k, opts, below);
	                }
	              } else {
	                for (i = 0; i < ORDER.nonCluster.length; i++) {
	                  k = ORDER.nonCluster[i];
	                  opts = optsAll[k];
	                  scatterMapbox.addSource(k, opts, trace.cluster);
	                  scatterMapbox.addLayer(k, opts, below);
	                }
	              }
	              calcTrace[0].trace._glTrace = scatterMapbox;
	              return scatterMapbox;
	            };
	          }
	        ),
	        /***/
	        86387: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var subtypes = __webpack_require__2(34098);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function selectPoints(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              var trace = cd[0].trace;
	              var i;
	              if (!subtypes.hasMarkers(trace)) return [];
	              if (selectionTester === false) {
	                for (i = 0; i < cd.length; i++) {
	                  cd[i].selected = 0;
	                }
	              } else {
	                for (i = 0; i < cd.length; i++) {
	                  var di = cd[i];
	                  var lonlat = di.lonlat;
	                  if (lonlat[0] !== BADNUM) {
	                    var lonlat2 = [Lib.modHalf(lonlat[0], 360), lonlat[1]];
	                    var xy = [xa.c2p(lonlat2), ya.c2p(lonlat2)];
	                    if (selectionTester.contains(xy, null, i, searchInfo)) {
	                      selection.push({
	                        pointNumber: i,
	                        lon: lonlat[0],
	                        lat: lonlat[1]
	                      });
	                      di.selected = 1;
	                    } else {
	                      di.selected = 0;
	                    }
	                  }
	                }
	              }
	              return selection;
	            };
	          }
	        ),
	        /***/
	        81245: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterAttrs = __webpack_require__2(82196);
	            var baseAttrs = __webpack_require__2(9012);
	            var lineAttrs = scatterAttrs.line;
	            module2.exports = {
	              mode: scatterAttrs.mode,
	              r: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              theta: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              r0: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc+clearAxisTypes"
	              },
	              dr: {
	                valType: "number",
	                dflt: 1,
	                editType: "calc"
	              },
	              theta0: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc+clearAxisTypes"
	              },
	              dtheta: {
	                valType: "number",
	                editType: "calc"
	              },
	              thetaunit: {
	                valType: "enumerated",
	                values: ["radians", "degrees", "gradians"],
	                dflt: "degrees",
	                editType: "calc+clearAxisTypes"
	              },
	              text: scatterAttrs.text,
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["r", "theta", "text"]
	              }),
	              hovertext: scatterAttrs.hovertext,
	              line: {
	                color: lineAttrs.color,
	                width: lineAttrs.width,
	                dash: lineAttrs.dash,
	                backoff: lineAttrs.backoff,
	                shape: extendFlat({}, lineAttrs.shape, {
	                  values: ["linear", "spline"]
	                }),
	                smoothing: lineAttrs.smoothing,
	                editType: "calc"
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              marker: scatterAttrs.marker,
	              cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {
	                dflt: false
	              }),
	              textposition: scatterAttrs.textposition,
	              textfont: scatterAttrs.textfont,
	              fill: extendFlat({}, scatterAttrs.fill, {
	                values: ["none", "toself", "tonext"],
	                dflt: "none"
	              }),
	              fillcolor: scatterAttrs.fillcolor,
	              // TODO error bars
	              // https://stackoverflow.com/a/26597487/4068492
	              // error_x (error_r, error_theta)
	              // error_y
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["r", "theta", "text", "name"]
	              }),
	              hoveron: scatterAttrs.hoveron,
	              hovertemplate: hovertemplateAttrs(),
	              selected: scatterAttrs.selected,
	              unselected: scatterAttrs.unselected
	            };
	          }
	        ),
	        /***/
	        26442: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var Axes = __webpack_require__2(89298);
	            var calcColorscale = __webpack_require__2(36922);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            module2.exports = function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var subplotId = trace.subplot;
	              var radialAxis = fullLayout[subplotId].radialaxis;
	              var angularAxis = fullLayout[subplotId].angularaxis;
	              var rArray = radialAxis.makeCalcdata(trace, "r");
	              var thetaArray = angularAxis.makeCalcdata(trace, "theta");
	              var len = trace._length;
	              var cd = new Array(len);
	              for (var i = 0; i < len; i++) {
	                var r = rArray[i];
	                var theta = thetaArray[i];
	                var cdi = cd[i] = {};
	                if (isNumeric(r) && isNumeric(theta)) {
	                  cdi.r = r;
	                  cdi.theta = theta;
	                } else {
	                  cdi.r = BADNUM;
	                }
	              }
	              var ppad = calcMarkerSize(trace, len);
	              trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {
	                ppad
	              });
	              calcColorscale(gd, trace);
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        22184: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleLineShapeDefaults = __webpack_require__2(94039);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var PTS_LINESONLY = __webpack_require__2(47581).PTS_LINESONLY;
	            var attributes = __webpack_require__2(81245);
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("thetaunit");
	              coerce("mode", len < PTS_LINESONLY ? "lines+markers" : "lines");
	              coerce("text");
	              coerce("hovertext");
	              if (traceOut.hoveron !== "fills") coerce("hovertemplate");
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  backoff: true
	                });
	                handleLineShapeDefaults(traceIn, traceOut, coerce);
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  gradient: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              var dfltHoverOn = [];
	              if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	                coerce("cliponaxis");
	                coerce("marker.maxdisplayed");
	                dfltHoverOn.push("points");
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	                if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	              }
	              if (traceOut.fill === "tonext" || traceOut.fill === "toself") {
	                dfltHoverOn.push("fills");
	              }
	              coerce("hoveron", dfltHoverOn.join("+") || "points");
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            }
	            function handleRThetaDefaults(traceIn, traceOut, layout, coerce) {
	              var r = coerce("r");
	              var theta = coerce("theta");
	              var len;
	              if (r) {
	                if (theta) {
	                  len = Math.min(r.length, theta.length);
	                } else {
	                  len = r.length;
	                  coerce("theta0");
	                  coerce("dtheta");
	                }
	              } else {
	                if (!theta) return 0;
	                len = traceOut.theta.length;
	                coerce("r0");
	                coerce("dr");
	              }
	              traceOut._length = len;
	              return len;
	            }
	            module2.exports = {
	              handleRThetaDefaults,
	              supplyDefaults
	            };
	          }
	        ),
	        /***/
	        98608: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var labels = {};
	              var subplot = fullLayout[trace.subplot]._subplot;
	              var radialAxis;
	              var angularAxis;
	              if (!subplot) {
	                subplot = fullLayout[trace.subplot];
	                radialAxis = subplot.radialaxis;
	                angularAxis = subplot.angularaxis;
	              } else {
	                radialAxis = subplot.radialAxis;
	                angularAxis = subplot.angularAxis;
	              }
	              var rVal = radialAxis.c2l(cdi.r);
	              labels.rLabel = Axes.tickText(radialAxis, rVal, true).text;
	              var thetaVal = angularAxis.thetaunit === "degrees" ? Lib.rad2deg(cdi.theta) : cdi.theta;
	              labels.thetaLabel = Axes.tickText(angularAxis, thetaVal, true).text;
	              return labels;
	            };
	          }
	        ),
	        /***/
	        59150: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterHover = __webpack_require__2(33720);
	            function hoverPoints(pointData, xval, yval, hovermode) {
	              var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	              if (!scatterPointData || scatterPointData[0].index === false) return;
	              var newPointData = scatterPointData[0];
	              if (newPointData.index === undefined) {
	                return scatterPointData;
	              }
	              var subplot = pointData.subplot;
	              var cdi = newPointData.cd[newPointData.index];
	              var trace = newPointData.trace;
	              if (!subplot.isPtInside(cdi)) return;
	              newPointData.xLabelVal = undefined;
	              newPointData.yLabelVal = undefined;
	              makeHoverPointText(cdi, trace, subplot, newPointData);
	              newPointData.hovertemplate = trace.hovertemplate;
	              return scatterPointData;
	            }
	            function makeHoverPointText(cdi, trace, subplot, pointData) {
	              var radialAxis = subplot.radialAxis;
	              var angularAxis = subplot.angularAxis;
	              radialAxis._hovertitle = "r";
	              angularAxis._hovertitle = "θ";
	              var fullLayout = {};
	              fullLayout[trace.subplot] = {
	                _subplot: subplot
	              };
	              var labels = trace._module.formatLabels(cdi, trace, fullLayout);
	              pointData.rLabel = labels.rLabel;
	              pointData.thetaLabel = labels.thetaLabel;
	              var hoverinfo = cdi.hi || trace.hoverinfo;
	              var text = [];
	              function textPart(ax, val) {
	                text.push(ax._hovertitle + ": " + val);
	              }
	              if (!trace.hovertemplate) {
	                var parts = hoverinfo.split("+");
	                if (parts.indexOf("all") !== -1) parts = ["r", "theta", "text"];
	                if (parts.indexOf("r") !== -1) textPart(radialAxis, pointData.rLabel);
	                if (parts.indexOf("theta") !== -1) textPart(angularAxis, pointData.thetaLabel);
	                if (parts.indexOf("text") !== -1 && pointData.text) {
	                  text.push(pointData.text);
	                  delete pointData.text;
	                }
	                pointData.extraText = text.join("<br>");
	              }
	            }
	            module2.exports = {
	              hoverPoints,
	              makeHoverPointText
	            };
	          }
	        ),
	        /***/
	        91271: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "scatterpolar",
	              basePlotModule: __webpack_require__2(23580),
	              categories: ["polar", "symbols", "showLegend", "scatter-like"],
	              attributes: __webpack_require__2(81245),
	              supplyDefaults: __webpack_require__2(22184).supplyDefaults,
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(98608),
	              calc: __webpack_require__2(26442),
	              plot: __webpack_require__2(45162),
	              style: __webpack_require__2(16296).style,
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(59150).hoverPoints,
	              selectPoints: __webpack_require__2(98002),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        45162: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterPlot = __webpack_require__2(32663);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function plot(gd, subplot, moduleCalcData) {
	              var mlayer = subplot.layers.frontplot.select("g.scatterlayer");
	              var xa = subplot.xaxis;
	              var ya = subplot.yaxis;
	              var plotinfo = {
	                xaxis: xa,
	                yaxis: ya,
	                plot: subplot.framework,
	                layerClipId: subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null
	              };
	              var radialAxis = subplot.radialAxis;
	              var angularAxis = subplot.angularAxis;
	              for (var i = 0; i < moduleCalcData.length; i++) {
	                var cdi = moduleCalcData[i];
	                for (var j = 0; j < cdi.length; j++) {
	                  if (j === 0) {
	                    cdi[0].trace._xA = xa;
	                    cdi[0].trace._yA = ya;
	                  }
	                  var cd = cdi[j];
	                  var r = cd.r;
	                  if (r === BADNUM) {
	                    cd.x = cd.y = BADNUM;
	                  } else {
	                    var rg = radialAxis.c2g(r);
	                    var thetag = angularAxis.c2g(cd.theta);
	                    cd.x = rg * Math.cos(thetag);
	                    cd.y = rg * Math.sin(thetag);
	                  }
	                }
	              }
	              scatterPlot(gd, plotinfo, moduleCalcData, mlayer);
	            };
	          }
	        ),
	        /***/
	        53286: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterPolarAttrs = __webpack_require__2(81245);
	            var scatterGlAttrs = __webpack_require__2(42341);
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            module2.exports = {
	              mode: scatterPolarAttrs.mode,
	              r: scatterPolarAttrs.r,
	              theta: scatterPolarAttrs.theta,
	              r0: scatterPolarAttrs.r0,
	              dr: scatterPolarAttrs.dr,
	              theta0: scatterPolarAttrs.theta0,
	              dtheta: scatterPolarAttrs.dtheta,
	              thetaunit: scatterPolarAttrs.thetaunit,
	              text: scatterPolarAttrs.text,
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["r", "theta", "text"]
	              }),
	              hovertext: scatterPolarAttrs.hovertext,
	              hovertemplate: scatterPolarAttrs.hovertemplate,
	              line: scatterGlAttrs.line,
	              connectgaps: scatterGlAttrs.connectgaps,
	              marker: scatterGlAttrs.marker,
	              // no cliponaxis
	              fill: scatterGlAttrs.fill,
	              fillcolor: scatterGlAttrs.fillcolor,
	              textposition: scatterGlAttrs.textposition,
	              textfont: scatterGlAttrs.textfont,
	              hoverinfo: scatterPolarAttrs.hoverinfo,
	              // no hoveron
	              selected: scatterPolarAttrs.selected,
	              unselected: scatterPolarAttrs.unselected
	            };
	          }
	        ),
	        /***/
	        65746: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "scatterpolargl",
	              basePlotModule: __webpack_require__2(23580),
	              categories: ["gl", "regl", "polar", "symbols", "showLegend", "scatter-like"],
	              attributes: __webpack_require__2(53286),
	              supplyDefaults: __webpack_require__2(75485),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(46255),
	              calc: __webpack_require__2(37499),
	              hoverPoints: __webpack_require__2(29347).hoverPoints,
	              selectPoints: __webpack_require__2(58147),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        37499: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var calcColorscale = __webpack_require__2(36922);
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            var convert = __webpack_require__2(19635);
	            var Axes = __webpack_require__2(89298);
	            var TOO_MANY_POINTS = __webpack_require__2(78232).TOO_MANY_POINTS;
	            module2.exports = function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var subplotId = trace.subplot;
	              var radialAxis = fullLayout[subplotId].radialaxis;
	              var angularAxis = fullLayout[subplotId].angularaxis;
	              var rArray = trace._r = radialAxis.makeCalcdata(trace, "r");
	              var thetaArray = trace._theta = angularAxis.makeCalcdata(trace, "theta");
	              var len = trace._length;
	              var stash = {};
	              if (len < rArray.length) rArray = rArray.slice(0, len);
	              if (len < thetaArray.length) thetaArray = thetaArray.slice(0, len);
	              stash.r = rArray;
	              stash.theta = thetaArray;
	              calcColorscale(gd, trace);
	              var opts = stash.opts = convert.style(gd, trace);
	              var ppad;
	              if (len < TOO_MANY_POINTS) {
	                ppad = calcMarkerSize(trace, len);
	              } else if (opts.marker) {
	                ppad = 2 * (opts.marker.sizeAvg || Math.max(opts.marker.size, 3));
	              }
	              trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {
	                ppad
	              });
	              return [{
	                x: false,
	                y: false,
	                t: stash,
	                trace
	              }];
	            };
	          }
	        ),
	        /***/
	        75485: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var subTypes = __webpack_require__2(34098);
	            var handleRThetaDefaults = __webpack_require__2(22184).handleRThetaDefaults;
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var PTS_LINESONLY = __webpack_require__2(47581).PTS_LINESONLY;
	            var attributes = __webpack_require__2(53286);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("thetaunit");
	              coerce("mode", len < PTS_LINESONLY ? "lines+markers" : "lines");
	              coerce("text");
	              coerce("hovertext");
	              if (traceOut.hoveron !== "fills") coerce("hovertemplate");
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  noAngleRef: true,
	                  noStandOff: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	              }
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        46255: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterPolarFormatLabels = __webpack_require__2(98608);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var i = cdi.i;
	              if (!("r" in cdi)) cdi.r = trace._r[i];
	              if (!("theta" in cdi)) cdi.theta = trace._theta[i];
	              return scatterPolarFormatLabels(cdi, trace, fullLayout);
	            };
	          }
	        ),
	        /***/
	        29347: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hover = __webpack_require__2(20794);
	            var makeHoverPointText = __webpack_require__2(59150).makeHoverPointText;
	            function hoverPoints(pointData, xval, yval, hovermode) {
	              var cd = pointData.cd;
	              var stash = cd[0].t;
	              var rArray = stash.r;
	              var thetaArray = stash.theta;
	              var scatterPointData = hover.hoverPoints(pointData, xval, yval, hovermode);
	              if (!scatterPointData || scatterPointData[0].index === false) return;
	              var newPointData = scatterPointData[0];
	              if (newPointData.index === undefined) {
	                return scatterPointData;
	              }
	              var subplot = pointData.subplot;
	              var cdi = newPointData.cd[newPointData.index];
	              var trace = newPointData.trace;
	              cdi.r = rArray[newPointData.index];
	              cdi.theta = thetaArray[newPointData.index];
	              if (!subplot.isPtInside(cdi)) return;
	              newPointData.xLabelVal = undefined;
	              newPointData.yLabelVal = undefined;
	              makeHoverPointText(cdi, trace, subplot, newPointData);
	              return scatterPointData;
	            }
	            module2.exports = {
	              hoverPoints
	            };
	          }
	        ),
	        /***/
	        21461: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var index = __webpack_require__2(65746);
	            index.plot = __webpack_require__2(49741);
	            module2.exports = index;
	          }
	        ),
	        /***/
	        49741: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var cluster = __webpack_require__2(88294);
	            var isNumeric = __webpack_require__2(92770);
	            var scatterglPlot = __webpack_require__2(26787);
	            var sceneUpdate = __webpack_require__2(38967);
	            var convert = __webpack_require__2(19635);
	            var Lib = __webpack_require__2(71828);
	            var TOO_MANY_POINTS = __webpack_require__2(78232).TOO_MANY_POINTS;
	            var reglPrecompiled = {};
	            module2.exports = function plot(gd, subplot, cdata) {
	              if (!cdata.length) return;
	              var radialAxis = subplot.radialAxis;
	              var angularAxis = subplot.angularAxis;
	              var scene = sceneUpdate(gd, subplot);
	              cdata.forEach(function(cdscatter) {
	                if (!cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
	                var cd = cdscatter[0];
	                var trace = cd.trace;
	                var stash = cd.t;
	                var len = trace._length;
	                var rArray = stash.r;
	                var thetaArray = stash.theta;
	                var opts = stash.opts;
	                var i;
	                var subRArray = rArray.slice();
	                var subThetaArray = thetaArray.slice();
	                for (i = 0; i < rArray.length; i++) {
	                  if (!subplot.isPtInside({
	                    r: rArray[i],
	                    theta: thetaArray[i]
	                  })) {
	                    subRArray[i] = NaN;
	                    subThetaArray[i] = NaN;
	                  }
	                }
	                var positions = new Array(len * 2);
	                var x = Array(len);
	                var y = Array(len);
	                for (i = 0; i < len; i++) {
	                  var r = subRArray[i];
	                  var xx, yy;
	                  if (isNumeric(r)) {
	                    var rg = radialAxis.c2g(r);
	                    var thetag = angularAxis.c2g(subThetaArray[i], trace.thetaunit);
	                    xx = rg * Math.cos(thetag);
	                    yy = rg * Math.sin(thetag);
	                  } else {
	                    xx = yy = NaN;
	                  }
	                  x[i] = positions[i * 2] = xx;
	                  y[i] = positions[i * 2 + 1] = yy;
	                }
	                stash.tree = cluster(positions);
	                if (opts.marker && len >= TOO_MANY_POINTS) {
	                  opts.marker.cluster = stash.tree;
	                }
	                if (opts.marker) {
	                  opts.markerSel.positions = opts.markerUnsel.positions = opts.marker.positions = positions;
	                }
	                if (opts.line && positions.length > 1) {
	                  Lib.extendFlat(opts.line, convert.linePositions(gd, trace, positions));
	                }
	                if (opts.text) {
	                  Lib.extendFlat(opts.text, {
	                    positions
	                  }, convert.textPosition(gd, trace, opts.text, opts.marker));
	                  Lib.extendFlat(opts.textSel, {
	                    positions
	                  }, convert.textPosition(gd, trace, opts.text, opts.markerSel));
	                  Lib.extendFlat(opts.textUnsel, {
	                    positions
	                  }, convert.textPosition(gd, trace, opts.text, opts.markerUnsel));
	                }
	                if (opts.fill && !scene.fill2d) scene.fill2d = true;
	                if (opts.marker && !scene.scatter2d) scene.scatter2d = true;
	                if (opts.line && !scene.line2d) scene.line2d = true;
	                if (opts.text && !scene.glText) scene.glText = true;
	                scene.lineOptions.push(opts.line);
	                scene.fillOptions.push(opts.fill);
	                scene.markerOptions.push(opts.marker);
	                scene.markerSelectedOptions.push(opts.markerSel);
	                scene.markerUnselectedOptions.push(opts.markerUnsel);
	                scene.textOptions.push(opts.text);
	                scene.textSelectedOptions.push(opts.textSel);
	                scene.textUnselectedOptions.push(opts.textUnsel);
	                scene.selectBatch.push([]);
	                scene.unselectBatch.push([]);
	                stash.x = x;
	                stash.y = y;
	                stash.rawx = x;
	                stash.rawy = y;
	                stash.r = rArray;
	                stash.theta = thetaArray;
	                stash.positions = positions;
	                stash._scene = scene;
	                stash.index = scene.count;
	                scene.count++;
	              });
	              return scatterglPlot(gd, subplot, cdata);
	            };
	            module2.exports.reglPrecompiled = reglPrecompiled;
	          }
	        ),
	        /***/
	        48300: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterAttrs = __webpack_require__2(82196);
	            var baseAttrs = __webpack_require__2(9012);
	            var lineAttrs = scatterAttrs.line;
	            module2.exports = {
	              mode: scatterAttrs.mode,
	              real: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              imag: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              text: scatterAttrs.text,
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["real", "imag", "text"]
	              }),
	              hovertext: scatterAttrs.hovertext,
	              line: {
	                color: lineAttrs.color,
	                width: lineAttrs.width,
	                dash: lineAttrs.dash,
	                backoff: lineAttrs.backoff,
	                shape: extendFlat({}, lineAttrs.shape, {
	                  values: ["linear", "spline"]
	                }),
	                smoothing: lineAttrs.smoothing,
	                editType: "calc"
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              marker: scatterAttrs.marker,
	              cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {
	                dflt: false
	              }),
	              textposition: scatterAttrs.textposition,
	              textfont: scatterAttrs.textfont,
	              fill: extendFlat({}, scatterAttrs.fill, {
	                values: ["none", "toself", "tonext"],
	                dflt: "none"
	              }),
	              fillcolor: scatterAttrs.fillcolor,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["real", "imag", "text", "name"]
	              }),
	              hoveron: scatterAttrs.hoveron,
	              hovertemplate: hovertemplateAttrs(),
	              selected: scatterAttrs.selected,
	              unselected: scatterAttrs.unselected
	            };
	          }
	        ),
	        /***/
	        30621: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var calcColorscale = __webpack_require__2(36922);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            module2.exports = function calc(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var subplotId = trace.subplot;
	              var realAxis = fullLayout[subplotId].realaxis;
	              var imaginaryAxis = fullLayout[subplotId].imaginaryaxis;
	              var realArray = realAxis.makeCalcdata(trace, "real");
	              var imagArray = imaginaryAxis.makeCalcdata(trace, "imag");
	              var len = trace._length;
	              var cd = new Array(len);
	              for (var i = 0; i < len; i++) {
	                var real = realArray[i];
	                var imag = imagArray[i];
	                var cdi = cd[i] = {};
	                if (isNumeric(real) && isNumeric(imag)) {
	                  cdi.real = real;
	                  cdi.imag = imag;
	                } else {
	                  cdi.real = BADNUM;
	                }
	              }
	              calcMarkerSize(trace, len);
	              calcColorscale(gd, trace);
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        65269: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleLineShapeDefaults = __webpack_require__2(94039);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var PTS_LINESONLY = __webpack_require__2(47581).PTS_LINESONLY;
	            var attributes = __webpack_require__2(48300);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleRealImagDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("mode", len < PTS_LINESONLY ? "lines+markers" : "lines");
	              coerce("text");
	              coerce("hovertext");
	              if (traceOut.hoveron !== "fills") coerce("hovertemplate");
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  backoff: true
	                });
	                handleLineShapeDefaults(traceIn, traceOut, coerce);
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  gradient: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              var dfltHoverOn = [];
	              if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	                coerce("cliponaxis");
	                coerce("marker.maxdisplayed");
	                dfltHoverOn.push("points");
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	                if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	              }
	              if (traceOut.fill === "tonext" || traceOut.fill === "toself") {
	                dfltHoverOn.push("fills");
	              }
	              coerce("hoveron", dfltHoverOn.join("+") || "points");
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	            function handleRealImagDefaults(traceIn, traceOut, layout, coerce) {
	              var real = coerce("real");
	              var imag = coerce("imag");
	              var len;
	              if (real && imag) {
	                len = Math.min(real.length, imag.length);
	              }
	              traceOut._length = len;
	              return len;
	            }
	          }
	        ),
	        /***/
	        62047: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var labels = {};
	              var subplot = fullLayout[trace.subplot]._subplot;
	              labels.realLabel = Axes.tickText(subplot.radialAxis, cdi.real, true).text;
	              labels.imagLabel = Axes.tickText(subplot.angularAxis, cdi.imag, true).text;
	              return labels;
	            };
	          }
	        ),
	        /***/
	        11350: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterHover = __webpack_require__2(33720);
	            function hoverPoints(pointData, xval, yval, hovermode) {
	              var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	              if (!scatterPointData || scatterPointData[0].index === false) return;
	              var newPointData = scatterPointData[0];
	              if (newPointData.index === undefined) {
	                return scatterPointData;
	              }
	              var subplot = pointData.subplot;
	              var cdi = newPointData.cd[newPointData.index];
	              var trace = newPointData.trace;
	              if (!subplot.isPtInside(cdi)) return;
	              newPointData.xLabelVal = undefined;
	              newPointData.yLabelVal = undefined;
	              makeHoverPointText(cdi, trace, subplot, newPointData);
	              newPointData.hovertemplate = trace.hovertemplate;
	              return scatterPointData;
	            }
	            function makeHoverPointText(cdi, trace, subplot, pointData) {
	              var realAxis = subplot.radialAxis;
	              var imaginaryAxis = subplot.angularAxis;
	              realAxis._hovertitle = "real";
	              imaginaryAxis._hovertitle = "imag";
	              var fullLayout = {};
	              fullLayout[trace.subplot] = {
	                _subplot: subplot
	              };
	              var labels = trace._module.formatLabels(cdi, trace, fullLayout);
	              pointData.realLabel = labels.realLabel;
	              pointData.imagLabel = labels.imagLabel;
	              var hoverinfo = cdi.hi || trace.hoverinfo;
	              var text = [];
	              function textPart(ax, val) {
	                text.push(ax._hovertitle + ": " + val);
	              }
	              if (!trace.hovertemplate) {
	                var parts = hoverinfo.split("+");
	                if (parts.indexOf("all") !== -1) parts = ["real", "imag", "text"];
	                if (parts.indexOf("real") !== -1) textPart(realAxis, pointData.realLabel);
	                if (parts.indexOf("imag") !== -1) textPart(imaginaryAxis, pointData.imagLabel);
	                if (parts.indexOf("text") !== -1 && pointData.text) {
	                  text.push(pointData.text);
	                  delete pointData.text;
	                }
	                pointData.extraText = text.join("<br>");
	              }
	            }
	            module2.exports = {
	              hoverPoints,
	              makeHoverPointText
	            };
	          }
	        ),
	        /***/
	        85956: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "scattersmith",
	              basePlotModule: __webpack_require__2(7504),
	              categories: ["smith", "symbols", "showLegend", "scatter-like"],
	              attributes: __webpack_require__2(48300),
	              supplyDefaults: __webpack_require__2(65269),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(62047),
	              calc: __webpack_require__2(30621),
	              plot: __webpack_require__2(12480),
	              style: __webpack_require__2(16296).style,
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(11350).hoverPoints,
	              selectPoints: __webpack_require__2(98002),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        12480: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterPlot = __webpack_require__2(32663);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var helpers = __webpack_require__2(23893);
	            var smith = helpers.smith;
	            module2.exports = function plot(gd, subplot, moduleCalcData) {
	              var mlayer = subplot.layers.frontplot.select("g.scatterlayer");
	              var xa = subplot.xaxis;
	              var ya = subplot.yaxis;
	              var plotinfo = {
	                xaxis: xa,
	                yaxis: ya,
	                plot: subplot.framework,
	                layerClipId: subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null
	              };
	              for (var i = 0; i < moduleCalcData.length; i++) {
	                var cdi = moduleCalcData[i];
	                for (var j = 0; j < cdi.length; j++) {
	                  if (j === 0) {
	                    cdi[0].trace._xA = xa;
	                    cdi[0].trace._yA = ya;
	                  }
	                  var cd = cdi[j];
	                  var real = cd.real;
	                  if (real === BADNUM) {
	                    cd.x = cd.y = BADNUM;
	                  } else {
	                    var t = smith([real, cd.imag]);
	                    cd.x = t[0];
	                    cd.y = t[1];
	                  }
	                }
	              }
	              scatterPlot(gd, plotinfo, moduleCalcData, mlayer);
	            };
	          }
	        ),
	        /***/
	        50413: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var scatterAttrs = __webpack_require__2(82196);
	            var baseAttrs = __webpack_require__2(9012);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var dash = __webpack_require__2(79952).P;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterLineAttrs = scatterAttrs.line;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            module2.exports = {
	              a: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              b: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              c: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              sum: {
	                valType: "number",
	                dflt: 0,
	                min: 0,
	                editType: "calc"
	              },
	              mode: extendFlat({}, scatterAttrs.mode, {
	                dflt: "markers"
	              }),
	              text: extendFlat({}, scatterAttrs.text, {}),
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: ["a", "b", "c", "text"]
	              }),
	              hovertext: extendFlat({}, scatterAttrs.hovertext, {}),
	              line: {
	                color: scatterLineAttrs.color,
	                width: scatterLineAttrs.width,
	                dash,
	                backoff: scatterLineAttrs.backoff,
	                shape: extendFlat({}, scatterLineAttrs.shape, {
	                  values: ["linear", "spline"]
	                }),
	                smoothing: scatterLineAttrs.smoothing,
	                editType: "calc"
	              },
	              connectgaps: scatterAttrs.connectgaps,
	              cliponaxis: scatterAttrs.cliponaxis,
	              fill: extendFlat({}, scatterAttrs.fill, {
	                values: ["none", "toself", "tonext"],
	                dflt: "none"
	              }),
	              fillcolor: scatterAttrs.fillcolor,
	              marker: extendFlat({
	                symbol: scatterMarkerAttrs.symbol,
	                opacity: scatterMarkerAttrs.opacity,
	                angle: scatterMarkerAttrs.angle,
	                angleref: scatterMarkerAttrs.angleref,
	                standoff: scatterMarkerAttrs.standoff,
	                maxdisplayed: scatterMarkerAttrs.maxdisplayed,
	                size: scatterMarkerAttrs.size,
	                sizeref: scatterMarkerAttrs.sizeref,
	                sizemin: scatterMarkerAttrs.sizemin,
	                sizemode: scatterMarkerAttrs.sizemode,
	                line: extendFlat({
	                  width: scatterMarkerLineAttrs.width,
	                  editType: "calc"
	                }, colorScaleAttrs("marker.line")),
	                gradient: scatterMarkerAttrs.gradient,
	                editType: "calc"
	              }, colorScaleAttrs("marker")),
	              textfont: scatterAttrs.textfont,
	              textposition: scatterAttrs.textposition,
	              selected: scatterAttrs.selected,
	              unselected: scatterAttrs.unselected,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["a", "b", "c", "text", "name"]
	              }),
	              hoveron: scatterAttrs.hoveron,
	              hovertemplate: hovertemplateAttrs()
	            };
	          }
	        ),
	        /***/
	        54337: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isNumeric = __webpack_require__2(92770);
	            var calcColorscale = __webpack_require__2(36922);
	            var arraysToCalcdata = __webpack_require__2(75225);
	            var calcSelection = __webpack_require__2(66279);
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            var dataArrays = ["a", "b", "c"];
	            var arraysToFill = {
	              a: ["b", "c"],
	              b: ["a", "c"],
	              c: ["a", "b"]
	            };
	            module2.exports = function calc(gd, trace) {
	              var ternary = gd._fullLayout[trace.subplot];
	              var displaySum = ternary.sum;
	              var normSum = trace.sum || displaySum;
	              var arrays = {
	                a: trace.a,
	                b: trace.b,
	                c: trace.c
	              };
	              var i, j, dataArray, newArray, fillArray1, fillArray2;
	              for (i = 0; i < dataArrays.length; i++) {
	                dataArray = dataArrays[i];
	                if (arrays[dataArray]) continue;
	                fillArray1 = arrays[arraysToFill[dataArray][0]];
	                fillArray2 = arrays[arraysToFill[dataArray][1]];
	                newArray = new Array(fillArray1.length);
	                for (j = 0; j < fillArray1.length; j++) {
	                  newArray[j] = normSum - fillArray1[j] - fillArray2[j];
	                }
	                arrays[dataArray] = newArray;
	              }
	              var serieslen = trace._length;
	              var cd = new Array(serieslen);
	              var a, b, c, norm, x, y;
	              for (i = 0; i < serieslen; i++) {
	                a = arrays.a[i];
	                b = arrays.b[i];
	                c = arrays.c[i];
	                if (isNumeric(a) && isNumeric(b) && isNumeric(c)) {
	                  a = +a;
	                  b = +b;
	                  c = +c;
	                  norm = displaySum / (a + b + c);
	                  if (norm !== 1) {
	                    a *= norm;
	                    b *= norm;
	                    c *= norm;
	                  }
	                  y = a;
	                  x = c - b;
	                  cd[i] = {
	                    x,
	                    y,
	                    a,
	                    b,
	                    c
	                  };
	                } else cd[i] = {
	                  x: false,
	                  y: false
	                };
	              }
	              calcMarkerSize(trace, serieslen);
	              calcColorscale(gd, trace);
	              arraysToCalcdata(cd, trace);
	              calcSelection(cd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        46008: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var constants = __webpack_require__2(47581);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var handleLineDefaults = __webpack_require__2(11058);
	            var handleLineShapeDefaults = __webpack_require__2(94039);
	            var handleTextDefaults = __webpack_require__2(82410);
	            var handleFillColorDefaults = __webpack_require__2(28908);
	            var attributes = __webpack_require__2(50413);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var a = coerce("a");
	              var b = coerce("b");
	              var c = coerce("c");
	              var len;
	              if (a) {
	                len = a.length;
	                if (b) {
	                  len = Math.min(len, b.length);
	                  if (c) len = Math.min(len, c.length);
	                } else if (c) len = Math.min(len, c.length);
	                else len = 0;
	              } else if (b && c) {
	                len = Math.min(b.length, c.length);
	              }
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._length = len;
	              coerce("sum");
	              coerce("text");
	              coerce("hovertext");
	              if (traceOut.hoveron !== "fills") coerce("hovertemplate");
	              var defaultMode = len < constants.PTS_LINESONLY ? "lines+markers" : "lines";
	              coerce("mode", defaultMode);
	              if (subTypes.hasLines(traceOut)) {
	                handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  backoff: true
	                });
	                handleLineShapeDefaults(traceIn, traceOut, coerce);
	                coerce("connectgaps");
	              }
	              if (subTypes.hasMarkers(traceOut)) {
	                handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                  gradient: true
	                });
	              }
	              if (subTypes.hasText(traceOut)) {
	                coerce("texttemplate");
	                handleTextDefaults(traceIn, traceOut, layout, coerce);
	              }
	              var dfltHoverOn = [];
	              if (subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
	                coerce("cliponaxis");
	                coerce("marker.maxdisplayed");
	                dfltHoverOn.push("points");
	              }
	              coerce("fill");
	              if (traceOut.fill !== "none") {
	                handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
	                if (!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
	              }
	              if (traceOut.fill === "tonext" || traceOut.fill === "toself") {
	                dfltHoverOn.push("fills");
	              }
	              coerce("hoveron", dfltHoverOn.join("+") || "points");
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	          }
	        ),
	        /***/
	        4524: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt, trace, cd, pointNumber) {
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              if (cd[pointNumber]) {
	                var cdi = cd[pointNumber];
	                out.a = cdi.a;
	                out.b = cdi.b;
	                out.c = cdi.c;
	              } else {
	                out.a = pt.a;
	                out.b = pt.b;
	                out.c = pt.c;
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        93645: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            module2.exports = function formatLabels(cdi, trace, fullLayout) {
	              var labels = {};
	              var subplot = fullLayout[trace.subplot]._subplot;
	              labels.aLabel = Axes.tickText(subplot.aaxis, cdi.a, true).text;
	              labels.bLabel = Axes.tickText(subplot.baxis, cdi.b, true).text;
	              labels.cLabel = Axes.tickText(subplot.caxis, cdi.c, true).text;
	              return labels;
	            };
	          }
	        ),
	        /***/
	        47250: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterHover = __webpack_require__2(33720);
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode) {
	              var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
	              if (!scatterPointData || scatterPointData[0].index === false) return;
	              var newPointData = scatterPointData[0];
	              if (newPointData.index === undefined) {
	                var yFracUp = 1 - newPointData.y0 / pointData.ya._length;
	                var xLen = pointData.xa._length;
	                var xMin = xLen * yFracUp / 2;
	                var xMax = xLen - xMin;
	                newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
	                newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
	                return scatterPointData;
	              }
	              var cdi = newPointData.cd[newPointData.index];
	              var trace = newPointData.trace;
	              var subplot = newPointData.subplot;
	              newPointData.a = cdi.a;
	              newPointData.b = cdi.b;
	              newPointData.c = cdi.c;
	              newPointData.xLabelVal = undefined;
	              newPointData.yLabelVal = undefined;
	              var fullLayout = {};
	              fullLayout[trace.subplot] = {
	                _subplot: subplot
	              };
	              var labels = trace._module.formatLabels(cdi, trace, fullLayout);
	              newPointData.aLabel = labels.aLabel;
	              newPointData.bLabel = labels.bLabel;
	              newPointData.cLabel = labels.cLabel;
	              var hoverinfo = cdi.hi || trace.hoverinfo;
	              var text = [];
	              function textPart(ax, val) {
	                text.push(ax._hovertitle + ": " + val);
	              }
	              if (!trace.hovertemplate) {
	                var parts = hoverinfo.split("+");
	                if (parts.indexOf("all") !== -1) parts = ["a", "b", "c"];
	                if (parts.indexOf("a") !== -1) textPart(subplot.aaxis, newPointData.aLabel);
	                if (parts.indexOf("b") !== -1) textPart(subplot.baxis, newPointData.bLabel);
	                if (parts.indexOf("c") !== -1) textPart(subplot.caxis, newPointData.cLabel);
	              }
	              newPointData.extraText = text.join("<br>");
	              newPointData.hovertemplate = trace.hovertemplate;
	              return scatterPointData;
	            };
	          }
	        ),
	        /***/
	        52979: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(50413),
	              supplyDefaults: __webpack_require__2(46008),
	              colorbar: __webpack_require__2(4898),
	              formatLabels: __webpack_require__2(93645),
	              calc: __webpack_require__2(54337),
	              plot: __webpack_require__2(7507),
	              style: __webpack_require__2(16296).style,
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(47250),
	              selectPoints: __webpack_require__2(98002),
	              eventData: __webpack_require__2(4524),
	              moduleType: "trace",
	              name: "scatterternary",
	              basePlotModule: __webpack_require__2(61639),
	              categories: ["ternary", "symbols", "showLegend", "scatter-like"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        7507: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterPlot = __webpack_require__2(32663);
	            module2.exports = function plot(gd, ternary, moduleCalcData) {
	              var plotContainer = ternary.plotContainer;
	              plotContainer.select(".scatterlayer").selectAll("*").remove();
	              var xa = ternary.xaxis;
	              var ya = ternary.yaxis;
	              var plotinfo = {
	                xaxis: xa,
	                yaxis: ya,
	                plot: plotContainer,
	                layerClipId: ternary._hasClipOnAxisFalse ? ternary.clipIdRelative : null
	              };
	              var scatterLayer = ternary.layers.frontplot.select("g.scatterlayer");
	              for (var i = 0; i < moduleCalcData.length; i++) {
	                var cdi = moduleCalcData[i];
	                if (cdi.length) {
	                  cdi[0].trace._xA = xa;
	                  cdi[0].trace._yA = ya;
	                }
	              }
	              scatterPlot(gd, plotinfo, moduleCalcData, scatterLayer);
	            };
	          }
	        ),
	        /***/
	        46880: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var scatterAttrs = __webpack_require__2(82196);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var scatterGlAttrs = __webpack_require__2(42341);
	            var cartesianIdRegex = __webpack_require__2(85555).idRegex;
	            var templatedArray = __webpack_require__2(44467).templatedArray;
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var scatterMarkerAttrs = scatterAttrs.marker;
	            var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
	            var markerLineAttrs = extendFlat(colorScaleAttrs("marker.line", {
	              editTypeOverride: "calc"
	            }), {
	              width: extendFlat({}, scatterMarkerLineAttrs.width, {
	                editType: "calc"
	              }),
	              editType: "calc"
	            });
	            var markerAttrs = extendFlat(colorScaleAttrs("marker"), {
	              symbol: scatterMarkerAttrs.symbol,
	              angle: scatterMarkerAttrs.angle,
	              size: extendFlat({}, scatterMarkerAttrs.size, {
	                editType: "markerSize"
	              }),
	              sizeref: scatterMarkerAttrs.sizeref,
	              sizemin: scatterMarkerAttrs.sizemin,
	              sizemode: scatterMarkerAttrs.sizemode,
	              opacity: scatterMarkerAttrs.opacity,
	              colorbar: scatterMarkerAttrs.colorbar,
	              line: markerLineAttrs,
	              editType: "calc"
	            });
	            markerAttrs.color.editType = markerAttrs.cmin.editType = markerAttrs.cmax.editType = "style";
	            function makeAxesValObject(axLetter) {
	              return {
	                valType: "info_array",
	                freeLength: true,
	                editType: "calc",
	                items: {
	                  valType: "subplotid",
	                  regex: cartesianIdRegex[axLetter],
	                  editType: "plot"
	                }
	              };
	            }
	            module2.exports = {
	              dimensions: templatedArray("dimension", {
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "calc"
	                },
	                label: {
	                  valType: "string",
	                  editType: "calc"
	                },
	                values: {
	                  valType: "data_array",
	                  editType: "calc+clearAxisTypes"
	                },
	                axis: {
	                  type: {
	                    valType: "enumerated",
	                    values: ["linear", "log", "date", "category"],
	                    editType: "calc+clearAxisTypes"
	                  },
	                  // TODO make 'true' the default in v3?
	                  matches: {
	                    valType: "boolean",
	                    dflt: false,
	                    editType: "calc"
	                  },
	                  editType: "calc+clearAxisTypes"
	                },
	                // TODO should add an attribute to pin down x only vars and y only vars
	                // like https://seaborn.pydata.org/generated/seaborn.pairplot.html
	                // x_vars and y_vars
	                // maybe more axis defaulting option e.g. `showgrid: false`
	                editType: "calc+clearAxisTypes"
	              }),
	              // mode: {}, (only 'markers' for now)
	              text: extendFlat({}, scatterGlAttrs.text, {}),
	              hovertext: extendFlat({}, scatterGlAttrs.hovertext, {}),
	              hovertemplate: hovertemplateAttrs(),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              marker: markerAttrs,
	              xaxes: makeAxesValObject("x"),
	              yaxes: makeAxesValObject("y"),
	              diagonal: {
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "calc"
	                },
	                // type: 'scattergl' | 'histogram' | 'box' | 'violin'
	                // ...
	                // more options
	                editType: "calc"
	              },
	              showupperhalf: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              showlowerhalf: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              selected: {
	                marker: scatterGlAttrs.selected.marker,
	                editType: "calc"
	              },
	              unselected: {
	                marker: scatterGlAttrs.unselected.marker,
	                editType: "calc"
	              },
	              opacity: scatterGlAttrs.opacity
	            };
	          }
	        ),
	        /***/
	        65017: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Grid = __webpack_require__2(83312);
	            module2.exports = {
	              moduleType: "trace",
	              name: "splom",
	              categories: ["gl", "regl", "cartesian", "symbols", "showLegend", "scatter-like"],
	              attributes: __webpack_require__2(46880),
	              supplyDefaults: __webpack_require__2(25784),
	              colorbar: __webpack_require__2(4898),
	              calc: __webpack_require__2(87625),
	              plot: __webpack_require__2(79410),
	              hoverPoints: __webpack_require__2(8567).hoverPoints,
	              selectPoints: __webpack_require__2(8689),
	              editStyle: __webpack_require__2(28801),
	              meta: {}
	            };
	            Registry.register(Grid);
	          }
	        ),
	        /***/
	        16947: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createLine = __webpack_require__2(46075);
	            var Registry = __webpack_require__2(73972);
	            var prepareRegl = __webpack_require__2(79749);
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var Cartesian = __webpack_require__2(93612);
	            var getFromId = __webpack_require__2(41675).getFromId;
	            var shouldShowZeroLine = __webpack_require__2(89298).shouldShowZeroLine;
	            var SPLOM = "splom";
	            var reglPrecompiled = {};
	            function plot(gd) {
	              var fullLayout = gd._fullLayout;
	              var _module = Registry.getModule(SPLOM);
	              var splomCalcData = getModuleCalcData(gd.calcdata, _module)[0];
	              var success = prepareRegl(gd, ["ANGLE_instanced_arrays", "OES_element_index_uint"], reglPrecompiled);
	              if (!success) return;
	              if (fullLayout._hasOnlyLargeSploms) {
	                updateGrid(gd);
	              }
	              _module.plot(gd, {}, splomCalcData);
	            }
	            function drag(gd) {
	              var cd = gd.calcdata;
	              var fullLayout = gd._fullLayout;
	              if (fullLayout._hasOnlyLargeSploms) {
	                updateGrid(gd);
	              }
	              for (var i = 0; i < cd.length; i++) {
	                var cd0 = cd[i][0];
	                var trace = cd0.trace;
	                var scene = fullLayout._splomScenes[trace.uid];
	                if (trace.type === "splom" && scene && scene.matrix) {
	                  dragOne(gd, trace, scene);
	                }
	              }
	            }
	            function dragOne(gd, trace, scene) {
	              var visibleLength = scene.matrixOptions.data.length;
	              var visibleDims = trace._visibleDims;
	              var ranges = scene.viewOpts.ranges = new Array(visibleLength);
	              for (var k = 0; k < visibleDims.length; k++) {
	                var i = visibleDims[k];
	                var rng = ranges[k] = new Array(4);
	                var xa = getFromId(gd, trace._diag[i][0]);
	                if (xa) {
	                  rng[0] = xa.r2l(xa.range[0]);
	                  rng[2] = xa.r2l(xa.range[1]);
	                }
	                var ya = getFromId(gd, trace._diag[i][1]);
	                if (ya) {
	                  rng[1] = ya.r2l(ya.range[0]);
	                  rng[3] = ya.r2l(ya.range[1]);
	                }
	              }
	              if (scene.selectBatch.length || scene.unselectBatch.length) {
	                scene.matrix.update({
	                  ranges
	                }, {
	                  ranges
	                });
	              } else {
	                scene.matrix.update({
	                  ranges
	                });
	              }
	            }
	            function updateGrid(gd) {
	              var fullLayout = gd._fullLayout;
	              var regl = fullLayout._glcanvas.data()[0].regl;
	              var splomGrid = fullLayout._splomGrid;
	              if (!splomGrid) {
	                splomGrid = fullLayout._splomGrid = createLine(regl);
	              }
	              splomGrid.update(makeGridData(gd));
	            }
	            function makeGridData(gd) {
	              var plotGlPixelRatio = gd._context.plotGlPixelRatio;
	              var fullLayout = gd._fullLayout;
	              var gs = fullLayout._size;
	              var fullView = [0, 0, fullLayout.width * plotGlPixelRatio, fullLayout.height * plotGlPixelRatio];
	              var lookup = {};
	              var k;
	              function push(prefix, ax, x0, x1, y0, y1) {
	                x0 *= plotGlPixelRatio;
	                x1 *= plotGlPixelRatio;
	                y0 *= plotGlPixelRatio;
	                y1 *= plotGlPixelRatio;
	                var lcolor = ax[prefix + "color"];
	                var lwidth = ax[prefix + "width"];
	                var key = String(lcolor + lwidth);
	                if (key in lookup) {
	                  lookup[key].data.push(NaN, NaN, x0, x1, y0, y1);
	                } else {
	                  lookup[key] = {
	                    data: [x0, x1, y0, y1],
	                    join: "rect",
	                    thickness: lwidth * plotGlPixelRatio,
	                    color: lcolor,
	                    viewport: fullView,
	                    range: fullView,
	                    overlay: false
	                  };
	                }
	              }
	              for (k in fullLayout._splomSubplots) {
	                var sp = fullLayout._plots[k];
	                var xa = sp.xaxis;
	                var ya = sp.yaxis;
	                var xVals = xa._gridVals;
	                var yVals = ya._gridVals;
	                var xOffset = xa._offset;
	                var xLength = xa._length;
	                var yLength = ya._length;
	                var yOffset = gs.b + ya.domain[0] * gs.h;
	                var ym = -ya._m;
	                var yb = -ym * ya.r2l(ya.range[0], ya.calendar);
	                var x, y;
	                if (xa.showgrid) {
	                  for (k = 0; k < xVals.length; k++) {
	                    x = xOffset + xa.l2p(xVals[k].x);
	                    push("grid", xa, x, yOffset, x, yOffset + yLength);
	                  }
	                }
	                if (ya.showgrid) {
	                  for (k = 0; k < yVals.length; k++) {
	                    y = yOffset + yb + ym * yVals[k].x;
	                    push("grid", ya, xOffset, y, xOffset + xLength, y);
	                  }
	                }
	                if (shouldShowZeroLine(gd, xa, ya)) {
	                  x = xOffset + xa.l2p(0);
	                  push("zeroline", xa, x, yOffset, x, yOffset + yLength);
	                }
	                if (shouldShowZeroLine(gd, ya, xa)) {
	                  y = yOffset + yb + 0;
	                  push("zeroline", ya, xOffset, y, xOffset + xLength, y);
	                }
	              }
	              var gridBatches = [];
	              for (k in lookup) {
	                gridBatches.push(lookup[k]);
	              }
	              return gridBatches;
	            }
	            function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var lookup = {};
	              var i;
	              if (oldFullLayout._splomScenes) {
	                for (i = 0; i < newFullData.length; i++) {
	                  var newTrace = newFullData[i];
	                  if (newTrace.type === "splom") {
	                    lookup[newTrace.uid] = 1;
	                  }
	                }
	                for (i = 0; i < oldFullData.length; i++) {
	                  var oldTrace = oldFullData[i];
	                  if (!lookup[oldTrace.uid]) {
	                    var scene = oldFullLayout._splomScenes[oldTrace.uid];
	                    if (scene && scene.destroy) scene.destroy();
	                    oldFullLayout._splomScenes[oldTrace.uid] = null;
	                    delete oldFullLayout._splomScenes[oldTrace.uid];
	                  }
	                }
	              }
	              if (Object.keys(oldFullLayout._splomScenes || {}).length === 0) {
	                delete oldFullLayout._splomScenes;
	              }
	              if (oldFullLayout._splomGrid && !newFullLayout._hasOnlyLargeSploms && oldFullLayout._hasOnlyLargeSploms) {
	                oldFullLayout._splomGrid.destroy();
	                oldFullLayout._splomGrid = null;
	                delete oldFullLayout._splomGrid;
	              }
	              Cartesian.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
	            }
	            module2.exports = {
	              name: SPLOM,
	              attr: Cartesian.attr,
	              attrRegex: Cartesian.attrRegex,
	              layoutAttributes: Cartesian.layoutAttributes,
	              supplyLayoutDefaults: Cartesian.supplyLayoutDefaults,
	              drawFramework: Cartesian.drawFramework,
	              plot,
	              drag,
	              updateGrid,
	              clean,
	              updateFx: Cartesian.updateFx,
	              toSVG: Cartesian.toSVG,
	              reglPrecompiled
	            };
	          }
	        ),
	        /***/
	        87625: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var AxisIDs = __webpack_require__2(41675);
	            var calcMarkerSize = __webpack_require__2(47761).calcMarkerSize;
	            var calcAxisExpansion = __webpack_require__2(47761).calcAxisExpansion;
	            var calcColorscale = __webpack_require__2(36922);
	            var convertMarkerSelection = __webpack_require__2(19635).markerSelection;
	            var convertMarkerStyle = __webpack_require__2(19635).markerStyle;
	            var sceneUpdate = __webpack_require__2(10164);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var TOO_MANY_POINTS = __webpack_require__2(78232).TOO_MANY_POINTS;
	            module2.exports = function calc(gd, trace) {
	              var dimensions = trace.dimensions;
	              var commonLength = trace._length;
	              var opts = {};
	              var cdata = opts.cdata = [];
	              var ldata = opts.data = [];
	              var visibleDims = trace._visibleDims = [];
	              var i, k, dim, xa, ya;
	              function makeCalcdata(ax, dim2) {
	                var ccol = ax.makeCalcdata({
	                  v: dim2.values,
	                  vcalendar: trace.calendar
	                }, "v");
	                for (var j = 0; j < ccol.length; j++) {
	                  ccol[j] = ccol[j] === BADNUM ? NaN : ccol[j];
	                }
	                cdata.push(ccol);
	                ldata.push(ax.type === "log" ? Lib.simpleMap(ccol, ax.c2l) : ccol);
	              }
	              for (i = 0; i < dimensions.length; i++) {
	                dim = dimensions[i];
	                if (dim.visible) {
	                  xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
	                  ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
	                  if (xa && ya && xa.type !== ya.type) {
	                    Lib.log("Skipping splom dimension " + i + " with conflicting axis types");
	                    continue;
	                  }
	                  if (xa) {
	                    makeCalcdata(xa, dim);
	                    if (ya && ya.type === "category") {
	                      ya._categories = xa._categories.slice();
	                    }
	                  } else {
	                    makeCalcdata(ya, dim);
	                  }
	                  visibleDims.push(i);
	                }
	              }
	              calcColorscale(gd, trace);
	              Lib.extendFlat(opts, convertMarkerStyle(gd, trace));
	              var visibleLength = cdata.length;
	              var hasTooManyPoints = visibleLength * commonLength > TOO_MANY_POINTS;
	              var ppad;
	              if (hasTooManyPoints) {
	                ppad = opts.sizeAvg || Math.max(opts.size, 3);
	              } else {
	                ppad = calcMarkerSize(trace, commonLength);
	              }
	              for (k = 0; k < visibleDims.length; k++) {
	                i = visibleDims[k];
	                dim = dimensions[i];
	                xa = AxisIDs.getFromId(gd, trace._diag[i][0]) || {};
	                ya = AxisIDs.getFromId(gd, trace._diag[i][1]) || {};
	                calcAxisExpansion(gd, trace, xa, ya, cdata[k], cdata[k], ppad);
	              }
	              var scene = sceneUpdate(gd, trace);
	              if (!scene.matrix) scene.matrix = true;
	              scene.matrixOptions = opts;
	              scene.selectedOptions = convertMarkerSelection(gd, trace, trace.selected);
	              scene.unselectedOptions = convertMarkerSelection(gd, trace, trace.unselected);
	              return [{
	                x: false,
	                y: false,
	                t: {},
	                trace
	              }];
	            };
	          }
	        ),
	        /***/
	        25784: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleArrayContainerDefaults = __webpack_require__2(85501);
	            var attributes = __webpack_require__2(46880);
	            var subTypes = __webpack_require__2(34098);
	            var handleMarkerDefaults = __webpack_require__2(49508);
	            var mergeLength = __webpack_require__2(94397);
	            var isOpenSymbol = __webpack_require__2(68645).isOpenSymbol;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
	                name: "dimensions",
	                handleItemDefaults: dimensionDefaults
	              });
	              var showDiag = coerce("diagonal.visible");
	              var showUpper = coerce("showupperhalf");
	              var showLower = coerce("showlowerhalf");
	              var dimLength = mergeLength(traceOut, dimensions, "values");
	              if (!dimLength || !showDiag && !showUpper && !showLower) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {
	                noAngleRef: true,
	                noStandOff: true
	              });
	              var isOpen = isOpenSymbol(traceOut.marker.symbol);
	              var isBubble = subTypes.isBubble(traceOut);
	              coerce("marker.line.width", isOpen || isBubble ? 1 : 0);
	              handleAxisDefaults(traceIn, traceOut, layout, coerce);
	              Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
	            };
	            function dimensionDefaults(dimIn, dimOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(dimIn, dimOut, attributes.dimensions, attr, dflt);
	              }
	              coerce("label");
	              var values = coerce("values");
	              if (!(values && values.length)) dimOut.visible = false;
	              else coerce("visible");
	              coerce("axis.type");
	              coerce("axis.matches");
	            }
	            function handleAxisDefaults(traceIn, traceOut, layout, coerce) {
	              var dimensions = traceOut.dimensions;
	              var dimLength = dimensions.length;
	              var showUpper = traceOut.showupperhalf;
	              var showLower = traceOut.showlowerhalf;
	              var showDiag = traceOut.diagonal.visible;
	              var i, j;
	              var xAxesDflt = new Array(dimLength);
	              var yAxesDflt = new Array(dimLength);
	              for (i = 0; i < dimLength; i++) {
	                var suffix = i ? i + 1 : "";
	                xAxesDflt[i] = "x" + suffix;
	                yAxesDflt[i] = "y" + suffix;
	              }
	              var xaxes = coerce("xaxes", xAxesDflt);
	              var yaxes = coerce("yaxes", yAxesDflt);
	              var diag = traceOut._diag = new Array(dimLength);
	              traceOut._xaxes = {};
	              traceOut._yaxes = {};
	              var xList = [];
	              var yList = [];
	              function fillAxisStashes(axId, counterAxId, dim2, list) {
	                if (!axId) return;
	                var axLetter = axId.charAt(0);
	                var stash = layout._splomAxes[axLetter];
	                traceOut["_" + axLetter + "axes"][axId] = 1;
	                list.push(axId);
	                if (!(axId in stash)) {
	                  var s = stash[axId] = {};
	                  if (dim2) {
	                    s.label = dim2.label || "";
	                    if (dim2.visible && dim2.axis) {
	                      if (dim2.axis.type) s.type = dim2.axis.type;
	                      if (dim2.axis.matches) s.matches = counterAxId;
	                    }
	                  }
	                }
	              }
	              var mustShiftX = !showDiag && !showLower;
	              var mustShiftY = !showDiag && !showUpper;
	              traceOut._axesDim = {};
	              for (i = 0; i < dimLength; i++) {
	                var dim = dimensions[i];
	                var i0 = i === 0;
	                var iN = i === dimLength - 1;
	                var xaId = i0 && mustShiftX || iN && mustShiftY ? undefined : xaxes[i];
	                var yaId = i0 && mustShiftY || iN && mustShiftX ? undefined : yaxes[i];
	                fillAxisStashes(xaId, yaId, dim, xList);
	                fillAxisStashes(yaId, xaId, dim, yList);
	                diag[i] = [xaId, yaId];
	                traceOut._axesDim[xaId] = i;
	                traceOut._axesDim[yaId] = i;
	              }
	              for (i = 0; i < xList.length; i++) {
	                for (j = 0; j < yList.length; j++) {
	                  var id = xList[i] + yList[j];
	                  if (i > j && showUpper) {
	                    layout._splomSubplots[id] = 1;
	                  } else if (i < j && showLower) {
	                    layout._splomSubplots[id] = 1;
	                  } else if (i === j && (showDiag || !showLower || !showUpper)) {
	                    layout._splomSubplots[id] = 1;
	                  }
	                }
	              }
	              if (!showLower || !showDiag && showUpper && showLower) {
	                layout._splomGridDflt.xside = "bottom";
	                layout._splomGridDflt.yside = "left";
	              }
	            }
	          }
	        ),
	        /***/
	        28801: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var calcColorscale = __webpack_require__2(36922);
	            var convertMarkerStyle = __webpack_require__2(19635).markerStyle;
	            module2.exports = function editStyle(gd, cd0) {
	              var trace = cd0.trace;
	              var scene = gd._fullLayout._splomScenes[trace.uid];
	              if (scene) {
	                calcColorscale(gd, trace);
	                Lib.extendFlat(scene.matrixOptions, convertMarkerStyle(gd, trace));
	                var opts = Lib.extendFlat({}, scene.matrixOptions, scene.viewOpts);
	                scene.matrix.update(opts, null);
	              }
	            };
	          }
	        ),
	        /***/
	        35948: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.getDimIndex = function getDimIndex(trace, ax) {
	              var axId = ax._id;
	              var axLetter = axId.charAt(0);
	              var ind = {
	                x: 0,
	                y: 1
	              }[axLetter];
	              var visibleDims = trace._visibleDims;
	              for (var k = 0; k < visibleDims.length; k++) {
	                var i = visibleDims[k];
	                if (trace._diag[i][ind] === axId) return k;
	              }
	              return false;
	            };
	          }
	        ),
	        /***/
	        8567: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var helpers = __webpack_require__2(35948);
	            var calcHover = __webpack_require__2(20794).calcHover;
	            function hoverPoints(pointData, xval, yval) {
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var scene = pointData.scene;
	              var cdata = scene.matrixOptions.cdata;
	              var xa = pointData.xa;
	              var ya = pointData.ya;
	              var xpx = xa.c2p(xval);
	              var ypx = ya.c2p(yval);
	              var maxDistance = pointData.distance;
	              var xi = helpers.getDimIndex(trace, xa);
	              var yi = helpers.getDimIndex(trace, ya);
	              if (xi === false || yi === false) return [pointData];
	              var x = cdata[xi];
	              var y = cdata[yi];
	              var id, dxy;
	              var minDist = maxDistance;
	              for (var i = 0; i < x.length; i++) {
	                var ptx = x[i];
	                var pty = y[i];
	                var dx = xa.c2p(ptx) - xpx;
	                var dy = ya.c2p(pty) - ypx;
	                var dist = Math.sqrt(dx * dx + dy * dy);
	                if (dist < minDist) {
	                  minDist = dxy = dist;
	                  id = i;
	                }
	              }
	              pointData.index = id;
	              pointData.distance = minDist;
	              pointData.dxy = dxy;
	              if (id === undefined) return [pointData];
	              return [calcHover(pointData, x, y, trace)];
	            }
	            module2.exports = {
	              hoverPoints
	            };
	          }
	        ),
	        /***/
	        6419: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var index = __webpack_require__2(65017);
	            index.basePlotModule = __webpack_require__2(16947), module2.exports = index;
	          }
	        ),
	        /***/
	        79410: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createMatrix = __webpack_require__2(60487);
	            var Lib = __webpack_require__2(71828);
	            var AxisIDs = __webpack_require__2(41675);
	            var selectMode = __webpack_require__2(64505).selectMode;
	            module2.exports = function plot(gd, _, splomCalcData) {
	              if (!splomCalcData.length) return;
	              for (var i = 0; i < splomCalcData.length; i++) {
	                plotOne(gd, splomCalcData[i][0]);
	              }
	            };
	            function plotOne(gd, cd0) {
	              var fullLayout = gd._fullLayout;
	              var gs = fullLayout._size;
	              var trace = cd0.trace;
	              var stash = cd0.t;
	              var scene = fullLayout._splomScenes[trace.uid];
	              var matrixOpts = scene.matrixOptions;
	              var cdata = matrixOpts.cdata;
	              var regl = fullLayout._glcanvas.data()[0].regl;
	              var dragmode = fullLayout.dragmode;
	              var xa, ya;
	              var i, j, k;
	              if (cdata.length === 0) return;
	              matrixOpts.lower = trace.showupperhalf;
	              matrixOpts.upper = trace.showlowerhalf;
	              matrixOpts.diagonal = trace.diagonal.visible;
	              var visibleDims = trace._visibleDims;
	              var visibleLength = cdata.length;
	              var viewOpts = scene.viewOpts = {};
	              viewOpts.ranges = new Array(visibleLength);
	              viewOpts.domains = new Array(visibleLength);
	              for (k = 0; k < visibleDims.length; k++) {
	                i = visibleDims[k];
	                var rng = viewOpts.ranges[k] = new Array(4);
	                var dmn = viewOpts.domains[k] = new Array(4);
	                xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
	                if (xa) {
	                  rng[0] = xa._rl[0];
	                  rng[2] = xa._rl[1];
	                  dmn[0] = xa.domain[0];
	                  dmn[2] = xa.domain[1];
	                }
	                ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
	                if (ya) {
	                  rng[1] = ya._rl[0];
	                  rng[3] = ya._rl[1];
	                  dmn[1] = ya.domain[0];
	                  dmn[3] = ya.domain[1];
	                }
	              }
	              var plotGlPixelRatio = gd._context.plotGlPixelRatio;
	              var l = gs.l * plotGlPixelRatio;
	              var b = gs.b * plotGlPixelRatio;
	              var w = gs.w * plotGlPixelRatio;
	              var h = gs.h * plotGlPixelRatio;
	              viewOpts.viewport = [l, b, w + l, h + b];
	              if (scene.matrix === true) {
	                scene.matrix = createMatrix(regl);
	              }
	              var clickSelectEnabled = fullLayout.clickmode.indexOf("select") > -1;
	              var isSelectMode = selectMode(dragmode) || !!trace.selectedpoints || clickSelectEnabled;
	              var needsBaseUpdate = true;
	              if (isSelectMode) {
	                var commonLength = trace._length;
	                if (trace.selectedpoints) {
	                  scene.selectBatch = trace.selectedpoints;
	                  var selPts = trace.selectedpoints;
	                  var selDict = {};
	                  for (i = 0; i < selPts.length; i++) {
	                    selDict[selPts[i]] = true;
	                  }
	                  var unselPts = [];
	                  for (i = 0; i < commonLength; i++) {
	                    if (!selDict[i]) unselPts.push(i);
	                  }
	                  scene.unselectBatch = unselPts;
	                }
	                var xpx = stash.xpx = new Array(visibleLength);
	                var ypx = stash.ypx = new Array(visibleLength);
	                for (k = 0; k < visibleDims.length; k++) {
	                  i = visibleDims[k];
	                  xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
	                  if (xa) {
	                    xpx[k] = new Array(commonLength);
	                    for (j = 0; j < commonLength; j++) {
	                      xpx[k][j] = xa.c2p(cdata[k][j]);
	                    }
	                  }
	                  ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
	                  if (ya) {
	                    ypx[k] = new Array(commonLength);
	                    for (j = 0; j < commonLength; j++) {
	                      ypx[k][j] = ya.c2p(cdata[k][j]);
	                    }
	                  }
	                }
	                if (scene.selectBatch.length || scene.unselectBatch.length) {
	                  var unselOpts = Lib.extendFlat({}, matrixOpts, scene.unselectedOptions, viewOpts);
	                  var selOpts = Lib.extendFlat({}, matrixOpts, scene.selectedOptions, viewOpts);
	                  scene.matrix.update(unselOpts, selOpts);
	                  needsBaseUpdate = false;
	                }
	              } else {
	                stash.xpx = stash.ypx = null;
	              }
	              if (needsBaseUpdate) {
	                var opts = Lib.extendFlat({}, matrixOpts, viewOpts);
	                scene.matrix.update(opts, null);
	              }
	            }
	          }
	        ),
	        /***/
	        10164: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            module2.exports = function sceneUpdate(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var uid = trace.uid;
	              var splomScenes = fullLayout._splomScenes;
	              if (!splomScenes) splomScenes = fullLayout._splomScenes = {};
	              var reset = {
	                dirty: true,
	                selectBatch: [],
	                unselectBatch: []
	              };
	              var first = {
	                matrix: false,
	                selectBatch: [],
	                unselectBatch: []
	              };
	              var scene = splomScenes[trace.uid];
	              if (!scene) {
	                scene = splomScenes[uid] = Lib.extendFlat({}, reset, first);
	                scene.draw = function draw() {
	                  if (scene.matrix && scene.matrix.draw) {
	                    if (scene.selectBatch.length || scene.unselectBatch.length) {
	                      scene.matrix.draw(scene.unselectBatch, scene.selectBatch);
	                    } else {
	                      scene.matrix.draw();
	                    }
	                  }
	                  scene.dirty = false;
	                };
	                scene.destroy = function destroy() {
	                  if (scene.matrix && scene.matrix.destroy) {
	                    scene.matrix.destroy();
	                  }
	                  scene.matrixOptions = null;
	                  scene.selectBatch = null;
	                  scene.unselectBatch = null;
	                  scene = null;
	                };
	              }
	              if (!scene.dirty) {
	                Lib.extendFlat(scene, reset);
	              }
	              return scene;
	            };
	          }
	        ),
	        /***/
	        8689: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var pushUnique = Lib.pushUnique;
	            var subTypes = __webpack_require__2(34098);
	            var helpers = __webpack_require__2(35948);
	            module2.exports = function select(searchInfo, selectionTester) {
	              var cd = searchInfo.cd;
	              var trace = cd[0].trace;
	              var stash = cd[0].t;
	              var scene = searchInfo.scene;
	              var cdata = scene.matrixOptions.cdata;
	              var xa = searchInfo.xaxis;
	              var ya = searchInfo.yaxis;
	              var selection = [];
	              if (!scene) return selection;
	              var hasOnlyLines = !subTypes.hasMarkers(trace) && !subTypes.hasText(trace);
	              if (trace.visible !== true || hasOnlyLines) return selection;
	              var xi = helpers.getDimIndex(trace, xa);
	              var yi = helpers.getDimIndex(trace, ya);
	              if (xi === false || yi === false) return selection;
	              var xpx = stash.xpx[xi];
	              var ypx = stash.ypx[yi];
	              var x = cdata[xi];
	              var y = cdata[yi];
	              var els = (searchInfo.scene.selectBatch || []).slice();
	              var unels = [];
	              if (selectionTester !== false && !selectionTester.degenerate) {
	                for (var i = 0; i < x.length; i++) {
	                  if (selectionTester.contains([xpx[i], ypx[i]], null, i, searchInfo)) {
	                    selection.push({
	                      pointNumber: i,
	                      x: x[i],
	                      y: y[i]
	                    });
	                    pushUnique(els, i);
	                  } else if (els.indexOf(i) !== -1) {
	                    pushUnique(els, i);
	                  } else {
	                    unels.push(i);
	                  }
	                }
	              }
	              var matrixOpts = scene.matrixOptions;
	              if (!els.length && !unels.length) {
	                scene.matrix.update(matrixOpts, null);
	              } else if (!scene.selectBatch.length && !scene.unselectBatch.length) {
	                scene.matrix.update(scene.unselectedOptions, Lib.extendFlat({}, matrixOpts, scene.selectedOptions, scene.viewOpts));
	              }
	              scene.selectBatch = els;
	              scene.unselectBatch = unels;
	              return selection;
	            };
	          }
	        ),
	        /***/
	        21850: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var mesh3dAttrs = __webpack_require__2(2418);
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var attrs = {
	              x: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              y: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              z: {
	                valType: "data_array",
	                editType: "calc+clearAxisTypes"
	              },
	              u: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              v: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              w: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              starts: {
	                x: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                y: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                z: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              maxdisplayed: {
	                valType: "integer",
	                min: 0,
	                dflt: 1e3,
	                editType: "calc"
	              },
	              // TODO
	              //
	              // Should add 'absolute' (like cone traces have), but currently gl-streamtube3d's
	              // `absoluteTubeSize` doesn't behave well enough for our needs.
	              //
	              // 'fixed' would be a nice addition to plot stream 'lines', see
	              // https://github.com/plotly/plotly.js/commit/812be20750e21e0a1831975001c248d365850f73#r29129877
	              //
	              // sizemode: {
	              //     valType: 'enumerated',
	              //     values: ['scaled', 'absolute', 'fixed'],
	              //     dflt: 'scaled',
	              //     editType: 'calc',
	              //
	              // },
	              sizeref: {
	                valType: "number",
	                editType: "calc",
	                min: 0,
	                dflt: 1
	              },
	              text: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              hovertemplate: hovertemplateAttrs({
	                editType: "calc"
	              }, {
	                keys: ["tubex", "tubey", "tubez", "tubeu", "tubev", "tubew", "norm", "divergence"]
	              }),
	              uhoverformat: axisHoverFormat("u", 1),
	              vhoverformat: axisHoverFormat("v", 1),
	              whoverformat: axisHoverFormat("w", 1),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z"),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            };
	            extendFlat(attrs, colorScaleAttrs("", {
	              colorAttr: "u/v/w norm",
	              showScaleDflt: true,
	              editTypeOverride: "calc"
	            }));
	            var fromMesh3d = ["opacity", "lightposition", "lighting"];
	            fromMesh3d.forEach(function(k) {
	              attrs[k] = mesh3dAttrs[k];
	            });
	            attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
	              editType: "calc",
	              flags: ["x", "y", "z", "u", "v", "w", "norm", "divergence", "text", "name"],
	              dflt: "x+y+z+norm+text+name"
	            });
	            attrs.transforms = undefined;
	            module2.exports = attrs;
	          }
	        ),
	        /***/
	        88489: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var colorscaleCalc = __webpack_require__2(78803);
	            function calc(gd, trace) {
	              trace._len = Math.min(trace.u.length, trace.v.length, trace.w.length, trace.x.length, trace.y.length, trace.z.length);
	              trace._u = filter(trace.u, trace._len);
	              trace._v = filter(trace.v, trace._len);
	              trace._w = filter(trace.w, trace._len);
	              trace._x = filter(trace.x, trace._len);
	              trace._y = filter(trace.y, trace._len);
	              trace._z = filter(trace.z, trace._len);
	              var grid = processGrid(trace);
	              trace._gridFill = grid.fill;
	              trace._Xs = grid.Xs;
	              trace._Ys = grid.Ys;
	              trace._Zs = grid.Zs;
	              trace._len = grid.len;
	              var slen = 0;
	              var startx, starty, startz;
	              if (trace.starts) {
	                startx = filter(trace.starts.x || []);
	                starty = filter(trace.starts.y || []);
	                startz = filter(trace.starts.z || []);
	                slen = Math.min(startx.length, starty.length, startz.length);
	              }
	              trace._startsX = startx || [];
	              trace._startsY = starty || [];
	              trace._startsZ = startz || [];
	              var normMax = 0;
	              var normMin = Infinity;
	              var i;
	              for (i = 0; i < trace._len; i++) {
	                var u = trace._u[i];
	                var v = trace._v[i];
	                var w = trace._w[i];
	                var norm = Math.sqrt(u * u + v * v + w * w);
	                normMax = Math.max(normMax, norm);
	                normMin = Math.min(normMin, norm);
	              }
	              colorscaleCalc(gd, trace, {
	                vals: [normMin, normMax],
	                containerStr: "",
	                cLetter: "c"
	              });
	              for (i = 0; i < slen; i++) {
	                var sx = startx[i];
	                grid.xMax = Math.max(grid.xMax, sx);
	                grid.xMin = Math.min(grid.xMin, sx);
	                var sy = starty[i];
	                grid.yMax = Math.max(grid.yMax, sy);
	                grid.yMin = Math.min(grid.yMin, sy);
	                var sz = startz[i];
	                grid.zMax = Math.max(grid.zMax, sz);
	                grid.zMin = Math.min(grid.zMin, sz);
	              }
	              trace._slen = slen;
	              trace._normMax = normMax;
	              trace._xbnds = [grid.xMin, grid.xMax];
	              trace._ybnds = [grid.yMin, grid.yMax];
	              trace._zbnds = [grid.zMin, grid.zMax];
	            }
	            function processGrid(trace) {
	              var x = trace._x;
	              var y = trace._y;
	              var z = trace._z;
	              var len = trace._len;
	              var i, j, k;
	              var xMax = -Infinity;
	              var xMin = Infinity;
	              var yMax = -Infinity;
	              var yMin = Infinity;
	              var zMax = -Infinity;
	              var zMin = Infinity;
	              var gridFill = "";
	              var filledX;
	              var filledY;
	              var filledZ;
	              var firstX, lastX;
	              var firstY, lastY;
	              var firstZ, lastZ;
	              if (len) {
	                firstX = x[0];
	                firstY = y[0];
	                firstZ = z[0];
	              }
	              if (len > 1) {
	                lastX = x[len - 1];
	                lastY = y[len - 1];
	                lastZ = z[len - 1];
	              }
	              for (i = 0; i < len; i++) {
	                xMax = Math.max(xMax, x[i]);
	                xMin = Math.min(xMin, x[i]);
	                yMax = Math.max(yMax, y[i]);
	                yMin = Math.min(yMin, y[i]);
	                zMax = Math.max(zMax, z[i]);
	                zMin = Math.min(zMin, z[i]);
	                if (!filledX && x[i] !== firstX) {
	                  filledX = true;
	                  gridFill += "x";
	                }
	                if (!filledY && y[i] !== firstY) {
	                  filledY = true;
	                  gridFill += "y";
	                }
	                if (!filledZ && z[i] !== firstZ) {
	                  filledZ = true;
	                  gridFill += "z";
	                }
	              }
	              if (!filledX) gridFill += "x";
	              if (!filledY) gridFill += "y";
	              if (!filledZ) gridFill += "z";
	              var Xs = distinctVals(trace._x);
	              var Ys = distinctVals(trace._y);
	              var Zs = distinctVals(trace._z);
	              gridFill = gridFill.replace("x", (firstX > lastX ? "-" : "+") + "x");
	              gridFill = gridFill.replace("y", (firstY > lastY ? "-" : "+") + "y");
	              gridFill = gridFill.replace("z", (firstZ > lastZ ? "-" : "+") + "z");
	              var empty = function() {
	                len = 0;
	                Xs = [];
	                Ys = [];
	                Zs = [];
	              };
	              if (!len || len < Xs.length * Ys.length * Zs.length) empty();
	              var getArray = function(c) {
	                return c === "x" ? x : c === "y" ? y : z;
	              };
	              var getVals = function(c) {
	                return c === "x" ? Xs : c === "y" ? Ys : Zs;
	              };
	              var getDir = function(c) {
	                return c[len - 1] < c[0] ? -1 : 1;
	              };
	              var arrK = getArray(gridFill[1]);
	              var arrJ = getArray(gridFill[3]);
	              var arrI = getArray(gridFill[5]);
	              var nk = getVals(gridFill[1]).length;
	              var nj = getVals(gridFill[3]).length;
	              var ni = getVals(gridFill[5]).length;
	              var arbitrary = false;
	              var getIndex = function(_i, _j, _k) {
	                return nk * (nj * _i + _j) + _k;
	              };
	              var dirK = getDir(getArray(gridFill[1]));
	              var dirJ = getDir(getArray(gridFill[3]));
	              var dirI = getDir(getArray(gridFill[5]));
	              for (i = 0; i < ni - 1; i++) {
	                for (j = 0; j < nj - 1; j++) {
	                  for (k = 0; k < nk - 1; k++) {
	                    var q000 = getIndex(i, j, k);
	                    var q001 = getIndex(i, j, k + 1);
	                    var q010 = getIndex(i, j + 1, k);
	                    var q100 = getIndex(i + 1, j, k);
	                    if (!(arrK[q000] * dirK < arrK[q001] * dirK) || !(arrJ[q000] * dirJ < arrJ[q010] * dirJ) || !(arrI[q000] * dirI < arrI[q100] * dirI)) {
	                      arbitrary = true;
	                    }
	                    if (arbitrary) break;
	                  }
	                  if (arbitrary) break;
	                }
	                if (arbitrary) break;
	              }
	              if (arbitrary) {
	                Lib.warn("Encountered arbitrary coordinates! Unable to input data grid.");
	                empty();
	              }
	              return {
	                xMin,
	                yMin,
	                zMin,
	                xMax,
	                yMax,
	                zMax,
	                Xs,
	                Ys,
	                Zs,
	                len,
	                fill: gridFill
	              };
	            }
	            function distinctVals(col) {
	              return Lib.distinctVals(col).vals;
	            }
	            function filter(arr, len) {
	              if (len === undefined) len = arr.length;
	              if (Lib.isTypedArray(arr)) return arr.subarray(0, len);
	              var values = [];
	              for (var i = 0; i < len; i++) {
	                values[i] = +arr[i];
	              }
	              return values;
	            }
	            module2.exports = {
	              calc,
	              filter,
	              processGrid
	            };
	          }
	        ),
	        /***/
	        90154: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var tube2mesh = __webpack_require__2(9330).gl_streamtube3d;
	            var createTubeMesh = tube2mesh.createTubeMesh;
	            var Lib = __webpack_require__2(71828);
	            var parseColorScale = __webpack_require__2(81697).parseColorScale;
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            var zip3 = __webpack_require__2(90060);
	            var axisName2scaleIndex = {
	              xaxis: 0,
	              yaxis: 1,
	              zaxis: 2
	            };
	            function Streamtube(scene, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.mesh = null;
	              this.data = null;
	            }
	            var proto = Streamtube.prototype;
	            proto.handlePick = function(selection) {
	              var sceneLayout = this.scene.fullSceneLayout;
	              var dataScale = this.scene.dataScale;
	              function fromDataScale(v, axisName) {
	                var ax = sceneLayout[axisName];
	                var scale = dataScale[axisName2scaleIndex[axisName]];
	                return ax.l2c(v) / scale;
	              }
	              if (selection.object === this.mesh) {
	                var pos = selection.data.position;
	                var uvx = selection.data.velocity;
	                selection.traceCoordinate = [
	                  fromDataScale(pos[0], "xaxis"),
	                  fromDataScale(pos[1], "yaxis"),
	                  fromDataScale(pos[2], "zaxis"),
	                  fromDataScale(uvx[0], "xaxis"),
	                  fromDataScale(uvx[1], "yaxis"),
	                  fromDataScale(uvx[2], "zaxis"),
	                  // u/v/w norm
	                  selection.data.intensity * this.data._normMax,
	                  // divergence
	                  selection.data.divergence
	                ];
	                selection.textLabel = this.data.hovertext || this.data.text;
	                return true;
	              }
	            };
	            function getDfltStartingPositions(vec) {
	              var len = vec.length;
	              var s;
	              if (len > 2) {
	                s = vec.slice(1, len - 1);
	              } else if (len === 2) {
	                s = [(vec[0] + vec[1]) / 2];
	              } else {
	                s = vec;
	              }
	              return s;
	            }
	            function getBoundPads(vec) {
	              var len = vec.length;
	              if (len === 1) {
	                return [0.5, 0.5];
	              } else {
	                return [vec[1] - vec[0], vec[len - 1] - vec[len - 2]];
	              }
	            }
	            function convert(scene, trace) {
	              var sceneLayout = scene.fullSceneLayout;
	              var dataScale = scene.dataScale;
	              var len = trace._len;
	              var tubeOpts = {};
	              function toDataCoords(arr, axisName) {
	                var ax = sceneLayout[axisName];
	                var scale = dataScale[axisName2scaleIndex[axisName]];
	                return Lib.simpleMap(arr, function(v) {
	                  return ax.d2l(v) * scale;
	                });
	              }
	              tubeOpts.vectors = zip3(toDataCoords(trace._u, "xaxis"), toDataCoords(trace._v, "yaxis"), toDataCoords(trace._w, "zaxis"), len);
	              if (!len) {
	                return {
	                  positions: [],
	                  cells: []
	                };
	              }
	              var meshx = toDataCoords(trace._Xs, "xaxis");
	              var meshy = toDataCoords(trace._Ys, "yaxis");
	              var meshz = toDataCoords(trace._Zs, "zaxis");
	              tubeOpts.meshgrid = [meshx, meshy, meshz];
	              tubeOpts.gridFill = trace._gridFill;
	              var slen = trace._slen;
	              if (slen) {
	                tubeOpts.startingPositions = zip3(toDataCoords(trace._startsX, "xaxis"), toDataCoords(trace._startsY, "yaxis"), toDataCoords(trace._startsZ, "zaxis"));
	              } else {
	                var sy0 = meshy[0];
	                var sx = getDfltStartingPositions(meshx);
	                var sz = getDfltStartingPositions(meshz);
	                var startingPositions = new Array(sx.length * sz.length);
	                var m = 0;
	                for (var i = 0; i < sx.length; i++) {
	                  for (var k = 0; k < sz.length; k++) {
	                    startingPositions[m++] = [sx[i], sy0, sz[k]];
	                  }
	                }
	                tubeOpts.startingPositions = startingPositions;
	              }
	              tubeOpts.colormap = parseColorScale(trace);
	              tubeOpts.tubeSize = trace.sizeref;
	              tubeOpts.maxLength = trace.maxdisplayed;
	              var xbnds = toDataCoords(trace._xbnds, "xaxis");
	              var ybnds = toDataCoords(trace._ybnds, "yaxis");
	              var zbnds = toDataCoords(trace._zbnds, "zaxis");
	              var xpads = getBoundPads(meshx);
	              var ypads = getBoundPads(meshy);
	              var zpads = getBoundPads(meshz);
	              var bounds = [[xbnds[0] - xpads[0], ybnds[0] - ypads[0], zbnds[0] - zpads[0]], [xbnds[1] + xpads[1], ybnds[1] + ypads[1], zbnds[1] + zpads[1]]];
	              var meshData = tube2mesh(tubeOpts, bounds);
	              var cOpts = extractOpts(trace);
	              meshData.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
	              var lp = trace.lightposition;
	              meshData.lightPosition = [lp.x, lp.y, lp.z];
	              meshData.ambient = trace.lighting.ambient;
	              meshData.diffuse = trace.lighting.diffuse;
	              meshData.specular = trace.lighting.specular;
	              meshData.roughness = trace.lighting.roughness;
	              meshData.fresnel = trace.lighting.fresnel;
	              meshData.opacity = trace.opacity;
	              trace._pad = meshData.tubeScale * trace.sizeref * 2;
	              return meshData;
	            }
	            proto.update = function(data) {
	              this.data = data;
	              var meshData = convert(this.scene, data);
	              this.mesh.update(meshData);
	            };
	            proto.dispose = function() {
	              this.scene.glplot.remove(this.mesh);
	              this.mesh.dispose();
	            };
	            function createStreamtubeTrace(scene, data) {
	              var gl2 = scene.glplot.gl;
	              var meshData = convert(scene, data);
	              var mesh = createTubeMesh(gl2, meshData);
	              var streamtube = new Streamtube(scene, data.uid);
	              streamtube.mesh = mesh;
	              streamtube.data = data;
	              mesh._trace = streamtube;
	              scene.glplot.add(mesh);
	              return streamtube;
	            }
	            module2.exports = createStreamtubeTrace;
	          }
	        ),
	        /***/
	        22459: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(21850);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var u = coerce("u");
	              var v = coerce("v");
	              var w = coerce("w");
	              var x = coerce("x");
	              var y = coerce("y");
	              var z = coerce("z");
	              if (!u || !u.length || !v || !v.length || !w || !w.length || !x || !x.length || !y || !y.length || !z || !z.length) {
	                traceOut.visible = false;
	                return;
	              }
	              coerce("starts.x");
	              coerce("starts.y");
	              coerce("starts.z");
	              coerce("maxdisplayed");
	              coerce("sizeref");
	              coerce("lighting.ambient");
	              coerce("lighting.diffuse");
	              coerce("lighting.specular");
	              coerce("lighting.roughness");
	              coerce("lighting.fresnel");
	              coerce("lightposition.x");
	              coerce("lightposition.y");
	              coerce("lightposition.z");
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "c"
	              });
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("uhoverformat");
	              coerce("vhoverformat");
	              coerce("whoverformat");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("zhoverformat");
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        61510: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "streamtube",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "showLegend"],
	              attributes: __webpack_require__2(21850),
	              supplyDefaults: __webpack_require__2(22459),
	              colorbar: {
	                min: "cmin",
	                max: "cmax"
	              },
	              calc: __webpack_require__2(88489).calc,
	              plot: __webpack_require__2(90154),
	              eventData: function(out, pt) {
	                out.tubex = out.x;
	                out.tubey = out.y;
	                out.tubez = out.z;
	                out.tubeu = pt.traceCoordinate[3];
	                out.tubev = pt.traceCoordinate[4];
	                out.tubew = pt.traceCoordinate[5];
	                out.norm = pt.traceCoordinate[6];
	                out.divergence = pt.traceCoordinate[7];
	                delete out.x;
	                delete out.y;
	                delete out.z;
	                return out;
	              },
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        57564: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var baseAttrs = __webpack_require__2(9012);
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var pieAttrs = __webpack_require__2(34e3);
	            var constants = __webpack_require__2(7055);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var pattern = __webpack_require__2(79952).u;
	            module2.exports = {
	              labels: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              parents: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              values: {
	                valType: "data_array",
	                editType: "calc"
	              },
	              branchvalues: {
	                valType: "enumerated",
	                values: ["remainder", "total"],
	                dflt: "remainder",
	                editType: "calc"
	              },
	              count: {
	                valType: "flaglist",
	                flags: ["branches", "leaves"],
	                dflt: "leaves",
	                editType: "calc"
	              },
	              level: {
	                valType: "any",
	                editType: "plot",
	                anim: true
	              },
	              maxdepth: {
	                valType: "integer",
	                editType: "plot",
	                dflt: -1
	              },
	              marker: extendFlat({
	                colors: {
	                  valType: "data_array",
	                  editType: "calc"
	                },
	                // colorinheritance: {
	                //     valType: 'enumerated',
	                //     values: ['per-branch', 'per-label', false]
	                // },
	                line: {
	                  color: extendFlat({}, pieAttrs.marker.line.color, {
	                    dflt: null
	                  }),
	                  width: extendFlat({}, pieAttrs.marker.line.width, {
	                    dflt: 1
	                  }),
	                  editType: "calc"
	                },
	                pattern,
	                editType: "calc"
	              }, colorScaleAttrs("marker", {
	                colorAttr: "colors",
	                anim: false
	                // TODO: set to anim: true?
	              })),
	              leaf: {
	                opacity: {
	                  valType: "number",
	                  editType: "style",
	                  min: 0,
	                  max: 1
	                },
	                editType: "plot"
	              },
	              text: pieAttrs.text,
	              textinfo: {
	                valType: "flaglist",
	                flags: ["label", "text", "value", "current path", "percent root", "percent entry", "percent parent"],
	                extras: ["none"],
	                editType: "plot"
	              },
	              // TODO: incorporate `label` and `value` in the eventData
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: constants.eventDataKeys.concat(["label", "value"])
	              }),
	              hovertext: pieAttrs.hovertext,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["label", "text", "value", "name", "current path", "percent root", "percent entry", "percent parent"],
	                dflt: "label+text+value+name"
	              }),
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              textfont: pieAttrs.textfont,
	              insidetextorientation: pieAttrs.insidetextorientation,
	              insidetextfont: pieAttrs.insidetextfont,
	              outsidetextfont: extendFlat({}, pieAttrs.outsidetextfont, {}),
	              rotation: {
	                valType: "angle",
	                dflt: 0,
	                editType: "plot"
	              },
	              sort: pieAttrs.sort,
	              root: {
	                color: {
	                  valType: "color",
	                  editType: "calc",
	                  dflt: "rgba(0,0,0,0)"
	                },
	                editType: "calc"
	              },
	              domain: domainAttrs({
	                name: "sunburst",
	                trace: true,
	                editType: "calc"
	              })
	            };
	          }
	        ),
	        /***/
	        66888: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var plots = __webpack_require__2(74875);
	            exports2.name = "sunburst";
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              plots.plotBasePlot(exports2.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              plots.cleanBasePlot(exports2.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	            };
	          }
	        ),
	        /***/
	        52147: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3Hierarchy = __webpack_require__2(674);
	            var isNumeric = __webpack_require__2(92770);
	            var Lib = __webpack_require__2(71828);
	            var makeColorScaleFn = __webpack_require__2(21081).makeColorScaleFuncFromTrace;
	            var makePullColorFn = __webpack_require__2(32354).makePullColorFn;
	            var generateExtendedColors = __webpack_require__2(32354).generateExtendedColors;
	            var colorscaleCalc = __webpack_require__2(21081).calc;
	            var ALMOST_EQUAL = __webpack_require__2(50606).ALMOST_EQUAL;
	            var sunburstExtendedColorWays = {};
	            var treemapExtendedColorWays = {};
	            var icicleExtendedColorWays = {};
	            exports2.calc = function(gd, trace) {
	              var fullLayout = gd._fullLayout;
	              var ids = trace.ids;
	              var hasIds = Lib.isArrayOrTypedArray(ids);
	              var labels = trace.labels;
	              var parents = trace.parents;
	              var values = trace.values;
	              var hasValues = Lib.isArrayOrTypedArray(values);
	              var cd = [];
	              var parent2children = {};
	              var refs = {};
	              var addToLookup = function(parent, v) {
	                if (parent2children[parent]) parent2children[parent].push(v);
	                else parent2children[parent] = [v];
	                refs[v] = 1;
	              };
	              var isValidKey = function(k2) {
	                return k2 || typeof k2 === "number";
	              };
	              var isValidVal = function(i2) {
	                return !hasValues || isNumeric(values[i2]) && values[i2] >= 0;
	              };
	              var len;
	              var isValid;
	              var getId;
	              if (hasIds) {
	                len = Math.min(ids.length, parents.length);
	                isValid = function(i2) {
	                  return isValidKey(ids[i2]) && isValidVal(i2);
	                };
	                getId = function(i2) {
	                  return String(ids[i2]);
	                };
	              } else {
	                len = Math.min(labels.length, parents.length);
	                isValid = function(i2) {
	                  return isValidKey(labels[i2]) && isValidVal(i2);
	                };
	                getId = function(i2) {
	                  return String(labels[i2]);
	                };
	              }
	              if (hasValues) len = Math.min(len, values.length);
	              for (var i = 0; i < len; i++) {
	                if (isValid(i)) {
	                  var id = getId(i);
	                  var pid = isValidKey(parents[i]) ? String(parents[i]) : "";
	                  var cdi = {
	                    i,
	                    id,
	                    pid,
	                    label: isValidKey(labels[i]) ? String(labels[i]) : ""
	                  };
	                  if (hasValues) cdi.v = +values[i];
	                  cd.push(cdi);
	                  addToLookup(pid, id);
	                }
	              }
	              if (!parent2children[""]) {
	                var impliedRoots = [];
	                var k;
	                for (k in parent2children) {
	                  if (!refs[k]) {
	                    impliedRoots.push(k);
	                  }
	                }
	                if (impliedRoots.length === 1) {
	                  k = impliedRoots[0];
	                  cd.unshift({
	                    hasImpliedRoot: true,
	                    id: k,
	                    pid: "",
	                    label: k
	                  });
	                } else {
	                  return Lib.warn(["Multiple implied roots, cannot build", trace.type, "hierarchy of", trace.name + ".", "These roots include:", impliedRoots.join(", ")].join(" "));
	                }
	              } else if (parent2children[""].length > 1) {
	                var dummyId = Lib.randstr();
	                for (var j = 0; j < cd.length; j++) {
	                  if (cd[j].pid === "") {
	                    cd[j].pid = dummyId;
	                  }
	                }
	                cd.unshift({
	                  hasMultipleRoots: true,
	                  id: dummyId,
	                  pid: "",
	                  label: ""
	                });
	              }
	              var root;
	              try {
	                root = d3Hierarchy.stratify().id(function(d) {
	                  return d.id;
	                }).parentId(function(d) {
	                  return d.pid;
	                })(cd);
	              } catch (e) {
	                return Lib.warn(["Failed to build", trace.type, "hierarchy of", trace.name + ".", "Error:", e.message].join(" "));
	              }
	              var hierarchy = d3Hierarchy.hierarchy(root);
	              var failed = false;
	              if (hasValues) {
	                switch (trace.branchvalues) {
	                  case "remainder":
	                    hierarchy.sum(function(d) {
	                      return d.data.v;
	                    });
	                    break;
	                  case "total":
	                    hierarchy.each(function(d) {
	                      var cdi2 = d.data.data;
	                      var v = cdi2.v;
	                      if (d.children) {
	                        var partialSum = d.children.reduce(function(a, c) {
	                          return a + c.data.data.v;
	                        }, 0);
	                        if (cdi2.hasImpliedRoot || cdi2.hasMultipleRoots) {
	                          v = partialSum;
	                        }
	                        if (v < partialSum * ALMOST_EQUAL) {
	                          failed = true;
	                          return Lib.warn(["Total value for node", d.data.data.id, "of", trace.name, "is smaller than the sum of its children.", "\nparent value =", v, "\nchildren sum =", partialSum].join(" "));
	                        }
	                      }
	                      d.value = v;
	                    });
	                    break;
	                }
	              } else {
	                countDescendants(hierarchy, trace, {
	                  branches: trace.count.indexOf("branches") !== -1,
	                  leaves: trace.count.indexOf("leaves") !== -1
	                });
	              }
	              if (failed) return;
	              if (trace.sort) {
	                hierarchy.sort(function(a, b) {
	                  return b.value - a.value;
	                });
	              }
	              var pullColor;
	              var scaleColor;
	              var colors = trace.marker.colors || [];
	              var hasColors = !!colors.length;
	              if (trace._hasColorscale) {
	                if (!hasColors) {
	                  colors = hasValues ? trace.values : trace._values;
	                }
	                colorscaleCalc(gd, trace, {
	                  vals: colors,
	                  containerStr: "marker",
	                  cLetter: "c"
	                });
	                scaleColor = makeColorScaleFn(trace.marker);
	              } else {
	                pullColor = makePullColorFn(fullLayout["_" + trace.type + "colormap"]);
	              }
	              hierarchy.each(function(d) {
	                var cdi2 = d.data.data;
	                cdi2.color = trace._hasColorscale ? scaleColor(colors[cdi2.i]) : pullColor(colors[cdi2.i], cdi2.id);
	              });
	              cd[0].hierarchy = hierarchy;
	              return cd;
	            };
	            exports2._runCrossTraceCalc = function(desiredType, gd) {
	              var fullLayout = gd._fullLayout;
	              var calcdata = gd.calcdata;
	              var colorWay = fullLayout[desiredType + "colorway"];
	              var colorMap = fullLayout["_" + desiredType + "colormap"];
	              if (fullLayout["extend" + desiredType + "colors"]) {
	                colorWay = generateExtendedColors(colorWay, desiredType === "icicle" ? icicleExtendedColorWays : desiredType === "treemap" ? treemapExtendedColorWays : sunburstExtendedColorWays);
	              }
	              var dfltColorCount = 0;
	              var rootColor;
	              function pickColor(d) {
	                var cdi = d.data.data;
	                var id = cdi.id;
	                if (cdi.color === false) {
	                  if (colorMap[id]) {
	                    cdi.color = colorMap[id];
	                  } else if (d.parent) {
	                    if (d.parent.parent) {
	                      cdi.color = d.parent.data.data.color;
	                    } else {
	                      colorMap[id] = cdi.color = colorWay[dfltColorCount % colorWay.length];
	                      dfltColorCount++;
	                    }
	                  } else {
	                    cdi.color = rootColor;
	                  }
	                }
	              }
	              for (var i = 0; i < calcdata.length; i++) {
	                var cd = calcdata[i];
	                var cd0 = cd[0];
	                if (cd0.trace.type === desiredType && cd0.hierarchy) {
	                  rootColor = cd0.trace.root.color;
	                  cd0.hierarchy.each(pickColor);
	                }
	              }
	            };
	            exports2.crossTraceCalc = function(gd) {
	              return exports2._runCrossTraceCalc("sunburst", gd);
	            };
	            function countDescendants(node, trace, opts) {
	              var nChild = 0;
	              var children = node.children;
	              if (children) {
	                var len = children.length;
	                for (var i = 0; i < len; i++) {
	                  nChild += countDescendants(children[i], trace, opts);
	                }
	                if (opts.branches) nChild++;
	              } else {
	                if (opts.leaves) nChild++;
	              }
	              node.value = node.data.data.value = nChild;
	              if (!trace._values) trace._values = [];
	              trace._values[node.data.data.i] = nChild;
	              return nChild;
	            }
	          }
	        ),
	        /***/
	        7055: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              CLICK_TRANSITION_TIME: 750,
	              CLICK_TRANSITION_EASING: "linear",
	              eventDataKeys: [
	                // string
	                "currentPath",
	                "root",
	                "entry",
	                // no need to add 'parent' here
	                // percentages i.e. ratios
	                "percentRoot",
	                "percentEntry",
	                "percentParent"
	              ]
	            };
	          }
	        ),
	        /***/
	        17094: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(57564);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleText = __webpack_require__2(90769).handleText;
	            var handleMarkerDefaults = __webpack_require__2(37434).handleMarkerDefaults;
	            var Colorscale = __webpack_require__2(21081);
	            var hasColorscale = Colorscale.hasColorscale;
	            var colorscaleDefaults = Colorscale.handleDefaults;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var labels = coerce("labels");
	              var parents = coerce("parents");
	              if (!labels || !labels.length || !parents || !parents.length) {
	                traceOut.visible = false;
	                return;
	              }
	              var vals = coerce("values");
	              if (vals && vals.length) {
	                coerce("branchvalues");
	              } else {
	                coerce("count");
	              }
	              coerce("level");
	              coerce("maxdepth");
	              handleMarkerDefaults(traceIn, traceOut, layout, coerce);
	              var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, "marker", "colors") || (traceIn.marker || {}).coloraxis;
	              if (withColorscale) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "marker.",
	                  cLetter: "c"
	                });
	              }
	              coerce("leaf.opacity", withColorscale ? 1 : 0.7);
	              var text = coerce("text");
	              coerce("texttemplate");
	              if (!traceOut.texttemplate) coerce("textinfo", Array.isArray(text) ? "text+label" : "label");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var textposition = "auto";
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                moduleHasSelected: false,
	                moduleHasUnselected: false,
	                moduleHasConstrain: false,
	                moduleHasCliponaxis: false,
	                moduleHasTextangle: false,
	                moduleHasInsideanchor: false
	              });
	              coerce("insidetextorientation");
	              coerce("sort");
	              coerce("rotation");
	              coerce("root.color");
	              handleDomainDefaults(traceOut, layout, coerce);
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        43467: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            module2.exports = function fillOne(s, pt, trace, gd, fadedColor) {
	              var cdi = pt.data.data;
	              var ptNumber = cdi.i;
	              var color = fadedColor || cdi.color;
	              if (ptNumber >= 0) {
	                pt.i = cdi.i;
	                var marker = trace.marker;
	                if (marker.pattern) {
	                  if (!marker.colors || !marker.pattern.shape) {
	                    marker.color = color;
	                    pt.color = color;
	                  }
	                } else {
	                  marker.color = color;
	                  pt.color = color;
	                }
	                Drawing.pointStyle(s, trace, gd, pt);
	              } else {
	                Color.fill(s, color);
	              }
	            };
	          }
	        ),
	        /***/
	        83523: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Registry = __webpack_require__2(73972);
	            var appendArrayPointValue = __webpack_require__2(23469).appendArrayPointValue;
	            var Fx = __webpack_require__2(30211);
	            var Lib = __webpack_require__2(71828);
	            var Events = __webpack_require__2(11086);
	            var helpers = __webpack_require__2(2791);
	            var pieHelpers = __webpack_require__2(53581);
	            var formatValue = pieHelpers.formatPieValue;
	            module2.exports = function attachFxHandlers(sliceTop, entry, gd, cd, opts) {
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var hierarchy = cd0.hierarchy;
	              var isSunburst = trace.type === "sunburst";
	              var isTreemapOrIcicle = trace.type === "treemap" || trace.type === "icicle";
	              if (!("_hasHoverLabel" in trace)) trace._hasHoverLabel = false;
	              if (!("_hasHoverEvent" in trace)) trace._hasHoverEvent = false;
	              var onMouseOver = function(pt) {
	                var fullLayoutNow = gd._fullLayout;
	                if (gd._dragging || fullLayoutNow.hovermode === false) return;
	                var traceNow = gd._fullData[trace.index];
	                var cdi = pt.data.data;
	                var ptNumber = cdi.i;
	                var isRoot = helpers.isHierarchyRoot(pt);
	                var parent = helpers.getParent(hierarchy, pt);
	                var val = helpers.getValue(pt);
	                var _cast = function(astr) {
	                  return Lib.castOption(traceNow, ptNumber, astr);
	                };
	                var hovertemplate = _cast("hovertemplate");
	                var hoverinfo = Fx.castHoverinfo(traceNow, fullLayoutNow, ptNumber);
	                var separators = fullLayoutNow.separators;
	                var eventData;
	                if (hovertemplate || hoverinfo && hoverinfo !== "none" && hoverinfo !== "skip") {
	                  var hoverCenterX;
	                  var hoverCenterY;
	                  if (isSunburst) {
	                    hoverCenterX = cd0.cx + pt.pxmid[0] * (1 - pt.rInscribed);
	                    hoverCenterY = cd0.cy + pt.pxmid[1] * (1 - pt.rInscribed);
	                  }
	                  if (isTreemapOrIcicle) {
	                    hoverCenterX = pt._hoverX;
	                    hoverCenterY = pt._hoverY;
	                  }
	                  var hoverPt = {};
	                  var parts = [];
	                  var thisText = [];
	                  var hasFlag = function(flag) {
	                    return parts.indexOf(flag) !== -1;
	                  };
	                  if (hoverinfo) {
	                    parts = hoverinfo === "all" ? traceNow._module.attributes.hoverinfo.flags : hoverinfo.split("+");
	                  }
	                  hoverPt.label = cdi.label;
	                  if (hasFlag("label") && hoverPt.label) thisText.push(hoverPt.label);
	                  if (cdi.hasOwnProperty("v")) {
	                    hoverPt.value = cdi.v;
	                    hoverPt.valueLabel = formatValue(hoverPt.value, separators);
	                    if (hasFlag("value")) thisText.push(hoverPt.valueLabel);
	                  }
	                  hoverPt.currentPath = pt.currentPath = helpers.getPath(pt.data);
	                  if (hasFlag("current path") && !isRoot) {
	                    thisText.push(hoverPt.currentPath);
	                  }
	                  var tx;
	                  var allPercents = [];
	                  var insertPercent = function() {
	                    if (allPercents.indexOf(tx) === -1) {
	                      thisText.push(tx);
	                      allPercents.push(tx);
	                    }
	                  };
	                  hoverPt.percentParent = pt.percentParent = val / helpers.getValue(parent);
	                  hoverPt.parent = pt.parentString = helpers.getPtLabel(parent);
	                  if (hasFlag("percent parent")) {
	                    tx = helpers.formatPercent(hoverPt.percentParent, separators) + " of " + hoverPt.parent;
	                    insertPercent();
	                  }
	                  hoverPt.percentEntry = pt.percentEntry = val / helpers.getValue(entry);
	                  hoverPt.entry = pt.entry = helpers.getPtLabel(entry);
	                  if (hasFlag("percent entry") && !isRoot && !pt.onPathbar) {
	                    tx = helpers.formatPercent(hoverPt.percentEntry, separators) + " of " + hoverPt.entry;
	                    insertPercent();
	                  }
	                  hoverPt.percentRoot = pt.percentRoot = val / helpers.getValue(hierarchy);
	                  hoverPt.root = pt.root = helpers.getPtLabel(hierarchy);
	                  if (hasFlag("percent root") && !isRoot) {
	                    tx = helpers.formatPercent(hoverPt.percentRoot, separators) + " of " + hoverPt.root;
	                    insertPercent();
	                  }
	                  hoverPt.text = _cast("hovertext") || _cast("text");
	                  if (hasFlag("text")) {
	                    tx = hoverPt.text;
	                    if (Lib.isValidTextValue(tx)) thisText.push(tx);
	                  }
	                  eventData = [makeEventData(pt, traceNow, opts.eventDataKeys)];
	                  var hoverItems = {
	                    trace: traceNow,
	                    y: hoverCenterY,
	                    _x0: pt._x0,
	                    _x1: pt._x1,
	                    _y0: pt._y0,
	                    _y1: pt._y1,
	                    text: thisText.join("<br>"),
	                    name: hovertemplate || hasFlag("name") ? traceNow.name : undefined,
	                    color: _cast("hoverlabel.bgcolor") || cdi.color,
	                    borderColor: _cast("hoverlabel.bordercolor"),
	                    fontFamily: _cast("hoverlabel.font.family"),
	                    fontSize: _cast("hoverlabel.font.size"),
	                    fontColor: _cast("hoverlabel.font.color"),
	                    nameLength: _cast("hoverlabel.namelength"),
	                    textAlign: _cast("hoverlabel.align"),
	                    hovertemplate,
	                    hovertemplateLabels: hoverPt,
	                    eventData
	                  };
	                  if (isSunburst) {
	                    hoverItems.x0 = hoverCenterX - pt.rInscribed * pt.rpx1;
	                    hoverItems.x1 = hoverCenterX + pt.rInscribed * pt.rpx1;
	                    hoverItems.idealAlign = pt.pxmid[0] < 0 ? "left" : "right";
	                  }
	                  if (isTreemapOrIcicle) {
	                    hoverItems.x = hoverCenterX;
	                    hoverItems.idealAlign = hoverCenterX < 0 ? "left" : "right";
	                  }
	                  var bbox = [];
	                  Fx.loneHover(hoverItems, {
	                    container: fullLayoutNow._hoverlayer.node(),
	                    outerContainer: fullLayoutNow._paper.node(),
	                    gd,
	                    inOut_bbox: bbox
	                  });
	                  eventData[0].bbox = bbox[0];
	                  trace._hasHoverLabel = true;
	                }
	                if (isTreemapOrIcicle) {
	                  var slice2 = sliceTop.select("path.surface");
	                  opts.styleOne(slice2, pt, traceNow, gd, {
	                    hovered: true
	                  });
	                }
	                trace._hasHoverEvent = true;
	                gd.emit("plotly_hover", {
	                  points: eventData || [makeEventData(pt, traceNow, opts.eventDataKeys)],
	                  event: d3.event
	                });
	              };
	              var onMouseOut = function(evt) {
	                var fullLayoutNow = gd._fullLayout;
	                var traceNow = gd._fullData[trace.index];
	                var pt = d3.select(this).datum();
	                if (trace._hasHoverEvent) {
	                  evt.originalEvent = d3.event;
	                  gd.emit("plotly_unhover", {
	                    points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
	                    event: d3.event
	                  });
	                  trace._hasHoverEvent = false;
	                }
	                if (trace._hasHoverLabel) {
	                  Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
	                  trace._hasHoverLabel = false;
	                }
	                if (isTreemapOrIcicle) {
	                  var slice2 = sliceTop.select("path.surface");
	                  opts.styleOne(slice2, pt, traceNow, gd, {
	                    hovered: false
	                  });
	                }
	              };
	              var onClick = function(pt) {
	                var fullLayoutNow = gd._fullLayout;
	                var traceNow = gd._fullData[trace.index];
	                var noTransition = isSunburst && (helpers.isHierarchyRoot(pt) || helpers.isLeaf(pt));
	                var id = helpers.getPtId(pt);
	                var nextEntry = helpers.isEntry(pt) ? helpers.findEntryWithChild(hierarchy, id) : helpers.findEntryWithLevel(hierarchy, id);
	                var nextLevel = helpers.getPtId(nextEntry);
	                var typeClickEvtData = {
	                  points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
	                  event: d3.event
	                };
	                if (!noTransition) typeClickEvtData.nextLevel = nextLevel;
	                var clickVal = Events.triggerHandler(gd, "plotly_" + trace.type + "click", typeClickEvtData);
	                if (clickVal !== false && fullLayoutNow.hovermode) {
	                  gd._hoverdata = [makeEventData(pt, traceNow, opts.eventDataKeys)];
	                  Fx.click(gd, d3.event);
	                }
	                if (noTransition) return;
	                if (clickVal === false) return;
	                if (gd._dragging) return;
	                if (gd._transitioning) return;
	                Registry.call("_storeDirectGUIEdit", traceNow, fullLayoutNow._tracePreGUI[traceNow.uid], {
	                  level: traceNow.level
	                });
	                var frame = {
	                  data: [{
	                    level: nextLevel
	                  }],
	                  traces: [trace.index]
	                };
	                var animOpts = {
	                  frame: {
	                    redraw: false,
	                    duration: opts.transitionTime
	                  },
	                  transition: {
	                    duration: opts.transitionTime,
	                    easing: opts.transitionEasing
	                  },
	                  mode: "immediate",
	                  fromcurrent: true
	                };
	                Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
	                Registry.call("animate", gd, frame, animOpts);
	              };
	              sliceTop.on("mouseover", onMouseOver);
	              sliceTop.on("mouseout", onMouseOut);
	              sliceTop.on("click", onClick);
	            };
	            function makeEventData(pt, trace, keys) {
	              var cdi = pt.data.data;
	              var out = {
	                curveNumber: trace.index,
	                pointNumber: cdi.i,
	                data: trace._input,
	                fullData: trace
	                // TODO more things like 'children', 'siblings', 'hierarchy?
	              };
	              for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                if (key in pt) out[key] = pt[key];
	              }
	              if ("parentString" in pt && !helpers.isHierarchyRoot(pt)) out.parent = pt.parentString;
	              appendArrayPointValue(out, trace, cdi.i);
	              return out;
	            }
	          }
	        ),
	        /***/
	        2791: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var setCursor = __webpack_require__2(6964);
	            var pieHelpers = __webpack_require__2(53581);
	            exports2.findEntryWithLevel = function(hierarchy, level) {
	              var out;
	              if (level) {
	                hierarchy.eachAfter(function(pt) {
	                  if (exports2.getPtId(pt) === level) {
	                    return out = pt.copy();
	                  }
	                });
	              }
	              return out || hierarchy;
	            };
	            exports2.findEntryWithChild = function(hierarchy, childId) {
	              var out;
	              hierarchy.eachAfter(function(pt) {
	                var children = pt.children || [];
	                for (var i = 0; i < children.length; i++) {
	                  var child = children[i];
	                  if (exports2.getPtId(child) === childId) {
	                    return out = pt.copy();
	                  }
	                }
	              });
	              return out || hierarchy;
	            };
	            exports2.isEntry = function(pt) {
	              return !pt.parent;
	            };
	            exports2.isLeaf = function(pt) {
	              return !pt.children;
	            };
	            exports2.getPtId = function(pt) {
	              return pt.data.data.id;
	            };
	            exports2.getPtLabel = function(pt) {
	              return pt.data.data.label;
	            };
	            exports2.getValue = function(d) {
	              return d.value;
	            };
	            exports2.isHierarchyRoot = function(pt) {
	              return getParentId(pt) === "";
	            };
	            exports2.setSliceCursor = function(sliceTop, gd, opts) {
	              var hide = opts.isTransitioning;
	              if (!hide) {
	                var pt = sliceTop.datum();
	                hide = opts.hideOnRoot && exports2.isHierarchyRoot(pt) || opts.hideOnLeaves && exports2.isLeaf(pt);
	              }
	              setCursor(sliceTop, hide ? null : "pointer");
	            };
	            function determineOutsideTextFont(trace, pt, layoutFont) {
	              return {
	                color: exports2.getOutsideTextFontKey("color", trace, pt, layoutFont),
	                family: exports2.getOutsideTextFontKey("family", trace, pt, layoutFont),
	                size: exports2.getOutsideTextFontKey("size", trace, pt, layoutFont)
	              };
	            }
	            function determineInsideTextFont(trace, pt, layoutFont, opts) {
	              var onPathbar = (opts || {}).onPathbar;
	              var cdi = pt.data.data;
	              var ptNumber = cdi.i;
	              var customColor = Lib.castOption(trace, ptNumber, (onPathbar ? "pathbar.textfont" : "insidetextfont") + ".color");
	              if (!customColor && trace._input.textfont) {
	                customColor = Lib.castOption(trace._input, ptNumber, "textfont.color");
	              }
	              return {
	                color: customColor || Color.contrast(cdi.color),
	                family: exports2.getInsideTextFontKey("family", trace, pt, layoutFont, opts),
	                size: exports2.getInsideTextFontKey("size", trace, pt, layoutFont, opts)
	              };
	            }
	            exports2.getInsideTextFontKey = function(keyStr, trace, pt, layoutFont, opts) {
	              var onPathbar = (opts || {}).onPathbar;
	              var cont = onPathbar ? "pathbar.textfont" : "insidetextfont";
	              var ptNumber = pt.data.data.i;
	              return Lib.castOption(trace, ptNumber, cont + "." + keyStr) || Lib.castOption(trace, ptNumber, "textfont." + keyStr) || layoutFont.size;
	            };
	            exports2.getOutsideTextFontKey = function(keyStr, trace, pt, layoutFont) {
	              var ptNumber = pt.data.data.i;
	              return Lib.castOption(trace, ptNumber, "outsidetextfont." + keyStr) || Lib.castOption(trace, ptNumber, "textfont." + keyStr) || layoutFont.size;
	            };
	            exports2.isOutsideText = function(trace, pt) {
	              return !trace._hasColorscale && exports2.isHierarchyRoot(pt);
	            };
	            exports2.determineTextFont = function(trace, pt, layoutFont, opts) {
	              return exports2.isOutsideText(trace, pt) ? determineOutsideTextFont(trace, pt, layoutFont) : determineInsideTextFont(trace, pt, layoutFont, opts);
	            };
	            exports2.hasTransition = function(transitionOpts) {
	              return !!(transitionOpts && transitionOpts.duration > 0);
	            };
	            exports2.getMaxDepth = function(trace) {
	              return trace.maxdepth >= 0 ? trace.maxdepth : Infinity;
	            };
	            exports2.isHeader = function(pt, trace) {
	              return !(exports2.isLeaf(pt) || pt.depth === trace._maxDepth - 1);
	            };
	            function getParentId(pt) {
	              return pt.data.data.pid;
	            }
	            exports2.getParent = function(hierarchy, pt) {
	              return exports2.findEntryWithLevel(hierarchy, getParentId(pt));
	            };
	            exports2.listPath = function(d, keyStr) {
	              var parent = d.parent;
	              if (!parent) return [];
	              var list = keyStr ? [parent.data[keyStr]] : [parent];
	              return exports2.listPath(parent, keyStr).concat(list);
	            };
	            exports2.getPath = function(d) {
	              return exports2.listPath(d, "label").join("/") + "/";
	            };
	            exports2.formatValue = pieHelpers.formatPieValue;
	            exports2.formatPercent = function(v, separators) {
	              var tx = Lib.formatPercent(v, 0);
	              if (tx === "0%") tx = pieHelpers.formatPiePercent(v, separators);
	              return tx;
	            };
	          }
	        ),
	        /***/
	        87619: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "sunburst",
	              basePlotModule: __webpack_require__2(66888),
	              categories: [],
	              animatable: true,
	              attributes: __webpack_require__2(57564),
	              layoutAttributes: __webpack_require__2(2654),
	              supplyDefaults: __webpack_require__2(17094),
	              supplyLayoutDefaults: __webpack_require__2(57034),
	              calc: __webpack_require__2(52147).calc,
	              crossTraceCalc: __webpack_require__2(52147).crossTraceCalc,
	              plot: __webpack_require__2(24714).plot,
	              style: __webpack_require__2(29969).style,
	              colorbar: __webpack_require__2(4898),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        2654: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              sunburstcolorway: {
	                valType: "colorlist",
	                editType: "calc"
	              },
	              extendsunburstcolors: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        57034: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(2654);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              coerce("sunburstcolorway", layoutOut.colorway);
	              coerce("extendsunburstcolors");
	            };
	          }
	        ),
	        /***/
	        24714: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var d3Hierarchy = __webpack_require__2(674);
	            var interpolate = __webpack_require__2(81684).sX;
	            var Drawing = __webpack_require__2(91424);
	            var Lib = __webpack_require__2(71828);
	            var svgTextUtils = __webpack_require__2(63893);
	            var uniformText = __webpack_require__2(72597);
	            var recordMinTextSize = uniformText.recordMinTextSize;
	            var clearMinTextSize = uniformText.clearMinTextSize;
	            var piePlot = __webpack_require__2(14575);
	            var getRotationAngle = __webpack_require__2(53581).getRotationAngle;
	            var computeTransform = piePlot.computeTransform;
	            var transformInsideText = piePlot.transformInsideText;
	            var styleOne = __webpack_require__2(29969).styleOne;
	            var resizeText = __webpack_require__2(16688).resizeText;
	            var attachFxHandlers = __webpack_require__2(83523);
	            var constants = __webpack_require__2(7055);
	            var helpers = __webpack_require__2(2791);
	            exports2.plot = function(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
	              var fullLayout = gd._fullLayout;
	              var layer = fullLayout._sunburstlayer;
	              var join, onComplete;
	              var isFullReplot = !transitionOpts;
	              var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
	              clearMinTextSize("sunburst", fullLayout);
	              join = layer.selectAll("g.trace.sunburst").data(cdmodule, function(cd) {
	                return cd[0].trace.uid;
	              });
	              join.enter().append("g").classed("trace", true).classed("sunburst", true).attr("stroke-linejoin", "round");
	              join.order();
	              if (hasTransition) {
	                if (makeOnCompleteCallback) {
	                  onComplete = makeOnCompleteCallback();
	                }
	                var transition = d3.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each("end", function() {
	                  onComplete && onComplete();
	                }).each("interrupt", function() {
	                  onComplete && onComplete();
	                });
	                transition.each(function() {
	                  layer.selectAll("g.trace").each(function(cd) {
	                    plotOne(gd, cd, this, transitionOpts);
	                  });
	                });
	              } else {
	                join.each(function(cd) {
	                  plotOne(gd, cd, this, transitionOpts);
	                });
	                if (fullLayout.uniformtext.mode) {
	                  resizeText(gd, fullLayout._sunburstlayer.selectAll(".trace"), "sunburst");
	                }
	              }
	              if (isFullReplot) {
	                join.exit().remove();
	              }
	            };
	            function plotOne(gd, cd, element, transitionOpts) {
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
	              var gTrace = d3.select(element);
	              var slices = gTrace.selectAll("g.slice");
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var hierarchy = cd0.hierarchy;
	              var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
	              var maxDepth = helpers.getMaxDepth(trace);
	              var gs = fullLayout._size;
	              var domain = trace.domain;
	              var vpw = gs.w * (domain.x[1] - domain.x[0]);
	              var vph = gs.h * (domain.y[1] - domain.y[0]);
	              var rMax = 0.5 * Math.min(vpw, vph);
	              var cx = cd0.cx = gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
	              var cy = cd0.cy = gs.t + gs.h * (1 - domain.y[0]) - vph / 2;
	              if (!entry) {
	                return slices.remove();
	              }
	              var prevEntry = null;
	              var prevLookup = {};
	              if (hasTransition) {
	                slices.each(function(pt) {
	                  prevLookup[helpers.getPtId(pt)] = {
	                    rpx0: pt.rpx0,
	                    rpx1: pt.rpx1,
	                    x0: pt.x0,
	                    x1: pt.x1,
	                    transform: pt.transform
	                  };
	                  if (!prevEntry && helpers.isEntry(pt)) {
	                    prevEntry = pt;
	                  }
	                });
	              }
	              var sliceData = partition(entry).descendants();
	              var maxHeight = entry.height + 1;
	              var yOffset = 0;
	              var cutoff = maxDepth;
	              if (cd0.hasMultipleRoots && helpers.isHierarchyRoot(entry)) {
	                sliceData = sliceData.slice(1);
	                maxHeight -= 1;
	                yOffset = 1;
	                cutoff += 1;
	              }
	              sliceData = sliceData.filter(function(pt) {
	                return pt.y1 <= cutoff;
	              });
	              var baseX = getRotationAngle(trace.rotation);
	              if (baseX) {
	                sliceData.forEach(function(pt) {
	                  pt.x0 += baseX;
	                  pt.x1 += baseX;
	                });
	              }
	              var maxY = Math.min(maxHeight, maxDepth);
	              var y2rpx = function(y) {
	                return (y - yOffset) / maxY * rMax;
	              };
	              var rx2px = function(r, x) {
	                return [r * Math.cos(x), -r * Math.sin(x)];
	              };
	              var pathSlice = function(d) {
	                return Lib.pathAnnulus(d.rpx0, d.rpx1, d.x0, d.x1, cx, cy);
	              };
	              var getTargetX = function(d) {
	                return cx + getTextXY(d)[0] * (d.transform.rCenter || 0) + (d.transform.x || 0);
	              };
	              var getTargetY = function(d) {
	                return cy + getTextXY(d)[1] * (d.transform.rCenter || 0) + (d.transform.y || 0);
	              };
	              slices = slices.data(sliceData, helpers.getPtId);
	              slices.enter().append("g").classed("slice", true);
	              if (hasTransition) {
	                slices.exit().transition().each(function() {
	                  var sliceTop = d3.select(this);
	                  var slicePath = sliceTop.select("path.surface");
	                  slicePath.transition().attrTween("d", function(pt2) {
	                    var interp = makeExitSliceInterpolator(pt2);
	                    return function(t) {
	                      return pathSlice(interp(t));
	                    };
	                  });
	                  var sliceTextGroup = sliceTop.select("g.slicetext");
	                  sliceTextGroup.attr("opacity", 0);
	                }).remove();
	              } else {
	                slices.exit().remove();
	              }
	              slices.order();
	              var nextX1ofPrevEntry = null;
	              if (hasTransition && prevEntry) {
	                var prevEntryId = helpers.getPtId(prevEntry);
	                slices.each(function(pt) {
	                  if (nextX1ofPrevEntry === null && helpers.getPtId(pt) === prevEntryId) {
	                    nextX1ofPrevEntry = pt.x1;
	                  }
	                });
	              }
	              var updateSlices = slices;
	              if (hasTransition) {
	                updateSlices = updateSlices.transition().each("end", function() {
	                  var sliceTop = d3.select(this);
	                  helpers.setSliceCursor(sliceTop, gd, {
	                    hideOnRoot: true,
	                    hideOnLeaves: true,
	                    isTransitioning: false
	                  });
	                });
	              }
	              updateSlices.each(function(pt) {
	                var sliceTop = d3.select(this);
	                var slicePath = Lib.ensureSingle(sliceTop, "path", "surface", function(s) {
	                  s.style("pointer-events", isStatic ? "none" : "all");
	                });
	                pt.rpx0 = y2rpx(pt.y0);
	                pt.rpx1 = y2rpx(pt.y1);
	                pt.xmid = (pt.x0 + pt.x1) / 2;
	                pt.pxmid = rx2px(pt.rpx1, pt.xmid);
	                pt.midangle = -(pt.xmid - Math.PI / 2);
	                pt.startangle = -(pt.x0 - Math.PI / 2);
	                pt.stopangle = -(pt.x1 - Math.PI / 2);
	                pt.halfangle = 0.5 * Math.min(Lib.angleDelta(pt.x0, pt.x1) || Math.PI, Math.PI);
	                pt.ring = 1 - pt.rpx0 / pt.rpx1;
	                pt.rInscribed = getInscribedRadiusFraction(pt);
	                if (hasTransition) {
	                  slicePath.transition().attrTween("d", function(pt2) {
	                    var interp = makeUpdateSliceInterpolator(pt2);
	                    return function(t) {
	                      return pathSlice(interp(t));
	                    };
	                  });
	                } else {
	                  slicePath.attr("d", pathSlice);
	                }
	                sliceTop.call(attachFxHandlers, entry, gd, cd, {
	                  eventDataKeys: constants.eventDataKeys,
	                  transitionTime: constants.CLICK_TRANSITION_TIME,
	                  transitionEasing: constants.CLICK_TRANSITION_EASING
	                }).call(helpers.setSliceCursor, gd, {
	                  hideOnRoot: true,
	                  hideOnLeaves: true,
	                  isTransitioning: gd._transitioning
	                });
	                slicePath.call(styleOne, pt, trace, gd);
	                var sliceTextGroup = Lib.ensureSingle(sliceTop, "g", "slicetext");
	                var sliceText = Lib.ensureSingle(sliceTextGroup, "text", "", function(s) {
	                  s.attr("data-notex", 1);
	                });
	                var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
	                sliceText.text(exports2.formatSliceLabel(pt, entry, trace, cd, fullLayout)).classed("slicetext", true).attr("text-anchor", "middle").call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
	                var textBB = Drawing.bBox(sliceText.node());
	                pt.transform = transformInsideText(textBB, pt, cd0);
	                pt.transform.targetX = getTargetX(pt);
	                pt.transform.targetY = getTargetY(pt);
	                var strTransform = function(d, textBB2) {
	                  var transform = d.transform;
	                  computeTransform(transform, textBB2);
	                  transform.fontSize = font.size;
	                  recordMinTextSize(trace.type, transform, fullLayout);
	                  return Lib.getTextTransform(transform);
	                };
	                if (hasTransition) {
	                  sliceText.transition().attrTween("transform", function(pt2) {
	                    var interp = makeUpdateTextInterpolator(pt2);
	                    return function(t) {
	                      return strTransform(interp(t), textBB);
	                    };
	                  });
	                } else {
	                  sliceText.attr("transform", strTransform(pt, textBB));
	                }
	              });
	              function makeExitSliceInterpolator(pt) {
	                var id = helpers.getPtId(pt);
	                var prev = prevLookup[id];
	                var entryPrev = prevLookup[helpers.getPtId(entry)];
	                var next;
	                if (entryPrev) {
	                  var a = (pt.x1 > entryPrev.x1 ? 2 * Math.PI : 0) + baseX;
	                  next = pt.rpx1 < entryPrev.rpx1 ? {
	                    x0: pt.x0,
	                    x1: pt.x1,
	                    rpx0: 0,
	                    rpx1: 0
	                  } : {
	                    x0: a,
	                    x1: a,
	                    rpx0: pt.rpx0,
	                    rpx1: pt.rpx1
	                  };
	                } else {
	                  var parent;
	                  var parentId = helpers.getPtId(pt.parent);
	                  slices.each(function(pt2) {
	                    if (helpers.getPtId(pt2) === parentId) {
	                      return parent = pt2;
	                    }
	                  });
	                  var parentChildren = parent.children;
	                  var ci;
	                  parentChildren.forEach(function(pt2, i) {
	                    if (helpers.getPtId(pt2) === id) {
	                      return ci = i;
	                    }
	                  });
	                  var n = parentChildren.length;
	                  var interp = interpolate(parent.x0, parent.x1);
	                  next = {
	                    rpx0: rMax,
	                    rpx1: rMax,
	                    x0: interp(ci / n),
	                    x1: interp((ci + 1) / n)
	                  };
	                }
	                return interpolate(prev, next);
	              }
	              function makeUpdateSliceInterpolator(pt) {
	                var prev0 = prevLookup[helpers.getPtId(pt)];
	                var prev;
	                var next = {
	                  x0: pt.x0,
	                  x1: pt.x1,
	                  rpx0: pt.rpx0,
	                  rpx1: pt.rpx1
	                };
	                if (prev0) {
	                  prev = prev0;
	                } else {
	                  if (prevEntry) {
	                    if (pt.parent) {
	                      if (nextX1ofPrevEntry) {
	                        var a = (pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0) + baseX;
	                        prev = {
	                          x0: a,
	                          x1: a
	                        };
	                      } else {
	                        prev = {
	                          rpx0: rMax,
	                          rpx1: rMax
	                        };
	                        Lib.extendFlat(prev, interpX0X1FromParent(pt));
	                      }
	                    } else {
	                      prev = {
	                        rpx0: 0,
	                        rpx1: 0
	                      };
	                    }
	                  } else {
	                    prev = {
	                      x0: baseX,
	                      x1: baseX
	                    };
	                  }
	                }
	                return interpolate(prev, next);
	              }
	              function makeUpdateTextInterpolator(pt) {
	                var prev0 = prevLookup[helpers.getPtId(pt)];
	                var prev;
	                var transform = pt.transform;
	                if (prev0) {
	                  prev = prev0;
	                } else {
	                  prev = {
	                    rpx1: pt.rpx1,
	                    transform: {
	                      textPosAngle: transform.textPosAngle,
	                      scale: 0,
	                      rotate: transform.rotate,
	                      rCenter: transform.rCenter,
	                      x: transform.x,
	                      y: transform.y
	                    }
	                  };
	                  if (prevEntry) {
	                    if (pt.parent) {
	                      if (nextX1ofPrevEntry) {
	                        var a = pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0;
	                        prev.x0 = prev.x1 = a;
	                      } else {
	                        Lib.extendFlat(prev, interpX0X1FromParent(pt));
	                      }
	                    } else {
	                      prev.x0 = prev.x1 = baseX;
	                    }
	                  } else {
	                    prev.x0 = prev.x1 = baseX;
	                  }
	                }
	                var textPosAngleFn = interpolate(prev.transform.textPosAngle, pt.transform.textPosAngle);
	                var rpx1Fn = interpolate(prev.rpx1, pt.rpx1);
	                var x0Fn = interpolate(prev.x0, pt.x0);
	                var x1Fn = interpolate(prev.x1, pt.x1);
	                var scaleFn = interpolate(prev.transform.scale, transform.scale);
	                var rotateFn = interpolate(prev.transform.rotate, transform.rotate);
	                var pow = transform.rCenter === 0 ? 3 : prev.transform.rCenter === 0 ? 1 / 3 : 1;
	                var _rCenterFn = interpolate(prev.transform.rCenter, transform.rCenter);
	                var rCenterFn = function(t) {
	                  return _rCenterFn(Math.pow(t, pow));
	                };
	                return function(t) {
	                  var rpx1 = rpx1Fn(t);
	                  var x0 = x0Fn(t);
	                  var x1 = x1Fn(t);
	                  var rCenter = rCenterFn(t);
	                  var pxmid = rx2px(rpx1, (x0 + x1) / 2);
	                  var textPosAngle = textPosAngleFn(t);
	                  var d = {
	                    pxmid,
	                    rpx1,
	                    transform: {
	                      textPosAngle,
	                      rCenter,
	                      x: transform.x,
	                      y: transform.y
	                    }
	                  };
	                  recordMinTextSize(trace.type, transform, fullLayout);
	                  return {
	                    transform: {
	                      targetX: getTargetX(d),
	                      targetY: getTargetY(d),
	                      scale: scaleFn(t),
	                      rotate: rotateFn(t),
	                      rCenter
	                    }
	                  };
	                };
	              }
	              function interpX0X1FromParent(pt) {
	                var parent = pt.parent;
	                var parentPrev = prevLookup[helpers.getPtId(parent)];
	                var out = {};
	                if (parentPrev) {
	                  var parentChildren = parent.children;
	                  var ci = parentChildren.indexOf(pt);
	                  var n = parentChildren.length;
	                  var interp = interpolate(parentPrev.x0, parentPrev.x1);
	                  out.x0 = interp(ci / n);
	                  out.x1 = interp(ci / n);
	                } else {
	                  out.x0 = out.x1 = 0;
	                }
	                return out;
	              }
	            }
	            function partition(entry) {
	              return d3Hierarchy.partition().size([2 * Math.PI, entry.height + 1])(entry);
	            }
	            exports2.formatSliceLabel = function(pt, entry, trace, cd, fullLayout) {
	              var texttemplate = trace.texttemplate;
	              var textinfo = trace.textinfo;
	              if (!texttemplate && (!textinfo || textinfo === "none")) {
	                return "";
	              }
	              var separators = fullLayout.separators;
	              var cd0 = cd[0];
	              var cdi = pt.data.data;
	              var hierarchy = cd0.hierarchy;
	              var isRoot = helpers.isHierarchyRoot(pt);
	              var parent = helpers.getParent(hierarchy, pt);
	              var val = helpers.getValue(pt);
	              if (!texttemplate) {
	                var parts = textinfo.split("+");
	                var hasFlag = function(flag) {
	                  return parts.indexOf(flag) !== -1;
	                };
	                var thisText = [];
	                var tx;
	                if (hasFlag("label") && cdi.label) {
	                  thisText.push(cdi.label);
	                }
	                if (cdi.hasOwnProperty("v") && hasFlag("value")) {
	                  thisText.push(helpers.formatValue(cdi.v, separators));
	                }
	                if (!isRoot) {
	                  if (hasFlag("current path")) {
	                    thisText.push(helpers.getPath(pt.data));
	                  }
	                  var nPercent = 0;
	                  if (hasFlag("percent parent")) nPercent++;
	                  if (hasFlag("percent entry")) nPercent++;
	                  if (hasFlag("percent root")) nPercent++;
	                  var hasMultiplePercents = nPercent > 1;
	                  if (nPercent) {
	                    var percent;
	                    var addPercent = function(key) {
	                      tx = helpers.formatPercent(percent, separators);
	                      if (hasMultiplePercents) tx += " of " + key;
	                      thisText.push(tx);
	                    };
	                    if (hasFlag("percent parent") && !isRoot) {
	                      percent = val / helpers.getValue(parent);
	                      addPercent("parent");
	                    }
	                    if (hasFlag("percent entry")) {
	                      percent = val / helpers.getValue(entry);
	                      addPercent("entry");
	                    }
	                    if (hasFlag("percent root")) {
	                      percent = val / helpers.getValue(hierarchy);
	                      addPercent("root");
	                    }
	                  }
	                }
	                if (hasFlag("text")) {
	                  tx = Lib.castOption(trace, cdi.i, "text");
	                  if (Lib.isValidTextValue(tx)) thisText.push(tx);
	                }
	                return thisText.join("<br>");
	              }
	              var txt = Lib.castOption(trace, cdi.i, "texttemplate");
	              if (!txt) return "";
	              var obj = {};
	              if (cdi.label) obj.label = cdi.label;
	              if (cdi.hasOwnProperty("v")) {
	                obj.value = cdi.v;
	                obj.valueLabel = helpers.formatValue(cdi.v, separators);
	              }
	              obj.currentPath = helpers.getPath(pt.data);
	              if (!isRoot) {
	                obj.percentParent = val / helpers.getValue(parent);
	                obj.percentParentLabel = helpers.formatPercent(obj.percentParent, separators);
	                obj.parent = helpers.getPtLabel(parent);
	              }
	              obj.percentEntry = val / helpers.getValue(entry);
	              obj.percentEntryLabel = helpers.formatPercent(obj.percentEntry, separators);
	              obj.entry = helpers.getPtLabel(entry);
	              obj.percentRoot = val / helpers.getValue(hierarchy);
	              obj.percentRootLabel = helpers.formatPercent(obj.percentRoot, separators);
	              obj.root = helpers.getPtLabel(hierarchy);
	              if (cdi.hasOwnProperty("color")) {
	                obj.color = cdi.color;
	              }
	              var ptTx = Lib.castOption(trace, cdi.i, "text");
	              if (Lib.isValidTextValue(ptTx) || ptTx === "") obj.text = ptTx;
	              obj.customdata = Lib.castOption(trace, cdi.i, "customdata");
	              return Lib.texttemplateString(txt, obj, fullLayout._d3locale, obj, trace._meta || {});
	            };
	            function getInscribedRadiusFraction(pt) {
	              if (pt.rpx0 === 0 && Lib.isFullCircle([pt.x0, pt.x1])) {
	                return 1;
	              } else {
	                return Math.max(0, Math.min(1 / (1 + 1 / Math.sin(pt.halfangle)), pt.ring / 2));
	              }
	            }
	            function getTextXY(d) {
	              return getCoords(d.rpx1, d.transform.textPosAngle);
	            }
	            function getCoords(r, angle) {
	              return [r * Math.sin(angle), -r * Math.cos(angle)];
	            }
	          }
	        ),
	        /***/
	        29969: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Lib = __webpack_require__2(71828);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            var fillOne = __webpack_require__2(43467);
	            function style(gd) {
	              var s = gd._fullLayout._sunburstlayer.selectAll(".trace");
	              resizeText(gd, s, "sunburst");
	              s.each(function(cd) {
	                var gTrace = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                gTrace.style("opacity", trace.opacity);
	                gTrace.selectAll("path.surface").each(function(pt) {
	                  d3.select(this).call(styleOne, pt, trace, gd);
	                });
	              });
	            }
	            function styleOne(s, pt, trace, gd) {
	              var cdi = pt.data.data;
	              var isLeaf = !pt.children;
	              var ptNumber = cdi.i;
	              var lineColor = Lib.castOption(trace, ptNumber, "marker.line.color") || Color.defaultLine;
	              var lineWidth = Lib.castOption(trace, ptNumber, "marker.line.width") || 0;
	              s.call(fillOne, pt, trace, gd).style("stroke-width", lineWidth).call(Color.stroke, lineColor).style("opacity", isLeaf ? trace.leaf.opacity : null);
	            }
	            module2.exports = {
	              style,
	              styleOne
	            };
	          }
	        ),
	        /***/
	        54532: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            function makeContourProjAttr(axLetter) {
	              return {
	                valType: "boolean",
	                dflt: false
	              };
	            }
	            function makeContourAttr(axLetter) {
	              return {
	                show: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                start: {
	                  valType: "number",
	                  dflt: null,
	                  editType: "plot"
	                  // impliedEdits: {'^autocontour': false},
	                },
	                end: {
	                  valType: "number",
	                  dflt: null,
	                  editType: "plot"
	                  // impliedEdits: {'^autocontour': false},
	                },
	                size: {
	                  valType: "number",
	                  dflt: null,
	                  min: 0,
	                  editType: "plot"
	                  // impliedEdits: {'^autocontour': false},
	                },
	                project: {
	                  x: makeContourProjAttr(),
	                  y: makeContourProjAttr(),
	                  z: makeContourProjAttr()
	                },
	                color: {
	                  valType: "color",
	                  dflt: Color.defaultLine
	                },
	                usecolormap: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                width: {
	                  valType: "number",
	                  min: 1,
	                  max: 16,
	                  dflt: 2
	                },
	                highlight: {
	                  valType: "boolean",
	                  dflt: true
	                },
	                highlightcolor: {
	                  valType: "color",
	                  dflt: Color.defaultLine
	                },
	                highlightwidth: {
	                  valType: "number",
	                  min: 1,
	                  max: 16,
	                  dflt: 2
	                }
	              };
	            }
	            var attrs = module2.exports = overrideAll(extendFlat({
	              z: {
	                valType: "data_array"
	              },
	              x: {
	                valType: "data_array"
	              },
	              y: {
	                valType: "data_array"
	              },
	              text: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true
	              },
	              hovertext: {
	                valType: "string",
	                dflt: "",
	                arrayOk: true
	              },
	              hovertemplate: hovertemplateAttrs(),
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              zhoverformat: axisHoverFormat("z"),
	              connectgaps: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              surfacecolor: {
	                valType: "data_array"
	              }
	            }, colorScaleAttrs("", {
	              colorAttr: "z or surfacecolor",
	              showScaleDflt: true,
	              autoColorDflt: false,
	              editTypeOverride: "calc"
	            }), {
	              contours: {
	                x: makeContourAttr(),
	                y: makeContourAttr(),
	                z: makeContourAttr()
	              },
	              hidesurface: {
	                valType: "boolean",
	                dflt: false
	              },
	              lightposition: {
	                x: {
	                  valType: "number",
	                  min: -1e5,
	                  max: 1e5,
	                  dflt: 10
	                },
	                y: {
	                  valType: "number",
	                  min: -1e5,
	                  max: 1e5,
	                  dflt: 1e4
	                },
	                z: {
	                  valType: "number",
	                  min: -1e5,
	                  max: 1e5,
	                  dflt: 0
	                }
	              },
	              lighting: {
	                ambient: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.8
	                },
	                diffuse: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.8
	                },
	                specular: {
	                  valType: "number",
	                  min: 0,
	                  max: 2,
	                  dflt: 0.05
	                },
	                roughness: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.5
	                },
	                fresnel: {
	                  valType: "number",
	                  min: 0,
	                  max: 5,
	                  dflt: 0.2
	                }
	              },
	              opacity: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 1
	              },
	              opacityscale: {
	                valType: "any",
	                editType: "calc"
	              },
	              _deprecated: {
	                zauto: extendFlat({}, colorScaleAttrs.zauto, {}),
	                zmin: extendFlat({}, colorScaleAttrs.zmin, {}),
	                zmax: extendFlat({}, colorScaleAttrs.zmax, {})
	              },
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }), "calc", "nested");
	            attrs.x.editType = attrs.y.editType = attrs.z.editType = "calc+clearAxisTypes";
	            attrs.transforms = undefined;
	          }
	        ),
	        /***/
	        18396: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorscaleCalc = __webpack_require__2(78803);
	            module2.exports = function calc(gd, trace) {
	              if (trace.surfacecolor) {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.surfacecolor,
	                  containerStr: "",
	                  cLetter: "c"
	                });
	              } else {
	                colorscaleCalc(gd, trace, {
	                  vals: trace.z,
	                  containerStr: "",
	                  cLetter: "c"
	                });
	              }
	            };
	          }
	        ),
	        /***/
	        43768: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createSurface = __webpack_require__2(9330).gl_surface3d;
	            var ndarray = __webpack_require__2(9330).ndarray;
	            var ndarrayInterp2d = __webpack_require__2(9330).ndarray_linear_interpolate.d2;
	            var interp2d = __webpack_require__2(824);
	            var findEmpties = __webpack_require__2(43907);
	            var isArrayOrTypedArray = __webpack_require__2(71828).isArrayOrTypedArray;
	            var parseColorScale = __webpack_require__2(81697).parseColorScale;
	            var str2RgbaArray = __webpack_require__2(78614);
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            function SurfaceTrace(scene, surface, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.surface = surface;
	              this.data = null;
	              this.showContour = [false, false, false];
	              this.contourStart = [null, null, null];
	              this.contourEnd = [null, null, null];
	              this.contourSize = [0, 0, 0];
	              this.minValues = [Infinity, Infinity, Infinity];
	              this.maxValues = [-Infinity, -Infinity, -Infinity];
	              this.dataScaleX = 1;
	              this.dataScaleY = 1;
	              this.refineData = true;
	              this.objectOffset = [0, 0, 0];
	            }
	            var proto = SurfaceTrace.prototype;
	            proto.getXat = function(a, b, calendar, axis) {
	              var v = !isArrayOrTypedArray(this.data.x) ? a : isArrayOrTypedArray(this.data.x[0]) ? this.data.x[b][a] : this.data.x[a];
	              return calendar === undefined ? v : axis.d2l(v, 0, calendar);
	            };
	            proto.getYat = function(a, b, calendar, axis) {
	              var v = !isArrayOrTypedArray(this.data.y) ? b : isArrayOrTypedArray(this.data.y[0]) ? this.data.y[b][a] : this.data.y[b];
	              return calendar === undefined ? v : axis.d2l(v, 0, calendar);
	            };
	            proto.getZat = function(a, b, calendar, axis) {
	              var v = this.data.z[b][a];
	              if (v === null && this.data.connectgaps && this.data._interpolatedZ) {
	                v = this.data._interpolatedZ[b][a];
	              }
	              return calendar === undefined ? v : axis.d2l(v, 0, calendar);
	            };
	            proto.handlePick = function(selection) {
	              if (selection.object === this.surface) {
	                var xRatio = (selection.data.index[0] - 1) / this.dataScaleX - 1;
	                var yRatio = (selection.data.index[1] - 1) / this.dataScaleY - 1;
	                var j = Math.max(Math.min(Math.round(xRatio), this.data.z[0].length - 1), 0);
	                var k = Math.max(Math.min(Math.round(yRatio), this.data._ylength - 1), 0);
	                selection.index = [j, k];
	                selection.traceCoordinate = [this.getXat(j, k), this.getYat(j, k), this.getZat(j, k)];
	                selection.dataCoordinate = [this.getXat(j, k, this.data.xcalendar, this.scene.fullSceneLayout.xaxis), this.getYat(j, k, this.data.ycalendar, this.scene.fullSceneLayout.yaxis), this.getZat(j, k, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)];
	                for (var i = 0; i < 3; i++) {
	                  var v = selection.dataCoordinate[i];
	                  if (v !== null && v !== undefined) {
	                    selection.dataCoordinate[i] *= this.scene.dataScale[i];
	                  }
	                }
	                var text = this.data.hovertext || this.data.text;
	                if (Array.isArray(text) && text[k] && text[k][j] !== undefined) {
	                  selection.textLabel = text[k][j];
	                } else if (text) {
	                  selection.textLabel = text;
	                } else {
	                  selection.textLabel = "";
	                }
	                selection.data.dataCoordinate = selection.dataCoordinate.slice();
	                this.surface.highlight(selection.data);
	                this.scene.glplot.spikes.position = selection.dataCoordinate;
	                return true;
	              }
	            };
	            function isColormapCircular(colormap) {
	              var first = colormap[0].rgb;
	              var last = colormap[colormap.length - 1].rgb;
	              return first[0] === last[0] && first[1] === last[1] && first[2] === last[2] && first[3] === last[3];
	            }
	            var shortPrimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997, 1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097, 1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099, 2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179, 2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297, 2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399, 2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477, 2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593, 2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699, 2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797, 2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897, 2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999];
	            function getPow(a, b) {
	              if (a < b) return 0;
	              var n = 0;
	              while (Math.floor(a % b) === 0) {
	                a /= b;
	                n++;
	              }
	              return n;
	            }
	            function getFactors(a) {
	              var powers = [];
	              for (var i = 0; i < shortPrimes.length; i++) {
	                var b = shortPrimes[i];
	                powers.push(getPow(a, b));
	              }
	              return powers;
	            }
	            function smallestDivisor(a) {
	              var A = getFactors(a);
	              var result = a;
	              for (var i = 0; i < shortPrimes.length; i++) {
	                if (A[i] > 0) {
	                  result = shortPrimes[i];
	                  break;
	                }
	              }
	              return result;
	            }
	            function leastCommonMultiple(a, b) {
	              if (a < 1 || b < 1) return undefined;
	              var A = getFactors(a);
	              var B = getFactors(b);
	              var n = 1;
	              for (var i = 0; i < shortPrimes.length; i++) {
	                n *= Math.pow(shortPrimes[i], Math.max(A[i], B[i]));
	              }
	              return n;
	            }
	            function arrayLCM(A) {
	              if (A.length === 0) return undefined;
	              var n = 1;
	              for (var i = 0; i < A.length; i++) {
	                n = leastCommonMultiple(n, A[i]);
	              }
	              return n;
	            }
	            proto.calcXnums = function(xlen) {
	              var i;
	              var nums = [];
	              for (i = 1; i < xlen; i++) {
	                var a = this.getXat(i - 1, 0);
	                var b = this.getXat(i, 0);
	                if (b !== a && a !== undefined && a !== null && b !== undefined && b !== null) {
	                  nums[i - 1] = Math.abs(b - a);
	                } else {
	                  nums[i - 1] = 0;
	                }
	              }
	              var totalDist = 0;
	              for (i = 1; i < xlen; i++) {
	                totalDist += nums[i - 1];
	              }
	              for (i = 1; i < xlen; i++) {
	                if (nums[i - 1] === 0) {
	                  nums[i - 1] = 1;
	                } else {
	                  nums[i - 1] = Math.round(totalDist / nums[i - 1]);
	                }
	              }
	              return nums;
	            };
	            proto.calcYnums = function(ylen) {
	              var i;
	              var nums = [];
	              for (i = 1; i < ylen; i++) {
	                var a = this.getYat(0, i - 1);
	                var b = this.getYat(0, i);
	                if (b !== a && a !== undefined && a !== null && b !== undefined && b !== null) {
	                  nums[i - 1] = Math.abs(b - a);
	                } else {
	                  nums[i - 1] = 0;
	                }
	              }
	              var totalDist = 0;
	              for (i = 1; i < ylen; i++) {
	                totalDist += nums[i - 1];
	              }
	              for (i = 1; i < ylen; i++) {
	                if (nums[i - 1] === 0) {
	                  nums[i - 1] = 1;
	                } else {
	                  nums[i - 1] = Math.round(totalDist / nums[i - 1]);
	                }
	              }
	              return nums;
	            };
	            var highlyComposites = [1, 2, 4, 6, 12, 24, 36, 48, 60, 120, 180, 240, 360, 720, 840, 1260];
	            var MIN_RESOLUTION = highlyComposites[9];
	            var MAX_RESOLUTION = highlyComposites[13];
	            proto.estimateScale = function(resSrc, axis) {
	              var nums = axis === 0 ? this.calcXnums(resSrc) : this.calcYnums(resSrc);
	              var resDst = 1 + arrayLCM(nums);
	              while (resDst < MIN_RESOLUTION) {
	                resDst *= 2;
	              }
	              while (resDst > MAX_RESOLUTION) {
	                resDst--;
	                resDst /= smallestDivisor(resDst);
	                resDst++;
	                if (resDst < MIN_RESOLUTION) {
	                  resDst = MAX_RESOLUTION;
	                }
	              }
	              var scale = Math.round(resDst / resSrc);
	              return scale > 1 ? scale : 1;
	            };
	            function fnHomography(out, inp, X) {
	              var w = X[8] + X[2] * inp[0] + X[5] * inp[1];
	              out[0] = (X[6] + X[0] * inp[0] + X[3] * inp[1]) / w;
	              out[1] = (X[7] + X[1] * inp[0] + X[4] * inp[1]) / w;
	              return out;
	            }
	            function homography(dest, src, X) {
	              warp(dest, src, fnHomography, X);
	              return dest;
	            }
	            function warp(dest, src, func, X) {
	              var warped = [0, 0];
	              var ni = dest.shape[0];
	              var nj = dest.shape[1];
	              for (var i = 0; i < ni; i++) {
	                for (var j = 0; j < nj; j++) {
	                  func(warped, [i, j], X);
	                  dest.set(i, j, ndarrayInterp2d(src, warped[0], warped[1]));
	                }
	              }
	              return dest;
	            }
	            proto.refineCoords = function(coords) {
	              var scaleW = this.dataScaleX;
	              var scaleH = this.dataScaleY;
	              var width = coords[0].shape[0];
	              var height = coords[0].shape[1];
	              var newWidth = Math.floor(coords[0].shape[0] * scaleW + 1) | 0;
	              var newHeight = Math.floor(coords[0].shape[1] * scaleH + 1) | 0;
	              var padWidth = 1 + width + 1;
	              var padHeight = 1 + height + 1;
	              var padImg = ndarray(new Float32Array(padWidth * padHeight), [padWidth, padHeight]);
	              var X = [1 / scaleW, 0, 0, 0, 1 / scaleH, 0, 0, 0, 1];
	              for (var i = 0; i < coords.length; ++i) {
	                this.surface.padField(padImg, coords[i]);
	                var scaledImg = ndarray(new Float32Array(newWidth * newHeight), [newWidth, newHeight]);
	                homography(scaledImg, padImg, X);
	                coords[i] = scaledImg;
	              }
	            };
	            function insertIfNewLevel(arr, newValue) {
	              var found = false;
	              for (var k = 0; k < arr.length; k++) {
	                if (newValue === arr[k]) {
	                  found = true;
	                  break;
	                }
	              }
	              if (found === false) arr.push(newValue);
	            }
	            proto.setContourLevels = function() {
	              var newLevels = [[], [], []];
	              var useNewLevels = [false, false, false];
	              var needsUpdate = false;
	              var i, j, value;
	              for (i = 0; i < 3; ++i) {
	                if (this.showContour[i]) {
	                  needsUpdate = true;
	                  if (this.contourSize[i] > 0 && this.contourStart[i] !== null && this.contourEnd[i] !== null && this.contourEnd[i] > this.contourStart[i]) {
	                    useNewLevels[i] = true;
	                    for (j = this.contourStart[i]; j < this.contourEnd[i]; j += this.contourSize[i]) {
	                      value = j * this.scene.dataScale[i];
	                      insertIfNewLevel(newLevels[i], value);
	                    }
	                  }
	                }
	              }
	              if (needsUpdate) {
	                var allLevels = [[], [], []];
	                for (i = 0; i < 3; ++i) {
	                  if (this.showContour[i]) {
	                    allLevels[i] = useNewLevels[i] ? newLevels[i] : this.scene.contourLevels[i];
	                  }
	                }
	                this.surface.update({
	                  levels: allLevels
	                });
	              }
	            };
	            proto.update = function(data) {
	              var scene = this.scene;
	              var sceneLayout = scene.fullSceneLayout;
	              var surface = this.surface;
	              var colormap = parseColorScale(data);
	              var scaleFactor = scene.dataScale;
	              var xlen = data.z[0].length;
	              var ylen = data._ylength;
	              var contourLevels = scene.contourLevels;
	              this.data = data;
	              var i, j, k, v;
	              var rawCoords = [];
	              for (i = 0; i < 3; i++) {
	                rawCoords[i] = [];
	                for (j = 0; j < xlen; j++) {
	                  rawCoords[i][j] = [];
	                }
	              }
	              for (j = 0; j < xlen; j++) {
	                for (k = 0; k < ylen; k++) {
	                  rawCoords[0][j][k] = this.getXat(j, k, data.xcalendar, sceneLayout.xaxis);
	                  rawCoords[1][j][k] = this.getYat(j, k, data.ycalendar, sceneLayout.yaxis);
	                  rawCoords[2][j][k] = this.getZat(j, k, data.zcalendar, sceneLayout.zaxis);
	                }
	              }
	              if (data.connectgaps) {
	                data._emptypoints = findEmpties(rawCoords[2]);
	                interp2d(rawCoords[2], data._emptypoints);
	                data._interpolatedZ = [];
	                for (j = 0; j < xlen; j++) {
	                  data._interpolatedZ[j] = [];
	                  for (k = 0; k < ylen; k++) {
	                    data._interpolatedZ[j][k] = rawCoords[2][j][k];
	                  }
	                }
	              }
	              for (i = 0; i < 3; i++) {
	                for (j = 0; j < xlen; j++) {
	                  for (k = 0; k < ylen; k++) {
	                    v = rawCoords[i][j][k];
	                    if (v === null || v === undefined) {
	                      rawCoords[i][j][k] = NaN;
	                    } else {
	                      v = rawCoords[i][j][k] *= scaleFactor[i];
	                    }
	                  }
	                }
	              }
	              for (i = 0; i < 3; i++) {
	                for (j = 0; j < xlen; j++) {
	                  for (k = 0; k < ylen; k++) {
	                    v = rawCoords[i][j][k];
	                    if (v !== null && v !== undefined) {
	                      if (this.minValues[i] > v) {
	                        this.minValues[i] = v;
	                      }
	                      if (this.maxValues[i] < v) {
	                        this.maxValues[i] = v;
	                      }
	                    }
	                  }
	                }
	              }
	              for (i = 0; i < 3; i++) {
	                this.objectOffset[i] = 0.5 * (this.minValues[i] + this.maxValues[i]);
	              }
	              for (i = 0; i < 3; i++) {
	                for (j = 0; j < xlen; j++) {
	                  for (k = 0; k < ylen; k++) {
	                    v = rawCoords[i][j][k];
	                    if (v !== null && v !== undefined) {
	                      rawCoords[i][j][k] -= this.objectOffset[i];
	                    }
	                  }
	                }
	              }
	              var coords = [ndarray(new Float32Array(xlen * ylen), [xlen, ylen]), ndarray(new Float32Array(xlen * ylen), [xlen, ylen]), ndarray(new Float32Array(xlen * ylen), [xlen, ylen])];
	              for (i = 0; i < 3; i++) {
	                for (j = 0; j < xlen; j++) {
	                  for (k = 0; k < ylen; k++) {
	                    coords[i].set(j, k, rawCoords[i][j][k]);
	                  }
	                }
	              }
	              rawCoords = [];
	              var params = {
	                colormap,
	                levels: [[], [], []],
	                showContour: [true, true, true],
	                showSurface: !data.hidesurface,
	                contourProject: [[false, false, false], [false, false, false], [false, false, false]],
	                contourWidth: [1, 1, 1],
	                contourColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
	                contourTint: [1, 1, 1],
	                dynamicColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
	                dynamicWidth: [1, 1, 1],
	                dynamicTint: [1, 1, 1],
	                opacityscale: data.opacityscale,
	                opacity: data.opacity
	              };
	              var cOpts = extractOpts(data);
	              params.intensityBounds = [cOpts.min, cOpts.max];
	              if (data.surfacecolor) {
	                var intensity = ndarray(new Float32Array(xlen * ylen), [xlen, ylen]);
	                for (j = 0; j < xlen; j++) {
	                  for (k = 0; k < ylen; k++) {
	                    intensity.set(j, k, data.surfacecolor[k][j]);
	                  }
	                }
	                coords.push(intensity);
	              } else {
	                params.intensityBounds[0] *= scaleFactor[2];
	                params.intensityBounds[1] *= scaleFactor[2];
	              }
	              if (MAX_RESOLUTION < coords[0].shape[0] || MAX_RESOLUTION < coords[0].shape[1]) {
	                this.refineData = false;
	              }
	              if (this.refineData === true) {
	                this.dataScaleX = this.estimateScale(coords[0].shape[0], 0);
	                this.dataScaleY = this.estimateScale(coords[0].shape[1], 1);
	                if (this.dataScaleX !== 1 || this.dataScaleY !== 1) {
	                  this.refineCoords(coords);
	                }
	              }
	              if (data.surfacecolor) {
	                params.intensity = coords.pop();
	              }
	              var highlightEnable = [true, true, true];
	              var axis = ["x", "y", "z"];
	              for (i = 0; i < 3; ++i) {
	                var contourParams = data.contours[axis[i]];
	                highlightEnable[i] = contourParams.highlight;
	                params.showContour[i] = contourParams.show || contourParams.highlight;
	                if (!params.showContour[i]) continue;
	                params.contourProject[i] = [contourParams.project.x, contourParams.project.y, contourParams.project.z];
	                if (contourParams.show) {
	                  this.showContour[i] = true;
	                  params.levels[i] = contourLevels[i];
	                  surface.highlightColor[i] = params.contourColor[i] = str2RgbaArray(contourParams.color);
	                  if (contourParams.usecolormap) {
	                    surface.highlightTint[i] = params.contourTint[i] = 0;
	                  } else {
	                    surface.highlightTint[i] = params.contourTint[i] = 1;
	                  }
	                  params.contourWidth[i] = contourParams.width;
	                  this.contourStart[i] = contourParams.start;
	                  this.contourEnd[i] = contourParams.end;
	                  this.contourSize[i] = contourParams.size;
	                } else {
	                  this.showContour[i] = false;
	                  this.contourStart[i] = null;
	                  this.contourEnd[i] = null;
	                  this.contourSize[i] = 0;
	                }
	                if (contourParams.highlight) {
	                  params.dynamicColor[i] = str2RgbaArray(contourParams.highlightcolor);
	                  params.dynamicWidth[i] = contourParams.highlightwidth;
	                }
	              }
	              if (isColormapCircular(colormap)) {
	                params.vertexColor = true;
	              }
	              params.objectOffset = this.objectOffset;
	              params.coords = coords;
	              surface.update(params);
	              surface.visible = data.visible;
	              surface.enableDynamic = highlightEnable;
	              surface.enableHighlight = highlightEnable;
	              surface.snapToData = true;
	              if ("lighting" in data) {
	                surface.ambientLight = data.lighting.ambient;
	                surface.diffuseLight = data.lighting.diffuse;
	                surface.specularLight = data.lighting.specular;
	                surface.roughness = data.lighting.roughness;
	                surface.fresnel = data.lighting.fresnel;
	              }
	              if ("lightposition" in data) {
	                surface.lightPosition = [data.lightposition.x, data.lightposition.y, data.lightposition.z];
	              }
	            };
	            proto.dispose = function() {
	              this.scene.glplot.remove(this.surface);
	              this.surface.dispose();
	            };
	            function createSurfaceTrace(scene, data) {
	              var gl2 = scene.glplot.gl;
	              var surface = createSurface({
	                gl: gl2
	              });
	              var result = new SurfaceTrace(scene, surface, data.uid);
	              surface._trace = result;
	              result.update(data);
	              scene.glplot.add(surface);
	              return result;
	            }
	            module2.exports = createSurfaceTrace;
	          }
	        ),
	        /***/
	        91831: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Registry = __webpack_require__2(73972);
	            var Lib = __webpack_require__2(71828);
	            var colorscaleDefaults = __webpack_require__2(1586);
	            var attributes = __webpack_require__2(54532);
	            var MIN = 0.1;
	            function createWave(n, minOpacity) {
	              var arr = [];
	              var steps = 32;
	              for (var i = 0; i < steps; i++) {
	                var u = i / (steps - 1);
	                var v = minOpacity + (1 - minOpacity) * (1 - Math.pow(Math.sin(n * u * Math.PI), 2));
	                arr.push([u, Math.max(0, Math.min(1, v))]);
	              }
	              return arr;
	            }
	            function isValidScaleArray(scl) {
	              var highestVal = 0;
	              if (!Array.isArray(scl) || scl.length < 2) return false;
	              if (!scl[0] || !scl[scl.length - 1]) return false;
	              if (+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
	              for (var i = 0; i < scl.length; i++) {
	                var si = scl[i];
	                if (si.length !== 2 || +si[0] < highestVal) {
	                  return false;
	                }
	                highestVal = +si[0];
	              }
	              return true;
	            }
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              var i, j;
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var x = coerce("x");
	              var y = coerce("y");
	              var z = coerce("z");
	              if (!z || !z.length || (x ? x.length < 1 : false) || (y ? y.length < 1 : false)) {
	                traceOut.visible = false;
	                return;
	              }
	              traceOut._xlength = Array.isArray(x) && Lib.isArrayOrTypedArray(x[0]) ? z.length : z[0].length;
	              traceOut._ylength = z.length;
	              var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleTraceDefaults");
	              handleCalendarDefaults(traceIn, traceOut, ["x", "y", "z"], layout);
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("zhoverformat");
	              ["lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lightposition.x", "lightposition.y", "lightposition.z", "hidesurface", "connectgaps", "opacity"].forEach(function(x2) {
	                coerce(x2);
	              });
	              var surfaceColor = coerce("surfacecolor");
	              var dims = ["x", "y", "z"];
	              for (i = 0; i < 3; ++i) {
	                var contourDim = "contours." + dims[i];
	                var show = coerce(contourDim + ".show");
	                var highlight = coerce(contourDim + ".highlight");
	                if (show || highlight) {
	                  for (j = 0; j < 3; ++j) {
	                    coerce(contourDim + ".project." + dims[j]);
	                  }
	                }
	                if (show) {
	                  coerce(contourDim + ".color");
	                  coerce(contourDim + ".width");
	                  coerce(contourDim + ".usecolormap");
	                }
	                if (highlight) {
	                  coerce(contourDim + ".highlightcolor");
	                  coerce(contourDim + ".highlightwidth");
	                }
	                coerce(contourDim + ".start");
	                coerce(contourDim + ".end");
	                coerce(contourDim + ".size");
	              }
	              if (!surfaceColor) {
	                mapLegacy(traceIn, "zmin", "cmin");
	                mapLegacy(traceIn, "zmax", "cmax");
	                mapLegacy(traceIn, "zauto", "cauto");
	              }
	              colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                prefix: "",
	                cLetter: "c"
	              });
	              opacityscaleDefaults(traceIn, traceOut, layout, coerce);
	              traceOut._length = null;
	            }
	            function opacityscaleDefaults(traceIn, traceOut, layout, coerce) {
	              var opacityscale = coerce("opacityscale");
	              if (opacityscale === "max") {
	                traceOut.opacityscale = [[0, MIN], [1, 1]];
	              } else if (opacityscale === "min") {
	                traceOut.opacityscale = [[0, 1], [1, MIN]];
	              } else if (opacityscale === "extremes") {
	                traceOut.opacityscale = createWave(1, MIN);
	              } else if (!isValidScaleArray(opacityscale)) {
	                traceOut.opacityscale = undefined;
	              }
	            }
	            function mapLegacy(traceIn, oldAttr, newAttr) {
	              if (oldAttr in traceIn && !(newAttr in traceIn)) {
	                traceIn[newAttr] = traceIn[oldAttr];
	              }
	            }
	            module2.exports = {
	              supplyDefaults,
	              opacityscaleDefaults
	            };
	          }
	        ),
	        /***/
	        93601: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(54532),
	              supplyDefaults: __webpack_require__2(91831).supplyDefaults,
	              colorbar: {
	                min: "cmin",
	                max: "cmax"
	              },
	              calc: __webpack_require__2(18396),
	              plot: __webpack_require__2(43768),
	              moduleType: "trace",
	              name: "surface",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "2dMap", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        44464: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var annAttrs = __webpack_require__2(50215);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var fontAttrs = __webpack_require__2(41940);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var descriptionOnlyNumbers = __webpack_require__2(12663).descriptionOnlyNumbers;
	            var attrs = module2.exports = overrideAll({
	              domain: domainAttrs({
	                name: "table",
	                trace: true
	              }),
	              columnwidth: {
	                valType: "number",
	                arrayOk: true,
	                dflt: null
	              },
	              columnorder: {
	                valType: "data_array"
	              },
	              header: {
	                values: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                format: {
	                  valType: "data_array",
	                  dflt: [],
	                  description: descriptionOnlyNumbers("cell value")
	                },
	                prefix: {
	                  valType: "string",
	                  arrayOk: true,
	                  dflt: null
	                },
	                suffix: {
	                  valType: "string",
	                  arrayOk: true,
	                  dflt: null
	                },
	                height: {
	                  valType: "number",
	                  dflt: 28
	                },
	                align: extendFlat({}, annAttrs.align, {
	                  arrayOk: true
	                }),
	                line: {
	                  width: {
	                    valType: "number",
	                    arrayOk: true,
	                    dflt: 1
	                  },
	                  color: {
	                    valType: "color",
	                    arrayOk: true,
	                    dflt: "grey"
	                  }
	                },
	                fill: {
	                  color: {
	                    valType: "color",
	                    arrayOk: true,
	                    dflt: "white"
	                  }
	                },
	                font: extendFlat({}, fontAttrs({
	                  arrayOk: true
	                }))
	              },
	              cells: {
	                values: {
	                  valType: "data_array",
	                  dflt: []
	                },
	                format: {
	                  valType: "data_array",
	                  dflt: [],
	                  description: descriptionOnlyNumbers("cell value")
	                },
	                prefix: {
	                  valType: "string",
	                  arrayOk: true,
	                  dflt: null
	                },
	                suffix: {
	                  valType: "string",
	                  arrayOk: true,
	                  dflt: null
	                },
	                height: {
	                  valType: "number",
	                  dflt: 20
	                },
	                align: extendFlat({}, annAttrs.align, {
	                  arrayOk: true
	                }),
	                line: {
	                  width: {
	                    valType: "number",
	                    arrayOk: true,
	                    dflt: 1
	                  },
	                  color: {
	                    valType: "color",
	                    arrayOk: true,
	                    dflt: "grey"
	                  }
	                },
	                fill: {
	                  color: {
	                    valType: "color",
	                    arrayOk: true,
	                    dflt: "white"
	                  }
	                },
	                font: extendFlat({}, fontAttrs({
	                  arrayOk: true
	                }))
	              }
	            }, "calc", "from-root");
	            attrs.transforms = undefined;
	          }
	        ),
	        /***/
	        99469: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var getModuleCalcData = __webpack_require__2(27659).a0;
	            var tablePlot = __webpack_require__2(36736);
	            var TABLE = "table";
	            exports2.name = TABLE;
	            exports2.plot = function(gd) {
	              var calcData = getModuleCalcData(gd.calcdata, TABLE)[0];
	              if (calcData.length) tablePlot(gd, calcData);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              var hadTable = oldFullLayout._has && oldFullLayout._has(TABLE);
	              var hasTable = newFullLayout._has && newFullLayout._has(TABLE);
	              if (hadTable && !hasTable) {
	                oldFullLayout._paperdiv.selectAll(".table").remove();
	              }
	            };
	          }
	        ),
	        /***/
	        76333: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var wrap = __webpack_require__2(28984).wrap;
	            module2.exports = function calc() {
	              return wrap({});
	            };
	          }
	        ),
	        /***/
	        49850: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              cellPad: 8,
	              columnExtentOffset: 10,
	              columnTitleOffset: 28,
	              emptyHeaderHeight: 16,
	              latexCheck: /^\$.*\$$/,
	              goldenRatio: 1.618,
	              lineBreaker: "<br>",
	              maxDimensionCount: 60,
	              overdrag: 45,
	              releaseTransitionDuration: 120,
	              releaseTransitionEase: "cubic-out",
	              scrollbarCaptureWidth: 18,
	              scrollbarHideDelay: 1e3,
	              scrollbarHideDuration: 1e3,
	              scrollbarOffset: 5,
	              scrollbarWidth: 8,
	              transitionDuration: 100,
	              transitionEase: "cubic-out",
	              uplift: 5,
	              wrapSpacer: " ",
	              wrapSplitCharacter: " ",
	              cn: {
	                // general class names
	                table: "table",
	                tableControlView: "table-control-view",
	                scrollBackground: "scroll-background",
	                yColumn: "y-column",
	                columnBlock: "column-block",
	                scrollAreaClip: "scroll-area-clip",
	                scrollAreaClipRect: "scroll-area-clip-rect",
	                columnBoundary: "column-boundary",
	                columnBoundaryClippath: "column-boundary-clippath",
	                columnBoundaryRect: "column-boundary-rect",
	                columnCells: "column-cells",
	                columnCell: "column-cell",
	                cellRect: "cell-rect",
	                cellText: "cell-text",
	                cellTextHolder: "cell-text-holder",
	                // scroll related class names
	                scrollbarKit: "scrollbar-kit",
	                scrollbar: "scrollbar",
	                scrollbarSlider: "scrollbar-slider",
	                scrollbarGlyph: "scrollbar-glyph",
	                scrollbarCaptureZone: "scrollbar-capture-zone"
	              }
	            };
	          }
	        ),
	        /***/
	        51018: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var c = __webpack_require__2(49850);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var isNumeric = __webpack_require__2(92770);
	            module2.exports = function calc(gd, trace) {
	              var cellsValues = squareStringMatrix(trace.cells.values);
	              var slicer = function(a) {
	                return a.slice(trace.header.values.length, a.length);
	              };
	              var headerValuesIn = squareStringMatrix(trace.header.values);
	              if (headerValuesIn.length && !headerValuesIn[0].length) {
	                headerValuesIn[0] = [""];
	                headerValuesIn = squareStringMatrix(headerValuesIn);
	              }
	              var headerValues = headerValuesIn.concat(slicer(cellsValues).map(function() {
	                return emptyStrings((headerValuesIn[0] || [""]).length);
	              }));
	              var domain = trace.domain;
	              var groupWidth = Math.floor(gd._fullLayout._size.w * (domain.x[1] - domain.x[0]));
	              var groupHeight = Math.floor(gd._fullLayout._size.h * (domain.y[1] - domain.y[0]));
	              var headerRowHeights = trace.header.values.length ? headerValues[0].map(function() {
	                return trace.header.height;
	              }) : [c.emptyHeaderHeight];
	              var rowHeights = cellsValues.length ? cellsValues[0].map(function() {
	                return trace.cells.height;
	              }) : [];
	              var headerHeight = headerRowHeights.reduce(sum, 0);
	              var scrollHeight = groupHeight - headerHeight;
	              var minimumFillHeight = scrollHeight + c.uplift;
	              var anchorToRowBlock = makeAnchorToRowBlock(rowHeights, minimumFillHeight);
	              var anchorToHeaderRowBlock = makeAnchorToRowBlock(headerRowHeights, headerHeight);
	              var headerRowBlocks = makeRowBlock(anchorToHeaderRowBlock, []);
	              var rowBlocks = makeRowBlock(anchorToRowBlock, headerRowBlocks);
	              var uniqueKeys = {};
	              var columnOrder = trace._fullInput.columnorder.concat(slicer(cellsValues.map(function(d, i) {
	                return i;
	              })));
	              var columnWidths = headerValues.map(function(d, i) {
	                var value = Array.isArray(trace.columnwidth) ? trace.columnwidth[Math.min(i, trace.columnwidth.length - 1)] : trace.columnwidth;
	                return isNumeric(value) ? Number(value) : 1;
	              });
	              var totalColumnWidths = columnWidths.reduce(sum, 0);
	              columnWidths = columnWidths.map(function(d) {
	                return d / totalColumnWidths * groupWidth;
	              });
	              var maxLineWidth = Math.max(arrayMax(trace.header.line.width), arrayMax(trace.cells.line.width));
	              var calcdata = {
	                // include staticPlot in the key so if it changes we delete and redraw
	                key: trace.uid + gd._context.staticPlot,
	                translateX: domain.x[0] * gd._fullLayout._size.w,
	                translateY: gd._fullLayout._size.h * (1 - domain.y[1]),
	                size: gd._fullLayout._size,
	                width: groupWidth,
	                maxLineWidth,
	                height: groupHeight,
	                columnOrder,
	                // will be mutated on column move, todo use in callback
	                groupHeight,
	                rowBlocks,
	                headerRowBlocks,
	                scrollY: 0,
	                // will be mutated on scroll
	                cells: extendFlat({}, trace.cells, {
	                  values: cellsValues
	                }),
	                headerCells: extendFlat({}, trace.header, {
	                  values: headerValues
	                }),
	                gdColumns: headerValues.map(function(d) {
	                  return d[0];
	                }),
	                gdColumnsOriginalOrder: headerValues.map(function(d) {
	                  return d[0];
	                }),
	                prevPages: [0, 0],
	                scrollbarState: {
	                  scrollbarScrollInProgress: false
	                },
	                columns: headerValues.map(function(label, i) {
	                  var foundKey = uniqueKeys[label];
	                  uniqueKeys[label] = (foundKey || 0) + 1;
	                  var key = label + "__" + uniqueKeys[label];
	                  return {
	                    key,
	                    label,
	                    specIndex: i,
	                    xIndex: columnOrder[i],
	                    xScale,
	                    x: undefined,
	                    // initialized below
	                    calcdata: undefined,
	                    // initialized below
	                    columnWidth: columnWidths[i]
	                  };
	                })
	              };
	              calcdata.columns.forEach(function(col) {
	                col.calcdata = calcdata;
	                col.x = xScale(col);
	              });
	              return calcdata;
	            };
	            function arrayMax(maybeArray) {
	              if (Array.isArray(maybeArray)) {
	                var max = 0;
	                for (var i = 0; i < maybeArray.length; i++) {
	                  max = Math.max(max, arrayMax(maybeArray[i]));
	                }
	                return max;
	              }
	              return maybeArray;
	            }
	            function sum(a, b) {
	              return a + b;
	            }
	            function squareStringMatrix(matrixIn) {
	              var matrix = matrixIn.slice();
	              var minLen = Infinity;
	              var maxLen = 0;
	              var i;
	              for (i = 0; i < matrix.length; i++) {
	                if (!Array.isArray(matrix[i])) matrix[i] = [matrix[i]];
	                minLen = Math.min(minLen, matrix[i].length);
	                maxLen = Math.max(maxLen, matrix[i].length);
	              }
	              if (minLen !== maxLen) {
	                for (i = 0; i < matrix.length; i++) {
	                  var padLen = maxLen - matrix[i].length;
	                  if (padLen) matrix[i] = matrix[i].concat(emptyStrings(padLen));
	                }
	              }
	              return matrix;
	            }
	            function emptyStrings(len) {
	              var padArray = new Array(len);
	              for (var j = 0; j < len; j++) padArray[j] = "";
	              return padArray;
	            }
	            function xScale(d) {
	              return d.calcdata.columns.reduce(function(prev, next) {
	                return next.xIndex < d.xIndex ? prev + next.columnWidth : prev;
	              }, 0);
	            }
	            function makeRowBlock(anchorToRowBlock, auxiliary) {
	              var blockAnchorKeys = Object.keys(anchorToRowBlock);
	              return blockAnchorKeys.map(function(k) {
	                return extendFlat({}, anchorToRowBlock[k], {
	                  auxiliaryBlocks: auxiliary
	                });
	              });
	            }
	            function makeAnchorToRowBlock(rowHeights, minimumFillHeight) {
	              var anchorToRowBlock = {};
	              var currentRowHeight;
	              var currentAnchor = 0;
	              var currentBlockHeight = 0;
	              var currentBlock = makeIdentity();
	              var currentFirstRowIndex = 0;
	              var blockCounter = 0;
	              for (var i = 0; i < rowHeights.length; i++) {
	                currentRowHeight = rowHeights[i];
	                currentBlock.rows.push({
	                  rowIndex: i,
	                  rowHeight: currentRowHeight
	                });
	                currentBlockHeight += currentRowHeight;
	                if (currentBlockHeight >= minimumFillHeight || i === rowHeights.length - 1) {
	                  anchorToRowBlock[currentAnchor] = currentBlock;
	                  currentBlock.key = blockCounter++;
	                  currentBlock.firstRowIndex = currentFirstRowIndex;
	                  currentBlock.lastRowIndex = i;
	                  currentBlock = makeIdentity();
	                  currentAnchor += currentBlockHeight;
	                  currentFirstRowIndex = i + 1;
	                  currentBlockHeight = 0;
	                }
	              }
	              return anchorToRowBlock;
	            }
	            function makeIdentity() {
	              return {
	                firstRowIndex: null,
	                lastRowIndex: null,
	                rows: []
	              };
	            }
	          }
	        ),
	        /***/
	        56269: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            exports2.splitToPanels = function(d) {
	              var prevPages = [0, 0];
	              var headerPanel = extendFlat({}, d, {
	                key: "header",
	                type: "header",
	                page: 0,
	                prevPages,
	                currentRepaint: [null, null],
	                dragHandle: true,
	                values: d.calcdata.headerCells.values[d.specIndex],
	                rowBlocks: d.calcdata.headerRowBlocks,
	                calcdata: extendFlat({}, d.calcdata, {
	                  cells: d.calcdata.headerCells
	                })
	              });
	              var revolverPanel1 = extendFlat({}, d, {
	                key: "cells1",
	                type: "cells",
	                page: 0,
	                prevPages,
	                currentRepaint: [null, null],
	                dragHandle: false,
	                values: d.calcdata.cells.values[d.specIndex],
	                rowBlocks: d.calcdata.rowBlocks
	              });
	              var revolverPanel2 = extendFlat({}, d, {
	                key: "cells2",
	                type: "cells",
	                page: 1,
	                prevPages,
	                currentRepaint: [null, null],
	                dragHandle: false,
	                values: d.calcdata.cells.values[d.specIndex],
	                rowBlocks: d.calcdata.rowBlocks
	              });
	              return [revolverPanel1, revolverPanel2, headerPanel];
	            };
	            exports2.splitToCells = function(d) {
	              var fromTo = rowFromTo(d);
	              return (d.values || []).slice(fromTo[0], fromTo[1]).map(function(v, i) {
	                var buster = typeof v === "string" && v.match(/[<$&> ]/) ? "_keybuster_" + Math.random() : "";
	                return {
	                  // keyWithinBlock: /*fromTo[0] + */i, // optimized future version - no busting
	                  // keyWithinBlock: fromTo[0] + i, // initial always-unoptimized version - janky scrolling with 5+ columns
	                  keyWithinBlock: i + buster,
	                  // current compromise: regular content is very fast; async content is possible
	                  key: fromTo[0] + i,
	                  column: d,
	                  calcdata: d.calcdata,
	                  page: d.page,
	                  rowBlocks: d.rowBlocks,
	                  value: v
	                };
	              });
	            };
	            function rowFromTo(d) {
	              var rowBlock = d.rowBlocks[d.page];
	              var rowFrom = rowBlock ? rowBlock.rows[0].rowIndex : 0;
	              var rowTo = rowBlock ? rowFrom + rowBlock.rows.length : 0;
	              return [rowFrom, rowTo];
	            }
	          }
	        ),
	        /***/
	        39754: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(44464);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            function defaultColumnOrder(traceOut, coerce) {
	              var specifiedColumnOrder = traceOut.columnorder || [];
	              var commonLength = traceOut.header.values.length;
	              var truncated = specifiedColumnOrder.slice(0, commonLength);
	              var sorted = truncated.slice().sort(function(a, b) {
	                return a - b;
	              });
	              var oneStepped = truncated.map(function(d) {
	                return sorted.indexOf(d);
	              });
	              for (var i = oneStepped.length; i < commonLength; i++) {
	                oneStepped.push(i);
	              }
	              coerce("columnorder", oneStepped);
	            }
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              handleDomainDefaults(traceOut, layout, coerce);
	              coerce("columnwidth");
	              coerce("header.values");
	              coerce("header.format");
	              coerce("header.align");
	              coerce("header.prefix");
	              coerce("header.suffix");
	              coerce("header.height");
	              coerce("header.line.width");
	              coerce("header.line.color");
	              coerce("header.fill.color");
	              Lib.coerceFont(coerce, "header.font", Lib.extendFlat({}, layout.font));
	              defaultColumnOrder(traceOut, coerce);
	              coerce("cells.values");
	              coerce("cells.format");
	              coerce("cells.align");
	              coerce("cells.prefix");
	              coerce("cells.suffix");
	              coerce("cells.height");
	              coerce("cells.line.width");
	              coerce("cells.line.color");
	              coerce("cells.fill.color");
	              Lib.coerceFont(coerce, "cells.font", Lib.extendFlat({}, layout.font));
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        96595: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(44464),
	              supplyDefaults: __webpack_require__2(39754),
	              calc: __webpack_require__2(76333),
	              plot: __webpack_require__2(36736),
	              moduleType: "trace",
	              name: "table",
	              basePlotModule: __webpack_require__2(99469),
	              categories: ["noOpacity"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        36736: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var c = __webpack_require__2(49850);
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var numberFormat = Lib.numberFormat;
	            var gup = __webpack_require__2(28984);
	            var Drawing = __webpack_require__2(91424);
	            var svgUtil = __webpack_require__2(63893);
	            var raiseToTop = __webpack_require__2(71828).raiseToTop;
	            var strTranslate = __webpack_require__2(71828).strTranslate;
	            var cancelEeaseColumn = __webpack_require__2(71828).cancelTransition;
	            var prepareData = __webpack_require__2(51018);
	            var splitData = __webpack_require__2(56269);
	            var Color = __webpack_require__2(7901);
	            module2.exports = function plot(gd, wrappedTraceHolders) {
	              var dynamic = !gd._context.staticPlot;
	              var table = gd._fullLayout._paper.selectAll("." + c.cn.table).data(wrappedTraceHolders.map(function(wrappedTraceHolder) {
	                var traceHolder = gup.unwrap(wrappedTraceHolder);
	                var trace = traceHolder.trace;
	                return prepareData(gd, trace);
	              }), gup.keyFun);
	              table.exit().remove();
	              table.enter().append("g").classed(c.cn.table, true).attr("overflow", "visible").style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("overflow", "visible").style("shape-rendering", "crispEdges").style("pointer-events", "all");
	              table.attr("width", function(d) {
	                return d.width + d.size.l + d.size.r;
	              }).attr("height", function(d) {
	                return d.height + d.size.t + d.size.b;
	              }).attr("transform", function(d) {
	                return strTranslate(d.translateX, d.translateY);
	              });
	              var tableControlView = table.selectAll("." + c.cn.tableControlView).data(gup.repeat, gup.keyFun);
	              var cvEnter = tableControlView.enter().append("g").classed(c.cn.tableControlView, true).style("box-sizing", "content-box");
	              if (dynamic) {
	                var wheelEvent = "onwheel" in document ? "wheel" : "mousewheel";
	                cvEnter.on("mousemove", function(d) {
	                  tableControlView.filter(function(dd) {
	                    return d === dd;
	                  }).call(renderScrollbarKit, gd);
	                }).on(wheelEvent, function(d) {
	                  if (d.scrollbarState.wheeling) return;
	                  d.scrollbarState.wheeling = true;
	                  var newY = d.scrollY + d3.event.deltaY;
	                  var noChange = makeDragRow(gd, tableControlView, null, newY)(d);
	                  if (!noChange) {
	                    d3.event.stopPropagation();
	                    d3.event.preventDefault();
	                  }
	                  d.scrollbarState.wheeling = false;
	                }).call(renderScrollbarKit, gd, true);
	              }
	              tableControlView.attr("transform", function(d) {
	                return strTranslate(d.size.l, d.size.t);
	              });
	              var scrollBackground = tableControlView.selectAll("." + c.cn.scrollBackground).data(gup.repeat, gup.keyFun);
	              scrollBackground.enter().append("rect").classed(c.cn.scrollBackground, true).attr("fill", "none");
	              scrollBackground.attr("width", function(d) {
	                return d.width;
	              }).attr("height", function(d) {
	                return d.height;
	              });
	              tableControlView.each(function(d) {
	                Drawing.setClipUrl(d3.select(this), scrollAreaBottomClipKey(gd, d), gd);
	              });
	              var yColumn = tableControlView.selectAll("." + c.cn.yColumn).data(function(vm) {
	                return vm.columns;
	              }, gup.keyFun);
	              yColumn.enter().append("g").classed(c.cn.yColumn, true);
	              yColumn.exit().remove();
	              yColumn.attr("transform", function(d) {
	                return strTranslate(d.x, 0);
	              });
	              if (dynamic) {
	                yColumn.call(d3.behavior.drag().origin(function(d) {
	                  var movedColumn = d3.select(this);
	                  easeColumn(movedColumn, d, -c.uplift);
	                  raiseToTop(this);
	                  d.calcdata.columnDragInProgress = true;
	                  renderScrollbarKit(tableControlView.filter(function(dd) {
	                    return d.calcdata.key === dd.key;
	                  }), gd);
	                  return d;
	                }).on("drag", function(d) {
	                  var movedColumn = d3.select(this);
	                  var getter = function(dd) {
	                    return (d === dd ? d3.event.x : dd.x) + dd.columnWidth / 2;
	                  };
	                  d.x = Math.max(-c.overdrag, Math.min(d.calcdata.width + c.overdrag - d.columnWidth, d3.event.x));
	                  var sortableColumns = flatData(yColumn).filter(function(dd) {
	                    return dd.calcdata.key === d.calcdata.key;
	                  });
	                  var newOrder = sortableColumns.sort(function(a, b) {
	                    return getter(a) - getter(b);
	                  });
	                  newOrder.forEach(function(dd, i) {
	                    dd.xIndex = i;
	                    dd.x = d === dd ? dd.x : dd.xScale(dd);
	                  });
	                  yColumn.filter(function(dd) {
	                    return d !== dd;
	                  }).transition().ease(c.transitionEase).duration(c.transitionDuration).attr("transform", function(d2) {
	                    return strTranslate(d2.x, 0);
	                  });
	                  movedColumn.call(cancelEeaseColumn).attr("transform", strTranslate(d.x, -c.uplift));
	                }).on("dragend", function(d) {
	                  var movedColumn = d3.select(this);
	                  var p = d.calcdata;
	                  d.x = d.xScale(d);
	                  d.calcdata.columnDragInProgress = false;
	                  easeColumn(movedColumn, d, 0);
	                  columnMoved(gd, p, p.columns.map(function(dd) {
	                    return dd.xIndex;
	                  }));
	                }));
	              }
	              yColumn.each(function(d) {
	                Drawing.setClipUrl(d3.select(this), columnBoundaryClipKey(gd, d), gd);
	              });
	              var columnBlock = yColumn.selectAll("." + c.cn.columnBlock).data(splitData.splitToPanels, gup.keyFun);
	              columnBlock.enter().append("g").classed(c.cn.columnBlock, true).attr("id", function(d) {
	                return d.key;
	              });
	              columnBlock.style("cursor", function(d) {
	                return d.dragHandle ? "ew-resize" : d.calcdata.scrollbarState.barWiggleRoom ? "ns-resize" : "default";
	              });
	              var headerColumnBlock = columnBlock.filter(headerBlock);
	              var cellsColumnBlock = columnBlock.filter(cellsBlock);
	              if (dynamic) {
	                cellsColumnBlock.call(d3.behavior.drag().origin(function(d) {
	                  d3.event.stopPropagation();
	                  return d;
	                }).on("drag", makeDragRow(gd, tableControlView, -1)).on("dragend", function() {
	                }));
	              }
	              renderColumnCellTree(gd, tableControlView, headerColumnBlock, columnBlock);
	              renderColumnCellTree(gd, tableControlView, cellsColumnBlock, columnBlock);
	              var scrollAreaClip = tableControlView.selectAll("." + c.cn.scrollAreaClip).data(gup.repeat, gup.keyFun);
	              scrollAreaClip.enter().append("clipPath").classed(c.cn.scrollAreaClip, true).attr("id", function(d) {
	                return scrollAreaBottomClipKey(gd, d);
	              });
	              var scrollAreaClipRect = scrollAreaClip.selectAll("." + c.cn.scrollAreaClipRect).data(gup.repeat, gup.keyFun);
	              scrollAreaClipRect.enter().append("rect").classed(c.cn.scrollAreaClipRect, true).attr("x", -c.overdrag).attr("y", -c.uplift).attr("fill", "none");
	              scrollAreaClipRect.attr("width", function(d) {
	                return d.width + 2 * c.overdrag;
	              }).attr("height", function(d) {
	                return d.height + c.uplift;
	              });
	              var columnBoundary = yColumn.selectAll("." + c.cn.columnBoundary).data(gup.repeat, gup.keyFun);
	              columnBoundary.enter().append("g").classed(c.cn.columnBoundary, true);
	              var columnBoundaryClippath = yColumn.selectAll("." + c.cn.columnBoundaryClippath).data(gup.repeat, gup.keyFun);
	              columnBoundaryClippath.enter().append("clipPath").classed(c.cn.columnBoundaryClippath, true);
	              columnBoundaryClippath.attr("id", function(d) {
	                return columnBoundaryClipKey(gd, d);
	              });
	              var columnBoundaryRect = columnBoundaryClippath.selectAll("." + c.cn.columnBoundaryRect).data(gup.repeat, gup.keyFun);
	              columnBoundaryRect.enter().append("rect").classed(c.cn.columnBoundaryRect, true).attr("fill", "none");
	              columnBoundaryRect.attr("width", function(d) {
	                return d.columnWidth + 2 * roundHalfWidth(d);
	              }).attr("height", function(d) {
	                return d.calcdata.height + 2 * roundHalfWidth(d) + c.uplift;
	              }).attr("x", function(d) {
	                return -roundHalfWidth(d);
	              }).attr("y", function(d) {
	                return -roundHalfWidth(d);
	              });
	              updateBlockYPosition(null, cellsColumnBlock, tableControlView);
	            };
	            function roundHalfWidth(d) {
	              return Math.ceil(d.calcdata.maxLineWidth / 2);
	            }
	            function scrollAreaBottomClipKey(gd, d) {
	              return "clip" + gd._fullLayout._uid + "_scrollAreaBottomClip_" + d.key;
	            }
	            function columnBoundaryClipKey(gd, d) {
	              return "clip" + gd._fullLayout._uid + "_columnBoundaryClippath_" + d.calcdata.key + "_" + d.specIndex;
	            }
	            function flatData(selection) {
	              return [].concat.apply([], selection.map(function(g) {
	                return g;
	              })).map(function(g) {
	                return g.__data__;
	              });
	            }
	            function renderScrollbarKit(tableControlView, gd, bypassVisibleBar) {
	              function calcTotalHeight(d) {
	                var blocks = d.rowBlocks;
	                return firstRowAnchor(blocks, blocks.length - 1) + (blocks.length ? rowsHeight(blocks[blocks.length - 1], Infinity) : 1);
	              }
	              var scrollbarKit = tableControlView.selectAll("." + c.cn.scrollbarKit).data(gup.repeat, gup.keyFun);
	              scrollbarKit.enter().append("g").classed(c.cn.scrollbarKit, true).style("shape-rendering", "geometricPrecision");
	              scrollbarKit.each(function(d) {
	                var s = d.scrollbarState;
	                s.totalHeight = calcTotalHeight(d);
	                s.scrollableAreaHeight = d.groupHeight - headerHeight(d);
	                s.currentlyVisibleHeight = Math.min(s.totalHeight, s.scrollableAreaHeight);
	                s.ratio = s.currentlyVisibleHeight / s.totalHeight;
	                s.barLength = Math.max(s.ratio * s.currentlyVisibleHeight, c.goldenRatio * c.scrollbarWidth);
	                s.barWiggleRoom = s.currentlyVisibleHeight - s.barLength;
	                s.wiggleRoom = Math.max(0, s.totalHeight - s.scrollableAreaHeight);
	                s.topY = s.barWiggleRoom === 0 ? 0 : d.scrollY / s.wiggleRoom * s.barWiggleRoom;
	                s.bottomY = s.topY + s.barLength;
	                s.dragMultiplier = s.wiggleRoom / s.barWiggleRoom;
	              }).attr("transform", function(d) {
	                var xPosition2 = d.width + c.scrollbarWidth / 2 + c.scrollbarOffset;
	                return strTranslate(xPosition2, headerHeight(d));
	              });
	              var scrollbar = scrollbarKit.selectAll("." + c.cn.scrollbar).data(gup.repeat, gup.keyFun);
	              scrollbar.enter().append("g").classed(c.cn.scrollbar, true);
	              var scrollbarSlider = scrollbar.selectAll("." + c.cn.scrollbarSlider).data(gup.repeat, gup.keyFun);
	              scrollbarSlider.enter().append("g").classed(c.cn.scrollbarSlider, true);
	              scrollbarSlider.attr("transform", function(d) {
	                return strTranslate(0, d.scrollbarState.topY || 0);
	              });
	              var scrollbarGlyph = scrollbarSlider.selectAll("." + c.cn.scrollbarGlyph).data(gup.repeat, gup.keyFun);
	              scrollbarGlyph.enter().append("line").classed(c.cn.scrollbarGlyph, true).attr("stroke", "black").attr("stroke-width", c.scrollbarWidth).attr("stroke-linecap", "round").attr("y1", c.scrollbarWidth / 2);
	              scrollbarGlyph.attr("y2", function(d) {
	                return d.scrollbarState.barLength - c.scrollbarWidth / 2;
	              }).attr("stroke-opacity", function(d) {
	                return d.columnDragInProgress || !d.scrollbarState.barWiggleRoom || bypassVisibleBar ? 0 : 0.4;
	              });
	              scrollbarGlyph.transition().delay(0).duration(0);
	              scrollbarGlyph.transition().delay(c.scrollbarHideDelay).duration(c.scrollbarHideDuration).attr("stroke-opacity", 0);
	              var scrollbarCaptureZone = scrollbar.selectAll("." + c.cn.scrollbarCaptureZone).data(gup.repeat, gup.keyFun);
	              scrollbarCaptureZone.enter().append("line").classed(c.cn.scrollbarCaptureZone, true).attr("stroke", "white").attr("stroke-opacity", 0.01).attr("stroke-width", c.scrollbarCaptureWidth).attr("stroke-linecap", "butt").attr("y1", 0).on("mousedown", function(d) {
	                var y = d3.event.y;
	                var bbox = this.getBoundingClientRect();
	                var s = d.scrollbarState;
	                var pixelVal = y - bbox.top;
	                var inverseScale = d3.scale.linear().domain([0, s.scrollableAreaHeight]).range([0, s.totalHeight]).clamp(true);
	                if (!(s.topY <= pixelVal && pixelVal <= s.bottomY)) {
	                  makeDragRow(gd, tableControlView, null, inverseScale(pixelVal - s.barLength / 2))(d);
	                }
	              }).call(d3.behavior.drag().origin(function(d) {
	                d3.event.stopPropagation();
	                d.scrollbarState.scrollbarScrollInProgress = true;
	                return d;
	              }).on("drag", makeDragRow(gd, tableControlView)).on("dragend", function() {
	              }));
	              scrollbarCaptureZone.attr("y2", function(d) {
	                return d.scrollbarState.scrollableAreaHeight;
	              });
	              if (gd._context.staticPlot) {
	                scrollbarGlyph.remove();
	                scrollbarCaptureZone.remove();
	              }
	            }
	            function renderColumnCellTree(gd, tableControlView, columnBlock, allColumnBlock) {
	              var columnCells = renderColumnCells(columnBlock);
	              var columnCell = renderColumnCell(columnCells);
	              supplyStylingValues(columnCell);
	              var cellRect = renderCellRect(columnCell);
	              sizeAndStyleRect(cellRect);
	              var cellTextHolder = renderCellTextHolder(columnCell);
	              var cellText = renderCellText(cellTextHolder);
	              setFont(cellText);
	              populateCellText(cellText, tableControlView, allColumnBlock, gd);
	              setCellHeightAndPositionY(columnCell);
	            }
	            function renderColumnCells(columnBlock) {
	              var columnCells = columnBlock.selectAll("." + c.cn.columnCells).data(gup.repeat, gup.keyFun);
	              columnCells.enter().append("g").classed(c.cn.columnCells, true);
	              columnCells.exit().remove();
	              return columnCells;
	            }
	            function renderColumnCell(columnCells) {
	              var columnCell = columnCells.selectAll("." + c.cn.columnCell).data(splitData.splitToCells, function(d) {
	                return d.keyWithinBlock;
	              });
	              columnCell.enter().append("g").classed(c.cn.columnCell, true);
	              columnCell.exit().remove();
	              return columnCell;
	            }
	            function renderCellRect(columnCell) {
	              var cellRect = columnCell.selectAll("." + c.cn.cellRect).data(gup.repeat, function(d) {
	                return d.keyWithinBlock;
	              });
	              cellRect.enter().append("rect").classed(c.cn.cellRect, true);
	              return cellRect;
	            }
	            function renderCellText(cellTextHolder) {
	              var cellText = cellTextHolder.selectAll("." + c.cn.cellText).data(gup.repeat, function(d) {
	                return d.keyWithinBlock;
	              });
	              cellText.enter().append("text").classed(c.cn.cellText, true).style("cursor", function() {
	                return "auto";
	              }).on("mousedown", function() {
	                d3.event.stopPropagation();
	              });
	              return cellText;
	            }
	            function renderCellTextHolder(columnCell) {
	              var cellTextHolder = columnCell.selectAll("." + c.cn.cellTextHolder).data(gup.repeat, function(d) {
	                return d.keyWithinBlock;
	              });
	              cellTextHolder.enter().append("g").classed(c.cn.cellTextHolder, true).style("shape-rendering", "geometricPrecision");
	              return cellTextHolder;
	            }
	            function supplyStylingValues(columnCell) {
	              columnCell.each(function(d, i) {
	                var spec = d.calcdata.cells.font;
	                var col = d.column.specIndex;
	                var font = {
	                  size: gridPick(spec.size, col, i),
	                  color: gridPick(spec.color, col, i),
	                  family: gridPick(spec.family, col, i)
	                };
	                d.rowNumber = d.key;
	                d.align = gridPick(d.calcdata.cells.align, col, i);
	                d.cellBorderWidth = gridPick(d.calcdata.cells.line.width, col, i);
	                d.font = font;
	              });
	            }
	            function setFont(cellText) {
	              cellText.each(function(d) {
	                Drawing.font(d3.select(this), d.font);
	              });
	            }
	            function sizeAndStyleRect(cellRect) {
	              cellRect.attr("width", function(d) {
	                return d.column.columnWidth;
	              }).attr("stroke-width", function(d) {
	                return d.cellBorderWidth;
	              }).each(function(d) {
	                var atomicSelection = d3.select(this);
	                Color.stroke(atomicSelection, gridPick(d.calcdata.cells.line.color, d.column.specIndex, d.rowNumber));
	                Color.fill(atomicSelection, gridPick(d.calcdata.cells.fill.color, d.column.specIndex, d.rowNumber));
	              });
	            }
	            function populateCellText(cellText, tableControlView, allColumnBlock, gd) {
	              cellText.text(function(d) {
	                var col = d.column.specIndex;
	                var row = d.rowNumber;
	                var userSuppliedContent = d.value;
	                var stringSupplied = typeof userSuppliedContent === "string";
	                var hasBreaks = stringSupplied && userSuppliedContent.match(/<br>/i);
	                var userBrokenText = !stringSupplied || hasBreaks;
	                d.mayHaveMarkup = stringSupplied && userSuppliedContent.match(/[<&>]/);
	                var latex = isLatex(userSuppliedContent);
	                d.latex = latex;
	                var prefix = latex ? "" : gridPick(d.calcdata.cells.prefix, col, row) || "";
	                var suffix = latex ? "" : gridPick(d.calcdata.cells.suffix, col, row) || "";
	                var format = latex ? null : gridPick(d.calcdata.cells.format, col, row) || null;
	                var prefixSuffixedText = prefix + (format ? numberFormat(format)(d.value) : d.value) + suffix;
	                var hasWrapSplitCharacter;
	                d.wrappingNeeded = !d.wrapped && !userBrokenText && !latex && (hasWrapSplitCharacter = hasWrapCharacter(prefixSuffixedText));
	                d.cellHeightMayIncrease = hasBreaks || latex || d.mayHaveMarkup || (hasWrapSplitCharacter === undefined ? hasWrapCharacter(prefixSuffixedText) : hasWrapSplitCharacter);
	                d.needsConvertToTspans = d.mayHaveMarkup || d.wrappingNeeded || d.latex;
	                var textToRender;
	                if (d.wrappingNeeded) {
	                  var hrefPreservedText = c.wrapSplitCharacter === " " ? prefixSuffixedText.replace(/<a href=/ig, "<a_href=") : prefixSuffixedText;
	                  var fragments = hrefPreservedText.split(c.wrapSplitCharacter);
	                  var hrefRestoredFragments = c.wrapSplitCharacter === " " ? fragments.map(function(frag) {
	                    return frag.replace(/<a_href=/ig, "<a href=");
	                  }) : fragments;
	                  d.fragments = hrefRestoredFragments.map(function(f) {
	                    return {
	                      text: f,
	                      width: null
	                    };
	                  });
	                  d.fragments.push({
	                    fragment: c.wrapSpacer,
	                    width: null
	                  });
	                  textToRender = hrefRestoredFragments.join(c.lineBreaker) + c.lineBreaker + c.wrapSpacer;
	                } else {
	                  delete d.fragments;
	                  textToRender = prefixSuffixedText;
	                }
	                return textToRender;
	              }).attr("dy", function(d) {
	                return d.needsConvertToTspans ? 0 : "0.75em";
	              }).each(function(d) {
	                var element = this;
	                var selection = d3.select(element);
	                var renderCallback = d.wrappingNeeded ? wrapTextMaker : updateYPositionMaker;
	                if (d.needsConvertToTspans) {
	                  svgUtil.convertToTspans(selection, gd, renderCallback(allColumnBlock, element, tableControlView, gd, d));
	                } else {
	                  d3.select(element.parentNode).attr("transform", function(d2) {
	                    return strTranslate(xPosition(d2), c.cellPad);
	                  }).attr("text-anchor", function(d2) {
	                    return {
	                      left: "start",
	                      center: "middle",
	                      right: "end"
	                    }[d2.align];
	                  });
	                }
	              });
	            }
	            function isLatex(content) {
	              return typeof content === "string" && content.match(c.latexCheck);
	            }
	            function hasWrapCharacter(text) {
	              return text.indexOf(c.wrapSplitCharacter) !== -1;
	            }
	            function columnMoved(gd, calcdata, indices) {
	              var o = calcdata.gdColumnsOriginalOrder;
	              calcdata.gdColumns.sort(function(a, b) {
	                return indices[o.indexOf(a)] - indices[o.indexOf(b)];
	              });
	              calcdata.columnorder = indices;
	              gd.emit("plotly_restyle");
	            }
	            function gridPick(spec, col, row) {
	              if (Array.isArray(spec)) {
	                var column = spec[Math.min(col, spec.length - 1)];
	                if (Array.isArray(column)) {
	                  return column[Math.min(row, column.length - 1)];
	                } else {
	                  return column;
	                }
	              } else {
	                return spec;
	              }
	            }
	            function easeColumn(selection, d, y) {
	              selection.transition().ease(c.releaseTransitionEase).duration(c.releaseTransitionDuration).attr("transform", strTranslate(d.x, y));
	            }
	            function cellsBlock(d) {
	              return d.type === "cells";
	            }
	            function headerBlock(d) {
	              return d.type === "header";
	            }
	            function headerHeight(d) {
	              var headerBlocks = d.rowBlocks.length ? d.rowBlocks[0].auxiliaryBlocks : [];
	              return headerBlocks.reduce(function(p, n) {
	                return p + rowsHeight(n, Infinity);
	              }, 0);
	            }
	            function findPagesAndCacheHeights(blocks, scrollY, scrollHeight) {
	              var pages = [];
	              var pTop = 0;
	              for (var blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
	                var block = blocks[blockIndex];
	                var blockRows = block.rows;
	                var rowsHeight2 = 0;
	                for (var i = 0; i < blockRows.length; i++) {
	                  rowsHeight2 += blockRows[i].rowHeight;
	                }
	                block.allRowsHeight = rowsHeight2;
	                var pBottom = pTop + rowsHeight2;
	                var windowTop = scrollY;
	                var windowBottom = windowTop + scrollHeight;
	                if (windowTop < pBottom && windowBottom > pTop) {
	                  pages.push(blockIndex);
	                }
	                pTop += rowsHeight2;
	              }
	              return pages;
	            }
	            function updateBlockYPosition(gd, cellsColumnBlock, tableControlView) {
	              var d = flatData(cellsColumnBlock)[0];
	              if (d === undefined) return;
	              var blocks = d.rowBlocks;
	              var calcdata = d.calcdata;
	              var bottom = firstRowAnchor(blocks, blocks.length);
	              var scrollHeight = d.calcdata.groupHeight - headerHeight(d);
	              var scrollY = calcdata.scrollY = Math.max(0, Math.min(bottom - scrollHeight, calcdata.scrollY));
	              var pages = findPagesAndCacheHeights(blocks, scrollY, scrollHeight);
	              if (pages.length === 1) {
	                if (pages[0] === blocks.length - 1) {
	                  pages.unshift(pages[0] - 1);
	                } else {
	                  pages.push(pages[0] + 1);
	                }
	              }
	              if (pages[0] % 2) {
	                pages.reverse();
	              }
	              cellsColumnBlock.each(function(d2, i) {
	                d2.page = pages[i];
	                d2.scrollY = scrollY;
	              });
	              cellsColumnBlock.attr("transform", function(d2) {
	                var yTranslate = firstRowAnchor(d2.rowBlocks, d2.page) - d2.scrollY;
	                return strTranslate(0, yTranslate);
	              });
	              if (gd) {
	                conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 0);
	                conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 1);
	                renderScrollbarKit(tableControlView, gd);
	              }
	            }
	            function makeDragRow(gd, allTableControlView, optionalMultiplier, optionalPosition) {
	              return function dragRow(eventD) {
	                var d = eventD.calcdata ? eventD.calcdata : eventD;
	                var tableControlView = allTableControlView.filter(function(dd) {
	                  return d.key === dd.key;
	                });
	                var multiplier = optionalMultiplier || d.scrollbarState.dragMultiplier;
	                var initialScrollY = d.scrollY;
	                d.scrollY = optionalPosition === undefined ? d.scrollY + multiplier * d3.event.dy : optionalPosition;
	                var cellsColumnBlock = tableControlView.selectAll("." + c.cn.yColumn).selectAll("." + c.cn.columnBlock).filter(cellsBlock);
	                updateBlockYPosition(gd, cellsColumnBlock, tableControlView);
	                return d.scrollY === initialScrollY;
	              };
	            }
	            function conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, prevPages, d, revolverIndex) {
	              var shouldComponentUpdate = pages[revolverIndex] !== prevPages[revolverIndex];
	              if (shouldComponentUpdate) {
	                clearTimeout(d.currentRepaint[revolverIndex]);
	                d.currentRepaint[revolverIndex] = setTimeout(function() {
	                  var toRerender = cellsColumnBlock.filter(function(d2, i) {
	                    return i === revolverIndex && pages[i] !== prevPages[i];
	                  });
	                  renderColumnCellTree(gd, tableControlView, toRerender, cellsColumnBlock);
	                  prevPages[revolverIndex] = pages[revolverIndex];
	                });
	              }
	            }
	            function wrapTextMaker(columnBlock, element, tableControlView, gd) {
	              return function wrapText() {
	                var cellTextHolder = d3.select(element.parentNode);
	                cellTextHolder.each(function(d) {
	                  var fragments = d.fragments;
	                  cellTextHolder.selectAll("tspan.line").each(function(dd, i) {
	                    fragments[i].width = this.getComputedTextLength();
	                  });
	                  var separatorLength = fragments[fragments.length - 1].width;
	                  var rest = fragments.slice(0, -1);
	                  var currentRow = [];
	                  var currentAddition, currentAdditionLength;
	                  var currentRowLength = 0;
	                  var rowLengthLimit = d.column.columnWidth - 2 * c.cellPad;
	                  d.value = "";
	                  while (rest.length) {
	                    currentAddition = rest.shift();
	                    currentAdditionLength = currentAddition.width + separatorLength;
	                    if (currentRowLength + currentAdditionLength > rowLengthLimit) {
	                      d.value += currentRow.join(c.wrapSpacer) + c.lineBreaker;
	                      currentRow = [];
	                      currentRowLength = 0;
	                    }
	                    currentRow.push(currentAddition.text);
	                    currentRowLength += currentAdditionLength;
	                  }
	                  if (currentRowLength) {
	                    d.value += currentRow.join(c.wrapSpacer);
	                  }
	                  d.wrapped = true;
	                });
	                cellTextHolder.selectAll("tspan.line").remove();
	                populateCellText(cellTextHolder.select("." + c.cn.cellText), tableControlView, columnBlock, gd);
	                d3.select(element.parentNode.parentNode).call(setCellHeightAndPositionY);
	              };
	            }
	            function updateYPositionMaker(columnBlock, element, tableControlView, gd, d) {
	              return function updateYPosition() {
	                if (d.settledY) return;
	                var cellTextHolder = d3.select(element.parentNode);
	                var l = getBlock(d);
	                var rowIndex = d.key - l.firstRowIndex;
	                var declaredRowHeight = l.rows[rowIndex].rowHeight;
	                var requiredHeight = d.cellHeightMayIncrease ? element.parentNode.getBoundingClientRect().height + 2 * c.cellPad : declaredRowHeight;
	                var finalHeight = Math.max(requiredHeight, declaredRowHeight);
	                var increase = finalHeight - l.rows[rowIndex].rowHeight;
	                if (increase) {
	                  l.rows[rowIndex].rowHeight = finalHeight;
	                  columnBlock.selectAll("." + c.cn.columnCell).call(setCellHeightAndPositionY);
	                  updateBlockYPosition(null, columnBlock.filter(cellsBlock), 0);
	                  renderScrollbarKit(tableControlView, gd, true);
	                }
	                cellTextHolder.attr("transform", function() {
	                  var element2 = this;
	                  var columnCellElement = element2.parentNode;
	                  var box = columnCellElement.getBoundingClientRect();
	                  var rectBox = d3.select(element2.parentNode).select("." + c.cn.cellRect).node().getBoundingClientRect();
	                  var currentTransform = element2.transform.baseVal.consolidate();
	                  var yPosition = rectBox.top - box.top + (currentTransform ? currentTransform.matrix.f : c.cellPad);
	                  return strTranslate(xPosition(d, d3.select(element2.parentNode).select("." + c.cn.cellTextHolder).node().getBoundingClientRect().width), yPosition);
	                });
	                d.settledY = true;
	              };
	            }
	            function xPosition(d, optionalWidth) {
	              switch (d.align) {
	                case "left":
	                  return c.cellPad;
	                case "right":
	                  return d.column.columnWidth - (optionalWidth || 0) - c.cellPad;
	                case "center":
	                  return (d.column.columnWidth - (optionalWidth || 0)) / 2;
	                default:
	                  return c.cellPad;
	              }
	            }
	            function setCellHeightAndPositionY(columnCell) {
	              columnCell.attr("transform", function(d) {
	                var headerHeight2 = d.rowBlocks[0].auxiliaryBlocks.reduce(function(p, n) {
	                  return p + rowsHeight(n, Infinity);
	                }, 0);
	                var l = getBlock(d);
	                var rowAnchor = rowsHeight(l, d.key);
	                var yOffset = rowAnchor + headerHeight2;
	                return strTranslate(0, yOffset);
	              }).selectAll("." + c.cn.cellRect).attr("height", function(d) {
	                return getRow(getBlock(d), d.key).rowHeight;
	              });
	            }
	            function firstRowAnchor(blocks, page) {
	              var total = 0;
	              for (var i = page - 1; i >= 0; i--) {
	                total += allRowsHeight(blocks[i]);
	              }
	              return total;
	            }
	            function rowsHeight(rowBlock, key) {
	              var total = 0;
	              for (var i = 0; i < rowBlock.rows.length && rowBlock.rows[i].rowIndex < key; i++) {
	                total += rowBlock.rows[i].rowHeight;
	              }
	              return total;
	            }
	            function allRowsHeight(rowBlock) {
	              var cached = rowBlock.allRowsHeight;
	              if (cached !== undefined) {
	                return cached;
	              }
	              var total = 0;
	              for (var i = 0; i < rowBlock.rows.length; i++) {
	                total += rowBlock.rows[i].rowHeight;
	              }
	              rowBlock.allRowsHeight = total;
	              return total;
	            }
	            function getBlock(d) {
	              return d.rowBlocks[d.page];
	            }
	            function getRow(l, i) {
	              return l.rows[i - l.firstRowIndex];
	            }
	          }
	        ),
	        /***/
	        45802: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var domainAttrs = __webpack_require__2(27670).Y;
	            var pieAttrs = __webpack_require__2(34e3);
	            var sunburstAttrs = __webpack_require__2(57564);
	            var constants = __webpack_require__2(43473);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var pattern = __webpack_require__2(79952).u;
	            module2.exports = {
	              labels: sunburstAttrs.labels,
	              parents: sunburstAttrs.parents,
	              values: sunburstAttrs.values,
	              branchvalues: sunburstAttrs.branchvalues,
	              count: sunburstAttrs.count,
	              level: sunburstAttrs.level,
	              maxdepth: sunburstAttrs.maxdepth,
	              tiling: {
	                packing: {
	                  valType: "enumerated",
	                  values: ["squarify", "binary", "dice", "slice", "slice-dice", "dice-slice"],
	                  dflt: "squarify",
	                  editType: "plot"
	                },
	                squarifyratio: {
	                  valType: "number",
	                  min: 1,
	                  dflt: 1,
	                  editType: "plot"
	                },
	                flip: {
	                  valType: "flaglist",
	                  flags: ["x", "y"],
	                  dflt: "",
	                  editType: "plot"
	                },
	                pad: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 3,
	                  editType: "plot"
	                },
	                editType: "calc"
	              },
	              marker: extendFlat({
	                pad: {
	                  t: {
	                    valType: "number",
	                    min: 0,
	                    editType: "plot"
	                  },
	                  l: {
	                    valType: "number",
	                    min: 0,
	                    editType: "plot"
	                  },
	                  r: {
	                    valType: "number",
	                    min: 0,
	                    editType: "plot"
	                  },
	                  b: {
	                    valType: "number",
	                    min: 0,
	                    editType: "plot"
	                  },
	                  editType: "calc"
	                },
	                colors: sunburstAttrs.marker.colors,
	                pattern,
	                depthfade: {
	                  valType: "enumerated",
	                  values: [true, false, "reversed"],
	                  editType: "style"
	                },
	                line: sunburstAttrs.marker.line,
	                cornerradius: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 0,
	                  editType: "plot"
	                },
	                editType: "calc"
	              }, colorScaleAttrs("marker", {
	                colorAttr: "colors",
	                anim: false
	                // TODO: set to anim: true?
	              })),
	              pathbar: {
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                side: {
	                  valType: "enumerated",
	                  values: ["top", "bottom"],
	                  dflt: "top",
	                  editType: "plot"
	                },
	                edgeshape: {
	                  valType: "enumerated",
	                  values: [">", "<", "|", "/", "\\"],
	                  dflt: ">",
	                  editType: "plot"
	                },
	                thickness: {
	                  valType: "number",
	                  min: 12,
	                  editType: "plot"
	                },
	                textfont: extendFlat({}, pieAttrs.textfont, {}),
	                editType: "calc"
	              },
	              text: pieAttrs.text,
	              textinfo: sunburstAttrs.textinfo,
	              // TODO: incorporate `label` and `value` in the eventData
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: constants.eventDataKeys.concat(["label", "value"])
	              }),
	              hovertext: pieAttrs.hovertext,
	              hoverinfo: sunburstAttrs.hoverinfo,
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              textfont: pieAttrs.textfont,
	              insidetextfont: pieAttrs.insidetextfont,
	              outsidetextfont: extendFlat({}, pieAttrs.outsidetextfont, {}),
	              textposition: {
	                valType: "enumerated",
	                values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
	                dflt: "top left",
	                editType: "plot"
	              },
	              sort: pieAttrs.sort,
	              root: sunburstAttrs.root,
	              domain: domainAttrs({
	                name: "treemap",
	                trace: true,
	                editType: "calc"
	              })
	            };
	          }
	        ),
	        /***/
	        78018: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var plots = __webpack_require__2(74875);
	            exports2.name = "treemap";
	            exports2.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
	              plots.plotBasePlot(exports2.name, gd, traces, transitionOpts, makeOnCompleteCallback);
	            };
	            exports2.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
	              plots.cleanBasePlot(exports2.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
	            };
	          }
	        ),
	        /***/
	        65039: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var calc = __webpack_require__2(52147);
	            exports2.y = function(gd, trace) {
	              return calc.calc(gd, trace);
	            };
	            exports2.T = function(gd) {
	              return calc._runCrossTraceCalc("treemap", gd);
	            };
	          }
	        ),
	        /***/
	        43473: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              CLICK_TRANSITION_TIME: 750,
	              CLICK_TRANSITION_EASING: "poly",
	              eventDataKeys: [
	                // string
	                "currentPath",
	                "root",
	                "entry",
	                // no need to add 'parent' here
	                // percentages i.e. ratios
	                "percentRoot",
	                "percentEntry",
	                "percentParent"
	              ],
	              gapWithPathbar: 1
	              // i.e. one pixel
	            };
	          }
	        ),
	        /***/
	        91174: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(45802);
	            var Color = __webpack_require__2(7901);
	            var handleDomainDefaults = __webpack_require__2(27670).c;
	            var handleText = __webpack_require__2(90769).handleText;
	            var TEXTPAD = __webpack_require__2(97313).TEXTPAD;
	            var handleMarkerDefaults = __webpack_require__2(37434).handleMarkerDefaults;
	            var Colorscale = __webpack_require__2(21081);
	            var hasColorscale = Colorscale.hasColorscale;
	            var colorscaleDefaults = Colorscale.handleDefaults;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var labels = coerce("labels");
	              var parents = coerce("parents");
	              if (!labels || !labels.length || !parents || !parents.length) {
	                traceOut.visible = false;
	                return;
	              }
	              var vals = coerce("values");
	              if (vals && vals.length) {
	                coerce("branchvalues");
	              } else {
	                coerce("count");
	              }
	              coerce("level");
	              coerce("maxdepth");
	              var packing = coerce("tiling.packing");
	              if (packing === "squarify") {
	                coerce("tiling.squarifyratio");
	              }
	              coerce("tiling.flip");
	              coerce("tiling.pad");
	              var text = coerce("text");
	              coerce("texttemplate");
	              if (!traceOut.texttemplate) coerce("textinfo", Array.isArray(text) ? "text+label" : "label");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var hasPathbar = coerce("pathbar.visible");
	              var textposition = "auto";
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                hasPathbar,
	                moduleHasSelected: false,
	                moduleHasUnselected: false,
	                moduleHasConstrain: false,
	                moduleHasCliponaxis: false,
	                moduleHasTextangle: false,
	                moduleHasInsideanchor: false
	              });
	              coerce("textposition");
	              var bottomText = traceOut.textposition.indexOf("bottom") !== -1;
	              handleMarkerDefaults(traceIn, traceOut, layout, coerce);
	              var withColorscale = traceOut._hasColorscale = hasColorscale(traceIn, "marker", "colors") || (traceIn.marker || {}).coloraxis;
	              if (withColorscale) {
	                colorscaleDefaults(traceIn, traceOut, layout, coerce, {
	                  prefix: "marker.",
	                  cLetter: "c"
	                });
	              } else {
	                coerce("marker.depthfade", !(traceOut.marker.colors || []).length);
	              }
	              var headerSize = traceOut.textfont.size * 2;
	              coerce("marker.pad.t", bottomText ? headerSize / 4 : headerSize);
	              coerce("marker.pad.l", headerSize / 4);
	              coerce("marker.pad.r", headerSize / 4);
	              coerce("marker.pad.b", bottomText ? headerSize : headerSize / 4);
	              coerce("marker.cornerradius");
	              traceOut._hovered = {
	                marker: {
	                  line: {
	                    width: 2,
	                    color: Color.contrast(layout.paper_bgcolor)
	                  }
	                }
	              };
	              if (hasPathbar) {
	                coerce("pathbar.thickness", traceOut.pathbar.textfont.size + 2 * TEXTPAD);
	                coerce("pathbar.side");
	                coerce("pathbar.edgeshape");
	              }
	              coerce("sort");
	              coerce("root.color");
	              handleDomainDefaults(traceOut, layout, coerce);
	              traceOut._length = null;
	            };
	          }
	        ),
	        /***/
	        80694: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var helpers = __webpack_require__2(2791);
	            var uniformText = __webpack_require__2(72597);
	            var clearMinTextSize = uniformText.clearMinTextSize;
	            var resizeText = __webpack_require__2(16688).resizeText;
	            var plotOne = __webpack_require__2(46650);
	            module2.exports = function _plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback, opts) {
	              var type = opts.type;
	              var drawDescendants = opts.drawDescendants;
	              var fullLayout = gd._fullLayout;
	              var layer = fullLayout["_" + type + "layer"];
	              var join, onComplete;
	              var isFullReplot = !transitionOpts;
	              clearMinTextSize(type, fullLayout);
	              join = layer.selectAll("g.trace." + type).data(cdmodule, function(cd) {
	                return cd[0].trace.uid;
	              });
	              join.enter().append("g").classed("trace", true).classed(type, true);
	              join.order();
	              if (!fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts)) {
	                if (makeOnCompleteCallback) {
	                  onComplete = makeOnCompleteCallback();
	                }
	                var transition = d3.transition().duration(transitionOpts.duration).ease(transitionOpts.easing).each("end", function() {
	                  onComplete && onComplete();
	                }).each("interrupt", function() {
	                  onComplete && onComplete();
	                });
	                transition.each(function() {
	                  layer.selectAll("g.trace").each(function(cd) {
	                    plotOne(gd, cd, this, transitionOpts, drawDescendants);
	                  });
	                });
	              } else {
	                join.each(function(cd) {
	                  plotOne(gd, cd, this, transitionOpts, drawDescendants);
	                });
	                if (fullLayout.uniformtext.mode) {
	                  resizeText(gd, layer.selectAll(".trace"), type);
	                }
	              }
	              if (isFullReplot) {
	                join.exit().remove();
	              }
	            };
	          }
	        ),
	        /***/
	        66209: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var svgTextUtils = __webpack_require__2(63893);
	            var partition = __webpack_require__2(37210);
	            var styleOne = __webpack_require__2(96362).styleOne;
	            var constants = __webpack_require__2(43473);
	            var helpers = __webpack_require__2(2791);
	            var attachFxHandlers = __webpack_require__2(83523);
	            var onPathbar = true;
	            module2.exports = function drawAncestors(gd, cd, entry, slices, opts) {
	              var barDifY = opts.barDifY;
	              var width = opts.width;
	              var height = opts.height;
	              var viewX = opts.viewX;
	              var viewY = opts.viewY;
	              var pathSlice = opts.pathSlice;
	              var toMoveInsideSlice = opts.toMoveInsideSlice;
	              var strTransform = opts.strTransform;
	              var hasTransition = opts.hasTransition;
	              var handleSlicesExit = opts.handleSlicesExit;
	              var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
	              var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
	              var refRect = {};
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var hierarchy = cd0.hierarchy;
	              var eachWidth = width / trace._entryDepth;
	              var pathIds = helpers.listPath(entry.data, "id");
	              var sliceData = partition(hierarchy.copy(), [width, height], {
	                packing: "dice",
	                pad: {
	                  inner: 0,
	                  top: 0,
	                  left: 0,
	                  right: 0,
	                  bottom: 0
	                }
	              }).descendants();
	              sliceData = sliceData.filter(function(pt) {
	                var level = pathIds.indexOf(pt.data.id);
	                if (level === -1) return false;
	                pt.x0 = eachWidth * level;
	                pt.x1 = eachWidth * (level + 1);
	                pt.y0 = barDifY;
	                pt.y1 = barDifY + height;
	                pt.onPathbar = true;
	                return true;
	              });
	              sliceData.reverse();
	              slices = slices.data(sliceData, helpers.getPtId);
	              slices.enter().append("g").classed("pathbar", true);
	              handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
	              slices.order();
	              var updateSlices = slices;
	              if (hasTransition) {
	                updateSlices = updateSlices.transition().each("end", function() {
	                  var sliceTop = d3.select(this);
	                  helpers.setSliceCursor(sliceTop, gd, {
	                    hideOnRoot: false,
	                    hideOnLeaves: false,
	                    isTransitioning: false
	                  });
	                });
	              }
	              updateSlices.each(function(pt) {
	                pt._x0 = viewX(pt.x0);
	                pt._x1 = viewX(pt.x1);
	                pt._y0 = viewY(pt.y0);
	                pt._y1 = viewY(pt.y1);
	                pt._hoverX = viewX(pt.x1 - Math.min(width, height) / 2);
	                pt._hoverY = viewY(pt.y1 - height / 2);
	                var sliceTop = d3.select(this);
	                var slicePath = Lib.ensureSingle(sliceTop, "path", "surface", function(s) {
	                  s.style("pointer-events", isStatic ? "none" : "all");
	                });
	                if (hasTransition) {
	                  slicePath.transition().attrTween("d", function(pt2) {
	                    var interp = makeUpdateSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
	                    return function(t) {
	                      return pathSlice(interp(t));
	                    };
	                  });
	                } else {
	                  slicePath.attr("d", pathSlice);
	                }
	                sliceTop.call(attachFxHandlers, entry, gd, cd, {
	                  styleOne,
	                  eventDataKeys: constants.eventDataKeys,
	                  transitionTime: constants.CLICK_TRANSITION_TIME,
	                  transitionEasing: constants.CLICK_TRANSITION_EASING
	                }).call(helpers.setSliceCursor, gd, {
	                  hideOnRoot: false,
	                  hideOnLeaves: false,
	                  isTransitioning: gd._transitioning
	                });
	                slicePath.call(styleOne, pt, trace, gd, {
	                  hovered: false
	                });
	                pt._text = (helpers.getPtLabel(pt) || "").split("<br>").join(" ") || "";
	                var sliceTextGroup = Lib.ensureSingle(sliceTop, "g", "slicetext");
	                var sliceText = Lib.ensureSingle(sliceTextGroup, "text", "", function(s) {
	                  s.attr("data-notex", 1);
	                });
	                var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font, {
	                  onPathbar: true
	                }));
	                sliceText.text(pt._text || " ").classed("slicetext", true).attr("text-anchor", "start").call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
	                pt.textBB = Drawing.bBox(sliceText.node());
	                pt.transform = toMoveInsideSlice(pt, {
	                  fontSize: font.size,
	                  onPathbar: true
	                });
	                pt.transform.fontSize = font.size;
	                if (hasTransition) {
	                  sliceText.transition().attrTween("transform", function(pt2) {
	                    var interp = makeUpdateTextInterpolator(pt2, onPathbar, refRect, [width, height]);
	                    return function(t) {
	                      return strTransform(interp(t));
	                    };
	                  });
	                } else {
	                  sliceText.attr("transform", strTransform(pt));
	                }
	              });
	            };
	          }
	        ),
	        /***/
	        52583: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var svgTextUtils = __webpack_require__2(63893);
	            var partition = __webpack_require__2(37210);
	            var styleOne = __webpack_require__2(96362).styleOne;
	            var constants = __webpack_require__2(43473);
	            var helpers = __webpack_require__2(2791);
	            var attachFxHandlers = __webpack_require__2(83523);
	            var formatSliceLabel = __webpack_require__2(24714).formatSliceLabel;
	            var onPathbar = false;
	            module2.exports = function drawDescendants(gd, cd, entry, slices, opts) {
	              var width = opts.width;
	              var height = opts.height;
	              var viewX = opts.viewX;
	              var viewY = opts.viewY;
	              var pathSlice = opts.pathSlice;
	              var toMoveInsideSlice = opts.toMoveInsideSlice;
	              var strTransform = opts.strTransform;
	              var hasTransition = opts.hasTransition;
	              var handleSlicesExit = opts.handleSlicesExit;
	              var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
	              var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
	              var prevEntry = opts.prevEntry;
	              var refRect = {};
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var hasLeft = trace.textposition.indexOf("left") !== -1;
	              var hasRight = trace.textposition.indexOf("right") !== -1;
	              var hasBottom = trace.textposition.indexOf("bottom") !== -1;
	              var noRoomForHeader = !hasBottom && !trace.marker.pad.t || hasBottom && !trace.marker.pad.b;
	              var allData = partition(entry, [width, height], {
	                packing: trace.tiling.packing,
	                squarifyratio: trace.tiling.squarifyratio,
	                flipX: trace.tiling.flip.indexOf("x") > -1,
	                flipY: trace.tiling.flip.indexOf("y") > -1,
	                pad: {
	                  inner: trace.tiling.pad,
	                  top: trace.marker.pad.t,
	                  left: trace.marker.pad.l,
	                  right: trace.marker.pad.r,
	                  bottom: trace.marker.pad.b
	                }
	              });
	              var sliceData = allData.descendants();
	              var minVisibleDepth = Infinity;
	              var maxVisibleDepth = -Infinity;
	              sliceData.forEach(function(pt) {
	                var depth = pt.depth;
	                if (depth >= trace._maxDepth) {
	                  pt.x0 = pt.x1 = (pt.x0 + pt.x1) / 2;
	                  pt.y0 = pt.y1 = (pt.y0 + pt.y1) / 2;
	                } else {
	                  minVisibleDepth = Math.min(minVisibleDepth, depth);
	                  maxVisibleDepth = Math.max(maxVisibleDepth, depth);
	                }
	              });
	              slices = slices.data(sliceData, helpers.getPtId);
	              trace._maxVisibleLayers = isFinite(maxVisibleDepth) ? maxVisibleDepth - minVisibleDepth + 1 : 0;
	              slices.enter().append("g").classed("slice", true);
	              handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
	              slices.order();
	              var nextOfPrevEntry = null;
	              if (hasTransition && prevEntry) {
	                var prevEntryId = helpers.getPtId(prevEntry);
	                slices.each(function(pt) {
	                  if (nextOfPrevEntry === null && helpers.getPtId(pt) === prevEntryId) {
	                    nextOfPrevEntry = {
	                      x0: pt.x0,
	                      x1: pt.x1,
	                      y0: pt.y0,
	                      y1: pt.y1
	                    };
	                  }
	                });
	              }
	              var getRefRect = function() {
	                return nextOfPrevEntry || {
	                  x0: 0,
	                  x1: width,
	                  y0: 0,
	                  y1: height
	                };
	              };
	              var updateSlices = slices;
	              if (hasTransition) {
	                updateSlices = updateSlices.transition().each("end", function() {
	                  var sliceTop = d3.select(this);
	                  helpers.setSliceCursor(sliceTop, gd, {
	                    hideOnRoot: true,
	                    hideOnLeaves: false,
	                    isTransitioning: false
	                  });
	                });
	              }
	              updateSlices.each(function(pt) {
	                var isHeader = helpers.isHeader(pt, trace);
	                pt._x0 = viewX(pt.x0);
	                pt._x1 = viewX(pt.x1);
	                pt._y0 = viewY(pt.y0);
	                pt._y1 = viewY(pt.y1);
	                pt._hoverX = viewX(pt.x1 - trace.marker.pad.r), pt._hoverY = hasBottom ? viewY(pt.y1 - trace.marker.pad.b / 2) : viewY(pt.y0 + trace.marker.pad.t / 2);
	                var sliceTop = d3.select(this);
	                var slicePath = Lib.ensureSingle(sliceTop, "path", "surface", function(s) {
	                  s.style("pointer-events", isStatic ? "none" : "all");
	                });
	                if (hasTransition) {
	                  slicePath.transition().attrTween("d", function(pt2) {
	                    var interp = makeUpdateSliceInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
	                    return function(t) {
	                      return pathSlice(interp(t));
	                    };
	                  });
	                } else {
	                  slicePath.attr("d", pathSlice);
	                }
	                sliceTop.call(attachFxHandlers, entry, gd, cd, {
	                  styleOne,
	                  eventDataKeys: constants.eventDataKeys,
	                  transitionTime: constants.CLICK_TRANSITION_TIME,
	                  transitionEasing: constants.CLICK_TRANSITION_EASING
	                }).call(helpers.setSliceCursor, gd, {
	                  isTransitioning: gd._transitioning
	                });
	                slicePath.call(styleOne, pt, trace, gd, {
	                  hovered: false
	                });
	                if (pt.x0 === pt.x1 || pt.y0 === pt.y1) {
	                  pt._text = "";
	                } else {
	                  if (isHeader) {
	                    pt._text = noRoomForHeader ? "" : helpers.getPtLabel(pt) || "";
	                  } else {
	                    pt._text = formatSliceLabel(pt, entry, trace, cd, fullLayout) || "";
	                  }
	                }
	                var sliceTextGroup = Lib.ensureSingle(sliceTop, "g", "slicetext");
	                var sliceText = Lib.ensureSingle(sliceTextGroup, "text", "", function(s) {
	                  s.attr("data-notex", 1);
	                });
	                var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
	                sliceText.text(pt._text || " ").classed("slicetext", true).attr("text-anchor", hasRight ? "end" : hasLeft || isHeader ? "start" : "middle").call(Drawing.font, font).call(svgTextUtils.convertToTspans, gd);
	                pt.textBB = Drawing.bBox(sliceText.node());
	                pt.transform = toMoveInsideSlice(pt, {
	                  fontSize: font.size,
	                  isHeader
	                });
	                pt.transform.fontSize = font.size;
	                if (hasTransition) {
	                  sliceText.transition().attrTween("transform", function(pt2) {
	                    var interp = makeUpdateTextInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
	                    return function(t) {
	                      return strTransform(interp(t));
	                    };
	                  });
	                } else {
	                  sliceText.attr("transform", strTransform(pt));
	                }
	              });
	              return nextOfPrevEntry;
	            };
	          }
	        ),
	        /***/
	        14102: (
	          /***/
	          function(module2) {
	            module2.exports = function flipTree(node, size, opts) {
	              var tmp;
	              if (opts.swapXY) {
	                tmp = node.x0;
	                node.x0 = node.y0;
	                node.y0 = tmp;
	                tmp = node.x1;
	                node.x1 = node.y1;
	                node.y1 = tmp;
	              }
	              if (opts.flipX) {
	                tmp = node.x0;
	                node.x0 = size[0] - node.x1;
	                node.x1 = size[0] - tmp;
	              }
	              if (opts.flipY) {
	                tmp = node.y0;
	                node.y0 = size[1] - node.y1;
	                node.y1 = size[1] - tmp;
	              }
	              var children = node.children;
	              if (children) {
	                for (var i = 0; i < children.length; i++) {
	                  flipTree(children[i], size, opts);
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        70954: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              moduleType: "trace",
	              name: "treemap",
	              basePlotModule: __webpack_require__2(78018),
	              categories: [],
	              animatable: true,
	              attributes: __webpack_require__2(45802),
	              layoutAttributes: __webpack_require__2(55479),
	              supplyDefaults: __webpack_require__2(91174),
	              supplyLayoutDefaults: __webpack_require__2(77182),
	              calc: __webpack_require__2(65039).y,
	              crossTraceCalc: __webpack_require__2(65039).T,
	              plot: __webpack_require__2(5893),
	              style: __webpack_require__2(96362).style,
	              colorbar: __webpack_require__2(4898),
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        55479: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              treemapcolorway: {
	                valType: "colorlist",
	                editType: "calc"
	              },
	              extendtreemapcolors: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        77182: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(55479);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              coerce("treemapcolorway", layoutOut.colorway);
	              coerce("extendtreemapcolors");
	            };
	          }
	        ),
	        /***/
	        37210: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3Hierarchy = __webpack_require__2(674);
	            var flipTree = __webpack_require__2(14102);
	            module2.exports = function partition(entry, size, opts) {
	              var flipX = opts.flipX;
	              var flipY = opts.flipY;
	              var swapXY = opts.packing === "dice-slice";
	              var top = opts.pad[flipY ? "bottom" : "top"];
	              var left = opts.pad[flipX ? "right" : "left"];
	              var right = opts.pad[flipX ? "left" : "right"];
	              var bottom = opts.pad[flipY ? "top" : "bottom"];
	              var tmp;
	              if (swapXY) {
	                tmp = left;
	                left = top;
	                top = tmp;
	                tmp = right;
	                right = bottom;
	                bottom = tmp;
	              }
	              var result = d3Hierarchy.treemap().tile(getTilingMethod(opts.packing, opts.squarifyratio)).paddingInner(opts.pad.inner).paddingLeft(left).paddingRight(right).paddingTop(top).paddingBottom(bottom).size(swapXY ? [size[1], size[0]] : size)(entry);
	              if (swapXY || flipX || flipY) {
	                flipTree(result, size, {
	                  swapXY,
	                  flipX,
	                  flipY
	                });
	              }
	              return result;
	            };
	            function getTilingMethod(key, squarifyratio) {
	              switch (key) {
	                case "squarify":
	                  return d3Hierarchy.treemapSquarify.ratio(squarifyratio);
	                case "binary":
	                  return d3Hierarchy.treemapBinary;
	                case "dice":
	                  return d3Hierarchy.treemapDice;
	                case "slice":
	                  return d3Hierarchy.treemapSlice;
	                default:
	                  return d3Hierarchy.treemapSliceDice;
	              }
	            }
	          }
	        ),
	        /***/
	        5893: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var draw = __webpack_require__2(80694);
	            var drawDescendants = __webpack_require__2(52583);
	            module2.exports = function _plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
	              return draw(gd, cdmodule, transitionOpts, makeOnCompleteCallback, {
	                type: "treemap",
	                drawDescendants
	              });
	            };
	          }
	        ),
	        /***/
	        46650: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var interpolate = __webpack_require__2(81684).sX;
	            var helpers = __webpack_require__2(2791);
	            var Lib = __webpack_require__2(71828);
	            var TEXTPAD = __webpack_require__2(97313).TEXTPAD;
	            var barPlot = __webpack_require__2(17295);
	            var toMoveInsideBar = barPlot.toMoveInsideBar;
	            var uniformText = __webpack_require__2(72597);
	            var recordMinTextSize = uniformText.recordMinTextSize;
	            var constants = __webpack_require__2(43473);
	            var drawAncestors = __webpack_require__2(66209);
	            function getKey(pt) {
	              return helpers.isHierarchyRoot(pt) ? "" : (
	                // don't use the dummyId
	                helpers.getPtId(pt)
	              );
	            }
	            module2.exports = function plotOne(gd, cd, element, transitionOpts, drawDescendants) {
	              var fullLayout = gd._fullLayout;
	              var cd0 = cd[0];
	              var trace = cd0.trace;
	              var type = trace.type;
	              var isIcicle = type === "icicle";
	              var hierarchy = cd0.hierarchy;
	              var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
	              var gTrace = d3.select(element);
	              var selAncestors = gTrace.selectAll("g.pathbar");
	              var selDescendants = gTrace.selectAll("g.slice");
	              if (!entry) {
	                selAncestors.remove();
	                selDescendants.remove();
	                return;
	              }
	              var isRoot = helpers.isHierarchyRoot(entry);
	              var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
	              var maxDepth = helpers.getMaxDepth(trace);
	              var hasVisibleDepth = function(pt) {
	                return pt.data.depth - entry.data.depth < maxDepth;
	              };
	              var gs = fullLayout._size;
	              var domain = trace.domain;
	              var vpw = gs.w * (domain.x[1] - domain.x[0]);
	              var vph = gs.h * (domain.y[1] - domain.y[0]);
	              var barW = vpw;
	              var barH = trace.pathbar.thickness;
	              var barPad = trace.marker.line.width + constants.gapWithPathbar;
	              var barDifY = !trace.pathbar.visible ? 0 : trace.pathbar.side.indexOf("bottom") > -1 ? vph + barPad : -(barH + barPad);
	              var pathbarOrigin = {
	                x0: barW,
	                // slide to the right
	                x1: barW,
	                y0: barDifY,
	                y1: barDifY + barH
	              };
	              var findClosestEdge = function(pt, ref, size) {
	                var e = trace.tiling.pad;
	                var isLeftOfRect = function(x) {
	                  return x - e <= ref.x0;
	                };
	                var isRightOfRect = function(x) {
	                  return x + e >= ref.x1;
	                };
	                var isBottomOfRect = function(y) {
	                  return y - e <= ref.y0;
	                };
	                var isTopOfRect = function(y) {
	                  return y + e >= ref.y1;
	                };
	                if (pt.x0 === ref.x0 && pt.x1 === ref.x1 && pt.y0 === ref.y0 && pt.y1 === ref.y1) {
	                  return {
	                    x0: pt.x0,
	                    x1: pt.x1,
	                    y0: pt.y0,
	                    y1: pt.y1
	                  };
	                }
	                return {
	                  x0: isLeftOfRect(pt.x0 - e) ? 0 : isRightOfRect(pt.x0 - e) ? size[0] : pt.x0,
	                  x1: isLeftOfRect(pt.x1 + e) ? 0 : isRightOfRect(pt.x1 + e) ? size[0] : pt.x1,
	                  y0: isBottomOfRect(pt.y0 - e) ? 0 : isTopOfRect(pt.y0 - e) ? size[1] : pt.y0,
	                  y1: isBottomOfRect(pt.y1 + e) ? 0 : isTopOfRect(pt.y1 + e) ? size[1] : pt.y1
	                };
	              };
	              var prevEntry = null;
	              var prevLookupPathbar = {};
	              var prevLookupSlices = {};
	              var nextOfPrevEntry = null;
	              var getPrev = function(pt, onPathbar) {
	                return onPathbar ? prevLookupPathbar[getKey(pt)] : prevLookupSlices[getKey(pt)];
	              };
	              var getOrigin = function(pt, onPathbar, refRect, size) {
	                if (onPathbar) {
	                  return prevLookupPathbar[getKey(hierarchy)] || pathbarOrigin;
	                } else {
	                  var ref = prevLookupSlices[trace.level] || refRect;
	                  if (hasVisibleDepth(pt)) {
	                    return findClosestEdge(pt, ref, size);
	                  }
	                }
	                return {};
	              };
	              if (cd0.hasMultipleRoots && isRoot) {
	                maxDepth++;
	              }
	              trace._maxDepth = maxDepth;
	              trace._backgroundColor = fullLayout.paper_bgcolor;
	              trace._entryDepth = entry.data.depth;
	              trace._atRootLevel = isRoot;
	              var cenX = -vpw / 2 + gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
	              var cenY = -vph / 2 + gs.t + gs.h * (1 - (domain.y[1] + domain.y[0]) / 2);
	              var viewMapX = function(x) {
	                return cenX + x;
	              };
	              var viewMapY = function(y) {
	                return cenY + y;
	              };
	              var barY0 = viewMapY(0);
	              var barX0 = viewMapX(0);
	              var viewBarX = function(x) {
	                return barX0 + x;
	              };
	              var viewBarY = function(y) {
	                return barY0 + y;
	              };
	              function pos(x, y) {
	                return x + "," + y;
	              }
	              var xStart = viewBarX(0);
	              var limitX0 = function(p) {
	                p.x = Math.max(xStart, p.x);
	              };
	              var edgeshape = trace.pathbar.edgeshape;
	              var pathAncestor = function(d) {
	                var _x0 = viewBarX(Math.max(Math.min(d.x0, d.x0), 0));
	                var _x1 = viewBarX(Math.min(Math.max(d.x1, d.x1), barW));
	                var _y0 = viewBarY(d.y0);
	                var _y1 = viewBarY(d.y1);
	                var halfH = barH / 2;
	                var pL = {};
	                var pR = {};
	                pL.x = _x0;
	                pR.x = _x1;
	                pL.y = pR.y = (_y0 + _y1) / 2;
	                var pA = {
	                  x: _x0,
	                  y: _y0
	                };
	                var pB = {
	                  x: _x1,
	                  y: _y0
	                };
	                var pC = {
	                  x: _x1,
	                  y: _y1
	                };
	                var pD = {
	                  x: _x0,
	                  y: _y1
	                };
	                if (edgeshape === ">") {
	                  pA.x -= halfH;
	                  pB.x -= halfH;
	                  pC.x -= halfH;
	                  pD.x -= halfH;
	                } else if (edgeshape === "/") {
	                  pC.x -= halfH;
	                  pD.x -= halfH;
	                  pL.x -= halfH / 2;
	                  pR.x -= halfH / 2;
	                } else if (edgeshape === "\\") {
	                  pA.x -= halfH;
	                  pB.x -= halfH;
	                  pL.x -= halfH / 2;
	                  pR.x -= halfH / 2;
	                } else if (edgeshape === "<") {
	                  pL.x -= halfH;
	                  pR.x -= halfH;
	                }
	                limitX0(pA);
	                limitX0(pD);
	                limitX0(pL);
	                limitX0(pB);
	                limitX0(pC);
	                limitX0(pR);
	                return "M" + pos(pA.x, pA.y) + "L" + pos(pB.x, pB.y) + "L" + pos(pR.x, pR.y) + "L" + pos(pC.x, pC.y) + "L" + pos(pD.x, pD.y) + "L" + pos(pL.x, pL.y) + "Z";
	              };
	              var pad = trace[isIcicle ? "tiling" : "marker"].pad;
	              var hasFlag = function(f) {
	                return trace.textposition.indexOf(f) !== -1;
	              };
	              var hasTop = hasFlag("top");
	              var hasLeft = hasFlag("left");
	              var hasRight = hasFlag("right");
	              var hasBottom = hasFlag("bottom");
	              var pathDescendant = function(d) {
	                var _x0 = viewMapX(d.x0);
	                var _x1 = viewMapX(d.x1);
	                var _y0 = viewMapY(d.y0);
	                var _y1 = viewMapY(d.y1);
	                var dx = _x1 - _x0;
	                var dy = _y1 - _y0;
	                if (!dx || !dy) return "";
	                var cornerradius = trace.marker.cornerradius || 0;
	                var r = Math.min(cornerradius, dx / 2, dy / 2);
	                if (r && d.data && d.data.data && d.data.data.label) {
	                  if (hasTop) r = Math.min(r, pad.t);
	                  if (hasLeft) r = Math.min(r, pad.l);
	                  if (hasRight) r = Math.min(r, pad.r);
	                  if (hasBottom) r = Math.min(r, pad.b);
	                }
	                var arc = function(rx, ry) {
	                  return r ? "a" + pos(r, r) + " 0 0 1 " + pos(rx, ry) : "";
	                };
	                return "M" + pos(_x0, _y0 + r) + arc(r, -r) + "L" + pos(_x1 - r, _y0) + arc(r, r) + "L" + pos(_x1, _y1 - r) + arc(-r, r) + "L" + pos(_x0 + r, _y1) + arc(-r, -r) + "Z";
	              };
	              var toMoveInsideSlice = function(pt, opts) {
	                var x0 = pt.x0;
	                var x1 = pt.x1;
	                var y0 = pt.y0;
	                var y1 = pt.y1;
	                var textBB = pt.textBB;
	                var _hasTop = hasTop || opts.isHeader && !hasBottom;
	                var anchor = _hasTop ? "start" : hasBottom ? "end" : "middle";
	                var _hasRight = hasFlag("right");
	                var _hasLeft = hasFlag("left") || opts.onPathbar;
	                var leftToRight = _hasLeft ? -1 : _hasRight ? 1 : 0;
	                if (opts.isHeader) {
	                  x0 += (isIcicle ? pad : pad.l) - TEXTPAD;
	                  x1 -= (isIcicle ? pad : pad.r) - TEXTPAD;
	                  if (x0 >= x1) {
	                    var mid = (x0 + x1) / 2;
	                    x0 = mid;
	                    x1 = mid;
	                  }
	                  var limY;
	                  if (hasBottom) {
	                    limY = y1 - (isIcicle ? pad : pad.b);
	                    if (y0 < limY && limY < y1) y0 = limY;
	                  } else {
	                    limY = y0 + (isIcicle ? pad : pad.t);
	                    if (y0 < limY && limY < y1) y1 = limY;
	                  }
	                }
	                var transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
	                  isHorizontal: false,
	                  constrained: true,
	                  angle: 0,
	                  anchor,
	                  leftToRight
	                });
	                transform.fontSize = opts.fontSize;
	                transform.targetX = viewMapX(transform.targetX);
	                transform.targetY = viewMapY(transform.targetY);
	                if (isNaN(transform.targetX) || isNaN(transform.targetY)) {
	                  return {};
	                }
	                if (x0 !== x1 && y0 !== y1) {
	                  recordMinTextSize(trace.type, transform, fullLayout);
	                }
	                return {
	                  scale: transform.scale,
	                  rotate: transform.rotate,
	                  textX: transform.textX,
	                  textY: transform.textY,
	                  anchorX: transform.anchorX,
	                  anchorY: transform.anchorY,
	                  targetX: transform.targetX,
	                  targetY: transform.targetY
	                };
	              };
	              var interpFromParent = function(pt, onPathbar) {
	                var parentPrev;
	                var i = 0;
	                var Q = pt;
	                while (!parentPrev && i < maxDepth) {
	                  i++;
	                  Q = Q.parent;
	                  if (Q) {
	                    parentPrev = getPrev(Q, onPathbar);
	                  } else i = maxDepth;
	                }
	                return parentPrev || {};
	              };
	              var makeExitSliceInterpolator = function(pt, onPathbar, refRect, size) {
	                var prev = getPrev(pt, onPathbar);
	                var next;
	                if (onPathbar) {
	                  next = pathbarOrigin;
	                } else {
	                  var entryPrev = getPrev(entry, onPathbar);
	                  if (entryPrev) {
	                    next = findClosestEdge(pt, entryPrev, size);
	                  } else {
	                    next = {};
	                  }
	                }
	                return interpolate(prev, next);
	              };
	              var makeUpdateSliceInterpolator = function(pt, onPathbar, refRect, size, opts) {
	                var prev0 = getPrev(pt, onPathbar);
	                var prev;
	                if (prev0) {
	                  prev = prev0;
	                } else {
	                  if (onPathbar) {
	                    prev = pathbarOrigin;
	                  } else {
	                    if (prevEntry) {
	                      if (pt.parent) {
	                        var ref = nextOfPrevEntry || refRect;
	                        if (ref && !onPathbar) {
	                          prev = findClosestEdge(pt, ref, size);
	                        } else {
	                          prev = {};
	                          Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
	                        }
	                      } else {
	                        prev = Lib.extendFlat({}, pt);
	                        if (isIcicle) {
	                          if (opts.orientation === "h") {
	                            if (opts.flipX) prev.x0 = pt.x1;
	                            else prev.x1 = 0;
	                          } else {
	                            if (opts.flipY) prev.y0 = pt.y1;
	                            else prev.y1 = 0;
	                          }
	                        }
	                      }
	                    } else {
	                      prev = {};
	                    }
	                  }
	                }
	                return interpolate(prev, {
	                  x0: pt.x0,
	                  x1: pt.x1,
	                  y0: pt.y0,
	                  y1: pt.y1
	                });
	              };
	              var makeUpdateTextInterpolator = function(pt, onPathbar, refRect, size) {
	                var prev0 = getPrev(pt, onPathbar);
	                var prev = {};
	                var origin = getOrigin(pt, onPathbar, refRect, size);
	                Lib.extendFlat(prev, {
	                  transform: toMoveInsideSlice({
	                    x0: origin.x0,
	                    x1: origin.x1,
	                    y0: origin.y0,
	                    y1: origin.y1,
	                    textBB: pt.textBB,
	                    _text: pt._text
	                  }, {
	                    isHeader: helpers.isHeader(pt, trace)
	                  })
	                });
	                if (prev0) {
	                  prev = prev0;
	                } else {
	                  if (pt.parent) {
	                    Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
	                  }
	                }
	                var transform = pt.transform;
	                if (pt.x0 !== pt.x1 && pt.y0 !== pt.y1) {
	                  recordMinTextSize(trace.type, transform, fullLayout);
	                }
	                return interpolate(prev, {
	                  transform: {
	                    scale: transform.scale,
	                    rotate: transform.rotate,
	                    textX: transform.textX,
	                    textY: transform.textY,
	                    anchorX: transform.anchorX,
	                    anchorY: transform.anchorY,
	                    targetX: transform.targetX,
	                    targetY: transform.targetY
	                  }
	                });
	              };
	              var handleSlicesExit = function(slices, onPathbar, refRect, size, pathSlice) {
	                var width = size[0];
	                var height = size[1];
	                if (hasTransition) {
	                  slices.exit().transition().each(function() {
	                    var sliceTop = d3.select(this);
	                    var slicePath = sliceTop.select("path.surface");
	                    slicePath.transition().attrTween("d", function(pt2) {
	                      var interp = makeExitSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
	                      return function(t) {
	                        return pathSlice(interp(t));
	                      };
	                    });
	                    var sliceTextGroup = sliceTop.select("g.slicetext");
	                    sliceTextGroup.attr("opacity", 0);
	                  }).remove();
	                } else {
	                  slices.exit().remove();
	                }
	              };
	              var strTransform = function(d) {
	                var transform = d.transform;
	                if (d.x0 !== d.x1 && d.y0 !== d.y1) {
	                  recordMinTextSize(trace.type, transform, fullLayout);
	                }
	                return Lib.getTextTransform({
	                  textX: transform.textX,
	                  textY: transform.textY,
	                  anchorX: transform.anchorX,
	                  anchorY: transform.anchorY,
	                  targetX: transform.targetX,
	                  targetY: transform.targetY,
	                  scale: transform.scale,
	                  rotate: transform.rotate
	                });
	              };
	              if (hasTransition) {
	                selAncestors.each(function(pt) {
	                  prevLookupPathbar[getKey(pt)] = {
	                    x0: pt.x0,
	                    x1: pt.x1,
	                    y0: pt.y0,
	                    y1: pt.y1
	                  };
	                  if (pt.transform) {
	                    prevLookupPathbar[getKey(pt)].transform = {
	                      textX: pt.transform.textX,
	                      textY: pt.transform.textY,
	                      anchorX: pt.transform.anchorX,
	                      anchorY: pt.transform.anchorY,
	                      targetX: pt.transform.targetX,
	                      targetY: pt.transform.targetY,
	                      scale: pt.transform.scale,
	                      rotate: pt.transform.rotate
	                    };
	                  }
	                });
	                selDescendants.each(function(pt) {
	                  prevLookupSlices[getKey(pt)] = {
	                    x0: pt.x0,
	                    x1: pt.x1,
	                    y0: pt.y0,
	                    y1: pt.y1
	                  };
	                  if (pt.transform) {
	                    prevLookupSlices[getKey(pt)].transform = {
	                      textX: pt.transform.textX,
	                      textY: pt.transform.textY,
	                      anchorX: pt.transform.anchorX,
	                      anchorY: pt.transform.anchorY,
	                      targetX: pt.transform.targetX,
	                      targetY: pt.transform.targetY,
	                      scale: pt.transform.scale,
	                      rotate: pt.transform.rotate
	                    };
	                  }
	                  if (!prevEntry && helpers.isEntry(pt)) {
	                    prevEntry = pt;
	                  }
	                });
	              }
	              nextOfPrevEntry = drawDescendants(gd, cd, entry, selDescendants, {
	                width: vpw,
	                height: vph,
	                viewX: viewMapX,
	                viewY: viewMapY,
	                pathSlice: pathDescendant,
	                toMoveInsideSlice,
	                prevEntry,
	                makeUpdateSliceInterpolator,
	                makeUpdateTextInterpolator,
	                handleSlicesExit,
	                hasTransition,
	                strTransform
	              });
	              if (trace.pathbar.visible) {
	                drawAncestors(gd, cd, entry, selAncestors, {
	                  barDifY,
	                  width: barW,
	                  height: barH,
	                  viewX: viewBarX,
	                  viewY: viewBarY,
	                  pathSlice: pathAncestor,
	                  toMoveInsideSlice,
	                  makeUpdateSliceInterpolator,
	                  makeUpdateTextInterpolator,
	                  handleSlicesExit,
	                  hasTransition,
	                  strTransform
	                });
	              } else {
	                selAncestors.remove();
	              }
	            };
	          }
	        ),
	        /***/
	        96362: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var Lib = __webpack_require__2(71828);
	            var helpers = __webpack_require__2(2791);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            var fillOne = __webpack_require__2(43467);
	            function style(gd) {
	              var s = gd._fullLayout._treemaplayer.selectAll(".trace");
	              resizeText(gd, s, "treemap");
	              s.each(function(cd) {
	                var gTrace = d3.select(this);
	                var cd0 = cd[0];
	                var trace = cd0.trace;
	                gTrace.style("opacity", trace.opacity);
	                gTrace.selectAll("path.surface").each(function(pt) {
	                  d3.select(this).call(styleOne, pt, trace, gd, {
	                    hovered: false
	                  });
	                });
	              });
	            }
	            function styleOne(s, pt, trace, gd, opts) {
	              var hovered = (opts || {}).hovered;
	              var cdi = pt.data.data;
	              var ptNumber = cdi.i;
	              var lineColor;
	              var lineWidth;
	              var fillColor = cdi.color;
	              var isRoot = helpers.isHierarchyRoot(pt);
	              var opacity = 1;
	              if (hovered) {
	                lineColor = trace._hovered.marker.line.color;
	                lineWidth = trace._hovered.marker.line.width;
	              } else {
	                if (isRoot && fillColor === trace.root.color) {
	                  opacity = 100;
	                  lineColor = "rgba(0,0,0,0)";
	                  lineWidth = 0;
	                } else {
	                  lineColor = Lib.castOption(trace, ptNumber, "marker.line.color") || Color.defaultLine;
	                  lineWidth = Lib.castOption(trace, ptNumber, "marker.line.width") || 0;
	                  if (!trace._hasColorscale && !pt.onPathbar) {
	                    var depthfade = trace.marker.depthfade;
	                    if (depthfade) {
	                      var fadedColor = Color.combine(Color.addOpacity(trace._backgroundColor, 0.75), fillColor);
	                      var n;
	                      if (depthfade === true) {
	                        var maxDepth = helpers.getMaxDepth(trace);
	                        if (isFinite(maxDepth)) {
	                          if (helpers.isLeaf(pt)) {
	                            n = 0;
	                          } else {
	                            n = trace._maxVisibleLayers - (pt.data.depth - trace._entryDepth);
	                          }
	                        } else {
	                          n = pt.data.height + 1;
	                        }
	                      } else {
	                        n = pt.data.depth - trace._entryDepth;
	                        if (!trace._atRootLevel) n++;
	                      }
	                      if (n > 0) {
	                        for (var i = 0; i < n; i++) {
	                          var ratio = 0.5 * i / n;
	                          fillColor = Color.combine(Color.addOpacity(fadedColor, ratio), fillColor);
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	              s.call(fillOne, pt, trace, gd, fillColor).style("stroke-width", lineWidth).call(Color.stroke, lineColor).style("opacity", opacity);
	            }
	            module2.exports = {
	              style,
	              styleOne
	            };
	          }
	        ),
	        /***/
	        68875: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var boxAttrs = __webpack_require__2(53522);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            module2.exports = {
	              y: boxAttrs.y,
	              x: boxAttrs.x,
	              x0: boxAttrs.x0,
	              y0: boxAttrs.y0,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              name: extendFlat({}, boxAttrs.name, {}),
	              orientation: extendFlat({}, boxAttrs.orientation, {}),
	              bandwidth: {
	                valType: "number",
	                min: 0,
	                editType: "calc"
	              },
	              scalegroup: {
	                valType: "string",
	                dflt: "",
	                editType: "calc"
	              },
	              scalemode: {
	                valType: "enumerated",
	                values: ["width", "count"],
	                dflt: "width",
	                editType: "calc"
	              },
	              spanmode: {
	                valType: "enumerated",
	                values: ["soft", "hard", "manual"],
	                dflt: "soft",
	                editType: "calc"
	              },
	              span: {
	                valType: "info_array",
	                items: [{
	                  valType: "any",
	                  editType: "calc"
	                }, {
	                  valType: "any",
	                  editType: "calc"
	                }],
	                editType: "calc"
	              },
	              line: {
	                color: {
	                  valType: "color",
	                  editType: "style"
	                },
	                width: {
	                  valType: "number",
	                  min: 0,
	                  dflt: 2,
	                  editType: "style"
	                },
	                editType: "plot"
	              },
	              fillcolor: boxAttrs.fillcolor,
	              points: extendFlat({}, boxAttrs.boxpoints, {}),
	              jitter: extendFlat({}, boxAttrs.jitter, {}),
	              pointpos: extendFlat({}, boxAttrs.pointpos, {}),
	              width: extendFlat({}, boxAttrs.width, {}),
	              marker: boxAttrs.marker,
	              text: boxAttrs.text,
	              hovertext: boxAttrs.hovertext,
	              hovertemplate: boxAttrs.hovertemplate,
	              quartilemethod: boxAttrs.quartilemethod,
	              box: {
	                visible: {
	                  valType: "boolean",
	                  dflt: false,
	                  editType: "plot"
	                },
	                width: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 0.25,
	                  editType: "plot"
	                },
	                fillcolor: {
	                  valType: "color",
	                  editType: "style"
	                },
	                line: {
	                  color: {
	                    valType: "color",
	                    editType: "style"
	                  },
	                  width: {
	                    valType: "number",
	                    min: 0,
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                editType: "plot"
	              },
	              meanline: {
	                visible: {
	                  valType: "boolean",
	                  dflt: false,
	                  editType: "plot"
	                },
	                color: {
	                  valType: "color",
	                  editType: "style"
	                },
	                width: {
	                  valType: "number",
	                  min: 0,
	                  editType: "style"
	                },
	                editType: "plot"
	              },
	              side: {
	                valType: "enumerated",
	                values: ["both", "positive", "negative"],
	                dflt: "both",
	                editType: "calc"
	              },
	              offsetgroup: boxAttrs.offsetgroup,
	              alignmentgroup: boxAttrs.alignmentgroup,
	              selected: boxAttrs.selected,
	              unselected: boxAttrs.unselected,
	              hoveron: {
	                valType: "flaglist",
	                flags: ["violins", "points", "kde"],
	                dflt: "violins+points+kde",
	                extras: ["all"],
	                editType: "style"
	              }
	            };
	          }
	        ),
	        /***/
	        38603: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var boxCalc = __webpack_require__2(48518);
	            var helpers = __webpack_require__2(60168);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            module2.exports = function calc(gd, trace) {
	              var cd = boxCalc(gd, trace);
	              if (cd[0].t.empty) return cd;
	              var fullLayout = gd._fullLayout;
	              var valAxis = Axes.getFromId(gd, trace[trace.orientation === "h" ? "xaxis" : "yaxis"]);
	              var spanMin = Infinity;
	              var spanMax = -Infinity;
	              var maxKDE = 0;
	              var maxCount = 0;
	              for (var i = 0; i < cd.length; i++) {
	                var cdi = cd[i];
	                var vals = cdi.pts.map(helpers.extractVal);
	                var bandwidth = cdi.bandwidth = calcBandwidth(trace, cdi, vals);
	                var span = cdi.span = calcSpan(trace, cdi, valAxis, bandwidth);
	                if (cdi.min === cdi.max && bandwidth === 0) {
	                  span = cdi.span = [cdi.min, cdi.max];
	                  cdi.density = [{
	                    v: 1,
	                    t: span[0]
	                  }];
	                  cdi.bandwidth = bandwidth;
	                  maxKDE = Math.max(maxKDE, 1);
	                } else {
	                  var dist = span[1] - span[0];
	                  var n = Math.ceil(dist / (bandwidth / 3));
	                  var step = dist / n;
	                  if (!isFinite(step) || !isFinite(n)) {
	                    Lib.error("Something went wrong with computing the violin span");
	                    cd[0].t.empty = true;
	                    return cd;
	                  }
	                  var kde = helpers.makeKDE(cdi, trace, vals);
	                  cdi.density = new Array(n);
	                  for (var k = 0, t = span[0]; t < span[1] + step / 2; k++, t += step) {
	                    var v = kde(t);
	                    cdi.density[k] = {
	                      v,
	                      t
	                    };
	                    maxKDE = Math.max(maxKDE, v);
	                  }
	                }
	                maxCount = Math.max(maxCount, vals.length);
	                spanMin = Math.min(spanMin, span[0]);
	                spanMax = Math.max(spanMax, span[1]);
	              }
	              var extremes = Axes.findExtremes(valAxis, [spanMin, spanMax], {
	                padded: true
	              });
	              trace._extremes[valAxis._id] = extremes;
	              if (trace.width) {
	                cd[0].t.maxKDE = maxKDE;
	              } else {
	                var violinScaleGroupStats = fullLayout._violinScaleGroupStats;
	                var scaleGroup = trace.scalegroup;
	                var groupStats = violinScaleGroupStats[scaleGroup];
	                if (groupStats) {
	                  groupStats.maxKDE = Math.max(groupStats.maxKDE, maxKDE);
	                  groupStats.maxCount = Math.max(groupStats.maxCount, maxCount);
	                } else {
	                  violinScaleGroupStats[scaleGroup] = {
	                    maxKDE,
	                    maxCount
	                  };
	                }
	              }
	              cd[0].t.labels.kde = Lib._(gd, "kde:");
	              return cd;
	            };
	            function silvermanRule(len, ssd, iqr) {
	              var a = Math.min(ssd, iqr / 1.349);
	              return 1.059 * a * Math.pow(len, -0.2);
	            }
	            function calcBandwidth(trace, cdi, vals) {
	              var span = cdi.max - cdi.min;
	              if (!span) {
	                if (trace.bandwidth) {
	                  return trace.bandwidth;
	                } else {
	                  return 0;
	                }
	              }
	              if (trace.bandwidth) {
	                return Math.max(trace.bandwidth, span / 1e4);
	              } else {
	                var len = vals.length;
	                var ssd = Lib.stdev(vals, len - 1, cdi.mean);
	                return Math.max(silvermanRule(len, ssd, cdi.q3 - cdi.q1), span / 100);
	              }
	            }
	            function calcSpan(trace, cdi, valAxis, bandwidth) {
	              var spanmode = trace.spanmode;
	              var spanIn = trace.span || [];
	              var spanTight = [cdi.min, cdi.max];
	              var spanLoose = [cdi.min - 2 * bandwidth, cdi.max + 2 * bandwidth];
	              var spanOut;
	              function calcSpanItem(index) {
	                var s = spanIn[index];
	                var sc = valAxis.type === "multicategory" ? valAxis.r2c(s) : valAxis.d2c(s, 0, trace[cdi.valLetter + "calendar"]);
	                return sc === BADNUM ? spanLoose[index] : sc;
	              }
	              if (spanmode === "soft") {
	                spanOut = spanLoose;
	              } else if (spanmode === "hard") {
	                spanOut = spanTight;
	              } else {
	                spanOut = [calcSpanItem(0), calcSpanItem(1)];
	              }
	              var dummyAx = {
	                type: "linear",
	                range: spanOut
	              };
	              Axes.setConvert(dummyAx);
	              dummyAx.cleanRange();
	              return spanOut;
	            }
	          }
	        ),
	        /***/
	        86403: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var setPositionOffset = __webpack_require__2(37188).setPositionOffset;
	            var orientations = ["v", "h"];
	            module2.exports = function crossTraceCalc(gd, plotinfo) {
	              var calcdata = gd.calcdata;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              for (var i = 0; i < orientations.length; i++) {
	                var orientation = orientations[i];
	                var posAxis = orientation === "h" ? ya : xa;
	                var violinList = [];
	                for (var j = 0; j < calcdata.length; j++) {
	                  var cd = calcdata[j];
	                  var t = cd[0].t;
	                  var trace = cd[0].trace;
	                  if (trace.visible === true && trace.type === "violin" && !t.empty && trace.orientation === orientation && trace.xaxis === xa._id && trace.yaxis === ya._id) {
	                    violinList.push(j);
	                  }
	                }
	                setPositionOffset("violin", gd, violinList, posAxis);
	              }
	            };
	          }
	        ),
	        /***/
	        15899: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Color = __webpack_require__2(7901);
	            var boxDefaults = __webpack_require__2(36411);
	            var attributes = __webpack_require__2(68875);
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              function coerce2(attr, dflt) {
	                return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
	              }
	              boxDefaults.handleSampleDefaults(traceIn, traceOut, coerce, layout);
	              if (traceOut.visible === false) return;
	              coerce("bandwidth");
	              coerce("side");
	              var width = coerce("width");
	              if (!width) {
	                coerce("scalegroup", traceOut.name);
	                coerce("scalemode");
	              }
	              var span = coerce("span");
	              var spanmodeDflt;
	              if (Array.isArray(span)) spanmodeDflt = "manual";
	              coerce("spanmode", spanmodeDflt);
	              var lineColor = coerce("line.color", (traceIn.marker || {}).color || defaultColor);
	              var lineWidth = coerce("line.width");
	              var fillColor = coerce("fillcolor", Color.addOpacity(traceOut.line.color, 0.5));
	              boxDefaults.handlePointsDefaults(traceIn, traceOut, coerce, {
	                prefix: ""
	              });
	              var boxWidth = coerce2("box.width");
	              var boxFillColor = coerce2("box.fillcolor", fillColor);
	              var boxLineColor = coerce2("box.line.color", lineColor);
	              var boxLineWidth = coerce2("box.line.width", lineWidth);
	              var boxVisible = coerce("box.visible", Boolean(boxWidth || boxFillColor || boxLineColor || boxLineWidth));
	              if (!boxVisible) traceOut.box = {
	                visible: false
	              };
	              var meanLineColor = coerce2("meanline.color", lineColor);
	              var meanLineWidth = coerce2("meanline.width", lineWidth);
	              var meanLineVisible = coerce("meanline.visible", Boolean(meanLineColor || meanLineWidth));
	              if (!meanLineVisible) traceOut.meanline = {
	                visible: false
	              };
	              coerce("quartilemethod");
	            };
	          }
	        ),
	        /***/
	        60168: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var kernels = {
	              gaussian: function(v) {
	                return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * v * v);
	              }
	            };
	            exports2.makeKDE = function(calcItem, trace, vals) {
	              var len = vals.length;
	              var kernel = kernels.gaussian;
	              var bandwidth = calcItem.bandwidth;
	              var factor = 1 / (len * bandwidth);
	              return function(x) {
	                var sum = 0;
	                for (var i = 0; i < len; i++) {
	                  sum += kernel((x - vals[i]) / bandwidth);
	                }
	                return factor * sum;
	              };
	            };
	            exports2.getPositionOnKdePath = function(calcItem, trace, valuePx) {
	              var posLetter, valLetter;
	              if (trace.orientation === "h") {
	                posLetter = "y";
	                valLetter = "x";
	              } else {
	                posLetter = "x";
	                valLetter = "y";
	              }
	              var pointOnPath = Lib.findPointOnPath(calcItem.path, valuePx, valLetter, {
	                pathLength: calcItem.pathLength
	              });
	              var posCenterPx = calcItem.posCenterPx;
	              var posOnPath0 = pointOnPath[posLetter];
	              var posOnPath1 = trace.side === "both" ? 2 * posCenterPx - posOnPath0 : posCenterPx;
	              return [posOnPath0, posOnPath1];
	            };
	            exports2.getKdeValue = function(calcItem, trace, valueDist) {
	              var vals = calcItem.pts.map(exports2.extractVal);
	              var kde = exports2.makeKDE(calcItem, trace, vals);
	              return kde(valueDist) / calcItem.posDensityScale;
	            };
	            exports2.extractVal = function(o) {
	              return o.v;
	            };
	          }
	        ),
	        /***/
	        57634: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Color = __webpack_require__2(7901);
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var boxHoverPoints = __webpack_require__2(41868);
	            var helpers = __webpack_require__2(60168);
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              if (!opts) opts = {};
	              var hoverLayer = opts.hoverLayer;
	              var cd = pointData.cd;
	              var trace = cd[0].trace;
	              var hoveron = trace.hoveron;
	              var hasHoveronViolins = hoveron.indexOf("violins") !== -1;
	              var hasHoveronKDE = hoveron.indexOf("kde") !== -1;
	              var closeData = [];
	              var closePtData;
	              var violinLineAttrs;
	              if (hasHoveronViolins || hasHoveronKDE) {
	                var closeBoxData = boxHoverPoints.hoverOnBoxes(pointData, xval, yval, hovermode);
	                if (hasHoveronKDE && closeBoxData.length > 0) {
	                  var xa = pointData.xa;
	                  var ya = pointData.ya;
	                  var pLetter, vLetter, pAxis, vAxis, vVal;
	                  if (trace.orientation === "h") {
	                    vVal = xval;
	                    pLetter = "y";
	                    pAxis = ya;
	                    vLetter = "x";
	                    vAxis = xa;
	                  } else {
	                    vVal = yval;
	                    pLetter = "x";
	                    pAxis = xa;
	                    vLetter = "y";
	                    vAxis = ya;
	                  }
	                  var di = cd[pointData.index];
	                  if (vVal >= di.span[0] && vVal <= di.span[1]) {
	                    var kdePointData = Lib.extendFlat({}, pointData);
	                    var vValPx = vAxis.c2p(vVal, true);
	                    var kdeVal = helpers.getKdeValue(di, trace, vVal);
	                    var pOnPath = helpers.getPositionOnKdePath(di, trace, vValPx);
	                    var paOffset = pAxis._offset;
	                    var paLength = pAxis._length;
	                    kdePointData[pLetter + "0"] = pOnPath[0];
	                    kdePointData[pLetter + "1"] = pOnPath[1];
	                    kdePointData[vLetter + "0"] = kdePointData[vLetter + "1"] = vValPx;
	                    kdePointData[vLetter + "Label"] = vLetter + ": " + Axes.hoverLabelText(vAxis, vVal, trace[vLetter + "hoverformat"]) + ", " + cd[0].t.labels.kde + " " + kdeVal.toFixed(3);
	                    var medId = 0;
	                    for (var k = 0; k < closeBoxData.length; k++) {
	                      if (closeBoxData[k].attr === "med") {
	                        medId = k;
	                        break;
	                      }
	                    }
	                    kdePointData.spikeDistance = closeBoxData[medId].spikeDistance;
	                    var spikePosAttr = pLetter + "Spike";
	                    kdePointData[spikePosAttr] = closeBoxData[medId][spikePosAttr];
	                    closeBoxData[medId].spikeDistance = undefined;
	                    closeBoxData[medId][spikePosAttr] = undefined;
	                    kdePointData.hovertemplate = false;
	                    closeData.push(kdePointData);
	                    violinLineAttrs = {};
	                    violinLineAttrs[pLetter + "1"] = Lib.constrain(paOffset + pOnPath[0], paOffset, paOffset + paLength);
	                    violinLineAttrs[pLetter + "2"] = Lib.constrain(paOffset + pOnPath[1], paOffset, paOffset + paLength);
	                    violinLineAttrs[vLetter + "1"] = violinLineAttrs[vLetter + "2"] = vAxis._offset + vValPx;
	                  }
	                }
	                if (hasHoveronViolins) {
	                  closeData = closeData.concat(closeBoxData);
	                }
	              }
	              if (hoveron.indexOf("points") !== -1) {
	                closePtData = boxHoverPoints.hoverOnPoints(pointData, xval, yval);
	              }
	              var violinLine = hoverLayer.selectAll(".violinline-" + trace.uid).data(violinLineAttrs ? [0] : []);
	              violinLine.enter().append("line").classed("violinline-" + trace.uid, true).attr("stroke-width", 1.5);
	              violinLine.exit().remove();
	              violinLine.attr(violinLineAttrs).call(Color.stroke, pointData.color);
	              if (hovermode === "closest") {
	                if (closePtData) return [closePtData];
	                return closeData;
	              }
	              if (closePtData) {
	                closeData.push(closePtData);
	                return closeData;
	              }
	              return closeData;
	            };
	          }
	        ),
	        /***/
	        47462: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(68875),
	              layoutAttributes: __webpack_require__2(9228),
	              supplyDefaults: __webpack_require__2(15899),
	              crossTraceDefaults: __webpack_require__2(36411).crossTraceDefaults,
	              supplyLayoutDefaults: __webpack_require__2(33598),
	              calc: __webpack_require__2(38603),
	              crossTraceCalc: __webpack_require__2(86403),
	              plot: __webpack_require__2(28443),
	              style: __webpack_require__2(31847),
	              styleOnSelect: __webpack_require__2(16296).styleOnSelect,
	              hoverPoints: __webpack_require__2(57634),
	              selectPoints: __webpack_require__2(24626),
	              moduleType: "trace",
	              name: "violin",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["cartesian", "svg", "symbols", "oriented", "box-violin", "showLegend", "violinLayout", "zoomScale"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        9228: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var boxLayoutAttrs = __webpack_require__2(40094);
	            var extendFlat = __webpack_require__2(71828).extendFlat;
	            module2.exports = {
	              violinmode: extendFlat({}, boxLayoutAttrs.boxmode, {}),
	              violingap: extendFlat({}, boxLayoutAttrs.boxgap, {}),
	              violingroupgap: extendFlat({}, boxLayoutAttrs.boxgroupgap, {})
	            };
	          }
	        ),
	        /***/
	        33598: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(9228);
	            var boxLayoutDefaults = __webpack_require__2(4199);
	            module2.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              boxLayoutDefaults._supply(layoutIn, layoutOut, fullData, coerce, "violin");
	            };
	          }
	        ),
	        /***/
	        28443: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var boxPlot = __webpack_require__2(86047);
	            var linePoints = __webpack_require__2(34621);
	            var helpers = __webpack_require__2(60168);
	            module2.exports = function plot(gd, plotinfo, cdViolins, violinLayer) {
	              var isStatic = gd._context.staticPlot;
	              var fullLayout = gd._fullLayout;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              function makePath(pts, trace) {
	                var segments = linePoints(pts, {
	                  xaxis: xa,
	                  yaxis: ya,
	                  trace,
	                  connectGaps: true,
	                  baseTolerance: 0.75,
	                  shape: "spline",
	                  simplify: true,
	                  linearized: true
	                });
	                return Drawing.smoothopen(segments[0], 1);
	              }
	              Lib.makeTraceGroups(violinLayer, cdViolins, "trace violins").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var cd0 = cd[0];
	                var t = cd0.t;
	                var trace = cd0.trace;
	                if (trace.visible !== true || t.empty) {
	                  plotGroup.remove();
	                  return;
	                }
	                var bPos = t.bPos;
	                var bdPos = t.bdPos;
	                var valAxis = plotinfo[t.valLetter + "axis"];
	                var posAxis = plotinfo[t.posLetter + "axis"];
	                var hasBothSides = trace.side === "both";
	                var hasPositiveSide = hasBothSides || trace.side === "positive";
	                var hasNegativeSide = hasBothSides || trace.side === "negative";
	                var violins = plotGroup.selectAll("path.violin").data(Lib.identity);
	                violins.enter().append("path").style("vector-effect", isStatic ? "none" : "non-scaling-stroke").attr("class", "violin");
	                violins.exit().remove();
	                violins.each(function(d) {
	                  var pathSel = d3.select(this);
	                  var density = d.density;
	                  var len = density.length;
	                  var posCenter = posAxis.c2l(d.pos + bPos, true);
	                  var posCenterPx = posAxis.l2p(posCenter);
	                  var scale;
	                  if (trace.width) {
	                    scale = t.maxKDE / bdPos;
	                  } else {
	                    var groupStats = fullLayout._violinScaleGroupStats[trace.scalegroup];
	                    scale = trace.scalemode === "count" ? groupStats.maxKDE / bdPos * (groupStats.maxCount / d.pts.length) : groupStats.maxKDE / bdPos;
	                  }
	                  var pathPos, pathNeg, path;
	                  var i, k, pts, pt;
	                  if (hasPositiveSide) {
	                    pts = new Array(len);
	                    for (i = 0; i < len; i++) {
	                      pt = pts[i] = {};
	                      pt[t.posLetter] = posCenter + density[i].v / scale;
	                      pt[t.valLetter] = valAxis.c2l(density[i].t, true);
	                    }
	                    pathPos = makePath(pts, trace);
	                  }
	                  if (hasNegativeSide) {
	                    pts = new Array(len);
	                    for (k = 0, i = len - 1; k < len; k++, i--) {
	                      pt = pts[k] = {};
	                      pt[t.posLetter] = posCenter - density[i].v / scale;
	                      pt[t.valLetter] = valAxis.c2l(density[i].t, true);
	                    }
	                    pathNeg = makePath(pts, trace);
	                  }
	                  if (hasBothSides) {
	                    path = pathPos + "L" + pathNeg.substr(1) + "Z";
	                  } else {
	                    var startPt = [posCenterPx, valAxis.c2p(density[0].t)];
	                    var endPt = [posCenterPx, valAxis.c2p(density[len - 1].t)];
	                    if (trace.orientation === "h") {
	                      startPt.reverse();
	                      endPt.reverse();
	                    }
	                    if (hasPositiveSide) {
	                      path = "M" + startPt + "L" + pathPos.substr(1) + "L" + endPt;
	                    } else {
	                      path = "M" + endPt + "L" + pathNeg.substr(1) + "L" + startPt;
	                    }
	                  }
	                  pathSel.attr("d", path);
	                  d.posCenterPx = posCenterPx;
	                  d.posDensityScale = scale * bdPos;
	                  d.path = pathSel.node();
	                  d.pathLength = d.path.getTotalLength() / (hasBothSides ? 2 : 1);
	                });
	                var boxAttrs = trace.box;
	                var boxWidth = boxAttrs.width;
	                var boxLineWidth = (boxAttrs.line || {}).width;
	                var bdPosScaled;
	                var bPosPxOffset;
	                if (hasBothSides) {
	                  bdPosScaled = bdPos * boxWidth;
	                  bPosPxOffset = 0;
	                } else if (hasPositiveSide) {
	                  bdPosScaled = [0, bdPos * boxWidth / 2];
	                  bPosPxOffset = boxLineWidth * {
	                    x: 1,
	                    y: -1
	                  }[t.posLetter];
	                } else {
	                  bdPosScaled = [bdPos * boxWidth / 2, 0];
	                  bPosPxOffset = boxLineWidth * {
	                    x: -1,
	                    y: 1
	                  }[t.posLetter];
	                }
	                boxPlot.plotBoxAndWhiskers(plotGroup, {
	                  pos: posAxis,
	                  val: valAxis
	                }, trace, {
	                  bPos,
	                  bdPos: bdPosScaled,
	                  bPosPxOffset
	                });
	                boxPlot.plotBoxMean(plotGroup, {
	                  pos: posAxis,
	                  val: valAxis
	                }, trace, {
	                  bPos,
	                  bdPos: bdPosScaled,
	                  bPosPxOffset
	                });
	                var fn;
	                if (!trace.box.visible && trace.meanline.visible) {
	                  fn = Lib.identity;
	                }
	                var meanPaths = plotGroup.selectAll("path.meanline").data(fn || []);
	                meanPaths.enter().append("path").attr("class", "meanline").style("fill", "none").style("vector-effect", isStatic ? "none" : "non-scaling-stroke");
	                meanPaths.exit().remove();
	                meanPaths.each(function(d) {
	                  var v = valAxis.c2p(d.mean, true);
	                  var p = helpers.getPositionOnKdePath(d, trace, v);
	                  d3.select(this).attr("d", trace.orientation === "h" ? "M" + v + "," + p[0] + "V" + p[1] : "M" + p[0] + "," + v + "H" + p[1]);
	                });
	                boxPlot.plotPoints(plotGroup, {
	                  x: xa,
	                  y: ya
	                }, trace, t);
	              });
	            };
	          }
	        ),
	        /***/
	        31847: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Color = __webpack_require__2(7901);
	            var stylePoints = __webpack_require__2(16296).stylePoints;
	            module2.exports = function style(gd) {
	              var s = d3.select(gd).selectAll("g.trace.violins");
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              s.each(function(d) {
	                var trace = d[0].trace;
	                var sel = d3.select(this);
	                var box = trace.box || {};
	                var boxLine = box.line || {};
	                var meanline = trace.meanline || {};
	                var meanLineWidth = meanline.width;
	                sel.selectAll("path.violin").style("stroke-width", trace.line.width + "px").call(Color.stroke, trace.line.color).call(Color.fill, trace.fillcolor);
	                sel.selectAll("path.box").style("stroke-width", boxLine.width + "px").call(Color.stroke, boxLine.color).call(Color.fill, box.fillcolor);
	                var meanLineStyle = {
	                  "stroke-width": meanLineWidth + "px",
	                  "stroke-dasharray": 2 * meanLineWidth + "px," + meanLineWidth + "px"
	                };
	                sel.selectAll("path.mean").style(meanLineStyle).call(Color.stroke, meanline.color);
	                sel.selectAll("path.meanline").style(meanLineStyle).call(Color.stroke, meanline.color);
	                stylePoints(sel, trace, gd);
	              });
	            };
	          }
	        ),
	        /***/
	        16336: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var colorScaleAttrs = __webpack_require__2(50693);
	            var isosurfaceAttrs = __webpack_require__2(16249);
	            var surfaceAttrs = __webpack_require__2(54532);
	            var baseAttrs = __webpack_require__2(9012);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var overrideAll = __webpack_require__2(30962).overrideAll;
	            var attrs = module2.exports = overrideAll(extendFlat({
	              x: isosurfaceAttrs.x,
	              y: isosurfaceAttrs.y,
	              z: isosurfaceAttrs.z,
	              value: isosurfaceAttrs.value,
	              isomin: isosurfaceAttrs.isomin,
	              isomax: isosurfaceAttrs.isomax,
	              surface: isosurfaceAttrs.surface,
	              spaceframe: {
	                show: {
	                  valType: "boolean",
	                  dflt: false
	                },
	                fill: {
	                  valType: "number",
	                  min: 0,
	                  max: 1,
	                  dflt: 1
	                }
	              },
	              slices: isosurfaceAttrs.slices,
	              caps: isosurfaceAttrs.caps,
	              text: isosurfaceAttrs.text,
	              hovertext: isosurfaceAttrs.hovertext,
	              xhoverformat: isosurfaceAttrs.xhoverformat,
	              yhoverformat: isosurfaceAttrs.yhoverformat,
	              zhoverformat: isosurfaceAttrs.zhoverformat,
	              valuehoverformat: isosurfaceAttrs.valuehoverformat,
	              hovertemplate: isosurfaceAttrs.hovertemplate
	            }, colorScaleAttrs("", {
	              colorAttr: "`value`",
	              showScaleDflt: true,
	              editTypeOverride: "calc"
	            }), {
	              colorbar: isosurfaceAttrs.colorbar,
	              opacity: isosurfaceAttrs.opacity,
	              opacityscale: surfaceAttrs.opacityscale,
	              lightposition: isosurfaceAttrs.lightposition,
	              lighting: isosurfaceAttrs.lighting,
	              flatshading: isosurfaceAttrs.flatshading,
	              contour: isosurfaceAttrs.contour,
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo),
	              showlegend: extendFlat({}, baseAttrs.showlegend, {
	                dflt: false
	              })
	            }), "calc", "nested");
	            attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = "calc+clearAxisTypes";
	            attrs.transforms = undefined;
	          }
	        ),
	        /***/
	        64809: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createMesh = __webpack_require__2(9330).gl_mesh3d;
	            var parseColorScale = __webpack_require__2(81697).parseColorScale;
	            var str2RgbaArray = __webpack_require__2(78614);
	            var extractOpts = __webpack_require__2(21081).extractOpts;
	            var zip3 = __webpack_require__2(90060);
	            var findNearestOnAxis = __webpack_require__2(22674).findNearestOnAxis;
	            var generateIsoMeshes = __webpack_require__2(22674).generateIsoMeshes;
	            function VolumeTrace(scene, mesh, uid) {
	              this.scene = scene;
	              this.uid = uid;
	              this.mesh = mesh;
	              this.name = "";
	              this.data = null;
	              this.showContour = false;
	            }
	            var proto = VolumeTrace.prototype;
	            proto.handlePick = function(selection) {
	              if (selection.object === this.mesh) {
	                var rawId = selection.data.index;
	                var x = this.data._meshX[rawId];
	                var y = this.data._meshY[rawId];
	                var z = this.data._meshZ[rawId];
	                var height = this.data._Ys.length;
	                var depth = this.data._Zs.length;
	                var i = findNearestOnAxis(x, this.data._Xs).id;
	                var j = findNearestOnAxis(y, this.data._Ys).id;
	                var k = findNearestOnAxis(z, this.data._Zs).id;
	                var selectIndex = selection.index = k + depth * j + depth * height * i;
	                selection.traceCoordinate = [this.data._meshX[selectIndex], this.data._meshY[selectIndex], this.data._meshZ[selectIndex], this.data._value[selectIndex]];
	                var text = this.data.hovertext || this.data.text;
	                if (Array.isArray(text) && text[selectIndex] !== undefined) {
	                  selection.textLabel = text[selectIndex];
	                } else if (text) {
	                  selection.textLabel = text;
	                }
	                return true;
	              }
	            };
	            proto.update = function(data) {
	              var scene = this.scene;
	              var layout = scene.fullSceneLayout;
	              this.data = generateIsoMeshes(data);
	              function toDataCoords(axis, coord, scale, calendar) {
	                return coord.map(function(x) {
	                  return axis.d2l(x, 0, calendar) * scale;
	                });
	              }
	              var positions = zip3(toDataCoords(layout.xaxis, data._meshX, scene.dataScale[0], data.xcalendar), toDataCoords(layout.yaxis, data._meshY, scene.dataScale[1], data.ycalendar), toDataCoords(layout.zaxis, data._meshZ, scene.dataScale[2], data.zcalendar));
	              var cells = zip3(data._meshI, data._meshJ, data._meshK);
	              var config = {
	                positions,
	                cells,
	                lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
	                ambient: data.lighting.ambient,
	                diffuse: data.lighting.diffuse,
	                specular: data.lighting.specular,
	                roughness: data.lighting.roughness,
	                fresnel: data.lighting.fresnel,
	                vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
	                faceNormalsEpsilon: data.lighting.facenormalsepsilon,
	                opacity: data.opacity,
	                opacityscale: data.opacityscale,
	                contourEnable: data.contour.show,
	                contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
	                contourWidth: data.contour.width,
	                useFacetNormals: data.flatshading
	              };
	              var cOpts = extractOpts(data);
	              config.vertexIntensity = data._meshIntensity;
	              config.vertexIntensityBounds = [cOpts.min, cOpts.max];
	              config.colormap = parseColorScale(data);
	              this.mesh.update(config);
	            };
	            proto.dispose = function() {
	              this.scene.glplot.remove(this.mesh);
	              this.mesh.dispose();
	            };
	            function createVolumeTrace(scene, data) {
	              var gl2 = scene.glplot.gl;
	              var mesh = createMesh({
	                gl: gl2
	              });
	              var result = new VolumeTrace(scene, mesh, data.uid);
	              mesh._trace = result;
	              result.update(data);
	              scene.glplot.add(mesh);
	              return result;
	            }
	            module2.exports = createVolumeTrace;
	          }
	        ),
	        /***/
	        47651: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var attributes = __webpack_require__2(16336);
	            var supplyIsoDefaults = __webpack_require__2(82738).supplyIsoDefaults;
	            var opacityscaleDefaults = __webpack_require__2(91831).opacityscaleDefaults;
	            module2.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
	              opacityscaleDefaults(traceIn, traceOut, layout, coerce);
	            };
	          }
	        ),
	        /***/
	        17659: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(16336),
	              supplyDefaults: __webpack_require__2(47651),
	              calc: __webpack_require__2(56959),
	              colorbar: {
	                min: "cmin",
	                max: "cmax"
	              },
	              plot: __webpack_require__2(64809),
	              moduleType: "trace",
	              name: "volume",
	              basePlotModule: __webpack_require__2(58547),
	              categories: ["gl3d", "showLegend"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        43037: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var barAttrs = __webpack_require__2(1486);
	            var lineAttrs = __webpack_require__2(82196).line;
	            var baseAttrs = __webpack_require__2(9012);
	            var axisHoverFormat = __webpack_require__2(12663).axisHoverFormat;
	            var hovertemplateAttrs = __webpack_require__2(5386).fF;
	            var texttemplateAttrs = __webpack_require__2(5386).si;
	            var constants = __webpack_require__2(48334);
	            var extendFlat = __webpack_require__2(1426).extendFlat;
	            var Color = __webpack_require__2(7901);
	            function directionAttrs(dirTxt) {
	              return {
	                marker: {
	                  color: extendFlat({}, barAttrs.marker.color, {
	                    arrayOk: false,
	                    editType: "style"
	                  }),
	                  line: {
	                    color: extendFlat({}, barAttrs.marker.line.color, {
	                      arrayOk: false,
	                      editType: "style"
	                    }),
	                    width: extendFlat({}, barAttrs.marker.line.width, {
	                      arrayOk: false,
	                      editType: "style"
	                    }),
	                    editType: "style"
	                  },
	                  editType: "style"
	                },
	                editType: "style"
	              };
	            }
	            module2.exports = {
	              measure: {
	                valType: "data_array",
	                dflt: [],
	                editType: "calc"
	              },
	              base: {
	                valType: "number",
	                dflt: null,
	                arrayOk: false,
	                editType: "calc"
	              },
	              x: barAttrs.x,
	              x0: barAttrs.x0,
	              dx: barAttrs.dx,
	              y: barAttrs.y,
	              y0: barAttrs.y0,
	              dy: barAttrs.dy,
	              xperiod: barAttrs.xperiod,
	              yperiod: barAttrs.yperiod,
	              xperiod0: barAttrs.xperiod0,
	              yperiod0: barAttrs.yperiod0,
	              xperiodalignment: barAttrs.xperiodalignment,
	              yperiodalignment: barAttrs.yperiodalignment,
	              xhoverformat: axisHoverFormat("x"),
	              yhoverformat: axisHoverFormat("y"),
	              hovertext: barAttrs.hovertext,
	              hovertemplate: hovertemplateAttrs({}, {
	                keys: constants.eventDataKeys
	              }),
	              hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
	                flags: ["name", "x", "y", "text", "initial", "delta", "final"]
	              }),
	              textinfo: {
	                valType: "flaglist",
	                flags: ["label", "text", "initial", "delta", "final"],
	                extras: ["none"],
	                editType: "plot",
	                arrayOk: false
	              },
	              // TODO: incorporate `label` and `value` in the eventData
	              texttemplate: texttemplateAttrs({
	                editType: "plot"
	              }, {
	                keys: constants.eventDataKeys.concat(["label"])
	              }),
	              text: barAttrs.text,
	              textposition: barAttrs.textposition,
	              insidetextanchor: barAttrs.insidetextanchor,
	              textangle: barAttrs.textangle,
	              textfont: barAttrs.textfont,
	              insidetextfont: barAttrs.insidetextfont,
	              outsidetextfont: barAttrs.outsidetextfont,
	              constraintext: barAttrs.constraintext,
	              cliponaxis: barAttrs.cliponaxis,
	              orientation: barAttrs.orientation,
	              offset: barAttrs.offset,
	              width: barAttrs.width,
	              increasing: directionAttrs(),
	              decreasing: directionAttrs(),
	              totals: directionAttrs(),
	              connector: {
	                line: {
	                  color: extendFlat({}, lineAttrs.color, {
	                    dflt: Color.defaultLine
	                  }),
	                  width: extendFlat({}, lineAttrs.width, {
	                    editType: "plot"
	                    // i.e. to adjust bars is mode: 'between'. See https://github.com/plotly/plotly.js/issues/3787
	                  }),
	                  dash: lineAttrs.dash,
	                  editType: "plot"
	                },
	                mode: {
	                  valType: "enumerated",
	                  values: ["spanning", "between"],
	                  dflt: "between",
	                  editType: "plot"
	                },
	                visible: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "plot"
	                },
	                editType: "plot"
	              },
	              offsetgroup: barAttrs.offsetgroup,
	              alignmentgroup: barAttrs.alignmentgroup
	            };
	          }
	        ),
	        /***/
	        52752: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var alignPeriod = __webpack_require__2(42973);
	            var mergeArray = __webpack_require__2(71828).mergeArray;
	            var calcSelection = __webpack_require__2(66279);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            function isAbsolute(a) {
	              return a === "a" || a === "absolute";
	            }
	            function isTotal(a) {
	              return a === "t" || a === "total";
	            }
	            module2.exports = function calc(gd, trace) {
	              var xa = Axes.getFromId(gd, trace.xaxis || "x");
	              var ya = Axes.getFromId(gd, trace.yaxis || "y");
	              var size, pos, origPos, pObj, hasPeriod, pLetter;
	              if (trace.orientation === "h") {
	                size = xa.makeCalcdata(trace, "x");
	                origPos = ya.makeCalcdata(trace, "y");
	                pObj = alignPeriod(trace, ya, "y", origPos);
	                hasPeriod = !!trace.yperiodalignment;
	                pLetter = "y";
	              } else {
	                size = ya.makeCalcdata(trace, "y");
	                origPos = xa.makeCalcdata(trace, "x");
	                pObj = alignPeriod(trace, xa, "x", origPos);
	                hasPeriod = !!trace.xperiodalignment;
	                pLetter = "x";
	              }
	              pos = pObj.vals;
	              var serieslen = Math.min(pos.length, size.length);
	              var cd = new Array(serieslen);
	              var previousSum = 0;
	              var newSize;
	              var hasTotals = false;
	              for (var i = 0; i < serieslen; i++) {
	                var amount = size[i] || 0;
	                var connectToNext = false;
	                if (size[i] !== BADNUM || isTotal(trace.measure[i]) || isAbsolute(trace.measure[i])) {
	                  if (i + 1 < serieslen && (size[i + 1] !== BADNUM || isTotal(trace.measure[i + 1]) || isAbsolute(trace.measure[i + 1]))) {
	                    connectToNext = true;
	                  }
	                }
	                var cdi = cd[i] = {
	                  i,
	                  p: pos[i],
	                  s: amount,
	                  rawS: amount,
	                  cNext: connectToNext
	                };
	                if (isAbsolute(trace.measure[i])) {
	                  previousSum = cdi.s;
	                  cdi.isSum = true;
	                  cdi.dir = "totals";
	                  cdi.s = previousSum;
	                } else if (isTotal(trace.measure[i])) {
	                  cdi.isSum = true;
	                  cdi.dir = "totals";
	                  cdi.s = previousSum;
	                } else {
	                  cdi.isSum = false;
	                  cdi.dir = cdi.rawS < 0 ? "decreasing" : "increasing";
	                  newSize = cdi.s;
	                  cdi.s = previousSum + newSize;
	                  previousSum += newSize;
	                }
	                if (cdi.dir === "totals") {
	                  hasTotals = true;
	                }
	                if (hasPeriod) {
	                  cd[i].orig_p = origPos[i];
	                  cd[i][pLetter + "End"] = pObj.ends[i];
	                  cd[i][pLetter + "Start"] = pObj.starts[i];
	                }
	                if (trace.ids) {
	                  cdi.id = String(trace.ids[i]);
	                }
	                cdi.v = (trace.base || 0) + previousSum;
	              }
	              if (cd.length) cd[0].hasTotals = hasTotals;
	              mergeArray(trace.text, cd, "tx");
	              mergeArray(trace.hovertext, cd, "htx");
	              calcSelection(cd, trace);
	              return cd;
	            };
	          }
	        ),
	        /***/
	        48334: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              eventDataKeys: ["initial", "delta", "final"]
	            };
	          }
	        ),
	        /***/
	        70766: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var setGroupPositions = __webpack_require__2(11661).setGroupPositions;
	            module2.exports = function crossTraceCalc(gd, plotinfo) {
	              var fullLayout = gd._fullLayout;
	              var fullData = gd._fullData;
	              var calcdata = gd.calcdata;
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              var waterfalls = [];
	              var waterfallsVert = [];
	              var waterfallsHorz = [];
	              var cd, i;
	              for (i = 0; i < fullData.length; i++) {
	                var fullTrace = fullData[i];
	                if (fullTrace.visible === true && fullTrace.xaxis === xa._id && fullTrace.yaxis === ya._id && fullTrace.type === "waterfall") {
	                  cd = calcdata[i];
	                  if (fullTrace.orientation === "h") {
	                    waterfallsHorz.push(cd);
	                  } else {
	                    waterfallsVert.push(cd);
	                  }
	                  waterfalls.push(cd);
	                }
	              }
	              var opts = {
	                mode: fullLayout.waterfallmode,
	                norm: fullLayout.waterfallnorm,
	                gap: fullLayout.waterfallgap,
	                groupgap: fullLayout.waterfallgroupgap
	              };
	              setGroupPositions(gd, xa, ya, waterfallsVert, opts);
	              setGroupPositions(gd, ya, xa, waterfallsHorz, opts);
	              for (i = 0; i < waterfalls.length; i++) {
	                cd = waterfalls[i];
	                for (var j = 0; j < cd.length; j++) {
	                  var di = cd[j];
	                  if (di.isSum === false) {
	                    di.s0 += j === 0 ? 0 : cd[j - 1].s;
	                  }
	                  if (j + 1 < cd.length) {
	                    cd[j].nextP0 = cd[j + 1].p0;
	                    cd[j].nextS0 = cd[j + 1].s0;
	                  }
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        83266: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var handleGroupingDefaults = __webpack_require__2(26125);
	            var handleText = __webpack_require__2(90769).handleText;
	            var handleXYDefaults = __webpack_require__2(67513);
	            var handlePeriodDefaults = __webpack_require__2(73927);
	            var attributes = __webpack_require__2(43037);
	            var Color = __webpack_require__2(7901);
	            var delta = __webpack_require__2(22372);
	            var INCREASING_COLOR = delta.INCREASING.COLOR;
	            var DECREASING_COLOR = delta.DECREASING.COLOR;
	            var TOTALS_COLOR = "#4499FF";
	            function handleDirection(coerce, direction, defaultColor) {
	              coerce(direction + ".marker.color", defaultColor);
	              coerce(direction + ".marker.line.color", Color.defaultLine);
	              coerce(direction + ".marker.line.width");
	            }
	            function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
	              function coerce(attr, dflt) {
	                return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
	              }
	              var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
	              if (!len) {
	                traceOut.visible = false;
	                return;
	              }
	              handlePeriodDefaults(traceIn, traceOut, layout, coerce);
	              coerce("xhoverformat");
	              coerce("yhoverformat");
	              coerce("measure");
	              coerce("orientation", traceOut.x && !traceOut.y ? "h" : "v");
	              coerce("base");
	              coerce("offset");
	              coerce("width");
	              coerce("text");
	              coerce("hovertext");
	              coerce("hovertemplate");
	              var textposition = coerce("textposition");
	              handleText(traceIn, traceOut, layout, coerce, textposition, {
	                moduleHasSelected: false,
	                moduleHasUnselected: false,
	                moduleHasConstrain: true,
	                moduleHasCliponaxis: true,
	                moduleHasTextangle: true,
	                moduleHasInsideanchor: true
	              });
	              if (traceOut.textposition !== "none") {
	                coerce("texttemplate");
	                if (!traceOut.texttemplate) coerce("textinfo");
	              }
	              handleDirection(coerce, "increasing", INCREASING_COLOR);
	              handleDirection(coerce, "decreasing", DECREASING_COLOR);
	              handleDirection(coerce, "totals", TOTALS_COLOR);
	              var connectorVisible = coerce("connector.visible");
	              if (connectorVisible) {
	                coerce("connector.mode");
	                var connectorLineWidth = coerce("connector.line.width");
	                if (connectorLineWidth) {
	                  coerce("connector.line.color");
	                  coerce("connector.line.dash");
	                }
	              }
	            }
	            function crossTraceDefaults(fullData, fullLayout) {
	              var traceIn, traceOut;
	              function coerce(attr) {
	                return Lib.coerce(traceOut._input, traceOut, attributes, attr);
	              }
	              if (fullLayout.waterfallmode === "group") {
	                for (var i = 0; i < fullData.length; i++) {
	                  traceOut = fullData[i];
	                  traceIn = traceOut._input;
	                  handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
	                }
	              }
	            }
	            module2.exports = {
	              supplyDefaults,
	              crossTraceDefaults
	            };
	          }
	        ),
	        /***/
	        58593: (
	          /***/
	          function(module2) {
	            module2.exports = function eventData(out, pt) {
	              out.x = "xVal" in pt ? pt.xVal : pt.x;
	              out.y = "yVal" in pt ? pt.yVal : pt.y;
	              if ("initial" in pt) out.initial = pt.initial;
	              if ("delta" in pt) out.delta = pt.delta;
	              if ("final" in pt) out.final = pt.final;
	              if (pt.xa) out.xaxis = pt.xa;
	              if (pt.ya) out.yaxis = pt.ya;
	              return out;
	            };
	          }
	        ),
	        /***/
	        61326: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hoverLabelText = __webpack_require__2(89298).hoverLabelText;
	            var opacity = __webpack_require__2(7901).opacity;
	            var hoverOnBars = __webpack_require__2(95423).hoverOnBars;
	            var delta = __webpack_require__2(22372);
	            var DIRSYMBOL = {
	              increasing: delta.INCREASING.SYMBOL,
	              decreasing: delta.DECREASING.SYMBOL
	            };
	            module2.exports = function hoverPoints(pointData, xval, yval, hovermode, opts) {
	              var point = hoverOnBars(pointData, xval, yval, hovermode, opts);
	              if (!point) return;
	              var cd = point.cd;
	              var trace = cd[0].trace;
	              var isHorizontal = trace.orientation === "h";
	              var vLetter = isHorizontal ? "x" : "y";
	              var vAxis = isHorizontal ? pointData.xa : pointData.ya;
	              function formatNumber(a) {
	                return hoverLabelText(vAxis, a, trace[vLetter + "hoverformat"]);
	              }
	              var index = point.index;
	              var di = cd[index];
	              var size = di.isSum ? di.b + di.s : di.rawS;
	              point.initial = di.b + di.s - size;
	              point.delta = size;
	              point.final = point.initial + point.delta;
	              var v = formatNumber(Math.abs(point.delta));
	              point.deltaLabel = size < 0 ? "(" + v + ")" : v;
	              point.finalLabel = formatNumber(point.final);
	              point.initialLabel = formatNumber(point.initial);
	              var hoverinfo = di.hi || trace.hoverinfo;
	              var text = [];
	              if (hoverinfo && hoverinfo !== "none" && hoverinfo !== "skip") {
	                var isAll = hoverinfo === "all";
	                var parts = hoverinfo.split("+");
	                var hasFlag = function(flag) {
	                  return isAll || parts.indexOf(flag) !== -1;
	                };
	                if (!di.isSum) {
	                  if (hasFlag("final") && (isHorizontal ? !hasFlag("x") : !hasFlag("y"))) {
	                    text.push(point.finalLabel);
	                  }
	                  if (hasFlag("delta")) {
	                    if (size < 0) {
	                      text.push(point.deltaLabel + " " + DIRSYMBOL.decreasing);
	                    } else {
	                      text.push(point.deltaLabel + " " + DIRSYMBOL.increasing);
	                    }
	                  }
	                  if (hasFlag("initial")) {
	                    text.push("Initial: " + point.initialLabel);
	                  }
	                }
	              }
	              if (text.length) point.extraText = text.join("<br>");
	              point.color = getTraceColor(trace, di);
	              return [point];
	            };
	            function getTraceColor(trace, di) {
	              var cont = trace[di.dir].marker;
	              var mc = cont.color;
	              var mlc = cont.line.color;
	              var mlw = cont.line.width;
	              if (opacity(mc)) return mc;
	              else if (opacity(mlc) && mlw) return mlc;
	            }
	          }
	        ),
	        /***/
	        19990: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              attributes: __webpack_require__2(43037),
	              layoutAttributes: __webpack_require__2(13494),
	              supplyDefaults: __webpack_require__2(83266).supplyDefaults,
	              crossTraceDefaults: __webpack_require__2(83266).crossTraceDefaults,
	              supplyLayoutDefaults: __webpack_require__2(5176),
	              calc: __webpack_require__2(52752),
	              crossTraceCalc: __webpack_require__2(70766),
	              plot: __webpack_require__2(30436),
	              style: __webpack_require__2(55750).style,
	              hoverPoints: __webpack_require__2(61326),
	              eventData: __webpack_require__2(58593),
	              selectPoints: __webpack_require__2(81974),
	              moduleType: "trace",
	              name: "waterfall",
	              basePlotModule: __webpack_require__2(93612),
	              categories: ["bar-like", "cartesian", "svg", "oriented", "showLegend", "zoomScale"],
	              meta: {}
	            };
	          }
	        ),
	        /***/
	        13494: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              waterfallmode: {
	                valType: "enumerated",
	                values: ["group", "overlay"],
	                dflt: "group",
	                editType: "calc"
	              },
	              waterfallgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                editType: "calc"
	              },
	              waterfallgroupgap: {
	                valType: "number",
	                min: 0,
	                max: 1,
	                dflt: 0,
	                editType: "calc"
	              }
	            };
	          }
	        ),
	        /***/
	        5176: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var layoutAttributes = __webpack_require__2(13494);
	            module2.exports = function(layoutIn, layoutOut, fullData) {
	              var hasTraceType = false;
	              function coerce(attr, dflt) {
	                return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
	              }
	              for (var i = 0; i < fullData.length; i++) {
	                var trace = fullData[i];
	                if (trace.visible && trace.type === "waterfall") {
	                  hasTraceType = true;
	                  break;
	                }
	              }
	              if (hasTraceType) {
	                coerce("waterfallmode");
	                coerce("waterfallgap", 0.2);
	                coerce("waterfallgroupgap");
	              }
	            };
	          }
	        ),
	        /***/
	        30436: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Lib = __webpack_require__2(71828);
	            var Drawing = __webpack_require__2(91424);
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            var barPlot = __webpack_require__2(17295);
	            var clearMinTextSize = __webpack_require__2(72597).clearMinTextSize;
	            module2.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
	              var fullLayout = gd._fullLayout;
	              clearMinTextSize("waterfall", fullLayout);
	              barPlot.plot(gd, plotinfo, cdModule, traceLayer, {
	                mode: fullLayout.waterfallmode,
	                norm: fullLayout.waterfallmode,
	                gap: fullLayout.waterfallgap,
	                groupgap: fullLayout.waterfallgroupgap
	              });
	              plotConnectors(gd, plotinfo, cdModule, traceLayer);
	            };
	            function plotConnectors(gd, plotinfo, cdModule, traceLayer) {
	              var xa = plotinfo.xaxis;
	              var ya = plotinfo.yaxis;
	              Lib.makeTraceGroups(traceLayer, cdModule, "trace bars").each(function(cd) {
	                var plotGroup = d3.select(this);
	                var trace = cd[0].trace;
	                var group = Lib.ensureSingle(plotGroup, "g", "lines");
	                if (!trace.connector || !trace.connector.visible) {
	                  group.remove();
	                  return;
	                }
	                var isHorizontal = trace.orientation === "h";
	                var mode = trace.connector.mode;
	                var connectors = group.selectAll("g.line").data(Lib.identity);
	                connectors.enter().append("g").classed("line", true);
	                connectors.exit().remove();
	                var len = connectors.size();
	                connectors.each(function(di, i) {
	                  if (i !== len - 1 && !di.cNext) return;
	                  var xy = getXY(di, xa, ya, isHorizontal);
	                  var x = xy[0];
	                  var y = xy[1];
	                  var shape = "";
	                  if (x[0] !== BADNUM && y[0] !== BADNUM && x[1] !== BADNUM && y[1] !== BADNUM) {
	                    if (mode === "spanning") {
	                      if (!di.isSum && i > 0) {
	                        if (isHorizontal) {
	                          shape += "M" + x[0] + "," + y[1] + "V" + y[0];
	                        } else {
	                          shape += "M" + x[1] + "," + y[0] + "H" + x[0];
	                        }
	                      }
	                    }
	                    if (mode !== "between") {
	                      if (di.isSum || i < len - 1) {
	                        if (isHorizontal) {
	                          shape += "M" + x[1] + "," + y[0] + "V" + y[1];
	                        } else {
	                          shape += "M" + x[0] + "," + y[1] + "H" + x[1];
	                        }
	                      }
	                    }
	                    if (x[2] !== BADNUM && y[2] !== BADNUM) {
	                      if (isHorizontal) {
	                        shape += "M" + x[1] + "," + y[1] + "V" + y[2];
	                      } else {
	                        shape += "M" + x[1] + "," + y[1] + "H" + x[2];
	                      }
	                    }
	                  }
	                  if (shape === "") shape = "M0,0Z";
	                  Lib.ensureSingle(d3.select(this), "path").attr("d", shape).call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
	                });
	              });
	            }
	            function getXY(di, xa, ya, isHorizontal) {
	              var s = [];
	              var p = [];
	              var sAxis = isHorizontal ? xa : ya;
	              var pAxis = isHorizontal ? ya : xa;
	              s[0] = sAxis.c2p(di.s0, true);
	              p[0] = pAxis.c2p(di.p0, true);
	              s[1] = sAxis.c2p(di.s1, true);
	              p[1] = pAxis.c2p(di.p1, true);
	              s[2] = sAxis.c2p(di.nextS0, true);
	              p[2] = pAxis.c2p(di.nextP0, true);
	              return isHorizontal ? [s, p] : [p, s];
	            }
	          }
	        ),
	        /***/
	        55750: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d3 = __webpack_require__2(39898);
	            var Drawing = __webpack_require__2(91424);
	            var Color = __webpack_require__2(7901);
	            var DESELECTDIM = __webpack_require__2(37822).DESELECTDIM;
	            var barStyle = __webpack_require__2(16688);
	            var resizeText = __webpack_require__2(72597).resizeText;
	            var styleTextPoints = barStyle.styleTextPoints;
	            function style(gd, cd, sel) {
	              var s = sel ? sel : d3.select(gd).selectAll("g.waterfalllayer").selectAll("g.trace");
	              resizeText(gd, s, "waterfall");
	              s.style("opacity", function(d) {
	                return d[0].trace.opacity;
	              });
	              s.each(function(d) {
	                var gTrace = d3.select(this);
	                var trace = d[0].trace;
	                gTrace.selectAll(".point > path").each(function(di) {
	                  if (!di.isBlank) {
	                    var cont = trace[di.dir].marker;
	                    d3.select(this).call(Color.fill, cont.color).call(Color.stroke, cont.line.color).call(Drawing.dashLine, cont.line.dash, cont.line.width).style("opacity", trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
	                  }
	                });
	                styleTextPoints(gTrace, trace, gd);
	                gTrace.selectAll(".lines").each(function() {
	                  var cont = trace.connector.line;
	                  Drawing.lineGroupStyle(d3.select(this).selectAll("path"), cont.width, cont.color, cont.dash);
	                });
	              });
	            }
	            module2.exports = {
	              style
	            };
	          }
	        ),
	        /***/
	        82887: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Axes = __webpack_require__2(89298);
	            var Lib = __webpack_require__2(71828);
	            var PlotSchema = __webpack_require__2(86281);
	            var pointsAccessorFunction = __webpack_require__2(79344).p;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            exports2.moduleType = "transform";
	            exports2.name = "aggregate";
	            var attrs = exports2.attributes = {
	              enabled: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              groups: {
	                // TODO: groupby should support string or array grouping this way too
	                // currently groupby only allows a grouping array
	                valType: "string",
	                strict: true,
	                noBlank: true,
	                arrayOk: true,
	                dflt: "x",
	                editType: "calc"
	              },
	              aggregations: {
	                _isLinkedToArray: "aggregation",
	                target: {
	                  valType: "string",
	                  editType: "calc"
	                },
	                func: {
	                  valType: "enumerated",
	                  values: ["count", "sum", "avg", "median", "mode", "rms", "stddev", "min", "max", "first", "last", "change", "range"],
	                  dflt: "first",
	                  editType: "calc"
	                },
	                funcmode: {
	                  valType: "enumerated",
	                  values: ["sample", "population"],
	                  dflt: "sample",
	                  editType: "calc"
	                },
	                enabled: {
	                  valType: "boolean",
	                  dflt: true,
	                  editType: "calc"
	                },
	                editType: "calc"
	              },
	              editType: "calc"
	            };
	            var aggAttrs = attrs.aggregations;
	            exports2.supplyDefaults = function(transformIn, traceOut) {
	              var transformOut = {};
	              var i;
	              function coerce(attr, dflt) {
	                return Lib.coerce(transformIn, transformOut, attrs, attr, dflt);
	              }
	              var enabled = coerce("enabled");
	              if (!enabled) return transformOut;
	              var arrayAttrArray = PlotSchema.findArrayAttributes(traceOut);
	              var arrayAttrs = {};
	              for (i = 0; i < arrayAttrArray.length; i++) arrayAttrs[arrayAttrArray[i]] = 1;
	              var groups = coerce("groups");
	              if (!Array.isArray(groups)) {
	                if (!arrayAttrs[groups]) {
	                  transformOut.enabled = false;
	                  return transformOut;
	                }
	                arrayAttrs[groups] = 0;
	              }
	              var aggregationsIn = transformIn.aggregations || [];
	              var aggregationsOut = transformOut.aggregations = new Array(aggregationsIn.length);
	              var aggregationOut;
	              function coercei(attr, dflt) {
	                return Lib.coerce(aggregationsIn[i], aggregationOut, aggAttrs, attr, dflt);
	              }
	              for (i = 0; i < aggregationsIn.length; i++) {
	                aggregationOut = {
	                  _index: i
	                };
	                var target = coercei("target");
	                var func = coercei("func");
	                var enabledi = coercei("enabled");
	                if (enabledi && target && (arrayAttrs[target] || func === "count" && arrayAttrs[target] === undefined)) {
	                  if (func === "stddev") coercei("funcmode");
	                  arrayAttrs[target] = 0;
	                  aggregationsOut[i] = aggregationOut;
	                } else aggregationsOut[i] = {
	                  enabled: false,
	                  _index: i
	                };
	              }
	              for (i = 0; i < arrayAttrArray.length; i++) {
	                if (arrayAttrs[arrayAttrArray[i]]) {
	                  aggregationsOut.push({
	                    target: arrayAttrArray[i],
	                    func: aggAttrs.func.dflt,
	                    enabled: true,
	                    _index: -1
	                  });
	                }
	              }
	              return transformOut;
	            };
	            exports2.calcTransform = function(gd, trace, opts) {
	              if (!opts.enabled) return;
	              var groups = opts.groups;
	              var groupArray = Lib.getTargetArray(trace, {
	                target: groups
	              });
	              if (!groupArray) return;
	              var i, vi, groupIndex, newGrouping;
	              var groupIndices = {};
	              var indexToPoints = {};
	              var groupings = [];
	              var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	              var len = groupArray.length;
	              if (trace._length) len = Math.min(len, trace._length);
	              for (i = 0; i < len; i++) {
	                vi = groupArray[i];
	                groupIndex = groupIndices[vi];
	                if (groupIndex === undefined) {
	                  groupIndices[vi] = groupings.length;
	                  newGrouping = [i];
	                  groupings.push(newGrouping);
	                  indexToPoints[groupIndices[vi]] = originalPointsAccessor(i);
	                } else {
	                  groupings[groupIndex].push(i);
	                  indexToPoints[groupIndices[vi]] = (indexToPoints[groupIndices[vi]] || []).concat(originalPointsAccessor(i));
	                }
	              }
	              opts._indexToPoints = indexToPoints;
	              var aggregations = opts.aggregations;
	              for (i = 0; i < aggregations.length; i++) {
	                aggregateOneArray(gd, trace, groupings, aggregations[i]);
	              }
	              if (typeof groups === "string") {
	                aggregateOneArray(gd, trace, groupings, {
	                  target: groups,
	                  func: "first",
	                  enabled: true
	                });
	              }
	              trace._length = groupings.length;
	            };
	            function aggregateOneArray(gd, trace, groupings, aggregation) {
	              if (!aggregation.enabled) return;
	              var attr = aggregation.target;
	              var targetNP = Lib.nestedProperty(trace, attr);
	              var arrayIn = targetNP.get();
	              var conversions = Axes.getDataConversions(gd, trace, attr, arrayIn);
	              var func = getAggregateFunction(aggregation, conversions);
	              var arrayOut = new Array(groupings.length);
	              for (var i = 0; i < groupings.length; i++) {
	                arrayOut[i] = func(arrayIn, groupings[i]);
	              }
	              targetNP.set(arrayOut);
	              if (aggregation.func === "count") {
	                Lib.pushUnique(trace._arrayAttrs, attr);
	              }
	            }
	            function getAggregateFunction(opts, conversions) {
	              var func = opts.func;
	              var d2c = conversions.d2c;
	              var c2d = conversions.c2d;
	              switch (func) {
	                case "count":
	                  return count;
	                case "first":
	                  return first;
	                case "last":
	                  return last;
	                case "sum":
	                  return function(array, indices) {
	                    var total = 0;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) total += vi;
	                    }
	                    return c2d(total);
	                  };
	                case "avg":
	                  return function(array, indices) {
	                    var total = 0;
	                    var cnt = 0;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) {
	                        total += vi;
	                        cnt++;
	                      }
	                    }
	                    return cnt ? c2d(total / cnt) : BADNUM;
	                  };
	                case "min":
	                  return function(array, indices) {
	                    var out = Infinity;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) out = Math.min(out, vi);
	                    }
	                    return out === Infinity ? BADNUM : c2d(out);
	                  };
	                case "max":
	                  return function(array, indices) {
	                    var out = -Infinity;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) out = Math.max(out, vi);
	                    }
	                    return out === -Infinity ? BADNUM : c2d(out);
	                  };
	                case "range":
	                  return function(array, indices) {
	                    var min = Infinity;
	                    var max = -Infinity;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) {
	                        min = Math.min(min, vi);
	                        max = Math.max(max, vi);
	                      }
	                    }
	                    return max === -Infinity || min === Infinity ? BADNUM : c2d(max - min);
	                  };
	                case "change":
	                  return function(array, indices) {
	                    var first2 = d2c(array[indices[0]]);
	                    var last2 = d2c(array[indices[indices.length - 1]]);
	                    return first2 === BADNUM || last2 === BADNUM ? BADNUM : c2d(last2 - first2);
	                  };
	                case "median":
	                  return function(array, indices) {
	                    var sortCalc = [];
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) sortCalc.push(vi);
	                    }
	                    if (!sortCalc.length) return BADNUM;
	                    sortCalc.sort(Lib.sorterAsc);
	                    var mid = (sortCalc.length - 1) / 2;
	                    return c2d((sortCalc[Math.floor(mid)] + sortCalc[Math.ceil(mid)]) / 2);
	                  };
	                case "mode":
	                  return function(array, indices) {
	                    var counts = {};
	                    var maxCnt = 0;
	                    var out = BADNUM;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) {
	                        var counti = counts[vi] = (counts[vi] || 0) + 1;
	                        if (counti > maxCnt) {
	                          maxCnt = counti;
	                          out = vi;
	                        }
	                      }
	                    }
	                    return maxCnt ? c2d(out) : BADNUM;
	                  };
	                case "rms":
	                  return function(array, indices) {
	                    var total = 0;
	                    var cnt = 0;
	                    for (var i = 0; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) {
	                        total += vi * vi;
	                        cnt++;
	                      }
	                    }
	                    return cnt ? c2d(Math.sqrt(total / cnt)) : BADNUM;
	                  };
	                case "stddev":
	                  return function(array, indices) {
	                    var total = 0;
	                    var total2 = 0;
	                    var cnt = 1;
	                    var v0 = BADNUM;
	                    var i;
	                    for (i = 0; i < indices.length && v0 === BADNUM; i++) {
	                      v0 = d2c(array[indices[i]]);
	                    }
	                    if (v0 === BADNUM) return BADNUM;
	                    for (; i < indices.length; i++) {
	                      var vi = d2c(array[indices[i]]);
	                      if (vi !== BADNUM) {
	                        var dv = vi - v0;
	                        total += dv;
	                        total2 += dv * dv;
	                        cnt++;
	                      }
	                    }
	                    var norm = opts.funcmode === "sample" ? cnt - 1 : cnt;
	                    if (!norm) return 0;
	                    return Math.sqrt((total2 - total * total / cnt) / norm);
	                  };
	              }
	            }
	            function count(array, indices) {
	              return indices.length;
	            }
	            function first(array, indices) {
	              return array[indices[0]];
	            }
	            function last(array, indices) {
	              return array[indices[indices.length - 1]];
	            }
	          }
	        ),
	        /***/
	        14382: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Registry = __webpack_require__2(73972);
	            var Axes = __webpack_require__2(89298);
	            var pointsAccessorFunction = __webpack_require__2(79344).p;
	            var filterOps = __webpack_require__2(74808);
	            var COMPARISON_OPS = filterOps.COMPARISON_OPS;
	            var INTERVAL_OPS = filterOps.INTERVAL_OPS;
	            var SET_OPS = filterOps.SET_OPS;
	            exports2.moduleType = "transform";
	            exports2.name = "filter";
	            exports2.attributes = {
	              enabled: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              target: {
	                valType: "string",
	                strict: true,
	                noBlank: true,
	                arrayOk: true,
	                dflt: "x",
	                editType: "calc"
	              },
	              operation: {
	                valType: "enumerated",
	                values: [].concat(COMPARISON_OPS).concat(INTERVAL_OPS).concat(SET_OPS),
	                dflt: "=",
	                editType: "calc"
	              },
	              value: {
	                valType: "any",
	                dflt: 0,
	                editType: "calc"
	              },
	              preservegaps: {
	                valType: "boolean",
	                dflt: false,
	                editType: "calc"
	              },
	              editType: "calc"
	            };
	            exports2.supplyDefaults = function(transformIn) {
	              var transformOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(transformIn, transformOut, exports2.attributes, attr, dflt);
	              }
	              var enabled = coerce("enabled");
	              if (enabled) {
	                var target = coerce("target");
	                if (Lib.isArrayOrTypedArray(target) && target.length === 0) {
	                  transformOut.enabled = false;
	                  return transformOut;
	                }
	                coerce("preservegaps");
	                coerce("operation");
	                coerce("value");
	                var handleCalendarDefaults = Registry.getComponentMethod("calendars", "handleDefaults");
	                handleCalendarDefaults(transformIn, transformOut, "valuecalendar", null);
	                handleCalendarDefaults(transformIn, transformOut, "targetcalendar", null);
	              }
	              return transformOut;
	            };
	            exports2.calcTransform = function(gd, trace, opts) {
	              if (!opts.enabled) return;
	              var targetArray = Lib.getTargetArray(trace, opts);
	              if (!targetArray) return;
	              var target = opts.target;
	              var len = targetArray.length;
	              if (trace._length) len = Math.min(len, trace._length);
	              var targetCalendar = opts.targetcalendar;
	              var arrayAttrs = trace._arrayAttrs;
	              var preservegaps = opts.preservegaps;
	              if (typeof target === "string") {
	                var attrTargetCalendar = Lib.nestedProperty(trace, target + "calendar").get();
	                if (attrTargetCalendar) targetCalendar = attrTargetCalendar;
	              }
	              var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
	              var filterFunc = getFilterFunc(opts, d2c, targetCalendar);
	              var originalArrays = {};
	              var indexToPoints = {};
	              var index = 0;
	              function forAllAttrs(fn, index2) {
	                for (var j = 0; j < arrayAttrs.length; j++) {
	                  var np = Lib.nestedProperty(trace, arrayAttrs[j]);
	                  fn(np, index2);
	                }
	              }
	              var initFn;
	              var fillFn;
	              if (preservegaps) {
	                initFn = function(np) {
	                  originalArrays[np.astr] = Lib.extendDeep([], np.get());
	                  np.set(new Array(len));
	                };
	                fillFn = function(np, index2) {
	                  var val = originalArrays[np.astr][index2];
	                  np.get()[index2] = val;
	                };
	              } else {
	                initFn = function(np) {
	                  originalArrays[np.astr] = Lib.extendDeep([], np.get());
	                  np.set([]);
	                };
	                fillFn = function(np, index2) {
	                  var val = originalArrays[np.astr][index2];
	                  np.get().push(val);
	                };
	              }
	              forAllAttrs(initFn);
	              var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	              for (var i = 0; i < len; i++) {
	                var passed = filterFunc(targetArray[i]);
	                if (passed) {
	                  forAllAttrs(fillFn, i);
	                  indexToPoints[index++] = originalPointsAccessor(i);
	                } else if (preservegaps) index++;
	              }
	              opts._indexToPoints = indexToPoints;
	              trace._length = index;
	            };
	            function getFilterFunc(opts, d2c, targetCalendar) {
	              var operation = opts.operation;
	              var value = opts.value;
	              var hasArrayValue = Array.isArray(value);
	              function isOperationIn(array) {
	                return array.indexOf(operation) !== -1;
	              }
	              var d2cValue = function(v) {
	                return d2c(v, 0, opts.valuecalendar);
	              };
	              var d2cTarget = function(v) {
	                return d2c(v, 0, targetCalendar);
	              };
	              var coercedValue;
	              if (isOperationIn(COMPARISON_OPS)) {
	                coercedValue = hasArrayValue ? d2cValue(value[0]) : d2cValue(value);
	              } else if (isOperationIn(INTERVAL_OPS)) {
	                coercedValue = hasArrayValue ? [d2cValue(value[0]), d2cValue(value[1])] : [d2cValue(value), d2cValue(value)];
	              } else if (isOperationIn(SET_OPS)) {
	                coercedValue = hasArrayValue ? value.map(d2cValue) : [d2cValue(value)];
	              }
	              switch (operation) {
	                case "=":
	                  return function(v) {
	                    return d2cTarget(v) === coercedValue;
	                  };
	                case "!=":
	                  return function(v) {
	                    return d2cTarget(v) !== coercedValue;
	                  };
	                case "<":
	                  return function(v) {
	                    return d2cTarget(v) < coercedValue;
	                  };
	                case "<=":
	                  return function(v) {
	                    return d2cTarget(v) <= coercedValue;
	                  };
	                case ">":
	                  return function(v) {
	                    return d2cTarget(v) > coercedValue;
	                  };
	                case ">=":
	                  return function(v) {
	                    return d2cTarget(v) >= coercedValue;
	                  };
	                case "[]":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv >= coercedValue[0] && cv <= coercedValue[1];
	                  };
	                case "()":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv > coercedValue[0] && cv < coercedValue[1];
	                  };
	                case "[)":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv >= coercedValue[0] && cv < coercedValue[1];
	                  };
	                case "(]":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv > coercedValue[0] && cv <= coercedValue[1];
	                  };
	                case "][":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv <= coercedValue[0] || cv >= coercedValue[1];
	                  };
	                case ")(":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv < coercedValue[0] || cv > coercedValue[1];
	                  };
	                case "](":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv <= coercedValue[0] || cv > coercedValue[1];
	                  };
	                case ")[":
	                  return function(v) {
	                    var cv = d2cTarget(v);
	                    return cv < coercedValue[0] || cv >= coercedValue[1];
	                  };
	                case "{}":
	                  return function(v) {
	                    return coercedValue.indexOf(d2cTarget(v)) !== -1;
	                  };
	                case "}{":
	                  return function(v) {
	                    return coercedValue.indexOf(d2cTarget(v)) === -1;
	                  };
	              }
	            }
	          }
	        ),
	        /***/
	        43102: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var PlotSchema = __webpack_require__2(86281);
	            var Plots = __webpack_require__2(74875);
	            var pointsAccessorFunction = __webpack_require__2(79344).p;
	            exports2.moduleType = "transform";
	            exports2.name = "groupby";
	            exports2.attributes = {
	              enabled: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              groups: {
	                valType: "data_array",
	                dflt: [],
	                editType: "calc"
	              },
	              nameformat: {
	                valType: "string",
	                editType: "calc"
	              },
	              styles: {
	                _isLinkedToArray: "style",
	                target: {
	                  valType: "string",
	                  editType: "calc"
	                },
	                value: {
	                  valType: "any",
	                  dflt: {},
	                  editType: "calc",
	                  _compareAsJSON: true
	                },
	                editType: "calc"
	              },
	              editType: "calc"
	            };
	            exports2.supplyDefaults = function(transformIn, traceOut, layout) {
	              var i;
	              var transformOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(transformIn, transformOut, exports2.attributes, attr, dflt);
	              }
	              var enabled = coerce("enabled");
	              if (!enabled) return transformOut;
	              coerce("groups");
	              coerce("nameformat", layout._dataLength > 1 ? "%{group} (%{trace})" : "%{group}");
	              var styleIn = transformIn.styles;
	              var styleOut = transformOut.styles = [];
	              if (styleIn) {
	                for (i = 0; i < styleIn.length; i++) {
	                  var thisStyle = styleOut[i] = {};
	                  Lib.coerce(styleIn[i], styleOut[i], exports2.attributes.styles, "target");
	                  var value = Lib.coerce(styleIn[i], styleOut[i], exports2.attributes.styles, "value");
	                  if (Lib.isPlainObject(value)) thisStyle.value = Lib.extendDeep({}, value);
	                  else if (value) delete thisStyle.value;
	                }
	              }
	              return transformOut;
	            };
	            exports2.transform = function(data, state) {
	              var newTraces, i, j;
	              var newData = [];
	              for (i = 0; i < data.length; i++) {
	                newTraces = transformOne(data[i], state);
	                for (j = 0; j < newTraces.length; j++) {
	                  newData.push(newTraces[j]);
	                }
	              }
	              return newData;
	            };
	            function transformOne(trace, state) {
	              var i, j, k, attr, srcArray, groupName, newTrace, transforms, arrayLookup;
	              var groupNameObj;
	              var opts = state.transform;
	              var transformIndex = state.transformIndex;
	              var groups = trace.transforms[transformIndex].groups;
	              var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	              if (!Lib.isArrayOrTypedArray(groups) || groups.length === 0) {
	                return [trace];
	              }
	              var groupNames = Lib.filterUnique(groups);
	              var newData = new Array(groupNames.length);
	              var len = groups.length;
	              var arrayAttrs = PlotSchema.findArrayAttributes(trace);
	              var styles = opts.styles || [];
	              var styleLookup = {};
	              for (i = 0; i < styles.length; i++) {
	                styleLookup[styles[i].target] = styles[i].value;
	              }
	              if (opts.styles) {
	                groupNameObj = Lib.keyedContainer(opts, "styles", "target", "value.name");
	              }
	              var indexLookup = {};
	              var indexCnts = {};
	              for (i = 0; i < groupNames.length; i++) {
	                groupName = groupNames[i];
	                indexLookup[groupName] = i;
	                indexCnts[groupName] = 0;
	                newTrace = newData[i] = Lib.extendDeepNoArrays({}, trace);
	                newTrace._group = groupName;
	                newTrace.transforms[transformIndex]._indexToPoints = {};
	                var suppliedName = null;
	                if (groupNameObj) {
	                  suppliedName = groupNameObj.get(groupName);
	                }
	                if (suppliedName || suppliedName === "") {
	                  newTrace.name = suppliedName;
	                } else {
	                  newTrace.name = Lib.templateString(opts.nameformat, {
	                    trace: trace.name,
	                    group: groupName
	                  });
	                }
	                transforms = newTrace.transforms;
	                newTrace.transforms = [];
	                for (j = 0; j < transforms.length; j++) {
	                  newTrace.transforms[j] = Lib.extendDeepNoArrays({}, transforms[j]);
	                }
	                for (j = 0; j < arrayAttrs.length; j++) {
	                  Lib.nestedProperty(newTrace, arrayAttrs[j]).set([]);
	                }
	              }
	              for (k = 0; k < arrayAttrs.length; k++) {
	                attr = arrayAttrs[k];
	                for (j = 0, arrayLookup = []; j < groupNames.length; j++) {
	                  arrayLookup[j] = Lib.nestedProperty(newData[j], attr).get();
	                }
	                srcArray = Lib.nestedProperty(trace, attr).get();
	                for (j = 0; j < len; j++) {
	                  arrayLookup[indexLookup[groups[j]]].push(srcArray[j]);
	                }
	              }
	              for (j = 0; j < len; j++) {
	                newTrace = newData[indexLookup[groups[j]]];
	                var indexToPoints = newTrace.transforms[transformIndex]._indexToPoints;
	                indexToPoints[indexCnts[groups[j]]] = originalPointsAccessor(j);
	                indexCnts[groups[j]]++;
	              }
	              for (i = 0; i < groupNames.length; i++) {
	                groupName = groupNames[i];
	                newTrace = newData[i];
	                Plots.clearExpandedTraceDefaultColors(newTrace);
	                newTrace = Lib.extendDeepNoArrays(newTrace, styleLookup[groupName] || {});
	              }
	              return newData;
	            }
	          }
	        ),
	        /***/
	        79344: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.p = function(transforms, opts) {
	              var tr;
	              var prevIndexToPoints;
	              for (var i = 0; i < transforms.length; i++) {
	                tr = transforms[i];
	                if (tr === opts) break;
	                if (!tr._indexToPoints || tr.enabled === false) continue;
	                prevIndexToPoints = tr._indexToPoints;
	              }
	              var originalPointsAccessor = prevIndexToPoints ? function(i2) {
	                return prevIndexToPoints[i2];
	              } : function(i2) {
	                return [i2];
	              };
	              return originalPointsAccessor;
	            };
	          }
	        ),
	        /***/
	        32275: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Lib = __webpack_require__2(71828);
	            var Axes = __webpack_require__2(89298);
	            var pointsAccessorFunction = __webpack_require__2(79344).p;
	            var BADNUM = __webpack_require__2(50606).BADNUM;
	            exports2.moduleType = "transform";
	            exports2.name = "sort";
	            exports2.attributes = {
	              enabled: {
	                valType: "boolean",
	                dflt: true,
	                editType: "calc"
	              },
	              target: {
	                valType: "string",
	                strict: true,
	                noBlank: true,
	                arrayOk: true,
	                dflt: "x",
	                editType: "calc"
	              },
	              order: {
	                valType: "enumerated",
	                values: ["ascending", "descending"],
	                dflt: "ascending",
	                editType: "calc"
	              },
	              editType: "calc"
	            };
	            exports2.supplyDefaults = function(transformIn) {
	              var transformOut = {};
	              function coerce(attr, dflt) {
	                return Lib.coerce(transformIn, transformOut, exports2.attributes, attr, dflt);
	              }
	              var enabled = coerce("enabled");
	              if (enabled) {
	                coerce("target");
	                coerce("order");
	              }
	              return transformOut;
	            };
	            exports2.calcTransform = function(gd, trace, opts) {
	              if (!opts.enabled) return;
	              var targetArray = Lib.getTargetArray(trace, opts);
	              if (!targetArray) return;
	              var target = opts.target;
	              var len = targetArray.length;
	              if (trace._length) len = Math.min(len, trace._length);
	              var arrayAttrs = trace._arrayAttrs;
	              var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
	              var indices = getIndices(opts, targetArray, d2c, len);
	              var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
	              var indexToPoints = {};
	              var i, j;
	              for (i = 0; i < arrayAttrs.length; i++) {
	                var np = Lib.nestedProperty(trace, arrayAttrs[i]);
	                var arrayOld = np.get();
	                var arrayNew = new Array(len);
	                for (j = 0; j < len; j++) {
	                  arrayNew[j] = arrayOld[indices[j]];
	                }
	                np.set(arrayNew);
	              }
	              for (j = 0; j < len; j++) {
	                indexToPoints[j] = originalPointsAccessor(indices[j]);
	              }
	              opts._indexToPoints = indexToPoints;
	              trace._length = len;
	            };
	            function getIndices(opts, targetArray, d2c, len) {
	              var sortedArray = new Array(len);
	              var indices = new Array(len);
	              var i;
	              for (i = 0; i < len; i++) {
	                sortedArray[i] = {
	                  v: targetArray[i],
	                  i
	                };
	              }
	              sortedArray.sort(getSortFunc(opts, d2c));
	              for (i = 0; i < len; i++) {
	                indices[i] = sortedArray[i].i;
	              }
	              return indices;
	            }
	            function getSortFunc(opts, d2c) {
	              switch (opts.order) {
	                case "ascending":
	                  return function(a, b) {
	                    var ac = d2c(a.v);
	                    var bc = d2c(b.v);
	                    if (ac === BADNUM) {
	                      return 1;
	                    }
	                    if (bc === BADNUM) {
	                      return -1;
	                    }
	                    return ac - bc;
	                  };
	                case "descending":
	                  return function(a, b) {
	                    var ac = d2c(a.v);
	                    var bc = d2c(b.v);
	                    if (ac === BADNUM) {
	                      return 1;
	                    }
	                    if (bc === BADNUM) {
	                      return -1;
	                    }
	                    return bc - ac;
	                  };
	              }
	            }
	          }
	        ),
	        /***/
	        11506: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.version = "2.27.1";
	          }
	        ),
	        /***/
	        9330: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            (function webpackUniversalModuleDefinition2(root, factory) {
	              module2.exports = factory();
	            })(self, function() {
	              return (
	                /******/
	                function() {
	                  var __webpack_modules__2 = {
	                    /***/
	                    7386: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_451__) {
	                        module3.exports = { alpha_shape: __nested_webpack_require_451__(2350), convex_hull: __nested_webpack_require_451__(5537), delaunay_triangulate: __nested_webpack_require_451__(4419), gl_cone3d: __nested_webpack_require_451__(1140), gl_error3d: __nested_webpack_require_451__(3110), gl_heatmap2d: __nested_webpack_require_451__(6386), gl_line3d: __nested_webpack_require_451__(6086), gl_mesh3d: __nested_webpack_require_451__(8116), gl_plot2d: __nested_webpack_require_451__(2117), gl_plot3d: __nested_webpack_require_451__(1059), gl_pointcloud2d: __nested_webpack_require_451__(8271), gl_scatter3d: __nested_webpack_require_451__(2182), gl_select_box: __nested_webpack_require_451__(6623), gl_spikes2d: __nested_webpack_require_451__(3050), gl_streamtube3d: __nested_webpack_require_451__(7307), gl_surface3d: __nested_webpack_require_451__(3754), ndarray: __nested_webpack_require_451__(5050), ndarray_linear_interpolate: __nested_webpack_require_451__(3581) };
	                      }
	                    ),
	                    /***/
	                    2146: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_1258__) {
	                        /*!
	                        * The buffer module from node.js, for the browser.
	                        *
	                        * @author   Feross Aboukhadijeh <https://feross.org>
	                        * @license  MIT
	                        */
	                        function _classCallCheck(instance, Constructor) {
	                          if (!(instance instanceof Constructor)) {
	                            throw new TypeError("Cannot call a class as a function");
	                          }
	                        }
	                        function _defineProperties(target, props) {
	                          for (var i = 0; i < props.length; i++) {
	                            var descriptor = props[i];
	                            descriptor.enumerable = descriptor.enumerable || false;
	                            descriptor.configurable = true;
	                            if ("value" in descriptor) descriptor.writable = true;
	                            Object.defineProperty(target, descriptor.key, descriptor);
	                          }
	                        }
	                        function _createClass(Constructor, protoProps, staticProps) {
	                          _defineProperties(Constructor.prototype, protoProps);
	                          Object.defineProperty(Constructor, "prototype", { writable: false });
	                          return Constructor;
	                        }
	                        function _inherits(subClass, superClass) {
	                          if (typeof superClass !== "function" && superClass !== null) {
	                            throw new TypeError("Super expression must either be null or a function");
	                          }
	                          subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
	                          Object.defineProperty(subClass, "prototype", { writable: false });
	                          if (superClass) _setPrototypeOf(subClass, superClass);
	                        }
	                        function _setPrototypeOf(o, p) {
	                          _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
	                            o2.__proto__ = p2;
	                            return o2;
	                          };
	                          return _setPrototypeOf(o, p);
	                        }
	                        function _createSuper(Derived) {
	                          var hasNativeReflectConstruct = _isNativeReflectConstruct();
	                          return function _createSuperInternal() {
	                            var Super = _getPrototypeOf(Derived), result;
	                            if (hasNativeReflectConstruct) {
	                              var NewTarget = _getPrototypeOf(this).constructor;
	                              result = Reflect.construct(Super, arguments, NewTarget);
	                            } else {
	                              result = Super.apply(this, arguments);
	                            }
	                            return _possibleConstructorReturn(this, result);
	                          };
	                        }
	                        function _possibleConstructorReturn(self2, call) {
	                          if (call && (_typeof(call) === "object" || typeof call === "function")) {
	                            return call;
	                          } else if (call !== undefined) {
	                            throw new TypeError("Derived constructors may only return object or undefined");
	                          }
	                          return _assertThisInitialized(self2);
	                        }
	                        function _assertThisInitialized(self2) {
	                          if (self2 === undefined) {
	                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	                          }
	                          return self2;
	                        }
	                        function _isNativeReflectConstruct() {
	                          if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	                          if (Reflect.construct.sham) return false;
	                          if (typeof Proxy === "function") return true;
	                          try {
	                            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
	                            }));
	                            return true;
	                          } catch (e) {
	                            return false;
	                          }
	                        }
	                        function _getPrototypeOf(o) {
	                          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
	                            return o2.__proto__ || Object.getPrototypeOf(o2);
	                          };
	                          return _getPrototypeOf(o);
	                        }
	                        function _typeof(obj) {
	                          "@babel/helpers - typeof";
	                          return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
	                            return typeof obj2;
	                          } : function(obj2) {
	                            return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	                          }, _typeof(obj);
	                        }
	                        var base64 = __nested_webpack_require_1258__(3910);
	                        var ieee754 = __nested_webpack_require_1258__(3187);
	                        var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
	                        exports2.lW = Buffer2;
	                        exports2.h2 = 50;
	                        var K_MAX_LENGTH = 2147483647;
	                        Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
	                        if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
	                          console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
	                        }
	                        function typedArraySupport() {
	                          try {
	                            var arr = new Uint8Array(1);
	                            var proto = { foo: function foo() {
	                              return 42;
	                            } };
	                            Object.setPrototypeOf(proto, Uint8Array.prototype);
	                            Object.setPrototypeOf(arr, proto);
	                            return arr.foo() === 42;
	                          } catch (e) {
	                            return false;
	                          }
	                        }
	                        Object.defineProperty(Buffer2.prototype, "parent", { enumerable: true, get: function get() {
	                          if (!Buffer2.isBuffer(this)) return undefined;
	                          return this.buffer;
	                        } });
	                        Object.defineProperty(Buffer2.prototype, "offset", { enumerable: true, get: function get() {
	                          if (!Buffer2.isBuffer(this)) return undefined;
	                          return this.byteOffset;
	                        } });
	                        function createBuffer(length) {
	                          if (length > K_MAX_LENGTH) {
	                            throw new RangeError('The value "' + length + '" is invalid for option "size"');
	                          }
	                          var buf = new Uint8Array(length);
	                          Object.setPrototypeOf(buf, Buffer2.prototype);
	                          return buf;
	                        }
	                        function Buffer2(arg, encodingOrOffset, length) {
	                          if (typeof arg === "number") {
	                            if (typeof encodingOrOffset === "string") {
	                              throw new TypeError('The "string" argument must be of type string. Received type number');
	                            }
	                            return allocUnsafe(arg);
	                          }
	                          return from(arg, encodingOrOffset, length);
	                        }
	                        Buffer2.poolSize = 8192;
	                        function from(value, encodingOrOffset, length) {
	                          if (typeof value === "string") {
	                            return fromString(value, encodingOrOffset);
	                          }
	                          if (ArrayBuffer.isView(value)) {
	                            return fromArrayView(value);
	                          }
	                          if (value == null) {
	                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(value));
	                          }
	                          if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
	                            return fromArrayBuffer(value, encodingOrOffset, length);
	                          }
	                          if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
	                            return fromArrayBuffer(value, encodingOrOffset, length);
	                          }
	                          if (typeof value === "number") {
	                            throw new TypeError('The "value" argument must not be of type number. Received type number');
	                          }
	                          var valueOf = value.valueOf && value.valueOf();
	                          if (valueOf != null && valueOf !== value) {
	                            return Buffer2.from(valueOf, encodingOrOffset, length);
	                          }
	                          var b = fromObject(value);
	                          if (b) return b;
	                          if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
	                            return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
	                          }
	                          throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(value));
	                        }
	                        Buffer2.from = function(value, encodingOrOffset, length) {
	                          return from(value, encodingOrOffset, length);
	                        };
	                        Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
	                        Object.setPrototypeOf(Buffer2, Uint8Array);
	                        function assertSize(size) {
	                          if (typeof size !== "number") {
	                            throw new TypeError('"size" argument must be of type number');
	                          } else if (size < 0) {
	                            throw new RangeError('The value "' + size + '" is invalid for option "size"');
	                          }
	                        }
	                        function alloc(size, fill, encoding) {
	                          assertSize(size);
	                          if (size <= 0) {
	                            return createBuffer(size);
	                          }
	                          if (fill !== undefined) {
	                            return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
	                          }
	                          return createBuffer(size);
	                        }
	                        Buffer2.alloc = function(size, fill, encoding) {
	                          return alloc(size, fill, encoding);
	                        };
	                        function allocUnsafe(size) {
	                          assertSize(size);
	                          return createBuffer(size < 0 ? 0 : checked(size) | 0);
	                        }
	                        Buffer2.allocUnsafe = function(size) {
	                          return allocUnsafe(size);
	                        };
	                        Buffer2.allocUnsafeSlow = function(size) {
	                          return allocUnsafe(size);
	                        };
	                        function fromString(string, encoding) {
	                          if (typeof encoding !== "string" || encoding === "") {
	                            encoding = "utf8";
	                          }
	                          if (!Buffer2.isEncoding(encoding)) {
	                            throw new TypeError("Unknown encoding: " + encoding);
	                          }
	                          var length = byteLength(string, encoding) | 0;
	                          var buf = createBuffer(length);
	                          var actual = buf.write(string, encoding);
	                          if (actual !== length) {
	                            buf = buf.slice(0, actual);
	                          }
	                          return buf;
	                        }
	                        function fromArrayLike(array) {
	                          var length = array.length < 0 ? 0 : checked(array.length) | 0;
	                          var buf = createBuffer(length);
	                          for (var i = 0; i < length; i += 1) {
	                            buf[i] = array[i] & 255;
	                          }
	                          return buf;
	                        }
	                        function fromArrayView(arrayView) {
	                          if (isInstance(arrayView, Uint8Array)) {
	                            var copy = new Uint8Array(arrayView);
	                            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
	                          }
	                          return fromArrayLike(arrayView);
	                        }
	                        function fromArrayBuffer(array, byteOffset, length) {
	                          if (byteOffset < 0 || array.byteLength < byteOffset) {
	                            throw new RangeError('"offset" is outside of buffer bounds');
	                          }
	                          if (array.byteLength < byteOffset + (length || 0)) {
	                            throw new RangeError('"length" is outside of buffer bounds');
	                          }
	                          var buf;
	                          if (byteOffset === undefined && length === undefined) {
	                            buf = new Uint8Array(array);
	                          } else if (length === undefined) {
	                            buf = new Uint8Array(array, byteOffset);
	                          } else {
	                            buf = new Uint8Array(array, byteOffset, length);
	                          }
	                          Object.setPrototypeOf(buf, Buffer2.prototype);
	                          return buf;
	                        }
	                        function fromObject(obj) {
	                          if (Buffer2.isBuffer(obj)) {
	                            var len = checked(obj.length) | 0;
	                            var buf = createBuffer(len);
	                            if (buf.length === 0) {
	                              return buf;
	                            }
	                            obj.copy(buf, 0, 0, len);
	                            return buf;
	                          }
	                          if (obj.length !== undefined) {
	                            if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
	                              return createBuffer(0);
	                            }
	                            return fromArrayLike(obj);
	                          }
	                          if (obj.type === "Buffer" && Array.isArray(obj.data)) {
	                            return fromArrayLike(obj.data);
	                          }
	                        }
	                        function checked(length) {
	                          if (length >= K_MAX_LENGTH) {
	                            throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
	                          }
	                          return length | 0;
	                        }
	                        Buffer2.isBuffer = function isBuffer(b) {
	                          return b != null && b._isBuffer === true && b !== Buffer2.prototype;
	                        };
	                        Buffer2.compare = function compare(a, b) {
	                          if (isInstance(a, Uint8Array)) a = Buffer2.from(a, a.offset, a.byteLength);
	                          if (isInstance(b, Uint8Array)) b = Buffer2.from(b, b.offset, b.byteLength);
	                          if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
	                            throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
	                          }
	                          if (a === b) return 0;
	                          var x = a.length;
	                          var y = b.length;
	                          for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	                            if (a[i] !== b[i]) {
	                              x = a[i];
	                              y = b[i];
	                              break;
	                            }
	                          }
	                          if (x < y) return -1;
	                          if (y < x) return 1;
	                          return 0;
	                        };
	                        Buffer2.isEncoding = function isEncoding(encoding) {
	                          switch (String(encoding).toLowerCase()) {
	                            case "hex":
	                            case "utf8":
	                            case "utf-8":
	                            case "ascii":
	                            case "latin1":
	                            case "binary":
	                            case "base64":
	                            case "ucs2":
	                            case "ucs-2":
	                            case "utf16le":
	                            case "utf-16le":
	                              return true;
	                            default:
	                              return false;
	                          }
	                        };
	                        Buffer2.concat = function concat(list, length) {
	                          if (!Array.isArray(list)) {
	                            throw new TypeError('"list" argument must be an Array of Buffers');
	                          }
	                          if (list.length === 0) {
	                            return Buffer2.alloc(0);
	                          }
	                          var i;
	                          if (length === undefined) {
	                            length = 0;
	                            for (i = 0; i < list.length; ++i) {
	                              length += list[i].length;
	                            }
	                          }
	                          var buffer = Buffer2.allocUnsafe(length);
	                          var pos = 0;
	                          for (i = 0; i < list.length; ++i) {
	                            var buf = list[i];
	                            if (isInstance(buf, Uint8Array)) {
	                              if (pos + buf.length > buffer.length) {
	                                if (!Buffer2.isBuffer(buf)) buf = Buffer2.from(buf);
	                                buf.copy(buffer, pos);
	                              } else {
	                                Uint8Array.prototype.set.call(buffer, buf, pos);
	                              }
	                            } else if (!Buffer2.isBuffer(buf)) {
	                              throw new TypeError('"list" argument must be an Array of Buffers');
	                            } else {
	                              buf.copy(buffer, pos);
	                            }
	                            pos += buf.length;
	                          }
	                          return buffer;
	                        };
	                        function byteLength(string, encoding) {
	                          if (Buffer2.isBuffer(string)) {
	                            return string.length;
	                          }
	                          if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	                            return string.byteLength;
	                          }
	                          if (typeof string !== "string") {
	                            throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + _typeof(string));
	                          }
	                          var len = string.length;
	                          var mustMatch = arguments.length > 2 && arguments[2] === true;
	                          if (!mustMatch && len === 0) return 0;
	                          var loweredCase = false;
	                          for (; ; ) {
	                            switch (encoding) {
	                              case "ascii":
	                              case "latin1":
	                              case "binary":
	                                return len;
	                              case "utf8":
	                              case "utf-8":
	                                return utf8ToBytes(string).length;
	                              case "ucs2":
	                              case "ucs-2":
	                              case "utf16le":
	                              case "utf-16le":
	                                return len * 2;
	                              case "hex":
	                                return len >>> 1;
	                              case "base64":
	                                return base64ToBytes(string).length;
	                              default:
	                                if (loweredCase) {
	                                  return mustMatch ? -1 : utf8ToBytes(string).length;
	                                }
	                                encoding = ("" + encoding).toLowerCase();
	                                loweredCase = true;
	                            }
	                          }
	                        }
	                        Buffer2.byteLength = byteLength;
	                        function slowToString(encoding, start, end) {
	                          var loweredCase = false;
	                          if (start === undefined || start < 0) {
	                            start = 0;
	                          }
	                          if (start > this.length) {
	                            return "";
	                          }
	                          if (end === undefined || end > this.length) {
	                            end = this.length;
	                          }
	                          if (end <= 0) {
	                            return "";
	                          }
	                          end >>>= 0;
	                          start >>>= 0;
	                          if (end <= start) {
	                            return "";
	                          }
	                          if (!encoding) encoding = "utf8";
	                          while (true) {
	                            switch (encoding) {
	                              case "hex":
	                                return hexSlice(this, start, end);
	                              case "utf8":
	                              case "utf-8":
	                                return utf8Slice(this, start, end);
	                              case "ascii":
	                                return asciiSlice(this, start, end);
	                              case "latin1":
	                              case "binary":
	                                return latin1Slice(this, start, end);
	                              case "base64":
	                                return base64Slice(this, start, end);
	                              case "ucs2":
	                              case "ucs-2":
	                              case "utf16le":
	                              case "utf-16le":
	                                return utf16leSlice(this, start, end);
	                              default:
	                                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
	                                encoding = (encoding + "").toLowerCase();
	                                loweredCase = true;
	                            }
	                          }
	                        }
	                        Buffer2.prototype._isBuffer = true;
	                        function swap(b, n, m) {
	                          var i = b[n];
	                          b[n] = b[m];
	                          b[m] = i;
	                        }
	                        Buffer2.prototype.swap16 = function swap16() {
	                          var len = this.length;
	                          if (len % 2 !== 0) {
	                            throw new RangeError("Buffer size must be a multiple of 16-bits");
	                          }
	                          for (var i = 0; i < len; i += 2) {
	                            swap(this, i, i + 1);
	                          }
	                          return this;
	                        };
	                        Buffer2.prototype.swap32 = function swap32() {
	                          var len = this.length;
	                          if (len % 4 !== 0) {
	                            throw new RangeError("Buffer size must be a multiple of 32-bits");
	                          }
	                          for (var i = 0; i < len; i += 4) {
	                            swap(this, i, i + 3);
	                            swap(this, i + 1, i + 2);
	                          }
	                          return this;
	                        };
	                        Buffer2.prototype.swap64 = function swap64() {
	                          var len = this.length;
	                          if (len % 8 !== 0) {
	                            throw new RangeError("Buffer size must be a multiple of 64-bits");
	                          }
	                          for (var i = 0; i < len; i += 8) {
	                            swap(this, i, i + 7);
	                            swap(this, i + 1, i + 6);
	                            swap(this, i + 2, i + 5);
	                            swap(this, i + 3, i + 4);
	                          }
	                          return this;
	                        };
	                        Buffer2.prototype.toString = function toString() {
	                          var length = this.length;
	                          if (length === 0) return "";
	                          if (arguments.length === 0) return utf8Slice(this, 0, length);
	                          return slowToString.apply(this, arguments);
	                        };
	                        Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
	                        Buffer2.prototype.equals = function equals(b) {
	                          if (!Buffer2.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
	                          if (this === b) return true;
	                          return Buffer2.compare(this, b) === 0;
	                        };
	                        Buffer2.prototype.inspect = function inspect() {
	                          var str = "";
	                          var max = exports2.h2;
	                          str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
	                          if (this.length > max) str += " ... ";
	                          return "<Buffer " + str + ">";
	                        };
	                        if (customInspectSymbol) {
	                          Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
	                        }
	                        Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	                          if (isInstance(target, Uint8Array)) {
	                            target = Buffer2.from(target, target.offset, target.byteLength);
	                          }
	                          if (!Buffer2.isBuffer(target)) {
	                            throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + _typeof(target));
	                          }
	                          if (start === undefined) {
	                            start = 0;
	                          }
	                          if (end === undefined) {
	                            end = target ? target.length : 0;
	                          }
	                          if (thisStart === undefined) {
	                            thisStart = 0;
	                          }
	                          if (thisEnd === undefined) {
	                            thisEnd = this.length;
	                          }
	                          if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	                            throw new RangeError("out of range index");
	                          }
	                          if (thisStart >= thisEnd && start >= end) {
	                            return 0;
	                          }
	                          if (thisStart >= thisEnd) {
	                            return -1;
	                          }
	                          if (start >= end) {
	                            return 1;
	                          }
	                          start >>>= 0;
	                          end >>>= 0;
	                          thisStart >>>= 0;
	                          thisEnd >>>= 0;
	                          if (this === target) return 0;
	                          var x = thisEnd - thisStart;
	                          var y = end - start;
	                          var len = Math.min(x, y);
	                          var thisCopy = this.slice(thisStart, thisEnd);
	                          var targetCopy = target.slice(start, end);
	                          for (var i = 0; i < len; ++i) {
	                            if (thisCopy[i] !== targetCopy[i]) {
	                              x = thisCopy[i];
	                              y = targetCopy[i];
	                              break;
	                            }
	                          }
	                          if (x < y) return -1;
	                          if (y < x) return 1;
	                          return 0;
	                        };
	                        function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	                          if (buffer.length === 0) return -1;
	                          if (typeof byteOffset === "string") {
	                            encoding = byteOffset;
	                            byteOffset = 0;
	                          } else if (byteOffset > 2147483647) {
	                            byteOffset = 2147483647;
	                          } else if (byteOffset < -2147483648) {
	                            byteOffset = -2147483648;
	                          }
	                          byteOffset = +byteOffset;
	                          if (numberIsNaN(byteOffset)) {
	                            byteOffset = dir ? 0 : buffer.length - 1;
	                          }
	                          if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	                          if (byteOffset >= buffer.length) {
	                            if (dir) return -1;
	                            else byteOffset = buffer.length - 1;
	                          } else if (byteOffset < 0) {
	                            if (dir) byteOffset = 0;
	                            else return -1;
	                          }
	                          if (typeof val === "string") {
	                            val = Buffer2.from(val, encoding);
	                          }
	                          if (Buffer2.isBuffer(val)) {
	                            if (val.length === 0) {
	                              return -1;
	                            }
	                            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	                          } else if (typeof val === "number") {
	                            val = val & 255;
	                            if (typeof Uint8Array.prototype.indexOf === "function") {
	                              if (dir) {
	                                return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	                              } else {
	                                return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	                              }
	                            }
	                            return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	                          }
	                          throw new TypeError("val must be string, number or Buffer");
	                        }
	                        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	                          var indexSize = 1;
	                          var arrLength = arr.length;
	                          var valLength = val.length;
	                          if (encoding !== undefined) {
	                            encoding = String(encoding).toLowerCase();
	                            if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
	                              if (arr.length < 2 || val.length < 2) {
	                                return -1;
	                              }
	                              indexSize = 2;
	                              arrLength /= 2;
	                              valLength /= 2;
	                              byteOffset /= 2;
	                            }
	                          }
	                          function read(buf, i2) {
	                            if (indexSize === 1) {
	                              return buf[i2];
	                            } else {
	                              return buf.readUInt16BE(i2 * indexSize);
	                            }
	                          }
	                          var i;
	                          if (dir) {
	                            var foundIndex = -1;
	                            for (i = byteOffset; i < arrLength; i++) {
	                              if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	                                if (foundIndex === -1) foundIndex = i;
	                                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	                              } else {
	                                if (foundIndex !== -1) i -= i - foundIndex;
	                                foundIndex = -1;
	                              }
	                            }
	                          } else {
	                            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	                            for (i = byteOffset; i >= 0; i--) {
	                              var found = true;
	                              for (var j = 0; j < valLength; j++) {
	                                if (read(arr, i + j) !== read(val, j)) {
	                                  found = false;
	                                  break;
	                                }
	                              }
	                              if (found) return i;
	                            }
	                          }
	                          return -1;
	                        }
	                        Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
	                          return this.indexOf(val, byteOffset, encoding) !== -1;
	                        };
	                        Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	                          return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	                        };
	                        Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	                          return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	                        };
	                        function hexWrite(buf, string, offset, length) {
	                          offset = Number(offset) || 0;
	                          var remaining = buf.length - offset;
	                          if (!length) {
	                            length = remaining;
	                          } else {
	                            length = Number(length);
	                            if (length > remaining) {
	                              length = remaining;
	                            }
	                          }
	                          var strLen = string.length;
	                          if (length > strLen / 2) {
	                            length = strLen / 2;
	                          }
	                          var i;
	                          for (i = 0; i < length; ++i) {
	                            var parsed = parseInt(string.substr(i * 2, 2), 16);
	                            if (numberIsNaN(parsed)) return i;
	                            buf[offset + i] = parsed;
	                          }
	                          return i;
	                        }
	                        function utf8Write(buf, string, offset, length) {
	                          return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	                        }
	                        function asciiWrite(buf, string, offset, length) {
	                          return blitBuffer(asciiToBytes(string), buf, offset, length);
	                        }
	                        function base64Write(buf, string, offset, length) {
	                          return blitBuffer(base64ToBytes(string), buf, offset, length);
	                        }
	                        function ucs2Write(buf, string, offset, length) {
	                          return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	                        }
	                        Buffer2.prototype.write = function write(string, offset, length, encoding) {
	                          if (offset === undefined) {
	                            encoding = "utf8";
	                            length = this.length;
	                            offset = 0;
	                          } else if (length === undefined && typeof offset === "string") {
	                            encoding = offset;
	                            length = this.length;
	                            offset = 0;
	                          } else if (isFinite(offset)) {
	                            offset = offset >>> 0;
	                            if (isFinite(length)) {
	                              length = length >>> 0;
	                              if (encoding === undefined) encoding = "utf8";
	                            } else {
	                              encoding = length;
	                              length = undefined;
	                            }
	                          } else {
	                            throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
	                          }
	                          var remaining = this.length - offset;
	                          if (length === undefined || length > remaining) length = remaining;
	                          if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	                            throw new RangeError("Attempt to write outside buffer bounds");
	                          }
	                          if (!encoding) encoding = "utf8";
	                          var loweredCase = false;
	                          for (; ; ) {
	                            switch (encoding) {
	                              case "hex":
	                                return hexWrite(this, string, offset, length);
	                              case "utf8":
	                              case "utf-8":
	                                return utf8Write(this, string, offset, length);
	                              case "ascii":
	                              case "latin1":
	                              case "binary":
	                                return asciiWrite(this, string, offset, length);
	                              case "base64":
	                                return base64Write(this, string, offset, length);
	                              case "ucs2":
	                              case "ucs-2":
	                              case "utf16le":
	                              case "utf-16le":
	                                return ucs2Write(this, string, offset, length);
	                              default:
	                                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
	                                encoding = ("" + encoding).toLowerCase();
	                                loweredCase = true;
	                            }
	                          }
	                        };
	                        Buffer2.prototype.toJSON = function toJSON() {
	                          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
	                        };
	                        function base64Slice(buf, start, end) {
	                          if (start === 0 && end === buf.length) {
	                            return base64.fromByteArray(buf);
	                          } else {
	                            return base64.fromByteArray(buf.slice(start, end));
	                          }
	                        }
	                        function utf8Slice(buf, start, end) {
	                          end = Math.min(buf.length, end);
	                          var res = [];
	                          var i = start;
	                          while (i < end) {
	                            var firstByte = buf[i];
	                            var codePoint = null;
	                            var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
	                            if (i + bytesPerSequence <= end) {
	                              var secondByte = undefined, thirdByte = undefined, fourthByte = undefined, tempCodePoint = undefined;
	                              switch (bytesPerSequence) {
	                                case 1:
	                                  if (firstByte < 128) {
	                                    codePoint = firstByte;
	                                  }
	                                  break;
	                                case 2:
	                                  secondByte = buf[i + 1];
	                                  if ((secondByte & 192) === 128) {
	                                    tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
	                                    if (tempCodePoint > 127) {
	                                      codePoint = tempCodePoint;
	                                    }
	                                  }
	                                  break;
	                                case 3:
	                                  secondByte = buf[i + 1];
	                                  thirdByte = buf[i + 2];
	                                  if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
	                                    tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
	                                    if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
	                                      codePoint = tempCodePoint;
	                                    }
	                                  }
	                                  break;
	                                case 4:
	                                  secondByte = buf[i + 1];
	                                  thirdByte = buf[i + 2];
	                                  fourthByte = buf[i + 3];
	                                  if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
	                                    tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
	                                    if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
	                                      codePoint = tempCodePoint;
	                                    }
	                                  }
	                              }
	                            }
	                            if (codePoint === null) {
	                              codePoint = 65533;
	                              bytesPerSequence = 1;
	                            } else if (codePoint > 65535) {
	                              codePoint -= 65536;
	                              res.push(codePoint >>> 10 & 1023 | 55296);
	                              codePoint = 56320 | codePoint & 1023;
	                            }
	                            res.push(codePoint);
	                            i += bytesPerSequence;
	                          }
	                          return decodeCodePointsArray(res);
	                        }
	                        var MAX_ARGUMENTS_LENGTH = 4096;
	                        function decodeCodePointsArray(codePoints) {
	                          var len = codePoints.length;
	                          if (len <= MAX_ARGUMENTS_LENGTH) {
	                            return String.fromCharCode.apply(String, codePoints);
	                          }
	                          var res = "";
	                          var i = 0;
	                          while (i < len) {
	                            res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	                          }
	                          return res;
	                        }
	                        function asciiSlice(buf, start, end) {
	                          var ret = "";
	                          end = Math.min(buf.length, end);
	                          for (var i = start; i < end; ++i) {
	                            ret += String.fromCharCode(buf[i] & 127);
	                          }
	                          return ret;
	                        }
	                        function latin1Slice(buf, start, end) {
	                          var ret = "";
	                          end = Math.min(buf.length, end);
	                          for (var i = start; i < end; ++i) {
	                            ret += String.fromCharCode(buf[i]);
	                          }
	                          return ret;
	                        }
	                        function hexSlice(buf, start, end) {
	                          var len = buf.length;
	                          if (!start || start < 0) start = 0;
	                          if (!end || end < 0 || end > len) end = len;
	                          var out = "";
	                          for (var i = start; i < end; ++i) {
	                            out += hexSliceLookupTable[buf[i]];
	                          }
	                          return out;
	                        }
	                        function utf16leSlice(buf, start, end) {
	                          var bytes = buf.slice(start, end);
	                          var res = "";
	                          for (var i = 0; i < bytes.length - 1; i += 2) {
	                            res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	                          }
	                          return res;
	                        }
	                        Buffer2.prototype.slice = function slice2(start, end) {
	                          var len = this.length;
	                          start = ~~start;
	                          end = end === undefined ? len : ~~end;
	                          if (start < 0) {
	                            start += len;
	                            if (start < 0) start = 0;
	                          } else if (start > len) {
	                            start = len;
	                          }
	                          if (end < 0) {
	                            end += len;
	                            if (end < 0) end = 0;
	                          } else if (end > len) {
	                            end = len;
	                          }
	                          if (end < start) end = start;
	                          var newBuf = this.subarray(start, end);
	                          Object.setPrototypeOf(newBuf, Buffer2.prototype);
	                          return newBuf;
	                        };
	                        function checkOffset(offset, ext, length) {
	                          if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
	                          if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
	                        }
	                        Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
	                          offset = offset >>> 0;
	                          byteLength2 = byteLength2 >>> 0;
	                          if (!noAssert) checkOffset(offset, byteLength2, this.length);
	                          var val = this[offset];
	                          var mul = 1;
	                          var i = 0;
	                          while (++i < byteLength2 && (mul *= 256)) {
	                            val += this[offset + i] * mul;
	                          }
	                          return val;
	                        };
	                        Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
	                          offset = offset >>> 0;
	                          byteLength2 = byteLength2 >>> 0;
	                          if (!noAssert) {
	                            checkOffset(offset, byteLength2, this.length);
	                          }
	                          var val = this[offset + --byteLength2];
	                          var mul = 1;
	                          while (byteLength2 > 0 && (mul *= 256)) {
	                            val += this[offset + --byteLength2] * mul;
	                          }
	                          return val;
	                        };
	                        Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 1, this.length);
	                          return this[offset];
	                        };
	                        Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 2, this.length);
	                          return this[offset] | this[offset + 1] << 8;
	                        };
	                        Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 2, this.length);
	                          return this[offset] << 8 | this[offset + 1];
	                        };
	                        Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 4, this.length);
	                          return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
	                        };
	                        Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 4, this.length);
	                          return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	                        };
	                        Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
	                          offset = offset >>> 0;
	                          validateNumber(offset, "offset");
	                          var first = this[offset];
	                          var last = this[offset + 7];
	                          if (first === undefined || last === undefined) {
	                            boundsError(offset, this.length - 8);
	                          }
	                          var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
	                          var hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
	                          return BigInt(lo) + (BigInt(hi) << BigInt(32));
	                        });
	                        Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
	                          offset = offset >>> 0;
	                          validateNumber(offset, "offset");
	                          var first = this[offset];
	                          var last = this[offset + 7];
	                          if (first === undefined || last === undefined) {
	                            boundsError(offset, this.length - 8);
	                          }
	                          var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
	                          var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
	                          return (BigInt(hi) << BigInt(32)) + BigInt(lo);
	                        });
	                        Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
	                          offset = offset >>> 0;
	                          byteLength2 = byteLength2 >>> 0;
	                          if (!noAssert) checkOffset(offset, byteLength2, this.length);
	                          var val = this[offset];
	                          var mul = 1;
	                          var i = 0;
	                          while (++i < byteLength2 && (mul *= 256)) {
	                            val += this[offset + i] * mul;
	                          }
	                          mul *= 128;
	                          if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
	                          return val;
	                        };
	                        Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
	                          offset = offset >>> 0;
	                          byteLength2 = byteLength2 >>> 0;
	                          if (!noAssert) checkOffset(offset, byteLength2, this.length);
	                          var i = byteLength2;
	                          var mul = 1;
	                          var val = this[offset + --i];
	                          while (i > 0 && (mul *= 256)) {
	                            val += this[offset + --i] * mul;
	                          }
	                          mul *= 128;
	                          if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
	                          return val;
	                        };
	                        Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 1, this.length);
	                          if (!(this[offset] & 128)) return this[offset];
	                          return (255 - this[offset] + 1) * -1;
	                        };
	                        Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 2, this.length);
	                          var val = this[offset] | this[offset + 1] << 8;
	                          return val & 32768 ? val | 4294901760 : val;
	                        };
	                        Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 2, this.length);
	                          var val = this[offset + 1] | this[offset] << 8;
	                          return val & 32768 ? val | 4294901760 : val;
	                        };
	                        Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 4, this.length);
	                          return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	                        };
	                        Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 4, this.length);
	                          return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	                        };
	                        Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
	                          offset = offset >>> 0;
	                          validateNumber(offset, "offset");
	                          var first = this[offset];
	                          var last = this[offset + 7];
	                          if (first === undefined || last === undefined) {
	                            boundsError(offset, this.length - 8);
	                          }
	                          var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24);
	                          return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
	                        });
	                        Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
	                          offset = offset >>> 0;
	                          validateNumber(offset, "offset");
	                          var first = this[offset];
	                          var last = this[offset + 7];
	                          if (first === undefined || last === undefined) {
	                            boundsError(offset, this.length - 8);
	                          }
	                          var val = (first << 24) + // Overflow
	                          this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
	                          return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
	                        });
	                        Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 4, this.length);
	                          return ieee754.read(this, offset, true, 23, 4);
	                        };
	                        Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 4, this.length);
	                          return ieee754.read(this, offset, false, 23, 4);
	                        };
	                        Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 8, this.length);
	                          return ieee754.read(this, offset, true, 52, 8);
	                        };
	                        Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	                          offset = offset >>> 0;
	                          if (!noAssert) checkOffset(offset, 8, this.length);
	                          return ieee754.read(this, offset, false, 52, 8);
	                        };
	                        function checkInt(buf, value, offset, ext, max, min) {
	                          if (!Buffer2.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	                          if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	                          if (offset + ext > buf.length) throw new RangeError("Index out of range");
	                        }
	                        Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          byteLength2 = byteLength2 >>> 0;
	                          if (!noAssert) {
	                            var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
	                            checkInt(this, value, offset, byteLength2, maxBytes, 0);
	                          }
	                          var mul = 1;
	                          var i = 0;
	                          this[offset] = value & 255;
	                          while (++i < byteLength2 && (mul *= 256)) {
	                            this[offset + i] = value / mul & 255;
	                          }
	                          return offset + byteLength2;
	                        };
	                        Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          byteLength2 = byteLength2 >>> 0;
	                          if (!noAssert) {
	                            var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
	                            checkInt(this, value, offset, byteLength2, maxBytes, 0);
	                          }
	                          var i = byteLength2 - 1;
	                          var mul = 1;
	                          this[offset + i] = value & 255;
	                          while (--i >= 0 && (mul *= 256)) {
	                            this[offset + i] = value / mul & 255;
	                          }
	                          return offset + byteLength2;
	                        };
	                        Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
	                          this[offset] = value & 255;
	                          return offset + 1;
	                        };
	                        Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
	                          this[offset] = value & 255;
	                          this[offset + 1] = value >>> 8;
	                          return offset + 2;
	                        };
	                        Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
	                          this[offset] = value >>> 8;
	                          this[offset + 1] = value & 255;
	                          return offset + 2;
	                        };
	                        Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
	                          this[offset + 3] = value >>> 24;
	                          this[offset + 2] = value >>> 16;
	                          this[offset + 1] = value >>> 8;
	                          this[offset] = value & 255;
	                          return offset + 4;
	                        };
	                        Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
	                          this[offset] = value >>> 24;
	                          this[offset + 1] = value >>> 16;
	                          this[offset + 2] = value >>> 8;
	                          this[offset + 3] = value & 255;
	                          return offset + 4;
	                        };
	                        function wrtBigUInt64LE(buf, value, offset, min, max) {
	                          checkIntBI(value, min, max, buf, offset, 7);
	                          var lo = Number(value & BigInt(4294967295));
	                          buf[offset++] = lo;
	                          lo = lo >> 8;
	                          buf[offset++] = lo;
	                          lo = lo >> 8;
	                          buf[offset++] = lo;
	                          lo = lo >> 8;
	                          buf[offset++] = lo;
	                          var hi = Number(value >> BigInt(32) & BigInt(4294967295));
	                          buf[offset++] = hi;
	                          hi = hi >> 8;
	                          buf[offset++] = hi;
	                          hi = hi >> 8;
	                          buf[offset++] = hi;
	                          hi = hi >> 8;
	                          buf[offset++] = hi;
	                          return offset;
	                        }
	                        function wrtBigUInt64BE(buf, value, offset, min, max) {
	                          checkIntBI(value, min, max, buf, offset, 7);
	                          var lo = Number(value & BigInt(4294967295));
	                          buf[offset + 7] = lo;
	                          lo = lo >> 8;
	                          buf[offset + 6] = lo;
	                          lo = lo >> 8;
	                          buf[offset + 5] = lo;
	                          lo = lo >> 8;
	                          buf[offset + 4] = lo;
	                          var hi = Number(value >> BigInt(32) & BigInt(4294967295));
	                          buf[offset + 3] = hi;
	                          hi = hi >> 8;
	                          buf[offset + 2] = hi;
	                          hi = hi >> 8;
	                          buf[offset + 1] = hi;
	                          hi = hi >> 8;
	                          buf[offset] = hi;
	                          return offset + 8;
	                        }
	                        Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value) {
	                          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	                          return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	                        });
	                        Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value) {
	                          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	                          return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	                        });
	                        Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) {
	                            var limit = Math.pow(2, 8 * byteLength2 - 1);
	                            checkInt(this, value, offset, byteLength2, limit - 1, -limit);
	                          }
	                          var i = 0;
	                          var mul = 1;
	                          var sub = 0;
	                          this[offset] = value & 255;
	                          while (++i < byteLength2 && (mul *= 256)) {
	                            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	                              sub = 1;
	                            }
	                            this[offset + i] = (value / mul >> 0) - sub & 255;
	                          }
	                          return offset + byteLength2;
	                        };
	                        Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) {
	                            var limit = Math.pow(2, 8 * byteLength2 - 1);
	                            checkInt(this, value, offset, byteLength2, limit - 1, -limit);
	                          }
	                          var i = byteLength2 - 1;
	                          var mul = 1;
	                          var sub = 0;
	                          this[offset + i] = value & 255;
	                          while (--i >= 0 && (mul *= 256)) {
	                            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	                              sub = 1;
	                            }
	                            this[offset + i] = (value / mul >> 0) - sub & 255;
	                          }
	                          return offset + byteLength2;
	                        };
	                        Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
	                          if (value < 0) value = 255 + value + 1;
	                          this[offset] = value & 255;
	                          return offset + 1;
	                        };
	                        Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
	                          this[offset] = value & 255;
	                          this[offset + 1] = value >>> 8;
	                          return offset + 2;
	                        };
	                        Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
	                          this[offset] = value >>> 8;
	                          this[offset + 1] = value & 255;
	                          return offset + 2;
	                        };
	                        Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
	                          this[offset] = value & 255;
	                          this[offset + 1] = value >>> 8;
	                          this[offset + 2] = value >>> 16;
	                          this[offset + 3] = value >>> 24;
	                          return offset + 4;
	                        };
	                        Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
	                          if (value < 0) value = 4294967295 + value + 1;
	                          this[offset] = value >>> 24;
	                          this[offset + 1] = value >>> 16;
	                          this[offset + 2] = value >>> 8;
	                          this[offset + 3] = value & 255;
	                          return offset + 4;
	                        };
	                        Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value) {
	                          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	                          return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	                        });
	                        Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value) {
	                          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	                          return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	                        });
	                        function checkIEEE754(buf, value, offset, ext, max, min) {
	                          if (offset + ext > buf.length) throw new RangeError("Index out of range");
	                          if (offset < 0) throw new RangeError("Index out of range");
	                        }
	                        function writeFloat(buf, value, offset, littleEndian, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) {
	                            checkIEEE754(buf, value, offset, 4);
	                          }
	                          ieee754.write(buf, value, offset, littleEndian, 23, 4);
	                          return offset + 4;
	                        }
	                        Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	                          return writeFloat(this, value, offset, true, noAssert);
	                        };
	                        Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	                          return writeFloat(this, value, offset, false, noAssert);
	                        };
	                        function writeDouble(buf, value, offset, littleEndian, noAssert) {
	                          value = +value;
	                          offset = offset >>> 0;
	                          if (!noAssert) {
	                            checkIEEE754(buf, value, offset, 8);
	                          }
	                          ieee754.write(buf, value, offset, littleEndian, 52, 8);
	                          return offset + 8;
	                        }
	                        Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	                          return writeDouble(this, value, offset, true, noAssert);
	                        };
	                        Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	                          return writeDouble(this, value, offset, false, noAssert);
	                        };
	                        Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
	                          if (!Buffer2.isBuffer(target)) throw new TypeError("argument should be a Buffer");
	                          if (!start) start = 0;
	                          if (!end && end !== 0) end = this.length;
	                          if (targetStart >= target.length) targetStart = target.length;
	                          if (!targetStart) targetStart = 0;
	                          if (end > 0 && end < start) end = start;
	                          if (end === start) return 0;
	                          if (target.length === 0 || this.length === 0) return 0;
	                          if (targetStart < 0) {
	                            throw new RangeError("targetStart out of bounds");
	                          }
	                          if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
	                          if (end < 0) throw new RangeError("sourceEnd out of bounds");
	                          if (end > this.length) end = this.length;
	                          if (target.length - targetStart < end - start) {
	                            end = target.length - targetStart + start;
	                          }
	                          var len = end - start;
	                          if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
	                            this.copyWithin(targetStart, start, end);
	                          } else {
	                            Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
	                          }
	                          return len;
	                        };
	                        Buffer2.prototype.fill = function fill(val, start, end, encoding) {
	                          if (typeof val === "string") {
	                            if (typeof start === "string") {
	                              encoding = start;
	                              start = 0;
	                              end = this.length;
	                            } else if (typeof end === "string") {
	                              encoding = end;
	                              end = this.length;
	                            }
	                            if (encoding !== undefined && typeof encoding !== "string") {
	                              throw new TypeError("encoding must be a string");
	                            }
	                            if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
	                              throw new TypeError("Unknown encoding: " + encoding);
	                            }
	                            if (val.length === 1) {
	                              var code = val.charCodeAt(0);
	                              if (encoding === "utf8" && code < 128 || encoding === "latin1") {
	                                val = code;
	                              }
	                            }
	                          } else if (typeof val === "number") {
	                            val = val & 255;
	                          } else if (typeof val === "boolean") {
	                            val = Number(val);
	                          }
	                          if (start < 0 || this.length < start || this.length < end) {
	                            throw new RangeError("Out of range index");
	                          }
	                          if (end <= start) {
	                            return this;
	                          }
	                          start = start >>> 0;
	                          end = end === undefined ? this.length : end >>> 0;
	                          if (!val) val = 0;
	                          var i;
	                          if (typeof val === "number") {
	                            for (i = start; i < end; ++i) {
	                              this[i] = val;
	                            }
	                          } else {
	                            var bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
	                            var len = bytes.length;
	                            if (len === 0) {
	                              throw new TypeError('The value "' + val + '" is invalid for argument "value"');
	                            }
	                            for (i = 0; i < end - start; ++i) {
	                              this[i + start] = bytes[i % len];
	                            }
	                          }
	                          return this;
	                        };
	                        var errors = {};
	                        function E(sym, getMessage, Base) {
	                          errors[sym] = /* @__PURE__ */ function(_Base) {
	                            _inherits(NodeError, _Base);
	                            var _super = _createSuper(NodeError);
	                            function NodeError() {
	                              var _this;
	                              _classCallCheck(this, NodeError);
	                              _this = _super.call(this);
	                              Object.defineProperty(_assertThisInitialized(_this), "message", { value: getMessage.apply(_assertThisInitialized(_this), arguments), writable: true, configurable: true });
	                              _this.name = "".concat(_this.name, " [").concat(sym, "]");
	                              _this.stack;
	                              delete _this.name;
	                              return _this;
	                            }
	                            _createClass(NodeError, [{ key: "code", get: function get() {
	                              return sym;
	                            }, set: function set(value) {
	                              Object.defineProperty(this, "code", { configurable: true, enumerable: true, value, writable: true });
	                            } }, { key: "toString", value: function toString() {
	                              return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
	                            } }]);
	                            return NodeError;
	                          }(Base);
	                        }
	                        E("ERR_BUFFER_OUT_OF_BOUNDS", function(name2) {
	                          if (name2) {
	                            return "".concat(name2, " is outside of buffer bounds");
	                          }
	                          return "Attempt to access memory outside buffer bounds";
	                        }, RangeError);
	                        E("ERR_INVALID_ARG_TYPE", function(name2, actual) {
	                          return 'The "'.concat(name2, '" argument must be of type number. Received type ').concat(_typeof(actual));
	                        }, TypeError);
	                        E("ERR_OUT_OF_RANGE", function(str, range2, input) {
	                          var msg = 'The value of "'.concat(str, '" is out of range.');
	                          var received = input;
	                          if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
	                            received = addNumericalSeparator(String(input));
	                          } else if (typeof input === "bigint") {
	                            received = String(input);
	                            if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) {
	                              received = addNumericalSeparator(received);
	                            }
	                            received += "n";
	                          }
	                          msg += " It must be ".concat(range2, ". Received ").concat(received);
	                          return msg;
	                        }, RangeError);
	                        function addNumericalSeparator(val) {
	                          var res = "";
	                          var i = val.length;
	                          var start = val[0] === "-" ? 1 : 0;
	                          for (; i >= start + 4; i -= 3) {
	                            res = "_".concat(val.slice(i - 3, i)).concat(res);
	                          }
	                          return "".concat(val.slice(0, i)).concat(res);
	                        }
	                        function checkBounds(buf, offset, byteLength2) {
	                          validateNumber(offset, "offset");
	                          if (buf[offset] === undefined || buf[offset + byteLength2] === undefined) {
	                            boundsError(offset, buf.length - (byteLength2 + 1));
	                          }
	                        }
	                        function checkIntBI(value, min, max, buf, offset, byteLength2) {
	                          if (value > max || value < min) {
	                            var n = typeof min === "bigint" ? "n" : "";
	                            var range2;
	                            {
	                              if (min === 0 || min === BigInt(0)) {
	                                range2 = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength2 + 1) * 8).concat(n);
	                              } else {
	                                range2 = ">= -(2".concat(n, " ** ").concat((byteLength2 + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength2 + 1) * 8 - 1).concat(n);
	                              }
	                            }
	                            throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
	                          }
	                          checkBounds(buf, offset, byteLength2);
	                        }
	                        function validateNumber(value, name2) {
	                          if (typeof value !== "number") {
	                            throw new errors.ERR_INVALID_ARG_TYPE(name2, "number", value);
	                          }
	                        }
	                        function boundsError(value, length, type) {
	                          if (Math.floor(value) !== value) {
	                            validateNumber(value, type);
	                            throw new errors.ERR_OUT_OF_RANGE("offset", "an integer", value);
	                          }
	                          if (length < 0) {
	                            throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
	                          }
	                          throw new errors.ERR_OUT_OF_RANGE("offset", ">= ".concat(0, " and <= ").concat(length), value);
	                        }
	                        var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
	                        function base64clean(str) {
	                          str = str.split("=")[0];
	                          str = str.trim().replace(INVALID_BASE64_RE, "");
	                          if (str.length < 2) return "";
	                          while (str.length % 4 !== 0) {
	                            str = str + "=";
	                          }
	                          return str;
	                        }
	                        function utf8ToBytes(string, units) {
	                          units = units || Infinity;
	                          var codePoint;
	                          var length = string.length;
	                          var leadSurrogate = null;
	                          var bytes = [];
	                          for (var i = 0; i < length; ++i) {
	                            codePoint = string.charCodeAt(i);
	                            if (codePoint > 55295 && codePoint < 57344) {
	                              if (!leadSurrogate) {
	                                if (codePoint > 56319) {
	                                  if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                                  continue;
	                                } else if (i + 1 === length) {
	                                  if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                                  continue;
	                                }
	                                leadSurrogate = codePoint;
	                                continue;
	                              }
	                              if (codePoint < 56320) {
	                                if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                                leadSurrogate = codePoint;
	                                continue;
	                              }
	                              codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
	                            } else if (leadSurrogate) {
	                              if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                            }
	                            leadSurrogate = null;
	                            if (codePoint < 128) {
	                              if ((units -= 1) < 0) break;
	                              bytes.push(codePoint);
	                            } else if (codePoint < 2048) {
	                              if ((units -= 2) < 0) break;
	                              bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
	                            } else if (codePoint < 65536) {
	                              if ((units -= 3) < 0) break;
	                              bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
	                            } else if (codePoint < 1114112) {
	                              if ((units -= 4) < 0) break;
	                              bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
	                            } else {
	                              throw new Error("Invalid code point");
	                            }
	                          }
	                          return bytes;
	                        }
	                        function asciiToBytes(str) {
	                          var byteArray = [];
	                          for (var i = 0; i < str.length; ++i) {
	                            byteArray.push(str.charCodeAt(i) & 255);
	                          }
	                          return byteArray;
	                        }
	                        function utf16leToBytes(str, units) {
	                          var c, hi, lo;
	                          var byteArray = [];
	                          for (var i = 0; i < str.length; ++i) {
	                            if ((units -= 2) < 0) break;
	                            c = str.charCodeAt(i);
	                            hi = c >> 8;
	                            lo = c % 256;
	                            byteArray.push(lo);
	                            byteArray.push(hi);
	                          }
	                          return byteArray;
	                        }
	                        function base64ToBytes(str) {
	                          return base64.toByteArray(base64clean(str));
	                        }
	                        function blitBuffer(src, dst, offset, length) {
	                          var i;
	                          for (i = 0; i < length; ++i) {
	                            if (i + offset >= dst.length || i >= src.length) break;
	                            dst[i + offset] = src[i];
	                          }
	                          return i;
	                        }
	                        function isInstance(obj, type) {
	                          return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
	                        }
	                        function numberIsNaN(obj) {
	                          return obj !== obj;
	                        }
	                        var hexSliceLookupTable = function() {
	                          var alphabet = "0123456789abcdef";
	                          var table = new Array(256);
	                          for (var i = 0; i < 16; ++i) {
	                            var i16 = i * 16;
	                            for (var j = 0; j < 16; ++j) {
	                              table[i16 + j] = alphabet[i] + alphabet[j];
	                            }
	                          }
	                          return table;
	                        }();
	                        function defineBigIntMethod(fn) {
	                          return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
	                        }
	                        function BufferBigIntNotDefined() {
	                          throw new Error("BigInt not supported");
	                        }
	                      }
	                    ),
	                    /***/
	                    2321: (
	                      /***/
	                      function(module3) {
	                        module3.exports = isMobile;
	                        module3.exports.isMobile = isMobile;
	                        module3.exports["default"] = isMobile;
	                        var mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
	                        var notMobileRE = /CrOS/;
	                        var tabletRE = /android|ipad|playbook|silk/i;
	                        function isMobile(opts) {
	                          if (!opts) opts = {};
	                          var ua = opts.ua;
	                          if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
	                          if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
	                            ua = ua.headers["user-agent"];
	                          }
	                          if (typeof ua !== "string") return false;
	                          var result = mobileRE.test(ua) && !notMobileRE.test(ua) || !!opts.tablet && tabletRE.test(ua);
	                          if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) {
	                            result = true;
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    3910: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        exports2.byteLength = byteLength;
	                        exports2.toByteArray = toByteArray;
	                        exports2.fromByteArray = fromByteArray;
	                        var lookup = [];
	                        var revLookup = [];
	                        var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
	                        var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	                        for (var i = 0, len = code.length; i < len; ++i) {
	                          lookup[i] = code[i];
	                          revLookup[code.charCodeAt(i)] = i;
	                        }
	                        revLookup["-".charCodeAt(0)] = 62;
	                        revLookup["_".charCodeAt(0)] = 63;
	                        function getLens(b64) {
	                          var len2 = b64.length;
	                          if (len2 % 4 > 0) {
	                            throw new Error("Invalid string. Length must be a multiple of 4");
	                          }
	                          var validLen = b64.indexOf("=");
	                          if (validLen === -1) validLen = len2;
	                          var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
	                          return [validLen, placeHoldersLen];
	                        }
	                        function byteLength(b64) {
	                          var lens = getLens(b64);
	                          var validLen = lens[0];
	                          var placeHoldersLen = lens[1];
	                          return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	                        }
	                        function _byteLength(b64, validLen, placeHoldersLen) {
	                          return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	                        }
	                        function toByteArray(b64) {
	                          var tmp;
	                          var lens = getLens(b64);
	                          var validLen = lens[0];
	                          var placeHoldersLen = lens[1];
	                          var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
	                          var curByte = 0;
	                          var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
	                          var i2;
	                          for (i2 = 0; i2 < len2; i2 += 4) {
	                            tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
	                            arr[curByte++] = tmp >> 16 & 255;
	                            arr[curByte++] = tmp >> 8 & 255;
	                            arr[curByte++] = tmp & 255;
	                          }
	                          if (placeHoldersLen === 2) {
	                            tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
	                            arr[curByte++] = tmp & 255;
	                          }
	                          if (placeHoldersLen === 1) {
	                            tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
	                            arr[curByte++] = tmp >> 8 & 255;
	                            arr[curByte++] = tmp & 255;
	                          }
	                          return arr;
	                        }
	                        function tripletToBase64(num) {
	                          return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
	                        }
	                        function encodeChunk(uint8, start, end) {
	                          var tmp;
	                          var output = [];
	                          for (var i2 = start; i2 < end; i2 += 3) {
	                            tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
	                            output.push(tripletToBase64(tmp));
	                          }
	                          return output.join("");
	                        }
	                        function fromByteArray(uint8) {
	                          var tmp;
	                          var len2 = uint8.length;
	                          var extraBytes = len2 % 3;
	                          var parts = [];
	                          var maxChunkLength = 16383;
	                          for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
	                            parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
	                          }
	                          if (extraBytes === 1) {
	                            tmp = uint8[len2 - 1];
	                            parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
	                          } else if (extraBytes === 2) {
	                            tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
	                            parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
	                          }
	                          return parts.join("");
	                        }
	                      }
	                    ),
	                    /***/
	                    3187: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	                        exports2.read = function(buffer, offset, isLE, mLen, nBytes) {
	                          var e, m;
	                          var eLen = nBytes * 8 - mLen - 1;
	                          var eMax = (1 << eLen) - 1;
	                          var eBias = eMax >> 1;
	                          var nBits = -7;
	                          var i = isLE ? nBytes - 1 : 0;
	                          var d = isLE ? -1 : 1;
	                          var s = buffer[offset + i];
	                          i += d;
	                          e = s & (1 << -nBits) - 1;
	                          s >>= -nBits;
	                          nBits += eLen;
	                          for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
	                          }
	                          m = e & (1 << -nBits) - 1;
	                          e >>= -nBits;
	                          nBits += mLen;
	                          for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
	                          }
	                          if (e === 0) {
	                            e = 1 - eBias;
	                          } else if (e === eMax) {
	                            return m ? NaN : (s ? -1 : 1) * Infinity;
	                          } else {
	                            m = m + Math.pow(2, mLen);
	                            e = e - eBias;
	                          }
	                          return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	                        };
	                        exports2.write = function(buffer, value, offset, isLE, mLen, nBytes) {
	                          var e, m, c;
	                          var eLen = nBytes * 8 - mLen - 1;
	                          var eMax = (1 << eLen) - 1;
	                          var eBias = eMax >> 1;
	                          var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	                          var i = isLE ? 0 : nBytes - 1;
	                          var d = isLE ? 1 : -1;
	                          var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	                          value = Math.abs(value);
	                          if (isNaN(value) || value === Infinity) {
	                            m = isNaN(value) ? 1 : 0;
	                            e = eMax;
	                          } else {
	                            e = Math.floor(Math.log(value) / Math.LN2);
	                            if (value * (c = Math.pow(2, -e)) < 1) {
	                              e--;
	                              c *= 2;
	                            }
	                            if (e + eBias >= 1) {
	                              value += rt / c;
	                            } else {
	                              value += rt * Math.pow(2, 1 - eBias);
	                            }
	                            if (value * c >= 2) {
	                              e++;
	                              c /= 2;
	                            }
	                            if (e + eBias >= eMax) {
	                              m = 0;
	                              e = eMax;
	                            } else if (e + eBias >= 1) {
	                              m = (value * c - 1) * Math.pow(2, mLen);
	                              e = e + eBias;
	                            } else {
	                              m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	                              e = 0;
	                            }
	                          }
	                          for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
	                          }
	                          e = e << mLen | m;
	                          eLen += mLen;
	                          for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
	                          }
	                          buffer[offset + i - d] |= s * 128;
	                        };
	                      }
	                    ),
	                    /***/
	                    1152: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_58199__) {
	                        module3.exports = createViewController;
	                        var createTurntable = __nested_webpack_require_58199__(3440);
	                        var createOrbit = __nested_webpack_require_58199__(7774);
	                        var createMatrix = __nested_webpack_require_58199__(9298);
	                        function ViewController(controllers, mode) {
	                          this._controllerNames = Object.keys(controllers);
	                          this._controllerList = this._controllerNames.map(function(n) {
	                            return controllers[n];
	                          });
	                          this._mode = mode;
	                          this._active = controllers[mode];
	                          if (!this._active) {
	                            this._mode = "turntable";
	                            this._active = controllers.turntable;
	                          }
	                          this.modes = this._controllerNames;
	                          this.computedMatrix = this._active.computedMatrix;
	                          this.computedEye = this._active.computedEye;
	                          this.computedUp = this._active.computedUp;
	                          this.computedCenter = this._active.computedCenter;
	                          this.computedRadius = this._active.computedRadius;
	                        }
	                        var proto = ViewController.prototype;
	                        proto.flush = function(a0) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].flush(a0);
	                          }
	                        };
	                        proto.idle = function(a0) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].idle(a0);
	                          }
	                        };
	                        proto.lookAt = function(a0, a1, a2, a3) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].lookAt(a0, a1, a2, a3);
	                          }
	                        };
	                        proto.rotate = function(a0, a1, a2, a3) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].rotate(a0, a1, a2, a3);
	                          }
	                        };
	                        proto.pan = function(a0, a1, a2, a3) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].pan(a0, a1, a2, a3);
	                          }
	                        };
	                        proto.translate = function(a0, a1, a2, a3) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].translate(a0, a1, a2, a3);
	                          }
	                        };
	                        proto.setMatrix = function(a0, a1) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].setMatrix(a0, a1);
	                          }
	                        };
	                        proto.setDistanceLimits = function(a0, a1) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].setDistanceLimits(a0, a1);
	                          }
	                        };
	                        proto.setDistance = function(a0, a1) {
	                          var cc = this._controllerList;
	                          for (var i = 0; i < cc.length; ++i) {
	                            cc[i].setDistance(a0, a1);
	                          }
	                        };
	                        proto.recalcMatrix = function(t) {
	                          this._active.recalcMatrix(t);
	                        };
	                        proto.getDistance = function(t) {
	                          return this._active.getDistance(t);
	                        };
	                        proto.getDistanceLimits = function(out) {
	                          return this._active.getDistanceLimits(out);
	                        };
	                        proto.lastT = function() {
	                          return this._active.lastT();
	                        };
	                        proto.setMode = function(mode) {
	                          if (mode === this._mode) {
	                            return;
	                          }
	                          var idx = this._controllerNames.indexOf(mode);
	                          if (idx < 0) {
	                            return;
	                          }
	                          var prev = this._active;
	                          var next = this._controllerList[idx];
	                          var lastT = Math.max(prev.lastT(), next.lastT());
	                          prev.recalcMatrix(lastT);
	                          next.setMatrix(lastT, prev.computedMatrix);
	                          this._active = next;
	                          this._mode = mode;
	                          this.computedMatrix = this._active.computedMatrix;
	                          this.computedEye = this._active.computedEye;
	                          this.computedUp = this._active.computedUp;
	                          this.computedCenter = this._active.computedCenter;
	                          this.computedRadius = this._active.computedRadius;
	                        };
	                        proto.getMode = function() {
	                          return this._mode;
	                        };
	                        function createViewController(options) {
	                          options = options || {};
	                          var eye = options.eye || [0, 0, 1];
	                          var center = options.center || [0, 0, 0];
	                          var up = options.up || [0, 1, 0];
	                          var limits = options.distanceLimits || [0, Infinity];
	                          var mode = options.mode || "turntable";
	                          var turntable = createTurntable();
	                          var orbit = createOrbit();
	                          var matrix = createMatrix();
	                          turntable.setDistanceLimits(limits[0], limits[1]);
	                          turntable.lookAt(0, eye, center, up);
	                          orbit.setDistanceLimits(limits[0], limits[1]);
	                          orbit.lookAt(0, eye, center, up);
	                          matrix.setDistanceLimits(limits[0], limits[1]);
	                          matrix.lookAt(0, eye, center, up);
	                          return new ViewController({ turntable, orbit, matrix }, mode);
	                        }
	                      }
	                    ),
	                    /***/
	                    8126: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_61625__) {
	                        var weakMap = typeof WeakMap === "undefined" ? __nested_webpack_require_61625__(5346) : WeakMap;
	                        var createBuffer = __nested_webpack_require_61625__(5827);
	                        var createVAO = __nested_webpack_require_61625__(2944);
	                        var TriangleCache = new weakMap();
	                        function createABigTriangle(gl2) {
	                          var triangleVAO = TriangleCache.get(gl2);
	                          var handle = triangleVAO && (triangleVAO._triangleBuffer.handle || triangleVAO._triangleBuffer.buffer);
	                          if (!handle || !gl2.isBuffer(handle)) {
	                            var buf = createBuffer(gl2, new Float32Array([-1, -1, -1, 4, 4, -1]));
	                            triangleVAO = createVAO(gl2, [{ buffer: buf, type: gl2.FLOAT, size: 2 }]);
	                            triangleVAO._triangleBuffer = buf;
	                            TriangleCache.set(gl2, triangleVAO);
	                          }
	                          triangleVAO.bind();
	                          gl2.drawArrays(gl2.TRIANGLES, 0, 3);
	                          triangleVAO.unbind();
	                        }
	                        module3.exports = createABigTriangle;
	                      }
	                    ),
	                    /***/
	                    8008: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_62410__) {
	                        var padLeft = __nested_webpack_require_62410__(4930);
	                        module3.exports = addLineNumbers;
	                        function addLineNumbers(string, start, delim) {
	                          start = typeof start === "number" ? start : 1;
	                          delim = delim || ": ";
	                          var lines = string.split(/\r?\n/);
	                          var totalDigits = String(lines.length + start - 1).length;
	                          return lines.map(function(line, i) {
	                            var c = i + start;
	                            var digits = String(c).length;
	                            var prefix = padLeft(c, totalDigits - digits);
	                            return prefix + delim + line;
	                          }).join("\n");
	                        }
	                      }
	                    ),
	                    /***/
	                    2153: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_62903__) {
	                        module3.exports = affineHull;
	                        var orient = __nested_webpack_require_62903__(417);
	                        function linearlyIndependent(points, d) {
	                          var nhull = new Array(d + 1);
	                          for (var i = 0; i < points.length; ++i) {
	                            nhull[i] = points[i];
	                          }
	                          for (var i = 0; i <= points.length; ++i) {
	                            for (var j = points.length; j <= d; ++j) {
	                              var x = new Array(d);
	                              for (var k = 0; k < d; ++k) {
	                                x[k] = Math.pow(j + 1 - i, k);
	                              }
	                              nhull[j] = x;
	                            }
	                            var o = orient.apply(undefined, nhull);
	                            if (o) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        }
	                        function affineHull(points) {
	                          var n = points.length;
	                          if (n === 0) {
	                            return [];
	                          }
	                          if (n === 1) {
	                            return [0];
	                          }
	                          var d = points[0].length;
	                          var frame = [points[0]];
	                          var index = [0];
	                          for (var i = 1; i < n; ++i) {
	                            frame.push(points[i]);
	                            if (!linearlyIndependent(frame, d)) {
	                              frame.pop();
	                              continue;
	                            }
	                            index.push(i);
	                            if (index.length === d + 1) {
	                              return index;
	                            }
	                          }
	                          return index;
	                        }
	                      }
	                    ),
	                    /***/
	                    4653: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_63703__) {
	                        module3.exports = alphaComplex;
	                        var delaunay = __nested_webpack_require_63703__(4419);
	                        var circumradius = __nested_webpack_require_63703__(1778);
	                        function alphaComplex(alpha, points) {
	                          return delaunay(points).filter(function(cell) {
	                            var simplex = new Array(cell.length);
	                            for (var i = 0; i < cell.length; ++i) {
	                              simplex[i] = points[cell[i]];
	                            }
	                            return circumradius(simplex) * alpha < 1;
	                          });
	                        }
	                      }
	                    ),
	                    /***/
	                    2350: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_64127__) {
	                        module3.exports = alphaShape;
	                        var ac = __nested_webpack_require_64127__(4653);
	                        var bnd = __nested_webpack_require_64127__(8691);
	                        function alphaShape(alpha, points) {
	                          return bnd(ac(alpha, points));
	                        }
	                      }
	                    ),
	                    /***/
	                    7896: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function _atob(str) {
	                          return atob(str);
	                        };
	                      }
	                    ),
	                    /***/
	                    957: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_64460__) {
	                        module3.exports = barycentric;
	                        var solve = __nested_webpack_require_64460__(6606);
	                        function reduce(x) {
	                          var r = 0;
	                          for (var i = 0; i < x.length; ++i) {
	                            r += x[i];
	                          }
	                          return r;
	                        }
	                        function barycentric(simplex, point) {
	                          var d = point.length;
	                          var A = new Array(d + 1);
	                          for (var i = 0; i < d; ++i) {
	                            var row = new Array(d + 1);
	                            for (var j = 0; j <= d; ++j) {
	                              row[j] = simplex[j][i];
	                            }
	                            A[i] = row;
	                          }
	                          A[d] = new Array(d + 1);
	                          for (var i = 0; i <= d; ++i) {
	                            A[d][i] = 1;
	                          }
	                          var b = new Array(d + 1);
	                          for (var i = 0; i < d; ++i) {
	                            b[i] = point[i];
	                          }
	                          b[d] = 1;
	                          var x = solve(A, b);
	                          var w = reduce(x[d + 1]);
	                          if (w === 0) {
	                            w = 1;
	                          }
	                          var y = new Array(d + 1);
	                          for (var i = 0; i <= d; ++i) {
	                            y[i] = reduce(x[i]) / w;
	                          }
	                          return y;
	                        }
	                      }
	                    ),
	                    /***/
	                    1539: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_65116__) {
	                        var rationalize = __nested_webpack_require_65116__(8524);
	                        module3.exports = add;
	                        function add(a, b) {
	                          return rationalize(a[0].mul(b[1]).add(b[0].mul(a[1])), a[1].mul(b[1]));
	                        }
	                      }
	                    ),
	                    /***/
	                    8846: (
	                      /***/
	                      function(module3) {
	                        module3.exports = cmp;
	                        function cmp(a, b) {
	                          return a[0].mul(b[1]).cmp(b[0].mul(a[1]));
	                        }
	                      }
	                    ),
	                    /***/
	                    9189: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_65495__) {
	                        var rationalize = __nested_webpack_require_65495__(8524);
	                        module3.exports = div;
	                        function div(a, b) {
	                          return rationalize(a[0].mul(b[1]), a[1].mul(b[0]));
	                        }
	                      }
	                    ),
	                    /***/
	                    5125: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_65722__) {
	                        var isRat = __nested_webpack_require_65722__(234);
	                        var isBN = __nested_webpack_require_65722__(3218);
	                        var num2bn = __nested_webpack_require_65722__(5514);
	                        var str2bn = __nested_webpack_require_65722__(2813);
	                        var rationalize = __nested_webpack_require_65722__(8524);
	                        var div = __nested_webpack_require_65722__(9189);
	                        module3.exports = makeRational;
	                        function makeRational(numer, denom) {
	                          if (isRat(numer)) {
	                            if (denom) {
	                              return div(numer, makeRational(denom));
	                            }
	                            return [numer[0].clone(), numer[1].clone()];
	                          }
	                          var shift = 0;
	                          var a, b;
	                          if (isBN(numer)) {
	                            a = numer.clone();
	                          } else if (typeof numer === "string") {
	                            a = str2bn(numer);
	                          } else if (numer === 0) {
	                            return [num2bn(0), num2bn(1)];
	                          } else if (numer === Math.floor(numer)) {
	                            a = num2bn(numer);
	                          } else {
	                            while (numer !== Math.floor(numer)) {
	                              numer = numer * Math.pow(2, 256);
	                              shift -= 256;
	                            }
	                            a = num2bn(numer);
	                          }
	                          if (isRat(denom)) {
	                            a.mul(denom[1]);
	                            b = denom[0].clone();
	                          } else if (isBN(denom)) {
	                            b = denom.clone();
	                          } else if (typeof denom === "string") {
	                            b = str2bn(denom);
	                          } else if (!denom) {
	                            b = num2bn(1);
	                          } else if (denom === Math.floor(denom)) {
	                            b = num2bn(denom);
	                          } else {
	                            while (denom !== Math.floor(denom)) {
	                              denom = denom * Math.pow(2, 256);
	                              shift += 256;
	                            }
	                            b = num2bn(denom);
	                          }
	                          if (shift > 0) {
	                            a = a.ushln(shift);
	                          } else if (shift < 0) {
	                            b = b.ushln(-shift);
	                          }
	                          return rationalize(a, b);
	                        }
	                      }
	                    ),
	                    /***/
	                    234: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_66916__) {
	                        var isBN = __nested_webpack_require_66916__(3218);
	                        module3.exports = isRat;
	                        function isRat(x) {
	                          return Array.isArray(x) && x.length === 2 && isBN(x[0]) && isBN(x[1]);
	                        }
	                      }
	                    ),
	                    /***/
	                    4275: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_67150__) {
	                        var BN = __nested_webpack_require_67150__(1928);
	                        module3.exports = sign;
	                        function sign(x) {
	                          return x.cmp(new BN(0));
	                        }
	                      }
	                    ),
	                    /***/
	                    9958: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_67342__) {
	                        var sign = __nested_webpack_require_67342__(4275);
	                        module3.exports = bn2num;
	                        function bn2num(b) {
	                          var l = b.length;
	                          var words = b.words;
	                          var out = 0;
	                          if (l === 1) {
	                            out = words[0];
	                          } else if (l === 2) {
	                            out = words[0] + words[1] * 67108864;
	                          } else {
	                            for (var i = 0; i < l; i++) {
	                              var w = words[i];
	                              out += w * Math.pow(67108864, i);
	                            }
	                          }
	                          return sign(b) * out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1112: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_67747__) {
	                        var db = __nested_webpack_require_67747__(8362);
	                        var ctz = __nested_webpack_require_67747__(2288).countTrailingZeros;
	                        module3.exports = ctzNumber;
	                        function ctzNumber(x) {
	                          var l = ctz(db.lo(x));
	                          if (l < 32) {
	                            return l;
	                          }
	                          var h = ctz(db.hi(x));
	                          if (h > 20) {
	                            return 52;
	                          }
	                          return h + 32;
	                        }
	                      }
	                    ),
	                    /***/
	                    3218: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_68107__) {
	                        __nested_webpack_require_68107__(1928);
	                        module3.exports = isBN;
	                        function isBN(x) {
	                          return x && typeof x === "object" && Boolean(x.words);
	                        }
	                      }
	                    ),
	                    /***/
	                    5514: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_68400__) {
	                        var BN = __nested_webpack_require_68400__(1928);
	                        var db = __nested_webpack_require_68400__(8362);
	                        module3.exports = num2bn;
	                        function num2bn(x) {
	                          var e = db.exponent(x);
	                          if (e < 52) {
	                            return new BN(x);
	                          } else {
	                            return new BN(x * Math.pow(2, 52 - e)).ushln(e - 52);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    8524: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_68705__) {
	                        var num2bn = __nested_webpack_require_68705__(5514);
	                        var sign = __nested_webpack_require_68705__(4275);
	                        module3.exports = rationalize;
	                        function rationalize(numer, denom) {
	                          var snumer = sign(numer);
	                          var sdenom = sign(denom);
	                          if (snumer === 0) {
	                            return [num2bn(0), num2bn(1)];
	                          }
	                          if (sdenom === 0) {
	                            return [num2bn(0), num2bn(0)];
	                          }
	                          if (sdenom < 0) {
	                            numer = numer.neg();
	                            denom = denom.neg();
	                          }
	                          var d = numer.gcd(denom);
	                          if (d.cmpn(1)) {
	                            return [numer.div(d), denom.div(d)];
	                          }
	                          return [numer, denom];
	                        }
	                      }
	                    ),
	                    /***/
	                    2813: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_69212__) {
	                        var BN = __nested_webpack_require_69212__(1928);
	                        module3.exports = str2BN;
	                        function str2BN(x) {
	                          return new BN(x);
	                        }
	                      }
	                    ),
	                    /***/
	                    3962: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_69401__) {
	                        var rationalize = __nested_webpack_require_69401__(8524);
	                        module3.exports = mul;
	                        function mul(a, b) {
	                          return rationalize(a[0].mul(b[0]), a[1].mul(b[1]));
	                        }
	                      }
	                    ),
	                    /***/
	                    4951: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_69628__) {
	                        var bnsign = __nested_webpack_require_69628__(4275);
	                        module3.exports = sign;
	                        function sign(x) {
	                          return bnsign(x[0]) * bnsign(x[1]);
	                        }
	                      }
	                    ),
	                    /***/
	                    4354: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_69833__) {
	                        var rationalize = __nested_webpack_require_69833__(8524);
	                        module3.exports = sub;
	                        function sub(a, b) {
	                          return rationalize(a[0].mul(b[1]).sub(a[1].mul(b[0])), a[1].mul(b[1]));
	                        }
	                      }
	                    ),
	                    /***/
	                    7999: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_70080__) {
	                        var bn2num = __nested_webpack_require_70080__(9958);
	                        var ctz = __nested_webpack_require_70080__(1112);
	                        module3.exports = roundRat;
	                        function roundRat(f) {
	                          var a = f[0];
	                          var b = f[1];
	                          if (a.cmpn(0) === 0) {
	                            return 0;
	                          }
	                          var h = a.abs().divmod(b.abs());
	                          var iv = h.div;
	                          var x = bn2num(iv);
	                          var ir = h.mod;
	                          var sgn = a.negative !== b.negative ? -1 : 1;
	                          if (ir.cmpn(0) === 0) {
	                            return sgn * x;
	                          }
	                          if (x) {
	                            var s = ctz(x) + 4;
	                            var y = bn2num(ir.ushln(s).divRound(b));
	                            return sgn * (x + y * Math.pow(2, -s));
	                          } else {
	                            var ybits = b.bitLength() - ir.bitLength() + 53;
	                            var y = bn2num(ir.ushln(ybits).divRound(b));
	                            if (ybits < 1023) {
	                              return sgn * y * Math.pow(2, -ybits);
	                            }
	                            y *= Math.pow(2, -1023);
	                            return sgn * y * Math.pow(2, 1023 - ybits);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    5070: (
	                      /***/
	                      function(module3) {
	                        function ge(a, y, c, l, h) {
	                          var i = h + 1;
	                          while (l <= h) {
	                            var m = l + h >>> 1, x = a[m];
	                            var p = c !== undefined ? c(x, y) : x - y;
	                            if (p >= 0) {
	                              i = m;
	                              h = m - 1;
	                            } else {
	                              l = m + 1;
	                            }
	                          }
	                          return i;
	                        }
	                        function gt(a, y, c, l, h) {
	                          var i = h + 1;
	                          while (l <= h) {
	                            var m = l + h >>> 1, x = a[m];
	                            var p = c !== undefined ? c(x, y) : x - y;
	                            if (p > 0) {
	                              i = m;
	                              h = m - 1;
	                            } else {
	                              l = m + 1;
	                            }
	                          }
	                          return i;
	                        }
	                        function lt(a, y, c, l, h) {
	                          var i = l - 1;
	                          while (l <= h) {
	                            var m = l + h >>> 1, x = a[m];
	                            var p = c !== undefined ? c(x, y) : x - y;
	                            if (p < 0) {
	                              i = m;
	                              l = m + 1;
	                            } else {
	                              h = m - 1;
	                            }
	                          }
	                          return i;
	                        }
	                        function le(a, y, c, l, h) {
	                          var i = l - 1;
	                          while (l <= h) {
	                            var m = l + h >>> 1, x = a[m];
	                            var p = c !== undefined ? c(x, y) : x - y;
	                            if (p <= 0) {
	                              i = m;
	                              l = m + 1;
	                            } else {
	                              h = m - 1;
	                            }
	                          }
	                          return i;
	                        }
	                        function eq(a, y, c, l, h) {
	                          while (l <= h) {
	                            var m = l + h >>> 1, x = a[m];
	                            var p = c !== undefined ? c(x, y) : x - y;
	                            if (p === 0) {
	                              return m;
	                            }
	                            if (p <= 0) {
	                              l = m + 1;
	                            } else {
	                              h = m - 1;
	                            }
	                          }
	                          return -1;
	                        }
	                        function norm(a, y, c, l, h, f) {
	                          if (typeof c === "function") {
	                            return f(a, y, c, l === undefined ? 0 : l | 0, h === undefined ? a.length - 1 : h | 0);
	                          }
	                          return f(a, y, undefined, c === undefined ? 0 : c | 0, l === undefined ? a.length - 1 : l | 0);
	                        }
	                        module3.exports = { ge: function(a, y, c, l, h) {
	                          return norm(a, y, c, l, h, ge);
	                        }, gt: function(a, y, c, l, h) {
	                          return norm(a, y, c, l, h, gt);
	                        }, lt: function(a, y, c, l, h) {
	                          return norm(a, y, c, l, h, lt);
	                        }, le: function(a, y, c, l, h) {
	                          return norm(a, y, c, l, h, le);
	                        }, eq: function(a, y, c, l, h) {
	                          return norm(a, y, c, l, h, eq);
	                        } };
	                      }
	                    ),
	                    /***/
	                    2288: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        "use restrict";
	                        var INT_BITS = 32;
	                        exports2.INT_BITS = INT_BITS;
	                        exports2.INT_MAX = 2147483647;
	                        exports2.INT_MIN = -1 << INT_BITS - 1;
	                        exports2.sign = function(v) {
	                          return (v > 0) - (v < 0);
	                        };
	                        exports2.abs = function(v) {
	                          var mask = v >> INT_BITS - 1;
	                          return (v ^ mask) - mask;
	                        };
	                        exports2.min = function(x, y) {
	                          return y ^ (x ^ y) & -(x < y);
	                        };
	                        exports2.max = function(x, y) {
	                          return x ^ (x ^ y) & -(x < y);
	                        };
	                        exports2.isPow2 = function(v) {
	                          return !(v & v - 1) && !!v;
	                        };
	                        exports2.log2 = function(v) {
	                          var r, shift;
	                          r = (v > 65535) << 4;
	                          v >>>= r;
	                          shift = (v > 255) << 3;
	                          v >>>= shift;
	                          r |= shift;
	                          shift = (v > 15) << 2;
	                          v >>>= shift;
	                          r |= shift;
	                          shift = (v > 3) << 1;
	                          v >>>= shift;
	                          r |= shift;
	                          return r | v >> 1;
	                        };
	                        exports2.log10 = function(v) {
	                          return v >= 1e9 ? 9 : v >= 1e8 ? 8 : v >= 1e7 ? 7 : v >= 1e6 ? 6 : v >= 1e5 ? 5 : v >= 1e4 ? 4 : v >= 1e3 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
	                        };
	                        exports2.popCount = function(v) {
	                          v = v - (v >>> 1 & 1431655765);
	                          v = (v & 858993459) + (v >>> 2 & 858993459);
	                          return (v + (v >>> 4) & 252645135) * 16843009 >>> 24;
	                        };
	                        function countTrailingZeros(v) {
	                          var c = 32;
	                          v &= -v;
	                          if (v) c--;
	                          if (v & 65535) c -= 16;
	                          if (v & 16711935) c -= 8;
	                          if (v & 252645135) c -= 4;
	                          if (v & 858993459) c -= 2;
	                          if (v & 1431655765) c -= 1;
	                          return c;
	                        }
	                        exports2.countTrailingZeros = countTrailingZeros;
	                        exports2.nextPow2 = function(v) {
	                          v += v === 0;
	                          --v;
	                          v |= v >>> 1;
	                          v |= v >>> 2;
	                          v |= v >>> 4;
	                          v |= v >>> 8;
	                          v |= v >>> 16;
	                          return v + 1;
	                        };
	                        exports2.prevPow2 = function(v) {
	                          v |= v >>> 1;
	                          v |= v >>> 2;
	                          v |= v >>> 4;
	                          v |= v >>> 8;
	                          v |= v >>> 16;
	                          return v - (v >>> 1);
	                        };
	                        exports2.parity = function(v) {
	                          v ^= v >>> 16;
	                          v ^= v >>> 8;
	                          v ^= v >>> 4;
	                          v &= 15;
	                          return 27030 >>> v & 1;
	                        };
	                        var REVERSE_TABLE = new Array(256);
	                        (function(tab) {
	                          for (var i = 0; i < 256; ++i) {
	                            var v = i, r = i, s = 7;
	                            for (v >>>= 1; v; v >>>= 1) {
	                              r <<= 1;
	                              r |= v & 1;
	                              --s;
	                            }
	                            tab[i] = r << s & 255;
	                          }
	                        })(REVERSE_TABLE);
	                        exports2.reverse = function(v) {
	                          return REVERSE_TABLE[v & 255] << 24 | REVERSE_TABLE[v >>> 8 & 255] << 16 | REVERSE_TABLE[v >>> 16 & 255] << 8 | REVERSE_TABLE[v >>> 24 & 255];
	                        };
	                        exports2.interleave2 = function(x, y) {
	                          x &= 65535;
	                          x = (x | x << 8) & 16711935;
	                          x = (x | x << 4) & 252645135;
	                          x = (x | x << 2) & 858993459;
	                          x = (x | x << 1) & 1431655765;
	                          y &= 65535;
	                          y = (y | y << 8) & 16711935;
	                          y = (y | y << 4) & 252645135;
	                          y = (y | y << 2) & 858993459;
	                          y = (y | y << 1) & 1431655765;
	                          return x | y << 1;
	                        };
	                        exports2.deinterleave2 = function(v, n) {
	                          v = v >>> n & 1431655765;
	                          v = (v | v >>> 1) & 858993459;
	                          v = (v | v >>> 2) & 252645135;
	                          v = (v | v >>> 4) & 16711935;
	                          v = (v | v >>> 16) & 65535;
	                          return v << 16 >> 16;
	                        };
	                        exports2.interleave3 = function(x, y, z) {
	                          x &= 1023;
	                          x = (x | x << 16) & 4278190335;
	                          x = (x | x << 8) & 251719695;
	                          x = (x | x << 4) & 3272356035;
	                          x = (x | x << 2) & 1227133513;
	                          y &= 1023;
	                          y = (y | y << 16) & 4278190335;
	                          y = (y | y << 8) & 251719695;
	                          y = (y | y << 4) & 3272356035;
	                          y = (y | y << 2) & 1227133513;
	                          x |= y << 1;
	                          z &= 1023;
	                          z = (z | z << 16) & 4278190335;
	                          z = (z | z << 8) & 251719695;
	                          z = (z | z << 4) & 3272356035;
	                          z = (z | z << 2) & 1227133513;
	                          return x | z << 2;
	                        };
	                        exports2.deinterleave3 = function(v, n) {
	                          v = v >>> n & 1227133513;
	                          v = (v | v >>> 2) & 3272356035;
	                          v = (v | v >>> 4) & 251719695;
	                          v = (v | v >>> 8) & 4278190335;
	                          v = (v | v >>> 16) & 1023;
	                          return v << 22 >> 22;
	                        };
	                        exports2.nextCombination = function(v) {
	                          var t = v | v - 1;
	                          return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
	                        };
	                      }
	                    ),
	                    /***/
	                    1928: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_75889__) {
	                        module3 = __nested_webpack_require_75889__.nmd(module3);
	                        (function(module4, exports2) {
	                          function assert(val, msg) {
	                            if (!val) throw new Error(msg || "Assertion failed");
	                          }
	                          function inherits(ctor, superCtor) {
	                            ctor.super_ = superCtor;
	                            var TempCtor = function() {
	                            };
	                            TempCtor.prototype = superCtor.prototype;
	                            ctor.prototype = new TempCtor();
	                            ctor.prototype.constructor = ctor;
	                          }
	                          function BN(number2, base, endian) {
	                            if (BN.isBN(number2)) {
	                              return number2;
	                            }
	                            this.negative = 0;
	                            this.words = null;
	                            this.length = 0;
	                            this.red = null;
	                            if (number2 !== null) {
	                              if (base === "le" || base === "be") {
	                                endian = base;
	                                base = 10;
	                              }
	                              this._init(number2 || 0, base || 10, endian || "be");
	                            }
	                          }
	                          if (typeof module4 === "object") {
	                            module4.exports = BN;
	                          } else {
	                            exports2.BN = BN;
	                          }
	                          BN.BN = BN;
	                          BN.wordSize = 26;
	                          var Buffer2;
	                          try {
	                            if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") {
	                              Buffer2 = window.Buffer;
	                            } else {
	                              Buffer2 = __nested_webpack_require_75889__(6601).Buffer;
	                            }
	                          } catch (e) {
	                          }
	                          BN.isBN = function isBN(num) {
	                            if (num instanceof BN) {
	                              return true;
	                            }
	                            return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
	                          };
	                          BN.max = function max(left, right) {
	                            if (left.cmp(right) > 0) return left;
	                            return right;
	                          };
	                          BN.min = function min(left, right) {
	                            if (left.cmp(right) < 0) return left;
	                            return right;
	                          };
	                          BN.prototype._init = function init(number2, base, endian) {
	                            if (typeof number2 === "number") {
	                              return this._initNumber(number2, base, endian);
	                            }
	                            if (typeof number2 === "object") {
	                              return this._initArray(number2, base, endian);
	                            }
	                            if (base === "hex") {
	                              base = 16;
	                            }
	                            assert(base === (base | 0) && base >= 2 && base <= 36);
	                            number2 = number2.toString().replace(/\s+/g, "");
	                            var start = 0;
	                            if (number2[0] === "-") {
	                              start++;
	                              this.negative = 1;
	                            }
	                            if (start < number2.length) {
	                              if (base === 16) {
	                                this._parseHex(number2, start, endian);
	                              } else {
	                                this._parseBase(number2, base, start);
	                                if (endian === "le") {
	                                  this._initArray(this.toArray(), base, endian);
	                                }
	                              }
	                            }
	                          };
	                          BN.prototype._initNumber = function _initNumber(number2, base, endian) {
	                            if (number2 < 0) {
	                              this.negative = 1;
	                              number2 = -number2;
	                            }
	                            if (number2 < 67108864) {
	                              this.words = [number2 & 67108863];
	                              this.length = 1;
	                            } else if (number2 < 4503599627370496) {
	                              this.words = [number2 & 67108863, number2 / 67108864 & 67108863];
	                              this.length = 2;
	                            } else {
	                              assert(number2 < 9007199254740992);
	                              this.words = [number2 & 67108863, number2 / 67108864 & 67108863, 1];
	                              this.length = 3;
	                            }
	                            if (endian !== "le") return;
	                            this._initArray(this.toArray(), base, endian);
	                          };
	                          BN.prototype._initArray = function _initArray(number2, base, endian) {
	                            assert(typeof number2.length === "number");
	                            if (number2.length <= 0) {
	                              this.words = [0];
	                              this.length = 1;
	                              return this;
	                            }
	                            this.length = Math.ceil(number2.length / 3);
	                            this.words = new Array(this.length);
	                            for (var i = 0; i < this.length; i++) {
	                              this.words[i] = 0;
	                            }
	                            var j, w;
	                            var off = 0;
	                            if (endian === "be") {
	                              for (i = number2.length - 1, j = 0; i >= 0; i -= 3) {
	                                w = number2[i] | number2[i - 1] << 8 | number2[i - 2] << 16;
	                                this.words[j] |= w << off & 67108863;
	                                this.words[j + 1] = w >>> 26 - off & 67108863;
	                                off += 24;
	                                if (off >= 26) {
	                                  off -= 26;
	                                  j++;
	                                }
	                              }
	                            } else if (endian === "le") {
	                              for (i = 0, j = 0; i < number2.length; i += 3) {
	                                w = number2[i] | number2[i + 1] << 8 | number2[i + 2] << 16;
	                                this.words[j] |= w << off & 67108863;
	                                this.words[j + 1] = w >>> 26 - off & 67108863;
	                                off += 24;
	                                if (off >= 26) {
	                                  off -= 26;
	                                  j++;
	                                }
	                              }
	                            }
	                            return this.strip();
	                          };
	                          function parseHex4Bits(string, index) {
	                            var c = string.charCodeAt(index);
	                            if (c >= 65 && c <= 70) {
	                              return c - 55;
	                            } else if (c >= 97 && c <= 102) {
	                              return c - 87;
	                            } else {
	                              return c - 48 & 15;
	                            }
	                          }
	                          function parseHexByte(string, lowerBound, index) {
	                            var r = parseHex4Bits(string, index);
	                            if (index - 1 >= lowerBound) {
	                              r |= parseHex4Bits(string, index - 1) << 4;
	                            }
	                            return r;
	                          }
	                          BN.prototype._parseHex = function _parseHex(number2, start, endian) {
	                            this.length = Math.ceil((number2.length - start) / 6);
	                            this.words = new Array(this.length);
	                            for (var i = 0; i < this.length; i++) {
	                              this.words[i] = 0;
	                            }
	                            var off = 0;
	                            var j = 0;
	                            var w;
	                            if (endian === "be") {
	                              for (i = number2.length - 1; i >= start; i -= 2) {
	                                w = parseHexByte(number2, start, i) << off;
	                                this.words[j] |= w & 67108863;
	                                if (off >= 18) {
	                                  off -= 18;
	                                  j += 1;
	                                  this.words[j] |= w >>> 26;
	                                } else {
	                                  off += 8;
	                                }
	                              }
	                            } else {
	                              var parseLength = number2.length - start;
	                              for (i = parseLength % 2 === 0 ? start + 1 : start; i < number2.length; i += 2) {
	                                w = parseHexByte(number2, start, i) << off;
	                                this.words[j] |= w & 67108863;
	                                if (off >= 18) {
	                                  off -= 18;
	                                  j += 1;
	                                  this.words[j] |= w >>> 26;
	                                } else {
	                                  off += 8;
	                                }
	                              }
	                            }
	                            this.strip();
	                          };
	                          function parseBase(str, start, end, mul) {
	                            var r = 0;
	                            var len = Math.min(str.length, end);
	                            for (var i = start; i < len; i++) {
	                              var c = str.charCodeAt(i) - 48;
	                              r *= mul;
	                              if (c >= 49) {
	                                r += c - 49 + 10;
	                              } else if (c >= 17) {
	                                r += c - 17 + 10;
	                              } else {
	                                r += c;
	                              }
	                            }
	                            return r;
	                          }
	                          BN.prototype._parseBase = function _parseBase(number2, base, start) {
	                            this.words = [0];
	                            this.length = 1;
	                            for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base) {
	                              limbLen++;
	                            }
	                            limbLen--;
	                            limbPow = limbPow / base | 0;
	                            var total = number2.length - start;
	                            var mod = total % limbLen;
	                            var end = Math.min(total, total - mod) + start;
	                            var word = 0;
	                            for (var i = start; i < end; i += limbLen) {
	                              word = parseBase(number2, i, i + limbLen, base);
	                              this.imuln(limbPow);
	                              if (this.words[0] + word < 67108864) {
	                                this.words[0] += word;
	                              } else {
	                                this._iaddn(word);
	                              }
	                            }
	                            if (mod !== 0) {
	                              var pow = 1;
	                              word = parseBase(number2, i, number2.length, base);
	                              for (i = 0; i < mod; i++) {
	                                pow *= base;
	                              }
	                              this.imuln(pow);
	                              if (this.words[0] + word < 67108864) {
	                                this.words[0] += word;
	                              } else {
	                                this._iaddn(word);
	                              }
	                            }
	                            this.strip();
	                          };
	                          BN.prototype.copy = function copy(dest) {
	                            dest.words = new Array(this.length);
	                            for (var i = 0; i < this.length; i++) {
	                              dest.words[i] = this.words[i];
	                            }
	                            dest.length = this.length;
	                            dest.negative = this.negative;
	                            dest.red = this.red;
	                          };
	                          BN.prototype.clone = function clone() {
	                            var r = new BN(null);
	                            this.copy(r);
	                            return r;
	                          };
	                          BN.prototype._expand = function _expand(size) {
	                            while (this.length < size) {
	                              this.words[this.length++] = 0;
	                            }
	                            return this;
	                          };
	                          BN.prototype.strip = function strip() {
	                            while (this.length > 1 && this.words[this.length - 1] === 0) {
	                              this.length--;
	                            }
	                            return this._normSign();
	                          };
	                          BN.prototype._normSign = function _normSign() {
	                            if (this.length === 1 && this.words[0] === 0) {
	                              this.negative = 0;
	                            }
	                            return this;
	                          };
	                          BN.prototype.inspect = function inspect() {
	                            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
	                          };
	                          var zeros = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"];
	                          var groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
	                          var groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
	                          BN.prototype.toString = function toString(base, padding) {
	                            base = base || 10;
	                            padding = padding | 0 || 1;
	                            var out;
	                            if (base === 16 || base === "hex") {
	                              out = "";
	                              var off = 0;
	                              var carry = 0;
	                              for (var i = 0; i < this.length; i++) {
	                                var w = this.words[i];
	                                var word = ((w << off | carry) & 16777215).toString(16);
	                                carry = w >>> 24 - off & 16777215;
	                                if (carry !== 0 || i !== this.length - 1) {
	                                  out = zeros[6 - word.length] + word + out;
	                                } else {
	                                  out = word + out;
	                                }
	                                off += 2;
	                                if (off >= 26) {
	                                  off -= 26;
	                                  i--;
	                                }
	                              }
	                              if (carry !== 0) {
	                                out = carry.toString(16) + out;
	                              }
	                              while (out.length % padding !== 0) {
	                                out = "0" + out;
	                              }
	                              if (this.negative !== 0) {
	                                out = "-" + out;
	                              }
	                              return out;
	                            }
	                            if (base === (base | 0) && base >= 2 && base <= 36) {
	                              var groupSize = groupSizes[base];
	                              var groupBase = groupBases[base];
	                              out = "";
	                              var c = this.clone();
	                              c.negative = 0;
	                              while (!c.isZero()) {
	                                var r = c.modn(groupBase).toString(base);
	                                c = c.idivn(groupBase);
	                                if (!c.isZero()) {
	                                  out = zeros[groupSize - r.length] + r + out;
	                                } else {
	                                  out = r + out;
	                                }
	                              }
	                              if (this.isZero()) {
	                                out = "0" + out;
	                              }
	                              while (out.length % padding !== 0) {
	                                out = "0" + out;
	                              }
	                              if (this.negative !== 0) {
	                                out = "-" + out;
	                              }
	                              return out;
	                            }
	                            assert(false, "Base should be between 2 and 36");
	                          };
	                          BN.prototype.toNumber = function toNumber() {
	                            var ret = this.words[0];
	                            if (this.length === 2) {
	                              ret += this.words[1] * 67108864;
	                            } else if (this.length === 3 && this.words[2] === 1) {
	                              ret += 4503599627370496 + this.words[1] * 67108864;
	                            } else if (this.length > 2) {
	                              assert(false, "Number can only safely store up to 53 bits");
	                            }
	                            return this.negative !== 0 ? -ret : ret;
	                          };
	                          BN.prototype.toJSON = function toJSON() {
	                            return this.toString(16);
	                          };
	                          BN.prototype.toBuffer = function toBuffer(endian, length) {
	                            assert(typeof Buffer2 !== "undefined");
	                            return this.toArrayLike(Buffer2, endian, length);
	                          };
	                          BN.prototype.toArray = function toArray(endian, length) {
	                            return this.toArrayLike(Array, endian, length);
	                          };
	                          BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
	                            var byteLength = this.byteLength();
	                            var reqLength = length || Math.max(1, byteLength);
	                            assert(byteLength <= reqLength, "byte array longer than desired length");
	                            assert(reqLength > 0, "Requested array length <= 0");
	                            this.strip();
	                            var littleEndian = endian === "le";
	                            var res = new ArrayType(reqLength);
	                            var b, i;
	                            var q = this.clone();
	                            if (!littleEndian) {
	                              for (i = 0; i < reqLength - byteLength; i++) {
	                                res[i] = 0;
	                              }
	                              for (i = 0; !q.isZero(); i++) {
	                                b = q.andln(255);
	                                q.iushrn(8);
	                                res[reqLength - i - 1] = b;
	                              }
	                            } else {
	                              for (i = 0; !q.isZero(); i++) {
	                                b = q.andln(255);
	                                q.iushrn(8);
	                                res[i] = b;
	                              }
	                              for (; i < reqLength; i++) {
	                                res[i] = 0;
	                              }
	                            }
	                            return res;
	                          };
	                          if (Math.clz32) {
	                            BN.prototype._countBits = function _countBits(w) {
	                              return 32 - Math.clz32(w);
	                            };
	                          } else {
	                            BN.prototype._countBits = function _countBits(w) {
	                              var t = w;
	                              var r = 0;
	                              if (t >= 4096) {
	                                r += 13;
	                                t >>>= 13;
	                              }
	                              if (t >= 64) {
	                                r += 7;
	                                t >>>= 7;
	                              }
	                              if (t >= 8) {
	                                r += 4;
	                                t >>>= 4;
	                              }
	                              if (t >= 2) {
	                                r += 2;
	                                t >>>= 2;
	                              }
	                              return r + t;
	                            };
	                          }
	                          BN.prototype._zeroBits = function _zeroBits(w) {
	                            if (w === 0) return 26;
	                            var t = w;
	                            var r = 0;
	                            if ((t & 8191) === 0) {
	                              r += 13;
	                              t >>>= 13;
	                            }
	                            if ((t & 127) === 0) {
	                              r += 7;
	                              t >>>= 7;
	                            }
	                            if ((t & 15) === 0) {
	                              r += 4;
	                              t >>>= 4;
	                            }
	                            if ((t & 3) === 0) {
	                              r += 2;
	                              t >>>= 2;
	                            }
	                            if ((t & 1) === 0) {
	                              r++;
	                            }
	                            return r;
	                          };
	                          BN.prototype.bitLength = function bitLength() {
	                            var w = this.words[this.length - 1];
	                            var hi = this._countBits(w);
	                            return (this.length - 1) * 26 + hi;
	                          };
	                          function toBitArray(num) {
	                            var w = new Array(num.bitLength());
	                            for (var bit = 0; bit < w.length; bit++) {
	                              var off = bit / 26 | 0;
	                              var wbit = bit % 26;
	                              w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
	                            }
	                            return w;
	                          }
	                          BN.prototype.zeroBits = function zeroBits() {
	                            if (this.isZero()) return 0;
	                            var r = 0;
	                            for (var i = 0; i < this.length; i++) {
	                              var b = this._zeroBits(this.words[i]);
	                              r += b;
	                              if (b !== 26) break;
	                            }
	                            return r;
	                          };
	                          BN.prototype.byteLength = function byteLength() {
	                            return Math.ceil(this.bitLength() / 8);
	                          };
	                          BN.prototype.toTwos = function toTwos(width) {
	                            if (this.negative !== 0) {
	                              return this.abs().inotn(width).iaddn(1);
	                            }
	                            return this.clone();
	                          };
	                          BN.prototype.fromTwos = function fromTwos(width) {
	                            if (this.testn(width - 1)) {
	                              return this.notn(width).iaddn(1).ineg();
	                            }
	                            return this.clone();
	                          };
	                          BN.prototype.isNeg = function isNeg() {
	                            return this.negative !== 0;
	                          };
	                          BN.prototype.neg = function neg() {
	                            return this.clone().ineg();
	                          };
	                          BN.prototype.ineg = function ineg() {
	                            if (!this.isZero()) {
	                              this.negative ^= 1;
	                            }
	                            return this;
	                          };
	                          BN.prototype.iuor = function iuor(num) {
	                            while (this.length < num.length) {
	                              this.words[this.length++] = 0;
	                            }
	                            for (var i = 0; i < num.length; i++) {
	                              this.words[i] = this.words[i] | num.words[i];
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.ior = function ior(num) {
	                            assert((this.negative | num.negative) === 0);
	                            return this.iuor(num);
	                          };
	                          BN.prototype.or = function or(num) {
	                            if (this.length > num.length) return this.clone().ior(num);
	                            return num.clone().ior(this);
	                          };
	                          BN.prototype.uor = function uor(num) {
	                            if (this.length > num.length) return this.clone().iuor(num);
	                            return num.clone().iuor(this);
	                          };
	                          BN.prototype.iuand = function iuand(num) {
	                            var b;
	                            if (this.length > num.length) {
	                              b = num;
	                            } else {
	                              b = this;
	                            }
	                            for (var i = 0; i < b.length; i++) {
	                              this.words[i] = this.words[i] & num.words[i];
	                            }
	                            this.length = b.length;
	                            return this.strip();
	                          };
	                          BN.prototype.iand = function iand(num) {
	                            assert((this.negative | num.negative) === 0);
	                            return this.iuand(num);
	                          };
	                          BN.prototype.and = function and(num) {
	                            if (this.length > num.length) return this.clone().iand(num);
	                            return num.clone().iand(this);
	                          };
	                          BN.prototype.uand = function uand(num) {
	                            if (this.length > num.length) return this.clone().iuand(num);
	                            return num.clone().iuand(this);
	                          };
	                          BN.prototype.iuxor = function iuxor(num) {
	                            var a;
	                            var b;
	                            if (this.length > num.length) {
	                              a = this;
	                              b = num;
	                            } else {
	                              a = num;
	                              b = this;
	                            }
	                            for (var i = 0; i < b.length; i++) {
	                              this.words[i] = a.words[i] ^ b.words[i];
	                            }
	                            if (this !== a) {
	                              for (; i < a.length; i++) {
	                                this.words[i] = a.words[i];
	                              }
	                            }
	                            this.length = a.length;
	                            return this.strip();
	                          };
	                          BN.prototype.ixor = function ixor(num) {
	                            assert((this.negative | num.negative) === 0);
	                            return this.iuxor(num);
	                          };
	                          BN.prototype.xor = function xor(num) {
	                            if (this.length > num.length) return this.clone().ixor(num);
	                            return num.clone().ixor(this);
	                          };
	                          BN.prototype.uxor = function uxor(num) {
	                            if (this.length > num.length) return this.clone().iuxor(num);
	                            return num.clone().iuxor(this);
	                          };
	                          BN.prototype.inotn = function inotn(width) {
	                            assert(typeof width === "number" && width >= 0);
	                            var bytesNeeded = Math.ceil(width / 26) | 0;
	                            var bitsLeft = width % 26;
	                            this._expand(bytesNeeded);
	                            if (bitsLeft > 0) {
	                              bytesNeeded--;
	                            }
	                            for (var i = 0; i < bytesNeeded; i++) {
	                              this.words[i] = ~this.words[i] & 67108863;
	                            }
	                            if (bitsLeft > 0) {
	                              this.words[i] = ~this.words[i] & 67108863 >> 26 - bitsLeft;
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.notn = function notn(width) {
	                            return this.clone().inotn(width);
	                          };
	                          BN.prototype.setn = function setn(bit, val) {
	                            assert(typeof bit === "number" && bit >= 0);
	                            var off = bit / 26 | 0;
	                            var wbit = bit % 26;
	                            this._expand(off + 1);
	                            if (val) {
	                              this.words[off] = this.words[off] | 1 << wbit;
	                            } else {
	                              this.words[off] = this.words[off] & ~(1 << wbit);
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.iadd = function iadd(num) {
	                            var r;
	                            if (this.negative !== 0 && num.negative === 0) {
	                              this.negative = 0;
	                              r = this.isub(num);
	                              this.negative ^= 1;
	                              return this._normSign();
	                            } else if (this.negative === 0 && num.negative !== 0) {
	                              num.negative = 0;
	                              r = this.isub(num);
	                              num.negative = 1;
	                              return r._normSign();
	                            }
	                            var a, b;
	                            if (this.length > num.length) {
	                              a = this;
	                              b = num;
	                            } else {
	                              a = num;
	                              b = this;
	                            }
	                            var carry = 0;
	                            for (var i = 0; i < b.length; i++) {
	                              r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
	                              this.words[i] = r & 67108863;
	                              carry = r >>> 26;
	                            }
	                            for (; carry !== 0 && i < a.length; i++) {
	                              r = (a.words[i] | 0) + carry;
	                              this.words[i] = r & 67108863;
	                              carry = r >>> 26;
	                            }
	                            this.length = a.length;
	                            if (carry !== 0) {
	                              this.words[this.length] = carry;
	                              this.length++;
	                            } else if (a !== this) {
	                              for (; i < a.length; i++) {
	                                this.words[i] = a.words[i];
	                              }
	                            }
	                            return this;
	                          };
	                          BN.prototype.add = function add(num) {
	                            var res;
	                            if (num.negative !== 0 && this.negative === 0) {
	                              num.negative = 0;
	                              res = this.sub(num);
	                              num.negative ^= 1;
	                              return res;
	                            } else if (num.negative === 0 && this.negative !== 0) {
	                              this.negative = 0;
	                              res = num.sub(this);
	                              this.negative = 1;
	                              return res;
	                            }
	                            if (this.length > num.length) return this.clone().iadd(num);
	                            return num.clone().iadd(this);
	                          };
	                          BN.prototype.isub = function isub(num) {
	                            if (num.negative !== 0) {
	                              num.negative = 0;
	                              var r = this.iadd(num);
	                              num.negative = 1;
	                              return r._normSign();
	                            } else if (this.negative !== 0) {
	                              this.negative = 0;
	                              this.iadd(num);
	                              this.negative = 1;
	                              return this._normSign();
	                            }
	                            var cmp = this.cmp(num);
	                            if (cmp === 0) {
	                              this.negative = 0;
	                              this.length = 1;
	                              this.words[0] = 0;
	                              return this;
	                            }
	                            var a, b;
	                            if (cmp > 0) {
	                              a = this;
	                              b = num;
	                            } else {
	                              a = num;
	                              b = this;
	                            }
	                            var carry = 0;
	                            for (var i = 0; i < b.length; i++) {
	                              r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
	                              carry = r >> 26;
	                              this.words[i] = r & 67108863;
	                            }
	                            for (; carry !== 0 && i < a.length; i++) {
	                              r = (a.words[i] | 0) + carry;
	                              carry = r >> 26;
	                              this.words[i] = r & 67108863;
	                            }
	                            if (carry === 0 && i < a.length && a !== this) {
	                              for (; i < a.length; i++) {
	                                this.words[i] = a.words[i];
	                              }
	                            }
	                            this.length = Math.max(this.length, i);
	                            if (a !== this) {
	                              this.negative = 1;
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.sub = function sub(num) {
	                            return this.clone().isub(num);
	                          };
	                          function smallMulTo(self2, num, out) {
	                            out.negative = num.negative ^ self2.negative;
	                            var len = self2.length + num.length | 0;
	                            out.length = len;
	                            len = len - 1 | 0;
	                            var a = self2.words[0] | 0;
	                            var b = num.words[0] | 0;
	                            var r = a * b;
	                            var lo = r & 67108863;
	                            var carry = r / 67108864 | 0;
	                            out.words[0] = lo;
	                            for (var k = 1; k < len; k++) {
	                              var ncarry = carry >>> 26;
	                              var rword = carry & 67108863;
	                              var maxJ = Math.min(k, num.length - 1);
	                              for (var j = Math.max(0, k - self2.length + 1); j <= maxJ; j++) {
	                                var i = k - j | 0;
	                                a = self2.words[i] | 0;
	                                b = num.words[j] | 0;
	                                r = a * b + rword;
	                                ncarry += r / 67108864 | 0;
	                                rword = r & 67108863;
	                              }
	                              out.words[k] = rword | 0;
	                              carry = ncarry | 0;
	                            }
	                            if (carry !== 0) {
	                              out.words[k] = carry | 0;
	                            } else {
	                              out.length--;
	                            }
	                            return out.strip();
	                          }
	                          var comb10MulTo = function comb10MulTo2(self2, num, out) {
	                            var a = self2.words;
	                            var b = num.words;
	                            var o = out.words;
	                            var c = 0;
	                            var lo;
	                            var mid;
	                            var hi;
	                            var a0 = a[0] | 0;
	                            var al0 = a0 & 8191;
	                            var ah0 = a0 >>> 13;
	                            var a1 = a[1] | 0;
	                            var al1 = a1 & 8191;
	                            var ah1 = a1 >>> 13;
	                            var a2 = a[2] | 0;
	                            var al2 = a2 & 8191;
	                            var ah2 = a2 >>> 13;
	                            var a3 = a[3] | 0;
	                            var al3 = a3 & 8191;
	                            var ah3 = a3 >>> 13;
	                            var a4 = a[4] | 0;
	                            var al4 = a4 & 8191;
	                            var ah4 = a4 >>> 13;
	                            var a5 = a[5] | 0;
	                            var al5 = a5 & 8191;
	                            var ah5 = a5 >>> 13;
	                            var a6 = a[6] | 0;
	                            var al6 = a6 & 8191;
	                            var ah6 = a6 >>> 13;
	                            var a7 = a[7] | 0;
	                            var al7 = a7 & 8191;
	                            var ah7 = a7 >>> 13;
	                            var a8 = a[8] | 0;
	                            var al8 = a8 & 8191;
	                            var ah8 = a8 >>> 13;
	                            var a9 = a[9] | 0;
	                            var al9 = a9 & 8191;
	                            var ah9 = a9 >>> 13;
	                            var b0 = b[0] | 0;
	                            var bl0 = b0 & 8191;
	                            var bh0 = b0 >>> 13;
	                            var b1 = b[1] | 0;
	                            var bl1 = b1 & 8191;
	                            var bh1 = b1 >>> 13;
	                            var b2 = b[2] | 0;
	                            var bl2 = b2 & 8191;
	                            var bh2 = b2 >>> 13;
	                            var b3 = b[3] | 0;
	                            var bl3 = b3 & 8191;
	                            var bh3 = b3 >>> 13;
	                            var b4 = b[4] | 0;
	                            var bl4 = b4 & 8191;
	                            var bh4 = b4 >>> 13;
	                            var b5 = b[5] | 0;
	                            var bl5 = b5 & 8191;
	                            var bh5 = b5 >>> 13;
	                            var b6 = b[6] | 0;
	                            var bl6 = b6 & 8191;
	                            var bh6 = b6 >>> 13;
	                            var b7 = b[7] | 0;
	                            var bl7 = b7 & 8191;
	                            var bh7 = b7 >>> 13;
	                            var b8 = b[8] | 0;
	                            var bl8 = b8 & 8191;
	                            var bh8 = b8 >>> 13;
	                            var b9 = b[9] | 0;
	                            var bl9 = b9 & 8191;
	                            var bh9 = b9 >>> 13;
	                            out.negative = self2.negative ^ num.negative;
	                            out.length = 19;
	                            lo = Math.imul(al0, bl0);
	                            mid = Math.imul(al0, bh0);
	                            mid = mid + Math.imul(ah0, bl0) | 0;
	                            hi = Math.imul(ah0, bh0);
	                            var w0 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
	                            w0 &= 67108863;
	                            lo = Math.imul(al1, bl0);
	                            mid = Math.imul(al1, bh0);
	                            mid = mid + Math.imul(ah1, bl0) | 0;
	                            hi = Math.imul(ah1, bh0);
	                            lo = lo + Math.imul(al0, bl1) | 0;
	                            mid = mid + Math.imul(al0, bh1) | 0;
	                            mid = mid + Math.imul(ah0, bl1) | 0;
	                            hi = hi + Math.imul(ah0, bh1) | 0;
	                            var w1 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
	                            w1 &= 67108863;
	                            lo = Math.imul(al2, bl0);
	                            mid = Math.imul(al2, bh0);
	                            mid = mid + Math.imul(ah2, bl0) | 0;
	                            hi = Math.imul(ah2, bh0);
	                            lo = lo + Math.imul(al1, bl1) | 0;
	                            mid = mid + Math.imul(al1, bh1) | 0;
	                            mid = mid + Math.imul(ah1, bl1) | 0;
	                            hi = hi + Math.imul(ah1, bh1) | 0;
	                            lo = lo + Math.imul(al0, bl2) | 0;
	                            mid = mid + Math.imul(al0, bh2) | 0;
	                            mid = mid + Math.imul(ah0, bl2) | 0;
	                            hi = hi + Math.imul(ah0, bh2) | 0;
	                            var w2 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
	                            w2 &= 67108863;
	                            lo = Math.imul(al3, bl0);
	                            mid = Math.imul(al3, bh0);
	                            mid = mid + Math.imul(ah3, bl0) | 0;
	                            hi = Math.imul(ah3, bh0);
	                            lo = lo + Math.imul(al2, bl1) | 0;
	                            mid = mid + Math.imul(al2, bh1) | 0;
	                            mid = mid + Math.imul(ah2, bl1) | 0;
	                            hi = hi + Math.imul(ah2, bh1) | 0;
	                            lo = lo + Math.imul(al1, bl2) | 0;
	                            mid = mid + Math.imul(al1, bh2) | 0;
	                            mid = mid + Math.imul(ah1, bl2) | 0;
	                            hi = hi + Math.imul(ah1, bh2) | 0;
	                            lo = lo + Math.imul(al0, bl3) | 0;
	                            mid = mid + Math.imul(al0, bh3) | 0;
	                            mid = mid + Math.imul(ah0, bl3) | 0;
	                            hi = hi + Math.imul(ah0, bh3) | 0;
	                            var w3 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
	                            w3 &= 67108863;
	                            lo = Math.imul(al4, bl0);
	                            mid = Math.imul(al4, bh0);
	                            mid = mid + Math.imul(ah4, bl0) | 0;
	                            hi = Math.imul(ah4, bh0);
	                            lo = lo + Math.imul(al3, bl1) | 0;
	                            mid = mid + Math.imul(al3, bh1) | 0;
	                            mid = mid + Math.imul(ah3, bl1) | 0;
	                            hi = hi + Math.imul(ah3, bh1) | 0;
	                            lo = lo + Math.imul(al2, bl2) | 0;
	                            mid = mid + Math.imul(al2, bh2) | 0;
	                            mid = mid + Math.imul(ah2, bl2) | 0;
	                            hi = hi + Math.imul(ah2, bh2) | 0;
	                            lo = lo + Math.imul(al1, bl3) | 0;
	                            mid = mid + Math.imul(al1, bh3) | 0;
	                            mid = mid + Math.imul(ah1, bl3) | 0;
	                            hi = hi + Math.imul(ah1, bh3) | 0;
	                            lo = lo + Math.imul(al0, bl4) | 0;
	                            mid = mid + Math.imul(al0, bh4) | 0;
	                            mid = mid + Math.imul(ah0, bl4) | 0;
	                            hi = hi + Math.imul(ah0, bh4) | 0;
	                            var w4 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
	                            w4 &= 67108863;
	                            lo = Math.imul(al5, bl0);
	                            mid = Math.imul(al5, bh0);
	                            mid = mid + Math.imul(ah5, bl0) | 0;
	                            hi = Math.imul(ah5, bh0);
	                            lo = lo + Math.imul(al4, bl1) | 0;
	                            mid = mid + Math.imul(al4, bh1) | 0;
	                            mid = mid + Math.imul(ah4, bl1) | 0;
	                            hi = hi + Math.imul(ah4, bh1) | 0;
	                            lo = lo + Math.imul(al3, bl2) | 0;
	                            mid = mid + Math.imul(al3, bh2) | 0;
	                            mid = mid + Math.imul(ah3, bl2) | 0;
	                            hi = hi + Math.imul(ah3, bh2) | 0;
	                            lo = lo + Math.imul(al2, bl3) | 0;
	                            mid = mid + Math.imul(al2, bh3) | 0;
	                            mid = mid + Math.imul(ah2, bl3) | 0;
	                            hi = hi + Math.imul(ah2, bh3) | 0;
	                            lo = lo + Math.imul(al1, bl4) | 0;
	                            mid = mid + Math.imul(al1, bh4) | 0;
	                            mid = mid + Math.imul(ah1, bl4) | 0;
	                            hi = hi + Math.imul(ah1, bh4) | 0;
	                            lo = lo + Math.imul(al0, bl5) | 0;
	                            mid = mid + Math.imul(al0, bh5) | 0;
	                            mid = mid + Math.imul(ah0, bl5) | 0;
	                            hi = hi + Math.imul(ah0, bh5) | 0;
	                            var w5 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
	                            w5 &= 67108863;
	                            lo = Math.imul(al6, bl0);
	                            mid = Math.imul(al6, bh0);
	                            mid = mid + Math.imul(ah6, bl0) | 0;
	                            hi = Math.imul(ah6, bh0);
	                            lo = lo + Math.imul(al5, bl1) | 0;
	                            mid = mid + Math.imul(al5, bh1) | 0;
	                            mid = mid + Math.imul(ah5, bl1) | 0;
	                            hi = hi + Math.imul(ah5, bh1) | 0;
	                            lo = lo + Math.imul(al4, bl2) | 0;
	                            mid = mid + Math.imul(al4, bh2) | 0;
	                            mid = mid + Math.imul(ah4, bl2) | 0;
	                            hi = hi + Math.imul(ah4, bh2) | 0;
	                            lo = lo + Math.imul(al3, bl3) | 0;
	                            mid = mid + Math.imul(al3, bh3) | 0;
	                            mid = mid + Math.imul(ah3, bl3) | 0;
	                            hi = hi + Math.imul(ah3, bh3) | 0;
	                            lo = lo + Math.imul(al2, bl4) | 0;
	                            mid = mid + Math.imul(al2, bh4) | 0;
	                            mid = mid + Math.imul(ah2, bl4) | 0;
	                            hi = hi + Math.imul(ah2, bh4) | 0;
	                            lo = lo + Math.imul(al1, bl5) | 0;
	                            mid = mid + Math.imul(al1, bh5) | 0;
	                            mid = mid + Math.imul(ah1, bl5) | 0;
	                            hi = hi + Math.imul(ah1, bh5) | 0;
	                            lo = lo + Math.imul(al0, bl6) | 0;
	                            mid = mid + Math.imul(al0, bh6) | 0;
	                            mid = mid + Math.imul(ah0, bl6) | 0;
	                            hi = hi + Math.imul(ah0, bh6) | 0;
	                            var w6 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
	                            w6 &= 67108863;
	                            lo = Math.imul(al7, bl0);
	                            mid = Math.imul(al7, bh0);
	                            mid = mid + Math.imul(ah7, bl0) | 0;
	                            hi = Math.imul(ah7, bh0);
	                            lo = lo + Math.imul(al6, bl1) | 0;
	                            mid = mid + Math.imul(al6, bh1) | 0;
	                            mid = mid + Math.imul(ah6, bl1) | 0;
	                            hi = hi + Math.imul(ah6, bh1) | 0;
	                            lo = lo + Math.imul(al5, bl2) | 0;
	                            mid = mid + Math.imul(al5, bh2) | 0;
	                            mid = mid + Math.imul(ah5, bl2) | 0;
	                            hi = hi + Math.imul(ah5, bh2) | 0;
	                            lo = lo + Math.imul(al4, bl3) | 0;
	                            mid = mid + Math.imul(al4, bh3) | 0;
	                            mid = mid + Math.imul(ah4, bl3) | 0;
	                            hi = hi + Math.imul(ah4, bh3) | 0;
	                            lo = lo + Math.imul(al3, bl4) | 0;
	                            mid = mid + Math.imul(al3, bh4) | 0;
	                            mid = mid + Math.imul(ah3, bl4) | 0;
	                            hi = hi + Math.imul(ah3, bh4) | 0;
	                            lo = lo + Math.imul(al2, bl5) | 0;
	                            mid = mid + Math.imul(al2, bh5) | 0;
	                            mid = mid + Math.imul(ah2, bl5) | 0;
	                            hi = hi + Math.imul(ah2, bh5) | 0;
	                            lo = lo + Math.imul(al1, bl6) | 0;
	                            mid = mid + Math.imul(al1, bh6) | 0;
	                            mid = mid + Math.imul(ah1, bl6) | 0;
	                            hi = hi + Math.imul(ah1, bh6) | 0;
	                            lo = lo + Math.imul(al0, bl7) | 0;
	                            mid = mid + Math.imul(al0, bh7) | 0;
	                            mid = mid + Math.imul(ah0, bl7) | 0;
	                            hi = hi + Math.imul(ah0, bh7) | 0;
	                            var w7 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
	                            w7 &= 67108863;
	                            lo = Math.imul(al8, bl0);
	                            mid = Math.imul(al8, bh0);
	                            mid = mid + Math.imul(ah8, bl0) | 0;
	                            hi = Math.imul(ah8, bh0);
	                            lo = lo + Math.imul(al7, bl1) | 0;
	                            mid = mid + Math.imul(al7, bh1) | 0;
	                            mid = mid + Math.imul(ah7, bl1) | 0;
	                            hi = hi + Math.imul(ah7, bh1) | 0;
	                            lo = lo + Math.imul(al6, bl2) | 0;
	                            mid = mid + Math.imul(al6, bh2) | 0;
	                            mid = mid + Math.imul(ah6, bl2) | 0;
	                            hi = hi + Math.imul(ah6, bh2) | 0;
	                            lo = lo + Math.imul(al5, bl3) | 0;
	                            mid = mid + Math.imul(al5, bh3) | 0;
	                            mid = mid + Math.imul(ah5, bl3) | 0;
	                            hi = hi + Math.imul(ah5, bh3) | 0;
	                            lo = lo + Math.imul(al4, bl4) | 0;
	                            mid = mid + Math.imul(al4, bh4) | 0;
	                            mid = mid + Math.imul(ah4, bl4) | 0;
	                            hi = hi + Math.imul(ah4, bh4) | 0;
	                            lo = lo + Math.imul(al3, bl5) | 0;
	                            mid = mid + Math.imul(al3, bh5) | 0;
	                            mid = mid + Math.imul(ah3, bl5) | 0;
	                            hi = hi + Math.imul(ah3, bh5) | 0;
	                            lo = lo + Math.imul(al2, bl6) | 0;
	                            mid = mid + Math.imul(al2, bh6) | 0;
	                            mid = mid + Math.imul(ah2, bl6) | 0;
	                            hi = hi + Math.imul(ah2, bh6) | 0;
	                            lo = lo + Math.imul(al1, bl7) | 0;
	                            mid = mid + Math.imul(al1, bh7) | 0;
	                            mid = mid + Math.imul(ah1, bl7) | 0;
	                            hi = hi + Math.imul(ah1, bh7) | 0;
	                            lo = lo + Math.imul(al0, bl8) | 0;
	                            mid = mid + Math.imul(al0, bh8) | 0;
	                            mid = mid + Math.imul(ah0, bl8) | 0;
	                            hi = hi + Math.imul(ah0, bh8) | 0;
	                            var w8 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
	                            w8 &= 67108863;
	                            lo = Math.imul(al9, bl0);
	                            mid = Math.imul(al9, bh0);
	                            mid = mid + Math.imul(ah9, bl0) | 0;
	                            hi = Math.imul(ah9, bh0);
	                            lo = lo + Math.imul(al8, bl1) | 0;
	                            mid = mid + Math.imul(al8, bh1) | 0;
	                            mid = mid + Math.imul(ah8, bl1) | 0;
	                            hi = hi + Math.imul(ah8, bh1) | 0;
	                            lo = lo + Math.imul(al7, bl2) | 0;
	                            mid = mid + Math.imul(al7, bh2) | 0;
	                            mid = mid + Math.imul(ah7, bl2) | 0;
	                            hi = hi + Math.imul(ah7, bh2) | 0;
	                            lo = lo + Math.imul(al6, bl3) | 0;
	                            mid = mid + Math.imul(al6, bh3) | 0;
	                            mid = mid + Math.imul(ah6, bl3) | 0;
	                            hi = hi + Math.imul(ah6, bh3) | 0;
	                            lo = lo + Math.imul(al5, bl4) | 0;
	                            mid = mid + Math.imul(al5, bh4) | 0;
	                            mid = mid + Math.imul(ah5, bl4) | 0;
	                            hi = hi + Math.imul(ah5, bh4) | 0;
	                            lo = lo + Math.imul(al4, bl5) | 0;
	                            mid = mid + Math.imul(al4, bh5) | 0;
	                            mid = mid + Math.imul(ah4, bl5) | 0;
	                            hi = hi + Math.imul(ah4, bh5) | 0;
	                            lo = lo + Math.imul(al3, bl6) | 0;
	                            mid = mid + Math.imul(al3, bh6) | 0;
	                            mid = mid + Math.imul(ah3, bl6) | 0;
	                            hi = hi + Math.imul(ah3, bh6) | 0;
	                            lo = lo + Math.imul(al2, bl7) | 0;
	                            mid = mid + Math.imul(al2, bh7) | 0;
	                            mid = mid + Math.imul(ah2, bl7) | 0;
	                            hi = hi + Math.imul(ah2, bh7) | 0;
	                            lo = lo + Math.imul(al1, bl8) | 0;
	                            mid = mid + Math.imul(al1, bh8) | 0;
	                            mid = mid + Math.imul(ah1, bl8) | 0;
	                            hi = hi + Math.imul(ah1, bh8) | 0;
	                            lo = lo + Math.imul(al0, bl9) | 0;
	                            mid = mid + Math.imul(al0, bh9) | 0;
	                            mid = mid + Math.imul(ah0, bl9) | 0;
	                            hi = hi + Math.imul(ah0, bh9) | 0;
	                            var w9 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
	                            w9 &= 67108863;
	                            lo = Math.imul(al9, bl1);
	                            mid = Math.imul(al9, bh1);
	                            mid = mid + Math.imul(ah9, bl1) | 0;
	                            hi = Math.imul(ah9, bh1);
	                            lo = lo + Math.imul(al8, bl2) | 0;
	                            mid = mid + Math.imul(al8, bh2) | 0;
	                            mid = mid + Math.imul(ah8, bl2) | 0;
	                            hi = hi + Math.imul(ah8, bh2) | 0;
	                            lo = lo + Math.imul(al7, bl3) | 0;
	                            mid = mid + Math.imul(al7, bh3) | 0;
	                            mid = mid + Math.imul(ah7, bl3) | 0;
	                            hi = hi + Math.imul(ah7, bh3) | 0;
	                            lo = lo + Math.imul(al6, bl4) | 0;
	                            mid = mid + Math.imul(al6, bh4) | 0;
	                            mid = mid + Math.imul(ah6, bl4) | 0;
	                            hi = hi + Math.imul(ah6, bh4) | 0;
	                            lo = lo + Math.imul(al5, bl5) | 0;
	                            mid = mid + Math.imul(al5, bh5) | 0;
	                            mid = mid + Math.imul(ah5, bl5) | 0;
	                            hi = hi + Math.imul(ah5, bh5) | 0;
	                            lo = lo + Math.imul(al4, bl6) | 0;
	                            mid = mid + Math.imul(al4, bh6) | 0;
	                            mid = mid + Math.imul(ah4, bl6) | 0;
	                            hi = hi + Math.imul(ah4, bh6) | 0;
	                            lo = lo + Math.imul(al3, bl7) | 0;
	                            mid = mid + Math.imul(al3, bh7) | 0;
	                            mid = mid + Math.imul(ah3, bl7) | 0;
	                            hi = hi + Math.imul(ah3, bh7) | 0;
	                            lo = lo + Math.imul(al2, bl8) | 0;
	                            mid = mid + Math.imul(al2, bh8) | 0;
	                            mid = mid + Math.imul(ah2, bl8) | 0;
	                            hi = hi + Math.imul(ah2, bh8) | 0;
	                            lo = lo + Math.imul(al1, bl9) | 0;
	                            mid = mid + Math.imul(al1, bh9) | 0;
	                            mid = mid + Math.imul(ah1, bl9) | 0;
	                            hi = hi + Math.imul(ah1, bh9) | 0;
	                            var w10 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
	                            w10 &= 67108863;
	                            lo = Math.imul(al9, bl2);
	                            mid = Math.imul(al9, bh2);
	                            mid = mid + Math.imul(ah9, bl2) | 0;
	                            hi = Math.imul(ah9, bh2);
	                            lo = lo + Math.imul(al8, bl3) | 0;
	                            mid = mid + Math.imul(al8, bh3) | 0;
	                            mid = mid + Math.imul(ah8, bl3) | 0;
	                            hi = hi + Math.imul(ah8, bh3) | 0;
	                            lo = lo + Math.imul(al7, bl4) | 0;
	                            mid = mid + Math.imul(al7, bh4) | 0;
	                            mid = mid + Math.imul(ah7, bl4) | 0;
	                            hi = hi + Math.imul(ah7, bh4) | 0;
	                            lo = lo + Math.imul(al6, bl5) | 0;
	                            mid = mid + Math.imul(al6, bh5) | 0;
	                            mid = mid + Math.imul(ah6, bl5) | 0;
	                            hi = hi + Math.imul(ah6, bh5) | 0;
	                            lo = lo + Math.imul(al5, bl6) | 0;
	                            mid = mid + Math.imul(al5, bh6) | 0;
	                            mid = mid + Math.imul(ah5, bl6) | 0;
	                            hi = hi + Math.imul(ah5, bh6) | 0;
	                            lo = lo + Math.imul(al4, bl7) | 0;
	                            mid = mid + Math.imul(al4, bh7) | 0;
	                            mid = mid + Math.imul(ah4, bl7) | 0;
	                            hi = hi + Math.imul(ah4, bh7) | 0;
	                            lo = lo + Math.imul(al3, bl8) | 0;
	                            mid = mid + Math.imul(al3, bh8) | 0;
	                            mid = mid + Math.imul(ah3, bl8) | 0;
	                            hi = hi + Math.imul(ah3, bh8) | 0;
	                            lo = lo + Math.imul(al2, bl9) | 0;
	                            mid = mid + Math.imul(al2, bh9) | 0;
	                            mid = mid + Math.imul(ah2, bl9) | 0;
	                            hi = hi + Math.imul(ah2, bh9) | 0;
	                            var w11 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
	                            w11 &= 67108863;
	                            lo = Math.imul(al9, bl3);
	                            mid = Math.imul(al9, bh3);
	                            mid = mid + Math.imul(ah9, bl3) | 0;
	                            hi = Math.imul(ah9, bh3);
	                            lo = lo + Math.imul(al8, bl4) | 0;
	                            mid = mid + Math.imul(al8, bh4) | 0;
	                            mid = mid + Math.imul(ah8, bl4) | 0;
	                            hi = hi + Math.imul(ah8, bh4) | 0;
	                            lo = lo + Math.imul(al7, bl5) | 0;
	                            mid = mid + Math.imul(al7, bh5) | 0;
	                            mid = mid + Math.imul(ah7, bl5) | 0;
	                            hi = hi + Math.imul(ah7, bh5) | 0;
	                            lo = lo + Math.imul(al6, bl6) | 0;
	                            mid = mid + Math.imul(al6, bh6) | 0;
	                            mid = mid + Math.imul(ah6, bl6) | 0;
	                            hi = hi + Math.imul(ah6, bh6) | 0;
	                            lo = lo + Math.imul(al5, bl7) | 0;
	                            mid = mid + Math.imul(al5, bh7) | 0;
	                            mid = mid + Math.imul(ah5, bl7) | 0;
	                            hi = hi + Math.imul(ah5, bh7) | 0;
	                            lo = lo + Math.imul(al4, bl8) | 0;
	                            mid = mid + Math.imul(al4, bh8) | 0;
	                            mid = mid + Math.imul(ah4, bl8) | 0;
	                            hi = hi + Math.imul(ah4, bh8) | 0;
	                            lo = lo + Math.imul(al3, bl9) | 0;
	                            mid = mid + Math.imul(al3, bh9) | 0;
	                            mid = mid + Math.imul(ah3, bl9) | 0;
	                            hi = hi + Math.imul(ah3, bh9) | 0;
	                            var w12 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
	                            w12 &= 67108863;
	                            lo = Math.imul(al9, bl4);
	                            mid = Math.imul(al9, bh4);
	                            mid = mid + Math.imul(ah9, bl4) | 0;
	                            hi = Math.imul(ah9, bh4);
	                            lo = lo + Math.imul(al8, bl5) | 0;
	                            mid = mid + Math.imul(al8, bh5) | 0;
	                            mid = mid + Math.imul(ah8, bl5) | 0;
	                            hi = hi + Math.imul(ah8, bh5) | 0;
	                            lo = lo + Math.imul(al7, bl6) | 0;
	                            mid = mid + Math.imul(al7, bh6) | 0;
	                            mid = mid + Math.imul(ah7, bl6) | 0;
	                            hi = hi + Math.imul(ah7, bh6) | 0;
	                            lo = lo + Math.imul(al6, bl7) | 0;
	                            mid = mid + Math.imul(al6, bh7) | 0;
	                            mid = mid + Math.imul(ah6, bl7) | 0;
	                            hi = hi + Math.imul(ah6, bh7) | 0;
	                            lo = lo + Math.imul(al5, bl8) | 0;
	                            mid = mid + Math.imul(al5, bh8) | 0;
	                            mid = mid + Math.imul(ah5, bl8) | 0;
	                            hi = hi + Math.imul(ah5, bh8) | 0;
	                            lo = lo + Math.imul(al4, bl9) | 0;
	                            mid = mid + Math.imul(al4, bh9) | 0;
	                            mid = mid + Math.imul(ah4, bl9) | 0;
	                            hi = hi + Math.imul(ah4, bh9) | 0;
	                            var w13 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
	                            w13 &= 67108863;
	                            lo = Math.imul(al9, bl5);
	                            mid = Math.imul(al9, bh5);
	                            mid = mid + Math.imul(ah9, bl5) | 0;
	                            hi = Math.imul(ah9, bh5);
	                            lo = lo + Math.imul(al8, bl6) | 0;
	                            mid = mid + Math.imul(al8, bh6) | 0;
	                            mid = mid + Math.imul(ah8, bl6) | 0;
	                            hi = hi + Math.imul(ah8, bh6) | 0;
	                            lo = lo + Math.imul(al7, bl7) | 0;
	                            mid = mid + Math.imul(al7, bh7) | 0;
	                            mid = mid + Math.imul(ah7, bl7) | 0;
	                            hi = hi + Math.imul(ah7, bh7) | 0;
	                            lo = lo + Math.imul(al6, bl8) | 0;
	                            mid = mid + Math.imul(al6, bh8) | 0;
	                            mid = mid + Math.imul(ah6, bl8) | 0;
	                            hi = hi + Math.imul(ah6, bh8) | 0;
	                            lo = lo + Math.imul(al5, bl9) | 0;
	                            mid = mid + Math.imul(al5, bh9) | 0;
	                            mid = mid + Math.imul(ah5, bl9) | 0;
	                            hi = hi + Math.imul(ah5, bh9) | 0;
	                            var w14 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
	                            w14 &= 67108863;
	                            lo = Math.imul(al9, bl6);
	                            mid = Math.imul(al9, bh6);
	                            mid = mid + Math.imul(ah9, bl6) | 0;
	                            hi = Math.imul(ah9, bh6);
	                            lo = lo + Math.imul(al8, bl7) | 0;
	                            mid = mid + Math.imul(al8, bh7) | 0;
	                            mid = mid + Math.imul(ah8, bl7) | 0;
	                            hi = hi + Math.imul(ah8, bh7) | 0;
	                            lo = lo + Math.imul(al7, bl8) | 0;
	                            mid = mid + Math.imul(al7, bh8) | 0;
	                            mid = mid + Math.imul(ah7, bl8) | 0;
	                            hi = hi + Math.imul(ah7, bh8) | 0;
	                            lo = lo + Math.imul(al6, bl9) | 0;
	                            mid = mid + Math.imul(al6, bh9) | 0;
	                            mid = mid + Math.imul(ah6, bl9) | 0;
	                            hi = hi + Math.imul(ah6, bh9) | 0;
	                            var w15 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
	                            w15 &= 67108863;
	                            lo = Math.imul(al9, bl7);
	                            mid = Math.imul(al9, bh7);
	                            mid = mid + Math.imul(ah9, bl7) | 0;
	                            hi = Math.imul(ah9, bh7);
	                            lo = lo + Math.imul(al8, bl8) | 0;
	                            mid = mid + Math.imul(al8, bh8) | 0;
	                            mid = mid + Math.imul(ah8, bl8) | 0;
	                            hi = hi + Math.imul(ah8, bh8) | 0;
	                            lo = lo + Math.imul(al7, bl9) | 0;
	                            mid = mid + Math.imul(al7, bh9) | 0;
	                            mid = mid + Math.imul(ah7, bl9) | 0;
	                            hi = hi + Math.imul(ah7, bh9) | 0;
	                            var w16 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
	                            w16 &= 67108863;
	                            lo = Math.imul(al9, bl8);
	                            mid = Math.imul(al9, bh8);
	                            mid = mid + Math.imul(ah9, bl8) | 0;
	                            hi = Math.imul(ah9, bh8);
	                            lo = lo + Math.imul(al8, bl9) | 0;
	                            mid = mid + Math.imul(al8, bh9) | 0;
	                            mid = mid + Math.imul(ah8, bl9) | 0;
	                            hi = hi + Math.imul(ah8, bh9) | 0;
	                            var w17 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
	                            w17 &= 67108863;
	                            lo = Math.imul(al9, bl9);
	                            mid = Math.imul(al9, bh9);
	                            mid = mid + Math.imul(ah9, bl9) | 0;
	                            hi = Math.imul(ah9, bh9);
	                            var w18 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
	                            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
	                            w18 &= 67108863;
	                            o[0] = w0;
	                            o[1] = w1;
	                            o[2] = w2;
	                            o[3] = w3;
	                            o[4] = w4;
	                            o[5] = w5;
	                            o[6] = w6;
	                            o[7] = w7;
	                            o[8] = w8;
	                            o[9] = w9;
	                            o[10] = w10;
	                            o[11] = w11;
	                            o[12] = w12;
	                            o[13] = w13;
	                            o[14] = w14;
	                            o[15] = w15;
	                            o[16] = w16;
	                            o[17] = w17;
	                            o[18] = w18;
	                            if (c !== 0) {
	                              o[19] = c;
	                              out.length++;
	                            }
	                            return out;
	                          };
	                          if (!Math.imul) {
	                            comb10MulTo = smallMulTo;
	                          }
	                          function bigMulTo(self2, num, out) {
	                            out.negative = num.negative ^ self2.negative;
	                            out.length = self2.length + num.length;
	                            var carry = 0;
	                            var hncarry = 0;
	                            for (var k = 0; k < out.length - 1; k++) {
	                              var ncarry = hncarry;
	                              hncarry = 0;
	                              var rword = carry & 67108863;
	                              var maxJ = Math.min(k, num.length - 1);
	                              for (var j = Math.max(0, k - self2.length + 1); j <= maxJ; j++) {
	                                var i = k - j;
	                                var a = self2.words[i] | 0;
	                                var b = num.words[j] | 0;
	                                var r = a * b;
	                                var lo = r & 67108863;
	                                ncarry = ncarry + (r / 67108864 | 0) | 0;
	                                lo = lo + rword | 0;
	                                rword = lo & 67108863;
	                                ncarry = ncarry + (lo >>> 26) | 0;
	                                hncarry += ncarry >>> 26;
	                                ncarry &= 67108863;
	                              }
	                              out.words[k] = rword;
	                              carry = ncarry;
	                              ncarry = hncarry;
	                            }
	                            if (carry !== 0) {
	                              out.words[k] = carry;
	                            } else {
	                              out.length--;
	                            }
	                            return out.strip();
	                          }
	                          function jumboMulTo(self2, num, out) {
	                            var fftm = new FFTM();
	                            return fftm.mulp(self2, num, out);
	                          }
	                          BN.prototype.mulTo = function mulTo(num, out) {
	                            var res;
	                            var len = this.length + num.length;
	                            if (this.length === 10 && num.length === 10) {
	                              res = comb10MulTo(this, num, out);
	                            } else if (len < 63) {
	                              res = smallMulTo(this, num, out);
	                            } else if (len < 1024) {
	                              res = bigMulTo(this, num, out);
	                            } else {
	                              res = jumboMulTo(this, num, out);
	                            }
	                            return res;
	                          };
	                          function FFTM(x, y) {
	                            this.x = x;
	                            this.y = y;
	                          }
	                          FFTM.prototype.makeRBT = function makeRBT(N) {
	                            var t = new Array(N);
	                            var l = BN.prototype._countBits(N) - 1;
	                            for (var i = 0; i < N; i++) {
	                              t[i] = this.revBin(i, l, N);
	                            }
	                            return t;
	                          };
	                          FFTM.prototype.revBin = function revBin(x, l, N) {
	                            if (x === 0 || x === N - 1) return x;
	                            var rb = 0;
	                            for (var i = 0; i < l; i++) {
	                              rb |= (x & 1) << l - i - 1;
	                              x >>= 1;
	                            }
	                            return rb;
	                          };
	                          FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
	                            for (var i = 0; i < N; i++) {
	                              rtws[i] = rws[rbt[i]];
	                              itws[i] = iws[rbt[i]];
	                            }
	                          };
	                          FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
	                            this.permute(rbt, rws, iws, rtws, itws, N);
	                            for (var s = 1; s < N; s <<= 1) {
	                              var l = s << 1;
	                              var rtwdf = Math.cos(2 * Math.PI / l);
	                              var itwdf = Math.sin(2 * Math.PI / l);
	                              for (var p = 0; p < N; p += l) {
	                                var rtwdf_ = rtwdf;
	                                var itwdf_ = itwdf;
	                                for (var j = 0; j < s; j++) {
	                                  var re = rtws[p + j];
	                                  var ie = itws[p + j];
	                                  var ro = rtws[p + j + s];
	                                  var io = itws[p + j + s];
	                                  var rx = rtwdf_ * ro - itwdf_ * io;
	                                  io = rtwdf_ * io + itwdf_ * ro;
	                                  ro = rx;
	                                  rtws[p + j] = re + ro;
	                                  itws[p + j] = ie + io;
	                                  rtws[p + j + s] = re - ro;
	                                  itws[p + j + s] = ie - io;
	                                  if (j !== l) {
	                                    rx = rtwdf * rtwdf_ - itwdf * itwdf_;
	                                    itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
	                                    rtwdf_ = rx;
	                                  }
	                                }
	                              }
	                            }
	                          };
	                          FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
	                            var N = Math.max(m, n) | 1;
	                            var odd = N & 1;
	                            var i = 0;
	                            for (N = N / 2 | 0; N; N = N >>> 1) {
	                              i++;
	                            }
	                            return 1 << i + 1 + odd;
	                          };
	                          FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
	                            if (N <= 1) return;
	                            for (var i = 0; i < N / 2; i++) {
	                              var t = rws[i];
	                              rws[i] = rws[N - i - 1];
	                              rws[N - i - 1] = t;
	                              t = iws[i];
	                              iws[i] = -iws[N - i - 1];
	                              iws[N - i - 1] = -t;
	                            }
	                          };
	                          FFTM.prototype.normalize13b = function normalize13b(ws, N) {
	                            var carry = 0;
	                            for (var i = 0; i < N / 2; i++) {
	                              var w = Math.round(ws[2 * i + 1] / N) * 8192 + Math.round(ws[2 * i] / N) + carry;
	                              ws[i] = w & 67108863;
	                              if (w < 67108864) {
	                                carry = 0;
	                              } else {
	                                carry = w / 67108864 | 0;
	                              }
	                            }
	                            return ws;
	                          };
	                          FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
	                            var carry = 0;
	                            for (var i = 0; i < len; i++) {
	                              carry = carry + (ws[i] | 0);
	                              rws[2 * i] = carry & 8191;
	                              carry = carry >>> 13;
	                              rws[2 * i + 1] = carry & 8191;
	                              carry = carry >>> 13;
	                            }
	                            for (i = 2 * len; i < N; ++i) {
	                              rws[i] = 0;
	                            }
	                            assert(carry === 0);
	                            assert((carry & -8192) === 0);
	                          };
	                          FFTM.prototype.stub = function stub(N) {
	                            var ph = new Array(N);
	                            for (var i = 0; i < N; i++) {
	                              ph[i] = 0;
	                            }
	                            return ph;
	                          };
	                          FFTM.prototype.mulp = function mulp(x, y, out) {
	                            var N = 2 * this.guessLen13b(x.length, y.length);
	                            var rbt = this.makeRBT(N);
	                            var _ = this.stub(N);
	                            var rws = new Array(N);
	                            var rwst = new Array(N);
	                            var iwst = new Array(N);
	                            var nrws = new Array(N);
	                            var nrwst = new Array(N);
	                            var niwst = new Array(N);
	                            var rmws = out.words;
	                            rmws.length = N;
	                            this.convert13b(x.words, x.length, rws, N);
	                            this.convert13b(y.words, y.length, nrws, N);
	                            this.transform(rws, _, rwst, iwst, N, rbt);
	                            this.transform(nrws, _, nrwst, niwst, N, rbt);
	                            for (var i = 0; i < N; i++) {
	                              var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
	                              iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
	                              rwst[i] = rx;
	                            }
	                            this.conjugate(rwst, iwst, N);
	                            this.transform(rwst, iwst, rmws, _, N, rbt);
	                            this.conjugate(rmws, _, N);
	                            this.normalize13b(rmws, N);
	                            out.negative = x.negative ^ y.negative;
	                            out.length = x.length + y.length;
	                            return out.strip();
	                          };
	                          BN.prototype.mul = function mul(num) {
	                            var out = new BN(null);
	                            out.words = new Array(this.length + num.length);
	                            return this.mulTo(num, out);
	                          };
	                          BN.prototype.mulf = function mulf(num) {
	                            var out = new BN(null);
	                            out.words = new Array(this.length + num.length);
	                            return jumboMulTo(this, num, out);
	                          };
	                          BN.prototype.imul = function imul(num) {
	                            return this.clone().mulTo(num, this);
	                          };
	                          BN.prototype.imuln = function imuln(num) {
	                            assert(typeof num === "number");
	                            assert(num < 67108864);
	                            var carry = 0;
	                            for (var i = 0; i < this.length; i++) {
	                              var w = (this.words[i] | 0) * num;
	                              var lo = (w & 67108863) + (carry & 67108863);
	                              carry >>= 26;
	                              carry += w / 67108864 | 0;
	                              carry += lo >>> 26;
	                              this.words[i] = lo & 67108863;
	                            }
	                            if (carry !== 0) {
	                              this.words[i] = carry;
	                              this.length++;
	                            }
	                            return this;
	                          };
	                          BN.prototype.muln = function muln(num) {
	                            return this.clone().imuln(num);
	                          };
	                          BN.prototype.sqr = function sqr() {
	                            return this.mul(this);
	                          };
	                          BN.prototype.isqr = function isqr() {
	                            return this.imul(this.clone());
	                          };
	                          BN.prototype.pow = function pow(num) {
	                            var w = toBitArray(num);
	                            if (w.length === 0) return new BN(1);
	                            var res = this;
	                            for (var i = 0; i < w.length; i++, res = res.sqr()) {
	                              if (w[i] !== 0) break;
	                            }
	                            if (++i < w.length) {
	                              for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
	                                if (w[i] === 0) continue;
	                                res = res.mul(q);
	                              }
	                            }
	                            return res;
	                          };
	                          BN.prototype.iushln = function iushln(bits) {
	                            assert(typeof bits === "number" && bits >= 0);
	                            var r = bits % 26;
	                            var s = (bits - r) / 26;
	                            var carryMask = 67108863 >>> 26 - r << 26 - r;
	                            var i;
	                            if (r !== 0) {
	                              var carry = 0;
	                              for (i = 0; i < this.length; i++) {
	                                var newCarry = this.words[i] & carryMask;
	                                var c = (this.words[i] | 0) - newCarry << r;
	                                this.words[i] = c | carry;
	                                carry = newCarry >>> 26 - r;
	                              }
	                              if (carry) {
	                                this.words[i] = carry;
	                                this.length++;
	                              }
	                            }
	                            if (s !== 0) {
	                              for (i = this.length - 1; i >= 0; i--) {
	                                this.words[i + s] = this.words[i];
	                              }
	                              for (i = 0; i < s; i++) {
	                                this.words[i] = 0;
	                              }
	                              this.length += s;
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.ishln = function ishln(bits) {
	                            assert(this.negative === 0);
	                            return this.iushln(bits);
	                          };
	                          BN.prototype.iushrn = function iushrn(bits, hint, extended) {
	                            assert(typeof bits === "number" && bits >= 0);
	                            var h;
	                            if (hint) {
	                              h = (hint - hint % 26) / 26;
	                            } else {
	                              h = 0;
	                            }
	                            var r = bits % 26;
	                            var s = Math.min((bits - r) / 26, this.length);
	                            var mask = 67108863 ^ 67108863 >>> r << r;
	                            var maskedWords = extended;
	                            h -= s;
	                            h = Math.max(0, h);
	                            if (maskedWords) {
	                              for (var i = 0; i < s; i++) {
	                                maskedWords.words[i] = this.words[i];
	                              }
	                              maskedWords.length = s;
	                            }
	                            if (s === 0) ; else if (this.length > s) {
	                              this.length -= s;
	                              for (i = 0; i < this.length; i++) {
	                                this.words[i] = this.words[i + s];
	                              }
	                            } else {
	                              this.words[0] = 0;
	                              this.length = 1;
	                            }
	                            var carry = 0;
	                            for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
	                              var word = this.words[i] | 0;
	                              this.words[i] = carry << 26 - r | word >>> r;
	                              carry = word & mask;
	                            }
	                            if (maskedWords && carry !== 0) {
	                              maskedWords.words[maskedWords.length++] = carry;
	                            }
	                            if (this.length === 0) {
	                              this.words[0] = 0;
	                              this.length = 1;
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.ishrn = function ishrn(bits, hint, extended) {
	                            assert(this.negative === 0);
	                            return this.iushrn(bits, hint, extended);
	                          };
	                          BN.prototype.shln = function shln(bits) {
	                            return this.clone().ishln(bits);
	                          };
	                          BN.prototype.ushln = function ushln(bits) {
	                            return this.clone().iushln(bits);
	                          };
	                          BN.prototype.shrn = function shrn(bits) {
	                            return this.clone().ishrn(bits);
	                          };
	                          BN.prototype.ushrn = function ushrn(bits) {
	                            return this.clone().iushrn(bits);
	                          };
	                          BN.prototype.testn = function testn(bit) {
	                            assert(typeof bit === "number" && bit >= 0);
	                            var r = bit % 26;
	                            var s = (bit - r) / 26;
	                            var q = 1 << r;
	                            if (this.length <= s) return false;
	                            var w = this.words[s];
	                            return !!(w & q);
	                          };
	                          BN.prototype.imaskn = function imaskn(bits) {
	                            assert(typeof bits === "number" && bits >= 0);
	                            var r = bits % 26;
	                            var s = (bits - r) / 26;
	                            assert(this.negative === 0, "imaskn works only with positive numbers");
	                            if (this.length <= s) {
	                              return this;
	                            }
	                            if (r !== 0) {
	                              s++;
	                            }
	                            this.length = Math.min(s, this.length);
	                            if (r !== 0) {
	                              var mask = 67108863 ^ 67108863 >>> r << r;
	                              this.words[this.length - 1] &= mask;
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.maskn = function maskn(bits) {
	                            return this.clone().imaskn(bits);
	                          };
	                          BN.prototype.iaddn = function iaddn(num) {
	                            assert(typeof num === "number");
	                            assert(num < 67108864);
	                            if (num < 0) return this.isubn(-num);
	                            if (this.negative !== 0) {
	                              if (this.length === 1 && (this.words[0] | 0) < num) {
	                                this.words[0] = num - (this.words[0] | 0);
	                                this.negative = 0;
	                                return this;
	                              }
	                              this.negative = 0;
	                              this.isubn(num);
	                              this.negative = 1;
	                              return this;
	                            }
	                            return this._iaddn(num);
	                          };
	                          BN.prototype._iaddn = function _iaddn(num) {
	                            this.words[0] += num;
	                            for (var i = 0; i < this.length && this.words[i] >= 67108864; i++) {
	                              this.words[i] -= 67108864;
	                              if (i === this.length - 1) {
	                                this.words[i + 1] = 1;
	                              } else {
	                                this.words[i + 1]++;
	                              }
	                            }
	                            this.length = Math.max(this.length, i + 1);
	                            return this;
	                          };
	                          BN.prototype.isubn = function isubn(num) {
	                            assert(typeof num === "number");
	                            assert(num < 67108864);
	                            if (num < 0) return this.iaddn(-num);
	                            if (this.negative !== 0) {
	                              this.negative = 0;
	                              this.iaddn(num);
	                              this.negative = 1;
	                              return this;
	                            }
	                            this.words[0] -= num;
	                            if (this.length === 1 && this.words[0] < 0) {
	                              this.words[0] = -this.words[0];
	                              this.negative = 1;
	                            } else {
	                              for (var i = 0; i < this.length && this.words[i] < 0; i++) {
	                                this.words[i] += 67108864;
	                                this.words[i + 1] -= 1;
	                              }
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.addn = function addn(num) {
	                            return this.clone().iaddn(num);
	                          };
	                          BN.prototype.subn = function subn(num) {
	                            return this.clone().isubn(num);
	                          };
	                          BN.prototype.iabs = function iabs() {
	                            this.negative = 0;
	                            return this;
	                          };
	                          BN.prototype.abs = function abs() {
	                            return this.clone().iabs();
	                          };
	                          BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
	                            var len = num.length + shift;
	                            var i;
	                            this._expand(len);
	                            var w;
	                            var carry = 0;
	                            for (i = 0; i < num.length; i++) {
	                              w = (this.words[i + shift] | 0) + carry;
	                              var right = (num.words[i] | 0) * mul;
	                              w -= right & 67108863;
	                              carry = (w >> 26) - (right / 67108864 | 0);
	                              this.words[i + shift] = w & 67108863;
	                            }
	                            for (; i < this.length - shift; i++) {
	                              w = (this.words[i + shift] | 0) + carry;
	                              carry = w >> 26;
	                              this.words[i + shift] = w & 67108863;
	                            }
	                            if (carry === 0) return this.strip();
	                            assert(carry === -1);
	                            carry = 0;
	                            for (i = 0; i < this.length; i++) {
	                              w = -(this.words[i] | 0) + carry;
	                              carry = w >> 26;
	                              this.words[i] = w & 67108863;
	                            }
	                            this.negative = 1;
	                            return this.strip();
	                          };
	                          BN.prototype._wordDiv = function _wordDiv(num, mode) {
	                            var shift = this.length - num.length;
	                            var a = this.clone();
	                            var b = num;
	                            var bhi = b.words[b.length - 1] | 0;
	                            var bhiBits = this._countBits(bhi);
	                            shift = 26 - bhiBits;
	                            if (shift !== 0) {
	                              b = b.ushln(shift);
	                              a.iushln(shift);
	                              bhi = b.words[b.length - 1] | 0;
	                            }
	                            var m = a.length - b.length;
	                            var q;
	                            if (mode !== "mod") {
	                              q = new BN(null);
	                              q.length = m + 1;
	                              q.words = new Array(q.length);
	                              for (var i = 0; i < q.length; i++) {
	                                q.words[i] = 0;
	                              }
	                            }
	                            var diff = a.clone()._ishlnsubmul(b, 1, m);
	                            if (diff.negative === 0) {
	                              a = diff;
	                              if (q) {
	                                q.words[m] = 1;
	                              }
	                            }
	                            for (var j = m - 1; j >= 0; j--) {
	                              var qj = (a.words[b.length + j] | 0) * 67108864 + (a.words[b.length + j - 1] | 0);
	                              qj = Math.min(qj / bhi | 0, 67108863);
	                              a._ishlnsubmul(b, qj, j);
	                              while (a.negative !== 0) {
	                                qj--;
	                                a.negative = 0;
	                                a._ishlnsubmul(b, 1, j);
	                                if (!a.isZero()) {
	                                  a.negative ^= 1;
	                                }
	                              }
	                              if (q) {
	                                q.words[j] = qj;
	                              }
	                            }
	                            if (q) {
	                              q.strip();
	                            }
	                            a.strip();
	                            if (mode !== "div" && shift !== 0) {
	                              a.iushrn(shift);
	                            }
	                            return { div: q || null, mod: a };
	                          };
	                          BN.prototype.divmod = function divmod(num, mode, positive) {
	                            assert(!num.isZero());
	                            if (this.isZero()) {
	                              return { div: new BN(0), mod: new BN(0) };
	                            }
	                            var div, mod, res;
	                            if (this.negative !== 0 && num.negative === 0) {
	                              res = this.neg().divmod(num, mode);
	                              if (mode !== "mod") {
	                                div = res.div.neg();
	                              }
	                              if (mode !== "div") {
	                                mod = res.mod.neg();
	                                if (positive && mod.negative !== 0) {
	                                  mod.iadd(num);
	                                }
	                              }
	                              return { div, mod };
	                            }
	                            if (this.negative === 0 && num.negative !== 0) {
	                              res = this.divmod(num.neg(), mode);
	                              if (mode !== "mod") {
	                                div = res.div.neg();
	                              }
	                              return { div, mod: res.mod };
	                            }
	                            if ((this.negative & num.negative) !== 0) {
	                              res = this.neg().divmod(num.neg(), mode);
	                              if (mode !== "div") {
	                                mod = res.mod.neg();
	                                if (positive && mod.negative !== 0) {
	                                  mod.isub(num);
	                                }
	                              }
	                              return { div: res.div, mod };
	                            }
	                            if (num.length > this.length || this.cmp(num) < 0) {
	                              return { div: new BN(0), mod: this };
	                            }
	                            if (num.length === 1) {
	                              if (mode === "div") {
	                                return { div: this.divn(num.words[0]), mod: null };
	                              }
	                              if (mode === "mod") {
	                                return { div: null, mod: new BN(this.modn(num.words[0])) };
	                              }
	                              return { div: this.divn(num.words[0]), mod: new BN(this.modn(num.words[0])) };
	                            }
	                            return this._wordDiv(num, mode);
	                          };
	                          BN.prototype.div = function div(num) {
	                            return this.divmod(num, "div", false).div;
	                          };
	                          BN.prototype.mod = function mod(num) {
	                            return this.divmod(num, "mod", false).mod;
	                          };
	                          BN.prototype.umod = function umod(num) {
	                            return this.divmod(num, "mod", true).mod;
	                          };
	                          BN.prototype.divRound = function divRound(num) {
	                            var dm = this.divmod(num);
	                            if (dm.mod.isZero()) return dm.div;
	                            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
	                            var half = num.ushrn(1);
	                            var r2 = num.andln(1);
	                            var cmp = mod.cmp(half);
	                            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
	                            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
	                          };
	                          BN.prototype.modn = function modn(num) {
	                            assert(num <= 67108863);
	                            var p = (1 << 26) % num;
	                            var acc = 0;
	                            for (var i = this.length - 1; i >= 0; i--) {
	                              acc = (p * acc + (this.words[i] | 0)) % num;
	                            }
	                            return acc;
	                          };
	                          BN.prototype.idivn = function idivn(num) {
	                            assert(num <= 67108863);
	                            var carry = 0;
	                            for (var i = this.length - 1; i >= 0; i--) {
	                              var w = (this.words[i] | 0) + carry * 67108864;
	                              this.words[i] = w / num | 0;
	                              carry = w % num;
	                            }
	                            return this.strip();
	                          };
	                          BN.prototype.divn = function divn(num) {
	                            return this.clone().idivn(num);
	                          };
	                          BN.prototype.egcd = function egcd(p) {
	                            assert(p.negative === 0);
	                            assert(!p.isZero());
	                            var x = this;
	                            var y = p.clone();
	                            if (x.negative !== 0) {
	                              x = x.umod(p);
	                            } else {
	                              x = x.clone();
	                            }
	                            var A = new BN(1);
	                            var B = new BN(0);
	                            var C = new BN(0);
	                            var D = new BN(1);
	                            var g = 0;
	                            while (x.isEven() && y.isEven()) {
	                              x.iushrn(1);
	                              y.iushrn(1);
	                              ++g;
	                            }
	                            var yp = y.clone();
	                            var xp = x.clone();
	                            while (!x.isZero()) {
	                              for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1) ;
	                              if (i > 0) {
	                                x.iushrn(i);
	                                while (i-- > 0) {
	                                  if (A.isOdd() || B.isOdd()) {
	                                    A.iadd(yp);
	                                    B.isub(xp);
	                                  }
	                                  A.iushrn(1);
	                                  B.iushrn(1);
	                                }
	                              }
	                              for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) ;
	                              if (j > 0) {
	                                y.iushrn(j);
	                                while (j-- > 0) {
	                                  if (C.isOdd() || D.isOdd()) {
	                                    C.iadd(yp);
	                                    D.isub(xp);
	                                  }
	                                  C.iushrn(1);
	                                  D.iushrn(1);
	                                }
	                              }
	                              if (x.cmp(y) >= 0) {
	                                x.isub(y);
	                                A.isub(C);
	                                B.isub(D);
	                              } else {
	                                y.isub(x);
	                                C.isub(A);
	                                D.isub(B);
	                              }
	                            }
	                            return { a: C, b: D, gcd: y.iushln(g) };
	                          };
	                          BN.prototype._invmp = function _invmp(p) {
	                            assert(p.negative === 0);
	                            assert(!p.isZero());
	                            var a = this;
	                            var b = p.clone();
	                            if (a.negative !== 0) {
	                              a = a.umod(p);
	                            } else {
	                              a = a.clone();
	                            }
	                            var x1 = new BN(1);
	                            var x2 = new BN(0);
	                            var delta = b.clone();
	                            while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
	                              for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1) ;
	                              if (i > 0) {
	                                a.iushrn(i);
	                                while (i-- > 0) {
	                                  if (x1.isOdd()) {
	                                    x1.iadd(delta);
	                                  }
	                                  x1.iushrn(1);
	                                }
	                              }
	                              for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) ;
	                              if (j > 0) {
	                                b.iushrn(j);
	                                while (j-- > 0) {
	                                  if (x2.isOdd()) {
	                                    x2.iadd(delta);
	                                  }
	                                  x2.iushrn(1);
	                                }
	                              }
	                              if (a.cmp(b) >= 0) {
	                                a.isub(b);
	                                x1.isub(x2);
	                              } else {
	                                b.isub(a);
	                                x2.isub(x1);
	                              }
	                            }
	                            var res;
	                            if (a.cmpn(1) === 0) {
	                              res = x1;
	                            } else {
	                              res = x2;
	                            }
	                            if (res.cmpn(0) < 0) {
	                              res.iadd(p);
	                            }
	                            return res;
	                          };
	                          BN.prototype.gcd = function gcd(num) {
	                            if (this.isZero()) return num.abs();
	                            if (num.isZero()) return this.abs();
	                            var a = this.clone();
	                            var b = num.clone();
	                            a.negative = 0;
	                            b.negative = 0;
	                            for (var shift = 0; a.isEven() && b.isEven(); shift++) {
	                              a.iushrn(1);
	                              b.iushrn(1);
	                            }
	                            do {
	                              while (a.isEven()) {
	                                a.iushrn(1);
	                              }
	                              while (b.isEven()) {
	                                b.iushrn(1);
	                              }
	                              var r = a.cmp(b);
	                              if (r < 0) {
	                                var t = a;
	                                a = b;
	                                b = t;
	                              } else if (r === 0 || b.cmpn(1) === 0) {
	                                break;
	                              }
	                              a.isub(b);
	                            } while (true);
	                            return b.iushln(shift);
	                          };
	                          BN.prototype.invm = function invm(num) {
	                            return this.egcd(num).a.umod(num);
	                          };
	                          BN.prototype.isEven = function isEven() {
	                            return (this.words[0] & 1) === 0;
	                          };
	                          BN.prototype.isOdd = function isOdd() {
	                            return (this.words[0] & 1) === 1;
	                          };
	                          BN.prototype.andln = function andln(num) {
	                            return this.words[0] & num;
	                          };
	                          BN.prototype.bincn = function bincn(bit) {
	                            assert(typeof bit === "number");
	                            var r = bit % 26;
	                            var s = (bit - r) / 26;
	                            var q = 1 << r;
	                            if (this.length <= s) {
	                              this._expand(s + 1);
	                              this.words[s] |= q;
	                              return this;
	                            }
	                            var carry = q;
	                            for (var i = s; carry !== 0 && i < this.length; i++) {
	                              var w = this.words[i] | 0;
	                              w += carry;
	                              carry = w >>> 26;
	                              w &= 67108863;
	                              this.words[i] = w;
	                            }
	                            if (carry !== 0) {
	                              this.words[i] = carry;
	                              this.length++;
	                            }
	                            return this;
	                          };
	                          BN.prototype.isZero = function isZero() {
	                            return this.length === 1 && this.words[0] === 0;
	                          };
	                          BN.prototype.cmpn = function cmpn(num) {
	                            var negative = num < 0;
	                            if (this.negative !== 0 && !negative) return -1;
	                            if (this.negative === 0 && negative) return 1;
	                            this.strip();
	                            var res;
	                            if (this.length > 1) {
	                              res = 1;
	                            } else {
	                              if (negative) {
	                                num = -num;
	                              }
	                              assert(num <= 67108863, "Number is too big");
	                              var w = this.words[0] | 0;
	                              res = w === num ? 0 : w < num ? -1 : 1;
	                            }
	                            if (this.negative !== 0) return -res | 0;
	                            return res;
	                          };
	                          BN.prototype.cmp = function cmp(num) {
	                            if (this.negative !== 0 && num.negative === 0) return -1;
	                            if (this.negative === 0 && num.negative !== 0) return 1;
	                            var res = this.ucmp(num);
	                            if (this.negative !== 0) return -res | 0;
	                            return res;
	                          };
	                          BN.prototype.ucmp = function ucmp(num) {
	                            if (this.length > num.length) return 1;
	                            if (this.length < num.length) return -1;
	                            var res = 0;
	                            for (var i = this.length - 1; i >= 0; i--) {
	                              var a = this.words[i] | 0;
	                              var b = num.words[i] | 0;
	                              if (a === b) continue;
	                              if (a < b) {
	                                res = -1;
	                              } else if (a > b) {
	                                res = 1;
	                              }
	                              break;
	                            }
	                            return res;
	                          };
	                          BN.prototype.gtn = function gtn(num) {
	                            return this.cmpn(num) === 1;
	                          };
	                          BN.prototype.gt = function gt(num) {
	                            return this.cmp(num) === 1;
	                          };
	                          BN.prototype.gten = function gten(num) {
	                            return this.cmpn(num) >= 0;
	                          };
	                          BN.prototype.gte = function gte(num) {
	                            return this.cmp(num) >= 0;
	                          };
	                          BN.prototype.ltn = function ltn(num) {
	                            return this.cmpn(num) === -1;
	                          };
	                          BN.prototype.lt = function lt(num) {
	                            return this.cmp(num) === -1;
	                          };
	                          BN.prototype.lten = function lten(num) {
	                            return this.cmpn(num) <= 0;
	                          };
	                          BN.prototype.lte = function lte(num) {
	                            return this.cmp(num) <= 0;
	                          };
	                          BN.prototype.eqn = function eqn(num) {
	                            return this.cmpn(num) === 0;
	                          };
	                          BN.prototype.eq = function eq(num) {
	                            return this.cmp(num) === 0;
	                          };
	                          BN.red = function red(num) {
	                            return new Red(num);
	                          };
	                          BN.prototype.toRed = function toRed(ctx) {
	                            assert(!this.red, "Already a number in reduction context");
	                            assert(this.negative === 0, "red works only with positives");
	                            return ctx.convertTo(this)._forceRed(ctx);
	                          };
	                          BN.prototype.fromRed = function fromRed() {
	                            assert(this.red, "fromRed works only with numbers in reduction context");
	                            return this.red.convertFrom(this);
	                          };
	                          BN.prototype._forceRed = function _forceRed(ctx) {
	                            this.red = ctx;
	                            return this;
	                          };
	                          BN.prototype.forceRed = function forceRed(ctx) {
	                            assert(!this.red, "Already a number in reduction context");
	                            return this._forceRed(ctx);
	                          };
	                          BN.prototype.redAdd = function redAdd(num) {
	                            assert(this.red, "redAdd works only with red numbers");
	                            return this.red.add(this, num);
	                          };
	                          BN.prototype.redIAdd = function redIAdd(num) {
	                            assert(this.red, "redIAdd works only with red numbers");
	                            return this.red.iadd(this, num);
	                          };
	                          BN.prototype.redSub = function redSub(num) {
	                            assert(this.red, "redSub works only with red numbers");
	                            return this.red.sub(this, num);
	                          };
	                          BN.prototype.redISub = function redISub(num) {
	                            assert(this.red, "redISub works only with red numbers");
	                            return this.red.isub(this, num);
	                          };
	                          BN.prototype.redShl = function redShl(num) {
	                            assert(this.red, "redShl works only with red numbers");
	                            return this.red.shl(this, num);
	                          };
	                          BN.prototype.redMul = function redMul(num) {
	                            assert(this.red, "redMul works only with red numbers");
	                            this.red._verify2(this, num);
	                            return this.red.mul(this, num);
	                          };
	                          BN.prototype.redIMul = function redIMul(num) {
	                            assert(this.red, "redMul works only with red numbers");
	                            this.red._verify2(this, num);
	                            return this.red.imul(this, num);
	                          };
	                          BN.prototype.redSqr = function redSqr() {
	                            assert(this.red, "redSqr works only with red numbers");
	                            this.red._verify1(this);
	                            return this.red.sqr(this);
	                          };
	                          BN.prototype.redISqr = function redISqr() {
	                            assert(this.red, "redISqr works only with red numbers");
	                            this.red._verify1(this);
	                            return this.red.isqr(this);
	                          };
	                          BN.prototype.redSqrt = function redSqrt() {
	                            assert(this.red, "redSqrt works only with red numbers");
	                            this.red._verify1(this);
	                            return this.red.sqrt(this);
	                          };
	                          BN.prototype.redInvm = function redInvm() {
	                            assert(this.red, "redInvm works only with red numbers");
	                            this.red._verify1(this);
	                            return this.red.invm(this);
	                          };
	                          BN.prototype.redNeg = function redNeg() {
	                            assert(this.red, "redNeg works only with red numbers");
	                            this.red._verify1(this);
	                            return this.red.neg(this);
	                          };
	                          BN.prototype.redPow = function redPow(num) {
	                            assert(this.red && !num.red, "redPow(normalNum)");
	                            this.red._verify1(this);
	                            return this.red.pow(this, num);
	                          };
	                          var primes = { k256: null, p224: null, p192: null, p25519: null };
	                          function MPrime(name2, p) {
	                            this.name = name2;
	                            this.p = new BN(p, 16);
	                            this.n = this.p.bitLength();
	                            this.k = new BN(1).iushln(this.n).isub(this.p);
	                            this.tmp = this._tmp();
	                          }
	                          MPrime.prototype._tmp = function _tmp() {
	                            var tmp = new BN(null);
	                            tmp.words = new Array(Math.ceil(this.n / 13));
	                            return tmp;
	                          };
	                          MPrime.prototype.ireduce = function ireduce(num) {
	                            var r = num;
	                            var rlen;
	                            do {
	                              this.split(r, this.tmp);
	                              r = this.imulK(r);
	                              r = r.iadd(this.tmp);
	                              rlen = r.bitLength();
	                            } while (rlen > this.n);
	                            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
	                            if (cmp === 0) {
	                              r.words[0] = 0;
	                              r.length = 1;
	                            } else if (cmp > 0) {
	                              r.isub(this.p);
	                            } else {
	                              if (r.strip !== undefined) {
	                                r.strip();
	                              } else {
	                                r._strip();
	                              }
	                            }
	                            return r;
	                          };
	                          MPrime.prototype.split = function split(input, out) {
	                            input.iushrn(this.n, 0, out);
	                          };
	                          MPrime.prototype.imulK = function imulK(num) {
	                            return num.imul(this.k);
	                          };
	                          function K256() {
	                            MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
	                          }
	                          inherits(K256, MPrime);
	                          K256.prototype.split = function split(input, output) {
	                            var mask = 4194303;
	                            var outLen = Math.min(input.length, 9);
	                            for (var i = 0; i < outLen; i++) {
	                              output.words[i] = input.words[i];
	                            }
	                            output.length = outLen;
	                            if (input.length <= 9) {
	                              input.words[0] = 0;
	                              input.length = 1;
	                              return;
	                            }
	                            var prev = input.words[9];
	                            output.words[output.length++] = prev & mask;
	                            for (i = 10; i < input.length; i++) {
	                              var next = input.words[i] | 0;
	                              input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
	                              prev = next;
	                            }
	                            prev >>>= 22;
	                            input.words[i - 10] = prev;
	                            if (prev === 0 && input.length > 10) {
	                              input.length -= 10;
	                            } else {
	                              input.length -= 9;
	                            }
	                          };
	                          K256.prototype.imulK = function imulK(num) {
	                            num.words[num.length] = 0;
	                            num.words[num.length + 1] = 0;
	                            num.length += 2;
	                            var lo = 0;
	                            for (var i = 0; i < num.length; i++) {
	                              var w = num.words[i] | 0;
	                              lo += w * 977;
	                              num.words[i] = lo & 67108863;
	                              lo = w * 64 + (lo / 67108864 | 0);
	                            }
	                            if (num.words[num.length - 1] === 0) {
	                              num.length--;
	                              if (num.words[num.length - 1] === 0) {
	                                num.length--;
	                              }
	                            }
	                            return num;
	                          };
	                          function P224() {
	                            MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
	                          }
	                          inherits(P224, MPrime);
	                          function P192() {
	                            MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
	                          }
	                          inherits(P192, MPrime);
	                          function P25519() {
	                            MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
	                          }
	                          inherits(P25519, MPrime);
	                          P25519.prototype.imulK = function imulK(num) {
	                            var carry = 0;
	                            for (var i = 0; i < num.length; i++) {
	                              var hi = (num.words[i] | 0) * 19 + carry;
	                              var lo = hi & 67108863;
	                              hi >>>= 26;
	                              num.words[i] = lo;
	                              carry = hi;
	                            }
	                            if (carry !== 0) {
	                              num.words[num.length++] = carry;
	                            }
	                            return num;
	                          };
	                          BN._prime = function prime(name2) {
	                            if (primes[name2]) return primes[name2];
	                            var prime2;
	                            if (name2 === "k256") {
	                              prime2 = new K256();
	                            } else if (name2 === "p224") {
	                              prime2 = new P224();
	                            } else if (name2 === "p192") {
	                              prime2 = new P192();
	                            } else if (name2 === "p25519") {
	                              prime2 = new P25519();
	                            } else {
	                              throw new Error("Unknown prime " + name2);
	                            }
	                            primes[name2] = prime2;
	                            return prime2;
	                          };
	                          function Red(m) {
	                            if (typeof m === "string") {
	                              var prime = BN._prime(m);
	                              this.m = prime.p;
	                              this.prime = prime;
	                            } else {
	                              assert(m.gtn(1), "modulus must be greater than 1");
	                              this.m = m;
	                              this.prime = null;
	                            }
	                          }
	                          Red.prototype._verify1 = function _verify1(a) {
	                            assert(a.negative === 0, "red works only with positives");
	                            assert(a.red, "red works only with red numbers");
	                          };
	                          Red.prototype._verify2 = function _verify2(a, b) {
	                            assert((a.negative | b.negative) === 0, "red works only with positives");
	                            assert(a.red && a.red === b.red, "red works only with red numbers");
	                          };
	                          Red.prototype.imod = function imod(a) {
	                            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
	                            return a.umod(this.m)._forceRed(this);
	                          };
	                          Red.prototype.neg = function neg(a) {
	                            if (a.isZero()) {
	                              return a.clone();
	                            }
	                            return this.m.sub(a)._forceRed(this);
	                          };
	                          Red.prototype.add = function add(a, b) {
	                            this._verify2(a, b);
	                            var res = a.add(b);
	                            if (res.cmp(this.m) >= 0) {
	                              res.isub(this.m);
	                            }
	                            return res._forceRed(this);
	                          };
	                          Red.prototype.iadd = function iadd(a, b) {
	                            this._verify2(a, b);
	                            var res = a.iadd(b);
	                            if (res.cmp(this.m) >= 0) {
	                              res.isub(this.m);
	                            }
	                            return res;
	                          };
	                          Red.prototype.sub = function sub(a, b) {
	                            this._verify2(a, b);
	                            var res = a.sub(b);
	                            if (res.cmpn(0) < 0) {
	                              res.iadd(this.m);
	                            }
	                            return res._forceRed(this);
	                          };
	                          Red.prototype.isub = function isub(a, b) {
	                            this._verify2(a, b);
	                            var res = a.isub(b);
	                            if (res.cmpn(0) < 0) {
	                              res.iadd(this.m);
	                            }
	                            return res;
	                          };
	                          Red.prototype.shl = function shl(a, num) {
	                            this._verify1(a);
	                            return this.imod(a.ushln(num));
	                          };
	                          Red.prototype.imul = function imul(a, b) {
	                            this._verify2(a, b);
	                            return this.imod(a.imul(b));
	                          };
	                          Red.prototype.mul = function mul(a, b) {
	                            this._verify2(a, b);
	                            return this.imod(a.mul(b));
	                          };
	                          Red.prototype.isqr = function isqr(a) {
	                            return this.imul(a, a.clone());
	                          };
	                          Red.prototype.sqr = function sqr(a) {
	                            return this.mul(a, a);
	                          };
	                          Red.prototype.sqrt = function sqrt(a) {
	                            if (a.isZero()) return a.clone();
	                            var mod3 = this.m.andln(3);
	                            assert(mod3 % 2 === 1);
	                            if (mod3 === 3) {
	                              var pow = this.m.add(new BN(1)).iushrn(2);
	                              return this.pow(a, pow);
	                            }
	                            var q = this.m.subn(1);
	                            var s = 0;
	                            while (!q.isZero() && q.andln(1) === 0) {
	                              s++;
	                              q.iushrn(1);
	                            }
	                            assert(!q.isZero());
	                            var one = new BN(1).toRed(this);
	                            var nOne = one.redNeg();
	                            var lpow = this.m.subn(1).iushrn(1);
	                            var z = this.m.bitLength();
	                            z = new BN(2 * z * z).toRed(this);
	                            while (this.pow(z, lpow).cmp(nOne) !== 0) {
	                              z.redIAdd(nOne);
	                            }
	                            var c = this.pow(z, q);
	                            var r = this.pow(a, q.addn(1).iushrn(1));
	                            var t = this.pow(a, q);
	                            var m = s;
	                            while (t.cmp(one) !== 0) {
	                              var tmp = t;
	                              for (var i = 0; tmp.cmp(one) !== 0; i++) {
	                                tmp = tmp.redSqr();
	                              }
	                              assert(i < m);
	                              var b = this.pow(c, new BN(1).iushln(m - i - 1));
	                              r = r.redMul(b);
	                              c = b.redSqr();
	                              t = t.redMul(c);
	                              m = i;
	                            }
	                            return r;
	                          };
	                          Red.prototype.invm = function invm(a) {
	                            var inv = a._invmp(this.m);
	                            if (inv.negative !== 0) {
	                              inv.negative = 0;
	                              return this.imod(inv).redNeg();
	                            } else {
	                              return this.imod(inv);
	                            }
	                          };
	                          Red.prototype.pow = function pow(a, num) {
	                            if (num.isZero()) return new BN(1).toRed(this);
	                            if (num.cmpn(1) === 0) return a.clone();
	                            var windowSize = 4;
	                            var wnd = new Array(1 << windowSize);
	                            wnd[0] = new BN(1).toRed(this);
	                            wnd[1] = a;
	                            for (var i = 2; i < wnd.length; i++) {
	                              wnd[i] = this.mul(wnd[i - 1], a);
	                            }
	                            var res = wnd[0];
	                            var current = 0;
	                            var currentLen = 0;
	                            var start = num.bitLength() % 26;
	                            if (start === 0) {
	                              start = 26;
	                            }
	                            for (i = num.length - 1; i >= 0; i--) {
	                              var word = num.words[i];
	                              for (var j = start - 1; j >= 0; j--) {
	                                var bit = word >> j & 1;
	                                if (res !== wnd[0]) {
	                                  res = this.sqr(res);
	                                }
	                                if (bit === 0 && current === 0) {
	                                  currentLen = 0;
	                                  continue;
	                                }
	                                current <<= 1;
	                                current |= bit;
	                                currentLen++;
	                                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
	                                res = this.mul(res, wnd[current]);
	                                currentLen = 0;
	                                current = 0;
	                              }
	                              start = 26;
	                            }
	                            return res;
	                          };
	                          Red.prototype.convertTo = function convertTo(num) {
	                            var r = num.umod(this.m);
	                            return r === num ? r.clone() : r;
	                          };
	                          Red.prototype.convertFrom = function convertFrom(num) {
	                            var res = num.clone();
	                            res.red = null;
	                            return res;
	                          };
	                          BN.mont = function mont(num) {
	                            return new Mont(num);
	                          };
	                          function Mont(m) {
	                            Red.call(this, m);
	                            this.shift = this.m.bitLength();
	                            if (this.shift % 26 !== 0) {
	                              this.shift += 26 - this.shift % 26;
	                            }
	                            this.r = new BN(1).iushln(this.shift);
	                            this.r2 = this.imod(this.r.sqr());
	                            this.rinv = this.r._invmp(this.m);
	                            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
	                            this.minv = this.minv.umod(this.r);
	                            this.minv = this.r.sub(this.minv);
	                          }
	                          inherits(Mont, Red);
	                          Mont.prototype.convertTo = function convertTo(num) {
	                            return this.imod(num.ushln(this.shift));
	                          };
	                          Mont.prototype.convertFrom = function convertFrom(num) {
	                            var r = this.imod(num.mul(this.rinv));
	                            r.red = null;
	                            return r;
	                          };
	                          Mont.prototype.imul = function imul(a, b) {
	                            if (a.isZero() || b.isZero()) {
	                              a.words[0] = 0;
	                              a.length = 1;
	                              return a;
	                            }
	                            var t = a.imul(b);
	                            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	                            var u = t.isub(c).iushrn(this.shift);
	                            var res = u;
	                            if (u.cmp(this.m) >= 0) {
	                              res = u.isub(this.m);
	                            } else if (u.cmpn(0) < 0) {
	                              res = u.iadd(this.m);
	                            }
	                            return res._forceRed(this);
	                          };
	                          Mont.prototype.mul = function mul(a, b) {
	                            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
	                            var t = a.mul(b);
	                            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	                            var u = t.isub(c).iushrn(this.shift);
	                            var res = u;
	                            if (u.cmp(this.m) >= 0) {
	                              res = u.isub(this.m);
	                            } else if (u.cmpn(0) < 0) {
	                              res = u.iadd(this.m);
	                            }
	                            return res._forceRed(this);
	                          };
	                          Mont.prototype.invm = function invm(a) {
	                            var res = this.imod(a._invmp(this.m).mul(this.r2));
	                            return res._forceRed(this);
	                          };
	                        })(module3, this);
	                      }
	                    ),
	                    /***/
	                    2692: (
	                      /***/
	                      function(module3) {
	                        module3.exports = boundary;
	                        function boundary(cells) {
	                          var i, j, k;
	                          var n = cells.length;
	                          var sz = 0;
	                          for (i = 0; i < n; ++i) {
	                            sz += cells[i].length;
	                          }
	                          var result = new Array(sz);
	                          var ptr = 0;
	                          for (i = 0; i < n; ++i) {
	                            var c = cells[i];
	                            var d = c.length;
	                            for (j = 0; j < d; ++j) {
	                              var b = result[ptr++] = new Array(d - 1);
	                              var p = 0;
	                              for (k = 0; k < d; ++k) {
	                                if (k === j) {
	                                  continue;
	                                }
	                                b[p++] = c[k];
	                              }
	                              if (j & 1) {
	                                var tmp = b[1];
	                                b[1] = b[0];
	                                b[0] = tmp;
	                              }
	                            }
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    2569: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_137948__) {
	                        module3.exports = boxIntersectWrapper;
	                        var pool = __nested_webpack_require_137948__(5306);
	                        var sweep = __nested_webpack_require_137948__(1390);
	                        var boxIntersectIter = __nested_webpack_require_137948__(2337);
	                        function boxEmpty(d, box) {
	                          for (var j = 0; j < d; ++j) {
	                            if (!(box[j] <= box[j + d])) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        }
	                        function convertBoxes(boxes, d, data, ids) {
	                          var ptr = 0;
	                          var count = 0;
	                          for (var i = 0, n = boxes.length; i < n; ++i) {
	                            var b = boxes[i];
	                            if (boxEmpty(d, b)) {
	                              continue;
	                            }
	                            for (var j = 0; j < 2 * d; ++j) {
	                              data[ptr++] = b[j];
	                            }
	                            ids[count++] = i;
	                          }
	                          return count;
	                        }
	                        function boxIntersect(red, blue, visit, full) {
	                          var n = red.length;
	                          var m = blue.length;
	                          if (n <= 0 || m <= 0) {
	                            return;
	                          }
	                          var d = red[0].length >>> 1;
	                          if (d <= 0) {
	                            return;
	                          }
	                          var retval;
	                          var redList = pool.mallocDouble(2 * d * n);
	                          var redIds = pool.mallocInt32(n);
	                          n = convertBoxes(red, d, redList, redIds);
	                          if (n > 0) {
	                            if (d === 1 && full) {
	                              sweep.init(n);
	                              retval = sweep.sweepComplete(d, visit, 0, n, redList, redIds, 0, n, redList, redIds);
	                            } else {
	                              var blueList = pool.mallocDouble(2 * d * m);
	                              var blueIds = pool.mallocInt32(m);
	                              m = convertBoxes(blue, d, blueList, blueIds);
	                              if (m > 0) {
	                                sweep.init(n + m);
	                                if (d === 1) {
	                                  retval = sweep.sweepBipartite(d, visit, 0, n, redList, redIds, 0, m, blueList, blueIds);
	                                } else {
	                                  retval = boxIntersectIter(d, visit, full, n, redList, redIds, m, blueList, blueIds);
	                                }
	                                pool.free(blueList);
	                                pool.free(blueIds);
	                              }
	                            }
	                            pool.free(redList);
	                            pool.free(redIds);
	                          }
	                          return retval;
	                        }
	                        var RESULT;
	                        function appendItem(i, j) {
	                          RESULT.push([i, j]);
	                        }
	                        function intersectFullArray(x) {
	                          RESULT = [];
	                          boxIntersect(x, x, appendItem, true);
	                          return RESULT;
	                        }
	                        function intersectBipartiteArray(x, y) {
	                          RESULT = [];
	                          boxIntersect(x, y, appendItem, false);
	                          return RESULT;
	                        }
	                        function boxIntersectWrapper(arg0, arg1, arg2) {
	                          switch (arguments.length) {
	                            case 1:
	                              return intersectFullArray(arg0);
	                            case 2:
	                              if (typeof arg1 === "function") {
	                                return boxIntersect(arg0, arg0, arg1, true);
	                              } else {
	                                return intersectBipartiteArray(arg0, arg1);
	                              }
	                            case 3:
	                              return boxIntersect(arg0, arg1, arg2, false);
	                            default:
	                              throw new Error("box-intersect: Invalid arguments");
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    7333: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        function full() {
	                          function bruteForceRedFull(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            var es = 2 * d;
	                            for (var i = rs, rp = es * rs; i < re; ++i, rp += es) {
	                              var x0 = rb[ax + rp], x1 = rb[ax + rp + d], xi = ri[i];
	                              Q: for (var j = bs, bp = es * bs; j < be; ++j, bp += es) {
	                                var y0 = bb[ax + bp], y1 = bb[ax + bp + d], yi = bi[j];
	                                if (y1 < x0 || x1 < y0) continue;
	                                for (var k = ax + 1; k < d; ++k) {
	                                  var r0 = rb[k + rp], r1 = rb[k + d + rp], b0 = bb[k + bp], b1 = bb[k + d + bp];
	                                  if (r1 < b0 || b1 < r0) continue Q;
	                                }
	                                var rv = vv(xi, yi);
	                                if (rv !== undefined) return rv;
	                              }
	                            }
	                          }
	                          function bruteForceBlueFull(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            var es = 2 * d;
	                            for (var j = bs, bp = es * bs; j < be; ++j, bp += es) {
	                              var y0 = bb[ax + bp], y1 = bb[ax + bp + d], yi = bi[j];
	                              Q: for (var i = rs, rp = es * rs; i < re; ++i, rp += es) {
	                                var x0 = rb[ax + rp], x1 = rb[ax + rp + d], xi = ri[i];
	                                if (y1 < x0 || x1 < y0) continue;
	                                for (var k = ax + 1; k < d; ++k) {
	                                  var r0 = rb[k + rp], r1 = rb[k + d + rp], b0 = bb[k + bp], b1 = bb[k + d + bp];
	                                  if (r1 < b0 || b1 < r0) continue Q;
	                                }
	                                var rv = vv(xi, yi);
	                                if (rv !== undefined) return rv;
	                              }
	                            }
	                          }
	                          function bruteForceFull(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            if (re - rs > be - bs) {
	                              return bruteForceRedFull(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi);
	                            } else {
	                              return bruteForceBlueFull(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi);
	                            }
	                          }
	                          return bruteForceFull;
	                        }
	                        function partial() {
	                          function bruteForceRedFlip(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            var es = 2 * d;
	                            for (var i = rs, rp = es * rs; i < re; ++i, rp += es) {
	                              var x0 = rb[ax + rp], x1 = rb[ax + rp + d], xi = ri[i];
	                              Q: for (var j = bs, bp = es * bs; j < be; ++j, bp += es) {
	                                var y0 = bb[ax + bp], yi = bi[j];
	                                if (y0 <= x0 || x1 < y0) continue;
	                                for (var k = ax + 1; k < d; ++k) {
	                                  var r0 = rb[k + rp], r1 = rb[k + d + rp], b0 = bb[k + bp], b1 = bb[k + d + bp];
	                                  if (r1 < b0 || b1 < r0) continue Q;
	                                }
	                                var rv = vv(yi, xi);
	                                if (rv !== undefined) return rv;
	                              }
	                            }
	                          }
	                          function bruteForceRed(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            var es = 2 * d;
	                            for (var i = rs, rp = es * rs; i < re; ++i, rp += es) {
	                              var x0 = rb[ax + rp], x1 = rb[ax + rp + d], xi = ri[i];
	                              Q: for (var j = bs, bp = es * bs; j < be; ++j, bp += es) {
	                                var y0 = bb[ax + bp], yi = bi[j];
	                                if (y0 < x0 || x1 < y0) continue;
	                                for (var k = ax + 1; k < d; ++k) {
	                                  var r0 = rb[k + rp], r1 = rb[k + d + rp], b0 = bb[k + bp], b1 = bb[k + d + bp];
	                                  if (r1 < b0 || b1 < r0) continue Q;
	                                }
	                                var rv = vv(xi, yi);
	                                if (rv !== undefined) return rv;
	                              }
	                            }
	                          }
	                          function bruteForceBlueFlip(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            var es = 2 * d;
	                            for (var j = bs, bp = es * bs; j < be; ++j, bp += es) {
	                              var y0 = bb[ax + bp], yi = bi[j];
	                              Q: for (var i = rs, rp = es * rs; i < re; ++i, rp += es) {
	                                var x0 = rb[ax + rp], x1 = rb[ax + rp + d], xi = ri[i];
	                                if (y0 <= x0 || x1 < y0) continue;
	                                for (var k = ax + 1; k < d; ++k) {
	                                  var r0 = rb[k + rp], r1 = rb[k + d + rp], b0 = bb[k + bp], b1 = bb[k + d + bp];
	                                  if (r1 < b0 || b1 < r0) continue Q;
	                                }
	                                var rv = vv(yi, xi);
	                                if (rv !== undefined) return rv;
	                              }
	                            }
	                          }
	                          function bruteForceBlue(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi) {
	                            var es = 2 * d;
	                            for (var j = bs, bp = es * bs; j < be; ++j, bp += es) {
	                              var y0 = bb[ax + bp], yi = bi[j];
	                              Q: for (var i = rs, rp = es * rs; i < re; ++i, rp += es) {
	                                var x0 = rb[ax + rp], x1 = rb[ax + rp + d], xi = ri[i];
	                                if (y0 < x0 || x1 < y0) continue;
	                                for (var k = ax + 1; k < d; ++k) {
	                                  var r0 = rb[k + rp], r1 = rb[k + d + rp], b0 = bb[k + bp], b1 = bb[k + d + bp];
	                                  if (r1 < b0 || b1 < r0) continue Q;
	                                }
	                                var rv = vv(xi, yi);
	                                if (rv !== undefined) return rv;
	                              }
	                            }
	                          }
	                          function bruteForcePartial(d, ax, vv, fp, rs, re, rb, ri, bs, be, bb, bi) {
	                            if (re - rs > be - bs) {
	                              if (fp) {
	                                return bruteForceRedFlip(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi);
	                              } else {
	                                return bruteForceRed(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi);
	                              }
	                            } else {
	                              if (fp) {
	                                return bruteForceBlueFlip(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi);
	                              } else {
	                                return bruteForceBlue(d, ax, vv, rs, re, rb, ri, bs, be, bb, bi);
	                              }
	                            }
	                          }
	                          return bruteForcePartial;
	                        }
	                        function bruteForcePlanner(isFull) {
	                          return isFull ? full() : partial();
	                        }
	                        exports2.partial = bruteForcePlanner(false);
	                        exports2.full = bruteForcePlanner(true);
	                      }
	                    ),
	                    /***/
	                    2337: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_143508__) {
	                        module3.exports = boxIntersectIter;
	                        var pool = __nested_webpack_require_143508__(5306);
	                        var bits = __nested_webpack_require_143508__(2288);
	                        var bruteForce = __nested_webpack_require_143508__(7333);
	                        var bruteForcePartial = bruteForce.partial;
	                        var bruteForceFull = bruteForce.full;
	                        var sweep = __nested_webpack_require_143508__(1390);
	                        var findMedian = __nested_webpack_require_143508__(2464);
	                        var genPartition = __nested_webpack_require_143508__(122);
	                        var BRUTE_FORCE_CUTOFF = 128;
	                        var SCAN_CUTOFF = 1 << 22;
	                        var SCAN_COMPLETE_CUTOFF = 1 << 22;
	                        var partitionInteriorContainsInterval = genPartition("!(lo>=p0)&&!(p1>=hi)");
	                        var partitionStartEqual = genPartition("lo===p0");
	                        var partitionStartLessThan = genPartition("lo<p0");
	                        var partitionEndLessThanEqual = genPartition("hi<=p0");
	                        var partitionContainsPoint = genPartition("lo<=p0&&p0<=hi");
	                        var partitionContainsPointProper = genPartition("lo<p0&&p0<=hi");
	                        var IFRAME_SIZE = 6;
	                        var DFRAME_SIZE = 2;
	                        var INIT_CAPACITY = 1024;
	                        var BOX_ISTACK = pool.mallocInt32(INIT_CAPACITY);
	                        var BOX_DSTACK = pool.mallocDouble(INIT_CAPACITY);
	                        function iterInit(d, count) {
	                          var levels = 8 * bits.log2(count + 1) * (d + 1) | 0;
	                          var maxInts = bits.nextPow2(IFRAME_SIZE * levels);
	                          if (BOX_ISTACK.length < maxInts) {
	                            pool.free(BOX_ISTACK);
	                            BOX_ISTACK = pool.mallocInt32(maxInts);
	                          }
	                          var maxDoubles = bits.nextPow2(DFRAME_SIZE * levels);
	                          if (BOX_DSTACK.length < maxDoubles) {
	                            pool.free(BOX_DSTACK);
	                            BOX_DSTACK = pool.mallocDouble(maxDoubles);
	                          }
	                        }
	                        function iterPush(ptr, axis, redStart, redEnd, blueStart, blueEnd, state, lo, hi) {
	                          var iptr = IFRAME_SIZE * ptr;
	                          BOX_ISTACK[iptr] = axis;
	                          BOX_ISTACK[iptr + 1] = redStart;
	                          BOX_ISTACK[iptr + 2] = redEnd;
	                          BOX_ISTACK[iptr + 3] = blueStart;
	                          BOX_ISTACK[iptr + 4] = blueEnd;
	                          BOX_ISTACK[iptr + 5] = state;
	                          var dptr = DFRAME_SIZE * ptr;
	                          BOX_DSTACK[dptr] = lo;
	                          BOX_DSTACK[dptr + 1] = hi;
	                        }
	                        function onePointPartial(d, axis, visit, flip, redStart, redEnd, red, redIndex, blueOffset, blue, blueId) {
	                          var elemSize = 2 * d;
	                          var bluePtr = blueOffset * elemSize;
	                          var blueX = blue[bluePtr + axis];
	                          red_loop: for (var i = redStart, redPtr = redStart * elemSize; i < redEnd; ++i, redPtr += elemSize) {
	                            var r0 = red[redPtr + axis];
	                            var r1 = red[redPtr + axis + d];
	                            if (blueX < r0 || r1 < blueX) {
	                              continue;
	                            }
	                            if (flip && blueX === r0) {
	                              continue;
	                            }
	                            var redId = redIndex[i];
	                            for (var j = axis + 1; j < d; ++j) {
	                              var r0 = red[redPtr + j];
	                              var r1 = red[redPtr + j + d];
	                              var b0 = blue[bluePtr + j];
	                              var b1 = blue[bluePtr + j + d];
	                              if (r1 < b0 || b1 < r0) {
	                                continue red_loop;
	                              }
	                            }
	                            var retval;
	                            if (flip) {
	                              retval = visit(blueId, redId);
	                            } else {
	                              retval = visit(redId, blueId);
	                            }
	                            if (retval !== undefined) {
	                              return retval;
	                            }
	                          }
	                        }
	                        function onePointFull(d, axis, visit, redStart, redEnd, red, redIndex, blueOffset, blue, blueId) {
	                          var elemSize = 2 * d;
	                          var bluePtr = blueOffset * elemSize;
	                          var blueX = blue[bluePtr + axis];
	                          red_loop: for (var i = redStart, redPtr = redStart * elemSize; i < redEnd; ++i, redPtr += elemSize) {
	                            var redId = redIndex[i];
	                            if (redId === blueId) {
	                              continue;
	                            }
	                            var r0 = red[redPtr + axis];
	                            var r1 = red[redPtr + axis + d];
	                            if (blueX < r0 || r1 < blueX) {
	                              continue;
	                            }
	                            for (var j = axis + 1; j < d; ++j) {
	                              var r0 = red[redPtr + j];
	                              var r1 = red[redPtr + j + d];
	                              var b0 = blue[bluePtr + j];
	                              var b1 = blue[bluePtr + j + d];
	                              if (r1 < b0 || b1 < r0) {
	                                continue red_loop;
	                              }
	                            }
	                            var retval = visit(redId, blueId);
	                            if (retval !== undefined) {
	                              return retval;
	                            }
	                          }
	                        }
	                        function boxIntersectIter(d, visit, initFull, xSize, xBoxes, xIndex, ySize, yBoxes, yIndex) {
	                          iterInit(d, xSize + ySize);
	                          var top = 0;
	                          var elemSize = 2 * d;
	                          var retval;
	                          iterPush(top++, 0, 0, xSize, 0, ySize, initFull ? 16 : 0, -Infinity, Infinity);
	                          if (!initFull) {
	                            iterPush(top++, 0, 0, ySize, 0, xSize, 1, -Infinity, Infinity);
	                          }
	                          while (top > 0) {
	                            top -= 1;
	                            var iptr = top * IFRAME_SIZE;
	                            var axis = BOX_ISTACK[iptr];
	                            var redStart = BOX_ISTACK[iptr + 1];
	                            var redEnd = BOX_ISTACK[iptr + 2];
	                            var blueStart = BOX_ISTACK[iptr + 3];
	                            var blueEnd = BOX_ISTACK[iptr + 4];
	                            var state = BOX_ISTACK[iptr + 5];
	                            var dptr = top * DFRAME_SIZE;
	                            var lo = BOX_DSTACK[dptr];
	                            var hi = BOX_DSTACK[dptr + 1];
	                            var flip = state & 1;
	                            var full = !!(state & 16);
	                            var red = xBoxes;
	                            var redIndex = xIndex;
	                            var blue = yBoxes;
	                            var blueIndex = yIndex;
	                            if (flip) {
	                              red = yBoxes;
	                              redIndex = yIndex;
	                              blue = xBoxes;
	                              blueIndex = xIndex;
	                            }
	                            if (state & 2) {
	                              redEnd = partitionStartLessThan(d, axis, redStart, redEnd, red, redIndex, hi);
	                              if (redStart >= redEnd) {
	                                continue;
	                              }
	                            }
	                            if (state & 4) {
	                              redStart = partitionEndLessThanEqual(d, axis, redStart, redEnd, red, redIndex, lo);
	                              if (redStart >= redEnd) {
	                                continue;
	                              }
	                            }
	                            var redCount = redEnd - redStart;
	                            var blueCount = blueEnd - blueStart;
	                            if (full) {
	                              if (d * redCount * (redCount + blueCount) < SCAN_COMPLETE_CUTOFF) {
	                                retval = sweep.scanComplete(d, axis, visit, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                                continue;
	                              }
	                            } else {
	                              if (d * Math.min(redCount, blueCount) < BRUTE_FORCE_CUTOFF) {
	                                retval = bruteForcePartial(d, axis, visit, flip, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                                continue;
	                              } else if (d * redCount * blueCount < SCAN_CUTOFF) {
	                                retval = sweep.scanBipartite(d, axis, visit, flip, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                                continue;
	                              }
	                            }
	                            var red0 = partitionInteriorContainsInterval(d, axis, redStart, redEnd, red, redIndex, lo, hi);
	                            if (redStart < red0) {
	                              if (d * (red0 - redStart) < BRUTE_FORCE_CUTOFF) {
	                                retval = bruteForceFull(d, axis + 1, visit, redStart, red0, red, redIndex, blueStart, blueEnd, blue, blueIndex);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                              } else if (axis === d - 2) {
	                                if (flip) {
	                                  retval = sweep.sweepBipartite(d, visit, blueStart, blueEnd, blue, blueIndex, redStart, red0, red, redIndex);
	                                } else {
	                                  retval = sweep.sweepBipartite(d, visit, redStart, red0, red, redIndex, blueStart, blueEnd, blue, blueIndex);
	                                }
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                              } else {
	                                iterPush(top++, axis + 1, redStart, red0, blueStart, blueEnd, flip, -Infinity, Infinity);
	                                iterPush(top++, axis + 1, blueStart, blueEnd, redStart, red0, flip ^ 1, -Infinity, Infinity);
	                              }
	                            }
	                            if (red0 < redEnd) {
	                              var blue0 = findMedian(d, axis, blueStart, blueEnd, blue, blueIndex);
	                              var mid = blue[elemSize * blue0 + axis];
	                              var blue1 = partitionStartEqual(d, axis, blue0, blueEnd, blue, blueIndex, mid);
	                              if (blue1 < blueEnd) {
	                                iterPush(top++, axis, red0, redEnd, blue1, blueEnd, (flip | 4) + (full ? 16 : 0), mid, hi);
	                              }
	                              if (blueStart < blue0) {
	                                iterPush(top++, axis, red0, redEnd, blueStart, blue0, (flip | 2) + (full ? 16 : 0), lo, mid);
	                              }
	                              if (blue0 + 1 === blue1) {
	                                if (full) {
	                                  retval = onePointFull(d, axis, visit, red0, redEnd, red, redIndex, blue0, blue, blueIndex[blue0]);
	                                } else {
	                                  retval = onePointPartial(d, axis, visit, flip, red0, redEnd, red, redIndex, blue0, blue, blueIndex[blue0]);
	                                }
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                              } else if (blue0 < blue1) {
	                                var red1;
	                                if (full) {
	                                  red1 = partitionContainsPoint(d, axis, red0, redEnd, red, redIndex, mid);
	                                  if (red0 < red1) {
	                                    var redX = partitionStartEqual(d, axis, red0, red1, red, redIndex, mid);
	                                    if (axis === d - 2) {
	                                      if (red0 < redX) {
	                                        retval = sweep.sweepComplete(d, visit, red0, redX, red, redIndex, blue0, blue1, blue, blueIndex);
	                                        if (retval !== undefined) {
	                                          return retval;
	                                        }
	                                      }
	                                      if (redX < red1) {
	                                        retval = sweep.sweepBipartite(d, visit, redX, red1, red, redIndex, blue0, blue1, blue, blueIndex);
	                                        if (retval !== undefined) {
	                                          return retval;
	                                        }
	                                      }
	                                    } else {
	                                      if (red0 < redX) {
	                                        iterPush(top++, axis + 1, red0, redX, blue0, blue1, 16, -Infinity, Infinity);
	                                      }
	                                      if (redX < red1) {
	                                        iterPush(top++, axis + 1, redX, red1, blue0, blue1, 0, -Infinity, Infinity);
	                                        iterPush(top++, axis + 1, blue0, blue1, redX, red1, 1, -Infinity, Infinity);
	                                      }
	                                    }
	                                  }
	                                } else {
	                                  if (flip) {
	                                    red1 = partitionContainsPointProper(d, axis, red0, redEnd, red, redIndex, mid);
	                                  } else {
	                                    red1 = partitionContainsPoint(d, axis, red0, redEnd, red, redIndex, mid);
	                                  }
	                                  if (red0 < red1) {
	                                    if (axis === d - 2) {
	                                      if (flip) {
	                                        retval = sweep.sweepBipartite(d, visit, blue0, blue1, blue, blueIndex, red0, red1, red, redIndex);
	                                      } else {
	                                        retval = sweep.sweepBipartite(d, visit, red0, red1, red, redIndex, blue0, blue1, blue, blueIndex);
	                                      }
	                                    } else {
	                                      iterPush(top++, axis + 1, red0, red1, blue0, blue1, flip, -Infinity, Infinity);
	                                      iterPush(top++, axis + 1, blue0, blue1, red0, red1, flip ^ 1, -Infinity, Infinity);
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    2464: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_151825__) {
	                        module3.exports = findMedian;
	                        var genPartition = __nested_webpack_require_151825__(122);
	                        var partitionStartLessThan = genPartition("lo<p0");
	                        var PARTITION_THRESHOLD = 8;
	                        function insertionSort(d, axis, start, end, boxes, ids) {
	                          var elemSize = 2 * d;
	                          var boxPtr = elemSize * (start + 1) + axis;
	                          for (var i = start + 1; i < end; ++i, boxPtr += elemSize) {
	                            var x = boxes[boxPtr];
	                            for (var j = i, ptr = elemSize * (i - 1); j > start && boxes[ptr + axis] > x; --j, ptr -= elemSize) {
	                              var aPtr = ptr;
	                              var bPtr = ptr + elemSize;
	                              for (var k = 0; k < elemSize; ++k, ++aPtr, ++bPtr) {
	                                var y = boxes[aPtr];
	                                boxes[aPtr] = boxes[bPtr];
	                                boxes[bPtr] = y;
	                              }
	                              var tmp = ids[j];
	                              ids[j] = ids[j - 1];
	                              ids[j - 1] = tmp;
	                            }
	                          }
	                        }
	                        function findMedian(d, axis, start, end, boxes, ids) {
	                          if (end <= start + 1) {
	                            return start;
	                          }
	                          var lo = start;
	                          var hi = end;
	                          var mid = end + start >>> 1;
	                          var elemSize = 2 * d;
	                          var pivot = mid;
	                          var value = boxes[elemSize * mid + axis];
	                          while (lo < hi) {
	                            if (hi - lo < PARTITION_THRESHOLD) {
	                              insertionSort(d, axis, lo, hi, boxes, ids);
	                              value = boxes[elemSize * mid + axis];
	                              break;
	                            }
	                            var count = hi - lo;
	                            var pivot0 = Math.random() * count + lo | 0;
	                            var value0 = boxes[elemSize * pivot0 + axis];
	                            var pivot1 = Math.random() * count + lo | 0;
	                            var value1 = boxes[elemSize * pivot1 + axis];
	                            var pivot2 = Math.random() * count + lo | 0;
	                            var value2 = boxes[elemSize * pivot2 + axis];
	                            if (value0 <= value1) {
	                              if (value2 >= value1) {
	                                pivot = pivot1;
	                                value = value1;
	                              } else if (value0 >= value2) {
	                                pivot = pivot0;
	                                value = value0;
	                              } else {
	                                pivot = pivot2;
	                                value = value2;
	                              }
	                            } else {
	                              if (value1 >= value2) {
	                                pivot = pivot1;
	                                value = value1;
	                              } else if (value2 >= value0) {
	                                pivot = pivot0;
	                                value = value0;
	                              } else {
	                                pivot = pivot2;
	                                value = value2;
	                              }
	                            }
	                            var aPtr = elemSize * (hi - 1);
	                            var bPtr = elemSize * pivot;
	                            for (var i = 0; i < elemSize; ++i, ++aPtr, ++bPtr) {
	                              var x = boxes[aPtr];
	                              boxes[aPtr] = boxes[bPtr];
	                              boxes[bPtr] = x;
	                            }
	                            var y = ids[hi - 1];
	                            ids[hi - 1] = ids[pivot];
	                            ids[pivot] = y;
	                            pivot = partitionStartLessThan(d, axis, lo, hi - 1, boxes, ids, value);
	                            var aPtr = elemSize * (hi - 1);
	                            var bPtr = elemSize * pivot;
	                            for (var i = 0; i < elemSize; ++i, ++aPtr, ++bPtr) {
	                              var x = boxes[aPtr];
	                              boxes[aPtr] = boxes[bPtr];
	                              boxes[bPtr] = x;
	                            }
	                            var y = ids[hi - 1];
	                            ids[hi - 1] = ids[pivot];
	                            ids[pivot] = y;
	                            if (mid < pivot) {
	                              hi = pivot - 1;
	                              while (lo < hi && boxes[elemSize * (hi - 1) + axis] === value) {
	                                hi -= 1;
	                              }
	                              hi += 1;
	                            } else if (pivot < mid) {
	                              lo = pivot + 1;
	                              while (lo < hi && boxes[elemSize * lo + axis] === value) {
	                                lo += 1;
	                              }
	                            } else {
	                              break;
	                            }
	                          }
	                          return partitionStartLessThan(d, axis, start, mid, boxes, ids, boxes[elemSize * mid + axis]);
	                        }
	                      }
	                    ),
	                    /***/
	                    122: (
	                      /***/
	                      function(module3) {
	                        module3.exports = genPartition;
	                        var P2F = { "lo===p0": lo_equal_p0, "lo<p0": lo_lessThan_p0, "lo<=p0": lo_lessOrEqual_p0, "hi<=p0": hi_lessOrEqual_p0, "lo<p0&&p0<=hi": lo_lessThan_p0_and_p0_lessOrEqual_hi, "lo<=p0&&p0<=hi": lo_lassOrEqual_p0_and_p0_lessOrEqual_hi, "!(lo>=p0)&&!(p1>=hi)": lo_lessThan_p0_and_p1_lessThan_hi };
	                        function genPartition(predicate) {
	                          return P2F[predicate];
	                        }
	                        function lo_equal_p0(a, b, c, d, e, f, p0) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var lo = e[k + n];
	                            if (lo === p0) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                        function lo_lessThan_p0(a, b, c, d, e, f, p0) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var lo = e[k + n];
	                            if (lo < p0) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                        function lo_lessOrEqual_p0(a, b, c, d, e, f, p0) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var hi = e[k + o];
	                            if (hi <= p0) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                        function hi_lessOrEqual_p0(a, b, c, d, e, f, p0) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var hi = e[k + o];
	                            if (hi <= p0) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                        function lo_lassOrEqual_p0_and_p0_lessOrEqual_hi(a, b, c, d, e, f, p0) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var lo = e[k + n], hi = e[k + o];
	                            if (lo <= p0 && p0 <= hi) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                        function lo_lessThan_p0_and_p0_lessOrEqual_hi(a, b, c, d, e, f, p0) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var lo = e[k + n], hi = e[k + o];
	                            if (lo < p0 && p0 <= hi) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                        function lo_lessThan_p0_and_p1_lessThan_hi(a, b, c, d, e, f, p0, p1) {
	                          for (var j = 2 * a, k = j * c, l = k, m = c, n = b, o = a + b, p = c; d > p; ++p, k += j) {
	                            var lo = e[k + n], hi = e[k + o];
	                            if (!(lo >= p0) && !(p1 >= hi)) if (m === p) m += 1, l += j;
	                            else {
	                              for (var s = 0; j > s; ++s) {
	                                var t = e[k + s];
	                                e[k + s] = e[l], e[l++] = t;
	                              }
	                              var u = f[p];
	                              f[p] = f[m], f[m++] = u;
	                            }
	                          }
	                          return m;
	                        }
	                      }
	                    ),
	                    /***/
	                    309: (
	                      /***/
	                      function(module3) {
	                        module3.exports = wrapper;
	                        var INSERT_SORT_CUTOFF = 32;
	                        function wrapper(data, n0) {
	                          if (n0 <= 4 * INSERT_SORT_CUTOFF) {
	                            insertionSort(0, n0 - 1, data);
	                          } else {
	                            quickSort(0, n0 - 1, data);
	                          }
	                        }
	                        function insertionSort(left, right, data) {
	                          var ptr = 2 * (left + 1);
	                          for (var i = left + 1; i <= right; ++i) {
	                            var a = data[ptr++];
	                            var b = data[ptr++];
	                            var j = i;
	                            var jptr = ptr - 2;
	                            while (j-- > left) {
	                              var x = data[jptr - 2];
	                              var y = data[jptr - 1];
	                              if (x < a) {
	                                break;
	                              } else if (x === a && y < b) {
	                                break;
	                              }
	                              data[jptr] = x;
	                              data[jptr + 1] = y;
	                              jptr -= 2;
	                            }
	                            data[jptr] = a;
	                            data[jptr + 1] = b;
	                          }
	                        }
	                        function swap(i, j, data) {
	                          i *= 2;
	                          j *= 2;
	                          var x = data[i];
	                          var y = data[i + 1];
	                          data[i] = data[j];
	                          data[i + 1] = data[j + 1];
	                          data[j] = x;
	                          data[j + 1] = y;
	                        }
	                        function move(i, j, data) {
	                          i *= 2;
	                          j *= 2;
	                          data[i] = data[j];
	                          data[i + 1] = data[j + 1];
	                        }
	                        function rotate(i, j, k, data) {
	                          i *= 2;
	                          j *= 2;
	                          k *= 2;
	                          var x = data[i];
	                          var y = data[i + 1];
	                          data[i] = data[j];
	                          data[i + 1] = data[j + 1];
	                          data[j] = data[k];
	                          data[j + 1] = data[k + 1];
	                          data[k] = x;
	                          data[k + 1] = y;
	                        }
	                        function shufflePivot(i, j, px, py, data) {
	                          i *= 2;
	                          j *= 2;
	                          data[i] = data[j];
	                          data[j] = px;
	                          data[i + 1] = data[j + 1];
	                          data[j + 1] = py;
	                        }
	                        function compare(i, j, data) {
	                          i *= 2;
	                          j *= 2;
	                          var x = data[i], y = data[j];
	                          if (x < y) {
	                            return false;
	                          } else if (x === y) {
	                            return data[i + 1] > data[j + 1];
	                          }
	                          return true;
	                        }
	                        function comparePivot(i, y, b, data) {
	                          i *= 2;
	                          var x = data[i];
	                          if (x < y) {
	                            return true;
	                          } else if (x === y) {
	                            return data[i + 1] < b;
	                          }
	                          return false;
	                        }
	                        function quickSort(left, right, data) {
	                          var sixth = (right - left + 1) / 6 | 0, index1 = left + sixth, index5 = right - sixth, index3 = left + right >> 1, index2 = index3 - sixth, index4 = index3 + sixth, el1 = index1, el2 = index2, el3 = index3, el4 = index4, el5 = index5, less = left + 1, great = right - 1, tmp = 0;
	                          if (compare(el1, el2, data)) {
	                            tmp = el1;
	                            el1 = el2;
	                            el2 = tmp;
	                          }
	                          if (compare(el4, el5, data)) {
	                            tmp = el4;
	                            el4 = el5;
	                            el5 = tmp;
	                          }
	                          if (compare(el1, el3, data)) {
	                            tmp = el1;
	                            el1 = el3;
	                            el3 = tmp;
	                          }
	                          if (compare(el2, el3, data)) {
	                            tmp = el2;
	                            el2 = el3;
	                            el3 = tmp;
	                          }
	                          if (compare(el1, el4, data)) {
	                            tmp = el1;
	                            el1 = el4;
	                            el4 = tmp;
	                          }
	                          if (compare(el3, el4, data)) {
	                            tmp = el3;
	                            el3 = el4;
	                            el4 = tmp;
	                          }
	                          if (compare(el2, el5, data)) {
	                            tmp = el2;
	                            el2 = el5;
	                            el5 = tmp;
	                          }
	                          if (compare(el2, el3, data)) {
	                            tmp = el2;
	                            el2 = el3;
	                            el3 = tmp;
	                          }
	                          if (compare(el4, el5, data)) {
	                            tmp = el4;
	                            el4 = el5;
	                            el5 = tmp;
	                          }
	                          var pivot1X = data[2 * el2];
	                          var pivot1Y = data[2 * el2 + 1];
	                          var pivot2X = data[2 * el4];
	                          var pivot2Y = data[2 * el4 + 1];
	                          var ptr0 = 2 * el1;
	                          var ptr2 = 2 * el3;
	                          var ptr4 = 2 * el5;
	                          var ptr5 = 2 * index1;
	                          var ptr6 = 2 * index3;
	                          var ptr7 = 2 * index5;
	                          for (var i1 = 0; i1 < 2; ++i1) {
	                            var x = data[ptr0 + i1];
	                            var y = data[ptr2 + i1];
	                            var z = data[ptr4 + i1];
	                            data[ptr5 + i1] = x;
	                            data[ptr6 + i1] = y;
	                            data[ptr7 + i1] = z;
	                          }
	                          move(index2, left, data);
	                          move(index4, right, data);
	                          for (var k = less; k <= great; ++k) {
	                            if (comparePivot(k, pivot1X, pivot1Y, data)) {
	                              if (k !== less) {
	                                swap(k, less, data);
	                              }
	                              ++less;
	                            } else {
	                              if (!comparePivot(k, pivot2X, pivot2Y, data)) {
	                                while (true) {
	                                  if (!comparePivot(great, pivot2X, pivot2Y, data)) {
	                                    if (--great < k) {
	                                      break;
	                                    }
	                                    continue;
	                                  } else {
	                                    if (comparePivot(great, pivot1X, pivot1Y, data)) {
	                                      rotate(k, less, great, data);
	                                      ++less;
	                                      --great;
	                                    } else {
	                                      swap(k, great, data);
	                                      --great;
	                                    }
	                                    break;
	                                  }
	                                }
	                              }
	                            }
	                          }
	                          shufflePivot(left, less - 1, pivot1X, pivot1Y, data);
	                          shufflePivot(right, great + 1, pivot2X, pivot2Y, data);
	                          if (less - 2 - left <= INSERT_SORT_CUTOFF) {
	                            insertionSort(left, less - 2, data);
	                          } else {
	                            quickSort(left, less - 2, data);
	                          }
	                          if (right - (great + 2) <= INSERT_SORT_CUTOFF) {
	                            insertionSort(great + 2, right, data);
	                          } else {
	                            quickSort(great + 2, right, data);
	                          }
	                          if (great - less <= INSERT_SORT_CUTOFF) {
	                            insertionSort(less, great, data);
	                          } else {
	                            quickSort(less, great, data);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    1390: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_159972__) {
	                        module3.exports = { init: sqInit, sweepBipartite, sweepComplete, scanBipartite, scanComplete };
	                        var pool = __nested_webpack_require_159972__(5306);
	                        var bits = __nested_webpack_require_159972__(2288);
	                        var isort = __nested_webpack_require_159972__(309);
	                        var BLUE_FLAG = 1 << 28;
	                        var INIT_CAPACITY = 1024;
	                        var RED_SWEEP_QUEUE = pool.mallocInt32(INIT_CAPACITY);
	                        var RED_SWEEP_INDEX = pool.mallocInt32(INIT_CAPACITY);
	                        var BLUE_SWEEP_QUEUE = pool.mallocInt32(INIT_CAPACITY);
	                        var BLUE_SWEEP_INDEX = pool.mallocInt32(INIT_CAPACITY);
	                        var COMMON_SWEEP_QUEUE = pool.mallocInt32(INIT_CAPACITY);
	                        var COMMON_SWEEP_INDEX = pool.mallocInt32(INIT_CAPACITY);
	                        var SWEEP_EVENTS = pool.mallocDouble(INIT_CAPACITY * 8);
	                        function sqInit(count) {
	                          var rcount = bits.nextPow2(count);
	                          if (RED_SWEEP_QUEUE.length < rcount) {
	                            pool.free(RED_SWEEP_QUEUE);
	                            RED_SWEEP_QUEUE = pool.mallocInt32(rcount);
	                          }
	                          if (RED_SWEEP_INDEX.length < rcount) {
	                            pool.free(RED_SWEEP_INDEX);
	                            RED_SWEEP_INDEX = pool.mallocInt32(rcount);
	                          }
	                          if (BLUE_SWEEP_QUEUE.length < rcount) {
	                            pool.free(BLUE_SWEEP_QUEUE);
	                            BLUE_SWEEP_QUEUE = pool.mallocInt32(rcount);
	                          }
	                          if (BLUE_SWEEP_INDEX.length < rcount) {
	                            pool.free(BLUE_SWEEP_INDEX);
	                            BLUE_SWEEP_INDEX = pool.mallocInt32(rcount);
	                          }
	                          if (COMMON_SWEEP_QUEUE.length < rcount) {
	                            pool.free(COMMON_SWEEP_QUEUE);
	                            COMMON_SWEEP_QUEUE = pool.mallocInt32(rcount);
	                          }
	                          if (COMMON_SWEEP_INDEX.length < rcount) {
	                            pool.free(COMMON_SWEEP_INDEX);
	                            COMMON_SWEEP_INDEX = pool.mallocInt32(rcount);
	                          }
	                          var eventLength = 8 * rcount;
	                          if (SWEEP_EVENTS.length < eventLength) {
	                            pool.free(SWEEP_EVENTS);
	                            SWEEP_EVENTS = pool.mallocDouble(eventLength);
	                          }
	                        }
	                        function sqPop(queue, index, count, item) {
	                          var idx = index[item];
	                          var top = queue[count - 1];
	                          queue[idx] = top;
	                          index[top] = idx;
	                        }
	                        function sqPush(queue, index, count, item) {
	                          queue[count] = item;
	                          index[item] = count;
	                        }
	                        function sweepBipartite(d, visit, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex) {
	                          var ptr = 0;
	                          var elemSize = 2 * d;
	                          var istart = d - 1;
	                          var iend = elemSize - 1;
	                          for (var i = redStart; i < redEnd; ++i) {
	                            var idx = redIndex[i];
	                            var redOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -(idx + 1);
	                            SWEEP_EVENTS[ptr++] = red[redOffset + iend];
	                            SWEEP_EVENTS[ptr++] = idx;
	                          }
	                          for (var i = blueStart; i < blueEnd; ++i) {
	                            var idx = blueIndex[i] + BLUE_FLAG;
	                            var blueOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = blue[blueOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx;
	                            SWEEP_EVENTS[ptr++] = blue[blueOffset + iend];
	                            SWEEP_EVENTS[ptr++] = idx;
	                          }
	                          var n = ptr >>> 1;
	                          isort(SWEEP_EVENTS, n);
	                          var redActive = 0;
	                          var blueActive = 0;
	                          for (var i = 0; i < n; ++i) {
	                            var e = SWEEP_EVENTS[2 * i + 1] | 0;
	                            if (e >= BLUE_FLAG) {
	                              e = e - BLUE_FLAG | 0;
	                              sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, e);
	                            } else if (e >= 0) {
	                              sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e);
	                            } else if (e <= -268435456) {
	                              e = -e - BLUE_FLAG | 0;
	                              for (var j = 0; j < redActive; ++j) {
	                                var retval = visit(RED_SWEEP_QUEUE[j], e);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                              }
	                              sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, e);
	                            } else {
	                              e = -e - 1 | 0;
	                              for (var j = 0; j < blueActive; ++j) {
	                                var retval = visit(e, BLUE_SWEEP_QUEUE[j]);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                              }
	                              sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, e);
	                            }
	                          }
	                        }
	                        function sweepComplete(d, visit, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex) {
	                          var ptr = 0;
	                          var elemSize = 2 * d;
	                          var istart = d - 1;
	                          var iend = elemSize - 1;
	                          for (var i = redStart; i < redEnd; ++i) {
	                            var idx = redIndex[i] + 1 << 1;
	                            var redOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + iend];
	                            SWEEP_EVENTS[ptr++] = idx;
	                          }
	                          for (var i = blueStart; i < blueEnd; ++i) {
	                            var idx = blueIndex[i] + 1 << 1;
	                            var blueOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = blue[blueOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx | 1;
	                            SWEEP_EVENTS[ptr++] = blue[blueOffset + iend];
	                            SWEEP_EVENTS[ptr++] = idx | 1;
	                          }
	                          var n = ptr >>> 1;
	                          isort(SWEEP_EVENTS, n);
	                          var redActive = 0;
	                          var blueActive = 0;
	                          var commonActive = 0;
	                          for (var i = 0; i < n; ++i) {
	                            var e = SWEEP_EVENTS[2 * i + 1] | 0;
	                            var color = e & 1;
	                            if (i < n - 1 && e >> 1 === SWEEP_EVENTS[2 * i + 3] >> 1) {
	                              color = 2;
	                              i += 1;
	                            }
	                            if (e < 0) {
	                              var id = -(e >> 1) - 1;
	                              for (var j = 0; j < commonActive; ++j) {
	                                var retval = visit(COMMON_SWEEP_QUEUE[j], id);
	                                if (retval !== undefined) {
	                                  return retval;
	                                }
	                              }
	                              if (color !== 0) {
	                                for (var j = 0; j < redActive; ++j) {
	                                  var retval = visit(RED_SWEEP_QUEUE[j], id);
	                                  if (retval !== undefined) {
	                                    return retval;
	                                  }
	                                }
	                              }
	                              if (color !== 1) {
	                                for (var j = 0; j < blueActive; ++j) {
	                                  var retval = visit(BLUE_SWEEP_QUEUE[j], id);
	                                  if (retval !== undefined) {
	                                    return retval;
	                                  }
	                                }
	                              }
	                              if (color === 0) {
	                                sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, id);
	                              } else if (color === 1) {
	                                sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, id);
	                              } else if (color === 2) {
	                                sqPush(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive++, id);
	                              }
	                            } else {
	                              var id = (e >> 1) - 1;
	                              if (color === 0) {
	                                sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, id);
	                              } else if (color === 1) {
	                                sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, id);
	                              } else if (color === 2) {
	                                sqPop(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive--, id);
	                              }
	                            }
	                          }
	                        }
	                        function scanBipartite(d, axis, visit, flip, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex) {
	                          var ptr = 0;
	                          var elemSize = 2 * d;
	                          var istart = axis;
	                          var iend = axis + d;
	                          var redShift = 1;
	                          var blueShift = 1;
	                          if (flip) {
	                            blueShift = BLUE_FLAG;
	                          } else {
	                            redShift = BLUE_FLAG;
	                          }
	                          for (var i = redStart; i < redEnd; ++i) {
	                            var idx = i + redShift;
	                            var redOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + iend];
	                            SWEEP_EVENTS[ptr++] = idx;
	                          }
	                          for (var i = blueStart; i < blueEnd; ++i) {
	                            var idx = i + blueShift;
	                            var blueOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = blue[blueOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx;
	                          }
	                          var n = ptr >>> 1;
	                          isort(SWEEP_EVENTS, n);
	                          var redActive = 0;
	                          for (var i = 0; i < n; ++i) {
	                            var e = SWEEP_EVENTS[2 * i + 1] | 0;
	                            if (e < 0) {
	                              var idx = -e;
	                              var isRed = false;
	                              if (idx >= BLUE_FLAG) {
	                                isRed = !flip;
	                                idx -= BLUE_FLAG;
	                              } else {
	                                isRed = !!flip;
	                                idx -= 1;
	                              }
	                              if (isRed) {
	                                sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, idx);
	                              } else {
	                                var blueId = blueIndex[idx];
	                                var bluePtr = elemSize * idx;
	                                var b0 = blue[bluePtr + axis + 1];
	                                var b1 = blue[bluePtr + axis + 1 + d];
	                                red_loop: for (var j = 0; j < redActive; ++j) {
	                                  var oidx = RED_SWEEP_QUEUE[j];
	                                  var redPtr = elemSize * oidx;
	                                  if (b1 < red[redPtr + axis + 1] || red[redPtr + axis + 1 + d] < b0) {
	                                    continue;
	                                  }
	                                  for (var k = axis + 2; k < d; ++k) {
	                                    if (blue[bluePtr + k + d] < red[redPtr + k] || red[redPtr + k + d] < blue[bluePtr + k]) {
	                                      continue red_loop;
	                                    }
	                                  }
	                                  var redId = redIndex[oidx];
	                                  var retval;
	                                  if (flip) {
	                                    retval = visit(blueId, redId);
	                                  } else {
	                                    retval = visit(redId, blueId);
	                                  }
	                                  if (retval !== undefined) {
	                                    return retval;
	                                  }
	                                }
	                              }
	                            } else {
	                              sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e - redShift);
	                            }
	                          }
	                        }
	                        function scanComplete(d, axis, visit, redStart, redEnd, red, redIndex, blueStart, blueEnd, blue, blueIndex) {
	                          var ptr = 0;
	                          var elemSize = 2 * d;
	                          var istart = axis;
	                          var iend = axis + d;
	                          for (var i = redStart; i < redEnd; ++i) {
	                            var idx = i + BLUE_FLAG;
	                            var redOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx;
	                            SWEEP_EVENTS[ptr++] = red[redOffset + iend];
	                            SWEEP_EVENTS[ptr++] = idx;
	                          }
	                          for (var i = blueStart; i < blueEnd; ++i) {
	                            var idx = i + 1;
	                            var blueOffset = elemSize * i;
	                            SWEEP_EVENTS[ptr++] = blue[blueOffset + istart];
	                            SWEEP_EVENTS[ptr++] = -idx;
	                          }
	                          var n = ptr >>> 1;
	                          isort(SWEEP_EVENTS, n);
	                          var redActive = 0;
	                          for (var i = 0; i < n; ++i) {
	                            var e = SWEEP_EVENTS[2 * i + 1] | 0;
	                            if (e < 0) {
	                              var idx = -e;
	                              if (idx >= BLUE_FLAG) {
	                                RED_SWEEP_QUEUE[redActive++] = idx - BLUE_FLAG;
	                              } else {
	                                idx -= 1;
	                                var blueId = blueIndex[idx];
	                                var bluePtr = elemSize * idx;
	                                var b0 = blue[bluePtr + axis + 1];
	                                var b1 = blue[bluePtr + axis + 1 + d];
	                                red_loop: for (var j = 0; j < redActive; ++j) {
	                                  var oidx = RED_SWEEP_QUEUE[j];
	                                  var redId = redIndex[oidx];
	                                  if (redId === blueId) {
	                                    break;
	                                  }
	                                  var redPtr = elemSize * oidx;
	                                  if (b1 < red[redPtr + axis + 1] || red[redPtr + axis + 1 + d] < b0) {
	                                    continue;
	                                  }
	                                  for (var k = axis + 2; k < d; ++k) {
	                                    if (blue[bluePtr + k + d] < red[redPtr + k] || red[redPtr + k + d] < blue[bluePtr + k]) {
	                                      continue red_loop;
	                                    }
	                                  }
	                                  var retval = visit(redId, blueId);
	                                  if (retval !== undefined) {
	                                    return retval;
	                                  }
	                                }
	                              }
	                            } else {
	                              var idx = e - BLUE_FLAG;
	                              for (var j = redActive - 1; j >= 0; --j) {
	                                if (RED_SWEEP_QUEUE[j] === idx) {
	                                  for (var k = j + 1; k < redActive; ++k) {
	                                    RED_SWEEP_QUEUE[k - 1] = RED_SWEEP_QUEUE[k];
	                                  }
	                                  break;
	                                }
	                              }
	                              --redActive;
	                            }
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    7761: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_168442__) {
	                        var monotoneTriangulate = __nested_webpack_require_168442__(9971);
	                        var makeIndex = __nested_webpack_require_168442__(743);
	                        var delaunayFlip = __nested_webpack_require_168442__(2161);
	                        var filterTriangulation = __nested_webpack_require_168442__(7098);
	                        module3.exports = cdt2d;
	                        function canonicalizeEdge(e) {
	                          return [Math.min(e[0], e[1]), Math.max(e[0], e[1])];
	                        }
	                        function compareEdge(a, b) {
	                          return a[0] - b[0] || a[1] - b[1];
	                        }
	                        function canonicalizeEdges(edges) {
	                          return edges.map(canonicalizeEdge).sort(compareEdge);
	                        }
	                        function getDefault(options, property, dflt) {
	                          if (property in options) {
	                            return options[property];
	                          }
	                          return dflt;
	                        }
	                        function cdt2d(points, edges, options) {
	                          if (!Array.isArray(edges)) {
	                            options = edges || {};
	                            edges = [];
	                          } else {
	                            options = options || {};
	                            edges = edges || [];
	                          }
	                          var delaunay = !!getDefault(options, "delaunay", true);
	                          var interior = !!getDefault(options, "interior", true);
	                          var exterior = !!getDefault(options, "exterior", true);
	                          var infinity = !!getDefault(options, "infinity", false);
	                          if (!interior && !exterior || points.length === 0) {
	                            return [];
	                          }
	                          var cells = monotoneTriangulate(points, edges);
	                          if (delaunay || interior !== exterior || infinity) {
	                            var triangulation = makeIndex(points.length, canonicalizeEdges(edges));
	                            for (var i = 0; i < cells.length; ++i) {
	                              var f = cells[i];
	                              triangulation.addTriangle(f[0], f[1], f[2]);
	                            }
	                            if (delaunay) {
	                              delaunayFlip(points, triangulation);
	                            }
	                            if (!exterior) {
	                              return filterTriangulation(triangulation, -1);
	                            } else if (!interior) {
	                              return filterTriangulation(triangulation, 1, infinity);
	                            } else if (infinity) {
	                              return filterTriangulation(triangulation, 0, infinity);
	                            } else {
	                              return triangulation.cells();
	                            }
	                          } else {
	                            return cells;
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    2161: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_170262__) {
	                        var inCircle = __nested_webpack_require_170262__(2227)[4];
	                        __nested_webpack_require_170262__(5070);
	                        module3.exports = delaunayRefine;
	                        function testFlip(points, triangulation, stack, a, b, x) {
	                          var y = triangulation.opposite(a, b);
	                          if (y < 0) {
	                            return;
	                          }
	                          if (b < a) {
	                            var tmp = a;
	                            a = b;
	                            b = tmp;
	                            tmp = x;
	                            x = y;
	                            y = tmp;
	                          }
	                          if (triangulation.isConstraint(a, b)) {
	                            return;
	                          }
	                          if (inCircle(points[a], points[b], points[x], points[y]) < 0) {
	                            stack.push(a, b);
	                          }
	                        }
	                        function delaunayRefine(points, triangulation) {
	                          var stack = [];
	                          var numPoints = points.length;
	                          var stars = triangulation.stars;
	                          for (var a = 0; a < numPoints; ++a) {
	                            var star = stars[a];
	                            for (var j = 1; j < star.length; j += 2) {
	                              var b = star[j];
	                              if (b < a) {
	                                continue;
	                              }
	                              if (triangulation.isConstraint(a, b)) {
	                                continue;
	                              }
	                              var x = star[j - 1], y = -1;
	                              for (var k = 1; k < star.length; k += 2) {
	                                if (star[k - 1] === b) {
	                                  y = star[k];
	                                  break;
	                                }
	                              }
	                              if (y < 0) {
	                                continue;
	                              }
	                              if (inCircle(points[a], points[b], points[x], points[y]) < 0) {
	                                stack.push(a, b);
	                              }
	                            }
	                          }
	                          while (stack.length > 0) {
	                            var b = stack.pop();
	                            var a = stack.pop();
	                            var x = -1, y = -1;
	                            var star = stars[a];
	                            for (var i = 1; i < star.length; i += 2) {
	                              var s = star[i - 1];
	                              var t = star[i];
	                              if (s === b) {
	                                y = t;
	                              } else if (t === b) {
	                                x = s;
	                              }
	                            }
	                            if (x < 0 || y < 0) {
	                              continue;
	                            }
	                            if (inCircle(points[a], points[b], points[x], points[y]) >= 0) {
	                              continue;
	                            }
	                            triangulation.flip(a, b);
	                            testFlip(points, triangulation, stack, x, a, y);
	                            testFlip(points, triangulation, stack, a, y, x);
	                            testFlip(points, triangulation, stack, y, b, x);
	                            testFlip(points, triangulation, stack, b, x, y);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    7098: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_172147__) {
	                        var bsearch = __nested_webpack_require_172147__(5070);
	                        module3.exports = classifyFaces;
	                        function FaceIndex(cells, neighbor, constraint, flags, active, next, boundary) {
	                          this.cells = cells;
	                          this.neighbor = neighbor;
	                          this.flags = flags;
	                          this.constraint = constraint;
	                          this.active = active;
	                          this.next = next;
	                          this.boundary = boundary;
	                        }
	                        var proto = FaceIndex.prototype;
	                        function compareCell(a, b) {
	                          return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
	                        }
	                        proto.locate = /* @__PURE__ */ function() {
	                          var key = [0, 0, 0];
	                          return function(a, b, c) {
	                            var x = a, y = b, z = c;
	                            if (b < c) {
	                              if (b < a) {
	                                x = b;
	                                y = c;
	                                z = a;
	                              }
	                            } else if (c < a) {
	                              x = c;
	                              y = a;
	                              z = b;
	                            }
	                            if (x < 0) {
	                              return -1;
	                            }
	                            key[0] = x;
	                            key[1] = y;
	                            key[2] = z;
	                            return bsearch.eq(this.cells, key, compareCell);
	                          };
	                        }();
	                        function indexCells(triangulation, infinity) {
	                          var cells = triangulation.cells();
	                          var nc = cells.length;
	                          for (var i = 0; i < nc; ++i) {
	                            var c = cells[i];
	                            var x = c[0], y = c[1], z = c[2];
	                            if (y < z) {
	                              if (y < x) {
	                                c[0] = y;
	                                c[1] = z;
	                                c[2] = x;
	                              }
	                            } else if (z < x) {
	                              c[0] = z;
	                              c[1] = x;
	                              c[2] = y;
	                            }
	                          }
	                          cells.sort(compareCell);
	                          var flags = new Array(nc);
	                          for (var i = 0; i < flags.length; ++i) {
	                            flags[i] = 0;
	                          }
	                          var active = [];
	                          var next = [];
	                          var neighbor = new Array(3 * nc);
	                          var constraint = new Array(3 * nc);
	                          var boundary = null;
	                          if (infinity) {
	                            boundary = [];
	                          }
	                          var index = new FaceIndex(cells, neighbor, constraint, flags, active, next, boundary);
	                          for (var i = 0; i < nc; ++i) {
	                            var c = cells[i];
	                            for (var j = 0; j < 3; ++j) {
	                              var x = c[j], y = c[(j + 1) % 3];
	                              var a = neighbor[3 * i + j] = index.locate(y, x, triangulation.opposite(y, x));
	                              var b = constraint[3 * i + j] = triangulation.isConstraint(x, y);
	                              if (a < 0) {
	                                if (b) {
	                                  next.push(i);
	                                } else {
	                                  active.push(i);
	                                  flags[i] = 1;
	                                }
	                                if (infinity) {
	                                  boundary.push([y, x, -1]);
	                                }
	                              }
	                            }
	                          }
	                          return index;
	                        }
	                        function filterCells(cells, flags, target) {
	                          var ptr = 0;
	                          for (var i = 0; i < cells.length; ++i) {
	                            if (flags[i] === target) {
	                              cells[ptr++] = cells[i];
	                            }
	                          }
	                          cells.length = ptr;
	                          return cells;
	                        }
	                        function classifyFaces(triangulation, target, infinity) {
	                          var index = indexCells(triangulation, infinity);
	                          if (target === 0) {
	                            if (infinity) {
	                              return index.cells.concat(index.boundary);
	                            } else {
	                              return index.cells;
	                            }
	                          }
	                          var side = 1;
	                          var active = index.active;
	                          var next = index.next;
	                          var flags = index.flags;
	                          var cells = index.cells;
	                          var constraint = index.constraint;
	                          var neighbor = index.neighbor;
	                          while (active.length > 0 || next.length > 0) {
	                            while (active.length > 0) {
	                              var t = active.pop();
	                              if (flags[t] === -side) {
	                                continue;
	                              }
	                              flags[t] = side;
	                              cells[t];
	                              for (var j = 0; j < 3; ++j) {
	                                var f = neighbor[3 * t + j];
	                                if (f >= 0 && flags[f] === 0) {
	                                  if (constraint[3 * t + j]) {
	                                    next.push(f);
	                                  } else {
	                                    active.push(f);
	                                    flags[f] = side;
	                                  }
	                                }
	                              }
	                            }
	                            var tmp = next;
	                            next = active;
	                            active = tmp;
	                            next.length = 0;
	                            side = -side;
	                          }
	                          var result = filterCells(cells, flags, target);
	                          if (infinity) {
	                            return result.concat(index.boundary);
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    9971: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_174798__) {
	                        var bsearch = __nested_webpack_require_174798__(5070);
	                        var orient = __nested_webpack_require_174798__(417)[3];
	                        var EVENT_POINT = 0;
	                        var EVENT_END = 1;
	                        var EVENT_START = 2;
	                        module3.exports = monotoneTriangulate;
	                        function PartialHull(a, b, idx, lowerIds, upperIds) {
	                          this.a = a;
	                          this.b = b;
	                          this.idx = idx;
	                          this.lowerIds = lowerIds;
	                          this.upperIds = upperIds;
	                        }
	                        function Event(a, b, type, idx) {
	                          this.a = a;
	                          this.b = b;
	                          this.type = type;
	                          this.idx = idx;
	                        }
	                        function compareEvent(a, b) {
	                          var d = a.a[0] - b.a[0] || a.a[1] - b.a[1] || a.type - b.type;
	                          if (d) {
	                            return d;
	                          }
	                          if (a.type !== EVENT_POINT) {
	                            d = orient(a.a, a.b, b.b);
	                            if (d) {
	                              return d;
	                            }
	                          }
	                          return a.idx - b.idx;
	                        }
	                        function testPoint(hull, p) {
	                          return orient(hull.a, hull.b, p);
	                        }
	                        function addPoint(cells, hulls, points, p, idx) {
	                          var lo = bsearch.lt(hulls, p, testPoint);
	                          var hi = bsearch.gt(hulls, p, testPoint);
	                          for (var i = lo; i < hi; ++i) {
	                            var hull = hulls[i];
	                            var lowerIds = hull.lowerIds;
	                            var m = lowerIds.length;
	                            while (m > 1 && orient(points[lowerIds[m - 2]], points[lowerIds[m - 1]], p) > 0) {
	                              cells.push([lowerIds[m - 1], lowerIds[m - 2], idx]);
	                              m -= 1;
	                            }
	                            lowerIds.length = m;
	                            lowerIds.push(idx);
	                            var upperIds = hull.upperIds;
	                            var m = upperIds.length;
	                            while (m > 1 && orient(points[upperIds[m - 2]], points[upperIds[m - 1]], p) < 0) {
	                              cells.push([upperIds[m - 2], upperIds[m - 1], idx]);
	                              m -= 1;
	                            }
	                            upperIds.length = m;
	                            upperIds.push(idx);
	                          }
	                        }
	                        function findSplit(hull, edge) {
	                          var d;
	                          if (hull.a[0] < edge.a[0]) {
	                            d = orient(hull.a, hull.b, edge.a);
	                          } else {
	                            d = orient(edge.b, edge.a, hull.a);
	                          }
	                          if (d) {
	                            return d;
	                          }
	                          if (edge.b[0] < hull.b[0]) {
	                            d = orient(hull.a, hull.b, edge.b);
	                          } else {
	                            d = orient(edge.b, edge.a, hull.b);
	                          }
	                          return d || hull.idx - edge.idx;
	                        }
	                        function splitHulls(hulls, points, event) {
	                          var splitIdx = bsearch.le(hulls, event, findSplit);
	                          var hull = hulls[splitIdx];
	                          var upperIds = hull.upperIds;
	                          var x = upperIds[upperIds.length - 1];
	                          hull.upperIds = [x];
	                          hulls.splice(splitIdx + 1, 0, new PartialHull(event.a, event.b, event.idx, [x], upperIds));
	                        }
	                        function mergeHulls(hulls, points, event) {
	                          var tmp = event.a;
	                          event.a = event.b;
	                          event.b = tmp;
	                          var mergeIdx = bsearch.eq(hulls, event, findSplit);
	                          var upper = hulls[mergeIdx];
	                          var lower = hulls[mergeIdx - 1];
	                          lower.upperIds = upper.upperIds;
	                          hulls.splice(mergeIdx, 1);
	                        }
	                        function monotoneTriangulate(points, edges) {
	                          var numPoints = points.length;
	                          var numEdges = edges.length;
	                          var events = [];
	                          for (var i = 0; i < numPoints; ++i) {
	                            events.push(new Event(points[i], null, EVENT_POINT, i));
	                          }
	                          for (var i = 0; i < numEdges; ++i) {
	                            var e = edges[i];
	                            var a = points[e[0]];
	                            var b = points[e[1]];
	                            if (a[0] < b[0]) {
	                              events.push(new Event(a, b, EVENT_START, i), new Event(b, a, EVENT_END, i));
	                            } else if (a[0] > b[0]) {
	                              events.push(new Event(b, a, EVENT_START, i), new Event(a, b, EVENT_END, i));
	                            }
	                          }
	                          events.sort(compareEvent);
	                          var minX = events[0].a[0] - (1 + Math.abs(events[0].a[0])) * Math.pow(2, -52);
	                          var hull = [new PartialHull([minX, 1], [minX, 0], -1, [], [])];
	                          var cells = [];
	                          for (var i = 0, numEvents = events.length; i < numEvents; ++i) {
	                            var event = events[i];
	                            var type = event.type;
	                            if (type === EVENT_POINT) {
	                              addPoint(cells, hull, points, event.a, event.idx);
	                            } else if (type === EVENT_START) {
	                              splitHulls(hull, points, event);
	                            } else {
	                              mergeHulls(hull, points, event);
	                            }
	                          }
	                          return cells;
	                        }
	                      }
	                    ),
	                    /***/
	                    743: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_178277__) {
	                        var bsearch = __nested_webpack_require_178277__(5070);
	                        module3.exports = createTriangulation;
	                        function Triangulation(stars, edges) {
	                          this.stars = stars;
	                          this.edges = edges;
	                        }
	                        var proto = Triangulation.prototype;
	                        function removePair(list, j, k) {
	                          for (var i = 1, n = list.length; i < n; i += 2) {
	                            if (list[i - 1] === j && list[i] === k) {
	                              list[i - 1] = list[n - 2];
	                              list[i] = list[n - 1];
	                              list.length = n - 2;
	                              return;
	                            }
	                          }
	                        }
	                        proto.isConstraint = /* @__PURE__ */ function() {
	                          var e = [0, 0];
	                          function compareLex(a, b) {
	                            return a[0] - b[0] || a[1] - b[1];
	                          }
	                          return function(i, j) {
	                            e[0] = Math.min(i, j);
	                            e[1] = Math.max(i, j);
	                            return bsearch.eq(this.edges, e, compareLex) >= 0;
	                          };
	                        }();
	                        proto.removeTriangle = function(i, j, k) {
	                          var stars = this.stars;
	                          removePair(stars[i], j, k);
	                          removePair(stars[j], k, i);
	                          removePair(stars[k], i, j);
	                        };
	                        proto.addTriangle = function(i, j, k) {
	                          var stars = this.stars;
	                          stars[i].push(j, k);
	                          stars[j].push(k, i);
	                          stars[k].push(i, j);
	                        };
	                        proto.opposite = function(j, i) {
	                          var list = this.stars[i];
	                          for (var k = 1, n = list.length; k < n; k += 2) {
	                            if (list[k] === j) {
	                              return list[k - 1];
	                            }
	                          }
	                          return -1;
	                        };
	                        proto.flip = function(i, j) {
	                          var a = this.opposite(i, j);
	                          var b = this.opposite(j, i);
	                          this.removeTriangle(i, j, a);
	                          this.removeTriangle(j, i, b);
	                          this.addTriangle(i, b, a);
	                          this.addTriangle(j, a, b);
	                        };
	                        proto.edges = function() {
	                          var stars = this.stars;
	                          var result = [];
	                          for (var i = 0, n = stars.length; i < n; ++i) {
	                            var list = stars[i];
	                            for (var j = 0, m = list.length; j < m; j += 2) {
	                              result.push([list[j], list[j + 1]]);
	                            }
	                          }
	                          return result;
	                        };
	                        proto.cells = function() {
	                          var stars = this.stars;
	                          var result = [];
	                          for (var i = 0, n = stars.length; i < n; ++i) {
	                            var list = stars[i];
	                            for (var j = 0, m = list.length; j < m; j += 2) {
	                              var s = list[j];
	                              var t = list[j + 1];
	                              if (i < Math.min(s, t)) {
	                                result.push([i, s, t]);
	                              }
	                            }
	                          }
	                          return result;
	                        };
	                        function createTriangulation(numVerts, edges) {
	                          var stars = new Array(numVerts);
	                          for (var i = 0; i < numVerts; ++i) {
	                            stars[i] = [];
	                          }
	                          return new Triangulation(stars, edges);
	                        }
	                      }
	                    ),
	                    /***/
	                    9887: (
	                      /***/
	                      function(module3) {
	                        module3.exports = orientation;
	                        function orientation(s) {
	                          var p = 1;
	                          for (var i = 1; i < s.length; ++i) {
	                            for (var j = 0; j < i; ++j) {
	                              if (s[i] < s[j]) {
	                                p = -p;
	                              } else if (s[j] === s[i]) {
	                                return 0;
	                              }
	                            }
	                          }
	                          return p;
	                        }
	                      }
	                    ),
	                    /***/
	                    9243: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_180297__) {
	                        var dup = __nested_webpack_require_180297__(3094);
	                        var solve = __nested_webpack_require_180297__(6606);
	                        function dot(a, b) {
	                          var s = 0;
	                          var d = a.length;
	                          for (var i = 0; i < d; ++i) {
	                            s += a[i] * b[i];
	                          }
	                          return s;
	                        }
	                        function barycentricCircumcenter(points) {
	                          var N = points.length;
	                          if (N === 0) {
	                            return [];
	                          }
	                          points[0].length;
	                          var A = dup([points.length + 1, points.length + 1], 1);
	                          var b = dup([points.length + 1], 1);
	                          A[N][N] = 0;
	                          for (var i = 0; i < N; ++i) {
	                            for (var j = 0; j <= i; ++j) {
	                              A[j][i] = A[i][j] = 2 * dot(points[i], points[j]);
	                            }
	                            b[i] = dot(points[i], points[i]);
	                          }
	                          var x = solve(A, b);
	                          var denom = 0;
	                          var h = x[N + 1];
	                          for (var i = 0; i < h.length; ++i) {
	                            denom += h[i];
	                          }
	                          var y = new Array(N);
	                          for (var i = 0; i < N; ++i) {
	                            var h = x[i];
	                            var numer = 0;
	                            for (var j = 0; j < h.length; ++j) {
	                              numer += h[j];
	                            }
	                            y[i] = numer / denom;
	                          }
	                          return y;
	                        }
	                        function circumcenter(points) {
	                          if (points.length === 0) {
	                            return [];
	                          }
	                          var D = points[0].length;
	                          var result = dup([D]);
	                          var weights = barycentricCircumcenter(points);
	                          for (var i = 0; i < points.length; ++i) {
	                            for (var j = 0; j < D; ++j) {
	                              result[j] += points[i][j] * weights[i];
	                            }
	                          }
	                          return result;
	                        }
	                        circumcenter.barycenetric = barycentricCircumcenter;
	                        module3.exports = circumcenter;
	                      }
	                    ),
	                    /***/
	                    1778: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_181422__) {
	                        module3.exports = circumradius;
	                        var circumcenter = __nested_webpack_require_181422__(9243);
	                        function circumradius(points) {
	                          var center = circumcenter(points);
	                          var avgDist = 0;
	                          for (var i = 0; i < points.length; ++i) {
	                            var p = points[i];
	                            for (var j = 0; j < center.length; ++j) {
	                              avgDist += Math.pow(p[j] - center[j], 2);
	                            }
	                          }
	                          return Math.sqrt(avgDist / points.length);
	                        }
	                      }
	                    ),
	                    /***/
	                    197: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_181815__) {
	                        module3.exports = cleanPSLG;
	                        var UnionFind = __nested_webpack_require_181815__(1731);
	                        var boxIntersect = __nested_webpack_require_181815__(2569);
	                        var segseg = __nested_webpack_require_181815__(4434);
	                        var rat = __nested_webpack_require_181815__(5125);
	                        var ratCmp = __nested_webpack_require_181815__(8846);
	                        var ratToFloat = __nested_webpack_require_181815__(7999);
	                        var ratVec = __nested_webpack_require_181815__(2826);
	                        var nextafter = __nested_webpack_require_181815__(8551);
	                        var solveIntersection = __nested_webpack_require_181815__(5528);
	                        function boundRat(r) {
	                          var f = ratToFloat(r);
	                          return [nextafter(f, -Infinity), nextafter(f, Infinity)];
	                        }
	                        function boundEdges(points, edges) {
	                          var bounds = new Array(edges.length);
	                          for (var i = 0; i < edges.length; ++i) {
	                            var e = edges[i];
	                            var a = points[e[0]];
	                            var b = points[e[1]];
	                            bounds[i] = [nextafter(Math.min(a[0], b[0]), -Infinity), nextafter(Math.min(a[1], b[1]), -Infinity), nextafter(Math.max(a[0], b[0]), Infinity), nextafter(Math.max(a[1], b[1]), Infinity)];
	                          }
	                          return bounds;
	                        }
	                        function boundPoints(points) {
	                          var bounds = new Array(points.length);
	                          for (var i = 0; i < points.length; ++i) {
	                            var p = points[i];
	                            bounds[i] = [nextafter(p[0], -Infinity), nextafter(p[1], -Infinity), nextafter(p[0], Infinity), nextafter(p[1], Infinity)];
	                          }
	                          return bounds;
	                        }
	                        function getCrossings(points, edges, edgeBounds) {
	                          var result = [];
	                          boxIntersect(edgeBounds, function(i, j) {
	                            var e = edges[i];
	                            var f = edges[j];
	                            if (e[0] === f[0] || e[0] === f[1] || e[1] === f[0] || e[1] === f[1]) {
	                              return;
	                            }
	                            var a = points[e[0]];
	                            var b = points[e[1]];
	                            var c = points[f[0]];
	                            var d = points[f[1]];
	                            if (segseg(a, b, c, d)) {
	                              result.push([i, j]);
	                            }
	                          });
	                          return result;
	                        }
	                        function getTJunctions(points, edges, edgeBounds, vertBounds) {
	                          var result = [];
	                          boxIntersect(edgeBounds, vertBounds, function(i, v) {
	                            var e = edges[i];
	                            if (e[0] === v || e[1] === v) {
	                              return;
	                            }
	                            var p = points[v];
	                            var a = points[e[0]];
	                            var b = points[e[1]];
	                            if (segseg(a, b, p, p)) {
	                              result.push([i, v]);
	                            }
	                          });
	                          return result;
	                        }
	                        function cutEdges(floatPoints, edges, crossings, junctions, useColor) {
	                          var i, e;
	                          var ratPoints = floatPoints.map(function(p) {
	                            return [rat(p[0]), rat(p[1])];
	                          });
	                          for (i = 0; i < crossings.length; ++i) {
	                            var crossing = crossings[i];
	                            e = crossing[0];
	                            var f = crossing[1];
	                            var ee = edges[e];
	                            var ef = edges[f];
	                            var x = solveIntersection(ratVec(floatPoints[ee[0]]), ratVec(floatPoints[ee[1]]), ratVec(floatPoints[ef[0]]), ratVec(floatPoints[ef[1]]));
	                            if (!x) {
	                              continue;
	                            }
	                            var idx = floatPoints.length;
	                            floatPoints.push([ratToFloat(x[0]), ratToFloat(x[1])]);
	                            ratPoints.push(x);
	                            junctions.push([e, idx], [f, idx]);
	                          }
	                          junctions.sort(function(a2, b2) {
	                            if (a2[0] !== b2[0]) {
	                              return a2[0] - b2[0];
	                            }
	                            var u = ratPoints[a2[1]];
	                            var v = ratPoints[b2[1]];
	                            return ratCmp(u[0], v[0]) || ratCmp(u[1], v[1]);
	                          });
	                          for (i = junctions.length - 1; i >= 0; --i) {
	                            var junction = junctions[i];
	                            e = junction[0];
	                            var edge = edges[e];
	                            var s = edge[0];
	                            var t = edge[1];
	                            var a = floatPoints[s];
	                            var b = floatPoints[t];
	                            if ((a[0] - b[0] || a[1] - b[1]) < 0) {
	                              var tmp = s;
	                              s = t;
	                              t = tmp;
	                            }
	                            edge[0] = s;
	                            var last = edge[1] = junction[1];
	                            var color;
	                            if (useColor) {
	                              color = edge[2];
	                            }
	                            while (i > 0 && junctions[i - 1][0] === e) {
	                              var junction = junctions[--i];
	                              var next = junction[1];
	                              if (useColor) {
	                                edges.push([last, next, color]);
	                              } else {
	                                edges.push([last, next]);
	                              }
	                              last = next;
	                            }
	                            if (useColor) {
	                              edges.push([last, t, color]);
	                            } else {
	                              edges.push([last, t]);
	                            }
	                          }
	                          return ratPoints;
	                        }
	                        function dedupPoints(floatPoints, ratPoints, floatBounds) {
	                          var numPoints = ratPoints.length;
	                          var uf = new UnionFind(numPoints);
	                          var bounds = [];
	                          for (var i = 0; i < ratPoints.length; ++i) {
	                            var p = ratPoints[i];
	                            var xb = boundRat(p[0]);
	                            var yb = boundRat(p[1]);
	                            bounds.push([nextafter(xb[0], -Infinity), nextafter(yb[0], -Infinity), nextafter(xb[1], Infinity), nextafter(yb[1], Infinity)]);
	                          }
	                          boxIntersect(bounds, function(i2, j2) {
	                            uf.link(i2, j2);
	                          });
	                          var noDupes = true;
	                          var labels = new Array(numPoints);
	                          for (var i = 0; i < numPoints; ++i) {
	                            var j = uf.find(i);
	                            if (j !== i) {
	                              noDupes = false;
	                              floatPoints[j] = [Math.min(floatPoints[i][0], floatPoints[j][0]), Math.min(floatPoints[i][1], floatPoints[j][1])];
	                            }
	                          }
	                          if (noDupes) {
	                            return null;
	                          }
	                          var ptr = 0;
	                          for (var i = 0; i < numPoints; ++i) {
	                            var j = uf.find(i);
	                            if (j === i) {
	                              labels[i] = ptr;
	                              floatPoints[ptr++] = floatPoints[i];
	                            } else {
	                              labels[i] = -1;
	                            }
	                          }
	                          floatPoints.length = ptr;
	                          for (var i = 0; i < numPoints; ++i) {
	                            if (labels[i] < 0) {
	                              labels[i] = labels[uf.find(i)];
	                            }
	                          }
	                          return labels;
	                        }
	                        function compareLex2(a, b) {
	                          return a[0] - b[0] || a[1] - b[1];
	                        }
	                        function compareLex3(a, b) {
	                          var d = a[0] - b[0] || a[1] - b[1];
	                          if (d) {
	                            return d;
	                          }
	                          if (a[2] < b[2]) {
	                            return -1;
	                          } else if (a[2] > b[2]) {
	                            return 1;
	                          }
	                          return 0;
	                        }
	                        function dedupEdges(edges, labels, useColor) {
	                          if (edges.length === 0) {
	                            return;
	                          }
	                          if (labels) {
	                            for (var i = 0; i < edges.length; ++i) {
	                              var e = edges[i];
	                              var a = labels[e[0]];
	                              var b = labels[e[1]];
	                              e[0] = Math.min(a, b);
	                              e[1] = Math.max(a, b);
	                            }
	                          } else {
	                            for (var i = 0; i < edges.length; ++i) {
	                              var e = edges[i];
	                              var a = e[0];
	                              var b = e[1];
	                              e[0] = Math.min(a, b);
	                              e[1] = Math.max(a, b);
	                            }
	                          }
	                          if (useColor) {
	                            edges.sort(compareLex3);
	                          } else {
	                            edges.sort(compareLex2);
	                          }
	                          var ptr = 1;
	                          for (var i = 1; i < edges.length; ++i) {
	                            var prev = edges[i - 1];
	                            var next = edges[i];
	                            if (next[0] === prev[0] && next[1] === prev[1] && (!useColor || next[2] === prev[2])) {
	                              continue;
	                            }
	                            edges[ptr++] = next;
	                          }
	                          edges.length = ptr;
	                        }
	                        function preRound(points, edges, useColor) {
	                          var labels = dedupPoints(points, [], boundPoints(points));
	                          dedupEdges(edges, labels, useColor);
	                          return !!labels;
	                        }
	                        function snapRound(points, edges, useColor) {
	                          var edgeBounds = boundEdges(points, edges);
	                          var crossings = getCrossings(points, edges, edgeBounds);
	                          var vertBounds = boundPoints(points);
	                          var tjunctions = getTJunctions(points, edges, edgeBounds, vertBounds);
	                          var ratPoints = cutEdges(points, edges, crossings, tjunctions, useColor);
	                          var labels = dedupPoints(points, ratPoints);
	                          dedupEdges(edges, labels, useColor);
	                          if (!labels) {
	                            return crossings.length > 0 || tjunctions.length > 0;
	                          }
	                          return true;
	                        }
	                        function cleanPSLG(points, edges, colors) {
	                          var prevEdges;
	                          if (colors) {
	                            prevEdges = edges;
	                            var augEdges = new Array(edges.length);
	                            for (var i = 0; i < edges.length; ++i) {
	                              var e = edges[i];
	                              augEdges[i] = [e[0], e[1], colors[i]];
	                            }
	                            edges = augEdges;
	                          }
	                          var modified = preRound(points, edges, !!colors);
	                          while (snapRound(points, edges, !!colors)) {
	                            modified = true;
	                          }
	                          if (!!colors && modified) {
	                            prevEdges.length = 0;
	                            colors.length = 0;
	                            for (var i = 0; i < edges.length; ++i) {
	                              var e = edges[i];
	                              prevEdges.push([e[0], e[1]]);
	                              colors.push(e[2]);
	                            }
	                          }
	                          return modified;
	                        }
	                      }
	                    ),
	                    /***/
	                    5528: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_189208__) {
	                        module3.exports = solveIntersection;
	                        var ratMul = __nested_webpack_require_189208__(3962);
	                        var ratDiv = __nested_webpack_require_189208__(9189);
	                        var ratSub = __nested_webpack_require_189208__(4354);
	                        var ratSign = __nested_webpack_require_189208__(4951);
	                        var rvSub = __nested_webpack_require_189208__(6695);
	                        var rvAdd = __nested_webpack_require_189208__(7584);
	                        var rvMuls = __nested_webpack_require_189208__(4469);
	                        function ratPerp(a, b) {
	                          return ratSub(ratMul(a[0], b[1]), ratMul(a[1], b[0]));
	                        }
	                        function solveIntersection(a, b, c, d) {
	                          var ba = rvSub(b, a);
	                          var dc = rvSub(d, c);
	                          var baXdc = ratPerp(ba, dc);
	                          if (ratSign(baXdc) === 0) {
	                            return null;
	                          }
	                          var ac = rvSub(a, c);
	                          var dcXac = ratPerp(dc, ac);
	                          var t = ratDiv(dcXac, baXdc);
	                          var s = rvMuls(ba, t);
	                          var r = rvAdd(a, s);
	                          return r;
	                        }
	                      }
	                    ),
	                    /***/
	                    5692: (
	                      /***/
	                      function(module3) {
	                        module3.exports = { "jet": [{ "index": 0, "rgb": [0, 0, 131] }, { "index": 0.125, "rgb": [0, 60, 170] }, { "index": 0.375, "rgb": [5, 255, 255] }, { "index": 0.625, "rgb": [255, 255, 0] }, { "index": 0.875, "rgb": [250, 0, 0] }, { "index": 1, "rgb": [128, 0, 0] }], "hsv": [{ "index": 0, "rgb": [255, 0, 0] }, { "index": 0.169, "rgb": [253, 255, 2] }, { "index": 0.173, "rgb": [247, 255, 2] }, { "index": 0.337, "rgb": [0, 252, 4] }, { "index": 0.341, "rgb": [0, 252, 10] }, { "index": 0.506, "rgb": [1, 249, 255] }, { "index": 0.671, "rgb": [2, 0, 253] }, { "index": 0.675, "rgb": [8, 0, 253] }, { "index": 0.839, "rgb": [255, 0, 251] }, { "index": 0.843, "rgb": [255, 0, 245] }, { "index": 1, "rgb": [255, 0, 6] }], "hot": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 0.3, "rgb": [230, 0, 0] }, { "index": 0.6, "rgb": [255, 210, 0] }, { "index": 1, "rgb": [255, 255, 255] }], "spring": [{ "index": 0, "rgb": [255, 0, 255] }, { "index": 1, "rgb": [255, 255, 0] }], "summer": [{ "index": 0, "rgb": [0, 128, 102] }, { "index": 1, "rgb": [255, 255, 102] }], "autumn": [{ "index": 0, "rgb": [255, 0, 0] }, { "index": 1, "rgb": [255, 255, 0] }], "winter": [{ "index": 0, "rgb": [0, 0, 255] }, { "index": 1, "rgb": [0, 255, 128] }], "bone": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 0.376, "rgb": [84, 84, 116] }, { "index": 0.753, "rgb": [169, 200, 200] }, { "index": 1, "rgb": [255, 255, 255] }], "copper": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 0.804, "rgb": [255, 160, 102] }, { "index": 1, "rgb": [255, 199, 127] }], "greys": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 1, "rgb": [255, 255, 255] }], "yignbu": [{ "index": 0, "rgb": [8, 29, 88] }, { "index": 0.125, "rgb": [37, 52, 148] }, { "index": 0.25, "rgb": [34, 94, 168] }, { "index": 0.375, "rgb": [29, 145, 192] }, { "index": 0.5, "rgb": [65, 182, 196] }, { "index": 0.625, "rgb": [127, 205, 187] }, { "index": 0.75, "rgb": [199, 233, 180] }, { "index": 0.875, "rgb": [237, 248, 217] }, { "index": 1, "rgb": [255, 255, 217] }], "greens": [{ "index": 0, "rgb": [0, 68, 27] }, { "index": 0.125, "rgb": [0, 109, 44] }, { "index": 0.25, "rgb": [35, 139, 69] }, { "index": 0.375, "rgb": [65, 171, 93] }, { "index": 0.5, "rgb": [116, 196, 118] }, { "index": 0.625, "rgb": [161, 217, 155] }, { "index": 0.75, "rgb": [199, 233, 192] }, { "index": 0.875, "rgb": [229, 245, 224] }, { "index": 1, "rgb": [247, 252, 245] }], "yiorrd": [{ "index": 0, "rgb": [128, 0, 38] }, { "index": 0.125, "rgb": [189, 0, 38] }, { "index": 0.25, "rgb": [227, 26, 28] }, { "index": 0.375, "rgb": [252, 78, 42] }, { "index": 0.5, "rgb": [253, 141, 60] }, { "index": 0.625, "rgb": [254, 178, 76] }, { "index": 0.75, "rgb": [254, 217, 118] }, { "index": 0.875, "rgb": [255, 237, 160] }, { "index": 1, "rgb": [255, 255, 204] }], "bluered": [{ "index": 0, "rgb": [0, 0, 255] }, { "index": 1, "rgb": [255, 0, 0] }], "rdbu": [{ "index": 0, "rgb": [5, 10, 172] }, { "index": 0.35, "rgb": [106, 137, 247] }, { "index": 0.5, "rgb": [190, 190, 190] }, { "index": 0.6, "rgb": [220, 170, 132] }, { "index": 0.7, "rgb": [230, 145, 90] }, { "index": 1, "rgb": [178, 10, 28] }], "picnic": [{ "index": 0, "rgb": [0, 0, 255] }, { "index": 0.1, "rgb": [51, 153, 255] }, { "index": 0.2, "rgb": [102, 204, 255] }, { "index": 0.3, "rgb": [153, 204, 255] }, { "index": 0.4, "rgb": [204, 204, 255] }, { "index": 0.5, "rgb": [255, 255, 255] }, { "index": 0.6, "rgb": [255, 204, 255] }, { "index": 0.7, "rgb": [255, 153, 255] }, { "index": 0.8, "rgb": [255, 102, 204] }, { "index": 0.9, "rgb": [255, 102, 102] }, { "index": 1, "rgb": [255, 0, 0] }], "rainbow": [{ "index": 0, "rgb": [150, 0, 90] }, { "index": 0.125, "rgb": [0, 0, 200] }, { "index": 0.25, "rgb": [0, 25, 255] }, { "index": 0.375, "rgb": [0, 152, 255] }, { "index": 0.5, "rgb": [44, 255, 150] }, { "index": 0.625, "rgb": [151, 255, 0] }, { "index": 0.75, "rgb": [255, 234, 0] }, { "index": 0.875, "rgb": [255, 111, 0] }, { "index": 1, "rgb": [255, 0, 0] }], "portland": [{ "index": 0, "rgb": [12, 51, 131] }, { "index": 0.25, "rgb": [10, 136, 186] }, { "index": 0.5, "rgb": [242, 211, 56] }, { "index": 0.75, "rgb": [242, 143, 56] }, { "index": 1, "rgb": [217, 30, 30] }], "blackbody": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 0.2, "rgb": [230, 0, 0] }, { "index": 0.4, "rgb": [230, 210, 0] }, { "index": 0.7, "rgb": [255, 255, 255] }, { "index": 1, "rgb": [160, 200, 255] }], "earth": [{ "index": 0, "rgb": [0, 0, 130] }, { "index": 0.1, "rgb": [0, 180, 180] }, { "index": 0.2, "rgb": [40, 210, 40] }, { "index": 0.4, "rgb": [230, 230, 50] }, { "index": 0.6, "rgb": [120, 70, 20] }, { "index": 1, "rgb": [255, 255, 255] }], "electric": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 0.15, "rgb": [30, 0, 100] }, { "index": 0.4, "rgb": [120, 0, 100] }, { "index": 0.6, "rgb": [160, 90, 0] }, { "index": 0.8, "rgb": [230, 200, 0] }, { "index": 1, "rgb": [255, 250, 220] }], "alpha": [{ "index": 0, "rgb": [255, 255, 255, 0] }, { "index": 1, "rgb": [255, 255, 255, 1] }], "viridis": [{ "index": 0, "rgb": [68, 1, 84] }, { "index": 0.13, "rgb": [71, 44, 122] }, { "index": 0.25, "rgb": [59, 81, 139] }, { "index": 0.38, "rgb": [44, 113, 142] }, { "index": 0.5, "rgb": [33, 144, 141] }, { "index": 0.63, "rgb": [39, 173, 129] }, { "index": 0.75, "rgb": [92, 200, 99] }, { "index": 0.88, "rgb": [170, 220, 50] }, { "index": 1, "rgb": [253, 231, 37] }], "inferno": [{ "index": 0, "rgb": [0, 0, 4] }, { "index": 0.13, "rgb": [31, 12, 72] }, { "index": 0.25, "rgb": [85, 15, 109] }, { "index": 0.38, "rgb": [136, 34, 106] }, { "index": 0.5, "rgb": [186, 54, 85] }, { "index": 0.63, "rgb": [227, 89, 51] }, { "index": 0.75, "rgb": [249, 140, 10] }, { "index": 0.88, "rgb": [249, 201, 50] }, { "index": 1, "rgb": [252, 255, 164] }], "magma": [{ "index": 0, "rgb": [0, 0, 4] }, { "index": 0.13, "rgb": [28, 16, 68] }, { "index": 0.25, "rgb": [79, 18, 123] }, { "index": 0.38, "rgb": [129, 37, 129] }, { "index": 0.5, "rgb": [181, 54, 122] }, { "index": 0.63, "rgb": [229, 80, 100] }, { "index": 0.75, "rgb": [251, 135, 97] }, { "index": 0.88, "rgb": [254, 194, 135] }, { "index": 1, "rgb": [252, 253, 191] }], "plasma": [{ "index": 0, "rgb": [13, 8, 135] }, { "index": 0.13, "rgb": [75, 3, 161] }, { "index": 0.25, "rgb": [125, 3, 168] }, { "index": 0.38, "rgb": [168, 34, 150] }, { "index": 0.5, "rgb": [203, 70, 121] }, { "index": 0.63, "rgb": [229, 107, 93] }, { "index": 0.75, "rgb": [248, 148, 65] }, { "index": 0.88, "rgb": [253, 195, 40] }, { "index": 1, "rgb": [240, 249, 33] }], "warm": [{ "index": 0, "rgb": [125, 0, 179] }, { "index": 0.13, "rgb": [172, 0, 187] }, { "index": 0.25, "rgb": [219, 0, 170] }, { "index": 0.38, "rgb": [255, 0, 130] }, { "index": 0.5, "rgb": [255, 63, 74] }, { "index": 0.63, "rgb": [255, 123, 0] }, { "index": 0.75, "rgb": [234, 176, 0] }, { "index": 0.88, "rgb": [190, 228, 0] }, { "index": 1, "rgb": [147, 255, 0] }], "cool": [{ "index": 0, "rgb": [125, 0, 179] }, { "index": 0.13, "rgb": [116, 0, 218] }, { "index": 0.25, "rgb": [98, 74, 237] }, { "index": 0.38, "rgb": [68, 146, 231] }, { "index": 0.5, "rgb": [0, 204, 197] }, { "index": 0.63, "rgb": [0, 247, 146] }, { "index": 0.75, "rgb": [0, 255, 88] }, { "index": 0.88, "rgb": [40, 255, 8] }, { "index": 1, "rgb": [147, 255, 0] }], "rainbow-soft": [{ "index": 0, "rgb": [125, 0, 179] }, { "index": 0.1, "rgb": [199, 0, 180] }, { "index": 0.2, "rgb": [255, 0, 121] }, { "index": 0.3, "rgb": [255, 108, 0] }, { "index": 0.4, "rgb": [222, 194, 0] }, { "index": 0.5, "rgb": [150, 255, 0] }, { "index": 0.6, "rgb": [0, 255, 55] }, { "index": 0.7, "rgb": [0, 246, 150] }, { "index": 0.8, "rgb": [50, 167, 222] }, { "index": 0.9, "rgb": [103, 51, 235] }, { "index": 1, "rgb": [124, 0, 186] }], "bathymetry": [{ "index": 0, "rgb": [40, 26, 44] }, { "index": 0.13, "rgb": [59, 49, 90] }, { "index": 0.25, "rgb": [64, 76, 139] }, { "index": 0.38, "rgb": [63, 110, 151] }, { "index": 0.5, "rgb": [72, 142, 158] }, { "index": 0.63, "rgb": [85, 174, 163] }, { "index": 0.75, "rgb": [120, 206, 163] }, { "index": 0.88, "rgb": [187, 230, 172] }, { "index": 1, "rgb": [253, 254, 204] }], "cdom": [{ "index": 0, "rgb": [47, 15, 62] }, { "index": 0.13, "rgb": [87, 23, 86] }, { "index": 0.25, "rgb": [130, 28, 99] }, { "index": 0.38, "rgb": [171, 41, 96] }, { "index": 0.5, "rgb": [206, 67, 86] }, { "index": 0.63, "rgb": [230, 106, 84] }, { "index": 0.75, "rgb": [242, 149, 103] }, { "index": 0.88, "rgb": [249, 193, 135] }, { "index": 1, "rgb": [254, 237, 176] }], "chlorophyll": [{ "index": 0, "rgb": [18, 36, 20] }, { "index": 0.13, "rgb": [25, 63, 41] }, { "index": 0.25, "rgb": [24, 91, 59] }, { "index": 0.38, "rgb": [13, 119, 72] }, { "index": 0.5, "rgb": [18, 148, 80] }, { "index": 0.63, "rgb": [80, 173, 89] }, { "index": 0.75, "rgb": [132, 196, 122] }, { "index": 0.88, "rgb": [175, 221, 162] }, { "index": 1, "rgb": [215, 249, 208] }], "density": [{ "index": 0, "rgb": [54, 14, 36] }, { "index": 0.13, "rgb": [89, 23, 80] }, { "index": 0.25, "rgb": [110, 45, 132] }, { "index": 0.38, "rgb": [120, 77, 178] }, { "index": 0.5, "rgb": [120, 113, 213] }, { "index": 0.63, "rgb": [115, 151, 228] }, { "index": 0.75, "rgb": [134, 185, 227] }, { "index": 0.88, "rgb": [177, 214, 227] }, { "index": 1, "rgb": [230, 241, 241] }], "freesurface-blue": [{ "index": 0, "rgb": [30, 4, 110] }, { "index": 0.13, "rgb": [47, 14, 176] }, { "index": 0.25, "rgb": [41, 45, 236] }, { "index": 0.38, "rgb": [25, 99, 212] }, { "index": 0.5, "rgb": [68, 131, 200] }, { "index": 0.63, "rgb": [114, 156, 197] }, { "index": 0.75, "rgb": [157, 181, 203] }, { "index": 0.88, "rgb": [200, 208, 216] }, { "index": 1, "rgb": [241, 237, 236] }], "freesurface-red": [{ "index": 0, "rgb": [60, 9, 18] }, { "index": 0.13, "rgb": [100, 17, 27] }, { "index": 0.25, "rgb": [142, 20, 29] }, { "index": 0.38, "rgb": [177, 43, 27] }, { "index": 0.5, "rgb": [192, 87, 63] }, { "index": 0.63, "rgb": [205, 125, 105] }, { "index": 0.75, "rgb": [216, 162, 148] }, { "index": 0.88, "rgb": [227, 199, 193] }, { "index": 1, "rgb": [241, 237, 236] }], "oxygen": [{ "index": 0, "rgb": [64, 5, 5] }, { "index": 0.13, "rgb": [106, 6, 15] }, { "index": 0.25, "rgb": [144, 26, 7] }, { "index": 0.38, "rgb": [168, 64, 3] }, { "index": 0.5, "rgb": [188, 100, 4] }, { "index": 0.63, "rgb": [206, 136, 11] }, { "index": 0.75, "rgb": [220, 174, 25] }, { "index": 0.88, "rgb": [231, 215, 44] }, { "index": 1, "rgb": [248, 254, 105] }], "par": [{ "index": 0, "rgb": [51, 20, 24] }, { "index": 0.13, "rgb": [90, 32, 35] }, { "index": 0.25, "rgb": [129, 44, 34] }, { "index": 0.38, "rgb": [159, 68, 25] }, { "index": 0.5, "rgb": [182, 99, 19] }, { "index": 0.63, "rgb": [199, 134, 22] }, { "index": 0.75, "rgb": [212, 171, 35] }, { "index": 0.88, "rgb": [221, 210, 54] }, { "index": 1, "rgb": [225, 253, 75] }], "phase": [{ "index": 0, "rgb": [145, 105, 18] }, { "index": 0.13, "rgb": [184, 71, 38] }, { "index": 0.25, "rgb": [186, 58, 115] }, { "index": 0.38, "rgb": [160, 71, 185] }, { "index": 0.5, "rgb": [110, 97, 218] }, { "index": 0.63, "rgb": [50, 123, 164] }, { "index": 0.75, "rgb": [31, 131, 110] }, { "index": 0.88, "rgb": [77, 129, 34] }, { "index": 1, "rgb": [145, 105, 18] }], "salinity": [{ "index": 0, "rgb": [42, 24, 108] }, { "index": 0.13, "rgb": [33, 50, 162] }, { "index": 0.25, "rgb": [15, 90, 145] }, { "index": 0.38, "rgb": [40, 118, 137] }, { "index": 0.5, "rgb": [59, 146, 135] }, { "index": 0.63, "rgb": [79, 175, 126] }, { "index": 0.75, "rgb": [120, 203, 104] }, { "index": 0.88, "rgb": [193, 221, 100] }, { "index": 1, "rgb": [253, 239, 154] }], "temperature": [{ "index": 0, "rgb": [4, 35, 51] }, { "index": 0.13, "rgb": [23, 51, 122] }, { "index": 0.25, "rgb": [85, 59, 157] }, { "index": 0.38, "rgb": [129, 79, 143] }, { "index": 0.5, "rgb": [175, 95, 130] }, { "index": 0.63, "rgb": [222, 112, 101] }, { "index": 0.75, "rgb": [249, 146, 66] }, { "index": 0.88, "rgb": [249, 196, 65] }, { "index": 1, "rgb": [232, 250, 91] }], "turbidity": [{ "index": 0, "rgb": [34, 31, 27] }, { "index": 0.13, "rgb": [65, 50, 41] }, { "index": 0.25, "rgb": [98, 69, 52] }, { "index": 0.38, "rgb": [131, 89, 57] }, { "index": 0.5, "rgb": [161, 112, 59] }, { "index": 0.63, "rgb": [185, 140, 66] }, { "index": 0.75, "rgb": [202, 174, 88] }, { "index": 0.88, "rgb": [216, 209, 126] }, { "index": 1, "rgb": [233, 246, 171] }], "velocity-blue": [{ "index": 0, "rgb": [17, 32, 64] }, { "index": 0.13, "rgb": [35, 52, 116] }, { "index": 0.25, "rgb": [29, 81, 156] }, { "index": 0.38, "rgb": [31, 113, 162] }, { "index": 0.5, "rgb": [50, 144, 169] }, { "index": 0.63, "rgb": [87, 173, 176] }, { "index": 0.75, "rgb": [149, 196, 189] }, { "index": 0.88, "rgb": [203, 221, 211] }, { "index": 1, "rgb": [254, 251, 230] }], "velocity-green": [{ "index": 0, "rgb": [23, 35, 19] }, { "index": 0.13, "rgb": [24, 64, 38] }, { "index": 0.25, "rgb": [11, 95, 45] }, { "index": 0.38, "rgb": [39, 123, 35] }, { "index": 0.5, "rgb": [95, 146, 12] }, { "index": 0.63, "rgb": [152, 165, 18] }, { "index": 0.75, "rgb": [201, 186, 69] }, { "index": 0.88, "rgb": [233, 216, 137] }, { "index": 1, "rgb": [255, 253, 205] }], "cubehelix": [{ "index": 0, "rgb": [0, 0, 0] }, { "index": 0.07, "rgb": [22, 5, 59] }, { "index": 0.13, "rgb": [60, 4, 105] }, { "index": 0.2, "rgb": [109, 1, 135] }, { "index": 0.27, "rgb": [161, 0, 147] }, { "index": 0.33, "rgb": [210, 2, 142] }, { "index": 0.4, "rgb": [251, 11, 123] }, { "index": 0.47, "rgb": [255, 29, 97] }, { "index": 0.53, "rgb": [255, 54, 69] }, { "index": 0.6, "rgb": [255, 85, 46] }, { "index": 0.67, "rgb": [255, 120, 34] }, { "index": 0.73, "rgb": [255, 157, 37] }, { "index": 0.8, "rgb": [241, 191, 57] }, { "index": 0.87, "rgb": [224, 220, 93] }, { "index": 0.93, "rgb": [218, 241, 142] }, { "index": 1, "rgb": [227, 253, 198] }] };
	                      }
	                    ),
	                    /***/
	                    9156: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_201177__) {
	                        var colorScale = __nested_webpack_require_201177__(5692);
	                        var lerp = __nested_webpack_require_201177__(3578);
	                        module3.exports = createColormap;
	                        function createColormap(spec) {
	                          var indicies, fromrgba, torgba, nsteps, cmap, colormap, format, nshades, colors, alpha, i;
	                          if (!spec) spec = {};
	                          nshades = (spec.nshades || 72) - 1;
	                          format = spec.format || "hex";
	                          colormap = spec.colormap;
	                          if (!colormap) colormap = "jet";
	                          if (typeof colormap === "string") {
	                            colormap = colormap.toLowerCase();
	                            if (!colorScale[colormap]) {
	                              throw Error(colormap + " not a supported colorscale");
	                            }
	                            cmap = colorScale[colormap];
	                          } else if (Array.isArray(colormap)) {
	                            cmap = colormap.slice();
	                          } else {
	                            throw Error("unsupported colormap option", colormap);
	                          }
	                          if (cmap.length > nshades + 1) {
	                            throw new Error(colormap + " map requires nshades to be at least size " + cmap.length);
	                          }
	                          if (!Array.isArray(spec.alpha)) {
	                            if (typeof spec.alpha === "number") {
	                              alpha = [spec.alpha, spec.alpha];
	                            } else {
	                              alpha = [1, 1];
	                            }
	                          } else if (spec.alpha.length !== 2) {
	                            alpha = [1, 1];
	                          } else {
	                            alpha = spec.alpha.slice();
	                          }
	                          indicies = cmap.map(function(c) {
	                            return Math.round(c.index * nshades);
	                          });
	                          alpha[0] = Math.min(Math.max(alpha[0], 0), 1);
	                          alpha[1] = Math.min(Math.max(alpha[1], 0), 1);
	                          var steps = cmap.map(function(c, i2) {
	                            var index = cmap[i2].index;
	                            var rgba = cmap[i2].rgb.slice();
	                            if (rgba.length === 4 && rgba[3] >= 0 && rgba[3] <= 1) {
	                              return rgba;
	                            }
	                            rgba[3] = alpha[0] + (alpha[1] - alpha[0]) * index;
	                            return rgba;
	                          });
	                          var colors = [];
	                          for (i = 0; i < indicies.length - 1; ++i) {
	                            nsteps = indicies[i + 1] - indicies[i];
	                            fromrgba = steps[i];
	                            torgba = steps[i + 1];
	                            for (var j = 0; j < nsteps; j++) {
	                              var amt = j / nsteps;
	                              colors.push([Math.round(lerp(fromrgba[0], torgba[0], amt)), Math.round(lerp(fromrgba[1], torgba[1], amt)), Math.round(lerp(fromrgba[2], torgba[2], amt)), lerp(fromrgba[3], torgba[3], amt)]);
	                            }
	                          }
	                          colors.push(cmap[cmap.length - 1].rgb.concat(alpha[1]));
	                          if (format === "hex") colors = colors.map(rgb2hex);
	                          else if (format === "rgbaString") colors = colors.map(rgbaStr);
	                          else if (format === "float") colors = colors.map(rgb2float);
	                          return colors;
	                        }
	                        function rgb2float(rgba) {
	                          return [rgba[0] / 255, rgba[1] / 255, rgba[2] / 255, rgba[3]];
	                        }
	                        function rgb2hex(rgba) {
	                          var dig, hex = "#";
	                          for (var i = 0; i < 3; ++i) {
	                            dig = rgba[i];
	                            dig = dig.toString(16);
	                            hex += ("00" + dig).substr(dig.length);
	                          }
	                          return hex;
	                        }
	                        function rgbaStr(rgba) {
	                          return "rgba(" + rgba.join(",") + ")";
	                        }
	                      }
	                    ),
	                    /***/
	                    9398: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_203722__) {
	                        module3.exports = compareAngle;
	                        var orient = __nested_webpack_require_203722__(417);
	                        var sgn = __nested_webpack_require_203722__(7538);
	                        var twoSum = __nested_webpack_require_203722__(87);
	                        var robustProduct = __nested_webpack_require_203722__(2019);
	                        var robustSum = __nested_webpack_require_203722__(9662);
	                        function testInterior(a, b, c) {
	                          var x0 = twoSum(a[0], -b[0]);
	                          var y0 = twoSum(a[1], -b[1]);
	                          var x1 = twoSum(c[0], -b[0]);
	                          var y1 = twoSum(c[1], -b[1]);
	                          var d = robustSum(robustProduct(x0, x1), robustProduct(y0, y1));
	                          return d[d.length - 1] >= 0;
	                        }
	                        function compareAngle(a, b, c, d) {
	                          var bcd = orient(b, c, d);
	                          if (bcd === 0) {
	                            var sabc = sgn(orient(a, b, c));
	                            var sabd = sgn(orient(a, b, d));
	                            if (sabc === sabd) {
	                              if (sabc === 0) {
	                                var ic = testInterior(a, b, c);
	                                var id = testInterior(a, b, d);
	                                if (ic === id) {
	                                  return 0;
	                                } else if (ic) {
	                                  return 1;
	                                } else {
	                                  return -1;
	                                }
	                              }
	                              return 0;
	                            } else if (sabd === 0) {
	                              if (sabc > 0) {
	                                return -1;
	                              } else if (testInterior(a, b, d)) {
	                                return -1;
	                              } else {
	                                return 1;
	                              }
	                            } else if (sabc === 0) {
	                              if (sabd > 0) {
	                                return 1;
	                              } else if (testInterior(a, b, c)) {
	                                return 1;
	                              } else {
	                                return -1;
	                              }
	                            }
	                            return sgn(sabd - sabc);
	                          }
	                          var abc = orient(a, b, c);
	                          if (abc > 0) {
	                            if (bcd > 0 && orient(a, b, d) > 0) {
	                              return 1;
	                            }
	                            return -1;
	                          } else if (abc < 0) {
	                            if (bcd > 0 || orient(a, b, d) > 0) {
	                              return 1;
	                            }
	                            return -1;
	                          } else {
	                            var abd = orient(a, b, d);
	                            if (abd > 0) {
	                              return 1;
	                            } else {
	                              if (testInterior(a, b, c)) {
	                                return 1;
	                              } else {
	                                return -1;
	                              }
	                            }
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    7538: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function signum(x) {
	                          if (x < 0) {
	                            return -1;
	                          }
	                          if (x > 0) {
	                            return 1;
	                          }
	                          return 0;
	                        };
	                      }
	                    ),
	                    /***/
	                    9209: (
	                      /***/
	                      function(module3) {
	                        module3.exports = compareCells;
	                        var min = Math.min;
	                        function compareInt(a, b) {
	                          return a - b;
	                        }
	                        function compareCells(a, b) {
	                          var n = a.length, t = a.length - b.length;
	                          if (t) {
	                            return t;
	                          }
	                          switch (n) {
	                            case 0:
	                              return 0;
	                            case 1:
	                              return a[0] - b[0];
	                            case 2:
	                              return a[0] + a[1] - b[0] - b[1] || min(a[0], a[1]) - min(b[0], b[1]);
	                            case 3:
	                              var l1 = a[0] + a[1], m1 = b[0] + b[1];
	                              t = l1 + a[2] - (m1 + b[2]);
	                              if (t) {
	                                return t;
	                              }
	                              var l0 = min(a[0], a[1]), m0 = min(b[0], b[1]);
	                              return min(l0, a[2]) - min(m0, b[2]) || min(l0 + a[2], l1) - min(m0 + b[2], m1);
	                            case 4:
	                              var aw = a[0], ax = a[1], ay = a[2], az = a[3], bw = b[0], bx = b[1], by = b[2], bz = b[3];
	                              return aw + ax + ay + az - (bw + bx + by + bz) || min(aw, ax, ay, az) - min(bw, bx, by, bz, bw) || min(aw + ax, aw + ay, aw + az, ax + ay, ax + az, ay + az) - min(bw + bx, bw + by, bw + bz, bx + by, bx + bz, by + bz) || min(aw + ax + ay, aw + ax + az, aw + ay + az, ax + ay + az) - min(bw + bx + by, bw + bx + bz, bw + by + bz, bx + by + bz);
	                            default:
	                              var as = a.slice().sort(compareInt);
	                              var bs = b.slice().sort(compareInt);
	                              for (var i = 0; i < n; ++i) {
	                                t = as[i] - bs[i];
	                                if (t) {
	                                  return t;
	                                }
	                              }
	                              return 0;
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    1284: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_206088__) {
	                        var compareCells = __nested_webpack_require_206088__(9209);
	                        var parity = __nested_webpack_require_206088__(9887);
	                        module3.exports = compareOrientedCells;
	                        function compareOrientedCells(a, b) {
	                          return compareCells(a, b) || parity(a) - parity(b);
	                        }
	                      }
	                    ),
	                    /***/
	                    5537: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_206383__) {
	                        var convexHull1d = __nested_webpack_require_206383__(8950);
	                        var convexHull2d = __nested_webpack_require_206383__(8722);
	                        var convexHullnd = __nested_webpack_require_206383__(3332);
	                        module3.exports = convexHull;
	                        function convexHull(points) {
	                          var n = points.length;
	                          if (n === 0) {
	                            return [];
	                          } else if (n === 1) {
	                            return [[0]];
	                          }
	                          var d = points[0].length;
	                          if (d === 0) {
	                            return [];
	                          } else if (d === 1) {
	                            return convexHull1d(points);
	                          } else if (d === 2) {
	                            return convexHull2d(points);
	                          }
	                          return convexHullnd(points, d);
	                        }
	                      }
	                    ),
	                    /***/
	                    8950: (
	                      /***/
	                      function(module3) {
	                        module3.exports = convexHull1d;
	                        function convexHull1d(points) {
	                          var lo = 0;
	                          var hi = 0;
	                          for (var i = 1; i < points.length; ++i) {
	                            if (points[i][0] < points[lo][0]) {
	                              lo = i;
	                            }
	                            if (points[i][0] > points[hi][0]) {
	                              hi = i;
	                            }
	                          }
	                          if (lo < hi) {
	                            return [[lo], [hi]];
	                          } else if (lo > hi) {
	                            return [[hi], [lo]];
	                          } else {
	                            return [[lo]];
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    8722: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_207212__) {
	                        module3.exports = convexHull2D;
	                        var monotoneHull = __nested_webpack_require_207212__(3266);
	                        function convexHull2D(points) {
	                          var hull = monotoneHull(points);
	                          var h = hull.length;
	                          if (h <= 2) {
	                            return [];
	                          }
	                          var edges = new Array(h);
	                          var a = hull[h - 1];
	                          for (var i = 0; i < h; ++i) {
	                            var b = hull[i];
	                            edges[i] = [a, b];
	                            a = b;
	                          }
	                          return edges;
	                        }
	                      }
	                    ),
	                    /***/
	                    3332: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_207585__) {
	                        module3.exports = convexHullnD;
	                        var ich = __nested_webpack_require_207585__(2183);
	                        var aff = __nested_webpack_require_207585__(2153);
	                        function permute(points, front) {
	                          var n = points.length;
	                          var npoints = new Array(n);
	                          for (var i = 0; i < front.length; ++i) {
	                            npoints[i] = points[front[i]];
	                          }
	                          var ptr = front.length;
	                          for (var i = 0; i < n; ++i) {
	                            if (front.indexOf(i) < 0) {
	                              npoints[ptr++] = points[i];
	                            }
	                          }
	                          return npoints;
	                        }
	                        function invPermute(cells, front) {
	                          var nc = cells.length;
	                          var nf = front.length;
	                          for (var i = 0; i < nc; ++i) {
	                            var c = cells[i];
	                            for (var j = 0; j < c.length; ++j) {
	                              var x = c[j];
	                              if (x < nf) {
	                                c[j] = front[x];
	                              } else {
	                                x = x - nf;
	                                for (var k = 0; k < nf; ++k) {
	                                  if (x >= front[k]) {
	                                    x += 1;
	                                  }
	                                }
	                                c[j] = x;
	                              }
	                            }
	                          }
	                          return cells;
	                        }
	                        function convexHullnD(points, d) {
	                          try {
	                            return ich(points, true);
	                          } catch (e) {
	                            var ah = aff(points);
	                            if (ah.length <= d) {
	                              return [];
	                            }
	                            var npoints = permute(points, ah);
	                            var nhull = ich(npoints, true);
	                            return invPermute(nhull, ah);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    9680: (
	                      /***/
	                      function(module3) {
	                        function dcubicHermite(p0, v0, p1, v1, t, f) {
	                          var dh00 = 6 * t * t - 6 * t, dh10 = 3 * t * t - 4 * t + 1, dh01 = -6 * t * t + 6 * t, dh11 = 3 * t * t - 2 * t;
	                          if (p0.length) {
	                            if (!f) {
	                              f = new Array(p0.length);
	                            }
	                            for (var i = p0.length - 1; i >= 0; --i) {
	                              f[i] = dh00 * p0[i] + dh10 * v0[i] + dh01 * p1[i] + dh11 * v1[i];
	                            }
	                            return f;
	                          }
	                          return dh00 * p0 + dh10 * v0 + dh01 * p1[i] + dh11 * v1;
	                        }
	                        function cubicHermite(p0, v0, p1, v1, t, f) {
	                          var ti = t - 1, t2 = t * t, ti2 = ti * ti, h00 = (1 + 2 * t) * ti2, h10 = t * ti2, h01 = t2 * (3 - 2 * t), h11 = t2 * ti;
	                          if (p0.length) {
	                            if (!f) {
	                              f = new Array(p0.length);
	                            }
	                            for (var i = p0.length - 1; i >= 0; --i) {
	                              f[i] = h00 * p0[i] + h10 * v0[i] + h01 * p1[i] + h11 * v1[i];
	                            }
	                            return f;
	                          }
	                          return h00 * p0 + h10 * v0 + h01 * p1 + h11 * v1;
	                        }
	                        module3.exports = cubicHermite;
	                        module3.exports.derivative = dcubicHermite;
	                      }
	                    ),
	                    /***/
	                    4419: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_209258__) {
	                        var ch = __nested_webpack_require_209258__(2183);
	                        var uniq = __nested_webpack_require_209258__(1215);
	                        module3.exports = triangulate;
	                        function LiftedPoint(p, i) {
	                          this.point = p;
	                          this.index = i;
	                        }
	                        function compareLifted(a, b) {
	                          var ap = a.point;
	                          var bp = b.point;
	                          var d = ap.length;
	                          for (var i = 0; i < d; ++i) {
	                            var s = bp[i] - ap[i];
	                            if (s) {
	                              return s;
	                            }
	                          }
	                          return 0;
	                        }
	                        function triangulate1D(n, points, includePointAtInfinity) {
	                          if (n === 1) {
	                            if (includePointAtInfinity) {
	                              return [[-1, 0]];
	                            } else {
	                              return [];
	                            }
	                          }
	                          var lifted = points.map(function(p, i2) {
	                            return [p[0], i2];
	                          });
	                          lifted.sort(function(a2, b2) {
	                            return a2[0] - b2[0];
	                          });
	                          var cells = new Array(n - 1);
	                          for (var i = 1; i < n; ++i) {
	                            var a = lifted[i - 1];
	                            var b = lifted[i];
	                            cells[i - 1] = [a[1], b[1]];
	                          }
	                          if (includePointAtInfinity) {
	                            cells.push([-1, cells[0][1]], [cells[n - 1][1], -1]);
	                          }
	                          return cells;
	                        }
	                        function triangulate(points, includePointAtInfinity) {
	                          var n = points.length;
	                          if (n === 0) {
	                            return [];
	                          }
	                          var d = points[0].length;
	                          if (d < 1) {
	                            return [];
	                          }
	                          if (d === 1) {
	                            return triangulate1D(n, points, includePointAtInfinity);
	                          }
	                          var lifted = new Array(n);
	                          var upper = 1;
	                          for (var i = 0; i < n; ++i) {
	                            var p = points[i];
	                            var x = new Array(d + 1);
	                            var l = 0;
	                            for (var j = 0; j < d; ++j) {
	                              var v = p[j];
	                              x[j] = v;
	                              l += v * v;
	                            }
	                            x[d] = l;
	                            lifted[i] = new LiftedPoint(x, i);
	                            upper = Math.max(l, upper);
	                          }
	                          uniq(lifted, compareLifted);
	                          n = lifted.length;
	                          var dpoints = new Array(n + d + 1);
	                          var dindex = new Array(n + d + 1);
	                          var u = (d + 1) * (d + 1) * upper;
	                          var y = new Array(d + 1);
	                          for (var i = 0; i <= d; ++i) {
	                            y[i] = 0;
	                          }
	                          y[d] = u;
	                          dpoints[0] = y.slice();
	                          dindex[0] = -1;
	                          for (var i = 0; i <= d; ++i) {
	                            var x = y.slice();
	                            x[i] = 1;
	                            dpoints[i + 1] = x;
	                            dindex[i + 1] = -1;
	                          }
	                          for (var i = 0; i < n; ++i) {
	                            var h = lifted[i];
	                            dpoints[i + d + 1] = h.point;
	                            dindex[i + d + 1] = h.index;
	                          }
	                          var hull = ch(dpoints, false);
	                          if (includePointAtInfinity) {
	                            hull = hull.filter(function(cell) {
	                              var count = 0;
	                              for (var j2 = 0; j2 <= d; ++j2) {
	                                var v2 = dindex[cell[j2]];
	                                if (v2 < 0) {
	                                  if (++count >= 2) {
	                                    return false;
	                                  }
	                                }
	                                cell[j2] = v2;
	                              }
	                              return true;
	                            });
	                          } else {
	                            hull = hull.filter(function(cell) {
	                              for (var i2 = 0; i2 <= d; ++i2) {
	                                var v2 = dindex[cell[i2]];
	                                if (v2 < 0) {
	                                  return false;
	                                }
	                                cell[i2] = v2;
	                              }
	                              return true;
	                            });
	                          }
	                          if (d & 1) {
	                            for (var i = 0; i < hull.length; ++i) {
	                              var h = hull[i];
	                              var x = h[0];
	                              h[0] = h[1];
	                              h[1] = x;
	                            }
	                          }
	                          return hull;
	                        }
	                      }
	                    ),
	                    /***/
	                    8362: (
	                      /***/
	                      function(module3) {
	                        var hasTypedArrays = false;
	                        if (typeof Float64Array !== "undefined") {
	                          var DOUBLE_VIEW = new Float64Array(1), UINT_VIEW = new Uint32Array(DOUBLE_VIEW.buffer);
	                          DOUBLE_VIEW[0] = 1;
	                          hasTypedArrays = true;
	                          if (UINT_VIEW[1] === 1072693248) {
	                            let toDoubleLE2 = function(lo, hi) {
	                              UINT_VIEW[0] = lo;
	                              UINT_VIEW[1] = hi;
	                              return DOUBLE_VIEW[0];
	                            }, lowUintLE2 = function(n) {
	                              DOUBLE_VIEW[0] = n;
	                              return UINT_VIEW[0];
	                            }, highUintLE2 = function(n) {
	                              DOUBLE_VIEW[0] = n;
	                              return UINT_VIEW[1];
	                            };
	                            module3.exports = function doubleBitsLE(n) {
	                              DOUBLE_VIEW[0] = n;
	                              return [UINT_VIEW[0], UINT_VIEW[1]];
	                            };
	                            module3.exports.pack = toDoubleLE2;
	                            module3.exports.lo = lowUintLE2;
	                            module3.exports.hi = highUintLE2;
	                          } else if (UINT_VIEW[0] === 1072693248) {
	                            let toDoubleBE2 = function(lo, hi) {
	                              UINT_VIEW[1] = lo;
	                              UINT_VIEW[0] = hi;
	                              return DOUBLE_VIEW[0];
	                            }, lowUintBE2 = function(n) {
	                              DOUBLE_VIEW[0] = n;
	                              return UINT_VIEW[1];
	                            }, highUintBE2 = function(n) {
	                              DOUBLE_VIEW[0] = n;
	                              return UINT_VIEW[0];
	                            };
	                            module3.exports = function doubleBitsBE(n) {
	                              DOUBLE_VIEW[0] = n;
	                              return [UINT_VIEW[1], UINT_VIEW[0]];
	                            };
	                            module3.exports.pack = toDoubleBE2;
	                            module3.exports.lo = lowUintBE2;
	                            module3.exports.hi = highUintBE2;
	                          } else {
	                            hasTypedArrays = false;
	                          }
	                        }
	                        if (!hasTypedArrays) {
	                          let toDouble2 = function(lo, hi) {
	                            buffer.writeUInt32LE(lo, 0, true);
	                            buffer.writeUInt32LE(hi, 4, true);
	                            return buffer.readDoubleLE(0, true);
	                          }, lowUint2 = function(n) {
	                            buffer.writeDoubleLE(n, 0, true);
	                            return buffer.readUInt32LE(0, true);
	                          }, highUint2 = function(n) {
	                            buffer.writeDoubleLE(n, 0, true);
	                            return buffer.readUInt32LE(4, true);
	                          };
	                          var buffer = new Buffer(8);
	                          module3.exports = function doubleBits(n) {
	                            buffer.writeDoubleLE(n, 0, true);
	                            return [buffer.readUInt32LE(0, true), buffer.readUInt32LE(4, true)];
	                          };
	                          module3.exports.pack = toDouble2;
	                          module3.exports.lo = lowUint2;
	                          module3.exports.hi = highUint2;
	                        }
	                        module3.exports.sign = function(n) {
	                          return module3.exports.hi(n) >>> 31;
	                        };
	                        module3.exports.exponent = function(n) {
	                          var b = module3.exports.hi(n);
	                          return (b << 1 >>> 21) - 1023;
	                        };
	                        module3.exports.fraction = function(n) {
	                          var lo = module3.exports.lo(n);
	                          var hi = module3.exports.hi(n);
	                          var b = hi & (1 << 20) - 1;
	                          if (hi & 2146435072) {
	                            b += 1 << 20;
	                          }
	                          return [lo, b];
	                        };
	                        module3.exports.denormalized = function(n) {
	                          var hi = module3.exports.hi(n);
	                          return !(hi & 2146435072);
	                        };
	                      }
	                    ),
	                    /***/
	                    3094: (
	                      /***/
	                      function(module3) {
	                        function dupe_array(count, value, i) {
	                          var c = count[i] | 0;
	                          if (c <= 0) {
	                            return [];
	                          }
	                          var result = new Array(c), j;
	                          if (i === count.length - 1) {
	                            for (j = 0; j < c; ++j) {
	                              result[j] = value;
	                            }
	                          } else {
	                            for (j = 0; j < c; ++j) {
	                              result[j] = dupe_array(count, value, i + 1);
	                            }
	                          }
	                          return result;
	                        }
	                        function dupe_number(count, value) {
	                          var result, i;
	                          result = new Array(count);
	                          for (i = 0; i < count; ++i) {
	                            result[i] = value;
	                          }
	                          return result;
	                        }
	                        function dupe(count, value) {
	                          if (typeof value === "undefined") {
	                            value = 0;
	                          }
	                          switch (typeof count) {
	                            case "number":
	                              if (count > 0) {
	                                return dupe_number(count | 0, value);
	                              }
	                              break;
	                            case "object":
	                              if (typeof count.length === "number") {
	                                return dupe_array(count, value, 0);
	                              }
	                              break;
	                          }
	                          return [];
	                        }
	                        module3.exports = dupe;
	                      }
	                    ),
	                    /***/
	                    8348: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_214254__) {
	                        module3.exports = edgeToAdjacency;
	                        var uniq = __nested_webpack_require_214254__(1215);
	                        function edgeToAdjacency(edges, numVertices) {
	                          var numEdges = edges.length;
	                          if (typeof numVertices !== "number") {
	                            numVertices = 0;
	                            for (var i = 0; i < numEdges; ++i) {
	                              var e = edges[i];
	                              numVertices = Math.max(numVertices, e[0], e[1]);
	                            }
	                            numVertices = (numVertices | 0) + 1;
	                          }
	                          numVertices = numVertices | 0;
	                          var adj = new Array(numVertices);
	                          for (var i = 0; i < numVertices; ++i) {
	                            adj[i] = [];
	                          }
	                          for (var i = 0; i < numEdges; ++i) {
	                            var e = edges[i];
	                            adj[e[0]].push(e[1]);
	                            adj[e[1]].push(e[0]);
	                          }
	                          for (var j = 0; j < numVertices; ++j) {
	                            uniq(adj[j], function(a, b) {
	                              return a - b;
	                            });
	                          }
	                          return adj;
	                        }
	                      }
	                    ),
	                    /***/
	                    5795: (
	                      /***/
	                      function(module3) {
	                        module3.exports = extractPlanes;
	                        function extractPlanes(M, zNear, zFar) {
	                          var z = zNear || 0;
	                          var zf = zFar || 1;
	                          return [[M[12] + M[0], M[13] + M[1], M[14] + M[2], M[15] + M[3]], [M[12] - M[0], M[13] - M[1], M[14] - M[2], M[15] - M[3]], [M[12] + M[4], M[13] + M[5], M[14] + M[6], M[15] + M[7]], [M[12] - M[4], M[13] - M[5], M[14] - M[6], M[15] - M[7]], [z * M[12] + M[8], z * M[13] + M[9], z * M[14] + M[10], z * M[15] + M[11]], [zf * M[12] - M[8], zf * M[13] - M[9], zf * M[14] - M[10], zf * M[15] - M[11]]];
	                        }
	                      }
	                    ),
	                    /***/
	                    8444: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_215384__) {
	                        module3.exports = createFilteredVector;
	                        var cubicHermite = __nested_webpack_require_215384__(9680);
	                        var bsearch = __nested_webpack_require_215384__(5070);
	                        function clamp(lo, hi, x) {
	                          return Math.min(hi, Math.max(lo, x));
	                        }
	                        function FilteredVector(state0, velocity0, t0) {
	                          this.dimension = state0.length;
	                          this.bounds = [new Array(this.dimension), new Array(this.dimension)];
	                          for (var i = 0; i < this.dimension; ++i) {
	                            this.bounds[0][i] = -Infinity;
	                            this.bounds[1][i] = Infinity;
	                          }
	                          this._state = state0.slice().reverse();
	                          this._velocity = velocity0.slice().reverse();
	                          this._time = [t0];
	                          this._scratch = [state0.slice(), state0.slice(), state0.slice(), state0.slice(), state0.slice()];
	                        }
	                        var proto = FilteredVector.prototype;
	                        proto.flush = function(t) {
	                          var idx = bsearch.gt(this._time, t) - 1;
	                          if (idx <= 0) {
	                            return;
	                          }
	                          this._time.splice(0, idx);
	                          this._state.splice(0, idx * this.dimension);
	                          this._velocity.splice(0, idx * this.dimension);
	                        };
	                        proto.curve = function(t) {
	                          var time = this._time;
	                          var n = time.length;
	                          var idx = bsearch.le(time, t);
	                          var result = this._scratch[0];
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var d = this.dimension;
	                          var bounds = this.bounds;
	                          if (idx < 0) {
	                            var ptr = d - 1;
	                            for (var i = 0; i < d; ++i, --ptr) {
	                              result[i] = state[ptr];
	                            }
	                          } else if (idx >= n - 1) {
	                            var ptr = state.length - 1;
	                            var tf = t - time[n - 1];
	                            for (var i = 0; i < d; ++i, --ptr) {
	                              result[i] = state[ptr] + tf * velocity[ptr];
	                            }
	                          } else {
	                            var ptr = d * (idx + 1) - 1;
	                            var t0 = time[idx];
	                            var t1 = time[idx + 1];
	                            var dt = t1 - t0 || 1;
	                            var x0 = this._scratch[1];
	                            var x1 = this._scratch[2];
	                            var v0 = this._scratch[3];
	                            var v1 = this._scratch[4];
	                            var steady = true;
	                            for (var i = 0; i < d; ++i, --ptr) {
	                              x0[i] = state[ptr];
	                              v0[i] = velocity[ptr] * dt;
	                              x1[i] = state[ptr + d];
	                              v1[i] = velocity[ptr + d] * dt;
	                              steady = steady && x0[i] === x1[i] && v0[i] === v1[i] && v0[i] === 0;
	                            }
	                            if (steady) {
	                              for (var i = 0; i < d; ++i) {
	                                result[i] = x0[i];
	                              }
	                            } else {
	                              cubicHermite(x0, v0, x1, v1, (t - t0) / dt, result);
	                            }
	                          }
	                          var lo = bounds[0];
	                          var hi = bounds[1];
	                          for (var i = 0; i < d; ++i) {
	                            result[i] = clamp(lo[i], hi[i], result[i]);
	                          }
	                          return result;
	                        };
	                        proto.dcurve = function(t) {
	                          var time = this._time;
	                          var n = time.length;
	                          var idx = bsearch.le(time, t);
	                          var result = this._scratch[0];
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var d = this.dimension;
	                          if (idx >= n - 1) {
	                            var ptr = state.length - 1;
	                            t - time[n - 1];
	                            for (var i = 0; i < d; ++i, --ptr) {
	                              result[i] = velocity[ptr];
	                            }
	                          } else {
	                            var ptr = d * (idx + 1) - 1;
	                            var t0 = time[idx];
	                            var t1 = time[idx + 1];
	                            var dt = t1 - t0 || 1;
	                            var x0 = this._scratch[1];
	                            var x1 = this._scratch[2];
	                            var v0 = this._scratch[3];
	                            var v1 = this._scratch[4];
	                            var steady = true;
	                            for (var i = 0; i < d; ++i, --ptr) {
	                              x0[i] = state[ptr];
	                              v0[i] = velocity[ptr] * dt;
	                              x1[i] = state[ptr + d];
	                              v1[i] = velocity[ptr + d] * dt;
	                              steady = steady && x0[i] === x1[i] && v0[i] === v1[i] && v0[i] === 0;
	                            }
	                            if (steady) {
	                              for (var i = 0; i < d; ++i) {
	                                result[i] = 0;
	                              }
	                            } else {
	                              cubicHermite.derivative(x0, v0, x1, v1, (t - t0) / dt, result);
	                              for (var i = 0; i < d; ++i) {
	                                result[i] /= dt;
	                              }
	                            }
	                          }
	                          return result;
	                        };
	                        proto.lastT = function() {
	                          var time = this._time;
	                          return time[time.length - 1];
	                        };
	                        proto.stable = function() {
	                          var velocity = this._velocity;
	                          var ptr = velocity.length;
	                          for (var i = this.dimension - 1; i >= 0; --i) {
	                            if (velocity[--ptr]) {
	                              return false;
	                            }
	                          }
	                          return true;
	                        };
	                        proto.jump = function(t) {
	                          var t0 = this.lastT();
	                          var d = this.dimension;
	                          if (t < t0 || arguments.length !== d + 1) {
	                            return;
	                          }
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var ptr = state.length - this.dimension;
	                          var bounds = this.bounds;
	                          var lo = bounds[0];
	                          var hi = bounds[1];
	                          this._time.push(t0, t);
	                          for (var j = 0; j < 2; ++j) {
	                            for (var i = 0; i < d; ++i) {
	                              state.push(state[ptr++]);
	                              velocity.push(0);
	                            }
	                          }
	                          this._time.push(t);
	                          for (var i = d; i > 0; --i) {
	                            state.push(clamp(lo[i - 1], hi[i - 1], arguments[i]));
	                            velocity.push(0);
	                          }
	                        };
	                        proto.push = function(t) {
	                          var t0 = this.lastT();
	                          var d = this.dimension;
	                          if (t < t0 || arguments.length !== d + 1) {
	                            return;
	                          }
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var ptr = state.length - this.dimension;
	                          var dt = t - t0;
	                          var bounds = this.bounds;
	                          var lo = bounds[0];
	                          var hi = bounds[1];
	                          var sf = dt > 1e-6 ? 1 / dt : 0;
	                          this._time.push(t);
	                          for (var i = d; i > 0; --i) {
	                            var xc = clamp(lo[i - 1], hi[i - 1], arguments[i]);
	                            state.push(xc);
	                            velocity.push((xc - state[ptr++]) * sf);
	                          }
	                        };
	                        proto.set = function(t) {
	                          var d = this.dimension;
	                          if (t < this.lastT() || arguments.length !== d + 1) {
	                            return;
	                          }
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var bounds = this.bounds;
	                          var lo = bounds[0];
	                          var hi = bounds[1];
	                          this._time.push(t);
	                          for (var i = d; i > 0; --i) {
	                            state.push(clamp(lo[i - 1], hi[i - 1], arguments[i]));
	                            velocity.push(0);
	                          }
	                        };
	                        proto.move = function(t) {
	                          var t0 = this.lastT();
	                          var d = this.dimension;
	                          if (t <= t0 || arguments.length !== d + 1) {
	                            return;
	                          }
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var statePtr = state.length - this.dimension;
	                          var bounds = this.bounds;
	                          var lo = bounds[0];
	                          var hi = bounds[1];
	                          var dt = t - t0;
	                          var sf = dt > 1e-6 ? 1 / dt : 0;
	                          this._time.push(t);
	                          for (var i = d; i > 0; --i) {
	                            var dx = arguments[i];
	                            state.push(clamp(lo[i - 1], hi[i - 1], state[statePtr++] + dx));
	                            velocity.push(dx * sf);
	                          }
	                        };
	                        proto.idle = function(t) {
	                          var t0 = this.lastT();
	                          if (t < t0) {
	                            return;
	                          }
	                          var d = this.dimension;
	                          var state = this._state;
	                          var velocity = this._velocity;
	                          var statePtr = state.length - d;
	                          var bounds = this.bounds;
	                          var lo = bounds[0];
	                          var hi = bounds[1];
	                          var dt = t - t0;
	                          this._time.push(t);
	                          for (var i = d - 1; i >= 0; --i) {
	                            state.push(clamp(lo[i], hi[i], state[statePtr] + dt * velocity[statePtr]));
	                            velocity.push(0);
	                            statePtr += 1;
	                          }
	                        };
	                        function getZero(d) {
	                          var result = new Array(d);
	                          for (var i = 0; i < d; ++i) {
	                            result[i] = 0;
	                          }
	                          return result;
	                        }
	                        function createFilteredVector(initState, initVelocity, initTime) {
	                          switch (arguments.length) {
	                            case 0:
	                              return new FilteredVector([0], [0], 0);
	                            case 1:
	                              if (typeof initState === "number") {
	                                var zero = getZero(initState);
	                                return new FilteredVector(zero, zero, 0);
	                              } else {
	                                return new FilteredVector(initState, getZero(initState.length), 0);
	                              }
	                            case 2:
	                              if (typeof initVelocity === "number") {
	                                var zero = getZero(initState.length);
	                                return new FilteredVector(initState, zero, +initVelocity);
	                              } else {
	                                initTime = 0;
	                              }
	                            case 3:
	                              if (initState.length !== initVelocity.length) {
	                                throw new Error("state and velocity lengths must match");
	                              }
	                              return new FilteredVector(initState, initVelocity, initTime);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    7080: (
	                      /***/
	                      function(module3) {
	                        module3.exports = createRBTree;
	                        var RED = 0;
	                        var BLACK = 1;
	                        function RBNode(color, key, value, left, right, count) {
	                          this._color = color;
	                          this.key = key;
	                          this.value = value;
	                          this.left = left;
	                          this.right = right;
	                          this._count = count;
	                        }
	                        function cloneNode(node) {
	                          return new RBNode(node._color, node.key, node.value, node.left, node.right, node._count);
	                        }
	                        function repaint(color, node) {
	                          return new RBNode(color, node.key, node.value, node.left, node.right, node._count);
	                        }
	                        function recount(node) {
	                          node._count = 1 + (node.left ? node.left._count : 0) + (node.right ? node.right._count : 0);
	                        }
	                        function RedBlackTree(compare, root) {
	                          this._compare = compare;
	                          this.root = root;
	                        }
	                        var proto = RedBlackTree.prototype;
	                        Object.defineProperty(proto, "keys", { get: function() {
	                          var result = [];
	                          this.forEach(function(k, v) {
	                            result.push(k);
	                          });
	                          return result;
	                        } });
	                        Object.defineProperty(proto, "values", { get: function() {
	                          var result = [];
	                          this.forEach(function(k, v) {
	                            result.push(v);
	                          });
	                          return result;
	                        } });
	                        Object.defineProperty(proto, "length", { get: function() {
	                          if (this.root) {
	                            return this.root._count;
	                          }
	                          return 0;
	                        } });
	                        proto.insert = function(key, value) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          var n_stack = [];
	                          var d_stack = [];
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            n_stack.push(n);
	                            d_stack.push(d);
	                            if (d <= 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          n_stack.push(new RBNode(RED, key, value, null, null, 1));
	                          for (var s = n_stack.length - 2; s >= 0; --s) {
	                            var n = n_stack[s];
	                            if (d_stack[s] <= 0) {
	                              n_stack[s] = new RBNode(n._color, n.key, n.value, n_stack[s + 1], n.right, n._count + 1);
	                            } else {
	                              n_stack[s] = new RBNode(n._color, n.key, n.value, n.left, n_stack[s + 1], n._count + 1);
	                            }
	                          }
	                          for (var s = n_stack.length - 1; s > 1; --s) {
	                            var p = n_stack[s - 1];
	                            var n = n_stack[s];
	                            if (p._color === BLACK || n._color === BLACK) {
	                              break;
	                            }
	                            var pp = n_stack[s - 2];
	                            if (pp.left === p) {
	                              if (p.left === n) {
	                                var y = pp.right;
	                                if (y && y._color === RED) {
	                                  p._color = BLACK;
	                                  pp.right = repaint(BLACK, y);
	                                  pp._color = RED;
	                                  s -= 1;
	                                } else {
	                                  pp._color = RED;
	                                  pp.left = p.right;
	                                  p._color = BLACK;
	                                  p.right = pp;
	                                  n_stack[s - 2] = p;
	                                  n_stack[s - 1] = n;
	                                  recount(pp);
	                                  recount(p);
	                                  if (s >= 3) {
	                                    var ppp = n_stack[s - 3];
	                                    if (ppp.left === pp) {
	                                      ppp.left = p;
	                                    } else {
	                                      ppp.right = p;
	                                    }
	                                  }
	                                  break;
	                                }
	                              } else {
	                                var y = pp.right;
	                                if (y && y._color === RED) {
	                                  p._color = BLACK;
	                                  pp.right = repaint(BLACK, y);
	                                  pp._color = RED;
	                                  s -= 1;
	                                } else {
	                                  p.right = n.left;
	                                  pp._color = RED;
	                                  pp.left = n.right;
	                                  n._color = BLACK;
	                                  n.left = p;
	                                  n.right = pp;
	                                  n_stack[s - 2] = n;
	                                  n_stack[s - 1] = p;
	                                  recount(pp);
	                                  recount(p);
	                                  recount(n);
	                                  if (s >= 3) {
	                                    var ppp = n_stack[s - 3];
	                                    if (ppp.left === pp) {
	                                      ppp.left = n;
	                                    } else {
	                                      ppp.right = n;
	                                    }
	                                  }
	                                  break;
	                                }
	                              }
	                            } else {
	                              if (p.right === n) {
	                                var y = pp.left;
	                                if (y && y._color === RED) {
	                                  p._color = BLACK;
	                                  pp.left = repaint(BLACK, y);
	                                  pp._color = RED;
	                                  s -= 1;
	                                } else {
	                                  pp._color = RED;
	                                  pp.right = p.left;
	                                  p._color = BLACK;
	                                  p.left = pp;
	                                  n_stack[s - 2] = p;
	                                  n_stack[s - 1] = n;
	                                  recount(pp);
	                                  recount(p);
	                                  if (s >= 3) {
	                                    var ppp = n_stack[s - 3];
	                                    if (ppp.right === pp) {
	                                      ppp.right = p;
	                                    } else {
	                                      ppp.left = p;
	                                    }
	                                  }
	                                  break;
	                                }
	                              } else {
	                                var y = pp.left;
	                                if (y && y._color === RED) {
	                                  p._color = BLACK;
	                                  pp.left = repaint(BLACK, y);
	                                  pp._color = RED;
	                                  s -= 1;
	                                } else {
	                                  p.left = n.right;
	                                  pp._color = RED;
	                                  pp.right = n.left;
	                                  n._color = BLACK;
	                                  n.right = p;
	                                  n.left = pp;
	                                  n_stack[s - 2] = n;
	                                  n_stack[s - 1] = p;
	                                  recount(pp);
	                                  recount(p);
	                                  recount(n);
	                                  if (s >= 3) {
	                                    var ppp = n_stack[s - 3];
	                                    if (ppp.right === pp) {
	                                      ppp.right = n;
	                                    } else {
	                                      ppp.left = n;
	                                    }
	                                  }
	                                  break;
	                                }
	                              }
	                            }
	                          }
	                          n_stack[0]._color = BLACK;
	                          return new RedBlackTree(cmp, n_stack[0]);
	                        };
	                        function doVisitFull(visit, node) {
	                          if (node.left) {
	                            var v = doVisitFull(visit, node.left);
	                            if (v) {
	                              return v;
	                            }
	                          }
	                          var v = visit(node.key, node.value);
	                          if (v) {
	                            return v;
	                          }
	                          if (node.right) {
	                            return doVisitFull(visit, node.right);
	                          }
	                        }
	                        function doVisitHalf(lo, compare, visit, node) {
	                          var l = compare(lo, node.key);
	                          if (l <= 0) {
	                            if (node.left) {
	                              var v = doVisitHalf(lo, compare, visit, node.left);
	                              if (v) {
	                                return v;
	                              }
	                            }
	                            var v = visit(node.key, node.value);
	                            if (v) {
	                              return v;
	                            }
	                          }
	                          if (node.right) {
	                            return doVisitHalf(lo, compare, visit, node.right);
	                          }
	                        }
	                        function doVisit(lo, hi, compare, visit, node) {
	                          var l = compare(lo, node.key);
	                          var h = compare(hi, node.key);
	                          var v;
	                          if (l <= 0) {
	                            if (node.left) {
	                              v = doVisit(lo, hi, compare, visit, node.left);
	                              if (v) {
	                                return v;
	                              }
	                            }
	                            if (h > 0) {
	                              v = visit(node.key, node.value);
	                              if (v) {
	                                return v;
	                              }
	                            }
	                          }
	                          if (h > 0 && node.right) {
	                            return doVisit(lo, hi, compare, visit, node.right);
	                          }
	                        }
	                        proto.forEach = function rbTreeForEach(visit, lo, hi) {
	                          if (!this.root) {
	                            return;
	                          }
	                          switch (arguments.length) {
	                            case 1:
	                              return doVisitFull(visit, this.root);
	                            case 2:
	                              return doVisitHalf(lo, this._compare, visit, this.root);
	                            case 3:
	                              if (this._compare(lo, hi) >= 0) {
	                                return;
	                              }
	                              return doVisit(lo, hi, this._compare, visit, this.root);
	                          }
	                        };
	                        Object.defineProperty(proto, "begin", { get: function() {
	                          var stack = [];
	                          var n = this.root;
	                          while (n) {
	                            stack.push(n);
	                            n = n.left;
	                          }
	                          return new RedBlackTreeIterator(this, stack);
	                        } });
	                        Object.defineProperty(proto, "end", { get: function() {
	                          var stack = [];
	                          var n = this.root;
	                          while (n) {
	                            stack.push(n);
	                            n = n.right;
	                          }
	                          return new RedBlackTreeIterator(this, stack);
	                        } });
	                        proto.at = function(idx) {
	                          if (idx < 0) {
	                            return new RedBlackTreeIterator(this, []);
	                          }
	                          var n = this.root;
	                          var stack = [];
	                          while (true) {
	                            stack.push(n);
	                            if (n.left) {
	                              if (idx < n.left._count) {
	                                n = n.left;
	                                continue;
	                              }
	                              idx -= n.left._count;
	                            }
	                            if (!idx) {
	                              return new RedBlackTreeIterator(this, stack);
	                            }
	                            idx -= 1;
	                            if (n.right) {
	                              if (idx >= n.right._count) {
	                                break;
	                              }
	                              n = n.right;
	                            } else {
	                              break;
	                            }
	                          }
	                          return new RedBlackTreeIterator(this, []);
	                        };
	                        proto.ge = function(key) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          var stack = [];
	                          var last_ptr = 0;
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            stack.push(n);
	                            if (d <= 0) {
	                              last_ptr = stack.length;
	                            }
	                            if (d <= 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          stack.length = last_ptr;
	                          return new RedBlackTreeIterator(this, stack);
	                        };
	                        proto.gt = function(key) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          var stack = [];
	                          var last_ptr = 0;
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            stack.push(n);
	                            if (d < 0) {
	                              last_ptr = stack.length;
	                            }
	                            if (d < 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          stack.length = last_ptr;
	                          return new RedBlackTreeIterator(this, stack);
	                        };
	                        proto.lt = function(key) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          var stack = [];
	                          var last_ptr = 0;
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            stack.push(n);
	                            if (d > 0) {
	                              last_ptr = stack.length;
	                            }
	                            if (d <= 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          stack.length = last_ptr;
	                          return new RedBlackTreeIterator(this, stack);
	                        };
	                        proto.le = function(key) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          var stack = [];
	                          var last_ptr = 0;
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            stack.push(n);
	                            if (d >= 0) {
	                              last_ptr = stack.length;
	                            }
	                            if (d < 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          stack.length = last_ptr;
	                          return new RedBlackTreeIterator(this, stack);
	                        };
	                        proto.find = function(key) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          var stack = [];
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            stack.push(n);
	                            if (d === 0) {
	                              return new RedBlackTreeIterator(this, stack);
	                            }
	                            if (d <= 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          return new RedBlackTreeIterator(this, []);
	                        };
	                        proto.remove = function(key) {
	                          var iter = this.find(key);
	                          if (iter) {
	                            return iter.remove();
	                          }
	                          return this;
	                        };
	                        proto.get = function(key) {
	                          var cmp = this._compare;
	                          var n = this.root;
	                          while (n) {
	                            var d = cmp(key, n.key);
	                            if (d === 0) {
	                              return n.value;
	                            }
	                            if (d <= 0) {
	                              n = n.left;
	                            } else {
	                              n = n.right;
	                            }
	                          }
	                          return;
	                        };
	                        function RedBlackTreeIterator(tree, stack) {
	                          this.tree = tree;
	                          this._stack = stack;
	                        }
	                        var iproto = RedBlackTreeIterator.prototype;
	                        Object.defineProperty(iproto, "valid", { get: function() {
	                          return this._stack.length > 0;
	                        } });
	                        Object.defineProperty(iproto, "node", { get: function() {
	                          if (this._stack.length > 0) {
	                            return this._stack[this._stack.length - 1];
	                          }
	                          return null;
	                        }, enumerable: true });
	                        iproto.clone = function() {
	                          return new RedBlackTreeIterator(this.tree, this._stack.slice());
	                        };
	                        function swapNode(n, v) {
	                          n.key = v.key;
	                          n.value = v.value;
	                          n.left = v.left;
	                          n.right = v.right;
	                          n._color = v._color;
	                          n._count = v._count;
	                        }
	                        function fixDoubleBlack(stack) {
	                          var n, p, s, z;
	                          for (var i = stack.length - 1; i >= 0; --i) {
	                            n = stack[i];
	                            if (i === 0) {
	                              n._color = BLACK;
	                              return;
	                            }
	                            p = stack[i - 1];
	                            if (p.left === n) {
	                              s = p.right;
	                              if (s.right && s.right._color === RED) {
	                                s = p.right = cloneNode(s);
	                                z = s.right = cloneNode(s.right);
	                                p.right = s.left;
	                                s.left = p;
	                                s.right = z;
	                                s._color = p._color;
	                                n._color = BLACK;
	                                p._color = BLACK;
	                                z._color = BLACK;
	                                recount(p);
	                                recount(s);
	                                if (i > 1) {
	                                  var pp = stack[i - 2];
	                                  if (pp.left === p) {
	                                    pp.left = s;
	                                  } else {
	                                    pp.right = s;
	                                  }
	                                }
	                                stack[i - 1] = s;
	                                return;
	                              } else if (s.left && s.left._color === RED) {
	                                s = p.right = cloneNode(s);
	                                z = s.left = cloneNode(s.left);
	                                p.right = z.left;
	                                s.left = z.right;
	                                z.left = p;
	                                z.right = s;
	                                z._color = p._color;
	                                p._color = BLACK;
	                                s._color = BLACK;
	                                n._color = BLACK;
	                                recount(p);
	                                recount(s);
	                                recount(z);
	                                if (i > 1) {
	                                  var pp = stack[i - 2];
	                                  if (pp.left === p) {
	                                    pp.left = z;
	                                  } else {
	                                    pp.right = z;
	                                  }
	                                }
	                                stack[i - 1] = z;
	                                return;
	                              }
	                              if (s._color === BLACK) {
	                                if (p._color === RED) {
	                                  p._color = BLACK;
	                                  p.right = repaint(RED, s);
	                                  return;
	                                } else {
	                                  p.right = repaint(RED, s);
	                                  continue;
	                                }
	                              } else {
	                                s = cloneNode(s);
	                                p.right = s.left;
	                                s.left = p;
	                                s._color = p._color;
	                                p._color = RED;
	                                recount(p);
	                                recount(s);
	                                if (i > 1) {
	                                  var pp = stack[i - 2];
	                                  if (pp.left === p) {
	                                    pp.left = s;
	                                  } else {
	                                    pp.right = s;
	                                  }
	                                }
	                                stack[i - 1] = s;
	                                stack[i] = p;
	                                if (i + 1 < stack.length) {
	                                  stack[i + 1] = n;
	                                } else {
	                                  stack.push(n);
	                                }
	                                i = i + 2;
	                              }
	                            } else {
	                              s = p.left;
	                              if (s.left && s.left._color === RED) {
	                                s = p.left = cloneNode(s);
	                                z = s.left = cloneNode(s.left);
	                                p.left = s.right;
	                                s.right = p;
	                                s.left = z;
	                                s._color = p._color;
	                                n._color = BLACK;
	                                p._color = BLACK;
	                                z._color = BLACK;
	                                recount(p);
	                                recount(s);
	                                if (i > 1) {
	                                  var pp = stack[i - 2];
	                                  if (pp.right === p) {
	                                    pp.right = s;
	                                  } else {
	                                    pp.left = s;
	                                  }
	                                }
	                                stack[i - 1] = s;
	                                return;
	                              } else if (s.right && s.right._color === RED) {
	                                s = p.left = cloneNode(s);
	                                z = s.right = cloneNode(s.right);
	                                p.left = z.right;
	                                s.right = z.left;
	                                z.right = p;
	                                z.left = s;
	                                z._color = p._color;
	                                p._color = BLACK;
	                                s._color = BLACK;
	                                n._color = BLACK;
	                                recount(p);
	                                recount(s);
	                                recount(z);
	                                if (i > 1) {
	                                  var pp = stack[i - 2];
	                                  if (pp.right === p) {
	                                    pp.right = z;
	                                  } else {
	                                    pp.left = z;
	                                  }
	                                }
	                                stack[i - 1] = z;
	                                return;
	                              }
	                              if (s._color === BLACK) {
	                                if (p._color === RED) {
	                                  p._color = BLACK;
	                                  p.left = repaint(RED, s);
	                                  return;
	                                } else {
	                                  p.left = repaint(RED, s);
	                                  continue;
	                                }
	                              } else {
	                                s = cloneNode(s);
	                                p.left = s.right;
	                                s.right = p;
	                                s._color = p._color;
	                                p._color = RED;
	                                recount(p);
	                                recount(s);
	                                if (i > 1) {
	                                  var pp = stack[i - 2];
	                                  if (pp.right === p) {
	                                    pp.right = s;
	                                  } else {
	                                    pp.left = s;
	                                  }
	                                }
	                                stack[i - 1] = s;
	                                stack[i] = p;
	                                if (i + 1 < stack.length) {
	                                  stack[i + 1] = n;
	                                } else {
	                                  stack.push(n);
	                                }
	                                i = i + 2;
	                              }
	                            }
	                          }
	                        }
	                        iproto.remove = function() {
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            return this.tree;
	                          }
	                          var cstack = new Array(stack.length);
	                          var n = stack[stack.length - 1];
	                          cstack[cstack.length - 1] = new RBNode(n._color, n.key, n.value, n.left, n.right, n._count);
	                          for (var i = stack.length - 2; i >= 0; --i) {
	                            var n = stack[i];
	                            if (n.left === stack[i + 1]) {
	                              cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i + 1], n.right, n._count);
	                            } else {
	                              cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i + 1], n._count);
	                            }
	                          }
	                          n = cstack[cstack.length - 1];
	                          if (n.left && n.right) {
	                            var split = cstack.length;
	                            n = n.left;
	                            while (n.right) {
	                              cstack.push(n);
	                              n = n.right;
	                            }
	                            var v = cstack[split - 1];
	                            cstack.push(new RBNode(n._color, v.key, v.value, n.left, n.right, n._count));
	                            cstack[split - 1].key = n.key;
	                            cstack[split - 1].value = n.value;
	                            for (var i = cstack.length - 2; i >= split; --i) {
	                              n = cstack[i];
	                              cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i + 1], n._count);
	                            }
	                            cstack[split - 1].left = cstack[split];
	                          }
	                          n = cstack[cstack.length - 1];
	                          if (n._color === RED) {
	                            var p = cstack[cstack.length - 2];
	                            if (p.left === n) {
	                              p.left = null;
	                            } else if (p.right === n) {
	                              p.right = null;
	                            }
	                            cstack.pop();
	                            for (var i = 0; i < cstack.length; ++i) {
	                              cstack[i]._count--;
	                            }
	                            return new RedBlackTree(this.tree._compare, cstack[0]);
	                          } else {
	                            if (n.left || n.right) {
	                              if (n.left) {
	                                swapNode(n, n.left);
	                              } else if (n.right) {
	                                swapNode(n, n.right);
	                              }
	                              n._color = BLACK;
	                              for (var i = 0; i < cstack.length - 1; ++i) {
	                                cstack[i]._count--;
	                              }
	                              return new RedBlackTree(this.tree._compare, cstack[0]);
	                            } else if (cstack.length === 1) {
	                              return new RedBlackTree(this.tree._compare, null);
	                            } else {
	                              for (var i = 0; i < cstack.length; ++i) {
	                                cstack[i]._count--;
	                              }
	                              var parent = cstack[cstack.length - 2];
	                              fixDoubleBlack(cstack);
	                              if (parent.left === n) {
	                                parent.left = null;
	                              } else {
	                                parent.right = null;
	                              }
	                            }
	                          }
	                          return new RedBlackTree(this.tree._compare, cstack[0]);
	                        };
	                        Object.defineProperty(iproto, "key", { get: function() {
	                          if (this._stack.length > 0) {
	                            return this._stack[this._stack.length - 1].key;
	                          }
	                          return;
	                        }, enumerable: true });
	                        Object.defineProperty(iproto, "value", { get: function() {
	                          if (this._stack.length > 0) {
	                            return this._stack[this._stack.length - 1].value;
	                          }
	                          return;
	                        }, enumerable: true });
	                        Object.defineProperty(iproto, "index", { get: function() {
	                          var idx = 0;
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            var r = this.tree.root;
	                            if (r) {
	                              return r._count;
	                            }
	                            return 0;
	                          } else if (stack[stack.length - 1].left) {
	                            idx = stack[stack.length - 1].left._count;
	                          }
	                          for (var s = stack.length - 2; s >= 0; --s) {
	                            if (stack[s + 1] === stack[s].right) {
	                              ++idx;
	                              if (stack[s].left) {
	                                idx += stack[s].left._count;
	                              }
	                            }
	                          }
	                          return idx;
	                        }, enumerable: true });
	                        iproto.next = function() {
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            return;
	                          }
	                          var n = stack[stack.length - 1];
	                          if (n.right) {
	                            n = n.right;
	                            while (n) {
	                              stack.push(n);
	                              n = n.left;
	                            }
	                          } else {
	                            stack.pop();
	                            while (stack.length > 0 && stack[stack.length - 1].right === n) {
	                              n = stack[stack.length - 1];
	                              stack.pop();
	                            }
	                          }
	                        };
	                        Object.defineProperty(iproto, "hasNext", { get: function() {
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            return false;
	                          }
	                          if (stack[stack.length - 1].right) {
	                            return true;
	                          }
	                          for (var s = stack.length - 1; s > 0; --s) {
	                            if (stack[s - 1].left === stack[s]) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        } });
	                        iproto.update = function(value) {
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            throw new Error("Can't update empty node!");
	                          }
	                          var cstack = new Array(stack.length);
	                          var n = stack[stack.length - 1];
	                          cstack[cstack.length - 1] = new RBNode(n._color, n.key, value, n.left, n.right, n._count);
	                          for (var i = stack.length - 2; i >= 0; --i) {
	                            n = stack[i];
	                            if (n.left === stack[i + 1]) {
	                              cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i + 1], n.right, n._count);
	                            } else {
	                              cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i + 1], n._count);
	                            }
	                          }
	                          return new RedBlackTree(this.tree._compare, cstack[0]);
	                        };
	                        iproto.prev = function() {
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            return;
	                          }
	                          var n = stack[stack.length - 1];
	                          if (n.left) {
	                            n = n.left;
	                            while (n) {
	                              stack.push(n);
	                              n = n.right;
	                            }
	                          } else {
	                            stack.pop();
	                            while (stack.length > 0 && stack[stack.length - 1].left === n) {
	                              n = stack[stack.length - 1];
	                              stack.pop();
	                            }
	                          }
	                        };
	                        Object.defineProperty(iproto, "hasPrev", { get: function() {
	                          var stack = this._stack;
	                          if (stack.length === 0) {
	                            return false;
	                          }
	                          if (stack[stack.length - 1].left) {
	                            return true;
	                          }
	                          for (var s = stack.length - 1; s > 0; --s) {
	                            if (stack[s - 1].right === stack[s]) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        } });
	                        function defaultCompare(a, b) {
	                          if (a < b) {
	                            return -1;
	                          }
	                          if (a > b) {
	                            return 1;
	                          }
	                          return 0;
	                        }
	                        function createRBTree(compare) {
	                          return new RedBlackTree(compare || defaultCompare, null);
	                        }
	                      }
	                    ),
	                    /***/
	                    7453: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_236846__) {
	                        module3.exports = createAxes;
	                        var createText = __nested_webpack_require_236846__(9557);
	                        var createLines = __nested_webpack_require_236846__(1681);
	                        var createBackground = __nested_webpack_require_236846__(1011);
	                        var getCubeProperties = __nested_webpack_require_236846__(2864);
	                        var Ticks = __nested_webpack_require_236846__(8468);
	                        var identity2 = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
	                        function copyVec3(a, b) {
	                          a[0] = b[0];
	                          a[1] = b[1];
	                          a[2] = b[2];
	                          return a;
	                        }
	                        function Axes(gl2) {
	                          this.gl = gl2;
	                          this.pixelRatio = 1;
	                          this.bounds = [[-10, -10, -10], [10, 10, 10]];
	                          this.ticks = [[], [], []];
	                          this.autoTicks = true;
	                          this.tickSpacing = [1, 1, 1];
	                          this.tickEnable = [true, true, true];
	                          this.tickFont = ["sans-serif", "sans-serif", "sans-serif"];
	                          this.tickSize = [12, 12, 12];
	                          this.tickAngle = [0, 0, 0];
	                          this.tickAlign = ["auto", "auto", "auto"];
	                          this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.tickPad = [10, 10, 10];
	                          this.lastCubeProps = { cubeEdges: [0, 0, 0], axis: [0, 0, 0] };
	                          this.labels = ["x", "y", "z"];
	                          this.labelEnable = [true, true, true];
	                          this.labelFont = "sans-serif";
	                          this.labelSize = [20, 20, 20];
	                          this.labelAngle = [0, 0, 0];
	                          this.labelAlign = ["auto", "auto", "auto"];
	                          this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.labelPad = [10, 10, 10];
	                          this.lineEnable = [true, true, true];
	                          this.lineMirror = [false, false, false];
	                          this.lineWidth = [1, 1, 1];
	                          this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.lineTickEnable = [true, true, true];
	                          this.lineTickMirror = [false, false, false];
	                          this.lineTickLength = [0, 0, 0];
	                          this.lineTickWidth = [1, 1, 1];
	                          this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.gridEnable = [true, true, true];
	                          this.gridWidth = [1, 1, 1];
	                          this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.zeroEnable = [true, true, true];
	                          this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.zeroLineWidth = [2, 2, 2];
	                          this.backgroundEnable = [false, false, false];
	                          this.backgroundColor = [[0.8, 0.8, 0.8, 0.5], [0.8, 0.8, 0.8, 0.5], [0.8, 0.8, 0.8, 0.5]];
	                          this._firstInit = true;
	                          this._text = null;
	                          this._lines = null;
	                          this._background = createBackground(gl2);
	                        }
	                        var proto = Axes.prototype;
	                        proto.update = function(options) {
	                          options = options || {};
	                          function parseOption(nest, cons, name2) {
	                            if (name2 in options) {
	                              var opt = options[name2];
	                              var prev = this[name2];
	                              var next;
	                              if (nest ? Array.isArray(opt) && Array.isArray(opt[0]) : Array.isArray(opt)) {
	                                this[name2] = next = [cons(opt[0]), cons(opt[1]), cons(opt[2])];
	                              } else {
	                                this[name2] = next = [cons(opt), cons(opt), cons(opt)];
	                              }
	                              for (var i2 = 0; i2 < 3; ++i2) {
	                                if (next[i2] !== prev[i2]) {
	                                  return true;
	                                }
	                              }
	                            }
	                            return false;
	                          }
	                          var NUMBER = parseOption.bind(this, false, Number);
	                          var BOOLEAN = parseOption.bind(this, false, Boolean);
	                          var STRING = parseOption.bind(this, false, String);
	                          var COLOR = parseOption.bind(this, true, function(v) {
	                            if (Array.isArray(v)) {
	                              if (v.length === 3) {
	                                return [+v[0], +v[1], +v[2], 1];
	                              } else if (v.length === 4) {
	                                return [+v[0], +v[1], +v[2], +v[3]];
	                              }
	                            }
	                            return [0, 0, 0, 1];
	                          });
	                          var nextTicks;
	                          var ticksUpdate = false;
	                          var boundsChanged = false;
	                          if ("bounds" in options) {
	                            var bounds = options.bounds;
	                            for (var i = 0; i < 2; ++i) {
	                              for (var j = 0; j < 3; ++j) {
	                                if (bounds[i][j] !== this.bounds[i][j]) {
	                                  boundsChanged = true;
	                                }
	                                this.bounds[i][j] = bounds[i][j];
	                              }
	                            }
	                          }
	                          if ("ticks" in options) {
	                            nextTicks = options.ticks;
	                            ticksUpdate = true;
	                            this.autoTicks = false;
	                            for (var i = 0; i < 3; ++i) {
	                              this.tickSpacing[i] = 0;
	                            }
	                          } else if (NUMBER("tickSpacing")) {
	                            this.autoTicks = true;
	                            boundsChanged = true;
	                          }
	                          if (this._firstInit) {
	                            if (!("ticks" in options || "tickSpacing" in options)) {
	                              this.autoTicks = true;
	                            }
	                            boundsChanged = true;
	                            ticksUpdate = true;
	                            this._firstInit = false;
	                          }
	                          if (boundsChanged && this.autoTicks) {
	                            nextTicks = Ticks.create(this.bounds, this.tickSpacing);
	                            ticksUpdate = true;
	                          }
	                          if (ticksUpdate) {
	                            for (var i = 0; i < 3; ++i) {
	                              nextTicks[i].sort(function(a, b) {
	                                return a.x - b.x;
	                              });
	                            }
	                            if (Ticks.equal(nextTicks, this.ticks)) {
	                              ticksUpdate = false;
	                            } else {
	                              this.ticks = nextTicks;
	                            }
	                          }
	                          BOOLEAN("tickEnable");
	                          if (STRING("tickFont")) {
	                            ticksUpdate = true;
	                          }
	                          NUMBER("tickSize");
	                          NUMBER("tickAngle");
	                          NUMBER("tickPad");
	                          COLOR("tickColor");
	                          var labelUpdate = STRING("labels");
	                          if (STRING("labelFont")) {
	                            labelUpdate = true;
	                          }
	                          BOOLEAN("labelEnable");
	                          NUMBER("labelSize");
	                          NUMBER("labelPad");
	                          COLOR("labelColor");
	                          BOOLEAN("lineEnable");
	                          BOOLEAN("lineMirror");
	                          NUMBER("lineWidth");
	                          COLOR("lineColor");
	                          BOOLEAN("lineTickEnable");
	                          BOOLEAN("lineTickMirror");
	                          NUMBER("lineTickLength");
	                          NUMBER("lineTickWidth");
	                          COLOR("lineTickColor");
	                          BOOLEAN("gridEnable");
	                          NUMBER("gridWidth");
	                          COLOR("gridColor");
	                          BOOLEAN("zeroEnable");
	                          COLOR("zeroLineColor");
	                          NUMBER("zeroLineWidth");
	                          BOOLEAN("backgroundEnable");
	                          COLOR("backgroundColor");
	                          if (!this._text) {
	                            this._text = createText(this.gl, this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont);
	                          } else if (this._text && (labelUpdate || ticksUpdate)) {
	                            this._text.update(this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont);
	                          }
	                          if (this._lines && ticksUpdate) {
	                            this._lines.dispose();
	                            this._lines = null;
	                          }
	                          if (!this._lines) {
	                            this._lines = createLines(this.gl, this.bounds, this.ticks);
	                          }
	                        };
	                        function OffsetInfo() {
	                          this.primalOffset = [0, 0, 0];
	                          this.primalMinor = [0, 0, 0];
	                          this.mirrorOffset = [0, 0, 0];
	                          this.mirrorMinor = [0, 0, 0];
	                        }
	                        var LINE_OFFSET = [new OffsetInfo(), new OffsetInfo(), new OffsetInfo()];
	                        function computeLineOffset(result, i, bounds, cubeEdges, cubeAxis) {
	                          var primalOffset = result.primalOffset;
	                          var primalMinor = result.primalMinor;
	                          var dualOffset = result.mirrorOffset;
	                          var dualMinor = result.mirrorMinor;
	                          var e = cubeEdges[i];
	                          for (var j = 0; j < 3; ++j) {
	                            if (i === j) {
	                              continue;
	                            }
	                            var a = primalOffset, b = dualOffset, c = primalMinor, d = dualMinor;
	                            if (e & 1 << j) {
	                              a = dualOffset;
	                              b = primalOffset;
	                              c = dualMinor;
	                              d = primalMinor;
	                            }
	                            a[j] = bounds[0][j];
	                            b[j] = bounds[1][j];
	                            if (cubeAxis[j] > 0) {
	                              c[j] = -1;
	                              d[j] = 0;
	                            } else {
	                              c[j] = 0;
	                              d[j] = 1;
	                            }
	                          }
	                        }
	                        var CUBE_ENABLE = [0, 0, 0];
	                        var DEFAULT_PARAMS = { model: identity2, view: identity2, projection: identity2, _ortho: false };
	                        proto.isOpaque = function() {
	                          return true;
	                        };
	                        proto.isTransparent = function() {
	                          return false;
	                        };
	                        proto.drawTransparent = function(params) {
	                        };
	                        var ALIGN_OPTION_AUTO = 0;
	                        var PRIMAL_MINOR = [0, 0, 0];
	                        var MIRROR_MINOR = [0, 0, 0];
	                        var PRIMAL_OFFSET = [0, 0, 0];
	                        proto.draw = function(params) {
	                          params = params || DEFAULT_PARAMS;
	                          var gl2 = this.gl;
	                          var model = params.model || identity2;
	                          var view = params.view || identity2;
	                          var projection = params.projection || identity2;
	                          var bounds = this.bounds;
	                          var isOrtho = params._ortho || false;
	                          var cubeParams = getCubeProperties(model, view, projection, bounds, isOrtho);
	                          var cubeEdges = cubeParams.cubeEdges;
	                          var cubeAxis = cubeParams.axis;
	                          var cx = view[12];
	                          var cy = view[13];
	                          var cz = view[14];
	                          var cw = view[15];
	                          var orthoFix = isOrtho ? 2 : 1;
	                          var pixelScaleF = orthoFix * this.pixelRatio * (projection[3] * cx + projection[7] * cy + projection[11] * cz + projection[15] * cw) / gl2.drawingBufferHeight;
	                          for (var i = 0; i < 3; ++i) {
	                            this.lastCubeProps.cubeEdges[i] = cubeEdges[i];
	                            this.lastCubeProps.axis[i] = cubeAxis[i];
	                          }
	                          var lineOffset = LINE_OFFSET;
	                          for (var i = 0; i < 3; ++i) {
	                            computeLineOffset(LINE_OFFSET[i], i, this.bounds, cubeEdges, cubeAxis);
	                          }
	                          var gl2 = this.gl;
	                          var cubeEnable = CUBE_ENABLE;
	                          for (var i = 0; i < 3; ++i) {
	                            if (this.backgroundEnable[i]) {
	                              cubeEnable[i] = cubeAxis[i];
	                            } else {
	                              cubeEnable[i] = 0;
	                            }
	                          }
	                          this._background.draw(model, view, projection, bounds, cubeEnable, this.backgroundColor);
	                          this._lines.bind(model, view, projection, this);
	                          for (var i = 0; i < 3; ++i) {
	                            var x = [0, 0, 0];
	                            if (cubeAxis[i] > 0) {
	                              x[i] = bounds[1][i];
	                            } else {
	                              x[i] = bounds[0][i];
	                            }
	                            for (var j = 0; j < 2; ++j) {
	                              var u = (i + 1 + j) % 3;
	                              var v = (i + 1 + (j ^ 1)) % 3;
	                              if (this.gridEnable[u]) {
	                                this._lines.drawGrid(u, v, this.bounds, x, this.gridColor[u], this.gridWidth[u] * this.pixelRatio);
	                              }
	                            }
	                            for (var j = 0; j < 2; ++j) {
	                              var u = (i + 1 + j) % 3;
	                              var v = (i + 1 + (j ^ 1)) % 3;
	                              if (this.zeroEnable[v]) {
	                                if (Math.min(bounds[0][v], bounds[1][v]) <= 0 && Math.max(bounds[0][v], bounds[1][v]) >= 0) {
	                                  this._lines.drawZero(u, v, this.bounds, x, this.zeroLineColor[v], this.zeroLineWidth[v] * this.pixelRatio);
	                                }
	                              }
	                            }
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            if (this.lineEnable[i]) {
	                              this._lines.drawAxisLine(i, this.bounds, lineOffset[i].primalOffset, this.lineColor[i], this.lineWidth[i] * this.pixelRatio);
	                            }
	                            if (this.lineMirror[i]) {
	                              this._lines.drawAxisLine(i, this.bounds, lineOffset[i].mirrorOffset, this.lineColor[i], this.lineWidth[i] * this.pixelRatio);
	                            }
	                            var primalMinor = copyVec3(PRIMAL_MINOR, lineOffset[i].primalMinor);
	                            var mirrorMinor = copyVec3(MIRROR_MINOR, lineOffset[i].mirrorMinor);
	                            var tickLength = this.lineTickLength;
	                            for (var j = 0; j < 3; ++j) {
	                              var scaleFactor = pixelScaleF / model[5 * j];
	                              primalMinor[j] *= tickLength[j] * scaleFactor;
	                              mirrorMinor[j] *= tickLength[j] * scaleFactor;
	                            }
	                            if (this.lineTickEnable[i]) {
	                              this._lines.drawAxisTicks(i, lineOffset[i].primalOffset, primalMinor, this.lineTickColor[i], this.lineTickWidth[i] * this.pixelRatio);
	                            }
	                            if (this.lineTickMirror[i]) {
	                              this._lines.drawAxisTicks(i, lineOffset[i].mirrorOffset, mirrorMinor, this.lineTickColor[i], this.lineTickWidth[i] * this.pixelRatio);
	                            }
	                          }
	                          this._lines.unbind();
	                          this._text.bind(model, view, projection, this.pixelRatio);
	                          var alignOpt;
	                          var hv_ratio = 0.5;
	                          var enableAlign;
	                          var alignDir;
	                          function alignTo(i2) {
	                            alignDir = [0, 0, 0];
	                            alignDir[i2] = 1;
	                          }
	                          function solveTickAlignments(i2, minor2, major2) {
	                            var i1 = (i2 + 1) % 3;
	                            var i22 = (i2 + 2) % 3;
	                            var A = minor2[i1];
	                            var B = minor2[i22];
	                            var C = major2[i1];
	                            var D = major2[i22];
	                            if (A > 0 && D > 0) {
	                              alignTo(i1);
	                              return;
	                            } else if (A > 0 && D < 0) {
	                              alignTo(i1);
	                              return;
	                            } else if (A < 0 && D > 0) {
	                              alignTo(i1);
	                              return;
	                            } else if (A < 0 && D < 0) {
	                              alignTo(i1);
	                              return;
	                            } else if (B > 0 && C > 0) {
	                              alignTo(i22);
	                              return;
	                            } else if (B > 0 && C < 0) {
	                              alignTo(i22);
	                              return;
	                            } else if (B < 0 && C > 0) {
	                              alignTo(i22);
	                              return;
	                            } else if (B < 0 && C < 0) {
	                              alignTo(i22);
	                              return;
	                            }
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            var minor = lineOffset[i].primalMinor;
	                            var major = lineOffset[i].mirrorMinor;
	                            var offset = copyVec3(PRIMAL_OFFSET, lineOffset[i].primalOffset);
	                            for (var j = 0; j < 3; ++j) {
	                              if (this.lineTickEnable[i]) {
	                                offset[j] += pixelScaleF * minor[j] * Math.max(this.lineTickLength[j], 0) / model[5 * j];
	                              }
	                            }
	                            var axis = [0, 0, 0];
	                            axis[i] = 1;
	                            if (this.tickEnable[i]) {
	                              if (this.tickAngle[i] === -3600) {
	                                this.tickAngle[i] = 0;
	                                this.tickAlign[i] = "auto";
	                              } else {
	                                this.tickAlign[i] = -1;
	                              }
	                              enableAlign = 1;
	                              alignOpt = [this.tickAlign[i], hv_ratio, enableAlign];
	                              if (alignOpt[0] === "auto") alignOpt[0] = ALIGN_OPTION_AUTO;
	                              else alignOpt[0] = parseInt("" + alignOpt[0]);
	                              alignDir = [0, 0, 0];
	                              solveTickAlignments(i, minor, major);
	                              for (var j = 0; j < 3; ++j) {
	                                offset[j] += pixelScaleF * minor[j] * this.tickPad[j] / model[5 * j];
	                              }
	                              this._text.drawTicks(i, this.tickSize[i], this.tickAngle[i], offset, this.tickColor[i], axis, alignDir, alignOpt);
	                            }
	                            if (this.labelEnable[i]) {
	                              enableAlign = 0;
	                              alignDir = [0, 0, 0];
	                              if (this.labels[i].length > 4) {
	                                alignTo(i);
	                                enableAlign = 1;
	                              }
	                              alignOpt = [this.labelAlign[i], hv_ratio, enableAlign];
	                              if (alignOpt[0] === "auto") alignOpt[0] = ALIGN_OPTION_AUTO;
	                              else alignOpt[0] = parseInt("" + alignOpt[0]);
	                              for (var j = 0; j < 3; ++j) {
	                                offset[j] += pixelScaleF * minor[j] * this.labelPad[j] / model[5 * j];
	                              }
	                              offset[i] += 0.5 * (bounds[0][i] + bounds[1][i]);
	                              this._text.drawLabel(i, this.labelSize[i], this.labelAngle[i], offset, this.labelColor[i], [0, 0, 0], alignDir, alignOpt);
	                            }
	                          }
	                          this._text.unbind();
	                        };
	                        proto.dispose = function() {
	                          this._text.dispose();
	                          this._lines.dispose();
	                          this._background.dispose();
	                          this._lines = null;
	                          this._text = null;
	                          this._background = null;
	                          this.gl = null;
	                        };
	                        function createAxes(gl2, options) {
	                          var axes = new Axes(gl2);
	                          axes.update(options);
	                          return axes;
	                        }
	                      }
	                    ),
	                    /***/
	                    1011: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_248714__) {
	                        module3.exports = createBackgroundCube;
	                        var createBuffer = __nested_webpack_require_248714__(5827);
	                        var createVAO = __nested_webpack_require_248714__(2944);
	                        var createShader = __nested_webpack_require_248714__(1943).bg;
	                        function BackgroundCube(gl2, buffer, vao, shader) {
	                          this.gl = gl2;
	                          this.buffer = buffer;
	                          this.vao = vao;
	                          this.shader = shader;
	                        }
	                        var proto = BackgroundCube.prototype;
	                        proto.draw = function(model, view, projection, bounds, enable, colors) {
	                          var needsBG = false;
	                          for (var i = 0; i < 3; ++i) {
	                            needsBG = needsBG || enable[i];
	                          }
	                          if (!needsBG) {
	                            return;
	                          }
	                          var gl2 = this.gl;
	                          gl2.enable(gl2.POLYGON_OFFSET_FILL);
	                          gl2.polygonOffset(1, 2);
	                          this.shader.bind();
	                          this.shader.uniforms = { model, view, projection, bounds, enable, colors };
	                          this.vao.bind();
	                          this.vao.draw(this.gl.TRIANGLES, 36);
	                          this.vao.unbind();
	                          gl2.disable(gl2.POLYGON_OFFSET_FILL);
	                        };
	                        proto.dispose = function() {
	                          this.vao.dispose();
	                          this.buffer.dispose();
	                          this.shader.dispose();
	                        };
	                        function createBackgroundCube(gl2) {
	                          var vertices = [];
	                          var indices = [];
	                          var ptr = 0;
	                          for (var d = 0; d < 3; ++d) {
	                            var u = (d + 1) % 3;
	                            var v = (d + 2) % 3;
	                            var x = [0, 0, 0];
	                            var c = [0, 0, 0];
	                            for (var s = -1; s <= 1; s += 2) {
	                              indices.push(ptr, ptr + 2, ptr + 1, ptr + 1, ptr + 2, ptr + 3);
	                              x[d] = s;
	                              c[d] = s;
	                              for (var i = -1; i <= 1; i += 2) {
	                                x[u] = i;
	                                for (var j = -1; j <= 1; j += 2) {
	                                  x[v] = j;
	                                  vertices.push(x[0], x[1], x[2], c[0], c[1], c[2]);
	                                  ptr += 1;
	                                }
	                              }
	                              var tt = u;
	                              u = v;
	                              v = tt;
	                            }
	                          }
	                          var buffer = createBuffer(gl2, new Float32Array(vertices));
	                          var elements = createBuffer(gl2, new Uint16Array(indices), gl2.ELEMENT_ARRAY_BUFFER);
	                          var vao = createVAO(gl2, [{ buffer, type: gl2.FLOAT, size: 3, offset: 0, stride: 24 }, { buffer, type: gl2.FLOAT, size: 3, offset: 12, stride: 24 }], elements);
	                          var shader = createShader(gl2);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.normal.location = 1;
	                          return new BackgroundCube(gl2, buffer, vao, shader);
	                        }
	                      }
	                    ),
	                    /***/
	                    2864: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_250569__) {
	                        module3.exports = getCubeEdges;
	                        var bits = __nested_webpack_require_250569__(2288);
	                        var multiply = __nested_webpack_require_250569__(104);
	                        var splitPoly = __nested_webpack_require_250569__(4670);
	                        var orient = __nested_webpack_require_250569__(417);
	                        var mvp = new Array(16);
	                        var pCubeVerts = new Array(8);
	                        var cubeVerts = new Array(8);
	                        var x = new Array(3);
	                        var zero3 = [0, 0, 0];
	                        (function() {
	                          for (var i = 0; i < 8; ++i) {
	                            pCubeVerts[i] = [1, 1, 1, 1];
	                            cubeVerts[i] = [1, 1, 1];
	                          }
	                        })();
	                        function transformHg(result, x2, mat) {
	                          for (var i = 0; i < 4; ++i) {
	                            result[i] = mat[12 + i];
	                            for (var j = 0; j < 3; ++j) {
	                              result[i] += x2[j] * mat[4 * j + i];
	                            }
	                          }
	                        }
	                        var FRUSTUM_PLANES = [[0, 0, 1, 0, 0], [0, 0, -1, 1, 0], [0, -1, 0, 1, 0], [0, 1, 0, 1, 0], [-1, 0, 0, 1, 0], [1, 0, 0, 1, 0]];
	                        function polygonArea(p) {
	                          for (var i = 0; i < FRUSTUM_PLANES.length; ++i) {
	                            p = splitPoly.positive(p, FRUSTUM_PLANES[i]);
	                            if (p.length < 3) {
	                              return 0;
	                            }
	                          }
	                          var base = p[0];
	                          var ax = base[0] / base[3];
	                          var ay = base[1] / base[3];
	                          var area = 0;
	                          for (var i = 1; i + 1 < p.length; ++i) {
	                            var b = p[i];
	                            var c = p[i + 1];
	                            var bx = b[0] / b[3];
	                            var by = b[1] / b[3];
	                            var cx = c[0] / c[3];
	                            var cy = c[1] / c[3];
	                            var ux = bx - ax;
	                            var uy = by - ay;
	                            var vx = cx - ax;
	                            var vy = cy - ay;
	                            area += Math.abs(ux * vy - uy * vx);
	                          }
	                          return area;
	                        }
	                        var CUBE_EDGES = [1, 1, 1];
	                        var CUBE_AXIS = [0, 0, 0];
	                        var CUBE_RESULT = { cubeEdges: CUBE_EDGES, axis: CUBE_AXIS };
	                        function getCubeEdges(model, view, projection, bounds, ortho) {
	                          multiply(mvp, view, model);
	                          multiply(mvp, projection, mvp);
	                          var ptr = 0;
	                          for (var i = 0; i < 2; ++i) {
	                            x[2] = bounds[i][2];
	                            for (var j = 0; j < 2; ++j) {
	                              x[1] = bounds[j][1];
	                              for (var k = 0; k < 2; ++k) {
	                                x[0] = bounds[k][0];
	                                transformHg(pCubeVerts[ptr], x, mvp);
	                                ptr += 1;
	                              }
	                            }
	                          }
	                          var closest = -1;
	                          for (var i = 0; i < 8; ++i) {
	                            var w = pCubeVerts[i][3];
	                            for (var l = 0; l < 3; ++l) {
	                              cubeVerts[i][l] = pCubeVerts[i][l] / w;
	                            }
	                            if (ortho) cubeVerts[i][2] *= -1;
	                            if (w < 0) {
	                              if (closest < 0) {
	                                closest = i;
	                              } else if (cubeVerts[i][2] < cubeVerts[closest][2]) {
	                                closest = i;
	                              }
	                            }
	                          }
	                          if (closest < 0) {
	                            closest = 0;
	                            for (var d = 0; d < 3; ++d) {
	                              var u = (d + 2) % 3;
	                              var v = (d + 1) % 3;
	                              var o0 = -1;
	                              var o1 = -1;
	                              for (var s = 0; s < 2; ++s) {
	                                var f0 = s << d;
	                                var f1 = f0 + (s << u) + (1 - s << v);
	                                var f2 = f0 + (1 - s << u) + (s << v);
	                                if (orient(cubeVerts[f0], cubeVerts[f1], cubeVerts[f2], zero3) < 0) {
	                                  continue;
	                                }
	                                if (s) {
	                                  o0 = 1;
	                                } else {
	                                  o1 = 1;
	                                }
	                              }
	                              if (o0 < 0 || o1 < 0) {
	                                if (o1 > o0) {
	                                  closest |= 1 << d;
	                                }
	                                continue;
	                              }
	                              for (var s = 0; s < 2; ++s) {
	                                var f0 = s << d;
	                                var f1 = f0 + (s << u) + (1 - s << v);
	                                var f2 = f0 + (1 - s << u) + (s << v);
	                                var o = polygonArea([pCubeVerts[f0], pCubeVerts[f1], pCubeVerts[f2], pCubeVerts[f0 + (1 << u) + (1 << v)]]);
	                                if (s) {
	                                  o0 = o;
	                                } else {
	                                  o1 = o;
	                                }
	                              }
	                              if (o1 > o0) {
	                                closest |= 1 << d;
	                                continue;
	                              }
	                            }
	                          }
	                          var farthest = 7 ^ closest;
	                          var bottom = -1;
	                          for (var i = 0; i < 8; ++i) {
	                            if (i === closest || i === farthest) {
	                              continue;
	                            }
	                            if (bottom < 0) {
	                              bottom = i;
	                            } else if (cubeVerts[bottom][1] > cubeVerts[i][1]) {
	                              bottom = i;
	                            }
	                          }
	                          var left = -1;
	                          for (var i = 0; i < 3; ++i) {
	                            var idx = bottom ^ 1 << i;
	                            if (idx === closest || idx === farthest) {
	                              continue;
	                            }
	                            if (left < 0) {
	                              left = idx;
	                            }
	                            var v = cubeVerts[idx];
	                            if (v[0] < cubeVerts[left][0]) {
	                              left = idx;
	                            }
	                          }
	                          var right = -1;
	                          for (var i = 0; i < 3; ++i) {
	                            var idx = bottom ^ 1 << i;
	                            if (idx === closest || idx === farthest || idx === left) {
	                              continue;
	                            }
	                            if (right < 0) {
	                              right = idx;
	                            }
	                            var v = cubeVerts[idx];
	                            if (v[0] > cubeVerts[right][0]) {
	                              right = idx;
	                            }
	                          }
	                          var cubeEdges = CUBE_EDGES;
	                          cubeEdges[0] = cubeEdges[1] = cubeEdges[2] = 0;
	                          cubeEdges[bits.log2(left ^ bottom)] = bottom & left;
	                          cubeEdges[bits.log2(bottom ^ right)] = bottom & right;
	                          var top = right ^ 7;
	                          if (top === closest || top === farthest) {
	                            top = left ^ 7;
	                            cubeEdges[bits.log2(right ^ top)] = top & right;
	                          } else {
	                            cubeEdges[bits.log2(left ^ top)] = top & left;
	                          }
	                          var axis = CUBE_AXIS;
	                          var cutCorner = closest;
	                          for (var d = 0; d < 3; ++d) {
	                            if (cutCorner & 1 << d) {
	                              axis[d] = -1;
	                            } else {
	                              axis[d] = 1;
	                            }
	                          }
	                          return CUBE_RESULT;
	                        }
	                      }
	                    ),
	                    /***/
	                    1681: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_254123__) {
	                        module3.exports = createLines;
	                        var createBuffer = __nested_webpack_require_254123__(5827);
	                        var createVAO = __nested_webpack_require_254123__(2944);
	                        var createShader = __nested_webpack_require_254123__(1943).j;
	                        var MAJOR_AXIS = [0, 0, 0];
	                        var MINOR_AXIS = [0, 0, 0];
	                        var SCREEN_AXIS = [0, 0, 0];
	                        var OFFSET_VEC = [0, 0, 0];
	                        var SHAPE = [1, 1];
	                        function zeroVec(a) {
	                          a[0] = a[1] = a[2] = 0;
	                          return a;
	                        }
	                        function copyVec(a, b) {
	                          a[0] = b[0];
	                          a[1] = b[1];
	                          a[2] = b[2];
	                          return a;
	                        }
	                        function Lines(gl2, vertBuffer, vao, shader, tickCount, tickOffset, gridCount, gridOffset) {
	                          this.gl = gl2;
	                          this.vertBuffer = vertBuffer;
	                          this.vao = vao;
	                          this.shader = shader;
	                          this.tickCount = tickCount;
	                          this.tickOffset = tickOffset;
	                          this.gridCount = gridCount;
	                          this.gridOffset = gridOffset;
	                        }
	                        var proto = Lines.prototype;
	                        proto.bind = function(model, view, projection) {
	                          this.shader.bind();
	                          this.shader.uniforms.model = model;
	                          this.shader.uniforms.view = view;
	                          this.shader.uniforms.projection = projection;
	                          SHAPE[0] = this.gl.drawingBufferWidth;
	                          SHAPE[1] = this.gl.drawingBufferHeight;
	                          this.shader.uniforms.screenShape = SHAPE;
	                          this.vao.bind();
	                        };
	                        proto.unbind = function() {
	                          this.vao.unbind();
	                        };
	                        proto.drawAxisLine = function(j, bounds, offset, color, lineWidth) {
	                          var minorAxis = zeroVec(MINOR_AXIS);
	                          this.shader.uniforms.majorAxis = MINOR_AXIS;
	                          minorAxis[j] = bounds[1][j] - bounds[0][j];
	                          this.shader.uniforms.minorAxis = minorAxis;
	                          var noffset = copyVec(OFFSET_VEC, offset);
	                          noffset[j] += bounds[0][j];
	                          this.shader.uniforms.offset = noffset;
	                          this.shader.uniforms.lineWidth = lineWidth;
	                          this.shader.uniforms.color = color;
	                          var screenAxis = zeroVec(SCREEN_AXIS);
	                          screenAxis[(j + 2) % 3] = 1;
	                          this.shader.uniforms.screenAxis = screenAxis;
	                          this.vao.draw(this.gl.TRIANGLES, 6);
	                          var screenAxis = zeroVec(SCREEN_AXIS);
	                          screenAxis[(j + 1) % 3] = 1;
	                          this.shader.uniforms.screenAxis = screenAxis;
	                          this.vao.draw(this.gl.TRIANGLES, 6);
	                        };
	                        proto.drawAxisTicks = function(j, offset, minorAxis, color, lineWidth) {
	                          if (!this.tickCount[j]) {
	                            return;
	                          }
	                          var majorAxis = zeroVec(MAJOR_AXIS);
	                          majorAxis[j] = 1;
	                          this.shader.uniforms.majorAxis = majorAxis;
	                          this.shader.uniforms.offset = offset;
	                          this.shader.uniforms.minorAxis = minorAxis;
	                          this.shader.uniforms.color = color;
	                          this.shader.uniforms.lineWidth = lineWidth;
	                          var screenAxis = zeroVec(SCREEN_AXIS);
	                          screenAxis[j] = 1;
	                          this.shader.uniforms.screenAxis = screenAxis;
	                          this.vao.draw(this.gl.TRIANGLES, this.tickCount[j], this.tickOffset[j]);
	                        };
	                        proto.drawGrid = function(i, j, bounds, offset, color, lineWidth) {
	                          if (!this.gridCount[i]) {
	                            return;
	                          }
	                          var minorAxis = zeroVec(MINOR_AXIS);
	                          minorAxis[j] = bounds[1][j] - bounds[0][j];
	                          this.shader.uniforms.minorAxis = minorAxis;
	                          var noffset = copyVec(OFFSET_VEC, offset);
	                          noffset[j] += bounds[0][j];
	                          this.shader.uniforms.offset = noffset;
	                          var majorAxis = zeroVec(MAJOR_AXIS);
	                          majorAxis[i] = 1;
	                          this.shader.uniforms.majorAxis = majorAxis;
	                          var screenAxis = zeroVec(SCREEN_AXIS);
	                          screenAxis[i] = 1;
	                          this.shader.uniforms.screenAxis = screenAxis;
	                          this.shader.uniforms.lineWidth = lineWidth;
	                          this.shader.uniforms.color = color;
	                          this.vao.draw(this.gl.TRIANGLES, this.gridCount[i], this.gridOffset[i]);
	                        };
	                        proto.drawZero = function(j, i, bounds, offset, color, lineWidth) {
	                          var minorAxis = zeroVec(MINOR_AXIS);
	                          this.shader.uniforms.majorAxis = minorAxis;
	                          minorAxis[j] = bounds[1][j] - bounds[0][j];
	                          this.shader.uniforms.minorAxis = minorAxis;
	                          var noffset = copyVec(OFFSET_VEC, offset);
	                          noffset[j] += bounds[0][j];
	                          this.shader.uniforms.offset = noffset;
	                          var screenAxis = zeroVec(SCREEN_AXIS);
	                          screenAxis[i] = 1;
	                          this.shader.uniforms.screenAxis = screenAxis;
	                          this.shader.uniforms.lineWidth = lineWidth;
	                          this.shader.uniforms.color = color;
	                          this.vao.draw(this.gl.TRIANGLES, 6);
	                        };
	                        proto.dispose = function() {
	                          this.vao.dispose();
	                          this.vertBuffer.dispose();
	                          this.shader.dispose();
	                        };
	                        function createLines(gl2, bounds, ticks) {
	                          var vertices = [];
	                          var tickOffset = [0, 0, 0];
	                          var tickCount = [0, 0, 0];
	                          var gridOffset = [0, 0, 0];
	                          var gridCount = [0, 0, 0];
	                          vertices.push(0, 0, 1, 0, 1, 1, 0, 0, -1, 0, 0, -1, 0, 1, 1, 0, 1, -1);
	                          for (var i = 0; i < 3; ++i) {
	                            var start = vertices.length / 3 | 0;
	                            for (var j = 0; j < ticks[i].length; ++j) {
	                              var x = +ticks[i][j].x;
	                              vertices.push(x, 0, 1, x, 1, 1, x, 0, -1, x, 0, -1, x, 1, 1, x, 1, -1);
	                            }
	                            var end = vertices.length / 3 | 0;
	                            tickOffset[i] = start;
	                            tickCount[i] = end - start;
	                            var start = vertices.length / 3 | 0;
	                            for (var k = 0; k < ticks[i].length; ++k) {
	                              var x = +ticks[i][k].x;
	                              vertices.push(x, 0, 1, x, 1, 1, x, 0, -1, x, 0, -1, x, 1, 1, x, 1, -1);
	                            }
	                            var end = vertices.length / 3 | 0;
	                            gridOffset[i] = start;
	                            gridCount[i] = end - start;
	                          }
	                          var vertBuf = createBuffer(gl2, new Float32Array(vertices));
	                          var vao = createVAO(gl2, [{ "buffer": vertBuf, "type": gl2.FLOAT, "size": 3, "stride": 0, "offset": 0 }]);
	                          var shader = createShader(gl2);
	                          shader.attributes.position.location = 0;
	                          return new Lines(gl2, vertBuf, vao, shader, tickCount, tickOffset, gridCount, gridOffset);
	                        }
	                      }
	                    ),
	                    /***/
	                    1943: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_258696__) {
	                        var glslify = __nested_webpack_require_258696__(6832);
	                        var createShader = __nested_webpack_require_258696__(5158);
	                        var lineVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"]);
	                        var lineFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);
	                        exports2.j = function(gl2) {
	                          return createShader(gl2, lineVert, lineFrag, null, [{ name: "position", type: "vec3" }]);
	                        };
	                        var textVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}"]);
	                        var textFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);
	                        exports2.f = function(gl2) {
	                          return createShader(gl2, textVert, textFrag, null, [{ name: "position", type: "vec3" }]);
	                        };
	                        var bgVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * view * model * vec4(nPosition, 1.0);\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}"]);
	                        var bgFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"]);
	                        exports2.bg = function(gl2) {
	                          return createShader(gl2, bgVert, bgFrag, null, [{ name: "position", type: "vec3" }, { name: "normal", type: "vec3" }]);
	                        };
	                      }
	                    ),
	                    /***/
	                    9557: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_265252__) {
	                        module3.exports = createTextSprites;
	                        var createBuffer = __nested_webpack_require_265252__(5827);
	                        var createVAO = __nested_webpack_require_265252__(2944);
	                        var vectorizeText = __nested_webpack_require_265252__(875);
	                        var createShader = __nested_webpack_require_265252__(1943).f;
	                        var globals = window || process.global || {};
	                        var __TEXT_CACHE = globals.__TEXT_CACHE || {};
	                        globals.__TEXT_CACHE = {};
	                        var VERTEX_SIZE = 3;
	                        function TextSprites(gl2, shader, buffer, vao) {
	                          this.gl = gl2;
	                          this.shader = shader;
	                          this.buffer = buffer;
	                          this.vao = vao;
	                          this.tickOffset = this.tickCount = this.labelOffset = this.labelCount = null;
	                        }
	                        var proto = TextSprites.prototype;
	                        var SHAPE = [0, 0];
	                        proto.bind = function(model, view, projection, pixelScale) {
	                          this.vao.bind();
	                          this.shader.bind();
	                          var uniforms = this.shader.uniforms;
	                          uniforms.model = model;
	                          uniforms.view = view;
	                          uniforms.projection = projection;
	                          uniforms.pixelScale = pixelScale;
	                          SHAPE[0] = this.gl.drawingBufferWidth;
	                          SHAPE[1] = this.gl.drawingBufferHeight;
	                          this.shader.uniforms.resolution = SHAPE;
	                        };
	                        proto.unbind = function() {
	                          this.vao.unbind();
	                        };
	                        proto.update = function(bounds, labels, labelFont, ticks, tickFont) {
	                          var data = [];
	                          function addItem(t, text, font, size, lineSpacing2, styletags2) {
	                            var fontcache = __TEXT_CACHE[font];
	                            if (!fontcache) {
	                              fontcache = __TEXT_CACHE[font] = {};
	                            }
	                            var mesh = fontcache[text];
	                            if (!mesh) {
	                              mesh = fontcache[text] = tryVectorizeText(text, { triangles: true, font, textAlign: "center", textBaseline: "middle", lineSpacing: lineSpacing2, styletags: styletags2 });
	                            }
	                            var scale = (size || 12) / 12;
	                            var positions = mesh.positions;
	                            var cells = mesh.cells;
	                            for (var i2 = 0, nc = cells.length; i2 < nc; ++i2) {
	                              var c = cells[i2];
	                              for (var j = 2; j >= 0; --j) {
	                                var p = positions[c[j]];
	                                data.push(scale * p[0], -scale * p[1], t);
	                              }
	                            }
	                          }
	                          var tickOffset = [0, 0, 0];
	                          var tickCount = [0, 0, 0];
	                          var labelOffset = [0, 0, 0];
	                          var labelCount = [0, 0, 0];
	                          var lineSpacing = 1.25;
	                          var styletags = { breaklines: true, bolds: true, italics: true, subscripts: true, superscripts: true };
	                          for (var d = 0; d < 3; ++d) {
	                            labelOffset[d] = data.length / VERTEX_SIZE | 0;
	                            addItem(
	                              0.5 * (bounds[0][d] + bounds[1][d]),
	                              labels[d],
	                              labelFont[d],
	                              12,
	                              // labelFontSize
	                              lineSpacing,
	                              styletags
	                            );
	                            labelCount[d] = (data.length / VERTEX_SIZE | 0) - labelOffset[d];
	                            tickOffset[d] = data.length / VERTEX_SIZE | 0;
	                            for (var i = 0; i < ticks[d].length; ++i) {
	                              if (!ticks[d][i].text) {
	                                continue;
	                              }
	                              addItem(ticks[d][i].x, ticks[d][i].text, ticks[d][i].font || tickFont, ticks[d][i].fontSize || 12, lineSpacing, styletags);
	                            }
	                            tickCount[d] = (data.length / VERTEX_SIZE | 0) - tickOffset[d];
	                          }
	                          this.buffer.update(data);
	                          this.tickOffset = tickOffset;
	                          this.tickCount = tickCount;
	                          this.labelOffset = labelOffset;
	                          this.labelCount = labelCount;
	                        };
	                        proto.drawTicks = function(d, scale, angle, offset, color, axis, alignDir, alignOpt) {
	                          if (!this.tickCount[d]) {
	                            return;
	                          }
	                          this.shader.uniforms.axis = axis;
	                          this.shader.uniforms.color = color;
	                          this.shader.uniforms.angle = angle;
	                          this.shader.uniforms.scale = scale;
	                          this.shader.uniforms.offset = offset;
	                          this.shader.uniforms.alignDir = alignDir;
	                          this.shader.uniforms.alignOpt = alignOpt;
	                          this.vao.draw(this.gl.TRIANGLES, this.tickCount[d], this.tickOffset[d]);
	                        };
	                        proto.drawLabel = function(d, scale, angle, offset, color, axis, alignDir, alignOpt) {
	                          if (!this.labelCount[d]) {
	                            return;
	                          }
	                          this.shader.uniforms.axis = axis;
	                          this.shader.uniforms.color = color;
	                          this.shader.uniforms.angle = angle;
	                          this.shader.uniforms.scale = scale;
	                          this.shader.uniforms.offset = offset;
	                          this.shader.uniforms.alignDir = alignDir;
	                          this.shader.uniforms.alignOpt = alignOpt;
	                          this.vao.draw(this.gl.TRIANGLES, this.labelCount[d], this.labelOffset[d]);
	                        };
	                        proto.dispose = function() {
	                          this.shader.dispose();
	                          this.vao.dispose();
	                          this.buffer.dispose();
	                        };
	                        function tryVectorizeText(text, options) {
	                          try {
	                            return vectorizeText(text, options);
	                          } catch (e) {
	                            console.warn('error vectorizing text:"' + text + '" error:', e);
	                            return { cells: [], positions: [] };
	                          }
	                        }
	                        function createTextSprites(gl2, bounds, labels, labelFont, ticks, tickFont) {
	                          var buffer = createBuffer(gl2);
	                          var vao = createVAO(gl2, [{ "buffer": buffer, "size": 3 }]);
	                          var shader = createShader(gl2);
	                          shader.attributes.position.location = 0;
	                          var result = new TextSprites(gl2, shader, buffer, vao);
	                          result.update(bounds, labels, labelFont, ticks, tickFont);
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    8468: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        exports2.create = defaultTicks;
	                        exports2.equal = ticksEqual;
	                        function prettyPrint(spacing, i) {
	                          var stepStr = spacing + "";
	                          var u = stepStr.indexOf(".");
	                          var sigFigs = 0;
	                          if (u >= 0) {
	                            sigFigs = stepStr.length - u - 1;
	                          }
	                          var shift = Math.pow(10, sigFigs);
	                          var x = Math.round(spacing * i * shift);
	                          var xstr = x + "";
	                          if (xstr.indexOf("e") >= 0) {
	                            return xstr;
	                          }
	                          var xi = x / shift, xf = x % shift;
	                          if (x < 0) {
	                            xi = -Math.ceil(xi) | 0;
	                            xf = -xf | 0;
	                          } else {
	                            xi = Math.floor(xi) | 0;
	                            xf = xf | 0;
	                          }
	                          var xis = "" + xi;
	                          if (x < 0) {
	                            xis = "-" + xis;
	                          }
	                          if (sigFigs) {
	                            var xs = "" + xf;
	                            while (xs.length < sigFigs) {
	                              xs = "0" + xs;
	                            }
	                            return xis + "." + xs;
	                          } else {
	                            return xis;
	                          }
	                        }
	                        function defaultTicks(bounds, tickSpacing) {
	                          var array = [];
	                          for (var d = 0; d < 3; ++d) {
	                            var ticks = [];
	                            0.5 * (bounds[0][d] + bounds[1][d]);
	                            for (var t = 0; t * tickSpacing[d] <= bounds[1][d]; ++t) {
	                              ticks.push({ x: t * tickSpacing[d], text: prettyPrint(tickSpacing[d], t) });
	                            }
	                            for (var t = -1; t * tickSpacing[d] >= bounds[0][d]; --t) {
	                              ticks.push({ x: t * tickSpacing[d], text: prettyPrint(tickSpacing[d], t) });
	                            }
	                            array.push(ticks);
	                          }
	                          return array;
	                        }
	                        function ticksEqual(ticksA, ticksB) {
	                          for (var i = 0; i < 3; ++i) {
	                            if (ticksA[i].length !== ticksB[i].length) {
	                              return false;
	                            }
	                            for (var j = 0; j < ticksA[i].length; ++j) {
	                              var a = ticksA[i][j];
	                              var b = ticksB[i][j];
	                              if (a.x !== b.x || a.text !== b.text || a.font !== b.font || a.fontColor !== b.fontColor || a.fontSize !== b.fontSize || a.dx !== b.dx || a.dy !== b.dy) {
	                                return false;
	                              }
	                            }
	                          }
	                          return true;
	                        }
	                      }
	                    ),
	                    /***/
	                    2771: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_270882__) {
	                        module3.exports = axesProperties;
	                        var getPlanes = __nested_webpack_require_270882__(5795);
	                        var splitPoly = __nested_webpack_require_270882__(4670);
	                        var cubeParams = __nested_webpack_require_270882__(2864);
	                        var m4mul = __nested_webpack_require_270882__(104);
	                        var m4transpose = __nested_webpack_require_270882__(2142);
	                        var v4transformMat4 = __nested_webpack_require_270882__(6342);
	                        var identity2 = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
	                        var mvp = new Float32Array(16);
	                        function AxesRange3D(lo, hi, pixelsPerDataUnit) {
	                          this.lo = lo;
	                          this.hi = hi;
	                          this.pixelsPerDataUnit = pixelsPerDataUnit;
	                        }
	                        var SCRATCH_P = [0, 0, 0, 1];
	                        var SCRATCH_Q = [0, 0, 0, 1];
	                        function gradient(result, M, v, width, height) {
	                          for (var i = 0; i < 3; ++i) {
	                            var p = SCRATCH_P;
	                            var q = SCRATCH_Q;
	                            for (var j = 0; j < 3; ++j) {
	                              q[j] = p[j] = v[j];
	                            }
	                            q[3] = p[3] = 1;
	                            q[i] += 1;
	                            v4transformMat4(q, q, M);
	                            if (q[3] < 0) {
	                              result[i] = Infinity;
	                            }
	                            p[i] -= 1;
	                            v4transformMat4(p, p, M);
	                            if (p[3] < 0) {
	                              result[i] = Infinity;
	                            }
	                            var dx = (p[0] / p[3] - q[0] / q[3]) * width;
	                            var dy = (p[1] / p[3] - q[1] / q[3]) * height;
	                            result[i] = 0.25 * Math.sqrt(dx * dx + dy * dy);
	                          }
	                          return result;
	                        }
	                        var RANGES = [new AxesRange3D(Infinity, -Infinity, Infinity), new AxesRange3D(Infinity, -Infinity, Infinity), new AxesRange3D(Infinity, -Infinity, Infinity)];
	                        var SCRATCH_X = [0, 0, 0];
	                        function axesProperties(axes, camera, width, height, params) {
	                          var model = camera.model || identity2;
	                          var view = camera.view || identity2;
	                          var projection = camera.projection || identity2;
	                          var isOrtho = camera._ortho || false;
	                          var bounds = axes.bounds;
	                          var params = params || cubeParams(model, view, projection, bounds, isOrtho);
	                          var axis = params.axis;
	                          m4mul(mvp, view, model);
	                          m4mul(mvp, projection, mvp);
	                          var ranges = RANGES;
	                          for (var i = 0; i < 3; ++i) {
	                            ranges[i].lo = Infinity;
	                            ranges[i].hi = -Infinity;
	                            ranges[i].pixelsPerDataUnit = Infinity;
	                          }
	                          var frustum = getPlanes(m4transpose(mvp, mvp));
	                          m4transpose(mvp, mvp);
	                          for (var d = 0; d < 3; ++d) {
	                            var u = (d + 1) % 3;
	                            var v = (d + 2) % 3;
	                            var x = SCRATCH_X;
	                            i_loop: for (var i = 0; i < 2; ++i) {
	                              var poly = [];
	                              if (axis[d] < 0 === !!i) {
	                                continue;
	                              }
	                              x[d] = bounds[i][d];
	                              for (var j = 0; j < 2; ++j) {
	                                x[u] = bounds[j ^ i][u];
	                                for (var k = 0; k < 2; ++k) {
	                                  x[v] = bounds[k ^ j ^ i][v];
	                                  poly.push(x.slice());
	                                }
	                              }
	                              var Q = isOrtho ? 5 : 4;
	                              for (var j = Q; j === Q; ++j) {
	                                if (poly.length === 0) {
	                                  continue i_loop;
	                                }
	                                poly = splitPoly.positive(poly, frustum[j]);
	                              }
	                              for (var j = 0; j < poly.length; ++j) {
	                                var v = poly[j];
	                                var grad = gradient(SCRATCH_X, mvp, v, width, height);
	                                for (var k = 0; k < 3; ++k) {
	                                  ranges[k].lo = Math.min(ranges[k].lo, v[k]);
	                                  ranges[k].hi = Math.max(ranges[k].hi, v[k]);
	                                  if (k !== d) {
	                                    ranges[k].pixelsPerDataUnit = Math.min(ranges[k].pixelsPerDataUnit, Math.abs(grad[k]));
	                                  }
	                                }
	                              }
	                            }
	                          }
	                          return ranges;
	                        }
	                      }
	                    ),
	                    /***/
	                    5827: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_273777__) {
	                        var pool = __nested_webpack_require_273777__(5306);
	                        var ops = __nested_webpack_require_273777__(7498);
	                        var ndarray = __nested_webpack_require_273777__(5050);
	                        var SUPPORTED_TYPES = ["uint8", "uint8_clamped", "uint16", "uint32", "int8", "int16", "int32", "float32"];
	                        function GLBuffer(gl2, type, handle, length, usage) {
	                          this.gl = gl2;
	                          this.type = type;
	                          this.handle = handle;
	                          this.length = length;
	                          this.usage = usage;
	                        }
	                        var proto = GLBuffer.prototype;
	                        proto.bind = function() {
	                          this.gl.bindBuffer(this.type, this.handle);
	                        };
	                        proto.unbind = function() {
	                          this.gl.bindBuffer(this.type, null);
	                        };
	                        proto.dispose = function() {
	                          this.gl.deleteBuffer(this.handle);
	                        };
	                        function updateTypeArray(gl2, type, len, usage, data, offset) {
	                          var dataLen = data.length * data.BYTES_PER_ELEMENT;
	                          if (offset < 0) {
	                            gl2.bufferData(type, data, usage);
	                            return dataLen;
	                          }
	                          if (dataLen + offset > len) {
	                            throw new Error("gl-buffer: If resizing buffer, must not specify offset");
	                          }
	                          gl2.bufferSubData(type, offset, data);
	                          return len;
	                        }
	                        function makeScratchTypeArray(array, dtype) {
	                          var res = pool.malloc(array.length, dtype);
	                          var n = array.length;
	                          for (var i = 0; i < n; ++i) {
	                            res[i] = array[i];
	                          }
	                          return res;
	                        }
	                        function isPacked(shape, stride) {
	                          var n = 1;
	                          for (var i = stride.length - 1; i >= 0; --i) {
	                            if (stride[i] !== n) {
	                              return false;
	                            }
	                            n *= shape[i];
	                          }
	                          return true;
	                        }
	                        proto.update = function(array, offset) {
	                          if (typeof offset !== "number") {
	                            offset = -1;
	                          }
	                          this.bind();
	                          if (typeof array === "object" && typeof array.shape !== "undefined") {
	                            var dtype = array.dtype;
	                            if (SUPPORTED_TYPES.indexOf(dtype) < 0) {
	                              dtype = "float32";
	                            }
	                            if (this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
	                              var ext = gl.getExtension("OES_element_index_uint");
	                              if (ext && dtype !== "uint16") {
	                                dtype = "uint32";
	                              } else {
	                                dtype = "uint16";
	                              }
	                            }
	                            if (dtype === array.dtype && isPacked(array.shape, array.stride)) {
	                              if (array.offset === 0 && array.data.length === array.shape[0]) {
	                                this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array.data, offset);
	                              } else {
	                                this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array.data.subarray(array.offset, array.shape[0]), offset);
	                              }
	                            } else {
	                              var tmp = pool.malloc(array.size, dtype);
	                              var ndt = ndarray(tmp, array.shape);
	                              ops.assign(ndt, array);
	                              if (offset < 0) {
	                                this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, tmp, offset);
	                              } else {
	                                this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, tmp.subarray(0, array.size), offset);
	                              }
	                              pool.free(tmp);
	                            }
	                          } else if (Array.isArray(array)) {
	                            var t;
	                            if (this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
	                              t = makeScratchTypeArray(array, "uint16");
	                            } else {
	                              t = makeScratchTypeArray(array, "float32");
	                            }
	                            if (offset < 0) {
	                              this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, t, offset);
	                            } else {
	                              this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, t.subarray(0, array.length), offset);
	                            }
	                            pool.free(t);
	                          } else if (typeof array === "object" && typeof array.length === "number") {
	                            this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array, offset);
	                          } else if (typeof array === "number" || array === undefined) {
	                            if (offset >= 0) {
	                              throw new Error("gl-buffer: Cannot specify offset when resizing buffer");
	                            }
	                            array = array | 0;
	                            if (array <= 0) {
	                              array = 1;
	                            }
	                            this.gl.bufferData(this.type, array | 0, this.usage);
	                            this.length = array;
	                          } else {
	                            throw new Error("gl-buffer: Invalid data type");
	                          }
	                        };
	                        function createBuffer(gl2, data, type, usage) {
	                          type = type || gl2.ARRAY_BUFFER;
	                          usage = usage || gl2.DYNAMIC_DRAW;
	                          if (type !== gl2.ARRAY_BUFFER && type !== gl2.ELEMENT_ARRAY_BUFFER) {
	                            throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");
	                          }
	                          if (usage !== gl2.DYNAMIC_DRAW && usage !== gl2.STATIC_DRAW && usage !== gl2.STREAM_DRAW) {
	                            throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");
	                          }
	                          var handle = gl2.createBuffer();
	                          var result = new GLBuffer(gl2, type, handle, 0, usage);
	                          result.update(data);
	                          return result;
	                        }
	                        module3.exports = createBuffer;
	                      }
	                    ),
	                    /***/
	                    1140: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_277599__) {
	                        var vec3 = __nested_webpack_require_277599__(2858);
	                        module3.exports = function(vectorfield, bounds) {
	                          var positions = vectorfield.positions;
	                          var vectors = vectorfield.vectors;
	                          var geo = { positions: [], vertexIntensity: [], vertexIntensityBounds: vectorfield.vertexIntensityBounds, vectors: [], cells: [], coneOffset: vectorfield.coneOffset, colormap: vectorfield.colormap };
	                          if (vectorfield.positions.length === 0) {
	                            if (bounds) {
	                              bounds[0] = [0, 0, 0];
	                              bounds[1] = [0, 0, 0];
	                            }
	                            return geo;
	                          }
	                          var maxNorm = 0;
	                          var minX = Infinity, maxX = -Infinity;
	                          var minY = Infinity, maxY = -Infinity;
	                          var minZ = Infinity, maxZ = -Infinity;
	                          var p2 = null;
	                          var u2 = null;
	                          var positionVectors = [];
	                          var vectorScale = Infinity;
	                          var skipIt = false;
	                          for (var i = 0; i < positions.length; i++) {
	                            var p = positions[i];
	                            minX = Math.min(p[0], minX);
	                            maxX = Math.max(p[0], maxX);
	                            minY = Math.min(p[1], minY);
	                            maxY = Math.max(p[1], maxY);
	                            minZ = Math.min(p[2], minZ);
	                            maxZ = Math.max(p[2], maxZ);
	                            var u = vectors[i];
	                            if (vec3.length(u) > maxNorm) {
	                              maxNorm = vec3.length(u);
	                            }
	                            if (i) {
	                              var q = 2 * vec3.distance(p2, p) / (vec3.length(u2) + vec3.length(u));
	                              if (q) {
	                                vectorScale = Math.min(vectorScale, q);
	                                skipIt = false;
	                              } else {
	                                skipIt = true;
	                              }
	                            }
	                            if (!skipIt) {
	                              p2 = p;
	                              u2 = u;
	                            }
	                            positionVectors.push(u);
	                          }
	                          var minV = [minX, minY, minZ];
	                          var maxV = [maxX, maxY, maxZ];
	                          if (bounds) {
	                            bounds[0] = minV;
	                            bounds[1] = maxV;
	                          }
	                          if (maxNorm === 0) {
	                            maxNorm = 1;
	                          }
	                          var invertedMaxNorm = 1 / maxNorm;
	                          if (!isFinite(vectorScale)) {
	                            vectorScale = 1;
	                          }
	                          geo.vectorScale = vectorScale;
	                          var coneScale = vectorfield.coneSize || 0.5;
	                          if (vectorfield.absoluteConeSize) {
	                            coneScale = vectorfield.absoluteConeSize * invertedMaxNorm;
	                          }
	                          geo.coneScale = coneScale;
	                          for (var i = 0, j = 0; i < positions.length; i++) {
	                            var p = positions[i];
	                            var x = p[0], y = p[1], z = p[2];
	                            var d = positionVectors[i];
	                            var intensity = vec3.length(d) * invertedMaxNorm;
	                            for (var k = 0, l = 8; k < l; k++) {
	                              geo.positions.push([x, y, z, j++]);
	                              geo.positions.push([x, y, z, j++]);
	                              geo.positions.push([x, y, z, j++]);
	                              geo.positions.push([x, y, z, j++]);
	                              geo.positions.push([x, y, z, j++]);
	                              geo.positions.push([x, y, z, j++]);
	                              geo.vectors.push(d);
	                              geo.vectors.push(d);
	                              geo.vectors.push(d);
	                              geo.vectors.push(d);
	                              geo.vectors.push(d);
	                              geo.vectors.push(d);
	                              geo.vertexIntensity.push(intensity, intensity, intensity);
	                              geo.vertexIntensity.push(intensity, intensity, intensity);
	                              var m = geo.positions.length;
	                              geo.cells.push([m - 6, m - 5, m - 4], [m - 3, m - 2, m - 1]);
	                            }
	                          }
	                          return geo;
	                        };
	                        var shaders = __nested_webpack_require_277599__(7234);
	                        module3.exports.createMesh = __nested_webpack_require_277599__(5028);
	                        module3.exports.createConeMesh = function(gl2, params) {
	                          return module3.exports.createMesh(gl2, params, { shaders, traceType: "cone" });
	                        };
	                      }
	                    ),
	                    /***/
	                    5028: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_280573__) {
	                        var createShader = __nested_webpack_require_280573__(5158);
	                        var createBuffer = __nested_webpack_require_280573__(5827);
	                        var createVAO = __nested_webpack_require_280573__(2944);
	                        var createTexture = __nested_webpack_require_280573__(8931);
	                        var multiply = __nested_webpack_require_280573__(104);
	                        var invert = __nested_webpack_require_280573__(7437);
	                        var ndarray = __nested_webpack_require_280573__(5050);
	                        var colormap = __nested_webpack_require_280573__(9156);
	                        var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        function VectorMesh(gl2, texture, triShader, pickShader, trianglePositions, triangleVectors, triangleIds, triangleColors, triangleUVs, triangleVAO, traceType) {
	                          this.gl = gl2;
	                          this.pixelRatio = 1;
	                          this.cells = [];
	                          this.positions = [];
	                          this.intensity = [];
	                          this.texture = texture;
	                          this.dirty = true;
	                          this.triShader = triShader;
	                          this.pickShader = pickShader;
	                          this.trianglePositions = trianglePositions;
	                          this.triangleVectors = triangleVectors;
	                          this.triangleColors = triangleColors;
	                          this.triangleUVs = triangleUVs;
	                          this.triangleIds = triangleIds;
	                          this.triangleVAO = triangleVAO;
	                          this.triangleCount = 0;
	                          this.pickId = 1;
	                          this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.lightPosition = [1e5, 1e5, 0];
	                          this.ambientLight = 0.8;
	                          this.diffuseLight = 0.8;
	                          this.specularLight = 2;
	                          this.roughness = 0.5;
	                          this.fresnel = 1.5;
	                          this.opacity = 1;
	                          this.traceType = traceType;
	                          this.tubeScale = 1;
	                          this.coneScale = 2;
	                          this.vectorScale = 1;
	                          this.coneOffset = 0.25;
	                          this._model = IDENTITY;
	                          this._view = IDENTITY;
	                          this._projection = IDENTITY;
	                          this._resolution = [1, 1];
	                        }
	                        var proto = VectorMesh.prototype;
	                        proto.isOpaque = function() {
	                          return this.opacity >= 1;
	                        };
	                        proto.isTransparent = function() {
	                          return this.opacity < 1;
	                        };
	                        proto.pickSlots = 1;
	                        proto.setPickBase = function(id) {
	                          this.pickId = id;
	                        };
	                        function genColormap(param) {
	                          var colors = colormap({ colormap: param, nshades: 256, format: "rgba" });
	                          var result = new Uint8Array(256 * 4);
	                          for (var i = 0; i < 256; ++i) {
	                            var c = colors[i];
	                            for (var j = 0; j < 3; ++j) {
	                              result[4 * i + j] = c[j];
	                            }
	                            result[4 * i + 3] = c[3] * 255;
	                          }
	                          return ndarray(result, [256, 256, 4], [4, 0, 1]);
	                        }
	                        function takeZComponent(array) {
	                          var n = array.length;
	                          var result = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            result[i] = array[i][2];
	                          }
	                          return result;
	                        }
	                        proto.update = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          this.dirty = true;
	                          if ("lightPosition" in params) {
	                            this.lightPosition = params.lightPosition;
	                          }
	                          if ("opacity" in params) {
	                            this.opacity = params.opacity;
	                          }
	                          if ("ambient" in params) {
	                            this.ambientLight = params.ambient;
	                          }
	                          if ("diffuse" in params) {
	                            this.diffuseLight = params.diffuse;
	                          }
	                          if ("specular" in params) {
	                            this.specularLight = params.specular;
	                          }
	                          if ("roughness" in params) {
	                            this.roughness = params.roughness;
	                          }
	                          if ("fresnel" in params) {
	                            this.fresnel = params.fresnel;
	                          }
	                          if (params.tubeScale !== undefined) {
	                            this.tubeScale = params.tubeScale;
	                          }
	                          if (params.vectorScale !== undefined) {
	                            this.vectorScale = params.vectorScale;
	                          }
	                          if (params.coneScale !== undefined) {
	                            this.coneScale = params.coneScale;
	                          }
	                          if (params.coneOffset !== undefined) {
	                            this.coneOffset = params.coneOffset;
	                          }
	                          if (params.colormap) {
	                            this.texture.shape = [256, 256];
	                            this.texture.minFilter = gl2.LINEAR_MIPMAP_LINEAR;
	                            this.texture.magFilter = gl2.LINEAR;
	                            this.texture.setPixels(genColormap(params.colormap));
	                            this.texture.generateMipmap();
	                          }
	                          var cells = params.cells;
	                          var positions = params.positions;
	                          var vectors = params.vectors;
	                          if (!positions || !cells || !vectors) {
	                            return;
	                          }
	                          var tPos = [];
	                          var tVec = [];
	                          var tCol = [];
	                          var tUVs = [];
	                          var tIds = [];
	                          this.cells = cells;
	                          this.positions = positions;
	                          this.vectors = vectors;
	                          var meshColor = params.meshColor || [1, 1, 1, 1];
	                          var vertexIntensity = params.vertexIntensity;
	                          var intensityLo = Infinity;
	                          var intensityHi = -Infinity;
	                          if (vertexIntensity) {
	                            if (params.vertexIntensityBounds) {
	                              intensityLo = +params.vertexIntensityBounds[0];
	                              intensityHi = +params.vertexIntensityBounds[1];
	                            } else {
	                              for (var i = 0; i < vertexIntensity.length; ++i) {
	                                var f = vertexIntensity[i];
	                                intensityLo = Math.min(intensityLo, f);
	                                intensityHi = Math.max(intensityHi, f);
	                              }
	                            }
	                          } else {
	                            for (var i = 0; i < positions.length; ++i) {
	                              var f = positions[i][2];
	                              intensityLo = Math.min(intensityLo, f);
	                              intensityHi = Math.max(intensityHi, f);
	                            }
	                          }
	                          if (vertexIntensity) {
	                            this.intensity = vertexIntensity;
	                          } else {
	                            this.intensity = takeZComponent(positions);
	                          }
	                          this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          for (var i = 0; i < positions.length; ++i) {
	                            var p = positions[i];
	                            for (var j = 0; j < 3; ++j) {
	                              if (isNaN(p[j]) || !isFinite(p[j])) {
	                                continue;
	                              }
	                              this.bounds[0][j] = Math.min(this.bounds[0][j], p[j]);
	                              this.bounds[1][j] = Math.max(this.bounds[1][j], p[j]);
	                            }
	                          }
	                          var triangleCount = 0;
	                          fill_loop: for (var i = 0; i < cells.length; ++i) {
	                            var cell = cells[i];
	                            switch (cell.length) {
	                              case 3:
	                                for (var j = 0; j < 3; ++j) {
	                                  var v = cell[j];
	                                  var p = positions[v];
	                                  for (var k = 0; k < 3; ++k) {
	                                    if (isNaN(p[k]) || !isFinite(p[k])) {
	                                      continue fill_loop;
	                                    }
	                                  }
	                                }
	                                for (var j = 0; j < 3; ++j) {
	                                  var v = cell[2 - j];
	                                  var p = positions[v];
	                                  tPos.push(p[0], p[1], p[2], p[3]);
	                                  var w = vectors[v];
	                                  tVec.push(w[0], w[1], w[2], w[3] || 0);
	                                  var c = meshColor;
	                                  if (c.length === 3) {
	                                    tCol.push(c[0], c[1], c[2], 1);
	                                  } else {
	                                    tCol.push(c[0], c[1], c[2], c[3]);
	                                  }
	                                  var uv;
	                                  if (vertexIntensity) {
	                                    uv = [(vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  } else {
	                                    uv = [(p[2] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  }
	                                  tUVs.push(uv[0], uv[1]);
	                                  tIds.push(i);
	                                }
	                                triangleCount += 1;
	                                break;
	                            }
	                          }
	                          this.triangleCount = triangleCount;
	                          this.trianglePositions.update(tPos);
	                          this.triangleVectors.update(tVec);
	                          this.triangleColors.update(tCol);
	                          this.triangleUVs.update(tUVs);
	                          this.triangleIds.update(new Uint32Array(tIds));
	                        };
	                        proto.drawTransparent = proto.draw = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          var model = params.model || IDENTITY;
	                          var view = params.view || IDENTITY;
	                          var projection = params.projection || IDENTITY;
	                          var clipBounds = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]];
	                          for (var i = 0; i < 3; ++i) {
	                            clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i]);
	                            clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i]);
	                          }
	                          var uniforms = { model, view, projection, inverseModel: IDENTITY.slice(), clipBounds, kambient: this.ambientLight, kdiffuse: this.diffuseLight, kspecular: this.specularLight, roughness: this.roughness, fresnel: this.fresnel, eyePosition: [0, 0, 0], lightPosition: [0, 0, 0], opacity: this.opacity, tubeScale: this.tubeScale, vectorScale: this.vectorScale, coneScale: this.coneScale, coneOffset: this.coneOffset, texture: 0 };
	                          uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model);
	                          gl2.disable(gl2.CULL_FACE);
	                          this.texture.bind(0);
	                          var invCameraMatrix = new Array(16);
	                          multiply(invCameraMatrix, uniforms.view, uniforms.model);
	                          multiply(invCameraMatrix, uniforms.projection, invCameraMatrix);
	                          invert(invCameraMatrix, invCameraMatrix);
	                          for (var i = 0; i < 3; ++i) {
	                            uniforms.eyePosition[i] = invCameraMatrix[12 + i] / invCameraMatrix[15];
	                          }
	                          var w = invCameraMatrix[15];
	                          for (var i = 0; i < 3; ++i) {
	                            w += this.lightPosition[i] * invCameraMatrix[4 * i + 3];
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            var s = invCameraMatrix[12 + i];
	                            for (var j = 0; j < 3; ++j) {
	                              s += invCameraMatrix[4 * j + i] * this.lightPosition[j];
	                            }
	                            uniforms.lightPosition[i] = s / w;
	                          }
	                          if (this.triangleCount > 0) {
	                            var shader = this.triShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            this.triangleVAO.bind();
	                            gl2.drawArrays(gl2.TRIANGLES, 0, this.triangleCount * 3);
	                            this.triangleVAO.unbind();
	                          }
	                        };
	                        proto.drawPick = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          var model = params.model || IDENTITY;
	                          var view = params.view || IDENTITY;
	                          var projection = params.projection || IDENTITY;
	                          var clipBounds = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]];
	                          for (var i = 0; i < 3; ++i) {
	                            clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i]);
	                            clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i]);
	                          }
	                          this._model = [].slice.call(model);
	                          this._view = [].slice.call(view);
	                          this._projection = [].slice.call(projection);
	                          this._resolution = [gl2.drawingBufferWidth, gl2.drawingBufferHeight];
	                          var uniforms = { model, view, projection, clipBounds, tubeScale: this.tubeScale, vectorScale: this.vectorScale, coneScale: this.coneScale, coneOffset: this.coneOffset, pickId: this.pickId / 255 };
	                          var shader = this.pickShader;
	                          shader.bind();
	                          shader.uniforms = uniforms;
	                          if (this.triangleCount > 0) {
	                            this.triangleVAO.bind();
	                            gl2.drawArrays(gl2.TRIANGLES, 0, this.triangleCount * 3);
	                            this.triangleVAO.unbind();
	                          }
	                        };
	                        proto.pick = function(pickData) {
	                          if (!pickData) {
	                            return null;
	                          }
	                          if (pickData.id !== this.pickId) {
	                            return null;
	                          }
	                          var cellId = pickData.value[0] + 256 * pickData.value[1] + 65536 * pickData.value[2];
	                          var cell = this.cells[cellId];
	                          var pos = this.positions[cell[1]].slice(0, 3);
	                          var result = { position: pos, dataCoordinate: pos, index: Math.floor(cell[1] / 48) };
	                          if (this.traceType === "cone") {
	                            result.index = Math.floor(cell[1] / 48);
	                          } else if (this.traceType === "streamtube") {
	                            result.intensity = this.intensity[cell[1]];
	                            result.velocity = this.vectors[cell[1]].slice(0, 3);
	                            result.divergence = this.vectors[cell[1]][3];
	                            result.index = cellId;
	                          }
	                          return result;
	                        };
	                        proto.dispose = function() {
	                          this.texture.dispose();
	                          this.triShader.dispose();
	                          this.pickShader.dispose();
	                          this.triangleVAO.dispose();
	                          this.trianglePositions.dispose();
	                          this.triangleVectors.dispose();
	                          this.triangleColors.dispose();
	                          this.triangleUVs.dispose();
	                          this.triangleIds.dispose();
	                        };
	                        function createMeshShader(gl2, shaders) {
	                          var shader = createShader(gl2, shaders.meshShader.vertex, shaders.meshShader.fragment, null, shaders.meshShader.attributes);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.color.location = 2;
	                          shader.attributes.uv.location = 3;
	                          shader.attributes.vector.location = 4;
	                          return shader;
	                        }
	                        function createPickShader(gl2, shaders) {
	                          var shader = createShader(gl2, shaders.pickShader.vertex, shaders.pickShader.fragment, null, shaders.pickShader.attributes);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.id.location = 1;
	                          shader.attributes.vector.location = 4;
	                          return shader;
	                        }
	                        function createVectorMesh(gl2, params, opts) {
	                          var shaders = opts.shaders;
	                          if (arguments.length === 1) {
	                            params = gl2;
	                            gl2 = params.gl;
	                          }
	                          var triShader = createMeshShader(gl2, shaders);
	                          var pickShader = createPickShader(gl2, shaders);
	                          var meshTexture = createTexture(gl2, ndarray(new Uint8Array([255, 255, 255, 255]), [1, 1, 4]));
	                          meshTexture.generateMipmap();
	                          meshTexture.minFilter = gl2.LINEAR_MIPMAP_LINEAR;
	                          meshTexture.magFilter = gl2.LINEAR;
	                          var trianglePositions = createBuffer(gl2);
	                          var triangleVectors = createBuffer(gl2);
	                          var triangleColors = createBuffer(gl2);
	                          var triangleUVs = createBuffer(gl2);
	                          var triangleIds = createBuffer(gl2);
	                          var triangleVAO = createVAO(gl2, [{ buffer: trianglePositions, type: gl2.FLOAT, size: 4 }, { buffer: triangleIds, type: gl2.UNSIGNED_BYTE, size: 4, normalized: true }, { buffer: triangleColors, type: gl2.FLOAT, size: 4 }, { buffer: triangleUVs, type: gl2.FLOAT, size: 2 }, { buffer: triangleVectors, type: gl2.FLOAT, size: 4 }]);
	                          var mesh = new VectorMesh(gl2, meshTexture, triShader, pickShader, trianglePositions, triangleVectors, triangleIds, triangleColors, triangleUVs, triangleVAO, opts.traceType || "cone");
	                          mesh.update(params);
	                          return mesh;
	                        }
	                        module3.exports = createVectorMesh;
	                      }
	                    ),
	                    /***/
	                    7234: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_291180__) {
	                        var glslify = __nested_webpack_require_291180__(6832);
	                        var triVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]);
	                        var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]);
	                        var pickVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * view * conePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]);
	                        var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
	                        exports2.meshShader = { vertex: triVertSrc, fragment: triFragSrc, attributes: [{ name: "position", type: "vec4" }, { name: "color", type: "vec4" }, { name: "uv", type: "vec2" }, { name: "vector", type: "vec3" }] };
	                        exports2.pickShader = { vertex: pickVertSrc, fragment: pickFragSrc, attributes: [{ name: "position", type: "vec4" }, { name: "id", type: "vec4" }, { name: "vector", type: "vec3" }] };
	                      }
	                    ),
	                    /***/
	                    1950: (
	                      /***/
	                      function(module3) {
	                        module3.exports = { 0: "NONE", 1: "ONE", 2: "LINE_LOOP", 3: "LINE_STRIP", 4: "TRIANGLES", 5: "TRIANGLE_STRIP", 6: "TRIANGLE_FAN", 256: "DEPTH_BUFFER_BIT", 512: "NEVER", 513: "LESS", 514: "EQUAL", 515: "LEQUAL", 516: "GREATER", 517: "NOTEQUAL", 518: "GEQUAL", 519: "ALWAYS", 768: "SRC_COLOR", 769: "ONE_MINUS_SRC_COLOR", 770: "SRC_ALPHA", 771: "ONE_MINUS_SRC_ALPHA", 772: "DST_ALPHA", 773: "ONE_MINUS_DST_ALPHA", 774: "DST_COLOR", 775: "ONE_MINUS_DST_COLOR", 776: "SRC_ALPHA_SATURATE", 1024: "STENCIL_BUFFER_BIT", 1028: "FRONT", 1029: "BACK", 1032: "FRONT_AND_BACK", 1280: "INVALID_ENUM", 1281: "INVALID_VALUE", 1282: "INVALID_OPERATION", 1285: "OUT_OF_MEMORY", 1286: "INVALID_FRAMEBUFFER_OPERATION", 2304: "CW", 2305: "CCW", 2849: "LINE_WIDTH", 2884: "CULL_FACE", 2885: "CULL_FACE_MODE", 2886: "FRONT_FACE", 2928: "DEPTH_RANGE", 2929: "DEPTH_TEST", 2930: "DEPTH_WRITEMASK", 2931: "DEPTH_CLEAR_VALUE", 2932: "DEPTH_FUNC", 2960: "STENCIL_TEST", 2961: "STENCIL_CLEAR_VALUE", 2962: "STENCIL_FUNC", 2963: "STENCIL_VALUE_MASK", 2964: "STENCIL_FAIL", 2965: "STENCIL_PASS_DEPTH_FAIL", 2966: "STENCIL_PASS_DEPTH_PASS", 2967: "STENCIL_REF", 2968: "STENCIL_WRITEMASK", 2978: "VIEWPORT", 3024: "DITHER", 3042: "BLEND", 3088: "SCISSOR_BOX", 3089: "SCISSOR_TEST", 3106: "COLOR_CLEAR_VALUE", 3107: "COLOR_WRITEMASK", 3317: "UNPACK_ALIGNMENT", 3333: "PACK_ALIGNMENT", 3379: "MAX_TEXTURE_SIZE", 3386: "MAX_VIEWPORT_DIMS", 3408: "SUBPIXEL_BITS", 3410: "RED_BITS", 3411: "GREEN_BITS", 3412: "BLUE_BITS", 3413: "ALPHA_BITS", 3414: "DEPTH_BITS", 3415: "STENCIL_BITS", 3553: "TEXTURE_2D", 4352: "DONT_CARE", 4353: "FASTEST", 4354: "NICEST", 5120: "BYTE", 5121: "UNSIGNED_BYTE", 5122: "SHORT", 5123: "UNSIGNED_SHORT", 5124: "INT", 5125: "UNSIGNED_INT", 5126: "FLOAT", 5386: "INVERT", 5890: "TEXTURE", 6401: "STENCIL_INDEX", 6402: "DEPTH_COMPONENT", 6406: "ALPHA", 6407: "RGB", 6408: "RGBA", 6409: "LUMINANCE", 6410: "LUMINANCE_ALPHA", 7680: "KEEP", 7681: "REPLACE", 7682: "INCR", 7683: "DECR", 7936: "VENDOR", 7937: "RENDERER", 7938: "VERSION", 9728: "NEAREST", 9729: "LINEAR", 9984: "NEAREST_MIPMAP_NEAREST", 9985: "LINEAR_MIPMAP_NEAREST", 9986: "NEAREST_MIPMAP_LINEAR", 9987: "LINEAR_MIPMAP_LINEAR", 10240: "TEXTURE_MAG_FILTER", 10241: "TEXTURE_MIN_FILTER", 10242: "TEXTURE_WRAP_S", 10243: "TEXTURE_WRAP_T", 10497: "REPEAT", 10752: "POLYGON_OFFSET_UNITS", 16384: "COLOR_BUFFER_BIT", 32769: "CONSTANT_COLOR", 32770: "ONE_MINUS_CONSTANT_COLOR", 32771: "CONSTANT_ALPHA", 32772: "ONE_MINUS_CONSTANT_ALPHA", 32773: "BLEND_COLOR", 32774: "FUNC_ADD", 32777: "BLEND_EQUATION_RGB", 32778: "FUNC_SUBTRACT", 32779: "FUNC_REVERSE_SUBTRACT", 32819: "UNSIGNED_SHORT_4_4_4_4", 32820: "UNSIGNED_SHORT_5_5_5_1", 32823: "POLYGON_OFFSET_FILL", 32824: "POLYGON_OFFSET_FACTOR", 32854: "RGBA4", 32855: "RGB5_A1", 32873: "TEXTURE_BINDING_2D", 32926: "SAMPLE_ALPHA_TO_COVERAGE", 32928: "SAMPLE_COVERAGE", 32936: "SAMPLE_BUFFERS", 32937: "SAMPLES", 32938: "SAMPLE_COVERAGE_VALUE", 32939: "SAMPLE_COVERAGE_INVERT", 32968: "BLEND_DST_RGB", 32969: "BLEND_SRC_RGB", 32970: "BLEND_DST_ALPHA", 32971: "BLEND_SRC_ALPHA", 33071: "CLAMP_TO_EDGE", 33170: "GENERATE_MIPMAP_HINT", 33189: "DEPTH_COMPONENT16", 33306: "DEPTH_STENCIL_ATTACHMENT", 33635: "UNSIGNED_SHORT_5_6_5", 33648: "MIRRORED_REPEAT", 33901: "ALIASED_POINT_SIZE_RANGE", 33902: "ALIASED_LINE_WIDTH_RANGE", 33984: "TEXTURE0", 33985: "TEXTURE1", 33986: "TEXTURE2", 33987: "TEXTURE3", 33988: "TEXTURE4", 33989: "TEXTURE5", 33990: "TEXTURE6", 33991: "TEXTURE7", 33992: "TEXTURE8", 33993: "TEXTURE9", 33994: "TEXTURE10", 33995: "TEXTURE11", 33996: "TEXTURE12", 33997: "TEXTURE13", 33998: "TEXTURE14", 33999: "TEXTURE15", 34e3: "TEXTURE16", 34001: "TEXTURE17", 34002: "TEXTURE18", 34003: "TEXTURE19", 34004: "TEXTURE20", 34005: "TEXTURE21", 34006: "TEXTURE22", 34007: "TEXTURE23", 34008: "TEXTURE24", 34009: "TEXTURE25", 34010: "TEXTURE26", 34011: "TEXTURE27", 34012: "TEXTURE28", 34013: "TEXTURE29", 34014: "TEXTURE30", 34015: "TEXTURE31", 34016: "ACTIVE_TEXTURE", 34024: "MAX_RENDERBUFFER_SIZE", 34041: "DEPTH_STENCIL", 34055: "INCR_WRAP", 34056: "DECR_WRAP", 34067: "TEXTURE_CUBE_MAP", 34068: "TEXTURE_BINDING_CUBE_MAP", 34069: "TEXTURE_CUBE_MAP_POSITIVE_X", 34070: "TEXTURE_CUBE_MAP_NEGATIVE_X", 34071: "TEXTURE_CUBE_MAP_POSITIVE_Y", 34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y", 34073: "TEXTURE_CUBE_MAP_POSITIVE_Z", 34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z", 34076: "MAX_CUBE_MAP_TEXTURE_SIZE", 34338: "VERTEX_ATTRIB_ARRAY_ENABLED", 34339: "VERTEX_ATTRIB_ARRAY_SIZE", 34340: "VERTEX_ATTRIB_ARRAY_STRIDE", 34341: "VERTEX_ATTRIB_ARRAY_TYPE", 34342: "CURRENT_VERTEX_ATTRIB", 34373: "VERTEX_ATTRIB_ARRAY_POINTER", 34466: "NUM_COMPRESSED_TEXTURE_FORMATS", 34467: "COMPRESSED_TEXTURE_FORMATS", 34660: "BUFFER_SIZE", 34661: "BUFFER_USAGE", 34816: "STENCIL_BACK_FUNC", 34817: "STENCIL_BACK_FAIL", 34818: "STENCIL_BACK_PASS_DEPTH_FAIL", 34819: "STENCIL_BACK_PASS_DEPTH_PASS", 34877: "BLEND_EQUATION_ALPHA", 34921: "MAX_VERTEX_ATTRIBS", 34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED", 34930: "MAX_TEXTURE_IMAGE_UNITS", 34962: "ARRAY_BUFFER", 34963: "ELEMENT_ARRAY_BUFFER", 34964: "ARRAY_BUFFER_BINDING", 34965: "ELEMENT_ARRAY_BUFFER_BINDING", 34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING", 35040: "STREAM_DRAW", 35044: "STATIC_DRAW", 35048: "DYNAMIC_DRAW", 35632: "FRAGMENT_SHADER", 35633: "VERTEX_SHADER", 35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS", 35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS", 35663: "SHADER_TYPE", 35664: "FLOAT_VEC2", 35665: "FLOAT_VEC3", 35666: "FLOAT_VEC4", 35667: "INT_VEC2", 35668: "INT_VEC3", 35669: "INT_VEC4", 35670: "BOOL", 35671: "BOOL_VEC2", 35672: "BOOL_VEC3", 35673: "BOOL_VEC4", 35674: "FLOAT_MAT2", 35675: "FLOAT_MAT3", 35676: "FLOAT_MAT4", 35678: "SAMPLER_2D", 35680: "SAMPLER_CUBE", 35712: "DELETE_STATUS", 35713: "COMPILE_STATUS", 35714: "LINK_STATUS", 35715: "VALIDATE_STATUS", 35716: "INFO_LOG_LENGTH", 35717: "ATTACHED_SHADERS", 35718: "ACTIVE_UNIFORMS", 35719: "ACTIVE_UNIFORM_MAX_LENGTH", 35720: "SHADER_SOURCE_LENGTH", 35721: "ACTIVE_ATTRIBUTES", 35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH", 35724: "SHADING_LANGUAGE_VERSION", 35725: "CURRENT_PROGRAM", 36003: "STENCIL_BACK_REF", 36004: "STENCIL_BACK_VALUE_MASK", 36005: "STENCIL_BACK_WRITEMASK", 36006: "FRAMEBUFFER_BINDING", 36007: "RENDERBUFFER_BINDING", 36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE", 36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME", 36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL", 36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE", 36053: "FRAMEBUFFER_COMPLETE", 36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT", 36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT", 36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS", 36061: "FRAMEBUFFER_UNSUPPORTED", 36064: "COLOR_ATTACHMENT0", 36096: "DEPTH_ATTACHMENT", 36128: "STENCIL_ATTACHMENT", 36160: "FRAMEBUFFER", 36161: "RENDERBUFFER", 36162: "RENDERBUFFER_WIDTH", 36163: "RENDERBUFFER_HEIGHT", 36164: "RENDERBUFFER_INTERNAL_FORMAT", 36168: "STENCIL_INDEX8", 36176: "RENDERBUFFER_RED_SIZE", 36177: "RENDERBUFFER_GREEN_SIZE", 36178: "RENDERBUFFER_BLUE_SIZE", 36179: "RENDERBUFFER_ALPHA_SIZE", 36180: "RENDERBUFFER_DEPTH_SIZE", 36181: "RENDERBUFFER_STENCIL_SIZE", 36194: "RGB565", 36336: "LOW_FLOAT", 36337: "MEDIUM_FLOAT", 36338: "HIGH_FLOAT", 36339: "LOW_INT", 36340: "MEDIUM_INT", 36341: "HIGH_INT", 36346: "SHADER_COMPILER", 36347: "MAX_VERTEX_UNIFORM_VECTORS", 36348: "MAX_VARYING_VECTORS", 36349: "MAX_FRAGMENT_UNIFORM_VECTORS", 37440: "UNPACK_FLIP_Y_WEBGL", 37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL", 37442: "CONTEXT_LOST_WEBGL", 37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL", 37444: "BROWSER_DEFAULT_WEBGL" };
	                      }
	                    ),
	                    /***/
	                    6603: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_309276__) {
	                        var gl10 = __nested_webpack_require_309276__(1950);
	                        module3.exports = function lookupConstant(number2) {
	                          return gl10[number2];
	                        };
	                      }
	                    ),
	                    /***/
	                    3110: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_309464__) {
	                        module3.exports = createErrorBars;
	                        var createBuffer = __nested_webpack_require_309464__(5827);
	                        var createVAO = __nested_webpack_require_309464__(2944);
	                        var createShader = __nested_webpack_require_309464__(7667);
	                        var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        function ErrorBars(gl2, buffer, vao, shader) {
	                          this.gl = gl2;
	                          this.shader = shader;
	                          this.buffer = buffer;
	                          this.vao = vao;
	                          this.pixelRatio = 1;
	                          this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.lineWidth = [1, 1, 1];
	                          this.capSize = [10, 10, 10];
	                          this.lineCount = [0, 0, 0];
	                          this.lineOffset = [0, 0, 0];
	                          this.opacity = 1;
	                          this.hasAlpha = false;
	                        }
	                        var proto = ErrorBars.prototype;
	                        proto.isOpaque = function() {
	                          return !this.hasAlpha;
	                        };
	                        proto.isTransparent = function() {
	                          return this.hasAlpha;
	                        };
	                        proto.drawTransparent = proto.draw = function(cameraParams) {
	                          var gl2 = this.gl;
	                          var uniforms = this.shader.uniforms;
	                          this.shader.bind();
	                          var view = uniforms.view = cameraParams.view || IDENTITY;
	                          var projection = uniforms.projection = cameraParams.projection || IDENTITY;
	                          uniforms.model = cameraParams.model || IDENTITY;
	                          uniforms.clipBounds = this.clipBounds;
	                          uniforms.opacity = this.opacity;
	                          var cx = view[12];
	                          var cy = view[13];
	                          var cz = view[14];
	                          var cw = view[15];
	                          var isOrtho = cameraParams._ortho || false;
	                          var orthoFix = isOrtho ? 2 : 1;
	                          var pixelScaleF = orthoFix * this.pixelRatio * (projection[3] * cx + projection[7] * cy + projection[11] * cz + projection[15] * cw) / gl2.drawingBufferHeight;
	                          this.vao.bind();
	                          for (var i = 0; i < 3; ++i) {
	                            gl2.lineWidth(this.lineWidth[i] * this.pixelRatio);
	                            uniforms.capSize = this.capSize[i] * pixelScaleF;
	                            if (this.lineCount[i]) {
	                              gl2.drawArrays(gl2.LINES, this.lineOffset[i], this.lineCount[i]);
	                            }
	                          }
	                          this.vao.unbind();
	                        };
	                        function updateBounds(bounds, point) {
	                          for (var i = 0; i < 3; ++i) {
	                            bounds[0][i] = Math.min(bounds[0][i], point[i]);
	                            bounds[1][i] = Math.max(bounds[1][i], point[i]);
	                          }
	                        }
	                        var FACE_TABLE = function() {
	                          var table = new Array(3);
	                          for (var d = 0; d < 3; ++d) {
	                            var row = [];
	                            for (var j = 1; j <= 2; ++j) {
	                              for (var s = -1; s <= 1; s += 2) {
	                                var u = (j + d) % 3;
	                                var y = [0, 0, 0];
	                                y[u] = s;
	                                row.push(y);
	                              }
	                            }
	                            table[d] = row;
	                          }
	                          return table;
	                        }();
	                        function emitFace(verts, x, c, d) {
	                          var offsets = FACE_TABLE[d];
	                          for (var i = 0; i < offsets.length; ++i) {
	                            var o = offsets[i];
	                            verts.push(x[0], x[1], x[2], c[0], c[1], c[2], c[3], o[0], o[1], o[2]);
	                          }
	                          return offsets.length;
	                        }
	                        proto.update = function(options) {
	                          options = options || {};
	                          if ("lineWidth" in options) {
	                            this.lineWidth = options.lineWidth;
	                            if (!Array.isArray(this.lineWidth)) {
	                              this.lineWidth = [this.lineWidth, this.lineWidth, this.lineWidth];
	                            }
	                          }
	                          if ("capSize" in options) {
	                            this.capSize = options.capSize;
	                            if (!Array.isArray(this.capSize)) {
	                              this.capSize = [this.capSize, this.capSize, this.capSize];
	                            }
	                          }
	                          this.hasAlpha = false;
	                          if ("opacity" in options) {
	                            this.opacity = +options.opacity;
	                            if (this.opacity < 1) {
	                              this.hasAlpha = true;
	                            }
	                          }
	                          var color = options.color || [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
	                          var position = options.position;
	                          var error = options.error;
	                          if (!Array.isArray(color[0])) {
	                            color = [color, color, color];
	                          }
	                          if (position && error) {
	                            var verts = [];
	                            var n = position.length;
	                            var vertexCount = 0;
	                            this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                            this.lineCount = [0, 0, 0];
	                            for (var j = 0; j < 3; ++j) {
	                              this.lineOffset[j] = vertexCount;
	                              i_loop: for (var i = 0; i < n; ++i) {
	                                var p = position[i];
	                                for (var k = 0; k < 3; ++k) {
	                                  if (isNaN(p[k]) || !isFinite(p[k])) {
	                                    continue i_loop;
	                                  }
	                                }
	                                var e = error[i];
	                                var c = color[j];
	                                if (Array.isArray(c[0])) {
	                                  c = color[i];
	                                }
	                                if (c.length === 3) {
	                                  c = [c[0], c[1], c[2], 1];
	                                } else if (c.length === 4) {
	                                  c = [c[0], c[1], c[2], c[3]];
	                                  if (!this.hasAlpha && c[3] < 1) this.hasAlpha = true;
	                                }
	                                if (isNaN(e[0][j]) || isNaN(e[1][j])) {
	                                  continue;
	                                }
	                                if (e[0][j] < 0) {
	                                  var x = p.slice();
	                                  x[j] += e[0][j];
	                                  verts.push(p[0], p[1], p[2], c[0], c[1], c[2], c[3], 0, 0, 0, x[0], x[1], x[2], c[0], c[1], c[2], c[3], 0, 0, 0);
	                                  updateBounds(this.bounds, x);
	                                  vertexCount += 2 + emitFace(verts, x, c, j);
	                                }
	                                if (e[1][j] > 0) {
	                                  var x = p.slice();
	                                  x[j] += e[1][j];
	                                  verts.push(p[0], p[1], p[2], c[0], c[1], c[2], c[3], 0, 0, 0, x[0], x[1], x[2], c[0], c[1], c[2], c[3], 0, 0, 0);
	                                  updateBounds(this.bounds, x);
	                                  vertexCount += 2 + emitFace(verts, x, c, j);
	                                }
	                              }
	                              this.lineCount[j] = vertexCount - this.lineOffset[j];
	                            }
	                            this.buffer.update(verts);
	                          }
	                        };
	                        proto.dispose = function() {
	                          this.shader.dispose();
	                          this.buffer.dispose();
	                          this.vao.dispose();
	                        };
	                        function createErrorBars(options) {
	                          var gl2 = options.gl;
	                          var buffer = createBuffer(gl2);
	                          var vao = createVAO(gl2, [{ buffer, type: gl2.FLOAT, size: 3, offset: 0, stride: 40 }, { buffer, type: gl2.FLOAT, size: 4, offset: 12, stride: 40 }, { buffer, type: gl2.FLOAT, size: 3, offset: 28, stride: 40 }]);
	                          var shader = createShader(gl2);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.color.location = 1;
	                          shader.attributes.offset.location = 2;
	                          var result = new ErrorBars(gl2, buffer, vao, shader);
	                          result.update(options);
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    7667: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_314103__) {
	                        var glslify = __nested_webpack_require_314103__(6832);
	                        var createShader = __nested_webpack_require_314103__(5158);
	                        var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * view * worldPosition;\n  fragColor           = color;\n  fragPosition        = position;\n}"]);
	                        var fragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"]);
	                        module3.exports = function(gl2) {
	                          return createShader(gl2, vertSrc, fragSrc, null, [{ name: "position", type: "vec3" }, { name: "color", type: "vec4" }, { name: "offset", type: "vec3" }]);
	                        };
	                      }
	                    ),
	                    /***/
	                    4234: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_315826__) {
	                        var createTexture = __nested_webpack_require_315826__(8931);
	                        module3.exports = createFBO;
	                        var colorAttachmentArrays = null;
	                        var FRAMEBUFFER_UNSUPPORTED;
	                        var FRAMEBUFFER_INCOMPLETE_ATTACHMENT;
	                        var FRAMEBUFFER_INCOMPLETE_DIMENSIONS;
	                        var FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT;
	                        function saveFBOState(gl2) {
	                          var fbo = gl2.getParameter(gl2.FRAMEBUFFER_BINDING);
	                          var rbo = gl2.getParameter(gl2.RENDERBUFFER_BINDING);
	                          var tex = gl2.getParameter(gl2.TEXTURE_BINDING_2D);
	                          return [fbo, rbo, tex];
	                        }
	                        function restoreFBOState(gl2, data) {
	                          gl2.bindFramebuffer(gl2.FRAMEBUFFER, data[0]);
	                          gl2.bindRenderbuffer(gl2.RENDERBUFFER, data[1]);
	                          gl2.bindTexture(gl2.TEXTURE_2D, data[2]);
	                        }
	                        function lazyInitColorAttachments(gl2, ext) {
	                          var maxColorAttachments = gl2.getParameter(ext.MAX_COLOR_ATTACHMENTS_WEBGL);
	                          colorAttachmentArrays = new Array(maxColorAttachments + 1);
	                          for (var i = 0; i <= maxColorAttachments; ++i) {
	                            var x = new Array(maxColorAttachments);
	                            for (var j = 0; j < i; ++j) {
	                              x[j] = gl2.COLOR_ATTACHMENT0 + j;
	                            }
	                            for (var j = i; j < maxColorAttachments; ++j) {
	                              x[j] = gl2.NONE;
	                            }
	                            colorAttachmentArrays[i] = x;
	                          }
	                        }
	                        function throwFBOError(status) {
	                          switch (status) {
	                            case FRAMEBUFFER_UNSUPPORTED:
	                              throw new Error("gl-fbo: Framebuffer unsupported");
	                            case FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
	                              throw new Error("gl-fbo: Framebuffer incomplete attachment");
	                            case FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
	                              throw new Error("gl-fbo: Framebuffer incomplete dimensions");
	                            case FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
	                              throw new Error("gl-fbo: Framebuffer incomplete missing attachment");
	                            default:
	                              throw new Error("gl-fbo: Framebuffer failed for unspecified reason");
	                          }
	                        }
	                        function initTexture(gl2, width, height, type, format, attachment) {
	                          if (!type) {
	                            return null;
	                          }
	                          var result = createTexture(gl2, width, height, format, type);
	                          result.magFilter = gl2.NEAREST;
	                          result.minFilter = gl2.NEAREST;
	                          result.mipSamples = 1;
	                          result.bind();
	                          gl2.framebufferTexture2D(gl2.FRAMEBUFFER, attachment, gl2.TEXTURE_2D, result.handle, 0);
	                          return result;
	                        }
	                        function initRenderBuffer(gl2, width, height, component, attachment) {
	                          var result = gl2.createRenderbuffer();
	                          gl2.bindRenderbuffer(gl2.RENDERBUFFER, result);
	                          gl2.renderbufferStorage(gl2.RENDERBUFFER, component, width, height);
	                          gl2.framebufferRenderbuffer(gl2.FRAMEBUFFER, attachment, gl2.RENDERBUFFER, result);
	                          return result;
	                        }
	                        function rebuildFBO(fbo) {
	                          var state = saveFBOState(fbo.gl);
	                          var gl2 = fbo.gl;
	                          var handle = fbo.handle = gl2.createFramebuffer();
	                          var width = fbo._shape[0];
	                          var height = fbo._shape[1];
	                          var numColors = fbo.color.length;
	                          var ext = fbo._ext;
	                          var useStencil = fbo._useStencil;
	                          var useDepth = fbo._useDepth;
	                          var colorType = fbo._colorType;
	                          gl2.bindFramebuffer(gl2.FRAMEBUFFER, handle);
	                          for (var i = 0; i < numColors; ++i) {
	                            fbo.color[i] = initTexture(gl2, width, height, colorType, gl2.RGBA, gl2.COLOR_ATTACHMENT0 + i);
	                          }
	                          if (numColors === 0) {
	                            fbo._color_rb = initRenderBuffer(gl2, width, height, gl2.RGBA4, gl2.COLOR_ATTACHMENT0);
	                            if (ext) {
	                              ext.drawBuffersWEBGL(colorAttachmentArrays[0]);
	                            }
	                          } else if (numColors > 1) {
	                            ext.drawBuffersWEBGL(colorAttachmentArrays[numColors]);
	                          }
	                          var WEBGL_depth_texture = gl2.getExtension("WEBGL_depth_texture");
	                          if (WEBGL_depth_texture) {
	                            if (useStencil) {
	                              fbo.depth = initTexture(gl2, width, height, WEBGL_depth_texture.UNSIGNED_INT_24_8_WEBGL, gl2.DEPTH_STENCIL, gl2.DEPTH_STENCIL_ATTACHMENT);
	                            } else if (useDepth) {
	                              fbo.depth = initTexture(gl2, width, height, gl2.UNSIGNED_SHORT, gl2.DEPTH_COMPONENT, gl2.DEPTH_ATTACHMENT);
	                            }
	                          } else {
	                            if (useDepth && useStencil) {
	                              fbo._depth_rb = initRenderBuffer(gl2, width, height, gl2.DEPTH_STENCIL, gl2.DEPTH_STENCIL_ATTACHMENT);
	                            } else if (useDepth) {
	                              fbo._depth_rb = initRenderBuffer(gl2, width, height, gl2.DEPTH_COMPONENT16, gl2.DEPTH_ATTACHMENT);
	                            } else if (useStencil) {
	                              fbo._depth_rb = initRenderBuffer(gl2, width, height, gl2.STENCIL_INDEX, gl2.STENCIL_ATTACHMENT);
	                            }
	                          }
	                          var status = gl2.checkFramebufferStatus(gl2.FRAMEBUFFER);
	                          if (status !== gl2.FRAMEBUFFER_COMPLETE) {
	                            fbo._destroyed = true;
	                            gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	                            gl2.deleteFramebuffer(fbo.handle);
	                            fbo.handle = null;
	                            if (fbo.depth) {
	                              fbo.depth.dispose();
	                              fbo.depth = null;
	                            }
	                            if (fbo._depth_rb) {
	                              gl2.deleteRenderbuffer(fbo._depth_rb);
	                              fbo._depth_rb = null;
	                            }
	                            for (var i = 0; i < fbo.color.length; ++i) {
	                              fbo.color[i].dispose();
	                              fbo.color[i] = null;
	                            }
	                            if (fbo._color_rb) {
	                              gl2.deleteRenderbuffer(fbo._color_rb);
	                              fbo._color_rb = null;
	                            }
	                            restoreFBOState(gl2, state);
	                            throwFBOError(status);
	                          }
	                          restoreFBOState(gl2, state);
	                        }
	                        function Framebuffer(gl2, width, height, colorType, numColors, useDepth, useStencil, ext) {
	                          this.gl = gl2;
	                          this._shape = [width | 0, height | 0];
	                          this._destroyed = false;
	                          this._ext = ext;
	                          this.color = new Array(numColors);
	                          for (var i = 0; i < numColors; ++i) {
	                            this.color[i] = null;
	                          }
	                          this._color_rb = null;
	                          this.depth = null;
	                          this._depth_rb = null;
	                          this._colorType = colorType;
	                          this._useDepth = useDepth;
	                          this._useStencil = useStencil;
	                          var parent = this;
	                          var shapeVector = [width | 0, height | 0];
	                          Object.defineProperties(shapeVector, { 0: { get: function() {
	                            return parent._shape[0];
	                          }, set: function(w) {
	                            return parent.width = w;
	                          } }, 1: { get: function() {
	                            return parent._shape[1];
	                          }, set: function(h) {
	                            return parent.height = h;
	                          } } });
	                          this._shapeVector = shapeVector;
	                          rebuildFBO(this);
	                        }
	                        var proto = Framebuffer.prototype;
	                        function reshapeFBO(fbo, w, h) {
	                          if (fbo._destroyed) {
	                            throw new Error("gl-fbo: Can't resize destroyed FBO");
	                          }
	                          if (fbo._shape[0] === w && fbo._shape[1] === h) {
	                            return;
	                          }
	                          var gl2 = fbo.gl;
	                          var maxFBOSize = gl2.getParameter(gl2.MAX_RENDERBUFFER_SIZE);
	                          if (w < 0 || w > maxFBOSize || h < 0 || h > maxFBOSize) {
	                            throw new Error("gl-fbo: Can't resize FBO, invalid dimensions");
	                          }
	                          fbo._shape[0] = w;
	                          fbo._shape[1] = h;
	                          var state = saveFBOState(gl2);
	                          for (var i = 0; i < fbo.color.length; ++i) {
	                            fbo.color[i].shape = fbo._shape;
	                          }
	                          if (fbo._color_rb) {
	                            gl2.bindRenderbuffer(gl2.RENDERBUFFER, fbo._color_rb);
	                            gl2.renderbufferStorage(gl2.RENDERBUFFER, gl2.RGBA4, fbo._shape[0], fbo._shape[1]);
	                          }
	                          if (fbo.depth) {
	                            fbo.depth.shape = fbo._shape;
	                          }
	                          if (fbo._depth_rb) {
	                            gl2.bindRenderbuffer(gl2.RENDERBUFFER, fbo._depth_rb);
	                            if (fbo._useDepth && fbo._useStencil) {
	                              gl2.renderbufferStorage(gl2.RENDERBUFFER, gl2.DEPTH_STENCIL, fbo._shape[0], fbo._shape[1]);
	                            } else if (fbo._useDepth) {
	                              gl2.renderbufferStorage(gl2.RENDERBUFFER, gl2.DEPTH_COMPONENT16, fbo._shape[0], fbo._shape[1]);
	                            } else if (fbo._useStencil) {
	                              gl2.renderbufferStorage(gl2.RENDERBUFFER, gl2.STENCIL_INDEX, fbo._shape[0], fbo._shape[1]);
	                            }
	                          }
	                          gl2.bindFramebuffer(gl2.FRAMEBUFFER, fbo.handle);
	                          var status = gl2.checkFramebufferStatus(gl2.FRAMEBUFFER);
	                          if (status !== gl2.FRAMEBUFFER_COMPLETE) {
	                            fbo.dispose();
	                            restoreFBOState(gl2, state);
	                            throwFBOError(status);
	                          }
	                          restoreFBOState(gl2, state);
	                        }
	                        Object.defineProperties(proto, { "shape": { get: function() {
	                          if (this._destroyed) {
	                            return [0, 0];
	                          }
	                          return this._shapeVector;
	                        }, set: function(x) {
	                          if (!Array.isArray(x)) {
	                            x = [x | 0, x | 0];
	                          }
	                          if (x.length !== 2) {
	                            throw new Error("gl-fbo: Shape vector must be length 2");
	                          }
	                          var w = x[0] | 0;
	                          var h = x[1] | 0;
	                          reshapeFBO(this, w, h);
	                          return [w, h];
	                        }, enumerable: false }, "width": { get: function() {
	                          if (this._destroyed) {
	                            return 0;
	                          }
	                          return this._shape[0];
	                        }, set: function(w) {
	                          w = w | 0;
	                          reshapeFBO(this, w, this._shape[1]);
	                          return w;
	                        }, enumerable: false }, "height": { get: function() {
	                          if (this._destroyed) {
	                            return 0;
	                          }
	                          return this._shape[1];
	                        }, set: function(h) {
	                          h = h | 0;
	                          reshapeFBO(this, this._shape[0], h);
	                          return h;
	                        }, enumerable: false } });
	                        proto.bind = function() {
	                          if (this._destroyed) {
	                            return;
	                          }
	                          var gl2 = this.gl;
	                          gl2.bindFramebuffer(gl2.FRAMEBUFFER, this.handle);
	                          gl2.viewport(0, 0, this._shape[0], this._shape[1]);
	                        };
	                        proto.dispose = function() {
	                          if (this._destroyed) {
	                            return;
	                          }
	                          this._destroyed = true;
	                          var gl2 = this.gl;
	                          gl2.deleteFramebuffer(this.handle);
	                          this.handle = null;
	                          if (this.depth) {
	                            this.depth.dispose();
	                            this.depth = null;
	                          }
	                          if (this._depth_rb) {
	                            gl2.deleteRenderbuffer(this._depth_rb);
	                            this._depth_rb = null;
	                          }
	                          for (var i = 0; i < this.color.length; ++i) {
	                            this.color[i].dispose();
	                            this.color[i] = null;
	                          }
	                          if (this._color_rb) {
	                            gl2.deleteRenderbuffer(this._color_rb);
	                            this._color_rb = null;
	                          }
	                        };
	                        function createFBO(gl2, width, height, options) {
	                          if (!FRAMEBUFFER_UNSUPPORTED) {
	                            FRAMEBUFFER_UNSUPPORTED = gl2.FRAMEBUFFER_UNSUPPORTED;
	                            FRAMEBUFFER_INCOMPLETE_ATTACHMENT = gl2.FRAMEBUFFER_INCOMPLETE_ATTACHMENT;
	                            FRAMEBUFFER_INCOMPLETE_DIMENSIONS = gl2.FRAMEBUFFER_INCOMPLETE_DIMENSIONS;
	                            FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = gl2.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT;
	                          }
	                          var WEBGL_draw_buffers = gl2.getExtension("WEBGL_draw_buffers");
	                          if (!colorAttachmentArrays && WEBGL_draw_buffers) {
	                            lazyInitColorAttachments(gl2, WEBGL_draw_buffers);
	                          }
	                          if (Array.isArray(width)) {
	                            options = height;
	                            height = width[1] | 0;
	                            width = width[0] | 0;
	                          }
	                          if (typeof width !== "number") {
	                            throw new Error("gl-fbo: Missing shape parameter");
	                          }
	                          var maxFBOSize = gl2.getParameter(gl2.MAX_RENDERBUFFER_SIZE);
	                          if (width < 0 || width > maxFBOSize || height < 0 || height > maxFBOSize) {
	                            throw new Error("gl-fbo: Parameters are too large for FBO");
	                          }
	                          options = options || {};
	                          var numColors = 1;
	                          if ("color" in options) {
	                            numColors = Math.max(options.color | 0, 0);
	                            if (numColors < 0) {
	                              throw new Error("gl-fbo: Must specify a nonnegative number of colors");
	                            }
	                            if (numColors > 1) {
	                              if (!WEBGL_draw_buffers) {
	                                throw new Error("gl-fbo: Multiple draw buffer extension not supported");
	                              } else if (numColors > gl2.getParameter(WEBGL_draw_buffers.MAX_COLOR_ATTACHMENTS_WEBGL)) {
	                                throw new Error("gl-fbo: Context does not support " + numColors + " draw buffers");
	                              }
	                            }
	                          }
	                          var colorType = gl2.UNSIGNED_BYTE;
	                          var OES_texture_float = gl2.getExtension("OES_texture_float");
	                          if (options.float && numColors > 0) {
	                            if (!OES_texture_float) {
	                              throw new Error("gl-fbo: Context does not support floating point textures");
	                            }
	                            colorType = gl2.FLOAT;
	                          } else if (options.preferFloat && numColors > 0) {
	                            if (OES_texture_float) {
	                              colorType = gl2.FLOAT;
	                            }
	                          }
	                          var useDepth = true;
	                          if ("depth" in options) {
	                            useDepth = !!options.depth;
	                          }
	                          var useStencil = false;
	                          if ("stencil" in options) {
	                            useStencil = !!options.stencil;
	                          }
	                          return new Framebuffer(gl2, width, height, colorType, numColors, useDepth, useStencil, WEBGL_draw_buffers);
	                        }
	                      }
	                    ),
	                    /***/
	                    3530: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_326286__) {
	                        var sprintf = __nested_webpack_require_326286__(8974).sprintf;
	                        var glConstants = __nested_webpack_require_326286__(6603);
	                        var shaderName = __nested_webpack_require_326286__(9365);
	                        var addLineNumbers = __nested_webpack_require_326286__(8008);
	                        module3.exports = formatCompilerError;
	                        function formatCompilerError(errLog, src, type) {
	                          var name2 = shaderName(src) || "of unknown name (see npm glsl-shader-name)";
	                          var typeName = "unknown type";
	                          if (type !== undefined) {
	                            typeName = type === glConstants.FRAGMENT_SHADER ? "fragment" : "vertex";
	                          }
	                          var longForm = sprintf("Error compiling %s shader %s:\n", typeName, name2);
	                          var shortForm = sprintf("%s%s", longForm, errLog);
	                          var errorStrings = errLog.split("\n");
	                          var errors = {};
	                          for (var i = 0; i < errorStrings.length; i++) {
	                            var errorString = errorStrings[i];
	                            if (errorString === "" || errorString === "\0") continue;
	                            var lineNo = parseInt(errorString.split(":")[2]);
	                            if (isNaN(lineNo)) {
	                              throw new Error(sprintf("Could not parse error: %s", errorString));
	                            }
	                            errors[lineNo] = errorString;
	                          }
	                          var lines = addLineNumbers(src).split("\n");
	                          for (var i = 0; i < lines.length; i++) {
	                            if (!errors[i + 3] && !errors[i + 2] && !errors[i + 1]) continue;
	                            var line = lines[i];
	                            longForm += line + "\n";
	                            if (errors[i + 1]) {
	                              var e = errors[i + 1];
	                              e = e.substr(e.split(":", 3).join(":").length + 1).trim();
	                              longForm += sprintf("^^^ %s\n\n", e);
	                            }
	                          }
	                          return { long: longForm.trim(), short: shortForm.trim() };
	                        }
	                      }
	                    ),
	                    /***/
	                    6386: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_327610__) {
	                        module3.exports = createHeatmap2D;
	                        var bsearch = __nested_webpack_require_327610__(5070);
	                        var iota = __nested_webpack_require_327610__(9560);
	                        var pool = __nested_webpack_require_327610__(5306);
	                        var createShader = __nested_webpack_require_327610__(5158);
	                        var createBuffer = __nested_webpack_require_327610__(5827);
	                        var shaders = __nested_webpack_require_327610__(1292);
	                        function GLHeatmap2D(plot, shader, pickShader, positionBuffer, weightBuffer, colorBuffer, idBuffer) {
	                          this.plot = plot;
	                          this.shader = shader;
	                          this.pickShader = pickShader;
	                          this.positionBuffer = positionBuffer;
	                          this.weightBuffer = weightBuffer;
	                          this.colorBuffer = colorBuffer;
	                          this.idBuffer = idBuffer;
	                          this.xData = [];
	                          this.yData = [];
	                          this.shape = [0, 0];
	                          this.bounds = [Infinity, Infinity, -Infinity, -Infinity];
	                          this.pickOffset = 0;
	                        }
	                        var proto = GLHeatmap2D.prototype;
	                        var WEIGHTS = [0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1];
	                        proto.draw = /* @__PURE__ */ function() {
	                          var MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];
	                          return function() {
	                            var plot = this.plot;
	                            var shader = this.shader;
	                            var bounds = this.bounds;
	                            var numVertices = this.numVertices;
	                            if (numVertices <= 0) {
	                              return;
	                            }
	                            var gl2 = plot.gl;
	                            var dataBox = plot.dataBox;
	                            var boundX = bounds[2] - bounds[0];
	                            var boundY = bounds[3] - bounds[1];
	                            var dataX = dataBox[2] - dataBox[0];
	                            var dataY = dataBox[3] - dataBox[1];
	                            MATRIX[0] = 2 * boundX / dataX;
	                            MATRIX[4] = 2 * boundY / dataY;
	                            MATRIX[6] = 2 * (bounds[0] - dataBox[0]) / dataX - 1;
	                            MATRIX[7] = 2 * (bounds[1] - dataBox[1]) / dataY - 1;
	                            shader.bind();
	                            var uniforms = shader.uniforms;
	                            uniforms.viewTransform = MATRIX;
	                            uniforms.shape = this.shape;
	                            var attributes = shader.attributes;
	                            this.positionBuffer.bind();
	                            attributes.position.pointer();
	                            this.weightBuffer.bind();
	                            attributes.weight.pointer(gl2.UNSIGNED_BYTE, false);
	                            this.colorBuffer.bind();
	                            attributes.color.pointer(gl2.UNSIGNED_BYTE, true);
	                            gl2.drawArrays(gl2.TRIANGLES, 0, numVertices);
	                          };
	                        }();
	                        proto.drawPick = /* @__PURE__ */ function() {
	                          var MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];
	                          var PICK_VECTOR = [0, 0, 0, 0];
	                          return function(pickOffset) {
	                            var plot = this.plot;
	                            var shader = this.pickShader;
	                            var bounds = this.bounds;
	                            var numVertices = this.numVertices;
	                            if (numVertices <= 0) {
	                              return;
	                            }
	                            var gl2 = plot.gl;
	                            var dataBox = plot.dataBox;
	                            var boundX = bounds[2] - bounds[0];
	                            var boundY = bounds[3] - bounds[1];
	                            var dataX = dataBox[2] - dataBox[0];
	                            var dataY = dataBox[3] - dataBox[1];
	                            MATRIX[0] = 2 * boundX / dataX;
	                            MATRIX[4] = 2 * boundY / dataY;
	                            MATRIX[6] = 2 * (bounds[0] - dataBox[0]) / dataX - 1;
	                            MATRIX[7] = 2 * (bounds[1] - dataBox[1]) / dataY - 1;
	                            for (var i = 0; i < 4; ++i) {
	                              PICK_VECTOR[i] = pickOffset >> i * 8 & 255;
	                            }
	                            this.pickOffset = pickOffset;
	                            shader.bind();
	                            var uniforms = shader.uniforms;
	                            uniforms.viewTransform = MATRIX;
	                            uniforms.pickOffset = PICK_VECTOR;
	                            uniforms.shape = this.shape;
	                            var attributes = shader.attributes;
	                            this.positionBuffer.bind();
	                            attributes.position.pointer();
	                            this.weightBuffer.bind();
	                            attributes.weight.pointer(gl2.UNSIGNED_BYTE, false);
	                            this.idBuffer.bind();
	                            attributes.pickId.pointer(gl2.UNSIGNED_BYTE, false);
	                            gl2.drawArrays(gl2.TRIANGLES, 0, numVertices);
	                            return pickOffset + this.shape[0] * this.shape[1];
	                          };
	                        }();
	                        proto.pick = function(x, y, value) {
	                          var pickOffset = this.pickOffset;
	                          var pointCount = this.shape[0] * this.shape[1];
	                          if (value < pickOffset || value >= pickOffset + pointCount) {
	                            return null;
	                          }
	                          var pointId = value - pickOffset;
	                          var xData = this.xData;
	                          var yData = this.yData;
	                          return { object: this, pointId, dataCoord: [xData[pointId % this.shape[0]], yData[pointId / this.shape[0] | 0]] };
	                        };
	                        proto.update = function(options) {
	                          options = options || {};
	                          var shape = options.shape || [0, 0];
	                          var x = options.x || iota(shape[0]);
	                          var y = options.y || iota(shape[1]);
	                          var z = options.z || new Float32Array(shape[0] * shape[1]);
	                          var isSmooth = options.zsmooth !== false;
	                          this.xData = x;
	                          this.yData = y;
	                          var colorLevels = options.colorLevels || [0];
	                          var colorValues = options.colorValues || [0, 0, 0, 1];
	                          var colorCount = colorLevels.length;
	                          var bounds = this.bounds;
	                          var lox, loy, hix, hiy;
	                          if (isSmooth) {
	                            lox = bounds[0] = x[0];
	                            loy = bounds[1] = y[0];
	                            hix = bounds[2] = x[x.length - 1];
	                            hiy = bounds[3] = y[y.length - 1];
	                          } else {
	                            lox = bounds[0] = x[0] + (x[1] - x[0]) / 2;
	                            loy = bounds[1] = y[0] + (y[1] - y[0]) / 2;
	                            hix = bounds[2] = x[x.length - 1] + (x[x.length - 1] - x[x.length - 2]) / 2;
	                            hiy = bounds[3] = y[y.length - 1] + (y[y.length - 1] - y[y.length - 2]) / 2;
	                          }
	                          var xs = 1 / (hix - lox);
	                          var ys = 1 / (hiy - loy);
	                          var numX = shape[0];
	                          var numY = shape[1];
	                          this.shape = [numX, numY];
	                          var numVerts = (isSmooth ? (numX - 1) * (numY - 1) : numX * numY) * (WEIGHTS.length >>> 1);
	                          this.numVertices = numVerts;
	                          var colors = pool.mallocUint8(numVerts * 4);
	                          var positions = pool.mallocFloat32(numVerts * 2);
	                          var weights = pool.mallocUint8(numVerts * 2);
	                          var ids = pool.mallocUint32(numVerts);
	                          var ptr = 0;
	                          var ni = isSmooth ? numX - 1 : numX;
	                          var nj = isSmooth ? numY - 1 : numY;
	                          for (var j = 0; j < nj; ++j) {
	                            var yc0, yc1;
	                            if (isSmooth) {
	                              yc0 = ys * (y[j] - loy);
	                              yc1 = ys * (y[j + 1] - loy);
	                            } else {
	                              yc0 = j < numY - 1 ? ys * (y[j] - (y[j + 1] - y[j]) / 2 - loy) : ys * (y[j] - (y[j] - y[j - 1]) / 2 - loy);
	                              yc1 = j < numY - 1 ? ys * (y[j] + (y[j + 1] - y[j]) / 2 - loy) : ys * (y[j] + (y[j] - y[j - 1]) / 2 - loy);
	                            }
	                            for (var i = 0; i < ni; ++i) {
	                              var xc0, xc1;
	                              if (isSmooth) {
	                                xc0 = xs * (x[i] - lox);
	                                xc1 = xs * (x[i + 1] - lox);
	                              } else {
	                                xc0 = i < numX - 1 ? xs * (x[i] - (x[i + 1] - x[i]) / 2 - lox) : xs * (x[i] - (x[i] - x[i - 1]) / 2 - lox);
	                                xc1 = i < numX - 1 ? xs * (x[i] + (x[i + 1] - x[i]) / 2 - lox) : xs * (x[i] + (x[i] - x[i - 1]) / 2 - lox);
	                              }
	                              for (var dd = 0; dd < WEIGHTS.length; dd += 2) {
	                                var dx = WEIGHTS[dd];
	                                var dy = WEIGHTS[dd + 1];
	                                var offset = isSmooth ? (j + dy) * numX + (i + dx) : j * numX + i;
	                                var zc = z[offset];
	                                var colorIdx = bsearch.le(colorLevels, zc);
	                                var r, g, b, a;
	                                if (colorIdx < 0) {
	                                  r = colorValues[0];
	                                  g = colorValues[1];
	                                  b = colorValues[2];
	                                  a = colorValues[3];
	                                } else if (colorIdx === colorCount - 1) {
	                                  r = colorValues[4 * colorCount - 4];
	                                  g = colorValues[4 * colorCount - 3];
	                                  b = colorValues[4 * colorCount - 2];
	                                  a = colorValues[4 * colorCount - 1];
	                                } else {
	                                  var t = (zc - colorLevels[colorIdx]) / (colorLevels[colorIdx + 1] - colorLevels[colorIdx]);
	                                  var ti = 1 - t;
	                                  var i0 = 4 * colorIdx;
	                                  var i1 = 4 * (colorIdx + 1);
	                                  r = ti * colorValues[i0] + t * colorValues[i1];
	                                  g = ti * colorValues[i0 + 1] + t * colorValues[i1 + 1];
	                                  b = ti * colorValues[i0 + 2] + t * colorValues[i1 + 2];
	                                  a = ti * colorValues[i0 + 3] + t * colorValues[i1 + 3];
	                                }
	                                colors[4 * ptr] = 255 * r;
	                                colors[4 * ptr + 1] = 255 * g;
	                                colors[4 * ptr + 2] = 255 * b;
	                                colors[4 * ptr + 3] = 255 * a;
	                                positions[2 * ptr] = xc0 * 0.5 + xc1 * 0.5;
	                                positions[2 * ptr + 1] = yc0 * 0.5 + yc1 * 0.5;
	                                weights[2 * ptr] = dx;
	                                weights[2 * ptr + 1] = dy;
	                                ids[ptr] = j * numX + i;
	                                ptr += 1;
	                              }
	                            }
	                          }
	                          this.positionBuffer.update(positions);
	                          this.weightBuffer.update(weights);
	                          this.colorBuffer.update(colors);
	                          this.idBuffer.update(ids);
	                          pool.free(positions);
	                          pool.free(colors);
	                          pool.free(weights);
	                          pool.free(ids);
	                        };
	                        proto.dispose = function() {
	                          this.shader.dispose();
	                          this.pickShader.dispose();
	                          this.positionBuffer.dispose();
	                          this.weightBuffer.dispose();
	                          this.colorBuffer.dispose();
	                          this.idBuffer.dispose();
	                          this.plot.removeObject(this);
	                        };
	                        function createHeatmap2D(plot, options) {
	                          var gl2 = plot.gl;
	                          var shader = createShader(gl2, shaders.vertex, shaders.fragment);
	                          var pickShader = createShader(gl2, shaders.pickVertex, shaders.pickFragment);
	                          var positionBuffer = createBuffer(gl2);
	                          var weightBuffer = createBuffer(gl2);
	                          var colorBuffer = createBuffer(gl2);
	                          var idBuffer = createBuffer(gl2);
	                          var heatmap = new GLHeatmap2D(plot, shader, pickShader, positionBuffer, weightBuffer, colorBuffer, idBuffer);
	                          heatmap.update(options);
	                          plot.addObject(heatmap);
	                          return heatmap;
	                        }
	                      }
	                    ),
	                    /***/
	                    1292: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_334426__) {
	                        var glslify = __nested_webpack_require_334426__(6832);
	                        module3.exports = { fragment: glslify(["precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"]), vertex: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"]), pickFragment: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"]), pickVertex: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"]) };
	                      }
	                    ),
	                    /***/
	                    248: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_336131__) {
	                        var glslify = __nested_webpack_require_336131__(6832);
	                        var createShader = __nested_webpack_require_336131__(5158);
	                        var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"]);
	                        var forwardFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"]);
	                        var pickFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"]);
	                        var ATTRIBUTES = [{ name: "position", type: "vec3" }, { name: "nextPosition", type: "vec3" }, { name: "arcLength", type: "float" }, { name: "lineWidth", type: "float" }, { name: "color", type: "vec4" }];
	                        exports2.createShader = function(gl2) {
	                          return createShader(gl2, vertSrc, forwardFrag, null, ATTRIBUTES);
	                        };
	                        exports2.createPickShader = function(gl2) {
	                          return createShader(gl2, vertSrc, pickFrag, null, ATTRIBUTES);
	                        };
	                      }
	                    ),
	                    /***/
	                    6086: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_340632__) {
	                        module3.exports = createLinePlot;
	                        var createBuffer = __nested_webpack_require_340632__(5827);
	                        var createVAO = __nested_webpack_require_340632__(2944);
	                        var createTexture = __nested_webpack_require_340632__(8931);
	                        var UINT8_VIEW = new Uint8Array(4);
	                        var FLOAT_VIEW = new Float32Array(UINT8_VIEW.buffer);
	                        function unpackFloat(x, y, z, w) {
	                          UINT8_VIEW[0] = w;
	                          UINT8_VIEW[1] = z;
	                          UINT8_VIEW[2] = y;
	                          UINT8_VIEW[3] = x;
	                          return FLOAT_VIEW[0];
	                        }
	                        var bsearch = __nested_webpack_require_340632__(5070);
	                        var ndarray = __nested_webpack_require_340632__(5050);
	                        var shaders = __nested_webpack_require_340632__(248);
	                        var createShader = shaders.createShader;
	                        var createPickShader = shaders.createPickShader;
	                        var identity2 = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        function distance(a, b) {
	                          var s = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            var d = a[i] - b[i];
	                            s += d * d;
	                          }
	                          return Math.sqrt(s);
	                        }
	                        function filterClipBounds(bounds) {
	                          var result = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]];
	                          for (var i = 0; i < 3; ++i) {
	                            result[0][i] = Math.max(bounds[0][i], result[0][i]);
	                            result[1][i] = Math.min(bounds[1][i], result[1][i]);
	                          }
	                          return result;
	                        }
	                        function PickResult(tau, position, index, dataCoordinate) {
	                          this.arcLength = tau;
	                          this.position = position;
	                          this.index = index;
	                          this.dataCoordinate = dataCoordinate;
	                        }
	                        function LinePlot(gl2, shader, pickShader, buffer, vao, texture) {
	                          this.gl = gl2;
	                          this.shader = shader;
	                          this.pickShader = pickShader;
	                          this.buffer = buffer;
	                          this.vao = vao;
	                          this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.points = [];
	                          this.arcLength = [];
	                          this.vertexCount = 0;
	                          this.bounds = [[0, 0, 0], [0, 0, 0]];
	                          this.pickId = 0;
	                          this.lineWidth = 1;
	                          this.texture = texture;
	                          this.dashScale = 1;
	                          this.opacity = 1;
	                          this.hasAlpha = false;
	                          this.dirty = true;
	                          this.pixelRatio = 1;
	                        }
	                        var proto = LinePlot.prototype;
	                        proto.isTransparent = function() {
	                          return this.hasAlpha;
	                        };
	                        proto.isOpaque = function() {
	                          return !this.hasAlpha;
	                        };
	                        proto.pickSlots = 1;
	                        proto.setPickBase = function(id) {
	                          this.pickId = id;
	                        };
	                        proto.drawTransparent = proto.draw = function(camera) {
	                          if (!this.vertexCount) return;
	                          var gl2 = this.gl;
	                          var shader = this.shader;
	                          var vao = this.vao;
	                          shader.bind();
	                          shader.uniforms = { model: camera.model || identity2, view: camera.view || identity2, projection: camera.projection || identity2, clipBounds: filterClipBounds(this.clipBounds), dashTexture: this.texture.bind(), dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1], opacity: this.opacity, screenShape: [gl2.drawingBufferWidth, gl2.drawingBufferHeight], pixelRatio: this.pixelRatio };
	                          vao.bind();
	                          vao.draw(gl2.TRIANGLE_STRIP, this.vertexCount);
	                          vao.unbind();
	                        };
	                        proto.drawPick = function(camera) {
	                          if (!this.vertexCount) return;
	                          var gl2 = this.gl;
	                          var shader = this.pickShader;
	                          var vao = this.vao;
	                          shader.bind();
	                          shader.uniforms = { model: camera.model || identity2, view: camera.view || identity2, projection: camera.projection || identity2, pickId: this.pickId, clipBounds: filterClipBounds(this.clipBounds), screenShape: [gl2.drawingBufferWidth, gl2.drawingBufferHeight], pixelRatio: this.pixelRatio };
	                          vao.bind();
	                          vao.draw(gl2.TRIANGLE_STRIP, this.vertexCount);
	                          vao.unbind();
	                        };
	                        proto.update = function(options) {
	                          var i, j;
	                          this.dirty = true;
	                          var connectGaps = !!options.connectGaps;
	                          if ("dashScale" in options) {
	                            this.dashScale = options.dashScale;
	                          }
	                          this.hasAlpha = false;
	                          if ("opacity" in options) {
	                            this.opacity = +options.opacity;
	                            if (this.opacity < 1) {
	                              this.hasAlpha = true;
	                            }
	                          }
	                          var buffer = [];
	                          var arcLengthArray = [];
	                          var pointArray = [];
	                          var arcLength = 0;
	                          var vertexCount = 0;
	                          var bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          var positions = options.position || options.positions;
	                          if (positions) {
	                            var colors = options.color || options.colors || [0, 0, 0, 1];
	                            var lineWidth = options.lineWidth || 1;
	                            var hadGap = false;
	                            fill_loop: for (i = 1; i < positions.length; ++i) {
	                              var a = positions[i - 1];
	                              var b = positions[i];
	                              arcLengthArray.push(arcLength);
	                              pointArray.push(a.slice());
	                              for (j = 0; j < 3; ++j) {
	                                if (isNaN(a[j]) || isNaN(b[j]) || !isFinite(a[j]) || !isFinite(b[j])) {
	                                  if (!connectGaps && buffer.length > 0) {
	                                    for (var k = 0; k < 24; ++k) {
	                                      buffer.push(buffer[buffer.length - 12]);
	                                    }
	                                    vertexCount += 2;
	                                    hadGap = true;
	                                  }
	                                  continue fill_loop;
	                                }
	                                bounds[0][j] = Math.min(bounds[0][j], a[j], b[j]);
	                                bounds[1][j] = Math.max(bounds[1][j], a[j], b[j]);
	                              }
	                              var acolor, bcolor;
	                              if (Array.isArray(colors[0])) {
	                                acolor = colors.length > i - 1 ? colors[i - 1] : (
	                                  // using index value
	                                  colors.length > 0 ? colors[colors.length - 1] : (
	                                    // using last item
	                                    [0, 0, 0, 1]
	                                  )
	                                );
	                                bcolor = colors.length > i ? colors[i] : (
	                                  // using index value
	                                  colors.length > 0 ? colors[colors.length - 1] : (
	                                    // using last item
	                                    [0, 0, 0, 1]
	                                  )
	                                );
	                              } else {
	                                acolor = bcolor = colors;
	                              }
	                              if (acolor.length === 3) {
	                                acolor = [acolor[0], acolor[1], acolor[2], 1];
	                              }
	                              if (bcolor.length === 3) {
	                                bcolor = [bcolor[0], bcolor[1], bcolor[2], 1];
	                              }
	                              if (!this.hasAlpha && acolor[3] < 1) this.hasAlpha = true;
	                              var w0;
	                              if (Array.isArray(lineWidth)) {
	                                w0 = lineWidth.length > i - 1 ? lineWidth[i - 1] : (
	                                  // using index value
	                                  lineWidth.length > 0 ? lineWidth[lineWidth.length - 1] : (
	                                    // using last item
	                                    [0, 0, 0, 1]
	                                  )
	                                );
	                              } else {
	                                w0 = lineWidth;
	                              }
	                              var t0 = arcLength;
	                              arcLength += distance(a, b);
	                              if (hadGap) {
	                                for (j = 0; j < 2; ++j) {
	                                  buffer.push(a[0], a[1], a[2], b[0], b[1], b[2], t0, w0, acolor[0], acolor[1], acolor[2], acolor[3]);
	                                }
	                                vertexCount += 2;
	                                hadGap = false;
	                              }
	                              buffer.push(a[0], a[1], a[2], b[0], b[1], b[2], t0, w0, acolor[0], acolor[1], acolor[2], acolor[3], a[0], a[1], a[2], b[0], b[1], b[2], t0, -w0, acolor[0], acolor[1], acolor[2], acolor[3], b[0], b[1], b[2], a[0], a[1], a[2], arcLength, -w0, bcolor[0], bcolor[1], bcolor[2], bcolor[3], b[0], b[1], b[2], a[0], a[1], a[2], arcLength, w0, bcolor[0], bcolor[1], bcolor[2], bcolor[3]);
	                              vertexCount += 4;
	                            }
	                          }
	                          this.buffer.update(buffer);
	                          arcLengthArray.push(arcLength);
	                          pointArray.push(positions[positions.length - 1].slice());
	                          this.bounds = bounds;
	                          this.vertexCount = vertexCount;
	                          this.points = pointArray;
	                          this.arcLength = arcLengthArray;
	                          if ("dashes" in options) {
	                            var dashArray = options.dashes;
	                            var prefixSum = dashArray.slice();
	                            prefixSum.unshift(0);
	                            for (i = 1; i < prefixSum.length; ++i) {
	                              prefixSum[i] = prefixSum[i - 1] + prefixSum[i];
	                            }
	                            var dashTexture = ndarray(new Array(256 * 4), [256, 1, 4]);
	                            for (i = 0; i < 256; ++i) {
	                              for (j = 0; j < 4; ++j) {
	                                dashTexture.set(i, 0, j, 0);
	                              }
	                              if (bsearch.le(prefixSum, prefixSum[prefixSum.length - 1] * i / 255) & 1) {
	                                dashTexture.set(i, 0, 0, 0);
	                              } else {
	                                dashTexture.set(i, 0, 0, 255);
	                              }
	                            }
	                            this.texture.setPixels(dashTexture);
	                          }
	                        };
	                        proto.dispose = function() {
	                          this.shader.dispose();
	                          this.vao.dispose();
	                          this.buffer.dispose();
	                        };
	                        proto.pick = function(selection) {
	                          if (!selection) {
	                            return null;
	                          }
	                          if (selection.id !== this.pickId) {
	                            return null;
	                          }
	                          var tau = unpackFloat(selection.value[0], selection.value[1], selection.value[2], 0);
	                          var index = bsearch.le(this.arcLength, tau);
	                          if (index < 0) {
	                            return null;
	                          }
	                          if (index === this.arcLength.length - 1) {
	                            return new PickResult(this.arcLength[this.arcLength.length - 1], this.points[this.points.length - 1].slice(), index);
	                          }
	                          var a = this.points[index];
	                          var b = this.points[Math.min(index + 1, this.points.length - 1)];
	                          var t = (tau - this.arcLength[index]) / (this.arcLength[index + 1] - this.arcLength[index]);
	                          var ti = 1 - t;
	                          var x = [0, 0, 0];
	                          for (var i = 0; i < 3; ++i) {
	                            x[i] = ti * a[i] + t * b[i];
	                          }
	                          var dataIndex = Math.min(t < 0.5 ? index : index + 1, this.points.length - 1);
	                          return new PickResult(tau, x, dataIndex, this.points[dataIndex]);
	                        };
	                        function createLinePlot(options) {
	                          var gl2 = options.gl || options.scene && options.scene.gl;
	                          var shader = createShader(gl2);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.nextPosition.location = 1;
	                          shader.attributes.arcLength.location = 2;
	                          shader.attributes.lineWidth.location = 3;
	                          shader.attributes.color.location = 4;
	                          var pickShader = createPickShader(gl2);
	                          pickShader.attributes.position.location = 0;
	                          pickShader.attributes.nextPosition.location = 1;
	                          pickShader.attributes.arcLength.location = 2;
	                          pickShader.attributes.lineWidth.location = 3;
	                          pickShader.attributes.color.location = 4;
	                          var buffer = createBuffer(gl2);
	                          var vao = createVAO(gl2, [{ "buffer": buffer, "size": 3, "offset": 0, "stride": 48 }, { "buffer": buffer, "size": 3, "offset": 12, "stride": 48 }, { "buffer": buffer, "size": 1, "offset": 24, "stride": 48 }, { "buffer": buffer, "size": 1, "offset": 28, "stride": 48 }, { "buffer": buffer, "size": 4, "offset": 32, "stride": 48 }]);
	                          var defaultTexture = ndarray(new Array(256 * 4), [256, 1, 4]);
	                          for (var i = 0; i < 256 * 4; ++i) {
	                            defaultTexture.data[i] = 255;
	                          }
	                          var texture = createTexture(gl2, defaultTexture);
	                          texture.wrap = gl2.REPEAT;
	                          var linePlot = new LinePlot(gl2, shader, pickShader, buffer, vao, texture);
	                          linePlot.update(options);
	                          return linePlot;
	                        }
	                      }
	                    ),
	                    /***/
	                    7332: (
	                      /***/
	                      function(module3) {
	                        module3.exports = clone;
	                        function clone(a) {
	                          var out = new Float32Array(16);
	                          out[0] = a[0];
	                          out[1] = a[1];
	                          out[2] = a[2];
	                          out[3] = a[3];
	                          out[4] = a[4];
	                          out[5] = a[5];
	                          out[6] = a[6];
	                          out[7] = a[7];
	                          out[8] = a[8];
	                          out[9] = a[9];
	                          out[10] = a[10];
	                          out[11] = a[11];
	                          out[12] = a[12];
	                          out[13] = a[13];
	                          out[14] = a[14];
	                          out[15] = a[15];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    9823: (
	                      /***/
	                      function(module3) {
	                        module3.exports = create;
	                        function create() {
	                          var out = new Float32Array(16);
	                          out[0] = 1;
	                          out[1] = 0;
	                          out[2] = 0;
	                          out[3] = 0;
	                          out[4] = 0;
	                          out[5] = 1;
	                          out[6] = 0;
	                          out[7] = 0;
	                          out[8] = 0;
	                          out[9] = 0;
	                          out[10] = 1;
	                          out[11] = 0;
	                          out[12] = 0;
	                          out[13] = 0;
	                          out[14] = 0;
	                          out[15] = 1;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7787: (
	                      /***/
	                      function(module3) {
	                        module3.exports = determinant;
	                        function determinant(a) {
	                          var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32;
	                          return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	                        }
	                      }
	                    ),
	                    /***/
	                    5950: (
	                      /***/
	                      function(module3) {
	                        module3.exports = fromQuat;
	                        function fromQuat(out, q) {
	                          var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, yx = y * x2, yy = y * y2, zx = z * x2, zy = z * y2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
	                          out[0] = 1 - yy - zz;
	                          out[1] = yx + wz;
	                          out[2] = zx - wy;
	                          out[3] = 0;
	                          out[4] = yx - wz;
	                          out[5] = 1 - xx - zz;
	                          out[6] = zy + wx;
	                          out[7] = 0;
	                          out[8] = zx + wy;
	                          out[9] = zy - wx;
	                          out[10] = 1 - xx - yy;
	                          out[11] = 0;
	                          out[12] = 0;
	                          out[13] = 0;
	                          out[14] = 0;
	                          out[15] = 1;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7280: (
	                      /***/
	                      function(module3) {
	                        module3.exports = fromRotationTranslation;
	                        function fromRotationTranslation(out, q, v) {
	                          var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, xy = x * y2, xz = x * z2, yy = y * y2, yz = y * z2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
	                          out[0] = 1 - (yy + zz);
	                          out[1] = xy + wz;
	                          out[2] = xz - wy;
	                          out[3] = 0;
	                          out[4] = xy - wz;
	                          out[5] = 1 - (xx + zz);
	                          out[6] = yz + wx;
	                          out[7] = 0;
	                          out[8] = xz + wy;
	                          out[9] = yz - wx;
	                          out[10] = 1 - (xx + yy);
	                          out[11] = 0;
	                          out[12] = v[0];
	                          out[13] = v[1];
	                          out[14] = v[2];
	                          out[15] = 1;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    9947: (
	                      /***/
	                      function(module3) {
	                        module3.exports = identity2;
	                        function identity2(out) {
	                          out[0] = 1;
	                          out[1] = 0;
	                          out[2] = 0;
	                          out[3] = 0;
	                          out[4] = 0;
	                          out[5] = 1;
	                          out[6] = 0;
	                          out[7] = 0;
	                          out[8] = 0;
	                          out[9] = 0;
	                          out[10] = 1;
	                          out[11] = 0;
	                          out[12] = 0;
	                          out[13] = 0;
	                          out[14] = 0;
	                          out[15] = 1;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7437: (
	                      /***/
	                      function(module3) {
	                        module3.exports = invert;
	                        function invert(out, a) {
	                          var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32, det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	                          if (!det) {
	                            return null;
	                          }
	                          det = 1 / det;
	                          out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	                          out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	                          out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	                          out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	                          out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	                          out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	                          out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	                          out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	                          out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	                          out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	                          out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	                          out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	                          out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	                          out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	                          out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	                          out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3012: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_353444__) {
	                        var identity2 = __nested_webpack_require_353444__(9947);
	                        module3.exports = lookAt;
	                        function lookAt(out, eye, center, up) {
	                          var x0, x1, x2, y0, y1, y2, z0, z1, z2, len, eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2], centerx = center[0], centery = center[1], centerz = center[2];
	                          if (Math.abs(eyex - centerx) < 1e-6 && Math.abs(eyey - centery) < 1e-6 && Math.abs(eyez - centerz) < 1e-6) {
	                            return identity2(out);
	                          }
	                          z0 = eyex - centerx;
	                          z1 = eyey - centery;
	                          z2 = eyez - centerz;
	                          len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
	                          z0 *= len;
	                          z1 *= len;
	                          z2 *= len;
	                          x0 = upy * z2 - upz * z1;
	                          x1 = upz * z0 - upx * z2;
	                          x2 = upx * z1 - upy * z0;
	                          len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
	                          if (!len) {
	                            x0 = 0;
	                            x1 = 0;
	                            x2 = 0;
	                          } else {
	                            len = 1 / len;
	                            x0 *= len;
	                            x1 *= len;
	                            x2 *= len;
	                          }
	                          y0 = z1 * x2 - z2 * x1;
	                          y1 = z2 * x0 - z0 * x2;
	                          y2 = z0 * x1 - z1 * x0;
	                          len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
	                          if (!len) {
	                            y0 = 0;
	                            y1 = 0;
	                            y2 = 0;
	                          } else {
	                            len = 1 / len;
	                            y0 *= len;
	                            y1 *= len;
	                            y2 *= len;
	                          }
	                          out[0] = x0;
	                          out[1] = y0;
	                          out[2] = z0;
	                          out[3] = 0;
	                          out[4] = x1;
	                          out[5] = y1;
	                          out[6] = z1;
	                          out[7] = 0;
	                          out[8] = x2;
	                          out[9] = y2;
	                          out[10] = z2;
	                          out[11] = 0;
	                          out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
	                          out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
	                          out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
	                          out[15] = 1;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    104: (
	                      /***/
	                      function(module3) {
	                        module3.exports = multiply;
	                        function multiply(out, a, b) {
	                          var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	                          var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	                          out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                          out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                          out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                          out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                          b0 = b[4];
	                          b1 = b[5];
	                          b2 = b[6];
	                          b3 = b[7];
	                          out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                          out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                          out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                          out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                          b0 = b[8];
	                          b1 = b[9];
	                          b2 = b[10];
	                          b3 = b[11];
	                          out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                          out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                          out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                          out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                          b0 = b[12];
	                          b1 = b[13];
	                          b2 = b[14];
	                          b3 = b[15];
	                          out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                          out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                          out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                          out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5268: (
	                      /***/
	                      function(module3) {
	                        module3.exports = ortho;
	                        function ortho(out, left, right, bottom, top, near, far) {
	                          var lr = 1 / (left - right), bt = 1 / (bottom - top), nf = 1 / (near - far);
	                          out[0] = -2 * lr;
	                          out[1] = 0;
	                          out[2] = 0;
	                          out[3] = 0;
	                          out[4] = 0;
	                          out[5] = -2 * bt;
	                          out[6] = 0;
	                          out[7] = 0;
	                          out[8] = 0;
	                          out[9] = 0;
	                          out[10] = 2 * nf;
	                          out[11] = 0;
	                          out[12] = (left + right) * lr;
	                          out[13] = (top + bottom) * bt;
	                          out[14] = (far + near) * nf;
	                          out[15] = 1;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1120: (
	                      /***/
	                      function(module3) {
	                        module3.exports = perspective;
	                        function perspective(out, fovy, aspect, near, far) {
	                          var f = 1 / Math.tan(fovy / 2), nf = 1 / (near - far);
	                          out[0] = f / aspect;
	                          out[1] = 0;
	                          out[2] = 0;
	                          out[3] = 0;
	                          out[4] = 0;
	                          out[5] = f;
	                          out[6] = 0;
	                          out[7] = 0;
	                          out[8] = 0;
	                          out[9] = 0;
	                          out[10] = (far + near) * nf;
	                          out[11] = -1;
	                          out[12] = 0;
	                          out[13] = 0;
	                          out[14] = 2 * far * near * nf;
	                          out[15] = 0;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    4422: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotate;
	                        function rotate(out, a, rad, axis) {
	                          var x = axis[0], y = axis[1], z = axis[2], len = Math.sqrt(x * x + y * y + z * z), s, c, t, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, b00, b01, b02, b10, b11, b12, b20, b21, b22;
	                          if (Math.abs(len) < 1e-6) {
	                            return null;
	                          }
	                          len = 1 / len;
	                          x *= len;
	                          y *= len;
	                          z *= len;
	                          s = Math.sin(rad);
	                          c = Math.cos(rad);
	                          t = 1 - c;
	                          a00 = a[0];
	                          a01 = a[1];
	                          a02 = a[2];
	                          a03 = a[3];
	                          a10 = a[4];
	                          a11 = a[5];
	                          a12 = a[6];
	                          a13 = a[7];
	                          a20 = a[8];
	                          a21 = a[9];
	                          a22 = a[10];
	                          a23 = a[11];
	                          b00 = x * x * t + c;
	                          b01 = y * x * t + z * s;
	                          b02 = z * x * t - y * s;
	                          b10 = x * y * t - z * s;
	                          b11 = y * y * t + c;
	                          b12 = z * y * t + x * s;
	                          b20 = x * z * t + y * s;
	                          b21 = y * z * t - x * s;
	                          b22 = z * z * t + c;
	                          out[0] = a00 * b00 + a10 * b01 + a20 * b02;
	                          out[1] = a01 * b00 + a11 * b01 + a21 * b02;
	                          out[2] = a02 * b00 + a12 * b01 + a22 * b02;
	                          out[3] = a03 * b00 + a13 * b01 + a23 * b02;
	                          out[4] = a00 * b10 + a10 * b11 + a20 * b12;
	                          out[5] = a01 * b10 + a11 * b11 + a21 * b12;
	                          out[6] = a02 * b10 + a12 * b11 + a22 * b12;
	                          out[7] = a03 * b10 + a13 * b11 + a23 * b12;
	                          out[8] = a00 * b20 + a10 * b21 + a20 * b22;
	                          out[9] = a01 * b20 + a11 * b21 + a21 * b22;
	                          out[10] = a02 * b20 + a12 * b21 + a22 * b22;
	                          out[11] = a03 * b20 + a13 * b21 + a23 * b22;
	                          if (a !== out) {
	                            out[12] = a[12];
	                            out[13] = a[13];
	                            out[14] = a[14];
	                            out[15] = a[15];
	                          }
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6109: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotateX;
	                        function rotateX(out, a, rad) {
	                          var s = Math.sin(rad), c = Math.cos(rad), a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
	                          if (a !== out) {
	                            out[0] = a[0];
	                            out[1] = a[1];
	                            out[2] = a[2];
	                            out[3] = a[3];
	                            out[12] = a[12];
	                            out[13] = a[13];
	                            out[14] = a[14];
	                            out[15] = a[15];
	                          }
	                          out[4] = a10 * c + a20 * s;
	                          out[5] = a11 * c + a21 * s;
	                          out[6] = a12 * c + a22 * s;
	                          out[7] = a13 * c + a23 * s;
	                          out[8] = a20 * c - a10 * s;
	                          out[9] = a21 * c - a11 * s;
	                          out[10] = a22 * c - a12 * s;
	                          out[11] = a23 * c - a13 * s;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7115: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotateY;
	                        function rotateY(out, a, rad) {
	                          var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
	                          if (a !== out) {
	                            out[4] = a[4];
	                            out[5] = a[5];
	                            out[6] = a[6];
	                            out[7] = a[7];
	                            out[12] = a[12];
	                            out[13] = a[13];
	                            out[14] = a[14];
	                            out[15] = a[15];
	                          }
	                          out[0] = a00 * c - a20 * s;
	                          out[1] = a01 * c - a21 * s;
	                          out[2] = a02 * c - a22 * s;
	                          out[3] = a03 * c - a23 * s;
	                          out[8] = a00 * s + a20 * c;
	                          out[9] = a01 * s + a21 * c;
	                          out[10] = a02 * s + a22 * c;
	                          out[11] = a03 * s + a23 * c;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5240: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotateZ;
	                        function rotateZ(out, a, rad) {
	                          var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
	                          if (a !== out) {
	                            out[8] = a[8];
	                            out[9] = a[9];
	                            out[10] = a[10];
	                            out[11] = a[11];
	                            out[12] = a[12];
	                            out[13] = a[13];
	                            out[14] = a[14];
	                            out[15] = a[15];
	                          }
	                          out[0] = a00 * c + a10 * s;
	                          out[1] = a01 * c + a11 * s;
	                          out[2] = a02 * c + a12 * s;
	                          out[3] = a03 * c + a13 * s;
	                          out[4] = a10 * c - a00 * s;
	                          out[5] = a11 * c - a01 * s;
	                          out[6] = a12 * c - a02 * s;
	                          out[7] = a13 * c - a03 * s;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3668: (
	                      /***/
	                      function(module3) {
	                        module3.exports = scale;
	                        function scale(out, a, v) {
	                          var x = v[0], y = v[1], z = v[2];
	                          out[0] = a[0] * x;
	                          out[1] = a[1] * x;
	                          out[2] = a[2] * x;
	                          out[3] = a[3] * x;
	                          out[4] = a[4] * y;
	                          out[5] = a[5] * y;
	                          out[6] = a[6] * y;
	                          out[7] = a[7] * y;
	                          out[8] = a[8] * z;
	                          out[9] = a[9] * z;
	                          out[10] = a[10] * z;
	                          out[11] = a[11] * z;
	                          out[12] = a[12];
	                          out[13] = a[13];
	                          out[14] = a[14];
	                          out[15] = a[15];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    998: (
	                      /***/
	                      function(module3) {
	                        module3.exports = translate;
	                        function translate(out, a, v) {
	                          var x = v[0], y = v[1], z = v[2], a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23;
	                          if (a === out) {
	                            out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
	                            out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
	                            out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
	                            out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
	                          } else {
	                            a00 = a[0];
	                            a01 = a[1];
	                            a02 = a[2];
	                            a03 = a[3];
	                            a10 = a[4];
	                            a11 = a[5];
	                            a12 = a[6];
	                            a13 = a[7];
	                            a20 = a[8];
	                            a21 = a[9];
	                            a22 = a[10];
	                            a23 = a[11];
	                            out[0] = a00;
	                            out[1] = a01;
	                            out[2] = a02;
	                            out[3] = a03;
	                            out[4] = a10;
	                            out[5] = a11;
	                            out[6] = a12;
	                            out[7] = a13;
	                            out[8] = a20;
	                            out[9] = a21;
	                            out[10] = a22;
	                            out[11] = a23;
	                            out[12] = a00 * x + a10 * y + a20 * z + a[12];
	                            out[13] = a01 * x + a11 * y + a21 * z + a[13];
	                            out[14] = a02 * x + a12 * y + a22 * z + a[14];
	                            out[15] = a03 * x + a13 * y + a23 * z + a[15];
	                          }
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    2142: (
	                      /***/
	                      function(module3) {
	                        module3.exports = transpose;
	                        function transpose(out, a) {
	                          if (out === a) {
	                            var a01 = a[1], a02 = a[2], a03 = a[3], a12 = a[6], a13 = a[7], a23 = a[11];
	                            out[1] = a[4];
	                            out[2] = a[8];
	                            out[3] = a[12];
	                            out[4] = a01;
	                            out[6] = a[9];
	                            out[7] = a[13];
	                            out[8] = a02;
	                            out[9] = a12;
	                            out[11] = a[14];
	                            out[12] = a03;
	                            out[13] = a13;
	                            out[14] = a23;
	                          } else {
	                            out[0] = a[0];
	                            out[1] = a[4];
	                            out[2] = a[8];
	                            out[3] = a[12];
	                            out[4] = a[1];
	                            out[5] = a[5];
	                            out[6] = a[9];
	                            out[7] = a[13];
	                            out[8] = a[2];
	                            out[9] = a[6];
	                            out[10] = a[10];
	                            out[11] = a[14];
	                            out[12] = a[3];
	                            out[13] = a[7];
	                            out[14] = a[11];
	                            out[15] = a[15];
	                          }
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    4340: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_363826__) {
	                        var barycentric = __nested_webpack_require_363826__(957);
	                        var closestPointToTriangle = __nested_webpack_require_363826__(7309);
	                        module3.exports = closestPointToPickLocation;
	                        function xformMatrix(m, v) {
	                          var out = [0, 0, 0, 0];
	                          for (var i = 0; i < 4; ++i) {
	                            for (var j = 0; j < 4; ++j) {
	                              out[j] += m[4 * i + j] * v[i];
	                            }
	                          }
	                          return out;
	                        }
	                        function projectVertex(v, model, view, projection, resolution) {
	                          var p = xformMatrix(projection, xformMatrix(view, xformMatrix(model, [v[0], v[1], v[2], 1])));
	                          for (var i = 0; i < 3; ++i) {
	                            p[i] /= p[3];
	                          }
	                          return [0.5 * resolution[0] * (1 + p[0]), 0.5 * resolution[1] * (1 - p[1])];
	                        }
	                        function barycentricCoord(simplex, point) {
	                          if (simplex.length === 2) {
	                            var d0 = 0;
	                            var d1 = 0;
	                            for (var i = 0; i < 2; ++i) {
	                              d0 += Math.pow(point[i] - simplex[0][i], 2);
	                              d1 += Math.pow(point[i] - simplex[1][i], 2);
	                            }
	                            d0 = Math.sqrt(d0);
	                            d1 = Math.sqrt(d1);
	                            if (d0 + d1 < 1e-6) {
	                              return [1, 0];
	                            }
	                            return [d1 / (d0 + d1), d0 / (d1 + d0)];
	                          } else if (simplex.length === 3) {
	                            var closestPoint = [0, 0];
	                            closestPointToTriangle(simplex[0], simplex[1], simplex[2], point, closestPoint);
	                            return barycentric(simplex, closestPoint);
	                          }
	                          return [];
	                        }
	                        function interpolate(simplex, weights) {
	                          var result = [0, 0, 0];
	                          for (var i = 0; i < simplex.length; ++i) {
	                            var p = simplex[i];
	                            var w = weights[i];
	                            for (var j = 0; j < 3; ++j) {
	                              result[j] += w * p[j];
	                            }
	                          }
	                          return result;
	                        }
	                        function closestPointToPickLocation(simplex, pixelCoord, model, view, projection, resolution) {
	                          if (simplex.length === 1) {
	                            return [0, simplex[0].slice()];
	                          }
	                          var simplex2D = new Array(simplex.length);
	                          for (var i = 0; i < simplex.length; ++i) {
	                            simplex2D[i] = projectVertex(simplex[i], model, view, projection, resolution);
	                          }
	                          var closestIndex = 0;
	                          var closestDist = Infinity;
	                          for (var i = 0; i < simplex2D.length; ++i) {
	                            var d2 = 0;
	                            for (var j = 0; j < 2; ++j) {
	                              d2 += Math.pow(simplex2D[i][j] - pixelCoord[j], 2);
	                            }
	                            if (d2 < closestDist) {
	                              closestDist = d2;
	                              closestIndex = i;
	                            }
	                          }
	                          var weights = barycentricCoord(simplex2D, pixelCoord);
	                          var s = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            if (weights[i] < -1e-3 || weights[i] > 1.0001) {
	                              return null;
	                            }
	                            s += weights[i];
	                          }
	                          if (Math.abs(s - 1) > 1e-3) {
	                            return null;
	                          }
	                          return [closestIndex, interpolate(simplex, weights), weights];
	                        }
	                      }
	                    ),
	                    /***/
	                    2056: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_365813__) {
	                        var glslify = __nested_webpack_require_365813__(6832);
	                        var triVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"]);
	                        var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"]);
	                        var edgeVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"]);
	                        var edgeFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]);
	                        var pointVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * view * model * vec4(position, 1.0);\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"]);
	                        var pointFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]);
	                        var pickVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_id        = id;\n  f_position  = position;\n}"]);
	                        var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
	                        var pickPointVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * view * model * vec4(position, 1.0);\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"]);
	                        var contourVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n}"]);
	                        var contourFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"]);
	                        exports2.meshShader = { vertex: triVertSrc, fragment: triFragSrc, attributes: [{ name: "position", type: "vec3" }, { name: "normal", type: "vec3" }, { name: "color", type: "vec4" }, { name: "uv", type: "vec2" }] };
	                        exports2.wireShader = { vertex: edgeVertSrc, fragment: edgeFragSrc, attributes: [{ name: "position", type: "vec3" }, { name: "color", type: "vec4" }, { name: "uv", type: "vec2" }] };
	                        exports2.pointShader = { vertex: pointVertSrc, fragment: pointFragSrc, attributes: [{ name: "position", type: "vec3" }, { name: "color", type: "vec4" }, { name: "uv", type: "vec2" }, { name: "pointSize", type: "float" }] };
	                        exports2.pickShader = { vertex: pickVertSrc, fragment: pickFragSrc, attributes: [{ name: "position", type: "vec3" }, { name: "id", type: "vec4" }] };
	                        exports2.pointPickShader = { vertex: pickPointVertSrc, fragment: pickFragSrc, attributes: [{ name: "position", type: "vec3" }, { name: "pointSize", type: "float" }, { name: "id", type: "vec4" }] };
	                        exports2.contourShader = { vertex: contourVertSrc, fragment: contourFragSrc, attributes: [{ name: "position", type: "vec3" }] };
	                      }
	                    ),
	                    /***/
	                    8116: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_376202__) {
	                        var DEFAULT_VERTEX_NORMALS_EPSILON = 1e-6;
	                        var DEFAULT_FACE_NORMALS_EPSILON = 1e-6;
	                        var createShader = __nested_webpack_require_376202__(5158);
	                        var createBuffer = __nested_webpack_require_376202__(5827);
	                        var createVAO = __nested_webpack_require_376202__(2944);
	                        var createTexture = __nested_webpack_require_376202__(8931);
	                        var normals = __nested_webpack_require_376202__(115);
	                        var multiply = __nested_webpack_require_376202__(104);
	                        var invert = __nested_webpack_require_376202__(7437);
	                        var ndarray = __nested_webpack_require_376202__(5050);
	                        var colormap = __nested_webpack_require_376202__(9156);
	                        var getContour = __nested_webpack_require_376202__(7212);
	                        var pool = __nested_webpack_require_376202__(5306);
	                        var shaders = __nested_webpack_require_376202__(2056);
	                        var closestPoint = __nested_webpack_require_376202__(4340);
	                        var meshShader = shaders.meshShader;
	                        var wireShader = shaders.wireShader;
	                        var pointShader = shaders.pointShader;
	                        var pickShader = shaders.pickShader;
	                        var pointPickShader = shaders.pointPickShader;
	                        var contourShader = shaders.contourShader;
	                        var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        function SimplicialMesh(gl2, texture, triShader, lineShader, pointShader2, pickShader2, pointPickShader2, contourShader2, trianglePositions, triangleIds, triangleColors, triangleUVs, triangleNormals, triangleVAO, edgePositions, edgeIds, edgeColors, edgeUVs, edgeVAO, pointPositions, pointIds, pointColors, pointUVs, pointSizes, pointVAO, contourPositions, contourVAO) {
	                          this.gl = gl2;
	                          this.pixelRatio = 1;
	                          this.cells = [];
	                          this.positions = [];
	                          this.intensity = [];
	                          this.texture = texture;
	                          this.dirty = true;
	                          this.triShader = triShader;
	                          this.lineShader = lineShader;
	                          this.pointShader = pointShader2;
	                          this.pickShader = pickShader2;
	                          this.pointPickShader = pointPickShader2;
	                          this.contourShader = contourShader2;
	                          this.trianglePositions = trianglePositions;
	                          this.triangleColors = triangleColors;
	                          this.triangleNormals = triangleNormals;
	                          this.triangleUVs = triangleUVs;
	                          this.triangleIds = triangleIds;
	                          this.triangleVAO = triangleVAO;
	                          this.triangleCount = 0;
	                          this.lineWidth = 1;
	                          this.edgePositions = edgePositions;
	                          this.edgeColors = edgeColors;
	                          this.edgeUVs = edgeUVs;
	                          this.edgeIds = edgeIds;
	                          this.edgeVAO = edgeVAO;
	                          this.edgeCount = 0;
	                          this.pointPositions = pointPositions;
	                          this.pointColors = pointColors;
	                          this.pointUVs = pointUVs;
	                          this.pointSizes = pointSizes;
	                          this.pointIds = pointIds;
	                          this.pointVAO = pointVAO;
	                          this.pointCount = 0;
	                          this.contourLineWidth = 1;
	                          this.contourPositions = contourPositions;
	                          this.contourVAO = contourVAO;
	                          this.contourCount = 0;
	                          this.contourColor = [0, 0, 0];
	                          this.contourEnable = true;
	                          this.pickVertex = true;
	                          this.pickId = 1;
	                          this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.lightPosition = [1e5, 1e5, 0];
	                          this.ambientLight = 0.8;
	                          this.diffuseLight = 0.8;
	                          this.specularLight = 2;
	                          this.roughness = 0.5;
	                          this.fresnel = 1.5;
	                          this.opacity = 1;
	                          this.hasAlpha = false;
	                          this.opacityscale = false;
	                          this._model = IDENTITY;
	                          this._view = IDENTITY;
	                          this._projection = IDENTITY;
	                          this._resolution = [1, 1];
	                        }
	                        var proto = SimplicialMesh.prototype;
	                        proto.isOpaque = function() {
	                          return !this.hasAlpha;
	                        };
	                        proto.isTransparent = function() {
	                          return this.hasAlpha;
	                        };
	                        proto.pickSlots = 1;
	                        proto.setPickBase = function(id) {
	                          this.pickId = id;
	                        };
	                        function getOpacityFromScale(ratio, opacityscale) {
	                          if (!opacityscale) return 1;
	                          if (!opacityscale.length) return 1;
	                          for (var i = 0; i < opacityscale.length; ++i) {
	                            if (opacityscale.length < 2) return 1;
	                            if (opacityscale[i][0] === ratio) return opacityscale[i][1];
	                            if (opacityscale[i][0] > ratio && i > 0) {
	                              var d = (opacityscale[i][0] - ratio) / (opacityscale[i][0] - opacityscale[i - 1][0]);
	                              return opacityscale[i][1] * (1 - d) + d * opacityscale[i - 1][1];
	                            }
	                          }
	                          return 1;
	                        }
	                        function genColormap(param, opacityscale) {
	                          var colors = colormap({ colormap: param, nshades: 256, format: "rgba" });
	                          var result = new Uint8Array(256 * 4);
	                          for (var i = 0; i < 256; ++i) {
	                            var c = colors[i];
	                            for (var j = 0; j < 3; ++j) {
	                              result[4 * i + j] = c[j];
	                            }
	                            if (!opacityscale) {
	                              result[4 * i + 3] = 255 * c[3];
	                            } else {
	                              result[4 * i + 3] = 255 * getOpacityFromScale(i / 255, opacityscale);
	                            }
	                          }
	                          return ndarray(result, [256, 256, 4], [4, 0, 1]);
	                        }
	                        function takeZComponent(array) {
	                          var n = array.length;
	                          var result = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            result[i] = array[i][2];
	                          }
	                          return result;
	                        }
	                        proto.highlight = function(selection) {
	                          if (!selection || !this.contourEnable) {
	                            this.contourCount = 0;
	                            return;
	                          }
	                          var level = getContour(this.cells, this.intensity, selection.intensity);
	                          var cells = level.cells;
	                          var vertexIds = level.vertexIds;
	                          var vertexWeights = level.vertexWeights;
	                          var numCells = cells.length;
	                          var result = pool.mallocFloat32(2 * 3 * numCells);
	                          var ptr = 0;
	                          for (var i = 0; i < numCells; ++i) {
	                            var c = cells[i];
	                            for (var j = 0; j < 2; ++j) {
	                              var v = c[0];
	                              if (c.length === 2) {
	                                v = c[j];
	                              }
	                              var a = vertexIds[v][0];
	                              var b = vertexIds[v][1];
	                              var w = vertexWeights[v];
	                              var wi = 1 - w;
	                              var pa = this.positions[a];
	                              var pb = this.positions[b];
	                              for (var k = 0; k < 3; ++k) {
	                                result[ptr++] = w * pa[k] + wi * pb[k];
	                              }
	                            }
	                          }
	                          this.contourCount = ptr / 3 | 0;
	                          this.contourPositions.update(result.subarray(0, ptr));
	                          pool.free(result);
	                        };
	                        proto.update = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          this.dirty = true;
	                          if ("contourEnable" in params) {
	                            this.contourEnable = params.contourEnable;
	                          }
	                          if ("contourColor" in params) {
	                            this.contourColor = params.contourColor;
	                          }
	                          if ("lineWidth" in params) {
	                            this.lineWidth = params.lineWidth;
	                          }
	                          if ("lightPosition" in params) {
	                            this.lightPosition = params.lightPosition;
	                          }
	                          this.hasAlpha = false;
	                          if ("opacity" in params) {
	                            this.opacity = params.opacity;
	                            if (this.opacity < 1) {
	                              this.hasAlpha = true;
	                            }
	                          }
	                          if ("opacityscale" in params) {
	                            this.opacityscale = params.opacityscale;
	                            this.hasAlpha = true;
	                          }
	                          if ("ambient" in params) {
	                            this.ambientLight = params.ambient;
	                          }
	                          if ("diffuse" in params) {
	                            this.diffuseLight = params.diffuse;
	                          }
	                          if ("specular" in params) {
	                            this.specularLight = params.specular;
	                          }
	                          if ("roughness" in params) {
	                            this.roughness = params.roughness;
	                          }
	                          if ("fresnel" in params) {
	                            this.fresnel = params.fresnel;
	                          }
	                          if (params.texture) {
	                            this.texture.dispose();
	                            this.texture = createTexture(gl2, params.texture);
	                          } else if (params.colormap) {
	                            this.texture.shape = [256, 256];
	                            this.texture.minFilter = gl2.LINEAR_MIPMAP_LINEAR;
	                            this.texture.magFilter = gl2.LINEAR;
	                            this.texture.setPixels(genColormap(params.colormap, this.opacityscale));
	                            this.texture.generateMipmap();
	                          }
	                          var cells = params.cells;
	                          var positions = params.positions;
	                          if (!positions || !cells) {
	                            return;
	                          }
	                          var tPos = [];
	                          var tCol = [];
	                          var tNor = [];
	                          var tUVs = [];
	                          var tIds = [];
	                          var ePos = [];
	                          var eCol = [];
	                          var eUVs = [];
	                          var eIds = [];
	                          var pPos = [];
	                          var pCol = [];
	                          var pUVs = [];
	                          var pSiz = [];
	                          var pIds = [];
	                          this.cells = cells;
	                          this.positions = positions;
	                          var vertexNormals = params.vertexNormals;
	                          var cellNormals = params.cellNormals;
	                          var vertexNormalsEpsilon = params.vertexNormalsEpsilon === undefined ? DEFAULT_VERTEX_NORMALS_EPSILON : params.vertexNormalsEpsilon;
	                          var faceNormalsEpsilon = params.faceNormalsEpsilon === undefined ? DEFAULT_FACE_NORMALS_EPSILON : params.faceNormalsEpsilon;
	                          if (params.useFacetNormals && !cellNormals) {
	                            cellNormals = normals.faceNormals(cells, positions, faceNormalsEpsilon);
	                          }
	                          if (!cellNormals && !vertexNormals) {
	                            vertexNormals = normals.vertexNormals(cells, positions, vertexNormalsEpsilon);
	                          }
	                          var vertexColors = params.vertexColors;
	                          var cellColors = params.cellColors;
	                          var meshColor = params.meshColor || [1, 1, 1, 1];
	                          var vertexUVs = params.vertexUVs;
	                          var vertexIntensity = params.vertexIntensity;
	                          var cellUVs = params.cellUVs;
	                          var cellIntensity = params.cellIntensity;
	                          var intensityLo = Infinity;
	                          var intensityHi = -Infinity;
	                          if (!vertexUVs && !cellUVs) {
	                            if (vertexIntensity) {
	                              if (params.vertexIntensityBounds) {
	                                intensityLo = +params.vertexIntensityBounds[0];
	                                intensityHi = +params.vertexIntensityBounds[1];
	                              } else {
	                                for (var i = 0; i < vertexIntensity.length; ++i) {
	                                  var f = vertexIntensity[i];
	                                  intensityLo = Math.min(intensityLo, f);
	                                  intensityHi = Math.max(intensityHi, f);
	                                }
	                              }
	                            } else if (cellIntensity) {
	                              if (params.cellIntensityBounds) {
	                                intensityLo = +params.cellIntensityBounds[0];
	                                intensityHi = +params.cellIntensityBounds[1];
	                              } else {
	                                for (var i = 0; i < cellIntensity.length; ++i) {
	                                  var f = cellIntensity[i];
	                                  intensityLo = Math.min(intensityLo, f);
	                                  intensityHi = Math.max(intensityHi, f);
	                                }
	                              }
	                            } else {
	                              for (var i = 0; i < positions.length; ++i) {
	                                var f = positions[i][2];
	                                intensityLo = Math.min(intensityLo, f);
	                                intensityHi = Math.max(intensityHi, f);
	                              }
	                            }
	                          }
	                          if (vertexIntensity) {
	                            this.intensity = vertexIntensity;
	                          } else if (cellIntensity) {
	                            this.intensity = cellIntensity;
	                          } else {
	                            this.intensity = takeZComponent(positions);
	                          }
	                          this.pickVertex = !(cellIntensity || cellColors);
	                          var pointSizes = params.pointSizes;
	                          var meshPointSize = params.pointSize || 1;
	                          this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          for (var i = 0; i < positions.length; ++i) {
	                            var p = positions[i];
	                            for (var j = 0; j < 3; ++j) {
	                              if (isNaN(p[j]) || !isFinite(p[j])) {
	                                continue;
	                              }
	                              this.bounds[0][j] = Math.min(this.bounds[0][j], p[j]);
	                              this.bounds[1][j] = Math.max(this.bounds[1][j], p[j]);
	                            }
	                          }
	                          var triangleCount = 0;
	                          var edgeCount = 0;
	                          var pointCount = 0;
	                          fill_loop: for (var i = 0; i < cells.length; ++i) {
	                            var cell = cells[i];
	                            switch (cell.length) {
	                              case 1:
	                                var v = cell[0];
	                                var p = positions[v];
	                                for (var j = 0; j < 3; ++j) {
	                                  if (isNaN(p[j]) || !isFinite(p[j])) {
	                                    continue fill_loop;
	                                  }
	                                }
	                                pPos.push(p[0], p[1], p[2]);
	                                var c;
	                                if (vertexColors) {
	                                  c = vertexColors[v];
	                                } else if (cellColors) {
	                                  c = cellColors[i];
	                                } else {
	                                  c = meshColor;
	                                }
	                                if (this.opacityscale && vertexIntensity) {
	                                  tCol.push(c[0], c[1], c[2], this.opacity * getOpacityFromScale((vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), this.opacityscale));
	                                } else if (c.length === 3) {
	                                  pCol.push(c[0], c[1], c[2], this.opacity);
	                                } else {
	                                  pCol.push(c[0], c[1], c[2], c[3] * this.opacity);
	                                  if (c[3] < 1) this.hasAlpha = true;
	                                }
	                                var uv;
	                                if (vertexUVs) {
	                                  uv = vertexUVs[v];
	                                } else if (vertexIntensity) {
	                                  uv = [(vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), 0];
	                                } else if (cellUVs) {
	                                  uv = cellUVs[i];
	                                } else if (cellIntensity) {
	                                  uv = [(cellIntensity[i] - intensityLo) / (intensityHi - intensityLo), 0];
	                                } else {
	                                  uv = [(p[2] - intensityLo) / (intensityHi - intensityLo), 0];
	                                }
	                                pUVs.push(uv[0], uv[1]);
	                                if (pointSizes) {
	                                  pSiz.push(pointSizes[v]);
	                                } else {
	                                  pSiz.push(meshPointSize);
	                                }
	                                pIds.push(i);
	                                pointCount += 1;
	                                break;
	                              case 2:
	                                for (var j = 0; j < 2; ++j) {
	                                  var v = cell[j];
	                                  var p = positions[v];
	                                  for (var k = 0; k < 3; ++k) {
	                                    if (isNaN(p[k]) || !isFinite(p[k])) {
	                                      continue fill_loop;
	                                    }
	                                  }
	                                }
	                                for (var j = 0; j < 2; ++j) {
	                                  var v = cell[j];
	                                  var p = positions[v];
	                                  ePos.push(p[0], p[1], p[2]);
	                                  var c;
	                                  if (vertexColors) {
	                                    c = vertexColors[v];
	                                  } else if (cellColors) {
	                                    c = cellColors[i];
	                                  } else {
	                                    c = meshColor;
	                                  }
	                                  if (this.opacityscale && vertexIntensity) {
	                                    tCol.push(c[0], c[1], c[2], this.opacity * getOpacityFromScale((vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), this.opacityscale));
	                                  } else if (c.length === 3) {
	                                    eCol.push(c[0], c[1], c[2], this.opacity);
	                                  } else {
	                                    eCol.push(c[0], c[1], c[2], c[3] * this.opacity);
	                                    if (c[3] < 1) this.hasAlpha = true;
	                                  }
	                                  var uv;
	                                  if (vertexUVs) {
	                                    uv = vertexUVs[v];
	                                  } else if (vertexIntensity) {
	                                    uv = [(vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  } else if (cellUVs) {
	                                    uv = cellUVs[i];
	                                  } else if (cellIntensity) {
	                                    uv = [(cellIntensity[i] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  } else {
	                                    uv = [(p[2] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  }
	                                  eUVs.push(uv[0], uv[1]);
	                                  eIds.push(i);
	                                }
	                                edgeCount += 1;
	                                break;
	                              case 3:
	                                for (var j = 0; j < 3; ++j) {
	                                  var v = cell[j];
	                                  var p = positions[v];
	                                  for (var k = 0; k < 3; ++k) {
	                                    if (isNaN(p[k]) || !isFinite(p[k])) {
	                                      continue fill_loop;
	                                    }
	                                  }
	                                }
	                                for (var j = 0; j < 3; ++j) {
	                                  var v = cell[2 - j];
	                                  var p = positions[v];
	                                  tPos.push(p[0], p[1], p[2]);
	                                  var c;
	                                  if (vertexColors) {
	                                    c = vertexColors[v];
	                                  } else if (cellColors) {
	                                    c = cellColors[i];
	                                  } else {
	                                    c = meshColor;
	                                  }
	                                  if (!c) {
	                                    tCol.push(0.5, 0.5, 0.5, 1);
	                                  } else if (this.opacityscale && vertexIntensity) {
	                                    tCol.push(c[0], c[1], c[2], this.opacity * getOpacityFromScale((vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), this.opacityscale));
	                                  } else if (c.length === 3) {
	                                    tCol.push(c[0], c[1], c[2], this.opacity);
	                                  } else {
	                                    tCol.push(c[0], c[1], c[2], c[3] * this.opacity);
	                                    if (c[3] < 1) this.hasAlpha = true;
	                                  }
	                                  var uv;
	                                  if (vertexUVs) {
	                                    uv = vertexUVs[v];
	                                  } else if (vertexIntensity) {
	                                    uv = [(vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  } else if (cellUVs) {
	                                    uv = cellUVs[i];
	                                  } else if (cellIntensity) {
	                                    uv = [(cellIntensity[i] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  } else {
	                                    uv = [(p[2] - intensityLo) / (intensityHi - intensityLo), 0];
	                                  }
	                                  tUVs.push(uv[0], uv[1]);
	                                  var q;
	                                  if (vertexNormals) {
	                                    q = vertexNormals[v];
	                                  } else {
	                                    q = cellNormals[i];
	                                  }
	                                  tNor.push(q[0], q[1], q[2]);
	                                  tIds.push(i);
	                                }
	                                triangleCount += 1;
	                                break;
	                            }
	                          }
	                          this.pointCount = pointCount;
	                          this.edgeCount = edgeCount;
	                          this.triangleCount = triangleCount;
	                          this.pointPositions.update(pPos);
	                          this.pointColors.update(pCol);
	                          this.pointUVs.update(pUVs);
	                          this.pointSizes.update(pSiz);
	                          this.pointIds.update(new Uint32Array(pIds));
	                          this.edgePositions.update(ePos);
	                          this.edgeColors.update(eCol);
	                          this.edgeUVs.update(eUVs);
	                          this.edgeIds.update(new Uint32Array(eIds));
	                          this.trianglePositions.update(tPos);
	                          this.triangleColors.update(tCol);
	                          this.triangleUVs.update(tUVs);
	                          this.triangleNormals.update(tNor);
	                          this.triangleIds.update(new Uint32Array(tIds));
	                        };
	                        proto.drawTransparent = proto.draw = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          var model = params.model || IDENTITY;
	                          var view = params.view || IDENTITY;
	                          var projection = params.projection || IDENTITY;
	                          var clipBounds = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]];
	                          for (var i = 0; i < 3; ++i) {
	                            clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i]);
	                            clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i]);
	                          }
	                          var uniforms = { model, view, projection, inverseModel: IDENTITY.slice(), clipBounds, kambient: this.ambientLight, kdiffuse: this.diffuseLight, kspecular: this.specularLight, roughness: this.roughness, fresnel: this.fresnel, eyePosition: [0, 0, 0], lightPosition: [0, 0, 0], contourColor: this.contourColor, texture: 0 };
	                          uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model);
	                          gl2.disable(gl2.CULL_FACE);
	                          this.texture.bind(0);
	                          var invCameraMatrix = new Array(16);
	                          multiply(invCameraMatrix, uniforms.view, uniforms.model);
	                          multiply(invCameraMatrix, uniforms.projection, invCameraMatrix);
	                          invert(invCameraMatrix, invCameraMatrix);
	                          for (var i = 0; i < 3; ++i) {
	                            uniforms.eyePosition[i] = invCameraMatrix[12 + i] / invCameraMatrix[15];
	                          }
	                          var w = invCameraMatrix[15];
	                          for (var i = 0; i < 3; ++i) {
	                            w += this.lightPosition[i] * invCameraMatrix[4 * i + 3];
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            var s = invCameraMatrix[12 + i];
	                            for (var j = 0; j < 3; ++j) {
	                              s += invCameraMatrix[4 * j + i] * this.lightPosition[j];
	                            }
	                            uniforms.lightPosition[i] = s / w;
	                          }
	                          if (this.triangleCount > 0) {
	                            var shader = this.triShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            this.triangleVAO.bind();
	                            gl2.drawArrays(gl2.TRIANGLES, 0, this.triangleCount * 3);
	                            this.triangleVAO.unbind();
	                          }
	                          if (this.edgeCount > 0 && this.lineWidth > 0) {
	                            var shader = this.lineShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            this.edgeVAO.bind();
	                            gl2.lineWidth(this.lineWidth * this.pixelRatio);
	                            gl2.drawArrays(gl2.LINES, 0, this.edgeCount * 2);
	                            this.edgeVAO.unbind();
	                          }
	                          if (this.pointCount > 0) {
	                            var shader = this.pointShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            this.pointVAO.bind();
	                            gl2.drawArrays(gl2.POINTS, 0, this.pointCount);
	                            this.pointVAO.unbind();
	                          }
	                          if (this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0) {
	                            var shader = this.contourShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            this.contourVAO.bind();
	                            gl2.drawArrays(gl2.LINES, 0, this.contourCount);
	                            this.contourVAO.unbind();
	                          }
	                        };
	                        proto.drawPick = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          var model = params.model || IDENTITY;
	                          var view = params.view || IDENTITY;
	                          var projection = params.projection || IDENTITY;
	                          var clipBounds = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]];
	                          for (var i = 0; i < 3; ++i) {
	                            clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i]);
	                            clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i]);
	                          }
	                          this._model = [].slice.call(model);
	                          this._view = [].slice.call(view);
	                          this._projection = [].slice.call(projection);
	                          this._resolution = [gl2.drawingBufferWidth, gl2.drawingBufferHeight];
	                          var uniforms = { model, view, projection, clipBounds, pickId: this.pickId / 255 };
	                          var shader = this.pickShader;
	                          shader.bind();
	                          shader.uniforms = uniforms;
	                          if (this.triangleCount > 0) {
	                            this.triangleVAO.bind();
	                            gl2.drawArrays(gl2.TRIANGLES, 0, this.triangleCount * 3);
	                            this.triangleVAO.unbind();
	                          }
	                          if (this.edgeCount > 0) {
	                            this.edgeVAO.bind();
	                            gl2.lineWidth(this.lineWidth * this.pixelRatio);
	                            gl2.drawArrays(gl2.LINES, 0, this.edgeCount * 2);
	                            this.edgeVAO.unbind();
	                          }
	                          if (this.pointCount > 0) {
	                            var shader = this.pointPickShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            this.pointVAO.bind();
	                            gl2.drawArrays(gl2.POINTS, 0, this.pointCount);
	                            this.pointVAO.unbind();
	                          }
	                        };
	                        proto.pick = function(pickData) {
	                          if (!pickData) {
	                            return null;
	                          }
	                          if (pickData.id !== this.pickId) {
	                            return null;
	                          }
	                          var cellId = pickData.value[0] + 256 * pickData.value[1] + 65536 * pickData.value[2];
	                          var cell = this.cells[cellId];
	                          var positions = this.positions;
	                          var simplex = new Array(cell.length);
	                          for (var i = 0; i < cell.length; ++i) {
	                            simplex[i] = positions[cell[i]];
	                          }
	                          var x = pickData.coord[0];
	                          var y = pickData.coord[1];
	                          if (!this.pickVertex) {
	                            var A = this.positions[cell[0]];
	                            var B = this.positions[cell[1]];
	                            var C = this.positions[cell[2]];
	                            var dataCoordinate = [(A[0] + B[0] + C[0]) / 3, (A[1] + B[1] + C[1]) / 3, (A[2] + B[2] + C[2]) / 3];
	                            return { _cellCenter: true, position: [x, y], index: cellId, cell, cellId, intensity: this.intensity[cellId], dataCoordinate };
	                          }
	                          var data = closestPoint(simplex, [x * this.pixelRatio, this._resolution[1] - y * this.pixelRatio], this._model, this._view, this._projection, this._resolution);
	                          if (!data) {
	                            return null;
	                          }
	                          var weights = data[2];
	                          var interpIntensity = 0;
	                          for (var i = 0; i < cell.length; ++i) {
	                            interpIntensity += weights[i] * this.intensity[cell[i]];
	                          }
	                          return { position: data[1], index: cell[data[0]], cell, cellId, intensity: interpIntensity, dataCoordinate: this.positions[cell[data[0]]] };
	                        };
	                        proto.dispose = function() {
	                          this.texture.dispose();
	                          this.triShader.dispose();
	                          this.lineShader.dispose();
	                          this.pointShader.dispose();
	                          this.pickShader.dispose();
	                          this.pointPickShader.dispose();
	                          this.triangleVAO.dispose();
	                          this.trianglePositions.dispose();
	                          this.triangleColors.dispose();
	                          this.triangleUVs.dispose();
	                          this.triangleNormals.dispose();
	                          this.triangleIds.dispose();
	                          this.edgeVAO.dispose();
	                          this.edgePositions.dispose();
	                          this.edgeColors.dispose();
	                          this.edgeUVs.dispose();
	                          this.edgeIds.dispose();
	                          this.pointVAO.dispose();
	                          this.pointPositions.dispose();
	                          this.pointColors.dispose();
	                          this.pointUVs.dispose();
	                          this.pointSizes.dispose();
	                          this.pointIds.dispose();
	                          this.contourVAO.dispose();
	                          this.contourPositions.dispose();
	                          this.contourShader.dispose();
	                        };
	                        function createMeshShader(gl2) {
	                          var shader = createShader(gl2, meshShader.vertex, meshShader.fragment);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.color.location = 2;
	                          shader.attributes.uv.location = 3;
	                          shader.attributes.normal.location = 4;
	                          return shader;
	                        }
	                        function createWireShader(gl2) {
	                          var shader = createShader(gl2, wireShader.vertex, wireShader.fragment);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.color.location = 2;
	                          shader.attributes.uv.location = 3;
	                          return shader;
	                        }
	                        function createPointShader(gl2) {
	                          var shader = createShader(gl2, pointShader.vertex, pointShader.fragment);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.color.location = 2;
	                          shader.attributes.uv.location = 3;
	                          shader.attributes.pointSize.location = 4;
	                          return shader;
	                        }
	                        function createPickShader(gl2) {
	                          var shader = createShader(gl2, pickShader.vertex, pickShader.fragment);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.id.location = 1;
	                          return shader;
	                        }
	                        function createPointPickShader(gl2) {
	                          var shader = createShader(gl2, pointPickShader.vertex, pointPickShader.fragment);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.id.location = 1;
	                          shader.attributes.pointSize.location = 4;
	                          return shader;
	                        }
	                        function createContourShader(gl2) {
	                          var shader = createShader(gl2, contourShader.vertex, contourShader.fragment);
	                          shader.attributes.position.location = 0;
	                          return shader;
	                        }
	                        function createSimplicialMesh(gl2, params) {
	                          if (arguments.length === 1) {
	                            params = gl2;
	                            gl2 = params.gl;
	                          }
	                          var ext = gl2.getExtension("OES_standard_derivatives") || gl2.getExtension("MOZ_OES_standard_derivatives") || gl2.getExtension("WEBKIT_OES_standard_derivatives");
	                          if (!ext) throw new Error("derivatives not supported");
	                          var triShader = createMeshShader(gl2);
	                          var lineShader = createWireShader(gl2);
	                          var pointShader2 = createPointShader(gl2);
	                          var pickShader2 = createPickShader(gl2);
	                          var pointPickShader2 = createPointPickShader(gl2);
	                          var contourShader2 = createContourShader(gl2);
	                          var meshTexture = createTexture(gl2, ndarray(new Uint8Array([255, 255, 255, 255]), [1, 1, 4]));
	                          meshTexture.generateMipmap();
	                          meshTexture.minFilter = gl2.LINEAR_MIPMAP_LINEAR;
	                          meshTexture.magFilter = gl2.LINEAR;
	                          var trianglePositions = createBuffer(gl2);
	                          var triangleColors = createBuffer(gl2);
	                          var triangleUVs = createBuffer(gl2);
	                          var triangleNormals = createBuffer(gl2);
	                          var triangleIds = createBuffer(gl2);
	                          var triangleVAO = createVAO(gl2, [{ buffer: trianglePositions, type: gl2.FLOAT, size: 3 }, { buffer: triangleIds, type: gl2.UNSIGNED_BYTE, size: 4, normalized: true }, { buffer: triangleColors, type: gl2.FLOAT, size: 4 }, { buffer: triangleUVs, type: gl2.FLOAT, size: 2 }, { buffer: triangleNormals, type: gl2.FLOAT, size: 3 }]);
	                          var edgePositions = createBuffer(gl2);
	                          var edgeColors = createBuffer(gl2);
	                          var edgeUVs = createBuffer(gl2);
	                          var edgeIds = createBuffer(gl2);
	                          var edgeVAO = createVAO(gl2, [{ buffer: edgePositions, type: gl2.FLOAT, size: 3 }, { buffer: edgeIds, type: gl2.UNSIGNED_BYTE, size: 4, normalized: true }, { buffer: edgeColors, type: gl2.FLOAT, size: 4 }, { buffer: edgeUVs, type: gl2.FLOAT, size: 2 }]);
	                          var pointPositions = createBuffer(gl2);
	                          var pointColors = createBuffer(gl2);
	                          var pointUVs = createBuffer(gl2);
	                          var pointSizes = createBuffer(gl2);
	                          var pointIds = createBuffer(gl2);
	                          var pointVAO = createVAO(gl2, [{ buffer: pointPositions, type: gl2.FLOAT, size: 3 }, { buffer: pointIds, type: gl2.UNSIGNED_BYTE, size: 4, normalized: true }, { buffer: pointColors, type: gl2.FLOAT, size: 4 }, { buffer: pointUVs, type: gl2.FLOAT, size: 2 }, { buffer: pointSizes, type: gl2.FLOAT, size: 1 }]);
	                          var contourPositions = createBuffer(gl2);
	                          var contourVAO = createVAO(gl2, [{ buffer: contourPositions, type: gl2.FLOAT, size: 3 }]);
	                          var mesh = new SimplicialMesh(gl2, meshTexture, triShader, lineShader, pointShader2, pickShader2, pointPickShader2, contourShader2, trianglePositions, triangleIds, triangleColors, triangleUVs, triangleNormals, triangleVAO, edgePositions, edgeIds, edgeColors, edgeUVs, edgeVAO, pointPositions, pointIds, pointColors, pointUVs, pointSizes, pointVAO, contourPositions, contourVAO);
	                          mesh.update(params);
	                          return mesh;
	                        }
	                        module3.exports = createSimplicialMesh;
	                      }
	                    ),
	                    /***/
	                    4554: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_397571__) {
	                        module3.exports = createBoxes;
	                        var createBuffer = __nested_webpack_require_397571__(5827);
	                        var createShader = __nested_webpack_require_397571__(5158);
	                        var shaders = __nested_webpack_require_397571__(2709);
	                        function Boxes(plot, vbo, shader) {
	                          this.plot = plot;
	                          this.vbo = vbo;
	                          this.shader = shader;
	                        }
	                        var proto = Boxes.prototype;
	                        proto.bind = function() {
	                          var shader = this.shader;
	                          this.vbo.bind();
	                          this.shader.bind();
	                          shader.attributes.coord.pointer();
	                          shader.uniforms.screenBox = this.plot.screenBox;
	                        };
	                        proto.drawBox = /* @__PURE__ */ function() {
	                          var lo = [0, 0];
	                          var hi = [0, 0];
	                          return function(loX, loY, hiX, hiY, color) {
	                            var plot = this.plot;
	                            var shader = this.shader;
	                            var gl2 = plot.gl;
	                            lo[0] = loX;
	                            lo[1] = loY;
	                            hi[0] = hiX;
	                            hi[1] = hiY;
	                            shader.uniforms.lo = lo;
	                            shader.uniforms.hi = hi;
	                            shader.uniforms.color = color;
	                            gl2.drawArrays(gl2.TRIANGLE_STRIP, 0, 4);
	                          };
	                        }();
	                        proto.dispose = function() {
	                          this.vbo.dispose();
	                          this.shader.dispose();
	                        };
	                        function createBoxes(plot) {
	                          var gl2 = plot.gl;
	                          var vbo = createBuffer(gl2, [0, 0, 0, 1, 1, 0, 1, 1]);
	                          var shader = createShader(gl2, shaders.boxVert, shaders.lineFrag);
	                          return new Boxes(plot, vbo, shader);
	                        }
	                      }
	                    ),
	                    /***/
	                    3016: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_398638__) {
	                        module3.exports = createGrid;
	                        var createBuffer = __nested_webpack_require_398638__(5827);
	                        var createShader = __nested_webpack_require_398638__(5158);
	                        var bsearch = __nested_webpack_require_398638__(5070);
	                        var shaders = __nested_webpack_require_398638__(2709);
	                        function Grid(plot, vbo, shader, tickShader) {
	                          this.plot = plot;
	                          this.vbo = vbo;
	                          this.shader = shader;
	                          this.tickShader = tickShader;
	                          this.ticks = [[], []];
	                        }
	                        function compareTickNum(a, b) {
	                          return a - b;
	                        }
	                        var proto = Grid.prototype;
	                        proto.draw = /* @__PURE__ */ function() {
	                          var DATA_SHIFT = [0, 0];
	                          var DATA_SCALE = [0, 0];
	                          var DATA_AXIS = [0, 0];
	                          return function() {
	                            var plot = this.plot;
	                            var vbo = this.vbo;
	                            var shader = this.shader;
	                            var ticks = this.ticks;
	                            var gl2 = plot.gl;
	                            var bounds = plot._tickBounds;
	                            var dataBox = plot.dataBox;
	                            var viewPixels = plot.viewBox;
	                            var lineWidth = plot.gridLineWidth;
	                            var gridColor = plot.gridLineColor;
	                            var gridEnable = plot.gridLineEnable;
	                            var pixelRatio = plot.pixelRatio;
	                            for (var i = 0; i < 2; ++i) {
	                              var lo = bounds[i];
	                              var hi = bounds[i + 2];
	                              var boundScale = hi - lo;
	                              var dataCenter = 0.5 * (dataBox[i + 2] + dataBox[i]);
	                              var dataWidth = dataBox[i + 2] - dataBox[i];
	                              DATA_SCALE[i] = 2 * boundScale / dataWidth;
	                              DATA_SHIFT[i] = 2 * (lo - dataCenter) / dataWidth;
	                            }
	                            shader.bind();
	                            vbo.bind();
	                            shader.attributes.dataCoord.pointer();
	                            shader.uniforms.dataShift = DATA_SHIFT;
	                            shader.uniforms.dataScale = DATA_SCALE;
	                            var offset = 0;
	                            for (var i = 0; i < 2; ++i) {
	                              DATA_AXIS[0] = DATA_AXIS[1] = 0;
	                              DATA_AXIS[i] = 1;
	                              shader.uniforms.dataAxis = DATA_AXIS;
	                              shader.uniforms.lineWidth = lineWidth[i] / (viewPixels[i + 2] - viewPixels[i]) * pixelRatio;
	                              shader.uniforms.color = gridColor[i];
	                              var size = ticks[i].length * 6;
	                              if (gridEnable[i] && size) {
	                                gl2.drawArrays(gl2.TRIANGLES, offset, size);
	                              }
	                              offset += size;
	                            }
	                          };
	                        }();
	                        proto.drawTickMarks = /* @__PURE__ */ function() {
	                          var DATA_SHIFT = [0, 0];
	                          var DATA_SCALE = [0, 0];
	                          var X_AXIS = [1, 0];
	                          var Y_AXIS = [0, 1];
	                          var SCR_OFFSET = [0, 0];
	                          var TICK_SCALE = [0, 0];
	                          return function() {
	                            var plot = this.plot;
	                            var vbo = this.vbo;
	                            var shader = this.tickShader;
	                            var ticks = this.ticks;
	                            var gl2 = plot.gl;
	                            var bounds = plot._tickBounds;
	                            var dataBox = plot.dataBox;
	                            var viewBox = plot.viewBox;
	                            var pixelRatio = plot.pixelRatio;
	                            var screenBox = plot.screenBox;
	                            var screenWidth = screenBox[2] - screenBox[0];
	                            var screenHeight = screenBox[3] - screenBox[1];
	                            var viewWidth = viewBox[2] - viewBox[0];
	                            var viewHeight = viewBox[3] - viewBox[1];
	                            for (var i = 0; i < 2; ++i) {
	                              var lo = bounds[i];
	                              var hi = bounds[i + 2];
	                              var boundScale = hi - lo;
	                              var dataCenter = 0.5 * (dataBox[i + 2] + dataBox[i]);
	                              var dataWidth = dataBox[i + 2] - dataBox[i];
	                              DATA_SCALE[i] = 2 * boundScale / dataWidth;
	                              DATA_SHIFT[i] = 2 * (lo - dataCenter) / dataWidth;
	                            }
	                            DATA_SCALE[0] *= viewWidth / screenWidth;
	                            DATA_SHIFT[0] *= viewWidth / screenWidth;
	                            DATA_SCALE[1] *= viewHeight / screenHeight;
	                            DATA_SHIFT[1] *= viewHeight / screenHeight;
	                            shader.bind();
	                            vbo.bind();
	                            shader.attributes.dataCoord.pointer();
	                            var uniforms = shader.uniforms;
	                            uniforms.dataShift = DATA_SHIFT;
	                            uniforms.dataScale = DATA_SCALE;
	                            var tickMarkLength = plot.tickMarkLength;
	                            var tickMarkWidth = plot.tickMarkWidth;
	                            var tickMarkColor = plot.tickMarkColor;
	                            var xTicksOffset = 0;
	                            var yTicksOffset = ticks[0].length * 6;
	                            var xStart = Math.min(bsearch.ge(ticks[0], (dataBox[0] - bounds[0]) / (bounds[2] - bounds[0]), compareTickNum), ticks[0].length);
	                            var xEnd = Math.min(bsearch.gt(ticks[0], (dataBox[2] - bounds[0]) / (bounds[2] - bounds[0]), compareTickNum), ticks[0].length);
	                            var xOffset = xTicksOffset + 6 * xStart;
	                            var xCount = 6 * Math.max(0, xEnd - xStart);
	                            var yStart = Math.min(bsearch.ge(ticks[1], (dataBox[1] - bounds[1]) / (bounds[3] - bounds[1]), compareTickNum), ticks[1].length);
	                            var yEnd = Math.min(bsearch.gt(ticks[1], (dataBox[3] - bounds[1]) / (bounds[3] - bounds[1]), compareTickNum), ticks[1].length);
	                            var yOffset = yTicksOffset + 6 * yStart;
	                            var yCount = 6 * Math.max(0, yEnd - yStart);
	                            SCR_OFFSET[0] = 2 * (viewBox[0] - tickMarkLength[1]) / screenWidth - 1;
	                            SCR_OFFSET[1] = (viewBox[3] + viewBox[1]) / screenHeight - 1;
	                            TICK_SCALE[0] = tickMarkLength[1] * pixelRatio / screenWidth;
	                            TICK_SCALE[1] = tickMarkWidth[1] * pixelRatio / screenHeight;
	                            if (yCount) {
	                              uniforms.color = tickMarkColor[1];
	                              uniforms.tickScale = TICK_SCALE;
	                              uniforms.dataAxis = Y_AXIS;
	                              uniforms.screenOffset = SCR_OFFSET;
	                              gl2.drawArrays(gl2.TRIANGLES, yOffset, yCount);
	                            }
	                            SCR_OFFSET[0] = (viewBox[2] + viewBox[0]) / screenWidth - 1;
	                            SCR_OFFSET[1] = 2 * (viewBox[1] - tickMarkLength[0]) / screenHeight - 1;
	                            TICK_SCALE[0] = tickMarkWidth[0] * pixelRatio / screenWidth;
	                            TICK_SCALE[1] = tickMarkLength[0] * pixelRatio / screenHeight;
	                            if (xCount) {
	                              uniforms.color = tickMarkColor[0];
	                              uniforms.tickScale = TICK_SCALE;
	                              uniforms.dataAxis = X_AXIS;
	                              uniforms.screenOffset = SCR_OFFSET;
	                              gl2.drawArrays(gl2.TRIANGLES, xOffset, xCount);
	                            }
	                            SCR_OFFSET[0] = 2 * (viewBox[2] + tickMarkLength[3]) / screenWidth - 1;
	                            SCR_OFFSET[1] = (viewBox[3] + viewBox[1]) / screenHeight - 1;
	                            TICK_SCALE[0] = tickMarkLength[3] * pixelRatio / screenWidth;
	                            TICK_SCALE[1] = tickMarkWidth[3] * pixelRatio / screenHeight;
	                            if (yCount) {
	                              uniforms.color = tickMarkColor[3];
	                              uniforms.tickScale = TICK_SCALE;
	                              uniforms.dataAxis = Y_AXIS;
	                              uniforms.screenOffset = SCR_OFFSET;
	                              gl2.drawArrays(gl2.TRIANGLES, yOffset, yCount);
	                            }
	                            SCR_OFFSET[0] = (viewBox[2] + viewBox[0]) / screenWidth - 1;
	                            SCR_OFFSET[1] = 2 * (viewBox[3] + tickMarkLength[2]) / screenHeight - 1;
	                            TICK_SCALE[0] = tickMarkWidth[2] * pixelRatio / screenWidth;
	                            TICK_SCALE[1] = tickMarkLength[2] * pixelRatio / screenHeight;
	                            if (xCount) {
	                              uniforms.color = tickMarkColor[2];
	                              uniforms.tickScale = TICK_SCALE;
	                              uniforms.dataAxis = X_AXIS;
	                              uniforms.screenOffset = SCR_OFFSET;
	                              gl2.drawArrays(gl2.TRIANGLES, xOffset, xCount);
	                            }
	                          };
	                        }();
	                        proto.update = /* @__PURE__ */ function() {
	                          var OFFSET_X = [1, 1, -1, -1, 1, -1];
	                          var OFFSET_Y = [1, -1, 1, 1, -1, -1];
	                          return function(options) {
	                            var ticks = options.ticks;
	                            var bounds = options.bounds;
	                            var data = new Float32Array(6 * 3 * (ticks[0].length + ticks[1].length));
	                            this.plot.zeroLineEnable;
	                            var ptr = 0;
	                            var gridTicks = [[], []];
	                            for (var dim = 0; dim < 2; ++dim) {
	                              var localTicks = gridTicks[dim];
	                              var axisTicks = ticks[dim];
	                              var lo = bounds[dim];
	                              var hi = bounds[dim + 2];
	                              for (var i = 0; i < axisTicks.length; ++i) {
	                                var x = (axisTicks[i].x - lo) / (hi - lo);
	                                localTicks.push(x);
	                                for (var j = 0; j < 6; ++j) {
	                                  data[ptr++] = x;
	                                  data[ptr++] = OFFSET_X[j];
	                                  data[ptr++] = OFFSET_Y[j];
	                                }
	                              }
	                            }
	                            this.ticks = gridTicks;
	                            this.vbo.update(data);
	                          };
	                        }();
	                        proto.dispose = function() {
	                          this.vbo.dispose();
	                          this.shader.dispose();
	                          this.tickShader.dispose();
	                        };
	                        function createGrid(plot) {
	                          var gl2 = plot.gl;
	                          var vbo = createBuffer(gl2);
	                          var shader = createShader(gl2, shaders.gridVert, shaders.gridFrag);
	                          var tickShader = createShader(gl2, shaders.tickVert, shaders.gridFrag);
	                          var grid = new Grid(plot, vbo, shader, tickShader);
	                          return grid;
	                        }
	                      }
	                    ),
	                    /***/
	                    1154: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_404765__) {
	                        module3.exports = createLines;
	                        var createBuffer = __nested_webpack_require_404765__(5827);
	                        var createShader = __nested_webpack_require_404765__(5158);
	                        var shaders = __nested_webpack_require_404765__(2709);
	                        function Lines(plot, vbo, shader) {
	                          this.plot = plot;
	                          this.vbo = vbo;
	                          this.shader = shader;
	                        }
	                        var proto = Lines.prototype;
	                        proto.bind = function() {
	                          var shader = this.shader;
	                          this.vbo.bind();
	                          this.shader.bind();
	                          shader.attributes.coord.pointer();
	                          shader.uniforms.screenBox = this.plot.screenBox;
	                        };
	                        proto.drawLine = /* @__PURE__ */ function() {
	                          var start = [0, 0];
	                          var end = [0, 0];
	                          return function(startX, startY, endX, endY, width, color) {
	                            var plot = this.plot;
	                            var shader = this.shader;
	                            var gl2 = plot.gl;
	                            start[0] = startX;
	                            start[1] = startY;
	                            end[0] = endX;
	                            end[1] = endY;
	                            shader.uniforms.start = start;
	                            shader.uniforms.end = end;
	                            shader.uniforms.width = width * plot.pixelRatio;
	                            shader.uniforms.color = color;
	                            gl2.drawArrays(gl2.TRIANGLE_STRIP, 0, 4);
	                          };
	                        }();
	                        proto.dispose = function() {
	                          this.vbo.dispose();
	                          this.shader.dispose();
	                        };
	                        function createLines(plot) {
	                          var gl2 = plot.gl;
	                          var vbo = createBuffer(gl2, [-1, -1, -1, 1, 1, -1, 1, 1]);
	                          var shader = createShader(gl2, shaders.lineVert, shaders.lineFrag);
	                          var lines = new Lines(plot, vbo, shader);
	                          return lines;
	                        }
	                      }
	                    ),
	                    /***/
	                    2709: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_405940__) {
	                        var glslify = __nested_webpack_require_405940__(6832);
	                        var FRAGMENT = glslify(["precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"]);
	                        module3.exports = { lineVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"]), lineFrag: FRAGMENT, textVert: glslify(["#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"]), textFrag: FRAGMENT, gridVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"]), gridFrag: FRAGMENT, boxVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"]), tickVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"]) };
	                      }
	                    ),
	                    /***/
	                    5613: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_408386__) {
	                        module3.exports = createTextElements;
	                        var createBuffer = __nested_webpack_require_408386__(5827);
	                        var createShader = __nested_webpack_require_408386__(5158);
	                        var getText = __nested_webpack_require_408386__(6946);
	                        var bsearch = __nested_webpack_require_408386__(5070);
	                        var shaders = __nested_webpack_require_408386__(2709);
	                        function TextElements(plot, vbo, shader) {
	                          this.plot = plot;
	                          this.vbo = vbo;
	                          this.shader = shader;
	                          this.tickOffset = [[], []];
	                          this.tickX = [[], []];
	                          this.labelOffset = [0, 0];
	                          this.labelCount = [0, 0];
	                        }
	                        var proto = TextElements.prototype;
	                        proto.drawTicks = /* @__PURE__ */ function() {
	                          var DATA_AXIS = [0, 0];
	                          var SCREEN_OFFSET = [0, 0];
	                          var ZERO_2 = [0, 0];
	                          return function(axis) {
	                            var plot = this.plot;
	                            var shader = this.shader;
	                            var tickX = this.tickX[axis];
	                            var tickOffset = this.tickOffset[axis];
	                            var gl2 = plot.gl;
	                            var viewBox = plot.viewBox;
	                            var dataBox = plot.dataBox;
	                            var screenBox = plot.screenBox;
	                            var pixelRatio = plot.pixelRatio;
	                            var tickEnable = plot.tickEnable;
	                            var tickPad = plot.tickPad;
	                            var textColor = plot.tickColor;
	                            var textAngle = plot.tickAngle;
	                            var labelEnable = plot.labelEnable;
	                            var labelPad = plot.labelPad;
	                            var labelColor = plot.labelColor;
	                            var labelAngle = plot.labelAngle;
	                            var labelOffset = this.labelOffset[axis];
	                            var labelCount = this.labelCount[axis];
	                            var start = bsearch.lt(tickX, dataBox[axis]);
	                            var end = bsearch.le(tickX, dataBox[axis + 2]);
	                            DATA_AXIS[0] = DATA_AXIS[1] = 0;
	                            DATA_AXIS[axis] = 1;
	                            SCREEN_OFFSET[axis] = (viewBox[2 + axis] + viewBox[axis]) / (screenBox[2 + axis] - screenBox[axis]) - 1;
	                            var screenScale = 2 / screenBox[2 + (axis ^ 1)] - screenBox[axis ^ 1];
	                            SCREEN_OFFSET[axis ^ 1] = screenScale * viewBox[axis ^ 1] - 1;
	                            if (tickEnable[axis]) {
	                              SCREEN_OFFSET[axis ^ 1] -= screenScale * pixelRatio * tickPad[axis];
	                              if (start < end && tickOffset[end] > tickOffset[start]) {
	                                shader.uniforms.dataAxis = DATA_AXIS;
	                                shader.uniforms.screenOffset = SCREEN_OFFSET;
	                                shader.uniforms.color = textColor[axis];
	                                shader.uniforms.angle = textAngle[axis];
	                                gl2.drawArrays(gl2.TRIANGLES, tickOffset[start], tickOffset[end] - tickOffset[start]);
	                              }
	                            }
	                            if (labelEnable[axis] && labelCount) {
	                              SCREEN_OFFSET[axis ^ 1] -= screenScale * pixelRatio * labelPad[axis];
	                              shader.uniforms.dataAxis = ZERO_2;
	                              shader.uniforms.screenOffset = SCREEN_OFFSET;
	                              shader.uniforms.color = labelColor[axis];
	                              shader.uniforms.angle = labelAngle[axis];
	                              gl2.drawArrays(gl2.TRIANGLES, labelOffset, labelCount);
	                            }
	                            SCREEN_OFFSET[axis ^ 1] = screenScale * viewBox[2 + (axis ^ 1)] - 1;
	                            if (tickEnable[axis + 2]) {
	                              SCREEN_OFFSET[axis ^ 1] += screenScale * pixelRatio * tickPad[axis + 2];
	                              if (start < end && tickOffset[end] > tickOffset[start]) {
	                                shader.uniforms.dataAxis = DATA_AXIS;
	                                shader.uniforms.screenOffset = SCREEN_OFFSET;
	                                shader.uniforms.color = textColor[axis + 2];
	                                shader.uniforms.angle = textAngle[axis + 2];
	                                gl2.drawArrays(gl2.TRIANGLES, tickOffset[start], tickOffset[end] - tickOffset[start]);
	                              }
	                            }
	                            if (labelEnable[axis + 2] && labelCount) {
	                              SCREEN_OFFSET[axis ^ 1] += screenScale * pixelRatio * labelPad[axis + 2];
	                              shader.uniforms.dataAxis = ZERO_2;
	                              shader.uniforms.screenOffset = SCREEN_OFFSET;
	                              shader.uniforms.color = labelColor[axis + 2];
	                              shader.uniforms.angle = labelAngle[axis + 2];
	                              gl2.drawArrays(gl2.TRIANGLES, labelOffset, labelCount);
	                            }
	                          };
	                        }();
	                        proto.drawTitle = /* @__PURE__ */ function() {
	                          var DATA_AXIS = [0, 0];
	                          var SCREEN_OFFSET = [0, 0];
	                          return function() {
	                            var plot = this.plot;
	                            var shader = this.shader;
	                            var gl2 = plot.gl;
	                            var screenBox = plot.screenBox;
	                            var titleCenter = plot.titleCenter;
	                            var titleAngle = plot.titleAngle;
	                            var titleColor = plot.titleColor;
	                            var pixelRatio = plot.pixelRatio;
	                            if (!this.titleCount) {
	                              return;
	                            }
	                            for (var i = 0; i < 2; ++i) {
	                              SCREEN_OFFSET[i] = 2 * (titleCenter[i] * pixelRatio - screenBox[i]) / (screenBox[2 + i] - screenBox[i]) - 1;
	                            }
	                            shader.bind();
	                            shader.uniforms.dataAxis = DATA_AXIS;
	                            shader.uniforms.screenOffset = SCREEN_OFFSET;
	                            shader.uniforms.angle = titleAngle;
	                            shader.uniforms.color = titleColor;
	                            gl2.drawArrays(gl2.TRIANGLES, this.titleOffset, this.titleCount);
	                          };
	                        }();
	                        proto.bind = /* @__PURE__ */ function() {
	                          var DATA_SHIFT = [0, 0];
	                          var DATA_SCALE = [0, 0];
	                          var TEXT_SCALE = [0, 0];
	                          return function() {
	                            var plot = this.plot;
	                            var shader = this.shader;
	                            var bounds = plot._tickBounds;
	                            var dataBox = plot.dataBox;
	                            var screenBox = plot.screenBox;
	                            var viewBox = plot.viewBox;
	                            shader.bind();
	                            for (var i = 0; i < 2; ++i) {
	                              var lo = bounds[i];
	                              var hi = bounds[i + 2];
	                              var boundScale = hi - lo;
	                              var dataCenter = 0.5 * (dataBox[i + 2] + dataBox[i]);
	                              var dataWidth = dataBox[i + 2] - dataBox[i];
	                              var viewLo = viewBox[i];
	                              var viewHi = viewBox[i + 2];
	                              var viewScale = viewHi - viewLo;
	                              var screenLo = screenBox[i];
	                              var screenHi = screenBox[i + 2];
	                              var screenScale = screenHi - screenLo;
	                              DATA_SCALE[i] = 2 * boundScale / dataWidth * viewScale / screenScale;
	                              DATA_SHIFT[i] = 2 * (lo - dataCenter) / dataWidth * viewScale / screenScale;
	                            }
	                            TEXT_SCALE[1] = 2 * plot.pixelRatio / (screenBox[3] - screenBox[1]);
	                            TEXT_SCALE[0] = TEXT_SCALE[1] * (screenBox[3] - screenBox[1]) / (screenBox[2] - screenBox[0]);
	                            shader.uniforms.dataScale = DATA_SCALE;
	                            shader.uniforms.dataShift = DATA_SHIFT;
	                            shader.uniforms.textScale = TEXT_SCALE;
	                            this.vbo.bind();
	                            shader.attributes.textCoordinate.pointer();
	                          };
	                        }();
	                        proto.update = function(options) {
	                          var vertices = [];
	                          var axesTicks = options.ticks;
	                          var bounds = options.bounds;
	                          var i, j, data, scale, dimension;
	                          for (dimension = 0; dimension < 2; ++dimension) {
	                            var offsets = [Math.floor(vertices.length / 3)], tickX = [-Infinity];
	                            var ticks = axesTicks[dimension];
	                            for (i = 0; i < ticks.length; ++i) {
	                              var tick = ticks[i];
	                              var x = tick.x;
	                              var text = tick.text;
	                              var font = tick.font || "sans-serif";
	                              scale = tick.fontSize || 12;
	                              var coordScale = 1 / (bounds[dimension + 2] - bounds[dimension]);
	                              var coordShift = bounds[dimension];
	                              var rows = text.split("\n");
	                              for (var r = 0; r < rows.length; r++) {
	                                data = getText(font, rows[r]).data;
	                                for (j = 0; j < data.length; j += 2) {
	                                  vertices.push(data[j] * scale, -data[j + 1] * scale - r * scale * 1.2, (x - coordShift) * coordScale);
	                                }
	                              }
	                              offsets.push(Math.floor(vertices.length / 3));
	                              tickX.push(x);
	                            }
	                            this.tickOffset[dimension] = offsets;
	                            this.tickX[dimension] = tickX;
	                          }
	                          for (dimension = 0; dimension < 2; ++dimension) {
	                            this.labelOffset[dimension] = Math.floor(vertices.length / 3);
	                            data = getText(options.labelFont[dimension], options.labels[dimension], { textAlign: "center" }).data;
	                            scale = options.labelSize[dimension];
	                            for (i = 0; i < data.length; i += 2) {
	                              vertices.push(data[i] * scale, -data[i + 1] * scale, 0);
	                            }
	                            this.labelCount[dimension] = Math.floor(vertices.length / 3) - this.labelOffset[dimension];
	                          }
	                          this.titleOffset = Math.floor(vertices.length / 3);
	                          data = getText(options.titleFont, options.title).data;
	                          scale = options.titleSize;
	                          for (i = 0; i < data.length; i += 2) {
	                            vertices.push(data[i] * scale, -data[i + 1] * scale, 0);
	                          }
	                          this.titleCount = Math.floor(vertices.length / 3) - this.titleOffset;
	                          this.vbo.update(vertices);
	                        };
	                        proto.dispose = function() {
	                          this.vbo.dispose();
	                          this.shader.dispose();
	                        };
	                        function createTextElements(plot) {
	                          var gl2 = plot.gl;
	                          var vbo = createBuffer(gl2);
	                          var shader = createShader(gl2, shaders.textVert, shaders.textFrag);
	                          var text = new TextElements(plot, vbo, shader);
	                          return text;
	                        }
	                      }
	                    ),
	                    /***/
	                    2117: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_415020__) {
	                        module3.exports = createGLPlot2D;
	                        var createPick = __nested_webpack_require_415020__(2611);
	                        var createGrid = __nested_webpack_require_415020__(3016);
	                        var createText = __nested_webpack_require_415020__(5613);
	                        var createLine = __nested_webpack_require_415020__(1154);
	                        var createBox = __nested_webpack_require_415020__(4554);
	                        function GLPlot2D(gl2, pickBuffer) {
	                          this.gl = gl2;
	                          this.pickBuffer = pickBuffer;
	                          this.screenBox = [0, 0, gl2.drawingBufferWidth, gl2.drawingBufferHeight];
	                          this.viewBox = [0, 0, 0, 0];
	                          this.dataBox = [-10, -10, 10, 10];
	                          this.gridLineEnable = [true, true];
	                          this.gridLineWidth = [1, 1];
	                          this.gridLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.pixelRatio = 1;
	                          this.tickMarkLength = [0, 0, 0, 0];
	                          this.tickMarkWidth = [0, 0, 0, 0];
	                          this.tickMarkColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.tickPad = [15, 15, 15, 15];
	                          this.tickAngle = [0, 0, 0, 0];
	                          this.tickEnable = [true, true, true, true];
	                          this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.labelPad = [15, 15, 15, 15];
	                          this.labelAngle = [0, Math.PI / 2, 0, 3 * Math.PI / 2];
	                          this.labelEnable = [true, true, true, true];
	                          this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.titleCenter = [0, 0];
	                          this.titleEnable = true;
	                          this.titleAngle = 0;
	                          this.titleColor = [0, 0, 0, 1];
	                          this.borderColor = [0, 0, 0, 0];
	                          this.backgroundColor = [0, 0, 0, 0];
	                          this.zeroLineEnable = [true, true];
	                          this.zeroLineWidth = [4, 4];
	                          this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.borderLineEnable = [true, true, true, true];
	                          this.borderLineWidth = [2, 2, 2, 2];
	                          this.borderLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.grid = null;
	                          this.text = null;
	                          this.line = null;
	                          this.box = null;
	                          this.objects = [];
	                          this.overlays = [];
	                          this._tickBounds = [Infinity, Infinity, -Infinity, -Infinity];
	                          this.static = false;
	                          this.dirty = false;
	                          this.pickDirty = false;
	                          this.pickDelay = 120;
	                          this.pickRadius = 10;
	                          this._pickTimeout = null;
	                          this._drawPick = this.drawPick.bind(this);
	                          this._depthCounter = 0;
	                        }
	                        var proto = GLPlot2D.prototype;
	                        proto.setDirty = function() {
	                          this.dirty = this.pickDirty = true;
	                        };
	                        proto.setOverlayDirty = function() {
	                          this.dirty = true;
	                        };
	                        proto.nextDepthValue = function() {
	                          return this._depthCounter++ / 65536;
	                        };
	                        proto.draw = /* @__PURE__ */ function() {
	                          return function() {
	                            var gl2 = this.gl;
	                            var screenBox = this.screenBox;
	                            var viewPixels = this.viewBox;
	                            var dataBox = this.dataBox;
	                            var pixelRatio = this.pixelRatio;
	                            var grid = this.grid;
	                            var line = this.line;
	                            var text = this.text;
	                            var objects = this.objects;
	                            this._depthCounter = 0;
	                            if (this.pickDirty) {
	                              if (this._pickTimeout) {
	                                clearTimeout(this._pickTimeout);
	                              }
	                              this.pickDirty = false;
	                              this._pickTimeout = setTimeout(this._drawPick, this.pickDelay);
	                            }
	                            if (!this.dirty) {
	                              return;
	                            }
	                            this.dirty = false;
	                            gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	                            gl2.enable(gl2.SCISSOR_TEST);
	                            gl2.disable(gl2.DEPTH_TEST);
	                            gl2.depthFunc(gl2.LESS);
	                            gl2.depthMask(false);
	                            gl2.enable(gl2.BLEND);
	                            gl2.blendEquation(gl2.FUNC_ADD, gl2.FUNC_ADD);
	                            gl2.blendFunc(gl2.ONE, gl2.ONE_MINUS_SRC_ALPHA);
	                            if (this.borderColor) {
	                              gl2.scissor(screenBox[0], screenBox[1], screenBox[2] - screenBox[0], screenBox[3] - screenBox[1]);
	                              var borderColor = this.borderColor;
	                              gl2.clearColor(borderColor[0] * borderColor[3], borderColor[1] * borderColor[3], borderColor[2] * borderColor[3], borderColor[3]);
	                              gl2.clear(gl2.COLOR_BUFFER_BIT | gl2.DEPTH_BUFFER_BIT);
	                            }
	                            gl2.scissor(viewPixels[0], viewPixels[1], viewPixels[2] - viewPixels[0], viewPixels[3] - viewPixels[1]);
	                            gl2.viewport(viewPixels[0], viewPixels[1], viewPixels[2] - viewPixels[0], viewPixels[3] - viewPixels[1]);
	                            var backgroundColor = this.backgroundColor;
	                            gl2.clearColor(backgroundColor[0] * backgroundColor[3], backgroundColor[1] * backgroundColor[3], backgroundColor[2] * backgroundColor[3], backgroundColor[3]);
	                            gl2.clear(gl2.COLOR_BUFFER_BIT);
	                            grid.draw();
	                            var zeroLineEnable = this.zeroLineEnable;
	                            var zeroLineColor = this.zeroLineColor;
	                            var zeroLineWidth = this.zeroLineWidth;
	                            if (zeroLineEnable[0] || zeroLineEnable[1]) {
	                              line.bind();
	                              for (var i = 0; i < 2; ++i) {
	                                if (!zeroLineEnable[i] || !(dataBox[i] <= 0 && dataBox[i + 2] >= 0)) {
	                                  continue;
	                                }
	                                var zeroIntercept = screenBox[i] - dataBox[i] * (screenBox[i + 2] - screenBox[i]) / (dataBox[i + 2] - dataBox[i]);
	                                if (i === 0) {
	                                  line.drawLine(zeroIntercept, screenBox[1], zeroIntercept, screenBox[3], zeroLineWidth[i], zeroLineColor[i]);
	                                } else {
	                                  line.drawLine(screenBox[0], zeroIntercept, screenBox[2], zeroIntercept, zeroLineWidth[i], zeroLineColor[i]);
	                                }
	                              }
	                            }
	                            for (var i = 0; i < objects.length; ++i) {
	                              objects[i].draw();
	                            }
	                            gl2.viewport(screenBox[0], screenBox[1], screenBox[2] - screenBox[0], screenBox[3] - screenBox[1]);
	                            gl2.scissor(screenBox[0], screenBox[1], screenBox[2] - screenBox[0], screenBox[3] - screenBox[1]);
	                            this.grid.drawTickMarks();
	                            line.bind();
	                            var borderLineEnable = this.borderLineEnable;
	                            var borderLineWidth = this.borderLineWidth;
	                            var borderLineColor = this.borderLineColor;
	                            if (borderLineEnable[1]) {
	                              line.drawLine(viewPixels[0], viewPixels[1] - 0.5 * borderLineWidth[1] * pixelRatio, viewPixels[0], viewPixels[3] + 0.5 * borderLineWidth[3] * pixelRatio, borderLineWidth[1], borderLineColor[1]);
	                            }
	                            if (borderLineEnable[0]) {
	                              line.drawLine(viewPixels[0] - 0.5 * borderLineWidth[0] * pixelRatio, viewPixels[1], viewPixels[2] + 0.5 * borderLineWidth[2] * pixelRatio, viewPixels[1], borderLineWidth[0], borderLineColor[0]);
	                            }
	                            if (borderLineEnable[3]) {
	                              line.drawLine(viewPixels[2], viewPixels[1] - 0.5 * borderLineWidth[1] * pixelRatio, viewPixels[2], viewPixels[3] + 0.5 * borderLineWidth[3] * pixelRatio, borderLineWidth[3], borderLineColor[3]);
	                            }
	                            if (borderLineEnable[2]) {
	                              line.drawLine(viewPixels[0] - 0.5 * borderLineWidth[0] * pixelRatio, viewPixels[3], viewPixels[2] + 0.5 * borderLineWidth[2] * pixelRatio, viewPixels[3], borderLineWidth[2], borderLineColor[2]);
	                            }
	                            text.bind();
	                            for (var i = 0; i < 2; ++i) {
	                              text.drawTicks(i);
	                            }
	                            if (this.titleEnable) {
	                              text.drawTitle();
	                            }
	                            var overlays = this.overlays;
	                            for (var i = 0; i < overlays.length; ++i) {
	                              overlays[i].draw();
	                            }
	                            gl2.disable(gl2.SCISSOR_TEST);
	                            gl2.disable(gl2.BLEND);
	                            gl2.depthMask(true);
	                          };
	                        }();
	                        proto.drawPick = /* @__PURE__ */ function() {
	                          return function() {
	                            if (this.static) return;
	                            var pickBuffer = this.pickBuffer;
	                            this.gl;
	                            this._pickTimeout = null;
	                            pickBuffer.begin();
	                            var pickOffset = 1;
	                            var objects = this.objects;
	                            for (var i = 0; i < objects.length; ++i) {
	                              pickOffset = objects[i].drawPick(pickOffset);
	                            }
	                            pickBuffer.end();
	                          };
	                        }();
	                        proto.pick = /* @__PURE__ */ function() {
	                          return function(x, y) {
	                            if (this.static) return;
	                            var pixelRatio = this.pixelRatio;
	                            var pickPixelRatio = this.pickPixelRatio;
	                            var viewBox = this.viewBox;
	                            var scrX = Math.round((x - viewBox[0] / pixelRatio) * pickPixelRatio) | 0;
	                            var scrY = Math.round((y - viewBox[1] / pixelRatio) * pickPixelRatio) | 0;
	                            var pickResult = this.pickBuffer.query(scrX, scrY, this.pickRadius);
	                            if (!pickResult) {
	                              return null;
	                            }
	                            var pickValue = pickResult.id + (pickResult.value[0] << 8) + (pickResult.value[1] << 16) + (pickResult.value[2] << 24);
	                            var objects = this.objects;
	                            for (var i = 0; i < objects.length; ++i) {
	                              var result = objects[i].pick(scrX, scrY, pickValue);
	                              if (result) {
	                                return result;
	                              }
	                            }
	                            return null;
	                          };
	                        }();
	                        function deepClone(array) {
	                          var result = array.slice();
	                          for (var i = 0; i < result.length; ++i) {
	                            result[i] = result[i].slice();
	                          }
	                          return result;
	                        }
	                        function compareTicks(a, b) {
	                          return a.x - b.x;
	                        }
	                        proto.setScreenBox = function(nbox) {
	                          var screenBox = this.screenBox;
	                          var pixelRatio = this.pixelRatio;
	                          screenBox[0] = Math.round(nbox[0] * pixelRatio) | 0;
	                          screenBox[1] = Math.round(nbox[1] * pixelRatio) | 0;
	                          screenBox[2] = Math.round(nbox[2] * pixelRatio) | 0;
	                          screenBox[3] = Math.round(nbox[3] * pixelRatio) | 0;
	                          this.setDirty();
	                        };
	                        proto.setDataBox = function(nbox) {
	                          var dataBox = this.dataBox;
	                          var different = dataBox[0] !== nbox[0] || dataBox[1] !== nbox[1] || dataBox[2] !== nbox[2] || dataBox[3] !== nbox[3];
	                          if (different) {
	                            dataBox[0] = nbox[0];
	                            dataBox[1] = nbox[1];
	                            dataBox[2] = nbox[2];
	                            dataBox[3] = nbox[3];
	                            this.setDirty();
	                          }
	                        };
	                        proto.setViewBox = function(nbox) {
	                          var pixelRatio = this.pixelRatio;
	                          var viewBox = this.viewBox;
	                          viewBox[0] = Math.round(nbox[0] * pixelRatio) | 0;
	                          viewBox[1] = Math.round(nbox[1] * pixelRatio) | 0;
	                          viewBox[2] = Math.round(nbox[2] * pixelRatio) | 0;
	                          viewBox[3] = Math.round(nbox[3] * pixelRatio) | 0;
	                          var pickPixelRatio = this.pickPixelRatio;
	                          this.pickBuffer.shape = [Math.round((nbox[2] - nbox[0]) * pickPixelRatio) | 0, Math.round((nbox[3] - nbox[1]) * pickPixelRatio) | 0];
	                          this.setDirty();
	                        };
	                        proto.update = function(options) {
	                          options = options || {};
	                          var gl2 = this.gl;
	                          this.pixelRatio = options.pixelRatio || 1;
	                          var pixelRatio = this.pixelRatio;
	                          this.pickPixelRatio = Math.max(pixelRatio, 1);
	                          this.setScreenBox(options.screenBox || [0, 0, gl2.drawingBufferWidth / pixelRatio, gl2.drawingBufferHeight / pixelRatio]);
	                          this.screenBox;
	                          this.setViewBox(options.viewBox || [0.125 * (this.screenBox[2] - this.screenBox[0]) / pixelRatio, 0.125 * (this.screenBox[3] - this.screenBox[1]) / pixelRatio, 0.875 * (this.screenBox[2] - this.screenBox[0]) / pixelRatio, 0.875 * (this.screenBox[3] - this.screenBox[1]) / pixelRatio]);
	                          var viewBox = this.viewBox;
	                          var aspectRatio = (viewBox[2] - viewBox[0]) / (viewBox[3] - viewBox[1]);
	                          this.setDataBox(options.dataBox || [-10, -10 / aspectRatio, 10, 10 / aspectRatio]);
	                          this.borderColor = options.borderColor !== false ? (options.borderColor || [0, 0, 0, 0]).slice() : false;
	                          this.backgroundColor = (options.backgroundColor || [0, 0, 0, 0]).slice();
	                          this.gridLineEnable = (options.gridLineEnable || [true, true]).slice();
	                          this.gridLineWidth = (options.gridLineWidth || [1, 1]).slice();
	                          this.gridLineColor = deepClone(options.gridLineColor || [[0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1]]);
	                          this.zeroLineEnable = (options.zeroLineEnable || [true, true]).slice();
	                          this.zeroLineWidth = (options.zeroLineWidth || [4, 4]).slice();
	                          this.zeroLineColor = deepClone(options.zeroLineColor || [[0, 0, 0, 1], [0, 0, 0, 1]]);
	                          this.tickMarkLength = (options.tickMarkLength || [0, 0, 0, 0]).slice();
	                          this.tickMarkWidth = (options.tickMarkWidth || [0, 0, 0, 0]).slice();
	                          this.tickMarkColor = deepClone(options.tickMarkColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]);
	                          this.titleCenter = (options.titleCenter || [0.5 * (viewBox[0] + viewBox[2]) / pixelRatio, (viewBox[3] + 120) / pixelRatio]).slice();
	                          this.titleEnable = !("titleEnable" in options) || !!options.titleEnable;
	                          this.titleAngle = options.titleAngle || 0;
	                          this.titleColor = (options.titleColor || [0, 0, 0, 1]).slice();
	                          this.labelPad = (options.labelPad || [15, 15, 15, 15]).slice();
	                          this.labelAngle = (options.labelAngle || [0, Math.PI / 2, 0, 3 * Math.PI / 2]).slice();
	                          this.labelEnable = (options.labelEnable || [true, true, true, true]).slice();
	                          this.labelColor = deepClone(options.labelColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]);
	                          this.tickPad = (options.tickPad || [15, 15, 15, 15]).slice();
	                          this.tickAngle = (options.tickAngle || [0, 0, 0, 0]).slice();
	                          this.tickEnable = (options.tickEnable || [true, true, true, true]).slice();
	                          this.tickColor = deepClone(options.tickColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]);
	                          this.borderLineEnable = (options.borderLineEnable || [true, true, true, true]).slice();
	                          this.borderLineWidth = (options.borderLineWidth || [2, 2, 2, 2]).slice();
	                          this.borderLineColor = deepClone(options.borderLineColor || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]);
	                          var ticks = options.ticks || [[], []];
	                          var bounds = this._tickBounds;
	                          bounds[0] = bounds[1] = Infinity;
	                          bounds[2] = bounds[3] = -Infinity;
	                          for (var i = 0; i < 2; ++i) {
	                            var axisTicks = ticks[i].slice(0);
	                            if (axisTicks.length === 0) {
	                              continue;
	                            }
	                            axisTicks.sort(compareTicks);
	                            bounds[i] = Math.min(bounds[i], axisTicks[0].x);
	                            bounds[i + 2] = Math.max(bounds[i + 2], axisTicks[axisTicks.length - 1].x);
	                          }
	                          this.grid.update({ bounds, ticks });
	                          this.text.update({ bounds, ticks, labels: options.labels || ["x", "y"], labelSize: options.labelSize || [12, 12], labelFont: options.labelFont || ["sans-serif", "sans-serif"], title: options.title || "", titleSize: options.titleSize || 18, titleFont: options.titleFont || "sans-serif" });
	                          this.static = !!options.static;
	                          this.setDirty();
	                        };
	                        proto.dispose = function() {
	                          this.box.dispose();
	                          this.grid.dispose();
	                          this.text.dispose();
	                          this.line.dispose();
	                          for (var i = this.objects.length - 1; i >= 0; --i) {
	                            this.objects[i].dispose();
	                          }
	                          this.objects.length = 0;
	                          for (var i = this.overlays.length - 1; i >= 0; --i) {
	                            this.overlays[i].dispose();
	                          }
	                          this.overlays.length = 0;
	                          this.gl = null;
	                        };
	                        proto.addObject = function(object) {
	                          if (this.objects.indexOf(object) < 0) {
	                            this.objects.push(object);
	                            this.setDirty();
	                          }
	                        };
	                        proto.removeObject = function(object) {
	                          var objects = this.objects;
	                          for (var i = 0; i < objects.length; ++i) {
	                            if (objects[i] === object) {
	                              objects.splice(i, 1);
	                              this.setDirty();
	                              break;
	                            }
	                          }
	                        };
	                        proto.addOverlay = function(object) {
	                          if (this.overlays.indexOf(object) < 0) {
	                            this.overlays.push(object);
	                            this.setOverlayDirty();
	                          }
	                        };
	                        proto.removeOverlay = function(object) {
	                          var objects = this.overlays;
	                          for (var i = 0; i < objects.length; ++i) {
	                            if (objects[i] === object) {
	                              objects.splice(i, 1);
	                              this.setOverlayDirty();
	                              break;
	                            }
	                          }
	                        };
	                        function createGLPlot2D(options) {
	                          var gl2 = options.gl;
	                          var pickBuffer = createPick(gl2, [gl2.drawingBufferWidth, gl2.drawingBufferHeight]);
	                          var plot = new GLPlot2D(gl2, pickBuffer);
	                          plot.grid = createGrid(plot);
	                          plot.text = createText(plot);
	                          plot.line = createLine(plot);
	                          plot.box = createBox(plot);
	                          plot.update(options);
	                          return plot;
	                        }
	                      }
	                    ),
	                    /***/
	                    4296: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_427633__) {
	                        module3.exports = createCamera;
	                        var now = __nested_webpack_require_427633__(8161);
	                        var createView = __nested_webpack_require_427633__(1152);
	                        var mouseChange = __nested_webpack_require_427633__(6145);
	                        var mouseWheel = __nested_webpack_require_427633__(6475);
	                        var mouseOffset = __nested_webpack_require_427633__(2565);
	                        var hasPassive = __nested_webpack_require_427633__(5233);
	                        function createCamera(element, options) {
	                          element = element || document.body;
	                          options = options || {};
	                          var limits = [0.01, Infinity];
	                          if ("distanceLimits" in options) {
	                            limits[0] = options.distanceLimits[0];
	                            limits[1] = options.distanceLimits[1];
	                          }
	                          if ("zoomMin" in options) {
	                            limits[0] = options.zoomMin;
	                          }
	                          if ("zoomMax" in options) {
	                            limits[1] = options.zoomMax;
	                          }
	                          var view = createView({ center: options.center || [0, 0, 0], up: options.up || [0, 1, 0], eye: options.eye || [0, 0, 10], mode: options.mode || "orbit", distanceLimits: limits });
	                          var pmatrix = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	                          var distance = 0;
	                          var width = element.clientWidth;
	                          var height = element.clientHeight;
	                          var camera = { keyBindingMode: "rotate", enableWheel: true, view, element, delay: options.delay || 16, rotateSpeed: options.rotateSpeed || 1, zoomSpeed: options.zoomSpeed || 1, translateSpeed: options.translateSpeed || 1, flipX: !!options.flipX, flipY: !!options.flipY, modes: view.modes, _ortho: options._ortho || options.projection && options.projection.type === "orthographic" || false, tick: function() {
	                            var t = now();
	                            var delay = this.delay;
	                            var ctime = t - 2 * delay;
	                            view.idle(t - delay);
	                            view.recalcMatrix(ctime);
	                            view.flush(t - (100 + delay * 2));
	                            var allEqual = true;
	                            var matrix = view.computedMatrix;
	                            for (var i = 0; i < 16; ++i) {
	                              allEqual = allEqual && pmatrix[i] === matrix[i];
	                              pmatrix[i] = matrix[i];
	                            }
	                            var sizeChanged = element.clientWidth === width && element.clientHeight === height;
	                            width = element.clientWidth;
	                            height = element.clientHeight;
	                            if (allEqual) {
	                              return !sizeChanged;
	                            }
	                            distance = Math.exp(view.computedRadius[0]);
	                            return true;
	                          }, lookAt: function(eye, center, up) {
	                            view.lookAt(view.lastT(), eye, center, up);
	                          }, rotate: function(pitch, yaw, roll) {
	                            view.rotate(view.lastT(), pitch, yaw, roll);
	                          }, pan: function(dx, dy, dz) {
	                            view.pan(view.lastT(), dx, dy, dz);
	                          }, translate: function(dx, dy, dz) {
	                            view.translate(view.lastT(), dx, dy, dz);
	                          } };
	                          Object.defineProperties(camera, { matrix: { get: function() {
	                            return view.computedMatrix;
	                          }, set: function(mat) {
	                            view.setMatrix(view.lastT(), mat);
	                            return view.computedMatrix;
	                          }, enumerable: true }, mode: { get: function() {
	                            return view.getMode();
	                          }, set: function(mode) {
	                            var curUp = view.computedUp.slice();
	                            var curEye = view.computedEye.slice();
	                            var curCenter = view.computedCenter.slice();
	                            view.setMode(mode);
	                            if (mode === "turntable") {
	                              var t0 = now();
	                              view._active.lookAt(t0, curEye, curCenter, curUp);
	                              view._active.lookAt(t0 + 500, curEye, curCenter, [0, 0, 1]);
	                              view._active.flush(t0);
	                            }
	                            return view.getMode();
	                          }, enumerable: true }, center: { get: function() {
	                            return view.computedCenter;
	                          }, set: function(ncenter) {
	                            view.lookAt(view.lastT(), null, ncenter);
	                            return view.computedCenter;
	                          }, enumerable: true }, eye: { get: function() {
	                            return view.computedEye;
	                          }, set: function(neye) {
	                            view.lookAt(view.lastT(), neye);
	                            return view.computedEye;
	                          }, enumerable: true }, up: { get: function() {
	                            return view.computedUp;
	                          }, set: function(nup) {
	                            view.lookAt(view.lastT(), null, null, nup);
	                            return view.computedUp;
	                          }, enumerable: true }, distance: { get: function() {
	                            return distance;
	                          }, set: function(d) {
	                            view.setDistance(view.lastT(), d);
	                            return d;
	                          }, enumerable: true }, distanceLimits: { get: function() {
	                            return view.getDistanceLimits(limits);
	                          }, set: function(v) {
	                            view.setDistanceLimits(v);
	                            return v;
	                          }, enumerable: true } });
	                          element.addEventListener("contextmenu", function(ev) {
	                            ev.preventDefault();
	                            return false;
	                          });
	                          camera._lastX = -1;
	                          camera._lastY = -1;
	                          camera._lastMods = { shift: false, control: false, alt: false, meta: false };
	                          camera.enableMouseListeners = function() {
	                            camera.mouseListener = mouseChange(element, handleInteraction);
	                            element.addEventListener("touchstart", function(ev) {
	                              var xy = mouseOffset(ev.changedTouches[0], element);
	                              handleInteraction(0, xy[0], xy[1], camera._lastMods);
	                              handleInteraction(1, xy[0], xy[1], camera._lastMods);
	                            }, hasPassive ? { passive: true } : false);
	                            element.addEventListener("touchmove", function(ev) {
	                              var xy = mouseOffset(ev.changedTouches[0], element);
	                              handleInteraction(1, xy[0], xy[1], camera._lastMods);
	                              ev.preventDefault();
	                            }, hasPassive ? { passive: false } : false);
	                            element.addEventListener("touchend", function(ev) {
	                              handleInteraction(0, camera._lastX, camera._lastY, camera._lastMods);
	                            }, hasPassive ? { passive: true } : false);
	                            function handleInteraction(buttons, x, y, mods) {
	                              var keyBindingMode = camera.keyBindingMode;
	                              if (keyBindingMode === false) return;
	                              var rotate = keyBindingMode === "rotate";
	                              var pan = keyBindingMode === "pan";
	                              var zoom = keyBindingMode === "zoom";
	                              var ctrl = !!mods.control;
	                              var alt = !!mods.alt;
	                              var shift = !!mods.shift;
	                              var left = !!(buttons & 1);
	                              var right = !!(buttons & 2);
	                              var middle = !!(buttons & 4);
	                              var scale = 1 / element.clientHeight;
	                              var dx = scale * (x - camera._lastX);
	                              var dy = scale * (y - camera._lastY);
	                              var flipX = camera.flipX ? 1 : -1;
	                              var flipY = camera.flipY ? 1 : -1;
	                              var drot = Math.PI * camera.rotateSpeed;
	                              var t = now();
	                              if (camera._lastX !== -1 && camera._lastY !== -1) {
	                                if (rotate && left && !ctrl && !alt && !shift || left && !ctrl && !alt && shift) {
	                                  view.rotate(t, flipX * drot * dx, -flipY * drot * dy, 0);
	                                }
	                                if (pan && left && !ctrl && !alt && !shift || right || left && ctrl && !alt && !shift) {
	                                  view.pan(t, -camera.translateSpeed * dx * distance, camera.translateSpeed * dy * distance, 0);
	                                }
	                                if (zoom && left && !ctrl && !alt && !shift || middle || left && !ctrl && alt && !shift) {
	                                  var kzoom = -camera.zoomSpeed * dy / window.innerHeight * (t - view.lastT()) * 100;
	                                  view.pan(t, 0, 0, distance * (Math.exp(kzoom) - 1));
	                                }
	                              }
	                              camera._lastX = x;
	                              camera._lastY = y;
	                              camera._lastMods = mods;
	                              return true;
	                            }
	                            camera.wheelListener = mouseWheel(element, function(dx, dy) {
	                              if (camera.keyBindingMode === false) return;
	                              if (!camera.enableWheel) return;
	                              var flipX = camera.flipX ? 1 : -1;
	                              var flipY = camera.flipY ? 1 : -1;
	                              var t = now();
	                              if (Math.abs(dx) > Math.abs(dy)) {
	                                view.rotate(t, 0, 0, -dx * flipX * Math.PI * camera.rotateSpeed / window.innerWidth);
	                              } else {
	                                if (!camera._ortho) {
	                                  var kzoom = -camera.zoomSpeed * flipY * dy / window.innerHeight * (t - view.lastT()) / 20;
	                                  view.pan(t, 0, 0, distance * (Math.exp(kzoom) - 1));
	                                }
	                              }
	                            }, true);
	                          };
	                          camera.enableMouseListeners();
	                          return camera;
	                        }
	                      }
	                    ),
	                    /***/
	                    8245: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_433691__) {
	                        var glslify = __nested_webpack_require_433691__(6832);
	                        var createShader = __nested_webpack_require_433691__(5158);
	                        var vertSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"]);
	                        var fragSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"]);
	                        module3.exports = function(gl2) {
	                          return createShader(gl2, vertSrc, fragSrc, null, [{ name: "position", type: "vec2" }]);
	                        };
	                      }
	                    ),
	                    /***/
	                    1059: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_434395__) {
	                        var createCamera = __nested_webpack_require_434395__(4296);
	                        var createAxes = __nested_webpack_require_434395__(7453);
	                        var axesRanges = __nested_webpack_require_434395__(2771);
	                        var createSpikes = __nested_webpack_require_434395__(6496);
	                        var createSelect = __nested_webpack_require_434395__(2611);
	                        var createFBO = __nested_webpack_require_434395__(4234);
	                        var drawTriangle = __nested_webpack_require_434395__(8126);
	                        var mouseChange = __nested_webpack_require_434395__(6145);
	                        var perspective = __nested_webpack_require_434395__(1120);
	                        var ortho = __nested_webpack_require_434395__(5268);
	                        var createShader = __nested_webpack_require_434395__(8245);
	                        var isMobile = __nested_webpack_require_434395__(2321)({ tablet: true, featureDetect: true });
	                        module3.exports = { createScene, createCamera };
	                        function MouseSelect() {
	                          this.mouse = [-1, -1];
	                          this.screen = null;
	                          this.distance = Infinity;
	                          this.index = null;
	                          this.dataCoordinate = null;
	                          this.dataPosition = null;
	                          this.object = null;
	                          this.data = null;
	                        }
	                        function getContext(canvas, options) {
	                          var gl2 = null;
	                          try {
	                            gl2 = canvas.getContext("webgl", options);
	                            if (!gl2) {
	                              gl2 = canvas.getContext("experimental-webgl", options);
	                            }
	                          } catch (e) {
	                            return null;
	                          }
	                          return gl2;
	                        }
	                        function roundUpPow10(x) {
	                          var y = Math.round(Math.log(Math.abs(x)) / Math.log(10));
	                          if (y < 0) {
	                            var base = Math.round(Math.pow(10, -y));
	                            return Math.ceil(x * base) / base;
	                          } else if (y > 0) {
	                            var base = Math.round(Math.pow(10, y));
	                            return Math.ceil(x / base) * base;
	                          }
	                          return Math.ceil(x);
	                        }
	                        function defaultBool(x) {
	                          if (typeof x === "boolean") {
	                            return x;
	                          }
	                          return true;
	                        }
	                        function createScene(options) {
	                          options = options || {};
	                          options.camera = options.camera || {};
	                          var canvas = options.canvas;
	                          if (!canvas) {
	                            canvas = document.createElement("canvas");
	                            if (options.container) {
	                              var container = options.container;
	                              container.appendChild(canvas);
	                            } else {
	                              document.body.appendChild(canvas);
	                            }
	                          }
	                          var gl2 = options.gl;
	                          if (!gl2) {
	                            if (options.glOptions) {
	                              isMobile = !!options.glOptions.preserveDrawingBuffer;
	                            }
	                            gl2 = getContext(canvas, options.glOptions || { premultipliedAlpha: true, antialias: true, preserveDrawingBuffer: isMobile });
	                          }
	                          if (!gl2) {
	                            throw new Error("webgl not supported");
	                          }
	                          var bounds = options.bounds || [[-10, -10, -10], [10, 10, 10]];
	                          var selection = new MouseSelect();
	                          var accumBuffer = createFBO(gl2, gl2.drawingBufferWidth, gl2.drawingBufferHeight, { preferFloat: !isMobile });
	                          var accumShader = createShader(gl2);
	                          var isOrtho = options.cameraObject && options.cameraObject._ortho === true || options.camera.projection && options.camera.projection.type === "orthographic" || false;
	                          var cameraOptions = { eye: options.camera.eye || [2, 0, 0], center: options.camera.center || [0, 0, 0], up: options.camera.up || [0, 1, 0], zoomMin: options.camera.zoomMax || 0.1, zoomMax: options.camera.zoomMin || 100, mode: options.camera.mode || "turntable", _ortho: isOrtho };
	                          var axesOptions = options.axes || {};
	                          var axes = createAxes(gl2, axesOptions);
	                          axes.enable = !axesOptions.disable;
	                          var spikeOptions = options.spikes || {};
	                          var spikes = createSpikes(gl2, spikeOptions);
	                          var objects = [];
	                          var pickBufferIds = [];
	                          var pickBufferCount = [];
	                          var pickBuffers = [];
	                          var dirty = true;
	                          var pickDirty = true;
	                          var projection = new Array(16);
	                          var model = new Array(16);
	                          var cameraParams = { view: null, projection, model, _ortho: false };
	                          var pickDirty = true;
	                          var viewShape = [gl2.drawingBufferWidth, gl2.drawingBufferHeight];
	                          var camera = options.cameraObject || createCamera(canvas, cameraOptions);
	                          var scene = { gl: gl2, contextLost: false, pixelRatio: options.pixelRatio || 1, canvas, selection, camera, axes, axesPixels: null, spikes, bounds, objects, shape: viewShape, aspect: options.aspectRatio || [1, 1, 1], pickRadius: options.pickRadius || 10, zNear: options.zNear || 0.01, zFar: options.zFar || 1e3, fovy: options.fovy || Math.PI / 4, clearColor: options.clearColor || [0, 0, 0, 0], autoResize: defaultBool(options.autoResize), autoBounds: defaultBool(options.autoBounds), autoScale: !!options.autoScale, autoCenter: defaultBool(options.autoCenter), clipToBounds: defaultBool(options.clipToBounds), snapToData: !!options.snapToData, onselect: options.onselect || null, onrender: options.onrender || null, onclick: options.onclick || null, cameraParams, oncontextloss: null, mouseListener: null, _stopped: false, getAspectratio: function() {
	                            return { x: this.aspect[0], y: this.aspect[1], z: this.aspect[2] };
	                          }, setAspectratio: function(aspectratio) {
	                            this.aspect[0] = aspectratio.x;
	                            this.aspect[1] = aspectratio.y;
	                            this.aspect[2] = aspectratio.z;
	                            pickDirty = true;
	                          }, setBounds: function(axisIndex, range2) {
	                            this.bounds[0][axisIndex] = range2.min;
	                            this.bounds[1][axisIndex] = range2.max;
	                          }, setClearColor: function(clearColor) {
	                            this.clearColor = clearColor;
	                          }, clearRGBA: function() {
	                            this.gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]);
	                            this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
	                          } };
	                          var pickShape = [gl2.drawingBufferWidth / scene.pixelRatio | 0, gl2.drawingBufferHeight / scene.pixelRatio | 0];
	                          function resizeListener() {
	                            if (scene._stopped) {
	                              return;
	                            }
	                            if (!scene.autoResize) {
	                              return;
	                            }
	                            var parent = canvas.parentNode;
	                            var width = 1;
	                            var height = 1;
	                            if (parent && parent !== document.body) {
	                              width = parent.clientWidth;
	                              height = parent.clientHeight;
	                            } else {
	                              width = window.innerWidth;
	                              height = window.innerHeight;
	                            }
	                            var nextWidth = Math.ceil(width * scene.pixelRatio) | 0;
	                            var nextHeight = Math.ceil(height * scene.pixelRatio) | 0;
	                            if (nextWidth !== canvas.width || nextHeight !== canvas.height) {
	                              canvas.width = nextWidth;
	                              canvas.height = nextHeight;
	                              var style = canvas.style;
	                              style.position = style.position || "absolute";
	                              style.left = "0px";
	                              style.top = "0px";
	                              style.width = width + "px";
	                              style.height = height + "px";
	                              dirty = true;
	                            }
	                          }
	                          if (scene.autoResize) {
	                            resizeListener();
	                          }
	                          window.addEventListener("resize", resizeListener);
	                          function reallocPickIds() {
	                            var numObjs = objects.length;
	                            var numPick = pickBuffers.length;
	                            for (var i = 0; i < numPick; ++i) {
	                              pickBufferCount[i] = 0;
	                            }
	                            obj_loop: for (var i = 0; i < numObjs; ++i) {
	                              var obj = objects[i];
	                              var pickCount = obj.pickSlots;
	                              if (!pickCount) {
	                                pickBufferIds[i] = -1;
	                                continue;
	                              }
	                              for (var j = 0; j < numPick; ++j) {
	                                if (pickBufferCount[j] + pickCount < 255) {
	                                  pickBufferIds[i] = j;
	                                  obj.setPickBase(pickBufferCount[j] + 1);
	                                  pickBufferCount[j] += pickCount;
	                                  continue obj_loop;
	                                }
	                              }
	                              var nbuffer = createSelect(gl2, viewShape);
	                              pickBufferIds[i] = numPick;
	                              pickBuffers.push(nbuffer);
	                              pickBufferCount.push(pickCount);
	                              obj.setPickBase(1);
	                              numPick += 1;
	                            }
	                            while (numPick > 0 && pickBufferCount[numPick - 1] === 0) {
	                              pickBufferCount.pop();
	                              pickBuffers.pop().dispose();
	                            }
	                          }
	                          scene.update = function(options2) {
	                            if (scene._stopped) {
	                              return;
	                            }
	                            dirty = true;
	                            pickDirty = true;
	                          };
	                          scene.add = function(obj) {
	                            if (scene._stopped) {
	                              return;
	                            }
	                            obj.axes = axes;
	                            objects.push(obj);
	                            pickBufferIds.push(-1);
	                            dirty = true;
	                            pickDirty = true;
	                            reallocPickIds();
	                          };
	                          scene.remove = function(obj) {
	                            if (scene._stopped) {
	                              return;
	                            }
	                            var idx = objects.indexOf(obj);
	                            if (idx < 0) {
	                              return;
	                            }
	                            objects.splice(idx, 1);
	                            pickBufferIds.pop();
	                            dirty = true;
	                            pickDirty = true;
	                            reallocPickIds();
	                          };
	                          scene.dispose = function() {
	                            if (scene._stopped) {
	                              return;
	                            }
	                            scene._stopped = true;
	                            window.removeEventListener("resize", resizeListener);
	                            canvas.removeEventListener("webglcontextlost", checkContextLoss);
	                            scene.mouseListener.enabled = false;
	                            if (scene.contextLost) {
	                              return;
	                            }
	                            axes.dispose();
	                            spikes.dispose();
	                            for (var i = 0; i < objects.length; ++i) {
	                              objects[i].dispose();
	                            }
	                            accumBuffer.dispose();
	                            for (var i = 0; i < pickBuffers.length; ++i) {
	                              pickBuffers[i].dispose();
	                            }
	                            accumShader.dispose();
	                            gl2 = null;
	                            axes = null;
	                            spikes = null;
	                            objects = [];
	                          };
	                          scene._mouseRotating = false;
	                          scene._prevButtons = 0;
	                          scene.enableMouseListeners = function() {
	                            scene.mouseListener = mouseChange(canvas, function(buttons, x, y) {
	                              if (scene._stopped) {
	                                return;
	                              }
	                              var numPick = pickBuffers.length;
	                              var numObjs = objects.length;
	                              var prevObj = selection.object;
	                              selection.distance = Infinity;
	                              selection.mouse[0] = x;
	                              selection.mouse[1] = y;
	                              selection.object = null;
	                              selection.screen = null;
	                              selection.dataCoordinate = selection.dataPosition = null;
	                              var change = false;
	                              if (buttons && scene._prevButtons) {
	                                scene._mouseRotating = true;
	                              } else {
	                                if (scene._mouseRotating) {
	                                  pickDirty = true;
	                                }
	                                scene._mouseRotating = false;
	                                for (var i = 0; i < numPick; ++i) {
	                                  var result = pickBuffers[i].query(x, pickShape[1] - y - 1, scene.pickRadius);
	                                  if (result) {
	                                    if (result.distance > selection.distance) {
	                                      continue;
	                                    }
	                                    for (var j = 0; j < numObjs; ++j) {
	                                      var obj = objects[j];
	                                      if (pickBufferIds[j] !== i) {
	                                        continue;
	                                      }
	                                      var objPick = obj.pick(result);
	                                      if (objPick) {
	                                        selection.buttons = buttons;
	                                        selection.screen = result.coord;
	                                        selection.distance = result.distance;
	                                        selection.object = obj;
	                                        selection.index = objPick.distance;
	                                        selection.dataPosition = objPick.position;
	                                        selection.dataCoordinate = objPick.dataCoordinate;
	                                        selection.data = objPick;
	                                        change = true;
	                                      }
	                                    }
	                                  }
	                                }
	                              }
	                              if (prevObj && prevObj !== selection.object) {
	                                if (prevObj.highlight) {
	                                  prevObj.highlight(null);
	                                }
	                                dirty = true;
	                              }
	                              if (selection.object) {
	                                if (selection.object.highlight) {
	                                  selection.object.highlight(selection.data);
	                                }
	                                dirty = true;
	                              }
	                              change = change || selection.object !== prevObj;
	                              if (change && scene.onselect) {
	                                scene.onselect(selection);
	                              }
	                              if (buttons & 1 && !(scene._prevButtons & 1) && scene.onclick) {
	                                scene.onclick(selection);
	                              }
	                              scene._prevButtons = buttons;
	                            });
	                          };
	                          function checkContextLoss() {
	                            if (scene.contextLost) {
	                              return true;
	                            }
	                            if (gl2.isContextLost()) {
	                              scene.contextLost = true;
	                              scene.mouseListener.enabled = false;
	                              scene.selection.object = null;
	                              if (scene.oncontextloss) {
	                                scene.oncontextloss();
	                              }
	                            }
	                          }
	                          canvas.addEventListener("webglcontextlost", checkContextLoss);
	                          function renderPick() {
	                            if (checkContextLoss()) {
	                              return;
	                            }
	                            gl2.colorMask(true, true, true, true);
	                            gl2.depthMask(true);
	                            gl2.disable(gl2.BLEND);
	                            gl2.enable(gl2.DEPTH_TEST);
	                            gl2.depthFunc(gl2.LEQUAL);
	                            var numObjs = objects.length;
	                            var numPick = pickBuffers.length;
	                            for (var j = 0; j < numPick; ++j) {
	                              var buf = pickBuffers[j];
	                              buf.shape = pickShape;
	                              buf.begin();
	                              for (var i = 0; i < numObjs; ++i) {
	                                if (pickBufferIds[i] !== j) {
	                                  continue;
	                                }
	                                var obj = objects[i];
	                                if (obj.drawPick) {
	                                  obj.pixelRatio = 1;
	                                  obj.drawPick(cameraParams);
	                                }
	                              }
	                              buf.end();
	                            }
	                          }
	                          var nBounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          var prevBounds = [nBounds[0].slice(), nBounds[1].slice()];
	                          function redraw() {
	                            if (checkContextLoss()) {
	                              return;
	                            }
	                            resizeListener();
	                            var cameraMoved = scene.camera.tick();
	                            cameraParams.view = scene.camera.matrix;
	                            dirty = dirty || cameraMoved;
	                            pickDirty = pickDirty || cameraMoved;
	                            axes.pixelRatio = scene.pixelRatio;
	                            spikes.pixelRatio = scene.pixelRatio;
	                            var numObjs = objects.length;
	                            var lo = nBounds[0];
	                            var hi = nBounds[1];
	                            lo[0] = lo[1] = lo[2] = Infinity;
	                            hi[0] = hi[1] = hi[2] = -Infinity;
	                            for (var i = 0; i < numObjs; ++i) {
	                              var obj = objects[i];
	                              obj.pixelRatio = scene.pixelRatio;
	                              obj.axes = scene.axes;
	                              dirty = dirty || !!obj.dirty;
	                              pickDirty = pickDirty || !!obj.dirty;
	                              var obb = obj.bounds;
	                              if (obb) {
	                                var olo = obb[0];
	                                var ohi = obb[1];
	                                for (var j = 0; j < 3; ++j) {
	                                  lo[j] = Math.min(lo[j], olo[j]);
	                                  hi[j] = Math.max(hi[j], ohi[j]);
	                                }
	                              }
	                            }
	                            var bounds2 = scene.bounds;
	                            if (scene.autoBounds) {
	                              for (var j = 0; j < 3; ++j) {
	                                if (hi[j] < lo[j]) {
	                                  lo[j] = -1;
	                                  hi[j] = 1;
	                                } else {
	                                  if (lo[j] === hi[j]) {
	                                    lo[j] -= 1;
	                                    hi[j] += 1;
	                                  }
	                                  var padding = 0.05 * (hi[j] - lo[j]);
	                                  lo[j] = lo[j] - padding;
	                                  hi[j] = hi[j] + padding;
	                                }
	                                bounds2[0][j] = lo[j];
	                                bounds2[1][j] = hi[j];
	                              }
	                            }
	                            var boundsChanged = false;
	                            for (var j = 0; j < 3; ++j) {
	                              boundsChanged = boundsChanged || prevBounds[0][j] !== bounds2[0][j] || prevBounds[1][j] !== bounds2[1][j];
	                              prevBounds[0][j] = bounds2[0][j];
	                              prevBounds[1][j] = bounds2[1][j];
	                            }
	                            pickDirty = pickDirty || boundsChanged;
	                            dirty = dirty || boundsChanged;
	                            if (!dirty) {
	                              return;
	                            }
	                            if (boundsChanged) {
	                              var tickSpacing = [0, 0, 0];
	                              for (var i = 0; i < 3; ++i) {
	                                tickSpacing[i] = roundUpPow10((bounds2[1][i] - bounds2[0][i]) / 10);
	                              }
	                              if (axes.autoTicks) {
	                                axes.update({ bounds: bounds2, tickSpacing });
	                              } else {
	                                axes.update({ bounds: bounds2 });
	                              }
	                            }
	                            var width = gl2.drawingBufferWidth;
	                            var height = gl2.drawingBufferHeight;
	                            viewShape[0] = width;
	                            viewShape[1] = height;
	                            pickShape[0] = Math.max(width / scene.pixelRatio, 1) | 0;
	                            pickShape[1] = Math.max(height / scene.pixelRatio, 1) | 0;
	                            calcCameraParams(scene, isOrtho);
	                            for (var i = 0; i < numObjs; ++i) {
	                              var obj = objects[i];
	                              obj.axesBounds = bounds2;
	                              if (scene.clipToBounds) {
	                                obj.clipBounds = bounds2;
	                              }
	                            }
	                            if (selection.object) {
	                              if (scene.snapToData) {
	                                spikes.position = selection.dataCoordinate;
	                              } else {
	                                spikes.position = selection.dataPosition;
	                              }
	                              spikes.bounds = bounds2;
	                            }
	                            if (pickDirty) {
	                              pickDirty = false;
	                              renderPick();
	                            }
	                            scene.axesPixels = axesRanges(scene.axes, cameraParams, width, height);
	                            if (scene.onrender) {
	                              scene.onrender();
	                            }
	                            gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	                            gl2.viewport(0, 0, width, height);
	                            scene.clearRGBA();
	                            gl2.depthMask(true);
	                            gl2.colorMask(true, true, true, true);
	                            gl2.enable(gl2.DEPTH_TEST);
	                            gl2.depthFunc(gl2.LEQUAL);
	                            gl2.disable(gl2.BLEND);
	                            gl2.disable(gl2.CULL_FACE);
	                            var hasTransparent = false;
	                            if (axes.enable) {
	                              hasTransparent = hasTransparent || axes.isTransparent();
	                              axes.draw(cameraParams);
	                            }
	                            spikes.axes = axes;
	                            if (selection.object) {
	                              spikes.draw(cameraParams);
	                            }
	                            gl2.disable(gl2.CULL_FACE);
	                            for (var i = 0; i < numObjs; ++i) {
	                              var obj = objects[i];
	                              obj.axes = axes;
	                              obj.pixelRatio = scene.pixelRatio;
	                              if (obj.isOpaque && obj.isOpaque()) {
	                                obj.draw(cameraParams);
	                              }
	                              if (obj.isTransparent && obj.isTransparent()) {
	                                hasTransparent = true;
	                              }
	                            }
	                            if (hasTransparent) {
	                              accumBuffer.shape = viewShape;
	                              accumBuffer.bind();
	                              gl2.clear(gl2.DEPTH_BUFFER_BIT);
	                              gl2.colorMask(false, false, false, false);
	                              gl2.depthMask(true);
	                              gl2.depthFunc(gl2.LESS);
	                              if (axes.enable && axes.isTransparent()) {
	                                axes.drawTransparent(cameraParams);
	                              }
	                              for (var i = 0; i < numObjs; ++i) {
	                                var obj = objects[i];
	                                if (obj.isOpaque && obj.isOpaque()) {
	                                  obj.draw(cameraParams);
	                                }
	                              }
	                              gl2.enable(gl2.BLEND);
	                              gl2.blendEquation(gl2.FUNC_ADD);
	                              gl2.blendFunc(gl2.ONE, gl2.ONE_MINUS_SRC_ALPHA);
	                              gl2.colorMask(true, true, true, true);
	                              gl2.depthMask(false);
	                              gl2.clearColor(0, 0, 0, 0);
	                              gl2.clear(gl2.COLOR_BUFFER_BIT);
	                              if (axes.isTransparent()) {
	                                axes.drawTransparent(cameraParams);
	                              }
	                              for (var i = 0; i < numObjs; ++i) {
	                                var obj = objects[i];
	                                if (obj.isTransparent && obj.isTransparent()) {
	                                  obj.drawTransparent(cameraParams);
	                                }
	                              }
	                              gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	                              gl2.blendFunc(gl2.ONE, gl2.ONE_MINUS_SRC_ALPHA);
	                              gl2.disable(gl2.DEPTH_TEST);
	                              accumShader.bind();
	                              accumBuffer.color[0].bind(0);
	                              accumShader.uniforms.accumBuffer = 0;
	                              drawTriangle(gl2);
	                              gl2.disable(gl2.BLEND);
	                            }
	                            dirty = false;
	                            for (var i = 0; i < numObjs; ++i) {
	                              objects[i].dirty = false;
	                            }
	                          }
	                          function render() {
	                            if (scene._stopped || scene.contextLost) {
	                              return;
	                            }
	                            redraw();
	                            requestAnimationFrame(render);
	                          }
	                          scene.enableMouseListeners();
	                          render();
	                          scene.redraw = function() {
	                            if (scene._stopped) {
	                              return;
	                            }
	                            dirty = true;
	                            redraw();
	                          };
	                          return scene;
	                        }
	                        function calcCameraParams(scene, isOrtho) {
	                          var bounds = scene.bounds;
	                          var cameraParams = scene.cameraParams;
	                          var projection = cameraParams.projection;
	                          var model = cameraParams.model;
	                          var width = scene.gl.drawingBufferWidth;
	                          var height = scene.gl.drawingBufferHeight;
	                          var zNear = scene.zNear;
	                          var zFar = scene.zFar;
	                          var fovy = scene.fovy;
	                          var r = width / height;
	                          if (isOrtho) {
	                            ortho(projection, -r, r, -1, 1, zNear, zFar);
	                            cameraParams._ortho = true;
	                          } else {
	                            perspective(projection, fovy, r, zNear, zFar);
	                            cameraParams._ortho = false;
	                          }
	                          for (var i = 0; i < 16; ++i) {
	                            model[i] = 0;
	                          }
	                          model[15] = 1;
	                          var maxS = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            maxS = Math.max(maxS, bounds[1][i] - bounds[0][i]);
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            if (scene.autoScale) {
	                              model[5 * i] = scene.aspect[i] / (bounds[1][i] - bounds[0][i]);
	                            } else {
	                              model[5 * i] = 1 / maxS;
	                            }
	                            if (scene.autoCenter) {
	                              model[12 + i] = -model[5 * i] * 0.5 * (bounds[0][i] + bounds[1][i]);
	                            }
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    8023: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_449952__) {
	                        var glslify = __nested_webpack_require_449952__(6832);
	                        exports2.pointVertex = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"]);
	                        exports2.pointFragment = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"]);
	                        exports2.pickVertex = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"]);
	                        exports2.pickFragment = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"]);
	                      }
	                    ),
	                    /***/
	                    8271: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_452548__) {
	                        var createShader = __nested_webpack_require_452548__(5158);
	                        var createBuffer = __nested_webpack_require_452548__(5827);
	                        var pool = __nested_webpack_require_452548__(5306);
	                        var SHADERS = __nested_webpack_require_452548__(8023);
	                        module3.exports = createPointcloud2D;
	                        function Pointcloud2D(plot, offsetBuffer, pickBuffer, shader, pickShader) {
	                          this.plot = plot;
	                          this.offsetBuffer = offsetBuffer;
	                          this.pickBuffer = pickBuffer;
	                          this.shader = shader;
	                          this.pickShader = pickShader;
	                          this.sizeMin = 0.5;
	                          this.sizeMinCap = 2;
	                          this.sizeMax = 20;
	                          this.areaRatio = 1;
	                          this.pointCount = 0;
	                          this.color = [1, 0, 0, 1];
	                          this.borderColor = [0, 0, 0, 1];
	                          this.blend = false;
	                          this.pickOffset = 0;
	                          this.points = null;
	                        }
	                        var proto = Pointcloud2D.prototype;
	                        proto.dispose = function() {
	                          this.shader.dispose();
	                          this.pickShader.dispose();
	                          this.offsetBuffer.dispose();
	                          this.pickBuffer.dispose();
	                          this.plot.removeObject(this);
	                        };
	                        proto.update = function(options) {
	                          var i;
	                          options = options || {};
	                          function dflt(opt, value) {
	                            if (opt in options) {
	                              return options[opt];
	                            }
	                            return value;
	                          }
	                          this.sizeMin = dflt("sizeMin", 0.5);
	                          this.sizeMax = dflt("sizeMax", 20);
	                          this.color = dflt("color", [1, 0, 0, 1]).slice();
	                          this.areaRatio = dflt("areaRatio", 1);
	                          this.borderColor = dflt("borderColor", [0, 0, 0, 1]).slice();
	                          this.blend = dflt("blend", false);
	                          var pointCount = options.positions.length >>> 1;
	                          var dataStraightThrough = options.positions instanceof Float32Array;
	                          var idStraightThrough = options.idToIndex instanceof Int32Array && options.idToIndex.length >= pointCount;
	                          var data = options.positions;
	                          var packed = dataStraightThrough ? data : pool.mallocFloat32(data.length);
	                          var packedId = idStraightThrough ? options.idToIndex : pool.mallocInt32(pointCount);
	                          if (!dataStraightThrough) {
	                            packed.set(data);
	                          }
	                          if (!idStraightThrough) {
	                            packed.set(data);
	                            for (i = 0; i < pointCount; i++) {
	                              packedId[i] = i;
	                            }
	                          }
	                          this.points = data;
	                          this.offsetBuffer.update(packed);
	                          this.pickBuffer.update(packedId);
	                          if (!dataStraightThrough) {
	                            pool.free(packed);
	                          }
	                          if (!idStraightThrough) {
	                            pool.free(packedId);
	                          }
	                          this.pointCount = pointCount;
	                          this.pickOffset = 0;
	                        };
	                        function count(points, dataBox) {
	                          var visiblePointCountEstimate = 0;
	                          var length = points.length >>> 1;
	                          var i;
	                          for (i = 0; i < length; i++) {
	                            var x = points[i * 2];
	                            var y = points[i * 2 + 1];
	                            if (x >= dataBox[0] && x <= dataBox[2] && y >= dataBox[1] && y <= dataBox[3]) visiblePointCountEstimate++;
	                          }
	                          return visiblePointCountEstimate;
	                        }
	                        proto.unifiedDraw = /* @__PURE__ */ function() {
	                          var MATRIX = [1, 0, 0, 0, 1, 0, 0, 0, 1];
	                          var PICK_VEC4 = [0, 0, 0, 0];
	                          return function(pickOffset) {
	                            var pick = pickOffset !== undefined;
	                            var shader = pick ? this.pickShader : this.shader;
	                            var gl2 = this.plot.gl;
	                            var dataBox = this.plot.dataBox;
	                            if (this.pointCount === 0) {
	                              return pickOffset;
	                            }
	                            var dataX = dataBox[2] - dataBox[0];
	                            var dataY = dataBox[3] - dataBox[1];
	                            var visiblePointCountEstimate = count(this.points, dataBox);
	                            var basicPointSize = this.plot.pickPixelRatio * Math.max(Math.min(this.sizeMinCap, this.sizeMin), Math.min(this.sizeMax, this.sizeMax / Math.pow(visiblePointCountEstimate, 0.33333)));
	                            MATRIX[0] = 2 / dataX;
	                            MATRIX[4] = 2 / dataY;
	                            MATRIX[6] = -2 * dataBox[0] / dataX - 1;
	                            MATRIX[7] = -2 * dataBox[1] / dataY - 1;
	                            this.offsetBuffer.bind();
	                            shader.bind();
	                            shader.attributes.position.pointer();
	                            shader.uniforms.matrix = MATRIX;
	                            shader.uniforms.color = this.color;
	                            shader.uniforms.borderColor = this.borderColor;
	                            shader.uniforms.pointCloud = basicPointSize < 5;
	                            shader.uniforms.pointSize = basicPointSize;
	                            shader.uniforms.centerFraction = Math.min(1, Math.max(0, Math.sqrt(1 - this.areaRatio)));
	                            if (pick) {
	                              PICK_VEC4[0] = pickOffset & 255;
	                              PICK_VEC4[1] = pickOffset >> 8 & 255;
	                              PICK_VEC4[2] = pickOffset >> 16 & 255;
	                              PICK_VEC4[3] = pickOffset >> 24 & 255;
	                              this.pickBuffer.bind();
	                              shader.attributes.pickId.pointer(gl2.UNSIGNED_BYTE);
	                              shader.uniforms.pickOffset = PICK_VEC4;
	                              this.pickOffset = pickOffset;
	                            }
	                            var blend = gl2.getParameter(gl2.BLEND);
	                            var dither = gl2.getParameter(gl2.DITHER);
	                            if (blend && !this.blend) gl2.disable(gl2.BLEND);
	                            if (dither) gl2.disable(gl2.DITHER);
	                            gl2.drawArrays(gl2.POINTS, 0, this.pointCount);
	                            if (blend && !this.blend) gl2.enable(gl2.BLEND);
	                            if (dither) gl2.enable(gl2.DITHER);
	                            return pickOffset + this.pointCount;
	                          };
	                        }();
	                        proto.draw = proto.unifiedDraw;
	                        proto.drawPick = proto.unifiedDraw;
	                        proto.pick = function(x, y, value) {
	                          var pickOffset = this.pickOffset;
	                          var pointCount = this.pointCount;
	                          if (value < pickOffset || value >= pickOffset + pointCount) {
	                            return null;
	                          }
	                          var pointId = value - pickOffset;
	                          var points = this.points;
	                          return { object: this, pointId, dataCoord: [points[2 * pointId], points[2 * pointId + 1]] };
	                        };
	                        function createPointcloud2D(plot, options) {
	                          var gl2 = plot.gl;
	                          var buffer = createBuffer(gl2);
	                          var pickBuffer = createBuffer(gl2);
	                          var shader = createShader(gl2, SHADERS.pointVertex, SHADERS.pointFragment);
	                          var pickShader = createShader(gl2, SHADERS.pickVertex, SHADERS.pickFragment);
	                          var result = new Pointcloud2D(plot, buffer, pickBuffer, shader, pickShader);
	                          result.update(options);
	                          plot.addObject(result);
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    6093: (
	                      /***/
	                      function(module3) {
	                        module3.exports = slerp;
	                        function slerp(out, a, b, t) {
	                          var ax = a[0], ay = a[1], az = a[2], aw = a[3], bx = b[0], by = b[1], bz = b[2], bw = b[3];
	                          var omega, cosom, sinom, scale0, scale1;
	                          cosom = ax * bx + ay * by + az * bz + aw * bw;
	                          if (cosom < 0) {
	                            cosom = -cosom;
	                            bx = -bx;
	                            by = -by;
	                            bz = -bz;
	                            bw = -bw;
	                          }
	                          if (1 - cosom > 1e-6) {
	                            omega = Math.acos(cosom);
	                            sinom = Math.sin(omega);
	                            scale0 = Math.sin((1 - t) * omega) / sinom;
	                            scale1 = Math.sin(t * omega) / sinom;
	                          } else {
	                            scale0 = 1 - t;
	                            scale1 = t;
	                          }
	                          out[0] = scale0 * ax + scale1 * bx;
	                          out[1] = scale0 * ay + scale1 * by;
	                          out[2] = scale0 * az + scale1 * bz;
	                          out[3] = scale0 * aw + scale1 * bw;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    8240: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function(a) {
	                          return !a && a !== 0 ? "" : a.toString();
	                        };
	                      }
	                    ),
	                    /***/
	                    4123: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_458780__) {
	                        var vectorizeText = __nested_webpack_require_458780__(875);
	                        module3.exports = getGlyph;
	                        var GLYPH_CACHE = {};
	                        function getGlyph(symbol, font, pixelRatio) {
	                          var fontCache = GLYPH_CACHE[font];
	                          if (!fontCache) {
	                            fontCache = GLYPH_CACHE[font] = {};
	                          }
	                          if (symbol in fontCache) {
	                            return fontCache[symbol];
	                          }
	                          var config = { textAlign: "center", textBaseline: "middle", lineHeight: 1, font, lineSpacing: 1.25, styletags: { breaklines: true, bolds: true, italics: true, subscripts: true, superscripts: true } };
	                          config.triangles = true;
	                          var triSymbol = vectorizeText(symbol, config);
	                          config.triangles = false;
	                          var lineSymbol = vectorizeText(symbol, config);
	                          var i, j;
	                          if (pixelRatio && pixelRatio !== 1) {
	                            for (i = 0; i < triSymbol.positions.length; ++i) {
	                              for (j = 0; j < triSymbol.positions[i].length; ++j) {
	                                triSymbol.positions[i][j] /= pixelRatio;
	                              }
	                            }
	                            for (i = 0; i < lineSymbol.positions.length; ++i) {
	                              for (j = 0; j < lineSymbol.positions[i].length; ++j) {
	                                lineSymbol.positions[i][j] /= pixelRatio;
	                              }
	                            }
	                          }
	                          var bounds = [[Infinity, Infinity], [-Infinity, -Infinity]];
	                          var n = lineSymbol.positions.length;
	                          for (i = 0; i < n; ++i) {
	                            var p = lineSymbol.positions[i];
	                            for (j = 0; j < 2; ++j) {
	                              bounds[0][j] = Math.min(bounds[0][j], p[j]);
	                              bounds[1][j] = Math.max(bounds[1][j], p[j]);
	                            }
	                          }
	                          return fontCache[symbol] = [triSymbol, lineSymbol, bounds];
	                        }
	                      }
	                    ),
	                    /***/
	                    9282: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_460125__) {
	                        var createShaderWrapper = __nested_webpack_require_460125__(5158);
	                        var glslify = __nested_webpack_require_460125__(6832);
	                        var perspectiveVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]);
	                        var orthographicVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]);
	                        var projectionVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * view * model * vec4(position, 1);\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * view * model * vec4(dataPosition, 1);\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"]);
	                        var drawFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"]);
	                        var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"]);
	                        var ATTRIBUTES = [{ name: "position", type: "vec3" }, { name: "color", type: "vec4" }, { name: "glyph", type: "vec2" }, { name: "id", type: "vec4" }];
	                        var perspective = { vertex: perspectiveVertSrc, fragment: drawFragSrc, attributes: ATTRIBUTES }, ortho = { vertex: orthographicVertSrc, fragment: drawFragSrc, attributes: ATTRIBUTES }, project = { vertex: projectionVertSrc, fragment: drawFragSrc, attributes: ATTRIBUTES }, pickPerspective = { vertex: perspectiveVertSrc, fragment: pickFragSrc, attributes: ATTRIBUTES }, pickOrtho = { vertex: orthographicVertSrc, fragment: pickFragSrc, attributes: ATTRIBUTES }, pickProject = { vertex: projectionVertSrc, fragment: pickFragSrc, attributes: ATTRIBUTES };
	                        function createShader(gl2, src) {
	                          var shader = createShaderWrapper(gl2, src);
	                          var attr = shader.attributes;
	                          attr.position.location = 0;
	                          attr.color.location = 1;
	                          attr.glyph.location = 2;
	                          attr.id.location = 3;
	                          return shader;
	                        }
	                        exports2.createPerspective = function(gl2) {
	                          return createShader(gl2, perspective);
	                        };
	                        exports2.createOrtho = function(gl2) {
	                          return createShader(gl2, ortho);
	                        };
	                        exports2.createProject = function(gl2) {
	                          return createShader(gl2, project);
	                        };
	                        exports2.createPickPerspective = function(gl2) {
	                          return createShader(gl2, pickPerspective);
	                        };
	                        exports2.createPickOrtho = function(gl2) {
	                          return createShader(gl2, pickOrtho);
	                        };
	                        exports2.createPickProject = function(gl2) {
	                          return createShader(gl2, pickProject);
	                        };
	                      }
	                    ),
	                    /***/
	                    2182: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_467893__) {
	                        var isAllBlank = __nested_webpack_require_467893__(3596);
	                        var createBuffer = __nested_webpack_require_467893__(5827);
	                        var createVAO = __nested_webpack_require_467893__(2944);
	                        var pool = __nested_webpack_require_467893__(5306);
	                        var mat4mult = __nested_webpack_require_467893__(104);
	                        var shaders = __nested_webpack_require_467893__(9282);
	                        var getGlyph = __nested_webpack_require_467893__(4123);
	                        var getSimpleString = __nested_webpack_require_467893__(8240);
	                        var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        module3.exports = createPointCloud;
	                        function transformMat4(x, m) {
	                          var x0 = x[0];
	                          var x1 = x[1];
	                          var x2 = x[2];
	                          var x3 = x[3];
	                          x[0] = m[0] * x0 + m[4] * x1 + m[8] * x2 + m[12] * x3;
	                          x[1] = m[1] * x0 + m[5] * x1 + m[9] * x2 + m[13] * x3;
	                          x[2] = m[2] * x0 + m[6] * x1 + m[10] * x2 + m[14] * x3;
	                          x[3] = m[3] * x0 + m[7] * x1 + m[11] * x2 + m[15] * x3;
	                          return x;
	                        }
	                        function project(p, v, m, x) {
	                          transformMat4(x, x);
	                          transformMat4(x, x);
	                          return transformMat4(x, x);
	                        }
	                        function ScatterPlotPickResult(index, position) {
	                          this.index = index;
	                          this.dataCoordinate = this.position = position;
	                        }
	                        function fixOpacity(a) {
	                          if (a === true) return 1;
	                          if (a > 1) return 1;
	                          return a;
	                        }
	                        function PointCloud(gl2, shader, orthoShader, projectShader, pointBuffer, colorBuffer, glyphBuffer, idBuffer, vao, pickPerspectiveShader, pickOrthoShader, pickProjectShader) {
	                          this.gl = gl2;
	                          this.pixelRatio = 1;
	                          this.shader = shader;
	                          this.orthoShader = orthoShader;
	                          this.projectShader = projectShader;
	                          this.pointBuffer = pointBuffer;
	                          this.colorBuffer = colorBuffer;
	                          this.glyphBuffer = glyphBuffer;
	                          this.idBuffer = idBuffer;
	                          this.vao = vao;
	                          this.vertexCount = 0;
	                          this.lineVertexCount = 0;
	                          this.opacity = 1;
	                          this.hasAlpha = false;
	                          this.lineWidth = 0;
	                          this.projectScale = [2 / 3, 2 / 3, 2 / 3];
	                          this.projectOpacity = [1, 1, 1];
	                          this.projectHasAlpha = false;
	                          this.pickId = 0;
	                          this.pickPerspectiveShader = pickPerspectiveShader;
	                          this.pickOrthoShader = pickOrthoShader;
	                          this.pickProjectShader = pickProjectShader;
	                          this.points = [];
	                          this._selectResult = new ScatterPlotPickResult(0, [0, 0, 0]);
	                          this.useOrtho = true;
	                          this.bounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          this.axesProject = [true, true, true];
	                          this.axesBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.highlightId = [1, 1, 1, 1];
	                          this.highlightScale = 2;
	                          this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.dirty = true;
	                        }
	                        var proto = PointCloud.prototype;
	                        proto.pickSlots = 1;
	                        proto.setPickBase = function(pickBase) {
	                          this.pickId = pickBase;
	                        };
	                        proto.isTransparent = function() {
	                          if (this.hasAlpha) {
	                            return true;
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            if (this.axesProject[i] && this.projectHasAlpha) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        };
	                        proto.isOpaque = function() {
	                          if (!this.hasAlpha) {
	                            return true;
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            if (this.axesProject[i] && !this.projectHasAlpha) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        };
	                        var VIEW_SHAPE = [0, 0];
	                        var U_VEC = [0, 0, 0];
	                        var V_VEC = [0, 0, 0];
	                        var MU_VEC = [0, 0, 0, 1];
	                        var MV_VEC = [0, 0, 0, 1];
	                        var SCRATCH_MATRIX = IDENTITY.slice();
	                        var SCRATCH_VEC = [0, 0, 0];
	                        var CLIP_BOUNDS = [[0, 0, 0], [0, 0, 0]];
	                        function zeroVec(a) {
	                          a[0] = a[1] = a[2] = 0;
	                          return a;
	                        }
	                        function augment(hg, af) {
	                          hg[0] = af[0];
	                          hg[1] = af[1];
	                          hg[2] = af[2];
	                          hg[3] = 1;
	                          return hg;
	                        }
	                        function setComponent(out, v, i, x) {
	                          out[0] = v[0];
	                          out[1] = v[1];
	                          out[2] = v[2];
	                          out[i] = x;
	                          return out;
	                        }
	                        function getClipBounds(bounds) {
	                          var result = CLIP_BOUNDS;
	                          for (var i = 0; i < 2; ++i) {
	                            for (var j = 0; j < 3; ++j) {
	                              result[i][j] = Math.max(Math.min(bounds[i][j], 1e8), -1e8);
	                            }
	                          }
	                          return result;
	                        }
	                        function drawProject(shader, points, camera, pixelRatio) {
	                          var axesProject = points.axesProject;
	                          var gl2 = points.gl;
	                          var uniforms = shader.uniforms;
	                          var model = camera.model || IDENTITY;
	                          var view = camera.view || IDENTITY;
	                          var projection = camera.projection || IDENTITY;
	                          var bounds = points.axesBounds;
	                          var clipBounds = getClipBounds(points.clipBounds);
	                          var cubeAxis;
	                          if (points.axes && points.axes.lastCubeProps) {
	                            cubeAxis = points.axes.lastCubeProps.axis;
	                          } else {
	                            cubeAxis = [1, 1, 1];
	                          }
	                          VIEW_SHAPE[0] = 2 / gl2.drawingBufferWidth;
	                          VIEW_SHAPE[1] = 2 / gl2.drawingBufferHeight;
	                          shader.bind();
	                          uniforms.view = view;
	                          uniforms.projection = projection;
	                          uniforms.screenSize = VIEW_SHAPE;
	                          uniforms.highlightId = points.highlightId;
	                          uniforms.highlightScale = points.highlightScale;
	                          uniforms.clipBounds = clipBounds;
	                          uniforms.pickGroup = points.pickId / 255;
	                          uniforms.pixelRatio = pixelRatio;
	                          for (var i = 0; i < 3; ++i) {
	                            if (!axesProject[i]) {
	                              continue;
	                            }
	                            uniforms.scale = points.projectScale[i];
	                            uniforms.opacity = points.projectOpacity[i];
	                            var pmodel = SCRATCH_MATRIX;
	                            for (var j = 0; j < 16; ++j) {
	                              pmodel[j] = 0;
	                            }
	                            for (var j = 0; j < 4; ++j) {
	                              pmodel[5 * j] = 1;
	                            }
	                            pmodel[5 * i] = 0;
	                            if (cubeAxis[i] < 0) {
	                              pmodel[12 + i] = bounds[0][i];
	                            } else {
	                              pmodel[12 + i] = bounds[1][i];
	                            }
	                            mat4mult(pmodel, model, pmodel);
	                            uniforms.model = pmodel;
	                            var u = (i + 1) % 3;
	                            var v = (i + 2) % 3;
	                            var du = zeroVec(U_VEC);
	                            var dv = zeroVec(V_VEC);
	                            du[u] = 1;
	                            dv[v] = 1;
	                            var mdu = project(projection, view, model, augment(MU_VEC, du));
	                            var mdv = project(projection, view, model, augment(MV_VEC, dv));
	                            if (Math.abs(mdu[1]) > Math.abs(mdv[1])) {
	                              var tmp = mdu;
	                              mdu = mdv;
	                              mdv = tmp;
	                              tmp = du;
	                              du = dv;
	                              dv = tmp;
	                              var t = u;
	                              u = v;
	                              v = t;
	                            }
	                            if (mdu[0] < 0) {
	                              du[u] = -1;
	                            }
	                            if (mdv[1] > 0) {
	                              dv[v] = -1;
	                            }
	                            var su = 0;
	                            var sv = 0;
	                            for (var j = 0; j < 4; ++j) {
	                              su += Math.pow(model[4 * u + j], 2);
	                              sv += Math.pow(model[4 * v + j], 2);
	                            }
	                            du[u] /= Math.sqrt(su);
	                            dv[v] /= Math.sqrt(sv);
	                            uniforms.axes[0] = du;
	                            uniforms.axes[1] = dv;
	                            uniforms.fragClipBounds[0] = setComponent(SCRATCH_VEC, clipBounds[0], i, -1e8);
	                            uniforms.fragClipBounds[1] = setComponent(SCRATCH_VEC, clipBounds[1], i, 1e8);
	                            points.vao.bind();
	                            points.vao.draw(gl2.TRIANGLES, points.vertexCount);
	                            if (points.lineWidth > 0) {
	                              gl2.lineWidth(points.lineWidth * pixelRatio);
	                              points.vao.draw(gl2.LINES, points.lineVertexCount, points.vertexCount);
	                            }
	                            points.vao.unbind();
	                          }
	                        }
	                        var NEG_INFINITY3 = [-1e8, -1e8, -1e8];
	                        var POS_INFINITY3 = [1e8, 1e8, 1e8];
	                        var CLIP_GROUP = [NEG_INFINITY3, POS_INFINITY3];
	                        function drawFull(shader, pshader, points, camera, pixelRatio, transparent, forceDraw) {
	                          var gl2 = points.gl;
	                          if (transparent === points.projectHasAlpha || forceDraw) {
	                            drawProject(pshader, points, camera, pixelRatio);
	                          }
	                          if (transparent === points.hasAlpha || forceDraw) {
	                            shader.bind();
	                            var uniforms = shader.uniforms;
	                            uniforms.model = camera.model || IDENTITY;
	                            uniforms.view = camera.view || IDENTITY;
	                            uniforms.projection = camera.projection || IDENTITY;
	                            VIEW_SHAPE[0] = 2 / gl2.drawingBufferWidth;
	                            VIEW_SHAPE[1] = 2 / gl2.drawingBufferHeight;
	                            uniforms.screenSize = VIEW_SHAPE;
	                            uniforms.highlightId = points.highlightId;
	                            uniforms.highlightScale = points.highlightScale;
	                            uniforms.fragClipBounds = CLIP_GROUP;
	                            uniforms.clipBounds = points.axes.bounds;
	                            uniforms.opacity = points.opacity;
	                            uniforms.pickGroup = points.pickId / 255;
	                            uniforms.pixelRatio = pixelRatio;
	                            points.vao.bind();
	                            points.vao.draw(gl2.TRIANGLES, points.vertexCount);
	                            if (points.lineWidth > 0) {
	                              gl2.lineWidth(points.lineWidth * pixelRatio);
	                              points.vao.draw(gl2.LINES, points.lineVertexCount, points.vertexCount);
	                            }
	                            points.vao.unbind();
	                          }
	                        }
	                        proto.draw = function(camera) {
	                          var shader = this.useOrtho ? this.orthoShader : this.shader;
	                          drawFull(shader, this.projectShader, this, camera, this.pixelRatio, false, false);
	                        };
	                        proto.drawTransparent = function(camera) {
	                          var shader = this.useOrtho ? this.orthoShader : this.shader;
	                          drawFull(shader, this.projectShader, this, camera, this.pixelRatio, true, false);
	                        };
	                        proto.drawPick = function(camera) {
	                          var shader = this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader;
	                          drawFull(shader, this.pickProjectShader, this, camera, 1, true, true);
	                        };
	                        proto.pick = function(selected) {
	                          if (!selected) {
	                            return null;
	                          }
	                          if (selected.id !== this.pickId) {
	                            return null;
	                          }
	                          var x = selected.value[2] + (selected.value[1] << 8) + (selected.value[0] << 16);
	                          if (x >= this.pointCount || x < 0) {
	                            return null;
	                          }
	                          var coord = this.points[x];
	                          var result = this._selectResult;
	                          result.index = x;
	                          for (var i = 0; i < 3; ++i) {
	                            result.position[i] = result.dataCoordinate[i] = coord[i];
	                          }
	                          return result;
	                        };
	                        proto.highlight = function(selection) {
	                          if (!selection) {
	                            this.highlightId = [1, 1, 1, 1];
	                          } else {
	                            var pointId = selection.index;
	                            var a0 = pointId & 255;
	                            var a1 = pointId >> 8 & 255;
	                            var a2 = pointId >> 16 & 255;
	                            this.highlightId = [a0 / 255, a1 / 255, a2 / 255, 0];
	                          }
	                        };
	                        function get_glyphData(glyphs, index, font, pixelRatio) {
	                          var str;
	                          if (Array.isArray(glyphs)) {
	                            if (index < glyphs.length) {
	                              str = glyphs[index];
	                            } else {
	                              str = undefined;
	                            }
	                          } else {
	                            str = glyphs;
	                          }
	                          str = getSimpleString(str);
	                          var visible = true;
	                          if (isAllBlank(str)) {
	                            str = "▼";
	                            visible = false;
	                          }
	                          var glyph = getGlyph(str, font, pixelRatio);
	                          return { mesh: glyph[0], lines: glyph[1], bounds: glyph[2], visible };
	                        }
	                        proto.update = function(options) {
	                          options = options || {};
	                          if ("perspective" in options) {
	                            this.useOrtho = !options.perspective;
	                          }
	                          if ("orthographic" in options) {
	                            this.useOrtho = !!options.orthographic;
	                          }
	                          if ("lineWidth" in options) {
	                            this.lineWidth = options.lineWidth;
	                          }
	                          if ("project" in options) {
	                            if (Array.isArray(options.project)) {
	                              this.axesProject = options.project;
	                            } else {
	                              var v = !!options.project;
	                              this.axesProject = [v, v, v];
	                            }
	                          }
	                          if ("projectScale" in options) {
	                            if (Array.isArray(options.projectScale)) {
	                              this.projectScale = options.projectScale.slice();
	                            } else {
	                              var s = +options.projectScale;
	                              this.projectScale = [s, s, s];
	                            }
	                          }
	                          this.projectHasAlpha = false;
	                          if ("projectOpacity" in options) {
	                            if (Array.isArray(options.projectOpacity)) {
	                              this.projectOpacity = options.projectOpacity.slice();
	                            } else {
	                              var s = +options.projectOpacity;
	                              this.projectOpacity = [s, s, s];
	                            }
	                            for (var i = 0; i < 3; ++i) {
	                              this.projectOpacity[i] = fixOpacity(this.projectOpacity[i]);
	                              if (this.projectOpacity[i] < 1) {
	                                this.projectHasAlpha = true;
	                              }
	                            }
	                          }
	                          this.hasAlpha = false;
	                          if ("opacity" in options) {
	                            this.opacity = fixOpacity(options.opacity);
	                            if (this.opacity < 1) {
	                              this.hasAlpha = true;
	                            }
	                          }
	                          this.dirty = true;
	                          var points = options.position;
	                          var font = options.font || "normal";
	                          var alignment = options.alignment || [0, 0];
	                          var alignmentX;
	                          var alignmentY;
	                          if (alignment.length === 2) {
	                            alignmentX = alignment[0];
	                            alignmentY = alignment[1];
	                          } else {
	                            alignmentX = [];
	                            alignmentY = [];
	                            for (var i = 0; i < alignment.length; ++i) {
	                              alignmentX[i] = alignment[i][0];
	                              alignmentY[i] = alignment[i][1];
	                            }
	                          }
	                          var lowerBound = [Infinity, Infinity, Infinity];
	                          var upperBound = [-Infinity, -Infinity, -Infinity];
	                          var glyphs = options.glyph;
	                          var colors = options.color;
	                          var sizes = options.size;
	                          var angles = options.angle;
	                          var lineColors = options.lineColor;
	                          var pickCounter = -1;
	                          var triVertexCount = 0;
	                          var lineVertexCount = 0;
	                          var numPoints = 0;
	                          if (points.length) {
	                            numPoints = points.length;
	                            count_loop: for (var i = 0; i < numPoints; ++i) {
	                              var x = points[i];
	                              for (var j = 0; j < 3; ++j) {
	                                if (isNaN(x[j]) || !isFinite(x[j])) {
	                                  continue count_loop;
	                                }
	                              }
	                              var glyphData = get_glyphData(glyphs, i, font, this.pixelRatio);
	                              var glyphMesh = glyphData.mesh;
	                              var glyphLines = glyphData.lines;
	                              var glyphBounds = glyphData.bounds;
	                              triVertexCount += glyphMesh.cells.length * 3;
	                              lineVertexCount += glyphLines.edges.length * 2;
	                            }
	                          }
	                          var vertexCount = triVertexCount + lineVertexCount;
	                          var positionArray = pool.mallocFloat(3 * vertexCount);
	                          var colorArray = pool.mallocFloat(4 * vertexCount);
	                          var glyphArray = pool.mallocFloat(2 * vertexCount);
	                          var idArray = pool.mallocUint32(vertexCount);
	                          if (vertexCount > 0) {
	                            var triOffset = 0;
	                            var lineOffset = triVertexCount;
	                            var color = [0, 0, 0, 1];
	                            var lineColor = [0, 0, 0, 1];
	                            var isColorArray = Array.isArray(colors) && Array.isArray(colors[0]);
	                            var isLineColorArray = Array.isArray(lineColors) && Array.isArray(lineColors[0]);
	                            fill_loop: for (var i = 0; i < numPoints; ++i) {
	                              pickCounter += 1;
	                              var x = points[i];
	                              for (var j = 0; j < 3; ++j) {
	                                if (isNaN(x[j]) || !isFinite(x[j])) {
	                                  continue fill_loop;
	                                }
	                                upperBound[j] = Math.max(upperBound[j], x[j]);
	                                lowerBound[j] = Math.min(lowerBound[j], x[j]);
	                              }
	                              var glyphData = get_glyphData(glyphs, i, font, this.pixelRatio);
	                              var glyphMesh = glyphData.mesh;
	                              var glyphLines = glyphData.lines;
	                              var glyphBounds = glyphData.bounds;
	                              var glyphVisible = glyphData.visible;
	                              if (!glyphVisible) color = [1, 1, 1, 0];
	                              else if (Array.isArray(colors)) {
	                                var c;
	                                if (isColorArray) {
	                                  if (i < colors.length) {
	                                    c = colors[i];
	                                  } else {
	                                    c = [0, 0, 0, 0];
	                                  }
	                                } else {
	                                  c = colors;
	                                }
	                                if (c.length === 3) {
	                                  for (var j = 0; j < 3; ++j) {
	                                    color[j] = c[j];
	                                  }
	                                  color[3] = 1;
	                                } else if (c.length === 4) {
	                                  for (var j = 0; j < 4; ++j) {
	                                    color[j] = c[j];
	                                  }
	                                  if (!this.hasAlpha && c[3] < 1) this.hasAlpha = true;
	                                }
	                              } else {
	                                color[0] = color[1] = color[2] = 0;
	                                color[3] = 1;
	                              }
	                              if (!glyphVisible) lineColor = [1, 1, 1, 0];
	                              else if (Array.isArray(lineColors)) {
	                                var c;
	                                if (isLineColorArray) {
	                                  if (i < lineColors.length) {
	                                    c = lineColors[i];
	                                  } else {
	                                    c = [0, 0, 0, 0];
	                                  }
	                                } else {
	                                  c = lineColors;
	                                }
	                                if (c.length === 3) {
	                                  for (var j = 0; j < 3; ++j) {
	                                    lineColor[j] = c[j];
	                                  }
	                                  lineColor[j] = 1;
	                                } else if (c.length === 4) {
	                                  for (var j = 0; j < 4; ++j) {
	                                    lineColor[j] = c[j];
	                                  }
	                                  if (!this.hasAlpha && c[3] < 1) this.hasAlpha = true;
	                                }
	                              } else {
	                                lineColor[0] = lineColor[1] = lineColor[2] = 0;
	                                lineColor[3] = 1;
	                              }
	                              var size = 0.5;
	                              if (!glyphVisible) size = 0;
	                              else if (Array.isArray(sizes)) {
	                                if (i < sizes.length) {
	                                  size = +sizes[i];
	                                } else {
	                                  size = 12;
	                                }
	                              } else if (sizes) {
	                                size = +sizes;
	                              } else if (this.useOrtho) {
	                                size = 12;
	                              }
	                              var angle = 0;
	                              if (Array.isArray(angles)) {
	                                if (i < angles.length) {
	                                  angle = +angles[i];
	                                } else {
	                                  angle = 0;
	                                }
	                              } else if (angles) {
	                                angle = +angles;
	                              }
	                              var cos = Math.cos(angle);
	                              var sin = Math.sin(angle);
	                              var x = points[i];
	                              for (var j = 0; j < 3; ++j) {
	                                upperBound[j] = Math.max(upperBound[j], x[j]);
	                                lowerBound[j] = Math.min(lowerBound[j], x[j]);
	                              }
	                              var textOffsetX = alignmentX;
	                              var textOffsetY = alignmentY;
	                              var textOffsetX = 0;
	                              if (Array.isArray(alignmentX)) {
	                                if (i < alignmentX.length) {
	                                  textOffsetX = alignmentX[i];
	                                } else {
	                                  textOffsetX = 0;
	                                }
	                              } else if (alignmentX) {
	                                textOffsetX = alignmentX;
	                              }
	                              var textOffsetY = 0;
	                              if (Array.isArray(alignmentY)) {
	                                if (i < alignmentY.length) {
	                                  textOffsetY = alignmentY[i];
	                                } else {
	                                  textOffsetY = 0;
	                                }
	                              } else if (alignmentY) {
	                                textOffsetY = alignmentY;
	                              }
	                              textOffsetX *= textOffsetX > 0 ? 1 - glyphBounds[0][0] : textOffsetX < 0 ? 1 + glyphBounds[1][0] : 1;
	                              textOffsetY *= textOffsetY > 0 ? 1 - glyphBounds[0][1] : textOffsetY < 0 ? 1 + glyphBounds[1][1] : 1;
	                              var textOffset = [textOffsetX, textOffsetY];
	                              var cells = glyphMesh.cells || [];
	                              var verts = glyphMesh.positions || [];
	                              for (var j = 0; j < cells.length; ++j) {
	                                var cell = cells[j];
	                                for (var k = 0; k < 3; ++k) {
	                                  for (var l = 0; l < 3; ++l) {
	                                    positionArray[3 * triOffset + l] = x[l];
	                                  }
	                                  for (var l = 0; l < 4; ++l) {
	                                    colorArray[4 * triOffset + l] = color[l];
	                                  }
	                                  idArray[triOffset] = pickCounter;
	                                  var p = verts[cell[k]];
	                                  glyphArray[2 * triOffset] = size * (cos * p[0] - sin * p[1] + textOffset[0]);
	                                  glyphArray[2 * triOffset + 1] = size * (sin * p[0] + cos * p[1] + textOffset[1]);
	                                  triOffset += 1;
	                                }
	                              }
	                              var cells = glyphLines.edges;
	                              var verts = glyphLines.positions;
	                              for (var j = 0; j < cells.length; ++j) {
	                                var cell = cells[j];
	                                for (var k = 0; k < 2; ++k) {
	                                  for (var l = 0; l < 3; ++l) {
	                                    positionArray[3 * lineOffset + l] = x[l];
	                                  }
	                                  for (var l = 0; l < 4; ++l) {
	                                    colorArray[4 * lineOffset + l] = lineColor[l];
	                                  }
	                                  idArray[lineOffset] = pickCounter;
	                                  var p = verts[cell[k]];
	                                  glyphArray[2 * lineOffset] = size * (cos * p[0] - sin * p[1] + textOffset[0]);
	                                  glyphArray[2 * lineOffset + 1] = size * (sin * p[0] + cos * p[1] + textOffset[1]);
	                                  lineOffset += 1;
	                                }
	                              }
	                            }
	                          }
	                          this.bounds = [lowerBound, upperBound];
	                          this.points = points;
	                          this.pointCount = points.length;
	                          this.vertexCount = triVertexCount;
	                          this.lineVertexCount = lineVertexCount;
	                          this.pointBuffer.update(positionArray);
	                          this.colorBuffer.update(colorArray);
	                          this.glyphBuffer.update(glyphArray);
	                          this.idBuffer.update(idArray);
	                          pool.free(positionArray);
	                          pool.free(colorArray);
	                          pool.free(glyphArray);
	                          pool.free(idArray);
	                        };
	                        proto.dispose = function() {
	                          this.shader.dispose();
	                          this.orthoShader.dispose();
	                          this.pickPerspectiveShader.dispose();
	                          this.pickOrthoShader.dispose();
	                          this.vao.dispose();
	                          this.pointBuffer.dispose();
	                          this.colorBuffer.dispose();
	                          this.glyphBuffer.dispose();
	                          this.idBuffer.dispose();
	                        };
	                        function createPointCloud(options) {
	                          var gl2 = options.gl;
	                          var shader = shaders.createPerspective(gl2);
	                          var orthoShader = shaders.createOrtho(gl2);
	                          var projectShader = shaders.createProject(gl2);
	                          var pickPerspectiveShader = shaders.createPickPerspective(gl2);
	                          var pickOrthoShader = shaders.createPickOrtho(gl2);
	                          var pickProjectShader = shaders.createPickProject(gl2);
	                          var pointBuffer = createBuffer(gl2);
	                          var colorBuffer = createBuffer(gl2);
	                          var glyphBuffer = createBuffer(gl2);
	                          var idBuffer = createBuffer(gl2);
	                          var vao = createVAO(gl2, [{ buffer: pointBuffer, size: 3, type: gl2.FLOAT }, { buffer: colorBuffer, size: 4, type: gl2.FLOAT }, { buffer: glyphBuffer, size: 2, type: gl2.FLOAT }, { buffer: idBuffer, size: 4, type: gl2.UNSIGNED_BYTE, normalized: true }]);
	                          var pointCloud = new PointCloud(gl2, shader, orthoShader, projectShader, pointBuffer, colorBuffer, glyphBuffer, idBuffer, vao, pickPerspectiveShader, pickOrthoShader, pickProjectShader);
	                          pointCloud.update(options);
	                          return pointCloud;
	                        }
	                      }
	                    ),
	                    /***/
	                    1884: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_483950__) {
	                        var glslify = __nested_webpack_require_483950__(6832);
	                        exports2.boxVertex = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"]);
	                        exports2.boxFragment = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"]);
	                      }
	                    ),
	                    /***/
	                    6623: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_484449__) {
	                        var createShader = __nested_webpack_require_484449__(5158);
	                        var createBuffer = __nested_webpack_require_484449__(5827);
	                        var SHADERS = __nested_webpack_require_484449__(1884);
	                        module3.exports = createSelectBox;
	                        function SelectBox(plot, boxBuffer, boxShader) {
	                          this.plot = plot;
	                          this.boxBuffer = boxBuffer;
	                          this.boxShader = boxShader;
	                          this.enabled = true;
	                          this.selectBox = [Infinity, Infinity, -Infinity, -Infinity];
	                          this.borderColor = [0, 0, 0, 1];
	                          this.innerFill = false;
	                          this.innerColor = [0, 0, 0, 0.25];
	                          this.outerFill = true;
	                          this.outerColor = [0, 0, 0, 0.5];
	                          this.borderWidth = 10;
	                        }
	                        var proto = SelectBox.prototype;
	                        proto.draw = function() {
	                          if (!this.enabled) {
	                            return;
	                          }
	                          var plot = this.plot;
	                          var selectBox = this.selectBox;
	                          var lineWidth = this.borderWidth;
	                          this.innerFill;
	                          var innerColor = this.innerColor;
	                          this.outerFill;
	                          var outerColor = this.outerColor;
	                          var borderColor = this.borderColor;
	                          var boxes = plot.box;
	                          var screenBox = plot.screenBox;
	                          var dataBox = plot.dataBox;
	                          var viewBox = plot.viewBox;
	                          var pixelRatio = plot.pixelRatio;
	                          var loX = (selectBox[0] - dataBox[0]) * (viewBox[2] - viewBox[0]) / (dataBox[2] - dataBox[0]) + viewBox[0];
	                          var loY = (selectBox[1] - dataBox[1]) * (viewBox[3] - viewBox[1]) / (dataBox[3] - dataBox[1]) + viewBox[1];
	                          var hiX = (selectBox[2] - dataBox[0]) * (viewBox[2] - viewBox[0]) / (dataBox[2] - dataBox[0]) + viewBox[0];
	                          var hiY = (selectBox[3] - dataBox[1]) * (viewBox[3] - viewBox[1]) / (dataBox[3] - dataBox[1]) + viewBox[1];
	                          loX = Math.max(loX, viewBox[0]);
	                          loY = Math.max(loY, viewBox[1]);
	                          hiX = Math.min(hiX, viewBox[2]);
	                          hiY = Math.min(hiY, viewBox[3]);
	                          if (hiX < loX || hiY < loY) {
	                            return;
	                          }
	                          boxes.bind();
	                          var screenWidth = screenBox[2] - screenBox[0];
	                          var screenHeight = screenBox[3] - screenBox[1];
	                          if (this.outerFill) {
	                            boxes.drawBox(0, 0, screenWidth, loY, outerColor);
	                            boxes.drawBox(0, loY, loX, hiY, outerColor);
	                            boxes.drawBox(0, hiY, screenWidth, screenHeight, outerColor);
	                            boxes.drawBox(hiX, loY, screenWidth, hiY, outerColor);
	                          }
	                          if (this.innerFill) {
	                            boxes.drawBox(loX, loY, hiX, hiY, innerColor);
	                          }
	                          if (lineWidth > 0) {
	                            var w = lineWidth * pixelRatio;
	                            boxes.drawBox(loX - w, loY - w, hiX + w, loY + w, borderColor);
	                            boxes.drawBox(loX - w, hiY - w, hiX + w, hiY + w, borderColor);
	                            boxes.drawBox(loX - w, loY - w, loX + w, hiY + w, borderColor);
	                            boxes.drawBox(hiX - w, loY - w, hiX + w, hiY + w, borderColor);
	                          }
	                        };
	                        proto.update = function(options) {
	                          options = options || {};
	                          this.innerFill = !!options.innerFill;
	                          this.outerFill = !!options.outerFill;
	                          this.innerColor = (options.innerColor || [0, 0, 0, 0.5]).slice();
	                          this.outerColor = (options.outerColor || [0, 0, 0, 0.5]).slice();
	                          this.borderColor = (options.borderColor || [0, 0, 0, 1]).slice();
	                          this.borderWidth = options.borderWidth || 0;
	                          this.selectBox = (options.selectBox || this.selectBox).slice();
	                        };
	                        proto.dispose = function() {
	                          this.boxBuffer.dispose();
	                          this.boxShader.dispose();
	                          this.plot.removeOverlay(this);
	                        };
	                        function createSelectBox(plot, options) {
	                          var gl2 = plot.gl;
	                          var buffer = createBuffer(gl2, [0, 0, 0, 1, 1, 0, 1, 1]);
	                          var shader = createShader(gl2, SHADERS.boxVertex, SHADERS.boxFragment);
	                          var selectBox = new SelectBox(plot, buffer, shader);
	                          selectBox.update(options);
	                          plot.addOverlay(selectBox);
	                          return selectBox;
	                        }
	                      }
	                    ),
	                    /***/
	                    2611: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_487476__) {
	                        module3.exports = createSelectBuffer;
	                        var createFBO = __nested_webpack_require_487476__(4234);
	                        var pool = __nested_webpack_require_487476__(5306);
	                        var ndarray = __nested_webpack_require_487476__(5050);
	                        var nextPow2 = __nested_webpack_require_487476__(2288).nextPow2;
	                        var selectRange = function(arr, x, y) {
	                          var closestD2 = 1e8;
	                          var closestX = -1;
	                          var closestY = -1;
	                          var ni = arr.shape[0];
	                          var nj = arr.shape[1];
	                          for (var i = 0; i < ni; i++) {
	                            for (var j = 0; j < nj; j++) {
	                              var r = arr.get(i, j, 0);
	                              var g = arr.get(i, j, 1);
	                              var b = arr.get(i, j, 2);
	                              var a = arr.get(i, j, 3);
	                              if (r < 255 || g < 255 || b < 255 || a < 255) {
	                                var dx = x - i;
	                                var dy = y - j;
	                                var d2 = dx * dx + dy * dy;
	                                if (d2 < closestD2) {
	                                  closestD2 = d2;
	                                  closestX = i;
	                                  closestY = j;
	                                }
	                              }
	                            }
	                          }
	                          return [closestX, closestY, closestD2];
	                        };
	                        function SelectResult(x, y, id, value, distance) {
	                          this.coord = [x, y];
	                          this.id = id;
	                          this.value = value;
	                          this.distance = distance;
	                        }
	                        function SelectBuffer(gl2, fbo, buffer) {
	                          this.gl = gl2;
	                          this.fbo = fbo;
	                          this.buffer = buffer;
	                          this._readTimeout = null;
	                          var self2 = this;
	                          this._readCallback = function() {
	                            if (!self2.gl) {
	                              return;
	                            }
	                            fbo.bind();
	                            gl2.readPixels(0, 0, fbo.shape[0], fbo.shape[1], gl2.RGBA, gl2.UNSIGNED_BYTE, self2.buffer);
	                            self2._readTimeout = null;
	                          };
	                        }
	                        var proto = SelectBuffer.prototype;
	                        Object.defineProperty(proto, "shape", { get: function() {
	                          if (!this.gl) {
	                            return [0, 0];
	                          }
	                          return this.fbo.shape.slice();
	                        }, set: function(v) {
	                          if (!this.gl) {
	                            return;
	                          }
	                          this.fbo.shape = v;
	                          var c = this.fbo.shape[0];
	                          var r = this.fbo.shape[1];
	                          if (r * c * 4 > this.buffer.length) {
	                            pool.free(this.buffer);
	                            var buffer = this.buffer = pool.mallocUint8(nextPow2(r * c * 4));
	                            for (var i = 0; i < r * c * 4; ++i) {
	                              buffer[i] = 255;
	                            }
	                          }
	                          return v;
	                        } });
	                        proto.begin = function() {
	                          var gl2 = this.gl;
	                          this.shape;
	                          if (!gl2) {
	                            return;
	                          }
	                          this.fbo.bind();
	                          gl2.clearColor(1, 1, 1, 1);
	                          gl2.clear(gl2.COLOR_BUFFER_BIT | gl2.DEPTH_BUFFER_BIT);
	                        };
	                        proto.end = function() {
	                          var gl2 = this.gl;
	                          if (!gl2) {
	                            return;
	                          }
	                          gl2.bindFramebuffer(gl2.FRAMEBUFFER, null);
	                          if (!this._readTimeout) {
	                            clearTimeout(this._readTimeout);
	                          }
	                          this._readTimeout = setTimeout(this._readCallback, 1);
	                        };
	                        proto.query = function(x, y, radius) {
	                          if (!this.gl) {
	                            return null;
	                          }
	                          var shape = this.fbo.shape.slice();
	                          x = x | 0;
	                          y = y | 0;
	                          if (typeof radius !== "number") {
	                            radius = 1;
	                          }
	                          var x0 = Math.min(Math.max(x - radius, 0), shape[0]) | 0;
	                          var x1 = Math.min(Math.max(x + radius, 0), shape[0]) | 0;
	                          var y0 = Math.min(Math.max(y - radius, 0), shape[1]) | 0;
	                          var y1 = Math.min(Math.max(y + radius, 0), shape[1]) | 0;
	                          if (x1 <= x0 || y1 <= y0) {
	                            return null;
	                          }
	                          var dims = [x1 - x0, y1 - y0];
	                          var region = ndarray(this.buffer, [dims[0], dims[1], 4], [4, shape[0] * 4, 1], 4 * (x0 + shape[0] * y0));
	                          var closest = selectRange(region.hi(dims[0], dims[1], 1), radius, radius);
	                          var dx = closest[0];
	                          var dy = closest[1];
	                          if (dx < 0 || Math.pow(this.radius, 2) < closest[2]) {
	                            return null;
	                          }
	                          var c0 = region.get(dx, dy, 0);
	                          var c1 = region.get(dx, dy, 1);
	                          var c2 = region.get(dx, dy, 2);
	                          var c3 = region.get(dx, dy, 3);
	                          return new SelectResult(dx + x0 | 0, dy + y0 | 0, c0, [c1, c2, c3], Math.sqrt(closest[2]));
	                        };
	                        proto.dispose = function() {
	                          if (!this.gl) {
	                            return;
	                          }
	                          this.fbo.dispose();
	                          pool.free(this.buffer);
	                          this.gl = null;
	                          if (this._readTimeout) {
	                            clearTimeout(this._readTimeout);
	                          }
	                        };
	                        function createSelectBuffer(gl2, shape) {
	                          var width = shape[0];
	                          var height = shape[1];
	                          var options = {};
	                          var fbo = createFBO(gl2, width, height, options);
	                          var buffer = pool.mallocUint8(width * height * 4);
	                          return new SelectBuffer(gl2, fbo, buffer);
	                        }
	                      }
	                    ),
	                    /***/
	                    5158: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_490573__) {
	                        var createUniformWrapper = __nested_webpack_require_490573__(9016);
	                        var createAttributeWrapper = __nested_webpack_require_490573__(4280);
	                        var makeReflect = __nested_webpack_require_490573__(3984);
	                        var shaderCache = __nested_webpack_require_490573__(1628);
	                        var runtime = __nested_webpack_require_490573__(2631);
	                        var GLError = __nested_webpack_require_490573__(9068);
	                        function Shader(gl2) {
	                          this.gl = gl2;
	                          this.gl.lastAttribCount = 0;
	                          this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
	                        }
	                        var proto = Shader.prototype;
	                        proto.bind = function() {
	                          if (!this.program) {
	                            this._relink();
	                          }
	                          var i;
	                          var newAttribCount = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES);
	                          var oldAttribCount = this.gl.lastAttribCount;
	                          if (newAttribCount > oldAttribCount) {
	                            for (i = oldAttribCount; i < newAttribCount; i++) {
	                              this.gl.enableVertexAttribArray(i);
	                            }
	                          } else if (oldAttribCount > newAttribCount) {
	                            for (i = newAttribCount; i < oldAttribCount; i++) {
	                              this.gl.disableVertexAttribArray(i);
	                            }
	                          }
	                          this.gl.lastAttribCount = newAttribCount;
	                          this.gl.useProgram(this.program);
	                        };
	                        proto.dispose = function() {
	                          var oldAttribCount = this.gl.lastAttribCount;
	                          for (var i = 0; i < oldAttribCount; i++) {
	                            this.gl.disableVertexAttribArray(i);
	                          }
	                          this.gl.lastAttribCount = 0;
	                          if (this._fref) {
	                            this._fref.dispose();
	                          }
	                          if (this._vref) {
	                            this._vref.dispose();
	                          }
	                          this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
	                        };
	                        function compareAttributes(a, b) {
	                          if (a.name < b.name) {
	                            return -1;
	                          }
	                          return 1;
	                        }
	                        proto.update = function(vertSource, fragSource, uniforms, attributes) {
	                          if (!fragSource || arguments.length === 1) {
	                            var obj = vertSource;
	                            vertSource = obj.vertex;
	                            fragSource = obj.fragment;
	                            uniforms = obj.uniforms;
	                            attributes = obj.attributes;
	                          }
	                          var wrapper = this;
	                          var gl2 = wrapper.gl;
	                          var pvref = wrapper._vref;
	                          wrapper._vref = shaderCache.shader(gl2, gl2.VERTEX_SHADER, vertSource);
	                          if (pvref) {
	                            pvref.dispose();
	                          }
	                          wrapper.vertShader = wrapper._vref.shader;
	                          var pfref = this._fref;
	                          wrapper._fref = shaderCache.shader(gl2, gl2.FRAGMENT_SHADER, fragSource);
	                          if (pfref) {
	                            pfref.dispose();
	                          }
	                          wrapper.fragShader = wrapper._fref.shader;
	                          if (!uniforms || !attributes) {
	                            var testProgram = gl2.createProgram();
	                            gl2.attachShader(testProgram, wrapper.fragShader);
	                            gl2.attachShader(testProgram, wrapper.vertShader);
	                            gl2.linkProgram(testProgram);
	                            if (!gl2.getProgramParameter(testProgram, gl2.LINK_STATUS)) {
	                              var errLog = gl2.getProgramInfoLog(testProgram);
	                              throw new GLError(errLog, "Error linking program:" + errLog);
	                            }
	                            uniforms = uniforms || runtime.uniforms(gl2, testProgram);
	                            attributes = attributes || runtime.attributes(gl2, testProgram);
	                            gl2.deleteProgram(testProgram);
	                          }
	                          attributes = attributes.slice();
	                          attributes.sort(compareAttributes);
	                          var attributeUnpacked = [];
	                          var attributeNames = [];
	                          var attributeLocations = [];
	                          var i;
	                          for (i = 0; i < attributes.length; ++i) {
	                            var attr = attributes[i];
	                            if (attr.type.indexOf("mat") >= 0) {
	                              var size = attr.type.charAt(attr.type.length - 1) | 0;
	                              var locVector = new Array(size);
	                              for (var j = 0; j < size; ++j) {
	                                locVector[j] = attributeLocations.length;
	                                attributeNames.push(attr.name + "[" + j + "]");
	                                if (typeof attr.location === "number") {
	                                  attributeLocations.push(attr.location + j);
	                                } else if (Array.isArray(attr.location) && attr.location.length === size && typeof attr.location[j] === "number") {
	                                  attributeLocations.push(attr.location[j] | 0);
	                                } else {
	                                  attributeLocations.push(-1);
	                                }
	                              }
	                              attributeUnpacked.push({ name: attr.name, type: attr.type, locations: locVector });
	                            } else {
	                              attributeUnpacked.push({ name: attr.name, type: attr.type, locations: [attributeLocations.length] });
	                              attributeNames.push(attr.name);
	                              if (typeof attr.location === "number") {
	                                attributeLocations.push(attr.location | 0);
	                              } else {
	                                attributeLocations.push(-1);
	                              }
	                            }
	                          }
	                          var curLocation = 0;
	                          for (i = 0; i < attributeLocations.length; ++i) {
	                            if (attributeLocations[i] < 0) {
	                              while (attributeLocations.indexOf(curLocation) >= 0) {
	                                curLocation += 1;
	                              }
	                              attributeLocations[i] = curLocation;
	                            }
	                          }
	                          var uniformLocations = new Array(uniforms.length);
	                          function relink() {
	                            wrapper.program = shaderCache.program(gl2, wrapper._vref, wrapper._fref, attributeNames, attributeLocations);
	                            for (var i2 = 0; i2 < uniforms.length; ++i2) {
	                              uniformLocations[i2] = gl2.getUniformLocation(wrapper.program, uniforms[i2].name);
	                            }
	                          }
	                          relink();
	                          wrapper._relink = relink;
	                          wrapper.types = { uniforms: makeReflect(uniforms), attributes: makeReflect(attributes) };
	                          wrapper.attributes = createAttributeWrapper(gl2, wrapper, attributeUnpacked, attributeLocations);
	                          Object.defineProperty(wrapper, "uniforms", createUniformWrapper(gl2, wrapper, uniforms, uniformLocations));
	                        };
	                        function createShader(gl2, vertSource, fragSource, uniforms, attributes) {
	                          var shader = new Shader(gl2);
	                          shader.update(vertSource, fragSource, uniforms, attributes);
	                          return shader;
	                        }
	                        module3.exports = createShader;
	                      }
	                    ),
	                    /***/
	                    9068: (
	                      /***/
	                      function(module3) {
	                        function GLError(rawError, shortMessage, longMessage) {
	                          this.shortMessage = shortMessage || "";
	                          this.longMessage = longMessage || "";
	                          this.rawError = rawError || "";
	                          this.message = "gl-shader: " + (shortMessage || rawError || "") + (longMessage ? "\n" + longMessage : "");
	                          this.stack = new Error().stack;
	                        }
	                        GLError.prototype = new Error();
	                        GLError.prototype.name = "GLError";
	                        GLError.prototype.constructor = GLError;
	                        module3.exports = GLError;
	                      }
	                    ),
	                    /***/
	                    4280: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_496842__) {
	                        module3.exports = createAttributeWrapper;
	                        var GLError = __nested_webpack_require_496842__(9068);
	                        function ShaderAttribute(gl2, wrapper, index, locations, dimension, constFunc) {
	                          this._gl = gl2;
	                          this._wrapper = wrapper;
	                          this._index = index;
	                          this._locations = locations;
	                          this._dimension = dimension;
	                          this._constFunc = constFunc;
	                        }
	                        var proto = ShaderAttribute.prototype;
	                        proto.pointer = function setAttribPointer(type, normalized, stride, offset) {
	                          var self2 = this;
	                          var gl2 = self2._gl;
	                          var location = self2._locations[self2._index];
	                          gl2.vertexAttribPointer(location, self2._dimension, type || gl2.FLOAT, !!normalized, stride || 0, offset || 0);
	                          gl2.enableVertexAttribArray(location);
	                        };
	                        proto.set = function(x0, x1, x2, x3) {
	                          return this._constFunc(this._locations[this._index], x0, x1, x2, x3);
	                        };
	                        Object.defineProperty(proto, "location", { get: function() {
	                          return this._locations[this._index];
	                        }, set: function(v) {
	                          if (v !== this._locations[this._index]) {
	                            this._locations[this._index] = v | 0;
	                            this._wrapper.program = null;
	                          }
	                          return v | 0;
	                        } });
	                        var allFns = [function(gl2, v, x0) {
	                          if (x0.length === undefined) {
	                            return gl2.vertexAttrib1f(v, x0);
	                          } else {
	                            return gl2.vertexAttrib1fv(v, x0);
	                          }
	                        }, function(gl2, v, x0, x1) {
	                          if (x0.length === undefined) {
	                            return gl2.vertexAttrib2f(v, x0, x1);
	                          } else {
	                            return gl2.vertexAttrib2fv(v, x0);
	                          }
	                        }, function(gl2, v, x0, x1, x2) {
	                          if (x0.length === undefined) {
	                            return gl2.vertexAttrib3f(v, x0, x1, x2);
	                          } else {
	                            return gl2.vertexAttrib3fv(v, x0);
	                          }
	                        }, function(gl2, v, x0, x1, x2, x3) {
	                          if (x0.length === undefined) {
	                            return gl2.vertexAttrib4f(v, x0, x1, x2, x3);
	                          } else {
	                            return gl2.vertexAttrib4fv(v, x0);
	                          }
	                        }];
	                        function addVectorAttribute(gl2, wrapper, index, locations, dimension, obj, name2) {
	                          var constFunc = allFns[dimension];
	                          var attr = new ShaderAttribute(gl2, wrapper, index, locations, dimension, constFunc);
	                          Object.defineProperty(obj, name2, { set: function(x) {
	                            gl2.disableVertexAttribArray(locations[index]);
	                            constFunc(gl2, locations[index], x);
	                            return x;
	                          }, get: function() {
	                            return attr;
	                          }, enumerable: true });
	                        }
	                        function addMatrixAttribute(gl2, wrapper, index, locations, dimension, obj, name2) {
	                          var parts = new Array(dimension);
	                          var attrs = new Array(dimension);
	                          for (var i = 0; i < dimension; ++i) {
	                            addVectorAttribute(gl2, wrapper, index[i], locations, dimension, parts, i);
	                            attrs[i] = parts[i];
	                          }
	                          Object.defineProperty(parts, "location", { set: function(v) {
	                            if (Array.isArray(v)) {
	                              for (var i2 = 0; i2 < dimension; ++i2) {
	                                attrs[i2].location = v[i2];
	                              }
	                            } else {
	                              for (var i2 = 0; i2 < dimension; ++i2) {
	                                attrs[i2].location = v + i2;
	                              }
	                            }
	                            return v;
	                          }, get: function() {
	                            var result = new Array(dimension);
	                            for (var i2 = 0; i2 < dimension; ++i2) {
	                              result[i2] = locations[index[i2]];
	                            }
	                            return result;
	                          }, enumerable: true });
	                          parts.pointer = function(type, normalized, stride, offset) {
	                            type = type || gl2.FLOAT;
	                            normalized = !!normalized;
	                            stride = stride || dimension * dimension;
	                            offset = offset || 0;
	                            for (var i2 = 0; i2 < dimension; ++i2) {
	                              var location = locations[index[i2]];
	                              gl2.vertexAttribPointer(location, dimension, type, normalized, stride, offset + i2 * dimension);
	                              gl2.enableVertexAttribArray(location);
	                            }
	                          };
	                          var scratch = new Array(dimension);
	                          var vertexAttrib = gl2["vertexAttrib" + dimension + "fv"];
	                          Object.defineProperty(obj, name2, { set: function(x) {
	                            for (var i2 = 0; i2 < dimension; ++i2) {
	                              var loc = locations[index[i2]];
	                              gl2.disableVertexAttribArray(loc);
	                              if (Array.isArray(x[0])) {
	                                vertexAttrib.call(gl2, loc, x[i2]);
	                              } else {
	                                for (var j = 0; j < dimension; ++j) {
	                                  scratch[j] = x[dimension * i2 + j];
	                                }
	                                vertexAttrib.call(gl2, loc, scratch);
	                              }
	                            }
	                            return x;
	                          }, get: function() {
	                            return parts;
	                          }, enumerable: true });
	                        }
	                        function createAttributeWrapper(gl2, wrapper, attributes, locations) {
	                          var obj = {};
	                          for (var i = 0, n = attributes.length; i < n; ++i) {
	                            var a = attributes[i];
	                            var name2 = a.name;
	                            var type = a.type;
	                            var locs = a.locations;
	                            switch (type) {
	                              case "bool":
	                              case "int":
	                              case "float":
	                                addVectorAttribute(gl2, wrapper, locs[0], locations, 1, obj, name2);
	                                break;
	                              default:
	                                if (type.indexOf("vec") >= 0) {
	                                  var d = type.charCodeAt(type.length - 1) - 48;
	                                  if (d < 2 || d > 4) {
	                                    throw new GLError("", "Invalid data type for attribute " + name2 + ": " + type);
	                                  }
	                                  addVectorAttribute(gl2, wrapper, locs[0], locations, d, obj, name2);
	                                } else if (type.indexOf("mat") >= 0) {
	                                  var d = type.charCodeAt(type.length - 1) - 48;
	                                  if (d < 2 || d > 4) {
	                                    throw new GLError("", "Invalid data type for attribute " + name2 + ": " + type);
	                                  }
	                                  addMatrixAttribute(gl2, wrapper, locs, locations, d, obj, name2);
	                                } else {
	                                  throw new GLError("", "Unknown data type for attribute " + name2 + ": " + type);
	                                }
	                                break;
	                            }
	                          }
	                          return obj;
	                        }
	                      }
	                    ),
	                    /***/
	                    9016: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_501052__) {
	                        var coallesceUniforms = __nested_webpack_require_501052__(3984);
	                        var GLError = __nested_webpack_require_501052__(9068);
	                        module3.exports = createUniformWrapper;
	                        function identity2(x) {
	                          return function() {
	                            return x;
	                          };
	                        }
	                        function makeVector(length, fill) {
	                          var result = new Array(length);
	                          for (var i = 0; i < length; ++i) {
	                            result[i] = fill;
	                          }
	                          return result;
	                        }
	                        function createUniformWrapper(gl2, wrapper, uniforms, locations) {
	                          function makeGetter(idx) {
	                            return function(gl3, wrapper2, locations2) {
	                              return gl3.getUniform(wrapper2.program, locations2[idx]);
	                            };
	                          }
	                          function makeSetter(type) {
	                            return function updateProperty(obj) {
	                              var indices = enumerateIndices("", type);
	                              for (var i = 0; i < indices.length; ++i) {
	                                var item = indices[i];
	                                var path = item[0];
	                                var idx = item[1];
	                                if (locations[idx]) {
	                                  var objPath = obj;
	                                  if (typeof path === "string" && (path.indexOf(".") === 0 || path.indexOf("[") === 0)) {
	                                    var key = path;
	                                    if (path.indexOf(".") === 0) {
	                                      key = path.slice(1);
	                                    }
	                                    if (key.indexOf("]") === key.length - 1) {
	                                      var j = key.indexOf("[");
	                                      var k1 = key.slice(0, j);
	                                      var k2 = key.slice(j + 1, key.length - 1);
	                                      objPath = k1 ? obj[k1][k2] : obj[k2];
	                                    } else {
	                                      objPath = obj[key];
	                                    }
	                                  }
	                                  var t = uniforms[idx].type;
	                                  var d;
	                                  switch (t) {
	                                    case "bool":
	                                    case "int":
	                                    case "sampler2D":
	                                    case "samplerCube":
	                                      gl2.uniform1i(locations[idx], objPath);
	                                      break;
	                                    case "float":
	                                      gl2.uniform1f(locations[idx], objPath);
	                                      break;
	                                    default:
	                                      var vidx = t.indexOf("vec");
	                                      if (0 <= vidx && vidx <= 1 && t.length === 4 + vidx) {
	                                        d = t.charCodeAt(t.length - 1) - 48;
	                                        if (d < 2 || d > 4) {
	                                          throw new GLError("", "Invalid data type");
	                                        }
	                                        switch (t.charAt(0)) {
	                                          case "b":
	                                          case "i":
	                                            gl2["uniform" + d + "iv"](locations[idx], objPath);
	                                            break;
	                                          case "v":
	                                            gl2["uniform" + d + "fv"](locations[idx], objPath);
	                                            break;
	                                          default:
	                                            throw new GLError("", "Unrecognized data type for vector " + name + ": " + t);
	                                        }
	                                      } else if (t.indexOf("mat") === 0 && t.length === 4) {
	                                        d = t.charCodeAt(t.length - 1) - 48;
	                                        if (d < 2 || d > 4) {
	                                          throw new GLError("", "Invalid uniform dimension type for matrix " + name + ": " + t);
	                                        }
	                                        gl2["uniformMatrix" + d + "fv"](locations[idx], false, objPath);
	                                        break;
	                                      } else {
	                                        throw new GLError("", "Unknown uniform data type for " + name + ": " + t);
	                                      }
	                                  }
	                                }
	                              }
	                            };
	                          }
	                          function enumerateIndices(prefix, type) {
	                            if (typeof type !== "object") {
	                              return [[prefix, type]];
	                            }
	                            var indices = [];
	                            for (var id in type) {
	                              var prop = type[id];
	                              var tprefix = prefix;
	                              if (parseInt(id) + "" === id) {
	                                tprefix += "[" + id + "]";
	                              } else {
	                                tprefix += "." + id;
	                              }
	                              if (typeof prop === "object") {
	                                indices.push.apply(indices, enumerateIndices(tprefix, prop));
	                              } else {
	                                indices.push([tprefix, prop]);
	                              }
	                            }
	                            return indices;
	                          }
	                          function defaultValue(type) {
	                            switch (type) {
	                              case "bool":
	                                return false;
	                              case "int":
	                              case "sampler2D":
	                              case "samplerCube":
	                                return 0;
	                              case "float":
	                                return 0;
	                              default:
	                                var vidx = type.indexOf("vec");
	                                if (0 <= vidx && vidx <= 1 && type.length === 4 + vidx) {
	                                  var d = type.charCodeAt(type.length - 1) - 48;
	                                  if (d < 2 || d > 4) {
	                                    throw new GLError("", "Invalid data type");
	                                  }
	                                  if (type.charAt(0) === "b") {
	                                    return makeVector(d, false);
	                                  }
	                                  return makeVector(d, 0);
	                                } else if (type.indexOf("mat") === 0 && type.length === 4) {
	                                  var d = type.charCodeAt(type.length - 1) - 48;
	                                  if (d < 2 || d > 4) {
	                                    throw new GLError("", "Invalid uniform dimension type for matrix " + name + ": " + type);
	                                  }
	                                  return makeVector(d * d, 0);
	                                } else {
	                                  throw new GLError("", "Unknown uniform data type for " + name + ": " + type);
	                                }
	                            }
	                          }
	                          function storeProperty(obj, prop, type) {
	                            if (typeof type === "object") {
	                              var child = processObject(type);
	                              Object.defineProperty(obj, prop, { get: identity2(child), set: makeSetter(type), enumerable: true, configurable: false });
	                            } else {
	                              if (locations[type]) {
	                                Object.defineProperty(obj, prop, { get: makeGetter(type), set: makeSetter(type), enumerable: true, configurable: false });
	                              } else {
	                                obj[prop] = defaultValue(uniforms[type].type);
	                              }
	                            }
	                          }
	                          function processObject(obj) {
	                            var result;
	                            if (Array.isArray(obj)) {
	                              result = new Array(obj.length);
	                              for (var i = 0; i < obj.length; ++i) {
	                                storeProperty(result, i, obj[i]);
	                              }
	                            } else {
	                              result = {};
	                              for (var id in obj) {
	                                storeProperty(result, id, obj[id]);
	                              }
	                            }
	                            return result;
	                          }
	                          var coallesced = coallesceUniforms(uniforms, true);
	                          return { get: identity2(processObject(coallesced)), set: makeSetter(coallesced), enumerable: true, configurable: true };
	                        }
	                      }
	                    ),
	                    /***/
	                    3984: (
	                      /***/
	                      function(module3) {
	                        module3.exports = makeReflectTypes;
	                        function makeReflectTypes(uniforms, useIndex) {
	                          var obj = {};
	                          for (var i = 0; i < uniforms.length; ++i) {
	                            var n = uniforms[i].name;
	                            var parts = n.split(".");
	                            var o = obj;
	                            for (var j = 0; j < parts.length; ++j) {
	                              var x = parts[j].split("[");
	                              if (x.length > 1) {
	                                if (!(x[0] in o)) {
	                                  o[x[0]] = [];
	                                }
	                                o = o[x[0]];
	                                for (var k = 1; k < x.length; ++k) {
	                                  var y = parseInt(x[k]);
	                                  if (k < x.length - 1 || j < parts.length - 1) {
	                                    if (!(y in o)) {
	                                      if (k < x.length - 1) {
	                                        o[y] = [];
	                                      } else {
	                                        o[y] = {};
	                                      }
	                                    }
	                                    o = o[y];
	                                  } else {
	                                    if (useIndex) {
	                                      o[y] = i;
	                                    } else {
	                                      o[y] = uniforms[i].type;
	                                    }
	                                  }
	                                }
	                              } else if (j < parts.length - 1) {
	                                if (!(x[0] in o)) {
	                                  o[x[0]] = {};
	                                }
	                                o = o[x[0]];
	                              } else {
	                                if (useIndex) {
	                                  o[x[0]] = i;
	                                } else {
	                                  o[x[0]] = uniforms[i].type;
	                                }
	                              }
	                            }
	                          }
	                          return obj;
	                        }
	                      }
	                    ),
	                    /***/
	                    2631: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        exports2.uniforms = runtimeUniforms;
	                        exports2.attributes = runtimeAttributes;
	                        var GL_TO_GLSL_TYPES = { "FLOAT": "float", "FLOAT_VEC2": "vec2", "FLOAT_VEC3": "vec3", "FLOAT_VEC4": "vec4", "INT": "int", "INT_VEC2": "ivec2", "INT_VEC3": "ivec3", "INT_VEC4": "ivec4", "BOOL": "bool", "BOOL_VEC2": "bvec2", "BOOL_VEC3": "bvec3", "BOOL_VEC4": "bvec4", "FLOAT_MAT2": "mat2", "FLOAT_MAT3": "mat3", "FLOAT_MAT4": "mat4", "SAMPLER_2D": "sampler2D", "SAMPLER_CUBE": "samplerCube" };
	                        var GL_TABLE = null;
	                        function getType(gl2, type) {
	                          if (!GL_TABLE) {
	                            var typeNames = Object.keys(GL_TO_GLSL_TYPES);
	                            GL_TABLE = {};
	                            for (var i = 0; i < typeNames.length; ++i) {
	                              var tn = typeNames[i];
	                              GL_TABLE[gl2[tn]] = GL_TO_GLSL_TYPES[tn];
	                            }
	                          }
	                          return GL_TABLE[type];
	                        }
	                        function runtimeUniforms(gl2, program) {
	                          var numUniforms = gl2.getProgramParameter(program, gl2.ACTIVE_UNIFORMS);
	                          var result = [];
	                          for (var i = 0; i < numUniforms; ++i) {
	                            var info = gl2.getActiveUniform(program, i);
	                            if (info) {
	                              var type = getType(gl2, info.type);
	                              if (info.size > 1) {
	                                for (var j = 0; j < info.size; ++j) {
	                                  result.push({ name: info.name.replace("[0]", "[" + j + "]"), type });
	                                }
	                              } else {
	                                result.push({ name: info.name, type });
	                              }
	                            }
	                          }
	                          return result;
	                        }
	                        function runtimeAttributes(gl2, program) {
	                          var numAttributes = gl2.getProgramParameter(program, gl2.ACTIVE_ATTRIBUTES);
	                          var result = [];
	                          for (var i = 0; i < numAttributes; ++i) {
	                            var info = gl2.getActiveAttrib(program, i);
	                            if (info) {
	                              result.push({ name: info.name, type: getType(gl2, info.type) });
	                            }
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    1628: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_507323__) {
	                        exports2.shader = getShaderReference;
	                        exports2.program = createProgram;
	                        var GLError = __nested_webpack_require_507323__(9068);
	                        var formatCompilerError = __nested_webpack_require_507323__(3530);
	                        var weakMap = typeof WeakMap === "undefined" ? __nested_webpack_require_507323__(4037) : WeakMap;
	                        var CACHE = new weakMap();
	                        var SHADER_COUNTER = 0;
	                        function ShaderReference(id, src, type, shader, programs, count, cache) {
	                          this.id = id;
	                          this.src = src;
	                          this.type = type;
	                          this.shader = shader;
	                          this.count = count;
	                          this.programs = [];
	                          this.cache = cache;
	                        }
	                        ShaderReference.prototype.dispose = function() {
	                          if (--this.count === 0) {
	                            var cache = this.cache;
	                            var gl2 = cache.gl;
	                            var programs = this.programs;
	                            for (var i = 0, n = programs.length; i < n; ++i) {
	                              var p = cache.programs[programs[i]];
	                              if (p) {
	                                delete cache.programs[i];
	                                gl2.deleteProgram(p);
	                              }
	                            }
	                            gl2.deleteShader(this.shader);
	                            delete cache.shaders[this.type === gl2.FRAGMENT_SHADER | 0][this.src];
	                          }
	                        };
	                        function ContextCache(gl2) {
	                          this.gl = gl2;
	                          this.shaders = [{}, {}];
	                          this.programs = {};
	                        }
	                        var proto = ContextCache.prototype;
	                        function compileShader(gl2, type, src) {
	                          var shader = gl2.createShader(type);
	                          gl2.shaderSource(shader, src);
	                          gl2.compileShader(shader);
	                          if (!gl2.getShaderParameter(shader, gl2.COMPILE_STATUS)) {
	                            var errLog = gl2.getShaderInfoLog(shader);
	                            try {
	                              var fmt = formatCompilerError(errLog, src, type);
	                            } catch (e) {
	                              console.warn("Failed to format compiler error: " + e);
	                              throw new GLError(errLog, "Error compiling shader:\n" + errLog);
	                            }
	                            throw new GLError(errLog, fmt.short, fmt.long);
	                          }
	                          return shader;
	                        }
	                        proto.getShaderReference = function(type, src) {
	                          var gl2 = this.gl;
	                          var shaders = this.shaders[type === gl2.FRAGMENT_SHADER | 0];
	                          var shader = shaders[src];
	                          if (!shader || !gl2.isShader(shader.shader)) {
	                            var shaderObj = compileShader(gl2, type, src);
	                            shader = shaders[src] = new ShaderReference(SHADER_COUNTER++, src, type, shaderObj, [], 1, this);
	                          } else {
	                            shader.count += 1;
	                          }
	                          return shader;
	                        };
	                        function linkProgram(gl2, vshader, fshader, attribs, locations) {
	                          var program = gl2.createProgram();
	                          gl2.attachShader(program, vshader);
	                          gl2.attachShader(program, fshader);
	                          for (var i = 0; i < attribs.length; ++i) {
	                            gl2.bindAttribLocation(program, locations[i], attribs[i]);
	                          }
	                          gl2.linkProgram(program);
	                          if (!gl2.getProgramParameter(program, gl2.LINK_STATUS)) {
	                            var errLog = gl2.getProgramInfoLog(program);
	                            throw new GLError(errLog, "Error linking program: " + errLog);
	                          }
	                          return program;
	                        }
	                        proto.getProgram = function(vref, fref, attribs, locations) {
	                          var token = [vref.id, fref.id, attribs.join(":"), locations.join(":")].join("@");
	                          var prog = this.programs[token];
	                          if (!prog || !this.gl.isProgram(prog)) {
	                            this.programs[token] = prog = linkProgram(this.gl, vref.shader, fref.shader, attribs, locations);
	                            vref.programs.push(token);
	                            fref.programs.push(token);
	                          }
	                          return prog;
	                        };
	                        function getCache(gl2) {
	                          var ctxCache = CACHE.get(gl2);
	                          if (!ctxCache) {
	                            ctxCache = new ContextCache(gl2);
	                            CACHE.set(gl2, ctxCache);
	                          }
	                          return ctxCache;
	                        }
	                        function getShaderReference(gl2, type, src) {
	                          return getCache(gl2).getShaderReference(type, src);
	                        }
	                        function createProgram(gl2, vref, fref, attribs, locations) {
	                          return getCache(gl2).getProgram(vref, fref, attribs, locations);
	                        }
	                      }
	                    ),
	                    /***/
	                    3050: (
	                      /***/
	                      function(module3) {
	                        module3.exports = createSpikes2D;
	                        function GLSpikes2D(plot) {
	                          this.plot = plot;
	                          this.enable = [true, true, false, false];
	                          this.width = [1, 1, 1, 1];
	                          this.color = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.center = [Infinity, Infinity];
	                        }
	                        var proto = GLSpikes2D.prototype;
	                        proto.update = function(options) {
	                          options = options || {};
	                          this.enable = (options.enable || [true, true, false, false]).slice();
	                          this.width = (options.width || [1, 1, 1, 1]).slice();
	                          this.color = (options.color || [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]).map(function(x) {
	                            return x.slice();
	                          });
	                          this.center = (options.center || [Infinity, Infinity]).slice();
	                          this.plot.setOverlayDirty();
	                        };
	                        proto.draw = function() {
	                          var spikeEnable = this.enable;
	                          var spikeWidth = this.width;
	                          var spikeColor = this.color;
	                          var spikeCenter = this.center;
	                          var plot = this.plot;
	                          var line = plot.line;
	                          var dataBox = plot.dataBox;
	                          var viewPixels = plot.viewBox;
	                          line.bind();
	                          if (dataBox[0] <= spikeCenter[0] && spikeCenter[0] <= dataBox[2] && dataBox[1] <= spikeCenter[1] && spikeCenter[1] <= dataBox[3]) {
	                            var centerX = viewPixels[0] + (spikeCenter[0] - dataBox[0]) / (dataBox[2] - dataBox[0]) * (viewPixels[2] - viewPixels[0]);
	                            var centerY = viewPixels[1] + (spikeCenter[1] - dataBox[1]) / (dataBox[3] - dataBox[1]) * (viewPixels[3] - viewPixels[1]);
	                            if (spikeEnable[0]) {
	                              line.drawLine(centerX, centerY, viewPixels[0], centerY, spikeWidth[0], spikeColor[0]);
	                            }
	                            if (spikeEnable[1]) {
	                              line.drawLine(centerX, centerY, centerX, viewPixels[1], spikeWidth[1], spikeColor[1]);
	                            }
	                            if (spikeEnable[2]) {
	                              line.drawLine(centerX, centerY, viewPixels[2], centerY, spikeWidth[2], spikeColor[2]);
	                            }
	                            if (spikeEnable[3]) {
	                              line.drawLine(centerX, centerY, centerX, viewPixels[3], spikeWidth[3], spikeColor[3]);
	                            }
	                          }
	                        };
	                        proto.dispose = function() {
	                          this.plot.removeOverlay(this);
	                        };
	                        function createSpikes2D(plot, options) {
	                          var spikes = new GLSpikes2D(plot);
	                          spikes.update(options);
	                          plot.addOverlay(spikes);
	                          return spikes;
	                        }
	                      }
	                    ),
	                    /***/
	                    3540: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_512120__) {
	                        var glslify = __nested_webpack_require_512120__(6832);
	                        var createShader = __nested_webpack_require_512120__(5158);
	                        var vertSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * view * model * vec4(vertexPosition, 1.0);\n  vec2 clipOffset = (projection * view * model * vec4(color, 0.0)).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"]);
	                        var fragSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"]);
	                        module3.exports = function(gl2) {
	                          return createShader(gl2, vertSrc, fragSrc, null, [{ name: "position", type: "vec3" }, { name: "color", type: "vec3" }, { name: "weight", type: "float" }]);
	                        };
	                      }
	                    ),
	                    /***/
	                    6496: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_513517__) {
	                        var createBuffer = __nested_webpack_require_513517__(5827);
	                        var createVAO = __nested_webpack_require_513517__(2944);
	                        var createShader = __nested_webpack_require_513517__(3540);
	                        module3.exports = createSpikes;
	                        var identity2 = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        function AxisSpikes(gl2, buffer, vao, shader) {
	                          this.gl = gl2;
	                          this.buffer = buffer;
	                          this.vao = vao;
	                          this.shader = shader;
	                          this.pixelRatio = 1;
	                          this.bounds = [[-1e3, -1e3, -1e3], [1e3, 1e3, 1e3]];
	                          this.position = [0, 0, 0];
	                          this.lineWidth = [2, 2, 2];
	                          this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.enabled = [true, true, true];
	                          this.drawSides = [true, true, true];
	                          this.axes = null;
	                        }
	                        var proto = AxisSpikes.prototype;
	                        var OUTER_FACE = [0, 0, 0];
	                        var INNER_FACE = [0, 0, 0];
	                        var SHAPE = [0, 0];
	                        proto.isTransparent = function() {
	                          return false;
	                        };
	                        proto.drawTransparent = function(camera) {
	                        };
	                        proto.draw = function(camera) {
	                          var gl2 = this.gl;
	                          var vao = this.vao;
	                          var shader = this.shader;
	                          vao.bind();
	                          shader.bind();
	                          var model = camera.model || identity2;
	                          var view = camera.view || identity2;
	                          var projection = camera.projection || identity2;
	                          var axis;
	                          if (this.axes) {
	                            axis = this.axes.lastCubeProps.axis;
	                          }
	                          var outerFace = OUTER_FACE;
	                          var innerFace = INNER_FACE;
	                          for (var i = 0; i < 3; ++i) {
	                            if (axis && axis[i] < 0) {
	                              outerFace[i] = this.bounds[0][i];
	                              innerFace[i] = this.bounds[1][i];
	                            } else {
	                              outerFace[i] = this.bounds[1][i];
	                              innerFace[i] = this.bounds[0][i];
	                            }
	                          }
	                          SHAPE[0] = gl2.drawingBufferWidth;
	                          SHAPE[1] = gl2.drawingBufferHeight;
	                          shader.uniforms.model = model;
	                          shader.uniforms.view = view;
	                          shader.uniforms.projection = projection;
	                          shader.uniforms.coordinates = [this.position, outerFace, innerFace];
	                          shader.uniforms.colors = this.colors;
	                          shader.uniforms.screenShape = SHAPE;
	                          for (var i = 0; i < 3; ++i) {
	                            shader.uniforms.lineWidth = this.lineWidth[i] * this.pixelRatio;
	                            if (this.enabled[i]) {
	                              vao.draw(gl2.TRIANGLES, 6, 6 * i);
	                              if (this.drawSides[i]) {
	                                vao.draw(gl2.TRIANGLES, 12, 18 + 12 * i);
	                              }
	                            }
	                          }
	                          vao.unbind();
	                        };
	                        proto.update = function(options) {
	                          if (!options) {
	                            return;
	                          }
	                          if ("bounds" in options) {
	                            this.bounds = options.bounds;
	                          }
	                          if ("position" in options) {
	                            this.position = options.position;
	                          }
	                          if ("lineWidth" in options) {
	                            this.lineWidth = options.lineWidth;
	                          }
	                          if ("colors" in options) {
	                            this.colors = options.colors;
	                          }
	                          if ("enabled" in options) {
	                            this.enabled = options.enabled;
	                          }
	                          if ("drawSides" in options) {
	                            this.drawSides = options.drawSides;
	                          }
	                        };
	                        proto.dispose = function() {
	                          this.vao.dispose();
	                          this.buffer.dispose();
	                          this.shader.dispose();
	                        };
	                        function createSpikes(gl2, options) {
	                          var data = [];
	                          function line(x, y, z, i, l, h) {
	                            var row = [x, y, z, 0, 0, 0, 1];
	                            row[i + 3] = 1;
	                            row[i] = l;
	                            data.push.apply(data, row);
	                            row[6] = -1;
	                            data.push.apply(data, row);
	                            row[i] = h;
	                            data.push.apply(data, row);
	                            data.push.apply(data, row);
	                            row[6] = 1;
	                            data.push.apply(data, row);
	                            row[i] = l;
	                            data.push.apply(data, row);
	                          }
	                          line(0, 0, 0, 0, 0, 1);
	                          line(0, 0, 0, 1, 0, 1);
	                          line(0, 0, 0, 2, 0, 1);
	                          line(1, 0, 0, 1, -1, 1);
	                          line(1, 0, 0, 2, -1, 1);
	                          line(0, 1, 0, 0, -1, 1);
	                          line(0, 1, 0, 2, -1, 1);
	                          line(0, 0, 1, 0, -1, 1);
	                          line(0, 0, 1, 1, -1, 1);
	                          var buffer = createBuffer(gl2, data);
	                          var vao = createVAO(gl2, [{ type: gl2.FLOAT, buffer, size: 3, offset: 0, stride: 28 }, { type: gl2.FLOAT, buffer, size: 3, offset: 12, stride: 28 }, { type: gl2.FLOAT, buffer, size: 1, offset: 24, stride: 28 }]);
	                          var shader = createShader(gl2);
	                          shader.attributes.position.location = 0;
	                          shader.attributes.color.location = 1;
	                          shader.attributes.weight.location = 2;
	                          var spikes = new AxisSpikes(gl2, buffer, vao, shader);
	                          spikes.update(options);
	                          return spikes;
	                        }
	                      }
	                    ),
	                    /***/
	                    9578: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_516827__) {
	                        var glslify = __nested_webpack_require_516827__(6832);
	                        var triVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]);
	                        var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]);
	                        var pickVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * view * tubePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]);
	                        var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
	                        exports2.meshShader = { vertex: triVertSrc, fragment: triFragSrc, attributes: [{ name: "position", type: "vec4" }, { name: "color", type: "vec4" }, { name: "uv", type: "vec2" }, { name: "vector", type: "vec4" }] };
	                        exports2.pickShader = { vertex: pickVertSrc, fragment: pickFragSrc, attributes: [{ name: "position", type: "vec4" }, { name: "id", type: "vec4" }, { name: "vector", type: "vec4" }] };
	                      }
	                    ),
	                    /***/
	                    7307: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_525348__) {
	                        var vec3 = __nested_webpack_require_525348__(2858);
	                        var vec4 = __nested_webpack_require_525348__(4020);
	                        var GRID_TYPES = ["xyz", "xzy", "yxz", "yzx", "zxy", "zyx"];
	                        var streamToTube = function(stream, maxDivergence, minDistance, maxNorm) {
	                          var points = stream.points;
	                          var velocities = stream.velocities;
	                          var divergences = stream.divergences;
	                          var verts = [];
	                          var faces = [];
	                          var vectors = [];
	                          var previousVerts = [];
	                          var currentVerts = [];
	                          var intensities = [];
	                          var previousIntensity = 0;
	                          var currentIntensity = 0;
	                          var currentVector = vec4.create();
	                          var previousVector = vec4.create();
	                          var facets = 8;
	                          for (var i = 0; i < points.length; i++) {
	                            var p = points[i];
	                            var fwd = velocities[i];
	                            var r = divergences[i];
	                            if (maxDivergence === 0) {
	                              r = minDistance * 0.05;
	                            }
	                            currentIntensity = vec3.length(fwd) / maxNorm;
	                            currentVector = vec4.create();
	                            vec3.copy(currentVector, fwd);
	                            currentVector[3] = r;
	                            for (var a = 0; a < facets; a++) {
	                              currentVerts[a] = [p[0], p[1], p[2], a];
	                            }
	                            if (previousVerts.length > 0) {
	                              for (var a = 0; a < facets; a++) {
	                                var a1 = (a + 1) % facets;
	                                verts.push(previousVerts[a], currentVerts[a], currentVerts[a1], currentVerts[a1], previousVerts[a1], previousVerts[a]);
	                                vectors.push(previousVector, currentVector, currentVector, currentVector, previousVector, previousVector);
	                                intensities.push(previousIntensity, currentIntensity, currentIntensity, currentIntensity, previousIntensity, previousIntensity);
	                                var len = verts.length;
	                                faces.push([len - 6, len - 5, len - 4], [len - 3, len - 2, len - 1]);
	                              }
	                            }
	                            var tmp1 = previousVerts;
	                            previousVerts = currentVerts;
	                            currentVerts = tmp1;
	                            var tmp2 = previousVector;
	                            previousVector = currentVector;
	                            currentVector = tmp2;
	                            var tmp3 = previousIntensity;
	                            previousIntensity = currentIntensity;
	                            currentIntensity = tmp3;
	                          }
	                          return { positions: verts, cells: faces, vectors, vertexIntensity: intensities };
	                        };
	                        var createTubes = function(streams, colormap, maxDivergence, minDistance) {
	                          var maxNorm = 0;
	                          for (var i = 0; i < streams.length; i++) {
	                            var velocities = streams[i].velocities;
	                            for (var j = 0; j < velocities.length; j++) {
	                              maxNorm = Math.max(maxNorm, vec3.length(velocities[j]));
	                            }
	                          }
	                          var tubes = streams.map(function(s) {
	                            return streamToTube(s, maxDivergence, minDistance, maxNorm);
	                          });
	                          var positions = [];
	                          var cells = [];
	                          var vectors = [];
	                          var vertexIntensity = [];
	                          for (var i = 0; i < tubes.length; i++) {
	                            var tube = tubes[i];
	                            var offset = positions.length;
	                            positions = positions.concat(tube.positions);
	                            vectors = vectors.concat(tube.vectors);
	                            vertexIntensity = vertexIntensity.concat(tube.vertexIntensity);
	                            for (var j = 0; j < tube.cells.length; j++) {
	                              var cell = tube.cells[j];
	                              var newCell = [];
	                              cells.push(newCell);
	                              for (var k = 0; k < cell.length; k++) {
	                                newCell.push(cell[k] + offset);
	                              }
	                            }
	                          }
	                          return { positions, cells, vectors, vertexIntensity, colormap };
	                        };
	                        var findLastSmallerIndex = function(points, v) {
	                          var len = points.length;
	                          var i;
	                          for (i = 0; i < len; i++) {
	                            var p = points[i];
	                            if (p === v) return i;
	                            else if (p > v) return i - 1;
	                          }
	                          return i;
	                        };
	                        var clamp = function(v, min, max) {
	                          return v < min ? min : v > max ? max : v;
	                        };
	                        var sampleMeshgrid = function(point, vectorField, gridInfo) {
	                          var vectors = vectorField.vectors;
	                          var meshgrid = vectorField.meshgrid;
	                          var x = point[0];
	                          var y = point[1];
	                          var z = point[2];
	                          var w = meshgrid[0].length;
	                          var h = meshgrid[1].length;
	                          var d = meshgrid[2].length;
	                          var x0 = findLastSmallerIndex(meshgrid[0], x);
	                          var y0 = findLastSmallerIndex(meshgrid[1], y);
	                          var z0 = findLastSmallerIndex(meshgrid[2], z);
	                          var x1 = x0 + 1;
	                          var y1 = y0 + 1;
	                          var z1 = z0 + 1;
	                          x0 = clamp(x0, 0, w - 1);
	                          x1 = clamp(x1, 0, w - 1);
	                          y0 = clamp(y0, 0, h - 1);
	                          y1 = clamp(y1, 0, h - 1);
	                          z0 = clamp(z0, 0, d - 1);
	                          z1 = clamp(z1, 0, d - 1);
	                          if (x0 < 0 || y0 < 0 || z0 < 0 || x1 > w - 1 || y1 > h - 1 || z1 > d - 1) {
	                            return vec3.create();
	                          }
	                          var mX0 = meshgrid[0][x0];
	                          var mX1 = meshgrid[0][x1];
	                          var mY0 = meshgrid[1][y0];
	                          var mY1 = meshgrid[1][y1];
	                          var mZ0 = meshgrid[2][z0];
	                          var mZ1 = meshgrid[2][z1];
	                          var xf = (x - mX0) / (mX1 - mX0);
	                          var yf = (y - mY0) / (mY1 - mY0);
	                          var zf = (z - mZ0) / (mZ1 - mZ0);
	                          if (!isFinite(xf)) xf = 0.5;
	                          if (!isFinite(yf)) yf = 0.5;
	                          if (!isFinite(zf)) zf = 0.5;
	                          var x0off;
	                          var x1off;
	                          var y0off;
	                          var y1off;
	                          var z0off;
	                          var z1off;
	                          if (gridInfo.reversedX) {
	                            x0 = w - 1 - x0;
	                            x1 = w - 1 - x1;
	                          }
	                          if (gridInfo.reversedY) {
	                            y0 = h - 1 - y0;
	                            y1 = h - 1 - y1;
	                          }
	                          if (gridInfo.reversedZ) {
	                            z0 = d - 1 - z0;
	                            z1 = d - 1 - z1;
	                          }
	                          switch (gridInfo.filled) {
	                            case 5:
	                              z0off = z0;
	                              z1off = z1;
	                              y0off = y0 * d;
	                              y1off = y1 * d;
	                              x0off = x0 * d * h;
	                              x1off = x1 * d * h;
	                              break;
	                            case 4:
	                              z0off = z0;
	                              z1off = z1;
	                              x0off = x0 * d;
	                              x1off = x1 * d;
	                              y0off = y0 * d * w;
	                              y1off = y1 * d * w;
	                              break;
	                            case 3:
	                              y0off = y0;
	                              y1off = y1;
	                              z0off = z0 * h;
	                              z1off = z1 * h;
	                              x0off = x0 * h * d;
	                              x1off = x1 * h * d;
	                              break;
	                            case 2:
	                              y0off = y0;
	                              y1off = y1;
	                              x0off = x0 * h;
	                              x1off = x1 * h;
	                              z0off = z0 * h * w;
	                              z1off = z1 * h * w;
	                              break;
	                            case 1:
	                              x0off = x0;
	                              x1off = x1;
	                              z0off = z0 * w;
	                              z1off = z1 * w;
	                              y0off = y0 * w * d;
	                              y1off = y1 * w * d;
	                              break;
	                            default:
	                              x0off = x0;
	                              x1off = x1;
	                              y0off = y0 * w;
	                              y1off = y1 * w;
	                              z0off = z0 * w * h;
	                              z1off = z1 * w * h;
	                              break;
	                          }
	                          var v000 = vectors[x0off + y0off + z0off];
	                          var v001 = vectors[x0off + y0off + z1off];
	                          var v010 = vectors[x0off + y1off + z0off];
	                          var v011 = vectors[x0off + y1off + z1off];
	                          var v100 = vectors[x1off + y0off + z0off];
	                          var v101 = vectors[x1off + y0off + z1off];
	                          var v110 = vectors[x1off + y1off + z0off];
	                          var v111 = vectors[x1off + y1off + z1off];
	                          var c00 = vec3.create();
	                          var c01 = vec3.create();
	                          var c10 = vec3.create();
	                          var c11 = vec3.create();
	                          vec3.lerp(c00, v000, v100, xf);
	                          vec3.lerp(c01, v001, v101, xf);
	                          vec3.lerp(c10, v010, v110, xf);
	                          vec3.lerp(c11, v011, v111, xf);
	                          var c0 = vec3.create();
	                          var c1 = vec3.create();
	                          vec3.lerp(c0, c00, c10, yf);
	                          vec3.lerp(c1, c01, c11, yf);
	                          var c = vec3.create();
	                          vec3.lerp(c, c0, c1, zf);
	                          return c;
	                        };
	                        var findMinSeparation = function(xs) {
	                          var minSeparation = Infinity;
	                          xs.sort(function(a, b) {
	                            return a - b;
	                          });
	                          var len = xs.length;
	                          for (var i = 1; i < len; i++) {
	                            var d = Math.abs(xs[i] - xs[i - 1]);
	                            if (d < minSeparation) {
	                              minSeparation = d;
	                            }
	                          }
	                          return minSeparation;
	                        };
	                        var calculateMinPositionDistance = function(positions) {
	                          var xs = [], ys = [], zs = [];
	                          var xi = {}, yi = {}, zi = {};
	                          var len = positions.length;
	                          for (var i = 0; i < len; i++) {
	                            var p = positions[i];
	                            var x = p[0], y = p[1], z = p[2];
	                            if (!xi[x]) {
	                              xs.push(x);
	                              xi[x] = true;
	                            }
	                            if (!yi[y]) {
	                              ys.push(y);
	                              yi[y] = true;
	                            }
	                            if (!zi[z]) {
	                              zs.push(z);
	                              zi[z] = true;
	                            }
	                          }
	                          var xSep = findMinSeparation(xs);
	                          var ySep = findMinSeparation(ys);
	                          var zSep = findMinSeparation(zs);
	                          var minSeparation = Math.min(xSep, ySep, zSep);
	                          return isFinite(minSeparation) ? minSeparation : 1;
	                        };
	                        module3.exports = function(vectorField, bounds) {
	                          var positions = vectorField.startingPositions;
	                          var maxLength = vectorField.maxLength || 1e3;
	                          var tubeSize = vectorField.tubeSize || 1;
	                          var absoluteTubeSize = vectorField.absoluteTubeSize;
	                          var gridFill = vectorField.gridFill || "+x+y+z";
	                          var gridInfo = {};
	                          if (gridFill.indexOf("-x") !== -1) {
	                            gridInfo.reversedX = true;
	                          }
	                          if (gridFill.indexOf("-y") !== -1) {
	                            gridInfo.reversedY = true;
	                          }
	                          if (gridFill.indexOf("-z") !== -1) {
	                            gridInfo.reversedZ = true;
	                          }
	                          gridInfo.filled = GRID_TYPES.indexOf(gridFill.replace(/-/g, "").replace(/\+/g, ""));
	                          var getVelocity = vectorField.getVelocity || function(p2) {
	                            return sampleMeshgrid(p2, vectorField, gridInfo);
	                          };
	                          var getDivergence = vectorField.getDivergence || function(p2, v0) {
	                            var dp = vec3.create();
	                            var e = 1e-4;
	                            vec3.add(dp, p2, [e, 0, 0]);
	                            var vx = getVelocity(dp);
	                            vec3.subtract(vx, vx, v0);
	                            vec3.scale(vx, vx, 1 / e);
	                            vec3.add(dp, p2, [0, e, 0]);
	                            var vy = getVelocity(dp);
	                            vec3.subtract(vy, vy, v0);
	                            vec3.scale(vy, vy, 1 / e);
	                            vec3.add(dp, p2, [0, 0, e]);
	                            var vz = getVelocity(dp);
	                            vec3.subtract(vz, vz, v0);
	                            vec3.scale(vz, vz, 1 / e);
	                            vec3.add(dp, vx, vy);
	                            vec3.add(dp, dp, vz);
	                            return dp;
	                          };
	                          var streams = [];
	                          var minX = bounds[0][0], minY = bounds[0][1], minZ = bounds[0][2];
	                          var maxX = bounds[1][0], maxY = bounds[1][1], maxZ = bounds[1][2];
	                          var inBounds = function(p2) {
	                            var x = p2[0];
	                            var y = p2[1];
	                            var z = p2[2];
	                            return !(x < minX || x > maxX || y < minY || y > maxY || z < minZ || z > maxZ);
	                          };
	                          var boundsSize = vec3.distance(bounds[0], bounds[1]);
	                          var maxStepSize = 10 * boundsSize / maxLength;
	                          var maxStepSizeSq = maxStepSize * maxStepSize;
	                          var minDistance = 1;
	                          var maxDivergence = 0;
	                          var len = positions.length;
	                          if (len > 1) {
	                            minDistance = calculateMinPositionDistance(positions);
	                          }
	                          for (var i = 0; i < len; i++) {
	                            var p = vec3.create();
	                            vec3.copy(p, positions[i]);
	                            var stream = [p];
	                            var velocities = [];
	                            var v = getVelocity(p);
	                            var op = p;
	                            velocities.push(v);
	                            var divergences = [];
	                            var dv = getDivergence(p, v);
	                            var dvLength = vec3.length(dv);
	                            if (isFinite(dvLength) && dvLength > maxDivergence) {
	                              maxDivergence = dvLength;
	                            }
	                            divergences.push(dvLength);
	                            streams.push({ points: stream, velocities, divergences });
	                            var j = 0;
	                            while (j < maxLength * 100 && stream.length < maxLength && inBounds(p)) {
	                              j++;
	                              var np = vec3.clone(v);
	                              var sqLen = vec3.squaredLength(np);
	                              if (sqLen === 0) {
	                                break;
	                              } else if (sqLen > maxStepSizeSq) {
	                                vec3.scale(np, np, maxStepSize / Math.sqrt(sqLen));
	                              }
	                              vec3.add(np, np, p);
	                              v = getVelocity(np);
	                              if (vec3.squaredDistance(op, np) - maxStepSizeSq > -1e-4 * maxStepSizeSq) {
	                                stream.push(np);
	                                op = np;
	                                velocities.push(v);
	                                var dv = getDivergence(np, v);
	                                var dvLength = vec3.length(dv);
	                                if (isFinite(dvLength) && dvLength > maxDivergence) {
	                                  maxDivergence = dvLength;
	                                }
	                                divergences.push(dvLength);
	                              }
	                              p = np;
	                            }
	                          }
	                          var tubes = createTubes(streams, vectorField.colormap, maxDivergence, minDistance);
	                          if (absoluteTubeSize) {
	                            tubes.tubeScale = absoluteTubeSize;
	                          } else {
	                            if (maxDivergence === 0) {
	                              maxDivergence = 1;
	                            }
	                            tubes.tubeScale = tubeSize * 0.5 * minDistance / maxDivergence;
	                          }
	                          return tubes;
	                        };
	                        var shaders = __nested_webpack_require_525348__(9578);
	                        var createMesh = __nested_webpack_require_525348__(1140).createMesh;
	                        module3.exports.createTubeMesh = function(gl2, params) {
	                          return createMesh(gl2, params, { shaders, traceType: "streamtube" });
	                        };
	                      }
	                    ),
	                    /***/
	                    9054: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_536673__) {
	                        var createShader = __nested_webpack_require_536673__(5158);
	                        var glslify = __nested_webpack_require_536673__(6832);
	                        var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n  vec4 clipPosition = projection * view * worldPosition;\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"]);
	                        var fragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if (\n    kill > 0.0 ||\n    vColor.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)\n  ) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color — in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"]);
	                        var contourVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n\n  vec4 clipPosition = projection * view * worldPosition;\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"]);
	                        var pickSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"]);
	                        exports2.createShader = function(gl2) {
	                          var shader = createShader(gl2, vertSrc, fragSrc, null, [{ name: "uv", type: "vec4" }, { name: "f", type: "vec3" }, { name: "normal", type: "vec3" }]);
	                          shader.attributes.uv.location = 0;
	                          shader.attributes.f.location = 1;
	                          shader.attributes.normal.location = 2;
	                          return shader;
	                        };
	                        exports2.createPickShader = function(gl2) {
	                          var shader = createShader(gl2, vertSrc, pickSrc, null, [{ name: "uv", type: "vec4" }, { name: "f", type: "vec3" }, { name: "normal", type: "vec3" }]);
	                          shader.attributes.uv.location = 0;
	                          shader.attributes.f.location = 1;
	                          shader.attributes.normal.location = 2;
	                          return shader;
	                        };
	                        exports2.createContourShader = function(gl2) {
	                          var shader = createShader(gl2, contourVertSrc, fragSrc, null, [{ name: "uv", type: "vec4" }, { name: "f", type: "float" }]);
	                          shader.attributes.uv.location = 0;
	                          shader.attributes.f.location = 1;
	                          return shader;
	                        };
	                        exports2.createPickContourShader = function(gl2) {
	                          var shader = createShader(gl2, contourVertSrc, pickSrc, null, [{ name: "uv", type: "vec4" }, { name: "f", type: "float" }]);
	                          shader.attributes.uv.location = 0;
	                          shader.attributes.f.location = 1;
	                          return shader;
	                        };
	                      }
	                    ),
	                    /***/
	                    3754: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_543637__) {
	                        module3.exports = createSurfacePlot;
	                        var bits = __nested_webpack_require_543637__(2288);
	                        var createBuffer = __nested_webpack_require_543637__(5827);
	                        var createVAO = __nested_webpack_require_543637__(2944);
	                        var createTexture = __nested_webpack_require_543637__(8931);
	                        var pool = __nested_webpack_require_543637__(5306);
	                        var colormap = __nested_webpack_require_543637__(9156);
	                        var ops = __nested_webpack_require_543637__(7498);
	                        var pack = __nested_webpack_require_543637__(7382);
	                        var ndarray = __nested_webpack_require_543637__(5050);
	                        var surfaceNets = __nested_webpack_require_543637__(4162);
	                        var multiply = __nested_webpack_require_543637__(104);
	                        var invert = __nested_webpack_require_543637__(7437);
	                        var bsearch = __nested_webpack_require_543637__(5070);
	                        var gradient = __nested_webpack_require_543637__(9144);
	                        var shaders = __nested_webpack_require_543637__(9054);
	                        var createShader = shaders.createShader;
	                        var createContourShader = shaders.createContourShader;
	                        var createPickShader = shaders.createPickShader;
	                        var createPickContourShader = shaders.createPickContourShader;
	                        var SURFACE_VERTEX_SIZE = 4 * (4 + 3 + 3);
	                        var IDENTITY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                        var QUAD = [[0, 0], [0, 1], [1, 0], [1, 1], [1, 0], [0, 1]];
	                        var PERMUTATIONS = [[0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0]];
	                        (function() {
	                          for (var i = 0; i < 3; ++i) {
	                            var p = PERMUTATIONS[i];
	                            var u = (i + 1) % 3;
	                            var v = (i + 2) % 3;
	                            p[u + 0] = 1;
	                            p[v + 3] = 1;
	                            p[i + 6] = 1;
	                          }
	                        })();
	                        function SurfacePickResult(position, index, uv, level, dataCoordinate) {
	                          this.position = position;
	                          this.index = index;
	                          this.uv = uv;
	                          this.level = level;
	                          this.dataCoordinate = dataCoordinate;
	                        }
	                        var N_COLORS = 256;
	                        function SurfacePlot(gl2, shape, bounds, shader, pickShader, coordinates, vao, colorMap, contourShader, contourPickShader, contourBuffer, contourVAO, dynamicBuffer, dynamicVAO, objectOffset) {
	                          this.gl = gl2;
	                          this.shape = shape;
	                          this.bounds = bounds;
	                          this.objectOffset = objectOffset;
	                          this.intensityBounds = [];
	                          this._shader = shader;
	                          this._pickShader = pickShader;
	                          this._coordinateBuffer = coordinates;
	                          this._vao = vao;
	                          this._colorMap = colorMap;
	                          this._contourShader = contourShader;
	                          this._contourPickShader = contourPickShader;
	                          this._contourBuffer = contourBuffer;
	                          this._contourVAO = contourVAO;
	                          this._contourOffsets = [[], [], []];
	                          this._contourCounts = [[], [], []];
	                          this._vertexCount = 0;
	                          this._pickResult = new SurfacePickResult([0, 0, 0], [0, 0], [0, 0], [0, 0, 0], [0, 0, 0]);
	                          this._dynamicBuffer = dynamicBuffer;
	                          this._dynamicVAO = dynamicVAO;
	                          this._dynamicOffsets = [0, 0, 0];
	                          this._dynamicCounts = [0, 0, 0];
	                          this.contourWidth = [1, 1, 1];
	                          this.contourLevels = [[1], [1], [1]];
	                          this.contourTint = [0, 0, 0];
	                          this.contourColor = [[0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1]];
	                          this.showContour = true;
	                          this.showSurface = true;
	                          this.enableHighlight = [true, true, true];
	                          this.highlightColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.highlightTint = [1, 1, 1];
	                          this.highlightLevel = [-1, -1, -1];
	                          this.enableDynamic = [true, true, true];
	                          this.dynamicLevel = [NaN, NaN, NaN];
	                          this.dynamicColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]];
	                          this.dynamicTint = [1, 1, 1];
	                          this.dynamicWidth = [1, 1, 1];
	                          this.axesBounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]];
	                          this.surfaceProject = [false, false, false];
	                          this.contourProject = [[false, false, false], [false, false, false], [false, false, false]];
	                          this.colorBounds = [false, false];
	                          this._field = [ndarray(pool.mallocFloat(1024), [0, 0]), ndarray(pool.mallocFloat(1024), [0, 0]), ndarray(pool.mallocFloat(1024), [0, 0])];
	                          this.pickId = 1;
	                          this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]];
	                          this.snapToData = false;
	                          this.pixelRatio = 1;
	                          this.opacity = 1;
	                          this.lightPosition = [10, 1e4, 0];
	                          this.ambientLight = 0.8;
	                          this.diffuseLight = 0.8;
	                          this.specularLight = 2;
	                          this.roughness = 0.5;
	                          this.fresnel = 1.5;
	                          this.vertexColor = 0;
	                          this.dirty = true;
	                        }
	                        var proto = SurfacePlot.prototype;
	                        proto.genColormap = function(name2, opacityscale) {
	                          var hasAlpha = false;
	                          var x = pack([colormap({ colormap: name2, nshades: N_COLORS, format: "rgba" }).map(function(c, i) {
	                            var a = opacityscale ? getOpacityFromScale(i / 255, opacityscale) : c[3];
	                            if (a < 1) hasAlpha = true;
	                            return [c[0], c[1], c[2], 255 * a];
	                          })]);
	                          ops.divseq(x, 255);
	                          this.hasAlphaScale = hasAlpha;
	                          return x;
	                        };
	                        proto.isTransparent = function() {
	                          return this.opacity < 1 || this.hasAlphaScale;
	                        };
	                        proto.isOpaque = function() {
	                          return !this.isTransparent();
	                        };
	                        proto.pickSlots = 1;
	                        proto.setPickBase = function(id) {
	                          this.pickId = id;
	                        };
	                        function getOpacityFromScale(ratio, opacityscale) {
	                          if (!opacityscale) return 1;
	                          if (!opacityscale.length) return 1;
	                          for (var i = 0; i < opacityscale.length; ++i) {
	                            if (opacityscale.length < 2) return 1;
	                            if (opacityscale[i][0] === ratio) return opacityscale[i][1];
	                            if (opacityscale[i][0] > ratio && i > 0) {
	                              var d = (opacityscale[i][0] - ratio) / (opacityscale[i][0] - opacityscale[i - 1][0]);
	                              return opacityscale[i][1] * (1 - d) + d * opacityscale[i - 1][1];
	                            }
	                          }
	                          return 1;
	                        }
	                        var ZERO_VEC = [0, 0, 0];
	                        var PROJECT_DATA = { showSurface: false, showContour: false, projections: [IDENTITY.slice(), IDENTITY.slice(), IDENTITY.slice()], clipBounds: [[[0, 0, 0], [0, 0, 0]], [[0, 0, 0], [0, 0, 0]], [[0, 0, 0], [0, 0, 0]]] };
	                        function computeProjectionData(camera, obj) {
	                          var i, j, k;
	                          var cubeAxis = obj.axes && obj.axes.lastCubeProps.axis || ZERO_VEC;
	                          var showSurface = obj.showSurface;
	                          var showContour = obj.showContour;
	                          for (i = 0; i < 3; ++i) {
	                            showSurface = showSurface || obj.surfaceProject[i];
	                            for (j = 0; j < 3; ++j) {
	                              showContour = showContour || obj.contourProject[i][j];
	                            }
	                          }
	                          for (i = 0; i < 3; ++i) {
	                            var axisSquish = PROJECT_DATA.projections[i];
	                            for (j = 0; j < 16; ++j) {
	                              axisSquish[j] = 0;
	                            }
	                            for (j = 0; j < 4; ++j) {
	                              axisSquish[5 * j] = 1;
	                            }
	                            axisSquish[5 * i] = 0;
	                            axisSquish[12 + i] = obj.axesBounds[+(cubeAxis[i] > 0)][i];
	                            multiply(axisSquish, camera.model, axisSquish);
	                            var nclipBounds = PROJECT_DATA.clipBounds[i];
	                            for (k = 0; k < 2; ++k) {
	                              for (j = 0; j < 3; ++j) {
	                                nclipBounds[k][j] = camera.clipBounds[k][j];
	                              }
	                            }
	                            nclipBounds[0][i] = -1e8;
	                            nclipBounds[1][i] = 1e8;
	                          }
	                          PROJECT_DATA.showSurface = showSurface;
	                          PROJECT_DATA.showContour = showContour;
	                          return PROJECT_DATA;
	                        }
	                        var UNIFORMS = { model: IDENTITY, view: IDENTITY, projection: IDENTITY, inverseModel: IDENTITY.slice(), lowerBound: [0, 0, 0], upperBound: [0, 0, 0], colorMap: 0, clipBounds: [[0, 0, 0], [0, 0, 0]], height: 0, contourTint: 0, contourColor: [0, 0, 0, 1], permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1], zOffset: -1e-4, objectOffset: [0, 0, 0], kambient: 1, kdiffuse: 1, kspecular: 1, lightPosition: [1e3, 1e3, 1e3], eyePosition: [0, 0, 0], roughness: 1, fresnel: 1, opacity: 1, vertexColor: 0 };
	                        var MATRIX_INVERSE = IDENTITY.slice();
	                        var DEFAULT_PERM = [1, 0, 0, 0, 1, 0, 0, 0, 1];
	                        function drawCore(params, transparent) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          gl2.disable(gl2.CULL_FACE);
	                          this._colorMap.bind(0);
	                          var uniforms = UNIFORMS;
	                          uniforms.model = params.model || IDENTITY;
	                          uniforms.view = params.view || IDENTITY;
	                          uniforms.projection = params.projection || IDENTITY;
	                          uniforms.lowerBound = [this.bounds[0][0], this.bounds[0][1], this.colorBounds[0] || this.bounds[0][2]];
	                          uniforms.upperBound = [this.bounds[1][0], this.bounds[1][1], this.colorBounds[1] || this.bounds[1][2]];
	                          uniforms.objectOffset = this.objectOffset;
	                          uniforms.contourColor = this.contourColor[0];
	                          uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model);
	                          for (var i = 0; i < 2; ++i) {
	                            var clipClamped = uniforms.clipBounds[i];
	                            for (var j = 0; j < 3; ++j) {
	                              clipClamped[j] = Math.min(Math.max(this.clipBounds[i][j], -1e8), 1e8);
	                            }
	                          }
	                          uniforms.kambient = this.ambientLight;
	                          uniforms.kdiffuse = this.diffuseLight;
	                          uniforms.kspecular = this.specularLight;
	                          uniforms.roughness = this.roughness;
	                          uniforms.fresnel = this.fresnel;
	                          uniforms.opacity = this.opacity;
	                          uniforms.height = 0;
	                          uniforms.permutation = DEFAULT_PERM;
	                          uniforms.vertexColor = this.vertexColor;
	                          var invCameraMatrix = MATRIX_INVERSE;
	                          multiply(invCameraMatrix, uniforms.view, uniforms.model);
	                          multiply(invCameraMatrix, uniforms.projection, invCameraMatrix);
	                          invert(invCameraMatrix, invCameraMatrix);
	                          for (i = 0; i < 3; ++i) {
	                            uniforms.eyePosition[i] = invCameraMatrix[12 + i] / invCameraMatrix[15];
	                          }
	                          var w = invCameraMatrix[15];
	                          for (i = 0; i < 3; ++i) {
	                            w += this.lightPosition[i] * invCameraMatrix[4 * i + 3];
	                          }
	                          for (i = 0; i < 3; ++i) {
	                            var s = invCameraMatrix[12 + i];
	                            for (j = 0; j < 3; ++j) {
	                              s += invCameraMatrix[4 * j + i] * this.lightPosition[j];
	                            }
	                            uniforms.lightPosition[i] = s / w;
	                          }
	                          var projectData = computeProjectionData(uniforms, this);
	                          if (projectData.showSurface) {
	                            this._shader.bind();
	                            this._shader.uniforms = uniforms;
	                            this._vao.bind();
	                            if (this.showSurface && this._vertexCount) {
	                              this._vao.draw(gl2.TRIANGLES, this._vertexCount);
	                            }
	                            for (i = 0; i < 3; ++i) {
	                              if (!this.surfaceProject[i] || !this.vertexCount) {
	                                continue;
	                              }
	                              this._shader.uniforms.model = projectData.projections[i];
	                              this._shader.uniforms.clipBounds = projectData.clipBounds[i];
	                              this._vao.draw(gl2.TRIANGLES, this._vertexCount);
	                            }
	                            this._vao.unbind();
	                          }
	                          if (projectData.showContour) {
	                            var shader = this._contourShader;
	                            uniforms.kambient = 1;
	                            uniforms.kdiffuse = 0;
	                            uniforms.kspecular = 0;
	                            uniforms.opacity = 1;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            var vao = this._contourVAO;
	                            vao.bind();
	                            for (i = 0; i < 3; ++i) {
	                              shader.uniforms.permutation = PERMUTATIONS[i];
	                              gl2.lineWidth(this.contourWidth[i] * this.pixelRatio);
	                              for (j = 0; j < this.contourLevels[i].length; ++j) {
	                                if (j === this.highlightLevel[i]) {
	                                  shader.uniforms.contourColor = this.highlightColor[i];
	                                  shader.uniforms.contourTint = this.highlightTint[i];
	                                } else if (j === 0 || j - 1 === this.highlightLevel[i]) {
	                                  shader.uniforms.contourColor = this.contourColor[i];
	                                  shader.uniforms.contourTint = this.contourTint[i];
	                                }
	                                if (!this._contourCounts[i][j]) {
	                                  continue;
	                                }
	                                shader.uniforms.height = this.contourLevels[i][j];
	                                vao.draw(gl2.LINES, this._contourCounts[i][j], this._contourOffsets[i][j]);
	                              }
	                            }
	                            for (i = 0; i < 3; ++i) {
	                              shader.uniforms.model = projectData.projections[i];
	                              shader.uniforms.clipBounds = projectData.clipBounds[i];
	                              for (j = 0; j < 3; ++j) {
	                                if (!this.contourProject[i][j]) {
	                                  continue;
	                                }
	                                shader.uniforms.permutation = PERMUTATIONS[j];
	                                gl2.lineWidth(this.contourWidth[j] * this.pixelRatio);
	                                for (var k = 0; k < this.contourLevels[j].length; ++k) {
	                                  if (k === this.highlightLevel[j]) {
	                                    shader.uniforms.contourColor = this.highlightColor[j];
	                                    shader.uniforms.contourTint = this.highlightTint[j];
	                                  } else if (k === 0 || k - 1 === this.highlightLevel[j]) {
	                                    shader.uniforms.contourColor = this.contourColor[j];
	                                    shader.uniforms.contourTint = this.contourTint[j];
	                                  }
	                                  if (!this._contourCounts[j][k]) {
	                                    continue;
	                                  }
	                                  shader.uniforms.height = this.contourLevels[j][k];
	                                  vao.draw(gl2.LINES, this._contourCounts[j][k], this._contourOffsets[j][k]);
	                                }
	                              }
	                            }
	                            vao.unbind();
	                            vao = this._dynamicVAO;
	                            vao.bind();
	                            for (i = 0; i < 3; ++i) {
	                              if (this._dynamicCounts[i] === 0) {
	                                continue;
	                              }
	                              shader.uniforms.model = uniforms.model;
	                              shader.uniforms.clipBounds = uniforms.clipBounds;
	                              shader.uniforms.permutation = PERMUTATIONS[i];
	                              gl2.lineWidth(this.dynamicWidth[i] * this.pixelRatio);
	                              shader.uniforms.contourColor = this.dynamicColor[i];
	                              shader.uniforms.contourTint = this.dynamicTint[i];
	                              shader.uniforms.height = this.dynamicLevel[i];
	                              vao.draw(gl2.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]);
	                              for (j = 0; j < 3; ++j) {
	                                if (!this.contourProject[j][i]) {
	                                  continue;
	                                }
	                                shader.uniforms.model = projectData.projections[j];
	                                shader.uniforms.clipBounds = projectData.clipBounds[j];
	                                vao.draw(gl2.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]);
	                              }
	                            }
	                            vao.unbind();
	                          }
	                        }
	                        proto.draw = function(params) {
	                          return drawCore.call(this, params, false);
	                        };
	                        proto.drawTransparent = function(params) {
	                          return drawCore.call(this, params, true);
	                        };
	                        var PICK_UNIFORMS = { model: IDENTITY, view: IDENTITY, projection: IDENTITY, inverseModel: IDENTITY, clipBounds: [[0, 0, 0], [0, 0, 0]], height: 0, shape: [0, 0], pickId: 0, lowerBound: [0, 0, 0], upperBound: [0, 0, 0], zOffset: 0, objectOffset: [0, 0, 0], permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1], lightPosition: [0, 0, 0], eyePosition: [0, 0, 0] };
	                        proto.drawPick = function(params) {
	                          params = params || {};
	                          var gl2 = this.gl;
	                          gl2.disable(gl2.CULL_FACE);
	                          var uniforms = PICK_UNIFORMS;
	                          uniforms.model = params.model || IDENTITY;
	                          uniforms.view = params.view || IDENTITY;
	                          uniforms.projection = params.projection || IDENTITY;
	                          uniforms.shape = this._field[2].shape;
	                          uniforms.pickId = this.pickId / 255;
	                          uniforms.lowerBound = this.bounds[0];
	                          uniforms.upperBound = this.bounds[1];
	                          uniforms.objectOffset = this.objectOffset;
	                          uniforms.permutation = DEFAULT_PERM;
	                          for (var i = 0; i < 2; ++i) {
	                            var clipClamped = uniforms.clipBounds[i];
	                            for (var j = 0; j < 3; ++j) {
	                              clipClamped[j] = Math.min(Math.max(this.clipBounds[i][j], -1e8), 1e8);
	                            }
	                          }
	                          var projectData = computeProjectionData(uniforms, this);
	                          if (projectData.showSurface) {
	                            this._pickShader.bind();
	                            this._pickShader.uniforms = uniforms;
	                            this._vao.bind();
	                            this._vao.draw(gl2.TRIANGLES, this._vertexCount);
	                            for (i = 0; i < 3; ++i) {
	                              if (!this.surfaceProject[i]) {
	                                continue;
	                              }
	                              this._pickShader.uniforms.model = projectData.projections[i];
	                              this._pickShader.uniforms.clipBounds = projectData.clipBounds[i];
	                              this._vao.draw(gl2.TRIANGLES, this._vertexCount);
	                            }
	                            this._vao.unbind();
	                          }
	                          if (projectData.showContour) {
	                            var shader = this._contourPickShader;
	                            shader.bind();
	                            shader.uniforms = uniforms;
	                            var vao = this._contourVAO;
	                            vao.bind();
	                            for (j = 0; j < 3; ++j) {
	                              gl2.lineWidth(this.contourWidth[j] * this.pixelRatio);
	                              shader.uniforms.permutation = PERMUTATIONS[j];
	                              for (i = 0; i < this.contourLevels[j].length; ++i) {
	                                if (this._contourCounts[j][i]) {
	                                  shader.uniforms.height = this.contourLevels[j][i];
	                                  vao.draw(gl2.LINES, this._contourCounts[j][i], this._contourOffsets[j][i]);
	                                }
	                              }
	                            }
	                            for (i = 0; i < 3; ++i) {
	                              shader.uniforms.model = projectData.projections[i];
	                              shader.uniforms.clipBounds = projectData.clipBounds[i];
	                              for (j = 0; j < 3; ++j) {
	                                if (!this.contourProject[i][j]) {
	                                  continue;
	                                }
	                                shader.uniforms.permutation = PERMUTATIONS[j];
	                                gl2.lineWidth(this.contourWidth[j] * this.pixelRatio);
	                                for (var k = 0; k < this.contourLevels[j].length; ++k) {
	                                  if (this._contourCounts[j][k]) {
	                                    shader.uniforms.height = this.contourLevels[j][k];
	                                    vao.draw(gl2.LINES, this._contourCounts[j][k], this._contourOffsets[j][k]);
	                                  }
	                                }
	                              }
	                            }
	                            vao.unbind();
	                          }
	                        };
	                        proto.pick = function(selection) {
	                          if (!selection) {
	                            return null;
	                          }
	                          if (selection.id !== this.pickId) {
	                            return null;
	                          }
	                          var shape = this._field[2].shape;
	                          var result = this._pickResult;
	                          var x = shape[0] * (selection.value[0] + (selection.value[2] >> 4) / 16) / 255;
	                          var ix = Math.floor(x);
	                          var fx = x - ix;
	                          var y = shape[1] * (selection.value[1] + (selection.value[2] & 15) / 16) / 255;
	                          var iy = Math.floor(y);
	                          var fy = y - iy;
	                          ix += 1;
	                          iy += 1;
	                          var pos = result.position;
	                          pos[0] = pos[1] = pos[2] = 0;
	                          for (var dx = 0; dx < 2; ++dx) {
	                            var s = dx ? fx : 1 - fx;
	                            for (var dy = 0; dy < 2; ++dy) {
	                              var t = dy ? fy : 1 - fy;
	                              var r = ix + dx;
	                              var c = iy + dy;
	                              var w = s * t;
	                              for (var i = 0; i < 3; ++i) {
	                                pos[i] += this._field[i].get(r, c) * w;
	                              }
	                            }
	                          }
	                          var levelIndex = this._pickResult.level;
	                          for (var j = 0; j < 3; ++j) {
	                            levelIndex[j] = bsearch.le(this.contourLevels[j], pos[j]);
	                            if (levelIndex[j] < 0) {
	                              if (this.contourLevels[j].length > 0) {
	                                levelIndex[j] = 0;
	                              }
	                            } else if (levelIndex[j] < this.contourLevels[j].length - 1) {
	                              var a = this.contourLevels[j][levelIndex[j]];
	                              var b = this.contourLevels[j][levelIndex[j] + 1];
	                              if (Math.abs(a - pos[j]) > Math.abs(b - pos[j])) {
	                                levelIndex[j] += 1;
	                              }
	                            }
	                          }
	                          result.index[0] = fx < 0.5 ? ix : ix + 1;
	                          result.index[1] = fy < 0.5 ? iy : iy + 1;
	                          result.uv[0] = x / shape[0];
	                          result.uv[1] = y / shape[1];
	                          for (i = 0; i < 3; ++i) {
	                            result.dataCoordinate[i] = this._field[i].get(result.index[0], result.index[1]);
	                          }
	                          return result;
	                        };
	                        proto.padField = function(dstField, srcField) {
	                          var srcShape = srcField.shape.slice();
	                          var dstShape = dstField.shape.slice();
	                          ops.assign(dstField.lo(1, 1).hi(srcShape[0], srcShape[1]), srcField);
	                          ops.assign(dstField.lo(1).hi(srcShape[0], 1), srcField.hi(srcShape[0], 1));
	                          ops.assign(dstField.lo(1, dstShape[1] - 1).hi(srcShape[0], 1), srcField.lo(0, srcShape[1] - 1).hi(srcShape[0], 1));
	                          ops.assign(dstField.lo(0, 1).hi(1, srcShape[1]), srcField.hi(1));
	                          ops.assign(dstField.lo(dstShape[0] - 1, 1).hi(1, srcShape[1]), srcField.lo(srcShape[0] - 1));
	                          dstField.set(0, 0, srcField.get(0, 0));
	                          dstField.set(0, dstShape[1] - 1, srcField.get(0, srcShape[1] - 1));
	                          dstField.set(dstShape[0] - 1, 0, srcField.get(srcShape[0] - 1, 0));
	                          dstField.set(dstShape[0] - 1, dstShape[1] - 1, srcField.get(srcShape[0] - 1, srcShape[1] - 1));
	                        };
	                        function handleArray(param, ctor) {
	                          if (Array.isArray(param)) {
	                            return [ctor(param[0]), ctor(param[1]), ctor(param[2])];
	                          }
	                          return [ctor(param), ctor(param), ctor(param)];
	                        }
	                        function toColor(x) {
	                          if (Array.isArray(x)) {
	                            if (x.length === 3) {
	                              return [x[0], x[1], x[2], 1];
	                            }
	                            return [x[0], x[1], x[2], x[3]];
	                          }
	                          return [0, 0, 0, 1];
	                        }
	                        function handleColor(param) {
	                          if (Array.isArray(param)) {
	                            if (Array.isArray(param)) {
	                              return [toColor(param[0]), toColor(param[1]), toColor(param[2])];
	                            } else {
	                              var c = toColor(param);
	                              return [c.slice(), c.slice(), c.slice()];
	                            }
	                          }
	                        }
	                        proto.update = function(params) {
	                          params = params || {};
	                          this.objectOffset = params.objectOffset || this.objectOffset;
	                          this.dirty = true;
	                          if ("contourWidth" in params) {
	                            this.contourWidth = handleArray(params.contourWidth, Number);
	                          }
	                          if ("showContour" in params) {
	                            this.showContour = handleArray(params.showContour, Boolean);
	                          }
	                          if ("showSurface" in params) {
	                            this.showSurface = !!params.showSurface;
	                          }
	                          if ("contourTint" in params) {
	                            this.contourTint = handleArray(params.contourTint, Boolean);
	                          }
	                          if ("contourColor" in params) {
	                            this.contourColor = handleColor(params.contourColor);
	                          }
	                          if ("contourProject" in params) {
	                            this.contourProject = handleArray(params.contourProject, function(x2) {
	                              return handleArray(x2, Boolean);
	                            });
	                          }
	                          if ("surfaceProject" in params) {
	                            this.surfaceProject = params.surfaceProject;
	                          }
	                          if ("dynamicColor" in params) {
	                            this.dynamicColor = handleColor(params.dynamicColor);
	                          }
	                          if ("dynamicTint" in params) {
	                            this.dynamicTint = handleArray(params.dynamicTint, Number);
	                          }
	                          if ("dynamicWidth" in params) {
	                            this.dynamicWidth = handleArray(params.dynamicWidth, Number);
	                          }
	                          if ("opacity" in params) {
	                            this.opacity = params.opacity;
	                          }
	                          if ("opacityscale" in params) {
	                            this.opacityscale = params.opacityscale;
	                          }
	                          if ("colorBounds" in params) {
	                            this.colorBounds = params.colorBounds;
	                          }
	                          if ("vertexColor" in params) {
	                            this.vertexColor = params.vertexColor ? 1 : 0;
	                          }
	                          if ("colormap" in params) {
	                            this._colorMap.setPixels(this.genColormap(params.colormap, this.opacityscale));
	                          }
	                          var field = params.field || params.coords && params.coords[2] || null;
	                          var levelsChanged = false;
	                          if (!field) {
	                            if (this._field[2].shape[0] || this._field[2].shape[2]) {
	                              field = this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2);
	                            } else {
	                              field = this._field[2].hi(0, 0);
	                            }
	                          }
	                          if ("field" in params || "coords" in params) {
	                            var fsize = (field.shape[0] + 2) * (field.shape[1] + 2);
	                            if (fsize > this._field[2].data.length) {
	                              pool.freeFloat(this._field[2].data);
	                              this._field[2].data = pool.mallocFloat(bits.nextPow2(fsize));
	                            }
	                            this._field[2] = ndarray(this._field[2].data, [field.shape[0] + 2, field.shape[1] + 2]);
	                            this.padField(this._field[2], field);
	                            this.shape = field.shape.slice();
	                            var shape = this.shape;
	                            for (var i = 0; i < 2; ++i) {
	                              if (this._field[2].size > this._field[i].data.length) {
	                                pool.freeFloat(this._field[i].data);
	                                this._field[i].data = pool.mallocFloat(this._field[2].size);
	                              }
	                              this._field[i] = ndarray(this._field[i].data, [shape[0] + 2, shape[1] + 2]);
	                            }
	                            if (params.coords) {
	                              var coords = params.coords;
	                              if (!Array.isArray(coords) || coords.length !== 3) {
	                                throw new Error("gl-surface: invalid coordinates for x/y");
	                              }
	                              for (i = 0; i < 2; ++i) {
	                                var coord = coords[i];
	                                for (j = 0; j < 2; ++j) {
	                                  if (coord.shape[j] !== shape[j]) {
	                                    throw new Error("gl-surface: coords have incorrect shape");
	                                  }
	                                }
	                                this.padField(this._field[i], coord);
	                              }
	                            } else if (params.ticks) {
	                              var ticks = params.ticks;
	                              if (!Array.isArray(ticks) || ticks.length !== 2) {
	                                throw new Error("gl-surface: invalid ticks");
	                              }
	                              for (i = 0; i < 2; ++i) {
	                                var tick = ticks[i];
	                                if (Array.isArray(tick) || tick.length) {
	                                  tick = ndarray(tick);
	                                }
	                                if (tick.shape[0] !== shape[i]) {
	                                  throw new Error("gl-surface: invalid tick length");
	                                }
	                                var tick2 = ndarray(tick.data, shape);
	                                tick2.stride[i] = tick.stride[0];
	                                tick2.stride[i ^ 1] = 0;
	                                this.padField(this._field[i], tick2);
	                              }
	                            } else {
	                              for (i = 0; i < 2; ++i) {
	                                var offset = [0, 0];
	                                offset[i] = 1;
	                                this._field[i] = ndarray(this._field[i].data, [shape[0] + 2, shape[1] + 2], offset, 0);
	                              }
	                              this._field[0].set(0, 0, 0);
	                              for (var j = 0; j < shape[0]; ++j) {
	                                this._field[0].set(j + 1, 0, j);
	                              }
	                              this._field[0].set(shape[0] + 1, 0, shape[0] - 1);
	                              this._field[1].set(0, 0, 0);
	                              for (j = 0; j < shape[1]; ++j) {
	                                this._field[1].set(0, j + 1, j);
	                              }
	                              this._field[1].set(0, shape[1] + 1, shape[1] - 1);
	                            }
	                            var fields = this._field;
	                            var dfields = ndarray(pool.mallocFloat(fields[2].size * 3 * 2), [3, shape[0] + 2, shape[1] + 2, 2]);
	                            for (i = 0; i < 3; ++i) {
	                              gradient(dfields.pick(i), fields[i], "mirror");
	                            }
	                            var normals = ndarray(pool.mallocFloat(fields[2].size * 3), [shape[0] + 2, shape[1] + 2, 3]);
	                            for (i = 0; i < shape[0] + 2; ++i) {
	                              for (j = 0; j < shape[1] + 2; ++j) {
	                                var dxdu = dfields.get(0, i, j, 0);
	                                var dxdv = dfields.get(0, i, j, 1);
	                                var dydu = dfields.get(1, i, j, 0);
	                                var dydv = dfields.get(1, i, j, 1);
	                                var dzdu = dfields.get(2, i, j, 0);
	                                var dzdv = dfields.get(2, i, j, 1);
	                                var nx = dydu * dzdv - dydv * dzdu;
	                                var ny = dzdu * dxdv - dzdv * dxdu;
	                                var nz = dxdu * dydv - dxdv * dydu;
	                                var nl = Math.sqrt(nx * nx + ny * ny + nz * nz);
	                                if (nl < 1e-8) {
	                                  nl = Math.max(Math.abs(nx), Math.abs(ny), Math.abs(nz));
	                                  if (nl < 1e-8) {
	                                    nz = 1;
	                                    ny = nx = 0;
	                                    nl = 1;
	                                  } else {
	                                    nl = 1 / nl;
	                                  }
	                                } else {
	                                  nl = 1 / Math.sqrt(nl);
	                                }
	                                normals.set(i, j, 0, nx * nl);
	                                normals.set(i, j, 1, ny * nl);
	                                normals.set(i, j, 2, nz * nl);
	                              }
	                            }
	                            pool.free(dfields.data);
	                            var lo = [Infinity, Infinity, Infinity];
	                            var hi = [-Infinity, -Infinity, -Infinity];
	                            var lo_intensity = Infinity;
	                            var hi_intensity = -Infinity;
	                            var count = (shape[0] - 1) * (shape[1] - 1) * 6;
	                            var tverts = pool.mallocFloat(bits.nextPow2(10 * count));
	                            var tptr = 0;
	                            var vertexCount = 0;
	                            for (i = 0; i < shape[0] - 1; ++i) {
	                              j_loop: for (j = 0; j < shape[1] - 1; ++j) {
	                                for (var dx = 0; dx < 2; ++dx) {
	                                  for (var dy = 0; dy < 2; ++dy) {
	                                    for (var k = 0; k < 3; ++k) {
	                                      var f = this._field[k].get(1 + i + dx, 1 + j + dy);
	                                      if (isNaN(f) || !isFinite(f)) {
	                                        continue j_loop;
	                                      }
	                                    }
	                                  }
	                                }
	                                for (k = 0; k < 6; ++k) {
	                                  var r = i + QUAD[k][0];
	                                  var c = j + QUAD[k][1];
	                                  var tx = this._field[0].get(r + 1, c + 1);
	                                  var ty = this._field[1].get(r + 1, c + 1);
	                                  f = this._field[2].get(r + 1, c + 1);
	                                  nx = normals.get(r + 1, c + 1, 0);
	                                  ny = normals.get(r + 1, c + 1, 1);
	                                  nz = normals.get(r + 1, c + 1, 2);
	                                  if (params.intensity) {
	                                    vf = params.intensity.get(r, c);
	                                  }
	                                  var vf = params.intensity ? params.intensity.get(r, c) : f + this.objectOffset[2];
	                                  tverts[tptr++] = r;
	                                  tverts[tptr++] = c;
	                                  tverts[tptr++] = tx;
	                                  tverts[tptr++] = ty;
	                                  tverts[tptr++] = f;
	                                  tverts[tptr++] = 0;
	                                  tverts[tptr++] = vf;
	                                  tverts[tptr++] = nx;
	                                  tverts[tptr++] = ny;
	                                  tverts[tptr++] = nz;
	                                  lo[0] = Math.min(lo[0], tx + this.objectOffset[0]);
	                                  lo[1] = Math.min(lo[1], ty + this.objectOffset[1]);
	                                  lo[2] = Math.min(lo[2], f + this.objectOffset[2]);
	                                  lo_intensity = Math.min(lo_intensity, vf);
	                                  hi[0] = Math.max(hi[0], tx + this.objectOffset[0]);
	                                  hi[1] = Math.max(hi[1], ty + this.objectOffset[1]);
	                                  hi[2] = Math.max(hi[2], f + this.objectOffset[2]);
	                                  hi_intensity = Math.max(hi_intensity, vf);
	                                  vertexCount += 1;
	                                }
	                              }
	                            }
	                            if (params.intensityBounds) {
	                              lo_intensity = +params.intensityBounds[0];
	                              hi_intensity = +params.intensityBounds[1];
	                            }
	                            for (i = 6; i < tptr; i += 10) {
	                              tverts[i] = (tverts[i] - lo_intensity) / (hi_intensity - lo_intensity);
	                            }
	                            this._vertexCount = vertexCount;
	                            this._coordinateBuffer.update(tverts.subarray(0, tptr));
	                            pool.freeFloat(tverts);
	                            pool.free(normals.data);
	                            this.bounds = [lo, hi];
	                            this.intensity = params.intensity || this._field[2];
	                            if (this.intensityBounds[0] !== lo_intensity || this.intensityBounds[1] !== hi_intensity) {
	                              levelsChanged = true;
	                            }
	                            this.intensityBounds = [lo_intensity, hi_intensity];
	                          }
	                          if ("levels" in params) {
	                            var levels = params.levels;
	                            if (!Array.isArray(levels[0])) {
	                              levels = [[], [], levels];
	                            } else {
	                              levels = levels.slice();
	                            }
	                            for (i = 0; i < 3; ++i) {
	                              levels[i] = levels[i].slice();
	                              levels[i].sort(function(a, b) {
	                                return a - b;
	                              });
	                            }
	                            for (i = 0; i < 3; ++i) {
	                              for (j = 0; j < levels[i].length; ++j) {
	                                levels[i][j] -= this.objectOffset[i];
	                              }
	                            }
	                            change_test: for (i = 0; i < 3; ++i) {
	                              if (levels[i].length !== this.contourLevels[i].length) {
	                                levelsChanged = true;
	                                break;
	                              }
	                              for (j = 0; j < levels[i].length; ++j) {
	                                if (levels[i][j] !== this.contourLevels[i][j]) {
	                                  levelsChanged = true;
	                                  break change_test;
	                                }
	                              }
	                            }
	                            this.contourLevels = levels;
	                          }
	                          if (levelsChanged) {
	                            fields = this._field;
	                            shape = this.shape;
	                            var contourVerts = [];
	                            for (var dim = 0; dim < 3; ++dim) {
	                              var contourLevel = this.contourLevels[dim];
	                              var levelOffsets = [];
	                              var levelCounts = [];
	                              var parts = [0, 0, 0];
	                              for (i = 0; i < contourLevel.length; ++i) {
	                                var graph = surfaceNets(this._field[dim], contourLevel[i]);
	                                levelOffsets.push(contourVerts.length / 5 | 0);
	                                vertexCount = 0;
	                                edge_loop: for (j = 0; j < graph.cells.length; ++j) {
	                                  var e = graph.cells[j];
	                                  for (k = 0; k < 2; ++k) {
	                                    var p = graph.positions[e[k]];
	                                    var x = p[0];
	                                    var ix = Math.floor(x) | 0;
	                                    var fx = x - ix;
	                                    var y = p[1];
	                                    var iy = Math.floor(y) | 0;
	                                    var fy = y - iy;
	                                    var hole = false;
	                                    axis_loop: for (var axis = 0; axis < 3; ++axis) {
	                                      parts[axis] = 0;
	                                      var iu = (dim + axis + 1) % 3;
	                                      for (dx = 0; dx < 2; ++dx) {
	                                        var s = dx ? fx : 1 - fx;
	                                        r = Math.min(Math.max(ix + dx, 0), shape[0]) | 0;
	                                        for (dy = 0; dy < 2; ++dy) {
	                                          var t = dy ? fy : 1 - fy;
	                                          c = Math.min(Math.max(iy + dy, 0), shape[1]) | 0;
	                                          if (axis < 2) {
	                                            f = this._field[iu].get(r, c);
	                                          } else {
	                                            f = (this.intensity.get(r, c) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0]);
	                                          }
	                                          if (!isFinite(f) || isNaN(f)) {
	                                            hole = true;
	                                            break axis_loop;
	                                          }
	                                          var w = s * t;
	                                          parts[axis] += w * f;
	                                        }
	                                      }
	                                    }
	                                    if (!hole) {
	                                      contourVerts.push(parts[0], parts[1], p[0], p[1], parts[2]);
	                                      vertexCount += 1;
	                                    } else {
	                                      if (k > 0) {
	                                        for (var l = 0; l < 5; ++l) {
	                                          contourVerts.pop();
	                                        }
	                                        vertexCount -= 1;
	                                      }
	                                      continue edge_loop;
	                                    }
	                                  }
	                                }
	                                levelCounts.push(vertexCount);
	                              }
	                              this._contourOffsets[dim] = levelOffsets;
	                              this._contourCounts[dim] = levelCounts;
	                            }
	                            var floatBuffer = pool.mallocFloat(contourVerts.length);
	                            for (i = 0; i < contourVerts.length; ++i) {
	                              floatBuffer[i] = contourVerts[i];
	                            }
	                            this._contourBuffer.update(floatBuffer);
	                            pool.freeFloat(floatBuffer);
	                          }
	                        };
	                        proto.dispose = function() {
	                          this._shader.dispose();
	                          this._vao.dispose();
	                          this._coordinateBuffer.dispose();
	                          this._colorMap.dispose();
	                          this._contourBuffer.dispose();
	                          this._contourVAO.dispose();
	                          this._contourShader.dispose();
	                          this._contourPickShader.dispose();
	                          this._dynamicBuffer.dispose();
	                          this._dynamicVAO.dispose();
	                          for (var i = 0; i < 3; ++i) {
	                            pool.freeFloat(this._field[i].data);
	                          }
	                        };
	                        proto.highlight = function(selection) {
	                          var i;
	                          if (!selection) {
	                            this._dynamicCounts = [0, 0, 0];
	                            this.dyanamicLevel = [NaN, NaN, NaN];
	                            this.highlightLevel = [-1, -1, -1];
	                            return;
	                          }
	                          for (i = 0; i < 3; ++i) {
	                            if (this.enableHighlight[i]) {
	                              this.highlightLevel[i] = selection.level[i];
	                            } else {
	                              this.highlightLevel[i] = -1;
	                            }
	                          }
	                          var levels;
	                          if (this.snapToData) {
	                            levels = selection.dataCoordinate;
	                          } else {
	                            levels = selection.position;
	                          }
	                          for (i = 0; i < 3; ++i) {
	                            levels[i] -= this.objectOffset[i];
	                          }
	                          if ((!this.enableDynamic[0] || levels[0] === this.dynamicLevel[0]) && (!this.enableDynamic[1] || levels[1] === this.dynamicLevel[1]) && (!this.enableDynamic[2] || levels[2] === this.dynamicLevel[2])) {
	                            return;
	                          }
	                          var vertexCount = 0;
	                          var shape = this.shape;
	                          var scratchBuffer = pool.mallocFloat(12 * shape[0] * shape[1]);
	                          for (var d = 0; d < 3; ++d) {
	                            if (!this.enableDynamic[d]) {
	                              this.dynamicLevel[d] = NaN;
	                              this._dynamicCounts[d] = 0;
	                              continue;
	                            }
	                            this.dynamicLevel[d] = levels[d];
	                            var u = (d + 1) % 3;
	                            var v = (d + 2) % 3;
	                            var f = this._field[d];
	                            var g = this._field[u];
	                            var h = this._field[v];
	                            var graph = surfaceNets(f, levels[d]);
	                            var edges = graph.cells;
	                            var positions = graph.positions;
	                            this._dynamicOffsets[d] = vertexCount;
	                            for (i = 0; i < edges.length; ++i) {
	                              var e = edges[i];
	                              for (var j = 0; j < 2; ++j) {
	                                var p = positions[e[j]];
	                                var x = +p[0];
	                                var ix = x | 0;
	                                var jx = Math.min(ix + 1, shape[0]) | 0;
	                                var fx = x - ix;
	                                var hx = 1 - fx;
	                                var y = +p[1];
	                                var iy = y | 0;
	                                var jy = Math.min(iy + 1, shape[1]) | 0;
	                                var fy = y - iy;
	                                var hy = 1 - fy;
	                                var w00 = hx * hy;
	                                var w01 = hx * fy;
	                                var w10 = fx * hy;
	                                var w11 = fx * fy;
	                                var cu = w00 * g.get(ix, iy) + w01 * g.get(ix, jy) + w10 * g.get(jx, iy) + w11 * g.get(jx, jy);
	                                var cv = w00 * h.get(ix, iy) + w01 * h.get(ix, jy) + w10 * h.get(jx, iy) + w11 * h.get(jx, jy);
	                                if (isNaN(cu) || isNaN(cv)) {
	                                  if (j) {
	                                    vertexCount -= 1;
	                                  }
	                                  break;
	                                }
	                                scratchBuffer[2 * vertexCount + 0] = cu;
	                                scratchBuffer[2 * vertexCount + 1] = cv;
	                                vertexCount += 1;
	                              }
	                            }
	                            this._dynamicCounts[d] = vertexCount - this._dynamicOffsets[d];
	                          }
	                          this._dynamicBuffer.update(scratchBuffer.subarray(0, 2 * vertexCount));
	                          pool.freeFloat(scratchBuffer);
	                        };
	                        function createSurfacePlot(params) {
	                          var gl2 = params.gl;
	                          var shader = createShader(gl2);
	                          var pickShader = createPickShader(gl2);
	                          var contourShader = createContourShader(gl2);
	                          var contourPickShader = createPickContourShader(gl2);
	                          var coordinateBuffer = createBuffer(gl2);
	                          var vao = createVAO(gl2, [{ buffer: coordinateBuffer, size: 4, stride: SURFACE_VERTEX_SIZE, offset: 0 }, { buffer: coordinateBuffer, size: 3, stride: SURFACE_VERTEX_SIZE, offset: 16 }, { buffer: coordinateBuffer, size: 3, stride: SURFACE_VERTEX_SIZE, offset: 28 }]);
	                          var contourBuffer = createBuffer(gl2);
	                          var contourVAO = createVAO(gl2, [{ buffer: contourBuffer, size: 4, stride: 20, offset: 0 }, { buffer: contourBuffer, size: 1, stride: 20, offset: 16 }]);
	                          var dynamicBuffer = createBuffer(gl2);
	                          var dynamicVAO = createVAO(gl2, [{ buffer: dynamicBuffer, size: 2, type: gl2.FLOAT }]);
	                          var cmap = createTexture(gl2, 1, N_COLORS, gl2.RGBA, gl2.UNSIGNED_BYTE);
	                          cmap.minFilter = gl2.LINEAR;
	                          cmap.magFilter = gl2.LINEAR;
	                          var surface = new SurfacePlot(
	                            gl2,
	                            [0, 0],
	                            // shape
	                            [[0, 0, 0], [0, 0, 0]],
	                            // bounds
	                            shader,
	                            pickShader,
	                            coordinateBuffer,
	                            vao,
	                            cmap,
	                            contourShader,
	                            contourPickShader,
	                            contourBuffer,
	                            contourVAO,
	                            dynamicBuffer,
	                            dynamicVAO,
	                            [0, 0, 0]
	                            // objectOffset
	                          );
	                          var nparams = { levels: [[], [], []] };
	                          for (var id in params) {
	                            nparams[id] = params[id];
	                          }
	                          nparams.colormap = nparams.colormap || "jet";
	                          surface.update(nparams);
	                          return surface;
	                        }
	                      }
	                    ),
	                    /***/
	                    8931: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_571544__) {
	                        var ndarray = __nested_webpack_require_571544__(5050);
	                        var ops = __nested_webpack_require_571544__(7498);
	                        var pool = __nested_webpack_require_571544__(5306);
	                        module3.exports = createTexture2D;
	                        var linearTypes = null;
	                        var filterTypes = null;
	                        var wrapTypes = null;
	                        function lazyInitLinearTypes(gl2) {
	                          linearTypes = [gl2.LINEAR, gl2.NEAREST_MIPMAP_LINEAR, gl2.LINEAR_MIPMAP_NEAREST, gl2.LINEAR_MIPMAP_NEAREST];
	                          filterTypes = [gl2.NEAREST, gl2.LINEAR, gl2.NEAREST_MIPMAP_NEAREST, gl2.NEAREST_MIPMAP_LINEAR, gl2.LINEAR_MIPMAP_NEAREST, gl2.LINEAR_MIPMAP_LINEAR];
	                          wrapTypes = [gl2.REPEAT, gl2.CLAMP_TO_EDGE, gl2.MIRRORED_REPEAT];
	                        }
	                        function acceptTextureDOM(obj) {
	                          return "undefined" != typeof HTMLCanvasElement && obj instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && obj instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && obj instanceof HTMLVideoElement || "undefined" != typeof ImageData && obj instanceof ImageData;
	                        }
	                        var convertFloatToUint8 = function(out, inp) {
	                          ops.muls(out, inp, 255);
	                        };
	                        function reshapeTexture(tex, w, h) {
	                          var gl2 = tex.gl;
	                          var maxSize = gl2.getParameter(gl2.MAX_TEXTURE_SIZE);
	                          if (w < 0 || w > maxSize || h < 0 || h > maxSize) {
	                            throw new Error("gl-texture2d: Invalid texture size");
	                          }
	                          tex._shape = [w, h];
	                          tex.bind();
	                          gl2.texImage2D(gl2.TEXTURE_2D, 0, tex.format, w, h, 0, tex.format, tex.type, null);
	                          tex._mipLevels = [0];
	                          return tex;
	                        }
	                        function Texture2D(gl2, handle, width, height, format, type) {
	                          this.gl = gl2;
	                          this.handle = handle;
	                          this.format = format;
	                          this.type = type;
	                          this._shape = [width, height];
	                          this._mipLevels = [0];
	                          this._magFilter = gl2.NEAREST;
	                          this._minFilter = gl2.NEAREST;
	                          this._wrapS = gl2.CLAMP_TO_EDGE;
	                          this._wrapT = gl2.CLAMP_TO_EDGE;
	                          this._anisoSamples = 1;
	                          var parent = this;
	                          var wrapVector = [this._wrapS, this._wrapT];
	                          Object.defineProperties(wrapVector, [{ get: function() {
	                            return parent._wrapS;
	                          }, set: function(v) {
	                            return parent.wrapS = v;
	                          } }, { get: function() {
	                            return parent._wrapT;
	                          }, set: function(v) {
	                            return parent.wrapT = v;
	                          } }]);
	                          this._wrapVector = wrapVector;
	                          var shapeVector = [this._shape[0], this._shape[1]];
	                          Object.defineProperties(shapeVector, [{ get: function() {
	                            return parent._shape[0];
	                          }, set: function(v) {
	                            return parent.width = v;
	                          } }, { get: function() {
	                            return parent._shape[1];
	                          }, set: function(v) {
	                            return parent.height = v;
	                          } }]);
	                          this._shapeVector = shapeVector;
	                        }
	                        var proto = Texture2D.prototype;
	                        Object.defineProperties(proto, { minFilter: { get: function() {
	                          return this._minFilter;
	                        }, set: function(v) {
	                          this.bind();
	                          var gl2 = this.gl;
	                          if (this.type === gl2.FLOAT && linearTypes.indexOf(v) >= 0) {
	                            if (!gl2.getExtension("OES_texture_float_linear")) {
	                              v = gl2.NEAREST;
	                            }
	                          }
	                          if (filterTypes.indexOf(v) < 0) {
	                            throw new Error("gl-texture2d: Unknown filter mode " + v);
	                          }
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MIN_FILTER, v);
	                          return this._minFilter = v;
	                        } }, magFilter: { get: function() {
	                          return this._magFilter;
	                        }, set: function(v) {
	                          this.bind();
	                          var gl2 = this.gl;
	                          if (this.type === gl2.FLOAT && linearTypes.indexOf(v) >= 0) {
	                            if (!gl2.getExtension("OES_texture_float_linear")) {
	                              v = gl2.NEAREST;
	                            }
	                          }
	                          if (filterTypes.indexOf(v) < 0) {
	                            throw new Error("gl-texture2d: Unknown filter mode " + v);
	                          }
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MAG_FILTER, v);
	                          return this._magFilter = v;
	                        } }, mipSamples: { get: function() {
	                          return this._anisoSamples;
	                        }, set: function(i) {
	                          var psamples = this._anisoSamples;
	                          this._anisoSamples = Math.max(i, 1) | 0;
	                          if (psamples !== this._anisoSamples) {
	                            var ext = this.gl.getExtension("EXT_texture_filter_anisotropic");
	                            if (ext) {
	                              this.gl.texParameterf(this.gl.TEXTURE_2D, ext.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
	                            }
	                          }
	                          return this._anisoSamples;
	                        } }, wrapS: { get: function() {
	                          return this._wrapS;
	                        }, set: function(v) {
	                          this.bind();
	                          if (wrapTypes.indexOf(v) < 0) {
	                            throw new Error("gl-texture2d: Unknown wrap mode " + v);
	                          }
	                          this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, v);
	                          return this._wrapS = v;
	                        } }, wrapT: { get: function() {
	                          return this._wrapT;
	                        }, set: function(v) {
	                          this.bind();
	                          if (wrapTypes.indexOf(v) < 0) {
	                            throw new Error("gl-texture2d: Unknown wrap mode " + v);
	                          }
	                          this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, v);
	                          return this._wrapT = v;
	                        } }, wrap: { get: function() {
	                          return this._wrapVector;
	                        }, set: function(v) {
	                          if (!Array.isArray(v)) {
	                            v = [v, v];
	                          }
	                          if (v.length !== 2) {
	                            throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");
	                          }
	                          for (var i = 0; i < 2; ++i) {
	                            if (wrapTypes.indexOf(v[i]) < 0) {
	                              throw new Error("gl-texture2d: Unknown wrap mode " + v);
	                            }
	                          }
	                          this._wrapS = v[0];
	                          this._wrapT = v[1];
	                          var gl2 = this.gl;
	                          this.bind();
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_S, this._wrapS);
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_T, this._wrapT);
	                          return v;
	                        } }, shape: { get: function() {
	                          return this._shapeVector;
	                        }, set: function(x) {
	                          if (!Array.isArray(x)) {
	                            x = [x | 0, x | 0];
	                          } else {
	                            if (x.length !== 2) {
	                              throw new Error("gl-texture2d: Invalid texture shape");
	                            }
	                          }
	                          reshapeTexture(this, x[0] | 0, x[1] | 0);
	                          return [x[0] | 0, x[1] | 0];
	                        } }, width: { get: function() {
	                          return this._shape[0];
	                        }, set: function(w) {
	                          w = w | 0;
	                          reshapeTexture(this, w, this._shape[1]);
	                          return w;
	                        } }, height: { get: function() {
	                          return this._shape[1];
	                        }, set: function(h) {
	                          h = h | 0;
	                          reshapeTexture(this, this._shape[0], h);
	                          return h;
	                        } } });
	                        proto.bind = function(unit) {
	                          var gl2 = this.gl;
	                          if (unit !== undefined) {
	                            gl2.activeTexture(gl2.TEXTURE0 + (unit | 0));
	                          }
	                          gl2.bindTexture(gl2.TEXTURE_2D, this.handle);
	                          if (unit !== undefined) {
	                            return unit | 0;
	                          }
	                          return gl2.getParameter(gl2.ACTIVE_TEXTURE) - gl2.TEXTURE0;
	                        };
	                        proto.dispose = function() {
	                          this.gl.deleteTexture(this.handle);
	                        };
	                        proto.generateMipmap = function() {
	                          this.bind();
	                          this.gl.generateMipmap(this.gl.TEXTURE_2D);
	                          var l = Math.min(this._shape[0], this._shape[1]);
	                          for (var i = 0; l > 0; ++i, l >>>= 1) {
	                            if (this._mipLevels.indexOf(i) < 0) {
	                              this._mipLevels.push(i);
	                            }
	                          }
	                        };
	                        proto.setPixels = function(data, x_off, y_off, mip_level) {
	                          var gl2 = this.gl;
	                          this.bind();
	                          if (Array.isArray(x_off)) {
	                            mip_level = y_off;
	                            y_off = x_off[1] | 0;
	                            x_off = x_off[0] | 0;
	                          } else {
	                            x_off = x_off || 0;
	                            y_off = y_off || 0;
	                          }
	                          mip_level = mip_level || 0;
	                          var directData = acceptTextureDOM(data) ? data : data.raw;
	                          if (directData) {
	                            var needsMip = this._mipLevels.indexOf(mip_level) < 0;
	                            if (needsMip) {
	                              gl2.texImage2D(gl2.TEXTURE_2D, 0, this.format, this.format, this.type, directData);
	                              this._mipLevels.push(mip_level);
	                            } else {
	                              gl2.texSubImage2D(gl2.TEXTURE_2D, mip_level, x_off, y_off, this.format, this.type, directData);
	                            }
	                          } else if (data.shape && data.stride && data.data) {
	                            if (data.shape.length < 2 || x_off + data.shape[1] > this._shape[1] >>> mip_level || y_off + data.shape[0] > this._shape[0] >>> mip_level || x_off < 0 || y_off < 0) {
	                              throw new Error("gl-texture2d: Texture dimensions are out of bounds");
	                            }
	                            texSubImageArray(gl2, x_off, y_off, mip_level, this.format, this.type, this._mipLevels, data);
	                          } else {
	                            throw new Error("gl-texture2d: Unsupported data type");
	                          }
	                        };
	                        function isPacked(shape, stride) {
	                          if (shape.length === 3) {
	                            return stride[2] === 1 && stride[1] === shape[0] * shape[2] && stride[0] === shape[2];
	                          }
	                          return stride[0] === 1 && stride[1] === shape[0];
	                        }
	                        function texSubImageArray(gl2, x_off, y_off, mip_level, cformat, ctype, mipLevels, array) {
	                          var dtype = array.dtype;
	                          var shape = array.shape.slice();
	                          if (shape.length < 2 || shape.length > 3) {
	                            throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
	                          }
	                          var type = 0, format = 0;
	                          var packed = isPacked(shape, array.stride.slice());
	                          if (dtype === "float32") {
	                            type = gl2.FLOAT;
	                          } else if (dtype === "float64") {
	                            type = gl2.FLOAT;
	                            packed = false;
	                            dtype = "float32";
	                          } else if (dtype === "uint8") {
	                            type = gl2.UNSIGNED_BYTE;
	                          } else {
	                            type = gl2.UNSIGNED_BYTE;
	                            packed = false;
	                            dtype = "uint8";
	                          }
	                          if (shape.length === 2) {
	                            format = gl2.LUMINANCE;
	                            shape = [shape[0], shape[1], 1];
	                            array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset);
	                          } else if (shape.length === 3) {
	                            if (shape[2] === 1) {
	                              format = gl2.ALPHA;
	                            } else if (shape[2] === 2) {
	                              format = gl2.LUMINANCE_ALPHA;
	                            } else if (shape[2] === 3) {
	                              format = gl2.RGB;
	                            } else if (shape[2] === 4) {
	                              format = gl2.RGBA;
	                            } else {
	                              throw new Error("gl-texture2d: Invalid shape for pixel coords");
	                            }
	                            shape[2];
	                          } else {
	                            throw new Error("gl-texture2d: Invalid shape for texture");
	                          }
	                          if ((format === gl2.LUMINANCE || format === gl2.ALPHA) && (cformat === gl2.LUMINANCE || cformat === gl2.ALPHA)) {
	                            format = cformat;
	                          }
	                          if (format !== cformat) {
	                            throw new Error("gl-texture2d: Incompatible texture format for setPixels");
	                          }
	                          var size = array.size;
	                          var needsMip = mipLevels.indexOf(mip_level) < 0;
	                          if (needsMip) {
	                            mipLevels.push(mip_level);
	                          }
	                          if (type === ctype && packed) {
	                            if (array.offset === 0 && array.data.length === size) {
	                              if (needsMip) {
	                                gl2.texImage2D(gl2.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data);
	                              } else {
	                                gl2.texSubImage2D(gl2.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data);
	                              }
	                            } else {
	                              if (needsMip) {
	                                gl2.texImage2D(gl2.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data.subarray(array.offset, array.offset + size));
	                              } else {
	                                gl2.texSubImage2D(gl2.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data.subarray(array.offset, array.offset + size));
	                              }
	                            }
	                          } else {
	                            var pack_buffer;
	                            if (ctype === gl2.FLOAT) {
	                              pack_buffer = pool.mallocFloat32(size);
	                            } else {
	                              pack_buffer = pool.mallocUint8(size);
	                            }
	                            var pack_view = ndarray(pack_buffer, shape, [shape[2], shape[2] * shape[0], 1]);
	                            if (type === gl2.FLOAT && ctype === gl2.UNSIGNED_BYTE) {
	                              convertFloatToUint8(pack_view, array);
	                            } else {
	                              ops.assign(pack_view, array);
	                            }
	                            if (needsMip) {
	                              gl2.texImage2D(gl2.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, pack_buffer.subarray(0, size));
	                            } else {
	                              gl2.texSubImage2D(gl2.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, pack_buffer.subarray(0, size));
	                            }
	                            if (ctype === gl2.FLOAT) {
	                              pool.freeFloat32(pack_buffer);
	                            } else {
	                              pool.freeUint8(pack_buffer);
	                            }
	                          }
	                        }
	                        function initTexture(gl2) {
	                          var tex = gl2.createTexture();
	                          gl2.bindTexture(gl2.TEXTURE_2D, tex);
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MIN_FILTER, gl2.NEAREST);
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MAG_FILTER, gl2.NEAREST);
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_S, gl2.CLAMP_TO_EDGE);
	                          gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_T, gl2.CLAMP_TO_EDGE);
	                          return tex;
	                        }
	                        function createTextureShape(gl2, width, height, format, type) {
	                          var maxTextureSize = gl2.getParameter(gl2.MAX_TEXTURE_SIZE);
	                          if (width < 0 || width > maxTextureSize || height < 0 || height > maxTextureSize) {
	                            throw new Error("gl-texture2d: Invalid texture shape");
	                          }
	                          if (type === gl2.FLOAT && !gl2.getExtension("OES_texture_float")) {
	                            throw new Error("gl-texture2d: Floating point textures not supported on this platform");
	                          }
	                          var tex = initTexture(gl2);
	                          gl2.texImage2D(gl2.TEXTURE_2D, 0, format, width, height, 0, format, type, null);
	                          return new Texture2D(gl2, tex, width, height, format, type);
	                        }
	                        function createTextureDOM(gl2, directData, width, height, format, type) {
	                          var tex = initTexture(gl2);
	                          gl2.texImage2D(gl2.TEXTURE_2D, 0, format, format, type, directData);
	                          return new Texture2D(gl2, tex, width, height, format, type);
	                        }
	                        function createTextureArray(gl2, array) {
	                          var dtype = array.dtype;
	                          var shape = array.shape.slice();
	                          var maxSize = gl2.getParameter(gl2.MAX_TEXTURE_SIZE);
	                          if (shape[0] < 0 || shape[0] > maxSize || shape[1] < 0 || shape[1] > maxSize) {
	                            throw new Error("gl-texture2d: Invalid texture size");
	                          }
	                          var packed = isPacked(shape, array.stride.slice());
	                          var type = 0;
	                          if (dtype === "float32") {
	                            type = gl2.FLOAT;
	                          } else if (dtype === "float64") {
	                            type = gl2.FLOAT;
	                            packed = false;
	                            dtype = "float32";
	                          } else if (dtype === "uint8") {
	                            type = gl2.UNSIGNED_BYTE;
	                          } else {
	                            type = gl2.UNSIGNED_BYTE;
	                            packed = false;
	                            dtype = "uint8";
	                          }
	                          var format = 0;
	                          if (shape.length === 2) {
	                            format = gl2.LUMINANCE;
	                            shape = [shape[0], shape[1], 1];
	                            array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset);
	                          } else if (shape.length === 3) {
	                            if (shape[2] === 1) {
	                              format = gl2.ALPHA;
	                            } else if (shape[2] === 2) {
	                              format = gl2.LUMINANCE_ALPHA;
	                            } else if (shape[2] === 3) {
	                              format = gl2.RGB;
	                            } else if (shape[2] === 4) {
	                              format = gl2.RGBA;
	                            } else {
	                              throw new Error("gl-texture2d: Invalid shape for pixel coords");
	                            }
	                          } else {
	                            throw new Error("gl-texture2d: Invalid shape for texture");
	                          }
	                          if (type === gl2.FLOAT && !gl2.getExtension("OES_texture_float")) {
	                            type = gl2.UNSIGNED_BYTE;
	                            packed = false;
	                          }
	                          var buffer, buf_store;
	                          var size = array.size;
	                          if (!packed) {
	                            var stride = [shape[2], shape[2] * shape[0], 1];
	                            buf_store = pool.malloc(size, dtype);
	                            var buf_array = ndarray(buf_store, shape, stride, 0);
	                            if ((dtype === "float32" || dtype === "float64") && type === gl2.UNSIGNED_BYTE) {
	                              convertFloatToUint8(buf_array, array);
	                            } else {
	                              ops.assign(buf_array, array);
	                            }
	                            buffer = buf_store.subarray(0, size);
	                          } else if (array.offset === 0 && array.data.length === size) {
	                            buffer = array.data;
	                          } else {
	                            buffer = array.data.subarray(array.offset, array.offset + size);
	                          }
	                          var tex = initTexture(gl2);
	                          gl2.texImage2D(gl2.TEXTURE_2D, 0, format, shape[0], shape[1], 0, format, type, buffer);
	                          if (!packed) {
	                            pool.free(buf_store);
	                          }
	                          return new Texture2D(gl2, tex, shape[0], shape[1], format, type);
	                        }
	                        function createTexture2D(gl2) {
	                          if (arguments.length <= 1) {
	                            throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
	                          }
	                          if (!linearTypes) {
	                            lazyInitLinearTypes(gl2);
	                          }
	                          if (typeof arguments[1] === "number") {
	                            return createTextureShape(gl2, arguments[1], arguments[2], arguments[3] || gl2.RGBA, arguments[4] || gl2.UNSIGNED_BYTE);
	                          }
	                          if (Array.isArray(arguments[1])) {
	                            return createTextureShape(gl2, arguments[1][0] | 0, arguments[1][1] | 0, arguments[2] || gl2.RGBA, arguments[3] || gl2.UNSIGNED_BYTE);
	                          }
	                          if (typeof arguments[1] === "object") {
	                            var obj = arguments[1];
	                            var directData = acceptTextureDOM(obj) ? obj : obj.raw;
	                            if (directData) {
	                              return createTextureDOM(gl2, directData, obj.width | 0, obj.height | 0, arguments[2] || gl2.RGBA, arguments[3] || gl2.UNSIGNED_BYTE);
	                            } else if (obj.shape && obj.data && obj.stride) {
	                              return createTextureArray(gl2, obj);
	                            }
	                          }
	                          throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
	                        }
	                      }
	                    ),
	                    /***/
	                    3056: (
	                      /***/
	                      function(module3) {
	                        function doBind(gl2, elements, attributes) {
	                          if (elements) {
	                            elements.bind();
	                          } else {
	                            gl2.bindBuffer(gl2.ELEMENT_ARRAY_BUFFER, null);
	                          }
	                          var nattribs = gl2.getParameter(gl2.MAX_VERTEX_ATTRIBS) | 0;
	                          if (attributes) {
	                            if (attributes.length > nattribs) {
	                              throw new Error("gl-vao: Too many vertex attributes");
	                            }
	                            for (var i = 0; i < attributes.length; ++i) {
	                              var attrib = attributes[i];
	                              if (attrib.buffer) {
	                                var buffer = attrib.buffer;
	                                var size = attrib.size || 4;
	                                var type = attrib.type || gl2.FLOAT;
	                                var normalized = !!attrib.normalized;
	                                var stride = attrib.stride || 0;
	                                var offset = attrib.offset || 0;
	                                buffer.bind();
	                                gl2.enableVertexAttribArray(i);
	                                gl2.vertexAttribPointer(i, size, type, normalized, stride, offset);
	                              } else {
	                                if (typeof attrib === "number") {
	                                  gl2.vertexAttrib1f(i, attrib);
	                                } else if (attrib.length === 1) {
	                                  gl2.vertexAttrib1f(i, attrib[0]);
	                                } else if (attrib.length === 2) {
	                                  gl2.vertexAttrib2f(i, attrib[0], attrib[1]);
	                                } else if (attrib.length === 3) {
	                                  gl2.vertexAttrib3f(i, attrib[0], attrib[1], attrib[2]);
	                                } else if (attrib.length === 4) {
	                                  gl2.vertexAttrib4f(i, attrib[0], attrib[1], attrib[2], attrib[3]);
	                                } else {
	                                  throw new Error("gl-vao: Invalid vertex attribute");
	                                }
	                                gl2.disableVertexAttribArray(i);
	                              }
	                            }
	                            for (; i < nattribs; ++i) {
	                              gl2.disableVertexAttribArray(i);
	                            }
	                          } else {
	                            gl2.bindBuffer(gl2.ARRAY_BUFFER, null);
	                            for (var i = 0; i < nattribs; ++i) {
	                              gl2.disableVertexAttribArray(i);
	                            }
	                          }
	                        }
	                        module3.exports = doBind;
	                      }
	                    ),
	                    /***/
	                    7220: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_585871__) {
	                        var bindAttribs = __nested_webpack_require_585871__(3056);
	                        function VAOEmulated(gl2) {
	                          this.gl = gl2;
	                          this._elements = null;
	                          this._attributes = null;
	                          this._elementsType = gl2.UNSIGNED_SHORT;
	                        }
	                        VAOEmulated.prototype.bind = function() {
	                          bindAttribs(this.gl, this._elements, this._attributes);
	                        };
	                        VAOEmulated.prototype.update = function(attributes, elements, elementsType) {
	                          this._elements = elements;
	                          this._attributes = attributes;
	                          this._elementsType = elementsType || this.gl.UNSIGNED_SHORT;
	                        };
	                        VAOEmulated.prototype.dispose = function() {
	                        };
	                        VAOEmulated.prototype.unbind = function() {
	                        };
	                        VAOEmulated.prototype.draw = function(mode, count, offset) {
	                          offset = offset || 0;
	                          var gl2 = this.gl;
	                          if (this._elements) {
	                            gl2.drawElements(mode, count, this._elementsType, offset);
	                          } else {
	                            gl2.drawArrays(mode, offset, count);
	                          }
	                        };
	                        function createVAOEmulated(gl2) {
	                          return new VAOEmulated(gl2);
	                        }
	                        module3.exports = createVAOEmulated;
	                      }
	                    ),
	                    /***/
	                    3778: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_586780__) {
	                        var bindAttribs = __nested_webpack_require_586780__(3056);
	                        function VertexAttribute(location, dimension, a, b, c, d) {
	                          this.location = location;
	                          this.dimension = dimension;
	                          this.a = a;
	                          this.b = b;
	                          this.c = c;
	                          this.d = d;
	                        }
	                        VertexAttribute.prototype.bind = function(gl2) {
	                          switch (this.dimension) {
	                            case 1:
	                              gl2.vertexAttrib1f(this.location, this.a);
	                              break;
	                            case 2:
	                              gl2.vertexAttrib2f(this.location, this.a, this.b);
	                              break;
	                            case 3:
	                              gl2.vertexAttrib3f(this.location, this.a, this.b, this.c);
	                              break;
	                            case 4:
	                              gl2.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d);
	                              break;
	                          }
	                        };
	                        function VAONative(gl2, ext, handle) {
	                          this.gl = gl2;
	                          this._ext = ext;
	                          this.handle = handle;
	                          this._attribs = [];
	                          this._useElements = false;
	                          this._elementsType = gl2.UNSIGNED_SHORT;
	                        }
	                        VAONative.prototype.bind = function() {
	                          this._ext.bindVertexArrayOES(this.handle);
	                          for (var i = 0; i < this._attribs.length; ++i) {
	                            this._attribs[i].bind(this.gl);
	                          }
	                        };
	                        VAONative.prototype.unbind = function() {
	                          this._ext.bindVertexArrayOES(null);
	                        };
	                        VAONative.prototype.dispose = function() {
	                          this._ext.deleteVertexArrayOES(this.handle);
	                        };
	                        VAONative.prototype.update = function(attributes, elements, elementsType) {
	                          this.bind();
	                          bindAttribs(this.gl, elements, attributes);
	                          this.unbind();
	                          this._attribs.length = 0;
	                          if (attributes) for (var i = 0; i < attributes.length; ++i) {
	                            var a = attributes[i];
	                            if (typeof a === "number") {
	                              this._attribs.push(new VertexAttribute(i, 1, a));
	                            } else if (Array.isArray(a)) {
	                              this._attribs.push(new VertexAttribute(i, a.length, a[0], a[1], a[2], a[3]));
	                            }
	                          }
	                          this._useElements = !!elements;
	                          this._elementsType = elementsType || this.gl.UNSIGNED_SHORT;
	                        };
	                        VAONative.prototype.draw = function(mode, count, offset) {
	                          offset = offset || 0;
	                          var gl2 = this.gl;
	                          if (this._useElements) {
	                            gl2.drawElements(mode, count, this._elementsType, offset);
	                          } else {
	                            gl2.drawArrays(mode, offset, count);
	                          }
	                        };
	                        function createVAONative(gl2, ext) {
	                          return new VAONative(gl2, ext, ext.createVertexArrayOES());
	                        }
	                        module3.exports = createVAONative;
	                      }
	                    ),
	                    /***/
	                    2944: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_588664__) {
	                        var createVAONative = __nested_webpack_require_588664__(3778);
	                        var createVAOEmulated = __nested_webpack_require_588664__(7220);
	                        function ExtensionShim(gl2) {
	                          this.bindVertexArrayOES = gl2.bindVertexArray.bind(gl2);
	                          this.createVertexArrayOES = gl2.createVertexArray.bind(gl2);
	                          this.deleteVertexArrayOES = gl2.deleteVertexArray.bind(gl2);
	                        }
	                        function createVAO(gl2, attributes, elements, elementsType) {
	                          var ext = gl2.createVertexArray ? new ExtensionShim(gl2) : gl2.getExtension("OES_vertex_array_object");
	                          var vao;
	                          if (ext) {
	                            vao = createVAONative(gl2, ext);
	                          } else {
	                            vao = createVAOEmulated(gl2);
	                          }
	                          vao.update(attributes, elements, elementsType);
	                          return vao;
	                        }
	                        module3.exports = createVAO;
	                      }
	                    ),
	                    /***/
	                    2598: (
	                      /***/
	                      function(module3) {
	                        module3.exports = add;
	                        function add(out, a, b) {
	                          out[0] = a[0] + b[0];
	                          out[1] = a[1] + b[1];
	                          out[2] = a[2] + b[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5879: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_589668__) {
	                        module3.exports = angle;
	                        var fromValues = __nested_webpack_require_589668__(5415);
	                        var normalize = __nested_webpack_require_589668__(899);
	                        var dot = __nested_webpack_require_589668__(9305);
	                        function angle(a, b) {
	                          var tempA = fromValues(a[0], a[1], a[2]);
	                          var tempB = fromValues(b[0], b[1], b[2]);
	                          normalize(tempA, tempA);
	                          normalize(tempB, tempB);
	                          var cosine = dot(tempA, tempB);
	                          if (cosine > 1) {
	                            return 0;
	                          } else {
	                            return Math.acos(cosine);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    8827: (
	                      /***/
	                      function(module3) {
	                        module3.exports = ceil;
	                        function ceil(out, a) {
	                          out[0] = Math.ceil(a[0]);
	                          out[1] = Math.ceil(a[1]);
	                          out[2] = Math.ceil(a[2]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7622: (
	                      /***/
	                      function(module3) {
	                        module3.exports = clone;
	                        function clone(a) {
	                          var out = new Float32Array(3);
	                          out[0] = a[0];
	                          out[1] = a[1];
	                          out[2] = a[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    8782: (
	                      /***/
	                      function(module3) {
	                        module3.exports = copy;
	                        function copy(out, a) {
	                          out[0] = a[0];
	                          out[1] = a[1];
	                          out[2] = a[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    8501: (
	                      /***/
	                      function(module3) {
	                        module3.exports = create;
	                        function create() {
	                          var out = new Float32Array(3);
	                          out[0] = 0;
	                          out[1] = 0;
	                          out[2] = 0;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    903: (
	                      /***/
	                      function(module3) {
	                        module3.exports = cross;
	                        function cross(out, a, b) {
	                          var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2];
	                          out[0] = ay * bz - az * by;
	                          out[1] = az * bx - ax * bz;
	                          out[2] = ax * by - ay * bx;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5981: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_591790__) {
	                        module3.exports = __nested_webpack_require_591790__(8288);
	                      }
	                    ),
	                    /***/
	                    8288: (
	                      /***/
	                      function(module3) {
	                        module3.exports = distance;
	                        function distance(a, b) {
	                          var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
	                          return Math.sqrt(x * x + y * y + z * z);
	                        }
	                      }
	                    ),
	                    /***/
	                    8629: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_592259__) {
	                        module3.exports = __nested_webpack_require_592259__(7979);
	                      }
	                    ),
	                    /***/
	                    7979: (
	                      /***/
	                      function(module3) {
	                        module3.exports = divide;
	                        function divide(out, a, b) {
	                          out[0] = a[0] / b[0];
	                          out[1] = a[1] / b[1];
	                          out[2] = a[2] / b[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    9305: (
	                      /***/
	                      function(module3) {
	                        module3.exports = dot;
	                        function dot(a, b) {
	                          return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	                        }
	                      }
	                    ),
	                    /***/
	                    154: (
	                      /***/
	                      function(module3) {
	                        module3.exports = 1e-6;
	                      }
	                    ),
	                    /***/
	                    4932: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_593054__) {
	                        module3.exports = equals;
	                        var EPSILON = __nested_webpack_require_593054__(154);
	                        function equals(a, b) {
	                          var a0 = a[0];
	                          var a1 = a[1];
	                          var a2 = a[2];
	                          var b0 = b[0];
	                          var b1 = b[1];
	                          var b2 = b[2];
	                          return Math.abs(a0 - b0) <= EPSILON * Math.max(1, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1, Math.abs(a2), Math.abs(b2));
	                        }
	                      }
	                    ),
	                    /***/
	                    5777: (
	                      /***/
	                      function(module3) {
	                        module3.exports = exactEquals;
	                        function exactEquals(a, b) {
	                          return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
	                        }
	                      }
	                    ),
	                    /***/
	                    3306: (
	                      /***/
	                      function(module3) {
	                        module3.exports = floor;
	                        function floor(out, a) {
	                          out[0] = Math.floor(a[0]);
	                          out[1] = Math.floor(a[1]);
	                          out[2] = Math.floor(a[2]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7447: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_594470__) {
	                        module3.exports = forEach;
	                        var vec = __nested_webpack_require_594470__(8501)();
	                        function forEach(a, stride, offset, count, fn, arg) {
	                          var i, l;
	                          if (!stride) {
	                            stride = 3;
	                          }
	                          if (!offset) {
	                            offset = 0;
	                          }
	                          if (count) {
	                            l = Math.min(count * stride + offset, a.length);
	                          } else {
	                            l = a.length;
	                          }
	                          for (i = offset; i < l; i += stride) {
	                            vec[0] = a[i];
	                            vec[1] = a[i + 1];
	                            vec[2] = a[i + 2];
	                            fn(vec, vec, arg);
	                            a[i] = vec[0];
	                            a[i + 1] = vec[1];
	                            a[i + 2] = vec[2];
	                          }
	                          return a;
	                        }
	                      }
	                    ),
	                    /***/
	                    5415: (
	                      /***/
	                      function(module3) {
	                        module3.exports = fromValues;
	                        function fromValues(x, y, z) {
	                          var out = new Float32Array(3);
	                          out[0] = x;
	                          out[1] = y;
	                          out[2] = z;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    2858: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_595834__) {
	                        module3.exports = { EPSILON: __nested_webpack_require_595834__(154), create: __nested_webpack_require_595834__(8501), clone: __nested_webpack_require_595834__(7622), angle: __nested_webpack_require_595834__(5879), fromValues: __nested_webpack_require_595834__(5415), copy: __nested_webpack_require_595834__(8782), set: __nested_webpack_require_595834__(831), equals: __nested_webpack_require_595834__(4932), exactEquals: __nested_webpack_require_595834__(5777), add: __nested_webpack_require_595834__(2598), subtract: __nested_webpack_require_595834__(911), sub: __nested_webpack_require_595834__(8921), multiply: __nested_webpack_require_595834__(105), mul: __nested_webpack_require_595834__(5733), divide: __nested_webpack_require_595834__(7979), div: __nested_webpack_require_595834__(8629), min: __nested_webpack_require_595834__(3605), max: __nested_webpack_require_595834__(1716), floor: __nested_webpack_require_595834__(3306), ceil: __nested_webpack_require_595834__(8827), round: __nested_webpack_require_595834__(1624), scale: __nested_webpack_require_595834__(5685), scaleAndAdd: __nested_webpack_require_595834__(6722), distance: __nested_webpack_require_595834__(8288), dist: __nested_webpack_require_595834__(5981), squaredDistance: __nested_webpack_require_595834__(6403), sqrDist: __nested_webpack_require_595834__(5294), length: __nested_webpack_require_595834__(4693), len: __nested_webpack_require_595834__(1468), squaredLength: __nested_webpack_require_595834__(4337), sqrLen: __nested_webpack_require_595834__(3303), negate: __nested_webpack_require_595834__(435), inverse: __nested_webpack_require_595834__(2073), normalize: __nested_webpack_require_595834__(899), dot: __nested_webpack_require_595834__(9305), cross: __nested_webpack_require_595834__(903), lerp: __nested_webpack_require_595834__(1868), random: __nested_webpack_require_595834__(6660), transformMat4: __nested_webpack_require_595834__(3255), transformMat3: __nested_webpack_require_595834__(9908), transformQuat: __nested_webpack_require_595834__(6568), rotateX: __nested_webpack_require_595834__(392), rotateY: __nested_webpack_require_595834__(3222), rotateZ: __nested_webpack_require_595834__(3388), forEach: __nested_webpack_require_595834__(7447) };
	                      }
	                    ),
	                    /***/
	                    2073: (
	                      /***/
	                      function(module3) {
	                        module3.exports = inverse;
	                        function inverse(out, a) {
	                          out[0] = 1 / a[0];
	                          out[1] = 1 / a[1];
	                          out[2] = 1 / a[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1468: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_597746__) {
	                        module3.exports = __nested_webpack_require_597746__(4693);
	                      }
	                    ),
	                    /***/
	                    4693: (
	                      /***/
	                      function(module3) {
	                        module3.exports = length;
	                        function length(a) {
	                          var x = a[0], y = a[1], z = a[2];
	                          return Math.sqrt(x * x + y * y + z * z);
	                        }
	                      }
	                    ),
	                    /***/
	                    1868: (
	                      /***/
	                      function(module3) {
	                        module3.exports = lerp;
	                        function lerp(out, a, b, t) {
	                          var ax = a[0], ay = a[1], az = a[2];
	                          out[0] = ax + t * (b[0] - ax);
	                          out[1] = ay + t * (b[1] - ay);
	                          out[2] = az + t * (b[2] - az);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1716: (
	                      /***/
	                      function(module3) {
	                        module3.exports = max;
	                        function max(out, a, b) {
	                          out[0] = Math.max(a[0], b[0]);
	                          out[1] = Math.max(a[1], b[1]);
	                          out[2] = Math.max(a[2], b[2]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3605: (
	                      /***/
	                      function(module3) {
	                        module3.exports = min;
	                        function min(out, a, b) {
	                          out[0] = Math.min(a[0], b[0]);
	                          out[1] = Math.min(a[1], b[1]);
	                          out[2] = Math.min(a[2], b[2]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5733: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_599313__) {
	                        module3.exports = __nested_webpack_require_599313__(105);
	                      }
	                    ),
	                    /***/
	                    105: (
	                      /***/
	                      function(module3) {
	                        module3.exports = multiply;
	                        function multiply(out, a, b) {
	                          out[0] = a[0] * b[0];
	                          out[1] = a[1] * b[1];
	                          out[2] = a[2] * b[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    435: (
	                      /***/
	                      function(module3) {
	                        module3.exports = negate;
	                        function negate(out, a) {
	                          out[0] = -a[0];
	                          out[1] = -a[1];
	                          out[2] = -a[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    899: (
	                      /***/
	                      function(module3) {
	                        module3.exports = normalize;
	                        function normalize(out, a) {
	                          var x = a[0], y = a[1], z = a[2];
	                          var len = x * x + y * y + z * z;
	                          if (len > 0) {
	                            len = 1 / Math.sqrt(len);
	                            out[0] = a[0] * len;
	                            out[1] = a[1] * len;
	                            out[2] = a[2] * len;
	                          }
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6660: (
	                      /***/
	                      function(module3) {
	                        module3.exports = random;
	                        function random(out, scale) {
	                          scale = scale || 1;
	                          var r = Math.random() * 2 * Math.PI;
	                          var z = Math.random() * 2 - 1;
	                          var zScale = Math.sqrt(1 - z * z) * scale;
	                          out[0] = Math.cos(r) * zScale;
	                          out[1] = Math.sin(r) * zScale;
	                          out[2] = z * scale;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    392: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotateX;
	                        function rotateX(out, a, b, c) {
	                          var by = b[1];
	                          var bz = b[2];
	                          var py = a[1] - by;
	                          var pz = a[2] - bz;
	                          var sc = Math.sin(c);
	                          var cc = Math.cos(c);
	                          out[0] = a[0];
	                          out[1] = by + py * cc - pz * sc;
	                          out[2] = bz + py * sc + pz * cc;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3222: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotateY;
	                        function rotateY(out, a, b, c) {
	                          var bx = b[0];
	                          var bz = b[2];
	                          var px = a[0] - bx;
	                          var pz = a[2] - bz;
	                          var sc = Math.sin(c);
	                          var cc = Math.cos(c);
	                          out[0] = bx + pz * sc + px * cc;
	                          out[1] = a[1];
	                          out[2] = bz + pz * cc - px * sc;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3388: (
	                      /***/
	                      function(module3) {
	                        module3.exports = rotateZ;
	                        function rotateZ(out, a, b, c) {
	                          var bx = b[0];
	                          var by = b[1];
	                          var px = a[0] - bx;
	                          var py = a[1] - by;
	                          var sc = Math.sin(c);
	                          var cc = Math.cos(c);
	                          out[0] = bx + px * cc - py * sc;
	                          out[1] = by + px * sc + py * cc;
	                          out[2] = a[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1624: (
	                      /***/
	                      function(module3) {
	                        module3.exports = round;
	                        function round(out, a) {
	                          out[0] = Math.round(a[0]);
	                          out[1] = Math.round(a[1]);
	                          out[2] = Math.round(a[2]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5685: (
	                      /***/
	                      function(module3) {
	                        module3.exports = scale;
	                        function scale(out, a, b) {
	                          out[0] = a[0] * b;
	                          out[1] = a[1] * b;
	                          out[2] = a[2] * b;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6722: (
	                      /***/
	                      function(module3) {
	                        module3.exports = scaleAndAdd;
	                        function scaleAndAdd(out, a, b, scale) {
	                          out[0] = a[0] + b[0] * scale;
	                          out[1] = a[1] + b[1] * scale;
	                          out[2] = a[2] + b[2] * scale;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    831: (
	                      /***/
	                      function(module3) {
	                        module3.exports = set;
	                        function set(out, x, y, z) {
	                          out[0] = x;
	                          out[1] = y;
	                          out[2] = z;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5294: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_604160__) {
	                        module3.exports = __nested_webpack_require_604160__(6403);
	                      }
	                    ),
	                    /***/
	                    3303: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_604285__) {
	                        module3.exports = __nested_webpack_require_604285__(4337);
	                      }
	                    ),
	                    /***/
	                    6403: (
	                      /***/
	                      function(module3) {
	                        module3.exports = squaredDistance;
	                        function squaredDistance(a, b) {
	                          var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
	                          return x * x + y * y + z * z;
	                        }
	                      }
	                    ),
	                    /***/
	                    4337: (
	                      /***/
	                      function(module3) {
	                        module3.exports = squaredLength;
	                        function squaredLength(a) {
	                          var x = a[0], y = a[1], z = a[2];
	                          return x * x + y * y + z * z;
	                        }
	                      }
	                    ),
	                    /***/
	                    8921: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_605063__) {
	                        module3.exports = __nested_webpack_require_605063__(911);
	                      }
	                    ),
	                    /***/
	                    911: (
	                      /***/
	                      function(module3) {
	                        module3.exports = subtract;
	                        function subtract(out, a, b) {
	                          out[0] = a[0] - b[0];
	                          out[1] = a[1] - b[1];
	                          out[2] = a[2] - b[2];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    9908: (
	                      /***/
	                      function(module3) {
	                        module3.exports = transformMat3;
	                        function transformMat3(out, a, m) {
	                          var x = a[0], y = a[1], z = a[2];
	                          out[0] = x * m[0] + y * m[3] + z * m[6];
	                          out[1] = x * m[1] + y * m[4] + z * m[7];
	                          out[2] = x * m[2] + y * m[5] + z * m[8];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3255: (
	                      /***/
	                      function(module3) {
	                        module3.exports = transformMat4;
	                        function transformMat4(out, a, m) {
	                          var x = a[0], y = a[1], z = a[2], w = m[3] * x + m[7] * y + m[11] * z + m[15];
	                          w = w || 1;
	                          out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
	                          out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
	                          out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6568: (
	                      /***/
	                      function(module3) {
	                        module3.exports = transformQuat;
	                        function transformQuat(out, a, q) {
	                          var x = a[0], y = a[1], z = a[2], qx = q[0], qy = q[1], qz = q[2], qw = q[3], ix = qw * x + qy * z - qz * y, iy = qw * y + qz * x - qx * z, iz = qw * z + qx * y - qy * x, iw = -qx * x - qy * y - qz * z;
	                          out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
	                          out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
	                          out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3433: (
	                      /***/
	                      function(module3) {
	                        module3.exports = add;
	                        function add(out, a, b) {
	                          out[0] = a[0] + b[0];
	                          out[1] = a[1] + b[1];
	                          out[2] = a[2] + b[2];
	                          out[3] = a[3] + b[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1413: (
	                      /***/
	                      function(module3) {
	                        module3.exports = clone;
	                        function clone(a) {
	                          var out = new Float32Array(4);
	                          out[0] = a[0];
	                          out[1] = a[1];
	                          out[2] = a[2];
	                          out[3] = a[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3470: (
	                      /***/
	                      function(module3) {
	                        module3.exports = copy;
	                        function copy(out, a) {
	                          out[0] = a[0];
	                          out[1] = a[1];
	                          out[2] = a[2];
	                          out[3] = a[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5313: (
	                      /***/
	                      function(module3) {
	                        module3.exports = create;
	                        function create() {
	                          var out = new Float32Array(4);
	                          out[0] = 0;
	                          out[1] = 0;
	                          out[2] = 0;
	                          out[3] = 0;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5446: (
	                      /***/
	                      function(module3) {
	                        module3.exports = distance;
	                        function distance(a, b) {
	                          var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2], w = b[3] - a[3];
	                          return Math.sqrt(x * x + y * y + z * z + w * w);
	                        }
	                      }
	                    ),
	                    /***/
	                    205: (
	                      /***/
	                      function(module3) {
	                        module3.exports = divide;
	                        function divide(out, a, b) {
	                          out[0] = a[0] / b[0];
	                          out[1] = a[1] / b[1];
	                          out[2] = a[2] / b[2];
	                          out[3] = a[3] / b[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    4242: (
	                      /***/
	                      function(module3) {
	                        module3.exports = dot;
	                        function dot(a, b) {
	                          return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	                        }
	                      }
	                    ),
	                    /***/
	                    5680: (
	                      /***/
	                      function(module3) {
	                        module3.exports = fromValues;
	                        function fromValues(x, y, z, w) {
	                          var out = new Float32Array(4);
	                          out[0] = x;
	                          out[1] = y;
	                          out[2] = z;
	                          out[3] = w;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    4020: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_609729__) {
	                        module3.exports = { create: __nested_webpack_require_609729__(5313), clone: __nested_webpack_require_609729__(1413), fromValues: __nested_webpack_require_609729__(5680), copy: __nested_webpack_require_609729__(3470), set: __nested_webpack_require_609729__(6453), add: __nested_webpack_require_609729__(3433), subtract: __nested_webpack_require_609729__(2705), multiply: __nested_webpack_require_609729__(746), divide: __nested_webpack_require_609729__(205), min: __nested_webpack_require_609729__(2170), max: __nested_webpack_require_609729__(3030), scale: __nested_webpack_require_609729__(5510), scaleAndAdd: __nested_webpack_require_609729__(4224), distance: __nested_webpack_require_609729__(5446), squaredDistance: __nested_webpack_require_609729__(1542), length: __nested_webpack_require_609729__(8177), squaredLength: __nested_webpack_require_609729__(9037), negate: __nested_webpack_require_609729__(6459), inverse: __nested_webpack_require_609729__(8057), normalize: __nested_webpack_require_609729__(381), dot: __nested_webpack_require_609729__(4242), lerp: __nested_webpack_require_609729__(8746), random: __nested_webpack_require_609729__(3770), transformMat4: __nested_webpack_require_609729__(6342), transformQuat: __nested_webpack_require_609729__(5022) };
	                      }
	                    ),
	                    /***/
	                    8057: (
	                      /***/
	                      function(module3) {
	                        module3.exports = inverse;
	                        function inverse(out, a) {
	                          out[0] = 1 / a[0];
	                          out[1] = 1 / a[1];
	                          out[2] = 1 / a[2];
	                          out[3] = 1 / a[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    8177: (
	                      /***/
	                      function(module3) {
	                        module3.exports = length;
	                        function length(a) {
	                          var x = a[0], y = a[1], z = a[2], w = a[3];
	                          return Math.sqrt(x * x + y * y + z * z + w * w);
	                        }
	                      }
	                    ),
	                    /***/
	                    8746: (
	                      /***/
	                      function(module3) {
	                        module3.exports = lerp;
	                        function lerp(out, a, b, t) {
	                          var ax = a[0], ay = a[1], az = a[2], aw = a[3];
	                          out[0] = ax + t * (b[0] - ax);
	                          out[1] = ay + t * (b[1] - ay);
	                          out[2] = az + t * (b[2] - az);
	                          out[3] = aw + t * (b[3] - aw);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3030: (
	                      /***/
	                      function(module3) {
	                        module3.exports = max;
	                        function max(out, a, b) {
	                          out[0] = Math.max(a[0], b[0]);
	                          out[1] = Math.max(a[1], b[1]);
	                          out[2] = Math.max(a[2], b[2]);
	                          out[3] = Math.max(a[3], b[3]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    2170: (
	                      /***/
	                      function(module3) {
	                        module3.exports = min;
	                        function min(out, a, b) {
	                          out[0] = Math.min(a[0], b[0]);
	                          out[1] = Math.min(a[1], b[1]);
	                          out[2] = Math.min(a[2], b[2]);
	                          out[3] = Math.min(a[3], b[3]);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    746: (
	                      /***/
	                      function(module3) {
	                        module3.exports = multiply;
	                        function multiply(out, a, b) {
	                          out[0] = a[0] * b[0];
	                          out[1] = a[1] * b[1];
	                          out[2] = a[2] * b[2];
	                          out[3] = a[3] * b[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6459: (
	                      /***/
	                      function(module3) {
	                        module3.exports = negate;
	                        function negate(out, a) {
	                          out[0] = -a[0];
	                          out[1] = -a[1];
	                          out[2] = -a[2];
	                          out[3] = -a[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    381: (
	                      /***/
	                      function(module3) {
	                        module3.exports = normalize;
	                        function normalize(out, a) {
	                          var x = a[0], y = a[1], z = a[2], w = a[3];
	                          var len = x * x + y * y + z * z + w * w;
	                          if (len > 0) {
	                            len = 1 / Math.sqrt(len);
	                            out[0] = x * len;
	                            out[1] = y * len;
	                            out[2] = z * len;
	                            out[3] = w * len;
	                          }
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    3770: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_613555__) {
	                        var vecNormalize = __nested_webpack_require_613555__(381);
	                        var vecScale = __nested_webpack_require_613555__(5510);
	                        module3.exports = random;
	                        function random(out, scale) {
	                          scale = scale || 1;
	                          out[0] = Math.random();
	                          out[1] = Math.random();
	                          out[2] = Math.random();
	                          out[3] = Math.random();
	                          vecNormalize(out, out);
	                          vecScale(out, out, scale);
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5510: (
	                      /***/
	                      function(module3) {
	                        module3.exports = scale;
	                        function scale(out, a, b) {
	                          out[0] = a[0] * b;
	                          out[1] = a[1] * b;
	                          out[2] = a[2] * b;
	                          out[3] = a[3] * b;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    4224: (
	                      /***/
	                      function(module3) {
	                        module3.exports = scaleAndAdd;
	                        function scaleAndAdd(out, a, b, scale) {
	                          out[0] = a[0] + b[0] * scale;
	                          out[1] = a[1] + b[1] * scale;
	                          out[2] = a[2] + b[2] * scale;
	                          out[3] = a[3] + b[3] * scale;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6453: (
	                      /***/
	                      function(module3) {
	                        module3.exports = set;
	                        function set(out, x, y, z, w) {
	                          out[0] = x;
	                          out[1] = y;
	                          out[2] = z;
	                          out[3] = w;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    1542: (
	                      /***/
	                      function(module3) {
	                        module3.exports = squaredDistance;
	                        function squaredDistance(a, b) {
	                          var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2], w = b[3] - a[3];
	                          return x * x + y * y + z * z + w * w;
	                        }
	                      }
	                    ),
	                    /***/
	                    9037: (
	                      /***/
	                      function(module3) {
	                        module3.exports = squaredLength;
	                        function squaredLength(a) {
	                          var x = a[0], y = a[1], z = a[2], w = a[3];
	                          return x * x + y * y + z * z + w * w;
	                        }
	                      }
	                    ),
	                    /***/
	                    2705: (
	                      /***/
	                      function(module3) {
	                        module3.exports = subtract;
	                        function subtract(out, a, b) {
	                          out[0] = a[0] - b[0];
	                          out[1] = a[1] - b[1];
	                          out[2] = a[2] - b[2];
	                          out[3] = a[3] - b[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    6342: (
	                      /***/
	                      function(module3) {
	                        module3.exports = transformMat4;
	                        function transformMat4(out, a, m) {
	                          var x = a[0], y = a[1], z = a[2], w = a[3];
	                          out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
	                          out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
	                          out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
	                          out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    5022: (
	                      /***/
	                      function(module3) {
	                        module3.exports = transformQuat;
	                        function transformQuat(out, a, q) {
	                          var x = a[0], y = a[1], z = a[2], qx = q[0], qy = q[1], qz = q[2], qw = q[3], ix = qw * x + qy * z - qz * y, iy = qw * y + qz * x - qx * z, iz = qw * z + qx * y - qy * x, iw = -qx * x - qy * y - qz * z;
	                          out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
	                          out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
	                          out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
	                          out[3] = a[3];
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    9365: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_617604__) {
	                        var tokenize = __nested_webpack_require_617604__(8096);
	                        var atob2 = __nested_webpack_require_617604__(7896);
	                        module3.exports = getName;
	                        function getName(src) {
	                          var tokens = Array.isArray(src) ? src : tokenize(src);
	                          for (var i = 0; i < tokens.length; i++) {
	                            var token = tokens[i];
	                            if (token.type !== "preprocessor") continue;
	                            var match = token.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);
	                            if (!match) continue;
	                            if (!match[2]) continue;
	                            var b64 = match[1];
	                            var name2 = match[2];
	                            return (b64 ? atob2(name2) : name2).trim();
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    3193: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_618129__) {
	                        module3.exports = tokenize;
	                        var literals100 = __nested_webpack_require_618129__(399), operators = __nested_webpack_require_618129__(9746), builtins100 = __nested_webpack_require_618129__(9525), literals300es = __nested_webpack_require_618129__(9458), builtins300es = __nested_webpack_require_618129__(3585);
	                        var NORMAL = 999, TOKEN = 9999, BLOCK_COMMENT = 0, LINE_COMMENT = 1, PREPROCESSOR = 2, OPERATOR = 3, INTEGER = 4, FLOAT = 5, IDENT = 6, BUILTIN = 7, KEYWORD = 8, WHITESPACE = 9, EOF = 10, HEX = 11;
	                        var map2 = ["block-comment", "line-comment", "preprocessor", "operator", "integer", "float", "ident", "builtin", "keyword", "whitespace", "eof", "integer"];
	                        function tokenize(opt) {
	                          var i = 0, total = 0, mode = NORMAL, c, last, content = [], tokens = [], line = 1, col = 0, start = 0, isnum = false, isoperator = false, input = "", len;
	                          opt = opt || {};
	                          var allBuiltins = builtins100;
	                          var allLiterals = literals100;
	                          if (opt.version === "300 es") {
	                            allBuiltins = builtins300es;
	                            allLiterals = literals300es;
	                          }
	                          var builtinsDict = {}, literalsDict = {};
	                          for (var i = 0; i < allBuiltins.length; i++) {
	                            builtinsDict[allBuiltins[i]] = true;
	                          }
	                          for (var i = 0; i < allLiterals.length; i++) {
	                            literalsDict[allLiterals[i]] = true;
	                          }
	                          return function(data) {
	                            tokens = [];
	                            if (data !== null) return write(data);
	                            return end();
	                          };
	                          function token(data) {
	                            if (data.length) {
	                              tokens.push({ type: map2[mode], data, position: start, line, column: col });
	                            }
	                          }
	                          function write(chunk) {
	                            i = 0;
	                            if (chunk.toString) chunk = chunk.toString();
	                            input += chunk.replace(/\r\n/g, "\n");
	                            len = input.length;
	                            var last2;
	                            while (c = input[i], i < len) {
	                              last2 = i;
	                              switch (mode) {
	                                case BLOCK_COMMENT:
	                                  i = block_comment();
	                                  break;
	                                case LINE_COMMENT:
	                                  i = line_comment();
	                                  break;
	                                case PREPROCESSOR:
	                                  i = preprocessor();
	                                  break;
	                                case OPERATOR:
	                                  i = operator();
	                                  break;
	                                case INTEGER:
	                                  i = integer();
	                                  break;
	                                case HEX:
	                                  i = hex();
	                                  break;
	                                case FLOAT:
	                                  i = decimal();
	                                  break;
	                                case TOKEN:
	                                  i = readtoken();
	                                  break;
	                                case WHITESPACE:
	                                  i = whitespace();
	                                  break;
	                                case NORMAL:
	                                  i = normal();
	                                  break;
	                              }
	                              if (last2 !== i) {
	                                switch (input[last2]) {
	                                  case "\n":
	                                    col = 0;
	                                    ++line;
	                                    break;
	                                  default:
	                                    ++col;
	                                    break;
	                                }
	                              }
	                            }
	                            total += i;
	                            input = input.slice(i);
	                            return tokens;
	                          }
	                          function end(chunk) {
	                            if (content.length) {
	                              token(content.join(""));
	                            }
	                            mode = EOF;
	                            token("(eof)");
	                            return tokens;
	                          }
	                          function normal() {
	                            content = content.length ? [] : content;
	                            if (last === "/" && c === "*") {
	                              start = total + i - 1;
	                              mode = BLOCK_COMMENT;
	                              last = c;
	                              return i + 1;
	                            }
	                            if (last === "/" && c === "/") {
	                              start = total + i - 1;
	                              mode = LINE_COMMENT;
	                              last = c;
	                              return i + 1;
	                            }
	                            if (c === "#") {
	                              mode = PREPROCESSOR;
	                              start = total + i;
	                              return i;
	                            }
	                            if (/\s/.test(c)) {
	                              mode = WHITESPACE;
	                              start = total + i;
	                              return i;
	                            }
	                            isnum = /\d/.test(c);
	                            isoperator = /[^\w_]/.test(c);
	                            start = total + i;
	                            mode = isnum ? INTEGER : isoperator ? OPERATOR : TOKEN;
	                            return i;
	                          }
	                          function whitespace() {
	                            if (/[^\s]/g.test(c)) {
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function preprocessor() {
	                            if ((c === "\r" || c === "\n") && last !== "\\") {
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function line_comment() {
	                            return preprocessor();
	                          }
	                          function block_comment() {
	                            if (c === "/" && last === "*") {
	                              content.push(c);
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i + 1;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function operator() {
	                            if (last === "." && /\d/.test(c)) {
	                              mode = FLOAT;
	                              return i;
	                            }
	                            if (last === "/" && c === "*") {
	                              mode = BLOCK_COMMENT;
	                              return i;
	                            }
	                            if (last === "/" && c === "/") {
	                              mode = LINE_COMMENT;
	                              return i;
	                            }
	                            if (c === "." && content.length) {
	                              while (determine_operator(content)) ;
	                              mode = FLOAT;
	                              return i;
	                            }
	                            if (c === ";" || c === ")" || c === "(") {
	                              if (content.length) while (determine_operator(content)) ;
	                              token(c);
	                              mode = NORMAL;
	                              return i + 1;
	                            }
	                            var is_composite_operator = content.length === 2 && c !== "=";
	                            if (/[\w_\d\s]/.test(c) || is_composite_operator) {
	                              while (determine_operator(content)) ;
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function determine_operator(buf) {
	                            var j = 0, idx, res;
	                            do {
	                              idx = operators.indexOf(buf.slice(0, buf.length + j).join(""));
	                              res = operators[idx];
	                              if (idx === -1) {
	                                if (j-- + buf.length > 0) continue;
	                                res = buf.slice(0, 1).join("");
	                              }
	                              token(res);
	                              start += res.length;
	                              content = content.slice(res.length);
	                              return content.length;
	                            } while (1);
	                          }
	                          function hex() {
	                            if (/[^a-fA-F0-9]/.test(c)) {
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function integer() {
	                            if (c === ".") {
	                              content.push(c);
	                              mode = FLOAT;
	                              last = c;
	                              return i + 1;
	                            }
	                            if (/[eE]/.test(c)) {
	                              content.push(c);
	                              mode = FLOAT;
	                              last = c;
	                              return i + 1;
	                            }
	                            if (c === "x" && content.length === 1 && content[0] === "0") {
	                              mode = HEX;
	                              content.push(c);
	                              last = c;
	                              return i + 1;
	                            }
	                            if (/[^\d]/.test(c)) {
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function decimal() {
	                            if (c === "f") {
	                              content.push(c);
	                              last = c;
	                              i += 1;
	                            }
	                            if (/[eE]/.test(c)) {
	                              content.push(c);
	                              last = c;
	                              return i + 1;
	                            }
	                            if ((c === "-" || c === "+") && /[eE]/.test(last)) {
	                              content.push(c);
	                              last = c;
	                              return i + 1;
	                            }
	                            if (/[^\d]/.test(c)) {
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                          function readtoken() {
	                            if (/[^\d\w_]/.test(c)) {
	                              var contentstr = content.join("");
	                              if (literalsDict[contentstr]) {
	                                mode = KEYWORD;
	                              } else if (builtinsDict[contentstr]) {
	                                mode = BUILTIN;
	                              } else {
	                                mode = IDENT;
	                              }
	                              token(content.join(""));
	                              mode = NORMAL;
	                              return i;
	                            }
	                            content.push(c);
	                            last = c;
	                            return i + 1;
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    3585: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_623003__) {
	                        var v100 = __nested_webpack_require_623003__(9525);
	                        v100 = v100.slice().filter(function(b) {
	                          return !/^(gl\_|texture)/.test(b);
	                        });
	                        module3.exports = v100.concat([
	                          // the updated gl_ constants
	                          "gl_VertexID",
	                          "gl_InstanceID",
	                          "gl_Position",
	                          "gl_PointSize",
	                          "gl_FragCoord",
	                          "gl_FrontFacing",
	                          "gl_FragDepth",
	                          "gl_PointCoord",
	                          "gl_MaxVertexAttribs",
	                          "gl_MaxVertexUniformVectors",
	                          "gl_MaxVertexOutputVectors",
	                          "gl_MaxFragmentInputVectors",
	                          "gl_MaxVertexTextureImageUnits",
	                          "gl_MaxCombinedTextureImageUnits",
	                          "gl_MaxTextureImageUnits",
	                          "gl_MaxFragmentUniformVectors",
	                          "gl_MaxDrawBuffers",
	                          "gl_MinProgramTexelOffset",
	                          "gl_MaxProgramTexelOffset",
	                          "gl_DepthRangeParameters",
	                          "gl_DepthRange",
	                          "trunc",
	                          "round",
	                          "roundEven",
	                          "isnan",
	                          "isinf",
	                          "floatBitsToInt",
	                          "floatBitsToUint",
	                          "intBitsToFloat",
	                          "uintBitsToFloat",
	                          "packSnorm2x16",
	                          "unpackSnorm2x16",
	                          "packUnorm2x16",
	                          "unpackUnorm2x16",
	                          "packHalf2x16",
	                          "unpackHalf2x16",
	                          "outerProduct",
	                          "transpose",
	                          "determinant",
	                          "inverse",
	                          "texture",
	                          "textureSize",
	                          "textureProj",
	                          "textureLod",
	                          "textureOffset",
	                          "texelFetch",
	                          "texelFetchOffset",
	                          "textureProjOffset",
	                          "textureLodOffset",
	                          "textureProjLod",
	                          "textureProjLodOffset",
	                          "textureGrad",
	                          "textureGradOffset",
	                          "textureProjGrad",
	                          "textureProjGradOffset"
	                        ]);
	                      }
	                    ),
	                    /***/
	                    9525: (
	                      /***/
	                      function(module3) {
	                        module3.exports = [
	                          // Keep this list sorted
	                          "abs",
	                          "acos",
	                          "all",
	                          "any",
	                          "asin",
	                          "atan",
	                          "ceil",
	                          "clamp",
	                          "cos",
	                          "cross",
	                          "dFdx",
	                          "dFdy",
	                          "degrees",
	                          "distance",
	                          "dot",
	                          "equal",
	                          "exp",
	                          "exp2",
	                          "faceforward",
	                          "floor",
	                          "fract",
	                          "gl_BackColor",
	                          "gl_BackLightModelProduct",
	                          "gl_BackLightProduct",
	                          "gl_BackMaterial",
	                          "gl_BackSecondaryColor",
	                          "gl_ClipPlane",
	                          "gl_ClipVertex",
	                          "gl_Color",
	                          "gl_DepthRange",
	                          "gl_DepthRangeParameters",
	                          "gl_EyePlaneQ",
	                          "gl_EyePlaneR",
	                          "gl_EyePlaneS",
	                          "gl_EyePlaneT",
	                          "gl_Fog",
	                          "gl_FogCoord",
	                          "gl_FogFragCoord",
	                          "gl_FogParameters",
	                          "gl_FragColor",
	                          "gl_FragCoord",
	                          "gl_FragData",
	                          "gl_FragDepth",
	                          "gl_FragDepthEXT",
	                          "gl_FrontColor",
	                          "gl_FrontFacing",
	                          "gl_FrontLightModelProduct",
	                          "gl_FrontLightProduct",
	                          "gl_FrontMaterial",
	                          "gl_FrontSecondaryColor",
	                          "gl_LightModel",
	                          "gl_LightModelParameters",
	                          "gl_LightModelProducts",
	                          "gl_LightProducts",
	                          "gl_LightSource",
	                          "gl_LightSourceParameters",
	                          "gl_MaterialParameters",
	                          "gl_MaxClipPlanes",
	                          "gl_MaxCombinedTextureImageUnits",
	                          "gl_MaxDrawBuffers",
	                          "gl_MaxFragmentUniformComponents",
	                          "gl_MaxLights",
	                          "gl_MaxTextureCoords",
	                          "gl_MaxTextureImageUnits",
	                          "gl_MaxTextureUnits",
	                          "gl_MaxVaryingFloats",
	                          "gl_MaxVertexAttribs",
	                          "gl_MaxVertexTextureImageUnits",
	                          "gl_MaxVertexUniformComponents",
	                          "gl_ModelViewMatrix",
	                          "gl_ModelViewMatrixInverse",
	                          "gl_ModelViewMatrixInverseTranspose",
	                          "gl_ModelViewMatrixTranspose",
	                          "gl_ModelViewProjectionMatrix",
	                          "gl_ModelViewProjectionMatrixInverse",
	                          "gl_ModelViewProjectionMatrixInverseTranspose",
	                          "gl_ModelViewProjectionMatrixTranspose",
	                          "gl_MultiTexCoord0",
	                          "gl_MultiTexCoord1",
	                          "gl_MultiTexCoord2",
	                          "gl_MultiTexCoord3",
	                          "gl_MultiTexCoord4",
	                          "gl_MultiTexCoord5",
	                          "gl_MultiTexCoord6",
	                          "gl_MultiTexCoord7",
	                          "gl_Normal",
	                          "gl_NormalMatrix",
	                          "gl_NormalScale",
	                          "gl_ObjectPlaneQ",
	                          "gl_ObjectPlaneR",
	                          "gl_ObjectPlaneS",
	                          "gl_ObjectPlaneT",
	                          "gl_Point",
	                          "gl_PointCoord",
	                          "gl_PointParameters",
	                          "gl_PointSize",
	                          "gl_Position",
	                          "gl_ProjectionMatrix",
	                          "gl_ProjectionMatrixInverse",
	                          "gl_ProjectionMatrixInverseTranspose",
	                          "gl_ProjectionMatrixTranspose",
	                          "gl_SecondaryColor",
	                          "gl_TexCoord",
	                          "gl_TextureEnvColor",
	                          "gl_TextureMatrix",
	                          "gl_TextureMatrixInverse",
	                          "gl_TextureMatrixInverseTranspose",
	                          "gl_TextureMatrixTranspose",
	                          "gl_Vertex",
	                          "greaterThan",
	                          "greaterThanEqual",
	                          "inversesqrt",
	                          "length",
	                          "lessThan",
	                          "lessThanEqual",
	                          "log",
	                          "log2",
	                          "matrixCompMult",
	                          "max",
	                          "min",
	                          "mix",
	                          "mod",
	                          "normalize",
	                          "not",
	                          "notEqual",
	                          "pow",
	                          "radians",
	                          "reflect",
	                          "refract",
	                          "sign",
	                          "sin",
	                          "smoothstep",
	                          "sqrt",
	                          "step",
	                          "tan",
	                          "texture2D",
	                          "texture2DLod",
	                          "texture2DProj",
	                          "texture2DProjLod",
	                          "textureCube",
	                          "textureCubeLod",
	                          "texture2DLodEXT",
	                          "texture2DProjLodEXT",
	                          "textureCubeLodEXT",
	                          "texture2DGradEXT",
	                          "texture2DProjGradEXT",
	                          "textureCubeGradEXT"
	                        ];
	                      }
	                    ),
	                    /***/
	                    9458: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_627009__) {
	                        var v100 = __nested_webpack_require_627009__(399);
	                        module3.exports = v100.slice().concat(["layout", "centroid", "smooth", "case", "mat2x2", "mat2x3", "mat2x4", "mat3x2", "mat3x3", "mat3x4", "mat4x2", "mat4x3", "mat4x4", "uvec2", "uvec3", "uvec4", "samplerCubeShadow", "sampler2DArray", "sampler2DArrayShadow", "isampler2D", "isampler3D", "isamplerCube", "isampler2DArray", "usampler2D", "usampler3D", "usamplerCube", "usampler2DArray", "coherent", "restrict", "readonly", "writeonly", "resource", "atomic_uint", "noperspective", "patch", "sample", "subroutine", "common", "partition", "active", "filter", "image1D", "image2D", "image3D", "imageCube", "iimage1D", "iimage2D", "iimage3D", "iimageCube", "uimage1D", "uimage2D", "uimage3D", "uimageCube", "image1DArray", "image2DArray", "iimage1DArray", "iimage2DArray", "uimage1DArray", "uimage2DArray", "image1DShadow", "image2DShadow", "image1DArrayShadow", "image2DArrayShadow", "imageBuffer", "iimageBuffer", "uimageBuffer", "sampler1DArray", "sampler1DArrayShadow", "isampler1D", "isampler1DArray", "usampler1D", "usampler1DArray", "isampler2DRect", "usampler2DRect", "samplerBuffer", "isamplerBuffer", "usamplerBuffer", "sampler2DMS", "isampler2DMS", "usampler2DMS", "sampler2DMSArray", "isampler2DMSArray", "usampler2DMSArray"]);
	                      }
	                    ),
	                    /***/
	                    399: (
	                      /***/
	                      function(module3) {
	                        module3.exports = [
	                          // current
	                          "precision",
	                          "highp",
	                          "mediump",
	                          "lowp",
	                          "attribute",
	                          "const",
	                          "uniform",
	                          "varying",
	                          "break",
	                          "continue",
	                          "do",
	                          "for",
	                          "while",
	                          "if",
	                          "else",
	                          "in",
	                          "out",
	                          "inout",
	                          "float",
	                          "int",
	                          "uint",
	                          "void",
	                          "bool",
	                          "true",
	                          "false",
	                          "discard",
	                          "return",
	                          "mat2",
	                          "mat3",
	                          "mat4",
	                          "vec2",
	                          "vec3",
	                          "vec4",
	                          "ivec2",
	                          "ivec3",
	                          "ivec4",
	                          "bvec2",
	                          "bvec3",
	                          "bvec4",
	                          "sampler1D",
	                          "sampler2D",
	                          "sampler3D",
	                          "samplerCube",
	                          "sampler1DShadow",
	                          "sampler2DShadow",
	                          "struct",
	                          "asm",
	                          "class",
	                          "union",
	                          "enum",
	                          "typedef",
	                          "template",
	                          "this",
	                          "packed",
	                          "goto",
	                          "switch",
	                          "default",
	                          "inline",
	                          "noinline",
	                          "volatile",
	                          "public",
	                          "static",
	                          "extern",
	                          "external",
	                          "interface",
	                          "long",
	                          "short",
	                          "double",
	                          "half",
	                          "fixed",
	                          "unsigned",
	                          "input",
	                          "output",
	                          "hvec2",
	                          "hvec3",
	                          "hvec4",
	                          "dvec2",
	                          "dvec3",
	                          "dvec4",
	                          "fvec2",
	                          "fvec3",
	                          "fvec4",
	                          "sampler2DRect",
	                          "sampler3DRect",
	                          "sampler2DRectShadow",
	                          "sizeof",
	                          "cast",
	                          "namespace",
	                          "using"
	                        ];
	                      }
	                    ),
	                    /***/
	                    9746: (
	                      /***/
	                      function(module3) {
	                        module3.exports = ["<<=", ">>=", "++", "--", "<<", ">>", "<=", ">=", "==", "!=", "&&", "||", "+=", "-=", "*=", "/=", "%=", "&=", "^^", "^=", "|=", "(", ")", "[", "]", ".", "!", "~", "*", "/", "%", "+", "-", "<", ">", "&", "^", "|", "?", ":", "=", ",", ";", "{", "}"];
	                      }
	                    ),
	                    /***/
	                    8096: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_629411__) {
	                        var tokenize = __nested_webpack_require_629411__(3193);
	                        module3.exports = tokenizeString;
	                        function tokenizeString(str, opt) {
	                          var generator = tokenize(opt);
	                          var tokens = [];
	                          tokens = tokens.concat(generator(str));
	                          tokens = tokens.concat(generator(null));
	                          return tokens;
	                        }
	                      }
	                    ),
	                    /***/
	                    6832: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function(strings) {
	                          if (typeof strings === "string") strings = [strings];
	                          var exprs = [].slice.call(arguments, 1);
	                          var parts = [];
	                          for (var i = 0; i < strings.length - 1; i++) {
	                            parts.push(strings[i], exprs[i] || "");
	                          }
	                          parts.push(strings[i]);
	                          return parts.join("");
	                        };
	                      }
	                    ),
	                    /***/
	                    5233: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_630018__) {
	                        var isBrowser = __nested_webpack_require_630018__(4846);
	                        function detect() {
	                          var supported = false;
	                          try {
	                            var opts = Object.defineProperty({}, "passive", { get: function() {
	                              supported = true;
	                            } });
	                            window.addEventListener("test", null, opts);
	                            window.removeEventListener("test", null, opts);
	                          } catch (e) {
	                            supported = false;
	                          }
	                          return supported;
	                        }
	                        module3.exports = isBrowser && detect();
	                      }
	                    ),
	                    /***/
	                    2183: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_630443__) {
	                        module3.exports = incrementalConvexHull;
	                        var orient = __nested_webpack_require_630443__(417);
	                        var compareCell = __nested_webpack_require_630443__(8211).H;
	                        function Simplex(vertices, adjacent, boundary) {
	                          this.vertices = vertices;
	                          this.adjacent = adjacent;
	                          this.boundary = boundary;
	                          this.lastVisited = -1;
	                        }
	                        Simplex.prototype.flip = function() {
	                          var t = this.vertices[0];
	                          this.vertices[0] = this.vertices[1];
	                          this.vertices[1] = t;
	                          var u = this.adjacent[0];
	                          this.adjacent[0] = this.adjacent[1];
	                          this.adjacent[1] = u;
	                        };
	                        function GlueFacet(vertices, cell, index) {
	                          this.vertices = vertices;
	                          this.cell = cell;
	                          this.index = index;
	                        }
	                        function compareGlue(a, b) {
	                          return compareCell(a.vertices, b.vertices);
	                        }
	                        function wrapper(test) {
	                          return function() {
	                            var tuple = this.tuple;
	                            return test.apply(this, tuple);
	                          };
	                        }
	                        function bakeOrient(d) {
	                          var test = orient[d + 1];
	                          if (!test) {
	                            test = orient;
	                          }
	                          return wrapper(test);
	                        }
	                        var BAKED = [];
	                        function Triangulation(dimension, vertices, simplices) {
	                          this.dimension = dimension;
	                          this.vertices = vertices;
	                          this.simplices = simplices;
	                          this.interior = simplices.filter(function(c) {
	                            return !c.boundary;
	                          });
	                          this.tuple = new Array(dimension + 1);
	                          for (var i = 0; i <= dimension; ++i) {
	                            this.tuple[i] = this.vertices[i];
	                          }
	                          var o = BAKED[dimension];
	                          if (!o) {
	                            o = BAKED[dimension] = bakeOrient(dimension);
	                          }
	                          this.orient = o;
	                        }
	                        var proto = Triangulation.prototype;
	                        proto.handleBoundaryDegeneracy = function(cell, point) {
	                          var d = this.dimension;
	                          var n = this.vertices.length - 1;
	                          var tuple = this.tuple;
	                          var verts = this.vertices;
	                          var toVisit = [cell];
	                          cell.lastVisited = -n;
	                          while (toVisit.length > 0) {
	                            cell = toVisit.pop();
	                            var cellAdj = cell.adjacent;
	                            for (var i = 0; i <= d; ++i) {
	                              var neighbor = cellAdj[i];
	                              if (!neighbor.boundary || neighbor.lastVisited <= -n) {
	                                continue;
	                              }
	                              var nv = neighbor.vertices;
	                              for (var j = 0; j <= d; ++j) {
	                                var vv = nv[j];
	                                if (vv < 0) {
	                                  tuple[j] = point;
	                                } else {
	                                  tuple[j] = verts[vv];
	                                }
	                              }
	                              var o = this.orient();
	                              if (o > 0) {
	                                return neighbor;
	                              }
	                              neighbor.lastVisited = -n;
	                              if (o === 0) {
	                                toVisit.push(neighbor);
	                              }
	                            }
	                          }
	                          return null;
	                        };
	                        proto.walk = function(point, random) {
	                          var n = this.vertices.length - 1;
	                          var d = this.dimension;
	                          var verts = this.vertices;
	                          var tuple = this.tuple;
	                          var initIndex = random ? this.interior.length * Math.random() | 0 : this.interior.length - 1;
	                          var cell = this.interior[initIndex];
	                          outerLoop: while (!cell.boundary) {
	                            var cellVerts = cell.vertices;
	                            var cellAdj = cell.adjacent;
	                            for (var i = 0; i <= d; ++i) {
	                              tuple[i] = verts[cellVerts[i]];
	                            }
	                            cell.lastVisited = n;
	                            for (var i = 0; i <= d; ++i) {
	                              var neighbor = cellAdj[i];
	                              if (neighbor.lastVisited >= n) {
	                                continue;
	                              }
	                              var prev = tuple[i];
	                              tuple[i] = point;
	                              var o = this.orient();
	                              tuple[i] = prev;
	                              if (o < 0) {
	                                cell = neighbor;
	                                continue outerLoop;
	                              } else {
	                                if (!neighbor.boundary) {
	                                  neighbor.lastVisited = n;
	                                } else {
	                                  neighbor.lastVisited = -n;
	                                }
	                              }
	                            }
	                            return;
	                          }
	                          return cell;
	                        };
	                        proto.addPeaks = function(point, cell) {
	                          var n = this.vertices.length - 1;
	                          var d = this.dimension;
	                          var verts = this.vertices;
	                          var tuple = this.tuple;
	                          var interior = this.interior;
	                          var simplices = this.simplices;
	                          var tovisit = [cell];
	                          cell.lastVisited = n;
	                          cell.vertices[cell.vertices.indexOf(-1)] = n;
	                          cell.boundary = false;
	                          interior.push(cell);
	                          var glueFacets = [];
	                          while (tovisit.length > 0) {
	                            var cell = tovisit.pop();
	                            var cellVerts = cell.vertices;
	                            var cellAdj = cell.adjacent;
	                            var indexOfN = cellVerts.indexOf(n);
	                            if (indexOfN < 0) {
	                              continue;
	                            }
	                            for (var i = 0; i <= d; ++i) {
	                              if (i === indexOfN) {
	                                continue;
	                              }
	                              var neighbor = cellAdj[i];
	                              if (!neighbor.boundary || neighbor.lastVisited >= n) {
	                                continue;
	                              }
	                              var nv = neighbor.vertices;
	                              if (neighbor.lastVisited !== -n) {
	                                var indexOfNeg1 = 0;
	                                for (var j = 0; j <= d; ++j) {
	                                  if (nv[j] < 0) {
	                                    indexOfNeg1 = j;
	                                    tuple[j] = point;
	                                  } else {
	                                    tuple[j] = verts[nv[j]];
	                                  }
	                                }
	                                var o = this.orient();
	                                if (o > 0) {
	                                  nv[indexOfNeg1] = n;
	                                  neighbor.boundary = false;
	                                  interior.push(neighbor);
	                                  tovisit.push(neighbor);
	                                  neighbor.lastVisited = n;
	                                  continue;
	                                } else {
	                                  neighbor.lastVisited = -n;
	                                }
	                              }
	                              var na = neighbor.adjacent;
	                              var vverts = cellVerts.slice();
	                              var vadj = cellAdj.slice();
	                              var ncell = new Simplex(vverts, vadj, true);
	                              simplices.push(ncell);
	                              var opposite = na.indexOf(cell);
	                              if (opposite < 0) {
	                                continue;
	                              }
	                              na[opposite] = ncell;
	                              vadj[indexOfN] = neighbor;
	                              vverts[i] = -1;
	                              vadj[i] = cell;
	                              cellAdj[i] = ncell;
	                              ncell.flip();
	                              for (var j = 0; j <= d; ++j) {
	                                var uu = vverts[j];
	                                if (uu < 0 || uu === n) {
	                                  continue;
	                                }
	                                var nface = new Array(d - 1);
	                                var nptr = 0;
	                                for (var k = 0; k <= d; ++k) {
	                                  var vv = vverts[k];
	                                  if (vv < 0 || k === j) {
	                                    continue;
	                                  }
	                                  nface[nptr++] = vv;
	                                }
	                                glueFacets.push(new GlueFacet(nface, ncell, j));
	                              }
	                            }
	                          }
	                          glueFacets.sort(compareGlue);
	                          for (var i = 0; i + 1 < glueFacets.length; i += 2) {
	                            var a = glueFacets[i];
	                            var b = glueFacets[i + 1];
	                            var ai = a.index;
	                            var bi = b.index;
	                            if (ai < 0 || bi < 0) {
	                              continue;
	                            }
	                            a.cell.adjacent[a.index] = b.cell;
	                            b.cell.adjacent[b.index] = a.cell;
	                          }
	                        };
	                        proto.insert = function(point, random) {
	                          var verts = this.vertices;
	                          verts.push(point);
	                          var cell = this.walk(point, random);
	                          if (!cell) {
	                            return;
	                          }
	                          var d = this.dimension;
	                          var tuple = this.tuple;
	                          for (var i = 0; i <= d; ++i) {
	                            var vv = cell.vertices[i];
	                            if (vv < 0) {
	                              tuple[i] = point;
	                            } else {
	                              tuple[i] = verts[vv];
	                            }
	                          }
	                          var o = this.orient(tuple);
	                          if (o < 0) {
	                            return;
	                          } else if (o === 0) {
	                            cell = this.handleBoundaryDegeneracy(cell, point);
	                            if (!cell) {
	                              return;
	                            }
	                          }
	                          this.addPeaks(point, cell);
	                        };
	                        proto.boundary = function() {
	                          var d = this.dimension;
	                          var boundary = [];
	                          var cells = this.simplices;
	                          var nc = cells.length;
	                          for (var i = 0; i < nc; ++i) {
	                            var c = cells[i];
	                            if (c.boundary) {
	                              var bcell = new Array(d);
	                              var cv = c.vertices;
	                              var ptr = 0;
	                              var parity = 0;
	                              for (var j = 0; j <= d; ++j) {
	                                if (cv[j] >= 0) {
	                                  bcell[ptr++] = cv[j];
	                                } else {
	                                  parity = j & 1;
	                                }
	                              }
	                              if (parity === (d & 1)) {
	                                var t = bcell[0];
	                                bcell[0] = bcell[1];
	                                bcell[1] = t;
	                              }
	                              boundary.push(bcell);
	                            }
	                          }
	                          return boundary;
	                        };
	                        function incrementalConvexHull(points, randomSearch) {
	                          var n = points.length;
	                          if (n === 0) {
	                            throw new Error("Must have at least d+1 points");
	                          }
	                          var d = points[0].length;
	                          if (n <= d) {
	                            throw new Error("Must input at least d+1 points");
	                          }
	                          var initialSimplex = points.slice(0, d + 1);
	                          var o = orient.apply(undefined, initialSimplex);
	                          if (o === 0) {
	                            throw new Error("Input not in general position");
	                          }
	                          var initialCoords = new Array(d + 1);
	                          for (var i = 0; i <= d; ++i) {
	                            initialCoords[i] = i;
	                          }
	                          if (o < 0) {
	                            initialCoords[0] = 1;
	                            initialCoords[1] = 0;
	                          }
	                          var initialCell = new Simplex(initialCoords, new Array(d + 1), false);
	                          var boundary = initialCell.adjacent;
	                          var list = new Array(d + 2);
	                          for (var i = 0; i <= d; ++i) {
	                            var verts = initialCoords.slice();
	                            for (var j = 0; j <= d; ++j) {
	                              if (j === i) {
	                                verts[j] = -1;
	                              }
	                            }
	                            var t = verts[0];
	                            verts[0] = verts[1];
	                            verts[1] = t;
	                            var cell = new Simplex(verts, new Array(d + 1), true);
	                            boundary[i] = cell;
	                            list[i] = cell;
	                          }
	                          list[d + 1] = initialCell;
	                          for (var i = 0; i <= d; ++i) {
	                            var verts = boundary[i].vertices;
	                            var adj = boundary[i].adjacent;
	                            for (var j = 0; j <= d; ++j) {
	                              var v = verts[j];
	                              if (v < 0) {
	                                adj[j] = initialCell;
	                                continue;
	                              }
	                              for (var k = 0; k <= d; ++k) {
	                                if (boundary[k].vertices.indexOf(v) < 0) {
	                                  adj[j] = boundary[k];
	                                }
	                              }
	                            }
	                          }
	                          var triangles = new Triangulation(d, initialSimplex, list);
	                          var useRandom = !!randomSearch;
	                          for (var i = d + 1; i < n; ++i) {
	                            triangles.insert(points[i], useRandom);
	                          }
	                          return triangles.boundary();
	                        }
	                      }
	                    ),
	                    /***/
	                    9014: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_638365__) {
	                        var bounds = __nested_webpack_require_638365__(5070);
	                        var NOT_FOUND = 0;
	                        var SUCCESS = 1;
	                        var EMPTY = 2;
	                        module3.exports = createWrapper;
	                        function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
	                          this.mid = mid;
	                          this.left = left;
	                          this.right = right;
	                          this.leftPoints = leftPoints;
	                          this.rightPoints = rightPoints;
	                          this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
	                        }
	                        var proto = IntervalTreeNode.prototype;
	                        function copy(a, b) {
	                          a.mid = b.mid;
	                          a.left = b.left;
	                          a.right = b.right;
	                          a.leftPoints = b.leftPoints;
	                          a.rightPoints = b.rightPoints;
	                          a.count = b.count;
	                        }
	                        function rebuild(node, intervals) {
	                          var ntree = createIntervalTree(intervals);
	                          node.mid = ntree.mid;
	                          node.left = ntree.left;
	                          node.right = ntree.right;
	                          node.leftPoints = ntree.leftPoints;
	                          node.rightPoints = ntree.rightPoints;
	                          node.count = ntree.count;
	                        }
	                        function rebuildWithInterval(node, interval) {
	                          var intervals = node.intervals([]);
	                          intervals.push(interval);
	                          rebuild(node, intervals);
	                        }
	                        function rebuildWithoutInterval(node, interval) {
	                          var intervals = node.intervals([]);
	                          var idx = intervals.indexOf(interval);
	                          if (idx < 0) {
	                            return NOT_FOUND;
	                          }
	                          intervals.splice(idx, 1);
	                          rebuild(node, intervals);
	                          return SUCCESS;
	                        }
	                        proto.intervals = function(result) {
	                          result.push.apply(result, this.leftPoints);
	                          if (this.left) {
	                            this.left.intervals(result);
	                          }
	                          if (this.right) {
	                            this.right.intervals(result);
	                          }
	                          return result;
	                        };
	                        proto.insert = function(interval) {
	                          var weight = this.count - this.leftPoints.length;
	                          this.count += 1;
	                          if (interval[1] < this.mid) {
	                            if (this.left) {
	                              if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
	                                rebuildWithInterval(this, interval);
	                              } else {
	                                this.left.insert(interval);
	                              }
	                            } else {
	                              this.left = createIntervalTree([interval]);
	                            }
	                          } else if (interval[0] > this.mid) {
	                            if (this.right) {
	                              if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
	                                rebuildWithInterval(this, interval);
	                              } else {
	                                this.right.insert(interval);
	                              }
	                            } else {
	                              this.right = createIntervalTree([interval]);
	                            }
	                          } else {
	                            var l = bounds.ge(this.leftPoints, interval, compareBegin);
	                            var r = bounds.ge(this.rightPoints, interval, compareEnd);
	                            this.leftPoints.splice(l, 0, interval);
	                            this.rightPoints.splice(r, 0, interval);
	                          }
	                        };
	                        proto.remove = function(interval) {
	                          var weight = this.count - this.leftPoints;
	                          if (interval[1] < this.mid) {
	                            if (!this.left) {
	                              return NOT_FOUND;
	                            }
	                            var rw = this.right ? this.right.count : 0;
	                            if (4 * rw > 3 * (weight - 1)) {
	                              return rebuildWithoutInterval(this, interval);
	                            }
	                            var r = this.left.remove(interval);
	                            if (r === EMPTY) {
	                              this.left = null;
	                              this.count -= 1;
	                              return SUCCESS;
	                            } else if (r === SUCCESS) {
	                              this.count -= 1;
	                            }
	                            return r;
	                          } else if (interval[0] > this.mid) {
	                            if (!this.right) {
	                              return NOT_FOUND;
	                            }
	                            var lw = this.left ? this.left.count : 0;
	                            if (4 * lw > 3 * (weight - 1)) {
	                              return rebuildWithoutInterval(this, interval);
	                            }
	                            var r = this.right.remove(interval);
	                            if (r === EMPTY) {
	                              this.right = null;
	                              this.count -= 1;
	                              return SUCCESS;
	                            } else if (r === SUCCESS) {
	                              this.count -= 1;
	                            }
	                            return r;
	                          } else {
	                            if (this.count === 1) {
	                              if (this.leftPoints[0] === interval) {
	                                return EMPTY;
	                              } else {
	                                return NOT_FOUND;
	                              }
	                            }
	                            if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
	                              if (this.left && this.right) {
	                                var p = this;
	                                var n = this.left;
	                                while (n.right) {
	                                  p = n;
	                                  n = n.right;
	                                }
	                                if (p === this) {
	                                  n.right = this.right;
	                                } else {
	                                  var l = this.left;
	                                  var r = this.right;
	                                  p.count -= n.count;
	                                  p.right = n.left;
	                                  n.left = l;
	                                  n.right = r;
	                                }
	                                copy(this, n);
	                                this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
	                              } else if (this.left) {
	                                copy(this, this.left);
	                              } else {
	                                copy(this, this.right);
	                              }
	                              return SUCCESS;
	                            }
	                            for (var l = bounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
	                              if (this.leftPoints[l][0] !== interval[0]) {
	                                break;
	                              }
	                              if (this.leftPoints[l] === interval) {
	                                this.count -= 1;
	                                this.leftPoints.splice(l, 1);
	                                for (var r = bounds.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
	                                  if (this.rightPoints[r][1] !== interval[1]) {
	                                    break;
	                                  } else if (this.rightPoints[r] === interval) {
	                                    this.rightPoints.splice(r, 1);
	                                    return SUCCESS;
	                                  }
	                                }
	                              }
	                            }
	                            return NOT_FOUND;
	                          }
	                        };
	                        function reportLeftRange(arr, hi, cb) {
	                          for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
	                            var r = cb(arr[i]);
	                            if (r) {
	                              return r;
	                            }
	                          }
	                        }
	                        function reportRightRange(arr, lo, cb) {
	                          for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
	                            var r = cb(arr[i]);
	                            if (r) {
	                              return r;
	                            }
	                          }
	                        }
	                        function reportRange(arr, cb) {
	                          for (var i = 0; i < arr.length; ++i) {
	                            var r = cb(arr[i]);
	                            if (r) {
	                              return r;
	                            }
	                          }
	                        }
	                        proto.queryPoint = function(x, cb) {
	                          if (x < this.mid) {
	                            if (this.left) {
	                              var r = this.left.queryPoint(x, cb);
	                              if (r) {
	                                return r;
	                              }
	                            }
	                            return reportLeftRange(this.leftPoints, x, cb);
	                          } else if (x > this.mid) {
	                            if (this.right) {
	                              var r = this.right.queryPoint(x, cb);
	                              if (r) {
	                                return r;
	                              }
	                            }
	                            return reportRightRange(this.rightPoints, x, cb);
	                          } else {
	                            return reportRange(this.leftPoints, cb);
	                          }
	                        };
	                        proto.queryInterval = function(lo, hi, cb) {
	                          if (lo < this.mid && this.left) {
	                            var r = this.left.queryInterval(lo, hi, cb);
	                            if (r) {
	                              return r;
	                            }
	                          }
	                          if (hi > this.mid && this.right) {
	                            var r = this.right.queryInterval(lo, hi, cb);
	                            if (r) {
	                              return r;
	                            }
	                          }
	                          if (hi < this.mid) {
	                            return reportLeftRange(this.leftPoints, hi, cb);
	                          } else if (lo > this.mid) {
	                            return reportRightRange(this.rightPoints, lo, cb);
	                          } else {
	                            return reportRange(this.leftPoints, cb);
	                          }
	                        };
	                        function compareNumbers(a, b) {
	                          return a - b;
	                        }
	                        function compareBegin(a, b) {
	                          var d = a[0] - b[0];
	                          if (d) {
	                            return d;
	                          }
	                          return a[1] - b[1];
	                        }
	                        function compareEnd(a, b) {
	                          var d = a[1] - b[1];
	                          if (d) {
	                            return d;
	                          }
	                          return a[0] - b[0];
	                        }
	                        function createIntervalTree(intervals) {
	                          if (intervals.length === 0) {
	                            return null;
	                          }
	                          var pts = [];
	                          for (var i = 0; i < intervals.length; ++i) {
	                            pts.push(intervals[i][0], intervals[i][1]);
	                          }
	                          pts.sort(compareNumbers);
	                          var mid = pts[pts.length >> 1];
	                          var leftIntervals = [];
	                          var rightIntervals = [];
	                          var centerIntervals = [];
	                          for (var i = 0; i < intervals.length; ++i) {
	                            var s = intervals[i];
	                            if (s[1] < mid) {
	                              leftIntervals.push(s);
	                            } else if (mid < s[0]) {
	                              rightIntervals.push(s);
	                            } else {
	                              centerIntervals.push(s);
	                            }
	                          }
	                          var leftPoints = centerIntervals;
	                          var rightPoints = centerIntervals.slice();
	                          leftPoints.sort(compareBegin);
	                          rightPoints.sort(compareEnd);
	                          return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
	                        }
	                        function IntervalTree(root) {
	                          this.root = root;
	                        }
	                        var tproto = IntervalTree.prototype;
	                        tproto.insert = function(interval) {
	                          if (this.root) {
	                            this.root.insert(interval);
	                          } else {
	                            this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
	                          }
	                        };
	                        tproto.remove = function(interval) {
	                          if (this.root) {
	                            var r = this.root.remove(interval);
	                            if (r === EMPTY) {
	                              this.root = null;
	                            }
	                            return r !== NOT_FOUND;
	                          }
	                          return false;
	                        };
	                        tproto.queryPoint = function(p, cb) {
	                          if (this.root) {
	                            return this.root.queryPoint(p, cb);
	                          }
	                        };
	                        tproto.queryInterval = function(lo, hi, cb) {
	                          if (lo <= hi && this.root) {
	                            return this.root.queryInterval(lo, hi, cb);
	                          }
	                        };
	                        Object.defineProperty(tproto, "count", { get: function() {
	                          if (this.root) {
	                            return this.root.count;
	                          }
	                          return 0;
	                        } });
	                        Object.defineProperty(tproto, "intervals", { get: function() {
	                          if (this.root) {
	                            return this.root.intervals([]);
	                          }
	                          return [];
	                        } });
	                        function createWrapper(intervals) {
	                          if (!intervals || intervals.length === 0) {
	                            return new IntervalTree(null);
	                          }
	                          return new IntervalTree(createIntervalTree(intervals));
	                        }
	                      }
	                    ),
	                    /***/
	                    9560: (
	                      /***/
	                      function(module3) {
	                        function iota(n) {
	                          var result = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            result[i] = i;
	                          }
	                          return result;
	                        }
	                        module3.exports = iota;
	                      }
	                    ),
	                    /***/
	                    4846: (
	                      /***/
	                      function(module3) {
	                        module3.exports = true;
	                      }
	                    ),
	                    /***/
	                    4780: (
	                      /***/
	                      function(module3) {
	                        /*!
	                        * Determine if an object is a Buffer
	                        *
	                        * @author   Feross Aboukhadijeh <https://feross.org>
	                        * @license  MIT
	                        */
	                        module3.exports = function(obj) {
	                          return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
	                        };
	                        function isBuffer(obj) {
	                          return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
	                        }
	                        function isSlowBuffer(obj) {
	                          return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer(obj.slice(0, 0));
	                        }
	                      }
	                    ),
	                    /***/
	                    3596: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function(str) {
	                          var l = str.length, a;
	                          for (var i = 0; i < l; i++) {
	                            a = str.charCodeAt(i);
	                            if ((a < 9 || a > 13) && a !== 32 && a !== 133 && a !== 160 && a !== 5760 && a !== 6158 && (a < 8192 || a > 8205) && a !== 8232 && a !== 8233 && a !== 8239 && a !== 8287 && a !== 8288 && a !== 12288 && a !== 65279) {
	                              return false;
	                            }
	                          }
	                          return true;
	                        };
	                      }
	                    ),
	                    /***/
	                    3578: (
	                      /***/
	                      function(module3) {
	                        function lerp(v0, v1, t) {
	                          return v0 * (1 - t) + v1 * t;
	                        }
	                        module3.exports = lerp;
	                      }
	                    ),
	                    /***/
	                    7191: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_647150__) {
	                        var normalize = __nested_webpack_require_647150__(4690);
	                        var create = __nested_webpack_require_647150__(9823);
	                        var clone = __nested_webpack_require_647150__(7332);
	                        var determinant = __nested_webpack_require_647150__(7787);
	                        var invert = __nested_webpack_require_647150__(7437);
	                        var transpose = __nested_webpack_require_647150__(2142);
	                        var vec3 = { length: __nested_webpack_require_647150__(4693), normalize: __nested_webpack_require_647150__(899), dot: __nested_webpack_require_647150__(9305), cross: __nested_webpack_require_647150__(903) };
	                        var tmp = create();
	                        var perspectiveMatrix = create();
	                        var tmpVec4 = [0, 0, 0, 0];
	                        var row = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
	                        var pdum3 = [0, 0, 0];
	                        module3.exports = function decomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
	                          if (!translation) translation = [0, 0, 0];
	                          if (!scale) scale = [0, 0, 0];
	                          if (!skew) skew = [0, 0, 0];
	                          if (!perspective) perspective = [0, 0, 0, 1];
	                          if (!quaternion) quaternion = [0, 0, 0, 1];
	                          if (!normalize(tmp, matrix)) return false;
	                          clone(perspectiveMatrix, tmp);
	                          perspectiveMatrix[3] = 0;
	                          perspectiveMatrix[7] = 0;
	                          perspectiveMatrix[11] = 0;
	                          perspectiveMatrix[15] = 1;
	                          if (Math.abs(determinant(perspectiveMatrix) < 1e-8)) return false;
	                          var a03 = tmp[3], a13 = tmp[7], a23 = tmp[11], a30 = tmp[12], a31 = tmp[13], a32 = tmp[14], a33 = tmp[15];
	                          if (a03 !== 0 || a13 !== 0 || a23 !== 0) {
	                            tmpVec4[0] = a03;
	                            tmpVec4[1] = a13;
	                            tmpVec4[2] = a23;
	                            tmpVec4[3] = a33;
	                            var ret = invert(perspectiveMatrix, perspectiveMatrix);
	                            if (!ret) return false;
	                            transpose(perspectiveMatrix, perspectiveMatrix);
	                            vec4multMat4(perspective, tmpVec4, perspectiveMatrix);
	                          } else {
	                            perspective[0] = perspective[1] = perspective[2] = 0;
	                            perspective[3] = 1;
	                          }
	                          translation[0] = a30;
	                          translation[1] = a31;
	                          translation[2] = a32;
	                          mat3from4(row, tmp);
	                          scale[0] = vec3.length(row[0]);
	                          vec3.normalize(row[0], row[0]);
	                          skew[0] = vec3.dot(row[0], row[1]);
	                          combine(row[1], row[1], row[0], 1, -skew[0]);
	                          scale[1] = vec3.length(row[1]);
	                          vec3.normalize(row[1], row[1]);
	                          skew[0] /= scale[1];
	                          skew[1] = vec3.dot(row[0], row[2]);
	                          combine(row[2], row[2], row[0], 1, -skew[1]);
	                          skew[2] = vec3.dot(row[1], row[2]);
	                          combine(row[2], row[2], row[1], 1, -skew[2]);
	                          scale[2] = vec3.length(row[2]);
	                          vec3.normalize(row[2], row[2]);
	                          skew[1] /= scale[2];
	                          skew[2] /= scale[2];
	                          vec3.cross(pdum3, row[1], row[2]);
	                          if (vec3.dot(row[0], pdum3) < 0) {
	                            for (var i = 0; i < 3; i++) {
	                              scale[i] *= -1;
	                              row[i][0] *= -1;
	                              row[i][1] *= -1;
	                              row[i][2] *= -1;
	                            }
	                          }
	                          quaternion[0] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] - row[1][1] - row[2][2], 0));
	                          quaternion[1] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] + row[1][1] - row[2][2], 0));
	                          quaternion[2] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] - row[1][1] + row[2][2], 0));
	                          quaternion[3] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] + row[1][1] + row[2][2], 0));
	                          if (row[2][1] > row[1][2]) quaternion[0] = -quaternion[0];
	                          if (row[0][2] > row[2][0]) quaternion[1] = -quaternion[1];
	                          if (row[1][0] > row[0][1]) quaternion[2] = -quaternion[2];
	                          return true;
	                        };
	                        function vec4multMat4(out, a, m) {
	                          var x = a[0], y = a[1], z = a[2], w = a[3];
	                          out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
	                          out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
	                          out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
	                          out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
	                          return out;
	                        }
	                        function mat3from4(out, mat4x4) {
	                          out[0][0] = mat4x4[0];
	                          out[0][1] = mat4x4[1];
	                          out[0][2] = mat4x4[2];
	                          out[1][0] = mat4x4[4];
	                          out[1][1] = mat4x4[5];
	                          out[1][2] = mat4x4[6];
	                          out[2][0] = mat4x4[8];
	                          out[2][1] = mat4x4[9];
	                          out[2][2] = mat4x4[10];
	                        }
	                        function combine(out, a, b, scale1, scale2) {
	                          out[0] = a[0] * scale1 + b[0] * scale2;
	                          out[1] = a[1] * scale1 + b[1] * scale2;
	                          out[2] = a[2] * scale1 + b[2] * scale2;
	                        }
	                      }
	                    ),
	                    /***/
	                    4690: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function normalize(out, mat) {
	                          var m44 = mat[15];
	                          if (m44 === 0) return false;
	                          var scale = 1 / m44;
	                          for (var i = 0; i < 16; i++) out[i] = mat[i] * scale;
	                          return true;
	                        };
	                      }
	                    ),
	                    /***/
	                    7649: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_652429__) {
	                        var lerp = __nested_webpack_require_652429__(1868);
	                        var recompose = __nested_webpack_require_652429__(1102);
	                        var decompose = __nested_webpack_require_652429__(7191);
	                        var determinant = __nested_webpack_require_652429__(7787);
	                        var slerp = __nested_webpack_require_652429__(1116);
	                        var state0 = state();
	                        var state1 = state();
	                        var tmp = state();
	                        module3.exports = interpolate;
	                        function interpolate(out, start, end, alpha) {
	                          if (determinant(start) === 0 || determinant(end) === 0) return false;
	                          var r0 = decompose(start, state0.translate, state0.scale, state0.skew, state0.perspective, state0.quaternion);
	                          var r1 = decompose(end, state1.translate, state1.scale, state1.skew, state1.perspective, state1.quaternion);
	                          if (!r0 || !r1) return false;
	                          lerp(tmp.translate, state0.translate, state1.translate, alpha);
	                          lerp(tmp.skew, state0.skew, state1.skew, alpha);
	                          lerp(tmp.scale, state0.scale, state1.scale, alpha);
	                          lerp(tmp.perspective, state0.perspective, state1.perspective, alpha);
	                          slerp(tmp.quaternion, state0.quaternion, state1.quaternion, alpha);
	                          recompose(out, tmp.translate, tmp.scale, tmp.skew, tmp.perspective, tmp.quaternion);
	                          return true;
	                        }
	                        function state() {
	                          return { translate: vec3(), scale: vec3(1), skew: vec3(), perspective: vec4(), quaternion: vec4() };
	                        }
	                        function vec3(n) {
	                          return [n || 0, n || 0, n || 0];
	                        }
	                        function vec4() {
	                          return [0, 0, 0, 1];
	                        }
	                      }
	                    ),
	                    /***/
	                    1102: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_653907__) {
	                        var mat4 = { identity: __nested_webpack_require_653907__(9947), translate: __nested_webpack_require_653907__(998), multiply: __nested_webpack_require_653907__(104), create: __nested_webpack_require_653907__(9823), scale: __nested_webpack_require_653907__(3668), fromRotationTranslation: __nested_webpack_require_653907__(7280) };
	                        mat4.create();
	                        var temp = mat4.create();
	                        module3.exports = function recomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
	                          mat4.identity(matrix);
	                          mat4.fromRotationTranslation(matrix, quaternion, translation);
	                          matrix[3] = perspective[0];
	                          matrix[7] = perspective[1];
	                          matrix[11] = perspective[2];
	                          matrix[15] = perspective[3];
	                          mat4.identity(temp);
	                          if (skew[2] !== 0) {
	                            temp[9] = skew[2];
	                            mat4.multiply(matrix, matrix, temp);
	                          }
	                          if (skew[1] !== 0) {
	                            temp[9] = 0;
	                            temp[8] = skew[1];
	                            mat4.multiply(matrix, matrix, temp);
	                          }
	                          if (skew[0] !== 0) {
	                            temp[8] = 0;
	                            temp[4] = skew[0];
	                            mat4.multiply(matrix, matrix, temp);
	                          }
	                          mat4.scale(matrix, matrix, scale);
	                          return matrix;
	                        };
	                      }
	                    ),
	                    /***/
	                    9298: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_655328__) {
	                        var bsearch = __nested_webpack_require_655328__(5070);
	                        var m4interp = __nested_webpack_require_655328__(7649);
	                        var invert44 = __nested_webpack_require_655328__(7437);
	                        var rotateX = __nested_webpack_require_655328__(6109);
	                        var rotateY = __nested_webpack_require_655328__(7115);
	                        var rotateZ = __nested_webpack_require_655328__(5240);
	                        var lookAt = __nested_webpack_require_655328__(3012);
	                        var translate = __nested_webpack_require_655328__(998);
	                        __nested_webpack_require_655328__(3668);
	                        var normalize = __nested_webpack_require_655328__(899);
	                        var DEFAULT_CENTER = [0, 0, 0];
	                        module3.exports = createMatrixCameraController;
	                        function MatrixCameraController(initialMatrix) {
	                          this._components = initialMatrix.slice();
	                          this._time = [0];
	                          this.prevMatrix = initialMatrix.slice();
	                          this.nextMatrix = initialMatrix.slice();
	                          this.computedMatrix = initialMatrix.slice();
	                          this.computedInverse = initialMatrix.slice();
	                          this.computedEye = [0, 0, 0];
	                          this.computedUp = [0, 0, 0];
	                          this.computedCenter = [0, 0, 0];
	                          this.computedRadius = [0];
	                          this._limits = [-Infinity, Infinity];
	                        }
	                        var proto = MatrixCameraController.prototype;
	                        proto.recalcMatrix = function(t) {
	                          var time = this._time;
	                          var tidx = bsearch.le(time, t);
	                          var mat = this.computedMatrix;
	                          if (tidx < 0) {
	                            return;
	                          }
	                          var comps = this._components;
	                          if (tidx === time.length - 1) {
	                            var ptr = 16 * tidx;
	                            for (var i = 0; i < 16; ++i) {
	                              mat[i] = comps[ptr++];
	                            }
	                          } else {
	                            var dt = time[tidx + 1] - time[tidx];
	                            var ptr = 16 * tidx;
	                            var prev = this.prevMatrix;
	                            var allEqual = true;
	                            for (var i = 0; i < 16; ++i) {
	                              prev[i] = comps[ptr++];
	                            }
	                            var next = this.nextMatrix;
	                            for (var i = 0; i < 16; ++i) {
	                              next[i] = comps[ptr++];
	                              allEqual = allEqual && prev[i] === next[i];
	                            }
	                            if (dt < 1e-6 || allEqual) {
	                              for (var i = 0; i < 16; ++i) {
	                                mat[i] = prev[i];
	                              }
	                            } else {
	                              m4interp(mat, prev, next, (t - time[tidx]) / dt);
	                            }
	                          }
	                          var up = this.computedUp;
	                          up[0] = mat[1];
	                          up[1] = mat[5];
	                          up[2] = mat[9];
	                          normalize(up, up);
	                          var imat = this.computedInverse;
	                          invert44(imat, mat);
	                          var eye = this.computedEye;
	                          var w = imat[15];
	                          eye[0] = imat[12] / w;
	                          eye[1] = imat[13] / w;
	                          eye[2] = imat[14] / w;
	                          var center = this.computedCenter;
	                          var radius = Math.exp(this.computedRadius[0]);
	                          for (var i = 0; i < 3; ++i) {
	                            center[i] = eye[i] - mat[2 + 4 * i] * radius;
	                          }
	                        };
	                        proto.idle = function(t) {
	                          if (t < this.lastT()) {
	                            return;
	                          }
	                          var mc = this._components;
	                          var ptr = mc.length - 16;
	                          for (var i = 0; i < 16; ++i) {
	                            mc.push(mc[ptr++]);
	                          }
	                          this._time.push(t);
	                        };
	                        proto.flush = function(t) {
	                          var idx = bsearch.gt(this._time, t) - 2;
	                          if (idx < 0) {
	                            return;
	                          }
	                          this._time.splice(0, idx);
	                          this._components.splice(0, 16 * idx);
	                        };
	                        proto.lastT = function() {
	                          return this._time[this._time.length - 1];
	                        };
	                        proto.lookAt = function(t, eye, center, up) {
	                          this.recalcMatrix(t);
	                          eye = eye || this.computedEye;
	                          center = center || DEFAULT_CENTER;
	                          up = up || this.computedUp;
	                          this.setMatrix(t, lookAt(this.computedMatrix, eye, center, up));
	                          var d2 = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            d2 += Math.pow(center[i] - eye[i], 2);
	                          }
	                          d2 = Math.log(Math.sqrt(d2));
	                          this.computedRadius[0] = d2;
	                        };
	                        proto.rotate = function(t, yaw, pitch, roll) {
	                          this.recalcMatrix(t);
	                          var mat = this.computedInverse;
	                          if (yaw) rotateY(mat, mat, yaw);
	                          if (pitch) rotateX(mat, mat, pitch);
	                          if (roll) rotateZ(mat, mat, roll);
	                          this.setMatrix(t, invert44(this.computedMatrix, mat));
	                        };
	                        var tvec = [0, 0, 0];
	                        proto.pan = function(t, dx, dy, dz) {
	                          tvec[0] = -(dx || 0);
	                          tvec[1] = -(dy || 0);
	                          tvec[2] = -(dz || 0);
	                          this.recalcMatrix(t);
	                          var mat = this.computedInverse;
	                          translate(mat, mat, tvec);
	                          this.setMatrix(t, invert44(mat, mat));
	                        };
	                        proto.translate = function(t, dx, dy, dz) {
	                          tvec[0] = dx || 0;
	                          tvec[1] = dy || 0;
	                          tvec[2] = dz || 0;
	                          this.recalcMatrix(t);
	                          var mat = this.computedMatrix;
	                          translate(mat, mat, tvec);
	                          this.setMatrix(t, mat);
	                        };
	                        proto.setMatrix = function(t, mat) {
	                          if (t < this.lastT()) {
	                            return;
	                          }
	                          this._time.push(t);
	                          for (var i = 0; i < 16; ++i) {
	                            this._components.push(mat[i]);
	                          }
	                        };
	                        proto.setDistance = function(t, d) {
	                          this.computedRadius[0] = d;
	                        };
	                        proto.setDistanceLimits = function(a, b) {
	                          var lim = this._limits;
	                          lim[0] = a;
	                          lim[1] = b;
	                        };
	                        proto.getDistanceLimits = function(out) {
	                          var lim = this._limits;
	                          if (out) {
	                            out[0] = lim[0];
	                            out[1] = lim[1];
	                            return out;
	                          }
	                          return lim;
	                        };
	                        function createMatrixCameraController(options) {
	                          options = options || {};
	                          var matrix = options.matrix || [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	                          return new MatrixCameraController(matrix);
	                        }
	                      }
	                    ),
	                    /***/
	                    3266: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_659142__) {
	                        module3.exports = monotoneConvexHull2D;
	                        var orient = __nested_webpack_require_659142__(417)[3];
	                        function monotoneConvexHull2D(points) {
	                          var n = points.length;
	                          if (n < 3) {
	                            var result = new Array(n);
	                            for (var i = 0; i < n; ++i) {
	                              result[i] = i;
	                            }
	                            if (n === 2 && points[0][0] === points[1][0] && points[0][1] === points[1][1]) {
	                              return [0];
	                            }
	                            return result;
	                          }
	                          var sorted = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            sorted[i] = i;
	                          }
	                          sorted.sort(function(a, b) {
	                            var d = points[a][0] - points[b][0];
	                            if (d) {
	                              return d;
	                            }
	                            return points[a][1] - points[b][1];
	                          });
	                          var lower = [sorted[0], sorted[1]];
	                          var upper = [sorted[0], sorted[1]];
	                          for (var i = 2; i < n; ++i) {
	                            var idx = sorted[i];
	                            var p = points[idx];
	                            var m = lower.length;
	                            while (m > 1 && orient(points[lower[m - 2]], points[lower[m - 1]], p) <= 0) {
	                              m -= 1;
	                              lower.pop();
	                            }
	                            lower.push(idx);
	                            m = upper.length;
	                            while (m > 1 && orient(points[upper[m - 2]], points[upper[m - 1]], p) >= 0) {
	                              m -= 1;
	                              upper.pop();
	                            }
	                            upper.push(idx);
	                          }
	                          var result = new Array(upper.length + lower.length - 2);
	                          var ptr = 0;
	                          for (var i = 0, nl = lower.length; i < nl; ++i) {
	                            result[ptr++] = lower[i];
	                          }
	                          for (var j = upper.length - 2; j > 0; --j) {
	                            result[ptr++] = upper[j];
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    6145: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_660402__) {
	                        module3.exports = mouseListen;
	                        var mouse = __nested_webpack_require_660402__(4110);
	                        function mouseListen(element, callback) {
	                          if (!callback) {
	                            callback = element;
	                            element = window;
	                          }
	                          var buttonState = 0;
	                          var x = 0;
	                          var y = 0;
	                          var mods = { shift: false, alt: false, control: false, meta: false };
	                          var attached = false;
	                          function updateMods(ev) {
	                            var changed = false;
	                            if ("altKey" in ev) {
	                              changed = changed || ev.altKey !== mods.alt;
	                              mods.alt = !!ev.altKey;
	                            }
	                            if ("shiftKey" in ev) {
	                              changed = changed || ev.shiftKey !== mods.shift;
	                              mods.shift = !!ev.shiftKey;
	                            }
	                            if ("ctrlKey" in ev) {
	                              changed = changed || ev.ctrlKey !== mods.control;
	                              mods.control = !!ev.ctrlKey;
	                            }
	                            if ("metaKey" in ev) {
	                              changed = changed || ev.metaKey !== mods.meta;
	                              mods.meta = !!ev.metaKey;
	                            }
	                            return changed;
	                          }
	                          function handleEvent(nextButtons, ev) {
	                            var nextX = mouse.x(ev);
	                            var nextY = mouse.y(ev);
	                            if ("buttons" in ev) {
	                              nextButtons = ev.buttons | 0;
	                            }
	                            if (nextButtons !== buttonState || nextX !== x || nextY !== y || updateMods(ev)) {
	                              buttonState = nextButtons | 0;
	                              x = nextX || 0;
	                              y = nextY || 0;
	                              callback && callback(buttonState, x, y, mods);
	                            }
	                          }
	                          function clearState(ev) {
	                            handleEvent(0, ev);
	                          }
	                          function handleBlur() {
	                            if (buttonState || x || y || mods.shift || mods.alt || mods.meta || mods.control) {
	                              x = y = 0;
	                              buttonState = 0;
	                              mods.shift = mods.alt = mods.control = mods.meta = false;
	                              callback && callback(0, 0, 0, mods);
	                            }
	                          }
	                          function handleMods(ev) {
	                            if (updateMods(ev)) {
	                              callback && callback(buttonState, x, y, mods);
	                            }
	                          }
	                          function handleMouseMove(ev) {
	                            if (mouse.buttons(ev) === 0) {
	                              handleEvent(0, ev);
	                            } else {
	                              handleEvent(buttonState, ev);
	                            }
	                          }
	                          function handleMouseDown(ev) {
	                            handleEvent(buttonState | mouse.buttons(ev), ev);
	                          }
	                          function handleMouseUp(ev) {
	                            handleEvent(buttonState & ~mouse.buttons(ev), ev);
	                          }
	                          function attachListeners() {
	                            if (attached) {
	                              return;
	                            }
	                            attached = true;
	                            element.addEventListener("mousemove", handleMouseMove);
	                            element.addEventListener("mousedown", handleMouseDown);
	                            element.addEventListener("mouseup", handleMouseUp);
	                            element.addEventListener("mouseleave", clearState);
	                            element.addEventListener("mouseenter", clearState);
	                            element.addEventListener("mouseout", clearState);
	                            element.addEventListener("mouseover", clearState);
	                            element.addEventListener("blur", handleBlur);
	                            element.addEventListener("keyup", handleMods);
	                            element.addEventListener("keydown", handleMods);
	                            element.addEventListener("keypress", handleMods);
	                            if (element !== window) {
	                              window.addEventListener("blur", handleBlur);
	                              window.addEventListener("keyup", handleMods);
	                              window.addEventListener("keydown", handleMods);
	                              window.addEventListener("keypress", handleMods);
	                            }
	                          }
	                          function detachListeners() {
	                            if (!attached) {
	                              return;
	                            }
	                            attached = false;
	                            element.removeEventListener("mousemove", handleMouseMove);
	                            element.removeEventListener("mousedown", handleMouseDown);
	                            element.removeEventListener("mouseup", handleMouseUp);
	                            element.removeEventListener("mouseleave", clearState);
	                            element.removeEventListener("mouseenter", clearState);
	                            element.removeEventListener("mouseout", clearState);
	                            element.removeEventListener("mouseover", clearState);
	                            element.removeEventListener("blur", handleBlur);
	                            element.removeEventListener("keyup", handleMods);
	                            element.removeEventListener("keydown", handleMods);
	                            element.removeEventListener("keypress", handleMods);
	                            if (element !== window) {
	                              window.removeEventListener("blur", handleBlur);
	                              window.removeEventListener("keyup", handleMods);
	                              window.removeEventListener("keydown", handleMods);
	                              window.removeEventListener("keypress", handleMods);
	                            }
	                          }
	                          attachListeners();
	                          var result = { element };
	                          Object.defineProperties(result, { enabled: { get: function() {
	                            return attached;
	                          }, set: function(f) {
	                            if (f) {
	                              attachListeners();
	                            } else {
	                              detachListeners();
	                            }
	                          }, enumerable: true }, buttons: { get: function() {
	                            return buttonState;
	                          }, enumerable: true }, x: { get: function() {
	                            return x;
	                          }, enumerable: true }, y: { get: function() {
	                            return y;
	                          }, enumerable: true }, mods: { get: function() {
	                            return mods;
	                          }, enumerable: true } });
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    2565: (
	                      /***/
	                      function(module3) {
	                        var rootPosition = { left: 0, top: 0 };
	                        module3.exports = mouseEventOffset;
	                        function mouseEventOffset(ev, target, out) {
	                          target = target || ev.currentTarget || ev.srcElement;
	                          if (!Array.isArray(out)) {
	                            out = [0, 0];
	                          }
	                          var cx = ev.clientX || 0;
	                          var cy = ev.clientY || 0;
	                          var rect = getBoundingClientOffset(target);
	                          out[0] = cx - rect.left;
	                          out[1] = cy - rect.top;
	                          return out;
	                        }
	                        function getBoundingClientOffset(element) {
	                          if (element === window || element === document || element === document.body) {
	                            return rootPosition;
	                          } else {
	                            return element.getBoundingClientRect();
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    4110: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        function mouseButtons(ev) {
	                          if (typeof ev === "object") {
	                            if ("buttons" in ev) {
	                              return ev.buttons;
	                            } else if ("which" in ev) {
	                              var b = ev.which;
	                              if (b === 2) {
	                                return 4;
	                              } else if (b === 3) {
	                                return 2;
	                              } else if (b > 0) {
	                                return 1 << b - 1;
	                              }
	                            } else if ("button" in ev) {
	                              var b = ev.button;
	                              if (b === 1) {
	                                return 4;
	                              } else if (b === 2) {
	                                return 2;
	                              } else if (b >= 0) {
	                                return 1 << b;
	                              }
	                            }
	                          }
	                          return 0;
	                        }
	                        exports2.buttons = mouseButtons;
	                        function mouseElement(ev) {
	                          return ev.target || ev.srcElement || window;
	                        }
	                        exports2.element = mouseElement;
	                        function mouseRelativeX(ev) {
	                          if (typeof ev === "object") {
	                            if ("offsetX" in ev) {
	                              return ev.offsetX;
	                            }
	                            var target = mouseElement(ev);
	                            var bounds = target.getBoundingClientRect();
	                            return ev.clientX - bounds.left;
	                          }
	                          return 0;
	                        }
	                        exports2.x = mouseRelativeX;
	                        function mouseRelativeY(ev) {
	                          if (typeof ev === "object") {
	                            if ("offsetY" in ev) {
	                              return ev.offsetY;
	                            }
	                            var target = mouseElement(ev);
	                            var bounds = target.getBoundingClientRect();
	                            return ev.clientY - bounds.top;
	                          }
	                          return 0;
	                        }
	                        exports2.y = mouseRelativeY;
	                      }
	                    ),
	                    /***/
	                    6475: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_665638__) {
	                        var toPX = __nested_webpack_require_665638__(14);
	                        module3.exports = mouseWheelListen;
	                        function mouseWheelListen(element, callback, noScroll) {
	                          if (typeof element === "function") {
	                            noScroll = !!callback;
	                            callback = element;
	                            element = window;
	                          }
	                          var lineHeight = toPX("ex", element);
	                          var listener = function(ev) {
	                            if (noScroll) {
	                              ev.preventDefault();
	                            }
	                            var dx = ev.deltaX || 0;
	                            var dy = ev.deltaY || 0;
	                            var dz = ev.deltaZ || 0;
	                            var mode = ev.deltaMode;
	                            var scale = 1;
	                            switch (mode) {
	                              case 1:
	                                scale = lineHeight;
	                                break;
	                              case 2:
	                                scale = window.innerHeight;
	                                break;
	                            }
	                            dx *= scale;
	                            dy *= scale;
	                            dz *= scale;
	                            if (dx || dy || dz) {
	                              return callback(dx, dy, dz, ev);
	                            }
	                          };
	                          element.addEventListener("wheel", listener);
	                          return listener;
	                        }
	                      }
	                    ),
	                    /***/
	                    9284: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_666345__) {
	                        var pool = __nested_webpack_require_666345__(5306);
	                        module3.exports = createSurfaceExtractor;
	                        var allFns = { "false,0,1": function surfaceProcedure(vertex, face, phase, mallocUint32, freeUint32) {
	                          return function extractContour0_1(a0, x0, x1, x2) {
	                            var s0 = a0.shape[0] | 0, s1 = a0.shape[1] | 0, d0 = a0.data, o0 = a0.offset | 0, t0_0 = a0.stride[0] | 0, t0_1 = a0.stride[1] | 0, p0 = o0, c0_0, d0_1 = -t0_0 | 0, c0_1 = 0, d0_2 = -t0_1 | 0, c0_2 = 0, d0_3 = -t0_0 - t0_1 | 0, c0_3 = 0, u0_0 = t0_0 | 0, u0_1 = t0_1 - t0_0 * s0 | 0, i0 = 0, i1 = 0, N = 0, Q = 2 * s0 | 0, P = mallocUint32(Q), V = mallocUint32(Q), X = 0, b0 = 0, e1 = -1 | 0, y1 = -1 | 0, b1 = 0, e2 = -s0 | 0, y2 = s0 | 0, b2 = 0, e3 = -s0 - 1 | 0, y3 = s0 - 1 | 0, b3 = 0, v0 = 0, T = 0;
	                            for (i0 = 0; i0 < s0; ++i0) {
	                              P[X++] = phase(d0[p0], x0, x1, x2);
	                              p0 += u0_0;
	                            }
	                            p0 += u0_1;
	                            if (s1 > 0) {
	                              i1 = 1;
	                              P[X++] = phase(d0[p0], x0, x1, x2);
	                              p0 += u0_0;
	                              if (s0 > 0) {
	                                i0 = 1;
	                                c0_0 = d0[p0];
	                                b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                b1 = P[X + e1];
	                                b2 = P[X + e2];
	                                b3 = P[X + e3];
	                                if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                  c0_1 = d0[p0 + d0_1];
	                                  c0_2 = d0[p0 + d0_2];
	                                  c0_3 = d0[p0 + d0_3];
	                                  vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                  v0 = V[X] = N++;
	                                }
	                                X += 1;
	                                p0 += u0_0;
	                                for (i0 = 2; i0 < s0; ++i0) {
	                                  c0_0 = d0[p0];
	                                  b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                  b1 = P[X + e1];
	                                  b2 = P[X + e2];
	                                  b3 = P[X + e3];
	                                  if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                    c0_1 = d0[p0 + d0_1];
	                                    c0_2 = d0[p0 + d0_2];
	                                    c0_3 = d0[p0 + d0_3];
	                                    vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                    v0 = V[X] = N++;
	                                    if (b3 !== b1) {
	                                      face(V[X + e1], v0, c0_3, c0_1, b3, b1, x0, x1, x2);
	                                    }
	                                  }
	                                  X += 1;
	                                  p0 += u0_0;
	                                }
	                              }
	                              p0 += u0_1;
	                              X = 0;
	                              T = e1;
	                              e1 = y1;
	                              y1 = T;
	                              T = e2;
	                              e2 = y2;
	                              y2 = T;
	                              T = e3;
	                              e3 = y3;
	                              y3 = T;
	                              for (i1 = 2; i1 < s1; ++i1) {
	                                P[X++] = phase(d0[p0], x0, x1, x2);
	                                p0 += u0_0;
	                                if (s0 > 0) {
	                                  i0 = 1;
	                                  c0_0 = d0[p0];
	                                  b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                  b1 = P[X + e1];
	                                  b2 = P[X + e2];
	                                  b3 = P[X + e3];
	                                  if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                    c0_1 = d0[p0 + d0_1];
	                                    c0_2 = d0[p0 + d0_2];
	                                    c0_3 = d0[p0 + d0_3];
	                                    vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                    v0 = V[X] = N++;
	                                    if (b3 !== b2) {
	                                      face(V[X + e2], v0, c0_2, c0_3, b2, b3, x0, x1, x2);
	                                    }
	                                  }
	                                  X += 1;
	                                  p0 += u0_0;
	                                  for (i0 = 2; i0 < s0; ++i0) {
	                                    c0_0 = d0[p0];
	                                    b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                    b1 = P[X + e1];
	                                    b2 = P[X + e2];
	                                    b3 = P[X + e3];
	                                    if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                      c0_1 = d0[p0 + d0_1];
	                                      c0_2 = d0[p0 + d0_2];
	                                      c0_3 = d0[p0 + d0_3];
	                                      vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                      v0 = V[X] = N++;
	                                      if (b3 !== b2) {
	                                        face(V[X + e2], v0, c0_2, c0_3, b2, b3, x0, x1, x2);
	                                      }
	                                      if (b3 !== b1) {
	                                        face(V[X + e1], v0, c0_3, c0_1, b3, b1, x0, x1, x2);
	                                      }
	                                    }
	                                    X += 1;
	                                    p0 += u0_0;
	                                  }
	                                }
	                                if (i1 & 1) {
	                                  X = 0;
	                                }
	                                T = e1;
	                                e1 = y1;
	                                y1 = T;
	                                T = e2;
	                                e2 = y2;
	                                y2 = T;
	                                T = e3;
	                                e3 = y3;
	                                y3 = T;
	                                p0 += u0_1;
	                              }
	                            }
	                            freeUint32(V);
	                            freeUint32(P);
	                          };
	                        }, "false,1,0": function anonymous(vertex, face, phase, mallocUint32, freeUint32) {
	                          return function extractContour1_0(a0, x0, x1, x2) {
	                            var s0 = a0.shape[0] | 0, s1 = a0.shape[1] | 0, d0 = a0.data, o0 = a0.offset | 0, t0_0 = a0.stride[0] | 0, t0_1 = a0.stride[1] | 0, p0 = o0, c0_0, d0_1 = -t0_0 | 0, c0_1 = 0, d0_2 = -t0_1 | 0, c0_2 = 0, d0_3 = -t0_0 - t0_1 | 0, c0_3 = 0, u0_1 = t0_1 | 0, u0_0 = t0_0 - t0_1 * s1 | 0, i0 = 0, i1 = 0, N = 0, Q = 2 * s1 | 0, P = mallocUint32(Q), V = mallocUint32(Q), X = 0, b0 = 0, e2 = -1 | 0, y2 = -1 | 0, b2 = 0, e1 = -s1 | 0, y1 = s1 | 0, b1 = 0, e3 = -s1 - 1 | 0, y3 = s1 - 1 | 0, b3 = 0, v0 = 0, T = 0;
	                            for (i1 = 0; i1 < s1; ++i1) {
	                              P[X++] = phase(d0[p0], x0, x1, x2);
	                              p0 += u0_1;
	                            }
	                            p0 += u0_0;
	                            if (s0 > 0) {
	                              i0 = 1;
	                              P[X++] = phase(d0[p0], x0, x1, x2);
	                              p0 += u0_1;
	                              if (s1 > 0) {
	                                i1 = 1;
	                                c0_0 = d0[p0];
	                                b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                b1 = P[X + e1];
	                                b2 = P[X + e2];
	                                b3 = P[X + e3];
	                                if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                  c0_1 = d0[p0 + d0_1];
	                                  c0_2 = d0[p0 + d0_2];
	                                  c0_3 = d0[p0 + d0_3];
	                                  vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                  v0 = V[X] = N++;
	                                }
	                                X += 1;
	                                p0 += u0_1;
	                                for (i1 = 2; i1 < s1; ++i1) {
	                                  c0_0 = d0[p0];
	                                  b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                  b1 = P[X + e1];
	                                  b2 = P[X + e2];
	                                  b3 = P[X + e3];
	                                  if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                    c0_1 = d0[p0 + d0_1];
	                                    c0_2 = d0[p0 + d0_2];
	                                    c0_3 = d0[p0 + d0_3];
	                                    vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                    v0 = V[X] = N++;
	                                    if (b3 !== b2) {
	                                      face(V[X + e2], v0, c0_2, c0_3, b2, b3, x0, x1, x2);
	                                    }
	                                  }
	                                  X += 1;
	                                  p0 += u0_1;
	                                }
	                              }
	                              p0 += u0_0;
	                              X = 0;
	                              T = e1;
	                              e1 = y1;
	                              y1 = T;
	                              T = e2;
	                              e2 = y2;
	                              y2 = T;
	                              T = e3;
	                              e3 = y3;
	                              y3 = T;
	                              for (i0 = 2; i0 < s0; ++i0) {
	                                P[X++] = phase(d0[p0], x0, x1, x2);
	                                p0 += u0_1;
	                                if (s1 > 0) {
	                                  i1 = 1;
	                                  c0_0 = d0[p0];
	                                  b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                  b1 = P[X + e1];
	                                  b2 = P[X + e2];
	                                  b3 = P[X + e3];
	                                  if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                    c0_1 = d0[p0 + d0_1];
	                                    c0_2 = d0[p0 + d0_2];
	                                    c0_3 = d0[p0 + d0_3];
	                                    vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                    v0 = V[X] = N++;
	                                    if (b3 !== b1) {
	                                      face(V[X + e1], v0, c0_3, c0_1, b3, b1, x0, x1, x2);
	                                    }
	                                  }
	                                  X += 1;
	                                  p0 += u0_1;
	                                  for (i1 = 2; i1 < s1; ++i1) {
	                                    c0_0 = d0[p0];
	                                    b0 = P[X] = phase(c0_0, x0, x1, x2);
	                                    b1 = P[X + e1];
	                                    b2 = P[X + e2];
	                                    b3 = P[X + e3];
	                                    if (b0 !== b1 || b0 !== b2 || b0 !== b3) {
	                                      c0_1 = d0[p0 + d0_1];
	                                      c0_2 = d0[p0 + d0_2];
	                                      c0_3 = d0[p0 + d0_3];
	                                      vertex(i0, i1, c0_0, c0_1, c0_2, c0_3, b0, b1, b2, b3, x0, x1, x2);
	                                      v0 = V[X] = N++;
	                                      if (b3 !== b2) {
	                                        face(V[X + e2], v0, c0_2, c0_3, b2, b3, x0, x1, x2);
	                                      }
	                                      if (b3 !== b1) {
	                                        face(V[X + e1], v0, c0_3, c0_1, b3, b1, x0, x1, x2);
	                                      }
	                                    }
	                                    X += 1;
	                                    p0 += u0_1;
	                                  }
	                                }
	                                if (i0 & 1) {
	                                  X = 0;
	                                }
	                                T = e1;
	                                e1 = y1;
	                                y1 = T;
	                                T = e2;
	                                e2 = y2;
	                                y2 = T;
	                                T = e3;
	                                e3 = y3;
	                                y3 = T;
	                                p0 += u0_0;
	                              }
	                            }
	                            freeUint32(V);
	                            freeUint32(P);
	                          };
	                        } };
	                        function compileSurfaceProcedure(vertexFunc, faceFunc, phaseFunc, scalarArgs, order, typesig) {
	                          var key = [typesig, order].join(",");
	                          var proc = allFns[key];
	                          return proc(vertexFunc, faceFunc, phaseFunc, pool.mallocUint32, pool.freeUint32);
	                        }
	                        function createSurfaceExtractor(args) {
	                          function error(msg) {
	                            throw new Error("ndarray-extract-contour: " + msg);
	                          }
	                          if (typeof args !== "object") {
	                            error("Must specify arguments");
	                          }
	                          var order = args.order;
	                          if (!Array.isArray(order)) {
	                            error("Must specify order");
	                          }
	                          var arrays = args.arrayArguments || 1;
	                          if (arrays < 1) {
	                            error("Must have at least one array argument");
	                          }
	                          var scalars = args.scalarArguments || 0;
	                          if (scalars < 0) {
	                            error("Scalar arg count must be > 0");
	                          }
	                          if (typeof args.vertex !== "function") {
	                            error("Must specify vertex creation function");
	                          }
	                          if (typeof args.cell !== "function") {
	                            error("Must specify cell creation function");
	                          }
	                          if (typeof args.phase !== "function") {
	                            error("Must specify phase function");
	                          }
	                          var getters = args.getters || [];
	                          var typesig = new Array(arrays);
	                          for (var i = 0; i < arrays; ++i) {
	                            if (getters.indexOf(i) >= 0) {
	                              typesig[i] = true;
	                            } else {
	                              typesig[i] = false;
	                            }
	                          }
	                          return compileSurfaceProcedure(args.vertex, args.cell, args.phase, scalars, order, typesig);
	                        }
	                      }
	                    ),
	                    /***/
	                    9144: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_671836__) {
	                        var dup = __nested_webpack_require_671836__(3094);
	                        var CACHED_CWiseOp = { zero: function(SS, a0, t0, p0) {
	                          var s0 = SS[0], t0p0 = t0[0];
	                          p0 |= 0;
	                          var i0 = 0, d0s0 = t0p0;
	                          for (i0 = 0; i0 < s0; ++i0) {
	                            a0[p0] = 0;
	                            p0 += d0s0;
	                          }
	                        }, fdTemplate1: function(SS, a0, t0, p0, a1, t1, p1) {
	                          var s0 = SS[0], t0p0 = t0[0], t1p0 = t1[0], q0 = -1 * t0p0, q1 = t0p0;
	                          p0 |= 0;
	                          p1 |= 0;
	                          var i0 = 0, d0s0 = t0p0, d1s0 = t1p0;
	                          for (i0 = 0; i0 < s0; ++i0) {
	                            a1[p1] = 0.5 * (a0[p0 + q0] - a0[p0 + q1]);
	                            p0 += d0s0;
	                            p1 += d1s0;
	                          }
	                        }, fdTemplate2: function(SS, a0, t0, p0, a1, t1, p1, a2, t2, p2) {
	                          var s0 = SS[0], s1 = SS[1], t0p0 = t0[0], t0p1 = t0[1], t1p0 = t1[0], t1p1 = t1[1], t2p0 = t2[0], t2p1 = t2[1], q0 = -1 * t0p0, q1 = t0p0, q2 = -1 * t0p1, q3 = t0p1;
	                          p0 |= 0;
	                          p1 |= 0;
	                          p2 |= 0;
	                          var i0 = 0, i1 = 0, d0s0 = t0p1, d0s1 = t0p0 - s1 * t0p1, d1s0 = t1p1, d1s1 = t1p0 - s1 * t1p1, d2s0 = t2p1, d2s1 = t2p0 - s1 * t2p1;
	                          for (i1 = 0; i1 < s0; ++i1) {
	                            for (i0 = 0; i0 < s1; ++i0) {
	                              a1[p1] = 0.5 * (a0[p0 + q0] - a0[p0 + q1]);
	                              a2[p2] = 0.5 * (a0[p0 + q2] - a0[p0 + q3]);
	                              p0 += d0s0;
	                              p1 += d1s0;
	                              p2 += d2s0;
	                            }
	                            p0 += d0s1;
	                            p1 += d1s1;
	                            p2 += d2s1;
	                          }
	                        } };
	                        var CACHED_thunk = { cdiff: function(compile2) {
	                          var CACHED = {};
	                          return function cdiff_cwise_thunk(array0, array1, array2) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, t2 = array2.dtype, r2 = array2.order, type = [t0, r0.join(), t1, r1.join(), t2, r2.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1, t2, r2]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0, array2.data, array2.stride, array2.offset | 0);
	                          };
	                        }, zero: function(compile2) {
	                          var CACHED = {};
	                          return function zero_cwise_thunk(array0) {
	                            var t0 = array0.dtype, r0 = array0.order, type = [t0, r0.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0);
	                          };
	                        }, fdTemplate1: function(compile2) {
	                          var CACHED = {};
	                          return function fdTemplate1_cwise_thunk(array0, array1) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, type = [t0, r0.join(), t1, r1.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0);
	                          };
	                        }, fdTemplate2: function(compile2) {
	                          var CACHED = {};
	                          return function fdTemplate2_cwise_thunk(array0, array1, array4) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, t4 = array4.dtype, r4 = array4.order, type = [t0, r0.join(), t1, r1.join(), t4, r4.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1, t4, r4]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0, array4.data, array4.stride, array4.offset | 0);
	                          };
	                        } };
	                        function createThunk(proc) {
	                          var thunk = CACHED_thunk[proc.funcName];
	                          return thunk(compile.bind(undefined, proc));
	                        }
	                        function compile(proc) {
	                          return CACHED_CWiseOp[proc.funcName];
	                        }
	                        function cwiseCompiler(user_args) {
	                          return createThunk({ funcName: user_args.funcName });
	                        }
	                        var TEMPLATE_CACHE = {};
	                        var GRADIENT_CACHE = {};
	                        var centralDiff = cwiseCompiler({ funcName: "cdiff" });
	                        var zeroOut = cwiseCompiler({ funcName: "zero" });
	                        function generateTemplate(d) {
	                          if (d in TEMPLATE_CACHE) {
	                            return TEMPLATE_CACHE[d];
	                          }
	                          return TEMPLATE_CACHE[d] = cwiseCompiler({ funcName: "fdTemplate" + d });
	                        }
	                        function CACHED_link(diff, zero, grad1, grad2) {
	                          return function(dst, src) {
	                            var s = src.shape.slice();
	                            if (s[0] > 2 && s[1] > 2) {
	                              grad2(src.pick(-1, -1).lo(1, 1).hi(s[0] - 2, s[1] - 2), dst.pick(-1, -1, 0).lo(1, 1).hi(s[0] - 2, s[1] - 2), dst.pick(-1, -1, 1).lo(1, 1).hi(s[0] - 2, s[1] - 2));
	                            }
	                            if (s[1] > 2) {
	                              grad1(src.pick(0, -1).lo(1).hi(s[1] - 2), dst.pick(0, -1, 1).lo(1).hi(s[1] - 2));
	                              zero(dst.pick(0, -1, 0).lo(1).hi(s[1] - 2));
	                            }
	                            if (s[1] > 2) {
	                              grad1(src.pick(s[0] - 1, -1).lo(1).hi(s[1] - 2), dst.pick(s[0] - 1, -1, 1).lo(1).hi(s[1] - 2));
	                              zero(dst.pick(s[0] - 1, -1, 0).lo(1).hi(s[1] - 2));
	                            }
	                            if (s[0] > 2) {
	                              grad1(src.pick(-1, 0).lo(1).hi(s[0] - 2), dst.pick(-1, 0, 0).lo(1).hi(s[0] - 2));
	                              zero(dst.pick(-1, 0, 1).lo(1).hi(s[0] - 2));
	                            }
	                            if (s[0] > 2) {
	                              grad1(src.pick(-1, s[1] - 1).lo(1).hi(s[0] - 2), dst.pick(-1, s[1] - 1, 0).lo(1).hi(s[0] - 2));
	                              zero(dst.pick(-1, s[1] - 1, 1).lo(1).hi(s[0] - 2));
	                            }
	                            dst.set(0, 0, 0, 0);
	                            dst.set(0, 0, 1, 0);
	                            dst.set(s[0] - 1, 0, 0, 0);
	                            dst.set(s[0] - 1, 0, 1, 0);
	                            dst.set(0, s[1] - 1, 0, 0);
	                            dst.set(0, s[1] - 1, 1, 0);
	                            dst.set(s[0] - 1, s[1] - 1, 0, 0);
	                            dst.set(s[0] - 1, s[1] - 1, 1, 0);
	                            return dst;
	                          };
	                        }
	                        function generateGradient(boundaryConditions) {
	                          var token = boundaryConditions.join();
	                          var proc = GRADIENT_CACHE[token];
	                          if (proc) {
	                            return proc;
	                          }
	                          var d = boundaryConditions.length;
	                          var linkArgs = [centralDiff, zeroOut];
	                          for (var i = 1; i <= d; ++i) {
	                            linkArgs.push(generateTemplate(i));
	                          }
	                          var link = CACHED_link;
	                          var proc = link.apply(undefined, linkArgs);
	                          GRADIENT_CACHE[token] = proc;
	                          return proc;
	                        }
	                        module3.exports = function gradient(out, inp, bc) {
	                          if (!Array.isArray(bc)) {
	                            if (typeof bc === "string") {
	                              bc = dup(inp.dimension, bc);
	                            } else {
	                              bc = dup(inp.dimension, "clamp");
	                            }
	                          }
	                          if (inp.size === 0) {
	                            return out;
	                          }
	                          if (inp.dimension === 0) {
	                            out.set(0);
	                            return out;
	                          }
	                          var cached = generateGradient(bc);
	                          return cached(out, inp);
	                        };
	                      }
	                    ),
	                    /***/
	                    3581: (
	                      /***/
	                      function(module3) {
	                        function interp1d(arr, x) {
	                          var ix = Math.floor(x), fx = x - ix, s0 = 0 <= ix && ix < arr.shape[0], s1 = 0 <= ix + 1 && ix + 1 < arr.shape[0], w0 = s0 ? +arr.get(ix) : 0, w1 = s1 ? +arr.get(ix + 1) : 0;
	                          return (1 - fx) * w0 + fx * w1;
	                        }
	                        function interp2d(arr, x, y) {
	                          var ix = Math.floor(x), fx = x - ix, s0 = 0 <= ix && ix < arr.shape[0], s1 = 0 <= ix + 1 && ix + 1 < arr.shape[0], iy = Math.floor(y), fy = y - iy, t0 = 0 <= iy && iy < arr.shape[1], t1 = 0 <= iy + 1 && iy + 1 < arr.shape[1], w00 = s0 && t0 ? arr.get(ix, iy) : 0, w01 = s0 && t1 ? arr.get(ix, iy + 1) : 0, w10 = s1 && t0 ? arr.get(ix + 1, iy) : 0, w11 = s1 && t1 ? arr.get(ix + 1, iy + 1) : 0;
	                          return (1 - fy) * ((1 - fx) * w00 + fx * w10) + fy * ((1 - fx) * w01 + fx * w11);
	                        }
	                        function interp3d(arr, x, y, z) {
	                          var ix = Math.floor(x), fx = x - ix, s0 = 0 <= ix && ix < arr.shape[0], s1 = 0 <= ix + 1 && ix + 1 < arr.shape[0], iy = Math.floor(y), fy = y - iy, t0 = 0 <= iy && iy < arr.shape[1], t1 = 0 <= iy + 1 && iy + 1 < arr.shape[1], iz = Math.floor(z), fz = z - iz, u0 = 0 <= iz && iz < arr.shape[2], u1 = 0 <= iz + 1 && iz + 1 < arr.shape[2], w000 = s0 && t0 && u0 ? arr.get(ix, iy, iz) : 0, w010 = s0 && t1 && u0 ? arr.get(ix, iy + 1, iz) : 0, w100 = s1 && t0 && u0 ? arr.get(ix + 1, iy, iz) : 0, w110 = s1 && t1 && u0 ? arr.get(ix + 1, iy + 1, iz) : 0, w001 = s0 && t0 && u1 ? arr.get(ix, iy, iz + 1) : 0, w011 = s0 && t1 && u1 ? arr.get(ix, iy + 1, iz + 1) : 0, w101 = s1 && t0 && u1 ? arr.get(ix + 1, iy, iz + 1) : 0, w111 = s1 && t1 && u1 ? arr.get(ix + 1, iy + 1, iz + 1) : 0;
	                          return (1 - fz) * ((1 - fy) * ((1 - fx) * w000 + fx * w100) + fy * ((1 - fx) * w010 + fx * w110)) + fz * ((1 - fy) * ((1 - fx) * w001 + fx * w101) + fy * ((1 - fx) * w011 + fx * w111));
	                        }
	                        function interpNd(arr) {
	                          var d = arr.shape.length | 0, ix = new Array(d), fx = new Array(d), s0 = new Array(d), s1 = new Array(d), i, t;
	                          for (i = 0; i < d; ++i) {
	                            t = +arguments[i + 1];
	                            ix[i] = Math.floor(t);
	                            fx[i] = t - ix[i];
	                            s0[i] = 0 <= ix[i] && ix[i] < arr.shape[i];
	                            s1[i] = 0 <= ix[i] + 1 && ix[i] + 1 < arr.shape[i];
	                          }
	                          var r = 0, j, w, idx;
	                          i_loop: for (i = 0; i < 1 << d; ++i) {
	                            w = 1;
	                            idx = arr.offset;
	                            for (j = 0; j < d; ++j) {
	                              if (i & 1 << j) {
	                                if (!s1[j]) {
	                                  continue i_loop;
	                                }
	                                w *= fx[j];
	                                idx += arr.stride[j] * (ix[j] + 1);
	                              } else {
	                                if (!s0[j]) {
	                                  continue i_loop;
	                                }
	                                w *= 1 - fx[j];
	                                idx += arr.stride[j] * ix[j];
	                              }
	                            }
	                            r += w * arr.data[idx];
	                          }
	                          return r;
	                        }
	                        function interpolate(arr, x, y, z) {
	                          switch (arr.shape.length) {
	                            case 0:
	                              return 0;
	                            case 1:
	                              return interp1d(arr, x);
	                            case 2:
	                              return interp2d(arr, x, y);
	                            case 3:
	                              return interp3d(arr, x, y, z);
	                            default:
	                              return interpNd.apply(undefined, arguments);
	                          }
	                        }
	                        module3.exports = interpolate;
	                        module3.exports.d1 = interp1d;
	                        module3.exports.d2 = interp2d;
	                        module3.exports.d3 = interp3d;
	                      }
	                    ),
	                    /***/
	                    7498: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        var CACHED_CWiseOp = { "float64,2,1,0": function() {
	                          return function divseq_cwise_loop_2s1s0m3f64(SS, a0, t0, p0, Y0) {
	                            var s0 = SS[0], s1 = SS[1], s2 = SS[2], t0p0 = t0[0], t0p1 = t0[1], t0p2 = t0[2];
	                            p0 |= 0;
	                            var i0 = 0, i1 = 0, i2 = 0, d0s0 = t0p2, d0s1 = t0p1 - s2 * t0p2, d0s2 = t0p0 - s1 * t0p1;
	                            for (i2 = 0; i2 < s0; ++i2) {
	                              for (i1 = 0; i1 < s1; ++i1) {
	                                for (i0 = 0; i0 < s2; ++i0) {
	                                  a0[p0] /= Y0;
	                                  p0 += d0s0;
	                                }
	                                p0 += d0s1;
	                              }
	                              p0 += d0s2;
	                            }
	                          };
	                        }, "uint8,2,0,1,float64,2,1,0": function() {
	                          return function muls_cwise_loop_2s0s1m1u8f64(SS, a0, t0, p0, a1, t1, p1, Y0) {
	                            var s0 = SS[0], s1 = SS[1], s2 = SS[2], t0p0 = t0[0], t0p1 = t0[1], t0p2 = t0[2], t1p0 = t1[0], t1p1 = t1[1], t1p2 = t1[2];
	                            p0 |= 0;
	                            p1 |= 0;
	                            var offset0 = p0;
	                            var offset1 = p1;
	                            for (var j1 = SS[0] | 0; j1 > 0; ) {
	                              if (j1 < 64) {
	                                s0 = j1;
	                                j1 = 0;
	                              } else {
	                                s0 = 64;
	                                j1 -= 64;
	                              }
	                              for (var j2 = SS[1] | 0; j2 > 0; ) {
	                                if (j2 < 64) {
	                                  s1 = j2;
	                                  j2 = 0;
	                                } else {
	                                  s1 = 64;
	                                  j2 -= 64;
	                                }
	                                p0 = offset0 + j1 * t0p0 + j2 * t0p1;
	                                p1 = offset1 + j1 * t1p0 + j2 * t1p1;
	                                var i0 = 0, i1 = 0, i2 = 0, d0s0 = t0p2, d0s1 = t0p0 - s2 * t0p2, d0s2 = t0p1 - s0 * t0p0, d1s0 = t1p2, d1s1 = t1p0 - s2 * t1p2, d1s2 = t1p1 - s0 * t1p0;
	                                for (i2 = 0; i2 < s1; ++i2) {
	                                  for (i1 = 0; i1 < s0; ++i1) {
	                                    for (i0 = 0; i0 < s2; ++i0) {
	                                      a0[p0] = a1[p1] * Y0;
	                                      p0 += d0s0;
	                                      p1 += d1s0;
	                                    }
	                                    p0 += d0s1;
	                                    p1 += d1s1;
	                                  }
	                                  p0 += d0s2;
	                                  p1 += d1s2;
	                                }
	                              }
	                            }
	                          };
	                        }, "float32,1,0,float32,1,0": function() {
	                          return function assign_cwise_loop_1s0m2f32(SS, a0, t0, p0, a1, t1, p1) {
	                            var s0 = SS[0], s1 = SS[1], t0p0 = t0[0], t0p1 = t0[1], t1p0 = t1[0], t1p1 = t1[1];
	                            p0 |= 0;
	                            p1 |= 0;
	                            var i0 = 0, i1 = 0, d0s0 = t0p1, d0s1 = t0p0 - s1 * t0p1, d1s0 = t1p1, d1s1 = t1p0 - s1 * t1p1;
	                            for (i1 = 0; i1 < s0; ++i1) {
	                              for (i0 = 0; i0 < s1; ++i0) {
	                                a0[p0] = a1[p1];
	                                p0 += d0s0;
	                                p1 += d1s0;
	                              }
	                              p0 += d0s1;
	                              p1 += d1s1;
	                            }
	                          };
	                        }, "float32,1,0,float32,0,1": function() {
	                          return function assign_cwise_loop_1s0m0f32(SS, a0, t0, p0, a1, t1, p1) {
	                            var s0 = SS[0], s1 = SS[1], t0p0 = t0[0], t0p1 = t0[1], t1p0 = t1[0], t1p1 = t1[1];
	                            p0 |= 0;
	                            p1 |= 0;
	                            var offset0 = p0;
	                            var offset1 = p1;
	                            for (var j0 = SS[1] | 0; j0 > 0; ) {
	                              if (j0 < 64) {
	                                s1 = j0;
	                                j0 = 0;
	                              } else {
	                                s1 = 64;
	                                j0 -= 64;
	                              }
	                              for (var j1 = SS[0] | 0; j1 > 0; ) {
	                                if (j1 < 64) {
	                                  s0 = j1;
	                                  j1 = 0;
	                                } else {
	                                  s0 = 64;
	                                  j1 -= 64;
	                                }
	                                p0 = offset0 + j0 * t0p1 + j1 * t0p0;
	                                p1 = offset1 + j0 * t1p1 + j1 * t1p0;
	                                var i0 = 0, i1 = 0, d0s0 = t0p1, d0s1 = t0p0 - s1 * t0p1, d1s0 = t1p1, d1s1 = t1p0 - s1 * t1p1;
	                                for (i1 = 0; i1 < s0; ++i1) {
	                                  for (i0 = 0; i0 < s1; ++i0) {
	                                    a0[p0] = a1[p1];
	                                    p0 += d0s0;
	                                    p1 += d1s0;
	                                  }
	                                  p0 += d0s1;
	                                  p1 += d1s1;
	                                }
	                              }
	                            }
	                          };
	                        }, "uint8,2,0,1,uint8,1,2,0": function() {
	                          return function assign_cwise_loop_2s0s1m0u8(SS, a0, t0, p0, a1, t1, p1) {
	                            var s0 = SS[0], s1 = SS[1], s2 = SS[2], t0p0 = t0[0], t0p1 = t0[1], t0p2 = t0[2], t1p0 = t1[0], t1p1 = t1[1], t1p2 = t1[2];
	                            p0 |= 0;
	                            p1 |= 0;
	                            var offset0 = p0;
	                            var offset1 = p1;
	                            for (var j0 = SS[2] | 0; j0 > 0; ) {
	                              if (j0 < 64) {
	                                s2 = j0;
	                                j0 = 0;
	                              } else {
	                                s2 = 64;
	                                j0 -= 64;
	                              }
	                              for (var j1 = SS[0] | 0; j1 > 0; ) {
	                                if (j1 < 64) {
	                                  s0 = j1;
	                                  j1 = 0;
	                                } else {
	                                  s0 = 64;
	                                  j1 -= 64;
	                                }
	                                for (var j2 = SS[1] | 0; j2 > 0; ) {
	                                  if (j2 < 64) {
	                                    s1 = j2;
	                                    j2 = 0;
	                                  } else {
	                                    s1 = 64;
	                                    j2 -= 64;
	                                  }
	                                  p0 = offset0 + j0 * t0p2 + j1 * t0p0 + j2 * t0p1;
	                                  p1 = offset1 + j0 * t1p2 + j1 * t1p0 + j2 * t1p1;
	                                  var i0 = 0, i1 = 0, i2 = 0, d0s0 = t0p2, d0s1 = t0p0 - s2 * t0p2, d0s2 = t0p1 - s0 * t0p0, d1s0 = t1p2, d1s1 = t1p0 - s2 * t1p2, d1s2 = t1p1 - s0 * t1p0;
	                                  for (i2 = 0; i2 < s1; ++i2) {
	                                    for (i1 = 0; i1 < s0; ++i1) {
	                                      for (i0 = 0; i0 < s2; ++i0) {
	                                        a0[p0] = a1[p1];
	                                        p0 += d0s0;
	                                        p1 += d1s0;
	                                      }
	                                      p0 += d0s1;
	                                      p1 += d1s1;
	                                    }
	                                    p0 += d0s2;
	                                    p1 += d1s2;
	                                  }
	                                }
	                              }
	                            }
	                          };
	                        }, "uint8,2,0,1,array,2,0,1": function() {
	                          return function assign_cwise_loop_2s0s1m3u8a(SS, a0, t0, p0, a1, t1, p1) {
	                            var s0 = SS[0], s1 = SS[1], s2 = SS[2], t0p0 = t0[0], t0p1 = t0[1], t0p2 = t0[2], t1p0 = t1[0], t1p1 = t1[1], t1p2 = t1[2];
	                            p0 |= 0;
	                            p1 |= 0;
	                            var i0 = 0, i1 = 0, i2 = 0, d0s0 = t0p2, d0s1 = t0p0 - s2 * t0p2, d0s2 = t0p1 - s0 * t0p0, d1s0 = t1p2, d1s1 = t1p0 - s2 * t1p2, d1s2 = t1p1 - s0 * t1p0;
	                            for (i2 = 0; i2 < s1; ++i2) {
	                              for (i1 = 0; i1 < s0; ++i1) {
	                                for (i0 = 0; i0 < s2; ++i0) {
	                                  a0[p0] = a1[p1];
	                                  p0 += d0s0;
	                                  p1 += d1s0;
	                                }
	                                p0 += d0s1;
	                                p1 += d1s1;
	                              }
	                              p0 += d0s2;
	                              p1 += d1s2;
	                            }
	                          };
	                        } };
	                        function generateCWiseOp(proc, typesig) {
	                          var key = typesig.join(",");
	                          var f = CACHED_CWiseOp[key];
	                          return f();
	                        }
	                        var compile = generateCWiseOp;
	                        var CACHED_thunk = { mul: function(compile2) {
	                          var CACHED = {};
	                          return function mul_cwise_thunk(array0, array1, array2) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, t2 = array2.dtype, r2 = array2.order, type = [t0, r0.join(), t1, r1.join(), t2, r2.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1, t2, r2]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0, array2.data, array2.stride, array2.offset | 0);
	                          };
	                        }, muls: function(compile2) {
	                          var CACHED = {};
	                          return function muls_cwise_thunk(array0, array1, scalar2) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, type = [t0, r0.join(), t1, r1.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0, scalar2);
	                          };
	                        }, mulseq: function(compile2) {
	                          var CACHED = {};
	                          return function mulseq_cwise_thunk(array0, scalar1) {
	                            var t0 = array0.dtype, r0 = array0.order, type = [t0, r0.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, scalar1);
	                          };
	                        }, div: function(compile2) {
	                          var CACHED = {};
	                          return function div_cwise_thunk(array0, array1, array2) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, t2 = array2.dtype, r2 = array2.order, type = [t0, r0.join(), t1, r1.join(), t2, r2.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1, t2, r2]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0, array2.data, array2.stride, array2.offset | 0);
	                          };
	                        }, divs: function(compile2) {
	                          var CACHED = {};
	                          return function divs_cwise_thunk(array0, array1, scalar2) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, type = [t0, r0.join(), t1, r1.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0, scalar2);
	                          };
	                        }, divseq: function(compile2) {
	                          var CACHED = {};
	                          return function divseq_cwise_thunk(array0, scalar1) {
	                            var t0 = array0.dtype, r0 = array0.order, type = [t0, r0.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, scalar1);
	                          };
	                        }, assign: function(compile2) {
	                          var CACHED = {};
	                          return function assign_cwise_thunk(array0, array1) {
	                            var t0 = array0.dtype, r0 = array0.order, t1 = array1.dtype, r1 = array1.order, type = [t0, r0.join(), t1, r1.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0, t1, r1]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, array1.data, array1.stride, array1.offset | 0);
	                          };
	                        } };
	                        function createThunk(proc) {
	                          var thunk = CACHED_thunk[proc.funcName];
	                          return thunk(compile.bind(undefined, proc));
	                        }
	                        function makeOp(user_args) {
	                          return createThunk({ funcName: user_args.funcName });
	                        }
	                        var assign_ops = { mul: "*", div: "/" };
	                        (function() {
	                          for (var id in assign_ops) {
	                            exports2[id] = makeOp({ funcName: id });
	                            exports2[id + "s"] = makeOp({ funcName: id + "s" });
	                            exports2[id + "seq"] = makeOp({ funcName: id + "seq" });
	                          }
	                        })();
	                        exports2.assign = makeOp({ funcName: "assign" });
	                      }
	                    ),
	                    /***/
	                    7382: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_685580__) {
	                        var ndarray = __nested_webpack_require_685580__(5050);
	                        var do_convert = __nested_webpack_require_685580__(9262);
	                        module3.exports = function convert(arr, result) {
	                          var shape = [], c = arr, sz = 1;
	                          while (Array.isArray(c)) {
	                            shape.push(c.length);
	                            sz *= c.length;
	                            c = c[0];
	                          }
	                          if (shape.length === 0) {
	                            return ndarray();
	                          }
	                          if (!result) {
	                            result = ndarray(new Float64Array(sz), shape);
	                          }
	                          do_convert(result, arr);
	                          return result;
	                        };
	                      }
	                    ),
	                    /***/
	                    9262: (
	                      /***/
	                      function(module3) {
	                        function CwiseOp() {
	                          return function(SS, a0, t0, p0, Y0) {
	                            var s0 = SS[0], s1 = SS[1], s2 = SS[2], t0p0 = t0[0], t0p1 = t0[1], t0p2 = t0[2], index = [0, 0, 0];
	                            p0 |= 0;
	                            var i0 = 0, i1 = 0, i2 = 0, d0s0 = t0p2, d0s1 = t0p1 - s2 * t0p2, d0s2 = t0p0 - s1 * t0p1;
	                            for (i2 = 0; i2 < s0; ++i2) {
	                              for (i1 = 0; i1 < s1; ++i1) {
	                                for (i0 = 0; i0 < s2; ++i0) {
	                                  {
	                                    var _inline_1_v = Y0, _inline_1_i;
	                                    for (_inline_1_i = 0; _inline_1_i < index.length - 1; ++_inline_1_i) {
	                                      _inline_1_v = _inline_1_v[index[_inline_1_i]];
	                                    }
	                                    a0[p0] = _inline_1_v[index[index.length - 1]];
	                                  }
	                                  p0 += d0s0;
	                                  ++index[2];
	                                }
	                                p0 += d0s1;
	                                index[2] -= s2;
	                                ++index[1];
	                              }
	                              p0 += d0s2;
	                              index[1] -= s1;
	                              ++index[0];
	                            }
	                          };
	                        }
	                        function generateCWiseOp() {
	                          return CwiseOp();
	                        }
	                        var compile = generateCWiseOp;
	                        function thunk(compile2) {
	                          var CACHED = {};
	                          return function convert_cwise_thunk(array0, scalar1) {
	                            var t0 = array0.dtype, r0 = array0.order, type = [t0, r0.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, scalar1);
	                          };
	                        }
	                        function createThunk(proc) {
	                          return thunk(compile.bind(undefined, proc));
	                        }
	                        function compileCwise(user_args) {
	                          return createThunk({ funcName: user_args.funcName });
	                        }
	                        module3.exports = compileCwise({ funcName: "convert" });
	                      }
	                    ),
	                    /***/
	                    8139: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_687223__) {
	                        var pool = __nested_webpack_require_687223__(5306);
	                        function getMallocFree(dtype) {
	                          switch (dtype) {
	                            case "uint32":
	                              return [pool.mallocUint32, pool.freeUint32];
	                            default:
	                              return null;
	                          }
	                        }
	                        var CACHED_insertionSort = { "uint32,1,0": function(malloc, free) {
	                          return function ndarrayInsertionSort1d0uint32(left, right, data, offset, s0, s1, n0, n1, d1, e1, f1) {
	                            var i, j, cptr, ptr = left * s0 + offset, i1, scratch = malloc(n1), dptr, sptr, a, b;
	                            for (i = left + 1; i <= right; ++i) {
	                              j = i;
	                              ptr += s0;
	                              cptr = ptr;
	                              dptr = 0;
	                              sptr = ptr;
	                              for (i1 = 0; i1 < n1; ++i1) {
	                                scratch[dptr++] = data[sptr];
	                                sptr += d1;
	                              }
	                              __g: while (j-- > left) {
	                                dptr = 0;
	                                sptr = cptr - s0;
	                                __l: for (i1 = 0; i1 < n1; ++i1) {
	                                  a = data[sptr];
	                                  b = scratch[dptr];
	                                  if (a < b) {
	                                    break __g;
	                                  }
	                                  if (a > b) {
	                                    break __l;
	                                  }
	                                  sptr += e1;
	                                  dptr += f1;
	                                }
	                                dptr = cptr;
	                                sptr = cptr - s0;
	                                for (i1 = 0; i1 < n1; ++i1) {
	                                  data[dptr] = data[sptr];
	                                  dptr += d1;
	                                  sptr += d1;
	                                }
	                                cptr -= s0;
	                              }
	                              dptr = cptr;
	                              sptr = 0;
	                              for (i1 = 0; i1 < n1; ++i1) {
	                                data[dptr] = scratch[sptr++];
	                                dptr += d1;
	                              }
	                            }
	                            free(scratch);
	                          };
	                        } };
	                        function createInsertionSort(order, dtype) {
	                          var allocator = getMallocFree(dtype);
	                          var key = [dtype, order].join(",");
	                          var result = CACHED_insertionSort[key];
	                          if (allocator) {
	                            return result(allocator[0], allocator[1]);
	                          } else {
	                            return result();
	                          }
	                        }
	                        var CACHED_quickSort = { "uint32,1,0": function(insertionSort, malloc, free) {
	                          return function ndarrayQuickSort1d0uint32(left, right, data, offset, s0, s1, n0, n1, d1, e1, f1) {
	                            var sixth = (right - left + 1) / 6 | 0, index1 = left + sixth, index5 = right - sixth, index3 = left + right >> 1, index2 = index3 - sixth, index4 = index3 + sixth, el1 = index1, el2 = index2, el3 = index3, el4 = index4, el5 = index5, less = left + 1, great = right - 1, pivots_are_equal = true, tmp, tmp0, x, y, z, k, ptr0, ptr1, ptr2, comp_pivot1 = 0, comp_pivot2 = 0, comp = 0, i1, b_ptr0, b_ptr1, b_ptr2, b_ptr3, b_ptr4, b_ptr5, b_ptr6, b_ptr7, ptr3, ptr4, ptr5, ptr6, ptr7, pivot_ptr, ptr_shift, elementSize = n1, pivot1 = malloc(elementSize), pivot2 = malloc(elementSize);
	                            b_ptr0 = s0 * el1;
	                            b_ptr1 = s0 * el2;
	                            ptr_shift = offset;
	                            __l1: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el1;
	                                el1 = el2;
	                                el2 = tmp0;
	                                break __l1;
	                              }
	                              if (comp < 0) {
	                                break __l1;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el4;
	                            b_ptr1 = s0 * el5;
	                            ptr_shift = offset;
	                            __l2: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el4;
	                                el4 = el5;
	                                el5 = tmp0;
	                                break __l2;
	                              }
	                              if (comp < 0) {
	                                break __l2;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el1;
	                            b_ptr1 = s0 * el3;
	                            ptr_shift = offset;
	                            __l3: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el1;
	                                el1 = el3;
	                                el3 = tmp0;
	                                break __l3;
	                              }
	                              if (comp < 0) {
	                                break __l3;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el2;
	                            b_ptr1 = s0 * el3;
	                            ptr_shift = offset;
	                            __l4: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el2;
	                                el2 = el3;
	                                el3 = tmp0;
	                                break __l4;
	                              }
	                              if (comp < 0) {
	                                break __l4;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el1;
	                            b_ptr1 = s0 * el4;
	                            ptr_shift = offset;
	                            __l5: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el1;
	                                el1 = el4;
	                                el4 = tmp0;
	                                break __l5;
	                              }
	                              if (comp < 0) {
	                                break __l5;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el3;
	                            b_ptr1 = s0 * el4;
	                            ptr_shift = offset;
	                            __l6: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el3;
	                                el3 = el4;
	                                el4 = tmp0;
	                                break __l6;
	                              }
	                              if (comp < 0) {
	                                break __l6;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el2;
	                            b_ptr1 = s0 * el5;
	                            ptr_shift = offset;
	                            __l7: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el2;
	                                el2 = el5;
	                                el5 = tmp0;
	                                break __l7;
	                              }
	                              if (comp < 0) {
	                                break __l7;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el2;
	                            b_ptr1 = s0 * el3;
	                            ptr_shift = offset;
	                            __l8: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el2;
	                                el2 = el3;
	                                el3 = tmp0;
	                                break __l8;
	                              }
	                              if (comp < 0) {
	                                break __l8;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el4;
	                            b_ptr1 = s0 * el5;
	                            ptr_shift = offset;
	                            __l9: for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              comp = data[ptr0] - data[ptr1];
	                              if (comp > 0) {
	                                tmp0 = el4;
	                                el4 = el5;
	                                el5 = tmp0;
	                                break __l9;
	                              }
	                              if (comp < 0) {
	                                break __l9;
	                              }
	                              ptr_shift += e1;
	                            }
	                            b_ptr0 = s0 * el1;
	                            b_ptr1 = s0 * el2;
	                            b_ptr2 = s0 * el3;
	                            b_ptr3 = s0 * el4;
	                            b_ptr4 = s0 * el5;
	                            b_ptr5 = s0 * index1;
	                            b_ptr6 = s0 * index3;
	                            b_ptr7 = s0 * index5;
	                            pivot_ptr = 0;
	                            ptr_shift = offset;
	                            for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              ptr2 = b_ptr2 + ptr_shift;
	                              ptr3 = b_ptr3 + ptr_shift;
	                              ptr4 = b_ptr4 + ptr_shift;
	                              ptr5 = b_ptr5 + ptr_shift;
	                              ptr6 = b_ptr6 + ptr_shift;
	                              ptr7 = b_ptr7 + ptr_shift;
	                              pivot1[pivot_ptr] = data[ptr1];
	                              pivot2[pivot_ptr] = data[ptr3];
	                              pivots_are_equal = pivots_are_equal && pivot1[pivot_ptr] === pivot2[pivot_ptr];
	                              x = data[ptr0];
	                              y = data[ptr2];
	                              z = data[ptr4];
	                              data[ptr5] = x;
	                              data[ptr6] = y;
	                              data[ptr7] = z;
	                              ++pivot_ptr;
	                              ptr_shift += d1;
	                            }
	                            b_ptr0 = s0 * index2;
	                            b_ptr1 = s0 * left;
	                            ptr_shift = offset;
	                            for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              data[ptr0] = data[ptr1];
	                              ptr_shift += d1;
	                            }
	                            b_ptr0 = s0 * index4;
	                            b_ptr1 = s0 * right;
	                            ptr_shift = offset;
	                            for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              data[ptr0] = data[ptr1];
	                              ptr_shift += d1;
	                            }
	                            if (pivots_are_equal) {
	                              for (k = less; k <= great; ++k) {
	                                ptr0 = offset + k * s0;
	                                pivot_ptr = 0;
	                                __l10: for (i1 = 0; i1 < n1; ++i1) {
	                                  comp = data[ptr0] - pivot1[pivot_ptr];
	                                  if (comp !== 0) {
	                                    break __l10;
	                                  }
	                                  pivot_ptr += f1;
	                                  ptr0 += e1;
	                                }
	                                if (comp === 0) {
	                                  continue;
	                                }
	                                if (comp < 0) {
	                                  if (k !== less) {
	                                    b_ptr0 = s0 * k;
	                                    b_ptr1 = s0 * less;
	                                    ptr_shift = offset;
	                                    for (i1 = 0; i1 < n1; ++i1) {
	                                      ptr0 = b_ptr0 + ptr_shift;
	                                      ptr1 = b_ptr1 + ptr_shift;
	                                      tmp = data[ptr0];
	                                      data[ptr0] = data[ptr1];
	                                      data[ptr1] = tmp;
	                                      ptr_shift += d1;
	                                    }
	                                  }
	                                  ++less;
	                                } else {
	                                  while (true) {
	                                    ptr0 = offset + great * s0;
	                                    pivot_ptr = 0;
	                                    __l11: for (i1 = 0; i1 < n1; ++i1) {
	                                      comp = data[ptr0] - pivot1[pivot_ptr];
	                                      if (comp !== 0) {
	                                        break __l11;
	                                      }
	                                      pivot_ptr += f1;
	                                      ptr0 += e1;
	                                    }
	                                    if (comp > 0) {
	                                      great--;
	                                    } else if (comp < 0) {
	                                      b_ptr0 = s0 * k;
	                                      b_ptr1 = s0 * less;
	                                      b_ptr2 = s0 * great;
	                                      ptr_shift = offset;
	                                      for (i1 = 0; i1 < n1; ++i1) {
	                                        ptr0 = b_ptr0 + ptr_shift;
	                                        ptr1 = b_ptr1 + ptr_shift;
	                                        ptr2 = b_ptr2 + ptr_shift;
	                                        tmp = data[ptr0];
	                                        data[ptr0] = data[ptr1];
	                                        data[ptr1] = data[ptr2];
	                                        data[ptr2] = tmp;
	                                        ptr_shift += d1;
	                                      }
	                                      ++less;
	                                      --great;
	                                      break;
	                                    } else {
	                                      b_ptr0 = s0 * k;
	                                      b_ptr1 = s0 * great;
	                                      ptr_shift = offset;
	                                      for (i1 = 0; i1 < n1; ++i1) {
	                                        ptr0 = b_ptr0 + ptr_shift;
	                                        ptr1 = b_ptr1 + ptr_shift;
	                                        tmp = data[ptr0];
	                                        data[ptr0] = data[ptr1];
	                                        data[ptr1] = tmp;
	                                        ptr_shift += d1;
	                                      }
	                                      --great;
	                                      break;
	                                    }
	                                  }
	                                }
	                              }
	                            } else {
	                              for (k = less; k <= great; ++k) {
	                                ptr0 = offset + k * s0;
	                                pivot_ptr = 0;
	                                __l12: for (i1 = 0; i1 < n1; ++i1) {
	                                  comp_pivot1 = data[ptr0] - pivot1[pivot_ptr];
	                                  if (comp_pivot1 !== 0) {
	                                    break __l12;
	                                  }
	                                  pivot_ptr += f1;
	                                  ptr0 += e1;
	                                }
	                                if (comp_pivot1 < 0) {
	                                  if (k !== less) {
	                                    b_ptr0 = s0 * k;
	                                    b_ptr1 = s0 * less;
	                                    ptr_shift = offset;
	                                    for (i1 = 0; i1 < n1; ++i1) {
	                                      ptr0 = b_ptr0 + ptr_shift;
	                                      ptr1 = b_ptr1 + ptr_shift;
	                                      tmp = data[ptr0];
	                                      data[ptr0] = data[ptr1];
	                                      data[ptr1] = tmp;
	                                      ptr_shift += d1;
	                                    }
	                                  }
	                                  ++less;
	                                } else {
	                                  ptr0 = offset + k * s0;
	                                  pivot_ptr = 0;
	                                  __l13: for (i1 = 0; i1 < n1; ++i1) {
	                                    comp_pivot2 = data[ptr0] - pivot2[pivot_ptr];
	                                    if (comp_pivot2 !== 0) {
	                                      break __l13;
	                                    }
	                                    pivot_ptr += f1;
	                                    ptr0 += e1;
	                                  }
	                                  if (comp_pivot2 > 0) {
	                                    while (true) {
	                                      ptr0 = offset + great * s0;
	                                      pivot_ptr = 0;
	                                      __l14: for (i1 = 0; i1 < n1; ++i1) {
	                                        comp = data[ptr0] - pivot2[pivot_ptr];
	                                        if (comp !== 0) {
	                                          break __l14;
	                                        }
	                                        pivot_ptr += f1;
	                                        ptr0 += e1;
	                                      }
	                                      if (comp > 0) {
	                                        if (--great < k) {
	                                          break;
	                                        }
	                                        continue;
	                                      } else {
	                                        ptr0 = offset + great * s0;
	                                        pivot_ptr = 0;
	                                        __l15: for (i1 = 0; i1 < n1; ++i1) {
	                                          comp = data[ptr0] - pivot1[pivot_ptr];
	                                          if (comp !== 0) {
	                                            break __l15;
	                                          }
	                                          pivot_ptr += f1;
	                                          ptr0 += e1;
	                                        }
	                                        if (comp < 0) {
	                                          b_ptr0 = s0 * k;
	                                          b_ptr1 = s0 * less;
	                                          b_ptr2 = s0 * great;
	                                          ptr_shift = offset;
	                                          for (i1 = 0; i1 < n1; ++i1) {
	                                            ptr0 = b_ptr0 + ptr_shift;
	                                            ptr1 = b_ptr1 + ptr_shift;
	                                            ptr2 = b_ptr2 + ptr_shift;
	                                            tmp = data[ptr0];
	                                            data[ptr0] = data[ptr1];
	                                            data[ptr1] = data[ptr2];
	                                            data[ptr2] = tmp;
	                                            ptr_shift += d1;
	                                          }
	                                          ++less;
	                                          --great;
	                                        } else {
	                                          b_ptr0 = s0 * k;
	                                          b_ptr1 = s0 * great;
	                                          ptr_shift = offset;
	                                          for (i1 = 0; i1 < n1; ++i1) {
	                                            ptr0 = b_ptr0 + ptr_shift;
	                                            ptr1 = b_ptr1 + ptr_shift;
	                                            tmp = data[ptr0];
	                                            data[ptr0] = data[ptr1];
	                                            data[ptr1] = tmp;
	                                            ptr_shift += d1;
	                                          }
	                                          --great;
	                                        }
	                                        break;
	                                      }
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                            b_ptr0 = s0 * left;
	                            b_ptr1 = s0 * (less - 1);
	                            pivot_ptr = 0;
	                            ptr_shift = offset;
	                            for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              data[ptr0] = data[ptr1];
	                              data[ptr1] = pivot1[pivot_ptr];
	                              ++pivot_ptr;
	                              ptr_shift += d1;
	                            }
	                            b_ptr0 = s0 * right;
	                            b_ptr1 = s0 * (great + 1);
	                            pivot_ptr = 0;
	                            ptr_shift = offset;
	                            for (i1 = 0; i1 < n1; ++i1) {
	                              ptr0 = b_ptr0 + ptr_shift;
	                              ptr1 = b_ptr1 + ptr_shift;
	                              data[ptr0] = data[ptr1];
	                              data[ptr1] = pivot2[pivot_ptr];
	                              ++pivot_ptr;
	                              ptr_shift += d1;
	                            }
	                            if (less - 2 - left <= 32) {
	                              insertionSort(left, less - 2, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            } else {
	                              ndarrayQuickSort1d0uint32(left, less - 2, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            }
	                            if (right - (great + 2) <= 32) {
	                              insertionSort(great + 2, right, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            } else {
	                              ndarrayQuickSort1d0uint32(great + 2, right, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            }
	                            if (pivots_are_equal) {
	                              free(pivot1);
	                              free(pivot2);
	                              return;
	                            }
	                            if (less < index1 && great > index5) {
	                              __l16: while (true) {
	                                ptr0 = offset + less * s0;
	                                pivot_ptr = 0;
	                                ptr_shift = offset;
	                                for (i1 = 0; i1 < n1; ++i1) {
	                                  if (data[ptr0] !== pivot1[pivot_ptr]) {
	                                    break __l16;
	                                  }
	                                  ++pivot_ptr;
	                                  ptr0 += d1;
	                                }
	                                ++less;
	                              }
	                              __l17: while (true) {
	                                ptr0 = offset + great * s0;
	                                pivot_ptr = 0;
	                                ptr_shift = offset;
	                                for (i1 = 0; i1 < n1; ++i1) {
	                                  if (data[ptr0] !== pivot2[pivot_ptr]) {
	                                    break __l17;
	                                  }
	                                  ++pivot_ptr;
	                                  ptr0 += d1;
	                                }
	                                --great;
	                              }
	                              for (k = less; k <= great; ++k) {
	                                ptr0 = offset + k * s0;
	                                pivot_ptr = 0;
	                                __l18: for (i1 = 0; i1 < n1; ++i1) {
	                                  comp_pivot1 = data[ptr0] - pivot1[pivot_ptr];
	                                  if (comp_pivot1 !== 0) {
	                                    break __l18;
	                                  }
	                                  pivot_ptr += f1;
	                                  ptr0 += e1;
	                                }
	                                if (comp_pivot1 === 0) {
	                                  if (k !== less) {
	                                    b_ptr0 = s0 * k;
	                                    b_ptr1 = s0 * less;
	                                    ptr_shift = offset;
	                                    for (i1 = 0; i1 < n1; ++i1) {
	                                      ptr0 = b_ptr0 + ptr_shift;
	                                      ptr1 = b_ptr1 + ptr_shift;
	                                      tmp = data[ptr0];
	                                      data[ptr0] = data[ptr1];
	                                      data[ptr1] = tmp;
	                                      ptr_shift += d1;
	                                    }
	                                  }
	                                  ++less;
	                                } else {
	                                  ptr0 = offset + k * s0;
	                                  pivot_ptr = 0;
	                                  __l19: for (i1 = 0; i1 < n1; ++i1) {
	                                    comp_pivot2 = data[ptr0] - pivot2[pivot_ptr];
	                                    if (comp_pivot2 !== 0) {
	                                      break __l19;
	                                    }
	                                    pivot_ptr += f1;
	                                    ptr0 += e1;
	                                  }
	                                  if (comp_pivot2 === 0) {
	                                    while (true) {
	                                      ptr0 = offset + great * s0;
	                                      pivot_ptr = 0;
	                                      __l20: for (i1 = 0; i1 < n1; ++i1) {
	                                        comp = data[ptr0] - pivot2[pivot_ptr];
	                                        if (comp !== 0) {
	                                          break __l20;
	                                        }
	                                        pivot_ptr += f1;
	                                        ptr0 += e1;
	                                      }
	                                      if (comp === 0) {
	                                        if (--great < k) {
	                                          break;
	                                        }
	                                        continue;
	                                      } else {
	                                        ptr0 = offset + great * s0;
	                                        pivot_ptr = 0;
	                                        __l21: for (i1 = 0; i1 < n1; ++i1) {
	                                          comp = data[ptr0] - pivot1[pivot_ptr];
	                                          if (comp !== 0) {
	                                            break __l21;
	                                          }
	                                          pivot_ptr += f1;
	                                          ptr0 += e1;
	                                        }
	                                        if (comp < 0) {
	                                          b_ptr0 = s0 * k;
	                                          b_ptr1 = s0 * less;
	                                          b_ptr2 = s0 * great;
	                                          ptr_shift = offset;
	                                          for (i1 = 0; i1 < n1; ++i1) {
	                                            ptr0 = b_ptr0 + ptr_shift;
	                                            ptr1 = b_ptr1 + ptr_shift;
	                                            ptr2 = b_ptr2 + ptr_shift;
	                                            tmp = data[ptr0];
	                                            data[ptr0] = data[ptr1];
	                                            data[ptr1] = data[ptr2];
	                                            data[ptr2] = tmp;
	                                            ptr_shift += d1;
	                                          }
	                                          ++less;
	                                          --great;
	                                        } else {
	                                          b_ptr0 = s0 * k;
	                                          b_ptr1 = s0 * great;
	                                          ptr_shift = offset;
	                                          for (i1 = 0; i1 < n1; ++i1) {
	                                            ptr0 = b_ptr0 + ptr_shift;
	                                            ptr1 = b_ptr1 + ptr_shift;
	                                            tmp = data[ptr0];
	                                            data[ptr0] = data[ptr1];
	                                            data[ptr1] = tmp;
	                                            ptr_shift += d1;
	                                          }
	                                          --great;
	                                        }
	                                        break;
	                                      }
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                            free(pivot1);
	                            free(pivot2);
	                            if (great - less <= 32) {
	                              insertionSort(less, great, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            } else {
	                              ndarrayQuickSort1d0uint32(less, great, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            }
	                          };
	                        } };
	                        function createQuickSort(order, dtype, insertionSort) {
	                          var allocator = getMallocFree(dtype);
	                          var key = [dtype, order].join(",");
	                          var result = CACHED_quickSort[key];
	                          if (order.length > 1 && allocator) {
	                            return result(insertionSort, allocator[0], allocator[1]);
	                          } else {
	                            return result(insertionSort);
	                          }
	                        }
	                        var CACHED_sort = { "uint32,1,0": function(insertionSort, quickSort) {
	                          return function(array) {
	                            var data = array.data, offset = array.offset | 0, shape = array.shape, stride = array.stride, s0 = stride[0] | 0, n0 = shape[0] | 0, s1 = stride[1] | 0, n1 = shape[1] | 0, d1 = s1, e1 = s1, f1 = 1;
	                            if (n0 <= 32) {
	                              insertionSort(0, n0 - 1, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            } else {
	                              quickSort(0, n0 - 1, data, offset, s0, s1, n0, n1, d1, e1, f1);
	                            }
	                          };
	                        } };
	                        function compileSort(order, dtype) {
	                          var key = [dtype, order].join(",");
	                          var result = CACHED_sort[key];
	                          var insertionSort = createInsertionSort(order, dtype);
	                          var quickSort = createQuickSort(order, dtype, insertionSort);
	                          return result(insertionSort, quickSort);
	                        }
	                        module3.exports = compileSort;
	                      }
	                    ),
	                    /***/
	                    8729: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_698074__) {
	                        var compile = __nested_webpack_require_698074__(8139);
	                        var CACHE = {};
	                        function sort(array) {
	                          var order = array.order;
	                          var dtype = array.dtype;
	                          var typeSig = [order, dtype];
	                          var typeName = typeSig.join(":");
	                          var compiled = CACHE[typeName];
	                          if (!compiled) {
	                            CACHE[typeName] = compiled = compile(order, dtype);
	                          }
	                          compiled(array);
	                          return array;
	                        }
	                        module3.exports = sort;
	                      }
	                    ),
	                    /***/
	                    5050: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_698484__) {
	                        var isBuffer = __nested_webpack_require_698484__(4780);
	                        var hasTypedArrays = typeof Float64Array !== "undefined";
	                        function compare1st(a, b) {
	                          return a[0] - b[0];
	                        }
	                        function order() {
	                          var stride = this.stride;
	                          var terms = new Array(stride.length);
	                          var i;
	                          for (i = 0; i < terms.length; ++i) {
	                            terms[i] = [Math.abs(stride[i]), i];
	                          }
	                          terms.sort(compare1st);
	                          var result = new Array(terms.length);
	                          for (i = 0; i < result.length; ++i) {
	                            result[i] = terms[i][1];
	                          }
	                          return result;
	                        }
	                        var allFns = {
	                          // Special case for trivial arrays
	                          T: function(dtype) {
	                            function View(a) {
	                              this.data = a;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.index = function() {
	                              return -1;
	                            };
	                            proto.size = 0;
	                            proto.dimension = -1;
	                            proto.shape = proto.stride = proto.order = [];
	                            proto.lo = proto.hi = proto.transpose = proto.step = function() {
	                              return new View(this.data);
	                            };
	                            proto.get = proto.set = function() {
	                            };
	                            proto.pick = function() {
	                              return null;
	                            };
	                            return function construct(a) {
	                              return new View(a);
	                            };
	                          },
	                          // Special case for 0d arrays
	                          0: function(dtype, TrivialArray) {
	                            function View(a, d) {
	                              this.data = a;
	                              this.offset = d;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.index = function() {
	                              return this.offset;
	                            };
	                            proto.dimension = 0;
	                            proto.size = 1;
	                            proto.shape = proto.stride = proto.order = [];
	                            proto.lo = proto.hi = proto.transpose = proto.step = function copy() {
	                              return new View(this.data, this.offset);
	                            };
	                            proto.pick = function pick() {
	                              return TrivialArray(this.data);
	                            };
	                            proto.valueOf = proto.get = function get() {
	                              return dtype === "generic" ? this.data.get(this.offset) : this.data[this.offset];
	                            };
	                            proto.set = function set(v) {
	                              return dtype === "generic" ? this.data.set(this.offset, v) : this.data[this.offset] = v;
	                            };
	                            return function construct(a, b, c, d) {
	                              return new View(a, d);
	                            };
	                          },
	                          1: function(dtype, CTOR_LIST, ORDER) {
	                            function View(a, b0, c0, d) {
	                              this.data = a;
	                              this.shape = [b0];
	                              this.stride = [c0];
	                              this.offset = d | 0;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.dimension = 1;
	                            Object.defineProperty(proto, "size", { get: function size() {
	                              return this.shape[0];
	                            } });
	                            proto.order = [0];
	                            proto.set = function set(i0, v) {
	                              return dtype === "generic" ? this.data.set(this.offset + this.stride[0] * i0, v) : this.data[this.offset + this.stride[0] * i0] = v;
	                            };
	                            proto.get = function get(i0) {
	                              return dtype === "generic" ? this.data.get(this.offset + this.stride[0] * i0) : this.data[this.offset + this.stride[0] * i0];
	                            };
	                            proto.index = function index(i0) {
	                              return this.offset + this.stride[0] * i0;
	                            };
	                            proto.hi = function hi(i0) {
	                              return new View(this.data, typeof i0 !== "number" || i0 < 0 ? this.shape[0] : i0 | 0, this.stride[0], this.offset);
	                            };
	                            proto.lo = function lo(i0) {
	                              var b = this.offset, d = 0, a0 = this.shape[0], c0 = this.stride[0];
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                d = i0 | 0;
	                                b += c0 * d;
	                                a0 -= d;
	                              }
	                              return new View(this.data, a0, c0, b);
	                            };
	                            proto.step = function step(i0) {
	                              var a0 = this.shape[0], b0 = this.stride[0], c = this.offset, d = 0, ceil = Math.ceil;
	                              if (typeof i0 === "number") {
	                                d = i0 | 0;
	                                if (d < 0) {
	                                  c += b0 * (a0 - 1);
	                                  a0 = ceil(-a0 / d);
	                                } else {
	                                  a0 = ceil(a0 / d);
	                                }
	                                b0 *= d;
	                              }
	                              return new View(this.data, a0, b0, c);
	                            };
	                            proto.transpose = function transpose(i0) {
	                              i0 = i0 === undefined ? 0 : i0 | 0;
	                              var a = this.shape, b = this.stride;
	                              return new View(this.data, a[i0], b[i0], this.offset);
	                            };
	                            proto.pick = function pick(i0) {
	                              var a = [], b = [], c = this.offset;
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                c = c + this.stride[0] * i0 | 0;
	                              } else {
	                                a.push(this.shape[0]);
	                                b.push(this.stride[0]);
	                              }
	                              var ctor = CTOR_LIST[a.length + 1];
	                              return ctor(this.data, a, b, c);
	                            };
	                            return function construct(data, shape, stride, offset) {
	                              return new View(data, shape[0], stride[0], offset);
	                            };
	                          },
	                          2: function(dtype, CTOR_LIST, ORDER) {
	                            function View(a, b0, b1, c0, c1, d) {
	                              this.data = a;
	                              this.shape = [b0, b1];
	                              this.stride = [c0, c1];
	                              this.offset = d | 0;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.dimension = 2;
	                            Object.defineProperty(proto, "size", { get: function size() {
	                              return this.shape[0] * this.shape[1];
	                            } });
	                            Object.defineProperty(proto, "order", { get: function order2() {
	                              return Math.abs(this.stride[0]) > Math.abs(this.stride[1]) ? [1, 0] : [0, 1];
	                            } });
	                            proto.set = function set(i0, i1, v) {
	                              return dtype === "generic" ? this.data.set(this.offset + this.stride[0] * i0 + this.stride[1] * i1, v) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1] = v;
	                            };
	                            proto.get = function get(i0, i1) {
	                              return dtype === "generic" ? this.data.get(this.offset + this.stride[0] * i0 + this.stride[1] * i1) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1];
	                            };
	                            proto.index = function index(i0, i1) {
	                              return this.offset + this.stride[0] * i0 + this.stride[1] * i1;
	                            };
	                            proto.hi = function hi(i0, i1) {
	                              return new View(this.data, typeof i0 !== "number" || i0 < 0 ? this.shape[0] : i0 | 0, typeof i1 !== "number" || i1 < 0 ? this.shape[1] : i1 | 0, this.stride[0], this.stride[1], this.offset);
	                            };
	                            proto.lo = function lo(i0, i1) {
	                              var b = this.offset, d = 0, a0 = this.shape[0], a1 = this.shape[1], c0 = this.stride[0], c1 = this.stride[1];
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                d = i0 | 0;
	                                b += c0 * d;
	                                a0 -= d;
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                d = i1 | 0;
	                                b += c1 * d;
	                                a1 -= d;
	                              }
	                              return new View(this.data, a0, a1, c0, c1, b);
	                            };
	                            proto.step = function step(i0, i1) {
	                              var a0 = this.shape[0], a1 = this.shape[1], b0 = this.stride[0], b1 = this.stride[1], c = this.offset, d = 0, ceil = Math.ceil;
	                              if (typeof i0 === "number") {
	                                d = i0 | 0;
	                                if (d < 0) {
	                                  c += b0 * (a0 - 1);
	                                  a0 = ceil(-a0 / d);
	                                } else {
	                                  a0 = ceil(a0 / d);
	                                }
	                                b0 *= d;
	                              }
	                              if (typeof i1 === "number") {
	                                d = i1 | 0;
	                                if (d < 0) {
	                                  c += b1 * (a1 - 1);
	                                  a1 = ceil(-a1 / d);
	                                } else {
	                                  a1 = ceil(a1 / d);
	                                }
	                                b1 *= d;
	                              }
	                              return new View(this.data, a0, a1, b0, b1, c);
	                            };
	                            proto.transpose = function transpose(i0, i1) {
	                              i0 = i0 === undefined ? 0 : i0 | 0;
	                              i1 = i1 === undefined ? 1 : i1 | 0;
	                              var a = this.shape, b = this.stride;
	                              return new View(this.data, a[i0], a[i1], b[i0], b[i1], this.offset);
	                            };
	                            proto.pick = function pick(i0, i1) {
	                              var a = [], b = [], c = this.offset;
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                c = c + this.stride[0] * i0 | 0;
	                              } else {
	                                a.push(this.shape[0]);
	                                b.push(this.stride[0]);
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                c = c + this.stride[1] * i1 | 0;
	                              } else {
	                                a.push(this.shape[1]);
	                                b.push(this.stride[1]);
	                              }
	                              var ctor = CTOR_LIST[a.length + 1];
	                              return ctor(this.data, a, b, c);
	                            };
	                            return function construct(data, shape, stride, offset) {
	                              return new View(data, shape[0], shape[1], stride[0], stride[1], offset);
	                            };
	                          },
	                          3: function(dtype, CTOR_LIST, ORDER) {
	                            function View(a, b0, b1, b2, c0, c1, c2, d) {
	                              this.data = a;
	                              this.shape = [b0, b1, b2];
	                              this.stride = [c0, c1, c2];
	                              this.offset = d | 0;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.dimension = 3;
	                            Object.defineProperty(proto, "size", { get: function size() {
	                              return this.shape[0] * this.shape[1] * this.shape[2];
	                            } });
	                            Object.defineProperty(proto, "order", { get: function order2() {
	                              var s0 = Math.abs(this.stride[0]), s1 = Math.abs(this.stride[1]), s2 = Math.abs(this.stride[2]);
	                              if (s0 > s1) {
	                                if (s1 > s2) {
	                                  return [2, 1, 0];
	                                } else if (s0 > s2) {
	                                  return [1, 2, 0];
	                                } else {
	                                  return [1, 0, 2];
	                                }
	                              } else if (s0 > s2) {
	                                return [2, 0, 1];
	                              } else if (s2 > s1) {
	                                return [0, 1, 2];
	                              } else {
	                                return [0, 2, 1];
	                              }
	                            } });
	                            proto.set = function set(i0, i1, i2, v) {
	                              return dtype === "generic" ? this.data.set(this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2, v) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2] = v;
	                            };
	                            proto.get = function get(i0, i1, i2) {
	                              return dtype === "generic" ? this.data.get(this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2];
	                            };
	                            proto.index = function index(i0, i1, i2) {
	                              return this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2;
	                            };
	                            proto.hi = function hi(i0, i1, i2) {
	                              return new View(this.data, typeof i0 !== "number" || i0 < 0 ? this.shape[0] : i0 | 0, typeof i1 !== "number" || i1 < 0 ? this.shape[1] : i1 | 0, typeof i2 !== "number" || i2 < 0 ? this.shape[2] : i2 | 0, this.stride[0], this.stride[1], this.stride[2], this.offset);
	                            };
	                            proto.lo = function lo(i0, i1, i2) {
	                              var b = this.offset, d = 0, a0 = this.shape[0], a1 = this.shape[1], a2 = this.shape[2], c0 = this.stride[0], c1 = this.stride[1], c2 = this.stride[2];
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                d = i0 | 0;
	                                b += c0 * d;
	                                a0 -= d;
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                d = i1 | 0;
	                                b += c1 * d;
	                                a1 -= d;
	                              }
	                              if (typeof i2 === "number" && i2 >= 0) {
	                                d = i2 | 0;
	                                b += c2 * d;
	                                a2 -= d;
	                              }
	                              return new View(this.data, a0, a1, a2, c0, c1, c2, b);
	                            };
	                            proto.step = function step(i0, i1, i2) {
	                              var a0 = this.shape[0], a1 = this.shape[1], a2 = this.shape[2], b0 = this.stride[0], b1 = this.stride[1], b2 = this.stride[2], c = this.offset, d = 0, ceil = Math.ceil;
	                              if (typeof i0 === "number") {
	                                d = i0 | 0;
	                                if (d < 0) {
	                                  c += b0 * (a0 - 1);
	                                  a0 = ceil(-a0 / d);
	                                } else {
	                                  a0 = ceil(a0 / d);
	                                }
	                                b0 *= d;
	                              }
	                              if (typeof i1 === "number") {
	                                d = i1 | 0;
	                                if (d < 0) {
	                                  c += b1 * (a1 - 1);
	                                  a1 = ceil(-a1 / d);
	                                } else {
	                                  a1 = ceil(a1 / d);
	                                }
	                                b1 *= d;
	                              }
	                              if (typeof i2 === "number") {
	                                d = i2 | 0;
	                                if (d < 0) {
	                                  c += b2 * (a2 - 1);
	                                  a2 = ceil(-a2 / d);
	                                } else {
	                                  a2 = ceil(a2 / d);
	                                }
	                                b2 *= d;
	                              }
	                              return new View(this.data, a0, a1, a2, b0, b1, b2, c);
	                            };
	                            proto.transpose = function transpose(i0, i1, i2) {
	                              i0 = i0 === undefined ? 0 : i0 | 0;
	                              i1 = i1 === undefined ? 1 : i1 | 0;
	                              i2 = i2 === undefined ? 2 : i2 | 0;
	                              var a = this.shape, b = this.stride;
	                              return new View(this.data, a[i0], a[i1], a[i2], b[i0], b[i1], b[i2], this.offset);
	                            };
	                            proto.pick = function pick(i0, i1, i2) {
	                              var a = [], b = [], c = this.offset;
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                c = c + this.stride[0] * i0 | 0;
	                              } else {
	                                a.push(this.shape[0]);
	                                b.push(this.stride[0]);
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                c = c + this.stride[1] * i1 | 0;
	                              } else {
	                                a.push(this.shape[1]);
	                                b.push(this.stride[1]);
	                              }
	                              if (typeof i2 === "number" && i2 >= 0) {
	                                c = c + this.stride[2] * i2 | 0;
	                              } else {
	                                a.push(this.shape[2]);
	                                b.push(this.stride[2]);
	                              }
	                              var ctor = CTOR_LIST[a.length + 1];
	                              return ctor(this.data, a, b, c);
	                            };
	                            return function construct(data, shape, stride, offset) {
	                              return new View(data, shape[0], shape[1], shape[2], stride[0], stride[1], stride[2], offset);
	                            };
	                          },
	                          4: function(dtype, CTOR_LIST, ORDER) {
	                            function View(a, b0, b1, b2, b3, c0, c1, c2, c3, d) {
	                              this.data = a;
	                              this.shape = [b0, b1, b2, b3];
	                              this.stride = [c0, c1, c2, c3];
	                              this.offset = d | 0;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.dimension = 4;
	                            Object.defineProperty(proto, "size", { get: function size() {
	                              return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3];
	                            } });
	                            Object.defineProperty(proto, "order", { get: ORDER });
	                            proto.set = function set(i0, i1, i2, i3, v) {
	                              return dtype === "generic" ? this.data.set(this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3, v) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3] = v;
	                            };
	                            proto.get = function get(i0, i1, i2, i3) {
	                              return dtype === "generic" ? this.data.get(this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3];
	                            };
	                            proto.index = function index(i0, i1, i2, i3) {
	                              return this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3;
	                            };
	                            proto.hi = function hi(i0, i1, i2, i3) {
	                              return new View(this.data, typeof i0 !== "number" || i0 < 0 ? this.shape[0] : i0 | 0, typeof i1 !== "number" || i1 < 0 ? this.shape[1] : i1 | 0, typeof i2 !== "number" || i2 < 0 ? this.shape[2] : i2 | 0, typeof i3 !== "number" || i3 < 0 ? this.shape[3] : i3 | 0, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.offset);
	                            };
	                            proto.lo = function lo(i0, i1, i2, i3) {
	                              var b = this.offset, d = 0, a0 = this.shape[0], a1 = this.shape[1], a2 = this.shape[2], a3 = this.shape[3], c0 = this.stride[0], c1 = this.stride[1], c2 = this.stride[2], c3 = this.stride[3];
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                d = i0 | 0;
	                                b += c0 * d;
	                                a0 -= d;
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                d = i1 | 0;
	                                b += c1 * d;
	                                a1 -= d;
	                              }
	                              if (typeof i2 === "number" && i2 >= 0) {
	                                d = i2 | 0;
	                                b += c2 * d;
	                                a2 -= d;
	                              }
	                              if (typeof i3 === "number" && i3 >= 0) {
	                                d = i3 | 0;
	                                b += c3 * d;
	                                a3 -= d;
	                              }
	                              return new View(this.data, a0, a1, a2, a3, c0, c1, c2, c3, b);
	                            };
	                            proto.step = function step(i0, i1, i2, i3) {
	                              var a0 = this.shape[0], a1 = this.shape[1], a2 = this.shape[2], a3 = this.shape[3], b0 = this.stride[0], b1 = this.stride[1], b2 = this.stride[2], b3 = this.stride[3], c = this.offset, d = 0, ceil = Math.ceil;
	                              if (typeof i0 === "number") {
	                                d = i0 | 0;
	                                if (d < 0) {
	                                  c += b0 * (a0 - 1);
	                                  a0 = ceil(-a0 / d);
	                                } else {
	                                  a0 = ceil(a0 / d);
	                                }
	                                b0 *= d;
	                              }
	                              if (typeof i1 === "number") {
	                                d = i1 | 0;
	                                if (d < 0) {
	                                  c += b1 * (a1 - 1);
	                                  a1 = ceil(-a1 / d);
	                                } else {
	                                  a1 = ceil(a1 / d);
	                                }
	                                b1 *= d;
	                              }
	                              if (typeof i2 === "number") {
	                                d = i2 | 0;
	                                if (d < 0) {
	                                  c += b2 * (a2 - 1);
	                                  a2 = ceil(-a2 / d);
	                                } else {
	                                  a2 = ceil(a2 / d);
	                                }
	                                b2 *= d;
	                              }
	                              if (typeof i3 === "number") {
	                                d = i3 | 0;
	                                if (d < 0) {
	                                  c += b3 * (a3 - 1);
	                                  a3 = ceil(-a3 / d);
	                                } else {
	                                  a3 = ceil(a3 / d);
	                                }
	                                b3 *= d;
	                              }
	                              return new View(this.data, a0, a1, a2, a3, b0, b1, b2, b3, c);
	                            };
	                            proto.transpose = function transpose(i0, i1, i2, i3) {
	                              i0 = i0 === undefined ? 0 : i0 | 0;
	                              i1 = i1 === undefined ? 1 : i1 | 0;
	                              i2 = i2 === undefined ? 2 : i2 | 0;
	                              i3 = i3 === undefined ? 3 : i3 | 0;
	                              var a = this.shape, b = this.stride;
	                              return new View(this.data, a[i0], a[i1], a[i2], a[i3], b[i0], b[i1], b[i2], b[i3], this.offset);
	                            };
	                            proto.pick = function pick(i0, i1, i2, i3) {
	                              var a = [], b = [], c = this.offset;
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                c = c + this.stride[0] * i0 | 0;
	                              } else {
	                                a.push(this.shape[0]);
	                                b.push(this.stride[0]);
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                c = c + this.stride[1] * i1 | 0;
	                              } else {
	                                a.push(this.shape[1]);
	                                b.push(this.stride[1]);
	                              }
	                              if (typeof i2 === "number" && i2 >= 0) {
	                                c = c + this.stride[2] * i2 | 0;
	                              } else {
	                                a.push(this.shape[2]);
	                                b.push(this.stride[2]);
	                              }
	                              if (typeof i3 === "number" && i3 >= 0) {
	                                c = c + this.stride[3] * i3 | 0;
	                              } else {
	                                a.push(this.shape[3]);
	                                b.push(this.stride[3]);
	                              }
	                              var ctor = CTOR_LIST[a.length + 1];
	                              return ctor(this.data, a, b, c);
	                            };
	                            return function construct(data, shape, stride, offset) {
	                              return new View(data, shape[0], shape[1], shape[2], shape[3], stride[0], stride[1], stride[2], stride[3], offset);
	                            };
	                          },
	                          5: function anonymous(dtype, CTOR_LIST, ORDER) {
	                            function View(a, b0, b1, b2, b3, b4, c0, c1, c2, c3, c4, d) {
	                              this.data = a;
	                              this.shape = [b0, b1, b2, b3, b4];
	                              this.stride = [c0, c1, c2, c3, c4];
	                              this.offset = d | 0;
	                            }
	                            var proto = View.prototype;
	                            proto.dtype = dtype;
	                            proto.dimension = 5;
	                            Object.defineProperty(proto, "size", { get: function size() {
	                              return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3] * this.shape[4];
	                            } });
	                            Object.defineProperty(proto, "order", { get: ORDER });
	                            proto.set = function set(i0, i1, i2, i3, i4, v) {
	                              return dtype === "generic" ? this.data.set(this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3 + this.stride[4] * i4, v) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3 + this.stride[4] * i4] = v;
	                            };
	                            proto.get = function get(i0, i1, i2, i3, i4) {
	                              return dtype === "generic" ? this.data.get(this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3 + this.stride[4] * i4) : this.data[this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3 + this.stride[4] * i4];
	                            };
	                            proto.index = function index(i0, i1, i2, i3, i4) {
	                              return this.offset + this.stride[0] * i0 + this.stride[1] * i1 + this.stride[2] * i2 + this.stride[3] * i3 + this.stride[4] * i4;
	                            };
	                            proto.hi = function hi(i0, i1, i2, i3, i4) {
	                              return new View(this.data, typeof i0 !== "number" || i0 < 0 ? this.shape[0] : i0 | 0, typeof i1 !== "number" || i1 < 0 ? this.shape[1] : i1 | 0, typeof i2 !== "number" || i2 < 0 ? this.shape[2] : i2 | 0, typeof i3 !== "number" || i3 < 0 ? this.shape[3] : i3 | 0, typeof i4 !== "number" || i4 < 0 ? this.shape[4] : i4 | 0, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.stride[4], this.offset);
	                            };
	                            proto.lo = function lo(i0, i1, i2, i3, i4) {
	                              var b = this.offset, d = 0, a0 = this.shape[0], a1 = this.shape[1], a2 = this.shape[2], a3 = this.shape[3], a4 = this.shape[4], c0 = this.stride[0], c1 = this.stride[1], c2 = this.stride[2], c3 = this.stride[3], c4 = this.stride[4];
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                d = i0 | 0;
	                                b += c0 * d;
	                                a0 -= d;
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                d = i1 | 0;
	                                b += c1 * d;
	                                a1 -= d;
	                              }
	                              if (typeof i2 === "number" && i2 >= 0) {
	                                d = i2 | 0;
	                                b += c2 * d;
	                                a2 -= d;
	                              }
	                              if (typeof i3 === "number" && i3 >= 0) {
	                                d = i3 | 0;
	                                b += c3 * d;
	                                a3 -= d;
	                              }
	                              if (typeof i4 === "number" && i4 >= 0) {
	                                d = i4 | 0;
	                                b += c4 * d;
	                                a4 -= d;
	                              }
	                              return new View(this.data, a0, a1, a2, a3, a4, c0, c1, c2, c3, c4, b);
	                            };
	                            proto.step = function step(i0, i1, i2, i3, i4) {
	                              var a0 = this.shape[0], a1 = this.shape[1], a2 = this.shape[2], a3 = this.shape[3], a4 = this.shape[4], b0 = this.stride[0], b1 = this.stride[1], b2 = this.stride[2], b3 = this.stride[3], b4 = this.stride[4], c = this.offset, d = 0, ceil = Math.ceil;
	                              if (typeof i0 === "number") {
	                                d = i0 | 0;
	                                if (d < 0) {
	                                  c += b0 * (a0 - 1);
	                                  a0 = ceil(-a0 / d);
	                                } else {
	                                  a0 = ceil(a0 / d);
	                                }
	                                b0 *= d;
	                              }
	                              if (typeof i1 === "number") {
	                                d = i1 | 0;
	                                if (d < 0) {
	                                  c += b1 * (a1 - 1);
	                                  a1 = ceil(-a1 / d);
	                                } else {
	                                  a1 = ceil(a1 / d);
	                                }
	                                b1 *= d;
	                              }
	                              if (typeof i2 === "number") {
	                                d = i2 | 0;
	                                if (d < 0) {
	                                  c += b2 * (a2 - 1);
	                                  a2 = ceil(-a2 / d);
	                                } else {
	                                  a2 = ceil(a2 / d);
	                                }
	                                b2 *= d;
	                              }
	                              if (typeof i3 === "number") {
	                                d = i3 | 0;
	                                if (d < 0) {
	                                  c += b3 * (a3 - 1);
	                                  a3 = ceil(-a3 / d);
	                                } else {
	                                  a3 = ceil(a3 / d);
	                                }
	                                b3 *= d;
	                              }
	                              if (typeof i4 === "number") {
	                                d = i4 | 0;
	                                if (d < 0) {
	                                  c += b4 * (a4 - 1);
	                                  a4 = ceil(-a4 / d);
	                                } else {
	                                  a4 = ceil(a4 / d);
	                                }
	                                b4 *= d;
	                              }
	                              return new View(this.data, a0, a1, a2, a3, a4, b0, b1, b2, b3, b4, c);
	                            };
	                            proto.transpose = function transpose(i0, i1, i2, i3, i4) {
	                              i0 = i0 === undefined ? 0 : i0 | 0;
	                              i1 = i1 === undefined ? 1 : i1 | 0;
	                              i2 = i2 === undefined ? 2 : i2 | 0;
	                              i3 = i3 === undefined ? 3 : i3 | 0;
	                              i4 = i4 === undefined ? 4 : i4 | 0;
	                              var a = this.shape, b = this.stride;
	                              return new View(this.data, a[i0], a[i1], a[i2], a[i3], a[i4], b[i0], b[i1], b[i2], b[i3], b[i4], this.offset);
	                            };
	                            proto.pick = function pick(i0, i1, i2, i3, i4) {
	                              var a = [], b = [], c = this.offset;
	                              if (typeof i0 === "number" && i0 >= 0) {
	                                c = c + this.stride[0] * i0 | 0;
	                              } else {
	                                a.push(this.shape[0]);
	                                b.push(this.stride[0]);
	                              }
	                              if (typeof i1 === "number" && i1 >= 0) {
	                                c = c + this.stride[1] * i1 | 0;
	                              } else {
	                                a.push(this.shape[1]);
	                                b.push(this.stride[1]);
	                              }
	                              if (typeof i2 === "number" && i2 >= 0) {
	                                c = c + this.stride[2] * i2 | 0;
	                              } else {
	                                a.push(this.shape[2]);
	                                b.push(this.stride[2]);
	                              }
	                              if (typeof i3 === "number" && i3 >= 0) {
	                                c = c + this.stride[3] * i3 | 0;
	                              } else {
	                                a.push(this.shape[3]);
	                                b.push(this.stride[3]);
	                              }
	                              if (typeof i4 === "number" && i4 >= 0) {
	                                c = c + this.stride[4] * i4 | 0;
	                              } else {
	                                a.push(this.shape[4]);
	                                b.push(this.stride[4]);
	                              }
	                              var ctor = CTOR_LIST[a.length + 1];
	                              return ctor(this.data, a, b, c);
	                            };
	                            return function construct(data, shape, stride, offset) {
	                              return new View(data, shape[0], shape[1], shape[2], shape[3], shape[4], stride[0], stride[1], stride[2], stride[3], stride[4], offset);
	                            };
	                          }
	                        };
	                        function compileConstructor(inType, inDimension) {
	                          var dKey = inDimension === -1 ? "T" : String(inDimension);
	                          var procedure = allFns[dKey];
	                          if (inDimension === -1) {
	                            return procedure(inType);
	                          } else if (inDimension === 0) {
	                            return procedure(inType, CACHED_CONSTRUCTORS[inType][0]);
	                          }
	                          return procedure(inType, CACHED_CONSTRUCTORS[inType], order);
	                        }
	                        function arrayDType(data) {
	                          if (isBuffer(data)) {
	                            return "buffer";
	                          }
	                          if (hasTypedArrays) {
	                            switch (Object.prototype.toString.call(data)) {
	                              case "[object Float64Array]":
	                                return "float64";
	                              case "[object Float32Array]":
	                                return "float32";
	                              case "[object Int8Array]":
	                                return "int8";
	                              case "[object Int16Array]":
	                                return "int16";
	                              case "[object Int32Array]":
	                                return "int32";
	                              case "[object Uint8ClampedArray]":
	                                return "uint8_clamped";
	                              case "[object Uint8Array]":
	                                return "uint8";
	                              case "[object Uint16Array]":
	                                return "uint16";
	                              case "[object Uint32Array]":
	                                return "uint32";
	                              case "[object BigInt64Array]":
	                                return "bigint64";
	                              case "[object BigUint64Array]":
	                                return "biguint64";
	                            }
	                          }
	                          if (Array.isArray(data)) {
	                            return "array";
	                          }
	                          return "generic";
	                        }
	                        var CACHED_CONSTRUCTORS = {
	                          "generic": [],
	                          "buffer": [],
	                          "array": [],
	                          // typed arrays
	                          "float32": [],
	                          "float64": [],
	                          "int8": [],
	                          "int16": [],
	                          "int32": [],
	                          "uint8_clamped": [],
	                          "uint8": [],
	                          "uint16": [],
	                          "uint32": [],
	                          "bigint64": [],
	                          "biguint64": []
	                        };
	                        function wrappedNDArrayCtor(data, shape, stride, offset) {
	                          if (data === undefined) {
	                            var ctor = CACHED_CONSTRUCTORS.array[0];
	                            return ctor([]);
	                          } else if (typeof data === "number") {
	                            data = [data];
	                          }
	                          if (shape === undefined) {
	                            shape = [data.length];
	                          }
	                          var d = shape.length;
	                          if (stride === undefined) {
	                            stride = new Array(d);
	                            for (var i = d - 1, sz = 1; i >= 0; --i) {
	                              stride[i] = sz;
	                              sz *= shape[i];
	                            }
	                          }
	                          if (offset === undefined) {
	                            offset = 0;
	                            for (var i = 0; i < d; ++i) {
	                              if (stride[i] < 0) {
	                                offset -= (shape[i] - 1) * stride[i];
	                              }
	                            }
	                          }
	                          var inType = arrayDType(data);
	                          var ctor_list = CACHED_CONSTRUCTORS[inType];
	                          while (ctor_list.length <= d + 1) {
	                            ctor_list.push(compileConstructor(inType, ctor_list.length - 1));
	                          }
	                          var ctor = ctor_list[d + 1];
	                          return ctor(data, shape, stride, offset);
	                        }
	                        module3.exports = wrappedNDArrayCtor;
	                      }
	                    ),
	                    /***/
	                    8551: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_716834__) {
	                        var doubleBits = __nested_webpack_require_716834__(8362);
	                        var SMALLEST_DENORM = Math.pow(2, -1074);
	                        var UINT_MAX = -1 >>> 0;
	                        module3.exports = nextafter;
	                        function nextafter(x, y) {
	                          if (isNaN(x) || isNaN(y)) {
	                            return NaN;
	                          }
	                          if (x === y) {
	                            return x;
	                          }
	                          if (x === 0) {
	                            if (y < 0) {
	                              return -SMALLEST_DENORM;
	                            } else {
	                              return SMALLEST_DENORM;
	                            }
	                          }
	                          var hi = doubleBits.hi(x);
	                          var lo = doubleBits.lo(x);
	                          if (y > x === x > 0) {
	                            if (lo === UINT_MAX) {
	                              hi += 1;
	                              lo = 0;
	                            } else {
	                              lo += 1;
	                            }
	                          } else {
	                            if (lo === 0) {
	                              lo = UINT_MAX;
	                              hi -= 1;
	                            } else {
	                              lo -= 1;
	                            }
	                          }
	                          return doubleBits.pack(lo, hi);
	                        }
	                      }
	                    ),
	                    /***/
	                    115: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        var DEFAULT_NORMALS_EPSILON = 1e-6;
	                        var DEFAULT_FACE_EPSILON = 1e-6;
	                        exports2.vertexNormals = function(faces, positions, specifiedEpsilon) {
	                          var N = positions.length;
	                          var normals = new Array(N);
	                          var epsilon = specifiedEpsilon === undefined ? DEFAULT_NORMALS_EPSILON : specifiedEpsilon;
	                          for (var i = 0; i < N; ++i) {
	                            normals[i] = [0, 0, 0];
	                          }
	                          for (var i = 0; i < faces.length; ++i) {
	                            var f = faces[i];
	                            var p = 0;
	                            var c = f[f.length - 1];
	                            var n = f[0];
	                            for (var j = 0; j < f.length; ++j) {
	                              p = c;
	                              c = n;
	                              n = f[(j + 1) % f.length];
	                              var v0 = positions[p];
	                              var v1 = positions[c];
	                              var v2 = positions[n];
	                              var d01 = new Array(3);
	                              var m01 = 0;
	                              var d21 = new Array(3);
	                              var m21 = 0;
	                              for (var k = 0; k < 3; ++k) {
	                                d01[k] = v0[k] - v1[k];
	                                m01 += d01[k] * d01[k];
	                                d21[k] = v2[k] - v1[k];
	                                m21 += d21[k] * d21[k];
	                              }
	                              if (m01 * m21 > epsilon) {
	                                var norm = normals[c];
	                                var w = 1 / Math.sqrt(m01 * m21);
	                                for (var k = 0; k < 3; ++k) {
	                                  var u = (k + 1) % 3;
	                                  var v = (k + 2) % 3;
	                                  norm[k] += w * (d21[u] * d01[v] - d21[v] * d01[u]);
	                                }
	                              }
	                            }
	                          }
	                          for (var i = 0; i < N; ++i) {
	                            var norm = normals[i];
	                            var m = 0;
	                            for (var k = 0; k < 3; ++k) {
	                              m += norm[k] * norm[k];
	                            }
	                            if (m > epsilon) {
	                              var w = 1 / Math.sqrt(m);
	                              for (var k = 0; k < 3; ++k) {
	                                norm[k] *= w;
	                              }
	                            } else {
	                              for (var k = 0; k < 3; ++k) {
	                                norm[k] = 0;
	                              }
	                            }
	                          }
	                          return normals;
	                        };
	                        exports2.faceNormals = function(faces, positions, specifiedEpsilon) {
	                          var N = faces.length;
	                          var normals = new Array(N);
	                          var epsilon = specifiedEpsilon === undefined ? DEFAULT_FACE_EPSILON : specifiedEpsilon;
	                          for (var i = 0; i < N; ++i) {
	                            var f = faces[i];
	                            var pos = new Array(3);
	                            for (var j = 0; j < 3; ++j) {
	                              pos[j] = positions[f[j]];
	                            }
	                            var d01 = new Array(3);
	                            var d21 = new Array(3);
	                            for (var j = 0; j < 3; ++j) {
	                              d01[j] = pos[1][j] - pos[0][j];
	                              d21[j] = pos[2][j] - pos[0][j];
	                            }
	                            var n = new Array(3);
	                            var l = 0;
	                            for (var j = 0; j < 3; ++j) {
	                              var u = (j + 1) % 3;
	                              var v = (j + 2) % 3;
	                              n[j] = d01[u] * d21[v] - d01[v] * d21[u];
	                              l += n[j] * n[j];
	                            }
	                            if (l > epsilon) {
	                              l = 1 / Math.sqrt(l);
	                            } else {
	                              l = 0;
	                            }
	                            for (var j = 0; j < 3; ++j) {
	                              n[j] *= l;
	                            }
	                            normals[i] = n;
	                          }
	                          return normals;
	                        };
	                      }
	                    ),
	                    /***/
	                    567: (
	                      /***/
	                      function(module3) {
	                        module3.exports = quatFromFrame;
	                        function quatFromFrame(out, rx, ry, rz, ux, uy, uz, fx, fy, fz) {
	                          var tr = rx + uy + fz;
	                          if (l > 0) {
	                            var l = Math.sqrt(tr + 1);
	                            out[0] = 0.5 * (uz - fy) / l;
	                            out[1] = 0.5 * (fx - rz) / l;
	                            out[2] = 0.5 * (ry - uy) / l;
	                            out[3] = 0.5 * l;
	                          } else {
	                            var tf = Math.max(rx, uy, fz);
	                            var l = Math.sqrt(2 * tf - tr + 1);
	                            if (rx >= tf) {
	                              out[0] = 0.5 * l;
	                              out[1] = 0.5 * (ux + ry) / l;
	                              out[2] = 0.5 * (fx + rz) / l;
	                              out[3] = 0.5 * (uz - fy) / l;
	                            } else if (uy >= tf) {
	                              out[0] = 0.5 * (ry + ux) / l;
	                              out[1] = 0.5 * l;
	                              out[2] = 0.5 * (fy + uz) / l;
	                              out[3] = 0.5 * (fx - rz) / l;
	                            } else {
	                              out[0] = 0.5 * (rz + fx) / l;
	                              out[1] = 0.5 * (uz + fy) / l;
	                              out[2] = 0.5 * l;
	                              out[3] = 0.5 * (ry - ux) / l;
	                            }
	                          }
	                          return out;
	                        }
	                      }
	                    ),
	                    /***/
	                    7774: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_720109__) {
	                        module3.exports = createOrbitController;
	                        var filterVector = __nested_webpack_require_720109__(8444);
	                        var lookAt = __nested_webpack_require_720109__(3012);
	                        var mat4FromQuat = __nested_webpack_require_720109__(5950);
	                        var invert44 = __nested_webpack_require_720109__(7437);
	                        var quatFromFrame = __nested_webpack_require_720109__(567);
	                        function len3(x, y, z) {
	                          return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2));
	                        }
	                        function len4(w, x, y, z) {
	                          return Math.sqrt(Math.pow(w, 2) + Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2));
	                        }
	                        function normalize4(out, a) {
	                          var ax = a[0];
	                          var ay = a[1];
	                          var az = a[2];
	                          var aw = a[3];
	                          var al = len4(ax, ay, az, aw);
	                          if (al > 1e-6) {
	                            out[0] = ax / al;
	                            out[1] = ay / al;
	                            out[2] = az / al;
	                            out[3] = aw / al;
	                          } else {
	                            out[0] = out[1] = out[2] = 0;
	                            out[3] = 1;
	                          }
	                        }
	                        function OrbitCameraController(initQuat, initCenter, initRadius) {
	                          this.radius = filterVector([initRadius]);
	                          this.center = filterVector(initCenter);
	                          this.rotation = filterVector(initQuat);
	                          this.computedRadius = this.radius.curve(0);
	                          this.computedCenter = this.center.curve(0);
	                          this.computedRotation = this.rotation.curve(0);
	                          this.computedUp = [0.1, 0, 0];
	                          this.computedEye = [0.1, 0, 0];
	                          this.computedMatrix = [0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	                          this.recalcMatrix(0);
	                        }
	                        var proto = OrbitCameraController.prototype;
	                        proto.lastT = function() {
	                          return Math.max(this.radius.lastT(), this.center.lastT(), this.rotation.lastT());
	                        };
	                        proto.recalcMatrix = function(t) {
	                          this.radius.curve(t);
	                          this.center.curve(t);
	                          this.rotation.curve(t);
	                          var quat = this.computedRotation;
	                          normalize4(quat, quat);
	                          var mat = this.computedMatrix;
	                          mat4FromQuat(mat, quat);
	                          var center = this.computedCenter;
	                          var eye = this.computedEye;
	                          var up = this.computedUp;
	                          var radius = Math.exp(this.computedRadius[0]);
	                          eye[0] = center[0] + radius * mat[2];
	                          eye[1] = center[1] + radius * mat[6];
	                          eye[2] = center[2] + radius * mat[10];
	                          up[0] = mat[1];
	                          up[1] = mat[5];
	                          up[2] = mat[9];
	                          for (var i = 0; i < 3; ++i) {
	                            var rr = 0;
	                            for (var j = 0; j < 3; ++j) {
	                              rr += mat[i + 4 * j] * eye[j];
	                            }
	                            mat[12 + i] = -rr;
	                          }
	                        };
	                        proto.getMatrix = function(t, result) {
	                          this.recalcMatrix(t);
	                          var m = this.computedMatrix;
	                          if (result) {
	                            for (var i = 0; i < 16; ++i) {
	                              result[i] = m[i];
	                            }
	                            return result;
	                          }
	                          return m;
	                        };
	                        proto.idle = function(t) {
	                          this.center.idle(t);
	                          this.radius.idle(t);
	                          this.rotation.idle(t);
	                        };
	                        proto.flush = function(t) {
	                          this.center.flush(t);
	                          this.radius.flush(t);
	                          this.rotation.flush(t);
	                        };
	                        proto.pan = function(t, dx, dy, dz) {
	                          dx = dx || 0;
	                          dy = dy || 0;
	                          dz = dz || 0;
	                          this.recalcMatrix(t);
	                          var mat = this.computedMatrix;
	                          var ux = mat[1];
	                          var uy = mat[5];
	                          var uz = mat[9];
	                          var ul = len3(ux, uy, uz);
	                          ux /= ul;
	                          uy /= ul;
	                          uz /= ul;
	                          var rx = mat[0];
	                          var ry = mat[4];
	                          var rz = mat[8];
	                          var ru = rx * ux + ry * uy + rz * uz;
	                          rx -= ux * ru;
	                          ry -= uy * ru;
	                          rz -= uz * ru;
	                          var rl = len3(rx, ry, rz);
	                          rx /= rl;
	                          ry /= rl;
	                          rz /= rl;
	                          mat[2];
	                          mat[6];
	                          mat[10];
	                          var vx = rx * dx + ux * dy;
	                          var vy = ry * dx + uy * dy;
	                          var vz = rz * dx + uz * dy;
	                          this.center.move(t, vx, vy, vz);
	                          var radius = Math.exp(this.computedRadius[0]);
	                          radius = Math.max(1e-4, radius + dz);
	                          this.radius.set(t, Math.log(radius));
	                        };
	                        proto.rotate = function(t, dx, dy, dz) {
	                          this.recalcMatrix(t);
	                          dx = dx || 0;
	                          dy = dy || 0;
	                          var mat = this.computedMatrix;
	                          var rx = mat[0];
	                          var ry = mat[4];
	                          var rz = mat[8];
	                          var ux = mat[1];
	                          var uy = mat[5];
	                          var uz = mat[9];
	                          var fx = mat[2];
	                          var fy = mat[6];
	                          var fz = mat[10];
	                          var qx = dx * rx + dy * ux;
	                          var qy = dx * ry + dy * uy;
	                          var qz = dx * rz + dy * uz;
	                          var bx = -(fy * qz - fz * qy);
	                          var by = -(fz * qx - fx * qz);
	                          var bz = -(fx * qy - fy * qx);
	                          var bw = Math.sqrt(Math.max(0, 1 - Math.pow(bx, 2) - Math.pow(by, 2) - Math.pow(bz, 2)));
	                          var bl = len4(bx, by, bz, bw);
	                          if (bl > 1e-6) {
	                            bx /= bl;
	                            by /= bl;
	                            bz /= bl;
	                            bw /= bl;
	                          } else {
	                            bx = by = bz = 0;
	                            bw = 1;
	                          }
	                          var rotation = this.computedRotation;
	                          var ax = rotation[0];
	                          var ay = rotation[1];
	                          var az = rotation[2];
	                          var aw = rotation[3];
	                          var cx = ax * bw + aw * bx + ay * bz - az * by;
	                          var cy = ay * bw + aw * by + az * bx - ax * bz;
	                          var cz = az * bw + aw * bz + ax * by - ay * bx;
	                          var cw = aw * bw - ax * bx - ay * by - az * bz;
	                          if (dz) {
	                            bx = fx;
	                            by = fy;
	                            bz = fz;
	                            var s = Math.sin(dz) / len3(bx, by, bz);
	                            bx *= s;
	                            by *= s;
	                            bz *= s;
	                            bw = Math.cos(dx);
	                            cx = cx * bw + cw * bx + cy * bz - cz * by;
	                            cy = cy * bw + cw * by + cz * bx - cx * bz;
	                            cz = cz * bw + cw * bz + cx * by - cy * bx;
	                            cw = cw * bw - cx * bx - cy * by - cz * bz;
	                          }
	                          var cl = len4(cx, cy, cz, cw);
	                          if (cl > 1e-6) {
	                            cx /= cl;
	                            cy /= cl;
	                            cz /= cl;
	                            cw /= cl;
	                          } else {
	                            cx = cy = cz = 0;
	                            cw = 1;
	                          }
	                          this.rotation.set(t, cx, cy, cz, cw);
	                        };
	                        proto.lookAt = function(t, eye, center, up) {
	                          this.recalcMatrix(t);
	                          center = center || this.computedCenter;
	                          eye = eye || this.computedEye;
	                          up = up || this.computedUp;
	                          var mat = this.computedMatrix;
	                          lookAt(mat, eye, center, up);
	                          var rotation = this.computedRotation;
	                          quatFromFrame(rotation, mat[0], mat[1], mat[2], mat[4], mat[5], mat[6], mat[8], mat[9], mat[10]);
	                          normalize4(rotation, rotation);
	                          this.rotation.set(t, rotation[0], rotation[1], rotation[2], rotation[3]);
	                          var fl = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            fl += Math.pow(center[i] - eye[i], 2);
	                          }
	                          this.radius.set(t, 0.5 * Math.log(Math.max(fl, 1e-6)));
	                          this.center.set(t, center[0], center[1], center[2]);
	                        };
	                        proto.translate = function(t, dx, dy, dz) {
	                          this.center.move(t, dx || 0, dy || 0, dz || 0);
	                        };
	                        proto.setMatrix = function(t, matrix) {
	                          var rotation = this.computedRotation;
	                          quatFromFrame(rotation, matrix[0], matrix[1], matrix[2], matrix[4], matrix[5], matrix[6], matrix[8], matrix[9], matrix[10]);
	                          normalize4(rotation, rotation);
	                          this.rotation.set(t, rotation[0], rotation[1], rotation[2], rotation[3]);
	                          var mat = this.computedMatrix;
	                          invert44(mat, matrix);
	                          var w = mat[15];
	                          if (Math.abs(w) > 1e-6) {
	                            var cx = mat[12] / w;
	                            var cy = mat[13] / w;
	                            var cz = mat[14] / w;
	                            this.recalcMatrix(t);
	                            var r = Math.exp(this.computedRadius[0]);
	                            this.center.set(t, cx - mat[2] * r, cy - mat[6] * r, cz - mat[10] * r);
	                            this.radius.idle(t);
	                          } else {
	                            this.center.idle(t);
	                            this.radius.idle(t);
	                          }
	                        };
	                        proto.setDistance = function(t, d) {
	                          if (d > 0) {
	                            this.radius.set(t, Math.log(d));
	                          }
	                        };
	                        proto.setDistanceLimits = function(lo, hi) {
	                          if (lo > 0) {
	                            lo = Math.log(lo);
	                          } else {
	                            lo = -Infinity;
	                          }
	                          if (hi > 0) {
	                            hi = Math.log(hi);
	                          } else {
	                            hi = Infinity;
	                          }
	                          hi = Math.max(hi, lo);
	                          this.radius.bounds[0][0] = lo;
	                          this.radius.bounds[1][0] = hi;
	                        };
	                        proto.getDistanceLimits = function(out) {
	                          var bounds = this.radius.bounds;
	                          if (out) {
	                            out[0] = Math.exp(bounds[0][0]);
	                            out[1] = Math.exp(bounds[1][0]);
	                            return out;
	                          }
	                          return [Math.exp(bounds[0][0]), Math.exp(bounds[1][0])];
	                        };
	                        proto.toJSON = function() {
	                          this.recalcMatrix(this.lastT());
	                          return { center: this.computedCenter.slice(), rotation: this.computedRotation.slice(), distance: Math.log(this.computedRadius[0]), zoomMin: this.radius.bounds[0][0], zoomMax: this.radius.bounds[1][0] };
	                        };
	                        proto.fromJSON = function(options) {
	                          var t = this.lastT();
	                          var c = options.center;
	                          if (c) {
	                            this.center.set(t, c[0], c[1], c[2]);
	                          }
	                          var r = options.rotation;
	                          if (r) {
	                            this.rotation.set(t, r[0], r[1], r[2], r[3]);
	                          }
	                          var d = options.distance;
	                          if (d && d > 0) {
	                            this.radius.set(t, Math.log(d));
	                          }
	                          this.setDistanceLimits(options.zoomMin, options.zoomMax);
	                        };
	                        function createOrbitController(options) {
	                          options = options || {};
	                          var center = options.center || [0, 0, 0];
	                          var rotation = options.rotation || [0, 0, 0, 1];
	                          var radius = options.radius || 1;
	                          center = [].slice.call(center, 0, 3);
	                          rotation = [].slice.call(rotation, 0, 4);
	                          normalize4(rotation, rotation);
	                          var result = new OrbitCameraController(rotation, center, Math.log(radius));
	                          result.setDistanceLimits(options.zoomMin, options.zoomMax);
	                          if ("eye" in options || "up" in options) {
	                            result.lookAt(0, options.eye, options.center, options.up);
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    4930: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_726977__) {
	                        /*!
	                        * pad-left <https://github.com/jonschlinkert/pad-left>
	                        *
	                        * Copyright (c) 2014-2015, Jon Schlinkert.
	                        * Licensed under the MIT license.
	                        */
	                        var repeat = __nested_webpack_require_726977__(6184);
	                        module3.exports = function padLeft(str, num, ch) {
	                          ch = typeof ch !== "undefined" ? ch + "" : " ";
	                          return repeat(ch, num) + str;
	                        };
	                      }
	                    ),
	                    /***/
	                    4405: (
	                      /***/
	                      function(module3) {
	                        module3.exports = function parseUnit(str, out) {
	                          if (!out) out = [0, ""];
	                          str = String(str);
	                          var num = parseFloat(str, 10);
	                          out[0] = num;
	                          out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || "";
	                          return out;
	                        };
	                      }
	                    ),
	                    /***/
	                    4166: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_727578__) {
	                        module3.exports = planarDual;
	                        var compareAngle = __nested_webpack_require_727578__(9398);
	                        function planarDual(cells, positions) {
	                          var numVertices = positions.length | 0;
	                          var numEdges = cells.length;
	                          var adj = [new Array(numVertices), new Array(numVertices)];
	                          for (var i = 0; i < numVertices; ++i) {
	                            adj[0][i] = [];
	                            adj[1][i] = [];
	                          }
	                          for (var i = 0; i < numEdges; ++i) {
	                            var c = cells[i];
	                            adj[0][c[0]].push(c);
	                            adj[1][c[1]].push(c);
	                          }
	                          var cycles = [];
	                          for (var i = 0; i < numVertices; ++i) {
	                            if (adj[0][i].length + adj[1][i].length === 0) {
	                              cycles.push([i]);
	                            }
	                          }
	                          function cut(c2, i2) {
	                            var a = adj[i2][c2[i2]];
	                            a.splice(a.indexOf(c2), 1);
	                          }
	                          function next(a, b, noCut) {
	                            var nextCell, nextVertex, nextDir;
	                            for (var i2 = 0; i2 < 2; ++i2) {
	                              if (adj[i2][b].length > 0) {
	                                nextCell = adj[i2][b][0];
	                                nextDir = i2;
	                                break;
	                              }
	                            }
	                            nextVertex = nextCell[nextDir ^ 1];
	                            for (var dir = 0; dir < 2; ++dir) {
	                              var nbhd = adj[dir][b];
	                              for (var k = 0; k < nbhd.length; ++k) {
	                                var e = nbhd[k];
	                                var p = e[dir ^ 1];
	                                var cmp = compareAngle(positions[a], positions[b], positions[nextVertex], positions[p]);
	                                if (cmp > 0) {
	                                  nextCell = e;
	                                  nextVertex = p;
	                                  nextDir = dir;
	                                }
	                              }
	                            }
	                            if (noCut) {
	                              return nextVertex;
	                            }
	                            if (nextCell) {
	                              cut(nextCell, nextDir);
	                            }
	                            return nextVertex;
	                          }
	                          function extractCycle(v, dir) {
	                            var e0 = adj[dir][v][0];
	                            var cycle = [v];
	                            cut(e0, dir);
	                            var u = e0[dir ^ 1];
	                            while (true) {
	                              while (u !== v) {
	                                cycle.push(u);
	                                u = next(cycle[cycle.length - 2], u, false);
	                              }
	                              if (adj[0][v].length + adj[1][v].length === 0) {
	                                break;
	                              }
	                              var a = cycle[cycle.length - 1];
	                              var b = v;
	                              var c2 = cycle[1];
	                              var d = next(a, b, true);
	                              if (compareAngle(positions[a], positions[b], positions[c2], positions[d]) < 0) {
	                                break;
	                              }
	                              cycle.push(v);
	                              u = next(a, b);
	                            }
	                            return cycle;
	                          }
	                          function shouldGlue(pcycle2, ncycle2) {
	                            return ncycle2[1] === ncycle2[ncycle2.length - 1];
	                          }
	                          for (var i = 0; i < numVertices; ++i) {
	                            for (var j = 0; j < 2; ++j) {
	                              var pcycle = [];
	                              while (adj[j][i].length > 0) {
	                                adj[0][i].length;
	                                var ncycle = extractCycle(i, j);
	                                if (shouldGlue(pcycle, ncycle)) {
	                                  pcycle.push.apply(pcycle, ncycle);
	                                } else {
	                                  if (pcycle.length > 0) {
	                                    cycles.push(pcycle);
	                                  }
	                                  pcycle = ncycle;
	                                }
	                              }
	                              if (pcycle.length > 0) {
	                                cycles.push(pcycle);
	                              }
	                            }
	                          }
	                          return cycles;
	                        }
	                      }
	                    ),
	                    /***/
	                    3959: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_729697__) {
	                        module3.exports = trimLeaves;
	                        var e2a = __nested_webpack_require_729697__(8348);
	                        function trimLeaves(edges, positions) {
	                          var adj = e2a(edges, positions.length);
	                          var live = new Array(positions.length);
	                          var nbhd = new Array(positions.length);
	                          var dead = [];
	                          for (var i = 0; i < positions.length; ++i) {
	                            var count = adj[i].length;
	                            nbhd[i] = count;
	                            live[i] = true;
	                            if (count <= 1) {
	                              dead.push(i);
	                            }
	                          }
	                          while (dead.length > 0) {
	                            var v = dead.pop();
	                            live[v] = false;
	                            var n = adj[v];
	                            for (var i = 0; i < n.length; ++i) {
	                              var u = n[i];
	                              if (--nbhd[u] === 0) {
	                                dead.push(u);
	                              }
	                            }
	                          }
	                          var newIndex = new Array(positions.length);
	                          var npositions = [];
	                          for (var i = 0; i < positions.length; ++i) {
	                            if (live[i]) {
	                              var v = npositions.length;
	                              newIndex[i] = v;
	                              npositions.push(positions[i]);
	                            } else {
	                              newIndex[i] = -1;
	                            }
	                          }
	                          var nedges = [];
	                          for (var i = 0; i < edges.length; ++i) {
	                            var e = edges[i];
	                            if (live[e[0]] && live[e[1]]) {
	                              nedges.push([newIndex[e[0]], newIndex[e[1]]]);
	                            }
	                          }
	                          return [nedges, npositions];
	                        }
	                      }
	                    ),
	                    /***/
	                    8040: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_730626__) {
	                        module3.exports = planarGraphToPolyline;
	                        var e2a = __nested_webpack_require_730626__(8348);
	                        var planarDual = __nested_webpack_require_730626__(4166);
	                        var preprocessPolygon = __nested_webpack_require_730626__(211);
	                        var twoProduct = __nested_webpack_require_730626__(9660);
	                        var robustSum = __nested_webpack_require_730626__(9662);
	                        var uniq = __nested_webpack_require_730626__(1215);
	                        var trimLeaves = __nested_webpack_require_730626__(3959);
	                        function makeArray(length, fill) {
	                          var result = new Array(length);
	                          for (var i = 0; i < length; ++i) {
	                            result[i] = fill;
	                          }
	                          return result;
	                        }
	                        function makeArrayOfArrays(length) {
	                          var result = new Array(length);
	                          for (var i = 0; i < length; ++i) {
	                            result[i] = [];
	                          }
	                          return result;
	                        }
	                        function planarGraphToPolyline(edges, positions) {
	                          var result = trimLeaves(edges, positions);
	                          edges = result[0];
	                          positions = result[1];
	                          var numVertices = positions.length;
	                          edges.length;
	                          var adj = e2a(edges, positions.length);
	                          for (var i = 0; i < numVertices; ++i) {
	                            if (adj[i].length % 2 === 1) {
	                              throw new Error("planar-graph-to-polyline: graph must be manifold");
	                            }
	                          }
	                          var faces = planarDual(edges, positions);
	                          function ccw(c2) {
	                            var n2 = c2.length;
	                            var area = [0];
	                            for (var j2 = 0; j2 < n2; ++j2) {
	                              var a2 = positions[c2[j2]];
	                              var b2 = positions[c2[(j2 + 1) % n2]];
	                              var t00 = twoProduct(-a2[0], a2[1]);
	                              var t01 = twoProduct(-a2[0], b2[1]);
	                              var t10 = twoProduct(b2[0], a2[1]);
	                              var t11 = twoProduct(b2[0], b2[1]);
	                              area = robustSum(area, robustSum(robustSum(t00, t01), robustSum(t10, t11)));
	                            }
	                            return area[area.length - 1] > 0;
	                          }
	                          faces = faces.filter(ccw);
	                          var numFaces = faces.length;
	                          var parent = new Array(numFaces);
	                          var containment = new Array(numFaces);
	                          for (var i = 0; i < numFaces; ++i) {
	                            parent[i] = i;
	                            var row = new Array(numFaces);
	                            var loopVertices = faces[i].map(function(v) {
	                              return positions[v];
	                            });
	                            var pmc = preprocessPolygon([loopVertices]);
	                            var count = 0;
	                            outer: for (var j = 0; j < numFaces; ++j) {
	                              row[j] = 0;
	                              if (i === j) {
	                                continue;
	                              }
	                              var c = faces[j];
	                              var n = c.length;
	                              for (var k = 0; k < n; ++k) {
	                                var d = pmc(positions[c[k]]);
	                                if (d !== 0) {
	                                  if (d < 0) {
	                                    row[j] = 1;
	                                    count += 1;
	                                  }
	                                  continue outer;
	                                }
	                              }
	                              row[j] = 1;
	                              count += 1;
	                            }
	                            containment[i] = [count, i, row];
	                          }
	                          containment.sort(function(a2, b2) {
	                            return b2[0] - a2[0];
	                          });
	                          for (var i = 0; i < numFaces; ++i) {
	                            var row = containment[i];
	                            var idx = row[1];
	                            var children = row[2];
	                            for (var j = 0; j < numFaces; ++j) {
	                              if (children[j]) {
	                                parent[j] = idx;
	                              }
	                            }
	                          }
	                          var fadj = makeArrayOfArrays(numFaces);
	                          for (var i = 0; i < numFaces; ++i) {
	                            fadj[i].push(parent[i]);
	                            fadj[parent[i]].push(i);
	                          }
	                          var edgeAdjacency = {};
	                          var internalVertices = makeArray(numVertices, false);
	                          for (var i = 0; i < numFaces; ++i) {
	                            var c = faces[i];
	                            var n = c.length;
	                            for (var j = 0; j < n; ++j) {
	                              var a = c[j];
	                              var b = c[(j + 1) % n];
	                              var key = Math.min(a, b) + ":" + Math.max(a, b);
	                              if (key in edgeAdjacency) {
	                                var neighbor = edgeAdjacency[key];
	                                fadj[neighbor].push(i);
	                                fadj[i].push(neighbor);
	                                internalVertices[a] = internalVertices[b] = true;
	                              } else {
	                                edgeAdjacency[key] = i;
	                              }
	                            }
	                          }
	                          function sharedBoundary(c2) {
	                            var n2 = c2.length;
	                            for (var i2 = 0; i2 < n2; ++i2) {
	                              if (!internalVertices[c2[i2]]) {
	                                return false;
	                              }
	                            }
	                            return true;
	                          }
	                          var toVisit = [];
	                          var parity = makeArray(numFaces, -1);
	                          for (var i = 0; i < numFaces; ++i) {
	                            if (parent[i] === i && !sharedBoundary(faces[i])) {
	                              toVisit.push(i);
	                              parity[i] = 0;
	                            } else {
	                              parity[i] = -1;
	                            }
	                          }
	                          var result = [];
	                          while (toVisit.length > 0) {
	                            var top = toVisit.pop();
	                            var nbhd = fadj[top];
	                            uniq(nbhd, function(a2, b2) {
	                              return a2 - b2;
	                            });
	                            var nnbhr = nbhd.length;
	                            var p = parity[top];
	                            var polyline;
	                            if (p === 0) {
	                              var c = faces[top];
	                              polyline = [c];
	                            }
	                            for (var i = 0; i < nnbhr; ++i) {
	                              var f = nbhd[i];
	                              if (parity[f] >= 0) {
	                                continue;
	                              }
	                              parity[f] = p ^ 1;
	                              toVisit.push(f);
	                              if (p === 0) {
	                                var c = faces[f];
	                                if (!sharedBoundary(c)) {
	                                  c.reverse();
	                                  polyline.push(c);
	                                }
	                              }
	                            }
	                            if (p === 0) {
	                              result.push(polyline);
	                            }
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    211: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_734327__) {
	                        module3.exports = preprocessPolygon;
	                        var orient = __nested_webpack_require_734327__(417)[3];
	                        var makeSlabs = __nested_webpack_require_734327__(4385);
	                        var makeIntervalTree = __nested_webpack_require_734327__(9014);
	                        var bsearch = __nested_webpack_require_734327__(5070);
	                        function visitInterval() {
	                          return true;
	                        }
	                        function intervalSearch(table) {
	                          return function(x, y) {
	                            var tree = table[x];
	                            if (tree) {
	                              return !!tree.queryPoint(y, visitInterval);
	                            }
	                            return false;
	                          };
	                        }
	                        function buildVerticalIndex(segments) {
	                          var table = {};
	                          for (var i = 0; i < segments.length; ++i) {
	                            var s = segments[i];
	                            var x = s[0][0];
	                            var y0 = s[0][1];
	                            var y1 = s[1][1];
	                            var p = [Math.min(y0, y1), Math.max(y0, y1)];
	                            if (x in table) {
	                              table[x].push(p);
	                            } else {
	                              table[x] = [p];
	                            }
	                          }
	                          var intervalTable = {};
	                          var keys = Object.keys(table);
	                          for (var i = 0; i < keys.length; ++i) {
	                            var segs = table[keys[i]];
	                            intervalTable[keys[i]] = makeIntervalTree(segs);
	                          }
	                          return intervalSearch(intervalTable);
	                        }
	                        function buildSlabSearch(slabs, coordinates) {
	                          return function(p) {
	                            var bucket = bsearch.le(coordinates, p[0]);
	                            if (bucket < 0) {
	                              return 1;
	                            }
	                            var root = slabs[bucket];
	                            if (!root) {
	                              if (bucket > 0 && coordinates[bucket] === p[0]) {
	                                root = slabs[bucket - 1];
	                              } else {
	                                return 1;
	                              }
	                            }
	                            var lastOrientation = 1;
	                            while (root) {
	                              var s = root.key;
	                              var o = orient(p, s[0], s[1]);
	                              if (s[0][0] < s[1][0]) {
	                                if (o < 0) {
	                                  root = root.left;
	                                } else if (o > 0) {
	                                  lastOrientation = -1;
	                                  root = root.right;
	                                } else {
	                                  return 0;
	                                }
	                              } else {
	                                if (o > 0) {
	                                  root = root.left;
	                                } else if (o < 0) {
	                                  lastOrientation = 1;
	                                  root = root.right;
	                                } else {
	                                  return 0;
	                                }
	                              }
	                            }
	                            return lastOrientation;
	                          };
	                        }
	                        function classifyEmpty(p) {
	                          return 1;
	                        }
	                        function createClassifyVertical(testVertical) {
	                          return function classify(p) {
	                            if (testVertical(p[0], p[1])) {
	                              return 0;
	                            }
	                            return 1;
	                          };
	                        }
	                        function createClassifyPointDegen(testVertical, testNormal) {
	                          return function classify(p) {
	                            if (testVertical(p[0], p[1])) {
	                              return 0;
	                            }
	                            return testNormal(p);
	                          };
	                        }
	                        function preprocessPolygon(loops) {
	                          var numLoops = loops.length;
	                          var segments = [];
	                          var vsegments = [];
	                          for (var i = 0; i < numLoops; ++i) {
	                            var loop = loops[i];
	                            var numVertices = loop.length;
	                            for (var s = numVertices - 1, t = 0; t < numVertices; s = t++) {
	                              var a = loop[s];
	                              var b = loop[t];
	                              if (a[0] === b[0]) {
	                                vsegments.push([a, b]);
	                              } else {
	                                segments.push([a, b]);
	                              }
	                            }
	                          }
	                          if (segments.length === 0) {
	                            if (vsegments.length === 0) {
	                              return classifyEmpty;
	                            } else {
	                              return createClassifyVertical(buildVerticalIndex(vsegments));
	                            }
	                          }
	                          var slabs = makeSlabs(segments);
	                          var testSlab = buildSlabSearch(slabs.slabs, slabs.coordinates);
	                          if (vsegments.length === 0) {
	                            return testSlab;
	                          } else {
	                            return createClassifyPointDegen(buildVerticalIndex(vsegments), testSlab);
	                          }
	                        }
	                      }
	                    ),
	                    /***/
	                    7309: (
	                      /***/
	                      function(module3) {
	                        var diff = new Float64Array(4);
	                        var edge0 = new Float64Array(4);
	                        var edge1 = new Float64Array(4);
	                        function closestPoint2d(V0, V1, V2, point, result) {
	                          if (diff.length < point.length) {
	                            diff = new Float64Array(point.length);
	                            edge0 = new Float64Array(point.length);
	                            edge1 = new Float64Array(point.length);
	                          }
	                          for (var i = 0; i < point.length; ++i) {
	                            diff[i] = V0[i] - point[i];
	                            edge0[i] = V1[i] - V0[i];
	                            edge1[i] = V2[i] - V0[i];
	                          }
	                          var a00 = 0, a01 = 0, a11 = 0, b0 = 0, b1 = 0, c = 0;
	                          for (var i = 0; i < point.length; ++i) {
	                            var e0 = edge0[i], e1 = edge1[i], d = diff[i];
	                            a00 += e0 * e0;
	                            a01 += e0 * e1;
	                            a11 += e1 * e1;
	                            b0 += d * e0;
	                            b1 += d * e1;
	                            c += d * d;
	                          }
	                          var det = Math.abs(a00 * a11 - a01 * a01);
	                          var s = a01 * b1 - a11 * b0;
	                          var t = a01 * b0 - a00 * b1;
	                          var sqrDistance;
	                          if (s + t <= det) {
	                            if (s < 0) {
	                              if (t < 0) {
	                                if (b0 < 0) {
	                                  t = 0;
	                                  if (-b0 >= a00) {
	                                    s = 1;
	                                    sqrDistance = a00 + 2 * b0 + c;
	                                  } else {
	                                    s = -b0 / a00;
	                                    sqrDistance = b0 * s + c;
	                                  }
	                                } else {
	                                  s = 0;
	                                  if (b1 >= 0) {
	                                    t = 0;
	                                    sqrDistance = c;
	                                  } else if (-b1 >= a11) {
	                                    t = 1;
	                                    sqrDistance = a11 + 2 * b1 + c;
	                                  } else {
	                                    t = -b1 / a11;
	                                    sqrDistance = b1 * t + c;
	                                  }
	                                }
	                              } else {
	                                s = 0;
	                                if (b1 >= 0) {
	                                  t = 0;
	                                  sqrDistance = c;
	                                } else if (-b1 >= a11) {
	                                  t = 1;
	                                  sqrDistance = a11 + 2 * b1 + c;
	                                } else {
	                                  t = -b1 / a11;
	                                  sqrDistance = b1 * t + c;
	                                }
	                              }
	                            } else if (t < 0) {
	                              t = 0;
	                              if (b0 >= 0) {
	                                s = 0;
	                                sqrDistance = c;
	                              } else if (-b0 >= a00) {
	                                s = 1;
	                                sqrDistance = a00 + 2 * b0 + c;
	                              } else {
	                                s = -b0 / a00;
	                                sqrDistance = b0 * s + c;
	                              }
	                            } else {
	                              var invDet = 1 / det;
	                              s *= invDet;
	                              t *= invDet;
	                              sqrDistance = s * (a00 * s + a01 * t + 2 * b0) + t * (a01 * s + a11 * t + 2 * b1) + c;
	                            }
	                          } else {
	                            var tmp0, tmp1, numer, denom;
	                            if (s < 0) {
	                              tmp0 = a01 + b0;
	                              tmp1 = a11 + b1;
	                              if (tmp1 > tmp0) {
	                                numer = tmp1 - tmp0;
	                                denom = a00 - 2 * a01 + a11;
	                                if (numer >= denom) {
	                                  s = 1;
	                                  t = 0;
	                                  sqrDistance = a00 + 2 * b0 + c;
	                                } else {
	                                  s = numer / denom;
	                                  t = 1 - s;
	                                  sqrDistance = s * (a00 * s + a01 * t + 2 * b0) + t * (a01 * s + a11 * t + 2 * b1) + c;
	                                }
	                              } else {
	                                s = 0;
	                                if (tmp1 <= 0) {
	                                  t = 1;
	                                  sqrDistance = a11 + 2 * b1 + c;
	                                } else if (b1 >= 0) {
	                                  t = 0;
	                                  sqrDistance = c;
	                                } else {
	                                  t = -b1 / a11;
	                                  sqrDistance = b1 * t + c;
	                                }
	                              }
	                            } else if (t < 0) {
	                              tmp0 = a01 + b1;
	                              tmp1 = a00 + b0;
	                              if (tmp1 > tmp0) {
	                                numer = tmp1 - tmp0;
	                                denom = a00 - 2 * a01 + a11;
	                                if (numer >= denom) {
	                                  t = 1;
	                                  s = 0;
	                                  sqrDistance = a11 + 2 * b1 + c;
	                                } else {
	                                  t = numer / denom;
	                                  s = 1 - t;
	                                  sqrDistance = s * (a00 * s + a01 * t + 2 * b0) + t * (a01 * s + a11 * t + 2 * b1) + c;
	                                }
	                              } else {
	                                t = 0;
	                                if (tmp1 <= 0) {
	                                  s = 1;
	                                  sqrDistance = a00 + 2 * b0 + c;
	                                } else if (b0 >= 0) {
	                                  s = 0;
	                                  sqrDistance = c;
	                                } else {
	                                  s = -b0 / a00;
	                                  sqrDistance = b0 * s + c;
	                                }
	                              }
	                            } else {
	                              numer = a11 + b1 - a01 - b0;
	                              if (numer <= 0) {
	                                s = 0;
	                                t = 1;
	                                sqrDistance = a11 + 2 * b1 + c;
	                              } else {
	                                denom = a00 - 2 * a01 + a11;
	                                if (numer >= denom) {
	                                  s = 1;
	                                  t = 0;
	                                  sqrDistance = a00 + 2 * b0 + c;
	                                } else {
	                                  s = numer / denom;
	                                  t = 1 - s;
	                                  sqrDistance = s * (a00 * s + a01 * t + 2 * b0) + t * (a01 * s + a11 * t + 2 * b1) + c;
	                                }
	                              }
	                            }
	                          }
	                          var u = 1 - s - t;
	                          for (var i = 0; i < point.length; ++i) {
	                            result[i] = u * V0[i] + s * V1[i] + t * V2[i];
	                          }
	                          if (sqrDistance < 0) {
	                            return 0;
	                          }
	                          return sqrDistance;
	                        }
	                        module3.exports = closestPoint2d;
	                      }
	                    ),
	                    /***/
	                    1116: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_739699__) {
	                        module3.exports = __nested_webpack_require_739699__(6093);
	                      }
	                    ),
	                    /***/
	                    7584: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_739824__) {
	                        var bnadd = __nested_webpack_require_739824__(1539);
	                        module3.exports = add;
	                        function add(a, b) {
	                          var n = a.length;
	                          var r = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            r[i] = bnadd(a[i], b[i]);
	                          }
	                          return r;
	                        }
	                      }
	                    ),
	                    /***/
	                    2826: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_740082__) {
	                        module3.exports = float2rat;
	                        var rat = __nested_webpack_require_740082__(5125);
	                        function float2rat(v) {
	                          var result = new Array(v.length);
	                          for (var i = 0; i < v.length; ++i) {
	                            result[i] = rat(v[i]);
	                          }
	                          return result;
	                        }
	                      }
	                    ),
	                    /***/
	                    4469: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_740355__) {
	                        var rat = __nested_webpack_require_740355__(5125);
	                        var mul = __nested_webpack_require_740355__(3962);
	                        module3.exports = muls;
	                        function muls(a, x) {
	                          var s = rat(x);
	                          var n = a.length;
	                          var r = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            r[i] = mul(a[i], s);
	                          }
	                          return r;
	                        }
	                      }
	                    ),
	                    /***/
	                    6695: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_740655__) {
	                        var bnsub = __nested_webpack_require_740655__(4354);
	                        module3.exports = sub;
	                        function sub(a, b) {
	                          var n = a.length;
	                          var r = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            r[i] = bnsub(a[i], b[i]);
	                          }
	                          return r;
	                        }
	                      }
	                    ),
	                    /***/
	                    7037: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_740913__) {
	                        var compareCell = __nested_webpack_require_740913__(9209);
	                        var compareOrientedCell = __nested_webpack_require_740913__(1284);
	                        var orientation = __nested_webpack_require_740913__(9887);
	                        module3.exports = reduceCellComplex;
	                        function reduceCellComplex(cells) {
	                          cells.sort(compareOrientedCell);
	                          var n = cells.length;
	                          var ptr = 0;
	                          for (var i = 0; i < n; ++i) {
	                            var c = cells[i];
	                            var o = orientation(c);
	                            if (o === 0) {
	                              continue;
	                            }
	                            if (ptr > 0) {
	                              var f = cells[ptr - 1];
	                              if (compareCell(c, f) === 0 && orientation(f) !== o) {
	                                ptr -= 1;
	                                continue;
	                              }
	                            }
	                            cells[ptr++] = c;
	                          }
	                          cells.length = ptr;
	                          return cells;
	                        }
	                      }
	                    ),
	                    /***/
	                    6184: (
	                      /***/
	                      function(module3) {
	                        /*!
	                        * repeat-string <https://github.com/jonschlinkert/repeat-string>
	                        *
	                        * Copyright (c) 2014-2015, Jon Schlinkert.
	                        * Licensed under the MIT License.
	                        */
	                        var res = "";
	                        var cache;
	                        module3.exports = repeat;
	                        function repeat(str, num) {
	                          if (typeof str !== "string") {
	                            throw new TypeError("expected a string");
	                          }
	                          if (num === 1) return str;
	                          if (num === 2) return str + str;
	                          var max = str.length * num;
	                          if (cache !== str || typeof cache === "undefined") {
	                            cache = str;
	                            res = "";
	                          } else if (res.length >= max) {
	                            return res.substr(0, max);
	                          }
	                          while (max > res.length && num > 1) {
	                            if (num & 1) {
	                              res += str;
	                            }
	                            num >>= 1;
	                            str += str;
	                          }
	                          res += str;
	                          res = res.substr(0, max);
	                          return res;
	                        }
	                      }
	                    ),
	                    /***/
	                    8161: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_742566__) {
	                        module3.exports = __nested_webpack_require_742566__.g.performance && __nested_webpack_require_742566__.g.performance.now ? function now() {
	                          return performance.now();
	                        } : Date.now || function now() {
	                          return +/* @__PURE__ */ new Date();
	                        };
	                      }
	                    ),
	                    /***/
	                    402: (
	                      /***/
	                      function(module3) {
	                        module3.exports = compressExpansion;
	                        function compressExpansion(e) {
	                          var m = e.length;
	                          var Q = e[e.length - 1];
	                          var bottom = m;
	                          for (var i = m - 2; i >= 0; --i) {
	                            var a = Q;
	                            var b = e[i];
	                            Q = a + b;
	                            var bv = Q - a;
	                            var q = b - bv;
	                            if (q) {
	                              e[--bottom] = Q;
	                              Q = q;
	                            }
	                          }
	                          var top = 0;
	                          for (var i = bottom; i < m; ++i) {
	                            var a = e[i];
	                            var b = Q;
	                            Q = a + b;
	                            var bv = Q - a;
	                            var q = b - bv;
	                            if (q) {
	                              e[top++] = q;
	                            }
	                          }
	                          e[top++] = Q;
	                          e.length = top;
	                          return e;
	                        }
	                      }
	                    ),
	                    /***/
	                    8167: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_743220__) {
	                        var twoProduct = __nested_webpack_require_743220__(9660);
	                        var robustSum = __nested_webpack_require_743220__(9662);
	                        var robustScale = __nested_webpack_require_743220__(8289);
	                        var compress = __nested_webpack_require_743220__(402);
	                        var NUM_EXPANDED = 6;
	                        function determinant_2(sum, scale, prod, compress2) {
	                          return function robustDeterminant2(m) {
	                            return compress2(sum(prod(m[0][0], m[1][1]), prod(-m[0][1], m[1][0])));
	                          };
	                        }
	                        function determinant_3(sum, scale, prod, compress2) {
	                          return function robustDeterminant3(m) {
	                            return compress2(sum(scale(sum(prod(m[1][1], m[2][2]), prod(-m[1][2], m[2][1])), m[0][0]), sum(scale(sum(prod(m[1][0], m[2][2]), prod(-m[1][2], m[2][0])), -m[0][1]), scale(sum(prod(m[1][0], m[2][1]), prod(-m[1][1], m[2][0])), m[0][2]))));
	                          };
	                        }
	                        function determinant_4(sum, scale, prod, compress2) {
	                          return function robustDeterminant4(m) {
	                            return compress2(sum(sum(scale(sum(scale(sum(prod(m[2][2], m[3][3]), prod(-m[2][3], m[3][2])), m[1][1]), sum(scale(sum(prod(m[2][1], m[3][3]), prod(-m[2][3], m[3][1])), -m[1][2]), scale(sum(prod(m[2][1], m[3][2]), prod(-m[2][2], m[3][1])), m[1][3]))), m[0][0]), scale(sum(scale(sum(prod(m[2][2], m[3][3]), prod(-m[2][3], m[3][2])), m[1][0]), sum(scale(sum(prod(m[2][0], m[3][3]), prod(-m[2][3], m[3][0])), -m[1][2]), scale(sum(prod(m[2][0], m[3][2]), prod(-m[2][2], m[3][0])), m[1][3]))), -m[0][1])), sum(scale(sum(scale(sum(prod(m[2][1], m[3][3]), prod(-m[2][3], m[3][1])), m[1][0]), sum(scale(sum(prod(m[2][0], m[3][3]), prod(-m[2][3], m[3][0])), -m[1][1]), scale(sum(prod(m[2][0], m[3][1]), prod(-m[2][1], m[3][0])), m[1][3]))), m[0][2]), scale(sum(scale(sum(prod(m[2][1], m[3][2]), prod(-m[2][2], m[3][1])), m[1][0]), sum(scale(sum(prod(m[2][0], m[3][2]), prod(-m[2][2], m[3][0])), -m[1][1]), scale(sum(prod(m[2][0], m[3][1]), prod(-m[2][1], m[3][0])), m[1][2]))), -m[0][3]))));
	                          };
	                        }
	                        function determinant_5(sum, scale, prod, compress2) {
	                          return function robustDeterminant5(m) {
	                            return compress2(sum(sum(scale(sum(sum(scale(sum(scale(sum(prod(m[3][3], m[4][4]), prod(-m[3][4], m[4][3])), m[2][2]), sum(scale(sum(prod(m[3][2], m[4][4]), prod(-m[3][4], m[4][2])), -m[2][3]), scale(sum(prod(m[3][2], m[4][3]), prod(-m[3][3], m[4][2])), m[2][4]))), m[1][1]), scale(sum(scale(sum(prod(m[3][3], m[4][4]), prod(-m[3][4], m[4][3])), m[2][1]), sum(scale(sum(prod(m[3][1], m[4][4]), prod(-m[3][4], m[4][1])), -m[2][3]), scale(sum(prod(m[3][1], m[4][3]), prod(-m[3][3], m[4][1])), m[2][4]))), -m[1][2])), sum(scale(sum(scale(sum(prod(m[3][2], m[4][4]), prod(-m[3][4], m[4][2])), m[2][1]), sum(scale(sum(prod(m[3][1], m[4][4]), prod(-m[3][4], m[4][1])), -m[2][2]), scale(sum(prod(m[3][1], m[4][2]), prod(-m[3][2], m[4][1])), m[2][4]))), m[1][3]), scale(sum(scale(sum(prod(m[3][2], m[4][3]), prod(-m[3][3], m[4][2])), m[2][1]), sum(scale(sum(prod(m[3][1], m[4][3]), prod(-m[3][3], m[4][1])), -m[2][2]), scale(sum(prod(m[3][1], m[4][2]), prod(-m[3][2], m[4][1])), m[2][3]))), -m[1][4]))), m[0][0]), scale(sum(sum(scale(sum(scale(sum(prod(m[3][3], m[4][4]), prod(-m[3][4], m[4][3])), m[2][2]), sum(scale(sum(prod(m[3][2], m[4][4]), prod(-m[3][4], m[4][2])), -m[2][3]), scale(sum(prod(m[3][2], m[4][3]), prod(-m[3][3], m[4][2])), m[2][4]))), m[1][0]), scale(sum(scale(sum(prod(m[3][3], m[4][4]), prod(-m[3][4], m[4][3])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][4]), prod(-m[3][4], m[4][0])), -m[2][3]), scale(sum(prod(m[3][0], m[4][3]), prod(-m[3][3], m[4][0])), m[2][4]))), -m[1][2])), sum(scale(sum(scale(sum(prod(m[3][2], m[4][4]), prod(-m[3][4], m[4][2])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][4]), prod(-m[3][4], m[4][0])), -m[2][2]), scale(sum(prod(m[3][0], m[4][2]), prod(-m[3][2], m[4][0])), m[2][4]))), m[1][3]), scale(sum(scale(sum(prod(m[3][2], m[4][3]), prod(-m[3][3], m[4][2])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][3]), prod(-m[3][3], m[4][0])), -m[2][2]), scale(sum(prod(m[3][0], m[4][2]), prod(-m[3][2], m[4][0])), m[2][3]))), -m[1][4]))), -m[0][1])), sum(scale(sum(sum(scale(sum(scale(sum(prod(m[3][3], m[4][4]), prod(-m[3][4], m[4][3])), m[2][1]), sum(scale(sum(prod(m[3][1], m[4][4]), prod(-m[3][4], m[4][1])), -m[2][3]), scale(sum(prod(m[3][1], m[4][3]), prod(-m[3][3], m[4][1])), m[2][4]))), m[1][0]), scale(sum(scale(sum(prod(m[3][3], m[4][4]), prod(-m[3][4], m[4][3])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][4]), prod(-m[3][4], m[4][0])), -m[2][3]), scale(sum(prod(m[3][0], m[4][3]), prod(-m[3][3], m[4][0])), m[2][4]))), -m[1][1])), sum(scale(sum(scale(sum(prod(m[3][1], m[4][4]), prod(-m[3][4], m[4][1])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][4]), prod(-m[3][4], m[4][0])), -m[2][1]), scale(sum(prod(m[3][0], m[4][1]), prod(-m[3][1], m[4][0])), m[2][4]))), m[1][3]), scale(sum(scale(sum(prod(m[3][1], m[4][3]), prod(-m[3][3], m[4][1])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][3]), prod(-m[3][3], m[4][0])), -m[2][1]), scale(sum(prod(m[3][0], m[4][1]), prod(-m[3][1], m[4][0])), m[2][3]))), -m[1][4]))), m[0][2]), sum(scale(sum(sum(scale(sum(scale(sum(prod(m[3][2], m[4][4]), prod(-m[3][4], m[4][2])), m[2][1]), sum(scale(sum(prod(m[3][1], m[4][4]), prod(-m[3][4], m[4][1])), -m[2][2]), scale(sum(prod(m[3][1], m[4][2]), prod(-m[3][2], m[4][1])), m[2][4]))), m[1][0]), scale(sum(scale(sum(prod(m[3][2], m[4][4]), prod(-m[3][4], m[4][2])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][4]), prod(-m[3][4], m[4][0])), -m[2][2]), scale(sum(prod(m[3][0], m[4][2]), prod(-m[3][2], m[4][0])), m[2][4]))), -m[1][1])), sum(scale(sum(scale(sum(prod(m[3][1], m[4][4]), prod(-m[3][4], m[4][1])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][4]), prod(-m[3][4], m[4][0])), -m[2][1]), scale(sum(prod(m[3][0], m[4][1]), prod(-m[3][1], m[4][0])), m[2][4]))), m[1][2]), scale(sum(scale(sum(prod(m[3][1], m[4][2]), prod(-m[3][2], m[4][1])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][2]), prod(-m[3][2], m[4][0])), -m[2][1]), scale(sum(prod(m[3][0], m[4][1]), prod(-m[3][1], m[4][0])), m[2][2]))), -m[1][4]))), -m[0][3]), scale(sum(sum(scale(sum(scale(sum(prod(m[3][2], m[4][3]), prod(-m[3][3], m[4][2])), m[2][1]), sum(scale(sum(prod(m[3][1], m[4][3]), prod(-m[3][3], m[4][1])), -m[2][2]), scale(sum(prod(m[3][1], m[4][2]), prod(-m[3][2], m[4][1])), m[2][3]))), m[1][0]), scale(sum(scale(sum(prod(m[3][2], m[4][3]), prod(-m[3][3], m[4][2])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][3]), prod(-m[3][3], m[4][0])), -m[2][2]), scale(sum(prod(m[3][0], m[4][2]), prod(-m[3][2], m[4][0])), m[2][3]))), -m[1][1])), sum(scale(sum(scale(sum(prod(m[3][1], m[4][3]), prod(-m[3][3], m[4][1])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][3]), prod(-m[3][3], m[4][0])), -m[2][1]), scale(sum(prod(m[3][0], m[4][1]), prod(-m[3][1], m[4][0])), m[2][3]))), m[1][2]), scale(sum(scale(sum(prod(m[3][1], m[4][2]), prod(-m[3][2], m[4][1])), m[2][0]), sum(scale(sum(prod(m[3][0], m[4][2]), prod(-m[3][2], m[4][0])), -m[2][1]), scale(sum(prod(m[3][0], m[4][1]), prod(-m[3][1], m[4][0])), m[2][2]))), -m[1][3]))), m[0][4])))));
	                          };
	                        }
	                        function compileDeterminant(n) {
	                          var fn = n === 2 ? determinant_2 : n === 3 ? determinant_3 : n === 4 ? determinant_4 : n === 5 ? determinant_5 : undefined;
	                          return fn(robustSum, robustScale, twoProduct, compress);
	                        }
	                        var CACHE = [function robustDeterminant0() {
	                          return [0];
	                        }, function robustDeterminant1(m) {
	                          return [m[0][0]];
	                        }];
	                        function proc(det0, det1, det2, det3, det4, det5, CACHE2, gen) {
	                          return function robustDeterminant(m) {
	                            switch (m.length) {
	                              case 0:
	                                return det0(m);
	                              case 1:
	                                return det1(m);
	                              case 2:
	                                return det2(m);
	                              case 3:
	                                return det3(m);
	                              case 4:
	                                return det4(m);
	                              case 5:
	                                return det5(m);
	                            }
	                            var det = CACHE2[m.length];
	                            if (!det) det = CACHE2[m.length] = gen(m.length);
	                            return det(m);
	                          };
	                        }
	                        function generateDispatch() {
	                          while (CACHE.length < NUM_EXPANDED) {
	                            CACHE.push(compileDeterminant(CACHE.length));
	                          }
	                          module3.exports = proc.apply(undefined, CACHE.concat([CACHE, compileDeterminant]));
	                          for (var i = 0; i < CACHE.length; ++i) {
	                            module3.exports[i] = CACHE[i];
	                          }
	                        }
	                        generateDispatch();
	                      }
	                    ),
	                    /***/
	                    9130: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_750555__) {
	                        var twoProduct = __nested_webpack_require_750555__(9660);
	                        var robustSum = __nested_webpack_require_750555__(9662);
	                        module3.exports = robustDotProduct;
	                        function robustDotProduct(a, b) {
	                          var r = twoProduct(a[0], b[0]);
	                          for (var i = 1; i < a.length; ++i) {
	                            r = robustSum(r, twoProduct(a[i], b[i]));
	                          }
	                          return r;
	                        }
	                      }
	                    ),
	                    /***/
	                    2227: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_750900__) {
	                        var twoProduct = __nested_webpack_require_750900__(9660);
	                        var robustSum = __nested_webpack_require_750900__(9662);
	                        var robustDiff = __nested_webpack_require_750900__(4078);
	                        var robustScale = __nested_webpack_require_750900__(8289);
	                        var NUM_EXPAND = 6;
	                        function orientation(n) {
	                          var fn = n === 3 ? inSphere3 : n === 4 ? inSphere4 : n === 5 ? inSphere5 : inSphere6;
	                          return fn(robustSum, robustDiff, twoProduct, robustScale);
	                        }
	                        function inSphere0() {
	                          return 0;
	                        }
	                        function inSphere1() {
	                          return 0;
	                        }
	                        function inSphere2() {
	                          return 0;
	                        }
	                        function inSphere3(sum, diff, prod, scale) {
	                          function exactInSphere3(m0, m1, m2) {
	                            var w0 = prod(m0[0], m0[0]);
	                            var w0m1 = scale(w0, m1[0]);
	                            var w0m2 = scale(w0, m2[0]);
	                            var w1 = prod(m1[0], m1[0]);
	                            var w1m0 = scale(w1, m0[0]);
	                            var w1m2 = scale(w1, m2[0]);
	                            var w2 = prod(m2[0], m2[0]);
	                            var w2m0 = scale(w2, m0[0]);
	                            var w2m1 = scale(w2, m1[0]);
	                            var p = sum(diff(w2m1, w1m2), diff(w1m0, w0m1));
	                            var n = diff(w2m0, w0m2);
	                            var d = diff(p, n);
	                            return d[d.length - 1];
	                          }
	                          return exactInSphere3;
	                        }
	                        function inSphere4(sum, diff, prod, scale) {
	                          function exactInSphere4(m0, m1, m2, m3) {
	                            var w0 = sum(prod(m0[0], m0[0]), prod(m0[1], m0[1]));
	                            var w0m1 = scale(w0, m1[0]);
	                            var w0m2 = scale(w0, m2[0]);
	                            var w0m3 = scale(w0, m3[0]);
	                            var w1 = sum(prod(m1[0], m1[0]), prod(m1[1], m1[1]));
	                            var w1m0 = scale(w1, m0[0]);
	                            var w1m2 = scale(w1, m2[0]);
	                            var w1m3 = scale(w1, m3[0]);
	                            var w2 = sum(prod(m2[0], m2[0]), prod(m2[1], m2[1]));
	                            var w2m0 = scale(w2, m0[0]);
	                            var w2m1 = scale(w2, m1[0]);
	                            var w2m3 = scale(w2, m3[0]);
	                            var w3 = sum(prod(m3[0], m3[0]), prod(m3[1], m3[1]));
	                            var w3m0 = scale(w3, m0[0]);
	                            var w3m1 = scale(w3, m1[0]);
	                            var w3m2 = scale(w3, m2[0]);
	                            var p = sum(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))));
	                            var n = sum(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))));
	                            var d = diff(p, n);
	                            return d[d.length - 1];
	                          }
	                          return exactInSphere4;
	                        }
	                        function inSphere5(sum, diff, prod, scale) {
	                          function exactInSphere5(m0, m1, m2, m3, m4) {
	                            var w0 = sum(prod(m0[0], m0[0]), sum(prod(m0[1], m0[1]), prod(m0[2], m0[2])));
	                            var w0m1 = scale(w0, m1[0]);
	                            var w0m2 = scale(w0, m2[0]);
	                            var w0m3 = scale(w0, m3[0]);
	                            var w0m4 = scale(w0, m4[0]);
	                            var w1 = sum(prod(m1[0], m1[0]), sum(prod(m1[1], m1[1]), prod(m1[2], m1[2])));
	                            var w1m0 = scale(w1, m0[0]);
	                            var w1m2 = scale(w1, m2[0]);
	                            var w1m3 = scale(w1, m3[0]);
	                            var w1m4 = scale(w1, m4[0]);
	                            var w2 = sum(prod(m2[0], m2[0]), sum(prod(m2[1], m2[1]), prod(m2[2], m2[2])));
	                            var w2m0 = scale(w2, m0[0]);
	                            var w2m1 = scale(w2, m1[0]);
	                            var w2m3 = scale(w2, m3[0]);
	                            var w2m4 = scale(w2, m4[0]);
	                            var w3 = sum(prod(m3[0], m3[0]), sum(prod(m3[1], m3[1]), prod(m3[2], m3[2])));
	                            var w3m0 = scale(w3, m0[0]);
	                            var w3m1 = scale(w3, m1[0]);
	                            var w3m2 = scale(w3, m2[0]);
	                            var w3m4 = scale(w3, m4[0]);
	                            var w4 = sum(prod(m4[0], m4[0]), sum(prod(m4[1], m4[1]), prod(m4[2], m4[2])));
	                            var w4m0 = scale(w4, m0[0]);
	                            var w4m1 = scale(w4, m1[0]);
	                            var w4m2 = scale(w4, m2[0]);
	                            var w4m3 = scale(w4, m3[0]);
	                            var p = sum(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), m1[2]), sum(scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), -m2[2]), scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), m3[2]))), sum(scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), -m4[2]), sum(scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), m0[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m1[2])))), sum(sum(scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), m3[2]), sum(scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), -m4[2]), scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), m0[2]))), sum(scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m1[2]), sum(scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m3[2])))));
	                            var n = sum(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), m0[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m2[2])), sum(scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m4[2]))), sum(sum(scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), m0[2]), scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), -m1[2])), sum(scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m4[2]))));
	                            var d = diff(p, n);
	                            return d[d.length - 1];
	                          }
	                          return exactInSphere5;
	                        }
	                        function inSphere6(sum, diff, prod, scale) {
	                          function exactInSphere6(m0, m1, m2, m3, m4, m5) {
	                            var w0 = sum(sum(prod(m0[0], m0[0]), prod(m0[1], m0[1])), sum(prod(m0[2], m0[2]), prod(m0[3], m0[3])));
	                            var w0m1 = scale(w0, m1[0]);
	                            var w0m2 = scale(w0, m2[0]);
	                            var w0m3 = scale(w0, m3[0]);
	                            var w0m4 = scale(w0, m4[0]);
	                            var w0m5 = scale(w0, m5[0]);
	                            var w1 = sum(sum(prod(m1[0], m1[0]), prod(m1[1], m1[1])), sum(prod(m1[2], m1[2]), prod(m1[3], m1[3])));
	                            var w1m0 = scale(w1, m0[0]);
	                            var w1m2 = scale(w1, m2[0]);
	                            var w1m3 = scale(w1, m3[0]);
	                            var w1m4 = scale(w1, m4[0]);
	                            var w1m5 = scale(w1, m5[0]);
	                            var w2 = sum(sum(prod(m2[0], m2[0]), prod(m2[1], m2[1])), sum(prod(m2[2], m2[2]), prod(m2[3], m2[3])));
	                            var w2m0 = scale(w2, m0[0]);
	                            var w2m1 = scale(w2, m1[0]);
	                            var w2m3 = scale(w2, m3[0]);
	                            var w2m4 = scale(w2, m4[0]);
	                            var w2m5 = scale(w2, m5[0]);
	                            var w3 = sum(sum(prod(m3[0], m3[0]), prod(m3[1], m3[1])), sum(prod(m3[2], m3[2]), prod(m3[3], m3[3])));
	                            var w3m0 = scale(w3, m0[0]);
	                            var w3m1 = scale(w3, m1[0]);
	                            var w3m2 = scale(w3, m2[0]);
	                            var w3m4 = scale(w3, m4[0]);
	                            var w3m5 = scale(w3, m5[0]);
	                            var w4 = sum(sum(prod(m4[0], m4[0]), prod(m4[1], m4[1])), sum(prod(m4[2], m4[2]), prod(m4[3], m4[3])));
	                            var w4m0 = scale(w4, m0[0]);
	                            var w4m1 = scale(w4, m1[0]);
	                            var w4m2 = scale(w4, m2[0]);
	                            var w4m3 = scale(w4, m3[0]);
	                            var w4m5 = scale(w4, m5[0]);
	                            var w5 = sum(sum(prod(m5[0], m5[0]), prod(m5[1], m5[1])), sum(prod(m5[2], m5[2]), prod(m5[3], m5[3])));
	                            var w5m0 = scale(w5, m0[0]);
	                            var w5m1 = scale(w5, m1[0]);
	                            var w5m2 = scale(w5, m2[0]);
	                            var w5m3 = scale(w5, m3[0]);
	                            var w5m4 = scale(w5, m4[0]);
	                            var p = sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m3[1]), sum(scale(diff(w5m3, w3m5), -m4[1]), scale(diff(w4m3, w3m4), m5[1]))), m2[2]), scale(sum(scale(diff(w5m4, w4m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m4[1]), scale(diff(w4m2, w2m4), m5[1]))), -m3[2])), sum(scale(sum(scale(diff(w5m3, w3m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m3[1]), scale(diff(w3m2, w2m3), m5[1]))), m4[2]), scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), -m5[2]))), m1[3]), sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m3[1]), sum(scale(diff(w5m3, w3m5), -m4[1]), scale(diff(w4m3, w3m4), m5[1]))), m1[2]), scale(sum(scale(diff(w5m4, w4m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m4[1]), scale(diff(w4m1, w1m4), m5[1]))), -m3[2])), sum(scale(sum(scale(diff(w5m3, w3m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m3[1]), scale(diff(w3m1, w1m3), m5[1]))), m4[2]), scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), -m5[2]))), -m2[3]), scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m4[1]), scale(diff(w4m2, w2m4), m5[1]))), m1[2]), scale(sum(scale(diff(w5m4, w4m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m4[1]), scale(diff(w4m1, w1m4), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m2[1]), scale(diff(w2m1, w1m2), m5[1]))), m4[2]), scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), -m5[2]))), m3[3]))), sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m3, w3m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m3[1]), scale(diff(w3m2, w2m3), m5[1]))), m1[2]), scale(sum(scale(diff(w5m3, w3m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m3[1]), scale(diff(w3m1, w1m3), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m2[1]), scale(diff(w2m1, w1m2), m5[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), -m5[2]))), -m4[3]), scale(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), m1[2]), scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), -m2[2])), sum(scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), -m4[2]))), m5[3])), sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m3[1]), sum(scale(diff(w5m3, w3m5), -m4[1]), scale(diff(w4m3, w3m4), m5[1]))), m1[2]), scale(sum(scale(diff(w5m4, w4m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m4[1]), scale(diff(w4m1, w1m4), m5[1]))), -m3[2])), sum(scale(sum(scale(diff(w5m3, w3m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m3[1]), scale(diff(w3m1, w1m3), m5[1]))), m4[2]), scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), -m5[2]))), m0[3]), scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m3[1]), sum(scale(diff(w5m3, w3m5), -m4[1]), scale(diff(w4m3, w3m4), m5[1]))), m0[2]), scale(sum(scale(diff(w5m4, w4m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m4[1]), scale(diff(w4m0, w0m4), m5[1]))), -m3[2])), sum(scale(sum(scale(diff(w5m3, w3m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m3[1]), scale(diff(w3m0, w0m3), m5[1]))), m4[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m5[2]))), -m1[3])))), sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m4[1]), scale(diff(w4m1, w1m4), m5[1]))), m0[2]), scale(sum(scale(diff(w5m4, w4m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m4[1]), scale(diff(w4m0, w0m4), m5[1]))), -m1[2])), sum(scale(sum(scale(diff(w5m1, w1m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m1[1]), scale(diff(w1m0, w0m1), m5[1]))), m4[2]), scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), -m5[2]))), m3[3]), scale(sum(sum(scale(sum(scale(diff(w5m3, w3m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m3[1]), scale(diff(w3m1, w1m3), m5[1]))), m0[2]), scale(sum(scale(diff(w5m3, w3m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m3[1]), scale(diff(w3m0, w0m3), m5[1]))), -m1[2])), sum(scale(sum(scale(diff(w5m1, w1m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m1[1]), scale(diff(w1m0, w0m1), m5[1]))), m3[2]), scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), -m5[2]))), -m4[3])), sum(scale(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), m0[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m1[2])), sum(scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), m3[2]), scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), -m4[2]))), m5[3]), scale(sum(sum(scale(sum(scale(diff(w5m3, w3m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m3[1]), scale(diff(w3m2, w2m3), m5[1]))), m1[2]), scale(sum(scale(diff(w5m3, w3m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m3[1]), scale(diff(w3m1, w1m3), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m2[1]), scale(diff(w2m1, w1m2), m5[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), -m5[2]))), m0[3]))), sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m3, w3m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m3[1]), scale(diff(w3m2, w2m3), m5[1]))), m0[2]), scale(sum(scale(diff(w5m3, w3m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m3[1]), scale(diff(w3m0, w0m3), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m2[1]), scale(diff(w2m0, w0m2), m5[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m5[2]))), -m1[3]), scale(sum(sum(scale(sum(scale(diff(w5m3, w3m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m3[1]), scale(diff(w3m1, w1m3), m5[1]))), m0[2]), scale(sum(scale(diff(w5m3, w3m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m3[1]), scale(diff(w3m0, w0m3), m5[1]))), -m1[2])), sum(scale(sum(scale(diff(w5m1, w1m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m1[1]), scale(diff(w1m0, w0m1), m5[1]))), m3[2]), scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), -m5[2]))), m2[3])), sum(scale(sum(sum(scale(sum(scale(diff(w5m2, w2m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m2[1]), scale(diff(w2m1, w1m2), m5[1]))), m0[2]), scale(sum(scale(diff(w5m2, w2m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m2[1]), scale(diff(w2m0, w0m2), m5[1]))), -m1[2])), sum(scale(sum(scale(diff(w5m1, w1m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m1[1]), scale(diff(w1m0, w0m1), m5[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m5[2]))), -m3[3]), scale(sum(sum(scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), m0[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m1[2])), sum(scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m3[2]))), m5[3])))));
	                            var n = sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m3[1]), sum(scale(diff(w5m3, w3m5), -m4[1]), scale(diff(w4m3, w3m4), m5[1]))), m2[2]), scale(sum(scale(diff(w5m4, w4m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m4[1]), scale(diff(w4m2, w2m4), m5[1]))), -m3[2])), sum(scale(sum(scale(diff(w5m3, w3m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m3[1]), scale(diff(w3m2, w2m3), m5[1]))), m4[2]), scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), -m5[2]))), m0[3]), sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m3[1]), sum(scale(diff(w5m3, w3m5), -m4[1]), scale(diff(w4m3, w3m4), m5[1]))), m0[2]), scale(sum(scale(diff(w5m4, w4m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m4[1]), scale(diff(w4m0, w0m4), m5[1]))), -m3[2])), sum(scale(sum(scale(diff(w5m3, w3m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m3[1]), scale(diff(w3m0, w0m3), m5[1]))), m4[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m5[2]))), -m2[3]), scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m4[1]), scale(diff(w4m2, w2m4), m5[1]))), m0[2]), scale(sum(scale(diff(w5m4, w4m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m4[1]), scale(diff(w4m0, w0m4), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m2[1]), scale(diff(w2m0, w0m2), m5[1]))), m4[2]), scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), -m5[2]))), m3[3]))), sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m3, w3m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m3[1]), scale(diff(w3m2, w2m3), m5[1]))), m0[2]), scale(sum(scale(diff(w5m3, w3m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m3[1]), scale(diff(w3m0, w0m3), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m2[1]), scale(diff(w2m0, w0m2), m5[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m5[2]))), -m4[3]), scale(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), m0[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m2[2])), sum(scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m4[2]))), m5[3])), sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m4[1]), scale(diff(w4m2, w2m4), m5[1]))), m1[2]), scale(sum(scale(diff(w5m4, w4m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m4[1]), scale(diff(w4m1, w1m4), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m2[1]), scale(diff(w2m1, w1m2), m5[1]))), m4[2]), scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), -m5[2]))), m0[3]), scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m2[1]), sum(scale(diff(w5m2, w2m5), -m4[1]), scale(diff(w4m2, w2m4), m5[1]))), m0[2]), scale(sum(scale(diff(w5m4, w4m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m4[1]), scale(diff(w4m0, w0m4), m5[1]))), -m2[2])), sum(scale(sum(scale(diff(w5m2, w2m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m2[1]), scale(diff(w2m0, w0m2), m5[1]))), m4[2]), scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), -m5[2]))), -m1[3])))), sum(sum(sum(scale(sum(sum(scale(sum(scale(diff(w5m4, w4m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m4[1]), scale(diff(w4m1, w1m4), m5[1]))), m0[2]), scale(sum(scale(diff(w5m4, w4m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m4[1]), scale(diff(w4m0, w0m4), m5[1]))), -m1[2])), sum(scale(sum(scale(diff(w5m1, w1m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m1[1]), scale(diff(w1m0, w0m1), m5[1]))), m4[2]), scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), -m5[2]))), m2[3]), scale(sum(sum(scale(sum(scale(diff(w5m2, w2m5), m1[1]), sum(scale(diff(w5m1, w1m5), -m2[1]), scale(diff(w2m1, w1m2), m5[1]))), m0[2]), scale(sum(scale(diff(w5m2, w2m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m2[1]), scale(diff(w2m0, w0m2), m5[1]))), -m1[2])), sum(scale(sum(scale(diff(w5m1, w1m5), m0[1]), sum(scale(diff(w5m0, w0m5), -m1[1]), scale(diff(w1m0, w0m1), m5[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m5[2]))), -m4[3])), sum(scale(sum(sum(scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), m0[2]), scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), -m1[2])), sum(scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m4[2]))), m5[3]), scale(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), m1[2]), scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), -m2[2])), sum(scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), -m4[2]))), m0[3]))), sum(sum(scale(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m2[1]), sum(scale(diff(w4m2, w2m4), -m3[1]), scale(diff(w3m2, w2m3), m4[1]))), m0[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m2[2])), sum(scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), m3[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m4[2]))), -m1[3]), scale(sum(sum(scale(sum(scale(diff(w4m3, w3m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m3[1]), scale(diff(w3m1, w1m3), m4[1]))), m0[2]), scale(sum(scale(diff(w4m3, w3m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m3[1]), scale(diff(w3m0, w0m3), m4[1]))), -m1[2])), sum(scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), m3[2]), scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), -m4[2]))), m2[3])), sum(scale(sum(sum(scale(sum(scale(diff(w4m2, w2m4), m1[1]), sum(scale(diff(w4m1, w1m4), -m2[1]), scale(diff(w2m1, w1m2), m4[1]))), m0[2]), scale(sum(scale(diff(w4m2, w2m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m2[1]), scale(diff(w2m0, w0m2), m4[1]))), -m1[2])), sum(scale(sum(scale(diff(w4m1, w1m4), m0[1]), sum(scale(diff(w4m0, w0m4), -m1[1]), scale(diff(w1m0, w0m1), m4[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m4[2]))), -m3[3]), scale(sum(sum(scale(sum(scale(diff(w3m2, w2m3), m1[1]), sum(scale(diff(w3m1, w1m3), -m2[1]), scale(diff(w2m1, w1m2), m3[1]))), m0[2]), scale(sum(scale(diff(w3m2, w2m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m2[1]), scale(diff(w2m0, w0m2), m3[1]))), -m1[2])), sum(scale(sum(scale(diff(w3m1, w1m3), m0[1]), sum(scale(diff(w3m0, w0m3), -m1[1]), scale(diff(w1m0, w0m1), m3[1]))), m2[2]), scale(sum(scale(diff(w2m1, w1m2), m0[1]), sum(scale(diff(w2m0, w0m2), -m1[1]), scale(diff(w1m0, w0m1), m2[1]))), -m3[2]))), m4[3])))));
	                            var d = diff(p, n);
	                            return d[d.length - 1];
	                          }
	                          return exactInSphere6;
	                        }
	                        var CACHED = [inSphere0, inSphere1, inSphere2];
	                        function slowInSphere(args) {
	                          var proc2 = CACHED[args.length];
	                          if (!proc2) {
	                            proc2 = CACHED[args.length] = orientation(args.length);
	                          }
	                          return proc2.apply(undefined, args);
	                        }
	                        function proc(slow, o0, o1, o2, o3, o4, o5, o6) {
	                          function testInSphere(a0, a1, a2, a3, a4, a5) {
	                            switch (arguments.length) {
	                              case 0:
	                              case 1:
	                                return 0;
	                              case 2:
	                                return o2(a0, a1);
	                              case 3:
	                                return o3(a0, a1, a2);
	                              case 4:
	                                return o4(a0, a1, a2, a3);
	                              case 5:
	                                return o5(a0, a1, a2, a3, a4);
	                              case 6:
	                                return o6(a0, a1, a2, a3, a4, a5);
	                            }
	                            var s = new Array(arguments.length);
	                            for (var i = 0; i < arguments.length; ++i) {
	                              s[i] = arguments[i];
	                            }
	                            return slow(s);
	                          }
	                          return testInSphere;
	                        }
	                        function generateInSphereTest() {
	                          while (CACHED.length <= NUM_EXPAND) {
	                            CACHED.push(orientation(CACHED.length));
	                          }
	                          module3.exports = proc.apply(undefined, [slowInSphere].concat(CACHED));
	                          for (var i = 0; i <= NUM_EXPAND; ++i) {
	                            module3.exports[i] = CACHED[i];
	                          }
	                        }
	                        generateInSphereTest();
	                      }
	                    ),
	                    /***/
	                    6606: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_772915__) {
	                        var determinant = __nested_webpack_require_772915__(8167);
	                        var NUM_EXPAND = 6;
	                        function generateSolver(n) {
	                          var fn = n === 2 ? solve2d : n === 3 ? solve3d : n === 4 ? solve4d : n === 5 ? solve5d : solve6d;
	                          if (n < 6) {
	                            return fn(determinant[n]);
	                          }
	                          return fn(determinant);
	                        }
	                        function robustLinearSolve0d() {
	                          return [[0]];
	                        }
	                        function robustLinearSolve1d(A, b) {
	                          return [[b[0]], [A[0][0]]];
	                        }
	                        function solve2d(det) {
	                          return function robustLinearSolve2d(A, b) {
	                            return [det([[+b[0], +A[0][1]], [+b[1], +A[1][1]]]), det([[+A[0][0], +b[0]], [+A[1][0], +b[1]]]), det(A)];
	                          };
	                        }
	                        function solve3d(det) {
	                          return function robustLinearSolve3d(A, b) {
	                            return [det([[+b[0], +A[0][1], +A[0][2]], [+b[1], +A[1][1], +A[1][2]], [+b[2], +A[2][1], +A[2][2]]]), det([[+A[0][0], +b[0], +A[0][2]], [+A[1][0], +b[1], +A[1][2]], [+A[2][0], +b[2], +A[2][2]]]), det([[+A[0][0], +A[0][1], +b[0]], [+A[1][0], +A[1][1], +b[1]], [+A[2][0], +A[2][1], +b[2]]]), det(A)];
	                          };
	                        }
	                        function solve4d(det) {
	                          return function robustLinearSolve4d(A, b) {
	                            return [det([[+b[0], +A[0][1], +A[0][2], +A[0][3]], [+b[1], +A[1][1], +A[1][2], +A[1][3]], [+b[2], +A[2][1], +A[2][2], +A[2][3]], [+b[3], +A[3][1], +A[3][2], +A[3][3]]]), det([[+A[0][0], +b[0], +A[0][2], +A[0][3]], [+A[1][0], +b[1], +A[1][2], +A[1][3]], [+A[2][0], +b[2], +A[2][2], +A[2][3]], [+A[3][0], +b[3], +A[3][2], +A[3][3]]]), det([[+A[0][0], +A[0][1], +b[0], +A[0][3]], [+A[1][0], +A[1][1], +b[1], +A[1][3]], [+A[2][0], +A[2][1], +b[2], +A[2][3]], [+A[3][0], +A[3][1], +b[3], +A[3][3]]]), det([[+A[0][0], +A[0][1], +A[0][2], +b[0]], [+A[1][0], +A[1][1], +A[1][2], +b[1]], [+A[2][0], +A[2][1], +A[2][2], +b[2]], [+A[3][0], +A[3][1], +A[3][2], +b[3]]]), det(A)];
	                          };
	                        }
	                        function solve5d(det) {
	                          return function robustLinearSolve5d(A, b) {
	                            return [det([[+b[0], +A[0][1], +A[0][2], +A[0][3], +A[0][4]], [+b[1], +A[1][1], +A[1][2], +A[1][3], +A[1][4]], [+b[2], +A[2][1], +A[2][2], +A[2][3], +A[2][4]], [+b[3], +A[3][1], +A[3][2], +A[3][3], +A[3][4]], [+b[4], +A[4][1], +A[4][2], +A[4][3], +A[4][4]]]), det([[+A[0][0], +b[0], +A[0][2], +A[0][3], +A[0][4]], [+A[1][0], +b[1], +A[1][2], +A[1][3], +A[1][4]], [+A[2][0], +b[2], +A[2][2], +A[2][3], +A[2][4]], [+A[3][0], +b[3], +A[3][2], +A[3][3], +A[3][4]], [+A[4][0], +b[4], +A[4][2], +A[4][3], +A[4][4]]]), det([[+A[0][0], +A[0][1], +b[0], +A[0][3], +A[0][4]], [+A[1][0], +A[1][1], +b[1], +A[1][3], +A[1][4]], [+A[2][0], +A[2][1], +b[2], +A[2][3], +A[2][4]], [+A[3][0], +A[3][1], +b[3], +A[3][3], +A[3][4]], [+A[4][0], +A[4][1], +b[4], +A[4][3], +A[4][4]]]), det([[+A[0][0], +A[0][1], +A[0][2], +b[0], +A[0][4]], [+A[1][0], +A[1][1], +A[1][2], +b[1], +A[1][4]], [+A[2][0], +A[2][1], +A[2][2], +b[2], +A[2][4]], [+A[3][0], +A[3][1], +A[3][2], +b[3], +A[3][4]], [+A[4][0], +A[4][1], +A[4][2], +b[4], +A[4][4]]]), det([[+A[0][0], +A[0][1], +A[0][2], +A[0][3], +b[0]], [+A[1][0], +A[1][1], +A[1][2], +A[1][3], +b[1]], [+A[2][0], +A[2][1], +A[2][2], +A[2][3], +b[2]], [+A[3][0], +A[3][1], +A[3][2], +A[3][3], +b[3]], [+A[4][0], +A[4][1], +A[4][2], +A[4][3], +b[4]]]), det(A)];
	                          };
	                        }
	                        function solve6d(det) {
	                          return function robustLinearSolve6d(A, b) {
	                            return [det([[+b[0], +A[0][1], +A[0][2], +A[0][3], +A[0][4], +A[0][5]], [+b[1], +A[1][1], +A[1][2], +A[1][3], +A[1][4], +A[1][5]], [+b[2], +A[2][1], +A[2][2], +A[2][3], +A[2][4], +A[2][5]], [+b[3], +A[3][1], +A[3][2], +A[3][3], +A[3][4], +A[3][5]], [+b[4], +A[4][1], +A[4][2], +A[4][3], +A[4][4], +A[4][5]], [+b[5], +A[5][1], +A[5][2], +A[5][3], +A[5][4], +A[5][5]]]), det([[+A[0][0], +b[0], +A[0][2], +A[0][3], +A[0][4], +A[0][5]], [+A[1][0], +b[1], +A[1][2], +A[1][3], +A[1][4], +A[1][5]], [+A[2][0], +b[2], +A[2][2], +A[2][3], +A[2][4], +A[2][5]], [+A[3][0], +b[3], +A[3][2], +A[3][3], +A[3][4], +A[3][5]], [+A[4][0], +b[4], +A[4][2], +A[4][3], +A[4][4], +A[4][5]], [+A[5][0], +b[5], +A[5][2], +A[5][3], +A[5][4], +A[5][5]]]), det([[+A[0][0], +A[0][1], +b[0], +A[0][3], +A[0][4], +A[0][5]], [+A[1][0], +A[1][1], +b[1], +A[1][3], +A[1][4], +A[1][5]], [+A[2][0], +A[2][1], +b[2], +A[2][3], +A[2][4], +A[2][5]], [+A[3][0], +A[3][1], +b[3], +A[3][3], +A[3][4], +A[3][5]], [+A[4][0], +A[4][1], +b[4], +A[4][3], +A[4][4], +A[4][5]], [+A[5][0], +A[5][1], +b[5], +A[5][3], +A[5][4], +A[5][5]]]), det([[+A[0][0], +A[0][1], +A[0][2], +b[0], +A[0][4], +A[0][5]], [+A[1][0], +A[1][1], +A[1][2], +b[1], +A[1][4], +A[1][5]], [+A[2][0], +A[2][1], +A[2][2], +b[2], +A[2][4], +A[2][5]], [+A[3][0], +A[3][1], +A[3][2], +b[3], +A[3][4], +A[3][5]], [+A[4][0], +A[4][1], +A[4][2], +b[4], +A[4][4], +A[4][5]], [+A[5][0], +A[5][1], +A[5][2], +b[5], +A[5][4], +A[5][5]]]), det([[+A[0][0], +A[0][1], +A[0][2], +A[0][3], +b[0], +A[0][5]], [+A[1][0], +A[1][1], +A[1][2], +A[1][3], +b[1], +A[1][5]], [+A[2][0], +A[2][1], +A[2][2], +A[2][3], +b[2], +A[2][5]], [+A[3][0], +A[3][1], +A[3][2], +A[3][3], +b[3], +A[3][5]], [+A[4][0], +A[4][1], +A[4][2], +A[4][3], +b[4], +A[4][5]], [+A[5][0], +A[5][1], +A[5][2], +A[5][3], +b[5], +A[5][5]]]), det([[+A[0][0], +A[0][1], +A[0][2], +A[0][3], +A[0][4], +b[0]], [+A[1][0], +A[1][1], +A[1][2], +A[1][3], +A[1][4], +b[1]], [+A[2][0], +A[2][1], +A[2][2], +A[2][3], +A[2][4], +b[2]], [+A[3][0], +A[3][1], +A[3][2], +A[3][3], +A[3][4], +b[3]], [+A[4][0], +A[4][1], +A[4][2], +A[4][3], +A[4][4], +b[4]], [+A[5][0], +A[5][1], +A[5][2], +A[5][3], +A[5][4], +b[5]]]), det(A)];
	                          };
	                        }
	                        var CACHE = [robustLinearSolve0d, robustLinearSolve1d];
	                        function proc(s0, s1, s2, s3, s4, s5, CACHE2, g) {
	                          return function dispatchLinearSolve(A, b) {
	                            switch (A.length) {
	                              case 0:
	                                return s0(A, b);
	                              case 1:
	                                return s1(A, b);
	                              case 2:
	                                return s2(A, b);
	                              case 3:
	                                return s3(A, b);
	                              case 4:
	                                return s4(A, b);
	                              case 5:
	                                return s5(A, b);
	                            }
	                            var s = CACHE2[A.length];
	                            if (!s) s = CACHE2[A.length] = g(A.length);
	                            return s(A, b);
	                          };
	                        }
	                        function generateDispatch() {
	                          while (CACHE.length < NUM_EXPAND) {
	                            CACHE.push(generateSolver(CACHE.length));
	                          }
	                          module3.exports = proc.apply(undefined, CACHE.concat([CACHE, generateSolver]));
	                          for (var i = 0; i < NUM_EXPAND; ++i) {
	                            module3.exports[i] = CACHE[i];
	                          }
	                        }
	                        generateDispatch();
	                      }
	                    ),
	                    /***/
	                    417: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_778358__) {
	                        var twoProduct = __nested_webpack_require_778358__(9660);
	                        var robustSum = __nested_webpack_require_778358__(9662);
	                        var robustScale = __nested_webpack_require_778358__(8289);
	                        var robustSubtract = __nested_webpack_require_778358__(4078);
	                        var NUM_EXPAND = 5;
	                        var EPSILON = 11102230246251565e-32;
	                        var ERRBOUND3 = (3 + 16 * EPSILON) * EPSILON;
	                        var ERRBOUND4 = (7 + 56 * EPSILON) * EPSILON;
	                        function orientation_3(sum, prod, scale, sub) {
	                          return function orientation3Exact2(m0, m1, m2) {
	                            var p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])));
	                            var n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]));
	                            var d = sub(p, n);
	                            return d[d.length - 1];
	                          };
	                        }
	                        function orientation_4(sum, prod, scale, sub) {
	                          return function orientation4Exact2(m0, m1, m2, m3) {
	                            var p = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))));
	                            var n = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))));
	                            var d = sub(p, n);
	                            return d[d.length - 1];
	                          };
	                        }
	                        function orientation_5(sum, prod, scale, sub) {
	                          return function orientation5Exact(m0, m1, m2, m3, m4) {
	                            var p = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))));
	                            var n = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))));
	                            var d = sub(p, n);
	                            return d[d.length - 1];
	                          };
	                        }
	                        function orientation(n) {
	                          var fn = n === 3 ? orientation_3 : n === 4 ? orientation_4 : orientation_5;
	                          return fn(robustSum, twoProduct, robustScale, robustSubtract);
	                        }
	                        var orientation3Exact = orientation(3);
	                        var orientation4Exact = orientation(4);
	                        var CACHED = [function orientation0() {
	                          return 0;
	                        }, function orientation1() {
	                          return 0;
	                        }, function orientation2(a, b) {
	                          return b[0] - a[0];
	                        }, function orientation3(a, b, c) {
	                          var l = (a[1] - c[1]) * (b[0] - c[0]);
	                          var r = (a[0] - c[0]) * (b[1] - c[1]);
	                          var det = l - r;
	                          var s;
	                          if (l > 0) {
	                            if (r <= 0) {
	                              return det;
	                            } else {
	                              s = l + r;
	                            }
	                          } else if (l < 0) {
	                            if (r >= 0) {
	                              return det;
	                            } else {
	                              s = -(l + r);
	                            }
	                          } else {
	                            return det;
	                          }
	                          var tol = ERRBOUND3 * s;
	                          if (det >= tol || det <= -tol) {
	                            return det;
	                          }
	                          return orientation3Exact(a, b, c);
	                        }, function orientation4(a, b, c, d) {
	                          var adx = a[0] - d[0];
	                          var bdx = b[0] - d[0];
	                          var cdx = c[0] - d[0];
	                          var ady = a[1] - d[1];
	                          var bdy = b[1] - d[1];
	                          var cdy = c[1] - d[1];
	                          var adz = a[2] - d[2];
	                          var bdz = b[2] - d[2];
	                          var cdz = c[2] - d[2];
	                          var bdxcdy = bdx * cdy;
	                          var cdxbdy = cdx * bdy;
	                          var cdxady = cdx * ady;
	                          var adxcdy = adx * cdy;
	                          var adxbdy = adx * bdy;
	                          var bdxady = bdx * ady;
	                          var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
	                          var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
	                          var tol = ERRBOUND4 * permanent;
	                          if (det > tol || -det > tol) {
	                            return det;
	                          }
	                          return orientation4Exact(a, b, c, d);
	                        }];
	                        function slowOrient(args) {
	                          var proc2 = CACHED[args.length];
	                          if (!proc2) {
	                            proc2 = CACHED[args.length] = orientation(args.length);
	                          }
	                          return proc2.apply(undefined, args);
	                        }
	                        function proc(slow, o0, o1, o2, o3, o4, o5) {
	                          return function getOrientation(a0, a1, a2, a3, a4) {
	                            switch (arguments.length) {
	                              case 0:
	                              case 1:
	                                return 0;
	                              case 2:
	                                return o2(a0, a1);
	                              case 3:
	                                return o3(a0, a1, a2);
	                              case 4:
	                                return o4(a0, a1, a2, a3);
	                              case 5:
	                                return o5(a0, a1, a2, a3, a4);
	                            }
	                            var s = new Array(arguments.length);
	                            for (var i = 0; i < arguments.length; ++i) {
	                              s[i] = arguments[i];
	                            }
	                            return slow(s);
	                          };
	                        }
	                        function generateOrientationProc() {
	                          while (CACHED.length <= NUM_EXPAND) {
	                            CACHED.push(orientation(CACHED.length));
	                          }
	                          module3.exports = proc.apply(undefined, [slowOrient].concat(CACHED));
	                          for (var i = 0; i <= NUM_EXPAND; ++i) {
	                            module3.exports[i] = CACHED[i];
	                          }
	                        }
	                        generateOrientationProc();
	                      }
	                    ),
	                    /***/
	                    2019: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_785963__) {
	                        var robustSum = __nested_webpack_require_785963__(9662);
	                        var robustScale = __nested_webpack_require_785963__(8289);
	                        module3.exports = robustProduct;
	                        function robustProduct(a, b) {
	                          if (a.length === 1) {
	                            return robustScale(b, a[0]);
	                          }
	                          if (b.length === 1) {
	                            return robustScale(a, b[0]);
	                          }
	                          if (a.length === 0 || b.length === 0) {
	                            return [0];
	                          }
	                          var r = [0];
	                          if (a.length < b.length) {
	                            for (var i = 0; i < a.length; ++i) {
	                              r = robustSum(r, robustScale(b, a[i]));
	                            }
	                          } else {
	                            for (var i = 0; i < b.length; ++i) {
	                              r = robustSum(r, robustScale(a, b[i]));
	                            }
	                          }
	                          return r;
	                        }
	                      }
	                    ),
	                    /***/
	                    8289: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_786508__) {
	                        var twoProduct = __nested_webpack_require_786508__(9660);
	                        var twoSum = __nested_webpack_require_786508__(87);
	                        module3.exports = scaleLinearExpansion;
	                        function scaleLinearExpansion(e, scale) {
	                          var n = e.length;
	                          if (n === 1) {
	                            var ts = twoProduct(e[0], scale);
	                            if (ts[0]) {
	                              return ts;
	                            }
	                            return [ts[1]];
	                          }
	                          var g = new Array(2 * n);
	                          var q = [0.1, 0.1];
	                          var t = [0.1, 0.1];
	                          var count = 0;
	                          twoProduct(e[0], scale, q);
	                          if (q[0]) {
	                            g[count++] = q[0];
	                          }
	                          for (var i = 1; i < n; ++i) {
	                            twoProduct(e[i], scale, t);
	                            var pq = q[1];
	                            twoSum(pq, t[0], q);
	                            if (q[0]) {
	                              g[count++] = q[0];
	                            }
	                            var a = t[1];
	                            var b = q[1];
	                            var x = a + b;
	                            var bv = x - a;
	                            var y = b - bv;
	                            q[1] = x;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                          }
	                          if (q[1]) {
	                            g[count++] = q[1];
	                          }
	                          if (count === 0) {
	                            g[count++] = 0;
	                          }
	                          g.length = count;
	                          return g;
	                        }
	                      }
	                    ),
	                    /***/
	                    4434: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_787228__) {
	                        module3.exports = segmentsIntersect;
	                        var orient = __nested_webpack_require_787228__(417)[3];
	                        function checkCollinear(a0, a1, b0, b1) {
	                          for (var d = 0; d < 2; ++d) {
	                            var x0 = a0[d];
	                            var y0 = a1[d];
	                            var l0 = Math.min(x0, y0);
	                            var h0 = Math.max(x0, y0);
	                            var x1 = b0[d];
	                            var y1 = b1[d];
	                            var l1 = Math.min(x1, y1);
	                            var h1 = Math.max(x1, y1);
	                            if (h1 < l0 || h0 < l1) {
	                              return false;
	                            }
	                          }
	                          return true;
	                        }
	                        function segmentsIntersect(a0, a1, b0, b1) {
	                          var x0 = orient(a0, b0, b1);
	                          var y0 = orient(a1, b0, b1);
	                          if (x0 > 0 && y0 > 0 || x0 < 0 && y0 < 0) {
	                            return false;
	                          }
	                          var x1 = orient(b0, a0, a1);
	                          var y1 = orient(b1, a0, a1);
	                          if (x1 > 0 && y1 > 0 || x1 < 0 && y1 < 0) {
	                            return false;
	                          }
	                          if (x0 === 0 && y0 === 0 && x1 === 0 && y1 === 0) {
	                            return checkCollinear(a0, a1, b0, b1);
	                          }
	                          return true;
	                        }
	                      }
	                    ),
	                    /***/
	                    4078: (
	                      /***/
	                      function(module3) {
	                        module3.exports = robustSubtract;
	                        function scalarScalar(a, b) {
	                          var x = a + b;
	                          var bv = x - a;
	                          var av = x - bv;
	                          var br = b - bv;
	                          var ar = a - av;
	                          var y = ar + br;
	                          if (y) {
	                            return [y, x];
	                          }
	                          return [x];
	                        }
	                        function robustSubtract(e, f) {
	                          var ne = e.length | 0;
	                          var nf = f.length | 0;
	                          if (ne === 1 && nf === 1) {
	                            return scalarScalar(e[0], -f[0]);
	                          }
	                          var n = ne + nf;
	                          var g = new Array(n);
	                          var count = 0;
	                          var eptr = 0;
	                          var fptr = 0;
	                          var abs = Math.abs;
	                          var ei = e[eptr];
	                          var ea = abs(ei);
	                          var fi = -f[fptr];
	                          var fa = abs(fi);
	                          var a, b;
	                          if (ea < fa) {
	                            b = ei;
	                            eptr += 1;
	                            if (eptr < ne) {
	                              ei = e[eptr];
	                              ea = abs(ei);
	                            }
	                          } else {
	                            b = fi;
	                            fptr += 1;
	                            if (fptr < nf) {
	                              fi = -f[fptr];
	                              fa = abs(fi);
	                            }
	                          }
	                          if (eptr < ne && ea < fa || fptr >= nf) {
	                            a = ei;
	                            eptr += 1;
	                            if (eptr < ne) {
	                              ei = e[eptr];
	                              ea = abs(ei);
	                            }
	                          } else {
	                            a = fi;
	                            fptr += 1;
	                            if (fptr < nf) {
	                              fi = -f[fptr];
	                              fa = abs(fi);
	                            }
	                          }
	                          var x = a + b;
	                          var bv = x - a;
	                          var y = b - bv;
	                          var q0 = y;
	                          var q1 = x;
	                          var _x, _bv, _av, _br, _ar;
	                          while (eptr < ne && fptr < nf) {
	                            if (ea < fa) {
	                              a = ei;
	                              eptr += 1;
	                              if (eptr < ne) {
	                                ei = e[eptr];
	                                ea = abs(ei);
	                              }
	                            } else {
	                              a = fi;
	                              fptr += 1;
	                              if (fptr < nf) {
	                                fi = -f[fptr];
	                                fa = abs(fi);
	                              }
	                            }
	                            b = q0;
	                            x = a + b;
	                            bv = x - a;
	                            y = b - bv;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                            _x = q1 + x;
	                            _bv = _x - q1;
	                            _av = _x - _bv;
	                            _br = x - _bv;
	                            _ar = q1 - _av;
	                            q0 = _ar + _br;
	                            q1 = _x;
	                          }
	                          while (eptr < ne) {
	                            a = ei;
	                            b = q0;
	                            x = a + b;
	                            bv = x - a;
	                            y = b - bv;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                            _x = q1 + x;
	                            _bv = _x - q1;
	                            _av = _x - _bv;
	                            _br = x - _bv;
	                            _ar = q1 - _av;
	                            q0 = _ar + _br;
	                            q1 = _x;
	                            eptr += 1;
	                            if (eptr < ne) {
	                              ei = e[eptr];
	                            }
	                          }
	                          while (fptr < nf) {
	                            a = fi;
	                            b = q0;
	                            x = a + b;
	                            bv = x - a;
	                            y = b - bv;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                            _x = q1 + x;
	                            _bv = _x - q1;
	                            _av = _x - _bv;
	                            _br = x - _bv;
	                            _ar = q1 - _av;
	                            q0 = _ar + _br;
	                            q1 = _x;
	                            fptr += 1;
	                            if (fptr < nf) {
	                              fi = -f[fptr];
	                            }
	                          }
	                          if (q0) {
	                            g[count++] = q0;
	                          }
	                          if (q1) {
	                            g[count++] = q1;
	                          }
	                          if (!count) {
	                            g[count++] = 0;
	                          }
	                          g.length = count;
	                          return g;
	                        }
	                      }
	                    ),
	                    /***/
	                    9662: (
	                      /***/
	                      function(module3) {
	                        module3.exports = linearExpansionSum;
	                        function scalarScalar(a, b) {
	                          var x = a + b;
	                          var bv = x - a;
	                          var av = x - bv;
	                          var br = b - bv;
	                          var ar = a - av;
	                          var y = ar + br;
	                          if (y) {
	                            return [y, x];
	                          }
	                          return [x];
	                        }
	                        function linearExpansionSum(e, f) {
	                          var ne = e.length | 0;
	                          var nf = f.length | 0;
	                          if (ne === 1 && nf === 1) {
	                            return scalarScalar(e[0], f[0]);
	                          }
	                          var n = ne + nf;
	                          var g = new Array(n);
	                          var count = 0;
	                          var eptr = 0;
	                          var fptr = 0;
	                          var abs = Math.abs;
	                          var ei = e[eptr];
	                          var ea = abs(ei);
	                          var fi = f[fptr];
	                          var fa = abs(fi);
	                          var a, b;
	                          if (ea < fa) {
	                            b = ei;
	                            eptr += 1;
	                            if (eptr < ne) {
	                              ei = e[eptr];
	                              ea = abs(ei);
	                            }
	                          } else {
	                            b = fi;
	                            fptr += 1;
	                            if (fptr < nf) {
	                              fi = f[fptr];
	                              fa = abs(fi);
	                            }
	                          }
	                          if (eptr < ne && ea < fa || fptr >= nf) {
	                            a = ei;
	                            eptr += 1;
	                            if (eptr < ne) {
	                              ei = e[eptr];
	                              ea = abs(ei);
	                            }
	                          } else {
	                            a = fi;
	                            fptr += 1;
	                            if (fptr < nf) {
	                              fi = f[fptr];
	                              fa = abs(fi);
	                            }
	                          }
	                          var x = a + b;
	                          var bv = x - a;
	                          var y = b - bv;
	                          var q0 = y;
	                          var q1 = x;
	                          var _x, _bv, _av, _br, _ar;
	                          while (eptr < ne && fptr < nf) {
	                            if (ea < fa) {
	                              a = ei;
	                              eptr += 1;
	                              if (eptr < ne) {
	                                ei = e[eptr];
	                                ea = abs(ei);
	                              }
	                            } else {
	                              a = fi;
	                              fptr += 1;
	                              if (fptr < nf) {
	                                fi = f[fptr];
	                                fa = abs(fi);
	                              }
	                            }
	                            b = q0;
	                            x = a + b;
	                            bv = x - a;
	                            y = b - bv;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                            _x = q1 + x;
	                            _bv = _x - q1;
	                            _av = _x - _bv;
	                            _br = x - _bv;
	                            _ar = q1 - _av;
	                            q0 = _ar + _br;
	                            q1 = _x;
	                          }
	                          while (eptr < ne) {
	                            a = ei;
	                            b = q0;
	                            x = a + b;
	                            bv = x - a;
	                            y = b - bv;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                            _x = q1 + x;
	                            _bv = _x - q1;
	                            _av = _x - _bv;
	                            _br = x - _bv;
	                            _ar = q1 - _av;
	                            q0 = _ar + _br;
	                            q1 = _x;
	                            eptr += 1;
	                            if (eptr < ne) {
	                              ei = e[eptr];
	                            }
	                          }
	                          while (fptr < nf) {
	                            a = fi;
	                            b = q0;
	                            x = a + b;
	                            bv = x - a;
	                            y = b - bv;
	                            if (y) {
	                              g[count++] = y;
	                            }
	                            _x = q1 + x;
	                            _bv = _x - q1;
	                            _av = _x - _bv;
	                            _br = x - _bv;
	                            _ar = q1 - _av;
	                            q0 = _ar + _br;
	                            q1 = _x;
	                            fptr += 1;
	                            if (fptr < nf) {
	                              fi = f[fptr];
	                            }
	                          }
	                          if (q0) {
	                            g[count++] = q0;
	                          }
	                          if (q1) {
	                            g[count++] = q1;
	                          }
	                          if (!count) {
	                            g[count++] = 0;
	                          }
	                          g.length = count;
	                          return g;
	                        }
	                      }
	                    ),
	                    /***/
	                    8691: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_790992__) {
	                        module3.exports = boundary;
	                        var bnd = __nested_webpack_require_790992__(2692);
	                        var reduce = __nested_webpack_require_790992__(7037);
	                        function boundary(cells) {
	                          return reduce(bnd(cells));
	                        }
	                      }
	                    ),
	                    /***/
	                    7212: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_791236__) {
	                        module3.exports = extractContour;
	                        var ndarray = __nested_webpack_require_791236__(5050);
	                        var pool = __nested_webpack_require_791236__(5306);
	                        var ndsort = __nested_webpack_require_791236__(8729);
	                        var contourAlgorithm = __nested_webpack_require_791236__(1168);
	                        function getDimension(cells) {
	                          var numCells = cells.length;
	                          var d = 0;
	                          for (var i = 0; i < numCells; ++i) {
	                            d = Math.max(d, cells[i].length) | 0;
	                          }
	                          return d - 1;
	                        }
	                        function getSigns(values, level) {
	                          var numVerts = values.length;
	                          var vertexSigns = pool.mallocUint8(numVerts);
	                          for (var i = 0; i < numVerts; ++i) {
	                            vertexSigns[i] = values[i] < level | 0;
	                          }
	                          return vertexSigns;
	                        }
	                        function getEdges(cells, d) {
	                          var numCells = cells.length;
	                          var maxEdges = d * (d + 1) / 2 * numCells | 0;
	                          var edges = pool.mallocUint32(maxEdges * 2);
	                          var ePtr = 0;
	                          for (var i = 0; i < numCells; ++i) {
	                            var c = cells[i];
	                            var d = c.length;
	                            for (var j = 0; j < d; ++j) {
	                              for (var k = 0; k < j; ++k) {
	                                var a = c[k];
	                                var b = c[j];
	                                edges[ePtr++] = Math.min(a, b) | 0;
	                                edges[ePtr++] = Math.max(a, b) | 0;
	                              }
	                            }
	                          }
	                          var nedges = ePtr / 2 | 0;
	                          ndsort(ndarray(edges, [nedges, 2]));
	                          var ptr = 2;
	                          for (var i = 2; i < ePtr; i += 2) {
	                            if (edges[i - 2] === edges[i] && edges[i - 1] === edges[i + 1]) {
	                              continue;
	                            }
	                            edges[ptr++] = edges[i];
	                            edges[ptr++] = edges[i + 1];
	                          }
	                          return ndarray(edges, [ptr / 2 | 0, 2]);
	                        }
	                        function getCrossingWeights(edges, values, signs, level) {
	                          var edata = edges.data;
	                          var numEdges = edges.shape[0];
	                          var weights = pool.mallocDouble(numEdges);
	                          var ptr = 0;
	                          for (var i = 0; i < numEdges; ++i) {
	                            var a = edata[2 * i];
	                            var b = edata[2 * i + 1];
	                            if (signs[a] === signs[b]) {
	                              continue;
	                            }
	                            var va = values[a];
	                            var vb = values[b];
	                            edata[2 * ptr] = a;
	                            edata[2 * ptr + 1] = b;
	                            weights[ptr++] = (vb - level) / (vb - va);
	                          }
	                          edges.shape[0] = ptr;
	                          return ndarray(weights, [ptr]);
	                        }
	                        function getCascade(edges, numVerts) {
	                          var result = pool.mallocInt32(numVerts * 2);
	                          var numEdges = edges.shape[0];
	                          var edata = edges.data;
	                          result[0] = 0;
	                          var lastV = 0;
	                          for (var i = 0; i < numEdges; ++i) {
	                            var a = edata[2 * i];
	                            if (a !== lastV) {
	                              result[2 * lastV + 1] = i;
	                              while (++lastV < a) {
	                                result[2 * lastV] = i;
	                                result[2 * lastV + 1] = i;
	                              }
	                              result[2 * lastV] = i;
	                            }
	                          }
	                          result[2 * lastV + 1] = numEdges;
	                          while (++lastV < numVerts) {
	                            result[2 * lastV] = result[2 * lastV + 1] = numEdges;
	                          }
	                          return result;
	                        }
	                        function unpackEdges(edges) {
	                          var ne = edges.shape[0] | 0;
	                          var edata = edges.data;
	                          var result = new Array(ne);
	                          for (var i = 0; i < ne; ++i) {
	                            result[i] = [edata[2 * i], edata[2 * i + 1]];
	                          }
	                          return result;
	                        }
	                        function extractContour(cells, values, level, d) {
	                          level = level || 0;
	                          if (typeof d === "undefined") {
	                            d = getDimension(cells);
	                          }
	                          var numCells = cells.length;
	                          if (numCells === 0 || d < 1) {
	                            return { cells: [], vertexIds: [], vertexWeights: [] };
	                          }
	                          var vertexSigns = getSigns(values, +level);
	                          var edges = getEdges(cells, d);
	                          var weights = getCrossingWeights(edges, values, vertexSigns, +level);
	                          var vcascade = getCascade(edges, values.length | 0);
	                          var faces = contourAlgorithm(d)(cells, edges.data, vcascade, vertexSigns);
	                          var uedges = unpackEdges(edges);
	                          var uweights = [].slice.call(weights.data, 0, weights.shape[0]);
	                          pool.free(vertexSigns);
	                          pool.free(edges.data);
	                          pool.free(weights.data);
	                          pool.free(vcascade);
	                          return { cells: faces, vertexIds: uedges, vertexWeights: uweights };
	                        }
	                      }
	                    ),
	                    /***/
	                    1168: (
	                      /***/
	                      function(module3) {
	                        module3.exports = getPolygonizer;
	                        var allFns = [function cellPolygonizer_0() {
	                          function getContour0d(F, E, C, S) {
	                            var n = F.length, R = [];
	                            for (var i = 0; i < n; ++i) {
	                              var c = F[i]; c.length;
	                            }
	                            return R;
	                          }
	                          return getContour0d;
	                        }, function cellPolygonizer_1() {
	                          function B(C, E, i, j) {
	                            var a = Math.min(i, j) | 0, b = Math.max(i, j) | 0, l = C[2 * a], h = C[2 * a + 1];
	                            while (l < h) {
	                              var m = l + h >> 1, v = E[2 * m + 1];
	                              if (v === b) {
	                                return m;
	                              }
	                              if (b < v) {
	                                h = m;
	                              } else {
	                                l = m + 1;
	                              }
	                            }
	                            return l;
	                          }
	                          function getContour1d(F, E, C, S) {
	                            var n = F.length, R = [];
	                            for (var i = 0; i < n; ++i) {
	                              var c = F[i], l = c.length;
	                              if (l === 2) {
	                                var M = (S[c[0]] << 0) + (S[c[1]] << 1);
	                                if (M === 0 || M === 3) {
	                                  continue;
	                                }
	                                switch (M) {
	                                  case 0:
	                                    break;
	                                  case 1:
	                                    R.push([B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 2:
	                                    R.push([B(C, E, c[1], c[0])]);
	                                    break;
	                                }
	                              }
	                            }
	                            return R;
	                          }
	                          return getContour1d;
	                        }, function cellPolygonizer_2() {
	                          function B(C, E, i, j) {
	                            var a = Math.min(i, j) | 0, b = Math.max(i, j) | 0, l = C[2 * a], h = C[2 * a + 1];
	                            while (l < h) {
	                              var m = l + h >> 1, v = E[2 * m + 1];
	                              if (v === b) {
	                                return m;
	                              }
	                              if (b < v) {
	                                h = m;
	                              } else {
	                                l = m + 1;
	                              }
	                            }
	                            return l;
	                          }
	                          function getContour2d(F, E, C, S) {
	                            var n = F.length, R = [];
	                            for (var i = 0; i < n; ++i) {
	                              var c = F[i], l = c.length;
	                              if (l === 3) {
	                                var M = (S[c[0]] << 0) + (S[c[1]] << 1) + (S[c[2]] << 2);
	                                if (M === 0 || M === 7) {
	                                  continue;
	                                }
	                                switch (M) {
	                                  case 0:
	                                    break;
	                                  case 1:
	                                    R.push([B(C, E, c[0], c[2]), B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 2:
	                                    R.push([B(C, E, c[1], c[0]), B(C, E, c[1], c[2])]);
	                                    break;
	                                  case 3:
	                                    R.push([B(C, E, c[0], c[2]), B(C, E, c[1], c[2])]);
	                                    break;
	                                  case 4:
	                                    R.push([B(C, E, c[2], c[1]), B(C, E, c[2], c[0])]);
	                                    break;
	                                  case 5:
	                                    R.push([B(C, E, c[2], c[1]), B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 6:
	                                    R.push([B(C, E, c[1], c[0]), B(C, E, c[2], c[0])]);
	                                    break;
	                                }
	                              } else if (l === 2) {
	                                var M = (S[c[0]] << 0) + (S[c[1]] << 1);
	                                if (M === 0 || M === 3) {
	                                  continue;
	                                }
	                                switch (M) {
	                                  case 0:
	                                    break;
	                                  case 1:
	                                    R.push([B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 2:
	                                    R.push([B(C, E, c[1], c[0])]);
	                                    break;
	                                }
	                              }
	                            }
	                            return R;
	                          }
	                          return getContour2d;
	                        }, function cellPolygonizer_3() {
	                          function B(C, E, i, j) {
	                            var a = Math.min(i, j) | 0, b = Math.max(i, j) | 0, l = C[2 * a], h = C[2 * a + 1];
	                            while (l < h) {
	                              var m = l + h >> 1, v = E[2 * m + 1];
	                              if (v === b) {
	                                return m;
	                              }
	                              if (b < v) {
	                                h = m;
	                              } else {
	                                l = m + 1;
	                              }
	                            }
	                            return l;
	                          }
	                          function getContour3d(F, E, C, S) {
	                            var n = F.length, R = [];
	                            for (var i = 0; i < n; ++i) {
	                              var c = F[i], l = c.length;
	                              if (l === 4) {
	                                var M = (S[c[0]] << 0) + (S[c[1]] << 1) + (S[c[2]] << 2) + (S[c[3]] << 3);
	                                if (M === 0 || M === 15) {
	                                  continue;
	                                }
	                                switch (M) {
	                                  case 0:
	                                    break;
	                                  case 1:
	                                    R.push([B(C, E, c[0], c[1]), B(C, E, c[0], c[2]), B(C, E, c[0], c[3])]);
	                                    break;
	                                  case 2:
	                                    R.push([B(C, E, c[1], c[2]), B(C, E, c[1], c[0]), B(C, E, c[1], c[3])]);
	                                    break;
	                                  case 3:
	                                    R.push([B(C, E, c[1], c[2]), B(C, E, c[0], c[2]), B(C, E, c[0], c[3])], [B(C, E, c[1], c[3]), B(C, E, c[1], c[2]), B(C, E, c[0], c[3])]);
	                                    break;
	                                  case 4:
	                                    R.push([B(C, E, c[2], c[0]), B(C, E, c[2], c[1]), B(C, E, c[2], c[3])]);
	                                    break;
	                                  case 5:
	                                    R.push([B(C, E, c[0], c[1]), B(C, E, c[2], c[1]), B(C, E, c[0], c[3])], [B(C, E, c[2], c[1]), B(C, E, c[2], c[3]), B(C, E, c[0], c[3])]);
	                                    break;
	                                  case 6:
	                                    R.push([B(C, E, c[2], c[0]), B(C, E, c[1], c[0]), B(C, E, c[1], c[3])], [B(C, E, c[2], c[3]), B(C, E, c[2], c[0]), B(C, E, c[1], c[3])]);
	                                    break;
	                                  case 7:
	                                    R.push([B(C, E, c[0], c[3]), B(C, E, c[1], c[3]), B(C, E, c[2], c[3])]);
	                                    break;
	                                  case 8:
	                                    R.push([B(C, E, c[3], c[1]), B(C, E, c[3], c[0]), B(C, E, c[3], c[2])]);
	                                    break;
	                                  case 9:
	                                    R.push([B(C, E, c[3], c[1]), B(C, E, c[0], c[1]), B(C, E, c[0], c[2])], [B(C, E, c[3], c[2]), B(C, E, c[3], c[1]), B(C, E, c[0], c[2])]);
	                                    break;
	                                  case 10:
	                                    R.push([B(C, E, c[1], c[0]), B(C, E, c[3], c[0]), B(C, E, c[1], c[2])], [B(C, E, c[3], c[0]), B(C, E, c[3], c[2]), B(C, E, c[1], c[2])]);
	                                    break;
	                                  case 11:
	                                    R.push([B(C, E, c[1], c[2]), B(C, E, c[0], c[2]), B(C, E, c[3], c[2])]);
	                                    break;
	                                  case 12:
	                                    R.push([B(C, E, c[3], c[0]), B(C, E, c[2], c[0]), B(C, E, c[2], c[1])], [B(C, E, c[3], c[1]), B(C, E, c[3], c[0]), B(C, E, c[2], c[1])]);
	                                    break;
	                                  case 13:
	                                    R.push([B(C, E, c[0], c[1]), B(C, E, c[2], c[1]), B(C, E, c[3], c[1])]);
	                                    break;
	                                  case 14:
	                                    R.push([B(C, E, c[2], c[0]), B(C, E, c[1], c[0]), B(C, E, c[3], c[0])]);
	                                    break;
	                                }
	                              } else if (l === 3) {
	                                var M = (S[c[0]] << 0) + (S[c[1]] << 1) + (S[c[2]] << 2);
	                                if (M === 0 || M === 7) {
	                                  continue;
	                                }
	                                switch (M) {
	                                  case 0:
	                                    break;
	                                  case 1:
	                                    R.push([B(C, E, c[0], c[2]), B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 2:
	                                    R.push([B(C, E, c[1], c[0]), B(C, E, c[1], c[2])]);
	                                    break;
	                                  case 3:
	                                    R.push([B(C, E, c[0], c[2]), B(C, E, c[1], c[2])]);
	                                    break;
	                                  case 4:
	                                    R.push([B(C, E, c[2], c[1]), B(C, E, c[2], c[0])]);
	                                    break;
	                                  case 5:
	                                    R.push([B(C, E, c[2], c[1]), B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 6:
	                                    R.push([B(C, E, c[1], c[0]), B(C, E, c[2], c[0])]);
	                                    break;
	                                }
	                              } else if (l === 2) {
	                                var M = (S[c[0]] << 0) + (S[c[1]] << 1);
	                                if (M === 0 || M === 3) {
	                                  continue;
	                                }
	                                switch (M) {
	                                  case 0:
	                                    break;
	                                  case 1:
	                                    R.push([B(C, E, c[0], c[1])]);
	                                    break;
	                                  case 2:
	                                    R.push([B(C, E, c[1], c[0])]);
	                                    break;
	                                }
	                              }
	                            }
	                            return R;
	                          }
	                          return getContour3d;
	                        }];
	                        function getPolygonizer(d) {
	                          return allFns[d]();
	                        }
	                      }
	                    ),
	                    /***/
	                    8211: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_798785__) {
	                        __nested_webpack_require_798785__(2288); __nested_webpack_require_798785__(1731);
	                        function compareCells(a, b) {
	                          var n = a.length, t = a.length - b.length, min = Math.min;
	                          if (t) {
	                            return t;
	                          }
	                          switch (n) {
	                            case 0:
	                              return 0;
	                            case 1:
	                              return a[0] - b[0];
	                            case 2:
	                              var d = a[0] + a[1] - b[0] - b[1];
	                              if (d) {
	                                return d;
	                              }
	                              return min(a[0], a[1]) - min(b[0], b[1]);
	                            case 3:
	                              var l1 = a[0] + a[1], m1 = b[0] + b[1];
	                              d = l1 + a[2] - (m1 + b[2]);
	                              if (d) {
	                                return d;
	                              }
	                              var l0 = min(a[0], a[1]), m0 = min(b[0], b[1]), d = min(l0, a[2]) - min(m0, b[2]);
	                              if (d) {
	                                return d;
	                              }
	                              return min(l0 + a[2], l1) - min(m0 + b[2], m1);
	                            default:
	                              var as = a.slice(0);
	                              as.sort();
	                              var bs = b.slice(0);
	                              bs.sort();
	                              for (var i = 0; i < n; ++i) {
	                                t = as[i] - bs[i];
	                                if (t) {
	                                  return t;
	                                }
	                              }
	                              return 0;
	                          }
	                        }
	                        exports2.H = compareCells;
	                      }
	                    ),
	                    /***/
	                    9392: (
	                      /***/
	                      function(__unused_webpack_module, exports2) {
	                        "use restrict";
	                        var INT_BITS = 32;
	                        exports2.INT_BITS = INT_BITS;
	                        exports2.INT_MAX = 2147483647;
	                        exports2.INT_MIN = -1 << INT_BITS - 1;
	                        exports2.sign = function(v) {
	                          return (v > 0) - (v < 0);
	                        };
	                        exports2.abs = function(v) {
	                          var mask = v >> INT_BITS - 1;
	                          return (v ^ mask) - mask;
	                        };
	                        exports2.min = function(x, y) {
	                          return y ^ (x ^ y) & -(x < y);
	                        };
	                        exports2.max = function(x, y) {
	                          return x ^ (x ^ y) & -(x < y);
	                        };
	                        exports2.isPow2 = function(v) {
	                          return !(v & v - 1) && !!v;
	                        };
	                        exports2.log2 = function(v) {
	                          var r, shift;
	                          r = (v > 65535) << 4;
	                          v >>>= r;
	                          shift = (v > 255) << 3;
	                          v >>>= shift;
	                          r |= shift;
	                          shift = (v > 15) << 2;
	                          v >>>= shift;
	                          r |= shift;
	                          shift = (v > 3) << 1;
	                          v >>>= shift;
	                          r |= shift;
	                          return r | v >> 1;
	                        };
	                        exports2.log10 = function(v) {
	                          return v >= 1e9 ? 9 : v >= 1e8 ? 8 : v >= 1e7 ? 7 : v >= 1e6 ? 6 : v >= 1e5 ? 5 : v >= 1e4 ? 4 : v >= 1e3 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
	                        };
	                        exports2.popCount = function(v) {
	                          v = v - (v >>> 1 & 1431655765);
	                          v = (v & 858993459) + (v >>> 2 & 858993459);
	                          return (v + (v >>> 4) & 252645135) * 16843009 >>> 24;
	                        };
	                        function countTrailingZeros(v) {
	                          var c = 32;
	                          v &= -v;
	                          if (v) c--;
	                          if (v & 65535) c -= 16;
	                          if (v & 16711935) c -= 8;
	                          if (v & 252645135) c -= 4;
	                          if (v & 858993459) c -= 2;
	                          if (v & 1431655765) c -= 1;
	                          return c;
	                        }
	                        exports2.countTrailingZeros = countTrailingZeros;
	                        exports2.nextPow2 = function(v) {
	                          v += v === 0;
	                          --v;
	                          v |= v >>> 1;
	                          v |= v >>> 2;
	                          v |= v >>> 4;
	                          v |= v >>> 8;
	                          v |= v >>> 16;
	                          return v + 1;
	                        };
	                        exports2.prevPow2 = function(v) {
	                          v |= v >>> 1;
	                          v |= v >>> 2;
	                          v |= v >>> 4;
	                          v |= v >>> 8;
	                          v |= v >>> 16;
	                          return v - (v >>> 1);
	                        };
	                        exports2.parity = function(v) {
	                          v ^= v >>> 16;
	                          v ^= v >>> 8;
	                          v ^= v >>> 4;
	                          v &= 15;
	                          return 27030 >>> v & 1;
	                        };
	                        var REVERSE_TABLE = new Array(256);
	                        (function(tab) {
	                          for (var i = 0; i < 256; ++i) {
	                            var v = i, r = i, s = 7;
	                            for (v >>>= 1; v; v >>>= 1) {
	                              r <<= 1;
	                              r |= v & 1;
	                              --s;
	                            }
	                            tab[i] = r << s & 255;
	                          }
	                        })(REVERSE_TABLE);
	                        exports2.reverse = function(v) {
	                          return REVERSE_TABLE[v & 255] << 24 | REVERSE_TABLE[v >>> 8 & 255] << 16 | REVERSE_TABLE[v >>> 16 & 255] << 8 | REVERSE_TABLE[v >>> 24 & 255];
	                        };
	                        exports2.interleave2 = function(x, y) {
	                          x &= 65535;
	                          x = (x | x << 8) & 16711935;
	                          x = (x | x << 4) & 252645135;
	                          x = (x | x << 2) & 858993459;
	                          x = (x | x << 1) & 1431655765;
	                          y &= 65535;
	                          y = (y | y << 8) & 16711935;
	                          y = (y | y << 4) & 252645135;
	                          y = (y | y << 2) & 858993459;
	                          y = (y | y << 1) & 1431655765;
	                          return x | y << 1;
	                        };
	                        exports2.deinterleave2 = function(v, n) {
	                          v = v >>> n & 1431655765;
	                          v = (v | v >>> 1) & 858993459;
	                          v = (v | v >>> 2) & 252645135;
	                          v = (v | v >>> 4) & 16711935;
	                          v = (v | v >>> 16) & 65535;
	                          return v << 16 >> 16;
	                        };
	                        exports2.interleave3 = function(x, y, z) {
	                          x &= 1023;
	                          x = (x | x << 16) & 4278190335;
	                          x = (x | x << 8) & 251719695;
	                          x = (x | x << 4) & 3272356035;
	                          x = (x | x << 2) & 1227133513;
	                          y &= 1023;
	                          y = (y | y << 16) & 4278190335;
	                          y = (y | y << 8) & 251719695;
	                          y = (y | y << 4) & 3272356035;
	                          y = (y | y << 2) & 1227133513;
	                          x |= y << 1;
	                          z &= 1023;
	                          z = (z | z << 16) & 4278190335;
	                          z = (z | z << 8) & 251719695;
	                          z = (z | z << 4) & 3272356035;
	                          z = (z | z << 2) & 1227133513;
	                          return x | z << 2;
	                        };
	                        exports2.deinterleave3 = function(v, n) {
	                          v = v >>> n & 1227133513;
	                          v = (v | v >>> 2) & 3272356035;
	                          v = (v | v >>> 4) & 251719695;
	                          v = (v | v >>> 8) & 4278190335;
	                          v = (v | v >>> 16) & 1023;
	                          return v << 22 >> 22;
	                        };
	                        exports2.nextCombination = function(v) {
	                          var t = v | v - 1;
	                          return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
	                        };
	                      }
	                    ),
	                    /***/
	                    6656: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_808931__) {
	                        "use restrict";
	                        var bits = __nested_webpack_require_808931__(9392), UnionFind = __nested_webpack_require_808931__(9521);
	                        function dimension(cells) {
	                          var d = 0, max = Math.max;
	                          for (var i = 0, il = cells.length; i < il; ++i) {
	                            d = max(d, cells[i].length);
	                          }
	                          return d - 1;
	                        }
	                        exports2.dimension = dimension;
	                        function countVertices(cells) {
	                          var vc = -1, max = Math.max;
	                          for (var i = 0, il = cells.length; i < il; ++i) {
	                            var c = cells[i];
	                            for (var j = 0, jl = c.length; j < jl; ++j) {
	                              vc = max(vc, c[j]);
	                            }
	                          }
	                          return vc + 1;
	                        }
	                        exports2.countVertices = countVertices;
	                        function cloneCells(cells) {
	                          var ncells = new Array(cells.length);
	                          for (var i = 0, il = cells.length; i < il; ++i) {
	                            ncells[i] = cells[i].slice(0);
	                          }
	                          return ncells;
	                        }
	                        exports2.cloneCells = cloneCells;
	                        function compareCells(a, b) {
	                          var n = a.length, t = a.length - b.length, min = Math.min;
	                          if (t) {
	                            return t;
	                          }
	                          switch (n) {
	                            case 0:
	                              return 0;
	                            case 1:
	                              return a[0] - b[0];
	                            case 2:
	                              var d = a[0] + a[1] - b[0] - b[1];
	                              if (d) {
	                                return d;
	                              }
	                              return min(a[0], a[1]) - min(b[0], b[1]);
	                            case 3:
	                              var l1 = a[0] + a[1], m1 = b[0] + b[1];
	                              d = l1 + a[2] - (m1 + b[2]);
	                              if (d) {
	                                return d;
	                              }
	                              var l0 = min(a[0], a[1]), m0 = min(b[0], b[1]), d = min(l0, a[2]) - min(m0, b[2]);
	                              if (d) {
	                                return d;
	                              }
	                              return min(l0 + a[2], l1) - min(m0 + b[2], m1);
	                            default:
	                              var as = a.slice(0);
	                              as.sort();
	                              var bs = b.slice(0);
	                              bs.sort();
	                              for (var i = 0; i < n; ++i) {
	                                t = as[i] - bs[i];
	                                if (t) {
	                                  return t;
	                                }
	                              }
	                              return 0;
	                          }
	                        }
	                        exports2.compareCells = compareCells;
	                        function compareZipped(a, b) {
	                          return compareCells(a[0], b[0]);
	                        }
	                        function normalize(cells, attr) {
	                          if (attr) {
	                            var len = cells.length;
	                            var zipped = new Array(len);
	                            for (var i = 0; i < len; ++i) {
	                              zipped[i] = [cells[i], attr[i]];
	                            }
	                            zipped.sort(compareZipped);
	                            for (var i = 0; i < len; ++i) {
	                              cells[i] = zipped[i][0];
	                              attr[i] = zipped[i][1];
	                            }
	                            return cells;
	                          } else {
	                            cells.sort(compareCells);
	                            return cells;
	                          }
	                        }
	                        exports2.normalize = normalize;
	                        function unique(cells) {
	                          if (cells.length === 0) {
	                            return [];
	                          }
	                          var ptr = 1, len = cells.length;
	                          for (var i = 1; i < len; ++i) {
	                            var a = cells[i];
	                            if (compareCells(a, cells[i - 1])) {
	                              if (i === ptr) {
	                                ptr++;
	                                continue;
	                              }
	                              cells[ptr++] = a;
	                            }
	                          }
	                          cells.length = ptr;
	                          return cells;
	                        }
	                        exports2.unique = unique;
	                        function findCell(cells, c) {
	                          var lo = 0, hi = cells.length - 1, r = -1;
	                          while (lo <= hi) {
	                            var mid = lo + hi >> 1, s = compareCells(cells[mid], c);
	                            if (s <= 0) {
	                              if (s === 0) {
	                                r = mid;
	                              }
	                              lo = mid + 1;
	                            } else if (s > 0) {
	                              hi = mid - 1;
	                            }
	                          }
	                          return r;
	                        }
	                        exports2.findCell = findCell;
	                        function incidence(from_cells, to_cells) {
	                          var index = new Array(from_cells.length);
	                          for (var i = 0, il = index.length; i < il; ++i) {
	                            index[i] = [];
	                          }
	                          var b = [];
	                          for (var i = 0, n = to_cells.length; i < n; ++i) {
	                            var c = to_cells[i];
	                            var cl = c.length;
	                            for (var k = 1, kn = 1 << cl; k < kn; ++k) {
	                              b.length = bits.popCount(k);
	                              var l = 0;
	                              for (var j = 0; j < cl; ++j) {
	                                if (k & 1 << j) {
	                                  b[l++] = c[j];
	                                }
	                              }
	                              var idx = findCell(from_cells, b);
	                              if (idx < 0) {
	                                continue;
	                              }
	                              while (true) {
	                                index[idx++].push(i);
	                                if (idx >= from_cells.length || compareCells(from_cells[idx], b) !== 0) {
	                                  break;
	                                }
	                              }
	                            }
	                          }
	                          return index;
	                        }
	                        exports2.incidence = incidence;
	                        function dual(cells, vertex_count) {
	                          if (!vertex_count) {
	                            return incidence(unique(skeleton(cells, 0)), cells);
	                          }
	                          var res = new Array(vertex_count);
	                          for (var i = 0; i < vertex_count; ++i) {
	                            res[i] = [];
	                          }
	                          for (var i = 0, len = cells.length; i < len; ++i) {
	                            var c = cells[i];
	                            for (var j = 0, cl = c.length; j < cl; ++j) {
	                              res[c[j]].push(i);
	                            }
	                          }
	                          return res;
	                        }
	                        exports2.dual = dual;
	                        function explode(cells) {
	                          var result = [];
	                          for (var i = 0, il = cells.length; i < il; ++i) {
	                            var c = cells[i], cl = c.length | 0;
	                            for (var j = 1, jl = 1 << cl; j < jl; ++j) {
	                              var b = [];
	                              for (var k = 0; k < cl; ++k) {
	                                if (j >>> k & 1) {
	                                  b.push(c[k]);
	                                }
	                              }
	                              result.push(b);
	                            }
	                          }
	                          return normalize(result);
	                        }
	                        exports2.explode = explode;
	                        function skeleton(cells, n) {
	                          if (n < 0) {
	                            return [];
	                          }
	                          var result = [], k0 = (1 << n + 1) - 1;
	                          for (var i = 0; i < cells.length; ++i) {
	                            var c = cells[i];
	                            for (var k = k0; k < 1 << c.length; k = bits.nextCombination(k)) {
	                              var b = new Array(n + 1), l = 0;
	                              for (var j = 0; j < c.length; ++j) {
	                                if (k & 1 << j) {
	                                  b[l++] = c[j];
	                                }
	                              }
	                              result.push(b);
	                            }
	                          }
	                          return normalize(result);
	                        }
	                        exports2.skeleton = skeleton;
	                        function boundary(cells) {
	                          var res = [];
	                          for (var i = 0, il = cells.length; i < il; ++i) {
	                            var c = cells[i];
	                            for (var j = 0, cl = c.length; j < cl; ++j) {
	                              var b = new Array(c.length - 1);
	                              for (var k = 0, l = 0; k < cl; ++k) {
	                                if (k !== j) {
	                                  b[l++] = c[k];
	                                }
	                              }
	                              res.push(b);
	                            }
	                          }
	                          return normalize(res);
	                        }
	                        exports2.boundary = boundary;
	                        function connectedComponents_dense(cells, vertex_count) {
	                          var labels = new UnionFind(vertex_count);
	                          for (var i = 0; i < cells.length; ++i) {
	                            var c = cells[i];
	                            for (var j = 0; j < c.length; ++j) {
	                              for (var k = j + 1; k < c.length; ++k) {
	                                labels.link(c[j], c[k]);
	                              }
	                            }
	                          }
	                          var components = [], component_labels = labels.ranks;
	                          for (var i = 0; i < component_labels.length; ++i) {
	                            component_labels[i] = -1;
	                          }
	                          for (var i = 0; i < cells.length; ++i) {
	                            var l = labels.find(cells[i][0]);
	                            if (component_labels[l] < 0) {
	                              component_labels[l] = components.length;
	                              components.push([cells[i].slice(0)]);
	                            } else {
	                              components[component_labels[l]].push(cells[i].slice(0));
	                            }
	                          }
	                          return components;
	                        }
	                        function connectedComponents_sparse(cells) {
	                          var vertices = unique(normalize(skeleton(cells, 0))), labels = new UnionFind(vertices.length);
	                          for (var i = 0; i < cells.length; ++i) {
	                            var c = cells[i];
	                            for (var j = 0; j < c.length; ++j) {
	                              var vj = findCell(vertices, [c[j]]);
	                              for (var k = j + 1; k < c.length; ++k) {
	                                labels.link(vj, findCell(vertices, [c[k]]));
	                              }
	                            }
	                          }
	                          var components = [], component_labels = labels.ranks;
	                          for (var i = 0; i < component_labels.length; ++i) {
	                            component_labels[i] = -1;
	                          }
	                          for (var i = 0; i < cells.length; ++i) {
	                            var l = labels.find(findCell(vertices, [cells[i][0]]));
	                            if (component_labels[l] < 0) {
	                              component_labels[l] = components.length;
	                              components.push([cells[i].slice(0)]);
	                            } else {
	                              components[component_labels[l]].push(cells[i].slice(0));
	                            }
	                          }
	                          return components;
	                        }
	                        function connectedComponents(cells, vertex_count) {
	                          if (vertex_count) {
	                            return connectedComponents_dense(cells, vertex_count);
	                          }
	                          return connectedComponents_sparse(cells);
	                        }
	                        exports2.connectedComponents = connectedComponents;
	                      }
	                    ),
	                    /***/
	                    9521: (
	                      /***/
	                      function(module3) {
	                        "use restrict";
	                        module3.exports = UnionFind;
	                        function UnionFind(count) {
	                          this.roots = new Array(count);
	                          this.ranks = new Array(count);
	                          for (var i = 0; i < count; ++i) {
	                            this.roots[i] = i;
	                            this.ranks[i] = 0;
	                          }
	                        }
	                        UnionFind.prototype.length = function() {
	                          return this.roots.length;
	                        };
	                        UnionFind.prototype.makeSet = function() {
	                          var n = this.roots.length;
	                          this.roots.push(n);
	                          this.ranks.push(0);
	                          return n;
	                        };
	                        UnionFind.prototype.find = function(x) {
	                          var roots = this.roots;
	                          while (roots[x] !== x) {
	                            var y = roots[x];
	                            roots[x] = roots[y];
	                            x = y;
	                          }
	                          return x;
	                        };
	                        UnionFind.prototype.link = function(x, y) {
	                          var xr = this.find(x), yr = this.find(y);
	                          if (xr === yr) {
	                            return;
	                          }
	                          var ranks = this.ranks, roots = this.roots, xd = ranks[xr], yd = ranks[yr];
	                          if (xd < yd) {
	                            roots[xr] = yr;
	                          } else if (yd < xd) {
	                            roots[yr] = xr;
	                          } else {
	                            roots[yr] = xr;
	                            ++ranks[xr];
	                          }
	                        };
	                      }
	                    ),
	                    /***/
	                    8243: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_815945__) {
	                        module3.exports = simplifyPolygon;
	                        var orient = __nested_webpack_require_815945__(417);
	                        var sc = __nested_webpack_require_815945__(6656);
	                        function errorWeight(base, a, b) {
	                          var area = Math.abs(orient(base, a, b));
	                          var perim = Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2));
	                          return area / perim;
	                        }
	                        function simplifyPolygon(cells, positions, minArea) {
	                          var n = positions.length;
	                          var nc = cells.length;
	                          var inv = new Array(n);
	                          var outv = new Array(n);
	                          var weights = new Array(n);
	                          var dead = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            inv[i] = outv[i] = -1;
	                            weights[i] = Infinity;
	                            dead[i] = false;
	                          }
	                          for (var i = 0; i < nc; ++i) {
	                            var c = cells[i];
	                            if (c.length !== 2) {
	                              throw new Error("Input must be a graph");
	                            }
	                            var s = c[1];
	                            var t = c[0];
	                            if (outv[t] !== -1) {
	                              outv[t] = -2;
	                            } else {
	                              outv[t] = s;
	                            }
	                            if (inv[s] !== -1) {
	                              inv[s] = -2;
	                            } else {
	                              inv[s] = t;
	                            }
	                          }
	                          function computeWeight(i2) {
	                            if (dead[i2]) {
	                              return Infinity;
	                            }
	                            var s2 = inv[i2];
	                            var t2 = outv[i2];
	                            if (s2 < 0 || t2 < 0) {
	                              return Infinity;
	                            } else {
	                              return errorWeight(positions[i2], positions[s2], positions[t2]);
	                            }
	                          }
	                          function heapSwap(i2, j) {
	                            var a = heap[i2];
	                            var b = heap[j];
	                            heap[i2] = b;
	                            heap[j] = a;
	                            index[a] = j;
	                            index[b] = i2;
	                          }
	                          function heapWeight(i2) {
	                            return weights[heap[i2]];
	                          }
	                          function heapParent(i2) {
	                            if (i2 & 1) {
	                              return i2 - 1 >> 1;
	                            }
	                            return (i2 >> 1) - 1;
	                          }
	                          function heapDown(i2) {
	                            var w2 = heapWeight(i2);
	                            while (true) {
	                              var tw = w2;
	                              var left = 2 * i2 + 1;
	                              var right = 2 * (i2 + 1);
	                              var next = i2;
	                              if (left < heapCount) {
	                                var lw = heapWeight(left);
	                                if (lw < tw) {
	                                  next = left;
	                                  tw = lw;
	                                }
	                              }
	                              if (right < heapCount) {
	                                var rw = heapWeight(right);
	                                if (rw < tw) {
	                                  next = right;
	                                }
	                              }
	                              if (next === i2) {
	                                return i2;
	                              }
	                              heapSwap(i2, next);
	                              i2 = next;
	                            }
	                          }
	                          function heapUp(i2) {
	                            var w2 = heapWeight(i2);
	                            while (i2 > 0) {
	                              var parent = heapParent(i2);
	                              if (parent >= 0) {
	                                var pw = heapWeight(parent);
	                                if (w2 < pw) {
	                                  heapSwap(i2, parent);
	                                  i2 = parent;
	                                  continue;
	                                }
	                              }
	                              return i2;
	                            }
	                          }
	                          function heapPop() {
	                            if (heapCount > 0) {
	                              var head = heap[0];
	                              heapSwap(0, heapCount - 1);
	                              heapCount -= 1;
	                              heapDown(0);
	                              return head;
	                            }
	                            return -1;
	                          }
	                          function heapUpdate(i2, w2) {
	                            var a = heap[i2];
	                            if (weights[a] === w2) {
	                              return i2;
	                            }
	                            weights[a] = -Infinity;
	                            heapUp(i2);
	                            heapPop();
	                            weights[a] = w2;
	                            heapCount += 1;
	                            return heapUp(heapCount - 1);
	                          }
	                          function kill(i2) {
	                            if (dead[i2]) {
	                              return;
	                            }
	                            dead[i2] = true;
	                            var s2 = inv[i2];
	                            var t2 = outv[i2];
	                            if (inv[t2] >= 0) {
	                              inv[t2] = s2;
	                            }
	                            if (outv[s2] >= 0) {
	                              outv[s2] = t2;
	                            }
	                            if (index[s2] >= 0) {
	                              heapUpdate(index[s2], computeWeight(s2));
	                            }
	                            if (index[t2] >= 0) {
	                              heapUpdate(index[t2], computeWeight(t2));
	                            }
	                          }
	                          var heap = [];
	                          var index = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            var w = weights[i] = computeWeight(i);
	                            if (w < Infinity) {
	                              index[i] = heap.length;
	                              heap.push(i);
	                            } else {
	                              index[i] = -1;
	                            }
	                          }
	                          var heapCount = heap.length;
	                          for (var i = heapCount >> 1; i >= 0; --i) {
	                            heapDown(i);
	                          }
	                          while (true) {
	                            var hmin = heapPop();
	                            if (hmin < 0 || weights[hmin] > minArea) {
	                              break;
	                            }
	                            kill(hmin);
	                          }
	                          var npositions = [];
	                          for (var i = 0; i < n; ++i) {
	                            if (!dead[i]) {
	                              index[i] = npositions.length;
	                              npositions.push(positions[i].slice());
	                            }
	                          }
	                          npositions.length;
	                          function tortoiseHare(seq, start) {
	                            if (seq[start] < 0) {
	                              return start;
	                            }
	                            var t2 = start;
	                            var h = start;
	                            do {
	                              var nh = seq[h];
	                              if (!dead[h] || nh < 0 || nh === h) {
	                                break;
	                              }
	                              h = nh;
	                              nh = seq[h];
	                              if (!dead[h] || nh < 0 || nh === h) {
	                                break;
	                              }
	                              h = nh;
	                              t2 = seq[t2];
	                            } while (t2 !== h);
	                            for (var v = start; v !== h; v = seq[v]) {
	                              seq[v] = h;
	                            }
	                            return h;
	                          }
	                          var ncells = [];
	                          cells.forEach(function(c2) {
	                            var tin = tortoiseHare(inv, c2[0]);
	                            var tout = tortoiseHare(outv, c2[1]);
	                            if (tin >= 0 && tout >= 0 && tin !== tout) {
	                              var cin = index[tin];
	                              var cout = index[tout];
	                              if (cin !== cout) {
	                                ncells.push([cin, cout]);
	                              }
	                            }
	                          });
	                          sc.unique(sc.normalize(ncells));
	                          return { positions: npositions, edges: ncells };
	                        }
	                      }
	                    ),
	                    /***/
	                    6638: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_819815__) {
	                        module3.exports = orderSegments;
	                        var orient = __nested_webpack_require_819815__(417);
	                        function horizontalOrder(a, b) {
	                          var bl, br;
	                          if (b[0][0] < b[1][0]) {
	                            bl = b[0];
	                            br = b[1];
	                          } else if (b[0][0] > b[1][0]) {
	                            bl = b[1];
	                            br = b[0];
	                          } else {
	                            var alo = Math.min(a[0][1], a[1][1]);
	                            var ahi = Math.max(a[0][1], a[1][1]);
	                            var blo = Math.min(b[0][1], b[1][1]);
	                            var bhi = Math.max(b[0][1], b[1][1]);
	                            if (ahi < blo) {
	                              return ahi - blo;
	                            }
	                            if (alo > bhi) {
	                              return alo - bhi;
	                            }
	                            return ahi - bhi;
	                          }
	                          var al, ar;
	                          if (a[0][1] < a[1][1]) {
	                            al = a[0];
	                            ar = a[1];
	                          } else {
	                            al = a[1];
	                            ar = a[0];
	                          }
	                          var d = orient(br, bl, al);
	                          if (d) {
	                            return d;
	                          }
	                          d = orient(br, bl, ar);
	                          if (d) {
	                            return d;
	                          }
	                          return ar - br;
	                        }
	                        function orderSegments(b, a) {
	                          var al, ar;
	                          if (a[0][0] < a[1][0]) {
	                            al = a[0];
	                            ar = a[1];
	                          } else if (a[0][0] > a[1][0]) {
	                            al = a[1];
	                            ar = a[0];
	                          } else {
	                            return horizontalOrder(a, b);
	                          }
	                          var bl, br;
	                          if (b[0][0] < b[1][0]) {
	                            bl = b[0];
	                            br = b[1];
	                          } else if (b[0][0] > b[1][0]) {
	                            bl = b[1];
	                            br = b[0];
	                          } else {
	                            return -horizontalOrder(b, a);
	                          }
	                          var d1 = orient(al, ar, br);
	                          var d2 = orient(al, ar, bl);
	                          if (d1 < 0) {
	                            if (d2 <= 0) {
	                              return d1;
	                            }
	                          } else if (d1 > 0) {
	                            if (d2 >= 0) {
	                              return d1;
	                            }
	                          } else if (d2) {
	                            return d2;
	                          }
	                          d1 = orient(br, bl, ar);
	                          d2 = orient(br, bl, al);
	                          if (d1 < 0) {
	                            if (d2 <= 0) {
	                              return d1;
	                            }
	                          } else if (d1 > 0) {
	                            if (d2 >= 0) {
	                              return d1;
	                            }
	                          } else if (d2) {
	                            return d2;
	                          }
	                          return ar[0] - br[0];
	                        }
	                      }
	                    ),
	                    /***/
	                    4385: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_821028__) {
	                        module3.exports = createSlabDecomposition;
	                        var bounds = __nested_webpack_require_821028__(5070);
	                        var createRBTree = __nested_webpack_require_821028__(7080);
	                        var orient = __nested_webpack_require_821028__(417);
	                        var orderSegments = __nested_webpack_require_821028__(6638);
	                        function SlabDecomposition(slabs, coordinates, horizontal) {
	                          this.slabs = slabs;
	                          this.coordinates = coordinates;
	                          this.horizontal = horizontal;
	                        }
	                        var proto = SlabDecomposition.prototype;
	                        function compareHorizontal(e, y) {
	                          return e.y - y;
	                        }
	                        function searchBucket(root, p) {
	                          var lastNode = null;
	                          while (root) {
	                            var seg = root.key;
	                            var l, r;
	                            if (seg[0][0] < seg[1][0]) {
	                              l = seg[0];
	                              r = seg[1];
	                            } else {
	                              l = seg[1];
	                              r = seg[0];
	                            }
	                            var o = orient(l, r, p);
	                            if (o < 0) {
	                              root = root.left;
	                            } else if (o > 0) {
	                              if (p[0] !== seg[1][0]) {
	                                lastNode = root;
	                                root = root.right;
	                              } else {
	                                var val = searchBucket(root.right, p);
	                                if (val) {
	                                  return val;
	                                }
	                                root = root.left;
	                              }
	                            } else {
	                              if (p[0] !== seg[1][0]) {
	                                return root;
	                              } else {
	                                var val = searchBucket(root.right, p);
	                                if (val) {
	                                  return val;
	                                }
	                                root = root.left;
	                              }
	                            }
	                          }
	                          return lastNode;
	                        }
	                        proto.castUp = function(p) {
	                          var bucket = bounds.le(this.coordinates, p[0]);
	                          if (bucket < 0) {
	                            return -1;
	                          }
	                          this.slabs[bucket];
	                          var hitNode = searchBucket(this.slabs[bucket], p);
	                          var lastHit = -1;
	                          if (hitNode) {
	                            lastHit = hitNode.value;
	                          }
	                          if (this.coordinates[bucket] === p[0]) {
	                            var lastSegment = null;
	                            if (hitNode) {
	                              lastSegment = hitNode.key;
	                            }
	                            if (bucket > 0) {
	                              var otherHitNode = searchBucket(this.slabs[bucket - 1], p);
	                              if (otherHitNode) {
	                                if (lastSegment) {
	                                  if (orderSegments(otherHitNode.key, lastSegment) > 0) {
	                                    lastSegment = otherHitNode.key;
	                                    lastHit = otherHitNode.value;
	                                  }
	                                } else {
	                                  lastHit = otherHitNode.value;
	                                  lastSegment = otherHitNode.key;
	                                }
	                              }
	                            }
	                            var horiz = this.horizontal[bucket];
	                            if (horiz.length > 0) {
	                              var hbucket = bounds.ge(horiz, p[1], compareHorizontal);
	                              if (hbucket < horiz.length) {
	                                var e = horiz[hbucket];
	                                if (p[1] === e.y) {
	                                  if (e.closed) {
	                                    return e.index;
	                                  } else {
	                                    while (hbucket < horiz.length - 1 && horiz[hbucket + 1].y === p[1]) {
	                                      hbucket = hbucket + 1;
	                                      e = horiz[hbucket];
	                                      if (e.closed) {
	                                        return e.index;
	                                      }
	                                    }
	                                    if (e.y === p[1] && !e.start) {
	                                      hbucket = hbucket + 1;
	                                      if (hbucket >= horiz.length) {
	                                        return lastHit;
	                                      }
	                                      e = horiz[hbucket];
	                                    }
	                                  }
	                                }
	                                if (e.start) {
	                                  if (lastSegment) {
	                                    var o = orient(lastSegment[0], lastSegment[1], [p[0], e.y]);
	                                    if (lastSegment[0][0] > lastSegment[1][0]) {
	                                      o = -o;
	                                    }
	                                    if (o > 0) {
	                                      lastHit = e.index;
	                                    }
	                                  } else {
	                                    lastHit = e.index;
	                                  }
	                                } else if (e.y !== p[1]) {
	                                  lastHit = e.index;
	                                }
	                              }
	                            }
	                          }
	                          return lastHit;
	                        };
	                        function IntervalSegment(y, index, start, closed) {
	                          this.y = y;
	                          this.index = index;
	                          this.start = start;
	                          this.closed = closed;
	                        }
	                        function Event(x, segment, create, index) {
	                          this.x = x;
	                          this.segment = segment;
	                          this.create = create;
	                          this.index = index;
	                        }
	                        function createSlabDecomposition(segments) {
	                          var numSegments = segments.length;
	                          var numEvents = 2 * numSegments;
	                          var events = new Array(numEvents);
	                          for (var i = 0; i < numSegments; ++i) {
	                            var s = segments[i];
	                            var f = s[0][0] < s[1][0];
	                            events[2 * i] = new Event(s[0][0], s, f, i);
	                            events[2 * i + 1] = new Event(s[1][0], s, !f, i);
	                          }
	                          events.sort(function(a, b) {
	                            var d = a.x - b.x;
	                            if (d) {
	                              return d;
	                            }
	                            d = a.create - b.create;
	                            if (d) {
	                              return d;
	                            }
	                            return Math.min(a.segment[0][1], a.segment[1][1]) - Math.min(b.segment[0][1], b.segment[1][1]);
	                          });
	                          var tree = createRBTree(orderSegments);
	                          var slabs = [];
	                          var lines = [];
	                          var horizontal = [];
	                          for (var i = 0; i < numEvents; ) {
	                            var x = events[i].x;
	                            var horiz = [];
	                            while (i < numEvents) {
	                              var e = events[i];
	                              if (e.x !== x) {
	                                break;
	                              }
	                              i += 1;
	                              if (e.segment[0][0] === e.x && e.segment[1][0] === e.x) {
	                                if (e.create) {
	                                  if (e.segment[0][1] < e.segment[1][1]) {
	                                    horiz.push(new IntervalSegment(e.segment[0][1], e.index, true, true));
	                                    horiz.push(new IntervalSegment(e.segment[1][1], e.index, false, false));
	                                  } else {
	                                    horiz.push(new IntervalSegment(e.segment[1][1], e.index, true, false));
	                                    horiz.push(new IntervalSegment(e.segment[0][1], e.index, false, true));
	                                  }
	                                }
	                              } else {
	                                if (e.create) {
	                                  tree = tree.insert(e.segment, e.index);
	                                } else {
	                                  tree = tree.remove(e.segment);
	                                }
	                              }
	                            }
	                            slabs.push(tree.root);
	                            lines.push(x);
	                            horizontal.push(horiz);
	                          }
	                          return new SlabDecomposition(slabs, lines, horizontal);
	                        }
	                      }
	                    ),
	                    /***/
	                    4670: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_824840__) {
	                        var robustDot = __nested_webpack_require_824840__(9130);
	                        var robustSum = __nested_webpack_require_824840__(9662);
	                        module3.exports = splitPolygon;
	                        module3.exports.positive = positive;
	                        module3.exports.negative = negative;
	                        function planeT(p, plane) {
	                          var r = robustSum(robustDot(p, plane), [plane[plane.length - 1]]);
	                          return r[r.length - 1];
	                        }
	                        function lerpW(a, wa, b, wb) {
	                          var d = wb - wa;
	                          var t = -wa / d;
	                          if (t < 0) {
	                            t = 0;
	                          } else if (t > 1) {
	                            t = 1;
	                          }
	                          var ti = 1 - t;
	                          var n = a.length;
	                          var r = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            r[i] = t * a[i] + ti * b[i];
	                          }
	                          return r;
	                        }
	                        function splitPolygon(points, plane) {
	                          var pos = [];
	                          var neg = [];
	                          var a = planeT(points[points.length - 1], plane);
	                          for (var s = points[points.length - 1], t = points[0], i = 0; i < points.length; ++i, s = t) {
	                            t = points[i];
	                            var b = planeT(t, plane);
	                            if (a < 0 && b > 0 || a > 0 && b < 0) {
	                              var p = lerpW(s, b, t, a);
	                              pos.push(p);
	                              neg.push(p.slice());
	                            }
	                            if (b < 0) {
	                              neg.push(t.slice());
	                            } else if (b > 0) {
	                              pos.push(t.slice());
	                            } else {
	                              pos.push(t.slice());
	                              neg.push(t.slice());
	                            }
	                            a = b;
	                          }
	                          return { positive: pos, negative: neg };
	                        }
	                        function positive(points, plane) {
	                          var pos = [];
	                          var a = planeT(points[points.length - 1], plane);
	                          for (var s = points[points.length - 1], t = points[0], i = 0; i < points.length; ++i, s = t) {
	                            t = points[i];
	                            var b = planeT(t, plane);
	                            if (a < 0 && b > 0 || a > 0 && b < 0) {
	                              pos.push(lerpW(s, b, t, a));
	                            }
	                            if (b >= 0) {
	                              pos.push(t.slice());
	                            }
	                            a = b;
	                          }
	                          return pos;
	                        }
	                        function negative(points, plane) {
	                          var neg = [];
	                          var a = planeT(points[points.length - 1], plane);
	                          for (var s = points[points.length - 1], t = points[0], i = 0; i < points.length; ++i, s = t) {
	                            t = points[i];
	                            var b = planeT(t, plane);
	                            if (a < 0 && b > 0 || a > 0 && b < 0) {
	                              neg.push(lerpW(s, b, t, a));
	                            }
	                            if (b <= 0) {
	                              neg.push(t.slice());
	                            }
	                            a = b;
	                          }
	                          return neg;
	                        }
	                      }
	                    ),
	                    /***/
	                    8974: (
	                      /***/
	                      function(module3, exports2, __nested_webpack_require_826467__) {
	                        var __WEBPACK_AMD_DEFINE_RESULT__;
	                        !function() {
	                          var re = { not_string: /[^s]/, not_bool: /[^t]/, not_type: /[^T]/, not_primitive: /[^v]/, number: /[diefg]/, numeric_arg: /[bcdiefguxX]/, json: /[j]/, not_json: /[^j]/, text: /^[^\x25]+/, modulo: /^\x25{2}/, placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/, key: /^([a-z_][a-z_\d]*)/i, key_access: /^\.([a-z_][a-z_\d]*)/i, index_access: /^\[(\d+)\]/, sign: /^[+-]/ };
	                          function sprintf(key) {
	                            return sprintf_format(sprintf_parse(key), arguments);
	                          }
	                          function vsprintf(fmt, argv) {
	                            return sprintf.apply(null, [fmt].concat(argv || []));
	                          }
	                          function sprintf_format(parse_tree, argv) {
	                            var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
	                            for (i = 0; i < tree_length; i++) {
	                              if (typeof parse_tree[i] === "string") {
	                                output += parse_tree[i];
	                              } else if (typeof parse_tree[i] === "object") {
	                                ph = parse_tree[i];
	                                if (ph.keys) {
	                                  arg = argv[cursor];
	                                  for (k = 0; k < ph.keys.length; k++) {
	                                    if (arg == undefined) {
	                                      throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
	                                    }
	                                    arg = arg[ph.keys[k]];
	                                  }
	                                } else if (ph.param_no) {
	                                  arg = argv[ph.param_no];
	                                } else {
	                                  arg = argv[cursor++];
	                                }
	                                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
	                                  arg = arg();
	                                }
	                                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) {
	                                  throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
	                                }
	                                if (re.number.test(ph.type)) {
	                                  is_positive = arg >= 0;
	                                }
	                                switch (ph.type) {
	                                  case "b":
	                                    arg = parseInt(arg, 10).toString(2);
	                                    break;
	                                  case "c":
	                                    arg = String.fromCharCode(parseInt(arg, 10));
	                                    break;
	                                  case "d":
	                                  case "i":
	                                    arg = parseInt(arg, 10);
	                                    break;
	                                  case "j":
	                                    arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
	                                    break;
	                                  case "e":
	                                    arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
	                                    break;
	                                  case "f":
	                                    arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
	                                    break;
	                                  case "g":
	                                    arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
	                                    break;
	                                  case "o":
	                                    arg = (parseInt(arg, 10) >>> 0).toString(8);
	                                    break;
	                                  case "s":
	                                    arg = String(arg);
	                                    arg = ph.precision ? arg.substring(0, ph.precision) : arg;
	                                    break;
	                                  case "t":
	                                    arg = String(!!arg);
	                                    arg = ph.precision ? arg.substring(0, ph.precision) : arg;
	                                    break;
	                                  case "T":
	                                    arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
	                                    arg = ph.precision ? arg.substring(0, ph.precision) : arg;
	                                    break;
	                                  case "u":
	                                    arg = parseInt(arg, 10) >>> 0;
	                                    break;
	                                  case "v":
	                                    arg = arg.valueOf();
	                                    arg = ph.precision ? arg.substring(0, ph.precision) : arg;
	                                    break;
	                                  case "x":
	                                    arg = (parseInt(arg, 10) >>> 0).toString(16);
	                                    break;
	                                  case "X":
	                                    arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
	                                    break;
	                                }
	                                if (re.json.test(ph.type)) {
	                                  output += arg;
	                                } else {
	                                  if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
	                                    sign = is_positive ? "+" : "-";
	                                    arg = arg.toString().replace(re.sign, "");
	                                  } else {
	                                    sign = "";
	                                  }
	                                  pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
	                                  pad_length = ph.width - (sign + arg).length;
	                                  pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
	                                  output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
	                                }
	                              }
	                            }
	                            return output;
	                          }
	                          var sprintf_cache = /* @__PURE__ */ Object.create(null);
	                          function sprintf_parse(fmt) {
	                            if (sprintf_cache[fmt]) {
	                              return sprintf_cache[fmt];
	                            }
	                            var _fmt = fmt, match, parse_tree = [], arg_names = 0;
	                            while (_fmt) {
	                              if ((match = re.text.exec(_fmt)) !== null) {
	                                parse_tree.push(match[0]);
	                              } else if ((match = re.modulo.exec(_fmt)) !== null) {
	                                parse_tree.push("%");
	                              } else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                                if (match[2]) {
	                                  arg_names |= 1;
	                                  var field_list = [], replacement_field = match[2], field_match = [];
	                                  if ((field_match = re.key.exec(replacement_field)) !== null) {
	                                    field_list.push(field_match[1]);
	                                    while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
	                                      if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                        field_list.push(field_match[1]);
	                                      } else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                        field_list.push(field_match[1]);
	                                      } else {
	                                        throw new SyntaxError("[sprintf] failed to parse named argument key");
	                                      }
	                                    }
	                                  } else {
	                                    throw new SyntaxError("[sprintf] failed to parse named argument key");
	                                  }
	                                  match[2] = field_list;
	                                } else {
	                                  arg_names |= 2;
	                                }
	                                if (arg_names === 3) {
	                                  throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
	                                }
	                                parse_tree.push({ placeholder: match[0], param_no: match[1], keys: match[2], sign: match[3], pad_char: match[4], align: match[5], width: match[6], precision: match[7], type: match[8] });
	                              } else {
	                                throw new SyntaxError("[sprintf] unexpected placeholder");
	                              }
	                              _fmt = _fmt.substring(match[0].length);
	                            }
	                            return sprintf_cache[fmt] = parse_tree;
	                          }
	                          {
	                            exports2.sprintf = sprintf;
	                            exports2.vsprintf = vsprintf;
	                          }
	                          if (typeof window !== "undefined") {
	                            window["sprintf"] = sprintf;
	                            window["vsprintf"] = vsprintf;
	                            {
	                              !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                                return { "sprintf": sprintf, "vsprintf": vsprintf };
	                              }.call(exports2, __nested_webpack_require_826467__, exports2, module3), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module3.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	                            }
	                          }
	                        }();
	                      }
	                    ),
	                    /***/
	                    4162: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_831759__) {
	                        module3.exports = surfaceNets;
	                        var generateContourExtractor = __nested_webpack_require_831759__(9284);
	                        var zeroCrossings = __nested_webpack_require_831759__(9584);
	                        var allFns = { "2d": function(genContour, order, dtype) {
	                          var contour = genContour({ order, scalarArguments: 3, getters: dtype === "generic" ? [0] : undefined, phase: function phaseFunc(p, a, b, c) {
	                            return p > c | 0;
	                          }, vertex: function vertexFunc(d0, d1, v0, v1, v2, v3, p0, p1, p2, p3, a, b, c) {
	                            var m = (p0 << 0) + (p1 << 1) + (p2 << 2) + (p3 << 3) | 0;
	                            if (m === 0 || m === 15) {
	                              return;
	                            }
	                            switch (m) {
	                              case 0:
	                                a.push([d0 - 0.5, d1 - 0.5]);
	                                break;
	                              case 1:
	                                a.push([d0 - 0.25 - 0.25 * (v1 + v0 - 2 * c) / (v0 - v1), d1 - 0.25 - 0.25 * (v2 + v0 - 2 * c) / (v0 - v2)]);
	                                break;
	                              case 2:
	                                a.push([d0 - 0.75 - 0.25 * (-v1 - v0 + 2 * c) / (v1 - v0), d1 - 0.25 - 0.25 * (v3 + v1 - 2 * c) / (v1 - v3)]);
	                                break;
	                              case 3:
	                                a.push([d0 - 0.5, d1 - 0.5 - 0.5 * (v2 + v0 + v3 + v1 - 4 * c) / (v0 - v2 + v1 - v3)]);
	                                break;
	                              case 4:
	                                a.push([d0 - 0.25 - 0.25 * (v3 + v2 - 2 * c) / (v2 - v3), d1 - 0.75 - 0.25 * (-v2 - v0 + 2 * c) / (v2 - v0)]);
	                                break;
	                              case 5:
	                                a.push([d0 - 0.5 - 0.5 * (v1 + v0 + v3 + v2 - 4 * c) / (v0 - v1 + v2 - v3), d1 - 0.5]);
	                                break;
	                              case 6:
	                                a.push([d0 - 0.5 - 0.25 * (-v1 - v0 + v3 + v2) / (v1 - v0 + v2 - v3), d1 - 0.5 - 0.25 * (-v2 - v0 + v3 + v1) / (v2 - v0 + v1 - v3)]);
	                                break;
	                              case 7:
	                                a.push([d0 - 0.75 - 0.25 * (v3 + v2 - 2 * c) / (v2 - v3), d1 - 0.75 - 0.25 * (v3 + v1 - 2 * c) / (v1 - v3)]);
	                                break;
	                              case 8:
	                                a.push([d0 - 0.75 - 0.25 * (-v3 - v2 + 2 * c) / (v3 - v2), d1 - 0.75 - 0.25 * (-v3 - v1 + 2 * c) / (v3 - v1)]);
	                                break;
	                              case 9:
	                                a.push([d0 - 0.5 - 0.25 * (v1 + v0 + -v3 - v2) / (v0 - v1 + v3 - v2), d1 - 0.5 - 0.25 * (v2 + v0 + -v3 - v1) / (v0 - v2 + v3 - v1)]);
	                                break;
	                              case 10:
	                                a.push([d0 - 0.5 - 0.5 * (-v1 - v0 + -v3 - v2 + 4 * c) / (v1 - v0 + v3 - v2), d1 - 0.5]);
	                                break;
	                              case 11:
	                                a.push([d0 - 0.25 - 0.25 * (-v3 - v2 + 2 * c) / (v3 - v2), d1 - 0.75 - 0.25 * (v2 + v0 - 2 * c) / (v0 - v2)]);
	                                break;
	                              case 12:
	                                a.push([d0 - 0.5, d1 - 0.5 - 0.5 * (-v2 - v0 + -v3 - v1 + 4 * c) / (v2 - v0 + v3 - v1)]);
	                                break;
	                              case 13:
	                                a.push([d0 - 0.75 - 0.25 * (v1 + v0 - 2 * c) / (v0 - v1), d1 - 0.25 - 0.25 * (-v3 - v1 + 2 * c) / (v3 - v1)]);
	                                break;
	                              case 14:
	                                a.push([d0 - 0.25 - 0.25 * (-v1 - v0 + 2 * c) / (v1 - v0), d1 - 0.25 - 0.25 * (-v2 - v0 + 2 * c) / (v2 - v0)]);
	                                break;
	                              case 15:
	                                a.push([d0 - 0.5, d1 - 0.5]);
	                                break;
	                            }
	                          }, cell: function cellFunc(v0, v1, c0, c1, p0, p1, a, b, c) {
	                            if (p0) {
	                              b.push([v0, v1]);
	                            } else {
	                              b.push([v1, v0]);
	                            }
	                          } });
	                          return function(array, level) {
	                            var verts = [], cells = [];
	                            contour(array, verts, cells, level);
	                            return { positions: verts, cells };
	                          };
	                        } };
	                        function buildSurfaceNets(order, dtype) {
	                          var inKey = order.length + "d";
	                          var fn = allFns[inKey];
	                          if (fn) return fn(generateContourExtractor, order, dtype);
	                        }
	                        function mesh1D(array, level) {
	                          var zc = zeroCrossings(array, level);
	                          var n = zc.length;
	                          var npos = new Array(n);
	                          var ncel = new Array(n);
	                          for (var i = 0; i < n; ++i) {
	                            npos[i] = [zc[i]];
	                            ncel[i] = [i];
	                          }
	                          return { positions: npos, cells: ncel };
	                        }
	                        var CACHE = {};
	                        function surfaceNets(array, level) {
	                          if (array.dimension <= 0) {
	                            return { positions: [], cells: [] };
	                          } else if (array.dimension === 1) {
	                            return mesh1D(array, level);
	                          }
	                          var typesig = array.order.join() + "-" + array.dtype;
	                          var proc = CACHE[typesig];
	                          var level = +level || 0;
	                          if (!proc) {
	                            proc = CACHE[typesig] = buildSurfaceNets(array.order, array.dtype);
	                          }
	                          return proc(array, level);
	                        }
	                      }
	                    ),
	                    /***/
	                    6946: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_834583__) {
	                        module3.exports = textGet;
	                        var vectorizeText = __nested_webpack_require_834583__(875);
	                        var globals = window || process.global || {};
	                        var __TEXT_CACHE = globals.__TEXT_CACHE || {};
	                        globals.__TEXT_CACHE = {};
	                        function unwrap(mesh) {
	                          var cells = mesh.cells;
	                          var positions = mesh.positions;
	                          var data = new Float32Array(cells.length * 6);
	                          var ptr = 0;
	                          var shapeX = 0;
	                          for (var i = 0; i < cells.length; ++i) {
	                            var tri = cells[i];
	                            for (var j = 0; j < 3; ++j) {
	                              var point = positions[tri[j]];
	                              data[ptr++] = point[0];
	                              data[ptr++] = point[1] + 1.4;
	                              shapeX = Math.max(point[0], shapeX);
	                            }
	                          }
	                          return { data, shape: shapeX };
	                        }
	                        function textGet(font, text, opts) {
	                          var opts = opts || {};
	                          var fontcache = __TEXT_CACHE[font];
	                          if (!fontcache) {
	                            fontcache = __TEXT_CACHE[font] = { " ": { data: new Float32Array(0), shape: 0.2 } };
	                          }
	                          var mesh = fontcache[text];
	                          if (!mesh) {
	                            if (text.length <= 1 || !/\d/.test(text)) {
	                              mesh = fontcache[text] = unwrap(vectorizeText(text, { triangles: true, font, textAlign: opts.textAlign || "left", textBaseline: "alphabetic", styletags: { breaklines: true, bolds: true, italics: true, subscripts: true, superscripts: true } }));
	                            } else {
	                              var parts = text.split(/(\d|\s)/);
	                              var buffer = new Array(parts.length);
	                              var bufferSize = 0;
	                              var shapeX = 0;
	                              for (var i = 0; i < parts.length; ++i) {
	                                buffer[i] = textGet(font, parts[i]);
	                                bufferSize += buffer[i].data.length;
	                                shapeX += buffer[i].shape;
	                                if (i > 0) {
	                                  shapeX += 0.02;
	                                }
	                              }
	                              var data = new Float32Array(bufferSize);
	                              var ptr = 0;
	                              var xOffset = -0.5 * shapeX;
	                              for (var i = 0; i < buffer.length; ++i) {
	                                var bdata = buffer[i].data;
	                                for (var j = 0; j < bdata.length; j += 2) {
	                                  data[ptr++] = bdata[j] + xOffset;
	                                  data[ptr++] = bdata[j + 1];
	                                }
	                                xOffset += buffer[i].shape + 0.02;
	                              }
	                              mesh = fontcache[text] = { data, shape: shapeX };
	                            }
	                          }
	                          return mesh;
	                        }
	                      }
	                    ),
	                    /***/
	                    14: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_836219__) {
	                        var parseUnit = __nested_webpack_require_836219__(4405);
	                        module3.exports = toPX;
	                        var PIXELS_PER_INCH = 96;
	                        function getPropertyInPX(element, prop) {
	                          var parts = parseUnit(getComputedStyle(element).getPropertyValue(prop));
	                          return parts[0] * toPX(parts[1], element);
	                        }
	                        function getSizeBrutal(unit, element) {
	                          var testDIV = document.createElement("div");
	                          testDIV.style["font-size"] = "128" + unit;
	                          element.appendChild(testDIV);
	                          var size = getPropertyInPX(testDIV, "font-size") / 128;
	                          element.removeChild(testDIV);
	                          return size;
	                        }
	                        function toPX(str, element) {
	                          element = element || document.body;
	                          str = (str || "px").trim().toLowerCase();
	                          if (element === window || element === document) {
	                            element = document.body;
	                          }
	                          switch (str) {
	                            case "%":
	                              return element.clientHeight / 100;
	                            case "ch":
	                            case "ex":
	                              return getSizeBrutal(str, element);
	                            case "em":
	                              return getPropertyInPX(element, "font-size");
	                            case "rem":
	                              return getPropertyInPX(document.body, "font-size");
	                            case "vw":
	                              return window.innerWidth / 100;
	                            case "vh":
	                              return window.innerHeight / 100;
	                            case "vmin":
	                              return Math.min(window.innerWidth, window.innerHeight) / 100;
	                            case "vmax":
	                              return Math.max(window.innerWidth, window.innerHeight) / 100;
	                            case "in":
	                              return PIXELS_PER_INCH;
	                            case "cm":
	                              return PIXELS_PER_INCH / 2.54;
	                            case "mm":
	                              return PIXELS_PER_INCH / 25.4;
	                            case "pt":
	                              return PIXELS_PER_INCH / 72;
	                            case "pc":
	                              return PIXELS_PER_INCH / 6;
	                          }
	                          return 1;
	                        }
	                      }
	                    ),
	                    /***/
	                    3440: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_837649__) {
	                        module3.exports = createTurntableController;
	                        var filterVector = __nested_webpack_require_837649__(8444);
	                        var invert44 = __nested_webpack_require_837649__(7437);
	                        var rotateM = __nested_webpack_require_837649__(4422);
	                        var cross = __nested_webpack_require_837649__(903);
	                        var normalize3 = __nested_webpack_require_837649__(899);
	                        var dot3 = __nested_webpack_require_837649__(9305);
	                        function len3(x, y, z) {
	                          return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2));
	                        }
	                        function clamp1(x) {
	                          return Math.min(1, Math.max(-1, x));
	                        }
	                        function findOrthoPair(v) {
	                          var vx = Math.abs(v[0]);
	                          var vy = Math.abs(v[1]);
	                          var vz = Math.abs(v[2]);
	                          var u = [0, 0, 0];
	                          if (vx > Math.max(vy, vz)) {
	                            u[2] = 1;
	                          } else if (vy > Math.max(vx, vz)) {
	                            u[0] = 1;
	                          } else {
	                            u[1] = 1;
	                          }
	                          var vv = 0;
	                          var uv = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            vv += v[i] * v[i];
	                            uv += u[i] * v[i];
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            u[i] -= uv / vv * v[i];
	                          }
	                          normalize3(u, u);
	                          return u;
	                        }
	                        function TurntableController(zoomMin, zoomMax, center, up, right, radius, theta, phi) {
	                          this.center = filterVector(center);
	                          this.up = filterVector(up);
	                          this.right = filterVector(right);
	                          this.radius = filterVector([radius]);
	                          this.angle = filterVector([theta, phi]);
	                          this.angle.bounds = [[-Infinity, -Math.PI / 2], [Infinity, Math.PI / 2]];
	                          this.setDistanceLimits(zoomMin, zoomMax);
	                          this.computedCenter = this.center.curve(0);
	                          this.computedUp = this.up.curve(0);
	                          this.computedRight = this.right.curve(0);
	                          this.computedRadius = this.radius.curve(0);
	                          this.computedAngle = this.angle.curve(0);
	                          this.computedToward = [0, 0, 0];
	                          this.computedEye = [0, 0, 0];
	                          this.computedMatrix = new Array(16);
	                          for (var i = 0; i < 16; ++i) {
	                            this.computedMatrix[i] = 0.5;
	                          }
	                          this.recalcMatrix(0);
	                        }
	                        var proto = TurntableController.prototype;
	                        proto.setDistanceLimits = function(minDist, maxDist) {
	                          if (minDist > 0) {
	                            minDist = Math.log(minDist);
	                          } else {
	                            minDist = -Infinity;
	                          }
	                          if (maxDist > 0) {
	                            maxDist = Math.log(maxDist);
	                          } else {
	                            maxDist = Infinity;
	                          }
	                          maxDist = Math.max(maxDist, minDist);
	                          this.radius.bounds[0][0] = minDist;
	                          this.radius.bounds[1][0] = maxDist;
	                        };
	                        proto.getDistanceLimits = function(out) {
	                          var bounds = this.radius.bounds[0];
	                          if (out) {
	                            out[0] = Math.exp(bounds[0][0]);
	                            out[1] = Math.exp(bounds[1][0]);
	                            return out;
	                          }
	                          return [Math.exp(bounds[0][0]), Math.exp(bounds[1][0])];
	                        };
	                        proto.recalcMatrix = function(t) {
	                          this.center.curve(t);
	                          this.up.curve(t);
	                          this.right.curve(t);
	                          this.radius.curve(t);
	                          this.angle.curve(t);
	                          var up = this.computedUp;
	                          var right = this.computedRight;
	                          var uu = 0;
	                          var ur = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            ur += up[i] * right[i];
	                            uu += up[i] * up[i];
	                          }
	                          var ul = Math.sqrt(uu);
	                          var rr = 0;
	                          for (var i = 0; i < 3; ++i) {
	                            right[i] -= up[i] * ur / uu;
	                            rr += right[i] * right[i];
	                            up[i] /= ul;
	                          }
	                          var rl = Math.sqrt(rr);
	                          for (var i = 0; i < 3; ++i) {
	                            right[i] /= rl;
	                          }
	                          var toward = this.computedToward;
	                          cross(toward, up, right);
	                          normalize3(toward, toward);
	                          var radius = Math.exp(this.computedRadius[0]);
	                          var theta = this.computedAngle[0];
	                          var phi = this.computedAngle[1];
	                          var ctheta = Math.cos(theta);
	                          var stheta = Math.sin(theta);
	                          var cphi = Math.cos(phi);
	                          var sphi = Math.sin(phi);
	                          var center = this.computedCenter;
	                          var wx = ctheta * cphi;
	                          var wy = stheta * cphi;
	                          var wz = sphi;
	                          var sx = -ctheta * sphi;
	                          var sy = -stheta * sphi;
	                          var sz = cphi;
	                          var eye = this.computedEye;
	                          var mat = this.computedMatrix;
	                          for (var i = 0; i < 3; ++i) {
	                            var x = wx * right[i] + wy * toward[i] + wz * up[i];
	                            mat[4 * i + 1] = sx * right[i] + sy * toward[i] + sz * up[i];
	                            mat[4 * i + 2] = x;
	                            mat[4 * i + 3] = 0;
	                          }
	                          var ax = mat[1];
	                          var ay = mat[5];
	                          var az = mat[9];
	                          var bx = mat[2];
	                          var by = mat[6];
	                          var bz = mat[10];
	                          var cx = ay * bz - az * by;
	                          var cy = az * bx - ax * bz;
	                          var cz = ax * by - ay * bx;
	                          var cl = len3(cx, cy, cz);
	                          cx /= cl;
	                          cy /= cl;
	                          cz /= cl;
	                          mat[0] = cx;
	                          mat[4] = cy;
	                          mat[8] = cz;
	                          for (var i = 0; i < 3; ++i) {
	                            eye[i] = center[i] + mat[2 + 4 * i] * radius;
	                          }
	                          for (var i = 0; i < 3; ++i) {
	                            var rr = 0;
	                            for (var j = 0; j < 3; ++j) {
	                              rr += mat[i + 4 * j] * eye[j];
	                            }
	                            mat[12 + i] = -rr;
	                          }
	                          mat[15] = 1;
	                        };
	                        proto.getMatrix = function(t, result) {
	                          this.recalcMatrix(t);
	                          var mat = this.computedMatrix;
	                          if (result) {
	                            for (var i = 0; i < 16; ++i) {
	                              result[i] = mat[i];
	                            }
	                            return result;
	                          }
	                          return mat;
	                        };
	                        var zAxis = [0, 0, 0];
	                        proto.rotate = function(t, dtheta, dphi, droll) {
	                          this.angle.move(t, dtheta, dphi);
	                          if (droll) {
	                            this.recalcMatrix(t);
	                            var mat = this.computedMatrix;
	                            zAxis[0] = mat[2];
	                            zAxis[1] = mat[6];
	                            zAxis[2] = mat[10];
	                            var up = this.computedUp;
	                            var right = this.computedRight;
	                            var toward = this.computedToward;
	                            for (var i = 0; i < 3; ++i) {
	                              mat[4 * i] = up[i];
	                              mat[4 * i + 1] = right[i];
	                              mat[4 * i + 2] = toward[i];
	                            }
	                            rotateM(mat, mat, droll, zAxis);
	                            for (var i = 0; i < 3; ++i) {
	                              up[i] = mat[4 * i];
	                              right[i] = mat[4 * i + 1];
	                            }
	                            this.up.set(t, up[0], up[1], up[2]);
	                            this.right.set(t, right[0], right[1], right[2]);
	                          }
	                        };
	                        proto.pan = function(t, dx, dy, dz) {
	                          dx = dx || 0;
	                          dy = dy || 0;
	                          dz = dz || 0;
	                          this.recalcMatrix(t);
	                          var mat = this.computedMatrix;
	                          Math.exp(this.computedRadius[0]);
	                          var ux = mat[1];
	                          var uy = mat[5];
	                          var uz = mat[9];
	                          var ul = len3(ux, uy, uz);
	                          ux /= ul;
	                          uy /= ul;
	                          uz /= ul;
	                          var rx = mat[0];
	                          var ry = mat[4];
	                          var rz = mat[8];
	                          var ru = rx * ux + ry * uy + rz * uz;
	                          rx -= ux * ru;
	                          ry -= uy * ru;
	                          rz -= uz * ru;
	                          var rl = len3(rx, ry, rz);
	                          rx /= rl;
	                          ry /= rl;
	                          rz /= rl;
	                          var vx = rx * dx + ux * dy;
	                          var vy = ry * dx + uy * dy;
	                          var vz = rz * dx + uz * dy;
	                          this.center.move(t, vx, vy, vz);
	                          var radius = Math.exp(this.computedRadius[0]);
	                          radius = Math.max(1e-4, radius + dz);
	                          this.radius.set(t, Math.log(radius));
	                        };
	                        proto.translate = function(t, dx, dy, dz) {
	                          this.center.move(t, dx || 0, dy || 0, dz || 0);
	                        };
	                        proto.setMatrix = function(t, mat, axes, noSnap) {
	                          var ushift = 1;
	                          if (typeof axes === "number") {
	                            ushift = axes | 0;
	                          }
	                          if (ushift < 0 || ushift > 3) {
	                            ushift = 1;
	                          }
	                          var vshift = (ushift + 2) % 3;
	                          if (!mat) {
	                            this.recalcMatrix(t);
	                            mat = this.computedMatrix;
	                          }
	                          var ux = mat[ushift];
	                          var uy = mat[ushift + 4];
	                          var uz = mat[ushift + 8];
	                          if (!noSnap) {
	                            var ul = len3(ux, uy, uz);
	                            ux /= ul;
	                            uy /= ul;
	                            uz /= ul;
	                          } else {
	                            var ax = Math.abs(ux);
	                            var ay = Math.abs(uy);
	                            var az = Math.abs(uz);
	                            var am = Math.max(ax, ay, az);
	                            if (ax === am) {
	                              ux = ux < 0 ? -1 : 1;
	                              uy = uz = 0;
	                            } else if (az === am) {
	                              uz = uz < 0 ? -1 : 1;
	                              ux = uy = 0;
	                            } else {
	                              uy = uy < 0 ? -1 : 1;
	                              ux = uz = 0;
	                            }
	                          }
	                          var rx = mat[vshift];
	                          var ry = mat[vshift + 4];
	                          var rz = mat[vshift + 8];
	                          var ru = rx * ux + ry * uy + rz * uz;
	                          rx -= ux * ru;
	                          ry -= uy * ru;
	                          rz -= uz * ru;
	                          var rl = len3(rx, ry, rz);
	                          rx /= rl;
	                          ry /= rl;
	                          rz /= rl;
	                          var fx = uy * rz - uz * ry;
	                          var fy = uz * rx - ux * rz;
	                          var fz = ux * ry - uy * rx;
	                          var fl = len3(fx, fy, fz);
	                          fx /= fl;
	                          fy /= fl;
	                          fz /= fl;
	                          this.center.jump(t, ex, ey, ez);
	                          this.radius.idle(t);
	                          this.up.jump(t, ux, uy, uz);
	                          this.right.jump(t, rx, ry, rz);
	                          var phi, theta;
	                          if (ushift === 2) {
	                            var cx = mat[1];
	                            var cy = mat[5];
	                            var cz = mat[9];
	                            var cr = cx * rx + cy * ry + cz * rz;
	                            var cf = cx * fx + cy * fy + cz * fz;
	                            if (tu < 0) {
	                              phi = -Math.PI / 2;
	                            } else {
	                              phi = Math.PI / 2;
	                            }
	                            theta = Math.atan2(cf, cr);
	                          } else {
	                            var tx = mat[2];
	                            var ty = mat[6];
	                            var tz = mat[10];
	                            var tu = tx * ux + ty * uy + tz * uz;
	                            var tr = tx * rx + ty * ry + tz * rz;
	                            var tf = tx * fx + ty * fy + tz * fz;
	                            phi = Math.asin(clamp1(tu));
	                            theta = Math.atan2(tf, tr);
	                          }
	                          this.angle.jump(t, theta, phi);
	                          this.recalcMatrix(t);
	                          var dx = mat[2];
	                          var dy = mat[6];
	                          var dz = mat[10];
	                          var imat = this.computedMatrix;
	                          invert44(imat, mat);
	                          var w = imat[15];
	                          var ex = imat[12] / w;
	                          var ey = imat[13] / w;
	                          var ez = imat[14] / w;
	                          var gs = Math.exp(this.computedRadius[0]);
	                          this.center.jump(t, ex - dx * gs, ey - dy * gs, ez - dz * gs);
	                        };
	                        proto.lastT = function() {
	                          return Math.max(this.center.lastT(), this.up.lastT(), this.right.lastT(), this.radius.lastT(), this.angle.lastT());
	                        };
	                        proto.idle = function(t) {
	                          this.center.idle(t);
	                          this.up.idle(t);
	                          this.right.idle(t);
	                          this.radius.idle(t);
	                          this.angle.idle(t);
	                        };
	                        proto.flush = function(t) {
	                          this.center.flush(t);
	                          this.up.flush(t);
	                          this.right.flush(t);
	                          this.radius.flush(t);
	                          this.angle.flush(t);
	                        };
	                        proto.setDistance = function(t, d) {
	                          if (d > 0) {
	                            this.radius.set(t, Math.log(d));
	                          }
	                        };
	                        proto.lookAt = function(t, eye, center, up) {
	                          this.recalcMatrix(t);
	                          eye = eye || this.computedEye;
	                          center = center || this.computedCenter;
	                          up = up || this.computedUp;
	                          var ux = up[0];
	                          var uy = up[1];
	                          var uz = up[2];
	                          var ul = len3(ux, uy, uz);
	                          if (ul < 1e-6) {
	                            return;
	                          }
	                          ux /= ul;
	                          uy /= ul;
	                          uz /= ul;
	                          var tx = eye[0] - center[0];
	                          var ty = eye[1] - center[1];
	                          var tz = eye[2] - center[2];
	                          var tl = len3(tx, ty, tz);
	                          if (tl < 1e-6) {
	                            return;
	                          }
	                          tx /= tl;
	                          ty /= tl;
	                          tz /= tl;
	                          var right = this.computedRight;
	                          var rx = right[0];
	                          var ry = right[1];
	                          var rz = right[2];
	                          var ru = ux * rx + uy * ry + uz * rz;
	                          rx -= ru * ux;
	                          ry -= ru * uy;
	                          rz -= ru * uz;
	                          var rl = len3(rx, ry, rz);
	                          if (rl < 0.01) {
	                            rx = uy * tz - uz * ty;
	                            ry = uz * tx - ux * tz;
	                            rz = ux * ty - uy * tx;
	                            rl = len3(rx, ry, rz);
	                            if (rl < 1e-6) {
	                              return;
	                            }
	                          }
	                          rx /= rl;
	                          ry /= rl;
	                          rz /= rl;
	                          this.up.set(t, ux, uy, uz);
	                          this.right.set(t, rx, ry, rz);
	                          this.center.set(t, center[0], center[1], center[2]);
	                          this.radius.set(t, Math.log(tl));
	                          var fx = uy * rz - uz * ry;
	                          var fy = uz * rx - ux * rz;
	                          var fz = ux * ry - uy * rx;
	                          var fl = len3(fx, fy, fz);
	                          fx /= fl;
	                          fy /= fl;
	                          fz /= fl;
	                          var tu = ux * tx + uy * ty + uz * tz;
	                          var tr = rx * tx + ry * ty + rz * tz;
	                          var tf = fx * tx + fy * ty + fz * tz;
	                          var phi = Math.asin(clamp1(tu));
	                          var theta = Math.atan2(tf, tr);
	                          var angleState = this.angle._state;
	                          var lastTheta = angleState[angleState.length - 1];
	                          var lastPhi = angleState[angleState.length - 2];
	                          lastTheta = lastTheta % (2 * Math.PI);
	                          var dp = Math.abs(lastTheta + 2 * Math.PI - theta);
	                          var d0 = Math.abs(lastTheta - theta);
	                          var dn = Math.abs(lastTheta - 2 * Math.PI - theta);
	                          if (dp < d0) {
	                            lastTheta += 2 * Math.PI;
	                          }
	                          if (dn < d0) {
	                            lastTheta -= 2 * Math.PI;
	                          }
	                          this.angle.jump(this.angle.lastT(), lastTheta, lastPhi);
	                          this.angle.set(t, theta, phi);
	                        };
	                        function createTurntableController(options) {
	                          options = options || {};
	                          var center = options.center || [0, 0, 0];
	                          var up = options.up || [0, 1, 0];
	                          var right = options.right || findOrthoPair(up);
	                          var radius = options.radius || 1;
	                          var theta = options.theta || 0;
	                          var phi = options.phi || 0;
	                          center = [].slice.call(center, 0, 3);
	                          up = [].slice.call(up, 0, 3);
	                          normalize3(up, up);
	                          right = [].slice.call(right, 0, 3);
	                          normalize3(right, right);
	                          if ("eye" in options) {
	                            var eye = options.eye;
	                            var toward = [eye[0] - center[0], eye[1] - center[1], eye[2] - center[2]];
	                            cross(right, toward, up);
	                            if (len3(right[0], right[1], right[2]) < 1e-6) {
	                              right = findOrthoPair(up);
	                            } else {
	                              normalize3(right, right);
	                            }
	                            radius = len3(toward[0], toward[1], toward[2]);
	                            var ut = dot3(up, toward) / radius;
	                            var rt = dot3(right, toward) / radius;
	                            phi = Math.acos(ut);
	                            theta = Math.acos(rt);
	                          }
	                          radius = Math.log(radius);
	                          return new TurntableController(options.zoomMin, options.zoomMax, center, up, right, radius, theta, phi);
	                        }
	                      }
	                    ),
	                    /***/
	                    9660: (
	                      /***/
	                      function(module3) {
	                        module3.exports = twoProduct;
	                        var SPLITTER = +(Math.pow(2, 27) + 1);
	                        function twoProduct(a, b, result) {
	                          var x = a * b;
	                          var c = SPLITTER * a;
	                          var abig = c - a;
	                          var ahi = c - abig;
	                          var alo = a - ahi;
	                          var d = SPLITTER * b;
	                          var bbig = d - b;
	                          var bhi = d - bbig;
	                          var blo = b - bhi;
	                          var err1 = x - ahi * bhi;
	                          var err2 = err1 - alo * bhi;
	                          var err3 = err2 - ahi * blo;
	                          var y = alo * blo - err3;
	                          if (result) {
	                            result[0] = y;
	                            result[1] = x;
	                            return result;
	                          }
	                          return [y, x];
	                        }
	                      }
	                    ),
	                    /***/
	                    87: (
	                      /***/
	                      function(module3) {
	                        module3.exports = fastTwoSum;
	                        function fastTwoSum(a, b, result) {
	                          var x = a + b;
	                          var bv = x - a;
	                          var av = x - bv;
	                          var br = b - bv;
	                          var ar = a - av;
	                          if (result) {
	                            result[0] = ar + br;
	                            result[1] = x;
	                            return result;
	                          }
	                          return [ar + br, x];
	                        }
	                      }
	                    ),
	                    /***/
	                    5306: (
	                      /***/
	                      function(__unused_webpack_module, exports2, __nested_webpack_require_847784__) {
	                        var bits = __nested_webpack_require_847784__(2288);
	                        var dup = __nested_webpack_require_847784__(3094);
	                        var Buffer2 = __nested_webpack_require_847784__(2146).lW;
	                        if (!__nested_webpack_require_847784__.g.__TYPEDARRAY_POOL) {
	                          __nested_webpack_require_847784__.g.__TYPEDARRAY_POOL = { UINT8: dup([32, 0]), UINT16: dup([32, 0]), UINT32: dup([32, 0]), BIGUINT64: dup([32, 0]), INT8: dup([32, 0]), INT16: dup([32, 0]), INT32: dup([32, 0]), BIGINT64: dup([32, 0]), FLOAT: dup([32, 0]), DOUBLE: dup([32, 0]), DATA: dup([32, 0]), UINT8C: dup([32, 0]), BUFFER: dup([32, 0]) };
	                        }
	                        var hasUint8C = typeof Uint8ClampedArray !== "undefined";
	                        var hasBigUint64 = typeof BigUint64Array !== "undefined";
	                        var hasBigInt64 = typeof BigInt64Array !== "undefined";
	                        var POOL = __nested_webpack_require_847784__.g.__TYPEDARRAY_POOL;
	                        if (!POOL.UINT8C) {
	                          POOL.UINT8C = dup([32, 0]);
	                        }
	                        if (!POOL.BIGUINT64) {
	                          POOL.BIGUINT64 = dup([32, 0]);
	                        }
	                        if (!POOL.BIGINT64) {
	                          POOL.BIGINT64 = dup([32, 0]);
	                        }
	                        if (!POOL.BUFFER) {
	                          POOL.BUFFER = dup([32, 0]);
	                        }
	                        var DATA = POOL.DATA, BUFFER = POOL.BUFFER;
	                        exports2.free = function free(array) {
	                          if (Buffer2.isBuffer(array)) {
	                            BUFFER[bits.log2(array.length)].push(array);
	                          } else {
	                            if (Object.prototype.toString.call(array) !== "[object ArrayBuffer]") {
	                              array = array.buffer;
	                            }
	                            if (!array) {
	                              return;
	                            }
	                            var n = array.length || array.byteLength;
	                            var log_n = bits.log2(n) | 0;
	                            DATA[log_n].push(array);
	                          }
	                        };
	                        function freeArrayBuffer(buffer) {
	                          if (!buffer) {
	                            return;
	                          }
	                          var n = buffer.length || buffer.byteLength;
	                          var log_n = bits.log2(n);
	                          DATA[log_n].push(buffer);
	                        }
	                        function freeTypedArray(array) {
	                          freeArrayBuffer(array.buffer);
	                        }
	                        exports2.freeUint8 = exports2.freeUint16 = exports2.freeUint32 = exports2.freeBigUint64 = exports2.freeInt8 = exports2.freeInt16 = exports2.freeInt32 = exports2.freeBigInt64 = exports2.freeFloat32 = exports2.freeFloat = exports2.freeFloat64 = exports2.freeDouble = exports2.freeUint8Clamped = exports2.freeDataView = freeTypedArray;
	                        exports2.freeArrayBuffer = freeArrayBuffer;
	                        exports2.freeBuffer = function freeBuffer(array) {
	                          BUFFER[bits.log2(array.length)].push(array);
	                        };
	                        exports2.malloc = function malloc(n, dtype) {
	                          if (dtype === undefined || dtype === "arraybuffer") {
	                            return mallocArrayBuffer(n);
	                          } else {
	                            switch (dtype) {
	                              case "uint8":
	                                return mallocUint8(n);
	                              case "uint16":
	                                return mallocUint16(n);
	                              case "uint32":
	                                return mallocUint32(n);
	                              case "int8":
	                                return mallocInt8(n);
	                              case "int16":
	                                return mallocInt16(n);
	                              case "int32":
	                                return mallocInt32(n);
	                              case "float":
	                              case "float32":
	                                return mallocFloat(n);
	                              case "double":
	                              case "float64":
	                                return mallocDouble(n);
	                              case "uint8_clamped":
	                                return mallocUint8Clamped(n);
	                              case "bigint64":
	                                return mallocBigInt64(n);
	                              case "biguint64":
	                                return mallocBigUint64(n);
	                              case "buffer":
	                                return mallocBuffer(n);
	                              case "data":
	                              case "dataview":
	                                return mallocDataView(n);
	                              default:
	                                return null;
	                            }
	                          }
	                          return null;
	                        };
	                        function mallocArrayBuffer(n) {
	                          var n = bits.nextPow2(n);
	                          var log_n = bits.log2(n);
	                          var d = DATA[log_n];
	                          if (d.length > 0) {
	                            return d.pop();
	                          }
	                          return new ArrayBuffer(n);
	                        }
	                        exports2.mallocArrayBuffer = mallocArrayBuffer;
	                        function mallocUint8(n) {
	                          return new Uint8Array(mallocArrayBuffer(n), 0, n);
	                        }
	                        exports2.mallocUint8 = mallocUint8;
	                        function mallocUint16(n) {
	                          return new Uint16Array(mallocArrayBuffer(2 * n), 0, n);
	                        }
	                        exports2.mallocUint16 = mallocUint16;
	                        function mallocUint32(n) {
	                          return new Uint32Array(mallocArrayBuffer(4 * n), 0, n);
	                        }
	                        exports2.mallocUint32 = mallocUint32;
	                        function mallocInt8(n) {
	                          return new Int8Array(mallocArrayBuffer(n), 0, n);
	                        }
	                        exports2.mallocInt8 = mallocInt8;
	                        function mallocInt16(n) {
	                          return new Int16Array(mallocArrayBuffer(2 * n), 0, n);
	                        }
	                        exports2.mallocInt16 = mallocInt16;
	                        function mallocInt32(n) {
	                          return new Int32Array(mallocArrayBuffer(4 * n), 0, n);
	                        }
	                        exports2.mallocInt32 = mallocInt32;
	                        function mallocFloat(n) {
	                          return new Float32Array(mallocArrayBuffer(4 * n), 0, n);
	                        }
	                        exports2.mallocFloat32 = exports2.mallocFloat = mallocFloat;
	                        function mallocDouble(n) {
	                          return new Float64Array(mallocArrayBuffer(8 * n), 0, n);
	                        }
	                        exports2.mallocFloat64 = exports2.mallocDouble = mallocDouble;
	                        function mallocUint8Clamped(n) {
	                          if (hasUint8C) {
	                            return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n);
	                          } else {
	                            return mallocUint8(n);
	                          }
	                        }
	                        exports2.mallocUint8Clamped = mallocUint8Clamped;
	                        function mallocBigUint64(n) {
	                          if (hasBigUint64) {
	                            return new BigUint64Array(mallocArrayBuffer(8 * n), 0, n);
	                          } else {
	                            return null;
	                          }
	                        }
	                        exports2.mallocBigUint64 = mallocBigUint64;
	                        function mallocBigInt64(n) {
	                          if (hasBigInt64) {
	                            return new BigInt64Array(mallocArrayBuffer(8 * n), 0, n);
	                          } else {
	                            return null;
	                          }
	                        }
	                        exports2.mallocBigInt64 = mallocBigInt64;
	                        function mallocDataView(n) {
	                          return new DataView(mallocArrayBuffer(n), 0, n);
	                        }
	                        exports2.mallocDataView = mallocDataView;
	                        function mallocBuffer(n) {
	                          n = bits.nextPow2(n);
	                          var log_n = bits.log2(n);
	                          var cache = BUFFER[log_n];
	                          if (cache.length > 0) {
	                            return cache.pop();
	                          }
	                          return new Buffer2(n);
	                        }
	                        exports2.mallocBuffer = mallocBuffer;
	                        exports2.clearCache = function clearCache() {
	                          for (var i = 0; i < 32; ++i) {
	                            POOL.UINT8[i].length = 0;
	                            POOL.UINT16[i].length = 0;
	                            POOL.UINT32[i].length = 0;
	                            POOL.INT8[i].length = 0;
	                            POOL.INT16[i].length = 0;
	                            POOL.INT32[i].length = 0;
	                            POOL.FLOAT[i].length = 0;
	                            POOL.DOUBLE[i].length = 0;
	                            POOL.BIGUINT64[i].length = 0;
	                            POOL.BIGINT64[i].length = 0;
	                            POOL.UINT8C[i].length = 0;
	                            DATA[i].length = 0;
	                            BUFFER[i].length = 0;
	                          }
	                        };
	                      }
	                    ),
	                    /***/
	                    1731: (
	                      /***/
	                      function(module3) {
	                        "use restrict";
	                        module3.exports = UnionFind;
	                        function UnionFind(count) {
	                          this.roots = new Array(count);
	                          this.ranks = new Array(count);
	                          for (var i = 0; i < count; ++i) {
	                            this.roots[i] = i;
	                            this.ranks[i] = 0;
	                          }
	                        }
	                        var proto = UnionFind.prototype;
	                        Object.defineProperty(proto, "length", { "get": function() {
	                          return this.roots.length;
	                        } });
	                        proto.makeSet = function() {
	                          var n = this.roots.length;
	                          this.roots.push(n);
	                          this.ranks.push(0);
	                          return n;
	                        };
	                        proto.find = function(x) {
	                          var x0 = x;
	                          var roots = this.roots;
	                          while (roots[x] !== x) {
	                            x = roots[x];
	                          }
	                          while (roots[x0] !== x) {
	                            var y = roots[x0];
	                            roots[x0] = x;
	                            x0 = y;
	                          }
	                          return x;
	                        };
	                        proto.link = function(x, y) {
	                          var xr = this.find(x), yr = this.find(y);
	                          if (xr === yr) {
	                            return;
	                          }
	                          var ranks = this.ranks, roots = this.roots, xd = ranks[xr], yd = ranks[yr];
	                          if (xd < yd) {
	                            roots[xr] = yr;
	                          } else if (yd < xd) {
	                            roots[yr] = xr;
	                          } else {
	                            roots[yr] = xr;
	                            ++ranks[xr];
	                          }
	                        };
	                      }
	                    ),
	                    /***/
	                    1215: (
	                      /***/
	                      function(module3) {
	                        function unique_pred(list, compare) {
	                          var ptr = 1, len = list.length, a = list[0], b = list[0];
	                          for (var i = 1; i < len; ++i) {
	                            b = a;
	                            a = list[i];
	                            if (compare(a, b)) {
	                              if (i === ptr) {
	                                ptr++;
	                                continue;
	                              }
	                              list[ptr++] = a;
	                            }
	                          }
	                          list.length = ptr;
	                          return list;
	                        }
	                        function unique_eq(list) {
	                          var ptr = 1, len = list.length, a = list[0], b = list[0];
	                          for (var i = 1; i < len; ++i, b = a) {
	                            b = a;
	                            a = list[i];
	                            if (a !== b) {
	                              if (i === ptr) {
	                                ptr++;
	                                continue;
	                              }
	                              list[ptr++] = a;
	                            }
	                          }
	                          list.length = ptr;
	                          return list;
	                        }
	                        function unique(list, compare, sorted) {
	                          if (list.length === 0) {
	                            return list;
	                          }
	                          if (compare) {
	                            if (!sorted) {
	                              list.sort(compare);
	                            }
	                            return unique_pred(list, compare);
	                          }
	                          if (!sorted) {
	                            list.sort();
	                          }
	                          return unique_eq(list);
	                        }
	                        module3.exports = unique;
	                      }
	                    ),
	                    /***/
	                    875: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_854234__) {
	                        module3.exports = createText;
	                        var vectorizeText = __nested_webpack_require_854234__(712);
	                        var defaultCanvas = null;
	                        var defaultContext = null;
	                        if (typeof document !== "undefined") {
	                          defaultCanvas = document.createElement("canvas");
	                          defaultCanvas.width = 8192;
	                          defaultCanvas.height = 1024;
	                          defaultContext = defaultCanvas.getContext("2d");
	                        }
	                        function createText(str, options) {
	                          if (typeof options !== "object" || options === null) {
	                            options = {};
	                          }
	                          return vectorizeText(str, options.canvas || defaultCanvas, options.context || defaultContext, options);
	                        }
	                      }
	                    ),
	                    /***/
	                    712: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_854813__) {
	                        module3.exports = vectorizeText;
	                        module3.exports.processPixels = processPixels;
	                        var surfaceNets = __nested_webpack_require_854813__(4162);
	                        var ndarray = __nested_webpack_require_854813__(5050);
	                        var simplify = __nested_webpack_require_854813__(8243);
	                        var cleanPSLG = __nested_webpack_require_854813__(197);
	                        var cdt2d = __nested_webpack_require_854813__(7761);
	                        var toPolygonCrappy = __nested_webpack_require_854813__(8040);
	                        var TAG_bold = "b";
	                        var CHR_bold = "b|";
	                        var TAG_italic = "i";
	                        var CHR_italic = "i|";
	                        var TAG_super = "sup";
	                        var CHR_super0 = "+";
	                        var CHR_super = "+1";
	                        var TAG_sub = "sub";
	                        var CHR_sub0 = "-";
	                        var CHR_sub = "-1";
	                        function parseTag(tag, TAG_CHR, str, map2) {
	                          var opnTag = "<" + tag + ">";
	                          var clsTag = "</" + tag + ">";
	                          var nOPN = opnTag.length;
	                          var nCLS = clsTag.length;
	                          var isRecursive = TAG_CHR[0] === CHR_super0 || TAG_CHR[0] === CHR_sub0;
	                          var a = 0;
	                          var b = -nCLS;
	                          while (a > -1) {
	                            a = str.indexOf(opnTag, a);
	                            if (a === -1) break;
	                            b = str.indexOf(clsTag, a + nOPN);
	                            if (b === -1) break;
	                            if (b <= a) break;
	                            for (var i = a; i < b + nCLS; ++i) {
	                              if (i < a + nOPN || i >= b) {
	                                map2[i] = null;
	                                str = str.substr(0, i) + " " + str.substr(i + 1);
	                              } else {
	                                if (map2[i] !== null) {
	                                  var pos = map2[i].indexOf(TAG_CHR[0]);
	                                  if (pos === -1) {
	                                    map2[i] += TAG_CHR;
	                                  } else {
	                                    if (isRecursive) {
	                                      map2[i] = map2[i].substr(0, pos + 1) + (1 + parseInt(map2[i][pos + 1])) + map2[i].substr(pos + 2);
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                            var start = a + nOPN;
	                            var remainingStr = str.substr(start, b - start);
	                            var c = remainingStr.indexOf(opnTag);
	                            if (c !== -1) a = c;
	                            else a = b + nCLS;
	                          }
	                          return map2;
	                        }
	                        function transformPositions(positions, options, size) {
	                          var align = options.textAlign || "start";
	                          var baseline = options.textBaseline || "alphabetic";
	                          var lo = [1 << 30, 1 << 30];
	                          var hi = [0, 0];
	                          var n = positions.length;
	                          for (var i = 0; i < n; ++i) {
	                            var p = positions[i];
	                            for (var j = 0; j < 2; ++j) {
	                              lo[j] = Math.min(lo[j], p[j]) | 0;
	                              hi[j] = Math.max(hi[j], p[j]) | 0;
	                            }
	                          }
	                          var xShift = 0;
	                          switch (align) {
	                            case "center":
	                              xShift = -0.5 * (lo[0] + hi[0]);
	                              break;
	                            case "right":
	                            case "end":
	                              xShift = -hi[0];
	                              break;
	                            case "left":
	                            case "start":
	                              xShift = -lo[0];
	                              break;
	                            default:
	                              throw new Error("vectorize-text: Unrecognized textAlign: '" + align + "'");
	                          }
	                          var yShift = 0;
	                          switch (baseline) {
	                            case "hanging":
	                            case "top":
	                              yShift = -lo[1];
	                              break;
	                            case "middle":
	                              yShift = -0.5 * (lo[1] + hi[1]);
	                              break;
	                            case "alphabetic":
	                            case "ideographic":
	                              yShift = -3 * size;
	                              break;
	                            case "bottom":
	                              yShift = -hi[1];
	                              break;
	                            default:
	                              throw new Error("vectorize-text: Unrecoginized textBaseline: '" + baseline + "'");
	                          }
	                          var scale = 1 / size;
	                          if ("lineHeight" in options) {
	                            scale *= +options.lineHeight;
	                          } else if ("width" in options) {
	                            scale = options.width / (hi[0] - lo[0]);
	                          } else if ("height" in options) {
	                            scale = options.height / (hi[1] - lo[1]);
	                          }
	                          return positions.map(function(p2) {
	                            return [scale * (p2[0] + xShift), scale * (p2[1] + yShift)];
	                          });
	                        }
	                        function getPixels(canvas, context, rawString, fontSize, lineSpacing, styletags) {
	                          rawString = rawString.replace(/\n/g, "");
	                          if (styletags.breaklines === true) {
	                            rawString = rawString.replace(/\<br\>/g, "\n");
	                          } else {
	                            rawString = rawString.replace(/\<br\>/g, " ");
	                          }
	                          var activeStyle = "";
	                          var map2 = [];
	                          for (j = 0; j < rawString.length; ++j) {
	                            map2[j] = activeStyle;
	                          }
	                          if (styletags.bolds === true) map2 = parseTag(TAG_bold, CHR_bold, rawString, map2);
	                          if (styletags.italics === true) map2 = parseTag(TAG_italic, CHR_italic, rawString, map2);
	                          if (styletags.superscripts === true) map2 = parseTag(TAG_super, CHR_super, rawString, map2);
	                          if (styletags.subscripts === true) map2 = parseTag(TAG_sub, CHR_sub, rawString, map2);
	                          var allStyles = [];
	                          var plainText = "";
	                          for (j = 0; j < rawString.length; ++j) {
	                            if (map2[j] !== null) {
	                              plainText += rawString[j];
	                              allStyles.push(map2[j]);
	                            }
	                          }
	                          var allTexts = plainText.split("\n");
	                          var numberOfLines = allTexts.length;
	                          var lineHeight = Math.round(lineSpacing * fontSize);
	                          var offsetX = fontSize;
	                          var offsetY = fontSize * 2;
	                          var maxWidth = 0;
	                          var minHeight = numberOfLines * lineHeight + offsetY;
	                          if (canvas.height < minHeight) {
	                            canvas.height = minHeight;
	                          }
	                          context.fillStyle = "#000";
	                          context.fillRect(0, 0, canvas.width, canvas.height);
	                          context.fillStyle = "#fff";
	                          var i, j, xPos, yPos, zPos;
	                          var nDone = 0;
	                          var buffer = "";
	                          function writeBuffer() {
	                            if (buffer !== "") {
	                              var delta = context.measureText(buffer).width;
	                              context.fillText(buffer, offsetX + xPos, offsetY + yPos);
	                              xPos += delta;
	                            }
	                          }
	                          function getTextFontSize() {
	                            return "" + Math.round(zPos) + "px ";
	                          }
	                          function changeStyle(oldStyle, newStyle) {
	                            var ctxFont = "" + context.font;
	                            if (styletags.subscripts === true) {
	                              var oldIndex_Sub = oldStyle.indexOf(CHR_sub0);
	                              var newIndex_Sub = newStyle.indexOf(CHR_sub0);
	                              var oldSub = oldIndex_Sub > -1 ? parseInt(oldStyle[1 + oldIndex_Sub]) : 0;
	                              var newSub = newIndex_Sub > -1 ? parseInt(newStyle[1 + newIndex_Sub]) : 0;
	                              if (oldSub !== newSub) {
	                                ctxFont = ctxFont.replace(getTextFontSize(), "?px ");
	                                zPos *= Math.pow(0.75, newSub - oldSub);
	                                ctxFont = ctxFont.replace("?px ", getTextFontSize());
	                              }
	                              yPos += 0.25 * lineHeight * (newSub - oldSub);
	                            }
	                            if (styletags.superscripts === true) {
	                              var oldIndex_Super = oldStyle.indexOf(CHR_super0);
	                              var newIndex_Super = newStyle.indexOf(CHR_super0);
	                              var oldSuper = oldIndex_Super > -1 ? parseInt(oldStyle[1 + oldIndex_Super]) : 0;
	                              var newSuper = newIndex_Super > -1 ? parseInt(newStyle[1 + newIndex_Super]) : 0;
	                              if (oldSuper !== newSuper) {
	                                ctxFont = ctxFont.replace(getTextFontSize(), "?px ");
	                                zPos *= Math.pow(0.75, newSuper - oldSuper);
	                                ctxFont = ctxFont.replace("?px ", getTextFontSize());
	                              }
	                              yPos -= 0.25 * lineHeight * (newSuper - oldSuper);
	                            }
	                            if (styletags.bolds === true) {
	                              var wasBold = oldStyle.indexOf(CHR_bold) > -1;
	                              var is_Bold = newStyle.indexOf(CHR_bold) > -1;
	                              if (!wasBold && is_Bold) {
	                                if (wasItalic) {
	                                  ctxFont = ctxFont.replace("italic ", "italic bold ");
	                                } else {
	                                  ctxFont = "bold " + ctxFont;
	                                }
	                              }
	                              if (wasBold && !is_Bold) {
	                                ctxFont = ctxFont.replace("bold ", "");
	                              }
	                            }
	                            if (styletags.italics === true) {
	                              var wasItalic = oldStyle.indexOf(CHR_italic) > -1;
	                              var is_Italic = newStyle.indexOf(CHR_italic) > -1;
	                              if (!wasItalic && is_Italic) {
	                                ctxFont = "italic " + ctxFont;
	                              }
	                              if (wasItalic && !is_Italic) {
	                                ctxFont = ctxFont.replace("italic ", "");
	                              }
	                            }
	                            context.font = ctxFont;
	                          }
	                          for (i = 0; i < numberOfLines; ++i) {
	                            var txt = allTexts[i] + "\n";
	                            xPos = 0;
	                            yPos = i * lineHeight;
	                            zPos = fontSize;
	                            buffer = "";
	                            for (j = 0; j < txt.length; ++j) {
	                              var style = j + nDone < allStyles.length ? allStyles[j + nDone] : allStyles[allStyles.length - 1];
	                              if (activeStyle === style) {
	                                buffer += txt[j];
	                              } else {
	                                writeBuffer();
	                                buffer = txt[j];
	                                if (style !== undefined) {
	                                  changeStyle(activeStyle, style);
	                                  activeStyle = style;
	                                }
	                              }
	                            }
	                            writeBuffer();
	                            nDone += txt.length;
	                            var width = Math.round(xPos + 2 * offsetX) | 0;
	                            if (maxWidth < width) maxWidth = width;
	                          }
	                          var xCut = maxWidth;
	                          var yCut = offsetY + lineHeight * numberOfLines;
	                          var pixels = ndarray(context.getImageData(0, 0, xCut, yCut).data, [yCut, xCut, 4]);
	                          return pixels.pick(-1, -1, 0).transpose(1, 0);
	                        }
	                        function getContour(pixels, doSimplify) {
	                          var contour = surfaceNets(pixels, 128);
	                          if (doSimplify) {
	                            return simplify(contour.cells, contour.positions, 0.25);
	                          }
	                          return { edges: contour.cells, positions: contour.positions };
	                        }
	                        function processPixelsImpl(pixels, options, size, simplify2) {
	                          var contour = getContour(pixels, simplify2);
	                          var positions = transformPositions(contour.positions, options, size);
	                          var edges = contour.edges;
	                          var flip = "ccw" === options.orientation;
	                          cleanPSLG(positions, edges);
	                          if (options.polygons || options.polygon || options.polyline) {
	                            var result = toPolygonCrappy(edges, positions);
	                            var nresult = new Array(result.length);
	                            for (var i = 0; i < result.length; ++i) {
	                              var loops = result[i];
	                              var nloops = new Array(loops.length);
	                              for (var j = 0; j < loops.length; ++j) {
	                                var loop = loops[j];
	                                var nloop = new Array(loop.length);
	                                for (var k = 0; k < loop.length; ++k) {
	                                  nloop[k] = positions[loop[k]].slice();
	                                }
	                                if (flip) {
	                                  nloop.reverse();
	                                }
	                                nloops[j] = nloop;
	                              }
	                              nresult[i] = nloops;
	                            }
	                            return nresult;
	                          } else if (options.triangles || options.triangulate || options.triangle) {
	                            return { cells: cdt2d(positions, edges, { delaunay: false, exterior: false, interior: true }), positions };
	                          } else {
	                            return { edges, positions };
	                          }
	                        }
	                        function processPixels(pixels, options, size) {
	                          try {
	                            return processPixelsImpl(pixels, options, size, true);
	                          } catch (e) {
	                          }
	                          try {
	                            return processPixelsImpl(pixels, options, size, false);
	                          } catch (e) {
	                          }
	                          if (options.polygons || options.polyline || options.polygon) {
	                            return [];
	                          }
	                          if (options.triangles || options.triangulate || options.triangle) {
	                            return { cells: [], positions: [] };
	                          }
	                          return { edges: [], positions: [] };
	                        }
	                        function vectorizeText(str, canvas, context, options) {
	                          var size = 64;
	                          var lineSpacing = 1.25;
	                          var styletags = { breaklines: false, bolds: false, italics: false, subscripts: false, superscripts: false };
	                          if (options) {
	                            if (options.size && options.size > 0) size = options.size;
	                            if (options.lineSpacing && options.lineSpacing > 0) lineSpacing = options.lineSpacing;
	                            if (options.styletags && options.styletags.breaklines) styletags.breaklines = options.styletags.breaklines ? true : false;
	                            if (options.styletags && options.styletags.bolds) styletags.bolds = options.styletags.bolds ? true : false;
	                            if (options.styletags && options.styletags.italics) styletags.italics = options.styletags.italics ? true : false;
	                            if (options.styletags && options.styletags.subscripts) styletags.subscripts = options.styletags.subscripts ? true : false;
	                            if (options.styletags && options.styletags.superscripts) styletags.superscripts = options.styletags.superscripts ? true : false;
	                          }
	                          context.font = [options.fontStyle, options.fontVariant, options.fontWeight, size + "px", options.font].filter(function(d) {
	                            return d;
	                          }).join(" ");
	                          context.textAlign = "start";
	                          context.textBaseline = "alphabetic";
	                          context.direction = "ltr";
	                          var pixels = getPixels(canvas, context, str, size, lineSpacing, styletags);
	                          return processPixels(pixels, options, size);
	                        }
	                      }
	                    ),
	                    /***/
	                    5346: (
	                      /***/
	                      function(module3) {
	                        (function WeakMapModule() {
	                          if (typeof ses !== "undefined" && ses.ok && !ses.ok()) {
	                            return;
	                          }
	                          function weakMapPermitHostObjects(map2) {
	                            if (map2.permitHostObjects___) {
	                              map2.permitHostObjects___(weakMapPermitHostObjects);
	                            }
	                          }
	                          if (typeof ses !== "undefined") {
	                            ses.weakMapPermitHostObjects = weakMapPermitHostObjects;
	                          }
	                          var doubleWeakMapCheckSilentFailure = false;
	                          if (typeof WeakMap === "function") {
	                            var HostWeakMap = WeakMap;
	                            if (typeof navigator !== "undefined" && /Firefox/.test(navigator.userAgent)) ; else {
	                              var testMap = new HostWeakMap();
	                              var testObject = Object.freeze({});
	                              testMap.set(testObject, 1);
	                              if (testMap.get(testObject) !== 1) {
	                                doubleWeakMapCheckSilentFailure = true;
	                              } else {
	                                module3.exports = WeakMap;
	                                return;
	                              }
	                            }
	                          }
	                          var gopn = Object.getOwnPropertyNames;
	                          var defProp = Object.defineProperty;
	                          var isExtensible = Object.isExtensible;
	                          var HIDDEN_NAME_PREFIX = "weakmap:";
	                          var HIDDEN_NAME = HIDDEN_NAME_PREFIX + "ident:" + Math.random() + "___";
	                          if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function" && typeof ArrayBuffer === "function" && typeof Uint8Array === "function") {
	                            var ab = new ArrayBuffer(25);
	                            var u8s = new Uint8Array(ab);
	                            crypto.getRandomValues(u8s);
	                            HIDDEN_NAME = HIDDEN_NAME_PREFIX + "rand:" + Array.prototype.map.call(u8s, function(u8) {
	                              return (u8 % 36).toString(36);
	                            }).join("") + "___";
	                          }
	                          function isNotHiddenName(name2) {
	                            return !(name2.substr(0, HIDDEN_NAME_PREFIX.length) == HIDDEN_NAME_PREFIX && name2.substr(name2.length - 3) === "___");
	                          }
	                          defProp(Object, "getOwnPropertyNames", { value: function fakeGetOwnPropertyNames(obj) {
	                            return gopn(obj).filter(isNotHiddenName);
	                          } });
	                          if ("getPropertyNames" in Object) {
	                            var originalGetPropertyNames = Object.getPropertyNames;
	                            defProp(Object, "getPropertyNames", { value: function fakeGetPropertyNames(obj) {
	                              return originalGetPropertyNames(obj).filter(isNotHiddenName);
	                            } });
	                          }
	                          function getHiddenRecord(key) {
	                            if (key !== Object(key)) {
	                              throw new TypeError("Not an object: " + key);
	                            }
	                            var hiddenRecord = key[HIDDEN_NAME];
	                            if (hiddenRecord && hiddenRecord.key === key) {
	                              return hiddenRecord;
	                            }
	                            if (!isExtensible(key)) {
	                              return undefined;
	                            }
	                            hiddenRecord = { key };
	                            try {
	                              defProp(key, HIDDEN_NAME, { value: hiddenRecord, writable: false, enumerable: false, configurable: false });
	                              return hiddenRecord;
	                            } catch (error) {
	                              return undefined;
	                            }
	                          }
	                          (function() {
	                            var oldFreeze = Object.freeze;
	                            defProp(Object, "freeze", { value: function identifyingFreeze(obj) {
	                              getHiddenRecord(obj);
	                              return oldFreeze(obj);
	                            } });
	                            var oldSeal = Object.seal;
	                            defProp(Object, "seal", { value: function identifyingSeal(obj) {
	                              getHiddenRecord(obj);
	                              return oldSeal(obj);
	                            } });
	                            var oldPreventExtensions = Object.preventExtensions;
	                            defProp(Object, "preventExtensions", { value: function identifyingPreventExtensions(obj) {
	                              getHiddenRecord(obj);
	                              return oldPreventExtensions(obj);
	                            } });
	                          })();
	                          function constFunc(func) {
	                            func.prototype = null;
	                            return Object.freeze(func);
	                          }
	                          var calledAsFunctionWarningDone = false;
	                          function calledAsFunctionWarning() {
	                            if (!calledAsFunctionWarningDone && typeof console !== "undefined") {
	                              calledAsFunctionWarningDone = true;
	                              console.warn("WeakMap should be invoked as new WeakMap(), not WeakMap(). This will be an error in the future.");
	                            }
	                          }
	                          var nextId = 0;
	                          var OurWeakMap = function() {
	                            if (!(this instanceof OurWeakMap)) {
	                              calledAsFunctionWarning();
	                            }
	                            var keys = [];
	                            var values = [];
	                            var id = nextId++;
	                            function get___(key, opt_default) {
	                              var index;
	                              var hiddenRecord = getHiddenRecord(key);
	                              if (hiddenRecord) {
	                                return id in hiddenRecord ? hiddenRecord[id] : opt_default;
	                              } else {
	                                index = keys.indexOf(key);
	                                return index >= 0 ? values[index] : opt_default;
	                              }
	                            }
	                            function has___(key) {
	                              var hiddenRecord = getHiddenRecord(key);
	                              if (hiddenRecord) {
	                                return id in hiddenRecord;
	                              } else {
	                                return keys.indexOf(key) >= 0;
	                              }
	                            }
	                            function set___(key, value) {
	                              var index;
	                              var hiddenRecord = getHiddenRecord(key);
	                              if (hiddenRecord) {
	                                hiddenRecord[id] = value;
	                              } else {
	                                index = keys.indexOf(key);
	                                if (index >= 0) {
	                                  values[index] = value;
	                                } else {
	                                  index = keys.length;
	                                  values[index] = value;
	                                  keys[index] = key;
	                                }
	                              }
	                              return this;
	                            }
	                            function delete___(key) {
	                              var hiddenRecord = getHiddenRecord(key);
	                              var index, lastIndex;
	                              if (hiddenRecord) {
	                                return id in hiddenRecord && delete hiddenRecord[id];
	                              } else {
	                                index = keys.indexOf(key);
	                                if (index < 0) {
	                                  return false;
	                                }
	                                lastIndex = keys.length - 1;
	                                keys[index] = undefined;
	                                values[index] = values[lastIndex];
	                                keys[index] = keys[lastIndex];
	                                keys.length = lastIndex;
	                                values.length = lastIndex;
	                                return true;
	                              }
	                            }
	                            return Object.create(OurWeakMap.prototype, { get___: { value: constFunc(get___) }, has___: { value: constFunc(has___) }, set___: { value: constFunc(set___) }, delete___: { value: constFunc(delete___) } });
	                          };
	                          OurWeakMap.prototype = Object.create(Object.prototype, { get: {
	                            /**
	                            * Return the value most recently associated with key, or
	                            * opt_default if none.
	                            */
	                            value: function get(key, opt_default) {
	                              return this.get___(key, opt_default);
	                            },
	                            writable: true,
	                            configurable: true
	                          }, has: {
	                            /**
	                            * Is there a value associated with key in this WeakMap?
	                            */
	                            value: function has(key) {
	                              return this.has___(key);
	                            },
	                            writable: true,
	                            configurable: true
	                          }, set: {
	                            /**
	                            * Associate value with key in this WeakMap, overwriting any
	                            * previous association if present.
	                            */
	                            value: function set(key, value) {
	                              return this.set___(key, value);
	                            },
	                            writable: true,
	                            configurable: true
	                          }, "delete": {
	                            /**
	                            * Remove any association for key in this WeakMap, returning
	                            * whether there was one.
	                            *
	                            * <p>Note that the boolean return here does not work like the
	                            * {@code delete} operator. The {@code delete} operator returns
	                            * whether the deletion succeeds at bringing about a state in
	                            * which the deleted property is absent. The {@code delete}
	                            * operator therefore returns true if the property was already
	                            * absent, whereas this {@code delete} method returns false if
	                            * the association was already absent.
	                            */
	                            value: function remove(key) {
	                              return this.delete___(key);
	                            },
	                            writable: true,
	                            configurable: true
	                          } });
	                          if (typeof HostWeakMap === "function") {
	                            (function() {
	                              if (doubleWeakMapCheckSilentFailure && typeof Proxy !== "undefined") {
	                                Proxy = undefined;
	                              }
	                              function DoubleWeakMap() {
	                                if (!(this instanceof OurWeakMap)) {
	                                  calledAsFunctionWarning();
	                                }
	                                var hmap = new HostWeakMap();
	                                var omap = undefined;
	                                var enableSwitching = false;
	                                function dget(key, opt_default) {
	                                  if (omap) {
	                                    return hmap.has(key) ? hmap.get(key) : omap.get___(key, opt_default);
	                                  } else {
	                                    return hmap.get(key, opt_default);
	                                  }
	                                }
	                                function dhas(key) {
	                                  return hmap.has(key) || (omap ? omap.has___(key) : false);
	                                }
	                                var dset;
	                                if (doubleWeakMapCheckSilentFailure) {
	                                  dset = function(key, value) {
	                                    hmap.set(key, value);
	                                    if (!hmap.has(key)) {
	                                      if (!omap) {
	                                        omap = new OurWeakMap();
	                                      }
	                                      omap.set(key, value);
	                                    }
	                                    return this;
	                                  };
	                                } else {
	                                  dset = function(key, value) {
	                                    if (enableSwitching) {
	                                      try {
	                                        hmap.set(key, value);
	                                      } catch (e) {
	                                        if (!omap) {
	                                          omap = new OurWeakMap();
	                                        }
	                                        omap.set___(key, value);
	                                      }
	                                    } else {
	                                      hmap.set(key, value);
	                                    }
	                                    return this;
	                                  };
	                                }
	                                function ddelete(key) {
	                                  var result = !!hmap["delete"](key);
	                                  if (omap) {
	                                    return omap.delete___(key) || result;
	                                  }
	                                  return result;
	                                }
	                                return Object.create(OurWeakMap.prototype, { get___: { value: constFunc(dget) }, has___: { value: constFunc(dhas) }, set___: { value: constFunc(dset) }, delete___: { value: constFunc(ddelete) }, permitHostObjects___: { value: constFunc(function(token) {
	                                  if (token === weakMapPermitHostObjects) {
	                                    enableSwitching = true;
	                                  } else {
	                                    throw new Error("bogus call to permitHostObjects___");
	                                  }
	                                }) } });
	                              }
	                              DoubleWeakMap.prototype = OurWeakMap.prototype;
	                              module3.exports = DoubleWeakMap;
	                              Object.defineProperty(WeakMap.prototype, "constructor", {
	                                value: WeakMap,
	                                enumerable: false,
	                                // as default .constructor is
	                                configurable: true,
	                                writable: true
	                              });
	                            })();
	                          } else {
	                            if (typeof Proxy !== "undefined") {
	                              Proxy = undefined;
	                            }
	                            module3.exports = OurWeakMap;
	                          }
	                        })();
	                      }
	                    ),
	                    /***/
	                    9222: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_886677__) {
	                        var hiddenStore = __nested_webpack_require_886677__(7178);
	                        module3.exports = createStore;
	                        function createStore() {
	                          var key = {};
	                          return function(obj) {
	                            if ((typeof obj !== "object" || obj === null) && typeof obj !== "function") {
	                              throw new Error("Weakmap-shim: Key must be object");
	                            }
	                            var store = obj.valueOf(key);
	                            return store && store.identity === key ? store : hiddenStore(obj, key);
	                          };
	                        }
	                      }
	                    ),
	                    /***/
	                    7178: (
	                      /***/
	                      function(module3) {
	                        module3.exports = hiddenStore;
	                        function hiddenStore(obj, key) {
	                          var store = { identity: key };
	                          var valueOf = obj.valueOf;
	                          Object.defineProperty(obj, "valueOf", { value: function(value) {
	                            return value !== key ? valueOf.apply(this, arguments) : store;
	                          }, writable: true });
	                          return store;
	                        }
	                      }
	                    ),
	                    /***/
	                    4037: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_887386__) {
	                        var createStore = __nested_webpack_require_887386__(9222);
	                        module3.exports = weakMap;
	                        function weakMap() {
	                          var privates = createStore();
	                          return { "get": function(key, fallback) {
	                            var store = privates(key);
	                            return store.hasOwnProperty("value") ? store.value : fallback;
	                          }, "set": function(key, value) {
	                            privates(key).value = value;
	                            return this;
	                          }, "has": function(key) {
	                            return "value" in privates(key);
	                          }, "delete": function(key) {
	                            return delete privates(key).value;
	                          } };
	                        }
	                      }
	                    ),
	                    /***/
	                    6183: (
	                      /***/
	                      function(module3) {
	                        function CWiseOp() {
	                          return function(SS, a0, t0, p0, Y0, Y1) {
	                            var s0 = SS[0], t0p0 = t0[0], index = [0], q0 = t0p0;
	                            p0 |= 0;
	                            var i0 = 0, d0s0 = t0p0;
	                            for (i0 = 0; i0 < s0; ++i0) {
	                              {
	                                var da = a0[p0] - Y1;
	                                var db = a0[p0 + q0] - Y1;
	                                if (da >= 0 !== db >= 0) {
	                                  Y0.push(index[0] + 0.5 + 0.5 * (da + db) / (da - db));
	                                }
	                              }
	                              p0 += d0s0;
	                              ++index[0];
	                            }
	                          };
	                        }
	                        function generateCWiseOp() {
	                          return CWiseOp();
	                        }
	                        var compile = generateCWiseOp;
	                        function thunk(compile2) {
	                          var CACHED = {};
	                          return function zeroCrossings_cwise_thunk(array0, scalar2, scalar3) {
	                            var t0 = array0.dtype, r0 = array0.order, type = [t0, r0.join()].join(), proc = CACHED[type];
	                            if (!proc) {
	                              CACHED[type] = proc = compile2([t0, r0]);
	                            }
	                            return proc(array0.shape.slice(0), array0.data, array0.stride, array0.offset | 0, scalar2, scalar3);
	                          };
	                        }
	                        function createThunk(proc) {
	                          return thunk(compile.bind(undefined, proc));
	                        }
	                        function compileCwise(user_args) {
	                          return createThunk({ funcName: user_args.funcName });
	                        }
	                        module3.exports = compileCwise({ funcName: "zeroCrossings" });
	                      }
	                    ),
	                    /***/
	                    9584: (
	                      /***/
	                      function(module3, __unused_webpack_exports2, __nested_webpack_require_888962__) {
	                        module3.exports = findZeroCrossings;
	                        var core = __nested_webpack_require_888962__(6183);
	                        function findZeroCrossings(array, level) {
	                          var cross = [];
	                          level = +level || 0;
	                          core(array.hi(array.shape[0] - 1), cross, level);
	                          return cross;
	                        }
	                      }
	                    ),
	                    /***/
	                    6601: (
	                      /***/
	                      function() {
	                      }
	                    )
	                    /******/
	                  };
	                  var __webpack_module_cache__2 = {};
	                  function __nested_webpack_require_889453__(moduleId) {
	                    var cachedModule = __webpack_module_cache__2[moduleId];
	                    if (cachedModule !== undefined) {
	                      return cachedModule.exports;
	                    }
	                    var module3 = __webpack_module_cache__2[moduleId] = {
	                      /******/
	                      id: moduleId,
	                      /******/
	                      loaded: false,
	                      /******/
	                      exports: {}
	                      /******/
	                    };
	                    __webpack_modules__2[moduleId].call(module3.exports, module3, module3.exports, __nested_webpack_require_889453__);
	                    module3.loaded = true;
	                    return module3.exports;
	                  }
	                  !function() {
	                    __nested_webpack_require_889453__.g = function() {
	                      if (typeof globalThis === "object") return globalThis;
	                      try {
	                        return this || new Function("return this")();
	                      } catch (e) {
	                        if (typeof window === "object") return window;
	                      }
	                    }();
	                  }();
	                  !function() {
	                    __nested_webpack_require_889453__.nmd = function(module3) {
	                      module3.paths = [];
	                      if (!module3.children) module3.children = [];
	                      return module3;
	                    };
	                  }();
	                  var __nested_webpack_exports__ = __nested_webpack_require_889453__(7386);
	                  return __nested_webpack_exports__;
	                }()
	              );
	            });
	          }
	        ),
	        /***/
	        12856: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            /*!
	             * The buffer module from node.js, for the browser.
	             *
	             * @author   Feross Aboukhadijeh <https://feross.org>
	             * @license  MIT
	             */
	            function _classCallCheck(instance, Constructor) {
	              if (!(instance instanceof Constructor)) {
	                throw new TypeError("Cannot call a class as a function");
	              }
	            }
	            function _defineProperties(target, props) {
	              for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
	              }
	            }
	            function _createClass(Constructor, protoProps, staticProps) {
	              _defineProperties(Constructor.prototype, protoProps);
	              Object.defineProperty(Constructor, "prototype", { writable: false });
	              return Constructor;
	            }
	            function _toPropertyKey(arg) {
	              var key = _toPrimitive(arg, "string");
	              return _typeof(key) === "symbol" ? key : String(key);
	            }
	            function _toPrimitive(input, hint) {
	              if (_typeof(input) !== "object" || input === null) return input;
	              var prim = input[Symbol.toPrimitive];
	              if (prim !== undefined) {
	                var res = prim.call(input, hint);
	                if (_typeof(res) !== "object") return res;
	                throw new TypeError("@@toPrimitive must return a primitive value.");
	              }
	              return (String )(input);
	            }
	            function _inherits(subClass, superClass) {
	              if (typeof superClass !== "function" && superClass !== null) {
	                throw new TypeError("Super expression must either be null or a function");
	              }
	              subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
	              Object.defineProperty(subClass, "prototype", { writable: false });
	              if (superClass) _setPrototypeOf(subClass, superClass);
	            }
	            function _setPrototypeOf(o, p) {
	              _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
	                o2.__proto__ = p2;
	                return o2;
	              };
	              return _setPrototypeOf(o, p);
	            }
	            function _createSuper(Derived) {
	              var hasNativeReflectConstruct = _isNativeReflectConstruct();
	              return function _createSuperInternal() {
	                var Super = _getPrototypeOf(Derived), result;
	                if (hasNativeReflectConstruct) {
	                  var NewTarget = _getPrototypeOf(this).constructor;
	                  result = Reflect.construct(Super, arguments, NewTarget);
	                } else {
	                  result = Super.apply(this, arguments);
	                }
	                return _possibleConstructorReturn(this, result);
	              };
	            }
	            function _possibleConstructorReturn(self2, call) {
	              if (call && (_typeof(call) === "object" || typeof call === "function")) {
	                return call;
	              } else if (call !== undefined) {
	                throw new TypeError("Derived constructors may only return object or undefined");
	              }
	              return _assertThisInitialized(self2);
	            }
	            function _assertThisInitialized(self2) {
	              if (self2 === undefined) {
	                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	              }
	              return self2;
	            }
	            function _isNativeReflectConstruct() {
	              if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	              if (Reflect.construct.sham) return false;
	              if (typeof Proxy === "function") return true;
	              try {
	                Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
	                }));
	                return true;
	              } catch (e) {
	                return false;
	              }
	            }
	            function _getPrototypeOf(o) {
	              _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
	                return o2.__proto__ || Object.getPrototypeOf(o2);
	              };
	              return _getPrototypeOf(o);
	            }
	            function _typeof(obj) {
	              "@babel/helpers - typeof";
	              return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
	                return typeof obj2;
	              } : function(obj2) {
	                return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	              }, _typeof(obj);
	            }
	            var base64 = __webpack_require__2(95341);
	            var ieee754 = __webpack_require__2(95280);
	            var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
	            exports2.Buffer = Buffer2;
	            exports2.SlowBuffer = SlowBuffer;
	            exports2.INSPECT_MAX_BYTES = 50;
	            var K_MAX_LENGTH = 2147483647;
	            exports2.kMaxLength = K_MAX_LENGTH;
	            Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
	            if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
	              console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
	            }
	            function typedArraySupport() {
	              try {
	                var arr = new Uint8Array(1);
	                var proto = {
	                  foo: function foo() {
	                    return 42;
	                  }
	                };
	                Object.setPrototypeOf(proto, Uint8Array.prototype);
	                Object.setPrototypeOf(arr, proto);
	                return arr.foo() === 42;
	              } catch (e) {
	                return false;
	              }
	            }
	            Object.defineProperty(Buffer2.prototype, "parent", {
	              enumerable: true,
	              get: function get() {
	                if (!Buffer2.isBuffer(this)) return undefined;
	                return this.buffer;
	              }
	            });
	            Object.defineProperty(Buffer2.prototype, "offset", {
	              enumerable: true,
	              get: function get() {
	                if (!Buffer2.isBuffer(this)) return undefined;
	                return this.byteOffset;
	              }
	            });
	            function createBuffer(length) {
	              if (length > K_MAX_LENGTH) {
	                throw new RangeError('The value "' + length + '" is invalid for option "size"');
	              }
	              var buf = new Uint8Array(length);
	              Object.setPrototypeOf(buf, Buffer2.prototype);
	              return buf;
	            }
	            function Buffer2(arg, encodingOrOffset, length) {
	              if (typeof arg === "number") {
	                if (typeof encodingOrOffset === "string") {
	                  throw new TypeError('The "string" argument must be of type string. Received type number');
	                }
	                return allocUnsafe(arg);
	              }
	              return from(arg, encodingOrOffset, length);
	            }
	            Buffer2.poolSize = 8192;
	            function from(value, encodingOrOffset, length) {
	              if (typeof value === "string") {
	                return fromString(value, encodingOrOffset);
	              }
	              if (ArrayBuffer.isView(value)) {
	                return fromArrayView(value);
	              }
	              if (value == null) {
	                throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(value));
	              }
	              if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
	                return fromArrayBuffer(value, encodingOrOffset, length);
	              }
	              if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
	                return fromArrayBuffer(value, encodingOrOffset, length);
	              }
	              if (typeof value === "number") {
	                throw new TypeError('The "value" argument must not be of type number. Received type number');
	              }
	              var valueOf = value.valueOf && value.valueOf();
	              if (valueOf != null && valueOf !== value) {
	                return Buffer2.from(valueOf, encodingOrOffset, length);
	              }
	              var b = fromObject(value);
	              if (b) return b;
	              if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
	                return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
	              }
	              throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(value));
	            }
	            Buffer2.from = function(value, encodingOrOffset, length) {
	              return from(value, encodingOrOffset, length);
	            };
	            Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
	            Object.setPrototypeOf(Buffer2, Uint8Array);
	            function assertSize(size) {
	              if (typeof size !== "number") {
	                throw new TypeError('"size" argument must be of type number');
	              } else if (size < 0) {
	                throw new RangeError('The value "' + size + '" is invalid for option "size"');
	              }
	            }
	            function alloc(size, fill, encoding) {
	              assertSize(size);
	              if (size <= 0) {
	                return createBuffer(size);
	              }
	              if (fill !== undefined) {
	                return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
	              }
	              return createBuffer(size);
	            }
	            Buffer2.alloc = function(size, fill, encoding) {
	              return alloc(size, fill, encoding);
	            };
	            function allocUnsafe(size) {
	              assertSize(size);
	              return createBuffer(size < 0 ? 0 : checked(size) | 0);
	            }
	            Buffer2.allocUnsafe = function(size) {
	              return allocUnsafe(size);
	            };
	            Buffer2.allocUnsafeSlow = function(size) {
	              return allocUnsafe(size);
	            };
	            function fromString(string, encoding) {
	              if (typeof encoding !== "string" || encoding === "") {
	                encoding = "utf8";
	              }
	              if (!Buffer2.isEncoding(encoding)) {
	                throw new TypeError("Unknown encoding: " + encoding);
	              }
	              var length = byteLength(string, encoding) | 0;
	              var buf = createBuffer(length);
	              var actual = buf.write(string, encoding);
	              if (actual !== length) {
	                buf = buf.slice(0, actual);
	              }
	              return buf;
	            }
	            function fromArrayLike(array) {
	              var length = array.length < 0 ? 0 : checked(array.length) | 0;
	              var buf = createBuffer(length);
	              for (var i = 0; i < length; i += 1) {
	                buf[i] = array[i] & 255;
	              }
	              return buf;
	            }
	            function fromArrayView(arrayView) {
	              if (isInstance(arrayView, Uint8Array)) {
	                var copy = new Uint8Array(arrayView);
	                return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
	              }
	              return fromArrayLike(arrayView);
	            }
	            function fromArrayBuffer(array, byteOffset, length) {
	              if (byteOffset < 0 || array.byteLength < byteOffset) {
	                throw new RangeError('"offset" is outside of buffer bounds');
	              }
	              if (array.byteLength < byteOffset + (length || 0)) {
	                throw new RangeError('"length" is outside of buffer bounds');
	              }
	              var buf;
	              if (byteOffset === undefined && length === undefined) {
	                buf = new Uint8Array(array);
	              } else if (length === undefined) {
	                buf = new Uint8Array(array, byteOffset);
	              } else {
	                buf = new Uint8Array(array, byteOffset, length);
	              }
	              Object.setPrototypeOf(buf, Buffer2.prototype);
	              return buf;
	            }
	            function fromObject(obj) {
	              if (Buffer2.isBuffer(obj)) {
	                var len = checked(obj.length) | 0;
	                var buf = createBuffer(len);
	                if (buf.length === 0) {
	                  return buf;
	                }
	                obj.copy(buf, 0, 0, len);
	                return buf;
	              }
	              if (obj.length !== undefined) {
	                if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
	                  return createBuffer(0);
	                }
	                return fromArrayLike(obj);
	              }
	              if (obj.type === "Buffer" && Array.isArray(obj.data)) {
	                return fromArrayLike(obj.data);
	              }
	            }
	            function checked(length) {
	              if (length >= K_MAX_LENGTH) {
	                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
	              }
	              return length | 0;
	            }
	            function SlowBuffer(length) {
	              if (+length != length) {
	                length = 0;
	              }
	              return Buffer2.alloc(+length);
	            }
	            Buffer2.isBuffer = function isBuffer(b) {
	              return b != null && b._isBuffer === true && b !== Buffer2.prototype;
	            };
	            Buffer2.compare = function compare(a, b) {
	              if (isInstance(a, Uint8Array)) a = Buffer2.from(a, a.offset, a.byteLength);
	              if (isInstance(b, Uint8Array)) b = Buffer2.from(b, b.offset, b.byteLength);
	              if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
	                throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
	              }
	              if (a === b) return 0;
	              var x = a.length;
	              var y = b.length;
	              for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	                if (a[i] !== b[i]) {
	                  x = a[i];
	                  y = b[i];
	                  break;
	                }
	              }
	              if (x < y) return -1;
	              if (y < x) return 1;
	              return 0;
	            };
	            Buffer2.isEncoding = function isEncoding(encoding) {
	              switch (String(encoding).toLowerCase()) {
	                case "hex":
	                case "utf8":
	                case "utf-8":
	                case "ascii":
	                case "latin1":
	                case "binary":
	                case "base64":
	                case "ucs2":
	                case "ucs-2":
	                case "utf16le":
	                case "utf-16le":
	                  return true;
	                default:
	                  return false;
	              }
	            };
	            Buffer2.concat = function concat(list, length) {
	              if (!Array.isArray(list)) {
	                throw new TypeError('"list" argument must be an Array of Buffers');
	              }
	              if (list.length === 0) {
	                return Buffer2.alloc(0);
	              }
	              var i;
	              if (length === undefined) {
	                length = 0;
	                for (i = 0; i < list.length; ++i) {
	                  length += list[i].length;
	                }
	              }
	              var buffer = Buffer2.allocUnsafe(length);
	              var pos = 0;
	              for (i = 0; i < list.length; ++i) {
	                var buf = list[i];
	                if (isInstance(buf, Uint8Array)) {
	                  if (pos + buf.length > buffer.length) {
	                    if (!Buffer2.isBuffer(buf)) buf = Buffer2.from(buf);
	                    buf.copy(buffer, pos);
	                  } else {
	                    Uint8Array.prototype.set.call(buffer, buf, pos);
	                  }
	                } else if (!Buffer2.isBuffer(buf)) {
	                  throw new TypeError('"list" argument must be an Array of Buffers');
	                } else {
	                  buf.copy(buffer, pos);
	                }
	                pos += buf.length;
	              }
	              return buffer;
	            };
	            function byteLength(string, encoding) {
	              if (Buffer2.isBuffer(string)) {
	                return string.length;
	              }
	              if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
	                return string.byteLength;
	              }
	              if (typeof string !== "string") {
	                throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + _typeof(string));
	              }
	              var len = string.length;
	              var mustMatch = arguments.length > 2 && arguments[2] === true;
	              if (!mustMatch && len === 0) return 0;
	              var loweredCase = false;
	              for (; ; ) {
	                switch (encoding) {
	                  case "ascii":
	                  case "latin1":
	                  case "binary":
	                    return len;
	                  case "utf8":
	                  case "utf-8":
	                    return utf8ToBytes(string).length;
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return len * 2;
	                  case "hex":
	                    return len >>> 1;
	                  case "base64":
	                    return base64ToBytes(string).length;
	                  default:
	                    if (loweredCase) {
	                      return mustMatch ? -1 : utf8ToBytes(string).length;
	                    }
	                    encoding = ("" + encoding).toLowerCase();
	                    loweredCase = true;
	                }
	              }
	            }
	            Buffer2.byteLength = byteLength;
	            function slowToString(encoding, start, end) {
	              var loweredCase = false;
	              if (start === undefined || start < 0) {
	                start = 0;
	              }
	              if (start > this.length) {
	                return "";
	              }
	              if (end === undefined || end > this.length) {
	                end = this.length;
	              }
	              if (end <= 0) {
	                return "";
	              }
	              end >>>= 0;
	              start >>>= 0;
	              if (end <= start) {
	                return "";
	              }
	              if (!encoding) encoding = "utf8";
	              while (true) {
	                switch (encoding) {
	                  case "hex":
	                    return hexSlice(this, start, end);
	                  case "utf8":
	                  case "utf-8":
	                    return utf8Slice(this, start, end);
	                  case "ascii":
	                    return asciiSlice(this, start, end);
	                  case "latin1":
	                  case "binary":
	                    return latin1Slice(this, start, end);
	                  case "base64":
	                    return base64Slice(this, start, end);
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return utf16leSlice(this, start, end);
	                  default:
	                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
	                    encoding = (encoding + "").toLowerCase();
	                    loweredCase = true;
	                }
	              }
	            }
	            Buffer2.prototype._isBuffer = true;
	            function swap(b, n, m) {
	              var i = b[n];
	              b[n] = b[m];
	              b[m] = i;
	            }
	            Buffer2.prototype.swap16 = function swap16() {
	              var len = this.length;
	              if (len % 2 !== 0) {
	                throw new RangeError("Buffer size must be a multiple of 16-bits");
	              }
	              for (var i = 0; i < len; i += 2) {
	                swap(this, i, i + 1);
	              }
	              return this;
	            };
	            Buffer2.prototype.swap32 = function swap32() {
	              var len = this.length;
	              if (len % 4 !== 0) {
	                throw new RangeError("Buffer size must be a multiple of 32-bits");
	              }
	              for (var i = 0; i < len; i += 4) {
	                swap(this, i, i + 3);
	                swap(this, i + 1, i + 2);
	              }
	              return this;
	            };
	            Buffer2.prototype.swap64 = function swap64() {
	              var len = this.length;
	              if (len % 8 !== 0) {
	                throw new RangeError("Buffer size must be a multiple of 64-bits");
	              }
	              for (var i = 0; i < len; i += 8) {
	                swap(this, i, i + 7);
	                swap(this, i + 1, i + 6);
	                swap(this, i + 2, i + 5);
	                swap(this, i + 3, i + 4);
	              }
	              return this;
	            };
	            Buffer2.prototype.toString = function toString() {
	              var length = this.length;
	              if (length === 0) return "";
	              if (arguments.length === 0) return utf8Slice(this, 0, length);
	              return slowToString.apply(this, arguments);
	            };
	            Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
	            Buffer2.prototype.equals = function equals(b) {
	              if (!Buffer2.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
	              if (this === b) return true;
	              return Buffer2.compare(this, b) === 0;
	            };
	            Buffer2.prototype.inspect = function inspect() {
	              var str = "";
	              var max = exports2.INSPECT_MAX_BYTES;
	              str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
	              if (this.length > max) str += " ... ";
	              return "<Buffer " + str + ">";
	            };
	            if (customInspectSymbol) {
	              Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
	            }
	            Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	              if (isInstance(target, Uint8Array)) {
	                target = Buffer2.from(target, target.offset, target.byteLength);
	              }
	              if (!Buffer2.isBuffer(target)) {
	                throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + _typeof(target));
	              }
	              if (start === undefined) {
	                start = 0;
	              }
	              if (end === undefined) {
	                end = target ? target.length : 0;
	              }
	              if (thisStart === undefined) {
	                thisStart = 0;
	              }
	              if (thisEnd === undefined) {
	                thisEnd = this.length;
	              }
	              if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	                throw new RangeError("out of range index");
	              }
	              if (thisStart >= thisEnd && start >= end) {
	                return 0;
	              }
	              if (thisStart >= thisEnd) {
	                return -1;
	              }
	              if (start >= end) {
	                return 1;
	              }
	              start >>>= 0;
	              end >>>= 0;
	              thisStart >>>= 0;
	              thisEnd >>>= 0;
	              if (this === target) return 0;
	              var x = thisEnd - thisStart;
	              var y = end - start;
	              var len = Math.min(x, y);
	              var thisCopy = this.slice(thisStart, thisEnd);
	              var targetCopy = target.slice(start, end);
	              for (var i = 0; i < len; ++i) {
	                if (thisCopy[i] !== targetCopy[i]) {
	                  x = thisCopy[i];
	                  y = targetCopy[i];
	                  break;
	                }
	              }
	              if (x < y) return -1;
	              if (y < x) return 1;
	              return 0;
	            };
	            function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	              if (buffer.length === 0) return -1;
	              if (typeof byteOffset === "string") {
	                encoding = byteOffset;
	                byteOffset = 0;
	              } else if (byteOffset > 2147483647) {
	                byteOffset = 2147483647;
	              } else if (byteOffset < -2147483648) {
	                byteOffset = -2147483648;
	              }
	              byteOffset = +byteOffset;
	              if (numberIsNaN(byteOffset)) {
	                byteOffset = dir ? 0 : buffer.length - 1;
	              }
	              if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	              if (byteOffset >= buffer.length) {
	                if (dir) return -1;
	                else byteOffset = buffer.length - 1;
	              } else if (byteOffset < 0) {
	                if (dir) byteOffset = 0;
	                else return -1;
	              }
	              if (typeof val === "string") {
	                val = Buffer2.from(val, encoding);
	              }
	              if (Buffer2.isBuffer(val)) {
	                if (val.length === 0) {
	                  return -1;
	                }
	                return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	              } else if (typeof val === "number") {
	                val = val & 255;
	                if (typeof Uint8Array.prototype.indexOf === "function") {
	                  if (dir) {
	                    return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	                  } else {
	                    return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	                  }
	                }
	                return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	              }
	              throw new TypeError("val must be string, number or Buffer");
	            }
	            function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	              var indexSize = 1;
	              var arrLength = arr.length;
	              var valLength = val.length;
	              if (encoding !== undefined) {
	                encoding = String(encoding).toLowerCase();
	                if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
	                  if (arr.length < 2 || val.length < 2) {
	                    return -1;
	                  }
	                  indexSize = 2;
	                  arrLength /= 2;
	                  valLength /= 2;
	                  byteOffset /= 2;
	                }
	              }
	              function read(buf, i2) {
	                if (indexSize === 1) {
	                  return buf[i2];
	                } else {
	                  return buf.readUInt16BE(i2 * indexSize);
	                }
	              }
	              var i;
	              if (dir) {
	                var foundIndex = -1;
	                for (i = byteOffset; i < arrLength; i++) {
	                  if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	                    if (foundIndex === -1) foundIndex = i;
	                    if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	                  } else {
	                    if (foundIndex !== -1) i -= i - foundIndex;
	                    foundIndex = -1;
	                  }
	                }
	              } else {
	                if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	                for (i = byteOffset; i >= 0; i--) {
	                  var found = true;
	                  for (var j = 0; j < valLength; j++) {
	                    if (read(arr, i + j) !== read(val, j)) {
	                      found = false;
	                      break;
	                    }
	                  }
	                  if (found) return i;
	                }
	              }
	              return -1;
	            }
	            Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
	              return this.indexOf(val, byteOffset, encoding) !== -1;
	            };
	            Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	              return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	            };
	            Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	              return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	            };
	            function hexWrite(buf, string, offset, length) {
	              offset = Number(offset) || 0;
	              var remaining = buf.length - offset;
	              if (!length) {
	                length = remaining;
	              } else {
	                length = Number(length);
	                if (length > remaining) {
	                  length = remaining;
	                }
	              }
	              var strLen = string.length;
	              if (length > strLen / 2) {
	                length = strLen / 2;
	              }
	              var i;
	              for (i = 0; i < length; ++i) {
	                var parsed = parseInt(string.substr(i * 2, 2), 16);
	                if (numberIsNaN(parsed)) return i;
	                buf[offset + i] = parsed;
	              }
	              return i;
	            }
	            function utf8Write(buf, string, offset, length) {
	              return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	            }
	            function asciiWrite(buf, string, offset, length) {
	              return blitBuffer(asciiToBytes(string), buf, offset, length);
	            }
	            function base64Write(buf, string, offset, length) {
	              return blitBuffer(base64ToBytes(string), buf, offset, length);
	            }
	            function ucs2Write(buf, string, offset, length) {
	              return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	            }
	            Buffer2.prototype.write = function write(string, offset, length, encoding) {
	              if (offset === undefined) {
	                encoding = "utf8";
	                length = this.length;
	                offset = 0;
	              } else if (length === undefined && typeof offset === "string") {
	                encoding = offset;
	                length = this.length;
	                offset = 0;
	              } else if (isFinite(offset)) {
	                offset = offset >>> 0;
	                if (isFinite(length)) {
	                  length = length >>> 0;
	                  if (encoding === undefined) encoding = "utf8";
	                } else {
	                  encoding = length;
	                  length = undefined;
	                }
	              } else {
	                throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
	              }
	              var remaining = this.length - offset;
	              if (length === undefined || length > remaining) length = remaining;
	              if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	                throw new RangeError("Attempt to write outside buffer bounds");
	              }
	              if (!encoding) encoding = "utf8";
	              var loweredCase = false;
	              for (; ; ) {
	                switch (encoding) {
	                  case "hex":
	                    return hexWrite(this, string, offset, length);
	                  case "utf8":
	                  case "utf-8":
	                    return utf8Write(this, string, offset, length);
	                  case "ascii":
	                  case "latin1":
	                  case "binary":
	                    return asciiWrite(this, string, offset, length);
	                  case "base64":
	                    return base64Write(this, string, offset, length);
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return ucs2Write(this, string, offset, length);
	                  default:
	                    if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
	                    encoding = ("" + encoding).toLowerCase();
	                    loweredCase = true;
	                }
	              }
	            };
	            Buffer2.prototype.toJSON = function toJSON() {
	              return {
	                type: "Buffer",
	                data: Array.prototype.slice.call(this._arr || this, 0)
	              };
	            };
	            function base64Slice(buf, start, end) {
	              if (start === 0 && end === buf.length) {
	                return base64.fromByteArray(buf);
	              } else {
	                return base64.fromByteArray(buf.slice(start, end));
	              }
	            }
	            function utf8Slice(buf, start, end) {
	              end = Math.min(buf.length, end);
	              var res = [];
	              var i = start;
	              while (i < end) {
	                var firstByte = buf[i];
	                var codePoint = null;
	                var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
	                if (i + bytesPerSequence <= end) {
	                  var secondByte = undefined, thirdByte = undefined, fourthByte = undefined, tempCodePoint = undefined;
	                  switch (bytesPerSequence) {
	                    case 1:
	                      if (firstByte < 128) {
	                        codePoint = firstByte;
	                      }
	                      break;
	                    case 2:
	                      secondByte = buf[i + 1];
	                      if ((secondByte & 192) === 128) {
	                        tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
	                        if (tempCodePoint > 127) {
	                          codePoint = tempCodePoint;
	                        }
	                      }
	                      break;
	                    case 3:
	                      secondByte = buf[i + 1];
	                      thirdByte = buf[i + 2];
	                      if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
	                        tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
	                        if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
	                          codePoint = tempCodePoint;
	                        }
	                      }
	                      break;
	                    case 4:
	                      secondByte = buf[i + 1];
	                      thirdByte = buf[i + 2];
	                      fourthByte = buf[i + 3];
	                      if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
	                        tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
	                        if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
	                          codePoint = tempCodePoint;
	                        }
	                      }
	                  }
	                }
	                if (codePoint === null) {
	                  codePoint = 65533;
	                  bytesPerSequence = 1;
	                } else if (codePoint > 65535) {
	                  codePoint -= 65536;
	                  res.push(codePoint >>> 10 & 1023 | 55296);
	                  codePoint = 56320 | codePoint & 1023;
	                }
	                res.push(codePoint);
	                i += bytesPerSequence;
	              }
	              return decodeCodePointsArray(res);
	            }
	            var MAX_ARGUMENTS_LENGTH = 4096;
	            function decodeCodePointsArray(codePoints) {
	              var len = codePoints.length;
	              if (len <= MAX_ARGUMENTS_LENGTH) {
	                return String.fromCharCode.apply(String, codePoints);
	              }
	              var res = "";
	              var i = 0;
	              while (i < len) {
	                res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	              }
	              return res;
	            }
	            function asciiSlice(buf, start, end) {
	              var ret = "";
	              end = Math.min(buf.length, end);
	              for (var i = start; i < end; ++i) {
	                ret += String.fromCharCode(buf[i] & 127);
	              }
	              return ret;
	            }
	            function latin1Slice(buf, start, end) {
	              var ret = "";
	              end = Math.min(buf.length, end);
	              for (var i = start; i < end; ++i) {
	                ret += String.fromCharCode(buf[i]);
	              }
	              return ret;
	            }
	            function hexSlice(buf, start, end) {
	              var len = buf.length;
	              if (!start || start < 0) start = 0;
	              if (!end || end < 0 || end > len) end = len;
	              var out = "";
	              for (var i = start; i < end; ++i) {
	                out += hexSliceLookupTable[buf[i]];
	              }
	              return out;
	            }
	            function utf16leSlice(buf, start, end) {
	              var bytes = buf.slice(start, end);
	              var res = "";
	              for (var i = 0; i < bytes.length - 1; i += 2) {
	                res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	              }
	              return res;
	            }
	            Buffer2.prototype.slice = function slice2(start, end) {
	              var len = this.length;
	              start = ~~start;
	              end = end === undefined ? len : ~~end;
	              if (start < 0) {
	                start += len;
	                if (start < 0) start = 0;
	              } else if (start > len) {
	                start = len;
	              }
	              if (end < 0) {
	                end += len;
	                if (end < 0) end = 0;
	              } else if (end > len) {
	                end = len;
	              }
	              if (end < start) end = start;
	              var newBuf = this.subarray(start, end);
	              Object.setPrototypeOf(newBuf, Buffer2.prototype);
	              return newBuf;
	            };
	            function checkOffset(offset, ext, length) {
	              if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
	              if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
	            }
	            Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
	              offset = offset >>> 0;
	              byteLength2 = byteLength2 >>> 0;
	              if (!noAssert) checkOffset(offset, byteLength2, this.length);
	              var val = this[offset];
	              var mul = 1;
	              var i = 0;
	              while (++i < byteLength2 && (mul *= 256)) {
	                val += this[offset + i] * mul;
	              }
	              return val;
	            };
	            Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
	              offset = offset >>> 0;
	              byteLength2 = byteLength2 >>> 0;
	              if (!noAssert) {
	                checkOffset(offset, byteLength2, this.length);
	              }
	              var val = this[offset + --byteLength2];
	              var mul = 1;
	              while (byteLength2 > 0 && (mul *= 256)) {
	                val += this[offset + --byteLength2] * mul;
	              }
	              return val;
	            };
	            Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 1, this.length);
	              return this[offset];
	            };
	            Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 2, this.length);
	              return this[offset] | this[offset + 1] << 8;
	            };
	            Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 2, this.length);
	              return this[offset] << 8 | this[offset + 1];
	            };
	            Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 4, this.length);
	              return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
	            };
	            Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 4, this.length);
	              return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	            };
	            Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
	              offset = offset >>> 0;
	              validateNumber(offset, "offset");
	              var first = this[offset];
	              var last = this[offset + 7];
	              if (first === undefined || last === undefined) {
	                boundsError(offset, this.length - 8);
	              }
	              var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
	              var hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
	              return BigInt(lo) + (BigInt(hi) << BigInt(32));
	            });
	            Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
	              offset = offset >>> 0;
	              validateNumber(offset, "offset");
	              var first = this[offset];
	              var last = this[offset + 7];
	              if (first === undefined || last === undefined) {
	                boundsError(offset, this.length - 8);
	              }
	              var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
	              var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
	              return (BigInt(hi) << BigInt(32)) + BigInt(lo);
	            });
	            Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
	              offset = offset >>> 0;
	              byteLength2 = byteLength2 >>> 0;
	              if (!noAssert) checkOffset(offset, byteLength2, this.length);
	              var val = this[offset];
	              var mul = 1;
	              var i = 0;
	              while (++i < byteLength2 && (mul *= 256)) {
	                val += this[offset + i] * mul;
	              }
	              mul *= 128;
	              if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
	              return val;
	            };
	            Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
	              offset = offset >>> 0;
	              byteLength2 = byteLength2 >>> 0;
	              if (!noAssert) checkOffset(offset, byteLength2, this.length);
	              var i = byteLength2;
	              var mul = 1;
	              var val = this[offset + --i];
	              while (i > 0 && (mul *= 256)) {
	                val += this[offset + --i] * mul;
	              }
	              mul *= 128;
	              if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
	              return val;
	            };
	            Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 1, this.length);
	              if (!(this[offset] & 128)) return this[offset];
	              return (255 - this[offset] + 1) * -1;
	            };
	            Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 2, this.length);
	              var val = this[offset] | this[offset + 1] << 8;
	              return val & 32768 ? val | 4294901760 : val;
	            };
	            Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 2, this.length);
	              var val = this[offset + 1] | this[offset] << 8;
	              return val & 32768 ? val | 4294901760 : val;
	            };
	            Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 4, this.length);
	              return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	            };
	            Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 4, this.length);
	              return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	            };
	            Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
	              offset = offset >>> 0;
	              validateNumber(offset, "offset");
	              var first = this[offset];
	              var last = this[offset + 7];
	              if (first === undefined || last === undefined) {
	                boundsError(offset, this.length - 8);
	              }
	              var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24);
	              return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
	            });
	            Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
	              offset = offset >>> 0;
	              validateNumber(offset, "offset");
	              var first = this[offset];
	              var last = this[offset + 7];
	              if (first === undefined || last === undefined) {
	                boundsError(offset, this.length - 8);
	              }
	              var val = (first << 24) + // Overflow
	              this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
	              return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
	            });
	            Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 4, this.length);
	              return ieee754.read(this, offset, true, 23, 4);
	            };
	            Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 4, this.length);
	              return ieee754.read(this, offset, false, 23, 4);
	            };
	            Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 8, this.length);
	              return ieee754.read(this, offset, true, 52, 8);
	            };
	            Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	              offset = offset >>> 0;
	              if (!noAssert) checkOffset(offset, 8, this.length);
	              return ieee754.read(this, offset, false, 52, 8);
	            };
	            function checkInt(buf, value, offset, ext, max, min) {
	              if (!Buffer2.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	              if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	              if (offset + ext > buf.length) throw new RangeError("Index out of range");
	            }
	            Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              byteLength2 = byteLength2 >>> 0;
	              if (!noAssert) {
	                var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
	                checkInt(this, value, offset, byteLength2, maxBytes, 0);
	              }
	              var mul = 1;
	              var i = 0;
	              this[offset] = value & 255;
	              while (++i < byteLength2 && (mul *= 256)) {
	                this[offset + i] = value / mul & 255;
	              }
	              return offset + byteLength2;
	            };
	            Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              byteLength2 = byteLength2 >>> 0;
	              if (!noAssert) {
	                var maxBytes = Math.pow(2, 8 * byteLength2) - 1;
	                checkInt(this, value, offset, byteLength2, maxBytes, 0);
	              }
	              var i = byteLength2 - 1;
	              var mul = 1;
	              this[offset + i] = value & 255;
	              while (--i >= 0 && (mul *= 256)) {
	                this[offset + i] = value / mul & 255;
	              }
	              return offset + byteLength2;
	            };
	            Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
	              this[offset] = value & 255;
	              return offset + 1;
	            };
	            Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
	              this[offset] = value & 255;
	              this[offset + 1] = value >>> 8;
	              return offset + 2;
	            };
	            Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
	              this[offset] = value >>> 8;
	              this[offset + 1] = value & 255;
	              return offset + 2;
	            };
	            Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
	              this[offset + 3] = value >>> 24;
	              this[offset + 2] = value >>> 16;
	              this[offset + 1] = value >>> 8;
	              this[offset] = value & 255;
	              return offset + 4;
	            };
	            Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
	              this[offset] = value >>> 24;
	              this[offset + 1] = value >>> 16;
	              this[offset + 2] = value >>> 8;
	              this[offset + 3] = value & 255;
	              return offset + 4;
	            };
	            function wrtBigUInt64LE(buf, value, offset, min, max) {
	              checkIntBI(value, min, max, buf, offset, 7);
	              var lo = Number(value & BigInt(4294967295));
	              buf[offset++] = lo;
	              lo = lo >> 8;
	              buf[offset++] = lo;
	              lo = lo >> 8;
	              buf[offset++] = lo;
	              lo = lo >> 8;
	              buf[offset++] = lo;
	              var hi = Number(value >> BigInt(32) & BigInt(4294967295));
	              buf[offset++] = hi;
	              hi = hi >> 8;
	              buf[offset++] = hi;
	              hi = hi >> 8;
	              buf[offset++] = hi;
	              hi = hi >> 8;
	              buf[offset++] = hi;
	              return offset;
	            }
	            function wrtBigUInt64BE(buf, value, offset, min, max) {
	              checkIntBI(value, min, max, buf, offset, 7);
	              var lo = Number(value & BigInt(4294967295));
	              buf[offset + 7] = lo;
	              lo = lo >> 8;
	              buf[offset + 6] = lo;
	              lo = lo >> 8;
	              buf[offset + 5] = lo;
	              lo = lo >> 8;
	              buf[offset + 4] = lo;
	              var hi = Number(value >> BigInt(32) & BigInt(4294967295));
	              buf[offset + 3] = hi;
	              hi = hi >> 8;
	              buf[offset + 2] = hi;
	              hi = hi >> 8;
	              buf[offset + 1] = hi;
	              hi = hi >> 8;
	              buf[offset] = hi;
	              return offset + 8;
	            }
	            Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value) {
	              var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	              return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	            });
	            Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value) {
	              var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	              return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
	            });
	            Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) {
	                var limit = Math.pow(2, 8 * byteLength2 - 1);
	                checkInt(this, value, offset, byteLength2, limit - 1, -limit);
	              }
	              var i = 0;
	              var mul = 1;
	              var sub = 0;
	              this[offset] = value & 255;
	              while (++i < byteLength2 && (mul *= 256)) {
	                if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	                  sub = 1;
	                }
	                this[offset + i] = (value / mul >> 0) - sub & 255;
	              }
	              return offset + byteLength2;
	            };
	            Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) {
	                var limit = Math.pow(2, 8 * byteLength2 - 1);
	                checkInt(this, value, offset, byteLength2, limit - 1, -limit);
	              }
	              var i = byteLength2 - 1;
	              var mul = 1;
	              var sub = 0;
	              this[offset + i] = value & 255;
	              while (--i >= 0 && (mul *= 256)) {
	                if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	                  sub = 1;
	                }
	                this[offset + i] = (value / mul >> 0) - sub & 255;
	              }
	              return offset + byteLength2;
	            };
	            Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
	              if (value < 0) value = 255 + value + 1;
	              this[offset] = value & 255;
	              return offset + 1;
	            };
	            Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
	              this[offset] = value & 255;
	              this[offset + 1] = value >>> 8;
	              return offset + 2;
	            };
	            Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
	              this[offset] = value >>> 8;
	              this[offset + 1] = value & 255;
	              return offset + 2;
	            };
	            Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
	              this[offset] = value & 255;
	              this[offset + 1] = value >>> 8;
	              this[offset + 2] = value >>> 16;
	              this[offset + 3] = value >>> 24;
	              return offset + 4;
	            };
	            Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
	              if (value < 0) value = 4294967295 + value + 1;
	              this[offset] = value >>> 24;
	              this[offset + 1] = value >>> 16;
	              this[offset + 2] = value >>> 8;
	              this[offset + 3] = value & 255;
	              return offset + 4;
	            };
	            Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value) {
	              var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	              return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	            });
	            Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value) {
	              var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	              return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
	            });
	            function checkIEEE754(buf, value, offset, ext, max, min) {
	              if (offset + ext > buf.length) throw new RangeError("Index out of range");
	              if (offset < 0) throw new RangeError("Index out of range");
	            }
	            function writeFloat(buf, value, offset, littleEndian, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) {
	                checkIEEE754(buf, value, offset, 4);
	              }
	              ieee754.write(buf, value, offset, littleEndian, 23, 4);
	              return offset + 4;
	            }
	            Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	              return writeFloat(this, value, offset, true, noAssert);
	            };
	            Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	              return writeFloat(this, value, offset, false, noAssert);
	            };
	            function writeDouble(buf, value, offset, littleEndian, noAssert) {
	              value = +value;
	              offset = offset >>> 0;
	              if (!noAssert) {
	                checkIEEE754(buf, value, offset, 8);
	              }
	              ieee754.write(buf, value, offset, littleEndian, 52, 8);
	              return offset + 8;
	            }
	            Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	              return writeDouble(this, value, offset, true, noAssert);
	            };
	            Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	              return writeDouble(this, value, offset, false, noAssert);
	            };
	            Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
	              if (!Buffer2.isBuffer(target)) throw new TypeError("argument should be a Buffer");
	              if (!start) start = 0;
	              if (!end && end !== 0) end = this.length;
	              if (targetStart >= target.length) targetStart = target.length;
	              if (!targetStart) targetStart = 0;
	              if (end > 0 && end < start) end = start;
	              if (end === start) return 0;
	              if (target.length === 0 || this.length === 0) return 0;
	              if (targetStart < 0) {
	                throw new RangeError("targetStart out of bounds");
	              }
	              if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
	              if (end < 0) throw new RangeError("sourceEnd out of bounds");
	              if (end > this.length) end = this.length;
	              if (target.length - targetStart < end - start) {
	                end = target.length - targetStart + start;
	              }
	              var len = end - start;
	              if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
	                this.copyWithin(targetStart, start, end);
	              } else {
	                Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
	              }
	              return len;
	            };
	            Buffer2.prototype.fill = function fill(val, start, end, encoding) {
	              if (typeof val === "string") {
	                if (typeof start === "string") {
	                  encoding = start;
	                  start = 0;
	                  end = this.length;
	                } else if (typeof end === "string") {
	                  encoding = end;
	                  end = this.length;
	                }
	                if (encoding !== undefined && typeof encoding !== "string") {
	                  throw new TypeError("encoding must be a string");
	                }
	                if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
	                  throw new TypeError("Unknown encoding: " + encoding);
	                }
	                if (val.length === 1) {
	                  var code = val.charCodeAt(0);
	                  if (encoding === "utf8" && code < 128 || encoding === "latin1") {
	                    val = code;
	                  }
	                }
	              } else if (typeof val === "number") {
	                val = val & 255;
	              } else if (typeof val === "boolean") {
	                val = Number(val);
	              }
	              if (start < 0 || this.length < start || this.length < end) {
	                throw new RangeError("Out of range index");
	              }
	              if (end <= start) {
	                return this;
	              }
	              start = start >>> 0;
	              end = end === undefined ? this.length : end >>> 0;
	              if (!val) val = 0;
	              var i;
	              if (typeof val === "number") {
	                for (i = start; i < end; ++i) {
	                  this[i] = val;
	                }
	              } else {
	                var bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
	                var len = bytes.length;
	                if (len === 0) {
	                  throw new TypeError('The value "' + val + '" is invalid for argument "value"');
	                }
	                for (i = 0; i < end - start; ++i) {
	                  this[i + start] = bytes[i % len];
	                }
	              }
	              return this;
	            };
	            var errors = {};
	            function E(sym, getMessage, Base) {
	              errors[sym] = /* @__PURE__ */ function(_Base) {
	                _inherits(NodeError, _Base);
	                var _super = _createSuper(NodeError);
	                function NodeError() {
	                  var _this;
	                  _classCallCheck(this, NodeError);
	                  _this = _super.call(this);
	                  Object.defineProperty(_assertThisInitialized(_this), "message", {
	                    value: getMessage.apply(_assertThisInitialized(_this), arguments),
	                    writable: true,
	                    configurable: true
	                  });
	                  _this.name = "".concat(_this.name, " [").concat(sym, "]");
	                  _this.stack;
	                  delete _this.name;
	                  return _this;
	                }
	                _createClass(NodeError, [{
	                  key: "code",
	                  get: function get() {
	                    return sym;
	                  },
	                  set: function set(value) {
	                    Object.defineProperty(this, "code", {
	                      configurable: true,
	                      enumerable: true,
	                      value,
	                      writable: true
	                    });
	                  }
	                }, {
	                  key: "toString",
	                  value: function toString() {
	                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
	                  }
	                }]);
	                return NodeError;
	              }(Base);
	            }
	            E("ERR_BUFFER_OUT_OF_BOUNDS", function(name2) {
	              if (name2) {
	                return "".concat(name2, " is outside of buffer bounds");
	              }
	              return "Attempt to access memory outside buffer bounds";
	            }, RangeError);
	            E("ERR_INVALID_ARG_TYPE", function(name2, actual) {
	              return 'The "'.concat(name2, '" argument must be of type number. Received type ').concat(_typeof(actual));
	            }, TypeError);
	            E("ERR_OUT_OF_RANGE", function(str, range2, input) {
	              var msg = 'The value of "'.concat(str, '" is out of range.');
	              var received = input;
	              if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
	                received = addNumericalSeparator(String(input));
	              } else if (typeof input === "bigint") {
	                received = String(input);
	                if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) {
	                  received = addNumericalSeparator(received);
	                }
	                received += "n";
	              }
	              msg += " It must be ".concat(range2, ". Received ").concat(received);
	              return msg;
	            }, RangeError);
	            function addNumericalSeparator(val) {
	              var res = "";
	              var i = val.length;
	              var start = val[0] === "-" ? 1 : 0;
	              for (; i >= start + 4; i -= 3) {
	                res = "_".concat(val.slice(i - 3, i)).concat(res);
	              }
	              return "".concat(val.slice(0, i)).concat(res);
	            }
	            function checkBounds(buf, offset, byteLength2) {
	              validateNumber(offset, "offset");
	              if (buf[offset] === undefined || buf[offset + byteLength2] === undefined) {
	                boundsError(offset, buf.length - (byteLength2 + 1));
	              }
	            }
	            function checkIntBI(value, min, max, buf, offset, byteLength2) {
	              if (value > max || value < min) {
	                var n = typeof min === "bigint" ? "n" : "";
	                var range2;
	                {
	                  if (min === 0 || min === BigInt(0)) {
	                    range2 = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength2 + 1) * 8).concat(n);
	                  } else {
	                    range2 = ">= -(2".concat(n, " ** ").concat((byteLength2 + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength2 + 1) * 8 - 1).concat(n);
	                  }
	                }
	                throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
	              }
	              checkBounds(buf, offset, byteLength2);
	            }
	            function validateNumber(value, name2) {
	              if (typeof value !== "number") {
	                throw new errors.ERR_INVALID_ARG_TYPE(name2, "number", value);
	              }
	            }
	            function boundsError(value, length, type) {
	              if (Math.floor(value) !== value) {
	                validateNumber(value, type);
	                throw new errors.ERR_OUT_OF_RANGE("offset", "an integer", value);
	              }
	              if (length < 0) {
	                throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
	              }
	              throw new errors.ERR_OUT_OF_RANGE("offset", ">= ".concat(0, " and <= ").concat(length), value);
	            }
	            var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
	            function base64clean(str) {
	              str = str.split("=")[0];
	              str = str.trim().replace(INVALID_BASE64_RE, "");
	              if (str.length < 2) return "";
	              while (str.length % 4 !== 0) {
	                str = str + "=";
	              }
	              return str;
	            }
	            function utf8ToBytes(string, units) {
	              units = units || Infinity;
	              var codePoint;
	              var length = string.length;
	              var leadSurrogate = null;
	              var bytes = [];
	              for (var i = 0; i < length; ++i) {
	                codePoint = string.charCodeAt(i);
	                if (codePoint > 55295 && codePoint < 57344) {
	                  if (!leadSurrogate) {
	                    if (codePoint > 56319) {
	                      if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                      continue;
	                    } else if (i + 1 === length) {
	                      if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                      continue;
	                    }
	                    leadSurrogate = codePoint;
	                    continue;
	                  }
	                  if (codePoint < 56320) {
	                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                    leadSurrogate = codePoint;
	                    continue;
	                  }
	                  codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
	                } else if (leadSurrogate) {
	                  if ((units -= 3) > -1) bytes.push(239, 191, 189);
	                }
	                leadSurrogate = null;
	                if (codePoint < 128) {
	                  if ((units -= 1) < 0) break;
	                  bytes.push(codePoint);
	                } else if (codePoint < 2048) {
	                  if ((units -= 2) < 0) break;
	                  bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
	                } else if (codePoint < 65536) {
	                  if ((units -= 3) < 0) break;
	                  bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
	                } else if (codePoint < 1114112) {
	                  if ((units -= 4) < 0) break;
	                  bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
	                } else {
	                  throw new Error("Invalid code point");
	                }
	              }
	              return bytes;
	            }
	            function asciiToBytes(str) {
	              var byteArray = [];
	              for (var i = 0; i < str.length; ++i) {
	                byteArray.push(str.charCodeAt(i) & 255);
	              }
	              return byteArray;
	            }
	            function utf16leToBytes(str, units) {
	              var c, hi, lo;
	              var byteArray = [];
	              for (var i = 0; i < str.length; ++i) {
	                if ((units -= 2) < 0) break;
	                c = str.charCodeAt(i);
	                hi = c >> 8;
	                lo = c % 256;
	                byteArray.push(lo);
	                byteArray.push(hi);
	              }
	              return byteArray;
	            }
	            function base64ToBytes(str) {
	              return base64.toByteArray(base64clean(str));
	            }
	            function blitBuffer(src, dst, offset, length) {
	              var i;
	              for (i = 0; i < length; ++i) {
	                if (i + offset >= dst.length || i >= src.length) break;
	                dst[i + offset] = src[i];
	              }
	              return i;
	            }
	            function isInstance(obj, type) {
	              return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
	            }
	            function numberIsNaN(obj) {
	              return obj !== obj;
	            }
	            var hexSliceLookupTable = function() {
	              var alphabet = "0123456789abcdef";
	              var table = new Array(256);
	              for (var i = 0; i < 16; ++i) {
	                var i16 = i * 16;
	                for (var j = 0; j < 16; ++j) {
	                  table[i16 + j] = alphabet[i] + alphabet[j];
	                }
	              }
	              return table;
	            }();
	            function defineBigIntMethod(fn) {
	              return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
	            }
	            function BufferBigIntNotDefined() {
	              throw new Error("BigInt not supported");
	            }
	          }
	        ),
	        /***/
	        35791: (
	          /***/
	          function(module2) {
	            module2.exports = isMobile;
	            module2.exports.isMobile = isMobile;
	            module2.exports["default"] = isMobile;
	            var mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
	            var notMobileRE = /CrOS/;
	            var tabletRE = /android|ipad|playbook|silk/i;
	            function isMobile(opts) {
	              if (!opts) opts = {};
	              var ua = opts.ua;
	              if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
	              if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
	                ua = ua.headers["user-agent"];
	              }
	              if (typeof ua !== "string") return false;
	              var result = mobileRE.test(ua) && !notMobileRE.test(ua) || !!opts.tablet && tabletRE.test(ua);
	              if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) {
	                result = true;
	              }
	              return result;
	            }
	          }
	        ),
	        /***/
	        86781: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              sankeyCenter: function() {
	                return (
	                  /* binding */
	                  center
	                );
	              },
	              /* harmony export */
	              sankeyCircular: function() {
	                return (
	                  /* binding */
	                  sankeyCircular
	                );
	              },
	              /* harmony export */
	              sankeyJustify: function() {
	                return (
	                  /* binding */
	                  justify
	                );
	              },
	              /* harmony export */
	              sankeyLeft: function() {
	                return (
	                  /* binding */
	                  left
	                );
	              },
	              /* harmony export */
	              sankeyRight: function() {
	                return (
	                  /* binding */
	                  right
	                );
	              }
	              /* harmony export */
	            });
	            var d3_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(33064);
	            var d3_collection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(15140);
	            var d3_shape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(45879);
	            var elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(2502);
	            var elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2___default = /* @__PURE__ */ __webpack_require__2.n(elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2__);
	            function targetDepth(d) {
	              return d.target.depth;
	            }
	            function left(node) {
	              return node.depth;
	            }
	            function right(node, n) {
	              return n - 1 - node.height;
	            }
	            function justify(node, n) {
	              return node.sourceLinks.length ? node.depth : n - 1;
	            }
	            function center(node) {
	              return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.VV)(node.sourceLinks, targetDepth) - 1 : 0;
	            }
	            function constant2(x) {
	              return function() {
	                return x;
	              };
	            }
	            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
	              return typeof obj;
	            } : function(obj) {
	              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	            };
	            function ascendingSourceBreadth(a, b) {
	              return ascendingBreadth(a.source, b.source) || a.index - b.index;
	            }
	            function ascendingTargetBreadth(a, b) {
	              return ascendingBreadth(a.target, b.target) || a.index - b.index;
	            }
	            function ascendingBreadth(a, b) {
	              if (a.partOfCycle === b.partOfCycle) {
	                return a.y0 - b.y0;
	              } else {
	                if (a.circularLinkType === "top" || b.circularLinkType === "bottom") {
	                  return -1;
	                } else {
	                  return 1;
	                }
	              }
	            }
	            function value(d) {
	              return d.value;
	            }
	            function nodeCenter(node) {
	              return (node.y0 + node.y1) / 2;
	            }
	            function linkSourceCenter(link) {
	              return nodeCenter(link.source);
	            }
	            function linkTargetCenter(link) {
	              return nodeCenter(link.target);
	            }
	            function defaultId(d) {
	              return d.index;
	            }
	            function defaultNodes(graph) {
	              return graph.nodes;
	            }
	            function defaultLinks(graph) {
	              return graph.links;
	            }
	            function find(nodeById, id) {
	              var node = nodeById.get(id);
	              if (!node) throw new Error("missing: " + id);
	              return node;
	            }
	            function getNodeID(node, id) {
	              return id(node);
	            }
	            var verticalMargin = 25;
	            var baseRadius = 10;
	            var scale = 0.3;
	            function sankeyCircular() {
	              var x0 = 0, y0 = 0, x1 = 1, y1 = 1, dx = 24, py, id = defaultId, align = justify, nodes = defaultNodes, links = defaultLinks, iterations = 32, circularLinkGap = 2, paddingRatio, sortNodes = null;
	              function sankeyCircular2() {
	                var graph = {
	                  nodes: nodes.apply(null, arguments),
	                  links: links.apply(null, arguments)
	                  // Process the graph's nodes and links, setting their positions
	                  // 1.  Associate the nodes with their respective links, and vice versa
	                };
	                computeNodeLinks(graph);
	                identifyCircles(graph, id, sortNodes);
	                computeNodeValues(graph);
	                computeNodeDepths(graph);
	                selectCircularLinkTypes(graph, id);
	                computeNodeBreadths(graph, iterations, id);
	                computeLinkBreadths(graph);
	                var linkSortingIterations = 4;
	                for (var iteration = 0; iteration < linkSortingIterations; iteration++) {
	                  sortSourceLinks(graph, y1, id);
	                  sortTargetLinks(graph, y1, id);
	                  resolveNodeLinkOverlaps(graph, y0, y1, id);
	                  sortSourceLinks(graph, y1, id);
	                  sortTargetLinks(graph, y1, id);
	                }
	                fillHeight(graph, y0, y1);
	                addCircularPathData(graph, circularLinkGap, y1, id);
	                return graph;
	              }
	              sankeyCircular2.nodeId = function(_) {
	                return arguments.length ? (id = typeof _ === "function" ? _ : constant2(_), sankeyCircular2) : id;
	              };
	              sankeyCircular2.nodeAlign = function(_) {
	                return arguments.length ? (align = typeof _ === "function" ? _ : constant2(_), sankeyCircular2) : align;
	              };
	              sankeyCircular2.nodeWidth = function(_) {
	                return arguments.length ? (dx = +_, sankeyCircular2) : dx;
	              };
	              sankeyCircular2.nodePadding = function(_) {
	                return arguments.length ? (py = +_, sankeyCircular2) : py;
	              };
	              sankeyCircular2.nodes = function(_) {
	                return arguments.length ? (nodes = typeof _ === "function" ? _ : constant2(_), sankeyCircular2) : nodes;
	              };
	              sankeyCircular2.links = function(_) {
	                return arguments.length ? (links = typeof _ === "function" ? _ : constant2(_), sankeyCircular2) : links;
	              };
	              sankeyCircular2.size = function(_) {
	                return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankeyCircular2) : [x1 - x0, y1 - y0];
	              };
	              sankeyCircular2.extent = function(_) {
	                return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankeyCircular2) : [[x0, y0], [x1, y1]];
	              };
	              sankeyCircular2.iterations = function(_) {
	                return arguments.length ? (iterations = +_, sankeyCircular2) : iterations;
	              };
	              sankeyCircular2.circularLinkGap = function(_) {
	                return arguments.length ? (circularLinkGap = +_, sankeyCircular2) : circularLinkGap;
	              };
	              sankeyCircular2.nodePaddingRatio = function(_) {
	                return arguments.length ? (paddingRatio = +_, sankeyCircular2) : paddingRatio;
	              };
	              sankeyCircular2.sortNodes = function(_) {
	                return arguments.length ? (sortNodes = _, sankeyCircular2) : sortNodes;
	              };
	              sankeyCircular2.update = function(graph) {
	                selectCircularLinkTypes(graph, id);
	                computeLinkBreadths(graph);
	                graph.links.forEach(function(link) {
	                  if (link.circular) {
	                    link.circularLinkType = link.y0 + link.y1 < y1 ? "top" : "bottom";
	                    link.source.circularLinkType = link.circularLinkType;
	                    link.target.circularLinkType = link.circularLinkType;
	                  }
	                });
	                sortSourceLinks(graph, y1, id, false);
	                sortTargetLinks(graph, y1, id);
	                addCircularPathData(graph, circularLinkGap, y1, id);
	                return graph;
	              };
	              function computeNodeLinks(graph) {
	                graph.nodes.forEach(function(node, i) {
	                  node.index = i;
	                  node.sourceLinks = [];
	                  node.targetLinks = [];
	                });
	                var nodeById = (0, d3_collection__WEBPACK_IMPORTED_MODULE_1__.UI)(graph.nodes, id);
	                graph.links.forEach(function(link, i) {
	                  link.index = i;
	                  var source = link.source;
	                  var target = link.target;
	                  if ((typeof source === "undefined" ? "undefined" : _typeof(source)) !== "object") {
	                    source = link.source = find(nodeById, source);
	                  }
	                  if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object") {
	                    target = link.target = find(nodeById, target);
	                  }
	                  source.sourceLinks.push(link);
	                  target.targetLinks.push(link);
	                });
	                return graph;
	              }
	              function computeNodeValues(graph) {
	                graph.nodes.forEach(function(node) {
	                  node.partOfCycle = false;
	                  node.value = Math.max((0, d3_array__WEBPACK_IMPORTED_MODULE_0__.Sm)(node.sourceLinks, value), (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.Sm)(node.targetLinks, value));
	                  node.sourceLinks.forEach(function(link) {
	                    if (link.circular) {
	                      node.partOfCycle = true;
	                      node.circularLinkType = link.circularLinkType;
	                    }
	                  });
	                  node.targetLinks.forEach(function(link) {
	                    if (link.circular) {
	                      node.partOfCycle = true;
	                      node.circularLinkType = link.circularLinkType;
	                    }
	                  });
	                });
	              }
	              function getCircleMargins(graph) {
	                var totalTopLinksWidth = 0, totalBottomLinksWidth = 0, totalRightLinksWidth = 0, totalLeftLinksWidth = 0;
	                var maxColumn = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.Fp)(graph.nodes, function(node) {
	                  return node.column;
	                });
	                graph.links.forEach(function(link) {
	                  if (link.circular) {
	                    if (link.circularLinkType == "top") {
	                      totalTopLinksWidth = totalTopLinksWidth + link.width;
	                    } else {
	                      totalBottomLinksWidth = totalBottomLinksWidth + link.width;
	                    }
	                    if (link.target.column == 0) {
	                      totalLeftLinksWidth = totalLeftLinksWidth + link.width;
	                    }
	                    if (link.source.column == maxColumn) {
	                      totalRightLinksWidth = totalRightLinksWidth + link.width;
	                    }
	                  }
	                });
	                totalTopLinksWidth = totalTopLinksWidth > 0 ? totalTopLinksWidth + verticalMargin + baseRadius : totalTopLinksWidth;
	                totalBottomLinksWidth = totalBottomLinksWidth > 0 ? totalBottomLinksWidth + verticalMargin + baseRadius : totalBottomLinksWidth;
	                totalRightLinksWidth = totalRightLinksWidth > 0 ? totalRightLinksWidth + verticalMargin + baseRadius : totalRightLinksWidth;
	                totalLeftLinksWidth = totalLeftLinksWidth > 0 ? totalLeftLinksWidth + verticalMargin + baseRadius : totalLeftLinksWidth;
	                return { "top": totalTopLinksWidth, "bottom": totalBottomLinksWidth, "left": totalLeftLinksWidth, "right": totalRightLinksWidth };
	              }
	              function scaleSankeySize(graph, margin) {
	                var maxColumn = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.Fp)(graph.nodes, function(node) {
	                  return node.column;
	                });
	                var currentWidth = x1 - x0;
	                var currentHeight = y1 - y0;
	                var newWidth = currentWidth + margin.right + margin.left;
	                var newHeight = currentHeight + margin.top + margin.bottom;
	                var scaleX = currentWidth / newWidth;
	                var scaleY = currentHeight / newHeight;
	                x0 = x0 * scaleX + margin.left;
	                x1 = margin.right == 0 ? x1 : x1 * scaleX;
	                y0 = y0 * scaleY + margin.top;
	                y1 = y1 * scaleY;
	                graph.nodes.forEach(function(node) {
	                  node.x0 = x0 + node.column * ((x1 - x0 - dx) / maxColumn);
	                  node.x1 = node.x0 + dx;
	                });
	                return scaleY;
	              }
	              function computeNodeDepths(graph) {
	                var nodes2, next, x;
	                for (nodes2 = graph.nodes, next = [], x = 0; nodes2.length; ++x, nodes2 = next, next = []) {
	                  nodes2.forEach(function(node) {
	                    node.depth = x;
	                    node.sourceLinks.forEach(function(link) {
	                      if (next.indexOf(link.target) < 0 && !link.circular) {
	                        next.push(link.target);
	                      }
	                    });
	                  });
	                }
	                for (nodes2 = graph.nodes, next = [], x = 0; nodes2.length; ++x, nodes2 = next, next = []) {
	                  nodes2.forEach(function(node) {
	                    node.height = x;
	                    node.targetLinks.forEach(function(link) {
	                      if (next.indexOf(link.source) < 0 && !link.circular) {
	                        next.push(link.source);
	                      }
	                    });
	                  });
	                }
	                graph.nodes.forEach(function(node) {
	                  node.column = Math.floor(align.call(null, node, x));
	                });
	              }
	              function computeNodeBreadths(graph, iterations2, id2) {
	                var columns = (0, d3_collection__WEBPACK_IMPORTED_MODULE_1__.b1)().key(function(d) {
	                  return d.column;
	                }).sortKeys(d3_array__WEBPACK_IMPORTED_MODULE_0__.j2).entries(graph.nodes).map(function(d) {
	                  return d.values;
	                });
	                initializeNodeBreadth(id2);
	                resolveCollisions();
	                for (var alpha = 1, n = iterations2; n > 0; --n) {
	                  relaxLeftAndRight(alpha *= 0.99, id2);
	                  resolveCollisions();
	                }
	                function initializeNodeBreadth(id3) {
	                  if (paddingRatio) {
	                    var padding = Infinity;
	                    columns.forEach(function(nodes2) {
	                      var thisPadding = y1 * paddingRatio / (nodes2.length + 1);
	                      padding = thisPadding < padding ? thisPadding : padding;
	                    });
	                    py = padding;
	                  }
	                  var ky = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.VV)(columns, function(nodes2) {
	                    return (y1 - y0 - (nodes2.length - 1) * py) / (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.Sm)(nodes2, value);
	                  });
	                  ky = ky * scale;
	                  graph.links.forEach(function(link) {
	                    link.width = link.value * ky;
	                  });
	                  var margin = getCircleMargins(graph);
	                  var ratio = scaleSankeySize(graph, margin);
	                  ky = ky * ratio;
	                  graph.links.forEach(function(link) {
	                    link.width = link.value * ky;
	                  });
	                  columns.forEach(function(nodes2) {
	                    var nodesLength = nodes2.length;
	                    nodes2.forEach(function(node, i) {
	                      if (node.depth == columns.length - 1 && nodesLength == 1) {
	                        node.y0 = y1 / 2 - node.value * ky;
	                        node.y1 = node.y0 + node.value * ky;
	                      } else if (node.depth == 0 && nodesLength == 1) {
	                        node.y0 = y1 / 2 - node.value * ky;
	                        node.y1 = node.y0 + node.value * ky;
	                      } else if (node.partOfCycle) {
	                        if (numberOfNonSelfLinkingCycles(node, id3) == 0) {
	                          node.y0 = y1 / 2 + i;
	                          node.y1 = node.y0 + node.value * ky;
	                        } else if (node.circularLinkType == "top") {
	                          node.y0 = y0 + i;
	                          node.y1 = node.y0 + node.value * ky;
	                        } else {
	                          node.y0 = y1 - node.value * ky - i;
	                          node.y1 = node.y0 + node.value * ky;
	                        }
	                      } else {
	                        if (margin.top == 0 || margin.bottom == 0) {
	                          node.y0 = (y1 - y0) / nodesLength * i;
	                          node.y1 = node.y0 + node.value * ky;
	                        } else {
	                          node.y0 = (y1 - y0) / 2 - nodesLength / 2 + i;
	                          node.y1 = node.y0 + node.value * ky;
	                        }
	                      }
	                    });
	                  });
	                }
	                function relaxLeftAndRight(alpha2, id3) {
	                  var columnsLength = columns.length;
	                  columns.forEach(function(nodes2) {
	                    var n2 = nodes2.length;
	                    var depth = nodes2[0].depth;
	                    nodes2.forEach(function(node) {
	                      var nodeHeight;
	                      if (node.sourceLinks.length || node.targetLinks.length) {
	                        if (node.partOfCycle && numberOfNonSelfLinkingCycles(node, id3) > 0) ;
	                        else if (depth == 0 && n2 == 1) {
	                          nodeHeight = node.y1 - node.y0;
	                          node.y0 = y1 / 2 - nodeHeight / 2;
	                          node.y1 = y1 / 2 + nodeHeight / 2;
	                        } else if (depth == columnsLength - 1 && n2 == 1) {
	                          nodeHeight = node.y1 - node.y0;
	                          node.y0 = y1 / 2 - nodeHeight / 2;
	                          node.y1 = y1 / 2 + nodeHeight / 2;
	                        } else {
	                          var avg = 0;
	                          var avgTargetY = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.J6)(node.sourceLinks, linkTargetCenter);
	                          var avgSourceY = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.J6)(node.targetLinks, linkSourceCenter);
	                          if (avgTargetY && avgSourceY) {
	                            avg = (avgTargetY + avgSourceY) / 2;
	                          } else {
	                            avg = avgTargetY || avgSourceY;
	                          }
	                          var dy = (avg - nodeCenter(node)) * alpha2;
	                          node.y0 += dy;
	                          node.y1 += dy;
	                        }
	                      }
	                    });
	                  });
	                }
	                function resolveCollisions() {
	                  columns.forEach(function(nodes2) {
	                    var node, dy, y = y0, n2 = nodes2.length, i;
	                    nodes2.sort(ascendingBreadth);
	                    for (i = 0; i < n2; ++i) {
	                      node = nodes2[i];
	                      dy = y - node.y0;
	                      if (dy > 0) {
	                        node.y0 += dy;
	                        node.y1 += dy;
	                      }
	                      y = node.y1 + py;
	                    }
	                    dy = y - py - y1;
	                    if (dy > 0) {
	                      y = node.y0 -= dy, node.y1 -= dy;
	                      for (i = n2 - 2; i >= 0; --i) {
	                        node = nodes2[i];
	                        dy = node.y1 + py - y;
	                        if (dy > 0) node.y0 -= dy, node.y1 -= dy;
	                        y = node.y0;
	                      }
	                    }
	                  });
	                }
	              }
	              function computeLinkBreadths(graph) {
	                graph.nodes.forEach(function(node) {
	                  node.sourceLinks.sort(ascendingTargetBreadth);
	                  node.targetLinks.sort(ascendingSourceBreadth);
	                });
	                graph.nodes.forEach(function(node) {
	                  var y02 = node.y0;
	                  var y12 = y02;
	                  var y0cycle = node.y1;
	                  var y1cycle = y0cycle;
	                  node.sourceLinks.forEach(function(link) {
	                    if (link.circular) {
	                      link.y0 = y0cycle - link.width / 2;
	                      y0cycle = y0cycle - link.width;
	                    } else {
	                      link.y0 = y02 + link.width / 2;
	                      y02 += link.width;
	                    }
	                  });
	                  node.targetLinks.forEach(function(link) {
	                    if (link.circular) {
	                      link.y1 = y1cycle - link.width / 2;
	                      y1cycle = y1cycle - link.width;
	                    } else {
	                      link.y1 = y12 + link.width / 2;
	                      y12 += link.width;
	                    }
	                  });
	                });
	              }
	              return sankeyCircular2;
	            }
	            function identifyCircles(graph, id, sortNodes) {
	              var circularLinkID = 0;
	              if (sortNodes === null) {
	                var adjList = [];
	                for (var i = 0; i < graph.links.length; i++) {
	                  var link = graph.links[i];
	                  var source = link.source.index;
	                  var target = link.target.index;
	                  if (!adjList[source]) adjList[source] = [];
	                  if (!adjList[target]) adjList[target] = [];
	                  if (adjList[source].indexOf(target) === -1) adjList[source].push(target);
	                }
	                var cycles = elementary_circuits_directed_graph__WEBPACK_IMPORTED_MODULE_2___default()(adjList);
	                cycles.sort(function(a, b) {
	                  return a.length - b.length;
	                });
	                var circularLinks = {};
	                for (i = 0; i < cycles.length; i++) {
	                  var cycle = cycles[i];
	                  var last = cycle.slice(-2);
	                  if (!circularLinks[last[0]]) circularLinks[last[0]] = {};
	                  circularLinks[last[0]][last[1]] = true;
	                }
	                graph.links.forEach(function(link2) {
	                  var target2 = link2.target.index;
	                  var source2 = link2.source.index;
	                  if (target2 === source2 || circularLinks[source2] && circularLinks[source2][target2]) {
	                    link2.circular = true;
	                    link2.circularLinkID = circularLinkID;
	                    circularLinkID = circularLinkID + 1;
	                  } else {
	                    link2.circular = false;
	                  }
	                });
	              } else {
	                graph.links.forEach(function(link2) {
	                  if (link2.source[sortNodes] < link2.target[sortNodes]) {
	                    link2.circular = false;
	                  } else {
	                    link2.circular = true;
	                    link2.circularLinkID = circularLinkID;
	                    circularLinkID = circularLinkID + 1;
	                  }
	                });
	              }
	            }
	            function selectCircularLinkTypes(graph, id) {
	              var numberOfTops = 0;
	              var numberOfBottoms = 0;
	              graph.links.forEach(function(link) {
	                if (link.circular) {
	                  if (link.source.circularLinkType || link.target.circularLinkType) {
	                    link.circularLinkType = link.source.circularLinkType ? link.source.circularLinkType : link.target.circularLinkType;
	                  } else {
	                    link.circularLinkType = numberOfTops < numberOfBottoms ? "top" : "bottom";
	                  }
	                  if (link.circularLinkType == "top") {
	                    numberOfTops = numberOfTops + 1;
	                  } else {
	                    numberOfBottoms = numberOfBottoms + 1;
	                  }
	                  graph.nodes.forEach(function(node) {
	                    if (getNodeID(node, id) == getNodeID(link.source, id) || getNodeID(node, id) == getNodeID(link.target, id)) {
	                      node.circularLinkType = link.circularLinkType;
	                    }
	                  });
	                }
	              });
	              graph.links.forEach(function(link) {
	                if (link.circular) {
	                  if (link.source.circularLinkType == link.target.circularLinkType) {
	                    link.circularLinkType = link.source.circularLinkType;
	                  }
	                  if (selfLinking(link, id)) {
	                    link.circularLinkType = link.source.circularLinkType;
	                  }
	                }
	              });
	            }
	            function linkAngle(link) {
	              var adjacent = Math.abs(link.y1 - link.y0);
	              var opposite = Math.abs(link.target.x0 - link.source.x1);
	              return Math.atan(opposite / adjacent);
	            }
	            function circularLinksCross(link1, link2) {
	              if (link1.source.column < link2.target.column) {
	                return false;
	              } else if (link1.target.column > link2.source.column) {
	                return false;
	              } else {
	                return true;
	              }
	            }
	            function numberOfNonSelfLinkingCycles(node, id) {
	              var sourceCount = 0;
	              node.sourceLinks.forEach(function(l) {
	                sourceCount = l.circular && !selfLinking(l, id) ? sourceCount + 1 : sourceCount;
	              });
	              var targetCount = 0;
	              node.targetLinks.forEach(function(l) {
	                targetCount = l.circular && !selfLinking(l, id) ? targetCount + 1 : targetCount;
	              });
	              return sourceCount + targetCount;
	            }
	            function onlyCircularLink(link) {
	              var nodeSourceLinks = link.source.sourceLinks;
	              var sourceCount = 0;
	              nodeSourceLinks.forEach(function(l) {
	                sourceCount = l.circular ? sourceCount + 1 : sourceCount;
	              });
	              var nodeTargetLinks = link.target.targetLinks;
	              var targetCount = 0;
	              nodeTargetLinks.forEach(function(l) {
	                targetCount = l.circular ? targetCount + 1 : targetCount;
	              });
	              if (sourceCount > 1 || targetCount > 1) {
	                return false;
	              } else {
	                return true;
	              }
	            }
	            function calcVerticalBuffer(links, circularLinkGap, id) {
	              links.sort(sortLinkColumnAscending);
	              links.forEach(function(link, i) {
	                var buffer = 0;
	                if (selfLinking(link, id) && onlyCircularLink(link)) {
	                  link.circularPathData.verticalBuffer = buffer + link.width / 2;
	                } else {
	                  var j = 0;
	                  for (j; j < i; j++) {
	                    if (circularLinksCross(links[i], links[j])) {
	                      var bufferOverThisLink = links[j].circularPathData.verticalBuffer + links[j].width / 2 + circularLinkGap;
	                      buffer = bufferOverThisLink > buffer ? bufferOverThisLink : buffer;
	                    }
	                  }
	                  link.circularPathData.verticalBuffer = buffer + link.width / 2;
	                }
	              });
	              return links;
	            }
	            function addCircularPathData(graph, circularLinkGap, y1, id) {
	              var buffer = 5;
	              var minY = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.VV)(graph.links, function(link) {
	                return link.source.y0;
	              });
	              graph.links.forEach(function(link) {
	                if (link.circular) {
	                  link.circularPathData = {};
	                }
	              });
	              var topLinks = graph.links.filter(function(l) {
	                return l.circularLinkType == "top";
	              });
	              calcVerticalBuffer(topLinks, circularLinkGap, id);
	              var bottomLinks = graph.links.filter(function(l) {
	                return l.circularLinkType == "bottom";
	              });
	              calcVerticalBuffer(bottomLinks, circularLinkGap, id);
	              graph.links.forEach(function(link) {
	                if (link.circular) {
	                  link.circularPathData.arcRadius = link.width + baseRadius;
	                  link.circularPathData.leftNodeBuffer = buffer;
	                  link.circularPathData.rightNodeBuffer = buffer;
	                  link.circularPathData.sourceWidth = link.source.x1 - link.source.x0;
	                  link.circularPathData.sourceX = link.source.x0 + link.circularPathData.sourceWidth;
	                  link.circularPathData.targetX = link.target.x0;
	                  link.circularPathData.sourceY = link.y0;
	                  link.circularPathData.targetY = link.y1;
	                  if (selfLinking(link, id) && onlyCircularLink(link)) {
	                    link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2;
	                    link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2;
	                    link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2;
	                    link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2;
	                    if (link.circularLinkType == "bottom") {
	                      link.circularPathData.verticalFullExtent = link.source.y1 + verticalMargin + link.circularPathData.verticalBuffer;
	                      link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
	                      link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
	                    } else {
	                      link.circularPathData.verticalFullExtent = link.source.y0 - verticalMargin - link.circularPathData.verticalBuffer;
	                      link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
	                      link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
	                    }
	                  } else {
	                    var thisColumn = link.source.column;
	                    var thisCircularLinkType = link.circularLinkType;
	                    var sameColumnLinks = graph.links.filter(function(l) {
	                      return l.source.column == thisColumn && l.circularLinkType == thisCircularLinkType;
	                    });
	                    if (link.circularLinkType == "bottom") {
	                      sameColumnLinks.sort(sortLinkSourceYDescending);
	                    } else {
	                      sameColumnLinks.sort(sortLinkSourceYAscending);
	                    }
	                    var radiusOffset = 0;
	                    sameColumnLinks.forEach(function(l, i) {
	                      if (l.circularLinkID == link.circularLinkID) {
	                        link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
	                        link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
	                      }
	                      radiusOffset = radiusOffset + l.width;
	                    });
	                    thisColumn = link.target.column;
	                    sameColumnLinks = graph.links.filter(function(l) {
	                      return l.target.column == thisColumn && l.circularLinkType == thisCircularLinkType;
	                    });
	                    if (link.circularLinkType == "bottom") {
	                      sameColumnLinks.sort(sortLinkTargetYDescending);
	                    } else {
	                      sameColumnLinks.sort(sortLinkTargetYAscending);
	                    }
	                    radiusOffset = 0;
	                    sameColumnLinks.forEach(function(l, i) {
	                      if (l.circularLinkID == link.circularLinkID) {
	                        link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
	                        link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
	                      }
	                      radiusOffset = radiusOffset + l.width;
	                    });
	                    if (link.circularLinkType == "bottom") {
	                      link.circularPathData.verticalFullExtent = Math.max(y1, link.source.y1, link.target.y1) + verticalMargin + link.circularPathData.verticalBuffer;
	                      link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
	                      link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
	                    } else {
	                      link.circularPathData.verticalFullExtent = minY - verticalMargin - link.circularPathData.verticalBuffer;
	                      link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
	                      link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
	                    }
	                  }
	                  link.circularPathData.leftInnerExtent = link.circularPathData.sourceX + link.circularPathData.leftNodeBuffer;
	                  link.circularPathData.rightInnerExtent = link.circularPathData.targetX - link.circularPathData.rightNodeBuffer;
	                  link.circularPathData.leftFullExtent = link.circularPathData.sourceX + link.circularPathData.leftLargeArcRadius + link.circularPathData.leftNodeBuffer;
	                  link.circularPathData.rightFullExtent = link.circularPathData.targetX - link.circularPathData.rightLargeArcRadius - link.circularPathData.rightNodeBuffer;
	                }
	                if (link.circular) {
	                  link.path = createCircularPathString(link);
	                } else {
	                  var normalPath = (0, d3_shape__WEBPACK_IMPORTED_MODULE_3__.h5)().source(function(d) {
	                    var x = d.source.x0 + (d.source.x1 - d.source.x0);
	                    var y = d.y0;
	                    return [x, y];
	                  }).target(function(d) {
	                    var x = d.target.x0;
	                    var y = d.y1;
	                    return [x, y];
	                  });
	                  link.path = normalPath(link);
	                }
	              });
	            }
	            function createCircularPathString(link) {
	              var pathString = "";
	              if (link.circularLinkType == "top") {
	                pathString = // start at the right of the source node
	                "M" + link.circularPathData.sourceX + " " + link.circularPathData.sourceY + " L" + link.circularPathData.leftInnerExtent + " " + link.circularPathData.sourceY + " A" + link.circularPathData.leftLargeArcRadius + " " + link.circularPathData.leftSmallArcRadius + " 0 0 0 " + // End of arc X //End of arc Y
	                link.circularPathData.leftFullExtent + " " + (link.circularPathData.sourceY - link.circularPathData.leftSmallArcRadius) + " L" + link.circularPathData.leftFullExtent + " " + link.circularPathData.verticalLeftInnerExtent + " A" + link.circularPathData.leftLargeArcRadius + " " + link.circularPathData.leftLargeArcRadius + " 0 0 0 " + // End of arc X //End of arc Y
	                link.circularPathData.leftInnerExtent + " " + link.circularPathData.verticalFullExtent + " L" + link.circularPathData.rightInnerExtent + " " + link.circularPathData.verticalFullExtent + " A" + link.circularPathData.rightLargeArcRadius + " " + link.circularPathData.rightLargeArcRadius + " 0 0 0 " + // End of arc X //End of arc Y
	                link.circularPathData.rightFullExtent + " " + link.circularPathData.verticalRightInnerExtent + " L" + link.circularPathData.rightFullExtent + " " + (link.circularPathData.targetY - link.circularPathData.rightSmallArcRadius) + " A" + link.circularPathData.rightLargeArcRadius + " " + link.circularPathData.rightSmallArcRadius + " 0 0 0 " + // End of arc X //End of arc Y
	                link.circularPathData.rightInnerExtent + " " + link.circularPathData.targetY + " L" + link.circularPathData.targetX + " " + link.circularPathData.targetY;
	              } else {
	                pathString = // start at the right of the source node
	                "M" + link.circularPathData.sourceX + " " + link.circularPathData.sourceY + " L" + link.circularPathData.leftInnerExtent + " " + link.circularPathData.sourceY + " A" + link.circularPathData.leftLargeArcRadius + " " + link.circularPathData.leftSmallArcRadius + " 0 0 1 " + // End of arc X //End of arc Y
	                link.circularPathData.leftFullExtent + " " + (link.circularPathData.sourceY + link.circularPathData.leftSmallArcRadius) + " L" + link.circularPathData.leftFullExtent + " " + link.circularPathData.verticalLeftInnerExtent + " A" + link.circularPathData.leftLargeArcRadius + " " + link.circularPathData.leftLargeArcRadius + " 0 0 1 " + // End of arc X //End of arc Y
	                link.circularPathData.leftInnerExtent + " " + link.circularPathData.verticalFullExtent + " L" + link.circularPathData.rightInnerExtent + " " + link.circularPathData.verticalFullExtent + " A" + link.circularPathData.rightLargeArcRadius + " " + link.circularPathData.rightLargeArcRadius + " 0 0 1 " + // End of arc X //End of arc Y
	                link.circularPathData.rightFullExtent + " " + link.circularPathData.verticalRightInnerExtent + " L" + link.circularPathData.rightFullExtent + " " + (link.circularPathData.targetY + link.circularPathData.rightSmallArcRadius) + " A" + link.circularPathData.rightLargeArcRadius + " " + link.circularPathData.rightSmallArcRadius + " 0 0 1 " + // End of arc X //End of arc Y
	                link.circularPathData.rightInnerExtent + " " + link.circularPathData.targetY + " L" + link.circularPathData.targetX + " " + link.circularPathData.targetY;
	              }
	              return pathString;
	            }
	            function sortLinkColumnAscending(link1, link2) {
	              if (linkColumnDistance(link1) == linkColumnDistance(link2)) {
	                return link1.circularLinkType == "bottom" ? sortLinkSourceYDescending(link1, link2) : sortLinkSourceYAscending(link1, link2);
	              } else {
	                return linkColumnDistance(link2) - linkColumnDistance(link1);
	              }
	            }
	            function sortLinkSourceYAscending(link1, link2) {
	              return link1.y0 - link2.y0;
	            }
	            function sortLinkSourceYDescending(link1, link2) {
	              return link2.y0 - link1.y0;
	            }
	            function sortLinkTargetYAscending(link1, link2) {
	              return link1.y1 - link2.y1;
	            }
	            function sortLinkTargetYDescending(link1, link2) {
	              return link2.y1 - link1.y1;
	            }
	            function linkColumnDistance(link) {
	              return link.target.column - link.source.column;
	            }
	            function linkXLength(link) {
	              return link.target.x0 - link.source.x1;
	            }
	            function linkPerpendicularYToLinkSource(longerLink, shorterLink) {
	              var angle = linkAngle(longerLink);
	              var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);
	              var yPerpendicular = incline(longerLink) == "up" ? longerLink.y1 + heightFromY1ToPependicular : longerLink.y1 - heightFromY1ToPependicular;
	              return yPerpendicular;
	            }
	            function linkPerpendicularYToLinkTarget(longerLink, shorterLink) {
	              var angle = linkAngle(longerLink);
	              var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);
	              var yPerpendicular = incline(longerLink) == "up" ? longerLink.y1 - heightFromY1ToPependicular : longerLink.y1 + heightFromY1ToPependicular;
	              return yPerpendicular;
	            }
	            function resolveNodeLinkOverlaps(graph, y0, y1, id) {
	              graph.links.forEach(function(link) {
	                if (link.circular) {
	                  return;
	                }
	                if (link.target.column - link.source.column > 1) {
	                  var columnToTest = link.source.column + 1;
	                  var maxColumnToTest = link.target.column - 1;
	                  var i = 1;
	                  var numberOfColumnsToTest = maxColumnToTest - columnToTest + 1;
	                  for (i = 1; columnToTest <= maxColumnToTest; columnToTest++, i++) {
	                    graph.nodes.forEach(function(node) {
	                      if (node.column == columnToTest) {
	                        var t = i / (numberOfColumnsToTest + 1);
	                        var B0_t = Math.pow(1 - t, 3);
	                        var B1_t = 3 * t * Math.pow(1 - t, 2);
	                        var B2_t = 3 * Math.pow(t, 2) * (1 - t);
	                        var B3_t = Math.pow(t, 3);
	                        var py_t = B0_t * link.y0 + B1_t * link.y0 + B2_t * link.y1 + B3_t * link.y1;
	                        var linkY0AtColumn = py_t - link.width / 2;
	                        var linkY1AtColumn = py_t + link.width / 2;
	                        var dy;
	                        if (linkY0AtColumn > node.y0 && linkY0AtColumn < node.y1) {
	                          dy = node.y1 - linkY0AtColumn + 10;
	                          dy = node.circularLinkType == "bottom" ? dy : -dy;
	                          node = adjustNodeHeight(node, dy, y0, y1);
	                          graph.nodes.forEach(function(otherNode) {
	                            if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
	                              return;
	                            }
	                            if (nodesOverlap(node, otherNode)) {
	                              adjustNodeHeight(otherNode, dy, y0, y1);
	                            }
	                          });
	                        } else if (linkY1AtColumn > node.y0 && linkY1AtColumn < node.y1) {
	                          dy = linkY1AtColumn - node.y0 + 10;
	                          node = adjustNodeHeight(node, dy, y0, y1);
	                          graph.nodes.forEach(function(otherNode) {
	                            if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
	                              return;
	                            }
	                            if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
	                              adjustNodeHeight(otherNode, dy, y0, y1);
	                            }
	                          });
	                        } else if (linkY0AtColumn < node.y0 && linkY1AtColumn > node.y1) {
	                          dy = linkY1AtColumn - node.y0 + 10;
	                          node = adjustNodeHeight(node, dy, y0, y1);
	                          graph.nodes.forEach(function(otherNode) {
	                            if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
	                              return;
	                            }
	                            if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
	                              adjustNodeHeight(otherNode, dy, y0, y1);
	                            }
	                          });
	                        }
	                      }
	                    });
	                  }
	                }
	              });
	            }
	            function nodesOverlap(nodeA, nodeB) {
	              if (nodeA.y0 > nodeB.y0 && nodeA.y0 < nodeB.y1) {
	                return true;
	              } else if (nodeA.y1 > nodeB.y0 && nodeA.y1 < nodeB.y1) {
	                return true;
	              } else if (nodeA.y0 < nodeB.y0 && nodeA.y1 > nodeB.y1) {
	                return true;
	              } else {
	                return false;
	              }
	            }
	            function adjustNodeHeight(node, dy, sankeyY0, sankeyY1) {
	              if (node.y0 + dy >= sankeyY0 && node.y1 + dy <= sankeyY1) {
	                node.y0 = node.y0 + dy;
	                node.y1 = node.y1 + dy;
	                node.targetLinks.forEach(function(l) {
	                  l.y1 = l.y1 + dy;
	                });
	                node.sourceLinks.forEach(function(l) {
	                  l.y0 = l.y0 + dy;
	                });
	              }
	              return node;
	            }
	            function sortSourceLinks(graph, y1, id, moveNodes) {
	              graph.nodes.forEach(function(node) {
	                if (moveNodes && node.y + (node.y1 - node.y0) > y1) {
	                  node.y = node.y - (node.y + (node.y1 - node.y0) - y1);
	                }
	                var nodesSourceLinks = graph.links.filter(function(l) {
	                  return getNodeID(l.source, id) == getNodeID(node, id);
	                });
	                var nodeSourceLinksLength = nodesSourceLinks.length;
	                if (nodeSourceLinksLength > 1) {
	                  nodesSourceLinks.sort(function(link1, link2) {
	                    if (!link1.circular && !link2.circular) {
	                      if (link1.target.column == link2.target.column) {
	                        return link1.y1 - link2.y1;
	                      } else if (!sameInclines(link1, link2)) {
	                        return link1.y1 - link2.y1;
	                      } else {
	                        if (link1.target.column > link2.target.column) {
	                          var link2Adj = linkPerpendicularYToLinkTarget(link2, link1);
	                          return link1.y1 - link2Adj;
	                        }
	                        if (link2.target.column > link1.target.column) {
	                          var link1Adj = linkPerpendicularYToLinkTarget(link1, link2);
	                          return link1Adj - link2.y1;
	                        }
	                      }
	                    }
	                    if (link1.circular && !link2.circular) {
	                      return link1.circularLinkType == "top" ? -1 : 1;
	                    } else if (link2.circular && !link1.circular) {
	                      return link2.circularLinkType == "top" ? 1 : -1;
	                    }
	                    if (link1.circular && link2.circular) {
	                      if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == "top") {
	                        if (link1.target.column === link2.target.column) {
	                          return link1.target.y1 - link2.target.y1;
	                        } else {
	                          return link2.target.column - link1.target.column;
	                        }
	                      } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == "bottom") {
	                        if (link1.target.column === link2.target.column) {
	                          return link2.target.y1 - link1.target.y1;
	                        } else {
	                          return link1.target.column - link2.target.column;
	                        }
	                      } else {
	                        return link1.circularLinkType == "top" ? -1 : 1;
	                      }
	                    }
	                  });
	                }
	                var ySourceOffset = node.y0;
	                nodesSourceLinks.forEach(function(link) {
	                  link.y0 = ySourceOffset + link.width / 2;
	                  ySourceOffset = ySourceOffset + link.width;
	                });
	                nodesSourceLinks.forEach(function(link, i) {
	                  if (link.circularLinkType == "bottom") {
	                    var j = i + 1;
	                    var offsetFromBottom = 0;
	                    for (j; j < nodeSourceLinksLength; j++) {
	                      offsetFromBottom = offsetFromBottom + nodesSourceLinks[j].width;
	                    }
	                    link.y0 = node.y1 - offsetFromBottom - link.width / 2;
	                  }
	                });
	              });
	            }
	            function sortTargetLinks(graph, y1, id) {
	              graph.nodes.forEach(function(node) {
	                var nodesTargetLinks = graph.links.filter(function(l) {
	                  return getNodeID(l.target, id) == getNodeID(node, id);
	                });
	                var nodesTargetLinksLength = nodesTargetLinks.length;
	                if (nodesTargetLinksLength > 1) {
	                  nodesTargetLinks.sort(function(link1, link2) {
	                    if (!link1.circular && !link2.circular) {
	                      if (link1.source.column == link2.source.column) {
	                        return link1.y0 - link2.y0;
	                      } else if (!sameInclines(link1, link2)) {
	                        return link1.y0 - link2.y0;
	                      } else {
	                        if (link2.source.column < link1.source.column) {
	                          var link2Adj = linkPerpendicularYToLinkSource(link2, link1);
	                          return link1.y0 - link2Adj;
	                        }
	                        if (link1.source.column < link2.source.column) {
	                          var link1Adj = linkPerpendicularYToLinkSource(link1, link2);
	                          return link1Adj - link2.y0;
	                        }
	                      }
	                    }
	                    if (link1.circular && !link2.circular) {
	                      return link1.circularLinkType == "top" ? -1 : 1;
	                    } else if (link2.circular && !link1.circular) {
	                      return link2.circularLinkType == "top" ? 1 : -1;
	                    }
	                    if (link1.circular && link2.circular) {
	                      if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == "top") {
	                        if (link1.source.column === link2.source.column) {
	                          return link1.source.y1 - link2.source.y1;
	                        } else {
	                          return link1.source.column - link2.source.column;
	                        }
	                      } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == "bottom") {
	                        if (link1.source.column === link2.source.column) {
	                          return link1.source.y1 - link2.source.y1;
	                        } else {
	                          return link2.source.column - link1.source.column;
	                        }
	                      } else {
	                        return link1.circularLinkType == "top" ? -1 : 1;
	                      }
	                    }
	                  });
	                }
	                var yTargetOffset = node.y0;
	                nodesTargetLinks.forEach(function(link) {
	                  link.y1 = yTargetOffset + link.width / 2;
	                  yTargetOffset = yTargetOffset + link.width;
	                });
	                nodesTargetLinks.forEach(function(link, i) {
	                  if (link.circularLinkType == "bottom") {
	                    var j = i + 1;
	                    var offsetFromBottom = 0;
	                    for (j; j < nodesTargetLinksLength; j++) {
	                      offsetFromBottom = offsetFromBottom + nodesTargetLinks[j].width;
	                    }
	                    link.y1 = node.y1 - offsetFromBottom - link.width / 2;
	                  }
	                });
	              });
	            }
	            function sameInclines(link1, link2) {
	              return incline(link1) == incline(link2);
	            }
	            function incline(link) {
	              return link.y0 - link.y1 > 0 ? "up" : "down";
	            }
	            function selfLinking(link, id) {
	              return getNodeID(link.source, id) == getNodeID(link.target, id);
	            }
	            function fillHeight(graph, y0, y1) {
	              var nodes = graph.nodes;
	              var links = graph.links;
	              var top = false;
	              var bottom = false;
	              links.forEach(function(link) {
	                if (link.circularLinkType == "top") {
	                  top = true;
	                } else if (link.circularLinkType == "bottom") {
	                  bottom = true;
	                }
	              });
	              if (top == false || bottom == false) {
	                var minY0 = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.VV)(nodes, function(node) {
	                  return node.y0;
	                });
	                var maxY1 = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.Fp)(nodes, function(node) {
	                  return node.y1;
	                });
	                var currentHeight = maxY1 - minY0;
	                var chartHeight = y1 - y0;
	                var ratio = chartHeight / currentHeight;
	                nodes.forEach(function(node) {
	                  var nodeHeight = (node.y1 - node.y0) * ratio;
	                  node.y0 = (node.y0 - minY0) * ratio;
	                  node.y1 = node.y0 + nodeHeight;
	                });
	                links.forEach(function(link) {
	                  link.y0 = (link.y0 - minY0) * ratio;
	                  link.y1 = (link.y1 - minY0) * ratio;
	                  link.width = link.width * ratio;
	                });
	              }
	            }
	          }
	        ),
	        /***/
	        30838: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              sankey: function() {
	                return (
	                  /* reexport */
	                  sankey
	                );
	              },
	              sankeyCenter: function() {
	                return (
	                  /* reexport */
	                  center
	                );
	              },
	              sankeyJustify: function() {
	                return (
	                  /* reexport */
	                  justify
	                );
	              },
	              sankeyLeft: function() {
	                return (
	                  /* reexport */
	                  left
	                );
	              },
	              sankeyLinkHorizontal: function() {
	                return (
	                  /* reexport */
	                  sankeyLinkHorizontal
	                );
	              },
	              sankeyRight: function() {
	                return (
	                  /* reexport */
	                  right
	                );
	              }
	            });
	            var src = __webpack_require__2(33064);
	            var d3_collection_src = __webpack_require__2(15140);
	            function targetDepth(d) {
	              return d.target.depth;
	            }
	            function left(node) {
	              return node.depth;
	            }
	            function right(node, n) {
	              return n - 1 - node.height;
	            }
	            function justify(node, n) {
	              return node.sourceLinks.length ? node.depth : n - 1;
	            }
	            function center(node) {
	              return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0, src.VV)(node.sourceLinks, targetDepth) - 1 : 0;
	            }
	            function constant2(x) {
	              return function() {
	                return x;
	              };
	            }
	            function ascendingSourceBreadth(a, b) {
	              return ascendingBreadth(a.source, b.source) || a.index - b.index;
	            }
	            function ascendingTargetBreadth(a, b) {
	              return ascendingBreadth(a.target, b.target) || a.index - b.index;
	            }
	            function ascendingBreadth(a, b) {
	              return a.y0 - b.y0;
	            }
	            function value(d) {
	              return d.value;
	            }
	            function nodeCenter(node) {
	              return (node.y0 + node.y1) / 2;
	            }
	            function weightedSource(link) {
	              return nodeCenter(link.source) * link.value;
	            }
	            function weightedTarget(link) {
	              return nodeCenter(link.target) * link.value;
	            }
	            function defaultId(d) {
	              return d.index;
	            }
	            function defaultNodes(graph) {
	              return graph.nodes;
	            }
	            function defaultLinks(graph) {
	              return graph.links;
	            }
	            function find(nodeById, id) {
	              var node = nodeById.get(id);
	              if (!node) throw new Error("missing: " + id);
	              return node;
	            }
	            function sankey() {
	              var x0 = 0, y0 = 0, x1 = 1, y1 = 1, dx = 24, py = 8, id = defaultId, align = justify, nodes = defaultNodes, links = defaultLinks, iterations = 32, maxPaddedSpace = 2 / 3;
	              function sankey2() {
	                var graph = { nodes: nodes.apply(null, arguments), links: links.apply(null, arguments) };
	                computeNodeLinks(graph);
	                computeNodeValues(graph);
	                computeNodeDepths(graph);
	                computeNodeBreadths(graph);
	                computeLinkBreadths(graph);
	                return graph;
	              }
	              sankey2.update = function(graph) {
	                computeLinkBreadths(graph);
	                return graph;
	              };
	              sankey2.nodeId = function(_) {
	                return arguments.length ? (id = typeof _ === "function" ? _ : constant2(_), sankey2) : id;
	              };
	              sankey2.nodeAlign = function(_) {
	                return arguments.length ? (align = typeof _ === "function" ? _ : constant2(_), sankey2) : align;
	              };
	              sankey2.nodeWidth = function(_) {
	                return arguments.length ? (dx = +_, sankey2) : dx;
	              };
	              sankey2.nodePadding = function(_) {
	                return arguments.length ? (py = +_, sankey2) : py;
	              };
	              sankey2.nodes = function(_) {
	                return arguments.length ? (nodes = typeof _ === "function" ? _ : constant2(_), sankey2) : nodes;
	              };
	              sankey2.links = function(_) {
	                return arguments.length ? (links = typeof _ === "function" ? _ : constant2(_), sankey2) : links;
	              };
	              sankey2.size = function(_) {
	                return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey2) : [x1 - x0, y1 - y0];
	              };
	              sankey2.extent = function(_) {
	                return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey2) : [[x0, y0], [x1, y1]];
	              };
	              sankey2.iterations = function(_) {
	                return arguments.length ? (iterations = +_, sankey2) : iterations;
	              };
	              function computeNodeLinks(graph) {
	                graph.nodes.forEach(function(node, i) {
	                  node.index = i;
	                  node.sourceLinks = [];
	                  node.targetLinks = [];
	                });
	                var nodeById = (0, d3_collection_src.UI)(graph.nodes, id);
	                graph.links.forEach(function(link, i) {
	                  link.index = i;
	                  var source = link.source, target = link.target;
	                  if (typeof source !== "object") source = link.source = find(nodeById, source);
	                  if (typeof target !== "object") target = link.target = find(nodeById, target);
	                  source.sourceLinks.push(link);
	                  target.targetLinks.push(link);
	                });
	              }
	              function computeNodeValues(graph) {
	                graph.nodes.forEach(function(node) {
	                  node.value = Math.max(
	                    (0, src.Sm)(node.sourceLinks, value),
	                    (0, src.Sm)(node.targetLinks, value)
	                  );
	                });
	              }
	              function computeNodeDepths(graph) {
	                var nodes2, next, x;
	                for (nodes2 = graph.nodes, next = [], x = 0; nodes2.length; ++x, nodes2 = next, next = []) {
	                  nodes2.forEach(function(node) {
	                    node.depth = x;
	                    node.sourceLinks.forEach(function(link) {
	                      if (next.indexOf(link.target) < 0) {
	                        next.push(link.target);
	                      }
	                    });
	                  });
	                }
	                for (nodes2 = graph.nodes, next = [], x = 0; nodes2.length; ++x, nodes2 = next, next = []) {
	                  nodes2.forEach(function(node) {
	                    node.height = x;
	                    node.targetLinks.forEach(function(link) {
	                      if (next.indexOf(link.source) < 0) {
	                        next.push(link.source);
	                      }
	                    });
	                  });
	                }
	                var kx = (x1 - x0 - dx) / (x - 1);
	                graph.nodes.forEach(function(node) {
	                  node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
	                });
	              }
	              function computeNodeBreadths(graph) {
	                var columns = (0, d3_collection_src.b1)().key(function(d) {
	                  return d.x0;
	                }).sortKeys(src.j2).entries(graph.nodes).map(function(d) {
	                  return d.values;
	                });
	                initializeNodeBreadth();
	                resolveCollisions();
	                for (var alpha = 1, n = iterations; n > 0; --n) {
	                  relaxRightToLeft(alpha *= 0.99);
	                  resolveCollisions();
	                  relaxLeftToRight(alpha);
	                  resolveCollisions();
	                }
	                function initializeNodeBreadth() {
	                  var L = (0, src.Fp)(columns, function(nodes2) {
	                    return nodes2.length;
	                  });
	                  var maxNodePadding = maxPaddedSpace * (y1 - y0) / (L - 1);
	                  if (py > maxNodePadding) py = maxNodePadding;
	                  var ky = (0, src.VV)(columns, function(nodes2) {
	                    return (y1 - y0 - (nodes2.length - 1) * py) / (0, src.Sm)(nodes2, value);
	                  });
	                  columns.forEach(function(nodes2) {
	                    nodes2.forEach(function(node, i) {
	                      node.y1 = (node.y0 = i) + node.value * ky;
	                    });
	                  });
	                  graph.links.forEach(function(link) {
	                    link.width = link.value * ky;
	                  });
	                }
	                function relaxLeftToRight(alpha2) {
	                  columns.forEach(function(nodes2) {
	                    nodes2.forEach(function(node) {
	                      if (node.targetLinks.length) {
	                        var dy = ((0, src.Sm)(node.targetLinks, weightedSource) / (0, src.Sm)(node.targetLinks, value) - nodeCenter(node)) * alpha2;
	                        node.y0 += dy, node.y1 += dy;
	                      }
	                    });
	                  });
	                }
	                function relaxRightToLeft(alpha2) {
	                  columns.slice().reverse().forEach(function(nodes2) {
	                    nodes2.forEach(function(node) {
	                      if (node.sourceLinks.length) {
	                        var dy = ((0, src.Sm)(node.sourceLinks, weightedTarget) / (0, src.Sm)(node.sourceLinks, value) - nodeCenter(node)) * alpha2;
	                        node.y0 += dy, node.y1 += dy;
	                      }
	                    });
	                  });
	                }
	                function resolveCollisions() {
	                  columns.forEach(function(nodes2) {
	                    var node, dy, y = y0, n2 = nodes2.length, i;
	                    nodes2.sort(ascendingBreadth);
	                    for (i = 0; i < n2; ++i) {
	                      node = nodes2[i];
	                      dy = y - node.y0;
	                      if (dy > 0) node.y0 += dy, node.y1 += dy;
	                      y = node.y1 + py;
	                    }
	                    dy = y - py - y1;
	                    if (dy > 0) {
	                      y = node.y0 -= dy, node.y1 -= dy;
	                      for (i = n2 - 2; i >= 0; --i) {
	                        node = nodes2[i];
	                        dy = node.y1 + py - y;
	                        if (dy > 0) node.y0 -= dy, node.y1 -= dy;
	                        y = node.y0;
	                      }
	                    }
	                  });
	                }
	              }
	              function computeLinkBreadths(graph) {
	                graph.nodes.forEach(function(node) {
	                  node.sourceLinks.sort(ascendingTargetBreadth);
	                  node.targetLinks.sort(ascendingSourceBreadth);
	                });
	                graph.nodes.forEach(function(node) {
	                  var y02 = node.y0, y12 = y02;
	                  node.sourceLinks.forEach(function(link) {
	                    link.y0 = y02 + link.width / 2, y02 += link.width;
	                  });
	                  node.targetLinks.forEach(function(link) {
	                    link.y1 = y12 + link.width / 2, y12 += link.width;
	                  });
	                });
	              }
	              return sankey2;
	            }
	            var src_link = __webpack_require__2(45879);
	            function horizontalSource(d) {
	              return [d.source.x1, d.y0];
	            }
	            function horizontalTarget(d) {
	              return [d.target.x0, d.y1];
	            }
	            function sankeyLinkHorizontal() {
	              return (0, src_link.h5)().source(horizontalSource).target(horizontalTarget);
	            }
	          }
	        ),
	        /***/
	        39898: (
	          /***/
	          function(module2, exports2, __webpack_require__2) {
	            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
	            !function() {
	              var d3 = {
	                version: "3.8.0"
	              };
	              var d3_arraySlice = [].slice, d3_array = function(list) {
	                return d3_arraySlice.call(list);
	              };
	              var d3_document = self.document;
	              function d3_documentElement(node) {
	                return node && (node.ownerDocument || node.document || node).documentElement;
	              }
	              function d3_window(node) {
	                return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	              }
	              if (d3_document) {
	                try {
	                  d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	                } catch (e) {
	                  d3_array = function(list) {
	                    var i = list.length, array = new Array(i);
	                    while (i--) array[i] = list[i];
	                    return array;
	                  };
	                }
	              }
	              if (!Date.now) Date.now = function() {
	                return +/* @__PURE__ */ new Date();
	              };
	              if (d3_document) {
	                try {
	                  d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	                } catch (error) {
	                  var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	                  d3_element_prototype.setAttribute = function(name2, value) {
	                    d3_element_setAttribute.call(this, name2, value + "");
	                  };
	                  d3_element_prototype.setAttributeNS = function(space, local, value) {
	                    d3_element_setAttributeNS.call(this, space, local, value + "");
	                  };
	                  d3_style_prototype.setProperty = function(name2, value, priority) {
	                    d3_style_setProperty.call(this, name2, value + "", priority);
	                  };
	                }
	              }
	              d3.ascending = d3_ascending;
	              function d3_ascending(a, b) {
	                return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	              }
	              d3.descending = function(a, b) {
	                return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	              };
	              d3.min = function(array, f) {
	                var i = -1, n = array.length, a, b;
	                if (arguments.length === 1) {
	                  while (++i < n) if ((b = array[i]) != null && b >= b) {
	                    a = b;
	                    break;
	                  }
	                  while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	                } else {
	                  while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	                    a = b;
	                    break;
	                  }
	                  while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	                }
	                return a;
	              };
	              d3.max = function(array, f) {
	                var i = -1, n = array.length, a, b;
	                if (arguments.length === 1) {
	                  while (++i < n) if ((b = array[i]) != null && b >= b) {
	                    a = b;
	                    break;
	                  }
	                  while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	                } else {
	                  while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	                    a = b;
	                    break;
	                  }
	                  while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	                }
	                return a;
	              };
	              d3.extent = function(array, f) {
	                var i = -1, n = array.length, a, b, c;
	                if (arguments.length === 1) {
	                  while (++i < n) if ((b = array[i]) != null && b >= b) {
	                    a = c = b;
	                    break;
	                  }
	                  while (++i < n) if ((b = array[i]) != null) {
	                    if (a > b) a = b;
	                    if (c < b) c = b;
	                  }
	                } else {
	                  while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	                    a = c = b;
	                    break;
	                  }
	                  while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	                    if (a > b) a = b;
	                    if (c < b) c = b;
	                  }
	                }
	                return [a, c];
	              };
	              function d3_number(x) {
	                return x === null ? NaN : +x;
	              }
	              function d3_numeric(x) {
	                return !isNaN(x);
	              }
	              d3.sum = function(array, f) {
	                var s = 0, n = array.length, a, i = -1;
	                if (arguments.length === 1) {
	                  while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	                } else {
	                  while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	                }
	                return s;
	              };
	              d3.mean = function(array, f) {
	                var s = 0, n = array.length, a, i = -1, j = n;
	                if (arguments.length === 1) {
	                  while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a;
	                  else --j;
	                } else {
	                  while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a;
	                  else --j;
	                }
	                if (j) return s / j;
	              };
	              d3.quantile = function(values, p) {
	                var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	                return e ? v + e * (values[h] - v) : v;
	              };
	              d3.median = function(array, f) {
	                var numbers = [], n = array.length, a, i = -1;
	                if (arguments.length === 1) {
	                  while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	                } else {
	                  while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	                }
	                if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), 0.5);
	              };
	              d3.variance = function(array, f) {
	                var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	                if (arguments.length === 1) {
	                  while (++i < n) {
	                    if (d3_numeric(a = d3_number(array[i]))) {
	                      d = a - m;
	                      m += d / ++j;
	                      s += d * (a - m);
	                    }
	                  }
	                } else {
	                  while (++i < n) {
	                    if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	                      d = a - m;
	                      m += d / ++j;
	                      s += d * (a - m);
	                    }
	                  }
	                }
	                if (j > 1) return s / (j - 1);
	              };
	              d3.deviation = function() {
	                var v = d3.variance.apply(this, arguments);
	                return v ? Math.sqrt(v) : v;
	              };
	              function d3_bisector(compare) {
	                return {
	                  left: function(a, x, lo, hi) {
	                    if (arguments.length < 3) lo = 0;
	                    if (arguments.length < 4) hi = a.length;
	                    while (lo < hi) {
	                      var mid = lo + hi >>> 1;
	                      if (compare(a[mid], x) < 0) lo = mid + 1;
	                      else hi = mid;
	                    }
	                    return lo;
	                  },
	                  right: function(a, x, lo, hi) {
	                    if (arguments.length < 3) lo = 0;
	                    if (arguments.length < 4) hi = a.length;
	                    while (lo < hi) {
	                      var mid = lo + hi >>> 1;
	                      if (compare(a[mid], x) > 0) hi = mid;
	                      else lo = mid + 1;
	                    }
	                    return lo;
	                  }
	                };
	              }
	              var d3_bisect = d3_bisector(d3_ascending);
	              d3.bisectLeft = d3_bisect.left;
	              d3.bisect = d3.bisectRight = d3_bisect.right;
	              d3.bisector = function(f) {
	                return d3_bisector(f.length === 1 ? function(d, x) {
	                  return d3_ascending(f(d), x);
	                } : f);
	              };
	              d3.shuffle = function(array, i0, i1) {
	                if ((m = arguments.length) < 3) {
	                  i1 = array.length;
	                  if (m < 2) i0 = 0;
	                }
	                var m = i1 - i0, t, i;
	                while (m) {
	                  i = Math.random() * m-- | 0;
	                  t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	                }
	                return array;
	              };
	              d3.permute = function(array, indexes) {
	                var i = indexes.length, permutes = new Array(i);
	                while (i--) permutes[i] = array[indexes[i]];
	                return permutes;
	              };
	              d3.pairs = function(array) {
	                var i = 0, n = array.length - 1, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	                while (i < n) pairs[i] = [p1, p1 = array[++i]];
	                return pairs;
	              };
	              d3.transpose = function(matrix) {
	                if (!(n = matrix.length)) return [];
	                for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	                  for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	                    row[j] = matrix[j][i];
	                  }
	                }
	                return transpose;
	              };
	              function d3_transposeLength(d) {
	                return d.length;
	              }
	              d3.zip = function() {
	                return d3.transpose(arguments);
	              };
	              d3.keys = function(map2) {
	                var keys = [];
	                for (var key in map2) keys.push(key);
	                return keys;
	              };
	              d3.values = function(map2) {
	                var values = [];
	                for (var key in map2) values.push(map2[key]);
	                return values;
	              };
	              d3.entries = function(map2) {
	                var entries = [];
	                for (var key in map2) entries.push({
	                  key,
	                  value: map2[key]
	                });
	                return entries;
	              };
	              d3.merge = function(arrays) {
	                var n = arrays.length, m, i = -1, j = 0, merged, array;
	                while (++i < n) j += arrays[i].length;
	                merged = new Array(j);
	                while (--n >= 0) {
	                  array = arrays[n];
	                  m = array.length;
	                  while (--m >= 0) {
	                    merged[--j] = array[m];
	                  }
	                }
	                return merged;
	              };
	              var abs = Math.abs;
	              d3.range = function(start, stop, step) {
	                if (arguments.length < 3) {
	                  step = 1;
	                  if (arguments.length < 2) {
	                    stop = start;
	                    start = 0;
	                  }
	                }
	                if ((stop - start) / step === Infinity) throw new Error("infinite range");
	                var range2 = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	                start *= k, stop *= k, step *= k;
	                if (step < 0) while ((j = start + step * ++i) > stop) range2.push(j / k);
	                else while ((j = start + step * ++i) < stop) range2.push(j / k);
	                return range2;
	              };
	              function d3_range_integerScale(x) {
	                var k = 1;
	                while (x * k % 1) k *= 10;
	                return k;
	              }
	              function d3_class(ctor, properties) {
	                for (var key in properties) {
	                  Object.defineProperty(ctor.prototype, key, {
	                    value: properties[key],
	                    enumerable: false
	                  });
	                }
	              }
	              d3.map = function(object, f) {
	                var map2 = new d3_Map();
	                if (object instanceof d3_Map) {
	                  object.forEach(function(key2, value) {
	                    map2.set(key2, value);
	                  });
	                } else if (Array.isArray(object)) {
	                  var i = -1, n = object.length, o;
	                  if (arguments.length === 1) while (++i < n) map2.set(i, object[i]);
	                  else while (++i < n) map2.set(f.call(object, o = object[i], i), o);
	                } else {
	                  for (var key in object) map2.set(key, object[key]);
	                }
	                return map2;
	              };
	              function d3_Map() {
	                this._ = /* @__PURE__ */ Object.create(null);
	              }
	              var d3_map_proto = "__proto__", d3_map_zero = "\0";
	              d3_class(d3_Map, {
	                has: d3_map_has,
	                get: function(key) {
	                  return this._[d3_map_escape(key)];
	                },
	                set: function(key, value) {
	                  return this._[d3_map_escape(key)] = value;
	                },
	                remove: d3_map_remove,
	                keys: d3_map_keys,
	                values: function() {
	                  var values = [];
	                  for (var key in this._) values.push(this._[key]);
	                  return values;
	                },
	                entries: function() {
	                  var entries = [];
	                  for (var key in this._) entries.push({
	                    key: d3_map_unescape(key),
	                    value: this._[key]
	                  });
	                  return entries;
	                },
	                size: d3_map_size,
	                empty: d3_map_empty,
	                forEach: function(f) {
	                  for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	                }
	              });
	              function d3_map_escape(key) {
	                return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	              }
	              function d3_map_unescape(key) {
	                return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	              }
	              function d3_map_has(key) {
	                return d3_map_escape(key) in this._;
	              }
	              function d3_map_remove(key) {
	                return (key = d3_map_escape(key)) in this._ && delete this._[key];
	              }
	              function d3_map_keys() {
	                var keys = [];
	                for (var key in this._) keys.push(d3_map_unescape(key));
	                return keys;
	              }
	              function d3_map_size() {
	                var size = 0;
	                for (var key in this._) ++size;
	                return size;
	              }
	              function d3_map_empty() {
	                for (var key in this._) return false;
	                return true;
	              }
	              d3.nest = function() {
	                var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	                function map2(mapType, array, depth) {
	                  if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	                  var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	                  while (++i < n) {
	                    if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	                      values.push(object);
	                    } else {
	                      valuesByKey.set(keyValue, [object]);
	                    }
	                  }
	                  if (mapType) {
	                    object = mapType();
	                    setter = function(keyValue2, values2) {
	                      object.set(keyValue2, map2(mapType, values2, depth));
	                    };
	                  } else {
	                    object = {};
	                    setter = function(keyValue2, values2) {
	                      object[keyValue2] = map2(mapType, values2, depth);
	                    };
	                  }
	                  valuesByKey.forEach(setter);
	                  return object;
	                }
	                function entries(map3, depth) {
	                  if (depth >= keys.length) return map3;
	                  var array = [], sortKey = sortKeys[depth++];
	                  map3.forEach(function(key, keyMap) {
	                    array.push({
	                      key,
	                      values: entries(keyMap, depth)
	                    });
	                  });
	                  return sortKey ? array.sort(function(a, b) {
	                    return sortKey(a.key, b.key);
	                  }) : array;
	                }
	                nest.map = function(array, mapType) {
	                  return map2(mapType, array, 0);
	                };
	                nest.entries = function(array) {
	                  return entries(map2(d3.map, array, 0), 0);
	                };
	                nest.key = function(d) {
	                  keys.push(d);
	                  return nest;
	                };
	                nest.sortKeys = function(order) {
	                  sortKeys[keys.length - 1] = order;
	                  return nest;
	                };
	                nest.sortValues = function(order) {
	                  sortValues = order;
	                  return nest;
	                };
	                nest.rollup = function(f) {
	                  rollup = f;
	                  return nest;
	                };
	                return nest;
	              };
	              d3.set = function(array) {
	                var set = new d3_Set();
	                if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	                return set;
	              };
	              function d3_Set() {
	                this._ = /* @__PURE__ */ Object.create(null);
	              }
	              d3_class(d3_Set, {
	                has: d3_map_has,
	                add: function(key) {
	                  this._[d3_map_escape(key += "")] = true;
	                  return key;
	                },
	                remove: d3_map_remove,
	                values: d3_map_keys,
	                size: d3_map_size,
	                empty: d3_map_empty,
	                forEach: function(f) {
	                  for (var key in this._) f.call(this, d3_map_unescape(key));
	                }
	              });
	              d3.behavior = {};
	              function d3_identity(d) {
	                return d;
	              }
	              d3.rebind = function(target, source) {
	                var i = 1, n = arguments.length, method;
	                while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	                return target;
	              };
	              function d3_rebind(target, source, method) {
	                return function() {
	                  var value = method.apply(source, arguments);
	                  return value === source ? target : value;
	                };
	              }
	              function d3_vendorSymbol(object, name2) {
	                if (name2 in object) return name2;
	                name2 = name2.charAt(0).toUpperCase() + name2.slice(1);
	                for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	                  var prefixName = d3_vendorPrefixes[i] + name2;
	                  if (prefixName in object) return prefixName;
	                }
	              }
	              var d3_vendorPrefixes = ["webkit", "ms", "moz", "Moz", "o", "O"];
	              function d3_noop() {
	              }
	              d3.dispatch = function() {
	                var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	                while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	                return dispatch;
	              };
	              function d3_dispatch() {
	              }
	              d3_dispatch.prototype.on = function(type, listener) {
	                var i = type.indexOf("."), name2 = "";
	                if (i >= 0) {
	                  name2 = type.slice(i + 1);
	                  type = type.slice(0, i);
	                }
	                if (type) return arguments.length < 2 ? this[type].on(name2) : this[type].on(name2, listener);
	                if (arguments.length === 2) {
	                  if (listener == null) for (type in this) {
	                    if (this.hasOwnProperty(type)) this[type].on(name2, null);
	                  }
	                  return this;
	                }
	              };
	              function d3_dispatch_event(dispatch) {
	                var listeners = [], listenerByName = new d3_Map();
	                function event() {
	                  var z = listeners, i = -1, n = z.length, l;
	                  while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	                  return dispatch;
	                }
	                event.on = function(name2, listener) {
	                  var l = listenerByName.get(name2), i;
	                  if (arguments.length < 2) return l && l.on;
	                  if (l) {
	                    l.on = null;
	                    listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	                    listenerByName.remove(name2);
	                  }
	                  if (listener) listeners.push(listenerByName.set(name2, {
	                    on: listener
	                  }));
	                  return dispatch;
	                };
	                return event;
	              }
	              d3.event = null;
	              function d3_eventPreventDefault() {
	                d3.event.preventDefault();
	              }
	              function d3_eventSource() {
	                var e = d3.event, s;
	                while (s = e.sourceEvent) e = s;
	                return e;
	              }
	              function d3_eventDispatch(target) {
	                var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	                while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	                dispatch.of = function(thiz, argumentz) {
	                  return function(e1) {
	                    try {
	                      var e0 = e1.sourceEvent = d3.event;
	                      e1.target = target;
	                      d3.event = e1;
	                      dispatch[e1.type].apply(thiz, argumentz);
	                    } finally {
	                      d3.event = e0;
	                    }
	                  };
	                };
	                return dispatch;
	              }
	              d3.requote = function(s) {
	                return s.replace(d3_requote_re, "\\$&");
	              };
	              var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	              var d3_subclass = {}.__proto__ ? function(object, prototype) {
	                object.__proto__ = prototype;
	              } : function(object, prototype) {
	                for (var property in prototype) object[property] = prototype[property];
	              };
	              function d3_selection(groups) {
	                d3_subclass(groups, d3_selectionPrototype);
	                return groups;
	              }
	              var d3_select = function(s, n) {
	                return n.querySelector(s);
	              }, d3_selectAll = function(s, n) {
	                return n.querySelectorAll(s);
	              }, d3_selectMatches = function(n, s) {
	                var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	                d3_selectMatches = function(n2, s2) {
	                  return d3_selectMatcher.call(n2, s2);
	                };
	                return d3_selectMatches(n, s);
	              };
	              if (typeof Sizzle === "function") {
	                d3_select = function(s, n) {
	                  return Sizzle(s, n)[0] || null;
	                };
	                d3_selectAll = Sizzle;
	                d3_selectMatches = Sizzle.matchesSelector;
	              }
	              d3.selection = function() {
	                return d3.select(d3_document.documentElement);
	              };
	              var d3_selectionPrototype = d3.selection.prototype = [];
	              d3_selectionPrototype.select = function(selector) {
	                var subgroups = [], subgroup, subnode, group, node;
	                selector = d3_selection_selector(selector);
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  subgroups.push(subgroup = []);
	                  subgroup.parentNode = (group = this[j]).parentNode;
	                  for (var i = -1, n = group.length; ++i < n; ) {
	                    if (node = group[i]) {
	                      subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	                      if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	                    } else {
	                      subgroup.push(null);
	                    }
	                  }
	                }
	                return d3_selection(subgroups);
	              };
	              function d3_selection_selector(selector) {
	                return typeof selector === "function" ? selector : function() {
	                  return d3_select(selector, this);
	                };
	              }
	              d3_selectionPrototype.selectAll = function(selector) {
	                var subgroups = [], subgroup, node;
	                selector = d3_selection_selectorAll(selector);
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	                    if (node = group[i]) {
	                      subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	                      subgroup.parentNode = node;
	                    }
	                  }
	                }
	                return d3_selection(subgroups);
	              };
	              function d3_selection_selectorAll(selector) {
	                return typeof selector === "function" ? selector : function() {
	                  return d3_selectAll(selector, this);
	                };
	              }
	              var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	              var d3_nsPrefix = {
	                svg: "http://www.w3.org/2000/svg",
	                xhtml: d3_nsXhtml,
	                xlink: "http://www.w3.org/1999/xlink",
	                xml: "http://www.w3.org/XML/1998/namespace",
	                xmlns: "http://www.w3.org/2000/xmlns/"
	              };
	              d3.ns = {
	                prefix: d3_nsPrefix,
	                qualify: function(name2) {
	                  var i = name2.indexOf(":"), prefix = name2;
	                  if (i >= 0 && (prefix = name2.slice(0, i)) !== "xmlns") name2 = name2.slice(i + 1);
	                  return d3_nsPrefix.hasOwnProperty(prefix) ? {
	                    space: d3_nsPrefix[prefix],
	                    local: name2
	                  } : name2;
	                }
	              };
	              d3_selectionPrototype.attr = function(name2, value) {
	                if (arguments.length < 2) {
	                  if (typeof name2 === "string") {
	                    var node = this.node();
	                    name2 = d3.ns.qualify(name2);
	                    return name2.local ? node.getAttributeNS(name2.space, name2.local) : node.getAttribute(name2);
	                  }
	                  for (value in name2) this.each(d3_selection_attr(value, name2[value]));
	                  return this;
	                }
	                return this.each(d3_selection_attr(name2, value));
	              };
	              function d3_selection_attr(name2, value) {
	                name2 = d3.ns.qualify(name2);
	                function attrNull() {
	                  this.removeAttribute(name2);
	                }
	                function attrNullNS() {
	                  this.removeAttributeNS(name2.space, name2.local);
	                }
	                function attrConstant() {
	                  this.setAttribute(name2, value);
	                }
	                function attrConstantNS() {
	                  this.setAttributeNS(name2.space, name2.local, value);
	                }
	                function attrFunction() {
	                  var x = value.apply(this, arguments);
	                  if (x == null) this.removeAttribute(name2);
	                  else this.setAttribute(name2, x);
	                }
	                function attrFunctionNS() {
	                  var x = value.apply(this, arguments);
	                  if (x == null) this.removeAttributeNS(name2.space, name2.local);
	                  else this.setAttributeNS(name2.space, name2.local, x);
	                }
	                return value == null ? name2.local ? attrNullNS : attrNull : typeof value === "function" ? name2.local ? attrFunctionNS : attrFunction : name2.local ? attrConstantNS : attrConstant;
	              }
	              function d3_collapse(s) {
	                return s.trim().replace(/\s+/g, " ");
	              }
	              d3_selectionPrototype.classed = function(name2, value) {
	                if (arguments.length < 2) {
	                  if (typeof name2 === "string") {
	                    var node = this.node(), n = (name2 = d3_selection_classes(name2)).length, i = -1;
	                    if (value = node.classList) {
	                      while (++i < n) if (!value.contains(name2[i])) return false;
	                    } else {
	                      value = node.getAttribute("class");
	                      while (++i < n) if (!d3_selection_classedRe(name2[i]).test(value)) return false;
	                    }
	                    return true;
	                  }
	                  for (value in name2) this.each(d3_selection_classed(value, name2[value]));
	                  return this;
	                }
	                return this.each(d3_selection_classed(name2, value));
	              };
	              function d3_selection_classedRe(name2) {
	                return new RegExp("(?:^|\\s+)" + d3.requote(name2) + "(?:\\s+|$)", "g");
	              }
	              function d3_selection_classes(name2) {
	                return (name2 + "").trim().split(/^|\s+/);
	              }
	              function d3_selection_classed(name2, value) {
	                name2 = d3_selection_classes(name2).map(d3_selection_classedName);
	                var n = name2.length;
	                function classedConstant() {
	                  var i = -1;
	                  while (++i < n) name2[i](this, value);
	                }
	                function classedFunction() {
	                  var i = -1, x = value.apply(this, arguments);
	                  while (++i < n) name2[i](this, x);
	                }
	                return typeof value === "function" ? classedFunction : classedConstant;
	              }
	              function d3_selection_classedName(name2) {
	                var re = d3_selection_classedRe(name2);
	                return function(node, value) {
	                  if (c = node.classList) return value ? c.add(name2) : c.remove(name2);
	                  var c = node.getAttribute("class") || "";
	                  if (value) {
	                    re.lastIndex = 0;
	                    if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name2));
	                  } else {
	                    node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	                  }
	                };
	              }
	              d3_selectionPrototype.style = function(name2, value, priority) {
	                var n = arguments.length;
	                if (n < 3) {
	                  if (typeof name2 !== "string") {
	                    if (n < 2) value = "";
	                    for (priority in name2) this.each(d3_selection_style(priority, name2[priority], value));
	                    return this;
	                  }
	                  if (n < 2) {
	                    var node = this.node();
	                    return d3_window(node).getComputedStyle(node, null).getPropertyValue(name2);
	                  }
	                  priority = "";
	                }
	                return this.each(d3_selection_style(name2, value, priority));
	              };
	              function d3_selection_style(name2, value, priority) {
	                function styleNull() {
	                  this.style.removeProperty(name2);
	                }
	                function styleConstant() {
	                  this.style.setProperty(name2, value, priority);
	                }
	                function styleFunction() {
	                  var x = value.apply(this, arguments);
	                  if (x == null) this.style.removeProperty(name2);
	                  else this.style.setProperty(name2, x, priority);
	                }
	                return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	              }
	              d3_selectionPrototype.property = function(name2, value) {
	                if (arguments.length < 2) {
	                  if (typeof name2 === "string") return this.node()[name2];
	                  for (value in name2) this.each(d3_selection_property(value, name2[value]));
	                  return this;
	                }
	                return this.each(d3_selection_property(name2, value));
	              };
	              function d3_selection_property(name2, value) {
	                function propertyNull() {
	                  delete this[name2];
	                }
	                function propertyConstant() {
	                  this[name2] = value;
	                }
	                function propertyFunction() {
	                  var x = value.apply(this, arguments);
	                  if (x == null) delete this[name2];
	                  else this[name2] = x;
	                }
	                return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	              }
	              d3_selectionPrototype.text = function(value) {
	                return arguments.length ? this.each(typeof value === "function" ? function() {
	                  var v = value.apply(this, arguments);
	                  this.textContent = v == null ? "" : v;
	                } : value == null ? function() {
	                  this.textContent = "";
	                } : function() {
	                  this.textContent = value;
	                }) : this.node().textContent;
	              };
	              d3_selectionPrototype.html = function(value) {
	                return arguments.length ? this.each(typeof value === "function" ? function() {
	                  var v = value.apply(this, arguments);
	                  this.innerHTML = v == null ? "" : v;
	                } : value == null ? function() {
	                  this.innerHTML = "";
	                } : function() {
	                  this.innerHTML = value;
	                }) : this.node().innerHTML;
	              };
	              d3_selectionPrototype.append = function(name2) {
	                name2 = d3_selection_creator(name2);
	                return this.select(function() {
	                  return this.appendChild(name2.apply(this, arguments));
	                });
	              };
	              function d3_selection_creator(name2) {
	                function create() {
	                  var document2 = this.ownerDocument, namespace = this.namespaceURI;
	                  return namespace === d3_nsXhtml && document2.documentElement.namespaceURI === d3_nsXhtml ? document2.createElement(name2) : document2.createElementNS(namespace, name2);
	                }
	                function createNS() {
	                  return this.ownerDocument.createElementNS(name2.space, name2.local);
	                }
	                return typeof name2 === "function" ? name2 : (name2 = d3.ns.qualify(name2)).local ? createNS : create;
	              }
	              d3_selectionPrototype.insert = function(name2, before) {
	                name2 = d3_selection_creator(name2);
	                before = d3_selection_selector(before);
	                return this.select(function() {
	                  return this.insertBefore(name2.apply(this, arguments), before.apply(this, arguments) || null);
	                });
	              };
	              d3_selectionPrototype.remove = function() {
	                return this.each(d3_selectionRemove);
	              };
	              function d3_selectionRemove() {
	                var parent = this.parentNode;
	                if (parent) parent.removeChild(this);
	              }
	              d3_selectionPrototype.data = function(value, key) {
	                var i = -1, n = this.length, group, node;
	                if (!arguments.length) {
	                  value = new Array(n = (group = this[0]).length);
	                  while (++i < n) {
	                    if (node = group[i]) {
	                      value[i] = node.__data__;
	                    }
	                  }
	                  return value;
	                }
	                function bind(group2, groupData) {
	                  var i2, n2 = group2.length, m = groupData.length, n0 = Math.min(n2, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n2), node2, nodeData;
	                  if (key) {
	                    var nodeByKeyValue = new d3_Map(), keyValues = new Array(n2), keyValue;
	                    for (i2 = -1; ++i2 < n2; ) {
	                      if (node2 = group2[i2]) {
	                        if (nodeByKeyValue.has(keyValue = key.call(node2, node2.__data__, i2))) {
	                          exitNodes[i2] = node2;
	                        } else {
	                          nodeByKeyValue.set(keyValue, node2);
	                        }
	                        keyValues[i2] = keyValue;
	                      }
	                    }
	                    for (i2 = -1; ++i2 < m; ) {
	                      if (!(node2 = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i2], i2)))) {
	                        enterNodes[i2] = d3_selection_dataNode(nodeData);
	                      } else if (node2 !== true) {
	                        updateNodes[i2] = node2;
	                        node2.__data__ = nodeData;
	                      }
	                      nodeByKeyValue.set(keyValue, true);
	                    }
	                    for (i2 = -1; ++i2 < n2; ) {
	                      if (i2 in keyValues && nodeByKeyValue.get(keyValues[i2]) !== true) {
	                        exitNodes[i2] = group2[i2];
	                      }
	                    }
	                  } else {
	                    for (i2 = -1; ++i2 < n0; ) {
	                      node2 = group2[i2];
	                      nodeData = groupData[i2];
	                      if (node2) {
	                        node2.__data__ = nodeData;
	                        updateNodes[i2] = node2;
	                      } else {
	                        enterNodes[i2] = d3_selection_dataNode(nodeData);
	                      }
	                    }
	                    for (; i2 < m; ++i2) {
	                      enterNodes[i2] = d3_selection_dataNode(groupData[i2]);
	                    }
	                    for (; i2 < n2; ++i2) {
	                      exitNodes[i2] = group2[i2];
	                    }
	                  }
	                  enterNodes.update = updateNodes;
	                  enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group2.parentNode;
	                  enter.push(enterNodes);
	                  update.push(updateNodes);
	                  exit.push(exitNodes);
	                }
	                var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	                if (typeof value === "function") {
	                  while (++i < n) {
	                    bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	                  }
	                } else {
	                  while (++i < n) {
	                    bind(group = this[i], value);
	                  }
	                }
	                update.enter = function() {
	                  return enter;
	                };
	                update.exit = function() {
	                  return exit;
	                };
	                return update;
	              };
	              function d3_selection_dataNode(data) {
	                return {
	                  __data__: data
	                };
	              }
	              d3_selectionPrototype.datum = function(value) {
	                return arguments.length ? this.property("__data__", value) : this.property("__data__");
	              };
	              d3_selectionPrototype.filter = function(filter) {
	                var subgroups = [], subgroup, group, node;
	                if (typeof filter !== "function") filter = d3_selection_filter(filter);
	                for (var j = 0, m = this.length; j < m; j++) {
	                  subgroups.push(subgroup = []);
	                  subgroup.parentNode = (group = this[j]).parentNode;
	                  for (var i = 0, n = group.length; i < n; i++) {
	                    if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	                      subgroup.push(node);
	                    }
	                  }
	                }
	                return d3_selection(subgroups);
	              };
	              function d3_selection_filter(selector) {
	                return function() {
	                  return d3_selectMatches(this, selector);
	                };
	              }
	              d3_selectionPrototype.order = function() {
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	                    if (node = group[i]) {
	                      if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	                      next = node;
	                    }
	                  }
	                }
	                return this;
	              };
	              d3_selectionPrototype.sort = function(comparator) {
	                comparator = d3_selection_sortComparator.apply(this, arguments);
	                for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	                return this.order();
	              };
	              function d3_selection_sortComparator(comparator) {
	                if (!arguments.length) comparator = d3_ascending;
	                return function(a, b) {
	                  return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	                };
	              }
	              d3_selectionPrototype.each = function(callback) {
	                return d3_selection_each(this, function(node, i, j) {
	                  callback.call(node, node.__data__, i, j);
	                });
	              };
	              function d3_selection_each(groups, callback) {
	                for (var j = 0, m = groups.length; j < m; j++) {
	                  for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	                    if (node = group[i]) callback(node, i, j);
	                  }
	                }
	                return groups;
	              }
	              d3_selectionPrototype.call = function(callback) {
	                var args = d3_array(arguments);
	                callback.apply(args[0] = this, args);
	                return this;
	              };
	              d3_selectionPrototype.empty = function() {
	                return !this.node();
	              };
	              d3_selectionPrototype.node = function() {
	                for (var j = 0, m = this.length; j < m; j++) {
	                  for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	                    var node = group[i];
	                    if (node) return node;
	                  }
	                }
	                return null;
	              };
	              d3_selectionPrototype.size = function() {
	                var n = 0;
	                d3_selection_each(this, function() {
	                  ++n;
	                });
	                return n;
	              };
	              function d3_selection_enter(selection) {
	                d3_subclass(selection, d3_selection_enterPrototype);
	                return selection;
	              }
	              var d3_selection_enterPrototype = [];
	              d3.selection.enter = d3_selection_enter;
	              d3.selection.enter.prototype = d3_selection_enterPrototype;
	              d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	              d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	              d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	              d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	              d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	              d3_selection_enterPrototype.select = function(selector) {
	                var subgroups = [], subgroup, subnode, upgroup, group, node;
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  upgroup = (group = this[j]).update;
	                  subgroups.push(subgroup = []);
	                  subgroup.parentNode = group.parentNode;
	                  for (var i = -1, n = group.length; ++i < n; ) {
	                    if (node = group[i]) {
	                      subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	                      subnode.__data__ = node.__data__;
	                    } else {
	                      subgroup.push(null);
	                    }
	                  }
	                }
	                return d3_selection(subgroups);
	              };
	              d3_selection_enterPrototype.insert = function(name2, before) {
	                if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	                return d3_selectionPrototype.insert.call(this, name2, before);
	              };
	              function d3_selection_enterInsertBefore(enter) {
	                var i0, j0;
	                return function(d, i, j) {
	                  var group = enter[j].update, n = group.length, node;
	                  if (j != j0) j0 = j, i0 = 0;
	                  if (i >= i0) i0 = i + 1;
	                  while (!(node = group[i0]) && ++i0 < n) ;
	                  return node;
	                };
	              }
	              d3.select = function(node) {
	                var group;
	                if (typeof node === "string") {
	                  group = [d3_select(node, d3_document)];
	                  group.parentNode = d3_document.documentElement;
	                } else {
	                  group = [node];
	                  group.parentNode = d3_documentElement(node);
	                }
	                return d3_selection([group]);
	              };
	              d3.selectAll = function(nodes) {
	                var group;
	                if (typeof nodes === "string") {
	                  group = d3_array(d3_selectAll(nodes, d3_document));
	                  group.parentNode = d3_document.documentElement;
	                } else {
	                  group = d3_array(nodes);
	                  group.parentNode = null;
	                }
	                return d3_selection([group]);
	              };
	              d3_selectionPrototype.on = function(type, listener, capture) {
	                var n = arguments.length;
	                if (n < 3) {
	                  if (typeof type !== "string") {
	                    if (n < 2) listener = false;
	                    for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	                    return this;
	                  }
	                  if (n < 2) return (n = this.node()["__on" + type]) && n._;
	                  capture = false;
	                }
	                return this.each(d3_selection_on(type, listener, capture));
	              };
	              function d3_selection_on(type, listener, capture) {
	                var name2 = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	                if (i > 0) type = type.slice(0, i);
	                var filter = d3_selection_onFilters.get(type);
	                if (filter) type = filter, wrap = d3_selection_onFilter;
	                function onRemove() {
	                  var l = this[name2];
	                  if (l) {
	                    this.removeEventListener(type, l, l.$);
	                    delete this[name2];
	                  }
	                }
	                function onAdd() {
	                  var l = wrap(listener, d3_array(arguments));
	                  onRemove.call(this);
	                  this.addEventListener(type, this[name2] = l, l.$ = capture);
	                  l._ = listener;
	                }
	                function removeAll() {
	                  var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	                  for (var name3 in this) {
	                    if (match = name3.match(re)) {
	                      var l = this[name3];
	                      this.removeEventListener(match[1], l, l.$);
	                      delete this[name3];
	                    }
	                  }
	                }
	                return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	              }
	              var d3_selection_onFilters = d3.map({
	                mouseenter: "mouseover",
	                mouseleave: "mouseout"
	              });
	              if (d3_document) {
	                d3_selection_onFilters.forEach(function(k) {
	                  if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	                });
	              }
	              function d3_selection_onListener(listener, argumentz) {
	                return function(e) {
	                  var o = d3.event;
	                  d3.event = e;
	                  argumentz[0] = this.__data__;
	                  try {
	                    listener.apply(this, argumentz);
	                  } finally {
	                    d3.event = o;
	                  }
	                };
	              }
	              function d3_selection_onFilter(listener, argumentz) {
	                var l = d3_selection_onListener(listener, argumentz);
	                return function(e) {
	                  var target = this, related = e.relatedTarget;
	                  if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	                    l.call(target, e);
	                  }
	                };
	              }
	              var d3_event_dragSelect, d3_event_dragId = 0;
	              function d3_event_dragSuppress(node) {
	                var name2 = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name2, w = d3.select(d3_window(node)).on("touchmove" + name2, d3_eventPreventDefault).on("dragstart" + name2, d3_eventPreventDefault).on("selectstart" + name2, d3_eventPreventDefault);
	                if (d3_event_dragSelect == null) {
	                  d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	                }
	                if (d3_event_dragSelect) {
	                  var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	                  style[d3_event_dragSelect] = "none";
	                }
	                return function(suppressClick) {
	                  w.on(name2, null);
	                  if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	                  if (suppressClick) {
	                    var off = function() {
	                      w.on(click, null);
	                    };
	                    w.on(click, function() {
	                      d3_eventPreventDefault();
	                      off();
	                    }, true);
	                    setTimeout(off, 0);
	                  }
	                };
	              }
	              d3.mouse = function(container) {
	                return d3_mousePoint(container, d3_eventSource());
	              };
	              var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	              function d3_mousePoint(container, e) {
	                if (e.changedTouches) e = e.changedTouches[0];
	                var svg = container.ownerSVGElement || container;
	                if (svg.createSVGPoint) {
	                  var point = svg.createSVGPoint();
	                  if (d3_mouse_bug44083 < 0) {
	                    var window2 = d3_window(container);
	                    if (window2.scrollX || window2.scrollY) {
	                      svg = d3.select("body").append("svg").style({
	                        position: "absolute",
	                        top: 0,
	                        left: 0,
	                        margin: 0,
	                        padding: 0,
	                        border: "none"
	                      }, "important");
	                      var ctm = svg[0][0].getScreenCTM();
	                      d3_mouse_bug44083 = !(ctm.f || ctm.e);
	                      svg.remove();
	                    }
	                  }
	                  if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY;
	                  else point.x = e.clientX, point.y = e.clientY;
	                  point = point.matrixTransform(container.getScreenCTM().inverse());
	                  return [point.x, point.y];
	                }
	                var rect = container.getBoundingClientRect();
	                return [e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop];
	              }
	              d3.touch = function(container, touches, identifier) {
	                if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	                if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	                  if ((touch = touches[i]).identifier === identifier) {
	                    return d3_mousePoint(container, touch);
	                  }
	                }
	              };
	              d3.behavior.drag = function() {
	                var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	                function drag() {
	                  this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	                }
	                function dragstart(id, position, subject, move, end) {
	                  return function() {
	                    var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	                    if (origin) {
	                      dragOffset = origin.apply(that, arguments);
	                      dragOffset = [dragOffset.x - position0[0], dragOffset.y - position0[1]];
	                    } else {
	                      dragOffset = [0, 0];
	                    }
	                    dispatch({
	                      type: "dragstart"
	                    });
	                    function moved() {
	                      var position1 = position(parent, dragId), dx, dy;
	                      if (!position1) return;
	                      dx = position1[0] - position0[0];
	                      dy = position1[1] - position0[1];
	                      dragged |= dx | dy;
	                      position0 = position1;
	                      dispatch({
	                        type: "drag",
	                        x: position1[0] + dragOffset[0],
	                        y: position1[1] + dragOffset[1],
	                        dx,
	                        dy
	                      });
	                    }
	                    function ended() {
	                      if (!position(parent, dragId)) return;
	                      dragSubject.on(move + dragName, null).on(end + dragName, null);
	                      dragRestore(dragged);
	                      dispatch({
	                        type: "dragend"
	                      });
	                    }
	                  };
	                }
	                drag.origin = function(x) {
	                  if (!arguments.length) return origin;
	                  origin = x;
	                  return drag;
	                };
	                return d3.rebind(drag, event, "on");
	              };
	              function d3_behavior_dragTouchId() {
	                return d3.event.changedTouches[0].identifier;
	              }
	              d3.touches = function(container, touches) {
	                if (arguments.length < 2) touches = d3_eventSource().touches;
	                return touches ? d3_array(touches).map(function(touch) {
	                  var point = d3_mousePoint(container, touch);
	                  point.identifier = touch.identifier;
	                  return point;
	                }) : [];
	              };
	              var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	              function d3_cross2d(a, b, c) {
	                return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	              }
	              function d3_asin(x) {
	                return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	              }
	              function d3_sinh(x) {
	                return ((x = Math.exp(x)) - 1 / x) / 2;
	              }
	              function d3_cosh(x) {
	                return ((x = Math.exp(x)) + 1 / x) / 2;
	              }
	              function d3_tanh(x) {
	                return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	              }
	              var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	              d3.interpolateZoom = function(p0, p1) {
	                var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	                if (d2 < ε2) {
	                  S = Math.log(w1 / w0) / ρ;
	                  i = function(t) {
	                    return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S)];
	                  };
	                } else {
	                  var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	                  S = (r1 - r0) / ρ;
	                  i = function(t) {
	                    var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	                    return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0)];
	                  };
	                }
	                i.duration = S * 1e3;
	                return i;
	              };
	              d3.behavior.zoom = function() {
	                var view = {
	                  x: 0,
	                  y: 0,
	                  k: 1
	                }, translate0, center0, center, size = [960, 500], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	                if (!d3_behavior_zoomWheel) {
	                  d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	                    return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	                  }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	                    return d3.event.wheelDelta;
	                  }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	                    return -d3.event.detail;
	                  }, "MozMousePixelScroll");
	                }
	                function zoom(g) {
	                  g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	                }
	                zoom.event = function(g) {
	                  g.each(function() {
	                    var dispatch = event.of(this, arguments), view1 = view;
	                    if (d3_transitionInheritId) {
	                      d3.select(this).transition().each("start.zoom", function() {
	                        view = this.__chart__ || {
	                          x: 0,
	                          y: 0,
	                          k: 1
	                        };
	                        zoomstarted(dispatch);
	                      }).tween("zoom:zoom", function() {
	                        var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([(cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k], [(cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k]);
	                        return function(t) {
	                          var l = i(t), k = dx / l[2];
	                          this.__chart__ = view = {
	                            x: cx - l[0] * k,
	                            y: cy - l[1] * k,
	                            k
	                          };
	                          zoomed(dispatch);
	                        };
	                      }).each("interrupt.zoom", function() {
	                        zoomended(dispatch);
	                      }).each("end.zoom", function() {
	                        zoomended(dispatch);
	                      });
	                    } else {
	                      this.__chart__ = view;
	                      zoomstarted(dispatch);
	                      zoomed(dispatch);
	                      zoomended(dispatch);
	                    }
	                  });
	                };
	                zoom.translate = function(_) {
	                  if (!arguments.length) return [view.x, view.y];
	                  view = {
	                    x: +_[0],
	                    y: +_[1],
	                    k: view.k
	                  };
	                  rescale();
	                  return zoom;
	                };
	                zoom.scale = function(_) {
	                  if (!arguments.length) return view.k;
	                  view = {
	                    x: view.x,
	                    y: view.y,
	                    k: null
	                  };
	                  scaleTo(+_);
	                  rescale();
	                  return zoom;
	                };
	                zoom.scaleExtent = function(_) {
	                  if (!arguments.length) return scaleExtent;
	                  scaleExtent = _ == null ? d3_behavior_zoomInfinity : [+_[0], +_[1]];
	                  return zoom;
	                };
	                zoom.center = function(_) {
	                  if (!arguments.length) return center;
	                  center = _ && [+_[0], +_[1]];
	                  return zoom;
	                };
	                zoom.size = function(_) {
	                  if (!arguments.length) return size;
	                  size = _ && [+_[0], +_[1]];
	                  return zoom;
	                };
	                zoom.duration = function(_) {
	                  if (!arguments.length) return duration;
	                  duration = +_;
	                  return zoom;
	                };
	                zoom.x = function(z) {
	                  if (!arguments.length) return x1;
	                  x1 = z;
	                  x0 = z.copy();
	                  view = {
	                    x: 0,
	                    y: 0,
	                    k: 1
	                  };
	                  return zoom;
	                };
	                zoom.y = function(z) {
	                  if (!arguments.length) return y1;
	                  y1 = z;
	                  y0 = z.copy();
	                  view = {
	                    x: 0,
	                    y: 0,
	                    k: 1
	                  };
	                  return zoom;
	                };
	                function location(p) {
	                  return [(p[0] - view.x) / view.k, (p[1] - view.y) / view.k];
	                }
	                function point(l) {
	                  return [l[0] * view.k + view.x, l[1] * view.k + view.y];
	                }
	                function scaleTo(s) {
	                  view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	                }
	                function translateTo(p, l) {
	                  l = point(l);
	                  view.x += p[0] - l[0];
	                  view.y += p[1] - l[1];
	                }
	                function zoomTo(that, p, l, k) {
	                  that.__chart__ = {
	                    x: view.x,
	                    y: view.y,
	                    k: view.k
	                  };
	                  scaleTo(Math.pow(2, k));
	                  translateTo(center0 = p, l);
	                  that = d3.select(that);
	                  if (duration > 0) that = that.transition().duration(duration);
	                  that.call(zoom.event);
	                }
	                function rescale() {
	                  if (x1) x1.domain(x0.range().map(function(x) {
	                    return (x - view.x) / view.k;
	                  }).map(x0.invert));
	                  if (y1) y1.domain(y0.range().map(function(y) {
	                    return (y - view.y) / view.k;
	                  }).map(y0.invert));
	                }
	                function zoomstarted(dispatch) {
	                  if (!zooming++) dispatch({
	                    type: "zoomstart"
	                  });
	                }
	                function zoomed(dispatch) {
	                  rescale();
	                  dispatch({
	                    type: "zoom",
	                    scale: view.k,
	                    translate: [view.x, view.y]
	                  });
	                }
	                function zoomended(dispatch) {
	                  if (!--zooming) dispatch({
	                    type: "zoomend"
	                  }), center0 = null;
	                }
	                function mousedowned() {
	                  var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	                  d3_selection_interrupt.call(that);
	                  zoomstarted(dispatch);
	                  function moved() {
	                    dragged = 1;
	                    translateTo(d3.mouse(that), location0);
	                    zoomed(dispatch);
	                  }
	                  function ended() {
	                    subject.on(mousemove, null).on(mouseup, null);
	                    dragRestore(dragged);
	                    zoomended(dispatch);
	                  }
	                }
	                function touchstarted() {
	                  var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	                  started();
	                  zoomstarted(dispatch);
	                  subject.on(mousedown, null).on(touchstart, started);
	                  function relocate() {
	                    var touches = d3.touches(that);
	                    scale0 = view.k;
	                    touches.forEach(function(t) {
	                      if (t.identifier in locations0) locations0[t.identifier] = location(t);
	                    });
	                    return touches;
	                  }
	                  function started() {
	                    var target = d3.event.target;
	                    d3.select(target).on(touchmove, moved).on(touchend, ended);
	                    targets.push(target);
	                    var changed = d3.event.changedTouches;
	                    for (var i = 0, n = changed.length; i < n; ++i) {
	                      locations0[changed[i].identifier] = null;
	                    }
	                    var touches = relocate(), now = Date.now();
	                    if (touches.length === 1) {
	                      if (now - touchtime < 500) {
	                        var p = touches[0];
	                        zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	                        d3_eventPreventDefault();
	                      }
	                      touchtime = now;
	                    } else if (touches.length > 1) {
	                      var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	                      distance0 = dx * dx + dy * dy;
	                    }
	                  }
	                  function moved() {
	                    var touches = d3.touches(that), p0, l0, p1, l1;
	                    d3_selection_interrupt.call(that);
	                    for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	                      p1 = touches[i];
	                      if (l1 = locations0[p1.identifier]) {
	                        if (l0) break;
	                        p0 = p1, l0 = l1;
	                      }
	                    }
	                    if (l1) {
	                      var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	                      p0 = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	                      l0 = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	                      scaleTo(scale1 * scale0);
	                    }
	                    touchtime = null;
	                    translateTo(p0, l0);
	                    zoomed(dispatch);
	                  }
	                  function ended() {
	                    if (d3.event.touches.length) {
	                      var changed = d3.event.changedTouches;
	                      for (var i = 0, n = changed.length; i < n; ++i) {
	                        delete locations0[changed[i].identifier];
	                      }
	                      for (var identifier in locations0) {
	                        return void relocate();
	                      }
	                    }
	                    d3.selectAll(targets).on(zoomName, null);
	                    subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	                    dragRestore();
	                    zoomended(dispatch);
	                  }
	                }
	                function mousewheeled() {
	                  var dispatch = event.of(this, arguments);
	                  if (mousewheelTimer) clearTimeout(mousewheelTimer);
	                  else d3_selection_interrupt.call(this), translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	                  mousewheelTimer = setTimeout(function() {
	                    mousewheelTimer = null;
	                    zoomended(dispatch);
	                  }, 50);
	                  d3_eventPreventDefault();
	                  scaleTo(Math.pow(2, d3_behavior_zoomDelta() * 2e-3) * view.k);
	                  translateTo(center0, translate0);
	                  zoomed(dispatch);
	                }
	                function dblclicked() {
	                  var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	                  zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	                }
	                return d3.rebind(zoom, event, "on");
	              };
	              var d3_behavior_zoomInfinity = [0, Infinity], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	              d3.color = d3_color;
	              function d3_color() {
	              }
	              d3_color.prototype.toString = function() {
	                return this.rgb() + "";
	              };
	              d3.hsl = d3_hsl;
	              function d3_hsl(h, s, l) {
	                return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	              }
	              var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	              d3_hslPrototype.brighter = function(k) {
	                k = Math.pow(0.7, arguments.length ? k : 1);
	                return new d3_hsl(this.h, this.s, this.l / k);
	              };
	              d3_hslPrototype.darker = function(k) {
	                k = Math.pow(0.7, arguments.length ? k : 1);
	                return new d3_hsl(this.h, this.s, k * this.l);
	              };
	              d3_hslPrototype.rgb = function() {
	                return d3_hsl_rgb(this.h, this.s, this.l);
	              };
	              function d3_hsl_rgb(h, s, l) {
	                var m1, m2;
	                h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	                s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	                l = l < 0 ? 0 : l > 1 ? 1 : l;
	                m2 = l <= 0.5 ? l * (1 + s) : l + s - l * s;
	                m1 = 2 * l - m2;
	                function v(h2) {
	                  if (h2 > 360) h2 -= 360;
	                  else if (h2 < 0) h2 += 360;
	                  if (h2 < 60) return m1 + (m2 - m1) * h2 / 60;
	                  if (h2 < 180) return m2;
	                  if (h2 < 240) return m1 + (m2 - m1) * (240 - h2) / 60;
	                  return m1;
	                }
	                function vv(h2) {
	                  return Math.round(v(h2) * 255);
	                }
	                return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	              }
	              d3.hcl = d3_hcl;
	              function d3_hcl(h, c, l) {
	                return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	              }
	              var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	              d3_hclPrototype.brighter = function(k) {
	                return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	              };
	              d3_hclPrototype.darker = function(k) {
	                return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	              };
	              d3_hclPrototype.rgb = function() {
	                return d3_hcl_lab(this.h, this.c, this.l).rgb();
	              };
	              function d3_hcl_lab(h, c, l) {
	                if (isNaN(h)) h = 0;
	                if (isNaN(c)) c = 0;
	                return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	              }
	              d3.lab = d3_lab;
	              function d3_lab(l, a, b) {
	                return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	              }
	              var d3_lab_K = 18;
	              var d3_lab_X = 0.95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	              var d3_labPrototype = d3_lab.prototype = new d3_color();
	              d3_labPrototype.brighter = function(k) {
	                return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	              };
	              d3_labPrototype.darker = function(k) {
	                return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	              };
	              d3_labPrototype.rgb = function() {
	                return d3_lab_rgb(this.l, this.a, this.b);
	              };
	              function d3_lab_rgb(l, a, b) {
	                var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	                x = d3_lab_xyz(x) * d3_lab_X;
	                y = d3_lab_xyz(y) * d3_lab_Y;
	                z = d3_lab_xyz(z) * d3_lab_Z;
	                return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), d3_xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.041556 * z), d3_xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z));
	              }
	              function d3_lab_hcl(l, a, b) {
	                return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	              }
	              function d3_lab_xyz(x) {
	                return x > 0.206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	              }
	              function d3_xyz_lab(x) {
	                return x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	              }
	              function d3_xyz_rgb(r) {
	                return Math.round(255 * (r <= 304e-5 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - 0.055));
	              }
	              d3.rgb = d3_rgb;
	              function d3_rgb(r, g, b) {
	                return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	              }
	              function d3_rgbNumber(value) {
	                return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	              }
	              function d3_rgbString(value) {
	                return d3_rgbNumber(value) + "";
	              }
	              var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	              d3_rgbPrototype.brighter = function(k) {
	                k = Math.pow(0.7, arguments.length ? k : 1);
	                var r = this.r, g = this.g, b = this.b, i = 30;
	                if (!r && !g && !b) return new d3_rgb(i, i, i);
	                if (r && r < i) r = i;
	                if (g && g < i) g = i;
	                if (b && b < i) b = i;
	                return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	              };
	              d3_rgbPrototype.darker = function(k) {
	                k = Math.pow(0.7, arguments.length ? k : 1);
	                return new d3_rgb(k * this.r, k * this.g, k * this.b);
	              };
	              d3_rgbPrototype.hsl = function() {
	                return d3_rgb_hsl(this.r, this.g, this.b);
	              };
	              d3_rgbPrototype.toString = function() {
	                return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	              };
	              function d3_rgb_hex(v) {
	                return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	              }
	              function d3_rgb_parse(format, rgb, hsl) {
	                var r = 0, g = 0, b = 0, m1, m2, color;
	                m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	                if (m1) {
	                  m2 = m1[2].split(",");
	                  switch (m1[1]) {
	                    case "hsl": {
	                      return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	                    }
	                    case "rgb": {
	                      return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	                    }
	                  }
	                }
	                if (color = d3_rgb_names.get(format)) {
	                  return rgb(color.r, color.g, color.b);
	                }
	                if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	                  if (format.length === 4) {
	                    r = (color & 3840) >> 4;
	                    r = r >> 4 | r;
	                    g = color & 240;
	                    g = g >> 4 | g;
	                    b = color & 15;
	                    b = b << 4 | b;
	                  } else if (format.length === 7) {
	                    r = (color & 16711680) >> 16;
	                    g = (color & 65280) >> 8;
	                    b = color & 255;
	                  }
	                }
	                return rgb(r, g, b);
	              }
	              function d3_rgb_hsl(r, g, b) {
	                var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	                if (d) {
	                  s = l < 0.5 ? d / (max + min) : d / (2 - max - min);
	                  if (r == max) h = (g - b) / d + (g < b ? 6 : 0);
	                  else if (g == max) h = (b - r) / d + 2;
	                  else h = (r - g) / d + 4;
	                  h *= 60;
	                } else {
	                  h = NaN;
	                  s = l > 0 && l < 1 ? 0 : h;
	                }
	                return new d3_hsl(h, s, l);
	              }
	              function d3_rgb_lab(r, g, b) {
	                r = d3_rgb_xyz(r);
	                g = d3_rgb_xyz(g);
	                b = d3_rgb_xyz(b);
	                var x = d3_xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / d3_lab_X), y = d3_xyz_lab((0.2126729 * r + 0.7151522 * g + 0.072175 * b) / d3_lab_Y), z = d3_xyz_lab((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / d3_lab_Z);
	                return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	              }
	              function d3_rgb_xyz(r) {
	                return (r /= 255) <= 0.04045 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
	              }
	              function d3_rgb_parseNumber(c) {
	                var f = parseFloat(c);
	                return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	              }
	              var d3_rgb_names = d3.map({
	                aliceblue: 15792383,
	                antiquewhite: 16444375,
	                aqua: 65535,
	                aquamarine: 8388564,
	                azure: 15794175,
	                beige: 16119260,
	                bisque: 16770244,
	                black: 0,
	                blanchedalmond: 16772045,
	                blue: 255,
	                blueviolet: 9055202,
	                brown: 10824234,
	                burlywood: 14596231,
	                cadetblue: 6266528,
	                chartreuse: 8388352,
	                chocolate: 13789470,
	                coral: 16744272,
	                cornflowerblue: 6591981,
	                cornsilk: 16775388,
	                crimson: 14423100,
	                cyan: 65535,
	                darkblue: 139,
	                darkcyan: 35723,
	                darkgoldenrod: 12092939,
	                darkgray: 11119017,
	                darkgreen: 25600,
	                darkgrey: 11119017,
	                darkkhaki: 12433259,
	                darkmagenta: 9109643,
	                darkolivegreen: 5597999,
	                darkorange: 16747520,
	                darkorchid: 10040012,
	                darkred: 9109504,
	                darksalmon: 15308410,
	                darkseagreen: 9419919,
	                darkslateblue: 4734347,
	                darkslategray: 3100495,
	                darkslategrey: 3100495,
	                darkturquoise: 52945,
	                darkviolet: 9699539,
	                deeppink: 16716947,
	                deepskyblue: 49151,
	                dimgray: 6908265,
	                dimgrey: 6908265,
	                dodgerblue: 2003199,
	                firebrick: 11674146,
	                floralwhite: 16775920,
	                forestgreen: 2263842,
	                fuchsia: 16711935,
	                gainsboro: 14474460,
	                ghostwhite: 16316671,
	                gold: 16766720,
	                goldenrod: 14329120,
	                gray: 8421504,
	                green: 32768,
	                greenyellow: 11403055,
	                grey: 8421504,
	                honeydew: 15794160,
	                hotpink: 16738740,
	                indianred: 13458524,
	                indigo: 4915330,
	                ivory: 16777200,
	                khaki: 15787660,
	                lavender: 15132410,
	                lavenderblush: 16773365,
	                lawngreen: 8190976,
	                lemonchiffon: 16775885,
	                lightblue: 11393254,
	                lightcoral: 15761536,
	                lightcyan: 14745599,
	                lightgoldenrodyellow: 16448210,
	                lightgray: 13882323,
	                lightgreen: 9498256,
	                lightgrey: 13882323,
	                lightpink: 16758465,
	                lightsalmon: 16752762,
	                lightseagreen: 2142890,
	                lightskyblue: 8900346,
	                lightslategray: 7833753,
	                lightslategrey: 7833753,
	                lightsteelblue: 11584734,
	                lightyellow: 16777184,
	                lime: 65280,
	                limegreen: 3329330,
	                linen: 16445670,
	                magenta: 16711935,
	                maroon: 8388608,
	                mediumaquamarine: 6737322,
	                mediumblue: 205,
	                mediumorchid: 12211667,
	                mediumpurple: 9662683,
	                mediumseagreen: 3978097,
	                mediumslateblue: 8087790,
	                mediumspringgreen: 64154,
	                mediumturquoise: 4772300,
	                mediumvioletred: 13047173,
	                midnightblue: 1644912,
	                mintcream: 16121850,
	                mistyrose: 16770273,
	                moccasin: 16770229,
	                navajowhite: 16768685,
	                navy: 128,
	                oldlace: 16643558,
	                olive: 8421376,
	                olivedrab: 7048739,
	                orange: 16753920,
	                orangered: 16729344,
	                orchid: 14315734,
	                palegoldenrod: 15657130,
	                palegreen: 10025880,
	                paleturquoise: 11529966,
	                palevioletred: 14381203,
	                papayawhip: 16773077,
	                peachpuff: 16767673,
	                peru: 13468991,
	                pink: 16761035,
	                plum: 14524637,
	                powderblue: 11591910,
	                purple: 8388736,
	                rebeccapurple: 6697881,
	                red: 16711680,
	                rosybrown: 12357519,
	                royalblue: 4286945,
	                saddlebrown: 9127187,
	                salmon: 16416882,
	                sandybrown: 16032864,
	                seagreen: 3050327,
	                seashell: 16774638,
	                sienna: 10506797,
	                silver: 12632256,
	                skyblue: 8900331,
	                slateblue: 6970061,
	                slategray: 7372944,
	                slategrey: 7372944,
	                snow: 16775930,
	                springgreen: 65407,
	                steelblue: 4620980,
	                tan: 13808780,
	                teal: 32896,
	                thistle: 14204888,
	                tomato: 16737095,
	                turquoise: 4251856,
	                violet: 15631086,
	                wheat: 16113331,
	                white: 16777215,
	                whitesmoke: 16119285,
	                yellow: 16776960,
	                yellowgreen: 10145074
	              });
	              d3_rgb_names.forEach(function(key, value) {
	                d3_rgb_names.set(key, d3_rgbNumber(value));
	              });
	              function d3_functor(v) {
	                return typeof v === "function" ? v : function() {
	                  return v;
	                };
	              }
	              d3.functor = d3_functor;
	              d3.xhr = d3_xhrType(d3_identity);
	              function d3_xhrType(response) {
	                return function(url, mimeType, callback) {
	                  if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, mimeType = null;
	                  return d3_xhr(url, mimeType, response, callback);
	                };
	              }
	              function d3_xhr(url, mimeType, response, callback) {
	                var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	                if (self.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	                "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	                  request.readyState > 3 && respond();
	                };
	                function respond() {
	                  var status = request.status, result;
	                  if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	                    try {
	                      result = response.call(xhr, request);
	                    } catch (e) {
	                      dispatch.error.call(xhr, e);
	                      return;
	                    }
	                    dispatch.load.call(xhr, result);
	                  } else {
	                    dispatch.error.call(xhr, request);
	                  }
	                }
	                request.onprogress = function(event) {
	                  var o = d3.event;
	                  d3.event = event;
	                  try {
	                    dispatch.progress.call(xhr, request);
	                  } finally {
	                    d3.event = o;
	                  }
	                };
	                xhr.header = function(name2, value) {
	                  name2 = (name2 + "").toLowerCase();
	                  if (arguments.length < 2) return headers[name2];
	                  if (value == null) delete headers[name2];
	                  else headers[name2] = value + "";
	                  return xhr;
	                };
	                xhr.mimeType = function(value) {
	                  if (!arguments.length) return mimeType;
	                  mimeType = value == null ? null : value + "";
	                  return xhr;
	                };
	                xhr.responseType = function(value) {
	                  if (!arguments.length) return responseType;
	                  responseType = value;
	                  return xhr;
	                };
	                xhr.response = function(value) {
	                  response = value;
	                  return xhr;
	                };
	                ["get", "post"].forEach(function(method) {
	                  xhr[method] = function() {
	                    return xhr.send.apply(xhr, [method].concat(d3_array(arguments)));
	                  };
	                });
	                xhr.send = function(method, data, callback2) {
	                  if (arguments.length === 2 && typeof data === "function") callback2 = data, data = null;
	                  request.open(method, url, true);
	                  if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	                  if (request.setRequestHeader) for (var name2 in headers) request.setRequestHeader(name2, headers[name2]);
	                  if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	                  if (responseType != null) request.responseType = responseType;
	                  if (callback2 != null) xhr.on("error", callback2).on("load", function(request2) {
	                    callback2(null, request2);
	                  });
	                  dispatch.beforesend.call(xhr, request);
	                  request.send(data == null ? null : data);
	                  return xhr;
	                };
	                xhr.abort = function() {
	                  request.abort();
	                  return xhr;
	                };
	                d3.rebind(xhr, dispatch, "on");
	                return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	              }
	              function d3_xhr_fixCallback(callback) {
	                return callback.length === 1 ? function(error, request) {
	                  callback(error == null ? request : null);
	                } : callback;
	              }
	              function d3_xhrHasResponse(request) {
	                var type = request.responseType;
	                return type && type !== "text" ? request.response : request.responseText;
	              }
	              d3.dsv = function(delimiter, mimeType) {
	                var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	                function dsv(url, row, callback) {
	                  if (arguments.length < 3) callback = row, row = null;
	                  var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	                  xhr.row = function(_) {
	                    return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	                  };
	                  return xhr;
	                }
	                function response(request) {
	                  return dsv.parse(request.responseText);
	                }
	                function typedResponse(f) {
	                  return function(request) {
	                    return dsv.parse(request.responseText, f);
	                  };
	                }
	                dsv.parse = function(text, f) {
	                  var o;
	                  return dsv.parseRows(text, function(row, i) {
	                    if (o) return o(row, i - 1);
	                    var a = function(d) {
	                      var obj = {};
	                      var len = row.length;
	                      for (var k = 0; k < len; ++k) {
	                        obj[row[k]] = d[k];
	                      }
	                      return obj;
	                    };
	                    o = f ? function(row2, i2) {
	                      return f(a(row2), i2);
	                    } : a;
	                  });
	                };
	                dsv.parseRows = function(text, f) {
	                  var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	                  function token() {
	                    if (I >= N) return EOF;
	                    if (eol) return eol = false, EOL;
	                    var j = I;
	                    if (text.charCodeAt(j) === 34) {
	                      var i = j;
	                      while (i++ < N) {
	                        if (text.charCodeAt(i) === 34) {
	                          if (text.charCodeAt(i + 1) !== 34) break;
	                          ++i;
	                        }
	                      }
	                      I = i + 2;
	                      var c = text.charCodeAt(i + 1);
	                      if (c === 13) {
	                        eol = true;
	                        if (text.charCodeAt(i + 2) === 10) ++I;
	                      } else if (c === 10) {
	                        eol = true;
	                      }
	                      return text.slice(j + 1, i).replace(/""/g, '"');
	                    }
	                    while (I < N) {
	                      var c = text.charCodeAt(I++), k = 1;
	                      if (c === 10) eol = true;
	                      else if (c === 13) {
	                        eol = true;
	                        if (text.charCodeAt(I) === 10) ++I, ++k;
	                      } else if (c !== delimiterCode) continue;
	                      return text.slice(j, I - k);
	                    }
	                    return text.slice(j);
	                  }
	                  while ((t = token()) !== EOF) {
	                    var a = [];
	                    while (t !== EOL && t !== EOF) {
	                      a.push(t);
	                      t = token();
	                    }
	                    if (f && (a = f(a, n++)) == null) continue;
	                    rows.push(a);
	                  }
	                  return rows;
	                };
	                dsv.format = function(rows) {
	                  if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	                  var fieldSet = new d3_Set(), fields = [];
	                  rows.forEach(function(row) {
	                    for (var field in row) {
	                      if (!fieldSet.has(field)) {
	                        fields.push(fieldSet.add(field));
	                      }
	                    }
	                  });
	                  return [fields.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	                    return fields.map(function(field) {
	                      return formatValue(row[field]);
	                    }).join(delimiter);
	                  })).join("\n");
	                };
	                dsv.formatRows = function(rows) {
	                  return rows.map(formatRow).join("\n");
	                };
	                function formatRow(row) {
	                  return row.map(formatValue).join(delimiter);
	                }
	                function formatValue(text) {
	                  return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	                }
	                return dsv;
	              };
	              d3.csv = d3.dsv(",", "text/csv");
	              d3.tsv = d3.dsv("	", "text/tab-separated-values");
	              var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	                setTimeout(callback, 17);
	              };
	              d3.timer = function() {
	                d3_timer.apply(this, arguments);
	              };
	              function d3_timer(callback, delay, then) {
	                var n = arguments.length;
	                if (n < 2) delay = 0;
	                if (n < 3) then = Date.now();
	                var time = then + delay, timer = {
	                  c: callback,
	                  t: time,
	                  n: null
	                };
	                if (d3_timer_queueTail) d3_timer_queueTail.n = timer;
	                else d3_timer_queueHead = timer;
	                d3_timer_queueTail = timer;
	                if (!d3_timer_interval) {
	                  d3_timer_timeout = clearTimeout(d3_timer_timeout);
	                  d3_timer_interval = 1;
	                  d3_timer_frame(d3_timer_step);
	                }
	                return timer;
	              }
	              function d3_timer_step() {
	                var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	                if (delay > 24) {
	                  if (isFinite(delay)) {
	                    clearTimeout(d3_timer_timeout);
	                    d3_timer_timeout = setTimeout(d3_timer_step, delay);
	                  }
	                  d3_timer_interval = 0;
	                } else {
	                  d3_timer_interval = 1;
	                  d3_timer_frame(d3_timer_step);
	                }
	              }
	              d3.timer.flush = function() {
	                d3_timer_mark();
	                d3_timer_sweep();
	              };
	              function d3_timer_mark() {
	                var now = Date.now(), timer = d3_timer_queueHead;
	                while (timer) {
	                  if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	                  timer = timer.n;
	                }
	                return now;
	              }
	              function d3_timer_sweep() {
	                var t0, t1 = d3_timer_queueHead, time = Infinity;
	                while (t1) {
	                  if (t1.c) {
	                    if (t1.t < time) time = t1.t;
	                    t1 = (t0 = t1).n;
	                  } else {
	                    t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	                  }
	                }
	                d3_timer_queueTail = t0;
	                return time;
	              }
	              d3.round = function(x, n) {
	                return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	              };
	              d3.geom = {};
	              function d3_geom_pointX(d) {
	                return d[0];
	              }
	              function d3_geom_pointY(d) {
	                return d[1];
	              }
	              d3.geom.hull = function(vertices) {
	                var x = d3_geom_pointX, y = d3_geom_pointY;
	                if (arguments.length) return hull(vertices);
	                function hull(data) {
	                  if (data.length < 3) return [];
	                  var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	                  for (i = 0; i < n; i++) {
	                    points.push([+fx.call(this, data[i], i), +fy.call(this, data[i], i), i]);
	                  }
	                  points.sort(d3_geom_hullOrder);
	                  for (i = 0; i < n; i++) flippedPoints.push([points[i][0], -points[i][1]]);
	                  var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	                  var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	                  for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	                  for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	                  return polygon;
	                }
	                hull.x = function(_) {
	                  return arguments.length ? (x = _, hull) : x;
	                };
	                hull.y = function(_) {
	                  return arguments.length ? (y = _, hull) : y;
	                };
	                return hull;
	              };
	              function d3_geom_hullUpper(points) {
	                var n = points.length, hull = [0, 1], hs = 2;
	                for (var i = 2; i < n; i++) {
	                  while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	                  hull[hs++] = i;
	                }
	                return hull.slice(0, hs);
	              }
	              function d3_geom_hullOrder(a, b) {
	                return a[0] - b[0] || a[1] - b[1];
	              }
	              d3.geom.polygon = function(coordinates) {
	                d3_subclass(coordinates, d3_geom_polygonPrototype);
	                return coordinates;
	              };
	              var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	              d3_geom_polygonPrototype.area = function() {
	                var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	                while (++i < n) {
	                  a = b;
	                  b = this[i];
	                  area += a[1] * b[0] - a[0] * b[1];
	                }
	                return area * 0.5;
	              };
	              d3_geom_polygonPrototype.centroid = function(k) {
	                var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	                if (!arguments.length) k = -1 / (6 * this.area());
	                while (++i < n) {
	                  a = b;
	                  b = this[i];
	                  c = a[0] * b[1] - b[0] * a[1];
	                  x += (a[0] + b[0]) * c;
	                  y += (a[1] + b[1]) * c;
	                }
	                return [x * k, y * k];
	              };
	              d3_geom_polygonPrototype.clip = function(subject) {
	                var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	                while (++i < n) {
	                  input = subject.slice();
	                  subject.length = 0;
	                  b = this[i];
	                  c = input[(m = input.length - closed) - 1];
	                  j = -1;
	                  while (++j < m) {
	                    d = input[j];
	                    if (d3_geom_polygonInside(d, a, b)) {
	                      if (!d3_geom_polygonInside(c, a, b)) {
	                        subject.push(d3_geom_polygonIntersect(c, d, a, b));
	                      }
	                      subject.push(d);
	                    } else if (d3_geom_polygonInside(c, a, b)) {
	                      subject.push(d3_geom_polygonIntersect(c, d, a, b));
	                    }
	                    c = d;
	                  }
	                  if (closed) subject.push(subject[0]);
	                  a = b;
	                }
	                return subject;
	              };
	              function d3_geom_polygonInside(p, a, b) {
	                return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	              }
	              function d3_geom_polygonIntersect(c, d, a, b) {
	                var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	                return [x1 + ua * x21, y1 + ua * y21];
	              }
	              function d3_geom_polygonClosed(coordinates) {
	                var a = coordinates[0], b = coordinates[coordinates.length - 1];
	                return !(a[0] - b[0] || a[1] - b[1]);
	              }
	              var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	              function d3_geom_voronoiBeach() {
	                d3_geom_voronoiRedBlackNode(this);
	                this.edge = this.site = this.circle = null;
	              }
	              function d3_geom_voronoiCreateBeach(site) {
	                var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	                beach.site = site;
	                return beach;
	              }
	              function d3_geom_voronoiDetachBeach(beach) {
	                d3_geom_voronoiDetachCircle(beach);
	                d3_geom_voronoiBeaches.remove(beach);
	                d3_geom_voronoiBeachPool.push(beach);
	                d3_geom_voronoiRedBlackNode(beach);
	              }
	              function d3_geom_voronoiRemoveBeach(beach) {
	                var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	                  x,
	                  y
	                }, previous = beach.P, next = beach.N, disappearing = [beach];
	                d3_geom_voronoiDetachBeach(beach);
	                var lArc = previous;
	                while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	                  previous = lArc.P;
	                  disappearing.unshift(lArc);
	                  d3_geom_voronoiDetachBeach(lArc);
	                  lArc = previous;
	                }
	                disappearing.unshift(lArc);
	                d3_geom_voronoiDetachCircle(lArc);
	                var rArc = next;
	                while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	                  next = rArc.N;
	                  disappearing.push(rArc);
	                  d3_geom_voronoiDetachBeach(rArc);
	                  rArc = next;
	                }
	                disappearing.push(rArc);
	                d3_geom_voronoiDetachCircle(rArc);
	                var nArcs = disappearing.length, iArc;
	                for (iArc = 1; iArc < nArcs; ++iArc) {
	                  rArc = disappearing[iArc];
	                  lArc = disappearing[iArc - 1];
	                  d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	                }
	                lArc = disappearing[0];
	                rArc = disappearing[nArcs - 1];
	                rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	                d3_geom_voronoiAttachCircle(lArc);
	                d3_geom_voronoiAttachCircle(rArc);
	              }
	              function d3_geom_voronoiAddBeach(site) {
	                var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	                while (node) {
	                  dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	                  if (dxl > ε) node = node.L;
	                  else {
	                    dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	                    if (dxr > ε) {
	                      if (!node.R) {
	                        lArc = node;
	                        break;
	                      }
	                      node = node.R;
	                    } else {
	                      if (dxl > -1e-6) {
	                        lArc = node.P;
	                        rArc = node;
	                      } else if (dxr > -1e-6) {
	                        lArc = node;
	                        rArc = node.N;
	                      } else {
	                        lArc = rArc = node;
	                      }
	                      break;
	                    }
	                  }
	                }
	                var newArc = d3_geom_voronoiCreateBeach(site);
	                d3_geom_voronoiBeaches.insert(lArc, newArc);
	                if (!lArc && !rArc) return;
	                if (lArc === rArc) {
	                  d3_geom_voronoiDetachCircle(lArc);
	                  rArc = d3_geom_voronoiCreateBeach(lArc.site);
	                  d3_geom_voronoiBeaches.insert(newArc, rArc);
	                  newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	                  d3_geom_voronoiAttachCircle(lArc);
	                  d3_geom_voronoiAttachCircle(rArc);
	                  return;
	                }
	                if (!rArc) {
	                  newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	                  return;
	                }
	                d3_geom_voronoiDetachCircle(lArc);
	                d3_geom_voronoiDetachCircle(rArc);
	                var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	                  x: (cy * hb - by * hc) / d + ax,
	                  y: (bx * hc - cx * hb) / d + ay
	                };
	                d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	                newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	                rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	                d3_geom_voronoiAttachCircle(lArc);
	                d3_geom_voronoiAttachCircle(rArc);
	              }
	              function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	                var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	                if (!pby2) return rfocx;
	                var lArc = arc.P;
	                if (!lArc) return -Infinity;
	                site = lArc.site;
	                var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	                if (!plby2) return lfocx;
	                var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	                if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	                return (rfocx + lfocx) / 2;
	              }
	              function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	                var rArc = arc.N;
	                if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	                var site = arc.site;
	                return site.y === directrix ? site.x : Infinity;
	              }
	              function d3_geom_voronoiCell(site) {
	                this.site = site;
	                this.edges = [];
	              }
	              d3_geom_voronoiCell.prototype.prepare = function() {
	                var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	                while (iHalfEdge--) {
	                  edge = halfEdges[iHalfEdge].edge;
	                  if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	                }
	                halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	                return halfEdges.length;
	              };
	              function d3_geom_voronoiCloseCells(extent2) {
	                var x0 = extent2[0][0], x1 = extent2[1][0], y0 = extent2[0][1], y1 = extent2[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	                while (iCell--) {
	                  cell = cells[iCell];
	                  if (!cell || !cell.prepare()) continue;
	                  halfEdges = cell.edges;
	                  nHalfEdges = halfEdges.length;
	                  iHalfEdge = 0;
	                  while (iHalfEdge < nHalfEdges) {
	                    end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	                    start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	                    if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	                      halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	                        x: x0,
	                        y: abs(x2 - x0) < ε ? y2 : y1
	                      } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	                        x: abs(y2 - y1) < ε ? x2 : x1,
	                        y: y1
	                      } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	                        x: x1,
	                        y: abs(x2 - x1) < ε ? y2 : y0
	                      } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	                        x: abs(y2 - y0) < ε ? x2 : x0,
	                        y: y0
	                      } : null), cell.site, null));
	                      ++nHalfEdges;
	                    }
	                  }
	                }
	              }
	              function d3_geom_voronoiHalfEdgeOrder(a, b) {
	                return b.angle - a.angle;
	              }
	              function d3_geom_voronoiCircle() {
	                d3_geom_voronoiRedBlackNode(this);
	                this.x = this.y = this.arc = this.site = this.cy = null;
	              }
	              function d3_geom_voronoiAttachCircle(arc) {
	                var lArc = arc.P, rArc = arc.N;
	                if (!lArc || !rArc) return;
	                var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	                if (lSite === rSite) return;
	                var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	                var d = 2 * (ax * cy - ay * cx);
	                if (d >= -1e-12) return;
	                var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	                var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	                circle.arc = arc;
	                circle.site = cSite;
	                circle.x = x + bx;
	                circle.y = cy + Math.sqrt(x * x + y * y);
	                circle.cy = cy;
	                arc.circle = circle;
	                var before = null, node = d3_geom_voronoiCircles._;
	                while (node) {
	                  if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	                    if (node.L) node = node.L;
	                    else {
	                      before = node.P;
	                      break;
	                    }
	                  } else {
	                    if (node.R) node = node.R;
	                    else {
	                      before = node;
	                      break;
	                    }
	                  }
	                }
	                d3_geom_voronoiCircles.insert(before, circle);
	                if (!before) d3_geom_voronoiFirstCircle = circle;
	              }
	              function d3_geom_voronoiDetachCircle(arc) {
	                var circle = arc.circle;
	                if (circle) {
	                  if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	                  d3_geom_voronoiCircles.remove(circle);
	                  d3_geom_voronoiCirclePool.push(circle);
	                  d3_geom_voronoiRedBlackNode(circle);
	                  arc.circle = null;
	                }
	              }
	              function d3_geom_clipLine(x0, y0, x1, y1) {
	                return function(line) {
	                  var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	                  r = x0 - ax;
	                  if (!dx && r > 0) return;
	                  r /= dx;
	                  if (dx < 0) {
	                    if (r < t0) return;
	                    if (r < t1) t1 = r;
	                  } else if (dx > 0) {
	                    if (r > t1) return;
	                    if (r > t0) t0 = r;
	                  }
	                  r = x1 - ax;
	                  if (!dx && r < 0) return;
	                  r /= dx;
	                  if (dx < 0) {
	                    if (r > t1) return;
	                    if (r > t0) t0 = r;
	                  } else if (dx > 0) {
	                    if (r < t0) return;
	                    if (r < t1) t1 = r;
	                  }
	                  r = y0 - ay;
	                  if (!dy && r > 0) return;
	                  r /= dy;
	                  if (dy < 0) {
	                    if (r < t0) return;
	                    if (r < t1) t1 = r;
	                  } else if (dy > 0) {
	                    if (r > t1) return;
	                    if (r > t0) t0 = r;
	                  }
	                  r = y1 - ay;
	                  if (!dy && r < 0) return;
	                  r /= dy;
	                  if (dy < 0) {
	                    if (r > t1) return;
	                    if (r > t0) t0 = r;
	                  } else if (dy > 0) {
	                    if (r < t0) return;
	                    if (r < t1) t1 = r;
	                  }
	                  if (t0 > 0) line.a = {
	                    x: ax + t0 * dx,
	                    y: ay + t0 * dy
	                  };
	                  if (t1 < 1) line.b = {
	                    x: ax + t1 * dx,
	                    y: ay + t1 * dy
	                  };
	                  return line;
	                };
	              }
	              function d3_geom_voronoiClipEdges(extent2) {
	                var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent2[0][0], extent2[0][1], extent2[1][0], extent2[1][1]), i = edges.length, e;
	                while (i--) {
	                  e = edges[i];
	                  if (!d3_geom_voronoiConnectEdge(e, extent2) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	                    e.a = e.b = null;
	                    edges.splice(i, 1);
	                  }
	                }
	              }
	              function d3_geom_voronoiConnectEdge(edge, extent2) {
	                var vb = edge.b;
	                if (vb) return true;
	                var va = edge.a, x0 = extent2[0][0], x1 = extent2[1][0], y0 = extent2[0][1], y1 = extent2[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	                if (ry === ly) {
	                  if (fx < x0 || fx >= x1) return;
	                  if (lx > rx) {
	                    if (!va) va = {
	                      x: fx,
	                      y: y0
	                    };
	                    else if (va.y >= y1) return;
	                    vb = {
	                      x: fx,
	                      y: y1
	                    };
	                  } else {
	                    if (!va) va = {
	                      x: fx,
	                      y: y1
	                    };
	                    else if (va.y < y0) return;
	                    vb = {
	                      x: fx,
	                      y: y0
	                    };
	                  }
	                } else {
	                  fm = (lx - rx) / (ry - ly);
	                  fb = fy - fm * fx;
	                  if (fm < -1 || fm > 1) {
	                    if (lx > rx) {
	                      if (!va) va = {
	                        x: (y0 - fb) / fm,
	                        y: y0
	                      };
	                      else if (va.y >= y1) return;
	                      vb = {
	                        x: (y1 - fb) / fm,
	                        y: y1
	                      };
	                    } else {
	                      if (!va) va = {
	                        x: (y1 - fb) / fm,
	                        y: y1
	                      };
	                      else if (va.y < y0) return;
	                      vb = {
	                        x: (y0 - fb) / fm,
	                        y: y0
	                      };
	                    }
	                  } else {
	                    if (ly < ry) {
	                      if (!va) va = {
	                        x: x0,
	                        y: fm * x0 + fb
	                      };
	                      else if (va.x >= x1) return;
	                      vb = {
	                        x: x1,
	                        y: fm * x1 + fb
	                      };
	                    } else {
	                      if (!va) va = {
	                        x: x1,
	                        y: fm * x1 + fb
	                      };
	                      else if (va.x < x0) return;
	                      vb = {
	                        x: x0,
	                        y: fm * x0 + fb
	                      };
	                    }
	                  }
	                }
	                edge.a = va;
	                edge.b = vb;
	                return true;
	              }
	              function d3_geom_voronoiEdge(lSite, rSite) {
	                this.l = lSite;
	                this.r = rSite;
	                this.a = this.b = null;
	              }
	              function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	                var edge = new d3_geom_voronoiEdge(lSite, rSite);
	                d3_geom_voronoiEdges.push(edge);
	                if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	                if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	                d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	                d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	                return edge;
	              }
	              function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	                var edge = new d3_geom_voronoiEdge(lSite, null);
	                edge.a = va;
	                edge.b = vb;
	                d3_geom_voronoiEdges.push(edge);
	                return edge;
	              }
	              function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	                if (!edge.a && !edge.b) {
	                  edge.a = vertex;
	                  edge.l = lSite;
	                  edge.r = rSite;
	                } else if (edge.l === rSite) {
	                  edge.b = vertex;
	                } else {
	                  edge.a = vertex;
	                }
	              }
	              function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	                var va = edge.a, vb = edge.b;
	                this.edge = edge;
	                this.site = lSite;
	                this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	              }
	              d3_geom_voronoiHalfEdge.prototype = {
	                start: function() {
	                  return this.edge.l === this.site ? this.edge.a : this.edge.b;
	                },
	                end: function() {
	                  return this.edge.l === this.site ? this.edge.b : this.edge.a;
	                }
	              };
	              function d3_geom_voronoiRedBlackTree() {
	                this._ = null;
	              }
	              function d3_geom_voronoiRedBlackNode(node) {
	                node.U = node.C = node.L = node.R = node.P = node.N = null;
	              }
	              d3_geom_voronoiRedBlackTree.prototype = {
	                insert: function(after, node) {
	                  var parent, grandpa, uncle;
	                  if (after) {
	                    node.P = after;
	                    node.N = after.N;
	                    if (after.N) after.N.P = node;
	                    after.N = node;
	                    if (after.R) {
	                      after = after.R;
	                      while (after.L) after = after.L;
	                      after.L = node;
	                    } else {
	                      after.R = node;
	                    }
	                    parent = after;
	                  } else if (this._) {
	                    after = d3_geom_voronoiRedBlackFirst(this._);
	                    node.P = null;
	                    node.N = after;
	                    after.P = after.L = node;
	                    parent = after;
	                  } else {
	                    node.P = node.N = null;
	                    this._ = node;
	                    parent = null;
	                  }
	                  node.L = node.R = null;
	                  node.U = parent;
	                  node.C = true;
	                  after = node;
	                  while (parent && parent.C) {
	                    grandpa = parent.U;
	                    if (parent === grandpa.L) {
	                      uncle = grandpa.R;
	                      if (uncle && uncle.C) {
	                        parent.C = uncle.C = false;
	                        grandpa.C = true;
	                        after = grandpa;
	                      } else {
	                        if (after === parent.R) {
	                          d3_geom_voronoiRedBlackRotateLeft(this, parent);
	                          after = parent;
	                          parent = after.U;
	                        }
	                        parent.C = false;
	                        grandpa.C = true;
	                        d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	                      }
	                    } else {
	                      uncle = grandpa.L;
	                      if (uncle && uncle.C) {
	                        parent.C = uncle.C = false;
	                        grandpa.C = true;
	                        after = grandpa;
	                      } else {
	                        if (after === parent.L) {
	                          d3_geom_voronoiRedBlackRotateRight(this, parent);
	                          after = parent;
	                          parent = after.U;
	                        }
	                        parent.C = false;
	                        grandpa.C = true;
	                        d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	                      }
	                    }
	                    parent = after.U;
	                  }
	                  this._.C = false;
	                },
	                remove: function(node) {
	                  if (node.N) node.N.P = node.P;
	                  if (node.P) node.P.N = node.N;
	                  node.N = node.P = null;
	                  var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	                  if (!left) next = right;
	                  else if (!right) next = left;
	                  else next = d3_geom_voronoiRedBlackFirst(right);
	                  if (parent) {
	                    if (parent.L === node) parent.L = next;
	                    else parent.R = next;
	                  } else {
	                    this._ = next;
	                  }
	                  if (left && right) {
	                    red = next.C;
	                    next.C = node.C;
	                    next.L = left;
	                    left.U = next;
	                    if (next !== right) {
	                      parent = next.U;
	                      next.U = node.U;
	                      node = next.R;
	                      parent.L = node;
	                      next.R = right;
	                      right.U = next;
	                    } else {
	                      next.U = parent;
	                      parent = next;
	                      node = next.R;
	                    }
	                  } else {
	                    red = node.C;
	                    node = next;
	                  }
	                  if (node) node.U = parent;
	                  if (red) return;
	                  if (node && node.C) {
	                    node.C = false;
	                    return;
	                  }
	                  do {
	                    if (node === this._) break;
	                    if (node === parent.L) {
	                      sibling = parent.R;
	                      if (sibling.C) {
	                        sibling.C = false;
	                        parent.C = true;
	                        d3_geom_voronoiRedBlackRotateLeft(this, parent);
	                        sibling = parent.R;
	                      }
	                      if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	                        if (!sibling.R || !sibling.R.C) {
	                          sibling.L.C = false;
	                          sibling.C = true;
	                          d3_geom_voronoiRedBlackRotateRight(this, sibling);
	                          sibling = parent.R;
	                        }
	                        sibling.C = parent.C;
	                        parent.C = sibling.R.C = false;
	                        d3_geom_voronoiRedBlackRotateLeft(this, parent);
	                        node = this._;
	                        break;
	                      }
	                    } else {
	                      sibling = parent.L;
	                      if (sibling.C) {
	                        sibling.C = false;
	                        parent.C = true;
	                        d3_geom_voronoiRedBlackRotateRight(this, parent);
	                        sibling = parent.L;
	                      }
	                      if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	                        if (!sibling.L || !sibling.L.C) {
	                          sibling.R.C = false;
	                          sibling.C = true;
	                          d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	                          sibling = parent.L;
	                        }
	                        sibling.C = parent.C;
	                        parent.C = sibling.L.C = false;
	                        d3_geom_voronoiRedBlackRotateRight(this, parent);
	                        node = this._;
	                        break;
	                      }
	                    }
	                    sibling.C = true;
	                    node = parent;
	                    parent = parent.U;
	                  } while (!node.C);
	                  if (node) node.C = false;
	                }
	              };
	              function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	                var p = node, q = node.R, parent = p.U;
	                if (parent) {
	                  if (parent.L === p) parent.L = q;
	                  else parent.R = q;
	                } else {
	                  tree._ = q;
	                }
	                q.U = parent;
	                p.U = q;
	                p.R = q.L;
	                if (p.R) p.R.U = p;
	                q.L = p;
	              }
	              function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	                var p = node, q = node.L, parent = p.U;
	                if (parent) {
	                  if (parent.L === p) parent.L = q;
	                  else parent.R = q;
	                } else {
	                  tree._ = q;
	                }
	                q.U = parent;
	                p.U = q;
	                p.L = q.R;
	                if (p.L) p.L.U = p;
	                q.R = p;
	              }
	              function d3_geom_voronoiRedBlackFirst(node) {
	                while (node.L) node = node.L;
	                return node;
	              }
	              function d3_geom_voronoi(sites, bbox) {
	                var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	                d3_geom_voronoiEdges = [];
	                d3_geom_voronoiCells = new Array(sites.length);
	                d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	                d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	                while (true) {
	                  circle = d3_geom_voronoiFirstCircle;
	                  if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	                    if (site.x !== x0 || site.y !== y0) {
	                      d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	                      d3_geom_voronoiAddBeach(site);
	                      x0 = site.x, y0 = site.y;
	                    }
	                    site = sites.pop();
	                  } else if (circle) {
	                    d3_geom_voronoiRemoveBeach(circle.arc);
	                  } else {
	                    break;
	                  }
	                }
	                if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	                var diagram = {
	                  cells: d3_geom_voronoiCells,
	                  edges: d3_geom_voronoiEdges
	                };
	                d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	                return diagram;
	              }
	              function d3_geom_voronoiVertexOrder(a, b) {
	                return b.y - a.y || b.x - a.x;
	              }
	              d3.geom.voronoi = function(points) {
	                var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	                if (points) return voronoi(points);
	                function voronoi(data) {
	                  var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	                  d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	                    var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	                      var s = e.start();
	                      return [s.x, s.y];
	                    }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [[x0, y1], [x1, y1], [x1, y0], [x0, y0]] : [];
	                    polygon.point = data[i];
	                  });
	                  return polygons;
	                }
	                function sites(data) {
	                  return data.map(function(d, i) {
	                    return {
	                      x: Math.round(fx(d, i) / ε) * ε,
	                      y: Math.round(fy(d, i) / ε) * ε,
	                      i
	                    };
	                  });
	                }
	                voronoi.links = function(data) {
	                  return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	                    return edge.l && edge.r;
	                  }).map(function(edge) {
	                    return {
	                      source: data[edge.l.i],
	                      target: data[edge.r.i]
	                    };
	                  });
	                };
	                voronoi.triangles = function(data) {
	                  var triangles = [];
	                  d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	                    var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	                    while (++j < m) {
	                      s0 = s1;
	                      e1 = edges[j].edge;
	                      s1 = e1.l === site ? e1.r : e1.l;
	                      if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	                        triangles.push([data[i], data[s0.i], data[s1.i]]);
	                      }
	                    }
	                  });
	                  return triangles;
	                };
	                voronoi.x = function(_) {
	                  return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	                };
	                voronoi.y = function(_) {
	                  return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	                };
	                voronoi.clipExtent = function(_) {
	                  if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	                  clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	                  return voronoi;
	                };
	                voronoi.size = function(_) {
	                  if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	                  return voronoi.clipExtent(_ && [[0, 0], _]);
	                };
	                return voronoi;
	              };
	              var d3_geom_voronoiClipExtent = [[-1e6, -1e6], [1e6, 1e6]];
	              function d3_geom_voronoiTriangleArea(a, b, c) {
	                return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	              }
	              d3.geom.delaunay = function(vertices) {
	                return d3.geom.voronoi().triangles(vertices);
	              };
	              d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	                var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	                if (compat = arguments.length) {
	                  x = d3_geom_quadtreeCompatX;
	                  y = d3_geom_quadtreeCompatY;
	                  if (compat === 3) {
	                    y2 = y1;
	                    x2 = x1;
	                    y1 = x1 = 0;
	                  }
	                  return quadtree(points);
	                }
	                function quadtree(data) {
	                  var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	                  if (x1 != null) {
	                    x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	                  } else {
	                    x2_ = y2_ = -(x1_ = y1_ = Infinity);
	                    xs = [], ys = [];
	                    n = data.length;
	                    if (compat) for (i = 0; i < n; ++i) {
	                      d = data[i];
	                      if (d.x < x1_) x1_ = d.x;
	                      if (d.y < y1_) y1_ = d.y;
	                      if (d.x > x2_) x2_ = d.x;
	                      if (d.y > y2_) y2_ = d.y;
	                      xs.push(d.x);
	                      ys.push(d.y);
	                    }
	                    else for (i = 0; i < n; ++i) {
	                      var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	                      if (x_ < x1_) x1_ = x_;
	                      if (y_ < y1_) y1_ = y_;
	                      if (x_ > x2_) x2_ = x_;
	                      if (y_ > y2_) y2_ = y_;
	                      xs.push(x_);
	                      ys.push(y_);
	                    }
	                  }
	                  var dx = x2_ - x1_, dy = y2_ - y1_;
	                  if (dx > dy) y2_ = y1_ + dx;
	                  else x2_ = x1_ + dy;
	                  function insert(n2, d2, x3, y3, x12, y12, x22, y22) {
	                    if (isNaN(x3) || isNaN(y3)) return;
	                    if (n2.leaf) {
	                      var nx = n2.x, ny = n2.y;
	                      if (nx != null) {
	                        if (abs(nx - x3) + abs(ny - y3) < 0.01) {
	                          insertChild(n2, d2, x3, y3, x12, y12, x22, y22);
	                        } else {
	                          var nPoint = n2.point;
	                          n2.x = n2.y = n2.point = null;
	                          insertChild(n2, nPoint, nx, ny, x12, y12, x22, y22);
	                          insertChild(n2, d2, x3, y3, x12, y12, x22, y22);
	                        }
	                      } else {
	                        n2.x = x3, n2.y = y3, n2.point = d2;
	                      }
	                    } else {
	                      insertChild(n2, d2, x3, y3, x12, y12, x22, y22);
	                    }
	                  }
	                  function insertChild(n2, d2, x3, y3, x12, y12, x22, y22) {
	                    var xm = (x12 + x22) * 0.5, ym = (y12 + y22) * 0.5, right = x3 >= xm, below = y3 >= ym, i2 = below << 1 | right;
	                    n2.leaf = false;
	                    n2 = n2.nodes[i2] || (n2.nodes[i2] = d3_geom_quadtreeNode());
	                    if (right) x12 = xm;
	                    else x22 = xm;
	                    if (below) y12 = ym;
	                    else y22 = ym;
	                    insert(n2, d2, x3, y3, x12, y12, x22, y22);
	                  }
	                  var root = d3_geom_quadtreeNode();
	                  root.add = function(d2) {
	                    insert(root, d2, +fx(d2, ++i), +fy(d2, i), x1_, y1_, x2_, y2_);
	                  };
	                  root.visit = function(f) {
	                    d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	                  };
	                  root.find = function(point) {
	                    return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	                  };
	                  i = -1;
	                  if (x1 == null) {
	                    while (++i < n) {
	                      insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	                    }
	                    --i;
	                  } else data.forEach(root.add);
	                  xs = ys = data = d = null;
	                  return root;
	                }
	                quadtree.x = function(_) {
	                  return arguments.length ? (x = _, quadtree) : x;
	                };
	                quadtree.y = function(_) {
	                  return arguments.length ? (y = _, quadtree) : y;
	                };
	                quadtree.extent = function(_) {
	                  if (!arguments.length) return x1 == null ? null : [[x1, y1], [x2, y2]];
	                  if (_ == null) x1 = y1 = x2 = y2 = null;
	                  else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], y2 = +_[1][1];
	                  return quadtree;
	                };
	                quadtree.size = function(_) {
	                  if (!arguments.length) return x1 == null ? null : [x2 - x1, y2 - y1];
	                  if (_ == null) x1 = y1 = x2 = y2 = null;
	                  else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	                  return quadtree;
	                };
	                return quadtree;
	              };
	              function d3_geom_quadtreeCompatX(d) {
	                return d.x;
	              }
	              function d3_geom_quadtreeCompatY(d) {
	                return d.y;
	              }
	              function d3_geom_quadtreeNode() {
	                return {
	                  leaf: true,
	                  nodes: [],
	                  point: null,
	                  x: null,
	                  y: null
	                };
	              }
	              function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	                if (!f(node, x1, y1, x2, y2)) {
	                  var sx = (x1 + x2) * 0.5, sy = (y1 + y2) * 0.5, children = node.nodes;
	                  if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	                  if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	                  if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	                  if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	                }
	              }
	              function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	                var minDistance2 = Infinity, closestPoint;
	                (function find(node, x1, y1, x2, y2) {
	                  if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	                  if (point = node.point) {
	                    var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	                    if (distance2 < minDistance2) {
	                      var distance = Math.sqrt(minDistance2 = distance2);
	                      x0 = x - distance, y0 = y - distance;
	                      x3 = x + distance, y3 = y + distance;
	                      closestPoint = point;
	                    }
	                  }
	                  var children = node.nodes, xm = (x1 + x2) * 0.5, ym = (y1 + y2) * 0.5, right = x >= xm, below = y >= ym;
	                  for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	                    if (node = children[i & 3]) switch (i & 3) {
	                      case 0:
	                        find(node, x1, y1, xm, ym);
	                        break;
	                      case 1:
	                        find(node, xm, y1, x2, ym);
	                        break;
	                      case 2:
	                        find(node, x1, ym, xm, y2);
	                        break;
	                      case 3:
	                        find(node, xm, ym, x2, y2);
	                        break;
	                    }
	                  }
	                })(root, x0, y0, x3, y3);
	                return closestPoint;
	              }
	              d3.interpolateRgb = d3_interpolateRgb;
	              function d3_interpolateRgb(a, b) {
	                a = d3.rgb(a);
	                b = d3.rgb(b);
	                var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	                return function(t) {
	                  return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	                };
	              }
	              d3.interpolateObject = d3_interpolateObject;
	              function d3_interpolateObject(a, b) {
	                var i = {}, c = {}, k;
	                for (k in a) {
	                  if (k in b) {
	                    i[k] = d3_interpolate(a[k], b[k]);
	                  } else {
	                    c[k] = a[k];
	                  }
	                }
	                for (k in b) {
	                  if (!(k in a)) {
	                    c[k] = b[k];
	                  }
	                }
	                return function(t) {
	                  for (k in i) c[k] = i[k](t);
	                  return c;
	                };
	              }
	              d3.interpolateNumber = d3_interpolateNumber;
	              function d3_interpolateNumber(a, b) {
	                a = +a, b = +b;
	                return function(t) {
	                  return a * (1 - t) + b * t;
	                };
	              }
	              d3.interpolateString = d3_interpolateString;
	              function d3_interpolateString(a, b) {
	                var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	                a = a + "", b = b + "";
	                while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	                  if ((bs = bm.index) > bi) {
	                    bs = b.slice(bi, bs);
	                    if (s[i]) s[i] += bs;
	                    else s[++i] = bs;
	                  }
	                  if ((am = am[0]) === (bm = bm[0])) {
	                    if (s[i]) s[i] += bm;
	                    else s[++i] = bm;
	                  } else {
	                    s[++i] = null;
	                    q.push({
	                      i,
	                      x: d3_interpolateNumber(am, bm)
	                    });
	                  }
	                  bi = d3_interpolate_numberB.lastIndex;
	                }
	                if (bi < b.length) {
	                  bs = b.slice(bi);
	                  if (s[i]) s[i] += bs;
	                  else s[++i] = bs;
	                }
	                return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	                  return b(t) + "";
	                }) : function() {
	                  return b;
	                } : (b = q.length, function(t) {
	                  for (var i2 = 0, o; i2 < b; ++i2) s[(o = q[i2]).i] = o.x(t);
	                  return s.join("");
	                });
	              }
	              var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	              d3.interpolate = d3_interpolate;
	              function d3_interpolate(a, b) {
	                var i = d3.interpolators.length, f;
	                while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	                return f;
	              }
	              d3.interpolators = [function(a, b) {
	                var t = typeof b;
	                return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	              }];
	              d3.interpolateArray = d3_interpolateArray;
	              function d3_interpolateArray(a, b) {
	                var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	                for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	                for (; i < na; ++i) c[i] = a[i];
	                for (; i < nb; ++i) c[i] = b[i];
	                return function(t) {
	                  for (i = 0; i < n0; ++i) c[i] = x[i](t);
	                  return c;
	                };
	              }
	              var d3_ease_default = function() {
	                return d3_identity;
	              };
	              var d3_ease = d3.map({
	                linear: d3_ease_default,
	                poly: d3_ease_poly,
	                quad: function() {
	                  return d3_ease_quad;
	                },
	                cubic: function() {
	                  return d3_ease_cubic;
	                },
	                sin: function() {
	                  return d3_ease_sin;
	                },
	                exp: function() {
	                  return d3_ease_exp;
	                },
	                circle: function() {
	                  return d3_ease_circle;
	                },
	                elastic: d3_ease_elastic,
	                back: d3_ease_back,
	                bounce: function() {
	                  return d3_ease_bounce;
	                }
	              });
	              var d3_ease_mode = d3.map({
	                "in": d3_identity,
	                out: d3_ease_reverse,
	                "in-out": d3_ease_reflect,
	                "out-in": function(f) {
	                  return d3_ease_reflect(d3_ease_reverse(f));
	                }
	              });
	              d3.ease = function(name2) {
	                var i = name2.indexOf("-"), t = i >= 0 ? name2.slice(0, i) : name2, m = i >= 0 ? name2.slice(i + 1) : "in";
	                t = d3_ease.get(t) || d3_ease_default;
	                m = d3_ease_mode.get(m) || d3_identity;
	                return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	              };
	              function d3_ease_clamp(f) {
	                return function(t) {
	                  return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	                };
	              }
	              function d3_ease_reverse(f) {
	                return function(t) {
	                  return 1 - f(1 - t);
	                };
	              }
	              function d3_ease_reflect(f) {
	                return function(t) {
	                  return 0.5 * (t < 0.5 ? f(2 * t) : 2 - f(2 - 2 * t));
	                };
	              }
	              function d3_ease_quad(t) {
	                return t * t;
	              }
	              function d3_ease_cubic(t) {
	                return t * t * t;
	              }
	              function d3_ease_cubicInOut(t) {
	                if (t <= 0) return 0;
	                if (t >= 1) return 1;
	                var t2 = t * t, t3 = t2 * t;
	                return 4 * (t < 0.5 ? t3 : 3 * (t - t2) + t3 - 0.75);
	              }
	              function d3_ease_poly(e) {
	                return function(t) {
	                  return Math.pow(t, e);
	                };
	              }
	              function d3_ease_sin(t) {
	                return 1 - Math.cos(t * halfπ);
	              }
	              function d3_ease_exp(t) {
	                return Math.pow(2, 10 * (t - 1));
	              }
	              function d3_ease_circle(t) {
	                return 1 - Math.sqrt(1 - t * t);
	              }
	              function d3_ease_elastic(a, p) {
	                var s;
	                if (arguments.length < 2) p = 0.45;
	                if (arguments.length) s = p / τ * Math.asin(1 / a);
	                else a = 1, s = p / 4;
	                return function(t) {
	                  return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	                };
	              }
	              function d3_ease_back(s) {
	                if (!s) s = 1.70158;
	                return function(t) {
	                  return t * t * ((s + 1) * t - s);
	                };
	              }
	              function d3_ease_bounce(t) {
	                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
	              }
	              d3.interpolateHcl = d3_interpolateHcl;
	              function d3_interpolateHcl(a, b) {
	                a = d3.hcl(a);
	                b = d3.hcl(b);
	                var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	                if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	                if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah;
	                else if (bh > 180) bh -= 360;
	                else if (bh < -180) bh += 360;
	                return function(t) {
	                  return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	                };
	              }
	              d3.interpolateHsl = d3_interpolateHsl;
	              function d3_interpolateHsl(a, b) {
	                a = d3.hsl(a);
	                b = d3.hsl(b);
	                var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	                if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	                if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah;
	                else if (bh > 180) bh -= 360;
	                else if (bh < -180) bh += 360;
	                return function(t) {
	                  return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	                };
	              }
	              d3.interpolateLab = d3_interpolateLab;
	              function d3_interpolateLab(a, b) {
	                a = d3.lab(a);
	                b = d3.lab(b);
	                var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	                return function(t) {
	                  return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	                };
	              }
	              d3.interpolateRound = d3_interpolateRound;
	              function d3_interpolateRound(a, b) {
	                b -= a;
	                return function(t) {
	                  return Math.round(a + b * t);
	                };
	              }
	              d3.transform = function(string) {
	                var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	                return (d3.transform = function(string2) {
	                  if (string2 != null) {
	                    g.setAttribute("transform", string2);
	                    var t = g.transform.baseVal.consolidate();
	                  }
	                  return new d3_transform(t ? t.matrix : d3_transformIdentity);
	                })(string);
	              };
	              function d3_transform(m) {
	                var r0 = [m.a, m.b], r1 = [m.c, m.d], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	                if (r0[0] * r1[1] < r1[0] * r0[1]) {
	                  r0[0] *= -1;
	                  r0[1] *= -1;
	                  kx *= -1;
	                  kz *= -1;
	                }
	                this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	                this.translate = [m.e, m.f];
	                this.scale = [kx, ky];
	                this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	              }
	              d3_transform.prototype.toString = function() {
	                return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	              };
	              function d3_transformDot(a, b) {
	                return a[0] * b[0] + a[1] * b[1];
	              }
	              function d3_transformNormalize(a) {
	                var k = Math.sqrt(d3_transformDot(a, a));
	                if (k) {
	                  a[0] /= k;
	                  a[1] /= k;
	                }
	                return k;
	              }
	              function d3_transformCombine(a, b, k) {
	                a[0] += k * b[0];
	                a[1] += k * b[1];
	                return a;
	              }
	              var d3_transformIdentity = {
	                a: 1,
	                b: 0,
	                c: 0,
	                d: 1,
	                e: 0,
	                f: 0
	              };
	              d3.interpolateTransform = d3_interpolateTransform;
	              function d3_interpolateTransformPop(s) {
	                return s.length ? s.pop() + "," : "";
	              }
	              function d3_interpolateTranslate(ta, tb, s, q) {
	                if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	                  var i = s.push("translate(", null, ",", null, ")");
	                  q.push({
	                    i: i - 4,
	                    x: d3_interpolateNumber(ta[0], tb[0])
	                  }, {
	                    i: i - 2,
	                    x: d3_interpolateNumber(ta[1], tb[1])
	                  });
	                } else if (tb[0] || tb[1]) {
	                  s.push("translate(" + tb + ")");
	                }
	              }
	              function d3_interpolateRotate(ra, rb, s, q) {
	                if (ra !== rb) {
	                  if (ra - rb > 180) rb += 360;
	                  else if (rb - ra > 180) ra += 360;
	                  q.push({
	                    i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	                    x: d3_interpolateNumber(ra, rb)
	                  });
	                } else if (rb) {
	                  s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	                }
	              }
	              function d3_interpolateSkew(wa, wb, s, q) {
	                if (wa !== wb) {
	                  q.push({
	                    i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	                    x: d3_interpolateNumber(wa, wb)
	                  });
	                } else if (wb) {
	                  s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	                }
	              }
	              function d3_interpolateScale(ka, kb, s, q) {
	                if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	                  var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	                  q.push({
	                    i: i - 4,
	                    x: d3_interpolateNumber(ka[0], kb[0])
	                  }, {
	                    i: i - 2,
	                    x: d3_interpolateNumber(ka[1], kb[1])
	                  });
	                } else if (kb[0] !== 1 || kb[1] !== 1) {
	                  s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	                }
	              }
	              function d3_interpolateTransform(a, b) {
	                var s = [], q = [];
	                a = d3.transform(a), b = d3.transform(b);
	                d3_interpolateTranslate(a.translate, b.translate, s, q);
	                d3_interpolateRotate(a.rotate, b.rotate, s, q);
	                d3_interpolateSkew(a.skew, b.skew, s, q);
	                d3_interpolateScale(a.scale, b.scale, s, q);
	                a = b = null;
	                return function(t) {
	                  var i = -1, n = q.length, o;
	                  while (++i < n) s[(o = q[i]).i] = o.x(t);
	                  return s.join("");
	                };
	              }
	              function d3_uninterpolateNumber(a, b) {
	                b = (b -= a = +a) || 1 / b;
	                return function(x) {
	                  return (x - a) / b;
	                };
	              }
	              function d3_uninterpolateClamp(a, b) {
	                b = (b -= a = +a) || 1 / b;
	                return function(x) {
	                  return Math.max(0, Math.min(1, (x - a) / b));
	                };
	              }
	              d3.layout = {};
	              d3.layout.bundle = function() {
	                return function(links) {
	                  var paths = [], i = -1, n = links.length;
	                  while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	                  return paths;
	                };
	              };
	              function d3_layout_bundlePath(link) {
	                var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [start];
	                while (start !== lca) {
	                  start = start.parent;
	                  points.push(start);
	                }
	                var k = points.length;
	                while (end !== lca) {
	                  points.splice(k, 0, end);
	                  end = end.parent;
	                }
	                return points;
	              }
	              function d3_layout_bundleAncestors(node) {
	                var ancestors = [], parent = node.parent;
	                while (parent != null) {
	                  ancestors.push(node);
	                  node = parent;
	                  parent = parent.parent;
	                }
	                ancestors.push(node);
	                return ancestors;
	              }
	              function d3_layout_bundleLeastCommonAncestor(a, b) {
	                if (a === b) return a;
	                var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	                while (aNode === bNode) {
	                  sharedNode = aNode;
	                  aNode = aNodes.pop();
	                  bNode = bNodes.pop();
	                }
	                return sharedNode;
	              }
	              d3.layout.chord = function() {
	                var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	                function relayout() {
	                  var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	                  chords = [];
	                  groups = [];
	                  k = 0, i = -1;
	                  while (++i < n) {
	                    x = 0, j = -1;
	                    while (++j < n) {
	                      x += matrix[i][j];
	                    }
	                    groupSums.push(x);
	                    subgroupIndex.push(d3.range(n));
	                    k += x;
	                  }
	                  if (sortGroups) {
	                    groupIndex.sort(function(a, b) {
	                      return sortGroups(groupSums[a], groupSums[b]);
	                    });
	                  }
	                  if (sortSubgroups) {
	                    subgroupIndex.forEach(function(d, i2) {
	                      d.sort(function(a, b) {
	                        return sortSubgroups(matrix[i2][a], matrix[i2][b]);
	                      });
	                    });
	                  }
	                  k = (τ - padding * n) / k;
	                  x = 0, i = -1;
	                  while (++i < n) {
	                    x0 = x, j = -1;
	                    while (++j < n) {
	                      var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	                      subgroups[di + "-" + dj] = {
	                        index: di,
	                        subindex: dj,
	                        startAngle: a0,
	                        endAngle: a1,
	                        value: v
	                      };
	                    }
	                    groups[di] = {
	                      index: di,
	                      startAngle: x0,
	                      endAngle: x,
	                      value: groupSums[di]
	                    };
	                    x += padding;
	                  }
	                  i = -1;
	                  while (++i < n) {
	                    j = i - 1;
	                    while (++j < n) {
	                      var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	                      if (source.value || target.value) {
	                        chords.push(source.value < target.value ? {
	                          source: target,
	                          target: source
	                        } : {
	                          source,
	                          target
	                        });
	                      }
	                    }
	                  }
	                  if (sortChords) resort();
	                }
	                function resort() {
	                  chords.sort(function(a, b) {
	                    return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	                  });
	                }
	                chord.matrix = function(x) {
	                  if (!arguments.length) return matrix;
	                  n = (matrix = x) && matrix.length;
	                  chords = groups = null;
	                  return chord;
	                };
	                chord.padding = function(x) {
	                  if (!arguments.length) return padding;
	                  padding = x;
	                  chords = groups = null;
	                  return chord;
	                };
	                chord.sortGroups = function(x) {
	                  if (!arguments.length) return sortGroups;
	                  sortGroups = x;
	                  chords = groups = null;
	                  return chord;
	                };
	                chord.sortSubgroups = function(x) {
	                  if (!arguments.length) return sortSubgroups;
	                  sortSubgroups = x;
	                  chords = null;
	                  return chord;
	                };
	                chord.sortChords = function(x) {
	                  if (!arguments.length) return sortChords;
	                  sortChords = x;
	                  if (chords) resort();
	                  return chord;
	                };
	                chord.chords = function() {
	                  if (!chords) relayout();
	                  return chords;
	                };
	                chord.groups = function() {
	                  if (!groups) relayout();
	                  return groups;
	                };
	                return chord;
	              };
	              d3.layout.force = function() {
	                var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [1, 1], drag, alpha, friction = 0.9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = 0.1, theta2 = 0.64, nodes = [], links = [], distances, strengths, charges;
	                function repulse(node) {
	                  return function(quad, x1, _, x2) {
	                    if (quad.point !== node) {
	                      var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	                      if (dw * dw / theta2 < dn) {
	                        if (dn < chargeDistance2) {
	                          var k = quad.charge / dn;
	                          node.px -= dx * k;
	                          node.py -= dy * k;
	                        }
	                        return true;
	                      }
	                      if (quad.point && dn && dn < chargeDistance2) {
	                        var k = quad.pointCharge / dn;
	                        node.px -= dx * k;
	                        node.py -= dy * k;
	                      }
	                    }
	                    return !quad.charge;
	                  };
	                }
	                force.tick = function() {
	                  if ((alpha *= 0.99) < 5e-3) {
	                    timer = null;
	                    event.end({
	                      type: "end",
	                      alpha: alpha = 0
	                    });
	                    return true;
	                  }
	                  var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	                  for (i = 0; i < m; ++i) {
	                    o = links[i];
	                    s = o.source;
	                    t = o.target;
	                    x = t.x - s.x;
	                    y = t.y - s.y;
	                    if (l = x * x + y * y) {
	                      l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	                      x *= l;
	                      y *= l;
	                      t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : 0.5);
	                      t.y -= y * k;
	                      s.x += x * (k = 1 - k);
	                      s.y += y * k;
	                    }
	                  }
	                  if (k = alpha * gravity) {
	                    x = size[0] / 2;
	                    y = size[1] / 2;
	                    i = -1;
	                    if (k) while (++i < n) {
	                      o = nodes[i];
	                      o.x += (x - o.x) * k;
	                      o.y += (y - o.y) * k;
	                    }
	                  }
	                  if (charge) {
	                    d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	                    i = -1;
	                    while (++i < n) {
	                      if (!(o = nodes[i]).fixed) {
	                        q.visit(repulse(o));
	                      }
	                    }
	                  }
	                  i = -1;
	                  while (++i < n) {
	                    o = nodes[i];
	                    if (o.fixed) {
	                      o.x = o.px;
	                      o.y = o.py;
	                    } else {
	                      o.x -= (o.px - (o.px = o.x)) * friction;
	                      o.y -= (o.py - (o.py = o.y)) * friction;
	                    }
	                  }
	                  event.tick({
	                    type: "tick",
	                    alpha
	                  });
	                };
	                force.nodes = function(x) {
	                  if (!arguments.length) return nodes;
	                  nodes = x;
	                  return force;
	                };
	                force.links = function(x) {
	                  if (!arguments.length) return links;
	                  links = x;
	                  return force;
	                };
	                force.size = function(x) {
	                  if (!arguments.length) return size;
	                  size = x;
	                  return force;
	                };
	                force.linkDistance = function(x) {
	                  if (!arguments.length) return linkDistance;
	                  linkDistance = typeof x === "function" ? x : +x;
	                  return force;
	                };
	                force.distance = force.linkDistance;
	                force.linkStrength = function(x) {
	                  if (!arguments.length) return linkStrength;
	                  linkStrength = typeof x === "function" ? x : +x;
	                  return force;
	                };
	                force.friction = function(x) {
	                  if (!arguments.length) return friction;
	                  friction = +x;
	                  return force;
	                };
	                force.charge = function(x) {
	                  if (!arguments.length) return charge;
	                  charge = typeof x === "function" ? x : +x;
	                  return force;
	                };
	                force.chargeDistance = function(x) {
	                  if (!arguments.length) return Math.sqrt(chargeDistance2);
	                  chargeDistance2 = x * x;
	                  return force;
	                };
	                force.gravity = function(x) {
	                  if (!arguments.length) return gravity;
	                  gravity = +x;
	                  return force;
	                };
	                force.theta = function(x) {
	                  if (!arguments.length) return Math.sqrt(theta2);
	                  theta2 = x * x;
	                  return force;
	                };
	                force.alpha = function(x) {
	                  if (!arguments.length) return alpha;
	                  x = +x;
	                  if (alpha) {
	                    if (x > 0) {
	                      alpha = x;
	                    } else {
	                      timer.c = null, timer.t = NaN, timer = null;
	                      event.end({
	                        type: "end",
	                        alpha: alpha = 0
	                      });
	                    }
	                  } else if (x > 0) {
	                    event.start({
	                      type: "start",
	                      alpha: alpha = x
	                    });
	                    timer = d3_timer(force.tick);
	                  }
	                  return force;
	                };
	                force.start = function() {
	                  var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	                  for (i = 0; i < n; ++i) {
	                    (o = nodes[i]).index = i;
	                    o.weight = 0;
	                  }
	                  for (i = 0; i < m; ++i) {
	                    o = links[i];
	                    if (typeof o.source == "number") o.source = nodes[o.source];
	                    if (typeof o.target == "number") o.target = nodes[o.target];
	                    ++o.source.weight;
	                    ++o.target.weight;
	                  }
	                  for (i = 0; i < n; ++i) {
	                    o = nodes[i];
	                    if (isNaN(o.x)) o.x = position("x", w);
	                    if (isNaN(o.y)) o.y = position("y", h);
	                    if (isNaN(o.px)) o.px = o.x;
	                    if (isNaN(o.py)) o.py = o.y;
	                  }
	                  distances = [];
	                  if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i);
	                  else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	                  strengths = [];
	                  if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i);
	                  else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	                  charges = [];
	                  if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i);
	                  else for (i = 0; i < n; ++i) charges[i] = charge;
	                  function position(dimension, size2) {
	                    if (!neighbors) {
	                      neighbors = new Array(n);
	                      for (j = 0; j < n; ++j) {
	                        neighbors[j] = [];
	                      }
	                      for (j = 0; j < m; ++j) {
	                        var o2 = links[j];
	                        neighbors[o2.source.index].push(o2.target);
	                        neighbors[o2.target.index].push(o2.source);
	                      }
	                    }
	                    var candidates = neighbors[i], j = -1, l = candidates.length, x;
	                    while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	                    return Math.random() * size2;
	                  }
	                  return force.resume();
	                };
	                force.resume = function() {
	                  return force.alpha(0.1);
	                };
	                force.stop = function() {
	                  return force.alpha(0);
	                };
	                force.drag = function() {
	                  if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	                  if (!arguments.length) return drag;
	                  this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	                };
	                function dragmove(d) {
	                  d.px = d3.event.x, d.py = d3.event.y;
	                  force.resume();
	                }
	                return d3.rebind(force, event, "on");
	              };
	              function d3_layout_forceDragstart(d) {
	                d.fixed |= 2;
	              }
	              function d3_layout_forceDragend(d) {
	                d.fixed &= -7;
	              }
	              function d3_layout_forceMouseover(d) {
	                d.fixed |= 4;
	                d.px = d.x, d.py = d.y;
	              }
	              function d3_layout_forceMouseout(d) {
	                d.fixed &= -5;
	              }
	              function d3_layout_forceAccumulate(quad, alpha, charges) {
	                var cx = 0, cy = 0;
	                quad.charge = 0;
	                if (!quad.leaf) {
	                  var nodes = quad.nodes, n = nodes.length, i = -1, c;
	                  while (++i < n) {
	                    c = nodes[i];
	                    if (c == null) continue;
	                    d3_layout_forceAccumulate(c, alpha, charges);
	                    quad.charge += c.charge;
	                    cx += c.charge * c.cx;
	                    cy += c.charge * c.cy;
	                  }
	                }
	                if (quad.point) {
	                  if (!quad.leaf) {
	                    quad.point.x += Math.random() - 0.5;
	                    quad.point.y += Math.random() - 0.5;
	                  }
	                  var k = alpha * charges[quad.point.index];
	                  quad.charge += quad.pointCharge = k;
	                  cx += k * quad.point.x;
	                  cy += k * quad.point.y;
	                }
	                quad.cx = cx / quad.charge;
	                quad.cy = cy / quad.charge;
	              }
	              var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	              d3.layout.hierarchy = function() {
	                var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	                function hierarchy(root) {
	                  var stack = [root], nodes = [], node;
	                  root.depth = 0;
	                  while ((node = stack.pop()) != null) {
	                    nodes.push(node);
	                    if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	                      var n, childs, child;
	                      while (--n >= 0) {
	                        stack.push(child = childs[n]);
	                        child.parent = node;
	                        child.depth = node.depth + 1;
	                      }
	                      if (value) node.value = 0;
	                      node.children = childs;
	                    } else {
	                      if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	                      delete node.children;
	                    }
	                  }
	                  d3_layout_hierarchyVisitAfter(root, function(node2) {
	                    var childs2, parent;
	                    if (sort && (childs2 = node2.children)) childs2.sort(sort);
	                    if (value && (parent = node2.parent)) parent.value += node2.value;
	                  });
	                  return nodes;
	                }
	                hierarchy.sort = function(x) {
	                  if (!arguments.length) return sort;
	                  sort = x;
	                  return hierarchy;
	                };
	                hierarchy.children = function(x) {
	                  if (!arguments.length) return children;
	                  children = x;
	                  return hierarchy;
	                };
	                hierarchy.value = function(x) {
	                  if (!arguments.length) return value;
	                  value = x;
	                  return hierarchy;
	                };
	                hierarchy.revalue = function(root) {
	                  if (value) {
	                    d3_layout_hierarchyVisitBefore(root, function(node) {
	                      if (node.children) node.value = 0;
	                    });
	                    d3_layout_hierarchyVisitAfter(root, function(node) {
	                      var parent;
	                      if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	                      if (parent = node.parent) parent.value += node.value;
	                    });
	                  }
	                  return root;
	                };
	                return hierarchy;
	              };
	              function d3_layout_hierarchyRebind(object, hierarchy) {
	                d3.rebind(object, hierarchy, "sort", "children", "value");
	                object.nodes = object;
	                object.links = d3_layout_hierarchyLinks;
	                return object;
	              }
	              function d3_layout_hierarchyVisitBefore(node, callback) {
	                var nodes = [node];
	                while ((node = nodes.pop()) != null) {
	                  callback(node);
	                  if ((children = node.children) && (n = children.length)) {
	                    var n, children;
	                    while (--n >= 0) nodes.push(children[n]);
	                  }
	                }
	              }
	              function d3_layout_hierarchyVisitAfter(node, callback) {
	                var nodes = [node], nodes2 = [];
	                while ((node = nodes.pop()) != null) {
	                  nodes2.push(node);
	                  if ((children = node.children) && (n = children.length)) {
	                    var i = -1, n, children;
	                    while (++i < n) nodes.push(children[i]);
	                  }
	                }
	                while ((node = nodes2.pop()) != null) {
	                  callback(node);
	                }
	              }
	              function d3_layout_hierarchyChildren(d) {
	                return d.children;
	              }
	              function d3_layout_hierarchyValue(d) {
	                return d.value;
	              }
	              function d3_layout_hierarchySort(a, b) {
	                return b.value - a.value;
	              }
	              function d3_layout_hierarchyLinks(nodes) {
	                return d3.merge(nodes.map(function(parent) {
	                  return (parent.children || []).map(function(child) {
	                    return {
	                      source: parent,
	                      target: child
	                    };
	                  });
	                }));
	              }
	              d3.layout.partition = function() {
	                var hierarchy = d3.layout.hierarchy(), size = [1, 1];
	                function position(node, x, dx, dy) {
	                  var children = node.children;
	                  node.x = x;
	                  node.y = node.depth * dy;
	                  node.dx = dx;
	                  node.dy = dy;
	                  if (children && (n = children.length)) {
	                    var i = -1, n, c, d;
	                    dx = node.value ? dx / node.value : 0;
	                    while (++i < n) {
	                      position(c = children[i], x, d = c.value * dx, dy);
	                      x += d;
	                    }
	                  }
	                }
	                function depth(node) {
	                  var children = node.children, d = 0;
	                  if (children && (n = children.length)) {
	                    var i = -1, n;
	                    while (++i < n) d = Math.max(d, depth(children[i]));
	                  }
	                  return 1 + d;
	                }
	                function partition(d, i) {
	                  var nodes = hierarchy.call(this, d, i);
	                  position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	                  return nodes;
	                }
	                partition.size = function(x) {
	                  if (!arguments.length) return size;
	                  size = x;
	                  return partition;
	                };
	                return d3_layout_hierarchyRebind(partition, hierarchy);
	              };
	              d3.layout.pie = function() {
	                var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	                function pie(data) {
	                  var n = data.length, values = data.map(function(d, i) {
	                    return +value.call(pie, d, i);
	                  }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	                  if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	                    return values[j] - values[i];
	                  } : function(i, j) {
	                    return sort(data[i], data[j]);
	                  });
	                  index.forEach(function(i) {
	                    arcs[i] = {
	                      data: data[i],
	                      value: v = values[i],
	                      startAngle: a,
	                      endAngle: a += v * k + pa,
	                      padAngle: p
	                    };
	                  });
	                  return arcs;
	                }
	                pie.value = function(_) {
	                  if (!arguments.length) return value;
	                  value = _;
	                  return pie;
	                };
	                pie.sort = function(_) {
	                  if (!arguments.length) return sort;
	                  sort = _;
	                  return pie;
	                };
	                pie.startAngle = function(_) {
	                  if (!arguments.length) return startAngle;
	                  startAngle = _;
	                  return pie;
	                };
	                pie.endAngle = function(_) {
	                  if (!arguments.length) return endAngle;
	                  endAngle = _;
	                  return pie;
	                };
	                pie.padAngle = function(_) {
	                  if (!arguments.length) return padAngle;
	                  padAngle = _;
	                  return pie;
	                };
	                return pie;
	              };
	              var d3_layout_pieSortByValue = {};
	              d3.layout.stack = function() {
	                var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	                function stack(data, index) {
	                  if (!(n = data.length)) return data;
	                  var series = data.map(function(d, i2) {
	                    return values.call(stack, d, i2);
	                  });
	                  var points = series.map(function(d) {
	                    return d.map(function(v, i2) {
	                      return [x.call(stack, v, i2), y.call(stack, v, i2)];
	                    });
	                  });
	                  var orders = order.call(stack, points, index);
	                  series = d3.permute(series, orders);
	                  points = d3.permute(points, orders);
	                  var offsets = offset.call(stack, points, index);
	                  var m = series[0].length, n, i, j, o;
	                  for (j = 0; j < m; ++j) {
	                    out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	                    for (i = 1; i < n; ++i) {
	                      out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	                    }
	                  }
	                  return data;
	                }
	                stack.values = function(x2) {
	                  if (!arguments.length) return values;
	                  values = x2;
	                  return stack;
	                };
	                stack.order = function(x2) {
	                  if (!arguments.length) return order;
	                  order = typeof x2 === "function" ? x2 : d3_layout_stackOrders.get(x2) || d3_layout_stackOrderDefault;
	                  return stack;
	                };
	                stack.offset = function(x2) {
	                  if (!arguments.length) return offset;
	                  offset = typeof x2 === "function" ? x2 : d3_layout_stackOffsets.get(x2) || d3_layout_stackOffsetZero;
	                  return stack;
	                };
	                stack.x = function(z) {
	                  if (!arguments.length) return x;
	                  x = z;
	                  return stack;
	                };
	                stack.y = function(z) {
	                  if (!arguments.length) return y;
	                  y = z;
	                  return stack;
	                };
	                stack.out = function(z) {
	                  if (!arguments.length) return out;
	                  out = z;
	                  return stack;
	                };
	                return stack;
	              };
	              function d3_layout_stackX(d) {
	                return d.x;
	              }
	              function d3_layout_stackY(d) {
	                return d.y;
	              }
	              function d3_layout_stackOut(d, y0, y) {
	                d.y0 = y0;
	                d.y = y;
	              }
	              var d3_layout_stackOrders = d3.map({
	                "inside-out": function(data) {
	                  var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	                    return max[a] - max[b];
	                  }), top = 0, bottom = 0, tops = [], bottoms = [];
	                  for (i = 0; i < n; ++i) {
	                    j = index[i];
	                    if (top < bottom) {
	                      top += sums[j];
	                      tops.push(j);
	                    } else {
	                      bottom += sums[j];
	                      bottoms.push(j);
	                    }
	                  }
	                  return bottoms.reverse().concat(tops);
	                },
	                reverse: function(data) {
	                  return d3.range(data.length).reverse();
	                },
	                "default": d3_layout_stackOrderDefault
	              });
	              var d3_layout_stackOffsets = d3.map({
	                silhouette: function(data) {
	                  var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	                  for (j = 0; j < m; ++j) {
	                    for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	                    if (o > max) max = o;
	                    sums.push(o);
	                  }
	                  for (j = 0; j < m; ++j) {
	                    y0[j] = (max - sums[j]) / 2;
	                  }
	                  return y0;
	                },
	                wiggle: function(data) {
	                  var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	                  y0[0] = o = o0 = 0;
	                  for (j = 1; j < m; ++j) {
	                    for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	                    for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	                      for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	                        s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	                      }
	                      s2 += s3 * data[i][j][1];
	                    }
	                    y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	                    if (o < o0) o0 = o;
	                  }
	                  for (j = 0; j < m; ++j) y0[j] -= o0;
	                  return y0;
	                },
	                expand: function(data) {
	                  var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	                  for (j = 0; j < m; ++j) {
	                    for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	                    if (o) for (i = 0; i < n; i++) data[i][j][1] /= o;
	                    else for (i = 0; i < n; i++) data[i][j][1] = k;
	                  }
	                  for (j = 0; j < m; ++j) y0[j] = 0;
	                  return y0;
	                },
	                zero: d3_layout_stackOffsetZero
	              });
	              function d3_layout_stackOrderDefault(data) {
	                return d3.range(data.length);
	              }
	              function d3_layout_stackOffsetZero(data) {
	                var j = -1, m = data[0].length, y0 = [];
	                while (++j < m) y0[j] = 0;
	                return y0;
	              }
	              function d3_layout_stackMaxIndex(array) {
	                var i = 1, j = 0, v = array[0][1], k, n = array.length;
	                for (; i < n; ++i) {
	                  if ((k = array[i][1]) > v) {
	                    j = i;
	                    v = k;
	                  }
	                }
	                return j;
	              }
	              function d3_layout_stackReduceSum(d) {
	                return d.reduce(d3_layout_stackSum, 0);
	              }
	              function d3_layout_stackSum(p, d) {
	                return p + d[1];
	              }
	              d3.layout.histogram = function() {
	                var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	                function histogram(data, i) {
	                  var bins = [], values = data.map(valuer, this), range2 = ranger.call(this, values, i), thresholds = binner.call(this, range2, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	                  while (++i < m) {
	                    bin = bins[i] = [];
	                    bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	                    bin.y = 0;
	                  }
	                  if (m > 0) {
	                    i = -1;
	                    while (++i < n) {
	                      x = values[i];
	                      if (x >= range2[0] && x <= range2[1]) {
	                        bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	                        bin.y += k;
	                        bin.push(data[i]);
	                      }
	                    }
	                  }
	                  return bins;
	                }
	                histogram.value = function(x) {
	                  if (!arguments.length) return valuer;
	                  valuer = x;
	                  return histogram;
	                };
	                histogram.range = function(x) {
	                  if (!arguments.length) return ranger;
	                  ranger = d3_functor(x);
	                  return histogram;
	                };
	                histogram.bins = function(x) {
	                  if (!arguments.length) return binner;
	                  binner = typeof x === "number" ? function(range2) {
	                    return d3_layout_histogramBinFixed(range2, x);
	                  } : d3_functor(x);
	                  return histogram;
	                };
	                histogram.frequency = function(x) {
	                  if (!arguments.length) return frequency;
	                  frequency = !!x;
	                  return histogram;
	                };
	                return histogram;
	              };
	              function d3_layout_histogramBinSturges(range2, values) {
	                return d3_layout_histogramBinFixed(range2, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	              }
	              function d3_layout_histogramBinFixed(range2, n) {
	                var x = -1, b = +range2[0], m = (range2[1] - b) / n, f = [];
	                while (++x <= n) f[x] = m * x + b;
	                return f;
	              }
	              function d3_layout_histogramRange(values) {
	                return [d3.min(values), d3.max(values)];
	              }
	              d3.layout.pack = function() {
	                var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [1, 1], radius;
	                function pack(d, i) {
	                  var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	                    return radius;
	                  };
	                  root.x = root.y = 0;
	                  d3_layout_hierarchyVisitAfter(root, function(d2) {
	                    d2.r = +r(d2.value);
	                  });
	                  d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	                  if (padding) {
	                    var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	                    d3_layout_hierarchyVisitAfter(root, function(d2) {
	                      d2.r += dr;
	                    });
	                    d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	                    d3_layout_hierarchyVisitAfter(root, function(d2) {
	                      d2.r -= dr;
	                    });
	                  }
	                  d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	                  return nodes;
	                }
	                pack.size = function(_) {
	                  if (!arguments.length) return size;
	                  size = _;
	                  return pack;
	                };
	                pack.radius = function(_) {
	                  if (!arguments.length) return radius;
	                  radius = _ == null || typeof _ === "function" ? _ : +_;
	                  return pack;
	                };
	                pack.padding = function(_) {
	                  if (!arguments.length) return padding;
	                  padding = +_;
	                  return pack;
	                };
	                return d3_layout_hierarchyRebind(pack, hierarchy);
	              };
	              function d3_layout_packSort(a, b) {
	                return a.value - b.value;
	              }
	              function d3_layout_packInsert(a, b) {
	                var c = a._pack_next;
	                a._pack_next = b;
	                b._pack_prev = a;
	                b._pack_next = c;
	                c._pack_prev = b;
	              }
	              function d3_layout_packSplice(a, b) {
	                a._pack_next = b;
	                b._pack_prev = a;
	              }
	              function d3_layout_packIntersects(a, b) {
	                var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	                return 0.999 * dr * dr > dx * dx + dy * dy;
	              }
	              function d3_layout_packSiblings(node) {
	                if (!(nodes = node.children) || !(n = nodes.length)) return;
	                var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	                function bound(node2) {
	                  xMin = Math.min(node2.x - node2.r, xMin);
	                  xMax = Math.max(node2.x + node2.r, xMax);
	                  yMin = Math.min(node2.y - node2.r, yMin);
	                  yMax = Math.max(node2.y + node2.r, yMax);
	                }
	                nodes.forEach(d3_layout_packLink);
	                a = nodes[0];
	                a.x = -a.r;
	                a.y = 0;
	                bound(a);
	                if (n > 1) {
	                  b = nodes[1];
	                  b.x = b.r;
	                  b.y = 0;
	                  bound(b);
	                  if (n > 2) {
	                    c = nodes[2];
	                    d3_layout_packPlace(a, b, c);
	                    bound(c);
	                    d3_layout_packInsert(a, c);
	                    a._pack_prev = c;
	                    d3_layout_packInsert(c, b);
	                    b = a._pack_next;
	                    for (i = 3; i < n; i++) {
	                      d3_layout_packPlace(a, b, c = nodes[i]);
	                      var isect = 0, s1 = 1, s2 = 1;
	                      for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	                        if (d3_layout_packIntersects(j, c)) {
	                          isect = 1;
	                          break;
	                        }
	                      }
	                      if (isect == 1) {
	                        for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	                          if (d3_layout_packIntersects(k, c)) {
	                            break;
	                          }
	                        }
	                      }
	                      if (isect) {
	                        if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j);
	                        else d3_layout_packSplice(a = k, b);
	                        i--;
	                      } else {
	                        d3_layout_packInsert(a, c);
	                        b = c;
	                        bound(c);
	                      }
	                    }
	                  }
	                }
	                var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	                for (i = 0; i < n; i++) {
	                  c = nodes[i];
	                  c.x -= cx;
	                  c.y -= cy;
	                  cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	                }
	                node.r = cr;
	                nodes.forEach(d3_layout_packUnlink);
	              }
	              function d3_layout_packLink(node) {
	                node._pack_next = node._pack_prev = node;
	              }
	              function d3_layout_packUnlink(node) {
	                delete node._pack_next;
	                delete node._pack_prev;
	              }
	              function d3_layout_packTransform(node, x, y, k) {
	                var children = node.children;
	                node.x = x += k * node.x;
	                node.y = y += k * node.y;
	                node.r *= k;
	                if (children) {
	                  var i = -1, n = children.length;
	                  while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	                }
	              }
	              function d3_layout_packPlace(a, b, c) {
	                var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	                if (db && (dx || dy)) {
	                  var da = b.r + c.r, dc = dx * dx + dy * dy;
	                  da *= da;
	                  db *= db;
	                  var x = 0.5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	                  c.x = a.x + x * dx + y * dy;
	                  c.y = a.y + x * dy - y * dx;
	                } else {
	                  c.x = a.x + db;
	                  c.y = a.y;
	                }
	              }
	              d3.layout.tree = function() {
	                var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [1, 1], nodeSize = null;
	                function tree(d, i) {
	                  var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	                  d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	                  d3_layout_hierarchyVisitBefore(root1, secondWalk);
	                  if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode);
	                  else {
	                    var left = root0, right = root0, bottom = root0;
	                    d3_layout_hierarchyVisitBefore(root0, function(node) {
	                      if (node.x < left.x) left = node;
	                      if (node.x > right.x) right = node;
	                      if (node.depth > bottom.depth) bottom = node;
	                    });
	                    var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	                    d3_layout_hierarchyVisitBefore(root0, function(node) {
	                      node.x = (node.x + tx) * kx;
	                      node.y = node.depth * ky;
	                    });
	                  }
	                  return nodes;
	                }
	                function wrapTree(root0) {
	                  var root1 = {
	                    A: null,
	                    children: [root0]
	                  }, queue = [root1], node1;
	                  while ((node1 = queue.pop()) != null) {
	                    for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	                      queue.push((children[i] = child = {
	                        _: children[i],
	                        parent: node1,
	                        children: (child = children[i].children) && child.slice() || [],
	                        A: null,
	                        a: null,
	                        z: 0,
	                        m: 0,
	                        c: 0,
	                        s: 0,
	                        t: null,
	                        i
	                      }).a = child);
	                    }
	                  }
	                  return root1.children[0];
	                }
	                function firstWalk(v) {
	                  var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	                  if (children.length) {
	                    d3_layout_treeShift(v);
	                    var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	                    if (w) {
	                      v.z = w.z + separation(v._, w._);
	                      v.m = v.z - midpoint;
	                    } else {
	                      v.z = midpoint;
	                    }
	                  } else if (w) {
	                    v.z = w.z + separation(v._, w._);
	                  }
	                  v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	                }
	                function secondWalk(v) {
	                  v._.x = v.z + v.parent.m;
	                  v.m += v.parent.m;
	                }
	                function apportion(v, w, ancestor) {
	                  if (w) {
	                    var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	                    while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	                      vom = d3_layout_treeLeft(vom);
	                      vop = d3_layout_treeRight(vop);
	                      vop.a = v;
	                      shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	                      if (shift > 0) {
	                        d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	                        sip += shift;
	                        sop += shift;
	                      }
	                      sim += vim.m;
	                      sip += vip.m;
	                      som += vom.m;
	                      sop += vop.m;
	                    }
	                    if (vim && !d3_layout_treeRight(vop)) {
	                      vop.t = vim;
	                      vop.m += sim - sop;
	                    }
	                    if (vip && !d3_layout_treeLeft(vom)) {
	                      vom.t = vip;
	                      vom.m += sip - som;
	                      ancestor = v;
	                    }
	                  }
	                  return ancestor;
	                }
	                function sizeNode(node) {
	                  node.x *= size[0];
	                  node.y = node.depth * size[1];
	                }
	                tree.separation = function(x) {
	                  if (!arguments.length) return separation;
	                  separation = x;
	                  return tree;
	                };
	                tree.size = function(x) {
	                  if (!arguments.length) return nodeSize ? null : size;
	                  nodeSize = (size = x) == null ? sizeNode : null;
	                  return tree;
	                };
	                tree.nodeSize = function(x) {
	                  if (!arguments.length) return nodeSize ? size : null;
	                  nodeSize = (size = x) == null ? null : sizeNode;
	                  return tree;
	                };
	                return d3_layout_hierarchyRebind(tree, hierarchy);
	              };
	              function d3_layout_treeSeparation(a, b) {
	                return a.parent == b.parent ? 1 : 2;
	              }
	              function d3_layout_treeLeft(v) {
	                var children = v.children;
	                return children.length ? children[0] : v.t;
	              }
	              function d3_layout_treeRight(v) {
	                var children = v.children, n;
	                return (n = children.length) ? children[n - 1] : v.t;
	              }
	              function d3_layout_treeMove(wm, wp, shift) {
	                var change = shift / (wp.i - wm.i);
	                wp.c -= change;
	                wp.s += shift;
	                wm.c += change;
	                wp.z += shift;
	                wp.m += shift;
	              }
	              function d3_layout_treeShift(v) {
	                var shift = 0, change = 0, children = v.children, i = children.length, w;
	                while (--i >= 0) {
	                  w = children[i];
	                  w.z += shift;
	                  w.m += shift;
	                  shift += w.s + (change += w.c);
	                }
	              }
	              function d3_layout_treeAncestor(vim, v, ancestor) {
	                return vim.a.parent === v.parent ? vim.a : ancestor;
	              }
	              d3.layout.cluster = function() {
	                var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [1, 1], nodeSize = false;
	                function cluster(d, i) {
	                  var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	                  d3_layout_hierarchyVisitAfter(root, function(node) {
	                    var children = node.children;
	                    if (children && children.length) {
	                      node.x = d3_layout_clusterX(children);
	                      node.y = d3_layout_clusterY(children);
	                    } else {
	                      node.x = previousNode ? x += separation(node, previousNode) : 0;
	                      node.y = 0;
	                      previousNode = node;
	                    }
	                  });
	                  var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	                  d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	                    node.x = (node.x - root.x) * size[0];
	                    node.y = (root.y - node.y) * size[1];
	                  } : function(node) {
	                    node.x = (node.x - x0) / (x1 - x0) * size[0];
	                    node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	                  });
	                  return nodes;
	                }
	                cluster.separation = function(x) {
	                  if (!arguments.length) return separation;
	                  separation = x;
	                  return cluster;
	                };
	                cluster.size = function(x) {
	                  if (!arguments.length) return nodeSize ? null : size;
	                  nodeSize = (size = x) == null;
	                  return cluster;
	                };
	                cluster.nodeSize = function(x) {
	                  if (!arguments.length) return nodeSize ? size : null;
	                  nodeSize = (size = x) != null;
	                  return cluster;
	                };
	                return d3_layout_hierarchyRebind(cluster, hierarchy);
	              };
	              function d3_layout_clusterY(children) {
	                return 1 + d3.max(children, function(child) {
	                  return child.y;
	                });
	              }
	              function d3_layout_clusterX(children) {
	                return children.reduce(function(x, child) {
	                  return x + child.x;
	                }, 0) / children.length;
	              }
	              function d3_layout_clusterLeft(node) {
	                var children = node.children;
	                return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	              }
	              function d3_layout_clusterRight(node) {
	                var children = node.children, n;
	                return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	              }
	              d3.layout.treemap = function() {
	                var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [1, 1], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = 0.5 * (1 + Math.sqrt(5));
	                function scale(children, k) {
	                  var i = -1, n = children.length, child, area;
	                  while (++i < n) {
	                    area = (child = children[i]).value * (k < 0 ? 0 : k);
	                    child.area = isNaN(area) || area <= 0 ? 0 : area;
	                  }
	                }
	                function squarify(node) {
	                  var children = node.children;
	                  if (children && children.length) {
	                    var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	                    scale(remaining, rect.dx * rect.dy / node.value);
	                    row.area = 0;
	                    while ((n = remaining.length) > 0) {
	                      row.push(child = remaining[n - 1]);
	                      row.area += child.area;
	                      if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	                        remaining.pop();
	                        best = score;
	                      } else {
	                        row.area -= row.pop().area;
	                        position(row, u, rect, false);
	                        u = Math.min(rect.dx, rect.dy);
	                        row.length = row.area = 0;
	                        best = Infinity;
	                      }
	                    }
	                    if (row.length) {
	                      position(row, u, rect, true);
	                      row.length = row.area = 0;
	                    }
	                    children.forEach(squarify);
	                  }
	                }
	                function stickify(node) {
	                  var children = node.children;
	                  if (children && children.length) {
	                    var rect = pad(node), remaining = children.slice(), child, row = [];
	                    scale(remaining, rect.dx * rect.dy / node.value);
	                    row.area = 0;
	                    while (child = remaining.pop()) {
	                      row.push(child);
	                      row.area += child.area;
	                      if (child.z != null) {
	                        position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	                        row.length = row.area = 0;
	                      }
	                    }
	                    children.forEach(stickify);
	                  }
	                }
	                function worst(row, u) {
	                  var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	                  while (++i < n) {
	                    if (!(r = row[i].area)) continue;
	                    if (r < rmin) rmin = r;
	                    if (r > rmax) rmax = r;
	                  }
	                  s *= s;
	                  u *= u;
	                  return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	                }
	                function position(row, u, rect, flush) {
	                  var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	                  if (u == rect.dx) {
	                    if (flush || v > rect.dy) v = rect.dy;
	                    while (++i < n) {
	                      o = row[i];
	                      o.x = x;
	                      o.y = y;
	                      o.dy = v;
	                      x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	                    }
	                    o.z = true;
	                    o.dx += rect.x + rect.dx - x;
	                    rect.y += v;
	                    rect.dy -= v;
	                  } else {
	                    if (flush || v > rect.dx) v = rect.dx;
	                    while (++i < n) {
	                      o = row[i];
	                      o.x = x;
	                      o.y = y;
	                      o.dx = v;
	                      y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	                    }
	                    o.z = false;
	                    o.dy += rect.y + rect.dy - y;
	                    rect.x += v;
	                    rect.dx -= v;
	                  }
	                }
	                function treemap(d) {
	                  var nodes = stickies || hierarchy(d), root = nodes[0];
	                  root.x = root.y = 0;
	                  if (root.value) root.dx = size[0], root.dy = size[1];
	                  else root.dx = root.dy = 0;
	                  if (stickies) hierarchy.revalue(root);
	                  scale([root], root.dx * root.dy / root.value);
	                  (stickies ? stickify : squarify)(root);
	                  if (sticky) stickies = nodes;
	                  return nodes;
	                }
	                treemap.size = function(x) {
	                  if (!arguments.length) return size;
	                  size = x;
	                  return treemap;
	                };
	                treemap.padding = function(x) {
	                  if (!arguments.length) return padding;
	                  function padFunction(node) {
	                    var p = x.call(treemap, node, node.depth);
	                    return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [p, p, p, p] : p);
	                  }
	                  function padConstant(node) {
	                    return d3_layout_treemapPad(node, x);
	                  }
	                  var type;
	                  pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [x, x, x, x], padConstant) : padConstant;
	                  return treemap;
	                };
	                treemap.round = function(x) {
	                  if (!arguments.length) return round != Number;
	                  round = x ? Math.round : Number;
	                  return treemap;
	                };
	                treemap.sticky = function(x) {
	                  if (!arguments.length) return sticky;
	                  sticky = x;
	                  stickies = null;
	                  return treemap;
	                };
	                treemap.ratio = function(x) {
	                  if (!arguments.length) return ratio;
	                  ratio = x;
	                  return treemap;
	                };
	                treemap.mode = function(x) {
	                  if (!arguments.length) return mode;
	                  mode = x + "";
	                  return treemap;
	                };
	                return d3_layout_hierarchyRebind(treemap, hierarchy);
	              };
	              function d3_layout_treemapPadNull(node) {
	                return {
	                  x: node.x,
	                  y: node.y,
	                  dx: node.dx,
	                  dy: node.dy
	                };
	              }
	              function d3_layout_treemapPad(node, padding) {
	                var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	                if (dx < 0) {
	                  x += dx / 2;
	                  dx = 0;
	                }
	                if (dy < 0) {
	                  y += dy / 2;
	                  dy = 0;
	                }
	                return {
	                  x,
	                  y,
	                  dx,
	                  dy
	                };
	              }
	              d3.random = {
	                normal: function(µ, σ) {
	                  var n = arguments.length;
	                  if (n < 2) σ = 1;
	                  if (n < 1) µ = 0;
	                  return function() {
	                    var x, y, r;
	                    do {
	                      x = Math.random() * 2 - 1;
	                      y = Math.random() * 2 - 1;
	                      r = x * x + y * y;
	                    } while (!r || r > 1);
	                    return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	                  };
	                },
	                logNormal: function() {
	                  var random = d3.random.normal.apply(d3, arguments);
	                  return function() {
	                    return Math.exp(random());
	                  };
	                },
	                bates: function(m) {
	                  var random = d3.random.irwinHall(m);
	                  return function() {
	                    return random() / m;
	                  };
	                },
	                irwinHall: function(m) {
	                  return function() {
	                    for (var s = 0, j = 0; j < m; j++) s += Math.random();
	                    return s;
	                  };
	                }
	              };
	              d3.scale = {};
	              function d3_scaleExtent(domain) {
	                var start = domain[0], stop = domain[domain.length - 1];
	                return start < stop ? [start, stop] : [stop, start];
	              }
	              function d3_scaleRange(scale) {
	                return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	              }
	              function d3_scale_bilinear(domain, range2, uninterpolate, interpolate) {
	                var u = uninterpolate(domain[0], domain[1]), i = interpolate(range2[0], range2[1]);
	                return function(x) {
	                  return i(u(x));
	                };
	              }
	              function d3_scale_nice(domain, nice) {
	                var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	                if (x1 < x0) {
	                  dx = i0, i0 = i1, i1 = dx;
	                  dx = x0, x0 = x1, x1 = dx;
	                }
	                domain[i0] = nice.floor(x0);
	                domain[i1] = nice.ceil(x1);
	                return domain;
	              }
	              function d3_scale_niceStep(step) {
	                return step ? {
	                  floor: function(x) {
	                    return Math.floor(x / step) * step;
	                  },
	                  ceil: function(x) {
	                    return Math.ceil(x / step) * step;
	                  }
	                } : d3_scale_niceIdentity;
	              }
	              var d3_scale_niceIdentity = {
	                floor: d3_identity,
	                ceil: d3_identity
	              };
	              function d3_scale_polylinear(domain, range2, uninterpolate, interpolate) {
	                var u = [], i = [], j = 0, k = Math.min(domain.length, range2.length) - 1;
	                if (domain[k] < domain[0]) {
	                  domain = domain.slice().reverse();
	                  range2 = range2.slice().reverse();
	                }
	                while (++j <= k) {
	                  u.push(uninterpolate(domain[j - 1], domain[j]));
	                  i.push(interpolate(range2[j - 1], range2[j]));
	                }
	                return function(x) {
	                  var j2 = d3.bisect(domain, x, 1, k) - 1;
	                  return i[j2](u[j2](x));
	                };
	              }
	              d3.scale.linear = function() {
	                return d3_scale_linear([0, 1], [0, 1], d3_interpolate, false);
	              };
	              function d3_scale_linear(domain, range2, interpolate, clamp) {
	                var output, input;
	                function rescale() {
	                  var linear = Math.min(domain.length, range2.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	                  output = linear(domain, range2, uninterpolate, interpolate);
	                  input = linear(range2, domain, uninterpolate, d3_interpolate);
	                  return scale;
	                }
	                function scale(x) {
	                  return output(x);
	                }
	                scale.invert = function(y) {
	                  return input(y);
	                };
	                scale.domain = function(x) {
	                  if (!arguments.length) return domain;
	                  domain = x.map(Number);
	                  return rescale();
	                };
	                scale.range = function(x) {
	                  if (!arguments.length) return range2;
	                  range2 = x;
	                  return rescale();
	                };
	                scale.rangeRound = function(x) {
	                  return scale.range(x).interpolate(d3_interpolateRound);
	                };
	                scale.clamp = function(x) {
	                  if (!arguments.length) return clamp;
	                  clamp = x;
	                  return rescale();
	                };
	                scale.interpolate = function(x) {
	                  if (!arguments.length) return interpolate;
	                  interpolate = x;
	                  return rescale();
	                };
	                scale.ticks = function(m) {
	                  return d3_scale_linearTicks(domain, m);
	                };
	                scale.tickFormat = function(m, format) {
	                  return d3_scale_linearTickFormat(domain, m, format);
	                };
	                scale.nice = function(m) {
	                  d3_scale_linearNice(domain, m);
	                  return rescale();
	                };
	                scale.copy = function() {
	                  return d3_scale_linear(domain, range2, interpolate, clamp);
	                };
	                return rescale();
	              }
	              function d3_scale_linearRebind(scale, linear) {
	                return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	              }
	              function d3_scale_linearNice(domain, m) {
	                d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	                d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	                return domain;
	              }
	              function d3_scale_linearTickRange(domain, m) {
	                if (m == null) m = 10;
	                var extent2 = d3_scaleExtent(domain), span = extent2[1] - extent2[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	                if (err <= 0.15) step *= 10;
	                else if (err <= 0.35) step *= 5;
	                else if (err <= 0.75) step *= 2;
	                extent2[0] = Math.ceil(extent2[0] / step) * step;
	                extent2[1] = Math.floor(extent2[1] / step) * step + step * 0.5;
	                extent2[2] = step;
	                return extent2;
	              }
	              function d3_scale_linearTicks(domain, m) {
	                return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	              }
	              d3.scale.log = function() {
	                return d3_scale_log(d3.scale.linear().domain([0, 1]), 10, true, [1, 10]);
	              };
	              function d3_scale_log(linear, base, positive, domain) {
	                function log(x) {
	                  return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	                }
	                function pow(x) {
	                  return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	                }
	                function scale(x) {
	                  return linear(log(x));
	                }
	                scale.invert = function(x) {
	                  return pow(linear.invert(x));
	                };
	                scale.domain = function(x) {
	                  if (!arguments.length) return domain;
	                  positive = x[0] >= 0;
	                  linear.domain((domain = x.map(Number)).map(log));
	                  return scale;
	                };
	                scale.base = function(_) {
	                  if (!arguments.length) return base;
	                  base = +_;
	                  linear.domain(domain.map(log));
	                  return scale;
	                };
	                scale.nice = function() {
	                  var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	                  linear.domain(niced);
	                  domain = niced.map(pow);
	                  return scale;
	                };
	                scale.ticks = function() {
	                  var extent2 = d3_scaleExtent(domain), ticks = [], u = extent2[0], v = extent2[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	                  if (isFinite(j - i)) {
	                    if (positive) {
	                      for (; i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	                      ticks.push(pow(i));
	                    } else {
	                      ticks.push(pow(i));
	                      for (; i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	                    }
	                    for (i = 0; ticks[i] < u; i++) {
	                    }
	                    for (j = ticks.length; ticks[j - 1] > v; j--) {
	                    }
	                    ticks = ticks.slice(i, j);
	                  }
	                  return ticks;
	                };
	                scale.copy = function() {
	                  return d3_scale_log(linear.copy(), base, positive, domain);
	                };
	                return d3_scale_linearRebind(scale, linear);
	              }
	              var d3_scale_logNiceNegative = {
	                floor: function(x) {
	                  return -Math.ceil(-x);
	                },
	                ceil: function(x) {
	                  return -Math.floor(-x);
	                }
	              };
	              d3.scale.pow = function() {
	                return d3_scale_pow(d3.scale.linear(), 1, [0, 1]);
	              };
	              function d3_scale_pow(linear, exponent, domain) {
	                var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	                function scale(x) {
	                  return linear(powp(x));
	                }
	                scale.invert = function(x) {
	                  return powb(linear.invert(x));
	                };
	                scale.domain = function(x) {
	                  if (!arguments.length) return domain;
	                  linear.domain((domain = x.map(Number)).map(powp));
	                  return scale;
	                };
	                scale.ticks = function(m) {
	                  return d3_scale_linearTicks(domain, m);
	                };
	                scale.tickFormat = function(m, format) {
	                  return d3_scale_linearTickFormat(domain, m, format);
	                };
	                scale.nice = function(m) {
	                  return scale.domain(d3_scale_linearNice(domain, m));
	                };
	                scale.exponent = function(x) {
	                  if (!arguments.length) return exponent;
	                  powp = d3_scale_powPow(exponent = x);
	                  powb = d3_scale_powPow(1 / exponent);
	                  linear.domain(domain.map(powp));
	                  return scale;
	                };
	                scale.copy = function() {
	                  return d3_scale_pow(linear.copy(), exponent, domain);
	                };
	                return d3_scale_linearRebind(scale, linear);
	              }
	              function d3_scale_powPow(e) {
	                return function(x) {
	                  return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	                };
	              }
	              d3.scale.sqrt = function() {
	                return d3.scale.pow().exponent(0.5);
	              };
	              d3.scale.ordinal = function() {
	                return d3_scale_ordinal([], {
	                  t: "range",
	                  a: [[]]
	                });
	              };
	              function d3_scale_ordinal(domain, ranger) {
	                var index, range2, rangeBand;
	                function scale(x) {
	                  return range2[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range2.length];
	                }
	                function steps(start, step) {
	                  return d3.range(domain.length).map(function(i) {
	                    return start + step * i;
	                  });
	                }
	                scale.domain = function(x) {
	                  if (!arguments.length) return domain;
	                  domain = [];
	                  index = new d3_Map();
	                  var i = -1, n = x.length, xi;
	                  while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	                  return scale[ranger.t].apply(scale, ranger.a);
	                };
	                scale.range = function(x) {
	                  if (!arguments.length) return range2;
	                  range2 = x;
	                  rangeBand = 0;
	                  ranger = {
	                    t: "range",
	                    a: arguments
	                  };
	                  return scale;
	                };
	                scale.rangePoints = function(x, padding) {
	                  if (arguments.length < 2) padding = 0;
	                  var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 0) : (stop - start) / (domain.length - 1 + padding);
	                  range2 = steps(start + step * padding / 2, step);
	                  rangeBand = 0;
	                  ranger = {
	                    t: "rangePoints",
	                    a: arguments
	                  };
	                  return scale;
	                };
	                scale.rangeRoundPoints = function(x, padding) {
	                  if (arguments.length < 2) padding = 0;
	                  var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 0) : (stop - start) / (domain.length - 1 + padding) | 0;
	                  range2 = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	                  rangeBand = 0;
	                  ranger = {
	                    t: "rangeRoundPoints",
	                    a: arguments
	                  };
	                  return scale;
	                };
	                scale.rangeBands = function(x, padding, outerPadding) {
	                  if (arguments.length < 2) padding = 0;
	                  if (arguments.length < 3) outerPadding = padding;
	                  var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	                  range2 = steps(start + step * outerPadding, step);
	                  if (reverse) range2.reverse();
	                  rangeBand = step * (1 - padding);
	                  ranger = {
	                    t: "rangeBands",
	                    a: arguments
	                  };
	                  return scale;
	                };
	                scale.rangeRoundBands = function(x, padding, outerPadding) {
	                  if (arguments.length < 2) padding = 0;
	                  if (arguments.length < 3) outerPadding = padding;
	                  var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	                  range2 = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	                  if (reverse) range2.reverse();
	                  rangeBand = Math.round(step * (1 - padding));
	                  ranger = {
	                    t: "rangeRoundBands",
	                    a: arguments
	                  };
	                  return scale;
	                };
	                scale.rangeBand = function() {
	                  return rangeBand;
	                };
	                scale.rangeExtent = function() {
	                  return d3_scaleExtent(ranger.a[0]);
	                };
	                scale.copy = function() {
	                  return d3_scale_ordinal(domain, ranger);
	                };
	                return scale.domain(domain);
	              }
	              d3.scale.category10 = function() {
	                return d3.scale.ordinal().range(d3_category10);
	              };
	              d3.scale.category20 = function() {
	                return d3.scale.ordinal().range(d3_category20);
	              };
	              d3.scale.category20b = function() {
	                return d3.scale.ordinal().range(d3_category20b);
	              };
	              d3.scale.category20c = function() {
	                return d3.scale.ordinal().range(d3_category20c);
	              };
	              var d3_category10 = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(d3_rgbString);
	              var d3_category20 = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(d3_rgbString);
	              var d3_category20b = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(d3_rgbString);
	              var d3_category20c = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(d3_rgbString);
	              d3.scale.quantile = function() {
	                return d3_scale_quantile([], []);
	              };
	              function d3_scale_quantile(domain, range2) {
	                var thresholds;
	                function rescale() {
	                  var k = 0, q = range2.length;
	                  thresholds = [];
	                  while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	                  return scale;
	                }
	                function scale(x) {
	                  if (!isNaN(x = +x)) return range2[d3.bisect(thresholds, x)];
	                }
	                scale.domain = function(x) {
	                  if (!arguments.length) return domain;
	                  domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	                  return rescale();
	                };
	                scale.range = function(x) {
	                  if (!arguments.length) return range2;
	                  range2 = x;
	                  return rescale();
	                };
	                scale.quantiles = function() {
	                  return thresholds;
	                };
	                scale.invertExtent = function(y) {
	                  y = range2.indexOf(y);
	                  return y < 0 ? [NaN, NaN] : [y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1]];
	                };
	                scale.copy = function() {
	                  return d3_scale_quantile(domain, range2);
	                };
	                return rescale();
	              }
	              d3.scale.quantize = function() {
	                return d3_scale_quantize(0, 1, [0, 1]);
	              };
	              function d3_scale_quantize(x0, x1, range2) {
	                var kx, i;
	                function scale(x) {
	                  return range2[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	                }
	                function rescale() {
	                  kx = range2.length / (x1 - x0);
	                  i = range2.length - 1;
	                  return scale;
	                }
	                scale.domain = function(x) {
	                  if (!arguments.length) return [x0, x1];
	                  x0 = +x[0];
	                  x1 = +x[x.length - 1];
	                  return rescale();
	                };
	                scale.range = function(x) {
	                  if (!arguments.length) return range2;
	                  range2 = x;
	                  return rescale();
	                };
	                scale.invertExtent = function(y) {
	                  y = range2.indexOf(y);
	                  y = y < 0 ? NaN : y / kx + x0;
	                  return [y, y + 1 / kx];
	                };
	                scale.copy = function() {
	                  return d3_scale_quantize(x0, x1, range2);
	                };
	                return rescale();
	              }
	              d3.scale.threshold = function() {
	                return d3_scale_threshold([0.5], [0, 1]);
	              };
	              function d3_scale_threshold(domain, range2) {
	                function scale(x) {
	                  if (x <= x) return range2[d3.bisect(domain, x)];
	                }
	                scale.domain = function(_) {
	                  if (!arguments.length) return domain;
	                  domain = _;
	                  return scale;
	                };
	                scale.range = function(_) {
	                  if (!arguments.length) return range2;
	                  range2 = _;
	                  return scale;
	                };
	                scale.invertExtent = function(y) {
	                  y = range2.indexOf(y);
	                  return [domain[y - 1], domain[y]];
	                };
	                scale.copy = function() {
	                  return d3_scale_threshold(domain, range2);
	                };
	                return scale;
	              }
	              d3.scale.identity = function() {
	                return d3_scale_identity([0, 1]);
	              };
	              function d3_scale_identity(domain) {
	                function identity2(x) {
	                  return +x;
	                }
	                identity2.invert = identity2;
	                identity2.domain = identity2.range = function(x) {
	                  if (!arguments.length) return domain;
	                  domain = x.map(identity2);
	                  return identity2;
	                };
	                identity2.ticks = function(m) {
	                  return d3_scale_linearTicks(domain, m);
	                };
	                identity2.tickFormat = function(m, format) {
	                  return d3_scale_linearTickFormat(domain, m, format);
	                };
	                identity2.copy = function() {
	                  return d3_scale_identity(domain);
	                };
	                return identity2;
	              }
	              d3.svg = {};
	              function d3_zero() {
	                return 0;
	              }
	              d3.svg.arc = function() {
	                var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	                function arc() {
	                  var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	                  if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	                  if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	                  var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	                  if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	                    rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	                    if (!cw) p1 *= -1;
	                    if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	                    if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	                  }
	                  if (r1) {
	                    x0 = r1 * Math.cos(a0 + p1);
	                    y0 = r1 * Math.sin(a0 + p1);
	                    x1 = r1 * Math.cos(a1 - p1);
	                    y1 = r1 * Math.sin(a1 - p1);
	                    var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	                    if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	                      var h1 = (a0 + a1) / 2;
	                      x0 = r1 * Math.cos(h1);
	                      y0 = r1 * Math.sin(h1);
	                      x1 = y1 = null;
	                    }
	                  } else {
	                    x0 = y0 = 0;
	                  }
	                  if (r0) {
	                    x2 = r0 * Math.cos(a1 - p0);
	                    y2 = r0 * Math.sin(a1 - p0);
	                    x3 = r0 * Math.cos(a0 + p0);
	                    y3 = r0 * Math.sin(a0 + p0);
	                    var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	                    if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	                      var h0 = (a0 + a1) / 2;
	                      x2 = r0 * Math.cos(h0);
	                      y2 = r0 * Math.sin(h0);
	                      x3 = y3 = null;
	                    }
	                  } else {
	                    x2 = y2 = 0;
	                  }
	                  if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > 1e-3) {
	                    cr = r0 < r1 ^ cw ? 0 : 1;
	                    var rc1 = rc, rc0 = rc;
	                    if (da < π) {
	                      var oc = x3 == null ? [x2, y2] : x1 == null ? [x0, y0] : d3_geom_polygonIntersect([x0, y0], [x3, y3], [x1, y1], [x2, y2]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	                      rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	                      rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	                    }
	                    if (x1 != null) {
	                      var t30 = d3_svg_arcCornerTangents(x3 == null ? [x2, y2] : [x3, y3], [x0, y0], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([x1, y1], [x2, y2], r1, rc1, cw);
	                      if (rc === rc1) {
	                        path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	                      } else {
	                        path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	                      }
	                    } else {
	                      path.push("M", x0, ",", y0);
	                    }
	                    if (x3 != null) {
	                      var t03 = d3_svg_arcCornerTangents([x0, y0], [x3, y3], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([x2, y2], x1 == null ? [x0, y0] : [x1, y1], r0, -rc0, cw);
	                      if (rc === rc0) {
	                        path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	                      } else {
	                        path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	                      }
	                    } else {
	                      path.push("L", x2, ",", y2);
	                    }
	                  } else {
	                    path.push("M", x0, ",", y0);
	                    if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	                    path.push("L", x2, ",", y2);
	                    if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	                  }
	                  path.push("Z");
	                  return path.join("");
	                }
	                function circleSegment(r1, cw) {
	                  return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	                }
	                arc.innerRadius = function(v) {
	                  if (!arguments.length) return innerRadius;
	                  innerRadius = d3_functor(v);
	                  return arc;
	                };
	                arc.outerRadius = function(v) {
	                  if (!arguments.length) return outerRadius;
	                  outerRadius = d3_functor(v);
	                  return arc;
	                };
	                arc.cornerRadius = function(v) {
	                  if (!arguments.length) return cornerRadius;
	                  cornerRadius = d3_functor(v);
	                  return arc;
	                };
	                arc.padRadius = function(v) {
	                  if (!arguments.length) return padRadius;
	                  padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	                  return arc;
	                };
	                arc.startAngle = function(v) {
	                  if (!arguments.length) return startAngle;
	                  startAngle = d3_functor(v);
	                  return arc;
	                };
	                arc.endAngle = function(v) {
	                  if (!arguments.length) return endAngle;
	                  endAngle = d3_functor(v);
	                  return arc;
	                };
	                arc.padAngle = function(v) {
	                  if (!arguments.length) return padAngle;
	                  padAngle = d3_functor(v);
	                  return arc;
	                };
	                arc.centroid = function() {
	                  var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	                  return [Math.cos(a) * r, Math.sin(a) * r];
	                };
	                return arc;
	              };
	              var d3_svg_arcAuto = "auto";
	              function d3_svg_arcInnerRadius(d) {
	                return d.innerRadius;
	              }
	              function d3_svg_arcOuterRadius(d) {
	                return d.outerRadius;
	              }
	              function d3_svg_arcStartAngle(d) {
	                return d.startAngle;
	              }
	              function d3_svg_arcEndAngle(d) {
	                return d.endAngle;
	              }
	              function d3_svg_arcPadAngle(d) {
	                return d && d.padAngle;
	              }
	              function d3_svg_arcSweep(x0, y0, x1, y1) {
	                return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	              }
	              function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	                var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	                if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	                return [[cx0 - ox, cy0 - oy], [cx0 * r1 / r, cy0 * r1 / r]];
	              }
	              function d3_true() {
	                return true;
	              }
	              function d3_svg_line(projection) {
	                var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = 0.7;
	                function line(data) {
	                  var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	                  function segment() {
	                    segments.push("M", interpolate(projection(points), tension));
	                  }
	                  while (++i < n) {
	                    if (defined.call(this, d = data[i], i)) {
	                      points.push([+fx.call(this, d, i), +fy.call(this, d, i)]);
	                    } else if (points.length) {
	                      segment();
	                      points = [];
	                    }
	                  }
	                  if (points.length) segment();
	                  return segments.length ? segments.join("") : null;
	                }
	                line.x = function(_) {
	                  if (!arguments.length) return x;
	                  x = _;
	                  return line;
	                };
	                line.y = function(_) {
	                  if (!arguments.length) return y;
	                  y = _;
	                  return line;
	                };
	                line.defined = function(_) {
	                  if (!arguments.length) return defined;
	                  defined = _;
	                  return line;
	                };
	                line.interpolate = function(_) {
	                  if (!arguments.length) return interpolateKey;
	                  if (typeof _ === "function") interpolateKey = interpolate = _;
	                  else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	                  return line;
	                };
	                line.tension = function(_) {
	                  if (!arguments.length) return tension;
	                  tension = _;
	                  return line;
	                };
	                return line;
	              }
	              d3.svg.line = function() {
	                return d3_svg_line(d3_identity);
	              };
	              var d3_svg_lineInterpolators = d3.map({
	                linear: d3_svg_lineLinear,
	                "linear-closed": d3_svg_lineLinearClosed,
	                step: d3_svg_lineStep,
	                "step-before": d3_svg_lineStepBefore,
	                "step-after": d3_svg_lineStepAfter,
	                basis: d3_svg_lineBasis,
	                "basis-open": d3_svg_lineBasisOpen,
	                "basis-closed": d3_svg_lineBasisClosed,
	                bundle: d3_svg_lineBundle,
	                cardinal: d3_svg_lineCardinal,
	                "cardinal-open": d3_svg_lineCardinalOpen,
	                "cardinal-closed": d3_svg_lineCardinalClosed,
	                monotone: d3_svg_lineMonotone
	              });
	              d3_svg_lineInterpolators.forEach(function(key, value) {
	                value.key = key;
	                value.closed = /-closed$/.test(key);
	              });
	              function d3_svg_lineLinear(points) {
	                return points.length > 1 ? points.join("L") : points + "Z";
	              }
	              function d3_svg_lineLinearClosed(points) {
	                return points.join("L") + "Z";
	              }
	              function d3_svg_lineStep(points) {
	                var i = 0, n = points.length, p = points[0], path = [p[0], ",", p[1]];
	                while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	                if (n > 1) path.push("H", p[0]);
	                return path.join("");
	              }
	              function d3_svg_lineStepBefore(points) {
	                var i = 0, n = points.length, p = points[0], path = [p[0], ",", p[1]];
	                while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	                return path.join("");
	              }
	              function d3_svg_lineStepAfter(points) {
	                var i = 0, n = points.length, p = points[0], path = [p[0], ",", p[1]];
	                while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	                return path.join("");
	              }
	              function d3_svg_lineCardinalOpen(points, tension) {
	                return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	              }
	              function d3_svg_lineCardinalClosed(points, tension) {
	                return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), points), d3_svg_lineCardinalTangents([points[points.length - 2]].concat(points, [points[1]]), tension));
	              }
	              function d3_svg_lineCardinal(points, tension) {
	                return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	              }
	              function d3_svg_lineHermite(points, tangents) {
	                if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	                  return d3_svg_lineLinear(points);
	                }
	                var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	                if (quad) {
	                  path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	                  p0 = points[1];
	                  pi = 2;
	                }
	                if (tangents.length > 1) {
	                  t = tangents[1];
	                  p = points[pi];
	                  pi++;
	                  path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	                  for (var i = 2; i < tangents.length; i++, pi++) {
	                    p = points[pi];
	                    t = tangents[i];
	                    path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	                  }
	                }
	                if (quad) {
	                  var lp = points[pi];
	                  path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	                }
	                return path;
	              }
	              function d3_svg_lineCardinalTangents(points, tension) {
	                var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	                while (++i < n) {
	                  p0 = p1;
	                  p1 = p2;
	                  p2 = points[i];
	                  tangents.push([a * (p2[0] - p0[0]), a * (p2[1] - p0[1])]);
	                }
	                return tangents;
	              }
	              function d3_svg_lineBasis(points) {
	                if (points.length < 3) return d3_svg_lineLinear(points);
	                var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [x0, x0, x0, (pi = points[1])[0]], py = [y0, y0, y0, pi[1]], path = [x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
	                points.push(points[n - 1]);
	                while (++i <= n) {
	                  pi = points[i];
	                  px.shift();
	                  px.push(pi[0]);
	                  py.shift();
	                  py.push(pi[1]);
	                  d3_svg_lineBasisBezier(path, px, py);
	                }
	                points.pop();
	                path.push("L", pi);
	                return path.join("");
	              }
	              function d3_svg_lineBasisOpen(points) {
	                if (points.length < 4) return d3_svg_lineLinear(points);
	                var path = [], i = -1, n = points.length, pi, px = [0], py = [0];
	                while (++i < 3) {
	                  pi = points[i];
	                  px.push(pi[0]);
	                  py.push(pi[1]);
	                }
	                path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	                --i;
	                while (++i < n) {
	                  pi = points[i];
	                  px.shift();
	                  px.push(pi[0]);
	                  py.shift();
	                  py.push(pi[1]);
	                  d3_svg_lineBasisBezier(path, px, py);
	                }
	                return path.join("");
	              }
	              function d3_svg_lineBasisClosed(points) {
	                var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	                while (++i < 4) {
	                  pi = points[i % n];
	                  px.push(pi[0]);
	                  py.push(pi[1]);
	                }
	                path = [d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
	                --i;
	                while (++i < m) {
	                  pi = points[i % n];
	                  px.shift();
	                  px.push(pi[0]);
	                  py.shift();
	                  py.push(pi[1]);
	                  d3_svg_lineBasisBezier(path, px, py);
	                }
	                return path.join("");
	              }
	              function d3_svg_lineBundle(points, tension) {
	                var n = points.length - 1;
	                if (n) {
	                  var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	                  while (++i <= n) {
	                    p = points[i];
	                    t = i / n;
	                    p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	                    p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	                  }
	                }
	                return d3_svg_lineBasis(points);
	              }
	              function d3_svg_lineDot4(a, b) {
	                return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	              }
	              var d3_svg_lineBasisBezier1 = [0, 2 / 3, 1 / 3, 0], d3_svg_lineBasisBezier2 = [0, 1 / 3, 2 / 3, 0], d3_svg_lineBasisBezier3 = [0, 1 / 6, 2 / 3, 1 / 6];
	              function d3_svg_lineBasisBezier(path, x, y) {
	                path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	              }
	              function d3_svg_lineSlope(p0, p1) {
	                return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	              }
	              function d3_svg_lineFiniteDifferences(points) {
	                var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	                while (++i < j) {
	                  m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	                }
	                m[i] = d;
	                return m;
	              }
	              function d3_svg_lineMonotoneTangents(points) {
	                var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	                while (++i < j) {
	                  d = d3_svg_lineSlope(points[i], points[i + 1]);
	                  if (abs(d) < ε) {
	                    m[i] = m[i + 1] = 0;
	                  } else {
	                    a = m[i] / d;
	                    b = m[i + 1] / d;
	                    s = a * a + b * b;
	                    if (s > 9) {
	                      s = d * 3 / Math.sqrt(s);
	                      m[i] = s * a;
	                      m[i + 1] = s * b;
	                    }
	                  }
	                }
	                i = -1;
	                while (++i <= j) {
	                  s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	                  tangents.push([s || 0, m[i] * s || 0]);
	                }
	                return tangents;
	              }
	              function d3_svg_lineMonotone(points) {
	                return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	              }
	              d3.svg.line.radial = function() {
	                var line = d3_svg_line(d3_svg_lineRadial);
	                line.radius = line.x, delete line.x;
	                line.angle = line.y, delete line.y;
	                return line;
	              };
	              function d3_svg_lineRadial(points) {
	                var point, i = -1, n = points.length, r, a;
	                while (++i < n) {
	                  point = points[i];
	                  r = point[0];
	                  a = point[1] - halfπ;
	                  point[0] = r * Math.cos(a);
	                  point[1] = r * Math.sin(a);
	                }
	                return points;
	              }
	              function d3_svg_area(projection) {
	                var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = 0.7;
	                function area(data) {
	                  var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	                    return x;
	                  } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	                    return y;
	                  } : d3_functor(y1), x, y;
	                  function segment() {
	                    segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	                  }
	                  while (++i < n) {
	                    if (defined.call(this, d = data[i], i)) {
	                      points0.push([x = +fx0.call(this, d, i), y = +fy0.call(this, d, i)]);
	                      points1.push([+fx1.call(this, d, i), +fy1.call(this, d, i)]);
	                    } else if (points0.length) {
	                      segment();
	                      points0 = [];
	                      points1 = [];
	                    }
	                  }
	                  if (points0.length) segment();
	                  return segments.length ? segments.join("") : null;
	                }
	                area.x = function(_) {
	                  if (!arguments.length) return x1;
	                  x0 = x1 = _;
	                  return area;
	                };
	                area.x0 = function(_) {
	                  if (!arguments.length) return x0;
	                  x0 = _;
	                  return area;
	                };
	                area.x1 = function(_) {
	                  if (!arguments.length) return x1;
	                  x1 = _;
	                  return area;
	                };
	                area.y = function(_) {
	                  if (!arguments.length) return y1;
	                  y0 = y1 = _;
	                  return area;
	                };
	                area.y0 = function(_) {
	                  if (!arguments.length) return y0;
	                  y0 = _;
	                  return area;
	                };
	                area.y1 = function(_) {
	                  if (!arguments.length) return y1;
	                  y1 = _;
	                  return area;
	                };
	                area.defined = function(_) {
	                  if (!arguments.length) return defined;
	                  defined = _;
	                  return area;
	                };
	                area.interpolate = function(_) {
	                  if (!arguments.length) return interpolateKey;
	                  if (typeof _ === "function") interpolateKey = interpolate = _;
	                  else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	                  interpolateReverse = interpolate.reverse || interpolate;
	                  L = interpolate.closed ? "M" : "L";
	                  return area;
	                };
	                area.tension = function(_) {
	                  if (!arguments.length) return tension;
	                  tension = _;
	                  return area;
	                };
	                return area;
	              }
	              d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	              d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	              d3.svg.area = function() {
	                return d3_svg_area(d3_identity);
	              };
	              d3.svg.area.radial = function() {
	                var area = d3_svg_area(d3_svg_lineRadial);
	                area.radius = area.x, delete area.x;
	                area.innerRadius = area.x0, delete area.x0;
	                area.outerRadius = area.x1, delete area.x1;
	                area.angle = area.y, delete area.y;
	                area.startAngle = area.y0, delete area.y0;
	                area.endAngle = area.y1, delete area.y1;
	                return area;
	              };
	              function d3_source(d) {
	                return d.source;
	              }
	              function d3_target(d) {
	                return d.target;
	              }
	              d3.svg.chord = function() {
	                var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	                function chord(d, i) {
	                  var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	                  return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	                }
	                function subgroup(self2, f, d, i) {
	                  var subgroup2 = f.call(self2, d, i), r = radius.call(self2, subgroup2, i), a0 = startAngle.call(self2, subgroup2, i) - halfπ, a1 = endAngle.call(self2, subgroup2, i) - halfπ;
	                  return {
	                    r,
	                    a0,
	                    a1,
	                    p0: [r * Math.cos(a0), r * Math.sin(a0)],
	                    p1: [r * Math.cos(a1), r * Math.sin(a1)]
	                  };
	                }
	                function equals(a, b) {
	                  return a.a0 == b.a0 && a.a1 == b.a1;
	                }
	                function arc(r, p, a) {
	                  return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	                }
	                function curve(r0, p0, r1, p1) {
	                  return "Q 0,0 " + p1;
	                }
	                chord.radius = function(v) {
	                  if (!arguments.length) return radius;
	                  radius = d3_functor(v);
	                  return chord;
	                };
	                chord.source = function(v) {
	                  if (!arguments.length) return source;
	                  source = d3_functor(v);
	                  return chord;
	                };
	                chord.target = function(v) {
	                  if (!arguments.length) return target;
	                  target = d3_functor(v);
	                  return chord;
	                };
	                chord.startAngle = function(v) {
	                  if (!arguments.length) return startAngle;
	                  startAngle = d3_functor(v);
	                  return chord;
	                };
	                chord.endAngle = function(v) {
	                  if (!arguments.length) return endAngle;
	                  endAngle = d3_functor(v);
	                  return chord;
	                };
	                return chord;
	              };
	              function d3_svg_chordRadius(d) {
	                return d.radius;
	              }
	              d3.svg.diagonal = function() {
	                var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	                function diagonal(d, i) {
	                  var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [p0, {
	                    x: p0.x,
	                    y: m
	                  }, {
	                    x: p3.x,
	                    y: m
	                  }, p3];
	                  p = p.map(projection);
	                  return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	                }
	                diagonal.source = function(x) {
	                  if (!arguments.length) return source;
	                  source = d3_functor(x);
	                  return diagonal;
	                };
	                diagonal.target = function(x) {
	                  if (!arguments.length) return target;
	                  target = d3_functor(x);
	                  return diagonal;
	                };
	                diagonal.projection = function(x) {
	                  if (!arguments.length) return projection;
	                  projection = x;
	                  return diagonal;
	                };
	                return diagonal;
	              };
	              function d3_svg_diagonalProjection(d) {
	                return [d.x, d.y];
	              }
	              d3.svg.diagonal.radial = function() {
	                var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	                diagonal.projection = function(x) {
	                  return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	                };
	                return diagonal;
	              };
	              function d3_svg_diagonalRadialProjection(projection) {
	                return function() {
	                  var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	                  return [r * Math.cos(a), r * Math.sin(a)];
	                };
	              }
	              d3.svg.symbol = function() {
	                var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	                function symbol(d, i) {
	                  return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	                }
	                symbol.type = function(x) {
	                  if (!arguments.length) return type;
	                  type = d3_functor(x);
	                  return symbol;
	                };
	                symbol.size = function(x) {
	                  if (!arguments.length) return size;
	                  size = d3_functor(x);
	                  return symbol;
	                };
	                return symbol;
	              };
	              function d3_svg_symbolSize() {
	                return 64;
	              }
	              function d3_svg_symbolType() {
	                return "circle";
	              }
	              function d3_svg_symbolCircle(size) {
	                var r = Math.sqrt(size / π);
	                return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	              }
	              var d3_svg_symbols = d3.map({
	                circle: d3_svg_symbolCircle,
	                cross: function(size) {
	                  var r = Math.sqrt(size / 5) / 2;
	                  return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	                },
	                diamond: function(size) {
	                  var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	                  return "M0," + -ry + "L" + rx + ",0 0," + ry + " " + -rx + ",0Z";
	                },
	                square: function(size) {
	                  var r = Math.sqrt(size) / 2;
	                  return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	                },
	                "triangle-down": function(size) {
	                  var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	                  return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	                },
	                "triangle-up": function(size) {
	                  var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	                  return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	                }
	              });
	              d3.svg.symbolTypes = d3_svg_symbols.keys();
	              var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	              d3_selectionPrototype.transition = function(name2) {
	                var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name2), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	                  time: Date.now(),
	                  ease: d3_ease_cubicInOut,
	                  delay: 0,
	                  duration: 250
	                };
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  subgroups.push(subgroup = []);
	                  for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	                    if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	                    subgroup.push(node);
	                  }
	                }
	                return d3_transition(subgroups, ns, id);
	              };
	              d3_selectionPrototype.interrupt = function(name2) {
	                return this.each(name2 == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name2)));
	              };
	              var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	              function d3_selection_interruptNS(ns) {
	                return function() {
	                  var lock, activeId, active;
	                  if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	                    active.timer.c = null;
	                    active.timer.t = NaN;
	                    if (--lock.count) delete lock[activeId];
	                    else delete this[ns];
	                    lock.active += 0.5;
	                    active.event && active.event.interrupt.call(this, this.__data__, active.index);
	                  }
	                };
	              }
	              function d3_transition(groups, ns, id) {
	                d3_subclass(groups, d3_transitionPrototype);
	                groups.namespace = ns;
	                groups.id = id;
	                return groups;
	              }
	              var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	              d3_transitionPrototype.call = d3_selectionPrototype.call;
	              d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	              d3_transitionPrototype.node = d3_selectionPrototype.node;
	              d3_transitionPrototype.size = d3_selectionPrototype.size;
	              d3.transition = function(selection, name2) {
	                return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name2) : selection : d3.selection().transition(selection);
	              };
	              d3.transition.prototype = d3_transitionPrototype;
	              d3_transitionPrototype.select = function(selector) {
	                var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	                selector = d3_selection_selector(selector);
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  subgroups.push(subgroup = []);
	                  for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	                    if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	                      if ("__data__" in node) subnode.__data__ = node.__data__;
	                      d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	                      subgroup.push(subnode);
	                    } else {
	                      subgroup.push(null);
	                    }
	                  }
	                }
	                return d3_transition(subgroups, ns, id);
	              };
	              d3_transitionPrototype.selectAll = function(selector) {
	                var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	                selector = d3_selection_selectorAll(selector);
	                for (var j = -1, m = this.length; ++j < m; ) {
	                  for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	                    if (node = group[i]) {
	                      transition = node[ns][id];
	                      subnodes = selector.call(node, node.__data__, i, j);
	                      subgroups.push(subgroup = []);
	                      for (var k = -1, o = subnodes.length; ++k < o; ) {
	                        if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	                        subgroup.push(subnode);
	                      }
	                    }
	                  }
	                }
	                return d3_transition(subgroups, ns, id);
	              };
	              d3_transitionPrototype.filter = function(filter) {
	                var subgroups = [], subgroup, group, node;
	                if (typeof filter !== "function") filter = d3_selection_filter(filter);
	                for (var j = 0, m = this.length; j < m; j++) {
	                  subgroups.push(subgroup = []);
	                  for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	                    if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	                      subgroup.push(node);
	                    }
	                  }
	                }
	                return d3_transition(subgroups, this.namespace, this.id);
	              };
	              d3_transitionPrototype.tween = function(name2, tween) {
	                var id = this.id, ns = this.namespace;
	                if (arguments.length < 2) return this.node()[ns][id].tween.get(name2);
	                return d3_selection_each(this, tween == null ? function(node) {
	                  node[ns][id].tween.remove(name2);
	                } : function(node) {
	                  node[ns][id].tween.set(name2, tween);
	                });
	              };
	              function d3_transition_tween(groups, name2, value, tween) {
	                var id = groups.id, ns = groups.namespace;
	                return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	                  node[ns][id].tween.set(name2, tween(value.call(node, node.__data__, i, j)));
	                } : (value = tween(value), function(node) {
	                  node[ns][id].tween.set(name2, value);
	                }));
	              }
	              d3_transitionPrototype.attr = function(nameNS, value) {
	                if (arguments.length < 2) {
	                  for (value in nameNS) this.attr(value, nameNS[value]);
	                  return this;
	                }
	                var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name2 = d3.ns.qualify(nameNS);
	                function attrNull() {
	                  this.removeAttribute(name2);
	                }
	                function attrNullNS() {
	                  this.removeAttributeNS(name2.space, name2.local);
	                }
	                function attrTween(b) {
	                  return b == null ? attrNull : (b += "", function() {
	                    var a = this.getAttribute(name2), i;
	                    return a !== b && (i = interpolate(a, b), function(t) {
	                      this.setAttribute(name2, i(t));
	                    });
	                  });
	                }
	                function attrTweenNS(b) {
	                  return b == null ? attrNullNS : (b += "", function() {
	                    var a = this.getAttributeNS(name2.space, name2.local), i;
	                    return a !== b && (i = interpolate(a, b), function(t) {
	                      this.setAttributeNS(name2.space, name2.local, i(t));
	                    });
	                  });
	                }
	                return d3_transition_tween(this, "attr." + nameNS, value, name2.local ? attrTweenNS : attrTween);
	              };
	              d3_transitionPrototype.attrTween = function(nameNS, tween) {
	                var name2 = d3.ns.qualify(nameNS);
	                function attrTween(d, i) {
	                  var f = tween.call(this, d, i, this.getAttribute(name2));
	                  return f && function(t) {
	                    this.setAttribute(name2, f(t));
	                  };
	                }
	                function attrTweenNS(d, i) {
	                  var f = tween.call(this, d, i, this.getAttributeNS(name2.space, name2.local));
	                  return f && function(t) {
	                    this.setAttributeNS(name2.space, name2.local, f(t));
	                  };
	                }
	                return this.tween("attr." + nameNS, name2.local ? attrTweenNS : attrTween);
	              };
	              d3_transitionPrototype.style = function(name2, value, priority) {
	                var n = arguments.length;
	                if (n < 3) {
	                  if (typeof name2 !== "string") {
	                    if (n < 2) value = "";
	                    for (priority in name2) this.style(priority, name2[priority], value);
	                    return this;
	                  }
	                  priority = "";
	                }
	                function styleNull() {
	                  this.style.removeProperty(name2);
	                }
	                function styleString(b) {
	                  return b == null ? styleNull : (b += "", function() {
	                    var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name2), i;
	                    return a !== b && (i = d3_interpolate(a, b), function(t) {
	                      this.style.setProperty(name2, i(t), priority);
	                    });
	                  });
	                }
	                return d3_transition_tween(this, "style." + name2, value, styleString);
	              };
	              d3_transitionPrototype.styleTween = function(name2, tween, priority) {
	                if (arguments.length < 3) priority = "";
	                function styleTween(d, i) {
	                  var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name2));
	                  return f && function(t) {
	                    this.style.setProperty(name2, f(t), priority);
	                  };
	                }
	                return this.tween("style." + name2, styleTween);
	              };
	              d3_transitionPrototype.text = function(value) {
	                return d3_transition_tween(this, "text", value, d3_transition_text);
	              };
	              function d3_transition_text(b) {
	                if (b == null) b = "";
	                return function() {
	                  this.textContent = b;
	                };
	              }
	              d3_transitionPrototype.remove = function() {
	                var ns = this.namespace;
	                return this.each("end.transition", function() {
	                  var p;
	                  if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	                });
	              };
	              d3_transitionPrototype.ease = function(value) {
	                var id = this.id, ns = this.namespace;
	                if (arguments.length < 1) return this.node()[ns][id].ease;
	                if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	                return d3_selection_each(this, function(node) {
	                  node[ns][id].ease = value;
	                });
	              };
	              d3_transitionPrototype.delay = function(value) {
	                var id = this.id, ns = this.namespace;
	                if (arguments.length < 1) return this.node()[ns][id].delay;
	                return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	                  node[ns][id].delay = +value.call(node, node.__data__, i, j);
	                } : (value = +value, function(node) {
	                  node[ns][id].delay = value;
	                }));
	              };
	              d3_transitionPrototype.duration = function(value) {
	                var id = this.id, ns = this.namespace;
	                if (arguments.length < 1) return this.node()[ns][id].duration;
	                return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	                  node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	                } : (value = Math.max(1, value), function(node) {
	                  node[ns][id].duration = value;
	                }));
	              };
	              d3_transitionPrototype.each = function(type, listener) {
	                var id = this.id, ns = this.namespace;
	                if (arguments.length < 2) {
	                  var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	                  try {
	                    d3_transitionInheritId = id;
	                    d3_selection_each(this, function(node, i, j) {
	                      d3_transitionInherit = node[ns][id];
	                      type.call(node, node.__data__, i, j);
	                    });
	                  } finally {
	                    d3_transitionInherit = inherit;
	                    d3_transitionInheritId = inheritId;
	                  }
	                } else {
	                  d3_selection_each(this, function(node) {
	                    var transition = node[ns][id];
	                    (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	                  });
	                }
	                return this;
	              };
	              d3_transitionPrototype.transition = function() {
	                var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	                for (var j = 0, m = this.length; j < m; j++) {
	                  subgroups.push(subgroup = []);
	                  for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	                    if (node = group[i]) {
	                      transition = node[ns][id0];
	                      d3_transitionNode(node, i, ns, id1, {
	                        time: transition.time,
	                        ease: transition.ease,
	                        delay: transition.delay + transition.duration,
	                        duration: transition.duration
	                      });
	                    }
	                    subgroup.push(node);
	                  }
	                }
	                return d3_transition(subgroups, ns, id1);
	              };
	              function d3_transitionNamespace(name2) {
	                return name2 == null ? "__transition__" : "__transition_" + name2 + "__";
	              }
	              function d3_transitionNode(node, i, ns, id, inherit) {
	                var lock = node[ns] || (node[ns] = {
	                  active: 0,
	                  count: 0
	                }), transition = lock[id], time, timer, duration, ease, tweens;
	                function schedule(elapsed) {
	                  var delay = transition.delay;
	                  timer.t = delay + time;
	                  if (delay <= elapsed) return start(elapsed - delay);
	                  timer.c = start;
	                }
	                function start(elapsed) {
	                  var activeId = lock.active, active = lock[activeId];
	                  if (active) {
	                    active.timer.c = null;
	                    active.timer.t = NaN;
	                    --lock.count;
	                    delete lock[activeId];
	                    active.event && active.event.interrupt.call(node, node.__data__, active.index);
	                  }
	                  for (var cancelId in lock) {
	                    if (+cancelId < id) {
	                      var cancel = lock[cancelId];
	                      cancel.timer.c = null;
	                      cancel.timer.t = NaN;
	                      --lock.count;
	                      delete lock[cancelId];
	                    }
	                  }
	                  timer.c = tick;
	                  d3_timer(function() {
	                    if (timer.c && tick(elapsed || 1)) {
	                      timer.c = null;
	                      timer.t = NaN;
	                    }
	                    return 1;
	                  }, 0, time);
	                  lock.active = id;
	                  transition.event && transition.event.start.call(node, node.__data__, i);
	                  tweens = [];
	                  transition.tween.forEach(function(key, value) {
	                    if (value = value.call(node, node.__data__, i)) {
	                      tweens.push(value);
	                    }
	                  });
	                  ease = transition.ease;
	                  duration = transition.duration;
	                }
	                function tick(elapsed) {
	                  var t = elapsed / duration, e = ease(t), n = tweens.length;
	                  while (n > 0) {
	                    tweens[--n].call(node, e);
	                  }
	                  if (t >= 1) {
	                    transition.event && transition.event.end.call(node, node.__data__, i);
	                    if (--lock.count) delete lock[id];
	                    else delete node[ns];
	                    return 1;
	                  }
	                }
	                if (!transition) {
	                  time = inherit.time;
	                  timer = d3_timer(schedule, 0, time);
	                  transition = lock[id] = {
	                    tween: new d3_Map(),
	                    time,
	                    timer,
	                    delay: inherit.delay,
	                    duration: inherit.duration,
	                    ease: inherit.ease,
	                    index: i
	                  };
	                  inherit = null;
	                  ++lock.count;
	                }
	              }
	              d3.svg.axis = function() {
	                var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [10], tickValues = null, tickFormat_;
	                function axis(g) {
	                  g.each(function() {
	                    var g2 = d3.select(this);
	                    var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	                    var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g2.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	                    var range2 = d3_scaleRange(scale1), path = g2.selectAll(".domain").data([0]), pathUpdate = (path.enter().append("path").attr("class", "domain"), d3.transition(path));
	                    tickEnter.append("line");
	                    tickEnter.append("text");
	                    var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	                    if (orient === "bottom" || orient === "top") {
	                      tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	                      text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	                      pathUpdate.attr("d", "M" + range2[0] + "," + sign * outerTickSize + "V0H" + range2[1] + "V" + sign * outerTickSize);
	                    } else {
	                      tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	                      text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	                      pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range2[0] + "H0V" + range2[1] + "H" + sign * outerTickSize);
	                    }
	                    lineEnter.attr(y2, sign * innerTickSize);
	                    textEnter.attr(y1, sign * tickSpacing);
	                    lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	                    textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	                    if (scale1.rangeBand) {
	                      var x = scale1, dx = x.rangeBand() / 2;
	                      scale0 = scale1 = function(d) {
	                        return x(d) + dx;
	                      };
	                    } else if (scale0.rangeBand) {
	                      scale0 = scale1;
	                    } else {
	                      tickExit.call(tickTransform, scale1, scale0);
	                    }
	                    tickEnter.call(tickTransform, scale0, scale1);
	                    tickUpdate.call(tickTransform, scale1, scale1);
	                  });
	                }
	                axis.scale = function(x) {
	                  if (!arguments.length) return scale;
	                  scale = x;
	                  return axis;
	                };
	                axis.orient = function(x) {
	                  if (!arguments.length) return orient;
	                  orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	                  return axis;
	                };
	                axis.ticks = function() {
	                  if (!arguments.length) return tickArguments_;
	                  tickArguments_ = d3_array(arguments);
	                  return axis;
	                };
	                axis.tickValues = function(x) {
	                  if (!arguments.length) return tickValues;
	                  tickValues = x;
	                  return axis;
	                };
	                axis.tickFormat = function(x) {
	                  if (!arguments.length) return tickFormat_;
	                  tickFormat_ = x;
	                  return axis;
	                };
	                axis.tickSize = function(x) {
	                  var n = arguments.length;
	                  if (!n) return innerTickSize;
	                  innerTickSize = +x;
	                  outerTickSize = +arguments[n - 1];
	                  return axis;
	                };
	                axis.innerTickSize = function(x) {
	                  if (!arguments.length) return innerTickSize;
	                  innerTickSize = +x;
	                  return axis;
	                };
	                axis.outerTickSize = function(x) {
	                  if (!arguments.length) return outerTickSize;
	                  outerTickSize = +x;
	                  return axis;
	                };
	                axis.tickPadding = function(x) {
	                  if (!arguments.length) return tickPadding;
	                  tickPadding = +x;
	                  return axis;
	                };
	                axis.tickSubdivide = function() {
	                  return arguments.length && axis;
	                };
	                return axis;
	              };
	              var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	                top: 1,
	                right: 1,
	                bottom: 1,
	                left: 1
	              };
	              function d3_svg_axisX(selection, x0, x1) {
	                selection.attr("transform", function(d) {
	                  var v0 = x0(d);
	                  return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	                });
	              }
	              function d3_svg_axisY(selection, y0, y1) {
	                selection.attr("transform", function(d) {
	                  var v0 = y0(d);
	                  return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	                });
	              }
	              d3.svg.brush = function() {
	                var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [0, 0], yExtent = [0, 0], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	                function brush(g) {
	                  g.each(function() {
	                    var g2 = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	                    var background = g2.selectAll(".background").data([0]);
	                    background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	                    g2.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	                    var resize = g2.selectAll(".resize").data(resizes, d3_identity);
	                    resize.exit().remove();
	                    resize.enter().append("g").attr("class", function(d) {
	                      return "resize " + d;
	                    }).style("cursor", function(d) {
	                      return d3_svg_brushCursor[d];
	                    }).append("rect").attr("x", function(d) {
	                      return /[ew]$/.test(d) ? -3 : null;
	                    }).attr("y", function(d) {
	                      return /^[ns]/.test(d) ? -3 : null;
	                    }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	                    resize.style("display", brush.empty() ? "none" : null);
	                    var gUpdate = d3.transition(g2), backgroundUpdate = d3.transition(background), range2;
	                    if (x) {
	                      range2 = d3_scaleRange(x);
	                      backgroundUpdate.attr("x", range2[0]).attr("width", range2[1] - range2[0]);
	                      redrawX(gUpdate);
	                    }
	                    if (y) {
	                      range2 = d3_scaleRange(y);
	                      backgroundUpdate.attr("y", range2[0]).attr("height", range2[1] - range2[0]);
	                      redrawY(gUpdate);
	                    }
	                    redraw(gUpdate);
	                  });
	                }
	                brush.event = function(g) {
	                  g.each(function() {
	                    var event_ = event.of(this, arguments), extent1 = {
	                      x: xExtent,
	                      y: yExtent,
	                      i: xExtentDomain,
	                      j: yExtentDomain
	                    }, extent0 = this.__chart__ || extent1;
	                    this.__chart__ = extent1;
	                    if (d3_transitionInheritId) {
	                      d3.select(this).transition().each("start.brush", function() {
	                        xExtentDomain = extent0.i;
	                        yExtentDomain = extent0.j;
	                        xExtent = extent0.x;
	                        yExtent = extent0.y;
	                        event_({
	                          type: "brushstart"
	                        });
	                      }).tween("brush:brush", function() {
	                        var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	                        xExtentDomain = yExtentDomain = null;
	                        return function(t) {
	                          xExtent = extent1.x = xi(t);
	                          yExtent = extent1.y = yi(t);
	                          event_({
	                            type: "brush",
	                            mode: "resize"
	                          });
	                        };
	                      }).each("end.brush", function() {
	                        xExtentDomain = extent1.i;
	                        yExtentDomain = extent1.j;
	                        event_({
	                          type: "brush",
	                          mode: "resize"
	                        });
	                        event_({
	                          type: "brushend"
	                        });
	                      });
	                    } else {
	                      event_({
	                        type: "brushstart"
	                      });
	                      event_({
	                        type: "brush",
	                        mode: "resize"
	                      });
	                      event_({
	                        type: "brushend"
	                      });
	                    }
	                  });
	                };
	                function redraw(g) {
	                  g.selectAll(".resize").attr("transform", function(d) {
	                    return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	                  });
	                }
	                function redrawX(g) {
	                  g.select(".extent").attr("x", xExtent[0]);
	                  g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	                }
	                function redrawY(g) {
	                  g.select(".extent").attr("y", yExtent[0]);
	                  g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	                }
	                function brushstart() {
	                  var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	                  var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	                  if (d3.event.changedTouches) {
	                    w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	                  } else {
	                    w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	                  }
	                  g.interrupt().selectAll("*").interrupt();
	                  if (dragging) {
	                    origin[0] = xExtent[0] - origin[0];
	                    origin[1] = yExtent[0] - origin[1];
	                  } else if (resizing) {
	                    var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	                    offset = [xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1]];
	                    origin[0] = xExtent[ex];
	                    origin[1] = yExtent[ey];
	                  } else if (d3.event.altKey) center = origin.slice();
	                  g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	                  d3.select("body").style("cursor", eventTarget.style("cursor"));
	                  event_({
	                    type: "brushstart"
	                  });
	                  brushmove();
	                  function keydown() {
	                    if (d3.event.keyCode == 32) {
	                      if (!dragging) {
	                        center = null;
	                        origin[0] -= xExtent[1];
	                        origin[1] -= yExtent[1];
	                        dragging = 2;
	                      }
	                      d3_eventPreventDefault();
	                    }
	                  }
	                  function keyup() {
	                    if (d3.event.keyCode == 32 && dragging == 2) {
	                      origin[0] += xExtent[1];
	                      origin[1] += yExtent[1];
	                      dragging = 0;
	                      d3_eventPreventDefault();
	                    }
	                  }
	                  function brushmove() {
	                    var point = d3.mouse(target), moved = false;
	                    if (offset) {
	                      point[0] += offset[0];
	                      point[1] += offset[1];
	                    }
	                    if (!dragging) {
	                      if (d3.event.altKey) {
	                        if (!center) center = [(xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2];
	                        origin[0] = xExtent[+(point[0] < center[0])];
	                        origin[1] = yExtent[+(point[1] < center[1])];
	                      } else center = null;
	                    }
	                    if (resizingX && move1(point, x, 0)) {
	                      redrawX(g);
	                      moved = true;
	                    }
	                    if (resizingY && move1(point, y, 1)) {
	                      redrawY(g);
	                      moved = true;
	                    }
	                    if (moved) {
	                      redraw(g);
	                      event_({
	                        type: "brush",
	                        mode: dragging ? "move" : "resize"
	                      });
	                    }
	                  }
	                  function move1(point, scale, i) {
	                    var range2 = d3_scaleRange(scale), r0 = range2[0], r1 = range2[1], position = origin[i], extent2 = i ? yExtent : xExtent, size = extent2[1] - extent2[0], min, max;
	                    if (dragging) {
	                      r0 -= position;
	                      r1 -= size + position;
	                    }
	                    min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	                    if (dragging) {
	                      max = (min += position) + size;
	                    } else {
	                      if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	                      if (position < min) {
	                        max = min;
	                        min = position;
	                      } else {
	                        max = position;
	                      }
	                    }
	                    if (extent2[0] != min || extent2[1] != max) {
	                      if (i) yExtentDomain = null;
	                      else xExtentDomain = null;
	                      extent2[0] = min;
	                      extent2[1] = max;
	                      return true;
	                    }
	                  }
	                  function brushend() {
	                    brushmove();
	                    g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	                    d3.select("body").style("cursor", null);
	                    w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	                    dragRestore();
	                    event_({
	                      type: "brushend"
	                    });
	                  }
	                }
	                brush.x = function(z) {
	                  if (!arguments.length) return x;
	                  x = z;
	                  resizes = d3_svg_brushResizes[!x << 1 | !y];
	                  return brush;
	                };
	                brush.y = function(z) {
	                  if (!arguments.length) return y;
	                  y = z;
	                  resizes = d3_svg_brushResizes[!x << 1 | !y];
	                  return brush;
	                };
	                brush.clamp = function(z) {
	                  if (!arguments.length) return x && y ? [xClamp, yClamp] : x ? xClamp : y ? yClamp : null;
	                  if (x && y) xClamp = !!z[0], yClamp = !!z[1];
	                  else if (x) xClamp = !!z;
	                  else if (y) yClamp = !!z;
	                  return brush;
	                };
	                brush.extent = function(z) {
	                  var x0, x1, y0, y1, t;
	                  if (!arguments.length) {
	                    if (x) {
	                      if (xExtentDomain) {
	                        x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	                      } else {
	                        x0 = xExtent[0], x1 = xExtent[1];
	                        if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	                        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	                      }
	                    }
	                    if (y) {
	                      if (yExtentDomain) {
	                        y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	                      } else {
	                        y0 = yExtent[0], y1 = yExtent[1];
	                        if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	                        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	                      }
	                    }
	                    return x && y ? [[x0, y0], [x1, y1]] : x ? [x0, x1] : y && [y0, y1];
	                  }
	                  if (x) {
	                    x0 = z[0], x1 = z[1];
	                    if (y) x0 = x0[0], x1 = x1[0];
	                    xExtentDomain = [x0, x1];
	                    if (x.invert) x0 = x(x0), x1 = x(x1);
	                    if (x1 < x0) t = x0, x0 = x1, x1 = t;
	                    if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [x0, x1];
	                  }
	                  if (y) {
	                    y0 = z[0], y1 = z[1];
	                    if (x) y0 = y0[1], y1 = y1[1];
	                    yExtentDomain = [y0, y1];
	                    if (y.invert) y0 = y(y0), y1 = y(y1);
	                    if (y1 < y0) t = y0, y0 = y1, y1 = t;
	                    if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [y0, y1];
	                  }
	                  return brush;
	                };
	                brush.clear = function() {
	                  if (!brush.empty()) {
	                    xExtent = [0, 0], yExtent = [0, 0];
	                    xExtentDomain = yExtentDomain = null;
	                  }
	                  return brush;
	                };
	                brush.empty = function() {
	                  return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	                };
	                return d3.rebind(brush, event, "on");
	              };
	              var d3_svg_brushCursor = {
	                n: "ns-resize",
	                e: "ew-resize",
	                s: "ns-resize",
	                w: "ew-resize",
	                nw: "nwse-resize",
	                ne: "nesw-resize",
	                se: "nwse-resize",
	                sw: "nesw-resize"
	              };
	              var d3_svg_brushResizes = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
	              d3.text = d3_xhrType(function(request) {
	                return request.responseText;
	              });
	              d3.json = function(url, callback) {
	                return d3_xhr(url, "application/json", d3_json, callback);
	              };
	              function d3_json(request) {
	                return JSON.parse(request.responseText);
	              }
	              d3.html = function(url, callback) {
	                return d3_xhr(url, "text/html", d3_html, callback);
	              };
	              function d3_html(request) {
	                var range2 = d3_document.createRange();
	                range2.selectNode(d3_document.body);
	                return range2.createContextualFragment(request.responseText);
	              }
	              d3.xml = d3_xhrType(function(request) {
	                return request.responseXML;
	              });
	              !(__WEBPACK_AMD_DEFINE_FACTORY__ = d3, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports2, __webpack_require__2, exports2, module2) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module2.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	            }.apply(self);
	          }
	        ),
	        /***/
	        88294: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(62849);
	          }
	        ),
	        /***/
	        62849: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var search = __webpack_require__2(91358);
	            var clamp = __webpack_require__2(53435);
	            var rect = __webpack_require__2(18863);
	            var getBounds = __webpack_require__2(21527);
	            var pick = __webpack_require__2(71299);
	            var defined = __webpack_require__2(46775);
	            var flatten = __webpack_require__2(30120);
	            var isObj = __webpack_require__2(64941);
	            var dtype = __webpack_require__2(90660);
	            var log2 = __webpack_require__2(27084);
	            var MAX_GROUP_ID = 1073741824;
	            module2.exports = function cluster(srcPoints, options) {
	              if (!options) {
	                options = {};
	              }
	              srcPoints = flatten(srcPoints, "float64");
	              options = pick(options, {
	                bounds: "range bounds dataBox databox",
	                maxDepth: "depth maxDepth maxdepth level maxLevel maxlevel levels",
	                dtype: "type dtype format out dst output destination"
	                // sort: 'sortBy sortby sort',
	                // pick: 'pick levelPoint',
	                // nodeSize: 'node nodeSize minNodeSize minSize size'
	              });
	              var maxDepth = defined(options.maxDepth, 255);
	              var bounds = defined(options.bounds, getBounds(srcPoints, 2));
	              if (bounds[0] === bounds[2]) {
	                bounds[2]++;
	              }
	              if (bounds[1] === bounds[3]) {
	                bounds[3]++;
	              }
	              var points = normalize(srcPoints, bounds);
	              var n = srcPoints.length >>> 1;
	              var ids;
	              if (!options.dtype) {
	                options.dtype = "array";
	              }
	              if (typeof options.dtype === "string") {
	                ids = new (dtype(options.dtype))(n);
	              } else if (options.dtype) {
	                ids = options.dtype;
	                if (Array.isArray(ids)) {
	                  ids.length = n;
	                }
	              }
	              for (var i = 0; i < n; ++i) {
	                ids[i] = i;
	              }
	              var levels = [];
	              var sublevels = [];
	              var groups = [];
	              var offsets = [];
	              sort(0, 0, 1, ids, 0, 1);
	              var offset = 0;
	              for (var level = 0; level < levels.length; level++) {
	                var levelItems = levels[level];
	                if (ids.set) {
	                  ids.set(levelItems, offset);
	                } else {
	                  for (var i$1 = 0, l = levelItems.length; i$1 < l; i$1++) {
	                    ids[i$1 + offset] = levelItems[i$1];
	                  }
	                }
	                var nextOffset = offset + levels[level].length;
	                offsets[level] = [offset, nextOffset];
	                offset = nextOffset;
	              }
	              ids.range = range2;
	              return ids;
	              function sort(x, y, diam, ids2, level2, group2) {
	                if (!ids2.length) {
	                  return null;
	                }
	                var levelItems2 = levels[level2] || (levels[level2] = []);
	                var levelGroups = groups[level2] || (groups[level2] = []);
	                var sublevel = sublevels[level2] || (sublevels[level2] = []);
	                var offset2 = levelItems2.length;
	                level2++;
	                if (level2 > maxDepth || group2 > MAX_GROUP_ID) {
	                  for (var i2 = 0; i2 < ids2.length; i2++) {
	                    levelItems2.push(ids2[i2]);
	                    levelGroups.push(group2);
	                    sublevel.push(null, null, null, null);
	                  }
	                  return offset2;
	                }
	                levelItems2.push(ids2[0]);
	                levelGroups.push(group2);
	                if (ids2.length <= 1) {
	                  sublevel.push(null, null, null, null);
	                  return offset2;
	                }
	                var d2 = diam * 0.5;
	                var cx = x + d2, cy = y + d2;
	                var lolo = [], lohi = [], hilo = [], hihi = [];
	                for (var i$12 = 1, l2 = ids2.length; i$12 < l2; i$12++) {
	                  var idx = ids2[i$12], x$1 = points[idx * 2], y$1 = points[idx * 2 + 1];
	                  x$1 < cx ? y$1 < cy ? lolo.push(idx) : lohi.push(idx) : y$1 < cy ? hilo.push(idx) : hihi.push(idx);
	                }
	                group2 <<= 2;
	                sublevel.push(
	                  sort(x, y, d2, lolo, level2, group2),
	                  sort(x, cy, d2, lohi, level2, group2 + 1),
	                  sort(cx, y, d2, hilo, level2, group2 + 2),
	                  sort(cx, cy, d2, hihi, level2, group2 + 3)
	                );
	                return offset2;
	              }
	              function range2() {
	                var args = [], len = arguments.length;
	                while (len--) args[len] = arguments[len];
	                var options2;
	                if (isObj(args[args.length - 1])) {
	                  var arg = args.pop();
	                  if (!args.length && (arg.x != null || arg.l != null || arg.left != null)) {
	                    args = [arg];
	                    options2 = {};
	                  }
	                  options2 = pick(arg, {
	                    level: "level maxLevel",
	                    d: "d diam diameter r radius px pxSize pixel pixelSize maxD size minSize",
	                    lod: "lod details ranges offsets"
	                  });
	                } else {
	                  options2 = {};
	                }
	                if (!args.length) {
	                  args = bounds;
	                }
	                var box = rect.apply(undefined, args);
	                var ref = [
	                  Math.min(box.x, box.x + box.width),
	                  Math.min(box.y, box.y + box.height),
	                  Math.max(box.x, box.x + box.width),
	                  Math.max(box.y, box.y + box.height)
	                ];
	                var minX = ref[0];
	                var minY = ref[1];
	                var maxX = ref[2];
	                var maxY = ref[3];
	                var ref$1 = normalize([minX, minY, maxX, maxY], bounds);
	                var nminX = ref$1[0];
	                var nminY = ref$1[1];
	                var nmaxX = ref$1[2];
	                var nmaxY = ref$1[3];
	                var maxLevel = defined(options2.level, levels.length);
	                if (options2.d != null) {
	                  var d;
	                  if (typeof options2.d === "number") {
	                    d = [options2.d, options2.d];
	                  } else if (options2.d.length) {
	                    d = options2.d;
	                  }
	                  maxLevel = Math.min(
	                    Math.max(
	                      Math.ceil(-log2(Math.abs(d[0]) / (bounds[2] - bounds[0]))),
	                      Math.ceil(-log2(Math.abs(d[1]) / (bounds[3] - bounds[1])))
	                    ),
	                    maxLevel
	                  );
	                }
	                maxLevel = Math.min(maxLevel, levels.length);
	                if (options2.lod) {
	                  return lod(nminX, nminY, nmaxX, nmaxY, maxLevel);
	                }
	                var selection = [];
	                select(0, 0, 1, 0, 0, 1);
	                function select(lox, loy, d2, level2, from, to) {
	                  if (from === null || to === null) {
	                    return;
	                  }
	                  var hix = lox + d2;
	                  var hiy = loy + d2;
	                  if (nminX > hix || nminY > hiy || nmaxX < lox || nmaxY < loy) {
	                    return;
	                  }
	                  if (level2 >= maxLevel) {
	                    return;
	                  }
	                  if (from === to) {
	                    return;
	                  }
	                  var levelItems2 = levels[level2];
	                  if (to === undefined) {
	                    to = levelItems2.length;
	                  }
	                  for (var i2 = from; i2 < to; i2++) {
	                    var id = levelItems2[i2];
	                    var px = srcPoints[id * 2];
	                    var py = srcPoints[id * 2 + 1];
	                    if (px >= minX && px <= maxX && py >= minY && py <= maxY) {
	                      selection.push(id);
	                    }
	                  }
	                  var offsets2 = sublevels[level2];
	                  var off0 = offsets2[from * 4 + 0];
	                  var off1 = offsets2[from * 4 + 1];
	                  var off2 = offsets2[from * 4 + 2];
	                  var off3 = offsets2[from * 4 + 3];
	                  var end = nextOffset2(offsets2, from + 1);
	                  var d22 = d2 * 0.5;
	                  var nextLevel = level2 + 1;
	                  select(lox, loy, d22, nextLevel, off0, off1 || off2 || off3 || end);
	                  select(lox, loy + d22, d22, nextLevel, off1, off2 || off3 || end);
	                  select(lox + d22, loy, d22, nextLevel, off2, off3 || end);
	                  select(lox + d22, loy + d22, d22, nextLevel, off3, end);
	                }
	                function nextOffset2(offsets2, from) {
	                  var offset2 = null, i2 = 0;
	                  while (offset2 === null) {
	                    offset2 = offsets2[from * 4 + i2];
	                    i2++;
	                    if (i2 > offsets2.length) {
	                      return null;
	                    }
	                  }
	                  return offset2;
	                }
	                return selection;
	              }
	              function lod(lox, loy, hix, hiy, maxLevel) {
	                var ranges = [];
	                for (var level2 = 0; level2 < maxLevel; level2++) {
	                  var levelGroups = groups[level2];
	                  var from = offsets[level2][0];
	                  var levelGroupStart = group(lox, loy, level2);
	                  var levelGroupEnd = group(hix, hiy, level2);
	                  var startOffset = search.ge(levelGroups, levelGroupStart);
	                  var endOffset = search.gt(levelGroups, levelGroupEnd, startOffset, levelGroups.length - 1);
	                  ranges[level2] = [startOffset + from, endOffset + from];
	                }
	                return ranges;
	              }
	              function group(x, y, level2) {
	                var group2 = 1;
	                var cx = 0.5, cy = 0.5;
	                var diam = 0.5;
	                for (var i2 = 0; i2 < level2; i2++) {
	                  group2 <<= 2;
	                  group2 += x < cx ? y < cy ? 0 : 1 : y < cy ? 2 : 3;
	                  diam *= 0.5;
	                  cx += x < cx ? -diam : diam;
	                  cy += y < cy ? -diam : diam;
	                }
	                return group2;
	              }
	            };
	            function normalize(pts, bounds) {
	              var lox = bounds[0];
	              var loy = bounds[1];
	              var hix = bounds[2];
	              var hiy = bounds[3];
	              var scaleX = 1 / (hix - lox);
	              var scaleY = 1 / (hiy - loy);
	              var result = new Array(pts.length);
	              for (var i = 0, n = pts.length / 2; i < n; i++) {
	                result[2 * i] = clamp((pts[2 * i] - lox) * scaleX, 0, 1);
	                result[2 * i + 1] = clamp((pts[2 * i + 1] - loy) * scaleY, 0, 1);
	              }
	              return result;
	            }
	          }
	        ),
	        /***/
	        30774: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            var meta_1 = __webpack_require__2(60302);
	            var RADIUS = 6378137;
	            function area(geojson) {
	              return meta_1.geomReduce(geojson, function(value, geom) {
	                return value + calculateArea(geom);
	              }, 0);
	            }
	            exports2["default"] = area;
	            function calculateArea(geom) {
	              var total = 0;
	              var i;
	              switch (geom.type) {
	                case "Polygon":
	                  return polygonArea(geom.coordinates);
	                case "MultiPolygon":
	                  for (i = 0; i < geom.coordinates.length; i++) {
	                    total += polygonArea(geom.coordinates[i]);
	                  }
	                  return total;
	                case "Point":
	                case "MultiPoint":
	                case "LineString":
	                case "MultiLineString":
	                  return 0;
	              }
	              return 0;
	            }
	            function polygonArea(coords) {
	              var total = 0;
	              if (coords && coords.length > 0) {
	                total += Math.abs(ringArea(coords[0]));
	                for (var i = 1; i < coords.length; i++) {
	                  total -= Math.abs(ringArea(coords[i]));
	                }
	              }
	              return total;
	            }
	            function ringArea(coords) {
	              var p1;
	              var p2;
	              var p3;
	              var lowerIndex;
	              var middleIndex;
	              var upperIndex;
	              var i;
	              var total = 0;
	              var coordsLength = coords.length;
	              if (coordsLength > 2) {
	                for (i = 0; i < coordsLength; i++) {
	                  if (i === coordsLength - 2) {
	                    lowerIndex = coordsLength - 2;
	                    middleIndex = coordsLength - 1;
	                    upperIndex = 0;
	                  } else if (i === coordsLength - 1) {
	                    lowerIndex = coordsLength - 1;
	                    middleIndex = 0;
	                    upperIndex = 1;
	                  } else {
	                    lowerIndex = i;
	                    middleIndex = i + 1;
	                    upperIndex = i + 2;
	                  }
	                  p1 = coords[lowerIndex];
	                  p2 = coords[middleIndex];
	                  p3 = coords[upperIndex];
	                  total += (rad(p3[0]) - rad(p1[0])) * Math.sin(rad(p2[1]));
	                }
	                total = total * RADIUS * RADIUS / 2;
	              }
	              return total;
	            }
	            function rad(num) {
	              return num * Math.PI / 180;
	            }
	          }
	        ),
	        /***/
	        23132: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            exports2.earthRadius = 63710088e-1;
	            exports2.factors = {
	              centimeters: exports2.earthRadius * 100,
	              centimetres: exports2.earthRadius * 100,
	              degrees: exports2.earthRadius / 111325,
	              feet: exports2.earthRadius * 3.28084,
	              inches: exports2.earthRadius * 39.37,
	              kilometers: exports2.earthRadius / 1e3,
	              kilometres: exports2.earthRadius / 1e3,
	              meters: exports2.earthRadius,
	              metres: exports2.earthRadius,
	              miles: exports2.earthRadius / 1609.344,
	              millimeters: exports2.earthRadius * 1e3,
	              millimetres: exports2.earthRadius * 1e3,
	              nauticalmiles: exports2.earthRadius / 1852,
	              radians: 1,
	              yards: exports2.earthRadius * 1.0936
	            };
	            exports2.unitsFactors = {
	              centimeters: 100,
	              centimetres: 100,
	              degrees: 1 / 111325,
	              feet: 3.28084,
	              inches: 39.37,
	              kilometers: 1 / 1e3,
	              kilometres: 1 / 1e3,
	              meters: 1,
	              metres: 1,
	              miles: 1 / 1609.344,
	              millimeters: 1e3,
	              millimetres: 1e3,
	              nauticalmiles: 1 / 1852,
	              radians: 1 / exports2.earthRadius,
	              yards: 1.0936133
	            };
	            exports2.areaFactors = {
	              acres: 247105e-9,
	              centimeters: 1e4,
	              centimetres: 1e4,
	              feet: 10.763910417,
	              hectares: 1e-4,
	              inches: 1550.003100006,
	              kilometers: 1e-6,
	              kilometres: 1e-6,
	              meters: 1,
	              metres: 1,
	              miles: 386e-9,
	              millimeters: 1e6,
	              millimetres: 1e6,
	              yards: 1.195990046
	            };
	            function feature(geom, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var feat = { type: "Feature" };
	              if (options.id === 0 || options.id) {
	                feat.id = options.id;
	              }
	              if (options.bbox) {
	                feat.bbox = options.bbox;
	              }
	              feat.properties = properties || {};
	              feat.geometry = geom;
	              return feat;
	            }
	            exports2.feature = feature;
	            function geometry(type, coordinates, _options) {
	              switch (type) {
	                case "Point":
	                  return point(coordinates).geometry;
	                case "LineString":
	                  return lineString(coordinates).geometry;
	                case "Polygon":
	                  return polygon(coordinates).geometry;
	                case "MultiPoint":
	                  return multiPoint(coordinates).geometry;
	                case "MultiLineString":
	                  return multiLineString(coordinates).geometry;
	                case "MultiPolygon":
	                  return multiPolygon(coordinates).geometry;
	                default:
	                  throw new Error(type + " is invalid");
	              }
	            }
	            exports2.geometry = geometry;
	            function point(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              if (!coordinates) {
	                throw new Error("coordinates is required");
	              }
	              if (!Array.isArray(coordinates)) {
	                throw new Error("coordinates must be an Array");
	              }
	              if (coordinates.length < 2) {
	                throw new Error("coordinates must be at least 2 numbers long");
	              }
	              if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
	                throw new Error("coordinates must contain numbers");
	              }
	              var geom = {
	                type: "Point",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.point = point;
	            function points(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return point(coords, properties);
	              }), options);
	            }
	            exports2.points = points;
	            function polygon(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
	                var ring = coordinates_1[_i];
	                if (ring.length < 4) {
	                  throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
	                }
	                for (var j = 0; j < ring[ring.length - 1].length; j++) {
	                  if (ring[ring.length - 1][j] !== ring[0][j]) {
	                    throw new Error("First and last Position are not equivalent.");
	                  }
	                }
	              }
	              var geom = {
	                type: "Polygon",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.polygon = polygon;
	            function polygons(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return polygon(coords, properties);
	              }), options);
	            }
	            exports2.polygons = polygons;
	            function lineString(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              if (coordinates.length < 2) {
	                throw new Error("coordinates must be an array of two or more positions");
	              }
	              var geom = {
	                type: "LineString",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.lineString = lineString;
	            function lineStrings(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return lineString(coords, properties);
	              }), options);
	            }
	            exports2.lineStrings = lineStrings;
	            function featureCollection(features, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var fc = { type: "FeatureCollection" };
	              if (options.id) {
	                fc.id = options.id;
	              }
	              if (options.bbox) {
	                fc.bbox = options.bbox;
	              }
	              fc.features = features;
	              return fc;
	            }
	            exports2.featureCollection = featureCollection;
	            function multiLineString(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiLineString",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiLineString = multiLineString;
	            function multiPoint(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiPoint",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiPoint = multiPoint;
	            function multiPolygon(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiPolygon",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiPolygon = multiPolygon;
	            function geometryCollection(geometries, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "GeometryCollection",
	                geometries
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.geometryCollection = geometryCollection;
	            function round(num, precision) {
	              if (precision === undefined) {
	                precision = 0;
	              }
	              if (precision && !(precision >= 0)) {
	                throw new Error("precision must be a positive number");
	              }
	              var multiplier = Math.pow(10, precision || 0);
	              return Math.round(num * multiplier) / multiplier;
	            }
	            exports2.round = round;
	            function radiansToLength(radians, units) {
	              if (units === undefined) {
	                units = "kilometers";
	              }
	              var factor = exports2.factors[units];
	              if (!factor) {
	                throw new Error(units + " units is invalid");
	              }
	              return radians * factor;
	            }
	            exports2.radiansToLength = radiansToLength;
	            function lengthToRadians(distance, units) {
	              if (units === undefined) {
	                units = "kilometers";
	              }
	              var factor = exports2.factors[units];
	              if (!factor) {
	                throw new Error(units + " units is invalid");
	              }
	              return distance / factor;
	            }
	            exports2.lengthToRadians = lengthToRadians;
	            function lengthToDegrees(distance, units) {
	              return radiansToDegrees(lengthToRadians(distance, units));
	            }
	            exports2.lengthToDegrees = lengthToDegrees;
	            function bearingToAzimuth(bearing) {
	              var angle = bearing % 360;
	              if (angle < 0) {
	                angle += 360;
	              }
	              return angle;
	            }
	            exports2.bearingToAzimuth = bearingToAzimuth;
	            function radiansToDegrees(radians) {
	              var degrees = radians % (2 * Math.PI);
	              return degrees * 180 / Math.PI;
	            }
	            exports2.radiansToDegrees = radiansToDegrees;
	            function degreesToRadians(degrees) {
	              var radians = degrees % 360;
	              return radians * Math.PI / 180;
	            }
	            exports2.degreesToRadians = degreesToRadians;
	            function convertLength(length, originalUnit, finalUnit) {
	              if (originalUnit === undefined) {
	                originalUnit = "kilometers";
	              }
	              if (finalUnit === undefined) {
	                finalUnit = "kilometers";
	              }
	              if (!(length >= 0)) {
	                throw new Error("length must be a positive number");
	              }
	              return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
	            }
	            exports2.convertLength = convertLength;
	            function convertArea(area, originalUnit, finalUnit) {
	              if (originalUnit === undefined) {
	                originalUnit = "meters";
	              }
	              if (finalUnit === undefined) {
	                finalUnit = "kilometers";
	              }
	              if (!(area >= 0)) {
	                throw new Error("area must be a positive number");
	              }
	              var startFactor = exports2.areaFactors[originalUnit];
	              if (!startFactor) {
	                throw new Error("invalid original units");
	              }
	              var finalFactor = exports2.areaFactors[finalUnit];
	              if (!finalFactor) {
	                throw new Error("invalid final units");
	              }
	              return area / startFactor * finalFactor;
	            }
	            exports2.convertArea = convertArea;
	            function isNumber(num) {
	              return !isNaN(num) && num !== null && !Array.isArray(num);
	            }
	            exports2.isNumber = isNumber;
	            function isObject(input) {
	              return !!input && input.constructor === Object;
	            }
	            exports2.isObject = isObject;
	            function validateBBox(bbox) {
	              if (!bbox) {
	                throw new Error("bbox is required");
	              }
	              if (!Array.isArray(bbox)) {
	                throw new Error("bbox must be an Array");
	              }
	              if (bbox.length !== 4 && bbox.length !== 6) {
	                throw new Error("bbox must be an Array of 4 or 6 numbers");
	              }
	              bbox.forEach(function(num) {
	                if (!isNumber(num)) {
	                  throw new Error("bbox must only contain numbers");
	                }
	              });
	            }
	            exports2.validateBBox = validateBBox;
	            function validateId(id) {
	              if (!id) {
	                throw new Error("id is required");
	              }
	              if (["string", "number"].indexOf(typeof id) === -1) {
	                throw new Error("id must be a number or a string");
	              }
	            }
	            exports2.validateId = validateId;
	          }
	        ),
	        /***/
	        60302: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            var helpers = __webpack_require__2(23132);
	            function coordEach(geojson, callback, excludeWrapCoord) {
	              if (geojson === null) return;
	              var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
	              for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
	                geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
	                isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
	                stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	                for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
	                  var multiFeatureIndex = 0;
	                  var geometryIndex = 0;
	                  geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
	                  if (geometry === null) continue;
	                  coords = geometry.coordinates;
	                  var geomType = geometry.type;
	                  wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
	                  switch (geomType) {
	                    case null:
	                      break;
	                    case "Point":
	                      if (callback(
	                        coords,
	                        coordIndex,
	                        featureIndex,
	                        multiFeatureIndex,
	                        geometryIndex
	                      ) === false)
	                        return false;
	                      coordIndex++;
	                      multiFeatureIndex++;
	                      break;
	                    case "LineString":
	                    case "MultiPoint":
	                      for (j = 0; j < coords.length; j++) {
	                        if (callback(
	                          coords[j],
	                          coordIndex,
	                          featureIndex,
	                          multiFeatureIndex,
	                          geometryIndex
	                        ) === false)
	                          return false;
	                        coordIndex++;
	                        if (geomType === "MultiPoint") multiFeatureIndex++;
	                      }
	                      if (geomType === "LineString") multiFeatureIndex++;
	                      break;
	                    case "Polygon":
	                    case "MultiLineString":
	                      for (j = 0; j < coords.length; j++) {
	                        for (k = 0; k < coords[j].length - wrapShrink; k++) {
	                          if (callback(
	                            coords[j][k],
	                            coordIndex,
	                            featureIndex,
	                            multiFeatureIndex,
	                            geometryIndex
	                          ) === false)
	                            return false;
	                          coordIndex++;
	                        }
	                        if (geomType === "MultiLineString") multiFeatureIndex++;
	                        if (geomType === "Polygon") geometryIndex++;
	                      }
	                      if (geomType === "Polygon") multiFeatureIndex++;
	                      break;
	                    case "MultiPolygon":
	                      for (j = 0; j < coords.length; j++) {
	                        geometryIndex = 0;
	                        for (k = 0; k < coords[j].length; k++) {
	                          for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
	                            if (callback(
	                              coords[j][k][l],
	                              coordIndex,
	                              featureIndex,
	                              multiFeatureIndex,
	                              geometryIndex
	                            ) === false)
	                              return false;
	                            coordIndex++;
	                          }
	                          geometryIndex++;
	                        }
	                        multiFeatureIndex++;
	                      }
	                      break;
	                    case "GeometryCollection":
	                      for (j = 0; j < geometry.geometries.length; j++)
	                        if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false)
	                          return false;
	                      break;
	                    default:
	                      throw new Error("Unknown Geometry Type");
	                  }
	                }
	              }
	            }
	            function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
	              var previousValue = initialValue;
	              coordEach(
	                geojson,
	                function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	                  if (coordIndex === 0 && initialValue === undefined)
	                    previousValue = currentCoord;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentCoord,
	                      coordIndex,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex
	                    );
	                },
	                excludeWrapCoord
	              );
	              return previousValue;
	            }
	            function propEach(geojson, callback) {
	              var i;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  for (i = 0; i < geojson.features.length; i++) {
	                    if (callback(geojson.features[i].properties, i) === false) break;
	                  }
	                  break;
	                case "Feature":
	                  callback(geojson.properties, 0);
	                  break;
	              }
	            }
	            function propReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              propEach(geojson, function(currentProperties, featureIndex) {
	                if (featureIndex === 0 && initialValue === undefined)
	                  previousValue = currentProperties;
	                else
	                  previousValue = callback(previousValue, currentProperties, featureIndex);
	              });
	              return previousValue;
	            }
	            function featureEach(geojson, callback) {
	              if (geojson.type === "Feature") {
	                callback(geojson, 0);
	              } else if (geojson.type === "FeatureCollection") {
	                for (var i = 0; i < geojson.features.length; i++) {
	                  if (callback(geojson.features[i], i) === false) break;
	                }
	              }
	            }
	            function featureReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              featureEach(geojson, function(currentFeature, featureIndex) {
	                if (featureIndex === 0 && initialValue === undefined)
	                  previousValue = currentFeature;
	                else previousValue = callback(previousValue, currentFeature, featureIndex);
	              });
	              return previousValue;
	            }
	            function coordAll(geojson) {
	              var coords = [];
	              coordEach(geojson, function(coord) {
	                coords.push(coord);
	              });
	              return coords;
	            }
	            function geomEach(geojson, callback) {
	              var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
	              for (i = 0; i < stop; i++) {
	                geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
	                featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
	                featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
	                featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
	                isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
	                stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	                for (g = 0; g < stopG; g++) {
	                  geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
	                  if (geometry === null) {
	                    if (callback(
	                      null,
	                      featureIndex,
	                      featureProperties,
	                      featureBBox,
	                      featureId
	                    ) === false)
	                      return false;
	                    continue;
	                  }
	                  switch (geometry.type) {
	                    case "Point":
	                    case "LineString":
	                    case "MultiPoint":
	                    case "Polygon":
	                    case "MultiLineString":
	                    case "MultiPolygon": {
	                      if (callback(
	                        geometry,
	                        featureIndex,
	                        featureProperties,
	                        featureBBox,
	                        featureId
	                      ) === false)
	                        return false;
	                      break;
	                    }
	                    case "GeometryCollection": {
	                      for (j = 0; j < geometry.geometries.length; j++) {
	                        if (callback(
	                          geometry.geometries[j],
	                          featureIndex,
	                          featureProperties,
	                          featureBBox,
	                          featureId
	                        ) === false)
	                          return false;
	                      }
	                      break;
	                    }
	                    default:
	                      throw new Error("Unknown Geometry Type");
	                  }
	                }
	                featureIndex++;
	              }
	            }
	            function geomReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              geomEach(
	                geojson,
	                function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	                  if (featureIndex === 0 && initialValue === undefined)
	                    previousValue = currentGeometry;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentGeometry,
	                      featureIndex,
	                      featureProperties,
	                      featureBBox,
	                      featureId
	                    );
	                }
	              );
	              return previousValue;
	            }
	            function flattenEach(geojson, callback) {
	              geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
	                var type = geometry === null ? null : geometry.type;
	                switch (type) {
	                  case null:
	                  case "Point":
	                  case "LineString":
	                  case "Polygon":
	                    if (callback(
	                      helpers.feature(geometry, properties, { bbox, id }),
	                      featureIndex,
	                      0
	                    ) === false)
	                      return false;
	                    return;
	                }
	                var geomType;
	                switch (type) {
	                  case "MultiPoint":
	                    geomType = "Point";
	                    break;
	                  case "MultiLineString":
	                    geomType = "LineString";
	                    break;
	                  case "MultiPolygon":
	                    geomType = "Polygon";
	                    break;
	                }
	                for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
	                  var coordinate = geometry.coordinates[multiFeatureIndex];
	                  var geom = {
	                    type: geomType,
	                    coordinates: coordinate
	                  };
	                  if (callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) === false)
	                    return false;
	                }
	              });
	            }
	            function flattenReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              flattenEach(
	                geojson,
	                function(currentFeature, featureIndex, multiFeatureIndex) {
	                  if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined)
	                    previousValue = currentFeature;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentFeature,
	                      featureIndex,
	                      multiFeatureIndex
	                    );
	                }
	              );
	              return previousValue;
	            }
	            function segmentEach(geojson, callback) {
	              flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
	                var segmentIndex = 0;
	                if (!feature.geometry) return;
	                var type = feature.geometry.type;
	                if (type === "Point" || type === "MultiPoint") return;
	                var previousCoords;
	                var previousFeatureIndex = 0;
	                var previousMultiIndex = 0;
	                var prevGeomIndex = 0;
	                if (coordEach(
	                  feature,
	                  function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
	                    if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
	                      previousCoords = currentCoord;
	                      previousFeatureIndex = featureIndex;
	                      previousMultiIndex = multiPartIndexCoord;
	                      prevGeomIndex = geometryIndex;
	                      segmentIndex = 0;
	                      return;
	                    }
	                    var currentSegment = helpers.lineString(
	                      [previousCoords, currentCoord],
	                      feature.properties
	                    );
	                    if (callback(
	                      currentSegment,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex,
	                      segmentIndex
	                    ) === false)
	                      return false;
	                    segmentIndex++;
	                    previousCoords = currentCoord;
	                  }
	                ) === false)
	                  return false;
	              });
	            }
	            function segmentReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              var started = false;
	              segmentEach(
	                geojson,
	                function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	                  if (started === false && initialValue === undefined)
	                    previousValue = currentSegment;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentSegment,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex,
	                      segmentIndex
	                    );
	                  started = true;
	                }
	              );
	              return previousValue;
	            }
	            function lineEach(geojson, callback) {
	              if (!geojson) throw new Error("geojson is required");
	              flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
	                if (feature.geometry === null) return;
	                var type = feature.geometry.type;
	                var coords = feature.geometry.coordinates;
	                switch (type) {
	                  case "LineString":
	                    if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false)
	                      return false;
	                    break;
	                  case "Polygon":
	                    for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
	                      if (callback(
	                        helpers.lineString(coords[geometryIndex], feature.properties),
	                        featureIndex,
	                        multiFeatureIndex,
	                        geometryIndex
	                      ) === false)
	                        return false;
	                    }
	                    break;
	                }
	              });
	            }
	            function lineReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              lineEach(
	                geojson,
	                function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	                  if (featureIndex === 0 && initialValue === undefined)
	                    previousValue = currentLine;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentLine,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex
	                    );
	                }
	              );
	              return previousValue;
	            }
	            function findSegment(geojson, options) {
	              options = options || {};
	              if (!helpers.isObject(options)) throw new Error("options is invalid");
	              var featureIndex = options.featureIndex || 0;
	              var multiFeatureIndex = options.multiFeatureIndex || 0;
	              var geometryIndex = options.geometryIndex || 0;
	              var segmentIndex = options.segmentIndex || 0;
	              var properties = options.properties;
	              var geometry;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  if (featureIndex < 0)
	                    featureIndex = geojson.features.length + featureIndex;
	                  properties = properties || geojson.features[featureIndex].properties;
	                  geometry = geojson.features[featureIndex].geometry;
	                  break;
	                case "Feature":
	                  properties = properties || geojson.properties;
	                  geometry = geojson.geometry;
	                  break;
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                case "Polygon":
	                case "MultiLineString":
	                case "MultiPolygon":
	                  geometry = geojson;
	                  break;
	                default:
	                  throw new Error("geojson is invalid");
	              }
	              if (geometry === null) return null;
	              var coords = geometry.coordinates;
	              switch (geometry.type) {
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                  if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
	                  return helpers.lineString(
	                    [coords[segmentIndex], coords[segmentIndex + 1]],
	                    properties,
	                    options
	                  );
	                case "Polygon":
	                  if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	                  if (segmentIndex < 0)
	                    segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
	                  return helpers.lineString(
	                    [
	                      coords[geometryIndex][segmentIndex],
	                      coords[geometryIndex][segmentIndex + 1]
	                    ],
	                    properties,
	                    options
	                  );
	                case "MultiLineString":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (segmentIndex < 0)
	                    segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
	                  return helpers.lineString(
	                    [
	                      coords[multiFeatureIndex][segmentIndex],
	                      coords[multiFeatureIndex][segmentIndex + 1]
	                    ],
	                    properties,
	                    options
	                  );
	                case "MultiPolygon":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (geometryIndex < 0)
	                    geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	                  if (segmentIndex < 0)
	                    segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
	                  return helpers.lineString(
	                    [
	                      coords[multiFeatureIndex][geometryIndex][segmentIndex],
	                      coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
	                    ],
	                    properties,
	                    options
	                  );
	              }
	              throw new Error("geojson is invalid");
	            }
	            function findPoint(geojson, options) {
	              options = options || {};
	              if (!helpers.isObject(options)) throw new Error("options is invalid");
	              var featureIndex = options.featureIndex || 0;
	              var multiFeatureIndex = options.multiFeatureIndex || 0;
	              var geometryIndex = options.geometryIndex || 0;
	              var coordIndex = options.coordIndex || 0;
	              var properties = options.properties;
	              var geometry;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  if (featureIndex < 0)
	                    featureIndex = geojson.features.length + featureIndex;
	                  properties = properties || geojson.features[featureIndex].properties;
	                  geometry = geojson.features[featureIndex].geometry;
	                  break;
	                case "Feature":
	                  properties = properties || geojson.properties;
	                  geometry = geojson.geometry;
	                  break;
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                case "Polygon":
	                case "MultiLineString":
	                case "MultiPolygon":
	                  geometry = geojson;
	                  break;
	                default:
	                  throw new Error("geojson is invalid");
	              }
	              if (geometry === null) return null;
	              var coords = geometry.coordinates;
	              switch (geometry.type) {
	                case "Point":
	                  return helpers.point(coords, properties, options);
	                case "MultiPoint":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  return helpers.point(coords[multiFeatureIndex], properties, options);
	                case "LineString":
	                  if (coordIndex < 0) coordIndex = coords.length + coordIndex;
	                  return helpers.point(coords[coordIndex], properties, options);
	                case "Polygon":
	                  if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	                  if (coordIndex < 0)
	                    coordIndex = coords[geometryIndex].length + coordIndex;
	                  return helpers.point(coords[geometryIndex][coordIndex], properties, options);
	                case "MultiLineString":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (coordIndex < 0)
	                    coordIndex = coords[multiFeatureIndex].length + coordIndex;
	                  return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
	                case "MultiPolygon":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (geometryIndex < 0)
	                    geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	                  if (coordIndex < 0)
	                    coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
	                  return helpers.point(
	                    coords[multiFeatureIndex][geometryIndex][coordIndex],
	                    properties,
	                    options
	                  );
	              }
	              throw new Error("geojson is invalid");
	            }
	            exports2.coordEach = coordEach;
	            exports2.coordReduce = coordReduce;
	            exports2.propEach = propEach;
	            exports2.propReduce = propReduce;
	            exports2.featureEach = featureEach;
	            exports2.featureReduce = featureReduce;
	            exports2.coordAll = coordAll;
	            exports2.geomEach = geomEach;
	            exports2.geomReduce = geomReduce;
	            exports2.flattenEach = flattenEach;
	            exports2.flattenReduce = flattenReduce;
	            exports2.segmentEach = segmentEach;
	            exports2.segmentReduce = segmentReduce;
	            exports2.lineEach = lineEach;
	            exports2.lineReduce = lineReduce;
	            exports2.findSegment = findSegment;
	            exports2.findPoint = findPoint;
	          }
	        ),
	        /***/
	        85268: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            var meta_1 = __webpack_require__2(27138);
	            function bbox(geojson) {
	              var result = [Infinity, Infinity, -Infinity, -Infinity];
	              meta_1.coordEach(geojson, function(coord) {
	                if (result[0] > coord[0]) {
	                  result[0] = coord[0];
	                }
	                if (result[1] > coord[1]) {
	                  result[1] = coord[1];
	                }
	                if (result[2] < coord[0]) {
	                  result[2] = coord[0];
	                }
	                if (result[3] < coord[1]) {
	                  result[3] = coord[1];
	                }
	              });
	              return result;
	            }
	            bbox["default"] = bbox;
	            exports2["default"] = bbox;
	          }
	        ),
	        /***/
	        94228: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            exports2.earthRadius = 63710088e-1;
	            exports2.factors = {
	              centimeters: exports2.earthRadius * 100,
	              centimetres: exports2.earthRadius * 100,
	              degrees: exports2.earthRadius / 111325,
	              feet: exports2.earthRadius * 3.28084,
	              inches: exports2.earthRadius * 39.37,
	              kilometers: exports2.earthRadius / 1e3,
	              kilometres: exports2.earthRadius / 1e3,
	              meters: exports2.earthRadius,
	              metres: exports2.earthRadius,
	              miles: exports2.earthRadius / 1609.344,
	              millimeters: exports2.earthRadius * 1e3,
	              millimetres: exports2.earthRadius * 1e3,
	              nauticalmiles: exports2.earthRadius / 1852,
	              radians: 1,
	              yards: exports2.earthRadius * 1.0936
	            };
	            exports2.unitsFactors = {
	              centimeters: 100,
	              centimetres: 100,
	              degrees: 1 / 111325,
	              feet: 3.28084,
	              inches: 39.37,
	              kilometers: 1 / 1e3,
	              kilometres: 1 / 1e3,
	              meters: 1,
	              metres: 1,
	              miles: 1 / 1609.344,
	              millimeters: 1e3,
	              millimetres: 1e3,
	              nauticalmiles: 1 / 1852,
	              radians: 1 / exports2.earthRadius,
	              yards: 1.0936133
	            };
	            exports2.areaFactors = {
	              acres: 247105e-9,
	              centimeters: 1e4,
	              centimetres: 1e4,
	              feet: 10.763910417,
	              hectares: 1e-4,
	              inches: 1550.003100006,
	              kilometers: 1e-6,
	              kilometres: 1e-6,
	              meters: 1,
	              metres: 1,
	              miles: 386e-9,
	              millimeters: 1e6,
	              millimetres: 1e6,
	              yards: 1.195990046
	            };
	            function feature(geom, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var feat = { type: "Feature" };
	              if (options.id === 0 || options.id) {
	                feat.id = options.id;
	              }
	              if (options.bbox) {
	                feat.bbox = options.bbox;
	              }
	              feat.properties = properties || {};
	              feat.geometry = geom;
	              return feat;
	            }
	            exports2.feature = feature;
	            function geometry(type, coordinates, _options) {
	              switch (type) {
	                case "Point":
	                  return point(coordinates).geometry;
	                case "LineString":
	                  return lineString(coordinates).geometry;
	                case "Polygon":
	                  return polygon(coordinates).geometry;
	                case "MultiPoint":
	                  return multiPoint(coordinates).geometry;
	                case "MultiLineString":
	                  return multiLineString(coordinates).geometry;
	                case "MultiPolygon":
	                  return multiPolygon(coordinates).geometry;
	                default:
	                  throw new Error(type + " is invalid");
	              }
	            }
	            exports2.geometry = geometry;
	            function point(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              if (!coordinates) {
	                throw new Error("coordinates is required");
	              }
	              if (!Array.isArray(coordinates)) {
	                throw new Error("coordinates must be an Array");
	              }
	              if (coordinates.length < 2) {
	                throw new Error("coordinates must be at least 2 numbers long");
	              }
	              if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
	                throw new Error("coordinates must contain numbers");
	              }
	              var geom = {
	                type: "Point",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.point = point;
	            function points(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return point(coords, properties);
	              }), options);
	            }
	            exports2.points = points;
	            function polygon(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
	                var ring = coordinates_1[_i];
	                if (ring.length < 4) {
	                  throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
	                }
	                for (var j = 0; j < ring[ring.length - 1].length; j++) {
	                  if (ring[ring.length - 1][j] !== ring[0][j]) {
	                    throw new Error("First and last Position are not equivalent.");
	                  }
	                }
	              }
	              var geom = {
	                type: "Polygon",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.polygon = polygon;
	            function polygons(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return polygon(coords, properties);
	              }), options);
	            }
	            exports2.polygons = polygons;
	            function lineString(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              if (coordinates.length < 2) {
	                throw new Error("coordinates must be an array of two or more positions");
	              }
	              var geom = {
	                type: "LineString",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.lineString = lineString;
	            function lineStrings(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return lineString(coords, properties);
	              }), options);
	            }
	            exports2.lineStrings = lineStrings;
	            function featureCollection(features, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var fc = { type: "FeatureCollection" };
	              if (options.id) {
	                fc.id = options.id;
	              }
	              if (options.bbox) {
	                fc.bbox = options.bbox;
	              }
	              fc.features = features;
	              return fc;
	            }
	            exports2.featureCollection = featureCollection;
	            function multiLineString(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiLineString",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiLineString = multiLineString;
	            function multiPoint(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiPoint",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiPoint = multiPoint;
	            function multiPolygon(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiPolygon",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiPolygon = multiPolygon;
	            function geometryCollection(geometries, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "GeometryCollection",
	                geometries
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.geometryCollection = geometryCollection;
	            function round(num, precision) {
	              if (precision === undefined) {
	                precision = 0;
	              }
	              if (precision && !(precision >= 0)) {
	                throw new Error("precision must be a positive number");
	              }
	              var multiplier = Math.pow(10, precision || 0);
	              return Math.round(num * multiplier) / multiplier;
	            }
	            exports2.round = round;
	            function radiansToLength(radians, units) {
	              if (units === undefined) {
	                units = "kilometers";
	              }
	              var factor = exports2.factors[units];
	              if (!factor) {
	                throw new Error(units + " units is invalid");
	              }
	              return radians * factor;
	            }
	            exports2.radiansToLength = radiansToLength;
	            function lengthToRadians(distance, units) {
	              if (units === undefined) {
	                units = "kilometers";
	              }
	              var factor = exports2.factors[units];
	              if (!factor) {
	                throw new Error(units + " units is invalid");
	              }
	              return distance / factor;
	            }
	            exports2.lengthToRadians = lengthToRadians;
	            function lengthToDegrees(distance, units) {
	              return radiansToDegrees(lengthToRadians(distance, units));
	            }
	            exports2.lengthToDegrees = lengthToDegrees;
	            function bearingToAzimuth(bearing) {
	              var angle = bearing % 360;
	              if (angle < 0) {
	                angle += 360;
	              }
	              return angle;
	            }
	            exports2.bearingToAzimuth = bearingToAzimuth;
	            function radiansToDegrees(radians) {
	              var degrees = radians % (2 * Math.PI);
	              return degrees * 180 / Math.PI;
	            }
	            exports2.radiansToDegrees = radiansToDegrees;
	            function degreesToRadians(degrees) {
	              var radians = degrees % 360;
	              return radians * Math.PI / 180;
	            }
	            exports2.degreesToRadians = degreesToRadians;
	            function convertLength(length, originalUnit, finalUnit) {
	              if (originalUnit === undefined) {
	                originalUnit = "kilometers";
	              }
	              if (finalUnit === undefined) {
	                finalUnit = "kilometers";
	              }
	              if (!(length >= 0)) {
	                throw new Error("length must be a positive number");
	              }
	              return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
	            }
	            exports2.convertLength = convertLength;
	            function convertArea(area, originalUnit, finalUnit) {
	              if (originalUnit === undefined) {
	                originalUnit = "meters";
	              }
	              if (finalUnit === undefined) {
	                finalUnit = "kilometers";
	              }
	              if (!(area >= 0)) {
	                throw new Error("area must be a positive number");
	              }
	              var startFactor = exports2.areaFactors[originalUnit];
	              if (!startFactor) {
	                throw new Error("invalid original units");
	              }
	              var finalFactor = exports2.areaFactors[finalUnit];
	              if (!finalFactor) {
	                throw new Error("invalid final units");
	              }
	              return area / startFactor * finalFactor;
	            }
	            exports2.convertArea = convertArea;
	            function isNumber(num) {
	              return !isNaN(num) && num !== null && !Array.isArray(num);
	            }
	            exports2.isNumber = isNumber;
	            function isObject(input) {
	              return !!input && input.constructor === Object;
	            }
	            exports2.isObject = isObject;
	            function validateBBox(bbox) {
	              if (!bbox) {
	                throw new Error("bbox is required");
	              }
	              if (!Array.isArray(bbox)) {
	                throw new Error("bbox must be an Array");
	              }
	              if (bbox.length !== 4 && bbox.length !== 6) {
	                throw new Error("bbox must be an Array of 4 or 6 numbers");
	              }
	              bbox.forEach(function(num) {
	                if (!isNumber(num)) {
	                  throw new Error("bbox must only contain numbers");
	                }
	              });
	            }
	            exports2.validateBBox = validateBBox;
	            function validateId(id) {
	              if (!id) {
	                throw new Error("id is required");
	              }
	              if (["string", "number"].indexOf(typeof id) === -1) {
	                throw new Error("id must be a number or a string");
	              }
	            }
	            exports2.validateId = validateId;
	          }
	        ),
	        /***/
	        27138: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            var helpers = __webpack_require__2(94228);
	            function coordEach(geojson, callback, excludeWrapCoord) {
	              if (geojson === null) return;
	              var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
	              for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
	                geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
	                isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
	                stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	                for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
	                  var multiFeatureIndex = 0;
	                  var geometryIndex = 0;
	                  geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
	                  if (geometry === null) continue;
	                  coords = geometry.coordinates;
	                  var geomType = geometry.type;
	                  wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
	                  switch (geomType) {
	                    case null:
	                      break;
	                    case "Point":
	                      if (callback(
	                        coords,
	                        coordIndex,
	                        featureIndex,
	                        multiFeatureIndex,
	                        geometryIndex
	                      ) === false)
	                        return false;
	                      coordIndex++;
	                      multiFeatureIndex++;
	                      break;
	                    case "LineString":
	                    case "MultiPoint":
	                      for (j = 0; j < coords.length; j++) {
	                        if (callback(
	                          coords[j],
	                          coordIndex,
	                          featureIndex,
	                          multiFeatureIndex,
	                          geometryIndex
	                        ) === false)
	                          return false;
	                        coordIndex++;
	                        if (geomType === "MultiPoint") multiFeatureIndex++;
	                      }
	                      if (geomType === "LineString") multiFeatureIndex++;
	                      break;
	                    case "Polygon":
	                    case "MultiLineString":
	                      for (j = 0; j < coords.length; j++) {
	                        for (k = 0; k < coords[j].length - wrapShrink; k++) {
	                          if (callback(
	                            coords[j][k],
	                            coordIndex,
	                            featureIndex,
	                            multiFeatureIndex,
	                            geometryIndex
	                          ) === false)
	                            return false;
	                          coordIndex++;
	                        }
	                        if (geomType === "MultiLineString") multiFeatureIndex++;
	                        if (geomType === "Polygon") geometryIndex++;
	                      }
	                      if (geomType === "Polygon") multiFeatureIndex++;
	                      break;
	                    case "MultiPolygon":
	                      for (j = 0; j < coords.length; j++) {
	                        geometryIndex = 0;
	                        for (k = 0; k < coords[j].length; k++) {
	                          for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
	                            if (callback(
	                              coords[j][k][l],
	                              coordIndex,
	                              featureIndex,
	                              multiFeatureIndex,
	                              geometryIndex
	                            ) === false)
	                              return false;
	                            coordIndex++;
	                          }
	                          geometryIndex++;
	                        }
	                        multiFeatureIndex++;
	                      }
	                      break;
	                    case "GeometryCollection":
	                      for (j = 0; j < geometry.geometries.length; j++)
	                        if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false)
	                          return false;
	                      break;
	                    default:
	                      throw new Error("Unknown Geometry Type");
	                  }
	                }
	              }
	            }
	            function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
	              var previousValue = initialValue;
	              coordEach(
	                geojson,
	                function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	                  if (coordIndex === 0 && initialValue === undefined)
	                    previousValue = currentCoord;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentCoord,
	                      coordIndex,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex
	                    );
	                },
	                excludeWrapCoord
	              );
	              return previousValue;
	            }
	            function propEach(geojson, callback) {
	              var i;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  for (i = 0; i < geojson.features.length; i++) {
	                    if (callback(geojson.features[i].properties, i) === false) break;
	                  }
	                  break;
	                case "Feature":
	                  callback(geojson.properties, 0);
	                  break;
	              }
	            }
	            function propReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              propEach(geojson, function(currentProperties, featureIndex) {
	                if (featureIndex === 0 && initialValue === undefined)
	                  previousValue = currentProperties;
	                else
	                  previousValue = callback(previousValue, currentProperties, featureIndex);
	              });
	              return previousValue;
	            }
	            function featureEach(geojson, callback) {
	              if (geojson.type === "Feature") {
	                callback(geojson, 0);
	              } else if (geojson.type === "FeatureCollection") {
	                for (var i = 0; i < geojson.features.length; i++) {
	                  if (callback(geojson.features[i], i) === false) break;
	                }
	              }
	            }
	            function featureReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              featureEach(geojson, function(currentFeature, featureIndex) {
	                if (featureIndex === 0 && initialValue === undefined)
	                  previousValue = currentFeature;
	                else previousValue = callback(previousValue, currentFeature, featureIndex);
	              });
	              return previousValue;
	            }
	            function coordAll(geojson) {
	              var coords = [];
	              coordEach(geojson, function(coord) {
	                coords.push(coord);
	              });
	              return coords;
	            }
	            function geomEach(geojson, callback) {
	              var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
	              for (i = 0; i < stop; i++) {
	                geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
	                featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
	                featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
	                featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
	                isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
	                stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	                for (g = 0; g < stopG; g++) {
	                  geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
	                  if (geometry === null) {
	                    if (callback(
	                      null,
	                      featureIndex,
	                      featureProperties,
	                      featureBBox,
	                      featureId
	                    ) === false)
	                      return false;
	                    continue;
	                  }
	                  switch (geometry.type) {
	                    case "Point":
	                    case "LineString":
	                    case "MultiPoint":
	                    case "Polygon":
	                    case "MultiLineString":
	                    case "MultiPolygon": {
	                      if (callback(
	                        geometry,
	                        featureIndex,
	                        featureProperties,
	                        featureBBox,
	                        featureId
	                      ) === false)
	                        return false;
	                      break;
	                    }
	                    case "GeometryCollection": {
	                      for (j = 0; j < geometry.geometries.length; j++) {
	                        if (callback(
	                          geometry.geometries[j],
	                          featureIndex,
	                          featureProperties,
	                          featureBBox,
	                          featureId
	                        ) === false)
	                          return false;
	                      }
	                      break;
	                    }
	                    default:
	                      throw new Error("Unknown Geometry Type");
	                  }
	                }
	                featureIndex++;
	              }
	            }
	            function geomReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              geomEach(
	                geojson,
	                function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	                  if (featureIndex === 0 && initialValue === undefined)
	                    previousValue = currentGeometry;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentGeometry,
	                      featureIndex,
	                      featureProperties,
	                      featureBBox,
	                      featureId
	                    );
	                }
	              );
	              return previousValue;
	            }
	            function flattenEach(geojson, callback) {
	              geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
	                var type = geometry === null ? null : geometry.type;
	                switch (type) {
	                  case null:
	                  case "Point":
	                  case "LineString":
	                  case "Polygon":
	                    if (callback(
	                      helpers.feature(geometry, properties, { bbox, id }),
	                      featureIndex,
	                      0
	                    ) === false)
	                      return false;
	                    return;
	                }
	                var geomType;
	                switch (type) {
	                  case "MultiPoint":
	                    geomType = "Point";
	                    break;
	                  case "MultiLineString":
	                    geomType = "LineString";
	                    break;
	                  case "MultiPolygon":
	                    geomType = "Polygon";
	                    break;
	                }
	                for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
	                  var coordinate = geometry.coordinates[multiFeatureIndex];
	                  var geom = {
	                    type: geomType,
	                    coordinates: coordinate
	                  };
	                  if (callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) === false)
	                    return false;
	                }
	              });
	            }
	            function flattenReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              flattenEach(
	                geojson,
	                function(currentFeature, featureIndex, multiFeatureIndex) {
	                  if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined)
	                    previousValue = currentFeature;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentFeature,
	                      featureIndex,
	                      multiFeatureIndex
	                    );
	                }
	              );
	              return previousValue;
	            }
	            function segmentEach(geojson, callback) {
	              flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
	                var segmentIndex = 0;
	                if (!feature.geometry) return;
	                var type = feature.geometry.type;
	                if (type === "Point" || type === "MultiPoint") return;
	                var previousCoords;
	                var previousFeatureIndex = 0;
	                var previousMultiIndex = 0;
	                var prevGeomIndex = 0;
	                if (coordEach(
	                  feature,
	                  function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
	                    if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
	                      previousCoords = currentCoord;
	                      previousFeatureIndex = featureIndex;
	                      previousMultiIndex = multiPartIndexCoord;
	                      prevGeomIndex = geometryIndex;
	                      segmentIndex = 0;
	                      return;
	                    }
	                    var currentSegment = helpers.lineString(
	                      [previousCoords, currentCoord],
	                      feature.properties
	                    );
	                    if (callback(
	                      currentSegment,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex,
	                      segmentIndex
	                    ) === false)
	                      return false;
	                    segmentIndex++;
	                    previousCoords = currentCoord;
	                  }
	                ) === false)
	                  return false;
	              });
	            }
	            function segmentReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              var started = false;
	              segmentEach(
	                geojson,
	                function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	                  if (started === false && initialValue === undefined)
	                    previousValue = currentSegment;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentSegment,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex,
	                      segmentIndex
	                    );
	                  started = true;
	                }
	              );
	              return previousValue;
	            }
	            function lineEach(geojson, callback) {
	              if (!geojson) throw new Error("geojson is required");
	              flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
	                if (feature.geometry === null) return;
	                var type = feature.geometry.type;
	                var coords = feature.geometry.coordinates;
	                switch (type) {
	                  case "LineString":
	                    if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false)
	                      return false;
	                    break;
	                  case "Polygon":
	                    for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
	                      if (callback(
	                        helpers.lineString(coords[geometryIndex], feature.properties),
	                        featureIndex,
	                        multiFeatureIndex,
	                        geometryIndex
	                      ) === false)
	                        return false;
	                    }
	                    break;
	                }
	              });
	            }
	            function lineReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              lineEach(
	                geojson,
	                function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	                  if (featureIndex === 0 && initialValue === undefined)
	                    previousValue = currentLine;
	                  else
	                    previousValue = callback(
	                      previousValue,
	                      currentLine,
	                      featureIndex,
	                      multiFeatureIndex,
	                      geometryIndex
	                    );
	                }
	              );
	              return previousValue;
	            }
	            function findSegment(geojson, options) {
	              options = options || {};
	              if (!helpers.isObject(options)) throw new Error("options is invalid");
	              var featureIndex = options.featureIndex || 0;
	              var multiFeatureIndex = options.multiFeatureIndex || 0;
	              var geometryIndex = options.geometryIndex || 0;
	              var segmentIndex = options.segmentIndex || 0;
	              var properties = options.properties;
	              var geometry;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  if (featureIndex < 0)
	                    featureIndex = geojson.features.length + featureIndex;
	                  properties = properties || geojson.features[featureIndex].properties;
	                  geometry = geojson.features[featureIndex].geometry;
	                  break;
	                case "Feature":
	                  properties = properties || geojson.properties;
	                  geometry = geojson.geometry;
	                  break;
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                case "Polygon":
	                case "MultiLineString":
	                case "MultiPolygon":
	                  geometry = geojson;
	                  break;
	                default:
	                  throw new Error("geojson is invalid");
	              }
	              if (geometry === null) return null;
	              var coords = geometry.coordinates;
	              switch (geometry.type) {
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                  if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
	                  return helpers.lineString(
	                    [coords[segmentIndex], coords[segmentIndex + 1]],
	                    properties,
	                    options
	                  );
	                case "Polygon":
	                  if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	                  if (segmentIndex < 0)
	                    segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
	                  return helpers.lineString(
	                    [
	                      coords[geometryIndex][segmentIndex],
	                      coords[geometryIndex][segmentIndex + 1]
	                    ],
	                    properties,
	                    options
	                  );
	                case "MultiLineString":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (segmentIndex < 0)
	                    segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
	                  return helpers.lineString(
	                    [
	                      coords[multiFeatureIndex][segmentIndex],
	                      coords[multiFeatureIndex][segmentIndex + 1]
	                    ],
	                    properties,
	                    options
	                  );
	                case "MultiPolygon":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (geometryIndex < 0)
	                    geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	                  if (segmentIndex < 0)
	                    segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
	                  return helpers.lineString(
	                    [
	                      coords[multiFeatureIndex][geometryIndex][segmentIndex],
	                      coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
	                    ],
	                    properties,
	                    options
	                  );
	              }
	              throw new Error("geojson is invalid");
	            }
	            function findPoint(geojson, options) {
	              options = options || {};
	              if (!helpers.isObject(options)) throw new Error("options is invalid");
	              var featureIndex = options.featureIndex || 0;
	              var multiFeatureIndex = options.multiFeatureIndex || 0;
	              var geometryIndex = options.geometryIndex || 0;
	              var coordIndex = options.coordIndex || 0;
	              var properties = options.properties;
	              var geometry;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  if (featureIndex < 0)
	                    featureIndex = geojson.features.length + featureIndex;
	                  properties = properties || geojson.features[featureIndex].properties;
	                  geometry = geojson.features[featureIndex].geometry;
	                  break;
	                case "Feature":
	                  properties = properties || geojson.properties;
	                  geometry = geojson.geometry;
	                  break;
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                case "Polygon":
	                case "MultiLineString":
	                case "MultiPolygon":
	                  geometry = geojson;
	                  break;
	                default:
	                  throw new Error("geojson is invalid");
	              }
	              if (geometry === null) return null;
	              var coords = geometry.coordinates;
	              switch (geometry.type) {
	                case "Point":
	                  return helpers.point(coords, properties, options);
	                case "MultiPoint":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  return helpers.point(coords[multiFeatureIndex], properties, options);
	                case "LineString":
	                  if (coordIndex < 0) coordIndex = coords.length + coordIndex;
	                  return helpers.point(coords[coordIndex], properties, options);
	                case "Polygon":
	                  if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	                  if (coordIndex < 0)
	                    coordIndex = coords[geometryIndex].length + coordIndex;
	                  return helpers.point(coords[geometryIndex][coordIndex], properties, options);
	                case "MultiLineString":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (coordIndex < 0)
	                    coordIndex = coords[multiFeatureIndex].length + coordIndex;
	                  return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
	                case "MultiPolygon":
	                  if (multiFeatureIndex < 0)
	                    multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (geometryIndex < 0)
	                    geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	                  if (coordIndex < 0)
	                    coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
	                  return helpers.point(
	                    coords[multiFeatureIndex][geometryIndex][coordIndex],
	                    properties,
	                    options
	                  );
	              }
	              throw new Error("geojson is invalid");
	            }
	            exports2.coordEach = coordEach;
	            exports2.coordReduce = coordReduce;
	            exports2.propEach = propEach;
	            exports2.propReduce = propReduce;
	            exports2.featureEach = featureEach;
	            exports2.featureReduce = featureReduce;
	            exports2.coordAll = coordAll;
	            exports2.geomEach = geomEach;
	            exports2.geomReduce = geomReduce;
	            exports2.flattenEach = flattenEach;
	            exports2.flattenReduce = flattenReduce;
	            exports2.segmentEach = segmentEach;
	            exports2.segmentReduce = segmentReduce;
	            exports2.lineEach = lineEach;
	            exports2.lineReduce = lineReduce;
	            exports2.findSegment = findSegment;
	            exports2.findPoint = findPoint;
	          }
	        ),
	        /***/
	        29261: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            var meta_1 = __webpack_require__2(88553);
	            var helpers_1 = __webpack_require__2(64182);
	            function centroid(geojson, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var xSum = 0;
	              var ySum = 0;
	              var len = 0;
	              meta_1.coordEach(geojson, function(coord) {
	                xSum += coord[0];
	                ySum += coord[1];
	                len++;
	              });
	              return helpers_1.point([xSum / len, ySum / len], options.properties);
	            }
	            exports2["default"] = centroid;
	          }
	        ),
	        /***/
	        64182: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            exports2.earthRadius = 63710088e-1;
	            exports2.factors = {
	              centimeters: exports2.earthRadius * 100,
	              centimetres: exports2.earthRadius * 100,
	              degrees: exports2.earthRadius / 111325,
	              feet: exports2.earthRadius * 3.28084,
	              inches: exports2.earthRadius * 39.37,
	              kilometers: exports2.earthRadius / 1e3,
	              kilometres: exports2.earthRadius / 1e3,
	              meters: exports2.earthRadius,
	              metres: exports2.earthRadius,
	              miles: exports2.earthRadius / 1609.344,
	              millimeters: exports2.earthRadius * 1e3,
	              millimetres: exports2.earthRadius * 1e3,
	              nauticalmiles: exports2.earthRadius / 1852,
	              radians: 1,
	              yards: exports2.earthRadius / 1.0936
	            };
	            exports2.unitsFactors = {
	              centimeters: 100,
	              centimetres: 100,
	              degrees: 1 / 111325,
	              feet: 3.28084,
	              inches: 39.37,
	              kilometers: 1 / 1e3,
	              kilometres: 1 / 1e3,
	              meters: 1,
	              metres: 1,
	              miles: 1 / 1609.344,
	              millimeters: 1e3,
	              millimetres: 1e3,
	              nauticalmiles: 1 / 1852,
	              radians: 1 / exports2.earthRadius,
	              yards: 1 / 1.0936
	            };
	            exports2.areaFactors = {
	              acres: 247105e-9,
	              centimeters: 1e4,
	              centimetres: 1e4,
	              feet: 10.763910417,
	              inches: 1550.003100006,
	              kilometers: 1e-6,
	              kilometres: 1e-6,
	              meters: 1,
	              metres: 1,
	              miles: 386e-9,
	              millimeters: 1e6,
	              millimetres: 1e6,
	              yards: 1.195990046
	            };
	            function feature(geom, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var feat = { type: "Feature" };
	              if (options.id === 0 || options.id) {
	                feat.id = options.id;
	              }
	              if (options.bbox) {
	                feat.bbox = options.bbox;
	              }
	              feat.properties = properties || {};
	              feat.geometry = geom;
	              return feat;
	            }
	            exports2.feature = feature;
	            function geometry(type, coordinates, options) {
	              switch (type) {
	                case "Point":
	                  return point(coordinates).geometry;
	                case "LineString":
	                  return lineString(coordinates).geometry;
	                case "Polygon":
	                  return polygon(coordinates).geometry;
	                case "MultiPoint":
	                  return multiPoint(coordinates).geometry;
	                case "MultiLineString":
	                  return multiLineString(coordinates).geometry;
	                case "MultiPolygon":
	                  return multiPolygon(coordinates).geometry;
	                default:
	                  throw new Error(type + " is invalid");
	              }
	            }
	            exports2.geometry = geometry;
	            function point(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "Point",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.point = point;
	            function points(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return point(coords, properties);
	              }), options);
	            }
	            exports2.points = points;
	            function polygon(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
	                var ring = coordinates_1[_i];
	                if (ring.length < 4) {
	                  throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
	                }
	                for (var j = 0; j < ring[ring.length - 1].length; j++) {
	                  if (ring[ring.length - 1][j] !== ring[0][j]) {
	                    throw new Error("First and last Position are not equivalent.");
	                  }
	                }
	              }
	              var geom = {
	                type: "Polygon",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.polygon = polygon;
	            function polygons(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return polygon(coords, properties);
	              }), options);
	            }
	            exports2.polygons = polygons;
	            function lineString(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              if (coordinates.length < 2) {
	                throw new Error("coordinates must be an array of two or more positions");
	              }
	              var geom = {
	                type: "LineString",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.lineString = lineString;
	            function lineStrings(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              return featureCollection(coordinates.map(function(coords) {
	                return lineString(coords, properties);
	              }), options);
	            }
	            exports2.lineStrings = lineStrings;
	            function featureCollection(features, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var fc = { type: "FeatureCollection" };
	              if (options.id) {
	                fc.id = options.id;
	              }
	              if (options.bbox) {
	                fc.bbox = options.bbox;
	              }
	              fc.features = features;
	              return fc;
	            }
	            exports2.featureCollection = featureCollection;
	            function multiLineString(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiLineString",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiLineString = multiLineString;
	            function multiPoint(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiPoint",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiPoint = multiPoint;
	            function multiPolygon(coordinates, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "MultiPolygon",
	                coordinates
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.multiPolygon = multiPolygon;
	            function geometryCollection(geometries, properties, options) {
	              if (options === undefined) {
	                options = {};
	              }
	              var geom = {
	                type: "GeometryCollection",
	                geometries
	              };
	              return feature(geom, properties, options);
	            }
	            exports2.geometryCollection = geometryCollection;
	            function round(num, precision) {
	              if (precision === undefined) {
	                precision = 0;
	              }
	              if (precision && !(precision >= 0)) {
	                throw new Error("precision must be a positive number");
	              }
	              var multiplier = Math.pow(10, precision || 0);
	              return Math.round(num * multiplier) / multiplier;
	            }
	            exports2.round = round;
	            function radiansToLength(radians, units) {
	              if (units === undefined) {
	                units = "kilometers";
	              }
	              var factor = exports2.factors[units];
	              if (!factor) {
	                throw new Error(units + " units is invalid");
	              }
	              return radians * factor;
	            }
	            exports2.radiansToLength = radiansToLength;
	            function lengthToRadians(distance, units) {
	              if (units === undefined) {
	                units = "kilometers";
	              }
	              var factor = exports2.factors[units];
	              if (!factor) {
	                throw new Error(units + " units is invalid");
	              }
	              return distance / factor;
	            }
	            exports2.lengthToRadians = lengthToRadians;
	            function lengthToDegrees(distance, units) {
	              return radiansToDegrees(lengthToRadians(distance, units));
	            }
	            exports2.lengthToDegrees = lengthToDegrees;
	            function bearingToAzimuth(bearing) {
	              var angle = bearing % 360;
	              if (angle < 0) {
	                angle += 360;
	              }
	              return angle;
	            }
	            exports2.bearingToAzimuth = bearingToAzimuth;
	            function radiansToDegrees(radians) {
	              var degrees = radians % (2 * Math.PI);
	              return degrees * 180 / Math.PI;
	            }
	            exports2.radiansToDegrees = radiansToDegrees;
	            function degreesToRadians(degrees) {
	              var radians = degrees % 360;
	              return radians * Math.PI / 180;
	            }
	            exports2.degreesToRadians = degreesToRadians;
	            function convertLength(length, originalUnit, finalUnit) {
	              if (originalUnit === undefined) {
	                originalUnit = "kilometers";
	              }
	              if (finalUnit === undefined) {
	                finalUnit = "kilometers";
	              }
	              if (!(length >= 0)) {
	                throw new Error("length must be a positive number");
	              }
	              return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
	            }
	            exports2.convertLength = convertLength;
	            function convertArea(area, originalUnit, finalUnit) {
	              if (originalUnit === undefined) {
	                originalUnit = "meters";
	              }
	              if (finalUnit === undefined) {
	                finalUnit = "kilometers";
	              }
	              if (!(area >= 0)) {
	                throw new Error("area must be a positive number");
	              }
	              var startFactor = exports2.areaFactors[originalUnit];
	              if (!startFactor) {
	                throw new Error("invalid original units");
	              }
	              var finalFactor = exports2.areaFactors[finalUnit];
	              if (!finalFactor) {
	                throw new Error("invalid final units");
	              }
	              return area / startFactor * finalFactor;
	            }
	            exports2.convertArea = convertArea;
	            function isNumber(num) {
	              return !isNaN(num) && num !== null && !Array.isArray(num) && !/^\s*$/.test(num);
	            }
	            exports2.isNumber = isNumber;
	            function isObject(input) {
	              return !!input && input.constructor === Object;
	            }
	            exports2.isObject = isObject;
	            function validateBBox(bbox) {
	              if (!bbox) {
	                throw new Error("bbox is required");
	              }
	              if (!Array.isArray(bbox)) {
	                throw new Error("bbox must be an Array");
	              }
	              if (bbox.length !== 4 && bbox.length !== 6) {
	                throw new Error("bbox must be an Array of 4 or 6 numbers");
	              }
	              bbox.forEach(function(num) {
	                if (!isNumber(num)) {
	                  throw new Error("bbox must only contain numbers");
	                }
	              });
	            }
	            exports2.validateBBox = validateBBox;
	            function validateId(id) {
	              if (!id) {
	                throw new Error("id is required");
	              }
	              if (["string", "number"].indexOf(typeof id) === -1) {
	                throw new Error("id must be a number or a string");
	              }
	            }
	            exports2.validateId = validateId;
	            function radians2degrees() {
	              throw new Error("method has been renamed to `radiansToDegrees`");
	            }
	            exports2.radians2degrees = radians2degrees;
	            function degrees2radians() {
	              throw new Error("method has been renamed to `degreesToRadians`");
	            }
	            exports2.degrees2radians = degrees2radians;
	            function distanceToDegrees() {
	              throw new Error("method has been renamed to `lengthToDegrees`");
	            }
	            exports2.distanceToDegrees = distanceToDegrees;
	            function distanceToRadians() {
	              throw new Error("method has been renamed to `lengthToRadians`");
	            }
	            exports2.distanceToRadians = distanceToRadians;
	            function radiansToDistance() {
	              throw new Error("method has been renamed to `radiansToLength`");
	            }
	            exports2.radiansToDistance = radiansToDistance;
	            function bearingToAngle() {
	              throw new Error("method has been renamed to `bearingToAzimuth`");
	            }
	            exports2.bearingToAngle = bearingToAngle;
	            function convertDistance() {
	              throw new Error("method has been renamed to `convertLength`");
	            }
	            exports2.convertDistance = convertDistance;
	          }
	        ),
	        /***/
	        88553: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            Object.defineProperty(exports2, "__esModule", { value: true });
	            var helpers = __webpack_require__2(64182);
	            function coordEach(geojson, callback, excludeWrapCoord) {
	              if (geojson === null) return;
	              var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
	              for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
	                geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
	                isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
	                stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	                for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
	                  var multiFeatureIndex = 0;
	                  var geometryIndex = 0;
	                  geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
	                  if (geometry === null) continue;
	                  coords = geometry.coordinates;
	                  var geomType = geometry.type;
	                  wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
	                  switch (geomType) {
	                    case null:
	                      break;
	                    case "Point":
	                      if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                      coordIndex++;
	                      multiFeatureIndex++;
	                      break;
	                    case "LineString":
	                    case "MultiPoint":
	                      for (j = 0; j < coords.length; j++) {
	                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                        coordIndex++;
	                        if (geomType === "MultiPoint") multiFeatureIndex++;
	                      }
	                      if (geomType === "LineString") multiFeatureIndex++;
	                      break;
	                    case "Polygon":
	                    case "MultiLineString":
	                      for (j = 0; j < coords.length; j++) {
	                        for (k = 0; k < coords[j].length - wrapShrink; k++) {
	                          if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                          coordIndex++;
	                        }
	                        if (geomType === "MultiLineString") multiFeatureIndex++;
	                        if (geomType === "Polygon") geometryIndex++;
	                      }
	                      if (geomType === "Polygon") multiFeatureIndex++;
	                      break;
	                    case "MultiPolygon":
	                      for (j = 0; j < coords.length; j++) {
	                        geometryIndex = 0;
	                        for (k = 0; k < coords[j].length; k++) {
	                          for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
	                            if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                            coordIndex++;
	                          }
	                          geometryIndex++;
	                        }
	                        multiFeatureIndex++;
	                      }
	                      break;
	                    case "GeometryCollection":
	                      for (j = 0; j < geometry.geometries.length; j++)
	                        if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
	                      break;
	                    default:
	                      throw new Error("Unknown Geometry Type");
	                  }
	                }
	              }
	            }
	            function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
	              var previousValue = initialValue;
	              coordEach(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
	                if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
	                else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
	              }, excludeWrapCoord);
	              return previousValue;
	            }
	            function propEach(geojson, callback) {
	              var i;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  for (i = 0; i < geojson.features.length; i++) {
	                    if (callback(geojson.features[i].properties, i) === false) break;
	                  }
	                  break;
	                case "Feature":
	                  callback(geojson.properties, 0);
	                  break;
	              }
	            }
	            function propReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              propEach(geojson, function(currentProperties, featureIndex) {
	                if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
	                else previousValue = callback(previousValue, currentProperties, featureIndex);
	              });
	              return previousValue;
	            }
	            function featureEach(geojson, callback) {
	              if (geojson.type === "Feature") {
	                callback(geojson, 0);
	              } else if (geojson.type === "FeatureCollection") {
	                for (var i = 0; i < geojson.features.length; i++) {
	                  if (callback(geojson.features[i], i) === false) break;
	                }
	              }
	            }
	            function featureReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              featureEach(geojson, function(currentFeature, featureIndex) {
	                if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
	                else previousValue = callback(previousValue, currentFeature, featureIndex);
	              });
	              return previousValue;
	            }
	            function coordAll(geojson) {
	              var coords = [];
	              coordEach(geojson, function(coord) {
	                coords.push(coord);
	              });
	              return coords;
	            }
	            function geomEach(geojson, callback) {
	              var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
	              for (i = 0; i < stop; i++) {
	                geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
	                featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
	                featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
	                featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
	                isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
	                stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
	                for (g = 0; g < stopG; g++) {
	                  geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
	                  if (geometry === null) {
	                    if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
	                    continue;
	                  }
	                  switch (geometry.type) {
	                    case "Point":
	                    case "LineString":
	                    case "MultiPoint":
	                    case "Polygon":
	                    case "MultiLineString":
	                    case "MultiPolygon": {
	                      if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
	                      break;
	                    }
	                    case "GeometryCollection": {
	                      for (j = 0; j < geometry.geometries.length; j++) {
	                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
	                      }
	                      break;
	                    }
	                    default:
	                      throw new Error("Unknown Geometry Type");
	                  }
	                }
	                featureIndex++;
	              }
	            }
	            function geomReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              geomEach(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
	                if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
	                else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
	              });
	              return previousValue;
	            }
	            function flattenEach(geojson, callback) {
	              geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
	                var type = geometry === null ? null : geometry.type;
	                switch (type) {
	                  case null:
	                  case "Point":
	                  case "LineString":
	                  case "Polygon":
	                    if (callback(helpers.feature(geometry, properties, { bbox, id }), featureIndex, 0) === false) return false;
	                    return;
	                }
	                var geomType;
	                switch (type) {
	                  case "MultiPoint":
	                    geomType = "Point";
	                    break;
	                  case "MultiLineString":
	                    geomType = "LineString";
	                    break;
	                  case "MultiPolygon":
	                    geomType = "Polygon";
	                    break;
	                }
	                for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
	                  var coordinate = geometry.coordinates[multiFeatureIndex];
	                  var geom = {
	                    type: geomType,
	                    coordinates: coordinate
	                  };
	                  if (callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
	                }
	              });
	            }
	            function flattenReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              flattenEach(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
	                if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
	                else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
	              });
	              return previousValue;
	            }
	            function segmentEach(geojson, callback) {
	              flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
	                var segmentIndex = 0;
	                if (!feature.geometry) return;
	                var type = feature.geometry.type;
	                if (type === "Point" || type === "MultiPoint") return;
	                var previousCoords;
	                var previousFeatureIndex = 0;
	                var previousMultiIndex = 0;
	                var prevGeomIndex = 0;
	                if (coordEach(feature, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
	                  if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
	                    previousCoords = currentCoord;
	                    previousFeatureIndex = featureIndex;
	                    previousMultiIndex = multiPartIndexCoord;
	                    prevGeomIndex = geometryIndex;
	                    segmentIndex = 0;
	                    return;
	                  }
	                  var currentSegment = helpers.lineString([previousCoords, currentCoord], feature.properties);
	                  if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
	                  segmentIndex++;
	                  previousCoords = currentCoord;
	                }) === false) return false;
	              });
	            }
	            function segmentReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              var started = false;
	              segmentEach(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
	                if (started === false && initialValue === undefined) previousValue = currentSegment;
	                else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
	                started = true;
	              });
	              return previousValue;
	            }
	            function lineEach(geojson, callback) {
	              if (!geojson) throw new Error("geojson is required");
	              flattenEach(geojson, function(feature, featureIndex, multiFeatureIndex) {
	                if (feature.geometry === null) return;
	                var type = feature.geometry.type;
	                var coords = feature.geometry.coordinates;
	                switch (type) {
	                  case "LineString":
	                    if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
	                    break;
	                  case "Polygon":
	                    for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
	                      if (callback(helpers.lineString(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
	                    }
	                    break;
	                }
	              });
	            }
	            function lineReduce(geojson, callback, initialValue) {
	              var previousValue = initialValue;
	              lineEach(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
	                if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
	                else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
	              });
	              return previousValue;
	            }
	            function findSegment(geojson, options) {
	              options = options || {};
	              if (!helpers.isObject(options)) throw new Error("options is invalid");
	              var featureIndex = options.featureIndex || 0;
	              var multiFeatureIndex = options.multiFeatureIndex || 0;
	              var geometryIndex = options.geometryIndex || 0;
	              var segmentIndex = options.segmentIndex || 0;
	              var properties = options.properties;
	              var geometry;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
	                  properties = properties || geojson.features[featureIndex].properties;
	                  geometry = geojson.features[featureIndex].geometry;
	                  break;
	                case "Feature":
	                  properties = properties || geojson.properties;
	                  geometry = geojson.geometry;
	                  break;
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                case "Polygon":
	                case "MultiLineString":
	                case "MultiPolygon":
	                  geometry = geojson;
	                  break;
	                default:
	                  throw new Error("geojson is invalid");
	              }
	              if (geometry === null) return null;
	              var coords = geometry.coordinates;
	              switch (geometry.type) {
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                  if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
	                  return helpers.lineString([coords[segmentIndex], coords[segmentIndex + 1]], properties, options);
	                case "Polygon":
	                  if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	                  if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
	                  return helpers.lineString([coords[geometryIndex][segmentIndex], coords[geometryIndex][segmentIndex + 1]], properties, options);
	                case "MultiLineString":
	                  if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
	                  return helpers.lineString([coords[multiFeatureIndex][segmentIndex], coords[multiFeatureIndex][segmentIndex + 1]], properties, options);
	                case "MultiPolygon":
	                  if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	                  if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
	                  return helpers.lineString([coords[multiFeatureIndex][geometryIndex][segmentIndex], coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]], properties, options);
	              }
	              throw new Error("geojson is invalid");
	            }
	            function findPoint(geojson, options) {
	              options = options || {};
	              if (!helpers.isObject(options)) throw new Error("options is invalid");
	              var featureIndex = options.featureIndex || 0;
	              var multiFeatureIndex = options.multiFeatureIndex || 0;
	              var geometryIndex = options.geometryIndex || 0;
	              var coordIndex = options.coordIndex || 0;
	              var properties = options.properties;
	              var geometry;
	              switch (geojson.type) {
	                case "FeatureCollection":
	                  if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
	                  properties = properties || geojson.features[featureIndex].properties;
	                  geometry = geojson.features[featureIndex].geometry;
	                  break;
	                case "Feature":
	                  properties = properties || geojson.properties;
	                  geometry = geojson.geometry;
	                  break;
	                case "Point":
	                case "MultiPoint":
	                  return null;
	                case "LineString":
	                case "Polygon":
	                case "MultiLineString":
	                case "MultiPolygon":
	                  geometry = geojson;
	                  break;
	                default:
	                  throw new Error("geojson is invalid");
	              }
	              if (geometry === null) return null;
	              var coords = geometry.coordinates;
	              switch (geometry.type) {
	                case "Point":
	                  return helpers.point(coords, properties, options);
	                case "MultiPoint":
	                  if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	                  return helpers.point(coords[multiFeatureIndex], properties, options);
	                case "LineString":
	                  if (coordIndex < 0) coordIndex = coords.length + coordIndex;
	                  return helpers.point(coords[coordIndex], properties, options);
	                case "Polygon":
	                  if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
	                  if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
	                  return helpers.point(coords[geometryIndex][coordIndex], properties, options);
	                case "MultiLineString":
	                  if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
	                  return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
	                case "MultiPolygon":
	                  if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
	                  if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
	                  if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
	                  return helpers.point(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
	              }
	              throw new Error("geojson is invalid");
	            }
	            exports2.coordEach = coordEach;
	            exports2.coordReduce = coordReduce;
	            exports2.propEach = propEach;
	            exports2.propReduce = propReduce;
	            exports2.featureEach = featureEach;
	            exports2.featureReduce = featureReduce;
	            exports2.coordAll = coordAll;
	            exports2.geomEach = geomEach;
	            exports2.geomReduce = geomReduce;
	            exports2.flattenEach = flattenEach;
	            exports2.flattenReduce = flattenReduce;
	            exports2.segmentEach = segmentEach;
	            exports2.segmentReduce = segmentReduce;
	            exports2.lineEach = lineEach;
	            exports2.lineReduce = lineReduce;
	            exports2.findSegment = findSegment;
	            exports2.findPoint = findPoint;
	          }
	        ),
	        /***/
	        65185: (
	          /***/
	          function(module2) {
	            module2.exports = absolutize;
	            function absolutize(path) {
	              var startX = 0;
	              var startY = 0;
	              var x = 0;
	              var y = 0;
	              return path.map(function(seg) {
	                seg = seg.slice();
	                var type = seg[0];
	                var command = type.toUpperCase();
	                if (type != command) {
	                  seg[0] = command;
	                  switch (type) {
	                    case "a":
	                      seg[6] += x;
	                      seg[7] += y;
	                      break;
	                    case "v":
	                      seg[1] += y;
	                      break;
	                    case "h":
	                      seg[1] += x;
	                      break;
	                    default:
	                      for (var i = 1; i < seg.length; ) {
	                        seg[i++] += x;
	                        seg[i++] += y;
	                      }
	                  }
	                }
	                switch (command) {
	                  case "Z":
	                    x = startX;
	                    y = startY;
	                    break;
	                  case "H":
	                    x = seg[1];
	                    break;
	                  case "V":
	                    y = seg[1];
	                    break;
	                  case "M":
	                    x = startX = seg[1];
	                    y = startY = seg[2];
	                    break;
	                  default:
	                    x = seg[seg.length - 2];
	                    y = seg[seg.length - 1];
	                }
	                return seg;
	              });
	            }
	          }
	        ),
	        /***/
	        21527: (
	          /***/
	          function(module2) {
	            module2.exports = normalize;
	            function normalize(arr, dim) {
	              if (!arr || arr.length == null) throw Error("Argument should be an array");
	              if (dim == null) dim = 1;
	              else dim = Math.floor(dim);
	              var bounds = Array(dim * 2);
	              for (var offset = 0; offset < dim; offset++) {
	                var max = -Infinity, min = Infinity, i = offset, l = arr.length;
	                for (; i < l; i += dim) {
	                  if (arr[i] > max) max = arr[i];
	                  if (arr[i] < min) min = arr[i];
	                }
	                bounds[offset] = min;
	                bounds[dim + offset] = max;
	              }
	              return bounds;
	            }
	          }
	        ),
	        /***/
	        6851: (
	          /***/
	          function(module2) {
	            module2.exports = function(arr, predicate, ctx) {
	              if (typeof Array.prototype.findIndex === "function") {
	                return arr.findIndex(predicate, ctx);
	              }
	              if (typeof predicate !== "function") {
	                throw new TypeError("predicate must be a function");
	              }
	              var list = Object(arr);
	              var len = list.length;
	              if (len === 0) {
	                return -1;
	              }
	              for (var i = 0; i < len; i++) {
	                if (predicate.call(ctx, list[i], i, list)) {
	                  return i;
	                }
	              }
	              return -1;
	            };
	          }
	        ),
	        /***/
	        54: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getBounds = __webpack_require__2(21527);
	            module2.exports = normalize;
	            function normalize(arr, dim, bounds) {
	              if (!arr || arr.length == null) throw Error("Argument should be an array");
	              if (dim == null) dim = 1;
	              if (bounds == null) bounds = getBounds(arr, dim);
	              for (var offset = 0; offset < dim; offset++) {
	                var max = bounds[dim + offset], min = bounds[offset], i = offset, l = arr.length;
	                if (max === Infinity && min === -Infinity) {
	                  for (i = offset; i < l; i += dim) {
	                    arr[i] = arr[i] === max ? 1 : arr[i] === min ? 0 : 0.5;
	                  }
	                } else if (max === Infinity) {
	                  for (i = offset; i < l; i += dim) {
	                    arr[i] = arr[i] === max ? 1 : 0;
	                  }
	                } else if (min === -Infinity) {
	                  for (i = offset; i < l; i += dim) {
	                    arr[i] = arr[i] === min ? 0 : 1;
	                  }
	                } else {
	                  var range2 = max - min;
	                  for (i = offset; i < l; i += dim) {
	                    if (!isNaN(arr[i])) {
	                      arr[i] = range2 === 0 ? 0.5 : (arr[i] - min) / range2;
	                    }
	                  }
	                }
	              }
	              return arr;
	            }
	          }
	        ),
	        /***/
	        57471: (
	          /***/
	          function(module2) {
	            module2.exports = function newArray(start, end) {
	              var n0 = typeof start === "number", n1 = typeof end === "number";
	              if (n0 && !n1) {
	                end = start;
	                start = 0;
	              } else if (!n0 && !n1) {
	                start = 0;
	                end = 0;
	              }
	              start = start | 0;
	              end = end | 0;
	              var len = end - start;
	              if (len < 0)
	                throw new Error("array length must be positive");
	              var a = new Array(len);
	              for (var i = 0, c = start; i < len; i++, c++)
	                a[i] = c;
	              return a;
	            };
	          }
	        ),
	        /***/
	        32791: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            function _typeof(obj) {
	              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	                _typeof = function _typeof2(obj2) {
	                  return typeof obj2;
	                };
	              } else {
	                _typeof = function _typeof2(obj2) {
	                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	                };
	              }
	              return _typeof(obj);
	            }
	            function _classCallCheck(instance, Constructor) {
	              if (!(instance instanceof Constructor)) {
	                throw new TypeError("Cannot call a class as a function");
	              }
	            }
	            var _require = __webpack_require__2(79616), _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
	            var AssertionError = __webpack_require__2(73894);
	            var _require2 = __webpack_require__2(43827), inspect = _require2.inspect;
	            var _require$types = __webpack_require__2(43827).types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
	            var objectAssign = Object.assign ? Object.assign : __webpack_require__2(73523).assign;
	            var objectIs = Object.is ? Object.is : __webpack_require__2(64003);
	            var isDeepEqual;
	            var isDeepStrictEqual;
	            function lazyLoadComparison() {
	              var comparison = __webpack_require__2(74061);
	              isDeepEqual = comparison.isDeepEqual;
	              isDeepStrictEqual = comparison.isDeepStrictEqual;
	            }
	            var warned = false;
	            var assert = module2.exports = ok;
	            var NO_EXCEPTION_SENTINEL = {};
	            function innerFail(obj) {
	              if (obj.message instanceof Error) throw obj.message;
	              throw new AssertionError(obj);
	            }
	            function fail(actual, expected, message, operator, stackStartFn) {
	              var argsLen = arguments.length;
	              var internalMessage;
	              if (argsLen === 0) {
	                internalMessage = "Failed";
	              } else if (argsLen === 1) {
	                message = actual;
	                actual = undefined;
	              } else {
	                if (warned === false) {
	                  warned = true;
	                  var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
	                  warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
	                }
	                if (argsLen === 2) operator = "!=";
	              }
	              if (message instanceof Error) throw message;
	              var errArgs = {
	                actual,
	                expected,
	                operator: operator === undefined ? "fail" : operator,
	                stackStartFn: stackStartFn || fail
	              };
	              if (message !== undefined) {
	                errArgs.message = message;
	              }
	              var err = new AssertionError(errArgs);
	              if (internalMessage) {
	                err.message = internalMessage;
	                err.generatedMessage = true;
	              }
	              throw err;
	            }
	            assert.fail = fail;
	            assert.AssertionError = AssertionError;
	            function innerOk(fn, argLen, value, message) {
	              if (!value) {
	                var generatedMessage = false;
	                if (argLen === 0) {
	                  generatedMessage = true;
	                  message = "No value argument passed to `assert.ok()`";
	                } else if (message instanceof Error) {
	                  throw message;
	                }
	                var err = new AssertionError({
	                  actual: value,
	                  expected: true,
	                  message,
	                  operator: "==",
	                  stackStartFn: fn
	                });
	                err.generatedMessage = generatedMessage;
	                throw err;
	              }
	            }
	            function ok() {
	              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	              }
	              innerOk.apply(undefined, [ok, args.length].concat(args));
	            }
	            assert.ok = ok;
	            assert.equal = function equal(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (actual != expected) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "==",
	                  stackStartFn: equal
	                });
	              }
	            };
	            assert.notEqual = function notEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (actual == expected) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "!=",
	                  stackStartFn: notEqual
	                });
	              }
	            };
	            assert.deepEqual = function deepEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (isDeepEqual === undefined) lazyLoadComparison();
	              if (!isDeepEqual(actual, expected)) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "deepEqual",
	                  stackStartFn: deepEqual
	                });
	              }
	            };
	            assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (isDeepEqual === undefined) lazyLoadComparison();
	              if (isDeepEqual(actual, expected)) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "notDeepEqual",
	                  stackStartFn: notDeepEqual
	                });
	              }
	            };
	            assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (isDeepEqual === undefined) lazyLoadComparison();
	              if (!isDeepStrictEqual(actual, expected)) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "deepStrictEqual",
	                  stackStartFn: deepStrictEqual
	                });
	              }
	            };
	            assert.notDeepStrictEqual = notDeepStrictEqual;
	            function notDeepStrictEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (isDeepEqual === undefined) lazyLoadComparison();
	              if (isDeepStrictEqual(actual, expected)) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "notDeepStrictEqual",
	                  stackStartFn: notDeepStrictEqual
	                });
	              }
	            }
	            assert.strictEqual = function strictEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (!objectIs(actual, expected)) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "strictEqual",
	                  stackStartFn: strictEqual
	                });
	              }
	            };
	            assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	              if (arguments.length < 2) {
	                throw new ERR_MISSING_ARGS("actual", "expected");
	              }
	              if (objectIs(actual, expected)) {
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: "notStrictEqual",
	                  stackStartFn: notStrictEqual
	                });
	              }
	            };
	            var Comparison = function Comparison2(obj, keys, actual) {
	              var _this = this;
	              _classCallCheck(this, Comparison2);
	              keys.forEach(function(key) {
	                if (key in obj) {
	                  if (actual !== undefined && typeof actual[key] === "string" && isRegExp(obj[key]) && obj[key].test(actual[key])) {
	                    _this[key] = actual[key];
	                  } else {
	                    _this[key] = obj[key];
	                  }
	                }
	              });
	            };
	            function compareExceptionKey(actual, expected, key, message, keys, fn) {
	              if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
	                if (!message) {
	                  var a = new Comparison(actual, keys);
	                  var b = new Comparison(expected, keys, actual);
	                  var err = new AssertionError({
	                    actual: a,
	                    expected: b,
	                    operator: "deepStrictEqual",
	                    stackStartFn: fn
	                  });
	                  err.actual = actual;
	                  err.expected = expected;
	                  err.operator = fn.name;
	                  throw err;
	                }
	                innerFail({
	                  actual,
	                  expected,
	                  message,
	                  operator: fn.name,
	                  stackStartFn: fn
	                });
	              }
	            }
	            function expectedException(actual, expected, msg, fn) {
	              if (typeof expected !== "function") {
	                if (isRegExp(expected)) return expected.test(actual);
	                if (arguments.length === 2) {
	                  throw new ERR_INVALID_ARG_TYPE("expected", ["Function", "RegExp"], expected);
	                }
	                if (_typeof(actual) !== "object" || actual === null) {
	                  var err = new AssertionError({
	                    actual,
	                    expected,
	                    message: msg,
	                    operator: "deepStrictEqual",
	                    stackStartFn: fn
	                  });
	                  err.operator = fn.name;
	                  throw err;
	                }
	                var keys = Object.keys(expected);
	                if (expected instanceof Error) {
	                  keys.push("name", "message");
	                } else if (keys.length === 0) {
	                  throw new ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
	                }
	                if (isDeepEqual === undefined) lazyLoadComparison();
	                keys.forEach(function(key) {
	                  if (typeof actual[key] === "string" && isRegExp(expected[key]) && expected[key].test(actual[key])) {
	                    return;
	                  }
	                  compareExceptionKey(actual, expected, key, msg, keys, fn);
	                });
	                return true;
	              }
	              if (expected.prototype !== undefined && actual instanceof expected) {
	                return true;
	              }
	              if (Error.isPrototypeOf(expected)) {
	                return false;
	              }
	              return expected.call({}, actual) === true;
	            }
	            function getActual(fn) {
	              if (typeof fn !== "function") {
	                throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
	              }
	              try {
	                fn();
	              } catch (e) {
	                return e;
	              }
	              return NO_EXCEPTION_SENTINEL;
	            }
	            function checkIsPromise(obj) {
	              return isPromise(obj) || obj !== null && _typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
	            }
	            function waitForActual(promiseFn) {
	              return Promise.resolve().then(function() {
	                var resultPromise;
	                if (typeof promiseFn === "function") {
	                  resultPromise = promiseFn();
	                  if (!checkIsPromise(resultPromise)) {
	                    throw new ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
	                  }
	                } else if (checkIsPromise(promiseFn)) {
	                  resultPromise = promiseFn;
	                } else {
	                  throw new ERR_INVALID_ARG_TYPE("promiseFn", ["Function", "Promise"], promiseFn);
	                }
	                return Promise.resolve().then(function() {
	                  return resultPromise;
	                }).then(function() {
	                  return NO_EXCEPTION_SENTINEL;
	                }).catch(function(e) {
	                  return e;
	                });
	              });
	            }
	            function expectsError(stackStartFn, actual, error, message) {
	              if (typeof error === "string") {
	                if (arguments.length === 4) {
	                  throw new ERR_INVALID_ARG_TYPE("error", ["Object", "Error", "Function", "RegExp"], error);
	                }
	                if (_typeof(actual) === "object" && actual !== null) {
	                  if (actual.message === error) {
	                    throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
	                  }
	                } else if (actual === error) {
	                  throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
	                }
	                message = error;
	                error = undefined;
	              } else if (error != null && _typeof(error) !== "object" && typeof error !== "function") {
	                throw new ERR_INVALID_ARG_TYPE("error", ["Object", "Error", "Function", "RegExp"], error);
	              }
	              if (actual === NO_EXCEPTION_SENTINEL) {
	                var details = "";
	                if (error && error.name) {
	                  details += " (".concat(error.name, ")");
	                }
	                details += message ? ": ".concat(message) : ".";
	                var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
	                innerFail({
	                  actual: undefined,
	                  expected: error,
	                  operator: stackStartFn.name,
	                  message: "Missing expected ".concat(fnType).concat(details),
	                  stackStartFn
	                });
	              }
	              if (error && !expectedException(actual, error, message, stackStartFn)) {
	                throw actual;
	              }
	            }
	            function expectsNoError(stackStartFn, actual, error, message) {
	              if (actual === NO_EXCEPTION_SENTINEL) return;
	              if (typeof error === "string") {
	                message = error;
	                error = undefined;
	              }
	              if (!error || expectedException(actual, error)) {
	                var details = message ? ": ".concat(message) : ".";
	                var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
	                innerFail({
	                  actual,
	                  expected: error,
	                  operator: stackStartFn.name,
	                  message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
	                  stackStartFn
	                });
	              }
	              throw actual;
	            }
	            assert.throws = function throws(promiseFn) {
	              for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	                args[_key2 - 1] = arguments[_key2];
	              }
	              expectsError.apply(undefined, [throws, getActual(promiseFn)].concat(args));
	            };
	            assert.rejects = function rejects(promiseFn) {
	              for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	                args[_key3 - 1] = arguments[_key3];
	              }
	              return waitForActual(promiseFn).then(function(result) {
	                return expectsError.apply(undefined, [rejects, result].concat(args));
	              });
	            };
	            assert.doesNotThrow = function doesNotThrow(fn) {
	              for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	                args[_key4 - 1] = arguments[_key4];
	              }
	              expectsNoError.apply(undefined, [doesNotThrow, getActual(fn)].concat(args));
	            };
	            assert.doesNotReject = function doesNotReject(fn) {
	              for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	                args[_key5 - 1] = arguments[_key5];
	              }
	              return waitForActual(fn).then(function(result) {
	                return expectsNoError.apply(undefined, [doesNotReject, result].concat(args));
	              });
	            };
	            assert.ifError = function ifError(err) {
	              if (err !== null && err !== undefined) {
	                var message = "ifError got unwanted exception: ";
	                if (_typeof(err) === "object" && typeof err.message === "string") {
	                  if (err.message.length === 0 && err.constructor) {
	                    message += err.constructor.name;
	                  } else {
	                    message += err.message;
	                  }
	                } else {
	                  message += inspect(err);
	                }
	                var newErr = new AssertionError({
	                  actual: err,
	                  expected: null,
	                  operator: "ifError",
	                  message,
	                  stackStartFn: ifError
	                });
	                var origStack = err.stack;
	                if (typeof origStack === "string") {
	                  var tmp2 = origStack.split("\n");
	                  tmp2.shift();
	                  var tmp1 = newErr.stack.split("\n");
	                  for (var i = 0; i < tmp2.length; i++) {
	                    var pos = tmp1.indexOf(tmp2[i]);
	                    if (pos !== -1) {
	                      tmp1 = tmp1.slice(0, pos);
	                      break;
	                    }
	                  }
	                  newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
	                }
	                throw newErr;
	              }
	            };
	            function strict() {
	              for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	                args[_key6] = arguments[_key6];
	              }
	              innerOk.apply(undefined, [strict, args.length].concat(args));
	            }
	            assert.strict = objectAssign(strict, assert, {
	              equal: assert.strictEqual,
	              deepEqual: assert.deepStrictEqual,
	              notEqual: assert.notStrictEqual,
	              notDeepEqual: assert.notDeepStrictEqual
	            });
	            assert.strict.strict = assert.strict;
	          }
	        ),
	        /***/
	        73894: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            function _objectSpread(target) {
	              for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i] != null ? arguments[i] : {};
	                var ownKeys = Object.keys(source);
	                if (typeof Object.getOwnPropertySymbols === "function") {
	                  ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
	                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	                  }));
	                }
	                ownKeys.forEach(function(key) {
	                  _defineProperty(target, key, source[key]);
	                });
	              }
	              return target;
	            }
	            function _defineProperty(obj, key, value) {
	              if (key in obj) {
	                Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
	              } else {
	                obj[key] = value;
	              }
	              return obj;
	            }
	            function _classCallCheck(instance, Constructor) {
	              if (!(instance instanceof Constructor)) {
	                throw new TypeError("Cannot call a class as a function");
	              }
	            }
	            function _defineProperties(target, props) {
	              for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	              }
	            }
	            function _createClass(Constructor, protoProps, staticProps) {
	              _defineProperties(Constructor.prototype, protoProps);
	              return Constructor;
	            }
	            function _possibleConstructorReturn(self2, call) {
	              if (call && (_typeof(call) === "object" || typeof call === "function")) {
	                return call;
	              }
	              return _assertThisInitialized(self2);
	            }
	            function _assertThisInitialized(self2) {
	              if (self2 === undefined) {
	                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	              }
	              return self2;
	            }
	            function _inherits(subClass, superClass) {
	              if (typeof superClass !== "function" && superClass !== null) {
	                throw new TypeError("Super expression must either be null or a function");
	              }
	              subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
	              if (superClass) _setPrototypeOf(subClass, superClass);
	            }
	            function _wrapNativeSuper(Class) {
	              var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : undefined;
	              _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
	                if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
	                if (typeof Class2 !== "function") {
	                  throw new TypeError("Super expression must either be null or a function");
	                }
	                if (typeof _cache !== "undefined") {
	                  if (_cache.has(Class2)) return _cache.get(Class2);
	                  _cache.set(Class2, Wrapper);
	                }
	                function Wrapper() {
	                  return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
	                }
	                Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
	                return _setPrototypeOf(Wrapper, Class2);
	              };
	              return _wrapNativeSuper(Class);
	            }
	            function isNativeReflectConstruct() {
	              if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	              if (Reflect.construct.sham) return false;
	              if (typeof Proxy === "function") return true;
	              try {
	                Date.prototype.toString.call(Reflect.construct(Date, [], function() {
	                }));
	                return true;
	              } catch (e) {
	                return false;
	              }
	            }
	            function _construct(Parent, args, Class) {
	              if (isNativeReflectConstruct()) {
	                _construct = Reflect.construct;
	              } else {
	                _construct = function _construct2(Parent2, args2, Class2) {
	                  var a = [null];
	                  a.push.apply(a, args2);
	                  var Constructor = Function.bind.apply(Parent2, a);
	                  var instance = new Constructor();
	                  if (Class2) _setPrototypeOf(instance, Class2.prototype);
	                  return instance;
	                };
	              }
	              return _construct.apply(null, arguments);
	            }
	            function _isNativeFunction(fn) {
	              return Function.toString.call(fn).indexOf("[native code]") !== -1;
	            }
	            function _setPrototypeOf(o, p) {
	              _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
	                o2.__proto__ = p2;
	                return o2;
	              };
	              return _setPrototypeOf(o, p);
	            }
	            function _getPrototypeOf(o) {
	              _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
	                return o2.__proto__ || Object.getPrototypeOf(o2);
	              };
	              return _getPrototypeOf(o);
	            }
	            function _typeof(obj) {
	              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	                _typeof = function _typeof2(obj2) {
	                  return typeof obj2;
	                };
	              } else {
	                _typeof = function _typeof2(obj2) {
	                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	                };
	              }
	              return _typeof(obj);
	            }
	            var _require = __webpack_require__2(43827), inspect = _require.inspect;
	            var _require2 = __webpack_require__2(79616), ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;
	            function endsWith(str, search, this_len) {
	              if (this_len === undefined || this_len > str.length) {
	                this_len = str.length;
	              }
	              return str.substring(this_len - search.length, this_len) === search;
	            }
	            function repeat(str, count) {
	              count = Math.floor(count);
	              if (str.length == 0 || count == 0) return "";
	              var maxCount = str.length * count;
	              count = Math.floor(Math.log(count) / Math.log(2));
	              while (count) {
	                str += str;
	                count--;
	              }
	              str += str.substring(0, maxCount - str.length);
	              return str;
	            }
	            var blue = "";
	            var green = "";
	            var red = "";
	            var white = "";
	            var kReadableOperator = {
	              deepStrictEqual: "Expected values to be strictly deep-equal:",
	              strictEqual: "Expected values to be strictly equal:",
	              strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
	              deepEqual: "Expected values to be loosely deep-equal:",
	              equal: "Expected values to be loosely equal:",
	              notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
	              notStrictEqual: 'Expected "actual" to be strictly unequal to:',
	              notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
	              notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
	              notEqual: 'Expected "actual" to be loosely unequal to:',
	              notIdentical: "Values identical but not reference-equal:"
	            };
	            var kMaxShortLength = 10;
	            function copyError(source) {
	              var keys = Object.keys(source);
	              var target = Object.create(Object.getPrototypeOf(source));
	              keys.forEach(function(key) {
	                target[key] = source[key];
	              });
	              Object.defineProperty(target, "message", {
	                value: source.message
	              });
	              return target;
	            }
	            function inspectValue(val) {
	              return inspect(val, {
	                compact: false,
	                customInspect: false,
	                depth: 1e3,
	                maxArrayLength: Infinity,
	                // Assert compares only enumerable properties (with a few exceptions).
	                showHidden: false,
	                // Having a long line as error is better than wrapping the line for
	                // comparison for now.
	                // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
	                // have meta information about the inspected properties (i.e., know where
	                // in what line the property starts and ends).
	                breakLength: Infinity,
	                // Assert does not detect proxies currently.
	                showProxy: false,
	                sorted: true,
	                // Inspect getters as we also check them when comparing entries.
	                getters: true
	              });
	            }
	            function createErrDiff(actual, expected, operator) {
	              var other = "";
	              var res = "";
	              var lastPos = 0;
	              var end = "";
	              var skipped = false;
	              var actualInspected = inspectValue(actual);
	              var actualLines = actualInspected.split("\n");
	              var expectedLines = inspectValue(expected).split("\n");
	              var i = 0;
	              var indicator = "";
	              if (operator === "strictEqual" && _typeof(actual) === "object" && _typeof(expected) === "object" && actual !== null && expected !== null) {
	                operator = "strictEqualObject";
	              }
	              if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
	                var inputLength = actualLines[0].length + expectedLines[0].length;
	                if (inputLength <= kMaxShortLength) {
	                  if ((_typeof(actual) !== "object" || actual === null) && (_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) {
	                    return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
	                  }
	                } else if (operator !== "strictEqualObject") {
	                  var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
	                  if (inputLength < maxLength) {
	                    while (actualLines[0][i] === expectedLines[0][i]) {
	                      i++;
	                    }
	                    if (i > 2) {
	                      indicator = "\n  ".concat(repeat(" ", i), "^");
	                      i = 0;
	                    }
	                  }
	                }
	              }
	              var a = actualLines[actualLines.length - 1];
	              var b = expectedLines[expectedLines.length - 1];
	              while (a === b) {
	                if (i++ < 2) {
	                  end = "\n  ".concat(a).concat(end);
	                } else {
	                  other = a;
	                }
	                actualLines.pop();
	                expectedLines.pop();
	                if (actualLines.length === 0 || expectedLines.length === 0) break;
	                a = actualLines[actualLines.length - 1];
	                b = expectedLines[expectedLines.length - 1];
	              }
	              var maxLines = Math.max(actualLines.length, expectedLines.length);
	              if (maxLines === 0) {
	                var _actualLines = actualInspected.split("\n");
	                if (_actualLines.length > 30) {
	                  _actualLines[26] = "".concat(blue, "...").concat(white);
	                  while (_actualLines.length > 27) {
	                    _actualLines.pop();
	                  }
	                }
	                return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
	              }
	              if (i > 3) {
	                end = "\n".concat(blue, "...").concat(white).concat(end);
	                skipped = true;
	              }
	              if (other !== "") {
	                end = "\n  ".concat(other).concat(end);
	                other = "";
	              }
	              var printedLines = 0;
	              var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
	              var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
	              for (i = 0; i < maxLines; i++) {
	                var cur = i - lastPos;
	                if (actualLines.length < i + 1) {
	                  if (cur > 1 && i > 2) {
	                    if (cur > 4) {
	                      res += "\n".concat(blue, "...").concat(white);
	                      skipped = true;
	                    } else if (cur > 3) {
	                      res += "\n  ".concat(expectedLines[i - 2]);
	                      printedLines++;
	                    }
	                    res += "\n  ".concat(expectedLines[i - 1]);
	                    printedLines++;
	                  }
	                  lastPos = i;
	                  other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
	                  printedLines++;
	                } else if (expectedLines.length < i + 1) {
	                  if (cur > 1 && i > 2) {
	                    if (cur > 4) {
	                      res += "\n".concat(blue, "...").concat(white);
	                      skipped = true;
	                    } else if (cur > 3) {
	                      res += "\n  ".concat(actualLines[i - 2]);
	                      printedLines++;
	                    }
	                    res += "\n  ".concat(actualLines[i - 1]);
	                    printedLines++;
	                  }
	                  lastPos = i;
	                  res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
	                  printedLines++;
	                } else {
	                  var expectedLine = expectedLines[i];
	                  var actualLine = actualLines[i];
	                  var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
	                  if (divergingLines && endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
	                    divergingLines = false;
	                    actualLine += ",";
	                  }
	                  if (divergingLines) {
	                    if (cur > 1 && i > 2) {
	                      if (cur > 4) {
	                        res += "\n".concat(blue, "...").concat(white);
	                        skipped = true;
	                      } else if (cur > 3) {
	                        res += "\n  ".concat(actualLines[i - 2]);
	                        printedLines++;
	                      }
	                      res += "\n  ".concat(actualLines[i - 1]);
	                      printedLines++;
	                    }
	                    lastPos = i;
	                    res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
	                    other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
	                    printedLines += 2;
	                  } else {
	                    res += other;
	                    other = "";
	                    if (cur === 1 || i === 0) {
	                      res += "\n  ".concat(actualLine);
	                      printedLines++;
	                    }
	                  }
	                }
	                if (printedLines > 20 && i < maxLines - 2) {
	                  return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
	                }
	              }
	              return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
	            }
	            var AssertionError = /* @__PURE__ */ function(_Error) {
	              _inherits(AssertionError2, _Error);
	              function AssertionError2(options) {
	                var _this;
	                _classCallCheck(this, AssertionError2);
	                if (_typeof(options) !== "object" || options === null) {
	                  throw new ERR_INVALID_ARG_TYPE("options", "Object", options);
	                }
	                var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
	                var actual = options.actual, expected = options.expected;
	                var limit = Error.stackTraceLimit;
	                Error.stackTraceLimit = 0;
	                if (message != null) {
	                  _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError2).call(this, String(message)));
	                } else {
	                  if (process.stderr && process.stderr.isTTY) {
	                    if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
	                      blue = "\x1B[34m";
	                      green = "\x1B[32m";
	                      white = "\x1B[39m";
	                      red = "\x1B[31m";
	                    } else {
	                      blue = "";
	                      green = "";
	                      white = "";
	                      red = "";
	                    }
	                  }
	                  if (_typeof(actual) === "object" && actual !== null && _typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
	                    actual = copyError(actual);
	                    expected = copyError(expected);
	                  }
	                  if (operator === "deepStrictEqual" || operator === "strictEqual") {
	                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError2).call(this, createErrDiff(actual, expected, operator)));
	                  } else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
	                    var base = kReadableOperator[operator];
	                    var res = inspectValue(actual).split("\n");
	                    if (operator === "notStrictEqual" && _typeof(actual) === "object" && actual !== null) {
	                      base = kReadableOperator.notStrictEqualObject;
	                    }
	                    if (res.length > 30) {
	                      res[26] = "".concat(blue, "...").concat(white);
	                      while (res.length > 27) {
	                        res.pop();
	                      }
	                    }
	                    if (res.length === 1) {
	                      _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError2).call(this, "".concat(base, " ").concat(res[0])));
	                    } else {
	                      _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError2).call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n")));
	                    }
	                  } else {
	                    var _res = inspectValue(actual);
	                    var other = "";
	                    var knownOperators = kReadableOperator[operator];
	                    if (operator === "notDeepEqual" || operator === "notEqual") {
	                      _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
	                      if (_res.length > 1024) {
	                        _res = "".concat(_res.slice(0, 1021), "...");
	                      }
	                    } else {
	                      other = "".concat(inspectValue(expected));
	                      if (_res.length > 512) {
	                        _res = "".concat(_res.slice(0, 509), "...");
	                      }
	                      if (other.length > 512) {
	                        other = "".concat(other.slice(0, 509), "...");
	                      }
	                      if (operator === "deepEqual" || operator === "equal") {
	                        _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
	                      } else {
	                        other = " ".concat(operator, " ").concat(other);
	                      }
	                    }
	                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError2).call(this, "".concat(_res).concat(other)));
	                  }
	                }
	                Error.stackTraceLimit = limit;
	                _this.generatedMessage = !message;
	                Object.defineProperty(_assertThisInitialized(_this), "name", {
	                  value: "AssertionError [ERR_ASSERTION]",
	                  enumerable: false,
	                  writable: true,
	                  configurable: true
	                });
	                _this.code = "ERR_ASSERTION";
	                _this.actual = actual;
	                _this.expected = expected;
	                _this.operator = operator;
	                if (Error.captureStackTrace) {
	                  Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
	                }
	                _this.stack;
	                _this.name = "AssertionError";
	                return _possibleConstructorReturn(_this);
	              }
	              _createClass(AssertionError2, [{
	                key: "toString",
	                value: function toString() {
	                  return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
	                }
	              }, {
	                key: inspect.custom,
	                value: function value(recurseTimes, ctx) {
	                  return inspect(this, _objectSpread({}, ctx, {
	                    customInspect: false,
	                    depth: 0
	                  }));
	                }
	              }]);
	              return AssertionError2;
	            }(_wrapNativeSuper(Error));
	            module2.exports = AssertionError;
	          }
	        ),
	        /***/
	        79616: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            function _typeof(obj) {
	              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	                _typeof = function _typeof2(obj2) {
	                  return typeof obj2;
	                };
	              } else {
	                _typeof = function _typeof2(obj2) {
	                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	                };
	              }
	              return _typeof(obj);
	            }
	            function _classCallCheck(instance, Constructor) {
	              if (!(instance instanceof Constructor)) {
	                throw new TypeError("Cannot call a class as a function");
	              }
	            }
	            function _possibleConstructorReturn(self2, call) {
	              if (call && (_typeof(call) === "object" || typeof call === "function")) {
	                return call;
	              }
	              return _assertThisInitialized(self2);
	            }
	            function _assertThisInitialized(self2) {
	              if (self2 === undefined) {
	                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	              }
	              return self2;
	            }
	            function _getPrototypeOf(o) {
	              _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
	                return o2.__proto__ || Object.getPrototypeOf(o2);
	              };
	              return _getPrototypeOf(o);
	            }
	            function _inherits(subClass, superClass) {
	              if (typeof superClass !== "function" && superClass !== null) {
	                throw new TypeError("Super expression must either be null or a function");
	              }
	              subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
	              if (superClass) _setPrototypeOf(subClass, superClass);
	            }
	            function _setPrototypeOf(o, p) {
	              _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
	                o2.__proto__ = p2;
	                return o2;
	              };
	              return _setPrototypeOf(o, p);
	            }
	            var codes = {};
	            var assert;
	            var util;
	            function createErrorType(code, message, Base) {
	              if (!Base) {
	                Base = Error;
	              }
	              function getMessage(arg1, arg2, arg3) {
	                if (typeof message === "string") {
	                  return message;
	                } else {
	                  return message(arg1, arg2, arg3);
	                }
	              }
	              var NodeError = /* @__PURE__ */ function(_Base) {
	                _inherits(NodeError2, _Base);
	                function NodeError2(arg1, arg2, arg3) {
	                  var _this;
	                  _classCallCheck(this, NodeError2);
	                  _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeError2).call(this, getMessage(arg1, arg2, arg3)));
	                  _this.code = code;
	                  return _this;
	                }
	                return NodeError2;
	              }(Base);
	              codes[code] = NodeError;
	            }
	            function oneOf(expected, thing) {
	              if (Array.isArray(expected)) {
	                var len = expected.length;
	                expected = expected.map(function(i) {
	                  return String(i);
	                });
	                if (len > 2) {
	                  return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
	                } else if (len === 2) {
	                  return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
	                } else {
	                  return "of ".concat(thing, " ").concat(expected[0]);
	                }
	              } else {
	                return "of ".concat(thing, " ").concat(String(expected));
	              }
	            }
	            function startsWith(str, search, pos) {
	              return str.substr(0 , search.length) === search;
	            }
	            function endsWith(str, search, this_len) {
	              if (this_len === undefined || this_len > str.length) {
	                this_len = str.length;
	              }
	              return str.substring(this_len - search.length, this_len) === search;
	            }
	            function includes(str, search, start) {
	              if (typeof start !== "number") {
	                start = 0;
	              }
	              if (start + search.length > str.length) {
	                return false;
	              } else {
	                return str.indexOf(search, start) !== -1;
	              }
	            }
	            createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
	            createErrorType("ERR_INVALID_ARG_TYPE", function(name2, expected, actual) {
	              if (assert === undefined) assert = __webpack_require__2(32791);
	              assert(typeof name2 === "string", "'name' must be a string");
	              var determiner;
	              if (typeof expected === "string" && startsWith(expected, "not ")) {
	                determiner = "must not be";
	                expected = expected.replace(/^not /, "");
	              } else {
	                determiner = "must be";
	              }
	              var msg;
	              if (endsWith(name2, " argument")) {
	                msg = "The ".concat(name2, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
	              } else {
	                var type = includes(name2, ".") ? "property" : "argument";
	                msg = 'The "'.concat(name2, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
	              }
	              msg += ". Received type ".concat(_typeof(actual));
	              return msg;
	            }, TypeError);
	            createErrorType("ERR_INVALID_ARG_VALUE", function(name2, value) {
	              var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
	              if (util === undefined) util = __webpack_require__2(43827);
	              var inspected = util.inspect(value);
	              if (inspected.length > 128) {
	                inspected = "".concat(inspected.slice(0, 128), "...");
	              }
	              return "The argument '".concat(name2, "' ").concat(reason, ". Received ").concat(inspected);
	            }, TypeError);
	            createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name2, value) {
	              var type;
	              if (value && value.constructor && value.constructor.name) {
	                type = "instance of ".concat(value.constructor.name);
	              } else {
	                type = "type ".concat(_typeof(value));
	              }
	              return "Expected ".concat(input, ' to be returned from the "').concat(name2, '"') + " function but got ".concat(type, ".");
	            }, TypeError);
	            createErrorType("ERR_MISSING_ARGS", function() {
	              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	              }
	              if (assert === undefined) assert = __webpack_require__2(32791);
	              assert(args.length > 0, "At least one arg needs to be specified");
	              var msg = "The ";
	              var len = args.length;
	              args = args.map(function(a) {
	                return '"'.concat(a, '"');
	              });
	              switch (len) {
	                case 1:
	                  msg += "".concat(args[0], " argument");
	                  break;
	                case 2:
	                  msg += "".concat(args[0], " and ").concat(args[1], " arguments");
	                  break;
	                default:
	                  msg += args.slice(0, len - 1).join(", ");
	                  msg += ", and ".concat(args[len - 1], " arguments");
	                  break;
	              }
	              return "".concat(msg, " must be specified");
	            }, TypeError);
	            module2.exports.codes = codes;
	          }
	        ),
	        /***/
	        74061: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            function _slicedToArray(arr, i) {
	              return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i);
	            }
	            function _iterableToArrayLimit(arr, i) {
	              var _arr = [];
	              var _n = true;
	              var _d = false;
	              var _e = undefined;
	              try {
	                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	                  _arr.push(_s.value);
	                  if (i && _arr.length === i) break;
	                }
	              } catch (err) {
	                _d = true;
	                _e = err;
	              } finally {
	                try {
	                  if (!_n && _i["return"] != null) _i["return"]();
	                } finally {
	                  if (_d) throw _e;
	                }
	              }
	              return _arr;
	            }
	            function _arrayWithHoles(arr) {
	              if (Array.isArray(arr)) return arr;
	            }
	            function _typeof(obj) {
	              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	                _typeof = function _typeof2(obj2) {
	                  return typeof obj2;
	                };
	              } else {
	                _typeof = function _typeof2(obj2) {
	                  return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	                };
	              }
	              return _typeof(obj);
	            }
	            var regexFlagsSupported = /a/g.flags !== undefined;
	            var arrayFromSet = function arrayFromSet2(set) {
	              var array = [];
	              set.forEach(function(value) {
	                return array.push(value);
	              });
	              return array;
	            };
	            var arrayFromMap = function arrayFromMap2(map2) {
	              var array = [];
	              map2.forEach(function(value, key) {
	                return array.push([key, value]);
	              });
	              return array;
	            };
	            var objectIs = Object.is ? Object.is : __webpack_require__2(64003);
	            var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
	              return [];
	            };
	            var numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__2(15567);
	            function uncurryThis(f) {
	              return f.call.bind(f);
	            }
	            var hasOwnProperty2 = uncurryThis(Object.prototype.hasOwnProperty);
	            var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
	            var objectToString = uncurryThis(Object.prototype.toString);
	            var _require$types = __webpack_require__2(43827).types, isAnyArrayBuffer = _require$types.isAnyArrayBuffer, isArrayBufferView = _require$types.isArrayBufferView, isDate = _require$types.isDate, isMap = _require$types.isMap, isRegExp = _require$types.isRegExp, isSet = _require$types.isSet, isNativeError = _require$types.isNativeError, isBoxedPrimitive = _require$types.isBoxedPrimitive, isNumberObject = _require$types.isNumberObject, isStringObject = _require$types.isStringObject, isBooleanObject = _require$types.isBooleanObject, isBigIntObject = _require$types.isBigIntObject, isSymbolObject = _require$types.isSymbolObject, isFloat32Array = _require$types.isFloat32Array, isFloat64Array = _require$types.isFloat64Array;
	            function isNonIndex(key) {
	              if (key.length === 0 || key.length > 10) return true;
	              for (var i = 0; i < key.length; i++) {
	                var code = key.charCodeAt(i);
	                if (code < 48 || code > 57) return true;
	              }
	              return key.length === 10 && key >= Math.pow(2, 32);
	            }
	            function getOwnNonIndexProperties(value) {
	              return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
	            }
	            /*!
	             * The buffer module from node.js, for the browser.
	             *
	             * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	             * @license  MIT
	             */
	            function compare(a, b) {
	              if (a === b) {
	                return 0;
	              }
	              var x = a.length;
	              var y = b.length;
	              for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	                if (a[i] !== b[i]) {
	                  x = a[i];
	                  y = b[i];
	                  break;
	                }
	              }
	              if (x < y) {
	                return -1;
	              }
	              if (y < x) {
	                return 1;
	              }
	              return 0;
	            }
	            var kStrict = true;
	            var kLoose = false;
	            var kNoIterator = 0;
	            var kIsArray = 1;
	            var kIsSet = 2;
	            var kIsMap = 3;
	            function areSimilarRegExps(a, b) {
	              return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
	            }
	            function areSimilarFloatArrays(a, b) {
	              if (a.byteLength !== b.byteLength) {
	                return false;
	              }
	              for (var offset = 0; offset < a.byteLength; offset++) {
	                if (a[offset] !== b[offset]) {
	                  return false;
	                }
	              }
	              return true;
	            }
	            function areSimilarTypedArrays(a, b) {
	              if (a.byteLength !== b.byteLength) {
	                return false;
	              }
	              return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
	            }
	            function areEqualArrayBuffers(buf1, buf2) {
	              return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
	            }
	            function isEqualBoxedPrimitive(val1, val2) {
	              if (isNumberObject(val1)) {
	                return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
	              }
	              if (isStringObject(val1)) {
	                return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
	              }
	              if (isBooleanObject(val1)) {
	                return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
	              }
	              if (isBigIntObject(val1)) {
	                return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
	              }
	              return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
	            }
	            function innerDeepEqual(val1, val2, strict, memos) {
	              if (val1 === val2) {
	                if (val1 !== 0) return true;
	                return strict ? objectIs(val1, val2) : true;
	              }
	              if (strict) {
	                if (_typeof(val1) !== "object") {
	                  return typeof val1 === "number" && numberIsNaN(val1) && numberIsNaN(val2);
	                }
	                if (_typeof(val2) !== "object" || val1 === null || val2 === null) {
	                  return false;
	                }
	                if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) {
	                  return false;
	                }
	              } else {
	                if (val1 === null || _typeof(val1) !== "object") {
	                  if (val2 === null || _typeof(val2) !== "object") {
	                    return val1 == val2;
	                  }
	                  return false;
	                }
	                if (val2 === null || _typeof(val2) !== "object") {
	                  return false;
	                }
	              }
	              var val1Tag = objectToString(val1);
	              var val2Tag = objectToString(val2);
	              if (val1Tag !== val2Tag) {
	                return false;
	              }
	              if (Array.isArray(val1)) {
	                if (val1.length !== val2.length) {
	                  return false;
	                }
	                var keys1 = getOwnNonIndexProperties(val1);
	                var keys2 = getOwnNonIndexProperties(val2);
	                if (keys1.length !== keys2.length) {
	                  return false;
	                }
	                return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
	              }
	              if (val1Tag === "[object Object]") {
	                if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) {
	                  return false;
	                }
	              }
	              if (isDate(val1)) {
	                if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) {
	                  return false;
	                }
	              } else if (isRegExp(val1)) {
	                if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) {
	                  return false;
	                }
	              } else if (isNativeError(val1) || val1 instanceof Error) {
	                if (val1.message !== val2.message || val1.name !== val2.name) {
	                  return false;
	                }
	              } else if (isArrayBufferView(val1)) {
	                if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
	                  if (!areSimilarFloatArrays(val1, val2)) {
	                    return false;
	                  }
	                } else if (!areSimilarTypedArrays(val1, val2)) {
	                  return false;
	                }
	                var _keys = getOwnNonIndexProperties(val1);
	                var _keys2 = getOwnNonIndexProperties(val2);
	                if (_keys.length !== _keys2.length) {
	                  return false;
	                }
	                return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
	              } else if (isSet(val1)) {
	                if (!isSet(val2) || val1.size !== val2.size) {
	                  return false;
	                }
	                return keyCheck(val1, val2, strict, memos, kIsSet);
	              } else if (isMap(val1)) {
	                if (!isMap(val2) || val1.size !== val2.size) {
	                  return false;
	                }
	                return keyCheck(val1, val2, strict, memos, kIsMap);
	              } else if (isAnyArrayBuffer(val1)) {
	                if (!areEqualArrayBuffers(val1, val2)) {
	                  return false;
	                }
	              } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) {
	                return false;
	              }
	              return keyCheck(val1, val2, strict, memos, kNoIterator);
	            }
	            function getEnumerables(val, keys) {
	              return keys.filter(function(k) {
	                return propertyIsEnumerable(val, k);
	              });
	            }
	            function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
	              if (arguments.length === 5) {
	                aKeys = Object.keys(val1);
	                var bKeys = Object.keys(val2);
	                if (aKeys.length !== bKeys.length) {
	                  return false;
	                }
	              }
	              var i = 0;
	              for (; i < aKeys.length; i++) {
	                if (!hasOwnProperty2(val2, aKeys[i])) {
	                  return false;
	                }
	              }
	              if (strict && arguments.length === 5) {
	                var symbolKeysA = objectGetOwnPropertySymbols(val1);
	                if (symbolKeysA.length !== 0) {
	                  var count = 0;
	                  for (i = 0; i < symbolKeysA.length; i++) {
	                    var key = symbolKeysA[i];
	                    if (propertyIsEnumerable(val1, key)) {
	                      if (!propertyIsEnumerable(val2, key)) {
	                        return false;
	                      }
	                      aKeys.push(key);
	                      count++;
	                    } else if (propertyIsEnumerable(val2, key)) {
	                      return false;
	                    }
	                  }
	                  var symbolKeysB = objectGetOwnPropertySymbols(val2);
	                  if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) {
	                    return false;
	                  }
	                } else {
	                  var _symbolKeysB = objectGetOwnPropertySymbols(val2);
	                  if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) {
	                    return false;
	                  }
	                }
	              }
	              if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) {
	                return true;
	              }
	              if (memos === undefined) {
	                memos = {
	                  val1: /* @__PURE__ */ new Map(),
	                  val2: /* @__PURE__ */ new Map(),
	                  position: 0
	                };
	              } else {
	                var val2MemoA = memos.val1.get(val1);
	                if (val2MemoA !== undefined) {
	                  var val2MemoB = memos.val2.get(val2);
	                  if (val2MemoB !== undefined) {
	                    return val2MemoA === val2MemoB;
	                  }
	                }
	                memos.position++;
	              }
	              memos.val1.set(val1, memos.position);
	              memos.val2.set(val2, memos.position);
	              var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
	              memos.val1.delete(val1);
	              memos.val2.delete(val2);
	              return areEq;
	            }
	            function setHasEqualElement(set, val1, strict, memo) {
	              var setValues = arrayFromSet(set);
	              for (var i = 0; i < setValues.length; i++) {
	                var val2 = setValues[i];
	                if (innerDeepEqual(val1, val2, strict, memo)) {
	                  set.delete(val2);
	                  return true;
	                }
	              }
	              return false;
	            }
	            function findLooseMatchingPrimitives(prim) {
	              switch (_typeof(prim)) {
	                case "undefined":
	                  return null;
	                case "object":
	                  return undefined;
	                case "symbol":
	                  return false;
	                case "string":
	                  prim = +prim;
	                case "number":
	                  if (numberIsNaN(prim)) {
	                    return false;
	                  }
	              }
	              return true;
	            }
	            function setMightHaveLoosePrim(a, b, prim) {
	              var altValue = findLooseMatchingPrimitives(prim);
	              if (altValue != null) return altValue;
	              return b.has(altValue) && !a.has(altValue);
	            }
	            function mapMightHaveLoosePrim(a, b, prim, item, memo) {
	              var altValue = findLooseMatchingPrimitives(prim);
	              if (altValue != null) {
	                return altValue;
	              }
	              var curB = b.get(altValue);
	              if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) {
	                return false;
	              }
	              return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
	            }
	            function setEquiv(a, b, strict, memo) {
	              var set = null;
	              var aValues = arrayFromSet(a);
	              for (var i = 0; i < aValues.length; i++) {
	                var val = aValues[i];
	                if (_typeof(val) === "object" && val !== null) {
	                  if (set === null) {
	                    set = /* @__PURE__ */ new Set();
	                  }
	                  set.add(val);
	                } else if (!b.has(val)) {
	                  if (strict) return false;
	                  if (!setMightHaveLoosePrim(a, b, val)) {
	                    return false;
	                  }
	                  if (set === null) {
	                    set = /* @__PURE__ */ new Set();
	                  }
	                  set.add(val);
	                }
	              }
	              if (set !== null) {
	                var bValues = arrayFromSet(b);
	                for (var _i = 0; _i < bValues.length; _i++) {
	                  var _val = bValues[_i];
	                  if (_typeof(_val) === "object" && _val !== null) {
	                    if (!setHasEqualElement(set, _val, strict, memo)) return false;
	                  } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) {
	                    return false;
	                  }
	                }
	                return set.size === 0;
	              }
	              return true;
	            }
	            function mapHasEqualEntry(set, map2, key1, item1, strict, memo) {
	              var setValues = arrayFromSet(set);
	              for (var i = 0; i < setValues.length; i++) {
	                var key2 = setValues[i];
	                if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map2.get(key2), strict, memo)) {
	                  set.delete(key2);
	                  return true;
	                }
	              }
	              return false;
	            }
	            function mapEquiv(a, b, strict, memo) {
	              var set = null;
	              var aEntries = arrayFromMap(a);
	              for (var i = 0; i < aEntries.length; i++) {
	                var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
	                if (_typeof(key) === "object" && key !== null) {
	                  if (set === null) {
	                    set = /* @__PURE__ */ new Set();
	                  }
	                  set.add(key);
	                } else {
	                  var item2 = b.get(key);
	                  if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
	                    if (strict) return false;
	                    if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
	                    if (set === null) {
	                      set = /* @__PURE__ */ new Set();
	                    }
	                    set.add(key);
	                  }
	                }
	              }
	              if (set !== null) {
	                var bEntries = arrayFromMap(b);
	                for (var _i2 = 0; _i2 < bEntries.length; _i2++) {
	                  var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
	                  if (_typeof(key) === "object" && key !== null) {
	                    if (!mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
	                  } else if (!strict && (!a.has(key) || !innerDeepEqual(a.get(key), item, false, memo)) && !mapHasEqualEntry(set, a, key, item, false, memo)) {
	                    return false;
	                  }
	                }
	                return set.size === 0;
	              }
	              return true;
	            }
	            function objEquiv(a, b, strict, keys, memos, iterationType) {
	              var i = 0;
	              if (iterationType === kIsSet) {
	                if (!setEquiv(a, b, strict, memos)) {
	                  return false;
	                }
	              } else if (iterationType === kIsMap) {
	                if (!mapEquiv(a, b, strict, memos)) {
	                  return false;
	                }
	              } else if (iterationType === kIsArray) {
	                for (; i < a.length; i++) {
	                  if (hasOwnProperty2(a, i)) {
	                    if (!hasOwnProperty2(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) {
	                      return false;
	                    }
	                  } else if (hasOwnProperty2(b, i)) {
	                    return false;
	                  } else {
	                    var keysA = Object.keys(a);
	                    for (; i < keysA.length; i++) {
	                      var key = keysA[i];
	                      if (!hasOwnProperty2(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) {
	                        return false;
	                      }
	                    }
	                    if (keysA.length !== Object.keys(b).length) {
	                      return false;
	                    }
	                    return true;
	                  }
	                }
	              }
	              for (i = 0; i < keys.length; i++) {
	                var _key = keys[i];
	                if (!innerDeepEqual(a[_key], b[_key], strict, memos)) {
	                  return false;
	                }
	              }
	              return true;
	            }
	            function isDeepEqual(val1, val2) {
	              return innerDeepEqual(val1, val2, kLoose);
	            }
	            function isDeepStrictEqual(val1, val2) {
	              return innerDeepEqual(val1, val2, kStrict);
	            }
	            module2.exports = {
	              isDeepEqual,
	              isDeepStrictEqual
	            };
	          }
	        ),
	        /***/
	        95341: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            exports2.byteLength = byteLength;
	            exports2.toByteArray = toByteArray;
	            exports2.fromByteArray = fromByteArray;
	            var lookup = [];
	            var revLookup = [];
	            var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
	            var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	            for (var i = 0, len = code.length; i < len; ++i) {
	              lookup[i] = code[i];
	              revLookup[code.charCodeAt(i)] = i;
	            }
	            revLookup["-".charCodeAt(0)] = 62;
	            revLookup["_".charCodeAt(0)] = 63;
	            function getLens(b64) {
	              var len2 = b64.length;
	              if (len2 % 4 > 0) {
	                throw new Error("Invalid string. Length must be a multiple of 4");
	              }
	              var validLen = b64.indexOf("=");
	              if (validLen === -1) validLen = len2;
	              var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
	              return [validLen, placeHoldersLen];
	            }
	            function byteLength(b64) {
	              var lens = getLens(b64);
	              var validLen = lens[0];
	              var placeHoldersLen = lens[1];
	              return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	            }
	            function _byteLength(b64, validLen, placeHoldersLen) {
	              return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
	            }
	            function toByteArray(b64) {
	              var tmp;
	              var lens = getLens(b64);
	              var validLen = lens[0];
	              var placeHoldersLen = lens[1];
	              var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
	              var curByte = 0;
	              var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
	              var i2;
	              for (i2 = 0; i2 < len2; i2 += 4) {
	                tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
	                arr[curByte++] = tmp >> 16 & 255;
	                arr[curByte++] = tmp >> 8 & 255;
	                arr[curByte++] = tmp & 255;
	              }
	              if (placeHoldersLen === 2) {
	                tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
	                arr[curByte++] = tmp & 255;
	              }
	              if (placeHoldersLen === 1) {
	                tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
	                arr[curByte++] = tmp >> 8 & 255;
	                arr[curByte++] = tmp & 255;
	              }
	              return arr;
	            }
	            function tripletToBase64(num) {
	              return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
	            }
	            function encodeChunk(uint8, start, end) {
	              var tmp;
	              var output = [];
	              for (var i2 = start; i2 < end; i2 += 3) {
	                tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
	                output.push(tripletToBase64(tmp));
	              }
	              return output.join("");
	            }
	            function fromByteArray(uint8) {
	              var tmp;
	              var len2 = uint8.length;
	              var extraBytes = len2 % 3;
	              var parts = [];
	              var maxChunkLength = 16383;
	              for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
	                parts.push(encodeChunk(
	                  uint8,
	                  i2,
	                  i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength
	                ));
	              }
	              if (extraBytes === 1) {
	                tmp = uint8[len2 - 1];
	                parts.push(
	                  lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
	                );
	              } else if (extraBytes === 2) {
	                tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
	                parts.push(
	                  lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
	                );
	              }
	              return parts.join("");
	            }
	          }
	        ),
	        /***/
	        91358: (
	          /***/
	          function(module2) {
	            function ge(a, y, c, l, h) {
	              var i = h + 1;
	              while (l <= h) {
	                var m = l + h >>> 1, x = a[m];
	                var p = c !== undefined ? c(x, y) : x - y;
	                if (p >= 0) {
	                  i = m;
	                  h = m - 1;
	                } else {
	                  l = m + 1;
	                }
	              }
	              return i;
	            }
	            function gt(a, y, c, l, h) {
	              var i = h + 1;
	              while (l <= h) {
	                var m = l + h >>> 1, x = a[m];
	                var p = c !== undefined ? c(x, y) : x - y;
	                if (p > 0) {
	                  i = m;
	                  h = m - 1;
	                } else {
	                  l = m + 1;
	                }
	              }
	              return i;
	            }
	            function lt(a, y, c, l, h) {
	              var i = l - 1;
	              while (l <= h) {
	                var m = l + h >>> 1, x = a[m];
	                var p = c !== undefined ? c(x, y) : x - y;
	                if (p < 0) {
	                  i = m;
	                  l = m + 1;
	                } else {
	                  h = m - 1;
	                }
	              }
	              return i;
	            }
	            function le(a, y, c, l, h) {
	              var i = l - 1;
	              while (l <= h) {
	                var m = l + h >>> 1, x = a[m];
	                var p = c !== undefined ? c(x, y) : x - y;
	                if (p <= 0) {
	                  i = m;
	                  l = m + 1;
	                } else {
	                  h = m - 1;
	                }
	              }
	              return i;
	            }
	            function eq(a, y, c, l, h) {
	              while (l <= h) {
	                var m = l + h >>> 1, x = a[m];
	                var p = c !== undefined ? c(x, y) : x - y;
	                if (p === 0) {
	                  return m;
	                }
	                if (p <= 0) {
	                  l = m + 1;
	                } else {
	                  h = m - 1;
	                }
	              }
	              return -1;
	            }
	            function norm(a, y, c, l, h, f) {
	              if (typeof c === "function") {
	                return f(a, y, c, l === undefined ? 0 : l | 0, h === undefined ? a.length - 1 : h | 0);
	              }
	              return f(a, y, undefined, c === undefined ? 0 : c | 0, l === undefined ? a.length - 1 : l | 0);
	            }
	            module2.exports = {
	              ge: function(a, y, c, l, h) {
	                return norm(a, y, c, l, h, ge);
	              },
	              gt: function(a, y, c, l, h) {
	                return norm(a, y, c, l, h, gt);
	              },
	              lt: function(a, y, c, l, h) {
	                return norm(a, y, c, l, h, lt);
	              },
	              le: function(a, y, c, l, h) {
	                return norm(a, y, c, l, h, le);
	              },
	              eq: function(a, y, c, l, h) {
	                return norm(a, y, c, l, h, eq);
	              }
	            };
	          }
	        ),
	        /***/
	        13547: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            "use restrict";
	            var INT_BITS = 32;
	            exports2.INT_BITS = INT_BITS;
	            exports2.INT_MAX = 2147483647;
	            exports2.INT_MIN = -1 << INT_BITS - 1;
	            exports2.sign = function(v) {
	              return (v > 0) - (v < 0);
	            };
	            exports2.abs = function(v) {
	              var mask = v >> INT_BITS - 1;
	              return (v ^ mask) - mask;
	            };
	            exports2.min = function(x, y) {
	              return y ^ (x ^ y) & -(x < y);
	            };
	            exports2.max = function(x, y) {
	              return x ^ (x ^ y) & -(x < y);
	            };
	            exports2.isPow2 = function(v) {
	              return !(v & v - 1) && !!v;
	            };
	            exports2.log2 = function(v) {
	              var r, shift;
	              r = (v > 65535) << 4;
	              v >>>= r;
	              shift = (v > 255) << 3;
	              v >>>= shift;
	              r |= shift;
	              shift = (v > 15) << 2;
	              v >>>= shift;
	              r |= shift;
	              shift = (v > 3) << 1;
	              v >>>= shift;
	              r |= shift;
	              return r | v >> 1;
	            };
	            exports2.log10 = function(v) {
	              return v >= 1e9 ? 9 : v >= 1e8 ? 8 : v >= 1e7 ? 7 : v >= 1e6 ? 6 : v >= 1e5 ? 5 : v >= 1e4 ? 4 : v >= 1e3 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
	            };
	            exports2.popCount = function(v) {
	              v = v - (v >>> 1 & 1431655765);
	              v = (v & 858993459) + (v >>> 2 & 858993459);
	              return (v + (v >>> 4) & 252645135) * 16843009 >>> 24;
	            };
	            function countTrailingZeros(v) {
	              var c = 32;
	              v &= -v;
	              if (v) c--;
	              if (v & 65535) c -= 16;
	              if (v & 16711935) c -= 8;
	              if (v & 252645135) c -= 4;
	              if (v & 858993459) c -= 2;
	              if (v & 1431655765) c -= 1;
	              return c;
	            }
	            exports2.countTrailingZeros = countTrailingZeros;
	            exports2.nextPow2 = function(v) {
	              v += v === 0;
	              --v;
	              v |= v >>> 1;
	              v |= v >>> 2;
	              v |= v >>> 4;
	              v |= v >>> 8;
	              v |= v >>> 16;
	              return v + 1;
	            };
	            exports2.prevPow2 = function(v) {
	              v |= v >>> 1;
	              v |= v >>> 2;
	              v |= v >>> 4;
	              v |= v >>> 8;
	              v |= v >>> 16;
	              return v - (v >>> 1);
	            };
	            exports2.parity = function(v) {
	              v ^= v >>> 16;
	              v ^= v >>> 8;
	              v ^= v >>> 4;
	              v &= 15;
	              return 27030 >>> v & 1;
	            };
	            var REVERSE_TABLE = new Array(256);
	            (function(tab) {
	              for (var i = 0; i < 256; ++i) {
	                var v = i, r = i, s = 7;
	                for (v >>>= 1; v; v >>>= 1) {
	                  r <<= 1;
	                  r |= v & 1;
	                  --s;
	                }
	                tab[i] = r << s & 255;
	              }
	            })(REVERSE_TABLE);
	            exports2.reverse = function(v) {
	              return REVERSE_TABLE[v & 255] << 24 | REVERSE_TABLE[v >>> 8 & 255] << 16 | REVERSE_TABLE[v >>> 16 & 255] << 8 | REVERSE_TABLE[v >>> 24 & 255];
	            };
	            exports2.interleave2 = function(x, y) {
	              x &= 65535;
	              x = (x | x << 8) & 16711935;
	              x = (x | x << 4) & 252645135;
	              x = (x | x << 2) & 858993459;
	              x = (x | x << 1) & 1431655765;
	              y &= 65535;
	              y = (y | y << 8) & 16711935;
	              y = (y | y << 4) & 252645135;
	              y = (y | y << 2) & 858993459;
	              y = (y | y << 1) & 1431655765;
	              return x | y << 1;
	            };
	            exports2.deinterleave2 = function(v, n) {
	              v = v >>> n & 1431655765;
	              v = (v | v >>> 1) & 858993459;
	              v = (v | v >>> 2) & 252645135;
	              v = (v | v >>> 4) & 16711935;
	              v = (v | v >>> 16) & 65535;
	              return v << 16 >> 16;
	            };
	            exports2.interleave3 = function(x, y, z) {
	              x &= 1023;
	              x = (x | x << 16) & 4278190335;
	              x = (x | x << 8) & 251719695;
	              x = (x | x << 4) & 3272356035;
	              x = (x | x << 2) & 1227133513;
	              y &= 1023;
	              y = (y | y << 16) & 4278190335;
	              y = (y | y << 8) & 251719695;
	              y = (y | y << 4) & 3272356035;
	              y = (y | y << 2) & 1227133513;
	              x |= y << 1;
	              z &= 1023;
	              z = (z | z << 16) & 4278190335;
	              z = (z | z << 8) & 251719695;
	              z = (z | z << 4) & 3272356035;
	              z = (z | z << 2) & 1227133513;
	              return x | z << 2;
	            };
	            exports2.deinterleave3 = function(v, n) {
	              v = v >>> n & 1227133513;
	              v = (v | v >>> 2) & 3272356035;
	              v = (v | v >>> 4) & 251719695;
	              v = (v | v >>> 8) & 4278190335;
	              v = (v | v >>> 16) & 1023;
	              return v << 22 >> 22;
	            };
	            exports2.nextCombination = function(v) {
	              var t = v | v - 1;
	              return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
	            };
	          }
	        ),
	        /***/
	        44781: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var clamp = __webpack_require__2(53435);
	            module2.exports = calcSDF;
	            var INF = 1e20;
	            function calcSDF(src, options) {
	              if (!options) options = {};
	              var cutoff = options.cutoff == null ? 0.25 : options.cutoff;
	              var radius = options.radius == null ? 8 : options.radius;
	              var channel = options.channel || 0;
	              var w, h, size, data, intData, stride, ctx, canvas, imgData, i, l;
	              if (ArrayBuffer.isView(src) || Array.isArray(src)) {
	                if (!options.width || !options.height) throw Error("For raw data width and height should be provided by options");
	                w = options.width, h = options.height;
	                data = src;
	                if (!options.stride) stride = Math.floor(src.length / w / h);
	                else stride = options.stride;
	              } else {
	                if (window.HTMLCanvasElement && src instanceof window.HTMLCanvasElement) {
	                  canvas = src;
	                  ctx = canvas.getContext("2d");
	                  w = canvas.width, h = canvas.height;
	                  imgData = ctx.getImageData(0, 0, w, h);
	                  data = imgData.data;
	                  stride = 4;
	                } else if (window.CanvasRenderingContext2D && src instanceof window.CanvasRenderingContext2D) {
	                  canvas = src.canvas;
	                  ctx = src;
	                  w = canvas.width, h = canvas.height;
	                  imgData = ctx.getImageData(0, 0, w, h);
	                  data = imgData.data;
	                  stride = 4;
	                } else if (window.ImageData && src instanceof window.ImageData) {
	                  imgData = src;
	                  w = src.width, h = src.height;
	                  data = imgData.data;
	                  stride = 4;
	                }
	              }
	              size = Math.max(w, h);
	              if (window.Uint8ClampedArray && data instanceof window.Uint8ClampedArray || window.Uint8Array && data instanceof window.Uint8Array) {
	                intData = data;
	                data = Array(w * h);
	                for (i = 0, l = intData.length; i < l; i++) {
	                  data[i] = intData[i * stride + channel] / 255;
	                }
	              } else {
	                if (stride !== 1) throw Error("Raw data can have only 1 value per pixel");
	              }
	              var gridOuter = Array(w * h);
	              var gridInner = Array(w * h);
	              var f = Array(size);
	              var d = Array(size);
	              var z = Array(size + 1);
	              var v = Array(size);
	              for (i = 0, l = w * h; i < l; i++) {
	                var a = data[i];
	                gridOuter[i] = a === 1 ? 0 : a === 0 ? INF : Math.pow(Math.max(0, 0.5 - a), 2);
	                gridInner[i] = a === 1 ? INF : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2);
	              }
	              edt(gridOuter, w, h, f, d, v, z);
	              edt(gridInner, w, h, f, d, v, z);
	              var dist = window.Float32Array ? new Float32Array(w * h) : new Array(w * h);
	              for (i = 0, l = w * h; i < l; i++) {
	                dist[i] = clamp(1 - ((gridOuter[i] - gridInner[i]) / radius + cutoff), 0, 1);
	              }
	              return dist;
	            }
	            function edt(data, width, height, f, d, v, z) {
	              for (var x = 0; x < width; x++) {
	                for (var y = 0; y < height; y++) {
	                  f[y] = data[y * width + x];
	                }
	                edt1d(f, d, v, z, height);
	                for (y = 0; y < height; y++) {
	                  data[y * width + x] = d[y];
	                }
	              }
	              for (y = 0; y < height; y++) {
	                for (x = 0; x < width; x++) {
	                  f[x] = data[y * width + x];
	                }
	                edt1d(f, d, v, z, width);
	                for (x = 0; x < width; x++) {
	                  data[y * width + x] = Math.sqrt(d[x]);
	                }
	              }
	            }
	            function edt1d(f, d, v, z, n) {
	              v[0] = 0;
	              z[0] = -1e20;
	              z[1] = 1e20;
	              for (var q = 1, k = 0; q < n; q++) {
	                var s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
	                while (s <= z[k]) {
	                  k--;
	                  s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
	                }
	                k++;
	                v[k] = q;
	                z[k] = s;
	                z[k + 1] = 1e20;
	              }
	              for (q = 0, k = 0; q < n; q++) {
	                while (z[k + 1] < q) k++;
	                d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
	              }
	            }
	          }
	        ),
	        /***/
	        6614: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var GetIntrinsic = __webpack_require__2(68318);
	            var callBind = __webpack_require__2(68222);
	            var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
	            module2.exports = function callBoundIntrinsic(name2, allowMissing) {
	              var intrinsic = GetIntrinsic(name2, !!allowMissing);
	              if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
	                return callBind(intrinsic);
	              }
	              return intrinsic;
	            };
	          }
	        ),
	        /***/
	        68222: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var bind = __webpack_require__2(77575);
	            var GetIntrinsic = __webpack_require__2(68318);
	            var $apply = GetIntrinsic("%Function.prototype.apply%");
	            var $call = GetIntrinsic("%Function.prototype.call%");
	            var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
	            var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
	            var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
	            var $max = GetIntrinsic("%Math.max%");
	            if ($defineProperty) {
	              try {
	                $defineProperty({}, "a", { value: 1 });
	              } catch (e) {
	                $defineProperty = null;
	              }
	            }
	            module2.exports = function callBind(originalFunction) {
	              var func = $reflectApply(bind, $call, arguments);
	              if ($gOPD && $defineProperty) {
	                var desc = $gOPD(func, "length");
	                if (desc.configurable) {
	                  $defineProperty(
	                    func,
	                    "length",
	                    { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
	                  );
	                }
	              }
	              return func;
	            };
	            var applyBind = function applyBind2() {
	              return $reflectApply(bind, $apply, arguments);
	            };
	            if ($defineProperty) {
	              $defineProperty(module2.exports, "apply", { value: applyBind });
	            } else {
	              module2.exports.apply = applyBind;
	            }
	          }
	        ),
	        /***/
	        53435: (
	          /***/
	          function(module2) {
	            module2.exports = clamp;
	            function clamp(value, min, max) {
	              return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
	            }
	          }
	        ),
	        /***/
	        6475: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var clamp = __webpack_require__2(53435);
	            module2.exports = toNumber;
	            module2.exports.to = toNumber;
	            module2.exports.from = fromNumber;
	            function toNumber(rgba, normalized) {
	              if (normalized == null) normalized = true;
	              var r = rgba[0], g = rgba[1], b = rgba[2], a = rgba[3];
	              if (a == null) a = normalized ? 1 : 255;
	              if (normalized) {
	                r *= 255;
	                g *= 255;
	                b *= 255;
	                a *= 255;
	              }
	              r = clamp(r, 0, 255) & 255;
	              g = clamp(g, 0, 255) & 255;
	              b = clamp(b, 0, 255) & 255;
	              a = clamp(a, 0, 255) & 255;
	              var n = r * 16777216 + (g << 16) + (b << 8) + a;
	              return n;
	            }
	            function fromNumber(n, normalized) {
	              n = +n;
	              var r = n >>> 24;
	              var g = (n & 16711680) >>> 16;
	              var b = (n & 65280) >>> 8;
	              var a = n & 255;
	              if (normalized === false) return [r, g, b, a];
	              return [r / 255, g / 255, b / 255, a / 255];
	            }
	          }
	        ),
	        /***/
	        76857: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              "aliceblue": [240, 248, 255],
	              "antiquewhite": [250, 235, 215],
	              "aqua": [0, 255, 255],
	              "aquamarine": [127, 255, 212],
	              "azure": [240, 255, 255],
	              "beige": [245, 245, 220],
	              "bisque": [255, 228, 196],
	              "black": [0, 0, 0],
	              "blanchedalmond": [255, 235, 205],
	              "blue": [0, 0, 255],
	              "blueviolet": [138, 43, 226],
	              "brown": [165, 42, 42],
	              "burlywood": [222, 184, 135],
	              "cadetblue": [95, 158, 160],
	              "chartreuse": [127, 255, 0],
	              "chocolate": [210, 105, 30],
	              "coral": [255, 127, 80],
	              "cornflowerblue": [100, 149, 237],
	              "cornsilk": [255, 248, 220],
	              "crimson": [220, 20, 60],
	              "cyan": [0, 255, 255],
	              "darkblue": [0, 0, 139],
	              "darkcyan": [0, 139, 139],
	              "darkgoldenrod": [184, 134, 11],
	              "darkgray": [169, 169, 169],
	              "darkgreen": [0, 100, 0],
	              "darkgrey": [169, 169, 169],
	              "darkkhaki": [189, 183, 107],
	              "darkmagenta": [139, 0, 139],
	              "darkolivegreen": [85, 107, 47],
	              "darkorange": [255, 140, 0],
	              "darkorchid": [153, 50, 204],
	              "darkred": [139, 0, 0],
	              "darksalmon": [233, 150, 122],
	              "darkseagreen": [143, 188, 143],
	              "darkslateblue": [72, 61, 139],
	              "darkslategray": [47, 79, 79],
	              "darkslategrey": [47, 79, 79],
	              "darkturquoise": [0, 206, 209],
	              "darkviolet": [148, 0, 211],
	              "deeppink": [255, 20, 147],
	              "deepskyblue": [0, 191, 255],
	              "dimgray": [105, 105, 105],
	              "dimgrey": [105, 105, 105],
	              "dodgerblue": [30, 144, 255],
	              "firebrick": [178, 34, 34],
	              "floralwhite": [255, 250, 240],
	              "forestgreen": [34, 139, 34],
	              "fuchsia": [255, 0, 255],
	              "gainsboro": [220, 220, 220],
	              "ghostwhite": [248, 248, 255],
	              "gold": [255, 215, 0],
	              "goldenrod": [218, 165, 32],
	              "gray": [128, 128, 128],
	              "green": [0, 128, 0],
	              "greenyellow": [173, 255, 47],
	              "grey": [128, 128, 128],
	              "honeydew": [240, 255, 240],
	              "hotpink": [255, 105, 180],
	              "indianred": [205, 92, 92],
	              "indigo": [75, 0, 130],
	              "ivory": [255, 255, 240],
	              "khaki": [240, 230, 140],
	              "lavender": [230, 230, 250],
	              "lavenderblush": [255, 240, 245],
	              "lawngreen": [124, 252, 0],
	              "lemonchiffon": [255, 250, 205],
	              "lightblue": [173, 216, 230],
	              "lightcoral": [240, 128, 128],
	              "lightcyan": [224, 255, 255],
	              "lightgoldenrodyellow": [250, 250, 210],
	              "lightgray": [211, 211, 211],
	              "lightgreen": [144, 238, 144],
	              "lightgrey": [211, 211, 211],
	              "lightpink": [255, 182, 193],
	              "lightsalmon": [255, 160, 122],
	              "lightseagreen": [32, 178, 170],
	              "lightskyblue": [135, 206, 250],
	              "lightslategray": [119, 136, 153],
	              "lightslategrey": [119, 136, 153],
	              "lightsteelblue": [176, 196, 222],
	              "lightyellow": [255, 255, 224],
	              "lime": [0, 255, 0],
	              "limegreen": [50, 205, 50],
	              "linen": [250, 240, 230],
	              "magenta": [255, 0, 255],
	              "maroon": [128, 0, 0],
	              "mediumaquamarine": [102, 205, 170],
	              "mediumblue": [0, 0, 205],
	              "mediumorchid": [186, 85, 211],
	              "mediumpurple": [147, 112, 219],
	              "mediumseagreen": [60, 179, 113],
	              "mediumslateblue": [123, 104, 238],
	              "mediumspringgreen": [0, 250, 154],
	              "mediumturquoise": [72, 209, 204],
	              "mediumvioletred": [199, 21, 133],
	              "midnightblue": [25, 25, 112],
	              "mintcream": [245, 255, 250],
	              "mistyrose": [255, 228, 225],
	              "moccasin": [255, 228, 181],
	              "navajowhite": [255, 222, 173],
	              "navy": [0, 0, 128],
	              "oldlace": [253, 245, 230],
	              "olive": [128, 128, 0],
	              "olivedrab": [107, 142, 35],
	              "orange": [255, 165, 0],
	              "orangered": [255, 69, 0],
	              "orchid": [218, 112, 214],
	              "palegoldenrod": [238, 232, 170],
	              "palegreen": [152, 251, 152],
	              "paleturquoise": [175, 238, 238],
	              "palevioletred": [219, 112, 147],
	              "papayawhip": [255, 239, 213],
	              "peachpuff": [255, 218, 185],
	              "peru": [205, 133, 63],
	              "pink": [255, 192, 203],
	              "plum": [221, 160, 221],
	              "powderblue": [176, 224, 230],
	              "purple": [128, 0, 128],
	              "rebeccapurple": [102, 51, 153],
	              "red": [255, 0, 0],
	              "rosybrown": [188, 143, 143],
	              "royalblue": [65, 105, 225],
	              "saddlebrown": [139, 69, 19],
	              "salmon": [250, 128, 114],
	              "sandybrown": [244, 164, 96],
	              "seagreen": [46, 139, 87],
	              "seashell": [255, 245, 238],
	              "sienna": [160, 82, 45],
	              "silver": [192, 192, 192],
	              "skyblue": [135, 206, 235],
	              "slateblue": [106, 90, 205],
	              "slategray": [112, 128, 144],
	              "slategrey": [112, 128, 144],
	              "snow": [255, 250, 250],
	              "springgreen": [0, 255, 127],
	              "steelblue": [70, 130, 180],
	              "tan": [210, 180, 140],
	              "teal": [0, 128, 128],
	              "thistle": [216, 191, 216],
	              "tomato": [255, 99, 71],
	              "turquoise": [64, 224, 208],
	              "violet": [238, 130, 238],
	              "wheat": [245, 222, 179],
	              "white": [255, 255, 255],
	              "whitesmoke": [245, 245, 245],
	              "yellow": [255, 255, 0],
	              "yellowgreen": [154, 205, 50]
	            };
	          }
	        ),
	        /***/
	        25075: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var rgba = __webpack_require__2(36652);
	            var clamp = __webpack_require__2(53435);
	            var dtype = __webpack_require__2(90660);
	            module2.exports = function normalize(color, type) {
	              if (type === "float" || !type) type = "array";
	              if (type === "uint") type = "uint8";
	              if (type === "uint_clamped") type = "uint8_clamped";
	              var Ctor = dtype(type);
	              var output = new Ctor(4);
	              var normalize2 = type !== "uint8" && type !== "uint8_clamped";
	              if (!color.length || typeof color === "string") {
	                color = rgba(color);
	                color[0] /= 255;
	                color[1] /= 255;
	                color[2] /= 255;
	              }
	              if (isInt(color)) {
	                output[0] = color[0];
	                output[1] = color[1];
	                output[2] = color[2];
	                output[3] = color[3] != null ? color[3] : 255;
	                if (normalize2) {
	                  output[0] /= 255;
	                  output[1] /= 255;
	                  output[2] /= 255;
	                  output[3] /= 255;
	                }
	                return output;
	              }
	              if (!normalize2) {
	                output[0] = clamp(Math.floor(color[0] * 255), 0, 255);
	                output[1] = clamp(Math.floor(color[1] * 255), 0, 255);
	                output[2] = clamp(Math.floor(color[2] * 255), 0, 255);
	                output[3] = color[3] == null ? 255 : clamp(Math.floor(color[3] * 255), 0, 255);
	              } else {
	                output[0] = color[0];
	                output[1] = color[1];
	                output[2] = color[2];
	                output[3] = color[3] != null ? color[3] : 1;
	              }
	              return output;
	            };
	            function isInt(color) {
	              if (color instanceof Uint8Array || color instanceof Uint8ClampedArray) return true;
	              if (Array.isArray(color) && (color[0] > 1 || color[0] === 0) && (color[1] > 1 || color[1] === 0) && (color[2] > 1 || color[2] === 0) && (!color[3] || color[3] > 1)) return true;
	              return false;
	            }
	          }
	        ),
	        /***/
	        90736: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var names = __webpack_require__2(76857);
	            var isObject = __webpack_require__2(10973);
	            var defined = __webpack_require__2(46775);
	            module2.exports = parse;
	            var baseHues = {
	              red: 0,
	              orange: 60,
	              yellow: 120,
	              green: 180,
	              blue: 240,
	              purple: 300
	            };
	            function parse(cstr) {
	              var m, parts = [], alpha = 1, space;
	              if (typeof cstr === "string") {
	                if (names[cstr]) {
	                  parts = names[cstr].slice();
	                  space = "rgb";
	                } else if (cstr === "transparent") {
	                  alpha = 0;
	                  space = "rgb";
	                  parts = [0, 0, 0];
	                } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
	                  var base = cstr.slice(1);
	                  var size = base.length;
	                  var isShort = size <= 4;
	                  alpha = 1;
	                  if (isShort) {
	                    parts = [
	                      parseInt(base[0] + base[0], 16),
	                      parseInt(base[1] + base[1], 16),
	                      parseInt(base[2] + base[2], 16)
	                    ];
	                    if (size === 4) {
	                      alpha = parseInt(base[3] + base[3], 16) / 255;
	                    }
	                  } else {
	                    parts = [
	                      parseInt(base[0] + base[1], 16),
	                      parseInt(base[2] + base[3], 16),
	                      parseInt(base[4] + base[5], 16)
	                    ];
	                    if (size === 8) {
	                      alpha = parseInt(base[6] + base[7], 16) / 255;
	                    }
	                  }
	                  if (!parts[0]) parts[0] = 0;
	                  if (!parts[1]) parts[1] = 0;
	                  if (!parts[2]) parts[2] = 0;
	                  space = "rgb";
	                } else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
	                  var name2 = m[1];
	                  var isRGB = name2 === "rgb";
	                  var base = name2.replace(/a$/, "");
	                  space = base;
	                  var size = base === "cmyk" ? 4 : base === "gray" ? 1 : 3;
	                  parts = m[2].trim().split(/\s*,\s*/).map(function(x, i) {
	                    if (/%$/.test(x)) {
	                      if (i === size) return parseFloat(x) / 100;
	                      if (base === "rgb") return parseFloat(x) * 255 / 100;
	                      return parseFloat(x);
	                    } else if (base[i] === "h") {
	                      if (/deg$/.test(x)) {
	                        return parseFloat(x);
	                      } else if (baseHues[x] !== undefined) {
	                        return baseHues[x];
	                      }
	                    }
	                    return parseFloat(x);
	                  });
	                  if (name2 === base) parts.push(1);
	                  alpha = isRGB ? 1 : parts[size] === undefined ? 1 : parts[size];
	                  parts = parts.slice(0, size);
	                } else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
	                  parts = cstr.match(/([0-9]+)/g).map(function(value) {
	                    return parseFloat(value);
	                  });
	                  space = cstr.match(/([a-z])/ig).join("").toLowerCase();
	                }
	              } else if (!isNaN(cstr)) {
	                space = "rgb";
	                parts = [cstr >>> 16, (cstr & 65280) >>> 8, cstr & 255];
	              } else if (isObject(cstr)) {
	                var r = defined(cstr.r, cstr.red, cstr.R, null);
	                if (r !== null) {
	                  space = "rgb";
	                  parts = [
	                    r,
	                    defined(cstr.g, cstr.green, cstr.G),
	                    defined(cstr.b, cstr.blue, cstr.B)
	                  ];
	                } else {
	                  space = "hsl";
	                  parts = [
	                    defined(cstr.h, cstr.hue, cstr.H),
	                    defined(cstr.s, cstr.saturation, cstr.S),
	                    defined(cstr.l, cstr.lightness, cstr.L, cstr.b, cstr.brightness)
	                  ];
	                }
	                alpha = defined(cstr.a, cstr.alpha, cstr.opacity, 1);
	                if (cstr.opacity != null) alpha /= 100;
	              } else if (Array.isArray(cstr) || __webpack_require__2.g.ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(cstr)) {
	                parts = [cstr[0], cstr[1], cstr[2]];
	                space = "rgb";
	                alpha = cstr.length === 4 ? cstr[3] : 1;
	              }
	              return {
	                space,
	                values: parts,
	                alpha
	              };
	            }
	          }
	        ),
	        /***/
	        36652: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parse = __webpack_require__2(90736);
	            var hsl = __webpack_require__2(80009);
	            var clamp = __webpack_require__2(53435);
	            module2.exports = function rgba(color) {
	              var values;
	              var parsed = parse(color);
	              if (!parsed.space) return [];
	              values = Array(3);
	              values[0] = clamp(parsed.values[0], 0, 255);
	              values[1] = clamp(parsed.values[1], 0, 255);
	              values[2] = clamp(parsed.values[2], 0, 255);
	              if (parsed.space[0] === "h") {
	                values = hsl.rgb(values);
	              }
	              values.push(clamp(parsed.alpha, 0, 1));
	              return values;
	            };
	          }
	        ),
	        /***/
	        80009: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var rgb = __webpack_require__2(6866);
	            module2.exports = {
	              name: "hsl",
	              min: [0, 0, 0],
	              max: [360, 100, 100],
	              channel: ["hue", "saturation", "lightness"],
	              alias: ["HSL"],
	              rgb: function(hsl) {
	                var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb2, val;
	                if (s === 0) {
	                  val = l * 255;
	                  return [val, val, val];
	                }
	                if (l < 0.5) {
	                  t2 = l * (1 + s);
	                } else {
	                  t2 = l + s - l * s;
	                }
	                t1 = 2 * l - t2;
	                rgb2 = [0, 0, 0];
	                for (var i = 0; i < 3; i++) {
	                  t3 = h + 1 / 3 * -(i - 1);
	                  if (t3 < 0) {
	                    t3++;
	                  } else if (t3 > 1) {
	                    t3--;
	                  }
	                  if (6 * t3 < 1) {
	                    val = t1 + (t2 - t1) * 6 * t3;
	                  } else if (2 * t3 < 1) {
	                    val = t2;
	                  } else if (3 * t3 < 2) {
	                    val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	                  } else {
	                    val = t1;
	                  }
	                  rgb2[i] = val * 255;
	                }
	                return rgb2;
	              }
	            };
	            rgb.hsl = function(rgb2) {
	              var r = rgb2[0] / 255, g = rgb2[1] / 255, b = rgb2[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
	              if (max === min) {
	                h = 0;
	              } else if (r === max) {
	                h = (g - b) / delta;
	              } else if (g === max) {
	                h = 2 + (b - r) / delta;
	              } else if (b === max) {
	                h = 4 + (r - g) / delta;
	              }
	              h = Math.min(h * 60, 360);
	              if (h < 0) {
	                h += 360;
	              }
	              l = (min + max) / 2;
	              if (max === min) {
	                s = 0;
	              } else if (l <= 0.5) {
	                s = delta / (max + min);
	              } else {
	                s = delta / (2 - max - min);
	              }
	              return [h, s * 100, l * 100];
	            };
	          }
	        ),
	        /***/
	        6866: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              name: "rgb",
	              min: [0, 0, 0],
	              max: [255, 255, 255],
	              channel: ["red", "green", "blue"],
	              alias: ["RGB"]
	            };
	          }
	        ),
	        /***/
	        24138: (
	          /***/
	          function(module2) {
	            module2.exports = {
	              AFG: "afghan",
	              ALA: "\\b\\wland",
	              ALB: "albania",
	              DZA: "algeria",
	              ASM: "^(?=.*americ).*samoa",
	              AND: "andorra",
	              AGO: "angola",
	              AIA: "anguill?a",
	              ATA: "antarctica",
	              ATG: "antigua",
	              ARG: "argentin",
	              ARM: "armenia",
	              ABW: "^(?!.*bonaire).*\\baruba",
	              AUS: "australia",
	              AUT: "^(?!.*hungary).*austria|\\baustri.*\\bemp",
	              AZE: "azerbaijan",
	              BHS: "bahamas",
	              BHR: "bahrain",
	              BGD: "bangladesh|^(?=.*east).*paki?stan",
	              BRB: "barbados",
	              BLR: "belarus|byelo",
	              BEL: "^(?!.*luxem).*belgium",
	              BLZ: "belize|^(?=.*british).*honduras",
	              BEN: "benin|dahome",
	              BMU: "bermuda",
	              BTN: "bhutan",
	              BOL: "bolivia",
	              BES: "^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands",
	              BIH: "herzegovina|bosnia",
	              BWA: "botswana|bechuana",
	              BVT: "bouvet",
	              BRA: "brazil",
	              IOT: "british.?indian.?ocean",
	              BRN: "brunei",
	              BGR: "bulgaria",
	              BFA: "burkina|\\bfaso|upper.?volta",
	              BDI: "burundi",
	              CPV: "verde",
	              KHM: "cambodia|kampuchea|khmer",
	              CMR: "cameroon",
	              CAN: "canada",
	              CYM: "cayman",
	              CAF: "\\bcentral.african.republic",
	              TCD: "\\bchad",
	              CHL: "\\bchile",
	              CHN: "^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china",
	              CXR: "christmas",
	              CCK: "\\bcocos|keeling",
	              COL: "colombia",
	              COM: "comoro",
	              COG: "^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo",
	              COK: "\\bcook",
	              CRI: "costa.?rica",
	              CIV: "ivoire|ivory",
	              HRV: "croatia",
	              CUB: "\\bcuba",
	              CUW: "^(?!.*bonaire).*\\bcura(c|ç)ao",
	              CYP: "cyprus",
	              CSK: "czechoslovakia",
	              CZE: "^(?=.*rep).*czech|czechia|bohemia",
	              COD: "\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc",
	              DNK: "denmark",
	              DJI: "djibouti",
	              DMA: "dominica(?!n)",
	              DOM: "dominican.rep",
	              ECU: "ecuador",
	              EGY: "egypt",
	              SLV: "el.?salvador",
	              GNQ: "guine.*eq|eq.*guine|^(?=.*span).*guinea",
	              ERI: "eritrea",
	              EST: "estonia",
	              ETH: "ethiopia|abyssinia",
	              FLK: "falkland|malvinas",
	              FRO: "faroe|faeroe",
	              FJI: "fiji",
	              FIN: "finland",
	              FRA: "^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul",
	              GUF: "^(?=.*french).*guiana",
	              PYF: "french.?polynesia|tahiti",
	              ATF: "french.?southern",
	              GAB: "gabon",
	              GMB: "gambia",
	              GEO: "^(?!.*south).*georgia",
	              DDR: "german.?democratic.?republic|democratic.?republic.*germany|east.germany",
	              DEU: "^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german",
	              GHA: "ghana|gold.?coast",
	              GIB: "gibraltar",
	              GRC: "greece|hellenic|hellas",
	              GRL: "greenland",
	              GRD: "grenada",
	              GLP: "guadeloupe",
	              GUM: "\\bguam",
	              GTM: "guatemala",
	              GGY: "guernsey",
	              GIN: "^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea",
	              GNB: "bissau|^(?=.*portu).*guinea",
	              GUY: "guyana|british.?guiana",
	              HTI: "haiti",
	              HMD: "heard.*mcdonald",
	              VAT: "holy.?see|vatican|papal.?st",
	              HND: "^(?!.*brit).*honduras",
	              HKG: "hong.?kong",
	              HUN: "^(?!.*austr).*hungary",
	              ISL: "iceland",
	              IND: "india(?!.*ocea)",
	              IDN: "indonesia",
	              IRN: "\\biran|persia",
	              IRQ: "\\biraq|mesopotamia",
	              IRL: "(^ireland)|(^republic.*ireland)",
	              IMN: "^(?=.*isle).*\\bman",
	              ISR: "israel",
	              ITA: "italy",
	              JAM: "jamaica",
	              JPN: "japan",
	              JEY: "jersey",
	              JOR: "jordan",
	              KAZ: "kazak",
	              KEN: "kenya|british.?east.?africa|east.?africa.?prot",
	              KIR: "kiribati",
	              PRK: "^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)",
	              KWT: "kuwait",
	              KGZ: "kyrgyz|kirghiz",
	              LAO: "\\blaos?\\b",
	              LVA: "latvia",
	              LBN: "lebanon",
	              LSO: "lesotho|basuto",
	              LBR: "liberia",
	              LBY: "libya",
	              LIE: "liechtenstein",
	              LTU: "lithuania",
	              LUX: "^(?!.*belg).*luxem",
	              MAC: "maca(o|u)",
	              MDG: "madagascar|malagasy",
	              MWI: "malawi|nyasa",
	              MYS: "malaysia",
	              MDV: "maldive",
	              MLI: "\\bmali\\b",
	              MLT: "\\bmalta",
	              MHL: "marshall",
	              MTQ: "martinique",
	              MRT: "mauritania",
	              MUS: "mauritius",
	              MYT: "\\bmayotte",
	              MEX: "\\bmexic",
	              FSM: "fed.*micronesia|micronesia.*fed",
	              MCO: "monaco",
	              MNG: "mongolia",
	              MNE: "^(?!.*serbia).*montenegro",
	              MSR: "montserrat",
	              MAR: "morocco|\\bmaroc",
	              MOZ: "mozambique",
	              MMR: "myanmar|burma",
	              NAM: "namibia",
	              NRU: "nauru",
	              NPL: "nepal",
	              NLD: "^(?!.*\\bant)(?!.*\\bcarib).*netherlands",
	              ANT: "^(?=.*\\bant).*(nether|dutch)",
	              NCL: "new.?caledonia",
	              NZL: "new.?zealand",
	              NIC: "nicaragua",
	              NER: "\\bniger(?!ia)",
	              NGA: "nigeria",
	              NIU: "niue",
	              NFK: "norfolk",
	              MNP: "mariana",
	              NOR: "norway",
	              OMN: "\\boman|trucial",
	              PAK: "^(?!.*east).*paki?stan",
	              PLW: "palau",
	              PSE: "palestin|\\bgaza|west.?bank",
	              PAN: "panama",
	              PNG: "papua|new.?guinea",
	              PRY: "paraguay",
	              PER: "peru",
	              PHL: "philippines",
	              PCN: "pitcairn",
	              POL: "poland",
	              PRT: "portugal",
	              PRI: "puerto.?rico",
	              QAT: "qatar",
	              KOR: "^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)",
	              MDA: "moldov|b(a|e)ssarabia",
	              REU: "r(e|é)union",
	              ROU: "r(o|u|ou)mania",
	              RUS: "\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics",
	              RWA: "rwanda",
	              BLM: "barth(e|é)lemy",
	              SHN: "helena",
	              KNA: "kitts|\\bnevis",
	              LCA: "\\blucia",
	              MAF: "^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)",
	              SPM: "miquelon",
	              VCT: "vincent",
	              WSM: "^(?!.*amer).*samoa",
	              SMR: "san.?marino",
	              STP: "\\bs(a|ã)o.?tom(e|é)",
	              SAU: "\\bsa\\w*.?arabia",
	              SEN: "senegal",
	              SRB: "^(?!.*monte).*serbia",
	              SYC: "seychell",
	              SLE: "sierra",
	              SGP: "singapore",
	              SXM: "^(?!.*martin)(?!.*saba).*maarten",
	              SVK: "^(?!.*cze).*slovak",
	              SVN: "slovenia",
	              SLB: "solomon",
	              SOM: "somali",
	              ZAF: "south.africa|s\\\\..?africa",
	              SGS: "south.?georgia|sandwich",
	              SSD: "\\bs\\w*.?sudan",
	              ESP: "spain",
	              LKA: "sri.?lanka|ceylon",
	              SDN: "^(?!.*\\bs(?!u)).*sudan",
	              SUR: "surinam|dutch.?guiana",
	              SJM: "svalbard",
	              SWZ: "swaziland",
	              SWE: "sweden",
	              CHE: "switz|swiss",
	              SYR: "syria",
	              TWN: "taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china",
	              TJK: "tajik",
	              THA: "thailand|\\bsiam",
	              MKD: "macedonia|fyrom",
	              TLS: "^(?=.*leste).*timor|^(?=.*east).*timor",
	              TGO: "togo",
	              TKL: "tokelau",
	              TON: "tonga",
	              TTO: "trinidad|tobago",
	              TUN: "tunisia",
	              TUR: "turkey",
	              TKM: "turkmen",
	              TCA: "turks",
	              TUV: "tuvalu",
	              UGA: "uganda",
	              UKR: "ukrain",
	              ARE: "emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em",
	              GBR: "united.?kingdom|britain|^u\\.?k\\.?$",
	              TZA: "tanzania",
	              USA: "united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)",
	              UMI: "minor.?outlying.?is",
	              URY: "uruguay",
	              UZB: "uzbek",
	              VUT: "vanuatu|new.?hebrides",
	              VEN: "venezuela",
	              VNM: "^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam",
	              VGB: "^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin",
	              VIR: "^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin",
	              WLF: "futuna|wallis",
	              ESH: "western.sahara",
	              YEM: "^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen",
	              YMD: "^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen",
	              YUG: "yugoslavia",
	              ZMB: "zambia|northern.?rhodesia",
	              EAZ: "zanzibar",
	              ZWE: "zimbabwe|^(?!.*northern).*rhodesia"
	            };
	          }
	        ),
	        /***/
	        72791: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              parse: __webpack_require__2(41004),
	              stringify: __webpack_require__2(53313)
	            };
	          }
	        ),
	        /***/
	        63625: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var sizes = __webpack_require__2(40402);
	            module2.exports = {
	              isSize: function isSize(value) {
	                return /^[\d\.]/.test(value) || value.indexOf("/") !== -1 || sizes.indexOf(value) !== -1;
	              }
	            };
	          }
	        ),
	        /***/
	        41004: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var unquote = __webpack_require__2(90448);
	            var globalKeywords = __webpack_require__2(38732);
	            var systemFontKeywords = __webpack_require__2(41901);
	            var fontWeightKeywords = __webpack_require__2(15659);
	            var fontStyleKeywords = __webpack_require__2(96209);
	            var fontStretchKeywords = __webpack_require__2(83794);
	            var splitBy = __webpack_require__2(99011);
	            var isSize = __webpack_require__2(63625).isSize;
	            module2.exports = parseFont;
	            var cache = parseFont.cache = {};
	            function parseFont(value) {
	              if (typeof value !== "string") throw new Error("Font argument must be a string.");
	              if (cache[value]) return cache[value];
	              if (value === "") {
	                throw new Error("Cannot parse an empty string.");
	              }
	              if (systemFontKeywords.indexOf(value) !== -1) {
	                return cache[value] = { system: value };
	              }
	              var font = {
	                style: "normal",
	                variant: "normal",
	                weight: "normal",
	                stretch: "normal",
	                lineHeight: "normal",
	                size: "1rem",
	                family: ["serif"]
	              };
	              var tokens = splitBy(value, /\s+/);
	              var token;
	              while (token = tokens.shift()) {
	                if (globalKeywords.indexOf(token) !== -1) {
	                  ["style", "variant", "weight", "stretch"].forEach(function(prop) {
	                    font[prop] = token;
	                  });
	                  return cache[value] = font;
	                }
	                if (fontStyleKeywords.indexOf(token) !== -1) {
	                  font.style = token;
	                  continue;
	                }
	                if (token === "normal" || token === "small-caps") {
	                  font.variant = token;
	                  continue;
	                }
	                if (fontStretchKeywords.indexOf(token) !== -1) {
	                  font.stretch = token;
	                  continue;
	                }
	                if (fontWeightKeywords.indexOf(token) !== -1) {
	                  font.weight = token;
	                  continue;
	                }
	                if (isSize(token)) {
	                  var parts = splitBy(token, "/");
	                  font.size = parts[0];
	                  if (parts[1] != null) {
	                    font.lineHeight = parseLineHeight(parts[1]);
	                  } else if (tokens[0] === "/") {
	                    tokens.shift();
	                    font.lineHeight = parseLineHeight(tokens.shift());
	                  }
	                  if (!tokens.length) {
	                    throw new Error("Missing required font-family.");
	                  }
	                  font.family = splitBy(tokens.join(" "), /\s*,\s*/).map(unquote);
	                  return cache[value] = font;
	                }
	                throw new Error("Unknown or unsupported font token: " + token);
	              }
	              throw new Error("Missing required font-size.");
	            }
	            function parseLineHeight(value) {
	              var parsed = parseFloat(value);
	              if (parsed.toString() === value) {
	                return parsed;
	              }
	              return value;
	            }
	          }
	        ),
	        /***/
	        53313: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var pick = __webpack_require__2(71299);
	            var isSize = __webpack_require__2(63625).isSize;
	            var globals = a2o(__webpack_require__2(38732));
	            var systems = a2o(__webpack_require__2(41901));
	            var weights = a2o(__webpack_require__2(15659));
	            var styles = a2o(__webpack_require__2(96209));
	            var stretches = a2o(__webpack_require__2(83794));
	            var variants = { "normal": 1, "small-caps": 1 };
	            var fams = {
	              "serif": 1,
	              "sans-serif": 1,
	              "monospace": 1,
	              "cursive": 1,
	              "fantasy": 1,
	              "system-ui": 1
	            };
	            var defaults = {
	              style: "normal",
	              variant: "normal",
	              weight: "normal",
	              stretch: "normal",
	              size: "1rem",
	              lineHeight: "normal",
	              family: "serif"
	            };
	            module2.exports = function stringifyFont(o) {
	              o = pick(o, {
	                style: "style fontstyle fontStyle font-style slope distinction",
	                variant: "variant font-variant fontVariant fontvariant var capitalization",
	                weight: "weight w font-weight fontWeight fontweight",
	                stretch: "stretch font-stretch fontStretch fontstretch width",
	                size: "size s font-size fontSize fontsize height em emSize",
	                lineHeight: "lh line-height lineHeight lineheight leading",
	                family: "font family fontFamily font-family fontfamily type typeface face",
	                system: "system reserved default global"
	              });
	              if (o.system) {
	                if (o.system) verify(o.system, systems);
	                return o.system;
	              }
	              verify(o.style, styles);
	              verify(o.variant, variants);
	              verify(o.weight, weights);
	              verify(o.stretch, stretches);
	              if (o.size == null) o.size = defaults.size;
	              if (typeof o.size === "number") o.size += "px";
	              if (!isSize) throw Error("Bad size value `" + o.size + "`");
	              if (!o.family) o.family = defaults.family;
	              if (Array.isArray(o.family)) {
	                if (!o.family.length) o.family = [defaults.family];
	                o.family = o.family.map(function(f) {
	                  return fams[f] ? f : '"' + f + '"';
	                }).join(", ");
	              }
	              var result = [];
	              result.push(o.style);
	              if (o.variant !== o.style) result.push(o.variant);
	              if (o.weight !== o.variant && o.weight !== o.style) result.push(o.weight);
	              if (o.stretch !== o.weight && o.stretch !== o.variant && o.stretch !== o.style) result.push(o.stretch);
	              result.push(o.size + (o.lineHeight == null || o.lineHeight === "normal" || o.lineHeight + "" === "1" ? "" : "/" + o.lineHeight));
	              result.push(o.family);
	              return result.filter(Boolean).join(" ");
	            };
	            function verify(value, values) {
	              if (value && !values[value] && !globals[value]) throw Error("Unknown keyword `" + value + "`");
	              return value;
	            }
	            function a2o(a) {
	              var o = {};
	              for (var i = 0; i < a.length; i++) {
	                o[a[i]] = 1;
	              }
	              return o;
	            }
	          }
	        ),
	        /***/
	        55174: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(24582), ensureValue = __webpack_require__2(10424), ensurePlainFunction = __webpack_require__2(82527), copy = __webpack_require__2(19012), normalizeOptions = __webpack_require__2(21780), map2 = __webpack_require__2(16906);
	            var bind = Function.prototype.bind, defineProperty = Object.defineProperty, hasOwnProperty2 = Object.prototype.hasOwnProperty, define2;
	            define2 = function(name2, desc, options) {
	              var value = ensureValue(desc) && ensurePlainFunction(desc.value), dgs;
	              dgs = copy(desc);
	              delete dgs.writable;
	              delete dgs.value;
	              dgs.get = function() {
	                if (!options.overwriteDefinition && hasOwnProperty2.call(this, name2)) return value;
	                desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
	                defineProperty(this, name2, desc);
	                return this[name2];
	              };
	              return dgs;
	            };
	            module2.exports = function(props) {
	              var options = normalizeOptions(arguments[1]);
	              if (isValue(options.resolveContext)) ensurePlainFunction(options.resolveContext);
	              return map2(props, function(desc, name2) {
	                return define2(name2, desc, options);
	              });
	            };
	          }
	        ),
	        /***/
	        62072: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(24582), isPlainFunction = __webpack_require__2(84985), assign = __webpack_require__2(95879), normalizeOpts = __webpack_require__2(21780), contains = __webpack_require__2(66741);
	            var d = module2.exports = function(dscr, value) {
	              var c, e, w, options, desc;
	              if (arguments.length < 2 || typeof dscr !== "string") {
	                options = value;
	                value = dscr;
	                dscr = null;
	              } else {
	                options = arguments[2];
	              }
	              if (isValue(dscr)) {
	                c = contains.call(dscr, "c");
	                e = contains.call(dscr, "e");
	                w = contains.call(dscr, "w");
	              } else {
	                c = w = true;
	                e = false;
	              }
	              desc = { value, configurable: c, enumerable: e, writable: w };
	              return !options ? desc : assign(normalizeOpts(options), desc);
	            };
	            d.gs = function(dscr, get, set) {
	              var c, e, options, desc;
	              if (typeof dscr !== "string") {
	                options = set;
	                set = get;
	                get = dscr;
	                dscr = null;
	              } else {
	                options = arguments[3];
	              }
	              if (!isValue(get)) {
	                get = undefined;
	              } else if (!isPlainFunction(get)) {
	                options = get;
	                get = set = undefined;
	              } else if (!isValue(set)) {
	                set = undefined;
	              } else if (!isPlainFunction(set)) {
	                options = set;
	                set = undefined;
	              }
	              if (isValue(dscr)) {
	                c = contains.call(dscr, "c");
	                e = contains.call(dscr, "e");
	              } else {
	                c = true;
	                e = false;
	              }
	              desc = { get, set, configurable: c, enumerable: e };
	              return !options ? desc : assign(normalizeOpts(options), desc);
	            };
	          }
	        ),
	        /***/
	        33064: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              j2: function() {
	                return (
	                  /* reexport */
	                  src_ascending
	                );
	              },
	              Fp: function() {
	                return (
	                  /* reexport */
	                  max
	                );
	              },
	              J6: function() {
	                return (
	                  /* reexport */
	                  mean
	                );
	              },
	              TS: function() {
	                return (
	                  /* reexport */
	                  merge
	                );
	              },
	              VV: function() {
	                return (
	                  /* reexport */
	                  min
	                );
	              },
	              w6: function() {
	                return (
	                  /* reexport */
	                  src_range
	                );
	              },
	              Sm: function() {
	                return (
	                  /* reexport */
	                  sum
	                );
	              }
	            });
	            function src_ascending(a, b) {
	              return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	            }
	            function bisector(compare) {
	              if (compare.length === 1) compare = ascendingComparator(compare);
	              return {
	                left: function(a, x, lo, hi) {
	                  if (lo == null) lo = 0;
	                  if (hi == null) hi = a.length;
	                  while (lo < hi) {
	                    var mid = lo + hi >>> 1;
	                    if (compare(a[mid], x) < 0) lo = mid + 1;
	                    else hi = mid;
	                  }
	                  return lo;
	                },
	                right: function(a, x, lo, hi) {
	                  if (lo == null) lo = 0;
	                  if (hi == null) hi = a.length;
	                  while (lo < hi) {
	                    var mid = lo + hi >>> 1;
	                    if (compare(a[mid], x) > 0) hi = mid;
	                    else lo = mid + 1;
	                  }
	                  return lo;
	                }
	              };
	            }
	            function ascendingComparator(f) {
	              return function(d, x) {
	                return src_ascending(f(d), x);
	              };
	            }
	            bisector(src_ascending);
	            function max(values, valueof) {
	              var n = values.length, i = -1, value, max2;
	              if (valueof == null) {
	                while (++i < n) {
	                  if ((value = values[i]) != null && value >= value) {
	                    max2 = value;
	                    while (++i < n) {
	                      if ((value = values[i]) != null && value > max2) {
	                        max2 = value;
	                      }
	                    }
	                  }
	                }
	              } else {
	                while (++i < n) {
	                  if ((value = valueof(values[i], i, values)) != null && value >= value) {
	                    max2 = value;
	                    while (++i < n) {
	                      if ((value = valueof(values[i], i, values)) != null && value > max2) {
	                        max2 = value;
	                      }
	                    }
	                  }
	                }
	              }
	              return max2;
	            }
	            function src_number(x) {
	              return x === null ? NaN : +x;
	            }
	            function mean(values, valueof) {
	              var n = values.length, m = n, i = -1, value, sum2 = 0;
	              if (valueof == null) {
	                while (++i < n) {
	                  if (!isNaN(value = src_number(values[i]))) sum2 += value;
	                  else --m;
	                }
	              } else {
	                while (++i < n) {
	                  if (!isNaN(value = src_number(valueof(values[i], i, values)))) sum2 += value;
	                  else --m;
	                }
	              }
	              if (m) return sum2 / m;
	            }
	            function merge(arrays) {
	              var n = arrays.length, m, i = -1, j = 0, merged, array2;
	              while (++i < n) j += arrays[i].length;
	              merged = new Array(j);
	              while (--n >= 0) {
	                array2 = arrays[n];
	                m = array2.length;
	                while (--m >= 0) {
	                  merged[--j] = array2[m];
	                }
	              }
	              return merged;
	            }
	            function min(values, valueof) {
	              var n = values.length, i = -1, value, min2;
	              if (valueof == null) {
	                while (++i < n) {
	                  if ((value = values[i]) != null && value >= value) {
	                    min2 = value;
	                    while (++i < n) {
	                      if ((value = values[i]) != null && min2 > value) {
	                        min2 = value;
	                      }
	                    }
	                  }
	                }
	              } else {
	                while (++i < n) {
	                  if ((value = valueof(values[i], i, values)) != null && value >= value) {
	                    min2 = value;
	                    while (++i < n) {
	                      if ((value = valueof(values[i], i, values)) != null && min2 > value) {
	                        min2 = value;
	                      }
	                    }
	                  }
	                }
	              }
	              return min2;
	            }
	            function src_range(start, stop, step) {
	              start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	              var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range2 = new Array(n);
	              while (++i < n) {
	                range2[i] = start + i * step;
	              }
	              return range2;
	            }
	            function sum(values, valueof) {
	              var n = values.length, i = -1, value, sum2 = 0;
	              if (valueof == null) {
	                while (++i < n) {
	                  if (value = +values[i]) sum2 += value;
	                }
	              } else {
	                while (++i < n) {
	                  if (value = +valueof(values[i], i, values)) sum2 += value;
	                }
	              }
	              return sum2;
	            }
	          }
	        ),
	        /***/
	        15140: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              UI: function() {
	                return (
	                  /* reexport */
	                  src_map
	                );
	              },
	              b1: function() {
	                return (
	                  /* reexport */
	                  nest
	                );
	              }
	            });
	            var prefix = "$";
	            function Map2() {
	            }
	            Map2.prototype = map2.prototype = {
	              constructor: Map2,
	              has: function(key) {
	                return prefix + key in this;
	              },
	              get: function(key) {
	                return this[prefix + key];
	              },
	              set: function(key, value) {
	                this[prefix + key] = value;
	                return this;
	              },
	              remove: function(key) {
	                var property = prefix + key;
	                return property in this && delete this[property];
	              },
	              clear: function() {
	                for (var property in this) if (property[0] === prefix) delete this[property];
	              },
	              keys: function() {
	                var keys = [];
	                for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	                return keys;
	              },
	              values: function() {
	                var values = [];
	                for (var property in this) if (property[0] === prefix) values.push(this[property]);
	                return values;
	              },
	              entries: function() {
	                var entries = [];
	                for (var property in this) if (property[0] === prefix) entries.push({ key: property.slice(1), value: this[property] });
	                return entries;
	              },
	              size: function() {
	                var size = 0;
	                for (var property in this) if (property[0] === prefix) ++size;
	                return size;
	              },
	              empty: function() {
	                for (var property in this) if (property[0] === prefix) return false;
	                return true;
	              },
	              each: function(f) {
	                for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	              }
	            };
	            function map2(object, f) {
	              var map3 = new Map2();
	              if (object instanceof Map2) object.each(function(value, key2) {
	                map3.set(key2, value);
	              });
	              else if (Array.isArray(object)) {
	                var i = -1, n = object.length, o;
	                if (f == null) while (++i < n) map3.set(i, object[i]);
	                else while (++i < n) map3.set(f(o = object[i], i, object), o);
	              } else if (object) for (var key in object) map3.set(key, object[key]);
	              return map3;
	            }
	            var src_map = map2;
	            function nest() {
	              var keys = [], sortKeys = [], sortValues, rollup, nest2;
	              function apply(array, depth, createResult, setResult) {
	                if (depth >= keys.length) {
	                  if (sortValues != null) array.sort(sortValues);
	                  return rollup != null ? rollup(array) : array;
	                }
	                var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = src_map(), values, result = createResult();
	                while (++i < n) {
	                  if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	                    values.push(value);
	                  } else {
	                    valuesByKey.set(keyValue, [value]);
	                  }
	                }
	                valuesByKey.each(function(values2, key2) {
	                  setResult(result, key2, apply(values2, depth, createResult, setResult));
	                });
	                return result;
	              }
	              function entries(map3, depth) {
	                if (++depth > keys.length) return map3;
	                var array, sortKey = sortKeys[depth - 1];
	                if (rollup != null && depth >= keys.length) array = map3.entries();
	                else array = [], map3.each(function(v, k) {
	                  array.push({ key: k, values: entries(v, depth) });
	                });
	                return sortKey != null ? array.sort(function(a, b) {
	                  return sortKey(a.key, b.key);
	                }) : array;
	              }
	              return nest2 = {
	                object: function(array) {
	                  return apply(array, 0, createObject, setObject);
	                },
	                map: function(array) {
	                  return apply(array, 0, createMap, setMap);
	                },
	                entries: function(array) {
	                  return entries(apply(array, 0, createMap, setMap), 0);
	                },
	                key: function(d) {
	                  keys.push(d);
	                  return nest2;
	                },
	                sortKeys: function(order) {
	                  sortKeys[keys.length - 1] = order;
	                  return nest2;
	                },
	                sortValues: function(order) {
	                  sortValues = order;
	                  return nest2;
	                },
	                rollup: function(f) {
	                  rollup = f;
	                  return nest2;
	                }
	              };
	            }
	            function createObject() {
	              return {};
	            }
	            function setObject(object, key, value) {
	              object[key] = value;
	            }
	            function createMap() {
	              return src_map();
	            }
	            function setMap(map3, key, value) {
	              map3.set(key, value);
	            }
	            function Set2() {
	            }
	            var proto = src_map.prototype;
	            Set2.prototype = {
	              constructor: Set2,
	              has: proto.has,
	              add: function(value) {
	                value += "";
	                this[prefix + value] = value;
	                return this;
	              },
	              remove: proto.remove,
	              clear: proto.clear,
	              values: proto.keys,
	              size: proto.size,
	              empty: proto.empty,
	              each: proto.each
	            };
	          }
	        ),
	        /***/
	        49887: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              forceCenter: function() {
	                return (
	                  /* reexport */
	                  center
	                );
	              },
	              forceCollide: function() {
	                return (
	                  /* reexport */
	                  collide
	                );
	              },
	              forceLink: function() {
	                return (
	                  /* reexport */
	                  src_link
	                );
	              },
	              forceManyBody: function() {
	                return (
	                  /* reexport */
	                  manyBody
	                );
	              },
	              forceRadial: function() {
	                return (
	                  /* reexport */
	                  radial
	                );
	              },
	              forceSimulation: function() {
	                return (
	                  /* reexport */
	                  simulation
	                );
	              },
	              forceX: function() {
	                return (
	                  /* reexport */
	                  src_x
	                );
	              },
	              forceY: function() {
	                return (
	                  /* reexport */
	                  src_y
	                );
	              }
	            });
	            function center(x2, y2) {
	              var nodes;
	              if (x2 == null) x2 = 0;
	              if (y2 == null) y2 = 0;
	              function force() {
	                var i, n = nodes.length, node, sx = 0, sy = 0;
	                for (i = 0; i < n; ++i) {
	                  node = nodes[i], sx += node.x, sy += node.y;
	                }
	                for (sx = sx / n - x2, sy = sy / n - y2, i = 0; i < n; ++i) {
	                  node = nodes[i], node.x -= sx, node.y -= sy;
	                }
	              }
	              force.initialize = function(_) {
	                nodes = _;
	              };
	              force.x = function(_) {
	                return arguments.length ? (x2 = +_, force) : x2;
	              };
	              force.y = function(_) {
	                return arguments.length ? (y2 = +_, force) : y2;
	              };
	              return force;
	            }
	            function constant2(x2) {
	              return function() {
	                return x2;
	              };
	            }
	            function jiggle() {
	              return (Math.random() - 0.5) * 1e-6;
	            }
	            function add(d) {
	              var x2 = +this._x.call(null, d), y2 = +this._y.call(null, d);
	              return add_add(this.cover(x2, y2), x2, y2, d);
	            }
	            function add_add(tree, x2, y2, d) {
	              if (isNaN(x2) || isNaN(y2)) return tree;
	              var parent, node = tree._root, leaf = { data: d }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
	              if (!node) return tree._root = leaf, tree;
	              while (node.length) {
	                if (right = x2 >= (xm = (x0 + x1) / 2)) x0 = xm;
	                else x1 = xm;
	                if (bottom = y2 >= (ym = (y0 + y1) / 2)) y0 = ym;
	                else y1 = ym;
	                if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	              }
	              xp = +tree._x.call(null, node.data);
	              yp = +tree._y.call(null, node.data);
	              if (x2 === xp && y2 === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	              do {
	                parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	                if (right = x2 >= (xm = (x0 + x1) / 2)) x0 = xm;
	                else x1 = xm;
	                if (bottom = y2 >= (ym = (y0 + y1) / 2)) y0 = ym;
	                else y1 = ym;
	              } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
	              return parent[j] = node, parent[i] = leaf, tree;
	            }
	            function addAll(data2) {
	              var d, i, n = data2.length, x2, y2, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
	              for (i = 0; i < n; ++i) {
	                if (isNaN(x2 = +this._x.call(null, d = data2[i])) || isNaN(y2 = +this._y.call(null, d))) continue;
	                xz[i] = x2;
	                yz[i] = y2;
	                if (x2 < x0) x0 = x2;
	                if (x2 > x1) x1 = x2;
	                if (y2 < y0) y0 = y2;
	                if (y2 > y1) y1 = y2;
	              }
	              if (x0 > x1 || y0 > y1) return this;
	              this.cover(x0, y0).cover(x1, y1);
	              for (i = 0; i < n; ++i) {
	                add_add(this, xz[i], yz[i], data2[i]);
	              }
	              return this;
	            }
	            function cover(x2, y2) {
	              if (isNaN(x2 = +x2) || isNaN(y2 = +y2)) return this;
	              var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
	              if (isNaN(x0)) {
	                x1 = (x0 = Math.floor(x2)) + 1;
	                y1 = (y0 = Math.floor(y2)) + 1;
	              } else {
	                var z = x1 - x0, node = this._root, parent, i;
	                while (x0 > x2 || x2 >= x1 || y0 > y2 || y2 >= y1) {
	                  i = (y2 < y0) << 1 | x2 < x0;
	                  parent = new Array(4), parent[i] = node, node = parent, z *= 2;
	                  switch (i) {
	                    case 0:
	                      x1 = x0 + z, y1 = y0 + z;
	                      break;
	                    case 1:
	                      x0 = x1 - z, y1 = y0 + z;
	                      break;
	                    case 2:
	                      x1 = x0 + z, y0 = y1 - z;
	                      break;
	                    case 3:
	                      x0 = x1 - z, y0 = y1 - z;
	                      break;
	                  }
	                }
	                if (this._root && this._root.length) this._root = node;
	              }
	              this._x0 = x0;
	              this._y0 = y0;
	              this._x1 = x1;
	              this._y1 = y1;
	              return this;
	            }
	            function data() {
	              var data2 = [];
	              this.visit(function(node) {
	                if (!node.length) do
	                  data2.push(node.data);
	                while (node = node.next);
	              });
	              return data2;
	            }
	            function extent2(_) {
	              return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	            }
	            function quad(node, x0, y0, x1, y1) {
	              this.node = node;
	              this.x0 = x0;
	              this.y0 = y0;
	              this.x1 = x1;
	              this.y1 = y1;
	            }
	            function find(x2, y2, radius) {
	              var data2, x0 = this._x0, y0 = this._y0, x1, y1, x22, y22, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
	              if (node) quads.push(new quad(node, x0, y0, x3, y3));
	              if (radius == null) radius = Infinity;
	              else {
	                x0 = x2 - radius, y0 = y2 - radius;
	                x3 = x2 + radius, y3 = y2 + radius;
	                radius *= radius;
	              }
	              while (q = quads.pop()) {
	                if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x22 = q.x1) < x0 || (y22 = q.y1) < y0) continue;
	                if (node.length) {
	                  var xm = (x1 + x22) / 2, ym = (y1 + y22) / 2;
	                  quads.push(
	                    new quad(node[3], xm, ym, x22, y22),
	                    new quad(node[2], x1, ym, xm, y22),
	                    new quad(node[1], xm, y1, x22, ym),
	                    new quad(node[0], x1, y1, xm, ym)
	                  );
	                  if (i = (y2 >= ym) << 1 | x2 >= xm) {
	                    q = quads[quads.length - 1];
	                    quads[quads.length - 1] = quads[quads.length - 1 - i];
	                    quads[quads.length - 1 - i] = q;
	                  }
	                } else {
	                  var dx = x2 - +this._x.call(null, node.data), dy = y2 - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
	                  if (d2 < radius) {
	                    var d = Math.sqrt(radius = d2);
	                    x0 = x2 - d, y0 = y2 - d;
	                    x3 = x2 + d, y3 = y2 + d;
	                    data2 = node.data;
	                  }
	                }
	              }
	              return data2;
	            }
	            function remove(d) {
	              if (isNaN(x2 = +this._x.call(null, d)) || isNaN(y2 = +this._y.call(null, d))) return this;
	              var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x2, y2, xm, ym, right, bottom, i, j;
	              if (!node) return this;
	              if (node.length) while (true) {
	                if (right = x2 >= (xm = (x0 + x1) / 2)) x0 = xm;
	                else x1 = xm;
	                if (bottom = y2 >= (ym = (y0 + y1) / 2)) y0 = ym;
	                else y1 = ym;
	                if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	                if (!node.length) break;
	                if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
	              }
	              while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	              if (next = node.next) delete node.next;
	              if (previous) return next ? previous.next = next : delete previous.next, this;
	              if (!parent) return this._root = next, this;
	              next ? parent[i] = next : delete parent[i];
	              if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
	                if (retainer) retainer[j] = node;
	                else this._root = node;
	              }
	              return this;
	            }
	            function removeAll(data2) {
	              for (var i = 0, n = data2.length; i < n; ++i) this.remove(data2[i]);
	              return this;
	            }
	            function root() {
	              return this._root;
	            }
	            function size() {
	              var size2 = 0;
	              this.visit(function(node) {
	                if (!node.length) do
	                  ++size2;
	                while (node = node.next);
	              });
	              return size2;
	            }
	            function visit(callback) {
	              var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	              if (node) quads.push(new quad(node, this._x0, this._y0, this._x1, this._y1));
	              while (q = quads.pop()) {
	                if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	                  var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	                  if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
	                  if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
	                  if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
	                  if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
	                }
	              }
	              return this;
	            }
	            function visitAfter(callback) {
	              var quads = [], next = [], q;
	              if (this._root) quads.push(new quad(this._root, this._x0, this._y0, this._x1, this._y1));
	              while (q = quads.pop()) {
	                var node = q.node;
	                if (node.length) {
	                  var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	                  if (child = node[0]) quads.push(new quad(child, x0, y0, xm, ym));
	                  if (child = node[1]) quads.push(new quad(child, xm, y0, x1, ym));
	                  if (child = node[2]) quads.push(new quad(child, x0, ym, xm, y1));
	                  if (child = node[3]) quads.push(new quad(child, xm, ym, x1, y1));
	                }
	                next.push(q);
	              }
	              while (q = next.pop()) {
	                callback(q.node, q.x0, q.y0, q.x1, q.y1);
	              }
	              return this;
	            }
	            function defaultX(d) {
	              return d[0];
	            }
	            function x(_) {
	              return arguments.length ? (this._x = _, this) : this._x;
	            }
	            function defaultY(d) {
	              return d[1];
	            }
	            function y(_) {
	              return arguments.length ? (this._y = _, this) : this._y;
	            }
	            function quadtree(nodes, x2, y2) {
	              var tree = new Quadtree(x2 == null ? defaultX : x2, y2 == null ? defaultY : y2, NaN, NaN, NaN, NaN);
	              return nodes == null ? tree : tree.addAll(nodes);
	            }
	            function Quadtree(x2, y2, x0, y0, x1, y1) {
	              this._x = x2;
	              this._y = y2;
	              this._x0 = x0;
	              this._y0 = y0;
	              this._x1 = x1;
	              this._y1 = y1;
	              this._root = undefined;
	            }
	            function leaf_copy(leaf) {
	              var copy = { data: leaf.data }, next = copy;
	              while (leaf = leaf.next) next = next.next = { data: leaf.data };
	              return copy;
	            }
	            var treeProto = quadtree.prototype = Quadtree.prototype;
	            treeProto.copy = function() {
	              var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
	              if (!node) return copy;
	              if (!node.length) return copy._root = leaf_copy(node), copy;
	              nodes = [{ source: node, target: copy._root = new Array(4) }];
	              while (node = nodes.pop()) {
	                for (var i = 0; i < 4; ++i) {
	                  if (child = node.source[i]) {
	                    if (child.length) nodes.push({ source: child, target: node.target[i] = new Array(4) });
	                    else node.target[i] = leaf_copy(child);
	                  }
	                }
	              }
	              return copy;
	            };
	            treeProto.add = add;
	            treeProto.addAll = addAll;
	            treeProto.cover = cover;
	            treeProto.data = data;
	            treeProto.extent = extent2;
	            treeProto.find = find;
	            treeProto.remove = remove;
	            treeProto.removeAll = removeAll;
	            treeProto.root = root;
	            treeProto.size = size;
	            treeProto.visit = visit;
	            treeProto.visitAfter = visitAfter;
	            treeProto.x = x;
	            treeProto.y = y;
	            function collide_x(d) {
	              return d.x + d.vx;
	            }
	            function collide_y(d) {
	              return d.y + d.vy;
	            }
	            function collide(radius) {
	              var nodes, radii, strength = 1, iterations = 1;
	              if (typeof radius !== "function") radius = constant2(radius == null ? 1 : +radius);
	              function force() {
	                var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
	                for (var k = 0; k < iterations; ++k) {
	                  tree = quadtree(nodes, collide_x, collide_y).visitAfter(prepare);
	                  for (i = 0; i < n; ++i) {
	                    node = nodes[i];
	                    ri = radii[node.index], ri2 = ri * ri;
	                    xi = node.x + node.vx;
	                    yi = node.y + node.vy;
	                    tree.visit(apply);
	                  }
	                }
	                function apply(quad2, x0, y0, x1, y1) {
	                  var data2 = quad2.data, rj = quad2.r, r = ri + rj;
	                  if (data2) {
	                    if (data2.index > node.index) {
	                      var x2 = xi - data2.x - data2.vx, y2 = yi - data2.y - data2.vy, l = x2 * x2 + y2 * y2;
	                      if (l < r * r) {
	                        if (x2 === 0) x2 = jiggle(), l += x2 * x2;
	                        if (y2 === 0) y2 = jiggle(), l += y2 * y2;
	                        l = (r - (l = Math.sqrt(l))) / l * strength;
	                        node.vx += (x2 *= l) * (r = (rj *= rj) / (ri2 + rj));
	                        node.vy += (y2 *= l) * r;
	                        data2.vx -= x2 * (r = 1 - r);
	                        data2.vy -= y2 * r;
	                      }
	                    }
	                    return;
	                  }
	                  return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	                }
	              }
	              function prepare(quad2) {
	                if (quad2.data) return quad2.r = radii[quad2.data.index];
	                for (var i = quad2.r = 0; i < 4; ++i) {
	                  if (quad2[i] && quad2[i].r > quad2.r) {
	                    quad2.r = quad2[i].r;
	                  }
	                }
	              }
	              function initialize() {
	                if (!nodes) return;
	                var i, n = nodes.length, node;
	                radii = new Array(n);
	                for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
	              }
	              force.initialize = function(_) {
	                nodes = _;
	                initialize();
	              };
	              force.iterations = function(_) {
	                return arguments.length ? (iterations = +_, force) : iterations;
	              };
	              force.strength = function(_) {
	                return arguments.length ? (strength = +_, force) : strength;
	              };
	              force.radius = function(_) {
	                return arguments.length ? (radius = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : radius;
	              };
	              return force;
	            }
	            var src = __webpack_require__2(15140);
	            function index(d) {
	              return d.index;
	            }
	            function link_find(nodeById, nodeId) {
	              var node = nodeById.get(nodeId);
	              if (!node) throw new Error("missing: " + nodeId);
	              return node;
	            }
	            function src_link(links) {
	              var id = index, strength = defaultStrength, strengths, distance = constant2(30), distances, nodes, count, bias, iterations = 1;
	              if (links == null) links = [];
	              function defaultStrength(link) {
	                return 1 / Math.min(count[link.source.index], count[link.target.index]);
	              }
	              function force(alpha) {
	                for (var k = 0, n = links.length; k < iterations; ++k) {
	                  for (var i = 0, link, source, target, x2, y2, l, b; i < n; ++i) {
	                    link = links[i], source = link.source, target = link.target;
	                    x2 = target.x + target.vx - source.x - source.vx || jiggle();
	                    y2 = target.y + target.vy - source.y - source.vy || jiggle();
	                    l = Math.sqrt(x2 * x2 + y2 * y2);
	                    l = (l - distances[i]) / l * alpha * strengths[i];
	                    x2 *= l, y2 *= l;
	                    target.vx -= x2 * (b = bias[i]);
	                    target.vy -= y2 * b;
	                    source.vx += x2 * (b = 1 - b);
	                    source.vy += y2 * b;
	                  }
	                }
	              }
	              function initialize() {
	                if (!nodes) return;
	                var i, n = nodes.length, m = links.length, nodeById = (0, src.UI)(nodes, id), link;
	                for (i = 0, count = new Array(n); i < m; ++i) {
	                  link = links[i], link.index = i;
	                  if (typeof link.source !== "object") link.source = link_find(nodeById, link.source);
	                  if (typeof link.target !== "object") link.target = link_find(nodeById, link.target);
	                  count[link.source.index] = (count[link.source.index] || 0) + 1;
	                  count[link.target.index] = (count[link.target.index] || 0) + 1;
	                }
	                for (i = 0, bias = new Array(m); i < m; ++i) {
	                  link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	                }
	                strengths = new Array(m), initializeStrength();
	                distances = new Array(m), initializeDistance();
	              }
	              function initializeStrength() {
	                if (!nodes) return;
	                for (var i = 0, n = links.length; i < n; ++i) {
	                  strengths[i] = +strength(links[i], i, links);
	                }
	              }
	              function initializeDistance() {
	                if (!nodes) return;
	                for (var i = 0, n = links.length; i < n; ++i) {
	                  distances[i] = +distance(links[i], i, links);
	                }
	              }
	              force.initialize = function(_) {
	                nodes = _;
	                initialize();
	              };
	              force.links = function(_) {
	                return arguments.length ? (links = _, initialize(), force) : links;
	              };
	              force.id = function(_) {
	                return arguments.length ? (id = _, force) : id;
	              };
	              force.iterations = function(_) {
	                return arguments.length ? (iterations = +_, force) : iterations;
	              };
	              force.strength = function(_) {
	                return arguments.length ? (strength = typeof _ === "function" ? _ : constant2(+_), initializeStrength(), force) : strength;
	              };
	              force.distance = function(_) {
	                return arguments.length ? (distance = typeof _ === "function" ? _ : constant2(+_), initializeDistance(), force) : distance;
	              };
	              return force;
	            }
	            var noop = { value: function() {
	            } };
	            function dispatch() {
	              for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	                if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
	                _[t] = [];
	              }
	              return new Dispatch(_);
	            }
	            function Dispatch(_) {
	              this._ = _;
	            }
	            function parseTypenames(typenames, types) {
	              return typenames.trim().split(/^|\s+/).map(function(t) {
	                var name2 = "", i = t.indexOf(".");
	                if (i >= 0) name2 = t.slice(i + 1), t = t.slice(0, i);
	                if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	                return { type: t, name: name2 };
	              });
	            }
	            Dispatch.prototype = dispatch.prototype = {
	              constructor: Dispatch,
	              on: function(typename, callback) {
	                var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
	                if (arguments.length < 2) {
	                  while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	                  return;
	                }
	                if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	                while (++i < n) {
	                  if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	                  else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	                }
	                return this;
	              },
	              copy: function() {
	                var copy = {}, _ = this._;
	                for (var t in _) copy[t] = _[t].slice();
	                return new Dispatch(copy);
	              },
	              call: function(type, that) {
	                if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	                if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	                for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	              },
	              apply: function(type, that, args) {
	                if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	                for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	              }
	            };
	            function get(type, name2) {
	              for (var i = 0, n = type.length, c; i < n; ++i) {
	                if ((c = type[i]).name === name2) {
	                  return c.value;
	                }
	              }
	            }
	            function set(type, name2, callback) {
	              for (var i = 0, n = type.length; i < n; ++i) {
	                if (type[i].name === name2) {
	                  type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	                  break;
	                }
	              }
	              if (callback != null) type.push({ name: name2, value: callback });
	              return type;
	            }
	            var src_dispatch = dispatch;
	            var timer_frame = 0, timeout = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
	              setTimeout(f, 17);
	            };
	            function now() {
	              return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	            }
	            function clearNow() {
	              clockNow = 0;
	            }
	            function Timer() {
	              this._call = this._time = this._next = null;
	            }
	            Timer.prototype = timer.prototype = {
	              constructor: Timer,
	              restart: function(callback, delay, time) {
	                if (typeof callback !== "function") throw new TypeError("callback is not a function");
	                time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	                if (!this._next && taskTail !== this) {
	                  if (taskTail) taskTail._next = this;
	                  else taskHead = this;
	                  taskTail = this;
	                }
	                this._call = callback;
	                this._time = time;
	                sleep();
	              },
	              stop: function() {
	                if (this._call) {
	                  this._call = null;
	                  this._time = Infinity;
	                  sleep();
	                }
	              }
	            };
	            function timer(callback, delay, time) {
	              var t = new Timer();
	              t.restart(callback, delay, time);
	              return t;
	            }
	            function timerFlush() {
	              now();
	              ++timer_frame;
	              var t = taskHead, e;
	              while (t) {
	                if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	                t = t._next;
	              }
	              --timer_frame;
	            }
	            function wake() {
	              clockNow = (clockLast = clock.now()) + clockSkew;
	              timer_frame = timeout = 0;
	              try {
	                timerFlush();
	              } finally {
	                timer_frame = 0;
	                nap();
	                clockNow = 0;
	              }
	            }
	            function poke() {
	              var now2 = clock.now(), delay = now2 - clockLast;
	              if (delay > pokeDelay) clockSkew -= delay, clockLast = now2;
	            }
	            function nap() {
	              var t0, t1 = taskHead, t2, time = Infinity;
	              while (t1) {
	                if (t1._call) {
	                  if (time > t1._time) time = t1._time;
	                  t0 = t1, t1 = t1._next;
	                } else {
	                  t2 = t1._next, t1._next = null;
	                  t1 = t0 ? t0._next = t2 : taskHead = t2;
	                }
	              }
	              taskTail = t0;
	              sleep(time);
	            }
	            function sleep(time) {
	              if (timer_frame) return;
	              if (timeout) timeout = clearTimeout(timeout);
	              var delay = time - clockNow;
	              if (delay > 24) {
	                if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	                if (interval) interval = clearInterval(interval);
	              } else {
	                if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	                timer_frame = 1, setFrame(wake);
	              }
	            }
	            function simulation_x(d) {
	              return d.x;
	            }
	            function simulation_y(d) {
	              return d.y;
	            }
	            var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
	            function simulation(nodes) {
	              var simulation2, alpha = 1, alphaMin = 1e-3, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, src.UI)(), stepper = timer(step), event = src_dispatch("tick", "end");
	              if (nodes == null) nodes = [];
	              function step() {
	                tick();
	                event.call("tick", simulation2);
	                if (alpha < alphaMin) {
	                  stepper.stop();
	                  event.call("end", simulation2);
	                }
	              }
	              function tick(iterations) {
	                var i, n = nodes.length, node;
	                if (iterations === undefined) iterations = 1;
	                for (var k = 0; k < iterations; ++k) {
	                  alpha += (alphaTarget - alpha) * alphaDecay;
	                  forces.each(function(force) {
	                    force(alpha);
	                  });
	                  for (i = 0; i < n; ++i) {
	                    node = nodes[i];
	                    if (node.fx == null) node.x += node.vx *= velocityDecay;
	                    else node.x = node.fx, node.vx = 0;
	                    if (node.fy == null) node.y += node.vy *= velocityDecay;
	                    else node.y = node.fy, node.vy = 0;
	                  }
	                }
	                return simulation2;
	              }
	              function initializeNodes() {
	                for (var i = 0, n = nodes.length, node; i < n; ++i) {
	                  node = nodes[i], node.index = i;
	                  if (node.fx != null) node.x = node.fx;
	                  if (node.fy != null) node.y = node.fy;
	                  if (isNaN(node.x) || isNaN(node.y)) {
	                    var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	                    node.x = radius * Math.cos(angle);
	                    node.y = radius * Math.sin(angle);
	                  }
	                  if (isNaN(node.vx) || isNaN(node.vy)) {
	                    node.vx = node.vy = 0;
	                  }
	                }
	              }
	              function initializeForce(force) {
	                if (force.initialize) force.initialize(nodes);
	                return force;
	              }
	              initializeNodes();
	              return simulation2 = {
	                tick,
	                restart: function() {
	                  return stepper.restart(step), simulation2;
	                },
	                stop: function() {
	                  return stepper.stop(), simulation2;
	                },
	                nodes: function(_) {
	                  return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation2) : nodes;
	                },
	                alpha: function(_) {
	                  return arguments.length ? (alpha = +_, simulation2) : alpha;
	                },
	                alphaMin: function(_) {
	                  return arguments.length ? (alphaMin = +_, simulation2) : alphaMin;
	                },
	                alphaDecay: function(_) {
	                  return arguments.length ? (alphaDecay = +_, simulation2) : +alphaDecay;
	                },
	                alphaTarget: function(_) {
	                  return arguments.length ? (alphaTarget = +_, simulation2) : alphaTarget;
	                },
	                velocityDecay: function(_) {
	                  return arguments.length ? (velocityDecay = 1 - _, simulation2) : 1 - velocityDecay;
	                },
	                force: function(name2, _) {
	                  return arguments.length > 1 ? (_ == null ? forces.remove(name2) : forces.set(name2, initializeForce(_)), simulation2) : forces.get(name2);
	                },
	                find: function(x2, y2, radius) {
	                  var i = 0, n = nodes.length, dx, dy, d2, node, closest;
	                  if (radius == null) radius = Infinity;
	                  else radius *= radius;
	                  for (i = 0; i < n; ++i) {
	                    node = nodes[i];
	                    dx = x2 - node.x;
	                    dy = y2 - node.y;
	                    d2 = dx * dx + dy * dy;
	                    if (d2 < radius) closest = node, radius = d2;
	                  }
	                  return closest;
	                },
	                on: function(name2, _) {
	                  return arguments.length > 1 ? (event.on(name2, _), simulation2) : event.on(name2);
	                }
	              };
	            }
	            function manyBody() {
	              var nodes, node, alpha, strength = constant2(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
	              function force(_) {
	                var i, n = nodes.length, tree = quadtree(nodes, simulation_x, simulation_y).visitAfter(accumulate);
	                for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	              }
	              function initialize() {
	                if (!nodes) return;
	                var i, n = nodes.length, node2;
	                strengths = new Array(n);
	                for (i = 0; i < n; ++i) node2 = nodes[i], strengths[node2.index] = +strength(node2, i, nodes);
	              }
	              function accumulate(quad2) {
	                var strength2 = 0, q, c, weight = 0, x2, y2, i;
	                if (quad2.length) {
	                  for (x2 = y2 = i = 0; i < 4; ++i) {
	                    if ((q = quad2[i]) && (c = Math.abs(q.value))) {
	                      strength2 += q.value, weight += c, x2 += c * q.x, y2 += c * q.y;
	                    }
	                  }
	                  quad2.x = x2 / weight;
	                  quad2.y = y2 / weight;
	                } else {
	                  q = quad2;
	                  q.x = q.data.x;
	                  q.y = q.data.y;
	                  do
	                    strength2 += strengths[q.data.index];
	                  while (q = q.next);
	                }
	                quad2.value = strength2;
	              }
	              function apply(quad2, x1, _, x2) {
	                if (!quad2.value) return true;
	                var x3 = quad2.x - node.x, y2 = quad2.y - node.y, w = x2 - x1, l = x3 * x3 + y2 * y2;
	                if (w * w / theta2 < l) {
	                  if (l < distanceMax2) {
	                    if (x3 === 0) x3 = jiggle(), l += x3 * x3;
	                    if (y2 === 0) y2 = jiggle(), l += y2 * y2;
	                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	                    node.vx += x3 * quad2.value * alpha / l;
	                    node.vy += y2 * quad2.value * alpha / l;
	                  }
	                  return true;
	                } else if (quad2.length || l >= distanceMax2) return;
	                if (quad2.data !== node || quad2.next) {
	                  if (x3 === 0) x3 = jiggle(), l += x3 * x3;
	                  if (y2 === 0) y2 = jiggle(), l += y2 * y2;
	                  if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	                }
	                do
	                  if (quad2.data !== node) {
	                    w = strengths[quad2.data.index] * alpha / l;
	                    node.vx += x3 * w;
	                    node.vy += y2 * w;
	                  }
	                while (quad2 = quad2.next);
	              }
	              force.initialize = function(_) {
	                nodes = _;
	                initialize();
	              };
	              force.strength = function(_) {
	                return arguments.length ? (strength = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : strength;
	              };
	              force.distanceMin = function(_) {
	                return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	              };
	              force.distanceMax = function(_) {
	                return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	              };
	              force.theta = function(_) {
	                return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	              };
	              return force;
	            }
	            function radial(radius, x2, y2) {
	              var nodes, strength = constant2(0.1), strengths, radiuses;
	              if (typeof radius !== "function") radius = constant2(+radius);
	              if (x2 == null) x2 = 0;
	              if (y2 == null) y2 = 0;
	              function force(alpha) {
	                for (var i = 0, n = nodes.length; i < n; ++i) {
	                  var node = nodes[i], dx = node.x - x2 || 1e-6, dy = node.y - y2 || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
	                  node.vx += dx * k;
	                  node.vy += dy * k;
	                }
	              }
	              function initialize() {
	                if (!nodes) return;
	                var i, n = nodes.length;
	                strengths = new Array(n);
	                radiuses = new Array(n);
	                for (i = 0; i < n; ++i) {
	                  radiuses[i] = +radius(nodes[i], i, nodes);
	                  strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
	                }
	              }
	              force.initialize = function(_) {
	                nodes = _, initialize();
	              };
	              force.strength = function(_) {
	                return arguments.length ? (strength = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : strength;
	              };
	              force.radius = function(_) {
	                return arguments.length ? (radius = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : radius;
	              };
	              force.x = function(_) {
	                return arguments.length ? (x2 = +_, force) : x2;
	              };
	              force.y = function(_) {
	                return arguments.length ? (y2 = +_, force) : y2;
	              };
	              return force;
	            }
	            function src_x(x2) {
	              var strength = constant2(0.1), nodes, strengths, xz;
	              if (typeof x2 !== "function") x2 = constant2(x2 == null ? 0 : +x2);
	              function force(alpha) {
	                for (var i = 0, n = nodes.length, node; i < n; ++i) {
	                  node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	                }
	              }
	              function initialize() {
	                if (!nodes) return;
	                var i, n = nodes.length;
	                strengths = new Array(n);
	                xz = new Array(n);
	                for (i = 0; i < n; ++i) {
	                  strengths[i] = isNaN(xz[i] = +x2(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	                }
	              }
	              force.initialize = function(_) {
	                nodes = _;
	                initialize();
	              };
	              force.strength = function(_) {
	                return arguments.length ? (strength = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : strength;
	              };
	              force.x = function(_) {
	                return arguments.length ? (x2 = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : x2;
	              };
	              return force;
	            }
	            function src_y(y2) {
	              var strength = constant2(0.1), nodes, strengths, yz;
	              if (typeof y2 !== "function") y2 = constant2(y2 == null ? 0 : +y2);
	              function force(alpha) {
	                for (var i = 0, n = nodes.length, node; i < n; ++i) {
	                  node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	                }
	              }
	              function initialize() {
	                if (!nodes) return;
	                var i, n = nodes.length;
	                strengths = new Array(n);
	                yz = new Array(n);
	                for (i = 0; i < n; ++i) {
	                  strengths[i] = isNaN(yz[i] = +y2(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	                }
	              }
	              force.initialize = function(_) {
	                nodes = _;
	                initialize();
	              };
	              force.strength = function(_) {
	                return arguments.length ? (strength = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : strength;
	              };
	              force.y = function(_) {
	                return arguments.length ? (y2 = typeof _ === "function" ? _ : constant2(+_), initialize(), force) : y2;
	              };
	              return force;
	            }
	          }
	        ),
	        /***/
	        60721: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              WU: function() {
	                return (
	                  /* reexport */
	                  format
	                );
	              },
	              FF: function() {
	                return (
	                  /* reexport */
	                  locale
	                );
	              }
	            });
	            function formatDecimal(x) {
	              return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
	            }
	            function formatDecimalParts(x, p) {
	              if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
	              var i, coefficient = x.slice(0, i);
	              return [
	                coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	                +x.slice(i + 1)
	              ];
	            }
	            function exponent(x) {
	              return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
	            }
	            function formatGroup(grouping, thousands) {
	              return function(value, width) {
	                var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
	                while (i > 0 && g > 0) {
	                  if (length + g + 1 > width) g = Math.max(1, width - length);
	                  t.push(value.substring(i -= g, i + g));
	                  if ((length += g + 1) > width) break;
	                  g = grouping[j = (j + 1) % grouping.length];
	                }
	                return t.reverse().join(thousands);
	              };
	            }
	            function formatNumerals(numerals) {
	              return function(value) {
	                return value.replace(/[0-9]/g, function(i) {
	                  return numerals[+i];
	                });
	              };
	            }
	            var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	            function formatSpecifier(specifier) {
	              if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	              var match;
	              return new FormatSpecifier({
	                fill: match[1],
	                align: match[2],
	                sign: match[3],
	                symbol: match[4],
	                zero: match[5],
	                width: match[6],
	                comma: match[7],
	                precision: match[8] && match[8].slice(1),
	                trim: match[9],
	                type: match[10]
	              });
	            }
	            formatSpecifier.prototype = FormatSpecifier.prototype;
	            function FormatSpecifier(specifier) {
	              this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	              this.align = specifier.align === undefined ? ">" : specifier.align + "";
	              this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	              this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	              this.zero = !!specifier.zero;
	              this.width = specifier.width === undefined ? undefined : +specifier.width;
	              this.comma = !!specifier.comma;
	              this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	              this.trim = !!specifier.trim;
	              this.type = specifier.type === undefined ? "" : specifier.type + "";
	            }
	            FormatSpecifier.prototype.toString = function() {
	              return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
	            };
	            function formatTrim(s) {
	              out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	                switch (s[i]) {
	                  case ".":
	                    i0 = i1 = i;
	                    break;
	                  case "0":
	                    if (i0 === 0) i0 = i;
	                    i1 = i;
	                    break;
	                  default:
	                    if (!+s[i]) break out;
	                    if (i0 > 0) i0 = 0;
	                    break;
	                }
	              }
	              return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	            }
	            var prefixExponent;
	            function formatPrefixAuto(x, p) {
	              var d = formatDecimalParts(x, p);
	              if (!d) return x + "";
	              var coefficient = d[0], exponent2 = d[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
	              return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
	            }
	            function formatRounded(x, p) {
	              var d = formatDecimalParts(x, p);
	              if (!d) return x + "";
	              var coefficient = d[0], exponent2 = d[1];
	              return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
	            }
	            var formatTypes = {
	              "%": function(x, p) {
	                return (x * 100).toFixed(p);
	              },
	              "b": function(x) {
	                return Math.round(x).toString(2);
	              },
	              "c": function(x) {
	                return x + "";
	              },
	              "d": formatDecimal,
	              "e": function(x, p) {
	                return x.toExponential(p);
	              },
	              "f": function(x, p) {
	                return x.toFixed(p);
	              },
	              "g": function(x, p) {
	                return x.toPrecision(p);
	              },
	              "o": function(x) {
	                return Math.round(x).toString(8);
	              },
	              "p": function(x, p) {
	                return formatRounded(x * 100, p);
	              },
	              "r": formatRounded,
	              "s": formatPrefixAuto,
	              "X": function(x) {
	                return Math.round(x).toString(16).toUpperCase();
	              },
	              "x": function(x) {
	                return Math.round(x).toString(16);
	              }
	            };
	            function identity2(x) {
	              return x;
	            }
	            var map2 = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
	            function locale(locale2) {
	              var group = locale2.grouping === undefined || locale2.thousands === undefined ? identity2 : formatGroup(map2.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === undefined ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === undefined ? "" : locale2.currency[1] + "", decimal = locale2.decimal === undefined ? "." : locale2.decimal + "", numerals = locale2.numerals === undefined ? identity2 : formatNumerals(map2.call(locale2.numerals, String)), percent = locale2.percent === undefined ? "%" : locale2.percent + "", minus = locale2.minus === undefined ? "-" : locale2.minus + "", nan = locale2.nan === undefined ? "NaN" : locale2.nan + "";
	              function newFormat(specifier) {
	                specifier = formatSpecifier(specifier);
	                var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
	                if (type === "n") comma = true, type = "g";
	                else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	                if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
	                var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	                var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
	                precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
	                function format2(value) {
	                  var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
	                  if (type === "c") {
	                    valueSuffix = formatType(value) + valueSuffix;
	                    value = "";
	                  } else {
	                    value = +value;
	                    var valueNegative = value < 0 || 1 / value < 0;
	                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	                    if (trim) value = formatTrim(value);
	                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
	                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	                    valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	                    if (maybeSuffix) {
	                      i = -1, n = value.length;
	                      while (++i < n) {
	                        if (c = value.charCodeAt(i), 48 > c || c > 57) {
	                          valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	                          value = value.slice(0, i);
	                          break;
	                        }
	                      }
	                    }
	                  }
	                  if (comma && !zero) value = group(value, Infinity);
	                  var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
	                  if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	                  switch (align) {
	                    case "<":
	                      value = valuePrefix + value + valueSuffix + padding;
	                      break;
	                    case "=":
	                      value = valuePrefix + padding + value + valueSuffix;
	                      break;
	                    case "^":
	                      value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	                      break;
	                    default:
	                      value = padding + valuePrefix + value + valueSuffix;
	                      break;
	                  }
	                  return numerals(value);
	                }
	                format2.toString = function() {
	                  return specifier + "";
	                };
	                return format2;
	              }
	              function formatPrefix2(specifier, value) {
	                var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
	                return function(value2) {
	                  return f(k * value2) + prefix;
	                };
	              }
	              return {
	                format: newFormat,
	                formatPrefix: formatPrefix2
	              };
	            }
	            var defaultLocale_locale;
	            var format;
	            defaultLocale({
	              decimal: ".",
	              thousands: ",",
	              grouping: [3],
	              currency: ["$", ""],
	              minus: "-"
	            });
	            function defaultLocale(definition) {
	              defaultLocale_locale = locale(definition);
	              format = defaultLocale_locale.format;
	              defaultLocale_locale.formatPrefix;
	              return defaultLocale_locale;
	            }
	          }
	        ),
	        /***/
	        65704: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              geoAiry: function() {
	                return (
	                  /* reexport */
	                  airy
	                );
	              },
	              geoAiryRaw: function() {
	                return (
	                  /* reexport */
	                  airyRaw
	                );
	              },
	              geoAitoff: function() {
	                return (
	                  /* reexport */
	                  aitoff
	                );
	              },
	              geoAitoffRaw: function() {
	                return (
	                  /* reexport */
	                  aitoffRaw
	                );
	              },
	              geoArmadillo: function() {
	                return (
	                  /* reexport */
	                  armadillo
	                );
	              },
	              geoArmadilloRaw: function() {
	                return (
	                  /* reexport */
	                  armadilloRaw
	                );
	              },
	              geoAugust: function() {
	                return (
	                  /* reexport */
	                  august
	                );
	              },
	              geoAugustRaw: function() {
	                return (
	                  /* reexport */
	                  augustRaw
	                );
	              },
	              geoBaker: function() {
	                return (
	                  /* reexport */
	                  baker
	                );
	              },
	              geoBakerRaw: function() {
	                return (
	                  /* reexport */
	                  bakerRaw
	                );
	              },
	              geoBerghaus: function() {
	                return (
	                  /* reexport */
	                  berghaus
	                );
	              },
	              geoBerghausRaw: function() {
	                return (
	                  /* reexport */
	                  berghausRaw
	                );
	              },
	              geoBertin1953: function() {
	                return (
	                  /* reexport */
	                  bertin
	                );
	              },
	              geoBertin1953Raw: function() {
	                return (
	                  /* reexport */
	                  bertin1953Raw
	                );
	              },
	              geoBoggs: function() {
	                return (
	                  /* reexport */
	                  boggs
	                );
	              },
	              geoBoggsRaw: function() {
	                return (
	                  /* reexport */
	                  boggsRaw
	                );
	              },
	              geoBonne: function() {
	                return (
	                  /* reexport */
	                  bonne
	                );
	              },
	              geoBonneRaw: function() {
	                return (
	                  /* reexport */
	                  bonneRaw
	                );
	              },
	              geoBottomley: function() {
	                return (
	                  /* reexport */
	                  bottomley
	                );
	              },
	              geoBottomleyRaw: function() {
	                return (
	                  /* reexport */
	                  bottomleyRaw
	                );
	              },
	              geoBromley: function() {
	                return (
	                  /* reexport */
	                  bromley
	                );
	              },
	              geoBromleyRaw: function() {
	                return (
	                  /* reexport */
	                  bromleyRaw
	                );
	              },
	              geoChamberlin: function() {
	                return (
	                  /* reexport */
	                  chamberlin
	                );
	              },
	              geoChamberlinAfrica: function() {
	                return (
	                  /* reexport */
	                  chamberlinAfrica
	                );
	              },
	              geoChamberlinRaw: function() {
	                return (
	                  /* reexport */
	                  chamberlinRaw
	                );
	              },
	              geoCollignon: function() {
	                return (
	                  /* reexport */
	                  collignon
	                );
	              },
	              geoCollignonRaw: function() {
	                return (
	                  /* reexport */
	                  collignonRaw
	                );
	              },
	              geoCraig: function() {
	                return (
	                  /* reexport */
	                  craig
	                );
	              },
	              geoCraigRaw: function() {
	                return (
	                  /* reexport */
	                  craigRaw
	                );
	              },
	              geoCraster: function() {
	                return (
	                  /* reexport */
	                  craster
	                );
	              },
	              geoCrasterRaw: function() {
	                return (
	                  /* reexport */
	                  crasterRaw
	                );
	              },
	              geoCylindricalEqualArea: function() {
	                return (
	                  /* reexport */
	                  cylindricalEqualArea
	                );
	              },
	              geoCylindricalEqualAreaRaw: function() {
	                return (
	                  /* reexport */
	                  cylindricalEqualAreaRaw
	                );
	              },
	              geoCylindricalStereographic: function() {
	                return (
	                  /* reexport */
	                  cylindricalStereographic
	                );
	              },
	              geoCylindricalStereographicRaw: function() {
	                return (
	                  /* reexport */
	                  cylindricalStereographicRaw
	                );
	              },
	              geoEckert1: function() {
	                return (
	                  /* reexport */
	                  eckert1
	                );
	              },
	              geoEckert1Raw: function() {
	                return (
	                  /* reexport */
	                  eckert1Raw
	                );
	              },
	              geoEckert2: function() {
	                return (
	                  /* reexport */
	                  eckert2
	                );
	              },
	              geoEckert2Raw: function() {
	                return (
	                  /* reexport */
	                  eckert2Raw
	                );
	              },
	              geoEckert3: function() {
	                return (
	                  /* reexport */
	                  eckert3
	                );
	              },
	              geoEckert3Raw: function() {
	                return (
	                  /* reexport */
	                  eckert3Raw
	                );
	              },
	              geoEckert4: function() {
	                return (
	                  /* reexport */
	                  eckert4
	                );
	              },
	              geoEckert4Raw: function() {
	                return (
	                  /* reexport */
	                  eckert4Raw
	                );
	              },
	              geoEckert5: function() {
	                return (
	                  /* reexport */
	                  eckert5
	                );
	              },
	              geoEckert5Raw: function() {
	                return (
	                  /* reexport */
	                  eckert5Raw
	                );
	              },
	              geoEckert6: function() {
	                return (
	                  /* reexport */
	                  eckert6
	                );
	              },
	              geoEckert6Raw: function() {
	                return (
	                  /* reexport */
	                  eckert6Raw
	                );
	              },
	              geoEisenlohr: function() {
	                return (
	                  /* reexport */
	                  eisenlohr
	                );
	              },
	              geoEisenlohrRaw: function() {
	                return (
	                  /* reexport */
	                  eisenlohrRaw
	                );
	              },
	              geoFahey: function() {
	                return (
	                  /* reexport */
	                  fahey
	                );
	              },
	              geoFaheyRaw: function() {
	                return (
	                  /* reexport */
	                  faheyRaw
	                );
	              },
	              geoFoucaut: function() {
	                return (
	                  /* reexport */
	                  foucaut
	                );
	              },
	              geoFoucautRaw: function() {
	                return (
	                  /* reexport */
	                  foucautRaw
	                );
	              },
	              geoFoucautSinusoidal: function() {
	                return (
	                  /* reexport */
	                  foucautSinusoidal
	                );
	              },
	              geoFoucautSinusoidalRaw: function() {
	                return (
	                  /* reexport */
	                  foucautSinusoidalRaw
	                );
	              },
	              geoGilbert: function() {
	                return (
	                  /* reexport */
	                  gilbert
	                );
	              },
	              geoGingery: function() {
	                return (
	                  /* reexport */
	                  gingery
	                );
	              },
	              geoGingeryRaw: function() {
	                return (
	                  /* reexport */
	                  gingeryRaw
	                );
	              },
	              geoGinzburg4: function() {
	                return (
	                  /* reexport */
	                  ginzburg4
	                );
	              },
	              geoGinzburg4Raw: function() {
	                return (
	                  /* reexport */
	                  ginzburg4Raw
	                );
	              },
	              geoGinzburg5: function() {
	                return (
	                  /* reexport */
	                  ginzburg5
	                );
	              },
	              geoGinzburg5Raw: function() {
	                return (
	                  /* reexport */
	                  ginzburg5Raw
	                );
	              },
	              geoGinzburg6: function() {
	                return (
	                  /* reexport */
	                  ginzburg6
	                );
	              },
	              geoGinzburg6Raw: function() {
	                return (
	                  /* reexport */
	                  ginzburg6Raw
	                );
	              },
	              geoGinzburg8: function() {
	                return (
	                  /* reexport */
	                  ginzburg8
	                );
	              },
	              geoGinzburg8Raw: function() {
	                return (
	                  /* reexport */
	                  ginzburg8Raw
	                );
	              },
	              geoGinzburg9: function() {
	                return (
	                  /* reexport */
	                  ginzburg9
	                );
	              },
	              geoGinzburg9Raw: function() {
	                return (
	                  /* reexport */
	                  ginzburg9Raw
	                );
	              },
	              geoGringorten: function() {
	                return (
	                  /* reexport */
	                  gringorten
	                );
	              },
	              geoGringortenQuincuncial: function() {
	                return (
	                  /* reexport */
	                  quincuncial_gringorten
	                );
	              },
	              geoGringortenRaw: function() {
	                return (
	                  /* reexport */
	                  gringortenRaw
	                );
	              },
	              geoGuyou: function() {
	                return (
	                  /* reexport */
	                  guyou
	                );
	              },
	              geoGuyouRaw: function() {
	                return (
	                  /* reexport */
	                  guyouRaw
	                );
	              },
	              geoHammer: function() {
	                return (
	                  /* reexport */
	                  hammer
	                );
	              },
	              geoHammerRaw: function() {
	                return (
	                  /* reexport */
	                  hammerRaw
	                );
	              },
	              geoHammerRetroazimuthal: function() {
	                return (
	                  /* reexport */
	                  hammerRetroazimuthal
	                );
	              },
	              geoHammerRetroazimuthalRaw: function() {
	                return (
	                  /* reexport */
	                  hammerRetroazimuthalRaw
	                );
	              },
	              geoHealpix: function() {
	                return (
	                  /* reexport */
	                  healpix
	                );
	              },
	              geoHealpixRaw: function() {
	                return (
	                  /* reexport */
	                  healpixRaw
	                );
	              },
	              geoHill: function() {
	                return (
	                  /* reexport */
	                  hill
	                );
	              },
	              geoHillRaw: function() {
	                return (
	                  /* reexport */
	                  hillRaw
	                );
	              },
	              geoHomolosine: function() {
	                return (
	                  /* reexport */
	                  homolosine
	                );
	              },
	              geoHomolosineRaw: function() {
	                return (
	                  /* reexport */
	                  homolosineRaw
	                );
	              },
	              geoHufnagel: function() {
	                return (
	                  /* reexport */
	                  hufnagel
	                );
	              },
	              geoHufnagelRaw: function() {
	                return (
	                  /* reexport */
	                  hufnagelRaw
	                );
	              },
	              geoHyperelliptical: function() {
	                return (
	                  /* reexport */
	                  hyperelliptical
	                );
	              },
	              geoHyperellipticalRaw: function() {
	                return (
	                  /* reexport */
	                  hyperellipticalRaw
	                );
	              },
	              geoInterrupt: function() {
	                return (
	                  /* reexport */
	                  interrupted
	                );
	              },
	              geoInterruptedBoggs: function() {
	                return (
	                  /* reexport */
	                  interrupted_boggs
	                );
	              },
	              geoInterruptedHomolosine: function() {
	                return (
	                  /* reexport */
	                  interrupted_homolosine
	                );
	              },
	              geoInterruptedMollweide: function() {
	                return (
	                  /* reexport */
	                  interrupted_mollweide
	                );
	              },
	              geoInterruptedMollweideHemispheres: function() {
	                return (
	                  /* reexport */
	                  mollweideHemispheres
	                );
	              },
	              geoInterruptedQuarticAuthalic: function() {
	                return (
	                  /* reexport */
	                  quarticAuthalic
	                );
	              },
	              geoInterruptedSinuMollweide: function() {
	                return (
	                  /* reexport */
	                  interrupted_sinuMollweide
	                );
	              },
	              geoInterruptedSinusoidal: function() {
	                return (
	                  /* reexport */
	                  interrupted_sinusoidal
	                );
	              },
	              geoKavrayskiy7: function() {
	                return (
	                  /* reexport */
	                  kavrayskiy7
	                );
	              },
	              geoKavrayskiy7Raw: function() {
	                return (
	                  /* reexport */
	                  kavrayskiy7Raw
	                );
	              },
	              geoLagrange: function() {
	                return (
	                  /* reexport */
	                  lagrange
	                );
	              },
	              geoLagrangeRaw: function() {
	                return (
	                  /* reexport */
	                  lagrangeRaw
	                );
	              },
	              geoLarrivee: function() {
	                return (
	                  /* reexport */
	                  larrivee
	                );
	              },
	              geoLarriveeRaw: function() {
	                return (
	                  /* reexport */
	                  larriveeRaw
	                );
	              },
	              geoLaskowski: function() {
	                return (
	                  /* reexport */
	                  laskowski
	                );
	              },
	              geoLaskowskiRaw: function() {
	                return (
	                  /* reexport */
	                  laskowskiRaw
	                );
	              },
	              geoLittrow: function() {
	                return (
	                  /* reexport */
	                  littrow
	                );
	              },
	              geoLittrowRaw: function() {
	                return (
	                  /* reexport */
	                  littrowRaw
	                );
	              },
	              geoLoximuthal: function() {
	                return (
	                  /* reexport */
	                  loximuthal
	                );
	              },
	              geoLoximuthalRaw: function() {
	                return (
	                  /* reexport */
	                  loximuthalRaw
	                );
	              },
	              geoMiller: function() {
	                return (
	                  /* reexport */
	                  miller
	                );
	              },
	              geoMillerRaw: function() {
	                return (
	                  /* reexport */
	                  millerRaw
	                );
	              },
	              geoModifiedStereographic: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographic
	                );
	              },
	              geoModifiedStereographicAlaska: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographicAlaska
	                );
	              },
	              geoModifiedStereographicGs48: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographicGs48
	                );
	              },
	              geoModifiedStereographicGs50: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographicGs50
	                );
	              },
	              geoModifiedStereographicLee: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographicLee
	                );
	              },
	              geoModifiedStereographicMiller: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographicMiller
	                );
	              },
	              geoModifiedStereographicRaw: function() {
	                return (
	                  /* reexport */
	                  modifiedStereographicRaw
	                );
	              },
	              geoMollweide: function() {
	                return (
	                  /* reexport */
	                  mollweide
	                );
	              },
	              geoMollweideRaw: function() {
	                return (
	                  /* reexport */
	                  mollweideRaw
	                );
	              },
	              geoMtFlatPolarParabolic: function() {
	                return (
	                  /* reexport */
	                  mtFlatPolarParabolic
	                );
	              },
	              geoMtFlatPolarParabolicRaw: function() {
	                return (
	                  /* reexport */
	                  mtFlatPolarParabolicRaw
	                );
	              },
	              geoMtFlatPolarQuartic: function() {
	                return (
	                  /* reexport */
	                  mtFlatPolarQuartic
	                );
	              },
	              geoMtFlatPolarQuarticRaw: function() {
	                return (
	                  /* reexport */
	                  mtFlatPolarQuarticRaw
	                );
	              },
	              geoMtFlatPolarSinusoidal: function() {
	                return (
	                  /* reexport */
	                  mtFlatPolarSinusoidal
	                );
	              },
	              geoMtFlatPolarSinusoidalRaw: function() {
	                return (
	                  /* reexport */
	                  mtFlatPolarSinusoidalRaw
	                );
	              },
	              geoNaturalEarth: function() {
	                return (
	                  /* reexport */
	                  naturalEarth1.Z
	                );
	              },
	              geoNaturalEarth2: function() {
	                return (
	                  /* reexport */
	                  naturalEarth2
	                );
	              },
	              geoNaturalEarth2Raw: function() {
	                return (
	                  /* reexport */
	                  naturalEarth2Raw
	                );
	              },
	              geoNaturalEarthRaw: function() {
	                return (
	                  /* reexport */
	                  naturalEarth1.K
	                );
	              },
	              geoNellHammer: function() {
	                return (
	                  /* reexport */
	                  nellHammer
	                );
	              },
	              geoNellHammerRaw: function() {
	                return (
	                  /* reexport */
	                  nellHammerRaw
	                );
	              },
	              geoNicolosi: function() {
	                return (
	                  /* reexport */
	                  nicolosi
	                );
	              },
	              geoNicolosiRaw: function() {
	                return (
	                  /* reexport */
	                  nicolosiRaw
	                );
	              },
	              geoPatterson: function() {
	                return (
	                  /* reexport */
	                  patterson
	                );
	              },
	              geoPattersonRaw: function() {
	                return (
	                  /* reexport */
	                  pattersonRaw
	                );
	              },
	              geoPeirceQuincuncial: function() {
	                return (
	                  /* reexport */
	                  peirce
	                );
	              },
	              geoPierceQuincuncial: function() {
	                return (
	                  /* reexport */
	                  peirce
	                );
	              },
	              geoPolyconic: function() {
	                return (
	                  /* reexport */
	                  polyconic
	                );
	              },
	              geoPolyconicRaw: function() {
	                return (
	                  /* reexport */
	                  polyconicRaw
	                );
	              },
	              geoPolyhedral: function() {
	                return (
	                  /* reexport */
	                  polyhedral
	                );
	              },
	              geoPolyhedralButterfly: function() {
	                return (
	                  /* reexport */
	                  butterfly
	                );
	              },
	              geoPolyhedralCollignon: function() {
	                return (
	                  /* reexport */
	                  polyhedral_collignon
	                );
	              },
	              geoPolyhedralWaterman: function() {
	                return (
	                  /* reexport */
	                  waterman
	                );
	              },
	              geoProject: function() {
	                return (
	                  /* reexport */
	                  project
	                );
	              },
	              geoQuantize: function() {
	                return (
	                  /* reexport */
	                  quantize
	                );
	              },
	              geoQuincuncial: function() {
	                return (
	                  /* reexport */
	                  quincuncial
	                );
	              },
	              geoRectangularPolyconic: function() {
	                return (
	                  /* reexport */
	                  rectangularPolyconic
	                );
	              },
	              geoRectangularPolyconicRaw: function() {
	                return (
	                  /* reexport */
	                  rectangularPolyconicRaw
	                );
	              },
	              geoRobinson: function() {
	                return (
	                  /* reexport */
	                  robinson
	                );
	              },
	              geoRobinsonRaw: function() {
	                return (
	                  /* reexport */
	                  robinsonRaw
	                );
	              },
	              geoSatellite: function() {
	                return (
	                  /* reexport */
	                  satellite
	                );
	              },
	              geoSatelliteRaw: function() {
	                return (
	                  /* reexport */
	                  satelliteRaw
	                );
	              },
	              geoSinuMollweide: function() {
	                return (
	                  /* reexport */
	                  sinuMollweide
	                );
	              },
	              geoSinuMollweideRaw: function() {
	                return (
	                  /* reexport */
	                  sinuMollweideRaw
	                );
	              },
	              geoSinusoidal: function() {
	                return (
	                  /* reexport */
	                  sinusoidal
	                );
	              },
	              geoSinusoidalRaw: function() {
	                return (
	                  /* reexport */
	                  sinusoidalRaw
	                );
	              },
	              geoStitch: function() {
	                return (
	                  /* reexport */
	                  stitch
	                );
	              },
	              geoTimes: function() {
	                return (
	                  /* reexport */
	                  times
	                );
	              },
	              geoTimesRaw: function() {
	                return (
	                  /* reexport */
	                  timesRaw
	                );
	              },
	              geoTwoPointAzimuthal: function() {
	                return (
	                  /* reexport */
	                  twoPointAzimuthal
	                );
	              },
	              geoTwoPointAzimuthalRaw: function() {
	                return (
	                  /* reexport */
	                  twoPointAzimuthalRaw
	                );
	              },
	              geoTwoPointAzimuthalUsa: function() {
	                return (
	                  /* reexport */
	                  twoPointAzimuthalUsa
	                );
	              },
	              geoTwoPointEquidistant: function() {
	                return (
	                  /* reexport */
	                  twoPointEquidistant
	                );
	              },
	              geoTwoPointEquidistantRaw: function() {
	                return (
	                  /* reexport */
	                  twoPointEquidistantRaw
	                );
	              },
	              geoTwoPointEquidistantUsa: function() {
	                return (
	                  /* reexport */
	                  twoPointEquidistantUsa
	                );
	              },
	              geoVanDerGrinten: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten
	                );
	              },
	              geoVanDerGrinten2: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten2
	                );
	              },
	              geoVanDerGrinten2Raw: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten2Raw
	                );
	              },
	              geoVanDerGrinten3: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten3
	                );
	              },
	              geoVanDerGrinten3Raw: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten3Raw
	                );
	              },
	              geoVanDerGrinten4: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten4
	                );
	              },
	              geoVanDerGrinten4Raw: function() {
	                return (
	                  /* reexport */
	                  vanDerGrinten4Raw
	                );
	              },
	              geoVanDerGrintenRaw: function() {
	                return (
	                  /* reexport */
	                  vanDerGrintenRaw
	                );
	              },
	              geoWagner: function() {
	                return (
	                  /* reexport */
	                  wagner
	                );
	              },
	              geoWagner4: function() {
	                return (
	                  /* reexport */
	                  wagner4
	                );
	              },
	              geoWagner4Raw: function() {
	                return (
	                  /* reexport */
	                  wagner4Raw
	                );
	              },
	              geoWagner6: function() {
	                return (
	                  /* reexport */
	                  wagner6
	                );
	              },
	              geoWagner6Raw: function() {
	                return (
	                  /* reexport */
	                  wagner6Raw
	                );
	              },
	              geoWagner7: function() {
	                return (
	                  /* reexport */
	                  wagner7
	                );
	              },
	              geoWagnerRaw: function() {
	                return (
	                  /* reexport */
	                  wagnerRaw
	                );
	              },
	              geoWiechel: function() {
	                return (
	                  /* reexport */
	                  wiechel
	                );
	              },
	              geoWiechelRaw: function() {
	                return (
	                  /* reexport */
	                  wiechelRaw
	                );
	              },
	              geoWinkel3: function() {
	                return (
	                  /* reexport */
	                  winkel3
	                );
	              },
	              geoWinkel3Raw: function() {
	                return (
	                  /* reexport */
	                  winkel3Raw
	                );
	              }
	            });
	            var src_projection = __webpack_require__2(15002);
	            var abs = Math.abs;
	            var atan = Math.atan;
	            var atan2 = Math.atan2;
	            var cos = Math.cos;
	            var exp = Math.exp;
	            var floor = Math.floor;
	            var log = Math.log;
	            var max = Math.max;
	            var min = Math.min;
	            var pow = Math.pow;
	            var round = Math.round;
	            var sign = Math.sign || function(x) {
	              return x > 0 ? 1 : x < 0 ? -1 : 0;
	            };
	            var sin = Math.sin;
	            var tan = Math.tan;
	            var epsilon = 1e-6;
	            var epsilon2 = 1e-12;
	            var pi = Math.PI;
	            var halfPi = pi / 2;
	            var quarterPi = pi / 4;
	            var sqrt1_2 = Math.SQRT1_2;
	            var sqrt2 = sqrt(2);
	            var sqrtPi = sqrt(pi);
	            var tau = pi * 2;
	            var degrees = 180 / pi;
	            var radians = pi / 180;
	            function sinci(x) {
	              return x ? x / Math.sin(x) : 1;
	            }
	            function asin(x) {
	              return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	            }
	            function acos(x) {
	              return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	            }
	            function sqrt(x) {
	              return x > 0 ? Math.sqrt(x) : 0;
	            }
	            function tanh(x) {
	              x = exp(2 * x);
	              return (x - 1) / (x + 1);
	            }
	            function sinh(x) {
	              return (exp(x) - exp(-x)) / 2;
	            }
	            function cosh(x) {
	              return (exp(x) + exp(-x)) / 2;
	            }
	            function arsinh(x) {
	              return log(x + sqrt(x * x + 1));
	            }
	            function arcosh(x) {
	              return log(x + sqrt(x * x - 1));
	            }
	            function airyRaw(beta) {
	              var tanBeta_2 = tan(beta / 2), b = 2 * log(cos(beta / 2)) / (tanBeta_2 * tanBeta_2);
	              function forward(x, y) {
	                var cosx = cos(x), cosy = cos(y), siny = sin(y), cosz = cosy * cosx, k2 = -((1 - cosz ? log((1 + cosz) / 2) / (1 - cosz) : -0.5) + b / (1 + cosz));
	                return [k2 * cosy * sin(x), k2 * siny];
	              }
	              forward.invert = function(x, y) {
	                var r = sqrt(x * x + y * y), z = -beta / 2, i = 50, delta;
	                if (!r) return [0, 0];
	                do {
	                  var z_2 = z / 2, cosz_2 = cos(z_2), sinz_2 = sin(z_2), tanz_2 = sinz_2 / cosz_2, lnsecz_2 = -log(abs(cosz_2));
	                  z -= delta = (2 / tanz_2 * lnsecz_2 - b * tanz_2 - r) / (-lnsecz_2 / (sinz_2 * sinz_2) + 1 - b / (2 * cosz_2 * cosz_2)) * (cosz_2 < 0 ? 0.7 : 1);
	                } while (abs(delta) > epsilon && --i > 0);
	                var sinz = sin(z);
	                return [atan2(x * sinz, r * cos(z)), asin(y * sinz / r)];
	              };
	              return forward;
	            }
	            function airy() {
	              var beta = halfPi, m = (0, src_projection.r)(airyRaw), p = m(beta);
	              p.radius = function(_) {
	                return arguments.length ? m(beta = _ * radians) : beta * degrees;
	              };
	              return p.scale(179.976).clipAngle(147);
	            }
	            function aitoffRaw(x, y) {
	              var cosy = cos(y), sincia = sinci(acos(cosy * cos(x /= 2)));
	              return [2 * cosy * sin(x) * sincia, sin(y) * sincia];
	            }
	            aitoffRaw.invert = function(x, y) {
	              if (x * x + 4 * y * y > pi * pi + epsilon) return;
	              var x12 = x, y12 = y, i = 25;
	              do {
	                var sinx = sin(x12), sinx_2 = sin(x12 / 2), cosx_2 = cos(x12 / 2), siny = sin(y12), cosy = cos(y12), sin_2y = sin(2 * y12), sin2y = siny * siny, cos2y = cosy * cosy, sin2x_2 = sinx_2 * sinx_2, c = 1 - cos2y * cosx_2 * cosx_2, e = c ? acos(cosy * cosx_2) * sqrt(f = 1 / c) : f = 0, f, fx = 2 * e * cosy * sinx_2 - x, fy = e * siny - y, dxdx = f * (cos2y * sin2x_2 + e * cosy * cosx_2 * sin2y), dxdy = f * (0.5 * sinx * sin_2y - e * 2 * siny * sinx_2), dydx = f * 0.25 * (sin_2y * sinx_2 - e * siny * cos2y * sinx), dydy = f * (sin2y * cosx_2 + e * sin2x_2 * cosy), z = dxdy * dydx - dydy * dxdx;
	                if (!z) break;
	                var dx = (fy * dxdy - fx * dydy) / z, dy = (fx * dydx - fy * dxdx) / z;
	                x12 -= dx, y12 -= dy;
	              } while ((abs(dx) > epsilon || abs(dy) > epsilon) && --i > 0);
	              return [x12, y12];
	            };
	            function aitoff() {
	              return (0, src_projection.Z)(aitoffRaw).scale(152.63);
	            }
	            function armadilloRaw(phi02) {
	              var sinPhi0 = sin(phi02), cosPhi0 = cos(phi02), sPhi0 = phi02 >= 0 ? 1 : -1, tanPhi0 = tan(sPhi0 * phi02), k2 = (1 + sinPhi0 - cosPhi0) / 2;
	              function forward(lambda, phi) {
	                var cosPhi = cos(phi), cosLambda = cos(lambda /= 2);
	                return [
	                  (1 + cosPhi) * sin(lambda),
	                  (sPhi0 * phi > -atan2(cosLambda, tanPhi0) - 1e-3 ? 0 : -sPhi0 * 10) + k2 + sin(phi) * cosPhi0 - (1 + cosPhi) * sinPhi0 * cosLambda
	                  // TODO D3 core should allow null or [NaN, NaN] to be returned.
	                ];
	              }
	              forward.invert = function(x, y) {
	                var lambda = 0, phi = 0, i = 50;
	                do {
	                  var cosLambda = cos(lambda), sinLambda = sin(lambda), cosPhi = cos(phi), sinPhi = sin(phi), A2 = 1 + cosPhi, fx = A2 * sinLambda - x, fy = k2 + sinPhi * cosPhi0 - A2 * sinPhi0 * cosLambda - y, dxdLambda = A2 * cosLambda / 2, dxdPhi = -sinLambda * sinPhi, dydLambda = sinPhi0 * A2 * sinLambda / 2, dydPhi = cosPhi0 * cosPhi + sinPhi0 * cosLambda * sinPhi, denominator = dxdPhi * dydLambda - dydPhi * dxdLambda, dLambda = (fy * dxdPhi - fx * dydPhi) / denominator / 2, dPhi = (fx * dydLambda - fy * dxdLambda) / denominator;
	                  if (abs(dPhi) > 2) dPhi /= 2;
	                  lambda -= dLambda, phi -= dPhi;
	                } while ((abs(dLambda) > epsilon || abs(dPhi) > epsilon) && --i > 0);
	                return sPhi0 * phi > -atan2(cos(lambda), tanPhi0) - 1e-3 ? [lambda * 2, phi] : null;
	              };
	              return forward;
	            }
	            function armadillo() {
	              var phi02 = 20 * radians, sPhi0 = phi02 >= 0 ? 1 : -1, tanPhi0 = tan(sPhi0 * phi02), m = (0, src_projection.r)(armadilloRaw), p = m(phi02), stream_ = p.stream;
	              p.parallel = function(_) {
	                if (!arguments.length) return phi02 * degrees;
	                tanPhi0 = tan((sPhi0 = (phi02 = _ * radians) >= 0 ? 1 : -1) * phi02);
	                return m(phi02);
	              };
	              p.stream = function(stream) {
	                var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([0, 0]), stream_(stream)), precision = p.precision();
	                p.rotate(rotate);
	                rotateStream.sphere = function() {
	                  sphereStream.polygonStart(), sphereStream.lineStart();
	                  for (var lambda = sPhi0 * -180; sPhi0 * lambda < 180; lambda += sPhi0 * 90)
	                    sphereStream.point(lambda, sPhi0 * 90);
	                  if (phi02) while (sPhi0 * (lambda -= 3 * sPhi0 * precision) >= -180) {
	                    sphereStream.point(lambda, sPhi0 * -atan2(cos(lambda * radians / 2), tanPhi0) * degrees);
	                  }
	                  sphereStream.lineEnd(), sphereStream.polygonEnd();
	                };
	                return rotateStream;
	              };
	              return p.scale(218.695).center([0, 28.0974]);
	            }
	            function augustRaw(lambda, phi) {
	              var tanPhi = tan(phi / 2), k2 = sqrt(1 - tanPhi * tanPhi), c = 1 + k2 * cos(lambda /= 2), x = sin(lambda) * k2 / c, y = tanPhi / c, x2 = x * x, y2 = y * y;
	              return [
	                4 / 3 * x * (3 + x2 - 3 * y2),
	                4 / 3 * y * (3 + 3 * x2 - y2)
	              ];
	            }
	            augustRaw.invert = function(x, y) {
	              x *= 3 / 8, y *= 3 / 8;
	              if (!x && abs(y) > 1) return null;
	              var x2 = x * x, y2 = y * y, s = 1 + x2 + y2, sin3Eta = sqrt((s - sqrt(s * s - 4 * y * y)) / 2), eta = asin(sin3Eta) / 3, xi = sin3Eta ? arcosh(abs(y / sin3Eta)) / 3 : arsinh(abs(x)) / 3, cosEta = cos(eta), coshXi = cosh(xi), d = coshXi * coshXi - cosEta * cosEta;
	              return [
	                sign(x) * 2 * atan2(sinh(xi) * cosEta, 0.25 - d),
	                sign(y) * 2 * atan2(coshXi * sin(eta), 0.25 + d)
	              ];
	            };
	            function august() {
	              return (0, src_projection.Z)(augustRaw).scale(66.1603);
	            }
	            var sqrt8 = sqrt(8), phi0 = log(1 + sqrt2);
	            function bakerRaw(lambda, phi) {
	              var phi02 = abs(phi);
	              return phi02 < quarterPi ? [lambda, log(tan(quarterPi + phi / 2))] : [lambda * cos(phi02) * (2 * sqrt2 - 1 / sin(phi02)), sign(phi) * (2 * sqrt2 * (phi02 - quarterPi) - log(tan(phi02 / 2)))];
	            }
	            bakerRaw.invert = function(x, y) {
	              if ((y02 = abs(y)) < phi0) return [x, 2 * atan(exp(y)) - halfPi];
	              var phi = quarterPi, i = 25, delta, y02;
	              do {
	                var cosPhi_2 = cos(phi / 2), tanPhi_2 = tan(phi / 2);
	                phi -= delta = (sqrt8 * (phi - quarterPi) - log(tanPhi_2) - y02) / (sqrt8 - cosPhi_2 * cosPhi_2 / (2 * tanPhi_2));
	              } while (abs(delta) > epsilon2 && --i > 0);
	              return [x / (cos(phi) * (sqrt8 - 1 / sin(phi))), sign(y) * phi];
	            };
	            function baker() {
	              return (0, src_projection.Z)(bakerRaw).scale(112.314);
	            }
	            var azimuthalEquidistant = __webpack_require__2(17889);
	            function berghausRaw(lobes2) {
	              var k2 = 2 * pi / lobes2;
	              function forward(lambda, phi) {
	                var p = (0, azimuthalEquidistant.N)(lambda, phi);
	                if (abs(lambda) > halfPi) {
	                  var theta = atan2(p[1], p[0]), r = sqrt(p[0] * p[0] + p[1] * p[1]), theta0 = k2 * round((theta - halfPi) / k2) + halfPi, alpha = atan2(sin(theta -= theta0), 2 - cos(theta));
	                  theta = theta0 + asin(pi / r * sin(alpha)) - alpha;
	                  p[0] = r * cos(theta);
	                  p[1] = r * sin(theta);
	                }
	                return p;
	              }
	              forward.invert = function(x, y) {
	                var r = sqrt(x * x + y * y);
	                if (r > halfPi) {
	                  var theta = atan2(y, x), theta0 = k2 * round((theta - halfPi) / k2) + halfPi, s = theta > theta0 ? -1 : 1, A2 = r * cos(theta0 - theta), cotAlpha = 1 / tan(s * acos((A2 - pi) / sqrt(pi * (pi - 2 * A2) + r * r)));
	                  theta = theta0 + 2 * atan((cotAlpha + s * sqrt(cotAlpha * cotAlpha - 3)) / 3);
	                  x = r * cos(theta), y = r * sin(theta);
	                }
	                return azimuthalEquidistant.N.invert(x, y);
	              };
	              return forward;
	            }
	            function berghaus() {
	              var lobes2 = 5, m = (0, src_projection.r)(berghausRaw), p = m(lobes2), projectionStream = p.stream, epsilon3 = 0.01, cr = -cos(epsilon3 * radians), sr = sin(epsilon3 * radians);
	              p.lobes = function(_) {
	                return arguments.length ? m(lobes2 = +_) : lobes2;
	              };
	              p.stream = function(stream) {
	                var rotate = p.rotate(), rotateStream = projectionStream(stream), sphereStream = (p.rotate([0, 0]), projectionStream(stream));
	                p.rotate(rotate);
	                rotateStream.sphere = function() {
	                  sphereStream.polygonStart(), sphereStream.lineStart();
	                  for (var i = 0, delta = 360 / lobes2, delta0 = 2 * pi / lobes2, phi = 90 - 180 / lobes2, phi02 = halfPi; i < lobes2; ++i, phi -= delta, phi02 -= delta0) {
	                    sphereStream.point(atan2(sr * cos(phi02), cr) * degrees, asin(sr * sin(phi02)) * degrees);
	                    if (phi < -90) {
	                      sphereStream.point(-90, -180 - phi - epsilon3);
	                      sphereStream.point(-90, -180 - phi + epsilon3);
	                    } else {
	                      sphereStream.point(90, phi + epsilon3);
	                      sphereStream.point(90, phi - epsilon3);
	                    }
	                  }
	                  sphereStream.lineEnd(), sphereStream.polygonEnd();
	                };
	                return rotateStream;
	              };
	              return p.scale(87.8076).center([0, 17.1875]).clipAngle(180 - 1e-3);
	            }
	            var azimuthalEqualArea = __webpack_require__2(12956);
	            function hammerRaw(A2, B2) {
	              if (arguments.length < 2) B2 = A2;
	              if (B2 === 1) return azimuthalEqualArea.l;
	              if (B2 === Infinity) return hammerQuarticAuthalicRaw;
	              function forward(lambda, phi) {
	                var coordinates = (0, azimuthalEqualArea.l)(lambda / B2, phi);
	                coordinates[0] *= A2;
	                return coordinates;
	              }
	              forward.invert = function(x, y) {
	                var coordinates = azimuthalEqualArea.l.invert(x / A2, y);
	                coordinates[0] *= B2;
	                return coordinates;
	              };
	              return forward;
	            }
	            function hammerQuarticAuthalicRaw(lambda, phi) {
	              return [
	                lambda * cos(phi) / cos(phi /= 2),
	                2 * sin(phi)
	              ];
	            }
	            hammerQuarticAuthalicRaw.invert = function(x, y) {
	              var phi = 2 * asin(y / 2);
	              return [
	                x * cos(phi / 2) / cos(phi),
	                phi
	              ];
	            };
	            function hammer() {
	              var B2 = 2, m = (0, src_projection.r)(hammerRaw), p = m(B2);
	              p.coefficient = function(_) {
	                if (!arguments.length) return B2;
	                return m(B2 = +_);
	              };
	              return p.scale(169.529);
	            }
	            function solve(f, y, x) {
	              var steps = 100, delta, f0, f1;
	              x = x === undefined ? 0 : +x;
	              y = +y;
	              do {
	                f0 = f(x);
	                f1 = f(x + epsilon);
	                if (f0 === f1) f1 = f0 + epsilon;
	                x -= delta = -1 * epsilon * (f0 - y) / (f0 - f1);
	              } while (steps-- > 0 && abs(delta) > epsilon);
	              return steps < 0 ? NaN : x;
	            }
	            function solve2d(f, MAX_ITERATIONS, eps) {
	              if (MAX_ITERATIONS === undefined) MAX_ITERATIONS = 40;
	              if (eps === undefined) eps = epsilon2;
	              return function(x, y, a, b) {
	                var err2, da, db;
	                a = a === undefined ? 0 : +a;
	                b = b === undefined ? 0 : +b;
	                for (var i = 0; i < MAX_ITERATIONS; i++) {
	                  var p = f(a, b), tx = p[0] - x, ty = p[1] - y;
	                  if (abs(tx) < eps && abs(ty) < eps) break;
	                  var h = tx * tx + ty * ty;
	                  if (h > err2) {
	                    a -= da /= 2;
	                    b -= db /= 2;
	                    continue;
	                  }
	                  err2 = h;
	                  var ea = (a > 0 ? -1 : 1) * eps, eb = (b > 0 ? -1 : 1) * eps, pa = f(a + ea, b), pb = f(a, b + eb), dxa = (pa[0] - p[0]) / ea, dya = (pa[1] - p[1]) / ea, dxb = (pb[0] - p[0]) / eb, dyb = (pb[1] - p[1]) / eb, D = dyb * dxa - dya * dxb, l = (abs(D) < 0.5 ? 0.5 : 1) / D;
	                  da = (ty * dxb - tx * dyb) * l;
	                  db = (tx * dya - ty * dxa) * l;
	                  a += da;
	                  b += db;
	                  if (abs(da) < eps && abs(db) < eps) break;
	                }
	                return [a, b];
	              };
	            }
	            function bertin1953Raw() {
	              var hammer2 = hammerRaw(1.68, 2), fu = 1.4, k2 = 12;
	              function forward(lambda, phi) {
	                if (lambda + phi < -1.4) {
	                  var u = (lambda - phi + 1.6) * (lambda + phi + fu) / 8;
	                  lambda += u;
	                  phi -= 0.8 * u * sin(phi + pi / 2);
	                }
	                var r = hammer2(lambda, phi);
	                var d = (1 - cos(lambda * phi)) / k2;
	                if (r[1] < 0) {
	                  r[0] *= 1 + d;
	                }
	                if (r[1] > 0) {
	                  r[1] *= 1 + d / 1.5 * r[0] * r[0];
	                }
	                return r;
	              }
	              forward.invert = solve2d(forward);
	              return forward;
	            }
	            function bertin() {
	              return (0, src_projection.Z)(bertin1953Raw()).rotate([-16.5, -42]).scale(176.57).center([7.93, 0.09]);
	            }
	            function mollweideBromleyTheta(cp, phi) {
	              var cpsinPhi = cp * sin(phi), i = 30, delta;
	              do
	                phi -= delta = (phi + sin(phi) - cpsinPhi) / (1 + cos(phi));
	              while (abs(delta) > epsilon && --i > 0);
	              return phi / 2;
	            }
	            function mollweideBromleyRaw(cx, cy, cp) {
	              function forward(lambda, phi) {
	                return [cx * lambda * cos(phi = mollweideBromleyTheta(cp, phi)), cy * sin(phi)];
	              }
	              forward.invert = function(x, y) {
	                return y = asin(y / cy), [x / (cx * cos(y)), asin((2 * y + sin(2 * y)) / cp)];
	              };
	              return forward;
	            }
	            var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);
	            function mollweide() {
	              return (0, src_projection.Z)(mollweideRaw).scale(169.529);
	            }
	            var k = 2.00276, w = 1.11072;
	            function boggsRaw(lambda, phi) {
	              var theta = mollweideBromleyTheta(pi, phi);
	              return [k * lambda / (1 / cos(phi) + w / cos(theta)), (phi + sqrt2 * sin(theta)) / k];
	            }
	            boggsRaw.invert = function(x, y) {
	              var ky = k * y, theta = y < 0 ? -quarterPi : quarterPi, i = 25, delta, phi;
	              do {
	                phi = ky - sqrt2 * sin(theta);
	                theta -= delta = (sin(2 * theta) + 2 * theta - pi * sin(phi)) / (2 * cos(2 * theta) + 2 + pi * cos(phi) * sqrt2 * cos(theta));
	              } while (abs(delta) > epsilon && --i > 0);
	              phi = ky - sqrt2 * sin(theta);
	              return [x * (1 / cos(phi) + w / cos(theta)) / k, phi];
	            };
	            function boggs() {
	              return (0, src_projection.Z)(boggsRaw).scale(160.857);
	            }
	            function parallel1(projectAt) {
	              var phi02 = 0, m = (0, src_projection.r)(projectAt), p = m(phi02);
	              p.parallel = function(_) {
	                return arguments.length ? m(phi02 = _ * radians) : phi02 * degrees;
	              };
	              return p;
	            }
	            function sinusoidalRaw(lambda, phi) {
	              return [lambda * cos(phi), phi];
	            }
	            sinusoidalRaw.invert = function(x, y) {
	              return [x / cos(y), y];
	            };
	            function sinusoidal() {
	              return (0, src_projection.Z)(sinusoidalRaw).scale(152.63);
	            }
	            function bonneRaw(phi02) {
	              if (!phi02) return sinusoidalRaw;
	              var cotPhi0 = 1 / tan(phi02);
	              function forward(lambda, phi) {
	                var rho = cotPhi0 + phi02 - phi, e = rho ? lambda * cos(phi) / rho : rho;
	                return [rho * sin(e), cotPhi0 - rho * cos(e)];
	              }
	              forward.invert = function(x, y) {
	                var rho = sqrt(x * x + (y = cotPhi0 - y) * y), phi = cotPhi0 + phi02 - rho;
	                return [rho / cos(phi) * atan2(x, y), phi];
	              };
	              return forward;
	            }
	            function bonne() {
	              return parallel1(bonneRaw).scale(123.082).center([0, 26.1441]).parallel(45);
	            }
	            function bottomleyRaw(sinPsi) {
	              function forward(lambda, phi) {
	                var rho = halfPi - phi, eta = rho ? lambda * sinPsi * sin(rho) / rho : rho;
	                return [rho * sin(eta) / sinPsi, halfPi - rho * cos(eta)];
	              }
	              forward.invert = function(x, y) {
	                var x12 = x * sinPsi, y12 = halfPi - y, rho = sqrt(x12 * x12 + y12 * y12), eta = atan2(x12, y12);
	                return [(rho ? rho / sin(rho) : 1) * eta / sinPsi, halfPi - rho];
	              };
	              return forward;
	            }
	            function bottomley() {
	              var sinPsi = 0.5, m = (0, src_projection.r)(bottomleyRaw), p = m(sinPsi);
	              p.fraction = function(_) {
	                return arguments.length ? m(sinPsi = +_) : sinPsi;
	              };
	              return p.scale(158.837);
	            }
	            var bromleyRaw = mollweideBromleyRaw(1, 4 / pi, pi);
	            function bromley() {
	              return (0, src_projection.Z)(bromleyRaw).scale(152.63);
	            }
	            var centroid = __webpack_require__2(66624);
	            var rotation = __webpack_require__2(49386);
	            function distance(dPhi, c1, s1, c2, s2, dLambda) {
	              var cosdLambda = cos(dLambda), r;
	              if (abs(dPhi) > 1 || abs(dLambda) > 1) {
	                r = acos(s1 * s2 + c1 * c2 * cosdLambda);
	              } else {
	                var sindPhi = sin(dPhi / 2), sindLambda = sin(dLambda / 2);
	                r = 2 * asin(sqrt(sindPhi * sindPhi + c1 * c2 * sindLambda * sindLambda));
	              }
	              return abs(r) > epsilon ? [r, atan2(c2 * sin(dLambda), c1 * s2 - s1 * c2 * cosdLambda)] : [0, 0];
	            }
	            function angle(b, c, a) {
	              return acos((b * b + c * c - a * a) / (2 * b * c));
	            }
	            function longitude(lambda) {
	              return lambda - 2 * pi * floor((lambda + pi) / (2 * pi));
	            }
	            function chamberlinRaw(p0, p1, p2) {
	              var points2 = [
	                [p0[0], p0[1], sin(p0[1]), cos(p0[1])],
	                [p1[0], p1[1], sin(p1[1]), cos(p1[1])],
	                [p2[0], p2[1], sin(p2[1]), cos(p2[1])]
	              ];
	              for (var a = points2[2], b, i = 0; i < 3; ++i, a = b) {
	                b = points2[i];
	                a.v = distance(b[1] - a[1], a[3], a[2], b[3], b[2], b[0] - a[0]);
	                a.point = [0, 0];
	              }
	              var beta0 = angle(points2[0].v[0], points2[2].v[0], points2[1].v[0]), beta1 = angle(points2[0].v[0], points2[1].v[0], points2[2].v[0]), beta2 = pi - beta0;
	              points2[2].point[1] = 0;
	              points2[0].point[0] = -(points2[1].point[0] = points2[0].v[0] / 2);
	              var mean = [
	                points2[2].point[0] = points2[0].point[0] + points2[2].v[0] * cos(beta0),
	                2 * (points2[0].point[1] = points2[1].point[1] = points2[2].v[0] * sin(beta0))
	              ];
	              function forward(lambda, phi) {
	                var sinPhi = sin(phi), cosPhi = cos(phi), v = new Array(3), i2;
	                for (i2 = 0; i2 < 3; ++i2) {
	                  var p = points2[i2];
	                  v[i2] = distance(phi - p[1], p[3], p[2], cosPhi, sinPhi, lambda - p[0]);
	                  if (!v[i2][0]) return p.point;
	                  v[i2][1] = longitude(v[i2][1] - p.v[1]);
	                }
	                var point = mean.slice();
	                for (i2 = 0; i2 < 3; ++i2) {
	                  var j = i2 == 2 ? 0 : i2 + 1;
	                  var a2 = angle(points2[i2].v[0], v[i2][0], v[j][0]);
	                  if (v[i2][1] < 0) a2 = -a2;
	                  if (!i2) {
	                    point[0] += v[i2][0] * cos(a2);
	                    point[1] -= v[i2][0] * sin(a2);
	                  } else if (i2 == 1) {
	                    a2 = beta1 - a2;
	                    point[0] -= v[i2][0] * cos(a2);
	                    point[1] -= v[i2][0] * sin(a2);
	                  } else {
	                    a2 = beta2 - a2;
	                    point[0] += v[i2][0] * cos(a2);
	                    point[1] += v[i2][0] * sin(a2);
	                  }
	                }
	                point[0] /= 3, point[1] /= 3;
	                return point;
	              }
	              return forward;
	            }
	            function pointRadians(p) {
	              return p[0] *= radians, p[1] *= radians, p;
	            }
	            function chamberlinAfrica() {
	              return chamberlin([0, 22], [45, 22], [22.5, -22]).scale(380).center([22.5, 2]);
	            }
	            function chamberlin(p0, p1, p2) {
	              var c = (0, centroid.Z)({ type: "MultiPoint", coordinates: [p0, p1, p2] }), R = [-c[0], -c[1]], r = (0, rotation.Z)(R), f = chamberlinRaw(pointRadians(r(p0)), pointRadians(r(p1)), pointRadians(r(p2)));
	              f.invert = solve2d(f);
	              var p = (0, src_projection.Z)(f).rotate(R), center = p.center;
	              delete p.rotate;
	              p.center = function(_) {
	                return arguments.length ? center(r(_)) : r.invert(center());
	              };
	              return p.clipAngle(90);
	            }
	            function collignonRaw(lambda, phi) {
	              var alpha = sqrt(1 - sin(phi));
	              return [2 / sqrtPi * lambda * alpha, sqrtPi * (1 - alpha)];
	            }
	            collignonRaw.invert = function(x, y) {
	              var lambda = (lambda = y / sqrtPi - 1) * lambda;
	              return [lambda > 0 ? x * sqrt(pi / lambda) / 2 : 0, asin(1 - lambda)];
	            };
	            function collignon() {
	              return (0, src_projection.Z)(collignonRaw).scale(95.6464).center([0, 30]);
	            }
	            function craigRaw(phi02) {
	              var tanPhi0 = tan(phi02);
	              function forward(lambda, phi) {
	                return [lambda, (lambda ? lambda / sin(lambda) : 1) * (sin(phi) * cos(lambda) - tanPhi0 * cos(phi))];
	              }
	              forward.invert = tanPhi0 ? function(x, y) {
	                if (x) y *= sin(x) / x;
	                var cosLambda = cos(x);
	                return [x, 2 * atan2(sqrt(cosLambda * cosLambda + tanPhi0 * tanPhi0 - y * y) - cosLambda, tanPhi0 - y)];
	              } : function(x, y) {
	                return [x, asin(x ? y * tan(x) / x : y)];
	              };
	              return forward;
	            }
	            function craig() {
	              return parallel1(craigRaw).scale(249.828).clipAngle(90);
	            }
	            var sqrt3 = sqrt(3);
	            function crasterRaw(lambda, phi) {
	              return [sqrt3 * lambda * (2 * cos(2 * phi / 3) - 1) / sqrtPi, sqrt3 * sqrtPi * sin(phi / 3)];
	            }
	            crasterRaw.invert = function(x, y) {
	              var phi = 3 * asin(y / (sqrt3 * sqrtPi));
	              return [sqrtPi * x / (sqrt3 * (2 * cos(2 * phi / 3) - 1)), phi];
	            };
	            function craster() {
	              return (0, src_projection.Z)(crasterRaw).scale(156.19);
	            }
	            function cylindricalEqualAreaRaw(phi02) {
	              var cosPhi0 = cos(phi02);
	              function forward(lambda, phi) {
	                return [lambda * cosPhi0, sin(phi) / cosPhi0];
	              }
	              forward.invert = function(x, y) {
	                return [x / cosPhi0, asin(y * cosPhi0)];
	              };
	              return forward;
	            }
	            function cylindricalEqualArea() {
	              return parallel1(cylindricalEqualAreaRaw).parallel(38.58).scale(195.044);
	            }
	            function cylindricalStereographicRaw(phi02) {
	              var cosPhi0 = cos(phi02);
	              function forward(lambda, phi) {
	                return [lambda * cosPhi0, (1 + cosPhi0) * tan(phi / 2)];
	              }
	              forward.invert = function(x, y) {
	                return [x / cosPhi0, atan(y / (1 + cosPhi0)) * 2];
	              };
	              return forward;
	            }
	            function cylindricalStereographic() {
	              return parallel1(cylindricalStereographicRaw).scale(124.75);
	            }
	            function eckert1Raw(lambda, phi) {
	              var alpha = sqrt(8 / (3 * pi));
	              return [
	                alpha * lambda * (1 - abs(phi) / pi),
	                alpha * phi
	              ];
	            }
	            eckert1Raw.invert = function(x, y) {
	              var alpha = sqrt(8 / (3 * pi)), phi = y / alpha;
	              return [
	                x / (alpha * (1 - abs(phi) / pi)),
	                phi
	              ];
	            };
	            function eckert1() {
	              return (0, src_projection.Z)(eckert1Raw).scale(165.664);
	            }
	            function eckert2Raw(lambda, phi) {
	              var alpha = sqrt(4 - 3 * sin(abs(phi)));
	              return [
	                2 / sqrt(6 * pi) * lambda * alpha,
	                sign(phi) * sqrt(2 * pi / 3) * (2 - alpha)
	              ];
	            }
	            eckert2Raw.invert = function(x, y) {
	              var alpha = 2 - abs(y) / sqrt(2 * pi / 3);
	              return [
	                x * sqrt(6 * pi) / (2 * alpha),
	                sign(y) * asin((4 - alpha * alpha) / 3)
	              ];
	            };
	            function eckert2() {
	              return (0, src_projection.Z)(eckert2Raw).scale(165.664);
	            }
	            function eckert3Raw(lambda, phi) {
	              var k2 = sqrt(pi * (4 + pi));
	              return [
	                2 / k2 * lambda * (1 + sqrt(1 - 4 * phi * phi / (pi * pi))),
	                4 / k2 * phi
	              ];
	            }
	            eckert3Raw.invert = function(x, y) {
	              var k2 = sqrt(pi * (4 + pi)) / 2;
	              return [
	                x * k2 / (1 + sqrt(1 - y * y * (4 + pi) / (4 * pi))),
	                y * k2 / 2
	              ];
	            };
	            function eckert3() {
	              return (0, src_projection.Z)(eckert3Raw).scale(180.739);
	            }
	            function eckert4Raw(lambda, phi) {
	              var k2 = (2 + halfPi) * sin(phi);
	              phi /= 2;
	              for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
	                var cosPhi = cos(phi);
	                phi -= delta = (phi + sin(phi) * (cosPhi + 2) - k2) / (2 * cosPhi * (1 + cosPhi));
	              }
	              return [
	                2 / sqrt(pi * (4 + pi)) * lambda * (1 + cos(phi)),
	                2 * sqrt(pi / (4 + pi)) * sin(phi)
	              ];
	            }
	            eckert4Raw.invert = function(x, y) {
	              var A2 = y * sqrt((4 + pi) / pi) / 2, k2 = asin(A2), c = cos(k2);
	              return [
	                x / (2 / sqrt(pi * (4 + pi)) * (1 + c)),
	                asin((k2 + A2 * (c + 2)) / (2 + halfPi))
	              ];
	            };
	            function eckert4() {
	              return (0, src_projection.Z)(eckert4Raw).scale(180.739);
	            }
	            function eckert5Raw(lambda, phi) {
	              return [
	                lambda * (1 + cos(phi)) / sqrt(2 + pi),
	                2 * phi / sqrt(2 + pi)
	              ];
	            }
	            eckert5Raw.invert = function(x, y) {
	              var k2 = sqrt(2 + pi), phi = y * k2 / 2;
	              return [
	                k2 * x / (1 + cos(phi)),
	                phi
	              ];
	            };
	            function eckert5() {
	              return (0, src_projection.Z)(eckert5Raw).scale(173.044);
	            }
	            function eckert6Raw(lambda, phi) {
	              var k2 = (1 + halfPi) * sin(phi);
	              for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
	                phi -= delta = (phi + sin(phi) - k2) / (1 + cos(phi));
	              }
	              k2 = sqrt(2 + pi);
	              return [
	                lambda * (1 + cos(phi)) / k2,
	                2 * phi / k2
	              ];
	            }
	            eckert6Raw.invert = function(x, y) {
	              var j = 1 + halfPi, k2 = sqrt(j / 2);
	              return [
	                x * 2 * k2 / (1 + cos(y *= k2)),
	                asin((y + sin(y)) / j)
	              ];
	            };
	            function eckert6() {
	              return (0, src_projection.Z)(eckert6Raw).scale(173.044);
	            }
	            var eisenlohrK = 3 + 2 * sqrt2;
	            function eisenlohrRaw(lambda, phi) {
	              var s0 = sin(lambda /= 2), c0 = cos(lambda), k2 = sqrt(cos(phi)), c1 = cos(phi /= 2), t = sin(phi) / (c1 + sqrt2 * c0 * k2), c = sqrt(2 / (1 + t * t)), v = sqrt((sqrt2 * c1 + (c0 + s0) * k2) / (sqrt2 * c1 + (c0 - s0) * k2));
	              return [
	                eisenlohrK * (c * (v - 1 / v) - 2 * log(v)),
	                eisenlohrK * (c * t * (v + 1 / v) - 2 * atan(t))
	              ];
	            }
	            eisenlohrRaw.invert = function(x, y) {
	              if (!(p = augustRaw.invert(x / 1.2, y * 1.065))) return null;
	              var lambda = p[0], phi = p[1], i = 20, p;
	              x /= eisenlohrK, y /= eisenlohrK;
	              do {
	                var _0 = lambda / 2, _1 = phi / 2, s0 = sin(_0), c0 = cos(_0), s1 = sin(_1), c1 = cos(_1), cos1 = cos(phi), k2 = sqrt(cos1), t = s1 / (c1 + sqrt2 * c0 * k2), t2 = t * t, c = sqrt(2 / (1 + t2)), v0 = sqrt2 * c1 + (c0 + s0) * k2, v1 = sqrt2 * c1 + (c0 - s0) * k2, v2 = v0 / v1, v = sqrt(v2), vm1v = v - 1 / v, vp1v = v + 1 / v, fx = c * vm1v - 2 * log(v) - x, fy = c * t * vp1v - 2 * atan(t) - y, deltatDeltaLambda = s1 && sqrt1_2 * k2 * s0 * t2 / s1, deltatDeltaPhi = (sqrt2 * c0 * c1 + k2) / (2 * (c1 + sqrt2 * c0 * k2) * (c1 + sqrt2 * c0 * k2) * k2), deltacDeltat = -0.5 * t * c * c * c, deltacDeltaLambda = deltacDeltat * deltatDeltaLambda, deltacDeltaPhi = deltacDeltat * deltatDeltaPhi, A2 = (A2 = 2 * c1 + sqrt2 * k2 * (c0 - s0)) * A2 * v, deltavDeltaLambda = (sqrt2 * c0 * c1 * k2 + cos1) / A2, deltavDeltaPhi = -(sqrt2 * s0 * s1) / (k2 * A2), deltaxDeltaLambda = vm1v * deltacDeltaLambda - 2 * deltavDeltaLambda / v + c * (deltavDeltaLambda + deltavDeltaLambda / v2), deltaxDeltaPhi = vm1v * deltacDeltaPhi - 2 * deltavDeltaPhi / v + c * (deltavDeltaPhi + deltavDeltaPhi / v2), deltayDeltaLambda = t * vp1v * deltacDeltaLambda - 2 * deltatDeltaLambda / (1 + t2) + c * vp1v * deltatDeltaLambda + c * t * (deltavDeltaLambda - deltavDeltaLambda / v2), deltayDeltaPhi = t * vp1v * deltacDeltaPhi - 2 * deltatDeltaPhi / (1 + t2) + c * vp1v * deltatDeltaPhi + c * t * (deltavDeltaPhi - deltavDeltaPhi / v2), denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
	                if (!denominator) break;
	                var deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator, deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	                lambda -= deltaLambda;
	                phi = max(-halfPi, min(halfPi, phi - deltaPhi));
	              } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	              return abs(abs(phi) - halfPi) < epsilon ? [0, phi] : i && [lambda, phi];
	            };
	            function eisenlohr() {
	              return (0, src_projection.Z)(eisenlohrRaw).scale(62.5271);
	            }
	            var faheyK = cos(35 * radians);
	            function faheyRaw(lambda, phi) {
	              var t = tan(phi / 2);
	              return [lambda * faheyK * sqrt(1 - t * t), (1 + faheyK) * t];
	            }
	            faheyRaw.invert = function(x, y) {
	              var t = y / (1 + faheyK);
	              return [x && x / (faheyK * sqrt(1 - t * t)), 2 * atan(t)];
	            };
	            function fahey() {
	              return (0, src_projection.Z)(faheyRaw).scale(137.152);
	            }
	            function foucautRaw(lambda, phi) {
	              var k2 = phi / 2, cosk = cos(k2);
	              return [2 * lambda / sqrtPi * cos(phi) * cosk * cosk, sqrtPi * tan(k2)];
	            }
	            foucautRaw.invert = function(x, y) {
	              var k2 = atan(y / sqrtPi), cosk = cos(k2), phi = 2 * k2;
	              return [x * sqrtPi / 2 / (cos(phi) * cosk * cosk), phi];
	            };
	            function foucaut() {
	              return (0, src_projection.Z)(foucautRaw).scale(135.264);
	            }
	            function foucautSinusoidalRaw(alpha) {
	              var beta = 1 - alpha, equatorial = raw(pi, 0)[0] - raw(-pi, 0)[0], polar = raw(0, halfPi)[1] - raw(0, -halfPi)[1], ratio = sqrt(2 * polar / equatorial);
	              function raw(lambda, phi) {
	                var cosphi = cos(phi), sinphi = sin(phi);
	                return [
	                  cosphi / (beta + alpha * cosphi) * lambda,
	                  beta * phi + alpha * sinphi
	                ];
	              }
	              function forward(lambda, phi) {
	                var p = raw(lambda, phi);
	                return [p[0] * ratio, p[1] / ratio];
	              }
	              function forwardMeridian(phi) {
	                return forward(0, phi)[1];
	              }
	              forward.invert = function(x, y) {
	                var phi = solve(forwardMeridian, y), lambda = x / ratio * (alpha + beta / cos(phi));
	                return [lambda, phi];
	              };
	              return forward;
	            }
	            function foucautSinusoidal() {
	              var alpha = 0.5, m = (0, src_projection.r)(foucautSinusoidalRaw), p = m(alpha);
	              p.alpha = function(_) {
	                return arguments.length ? m(alpha = +_) : alpha;
	              };
	              return p.scale(168.725);
	            }
	            var orthographic = __webpack_require__2(57962);
	            var projection_equirectangular = __webpack_require__2(97492);
	            function gilbertForward(point) {
	              return [point[0] / 2, asin(tan(point[1] / 2 * radians)) * degrees];
	            }
	            function gilbertInvert(point) {
	              return [point[0] * 2, 2 * atan(sin(point[1] * radians)) * degrees];
	            }
	            function gilbert(projectionType) {
	              if (projectionType == null) projectionType = orthographic.Z;
	              var projection = projectionType(), equirectangular = (0, projection_equirectangular.Z)().scale(degrees).precision(0).clipAngle(null).translate([0, 0]);
	              function gilbert2(point) {
	                return projection(gilbertForward(point));
	              }
	              if (projection.invert) gilbert2.invert = function(point) {
	                return gilbertInvert(projection.invert(point));
	              };
	              gilbert2.stream = function(stream) {
	                var s1 = projection.stream(stream), s0 = equirectangular.stream({
	                  point: function(lambda, phi) {
	                    s1.point(lambda / 2, asin(tan(-phi / 2 * radians)) * degrees);
	                  },
	                  lineStart: function() {
	                    s1.lineStart();
	                  },
	                  lineEnd: function() {
	                    s1.lineEnd();
	                  },
	                  polygonStart: function() {
	                    s1.polygonStart();
	                  },
	                  polygonEnd: function() {
	                    s1.polygonEnd();
	                  }
	                });
	                s0.sphere = s1.sphere;
	                return s0;
	              };
	              function property(name2) {
	                gilbert2[name2] = function() {
	                  return arguments.length ? (projection[name2].apply(projection, arguments), gilbert2) : projection[name2]();
	                };
	              }
	              gilbert2.rotate = function(_) {
	                return arguments.length ? (equirectangular.rotate(_), gilbert2) : equirectangular.rotate();
	              };
	              gilbert2.center = function(_) {
	                return arguments.length ? (projection.center(gilbertForward(_)), gilbert2) : gilbertInvert(projection.center());
	              };
	              property("angle");
	              property("clipAngle");
	              property("clipExtent");
	              property("fitExtent");
	              property("fitHeight");
	              property("fitSize");
	              property("fitWidth");
	              property("scale");
	              property("translate");
	              property("precision");
	              return gilbert2.scale(249.5);
	            }
	            function gingeryRaw(rho, n) {
	              var k2 = 2 * pi / n, rho2 = rho * rho;
	              function forward(lambda, phi) {
	                var p = (0, azimuthalEquidistant.N)(lambda, phi), x = p[0], y = p[1], r2 = x * x + y * y;
	                if (r2 > rho2) {
	                  var r = sqrt(r2), theta = atan2(y, x), theta0 = k2 * round(theta / k2), alpha = theta - theta0, rhoCosAlpha = rho * cos(alpha), k_ = (rho * sin(alpha) - alpha * sin(rhoCosAlpha)) / (halfPi - rhoCosAlpha), s_ = gingeryLength(alpha, k_), e = (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
	                  x = r;
	                  var i = 50, delta;
	                  do {
	                    x -= delta = (rho + gingeryIntegrate(s_, rhoCosAlpha, x) * e - r) / (s_(x) * e);
	                  } while (abs(delta) > epsilon && --i > 0);
	                  y = alpha * sin(x);
	                  if (x < halfPi) y -= k_ * (x - halfPi);
	                  var s = sin(theta0), c = cos(theta0);
	                  p[0] = x * c - y * s;
	                  p[1] = x * s + y * c;
	                }
	                return p;
	              }
	              forward.invert = function(x, y) {
	                var r2 = x * x + y * y;
	                if (r2 > rho2) {
	                  var r = sqrt(r2), theta = atan2(y, x), theta0 = k2 * round(theta / k2), dTheta = theta - theta0;
	                  x = r * cos(dTheta);
	                  y = r * sin(dTheta);
	                  var x_halfPi = x - halfPi, sinx = sin(x), alpha = y / sinx, delta = x < halfPi ? Infinity : 0, i = 10;
	                  while (true) {
	                    var rhosinAlpha = rho * sin(alpha), rhoCosAlpha = rho * cos(alpha), sinRhoCosAlpha = sin(rhoCosAlpha), halfPi_RhoCosAlpha = halfPi - rhoCosAlpha, k_ = (rhosinAlpha - alpha * sinRhoCosAlpha) / halfPi_RhoCosAlpha, s_ = gingeryLength(alpha, k_);
	                    if (abs(delta) < epsilon2 || !--i) break;
	                    alpha -= delta = (alpha * sinx - k_ * x_halfPi - y) / (sinx - x_halfPi * 2 * (halfPi_RhoCosAlpha * (rhoCosAlpha + alpha * rhosinAlpha * cos(rhoCosAlpha) - sinRhoCosAlpha) - rhosinAlpha * (rhosinAlpha - alpha * sinRhoCosAlpha)) / (halfPi_RhoCosAlpha * halfPi_RhoCosAlpha));
	                  }
	                  r = rho + gingeryIntegrate(s_, rhoCosAlpha, x) * (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
	                  theta = theta0 + alpha;
	                  x = r * cos(theta);
	                  y = r * sin(theta);
	                }
	                return azimuthalEquidistant.N.invert(x, y);
	              };
	              return forward;
	            }
	            function gingeryLength(alpha, k2) {
	              return function(x) {
	                var y_ = alpha * cos(x);
	                if (x < halfPi) y_ -= k2;
	                return sqrt(1 + y_ * y_);
	              };
	            }
	            function gingeryIntegrate(f, a, b) {
	              var n = 50, h = (b - a) / n, s = f(a) + f(b);
	              for (var i = 1, x = a; i < n; ++i) s += 2 * f(x += h);
	              return s * 0.5 * h;
	            }
	            function gingery() {
	              var n = 6, rho = 30 * radians, cRho = cos(rho), sRho = sin(rho), m = (0, src_projection.r)(gingeryRaw), p = m(rho, n), stream_ = p.stream, epsilon3 = 0.01, cr = -cos(epsilon3 * radians), sr = sin(epsilon3 * radians);
	              p.radius = function(_) {
	                if (!arguments.length) return rho * degrees;
	                cRho = cos(rho = _ * radians);
	                sRho = sin(rho);
	                return m(rho, n);
	              };
	              p.lobes = function(_) {
	                if (!arguments.length) return n;
	                return m(rho, n = +_);
	              };
	              p.stream = function(stream) {
	                var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([0, 0]), stream_(stream));
	                p.rotate(rotate);
	                rotateStream.sphere = function() {
	                  sphereStream.polygonStart(), sphereStream.lineStart();
	                  for (var i = 0, delta = 2 * pi / n, phi = 0; i < n; ++i, phi -= delta) {
	                    sphereStream.point(atan2(sr * cos(phi), cr) * degrees, asin(sr * sin(phi)) * degrees);
	                    sphereStream.point(atan2(sRho * cos(phi - delta / 2), cRho) * degrees, asin(sRho * sin(phi - delta / 2)) * degrees);
	                  }
	                  sphereStream.lineEnd(), sphereStream.polygonEnd();
	                };
	                return rotateStream;
	              };
	              return p.rotate([90, -40]).scale(91.7095).clipAngle(180 - 1e-3);
	            }
	            function ginzburgPolyconic(a, b, c, d, e, f, g, h) {
	              if (arguments.length < 8) h = 0;
	              function forward(lambda, phi) {
	                if (!phi) return [a * lambda / pi, 0];
	                var phi2 = phi * phi, xB = a + phi2 * (b + phi2 * (c + phi2 * d)), yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)), m = (xB * xB + yB * yB) / (2 * yB), alpha = lambda * asin(xB / m) / pi;
	                return [m * sin(alpha), phi * (1 + phi2 * h) + m * (1 - cos(alpha))];
	              }
	              forward.invert = function(x, y) {
	                var lambda = pi * x / a, phi = y, deltaLambda, deltaPhi, i = 50;
	                do {
	                  var phi2 = phi * phi, xB = a + phi2 * (b + phi2 * (c + phi2 * d)), yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)), p = xB * xB + yB * yB, q = 2 * yB, m = p / q, m2 = m * m, dAlphadLambda = asin(xB / m) / pi, alpha = lambda * dAlphadLambda, xB2 = xB * xB, dxBdPhi = (2 * b + phi2 * (4 * c + phi2 * 6 * d)) * phi, dyBdPhi = e + phi2 * (3 * f + phi2 * 5 * g), dpdPhi = 2 * (xB * dxBdPhi + yB * (dyBdPhi - 1)), dqdPhi = 2 * (dyBdPhi - 1), dmdPhi = (dpdPhi * q - p * dqdPhi) / (q * q), cosAlpha = cos(alpha), sinAlpha = sin(alpha), mcosAlpha = m * cosAlpha, msinAlpha = m * sinAlpha, dAlphadPhi = lambda / pi * (1 / sqrt(1 - xB2 / m2)) * (dxBdPhi * m - xB * dmdPhi) / m2, fx = msinAlpha - x, fy = phi * (1 + phi2 * h) + m - mcosAlpha - y, deltaxDeltaPhi = dmdPhi * sinAlpha + mcosAlpha * dAlphadPhi, deltaxDeltaLambda = mcosAlpha * dAlphadLambda, deltayDeltaPhi = 1 + dmdPhi - (dmdPhi * cosAlpha - msinAlpha * dAlphadPhi), deltayDeltaLambda = msinAlpha * dAlphadLambda, denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
	                  if (!denominator) break;
	                  lambda -= deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator;
	                  phi -= deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	                } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	                return [lambda, phi];
	              };
	              return forward;
	            }
	            var ginzburg4Raw = ginzburgPolyconic(2.8284, -1.6988, 0.75432, -0.18071, 1.76003, -0.38914, 0.042555);
	            function ginzburg4() {
	              return (0, src_projection.Z)(ginzburg4Raw).scale(149.995);
	            }
	            var ginzburg5Raw = ginzburgPolyconic(2.583819, -0.835827, 0.170354, -0.038094, 1.543313, -0.411435, 0.082742);
	            function ginzburg5() {
	              return (0, src_projection.Z)(ginzburg5Raw).scale(153.93);
	            }
	            var ginzburg6Raw = ginzburgPolyconic(5 / 6 * pi, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, 0.045);
	            function ginzburg6() {
	              return (0, src_projection.Z)(ginzburg6Raw).scale(130.945);
	            }
	            function ginzburg8Raw(lambda, phi) {
	              var lambda2 = lambda * lambda, phi2 = phi * phi;
	              return [
	                lambda * (1 - 0.162388 * phi2) * (0.87 - 952426e-9 * lambda2 * lambda2),
	                phi * (1 + phi2 / 12)
	              ];
	            }
	            ginzburg8Raw.invert = function(x, y) {
	              var lambda = x, phi = y, i = 50, delta;
	              do {
	                var phi2 = phi * phi;
	                phi -= delta = (phi * (1 + phi2 / 12) - y) / (1 + phi2 / 4);
	              } while (abs(delta) > epsilon && --i > 0);
	              i = 50;
	              x /= 1 - 0.162388 * phi2;
	              do {
	                var lambda4 = (lambda4 = lambda * lambda) * lambda4;
	                lambda -= delta = (lambda * (0.87 - 952426e-9 * lambda4) - x) / (0.87 - 476213e-8 * lambda4);
	              } while (abs(delta) > epsilon && --i > 0);
	              return [lambda, phi];
	            };
	            function ginzburg8() {
	              return (0, src_projection.Z)(ginzburg8Raw).scale(131.747);
	            }
	            var ginzburg9Raw = ginzburgPolyconic(2.6516, -0.76534, 0.19123, -0.047094, 1.36289, -0.13965, 0.031762);
	            function ginzburg9() {
	              return (0, src_projection.Z)(ginzburg9Raw).scale(131.087);
	            }
	            function square(project2) {
	              var dx = project2(halfPi, 0)[0] - project2(-halfPi, 0)[0];
	              function projectSquare(lambda, phi) {
	                var s = lambda > 0 ? -0.5 : 0.5, point = project2(lambda + s * pi, phi);
	                point[0] -= s * dx;
	                return point;
	              }
	              if (project2.invert) projectSquare.invert = function(x, y) {
	                var s = x > 0 ? -0.5 : 0.5, location = project2.invert(x + s * dx, y), lambda = location[0] - s * pi;
	                if (lambda < -pi) lambda += 2 * pi;
	                else if (lambda > pi) lambda -= 2 * pi;
	                location[0] = lambda;
	                return location;
	              };
	              return projectSquare;
	            }
	            function gringortenRaw(lambda, phi) {
	              var sLambda = sign(lambda), sPhi = sign(phi), cosPhi = cos(phi), x = cos(lambda) * cosPhi, y = sin(lambda) * cosPhi, z = sin(sPhi * phi);
	              lambda = abs(atan2(y, z));
	              phi = asin(x);
	              if (abs(lambda - halfPi) > epsilon) lambda %= halfPi;
	              var point = gringortenHexadecant(lambda > pi / 4 ? halfPi - lambda : lambda, phi);
	              if (lambda > pi / 4) z = point[0], point[0] = -point[1], point[1] = -z;
	              return point[0] *= sLambda, point[1] *= -sPhi, point;
	            }
	            gringortenRaw.invert = function(x, y) {
	              if (abs(x) > 1) x = sign(x) * 2 - x;
	              if (abs(y) > 1) y = sign(y) * 2 - y;
	              var sx = sign(x), sy = sign(y), x02 = -sx * x, y02 = -sy * y, t = y02 / x02 < 1, p = gringortenHexadecantInvert(t ? y02 : x02, t ? x02 : y02), lambda = p[0], phi = p[1], cosPhi = cos(phi);
	              if (t) lambda = -halfPi - lambda;
	              return [sx * (atan2(sin(lambda) * cosPhi, -sin(phi)) + pi), sy * asin(cos(lambda) * cosPhi)];
	            };
	            function gringortenHexadecant(lambda, phi) {
	              if (phi === halfPi) return [0, 0];
	              var sinPhi = sin(phi), r = sinPhi * sinPhi, r2 = r * r, j = 1 + r2, k2 = 1 + 3 * r2, q = 1 - r2, z = asin(1 / sqrt(j)), v = q + r * j * z, p2 = (1 - sinPhi) / v, p = sqrt(p2), a2 = p2 * j, a = sqrt(a2), h = p * q, x, i;
	              if (lambda === 0) return [0, -(h + r * a)];
	              var cosPhi = cos(phi), secPhi = 1 / cosPhi, drdPhi = 2 * sinPhi * cosPhi, dvdPhi = (-3 * r + z * k2) * drdPhi, dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v), dpdPhi = 0.5 * dp2dPhi / p, dhdPhi = q * dpdPhi - 2 * r * p * drdPhi, dra2dPhi = r * j * dp2dPhi + p2 * k2 * drdPhi, mu = -secPhi * drdPhi, nu = -secPhi * dra2dPhi, zeta = -2 * secPhi * dhdPhi, lambda1 = 4 * lambda / pi, delta;
	              if (lambda > 0.222 * pi || phi < pi / 4 && lambda > 0.175 * pi) {
	                x = (h + r * sqrt(a2 * (1 + r2) - h * h)) / (1 + r2);
	                if (lambda > pi / 4) return [x, x];
	                var x12 = x, x02 = 0.5 * x;
	                x = 0.5 * (x02 + x12), i = 50;
	                do {
	                  var g = sqrt(a2 - x * x), f = x * (zeta + mu * g) + nu * asin(x / a) - lambda1;
	                  if (!f) break;
	                  if (f < 0) x02 = x;
	                  else x12 = x;
	                  x = 0.5 * (x02 + x12);
	                } while (abs(x12 - x02) > epsilon && --i > 0);
	              } else {
	                x = epsilon, i = 25;
	                do {
	                  var x2 = x * x, g2 = sqrt(a2 - x2), zetaMug = zeta + mu * g2, f2 = x * zetaMug + nu * asin(x / a) - lambda1, df = zetaMug + (nu - mu * x2) / g2;
	                  x -= delta = g2 ? f2 / df : 0;
	                } while (abs(delta) > epsilon && --i > 0);
	              }
	              return [x, -h - r * sqrt(a2 - x * x)];
	            }
	            function gringortenHexadecantInvert(x, y) {
	              var x02 = 0, x12 = 1, r = 0.5, i = 50;
	              while (true) {
	                var r2 = r * r, sinPhi = sqrt(r), z = asin(1 / sqrt(1 + r2)), v = 1 - r2 + r * (1 + r2) * z, p2 = (1 - sinPhi) / v, p = sqrt(p2), a2 = p2 * (1 + r2), h = p * (1 - r2), g2 = a2 - x * x, g = sqrt(g2), y02 = y + h + r * g;
	                if (abs(x12 - x02) < epsilon2 || --i === 0 || y02 === 0) break;
	                if (y02 > 0) x02 = r;
	                else x12 = r;
	                r = 0.5 * (x02 + x12);
	              }
	              if (!i) return null;
	              var phi = asin(sinPhi), cosPhi = cos(phi), secPhi = 1 / cosPhi, drdPhi = 2 * sinPhi * cosPhi, dvdPhi = (-3 * r + z * (1 + 3 * r2)) * drdPhi, dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v), dpdPhi = 0.5 * dp2dPhi / p, dhdPhi = (1 - r2) * dpdPhi - 2 * r * p * drdPhi, zeta = -2 * secPhi * dhdPhi, mu = -secPhi * drdPhi, nu = -secPhi * (r * (1 + r2) * dp2dPhi + p2 * (1 + 3 * r2) * drdPhi);
	              return [pi / 4 * (x * (zeta + mu * g) + nu * asin(x / sqrt(a2))), phi];
	            }
	            function gringorten() {
	              return (0, src_projection.Z)(square(gringortenRaw)).scale(239.75);
	            }
	            function ellipticJi(u, v, m) {
	              var a, b, c;
	              if (!u) {
	                b = ellipticJ(v, 1 - m);
	                return [
	                  [0, b[0] / b[1]],
	                  [1 / b[1], 0],
	                  [b[2] / b[1], 0]
	                ];
	              }
	              a = ellipticJ(u, m);
	              if (!v) return [[a[0], 0], [a[1], 0], [a[2], 0]];
	              b = ellipticJ(v, 1 - m);
	              c = b[1] * b[1] + m * a[0] * a[0] * b[0] * b[0];
	              return [
	                [a[0] * b[2] / c, a[1] * a[2] * b[0] * b[1] / c],
	                [a[1] * b[1] / c, -a[0] * a[2] * b[0] * b[2] / c],
	                [a[2] * b[1] * b[2] / c, -m * a[0] * a[1] * b[0] / c]
	              ];
	            }
	            function ellipticJ(u, m) {
	              var ai, b, phi, t, twon;
	              if (m < epsilon) {
	                t = sin(u);
	                b = cos(u);
	                ai = m * (u - t * b) / 4;
	                return [
	                  t - ai * b,
	                  b + ai * t,
	                  1 - m * t * t / 2,
	                  u - ai
	                ];
	              }
	              if (m >= 1 - epsilon) {
	                ai = (1 - m) / 4;
	                b = cosh(u);
	                t = tanh(u);
	                phi = 1 / b;
	                twon = b * sinh(u);
	                return [
	                  t + ai * (twon - u) / (b * b),
	                  phi - ai * t * phi * (twon - u),
	                  phi + ai * t * phi * (twon + u),
	                  2 * atan(exp(u)) - halfPi + ai * (twon - u) / b
	                ];
	              }
	              var a = [1, 0, 0, 0, 0, 0, 0, 0, 0], c = [sqrt(m), 0, 0, 0, 0, 0, 0, 0, 0], i = 0;
	              b = sqrt(1 - m);
	              twon = 1;
	              while (abs(c[i] / a[i]) > epsilon && i < 8) {
	                ai = a[i++];
	                c[i] = (ai - b) / 2;
	                a[i] = (ai + b) / 2;
	                b = sqrt(ai * b);
	                twon *= 2;
	              }
	              phi = twon * a[i] * u;
	              do {
	                t = c[i] * sin(b = phi) / a[i];
	                phi = (asin(t) + phi) / 2;
	              } while (--i);
	              return [sin(phi), t = cos(phi), t / cos(phi - b), phi];
	            }
	            function ellipticFi(phi, psi, m) {
	              var r = abs(phi), i = abs(psi), sinhPsi = sinh(i);
	              if (r) {
	                var cscPhi = 1 / sin(r), cotPhi2 = 1 / (tan(r) * tan(r)), b = -(cotPhi2 + m * (sinhPsi * sinhPsi * cscPhi * cscPhi) - 1 + m), c = (m - 1) * cotPhi2, cotLambda2 = (-b + sqrt(b * b - 4 * c)) / 2;
	                return [
	                  ellipticF(atan(1 / sqrt(cotLambda2)), m) * sign(phi),
	                  ellipticF(atan(sqrt((cotLambda2 / cotPhi2 - 1) / m)), 1 - m) * sign(psi)
	                ];
	              }
	              return [
	                0,
	                ellipticF(atan(sinhPsi), 1 - m) * sign(psi)
	              ];
	            }
	            function ellipticF(phi, m) {
	              if (!m) return phi;
	              if (m === 1) return log(tan(phi / 2 + quarterPi));
	              var a = 1, b = sqrt(1 - m), c = sqrt(m);
	              for (var i = 0; abs(c) > epsilon; i++) {
	                if (phi % pi) {
	                  var dPhi = atan(b * tan(phi) / a);
	                  if (dPhi < 0) dPhi += pi;
	                  phi += dPhi + ~~(phi / pi) * pi;
	                } else phi += phi;
	                c = (a + b) / 2;
	                b = sqrt(a * b);
	                c = ((a = c) - b) / 2;
	              }
	              return phi / (pow(2, i) * a);
	            }
	            function guyouRaw(lambda, phi) {
	              var k_ = (sqrt2 - 1) / (sqrt2 + 1), k2 = sqrt(1 - k_ * k_), K2 = ellipticF(halfPi, k2 * k2), f = -1, psi = log(tan(pi / 4 + abs(phi) / 2)), r = exp(f * psi) / sqrt(k_), at = guyouComplexAtan(r * cos(f * lambda), r * sin(f * lambda)), t = ellipticFi(at[0], at[1], k2 * k2);
	              return [-t[1], (phi >= 0 ? 1 : -1) * (0.5 * K2 - t[0])];
	            }
	            function guyouComplexAtan(x, y) {
	              var x2 = x * x, y_1 = y + 1, t = 1 - x2 - y * y;
	              return [
	                0.5 * ((x >= 0 ? halfPi : -halfPi) - atan2(t, 2 * x)),
	                -0.25 * log(t * t + 4 * x2) + 0.5 * log(y_1 * y_1 + x2)
	              ];
	            }
	            function guyouComplexDivide(a, b) {
	              var denominator = b[0] * b[0] + b[1] * b[1];
	              return [
	                (a[0] * b[0] + a[1] * b[1]) / denominator,
	                (a[1] * b[0] - a[0] * b[1]) / denominator
	              ];
	            }
	            guyouRaw.invert = function(x, y) {
	              var k_ = (sqrt2 - 1) / (sqrt2 + 1), k2 = sqrt(1 - k_ * k_), K2 = ellipticF(halfPi, k2 * k2), f = -1, j = ellipticJi(0.5 * K2 - y, -x, k2 * k2), tn = guyouComplexDivide(j[0], j[1]), lambda = atan2(tn[1], tn[0]) / f;
	              return [
	                lambda,
	                2 * atan(exp(0.5 / f * log(k_ * tn[0] * tn[0] + k_ * tn[1] * tn[1]))) - halfPi
	              ];
	            };
	            function guyou() {
	              return (0, src_projection.Z)(square(guyouRaw)).scale(151.496);
	            }
	            var src_circle = __webpack_require__2(7613);
	            function hammerRetroazimuthalRaw(phi02) {
	              var sinPhi0 = sin(phi02), cosPhi0 = cos(phi02), rotate = hammerRetroazimuthalRotation(phi02);
	              rotate.invert = hammerRetroazimuthalRotation(-phi02);
	              function forward(lambda, phi) {
	                var p = rotate(lambda, phi);
	                lambda = p[0], phi = p[1];
	                var sinPhi = sin(phi), cosPhi = cos(phi), cosLambda = cos(lambda), z = acos(sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosLambda), sinz = sin(z), K2 = abs(sinz) > epsilon ? z / sinz : 1;
	                return [
	                  K2 * cosPhi0 * sin(lambda),
	                  (abs(lambda) > halfPi ? K2 : -K2) * (sinPhi0 * cosPhi - cosPhi0 * sinPhi * cosLambda)
	                ];
	              }
	              forward.invert = function(x, y) {
	                var rho = sqrt(x * x + y * y), sinz = -sin(rho), cosz = cos(rho), a = rho * cosz, b = -y * sinz, c = rho * sinPhi0, d = sqrt(a * a + b * b - c * c), phi = atan2(a * c + b * d, b * c - a * d), lambda = (rho > halfPi ? -1 : 1) * atan2(x * sinz, rho * cos(phi) * cosz + y * sin(phi) * sinz);
	                return rotate.invert(lambda, phi);
	              };
	              return forward;
	            }
	            function hammerRetroazimuthalRotation(phi02) {
	              var sinPhi0 = sin(phi02), cosPhi0 = cos(phi02);
	              return function(lambda, phi) {
	                var cosPhi = cos(phi), x = cos(lambda) * cosPhi, y = sin(lambda) * cosPhi, z = sin(phi);
	                return [
	                  atan2(y, x * cosPhi0 - z * sinPhi0),
	                  asin(z * cosPhi0 + x * sinPhi0)
	                ];
	              };
	            }
	            function hammerRetroazimuthal() {
	              var phi02 = 0, m = (0, src_projection.r)(hammerRetroazimuthalRaw), p = m(phi02), rotate_ = p.rotate, stream_ = p.stream, circle = (0, src_circle.Z)();
	              p.parallel = function(_) {
	                if (!arguments.length) return phi02 * degrees;
	                var r = p.rotate();
	                return m(phi02 = _ * radians).rotate(r);
	              };
	              p.rotate = function(_) {
	                if (!arguments.length) return _ = rotate_.call(p), _[1] += phi02 * degrees, _;
	                rotate_.call(p, [_[0], _[1] - phi02 * degrees]);
	                circle.center([-_[0], -_[1]]);
	                return p;
	              };
	              p.stream = function(stream) {
	                stream = stream_(stream);
	                stream.sphere = function() {
	                  stream.polygonStart();
	                  var epsilon3 = 0.01, ring = circle.radius(90 - epsilon3)().coordinates[0], n = ring.length - 1, i = -1, p2;
	                  stream.lineStart();
	                  while (++i < n) stream.point((p2 = ring[i])[0], p2[1]);
	                  stream.lineEnd();
	                  ring = circle.radius(90 + epsilon3)().coordinates[0];
	                  n = ring.length - 1;
	                  stream.lineStart();
	                  while (--i >= 0) stream.point((p2 = ring[i])[0], p2[1]);
	                  stream.lineEnd();
	                  stream.polygonEnd();
	                };
	                return stream;
	              };
	              return p.scale(79.4187).parallel(45).clipAngle(180 - 1e-3);
	            }
	            var src = __webpack_require__2(33064);
	            var src_stream = __webpack_require__2(72736);
	            var K = 3, healpixParallel = asin(1 - 1 / K) * degrees, healpixLambert = cylindricalEqualAreaRaw(0);
	            function healpixRaw(H) {
	              var phi02 = healpixParallel * radians, dx = collignonRaw(pi, phi02)[0] - collignonRaw(-pi, phi02)[0], y02 = healpixLambert(0, phi02)[1], y12 = collignonRaw(0, phi02)[1], dy1 = sqrtPi - y12, k2 = tau / H, w2 = 4 / tau, h = y02 + dy1 * dy1 * 4 / tau;
	              function forward(lambda, phi) {
	                var point, phi2 = abs(phi);
	                if (phi2 > phi02) {
	                  var i = min(H - 1, max(0, floor((lambda + pi) / k2)));
	                  lambda += pi * (H - 1) / H - i * k2;
	                  point = collignonRaw(lambda, phi2);
	                  point[0] = point[0] * tau / dx - tau * (H - 1) / (2 * H) + i * tau / H;
	                  point[1] = y02 + (point[1] - y12) * 4 * dy1 / tau;
	                  if (phi < 0) point[1] = -point[1];
	                } else {
	                  point = healpixLambert(lambda, phi);
	                }
	                point[0] *= w2, point[1] /= h;
	                return point;
	              }
	              forward.invert = function(x, y) {
	                x /= w2, y *= h;
	                var y2 = abs(y);
	                if (y2 > y02) {
	                  var i = min(H - 1, max(0, floor((x + pi) / k2)));
	                  x = (x + pi * (H - 1) / H - i * k2) * dx / tau;
	                  var point = collignonRaw.invert(x, 0.25 * (y2 - y02) * tau / dy1 + y12);
	                  point[0] -= pi * (H - 1) / H - i * k2;
	                  if (y < 0) point[1] = -point[1];
	                  return point;
	                }
	                return healpixLambert.invert(x, y);
	              };
	              return forward;
	            }
	            function sphereTop(x, i) {
	              return [x, i & 1 ? 90 - epsilon : healpixParallel];
	            }
	            function sphereBottom(x, i) {
	              return [x, i & 1 ? -90 + epsilon : -healpixParallel];
	            }
	            function sphereNudge(d) {
	              return [d[0] * (1 - epsilon), d[1]];
	            }
	            function sphere(step) {
	              var c = [].concat(
	                (0, src.w6)(-180, 180 + step / 2, step).map(sphereTop),
	                (0, src.w6)(180, -180 - step / 2, -step).map(sphereBottom)
	              );
	              return {
	                type: "Polygon",
	                coordinates: [step === 180 ? c.map(sphereNudge) : c]
	              };
	            }
	            function healpix() {
	              var H = 4, m = (0, src_projection.r)(healpixRaw), p = m(H), stream_ = p.stream;
	              p.lobes = function(_) {
	                return arguments.length ? m(H = +_) : H;
	              };
	              p.stream = function(stream) {
	                var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([0, 0]), stream_(stream));
	                p.rotate(rotate);
	                rotateStream.sphere = function() {
	                  (0, src_stream.Z)(sphere(180 / H), sphereStream);
	                };
	                return rotateStream;
	              };
	              return p.scale(239.75);
	            }
	            function hillRaw(K2) {
	              var L = 1 + K2, sinBt = sin(1 / L), Bt = asin(sinBt), A2 = 2 * sqrt(pi / (B2 = pi + 4 * Bt * L)), B2, rho0 = 0.5 * A2 * (L + sqrt(K2 * (2 + K2))), K22 = K2 * K2, L2 = L * L;
	              function forward(lambda, phi) {
	                var t = 1 - sin(phi), rho, omega;
	                if (t && t < 2) {
	                  var theta = halfPi - phi, i = 25, delta;
	                  do {
	                    var sinTheta = sin(theta), cosTheta = cos(theta), Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta), C = 1 + L2 - 2 * L * cosTheta;
	                    theta -= delta = (theta - K22 * Bt - L * sinTheta + C * Bt_Bt1 - 0.5 * t * B2) / (2 * L * sinTheta * Bt_Bt1);
	                  } while (abs(delta) > epsilon2 && --i > 0);
	                  rho = A2 * sqrt(C);
	                  omega = lambda * Bt_Bt1 / pi;
	                } else {
	                  rho = A2 * (K2 + t);
	                  omega = lambda * Bt / pi;
	                }
	                return [
	                  rho * sin(omega),
	                  rho0 - rho * cos(omega)
	                ];
	              }
	              forward.invert = function(x, y) {
	                var rho2 = x * x + (y -= rho0) * y, cosTheta = (1 + L2 - rho2 / (A2 * A2)) / (2 * L), theta = acos(cosTheta), sinTheta = sin(theta), Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta);
	                return [
	                  asin(x / sqrt(rho2)) * pi / Bt_Bt1,
	                  asin(1 - 2 * (theta - K22 * Bt - L * sinTheta + (1 + L2 - 2 * L * cosTheta) * Bt_Bt1) / B2)
	                ];
	              };
	              return forward;
	            }
	            function hill() {
	              var K2 = 1, m = (0, src_projection.r)(hillRaw), p = m(K2);
	              p.ratio = function(_) {
	                return arguments.length ? m(K2 = +_) : K2;
	              };
	              return p.scale(167.774).center([0, 18.67]);
	            }
	            var sinuMollweidePhi = 0.7109889596207567;
	            var sinuMollweideY = 0.0528035274542;
	            function sinuMollweideRaw(lambda, phi) {
	              return phi > -0.7109889596207567 ? (lambda = mollweideRaw(lambda, phi), lambda[1] += sinuMollweideY, lambda) : sinusoidalRaw(lambda, phi);
	            }
	            sinuMollweideRaw.invert = function(x, y) {
	              return y > -0.7109889596207567 ? mollweideRaw.invert(x, y - sinuMollweideY) : sinusoidalRaw.invert(x, y);
	            };
	            function sinuMollweide() {
	              return (0, src_projection.Z)(sinuMollweideRaw).rotate([-20, -55]).scale(164.263).center([0, -5.4036]);
	            }
	            function homolosineRaw(lambda, phi) {
	              return abs(phi) > sinuMollweidePhi ? (lambda = mollweideRaw(lambda, phi), lambda[1] -= phi > 0 ? sinuMollweideY : -0.0528035274542, lambda) : sinusoidalRaw(lambda, phi);
	            }
	            homolosineRaw.invert = function(x, y) {
	              return abs(y) > sinuMollweidePhi ? mollweideRaw.invert(x, y + (y > 0 ? sinuMollweideY : -0.0528035274542)) : sinusoidalRaw.invert(x, y);
	            };
	            function homolosine() {
	              return (0, src_projection.Z)(homolosineRaw).scale(152.63);
	            }
	            function hufnagelRaw(a, b, psiMax, ratio) {
	              var k2 = sqrt(
	                4 * pi / (2 * psiMax + (1 + a - b / 2) * sin(2 * psiMax) + (a + b) / 2 * sin(4 * psiMax) + b / 2 * sin(6 * psiMax))
	              ), c = sqrt(
	                ratio * sin(psiMax) * sqrt((1 + a * cos(2 * psiMax) + b * cos(4 * psiMax)) / (1 + a + b))
	              ), M = psiMax * mapping(1);
	              function radius(psi) {
	                return sqrt(1 + a * cos(2 * psi) + b * cos(4 * psi));
	              }
	              function mapping(t) {
	                var psi = t * psiMax;
	                return (2 * psi + (1 + a - b / 2) * sin(2 * psi) + (a + b) / 2 * sin(4 * psi) + b / 2 * sin(6 * psi)) / psiMax;
	              }
	              function inversemapping(psi) {
	                return radius(psi) * sin(psi);
	              }
	              var forward = function(lambda, phi) {
	                var psi = psiMax * solve(mapping, M * sin(phi) / psiMax, phi / pi);
	                if (isNaN(psi)) psi = psiMax * sign(phi);
	                var kr = k2 * radius(psi);
	                return [kr * c * lambda / pi * cos(psi), kr / c * sin(psi)];
	              };
	              forward.invert = function(x, y) {
	                var psi = solve(inversemapping, y * c / k2);
	                return [
	                  x * pi / (cos(psi) * k2 * c * radius(psi)),
	                  asin(psiMax * mapping(psi / psiMax) / M)
	                ];
	              };
	              if (psiMax === 0) {
	                k2 = sqrt(ratio / pi);
	                forward = function(lambda, phi) {
	                  return [lambda * k2, sin(phi) / k2];
	                };
	                forward.invert = function(x, y) {
	                  return [x / k2, asin(y * k2)];
	                };
	              }
	              return forward;
	            }
	            function hufnagel() {
	              var a = 1, b = 0, psiMax = 45 * radians, ratio = 2, mutate = (0, src_projection.r)(hufnagelRaw), projection = mutate(a, b, psiMax, ratio);
	              projection.a = function(_) {
	                return arguments.length ? mutate(a = +_, b, psiMax, ratio) : a;
	              };
	              projection.b = function(_) {
	                return arguments.length ? mutate(a, b = +_, psiMax, ratio) : b;
	              };
	              projection.psiMax = function(_) {
	                return arguments.length ? mutate(a, b, psiMax = +_ * radians, ratio) : psiMax * degrees;
	              };
	              projection.ratio = function(_) {
	                return arguments.length ? mutate(a, b, psiMax, ratio = +_) : ratio;
	              };
	              return projection.scale(180.739);
	            }
	            function adsimp(f, a, b, fa, fm, fb, V0, tol, maxdepth, depth, state) {
	              if (state.nanEncountered) {
	                return NaN;
	              }
	              var h, f1, f2, sl, sr, s2, m, V1, V2, err;
	              h = b - a;
	              f1 = f(a + h * 0.25);
	              f2 = f(b - h * 0.25);
	              if (isNaN(f1)) {
	                state.nanEncountered = true;
	                return;
	              }
	              if (isNaN(f2)) {
	                state.nanEncountered = true;
	                return;
	              }
	              sl = h * (fa + 4 * f1 + fm) / 12;
	              sr = h * (fm + 4 * f2 + fb) / 12;
	              s2 = sl + sr;
	              err = (s2 - V0) / 15;
	              if (depth > maxdepth) {
	                state.maxDepthCount++;
	                return s2 + err;
	              } else if (Math.abs(err) < tol) {
	                return s2 + err;
	              } else {
	                m = a + h * 0.5;
	                V1 = adsimp(f, a, m, fa, f1, fm, sl, tol * 0.5, maxdepth, depth + 1, state);
	                if (isNaN(V1)) {
	                  state.nanEncountered = true;
	                  return NaN;
	                }
	                V2 = adsimp(f, m, b, fm, f2, fb, sr, tol * 0.5, maxdepth, depth + 1, state);
	                if (isNaN(V2)) {
	                  state.nanEncountered = true;
	                  return NaN;
	                }
	                return V1 + V2;
	              }
	            }
	            function integrate(f, a, b, tol, maxdepth) {
	              var state = {
	                maxDepthCount: 0,
	                nanEncountered: false
	              };
	              if (maxdepth === undefined) {
	                maxdepth = 20;
	              }
	              var fa = f(a);
	              var fm = f(0.5 * (a + b));
	              var fb = f(b);
	              var V0 = (fa + 4 * fm + fb) * (b - a) / 6;
	              var result = adsimp(f, a, b, fa, fm, fb, V0, tol, maxdepth, 1, state);
	              return result;
	            }
	            function hyperellipticalRaw(alpha, k2, gamma) {
	              function elliptic(f) {
	                return alpha + (1 - alpha) * pow(1 - pow(f, k2), 1 / k2);
	              }
	              function z(f) {
	                return integrate(elliptic, 0, f, 1e-4);
	              }
	              var G = 1 / z(1), n = 1e3, m = (1 + 1e-8) * G, approx = [];
	              for (var i = 0; i <= n; i++)
	                approx.push(z(i / n) * m);
	              function Y(sinphi) {
	                var rmin = 0, rmax = n, r = n >> 1;
	                do {
	                  if (approx[r] > sinphi) rmax = r;
	                  else rmin = r;
	                  r = rmin + rmax >> 1;
	                } while (r > rmin);
	                var u = approx[r + 1] - approx[r];
	                if (u) u = (sinphi - approx[r + 1]) / u;
	                return (r + 1 + u) / n;
	              }
	              var ratio = 2 * Y(1) / pi * G / gamma;
	              var forward = function(lambda, phi) {
	                var y = Y(abs(sin(phi))), x = elliptic(y) * lambda;
	                y /= ratio;
	                return [x, phi >= 0 ? y : -y];
	              };
	              forward.invert = function(x, y) {
	                var phi;
	                y *= ratio;
	                if (abs(y) < 1) phi = sign(y) * asin(z(abs(y)) * G);
	                return [x / elliptic(abs(y)), phi];
	              };
	              return forward;
	            }
	            function hyperelliptical() {
	              var alpha = 0, k2 = 2.5, gamma = 1.183136, m = (0, src_projection.r)(hyperellipticalRaw), p = m(alpha, k2, gamma);
	              p.alpha = function(_) {
	                return arguments.length ? m(alpha = +_, k2, gamma) : alpha;
	              };
	              p.k = function(_) {
	                return arguments.length ? m(alpha, k2 = +_, gamma) : k2;
	              };
	              p.gamma = function(_) {
	                return arguments.length ? m(alpha, k2, gamma = +_) : gamma;
	              };
	              return p.scale(152.63);
	            }
	            function pointEqual(a, b) {
	              return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	            }
	            function interpolateLine(coordinates, m) {
	              var i = -1, n = coordinates.length, p0 = coordinates[0], p1, dx, dy, resampled = [];
	              while (++i < n) {
	                p1 = coordinates[i];
	                dx = (p1[0] - p0[0]) / m;
	                dy = (p1[1] - p0[1]) / m;
	                for (var j = 0; j < m; ++j) resampled.push([p0[0] + j * dx, p0[1] + j * dy]);
	                p0 = p1;
	              }
	              resampled.push(p1);
	              return resampled;
	            }
	            function interpolateSphere(lobes2) {
	              var coordinates = [], lobe, lambda0, phi02, phi1, lambda2, phi2, i, n = lobes2[0].length;
	              for (i = 0; i < n; ++i) {
	                lobe = lobes2[0][i];
	                lambda0 = lobe[0][0], phi02 = lobe[0][1], phi1 = lobe[1][1];
	                lambda2 = lobe[2][0], phi2 = lobe[2][1];
	                coordinates.push(interpolateLine([
	                  [lambda0 + epsilon, phi02 + epsilon],
	                  [lambda0 + epsilon, phi1 - epsilon],
	                  [lambda2 - epsilon, phi1 - epsilon],
	                  [lambda2 - epsilon, phi2 + epsilon]
	                ], 30));
	              }
	              for (i = lobes2[1].length - 1; i >= 0; --i) {
	                lobe = lobes2[1][i];
	                lambda0 = lobe[0][0], phi02 = lobe[0][1], phi1 = lobe[1][1];
	                lambda2 = lobe[2][0], phi2 = lobe[2][1];
	                coordinates.push(interpolateLine([
	                  [lambda2 - epsilon, phi2 - epsilon],
	                  [lambda2 - epsilon, phi1 + epsilon],
	                  [lambda0 + epsilon, phi1 + epsilon],
	                  [lambda0 + epsilon, phi02 - epsilon]
	                ], 30));
	              }
	              return {
	                type: "Polygon",
	                coordinates: [(0, src.TS)(coordinates)]
	              };
	            }
	            function interrupted(project2, lobes2, inverse2) {
	              var sphere2, bounds2;
	              function forward(lambda, phi) {
	                var sign2 = phi < 0 ? -1 : 1, lobe = lobes2[+(phi < 0)];
	                for (var i = 0, n = lobe.length - 1; i < n && lambda > lobe[i][2][0]; ++i) ;
	                var p2 = project2(lambda - lobe[i][1][0], phi);
	                p2[0] += project2(lobe[i][1][0], sign2 * phi > sign2 * lobe[i][0][1] ? lobe[i][0][1] : phi)[0];
	                return p2;
	              }
	              if (inverse2) {
	                forward.invert = inverse2(forward);
	              } else if (project2.invert) {
	                forward.invert = function(x, y) {
	                  var bound = bounds2[+(y < 0)], lobe = lobes2[+(y < 0)];
	                  for (var i = 0, n = bound.length; i < n; ++i) {
	                    var b = bound[i];
	                    if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
	                      var p2 = project2.invert(x - project2(lobe[i][1][0], 0)[0], y);
	                      p2[0] += lobe[i][1][0];
	                      return pointEqual(forward(p2[0], p2[1]), [x, y]) ? p2 : null;
	                    }
	                  }
	                };
	              }
	              var p = (0, src_projection.Z)(forward), stream_ = p.stream;
	              p.stream = function(stream) {
	                var rotate = p.rotate(), rotateStream = stream_(stream), sphereStream = (p.rotate([0, 0]), stream_(stream));
	                p.rotate(rotate);
	                rotateStream.sphere = function() {
	                  (0, src_stream.Z)(sphere2, sphereStream);
	                };
	                return rotateStream;
	              };
	              p.lobes = function(_) {
	                if (!arguments.length) return lobes2.map(function(lobe) {
	                  return lobe.map(function(l) {
	                    return [
	                      [l[0][0] * degrees, l[0][1] * degrees],
	                      [l[1][0] * degrees, l[1][1] * degrees],
	                      [l[2][0] * degrees, l[2][1] * degrees]
	                    ];
	                  });
	                });
	                sphere2 = interpolateSphere(_);
	                lobes2 = _.map(function(lobe) {
	                  return lobe.map(function(l) {
	                    return [
	                      [l[0][0] * radians, l[0][1] * radians],
	                      [l[1][0] * radians, l[1][1] * radians],
	                      [l[2][0] * radians, l[2][1] * radians]
	                    ];
	                  });
	                });
	                bounds2 = lobes2.map(function(lobe) {
	                  return lobe.map(function(l) {
	                    var x02 = project2(l[0][0], l[0][1])[0], x12 = project2(l[2][0], l[2][1])[0], y02 = project2(l[1][0], l[0][1])[1], y12 = project2(l[1][0], l[1][1])[1], t;
	                    if (y02 > y12) t = y02, y02 = y12, y12 = t;
	                    return [[x02, y02], [x12, y12]];
	                  });
	                });
	                return p;
	              };
	              if (lobes2 != null) p.lobes(lobes2);
	              return p;
	            }
	            var lobes = [[
	              // northern hemisphere
	              [[-180, 0], [-100, 90], [-40, 0]],
	              [[-40, 0], [30, 90], [180, 0]]
	            ], [
	              // southern hemisphere
	              [[-180, 0], [-160, -90], [-100, 0]],
	              [[-100, 0], [-60, -90], [-20, 0]],
	              [[-20, 0], [20, -90], [80, 0]],
	              [[80, 0], [140, -90], [180, 0]]
	            ]];
	            function interrupted_boggs() {
	              return interrupted(boggsRaw, lobes).scale(160.857);
	            }
	            var homolosine_lobes = [[
	              // northern hemisphere
	              [[-180, 0], [-100, 90], [-40, 0]],
	              [[-40, 0], [30, 90], [180, 0]]
	            ], [
	              // southern hemisphere
	              [[-180, 0], [-160, -90], [-100, 0]],
	              [[-100, 0], [-60, -90], [-20, 0]],
	              [[-20, 0], [20, -90], [80, 0]],
	              [[80, 0], [140, -90], [180, 0]]
	            ]];
	            function interrupted_homolosine() {
	              return interrupted(homolosineRaw, homolosine_lobes).scale(152.63);
	            }
	            var mollweide_lobes = [[
	              // northern hemisphere
	              [[-180, 0], [-100, 90], [-40, 0]],
	              [[-40, 0], [30, 90], [180, 0]]
	            ], [
	              // southern hemisphere
	              [[-180, 0], [-160, -90], [-100, 0]],
	              [[-100, 0], [-60, -90], [-20, 0]],
	              [[-20, 0], [20, -90], [80, 0]],
	              [[80, 0], [140, -90], [180, 0]]
	            ]];
	            function interrupted_mollweide() {
	              return interrupted(mollweideRaw, mollweide_lobes).scale(169.529);
	            }
	            var mollweideHemispheres_lobes = [[
	              // northern hemisphere
	              [[-180, 0], [-90, 90], [0, 0]],
	              [[0, 0], [90, 90], [180, 0]]
	            ], [
	              // southern hemisphere
	              [[-180, 0], [-90, -90], [0, 0]],
	              [[0, 0], [90, -90], [180, 0]]
	            ]];
	            function mollweideHemispheres() {
	              return interrupted(mollweideRaw, mollweideHemispheres_lobes).scale(169.529).rotate([20, 0]);
	            }
	            var sinuMollweide_lobes = [[
	              // northern hemisphere
	              [[-180, 35], [-30, 90], [0, 35]],
	              [[0, 35], [30, 90], [180, 35]]
	            ], [
	              // southern hemisphere
	              [[-180, -10], [-102, -90], [-65, -10]],
	              [[-65, -10], [5, -90], [77, -10]],
	              [[77, -10], [103, -90], [180, -10]]
	            ]];
	            function interrupted_sinuMollweide() {
	              return interrupted(sinuMollweideRaw, sinuMollweide_lobes, solve2d).rotate([-20, -55]).scale(164.263).center([0, -5.4036]);
	            }
	            var sinusoidal_lobes = [[
	              // northern hemisphere
	              [[-180, 0], [-110, 90], [-40, 0]],
	              [[-40, 0], [0, 90], [40, 0]],
	              [[40, 0], [110, 90], [180, 0]]
	            ], [
	              // southern hemisphere
	              [[-180, 0], [-110, -90], [-40, 0]],
	              [[-40, 0], [0, -90], [40, 0]],
	              [[40, 0], [110, -90], [180, 0]]
	            ]];
	            function interrupted_sinusoidal() {
	              return interrupted(sinusoidalRaw, sinusoidal_lobes).scale(152.63).rotate([-20, 0]);
	            }
	            function kavrayskiy7Raw(lambda, phi) {
	              return [3 / tau * lambda * sqrt(pi * pi / 3 - phi * phi), phi];
	            }
	            kavrayskiy7Raw.invert = function(x, y) {
	              return [tau / 3 * x / sqrt(pi * pi / 3 - y * y), y];
	            };
	            function kavrayskiy7() {
	              return (0, src_projection.Z)(kavrayskiy7Raw).scale(158.837);
	            }
	            function lagrangeRaw(n) {
	              function forward(lambda, phi) {
	                if (abs(abs(phi) - halfPi) < epsilon) return [0, phi < 0 ? -2 : 2];
	                var sinPhi = sin(phi), v = pow((1 + sinPhi) / (1 - sinPhi), n / 2), c = 0.5 * (v + 1 / v) + cos(lambda *= n);
	                return [
	                  2 * sin(lambda) / c,
	                  (v - 1 / v) / c
	                ];
	              }
	              forward.invert = function(x, y) {
	                var y02 = abs(y);
	                if (abs(y02 - 2) < epsilon) return x ? null : [0, sign(y) * halfPi];
	                if (y02 > 2) return null;
	                x /= 2, y /= 2;
	                var x2 = x * x, y2 = y * y, t = 2 * y / (1 + x2 + y2);
	                t = pow((1 + t) / (1 - t), 1 / n);
	                return [
	                  atan2(2 * x, 1 - x2 - y2) / n,
	                  asin((t - 1) / (t + 1))
	                ];
	              };
	              return forward;
	            }
	            function lagrange() {
	              var n = 0.5, m = (0, src_projection.r)(lagrangeRaw), p = m(n);
	              p.spacing = function(_) {
	                return arguments.length ? m(n = +_) : n;
	              };
	              return p.scale(124.75);
	            }
	            var pi_sqrt2 = pi / sqrt2;
	            function larriveeRaw(lambda, phi) {
	              return [
	                lambda * (1 + sqrt(cos(phi))) / 2,
	                phi / (cos(phi / 2) * cos(lambda / 6))
	              ];
	            }
	            larriveeRaw.invert = function(x, y) {
	              var x02 = abs(x), y02 = abs(y), lambda = epsilon, phi = halfPi;
	              if (y02 < pi_sqrt2) phi *= y02 / pi_sqrt2;
	              else lambda += 6 * acos(pi_sqrt2 / y02);
	              for (var i = 0; i < 25; i++) {
	                var sinPhi = sin(phi), sqrtcosPhi = sqrt(cos(phi)), sinPhi_2 = sin(phi / 2), cosPhi_2 = cos(phi / 2), sinLambda_6 = sin(lambda / 6), cosLambda_6 = cos(lambda / 6), f0 = 0.5 * lambda * (1 + sqrtcosPhi) - x02, f1 = phi / (cosPhi_2 * cosLambda_6) - y02, df0dPhi = sqrtcosPhi ? -0.25 * lambda * sinPhi / sqrtcosPhi : 0, df0dLambda = 0.5 * (1 + sqrtcosPhi), df1dPhi = (1 + 0.5 * phi * sinPhi_2 / cosPhi_2) / (cosPhi_2 * cosLambda_6), df1dLambda = phi / cosPhi_2 * (sinLambda_6 / 6) / (cosLambda_6 * cosLambda_6), denom = df0dPhi * df1dLambda - df1dPhi * df0dLambda, dPhi = (f0 * df1dLambda - f1 * df0dLambda) / denom, dLambda = (f1 * df0dPhi - f0 * df1dPhi) / denom;
	                phi -= dPhi;
	                lambda -= dLambda;
	                if (abs(dPhi) < epsilon && abs(dLambda) < epsilon) break;
	              }
	              return [x < 0 ? -lambda : lambda, y < 0 ? -phi : phi];
	            };
	            function larrivee() {
	              return (0, src_projection.Z)(larriveeRaw).scale(97.2672);
	            }
	            function laskowskiRaw(lambda, phi) {
	              var lambda2 = lambda * lambda, phi2 = phi * phi;
	              return [
	                lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)),
	                phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 199025e-9) + phi2 * (0.0998909 + phi2 * -0.0491032))
	              ];
	            }
	            laskowskiRaw.invert = function(x, y) {
	              var lambda = sign(x) * pi, phi = y / 2, i = 50;
	              do {
	                var lambda2 = lambda * lambda, phi2 = phi * phi, lambdaPhi = lambda * phi, fx = lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)) - x, fy = phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 199025e-9) + phi2 * (0.0998909 + phi2 * -0.0491032)) - y, deltaxDeltaLambda = 0.975534 - phi2 * (0.119161 + 3 * lambda2 * 0.0143059 + phi2 * 0.0547009), deltaxDeltaPhi = -lambdaPhi * (2 * 0.119161 + 4 * 0.0547009 * phi2 + 2 * 0.0143059 * lambda2), deltayDeltaLambda = lambdaPhi * (2 * 0.0802894 + 4 * 199025e-9 * lambda2 + 2 * -0.02855 * phi2), deltayDeltaPhi = 1.00384 + lambda2 * (0.0802894 + 199025e-9 * lambda2) + phi2 * (3 * (0.0998909 - 0.02855 * lambda2) - 5 * 0.0491032 * phi2), denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda, deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator, deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	                lambda -= deltaLambda, phi -= deltaPhi;
	              } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	              return i && [lambda, phi];
	            };
	            function laskowski() {
	              return (0, src_projection.Z)(laskowskiRaw).scale(139.98);
	            }
	            function littrowRaw(lambda, phi) {
	              return [
	                sin(lambda) / cos(phi),
	                tan(phi) * cos(lambda)
	              ];
	            }
	            littrowRaw.invert = function(x, y) {
	              var x2 = x * x, y2 = y * y, y2_1 = y2 + 1, x2_y2_1 = x2 + y2_1, cosPhi = x ? sqrt1_2 * sqrt((x2_y2_1 - sqrt(x2_y2_1 * x2_y2_1 - 4 * x2)) / x2) : 1 / sqrt(y2_1);
	              return [
	                asin(x * cosPhi),
	                sign(y) * acos(cosPhi)
	              ];
	            };
	            function littrow() {
	              return (0, src_projection.Z)(littrowRaw).scale(144.049).clipAngle(90 - 1e-3);
	            }
	            function loximuthalRaw(phi02) {
	              var cosPhi0 = cos(phi02), tanPhi0 = tan(quarterPi + phi02 / 2);
	              function forward(lambda, phi) {
	                var y = phi - phi02, x = abs(y) < epsilon ? lambda * cosPhi0 : abs(x = quarterPi + phi / 2) < epsilon || abs(abs(x) - halfPi) < epsilon ? 0 : lambda * y / log(tan(x) / tanPhi0);
	                return [x, y];
	              }
	              forward.invert = function(x, y) {
	                var lambda, phi = y + phi02;
	                return [
	                  abs(y) < epsilon ? x / cosPhi0 : abs(lambda = quarterPi + phi / 2) < epsilon || abs(abs(lambda) - halfPi) < epsilon ? 0 : x * log(tan(lambda) / tanPhi0) / y,
	                  phi
	                ];
	              };
	              return forward;
	            }
	            function loximuthal() {
	              return parallel1(loximuthalRaw).parallel(40).scale(158.837);
	            }
	            function millerRaw(lambda, phi) {
	              return [lambda, 1.25 * log(tan(quarterPi + 0.4 * phi))];
	            }
	            millerRaw.invert = function(x, y) {
	              return [x, 2.5 * atan(exp(0.8 * y)) - 0.625 * pi];
	            };
	            function miller() {
	              return (0, src_projection.Z)(millerRaw).scale(108.318);
	            }
	            function modifiedStereographicRaw(C) {
	              var m = C.length - 1;
	              function forward(lambda, phi) {
	                var cosPhi = cos(phi), k2 = 2 / (1 + cosPhi * cos(lambda)), zr = k2 * cosPhi * sin(lambda), zi = k2 * sin(phi), i = m, w2 = C[i], ar = w2[0], ai = w2[1], t;
	                while (--i >= 0) {
	                  w2 = C[i];
	                  ar = w2[0] + zr * (t = ar) - zi * ai;
	                  ai = w2[1] + zr * ai + zi * t;
	                }
	                ar = zr * (t = ar) - zi * ai;
	                ai = zr * ai + zi * t;
	                return [ar, ai];
	              }
	              forward.invert = function(x, y) {
	                var i = 20, zr = x, zi = y;
	                do {
	                  var j = m, w2 = C[j], ar = w2[0], ai = w2[1], br = 0, bi = 0, t;
	                  while (--j >= 0) {
	                    w2 = C[j];
	                    br = ar + zr * (t = br) - zi * bi;
	                    bi = ai + zr * bi + zi * t;
	                    ar = w2[0] + zr * (t = ar) - zi * ai;
	                    ai = w2[1] + zr * ai + zi * t;
	                  }
	                  br = ar + zr * (t = br) - zi * bi;
	                  bi = ai + zr * bi + zi * t;
	                  ar = zr * (t = ar) - zi * ai - x;
	                  ai = zr * ai + zi * t - y;
	                  var denominator = br * br + bi * bi, deltar, deltai;
	                  zr -= deltar = (ar * br + ai * bi) / denominator;
	                  zi -= deltai = (ai * br - ar * bi) / denominator;
	                } while (abs(deltar) + abs(deltai) > epsilon * epsilon && --i > 0);
	                if (i) {
	                  var rho = sqrt(zr * zr + zi * zi), c = 2 * atan(rho * 0.5), sinc = sin(c);
	                  return [atan2(zr * sinc, rho * cos(c)), rho ? asin(zi * sinc / rho) : 0];
	                }
	              };
	              return forward;
	            }
	            var alaska = [[0.9972523, 0], [52513e-7, -41175e-7], [74606e-7, 48125e-7], [-0.0153783, -0.1968253], [0.0636871, -0.1408027], [0.3660976, -0.2937382]], gs48 = [[0.98879, 0], [0, 0], [-0.050909, 0], [0, 0], [0.075528, 0]], gs50 = [[0.984299, 0], [0.0211642, 37608e-7], [-0.1036018, -0.0575102], [-0.0329095, -0.0320119], [0.0499471, 0.1223335], [0.026046, 0.0899805], [7388e-7, -0.1435792], [75848e-7, -0.1334108], [-0.0216473, 0.0776645], [-0.0225161, 0.0853673]], modifiedStereographic_miller = [[0.9245, 0], [0, 0], [0.01943, 0]], lee = [[0.721316, 0], [0, 0], [-881625e-8, -617325e-8]];
	            function modifiedStereographicAlaska() {
	              return modifiedStereographic(alaska, [152, -64]).scale(1400).center([-160.908, 62.4864]).clipAngle(30).angle(7.8);
	            }
	            function modifiedStereographicGs48() {
	              return modifiedStereographic(gs48, [95, -38]).scale(1e3).clipAngle(55).center([-96.5563, 38.8675]);
	            }
	            function modifiedStereographicGs50() {
	              return modifiedStereographic(gs50, [120, -45]).scale(359.513).clipAngle(55).center([-117.474, 53.0628]);
	            }
	            function modifiedStereographicMiller() {
	              return modifiedStereographic(modifiedStereographic_miller, [-20, -18]).scale(209.091).center([20, 16.7214]).clipAngle(82);
	            }
	            function modifiedStereographicLee() {
	              return modifiedStereographic(lee, [165, 10]).scale(250).clipAngle(130).center([-165, -10]);
	            }
	            function modifiedStereographic(coefficients, rotate) {
	              var p = (0, src_projection.Z)(modifiedStereographicRaw(coefficients)).rotate(rotate).clipAngle(90), r = (0, rotation.Z)(rotate), center = p.center;
	              delete p.rotate;
	              p.center = function(_) {
	                return arguments.length ? center(r(_)) : r.invert(center());
	              };
	              return p;
	            }
	            var sqrt6 = sqrt(6), sqrt7 = sqrt(7);
	            function mtFlatPolarParabolicRaw(lambda, phi) {
	              var theta = asin(7 * sin(phi) / (3 * sqrt6));
	              return [
	                sqrt6 * lambda * (2 * cos(2 * theta / 3) - 1) / sqrt7,
	                9 * sin(theta / 3) / sqrt7
	              ];
	            }
	            mtFlatPolarParabolicRaw.invert = function(x, y) {
	              var theta = 3 * asin(y * sqrt7 / 9);
	              return [
	                x * sqrt7 / (sqrt6 * (2 * cos(2 * theta / 3) - 1)),
	                asin(sin(theta) * 3 * sqrt6 / 7)
	              ];
	            };
	            function mtFlatPolarParabolic() {
	              return (0, src_projection.Z)(mtFlatPolarParabolicRaw).scale(164.859);
	            }
	            function mtFlatPolarQuarticRaw(lambda, phi) {
	              var k2 = (1 + sqrt1_2) * sin(phi), theta = phi;
	              for (var i = 0, delta; i < 25; i++) {
	                theta -= delta = (sin(theta / 2) + sin(theta) - k2) / (0.5 * cos(theta / 2) + cos(theta));
	                if (abs(delta) < epsilon) break;
	              }
	              return [
	                lambda * (1 + 2 * cos(theta) / cos(theta / 2)) / (3 * sqrt2),
	                2 * sqrt(3) * sin(theta / 2) / sqrt(2 + sqrt2)
	              ];
	            }
	            mtFlatPolarQuarticRaw.invert = function(x, y) {
	              var sinTheta_2 = y * sqrt(2 + sqrt2) / (2 * sqrt(3)), theta = 2 * asin(sinTheta_2);
	              return [
	                3 * sqrt2 * x / (1 + 2 * cos(theta) / cos(theta / 2)),
	                asin((sinTheta_2 + sin(theta)) / (1 + sqrt1_2))
	              ];
	            };
	            function mtFlatPolarQuartic() {
	              return (0, src_projection.Z)(mtFlatPolarQuarticRaw).scale(188.209);
	            }
	            function mtFlatPolarSinusoidalRaw(lambda, phi) {
	              var A2 = sqrt(6 / (4 + pi)), k2 = (1 + pi / 4) * sin(phi), theta = phi / 2;
	              for (var i = 0, delta; i < 25; i++) {
	                theta -= delta = (theta / 2 + sin(theta) - k2) / (0.5 + cos(theta));
	                if (abs(delta) < epsilon) break;
	              }
	              return [
	                A2 * (0.5 + cos(theta)) * lambda / 1.5,
	                A2 * theta
	              ];
	            }
	            mtFlatPolarSinusoidalRaw.invert = function(x, y) {
	              var A2 = sqrt(6 / (4 + pi)), theta = y / A2;
	              if (abs(abs(theta) - halfPi) < epsilon) theta = theta < 0 ? -halfPi : halfPi;
	              return [
	                1.5 * x / (A2 * (0.5 + cos(theta))),
	                asin((theta / 2 + sin(theta)) / (1 + pi / 4))
	              ];
	            };
	            function mtFlatPolarSinusoidal() {
	              return (0, src_projection.Z)(mtFlatPolarSinusoidalRaw).scale(166.518);
	            }
	            var naturalEarth1 = __webpack_require__2(26867);
	            function naturalEarth2Raw(lambda, phi) {
	              var phi2 = phi * phi, phi4 = phi2 * phi2, phi6 = phi2 * phi4;
	              return [
	                lambda * (0.84719 - 0.13063 * phi2 + phi6 * phi6 * (-0.04515 + 0.05494 * phi2 - 0.02326 * phi4 + 331e-5 * phi6)),
	                phi * (1.01183 + phi4 * phi4 * (-0.02625 + 0.01926 * phi2 - 396e-5 * phi4))
	              ];
	            }
	            naturalEarth2Raw.invert = function(x, y) {
	              var phi = y, i = 25, delta, phi2, phi4, phi6;
	              do {
	                phi2 = phi * phi;
	                phi4 = phi2 * phi2;
	                phi -= delta = (phi * (1.01183 + phi4 * phi4 * (-0.02625 + 0.01926 * phi2 - 396e-5 * phi4)) - y) / (1.01183 + phi4 * phi4 * (9 * -0.02625 + 11 * 0.01926 * phi2 + 13 * -396e-5 * phi4));
	              } while (abs(delta) > epsilon2 && --i > 0);
	              phi2 = phi * phi;
	              phi4 = phi2 * phi2;
	              phi6 = phi2 * phi4;
	              return [
	                x / (0.84719 - 0.13063 * phi2 + phi6 * phi6 * (-0.04515 + 0.05494 * phi2 - 0.02326 * phi4 + 331e-5 * phi6)),
	                phi
	              ];
	            };
	            function naturalEarth2() {
	              return (0, src_projection.Z)(naturalEarth2Raw).scale(175.295);
	            }
	            function nellHammerRaw(lambda, phi) {
	              return [
	                lambda * (1 + cos(phi)) / 2,
	                2 * (phi - tan(phi / 2))
	              ];
	            }
	            nellHammerRaw.invert = function(x, y) {
	              var p = y / 2;
	              for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; ++i) {
	                var c = cos(y / 2);
	                y -= delta = (y - tan(y / 2) - p) / (1 - 0.5 / (c * c));
	              }
	              return [
	                2 * x / (1 + cos(y)),
	                y
	              ];
	            };
	            function nellHammer() {
	              return (0, src_projection.Z)(nellHammerRaw).scale(152.63);
	            }
	            var quarticAuthalic_lobes = [[
	              // northern hemisphere
	              [[-180, 0], [-90, 90], [0, 0]],
	              [[0, 0], [90, 90], [180, 0]]
	            ], [
	              // southern hemisphere
	              [[-180, 0], [-90, -90], [0, 0]],
	              [[0, 0], [90, -90], [180, 0]]
	            ]];
	            function quarticAuthalic() {
	              return interrupted(hammerRaw(Infinity), quarticAuthalic_lobes).rotate([20, 0]).scale(152.63);
	            }
	            function nicolosiRaw(lambda, phi) {
	              var sinPhi = sin(phi), q = cos(phi), s = sign(lambda);
	              if (lambda === 0 || abs(phi) === halfPi) return [0, phi];
	              else if (phi === 0) return [lambda, 0];
	              else if (abs(lambda) === halfPi) return [lambda * q, halfPi * sinPhi];
	              var b = pi / (2 * lambda) - 2 * lambda / pi, c = 2 * phi / pi, d = (1 - c * c) / (sinPhi - c);
	              var b2 = b * b, d2 = d * d, b2d2 = 1 + b2 / d2, d2b2 = 1 + d2 / b2;
	              var M = (b * sinPhi / d - b / 2) / b2d2, N = (d2 * sinPhi / b2 + d / 2) / d2b2, m = M * M + q * q / b2d2, n = N * N - (d2 * sinPhi * sinPhi / b2 + d * sinPhi - 1) / d2b2;
	              return [
	                halfPi * (M + sqrt(m) * s),
	                halfPi * (N + sqrt(n < 0 ? 0 : n) * sign(-phi * b) * s)
	              ];
	            }
	            nicolosiRaw.invert = function(x, y) {
	              x /= halfPi;
	              y /= halfPi;
	              var x2 = x * x, y2 = y * y, x2y2 = x2 + y2, pi2 = pi * pi;
	              return [
	                x ? (x2y2 - 1 + sqrt((1 - x2y2) * (1 - x2y2) + 4 * x2)) / (2 * x) * halfPi : 0,
	                solve(function(phi) {
	                  return x2y2 * (pi * sin(phi) - 2 * phi) * pi + 4 * phi * phi * (y - sin(phi)) + 2 * pi * phi - pi2 * y;
	                }, 0)
	              ];
	            };
	            function nicolosi() {
	              return (0, src_projection.Z)(nicolosiRaw).scale(127.267);
	            }
	            var pattersonK1 = 1.0148, pattersonK2 = 0.23185, pattersonK3 = -0.14499, pattersonK4 = 0.02406, pattersonC1 = pattersonK1, pattersonC2 = 5 * pattersonK2, pattersonC3 = 7 * pattersonK3, pattersonC4 = 9 * pattersonK4, pattersonYmax = 1.790857183;
	            function pattersonRaw(lambda, phi) {
	              var phi2 = phi * phi;
	              return [
	                lambda,
	                phi * (pattersonK1 + phi2 * phi2 * (pattersonK2 + phi2 * (pattersonK3 + pattersonK4 * phi2)))
	              ];
	            }
	            pattersonRaw.invert = function(x, y) {
	              if (y > pattersonYmax) y = pattersonYmax;
	              else if (y < -1.790857183) y = -1.790857183;
	              var yc = y, delta;
	              do {
	                var y2 = yc * yc;
	                yc -= delta = (yc * (pattersonK1 + y2 * y2 * (pattersonK2 + y2 * (pattersonK3 + pattersonK4 * y2))) - y) / (pattersonC1 + y2 * y2 * (pattersonC2 + y2 * (pattersonC3 + pattersonC4 * y2)));
	              } while (abs(delta) > epsilon);
	              return [x, yc];
	            };
	            function patterson() {
	              return (0, src_projection.Z)(pattersonRaw).scale(139.319);
	            }
	            function polyconicRaw(lambda, phi) {
	              if (abs(phi) < epsilon) return [lambda, 0];
	              var tanPhi = tan(phi), k2 = lambda * sin(phi);
	              return [
	                sin(k2) / tanPhi,
	                phi + (1 - cos(k2)) / tanPhi
	              ];
	            }
	            polyconicRaw.invert = function(x, y) {
	              if (abs(y) < epsilon) return [x, 0];
	              var k2 = x * x + y * y, phi = y * 0.5, i = 10, delta;
	              do {
	                var tanPhi = tan(phi), secPhi = 1 / cos(phi), j = k2 - 2 * y * phi + phi * phi;
	                phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
	              } while (abs(delta) > epsilon && --i > 0);
	              tanPhi = tan(phi);
	              return [
	                (abs(y) < abs(phi + 1 / tanPhi) ? asin(x * tanPhi) : sign(y) * sign(x) * (acos(abs(x * tanPhi)) + halfPi)) / sin(phi),
	                phi
	              ];
	            };
	            function polyconic() {
	              return (0, src_projection.Z)(polyconicRaw).scale(103.74);
	            }
	            var bounds = __webpack_require__2(77338);
	            var interpolate = __webpack_require__2(83074);
	            function matrix(a, b) {
	              var u = subtract(a[1], a[0]), v = subtract(b[1], b[0]), phi = matrix_angle(u, v), s = matrix_length(u) / matrix_length(v);
	              return multiply([
	                1,
	                0,
	                a[0][0],
	                0,
	                1,
	                a[0][1]
	              ], multiply([
	                s,
	                0,
	                0,
	                0,
	                s,
	                0
	              ], multiply([
	                cos(phi),
	                sin(phi),
	                0,
	                -sin(phi),
	                cos(phi),
	                0
	              ], [
	                1,
	                0,
	                -b[0][0],
	                0,
	                1,
	                -b[0][1]
	              ])));
	            }
	            function inverse(m) {
	              var k2 = 1 / (m[0] * m[4] - m[1] * m[3]);
	              return [
	                k2 * m[4],
	                -k2 * m[1],
	                k2 * (m[1] * m[5] - m[2] * m[4]),
	                -k2 * m[3],
	                k2 * m[0],
	                k2 * (m[2] * m[3] - m[0] * m[5])
	              ];
	            }
	            function multiply(a, b) {
	              return [
	                a[0] * b[0] + a[1] * b[3],
	                a[0] * b[1] + a[1] * b[4],
	                a[0] * b[2] + a[1] * b[5] + a[2],
	                a[3] * b[0] + a[4] * b[3],
	                a[3] * b[1] + a[4] * b[4],
	                a[3] * b[2] + a[4] * b[5] + a[5]
	              ];
	            }
	            function subtract(a, b) {
	              return [a[0] - b[0], a[1] - b[1]];
	            }
	            function matrix_length(v) {
	              return sqrt(v[0] * v[0] + v[1] * v[1]);
	            }
	            function matrix_angle(a, b) {
	              return atan2(a[0] * b[1] - a[1] * b[0], a[0] * b[0] + a[1] * b[1]);
	            }
	            function polyhedral(root, face, r) {
	              recurse(root, { transform: null });
	              function recurse(node, parent) {
	                node.edges = faceEdges(node.face);
	                if (parent.face) {
	                  var shared = node.shared = sharedEdge(node.face, parent.face), m = matrix(shared.map(parent.project), shared.map(node.project));
	                  node.transform = parent.transform ? multiply(parent.transform, m) : m;
	                  var edges = parent.edges;
	                  for (var i = 0, n = edges.length; i < n; ++i) {
	                    if (polyhedral_pointEqual(shared[0], edges[i][1]) && polyhedral_pointEqual(shared[1], edges[i][0])) edges[i] = node;
	                    if (polyhedral_pointEqual(shared[0], edges[i][0]) && polyhedral_pointEqual(shared[1], edges[i][1])) edges[i] = node;
	                  }
	                  edges = node.edges;
	                  for (i = 0, n = edges.length; i < n; ++i) {
	                    if (polyhedral_pointEqual(shared[0], edges[i][0]) && polyhedral_pointEqual(shared[1], edges[i][1])) edges[i] = parent;
	                    if (polyhedral_pointEqual(shared[0], edges[i][1]) && polyhedral_pointEqual(shared[1], edges[i][0])) edges[i] = parent;
	                  }
	                } else {
	                  node.transform = parent.transform;
	                }
	                if (node.children) {
	                  node.children.forEach(function(child) {
	                    recurse(child, node);
	                  });
	                }
	                return node;
	              }
	              function forward(lambda, phi) {
	                var node = face(lambda, phi), point = node.project([lambda * degrees, phi * degrees]), t;
	                if (t = node.transform) {
	                  return [
	                    t[0] * point[0] + t[1] * point[1] + t[2],
	                    -(t[3] * point[0] + t[4] * point[1] + t[5])
	                  ];
	                }
	                point[1] = -point[1];
	                return point;
	              }
	              if (hasInverse(root)) forward.invert = function(x, y) {
	                var coordinates = faceInvert(root, [x, -y]);
	                return coordinates && (coordinates[0] *= radians, coordinates[1] *= radians, coordinates);
	              };
	              function faceInvert(node, coordinates) {
	                var invert = node.project.invert, t = node.transform, point = coordinates;
	                if (t) {
	                  t = inverse(t);
	                  point = [
	                    t[0] * point[0] + t[1] * point[1] + t[2],
	                    t[3] * point[0] + t[4] * point[1] + t[5]
	                  ];
	                }
	                if (invert && node === faceDegrees(p = invert(point))) return p;
	                var p, children = node.children;
	                for (var i = 0, n = children && children.length; i < n; ++i) {
	                  if (p = faceInvert(children[i], coordinates)) return p;
	                }
	              }
	              function faceDegrees(coordinates) {
	                return face(coordinates[0] * radians, coordinates[1] * radians);
	              }
	              var proj = (0, src_projection.Z)(forward), stream_ = proj.stream;
	              proj.stream = function(stream) {
	                var rotate = proj.rotate(), rotateStream = stream_(stream), sphereStream = (proj.rotate([0, 0]), stream_(stream));
	                proj.rotate(rotate);
	                rotateStream.sphere = function() {
	                  sphereStream.polygonStart();
	                  sphereStream.lineStart();
	                  outline(sphereStream, root);
	                  sphereStream.lineEnd();
	                  sphereStream.polygonEnd();
	                };
	                return rotateStream;
	              };
	              return proj.angle(r == null ? -30 : r * degrees);
	            }
	            function outline(stream, node, parent) {
	              var point, edges = node.edges, n = edges.length, edge, multiPoint = { type: "MultiPoint", coordinates: node.face }, notPoles = node.face.filter(function(d) {
	                return abs(d[1]) !== 90;
	              }), b = (0, bounds.Z)({ type: "MultiPoint", coordinates: notPoles }), inside = false, j = -1, dx = b[1][0] - b[0][0];
	              var c = dx === 180 || dx === 360 ? [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2] : (0, centroid.Z)(multiPoint);
	              if (parent) while (++j < n) {
	                if (edges[j] === parent) break;
	              }
	              ++j;
	              for (var i = 0; i < n; ++i) {
	                edge = edges[(i + j) % n];
	                if (Array.isArray(edge)) {
	                  if (!inside) {
	                    stream.point((point = (0, interpolate.Z)(edge[0], c)(epsilon))[0], point[1]);
	                    inside = true;
	                  }
	                  stream.point((point = (0, interpolate.Z)(edge[1], c)(epsilon))[0], point[1]);
	                } else {
	                  inside = false;
	                  if (edge !== parent) outline(stream, edge, node);
	                }
	              }
	            }
	            function polyhedral_pointEqual(a, b) {
	              return a && b && a[0] === b[0] && a[1] === b[1];
	            }
	            function sharedEdge(a, b) {
	              var x, y, n = a.length, found = null;
	              for (var i = 0; i < n; ++i) {
	                x = a[i];
	                for (var j = b.length; --j >= 0; ) {
	                  y = b[j];
	                  if (x[0] === y[0] && x[1] === y[1]) {
	                    if (found) return [found, x];
	                    found = x;
	                  }
	                }
	              }
	            }
	            function faceEdges(face) {
	              var n = face.length, edges = [];
	              for (var a = face[n - 1], i = 0; i < n; ++i) edges.push([a, a = face[i]]);
	              return edges;
	            }
	            function hasInverse(node) {
	              return node.project.invert || node.children && node.children.some(hasInverse);
	            }
	            var gnomonic = __webpack_require__2(98936);
	            var octahedron = [
	              [0, 90],
	              [-90, 0],
	              [0, 0],
	              [90, 0],
	              [180, 0],
	              [0, -90]
	            ];
	            var polyhedral_octahedron = [
	              [0, 2, 1],
	              [0, 3, 2],
	              [5, 1, 2],
	              [5, 2, 3],
	              [0, 1, 4],
	              [0, 4, 3],
	              [5, 4, 1],
	              [5, 3, 4]
	            ].map(function(face) {
	              return face.map(function(i) {
	                return octahedron[i];
	              });
	            });
	            function butterfly(faceProjection) {
	              faceProjection = faceProjection || function(face) {
	                var c = (0, centroid.Z)({ type: "MultiPoint", coordinates: face });
	                return (0, gnomonic.Z)().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
	              };
	              var faces = polyhedral_octahedron.map(function(face) {
	                return { face, project: faceProjection(face) };
	              });
	              [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
	                var node = faces[d];
	                node && (node.children || (node.children = [])).push(faces[i]);
	              });
	              return polyhedral(faces[0], function(lambda, phi) {
	                return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4 : lambda < 0 ? phi < 0 ? 2 : 0 : lambda < pi / 2 ? phi < 0 ? 3 : 1 : phi < 0 ? 7 : 5];
	              }).angle(-30).scale(101.858).center([0, 45]);
	            }
	            var kx = 2 / sqrt(3);
	            function collignonK(a, b) {
	              var p = collignonRaw(a, b);
	              return [p[0] * kx, p[1]];
	            }
	            collignonK.invert = function(x, y) {
	              return collignonRaw.invert(x / kx, y);
	            };
	            function polyhedral_collignon(faceProjection) {
	              faceProjection = faceProjection || function(face) {
	                var c = (0, centroid.Z)({ type: "MultiPoint", coordinates: face });
	                return (0, src_projection.Z)(collignonK).translate([0, 0]).scale(1).rotate(c[1] > 0 ? [-c[0], 0] : [180 - c[0], 180]);
	              };
	              var faces = polyhedral_octahedron.map(function(face) {
	                return { face, project: faceProjection(face) };
	              });
	              [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
	                var node = faces[d];
	                node && (node.children || (node.children = [])).push(faces[i]);
	              });
	              return polyhedral(faces[0], function(lambda, phi) {
	                return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4 : lambda < 0 ? phi < 0 ? 2 : 0 : lambda < pi / 2 ? phi < 0 ? 3 : 1 : phi < 0 ? 7 : 5];
	              }).angle(-30).scale(121.906).center([0, 48.5904]);
	            }
	            function waterman(faceProjection) {
	              faceProjection = faceProjection || function(face2) {
	                var c = face2.length === 6 ? (0, centroid.Z)({ type: "MultiPoint", coordinates: face2 }) : face2[0];
	                return (0, gnomonic.Z)().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
	              };
	              var w5 = polyhedral_octahedron.map(function(face2) {
	                var xyz = face2.map(cartesian), n = xyz.length, a = xyz[n - 1], b, hexagon = [];
	                for (var i = 0; i < n; ++i) {
	                  b = xyz[i];
	                  hexagon.push(spherical([
	                    a[0] * 0.9486832980505138 + b[0] * 0.31622776601683794,
	                    a[1] * 0.9486832980505138 + b[1] * 0.31622776601683794,
	                    a[2] * 0.9486832980505138 + b[2] * 0.31622776601683794
	                  ]), spherical([
	                    b[0] * 0.9486832980505138 + a[0] * 0.31622776601683794,
	                    b[1] * 0.9486832980505138 + a[1] * 0.31622776601683794,
	                    b[2] * 0.9486832980505138 + a[2] * 0.31622776601683794
	                  ]));
	                  a = b;
	                }
	                return hexagon;
	              });
	              var cornerNormals = [];
	              var parents = [-1, 0, 0, 1, 0, 1, 4, 5];
	              w5.forEach(function(hexagon, j) {
	                var face2 = polyhedral_octahedron[j], n = face2.length, normals = cornerNormals[j] = [];
	                for (var i = 0; i < n; ++i) {
	                  w5.push([
	                    face2[i],
	                    hexagon[(i * 2 + 2) % (2 * n)],
	                    hexagon[(i * 2 + 1) % (2 * n)]
	                  ]);
	                  parents.push(j);
	                  normals.push(cross(
	                    cartesian(hexagon[(i * 2 + 2) % (2 * n)]),
	                    cartesian(hexagon[(i * 2 + 1) % (2 * n)])
	                  ));
	                }
	              });
	              var faces = w5.map(function(face2) {
	                return {
	                  project: faceProjection(face2),
	                  face: face2
	                };
	              });
	              parents.forEach(function(d, i) {
	                var parent = faces[d];
	                parent && (parent.children || (parent.children = [])).push(faces[i]);
	              });
	              function face(lambda, phi) {
	                var cosphi = cos(phi), p = [cosphi * cos(lambda), cosphi * sin(lambda), sin(phi)];
	                var hexagon = lambda < -pi / 2 ? phi < 0 ? 6 : 4 : lambda < 0 ? phi < 0 ? 2 : 0 : lambda < pi / 2 ? phi < 0 ? 3 : 1 : phi < 0 ? 7 : 5;
	                var n = cornerNormals[hexagon];
	                return faces[dot(n[0], p) < 0 ? 8 + 3 * hexagon : dot(n[1], p) < 0 ? 8 + 3 * hexagon + 1 : dot(n[2], p) < 0 ? 8 + 3 * hexagon + 2 : hexagon];
	              }
	              return polyhedral(faces[0], face).angle(-30).scale(110.625).center([0, 45]);
	            }
	            function dot(a, b) {
	              for (var i = 0, n = a.length, s = 0; i < n; ++i) s += a[i] * b[i];
	              return s;
	            }
	            function cross(a, b) {
	              return [
	                a[1] * b[2] - a[2] * b[1],
	                a[2] * b[0] - a[0] * b[2],
	                a[0] * b[1] - a[1] * b[0]
	              ];
	            }
	            function spherical(cartesian2) {
	              return [
	                atan2(cartesian2[1], cartesian2[0]) * degrees,
	                asin(max(-1, min(1, cartesian2[2]))) * degrees
	              ];
	            }
	            function cartesian(coordinates) {
	              var lambda = coordinates[0] * radians, phi = coordinates[1] * radians, cosphi = cos(phi);
	              return [
	                cosphi * cos(lambda),
	                cosphi * sin(lambda),
	                sin(phi)
	              ];
	            }
	            function noop() {
	            }
	            function clockwise(ring) {
	              if ((n = ring.length) < 4) return false;
	              var i = 0, n, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	              while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	              return area <= 0;
	            }
	            function contains(ring, point) {
	              var x = point[0], y = point[1], contains2 = false;
	              for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	                var pi2 = ring[i], xi = pi2[0], yi = pi2[1], pj = ring[j], xj = pj[0], yj = pj[1];
	                if (yi > y ^ yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains2 = !contains2;
	              }
	              return contains2;
	            }
	            function project(object, projection) {
	              var stream = projection.stream, project2;
	              if (!stream) throw new Error("invalid projection");
	              switch (object && object.type) {
	                case "Feature":
	                  project2 = projectFeature;
	                  break;
	                case "FeatureCollection":
	                  project2 = projectFeatureCollection;
	                  break;
	                default:
	                  project2 = projectGeometry;
	                  break;
	              }
	              return project2(object, stream);
	            }
	            function projectFeatureCollection(o, stream) {
	              return {
	                type: "FeatureCollection",
	                features: o.features.map(function(f) {
	                  return projectFeature(f, stream);
	                })
	              };
	            }
	            function projectFeature(o, stream) {
	              return {
	                type: "Feature",
	                id: o.id,
	                properties: o.properties,
	                geometry: projectGeometry(o.geometry, stream)
	              };
	            }
	            function projectGeometryCollection(o, stream) {
	              return {
	                type: "GeometryCollection",
	                geometries: o.geometries.map(function(o2) {
	                  return projectGeometry(o2, stream);
	                })
	              };
	            }
	            function projectGeometry(o, stream) {
	              if (!o) return null;
	              if (o.type === "GeometryCollection") return projectGeometryCollection(o, stream);
	              var sink;
	              switch (o.type) {
	                case "Point":
	                  sink = sinkPoint;
	                  break;
	                case "MultiPoint":
	                  sink = sinkPoint;
	                  break;
	                case "LineString":
	                  sink = sinkLine;
	                  break;
	                case "MultiLineString":
	                  sink = sinkLine;
	                  break;
	                case "Polygon":
	                  sink = sinkPolygon;
	                  break;
	                case "MultiPolygon":
	                  sink = sinkPolygon;
	                  break;
	                case "Sphere":
	                  sink = sinkPolygon;
	                  break;
	                default:
	                  return null;
	              }
	              (0, src_stream.Z)(o, stream(sink));
	              return sink.result();
	            }
	            var points = [], lines = [];
	            var sinkPoint = {
	              point: function(x, y) {
	                points.push([x, y]);
	              },
	              result: function() {
	                var result = !points.length ? null : points.length < 2 ? { type: "Point", coordinates: points[0] } : { type: "MultiPoint", coordinates: points };
	                points = [];
	                return result;
	              }
	            };
	            var sinkLine = {
	              lineStart: noop,
	              point: function(x, y) {
	                points.push([x, y]);
	              },
	              lineEnd: function() {
	                if (points.length) lines.push(points), points = [];
	              },
	              result: function() {
	                var result = !lines.length ? null : lines.length < 2 ? { type: "LineString", coordinates: lines[0] } : { type: "MultiLineString", coordinates: lines };
	                lines = [];
	                return result;
	              }
	            };
	            var sinkPolygon = {
	              polygonStart: noop,
	              lineStart: noop,
	              point: function(x, y) {
	                points.push([x, y]);
	              },
	              lineEnd: function() {
	                var n = points.length;
	                if (n) {
	                  do
	                    points.push(points[0].slice());
	                  while (++n < 4);
	                  lines.push(points), points = [];
	                }
	              },
	              polygonEnd: noop,
	              result: function() {
	                if (!lines.length) return null;
	                var polygons = [], holes = [];
	                lines.forEach(function(ring) {
	                  if (clockwise(ring)) polygons.push([ring]);
	                  else holes.push(ring);
	                });
	                holes.forEach(function(hole) {
	                  var point = hole[0];
	                  polygons.some(function(polygon) {
	                    if (contains(polygon[0], point)) {
	                      polygon.push(hole);
	                      return true;
	                    }
	                  }) || polygons.push([hole]);
	                });
	                lines = [];
	                return !polygons.length ? null : polygons.length > 1 ? { type: "MultiPolygon", coordinates: polygons } : { type: "Polygon", coordinates: polygons[0] };
	              }
	            };
	            function quincuncial(project2) {
	              var dx = project2(halfPi, 0)[0] - project2(-halfPi, 0)[0];
	              function projectQuincuncial(lambda, phi) {
	                var t = abs(lambda) < halfPi, p = project2(t ? lambda : lambda > 0 ? lambda - pi : lambda + pi, phi), x = (p[0] - p[1]) * sqrt1_2, y = (p[0] + p[1]) * sqrt1_2;
	                if (t) return [x, y];
	                var d = dx * sqrt1_2, s = x > 0 ^ y > 0 ? -1 : 1;
	                return [s * x - sign(y) * d, s * y - sign(x) * d];
	              }
	              if (project2.invert) projectQuincuncial.invert = function(x02, y02) {
	                var x = (x02 + y02) * sqrt1_2, y = (y02 - x02) * sqrt1_2, t = abs(x) < 0.5 * dx && abs(y) < 0.5 * dx;
	                if (!t) {
	                  var d = dx * sqrt1_2, s = x > 0 ^ y > 0 ? -1 : 1, x12 = -s * x02 + (y > 0 ? 1 : -1) * d, y12 = -s * y02 + (x > 0 ? 1 : -1) * d;
	                  x = (-x12 - y12) * sqrt1_2;
	                  y = (x12 - y12) * sqrt1_2;
	                }
	                var p = project2.invert(x, y);
	                if (!t) p[0] += x > 0 ? pi : -pi;
	                return p;
	              };
	              return (0, src_projection.Z)(projectQuincuncial).rotate([-90, -90, 45]).clipAngle(180 - 1e-3);
	            }
	            function quincuncial_gringorten() {
	              return quincuncial(gringortenRaw).scale(176.423);
	            }
	            function peirce() {
	              return quincuncial(guyouRaw).scale(111.48);
	            }
	            function quantize(input, digits) {
	              if (!(0 <= (digits = +digits) && digits <= 20)) throw new Error("invalid digits");
	              function quantizePoint(input2) {
	                var n = input2.length, i = 2, output2 = new Array(n);
	                output2[0] = +input2[0].toFixed(digits);
	                output2[1] = +input2[1].toFixed(digits);
	                while (i < n) output2[i] = input2[i], ++i;
	                return output2;
	              }
	              function quantizePoints(input2) {
	                return input2.map(quantizePoint);
	              }
	              function quantizePointsNoDuplicates(input2) {
	                var point0 = quantizePoint(input2[0]);
	                var output2 = [point0];
	                for (var i = 1; i < input2.length; i++) {
	                  var point = quantizePoint(input2[i]);
	                  if (point.length > 2 || point[0] != point0[0] || point[1] != point0[1]) {
	                    output2.push(point);
	                    point0 = point;
	                  }
	                }
	                if (output2.length === 1 && input2.length > 1) {
	                  output2.push(quantizePoint(input2[input2.length - 1]));
	                }
	                return output2;
	              }
	              function quantizePolygon(input2) {
	                return input2.map(quantizePointsNoDuplicates);
	              }
	              function quantizeGeometry(input2) {
	                if (input2 == null) return input2;
	                var output2;
	                switch (input2.type) {
	                  case "GeometryCollection":
	                    output2 = { type: "GeometryCollection", geometries: input2.geometries.map(quantizeGeometry) };
	                    break;
	                  case "Point":
	                    output2 = { type: "Point", coordinates: quantizePoint(input2.coordinates) };
	                    break;
	                  case "MultiPoint":
	                    output2 = { type: input2.type, coordinates: quantizePoints(input2.coordinates) };
	                    break;
	                  case "LineString":
	                    output2 = { type: input2.type, coordinates: quantizePointsNoDuplicates(input2.coordinates) };
	                    break;
	                  case "MultiLineString":
	                  case "Polygon":
	                    output2 = { type: input2.type, coordinates: quantizePolygon(input2.coordinates) };
	                    break;
	                  case "MultiPolygon":
	                    output2 = { type: "MultiPolygon", coordinates: input2.coordinates.map(quantizePolygon) };
	                    break;
	                  default:
	                    return input2;
	                }
	                if (input2.bbox != null) output2.bbox = input2.bbox;
	                return output2;
	              }
	              function quantizeFeature(input2) {
	                var output2 = { type: "Feature", properties: input2.properties, geometry: quantizeGeometry(input2.geometry) };
	                if (input2.id != null) output2.id = input2.id;
	                if (input2.bbox != null) output2.bbox = input2.bbox;
	                return output2;
	              }
	              if (input != null) switch (input.type) {
	                case "Feature":
	                  return quantizeFeature(input);
	                case "FeatureCollection": {
	                  var output = { type: "FeatureCollection", features: input.features.map(quantizeFeature) };
	                  if (input.bbox != null) output.bbox = input.bbox;
	                  return output;
	                }
	                default:
	                  return quantizeGeometry(input);
	              }
	              return input;
	            }
	            function rectangularPolyconicRaw(phi02) {
	              var sinPhi0 = sin(phi02);
	              function forward(lambda, phi) {
	                var A2 = sinPhi0 ? tan(lambda * sinPhi0 / 2) / sinPhi0 : lambda / 2;
	                if (!phi) return [2 * A2, -phi02];
	                var E = 2 * atan(A2 * sin(phi)), cotPhi = 1 / tan(phi);
	                return [
	                  sin(E) * cotPhi,
	                  phi + (1 - cos(E)) * cotPhi - phi02
	                ];
	              }
	              forward.invert = function(x, y) {
	                if (abs(y += phi02) < epsilon) return [sinPhi0 ? 2 * atan(sinPhi0 * x / 2) / sinPhi0 : x, 0];
	                var k2 = x * x + y * y, phi = 0, i = 10, delta;
	                do {
	                  var tanPhi = tan(phi), secPhi = 1 / cos(phi), j = k2 - 2 * y * phi + phi * phi;
	                  phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
	                } while (abs(delta) > epsilon && --i > 0);
	                var E = x * (tanPhi = tan(phi)), A2 = tan(abs(y) < abs(phi + 1 / tanPhi) ? asin(E) * 0.5 : acos(E) * 0.5 + pi / 4) / sin(phi);
	                return [
	                  sinPhi0 ? 2 * atan(sinPhi0 * A2) / sinPhi0 : 2 * A2,
	                  phi
	                ];
	              };
	              return forward;
	            }
	            function rectangularPolyconic() {
	              return parallel1(rectangularPolyconicRaw).scale(131.215);
	            }
	            var robinson_K = [
	              [0.9986, -0.062],
	              [1, 0],
	              [0.9986, 0.062],
	              [0.9954, 0.124],
	              [0.99, 0.186],
	              [0.9822, 0.248],
	              [0.973, 0.31],
	              [0.96, 0.372],
	              [0.9427, 0.434],
	              [0.9216, 0.4958],
	              [0.8962, 0.5571],
	              [0.8679, 0.6176],
	              [0.835, 0.6769],
	              [0.7986, 0.7346],
	              [0.7597, 0.7903],
	              [0.7186, 0.8435],
	              [0.6732, 0.8936],
	              [0.6213, 0.9394],
	              [0.5722, 0.9761],
	              [0.5322, 1]
	            ];
	            robinson_K.forEach(function(d) {
	              d[1] *= 1.0144;
	            });
	            function robinsonRaw(lambda, phi) {
	              var i = min(18, abs(phi) * 36 / pi), i0 = floor(i), di = i - i0, ax = (k2 = robinson_K[i0])[0], ay = k2[1], bx = (k2 = robinson_K[++i0])[0], by = k2[1], cx = (k2 = robinson_K[min(19, ++i0)])[0], cy = k2[1], k2;
	              return [
	                lambda * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
	                (phi > 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2)
	              ];
	            }
	            robinsonRaw.invert = function(x, y) {
	              var yy = y / halfPi, phi = yy * 90, i = min(18, abs(phi / 5)), i0 = max(0, floor(i));
	              do {
	                var ay = robinson_K[i0][1], by = robinson_K[i0 + 1][1], cy = robinson_K[min(19, i0 + 2)][1], u = cy - ay, v = cy - 2 * by + ay, t = 2 * (abs(yy) - by) / u, c = v / u, di = t * (1 - c * t * (1 - 2 * c * t));
	                if (di >= 0 || i0 === 1) {
	                  phi = (y >= 0 ? 5 : -5) * (di + i);
	                  var j = 50, delta;
	                  do {
	                    i = min(18, abs(phi) / 5);
	                    i0 = floor(i);
	                    di = i - i0;
	                    ay = robinson_K[i0][1];
	                    by = robinson_K[i0 + 1][1];
	                    cy = robinson_K[min(19, i0 + 2)][1];
	                    phi -= (delta = (y >= 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * degrees;
	                  } while (abs(delta) > epsilon2 && --j > 0);
	                  break;
	                }
	              } while (--i0 >= 0);
	              var ax = robinson_K[i0][0], bx = robinson_K[i0 + 1][0], cx = robinson_K[min(19, i0 + 2)][0];
	              return [
	                x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
	                phi * radians
	              ];
	            };
	            function robinson() {
	              return (0, src_projection.Z)(robinsonRaw).scale(152.63);
	            }
	            function satelliteVerticalRaw(P) {
	              function forward(lambda, phi) {
	                var cosPhi = cos(phi), k2 = (P - 1) / (P - cosPhi * cos(lambda));
	                return [
	                  k2 * cosPhi * sin(lambda),
	                  k2 * sin(phi)
	                ];
	              }
	              forward.invert = function(x, y) {
	                var rho2 = x * x + y * y, rho = sqrt(rho2), sinc = (P - sqrt(1 - rho2 * (P + 1) / (P - 1))) / ((P - 1) / rho + rho / (P - 1));
	                return [
	                  atan2(x * sinc, rho * sqrt(1 - sinc * sinc)),
	                  rho ? asin(y * sinc / rho) : 0
	                ];
	              };
	              return forward;
	            }
	            function satelliteRaw(P, omega) {
	              var vertical = satelliteVerticalRaw(P);
	              if (!omega) return vertical;
	              var cosOmega = cos(omega), sinOmega = sin(omega);
	              function forward(lambda, phi) {
	                var coordinates = vertical(lambda, phi), y = coordinates[1], A2 = y * sinOmega / (P - 1) + cosOmega;
	                return [
	                  coordinates[0] * cosOmega / A2,
	                  y / A2
	                ];
	              }
	              forward.invert = function(x, y) {
	                var k2 = (P - 1) / (P - 1 - y * sinOmega);
	                return vertical.invert(k2 * x, k2 * y * cosOmega);
	              };
	              return forward;
	            }
	            function satellite() {
	              var distance2 = 2, omega = 0, m = (0, src_projection.r)(satelliteRaw), p = m(distance2, omega);
	              p.distance = function(_) {
	                if (!arguments.length) return distance2;
	                return m(distance2 = +_, omega);
	              };
	              p.tilt = function(_) {
	                if (!arguments.length) return omega * degrees;
	                return m(distance2, omega = _ * radians);
	              };
	              return p.scale(432.147).clipAngle(acos(1 / distance2) * degrees - 1e-6);
	            }
	            var stitch_epsilon = 1e-4, epsilonInverse = 1e4, x0 = -180, x0e = x0 + stitch_epsilon, x1 = 180, x1e = x1 - stitch_epsilon, y0 = -90, y0e = y0 + stitch_epsilon, y1 = 90, y1e = y1 - stitch_epsilon;
	            function nonempty(coordinates) {
	              return coordinates.length > 0;
	            }
	            function stitch_quantize(x) {
	              return Math.floor(x * epsilonInverse) / epsilonInverse;
	            }
	            function normalizePoint(y) {
	              return y === y0 || y === y1 ? [0, y] : [x0, stitch_quantize(y)];
	            }
	            function clampPoint(p) {
	              var x = p[0], y = p[1], clamped = false;
	              if (x <= x0e) x = x0, clamped = true;
	              else if (x >= x1e) x = x1, clamped = true;
	              if (y <= y0e) y = y0, clamped = true;
	              else if (y >= y1e) y = y1, clamped = true;
	              return clamped ? [x, y] : p;
	            }
	            function clampPoints(points2) {
	              return points2.map(clampPoint);
	            }
	            function extractFragments(rings, polygon, fragments) {
	              for (var j = 0, m = rings.length; j < m; ++j) {
	                var ring = rings[j].slice();
	                fragments.push({ index: -1, polygon, ring });
	                for (var i = 0, n = ring.length; i < n; ++i) {
	                  var point = ring[i], x = point[0], y = point[1];
	                  if (x <= x0e || x >= x1e || y <= y0e || y >= y1e) {
	                    ring[i] = clampPoint(point);
	                    for (var k2 = i + 1; k2 < n; ++k2) {
	                      var pointk = ring[k2], xk = pointk[0], yk = pointk[1];
	                      if (xk > x0e && xk < x1e && yk > y0e && yk < y1e) break;
	                    }
	                    if (k2 === i + 1) continue;
	                    if (i) {
	                      var fragmentBefore = { index: -1, polygon, ring: ring.slice(0, i + 1) };
	                      fragmentBefore.ring[fragmentBefore.ring.length - 1] = normalizePoint(y);
	                      fragments[fragments.length - 1] = fragmentBefore;
	                    } else fragments.pop();
	                    if (k2 >= n) break;
	                    fragments.push({ index: -1, polygon, ring: ring = ring.slice(k2 - 1) });
	                    ring[0] = normalizePoint(ring[0][1]);
	                    i = -1;
	                    n = ring.length;
	                  }
	                }
	              }
	            }
	            function stitchFragments(fragments) {
	              var i, n = fragments.length;
	              var fragmentByStart = {}, fragmentByEnd = {}, fragment, start, startFragment, end, endFragment;
	              for (i = 0; i < n; ++i) {
	                fragment = fragments[i];
	                start = fragment.ring[0];
	                end = fragment.ring[fragment.ring.length - 1];
	                if (start[0] === end[0] && start[1] === end[1]) {
	                  fragment.polygon.push(fragment.ring);
	                  fragments[i] = null;
	                  continue;
	                }
	                fragment.index = i;
	                fragmentByStart[start] = fragmentByEnd[end] = fragment;
	              }
	              for (i = 0; i < n; ++i) {
	                fragment = fragments[i];
	                if (fragment) {
	                  start = fragment.ring[0];
	                  end = fragment.ring[fragment.ring.length - 1];
	                  startFragment = fragmentByEnd[start];
	                  endFragment = fragmentByStart[end];
	                  delete fragmentByStart[start];
	                  delete fragmentByEnd[end];
	                  if (start[0] === end[0] && start[1] === end[1]) {
	                    fragment.polygon.push(fragment.ring);
	                    continue;
	                  }
	                  if (startFragment) {
	                    delete fragmentByEnd[start];
	                    delete fragmentByStart[startFragment.ring[0]];
	                    startFragment.ring.pop();
	                    fragments[startFragment.index] = null;
	                    fragment = { index: -1, polygon: startFragment.polygon, ring: startFragment.ring.concat(fragment.ring) };
	                    if (startFragment === endFragment) {
	                      fragment.polygon.push(fragment.ring);
	                    } else {
	                      fragment.index = n++;
	                      fragments.push(fragmentByStart[fragment.ring[0]] = fragmentByEnd[fragment.ring[fragment.ring.length - 1]] = fragment);
	                    }
	                  } else if (endFragment) {
	                    delete fragmentByStart[end];
	                    delete fragmentByEnd[endFragment.ring[endFragment.ring.length - 1]];
	                    fragment.ring.pop();
	                    fragment = { index: n++, polygon: endFragment.polygon, ring: fragment.ring.concat(endFragment.ring) };
	                    fragments[endFragment.index] = null;
	                    fragments.push(fragmentByStart[fragment.ring[0]] = fragmentByEnd[fragment.ring[fragment.ring.length - 1]] = fragment);
	                  } else {
	                    fragment.ring.push(fragment.ring[0]);
	                    fragment.polygon.push(fragment.ring);
	                  }
	                }
	              }
	            }
	            function stitchFeature(input) {
	              var output = { type: "Feature", geometry: stitchGeometry(input.geometry) };
	              if (input.id != null) output.id = input.id;
	              if (input.bbox != null) output.bbox = input.bbox;
	              if (input.properties != null) output.properties = input.properties;
	              return output;
	            }
	            function stitchGeometry(input) {
	              if (input == null) return input;
	              var output, fragments, i, n;
	              switch (input.type) {
	                case "GeometryCollection":
	                  output = { type: "GeometryCollection", geometries: input.geometries.map(stitchGeometry) };
	                  break;
	                case "Point":
	                  output = { type: "Point", coordinates: clampPoint(input.coordinates) };
	                  break;
	                case "MultiPoint":
	                case "LineString":
	                  output = { type: input.type, coordinates: clampPoints(input.coordinates) };
	                  break;
	                case "MultiLineString":
	                  output = { type: "MultiLineString", coordinates: input.coordinates.map(clampPoints) };
	                  break;
	                case "Polygon": {
	                  var polygon = [];
	                  extractFragments(input.coordinates, polygon, fragments = []);
	                  stitchFragments(fragments);
	                  output = { type: "Polygon", coordinates: polygon };
	                  break;
	                }
	                case "MultiPolygon": {
	                  fragments = [], i = -1, n = input.coordinates.length;
	                  var polygons = new Array(n);
	                  while (++i < n) extractFragments(input.coordinates[i], polygons[i] = [], fragments);
	                  stitchFragments(fragments);
	                  output = { type: "MultiPolygon", coordinates: polygons.filter(nonempty) };
	                  break;
	                }
	                default:
	                  return input;
	              }
	              if (input.bbox != null) output.bbox = input.bbox;
	              return output;
	            }
	            function stitch(input) {
	              if (input == null) return input;
	              switch (input.type) {
	                case "Feature":
	                  return stitchFeature(input);
	                case "FeatureCollection": {
	                  var output = { type: "FeatureCollection", features: input.features.map(stitchFeature) };
	                  if (input.bbox != null) output.bbox = input.bbox;
	                  return output;
	                }
	                default:
	                  return stitchGeometry(input);
	              }
	            }
	            function timesRaw(lambda, phi) {
	              var t = tan(phi / 2), s = sin(quarterPi * t);
	              return [
	                lambda * (0.74482 - 0.34588 * s * s),
	                1.70711 * t
	              ];
	            }
	            timesRaw.invert = function(x, y) {
	              var t = y / 1.70711, s = sin(quarterPi * t);
	              return [
	                x / (0.74482 - 0.34588 * s * s),
	                2 * atan(t)
	              ];
	            };
	            function times() {
	              return (0, src_projection.Z)(timesRaw).scale(146.153);
	            }
	            function twoPoint(raw, p0, p1) {
	              var i = (0, interpolate.Z)(p0, p1), o = i(0.5), a = (0, rotation.Z)([-o[0], -o[1]])(p0), b = i.distance / 2, y = -asin(sin(a[1] * radians) / sin(b)), R = [-o[0], -o[1], -(a[0] > 0 ? pi - y : y) * degrees], p = (0, src_projection.Z)(raw(b)).rotate(R), r = (0, rotation.Z)(R), center = p.center;
	              delete p.rotate;
	              p.center = function(_) {
	                return arguments.length ? center(r(_)) : r.invert(center());
	              };
	              return p.clipAngle(90);
	            }
	            function twoPointAzimuthalRaw(d) {
	              var cosd = cos(d);
	              function forward(lambda, phi) {
	                var coordinates = (0, gnomonic.M)(lambda, phi);
	                coordinates[0] *= cosd;
	                return coordinates;
	              }
	              forward.invert = function(x, y) {
	                return gnomonic.M.invert(x / cosd, y);
	              };
	              return forward;
	            }
	            function twoPointAzimuthalUsa() {
	              return twoPointAzimuthal([-158, 21.5], [-77, 39]).clipAngle(60).scale(400);
	            }
	            function twoPointAzimuthal(p0, p1) {
	              return twoPoint(twoPointAzimuthalRaw, p0, p1);
	            }
	            function twoPointEquidistantRaw(z0) {
	              if (!(z0 *= 2)) return azimuthalEquidistant.N;
	              var lambdaa = -z0 / 2, lambdab = -lambdaa, z02 = z0 * z0, tanLambda0 = tan(lambdab), S = 0.5 / sin(lambdab);
	              function forward(lambda, phi) {
	                var za = acos(cos(phi) * cos(lambda - lambdaa)), zb = acos(cos(phi) * cos(lambda - lambdab)), ys = phi < 0 ? -1 : 1;
	                za *= za, zb *= zb;
	                return [
	                  (za - zb) / (2 * z0),
	                  ys * sqrt(4 * z02 * zb - (z02 - za + zb) * (z02 - za + zb)) / (2 * z0)
	                ];
	              }
	              forward.invert = function(x, y) {
	                var y2 = y * y, cosza = cos(sqrt(y2 + (t = x + lambdaa) * t)), coszb = cos(sqrt(y2 + (t = x + lambdab) * t)), t, d;
	                return [
	                  atan2(d = cosza - coszb, t = (cosza + coszb) * tanLambda0),
	                  (y < 0 ? -1 : 1) * acos(sqrt(t * t + d * d) * S)
	                ];
	              };
	              return forward;
	            }
	            function twoPointEquidistantUsa() {
	              return twoPointEquidistant([-158, 21.5], [-77, 39]).clipAngle(130).scale(122.571);
	            }
	            function twoPointEquidistant(p0, p1) {
	              return twoPoint(twoPointEquidistantRaw, p0, p1);
	            }
	            function vanDerGrintenRaw(lambda, phi) {
	              if (abs(phi) < epsilon) return [lambda, 0];
	              var sinTheta = abs(phi / halfPi), theta = asin(sinTheta);
	              if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
	              var cosTheta = cos(theta), A2 = abs(pi / lambda - lambda / pi) / 2, A22 = A2 * A2, G = cosTheta / (sinTheta + cosTheta - 1), P = G * (2 / sinTheta - 1), P2 = P * P, P2_A2 = P2 + A22, G_P2 = G - P2, Q = A22 + G;
	              return [
	                sign(lambda) * pi * (A2 * G_P2 + sqrt(A22 * G_P2 * G_P2 - P2_A2 * (G * G - P2))) / P2_A2,
	                sign(phi) * pi * (P * Q - A2 * sqrt((A22 + 1) * P2_A2 - Q * Q)) / P2_A2
	              ];
	            }
	            vanDerGrintenRaw.invert = function(x, y) {
	              if (abs(y) < epsilon) return [x, 0];
	              if (abs(x) < epsilon) return [0, halfPi * sin(2 * atan(y / pi))];
	              var x2 = (x /= pi) * x, y2 = (y /= pi) * y, x2_y2 = x2 + y2, z = x2_y2 * x2_y2, c1 = -abs(y) * (1 + x2_y2), c2 = c1 - 2 * y2 + x2, c3 = -2 * c1 + 1 + 2 * y2 + z, d = y2 / c3 + (2 * c2 * c2 * c2 / (c3 * c3 * c3) - 9 * c1 * c2 / (c3 * c3)) / 27, a1 = (c1 - c2 * c2 / (3 * c3)) / c3, m1 = 2 * sqrt(-a1 / 3), theta1 = acos(3 * d / (a1 * m1)) / 3;
	              return [
	                pi * (x2_y2 - 1 + sqrt(1 + 2 * (x2 - y2) + z)) / (2 * x),
	                sign(y) * pi * (-m1 * cos(theta1 + pi / 3) - c2 / (3 * c3))
	              ];
	            };
	            function vanDerGrinten() {
	              return (0, src_projection.Z)(vanDerGrintenRaw).scale(79.4183);
	            }
	            function vanDerGrinten2Raw(lambda, phi) {
	              if (abs(phi) < epsilon) return [lambda, 0];
	              var sinTheta = abs(phi / halfPi), theta = asin(sinTheta);
	              if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
	              var cosTheta = cos(theta), A2 = abs(pi / lambda - lambda / pi) / 2, A22 = A2 * A2, x12 = cosTheta * (sqrt(1 + A22) - A2 * cosTheta) / (1 + A22 * sinTheta * sinTheta);
	              return [
	                sign(lambda) * pi * x12,
	                sign(phi) * pi * sqrt(1 - x12 * (2 * A2 + x12))
	              ];
	            }
	            vanDerGrinten2Raw.invert = function(x, y) {
	              if (!x) return [0, halfPi * sin(2 * atan(y / pi))];
	              var x12 = abs(x / pi), A2 = (1 - x12 * x12 - (y /= pi) * y) / (2 * x12), A22 = A2 * A2, B2 = sqrt(A22 + 1);
	              return [
	                sign(x) * pi * (B2 - A2),
	                sign(y) * halfPi * sin(2 * atan2(sqrt((1 - 2 * A2 * x12) * (A2 + B2) - x12), sqrt(B2 + A2 + x12)))
	              ];
	            };
	            function vanDerGrinten2() {
	              return (0, src_projection.Z)(vanDerGrinten2Raw).scale(79.4183);
	            }
	            function vanDerGrinten3Raw(lambda, phi) {
	              if (abs(phi) < epsilon) return [lambda, 0];
	              var sinTheta = phi / halfPi, theta = asin(sinTheta);
	              if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, pi * tan(theta / 2)];
	              var A2 = (pi / lambda - lambda / pi) / 2, y12 = sinTheta / (1 + cos(theta));
	              return [
	                pi * (sign(lambda) * sqrt(A2 * A2 + 1 - y12 * y12) - A2),
	                pi * y12
	              ];
	            }
	            vanDerGrinten3Raw.invert = function(x, y) {
	              if (!y) return [x, 0];
	              var y12 = y / pi, A2 = (pi * pi * (1 - y12 * y12) - x * x) / (2 * pi * x);
	              return [
	                x ? pi * (sign(x) * sqrt(A2 * A2 + 1) - A2) : 0,
	                halfPi * sin(2 * atan(y12))
	              ];
	            };
	            function vanDerGrinten3() {
	              return (0, src_projection.Z)(vanDerGrinten3Raw).scale(79.4183);
	            }
	            function vanDerGrinten4Raw(lambda, phi) {
	              if (!phi) return [lambda, 0];
	              var phi02 = abs(phi);
	              if (!lambda || phi02 === halfPi) return [0, phi];
	              var B2 = phi02 / halfPi, B22 = B2 * B2, C = (8 * B2 - B22 * (B22 + 2) - 5) / (2 * B22 * (B2 - 1)), C2 = C * C, BC = B2 * C, B_C2 = B22 + C2 + 2 * BC, B_3C = B2 + 3 * C, lambda0 = lambda / halfPi, lambda1 = lambda0 + 1 / lambda0, D = sign(abs(lambda) - halfPi) * sqrt(lambda1 * lambda1 - 4), D2 = D * D, F = B_C2 * (B22 + C2 * D2 - 1) + (1 - B22) * (B22 * (B_3C * B_3C + 4 * C2) + 12 * BC * C2 + 4 * C2 * C2), x12 = (D * (B_C2 + C2 - 1) + 2 * sqrt(F)) / (4 * B_C2 + D2);
	              return [
	                sign(lambda) * halfPi * x12,
	                sign(phi) * halfPi * sqrt(1 + D * abs(x12) - x12 * x12)
	              ];
	            }
	            vanDerGrinten4Raw.invert = function(x, y) {
	              var delta;
	              if (!x || !y) return [x, y];
	              y /= pi;
	              var x12 = sign(x) * x / halfPi, D = (x12 * x12 - 1 + 4 * y * y) / abs(x12), D2 = D * D, B2 = 2 * y, i = 50;
	              do {
	                var B22 = B2 * B2, C = (8 * B2 - B22 * (B22 + 2) - 5) / (2 * B22 * (B2 - 1)), C_ = (3 * B2 - B22 * B2 - 10) / (2 * B22 * B2), C2 = C * C, BC = B2 * C, B_C = B2 + C, B_C2 = B_C * B_C, B_3C = B2 + 3 * C, F = B_C2 * (B22 + C2 * D2 - 1) + (1 - B22) * (B22 * (B_3C * B_3C + 4 * C2) + C2 * (12 * BC + 4 * C2)), F_ = -2 * B_C * (4 * BC * C2 + (1 - 4 * B22 + 3 * B22 * B22) * (1 + C_) + C2 * (-6 + 14 * B22 - D2 + (-8 + 8 * B22 - 2 * D2) * C_) + BC * (-8 + 12 * B22 + (-10 + 10 * B22 - D2) * C_)), sqrtF = sqrt(F), f = D * (B_C2 + C2 - 1) + 2 * sqrtF - x12 * (4 * B_C2 + D2), f_ = D * (2 * C * C_ + 2 * B_C * (1 + C_)) + F_ / sqrtF - 8 * B_C * (D * (-1 + C2 + B_C2) + 2 * sqrtF) * (1 + C_) / (D2 + 4 * B_C2);
	                B2 -= delta = f / f_;
	              } while (delta > epsilon && --i > 0);
	              return [
	                sign(x) * (sqrt(D * D + 4) + D) * pi / 4,
	                halfPi * B2
	              ];
	            };
	            function vanDerGrinten4() {
	              return (0, src_projection.Z)(vanDerGrinten4Raw).scale(127.16);
	            }
	            function wagnerFormula(cx, cy, m1, m2, n) {
	              function forward(lambda, phi) {
	                var s = m1 * sin(m2 * phi), c0 = sqrt(1 - s * s), c1 = sqrt(2 / (1 + c0 * cos(lambda *= n)));
	                return [
	                  cx * c0 * c1 * sin(lambda),
	                  cy * s * c1
	                ];
	              }
	              forward.invert = function(x, y) {
	                var t1 = x / cx, t2 = y / cy, p = sqrt(t1 * t1 + t2 * t2), c = 2 * asin(p / 2);
	                return [
	                  atan2(x * tan(c), cx * p) / n,
	                  p && asin(y * sin(c) / (cy * m1 * p)) / m2
	                ];
	              };
	              return forward;
	            }
	            function wagnerRaw(poleline, parallels, inflation, ratio) {
	              var phi1 = pi / 3;
	              poleline = max(poleline, epsilon);
	              parallels = max(parallels, epsilon);
	              poleline = min(poleline, halfPi);
	              parallels = min(parallels, pi - epsilon);
	              inflation = max(inflation, 0);
	              inflation = min(inflation, 100 - epsilon);
	              ratio = max(ratio, epsilon);
	              var vinflation = inflation / 100 + 1;
	              var vratio = ratio / 100;
	              var m2 = acos(vinflation * cos(phi1)) / phi1, m1 = sin(poleline) / sin(m2 * halfPi), n = parallels / pi, k2 = sqrt(vratio * sin(poleline / 2) / sin(parallels / 2)), cx = k2 / sqrt(n * m1 * m2), cy = 1 / (k2 * sqrt(n * m1 * m2));
	              return wagnerFormula(cx, cy, m1, m2, n);
	            }
	            function wagner() {
	              var poleline = 65 * radians, parallels = 60 * radians, inflation = 20, ratio = 200, mutate = (0, src_projection.r)(wagnerRaw), projection = mutate(poleline, parallels, inflation, ratio);
	              projection.poleline = function(_) {
	                return arguments.length ? mutate(poleline = +_ * radians, parallels, inflation, ratio) : poleline * degrees;
	              };
	              projection.parallels = function(_) {
	                return arguments.length ? mutate(poleline, parallels = +_ * radians, inflation, ratio) : parallels * degrees;
	              };
	              projection.inflation = function(_) {
	                return arguments.length ? mutate(poleline, parallels, inflation = +_, ratio) : inflation;
	              };
	              projection.ratio = function(_) {
	                return arguments.length ? mutate(poleline, parallels, inflation, ratio = +_) : ratio;
	              };
	              return projection.scale(163.775);
	            }
	            function wagner7() {
	              return wagner().poleline(65).parallels(60).inflation(0).ratio(200).scale(172.633);
	            }
	            var A = 4 * pi + 3 * sqrt(3), B = 2 * sqrt(2 * pi * sqrt(3) / A);
	            var wagner4Raw = mollweideBromleyRaw(B * sqrt(3) / pi, B, A / 6);
	            function wagner4() {
	              return (0, src_projection.Z)(wagner4Raw).scale(176.84);
	            }
	            function wagner6Raw(lambda, phi) {
	              return [lambda * sqrt(1 - 3 * phi * phi / (pi * pi)), phi];
	            }
	            wagner6Raw.invert = function(x, y) {
	              return [x / sqrt(1 - 3 * y * y / (pi * pi)), y];
	            };
	            function wagner6() {
	              return (0, src_projection.Z)(wagner6Raw).scale(152.63);
	            }
	            function wiechelRaw(lambda, phi) {
	              var cosPhi = cos(phi), sinPhi = cos(lambda) * cosPhi, sin1_Phi = 1 - sinPhi, cosLambda = cos(lambda = atan2(sin(lambda) * cosPhi, -sin(phi))), sinLambda = sin(lambda);
	              cosPhi = sqrt(1 - sinPhi * sinPhi);
	              return [
	                sinLambda * cosPhi - cosLambda * sin1_Phi,
	                -cosLambda * cosPhi - sinLambda * sin1_Phi
	              ];
	            }
	            wiechelRaw.invert = function(x, y) {
	              var w2 = (x * x + y * y) / -2, k2 = sqrt(-w2 * (2 + w2)), b = y * w2 + x * k2, a = x * w2 - y * k2, D = sqrt(a * a + b * b);
	              return [
	                atan2(k2 * b, D * (1 + w2)),
	                D ? -asin(k2 * a / D) : 0
	              ];
	            };
	            function wiechel() {
	              return (0, src_projection.Z)(wiechelRaw).rotate([0, -90, 45]).scale(124.75).clipAngle(180 - 1e-3);
	            }
	            function winkel3Raw(lambda, phi) {
	              var coordinates = aitoffRaw(lambda, phi);
	              return [
	                (coordinates[0] + lambda / halfPi) / 2,
	                (coordinates[1] + phi) / 2
	              ];
	            }
	            winkel3Raw.invert = function(x, y) {
	              var lambda = x, phi = y, i = 25;
	              do {
	                var cosphi = cos(phi), sinphi = sin(phi), sin_2phi = sin(2 * phi), sin2phi = sinphi * sinphi, cos2phi = cosphi * cosphi, sinlambda = sin(lambda), coslambda_2 = cos(lambda / 2), sinlambda_2 = sin(lambda / 2), sin2lambda_2 = sinlambda_2 * sinlambda_2, C = 1 - cos2phi * coslambda_2 * coslambda_2, E = C ? acos(cosphi * coslambda_2) * sqrt(F = 1 / C) : F = 0, F, fx = 0.5 * (2 * E * cosphi * sinlambda_2 + lambda / halfPi) - x, fy = 0.5 * (E * sinphi + phi) - y, dxdlambda = 0.5 * F * (cos2phi * sin2lambda_2 + E * cosphi * coslambda_2 * sin2phi) + 0.5 / halfPi, dxdphi = F * (sinlambda * sin_2phi / 4 - E * sinphi * sinlambda_2), dydlambda = 0.125 * F * (sin_2phi * sinlambda_2 - E * sinphi * cos2phi * sinlambda), dydphi = 0.5 * F * (sin2phi * coslambda_2 + E * sin2lambda_2 * cosphi) + 0.5, denominator = dxdphi * dydlambda - dydphi * dxdlambda, dlambda = (fy * dxdphi - fx * dydphi) / denominator, dphi = (fx * dydlambda - fy * dxdlambda) / denominator;
	                lambda -= dlambda, phi -= dphi;
	              } while ((abs(dlambda) > epsilon || abs(dphi) > epsilon) && --i > 0);
	              return [lambda, phi];
	            };
	            function winkel3() {
	              return (0, src_projection.Z)(winkel3Raw).scale(158.837);
	            }
	          }
	        ),
	        /***/
	        33940: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return new Adder();
	            }
	            function Adder() {
	              this.reset();
	            }
	            Adder.prototype = {
	              constructor: Adder,
	              reset: function() {
	                this.s = // rounded value
	                this.t = 0;
	              },
	              add: function(y) {
	                add(temp, y, this.t);
	                add(this, temp.s, this.s);
	                if (this.s) this.t += temp.t;
	                else this.s = temp.t;
	              },
	              valueOf: function() {
	                return this.s;
	              }
	            };
	            var temp = new Adder();
	            function add(adder, a, b) {
	              var x = adder.s = a + b, bv = x - a, av = x - bv;
	              adder.t = a - av + (b - bv);
	            }
	          }
	        ),
	        /***/
	        97860: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              L9: function() {
	                return (
	                  /* binding */
	                  areaRingSum
	                );
	              },
	              /* harmony export */
	              ZP: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              },
	              /* harmony export */
	              gL: function() {
	                return (
	                  /* binding */
	                  areaStream
	                );
	              }
	              /* harmony export */
	            });
	            var _adder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(33940);
	            var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(39695);
	            var _noop_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(73182);
	            var _stream_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(72736);
	            var areaRingSum = (0, _adder_js__WEBPACK_IMPORTED_MODULE_0__.Z)();
	            var areaSum = (0, _adder_js__WEBPACK_IMPORTED_MODULE_0__.Z)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
	            var areaStream = {
	              point: _noop_js__WEBPACK_IMPORTED_MODULE_1__.Z,
	              lineStart: _noop_js__WEBPACK_IMPORTED_MODULE_1__.Z,
	              lineEnd: _noop_js__WEBPACK_IMPORTED_MODULE_1__.Z,
	              polygonStart: function() {
	                areaRingSum.reset();
	                areaStream.lineStart = areaRingStart;
	                areaStream.lineEnd = areaRingEnd;
	              },
	              polygonEnd: function() {
	                var areaRing = +areaRingSum;
	                areaSum.add(areaRing < 0 ? _math_js__WEBPACK_IMPORTED_MODULE_2__.BZ + areaRing : areaRing);
	                this.lineStart = this.lineEnd = this.point = _noop_js__WEBPACK_IMPORTED_MODULE_1__.Z;
	              },
	              sphere: function() {
	                areaSum.add(_math_js__WEBPACK_IMPORTED_MODULE_2__.BZ);
	              }
	            };
	            function areaRingStart() {
	              areaStream.point = areaPointFirst;
	            }
	            function areaRingEnd() {
	              areaPoint(lambda00, phi00);
	            }
	            function areaPointFirst(lambda, phi) {
	              areaStream.point = areaPoint;
	              lambda00 = lambda, phi00 = phi;
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_2__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_2__.uR;
	              lambda0 = lambda, cosPhi0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.mC)(phi = phi / 2 + _math_js__WEBPACK_IMPORTED_MODULE_2__.pu), sinPhi0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.O$)(phi);
	            }
	            function areaPoint(lambda, phi) {
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_2__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_2__.uR;
	              phi = phi / 2 + _math_js__WEBPACK_IMPORTED_MODULE_2__.pu;
	              var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.mC)(phi), sinPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.O$)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.mC)(adLambda), v = k * sdLambda * (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.O$)(adLambda);
	              areaRingSum.add((0, _math_js__WEBPACK_IMPORTED_MODULE_2__.fv)(v, u));
	              lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(object) {
	              areaSum.reset();
	              (0, _stream_js__WEBPACK_IMPORTED_MODULE_3__.Z)(object, areaStream);
	              return areaSum * 2;
	            }
	          }
	        ),
	        /***/
	        77338: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _adder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(33940);
	            var _area_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(97860);
	            var _cartesian_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(7620);
	            var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(39695);
	            var _stream_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__2(72736);
	            var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum = (0, _adder_js__WEBPACK_IMPORTED_MODULE_0__.Z)(), ranges, range2;
	            var boundsStream = {
	              point: boundsPoint,
	              lineStart: boundsLineStart,
	              lineEnd: boundsLineEnd,
	              polygonStart: function() {
	                boundsStream.point = boundsRingPoint;
	                boundsStream.lineStart = boundsRingStart;
	                boundsStream.lineEnd = boundsRingEnd;
	                deltaSum.reset();
	                _area_js__WEBPACK_IMPORTED_MODULE_1__.gL.polygonStart();
	              },
	              polygonEnd: function() {
	                _area_js__WEBPACK_IMPORTED_MODULE_1__.gL.polygonEnd();
	                boundsStream.point = boundsPoint;
	                boundsStream.lineStart = boundsLineStart;
	                boundsStream.lineEnd = boundsLineEnd;
	                if (_area_js__WEBPACK_IMPORTED_MODULE_1__.L9 < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	                else if (deltaSum > _math_js__WEBPACK_IMPORTED_MODULE_2__.Ho) phi1 = 90;
	                else if (deltaSum < -_math_js__WEBPACK_IMPORTED_MODULE_2__.Ho) phi0 = -90;
	                range2[0] = lambda0, range2[1] = lambda1;
	              },
	              sphere: function() {
	                lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	              }
	            };
	            function boundsPoint(lambda, phi) {
	              ranges.push(range2 = [lambda0 = lambda, lambda1 = lambda]);
	              if (phi < phi0) phi0 = phi;
	              if (phi > phi1) phi1 = phi;
	            }
	            function linePoint(lambda, phi) {
	              var p = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.Og)([lambda * _math_js__WEBPACK_IMPORTED_MODULE_2__.uR, phi * _math_js__WEBPACK_IMPORTED_MODULE_2__.uR]);
	              if (p0) {
	                var normal = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T5)(p0, p), equatorial = [normal[1], -normal[0], 0], inflection = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T5)(equatorial, normal);
	                (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.iJ)(inflection);
	                inflection = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.Y1)(inflection);
	                var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * _math_js__WEBPACK_IMPORTED_MODULE_2__.RW * sign, phii, antimeridian = (0, _math_js__WEBPACK_IMPORTED_MODULE_2__.Wn)(delta) > 180;
	                if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
	                  phii = inflection[1] * _math_js__WEBPACK_IMPORTED_MODULE_2__.RW;
	                  if (phii > phi1) phi1 = phii;
	                } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
	                  phii = -inflection[1] * _math_js__WEBPACK_IMPORTED_MODULE_2__.RW;
	                  if (phii < phi0) phi0 = phii;
	                } else {
	                  if (phi < phi0) phi0 = phi;
	                  if (phi > phi1) phi1 = phi;
	                }
	                if (antimeridian) {
	                  if (lambda < lambda2) {
	                    if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
	                  } else {
	                    if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
	                  }
	                } else {
	                  if (lambda1 >= lambda0) {
	                    if (lambda < lambda0) lambda0 = lambda;
	                    if (lambda > lambda1) lambda1 = lambda;
	                  } else {
	                    if (lambda > lambda2) {
	                      if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
	                    } else {
	                      if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
	                    }
	                  }
	                }
	              } else {
	                ranges.push(range2 = [lambda0 = lambda, lambda1 = lambda]);
	              }
	              if (phi < phi0) phi0 = phi;
	              if (phi > phi1) phi1 = phi;
	              p0 = p, lambda2 = lambda;
	            }
	            function boundsLineStart() {
	              boundsStream.point = linePoint;
	            }
	            function boundsLineEnd() {
	              range2[0] = lambda0, range2[1] = lambda1;
	              boundsStream.point = boundsPoint;
	              p0 = null;
	            }
	            function boundsRingPoint(lambda, phi) {
	              if (p0) {
	                var delta = lambda - lambda2;
	                deltaSum.add((0, _math_js__WEBPACK_IMPORTED_MODULE_2__.Wn)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	              } else {
	                lambda00 = lambda, phi00 = phi;
	              }
	              _area_js__WEBPACK_IMPORTED_MODULE_1__.gL.point(lambda, phi);
	              linePoint(lambda, phi);
	            }
	            function boundsRingStart() {
	              _area_js__WEBPACK_IMPORTED_MODULE_1__.gL.lineStart();
	            }
	            function boundsRingEnd() {
	              boundsRingPoint(lambda00, phi00);
	              _area_js__WEBPACK_IMPORTED_MODULE_1__.gL.lineEnd();
	              if ((0, _math_js__WEBPACK_IMPORTED_MODULE_2__.Wn)(deltaSum) > _math_js__WEBPACK_IMPORTED_MODULE_2__.Ho) lambda0 = -(lambda1 = 180);
	              range2[0] = lambda0, range2[1] = lambda1;
	              p0 = null;
	            }
	            function angle(lambda02, lambda12) {
	              return (lambda12 -= lambda02) < 0 ? lambda12 + 360 : lambda12;
	            }
	            function rangeCompare(a, b) {
	              return a[0] - b[0];
	            }
	            function rangeContains(range3, x) {
	              return range3[0] <= range3[1] ? range3[0] <= x && x <= range3[1] : x < range3[0] || range3[1] < x;
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(feature) {
	              var i, n, a, b, merged, deltaMax, delta;
	              phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
	              ranges = [];
	              (0, _stream_js__WEBPACK_IMPORTED_MODULE_4__.Z)(feature, boundsStream);
	              if (n = ranges.length) {
	                ranges.sort(rangeCompare);
	                for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	                  b = ranges[i];
	                  if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	                  } else {
	                    merged.push(a = b);
	                  }
	                }
	                for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	                  b = merged[i];
	                  if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
	                }
	              }
	              ranges = range2 = null;
	              return lambda0 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0, phi0], [lambda1, phi1]];
	            }
	          }
	        ),
	        /***/
	        7620: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Og: function() {
	                return (
	                  /* binding */
	                  cartesian
	                );
	              },
	              /* harmony export */
	              T: function() {
	                return (
	                  /* binding */
	                  cartesianScale
	                );
	              },
	              /* harmony export */
	              T5: function() {
	                return (
	                  /* binding */
	                  cartesianCross
	                );
	              },
	              /* harmony export */
	              Y1: function() {
	                return (
	                  /* binding */
	                  spherical
	                );
	              },
	              /* harmony export */
	              iJ: function() {
	                return (
	                  /* binding */
	                  cartesianNormalizeInPlace
	                );
	              },
	              /* harmony export */
	              j9: function() {
	                return (
	                  /* binding */
	                  cartesianDot
	                );
	              },
	              /* harmony export */
	              s0: function() {
	                return (
	                  /* binding */
	                  cartesianAddInPlace
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            function spherical(cartesian2) {
	              return [(0, _math_js__WEBPACK_IMPORTED_MODULE_0__.fv)(cartesian2[1], cartesian2[0]), (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.ZR)(cartesian2[2])];
	            }
	            function cartesian(spherical2) {
	              var lambda = spherical2[0], phi = spherical2[1], cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(phi);
	              return [cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(lambda), cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(lambda), (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(phi)];
	            }
	            function cartesianDot(a, b) {
	              return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	            }
	            function cartesianCross(a, b) {
	              return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	            }
	            function cartesianAddInPlace(a, b) {
	              a[0] += b[0], a[1] += b[1], a[2] += b[2];
	            }
	            function cartesianScale(vector, k) {
	              return [vector[0] * k, vector[1] * k, vector[2] * k];
	            }
	            function cartesianNormalizeInPlace(d) {
	              var l = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__._b)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	              d[0] /= l, d[1] /= l, d[2] /= l;
	            }
	          }
	        ),
	        /***/
	        66624: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(39695);
	            var _noop_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(73182);
	            var _stream_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(72736);
	            var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0;
	            var centroidStream = {
	              sphere: _noop_js__WEBPACK_IMPORTED_MODULE_0__.Z,
	              point: centroidPoint,
	              lineStart: centroidLineStart,
	              lineEnd: centroidLineEnd,
	              polygonStart: function() {
	                centroidStream.lineStart = centroidRingStart;
	                centroidStream.lineEnd = centroidRingEnd;
	              },
	              polygonEnd: function() {
	                centroidStream.lineStart = centroidLineStart;
	                centroidStream.lineEnd = centroidLineEnd;
	              }
	            };
	            function centroidPoint(lambda, phi) {
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR;
	              var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi);
	              centroidPointCartesian(cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(lambda), cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda), (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi));
	            }
	            function centroidPointCartesian(x, y, z) {
	              ++W0;
	              X0 += (x - X0) / W0;
	              Y0 += (y - Y0) / W0;
	              Z0 += (z - Z0) / W0;
	            }
	            function centroidLineStart() {
	              centroidStream.point = centroidLinePointFirst;
	            }
	            function centroidLinePointFirst(lambda, phi) {
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR;
	              var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi);
	              x0 = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(lambda);
	              y0 = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda);
	              z0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi);
	              centroidStream.point = centroidLinePoint;
	              centroidPointCartesian(x0, y0, z0);
	            }
	            function centroidLinePoint(lambda, phi) {
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR;
	              var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi), x = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(lambda), y = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda), z = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi), w = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.fv)((0, _math_js__WEBPACK_IMPORTED_MODULE_1__._b)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	              W1 += w;
	              X1 += w * (x0 + (x0 = x));
	              Y1 += w * (y0 + (y0 = y));
	              Z1 += w * (z0 + (z0 = z));
	              centroidPointCartesian(x0, y0, z0);
	            }
	            function centroidLineEnd() {
	              centroidStream.point = centroidPoint;
	            }
	            function centroidRingStart() {
	              centroidStream.point = centroidRingPointFirst;
	            }
	            function centroidRingEnd() {
	              centroidRingPoint(lambda00, phi00);
	              centroidStream.point = centroidPoint;
	            }
	            function centroidRingPointFirst(lambda, phi) {
	              lambda00 = lambda, phi00 = phi;
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR;
	              centroidStream.point = centroidRingPoint;
	              var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi);
	              x0 = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(lambda);
	              y0 = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda);
	              z0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi);
	              centroidPointCartesian(x0, y0, z0);
	            }
	            function centroidRingPoint(lambda, phi) {
	              lambda *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR, phi *= _math_js__WEBPACK_IMPORTED_MODULE_1__.uR;
	              var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi), x = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(lambda), y = cosPhi * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda), z = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__._b)(cx * cx + cy * cy + cz * cz), w = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.ZR)(m), v = m && -w / m;
	              X2 += v * cx;
	              Y2 += v * cy;
	              Z2 += v * cz;
	              W1 += w;
	              X1 += w * (x0 + (x0 = x));
	              Y1 += w * (y0 + (y0 = y));
	              Z1 += w * (z0 + (z0 = z));
	              centroidPointCartesian(x0, y0, z0);
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(object) {
	              W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
	              (0, _stream_js__WEBPACK_IMPORTED_MODULE_2__.Z)(object, centroidStream);
	              var x = X2, y = Y2, z = Z2, m = x * x + y * y + z * z;
	              if (m < _math_js__WEBPACK_IMPORTED_MODULE_1__.aW) {
	                x = X1, y = Y1, z = Z1;
	                if (W1 < _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho) x = X0, y = Y0, z = Z0;
	                m = x * x + y * y + z * z;
	                if (m < _math_js__WEBPACK_IMPORTED_MODULE_1__.aW) return [NaN, NaN];
	              }
	              return [(0, _math_js__WEBPACK_IMPORTED_MODULE_1__.fv)(y, x) * _math_js__WEBPACK_IMPORTED_MODULE_1__.RW, (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.ZR)(z / (0, _math_js__WEBPACK_IMPORTED_MODULE_1__._b)(m)) * _math_js__WEBPACK_IMPORTED_MODULE_1__.RW];
	            }
	          }
	        ),
	        /***/
	        7613: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              m: function() {
	                return (
	                  /* binding */
	                  circleStream
	                );
	              },
	              Z: function() {
	                return (
	                  /* binding */
	                  circle
	                );
	              }
	            });
	            var cartesian = __webpack_require__2(7620);
	            function constant2(x) {
	              return function() {
	                return x;
	              };
	            }
	            var math = __webpack_require__2(39695);
	            var rotation = __webpack_require__2(49386);
	            function circleStream(stream, radius, delta, direction, t0, t1) {
	              if (!delta) return;
	              var cosRadius = (0, math.mC)(radius), sinRadius = (0, math.O$)(radius), step = direction * delta;
	              if (t0 == null) {
	                t0 = radius + direction * math.BZ;
	                t1 = radius - step / 2;
	              } else {
	                t0 = circleRadius(cosRadius, t0);
	                t1 = circleRadius(cosRadius, t1);
	                if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * math.BZ;
	              }
	              for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	                point = (0, cartesian.Y1)([cosRadius, -sinRadius * (0, math.mC)(t), -sinRadius * (0, math.O$)(t)]);
	                stream.point(point[0], point[1]);
	              }
	            }
	            function circleRadius(cosRadius, point) {
	              point = (0, cartesian.Og)(point), point[0] -= cosRadius;
	              (0, cartesian.iJ)(point);
	              var radius = (0, math.Kh)(-point[1]);
	              return ((-point[2] < 0 ? -radius : radius) + math.BZ - math.Ho) % math.BZ;
	            }
	            function circle() {
	              var center = constant2([0, 0]), radius = constant2(90), precision = constant2(6), ring, rotate, stream = { point };
	              function point(x, y) {
	                ring.push(x = rotate(x, y));
	                x[0] *= math.RW, x[1] *= math.RW;
	              }
	              function circle2() {
	                var c = center.apply(this, arguments), r = radius.apply(this, arguments) * math.uR, p = precision.apply(this, arguments) * math.uR;
	                ring = [];
	                rotate = (0, rotation.I)(-c[0] * math.uR, -c[1] * math.uR, 0).invert;
	                circleStream(stream, r, p, 1);
	                c = { type: "Polygon", coordinates: [ring] };
	                ring = rotate = null;
	                return c;
	              }
	              circle2.center = function(_) {
	                return arguments.length ? (center = typeof _ === "function" ? _ : constant2([+_[0], +_[1]]), circle2) : center;
	              };
	              circle2.radius = function(_) {
	                return arguments.length ? (radius = typeof _ === "function" ? _ : constant2(+_), circle2) : radius;
	              };
	              circle2.precision = function(_) {
	                return arguments.length ? (precision = typeof _ === "function" ? _ : constant2(+_), circle2) : precision;
	              };
	              return circle2;
	            }
	          }
	        ),
	        /***/
	        87070: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(97023);
	            var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(39695);
	            __webpack_exports__2.Z = (0, _index_js__WEBPACK_IMPORTED_MODULE_0__.Z)(
	              function() {
	                return true;
	              },
	              clipAntimeridianLine,
	              clipAntimeridianInterpolate,
	              [-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, -_math_js__WEBPACK_IMPORTED_MODULE_1__.ou]
	            );
	            function clipAntimeridianLine(stream) {
	              var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean;
	              return {
	                lineStart: function() {
	                  stream.lineStart();
	                  clean = 1;
	                },
	                point: function(lambda1, phi1) {
	                  var sign1 = lambda1 > 0 ? _math_js__WEBPACK_IMPORTED_MODULE_1__.pi : -_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, delta = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(lambda1 - lambda0);
	                  if ((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(delta - _math_js__WEBPACK_IMPORTED_MODULE_1__.pi) < _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho) {
	                    stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? _math_js__WEBPACK_IMPORTED_MODULE_1__.ou : -_math_js__WEBPACK_IMPORTED_MODULE_1__.ou);
	                    stream.point(sign0, phi0);
	                    stream.lineEnd();
	                    stream.lineStart();
	                    stream.point(sign1, phi0);
	                    stream.point(lambda1, phi0);
	                    clean = 0;
	                  } else if (sign0 !== sign1 && delta >= _math_js__WEBPACK_IMPORTED_MODULE_1__.pi) {
	                    if ((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(lambda0 - sign0) < _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho) lambda0 -= sign0 * _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho;
	                    if ((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(lambda1 - sign1) < _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho) lambda1 -= sign1 * _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho;
	                    phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	                    stream.point(sign0, phi0);
	                    stream.lineEnd();
	                    stream.lineStart();
	                    stream.point(sign1, phi0);
	                    clean = 0;
	                  }
	                  stream.point(lambda0 = lambda1, phi0 = phi1);
	                  sign0 = sign1;
	                },
	                lineEnd: function() {
	                  stream.lineEnd();
	                  lambda0 = phi0 = NaN;
	                },
	                clean: function() {
	                  return 2 - clean;
	                }
	              };
	            }
	            function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	              var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda0 - lambda1);
	              return (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(sinLambda0Lambda1) > _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho ? (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.z4)(((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi0) * (cosPhi1 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi1)) * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda1) - (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi1) * (cosPhi0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi0)) * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
	            }
	            function clipAntimeridianInterpolate(from, to, direction, stream) {
	              var phi;
	              if (from == null) {
	                phi = direction * _math_js__WEBPACK_IMPORTED_MODULE_1__.ou;
	                stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, phi);
	                stream.point(0, phi);
	                stream.point(_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, phi);
	                stream.point(_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, 0);
	                stream.point(_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, -phi);
	                stream.point(0, -phi);
	                stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, -phi);
	                stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, 0);
	                stream.point(-_math_js__WEBPACK_IMPORTED_MODULE_1__.pi, phi);
	              } else if ((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(from[0] - to[0]) > _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho) {
	                var lambda = from[0] < to[0] ? _math_js__WEBPACK_IMPORTED_MODULE_1__.pi : -_math_js__WEBPACK_IMPORTED_MODULE_1__.pi;
	                phi = direction * lambda / 2;
	                stream.point(-lambda, phi);
	                stream.point(0, phi);
	                stream.point(lambda, phi);
	              } else {
	                stream.point(to[0], to[1]);
	              }
	            }
	          }
	        ),
	        /***/
	        85272: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _noop_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(73182);
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              var lines = [], line;
	              return {
	                point: function(x, y, m) {
	                  line.push([x, y, m]);
	                },
	                lineStart: function() {
	                  lines.push(line = []);
	                },
	                lineEnd: _noop_js__WEBPACK_IMPORTED_MODULE_0__.Z,
	                rejoin: function() {
	                  if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	                },
	                result: function() {
	                  var result = lines;
	                  lines = [];
	                  line = null;
	                  return result;
	                }
	              };
	            }
	          }
	        ),
	        /***/
	        1457: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _cartesian_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(7620);
	            var _circle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(7613);
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            var _pointEqual_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(67108);
	            var _index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__2(97023);
	            function __WEBPACK_DEFAULT_EXPORT__(radius) {
	              var cr = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(radius), delta = 6 * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, smallRadius = cr > 0, notHemisphere = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(cr) > _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho;
	              function interpolate(from, to, direction, stream) {
	                (0, _circle_js__WEBPACK_IMPORTED_MODULE_1__.m)(stream, radius, delta, direction, from, to);
	              }
	              function visible(lambda, phi) {
	                return (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(lambda) * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(phi) > cr;
	              }
	              function clipLine(stream) {
	                var point0, c0, v0, v00, clean;
	                return {
	                  lineStart: function() {
	                    v00 = v0 = false;
	                    clean = 1;
	                  },
	                  point: function(lambda, phi) {
	                    var point1 = [lambda, phi], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? _math_js__WEBPACK_IMPORTED_MODULE_0__.pi : -_math_js__WEBPACK_IMPORTED_MODULE_0__.pi), phi) : 0;
	                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
	                    if (v !== v0) {
	                      point2 = intersect(point0, point1);
	                      if (!point2 || (0, _pointEqual_js__WEBPACK_IMPORTED_MODULE_2__.Z)(point0, point2) || (0, _pointEqual_js__WEBPACK_IMPORTED_MODULE_2__.Z)(point1, point2))
	                        point1[2] = 1;
	                    }
	                    if (v !== v0) {
	                      clean = 0;
	                      if (v) {
	                        stream.lineStart();
	                        point2 = intersect(point1, point0);
	                        stream.point(point2[0], point2[1]);
	                      } else {
	                        point2 = intersect(point0, point1);
	                        stream.point(point2[0], point2[1], 2);
	                        stream.lineEnd();
	                      }
	                      point0 = point2;
	                    } else if (notHemisphere && point0 && smallRadius ^ v) {
	                      var t;
	                      if (!(c & c0) && (t = intersect(point1, point0, true))) {
	                        clean = 0;
	                        if (smallRadius) {
	                          stream.lineStart();
	                          stream.point(t[0][0], t[0][1]);
	                          stream.point(t[1][0], t[1][1]);
	                          stream.lineEnd();
	                        } else {
	                          stream.point(t[1][0], t[1][1]);
	                          stream.lineEnd();
	                          stream.lineStart();
	                          stream.point(t[0][0], t[0][1], 3);
	                        }
	                      }
	                    }
	                    if (v && (!point0 || !(0, _pointEqual_js__WEBPACK_IMPORTED_MODULE_2__.Z)(point0, point1))) {
	                      stream.point(point1[0], point1[1]);
	                    }
	                    point0 = point1, v0 = v, c0 = c;
	                  },
	                  lineEnd: function() {
	                    if (v0) stream.lineEnd();
	                    point0 = null;
	                  },
	                  // Rejoin first and last segments if there were intersections and the first
	                  // and last points were visible.
	                  clean: function() {
	                    return clean | (v00 && v0) << 1;
	                  }
	                };
	              }
	              function intersect(a, b, two) {
	                var pa = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.Og)(a), pb = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.Og)(b);
	                var n1 = [1, 0, 0], n2 = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T5)(pa, pb), n2n2 = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.j9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	                if (!determinant) return !two && a;
	                var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T5)(n1, n2), A = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T)(n1, c1), B = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T)(n2, c2);
	                (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.s0)(A, B);
	                var u = n1xn2, w = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.j9)(A, u), uu = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.j9)(u, u), t2 = w * w - uu * ((0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.j9)(A, A) - 1);
	                if (t2 < 0) return;
	                var t = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__._b)(t2), q = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T)(u, (-w - t) / uu);
	                (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.s0)(q, A);
	                q = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.Y1)(q);
	                if (!two) return q;
	                var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
	                if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	                var delta2 = lambda1 - lambda0, polar = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(delta2 - _math_js__WEBPACK_IMPORTED_MODULE_0__.pi) < _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho, meridian = polar || delta2 < _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho;
	                if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	                if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(q[0] - lambda0) < _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta2 > _math_js__WEBPACK_IMPORTED_MODULE_0__.pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	                  var q1 = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.T)(u, (-w + t) / uu);
	                  (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.s0)(q1, A);
	                  return [q, (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_3__.Y1)(q1)];
	                }
	              }
	              function code(lambda, phi) {
	                var r = smallRadius ? radius : _math_js__WEBPACK_IMPORTED_MODULE_0__.pi - radius, code2 = 0;
	                if (lambda < -r) code2 |= 1;
	                else if (lambda > r) code2 |= 2;
	                if (phi < -r) code2 |= 4;
	                else if (phi > r) code2 |= 8;
	                return code2;
	              }
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_4__.Z)(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-_math_js__WEBPACK_IMPORTED_MODULE_0__.pi, radius - _math_js__WEBPACK_IMPORTED_MODULE_0__.pi]);
	            }
	          }
	        ),
	        /***/
	        97023: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _buffer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(85272);
	            var _rejoin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(46225);
	            var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__2(39695);
	            var _polygonContains_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(23071);
	            var d3_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(33064);
	            function __WEBPACK_DEFAULT_EXPORT__(pointVisible, clipLine, interpolate, start) {
	              return function(sink) {
	                var line = clipLine(sink), ringBuffer = (0, _buffer_js__WEBPACK_IMPORTED_MODULE_1__.Z)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
	                var clip = {
	                  point,
	                  lineStart,
	                  lineEnd,
	                  polygonStart: function() {
	                    clip.point = pointRing;
	                    clip.lineStart = ringStart;
	                    clip.lineEnd = ringEnd;
	                    segments = [];
	                    polygon = [];
	                  },
	                  polygonEnd: function() {
	                    clip.point = point;
	                    clip.lineStart = lineStart;
	                    clip.lineEnd = lineEnd;
	                    segments = (0, d3_array__WEBPACK_IMPORTED_MODULE_0__.TS)(segments);
	                    var startInside = (0, _polygonContains_js__WEBPACK_IMPORTED_MODULE_2__.Z)(polygon, start);
	                    if (segments.length) {
	                      if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	                      (0, _rejoin_js__WEBPACK_IMPORTED_MODULE_3__.Z)(segments, compareIntersection, startInside, interpolate, sink);
	                    } else if (startInside) {
	                      if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	                      sink.lineStart();
	                      interpolate(null, null, 1, sink);
	                      sink.lineEnd();
	                    }
	                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	                    segments = polygon = null;
	                  },
	                  sphere: function() {
	                    sink.polygonStart();
	                    sink.lineStart();
	                    interpolate(null, null, 1, sink);
	                    sink.lineEnd();
	                    sink.polygonEnd();
	                  }
	                };
	                function point(lambda, phi) {
	                  if (pointVisible(lambda, phi)) sink.point(lambda, phi);
	                }
	                function pointLine(lambda, phi) {
	                  line.point(lambda, phi);
	                }
	                function lineStart() {
	                  clip.point = pointLine;
	                  line.lineStart();
	                }
	                function lineEnd() {
	                  clip.point = point;
	                  line.lineEnd();
	                }
	                function pointRing(lambda, phi) {
	                  ring.push([lambda, phi]);
	                  ringSink.point(lambda, phi);
	                }
	                function ringStart() {
	                  ringSink.lineStart();
	                  ring = [];
	                }
	                function ringEnd() {
	                  pointRing(ring[0][0], ring[0][1]);
	                  ringSink.lineEnd();
	                  var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point2;
	                  ring.pop();
	                  polygon.push(ring);
	                  ring = null;
	                  if (!n) return;
	                  if (clean & 1) {
	                    segment = ringSegments[0];
	                    if ((m = segment.length - 1) > 0) {
	                      if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	                      sink.lineStart();
	                      for (i = 0; i < m; ++i) sink.point((point2 = segment[i])[0], point2[1]);
	                      sink.lineEnd();
	                    }
	                    return;
	                  }
	                  if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	                  segments.push(ringSegments.filter(validSegment));
	                }
	                return clip;
	              };
	            }
	            function validSegment(segment) {
	              return segment.length > 1;
	            }
	            function compareIntersection(a, b) {
	              return ((a = a.x)[0] < 0 ? a[1] - _math_js__WEBPACK_IMPORTED_MODULE_4__.ou - _math_js__WEBPACK_IMPORTED_MODULE_4__.Ho : _math_js__WEBPACK_IMPORTED_MODULE_4__.ou - a[1]) - ((b = b.x)[0] < 0 ? b[1] - _math_js__WEBPACK_IMPORTED_MODULE_4__.ou - _math_js__WEBPACK_IMPORTED_MODULE_4__.Ho : _math_js__WEBPACK_IMPORTED_MODULE_4__.ou - b[1]);
	            }
	          }
	        ),
	        /***/
	        87605: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              Z: function() {
	                return (
	                  /* binding */
	                  clipRectangle
	                );
	              }
	            });
	            var math = __webpack_require__2(39695);
	            var buffer = __webpack_require__2(85272);
	            function line(a, b, x0, y0, x1, y1) {
	              var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	              r = x0 - ax;
	              if (!dx && r > 0) return;
	              r /= dx;
	              if (dx < 0) {
	                if (r < t0) return;
	                if (r < t1) t1 = r;
	              } else if (dx > 0) {
	                if (r > t1) return;
	                if (r > t0) t0 = r;
	              }
	              r = x1 - ax;
	              if (!dx && r < 0) return;
	              r /= dx;
	              if (dx < 0) {
	                if (r > t1) return;
	                if (r > t0) t0 = r;
	              } else if (dx > 0) {
	                if (r < t0) return;
	                if (r < t1) t1 = r;
	              }
	              r = y0 - ay;
	              if (!dy && r > 0) return;
	              r /= dy;
	              if (dy < 0) {
	                if (r < t0) return;
	                if (r < t1) t1 = r;
	              } else if (dy > 0) {
	                if (r > t1) return;
	                if (r > t0) t0 = r;
	              }
	              r = y1 - ay;
	              if (!dy && r < 0) return;
	              r /= dy;
	              if (dy < 0) {
	                if (r > t1) return;
	                if (r > t0) t0 = r;
	              } else if (dy > 0) {
	                if (r < t0) return;
	                if (r < t1) t1 = r;
	              }
	              if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	              if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	              return true;
	            }
	            var rejoin = __webpack_require__2(46225);
	            var src = __webpack_require__2(33064);
	            var clipMax = 1e9, clipMin = -1e9;
	            function clipRectangle(x0, y0, x1, y1) {
	              function visible(x, y) {
	                return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	              }
	              function interpolate(from, to, direction, stream) {
	                var a = 0, a1 = 0;
	                if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
	                  do
	                    stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	                  while ((a = (a + direction + 4) % 4) !== a1);
	                } else {
	                  stream.point(to[0], to[1]);
	                }
	              }
	              function corner(p, direction) {
	                return (0, math.Wn)(p[0] - x0) < math.Ho ? direction > 0 ? 0 : 3 : (0, math.Wn)(p[0] - x1) < math.Ho ? direction > 0 ? 2 : 1 : (0, math.Wn)(p[1] - y0) < math.Ho ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	              }
	              function compareIntersection(a, b) {
	                return comparePoint(a.x, b.x);
	              }
	              function comparePoint(a, b) {
	                var ca = corner(a, 1), cb = corner(b, 1);
	                return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	              }
	              return function(stream) {
	                var activeStream = stream, bufferStream = (0, buffer.Z)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
	                var clipStream = {
	                  point,
	                  lineStart,
	                  lineEnd,
	                  polygonStart,
	                  polygonEnd
	                };
	                function point(x, y) {
	                  if (visible(x, y)) activeStream.point(x, y);
	                }
	                function polygonInside() {
	                  var winding = 0;
	                  for (var i = 0, n = polygon.length; i < n; ++i) {
	                    for (var ring2 = polygon[i], j = 1, m = ring2.length, point2 = ring2[0], a0, a1, b0 = point2[0], b1 = point2[1]; j < m; ++j) {
	                      a0 = b0, a1 = b1, point2 = ring2[j], b0 = point2[0], b1 = point2[1];
	                      if (a1 <= y1) {
	                        if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
	                      } else {
	                        if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
	                      }
	                    }
	                  }
	                  return winding;
	                }
	                function polygonStart() {
	                  activeStream = bufferStream, segments = [], polygon = [], clean = true;
	                }
	                function polygonEnd() {
	                  var startInside = polygonInside(), cleanInside = clean && startInside, visible2 = (segments = (0, src.TS)(segments)).length;
	                  if (cleanInside || visible2) {
	                    stream.polygonStart();
	                    if (cleanInside) {
	                      stream.lineStart();
	                      interpolate(null, null, 1, stream);
	                      stream.lineEnd();
	                    }
	                    if (visible2) {
	                      (0, rejoin.Z)(segments, compareIntersection, startInside, interpolate, stream);
	                    }
	                    stream.polygonEnd();
	                  }
	                  activeStream = stream, segments = polygon = ring = null;
	                }
	                function lineStart() {
	                  clipStream.point = linePoint;
	                  if (polygon) polygon.push(ring = []);
	                  first = true;
	                  v_ = false;
	                  x_ = y_ = NaN;
	                }
	                function lineEnd() {
	                  if (segments) {
	                    linePoint(x__, y__);
	                    if (v__ && v_) bufferStream.rejoin();
	                    segments.push(bufferStream.result());
	                  }
	                  clipStream.point = point;
	                  if (v_) activeStream.lineEnd();
	                }
	                function linePoint(x, y) {
	                  var v = visible(x, y);
	                  if (polygon) ring.push([x, y]);
	                  if (first) {
	                    x__ = x, y__ = y, v__ = v;
	                    first = false;
	                    if (v) {
	                      activeStream.lineStart();
	                      activeStream.point(x, y);
	                    }
	                  } else {
	                    if (v && v_) activeStream.point(x, y);
	                    else {
	                      var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))], b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	                      if (line(a, b, x0, y0, x1, y1)) {
	                        if (!v_) {
	                          activeStream.lineStart();
	                          activeStream.point(a[0], a[1]);
	                        }
	                        activeStream.point(b[0], b[1]);
	                        if (!v) activeStream.lineEnd();
	                        clean = false;
	                      } else if (v) {
	                        activeStream.lineStart();
	                        activeStream.point(x, y);
	                        clean = false;
	                      }
	                    }
	                  }
	                  x_ = x, y_ = y, v_ = v;
	                }
	                return clipStream;
	              };
	            }
	          }
	        ),
	        /***/
	        46225: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _pointEqual_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(67108);
	            var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(39695);
	            function Intersection(point, points, other, entry) {
	              this.x = point;
	              this.z = points;
	              this.o = other;
	              this.e = entry;
	              this.v = false;
	              this.n = this.p = null;
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(segments, compareIntersection, startInside, interpolate, stream) {
	              var subject = [], clip = [], i, n;
	              segments.forEach(function(segment) {
	                if ((n2 = segment.length - 1) <= 0) return;
	                var n2, p0 = segment[0], p1 = segment[n2], x;
	                if ((0, _pointEqual_js__WEBPACK_IMPORTED_MODULE_0__.Z)(p0, p1)) {
	                  if (!p0[2] && !p1[2]) {
	                    stream.lineStart();
	                    for (i = 0; i < n2; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	                    stream.lineEnd();
	                    return;
	                  }
	                  p1[0] += 2 * _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho;
	                }
	                subject.push(x = new Intersection(p0, segment, null, true));
	                clip.push(x.o = new Intersection(p0, null, x, false));
	                subject.push(x = new Intersection(p1, segment, null, false));
	                clip.push(x.o = new Intersection(p1, null, x, true));
	              });
	              if (!subject.length) return;
	              clip.sort(compareIntersection);
	              link(subject);
	              link(clip);
	              for (i = 0, n = clip.length; i < n; ++i) {
	                clip[i].e = startInside = !startInside;
	              }
	              var start = subject[0], points, point;
	              while (1) {
	                var current = start, isSubject = true;
	                while (current.v) if ((current = current.n) === start) return;
	                points = current.z;
	                stream.lineStart();
	                do {
	                  current.v = current.o.v = true;
	                  if (current.e) {
	                    if (isSubject) {
	                      for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	                    } else {
	                      interpolate(current.x, current.n.x, 1, stream);
	                    }
	                    current = current.n;
	                  } else {
	                    if (isSubject) {
	                      points = current.p.z;
	                      for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	                    } else {
	                      interpolate(current.x, current.p.x, -1, stream);
	                    }
	                    current = current.p;
	                  }
	                  current = current.o;
	                  points = current.z;
	                  isSubject = !isSubject;
	                } while (!current.v);
	                stream.lineEnd();
	              }
	            }
	            function link(array) {
	              if (!(n = array.length)) return;
	              var n, i = 0, a = array[0], b;
	              while (++i < n) {
	                a.n = b = array[i];
	                b.p = a;
	                a = b;
	              }
	              a.n = b = array[0];
	              b.p = a;
	            }
	          }
	        ),
	        /***/
	        96059: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            function __WEBPACK_DEFAULT_EXPORT__(a, b) {
	              function compose(x, y) {
	                return x = a(x, y), b(x[0], x[1]);
	              }
	              if (a.invert && b.invert) compose.invert = function(x, y) {
	                return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	              };
	              return compose;
	            }
	          }
	        ),
	        /***/
	        8593: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            function __WEBPACK_DEFAULT_EXPORT__(x) {
	              return x;
	            }
	          }
	        ),
	        /***/
	        27362: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              geoAlbers: function() {
	                return (
	                  /* reexport */
	                  albers
	                );
	              },
	              geoAlbersUsa: function() {
	                return (
	                  /* reexport */
	                  albersUsa
	                );
	              },
	              geoArea: function() {
	                return (
	                  /* reexport */
	                  src_area.ZP
	                );
	              },
	              geoAzimuthalEqualArea: function() {
	                return (
	                  /* reexport */
	                  azimuthalEqualArea.Z
	                );
	              },
	              geoAzimuthalEqualAreaRaw: function() {
	                return (
	                  /* reexport */
	                  azimuthalEqualArea.l
	                );
	              },
	              geoAzimuthalEquidistant: function() {
	                return (
	                  /* reexport */
	                  azimuthalEquidistant.Z
	                );
	              },
	              geoAzimuthalEquidistantRaw: function() {
	                return (
	                  /* reexport */
	                  azimuthalEquidistant.N
	                );
	              },
	              geoBounds: function() {
	                return (
	                  /* reexport */
	                  bounds.Z
	                );
	              },
	              geoCentroid: function() {
	                return (
	                  /* reexport */
	                  centroid.Z
	                );
	              },
	              geoCircle: function() {
	                return (
	                  /* reexport */
	                  circle.Z
	                );
	              },
	              geoClipAntimeridian: function() {
	                return (
	                  /* reexport */
	                  antimeridian.Z
	                );
	              },
	              geoClipCircle: function() {
	                return (
	                  /* reexport */
	                  clip_circle.Z
	                );
	              },
	              geoClipExtent: function() {
	                return (
	                  /* reexport */
	                  extent2
	                );
	              },
	              geoClipRectangle: function() {
	                return (
	                  /* reexport */
	                  rectangle.Z
	                );
	              },
	              geoConicConformal: function() {
	                return (
	                  /* reexport */
	                  conicConformal
	                );
	              },
	              geoConicConformalRaw: function() {
	                return (
	                  /* reexport */
	                  conicConformalRaw
	                );
	              },
	              geoConicEqualArea: function() {
	                return (
	                  /* reexport */
	                  conicEqualArea
	                );
	              },
	              geoConicEqualAreaRaw: function() {
	                return (
	                  /* reexport */
	                  conicEqualAreaRaw
	                );
	              },
	              geoConicEquidistant: function() {
	                return (
	                  /* reexport */
	                  conicEquidistant
	                );
	              },
	              geoConicEquidistantRaw: function() {
	                return (
	                  /* reexport */
	                  conicEquidistantRaw
	                );
	              },
	              geoContains: function() {
	                return (
	                  /* reexport */
	                  contains
	                );
	              },
	              geoDistance: function() {
	                return (
	                  /* reexport */
	                  distance
	                );
	              },
	              geoEqualEarth: function() {
	                return (
	                  /* reexport */
	                  equalEarth
	                );
	              },
	              geoEqualEarthRaw: function() {
	                return (
	                  /* reexport */
	                  equalEarthRaw
	                );
	              },
	              geoEquirectangular: function() {
	                return (
	                  /* reexport */
	                  equirectangular.Z
	                );
	              },
	              geoEquirectangularRaw: function() {
	                return (
	                  /* reexport */
	                  equirectangular.k
	                );
	              },
	              geoGnomonic: function() {
	                return (
	                  /* reexport */
	                  gnomonic.Z
	                );
	              },
	              geoGnomonicRaw: function() {
	                return (
	                  /* reexport */
	                  gnomonic.M
	                );
	              },
	              geoGraticule: function() {
	                return (
	                  /* reexport */
	                  graticule
	                );
	              },
	              geoGraticule10: function() {
	                return (
	                  /* reexport */
	                  graticule10
	                );
	              },
	              geoIdentity: function() {
	                return (
	                  /* reexport */
	                  projection_identity
	                );
	              },
	              geoInterpolate: function() {
	                return (
	                  /* reexport */
	                  interpolate.Z
	                );
	              },
	              geoLength: function() {
	                return (
	                  /* reexport */
	                  src_length
	                );
	              },
	              geoMercator: function() {
	                return (
	                  /* reexport */
	                  mercator
	                );
	              },
	              geoMercatorRaw: function() {
	                return (
	                  /* reexport */
	                  mercatorRaw
	                );
	              },
	              geoNaturalEarth1: function() {
	                return (
	                  /* reexport */
	                  naturalEarth1.Z
	                );
	              },
	              geoNaturalEarth1Raw: function() {
	                return (
	                  /* reexport */
	                  naturalEarth1.K
	                );
	              },
	              geoOrthographic: function() {
	                return (
	                  /* reexport */
	                  orthographic.Z
	                );
	              },
	              geoOrthographicRaw: function() {
	                return (
	                  /* reexport */
	                  orthographic.I
	                );
	              },
	              geoPath: function() {
	                return (
	                  /* reexport */
	                  path
	                );
	              },
	              geoProjection: function() {
	                return (
	                  /* reexport */
	                  projection.Z
	                );
	              },
	              geoProjectionMutator: function() {
	                return (
	                  /* reexport */
	                  projection.r
	                );
	              },
	              geoRotation: function() {
	                return (
	                  /* reexport */
	                  rotation.Z
	                );
	              },
	              geoStereographic: function() {
	                return (
	                  /* reexport */
	                  stereographic
	                );
	              },
	              geoStereographicRaw: function() {
	                return (
	                  /* reexport */
	                  stereographicRaw
	                );
	              },
	              geoStream: function() {
	                return (
	                  /* reexport */
	                  stream.Z
	                );
	              },
	              geoTransform: function() {
	                return (
	                  /* reexport */
	                  src_transform.Z
	                );
	              },
	              geoTransverseMercator: function() {
	                return (
	                  /* reexport */
	                  transverseMercator
	                );
	              },
	              geoTransverseMercatorRaw: function() {
	                return (
	                  /* reexport */
	                  transverseMercatorRaw
	                );
	              }
	            });
	            var src_area = __webpack_require__2(97860);
	            var bounds = __webpack_require__2(77338);
	            var centroid = __webpack_require__2(66624);
	            var circle = __webpack_require__2(7613);
	            var antimeridian = __webpack_require__2(87070);
	            var clip_circle = __webpack_require__2(1457);
	            var rectangle = __webpack_require__2(87605);
	            function extent2() {
	              var x02 = 0, y02 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
	              return clip = {
	                stream: function(stream2) {
	                  return cache && cacheStream === stream2 ? cache : cache = (0, rectangle.Z)(x02, y02, x1, y1)(cacheStream = stream2);
	                },
	                extent: function(_) {
	                  return arguments.length ? (x02 = +_[0][0], y02 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x02, y02], [x1, y1]];
	                }
	              };
	            }
	            var polygonContains = __webpack_require__2(23071);
	            var adder = __webpack_require__2(33940);
	            var math = __webpack_require__2(39695);
	            var noop = __webpack_require__2(73182);
	            var stream = __webpack_require__2(72736);
	            var lengthSum = (0, adder.Z)(), lambda0, sinPhi0, cosPhi0;
	            var lengthStream = {
	              sphere: noop.Z,
	              point: noop.Z,
	              lineStart: lengthLineStart,
	              lineEnd: noop.Z,
	              polygonStart: noop.Z,
	              polygonEnd: noop.Z
	            };
	            function lengthLineStart() {
	              lengthStream.point = lengthPointFirst;
	              lengthStream.lineEnd = lengthLineEnd;
	            }
	            function lengthLineEnd() {
	              lengthStream.point = lengthStream.lineEnd = noop.Z;
	            }
	            function lengthPointFirst(lambda, phi) {
	              lambda *= math.uR, phi *= math.uR;
	              lambda0 = lambda, sinPhi0 = (0, math.O$)(phi), cosPhi0 = (0, math.mC)(phi);
	              lengthStream.point = lengthPoint;
	            }
	            function lengthPoint(lambda, phi) {
	              lambda *= math.uR, phi *= math.uR;
	              var sinPhi = (0, math.O$)(phi), cosPhi = (0, math.mC)(phi), delta = (0, math.Wn)(lambda - lambda0), cosDelta = (0, math.mC)(delta), sinDelta = (0, math.O$)(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
	              lengthSum.add((0, math.fv)((0, math._b)(x * x + y * y), z));
	              lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
	            }
	            function src_length(object2) {
	              lengthSum.reset();
	              (0, stream.Z)(object2, lengthStream);
	              return +lengthSum;
	            }
	            var coordinates = [null, null], object = { type: "LineString", coordinates };
	            function distance(a, b) {
	              coordinates[0] = a;
	              coordinates[1] = b;
	              return src_length(object);
	            }
	            var containsObjectType = {
	              Feature: function(object2, point) {
	                return containsGeometry(object2.geometry, point);
	              },
	              FeatureCollection: function(object2, point) {
	                var features = object2.features, i = -1, n = features.length;
	                while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	                return false;
	              }
	            };
	            var containsGeometryType = {
	              Sphere: function() {
	                return true;
	              },
	              Point: function(object2, point) {
	                return containsPoint(object2.coordinates, point);
	              },
	              MultiPoint: function(object2, point) {
	                var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
	                while (++i < n) if (containsPoint(coordinates2[i], point)) return true;
	                return false;
	              },
	              LineString: function(object2, point) {
	                return containsLine(object2.coordinates, point);
	              },
	              MultiLineString: function(object2, point) {
	                var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
	                while (++i < n) if (containsLine(coordinates2[i], point)) return true;
	                return false;
	              },
	              Polygon: function(object2, point) {
	                return containsPolygon(object2.coordinates, point);
	              },
	              MultiPolygon: function(object2, point) {
	                var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
	                while (++i < n) if (containsPolygon(coordinates2[i], point)) return true;
	                return false;
	              },
	              GeometryCollection: function(object2, point) {
	                var geometries = object2.geometries, i = -1, n = geometries.length;
	                while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	                return false;
	              }
	            };
	            function containsGeometry(geometry, point) {
	              return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
	            }
	            function containsPoint(coordinates2, point) {
	              return distance(coordinates2, point) === 0;
	            }
	            function containsLine(coordinates2, point) {
	              var ao, bo, ab;
	              for (var i = 0, n = coordinates2.length; i < n; i++) {
	                bo = distance(coordinates2[i], point);
	                if (bo === 0) return true;
	                if (i > 0) {
	                  ab = distance(coordinates2[i], coordinates2[i - 1]);
	                  if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < math.aW * ab)
	                    return true;
	                }
	                ao = bo;
	              }
	              return false;
	            }
	            function containsPolygon(coordinates2, point) {
	              return !!(0, polygonContains.Z)(coordinates2.map(ringRadians), pointRadians(point));
	            }
	            function ringRadians(ring) {
	              return ring = ring.map(pointRadians), ring.pop(), ring;
	            }
	            function pointRadians(point) {
	              return [point[0] * math.uR, point[1] * math.uR];
	            }
	            function contains(object2, point) {
	              return (object2 && containsObjectType.hasOwnProperty(object2.type) ? containsObjectType[object2.type] : containsGeometry)(object2, point);
	            }
	            var src = __webpack_require__2(33064);
	            function graticuleX(y02, y1, dy) {
	              var y = (0, src.w6)(y02, y1 - math.Ho, dy).concat(y1);
	              return function(x) {
	                return y.map(function(y2) {
	                  return [x, y2];
	                });
	              };
	            }
	            function graticuleY(x02, x1, dx) {
	              var x = (0, src.w6)(x02, x1 - math.Ho, dx).concat(x1);
	              return function(y) {
	                return x.map(function(x2) {
	                  return [x2, y];
	                });
	              };
	            }
	            function graticule() {
	              var x1, x02, X12, X02, y1, y02, Y12, Y02, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	              function graticule2() {
	                return { type: "MultiLineString", coordinates: lines() };
	              }
	              function lines() {
	                return (0, src.w6)((0, math.mD)(X02 / DX) * DX, X12, DX).map(X).concat((0, src.w6)((0, math.mD)(Y02 / DY) * DY, Y12, DY).map(Y)).concat((0, src.w6)((0, math.mD)(x02 / dx) * dx, x1, dx).filter(function(x2) {
	                  return (0, math.Wn)(x2 % DX) > math.Ho;
	                }).map(x)).concat((0, src.w6)((0, math.mD)(y02 / dy) * dy, y1, dy).filter(function(y2) {
	                  return (0, math.Wn)(y2 % DY) > math.Ho;
	                }).map(y));
	              }
	              graticule2.lines = function() {
	                return lines().map(function(coordinates2) {
	                  return { type: "LineString", coordinates: coordinates2 };
	                });
	              };
	              graticule2.outline = function() {
	                return {
	                  type: "Polygon",
	                  coordinates: [
	                    X(X02).concat(
	                      Y(Y12).slice(1),
	                      X(X12).reverse().slice(1),
	                      Y(Y02).reverse().slice(1)
	                    )
	                  ]
	                };
	              };
	              graticule2.extent = function(_) {
	                if (!arguments.length) return graticule2.extentMinor();
	                return graticule2.extentMajor(_).extentMinor(_);
	              };
	              graticule2.extentMajor = function(_) {
	                if (!arguments.length) return [[X02, Y02], [X12, Y12]];
	                X02 = +_[0][0], X12 = +_[1][0];
	                Y02 = +_[0][1], Y12 = +_[1][1];
	                if (X02 > X12) _ = X02, X02 = X12, X12 = _;
	                if (Y02 > Y12) _ = Y02, Y02 = Y12, Y12 = _;
	                return graticule2.precision(precision);
	              };
	              graticule2.extentMinor = function(_) {
	                if (!arguments.length) return [[x02, y02], [x1, y1]];
	                x02 = +_[0][0], x1 = +_[1][0];
	                y02 = +_[0][1], y1 = +_[1][1];
	                if (x02 > x1) _ = x02, x02 = x1, x1 = _;
	                if (y02 > y1) _ = y02, y02 = y1, y1 = _;
	                return graticule2.precision(precision);
	              };
	              graticule2.step = function(_) {
	                if (!arguments.length) return graticule2.stepMinor();
	                return graticule2.stepMajor(_).stepMinor(_);
	              };
	              graticule2.stepMajor = function(_) {
	                if (!arguments.length) return [DX, DY];
	                DX = +_[0], DY = +_[1];
	                return graticule2;
	              };
	              graticule2.stepMinor = function(_) {
	                if (!arguments.length) return [dx, dy];
	                dx = +_[0], dy = +_[1];
	                return graticule2;
	              };
	              graticule2.precision = function(_) {
	                if (!arguments.length) return precision;
	                precision = +_;
	                x = graticuleX(y02, y1, 90);
	                y = graticuleY(x02, x1, precision);
	                X = graticuleX(Y02, Y12, 90);
	                Y = graticuleY(X02, X12, precision);
	                return graticule2;
	              };
	              return graticule2.extentMajor([[-180, -90 + math.Ho], [180, 90 - math.Ho]]).extentMinor([[-180, -80 - math.Ho], [180, 80 + math.Ho]]);
	            }
	            function graticule10() {
	              return graticule()();
	            }
	            var interpolate = __webpack_require__2(83074);
	            var identity2 = __webpack_require__2(8593);
	            var areaSum = (0, adder.Z)(), areaRingSum = (0, adder.Z)(), x00, y00, x0, y0;
	            var areaStream = {
	              point: noop.Z,
	              lineStart: noop.Z,
	              lineEnd: noop.Z,
	              polygonStart: function() {
	                areaStream.lineStart = areaRingStart;
	                areaStream.lineEnd = areaRingEnd;
	              },
	              polygonEnd: function() {
	                areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop.Z;
	                areaSum.add((0, math.Wn)(areaRingSum));
	                areaRingSum.reset();
	              },
	              result: function() {
	                var area = areaSum / 2;
	                areaSum.reset();
	                return area;
	              }
	            };
	            function areaRingStart() {
	              areaStream.point = areaPointFirst;
	            }
	            function areaPointFirst(x, y) {
	              areaStream.point = areaPoint;
	              x00 = x0 = x, y00 = y0 = y;
	            }
	            function areaPoint(x, y) {
	              areaRingSum.add(y0 * x - x0 * y);
	              x0 = x, y0 = y;
	            }
	            function areaRingEnd() {
	              areaPoint(x00, y00);
	            }
	            var path_area = areaStream;
	            var path_bounds = __webpack_require__2(3559);
	            var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, centroid_x00, centroid_y00, centroid_x0, centroid_y0;
	            var centroidStream = {
	              point: centroidPoint,
	              lineStart: centroidLineStart,
	              lineEnd: centroidLineEnd,
	              polygonStart: function() {
	                centroidStream.lineStart = centroidRingStart;
	                centroidStream.lineEnd = centroidRingEnd;
	              },
	              polygonEnd: function() {
	                centroidStream.point = centroidPoint;
	                centroidStream.lineStart = centroidLineStart;
	                centroidStream.lineEnd = centroidLineEnd;
	              },
	              result: function() {
	                var centroid2 = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
	                X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
	                return centroid2;
	              }
	            };
	            function centroidPoint(x, y) {
	              X0 += x;
	              Y0 += y;
	              ++Z0;
	            }
	            function centroidLineStart() {
	              centroidStream.point = centroidPointFirstLine;
	            }
	            function centroidPointFirstLine(x, y) {
	              centroidStream.point = centroidPointLine;
	              centroidPoint(centroid_x0 = x, centroid_y0 = y);
	            }
	            function centroidPointLine(x, y) {
	              var dx = x - centroid_x0, dy = y - centroid_y0, z = (0, math._b)(dx * dx + dy * dy);
	              X1 += z * (centroid_x0 + x) / 2;
	              Y1 += z * (centroid_y0 + y) / 2;
	              Z1 += z;
	              centroidPoint(centroid_x0 = x, centroid_y0 = y);
	            }
	            function centroidLineEnd() {
	              centroidStream.point = centroidPoint;
	            }
	            function centroidRingStart() {
	              centroidStream.point = centroidPointFirstRing;
	            }
	            function centroidRingEnd() {
	              centroidPointRing(centroid_x00, centroid_y00);
	            }
	            function centroidPointFirstRing(x, y) {
	              centroidStream.point = centroidPointRing;
	              centroidPoint(centroid_x00 = centroid_x0 = x, centroid_y00 = centroid_y0 = y);
	            }
	            function centroidPointRing(x, y) {
	              var dx = x - centroid_x0, dy = y - centroid_y0, z = (0, math._b)(dx * dx + dy * dy);
	              X1 += z * (centroid_x0 + x) / 2;
	              Y1 += z * (centroid_y0 + y) / 2;
	              Z1 += z;
	              z = centroid_y0 * x - centroid_x0 * y;
	              X2 += z * (centroid_x0 + x);
	              Y2 += z * (centroid_y0 + y);
	              Z2 += z * 3;
	              centroidPoint(centroid_x0 = x, centroid_y0 = y);
	            }
	            var path_centroid = centroidStream;
	            function PathContext(context) {
	              this._context = context;
	            }
	            PathContext.prototype = {
	              _radius: 4.5,
	              pointRadius: function(_) {
	                return this._radius = _, this;
	              },
	              polygonStart: function() {
	                this._line = 0;
	              },
	              polygonEnd: function() {
	                this._line = NaN;
	              },
	              lineStart: function() {
	                this._point = 0;
	              },
	              lineEnd: function() {
	                if (this._line === 0) this._context.closePath();
	                this._point = NaN;
	              },
	              point: function(x, y) {
	                switch (this._point) {
	                  case 0: {
	                    this._context.moveTo(x, y);
	                    this._point = 1;
	                    break;
	                  }
	                  case 1: {
	                    this._context.lineTo(x, y);
	                    break;
	                  }
	                  default: {
	                    this._context.moveTo(x + this._radius, y);
	                    this._context.arc(x, y, this._radius, 0, math.BZ);
	                    break;
	                  }
	                }
	              },
	              result: noop.Z
	            };
	            var measure_lengthSum = (0, adder.Z)(), lengthRing, measure_x00, measure_y00, measure_x0, measure_y0;
	            var measure_lengthStream = {
	              point: noop.Z,
	              lineStart: function() {
	                measure_lengthStream.point = measure_lengthPointFirst;
	              },
	              lineEnd: function() {
	                if (lengthRing) measure_lengthPoint(measure_x00, measure_y00);
	                measure_lengthStream.point = noop.Z;
	              },
	              polygonStart: function() {
	                lengthRing = true;
	              },
	              polygonEnd: function() {
	                lengthRing = null;
	              },
	              result: function() {
	                var length = +measure_lengthSum;
	                measure_lengthSum.reset();
	                return length;
	              }
	            };
	            function measure_lengthPointFirst(x, y) {
	              measure_lengthStream.point = measure_lengthPoint;
	              measure_x00 = measure_x0 = x, measure_y00 = measure_y0 = y;
	            }
	            function measure_lengthPoint(x, y) {
	              measure_x0 -= x, measure_y0 -= y;
	              measure_lengthSum.add((0, math._b)(measure_x0 * measure_x0 + measure_y0 * measure_y0));
	              measure_x0 = x, measure_y0 = y;
	            }
	            var measure = measure_lengthStream;
	            function PathString() {
	              this._string = [];
	            }
	            PathString.prototype = {
	              _radius: 4.5,
	              _circle: string_circle(4.5),
	              pointRadius: function(_) {
	                if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
	                return this;
	              },
	              polygonStart: function() {
	                this._line = 0;
	              },
	              polygonEnd: function() {
	                this._line = NaN;
	              },
	              lineStart: function() {
	                this._point = 0;
	              },
	              lineEnd: function() {
	                if (this._line === 0) this._string.push("Z");
	                this._point = NaN;
	              },
	              point: function(x, y) {
	                switch (this._point) {
	                  case 0: {
	                    this._string.push("M", x, ",", y);
	                    this._point = 1;
	                    break;
	                  }
	                  case 1: {
	                    this._string.push("L", x, ",", y);
	                    break;
	                  }
	                  default: {
	                    if (this._circle == null) this._circle = string_circle(this._radius);
	                    this._string.push("M", x, ",", y, this._circle);
	                    break;
	                  }
	                }
	              },
	              result: function() {
	                if (this._string.length) {
	                  var result = this._string.join("");
	                  this._string = [];
	                  return result;
	                } else {
	                  return null;
	                }
	              }
	            };
	            function string_circle(radius) {
	              return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	            }
	            function path(projection2, context) {
	              var pointRadius = 4.5, projectionStream, contextStream;
	              function path2(object2) {
	                if (object2) {
	                  if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	                  (0, stream.Z)(object2, projectionStream(contextStream));
	                }
	                return contextStream.result();
	              }
	              path2.area = function(object2) {
	                (0, stream.Z)(object2, projectionStream(path_area));
	                return path_area.result();
	              };
	              path2.measure = function(object2) {
	                (0, stream.Z)(object2, projectionStream(measure));
	                return measure.result();
	              };
	              path2.bounds = function(object2) {
	                (0, stream.Z)(object2, projectionStream(path_bounds.Z));
	                return path_bounds.Z.result();
	              };
	              path2.centroid = function(object2) {
	                (0, stream.Z)(object2, projectionStream(path_centroid));
	                return path_centroid.result();
	              };
	              path2.projection = function(_) {
	                return arguments.length ? (projectionStream = _ == null ? (projection2 = null, identity2.Z) : (projection2 = _).stream, path2) : projection2;
	              };
	              path2.context = function(_) {
	                if (!arguments.length) return context;
	                contextStream = _ == null ? (context = null, new PathString()) : new PathContext(context = _);
	                if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	                return path2;
	              };
	              path2.pointRadius = function(_) {
	                if (!arguments.length) return pointRadius;
	                pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	                return path2;
	              };
	              return path2.projection(projection2).context(context);
	            }
	            var projection = __webpack_require__2(15002);
	            function conicProjection(projectAt) {
	              var phi0 = 0, phi1 = math.pi / 3, m = (0, projection.r)(projectAt), p = m(phi0, phi1);
	              p.parallels = function(_) {
	                return arguments.length ? m(phi0 = _[0] * math.uR, phi1 = _[1] * math.uR) : [phi0 * math.RW, phi1 * math.RW];
	              };
	              return p;
	            }
	            function cylindricalEqualAreaRaw(phi0) {
	              var cosPhi02 = (0, math.mC)(phi0);
	              function forward(lambda, phi) {
	                return [lambda * cosPhi02, (0, math.O$)(phi) / cosPhi02];
	              }
	              forward.invert = function(x, y) {
	                return [x / cosPhi02, (0, math.ZR)(y * cosPhi02)];
	              };
	              return forward;
	            }
	            function conicEqualAreaRaw(y02, y1) {
	              var sy0 = (0, math.O$)(y02), n = (sy0 + (0, math.O$)(y1)) / 2;
	              if ((0, math.Wn)(n) < math.Ho) return cylindricalEqualAreaRaw(y02);
	              var c = 1 + sy0 * (2 * n - sy0), r0 = (0, math._b)(c) / n;
	              function project(x, y) {
	                var r = (0, math._b)(c - 2 * n * (0, math.O$)(y)) / n;
	                return [r * (0, math.O$)(x *= n), r0 - r * (0, math.mC)(x)];
	              }
	              project.invert = function(x, y) {
	                var r0y = r0 - y, l = (0, math.fv)(x, (0, math.Wn)(r0y)) * (0, math.Xx)(r0y);
	                if (r0y * n < 0)
	                  l -= math.pi * (0, math.Xx)(x) * (0, math.Xx)(r0y);
	                return [l / n, (0, math.ZR)((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	              };
	              return project;
	            }
	            function conicEqualArea() {
	              return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
	            }
	            function albers() {
	              return conicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
	            }
	            var fit = __webpack_require__2(47589);
	            function multiplex(streams) {
	              var n = streams.length;
	              return {
	                point: function(x, y) {
	                  var i = -1;
	                  while (++i < n) streams[i].point(x, y);
	                },
	                sphere: function() {
	                  var i = -1;
	                  while (++i < n) streams[i].sphere();
	                },
	                lineStart: function() {
	                  var i = -1;
	                  while (++i < n) streams[i].lineStart();
	                },
	                lineEnd: function() {
	                  var i = -1;
	                  while (++i < n) streams[i].lineEnd();
	                },
	                polygonStart: function() {
	                  var i = -1;
	                  while (++i < n) streams[i].polygonStart();
	                },
	                polygonEnd: function() {
	                  var i = -1;
	                  while (++i < n) streams[i].polygonEnd();
	                }
	              };
	            }
	            function albersUsa() {
	              var cache, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, point, pointStream = { point: function(x, y) {
	                point = [x, y];
	              } };
	              function albersUsa2(coordinates2) {
	                var x = coordinates2[0], y = coordinates2[1];
	                return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
	              }
	              albersUsa2.invert = function(coordinates2) {
	                var k = lower48.scale(), t = lower48.translate(), x = (coordinates2[0] - t[0]) / k, y = (coordinates2[1] - t[1]) / k;
	                return (y >= 0.12 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates2);
	              };
	              albersUsa2.stream = function(stream2) {
	                return cache && cacheStream === stream2 ? cache : cache = multiplex([lower48.stream(cacheStream = stream2), alaska.stream(stream2), hawaii.stream(stream2)]);
	              };
	              albersUsa2.precision = function(_) {
	                if (!arguments.length) return lower48.precision();
	                lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	                return reset();
	              };
	              albersUsa2.scale = function(_) {
	                if (!arguments.length) return lower48.scale();
	                lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	                return albersUsa2.translate(lower48.translate());
	              };
	              albersUsa2.translate = function(_) {
	                if (!arguments.length) return lower48.translate();
	                var k = lower48.scale(), x = +_[0], y = +_[1];
	                lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
	                alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + math.Ho, y + 0.12 * k + math.Ho], [x - 0.214 * k - math.Ho, y + 0.234 * k - math.Ho]]).stream(pointStream);
	                hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + math.Ho, y + 0.166 * k + math.Ho], [x - 0.115 * k - math.Ho, y + 0.234 * k - math.Ho]]).stream(pointStream);
	                return reset();
	              };
	              albersUsa2.fitExtent = function(extent3, object2) {
	                return (0, fit.qg)(albersUsa2, extent3, object2);
	              };
	              albersUsa2.fitSize = function(size, object2) {
	                return (0, fit.mF)(albersUsa2, size, object2);
	              };
	              albersUsa2.fitWidth = function(width, object2) {
	                return (0, fit.V6)(albersUsa2, width, object2);
	              };
	              albersUsa2.fitHeight = function(height, object2) {
	                return (0, fit.rf)(albersUsa2, height, object2);
	              };
	              function reset() {
	                cache = cacheStream = null;
	                return albersUsa2;
	              }
	              return albersUsa2.scale(1070);
	            }
	            var azimuthalEqualArea = __webpack_require__2(12956);
	            var azimuthalEquidistant = __webpack_require__2(17889);
	            var rotation = __webpack_require__2(49386);
	            function mercatorRaw(lambda, phi) {
	              return [lambda, (0, math.cM)((0, math.OR)((math.ou + phi) / 2))];
	            }
	            mercatorRaw.invert = function(x, y) {
	              return [x, 2 * (0, math.z4)((0, math.Qq)(y)) - math.ou];
	            };
	            function mercator() {
	              return mercatorProjection(mercatorRaw).scale(961 / math.BZ);
	            }
	            function mercatorProjection(project) {
	              var m = (0, projection.Z)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x02 = null, y02, x1, y1;
	              m.scale = function(_) {
	                return arguments.length ? (scale(_), reclip()) : scale();
	              };
	              m.translate = function(_) {
	                return arguments.length ? (translate(_), reclip()) : translate();
	              };
	              m.center = function(_) {
	                return arguments.length ? (center(_), reclip()) : center();
	              };
	              m.clipExtent = function(_) {
	                return arguments.length ? (_ == null ? x02 = y02 = x1 = y1 = null : (x02 = +_[0][0], y02 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x02 == null ? null : [[x02, y02], [x1, y1]];
	              };
	              function reclip() {
	                var k = math.pi * scale(), t = m((0, rotation.Z)(m.rotate()).invert([0, 0]));
	                return clipExtent(x02 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x02), y02], [Math.min(t[0] + k, x1), y1]] : [[x02, Math.max(t[1] - k, y02)], [x1, Math.min(t[1] + k, y1)]]);
	              }
	              return reclip();
	            }
	            function tany(y) {
	              return (0, math.OR)((math.ou + y) / 2);
	            }
	            function conicConformalRaw(y02, y1) {
	              var cy0 = (0, math.mC)(y02), n = y02 === y1 ? (0, math.O$)(y02) : (0, math.cM)(cy0 / (0, math.mC)(y1)) / (0, math.cM)(tany(y1) / tany(y02)), f = cy0 * (0, math.sQ)(tany(y02), n) / n;
	              if (!n) return mercatorRaw;
	              function project(x, y) {
	                if (f > 0) {
	                  if (y < -math.ou + math.Ho) y = -math.ou + math.Ho;
	                } else {
	                  if (y > math.ou - math.Ho) y = math.ou - math.Ho;
	                }
	                var r = f / (0, math.sQ)(tany(y), n);
	                return [r * (0, math.O$)(n * x), f - r * (0, math.mC)(n * x)];
	              }
	              project.invert = function(x, y) {
	                var fy = f - y, r = (0, math.Xx)(n) * (0, math._b)(x * x + fy * fy), l = (0, math.fv)(x, (0, math.Wn)(fy)) * (0, math.Xx)(fy);
	                if (fy * n < 0)
	                  l -= math.pi * (0, math.Xx)(x) * (0, math.Xx)(fy);
	                return [l / n, 2 * (0, math.z4)((0, math.sQ)(f / r, 1 / n)) - math.ou];
	              };
	              return project;
	            }
	            function conicConformal() {
	              return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
	            }
	            var equirectangular = __webpack_require__2(97492);
	            function conicEquidistantRaw(y02, y1) {
	              var cy0 = (0, math.mC)(y02), n = y02 === y1 ? (0, math.O$)(y02) : (cy0 - (0, math.mC)(y1)) / (y1 - y02), g = cy0 / n + y02;
	              if ((0, math.Wn)(n) < math.Ho) return equirectangular.k;
	              function project(x, y) {
	                var gy = g - y, nx = n * x;
	                return [gy * (0, math.O$)(nx), g - gy * (0, math.mC)(nx)];
	              }
	              project.invert = function(x, y) {
	                var gy = g - y, l = (0, math.fv)(x, (0, math.Wn)(gy)) * (0, math.Xx)(gy);
	                if (gy * n < 0)
	                  l -= math.pi * (0, math.Xx)(x) * (0, math.Xx)(gy);
	                return [l / n, g - (0, math.Xx)(n) * (0, math._b)(x * x + gy * gy)];
	              };
	              return project;
	            }
	            function conicEquidistant() {
	              return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
	            }
	            var A1 = 1.340264, A2 = -0.081106, A3 = 893e-6, A4 = 3796e-6, M = (0, math._b)(3) / 2, iterations = 12;
	            function equalEarthRaw(lambda, phi) {
	              var l = (0, math.ZR)(M * (0, math.O$)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
	              return [
	                lambda * (0, math.mC)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
	                l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
	              ];
	            }
	            equalEarthRaw.invert = function(x, y) {
	              var l = y, l2 = l * l, l6 = l2 * l2 * l2;
	              for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
	                fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
	                fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
	                l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
	                if ((0, math.Wn)(delta) < math.aW) break;
	              }
	              return [
	                M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, math.mC)(l),
	                (0, math.ZR)((0, math.O$)(l) / M)
	              ];
	            };
	            function equalEarth() {
	              return (0, projection.Z)(equalEarthRaw).scale(177.158);
	            }
	            var gnomonic = __webpack_require__2(98936);
	            var src_transform = __webpack_require__2(64684);
	            function projection_identity() {
	              var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x02 = null, y02, x1, y1, kx = 1, ky = 1, transform = (0, src_transform.l)({
	                point: function(x, y) {
	                  var p = projection2([x, y]);
	                  this.stream.point(p[0], p[1]);
	                }
	              }), postclip = identity2.Z, cache, cacheStream;
	              function reset() {
	                kx = k * sx;
	                ky = k * sy;
	                cache = cacheStream = null;
	                return projection2;
	              }
	              function projection2(p) {
	                var x = p[0] * kx, y = p[1] * ky;
	                if (alpha) {
	                  var t = y * ca - x * sa;
	                  x = x * ca + y * sa;
	                  y = t;
	                }
	                return [x + tx, y + ty];
	              }
	              projection2.invert = function(p) {
	                var x = p[0] - tx, y = p[1] - ty;
	                if (alpha) {
	                  var t = y * ca + x * sa;
	                  x = x * ca - y * sa;
	                  y = t;
	                }
	                return [x / kx, y / ky];
	              };
	              projection2.stream = function(stream2) {
	                return cache && cacheStream === stream2 ? cache : cache = transform(postclip(cacheStream = stream2));
	              };
	              projection2.postclip = function(_) {
	                return arguments.length ? (postclip = _, x02 = y02 = x1 = y1 = null, reset()) : postclip;
	              };
	              projection2.clipExtent = function(_) {
	                return arguments.length ? (postclip = _ == null ? (x02 = y02 = x1 = y1 = null, identity2.Z) : (0, rectangle.Z)(x02 = +_[0][0], y02 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x02 == null ? null : [[x02, y02], [x1, y1]];
	              };
	              projection2.scale = function(_) {
	                return arguments.length ? (k = +_, reset()) : k;
	              };
	              projection2.translate = function(_) {
	                return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
	              };
	              projection2.angle = function(_) {
	                return arguments.length ? (alpha = _ % 360 * math.uR, sa = (0, math.O$)(alpha), ca = (0, math.mC)(alpha), reset()) : alpha * math.RW;
	              };
	              projection2.reflectX = function(_) {
	                return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
	              };
	              projection2.reflectY = function(_) {
	                return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
	              };
	              projection2.fitExtent = function(extent3, object2) {
	                return (0, fit.qg)(projection2, extent3, object2);
	              };
	              projection2.fitSize = function(size, object2) {
	                return (0, fit.mF)(projection2, size, object2);
	              };
	              projection2.fitWidth = function(width, object2) {
	                return (0, fit.V6)(projection2, width, object2);
	              };
	              projection2.fitHeight = function(height, object2) {
	                return (0, fit.rf)(projection2, height, object2);
	              };
	              return projection2;
	            }
	            var naturalEarth1 = __webpack_require__2(26867);
	            var orthographic = __webpack_require__2(57962);
	            var azimuthal = __webpack_require__2(25382);
	            function stereographicRaw(x, y) {
	              var cy = (0, math.mC)(y), k = 1 + (0, math.mC)(x) * cy;
	              return [cy * (0, math.O$)(x) / k, (0, math.O$)(y) / k];
	            }
	            stereographicRaw.invert = (0, azimuthal.O)(function(z) {
	              return 2 * (0, math.z4)(z);
	            });
	            function stereographic() {
	              return (0, projection.Z)(stereographicRaw).scale(250).clipAngle(142);
	            }
	            function transverseMercatorRaw(lambda, phi) {
	              return [(0, math.cM)((0, math.OR)((math.ou + phi) / 2)), -lambda];
	            }
	            transverseMercatorRaw.invert = function(x, y) {
	              return [-y, 2 * (0, math.z4)((0, math.Qq)(x)) - math.ou];
	            };
	            function transverseMercator() {
	              var m = mercatorProjection(transverseMercatorRaw), center = m.center, rotate = m.rotate;
	              m.center = function(_) {
	                return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	              };
	              m.rotate = function(_) {
	                return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	              };
	              return rotate([0, 0, 90]).scale(159.155);
	            }
	          }
	        ),
	        /***/
	        83074: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            function __WEBPACK_DEFAULT_EXPORT__(a, b) {
	              var x0 = a[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, y0 = a[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, x1 = b[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, y1 = b[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, cy0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(y0), sy0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(y0), cy1 = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(y1), sy1 = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(y1), kx0 = cy0 * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(x0), ky0 = cy0 * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(x0), kx1 = cy1 * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(x1), ky1 = cy1 * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(x1), d = 2 * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.ZR)((0, _math_js__WEBPACK_IMPORTED_MODULE_0__._b)((0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Jy)(y1 - y0) + cy0 * cy1 * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Jy)(x1 - x0))), k = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(d);
	              var interpolate = d ? function(t) {
	                var B = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(t *= d) / k, A = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	                return [
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.fv)(y, x) * _math_js__WEBPACK_IMPORTED_MODULE_0__.RW,
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.fv)(z, (0, _math_js__WEBPACK_IMPORTED_MODULE_0__._b)(x * x + y * y)) * _math_js__WEBPACK_IMPORTED_MODULE_0__.RW
	                ];
	              } : function() {
	                return [x0 * _math_js__WEBPACK_IMPORTED_MODULE_0__.RW, y0 * _math_js__WEBPACK_IMPORTED_MODULE_0__.RW];
	              };
	              interpolate.distance = d;
	              return interpolate;
	            }
	          }
	        ),
	        /***/
	        39695: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              BZ: function() {
	                return (
	                  /* binding */
	                  tau
	                );
	              },
	              /* harmony export */
	              Ho: function() {
	                return (
	                  /* binding */
	                  epsilon
	                );
	              },
	              /* harmony export */
	              Jy: function() {
	                return (
	                  /* binding */
	                  haversin
	                );
	              },
	              /* harmony export */
	              Kh: function() {
	                return (
	                  /* binding */
	                  acos
	                );
	              },
	              /* harmony export */
	              O$: function() {
	                return (
	                  /* binding */
	                  sin
	                );
	              },
	              /* harmony export */
	              OR: function() {
	                return (
	                  /* binding */
	                  tan
	                );
	              },
	              /* harmony export */
	              Qq: function() {
	                return (
	                  /* binding */
	                  exp
	                );
	              },
	              /* harmony export */
	              RW: function() {
	                return (
	                  /* binding */
	                  degrees
	                );
	              },
	              /* harmony export */
	              Wn: function() {
	                return (
	                  /* binding */
	                  abs
	                );
	              },
	              /* harmony export */
	              Xx: function() {
	                return (
	                  /* binding */
	                  sign
	                );
	              },
	              /* harmony export */
	              ZR: function() {
	                return (
	                  /* binding */
	                  asin
	                );
	              },
	              /* harmony export */
	              _b: function() {
	                return (
	                  /* binding */
	                  sqrt
	                );
	              },
	              /* harmony export */
	              aW: function() {
	                return (
	                  /* binding */
	                  epsilon2
	                );
	              },
	              /* harmony export */
	              cM: function() {
	                return (
	                  /* binding */
	                  log
	                );
	              },
	              /* harmony export */
	              fv: function() {
	                return (
	                  /* binding */
	                  atan2
	                );
	              },
	              /* harmony export */
	              mC: function() {
	                return (
	                  /* binding */
	                  cos
	                );
	              },
	              /* harmony export */
	              mD: function() {
	                return (
	                  /* binding */
	                  ceil
	                );
	              },
	              /* harmony export */
	              ou: function() {
	                return (
	                  /* binding */
	                  halfPi
	                );
	              },
	              /* harmony export */
	              pi: function() {
	                return (
	                  /* binding */
	                  pi
	                );
	              },
	              /* harmony export */
	              pu: function() {
	                return (
	                  /* binding */
	                  quarterPi
	                );
	              },
	              /* harmony export */
	              sQ: function() {
	                return (
	                  /* binding */
	                  pow
	                );
	              },
	              /* harmony export */
	              uR: function() {
	                return (
	                  /* binding */
	                  radians
	                );
	              },
	              /* harmony export */
	              z4: function() {
	                return (
	                  /* binding */
	                  atan
	                );
	              }
	              /* harmony export */
	            });
	            var epsilon = 1e-6;
	            var epsilon2 = 1e-12;
	            var pi = Math.PI;
	            var halfPi = pi / 2;
	            var quarterPi = pi / 4;
	            var tau = pi * 2;
	            var degrees = 180 / pi;
	            var radians = pi / 180;
	            var abs = Math.abs;
	            var atan = Math.atan;
	            var atan2 = Math.atan2;
	            var cos = Math.cos;
	            var ceil = Math.ceil;
	            var exp = Math.exp;
	            var log = Math.log;
	            var pow = Math.pow;
	            var sin = Math.sin;
	            var sign = Math.sign || function(x) {
	              return x > 0 ? 1 : x < 0 ? -1 : 0;
	            };
	            var sqrt = Math.sqrt;
	            var tan = Math.tan;
	            function acos(x) {
	              return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	            }
	            function asin(x) {
	              return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	            }
	            function haversin(x) {
	              return (x = sin(x / 2)) * x;
	            }
	          }
	        ),
	        /***/
	        73182: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* binding */
	                  noop
	                );
	              }
	              /* harmony export */
	            });
	            function noop() {
	            }
	          }
	        ),
	        /***/
	        3559: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            var _noop_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(73182);
	            var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
	            var boundsStream = {
	              point: boundsPoint,
	              lineStart: _noop_js__WEBPACK_IMPORTED_MODULE_0__.Z,
	              lineEnd: _noop_js__WEBPACK_IMPORTED_MODULE_0__.Z,
	              polygonStart: _noop_js__WEBPACK_IMPORTED_MODULE_0__.Z,
	              polygonEnd: _noop_js__WEBPACK_IMPORTED_MODULE_0__.Z,
	              result: function() {
	                var bounds = [[x0, y0], [x1, y1]];
	                x1 = y1 = -(y0 = x0 = Infinity);
	                return bounds;
	              }
	            };
	            function boundsPoint(x, y) {
	              if (x < x0) x0 = x;
	              if (x > x1) x1 = x;
	              if (y < y0) y0 = y;
	              if (y > y1) y1 = y;
	            }
	            __webpack_exports__2.Z = boundsStream;
	          }
	        ),
	        /***/
	        67108: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            function __WEBPACK_DEFAULT_EXPORT__(a, b) {
	              return (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(a[0] - b[0]) < _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho && (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(a[1] - b[1]) < _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho;
	            }
	          }
	        ),
	        /***/
	        23071: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _adder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(33940);
	            var _cartesian_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(7620);
	            var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(39695);
	            var sum = (0, _adder_js__WEBPACK_IMPORTED_MODULE_0__.Z)();
	            function longitude(point) {
	              if ((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(point[0]) <= _math_js__WEBPACK_IMPORTED_MODULE_1__.pi)
	                return point[0];
	              else
	                return (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Xx)(point[0]) * (((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Wn)(point[0]) + _math_js__WEBPACK_IMPORTED_MODULE_1__.pi) % _math_js__WEBPACK_IMPORTED_MODULE_1__.BZ - _math_js__WEBPACK_IMPORTED_MODULE_1__.pi);
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(polygon, point) {
	              var lambda = longitude(point), phi = point[1], sinPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi), normal = [(0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(lambda), -(0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(lambda), 0], angle = 0, winding = 0;
	              sum.reset();
	              if (sinPhi === 1) phi = _math_js__WEBPACK_IMPORTED_MODULE_1__.ou + _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho;
	              else if (sinPhi === -1) phi = -_math_js__WEBPACK_IMPORTED_MODULE_1__.ou - _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho;
	              for (var i = 0, n = polygon.length; i < n; ++i) {
	                if (!(m = (ring = polygon[i]).length)) continue;
	                var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + _math_js__WEBPACK_IMPORTED_MODULE_1__.pu, sinPhi0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi0), cosPhi0 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi0);
	                for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	                  var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + _math_js__WEBPACK_IMPORTED_MODULE_1__.pu, sinPhi1 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(phi1), cosPhi1 = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > _math_js__WEBPACK_IMPORTED_MODULE_1__.pi, k = sinPhi0 * sinPhi1;
	                  sum.add((0, _math_js__WEBPACK_IMPORTED_MODULE_1__.fv)(k * sign * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(absDelta), cosPhi0 * cosPhi1 + k * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.mC)(absDelta)));
	                  angle += antimeridian ? delta + sign * _math_js__WEBPACK_IMPORTED_MODULE_1__.BZ : delta;
	                  if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	                    var arc = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_2__.T5)((0, _cartesian_js__WEBPACK_IMPORTED_MODULE_2__.Og)(point0), (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_2__.Og)(point1));
	                    (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_2__.iJ)(arc);
	                    var intersection = (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_2__.T5)(normal, arc);
	                    (0, _cartesian_js__WEBPACK_IMPORTED_MODULE_2__.iJ)(intersection);
	                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.ZR)(intersection[2]);
	                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	                      winding += antimeridian ^ delta >= 0 ? 1 : -1;
	                    }
	                  }
	                }
	              }
	              return (angle < -_math_js__WEBPACK_IMPORTED_MODULE_1__.Ho || angle < _math_js__WEBPACK_IMPORTED_MODULE_1__.Ho && sum < -_math_js__WEBPACK_IMPORTED_MODULE_1__.Ho) ^ winding & 1;
	            }
	          }
	        ),
	        /***/
	        25382: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              O: function() {
	                return (
	                  /* binding */
	                  azimuthalInvert
	                );
	              },
	              /* harmony export */
	              W: function() {
	                return (
	                  /* binding */
	                  azimuthalRaw
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            function azimuthalRaw(scale) {
	              return function(x, y) {
	                var cx = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(x), cy = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(y), k = scale(cx * cy);
	                return [
	                  k * cy * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(x),
	                  k * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(y)
	                ];
	              };
	            }
	            function azimuthalInvert(angle) {
	              return function(x, y) {
	                var z = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__._b)(x * x + y * y), c = angle(z), sc = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(c), cc = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(c);
	                return [
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.fv)(x * sc, z * cc),
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.ZR)(z && y * sc / z)
	                ];
	              };
	            }
	          }
	        ),
	        /***/
	        12956: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              },
	              /* harmony export */
	              l: function() {
	                return (
	                  /* binding */
	                  azimuthalEqualAreaRaw
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(39695);
	            var _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(25382);
	            var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(15002);
	            var azimuthalEqualAreaRaw = (0, _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__.W)(function(cxcy) {
	              return (0, _math_js__WEBPACK_IMPORTED_MODULE_1__._b)(2 / (1 + cxcy));
	            });
	            azimuthalEqualAreaRaw.invert = (0, _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__.O)(function(z) {
	              return 2 * (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.ZR)(z / 2);
	            });
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_2__.Z)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
	            }
	          }
	        ),
	        /***/
	        17889: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              N: function() {
	                return (
	                  /* binding */
	                  azimuthalEquidistantRaw
	                );
	              },
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(39695);
	            var _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(25382);
	            var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(15002);
	            var azimuthalEquidistantRaw = (0, _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__.W)(function(c) {
	              return (c = (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.Kh)(c)) && c / (0, _math_js__WEBPACK_IMPORTED_MODULE_1__.O$)(c);
	            });
	            azimuthalEquidistantRaw.invert = (0, _azimuthal_js__WEBPACK_IMPORTED_MODULE_0__.O)(function(z) {
	              return z;
	            });
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_2__.Z)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
	            }
	          }
	        ),
	        /***/
	        97492: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              },
	              /* harmony export */
	              k: function() {
	                return (
	                  /* binding */
	                  equirectangularRaw
	                );
	              }
	              /* harmony export */
	            });
	            var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(15002);
	            function equirectangularRaw(lambda, phi) {
	              return [lambda, phi];
	            }
	            equirectangularRaw.invert = equirectangularRaw;
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_0__.Z)(equirectangularRaw).scale(152.63);
	            }
	          }
	        ),
	        /***/
	        47589: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              V6: function() {
	                return (
	                  /* binding */
	                  fitWidth
	                );
	              },
	              /* harmony export */
	              mF: function() {
	                return (
	                  /* binding */
	                  fitSize
	                );
	              },
	              /* harmony export */
	              qg: function() {
	                return (
	                  /* binding */
	                  fitExtent
	                );
	              },
	              /* harmony export */
	              rf: function() {
	                return (
	                  /* binding */
	                  fitHeight
	                );
	              }
	              /* harmony export */
	            });
	            var _stream_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(72736);
	            var _path_bounds_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(3559);
	            function fit(projection, fitBounds, object) {
	              var clip = projection.clipExtent && projection.clipExtent();
	              projection.scale(150).translate([0, 0]);
	              if (clip != null) projection.clipExtent(null);
	              (0, _stream_js__WEBPACK_IMPORTED_MODULE_0__.Z)(object, projection.stream(_path_bounds_js__WEBPACK_IMPORTED_MODULE_1__.Z));
	              fitBounds(_path_bounds_js__WEBPACK_IMPORTED_MODULE_1__.Z.result());
	              if (clip != null) projection.clipExtent(clip);
	              return projection;
	            }
	            function fitExtent(projection, extent2, object) {
	              return fit(projection, function(b) {
	                var w = extent2[1][0] - extent2[0][0], h = extent2[1][1] - extent2[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent2[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent2[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	                projection.scale(150 * k).translate([x, y]);
	              }, object);
	            }
	            function fitSize(projection, size, object) {
	              return fitExtent(projection, [[0, 0], size], object);
	            }
	            function fitWidth(projection, width, object) {
	              return fit(projection, function(b) {
	                var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
	                projection.scale(150 * k).translate([x, y]);
	              }, object);
	            }
	            function fitHeight(projection, height, object) {
	              return fit(projection, function(b) {
	                var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
	                projection.scale(150 * k).translate([x, y]);
	              }, object);
	            }
	          }
	        ),
	        /***/
	        98936: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              M: function() {
	                return (
	                  /* binding */
	                  gnomonicRaw
	                );
	              },
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            var _azimuthal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(25382);
	            var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(15002);
	            function gnomonicRaw(x, y) {
	              var cy = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(y), k = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(x) * cy;
	              return [cy * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(x) / k, (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(y) / k];
	            }
	            gnomonicRaw.invert = (0, _azimuthal_js__WEBPACK_IMPORTED_MODULE_1__.O)(_math_js__WEBPACK_IMPORTED_MODULE_0__.z4);
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_2__.Z)(gnomonicRaw).scale(144.049).clipAngle(60);
	            }
	          }
	        ),
	        /***/
	        15002: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              Z: function() {
	                return (
	                  /* binding */
	                  projection
	                );
	              },
	              r: function() {
	                return (
	                  /* binding */
	                  projectionMutator
	                );
	              }
	            });
	            var antimeridian = __webpack_require__2(87070);
	            var circle = __webpack_require__2(1457);
	            var rectangle = __webpack_require__2(87605);
	            var compose = __webpack_require__2(96059);
	            var identity2 = __webpack_require__2(8593);
	            var math = __webpack_require__2(39695);
	            var rotation = __webpack_require__2(49386);
	            var transform = __webpack_require__2(64684);
	            var fit = __webpack_require__2(47589);
	            var cartesian = __webpack_require__2(7620);
	            var maxDepth = 16, cosMinDistance = (0, math.mC)(30 * math.uR);
	            function resample(project, delta2) {
	              return +delta2 ? resample_resample(project, delta2) : resampleNone(project);
	            }
	            function resampleNone(project) {
	              return (0, transform.l)({
	                point: function(x, y) {
	                  x = project(x, y);
	                  this.stream.point(x[0], x[1]);
	                }
	              });
	            }
	            function resample_resample(project, delta2) {
	              function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	                var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	                if (d2 > 4 * delta2 && depth--) {
	                  var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, math._b)(a * a + b * b + c * c), phi2 = (0, math.ZR)(c /= m), lambda2 = (0, math.Wn)((0, math.Wn)(c) - 1) < math.Ho || (0, math.Wn)(lambda0 - lambda1) < math.Ho ? (lambda0 + lambda1) / 2 : (0, math.fv)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	                  if (dz * dz / d2 > delta2 || (0, math.Wn)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	                    resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	                    stream.point(x2, y2);
	                    resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	                  }
	                }
	              }
	              return function(stream) {
	                var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0;
	                var resampleStream = {
	                  point,
	                  lineStart,
	                  lineEnd,
	                  polygonStart: function() {
	                    stream.polygonStart();
	                    resampleStream.lineStart = ringStart;
	                  },
	                  polygonEnd: function() {
	                    stream.polygonEnd();
	                    resampleStream.lineStart = lineStart;
	                  }
	                };
	                function point(x, y) {
	                  x = project(x, y);
	                  stream.point(x[0], x[1]);
	                }
	                function lineStart() {
	                  x0 = NaN;
	                  resampleStream.point = linePoint;
	                  stream.lineStart();
	                }
	                function linePoint(lambda, phi) {
	                  var c = (0, cartesian.Og)([lambda, phi]), p = project(lambda, phi);
	                  resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	                  stream.point(x0, y0);
	                }
	                function lineEnd() {
	                  resampleStream.point = point;
	                  stream.lineEnd();
	                }
	                function ringStart() {
	                  lineStart();
	                  resampleStream.point = ringPoint;
	                  resampleStream.lineEnd = ringEnd;
	                }
	                function ringPoint(lambda, phi) {
	                  linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	                  resampleStream.point = linePoint;
	                }
	                function ringEnd() {
	                  resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	                  resampleStream.lineEnd = lineEnd;
	                  lineEnd();
	                }
	                return resampleStream;
	              };
	            }
	            var transformRadians = (0, transform.l)({
	              point: function(x, y) {
	                this.stream.point(x * math.uR, y * math.uR);
	              }
	            });
	            function transformRotate(rotate) {
	              return (0, transform.l)({
	                point: function(x, y) {
	                  var r = rotate(x, y);
	                  return this.stream.point(r[0], r[1]);
	                }
	              });
	            }
	            function scaleTranslate(k, dx, dy, sx, sy) {
	              function transform2(x, y) {
	                x *= sx;
	                y *= sy;
	                return [dx + k * x, dy - k * y];
	              }
	              transform2.invert = function(x, y) {
	                return [(x - dx) / k * sx, (dy - y) / k * sy];
	              };
	              return transform2;
	            }
	            function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
	              var cosAlpha = (0, math.mC)(alpha), sinAlpha = (0, math.O$)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
	              function transform2(x, y) {
	                x *= sx;
	                y *= sy;
	                return [a * x - b * y + dx, dy - b * x - a * y];
	              }
	              transform2.invert = function(x, y) {
	                return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
	              };
	              return transform2;
	            }
	            function projection(project) {
	              return projectionMutator(function() {
	                return project;
	              })();
	            }
	            function projectionMutator(projectAt) {
	              var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = antimeridian.Z, x0 = null, y0, x1, y1, postclip = identity2.Z, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
	              function projection2(point) {
	                return projectRotateTransform(point[0] * math.uR, point[1] * math.uR);
	              }
	              function invert(point) {
	                point = projectRotateTransform.invert(point[0], point[1]);
	                return point && [point[0] * math.RW, point[1] * math.RW];
	              }
	              projection2.stream = function(stream) {
	                return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
	              };
	              projection2.preclip = function(_) {
	                return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
	              };
	              projection2.postclip = function(_) {
	                return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
	              };
	              projection2.clipAngle = function(_) {
	                return arguments.length ? (preclip = +_ ? (0, circle.Z)(theta = _ * math.uR) : (theta = null, antimeridian.Z), reset()) : theta * math.RW;
	              };
	              projection2.clipExtent = function(_) {
	                return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity2.Z) : (0, rectangle.Z)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	              };
	              projection2.scale = function(_) {
	                return arguments.length ? (k = +_, recenter()) : k;
	              };
	              projection2.translate = function(_) {
	                return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	              };
	              projection2.center = function(_) {
	                return arguments.length ? (lambda = _[0] % 360 * math.uR, phi = _[1] % 360 * math.uR, recenter()) : [lambda * math.RW, phi * math.RW];
	              };
	              projection2.rotate = function(_) {
	                return arguments.length ? (deltaLambda = _[0] % 360 * math.uR, deltaPhi = _[1] % 360 * math.uR, deltaGamma = _.length > 2 ? _[2] % 360 * math.uR : 0, recenter()) : [deltaLambda * math.RW, deltaPhi * math.RW, deltaGamma * math.RW];
	              };
	              projection2.angle = function(_) {
	                return arguments.length ? (alpha = _ % 360 * math.uR, recenter()) : alpha * math.RW;
	              };
	              projection2.reflectX = function(_) {
	                return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
	              };
	              projection2.reflectY = function(_) {
	                return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
	              };
	              projection2.precision = function(_) {
	                return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : (0, math._b)(delta2);
	              };
	              projection2.fitExtent = function(extent2, object) {
	                return (0, fit.qg)(projection2, extent2, object);
	              };
	              projection2.fitSize = function(size, object) {
	                return (0, fit.mF)(projection2, size, object);
	              };
	              projection2.fitWidth = function(width, object) {
	                return (0, fit.V6)(projection2, width, object);
	              };
	              projection2.fitHeight = function(height, object) {
	                return (0, fit.rf)(projection2, height, object);
	              };
	              function recenter() {
	                var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform2 = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], sx, sy, alpha);
	                rotate = (0, rotation.I)(deltaLambda, deltaPhi, deltaGamma);
	                projectTransform = (0, compose.Z)(project, transform2);
	                projectRotateTransform = (0, compose.Z)(rotate, projectTransform);
	                projectResample = resample(projectTransform, delta2);
	                return reset();
	              }
	              function reset() {
	                cache = cacheStream = null;
	                return projection2;
	              }
	              return function() {
	                project = projectAt.apply(this, arguments);
	                projection2.invert = project.invert && invert;
	                return recenter();
	              };
	            }
	          }
	        ),
	        /***/
	        26867: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              K: function() {
	                return (
	                  /* binding */
	                  naturalEarth1Raw
	                );
	              },
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(15002);
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            function naturalEarth1Raw(lambda, phi) {
	              var phi2 = phi * phi, phi4 = phi2 * phi2;
	              return [
	                lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (3971e-6 * phi2 - 1529e-6 * phi4))),
	                phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 5916e-6 * phi4)))
	              ];
	            }
	            naturalEarth1Raw.invert = function(x, y) {
	              var phi = y, i = 25, delta;
	              do {
	                var phi2 = phi * phi, phi4 = phi2 * phi2;
	                phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 5916e-6 * phi4))) - y) / (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 5916e-6 * 11 * phi4)));
	              } while ((0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(delta) > _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho && --i > 0);
	              return [
	                x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (3971e-6 - 1529e-6 * phi2)))),
	                phi
	              ];
	            };
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_1__.Z)(naturalEarth1Raw).scale(175.295);
	            }
	          }
	        ),
	        /***/
	        57962: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              I: function() {
	                return (
	                  /* binding */
	                  orthographicRaw
	                );
	              },
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            var _azimuthal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(25382);
	            var _index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(15002);
	            function orthographicRaw(x, y) {
	              return [(0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(y) * (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(x), (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(y)];
	            }
	            orthographicRaw.invert = (0, _azimuthal_js__WEBPACK_IMPORTED_MODULE_1__.O)(_math_js__WEBPACK_IMPORTED_MODULE_0__.ZR);
	            function __WEBPACK_DEFAULT_EXPORT__() {
	              return (0, _index_js__WEBPACK_IMPORTED_MODULE_2__.Z)(orthographicRaw).scale(249.5).clipAngle(90 + _math_js__WEBPACK_IMPORTED_MODULE_0__.Ho);
	            }
	          }
	        ),
	        /***/
	        49386: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              I: function() {
	                return (
	                  /* binding */
	                  rotateRadians
	                );
	              },
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            var _compose_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(96059);
	            var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(39695);
	            function rotationIdentity(lambda, phi) {
	              return [(0, _math_js__WEBPACK_IMPORTED_MODULE_0__.Wn)(lambda) > _math_js__WEBPACK_IMPORTED_MODULE_0__.pi ? lambda + Math.round(-lambda / _math_js__WEBPACK_IMPORTED_MODULE_0__.BZ) * _math_js__WEBPACK_IMPORTED_MODULE_0__.BZ : lambda, phi];
	            }
	            rotationIdentity.invert = rotationIdentity;
	            function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	              return (deltaLambda %= _math_js__WEBPACK_IMPORTED_MODULE_0__.BZ) ? deltaPhi || deltaGamma ? (0, _compose_js__WEBPACK_IMPORTED_MODULE_1__.Z)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
	            }
	            function forwardRotationLambda(deltaLambda) {
	              return function(lambda, phi) {
	                return lambda += deltaLambda, [lambda > _math_js__WEBPACK_IMPORTED_MODULE_0__.pi ? lambda - _math_js__WEBPACK_IMPORTED_MODULE_0__.BZ : lambda < -_math_js__WEBPACK_IMPORTED_MODULE_0__.pi ? lambda + _math_js__WEBPACK_IMPORTED_MODULE_0__.BZ : lambda, phi];
	              };
	            }
	            function rotationLambda(deltaLambda) {
	              var rotation = forwardRotationLambda(deltaLambda);
	              rotation.invert = forwardRotationLambda(-deltaLambda);
	              return rotation;
	            }
	            function rotationPhiGamma(deltaPhi, deltaGamma) {
	              var cosDeltaPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(deltaPhi), sinDeltaPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(deltaPhi), cosDeltaGamma = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(deltaGamma), sinDeltaGamma = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(deltaGamma);
	              function rotation(lambda, phi) {
	                var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(phi), x = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(lambda) * cosPhi, y = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(lambda) * cosPhi, z = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
	                return [
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.fv)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.ZR)(k * cosDeltaGamma + y * sinDeltaGamma)
	                ];
	              }
	              rotation.invert = function(lambda, phi) {
	                var cosPhi = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(phi), x = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.mC)(lambda) * cosPhi, y = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(lambda) * cosPhi, z = (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.O$)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
	                return [
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.fv)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	                  (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.ZR)(k * cosDeltaPhi - x * sinDeltaPhi)
	                ];
	              };
	              return rotation;
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(rotate) {
	              rotate = rotateRadians(rotate[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, rotate[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, rotate.length > 2 ? rotate[2] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR : 0);
	              function forward(coordinates) {
	                coordinates = rotate(coordinates[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, coordinates[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR);
	                return coordinates[0] *= _math_js__WEBPACK_IMPORTED_MODULE_0__.RW, coordinates[1] *= _math_js__WEBPACK_IMPORTED_MODULE_0__.RW, coordinates;
	              }
	              forward.invert = function(coordinates) {
	                coordinates = rotate.invert(coordinates[0] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR, coordinates[1] * _math_js__WEBPACK_IMPORTED_MODULE_0__.uR);
	                return coordinates[0] *= _math_js__WEBPACK_IMPORTED_MODULE_0__.RW, coordinates[1] *= _math_js__WEBPACK_IMPORTED_MODULE_0__.RW, coordinates;
	              };
	              return forward;
	            }
	          }
	        ),
	        /***/
	        72736: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              }
	              /* harmony export */
	            });
	            function streamGeometry(geometry, stream) {
	              if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	                streamGeometryType[geometry.type](geometry, stream);
	              }
	            }
	            var streamObjectType = {
	              Feature: function(object, stream) {
	                streamGeometry(object.geometry, stream);
	              },
	              FeatureCollection: function(object, stream) {
	                var features = object.features, i = -1, n = features.length;
	                while (++i < n) streamGeometry(features[i].geometry, stream);
	              }
	            };
	            var streamGeometryType = {
	              Sphere: function(object, stream) {
	                stream.sphere();
	              },
	              Point: function(object, stream) {
	                object = object.coordinates;
	                stream.point(object[0], object[1], object[2]);
	              },
	              MultiPoint: function(object, stream) {
	                var coordinates = object.coordinates, i = -1, n = coordinates.length;
	                while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	              },
	              LineString: function(object, stream) {
	                streamLine(object.coordinates, stream, 0);
	              },
	              MultiLineString: function(object, stream) {
	                var coordinates = object.coordinates, i = -1, n = coordinates.length;
	                while (++i < n) streamLine(coordinates[i], stream, 0);
	              },
	              Polygon: function(object, stream) {
	                streamPolygon(object.coordinates, stream);
	              },
	              MultiPolygon: function(object, stream) {
	                var coordinates = object.coordinates, i = -1, n = coordinates.length;
	                while (++i < n) streamPolygon(coordinates[i], stream);
	              },
	              GeometryCollection: function(object, stream) {
	                var geometries = object.geometries, i = -1, n = geometries.length;
	                while (++i < n) streamGeometry(geometries[i], stream);
	              }
	            };
	            function streamLine(coordinates, stream, closed) {
	              var i = -1, n = coordinates.length - closed, coordinate;
	              stream.lineStart();
	              while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	              stream.lineEnd();
	            }
	            function streamPolygon(coordinates, stream) {
	              var i = -1, n = coordinates.length;
	              stream.polygonStart();
	              while (++i < n) streamLine(coordinates[i], stream, 1);
	              stream.polygonEnd();
	            }
	            function __WEBPACK_DEFAULT_EXPORT__(object, stream) {
	              if (object && streamObjectType.hasOwnProperty(object.type)) {
	                streamObjectType[object.type](object, stream);
	              } else {
	                streamGeometry(object, stream);
	              }
	            }
	          }
	        ),
	        /***/
	        64684: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* export default binding */
	                  __WEBPACK_DEFAULT_EXPORT__
	                );
	              },
	              /* harmony export */
	              l: function() {
	                return (
	                  /* binding */
	                  transformer
	                );
	              }
	              /* harmony export */
	            });
	            function __WEBPACK_DEFAULT_EXPORT__(methods) {
	              return {
	                stream: transformer(methods)
	              };
	            }
	            function transformer(methods) {
	              return function(stream) {
	                var s = new TransformStream();
	                for (var key in methods) s[key] = methods[key];
	                s.stream = stream;
	                return s;
	              };
	            }
	            function TransformStream() {
	            }
	            TransformStream.prototype = {
	              constructor: TransformStream,
	              point: function(x, y) {
	                this.stream.point(x, y);
	              },
	              sphere: function() {
	                this.stream.sphere();
	              },
	              lineStart: function() {
	                this.stream.lineStart();
	              },
	              lineEnd: function() {
	                this.stream.lineEnd();
	              },
	              polygonStart: function() {
	                this.stream.polygonStart();
	              },
	              polygonEnd: function() {
	                this.stream.polygonEnd();
	              }
	            };
	          }
	        ),
	        /***/
	        674: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              cluster: function() {
	                return (
	                  /* reexport */
	                  cluster
	                );
	              },
	              hierarchy: function() {
	                return (
	                  /* reexport */
	                  hierarchy
	                );
	              },
	              pack: function() {
	                return (
	                  /* reexport */
	                  pack
	                );
	              },
	              packEnclose: function() {
	                return (
	                  /* reexport */
	                  enclose
	                );
	              },
	              packSiblings: function() {
	                return (
	                  /* reexport */
	                  siblings
	                );
	              },
	              partition: function() {
	                return (
	                  /* reexport */
	                  partition
	                );
	              },
	              stratify: function() {
	                return (
	                  /* reexport */
	                  stratify
	                );
	              },
	              tree: function() {
	                return (
	                  /* reexport */
	                  tree
	                );
	              },
	              treemap: function() {
	                return (
	                  /* reexport */
	                  treemap
	                );
	              },
	              treemapBinary: function() {
	                return (
	                  /* reexport */
	                  binary
	                );
	              },
	              treemapDice: function() {
	                return (
	                  /* reexport */
	                  dice
	                );
	              },
	              treemapResquarify: function() {
	                return (
	                  /* reexport */
	                  resquarify
	                );
	              },
	              treemapSlice: function() {
	                return (
	                  /* reexport */
	                  treemap_slice
	                );
	              },
	              treemapSliceDice: function() {
	                return (
	                  /* reexport */
	                  sliceDice
	                );
	              },
	              treemapSquarify: function() {
	                return (
	                  /* reexport */
	                  squarify
	                );
	              }
	            });
	            function defaultSeparation(a, b) {
	              return a.parent === b.parent ? 1 : 2;
	            }
	            function meanX(children) {
	              return children.reduce(meanXReduce, 0) / children.length;
	            }
	            function meanXReduce(x, c) {
	              return x + c.x;
	            }
	            function maxY(children) {
	              return 1 + children.reduce(maxYReduce, 0);
	            }
	            function maxYReduce(y, c) {
	              return Math.max(y, c.y);
	            }
	            function leafLeft(node) {
	              var children;
	              while (children = node.children) node = children[0];
	              return node;
	            }
	            function leafRight(node) {
	              var children;
	              while (children = node.children) node = children[children.length - 1];
	              return node;
	            }
	            function cluster() {
	              var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
	              function cluster2(root) {
	                var previousNode, x = 0;
	                root.eachAfter(function(node) {
	                  var children = node.children;
	                  if (children) {
	                    node.x = meanX(children);
	                    node.y = maxY(children);
	                  } else {
	                    node.x = previousNode ? x += separation(node, previousNode) : 0;
	                    node.y = 0;
	                    previousNode = node;
	                  }
	                });
	                var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	                return root.eachAfter(nodeSize ? function(node) {
	                  node.x = (node.x - root.x) * dx;
	                  node.y = (root.y - node.y) * dy;
	                } : function(node) {
	                  node.x = (node.x - x0) / (x1 - x0) * dx;
	                  node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	                });
	              }
	              cluster2.separation = function(x) {
	                return arguments.length ? (separation = x, cluster2) : separation;
	              };
	              cluster2.size = function(x) {
	                return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster2) : nodeSize ? null : [dx, dy];
	              };
	              cluster2.nodeSize = function(x) {
	                return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster2) : nodeSize ? [dx, dy] : null;
	              };
	              return cluster2;
	            }
	            function count(node) {
	              var sum2 = 0, children = node.children, i = children && children.length;
	              if (!i) sum2 = 1;
	              else while (--i >= 0) sum2 += children[i].value;
	              node.value = sum2;
	            }
	            function hierarchy_count() {
	              return this.eachAfter(count);
	            }
	            function each(callback) {
	              var node = this, current, next = [node], children, i, n;
	              do {
	                current = next.reverse(), next = [];
	                while (node = current.pop()) {
	                  callback(node), children = node.children;
	                  if (children) for (i = 0, n = children.length; i < n; ++i) {
	                    next.push(children[i]);
	                  }
	                }
	              } while (next.length);
	              return this;
	            }
	            function eachBefore(callback) {
	              var node = this, nodes = [node], children, i;
	              while (node = nodes.pop()) {
	                callback(node), children = node.children;
	                if (children) for (i = children.length - 1; i >= 0; --i) {
	                  nodes.push(children[i]);
	                }
	              }
	              return this;
	            }
	            function eachAfter(callback) {
	              var node = this, nodes = [node], next = [], children, i, n;
	              while (node = nodes.pop()) {
	                next.push(node), children = node.children;
	                if (children) for (i = 0, n = children.length; i < n; ++i) {
	                  nodes.push(children[i]);
	                }
	              }
	              while (node = next.pop()) {
	                callback(node);
	              }
	              return this;
	            }
	            function sum(value) {
	              return this.eachAfter(function(node) {
	                var sum2 = +value(node.data) || 0, children = node.children, i = children && children.length;
	                while (--i >= 0) sum2 += children[i].value;
	                node.value = sum2;
	              });
	            }
	            function sort(compare) {
	              return this.eachBefore(function(node) {
	                if (node.children) {
	                  node.children.sort(compare);
	                }
	              });
	            }
	            function path(end) {
	              var start = this, ancestor = leastCommonAncestor(start, end), nodes = [start];
	              while (start !== ancestor) {
	                start = start.parent;
	                nodes.push(start);
	              }
	              var k = nodes.length;
	              while (end !== ancestor) {
	                nodes.splice(k, 0, end);
	                end = end.parent;
	              }
	              return nodes;
	            }
	            function leastCommonAncestor(a, b) {
	              if (a === b) return a;
	              var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
	              a = aNodes.pop();
	              b = bNodes.pop();
	              while (a === b) {
	                c = a;
	                a = aNodes.pop();
	                b = bNodes.pop();
	              }
	              return c;
	            }
	            function ancestors() {
	              var node = this, nodes = [node];
	              while (node = node.parent) {
	                nodes.push(node);
	              }
	              return nodes;
	            }
	            function descendants() {
	              var nodes = [];
	              this.each(function(node) {
	                nodes.push(node);
	              });
	              return nodes;
	            }
	            function leaves() {
	              var leaves2 = [];
	              this.eachBefore(function(node) {
	                if (!node.children) {
	                  leaves2.push(node);
	                }
	              });
	              return leaves2;
	            }
	            function links() {
	              var root = this, links2 = [];
	              root.each(function(node) {
	                if (node !== root) {
	                  links2.push({ source: node.parent, target: node });
	                }
	              });
	              return links2;
	            }
	            function hierarchy(data, children) {
	              var root = new Node(data), valued = +data.value && (root.value = data.value), node, nodes = [root], child, childs, i, n;
	              if (children == null) children = defaultChildren;
	              while (node = nodes.pop()) {
	                if (valued) node.value = +node.data.value;
	                if ((childs = children(node.data)) && (n = childs.length)) {
	                  node.children = new Array(n);
	                  for (i = n - 1; i >= 0; --i) {
	                    nodes.push(child = node.children[i] = new Node(childs[i]));
	                    child.parent = node;
	                    child.depth = node.depth + 1;
	                  }
	                }
	              }
	              return root.eachBefore(computeHeight);
	            }
	            function node_copy() {
	              return hierarchy(this).eachBefore(copyData);
	            }
	            function defaultChildren(d) {
	              return d.children;
	            }
	            function copyData(node) {
	              node.data = node.data.data;
	            }
	            function computeHeight(node) {
	              var height = 0;
	              do
	                node.height = height;
	              while ((node = node.parent) && node.height < ++height);
	            }
	            function Node(data) {
	              this.data = data;
	              this.depth = this.height = 0;
	              this.parent = null;
	            }
	            Node.prototype = hierarchy.prototype = {
	              constructor: Node,
	              count: hierarchy_count,
	              each,
	              eachAfter,
	              eachBefore,
	              sum,
	              sort,
	              path,
	              ancestors,
	              descendants,
	              leaves,
	              links,
	              copy: node_copy
	            };
	            var slice2 = Array.prototype.slice;
	            function shuffle(array) {
	              var m = array.length, t, i;
	              while (m) {
	                i = Math.random() * m-- | 0;
	                t = array[m];
	                array[m] = array[i];
	                array[i] = t;
	              }
	              return array;
	            }
	            function enclose(circles) {
	              var i = 0, n = (circles = shuffle(slice2.call(circles))).length, B = [], p, e;
	              while (i < n) {
	                p = circles[i];
	                if (e && enclosesWeak(e, p)) ++i;
	                else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	              }
	              return e;
	            }
	            function extendBasis(B, p) {
	              var i, j;
	              if (enclosesWeakAll(p, B)) return [p];
	              for (i = 0; i < B.length; ++i) {
	                if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	                  return [B[i], p];
	                }
	              }
	              for (i = 0; i < B.length - 1; ++i) {
	                for (j = i + 1; j < B.length; ++j) {
	                  if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	                    return [B[i], B[j], p];
	                  }
	                }
	              }
	              throw new Error();
	            }
	            function enclosesNot(a, b) {
	              var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	              return dr < 0 || dr * dr < dx * dx + dy * dy;
	            }
	            function enclosesWeak(a, b) {
	              var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	              return dr > 0 && dr * dr > dx * dx + dy * dy;
	            }
	            function enclosesWeakAll(a, B) {
	              for (var i = 0; i < B.length; ++i) {
	                if (!enclosesWeak(a, B[i])) {
	                  return false;
	                }
	              }
	              return true;
	            }
	            function encloseBasis(B) {
	              switch (B.length) {
	                case 1:
	                  return encloseBasis1(B[0]);
	                case 2:
	                  return encloseBasis2(B[0], B[1]);
	                case 3:
	                  return encloseBasis3(B[0], B[1], B[2]);
	              }
	            }
	            function encloseBasis1(a) {
	              return {
	                x: a.x,
	                y: a.y,
	                r: a.r
	              };
	            }
	            function encloseBasis2(a, b) {
	              var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
	              return {
	                x: (x1 + x2 + x21 / l * r21) / 2,
	                y: (y1 + y2 + y21 / l * r21) / 2,
	                r: (l + r1 + r2) / 2
	              };
	            }
	            function encloseBasis3(a, b, c) {
	              var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	              return {
	                x: x1 + xa + xb * r,
	                y: y1 + ya + yb * r,
	                r
	              };
	            }
	            function place(b, a, c) {
	              var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
	              if (d2) {
	                a2 = a.r + c.r, a2 *= a2;
	                b2 = b.r + c.r, b2 *= b2;
	                if (a2 > b2) {
	                  x = (d2 + b2 - a2) / (2 * d2);
	                  y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
	                  c.x = b.x - x * dx - y * dy;
	                  c.y = b.y - x * dy + y * dx;
	                } else {
	                  x = (d2 + a2 - b2) / (2 * d2);
	                  y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
	                  c.x = a.x + x * dx - y * dy;
	                  c.y = a.y + x * dy + y * dx;
	                }
	              } else {
	                c.x = a.x + c.r;
	                c.y = a.y;
	              }
	            }
	            function intersects(a, b) {
	              var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	              return dr > 0 && dr * dr > dx * dx + dy * dy;
	            }
	            function score(node) {
	              var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
	              return dx * dx + dy * dy;
	            }
	            function siblings_Node(circle) {
	              this._ = circle;
	              this.next = null;
	              this.previous = null;
	            }
	            function packEnclose(circles) {
	              if (!(n = circles.length)) return 0;
	              var a, b, c, n, aa, ca, i, j, k, sj, sk;
	              a = circles[0], a.x = 0, a.y = 0;
	              if (!(n > 1)) return a.r;
	              b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	              if (!(n > 2)) return a.r + b.r;
	              place(b, a, c = circles[2]);
	              a = new siblings_Node(a), b = new siblings_Node(b), c = new siblings_Node(c);
	              a.next = c.previous = b;
	              b.next = a.previous = c;
	              c.next = b.previous = a;
	              pack: for (i = 3; i < n; ++i) {
	                place(a._, b._, c = circles[i]), c = new siblings_Node(c);
	                j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	                do {
	                  if (sj <= sk) {
	                    if (intersects(j._, c._)) {
	                      b = j, a.next = b, b.previous = a, --i;
	                      continue pack;
	                    }
	                    sj += j._.r, j = j.next;
	                  } else {
	                    if (intersects(k._, c._)) {
	                      a = k, a.next = b, b.previous = a, --i;
	                      continue pack;
	                    }
	                    sk += k._.r, k = k.previous;
	                  }
	                } while (j !== k.next);
	                c.previous = a, c.next = b, a.next = b.previous = b = c;
	                aa = score(a);
	                while ((c = c.next) !== b) {
	                  if ((ca = score(c)) < aa) {
	                    a = c, aa = ca;
	                  }
	                }
	                b = a.next;
	              }
	              a = [b._], c = b;
	              while ((c = c.next) !== b) a.push(c._);
	              c = enclose(a);
	              for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	              return c.r;
	            }
	            function siblings(circles) {
	              packEnclose(circles);
	              return circles;
	            }
	            function optional(f) {
	              return f == null ? null : required(f);
	            }
	            function required(f) {
	              if (typeof f !== "function") throw new Error();
	              return f;
	            }
	            function constantZero() {
	              return 0;
	            }
	            function constant2(x) {
	              return function() {
	                return x;
	              };
	            }
	            function defaultRadius(d) {
	              return Math.sqrt(d.value);
	            }
	            function pack() {
	              var radius = null, dx = 1, dy = 1, padding = constantZero;
	              function pack2(root) {
	                root.x = dx / 2, root.y = dy / 2;
	                if (radius) {
	                  root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
	                } else {
	                  root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(constantZero, 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	                }
	                return root;
	              }
	              pack2.radius = function(x) {
	                return arguments.length ? (radius = optional(x), pack2) : radius;
	              };
	              pack2.size = function(x) {
	                return arguments.length ? (dx = +x[0], dy = +x[1], pack2) : [dx, dy];
	              };
	              pack2.padding = function(x) {
	                return arguments.length ? (padding = typeof x === "function" ? x : constant2(+x), pack2) : padding;
	              };
	              return pack2;
	            }
	            function radiusLeaf(radius) {
	              return function(node) {
	                if (!node.children) {
	                  node.r = Math.max(0, +radius(node) || 0);
	                }
	              };
	            }
	            function packChildren(padding, k) {
	              return function(node) {
	                if (children = node.children) {
	                  var children, i, n = children.length, r = padding(node) * k || 0, e;
	                  if (r) for (i = 0; i < n; ++i) children[i].r += r;
	                  e = packEnclose(children);
	                  if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	                  node.r = e + r;
	                }
	              };
	            }
	            function translateChild(k) {
	              return function(node) {
	                var parent = node.parent;
	                node.r *= k;
	                if (parent) {
	                  node.x = parent.x + k * node.x;
	                  node.y = parent.y + k * node.y;
	                }
	              };
	            }
	            function treemap_round(node) {
	              node.x0 = Math.round(node.x0);
	              node.y0 = Math.round(node.y0);
	              node.x1 = Math.round(node.x1);
	              node.y1 = Math.round(node.y1);
	            }
	            function dice(parent, x0, y0, x1, y1) {
	              var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
	              while (++i < n) {
	                node = nodes[i], node.y0 = y0, node.y1 = y1;
	                node.x0 = x0, node.x1 = x0 += node.value * k;
	              }
	            }
	            function partition() {
	              var dx = 1, dy = 1, padding = 0, round = false;
	              function partition2(root) {
	                var n = root.height + 1;
	                root.x0 = root.y0 = padding;
	                root.x1 = dx;
	                root.y1 = dy / n;
	                root.eachBefore(positionNode(dy, n));
	                if (round) root.eachBefore(treemap_round);
	                return root;
	              }
	              function positionNode(dy2, n) {
	                return function(node) {
	                  if (node.children) {
	                    dice(node, node.x0, dy2 * (node.depth + 1) / n, node.x1, dy2 * (node.depth + 2) / n);
	                  }
	                  var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
	                  if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	                  if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	                  node.x0 = x0;
	                  node.y0 = y0;
	                  node.x1 = x1;
	                  node.y1 = y1;
	                };
	              }
	              partition2.round = function(x) {
	                return arguments.length ? (round = !!x, partition2) : round;
	              };
	              partition2.size = function(x) {
	                return arguments.length ? (dx = +x[0], dy = +x[1], partition2) : [dx, dy];
	              };
	              partition2.padding = function(x) {
	                return arguments.length ? (padding = +x, partition2) : padding;
	              };
	              return partition2;
	            }
	            var keyPrefix = "$", preroot = { depth: -1 }, ambiguous = {};
	            function defaultId(d) {
	              return d.id;
	            }
	            function defaultParentId(d) {
	              return d.parentId;
	            }
	            function stratify() {
	              var id = defaultId, parentId = defaultParentId;
	              function stratify2(data) {
	                var d, i, n = data.length, root, parent, node, nodes = new Array(n), nodeId, nodeKey, nodeByKey = {};
	                for (i = 0; i < n; ++i) {
	                  d = data[i], node = nodes[i] = new Node(d);
	                  if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	                    nodeKey = keyPrefix + (node.id = nodeId);
	                    nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	                  }
	                }
	                for (i = 0; i < n; ++i) {
	                  node = nodes[i], nodeId = parentId(data[i], i, data);
	                  if (nodeId == null || !(nodeId += "")) {
	                    if (root) throw new Error("multiple roots");
	                    root = node;
	                  } else {
	                    parent = nodeByKey[keyPrefix + nodeId];
	                    if (!parent) throw new Error("missing: " + nodeId);
	                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	                    if (parent.children) parent.children.push(node);
	                    else parent.children = [node];
	                    node.parent = parent;
	                  }
	                }
	                if (!root) throw new Error("no root");
	                root.parent = preroot;
	                root.eachBefore(function(node2) {
	                  node2.depth = node2.parent.depth + 1;
	                  --n;
	                }).eachBefore(computeHeight);
	                root.parent = null;
	                if (n > 0) throw new Error("cycle");
	                return root;
	              }
	              stratify2.id = function(x) {
	                return arguments.length ? (id = required(x), stratify2) : id;
	              };
	              stratify2.parentId = function(x) {
	                return arguments.length ? (parentId = required(x), stratify2) : parentId;
	              };
	              return stratify2;
	            }
	            function tree_defaultSeparation(a, b) {
	              return a.parent === b.parent ? 1 : 2;
	            }
	            function nextLeft(v) {
	              var children = v.children;
	              return children ? children[0] : v.t;
	            }
	            function nextRight(v) {
	              var children = v.children;
	              return children ? children[children.length - 1] : v.t;
	            }
	            function moveSubtree(wm, wp, shift) {
	              var change = shift / (wp.i - wm.i);
	              wp.c -= change;
	              wp.s += shift;
	              wm.c += change;
	              wp.z += shift;
	              wp.m += shift;
	            }
	            function executeShifts(v) {
	              var shift = 0, change = 0, children = v.children, i = children.length, w;
	              while (--i >= 0) {
	                w = children[i];
	                w.z += shift;
	                w.m += shift;
	                shift += w.s + (change += w.c);
	              }
	            }
	            function nextAncestor(vim, v, ancestor) {
	              return vim.a.parent === v.parent ? vim.a : ancestor;
	            }
	            function TreeNode(node, i) {
	              this._ = node;
	              this.parent = null;
	              this.children = null;
	              this.A = null;
	              this.a = this;
	              this.z = 0;
	              this.m = 0;
	              this.c = 0;
	              this.s = 0;
	              this.t = null;
	              this.i = i;
	            }
	            TreeNode.prototype = Object.create(Node.prototype);
	            function treeRoot(root) {
	              var tree2 = new TreeNode(root, 0), node, nodes = [tree2], child, children, i, n;
	              while (node = nodes.pop()) {
	                if (children = node._.children) {
	                  node.children = new Array(n = children.length);
	                  for (i = n - 1; i >= 0; --i) {
	                    nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	                    child.parent = node;
	                  }
	                }
	              }
	              (tree2.parent = new TreeNode(null, 0)).children = [tree2];
	              return tree2;
	            }
	            function tree() {
	              var separation = tree_defaultSeparation, dx = 1, dy = 1, nodeSize = null;
	              function tree2(root) {
	                var t = treeRoot(root);
	                t.eachAfter(firstWalk), t.parent.m = -t.z;
	                t.eachBefore(secondWalk);
	                if (nodeSize) root.eachBefore(sizeNode);
	                else {
	                  var left = root, right = root, bottom = root;
	                  root.eachBefore(function(node) {
	                    if (node.x < left.x) left = node;
	                    if (node.x > right.x) right = node;
	                    if (node.depth > bottom.depth) bottom = node;
	                  });
	                  var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
	                  root.eachBefore(function(node) {
	                    node.x = (node.x + tx) * kx;
	                    node.y = node.depth * ky;
	                  });
	                }
	                return root;
	              }
	              function firstWalk(v) {
	                var children = v.children, siblings2 = v.parent.children, w = v.i ? siblings2[v.i - 1] : null;
	                if (children) {
	                  executeShifts(v);
	                  var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	                  if (w) {
	                    v.z = w.z + separation(v._, w._);
	                    v.m = v.z - midpoint;
	                  } else {
	                    v.z = midpoint;
	                  }
	                } else if (w) {
	                  v.z = w.z + separation(v._, w._);
	                }
	                v.parent.A = apportion(v, w, v.parent.A || siblings2[0]);
	              }
	              function secondWalk(v) {
	                v._.x = v.z + v.parent.m;
	                v.m += v.parent.m;
	              }
	              function apportion(v, w, ancestor) {
	                if (w) {
	                  var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	                  while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	                    vom = nextLeft(vom);
	                    vop = nextRight(vop);
	                    vop.a = v;
	                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	                    if (shift > 0) {
	                      moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	                      sip += shift;
	                      sop += shift;
	                    }
	                    sim += vim.m;
	                    sip += vip.m;
	                    som += vom.m;
	                    sop += vop.m;
	                  }
	                  if (vim && !nextRight(vop)) {
	                    vop.t = vim;
	                    vop.m += sim - sop;
	                  }
	                  if (vip && !nextLeft(vom)) {
	                    vom.t = vip;
	                    vom.m += sip - som;
	                    ancestor = v;
	                  }
	                }
	                return ancestor;
	              }
	              function sizeNode(node) {
	                node.x *= dx;
	                node.y = node.depth * dy;
	              }
	              tree2.separation = function(x) {
	                return arguments.length ? (separation = x, tree2) : separation;
	              };
	              tree2.size = function(x) {
	                return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree2) : nodeSize ? null : [dx, dy];
	              };
	              tree2.nodeSize = function(x) {
	                return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree2) : nodeSize ? [dx, dy] : null;
	              };
	              return tree2;
	            }
	            function treemap_slice(parent, x0, y0, x1, y1) {
	              var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
	              while (++i < n) {
	                node = nodes[i], node.x0 = x0, node.x1 = x1;
	                node.y0 = y0, node.y1 = y0 += node.value * k;
	              }
	            }
	            var phi = (1 + Math.sqrt(5)) / 2;
	            function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	              var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
	              while (i0 < n) {
	                dx = x1 - x0, dy = y1 - y0;
	                do
	                  sumValue = nodes[i1++].value;
	                while (!sumValue && i1 < n);
	                minValue = maxValue = sumValue;
	                alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	                beta = sumValue * sumValue * alpha;
	                minRatio = Math.max(maxValue / beta, beta / minValue);
	                for (; i1 < n; ++i1) {
	                  sumValue += nodeValue = nodes[i1].value;
	                  if (nodeValue < minValue) minValue = nodeValue;
	                  if (nodeValue > maxValue) maxValue = nodeValue;
	                  beta = sumValue * sumValue * alpha;
	                  newRatio = Math.max(maxValue / beta, beta / minValue);
	                  if (newRatio > minRatio) {
	                    sumValue -= nodeValue;
	                    break;
	                  }
	                  minRatio = newRatio;
	                }
	                rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
	                if (row.dice) dice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	                else treemap_slice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	                value -= sumValue, i0 = i1;
	              }
	              return rows;
	            }
	            var squarify = function custom(ratio) {
	              function squarify2(parent, x0, y0, x1, y1) {
	                squarifyRatio(ratio, parent, x0, y0, x1, y1);
	              }
	              squarify2.ratio = function(x) {
	                return custom((x = +x) > 1 ? x : 1);
	              };
	              return squarify2;
	            }(phi);
	            function treemap() {
	              var tile = squarify, round = false, dx = 1, dy = 1, paddingStack = [0], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
	              function treemap2(root) {
	                root.x0 = root.y0 = 0;
	                root.x1 = dx;
	                root.y1 = dy;
	                root.eachBefore(positionNode);
	                paddingStack = [0];
	                if (round) root.eachBefore(treemap_round);
	                return root;
	              }
	              function positionNode(node) {
	                var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
	                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	                node.x0 = x0;
	                node.y0 = y0;
	                node.x1 = x1;
	                node.y1 = y1;
	                if (node.children) {
	                  p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	                  x0 += paddingLeft(node) - p;
	                  y0 += paddingTop(node) - p;
	                  x1 -= paddingRight(node) - p;
	                  y1 -= paddingBottom(node) - p;
	                  if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	                  if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	                  tile(node, x0, y0, x1, y1);
	                }
	              }
	              treemap2.round = function(x) {
	                return arguments.length ? (round = !!x, treemap2) : round;
	              };
	              treemap2.size = function(x) {
	                return arguments.length ? (dx = +x[0], dy = +x[1], treemap2) : [dx, dy];
	              };
	              treemap2.tile = function(x) {
	                return arguments.length ? (tile = required(x), treemap2) : tile;
	              };
	              treemap2.padding = function(x) {
	                return arguments.length ? treemap2.paddingInner(x).paddingOuter(x) : treemap2.paddingInner();
	              };
	              treemap2.paddingInner = function(x) {
	                return arguments.length ? (paddingInner = typeof x === "function" ? x : constant2(+x), treemap2) : paddingInner;
	              };
	              treemap2.paddingOuter = function(x) {
	                return arguments.length ? treemap2.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap2.paddingTop();
	              };
	              treemap2.paddingTop = function(x) {
	                return arguments.length ? (paddingTop = typeof x === "function" ? x : constant2(+x), treemap2) : paddingTop;
	              };
	              treemap2.paddingRight = function(x) {
	                return arguments.length ? (paddingRight = typeof x === "function" ? x : constant2(+x), treemap2) : paddingRight;
	              };
	              treemap2.paddingBottom = function(x) {
	                return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant2(+x), treemap2) : paddingBottom;
	              };
	              treemap2.paddingLeft = function(x) {
	                return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant2(+x), treemap2) : paddingLeft;
	              };
	              return treemap2;
	            }
	            function binary(parent, x0, y0, x1, y1) {
	              var nodes = parent.children, i, n = nodes.length, sum2, sums = new Array(n + 1);
	              for (sums[0] = sum2 = i = 0; i < n; ++i) {
	                sums[i + 1] = sum2 += nodes[i].value;
	              }
	              partition2(0, n, parent.value, x0, y0, x1, y1);
	              function partition2(i2, j, value, x02, y02, x12, y12) {
	                if (i2 >= j - 1) {
	                  var node = nodes[i2];
	                  node.x0 = x02, node.y0 = y02;
	                  node.x1 = x12, node.y1 = y12;
	                  return;
	                }
	                var valueOffset = sums[i2], valueTarget = value / 2 + valueOffset, k = i2 + 1, hi = j - 1;
	                while (k < hi) {
	                  var mid = k + hi >>> 1;
	                  if (sums[mid] < valueTarget) k = mid + 1;
	                  else hi = mid;
	                }
	                if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i2 + 1 < k) --k;
	                var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
	                if (x12 - x02 > y12 - y02) {
	                  var xk = (x02 * valueRight + x12 * valueLeft) / value;
	                  partition2(i2, k, valueLeft, x02, y02, xk, y12);
	                  partition2(k, j, valueRight, xk, y02, x12, y12);
	                } else {
	                  var yk = (y02 * valueRight + y12 * valueLeft) / value;
	                  partition2(i2, k, valueLeft, x02, y02, x12, yk);
	                  partition2(k, j, valueRight, x02, yk, x12, y12);
	                }
	              }
	            }
	            function sliceDice(parent, x0, y0, x1, y1) {
	              (parent.depth & 1 ? treemap_slice : dice)(parent, x0, y0, x1, y1);
	            }
	            var resquarify = function custom(ratio) {
	              function resquarify2(parent, x0, y0, x1, y1) {
	                if ((rows = parent._squarify) && rows.ratio === ratio) {
	                  var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
	                  while (++j < m) {
	                    row = rows[j], nodes = row.children;
	                    for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	                    if (row.dice) dice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	                    else treemap_slice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	                    value -= row.value;
	                  }
	                } else {
	                  parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	                  rows.ratio = ratio;
	                }
	              }
	              resquarify2.ratio = function(x) {
	                return custom((x = +x) > 1 ? x : 1);
	              };
	              return resquarify2;
	            }(phi);
	          }
	        ),
	        /***/
	        45879: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              h5: function() {
	                return (
	                  /* binding */
	                  linkHorizontal
	                );
	              }
	            });
	            var pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
	            function Path() {
	              this._x0 = this._y0 = // start of current subpath
	              this._x1 = this._y1 = null;
	              this._ = "";
	            }
	            function path() {
	              return new Path();
	            }
	            Path.prototype = path.prototype = {
	              constructor: Path,
	              moveTo: function(x, y) {
	                this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	              },
	              closePath: function() {
	                if (this._x1 !== null) {
	                  this._x1 = this._x0, this._y1 = this._y0;
	                  this._ += "Z";
	                }
	              },
	              lineTo: function(x, y) {
	                this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	              },
	              quadraticCurveTo: function(x1, y1, x, y) {
	                this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	              },
	              bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	                this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	              },
	              arcTo: function(x1, y1, x2, y2, r) {
	                x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	                var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
	                if (r < 0) throw new Error("negative radius: " + r);
	                if (this._x1 === null) {
	                  this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	                } else if (!(l01_2 > epsilon)) ;
	                else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	                  this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	                } else {
	                  var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
	                  if (Math.abs(t01 - 1) > epsilon) {
	                    this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	                  }
	                  this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	                }
	              },
	              arc: function(x, y, r, a0, a1, ccw) {
	                x = +x, y = +y, r = +r, ccw = !!ccw;
	                var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
	                if (r < 0) throw new Error("negative radius: " + r);
	                if (this._x1 === null) {
	                  this._ += "M" + x0 + "," + y0;
	                } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	                  this._ += "L" + x0 + "," + y0;
	                }
	                if (!r) return;
	                if (da < 0) da = da % tau + tau;
	                if (da > tauEpsilon) {
	                  this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	                } else if (da > epsilon) {
	                  this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	                }
	              },
	              rect: function(x, y, w, h) {
	                this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
	              },
	              toString: function() {
	                return this._;
	              }
	            };
	            var src_path = path;
	            var slice2 = Array.prototype.slice;
	            function constant2(x) {
	              return function constant3() {
	                return x;
	              };
	            }
	            function point_x(p) {
	              return p[0];
	            }
	            function point_y(p) {
	              return p[1];
	            }
	            function linkSource(d) {
	              return d.source;
	            }
	            function linkTarget(d) {
	              return d.target;
	            }
	            function link_link(curve) {
	              var source = linkSource, target = linkTarget, x = point_x, y = point_y, context = null;
	              function link() {
	                var buffer, argv = slice2.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	                if (!context) context = buffer = src_path();
	                curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
	                if (buffer) return context = null, buffer + "" || null;
	              }
	              link.source = function(_) {
	                return arguments.length ? (source = _, link) : source;
	              };
	              link.target = function(_) {
	                return arguments.length ? (target = _, link) : target;
	              };
	              link.x = function(_) {
	                return arguments.length ? (x = typeof _ === "function" ? _ : constant2(+_), link) : x;
	              };
	              link.y = function(_) {
	                return arguments.length ? (y = typeof _ === "function" ? _ : constant2(+_), link) : y;
	              };
	              link.context = function(_) {
	                return arguments.length ? (context = _ == null ? null : _, link) : context;
	              };
	              return link;
	            }
	            function curveHorizontal(context, x0, y0, x1, y1) {
	              context.moveTo(x0, y0);
	              context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	            }
	            function linkHorizontal() {
	              return link_link(curveHorizontal);
	            }
	          }
	        ),
	        /***/
	        84096: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              i$: function() {
	                return (
	                  /* reexport */
	                  timeFormat
	                );
	              },
	              Dq: function() {
	                return (
	                  /* reexport */
	                  formatLocale
	                );
	              },
	              g0: function() {
	                return (
	                  /* reexport */
	                  utcFormat
	                );
	              }
	            });
	            var utcWeek = __webpack_require__2(58176);
	            var utcDay = __webpack_require__2(48480);
	            var src_week = __webpack_require__2(59879);
	            var src_day = __webpack_require__2(82301);
	            var year = __webpack_require__2(34823);
	            var utcYear = __webpack_require__2(79791);
	            function localDate(d) {
	              if (0 <= d.y && d.y < 100) {
	                var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	                date.setFullYear(d.y);
	                return date;
	              }
	              return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	            }
	            function utcDate(d) {
	              if (0 <= d.y && d.y < 100) {
	                var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	                date.setUTCFullYear(d.y);
	                return date;
	              }
	              return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	            }
	            function newDate(y, m, d) {
	              return { y, m, d, H: 0, M: 0, S: 0, L: 0 };
	            }
	            function formatLocale(locale2) {
	              var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
	              var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
	              var formats = {
	                "a": formatShortWeekday,
	                "A": formatWeekday,
	                "b": formatShortMonth,
	                "B": formatMonth,
	                "c": null,
	                "d": formatDayOfMonth,
	                "e": formatDayOfMonth,
	                "f": formatMicroseconds,
	                "H": formatHour24,
	                "I": formatHour12,
	                "j": formatDayOfYear,
	                "L": formatMilliseconds,
	                "m": formatMonthNumber,
	                "M": formatMinutes,
	                "p": formatPeriod,
	                "q": formatQuarter,
	                "Q": formatUnixTimestamp,
	                "s": formatUnixTimestampSeconds,
	                "S": formatSeconds,
	                "u": formatWeekdayNumberMonday,
	                "U": formatWeekNumberSunday,
	                "V": formatWeekNumberISO,
	                "w": formatWeekdayNumberSunday,
	                "W": formatWeekNumberMonday,
	                "x": null,
	                "X": null,
	                "y": formatYear,
	                "Y": formatFullYear,
	                "Z": formatZone,
	                "%": formatLiteralPercent
	              };
	              var utcFormats = {
	                "a": formatUTCShortWeekday,
	                "A": formatUTCWeekday,
	                "b": formatUTCShortMonth,
	                "B": formatUTCMonth,
	                "c": null,
	                "d": formatUTCDayOfMonth,
	                "e": formatUTCDayOfMonth,
	                "f": formatUTCMicroseconds,
	                "H": formatUTCHour24,
	                "I": formatUTCHour12,
	                "j": formatUTCDayOfYear,
	                "L": formatUTCMilliseconds,
	                "m": formatUTCMonthNumber,
	                "M": formatUTCMinutes,
	                "p": formatUTCPeriod,
	                "q": formatUTCQuarter,
	                "Q": formatUnixTimestamp,
	                "s": formatUnixTimestampSeconds,
	                "S": formatUTCSeconds,
	                "u": formatUTCWeekdayNumberMonday,
	                "U": formatUTCWeekNumberSunday,
	                "V": formatUTCWeekNumberISO,
	                "w": formatUTCWeekdayNumberSunday,
	                "W": formatUTCWeekNumberMonday,
	                "x": null,
	                "X": null,
	                "y": formatUTCYear,
	                "Y": formatUTCFullYear,
	                "Z": formatUTCZone,
	                "%": formatLiteralPercent
	              };
	              var parses = {
	                "a": parseShortWeekday,
	                "A": parseWeekday,
	                "b": parseShortMonth,
	                "B": parseMonth,
	                "c": parseLocaleDateTime,
	                "d": parseDayOfMonth,
	                "e": parseDayOfMonth,
	                "f": parseMicroseconds,
	                "H": parseHour24,
	                "I": parseHour24,
	                "j": parseDayOfYear,
	                "L": parseMilliseconds,
	                "m": parseMonthNumber,
	                "M": parseMinutes,
	                "p": parsePeriod,
	                "q": parseQuarter,
	                "Q": parseUnixTimestamp,
	                "s": parseUnixTimestampSeconds,
	                "S": parseSeconds,
	                "u": parseWeekdayNumberMonday,
	                "U": parseWeekNumberSunday,
	                "V": parseWeekNumberISO,
	                "w": parseWeekdayNumberSunday,
	                "W": parseWeekNumberMonday,
	                "x": parseLocaleDate,
	                "X": parseLocaleTime,
	                "y": parseYear,
	                "Y": parseFullYear,
	                "Z": parseZone,
	                "%": parseLiteralPercent
	              };
	              formats.x = newFormat(locale_date, formats);
	              formats.X = newFormat(locale_time, formats);
	              formats.c = newFormat(locale_dateTime, formats);
	              utcFormats.x = newFormat(locale_date, utcFormats);
	              utcFormats.X = newFormat(locale_time, utcFormats);
	              utcFormats.c = newFormat(locale_dateTime, utcFormats);
	              function newFormat(specifier, formats2) {
	                return function(date) {
	                  var string = [], i = -1, j = 0, n = specifier.length, c, pad2, format;
	                  if (!(date instanceof Date)) date = /* @__PURE__ */ new Date(+date);
	                  while (++i < n) {
	                    if (specifier.charCodeAt(i) === 37) {
	                      string.push(specifier.slice(j, i));
	                      if ((pad2 = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	                      else pad2 = c === "e" ? " " : "0";
	                      if (format = formats2[c]) c = format(date, pad2);
	                      string.push(c);
	                      j = i + 1;
	                    }
	                  }
	                  string.push(specifier.slice(j, i));
	                  return string.join("");
	                };
	              }
	              function newParse(specifier, Z) {
	                return function(string) {
	                  var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
	                  if (i != string.length) return null;
	                  if ("Q" in d) return new Date(d.Q);
	                  if ("s" in d) return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
	                  if (Z && !("Z" in d)) d.Z = 0;
	                  if ("p" in d) d.H = d.H % 12 + d.p * 12;
	                  if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	                  if ("V" in d) {
	                    if (d.V < 1 || d.V > 53) return null;
	                    if (!("w" in d)) d.w = 1;
	                    if ("Z" in d) {
	                      week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	                      week = day > 4 || day === 0 ? utcWeek.l6.ceil(week) : (0, utcWeek.l6)(week);
	                      week = utcDay.Z.offset(week, (d.V - 1) * 7);
	                      d.y = week.getUTCFullYear();
	                      d.m = week.getUTCMonth();
	                      d.d = week.getUTCDate() + (d.w + 6) % 7;
	                    } else {
	                      week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	                      week = day > 4 || day === 0 ? src_week.wA.ceil(week) : (0, src_week.wA)(week);
	                      week = src_day.Z.offset(week, (d.V - 1) * 7);
	                      d.y = week.getFullYear();
	                      d.m = week.getMonth();
	                      d.d = week.getDate() + (d.w + 6) % 7;
	                    }
	                  } else if ("W" in d || "U" in d) {
	                    if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	                    day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	                    d.m = 0;
	                    d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	                  }
	                  if ("Z" in d) {
	                    d.H += d.Z / 100 | 0;
	                    d.M += d.Z % 100;
	                    return utcDate(d);
	                  }
	                  return localDate(d);
	                };
	              }
	              function parseSpecifier(d, specifier, string, j) {
	                var i = 0, n = specifier.length, m = string.length, c, parse;
	                while (i < n) {
	                  if (j >= m) return -1;
	                  c = specifier.charCodeAt(i++);
	                  if (c === 37) {
	                    c = specifier.charAt(i++);
	                    parse = parses[c in pads ? specifier.charAt(i++) : c];
	                    if (!parse || (j = parse(d, string, j)) < 0) return -1;
	                  } else if (c != string.charCodeAt(j++)) {
	                    return -1;
	                  }
	                }
	                return j;
	              }
	              function parsePeriod(d, string, i) {
	                var n = periodRe.exec(string.slice(i));
	                return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	              }
	              function parseShortWeekday(d, string, i) {
	                var n = shortWeekdayRe.exec(string.slice(i));
	                return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	              }
	              function parseWeekday(d, string, i) {
	                var n = weekdayRe.exec(string.slice(i));
	                return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	              }
	              function parseShortMonth(d, string, i) {
	                var n = shortMonthRe.exec(string.slice(i));
	                return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	              }
	              function parseMonth(d, string, i) {
	                var n = monthRe.exec(string.slice(i));
	                return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	              }
	              function parseLocaleDateTime(d, string, i) {
	                return parseSpecifier(d, locale_dateTime, string, i);
	              }
	              function parseLocaleDate(d, string, i) {
	                return parseSpecifier(d, locale_date, string, i);
	              }
	              function parseLocaleTime(d, string, i) {
	                return parseSpecifier(d, locale_time, string, i);
	              }
	              function formatShortWeekday(d) {
	                return locale_shortWeekdays[d.getDay()];
	              }
	              function formatWeekday(d) {
	                return locale_weekdays[d.getDay()];
	              }
	              function formatShortMonth(d) {
	                return locale_shortMonths[d.getMonth()];
	              }
	              function formatMonth(d) {
	                return locale_months[d.getMonth()];
	              }
	              function formatPeriod(d) {
	                return locale_periods[+(d.getHours() >= 12)];
	              }
	              function formatQuarter(d) {
	                return 1 + ~~(d.getMonth() / 3);
	              }
	              function formatUTCShortWeekday(d) {
	                return locale_shortWeekdays[d.getUTCDay()];
	              }
	              function formatUTCWeekday(d) {
	                return locale_weekdays[d.getUTCDay()];
	              }
	              function formatUTCShortMonth(d) {
	                return locale_shortMonths[d.getUTCMonth()];
	              }
	              function formatUTCMonth(d) {
	                return locale_months[d.getUTCMonth()];
	              }
	              function formatUTCPeriod(d) {
	                return locale_periods[+(d.getUTCHours() >= 12)];
	              }
	              function formatUTCQuarter(d) {
	                return 1 + ~~(d.getUTCMonth() / 3);
	              }
	              return {
	                format: function(specifier) {
	                  var f = newFormat(specifier += "", formats);
	                  f.toString = function() {
	                    return specifier;
	                  };
	                  return f;
	                },
	                parse: function(specifier) {
	                  var p = newParse(specifier += "", false);
	                  p.toString = function() {
	                    return specifier;
	                  };
	                  return p;
	                },
	                utcFormat: function(specifier) {
	                  var f = newFormat(specifier += "", utcFormats);
	                  f.toString = function() {
	                    return specifier;
	                  };
	                  return f;
	                },
	                utcParse: function(specifier) {
	                  var p = newParse(specifier += "", true);
	                  p.toString = function() {
	                    return specifier;
	                  };
	                  return p;
	                }
	              };
	            }
	            var pads = { "-": "", "_": " ", "0": "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
	            function pad(value, fill, width) {
	              var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	              return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	            }
	            function requote(s) {
	              return s.replace(requoteRe, "\\$&");
	            }
	            function formatRe(names) {
	              return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	            }
	            function formatLookup(names) {
	              var map2 = {}, i = -1, n = names.length;
	              while (++i < n) map2[names[i].toLowerCase()] = i;
	              return map2;
	            }
	            function parseWeekdayNumberSunday(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 1));
	              return n ? (d.w = +n[0], i + n[0].length) : -1;
	            }
	            function parseWeekdayNumberMonday(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 1));
	              return n ? (d.u = +n[0], i + n[0].length) : -1;
	            }
	            function parseWeekNumberSunday(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.U = +n[0], i + n[0].length) : -1;
	            }
	            function parseWeekNumberISO(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.V = +n[0], i + n[0].length) : -1;
	            }
	            function parseWeekNumberMonday(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.W = +n[0], i + n[0].length) : -1;
	            }
	            function parseFullYear(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 4));
	              return n ? (d.y = +n[0], i + n[0].length) : -1;
	            }
	            function parseYear(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
	            }
	            function parseZone(d, string, i) {
	              var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	              return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	            }
	            function parseQuarter(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 1));
	              return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	            }
	            function parseMonthNumber(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	            }
	            function parseDayOfMonth(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.d = +n[0], i + n[0].length) : -1;
	            }
	            function parseDayOfYear(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 3));
	              return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	            }
	            function parseHour24(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.H = +n[0], i + n[0].length) : -1;
	            }
	            function parseMinutes(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.M = +n[0], i + n[0].length) : -1;
	            }
	            function parseSeconds(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 2));
	              return n ? (d.S = +n[0], i + n[0].length) : -1;
	            }
	            function parseMilliseconds(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 3));
	              return n ? (d.L = +n[0], i + n[0].length) : -1;
	            }
	            function parseMicroseconds(d, string, i) {
	              var n = numberRe.exec(string.slice(i, i + 6));
	              return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
	            }
	            function parseLiteralPercent(d, string, i) {
	              var n = percentRe.exec(string.slice(i, i + 1));
	              return n ? i + n[0].length : -1;
	            }
	            function parseUnixTimestamp(d, string, i) {
	              var n = numberRe.exec(string.slice(i));
	              return n ? (d.Q = +n[0], i + n[0].length) : -1;
	            }
	            function parseUnixTimestampSeconds(d, string, i) {
	              var n = numberRe.exec(string.slice(i));
	              return n ? (d.s = +n[0], i + n[0].length) : -1;
	            }
	            function formatDayOfMonth(d, p) {
	              return pad(d.getDate(), p, 2);
	            }
	            function formatHour24(d, p) {
	              return pad(d.getHours(), p, 2);
	            }
	            function formatHour12(d, p) {
	              return pad(d.getHours() % 12 || 12, p, 2);
	            }
	            function formatDayOfYear(d, p) {
	              return pad(1 + src_day.Z.count((0, year.Z)(d), d), p, 3);
	            }
	            function formatMilliseconds(d, p) {
	              return pad(d.getMilliseconds(), p, 3);
	            }
	            function formatMicroseconds(d, p) {
	              return formatMilliseconds(d, p) + "000";
	            }
	            function formatMonthNumber(d, p) {
	              return pad(d.getMonth() + 1, p, 2);
	            }
	            function formatMinutes(d, p) {
	              return pad(d.getMinutes(), p, 2);
	            }
	            function formatSeconds(d, p) {
	              return pad(d.getSeconds(), p, 2);
	            }
	            function formatWeekdayNumberMonday(d) {
	              var day = d.getDay();
	              return day === 0 ? 7 : day;
	            }
	            function formatWeekNumberSunday(d, p) {
	              return pad(src_week.OM.count((0, year.Z)(d) - 1, d), p, 2);
	            }
	            function formatWeekNumberISO(d, p) {
	              var day = d.getDay();
	              d = day >= 4 || day === 0 ? (0, src_week.bL)(d) : src_week.bL.ceil(d);
	              return pad(src_week.bL.count((0, year.Z)(d), d) + ((0, year.Z)(d).getDay() === 4), p, 2);
	            }
	            function formatWeekdayNumberSunday(d) {
	              return d.getDay();
	            }
	            function formatWeekNumberMonday(d, p) {
	              return pad(src_week.wA.count((0, year.Z)(d) - 1, d), p, 2);
	            }
	            function formatYear(d, p) {
	              return pad(d.getFullYear() % 100, p, 2);
	            }
	            function formatFullYear(d, p) {
	              return pad(d.getFullYear() % 1e4, p, 4);
	            }
	            function formatZone(d) {
	              var z = d.getTimezoneOffset();
	              return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
	            }
	            function formatUTCDayOfMonth(d, p) {
	              return pad(d.getUTCDate(), p, 2);
	            }
	            function formatUTCHour24(d, p) {
	              return pad(d.getUTCHours(), p, 2);
	            }
	            function formatUTCHour12(d, p) {
	              return pad(d.getUTCHours() % 12 || 12, p, 2);
	            }
	            function formatUTCDayOfYear(d, p) {
	              return pad(1 + utcDay.Z.count((0, utcYear.Z)(d), d), p, 3);
	            }
	            function formatUTCMilliseconds(d, p) {
	              return pad(d.getUTCMilliseconds(), p, 3);
	            }
	            function formatUTCMicroseconds(d, p) {
	              return formatUTCMilliseconds(d, p) + "000";
	            }
	            function formatUTCMonthNumber(d, p) {
	              return pad(d.getUTCMonth() + 1, p, 2);
	            }
	            function formatUTCMinutes(d, p) {
	              return pad(d.getUTCMinutes(), p, 2);
	            }
	            function formatUTCSeconds(d, p) {
	              return pad(d.getUTCSeconds(), p, 2);
	            }
	            function formatUTCWeekdayNumberMonday(d) {
	              var dow = d.getUTCDay();
	              return dow === 0 ? 7 : dow;
	            }
	            function formatUTCWeekNumberSunday(d, p) {
	              return pad(utcWeek.Ox.count((0, utcYear.Z)(d) - 1, d), p, 2);
	            }
	            function formatUTCWeekNumberISO(d, p) {
	              var day = d.getUTCDay();
	              d = day >= 4 || day === 0 ? (0, utcWeek.hB)(d) : utcWeek.hB.ceil(d);
	              return pad(utcWeek.hB.count((0, utcYear.Z)(d), d) + ((0, utcYear.Z)(d).getUTCDay() === 4), p, 2);
	            }
	            function formatUTCWeekdayNumberSunday(d) {
	              return d.getUTCDay();
	            }
	            function formatUTCWeekNumberMonday(d, p) {
	              return pad(utcWeek.l6.count((0, utcYear.Z)(d) - 1, d), p, 2);
	            }
	            function formatUTCYear(d, p) {
	              return pad(d.getUTCFullYear() % 100, p, 2);
	            }
	            function formatUTCFullYear(d, p) {
	              return pad(d.getUTCFullYear() % 1e4, p, 4);
	            }
	            function formatUTCZone() {
	              return "+0000";
	            }
	            function formatLiteralPercent() {
	              return "%";
	            }
	            function formatUnixTimestamp(d) {
	              return +d;
	            }
	            function formatUnixTimestampSeconds(d) {
	              return Math.floor(+d / 1e3);
	            }
	            var locale;
	            var timeFormat;
	            var utcFormat;
	            defaultLocale({
	              dateTime: "%x, %X",
	              date: "%-m/%-d/%Y",
	              time: "%-I:%M:%S %p",
	              periods: ["AM", "PM"],
	              days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	              shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	              months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	              shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	            });
	            function defaultLocale(definition) {
	              locale = formatLocale(definition);
	              timeFormat = locale.format;
	              locale.parse;
	              utcFormat = locale.utcFormat;
	              locale.utcParse;
	              return locale;
	            }
	          }
	        ),
	        /***/
	        82301: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              a: function() {
	                return (
	                  /* binding */
	                  days
	                );
	              }
	              /* harmony export */
	            });
	            var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(30052);
	            var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(54263);
	            var day = (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	              date.setHours(0, 0, 0, 0);
	            }, function(date, step) {
	              date.setDate(date.getDate() + step);
	            }, function(start, end) {
	              return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration_js__WEBPACK_IMPORTED_MODULE_1__.yB) / _duration_js__WEBPACK_IMPORTED_MODULE_1__.UD;
	            }, function(date) {
	              return date.getDate() - 1;
	            });
	            __webpack_exports__2.Z = day;
	            var days = day.range;
	          }
	        ),
	        /***/
	        54263: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              UD: function() {
	                return (
	                  /* binding */
	                  durationDay
	                );
	              },
	              /* harmony export */
	              Y2: function() {
	                return (
	                  /* binding */
	                  durationHour
	                );
	              },
	              /* harmony export */
	              Ym: function() {
	                return (
	                  /* binding */
	                  durationSecond
	                );
	              },
	              /* harmony export */
	              iM: function() {
	                return (
	                  /* binding */
	                  durationWeek
	                );
	              },
	              /* harmony export */
	              yB: function() {
	                return (
	                  /* binding */
	                  durationMinute
	                );
	              }
	              /* harmony export */
	            });
	            var durationSecond = 1e3;
	            var durationMinute = 6e4;
	            var durationHour = 36e5;
	            var durationDay = 864e5;
	            var durationWeek = 6048e5;
	          }
	        ),
	        /***/
	        81041: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            __webpack_require__2.d(__webpack_exports__2, {
	              timeDay: function() {
	                return (
	                  /* reexport */
	                  day.Z
	                );
	              },
	              timeDays: function() {
	                return (
	                  /* reexport */
	                  day.a
	                );
	              },
	              timeFriday: function() {
	                return (
	                  /* reexport */
	                  week.mC
	                );
	              },
	              timeFridays: function() {
	                return (
	                  /* reexport */
	                  week.b$
	                );
	              },
	              timeHour: function() {
	                return (
	                  /* reexport */
	                  src_hour
	                );
	              },
	              timeHours: function() {
	                return (
	                  /* reexport */
	                  hours
	                );
	              },
	              timeInterval: function() {
	                return (
	                  /* reexport */
	                  interval.Z
	                );
	              },
	              timeMillisecond: function() {
	                return (
	                  /* reexport */
	                  src_millisecond
	                );
	              },
	              timeMilliseconds: function() {
	                return (
	                  /* reexport */
	                  milliseconds
	                );
	              },
	              timeMinute: function() {
	                return (
	                  /* reexport */
	                  src_minute
	                );
	              },
	              timeMinutes: function() {
	                return (
	                  /* reexport */
	                  minutes
	                );
	              },
	              timeMonday: function() {
	                return (
	                  /* reexport */
	                  week.wA
	                );
	              },
	              timeMondays: function() {
	                return (
	                  /* reexport */
	                  week.bJ
	                );
	              },
	              timeMonth: function() {
	                return (
	                  /* reexport */
	                  src_month
	                );
	              },
	              timeMonths: function() {
	                return (
	                  /* reexport */
	                  months
	                );
	              },
	              timeSaturday: function() {
	                return (
	                  /* reexport */
	                  week.EY
	                );
	              },
	              timeSaturdays: function() {
	                return (
	                  /* reexport */
	                  week.Ff
	                );
	              },
	              timeSecond: function() {
	                return (
	                  /* reexport */
	                  src_second
	                );
	              },
	              timeSeconds: function() {
	                return (
	                  /* reexport */
	                  seconds
	                );
	              },
	              timeSunday: function() {
	                return (
	                  /* reexport */
	                  week.OM
	                );
	              },
	              timeSundays: function() {
	                return (
	                  /* reexport */
	                  week.vm
	                );
	              },
	              timeThursday: function() {
	                return (
	                  /* reexport */
	                  week.bL
	                );
	              },
	              timeThursdays: function() {
	                return (
	                  /* reexport */
	                  week.$t
	                );
	              },
	              timeTuesday: function() {
	                return (
	                  /* reexport */
	                  week.sy
	                );
	              },
	              timeTuesdays: function() {
	                return (
	                  /* reexport */
	                  week.aU
	                );
	              },
	              timeWednesday: function() {
	                return (
	                  /* reexport */
	                  week.zg
	                );
	              },
	              timeWednesdays: function() {
	                return (
	                  /* reexport */
	                  week.Ld
	                );
	              },
	              timeWeek: function() {
	                return (
	                  /* reexport */
	                  week.OM
	                );
	              },
	              timeWeeks: function() {
	                return (
	                  /* reexport */
	                  week.vm
	                );
	              },
	              timeYear: function() {
	                return (
	                  /* reexport */
	                  year.Z
	                );
	              },
	              timeYears: function() {
	                return (
	                  /* reexport */
	                  year.g
	                );
	              },
	              utcDay: function() {
	                return (
	                  /* reexport */
	                  utcDay.Z
	                );
	              },
	              utcDays: function() {
	                return (
	                  /* reexport */
	                  utcDay.y
	                );
	              },
	              utcFriday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.QQ
	                );
	              },
	              utcFridays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.fz
	                );
	              },
	              utcHour: function() {
	                return (
	                  /* reexport */
	                  src_utcHour
	                );
	              },
	              utcHours: function() {
	                return (
	                  /* reexport */
	                  utcHours
	                );
	              },
	              utcMillisecond: function() {
	                return (
	                  /* reexport */
	                  src_millisecond
	                );
	              },
	              utcMilliseconds: function() {
	                return (
	                  /* reexport */
	                  milliseconds
	                );
	              },
	              utcMinute: function() {
	                return (
	                  /* reexport */
	                  src_utcMinute
	                );
	              },
	              utcMinutes: function() {
	                return (
	                  /* reexport */
	                  utcMinutes
	                );
	              },
	              utcMonday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.l6
	                );
	              },
	              utcMondays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.$3
	                );
	              },
	              utcMonth: function() {
	                return (
	                  /* reexport */
	                  src_utcMonth
	                );
	              },
	              utcMonths: function() {
	                return (
	                  /* reexport */
	                  utcMonths
	                );
	              },
	              utcSaturday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.g4
	                );
	              },
	              utcSaturdays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.Q_
	                );
	              },
	              utcSecond: function() {
	                return (
	                  /* reexport */
	                  src_second
	                );
	              },
	              utcSeconds: function() {
	                return (
	                  /* reexport */
	                  seconds
	                );
	              },
	              utcSunday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.Ox
	                );
	              },
	              utcSundays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.SU
	                );
	              },
	              utcThursday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.hB
	                );
	              },
	              utcThursdays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.xj
	                );
	              },
	              utcTuesday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.J1
	                );
	              },
	              utcTuesdays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.DK
	                );
	              },
	              utcWednesday: function() {
	                return (
	                  /* reexport */
	                  utcWeek.b3
	                );
	              },
	              utcWednesdays: function() {
	                return (
	                  /* reexport */
	                  utcWeek.uy
	                );
	              },
	              utcWeek: function() {
	                return (
	                  /* reexport */
	                  utcWeek.Ox
	                );
	              },
	              utcWeeks: function() {
	                return (
	                  /* reexport */
	                  utcWeek.SU
	                );
	              },
	              utcYear: function() {
	                return (
	                  /* reexport */
	                  utcYear.Z
	                );
	              },
	              utcYears: function() {
	                return (
	                  /* reexport */
	                  utcYear.D
	                );
	              }
	            });
	            var interval = __webpack_require__2(30052);
	            var millisecond = (0, interval.Z)(function() {
	            }, function(date, step) {
	              date.setTime(+date + step);
	            }, function(start, end) {
	              return end - start;
	            });
	            millisecond.every = function(k) {
	              k = Math.floor(k);
	              if (!isFinite(k) || !(k > 0)) return null;
	              if (!(k > 1)) return millisecond;
	              return (0, interval.Z)(function(date) {
	                date.setTime(Math.floor(date / k) * k);
	              }, function(date, step) {
	                date.setTime(+date + step * k);
	              }, function(start, end) {
	                return (end - start) / k;
	              });
	            };
	            var src_millisecond = millisecond;
	            var milliseconds = millisecond.range;
	            var duration = __webpack_require__2(54263);
	            var second = (0, interval.Z)(function(date) {
	              date.setTime(date - date.getMilliseconds());
	            }, function(date, step) {
	              date.setTime(+date + step * duration.Ym);
	            }, function(start, end) {
	              return (end - start) / duration.Ym;
	            }, function(date) {
	              return date.getUTCSeconds();
	            });
	            var src_second = second;
	            var seconds = second.range;
	            var minute = (0, interval.Z)(function(date) {
	              date.setTime(date - date.getMilliseconds() - date.getSeconds() * duration.Ym);
	            }, function(date, step) {
	              date.setTime(+date + step * duration.yB);
	            }, function(start, end) {
	              return (end - start) / duration.yB;
	            }, function(date) {
	              return date.getMinutes();
	            });
	            var src_minute = minute;
	            var minutes = minute.range;
	            var hour = (0, interval.Z)(function(date) {
	              date.setTime(date - date.getMilliseconds() - date.getSeconds() * duration.Ym - date.getMinutes() * duration.yB);
	            }, function(date, step) {
	              date.setTime(+date + step * duration.Y2);
	            }, function(start, end) {
	              return (end - start) / duration.Y2;
	            }, function(date) {
	              return date.getHours();
	            });
	            var src_hour = hour;
	            var hours = hour.range;
	            var day = __webpack_require__2(82301);
	            var week = __webpack_require__2(59879);
	            var month = (0, interval.Z)(function(date) {
	              date.setDate(1);
	              date.setHours(0, 0, 0, 0);
	            }, function(date, step) {
	              date.setMonth(date.getMonth() + step);
	            }, function(start, end) {
	              return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	            }, function(date) {
	              return date.getMonth();
	            });
	            var src_month = month;
	            var months = month.range;
	            var year = __webpack_require__2(34823);
	            var utcMinute = (0, interval.Z)(function(date) {
	              date.setUTCSeconds(0, 0);
	            }, function(date, step) {
	              date.setTime(+date + step * duration.yB);
	            }, function(start, end) {
	              return (end - start) / duration.yB;
	            }, function(date) {
	              return date.getUTCMinutes();
	            });
	            var src_utcMinute = utcMinute;
	            var utcMinutes = utcMinute.range;
	            var utcHour = (0, interval.Z)(function(date) {
	              date.setUTCMinutes(0, 0, 0);
	            }, function(date, step) {
	              date.setTime(+date + step * duration.Y2);
	            }, function(start, end) {
	              return (end - start) / duration.Y2;
	            }, function(date) {
	              return date.getUTCHours();
	            });
	            var src_utcHour = utcHour;
	            var utcHours = utcHour.range;
	            var utcDay = __webpack_require__2(48480);
	            var utcWeek = __webpack_require__2(58176);
	            var utcMonth = (0, interval.Z)(function(date) {
	              date.setUTCDate(1);
	              date.setUTCHours(0, 0, 0, 0);
	            }, function(date, step) {
	              date.setUTCMonth(date.getUTCMonth() + step);
	            }, function(start, end) {
	              return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	            }, function(date) {
	              return date.getUTCMonth();
	            });
	            var src_utcMonth = utcMonth;
	            var utcMonths = utcMonth.range;
	            var utcYear = __webpack_require__2(79791);
	          }
	        ),
	        /***/
	        30052: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              Z: function() {
	                return (
	                  /* binding */
	                  newInterval
	                );
	              }
	              /* harmony export */
	            });
	            var t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
	            function newInterval(floori, offseti, count, field) {
	              function interval(date) {
	                return floori(date = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date)), date;
	              }
	              interval.floor = function(date) {
	                return floori(date = /* @__PURE__ */ new Date(+date)), date;
	              };
	              interval.ceil = function(date) {
	                return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	              };
	              interval.round = function(date) {
	                var d0 = interval(date), d1 = interval.ceil(date);
	                return date - d0 < d1 - date ? d0 : d1;
	              };
	              interval.offset = function(date, step) {
	                return offseti(date = /* @__PURE__ */ new Date(+date), step == null ? 1 : Math.floor(step)), date;
	              };
	              interval.range = function(start, stop, step) {
	                var range2 = [], previous;
	                start = interval.ceil(start);
	                step = step == null ? 1 : Math.floor(step);
	                if (!(start < stop) || !(step > 0)) return range2;
	                do
	                  range2.push(previous = /* @__PURE__ */ new Date(+start)), offseti(start, step), floori(start);
	                while (previous < start && start < stop);
	                return range2;
	              };
	              interval.filter = function(test) {
	                return newInterval(function(date) {
	                  if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	                }, function(date, step) {
	                  if (date >= date) {
	                    if (step < 0) while (++step <= 0) {
	                      while (offseti(date, -1), !test(date)) {
	                      }
	                    }
	                    else while (--step >= 0) {
	                      while (offseti(date, 1), !test(date)) {
	                      }
	                    }
	                  }
	                });
	              };
	              if (count) {
	                interval.count = function(start, end) {
	                  t0.setTime(+start), t1.setTime(+end);
	                  floori(t0), floori(t1);
	                  return Math.floor(count(t0, t1));
	                };
	                interval.every = function(step) {
	                  step = Math.floor(step);
	                  return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
	                    return field(d) % step === 0;
	                  } : function(d) {
	                    return interval.count(0, d) % step === 0;
	                  });
	                };
	              }
	              return interval;
	            }
	          }
	        ),
	        /***/
	        48480: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              y: function() {
	                return (
	                  /* binding */
	                  utcDays
	                );
	              }
	              /* harmony export */
	            });
	            var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(30052);
	            var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(54263);
	            var utcDay = (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	              date.setUTCHours(0, 0, 0, 0);
	            }, function(date, step) {
	              date.setUTCDate(date.getUTCDate() + step);
	            }, function(start, end) {
	              return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__.UD;
	            }, function(date) {
	              return date.getUTCDate() - 1;
	            });
	            __webpack_exports__2.Z = utcDay;
	            var utcDays = utcDay.range;
	          }
	        ),
	        /***/
	        58176: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              $3: function() {
	                return (
	                  /* binding */
	                  utcMondays
	                );
	              },
	              /* harmony export */
	              DK: function() {
	                return (
	                  /* binding */
	                  utcTuesdays
	                );
	              },
	              /* harmony export */
	              J1: function() {
	                return (
	                  /* binding */
	                  utcTuesday
	                );
	              },
	              /* harmony export */
	              Ox: function() {
	                return (
	                  /* binding */
	                  utcSunday
	                );
	              },
	              /* harmony export */
	              QQ: function() {
	                return (
	                  /* binding */
	                  utcFriday
	                );
	              },
	              /* harmony export */
	              Q_: function() {
	                return (
	                  /* binding */
	                  utcSaturdays
	                );
	              },
	              /* harmony export */
	              SU: function() {
	                return (
	                  /* binding */
	                  utcSundays
	                );
	              },
	              /* harmony export */
	              b3: function() {
	                return (
	                  /* binding */
	                  utcWednesday
	                );
	              },
	              /* harmony export */
	              fz: function() {
	                return (
	                  /* binding */
	                  utcFridays
	                );
	              },
	              /* harmony export */
	              g4: function() {
	                return (
	                  /* binding */
	                  utcSaturday
	                );
	              },
	              /* harmony export */
	              hB: function() {
	                return (
	                  /* binding */
	                  utcThursday
	                );
	              },
	              /* harmony export */
	              l6: function() {
	                return (
	                  /* binding */
	                  utcMonday
	                );
	              },
	              /* harmony export */
	              uy: function() {
	                return (
	                  /* binding */
	                  utcWednesdays
	                );
	              },
	              /* harmony export */
	              xj: function() {
	                return (
	                  /* binding */
	                  utcThursdays
	                );
	              }
	              /* harmony export */
	            });
	            var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(30052);
	            var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(54263);
	            function utcWeekday(i) {
	              return (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	                date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	                date.setUTCHours(0, 0, 0, 0);
	              }, function(date, step) {
	                date.setUTCDate(date.getUTCDate() + step * 7);
	              }, function(start, end) {
	                return (end - start) / _duration_js__WEBPACK_IMPORTED_MODULE_1__.iM;
	              });
	            }
	            var utcSunday = utcWeekday(0);
	            var utcMonday = utcWeekday(1);
	            var utcTuesday = utcWeekday(2);
	            var utcWednesday = utcWeekday(3);
	            var utcThursday = utcWeekday(4);
	            var utcFriday = utcWeekday(5);
	            var utcSaturday = utcWeekday(6);
	            var utcSundays = utcSunday.range;
	            var utcMondays = utcMonday.range;
	            var utcTuesdays = utcTuesday.range;
	            var utcWednesdays = utcWednesday.range;
	            var utcThursdays = utcThursday.range;
	            var utcFridays = utcFriday.range;
	            var utcSaturdays = utcSaturday.range;
	          }
	        ),
	        /***/
	        79791: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              D: function() {
	                return (
	                  /* binding */
	                  utcYears
	                );
	              }
	              /* harmony export */
	            });
	            var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(30052);
	            var utcYear = (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	              date.setUTCMonth(0, 1);
	              date.setUTCHours(0, 0, 0, 0);
	            }, function(date, step) {
	              date.setUTCFullYear(date.getUTCFullYear() + step);
	            }, function(start, end) {
	              return end.getUTCFullYear() - start.getUTCFullYear();
	            }, function(date) {
	              return date.getUTCFullYear();
	            });
	            utcYear.every = function(k) {
	              return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	                date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	                date.setUTCMonth(0, 1);
	                date.setUTCHours(0, 0, 0, 0);
	              }, function(date, step) {
	                date.setUTCFullYear(date.getUTCFullYear() + step * k);
	              });
	            };
	            __webpack_exports__2.Z = utcYear;
	            var utcYears = utcYear.range;
	          }
	        ),
	        /***/
	        59879: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              $t: function() {
	                return (
	                  /* binding */
	                  thursdays
	                );
	              },
	              /* harmony export */
	              EY: function() {
	                return (
	                  /* binding */
	                  saturday
	                );
	              },
	              /* harmony export */
	              Ff: function() {
	                return (
	                  /* binding */
	                  saturdays
	                );
	              },
	              /* harmony export */
	              Ld: function() {
	                return (
	                  /* binding */
	                  wednesdays
	                );
	              },
	              /* harmony export */
	              OM: function() {
	                return (
	                  /* binding */
	                  sunday
	                );
	              },
	              /* harmony export */
	              aU: function() {
	                return (
	                  /* binding */
	                  tuesdays
	                );
	              },
	              /* harmony export */
	              b$: function() {
	                return (
	                  /* binding */
	                  fridays
	                );
	              },
	              /* harmony export */
	              bJ: function() {
	                return (
	                  /* binding */
	                  mondays
	                );
	              },
	              /* harmony export */
	              bL: function() {
	                return (
	                  /* binding */
	                  thursday
	                );
	              },
	              /* harmony export */
	              mC: function() {
	                return (
	                  /* binding */
	                  friday
	                );
	              },
	              /* harmony export */
	              sy: function() {
	                return (
	                  /* binding */
	                  tuesday
	                );
	              },
	              /* harmony export */
	              vm: function() {
	                return (
	                  /* binding */
	                  sundays
	                );
	              },
	              /* harmony export */
	              wA: function() {
	                return (
	                  /* binding */
	                  monday
	                );
	              },
	              /* harmony export */
	              zg: function() {
	                return (
	                  /* binding */
	                  wednesday
	                );
	              }
	              /* harmony export */
	            });
	            var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(30052);
	            var _duration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(54263);
	            function weekday(i) {
	              return (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	                date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	                date.setHours(0, 0, 0, 0);
	              }, function(date, step) {
	                date.setDate(date.getDate() + step * 7);
	              }, function(start, end) {
	                return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration_js__WEBPACK_IMPORTED_MODULE_1__.yB) / _duration_js__WEBPACK_IMPORTED_MODULE_1__.iM;
	              });
	            }
	            var sunday = weekday(0);
	            var monday = weekday(1);
	            var tuesday = weekday(2);
	            var wednesday = weekday(3);
	            var thursday = weekday(4);
	            var friday = weekday(5);
	            var saturday = weekday(6);
	            var sundays = sunday.range;
	            var mondays = monday.range;
	            var tuesdays = tuesday.range;
	            var wednesdays = wednesday.range;
	            var thursdays = thursday.range;
	            var fridays = friday.range;
	            var saturdays = saturday.range;
	          }
	        ),
	        /***/
	        34823: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              /* harmony export */
	              g: function() {
	                return (
	                  /* binding */
	                  years
	                );
	              }
	              /* harmony export */
	            });
	            var _interval_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(30052);
	            var year = (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	              date.setMonth(0, 1);
	              date.setHours(0, 0, 0, 0);
	            }, function(date, step) {
	              date.setFullYear(date.getFullYear() + step);
	            }, function(start, end) {
	              return end.getFullYear() - start.getFullYear();
	            }, function(date) {
	              return date.getFullYear();
	            });
	            year.every = function(k) {
	              return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval_js__WEBPACK_IMPORTED_MODULE_0__.Z)(function(date) {
	                date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	                date.setMonth(0, 1);
	                date.setHours(0, 0, 0, 0);
	              }, function(date, step) {
	                date.setFullYear(date.getFullYear() + step * k);
	              });
	            };
	            __webpack_exports__2.Z = year;
	            var years = year.range;
	          }
	        ),
	        /***/
	        17045: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var keys = __webpack_require__2(8709);
	            var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
	            var toStr = Object.prototype.toString;
	            var concat = Array.prototype.concat;
	            var origDefineProperty = Object.defineProperty;
	            var isFunction = function(fn) {
	              return typeof fn === "function" && toStr.call(fn) === "[object Function]";
	            };
	            var hasPropertyDescriptors = __webpack_require__2(55622)();
	            var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;
	            var defineProperty = function(object, name2, value, predicate) {
	              if (name2 in object) {
	                if (predicate === true) {
	                  if (object[name2] === value) {
	                    return;
	                  }
	                } else if (!isFunction(predicate) || !predicate()) {
	                  return;
	                }
	              }
	              if (supportsDescriptors) {
	                origDefineProperty(object, name2, {
	                  configurable: true,
	                  enumerable: false,
	                  value,
	                  writable: true
	                });
	              } else {
	                object[name2] = value;
	              }
	            };
	            var defineProperties = function(object, map2) {
	              var predicates = arguments.length > 2 ? arguments[2] : {};
	              var props = keys(map2);
	              if (hasSymbols) {
	                props = concat.call(props, Object.getOwnPropertySymbols(map2));
	              }
	              for (var i = 0; i < props.length; i += 1) {
	                defineProperty(object, props[i], map2[props[i]], predicates[props[i]]);
	              }
	            };
	            defineProperties.supportsDescriptors = !!supportsDescriptors;
	            module2.exports = defineProperties;
	          }
	        ),
	        /***/
	        46775: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              for (var i = 0; i < arguments.length; i++) {
	                if (arguments[i] !== undefined) return arguments[i];
	              }
	            };
	          }
	        ),
	        /***/
	        53545: (
	          /***/
	          function(module2) {
	            module2.exports = kerning;
	            var canvas = kerning.canvas = document.createElement("canvas");
	            var ctx = canvas.getContext("2d");
	            var asciiPairs = createPairs([32, 126]);
	            kerning.createPairs = createPairs;
	            kerning.ascii = asciiPairs;
	            function kerning(family, o) {
	              if (Array.isArray(family)) family = family.join(", ");
	              var table = {}, pairs, fs = 16, threshold = 0.05;
	              if (o) {
	                if (o.length === 2 && typeof o[0] === "number") {
	                  pairs = createPairs(o);
	                } else if (Array.isArray(o)) {
	                  pairs = o;
	                } else {
	                  if (o.o) pairs = createPairs(o.o);
	                  else if (o.pairs) pairs = o.pairs;
	                  if (o.fontSize) fs = o.fontSize;
	                  if (o.threshold != null) threshold = o.threshold;
	                }
	              }
	              if (!pairs) pairs = asciiPairs;
	              ctx.font = fs + "px " + family;
	              for (var i = 0; i < pairs.length; i++) {
	                var pair = pairs[i];
	                var width = ctx.measureText(pair[0]).width + ctx.measureText(pair[1]).width;
	                var kerningWidth = ctx.measureText(pair).width;
	                if (Math.abs(width - kerningWidth) > fs * threshold) {
	                  var emWidth = (kerningWidth - width) / fs;
	                  table[pair] = emWidth * 1e3;
	                }
	              }
	              return table;
	            }
	            function createPairs(range2) {
	              var pairs = [];
	              for (var i = range2[0]; i <= range2[1]; i++) {
	                var leftChar = String.fromCharCode(i);
	                for (var j = range2[0]; j < range2[1]; j++) {
	                  var rightChar = String.fromCharCode(j);
	                  var pair = leftChar + rightChar;
	                  pairs.push(pair);
	                }
	              }
	              return pairs;
	            }
	          }
	        ),
	        /***/
	        31457: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var abs = __webpack_require__2(65185);
	            var normalize = __webpack_require__2(18625);
	            var methods = {
	              "M": "moveTo",
	              "C": "bezierCurveTo"
	            };
	            module2.exports = function(context, segments) {
	              context.beginPath();
	              normalize(abs(segments)).forEach(
	                function(segment) {
	                  var command = segment[0];
	                  var args = segment.slice(1);
	                  context[methods[command]].apply(context, args);
	                }
	              );
	              context.closePath();
	            };
	          }
	        ),
	        /***/
	        90660: (
	          /***/
	          function(module2) {
	            module2.exports = function(dtype) {
	              switch (dtype) {
	                case "int8":
	                  return Int8Array;
	                case "int16":
	                  return Int16Array;
	                case "int32":
	                  return Int32Array;
	                case "uint8":
	                  return Uint8Array;
	                case "uint16":
	                  return Uint16Array;
	                case "uint32":
	                  return Uint32Array;
	                case "float32":
	                  return Float32Array;
	                case "float64":
	                  return Float64Array;
	                case "array":
	                  return Array;
	                case "uint8_clamped":
	                  return Uint8ClampedArray;
	              }
	            };
	          }
	        ),
	        /***/
	        12129: (
	          /***/
	          function(module2) {
	            function dupe_array(count, value, i) {
	              var c = count[i] | 0;
	              if (c <= 0) {
	                return [];
	              }
	              var result = new Array(c), j;
	              if (i === count.length - 1) {
	                for (j = 0; j < c; ++j) {
	                  result[j] = value;
	                }
	              } else {
	                for (j = 0; j < c; ++j) {
	                  result[j] = dupe_array(count, value, i + 1);
	                }
	              }
	              return result;
	            }
	            function dupe_number(count, value) {
	              var result, i;
	              result = new Array(count);
	              for (i = 0; i < count; ++i) {
	                result[i] = value;
	              }
	              return result;
	            }
	            function dupe(count, value) {
	              if (typeof value === "undefined") {
	                value = 0;
	              }
	              switch (typeof count) {
	                case "number":
	                  if (count > 0) {
	                    return dupe_number(count | 0, value);
	                  }
	                  break;
	                case "object":
	                  if (typeof count.length === "number") {
	                    return dupe_array(count, value, 0);
	                  }
	                  break;
	              }
	              return [];
	            }
	            module2.exports = dupe;
	          }
	        ),
	        /***/
	        11474: (
	          /***/
	          function(module2) {
	            module2.exports = earcut;
	            module2.exports["default"] = earcut;
	            function earcut(data, holeIndices, dim) {
	              dim = dim || 2;
	              var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
	              if (!outerNode || outerNode.next === outerNode.prev) return triangles;
	              var minX, minY, maxX, maxY, x, y, invSize;
	              if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	              if (data.length > 80 * dim) {
	                minX = maxX = data[0];
	                minY = maxY = data[1];
	                for (var i = dim; i < outerLen; i += dim) {
	                  x = data[i];
	                  y = data[i + 1];
	                  if (x < minX) minX = x;
	                  if (y < minY) minY = y;
	                  if (x > maxX) maxX = x;
	                  if (y > maxY) maxY = y;
	                }
	                invSize = Math.max(maxX - minX, maxY - minY);
	                invSize = invSize !== 0 ? 1 / invSize : 0;
	              }
	              earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
	              return triangles;
	            }
	            function linkedList(data, start, end, dim, clockwise) {
	              var i, last;
	              if (clockwise === signedArea(data, start, end, dim) > 0) {
	                for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	              } else {
	                for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	              }
	              if (last && equals(last, last.next)) {
	                removeNode(last);
	                last = last.next;
	              }
	              return last;
	            }
	            function filterPoints(start, end) {
	              if (!start) return start;
	              if (!end) end = start;
	              var p = start, again;
	              do {
	                again = false;
	                if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	                  removeNode(p);
	                  p = end = p.prev;
	                  if (p === p.next) break;
	                  again = true;
	                } else {
	                  p = p.next;
	                }
	              } while (again || p !== end);
	              return end;
	            }
	            function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	              if (!ear) return;
	              if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
	              var stop = ear, prev, next;
	              while (ear.prev !== ear.next) {
	                prev = ear.prev;
	                next = ear.next;
	                if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	                  triangles.push(prev.i / dim);
	                  triangles.push(ear.i / dim);
	                  triangles.push(next.i / dim);
	                  removeNode(ear);
	                  ear = next.next;
	                  stop = next.next;
	                  continue;
	                }
	                ear = next;
	                if (ear === stop) {
	                  if (!pass) {
	                    earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
	                  } else if (pass === 1) {
	                    ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
	                    earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
	                  } else if (pass === 2) {
	                    splitEarcut(ear, triangles, dim, minX, minY, invSize);
	                  }
	                  break;
	                }
	              }
	            }
	            function isEar(ear) {
	              var a = ear.prev, b = ear, c = ear.next;
	              if (area(a, b, c) >= 0) return false;
	              var p = ear.next.next;
	              while (p !== ear.prev) {
	                if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
	                p = p.next;
	              }
	              return true;
	            }
	            function isEarHashed(ear, minX, minY, invSize) {
	              var a = ear.prev, b = ear, c = ear.next;
	              if (area(a, b, c) >= 0) return false;
	              var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
	              var minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
	              var p = ear.prevZ, n = ear.nextZ;
	              while (p && p.z >= minZ && n && n.z <= maxZ) {
	                if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
	                p = p.prevZ;
	                if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
	                n = n.nextZ;
	              }
	              while (p && p.z >= minZ) {
	                if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
	                p = p.prevZ;
	              }
	              while (n && n.z <= maxZ) {
	                if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
	                n = n.nextZ;
	              }
	              return true;
	            }
	            function cureLocalIntersections(start, triangles, dim) {
	              var p = start;
	              do {
	                var a = p.prev, b = p.next.next;
	                if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	                  triangles.push(a.i / dim);
	                  triangles.push(p.i / dim);
	                  triangles.push(b.i / dim);
	                  removeNode(p);
	                  removeNode(p.next);
	                  p = start = b;
	                }
	                p = p.next;
	              } while (p !== start);
	              return filterPoints(p);
	            }
	            function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	              var a = start;
	              do {
	                var b = a.next.next;
	                while (b !== a.prev) {
	                  if (a.i !== b.i && isValidDiagonal(a, b)) {
	                    var c = splitPolygon(a, b);
	                    a = filterPoints(a, a.next);
	                    c = filterPoints(c, c.next);
	                    earcutLinked(a, triangles, dim, minX, minY, invSize);
	                    earcutLinked(c, triangles, dim, minX, minY, invSize);
	                    return;
	                  }
	                  b = b.next;
	                }
	                a = a.next;
	              } while (a !== start);
	            }
	            function eliminateHoles(data, holeIndices, outerNode, dim) {
	              var queue = [], i, len, start, end, list;
	              for (i = 0, len = holeIndices.length; i < len; i++) {
	                start = holeIndices[i] * dim;
	                end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	                list = linkedList(data, start, end, dim, false);
	                if (list === list.next) list.steiner = true;
	                queue.push(getLeftmost(list));
	              }
	              queue.sort(compareX);
	              for (i = 0; i < queue.length; i++) {
	                eliminateHole(queue[i], outerNode);
	                outerNode = filterPoints(outerNode, outerNode.next);
	              }
	              return outerNode;
	            }
	            function compareX(a, b) {
	              return a.x - b.x;
	            }
	            function eliminateHole(hole, outerNode) {
	              outerNode = findHoleBridge(hole, outerNode);
	              if (outerNode) {
	                var b = splitPolygon(outerNode, hole);
	                filterPoints(outerNode, outerNode.next);
	                filterPoints(b, b.next);
	              }
	            }
	            function findHoleBridge(hole, outerNode) {
	              var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
	              do {
	                if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	                  var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	                  if (x <= hx && x > qx) {
	                    qx = x;
	                    if (x === hx) {
	                      if (hy === p.y) return p;
	                      if (hy === p.next.y) return p.next;
	                    }
	                    m = p.x < p.next.x ? p : p.next;
	                  }
	                }
	                p = p.next;
	              } while (p !== outerNode);
	              if (!m) return null;
	              if (hx === qx) return m;
	              var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
	              p = m;
	              do {
	                if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	                  tan = Math.abs(hy - p.y) / (hx - p.x);
	                  if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
	                    m = p;
	                    tanMin = tan;
	                  }
	                }
	                p = p.next;
	              } while (p !== stop);
	              return m;
	            }
	            function sectorContainsSector(m, p) {
	              return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
	            }
	            function indexCurve(start, minX, minY, invSize) {
	              var p = start;
	              do {
	                if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
	                p.prevZ = p.prev;
	                p.nextZ = p.next;
	                p = p.next;
	              } while (p !== start);
	              p.prevZ.nextZ = null;
	              p.prevZ = null;
	              sortLinked(p);
	            }
	            function sortLinked(list) {
	              var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
	              do {
	                p = list;
	                list = null;
	                tail = null;
	                numMerges = 0;
	                while (p) {
	                  numMerges++;
	                  q = p;
	                  pSize = 0;
	                  for (i = 0; i < inSize; i++) {
	                    pSize++;
	                    q = q.nextZ;
	                    if (!q) break;
	                  }
	                  qSize = inSize;
	                  while (pSize > 0 || qSize > 0 && q) {
	                    if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                      e = p;
	                      p = p.nextZ;
	                      pSize--;
	                    } else {
	                      e = q;
	                      q = q.nextZ;
	                      qSize--;
	                    }
	                    if (tail) tail.nextZ = e;
	                    else list = e;
	                    e.prevZ = tail;
	                    tail = e;
	                  }
	                  p = q;
	                }
	                tail.nextZ = null;
	                inSize *= 2;
	              } while (numMerges > 1);
	              return list;
	            }
	            function zOrder(x, y, minX, minY, invSize) {
	              x = 32767 * (x - minX) * invSize;
	              y = 32767 * (y - minY) * invSize;
	              x = (x | x << 8) & 16711935;
	              x = (x | x << 4) & 252645135;
	              x = (x | x << 2) & 858993459;
	              x = (x | x << 1) & 1431655765;
	              y = (y | y << 8) & 16711935;
	              y = (y | y << 4) & 252645135;
	              y = (y | y << 2) & 858993459;
	              y = (y | y << 1) & 1431655765;
	              return x | y << 1;
	            }
	            function getLeftmost(start) {
	              var p = start, leftmost = start;
	              do {
	                if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
	                p = p.next;
	              } while (p !== start);
	              return leftmost;
	            }
	            function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	              return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	            }
	            function isValidDiagonal(a, b) {
	              return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
	              (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
	              (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
	              equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0);
	            }
	            function area(p, q, r) {
	              return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	            }
	            function equals(p1, p2) {
	              return p1.x === p2.x && p1.y === p2.y;
	            }
	            function intersects(p1, q1, p2, q2) {
	              var o1 = sign(area(p1, q1, p2));
	              var o2 = sign(area(p1, q1, q2));
	              var o3 = sign(area(p2, q2, p1));
	              var o4 = sign(area(p2, q2, q1));
	              if (o1 !== o2 && o3 !== o4) return true;
	              if (o1 === 0 && onSegment(p1, p2, q1)) return true;
	              if (o2 === 0 && onSegment(p1, q2, q1)) return true;
	              if (o3 === 0 && onSegment(p2, p1, q2)) return true;
	              if (o4 === 0 && onSegment(p2, q1, q2)) return true;
	              return false;
	            }
	            function onSegment(p, q, r) {
	              return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
	            }
	            function sign(num) {
	              return num > 0 ? 1 : num < 0 ? -1 : 0;
	            }
	            function intersectsPolygon(a, b) {
	              var p = a;
	              do {
	                if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
	                p = p.next;
	              } while (p !== a);
	              return false;
	            }
	            function locallyInside(a, b) {
	              return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	            }
	            function middleInside(a, b) {
	              var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
	              do {
	                if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x)
	                  inside = !inside;
	                p = p.next;
	              } while (p !== a);
	              return inside;
	            }
	            function splitPolygon(a, b) {
	              var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
	              a.next = b;
	              b.prev = a;
	              a2.next = an;
	              an.prev = a2;
	              b2.next = a2;
	              a2.prev = b2;
	              bp.next = b2;
	              b2.prev = bp;
	              return b2;
	            }
	            function insertNode(i, x, y, last) {
	              var p = new Node(i, x, y);
	              if (!last) {
	                p.prev = p;
	                p.next = p;
	              } else {
	                p.next = last.next;
	                p.prev = last;
	                last.next.prev = p;
	                last.next = p;
	              }
	              return p;
	            }
	            function removeNode(p) {
	              p.next.prev = p.prev;
	              p.prev.next = p.next;
	              if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	              if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	            }
	            function Node(i, x, y) {
	              this.i = i;
	              this.x = x;
	              this.y = y;
	              this.prev = null;
	              this.next = null;
	              this.z = null;
	              this.prevZ = null;
	              this.nextZ = null;
	              this.steiner = false;
	            }
	            earcut.deviation = function(data, holeIndices, dim, triangles) {
	              var hasHoles = holeIndices && holeIndices.length;
	              var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	              var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	              if (hasHoles) {
	                for (var i = 0, len = holeIndices.length; i < len; i++) {
	                  var start = holeIndices[i] * dim;
	                  var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	                  polygonArea -= Math.abs(signedArea(data, start, end, dim));
	                }
	              }
	              var trianglesArea = 0;
	              for (i = 0; i < triangles.length; i += 3) {
	                var a = triangles[i] * dim;
	                var b = triangles[i + 1] * dim;
	                var c = triangles[i + 2] * dim;
	                trianglesArea += Math.abs(
	                  (data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1])
	                );
	              }
	              return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
	            };
	            function signedArea(data, start, end, dim) {
	              var sum = 0;
	              for (var i = start, j = end - dim; i < end; i += dim) {
	                sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	                j = i;
	              }
	              return sum;
	            }
	            earcut.flatten = function(data) {
	              var dim = data[0][0].length, result = { vertices: [], holes: [], dimensions: dim }, holeIndex = 0;
	              for (var i = 0; i < data.length; i++) {
	                for (var j = 0; j < data[i].length; j++) {
	                  for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	                }
	                if (i > 0) {
	                  holeIndex += data[i - 1].length;
	                  result.holes.push(holeIndex);
	                }
	              }
	              return result;
	            };
	          }
	        ),
	        /***/
	        2502: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var tarjan = __webpack_require__2(68664);
	            module2.exports = function findCircuits(edges, cb) {
	              var circuits = [];
	              var stack = [];
	              var blocked = [];
	              var B = {};
	              var Ak = [];
	              var s;
	              function unblock(u) {
	                blocked[u] = false;
	                if (B.hasOwnProperty(u)) {
	                  Object.keys(B[u]).forEach(function(w) {
	                    delete B[u][w];
	                    if (blocked[w]) {
	                      unblock(w);
	                    }
	                  });
	                }
	              }
	              function circuit(v) {
	                var found = false;
	                stack.push(v);
	                blocked[v] = true;
	                var i2;
	                var w;
	                for (i2 = 0; i2 < Ak[v].length; i2++) {
	                  w = Ak[v][i2];
	                  if (w === s) {
	                    output(s, stack);
	                    found = true;
	                  } else if (!blocked[w]) {
	                    found = circuit(w);
	                  }
	                }
	                if (found) {
	                  unblock(v);
	                } else {
	                  for (i2 = 0; i2 < Ak[v].length; i2++) {
	                    w = Ak[v][i2];
	                    var entry = B[w];
	                    if (!entry) {
	                      entry = {};
	                      B[w] = entry;
	                    }
	                    entry[w] = true;
	                  }
	                }
	                stack.pop();
	                return found;
	              }
	              function output(start, stack2) {
	                var cycle = [].concat(stack2).concat(start);
	                if (cb) {
	                  cb(circuit);
	                } else {
	                  circuits.push(cycle);
	                }
	              }
	              function subgraph(minId) {
	                for (var i2 = 0; i2 < edges.length; i2++) {
	                  if (i2 < minId) edges[i2] = [];
	                  edges[i2] = edges[i2].filter(function(i3) {
	                    return i3 >= minId;
	                  });
	                }
	              }
	              function adjacencyStructureSCC(from) {
	                subgraph(from);
	                var g = edges;
	                var sccs = tarjan(g);
	                var ccs = sccs.components.filter(function(scc) {
	                  return scc.length > 1;
	                });
	                var leastVertex = Infinity;
	                var leastVertexComponent;
	                for (var i2 = 0; i2 < ccs.length; i2++) {
	                  for (var j2 = 0; j2 < ccs[i2].length; j2++) {
	                    if (ccs[i2][j2] < leastVertex) {
	                      leastVertex = ccs[i2][j2];
	                      leastVertexComponent = i2;
	                    }
	                  }
	                }
	                var cc = ccs[leastVertexComponent];
	                if (!cc) return false;
	                var adjList = edges.map(function(l, index) {
	                  if (cc.indexOf(index) === -1) return [];
	                  return l.filter(function(i3) {
	                    return cc.indexOf(i3) !== -1;
	                  });
	                });
	                return {
	                  leastVertex,
	                  adjList
	                };
	              }
	              s = 0;
	              var n = edges.length;
	              while (s < n) {
	                var p = adjacencyStructureSCC(s);
	                s = p.leastVertex;
	                Ak = p.adjList;
	                if (Ak) {
	                  for (var i = 0; i < Ak.length; i++) {
	                    for (var j = 0; j < Ak[i].length; j++) {
	                      var vertexId = Ak[i][j];
	                      blocked[+vertexId] = false;
	                      B[vertexId] = {};
	                    }
	                  }
	                  circuit(s);
	                  s = s + 1;
	                } else {
	                  s = n;
	                }
	              }
	              if (cb) {
	                return;
	              } else {
	                return circuits;
	              }
	            };
	          }
	        ),
	        /***/
	        16134: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var value = __webpack_require__2(36672);
	            module2.exports = function() {
	              value(this).length = 0;
	              return this;
	            };
	          }
	        ),
	        /***/
	        4892: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(64404)() ? Array.from : __webpack_require__2(49441);
	          }
	        ),
	        /***/
	        64404: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              var from = Array.from, arr, result;
	              if (typeof from !== "function") return false;
	              arr = ["raz", "dwa"];
	              result = from(arr);
	              return Boolean(result && result !== arr && result[1] === "dwa");
	            };
	          }
	        ),
	        /***/
	        49441: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var iteratorSymbol = __webpack_require__2(8260).iterator, isArguments = __webpack_require__2(73051), isFunction = __webpack_require__2(33717), toPosInt = __webpack_require__2(35976), callable = __webpack_require__2(78513), validValue = __webpack_require__2(36672), isValue = __webpack_require__2(95296), isString = __webpack_require__2(87963), isArray = Array.isArray, call = Function.prototype.call, desc = { configurable: true, enumerable: true, writable: true, value: null }, defineProperty = Object.defineProperty;
	            module2.exports = function(arrayLike) {
	              var mapFn = arguments[1], thisArg = arguments[2], Context, i, j, arr, length, code, iterator, result, getIterator, value;
	              arrayLike = Object(validValue(arrayLike));
	              if (isValue(mapFn)) callable(mapFn);
	              if (!this || this === Array || !isFunction(this)) {
	                if (!mapFn) {
	                  if (isArguments(arrayLike)) {
	                    length = arrayLike.length;
	                    if (length !== 1) return Array.apply(null, arrayLike);
	                    arr = new Array(1);
	                    arr[0] = arrayLike[0];
	                    return arr;
	                  }
	                  if (isArray(arrayLike)) {
	                    arr = new Array(length = arrayLike.length);
	                    for (i = 0; i < length; ++i) arr[i] = arrayLike[i];
	                    return arr;
	                  }
	                }
	                arr = [];
	              } else {
	                Context = this;
	              }
	              if (!isArray(arrayLike)) {
	                if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
	                  iterator = callable(getIterator).call(arrayLike);
	                  if (Context) arr = new Context();
	                  result = iterator.next();
	                  i = 0;
	                  while (!result.done) {
	                    value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
	                    if (Context) {
	                      desc.value = value;
	                      defineProperty(arr, i, desc);
	                    } else {
	                      arr[i] = value;
	                    }
	                    result = iterator.next();
	                    ++i;
	                  }
	                  length = i;
	                } else if (isString(arrayLike)) {
	                  length = arrayLike.length;
	                  if (Context) arr = new Context();
	                  for (i = 0, j = 0; i < length; ++i) {
	                    value = arrayLike[i];
	                    if (i + 1 < length) {
	                      code = value.charCodeAt(0);
	                      if (code >= 55296 && code <= 56319) value += arrayLike[++i];
	                    }
	                    value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
	                    if (Context) {
	                      desc.value = value;
	                      defineProperty(arr, j, desc);
	                    } else {
	                      arr[j] = value;
	                    }
	                    ++j;
	                  }
	                  length = j;
	                }
	              }
	              if (length === undefined) {
	                length = toPosInt(arrayLike.length);
	                if (Context) arr = new Context(length);
	                for (i = 0; i < length; ++i) {
	                  value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
	                  if (Context) {
	                    desc.value = value;
	                    defineProperty(arr, i, desc);
	                  } else {
	                    arr[i] = value;
	                  }
	                }
	              }
	              if (Context) {
	                desc.value = null;
	                arr.length = length;
	              }
	              return arr;
	            };
	          }
	        ),
	        /***/
	        73051: (
	          /***/
	          function(module2) {
	            var objToString = Object.prototype.toString, id = objToString.call(/* @__PURE__ */ function() {
	              return arguments;
	            }());
	            module2.exports = function(value) {
	              return objToString.call(value) === id;
	            };
	          }
	        ),
	        /***/
	        33717: (
	          /***/
	          function(module2) {
	            var objToString = Object.prototype.toString, isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
	            module2.exports = function(value) {
	              return typeof value === "function" && isFunctionStringTag(objToString.call(value));
	            };
	          }
	        ),
	        /***/
	        52345: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	            };
	          }
	        ),
	        /***/
	        9953: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(90436)() ? Math.sign : __webpack_require__2(6069);
	          }
	        ),
	        /***/
	        90436: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              var sign = Math.sign;
	              if (typeof sign !== "function") return false;
	              return sign(10) === 1 && sign(-20) === -1;
	            };
	          }
	        ),
	        /***/
	        6069: (
	          /***/
	          function(module2) {
	            module2.exports = function(value) {
	              value = Number(value);
	              if (isNaN(value) || value === 0) return value;
	              return value > 0 ? 1 : -1;
	            };
	          }
	        ),
	        /***/
	        56247: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var sign = __webpack_require__2(9953), abs = Math.abs, floor = Math.floor;
	            module2.exports = function(value) {
	              if (isNaN(value)) return 0;
	              value = Number(value);
	              if (value === 0 || !isFinite(value)) return value;
	              return sign(value) * floor(abs(value));
	            };
	          }
	        ),
	        /***/
	        35976: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var toInteger = __webpack_require__2(56247), max = Math.max;
	            module2.exports = function(value) {
	              return max(0, toInteger(value));
	            };
	          }
	        ),
	        /***/
	        67260: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var callable = __webpack_require__2(78513), value = __webpack_require__2(36672), bind = Function.prototype.bind, call = Function.prototype.call, keys = Object.keys, objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;
	            module2.exports = function(method, defVal) {
	              return function(obj, cb) {
	                var list, thisArg = arguments[2], compareFn = arguments[3];
	                obj = Object(value(obj));
	                callable(cb);
	                list = keys(obj);
	                if (compareFn) {
	                  list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
	                }
	                if (typeof method !== "function") method = list[method];
	                return call.call(method, list, function(key, index) {
	                  if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
	                  return call.call(cb, thisArg, obj[key], key, obj, index);
	                });
	              };
	            };
	          }
	        ),
	        /***/
	        95879: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(73583)() ? Object.assign : __webpack_require__2(34205);
	          }
	        ),
	        /***/
	        73583: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              var assign = Object.assign, obj;
	              if (typeof assign !== "function") return false;
	              obj = { foo: "raz" };
	              assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	              return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
	            };
	          }
	        ),
	        /***/
	        34205: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var keys = __webpack_require__2(68700), value = __webpack_require__2(36672), max = Math.max;
	            module2.exports = function(dest, src) {
	              var error, i, length = max(arguments.length, 2), assign;
	              dest = Object(value(dest));
	              assign = function(key) {
	                try {
	                  dest[key] = src[key];
	                } catch (e) {
	                  if (!error) error = e;
	                }
	              };
	              for (i = 1; i < length; ++i) {
	                src = arguments[i];
	                keys(src).forEach(assign);
	              }
	              if (error !== undefined) throw error;
	              return dest;
	            };
	          }
	        ),
	        /***/
	        19012: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var aFrom = __webpack_require__2(4892), assign = __webpack_require__2(95879), value = __webpack_require__2(36672);
	            module2.exports = function(obj) {
	              var copy = Object(value(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
	              if (copy !== obj && !propertyNames) return copy;
	              var result = {};
	              if (propertyNames) {
	                aFrom(propertyNames, function(propertyName) {
	                  if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
	                });
	              } else {
	                assign(result, obj);
	              }
	              return result;
	            };
	          }
	        ),
	        /***/
	        52818: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var create = Object.create, shim;
	            if (!__webpack_require__2(33247)()) {
	              shim = __webpack_require__2(51882);
	            }
	            module2.exports = function() {
	              var nullObject, polyProps, desc;
	              if (!shim) return create;
	              if (shim.level !== 1) return create;
	              nullObject = {};
	              polyProps = {};
	              desc = { configurable: false, enumerable: false, writable: true, value: undefined };
	              Object.getOwnPropertyNames(Object.prototype).forEach(function(name2) {
	                if (name2 === "__proto__") {
	                  polyProps[name2] = {
	                    configurable: true,
	                    enumerable: false,
	                    writable: true,
	                    value: undefined
	                  };
	                  return;
	                }
	                polyProps[name2] = desc;
	              });
	              Object.defineProperties(nullObject, polyProps);
	              Object.defineProperty(shim, "nullPolyfill", {
	                configurable: false,
	                enumerable: false,
	                writable: false,
	                value: nullObject
	              });
	              return function(prototype, props) {
	                return create(prototype === null ? nullObject : prototype, props);
	              };
	            }();
	          }
	        ),
	        /***/
	        96437: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(67260)("forEach");
	          }
	        ),
	        /***/
	        99611: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(95296);
	            var map2 = { function: true, object: true };
	            module2.exports = function(value) {
	              return isValue(value) && map2[typeof value] || false;
	            };
	          }
	        ),
	        /***/
	        95296: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var _undefined = __webpack_require__2(52345)();
	            module2.exports = function(val) {
	              return val !== _undefined && val !== null;
	            };
	          }
	        ),
	        /***/
	        68700: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(13895)() ? Object.keys : __webpack_require__2(25217);
	          }
	        ),
	        /***/
	        13895: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              try {
	                Object.keys("primitive");
	                return true;
	              } catch (e) {
	                return false;
	              }
	            };
	          }
	        ),
	        /***/
	        25217: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(95296);
	            var keys = Object.keys;
	            module2.exports = function(object) {
	              return keys(isValue(object) ? Object(object) : object);
	            };
	          }
	        ),
	        /***/
	        16906: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var callable = __webpack_require__2(78513), forEach = __webpack_require__2(96437), call = Function.prototype.call;
	            module2.exports = function(obj, cb) {
	              var result = {}, thisArg = arguments[2];
	              callable(cb);
	              forEach(obj, function(value, key, targetObj, index) {
	                result[key] = call.call(cb, thisArg, value, key, targetObj, index);
	              });
	              return result;
	            };
	          }
	        ),
	        /***/
	        21780: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(95296);
	            var forEach = Array.prototype.forEach, create = Object.create;
	            var process = function(src, obj) {
	              var key;
	              for (key in src) obj[key] = src[key];
	            };
	            module2.exports = function(opts1) {
	              var result = create(null);
	              forEach.call(arguments, function(options) {
	                if (!isValue(options)) return;
	                process(Object(options), result);
	              });
	              return result;
	            };
	          }
	        ),
	        /***/
	        1496: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(33247)() ? Object.setPrototypeOf : __webpack_require__2(51882);
	          }
	        ),
	        /***/
	        33247: (
	          /***/
	          function(module2) {
	            var create = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};
	            module2.exports = function() {
	              var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || create;
	              if (typeof setPrototypeOf !== "function") return false;
	              return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
	            };
	          }
	        ),
	        /***/
	        51882: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isObject = __webpack_require__2(99611), value = __webpack_require__2(36672), objIsPrototypeOf = Object.prototype.isPrototypeOf, defineProperty = Object.defineProperty, nullDesc = { configurable: true, enumerable: false, writable: true, value: undefined }, validate;
	            validate = function(obj, prototype) {
	              value(obj);
	              if (prototype === null || isObject(prototype)) return obj;
	              throw new TypeError("Prototype must be null or an object");
	            };
	            module2.exports = function(status) {
	              var fn, set;
	              if (!status) return null;
	              if (status.level === 2) {
	                if (status.set) {
	                  set = status.set;
	                  fn = function(obj, prototype) {
	                    set.call(validate(obj, prototype), prototype);
	                    return obj;
	                  };
	                } else {
	                  fn = function(obj, prototype) {
	                    validate(obj, prototype).__proto__ = prototype;
	                    return obj;
	                  };
	                }
	              } else {
	                fn = function self2(obj, prototype) {
	                  var isNullBase;
	                  validate(obj, prototype);
	                  isNullBase = objIsPrototypeOf.call(self2.nullPolyfill, obj);
	                  if (isNullBase) delete self2.nullPolyfill.__proto__;
	                  if (prototype === null) prototype = self2.nullPolyfill;
	                  obj.__proto__ = prototype;
	                  if (isNullBase) defineProperty(self2.nullPolyfill, "__proto__", nullDesc);
	                  return obj;
	                };
	              }
	              return Object.defineProperty(fn, "level", {
	                configurable: false,
	                enumerable: false,
	                writable: false,
	                value: status.level
	              });
	            }(
	              function() {
	                var tmpObj1 = /* @__PURE__ */ Object.create(null), tmpObj2 = {}, set, desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
	                if (desc) {
	                  try {
	                    set = desc.set;
	                    set.call(tmpObj1, tmpObj2);
	                  } catch (ignore) {
	                  }
	                  if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { set, level: 2 };
	                }
	                tmpObj1.__proto__ = tmpObj2;
	                if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 2 };
	                tmpObj1 = {};
	                tmpObj1.__proto__ = tmpObj2;
	                if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 1 };
	                return false;
	              }()
	            );
	            __webpack_require__2(52818);
	          }
	        ),
	        /***/
	        78513: (
	          /***/
	          function(module2) {
	            module2.exports = function(fn) {
	              if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	              return fn;
	            };
	          }
	        ),
	        /***/
	        98976: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isObject = __webpack_require__2(99611);
	            module2.exports = function(value) {
	              if (!isObject(value)) throw new TypeError(value + " is not an Object");
	              return value;
	            };
	          }
	        ),
	        /***/
	        36672: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(95296);
	            module2.exports = function(value) {
	              if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	              return value;
	            };
	          }
	        ),
	        /***/
	        66741: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(17557)() ? String.prototype.contains : __webpack_require__2(60381);
	          }
	        ),
	        /***/
	        17557: (
	          /***/
	          function(module2) {
	            var str = "razdwatrzy";
	            module2.exports = function() {
	              if (typeof str.contains !== "function") return false;
	              return str.contains("dwa") === true && str.contains("foo") === false;
	            };
	          }
	        ),
	        /***/
	        60381: (
	          /***/
	          function(module2) {
	            var indexOf = String.prototype.indexOf;
	            module2.exports = function(searchString) {
	              return indexOf.call(this, searchString, arguments[1]) > -1;
	            };
	          }
	        ),
	        /***/
	        87963: (
	          /***/
	          function(module2) {
	            var objToString = Object.prototype.toString, id = objToString.call("");
	            module2.exports = function(value) {
	              return typeof value === "string" || value && typeof value === "object" && (value instanceof String || objToString.call(value) === id) || false;
	            };
	          }
	        ),
	        /***/
	        43043: (
	          /***/
	          function(module2) {
	            var generated = /* @__PURE__ */ Object.create(null), random = Math.random;
	            module2.exports = function() {
	              var str;
	              do {
	                str = random().toString(36).slice(2);
	              } while (generated[str]);
	              return str;
	            };
	          }
	        ),
	        /***/
	        32411: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var setPrototypeOf = __webpack_require__2(1496), contains = __webpack_require__2(66741), d = __webpack_require__2(62072), Symbol2 = __webpack_require__2(8260), Iterator = __webpack_require__2(95426);
	            var defineProperty = Object.defineProperty, ArrayIterator;
	            ArrayIterator = module2.exports = function(arr, kind) {
	              if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
	              Iterator.call(this, arr);
	              if (!kind) kind = "value";
	              else if (contains.call(kind, "key+value")) kind = "key+value";
	              else if (contains.call(kind, "key")) kind = "key";
	              else kind = "value";
	              defineProperty(this, "__kind__", d("", kind));
	            };
	            if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);
	            delete ArrayIterator.prototype.constructor;
	            ArrayIterator.prototype = Object.create(Iterator.prototype, {
	              _resolve: d(function(i) {
	                if (this.__kind__ === "value") return this.__list__[i];
	                if (this.__kind__ === "key+value") return [i, this.__list__[i]];
	                return i;
	              })
	            });
	            defineProperty(ArrayIterator.prototype, Symbol2.toStringTag, d("c", "Array Iterator"));
	          }
	        ),
	        /***/
	        27515: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArguments = __webpack_require__2(73051), callable = __webpack_require__2(78513), isString = __webpack_require__2(87963), get = __webpack_require__2(66661);
	            var isArray = Array.isArray, call = Function.prototype.call, some = Array.prototype.some;
	            module2.exports = function(iterable, cb) {
	              var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
	              if (isArray(iterable) || isArguments(iterable)) mode = "array";
	              else if (isString(iterable)) mode = "string";
	              else iterable = get(iterable);
	              callable(cb);
	              doBreak = function() {
	                broken = true;
	              };
	              if (mode === "array") {
	                some.call(iterable, function(value) {
	                  call.call(cb, thisArg, value, doBreak);
	                  return broken;
	                });
	                return;
	              }
	              if (mode === "string") {
	                length = iterable.length;
	                for (i = 0; i < length; ++i) {
	                  char = iterable[i];
	                  if (i + 1 < length) {
	                    code = char.charCodeAt(0);
	                    if (code >= 55296 && code <= 56319) char += iterable[++i];
	                  }
	                  call.call(cb, thisArg, char, doBreak);
	                  if (broken) break;
	                }
	                return;
	              }
	              result = iterable.next();
	              while (!result.done) {
	                call.call(cb, thisArg, result.value, doBreak);
	                if (broken) return;
	                result = iterable.next();
	              }
	            };
	          }
	        ),
	        /***/
	        66661: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArguments = __webpack_require__2(73051), isString = __webpack_require__2(87963), ArrayIterator = __webpack_require__2(32411), StringIterator = __webpack_require__2(259), iterable = __webpack_require__2(58095), iteratorSymbol = __webpack_require__2(8260).iterator;
	            module2.exports = function(obj) {
	              if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
	              if (isArguments(obj)) return new ArrayIterator(obj);
	              if (isString(obj)) return new StringIterator(obj);
	              return new ArrayIterator(obj);
	            };
	          }
	        ),
	        /***/
	        95426: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var clear = __webpack_require__2(16134), assign = __webpack_require__2(95879), callable = __webpack_require__2(78513), value = __webpack_require__2(36672), d = __webpack_require__2(62072), autoBind = __webpack_require__2(55174), Symbol2 = __webpack_require__2(8260);
	            var defineProperty = Object.defineProperty, defineProperties = Object.defineProperties, Iterator;
	            module2.exports = Iterator = function(list, context) {
	              if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
	              defineProperties(this, {
	                __list__: d("w", value(list)),
	                __context__: d("w", context),
	                __nextIndex__: d("w", 0)
	              });
	              if (!context) return;
	              callable(context.on);
	              context.on("_add", this._onAdd);
	              context.on("_delete", this._onDelete);
	              context.on("_clear", this._onClear);
	            };
	            delete Iterator.prototype.constructor;
	            defineProperties(
	              Iterator.prototype,
	              assign(
	                {
	                  _next: d(function() {
	                    var i;
	                    if (!this.__list__) return undefined;
	                    if (this.__redo__) {
	                      i = this.__redo__.shift();
	                      if (i !== undefined) return i;
	                    }
	                    if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
	                    this._unBind();
	                    return undefined;
	                  }),
	                  next: d(function() {
	                    return this._createResult(this._next());
	                  }),
	                  _createResult: d(function(i) {
	                    if (i === undefined) return { done: true, value: undefined };
	                    return { done: false, value: this._resolve(i) };
	                  }),
	                  _resolve: d(function(i) {
	                    return this.__list__[i];
	                  }),
	                  _unBind: d(function() {
	                    this.__list__ = null;
	                    delete this.__redo__;
	                    if (!this.__context__) return;
	                    this.__context__.off("_add", this._onAdd);
	                    this.__context__.off("_delete", this._onDelete);
	                    this.__context__.off("_clear", this._onClear);
	                    this.__context__ = null;
	                  }),
	                  toString: d(function() {
	                    return "[object " + (this[Symbol2.toStringTag] || "Object") + "]";
	                  })
	                },
	                autoBind({
	                  _onAdd: d(function(index) {
	                    if (index >= this.__nextIndex__) return;
	                    ++this.__nextIndex__;
	                    if (!this.__redo__) {
	                      defineProperty(this, "__redo__", d("c", [index]));
	                      return;
	                    }
	                    this.__redo__.forEach(function(redo, i) {
	                      if (redo >= index) this.__redo__[i] = ++redo;
	                    }, this);
	                    this.__redo__.push(index);
	                  }),
	                  _onDelete: d(function(index) {
	                    var i;
	                    if (index >= this.__nextIndex__) return;
	                    --this.__nextIndex__;
	                    if (!this.__redo__) return;
	                    i = this.__redo__.indexOf(index);
	                    if (i !== -1) this.__redo__.splice(i, 1);
	                    this.__redo__.forEach(function(redo, j) {
	                      if (redo > index) this.__redo__[j] = --redo;
	                    }, this);
	                  }),
	                  _onClear: d(function() {
	                    if (this.__redo__) clear.call(this.__redo__);
	                    this.__nextIndex__ = 0;
	                  })
	                })
	              )
	            );
	            defineProperty(
	              Iterator.prototype,
	              Symbol2.iterator,
	              d(function() {
	                return this;
	              })
	            );
	          }
	        ),
	        /***/
	        35940: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isArguments = __webpack_require__2(73051), isValue = __webpack_require__2(95296), isString = __webpack_require__2(87963);
	            var iteratorSymbol = __webpack_require__2(8260).iterator, isArray = Array.isArray;
	            module2.exports = function(value) {
	              if (!isValue(value)) return false;
	              if (isArray(value)) return true;
	              if (isString(value)) return true;
	              if (isArguments(value)) return true;
	              return typeof value[iteratorSymbol] === "function";
	            };
	          }
	        ),
	        /***/
	        259: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var setPrototypeOf = __webpack_require__2(1496), d = __webpack_require__2(62072), Symbol2 = __webpack_require__2(8260), Iterator = __webpack_require__2(95426);
	            var defineProperty = Object.defineProperty, StringIterator;
	            StringIterator = module2.exports = function(str) {
	              if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
	              str = String(str);
	              Iterator.call(this, str);
	              defineProperty(this, "__length__", d("", str.length));
	            };
	            if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);
	            delete StringIterator.prototype.constructor;
	            StringIterator.prototype = Object.create(Iterator.prototype, {
	              _next: d(function() {
	                if (!this.__list__) return undefined;
	                if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
	                this._unBind();
	                return undefined;
	              }),
	              _resolve: d(function(i) {
	                var char = this.__list__[i], code;
	                if (this.__nextIndex__ === this.__length__) return char;
	                code = char.charCodeAt(0);
	                if (code >= 55296 && code <= 56319) return char + this.__list__[this.__nextIndex__++];
	                return char;
	              })
	            });
	            defineProperty(StringIterator.prototype, Symbol2.toStringTag, d("c", "String Iterator"));
	          }
	        ),
	        /***/
	        58095: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isIterable = __webpack_require__2(35940);
	            module2.exports = function(value) {
	              if (!isIterable(value)) throw new TypeError(value + " is not iterable");
	              return value;
	            };
	          }
	        ),
	        /***/
	        73523: (
	          /***/
	          function(module2) {
	            function assign(target, firstSource) {
	              if (target === undefined || target === null) {
	                throw new TypeError("Cannot convert first argument to object");
	              }
	              var to = Object(target);
	              for (var i = 1; i < arguments.length; i++) {
	                var nextSource = arguments[i];
	                if (nextSource === undefined || nextSource === null) {
	                  continue;
	                }
	                var keysArray = Object.keys(Object(nextSource));
	                for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                  var nextKey = keysArray[nextIndex];
	                  var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                  if (desc !== undefined && desc.enumerable) {
	                    to[nextKey] = nextSource[nextKey];
	                  }
	                }
	              }
	              return to;
	            }
	            function polyfill() {
	              if (!Object.assign) {
	                Object.defineProperty(Object, "assign", {
	                  enumerable: false,
	                  configurable: true,
	                  writable: true,
	                  value: assign
	                });
	              }
	            }
	            module2.exports = {
	              assign,
	              polyfill
	            };
	          }
	        ),
	        /***/
	        8260: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(69711)() ? __webpack_require__2(94908).Symbol : __webpack_require__2(18415);
	          }
	        ),
	        /***/
	        69711: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var global = __webpack_require__2(94908), validTypes = { object: true, symbol: true };
	            module2.exports = function() {
	              var Symbol2 = global.Symbol;
	              var symbol;
	              if (typeof Symbol2 !== "function") return false;
	              symbol = Symbol2("test symbol");
	              try {
	                String(symbol);
	              } catch (e) {
	                return false;
	              }
	              if (!validTypes[typeof Symbol2.iterator]) return false;
	              if (!validTypes[typeof Symbol2.toPrimitive]) return false;
	              if (!validTypes[typeof Symbol2.toStringTag]) return false;
	              return true;
	            };
	          }
	        ),
	        /***/
	        82276: (
	          /***/
	          function(module2) {
	            module2.exports = function(value) {
	              if (!value) return false;
	              if (typeof value === "symbol") return true;
	              if (!value.constructor) return false;
	              if (value.constructor.name !== "Symbol") return false;
	              return value[value.constructor.toStringTag] === "Symbol";
	            };
	          }
	        ),
	        /***/
	        29366: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d = __webpack_require__2(62072);
	            var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;
	            var created = create(null);
	            module2.exports = function(desc) {
	              var postfix = 0, name2, ie11BugWorkaround;
	              while (created[desc + (postfix || "")]) ++postfix;
	              desc += postfix || "";
	              created[desc] = true;
	              name2 = "@@" + desc;
	              defineProperty(
	                objPrototype,
	                name2,
	                d.gs(null, function(value) {
	                  if (ie11BugWorkaround) return;
	                  ie11BugWorkaround = true;
	                  defineProperty(this, name2, d(value));
	                  ie11BugWorkaround = false;
	                })
	              );
	              return name2;
	            };
	          }
	        ),
	        /***/
	        92842: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d = __webpack_require__2(62072), NativeSymbol = __webpack_require__2(94908).Symbol;
	            module2.exports = function(SymbolPolyfill) {
	              return Object.defineProperties(SymbolPolyfill, {
	                // To ensure proper interoperability with other native functions (e.g. Array.from)
	                // fallback to eventual native implementation of given symbol
	                hasInstance: d(
	                  "",
	                  NativeSymbol && NativeSymbol.hasInstance || SymbolPolyfill("hasInstance")
	                ),
	                isConcatSpreadable: d(
	                  "",
	                  NativeSymbol && NativeSymbol.isConcatSpreadable || SymbolPolyfill("isConcatSpreadable")
	                ),
	                iterator: d("", NativeSymbol && NativeSymbol.iterator || SymbolPolyfill("iterator")),
	                match: d("", NativeSymbol && NativeSymbol.match || SymbolPolyfill("match")),
	                replace: d("", NativeSymbol && NativeSymbol.replace || SymbolPolyfill("replace")),
	                search: d("", NativeSymbol && NativeSymbol.search || SymbolPolyfill("search")),
	                species: d("", NativeSymbol && NativeSymbol.species || SymbolPolyfill("species")),
	                split: d("", NativeSymbol && NativeSymbol.split || SymbolPolyfill("split")),
	                toPrimitive: d(
	                  "",
	                  NativeSymbol && NativeSymbol.toPrimitive || SymbolPolyfill("toPrimitive")
	                ),
	                toStringTag: d(
	                  "",
	                  NativeSymbol && NativeSymbol.toStringTag || SymbolPolyfill("toStringTag")
	                ),
	                unscopables: d(
	                  "",
	                  NativeSymbol && NativeSymbol.unscopables || SymbolPolyfill("unscopables")
	                )
	              });
	            };
	          }
	        ),
	        /***/
	        13304: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d = __webpack_require__2(62072), validateSymbol = __webpack_require__2(53308);
	            var registry = /* @__PURE__ */ Object.create(null);
	            module2.exports = function(SymbolPolyfill) {
	              return Object.defineProperties(SymbolPolyfill, {
	                for: d(function(key) {
	                  if (registry[key]) return registry[key];
	                  return registry[key] = SymbolPolyfill(String(key));
	                }),
	                keyFor: d(function(symbol) {
	                  var key;
	                  validateSymbol(symbol);
	                  for (key in registry) {
	                    if (registry[key] === symbol) return key;
	                  }
	                  return undefined;
	                })
	              });
	            };
	          }
	        ),
	        /***/
	        18415: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var d = __webpack_require__2(62072), validateSymbol = __webpack_require__2(53308), NativeSymbol = __webpack_require__2(94908).Symbol, generateName = __webpack_require__2(29366), setupStandardSymbols = __webpack_require__2(92842), setupSymbolRegistry = __webpack_require__2(13304);
	            var create = Object.create, defineProperties = Object.defineProperties, defineProperty = Object.defineProperty;
	            var SymbolPolyfill, HiddenSymbol, isNativeSafe;
	            if (typeof NativeSymbol === "function") {
	              try {
	                String(NativeSymbol());
	                isNativeSafe = true;
	              } catch (ignore) {
	              }
	            } else {
	              NativeSymbol = null;
	            }
	            HiddenSymbol = function Symbol2(description) {
	              if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	              return SymbolPolyfill(description);
	            };
	            module2.exports = SymbolPolyfill = function Symbol2(description) {
	              var symbol;
	              if (this instanceof Symbol2) throw new TypeError("Symbol is not a constructor");
	              if (isNativeSafe) return NativeSymbol(description);
	              symbol = create(HiddenSymbol.prototype);
	              description = description === undefined ? "" : String(description);
	              return defineProperties(symbol, {
	                __description__: d("", description),
	                __name__: d("", generateName(description))
	              });
	            };
	            setupStandardSymbols(SymbolPolyfill);
	            setupSymbolRegistry(SymbolPolyfill);
	            defineProperties(HiddenSymbol.prototype, {
	              constructor: d(SymbolPolyfill),
	              toString: d("", function() {
	                return this.__name__;
	              })
	            });
	            defineProperties(SymbolPolyfill.prototype, {
	              toString: d(function() {
	                return "Symbol (" + validateSymbol(this).__description__ + ")";
	              }),
	              valueOf: d(function() {
	                return validateSymbol(this);
	              })
	            });
	            defineProperty(
	              SymbolPolyfill.prototype,
	              SymbolPolyfill.toPrimitive,
	              d("", function() {
	                var symbol = validateSymbol(this);
	                if (typeof symbol === "symbol") return symbol;
	                return symbol.toString();
	              })
	            );
	            defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));
	            defineProperty(
	              HiddenSymbol.prototype,
	              SymbolPolyfill.toStringTag,
	              d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
	            );
	            defineProperty(
	              HiddenSymbol.prototype,
	              SymbolPolyfill.toPrimitive,
	              d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
	            );
	          }
	        ),
	        /***/
	        53308: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isSymbol = __webpack_require__2(82276);
	            module2.exports = function(value) {
	              if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	              return value;
	            };
	          }
	        ),
	        /***/
	        83522: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(96402)() ? WeakMap : __webpack_require__2(329);
	          }
	        ),
	        /***/
	        96402: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              var weakMap, obj;
	              if (typeof WeakMap !== "function") return false;
	              try {
	                weakMap = new WeakMap([[obj = {}, "one"], [{}, "two"], [{}, "three"]]);
	              } catch (e) {
	                return false;
	              }
	              if (String(weakMap) !== "[object WeakMap]") return false;
	              if (typeof weakMap.set !== "function") return false;
	              if (weakMap.set({}, 1) !== weakMap) return false;
	              if (typeof weakMap.delete !== "function") return false;
	              if (typeof weakMap.has !== "function") return false;
	              if (weakMap.get(obj) !== "one") return false;
	              return true;
	            };
	          }
	        ),
	        /***/
	        96416: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              if (typeof WeakMap !== "function") return false;
	              return Object.prototype.toString.call(/* @__PURE__ */ new WeakMap()) === "[object WeakMap]";
	            }();
	          }
	        ),
	        /***/
	        329: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(95296), setPrototypeOf = __webpack_require__2(1496), object = __webpack_require__2(98976), ensureValue = __webpack_require__2(36672), randomUniq = __webpack_require__2(43043), d = __webpack_require__2(62072), getIterator = __webpack_require__2(66661), forOf = __webpack_require__2(27515), toStringTagSymbol = __webpack_require__2(8260).toStringTag, isNative = __webpack_require__2(96416), isArray = Array.isArray, defineProperty = Object.defineProperty, objHasOwnProperty = Object.prototype.hasOwnProperty, getPrototypeOf = Object.getPrototypeOf, WeakMapPoly;
	            module2.exports = WeakMapPoly = function() {
	              var iterable = arguments[0], self2;
	              if (!(this instanceof WeakMapPoly)) throw new TypeError("Constructor requires 'new'");
	              self2 = isNative && setPrototypeOf && WeakMap !== WeakMapPoly ? setPrototypeOf(/* @__PURE__ */ new WeakMap(), getPrototypeOf(this)) : this;
	              if (isValue(iterable)) {
	                if (!isArray(iterable)) iterable = getIterator(iterable);
	              }
	              defineProperty(self2, "__weakMapData__", d("c", "$weakMap$" + randomUniq()));
	              if (!iterable) return self2;
	              forOf(iterable, function(val) {
	                ensureValue(val);
	                self2.set(val[0], val[1]);
	              });
	              return self2;
	            };
	            if (isNative) {
	              if (setPrototypeOf) setPrototypeOf(WeakMapPoly, WeakMap);
	              WeakMapPoly.prototype = Object.create(WeakMap.prototype, { constructor: d(WeakMapPoly) });
	            }
	            Object.defineProperties(WeakMapPoly.prototype, {
	              delete: d(function(key) {
	                if (objHasOwnProperty.call(object(key), this.__weakMapData__)) {
	                  delete key[this.__weakMapData__];
	                  return true;
	                }
	                return false;
	              }),
	              get: d(function(key) {
	                if (!objHasOwnProperty.call(object(key), this.__weakMapData__)) return undefined;
	                return key[this.__weakMapData__];
	              }),
	              has: d(function(key) {
	                return objHasOwnProperty.call(object(key), this.__weakMapData__);
	              }),
	              set: d(function(key, value) {
	                defineProperty(object(key), this.__weakMapData__, d("c", value));
	                return this;
	              }),
	              toString: d(function() {
	                return "[object WeakMap]";
	              })
	            });
	            defineProperty(WeakMapPoly.prototype, toStringTagSymbol, d("c", "WeakMap"));
	          }
	        ),
	        /***/
	        15398: (
	          /***/
	          function(module2) {
	            var R = typeof Reflect === "object" ? Reflect : null;
	            var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
	              return Function.prototype.apply.call(target, receiver, args);
	            };
	            var ReflectOwnKeys;
	            if (R && typeof R.ownKeys === "function") {
	              ReflectOwnKeys = R.ownKeys;
	            } else if (Object.getOwnPropertySymbols) {
	              ReflectOwnKeys = function ReflectOwnKeys2(target) {
	                return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
	              };
	            } else {
	              ReflectOwnKeys = function ReflectOwnKeys2(target) {
	                return Object.getOwnPropertyNames(target);
	              };
	            }
	            function ProcessEmitWarning(warning) {
	              if (console && console.warn) console.warn(warning);
	            }
	            var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
	              return value !== value;
	            };
	            function EventEmitter() {
	              EventEmitter.init.call(this);
	            }
	            module2.exports = EventEmitter;
	            module2.exports.once = once;
	            EventEmitter.EventEmitter = EventEmitter;
	            EventEmitter.prototype._events = undefined;
	            EventEmitter.prototype._eventsCount = 0;
	            EventEmitter.prototype._maxListeners = undefined;
	            var defaultMaxListeners = 10;
	            function checkListener(listener) {
	              if (typeof listener !== "function") {
	                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	              }
	            }
	            Object.defineProperty(EventEmitter, "defaultMaxListeners", {
	              enumerable: true,
	              get: function() {
	                return defaultMaxListeners;
	              },
	              set: function(arg) {
	                if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
	                  throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
	                }
	                defaultMaxListeners = arg;
	              }
	            });
	            EventEmitter.init = function() {
	              if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
	                this._events = /* @__PURE__ */ Object.create(null);
	                this._eventsCount = 0;
	              }
	              this._maxListeners = this._maxListeners || undefined;
	            };
	            EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	              if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) {
	                throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
	              }
	              this._maxListeners = n;
	              return this;
	            };
	            function _getMaxListeners(that) {
	              if (that._maxListeners === undefined)
	                return EventEmitter.defaultMaxListeners;
	              return that._maxListeners;
	            }
	            EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	              return _getMaxListeners(this);
	            };
	            EventEmitter.prototype.emit = function emit(type) {
	              var args = [];
	              for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	              var doError = type === "error";
	              var events = this._events;
	              if (events !== undefined)
	                doError = doError && events.error === undefined;
	              else if (!doError)
	                return false;
	              if (doError) {
	                var er;
	                if (args.length > 0)
	                  er = args[0];
	                if (er instanceof Error) {
	                  throw er;
	                }
	                var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
	                err.context = er;
	                throw err;
	              }
	              var handler = events[type];
	              if (handler === undefined)
	                return false;
	              if (typeof handler === "function") {
	                ReflectApply(handler, this, args);
	              } else {
	                var len = handler.length;
	                var listeners = arrayClone(handler, len);
	                for (var i = 0; i < len; ++i)
	                  ReflectApply(listeners[i], this, args);
	              }
	              return true;
	            };
	            function _addListener(target, type, listener, prepend) {
	              var m;
	              var events;
	              var existing;
	              checkListener(listener);
	              events = target._events;
	              if (events === undefined) {
	                events = target._events = /* @__PURE__ */ Object.create(null);
	                target._eventsCount = 0;
	              } else {
	                if (events.newListener !== undefined) {
	                  target.emit(
	                    "newListener",
	                    type,
	                    listener.listener ? listener.listener : listener
	                  );
	                  events = target._events;
	                }
	                existing = events[type];
	              }
	              if (existing === undefined) {
	                existing = events[type] = listener;
	                ++target._eventsCount;
	              } else {
	                if (typeof existing === "function") {
	                  existing = events[type] = prepend ? [listener, existing] : [existing, listener];
	                } else if (prepend) {
	                  existing.unshift(listener);
	                } else {
	                  existing.push(listener);
	                }
	                m = _getMaxListeners(target);
	                if (m > 0 && existing.length > m && !existing.warned) {
	                  existing.warned = true;
	                  var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
	                  w.name = "MaxListenersExceededWarning";
	                  w.emitter = target;
	                  w.type = type;
	                  w.count = existing.length;
	                  ProcessEmitWarning(w);
	                }
	              }
	              return target;
	            }
	            EventEmitter.prototype.addListener = function addListener(type, listener) {
	              return _addListener(this, type, listener, false);
	            };
	            EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	            EventEmitter.prototype.prependListener = function prependListener(type, listener) {
	              return _addListener(this, type, listener, true);
	            };
	            function onceWrapper() {
	              if (!this.fired) {
	                this.target.removeListener(this.type, this.wrapFn);
	                this.fired = true;
	                if (arguments.length === 0)
	                  return this.listener.call(this.target);
	                return this.listener.apply(this.target, arguments);
	              }
	            }
	            function _onceWrap(target, type, listener) {
	              var state = { fired: false, wrapFn: undefined, target, type, listener };
	              var wrapped = onceWrapper.bind(state);
	              wrapped.listener = listener;
	              state.wrapFn = wrapped;
	              return wrapped;
	            }
	            EventEmitter.prototype.once = function once2(type, listener) {
	              checkListener(listener);
	              this.on(type, _onceWrap(this, type, listener));
	              return this;
	            };
	            EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
	              checkListener(listener);
	              this.prependListener(type, _onceWrap(this, type, listener));
	              return this;
	            };
	            EventEmitter.prototype.removeListener = function removeListener(type, listener) {
	              var list, events, position, i, originalListener;
	              checkListener(listener);
	              events = this._events;
	              if (events === undefined)
	                return this;
	              list = events[type];
	              if (list === undefined)
	                return this;
	              if (list === listener || list.listener === listener) {
	                if (--this._eventsCount === 0)
	                  this._events = /* @__PURE__ */ Object.create(null);
	                else {
	                  delete events[type];
	                  if (events.removeListener)
	                    this.emit("removeListener", type, list.listener || listener);
	                }
	              } else if (typeof list !== "function") {
	                position = -1;
	                for (i = list.length - 1; i >= 0; i--) {
	                  if (list[i] === listener || list[i].listener === listener) {
	                    originalListener = list[i].listener;
	                    position = i;
	                    break;
	                  }
	                }
	                if (position < 0)
	                  return this;
	                if (position === 0)
	                  list.shift();
	                else {
	                  spliceOne(list, position);
	                }
	                if (list.length === 1)
	                  events[type] = list[0];
	                if (events.removeListener !== undefined)
	                  this.emit("removeListener", type, originalListener || listener);
	              }
	              return this;
	            };
	            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	            EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
	              var listeners, events, i;
	              events = this._events;
	              if (events === undefined)
	                return this;
	              if (events.removeListener === undefined) {
	                if (arguments.length === 0) {
	                  this._events = /* @__PURE__ */ Object.create(null);
	                  this._eventsCount = 0;
	                } else if (events[type] !== undefined) {
	                  if (--this._eventsCount === 0)
	                    this._events = /* @__PURE__ */ Object.create(null);
	                  else
	                    delete events[type];
	                }
	                return this;
	              }
	              if (arguments.length === 0) {
	                var keys = Object.keys(events);
	                var key;
	                for (i = 0; i < keys.length; ++i) {
	                  key = keys[i];
	                  if (key === "removeListener") continue;
	                  this.removeAllListeners(key);
	                }
	                this.removeAllListeners("removeListener");
	                this._events = /* @__PURE__ */ Object.create(null);
	                this._eventsCount = 0;
	                return this;
	              }
	              listeners = events[type];
	              if (typeof listeners === "function") {
	                this.removeListener(type, listeners);
	              } else if (listeners !== undefined) {
	                for (i = listeners.length - 1; i >= 0; i--) {
	                  this.removeListener(type, listeners[i]);
	                }
	              }
	              return this;
	            };
	            function _listeners(target, type, unwrap) {
	              var events = target._events;
	              if (events === undefined)
	                return [];
	              var evlistener = events[type];
	              if (evlistener === undefined)
	                return [];
	              if (typeof evlistener === "function")
	                return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	              return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	            }
	            EventEmitter.prototype.listeners = function listeners(type) {
	              return _listeners(this, type, true);
	            };
	            EventEmitter.prototype.rawListeners = function rawListeners(type) {
	              return _listeners(this, type, false);
	            };
	            EventEmitter.listenerCount = function(emitter, type) {
	              if (typeof emitter.listenerCount === "function") {
	                return emitter.listenerCount(type);
	              } else {
	                return listenerCount.call(emitter, type);
	              }
	            };
	            EventEmitter.prototype.listenerCount = listenerCount;
	            function listenerCount(type) {
	              var events = this._events;
	              if (events !== undefined) {
	                var evlistener = events[type];
	                if (typeof evlistener === "function") {
	                  return 1;
	                } else if (evlistener !== undefined) {
	                  return evlistener.length;
	                }
	              }
	              return 0;
	            }
	            EventEmitter.prototype.eventNames = function eventNames() {
	              return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	            };
	            function arrayClone(arr, n) {
	              var copy = new Array(n);
	              for (var i = 0; i < n; ++i)
	                copy[i] = arr[i];
	              return copy;
	            }
	            function spliceOne(list, index) {
	              for (; index + 1 < list.length; index++)
	                list[index] = list[index + 1];
	              list.pop();
	            }
	            function unwrapListeners(arr) {
	              var ret = new Array(arr.length);
	              for (var i = 0; i < ret.length; ++i) {
	                ret[i] = arr[i].listener || arr[i];
	              }
	              return ret;
	            }
	            function once(emitter, name2) {
	              return new Promise(function(resolve, reject) {
	                function errorListener(err) {
	                  emitter.removeListener(name2, resolver);
	                  reject(err);
	                }
	                function resolver() {
	                  if (typeof emitter.removeListener === "function") {
	                    emitter.removeListener("error", errorListener);
	                  }
	                  resolve([].slice.call(arguments));
	                }
	                eventTargetAgnosticAddListener(emitter, name2, resolver, { once: true });
	                if (name2 !== "error") {
	                  addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
	                }
	              });
	            }
	            function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
	              if (typeof emitter.on === "function") {
	                eventTargetAgnosticAddListener(emitter, "error", handler, flags);
	              }
	            }
	            function eventTargetAgnosticAddListener(emitter, name2, listener, flags) {
	              if (typeof emitter.on === "function") {
	                if (flags.once) {
	                  emitter.once(name2, listener);
	                } else {
	                  emitter.on(name2, listener);
	                }
	              } else if (typeof emitter.addEventListener === "function") {
	                emitter.addEventListener(name2, function wrapListener(arg) {
	                  if (flags.once) {
	                    emitter.removeEventListener(name2, wrapListener);
	                  }
	                  listener(arg);
	                });
	              } else {
	                throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
	              }
	            }
	          }
	        ),
	        /***/
	        60774: (
	          /***/
	          function(module2) {
	            var naiveFallback = function() {
	              if (typeof self === "object" && self) return self;
	              if (typeof window === "object" && window) return window;
	              throw new Error("Unable to resolve global `this`");
	            };
	            module2.exports = function() {
	              if (this) return this;
	              try {
	                Object.defineProperty(Object.prototype, "__global__", {
	                  get: function() {
	                    return this;
	                  },
	                  configurable: true
	                });
	              } catch (error) {
	                return naiveFallback();
	              }
	              try {
	                if (!__global__) return naiveFallback();
	                return __global__;
	              } finally {
	                delete Object.prototype.__global__;
	              }
	            }();
	          }
	        ),
	        /***/
	        94908: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(51152)() ? globalThis : __webpack_require__2(60774);
	          }
	        ),
	        /***/
	        51152: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              if (typeof globalThis !== "object") return false;
	              if (!globalThis) return false;
	              return globalThis.Array === Array;
	            };
	          }
	        ),
	        /***/
	        92770: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var allBlankCharCodes = __webpack_require__2(18546);
	            module2.exports = function(n) {
	              var type = typeof n;
	              if (type === "string") {
	                var original = n;
	                n = +n;
	                if (n === 0 && allBlankCharCodes(original)) return false;
	              } else if (type !== "number") return false;
	              return n - n < 1;
	            };
	          }
	        ),
	        /***/
	        30120: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var dtype = __webpack_require__2(90660);
	            module2.exports = flattenVertexData;
	            function flattenVertexData(data, output, offset) {
	              if (!data) throw new TypeError("must specify data as first parameter");
	              offset = +(offset || 0) | 0;
	              if (Array.isArray(data) && (data[0] && typeof data[0][0] === "number")) {
	                var dim = data[0].length;
	                var length = data.length * dim;
	                var i, j, k, l;
	                if (!output || typeof output === "string") {
	                  output = new (dtype(output || "float32"))(length + offset);
	                }
	                var dstLength = output.length - offset;
	                if (length !== dstLength) {
	                  throw new Error("source length " + length + " (" + dim + "x" + data.length + ") does not match destination length " + dstLength);
	                }
	                for (i = 0, k = offset; i < data.length; i++) {
	                  for (j = 0; j < dim; j++) {
	                    output[k++] = data[i][j] === null ? NaN : data[i][j];
	                  }
	                }
	              } else {
	                if (!output || typeof output === "string") {
	                  var Ctor = dtype(output || "float32");
	                  if (Array.isArray(data) || output === "array") {
	                    output = new Ctor(data.length + offset);
	                    for (i = 0, k = offset, l = output.length; k < l; k++, i++) {
	                      output[k] = data[i] === null ? NaN : data[i];
	                    }
	                  } else {
	                    if (offset === 0) {
	                      output = new Ctor(data);
	                    } else {
	                      output = new Ctor(data.length + offset);
	                      output.set(data, offset);
	                    }
	                  }
	                } else {
	                  output.set(data, offset);
	                }
	              }
	              return output;
	            }
	          }
	        ),
	        /***/
	        68016: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var stringifyFont = __webpack_require__2(53313);
	            var defaultChars = [32, 126];
	            module2.exports = atlas;
	            function atlas(options) {
	              options = options || {};
	              var shape = options.shape ? options.shape : options.canvas ? [options.canvas.width, options.canvas.height] : [512, 512];
	              var canvas = options.canvas || document.createElement("canvas");
	              var font = options.font;
	              var step = typeof options.step === "number" ? [options.step, options.step] : options.step || [32, 32];
	              var chars = options.chars || defaultChars;
	              if (font && typeof font !== "string") font = stringifyFont(font);
	              if (!Array.isArray(chars)) {
	                chars = String(chars).split("");
	              } else if (chars.length === 2 && typeof chars[0] === "number" && typeof chars[1] === "number") {
	                var newchars = [];
	                for (var i = chars[0], j = 0; i <= chars[1]; i++) {
	                  newchars[j++] = String.fromCharCode(i);
	                }
	                chars = newchars;
	              }
	              shape = shape.slice();
	              canvas.width = shape[0];
	              canvas.height = shape[1];
	              var ctx = canvas.getContext("2d");
	              ctx.fillStyle = "#000";
	              ctx.fillRect(0, 0, canvas.width, canvas.height);
	              ctx.font = font;
	              ctx.textAlign = "center";
	              ctx.textBaseline = "middle";
	              ctx.fillStyle = "#fff";
	              var x = step[0] / 2;
	              var y = step[1] / 2;
	              for (var i = 0; i < chars.length; i++) {
	                ctx.fillText(chars[i], x, y);
	                if ((x += step[0]) > shape[0] - step[0] / 2) x = step[0] / 2, y += step[1];
	              }
	              return canvas;
	            }
	          }
	        ),
	        /***/
	        32879: (
	          /***/
	          function(module2) {
	            module2.exports = measure;
	            measure.canvas = document.createElement("canvas");
	            measure.cache = {};
	            function measure(font, o) {
	              if (!o) o = {};
	              if (typeof font === "string" || Array.isArray(font)) {
	                o.family = font;
	              }
	              var family = Array.isArray(o.family) ? o.family.join(", ") : o.family;
	              if (!family) throw Error("`family` must be defined");
	              var fs = o.size || o.fontSize || o.em || 48;
	              var weight = o.weight || o.fontWeight || "";
	              var style = o.style || o.fontStyle || "";
	              var font = [style, weight, fs].join(" ") + "px " + family;
	              var origin = o.origin || "top";
	              if (measure.cache[family]) {
	                if (fs <= measure.cache[family].em) {
	                  return applyOrigin(measure.cache[family], origin);
	                }
	              }
	              var canvas = o.canvas || measure.canvas;
	              var ctx = canvas.getContext("2d");
	              var chars = {
	                upper: o.upper !== undefined ? o.upper : "H",
	                lower: o.lower !== undefined ? o.lower : "x",
	                descent: o.descent !== undefined ? o.descent : "p",
	                ascent: o.ascent !== undefined ? o.ascent : "h",
	                tittle: o.tittle !== undefined ? o.tittle : "i",
	                overshoot: o.overshoot !== undefined ? o.overshoot : "O"
	              };
	              var l = Math.ceil(fs * 1.5);
	              canvas.height = l;
	              canvas.width = l * 0.5;
	              ctx.font = font;
	              var char = "H";
	              var result = {
	                top: 0
	              };
	              ctx.clearRect(0, 0, l, l);
	              ctx.textBaseline = "top";
	              ctx.fillStyle = "black";
	              ctx.fillText(char, 0, 0);
	              var topPx = firstTop(ctx.getImageData(0, 0, l, l));
	              ctx.clearRect(0, 0, l, l);
	              ctx.textBaseline = "bottom";
	              ctx.fillText(char, 0, l);
	              var bottomPx = firstTop(ctx.getImageData(0, 0, l, l));
	              result.lineHeight = result.bottom = l - bottomPx + topPx;
	              ctx.clearRect(0, 0, l, l);
	              ctx.textBaseline = "alphabetic";
	              ctx.fillText(char, 0, l);
	              var baselinePx = firstTop(ctx.getImageData(0, 0, l, l));
	              var baseline = l - baselinePx - 1 + topPx;
	              result.baseline = result.alphabetic = baseline;
	              ctx.clearRect(0, 0, l, l);
	              ctx.textBaseline = "middle";
	              ctx.fillText(char, 0, l * 0.5);
	              var medianPx = firstTop(ctx.getImageData(0, 0, l, l));
	              result.median = result.middle = l - medianPx - 1 + topPx - l * 0.5;
	              ctx.clearRect(0, 0, l, l);
	              ctx.textBaseline = "hanging";
	              ctx.fillText(char, 0, l * 0.5);
	              var hangingPx = firstTop(ctx.getImageData(0, 0, l, l));
	              result.hanging = l - hangingPx - 1 + topPx - l * 0.5;
	              ctx.clearRect(0, 0, l, l);
	              ctx.textBaseline = "ideographic";
	              ctx.fillText(char, 0, l);
	              var ideographicPx = firstTop(ctx.getImageData(0, 0, l, l));
	              result.ideographic = l - ideographicPx - 1 + topPx;
	              if (chars.upper) {
	                ctx.clearRect(0, 0, l, l);
	                ctx.textBaseline = "top";
	                ctx.fillText(chars.upper, 0, 0);
	                result.upper = firstTop(ctx.getImageData(0, 0, l, l));
	                result.capHeight = result.baseline - result.upper;
	              }
	              if (chars.lower) {
	                ctx.clearRect(0, 0, l, l);
	                ctx.textBaseline = "top";
	                ctx.fillText(chars.lower, 0, 0);
	                result.lower = firstTop(ctx.getImageData(0, 0, l, l));
	                result.xHeight = result.baseline - result.lower;
	              }
	              if (chars.tittle) {
	                ctx.clearRect(0, 0, l, l);
	                ctx.textBaseline = "top";
	                ctx.fillText(chars.tittle, 0, 0);
	                result.tittle = firstTop(ctx.getImageData(0, 0, l, l));
	              }
	              if (chars.ascent) {
	                ctx.clearRect(0, 0, l, l);
	                ctx.textBaseline = "top";
	                ctx.fillText(chars.ascent, 0, 0);
	                result.ascent = firstTop(ctx.getImageData(0, 0, l, l));
	              }
	              if (chars.descent) {
	                ctx.clearRect(0, 0, l, l);
	                ctx.textBaseline = "top";
	                ctx.fillText(chars.descent, 0, 0);
	                result.descent = firstBottom(ctx.getImageData(0, 0, l, l));
	              }
	              if (chars.overshoot) {
	                ctx.clearRect(0, 0, l, l);
	                ctx.textBaseline = "top";
	                ctx.fillText(chars.overshoot, 0, 0);
	                var overshootPx = firstBottom(ctx.getImageData(0, 0, l, l));
	                result.overshoot = overshootPx - baseline;
	              }
	              for (var name2 in result) {
	                result[name2] /= fs;
	              }
	              result.em = fs;
	              measure.cache[family] = result;
	              return applyOrigin(result, origin);
	            }
	            function applyOrigin(obj, origin) {
	              var res = {};
	              if (typeof origin === "string") origin = obj[origin];
	              for (var name2 in obj) {
	                if (name2 === "em") continue;
	                res[name2] = obj[name2] - origin;
	              }
	              return res;
	            }
	            function firstTop(iData) {
	              var l = iData.height;
	              var data = iData.data;
	              for (var i = 3; i < data.length; i += 4) {
	                if (data[i] !== 0) {
	                  return Math.floor((i - 3) * 0.25 / l);
	                }
	              }
	            }
	            function firstBottom(iData) {
	              var l = iData.height;
	              var data = iData.data;
	              for (var i = data.length - 1; i > 0; i -= 4) {
	                if (data[i] !== 0) {
	                  return Math.floor((i - 3) * 0.25 / l);
	                }
	              }
	            }
	          }
	        ),
	        /***/
	        31353: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isCallable = __webpack_require__2(85395);
	            var toStr = Object.prototype.toString;
	            var hasOwnProperty2 = Object.prototype.hasOwnProperty;
	            var forEachArray = function forEachArray2(array, iterator, receiver) {
	              for (var i = 0, len = array.length; i < len; i++) {
	                if (hasOwnProperty2.call(array, i)) {
	                  if (receiver == null) {
	                    iterator(array[i], i, array);
	                  } else {
	                    iterator.call(receiver, array[i], i, array);
	                  }
	                }
	              }
	            };
	            var forEachString = function forEachString2(string, iterator, receiver) {
	              for (var i = 0, len = string.length; i < len; i++) {
	                if (receiver == null) {
	                  iterator(string.charAt(i), i, string);
	                } else {
	                  iterator.call(receiver, string.charAt(i), i, string);
	                }
	              }
	            };
	            var forEachObject = function forEachObject2(object, iterator, receiver) {
	              for (var k in object) {
	                if (hasOwnProperty2.call(object, k)) {
	                  if (receiver == null) {
	                    iterator(object[k], k, object);
	                  } else {
	                    iterator.call(receiver, object[k], k, object);
	                  }
	                }
	              }
	            };
	            var forEach = function forEach2(list, iterator, thisArg) {
	              if (!isCallable(iterator)) {
	                throw new TypeError("iterator must be a function");
	              }
	              var receiver;
	              if (arguments.length >= 3) {
	                receiver = thisArg;
	              }
	              if (toStr.call(list) === "[object Array]") {
	                forEachArray(list, iterator, receiver);
	              } else if (typeof list === "string") {
	                forEachString(list, iterator, receiver);
	              } else {
	                forEachObject(list, iterator, receiver);
	              }
	            };
	            module2.exports = forEach;
	          }
	        ),
	        /***/
	        73047: (
	          /***/
	          function(module2) {
	            var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
	            var slice2 = Array.prototype.slice;
	            var toStr = Object.prototype.toString;
	            var funcType = "[object Function]";
	            module2.exports = function bind(that) {
	              var target = this;
	              if (typeof target !== "function" || toStr.call(target) !== funcType) {
	                throw new TypeError(ERROR_MESSAGE + target);
	              }
	              var args = slice2.call(arguments, 1);
	              var bound;
	              var binder = function() {
	                if (this instanceof bound) {
	                  var result = target.apply(
	                    this,
	                    args.concat(slice2.call(arguments))
	                  );
	                  if (Object(result) === result) {
	                    return result;
	                  }
	                  return this;
	                } else {
	                  return target.apply(
	                    that,
	                    args.concat(slice2.call(arguments))
	                  );
	                }
	              };
	              var boundLength = Math.max(0, target.length - args.length);
	              var boundArgs = [];
	              for (var i = 0; i < boundLength; i++) {
	                boundArgs.push("$" + i);
	              }
	              bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
	              if (target.prototype) {
	                var Empty = function Empty2() {
	                };
	                Empty.prototype = target.prototype;
	                bound.prototype = new Empty();
	                Empty.prototype = null;
	              }
	              return bound;
	            };
	          }
	        ),
	        /***/
	        77575: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var implementation = __webpack_require__2(73047);
	            module2.exports = Function.prototype.bind || implementation;
	          }
	        ),
	        /***/
	        86249: (
	          /***/
	          function(module2) {
	            module2.exports = getCanvasContext;
	            function getCanvasContext(type, opts) {
	              if (typeof type !== "string") {
	                throw new TypeError("must specify type string");
	              }
	              opts = opts || {};
	              if (typeof document === "undefined" && !opts.canvas) {
	                return null;
	              }
	              var canvas = opts.canvas || document.createElement("canvas");
	              if (typeof opts.width === "number") {
	                canvas.width = opts.width;
	              }
	              if (typeof opts.height === "number") {
	                canvas.height = opts.height;
	              }
	              var attribs = opts;
	              var gl2;
	              try {
	                var names = [type];
	                if (type.indexOf("webgl") === 0) {
	                  names.push("experimental-" + type);
	                }
	                for (var i = 0; i < names.length; i++) {
	                  gl2 = canvas.getContext(names[i], attribs);
	                  if (gl2) return gl2;
	                }
	              } catch (e) {
	                gl2 = null;
	              }
	              return gl2 || null;
	            }
	          }
	        ),
	        /***/
	        68318: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var undefined2;
	            var $SyntaxError = SyntaxError;
	            var $Function = Function;
	            var $TypeError = TypeError;
	            var getEvalledConstructor = function(expressionSyntax) {
	              try {
	                return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
	              } catch (e) {
	              }
	            };
	            var $gOPD = Object.getOwnPropertyDescriptor;
	            if ($gOPD) {
	              try {
	                $gOPD({}, "");
	              } catch (e) {
	                $gOPD = null;
	              }
	            }
	            var throwTypeError = function() {
	              throw new $TypeError();
	            };
	            var ThrowTypeError = $gOPD ? function() {
	              try {
	                arguments.callee;
	                return throwTypeError;
	              } catch (calleeThrows) {
	                try {
	                  return $gOPD(arguments, "callee").get;
	                } catch (gOPDthrows) {
	                  return throwTypeError;
	                }
	              }
	            }() : throwTypeError;
	            var hasSymbols = __webpack_require__2(57877)();
	            var getProto = Object.getPrototypeOf || function(x) {
	              return x.__proto__;
	            };
	            var needsEval = {};
	            var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
	            var INTRINSICS = {
	              "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
	              "%Array%": Array,
	              "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
	              "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
	              "%AsyncFromSyncIteratorPrototype%": undefined2,
	              "%AsyncFunction%": needsEval,
	              "%AsyncGenerator%": needsEval,
	              "%AsyncGeneratorFunction%": needsEval,
	              "%AsyncIteratorPrototype%": needsEval,
	              "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
	              "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
	              "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined2 : BigInt64Array,
	              "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined2 : BigUint64Array,
	              "%Boolean%": Boolean,
	              "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
	              "%Date%": Date,
	              "%decodeURI%": decodeURI,
	              "%decodeURIComponent%": decodeURIComponent,
	              "%encodeURI%": encodeURI,
	              "%encodeURIComponent%": encodeURIComponent,
	              "%Error%": Error,
	              "%eval%": eval,
	              // eslint-disable-line no-eval
	              "%EvalError%": EvalError,
	              "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
	              "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
	              "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
	              "%Function%": $Function,
	              "%GeneratorFunction%": needsEval,
	              "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
	              "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
	              "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
	              "%isFinite%": isFinite,
	              "%isNaN%": isNaN,
	              "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
	              "%JSON%": typeof JSON === "object" ? JSON : undefined2,
	              "%Map%": typeof Map === "undefined" ? undefined2 : Map,
	              "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
	              "%Math%": Math,
	              "%Number%": Number,
	              "%Object%": Object,
	              "%parseFloat%": parseFloat,
	              "%parseInt%": parseInt,
	              "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
	              "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
	              "%RangeError%": RangeError,
	              "%ReferenceError%": ReferenceError,
	              "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
	              "%RegExp%": RegExp,
	              "%Set%": typeof Set === "undefined" ? undefined2 : Set,
	              "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
	              "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
	              "%String%": String,
	              "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
	              "%Symbol%": hasSymbols ? Symbol : undefined2,
	              "%SyntaxError%": $SyntaxError,
	              "%ThrowTypeError%": ThrowTypeError,
	              "%TypedArray%": TypedArray,
	              "%TypeError%": $TypeError,
	              "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
	              "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
	              "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
	              "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
	              "%URIError%": URIError,
	              "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
	              "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
	              "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
	            };
	            try {
	              null.error;
	            } catch (e) {
	              var errorProto = getProto(getProto(e));
	              INTRINSICS["%Error.prototype%"] = errorProto;
	            }
	            var doEval = function doEval2(name2) {
	              var value;
	              if (name2 === "%AsyncFunction%") {
	                value = getEvalledConstructor("async function () {}");
	              } else if (name2 === "%GeneratorFunction%") {
	                value = getEvalledConstructor("function* () {}");
	              } else if (name2 === "%AsyncGeneratorFunction%") {
	                value = getEvalledConstructor("async function* () {}");
	              } else if (name2 === "%AsyncGenerator%") {
	                var fn = doEval2("%AsyncGeneratorFunction%");
	                if (fn) {
	                  value = fn.prototype;
	                }
	              } else if (name2 === "%AsyncIteratorPrototype%") {
	                var gen = doEval2("%AsyncGenerator%");
	                if (gen) {
	                  value = getProto(gen.prototype);
	                }
	              }
	              INTRINSICS[name2] = value;
	              return value;
	            };
	            var LEGACY_ALIASES = {
	              "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
	              "%ArrayPrototype%": ["Array", "prototype"],
	              "%ArrayProto_entries%": ["Array", "prototype", "entries"],
	              "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
	              "%ArrayProto_keys%": ["Array", "prototype", "keys"],
	              "%ArrayProto_values%": ["Array", "prototype", "values"],
	              "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
	              "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
	              "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
	              "%BooleanPrototype%": ["Boolean", "prototype"],
	              "%DataViewPrototype%": ["DataView", "prototype"],
	              "%DatePrototype%": ["Date", "prototype"],
	              "%ErrorPrototype%": ["Error", "prototype"],
	              "%EvalErrorPrototype%": ["EvalError", "prototype"],
	              "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
	              "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
	              "%FunctionPrototype%": ["Function", "prototype"],
	              "%Generator%": ["GeneratorFunction", "prototype"],
	              "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
	              "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
	              "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
	              "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
	              "%JSONParse%": ["JSON", "parse"],
	              "%JSONStringify%": ["JSON", "stringify"],
	              "%MapPrototype%": ["Map", "prototype"],
	              "%NumberPrototype%": ["Number", "prototype"],
	              "%ObjectPrototype%": ["Object", "prototype"],
	              "%ObjProto_toString%": ["Object", "prototype", "toString"],
	              "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
	              "%PromisePrototype%": ["Promise", "prototype"],
	              "%PromiseProto_then%": ["Promise", "prototype", "then"],
	              "%Promise_all%": ["Promise", "all"],
	              "%Promise_reject%": ["Promise", "reject"],
	              "%Promise_resolve%": ["Promise", "resolve"],
	              "%RangeErrorPrototype%": ["RangeError", "prototype"],
	              "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
	              "%RegExpPrototype%": ["RegExp", "prototype"],
	              "%SetPrototype%": ["Set", "prototype"],
	              "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
	              "%StringPrototype%": ["String", "prototype"],
	              "%SymbolPrototype%": ["Symbol", "prototype"],
	              "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
	              "%TypedArrayPrototype%": ["TypedArray", "prototype"],
	              "%TypeErrorPrototype%": ["TypeError", "prototype"],
	              "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
	              "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
	              "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
	              "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
	              "%URIErrorPrototype%": ["URIError", "prototype"],
	              "%WeakMapPrototype%": ["WeakMap", "prototype"],
	              "%WeakSetPrototype%": ["WeakSet", "prototype"]
	            };
	            var bind = __webpack_require__2(77575);
	            var hasOwn = __webpack_require__2(35065);
	            var $concat = bind.call(Function.call, Array.prototype.concat);
	            var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	            var $replace = bind.call(Function.call, String.prototype.replace);
	            var $strSlice = bind.call(Function.call, String.prototype.slice);
	            var $exec = bind.call(Function.call, RegExp.prototype.exec);
	            var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	            var reEscapeChar = /\\(\\)?/g;
	            var stringToPath = function stringToPath2(string) {
	              var first = $strSlice(string, 0, 1);
	              var last = $strSlice(string, -1);
	              if (first === "%" && last !== "%") {
	                throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
	              } else if (last === "%" && first !== "%") {
	                throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
	              }
	              var result = [];
	              $replace(string, rePropName, function(match, number2, quote, subString) {
	                result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number2 || match;
	              });
	              return result;
	            };
	            var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
	              var intrinsicName = name2;
	              var alias;
	              if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
	                alias = LEGACY_ALIASES[intrinsicName];
	                intrinsicName = "%" + alias[0] + "%";
	              }
	              if (hasOwn(INTRINSICS, intrinsicName)) {
	                var value = INTRINSICS[intrinsicName];
	                if (value === needsEval) {
	                  value = doEval(intrinsicName);
	                }
	                if (typeof value === "undefined" && !allowMissing) {
	                  throw new $TypeError("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
	                }
	                return {
	                  alias,
	                  name: intrinsicName,
	                  value
	                };
	              }
	              throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
	            };
	            module2.exports = function GetIntrinsic(name2, allowMissing) {
	              if (typeof name2 !== "string" || name2.length === 0) {
	                throw new $TypeError("intrinsic name must be a non-empty string");
	              }
	              if (arguments.length > 1 && typeof allowMissing !== "boolean") {
	                throw new $TypeError('"allowMissing" argument must be a boolean');
	              }
	              if ($exec(/^%?[^%]*%?$/, name2) === null) {
	                throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
	              }
	              var parts = stringToPath(name2);
	              var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
	              var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
	              var intrinsicRealName = intrinsic.name;
	              var value = intrinsic.value;
	              var skipFurtherCaching = false;
	              var alias = intrinsic.alias;
	              if (alias) {
	                intrinsicBaseName = alias[0];
	                $spliceApply(parts, $concat([0, 1], alias));
	              }
	              for (var i = 1, isOwn = true; i < parts.length; i += 1) {
	                var part = parts[i];
	                var first = $strSlice(part, 0, 1);
	                var last = $strSlice(part, -1);
	                if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
	                  throw new $SyntaxError("property names with quotes must have matching quotes");
	                }
	                if (part === "constructor" || !isOwn) {
	                  skipFurtherCaching = true;
	                }
	                intrinsicBaseName += "." + part;
	                intrinsicRealName = "%" + intrinsicBaseName + "%";
	                if (hasOwn(INTRINSICS, intrinsicRealName)) {
	                  value = INTRINSICS[intrinsicRealName];
	                } else if (value != null) {
	                  if (!(part in value)) {
	                    if (!allowMissing) {
	                      throw new $TypeError("base intrinsic for " + name2 + " exists, but the property is not available.");
	                    }
	                    return undefined;
	                  }
	                  if ($gOPD && i + 1 >= parts.length) {
	                    var desc = $gOPD(value, part);
	                    isOwn = !!desc;
	                    if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
	                      value = desc.get;
	                    } else {
	                      value = value[part];
	                    }
	                  } else {
	                    isOwn = hasOwn(value, part);
	                    value = value[part];
	                  }
	                  if (isOwn && !skipFurtherCaching) {
	                    INTRINSICS[intrinsicRealName] = value;
	                  }
	                }
	              }
	              return value;
	            };
	          }
	        ),
	        /***/
	        85400: (
	          /***/
	          function(module2) {
	            module2.exports = adjoint;
	            function adjoint(out, a) {
	              var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	              out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
	              out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
	              out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
	              out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
	              out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
	              out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
	              out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
	              out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
	              out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
	              out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
	              out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
	              out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
	              out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
	              out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
	              out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
	              out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
	              return out;
	            }
	          }
	        ),
	        /***/
	        42331: (
	          /***/
	          function(module2) {
	            module2.exports = clone;
	            function clone(a) {
	              var out = new Float32Array(16);
	              out[0] = a[0];
	              out[1] = a[1];
	              out[2] = a[2];
	              out[3] = a[3];
	              out[4] = a[4];
	              out[5] = a[5];
	              out[6] = a[6];
	              out[7] = a[7];
	              out[8] = a[8];
	              out[9] = a[9];
	              out[10] = a[10];
	              out[11] = a[11];
	              out[12] = a[12];
	              out[13] = a[13];
	              out[14] = a[14];
	              out[15] = a[15];
	              return out;
	            }
	          }
	        ),
	        /***/
	        31042: (
	          /***/
	          function(module2) {
	            module2.exports = copy;
	            function copy(out, a) {
	              out[0] = a[0];
	              out[1] = a[1];
	              out[2] = a[2];
	              out[3] = a[3];
	              out[4] = a[4];
	              out[5] = a[5];
	              out[6] = a[6];
	              out[7] = a[7];
	              out[8] = a[8];
	              out[9] = a[9];
	              out[10] = a[10];
	              out[11] = a[11];
	              out[12] = a[12];
	              out[13] = a[13];
	              out[14] = a[14];
	              out[15] = a[15];
	              return out;
	            }
	          }
	        ),
	        /***/
	        11902: (
	          /***/
	          function(module2) {
	            module2.exports = create;
	            function create() {
	              var out = new Float32Array(16);
	              out[0] = 1;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = 1;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = 1;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        89887: (
	          /***/
	          function(module2) {
	            module2.exports = determinant;
	            function determinant(a) {
	              var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32;
	              return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	            }
	          }
	        ),
	        /***/
	        27812: (
	          /***/
	          function(module2) {
	            module2.exports = fromQuat;
	            function fromQuat(out, q) {
	              var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, yx = y * x2, yy = y * y2, zx = z * x2, zy = z * y2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
	              out[0] = 1 - yy - zz;
	              out[1] = yx + wz;
	              out[2] = zx - wy;
	              out[3] = 0;
	              out[4] = yx - wz;
	              out[5] = 1 - xx - zz;
	              out[6] = zy + wx;
	              out[7] = 0;
	              out[8] = zx + wy;
	              out[9] = zy - wx;
	              out[10] = 1 - xx - yy;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        34045: (
	          /***/
	          function(module2) {
	            module2.exports = fromRotation;
	            function fromRotation(out, rad, axis) {
	              var s, c, t;
	              var x = axis[0];
	              var y = axis[1];
	              var z = axis[2];
	              var len = Math.sqrt(x * x + y * y + z * z);
	              if (Math.abs(len) < 1e-6) {
	                return null;
	              }
	              len = 1 / len;
	              x *= len;
	              y *= len;
	              z *= len;
	              s = Math.sin(rad);
	              c = Math.cos(rad);
	              t = 1 - c;
	              out[0] = x * x * t + c;
	              out[1] = y * x * t + z * s;
	              out[2] = z * x * t - y * s;
	              out[3] = 0;
	              out[4] = x * y * t - z * s;
	              out[5] = y * y * t + c;
	              out[6] = z * y * t + x * s;
	              out[7] = 0;
	              out[8] = x * z * t + y * s;
	              out[9] = y * z * t - x * s;
	              out[10] = z * z * t + c;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        45973: (
	          /***/
	          function(module2) {
	            module2.exports = fromRotationTranslation;
	            function fromRotationTranslation(out, q, v) {
	              var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, xy = x * y2, xz = x * z2, yy = y * y2, yz = y * z2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
	              out[0] = 1 - (yy + zz);
	              out[1] = xy + wz;
	              out[2] = xz - wy;
	              out[3] = 0;
	              out[4] = xy - wz;
	              out[5] = 1 - (xx + zz);
	              out[6] = yz + wx;
	              out[7] = 0;
	              out[8] = xz + wy;
	              out[9] = yz - wx;
	              out[10] = 1 - (xx + yy);
	              out[11] = 0;
	              out[12] = v[0];
	              out[13] = v[1];
	              out[14] = v[2];
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        81472: (
	          /***/
	          function(module2) {
	            module2.exports = fromScaling;
	            function fromScaling(out, v) {
	              out[0] = v[0];
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = v[1];
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = v[2];
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        14669: (
	          /***/
	          function(module2) {
	            module2.exports = fromTranslation;
	            function fromTranslation(out, v) {
	              out[0] = 1;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = 1;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = 1;
	              out[11] = 0;
	              out[12] = v[0];
	              out[13] = v[1];
	              out[14] = v[2];
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        75262: (
	          /***/
	          function(module2) {
	            module2.exports = fromXRotation;
	            function fromXRotation(out, rad) {
	              var s = Math.sin(rad), c = Math.cos(rad);
	              out[0] = 1;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = c;
	              out[6] = s;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = -s;
	              out[10] = c;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        331: (
	          /***/
	          function(module2) {
	            module2.exports = fromYRotation;
	            function fromYRotation(out, rad) {
	              var s = Math.sin(rad), c = Math.cos(rad);
	              out[0] = c;
	              out[1] = 0;
	              out[2] = -s;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = 1;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = s;
	              out[9] = 0;
	              out[10] = c;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        11049: (
	          /***/
	          function(module2) {
	            module2.exports = fromZRotation;
	            function fromZRotation(out, rad) {
	              var s = Math.sin(rad), c = Math.cos(rad);
	              out[0] = c;
	              out[1] = s;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = -s;
	              out[5] = c;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = 1;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        75195: (
	          /***/
	          function(module2) {
	            module2.exports = frustum;
	            function frustum(out, left, right, bottom, top, near, far) {
	              var rl = 1 / (right - left), tb = 1 / (top - bottom), nf = 1 / (near - far);
	              out[0] = near * 2 * rl;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = near * 2 * tb;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = (right + left) * rl;
	              out[9] = (top + bottom) * tb;
	              out[10] = (far + near) * nf;
	              out[11] = -1;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = far * near * 2 * nf;
	              out[15] = 0;
	              return out;
	            }
	          }
	        ),
	        /***/
	        71551: (
	          /***/
	          function(module2) {
	            module2.exports = identity2;
	            function identity2(out) {
	              out[0] = 1;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = 1;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = 1;
	              out[11] = 0;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 0;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        79576: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              create: __webpack_require__2(11902),
	              clone: __webpack_require__2(42331),
	              copy: __webpack_require__2(31042),
	              identity: __webpack_require__2(71551),
	              transpose: __webpack_require__2(88654),
	              invert: __webpack_require__2(95874),
	              adjoint: __webpack_require__2(85400),
	              determinant: __webpack_require__2(89887),
	              multiply: __webpack_require__2(91362),
	              translate: __webpack_require__2(31283),
	              scale: __webpack_require__2(10789),
	              rotate: __webpack_require__2(65074),
	              rotateX: __webpack_require__2(35545),
	              rotateY: __webpack_require__2(94918),
	              rotateZ: __webpack_require__2(15692),
	              fromRotation: __webpack_require__2(34045),
	              fromRotationTranslation: __webpack_require__2(45973),
	              fromScaling: __webpack_require__2(81472),
	              fromTranslation: __webpack_require__2(14669),
	              fromXRotation: __webpack_require__2(75262),
	              fromYRotation: __webpack_require__2(331),
	              fromZRotation: __webpack_require__2(11049),
	              fromQuat: __webpack_require__2(27812),
	              frustum: __webpack_require__2(75195),
	              perspective: __webpack_require__2(7864),
	              perspectiveFromFieldOfView: __webpack_require__2(35279),
	              ortho: __webpack_require__2(60378),
	              lookAt: __webpack_require__2(65551),
	              str: __webpack_require__2(6726)
	            };
	          }
	        ),
	        /***/
	        95874: (
	          /***/
	          function(module2) {
	            module2.exports = invert;
	            function invert(out, a) {
	              var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32, det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	              if (!det) {
	                return null;
	              }
	              det = 1 / det;
	              out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	              out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	              out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	              out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	              out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	              out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	              out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	              out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	              out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	              out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	              out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	              out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	              out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	              out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	              out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	              out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	              return out;
	            }
	          }
	        ),
	        /***/
	        65551: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var identity2 = __webpack_require__2(71551);
	            module2.exports = lookAt;
	            function lookAt(out, eye, center, up) {
	              var x0, x1, x2, y0, y1, y2, z0, z1, z2, len, eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2], centerx = center[0], centery = center[1], centerz = center[2];
	              if (Math.abs(eyex - centerx) < 1e-6 && Math.abs(eyey - centery) < 1e-6 && Math.abs(eyez - centerz) < 1e-6) {
	                return identity2(out);
	              }
	              z0 = eyex - centerx;
	              z1 = eyey - centery;
	              z2 = eyez - centerz;
	              len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
	              z0 *= len;
	              z1 *= len;
	              z2 *= len;
	              x0 = upy * z2 - upz * z1;
	              x1 = upz * z0 - upx * z2;
	              x2 = upx * z1 - upy * z0;
	              len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
	              if (!len) {
	                x0 = 0;
	                x1 = 0;
	                x2 = 0;
	              } else {
	                len = 1 / len;
	                x0 *= len;
	                x1 *= len;
	                x2 *= len;
	              }
	              y0 = z1 * x2 - z2 * x1;
	              y1 = z2 * x0 - z0 * x2;
	              y2 = z0 * x1 - z1 * x0;
	              len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
	              if (!len) {
	                y0 = 0;
	                y1 = 0;
	                y2 = 0;
	              } else {
	                len = 1 / len;
	                y0 *= len;
	                y1 *= len;
	                y2 *= len;
	              }
	              out[0] = x0;
	              out[1] = y0;
	              out[2] = z0;
	              out[3] = 0;
	              out[4] = x1;
	              out[5] = y1;
	              out[6] = z1;
	              out[7] = 0;
	              out[8] = x2;
	              out[9] = y2;
	              out[10] = z2;
	              out[11] = 0;
	              out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
	              out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
	              out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        91362: (
	          /***/
	          function(module2) {
	            module2.exports = multiply;
	            function multiply(out, a, b) {
	              var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	              var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	              out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	              out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	              out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	              out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	              b0 = b[4];
	              b1 = b[5];
	              b2 = b[6];
	              b3 = b[7];
	              out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	              out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	              out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	              out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	              b0 = b[8];
	              b1 = b[9];
	              b2 = b[10];
	              b3 = b[11];
	              out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	              out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	              out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	              out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	              b0 = b[12];
	              b1 = b[13];
	              b2 = b[14];
	              b3 = b[15];
	              out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	              out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	              out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	              out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	              return out;
	            }
	          }
	        ),
	        /***/
	        60378: (
	          /***/
	          function(module2) {
	            module2.exports = ortho;
	            function ortho(out, left, right, bottom, top, near, far) {
	              var lr = 1 / (left - right), bt = 1 / (bottom - top), nf = 1 / (near - far);
	              out[0] = -2 * lr;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = -2 * bt;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = 2 * nf;
	              out[11] = 0;
	              out[12] = (left + right) * lr;
	              out[13] = (top + bottom) * bt;
	              out[14] = (far + near) * nf;
	              out[15] = 1;
	              return out;
	            }
	          }
	        ),
	        /***/
	        7864: (
	          /***/
	          function(module2) {
	            module2.exports = perspective;
	            function perspective(out, fovy, aspect, near, far) {
	              var f = 1 / Math.tan(fovy / 2), nf = 1 / (near - far);
	              out[0] = f / aspect;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = f;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = 0;
	              out[9] = 0;
	              out[10] = (far + near) * nf;
	              out[11] = -1;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = 2 * far * near * nf;
	              out[15] = 0;
	              return out;
	            }
	          }
	        ),
	        /***/
	        35279: (
	          /***/
	          function(module2) {
	            module2.exports = perspectiveFromFieldOfView;
	            function perspectiveFromFieldOfView(out, fov, near, far) {
	              var upTan = Math.tan(fov.upDegrees * Math.PI / 180), downTan = Math.tan(fov.downDegrees * Math.PI / 180), leftTan = Math.tan(fov.leftDegrees * Math.PI / 180), rightTan = Math.tan(fov.rightDegrees * Math.PI / 180), xScale = 2 / (leftTan + rightTan), yScale = 2 / (upTan + downTan);
	              out[0] = xScale;
	              out[1] = 0;
	              out[2] = 0;
	              out[3] = 0;
	              out[4] = 0;
	              out[5] = yScale;
	              out[6] = 0;
	              out[7] = 0;
	              out[8] = -((leftTan - rightTan) * xScale * 0.5);
	              out[9] = (upTan - downTan) * yScale * 0.5;
	              out[10] = far / (near - far);
	              out[11] = -1;
	              out[12] = 0;
	              out[13] = 0;
	              out[14] = far * near / (near - far);
	              out[15] = 0;
	              return out;
	            }
	          }
	        ),
	        /***/
	        65074: (
	          /***/
	          function(module2) {
	            module2.exports = rotate;
	            function rotate(out, a, rad, axis) {
	              var x = axis[0], y = axis[1], z = axis[2], len = Math.sqrt(x * x + y * y + z * z), s, c, t, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, b00, b01, b02, b10, b11, b12, b20, b21, b22;
	              if (Math.abs(len) < 1e-6) {
	                return null;
	              }
	              len = 1 / len;
	              x *= len;
	              y *= len;
	              z *= len;
	              s = Math.sin(rad);
	              c = Math.cos(rad);
	              t = 1 - c;
	              a00 = a[0];
	              a01 = a[1];
	              a02 = a[2];
	              a03 = a[3];
	              a10 = a[4];
	              a11 = a[5];
	              a12 = a[6];
	              a13 = a[7];
	              a20 = a[8];
	              a21 = a[9];
	              a22 = a[10];
	              a23 = a[11];
	              b00 = x * x * t + c;
	              b01 = y * x * t + z * s;
	              b02 = z * x * t - y * s;
	              b10 = x * y * t - z * s;
	              b11 = y * y * t + c;
	              b12 = z * y * t + x * s;
	              b20 = x * z * t + y * s;
	              b21 = y * z * t - x * s;
	              b22 = z * z * t + c;
	              out[0] = a00 * b00 + a10 * b01 + a20 * b02;
	              out[1] = a01 * b00 + a11 * b01 + a21 * b02;
	              out[2] = a02 * b00 + a12 * b01 + a22 * b02;
	              out[3] = a03 * b00 + a13 * b01 + a23 * b02;
	              out[4] = a00 * b10 + a10 * b11 + a20 * b12;
	              out[5] = a01 * b10 + a11 * b11 + a21 * b12;
	              out[6] = a02 * b10 + a12 * b11 + a22 * b12;
	              out[7] = a03 * b10 + a13 * b11 + a23 * b12;
	              out[8] = a00 * b20 + a10 * b21 + a20 * b22;
	              out[9] = a01 * b20 + a11 * b21 + a21 * b22;
	              out[10] = a02 * b20 + a12 * b21 + a22 * b22;
	              out[11] = a03 * b20 + a13 * b21 + a23 * b22;
	              if (a !== out) {
	                out[12] = a[12];
	                out[13] = a[13];
	                out[14] = a[14];
	                out[15] = a[15];
	              }
	              return out;
	            }
	          }
	        ),
	        /***/
	        35545: (
	          /***/
	          function(module2) {
	            module2.exports = rotateX;
	            function rotateX(out, a, rad) {
	              var s = Math.sin(rad), c = Math.cos(rad), a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
	              if (a !== out) {
	                out[0] = a[0];
	                out[1] = a[1];
	                out[2] = a[2];
	                out[3] = a[3];
	                out[12] = a[12];
	                out[13] = a[13];
	                out[14] = a[14];
	                out[15] = a[15];
	              }
	              out[4] = a10 * c + a20 * s;
	              out[5] = a11 * c + a21 * s;
	              out[6] = a12 * c + a22 * s;
	              out[7] = a13 * c + a23 * s;
	              out[8] = a20 * c - a10 * s;
	              out[9] = a21 * c - a11 * s;
	              out[10] = a22 * c - a12 * s;
	              out[11] = a23 * c - a13 * s;
	              return out;
	            }
	          }
	        ),
	        /***/
	        94918: (
	          /***/
	          function(module2) {
	            module2.exports = rotateY;
	            function rotateY(out, a, rad) {
	              var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
	              if (a !== out) {
	                out[4] = a[4];
	                out[5] = a[5];
	                out[6] = a[6];
	                out[7] = a[7];
	                out[12] = a[12];
	                out[13] = a[13];
	                out[14] = a[14];
	                out[15] = a[15];
	              }
	              out[0] = a00 * c - a20 * s;
	              out[1] = a01 * c - a21 * s;
	              out[2] = a02 * c - a22 * s;
	              out[3] = a03 * c - a23 * s;
	              out[8] = a00 * s + a20 * c;
	              out[9] = a01 * s + a21 * c;
	              out[10] = a02 * s + a22 * c;
	              out[11] = a03 * s + a23 * c;
	              return out;
	            }
	          }
	        ),
	        /***/
	        15692: (
	          /***/
	          function(module2) {
	            module2.exports = rotateZ;
	            function rotateZ(out, a, rad) {
	              var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
	              if (a !== out) {
	                out[8] = a[8];
	                out[9] = a[9];
	                out[10] = a[10];
	                out[11] = a[11];
	                out[12] = a[12];
	                out[13] = a[13];
	                out[14] = a[14];
	                out[15] = a[15];
	              }
	              out[0] = a00 * c + a10 * s;
	              out[1] = a01 * c + a11 * s;
	              out[2] = a02 * c + a12 * s;
	              out[3] = a03 * c + a13 * s;
	              out[4] = a10 * c - a00 * s;
	              out[5] = a11 * c - a01 * s;
	              out[6] = a12 * c - a02 * s;
	              out[7] = a13 * c - a03 * s;
	              return out;
	            }
	          }
	        ),
	        /***/
	        10789: (
	          /***/
	          function(module2) {
	            module2.exports = scale;
	            function scale(out, a, v) {
	              var x = v[0], y = v[1], z = v[2];
	              out[0] = a[0] * x;
	              out[1] = a[1] * x;
	              out[2] = a[2] * x;
	              out[3] = a[3] * x;
	              out[4] = a[4] * y;
	              out[5] = a[5] * y;
	              out[6] = a[6] * y;
	              out[7] = a[7] * y;
	              out[8] = a[8] * z;
	              out[9] = a[9] * z;
	              out[10] = a[10] * z;
	              out[11] = a[11] * z;
	              out[12] = a[12];
	              out[13] = a[13];
	              out[14] = a[14];
	              out[15] = a[15];
	              return out;
	            }
	          }
	        ),
	        /***/
	        6726: (
	          /***/
	          function(module2) {
	            module2.exports = str;
	            function str(a) {
	              return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
	            }
	          }
	        ),
	        /***/
	        31283: (
	          /***/
	          function(module2) {
	            module2.exports = translate;
	            function translate(out, a, v) {
	              var x = v[0], y = v[1], z = v[2], a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23;
	              if (a === out) {
	                out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
	                out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
	                out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
	                out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
	              } else {
	                a00 = a[0];
	                a01 = a[1];
	                a02 = a[2];
	                a03 = a[3];
	                a10 = a[4];
	                a11 = a[5];
	                a12 = a[6];
	                a13 = a[7];
	                a20 = a[8];
	                a21 = a[9];
	                a22 = a[10];
	                a23 = a[11];
	                out[0] = a00;
	                out[1] = a01;
	                out[2] = a02;
	                out[3] = a03;
	                out[4] = a10;
	                out[5] = a11;
	                out[6] = a12;
	                out[7] = a13;
	                out[8] = a20;
	                out[9] = a21;
	                out[10] = a22;
	                out[11] = a23;
	                out[12] = a00 * x + a10 * y + a20 * z + a[12];
	                out[13] = a01 * x + a11 * y + a21 * z + a[13];
	                out[14] = a02 * x + a12 * y + a22 * z + a[14];
	                out[15] = a03 * x + a13 * y + a23 * z + a[15];
	              }
	              return out;
	            }
	          }
	        ),
	        /***/
	        88654: (
	          /***/
	          function(module2) {
	            module2.exports = transpose;
	            function transpose(out, a) {
	              if (out === a) {
	                var a01 = a[1], a02 = a[2], a03 = a[3], a12 = a[6], a13 = a[7], a23 = a[11];
	                out[1] = a[4];
	                out[2] = a[8];
	                out[3] = a[12];
	                out[4] = a01;
	                out[6] = a[9];
	                out[7] = a[13];
	                out[8] = a02;
	                out[9] = a12;
	                out[11] = a[14];
	                out[12] = a03;
	                out[13] = a13;
	                out[14] = a23;
	              } else {
	                out[0] = a[0];
	                out[1] = a[4];
	                out[2] = a[8];
	                out[3] = a[12];
	                out[4] = a[1];
	                out[5] = a[5];
	                out[6] = a[9];
	                out[7] = a[13];
	                out[8] = a[2];
	                out[9] = a[6];
	                out[10] = a[10];
	                out[11] = a[14];
	                out[12] = a[3];
	                out[13] = a[7];
	                out[14] = a[11];
	                out[15] = a[15];
	              }
	              return out;
	            }
	          }
	        ),
	        /***/
	        42505: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var Font = __webpack_require__2(72791);
	            var pick = __webpack_require__2(71299);
	            var createRegl = __webpack_require__2(98580);
	            var createGl = __webpack_require__2(12018);
	            var WeakMap2 = __webpack_require__2(83522);
	            var rgba = __webpack_require__2(25075);
	            var fontAtlas = __webpack_require__2(68016);
	            var pool = __webpack_require__2(58404);
	            var parseRect = __webpack_require__2(18863);
	            var isObj = __webpack_require__2(10973);
	            var parseUnit = __webpack_require__2(25677);
	            var px = __webpack_require__2(75686);
	            var kerning = __webpack_require__2(53545);
	            var extend = __webpack_require__2(56131);
	            var metrics = __webpack_require__2(32879);
	            var flatten = __webpack_require__2(30120);
	            var ref = __webpack_require__2(13547);
	            var nextPow2 = ref.nextPow2;
	            var shaderCache = new WeakMap2();
	            var isStretchSupported = false;
	            if (document.body) {
	              var el = document.body.appendChild(document.createElement("div"));
	              el.style.font = "italic small-caps bold condensed 16px/2 cursive";
	              if (getComputedStyle(el).fontStretch) {
	                isStretchSupported = true;
	              }
	              document.body.removeChild(el);
	            }
	            var GlText = function GlText2(o) {
	              if (isRegl(o)) {
	                o = { regl: o };
	                this.gl = o.regl._gl;
	              } else {
	                this.gl = createGl(o);
	              }
	              this.shader = shaderCache.get(this.gl);
	              if (!this.shader) {
	                this.regl = o.regl || createRegl({ gl: this.gl });
	              } else {
	                this.regl = this.shader.regl;
	              }
	              this.charBuffer = this.regl.buffer({ type: "uint8", usage: "stream" });
	              this.sizeBuffer = this.regl.buffer({ type: "float", usage: "stream" });
	              if (!this.shader) {
	                this.shader = this.createShader();
	                shaderCache.set(this.gl, this.shader);
	              }
	              this.batch = [];
	              this.fontSize = [];
	              this.font = [];
	              this.fontAtlas = [];
	              this.draw = this.shader.draw.bind(this);
	              this.render = function() {
	                this.regl._refresh();
	                this.draw(this.batch);
	              };
	              this.canvas = this.gl.canvas;
	              this.update(isObj(o) ? o : {});
	            };
	            GlText.prototype.createShader = function createShader() {
	              var regl = this.regl;
	              var draw = regl({
	                blend: {
	                  enable: true,
	                  color: [0, 0, 0, 1],
	                  func: {
	                    srcRGB: "src alpha",
	                    dstRGB: "one minus src alpha",
	                    srcAlpha: "one minus dst alpha",
	                    dstAlpha: "one"
	                  }
	                },
	                stencil: { enable: false },
	                depth: { enable: false },
	                count: regl.prop("count"),
	                offset: regl.prop("offset"),
	                attributes: {
	                  charOffset: {
	                    offset: 4,
	                    stride: 8,
	                    buffer: regl.this("sizeBuffer")
	                  },
	                  width: {
	                    offset: 0,
	                    stride: 8,
	                    buffer: regl.this("sizeBuffer")
	                  },
	                  char: regl.this("charBuffer"),
	                  position: regl.this("position")
	                },
	                uniforms: {
	                  atlasSize: function(c, p) {
	                    return [p.atlas.width, p.atlas.height];
	                  },
	                  atlasDim: function(c, p) {
	                    return [p.atlas.cols, p.atlas.rows];
	                  },
	                  atlas: function(c, p) {
	                    return p.atlas.texture;
	                  },
	                  charStep: function(c, p) {
	                    return p.atlas.step;
	                  },
	                  em: function(c, p) {
	                    return p.atlas.em;
	                  },
	                  color: regl.prop("color"),
	                  opacity: regl.prop("opacity"),
	                  viewport: regl.this("viewportArray"),
	                  scale: regl.this("scale"),
	                  align: regl.prop("align"),
	                  baseline: regl.prop("baseline"),
	                  translate: regl.this("translate"),
	                  positionOffset: regl.prop("positionOffset")
	                },
	                primitive: "points",
	                viewport: regl.this("viewport"),
	                vert: "\n			precision highp float;\n			attribute float width, charOffset, char;\n			attribute vec2 position;\n			uniform float fontSize, charStep, em, align, baseline;\n			uniform vec4 viewport;\n			uniform vec4 color;\n			uniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n			varying vec2 charCoord, charId;\n			varying float charWidth;\n			varying vec4 fontColor;\n			void main () {\n				vec2 offset = floor(em * (vec2(align + charOffset, baseline)\n					+ vec2(positionOffset.x, -positionOffset.y)))\n					/ (viewport.zw * scale.xy);\n\n				vec2 position = (position + translate) * scale;\n				position += offset * scale;\n\n				charCoord = position * viewport.zw + viewport.xy;\n\n				gl_Position = vec4(position * 2. - 1., 0, 1);\n\n				gl_PointSize = charStep;\n\n				charId.x = mod(char, atlasDim.x);\n				charId.y = floor(char / atlasDim.x);\n\n				charWidth = width * em;\n\n				fontColor = color / 255.;\n			}",
	                frag: "\n			precision highp float;\n			uniform float fontSize, charStep, opacity;\n			uniform vec2 atlasSize;\n			uniform vec4 viewport;\n			uniform sampler2D atlas;\n			varying vec4 fontColor;\n			varying vec2 charCoord, charId;\n			varying float charWidth;\n\n			float lightness(vec4 color) {\n				return color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n			}\n\n			void main () {\n				vec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n				float halfCharStep = floor(charStep * .5 + .5);\n\n				// invert y and shift by 1px (FF expecially needs that)\n				uv.y = charStep - uv.y;\n\n				// ignore points outside of character bounding box\n				float halfCharWidth = ceil(charWidth * .5);\n				if (floor(uv.x) > halfCharStep + halfCharWidth ||\n					floor(uv.x) < halfCharStep - halfCharWidth) return;\n\n				uv += charId * charStep;\n				uv = uv / atlasSize;\n\n				vec4 color = fontColor;\n				vec4 mask = texture2D(atlas, uv);\n\n				float maskY = lightness(mask);\n				// float colorY = lightness(color);\n				color.a *= maskY;\n				color.a *= opacity;\n\n				// color.a += .1;\n\n				// antialiasing, see yiq color space y-channel formula\n				// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n				gl_FragColor = color;\n			}"
	              });
	              var atlas = {};
	              return { regl, draw, atlas };
	            };
	            GlText.prototype.update = function update(o) {
	              var this$1$1 = this;
	              if (typeof o === "string") {
	                o = { text: o };
	              } else if (!o) {
	                return;
	              }
	              o = pick(o, {
	                position: "position positions coord coords coordinates",
	                font: "font fontFace fontface typeface cssFont css-font family fontFamily",
	                fontSize: "fontSize fontsize size font-size",
	                text: "text texts chars characters value values symbols",
	                align: "align alignment textAlign textbaseline",
	                baseline: "baseline textBaseline textbaseline",
	                direction: "dir direction textDirection",
	                color: "color colour fill fill-color fillColor textColor textcolor",
	                kerning: "kerning kern",
	                range: "range dataBox",
	                viewport: "vp viewport viewBox viewbox viewPort",
	                opacity: "opacity alpha transparency visible visibility opaque",
	                offset: "offset positionOffset padding shift indent indentation"
	              }, true);
	              if (o.opacity != null) {
	                if (Array.isArray(o.opacity)) {
	                  this.opacity = o.opacity.map(function(o2) {
	                    return parseFloat(o2);
	                  });
	                } else {
	                  this.opacity = parseFloat(o.opacity);
	                }
	              }
	              if (o.viewport != null) {
	                this.viewport = parseRect(o.viewport);
	                this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height];
	              }
	              if (this.viewport == null) {
	                this.viewport = {
	                  x: 0,
	                  y: 0,
	                  width: this.gl.drawingBufferWidth,
	                  height: this.gl.drawingBufferHeight
	                };
	                this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height];
	              }
	              if (o.kerning != null) {
	                this.kerning = o.kerning;
	              }
	              if (o.offset != null) {
	                if (typeof o.offset === "number") {
	                  o.offset = [o.offset, 0];
	                }
	                this.positionOffset = flatten(o.offset);
	              }
	              if (o.direction) {
	                this.direction = o.direction;
	              }
	              if (o.range) {
	                this.range = o.range;
	                this.scale = [1 / (o.range[2] - o.range[0]), 1 / (o.range[3] - o.range[1])];
	                this.translate = [-o.range[0], -o.range[1]];
	              }
	              if (o.scale) {
	                this.scale = o.scale;
	              }
	              if (o.translate) {
	                this.translate = o.translate;
	              }
	              if (!this.scale) {
	                this.scale = [1 / this.viewport.width, 1 / this.viewport.height];
	              }
	              if (!this.translate) {
	                this.translate = [0, 0];
	              }
	              if (!this.font.length && !o.font) {
	                o.font = GlText.baseFontSize + "px sans-serif";
	              }
	              var newFont = false, newFontSize = false;
	              if (o.font) {
	                (Array.isArray(o.font) ? o.font : [o.font]).forEach(function(font2, i2) {
	                  if (typeof font2 === "string") {
	                    try {
	                      font2 = Font.parse(font2);
	                    } catch (e) {
	                      font2 = Font.parse(GlText.baseFontSize + "px " + font2);
	                    }
	                  } else {
	                    font2 = Font.parse(Font.stringify(font2));
	                  }
	                  var baseString = Font.stringify({
	                    size: GlText.baseFontSize,
	                    family: font2.family,
	                    stretch: isStretchSupported ? font2.stretch : undefined,
	                    variant: font2.variant,
	                    weight: font2.weight,
	                    style: font2.style
	                  });
	                  var unit = parseUnit(font2.size);
	                  var fs = Math.round(unit[0] * px(unit[1]));
	                  if (fs !== this$1$1.fontSize[i2]) {
	                    newFontSize = true;
	                    this$1$1.fontSize[i2] = fs;
	                  }
	                  if (!this$1$1.font[i2] || baseString != this$1$1.font[i2].baseString) {
	                    newFont = true;
	                    this$1$1.font[i2] = GlText.fonts[baseString];
	                    if (!this$1$1.font[i2]) {
	                      var family = font2.family.join(", ");
	                      var style = [font2.style];
	                      if (font2.style != font2.variant) {
	                        style.push(font2.variant);
	                      }
	                      if (font2.variant != font2.weight) {
	                        style.push(font2.weight);
	                      }
	                      if (isStretchSupported && font2.weight != font2.stretch) {
	                        style.push(font2.stretch);
	                      }
	                      this$1$1.font[i2] = {
	                        baseString,
	                        // typeface
	                        family,
	                        weight: font2.weight,
	                        stretch: font2.stretch,
	                        style: font2.style,
	                        variant: font2.variant,
	                        // widths of characters
	                        width: {},
	                        // kernin pairs offsets
	                        kerning: {},
	                        metrics: metrics(family, {
	                          origin: "top",
	                          fontSize: GlText.baseFontSize,
	                          fontStyle: style.join(" ")
	                        })
	                      };
	                      GlText.fonts[baseString] = this$1$1.font[i2];
	                    }
	                  }
	                });
	              }
	              if (newFont || newFontSize) {
	                this.font.forEach(function(font2, i2) {
	                  var fontString = Font.stringify({
	                    size: this$1$1.fontSize[i2],
	                    family: font2.family,
	                    stretch: isStretchSupported ? font2.stretch : undefined,
	                    variant: font2.variant,
	                    weight: font2.weight,
	                    style: font2.style
	                  });
	                  this$1$1.fontAtlas[i2] = this$1$1.shader.atlas[fontString];
	                  if (!this$1$1.fontAtlas[i2]) {
	                    var metrics2 = font2.metrics;
	                    this$1$1.shader.atlas[fontString] = this$1$1.fontAtlas[i2] = {
	                      fontString,
	                      // even step is better for rendered characters
	                      step: Math.ceil(this$1$1.fontSize[i2] * metrics2.bottom * 0.5) * 2,
	                      em: this$1$1.fontSize[i2],
	                      cols: 0,
	                      rows: 0,
	                      height: 0,
	                      width: 0,
	                      chars: [],
	                      ids: {},
	                      texture: this$1$1.regl.texture()
	                    };
	                  }
	                  if (o.text == null) {
	                    o.text = this$1$1.text;
	                  }
	                });
	              }
	              if (typeof o.text === "string" && o.position && o.position.length > 2) {
	                var textArray = Array(o.position.length * 0.5);
	                for (var i = 0; i < textArray.length; i++) {
	                  textArray[i] = o.text;
	                }
	                o.text = textArray;
	              }
	              var newAtlasChars;
	              if (o.text != null || newFont) {
	                this.textOffsets = [0];
	                if (Array.isArray(o.text)) {
	                  this.count = o.text[0].length;
	                  this.counts = [this.count];
	                  for (var i$1 = 1; i$1 < o.text.length; i$1++) {
	                    this.textOffsets[i$1] = this.textOffsets[i$1 - 1] + o.text[i$1 - 1].length;
	                    this.count += o.text[i$1].length;
	                    this.counts.push(o.text[i$1].length);
	                  }
	                  this.text = o.text.join("");
	                } else {
	                  this.text = o.text;
	                  this.count = this.text.length;
	                  this.counts = [this.count];
	                }
	                newAtlasChars = [];
	                this.font.forEach(function(font2, idx) {
	                  GlText.atlasContext.font = font2.baseString;
	                  var atlas2 = this$1$1.fontAtlas[idx];
	                  for (var i2 = 0; i2 < this$1$1.text.length; i2++) {
	                    var char2 = this$1$1.text.charAt(i2);
	                    if (atlas2.ids[char2] == null) {
	                      atlas2.ids[char2] = atlas2.chars.length;
	                      atlas2.chars.push(char2);
	                      newAtlasChars.push(char2);
	                    }
	                    if (font2.width[char2] == null) {
	                      font2.width[char2] = GlText.atlasContext.measureText(char2).width / GlText.baseFontSize;
	                      if (this$1$1.kerning) {
	                        var pairs = [];
	                        for (var baseChar in font2.width) {
	                          pairs.push(baseChar + char2, char2 + baseChar);
	                        }
	                        extend(font2.kerning, kerning(font2.family, {
	                          pairs
	                        }));
	                      }
	                    }
	                  }
	                });
	              }
	              if (o.position) {
	                if (o.position.length > 2) {
	                  var flat = !o.position[0].length;
	                  var positionData = pool.mallocFloat(this.count * 2);
	                  for (var i$2 = 0, ptr = 0; i$2 < this.counts.length; i$2++) {
	                    var count = this.counts[i$2];
	                    if (flat) {
	                      for (var j = 0; j < count; j++) {
	                        positionData[ptr++] = o.position[i$2 * 2];
	                        positionData[ptr++] = o.position[i$2 * 2 + 1];
	                      }
	                    } else {
	                      for (var j$1 = 0; j$1 < count; j$1++) {
	                        positionData[ptr++] = o.position[i$2][0];
	                        positionData[ptr++] = o.position[i$2][1];
	                      }
	                    }
	                  }
	                  if (this.position.call) {
	                    this.position({
	                      type: "float",
	                      data: positionData
	                    });
	                  } else {
	                    this.position = this.regl.buffer({
	                      type: "float",
	                      data: positionData
	                    });
	                  }
	                  pool.freeFloat(positionData);
	                } else {
	                  if (this.position.destroy) {
	                    this.position.destroy();
	                  }
	                  this.position = {
	                    constant: o.position
	                  };
	                }
	              }
	              if (o.text || newFont) {
	                var charIds = pool.mallocUint8(this.count);
	                var sizeData = pool.mallocFloat(this.count * 2);
	                this.textWidth = [];
	                for (var i$3 = 0, ptr$1 = 0; i$3 < this.counts.length; i$3++) {
	                  var count$1 = this.counts[i$3];
	                  var font = this.font[i$3] || this.font[0];
	                  var atlas = this.fontAtlas[i$3] || this.fontAtlas[0];
	                  for (var j$2 = 0; j$2 < count$1; j$2++) {
	                    var char = this.text.charAt(ptr$1);
	                    var prevChar = this.text.charAt(ptr$1 - 1);
	                    charIds[ptr$1] = atlas.ids[char];
	                    sizeData[ptr$1 * 2] = font.width[char];
	                    if (j$2) {
	                      var prevWidth = sizeData[ptr$1 * 2 - 2];
	                      var currWidth = sizeData[ptr$1 * 2];
	                      var prevOffset = sizeData[ptr$1 * 2 - 1];
	                      var offset = prevOffset + prevWidth * 0.5 + currWidth * 0.5;
	                      if (this.kerning) {
	                        var kerning$1 = font.kerning[prevChar + char];
	                        if (kerning$1) {
	                          offset += kerning$1 * 1e-3;
	                        }
	                      }
	                      sizeData[ptr$1 * 2 + 1] = offset;
	                    } else {
	                      sizeData[ptr$1 * 2 + 1] = sizeData[ptr$1 * 2] * 0.5;
	                    }
	                    ptr$1++;
	                  }
	                  this.textWidth.push(
	                    !sizeData.length ? 0 : (
	                      // last offset + half last width
	                      sizeData[ptr$1 * 2 - 2] * 0.5 + sizeData[ptr$1 * 2 - 1]
	                    )
	                  );
	                }
	                if (!o.align) {
	                  o.align = this.align;
	                }
	                this.charBuffer({ data: charIds, type: "uint8", usage: "stream" });
	                this.sizeBuffer({ data: sizeData, type: "float", usage: "stream" });
	                pool.freeUint8(charIds);
	                pool.freeFloat(sizeData);
	                if (newAtlasChars.length) {
	                  this.font.forEach(function(font2, i2) {
	                    var atlas2 = this$1$1.fontAtlas[i2];
	                    var step = atlas2.step;
	                    var maxCols = Math.floor(GlText.maxAtlasSize / step);
	                    var cols = Math.min(maxCols, atlas2.chars.length);
	                    var rows = Math.ceil(atlas2.chars.length / cols);
	                    var atlasWidth = nextPow2(cols * step);
	                    var atlasHeight = nextPow2(rows * step);
	                    atlas2.width = atlasWidth;
	                    atlas2.height = atlasHeight;
	                    atlas2.rows = rows;
	                    atlas2.cols = cols;
	                    if (!atlas2.em) {
	                      return;
	                    }
	                    atlas2.texture({
	                      data: fontAtlas({
	                        canvas: GlText.atlasCanvas,
	                        font: atlas2.fontString,
	                        chars: atlas2.chars,
	                        shape: [atlasWidth, atlasHeight],
	                        step: [step, step]
	                      })
	                    });
	                  });
	                }
	              }
	              if (o.align) {
	                this.align = o.align;
	                this.alignOffset = this.textWidth.map(function(textWidth, i2) {
	                  var align = !Array.isArray(this$1$1.align) ? this$1$1.align : this$1$1.align.length > 1 ? this$1$1.align[i2] : this$1$1.align[0];
	                  if (typeof align === "number") {
	                    return align;
	                  }
	                  switch (align) {
	                    case "right":
	                    case "end":
	                      return -textWidth;
	                    case "center":
	                    case "centre":
	                    case "middle":
	                      return -textWidth * 0.5;
	                  }
	                  return 0;
	                });
	              }
	              if (this.baseline == null && o.baseline == null) {
	                o.baseline = 0;
	              }
	              if (o.baseline != null) {
	                this.baseline = o.baseline;
	                if (!Array.isArray(this.baseline)) {
	                  this.baseline = [this.baseline];
	                }
	                this.baselineOffset = this.baseline.map(function(baseline, i2) {
	                  var m = (this$1$1.font[i2] || this$1$1.font[0]).metrics;
	                  var base = 0;
	                  base += m.bottom * 0.5;
	                  if (typeof baseline === "number") {
	                    base += baseline - m.baseline;
	                  } else {
	                    base += -m[baseline];
	                  }
	                  base *= -1;
	                  return base;
	                });
	              }
	              if (o.color != null) {
	                if (!o.color) {
	                  o.color = "transparent";
	                }
	                if (typeof o.color === "string" || !isNaN(o.color)) {
	                  this.color = rgba(o.color, "uint8");
	                } else {
	                  var colorData;
	                  if (typeof o.color[0] === "number" && o.color.length > this.counts.length) {
	                    var l = o.color.length;
	                    colorData = pool.mallocUint8(l);
	                    var sub = (o.color.subarray || o.color.slice).bind(o.color);
	                    for (var i$4 = 0; i$4 < l; i$4 += 4) {
	                      colorData.set(rgba(sub(i$4, i$4 + 4), "uint8"), i$4);
	                    }
	                  } else {
	                    var l$1 = o.color.length;
	                    colorData = pool.mallocUint8(l$1 * 4);
	                    for (var i$5 = 0; i$5 < l$1; i$5++) {
	                      colorData.set(rgba(o.color[i$5] || 0, "uint8"), i$5 * 4);
	                    }
	                  }
	                  this.color = colorData;
	                }
	              }
	              if (o.position || o.text || o.color || o.baseline || o.align || o.font || o.offset || o.opacity) {
	                var isBatch = this.color.length > 4 || this.baselineOffset.length > 1 || this.align && this.align.length > 1 || this.fontAtlas.length > 1 || this.positionOffset.length > 2;
	                if (isBatch) {
	                  var length = Math.max(
	                    this.position.length * 0.5 || 0,
	                    this.color.length * 0.25 || 0,
	                    this.baselineOffset.length || 0,
	                    this.alignOffset.length || 0,
	                    this.font.length || 0,
	                    this.opacity.length || 0,
	                    this.positionOffset.length * 0.5 || 0
	                  );
	                  this.batch = Array(length);
	                  for (var i$6 = 0; i$6 < this.batch.length; i$6++) {
	                    this.batch[i$6] = {
	                      count: this.counts.length > 1 ? this.counts[i$6] : this.counts[0],
	                      offset: this.textOffsets.length > 1 ? this.textOffsets[i$6] : this.textOffsets[0],
	                      color: !this.color ? [0, 0, 0, 255] : this.color.length <= 4 ? this.color : this.color.subarray(i$6 * 4, i$6 * 4 + 4),
	                      opacity: Array.isArray(this.opacity) ? this.opacity[i$6] : this.opacity,
	                      baseline: this.baselineOffset[i$6] != null ? this.baselineOffset[i$6] : this.baselineOffset[0],
	                      align: !this.align ? 0 : this.alignOffset[i$6] != null ? this.alignOffset[i$6] : this.alignOffset[0],
	                      atlas: this.fontAtlas[i$6] || this.fontAtlas[0],
	                      positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(i$6 * 2, i$6 * 2 + 2) : this.positionOffset
	                    };
	                  }
	                } else {
	                  if (this.count) {
	                    this.batch = [{
	                      count: this.count,
	                      offset: 0,
	                      color: this.color || [0, 0, 0, 255],
	                      opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
	                      baseline: this.baselineOffset[0],
	                      align: this.alignOffset ? this.alignOffset[0] : 0,
	                      atlas: this.fontAtlas[0],
	                      positionOffset: this.positionOffset
	                    }];
	                  } else {
	                    this.batch = [];
	                  }
	                }
	              }
	            };
	            GlText.prototype.destroy = function destroy() {
	            };
	            GlText.prototype.kerning = true;
	            GlText.prototype.position = { constant: new Float32Array(2) };
	            GlText.prototype.translate = null;
	            GlText.prototype.scale = null;
	            GlText.prototype.font = null;
	            GlText.prototype.text = "";
	            GlText.prototype.positionOffset = [0, 0];
	            GlText.prototype.opacity = 1;
	            GlText.prototype.color = new Uint8Array([0, 0, 0, 255]);
	            GlText.prototype.alignOffset = [0, 0];
	            GlText.maxAtlasSize = 1024;
	            GlText.atlasCanvas = document.createElement("canvas");
	            GlText.atlasContext = GlText.atlasCanvas.getContext("2d", { alpha: false });
	            GlText.baseFontSize = 64;
	            GlText.fonts = {};
	            function isRegl(o) {
	              return typeof o === "function" && o._gl && o.prop && o.texture && o.buffer;
	            }
	            module2.exports = GlText;
	          }
	        ),
	        /***/
	        12018: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var pick = __webpack_require__2(71299);
	            module2.exports = function setContext(o) {
	              if (!o) o = {};
	              else if (typeof o === "string") o = { container: o };
	              if (isCanvas(o)) {
	                o = { container: o };
	              } else if (isElement(o)) {
	                o = { container: o };
	              } else if (isContext(o)) {
	                o = { gl: o };
	              } else {
	                o = pick(o, {
	                  container: "container target element el canvas holder parent parentNode wrapper use ref root node",
	                  gl: "gl context webgl glContext",
	                  attrs: "attributes attrs contextAttributes",
	                  pixelRatio: "pixelRatio pxRatio px ratio pxratio pixelratio",
	                  width: "w width",
	                  height: "h height"
	                }, true);
	              }
	              if (!o.pixelRatio) o.pixelRatio = __webpack_require__2.g.pixelRatio || 1;
	              if (o.gl) {
	                return o.gl;
	              }
	              if (o.canvas) {
	                o.container = o.canvas.parentNode;
	              }
	              if (o.container) {
	                if (typeof o.container === "string") {
	                  var c = document.querySelector(o.container);
	                  if (!c) throw Error("Element " + o.container + " is not found");
	                  o.container = c;
	                }
	                if (isCanvas(o.container)) {
	                  o.canvas = o.container;
	                  o.container = o.canvas.parentNode;
	                } else if (!o.canvas) {
	                  o.canvas = createCanvas();
	                  o.container.appendChild(o.canvas);
	                  resize(o);
	                }
	              } else if (!o.canvas) {
	                if (typeof document !== "undefined") {
	                  o.container = document.body || document.documentElement;
	                  o.canvas = createCanvas();
	                  o.container.appendChild(o.canvas);
	                  resize(o);
	                } else {
	                  throw Error("Not DOM environment. Use headless-gl.");
	                }
	              }
	              if (!o.gl) {
	                ["webgl", "experimental-webgl", "webgl-experimental"].some(function(c2) {
	                  try {
	                    o.gl = o.canvas.getContext(c2, o.attrs);
	                  } catch (e) {
	                  }
	                  return o.gl;
	                });
	              }
	              return o.gl;
	            };
	            function resize(o) {
	              if (o.container) {
	                if (o.container == document.body) {
	                  if (!document.body.style.width) o.canvas.width = o.width || o.pixelRatio * __webpack_require__2.g.innerWidth;
	                  if (!document.body.style.height) o.canvas.height = o.height || o.pixelRatio * __webpack_require__2.g.innerHeight;
	                } else {
	                  var bounds = o.container.getBoundingClientRect();
	                  o.canvas.width = o.width || bounds.right - bounds.left;
	                  o.canvas.height = o.height || bounds.bottom - bounds.top;
	                }
	              }
	            }
	            function isCanvas(e) {
	              return typeof e.getContext === "function" && "width" in e && "height" in e;
	            }
	            function isElement(e) {
	              return typeof e.nodeName === "string" && typeof e.appendChild === "function" && typeof e.getBoundingClientRect === "function";
	            }
	            function isContext(e) {
	              return typeof e.drawArrays === "function" || typeof e.drawElements === "function";
	            }
	            function createCanvas() {
	              var canvas = document.createElement("canvas");
	              canvas.style.position = "absolute";
	              canvas.style.top = 0;
	              canvas.style.left = 0;
	              return canvas;
	            }
	          }
	        ),
	        /***/
	        56068: (
	          /***/
	          function(module2) {
	            module2.exports = function(strings) {
	              if (typeof strings === "string") strings = [strings];
	              var exprs = [].slice.call(arguments, 1);
	              var parts = [];
	              for (var i = 0; i < strings.length - 1; i++) {
	                parts.push(strings[i], exprs[i] || "");
	              }
	              parts.push(strings[i]);
	              return parts.join("");
	            };
	          }
	        ),
	        /***/
	        40383: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var GetIntrinsic = __webpack_require__2(68318);
	            var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
	            if ($gOPD) {
	              try {
	                $gOPD([], "length");
	              } catch (e) {
	                $gOPD = null;
	              }
	            }
	            module2.exports = $gOPD;
	          }
	        ),
	        /***/
	        57035: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isBrowser = __webpack_require__2(54404);
	            var hasHover;
	            if (typeof __webpack_require__2.g.matchMedia === "function") {
	              hasHover = !__webpack_require__2.g.matchMedia("(hover: none)").matches;
	            } else {
	              hasHover = isBrowser;
	            }
	            module2.exports = hasHover;
	          }
	        ),
	        /***/
	        38520: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isBrowser = __webpack_require__2(54404);
	            function detect() {
	              var supported = false;
	              try {
	                var opts = Object.defineProperty({}, "passive", {
	                  get: function() {
	                    supported = true;
	                  }
	                });
	                window.addEventListener("test", null, opts);
	                window.removeEventListener("test", null, opts);
	              } catch (e) {
	                supported = false;
	              }
	              return supported;
	            }
	            module2.exports = isBrowser && detect();
	          }
	        ),
	        /***/
	        55622: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var GetIntrinsic = __webpack_require__2(68318);
	            var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
	            var hasPropertyDescriptors = function hasPropertyDescriptors2() {
	              if ($defineProperty) {
	                try {
	                  $defineProperty({}, "a", { value: 1 });
	                  return true;
	                } catch (e) {
	                  return false;
	                }
	              }
	              return false;
	            };
	            hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	              if (!hasPropertyDescriptors()) {
	                return null;
	              }
	              try {
	                return $defineProperty([], "length", { value: 1 }).length !== 1;
	              } catch (e) {
	                return true;
	              }
	            };
	            module2.exports = hasPropertyDescriptors;
	          }
	        ),
	        /***/
	        57877: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var origSymbol = typeof Symbol !== "undefined" && Symbol;
	            var hasSymbolSham = __webpack_require__2(35638);
	            module2.exports = function hasNativeSymbols() {
	              if (typeof origSymbol !== "function") {
	                return false;
	              }
	              if (typeof Symbol !== "function") {
	                return false;
	              }
	              if (typeof origSymbol("foo") !== "symbol") {
	                return false;
	              }
	              if (typeof Symbol("bar") !== "symbol") {
	                return false;
	              }
	              return hasSymbolSham();
	            };
	          }
	        ),
	        /***/
	        35638: (
	          /***/
	          function(module2) {
	            module2.exports = function hasSymbols() {
	              if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
	                return false;
	              }
	              if (typeof Symbol.iterator === "symbol") {
	                return true;
	              }
	              var obj = {};
	              var sym = Symbol("test");
	              var symObj = Object(sym);
	              if (typeof sym === "string") {
	                return false;
	              }
	              if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
	                return false;
	              }
	              if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
	                return false;
	              }
	              var symVal = 42;
	              obj[sym] = symVal;
	              for (sym in obj) {
	                return false;
	              }
	              if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
	                return false;
	              }
	              if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
	                return false;
	              }
	              var syms = Object.getOwnPropertySymbols(obj);
	              if (syms.length !== 1 || syms[0] !== sym) {
	                return false;
	              }
	              if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
	                return false;
	              }
	              if (typeof Object.getOwnPropertyDescriptor === "function") {
	                var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
	                if (descriptor.value !== symVal || descriptor.enumerable !== true) {
	                  return false;
	                }
	              }
	              return true;
	            };
	          }
	        ),
	        /***/
	        84543: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hasSymbols = __webpack_require__2(35638);
	            module2.exports = function hasToStringTagShams() {
	              return hasSymbols() && !!Symbol.toStringTag;
	            };
	          }
	        ),
	        /***/
	        35065: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var bind = __webpack_require__2(77575);
	            module2.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
	          }
	        ),
	        /***/
	        95280: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	            exports2.read = function(buffer, offset, isLE, mLen, nBytes) {
	              var e, m;
	              var eLen = nBytes * 8 - mLen - 1;
	              var eMax = (1 << eLen) - 1;
	              var eBias = eMax >> 1;
	              var nBits = -7;
	              var i = isLE ? nBytes - 1 : 0;
	              var d = isLE ? -1 : 1;
	              var s = buffer[offset + i];
	              i += d;
	              e = s & (1 << -nBits) - 1;
	              s >>= -nBits;
	              nBits += eLen;
	              for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
	              }
	              m = e & (1 << -nBits) - 1;
	              e >>= -nBits;
	              nBits += mLen;
	              for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
	              }
	              if (e === 0) {
	                e = 1 - eBias;
	              } else if (e === eMax) {
	                return m ? NaN : (s ? -1 : 1) * Infinity;
	              } else {
	                m = m + Math.pow(2, mLen);
	                e = e - eBias;
	              }
	              return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	            };
	            exports2.write = function(buffer, value, offset, isLE, mLen, nBytes) {
	              var e, m, c;
	              var eLen = nBytes * 8 - mLen - 1;
	              var eMax = (1 << eLen) - 1;
	              var eBias = eMax >> 1;
	              var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	              var i = isLE ? 0 : nBytes - 1;
	              var d = isLE ? 1 : -1;
	              var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	              value = Math.abs(value);
	              if (isNaN(value) || value === Infinity) {
	                m = isNaN(value) ? 1 : 0;
	                e = eMax;
	              } else {
	                e = Math.floor(Math.log(value) / Math.LN2);
	                if (value * (c = Math.pow(2, -e)) < 1) {
	                  e--;
	                  c *= 2;
	                }
	                if (e + eBias >= 1) {
	                  value += rt / c;
	                } else {
	                  value += rt * Math.pow(2, 1 - eBias);
	                }
	                if (value * c >= 2) {
	                  e++;
	                  c /= 2;
	                }
	                if (e + eBias >= eMax) {
	                  m = 0;
	                  e = eMax;
	                } else if (e + eBias >= 1) {
	                  m = (value * c - 1) * Math.pow(2, mLen);
	                  e = e + eBias;
	                } else {
	                  m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	                  e = 0;
	                }
	              }
	              for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
	              }
	              e = e << mLen | m;
	              eLen += mLen;
	              for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
	              }
	              buffer[offset + i - d] |= s * 128;
	            };
	          }
	        ),
	        /***/
	        42018: (
	          /***/
	          function(module2) {
	            if (typeof Object.create === "function") {
	              module2.exports = function inherits(ctor, superCtor) {
	                if (superCtor) {
	                  ctor.super_ = superCtor;
	                  ctor.prototype = Object.create(superCtor.prototype, {
	                    constructor: {
	                      value: ctor,
	                      enumerable: false,
	                      writable: true,
	                      configurable: true
	                    }
	                  });
	                }
	              };
	            } else {
	              module2.exports = function inherits(ctor, superCtor) {
	                if (superCtor) {
	                  ctor.super_ = superCtor;
	                  var TempCtor = function() {
	                  };
	                  TempCtor.prototype = superCtor.prototype;
	                  ctor.prototype = new TempCtor();
	                  ctor.prototype.constructor = ctor;
	                }
	              };
	            }
	          }
	        ),
	        /***/
	        47216: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var hasToStringTag = __webpack_require__2(84543)();
	            var callBound = __webpack_require__2(6614);
	            var $toString = callBound("Object.prototype.toString");
	            var isStandardArguments = function isArguments(value) {
	              if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) {
	                return false;
	              }
	              return $toString(value) === "[object Arguments]";
	            };
	            var isLegacyArguments = function isArguments(value) {
	              if (isStandardArguments(value)) {
	                return true;
	              }
	              return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
	            };
	            var supportsStandardArguments = function() {
	              return isStandardArguments(arguments);
	            }();
	            isStandardArguments.isLegacyArguments = isLegacyArguments;
	            module2.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
	          }
	        ),
	        /***/
	        54404: (
	          /***/
	          function(module2) {
	            module2.exports = true;
	          }
	        ),
	        /***/
	        85395: (
	          /***/
	          function(module2) {
	            var fnToStr = Function.prototype.toString;
	            var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
	            var badArrayLike;
	            var isCallableMarker;
	            if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") {
	              try {
	                badArrayLike = Object.defineProperty({}, "length", {
	                  get: function() {
	                    throw isCallableMarker;
	                  }
	                });
	                isCallableMarker = {};
	                reflectApply(function() {
	                  throw 42;
	                }, null, badArrayLike);
	              } catch (_) {
	                if (_ !== isCallableMarker) {
	                  reflectApply = null;
	                }
	              }
	            } else {
	              reflectApply = null;
	            }
	            var constructorRegex = /^\s*class\b/;
	            var isES6ClassFn = function isES6ClassFunction(value) {
	              try {
	                var fnStr = fnToStr.call(value);
	                return constructorRegex.test(fnStr);
	              } catch (e) {
	                return false;
	              }
	            };
	            var tryFunctionObject = function tryFunctionToStr(value) {
	              try {
	                if (isES6ClassFn(value)) {
	                  return false;
	                }
	                fnToStr.call(value);
	                return true;
	              } catch (e) {
	                return false;
	              }
	            };
	            var toStr = Object.prototype.toString;
	            var objectClass = "[object Object]";
	            var fnClass = "[object Function]";
	            var genClass = "[object GeneratorFunction]";
	            var ddaClass = "[object HTMLAllCollection]";
	            var ddaClass2 = "[object HTML document.all class]";
	            var ddaClass3 = "[object HTMLCollection]";
	            var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
	            var isIE68 = !(0 in [,]);
	            var isDDA = function isDocumentDotAll() {
	              return false;
	            };
	            if (typeof document === "object") {
	              var all = document.all;
	              if (toStr.call(all) === toStr.call(document.all)) {
	                isDDA = function isDocumentDotAll(value) {
	                  if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
	                    try {
	                      var str = toStr.call(value);
	                      return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
	                    } catch (e) {
	                    }
	                  }
	                  return false;
	                };
	              }
	            }
	            module2.exports = reflectApply ? function isCallable(value) {
	              if (isDDA(value)) {
	                return true;
	              }
	              if (!value) {
	                return false;
	              }
	              if (typeof value !== "function" && typeof value !== "object") {
	                return false;
	              }
	              try {
	                reflectApply(value, null, badArrayLike);
	              } catch (e) {
	                if (e !== isCallableMarker) {
	                  return false;
	                }
	              }
	              return !isES6ClassFn(value) && tryFunctionObject(value);
	            } : function isCallable(value) {
	              if (isDDA(value)) {
	                return true;
	              }
	              if (!value) {
	                return false;
	              }
	              if (typeof value !== "function" && typeof value !== "object") {
	                return false;
	              }
	              if (hasToStringTag) {
	                return tryFunctionObject(value);
	              }
	              if (isES6ClassFn(value)) {
	                return false;
	              }
	              var strClass = toStr.call(value);
	              if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
	                return false;
	              }
	              return tryFunctionObject(value);
	            };
	          }
	        ),
	        /***/
	        65481: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var toStr = Object.prototype.toString;
	            var fnToStr = Function.prototype.toString;
	            var isFnRegex = /^\s*(?:function)?\*/;
	            var hasToStringTag = __webpack_require__2(84543)();
	            var getProto = Object.getPrototypeOf;
	            var getGeneratorFunc = function() {
	              if (!hasToStringTag) {
	                return false;
	              }
	              try {
	                return Function("return function*() {}")();
	              } catch (e) {
	              }
	            };
	            var GeneratorFunction;
	            module2.exports = function isGeneratorFunction(fn) {
	              if (typeof fn !== "function") {
	                return false;
	              }
	              if (isFnRegex.test(fnToStr.call(fn))) {
	                return true;
	              }
	              if (!hasToStringTag) {
	                var str = toStr.call(fn);
	                return str === "[object GeneratorFunction]";
	              }
	              if (!getProto) {
	                return false;
	              }
	              if (typeof GeneratorFunction === "undefined") {
	                var generatorFunc = getGeneratorFunc();
	                GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	              }
	              return getProto(fn) === GeneratorFunction;
	            };
	          }
	        ),
	        /***/
	        62683: (
	          /***/
	          function(module2) {
	            module2.exports = typeof navigator !== "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
	          }
	        ),
	        /***/
	        64274: (
	          /***/
	          function(module2) {
	            module2.exports = function isNaN2(value) {
	              return value !== value;
	            };
	          }
	        ),
	        /***/
	        15567: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var callBind = __webpack_require__2(68222);
	            var define2 = __webpack_require__2(17045);
	            var implementation = __webpack_require__2(64274);
	            var getPolyfill = __webpack_require__2(14922);
	            var shim = __webpack_require__2(22442);
	            var polyfill = callBind(getPolyfill(), Number);
	            define2(polyfill, {
	              getPolyfill,
	              implementation,
	              shim
	            });
	            module2.exports = polyfill;
	          }
	        ),
	        /***/
	        14922: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var implementation = __webpack_require__2(64274);
	            module2.exports = function getPolyfill() {
	              if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) {
	                return Number.isNaN;
	              }
	              return implementation;
	            };
	          }
	        ),
	        /***/
	        22442: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var define2 = __webpack_require__2(17045);
	            var getPolyfill = __webpack_require__2(14922);
	            module2.exports = function shimNumberIsNaN() {
	              var polyfill = getPolyfill();
	              define2(Number, { isNaN: polyfill }, {
	                isNaN: function testIsNaN() {
	                  return Number.isNaN !== polyfill;
	                }
	              });
	              return polyfill;
	            };
	          }
	        ),
	        /***/
	        64941: (
	          /***/
	          function(module2) {
	            module2.exports = function(x) {
	              var type = typeof x;
	              return x !== null && (type === "object" || type === "function");
	            };
	          }
	        ),
	        /***/
	        10973: (
	          /***/
	          function(module2) {
	            var toString = Object.prototype.toString;
	            module2.exports = function(x) {
	              var prototype;
	              return toString.call(x) === "[object Object]" && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	            };
	          }
	        ),
	        /***/
	        18546: (
	          /***/
	          function(module2) {
	            module2.exports = function(str) {
	              var l = str.length, a;
	              for (var i = 0; i < l; i++) {
	                a = str.charCodeAt(i);
	                if ((a < 9 || a > 13) && a !== 32 && a !== 133 && a !== 160 && a !== 5760 && a !== 6158 && (a < 8192 || a > 8205) && a !== 8232 && a !== 8233 && a !== 8239 && a !== 8287 && a !== 8288 && a !== 12288 && a !== 65279) {
	                  return false;
	                }
	              }
	              return true;
	            };
	          }
	        ),
	        /***/
	        89546: (
	          /***/
	          function(module2) {
	            module2.exports = function isPath(str) {
	              if (typeof str !== "string") return false;
	              str = str.trim();
	              if (/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(str) && /[\dz]$/i.test(str) && str.length > 4) return true;
	              return false;
	            };
	          }
	        ),
	        /***/
	        9187: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var forEach = __webpack_require__2(31353);
	            var availableTypedArrays = __webpack_require__2(72077);
	            var callBound = __webpack_require__2(6614);
	            var $toString = callBound("Object.prototype.toString");
	            var hasToStringTag = __webpack_require__2(84543)();
	            var gOPD = __webpack_require__2(40383);
	            var g = typeof globalThis === "undefined" ? __webpack_require__2.g : globalThis;
	            var typedArrays = availableTypedArrays();
	            var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf(array, value) {
	              for (var i = 0; i < array.length; i += 1) {
	                if (array[i] === value) {
	                  return i;
	                }
	              }
	              return -1;
	            };
	            var $slice = callBound("String.prototype.slice");
	            var toStrTags = {};
	            var getPrototypeOf = Object.getPrototypeOf;
	            if (hasToStringTag && gOPD && getPrototypeOf) {
	              forEach(typedArrays, function(typedArray) {
	                var arr = new g[typedArray]();
	                if (Symbol.toStringTag in arr) {
	                  var proto = getPrototypeOf(arr);
	                  var descriptor = gOPD(proto, Symbol.toStringTag);
	                  if (!descriptor) {
	                    var superProto = getPrototypeOf(proto);
	                    descriptor = gOPD(superProto, Symbol.toStringTag);
	                  }
	                  toStrTags[typedArray] = descriptor.get;
	                }
	              });
	            }
	            var tryTypedArrays = function tryAllTypedArrays(value) {
	              var anyTrue = false;
	              forEach(toStrTags, function(getter, typedArray) {
	                if (!anyTrue) {
	                  try {
	                    anyTrue = getter.call(value) === typedArray;
	                  } catch (e) {
	                  }
	                }
	              });
	              return anyTrue;
	            };
	            module2.exports = function isTypedArray(value) {
	              if (!value || typeof value !== "object") {
	                return false;
	              }
	              if (!hasToStringTag || !(Symbol.toStringTag in value)) {
	                var tag = $slice($toString(value), 8, -1);
	                return $indexOf(typedArrays, tag) > -1;
	              }
	              if (!gOPD) {
	                return false;
	              }
	              return tryTypedArrays(value);
	            };
	          }
	        ),
	        /***/
	        44517: (
	          /***/
	          function(module2) {
	            (function(global, factory) {
	              module2.exports = factory() ;
	            })(this, function() {
	              var shared, worker, mapboxgl;
	              function define2(_, chunk) {
	                if (!shared) {
	                  shared = chunk;
	                } else if (!worker) {
	                  worker = chunk;
	                } else {
	                  var workerBundleString = "var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk);";
	                  var sharedChunk = {};
	                  shared(sharedChunk);
	                  mapboxgl = chunk(sharedChunk);
	                  mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: "text/javascript" }));
	                }
	              }
	              define2(["exports"], function(exports2) {
	                function createCommonjsModule(fn, module3) {
	                  return module3 = { exports: {} }, fn(module3, module3.exports), module3.exports;
	                }
	                var version = "1.10.1";
	                var unitbezier = UnitBezier;
	                function UnitBezier(p1x, p1y, p2x, p2y) {
	                  this.cx = 3 * p1x;
	                  this.bx = 3 * (p2x - p1x) - this.cx;
	                  this.ax = 1 - this.cx - this.bx;
	                  this.cy = 3 * p1y;
	                  this.by = 3 * (p2y - p1y) - this.cy;
	                  this.ay = 1 - this.cy - this.by;
	                  this.p1x = p1x;
	                  this.p1y = p2y;
	                  this.p2x = p2x;
	                  this.p2y = p2y;
	                }
	                UnitBezier.prototype.sampleCurveX = function(t) {
	                  return ((this.ax * t + this.bx) * t + this.cx) * t;
	                };
	                UnitBezier.prototype.sampleCurveY = function(t) {
	                  return ((this.ay * t + this.by) * t + this.cy) * t;
	                };
	                UnitBezier.prototype.sampleCurveDerivativeX = function(t) {
	                  return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
	                };
	                UnitBezier.prototype.solveCurveX = function(x, epsilon) {
	                  if (typeof epsilon === "undefined") {
	                    epsilon = 1e-6;
	                  }
	                  var t02, t12, t22, x2, i;
	                  for (t22 = x, i = 0; i < 8; i++) {
	                    x2 = this.sampleCurveX(t22) - x;
	                    if (Math.abs(x2) < epsilon) {
	                      return t22;
	                    }
	                    var d2 = this.sampleCurveDerivativeX(t22);
	                    if (Math.abs(d2) < 1e-6) {
	                      break;
	                    }
	                    t22 = t22 - x2 / d2;
	                  }
	                  t02 = 0;
	                  t12 = 1;
	                  t22 = x;
	                  if (t22 < t02) {
	                    return t02;
	                  }
	                  if (t22 > t12) {
	                    return t12;
	                  }
	                  while (t02 < t12) {
	                    x2 = this.sampleCurveX(t22);
	                    if (Math.abs(x2 - x) < epsilon) {
	                      return t22;
	                    }
	                    if (x > x2) {
	                      t02 = t22;
	                    } else {
	                      t12 = t22;
	                    }
	                    t22 = (t12 - t02) * 0.5 + t02;
	                  }
	                  return t22;
	                };
	                UnitBezier.prototype.solve = function(x, epsilon) {
	                  return this.sampleCurveY(this.solveCurveX(x, epsilon));
	                };
	                var pointGeometry = Point;
	                function Point(x, y) {
	                  this.x = x;
	                  this.y = y;
	                }
	                Point.prototype = {
	                  clone: function() {
	                    return new Point(this.x, this.y);
	                  },
	                  add: function(p) {
	                    return this.clone()._add(p);
	                  },
	                  sub: function(p) {
	                    return this.clone()._sub(p);
	                  },
	                  multByPoint: function(p) {
	                    return this.clone()._multByPoint(p);
	                  },
	                  divByPoint: function(p) {
	                    return this.clone()._divByPoint(p);
	                  },
	                  mult: function(k) {
	                    return this.clone()._mult(k);
	                  },
	                  div: function(k) {
	                    return this.clone()._div(k);
	                  },
	                  rotate: function(a) {
	                    return this.clone()._rotate(a);
	                  },
	                  rotateAround: function(a, p) {
	                    return this.clone()._rotateAround(a, p);
	                  },
	                  matMult: function(m) {
	                    return this.clone()._matMult(m);
	                  },
	                  unit: function() {
	                    return this.clone()._unit();
	                  },
	                  perp: function() {
	                    return this.clone()._perp();
	                  },
	                  round: function() {
	                    return this.clone()._round();
	                  },
	                  mag: function() {
	                    return Math.sqrt(this.x * this.x + this.y * this.y);
	                  },
	                  equals: function(other) {
	                    return this.x === other.x && this.y === other.y;
	                  },
	                  dist: function(p) {
	                    return Math.sqrt(this.distSqr(p));
	                  },
	                  distSqr: function(p) {
	                    var dx = p.x - this.x, dy = p.y - this.y;
	                    return dx * dx + dy * dy;
	                  },
	                  angle: function() {
	                    return Math.atan2(this.y, this.x);
	                  },
	                  angleTo: function(b) {
	                    return Math.atan2(this.y - b.y, this.x - b.x);
	                  },
	                  angleWith: function(b) {
	                    return this.angleWithSep(b.x, b.y);
	                  },
	                  angleWithSep: function(x, y) {
	                    return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
	                  },
	                  _matMult: function(m) {
	                    var x = m[0] * this.x + m[1] * this.y, y = m[2] * this.x + m[3] * this.y;
	                    this.x = x;
	                    this.y = y;
	                    return this;
	                  },
	                  _add: function(p) {
	                    this.x += p.x;
	                    this.y += p.y;
	                    return this;
	                  },
	                  _sub: function(p) {
	                    this.x -= p.x;
	                    this.y -= p.y;
	                    return this;
	                  },
	                  _mult: function(k) {
	                    this.x *= k;
	                    this.y *= k;
	                    return this;
	                  },
	                  _div: function(k) {
	                    this.x /= k;
	                    this.y /= k;
	                    return this;
	                  },
	                  _multByPoint: function(p) {
	                    this.x *= p.x;
	                    this.y *= p.y;
	                    return this;
	                  },
	                  _divByPoint: function(p) {
	                    this.x /= p.x;
	                    this.y /= p.y;
	                    return this;
	                  },
	                  _unit: function() {
	                    this._div(this.mag());
	                    return this;
	                  },
	                  _perp: function() {
	                    var y = this.y;
	                    this.y = this.x;
	                    this.x = -y;
	                    return this;
	                  },
	                  _rotate: function(angle) {
	                    var cos = Math.cos(angle), sin = Math.sin(angle), x = cos * this.x - sin * this.y, y = sin * this.x + cos * this.y;
	                    this.x = x;
	                    this.y = y;
	                    return this;
	                  },
	                  _rotateAround: function(angle, p) {
	                    var cos = Math.cos(angle), sin = Math.sin(angle), x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y), y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
	                    this.x = x;
	                    this.y = y;
	                    return this;
	                  },
	                  _round: function() {
	                    this.x = Math.round(this.x);
	                    this.y = Math.round(this.y);
	                    return this;
	                  }
	                };
	                Point.convert = function(a) {
	                  if (a instanceof Point) {
	                    return a;
	                  }
	                  if (Array.isArray(a)) {
	                    return new Point(a[0], a[1]);
	                  }
	                  return a;
	                };
	                function deepEqual(a, b) {
	                  if (Array.isArray(a)) {
	                    if (!Array.isArray(b) || a.length !== b.length) {
	                      return false;
	                    }
	                    for (var i = 0; i < a.length; i++) {
	                      if (!deepEqual(a[i], b[i])) {
	                        return false;
	                      }
	                    }
	                    return true;
	                  }
	                  if (typeof a === "object" && a !== null && b !== null) {
	                    if (!(typeof b === "object")) {
	                      return false;
	                    }
	                    var keys = Object.keys(a);
	                    if (keys.length !== Object.keys(b).length) {
	                      return false;
	                    }
	                    for (var key in a) {
	                      if (!deepEqual(a[key], b[key])) {
	                        return false;
	                      }
	                    }
	                    return true;
	                  }
	                  return a === b;
	                }
	                function easeCubicInOut(t) {
	                  if (t <= 0) {
	                    return 0;
	                  }
	                  if (t >= 1) {
	                    return 1;
	                  }
	                  var t22 = t * t, t32 = t22 * t;
	                  return 4 * (t < 0.5 ? t32 : 3 * (t - t22) + t32 - 0.75);
	                }
	                function bezier(p1x, p1y, p2x, p2y) {
	                  var bezier2 = new unitbezier(p1x, p1y, p2x, p2y);
	                  return function(t) {
	                    return bezier2.solve(t);
	                  };
	                }
	                var ease = bezier(0.25, 0.1, 0.25, 1);
	                function clamp(n, min, max) {
	                  return Math.min(max, Math.max(min, n));
	                }
	                function wrap(n, min, max) {
	                  var d = max - min;
	                  var w = ((n - min) % d + d) % d + min;
	                  return w === min ? max : w;
	                }
	                function asyncAll(array2, fn, callback) {
	                  if (!array2.length) {
	                    return callback(null, []);
	                  }
	                  var remaining = array2.length;
	                  var results = new Array(array2.length);
	                  var error2 = null;
	                  array2.forEach(function(item, i) {
	                    fn(item, function(err, result) {
	                      if (err) {
	                        error2 = err;
	                      }
	                      results[i] = result;
	                      if (--remaining === 0) {
	                        callback(error2, results);
	                      }
	                    });
	                  });
	                }
	                function values(obj) {
	                  var result = [];
	                  for (var k in obj) {
	                    result.push(obj[k]);
	                  }
	                  return result;
	                }
	                function keysDifference(obj, other) {
	                  var difference = [];
	                  for (var i in obj) {
	                    if (!(i in other)) {
	                      difference.push(i);
	                    }
	                  }
	                  return difference;
	                }
	                function extend(dest) {
	                  var sources2 = [], len = arguments.length - 1;
	                  while (len-- > 0)
	                    sources2[len] = arguments[len + 1];
	                  for (var i = 0, list = sources2; i < list.length; i += 1) {
	                    var src = list[i];
	                    for (var k in src) {
	                      dest[k] = src[k];
	                    }
	                  }
	                  return dest;
	                }
	                function pick(src, properties2) {
	                  var result = {};
	                  for (var i = 0; i < properties2.length; i++) {
	                    var k = properties2[i];
	                    if (k in src) {
	                      result[k] = src[k];
	                    }
	                  }
	                  return result;
	                }
	                var id = 1;
	                function uniqueId() {
	                  return id++;
	                }
	                function uuid() {
	                  function b(a) {
	                    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, b);
	                  }
	                  return b();
	                }
	                function validateUuid(str) {
	                  return str ? /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str) : false;
	                }
	                function bindAll(fns, context) {
	                  fns.forEach(function(fn) {
	                    if (!context[fn]) {
	                      return;
	                    }
	                    context[fn] = context[fn].bind(context);
	                  });
	                }
	                function endsWith(string, suffix) {
	                  return string.indexOf(suffix, string.length - suffix.length) !== -1;
	                }
	                function mapObject(input, iterator, context) {
	                  var output = {};
	                  for (var key in input) {
	                    output[key] = iterator.call(context || this, input[key], key, input);
	                  }
	                  return output;
	                }
	                function filterObject(input, iterator, context) {
	                  var output = {};
	                  for (var key in input) {
	                    if (iterator.call(context || this, input[key], key, input)) {
	                      output[key] = input[key];
	                    }
	                  }
	                  return output;
	                }
	                function clone(input) {
	                  if (Array.isArray(input)) {
	                    return input.map(clone);
	                  } else if (typeof input === "object" && input) {
	                    return mapObject(input, clone);
	                  } else {
	                    return input;
	                  }
	                }
	                function arraysIntersect(a, b) {
	                  for (var l = 0; l < a.length; l++) {
	                    if (b.indexOf(a[l]) >= 0) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                var warnOnceHistory = {};
	                function warnOnce(message) {
	                  if (!warnOnceHistory[message]) {
	                    if (typeof console !== "undefined") {
	                      console.warn(message);
	                    }
	                    warnOnceHistory[message] = true;
	                  }
	                }
	                function isCounterClockwise(a, b, c) {
	                  return (c.y - a.y) * (b.x - a.x) > (b.y - a.y) * (c.x - a.x);
	                }
	                function calculateSignedArea(ring) {
	                  var sum = 0;
	                  for (var i = 0, len = ring.length, j = len - 1, p1 = undefined, p2 = undefined; i < len; j = i++) {
	                    p1 = ring[i];
	                    p2 = ring[j];
	                    sum += (p2.x - p1.x) * (p1.y + p2.y);
	                  }
	                  return sum;
	                }
	                function sphericalToCartesian(ref) {
	                  var r = ref[0];
	                  var azimuthal = ref[1];
	                  var polar = ref[2];
	                  azimuthal += 90;
	                  azimuthal *= Math.PI / 180;
	                  polar *= Math.PI / 180;
	                  return {
	                    x: r * Math.cos(azimuthal) * Math.sin(polar),
	                    y: r * Math.sin(azimuthal) * Math.sin(polar),
	                    z: r * Math.cos(polar)
	                  };
	                }
	                function isWorker() {
	                  return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
	                }
	                function parseCacheControl(cacheControl) {
	                  var re = /(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g;
	                  var header = {};
	                  cacheControl.replace(re, function($0, $1, $2, $3) {
	                    var value = $2 || $3;
	                    header[$1] = value ? value.toLowerCase() : true;
	                    return "";
	                  });
	                  if (header["max-age"]) {
	                    var maxAge = parseInt(header["max-age"], 10);
	                    if (isNaN(maxAge)) {
	                      delete header["max-age"];
	                    } else {
	                      header["max-age"] = maxAge;
	                    }
	                  }
	                  return header;
	                }
	                var _isSafari = null;
	                function isSafari(scope) {
	                  if (_isSafari == null) {
	                    var userAgent = scope.navigator ? scope.navigator.userAgent : null;
	                    _isSafari = !!scope.safari || !!(userAgent && (/\b(iPad|iPhone|iPod)\b/.test(userAgent) || !!userAgent.match("Safari") && !userAgent.match("Chrome")));
	                  }
	                  return _isSafari;
	                }
	                function storageAvailable(type) {
	                  try {
	                    var storage = self[type];
	                    storage.setItem("_mapbox_test_", 1);
	                    storage.removeItem("_mapbox_test_");
	                    return true;
	                  } catch (e) {
	                    return false;
	                  }
	                }
	                function b64EncodeUnicode(str) {
	                  return self.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
	                    return String.fromCharCode(Number("0x" + p1));
	                  }));
	                }
	                function b64DecodeUnicode(str) {
	                  return decodeURIComponent(self.atob(str).split("").map(function(c) {
	                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
	                  }).join(""));
	                }
	                var now = self.performance && self.performance.now ? self.performance.now.bind(self.performance) : Date.now.bind(Date);
	                var raf = self.requestAnimationFrame || self.mozRequestAnimationFrame || self.webkitRequestAnimationFrame || self.msRequestAnimationFrame;
	                var cancel = self.cancelAnimationFrame || self.mozCancelAnimationFrame || self.webkitCancelAnimationFrame || self.msCancelAnimationFrame;
	                var linkEl;
	                var reducedMotionQuery;
	                var exported = {
	                  now,
	                  frame: function frame(fn) {
	                    var frame2 = raf(fn);
	                    return {
	                      cancel: function() {
	                        return cancel(frame2);
	                      }
	                    };
	                  },
	                  getImageData: function getImageData(img, padding) {
	                    if (padding === undefined)
	                      padding = 0;
	                    var canvas = self.document.createElement("canvas");
	                    var context = canvas.getContext("2d");
	                    if (!context) {
	                      throw new Error("failed to create canvas 2d context");
	                    }
	                    canvas.width = img.width;
	                    canvas.height = img.height;
	                    context.drawImage(img, 0, 0, img.width, img.height);
	                    return context.getImageData(-padding, -padding, img.width + 2 * padding, img.height + 2 * padding);
	                  },
	                  resolveURL: function resolveURL(path) {
	                    if (!linkEl) {
	                      linkEl = self.document.createElement("a");
	                    }
	                    linkEl.href = path;
	                    return linkEl.href;
	                  },
	                  hardwareConcurrency: self.navigator.hardwareConcurrency || 4,
	                  get devicePixelRatio() {
	                    return self.devicePixelRatio;
	                  },
	                  get prefersReducedMotion() {
	                    if (!self.matchMedia) {
	                      return false;
	                    }
	                    if (reducedMotionQuery == null) {
	                      reducedMotionQuery = self.matchMedia("(prefers-reduced-motion: reduce)");
	                    }
	                    return reducedMotionQuery.matches;
	                  }
	                };
	                var config = {
	                  API_URL: "https://api.mapbox.com",
	                  get EVENTS_URL() {
	                    if (!this.API_URL) {
	                      return null;
	                    }
	                    if (this.API_URL.indexOf("https://api.mapbox.cn") === 0) {
	                      return "https://events.mapbox.cn/events/v2";
	                    } else if (this.API_URL.indexOf("https://api.mapbox.com") === 0) {
	                      return "https://events.mapbox.com/events/v2";
	                    } else {
	                      return null;
	                    }
	                  },
	                  FEEDBACK_URL: "https://apps.mapbox.com/feedback",
	                  REQUIRE_ACCESS_TOKEN: true,
	                  ACCESS_TOKEN: null,
	                  MAX_PARALLEL_IMAGE_REQUESTS: 16
	                };
	                var exported$1 = {
	                  supported: false,
	                  testSupport
	                };
	                var glForTesting;
	                var webpCheckComplete = false;
	                var webpImgTest;
	                var webpImgTestOnloadComplete = false;
	                if (self.document) {
	                  webpImgTest = self.document.createElement("img");
	                  webpImgTest.onload = function() {
	                    if (glForTesting) {
	                      testWebpTextureUpload(glForTesting);
	                    }
	                    glForTesting = null;
	                    webpImgTestOnloadComplete = true;
	                  };
	                  webpImgTest.onerror = function() {
	                    webpCheckComplete = true;
	                    glForTesting = null;
	                  };
	                  webpImgTest.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=";
	                }
	                function testSupport(gl2) {
	                  if (webpCheckComplete || !webpImgTest) {
	                    return;
	                  }
	                  if (webpImgTestOnloadComplete) {
	                    testWebpTextureUpload(gl2);
	                  } else {
	                    glForTesting = gl2;
	                  }
	                }
	                function testWebpTextureUpload(gl2) {
	                  var texture = gl2.createTexture();
	                  gl2.bindTexture(gl2.TEXTURE_2D, texture);
	                  try {
	                    gl2.texImage2D(gl2.TEXTURE_2D, 0, gl2.RGBA, gl2.RGBA, gl2.UNSIGNED_BYTE, webpImgTest);
	                    if (gl2.isContextLost()) {
	                      return;
	                    }
	                    exported$1.supported = true;
	                  } catch (e) {
	                  }
	                  gl2.deleteTexture(texture);
	                  webpCheckComplete = true;
	                }
	                var SKU_ID = "01";
	                function createSkuToken() {
	                  var TOKEN_VERSION = "1";
	                  var base62chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
	                  var sessionRandomizer = "";
	                  for (var i = 0; i < 10; i++) {
	                    sessionRandomizer += base62chars[Math.floor(Math.random() * 62)];
	                  }
	                  var expiration = 12 * 60 * 60 * 1e3;
	                  var token = [
	                    TOKEN_VERSION,
	                    SKU_ID,
	                    sessionRandomizer
	                  ].join("");
	                  var tokenExpiresAt = Date.now() + expiration;
	                  return {
	                    token,
	                    tokenExpiresAt
	                  };
	                }
	                var RequestManager = function RequestManager2(transformRequestFn, customAccessToken) {
	                  this._transformRequestFn = transformRequestFn;
	                  this._customAccessToken = customAccessToken;
	                  this._createSkuToken();
	                };
	                RequestManager.prototype._createSkuToken = function _createSkuToken() {
	                  var skuToken = createSkuToken();
	                  this._skuToken = skuToken.token;
	                  this._skuTokenExpiresAt = skuToken.tokenExpiresAt;
	                };
	                RequestManager.prototype._isSkuTokenExpired = function _isSkuTokenExpired() {
	                  return Date.now() > this._skuTokenExpiresAt;
	                };
	                RequestManager.prototype.transformRequest = function transformRequest(url, type) {
	                  if (this._transformRequestFn) {
	                    return this._transformRequestFn(url, type) || { url };
	                  }
	                  return { url };
	                };
	                RequestManager.prototype.normalizeStyleURL = function normalizeStyleURL(url, accessToken) {
	                  if (!isMapboxURL(url)) {
	                    return url;
	                  }
	                  var urlObject = parseUrl(url);
	                  urlObject.path = "/styles/v1" + urlObject.path;
	                  return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
	                };
	                RequestManager.prototype.normalizeGlyphsURL = function normalizeGlyphsURL(url, accessToken) {
	                  if (!isMapboxURL(url)) {
	                    return url;
	                  }
	                  var urlObject = parseUrl(url);
	                  urlObject.path = "/fonts/v1" + urlObject.path;
	                  return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
	                };
	                RequestManager.prototype.normalizeSourceURL = function normalizeSourceURL(url, accessToken) {
	                  if (!isMapboxURL(url)) {
	                    return url;
	                  }
	                  var urlObject = parseUrl(url);
	                  urlObject.path = "/v4/" + urlObject.authority + ".json";
	                  urlObject.params.push("secure");
	                  return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
	                };
	                RequestManager.prototype.normalizeSpriteURL = function normalizeSpriteURL(url, format, extension, accessToken) {
	                  var urlObject = parseUrl(url);
	                  if (!isMapboxURL(url)) {
	                    urlObject.path += "" + format + extension;
	                    return formatUrl(urlObject);
	                  }
	                  urlObject.path = "/styles/v1" + urlObject.path + "/sprite" + format + extension;
	                  return this._makeAPIURL(urlObject, this._customAccessToken || accessToken);
	                };
	                RequestManager.prototype.normalizeTileURL = function normalizeTileURL(tileURL, tileSize) {
	                  if (this._isSkuTokenExpired()) {
	                    this._createSkuToken();
	                  }
	                  if (tileURL && !isMapboxURL(tileURL)) {
	                    return tileURL;
	                  }
	                  var urlObject = parseUrl(tileURL);
	                  var imageExtensionRe = /(\.(png|jpg)\d*)(?=$)/;
	                  var tileURLAPIPrefixRe = /^.+\/v4\//;
	                  var suffix = exported.devicePixelRatio >= 2 || tileSize === 512 ? "@2x" : "";
	                  var extension = exported$1.supported ? ".webp" : "$1";
	                  urlObject.path = urlObject.path.replace(imageExtensionRe, "" + suffix + extension);
	                  urlObject.path = urlObject.path.replace(tileURLAPIPrefixRe, "/");
	                  urlObject.path = "/v4" + urlObject.path;
	                  var accessToken = this._customAccessToken || getAccessToken(urlObject.params) || config.ACCESS_TOKEN;
	                  if (config.REQUIRE_ACCESS_TOKEN && accessToken && this._skuToken) {
	                    urlObject.params.push("sku=" + this._skuToken);
	                  }
	                  return this._makeAPIURL(urlObject, accessToken);
	                };
	                RequestManager.prototype.canonicalizeTileURL = function canonicalizeTileURL(url, removeAccessToken) {
	                  var version2 = "/v4/";
	                  var extensionRe = /\.[\w]+$/;
	                  var urlObject = parseUrl(url);
	                  if (!urlObject.path.match(/(^\/v4\/)/) || !urlObject.path.match(extensionRe)) {
	                    return url;
	                  }
	                  var result = "mapbox://tiles/";
	                  result += urlObject.path.replace(version2, "");
	                  var params = urlObject.params;
	                  if (removeAccessToken) {
	                    params = params.filter(function(p) {
	                      return !p.match(/^access_token=/);
	                    });
	                  }
	                  if (params.length) {
	                    result += "?" + params.join("&");
	                  }
	                  return result;
	                };
	                RequestManager.prototype.canonicalizeTileset = function canonicalizeTileset(tileJSON, sourceURL) {
	                  var removeAccessToken = sourceURL ? isMapboxURL(sourceURL) : false;
	                  var canonical = [];
	                  for (var i = 0, list = tileJSON.tiles || []; i < list.length; i += 1) {
	                    var url = list[i];
	                    if (isMapboxHTTPURL(url)) {
	                      canonical.push(this.canonicalizeTileURL(url, removeAccessToken));
	                    } else {
	                      canonical.push(url);
	                    }
	                  }
	                  return canonical;
	                };
	                RequestManager.prototype._makeAPIURL = function _makeAPIURL(urlObject, accessToken) {
	                  var help = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes";
	                  var apiUrlObject = parseUrl(config.API_URL);
	                  urlObject.protocol = apiUrlObject.protocol;
	                  urlObject.authority = apiUrlObject.authority;
	                  if (apiUrlObject.path !== "/") {
	                    urlObject.path = "" + apiUrlObject.path + urlObject.path;
	                  }
	                  if (!config.REQUIRE_ACCESS_TOKEN) {
	                    return formatUrl(urlObject);
	                  }
	                  accessToken = accessToken || config.ACCESS_TOKEN;
	                  if (!accessToken) {
	                    throw new Error("An API access token is required to use Mapbox GL. " + help);
	                  }
	                  if (accessToken[0] === "s") {
	                    throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + help);
	                  }
	                  urlObject.params = urlObject.params.filter(function(d) {
	                    return d.indexOf("access_token") === -1;
	                  });
	                  urlObject.params.push("access_token=" + accessToken);
	                  return formatUrl(urlObject);
	                };
	                function isMapboxURL(url) {
	                  return url.indexOf("mapbox:") === 0;
	                }
	                var mapboxHTTPURLRe = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
	                function isMapboxHTTPURL(url) {
	                  return mapboxHTTPURLRe.test(url);
	                }
	                function hasCacheDefeatingSku(url) {
	                  return url.indexOf("sku=") > 0 && isMapboxHTTPURL(url);
	                }
	                function getAccessToken(params) {
	                  for (var i = 0, list = params; i < list.length; i += 1) {
	                    var param = list[i];
	                    var match = param.match(/^access_token=(.*)$/);
	                    if (match) {
	                      return match[1];
	                    }
	                  }
	                  return null;
	                }
	                var urlRe = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
	                function parseUrl(url) {
	                  var parts = url.match(urlRe);
	                  if (!parts) {
	                    throw new Error("Unable to parse URL object");
	                  }
	                  return {
	                    protocol: parts[1],
	                    authority: parts[2],
	                    path: parts[3] || "/",
	                    params: parts[4] ? parts[4].split("&") : []
	                  };
	                }
	                function formatUrl(obj) {
	                  var params = obj.params.length ? "?" + obj.params.join("&") : "";
	                  return obj.protocol + "://" + obj.authority + obj.path + params;
	                }
	                var telemEventKey = "mapbox.eventData";
	                function parseAccessToken(accessToken) {
	                  if (!accessToken) {
	                    return null;
	                  }
	                  var parts = accessToken.split(".");
	                  if (!parts || parts.length !== 3) {
	                    return null;
	                  }
	                  try {
	                    var jsonData = JSON.parse(b64DecodeUnicode(parts[1]));
	                    return jsonData;
	                  } catch (e) {
	                    return null;
	                  }
	                }
	                var TelemetryEvent = function TelemetryEvent2(type) {
	                  this.type = type;
	                  this.anonId = null;
	                  this.eventData = {};
	                  this.queue = [];
	                  this.pendingRequest = null;
	                };
	                TelemetryEvent.prototype.getStorageKey = function getStorageKey(domain) {
	                  var tokenData = parseAccessToken(config.ACCESS_TOKEN);
	                  var u = "";
	                  if (tokenData && tokenData["u"]) {
	                    u = b64EncodeUnicode(tokenData["u"]);
	                  } else {
	                    u = config.ACCESS_TOKEN || "";
	                  }
	                  return domain ? telemEventKey + "." + domain + ":" + u : telemEventKey + ":" + u;
	                };
	                TelemetryEvent.prototype.fetchEventData = function fetchEventData() {
	                  var isLocalStorageAvailable = storageAvailable("localStorage");
	                  var storageKey = this.getStorageKey();
	                  var uuidKey = this.getStorageKey("uuid");
	                  if (isLocalStorageAvailable) {
	                    try {
	                      var data = self.localStorage.getItem(storageKey);
	                      if (data) {
	                        this.eventData = JSON.parse(data);
	                      }
	                      var uuid2 = self.localStorage.getItem(uuidKey);
	                      if (uuid2) {
	                        this.anonId = uuid2;
	                      }
	                    } catch (e) {
	                      warnOnce("Unable to read from LocalStorage");
	                    }
	                  }
	                };
	                TelemetryEvent.prototype.saveEventData = function saveEventData() {
	                  var isLocalStorageAvailable = storageAvailable("localStorage");
	                  var storageKey = this.getStorageKey();
	                  var uuidKey = this.getStorageKey("uuid");
	                  if (isLocalStorageAvailable) {
	                    try {
	                      self.localStorage.setItem(uuidKey, this.anonId);
	                      if (Object.keys(this.eventData).length >= 1) {
	                        self.localStorage.setItem(storageKey, JSON.stringify(this.eventData));
	                      }
	                    } catch (e) {
	                      warnOnce("Unable to write to LocalStorage");
	                    }
	                  }
	                };
	                TelemetryEvent.prototype.processRequests = function processRequests(_) {
	                };
	                TelemetryEvent.prototype.postEvent = function postEvent(timestamp, additionalPayload, callback, customAccessToken) {
	                  var this$1$1 = this;
	                  if (!config.EVENTS_URL) {
	                    return;
	                  }
	                  var eventsUrlObject = parseUrl(config.EVENTS_URL);
	                  eventsUrlObject.params.push("access_token=" + (customAccessToken || config.ACCESS_TOKEN || ""));
	                  var payload = {
	                    event: this.type,
	                    created: new Date(timestamp).toISOString(),
	                    sdkIdentifier: "mapbox-gl-js",
	                    sdkVersion: version,
	                    skuId: SKU_ID,
	                    userId: this.anonId
	                  };
	                  var finalPayload = additionalPayload ? extend(payload, additionalPayload) : payload;
	                  var request = {
	                    url: formatUrl(eventsUrlObject),
	                    headers: { "Content-Type": "text/plain" },
	                    body: JSON.stringify([finalPayload])
	                  };
	                  this.pendingRequest = postData(request, function(error2) {
	                    this$1$1.pendingRequest = null;
	                    callback(error2);
	                    this$1$1.saveEventData();
	                    this$1$1.processRequests(customAccessToken);
	                  });
	                };
	                TelemetryEvent.prototype.queueRequest = function queueRequest(event, customAccessToken) {
	                  this.queue.push(event);
	                  this.processRequests(customAccessToken);
	                };
	                var MapLoadEvent = function(TelemetryEvent2) {
	                  function MapLoadEvent2() {
	                    TelemetryEvent2.call(this, "map.load");
	                    this.success = {};
	                    this.skuToken = "";
	                  }
	                  MapLoadEvent2.__proto__ = TelemetryEvent2;
	                  MapLoadEvent2.prototype = Object.create(TelemetryEvent2.prototype);
	                  MapLoadEvent2.prototype.constructor = MapLoadEvent2;
	                  MapLoadEvent2.prototype.postMapLoadEvent = function postMapLoadEvent2(tileUrls, mapId, skuToken, customAccessToken) {
	                    this.skuToken = skuToken;
	                    if (config.EVENTS_URL && customAccessToken || config.ACCESS_TOKEN && Array.isArray(tileUrls) && tileUrls.some(function(url) {
	                      return isMapboxURL(url) || isMapboxHTTPURL(url);
	                    })) {
	                      this.queueRequest({
	                        id: mapId,
	                        timestamp: Date.now()
	                      }, customAccessToken);
	                    }
	                  };
	                  MapLoadEvent2.prototype.processRequests = function processRequests(customAccessToken) {
	                    var this$1$1 = this;
	                    if (this.pendingRequest || this.queue.length === 0) {
	                      return;
	                    }
	                    var ref = this.queue.shift();
	                    var id2 = ref.id;
	                    var timestamp = ref.timestamp;
	                    if (id2 && this.success[id2]) {
	                      return;
	                    }
	                    if (!this.anonId) {
	                      this.fetchEventData();
	                    }
	                    if (!validateUuid(this.anonId)) {
	                      this.anonId = uuid();
	                    }
	                    this.postEvent(timestamp, { skuToken: this.skuToken }, function(err) {
	                      if (!err) {
	                        if (id2) {
	                          this$1$1.success[id2] = true;
	                        }
	                      }
	                    }, customAccessToken);
	                  };
	                  return MapLoadEvent2;
	                }(TelemetryEvent);
	                var TurnstileEvent = function(TelemetryEvent2) {
	                  function TurnstileEvent2(customAccessToken) {
	                    TelemetryEvent2.call(this, "appUserTurnstile");
	                    this._customAccessToken = customAccessToken;
	                  }
	                  TurnstileEvent2.__proto__ = TelemetryEvent2;
	                  TurnstileEvent2.prototype = Object.create(TelemetryEvent2.prototype);
	                  TurnstileEvent2.prototype.constructor = TurnstileEvent2;
	                  TurnstileEvent2.prototype.postTurnstileEvent = function postTurnstileEvent2(tileUrls, customAccessToken) {
	                    if (config.EVENTS_URL && config.ACCESS_TOKEN && Array.isArray(tileUrls) && tileUrls.some(function(url) {
	                      return isMapboxURL(url) || isMapboxHTTPURL(url);
	                    })) {
	                      this.queueRequest(Date.now(), customAccessToken);
	                    }
	                  };
	                  TurnstileEvent2.prototype.processRequests = function processRequests(customAccessToken) {
	                    var this$1$1 = this;
	                    if (this.pendingRequest || this.queue.length === 0) {
	                      return;
	                    }
	                    if (!this.anonId || !this.eventData.lastSuccess || !this.eventData.tokenU) {
	                      this.fetchEventData();
	                    }
	                    var tokenData = parseAccessToken(config.ACCESS_TOKEN);
	                    var tokenU = tokenData ? tokenData["u"] : config.ACCESS_TOKEN;
	                    var dueForEvent = tokenU !== this.eventData.tokenU;
	                    if (!validateUuid(this.anonId)) {
	                      this.anonId = uuid();
	                      dueForEvent = true;
	                    }
	                    var nextUpdate = this.queue.shift();
	                    if (this.eventData.lastSuccess) {
	                      var lastUpdate = new Date(this.eventData.lastSuccess);
	                      var nextDate = new Date(nextUpdate);
	                      var daysElapsed = (nextUpdate - this.eventData.lastSuccess) / (24 * 60 * 60 * 1e3);
	                      dueForEvent = dueForEvent || daysElapsed >= 1 || daysElapsed < -1 || lastUpdate.getDate() !== nextDate.getDate();
	                    } else {
	                      dueForEvent = true;
	                    }
	                    if (!dueForEvent) {
	                      return this.processRequests();
	                    }
	                    this.postEvent(nextUpdate, { "enabled.telemetry": false }, function(err) {
	                      if (!err) {
	                        this$1$1.eventData.lastSuccess = nextUpdate;
	                        this$1$1.eventData.tokenU = tokenU;
	                      }
	                    }, customAccessToken);
	                  };
	                  return TurnstileEvent2;
	                }(TelemetryEvent);
	                var turnstileEvent_ = new TurnstileEvent();
	                var postTurnstileEvent = turnstileEvent_.postTurnstileEvent.bind(turnstileEvent_);
	                var mapLoadEvent_ = new MapLoadEvent();
	                var postMapLoadEvent = mapLoadEvent_.postMapLoadEvent.bind(mapLoadEvent_);
	                var CACHE_NAME = "mapbox-tiles";
	                var cacheLimit = 500;
	                var cacheCheckThreshold = 50;
	                var MIN_TIME_UNTIL_EXPIRY = 1e3 * 60 * 7;
	                var sharedCache;
	                function cacheOpen() {
	                  if (self.caches && !sharedCache) {
	                    sharedCache = self.caches.open(CACHE_NAME);
	                  }
	                }
	                var responseConstructorSupportsReadableStream;
	                function prepareBody(response, callback) {
	                  if (responseConstructorSupportsReadableStream === undefined) {
	                    try {
	                      new Response(new ReadableStream());
	                      responseConstructorSupportsReadableStream = true;
	                    } catch (e) {
	                      responseConstructorSupportsReadableStream = false;
	                    }
	                  }
	                  if (responseConstructorSupportsReadableStream) {
	                    callback(response.body);
	                  } else {
	                    response.blob().then(callback);
	                  }
	                }
	                function cachePut(request, response, requestTime) {
	                  cacheOpen();
	                  if (!sharedCache) {
	                    return;
	                  }
	                  var options = {
	                    status: response.status,
	                    statusText: response.statusText,
	                    headers: new self.Headers()
	                  };
	                  response.headers.forEach(function(v, k) {
	                    return options.headers.set(k, v);
	                  });
	                  var cacheControl = parseCacheControl(response.headers.get("Cache-Control") || "");
	                  if (cacheControl["no-store"]) {
	                    return;
	                  }
	                  if (cacheControl["max-age"]) {
	                    options.headers.set("Expires", new Date(requestTime + cacheControl["max-age"] * 1e3).toUTCString());
	                  }
	                  var timeUntilExpiry = new Date(options.headers.get("Expires")).getTime() - requestTime;
	                  if (timeUntilExpiry < MIN_TIME_UNTIL_EXPIRY) {
	                    return;
	                  }
	                  prepareBody(response, function(body) {
	                    var clonedResponse = new self.Response(body, options);
	                    cacheOpen();
	                    if (!sharedCache) {
	                      return;
	                    }
	                    sharedCache.then(function(cache) {
	                      return cache.put(stripQueryParameters(request.url), clonedResponse);
	                    }).catch(function(e) {
	                      return warnOnce(e.message);
	                    });
	                  });
	                }
	                function stripQueryParameters(url) {
	                  var start = url.indexOf("?");
	                  return start < 0 ? url : url.slice(0, start);
	                }
	                function cacheGet(request, callback) {
	                  cacheOpen();
	                  if (!sharedCache) {
	                    return callback(null);
	                  }
	                  var strippedURL = stripQueryParameters(request.url);
	                  sharedCache.then(function(cache) {
	                    cache.match(strippedURL).then(function(response) {
	                      var fresh = isFresh(response);
	                      cache.delete(strippedURL);
	                      if (fresh) {
	                        cache.put(strippedURL, response.clone());
	                      }
	                      callback(null, response, fresh);
	                    }).catch(callback);
	                  }).catch(callback);
	                }
	                function isFresh(response) {
	                  if (!response) {
	                    return false;
	                  }
	                  var expires = new Date(response.headers.get("Expires") || 0);
	                  var cacheControl = parseCacheControl(response.headers.get("Cache-Control") || "");
	                  return expires > Date.now() && !cacheControl["no-cache"];
	                }
	                var globalEntryCounter = Infinity;
	                function cacheEntryPossiblyAdded(dispatcher) {
	                  globalEntryCounter++;
	                  if (globalEntryCounter > cacheCheckThreshold) {
	                    dispatcher.getActor().send("enforceCacheSizeLimit", cacheLimit);
	                    globalEntryCounter = 0;
	                  }
	                }
	                function enforceCacheSizeLimit(limit) {
	                  cacheOpen();
	                  if (!sharedCache) {
	                    return;
	                  }
	                  sharedCache.then(function(cache) {
	                    cache.keys().then(function(keys) {
	                      for (var i = 0; i < keys.length - limit; i++) {
	                        cache.delete(keys[i]);
	                      }
	                    });
	                  });
	                }
	                function clearTileCache(callback) {
	                  var promise = self.caches.delete(CACHE_NAME);
	                  if (callback) {
	                    promise.catch(callback).then(function() {
	                      return callback();
	                    });
	                  }
	                }
	                function setCacheLimits(limit, checkThreshold) {
	                  cacheLimit = limit;
	                  cacheCheckThreshold = checkThreshold;
	                }
	                var supportsOffscreenCanvas;
	                function offscreenCanvasSupported() {
	                  if (supportsOffscreenCanvas == null) {
	                    supportsOffscreenCanvas = self.OffscreenCanvas && new self.OffscreenCanvas(1, 1).getContext("2d") && typeof self.createImageBitmap === "function";
	                  }
	                  return supportsOffscreenCanvas;
	                }
	                var ResourceType = {
	                  Unknown: "Unknown",
	                  Style: "Style",
	                  Source: "Source",
	                  Tile: "Tile",
	                  Glyphs: "Glyphs",
	                  SpriteImage: "SpriteImage",
	                  SpriteJSON: "SpriteJSON",
	                  Image: "Image"
	                };
	                if (typeof Object.freeze == "function") {
	                  Object.freeze(ResourceType);
	                }
	                var AJAXError = function(Error2) {
	                  function AJAXError2(message, status2, url) {
	                    if (status2 === 401 && isMapboxHTTPURL(url)) {
	                      message += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes";
	                    }
	                    Error2.call(this, message);
	                    this.status = status2;
	                    this.url = url;
	                    this.name = this.constructor.name;
	                    this.message = message;
	                  }
	                  if (Error2)
	                    AJAXError2.__proto__ = Error2;
	                  AJAXError2.prototype = Object.create(Error2 && Error2.prototype);
	                  AJAXError2.prototype.constructor = AJAXError2;
	                  AJAXError2.prototype.toString = function toString2() {
	                    return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
	                  };
	                  return AJAXError2;
	                }(Error);
	                var getReferrer = isWorker() ? function() {
	                  return self.worker && self.worker.referrer;
	                } : function() {
	                  return (self.location.protocol === "blob:" ? self.parent : self).location.href;
	                };
	                var isFileURL = function(url) {
	                  return /^file:/.test(url) || /^file:/.test(getReferrer()) && !/^\w+:/.test(url);
	                };
	                function makeFetchRequest(requestParameters, callback) {
	                  var controller = new self.AbortController();
	                  var request = new self.Request(requestParameters.url, {
	                    method: requestParameters.method || "GET",
	                    body: requestParameters.body,
	                    credentials: requestParameters.credentials,
	                    headers: requestParameters.headers,
	                    referrer: getReferrer(),
	                    signal: controller.signal
	                  });
	                  var complete = false;
	                  var aborted = false;
	                  var cacheIgnoringSearch = hasCacheDefeatingSku(request.url);
	                  if (requestParameters.type === "json") {
	                    request.headers.set("Accept", "application/json");
	                  }
	                  var validateOrFetch = function(err, cachedResponse, responseIsFresh) {
	                    if (aborted) {
	                      return;
	                    }
	                    if (err) {
	                      if (err.message !== "SecurityError") {
	                        warnOnce(err);
	                      }
	                    }
	                    if (cachedResponse && responseIsFresh) {
	                      return finishRequest(cachedResponse);
	                    }
	                    var requestTime = Date.now();
	                    self.fetch(request).then(function(response) {
	                      if (response.ok) {
	                        var cacheableResponse = cacheIgnoringSearch ? response.clone() : null;
	                        return finishRequest(response, cacheableResponse, requestTime);
	                      } else {
	                        return callback(new AJAXError(response.statusText, response.status, requestParameters.url));
	                      }
	                    }).catch(function(error2) {
	                      if (error2.code === 20) {
	                        return;
	                      }
	                      callback(new Error(error2.message));
	                    });
	                  };
	                  var finishRequest = function(response, cacheableResponse, requestTime) {
	                    (requestParameters.type === "arrayBuffer" ? response.arrayBuffer() : requestParameters.type === "json" ? response.json() : response.text()).then(function(result) {
	                      if (aborted) {
	                        return;
	                      }
	                      if (cacheableResponse && requestTime) {
	                        cachePut(request, cacheableResponse, requestTime);
	                      }
	                      complete = true;
	                      callback(null, result, response.headers.get("Cache-Control"), response.headers.get("Expires"));
	                    }).catch(function(err) {
	                      if (!aborted) {
	                        callback(new Error(err.message));
	                      }
	                    });
	                  };
	                  if (cacheIgnoringSearch) {
	                    cacheGet(request, validateOrFetch);
	                  } else {
	                    validateOrFetch(null, null);
	                  }
	                  return {
	                    cancel: function() {
	                      aborted = true;
	                      if (!complete) {
	                        controller.abort();
	                      }
	                    }
	                  };
	                }
	                function makeXMLHttpRequest(requestParameters, callback) {
	                  var xhr = new self.XMLHttpRequest();
	                  xhr.open(requestParameters.method || "GET", requestParameters.url, true);
	                  if (requestParameters.type === "arrayBuffer") {
	                    xhr.responseType = "arraybuffer";
	                  }
	                  for (var k in requestParameters.headers) {
	                    xhr.setRequestHeader(k, requestParameters.headers[k]);
	                  }
	                  if (requestParameters.type === "json") {
	                    xhr.responseType = "text";
	                    xhr.setRequestHeader("Accept", "application/json");
	                  }
	                  xhr.withCredentials = requestParameters.credentials === "include";
	                  xhr.onerror = function() {
	                    callback(new Error(xhr.statusText));
	                  };
	                  xhr.onload = function() {
	                    if ((xhr.status >= 200 && xhr.status < 300 || xhr.status === 0) && xhr.response !== null) {
	                      var data = xhr.response;
	                      if (requestParameters.type === "json") {
	                        try {
	                          data = JSON.parse(xhr.response);
	                        } catch (err) {
	                          return callback(err);
	                        }
	                      }
	                      callback(null, data, xhr.getResponseHeader("Cache-Control"), xhr.getResponseHeader("Expires"));
	                    } else {
	                      callback(new AJAXError(xhr.statusText, xhr.status, requestParameters.url));
	                    }
	                  };
	                  xhr.send(requestParameters.body);
	                  return {
	                    cancel: function() {
	                      return xhr.abort();
	                    }
	                  };
	                }
	                var makeRequest = function(requestParameters, callback) {
	                  if (!isFileURL(requestParameters.url)) {
	                    if (self.fetch && self.Request && self.AbortController && self.Request.prototype.hasOwnProperty("signal")) {
	                      return makeFetchRequest(requestParameters, callback);
	                    }
	                    if (isWorker() && self.worker && self.worker.actor) {
	                      var queueOnMainThread = true;
	                      return self.worker.actor.send("getResource", requestParameters, callback, undefined, queueOnMainThread);
	                    }
	                  }
	                  return makeXMLHttpRequest(requestParameters, callback);
	                };
	                var getJSON = function(requestParameters, callback) {
	                  return makeRequest(extend(requestParameters, { type: "json" }), callback);
	                };
	                var getArrayBuffer = function(requestParameters, callback) {
	                  return makeRequest(extend(requestParameters, { type: "arrayBuffer" }), callback);
	                };
	                var postData = function(requestParameters, callback) {
	                  return makeRequest(extend(requestParameters, { method: "POST" }), callback);
	                };
	                function sameOrigin(url) {
	                  var a = self.document.createElement("a");
	                  a.href = url;
	                  return a.protocol === self.document.location.protocol && a.host === self.document.location.host;
	                }
	                var transparentPngUrl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
	                function arrayBufferToImage(data, callback, cacheControl, expires) {
	                  var img = new self.Image();
	                  var URL2 = self.URL;
	                  img.onload = function() {
	                    callback(null, img);
	                    URL2.revokeObjectURL(img.src);
	                  };
	                  img.onerror = function() {
	                    return callback(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
	                  };
	                  var blob = new self.Blob([new Uint8Array(data)], { type: "image/png" });
	                  img.cacheControl = cacheControl;
	                  img.expires = expires;
	                  img.src = data.byteLength ? URL2.createObjectURL(blob) : transparentPngUrl;
	                }
	                function arrayBufferToImageBitmap(data, callback) {
	                  var blob = new self.Blob([new Uint8Array(data)], { type: "image/png" });
	                  self.createImageBitmap(blob).then(function(imgBitmap) {
	                    callback(null, imgBitmap);
	                  }).catch(function(e) {
	                    callback(new Error("Could not load image because of " + e.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
	                  });
	                }
	                var imageQueue, numImageRequests;
	                var resetImageRequestQueue = function() {
	                  imageQueue = [];
	                  numImageRequests = 0;
	                };
	                resetImageRequestQueue();
	                var getImage = function(requestParameters, callback) {
	                  if (exported$1.supported) {
	                    if (!requestParameters.headers) {
	                      requestParameters.headers = {};
	                    }
	                    requestParameters.headers.accept = "image/webp,*/*";
	                  }
	                  if (numImageRequests >= config.MAX_PARALLEL_IMAGE_REQUESTS) {
	                    var queued = {
	                      requestParameters,
	                      callback,
	                      cancelled: false,
	                      cancel: function cancel2() {
	                        this.cancelled = true;
	                      }
	                    };
	                    imageQueue.push(queued);
	                    return queued;
	                  }
	                  numImageRequests++;
	                  var advanced = false;
	                  var advanceImageRequestQueue = function() {
	                    if (advanced) {
	                      return;
	                    }
	                    advanced = true;
	                    numImageRequests--;
	                    while (imageQueue.length && numImageRequests < config.MAX_PARALLEL_IMAGE_REQUESTS) {
	                      var request2 = imageQueue.shift();
	                      var requestParameters2 = request2.requestParameters;
	                      var callback2 = request2.callback;
	                      var cancelled = request2.cancelled;
	                      if (!cancelled) {
	                        request2.cancel = getImage(requestParameters2, callback2).cancel;
	                      }
	                    }
	                  };
	                  var request = getArrayBuffer(requestParameters, function(err, data, cacheControl, expires) {
	                    advanceImageRequestQueue();
	                    if (err) {
	                      callback(err);
	                    } else if (data) {
	                      if (offscreenCanvasSupported()) {
	                        arrayBufferToImageBitmap(data, callback);
	                      } else {
	                        arrayBufferToImage(data, callback, cacheControl, expires);
	                      }
	                    }
	                  });
	                  return {
	                    cancel: function() {
	                      request.cancel();
	                      advanceImageRequestQueue();
	                    }
	                  };
	                };
	                var getVideo = function(urls, callback) {
	                  var video = self.document.createElement("video");
	                  video.muted = true;
	                  video.onloadstart = function() {
	                    callback(null, video);
	                  };
	                  for (var i = 0; i < urls.length; i++) {
	                    var s = self.document.createElement("source");
	                    if (!sameOrigin(urls[i])) {
	                      video.crossOrigin = "Anonymous";
	                    }
	                    s.src = urls[i];
	                    video.appendChild(s);
	                  }
	                  return {
	                    cancel: function() {
	                    }
	                  };
	                };
	                function _addEventListener(type, listener, listenerList) {
	                  var listenerExists = listenerList[type] && listenerList[type].indexOf(listener) !== -1;
	                  if (!listenerExists) {
	                    listenerList[type] = listenerList[type] || [];
	                    listenerList[type].push(listener);
	                  }
	                }
	                function _removeEventListener(type, listener, listenerList) {
	                  if (listenerList && listenerList[type]) {
	                    var index = listenerList[type].indexOf(listener);
	                    if (index !== -1) {
	                      listenerList[type].splice(index, 1);
	                    }
	                  }
	                }
	                var Event = function Event2(type, data) {
	                  if (data === undefined)
	                    data = {};
	                  extend(this, data);
	                  this.type = type;
	                };
	                var ErrorEvent = function(Event2) {
	                  function ErrorEvent2(error2, data) {
	                    if (data === undefined)
	                      data = {};
	                    Event2.call(this, "error", extend({ error: error2 }, data));
	                  }
	                  ErrorEvent2.__proto__ = Event2;
	                  ErrorEvent2.prototype = Object.create(Event2.prototype);
	                  ErrorEvent2.prototype.constructor = ErrorEvent2;
	                  return ErrorEvent2;
	                }(Event);
	                var Evented = function Evented2() {
	                };
	                Evented.prototype.on = function on(type, listener) {
	                  this._listeners = this._listeners || {};
	                  _addEventListener(type, listener, this._listeners);
	                  return this;
	                };
	                Evented.prototype.off = function off(type, listener) {
	                  _removeEventListener(type, listener, this._listeners);
	                  _removeEventListener(type, listener, this._oneTimeListeners);
	                  return this;
	                };
	                Evented.prototype.once = function once(type, listener) {
	                  this._oneTimeListeners = this._oneTimeListeners || {};
	                  _addEventListener(type, listener, this._oneTimeListeners);
	                  return this;
	                };
	                Evented.prototype.fire = function fire(event, properties2) {
	                  if (typeof event === "string") {
	                    event = new Event(event, properties2 || {});
	                  }
	                  var type = event.type;
	                  if (this.listens(type)) {
	                    event.target = this;
	                    var listeners = this._listeners && this._listeners[type] ? this._listeners[type].slice() : [];
	                    for (var i = 0, list = listeners; i < list.length; i += 1) {
	                      var listener = list[i];
	                      listener.call(this, event);
	                    }
	                    var oneTimeListeners = this._oneTimeListeners && this._oneTimeListeners[type] ? this._oneTimeListeners[type].slice() : [];
	                    for (var i$1 = 0, list$1 = oneTimeListeners; i$1 < list$1.length; i$1 += 1) {
	                      var listener$1 = list$1[i$1];
	                      _removeEventListener(type, listener$1, this._oneTimeListeners);
	                      listener$1.call(this, event);
	                    }
	                    var parent = this._eventedParent;
	                    if (parent) {
	                      extend(event, typeof this._eventedParentData === "function" ? this._eventedParentData() : this._eventedParentData);
	                      parent.fire(event);
	                    }
	                  } else if (event instanceof ErrorEvent) {
	                    console.error(event.error);
	                  }
	                  return this;
	                };
	                Evented.prototype.listens = function listens(type) {
	                  return this._listeners && this._listeners[type] && this._listeners[type].length > 0 || this._oneTimeListeners && this._oneTimeListeners[type] && this._oneTimeListeners[type].length > 0 || this._eventedParent && this._eventedParent.listens(type);
	                };
	                Evented.prototype.setEventedParent = function setEventedParent(parent, data) {
	                  this._eventedParent = parent;
	                  this._eventedParentData = data;
	                  return this;
	                };
	                var $version = 8;
	                var $root = {
	                  version: {
	                    required: true,
	                    type: "enum",
	                    values: [
	                      8
	                    ]
	                  },
	                  name: {
	                    type: "string"
	                  },
	                  metadata: {
	                    type: "*"
	                  },
	                  center: {
	                    type: "array",
	                    value: "number"
	                  },
	                  zoom: {
	                    type: "number"
	                  },
	                  bearing: {
	                    type: "number",
	                    "default": 0,
	                    period: 360,
	                    units: "degrees"
	                  },
	                  pitch: {
	                    type: "number",
	                    "default": 0,
	                    units: "degrees"
	                  },
	                  light: {
	                    type: "light"
	                  },
	                  sources: {
	                    required: true,
	                    type: "sources"
	                  },
	                  sprite: {
	                    type: "string"
	                  },
	                  glyphs: {
	                    type: "string"
	                  },
	                  transition: {
	                    type: "transition"
	                  },
	                  layers: {
	                    required: true,
	                    type: "array",
	                    value: "layer"
	                  }
	                };
	                var sources = {
	                  "*": {
	                    type: "source"
	                  }
	                };
	                var source = [
	                  "source_vector",
	                  "source_raster",
	                  "source_raster_dem",
	                  "source_geojson",
	                  "source_video",
	                  "source_image"
	                ];
	                var source_vector = {
	                  type: {
	                    required: true,
	                    type: "enum",
	                    values: {
	                      vector: {}
	                    }
	                  },
	                  url: {
	                    type: "string"
	                  },
	                  tiles: {
	                    type: "array",
	                    value: "string"
	                  },
	                  bounds: {
	                    type: "array",
	                    value: "number",
	                    length: 4,
	                    "default": [
	                      -180,
	                      -85.051129,
	                      180,
	                      85.051129
	                    ]
	                  },
	                  scheme: {
	                    type: "enum",
	                    values: {
	                      xyz: {},
	                      tms: {}
	                    },
	                    "default": "xyz"
	                  },
	                  minzoom: {
	                    type: "number",
	                    "default": 0
	                  },
	                  maxzoom: {
	                    type: "number",
	                    "default": 22
	                  },
	                  attribution: {
	                    type: "string"
	                  },
	                  promoteId: {
	                    type: "promoteId"
	                  },
	                  "*": {
	                    type: "*"
	                  }
	                };
	                var source_raster = {
	                  type: {
	                    required: true,
	                    type: "enum",
	                    values: {
	                      raster: {}
	                    }
	                  },
	                  url: {
	                    type: "string"
	                  },
	                  tiles: {
	                    type: "array",
	                    value: "string"
	                  },
	                  bounds: {
	                    type: "array",
	                    value: "number",
	                    length: 4,
	                    "default": [
	                      -180,
	                      -85.051129,
	                      180,
	                      85.051129
	                    ]
	                  },
	                  minzoom: {
	                    type: "number",
	                    "default": 0
	                  },
	                  maxzoom: {
	                    type: "number",
	                    "default": 22
	                  },
	                  tileSize: {
	                    type: "number",
	                    "default": 512,
	                    units: "pixels"
	                  },
	                  scheme: {
	                    type: "enum",
	                    values: {
	                      xyz: {},
	                      tms: {}
	                    },
	                    "default": "xyz"
	                  },
	                  attribution: {
	                    type: "string"
	                  },
	                  "*": {
	                    type: "*"
	                  }
	                };
	                var source_raster_dem = {
	                  type: {
	                    required: true,
	                    type: "enum",
	                    values: {
	                      "raster-dem": {}
	                    }
	                  },
	                  url: {
	                    type: "string"
	                  },
	                  tiles: {
	                    type: "array",
	                    value: "string"
	                  },
	                  bounds: {
	                    type: "array",
	                    value: "number",
	                    length: 4,
	                    "default": [
	                      -180,
	                      -85.051129,
	                      180,
	                      85.051129
	                    ]
	                  },
	                  minzoom: {
	                    type: "number",
	                    "default": 0
	                  },
	                  maxzoom: {
	                    type: "number",
	                    "default": 22
	                  },
	                  tileSize: {
	                    type: "number",
	                    "default": 512,
	                    units: "pixels"
	                  },
	                  attribution: {
	                    type: "string"
	                  },
	                  encoding: {
	                    type: "enum",
	                    values: {
	                      terrarium: {},
	                      mapbox: {}
	                    },
	                    "default": "mapbox"
	                  },
	                  "*": {
	                    type: "*"
	                  }
	                };
	                var source_geojson = {
	                  type: {
	                    required: true,
	                    type: "enum",
	                    values: {
	                      geojson: {}
	                    }
	                  },
	                  data: {
	                    type: "*"
	                  },
	                  maxzoom: {
	                    type: "number",
	                    "default": 18
	                  },
	                  attribution: {
	                    type: "string"
	                  },
	                  buffer: {
	                    type: "number",
	                    "default": 128,
	                    maximum: 512,
	                    minimum: 0
	                  },
	                  tolerance: {
	                    type: "number",
	                    "default": 0.375
	                  },
	                  cluster: {
	                    type: "boolean",
	                    "default": false
	                  },
	                  clusterRadius: {
	                    type: "number",
	                    "default": 50,
	                    minimum: 0
	                  },
	                  clusterMaxZoom: {
	                    type: "number"
	                  },
	                  clusterProperties: {
	                    type: "*"
	                  },
	                  lineMetrics: {
	                    type: "boolean",
	                    "default": false
	                  },
	                  generateId: {
	                    type: "boolean",
	                    "default": false
	                  },
	                  promoteId: {
	                    type: "promoteId"
	                  }
	                };
	                var source_video = {
	                  type: {
	                    required: true,
	                    type: "enum",
	                    values: {
	                      video: {}
	                    }
	                  },
	                  urls: {
	                    required: true,
	                    type: "array",
	                    value: "string"
	                  },
	                  coordinates: {
	                    required: true,
	                    type: "array",
	                    length: 4,
	                    value: {
	                      type: "array",
	                      length: 2,
	                      value: "number"
	                    }
	                  }
	                };
	                var source_image = {
	                  type: {
	                    required: true,
	                    type: "enum",
	                    values: {
	                      image: {}
	                    }
	                  },
	                  url: {
	                    required: true,
	                    type: "string"
	                  },
	                  coordinates: {
	                    required: true,
	                    type: "array",
	                    length: 4,
	                    value: {
	                      type: "array",
	                      length: 2,
	                      value: "number"
	                    }
	                  }
	                };
	                var layer = {
	                  id: {
	                    type: "string",
	                    required: true
	                  },
	                  type: {
	                    type: "enum",
	                    values: {
	                      fill: {},
	                      line: {},
	                      symbol: {},
	                      circle: {},
	                      heatmap: {},
	                      "fill-extrusion": {},
	                      raster: {},
	                      hillshade: {},
	                      background: {}
	                    },
	                    required: true
	                  },
	                  metadata: {
	                    type: "*"
	                  },
	                  source: {
	                    type: "string"
	                  },
	                  "source-layer": {
	                    type: "string"
	                  },
	                  minzoom: {
	                    type: "number",
	                    minimum: 0,
	                    maximum: 24
	                  },
	                  maxzoom: {
	                    type: "number",
	                    minimum: 0,
	                    maximum: 24
	                  },
	                  filter: {
	                    type: "filter"
	                  },
	                  layout: {
	                    type: "layout"
	                  },
	                  paint: {
	                    type: "paint"
	                  }
	                };
	                var layout = [
	                  "layout_fill",
	                  "layout_line",
	                  "layout_circle",
	                  "layout_heatmap",
	                  "layout_fill-extrusion",
	                  "layout_symbol",
	                  "layout_raster",
	                  "layout_hillshade",
	                  "layout_background"
	                ];
	                var layout_background = {
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_fill = {
	                  "fill-sort-key": {
	                    type: "number",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_circle = {
	                  "circle-sort-key": {
	                    type: "number",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_heatmap = {
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_line = {
	                  "line-cap": {
	                    type: "enum",
	                    values: {
	                      butt: {},
	                      round: {},
	                      square: {}
	                    },
	                    "default": "butt",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "line-join": {
	                    type: "enum",
	                    values: {
	                      bevel: {},
	                      round: {},
	                      miter: {}
	                    },
	                    "default": "miter",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-miter-limit": {
	                    type: "number",
	                    "default": 2,
	                    requires: [
	                      {
	                        "line-join": "miter"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "line-round-limit": {
	                    type: "number",
	                    "default": 1.05,
	                    requires: [
	                      {
	                        "line-join": "round"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "line-sort-key": {
	                    type: "number",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_symbol = {
	                  "symbol-placement": {
	                    type: "enum",
	                    values: {
	                      point: {},
	                      line: {},
	                      "line-center": {}
	                    },
	                    "default": "point",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "symbol-spacing": {
	                    type: "number",
	                    "default": 250,
	                    minimum: 1,
	                    units: "pixels",
	                    requires: [
	                      {
	                        "symbol-placement": "line"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "symbol-avoid-edges": {
	                    type: "boolean",
	                    "default": false,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "symbol-sort-key": {
	                    type: "number",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "symbol-z-order": {
	                    type: "enum",
	                    values: {
	                      auto: {},
	                      "viewport-y": {},
	                      source: {}
	                    },
	                    "default": "auto",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-allow-overlap": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-ignore-placement": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-optional": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "icon-image",
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-rotation-alignment": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {},
	                      auto: {}
	                    },
	                    "default": "auto",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-size": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    units: "factor of the original icon size",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-text-fit": {
	                    type: "enum",
	                    values: {
	                      none: {},
	                      width: {},
	                      height: {},
	                      both: {}
	                    },
	                    "default": "none",
	                    requires: [
	                      "icon-image",
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-text-fit-padding": {
	                    type: "array",
	                    value: "number",
	                    length: 4,
	                    "default": [
	                      0,
	                      0,
	                      0,
	                      0
	                    ],
	                    units: "pixels",
	                    requires: [
	                      "icon-image",
	                      "text-field",
	                      {
	                        "icon-text-fit": [
	                          "both",
	                          "width",
	                          "height"
	                        ]
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-image": {
	                    type: "resolvedImage",
	                    tokens: true,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-rotate": {
	                    type: "number",
	                    "default": 0,
	                    period: 360,
	                    units: "degrees",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-padding": {
	                    type: "number",
	                    "default": 2,
	                    minimum: 0,
	                    units: "pixels",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-keep-upright": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "icon-image",
	                      {
	                        "icon-rotation-alignment": "map"
	                      },
	                      {
	                        "symbol-placement": [
	                          "line",
	                          "line-center"
	                        ]
	                      }
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-offset": {
	                    type: "array",
	                    value: "number",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-anchor": {
	                    type: "enum",
	                    values: {
	                      center: {},
	                      left: {},
	                      right: {},
	                      top: {},
	                      bottom: {},
	                      "top-left": {},
	                      "top-right": {},
	                      "bottom-left": {},
	                      "bottom-right": {}
	                    },
	                    "default": "center",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-pitch-alignment": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {},
	                      auto: {}
	                    },
	                    "default": "auto",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-pitch-alignment": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {},
	                      auto: {}
	                    },
	                    "default": "auto",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-rotation-alignment": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {},
	                      auto: {}
	                    },
	                    "default": "auto",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-field": {
	                    type: "formatted",
	                    "default": "",
	                    tokens: true,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-font": {
	                    type: "array",
	                    value: "string",
	                    "default": [
	                      "Open Sans Regular",
	                      "Arial Unicode MS Regular"
	                    ],
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-size": {
	                    type: "number",
	                    "default": 16,
	                    minimum: 0,
	                    units: "pixels",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-max-width": {
	                    type: "number",
	                    "default": 10,
	                    minimum: 0,
	                    units: "ems",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-line-height": {
	                    type: "number",
	                    "default": 1.2,
	                    units: "ems",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-letter-spacing": {
	                    type: "number",
	                    "default": 0,
	                    units: "ems",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-justify": {
	                    type: "enum",
	                    values: {
	                      auto: {},
	                      left: {},
	                      center: {},
	                      right: {}
	                    },
	                    "default": "center",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-radial-offset": {
	                    type: "number",
	                    units: "ems",
	                    "default": 0,
	                    requires: [
	                      "text-field"
	                    ],
	                    "property-type": "data-driven",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    }
	                  },
	                  "text-variable-anchor": {
	                    type: "array",
	                    value: "enum",
	                    values: {
	                      center: {},
	                      left: {},
	                      right: {},
	                      top: {},
	                      bottom: {},
	                      "top-left": {},
	                      "top-right": {},
	                      "bottom-left": {},
	                      "bottom-right": {}
	                    },
	                    requires: [
	                      "text-field",
	                      {
	                        "symbol-placement": [
	                          "point"
	                        ]
	                      }
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-anchor": {
	                    type: "enum",
	                    values: {
	                      center: {},
	                      left: {},
	                      right: {},
	                      top: {},
	                      bottom: {},
	                      "top-left": {},
	                      "top-right": {},
	                      "bottom-left": {},
	                      "bottom-right": {}
	                    },
	                    "default": "center",
	                    requires: [
	                      "text-field",
	                      {
	                        "!": "text-variable-anchor"
	                      }
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-max-angle": {
	                    type: "number",
	                    "default": 45,
	                    units: "degrees",
	                    requires: [
	                      "text-field",
	                      {
	                        "symbol-placement": [
	                          "line",
	                          "line-center"
	                        ]
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-writing-mode": {
	                    type: "array",
	                    value: "enum",
	                    values: {
	                      horizontal: {},
	                      vertical: {}
	                    },
	                    requires: [
	                      "text-field",
	                      {
	                        "symbol-placement": [
	                          "point"
	                        ]
	                      }
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-rotate": {
	                    type: "number",
	                    "default": 0,
	                    period: 360,
	                    units: "degrees",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-padding": {
	                    type: "number",
	                    "default": 2,
	                    minimum: 0,
	                    units: "pixels",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-keep-upright": {
	                    type: "boolean",
	                    "default": true,
	                    requires: [
	                      "text-field",
	                      {
	                        "text-rotation-alignment": "map"
	                      },
	                      {
	                        "symbol-placement": [
	                          "line",
	                          "line-center"
	                        ]
	                      }
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-transform": {
	                    type: "enum",
	                    values: {
	                      none: {},
	                      uppercase: {},
	                      lowercase: {}
	                    },
	                    "default": "none",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-offset": {
	                    type: "array",
	                    value: "number",
	                    units: "ems",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    requires: [
	                      "text-field",
	                      {
	                        "!": "text-radial-offset"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-allow-overlap": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-ignore-placement": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-optional": {
	                    type: "boolean",
	                    "default": false,
	                    requires: [
	                      "text-field",
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_raster = {
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var layout_hillshade = {
	                  visibility: {
	                    type: "enum",
	                    values: {
	                      visible: {},
	                      none: {}
	                    },
	                    "default": "visible",
	                    "property-type": "constant"
	                  }
	                };
	                var filter = {
	                  type: "array",
	                  value: "*"
	                };
	                var filter_operator = {
	                  type: "enum",
	                  values: {
	                    "==": {},
	                    "!=": {},
	                    ">": {},
	                    ">=": {},
	                    "<": {},
	                    "<=": {},
	                    "in": {},
	                    "!in": {},
	                    all: {},
	                    any: {},
	                    none: {},
	                    has: {},
	                    "!has": {},
	                    within: {}
	                  }
	                };
	                var geometry_type = {
	                  type: "enum",
	                  values: {
	                    Point: {},
	                    LineString: {},
	                    Polygon: {}
	                  }
	                };
	                var function_stop = {
	                  type: "array",
	                  minimum: 0,
	                  maximum: 24,
	                  value: [
	                    "number",
	                    "color"
	                  ],
	                  length: 2
	                };
	                var expression = {
	                  type: "array",
	                  value: "*",
	                  minimum: 1
	                };
	                var expression_name = {
	                  type: "enum",
	                  values: {
	                    "let": {
	                      group: "Variable binding"
	                    },
	                    "var": {
	                      group: "Variable binding"
	                    },
	                    literal: {
	                      group: "Types"
	                    },
	                    array: {
	                      group: "Types"
	                    },
	                    at: {
	                      group: "Lookup"
	                    },
	                    "in": {
	                      group: "Lookup"
	                    },
	                    "index-of": {
	                      group: "Lookup"
	                    },
	                    slice: {
	                      group: "Lookup"
	                    },
	                    "case": {
	                      group: "Decision"
	                    },
	                    match: {
	                      group: "Decision"
	                    },
	                    coalesce: {
	                      group: "Decision"
	                    },
	                    step: {
	                      group: "Ramps, scales, curves"
	                    },
	                    interpolate: {
	                      group: "Ramps, scales, curves"
	                    },
	                    "interpolate-hcl": {
	                      group: "Ramps, scales, curves"
	                    },
	                    "interpolate-lab": {
	                      group: "Ramps, scales, curves"
	                    },
	                    ln2: {
	                      group: "Math"
	                    },
	                    pi: {
	                      group: "Math"
	                    },
	                    e: {
	                      group: "Math"
	                    },
	                    "typeof": {
	                      group: "Types"
	                    },
	                    string: {
	                      group: "Types"
	                    },
	                    number: {
	                      group: "Types"
	                    },
	                    boolean: {
	                      group: "Types"
	                    },
	                    object: {
	                      group: "Types"
	                    },
	                    collator: {
	                      group: "Types"
	                    },
	                    format: {
	                      group: "Types"
	                    },
	                    image: {
	                      group: "Types"
	                    },
	                    "number-format": {
	                      group: "Types"
	                    },
	                    "to-string": {
	                      group: "Types"
	                    },
	                    "to-number": {
	                      group: "Types"
	                    },
	                    "to-boolean": {
	                      group: "Types"
	                    },
	                    "to-rgba": {
	                      group: "Color"
	                    },
	                    "to-color": {
	                      group: "Types"
	                    },
	                    rgb: {
	                      group: "Color"
	                    },
	                    rgba: {
	                      group: "Color"
	                    },
	                    get: {
	                      group: "Lookup"
	                    },
	                    has: {
	                      group: "Lookup"
	                    },
	                    length: {
	                      group: "Lookup"
	                    },
	                    properties: {
	                      group: "Feature data"
	                    },
	                    "feature-state": {
	                      group: "Feature data"
	                    },
	                    "geometry-type": {
	                      group: "Feature data"
	                    },
	                    id: {
	                      group: "Feature data"
	                    },
	                    zoom: {
	                      group: "Zoom"
	                    },
	                    "heatmap-density": {
	                      group: "Heatmap"
	                    },
	                    "line-progress": {
	                      group: "Feature data"
	                    },
	                    accumulated: {
	                      group: "Feature data"
	                    },
	                    "+": {
	                      group: "Math"
	                    },
	                    "*": {
	                      group: "Math"
	                    },
	                    "-": {
	                      group: "Math"
	                    },
	                    "/": {
	                      group: "Math"
	                    },
	                    "%": {
	                      group: "Math"
	                    },
	                    "^": {
	                      group: "Math"
	                    },
	                    sqrt: {
	                      group: "Math"
	                    },
	                    log10: {
	                      group: "Math"
	                    },
	                    ln: {
	                      group: "Math"
	                    },
	                    log2: {
	                      group: "Math"
	                    },
	                    sin: {
	                      group: "Math"
	                    },
	                    cos: {
	                      group: "Math"
	                    },
	                    tan: {
	                      group: "Math"
	                    },
	                    asin: {
	                      group: "Math"
	                    },
	                    acos: {
	                      group: "Math"
	                    },
	                    atan: {
	                      group: "Math"
	                    },
	                    min: {
	                      group: "Math"
	                    },
	                    max: {
	                      group: "Math"
	                    },
	                    round: {
	                      group: "Math"
	                    },
	                    abs: {
	                      group: "Math"
	                    },
	                    ceil: {
	                      group: "Math"
	                    },
	                    floor: {
	                      group: "Math"
	                    },
	                    distance: {
	                      group: "Math"
	                    },
	                    "==": {
	                      group: "Decision"
	                    },
	                    "!=": {
	                      group: "Decision"
	                    },
	                    ">": {
	                      group: "Decision"
	                    },
	                    "<": {
	                      group: "Decision"
	                    },
	                    ">=": {
	                      group: "Decision"
	                    },
	                    "<=": {
	                      group: "Decision"
	                    },
	                    all: {
	                      group: "Decision"
	                    },
	                    any: {
	                      group: "Decision"
	                    },
	                    "!": {
	                      group: "Decision"
	                    },
	                    within: {
	                      group: "Decision"
	                    },
	                    "is-supported-script": {
	                      group: "String"
	                    },
	                    upcase: {
	                      group: "String"
	                    },
	                    downcase: {
	                      group: "String"
	                    },
	                    concat: {
	                      group: "String"
	                    },
	                    "resolved-locale": {
	                      group: "String"
	                    }
	                  }
	                };
	                var light = {
	                  anchor: {
	                    type: "enum",
	                    "default": "viewport",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "property-type": "data-constant",
	                    transition: false,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    }
	                  },
	                  position: {
	                    type: "array",
	                    "default": [
	                      1.15,
	                      210,
	                      30
	                    ],
	                    length: 3,
	                    value: "number",
	                    "property-type": "data-constant",
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    }
	                  },
	                  color: {
	                    type: "color",
	                    "property-type": "data-constant",
	                    "default": "#ffffff",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    transition: true
	                  },
	                  intensity: {
	                    type: "number",
	                    "property-type": "data-constant",
	                    "default": 0.5,
	                    minimum: 0,
	                    maximum: 1,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    transition: true
	                  }
	                };
	                var paint = [
	                  "paint_fill",
	                  "paint_line",
	                  "paint_circle",
	                  "paint_heatmap",
	                  "paint_fill-extrusion",
	                  "paint_symbol",
	                  "paint_raster",
	                  "paint_hillshade",
	                  "paint_background"
	                ];
	                var paint_fill = {
	                  "fill-antialias": {
	                    type: "boolean",
	                    "default": true,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "fill-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "fill-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    requires: [
	                      {
	                        "!": "fill-pattern"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "fill-outline-color": {
	                    type: "color",
	                    transition: true,
	                    requires: [
	                      {
	                        "!": "fill-pattern"
	                      },
	                      {
	                        "fill-antialias": true
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "fill-translate": {
	                    type: "array",
	                    value: "number",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "fill-translate-anchor": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "map",
	                    requires: [
	                      "fill-translate"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "fill-pattern": {
	                    type: "resolvedImage",
	                    transition: true,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "cross-faded-data-driven"
	                  }
	                };
	                var paint_line = {
	                  "line-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    requires: [
	                      {
	                        "!": "line-pattern"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-translate": {
	                    type: "array",
	                    value: "number",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "line-translate-anchor": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "map",
	                    requires: [
	                      "line-translate"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "line-width": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-gap-width": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-offset": {
	                    type: "number",
	                    "default": 0,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-blur": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "line-dasharray": {
	                    type: "array",
	                    value: "number",
	                    minimum: 0,
	                    transition: true,
	                    units: "line widths",
	                    requires: [
	                      {
	                        "!": "line-pattern"
	                      }
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "cross-faded"
	                  },
	                  "line-pattern": {
	                    type: "resolvedImage",
	                    transition: true,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom",
	                        "feature"
	                      ]
	                    },
	                    "property-type": "cross-faded-data-driven"
	                  },
	                  "line-gradient": {
	                    type: "color",
	                    transition: false,
	                    requires: [
	                      {
	                        "!": "line-dasharray"
	                      },
	                      {
	                        "!": "line-pattern"
	                      },
	                      {
	                        source: "geojson",
	                        has: {
	                          lineMetrics: true
	                        }
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "line-progress"
	                      ]
	                    },
	                    "property-type": "color-ramp"
	                  }
	                };
	                var paint_circle = {
	                  "circle-radius": {
	                    type: "number",
	                    "default": 5,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "circle-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "circle-blur": {
	                    type: "number",
	                    "default": 0,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "circle-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "circle-translate": {
	                    type: "array",
	                    value: "number",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "circle-translate-anchor": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "map",
	                    requires: [
	                      "circle-translate"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "circle-pitch-scale": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "map",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "circle-pitch-alignment": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "viewport",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "circle-stroke-width": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "circle-stroke-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "circle-stroke-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  }
	                };
	                var paint_heatmap = {
	                  "heatmap-radius": {
	                    type: "number",
	                    "default": 30,
	                    minimum: 1,
	                    transition: true,
	                    units: "pixels",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "heatmap-weight": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    transition: false,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "heatmap-intensity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "heatmap-color": {
	                    type: "color",
	                    "default": [
	                      "interpolate",
	                      [
	                        "linear"
	                      ],
	                      [
	                        "heatmap-density"
	                      ],
	                      0,
	                      "rgba(0, 0, 255, 0)",
	                      0.1,
	                      "royalblue",
	                      0.3,
	                      "cyan",
	                      0.5,
	                      "lime",
	                      0.7,
	                      "yellow",
	                      1,
	                      "red"
	                    ],
	                    transition: false,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "heatmap-density"
	                      ]
	                    },
	                    "property-type": "color-ramp"
	                  },
	                  "heatmap-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  }
	                };
	                var paint_symbol = {
	                  "icon-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-halo-color": {
	                    type: "color",
	                    "default": "rgba(0, 0, 0, 0)",
	                    transition: true,
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-halo-width": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-halo-blur": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "icon-translate": {
	                    type: "array",
	                    value: "number",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    transition: true,
	                    units: "pixels",
	                    requires: [
	                      "icon-image"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "icon-translate-anchor": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "map",
	                    requires: [
	                      "icon-image",
	                      "icon-translate"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    overridable: true,
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-halo-color": {
	                    type: "color",
	                    "default": "rgba(0, 0, 0, 0)",
	                    transition: true,
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-halo-width": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-halo-blur": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    transition: true,
	                    units: "pixels",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom",
	                        "feature",
	                        "feature-state"
	                      ]
	                    },
	                    "property-type": "data-driven"
	                  },
	                  "text-translate": {
	                    type: "array",
	                    value: "number",
	                    length: 2,
	                    "default": [
	                      0,
	                      0
	                    ],
	                    transition: true,
	                    units: "pixels",
	                    requires: [
	                      "text-field"
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "text-translate-anchor": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "map",
	                    requires: [
	                      "text-field",
	                      "text-translate"
	                    ],
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  }
	                };
	                var paint_raster = {
	                  "raster-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-hue-rotate": {
	                    type: "number",
	                    "default": 0,
	                    period: 360,
	                    transition: true,
	                    units: "degrees",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-brightness-min": {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-brightness-max": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-saturation": {
	                    type: "number",
	                    "default": 0,
	                    minimum: -1,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-contrast": {
	                    type: "number",
	                    "default": 0,
	                    minimum: -1,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-resampling": {
	                    type: "enum",
	                    values: {
	                      linear: {},
	                      nearest: {}
	                    },
	                    "default": "linear",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "raster-fade-duration": {
	                    type: "number",
	                    "default": 300,
	                    minimum: 0,
	                    transition: false,
	                    units: "milliseconds",
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  }
	                };
	                var paint_hillshade = {
	                  "hillshade-illumination-direction": {
	                    type: "number",
	                    "default": 335,
	                    minimum: 0,
	                    maximum: 359,
	                    transition: false,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "hillshade-illumination-anchor": {
	                    type: "enum",
	                    values: {
	                      map: {},
	                      viewport: {}
	                    },
	                    "default": "viewport",
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "hillshade-exaggeration": {
	                    type: "number",
	                    "default": 0.5,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "hillshade-shadow-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "hillshade-highlight-color": {
	                    type: "color",
	                    "default": "#FFFFFF",
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "hillshade-accent-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  }
	                };
	                var paint_background = {
	                  "background-color": {
	                    type: "color",
	                    "default": "#000000",
	                    transition: true,
	                    requires: [
	                      {
	                        "!": "background-pattern"
	                      }
	                    ],
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  },
	                  "background-pattern": {
	                    type: "resolvedImage",
	                    transition: true,
	                    expression: {
	                      interpolated: false,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "cross-faded"
	                  },
	                  "background-opacity": {
	                    type: "number",
	                    "default": 1,
	                    minimum: 0,
	                    maximum: 1,
	                    transition: true,
	                    expression: {
	                      interpolated: true,
	                      parameters: [
	                        "zoom"
	                      ]
	                    },
	                    "property-type": "data-constant"
	                  }
	                };
	                var transition = {
	                  duration: {
	                    type: "number",
	                    "default": 300,
	                    minimum: 0,
	                    units: "milliseconds"
	                  },
	                  delay: {
	                    type: "number",
	                    "default": 0,
	                    minimum: 0,
	                    units: "milliseconds"
	                  }
	                };
	                var promoteId = {
	                  "*": {
	                    type: "string"
	                  }
	                };
	                var spec = {
	                  $version,
	                  $root,
	                  sources,
	                  source,
	                  source_vector,
	                  source_raster,
	                  source_raster_dem,
	                  source_geojson,
	                  source_video,
	                  source_image,
	                  layer,
	                  layout,
	                  layout_background,
	                  layout_fill,
	                  layout_circle,
	                  layout_heatmap,
	                  "layout_fill-extrusion": {
	                    visibility: {
	                      type: "enum",
	                      values: {
	                        visible: {},
	                        none: {}
	                      },
	                      "default": "visible",
	                      "property-type": "constant"
	                    }
	                  },
	                  layout_line,
	                  layout_symbol,
	                  layout_raster,
	                  layout_hillshade,
	                  filter,
	                  filter_operator,
	                  geometry_type,
	                  "function": {
	                    expression: {
	                      type: "expression"
	                    },
	                    stops: {
	                      type: "array",
	                      value: "function_stop"
	                    },
	                    base: {
	                      type: "number",
	                      "default": 1,
	                      minimum: 0
	                    },
	                    property: {
	                      type: "string",
	                      "default": "$zoom"
	                    },
	                    type: {
	                      type: "enum",
	                      values: {
	                        identity: {},
	                        exponential: {},
	                        interval: {},
	                        categorical: {}
	                      },
	                      "default": "exponential"
	                    },
	                    colorSpace: {
	                      type: "enum",
	                      values: {
	                        rgb: {},
	                        lab: {},
	                        hcl: {}
	                      },
	                      "default": "rgb"
	                    },
	                    "default": {
	                      type: "*",
	                      required: false
	                    }
	                  },
	                  function_stop,
	                  expression,
	                  expression_name,
	                  light,
	                  paint,
	                  paint_fill,
	                  "paint_fill-extrusion": {
	                    "fill-extrusion-opacity": {
	                      type: "number",
	                      "default": 1,
	                      minimum: 0,
	                      maximum: 1,
	                      transition: true,
	                      expression: {
	                        interpolated: true,
	                        parameters: [
	                          "zoom"
	                        ]
	                      },
	                      "property-type": "data-constant"
	                    },
	                    "fill-extrusion-color": {
	                      type: "color",
	                      "default": "#000000",
	                      transition: true,
	                      requires: [
	                        {
	                          "!": "fill-extrusion-pattern"
	                        }
	                      ],
	                      expression: {
	                        interpolated: true,
	                        parameters: [
	                          "zoom",
	                          "feature",
	                          "feature-state"
	                        ]
	                      },
	                      "property-type": "data-driven"
	                    },
	                    "fill-extrusion-translate": {
	                      type: "array",
	                      value: "number",
	                      length: 2,
	                      "default": [
	                        0,
	                        0
	                      ],
	                      transition: true,
	                      units: "pixels",
	                      expression: {
	                        interpolated: true,
	                        parameters: [
	                          "zoom"
	                        ]
	                      },
	                      "property-type": "data-constant"
	                    },
	                    "fill-extrusion-translate-anchor": {
	                      type: "enum",
	                      values: {
	                        map: {},
	                        viewport: {}
	                      },
	                      "default": "map",
	                      requires: [
	                        "fill-extrusion-translate"
	                      ],
	                      expression: {
	                        interpolated: false,
	                        parameters: [
	                          "zoom"
	                        ]
	                      },
	                      "property-type": "data-constant"
	                    },
	                    "fill-extrusion-pattern": {
	                      type: "resolvedImage",
	                      transition: true,
	                      expression: {
	                        interpolated: false,
	                        parameters: [
	                          "zoom",
	                          "feature"
	                        ]
	                      },
	                      "property-type": "cross-faded-data-driven"
	                    },
	                    "fill-extrusion-height": {
	                      type: "number",
	                      "default": 0,
	                      minimum: 0,
	                      units: "meters",
	                      transition: true,
	                      expression: {
	                        interpolated: true,
	                        parameters: [
	                          "zoom",
	                          "feature",
	                          "feature-state"
	                        ]
	                      },
	                      "property-type": "data-driven"
	                    },
	                    "fill-extrusion-base": {
	                      type: "number",
	                      "default": 0,
	                      minimum: 0,
	                      units: "meters",
	                      transition: true,
	                      requires: [
	                        "fill-extrusion-height"
	                      ],
	                      expression: {
	                        interpolated: true,
	                        parameters: [
	                          "zoom",
	                          "feature",
	                          "feature-state"
	                        ]
	                      },
	                      "property-type": "data-driven"
	                    },
	                    "fill-extrusion-vertical-gradient": {
	                      type: "boolean",
	                      "default": true,
	                      transition: false,
	                      expression: {
	                        interpolated: false,
	                        parameters: [
	                          "zoom"
	                        ]
	                      },
	                      "property-type": "data-constant"
	                    }
	                  },
	                  paint_line,
	                  paint_circle,
	                  paint_heatmap,
	                  paint_symbol,
	                  paint_raster,
	                  paint_hillshade,
	                  paint_background,
	                  transition,
	                  "property-type": {
	                    "data-driven": {
	                      type: "property-type"
	                    },
	                    "cross-faded": {
	                      type: "property-type"
	                    },
	                    "cross-faded-data-driven": {
	                      type: "property-type"
	                    },
	                    "color-ramp": {
	                      type: "property-type"
	                    },
	                    "data-constant": {
	                      type: "property-type"
	                    },
	                    constant: {
	                      type: "property-type"
	                    }
	                  },
	                  promoteId
	                };
	                var ValidationError = function ValidationError2(key, value, message, identifier) {
	                  this.message = (key ? key + ": " : "") + message;
	                  if (identifier) {
	                    this.identifier = identifier;
	                  }
	                  if (value !== null && value !== undefined && value.__line__) {
	                    this.line = value.__line__;
	                  }
	                };
	                function validateConstants(options) {
	                  var key = options.key;
	                  var constants = options.value;
	                  if (constants) {
	                    return [new ValidationError(key, constants, "constants have been deprecated as of v8")];
	                  } else {
	                    return [];
	                  }
	                }
	                function extend$1(output) {
	                  var inputs = [], len = arguments.length - 1;
	                  while (len-- > 0)
	                    inputs[len] = arguments[len + 1];
	                  for (var i = 0, list = inputs; i < list.length; i += 1) {
	                    var input = list[i];
	                    for (var k in input) {
	                      output[k] = input[k];
	                    }
	                  }
	                  return output;
	                }
	                function unbundle(value) {
	                  if (value instanceof Number || value instanceof String || value instanceof Boolean) {
	                    return value.valueOf();
	                  } else {
	                    return value;
	                  }
	                }
	                function deepUnbundle(value) {
	                  if (Array.isArray(value)) {
	                    return value.map(deepUnbundle);
	                  } else if (value instanceof Object && !(value instanceof Number || value instanceof String || value instanceof Boolean)) {
	                    var unbundledValue = {};
	                    for (var key in value) {
	                      unbundledValue[key] = deepUnbundle(value[key]);
	                    }
	                    return unbundledValue;
	                  }
	                  return unbundle(value);
	                }
	                var ParsingError = function(Error2) {
	                  function ParsingError2(key, message) {
	                    Error2.call(this, message);
	                    this.message = message;
	                    this.key = key;
	                  }
	                  if (Error2)
	                    ParsingError2.__proto__ = Error2;
	                  ParsingError2.prototype = Object.create(Error2 && Error2.prototype);
	                  ParsingError2.prototype.constructor = ParsingError2;
	                  return ParsingError2;
	                }(Error);
	                var Scope = function Scope2(parent, bindings) {
	                  if (bindings === undefined)
	                    bindings = [];
	                  this.parent = parent;
	                  this.bindings = {};
	                  for (var i = 0, list = bindings; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var name3 = ref[0];
	                    var expression2 = ref[1];
	                    this.bindings[name3] = expression2;
	                  }
	                };
	                Scope.prototype.concat = function concat(bindings) {
	                  return new Scope(this, bindings);
	                };
	                Scope.prototype.get = function get2(name3) {
	                  if (this.bindings[name3]) {
	                    return this.bindings[name3];
	                  }
	                  if (this.parent) {
	                    return this.parent.get(name3);
	                  }
	                  throw new Error(name3 + " not found in scope.");
	                };
	                Scope.prototype.has = function has2(name3) {
	                  if (this.bindings[name3]) {
	                    return true;
	                  }
	                  return this.parent ? this.parent.has(name3) : false;
	                };
	                var NullType = { kind: "null" };
	                var NumberType = { kind: "number" };
	                var StringType = { kind: "string" };
	                var BooleanType = { kind: "boolean" };
	                var ColorType = { kind: "color" };
	                var ObjectType = { kind: "object" };
	                var ValueType = { kind: "value" };
	                var ErrorType = { kind: "error" };
	                var CollatorType = { kind: "collator" };
	                var FormattedType = { kind: "formatted" };
	                var ResolvedImageType = { kind: "resolvedImage" };
	                function array(itemType, N) {
	                  return {
	                    kind: "array",
	                    itemType,
	                    N
	                  };
	                }
	                function toString(type) {
	                  if (type.kind === "array") {
	                    var itemType = toString(type.itemType);
	                    return typeof type.N === "number" ? "array<" + itemType + ", " + type.N + ">" : type.itemType.kind === "value" ? "array" : "array<" + itemType + ">";
	                  } else {
	                    return type.kind;
	                  }
	                }
	                var valueMemberTypes = [
	                  NullType,
	                  NumberType,
	                  StringType,
	                  BooleanType,
	                  ColorType,
	                  FormattedType,
	                  ObjectType,
	                  array(ValueType),
	                  ResolvedImageType
	                ];
	                function checkSubtype(expected, t) {
	                  if (t.kind === "error") {
	                    return null;
	                  } else if (expected.kind === "array") {
	                    if (t.kind === "array" && (t.N === 0 && t.itemType.kind === "value" || !checkSubtype(expected.itemType, t.itemType)) && (typeof expected.N !== "number" || expected.N === t.N)) {
	                      return null;
	                    }
	                  } else if (expected.kind === t.kind) {
	                    return null;
	                  } else if (expected.kind === "value") {
	                    for (var i = 0, list = valueMemberTypes; i < list.length; i += 1) {
	                      var memberType = list[i];
	                      if (!checkSubtype(memberType, t)) {
	                        return null;
	                      }
	                    }
	                  }
	                  return "Expected " + toString(expected) + " but found " + toString(t) + " instead.";
	                }
	                function isValidType(provided, allowedTypes) {
	                  return allowedTypes.some(function(t) {
	                    return t.kind === provided.kind;
	                  });
	                }
	                function isValidNativeType(provided, allowedTypes) {
	                  return allowedTypes.some(function(t) {
	                    if (t === "null") {
	                      return provided === null;
	                    } else if (t === "array") {
	                      return Array.isArray(provided);
	                    } else if (t === "object") {
	                      return provided && !Array.isArray(provided) && typeof provided === "object";
	                    } else {
	                      return t === typeof provided;
	                    }
	                  });
	                }
	                var csscolorparser = createCommonjsModule(function(module3, exports3) {
	                  var kCSSColorTable = {
	                    "transparent": [
	                      0,
	                      0,
	                      0,
	                      0
	                    ],
	                    "aliceblue": [
	                      240,
	                      248,
	                      255,
	                      1
	                    ],
	                    "antiquewhite": [
	                      250,
	                      235,
	                      215,
	                      1
	                    ],
	                    "aqua": [
	                      0,
	                      255,
	                      255,
	                      1
	                    ],
	                    "aquamarine": [
	                      127,
	                      255,
	                      212,
	                      1
	                    ],
	                    "azure": [
	                      240,
	                      255,
	                      255,
	                      1
	                    ],
	                    "beige": [
	                      245,
	                      245,
	                      220,
	                      1
	                    ],
	                    "bisque": [
	                      255,
	                      228,
	                      196,
	                      1
	                    ],
	                    "black": [
	                      0,
	                      0,
	                      0,
	                      1
	                    ],
	                    "blanchedalmond": [
	                      255,
	                      235,
	                      205,
	                      1
	                    ],
	                    "blue": [
	                      0,
	                      0,
	                      255,
	                      1
	                    ],
	                    "blueviolet": [
	                      138,
	                      43,
	                      226,
	                      1
	                    ],
	                    "brown": [
	                      165,
	                      42,
	                      42,
	                      1
	                    ],
	                    "burlywood": [
	                      222,
	                      184,
	                      135,
	                      1
	                    ],
	                    "cadetblue": [
	                      95,
	                      158,
	                      160,
	                      1
	                    ],
	                    "chartreuse": [
	                      127,
	                      255,
	                      0,
	                      1
	                    ],
	                    "chocolate": [
	                      210,
	                      105,
	                      30,
	                      1
	                    ],
	                    "coral": [
	                      255,
	                      127,
	                      80,
	                      1
	                    ],
	                    "cornflowerblue": [
	                      100,
	                      149,
	                      237,
	                      1
	                    ],
	                    "cornsilk": [
	                      255,
	                      248,
	                      220,
	                      1
	                    ],
	                    "crimson": [
	                      220,
	                      20,
	                      60,
	                      1
	                    ],
	                    "cyan": [
	                      0,
	                      255,
	                      255,
	                      1
	                    ],
	                    "darkblue": [
	                      0,
	                      0,
	                      139,
	                      1
	                    ],
	                    "darkcyan": [
	                      0,
	                      139,
	                      139,
	                      1
	                    ],
	                    "darkgoldenrod": [
	                      184,
	                      134,
	                      11,
	                      1
	                    ],
	                    "darkgray": [
	                      169,
	                      169,
	                      169,
	                      1
	                    ],
	                    "darkgreen": [
	                      0,
	                      100,
	                      0,
	                      1
	                    ],
	                    "darkgrey": [
	                      169,
	                      169,
	                      169,
	                      1
	                    ],
	                    "darkkhaki": [
	                      189,
	                      183,
	                      107,
	                      1
	                    ],
	                    "darkmagenta": [
	                      139,
	                      0,
	                      139,
	                      1
	                    ],
	                    "darkolivegreen": [
	                      85,
	                      107,
	                      47,
	                      1
	                    ],
	                    "darkorange": [
	                      255,
	                      140,
	                      0,
	                      1
	                    ],
	                    "darkorchid": [
	                      153,
	                      50,
	                      204,
	                      1
	                    ],
	                    "darkred": [
	                      139,
	                      0,
	                      0,
	                      1
	                    ],
	                    "darksalmon": [
	                      233,
	                      150,
	                      122,
	                      1
	                    ],
	                    "darkseagreen": [
	                      143,
	                      188,
	                      143,
	                      1
	                    ],
	                    "darkslateblue": [
	                      72,
	                      61,
	                      139,
	                      1
	                    ],
	                    "darkslategray": [
	                      47,
	                      79,
	                      79,
	                      1
	                    ],
	                    "darkslategrey": [
	                      47,
	                      79,
	                      79,
	                      1
	                    ],
	                    "darkturquoise": [
	                      0,
	                      206,
	                      209,
	                      1
	                    ],
	                    "darkviolet": [
	                      148,
	                      0,
	                      211,
	                      1
	                    ],
	                    "deeppink": [
	                      255,
	                      20,
	                      147,
	                      1
	                    ],
	                    "deepskyblue": [
	                      0,
	                      191,
	                      255,
	                      1
	                    ],
	                    "dimgray": [
	                      105,
	                      105,
	                      105,
	                      1
	                    ],
	                    "dimgrey": [
	                      105,
	                      105,
	                      105,
	                      1
	                    ],
	                    "dodgerblue": [
	                      30,
	                      144,
	                      255,
	                      1
	                    ],
	                    "firebrick": [
	                      178,
	                      34,
	                      34,
	                      1
	                    ],
	                    "floralwhite": [
	                      255,
	                      250,
	                      240,
	                      1
	                    ],
	                    "forestgreen": [
	                      34,
	                      139,
	                      34,
	                      1
	                    ],
	                    "fuchsia": [
	                      255,
	                      0,
	                      255,
	                      1
	                    ],
	                    "gainsboro": [
	                      220,
	                      220,
	                      220,
	                      1
	                    ],
	                    "ghostwhite": [
	                      248,
	                      248,
	                      255,
	                      1
	                    ],
	                    "gold": [
	                      255,
	                      215,
	                      0,
	                      1
	                    ],
	                    "goldenrod": [
	                      218,
	                      165,
	                      32,
	                      1
	                    ],
	                    "gray": [
	                      128,
	                      128,
	                      128,
	                      1
	                    ],
	                    "green": [
	                      0,
	                      128,
	                      0,
	                      1
	                    ],
	                    "greenyellow": [
	                      173,
	                      255,
	                      47,
	                      1
	                    ],
	                    "grey": [
	                      128,
	                      128,
	                      128,
	                      1
	                    ],
	                    "honeydew": [
	                      240,
	                      255,
	                      240,
	                      1
	                    ],
	                    "hotpink": [
	                      255,
	                      105,
	                      180,
	                      1
	                    ],
	                    "indianred": [
	                      205,
	                      92,
	                      92,
	                      1
	                    ],
	                    "indigo": [
	                      75,
	                      0,
	                      130,
	                      1
	                    ],
	                    "ivory": [
	                      255,
	                      255,
	                      240,
	                      1
	                    ],
	                    "khaki": [
	                      240,
	                      230,
	                      140,
	                      1
	                    ],
	                    "lavender": [
	                      230,
	                      230,
	                      250,
	                      1
	                    ],
	                    "lavenderblush": [
	                      255,
	                      240,
	                      245,
	                      1
	                    ],
	                    "lawngreen": [
	                      124,
	                      252,
	                      0,
	                      1
	                    ],
	                    "lemonchiffon": [
	                      255,
	                      250,
	                      205,
	                      1
	                    ],
	                    "lightblue": [
	                      173,
	                      216,
	                      230,
	                      1
	                    ],
	                    "lightcoral": [
	                      240,
	                      128,
	                      128,
	                      1
	                    ],
	                    "lightcyan": [
	                      224,
	                      255,
	                      255,
	                      1
	                    ],
	                    "lightgoldenrodyellow": [
	                      250,
	                      250,
	                      210,
	                      1
	                    ],
	                    "lightgray": [
	                      211,
	                      211,
	                      211,
	                      1
	                    ],
	                    "lightgreen": [
	                      144,
	                      238,
	                      144,
	                      1
	                    ],
	                    "lightgrey": [
	                      211,
	                      211,
	                      211,
	                      1
	                    ],
	                    "lightpink": [
	                      255,
	                      182,
	                      193,
	                      1
	                    ],
	                    "lightsalmon": [
	                      255,
	                      160,
	                      122,
	                      1
	                    ],
	                    "lightseagreen": [
	                      32,
	                      178,
	                      170,
	                      1
	                    ],
	                    "lightskyblue": [
	                      135,
	                      206,
	                      250,
	                      1
	                    ],
	                    "lightslategray": [
	                      119,
	                      136,
	                      153,
	                      1
	                    ],
	                    "lightslategrey": [
	                      119,
	                      136,
	                      153,
	                      1
	                    ],
	                    "lightsteelblue": [
	                      176,
	                      196,
	                      222,
	                      1
	                    ],
	                    "lightyellow": [
	                      255,
	                      255,
	                      224,
	                      1
	                    ],
	                    "lime": [
	                      0,
	                      255,
	                      0,
	                      1
	                    ],
	                    "limegreen": [
	                      50,
	                      205,
	                      50,
	                      1
	                    ],
	                    "linen": [
	                      250,
	                      240,
	                      230,
	                      1
	                    ],
	                    "magenta": [
	                      255,
	                      0,
	                      255,
	                      1
	                    ],
	                    "maroon": [
	                      128,
	                      0,
	                      0,
	                      1
	                    ],
	                    "mediumaquamarine": [
	                      102,
	                      205,
	                      170,
	                      1
	                    ],
	                    "mediumblue": [
	                      0,
	                      0,
	                      205,
	                      1
	                    ],
	                    "mediumorchid": [
	                      186,
	                      85,
	                      211,
	                      1
	                    ],
	                    "mediumpurple": [
	                      147,
	                      112,
	                      219,
	                      1
	                    ],
	                    "mediumseagreen": [
	                      60,
	                      179,
	                      113,
	                      1
	                    ],
	                    "mediumslateblue": [
	                      123,
	                      104,
	                      238,
	                      1
	                    ],
	                    "mediumspringgreen": [
	                      0,
	                      250,
	                      154,
	                      1
	                    ],
	                    "mediumturquoise": [
	                      72,
	                      209,
	                      204,
	                      1
	                    ],
	                    "mediumvioletred": [
	                      199,
	                      21,
	                      133,
	                      1
	                    ],
	                    "midnightblue": [
	                      25,
	                      25,
	                      112,
	                      1
	                    ],
	                    "mintcream": [
	                      245,
	                      255,
	                      250,
	                      1
	                    ],
	                    "mistyrose": [
	                      255,
	                      228,
	                      225,
	                      1
	                    ],
	                    "moccasin": [
	                      255,
	                      228,
	                      181,
	                      1
	                    ],
	                    "navajowhite": [
	                      255,
	                      222,
	                      173,
	                      1
	                    ],
	                    "navy": [
	                      0,
	                      0,
	                      128,
	                      1
	                    ],
	                    "oldlace": [
	                      253,
	                      245,
	                      230,
	                      1
	                    ],
	                    "olive": [
	                      128,
	                      128,
	                      0,
	                      1
	                    ],
	                    "olivedrab": [
	                      107,
	                      142,
	                      35,
	                      1
	                    ],
	                    "orange": [
	                      255,
	                      165,
	                      0,
	                      1
	                    ],
	                    "orangered": [
	                      255,
	                      69,
	                      0,
	                      1
	                    ],
	                    "orchid": [
	                      218,
	                      112,
	                      214,
	                      1
	                    ],
	                    "palegoldenrod": [
	                      238,
	                      232,
	                      170,
	                      1
	                    ],
	                    "palegreen": [
	                      152,
	                      251,
	                      152,
	                      1
	                    ],
	                    "paleturquoise": [
	                      175,
	                      238,
	                      238,
	                      1
	                    ],
	                    "palevioletred": [
	                      219,
	                      112,
	                      147,
	                      1
	                    ],
	                    "papayawhip": [
	                      255,
	                      239,
	                      213,
	                      1
	                    ],
	                    "peachpuff": [
	                      255,
	                      218,
	                      185,
	                      1
	                    ],
	                    "peru": [
	                      205,
	                      133,
	                      63,
	                      1
	                    ],
	                    "pink": [
	                      255,
	                      192,
	                      203,
	                      1
	                    ],
	                    "plum": [
	                      221,
	                      160,
	                      221,
	                      1
	                    ],
	                    "powderblue": [
	                      176,
	                      224,
	                      230,
	                      1
	                    ],
	                    "purple": [
	                      128,
	                      0,
	                      128,
	                      1
	                    ],
	                    "rebeccapurple": [
	                      102,
	                      51,
	                      153,
	                      1
	                    ],
	                    "red": [
	                      255,
	                      0,
	                      0,
	                      1
	                    ],
	                    "rosybrown": [
	                      188,
	                      143,
	                      143,
	                      1
	                    ],
	                    "royalblue": [
	                      65,
	                      105,
	                      225,
	                      1
	                    ],
	                    "saddlebrown": [
	                      139,
	                      69,
	                      19,
	                      1
	                    ],
	                    "salmon": [
	                      250,
	                      128,
	                      114,
	                      1
	                    ],
	                    "sandybrown": [
	                      244,
	                      164,
	                      96,
	                      1
	                    ],
	                    "seagreen": [
	                      46,
	                      139,
	                      87,
	                      1
	                    ],
	                    "seashell": [
	                      255,
	                      245,
	                      238,
	                      1
	                    ],
	                    "sienna": [
	                      160,
	                      82,
	                      45,
	                      1
	                    ],
	                    "silver": [
	                      192,
	                      192,
	                      192,
	                      1
	                    ],
	                    "skyblue": [
	                      135,
	                      206,
	                      235,
	                      1
	                    ],
	                    "slateblue": [
	                      106,
	                      90,
	                      205,
	                      1
	                    ],
	                    "slategray": [
	                      112,
	                      128,
	                      144,
	                      1
	                    ],
	                    "slategrey": [
	                      112,
	                      128,
	                      144,
	                      1
	                    ],
	                    "snow": [
	                      255,
	                      250,
	                      250,
	                      1
	                    ],
	                    "springgreen": [
	                      0,
	                      255,
	                      127,
	                      1
	                    ],
	                    "steelblue": [
	                      70,
	                      130,
	                      180,
	                      1
	                    ],
	                    "tan": [
	                      210,
	                      180,
	                      140,
	                      1
	                    ],
	                    "teal": [
	                      0,
	                      128,
	                      128,
	                      1
	                    ],
	                    "thistle": [
	                      216,
	                      191,
	                      216,
	                      1
	                    ],
	                    "tomato": [
	                      255,
	                      99,
	                      71,
	                      1
	                    ],
	                    "turquoise": [
	                      64,
	                      224,
	                      208,
	                      1
	                    ],
	                    "violet": [
	                      238,
	                      130,
	                      238,
	                      1
	                    ],
	                    "wheat": [
	                      245,
	                      222,
	                      179,
	                      1
	                    ],
	                    "white": [
	                      255,
	                      255,
	                      255,
	                      1
	                    ],
	                    "whitesmoke": [
	                      245,
	                      245,
	                      245,
	                      1
	                    ],
	                    "yellow": [
	                      255,
	                      255,
	                      0,
	                      1
	                    ],
	                    "yellowgreen": [
	                      154,
	                      205,
	                      50,
	                      1
	                    ]
	                  };
	                  function clamp_css_byte(i) {
	                    i = Math.round(i);
	                    return i < 0 ? 0 : i > 255 ? 255 : i;
	                  }
	                  function clamp_css_float(f) {
	                    return f < 0 ? 0 : f > 1 ? 1 : f;
	                  }
	                  function parse_css_int(str) {
	                    if (str[str.length - 1] === "%") {
	                      return clamp_css_byte(parseFloat(str) / 100 * 255);
	                    }
	                    return clamp_css_byte(parseInt(str));
	                  }
	                  function parse_css_float(str) {
	                    if (str[str.length - 1] === "%") {
	                      return clamp_css_float(parseFloat(str) / 100);
	                    }
	                    return clamp_css_float(parseFloat(str));
	                  }
	                  function css_hue_to_rgb(m1, m2, h) {
	                    if (h < 0) {
	                      h += 1;
	                    } else if (h > 1) {
	                      h -= 1;
	                    }
	                    if (h * 6 < 1) {
	                      return m1 + (m2 - m1) * h * 6;
	                    }
	                    if (h * 2 < 1) {
	                      return m2;
	                    }
	                    if (h * 3 < 2) {
	                      return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	                    }
	                    return m1;
	                  }
	                  function parseCSSColor(css_str) {
	                    var str = css_str.replace(/ /g, "").toLowerCase();
	                    if (str in kCSSColorTable) {
	                      return kCSSColorTable[str].slice();
	                    }
	                    if (str[0] === "#") {
	                      if (str.length === 4) {
	                        var iv = parseInt(str.substr(1), 16);
	                        if (!(iv >= 0 && iv <= 4095)) {
	                          return null;
	                        }
	                        return [
	                          (iv & 3840) >> 4 | (iv & 3840) >> 8,
	                          iv & 240 | (iv & 240) >> 4,
	                          iv & 15 | (iv & 15) << 4,
	                          1
	                        ];
	                      } else if (str.length === 7) {
	                        var iv = parseInt(str.substr(1), 16);
	                        if (!(iv >= 0 && iv <= 16777215)) {
	                          return null;
	                        }
	                        return [
	                          (iv & 16711680) >> 16,
	                          (iv & 65280) >> 8,
	                          iv & 255,
	                          1
	                        ];
	                      }
	                      return null;
	                    }
	                    var op = str.indexOf("("), ep = str.indexOf(")");
	                    if (op !== -1 && ep + 1 === str.length) {
	                      var fname = str.substr(0, op);
	                      var params = str.substr(op + 1, ep - (op + 1)).split(",");
	                      var alpha = 1;
	                      switch (fname) {
	                        case "rgba":
	                          if (params.length !== 4) {
	                            return null;
	                          }
	                          alpha = parse_css_float(params.pop());
	                        case "rgb":
	                          if (params.length !== 3) {
	                            return null;
	                          }
	                          return [
	                            parse_css_int(params[0]),
	                            parse_css_int(params[1]),
	                            parse_css_int(params[2]),
	                            alpha
	                          ];
	                        case "hsla":
	                          if (params.length !== 4) {
	                            return null;
	                          }
	                          alpha = parse_css_float(params.pop());
	                        case "hsl":
	                          if (params.length !== 3) {
	                            return null;
	                          }
	                          var h = (parseFloat(params[0]) % 360 + 360) % 360 / 360;
	                          var s = parse_css_float(params[1]);
	                          var l = parse_css_float(params[2]);
	                          var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	                          var m1 = l * 2 - m2;
	                          return [
	                            clamp_css_byte(css_hue_to_rgb(m1, m2, h + 1 / 3) * 255),
	                            clamp_css_byte(css_hue_to_rgb(m1, m2, h) * 255),
	                            clamp_css_byte(css_hue_to_rgb(m1, m2, h - 1 / 3) * 255),
	                            alpha
	                          ];
	                        default:
	                          return null;
	                      }
	                    }
	                    return null;
	                  }
	                  try {
	                    exports3.parseCSSColor = parseCSSColor;
	                  } catch (e) {
	                  }
	                });
	                var csscolorparser_1 = csscolorparser.parseCSSColor;
	                var Color = function Color2(r, g, b, a) {
	                  if (a === undefined)
	                    a = 1;
	                  this.r = r;
	                  this.g = g;
	                  this.b = b;
	                  this.a = a;
	                };
	                Color.parse = function parse(input) {
	                  if (!input) {
	                    return undefined;
	                  }
	                  if (input instanceof Color) {
	                    return input;
	                  }
	                  if (typeof input !== "string") {
	                    return undefined;
	                  }
	                  var rgba2 = csscolorparser_1(input);
	                  if (!rgba2) {
	                    return undefined;
	                  }
	                  return new Color(rgba2[0] / 255 * rgba2[3], rgba2[1] / 255 * rgba2[3], rgba2[2] / 255 * rgba2[3], rgba2[3]);
	                };
	                Color.prototype.toString = function toString2() {
	                  var ref = this.toArray();
	                  var r = ref[0];
	                  var g = ref[1];
	                  var b = ref[2];
	                  var a = ref[3];
	                  return "rgba(" + Math.round(r) + "," + Math.round(g) + "," + Math.round(b) + "," + a + ")";
	                };
	                Color.prototype.toArray = function toArray() {
	                  var ref = this;
	                  var r = ref.r;
	                  var g = ref.g;
	                  var b = ref.b;
	                  var a = ref.a;
	                  return a === 0 ? [
	                    0,
	                    0,
	                    0,
	                    0
	                  ] : [
	                    r * 255 / a,
	                    g * 255 / a,
	                    b * 255 / a,
	                    a
	                  ];
	                };
	                Color.black = new Color(0, 0, 0, 1);
	                Color.white = new Color(1, 1, 1, 1);
	                Color.transparent = new Color(0, 0, 0, 0);
	                Color.red = new Color(1, 0, 0, 1);
	                var Collator = function Collator2(caseSensitive, diacriticSensitive, locale) {
	                  if (caseSensitive) {
	                    this.sensitivity = diacriticSensitive ? "variant" : "case";
	                  } else {
	                    this.sensitivity = diacriticSensitive ? "accent" : "base";
	                  }
	                  this.locale = locale;
	                  this.collator = new Intl.Collator(this.locale ? this.locale : [], {
	                    sensitivity: this.sensitivity,
	                    usage: "search"
	                  });
	                };
	                Collator.prototype.compare = function compare2(lhs, rhs) {
	                  return this.collator.compare(lhs, rhs);
	                };
	                Collator.prototype.resolvedLocale = function resolvedLocale() {
	                  return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
	                };
	                var FormattedSection = function FormattedSection2(text, image, scale2, fontStack, textColor) {
	                  this.text = text;
	                  this.image = image;
	                  this.scale = scale2;
	                  this.fontStack = fontStack;
	                  this.textColor = textColor;
	                };
	                var Formatted = function Formatted2(sections) {
	                  this.sections = sections;
	                };
	                Formatted.fromString = function fromString(unformatted) {
	                  return new Formatted([new FormattedSection(unformatted, null, null, null, null)]);
	                };
	                Formatted.prototype.isEmpty = function isEmpty2() {
	                  if (this.sections.length === 0) {
	                    return true;
	                  }
	                  return !this.sections.some(function(section) {
	                    return section.text.length !== 0 || section.image && section.image.name.length !== 0;
	                  });
	                };
	                Formatted.factory = function factory(text) {
	                  if (text instanceof Formatted) {
	                    return text;
	                  } else {
	                    return Formatted.fromString(text);
	                  }
	                };
	                Formatted.prototype.toString = function toString2() {
	                  if (this.sections.length === 0) {
	                    return "";
	                  }
	                  return this.sections.map(function(section) {
	                    return section.text;
	                  }).join("");
	                };
	                Formatted.prototype.serialize = function serialize2() {
	                  var serialized = ["format"];
	                  for (var i = 0, list = this.sections; i < list.length; i += 1) {
	                    var section = list[i];
	                    if (section.image) {
	                      serialized.push([
	                        "image",
	                        section.image.name
	                      ]);
	                      continue;
	                    }
	                    serialized.push(section.text);
	                    var options = {};
	                    if (section.fontStack) {
	                      options["text-font"] = [
	                        "literal",
	                        section.fontStack.split(",")
	                      ];
	                    }
	                    if (section.scale) {
	                      options["font-scale"] = section.scale;
	                    }
	                    if (section.textColor) {
	                      options["text-color"] = ["rgba"].concat(section.textColor.toArray());
	                    }
	                    serialized.push(options);
	                  }
	                  return serialized;
	                };
	                var ResolvedImage = function ResolvedImage2(options) {
	                  this.name = options.name;
	                  this.available = options.available;
	                };
	                ResolvedImage.prototype.toString = function toString2() {
	                  return this.name;
	                };
	                ResolvedImage.fromString = function fromString(name3) {
	                  if (!name3) {
	                    return null;
	                  }
	                  return new ResolvedImage({
	                    name: name3,
	                    available: false
	                  });
	                };
	                ResolvedImage.prototype.serialize = function serialize2() {
	                  return [
	                    "image",
	                    this.name
	                  ];
	                };
	                function validateRGBA(r, g, b, a) {
	                  if (!(typeof r === "number" && r >= 0 && r <= 255 && typeof g === "number" && g >= 0 && g <= 255 && typeof b === "number" && b >= 0 && b <= 255)) {
	                    var value = typeof a === "number" ? [
	                      r,
	                      g,
	                      b,
	                      a
	                    ] : [
	                      r,
	                      g,
	                      b
	                    ];
	                    return "Invalid rgba value [" + value.join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
	                  }
	                  if (!(typeof a === "undefined" || typeof a === "number" && a >= 0 && a <= 1)) {
	                    return "Invalid rgba value [" + [
	                      r,
	                      g,
	                      b,
	                      a
	                    ].join(", ") + "]: 'a' must be between 0 and 1.";
	                  }
	                  return null;
	                }
	                function isValue(mixed) {
	                  if (mixed === null) {
	                    return true;
	                  } else if (typeof mixed === "string") {
	                    return true;
	                  } else if (typeof mixed === "boolean") {
	                    return true;
	                  } else if (typeof mixed === "number") {
	                    return true;
	                  } else if (mixed instanceof Color) {
	                    return true;
	                  } else if (mixed instanceof Collator) {
	                    return true;
	                  } else if (mixed instanceof Formatted) {
	                    return true;
	                  } else if (mixed instanceof ResolvedImage) {
	                    return true;
	                  } else if (Array.isArray(mixed)) {
	                    for (var i = 0, list = mixed; i < list.length; i += 1) {
	                      var item = list[i];
	                      if (!isValue(item)) {
	                        return false;
	                      }
	                    }
	                    return true;
	                  } else if (typeof mixed === "object") {
	                    for (var key in mixed) {
	                      if (!isValue(mixed[key])) {
	                        return false;
	                      }
	                    }
	                    return true;
	                  } else {
	                    return false;
	                  }
	                }
	                function typeOf(value) {
	                  if (value === null) {
	                    return NullType;
	                  } else if (typeof value === "string") {
	                    return StringType;
	                  } else if (typeof value === "boolean") {
	                    return BooleanType;
	                  } else if (typeof value === "number") {
	                    return NumberType;
	                  } else if (value instanceof Color) {
	                    return ColorType;
	                  } else if (value instanceof Collator) {
	                    return CollatorType;
	                  } else if (value instanceof Formatted) {
	                    return FormattedType;
	                  } else if (value instanceof ResolvedImage) {
	                    return ResolvedImageType;
	                  } else if (Array.isArray(value)) {
	                    var length = value.length;
	                    var itemType;
	                    for (var i = 0, list = value; i < list.length; i += 1) {
	                      var item = list[i];
	                      var t = typeOf(item);
	                      if (!itemType) {
	                        itemType = t;
	                      } else if (itemType === t) {
	                        continue;
	                      } else {
	                        itemType = ValueType;
	                        break;
	                      }
	                    }
	                    return array(itemType || ValueType, length);
	                  } else {
	                    return ObjectType;
	                  }
	                }
	                function toString$1(value) {
	                  var type = typeof value;
	                  if (value === null) {
	                    return "";
	                  } else if (type === "string" || type === "number" || type === "boolean") {
	                    return String(value);
	                  } else if (value instanceof Color || value instanceof Formatted || value instanceof ResolvedImage) {
	                    return value.toString();
	                  } else {
	                    return JSON.stringify(value);
	                  }
	                }
	                var Literal = function Literal2(type, value) {
	                  this.type = type;
	                  this.value = value;
	                };
	                Literal.parse = function parse(args, context) {
	                  if (args.length !== 2) {
	                    return context.error("'literal' expression requires exactly one argument, but found " + (args.length - 1) + " instead.");
	                  }
	                  if (!isValue(args[1])) {
	                    return context.error("invalid value");
	                  }
	                  var value = args[1];
	                  var type = typeOf(value);
	                  var expected = context.expectedType;
	                  if (type.kind === "array" && type.N === 0 && expected && expected.kind === "array" && (typeof expected.N !== "number" || expected.N === 0)) {
	                    type = expected;
	                  }
	                  return new Literal(type, value);
	                };
	                Literal.prototype.evaluate = function evaluate() {
	                  return this.value;
	                };
	                Literal.prototype.eachChild = function eachChild() {
	                };
	                Literal.prototype.outputDefined = function outputDefined() {
	                  return true;
	                };
	                Literal.prototype.serialize = function serialize2() {
	                  if (this.type.kind === "array" || this.type.kind === "object") {
	                    return [
	                      "literal",
	                      this.value
	                    ];
	                  } else if (this.value instanceof Color) {
	                    return ["rgba"].concat(this.value.toArray());
	                  } else if (this.value instanceof Formatted) {
	                    return this.value.serialize();
	                  } else {
	                    return this.value;
	                  }
	                };
	                var RuntimeError = function RuntimeError2(message) {
	                  this.name = "ExpressionEvaluationError";
	                  this.message = message;
	                };
	                RuntimeError.prototype.toJSON = function toJSON() {
	                  return this.message;
	                };
	                var types = {
	                  string: StringType,
	                  number: NumberType,
	                  boolean: BooleanType,
	                  object: ObjectType
	                };
	                var Assertion = function Assertion2(type, args) {
	                  this.type = type;
	                  this.args = args;
	                };
	                Assertion.parse = function parse(args, context) {
	                  if (args.length < 2) {
	                    return context.error("Expected at least one argument.");
	                  }
	                  var i = 1;
	                  var type;
	                  var name3 = args[0];
	                  if (name3 === "array") {
	                    var itemType;
	                    if (args.length > 2) {
	                      var type$1 = args[1];
	                      if (typeof type$1 !== "string" || !(type$1 in types) || type$1 === "object") {
	                        return context.error('The item type argument of "array" must be one of string, number, boolean', 1);
	                      }
	                      itemType = types[type$1];
	                      i++;
	                    } else {
	                      itemType = ValueType;
	                    }
	                    var N;
	                    if (args.length > 3) {
	                      if (args[2] !== null && (typeof args[2] !== "number" || args[2] < 0 || args[2] !== Math.floor(args[2]))) {
	                        return context.error('The length argument to "array" must be a positive integer literal', 2);
	                      }
	                      N = args[2];
	                      i++;
	                    }
	                    type = array(itemType, N);
	                  } else {
	                    type = types[name3];
	                  }
	                  var parsed = [];
	                  for (; i < args.length; i++) {
	                    var input = context.parse(args[i], i, ValueType);
	                    if (!input) {
	                      return null;
	                    }
	                    parsed.push(input);
	                  }
	                  return new Assertion(type, parsed);
	                };
	                Assertion.prototype.evaluate = function evaluate(ctx) {
	                  for (var i = 0; i < this.args.length; i++) {
	                    var value = this.args[i].evaluate(ctx);
	                    var error2 = checkSubtype(this.type, typeOf(value));
	                    if (!error2) {
	                      return value;
	                    } else if (i === this.args.length - 1) {
	                      throw new RuntimeError("Expected value to be of type " + toString(this.type) + ", but found " + toString(typeOf(value)) + " instead.");
	                    }
	                  }
	                  return null;
	                };
	                Assertion.prototype.eachChild = function eachChild(fn) {
	                  this.args.forEach(fn);
	                };
	                Assertion.prototype.outputDefined = function outputDefined() {
	                  return this.args.every(function(arg) {
	                    return arg.outputDefined();
	                  });
	                };
	                Assertion.prototype.serialize = function serialize2() {
	                  var type = this.type;
	                  var serialized = [type.kind];
	                  if (type.kind === "array") {
	                    var itemType = type.itemType;
	                    if (itemType.kind === "string" || itemType.kind === "number" || itemType.kind === "boolean") {
	                      serialized.push(itemType.kind);
	                      var N = type.N;
	                      if (typeof N === "number" || this.args.length > 1) {
	                        serialized.push(N);
	                      }
	                    }
	                  }
	                  return serialized.concat(this.args.map(function(arg) {
	                    return arg.serialize();
	                  }));
	                };
	                var FormatExpression = function FormatExpression2(sections) {
	                  this.type = FormattedType;
	                  this.sections = sections;
	                };
	                FormatExpression.parse = function parse(args, context) {
	                  if (args.length < 2) {
	                    return context.error("Expected at least one argument.");
	                  }
	                  var firstArg = args[1];
	                  if (!Array.isArray(firstArg) && typeof firstArg === "object") {
	                    return context.error("First argument must be an image or text section.");
	                  }
	                  var sections = [];
	                  var nextTokenMayBeObject = false;
	                  for (var i = 1; i <= args.length - 1; ++i) {
	                    var arg = args[i];
	                    if (nextTokenMayBeObject && typeof arg === "object" && !Array.isArray(arg)) {
	                      nextTokenMayBeObject = false;
	                      var scale2 = null;
	                      if (arg["font-scale"]) {
	                        scale2 = context.parse(arg["font-scale"], 1, NumberType);
	                        if (!scale2) {
	                          return null;
	                        }
	                      }
	                      var font = null;
	                      if (arg["text-font"]) {
	                        font = context.parse(arg["text-font"], 1, array(StringType));
	                        if (!font) {
	                          return null;
	                        }
	                      }
	                      var textColor = null;
	                      if (arg["text-color"]) {
	                        textColor = context.parse(arg["text-color"], 1, ColorType);
	                        if (!textColor) {
	                          return null;
	                        }
	                      }
	                      var lastExpression = sections[sections.length - 1];
	                      lastExpression.scale = scale2;
	                      lastExpression.font = font;
	                      lastExpression.textColor = textColor;
	                    } else {
	                      var content = context.parse(args[i], 1, ValueType);
	                      if (!content) {
	                        return null;
	                      }
	                      var kind = content.type.kind;
	                      if (kind !== "string" && kind !== "value" && kind !== "null" && kind !== "resolvedImage") {
	                        return context.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
	                      }
	                      nextTokenMayBeObject = true;
	                      sections.push({
	                        content,
	                        scale: null,
	                        font: null,
	                        textColor: null
	                      });
	                    }
	                  }
	                  return new FormatExpression(sections);
	                };
	                FormatExpression.prototype.evaluate = function evaluate(ctx) {
	                  var evaluateSection = function(section) {
	                    var evaluatedContent = section.content.evaluate(ctx);
	                    if (typeOf(evaluatedContent) === ResolvedImageType) {
	                      return new FormattedSection("", evaluatedContent, null, null, null);
	                    }
	                    return new FormattedSection(toString$1(evaluatedContent), null, section.scale ? section.scale.evaluate(ctx) : null, section.font ? section.font.evaluate(ctx).join(",") : null, section.textColor ? section.textColor.evaluate(ctx) : null);
	                  };
	                  return new Formatted(this.sections.map(evaluateSection));
	                };
	                FormatExpression.prototype.eachChild = function eachChild(fn) {
	                  for (var i = 0, list = this.sections; i < list.length; i += 1) {
	                    var section = list[i];
	                    fn(section.content);
	                    if (section.scale) {
	                      fn(section.scale);
	                    }
	                    if (section.font) {
	                      fn(section.font);
	                    }
	                    if (section.textColor) {
	                      fn(section.textColor);
	                    }
	                  }
	                };
	                FormatExpression.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                FormatExpression.prototype.serialize = function serialize2() {
	                  var serialized = ["format"];
	                  for (var i = 0, list = this.sections; i < list.length; i += 1) {
	                    var section = list[i];
	                    serialized.push(section.content.serialize());
	                    var options = {};
	                    if (section.scale) {
	                      options["font-scale"] = section.scale.serialize();
	                    }
	                    if (section.font) {
	                      options["text-font"] = section.font.serialize();
	                    }
	                    if (section.textColor) {
	                      options["text-color"] = section.textColor.serialize();
	                    }
	                    serialized.push(options);
	                  }
	                  return serialized;
	                };
	                var ImageExpression = function ImageExpression2(input) {
	                  this.type = ResolvedImageType;
	                  this.input = input;
	                };
	                ImageExpression.parse = function parse(args, context) {
	                  if (args.length !== 2) {
	                    return context.error("Expected two arguments.");
	                  }
	                  var name3 = context.parse(args[1], 1, StringType);
	                  if (!name3) {
	                    return context.error("No image name provided.");
	                  }
	                  return new ImageExpression(name3);
	                };
	                ImageExpression.prototype.evaluate = function evaluate(ctx) {
	                  var evaluatedImageName = this.input.evaluate(ctx);
	                  var value = ResolvedImage.fromString(evaluatedImageName);
	                  if (value && ctx.availableImages) {
	                    value.available = ctx.availableImages.indexOf(evaluatedImageName) > -1;
	                  }
	                  return value;
	                };
	                ImageExpression.prototype.eachChild = function eachChild(fn) {
	                  fn(this.input);
	                };
	                ImageExpression.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                ImageExpression.prototype.serialize = function serialize2() {
	                  return [
	                    "image",
	                    this.input.serialize()
	                  ];
	                };
	                var types$1 = {
	                  "to-boolean": BooleanType,
	                  "to-color": ColorType,
	                  "to-number": NumberType,
	                  "to-string": StringType
	                };
	                var Coercion = function Coercion2(type, args) {
	                  this.type = type;
	                  this.args = args;
	                };
	                Coercion.parse = function parse(args, context) {
	                  if (args.length < 2) {
	                    return context.error("Expected at least one argument.");
	                  }
	                  var name3 = args[0];
	                  if ((name3 === "to-boolean" || name3 === "to-string") && args.length !== 2) {
	                    return context.error("Expected one argument.");
	                  }
	                  var type = types$1[name3];
	                  var parsed = [];
	                  for (var i = 1; i < args.length; i++) {
	                    var input = context.parse(args[i], i, ValueType);
	                    if (!input) {
	                      return null;
	                    }
	                    parsed.push(input);
	                  }
	                  return new Coercion(type, parsed);
	                };
	                Coercion.prototype.evaluate = function evaluate(ctx) {
	                  if (this.type.kind === "boolean") {
	                    return Boolean(this.args[0].evaluate(ctx));
	                  } else if (this.type.kind === "color") {
	                    var input;
	                    var error2;
	                    for (var i = 0, list = this.args; i < list.length; i += 1) {
	                      var arg = list[i];
	                      input = arg.evaluate(ctx);
	                      error2 = null;
	                      if (input instanceof Color) {
	                        return input;
	                      } else if (typeof input === "string") {
	                        var c = ctx.parseColor(input);
	                        if (c) {
	                          return c;
	                        }
	                      } else if (Array.isArray(input)) {
	                        if (input.length < 3 || input.length > 4) {
	                          error2 = "Invalid rbga value " + JSON.stringify(input) + ": expected an array containing either three or four numeric values.";
	                        } else {
	                          error2 = validateRGBA(input[0], input[1], input[2], input[3]);
	                        }
	                        if (!error2) {
	                          return new Color(input[0] / 255, input[1] / 255, input[2] / 255, input[3]);
	                        }
	                      }
	                    }
	                    throw new RuntimeError(error2 || "Could not parse color from value '" + (typeof input === "string" ? input : String(JSON.stringify(input))) + "'");
	                  } else if (this.type.kind === "number") {
	                    var value = null;
	                    for (var i$1 = 0, list$1 = this.args; i$1 < list$1.length; i$1 += 1) {
	                      var arg$1 = list$1[i$1];
	                      value = arg$1.evaluate(ctx);
	                      if (value === null) {
	                        return 0;
	                      }
	                      var num = Number(value);
	                      if (isNaN(num)) {
	                        continue;
	                      }
	                      return num;
	                    }
	                    throw new RuntimeError("Could not convert " + JSON.stringify(value) + " to number.");
	                  } else if (this.type.kind === "formatted") {
	                    return Formatted.fromString(toString$1(this.args[0].evaluate(ctx)));
	                  } else if (this.type.kind === "resolvedImage") {
	                    return ResolvedImage.fromString(toString$1(this.args[0].evaluate(ctx)));
	                  } else {
	                    return toString$1(this.args[0].evaluate(ctx));
	                  }
	                };
	                Coercion.prototype.eachChild = function eachChild(fn) {
	                  this.args.forEach(fn);
	                };
	                Coercion.prototype.outputDefined = function outputDefined() {
	                  return this.args.every(function(arg) {
	                    return arg.outputDefined();
	                  });
	                };
	                Coercion.prototype.serialize = function serialize2() {
	                  if (this.type.kind === "formatted") {
	                    return new FormatExpression([{
	                      content: this.args[0],
	                      scale: null,
	                      font: null,
	                      textColor: null
	                    }]).serialize();
	                  }
	                  if (this.type.kind === "resolvedImage") {
	                    return new ImageExpression(this.args[0]).serialize();
	                  }
	                  var serialized = ["to-" + this.type.kind];
	                  this.eachChild(function(child) {
	                    serialized.push(child.serialize());
	                  });
	                  return serialized;
	                };
	                var geometryTypes = [
	                  "Unknown",
	                  "Point",
	                  "LineString",
	                  "Polygon"
	                ];
	                var EvaluationContext = function EvaluationContext2() {
	                  this.globals = null;
	                  this.feature = null;
	                  this.featureState = null;
	                  this.formattedSection = null;
	                  this._parseColorCache = {};
	                  this.availableImages = null;
	                  this.canonical = null;
	                };
	                EvaluationContext.prototype.id = function id2() {
	                  return this.feature && "id" in this.feature ? this.feature.id : null;
	                };
	                EvaluationContext.prototype.geometryType = function geometryType() {
	                  return this.feature ? typeof this.feature.type === "number" ? geometryTypes[this.feature.type] : this.feature.type : null;
	                };
	                EvaluationContext.prototype.geometry = function geometry() {
	                  return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
	                };
	                EvaluationContext.prototype.canonicalID = function canonicalID() {
	                  return this.canonical;
	                };
	                EvaluationContext.prototype.properties = function properties2() {
	                  return this.feature && this.feature.properties || {};
	                };
	                EvaluationContext.prototype.parseColor = function parseColor(input) {
	                  var cached = this._parseColorCache[input];
	                  if (!cached) {
	                    cached = this._parseColorCache[input] = Color.parse(input);
	                  }
	                  return cached;
	                };
	                var CompoundExpression = function CompoundExpression2(name3, type, evaluate, args) {
	                  this.name = name3;
	                  this.type = type;
	                  this._evaluate = evaluate;
	                  this.args = args;
	                };
	                CompoundExpression.prototype.evaluate = function evaluate(ctx) {
	                  return this._evaluate(ctx, this.args);
	                };
	                CompoundExpression.prototype.eachChild = function eachChild(fn) {
	                  this.args.forEach(fn);
	                };
	                CompoundExpression.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                CompoundExpression.prototype.serialize = function serialize2() {
	                  return [this.name].concat(this.args.map(function(arg) {
	                    return arg.serialize();
	                  }));
	                };
	                CompoundExpression.parse = function parse(args, context) {
	                  var ref$1;
	                  var op = args[0];
	                  var definition = CompoundExpression.definitions[op];
	                  if (!definition) {
	                    return context.error('Unknown expression "' + op + '". If you wanted a literal array, use ["literal", [...]].', 0);
	                  }
	                  var type = Array.isArray(definition) ? definition[0] : definition.type;
	                  var availableOverloads = Array.isArray(definition) ? [[
	                    definition[1],
	                    definition[2]
	                  ]] : definition.overloads;
	                  var overloads = availableOverloads.filter(function(ref2) {
	                    var signature = ref2[0];
	                    return !Array.isArray(signature) || signature.length === args.length - 1;
	                  });
	                  var signatureContext = null;
	                  for (var i$3 = 0, list = overloads; i$3 < list.length; i$3 += 1) {
	                    var ref = list[i$3];
	                    var params = ref[0];
	                    var evaluate = ref[1];
	                    signatureContext = new ParsingContext(context.registry, context.path, null, context.scope);
	                    var parsedArgs = [];
	                    var argParseFailed = false;
	                    for (var i = 1; i < args.length; i++) {
	                      var arg = args[i];
	                      var expectedType = Array.isArray(params) ? params[i - 1] : params.type;
	                      var parsed = signatureContext.parse(arg, 1 + parsedArgs.length, expectedType);
	                      if (!parsed) {
	                        argParseFailed = true;
	                        break;
	                      }
	                      parsedArgs.push(parsed);
	                    }
	                    if (argParseFailed) {
	                      continue;
	                    }
	                    if (Array.isArray(params)) {
	                      if (params.length !== parsedArgs.length) {
	                        signatureContext.error("Expected " + params.length + " arguments, but found " + parsedArgs.length + " instead.");
	                        continue;
	                      }
	                    }
	                    for (var i$1 = 0; i$1 < parsedArgs.length; i$1++) {
	                      var expected = Array.isArray(params) ? params[i$1] : params.type;
	                      var arg$1 = parsedArgs[i$1];
	                      signatureContext.concat(i$1 + 1).checkSubtype(expected, arg$1.type);
	                    }
	                    if (signatureContext.errors.length === 0) {
	                      return new CompoundExpression(op, type, evaluate, parsedArgs);
	                    }
	                  }
	                  if (overloads.length === 1) {
	                    (ref$1 = context.errors).push.apply(ref$1, signatureContext.errors);
	                  } else {
	                    var expected$1 = overloads.length ? overloads : availableOverloads;
	                    var signatures = expected$1.map(function(ref2) {
	                      var params2 = ref2[0];
	                      return stringifySignature(params2);
	                    }).join(" | ");
	                    var actualTypes = [];
	                    for (var i$2 = 1; i$2 < args.length; i$2++) {
	                      var parsed$1 = context.parse(args[i$2], 1 + actualTypes.length);
	                      if (!parsed$1) {
	                        return null;
	                      }
	                      actualTypes.push(toString(parsed$1.type));
	                    }
	                    context.error("Expected arguments of type " + signatures + ", but found (" + actualTypes.join(", ") + ") instead.");
	                  }
	                  return null;
	                };
	                CompoundExpression.register = function register2(registry2, definitions) {
	                  CompoundExpression.definitions = definitions;
	                  for (var name3 in definitions) {
	                    registry2[name3] = CompoundExpression;
	                  }
	                };
	                function stringifySignature(signature) {
	                  if (Array.isArray(signature)) {
	                    return "(" + signature.map(toString).join(", ") + ")";
	                  } else {
	                    return "(" + toString(signature.type) + "...)";
	                  }
	                }
	                var CollatorExpression = function CollatorExpression2(caseSensitive, diacriticSensitive, locale) {
	                  this.type = CollatorType;
	                  this.locale = locale;
	                  this.caseSensitive = caseSensitive;
	                  this.diacriticSensitive = diacriticSensitive;
	                };
	                CollatorExpression.parse = function parse(args, context) {
	                  if (args.length !== 2) {
	                    return context.error("Expected one argument.");
	                  }
	                  var options = args[1];
	                  if (typeof options !== "object" || Array.isArray(options)) {
	                    return context.error("Collator options argument must be an object.");
	                  }
	                  var caseSensitive = context.parse(options["case-sensitive"] === undefined ? false : options["case-sensitive"], 1, BooleanType);
	                  if (!caseSensitive) {
	                    return null;
	                  }
	                  var diacriticSensitive = context.parse(options["diacritic-sensitive"] === undefined ? false : options["diacritic-sensitive"], 1, BooleanType);
	                  if (!diacriticSensitive) {
	                    return null;
	                  }
	                  var locale = null;
	                  if (options["locale"]) {
	                    locale = context.parse(options["locale"], 1, StringType);
	                    if (!locale) {
	                      return null;
	                    }
	                  }
	                  return new CollatorExpression(caseSensitive, diacriticSensitive, locale);
	                };
	                CollatorExpression.prototype.evaluate = function evaluate(ctx) {
	                  return new Collator(this.caseSensitive.evaluate(ctx), this.diacriticSensitive.evaluate(ctx), this.locale ? this.locale.evaluate(ctx) : null);
	                };
	                CollatorExpression.prototype.eachChild = function eachChild(fn) {
	                  fn(this.caseSensitive);
	                  fn(this.diacriticSensitive);
	                  if (this.locale) {
	                    fn(this.locale);
	                  }
	                };
	                CollatorExpression.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                CollatorExpression.prototype.serialize = function serialize2() {
	                  var options = {};
	                  options["case-sensitive"] = this.caseSensitive.serialize();
	                  options["diacritic-sensitive"] = this.diacriticSensitive.serialize();
	                  if (this.locale) {
	                    options["locale"] = this.locale.serialize();
	                  }
	                  return [
	                    "collator",
	                    options
	                  ];
	                };
	                var EXTENT = 8192;
	                function updateBBox(bbox, coord) {
	                  bbox[0] = Math.min(bbox[0], coord[0]);
	                  bbox[1] = Math.min(bbox[1], coord[1]);
	                  bbox[2] = Math.max(bbox[2], coord[0]);
	                  bbox[3] = Math.max(bbox[3], coord[1]);
	                }
	                function mercatorXfromLng(lng) {
	                  return (180 + lng) / 360;
	                }
	                function mercatorYfromLat(lat) {
	                  return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
	                }
	                function boxWithinBox(bbox1, bbox2) {
	                  if (bbox1[0] <= bbox2[0]) {
	                    return false;
	                  }
	                  if (bbox1[2] >= bbox2[2]) {
	                    return false;
	                  }
	                  if (bbox1[1] <= bbox2[1]) {
	                    return false;
	                  }
	                  if (bbox1[3] >= bbox2[3]) {
	                    return false;
	                  }
	                  return true;
	                }
	                function getTileCoordinates(p, canonical) {
	                  var x = mercatorXfromLng(p[0]);
	                  var y = mercatorYfromLat(p[1]);
	                  var tilesAtZoom = Math.pow(2, canonical.z);
	                  return [
	                    Math.round(x * tilesAtZoom * EXTENT),
	                    Math.round(y * tilesAtZoom * EXTENT)
	                  ];
	                }
	                function onBoundary(p, p1, p2) {
	                  var x1 = p[0] - p1[0];
	                  var y1 = p[1] - p1[1];
	                  var x2 = p[0] - p2[0];
	                  var y2 = p[1] - p2[1];
	                  return x1 * y2 - x2 * y1 === 0 && x1 * x2 <= 0 && y1 * y2 <= 0;
	                }
	                function rayIntersect(p, p1, p2) {
	                  return p1[1] > p[1] !== p2[1] > p[1] && p[0] < (p2[0] - p1[0]) * (p[1] - p1[1]) / (p2[1] - p1[1]) + p1[0];
	                }
	                function pointWithinPolygon(point, rings) {
	                  var inside = false;
	                  for (var i = 0, len = rings.length; i < len; i++) {
	                    var ring = rings[i];
	                    for (var j = 0, len2 = ring.length; j < len2 - 1; j++) {
	                      if (onBoundary(point, ring[j], ring[j + 1])) {
	                        return false;
	                      }
	                      if (rayIntersect(point, ring[j], ring[j + 1])) {
	                        inside = !inside;
	                      }
	                    }
	                  }
	                  return inside;
	                }
	                function pointWithinPolygons(point, polygons) {
	                  for (var i = 0; i < polygons.length; i++) {
	                    if (pointWithinPolygon(point, polygons[i])) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function perp(v1, v2) {
	                  return v1[0] * v2[1] - v1[1] * v2[0];
	                }
	                function twoSided(p1, p2, q1, q2) {
	                  var x1 = p1[0] - q1[0];
	                  var y1 = p1[1] - q1[1];
	                  var x2 = p2[0] - q1[0];
	                  var y2 = p2[1] - q1[1];
	                  var x3 = q2[0] - q1[0];
	                  var y3 = q2[1] - q1[1];
	                  var det1 = x1 * y3 - x3 * y1;
	                  var det2 = x2 * y3 - x3 * y2;
	                  if (det1 > 0 && det2 < 0 || det1 < 0 && det2 > 0) {
	                    return true;
	                  }
	                  return false;
	                }
	                function lineIntersectLine(a, b, c, d) {
	                  var vectorP = [
	                    b[0] - a[0],
	                    b[1] - a[1]
	                  ];
	                  var vectorQ = [
	                    d[0] - c[0],
	                    d[1] - c[1]
	                  ];
	                  if (perp(vectorQ, vectorP) === 0) {
	                    return false;
	                  }
	                  if (twoSided(a, b, c, d) && twoSided(c, d, a, b)) {
	                    return true;
	                  }
	                  return false;
	                }
	                function lineIntersectPolygon(p1, p2, polygon) {
	                  for (var i = 0, list = polygon; i < list.length; i += 1) {
	                    var ring = list[i];
	                    for (var j = 0; j < ring.length - 1; ++j) {
	                      if (lineIntersectLine(p1, p2, ring[j], ring[j + 1])) {
	                        return true;
	                      }
	                    }
	                  }
	                  return false;
	                }
	                function lineStringWithinPolygon(line, polygon) {
	                  for (var i = 0; i < line.length; ++i) {
	                    if (!pointWithinPolygon(line[i], polygon)) {
	                      return false;
	                    }
	                  }
	                  for (var i$1 = 0; i$1 < line.length - 1; ++i$1) {
	                    if (lineIntersectPolygon(line[i$1], line[i$1 + 1], polygon)) {
	                      return false;
	                    }
	                  }
	                  return true;
	                }
	                function lineStringWithinPolygons(line, polygons) {
	                  for (var i = 0; i < polygons.length; i++) {
	                    if (lineStringWithinPolygon(line, polygons[i])) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function getTilePolygon(coordinates, bbox, canonical) {
	                  var polygon = [];
	                  for (var i = 0; i < coordinates.length; i++) {
	                    var ring = [];
	                    for (var j = 0; j < coordinates[i].length; j++) {
	                      var coord = getTileCoordinates(coordinates[i][j], canonical);
	                      updateBBox(bbox, coord);
	                      ring.push(coord);
	                    }
	                    polygon.push(ring);
	                  }
	                  return polygon;
	                }
	                function getTilePolygons(coordinates, bbox, canonical) {
	                  var polygons = [];
	                  for (var i = 0; i < coordinates.length; i++) {
	                    var polygon = getTilePolygon(coordinates[i], bbox, canonical);
	                    polygons.push(polygon);
	                  }
	                  return polygons;
	                }
	                function updatePoint(p, bbox, polyBBox, worldSize) {
	                  if (p[0] < polyBBox[0] || p[0] > polyBBox[2]) {
	                    var halfWorldSize = worldSize * 0.5;
	                    var shift = p[0] - polyBBox[0] > halfWorldSize ? -worldSize : polyBBox[0] - p[0] > halfWorldSize ? worldSize : 0;
	                    if (shift === 0) {
	                      shift = p[0] - polyBBox[2] > halfWorldSize ? -worldSize : polyBBox[2] - p[0] > halfWorldSize ? worldSize : 0;
	                    }
	                    p[0] += shift;
	                  }
	                  updateBBox(bbox, p);
	                }
	                function resetBBox(bbox) {
	                  bbox[0] = bbox[1] = Infinity;
	                  bbox[2] = bbox[3] = -Infinity;
	                }
	                function getTilePoints(geometry, pointBBox, polyBBox, canonical) {
	                  var worldSize = Math.pow(2, canonical.z) * EXTENT;
	                  var shifts = [
	                    canonical.x * EXTENT,
	                    canonical.y * EXTENT
	                  ];
	                  var tilePoints = [];
	                  for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
	                    var points = list$1[i$1];
	                    for (var i = 0, list = points; i < list.length; i += 1) {
	                      var point = list[i];
	                      var p = [
	                        point.x + shifts[0],
	                        point.y + shifts[1]
	                      ];
	                      updatePoint(p, pointBBox, polyBBox, worldSize);
	                      tilePoints.push(p);
	                    }
	                  }
	                  return tilePoints;
	                }
	                function getTileLines(geometry, lineBBox, polyBBox, canonical) {
	                  var worldSize = Math.pow(2, canonical.z) * EXTENT;
	                  var shifts = [
	                    canonical.x * EXTENT,
	                    canonical.y * EXTENT
	                  ];
	                  var tileLines = [];
	                  for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
	                    var line = list$1[i$1];
	                    var tileLine = [];
	                    for (var i = 0, list = line; i < list.length; i += 1) {
	                      var point = list[i];
	                      var p = [
	                        point.x + shifts[0],
	                        point.y + shifts[1]
	                      ];
	                      updateBBox(lineBBox, p);
	                      tileLine.push(p);
	                    }
	                    tileLines.push(tileLine);
	                  }
	                  if (lineBBox[2] - lineBBox[0] <= worldSize / 2) {
	                    resetBBox(lineBBox);
	                    for (var i$3 = 0, list$3 = tileLines; i$3 < list$3.length; i$3 += 1) {
	                      var line$1 = list$3[i$3];
	                      for (var i$2 = 0, list$2 = line$1; i$2 < list$2.length; i$2 += 1) {
	                        var p$1 = list$2[i$2];
	                        updatePoint(p$1, lineBBox, polyBBox, worldSize);
	                      }
	                    }
	                  }
	                  return tileLines;
	                }
	                function pointsWithinPolygons(ctx, polygonGeometry) {
	                  var pointBBox = [
	                    Infinity,
	                    Infinity,
	                    -Infinity,
	                    -Infinity
	                  ];
	                  var polyBBox = [
	                    Infinity,
	                    Infinity,
	                    -Infinity,
	                    -Infinity
	                  ];
	                  var canonical = ctx.canonicalID();
	                  if (polygonGeometry.type === "Polygon") {
	                    var tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
	                    var tilePoints = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
	                    if (!boxWithinBox(pointBBox, polyBBox)) {
	                      return false;
	                    }
	                    for (var i = 0, list = tilePoints; i < list.length; i += 1) {
	                      var point = list[i];
	                      if (!pointWithinPolygon(point, tilePolygon)) {
	                        return false;
	                      }
	                    }
	                  }
	                  if (polygonGeometry.type === "MultiPolygon") {
	                    var tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
	                    var tilePoints$1 = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
	                    if (!boxWithinBox(pointBBox, polyBBox)) {
	                      return false;
	                    }
	                    for (var i$1 = 0, list$1 = tilePoints$1; i$1 < list$1.length; i$1 += 1) {
	                      var point$1 = list$1[i$1];
	                      if (!pointWithinPolygons(point$1, tilePolygons)) {
	                        return false;
	                      }
	                    }
	                  }
	                  return true;
	                }
	                function linesWithinPolygons(ctx, polygonGeometry) {
	                  var lineBBox = [
	                    Infinity,
	                    Infinity,
	                    -Infinity,
	                    -Infinity
	                  ];
	                  var polyBBox = [
	                    Infinity,
	                    Infinity,
	                    -Infinity,
	                    -Infinity
	                  ];
	                  var canonical = ctx.canonicalID();
	                  if (polygonGeometry.type === "Polygon") {
	                    var tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
	                    var tileLines = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
	                    if (!boxWithinBox(lineBBox, polyBBox)) {
	                      return false;
	                    }
	                    for (var i = 0, list = tileLines; i < list.length; i += 1) {
	                      var line = list[i];
	                      if (!lineStringWithinPolygon(line, tilePolygon)) {
	                        return false;
	                      }
	                    }
	                  }
	                  if (polygonGeometry.type === "MultiPolygon") {
	                    var tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
	                    var tileLines$1 = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
	                    if (!boxWithinBox(lineBBox, polyBBox)) {
	                      return false;
	                    }
	                    for (var i$1 = 0, list$1 = tileLines$1; i$1 < list$1.length; i$1 += 1) {
	                      var line$1 = list$1[i$1];
	                      if (!lineStringWithinPolygons(line$1, tilePolygons)) {
	                        return false;
	                      }
	                    }
	                  }
	                  return true;
	                }
	                var Within = function Within2(geojson, geometries) {
	                  this.type = BooleanType;
	                  this.geojson = geojson;
	                  this.geometries = geometries;
	                };
	                Within.parse = function parse(args, context) {
	                  if (args.length !== 2) {
	                    return context.error("'within' expression requires exactly one argument, but found " + (args.length - 1) + " instead.");
	                  }
	                  if (isValue(args[1])) {
	                    var geojson = args[1];
	                    if (geojson.type === "FeatureCollection") {
	                      for (var i = 0; i < geojson.features.length; ++i) {
	                        var type = geojson.features[i].geometry.type;
	                        if (type === "Polygon" || type === "MultiPolygon") {
	                          return new Within(geojson, geojson.features[i].geometry);
	                        }
	                      }
	                    } else if (geojson.type === "Feature") {
	                      var type$1 = geojson.geometry.type;
	                      if (type$1 === "Polygon" || type$1 === "MultiPolygon") {
	                        return new Within(geojson, geojson.geometry);
	                      }
	                    } else if (geojson.type === "Polygon" || geojson.type === "MultiPolygon") {
	                      return new Within(geojson, geojson);
	                    }
	                  }
	                  return context.error("'within' expression requires valid geojson object that contains polygon geometry type.");
	                };
	                Within.prototype.evaluate = function evaluate(ctx) {
	                  if (ctx.geometry() != null && ctx.canonicalID() != null) {
	                    if (ctx.geometryType() === "Point") {
	                      return pointsWithinPolygons(ctx, this.geometries);
	                    } else if (ctx.geometryType() === "LineString") {
	                      return linesWithinPolygons(ctx, this.geometries);
	                    }
	                  }
	                  return false;
	                };
	                Within.prototype.eachChild = function eachChild() {
	                };
	                Within.prototype.outputDefined = function outputDefined() {
	                  return true;
	                };
	                Within.prototype.serialize = function serialize2() {
	                  return [
	                    "within",
	                    this.geojson
	                  ];
	                };
	                function isFeatureConstant(e) {
	                  if (e instanceof CompoundExpression) {
	                    if (e.name === "get" && e.args.length === 1) {
	                      return false;
	                    } else if (e.name === "feature-state") {
	                      return false;
	                    } else if (e.name === "has" && e.args.length === 1) {
	                      return false;
	                    } else if (e.name === "properties" || e.name === "geometry-type" || e.name === "id") {
	                      return false;
	                    } else if (/^filter-/.test(e.name)) {
	                      return false;
	                    }
	                  }
	                  if (e instanceof Within) {
	                    return false;
	                  }
	                  var result = true;
	                  e.eachChild(function(arg) {
	                    if (result && !isFeatureConstant(arg)) {
	                      result = false;
	                    }
	                  });
	                  return result;
	                }
	                function isStateConstant(e) {
	                  if (e instanceof CompoundExpression) {
	                    if (e.name === "feature-state") {
	                      return false;
	                    }
	                  }
	                  var result = true;
	                  e.eachChild(function(arg) {
	                    if (result && !isStateConstant(arg)) {
	                      result = false;
	                    }
	                  });
	                  return result;
	                }
	                function isGlobalPropertyConstant(e, properties2) {
	                  if (e instanceof CompoundExpression && properties2.indexOf(e.name) >= 0) {
	                    return false;
	                  }
	                  var result = true;
	                  e.eachChild(function(arg) {
	                    if (result && !isGlobalPropertyConstant(arg, properties2)) {
	                      result = false;
	                    }
	                  });
	                  return result;
	                }
	                var Var = function Var2(name3, boundExpression) {
	                  this.type = boundExpression.type;
	                  this.name = name3;
	                  this.boundExpression = boundExpression;
	                };
	                Var.parse = function parse(args, context) {
	                  if (args.length !== 2 || typeof args[1] !== "string") {
	                    return context.error("'var' expression requires exactly one string literal argument.");
	                  }
	                  var name3 = args[1];
	                  if (!context.scope.has(name3)) {
	                    return context.error('Unknown variable "' + name3 + '". Make sure "' + name3 + '" has been bound in an enclosing "let" expression before using it.', 1);
	                  }
	                  return new Var(name3, context.scope.get(name3));
	                };
	                Var.prototype.evaluate = function evaluate(ctx) {
	                  return this.boundExpression.evaluate(ctx);
	                };
	                Var.prototype.eachChild = function eachChild() {
	                };
	                Var.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                Var.prototype.serialize = function serialize2() {
	                  return [
	                    "var",
	                    this.name
	                  ];
	                };
	                var ParsingContext = function ParsingContext2(registry2, path, expectedType, scope, errors) {
	                  if (path === undefined)
	                    path = [];
	                  if (scope === undefined)
	                    scope = new Scope();
	                  if (errors === undefined)
	                    errors = [];
	                  this.registry = registry2;
	                  this.path = path;
	                  this.key = path.map(function(part) {
	                    return "[" + part + "]";
	                  }).join("");
	                  this.scope = scope;
	                  this.errors = errors;
	                  this.expectedType = expectedType;
	                };
	                ParsingContext.prototype.parse = function parse(expr, index, expectedType, bindings, options) {
	                  if (options === undefined)
	                    options = {};
	                  if (index) {
	                    return this.concat(index, expectedType, bindings)._parse(expr, options);
	                  }
	                  return this._parse(expr, options);
	                };
	                ParsingContext.prototype._parse = function _parse(expr, options) {
	                  if (expr === null || typeof expr === "string" || typeof expr === "boolean" || typeof expr === "number") {
	                    expr = [
	                      "literal",
	                      expr
	                    ];
	                  }
	                  function annotate(parsed2, type, typeAnnotation) {
	                    if (typeAnnotation === "assert") {
	                      return new Assertion(type, [parsed2]);
	                    } else if (typeAnnotation === "coerce") {
	                      return new Coercion(type, [parsed2]);
	                    } else {
	                      return parsed2;
	                    }
	                  }
	                  if (Array.isArray(expr)) {
	                    if (expr.length === 0) {
	                      return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
	                    }
	                    var op = expr[0];
	                    if (typeof op !== "string") {
	                      this.error("Expression name must be a string, but found " + typeof op + ' instead. If you wanted a literal array, use ["literal", [...]].', 0);
	                      return null;
	                    }
	                    var Expr = this.registry[op];
	                    if (Expr) {
	                      var parsed = Expr.parse(expr, this);
	                      if (!parsed) {
	                        return null;
	                      }
	                      if (this.expectedType) {
	                        var expected = this.expectedType;
	                        var actual = parsed.type;
	                        if ((expected.kind === "string" || expected.kind === "number" || expected.kind === "boolean" || expected.kind === "object" || expected.kind === "array") && actual.kind === "value") {
	                          parsed = annotate(parsed, expected, options.typeAnnotation || "assert");
	                        } else if ((expected.kind === "color" || expected.kind === "formatted" || expected.kind === "resolvedImage") && (actual.kind === "value" || actual.kind === "string")) {
	                          parsed = annotate(parsed, expected, options.typeAnnotation || "coerce");
	                        } else if (this.checkSubtype(expected, actual)) {
	                          return null;
	                        }
	                      }
	                      if (!(parsed instanceof Literal) && parsed.type.kind !== "resolvedImage" && isConstant(parsed)) {
	                        var ec = new EvaluationContext();
	                        try {
	                          parsed = new Literal(parsed.type, parsed.evaluate(ec));
	                        } catch (e) {
	                          this.error(e.message);
	                          return null;
	                        }
	                      }
	                      return parsed;
	                    }
	                    return this.error('Unknown expression "' + op + '". If you wanted a literal array, use ["literal", [...]].', 0);
	                  } else if (typeof expr === "undefined") {
	                    return this.error("'undefined' value invalid. Use null instead.");
	                  } else if (typeof expr === "object") {
	                    return this.error('Bare objects invalid. Use ["literal", {...}] instead.');
	                  } else {
	                    return this.error("Expected an array, but found " + typeof expr + " instead.");
	                  }
	                };
	                ParsingContext.prototype.concat = function concat(index, expectedType, bindings) {
	                  var path = typeof index === "number" ? this.path.concat(index) : this.path;
	                  var scope = bindings ? this.scope.concat(bindings) : this.scope;
	                  return new ParsingContext(this.registry, path, expectedType || null, scope, this.errors);
	                };
	                ParsingContext.prototype.error = function error2(error$1) {
	                  var keys = [], len = arguments.length - 1;
	                  while (len-- > 0)
	                    keys[len] = arguments[len + 1];
	                  var key = "" + this.key + keys.map(function(k) {
	                    return "[" + k + "]";
	                  }).join("");
	                  this.errors.push(new ParsingError(key, error$1));
	                };
	                ParsingContext.prototype.checkSubtype = function checkSubtype$1(expected, t) {
	                  var error2 = checkSubtype(expected, t);
	                  if (error2) {
	                    this.error(error2);
	                  }
	                  return error2;
	                };
	                function isConstant(expression2) {
	                  if (expression2 instanceof Var) {
	                    return isConstant(expression2.boundExpression);
	                  } else if (expression2 instanceof CompoundExpression && expression2.name === "error") {
	                    return false;
	                  } else if (expression2 instanceof CollatorExpression) {
	                    return false;
	                  } else if (expression2 instanceof Within) {
	                    return false;
	                  }
	                  var isTypeAnnotation = expression2 instanceof Coercion || expression2 instanceof Assertion;
	                  var childrenConstant = true;
	                  expression2.eachChild(function(child) {
	                    if (isTypeAnnotation) {
	                      childrenConstant = childrenConstant && isConstant(child);
	                    } else {
	                      childrenConstant = childrenConstant && child instanceof Literal;
	                    }
	                  });
	                  if (!childrenConstant) {
	                    return false;
	                  }
	                  return isFeatureConstant(expression2) && isGlobalPropertyConstant(expression2, [
	                    "zoom",
	                    "heatmap-density",
	                    "line-progress",
	                    "accumulated",
	                    "is-supported-script"
	                  ]);
	                }
	                function findStopLessThanOrEqualTo(stops, input) {
	                  var lastIndex = stops.length - 1;
	                  var lowerIndex = 0;
	                  var upperIndex = lastIndex;
	                  var currentIndex = 0;
	                  var currentValue, nextValue;
	                  while (lowerIndex <= upperIndex) {
	                    currentIndex = Math.floor((lowerIndex + upperIndex) / 2);
	                    currentValue = stops[currentIndex];
	                    nextValue = stops[currentIndex + 1];
	                    if (currentValue <= input) {
	                      if (currentIndex === lastIndex || input < nextValue) {
	                        return currentIndex;
	                      }
	                      lowerIndex = currentIndex + 1;
	                    } else if (currentValue > input) {
	                      upperIndex = currentIndex - 1;
	                    } else {
	                      throw new RuntimeError("Input is not a number.");
	                    }
	                  }
	                  return 0;
	                }
	                var Step = function Step2(type, input, stops) {
	                  this.type = type;
	                  this.input = input;
	                  this.labels = [];
	                  this.outputs = [];
	                  for (var i = 0, list = stops; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var label = ref[0];
	                    var expression2 = ref[1];
	                    this.labels.push(label);
	                    this.outputs.push(expression2);
	                  }
	                };
	                Step.parse = function parse(args, context) {
	                  if (args.length - 1 < 4) {
	                    return context.error("Expected at least 4 arguments, but found only " + (args.length - 1) + ".");
	                  }
	                  if ((args.length - 1) % 2 !== 0) {
	                    return context.error("Expected an even number of arguments.");
	                  }
	                  var input = context.parse(args[1], 1, NumberType);
	                  if (!input) {
	                    return null;
	                  }
	                  var stops = [];
	                  var outputType = null;
	                  if (context.expectedType && context.expectedType.kind !== "value") {
	                    outputType = context.expectedType;
	                  }
	                  for (var i = 1; i < args.length; i += 2) {
	                    var label = i === 1 ? -Infinity : args[i];
	                    var value = args[i + 1];
	                    var labelKey = i;
	                    var valueKey = i + 1;
	                    if (typeof label !== "number") {
	                      return context.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
	                    }
	                    if (stops.length && stops[stops.length - 1][0] >= label) {
	                      return context.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', labelKey);
	                    }
	                    var parsed = context.parse(value, valueKey, outputType);
	                    if (!parsed) {
	                      return null;
	                    }
	                    outputType = outputType || parsed.type;
	                    stops.push([
	                      label,
	                      parsed
	                    ]);
	                  }
	                  return new Step(outputType, input, stops);
	                };
	                Step.prototype.evaluate = function evaluate(ctx) {
	                  var labels = this.labels;
	                  var outputs = this.outputs;
	                  if (labels.length === 1) {
	                    return outputs[0].evaluate(ctx);
	                  }
	                  var value = this.input.evaluate(ctx);
	                  if (value <= labels[0]) {
	                    return outputs[0].evaluate(ctx);
	                  }
	                  var stopCount = labels.length;
	                  if (value >= labels[stopCount - 1]) {
	                    return outputs[stopCount - 1].evaluate(ctx);
	                  }
	                  var index = findStopLessThanOrEqualTo(labels, value);
	                  return outputs[index].evaluate(ctx);
	                };
	                Step.prototype.eachChild = function eachChild(fn) {
	                  fn(this.input);
	                  for (var i = 0, list = this.outputs; i < list.length; i += 1) {
	                    var expression2 = list[i];
	                    fn(expression2);
	                  }
	                };
	                Step.prototype.outputDefined = function outputDefined() {
	                  return this.outputs.every(function(out) {
	                    return out.outputDefined();
	                  });
	                };
	                Step.prototype.serialize = function serialize2() {
	                  var serialized = [
	                    "step",
	                    this.input.serialize()
	                  ];
	                  for (var i = 0; i < this.labels.length; i++) {
	                    if (i > 0) {
	                      serialized.push(this.labels[i]);
	                    }
	                    serialized.push(this.outputs[i].serialize());
	                  }
	                  return serialized;
	                };
	                function number2(a, b, t) {
	                  return a * (1 - t) + b * t;
	                }
	                function color(from, to, t) {
	                  return new Color(number2(from.r, to.r, t), number2(from.g, to.g, t), number2(from.b, to.b, t), number2(from.a, to.a, t));
	                }
	                function array$1(from, to, t) {
	                  return from.map(function(d, i) {
	                    return number2(d, to[i], t);
	                  });
	                }
	                var interpolate = /* @__PURE__ */ Object.freeze({
	                  __proto__: null,
	                  number: number2,
	                  color,
	                  array: array$1
	                });
	                var Xn = 0.95047, Yn = 1, Zn = 1.08883, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1, deg2rad = Math.PI / 180, rad2deg = 180 / Math.PI;
	                function xyz2lab(t) {
	                  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	                }
	                function lab2xyz(t) {
	                  return t > t1 ? t * t * t : t2 * (t - t0);
	                }
	                function xyz2rgb(x) {
	                  return 255 * (x <= 31308e-7 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	                }
	                function rgb2xyz(x) {
	                  x /= 255;
	                  return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	                }
	                function rgbToLab(rgbColor) {
	                  var b = rgb2xyz(rgbColor.r), a = rgb2xyz(rgbColor.g), l = rgb2xyz(rgbColor.b), x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn), y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.072175 * l) / Yn), z = xyz2lab((0.0193339 * b + 0.119192 * a + 0.9503041 * l) / Zn);
	                  return {
	                    l: 116 * y - 16,
	                    a: 500 * (x - y),
	                    b: 200 * (y - z),
	                    alpha: rgbColor.a
	                  };
	                }
	                function labToRgb(labColor) {
	                  var y = (labColor.l + 16) / 116, x = isNaN(labColor.a) ? y : y + labColor.a / 500, z = isNaN(labColor.b) ? y : y - labColor.b / 200;
	                  y = Yn * lab2xyz(y);
	                  x = Xn * lab2xyz(x);
	                  z = Zn * lab2xyz(z);
	                  return new Color(xyz2rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), xyz2rgb(-0.969266 * x + 1.8760108 * y + 0.041556 * z), xyz2rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), labColor.alpha);
	                }
	                function interpolateLab(from, to, t) {
	                  return {
	                    l: number2(from.l, to.l, t),
	                    a: number2(from.a, to.a, t),
	                    b: number2(from.b, to.b, t),
	                    alpha: number2(from.alpha, to.alpha, t)
	                  };
	                }
	                function rgbToHcl(rgbColor) {
	                  var ref = rgbToLab(rgbColor);
	                  var l = ref.l;
	                  var a = ref.a;
	                  var b = ref.b;
	                  var h = Math.atan2(b, a) * rad2deg;
	                  return {
	                    h: h < 0 ? h + 360 : h,
	                    c: Math.sqrt(a * a + b * b),
	                    l,
	                    alpha: rgbColor.a
	                  };
	                }
	                function hclToRgb(hclColor) {
	                  var h = hclColor.h * deg2rad, c = hclColor.c, l = hclColor.l;
	                  return labToRgb({
	                    l,
	                    a: Math.cos(h) * c,
	                    b: Math.sin(h) * c,
	                    alpha: hclColor.alpha
	                  });
	                }
	                function interpolateHue(a, b, t) {
	                  var d = b - a;
	                  return a + t * (d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d);
	                }
	                function interpolateHcl(from, to, t) {
	                  return {
	                    h: interpolateHue(from.h, to.h, t),
	                    c: number2(from.c, to.c, t),
	                    l: number2(from.l, to.l, t),
	                    alpha: number2(from.alpha, to.alpha, t)
	                  };
	                }
	                var lab = {
	                  forward: rgbToLab,
	                  reverse: labToRgb,
	                  interpolate: interpolateLab
	                };
	                var hcl = {
	                  forward: rgbToHcl,
	                  reverse: hclToRgb,
	                  interpolate: interpolateHcl
	                };
	                var colorSpaces = /* @__PURE__ */ Object.freeze({
	                  __proto__: null,
	                  lab,
	                  hcl
	                });
	                var Interpolate = function Interpolate2(type, operator, interpolation, input, stops) {
	                  this.type = type;
	                  this.operator = operator;
	                  this.interpolation = interpolation;
	                  this.input = input;
	                  this.labels = [];
	                  this.outputs = [];
	                  for (var i = 0, list = stops; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var label = ref[0];
	                    var expression2 = ref[1];
	                    this.labels.push(label);
	                    this.outputs.push(expression2);
	                  }
	                };
	                Interpolate.interpolationFactor = function interpolationFactor2(interpolation, input, lower, upper) {
	                  var t = 0;
	                  if (interpolation.name === "exponential") {
	                    t = exponentialInterpolation(input, interpolation.base, lower, upper);
	                  } else if (interpolation.name === "linear") {
	                    t = exponentialInterpolation(input, 1, lower, upper);
	                  } else if (interpolation.name === "cubic-bezier") {
	                    var c = interpolation.controlPoints;
	                    var ub = new unitbezier(c[0], c[1], c[2], c[3]);
	                    t = ub.solve(exponentialInterpolation(input, 1, lower, upper));
	                  }
	                  return t;
	                };
	                Interpolate.parse = function parse(args, context) {
	                  var operator = args[0];
	                  var interpolation = args[1];
	                  var input = args[2];
	                  var rest = args.slice(3);
	                  if (!Array.isArray(interpolation) || interpolation.length === 0) {
	                    return context.error("Expected an interpolation type expression.", 1);
	                  }
	                  if (interpolation[0] === "linear") {
	                    interpolation = { name: "linear" };
	                  } else if (interpolation[0] === "exponential") {
	                    var base = interpolation[1];
	                    if (typeof base !== "number") {
	                      return context.error("Exponential interpolation requires a numeric base.", 1, 1);
	                    }
	                    interpolation = {
	                      name: "exponential",
	                      base
	                    };
	                  } else if (interpolation[0] === "cubic-bezier") {
	                    var controlPoints = interpolation.slice(1);
	                    if (controlPoints.length !== 4 || controlPoints.some(function(t) {
	                      return typeof t !== "number" || t < 0 || t > 1;
	                    })) {
	                      return context.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
	                    }
	                    interpolation = {
	                      name: "cubic-bezier",
	                      controlPoints
	                    };
	                  } else {
	                    return context.error("Unknown interpolation type " + String(interpolation[0]), 1, 0);
	                  }
	                  if (args.length - 1 < 4) {
	                    return context.error("Expected at least 4 arguments, but found only " + (args.length - 1) + ".");
	                  }
	                  if ((args.length - 1) % 2 !== 0) {
	                    return context.error("Expected an even number of arguments.");
	                  }
	                  input = context.parse(input, 2, NumberType);
	                  if (!input) {
	                    return null;
	                  }
	                  var stops = [];
	                  var outputType = null;
	                  if (operator === "interpolate-hcl" || operator === "interpolate-lab") {
	                    outputType = ColorType;
	                  } else if (context.expectedType && context.expectedType.kind !== "value") {
	                    outputType = context.expectedType;
	                  }
	                  for (var i = 0; i < rest.length; i += 2) {
	                    var label = rest[i];
	                    var value = rest[i + 1];
	                    var labelKey = i + 3;
	                    var valueKey = i + 4;
	                    if (typeof label !== "number") {
	                      return context.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
	                    }
	                    if (stops.length && stops[stops.length - 1][0] >= label) {
	                      return context.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', labelKey);
	                    }
	                    var parsed = context.parse(value, valueKey, outputType);
	                    if (!parsed) {
	                      return null;
	                    }
	                    outputType = outputType || parsed.type;
	                    stops.push([
	                      label,
	                      parsed
	                    ]);
	                  }
	                  if (outputType.kind !== "number" && outputType.kind !== "color" && !(outputType.kind === "array" && outputType.itemType.kind === "number" && typeof outputType.N === "number")) {
	                    return context.error("Type " + toString(outputType) + " is not interpolatable.");
	                  }
	                  return new Interpolate(outputType, operator, interpolation, input, stops);
	                };
	                Interpolate.prototype.evaluate = function evaluate(ctx) {
	                  var labels = this.labels;
	                  var outputs = this.outputs;
	                  if (labels.length === 1) {
	                    return outputs[0].evaluate(ctx);
	                  }
	                  var value = this.input.evaluate(ctx);
	                  if (value <= labels[0]) {
	                    return outputs[0].evaluate(ctx);
	                  }
	                  var stopCount = labels.length;
	                  if (value >= labels[stopCount - 1]) {
	                    return outputs[stopCount - 1].evaluate(ctx);
	                  }
	                  var index = findStopLessThanOrEqualTo(labels, value);
	                  var lower = labels[index];
	                  var upper = labels[index + 1];
	                  var t = Interpolate.interpolationFactor(this.interpolation, value, lower, upper);
	                  var outputLower = outputs[index].evaluate(ctx);
	                  var outputUpper = outputs[index + 1].evaluate(ctx);
	                  if (this.operator === "interpolate") {
	                    return interpolate[this.type.kind.toLowerCase()](outputLower, outputUpper, t);
	                  } else if (this.operator === "interpolate-hcl") {
	                    return hcl.reverse(hcl.interpolate(hcl.forward(outputLower), hcl.forward(outputUpper), t));
	                  } else {
	                    return lab.reverse(lab.interpolate(lab.forward(outputLower), lab.forward(outputUpper), t));
	                  }
	                };
	                Interpolate.prototype.eachChild = function eachChild(fn) {
	                  fn(this.input);
	                  for (var i = 0, list = this.outputs; i < list.length; i += 1) {
	                    var expression2 = list[i];
	                    fn(expression2);
	                  }
	                };
	                Interpolate.prototype.outputDefined = function outputDefined() {
	                  return this.outputs.every(function(out) {
	                    return out.outputDefined();
	                  });
	                };
	                Interpolate.prototype.serialize = function serialize2() {
	                  var interpolation;
	                  if (this.interpolation.name === "linear") {
	                    interpolation = ["linear"];
	                  } else if (this.interpolation.name === "exponential") {
	                    if (this.interpolation.base === 1) {
	                      interpolation = ["linear"];
	                    } else {
	                      interpolation = [
	                        "exponential",
	                        this.interpolation.base
	                      ];
	                    }
	                  } else {
	                    interpolation = ["cubic-bezier"].concat(this.interpolation.controlPoints);
	                  }
	                  var serialized = [
	                    this.operator,
	                    interpolation,
	                    this.input.serialize()
	                  ];
	                  for (var i = 0; i < this.labels.length; i++) {
	                    serialized.push(this.labels[i], this.outputs[i].serialize());
	                  }
	                  return serialized;
	                };
	                function exponentialInterpolation(input, base, lowerValue, upperValue) {
	                  var difference = upperValue - lowerValue;
	                  var progress = input - lowerValue;
	                  if (difference === 0) {
	                    return 0;
	                  } else if (base === 1) {
	                    return progress / difference;
	                  } else {
	                    return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
	                  }
	                }
	                var Coalesce = function Coalesce2(type, args) {
	                  this.type = type;
	                  this.args = args;
	                };
	                Coalesce.parse = function parse(args, context) {
	                  if (args.length < 2) {
	                    return context.error("Expectected at least one argument.");
	                  }
	                  var outputType = null;
	                  var expectedType = context.expectedType;
	                  if (expectedType && expectedType.kind !== "value") {
	                    outputType = expectedType;
	                  }
	                  var parsedArgs = [];
	                  for (var i = 0, list = args.slice(1); i < list.length; i += 1) {
	                    var arg = list[i];
	                    var parsed = context.parse(arg, 1 + parsedArgs.length, outputType, undefined, { typeAnnotation: "omit" });
	                    if (!parsed) {
	                      return null;
	                    }
	                    outputType = outputType || parsed.type;
	                    parsedArgs.push(parsed);
	                  }
	                  var needsAnnotation = expectedType && parsedArgs.some(function(arg2) {
	                    return checkSubtype(expectedType, arg2.type);
	                  });
	                  return needsAnnotation ? new Coalesce(ValueType, parsedArgs) : new Coalesce(outputType, parsedArgs);
	                };
	                Coalesce.prototype.evaluate = function evaluate(ctx) {
	                  var result = null;
	                  var argCount = 0;
	                  var requestedImageName;
	                  for (var i = 0, list = this.args; i < list.length; i += 1) {
	                    var arg = list[i];
	                    argCount++;
	                    result = arg.evaluate(ctx);
	                    if (result && result instanceof ResolvedImage && !result.available) {
	                      if (!requestedImageName) {
	                        requestedImageName = result.name;
	                      }
	                      result = null;
	                      if (argCount === this.args.length) {
	                        result = requestedImageName;
	                      }
	                    }
	                    if (result !== null) {
	                      break;
	                    }
	                  }
	                  return result;
	                };
	                Coalesce.prototype.eachChild = function eachChild(fn) {
	                  this.args.forEach(fn);
	                };
	                Coalesce.prototype.outputDefined = function outputDefined() {
	                  return this.args.every(function(arg) {
	                    return arg.outputDefined();
	                  });
	                };
	                Coalesce.prototype.serialize = function serialize2() {
	                  var serialized = ["coalesce"];
	                  this.eachChild(function(child) {
	                    serialized.push(child.serialize());
	                  });
	                  return serialized;
	                };
	                var Let = function Let2(bindings, result) {
	                  this.type = result.type;
	                  this.bindings = [].concat(bindings);
	                  this.result = result;
	                };
	                Let.prototype.evaluate = function evaluate(ctx) {
	                  return this.result.evaluate(ctx);
	                };
	                Let.prototype.eachChild = function eachChild(fn) {
	                  for (var i = 0, list = this.bindings; i < list.length; i += 1) {
	                    var binding = list[i];
	                    fn(binding[1]);
	                  }
	                  fn(this.result);
	                };
	                Let.parse = function parse(args, context) {
	                  if (args.length < 4) {
	                    return context.error("Expected at least 3 arguments, but found " + (args.length - 1) + " instead.");
	                  }
	                  var bindings = [];
	                  for (var i = 1; i < args.length - 1; i += 2) {
	                    var name3 = args[i];
	                    if (typeof name3 !== "string") {
	                      return context.error("Expected string, but found " + typeof name3 + " instead.", i);
	                    }
	                    if (/[^a-zA-Z0-9_]/.test(name3)) {
	                      return context.error("Variable names must contain only alphanumeric characters or '_'.", i);
	                    }
	                    var value = context.parse(args[i + 1], i + 1);
	                    if (!value) {
	                      return null;
	                    }
	                    bindings.push([
	                      name3,
	                      value
	                    ]);
	                  }
	                  var result = context.parse(args[args.length - 1], args.length - 1, context.expectedType, bindings);
	                  if (!result) {
	                    return null;
	                  }
	                  return new Let(bindings, result);
	                };
	                Let.prototype.outputDefined = function outputDefined() {
	                  return this.result.outputDefined();
	                };
	                Let.prototype.serialize = function serialize2() {
	                  var serialized = ["let"];
	                  for (var i = 0, list = this.bindings; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var name3 = ref[0];
	                    var expr = ref[1];
	                    serialized.push(name3, expr.serialize());
	                  }
	                  serialized.push(this.result.serialize());
	                  return serialized;
	                };
	                var At = function At2(type, index, input) {
	                  this.type = type;
	                  this.index = index;
	                  this.input = input;
	                };
	                At.parse = function parse(args, context) {
	                  if (args.length !== 3) {
	                    return context.error("Expected 2 arguments, but found " + (args.length - 1) + " instead.");
	                  }
	                  var index = context.parse(args[1], 1, NumberType);
	                  var input = context.parse(args[2], 2, array(context.expectedType || ValueType));
	                  if (!index || !input) {
	                    return null;
	                  }
	                  var t = input.type;
	                  return new At(t.itemType, index, input);
	                };
	                At.prototype.evaluate = function evaluate(ctx) {
	                  var index = this.index.evaluate(ctx);
	                  var array2 = this.input.evaluate(ctx);
	                  if (index < 0) {
	                    throw new RuntimeError("Array index out of bounds: " + index + " < 0.");
	                  }
	                  if (index >= array2.length) {
	                    throw new RuntimeError("Array index out of bounds: " + index + " > " + (array2.length - 1) + ".");
	                  }
	                  if (index !== Math.floor(index)) {
	                    throw new RuntimeError("Array index must be an integer, but found " + index + " instead.");
	                  }
	                  return array2[index];
	                };
	                At.prototype.eachChild = function eachChild(fn) {
	                  fn(this.index);
	                  fn(this.input);
	                };
	                At.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                At.prototype.serialize = function serialize2() {
	                  return [
	                    "at",
	                    this.index.serialize(),
	                    this.input.serialize()
	                  ];
	                };
	                var In = function In2(needle, haystack) {
	                  this.type = BooleanType;
	                  this.needle = needle;
	                  this.haystack = haystack;
	                };
	                In.parse = function parse(args, context) {
	                  if (args.length !== 3) {
	                    return context.error("Expected 2 arguments, but found " + (args.length - 1) + " instead.");
	                  }
	                  var needle = context.parse(args[1], 1, ValueType);
	                  var haystack = context.parse(args[2], 2, ValueType);
	                  if (!needle || !haystack) {
	                    return null;
	                  }
	                  if (!isValidType(needle.type, [
	                    BooleanType,
	                    StringType,
	                    NumberType,
	                    NullType,
	                    ValueType
	                  ])) {
	                    return context.error("Expected first argument to be of type boolean, string, number or null, but found " + toString(needle.type) + " instead");
	                  }
	                  return new In(needle, haystack);
	                };
	                In.prototype.evaluate = function evaluate(ctx) {
	                  var needle = this.needle.evaluate(ctx);
	                  var haystack = this.haystack.evaluate(ctx);
	                  if (!haystack) {
	                    return false;
	                  }
	                  if (!isValidNativeType(needle, [
	                    "boolean",
	                    "string",
	                    "number",
	                    "null"
	                  ])) {
	                    throw new RuntimeError("Expected first argument to be of type boolean, string, number or null, but found " + toString(typeOf(needle)) + " instead.");
	                  }
	                  if (!isValidNativeType(haystack, [
	                    "string",
	                    "array"
	                  ])) {
	                    throw new RuntimeError("Expected second argument to be of type array or string, but found " + toString(typeOf(haystack)) + " instead.");
	                  }
	                  return haystack.indexOf(needle) >= 0;
	                };
	                In.prototype.eachChild = function eachChild(fn) {
	                  fn(this.needle);
	                  fn(this.haystack);
	                };
	                In.prototype.outputDefined = function outputDefined() {
	                  return true;
	                };
	                In.prototype.serialize = function serialize2() {
	                  return [
	                    "in",
	                    this.needle.serialize(),
	                    this.haystack.serialize()
	                  ];
	                };
	                var IndexOf = function IndexOf2(needle, haystack, fromIndex) {
	                  this.type = NumberType;
	                  this.needle = needle;
	                  this.haystack = haystack;
	                  this.fromIndex = fromIndex;
	                };
	                IndexOf.parse = function parse(args, context) {
	                  if (args.length <= 2 || args.length >= 5) {
	                    return context.error("Expected 3 or 4 arguments, but found " + (args.length - 1) + " instead.");
	                  }
	                  var needle = context.parse(args[1], 1, ValueType);
	                  var haystack = context.parse(args[2], 2, ValueType);
	                  if (!needle || !haystack) {
	                    return null;
	                  }
	                  if (!isValidType(needle.type, [
	                    BooleanType,
	                    StringType,
	                    NumberType,
	                    NullType,
	                    ValueType
	                  ])) {
	                    return context.error("Expected first argument to be of type boolean, string, number or null, but found " + toString(needle.type) + " instead");
	                  }
	                  if (args.length === 4) {
	                    var fromIndex = context.parse(args[3], 3, NumberType);
	                    if (!fromIndex) {
	                      return null;
	                    }
	                    return new IndexOf(needle, haystack, fromIndex);
	                  } else {
	                    return new IndexOf(needle, haystack);
	                  }
	                };
	                IndexOf.prototype.evaluate = function evaluate(ctx) {
	                  var needle = this.needle.evaluate(ctx);
	                  var haystack = this.haystack.evaluate(ctx);
	                  if (!isValidNativeType(needle, [
	                    "boolean",
	                    "string",
	                    "number",
	                    "null"
	                  ])) {
	                    throw new RuntimeError("Expected first argument to be of type boolean, string, number or null, but found " + toString(typeOf(needle)) + " instead.");
	                  }
	                  if (!isValidNativeType(haystack, [
	                    "string",
	                    "array"
	                  ])) {
	                    throw new RuntimeError("Expected second argument to be of type array or string, but found " + toString(typeOf(haystack)) + " instead.");
	                  }
	                  if (this.fromIndex) {
	                    var fromIndex = this.fromIndex.evaluate(ctx);
	                    return haystack.indexOf(needle, fromIndex);
	                  }
	                  return haystack.indexOf(needle);
	                };
	                IndexOf.prototype.eachChild = function eachChild(fn) {
	                  fn(this.needle);
	                  fn(this.haystack);
	                  if (this.fromIndex) {
	                    fn(this.fromIndex);
	                  }
	                };
	                IndexOf.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                IndexOf.prototype.serialize = function serialize2() {
	                  if (this.fromIndex != null && this.fromIndex !== undefined) {
	                    var fromIndex = this.fromIndex.serialize();
	                    return [
	                      "index-of",
	                      this.needle.serialize(),
	                      this.haystack.serialize(),
	                      fromIndex
	                    ];
	                  }
	                  return [
	                    "index-of",
	                    this.needle.serialize(),
	                    this.haystack.serialize()
	                  ];
	                };
	                var Match = function Match2(inputType, outputType, input, cases, outputs, otherwise) {
	                  this.inputType = inputType;
	                  this.type = outputType;
	                  this.input = input;
	                  this.cases = cases;
	                  this.outputs = outputs;
	                  this.otherwise = otherwise;
	                };
	                Match.parse = function parse(args, context) {
	                  if (args.length < 5) {
	                    return context.error("Expected at least 4 arguments, but found only " + (args.length - 1) + ".");
	                  }
	                  if (args.length % 2 !== 1) {
	                    return context.error("Expected an even number of arguments.");
	                  }
	                  var inputType;
	                  var outputType;
	                  if (context.expectedType && context.expectedType.kind !== "value") {
	                    outputType = context.expectedType;
	                  }
	                  var cases = {};
	                  var outputs = [];
	                  for (var i = 2; i < args.length - 1; i += 2) {
	                    var labels = args[i];
	                    var value = args[i + 1];
	                    if (!Array.isArray(labels)) {
	                      labels = [labels];
	                    }
	                    var labelContext = context.concat(i);
	                    if (labels.length === 0) {
	                      return labelContext.error("Expected at least one branch label.");
	                    }
	                    for (var i$1 = 0, list = labels; i$1 < list.length; i$1 += 1) {
	                      var label = list[i$1];
	                      if (typeof label !== "number" && typeof label !== "string") {
	                        return labelContext.error("Branch labels must be numbers or strings.");
	                      } else if (typeof label === "number" && Math.abs(label) > Number.MAX_SAFE_INTEGER) {
	                        return labelContext.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
	                      } else if (typeof label === "number" && Math.floor(label) !== label) {
	                        return labelContext.error("Numeric branch labels must be integer values.");
	                      } else if (!inputType) {
	                        inputType = typeOf(label);
	                      } else if (labelContext.checkSubtype(inputType, typeOf(label))) {
	                        return null;
	                      }
	                      if (typeof cases[String(label)] !== "undefined") {
	                        return labelContext.error("Branch labels must be unique.");
	                      }
	                      cases[String(label)] = outputs.length;
	                    }
	                    var result = context.parse(value, i, outputType);
	                    if (!result) {
	                      return null;
	                    }
	                    outputType = outputType || result.type;
	                    outputs.push(result);
	                  }
	                  var input = context.parse(args[1], 1, ValueType);
	                  if (!input) {
	                    return null;
	                  }
	                  var otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
	                  if (!otherwise) {
	                    return null;
	                  }
	                  if (input.type.kind !== "value" && context.concat(1).checkSubtype(inputType, input.type)) {
	                    return null;
	                  }
	                  return new Match(inputType, outputType, input, cases, outputs, otherwise);
	                };
	                Match.prototype.evaluate = function evaluate(ctx) {
	                  var input = this.input.evaluate(ctx);
	                  var output = typeOf(input) === this.inputType && this.outputs[this.cases[input]] || this.otherwise;
	                  return output.evaluate(ctx);
	                };
	                Match.prototype.eachChild = function eachChild(fn) {
	                  fn(this.input);
	                  this.outputs.forEach(fn);
	                  fn(this.otherwise);
	                };
	                Match.prototype.outputDefined = function outputDefined() {
	                  return this.outputs.every(function(out) {
	                    return out.outputDefined();
	                  }) && this.otherwise.outputDefined();
	                };
	                Match.prototype.serialize = function serialize2() {
	                  var this$1$1 = this;
	                  var serialized = [
	                    "match",
	                    this.input.serialize()
	                  ];
	                  var sortedLabels = Object.keys(this.cases).sort();
	                  var groupedByOutput = [];
	                  var outputLookup = {};
	                  for (var i = 0, list = sortedLabels; i < list.length; i += 1) {
	                    var label = list[i];
	                    var outputIndex = outputLookup[this.cases[label]];
	                    if (outputIndex === undefined) {
	                      outputLookup[this.cases[label]] = groupedByOutput.length;
	                      groupedByOutput.push([
	                        this.cases[label],
	                        [label]
	                      ]);
	                    } else {
	                      groupedByOutput[outputIndex][1].push(label);
	                    }
	                  }
	                  var coerceLabel = function(label2) {
	                    return this$1$1.inputType.kind === "number" ? Number(label2) : label2;
	                  };
	                  for (var i$1 = 0, list$1 = groupedByOutput; i$1 < list$1.length; i$1 += 1) {
	                    var ref = list$1[i$1];
	                    var outputIndex = ref[0];
	                    var labels = ref[1];
	                    if (labels.length === 1) {
	                      serialized.push(coerceLabel(labels[0]));
	                    } else {
	                      serialized.push(labels.map(coerceLabel));
	                    }
	                    serialized.push(this.outputs[outputIndex$1].serialize());
	                  }
	                  serialized.push(this.otherwise.serialize());
	                  return serialized;
	                };
	                var Case = function Case2(type, branches, otherwise) {
	                  this.type = type;
	                  this.branches = branches;
	                  this.otherwise = otherwise;
	                };
	                Case.parse = function parse(args, context) {
	                  if (args.length < 4) {
	                    return context.error("Expected at least 3 arguments, but found only " + (args.length - 1) + ".");
	                  }
	                  if (args.length % 2 !== 0) {
	                    return context.error("Expected an odd number of arguments.");
	                  }
	                  var outputType;
	                  if (context.expectedType && context.expectedType.kind !== "value") {
	                    outputType = context.expectedType;
	                  }
	                  var branches = [];
	                  for (var i = 1; i < args.length - 1; i += 2) {
	                    var test = context.parse(args[i], i, BooleanType);
	                    if (!test) {
	                      return null;
	                    }
	                    var result = context.parse(args[i + 1], i + 1, outputType);
	                    if (!result) {
	                      return null;
	                    }
	                    branches.push([
	                      test,
	                      result
	                    ]);
	                    outputType = outputType || result.type;
	                  }
	                  var otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
	                  if (!otherwise) {
	                    return null;
	                  }
	                  return new Case(outputType, branches, otherwise);
	                };
	                Case.prototype.evaluate = function evaluate(ctx) {
	                  for (var i = 0, list = this.branches; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var test = ref[0];
	                    var expression2 = ref[1];
	                    if (test.evaluate(ctx)) {
	                      return expression2.evaluate(ctx);
	                    }
	                  }
	                  return this.otherwise.evaluate(ctx);
	                };
	                Case.prototype.eachChild = function eachChild(fn) {
	                  for (var i = 0, list = this.branches; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var test = ref[0];
	                    var expression2 = ref[1];
	                    fn(test);
	                    fn(expression2);
	                  }
	                  fn(this.otherwise);
	                };
	                Case.prototype.outputDefined = function outputDefined() {
	                  return this.branches.every(function(ref) {
	                    ref[0];
	                    var out = ref[1];
	                    return out.outputDefined();
	                  }) && this.otherwise.outputDefined();
	                };
	                Case.prototype.serialize = function serialize2() {
	                  var serialized = ["case"];
	                  this.eachChild(function(child) {
	                    serialized.push(child.serialize());
	                  });
	                  return serialized;
	                };
	                var Slice = function Slice2(type, input, beginIndex, endIndex) {
	                  this.type = type;
	                  this.input = input;
	                  this.beginIndex = beginIndex;
	                  this.endIndex = endIndex;
	                };
	                Slice.parse = function parse(args, context) {
	                  if (args.length <= 2 || args.length >= 5) {
	                    return context.error("Expected 3 or 4 arguments, but found " + (args.length - 1) + " instead.");
	                  }
	                  var input = context.parse(args[1], 1, ValueType);
	                  var beginIndex = context.parse(args[2], 2, NumberType);
	                  if (!input || !beginIndex) {
	                    return null;
	                  }
	                  if (!isValidType(input.type, [
	                    array(ValueType),
	                    StringType,
	                    ValueType
	                  ])) {
	                    return context.error("Expected first argument to be of type array or string, but found " + toString(input.type) + " instead");
	                  }
	                  if (args.length === 4) {
	                    var endIndex = context.parse(args[3], 3, NumberType);
	                    if (!endIndex) {
	                      return null;
	                    }
	                    return new Slice(input.type, input, beginIndex, endIndex);
	                  } else {
	                    return new Slice(input.type, input, beginIndex);
	                  }
	                };
	                Slice.prototype.evaluate = function evaluate(ctx) {
	                  var input = this.input.evaluate(ctx);
	                  var beginIndex = this.beginIndex.evaluate(ctx);
	                  if (!isValidNativeType(input, [
	                    "string",
	                    "array"
	                  ])) {
	                    throw new RuntimeError("Expected first argument to be of type array or string, but found " + toString(typeOf(input)) + " instead.");
	                  }
	                  if (this.endIndex) {
	                    var endIndex = this.endIndex.evaluate(ctx);
	                    return input.slice(beginIndex, endIndex);
	                  }
	                  return input.slice(beginIndex);
	                };
	                Slice.prototype.eachChild = function eachChild(fn) {
	                  fn(this.input);
	                  fn(this.beginIndex);
	                  if (this.endIndex) {
	                    fn(this.endIndex);
	                  }
	                };
	                Slice.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                Slice.prototype.serialize = function serialize2() {
	                  if (this.endIndex != null && this.endIndex !== undefined) {
	                    var endIndex = this.endIndex.serialize();
	                    return [
	                      "slice",
	                      this.input.serialize(),
	                      this.beginIndex.serialize(),
	                      endIndex
	                    ];
	                  }
	                  return [
	                    "slice",
	                    this.input.serialize(),
	                    this.beginIndex.serialize()
	                  ];
	                };
	                function isComparableType(op, type) {
	                  if (op === "==" || op === "!=") {
	                    return type.kind === "boolean" || type.kind === "string" || type.kind === "number" || type.kind === "null" || type.kind === "value";
	                  } else {
	                    return type.kind === "string" || type.kind === "number" || type.kind === "value";
	                  }
	                }
	                function eq(ctx, a, b) {
	                  return a === b;
	                }
	                function neq(ctx, a, b) {
	                  return a !== b;
	                }
	                function lt(ctx, a, b) {
	                  return a < b;
	                }
	                function gt(ctx, a, b) {
	                  return a > b;
	                }
	                function lteq(ctx, a, b) {
	                  return a <= b;
	                }
	                function gteq(ctx, a, b) {
	                  return a >= b;
	                }
	                function eqCollate(ctx, a, b, c) {
	                  return c.compare(a, b) === 0;
	                }
	                function neqCollate(ctx, a, b, c) {
	                  return !eqCollate(ctx, a, b, c);
	                }
	                function ltCollate(ctx, a, b, c) {
	                  return c.compare(a, b) < 0;
	                }
	                function gtCollate(ctx, a, b, c) {
	                  return c.compare(a, b) > 0;
	                }
	                function lteqCollate(ctx, a, b, c) {
	                  return c.compare(a, b) <= 0;
	                }
	                function gteqCollate(ctx, a, b, c) {
	                  return c.compare(a, b) >= 0;
	                }
	                function makeComparison(op, compareBasic, compareWithCollator) {
	                  var isOrderComparison = op !== "==" && op !== "!=";
	                  return function() {
	                    function Comparison(lhs, rhs, collator) {
	                      this.type = BooleanType;
	                      this.lhs = lhs;
	                      this.rhs = rhs;
	                      this.collator = collator;
	                      this.hasUntypedArgument = lhs.type.kind === "value" || rhs.type.kind === "value";
	                    }
	                    Comparison.parse = function parse(args, context) {
	                      if (args.length !== 3 && args.length !== 4) {
	                        return context.error("Expected two or three arguments.");
	                      }
	                      var op2 = args[0];
	                      var lhs = context.parse(args[1], 1, ValueType);
	                      if (!lhs) {
	                        return null;
	                      }
	                      if (!isComparableType(op2, lhs.type)) {
	                        return context.concat(1).error('"' + op2 + `" comparisons are not supported for type '` + toString(lhs.type) + "'.");
	                      }
	                      var rhs = context.parse(args[2], 2, ValueType);
	                      if (!rhs) {
	                        return null;
	                      }
	                      if (!isComparableType(op2, rhs.type)) {
	                        return context.concat(2).error('"' + op2 + `" comparisons are not supported for type '` + toString(rhs.type) + "'.");
	                      }
	                      if (lhs.type.kind !== rhs.type.kind && lhs.type.kind !== "value" && rhs.type.kind !== "value") {
	                        return context.error("Cannot compare types '" + toString(lhs.type) + "' and '" + toString(rhs.type) + "'.");
	                      }
	                      if (isOrderComparison) {
	                        if (lhs.type.kind === "value" && rhs.type.kind !== "value") {
	                          lhs = new Assertion(rhs.type, [lhs]);
	                        } else if (lhs.type.kind !== "value" && rhs.type.kind === "value") {
	                          rhs = new Assertion(lhs.type, [rhs]);
	                        }
	                      }
	                      var collator = null;
	                      if (args.length === 4) {
	                        if (lhs.type.kind !== "string" && rhs.type.kind !== "string" && lhs.type.kind !== "value" && rhs.type.kind !== "value") {
	                          return context.error("Cannot use collator to compare non-string types.");
	                        }
	                        collator = context.parse(args[3], 3, CollatorType);
	                        if (!collator) {
	                          return null;
	                        }
	                      }
	                      return new Comparison(lhs, rhs, collator);
	                    };
	                    Comparison.prototype.evaluate = function evaluate(ctx) {
	                      var lhs = this.lhs.evaluate(ctx);
	                      var rhs = this.rhs.evaluate(ctx);
	                      if (isOrderComparison && this.hasUntypedArgument) {
	                        var lt2 = typeOf(lhs);
	                        var rt = typeOf(rhs);
	                        if (lt2.kind !== rt.kind || !(lt2.kind === "string" || lt2.kind === "number")) {
	                          throw new RuntimeError('Expected arguments for "' + op + '" to be (string, string) or (number, number), but found (' + lt2.kind + ", " + rt.kind + ") instead.");
	                        }
	                      }
	                      if (this.collator && !isOrderComparison && this.hasUntypedArgument) {
	                        var lt$1 = typeOf(lhs);
	                        var rt$1 = typeOf(rhs);
	                        if (lt$1.kind !== "string" || rt$1.kind !== "string") {
	                          return compareBasic(ctx, lhs, rhs);
	                        }
	                      }
	                      return this.collator ? compareWithCollator(ctx, lhs, rhs, this.collator.evaluate(ctx)) : compareBasic(ctx, lhs, rhs);
	                    };
	                    Comparison.prototype.eachChild = function eachChild(fn) {
	                      fn(this.lhs);
	                      fn(this.rhs);
	                      if (this.collator) {
	                        fn(this.collator);
	                      }
	                    };
	                    Comparison.prototype.outputDefined = function outputDefined() {
	                      return true;
	                    };
	                    Comparison.prototype.serialize = function serialize2() {
	                      var serialized = [op];
	                      this.eachChild(function(child) {
	                        serialized.push(child.serialize());
	                      });
	                      return serialized;
	                    };
	                    return Comparison;
	                  }();
	                }
	                var Equals = makeComparison("==", eq, eqCollate);
	                var NotEquals = makeComparison("!=", neq, neqCollate);
	                var LessThan = makeComparison("<", lt, ltCollate);
	                var GreaterThan = makeComparison(">", gt, gtCollate);
	                var LessThanOrEqual = makeComparison("<=", lteq, lteqCollate);
	                var GreaterThanOrEqual = makeComparison(">=", gteq, gteqCollate);
	                var NumberFormat = function NumberFormat2(number3, locale, currency, minFractionDigits, maxFractionDigits) {
	                  this.type = StringType;
	                  this.number = number3;
	                  this.locale = locale;
	                  this.currency = currency;
	                  this.minFractionDigits = minFractionDigits;
	                  this.maxFractionDigits = maxFractionDigits;
	                };
	                NumberFormat.parse = function parse(args, context) {
	                  if (args.length !== 3) {
	                    return context.error("Expected two arguments.");
	                  }
	                  var number3 = context.parse(args[1], 1, NumberType);
	                  if (!number3) {
	                    return null;
	                  }
	                  var options = args[2];
	                  if (typeof options !== "object" || Array.isArray(options)) {
	                    return context.error("NumberFormat options argument must be an object.");
	                  }
	                  var locale = null;
	                  if (options["locale"]) {
	                    locale = context.parse(options["locale"], 1, StringType);
	                    if (!locale) {
	                      return null;
	                    }
	                  }
	                  var currency = null;
	                  if (options["currency"]) {
	                    currency = context.parse(options["currency"], 1, StringType);
	                    if (!currency) {
	                      return null;
	                    }
	                  }
	                  var minFractionDigits = null;
	                  if (options["min-fraction-digits"]) {
	                    minFractionDigits = context.parse(options["min-fraction-digits"], 1, NumberType);
	                    if (!minFractionDigits) {
	                      return null;
	                    }
	                  }
	                  var maxFractionDigits = null;
	                  if (options["max-fraction-digits"]) {
	                    maxFractionDigits = context.parse(options["max-fraction-digits"], 1, NumberType);
	                    if (!maxFractionDigits) {
	                      return null;
	                    }
	                  }
	                  return new NumberFormat(number3, locale, currency, minFractionDigits, maxFractionDigits);
	                };
	                NumberFormat.prototype.evaluate = function evaluate(ctx) {
	                  return new Intl.NumberFormat(this.locale ? this.locale.evaluate(ctx) : [], {
	                    style: this.currency ? "currency" : "decimal",
	                    currency: this.currency ? this.currency.evaluate(ctx) : undefined,
	                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(ctx) : undefined,
	                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(ctx) : undefined
	                  }).format(this.number.evaluate(ctx));
	                };
	                NumberFormat.prototype.eachChild = function eachChild(fn) {
	                  fn(this.number);
	                  if (this.locale) {
	                    fn(this.locale);
	                  }
	                  if (this.currency) {
	                    fn(this.currency);
	                  }
	                  if (this.minFractionDigits) {
	                    fn(this.minFractionDigits);
	                  }
	                  if (this.maxFractionDigits) {
	                    fn(this.maxFractionDigits);
	                  }
	                };
	                NumberFormat.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                NumberFormat.prototype.serialize = function serialize2() {
	                  var options = {};
	                  if (this.locale) {
	                    options["locale"] = this.locale.serialize();
	                  }
	                  if (this.currency) {
	                    options["currency"] = this.currency.serialize();
	                  }
	                  if (this.minFractionDigits) {
	                    options["min-fraction-digits"] = this.minFractionDigits.serialize();
	                  }
	                  if (this.maxFractionDigits) {
	                    options["max-fraction-digits"] = this.maxFractionDigits.serialize();
	                  }
	                  return [
	                    "number-format",
	                    this.number.serialize(),
	                    options
	                  ];
	                };
	                var Length = function Length2(input) {
	                  this.type = NumberType;
	                  this.input = input;
	                };
	                Length.parse = function parse(args, context) {
	                  if (args.length !== 2) {
	                    return context.error("Expected 1 argument, but found " + (args.length - 1) + " instead.");
	                  }
	                  var input = context.parse(args[1], 1);
	                  if (!input) {
	                    return null;
	                  }
	                  if (input.type.kind !== "array" && input.type.kind !== "string" && input.type.kind !== "value") {
	                    return context.error("Expected argument of type string or array, but found " + toString(input.type) + " instead.");
	                  }
	                  return new Length(input);
	                };
	                Length.prototype.evaluate = function evaluate(ctx) {
	                  var input = this.input.evaluate(ctx);
	                  if (typeof input === "string") {
	                    return input.length;
	                  } else if (Array.isArray(input)) {
	                    return input.length;
	                  } else {
	                    throw new RuntimeError("Expected value to be of type string or array, but found " + toString(typeOf(input)) + " instead.");
	                  }
	                };
	                Length.prototype.eachChild = function eachChild(fn) {
	                  fn(this.input);
	                };
	                Length.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                Length.prototype.serialize = function serialize2() {
	                  var serialized = ["length"];
	                  this.eachChild(function(child) {
	                    serialized.push(child.serialize());
	                  });
	                  return serialized;
	                };
	                var expressions = {
	                  "==": Equals,
	                  "!=": NotEquals,
	                  ">": GreaterThan,
	                  "<": LessThan,
	                  ">=": GreaterThanOrEqual,
	                  "<=": LessThanOrEqual,
	                  "array": Assertion,
	                  "at": At,
	                  "boolean": Assertion,
	                  "case": Case,
	                  "coalesce": Coalesce,
	                  "collator": CollatorExpression,
	                  "format": FormatExpression,
	                  "image": ImageExpression,
	                  "in": In,
	                  "index-of": IndexOf,
	                  "interpolate": Interpolate,
	                  "interpolate-hcl": Interpolate,
	                  "interpolate-lab": Interpolate,
	                  "length": Length,
	                  "let": Let,
	                  "literal": Literal,
	                  "match": Match,
	                  "number": Assertion,
	                  "number-format": NumberFormat,
	                  "object": Assertion,
	                  "slice": Slice,
	                  "step": Step,
	                  "string": Assertion,
	                  "to-boolean": Coercion,
	                  "to-color": Coercion,
	                  "to-number": Coercion,
	                  "to-string": Coercion,
	                  "var": Var,
	                  "within": Within
	                };
	                function rgba(ctx, ref) {
	                  var r = ref[0];
	                  var g = ref[1];
	                  var b = ref[2];
	                  var a = ref[3];
	                  r = r.evaluate(ctx);
	                  g = g.evaluate(ctx);
	                  b = b.evaluate(ctx);
	                  var alpha = a ? a.evaluate(ctx) : 1;
	                  var error2 = validateRGBA(r, g, b, alpha);
	                  if (error2) {
	                    throw new RuntimeError(error2);
	                  }
	                  return new Color(r / 255 * alpha, g / 255 * alpha, b / 255 * alpha, alpha);
	                }
	                function has(key, obj) {
	                  return key in obj;
	                }
	                function get(key, obj) {
	                  var v = obj[key];
	                  return typeof v === "undefined" ? null : v;
	                }
	                function binarySearch(v, a, i, j) {
	                  while (i <= j) {
	                    var m = i + j >> 1;
	                    if (a[m] === v) {
	                      return true;
	                    }
	                    if (a[m] > v) {
	                      j = m - 1;
	                    } else {
	                      i = m + 1;
	                    }
	                  }
	                  return false;
	                }
	                function varargs(type) {
	                  return { type };
	                }
	                CompoundExpression.register(expressions, {
	                  "error": [
	                    ErrorType,
	                    [StringType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      throw new RuntimeError(v.evaluate(ctx));
	                    }
	                  ],
	                  "typeof": [
	                    StringType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      return toString(typeOf(v.evaluate(ctx)));
	                    }
	                  ],
	                  "to-rgba": [
	                    array(NumberType, 4),
	                    [ColorType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      return v.evaluate(ctx).toArray();
	                    }
	                  ],
	                  "rgb": [
	                    ColorType,
	                    [
	                      NumberType,
	                      NumberType,
	                      NumberType
	                    ],
	                    rgba
	                  ],
	                  "rgba": [
	                    ColorType,
	                    [
	                      NumberType,
	                      NumberType,
	                      NumberType,
	                      NumberType
	                    ],
	                    rgba
	                  ],
	                  "has": {
	                    type: BooleanType,
	                    overloads: [
	                      [
	                        [StringType],
	                        function(ctx, ref) {
	                          var key = ref[0];
	                          return has(key.evaluate(ctx), ctx.properties());
	                        }
	                      ],
	                      [
	                        [
	                          StringType,
	                          ObjectType
	                        ],
	                        function(ctx, ref) {
	                          var key = ref[0];
	                          var obj = ref[1];
	                          return has(key.evaluate(ctx), obj.evaluate(ctx));
	                        }
	                      ]
	                    ]
	                  },
	                  "get": {
	                    type: ValueType,
	                    overloads: [
	                      [
	                        [StringType],
	                        function(ctx, ref) {
	                          var key = ref[0];
	                          return get(key.evaluate(ctx), ctx.properties());
	                        }
	                      ],
	                      [
	                        [
	                          StringType,
	                          ObjectType
	                        ],
	                        function(ctx, ref) {
	                          var key = ref[0];
	                          var obj = ref[1];
	                          return get(key.evaluate(ctx), obj.evaluate(ctx));
	                        }
	                      ]
	                    ]
	                  },
	                  "feature-state": [
	                    ValueType,
	                    [StringType],
	                    function(ctx, ref) {
	                      var key = ref[0];
	                      return get(key.evaluate(ctx), ctx.featureState || {});
	                    }
	                  ],
	                  "properties": [
	                    ObjectType,
	                    [],
	                    function(ctx) {
	                      return ctx.properties();
	                    }
	                  ],
	                  "geometry-type": [
	                    StringType,
	                    [],
	                    function(ctx) {
	                      return ctx.geometryType();
	                    }
	                  ],
	                  "id": [
	                    ValueType,
	                    [],
	                    function(ctx) {
	                      return ctx.id();
	                    }
	                  ],
	                  "zoom": [
	                    NumberType,
	                    [],
	                    function(ctx) {
	                      return ctx.globals.zoom;
	                    }
	                  ],
	                  "heatmap-density": [
	                    NumberType,
	                    [],
	                    function(ctx) {
	                      return ctx.globals.heatmapDensity || 0;
	                    }
	                  ],
	                  "line-progress": [
	                    NumberType,
	                    [],
	                    function(ctx) {
	                      return ctx.globals.lineProgress || 0;
	                    }
	                  ],
	                  "accumulated": [
	                    ValueType,
	                    [],
	                    function(ctx) {
	                      return ctx.globals.accumulated === undefined ? null : ctx.globals.accumulated;
	                    }
	                  ],
	                  "+": [
	                    NumberType,
	                    varargs(NumberType),
	                    function(ctx, args) {
	                      var result = 0;
	                      for (var i = 0, list = args; i < list.length; i += 1) {
	                        var arg = list[i];
	                        result += arg.evaluate(ctx);
	                      }
	                      return result;
	                    }
	                  ],
	                  "*": [
	                    NumberType,
	                    varargs(NumberType),
	                    function(ctx, args) {
	                      var result = 1;
	                      for (var i = 0, list = args; i < list.length; i += 1) {
	                        var arg = list[i];
	                        result *= arg.evaluate(ctx);
	                      }
	                      return result;
	                    }
	                  ],
	                  "-": {
	                    type: NumberType,
	                    overloads: [
	                      [
	                        [
	                          NumberType,
	                          NumberType
	                        ],
	                        function(ctx, ref) {
	                          var a = ref[0];
	                          var b = ref[1];
	                          return a.evaluate(ctx) - b.evaluate(ctx);
	                        }
	                      ],
	                      [
	                        [NumberType],
	                        function(ctx, ref) {
	                          var a = ref[0];
	                          return -a.evaluate(ctx);
	                        }
	                      ]
	                    ]
	                  },
	                  "/": [
	                    NumberType,
	                    [
	                      NumberType,
	                      NumberType
	                    ],
	                    function(ctx, ref) {
	                      var a = ref[0];
	                      var b = ref[1];
	                      return a.evaluate(ctx) / b.evaluate(ctx);
	                    }
	                  ],
	                  "%": [
	                    NumberType,
	                    [
	                      NumberType,
	                      NumberType
	                    ],
	                    function(ctx, ref) {
	                      var a = ref[0];
	                      var b = ref[1];
	                      return a.evaluate(ctx) % b.evaluate(ctx);
	                    }
	                  ],
	                  "ln2": [
	                    NumberType,
	                    [],
	                    function() {
	                      return Math.LN2;
	                    }
	                  ],
	                  "pi": [
	                    NumberType,
	                    [],
	                    function() {
	                      return Math.PI;
	                    }
	                  ],
	                  "e": [
	                    NumberType,
	                    [],
	                    function() {
	                      return Math.E;
	                    }
	                  ],
	                  "^": [
	                    NumberType,
	                    [
	                      NumberType,
	                      NumberType
	                    ],
	                    function(ctx, ref) {
	                      var b = ref[0];
	                      var e = ref[1];
	                      return Math.pow(b.evaluate(ctx), e.evaluate(ctx));
	                    }
	                  ],
	                  "sqrt": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var x = ref[0];
	                      return Math.sqrt(x.evaluate(ctx));
	                    }
	                  ],
	                  "log10": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.log(n.evaluate(ctx)) / Math.LN10;
	                    }
	                  ],
	                  "ln": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.log(n.evaluate(ctx));
	                    }
	                  ],
	                  "log2": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.log(n.evaluate(ctx)) / Math.LN2;
	                    }
	                  ],
	                  "sin": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.sin(n.evaluate(ctx));
	                    }
	                  ],
	                  "cos": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.cos(n.evaluate(ctx));
	                    }
	                  ],
	                  "tan": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.tan(n.evaluate(ctx));
	                    }
	                  ],
	                  "asin": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.asin(n.evaluate(ctx));
	                    }
	                  ],
	                  "acos": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.acos(n.evaluate(ctx));
	                    }
	                  ],
	                  "atan": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.atan(n.evaluate(ctx));
	                    }
	                  ],
	                  "min": [
	                    NumberType,
	                    varargs(NumberType),
	                    function(ctx, args) {
	                      return Math.min.apply(Math, args.map(function(arg) {
	                        return arg.evaluate(ctx);
	                      }));
	                    }
	                  ],
	                  "max": [
	                    NumberType,
	                    varargs(NumberType),
	                    function(ctx, args) {
	                      return Math.max.apply(Math, args.map(function(arg) {
	                        return arg.evaluate(ctx);
	                      }));
	                    }
	                  ],
	                  "abs": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.abs(n.evaluate(ctx));
	                    }
	                  ],
	                  "round": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      var v = n.evaluate(ctx);
	                      return v < 0 ? -Math.round(-v) : Math.round(v);
	                    }
	                  ],
	                  "floor": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.floor(n.evaluate(ctx));
	                    }
	                  ],
	                  "ceil": [
	                    NumberType,
	                    [NumberType],
	                    function(ctx, ref) {
	                      var n = ref[0];
	                      return Math.ceil(n.evaluate(ctx));
	                    }
	                  ],
	                  "filter-==": [
	                    BooleanType,
	                    [
	                      StringType,
	                      ValueType
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      return ctx.properties()[k.value] === v.value;
	                    }
	                  ],
	                  "filter-id-==": [
	                    BooleanType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      return ctx.id() === v.value;
	                    }
	                  ],
	                  "filter-type-==": [
	                    BooleanType,
	                    [StringType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      return ctx.geometryType() === v.value;
	                    }
	                  ],
	                  "filter-<": [
	                    BooleanType,
	                    [
	                      StringType,
	                      ValueType
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      var a = ctx.properties()[k.value];
	                      var b = v.value;
	                      return typeof a === typeof b && a < b;
	                    }
	                  ],
	                  "filter-id-<": [
	                    BooleanType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      var a = ctx.id();
	                      var b = v.value;
	                      return typeof a === typeof b && a < b;
	                    }
	                  ],
	                  "filter->": [
	                    BooleanType,
	                    [
	                      StringType,
	                      ValueType
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      var a = ctx.properties()[k.value];
	                      var b = v.value;
	                      return typeof a === typeof b && a > b;
	                    }
	                  ],
	                  "filter-id->": [
	                    BooleanType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      var a = ctx.id();
	                      var b = v.value;
	                      return typeof a === typeof b && a > b;
	                    }
	                  ],
	                  "filter-<=": [
	                    BooleanType,
	                    [
	                      StringType,
	                      ValueType
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      var a = ctx.properties()[k.value];
	                      var b = v.value;
	                      return typeof a === typeof b && a <= b;
	                    }
	                  ],
	                  "filter-id-<=": [
	                    BooleanType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      var a = ctx.id();
	                      var b = v.value;
	                      return typeof a === typeof b && a <= b;
	                    }
	                  ],
	                  "filter->=": [
	                    BooleanType,
	                    [
	                      StringType,
	                      ValueType
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      var a = ctx.properties()[k.value];
	                      var b = v.value;
	                      return typeof a === typeof b && a >= b;
	                    }
	                  ],
	                  "filter-id->=": [
	                    BooleanType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      var a = ctx.id();
	                      var b = v.value;
	                      return typeof a === typeof b && a >= b;
	                    }
	                  ],
	                  "filter-has": [
	                    BooleanType,
	                    [ValueType],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      return k.value in ctx.properties();
	                    }
	                  ],
	                  "filter-has-id": [
	                    BooleanType,
	                    [],
	                    function(ctx) {
	                      return ctx.id() !== null && ctx.id() !== undefined;
	                    }
	                  ],
	                  "filter-type-in": [
	                    BooleanType,
	                    [array(StringType)],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      return v.value.indexOf(ctx.geometryType()) >= 0;
	                    }
	                  ],
	                  "filter-id-in": [
	                    BooleanType,
	                    [array(ValueType)],
	                    function(ctx, ref) {
	                      var v = ref[0];
	                      return v.value.indexOf(ctx.id()) >= 0;
	                    }
	                  ],
	                  "filter-in-small": [
	                    BooleanType,
	                    [
	                      StringType,
	                      array(ValueType)
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      return v.value.indexOf(ctx.properties()[k.value]) >= 0;
	                    }
	                  ],
	                  "filter-in-large": [
	                    BooleanType,
	                    [
	                      StringType,
	                      array(ValueType)
	                    ],
	                    function(ctx, ref) {
	                      var k = ref[0];
	                      var v = ref[1];
	                      return binarySearch(ctx.properties()[k.value], v.value, 0, v.value.length - 1);
	                    }
	                  ],
	                  "all": {
	                    type: BooleanType,
	                    overloads: [
	                      [
	                        [
	                          BooleanType,
	                          BooleanType
	                        ],
	                        function(ctx, ref) {
	                          var a = ref[0];
	                          var b = ref[1];
	                          return a.evaluate(ctx) && b.evaluate(ctx);
	                        }
	                      ],
	                      [
	                        varargs(BooleanType),
	                        function(ctx, args) {
	                          for (var i = 0, list = args; i < list.length; i += 1) {
	                            var arg = list[i];
	                            if (!arg.evaluate(ctx)) {
	                              return false;
	                            }
	                          }
	                          return true;
	                        }
	                      ]
	                    ]
	                  },
	                  "any": {
	                    type: BooleanType,
	                    overloads: [
	                      [
	                        [
	                          BooleanType,
	                          BooleanType
	                        ],
	                        function(ctx, ref) {
	                          var a = ref[0];
	                          var b = ref[1];
	                          return a.evaluate(ctx) || b.evaluate(ctx);
	                        }
	                      ],
	                      [
	                        varargs(BooleanType),
	                        function(ctx, args) {
	                          for (var i = 0, list = args; i < list.length; i += 1) {
	                            var arg = list[i];
	                            if (arg.evaluate(ctx)) {
	                              return true;
	                            }
	                          }
	                          return false;
	                        }
	                      ]
	                    ]
	                  },
	                  "!": [
	                    BooleanType,
	                    [BooleanType],
	                    function(ctx, ref) {
	                      var b = ref[0];
	                      return !b.evaluate(ctx);
	                    }
	                  ],
	                  "is-supported-script": [
	                    BooleanType,
	                    [StringType],
	                    function(ctx, ref) {
	                      var s = ref[0];
	                      var isSupportedScript = ctx.globals && ctx.globals.isSupportedScript;
	                      if (isSupportedScript) {
	                        return isSupportedScript(s.evaluate(ctx));
	                      }
	                      return true;
	                    }
	                  ],
	                  "upcase": [
	                    StringType,
	                    [StringType],
	                    function(ctx, ref) {
	                      var s = ref[0];
	                      return s.evaluate(ctx).toUpperCase();
	                    }
	                  ],
	                  "downcase": [
	                    StringType,
	                    [StringType],
	                    function(ctx, ref) {
	                      var s = ref[0];
	                      return s.evaluate(ctx).toLowerCase();
	                    }
	                  ],
	                  "concat": [
	                    StringType,
	                    varargs(ValueType),
	                    function(ctx, args) {
	                      return args.map(function(arg) {
	                        return toString$1(arg.evaluate(ctx));
	                      }).join("");
	                    }
	                  ],
	                  "resolved-locale": [
	                    StringType,
	                    [CollatorType],
	                    function(ctx, ref) {
	                      var collator = ref[0];
	                      return collator.evaluate(ctx).resolvedLocale();
	                    }
	                  ]
	                });
	                function success(value) {
	                  return {
	                    result: "success",
	                    value
	                  };
	                }
	                function error(value) {
	                  return {
	                    result: "error",
	                    value
	                  };
	                }
	                function supportsPropertyExpression(spec2) {
	                  return spec2["property-type"] === "data-driven" || spec2["property-type"] === "cross-faded-data-driven";
	                }
	                function supportsZoomExpression(spec2) {
	                  return !!spec2.expression && spec2.expression.parameters.indexOf("zoom") > -1;
	                }
	                function supportsInterpolation(spec2) {
	                  return !!spec2.expression && spec2.expression.interpolated;
	                }
	                function getType(val) {
	                  if (val instanceof Number) {
	                    return "number";
	                  } else if (val instanceof String) {
	                    return "string";
	                  } else if (val instanceof Boolean) {
	                    return "boolean";
	                  } else if (Array.isArray(val)) {
	                    return "array";
	                  } else if (val === null) {
	                    return "null";
	                  } else {
	                    return typeof val;
	                  }
	                }
	                function isFunction(value) {
	                  return typeof value === "object" && value !== null && !Array.isArray(value);
	                }
	                function identityFunction(x) {
	                  return x;
	                }
	                function createFunction(parameters, propertySpec) {
	                  var isColor = propertySpec.type === "color";
	                  var zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === "object";
	                  var featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
	                  var zoomDependent = zoomAndFeatureDependent || !featureDependent;
	                  var type = parameters.type || (supportsInterpolation(propertySpec) ? "exponential" : "interval");
	                  if (isColor) {
	                    parameters = extend$1({}, parameters);
	                    if (parameters.stops) {
	                      parameters.stops = parameters.stops.map(function(stop2) {
	                        return [
	                          stop2[0],
	                          Color.parse(stop2[1])
	                        ];
	                      });
	                    }
	                    if (parameters.default) {
	                      parameters.default = Color.parse(parameters.default);
	                    } else {
	                      parameters.default = Color.parse(propertySpec.default);
	                    }
	                  }
	                  if (parameters.colorSpace && parameters.colorSpace !== "rgb" && !colorSpaces[parameters.colorSpace]) {
	                    throw new Error("Unknown color space: " + parameters.colorSpace);
	                  }
	                  var innerFun;
	                  var hashedStops;
	                  var categoricalKeyType;
	                  if (type === "exponential") {
	                    innerFun = evaluateExponentialFunction;
	                  } else if (type === "interval") {
	                    innerFun = evaluateIntervalFunction;
	                  } else if (type === "categorical") {
	                    innerFun = evaluateCategoricalFunction;
	                    hashedStops = /* @__PURE__ */ Object.create(null);
	                    for (var i = 0, list = parameters.stops; i < list.length; i += 1) {
	                      var stop = list[i];
	                      hashedStops[stop[0]] = stop[1];
	                    }
	                    categoricalKeyType = typeof parameters.stops[0][0];
	                  } else if (type === "identity") {
	                    innerFun = evaluateIdentityFunction;
	                  } else {
	                    throw new Error('Unknown function type "' + type + '"');
	                  }
	                  if (zoomAndFeatureDependent) {
	                    var featureFunctions = {};
	                    var zoomStops = [];
	                    for (var s = 0; s < parameters.stops.length; s++) {
	                      var stop$1 = parameters.stops[s];
	                      var zoom = stop$1[0].zoom;
	                      if (featureFunctions[zoom] === undefined) {
	                        featureFunctions[zoom] = {
	                          zoom,
	                          type: parameters.type,
	                          property: parameters.property,
	                          default: parameters.default,
	                          stops: []
	                        };
	                        zoomStops.push(zoom);
	                      }
	                      featureFunctions[zoom].stops.push([
	                        stop$1[0].value,
	                        stop$1[1]
	                      ]);
	                    }
	                    var featureFunctionStops = [];
	                    for (var i$1 = 0, list$1 = zoomStops; i$1 < list$1.length; i$1 += 1) {
	                      var z = list$1[i$1];
	                      featureFunctionStops.push([
	                        featureFunctions[z].zoom,
	                        createFunction(featureFunctions[z], propertySpec)
	                      ]);
	                    }
	                    var interpolationType = { name: "linear" };
	                    return {
	                      kind: "composite",
	                      interpolationType,
	                      interpolationFactor: Interpolate.interpolationFactor.bind(undefined, interpolationType),
	                      zoomStops: featureFunctionStops.map(function(s2) {
	                        return s2[0];
	                      }),
	                      evaluate: function evaluate(ref, properties2) {
	                        var zoom2 = ref.zoom;
	                        return evaluateExponentialFunction({
	                          stops: featureFunctionStops,
	                          base: parameters.base
	                        }, propertySpec, zoom2).evaluate(zoom2, properties2);
	                      }
	                    };
	                  } else if (zoomDependent) {
	                    var interpolationType$1 = type === "exponential" ? {
	                      name: "exponential",
	                      base: parameters.base !== undefined ? parameters.base : 1
	                    } : null;
	                    return {
	                      kind: "camera",
	                      interpolationType: interpolationType$1,
	                      interpolationFactor: Interpolate.interpolationFactor.bind(undefined, interpolationType$1),
	                      zoomStops: parameters.stops.map(function(s2) {
	                        return s2[0];
	                      }),
	                      evaluate: function(ref) {
	                        var zoom2 = ref.zoom;
	                        return innerFun(parameters, propertySpec, zoom2, hashedStops, categoricalKeyType);
	                      }
	                    };
	                  } else {
	                    return {
	                      kind: "source",
	                      evaluate: function evaluate(_, feature) {
	                        var value = feature && feature.properties ? feature.properties[parameters.property] : undefined;
	                        if (value === undefined) {
	                          return coalesce(parameters.default, propertySpec.default);
	                        }
	                        return innerFun(parameters, propertySpec, value, hashedStops, categoricalKeyType);
	                      }
	                    };
	                  }
	                }
	                function coalesce(a, b, c) {
	                  if (a !== undefined) {
	                    return a;
	                  }
	                  if (b !== undefined) {
	                    return b;
	                  }
	                  if (c !== undefined) {
	                    return c;
	                  }
	                }
	                function evaluateCategoricalFunction(parameters, propertySpec, input, hashedStops, keyType) {
	                  var evaluated = typeof input === keyType ? hashedStops[input] : undefined;
	                  return coalesce(evaluated, parameters.default, propertySpec.default);
	                }
	                function evaluateIntervalFunction(parameters, propertySpec, input) {
	                  if (getType(input) !== "number") {
	                    return coalesce(parameters.default, propertySpec.default);
	                  }
	                  var n = parameters.stops.length;
	                  if (n === 1) {
	                    return parameters.stops[0][1];
	                  }
	                  if (input <= parameters.stops[0][0]) {
	                    return parameters.stops[0][1];
	                  }
	                  if (input >= parameters.stops[n - 1][0]) {
	                    return parameters.stops[n - 1][1];
	                  }
	                  var index = findStopLessThanOrEqualTo(parameters.stops.map(function(stop) {
	                    return stop[0];
	                  }), input);
	                  return parameters.stops[index][1];
	                }
	                function evaluateExponentialFunction(parameters, propertySpec, input) {
	                  var base = parameters.base !== undefined ? parameters.base : 1;
	                  if (getType(input) !== "number") {
	                    return coalesce(parameters.default, propertySpec.default);
	                  }
	                  var n = parameters.stops.length;
	                  if (n === 1) {
	                    return parameters.stops[0][1];
	                  }
	                  if (input <= parameters.stops[0][0]) {
	                    return parameters.stops[0][1];
	                  }
	                  if (input >= parameters.stops[n - 1][0]) {
	                    return parameters.stops[n - 1][1];
	                  }
	                  var index = findStopLessThanOrEqualTo(parameters.stops.map(function(stop) {
	                    return stop[0];
	                  }), input);
	                  var t = interpolationFactor(input, base, parameters.stops[index][0], parameters.stops[index + 1][0]);
	                  var outputLower = parameters.stops[index][1];
	                  var outputUpper = parameters.stops[index + 1][1];
	                  var interp = interpolate[propertySpec.type] || identityFunction;
	                  if (parameters.colorSpace && parameters.colorSpace !== "rgb") {
	                    var colorspace = colorSpaces[parameters.colorSpace];
	                    interp = function(a, b) {
	                      return colorspace.reverse(colorspace.interpolate(colorspace.forward(a), colorspace.forward(b), t));
	                    };
	                  }
	                  if (typeof outputLower.evaluate === "function") {
	                    return {
	                      evaluate: function evaluate() {
	                        var args = [], len = arguments.length;
	                        while (len--)
	                          args[len] = arguments[len];
	                        var evaluatedLower = outputLower.evaluate.apply(undefined, args);
	                        var evaluatedUpper = outputUpper.evaluate.apply(undefined, args);
	                        if (evaluatedLower === undefined || evaluatedUpper === undefined) {
	                          return undefined;
	                        }
	                        return interp(evaluatedLower, evaluatedUpper, t);
	                      }
	                    };
	                  }
	                  return interp(outputLower, outputUpper, t);
	                }
	                function evaluateIdentityFunction(parameters, propertySpec, input) {
	                  if (propertySpec.type === "color") {
	                    input = Color.parse(input);
	                  } else if (propertySpec.type === "formatted") {
	                    input = Formatted.fromString(input.toString());
	                  } else if (propertySpec.type === "resolvedImage") {
	                    input = ResolvedImage.fromString(input.toString());
	                  } else if (getType(input) !== propertySpec.type && (propertySpec.type !== "enum" || !propertySpec.values[input])) {
	                    input = undefined;
	                  }
	                  return coalesce(input, parameters.default, propertySpec.default);
	                }
	                function interpolationFactor(input, base, lowerValue, upperValue) {
	                  var difference = upperValue - lowerValue;
	                  var progress = input - lowerValue;
	                  if (difference === 0) {
	                    return 0;
	                  } else if (base === 1) {
	                    return progress / difference;
	                  } else {
	                    return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
	                  }
	                }
	                var StyleExpression = function StyleExpression2(expression2, propertySpec) {
	                  this.expression = expression2;
	                  this._warningHistory = {};
	                  this._evaluator = new EvaluationContext();
	                  this._defaultValue = propertySpec ? getDefaultValue(propertySpec) : null;
	                  this._enumValues = propertySpec && propertySpec.type === "enum" ? propertySpec.values : null;
	                };
	                StyleExpression.prototype.evaluateWithoutErrorHandling = function evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
	                  this._evaluator.globals = globals;
	                  this._evaluator.feature = feature;
	                  this._evaluator.featureState = featureState;
	                  this._evaluator.canonical = canonical;
	                  this._evaluator.availableImages = availableImages || null;
	                  this._evaluator.formattedSection = formattedSection;
	                  return this.expression.evaluate(this._evaluator);
	                };
	                StyleExpression.prototype.evaluate = function evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
	                  this._evaluator.globals = globals;
	                  this._evaluator.feature = feature || null;
	                  this._evaluator.featureState = featureState || null;
	                  this._evaluator.canonical = canonical;
	                  this._evaluator.availableImages = availableImages || null;
	                  this._evaluator.formattedSection = formattedSection || null;
	                  try {
	                    var val = this.expression.evaluate(this._evaluator);
	                    if (val === null || val === void 0 || typeof val === "number" && val !== val) {
	                      return this._defaultValue;
	                    }
	                    if (this._enumValues && !(val in this._enumValues)) {
	                      throw new RuntimeError("Expected value to be one of " + Object.keys(this._enumValues).map(function(v) {
	                        return JSON.stringify(v);
	                      }).join(", ") + ", but found " + JSON.stringify(val) + " instead.");
	                    }
	                    return val;
	                  } catch (e) {
	                    if (!this._warningHistory[e.message]) {
	                      this._warningHistory[e.message] = true;
	                      if (typeof console !== "undefined") {
	                        console.warn(e.message);
	                      }
	                    }
	                    return this._defaultValue;
	                  }
	                };
	                function isExpression(expression2) {
	                  return Array.isArray(expression2) && expression2.length > 0 && typeof expression2[0] === "string" && expression2[0] in expressions;
	                }
	                function createExpression(expression2, propertySpec) {
	                  var parser = new ParsingContext(expressions, [], propertySpec ? getExpectedType(propertySpec) : undefined);
	                  var parsed = parser.parse(expression2, undefined, undefined, undefined, propertySpec && propertySpec.type === "string" ? { typeAnnotation: "coerce" } : undefined);
	                  if (!parsed) {
	                    return error(parser.errors);
	                  }
	                  return success(new StyleExpression(parsed, propertySpec));
	                }
	                var ZoomConstantExpression = function ZoomConstantExpression2(kind, expression2) {
	                  this.kind = kind;
	                  this._styleExpression = expression2;
	                  this.isStateDependent = kind !== "constant" && !isStateConstant(expression2.expression);
	                };
	                ZoomConstantExpression.prototype.evaluateWithoutErrorHandling = function evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
	                  return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
	                };
	                ZoomConstantExpression.prototype.evaluate = function evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
	                  return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
	                };
	                var ZoomDependentExpression = function ZoomDependentExpression2(kind, expression2, zoomStops, interpolationType) {
	                  this.kind = kind;
	                  this.zoomStops = zoomStops;
	                  this._styleExpression = expression2;
	                  this.isStateDependent = kind !== "camera" && !isStateConstant(expression2.expression);
	                  this.interpolationType = interpolationType;
	                };
	                ZoomDependentExpression.prototype.evaluateWithoutErrorHandling = function evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
	                  return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
	                };
	                ZoomDependentExpression.prototype.evaluate = function evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
	                  return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
	                };
	                ZoomDependentExpression.prototype.interpolationFactor = function interpolationFactor2(input, lower, upper) {
	                  if (this.interpolationType) {
	                    return Interpolate.interpolationFactor(this.interpolationType, input, lower, upper);
	                  } else {
	                    return 0;
	                  }
	                };
	                function createPropertyExpression(expression2, propertySpec) {
	                  expression2 = createExpression(expression2, propertySpec);
	                  if (expression2.result === "error") {
	                    return expression2;
	                  }
	                  var parsed = expression2.value.expression;
	                  var isFeatureConstant$1 = isFeatureConstant(parsed);
	                  if (!isFeatureConstant$1 && !supportsPropertyExpression(propertySpec)) {
	                    return error([new ParsingError("", "data expressions not supported")]);
	                  }
	                  var isZoomConstant = isGlobalPropertyConstant(parsed, ["zoom"]);
	                  if (!isZoomConstant && !supportsZoomExpression(propertySpec)) {
	                    return error([new ParsingError("", "zoom expressions not supported")]);
	                  }
	                  var zoomCurve = findZoomCurve(parsed);
	                  if (!zoomCurve && !isZoomConstant) {
	                    return error([new ParsingError("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
	                  } else if (zoomCurve instanceof ParsingError) {
	                    return error([zoomCurve]);
	                  } else if (zoomCurve instanceof Interpolate && !supportsInterpolation(propertySpec)) {
	                    return error([new ParsingError("", '"interpolate" expressions cannot be used with this property')]);
	                  }
	                  if (!zoomCurve) {
	                    return success(isFeatureConstant$1 ? new ZoomConstantExpression("constant", expression2.value) : new ZoomConstantExpression("source", expression2.value));
	                  }
	                  var interpolationType = zoomCurve instanceof Interpolate ? zoomCurve.interpolation : undefined;
	                  return success(isFeatureConstant$1 ? new ZoomDependentExpression("camera", expression2.value, zoomCurve.labels, interpolationType) : new ZoomDependentExpression("composite", expression2.value, zoomCurve.labels, interpolationType));
	                }
	                var StylePropertyFunction = function StylePropertyFunction2(parameters, specification) {
	                  this._parameters = parameters;
	                  this._specification = specification;
	                  extend$1(this, createFunction(this._parameters, this._specification));
	                };
	                StylePropertyFunction.deserialize = function deserialize2(serialized) {
	                  return new StylePropertyFunction(serialized._parameters, serialized._specification);
	                };
	                StylePropertyFunction.serialize = function serialize2(input) {
	                  return {
	                    _parameters: input._parameters,
	                    _specification: input._specification
	                  };
	                };
	                function normalizePropertyExpression(value, specification) {
	                  if (isFunction(value)) {
	                    return new StylePropertyFunction(value, specification);
	                  } else if (isExpression(value)) {
	                    var expression2 = createPropertyExpression(value, specification);
	                    if (expression2.result === "error") {
	                      throw new Error(expression2.value.map(function(err) {
	                        return err.key + ": " + err.message;
	                      }).join(", "));
	                    }
	                    return expression2.value;
	                  } else {
	                    var constant2 = value;
	                    if (typeof value === "string" && specification.type === "color") {
	                      constant2 = Color.parse(value);
	                    }
	                    return {
	                      kind: "constant",
	                      evaluate: function() {
	                        return constant2;
	                      }
	                    };
	                  }
	                }
	                function findZoomCurve(expression2) {
	                  var result = null;
	                  if (expression2 instanceof Let) {
	                    result = findZoomCurve(expression2.result);
	                  } else if (expression2 instanceof Coalesce) {
	                    for (var i = 0, list = expression2.args; i < list.length; i += 1) {
	                      var arg = list[i];
	                      result = findZoomCurve(arg);
	                      if (result) {
	                        break;
	                      }
	                    }
	                  } else if ((expression2 instanceof Step || expression2 instanceof Interpolate) && expression2.input instanceof CompoundExpression && expression2.input.name === "zoom") {
	                    result = expression2;
	                  }
	                  if (result instanceof ParsingError) {
	                    return result;
	                  }
	                  expression2.eachChild(function(child) {
	                    var childResult = findZoomCurve(child);
	                    if (childResult instanceof ParsingError) {
	                      result = childResult;
	                    } else if (!result && childResult) {
	                      result = new ParsingError("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.');
	                    } else if (result && childResult && result !== childResult) {
	                      result = new ParsingError("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.');
	                    }
	                  });
	                  return result;
	                }
	                function getExpectedType(spec2) {
	                  var types2 = {
	                    color: ColorType,
	                    string: StringType,
	                    number: NumberType,
	                    enum: StringType,
	                    boolean: BooleanType,
	                    formatted: FormattedType,
	                    resolvedImage: ResolvedImageType
	                  };
	                  if (spec2.type === "array") {
	                    return array(types2[spec2.value] || ValueType, spec2.length);
	                  }
	                  return types2[spec2.type];
	                }
	                function getDefaultValue(spec2) {
	                  if (spec2.type === "color" && isFunction(spec2.default)) {
	                    return new Color(0, 0, 0, 0);
	                  } else if (spec2.type === "color") {
	                    return Color.parse(spec2.default) || null;
	                  } else if (spec2.default === undefined) {
	                    return null;
	                  } else {
	                    return spec2.default;
	                  }
	                }
	                function validateObject(options) {
	                  var key = options.key;
	                  var object = options.value;
	                  var elementSpecs = options.valueSpec || {};
	                  var elementValidators = options.objectElementValidators || {};
	                  var style = options.style;
	                  var styleSpec = options.styleSpec;
	                  var errors = [];
	                  var type = getType(object);
	                  if (type !== "object") {
	                    return [new ValidationError(key, object, "object expected, " + type + " found")];
	                  }
	                  for (var objectKey in object) {
	                    var elementSpecKey = objectKey.split(".")[0];
	                    var elementSpec = elementSpecs[elementSpecKey] || elementSpecs["*"];
	                    var validateElement = undefined;
	                    if (elementValidators[elementSpecKey]) {
	                      validateElement = elementValidators[elementSpecKey];
	                    } else if (elementSpecs[elementSpecKey]) {
	                      validateElement = validate;
	                    } else if (elementValidators["*"]) {
	                      validateElement = elementValidators["*"];
	                    } else if (elementSpecs["*"]) {
	                      validateElement = validate;
	                    } else {
	                      errors.push(new ValidationError(key, object[objectKey], 'unknown property "' + objectKey + '"'));
	                      continue;
	                    }
	                    errors = errors.concat(validateElement({
	                      key: (key ? key + "." : key) + objectKey,
	                      value: object[objectKey],
	                      valueSpec: elementSpec,
	                      style,
	                      styleSpec,
	                      object,
	                      objectKey
	                    }, object));
	                  }
	                  for (var elementSpecKey$1 in elementSpecs) {
	                    if (elementValidators[elementSpecKey$1]) {
	                      continue;
	                    }
	                    if (elementSpecs[elementSpecKey$1].required && elementSpecs[elementSpecKey$1]["default"] === undefined && object[elementSpecKey$1] === undefined) {
	                      errors.push(new ValidationError(key, object, 'missing required property "' + elementSpecKey$1 + '"'));
	                    }
	                  }
	                  return errors;
	                }
	                function validateArray(options) {
	                  var array2 = options.value;
	                  var arraySpec = options.valueSpec;
	                  var style = options.style;
	                  var styleSpec = options.styleSpec;
	                  var key = options.key;
	                  var validateArrayElement = options.arrayElementValidator || validate;
	                  if (getType(array2) !== "array") {
	                    return [new ValidationError(key, array2, "array expected, " + getType(array2) + " found")];
	                  }
	                  if (arraySpec.length && array2.length !== arraySpec.length) {
	                    return [new ValidationError(key, array2, "array length " + arraySpec.length + " expected, length " + array2.length + " found")];
	                  }
	                  if (arraySpec["min-length"] && array2.length < arraySpec["min-length"]) {
	                    return [new ValidationError(key, array2, "array length at least " + arraySpec["min-length"] + " expected, length " + array2.length + " found")];
	                  }
	                  var arrayElementSpec = {
	                    "type": arraySpec.value,
	                    "values": arraySpec.values
	                  };
	                  if (styleSpec.$version < 7) {
	                    arrayElementSpec.function = arraySpec.function;
	                  }
	                  if (getType(arraySpec.value) === "object") {
	                    arrayElementSpec = arraySpec.value;
	                  }
	                  var errors = [];
	                  for (var i = 0; i < array2.length; i++) {
	                    errors = errors.concat(validateArrayElement({
	                      array: array2,
	                      arrayIndex: i,
	                      value: array2[i],
	                      valueSpec: arrayElementSpec,
	                      style,
	                      styleSpec,
	                      key: key + "[" + i + "]"
	                    }));
	                  }
	                  return errors;
	                }
	                function validateNumber(options) {
	                  var key = options.key;
	                  var value = options.value;
	                  var valueSpec = options.valueSpec;
	                  var type = getType(value);
	                  if (type === "number" && value !== value) {
	                    type = "NaN";
	                  }
	                  if (type !== "number") {
	                    return [new ValidationError(key, value, "number expected, " + type + " found")];
	                  }
	                  if ("minimum" in valueSpec && value < valueSpec.minimum) {
	                    return [new ValidationError(key, value, value + " is less than the minimum value " + valueSpec.minimum)];
	                  }
	                  if ("maximum" in valueSpec && value > valueSpec.maximum) {
	                    return [new ValidationError(key, value, value + " is greater than the maximum value " + valueSpec.maximum)];
	                  }
	                  return [];
	                }
	                function validateFunction(options) {
	                  var functionValueSpec = options.valueSpec;
	                  var functionType = unbundle(options.value.type);
	                  var stopKeyType;
	                  var stopDomainValues = {};
	                  var previousStopDomainValue;
	                  var previousStopDomainZoom;
	                  var isZoomFunction = functionType !== "categorical" && options.value.property === undefined;
	                  var isPropertyFunction = !isZoomFunction;
	                  var isZoomAndPropertyFunction = getType(options.value.stops) === "array" && getType(options.value.stops[0]) === "array" && getType(options.value.stops[0][0]) === "object";
	                  var errors = validateObject({
	                    key: options.key,
	                    value: options.value,
	                    valueSpec: options.styleSpec.function,
	                    style: options.style,
	                    styleSpec: options.styleSpec,
	                    objectElementValidators: {
	                      stops: validateFunctionStops,
	                      default: validateFunctionDefault
	                    }
	                  });
	                  if (functionType === "identity" && isZoomFunction) {
	                    errors.push(new ValidationError(options.key, options.value, 'missing required property "property"'));
	                  }
	                  if (functionType !== "identity" && !options.value.stops) {
	                    errors.push(new ValidationError(options.key, options.value, 'missing required property "stops"'));
	                  }
	                  if (functionType === "exponential" && options.valueSpec.expression && !supportsInterpolation(options.valueSpec)) {
	                    errors.push(new ValidationError(options.key, options.value, "exponential functions not supported"));
	                  }
	                  if (options.styleSpec.$version >= 8) {
	                    if (isPropertyFunction && !supportsPropertyExpression(options.valueSpec)) {
	                      errors.push(new ValidationError(options.key, options.value, "property functions not supported"));
	                    } else if (isZoomFunction && !supportsZoomExpression(options.valueSpec)) {
	                      errors.push(new ValidationError(options.key, options.value, "zoom functions not supported"));
	                    }
	                  }
	                  if ((functionType === "categorical" || isZoomAndPropertyFunction) && options.value.property === undefined) {
	                    errors.push(new ValidationError(options.key, options.value, '"property" property is required'));
	                  }
	                  return errors;
	                  function validateFunctionStops(options2) {
	                    if (functionType === "identity") {
	                      return [new ValidationError(options2.key, options2.value, 'identity function may not have a "stops" property')];
	                    }
	                    var errors2 = [];
	                    var value = options2.value;
	                    errors2 = errors2.concat(validateArray({
	                      key: options2.key,
	                      value,
	                      valueSpec: options2.valueSpec,
	                      style: options2.style,
	                      styleSpec: options2.styleSpec,
	                      arrayElementValidator: validateFunctionStop
	                    }));
	                    if (getType(value) === "array" && value.length === 0) {
	                      errors2.push(new ValidationError(options2.key, value, "array must have at least one stop"));
	                    }
	                    return errors2;
	                  }
	                  function validateFunctionStop(options2) {
	                    var errors2 = [];
	                    var value = options2.value;
	                    var key = options2.key;
	                    if (getType(value) !== "array") {
	                      return [new ValidationError(key, value, "array expected, " + getType(value) + " found")];
	                    }
	                    if (value.length !== 2) {
	                      return [new ValidationError(key, value, "array length 2 expected, length " + value.length + " found")];
	                    }
	                    if (isZoomAndPropertyFunction) {
	                      if (getType(value[0]) !== "object") {
	                        return [new ValidationError(key, value, "object expected, " + getType(value[0]) + " found")];
	                      }
	                      if (value[0].zoom === undefined) {
	                        return [new ValidationError(key, value, "object stop key must have zoom")];
	                      }
	                      if (value[0].value === undefined) {
	                        return [new ValidationError(key, value, "object stop key must have value")];
	                      }
	                      if (previousStopDomainZoom && previousStopDomainZoom > unbundle(value[0].zoom)) {
	                        return [new ValidationError(key, value[0].zoom, "stop zoom values must appear in ascending order")];
	                      }
	                      if (unbundle(value[0].zoom) !== previousStopDomainZoom) {
	                        previousStopDomainZoom = unbundle(value[0].zoom);
	                        previousStopDomainValue = undefined;
	                        stopDomainValues = {};
	                      }
	                      errors2 = errors2.concat(validateObject({
	                        key: key + "[0]",
	                        value: value[0],
	                        valueSpec: { zoom: {} },
	                        style: options2.style,
	                        styleSpec: options2.styleSpec,
	                        objectElementValidators: {
	                          zoom: validateNumber,
	                          value: validateStopDomainValue
	                        }
	                      }));
	                    } else {
	                      errors2 = errors2.concat(validateStopDomainValue({
	                        key: key + "[0]",
	                        value: value[0],
	                        valueSpec: {},
	                        style: options2.style,
	                        styleSpec: options2.styleSpec
	                      }, value));
	                    }
	                    if (isExpression(deepUnbundle(value[1]))) {
	                      return errors2.concat([new ValidationError(key + "[1]", value[1], "expressions are not allowed in function stops.")]);
	                    }
	                    return errors2.concat(validate({
	                      key: key + "[1]",
	                      value: value[1],
	                      valueSpec: functionValueSpec,
	                      style: options2.style,
	                      styleSpec: options2.styleSpec
	                    }));
	                  }
	                  function validateStopDomainValue(options2, stop) {
	                    var type = getType(options2.value);
	                    var value = unbundle(options2.value);
	                    var reportValue = options2.value !== null ? options2.value : stop;
	                    if (!stopKeyType) {
	                      stopKeyType = type;
	                    } else if (type !== stopKeyType) {
	                      return [new ValidationError(options2.key, reportValue, type + " stop domain type must match previous stop domain type " + stopKeyType)];
	                    }
	                    if (type !== "number" && type !== "string" && type !== "boolean") {
	                      return [new ValidationError(options2.key, reportValue, "stop domain value must be a number, string, or boolean")];
	                    }
	                    if (type !== "number" && functionType !== "categorical") {
	                      var message = "number expected, " + type + " found";
	                      if (supportsPropertyExpression(functionValueSpec) && functionType === undefined) {
	                        message += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.';
	                      }
	                      return [new ValidationError(options2.key, reportValue, message)];
	                    }
	                    if (functionType === "categorical" && type === "number" && (!isFinite(value) || Math.floor(value) !== value)) {
	                      return [new ValidationError(options2.key, reportValue, "integer expected, found " + value)];
	                    }
	                    if (functionType !== "categorical" && type === "number" && previousStopDomainValue !== undefined && value < previousStopDomainValue) {
	                      return [new ValidationError(options2.key, reportValue, "stop domain values must appear in ascending order")];
	                    } else {
	                      previousStopDomainValue = value;
	                    }
	                    if (functionType === "categorical" && value in stopDomainValues) {
	                      return [new ValidationError(options2.key, reportValue, "stop domain values must be unique")];
	                    } else {
	                      stopDomainValues[value] = true;
	                    }
	                    return [];
	                  }
	                  function validateFunctionDefault(options2) {
	                    return validate({
	                      key: options2.key,
	                      value: options2.value,
	                      valueSpec: functionValueSpec,
	                      style: options2.style,
	                      styleSpec: options2.styleSpec
	                    });
	                  }
	                }
	                function validateExpression(options) {
	                  var expression2 = (options.expressionContext === "property" ? createPropertyExpression : createExpression)(deepUnbundle(options.value), options.valueSpec);
	                  if (expression2.result === "error") {
	                    return expression2.value.map(function(error2) {
	                      return new ValidationError("" + options.key + error2.key, options.value, error2.message);
	                    });
	                  }
	                  var expressionObj = expression2.value.expression || expression2.value._styleExpression.expression;
	                  if (options.expressionContext === "property" && options.propertyKey === "text-font" && !expressionObj.outputDefined()) {
	                    return [new ValidationError(options.key, options.value, 'Invalid data expression for "' + options.propertyKey + '". Output values must be contained as literals within the expression.')];
	                  }
	                  if (options.expressionContext === "property" && options.propertyType === "layout" && !isStateConstant(expressionObj)) {
	                    return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with layout properties.')];
	                  }
	                  if (options.expressionContext === "filter" && !isStateConstant(expressionObj)) {
	                    return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with filters.')];
	                  }
	                  if (options.expressionContext && options.expressionContext.indexOf("cluster") === 0) {
	                    if (!isGlobalPropertyConstant(expressionObj, [
	                      "zoom",
	                      "feature-state"
	                    ])) {
	                      return [new ValidationError(options.key, options.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
	                    }
	                    if (options.expressionContext === "cluster-initial" && !isFeatureConstant(expressionObj)) {
	                      return [new ValidationError(options.key, options.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
	                    }
	                  }
	                  return [];
	                }
	                function validateBoolean(options) {
	                  var value = options.value;
	                  var key = options.key;
	                  var type = getType(value);
	                  if (type !== "boolean") {
	                    return [new ValidationError(key, value, "boolean expected, " + type + " found")];
	                  }
	                  return [];
	                }
	                function validateColor(options) {
	                  var key = options.key;
	                  var value = options.value;
	                  var type = getType(value);
	                  if (type !== "string") {
	                    return [new ValidationError(key, value, "color expected, " + type + " found")];
	                  }
	                  if (csscolorparser_1(value) === null) {
	                    return [new ValidationError(key, value, 'color expected, "' + value + '" found')];
	                  }
	                  return [];
	                }
	                function validateEnum(options) {
	                  var key = options.key;
	                  var value = options.value;
	                  var valueSpec = options.valueSpec;
	                  var errors = [];
	                  if (Array.isArray(valueSpec.values)) {
	                    if (valueSpec.values.indexOf(unbundle(value)) === -1) {
	                      errors.push(new ValidationError(key, value, "expected one of [" + valueSpec.values.join(", ") + "], " + JSON.stringify(value) + " found"));
	                    }
	                  } else {
	                    if (Object.keys(valueSpec.values).indexOf(unbundle(value)) === -1) {
	                      errors.push(new ValidationError(key, value, "expected one of [" + Object.keys(valueSpec.values).join(", ") + "], " + JSON.stringify(value) + " found"));
	                    }
	                  }
	                  return errors;
	                }
	                function isExpressionFilter(filter2) {
	                  if (filter2 === true || filter2 === false) {
	                    return true;
	                  }
	                  if (!Array.isArray(filter2) || filter2.length === 0) {
	                    return false;
	                  }
	                  switch (filter2[0]) {
	                    case "has":
	                      return filter2.length >= 2 && filter2[1] !== "$id" && filter2[1] !== "$type";
	                    case "in":
	                      return filter2.length >= 3 && (typeof filter2[1] !== "string" || Array.isArray(filter2[2]));
	                    case "!in":
	                    case "!has":
	                    case "none":
	                      return false;
	                    case "==":
	                    case "!=":
	                    case ">":
	                    case ">=":
	                    case "<":
	                    case "<=":
	                      return filter2.length !== 3 || (Array.isArray(filter2[1]) || Array.isArray(filter2[2]));
	                    case "any":
	                    case "all":
	                      for (var i = 0, list = filter2.slice(1); i < list.length; i += 1) {
	                        var f = list[i];
	                        if (!isExpressionFilter(f) && typeof f !== "boolean") {
	                          return false;
	                        }
	                      }
	                      return true;
	                    default:
	                      return true;
	                  }
	                }
	                var filterSpec = {
	                  "type": "boolean",
	                  "default": false,
	                  "transition": false,
	                  "property-type": "data-driven",
	                  "expression": {
	                    "interpolated": false,
	                    "parameters": [
	                      "zoom",
	                      "feature"
	                    ]
	                  }
	                };
	                function createFilter(filter2) {
	                  if (filter2 === null || filter2 === undefined) {
	                    return {
	                      filter: function() {
	                        return true;
	                      },
	                      needGeometry: false
	                    };
	                  }
	                  if (!isExpressionFilter(filter2)) {
	                    filter2 = convertFilter(filter2);
	                  }
	                  var compiled = createExpression(filter2, filterSpec);
	                  if (compiled.result === "error") {
	                    throw new Error(compiled.value.map(function(err) {
	                      return err.key + ": " + err.message;
	                    }).join(", "));
	                  } else {
	                    var needGeometry = geometryNeeded(filter2);
	                    return {
	                      filter: function(globalProperties, feature, canonical) {
	                        return compiled.value.evaluate(globalProperties, feature, {}, canonical);
	                      },
	                      needGeometry
	                    };
	                  }
	                }
	                function compare(a, b) {
	                  return a < b ? -1 : a > b ? 1 : 0;
	                }
	                function geometryNeeded(filter2) {
	                  if (!Array.isArray(filter2)) {
	                    return false;
	                  }
	                  if (filter2[0] === "within") {
	                    return true;
	                  }
	                  for (var index = 1; index < filter2.length; index++) {
	                    if (geometryNeeded(filter2[index])) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function convertFilter(filter2) {
	                  if (!filter2) {
	                    return true;
	                  }
	                  var op = filter2[0];
	                  if (filter2.length <= 1) {
	                    return op !== "any";
	                  }
	                  var converted = op === "==" ? convertComparisonOp(filter2[1], filter2[2], "==") : op === "!=" ? convertNegation(convertComparisonOp(filter2[1], filter2[2], "==")) : op === "<" || op === ">" || op === "<=" || op === ">=" ? convertComparisonOp(filter2[1], filter2[2], op) : op === "any" ? convertDisjunctionOp(filter2.slice(1)) : op === "all" ? ["all"].concat(filter2.slice(1).map(convertFilter)) : op === "none" ? ["all"].concat(filter2.slice(1).map(convertFilter).map(convertNegation)) : op === "in" ? convertInOp(filter2[1], filter2.slice(2)) : op === "!in" ? convertNegation(convertInOp(filter2[1], filter2.slice(2))) : op === "has" ? convertHasOp(filter2[1]) : op === "!has" ? convertNegation(convertHasOp(filter2[1])) : op === "within" ? filter2 : true;
	                  return converted;
	                }
	                function convertComparisonOp(property, value, op) {
	                  switch (property) {
	                    case "$type":
	                      return [
	                        "filter-type-" + op,
	                        value
	                      ];
	                    case "$id":
	                      return [
	                        "filter-id-" + op,
	                        value
	                      ];
	                    default:
	                      return [
	                        "filter-" + op,
	                        property,
	                        value
	                      ];
	                  }
	                }
	                function convertDisjunctionOp(filters) {
	                  return ["any"].concat(filters.map(convertFilter));
	                }
	                function convertInOp(property, values2) {
	                  if (values2.length === 0) {
	                    return false;
	                  }
	                  switch (property) {
	                    case "$type":
	                      return [
	                        "filter-type-in",
	                        [
	                          "literal",
	                          values2
	                        ]
	                      ];
	                    case "$id":
	                      return [
	                        "filter-id-in",
	                        [
	                          "literal",
	                          values2
	                        ]
	                      ];
	                    default:
	                      if (values2.length > 200 && !values2.some(function(v) {
	                        return typeof v !== typeof values2[0];
	                      })) {
	                        return [
	                          "filter-in-large",
	                          property,
	                          [
	                            "literal",
	                            values2.sort(compare)
	                          ]
	                        ];
	                      } else {
	                        return [
	                          "filter-in-small",
	                          property,
	                          [
	                            "literal",
	                            values2
	                          ]
	                        ];
	                      }
	                  }
	                }
	                function convertHasOp(property) {
	                  switch (property) {
	                    case "$type":
	                      return true;
	                    case "$id":
	                      return ["filter-has-id"];
	                    default:
	                      return [
	                        "filter-has",
	                        property
	                      ];
	                  }
	                }
	                function convertNegation(filter2) {
	                  return [
	                    "!",
	                    filter2
	                  ];
	                }
	                function validateFilter(options) {
	                  if (isExpressionFilter(deepUnbundle(options.value))) {
	                    return validateExpression(extend$1({}, options, {
	                      expressionContext: "filter",
	                      valueSpec: { value: "boolean" }
	                    }));
	                  } else {
	                    return validateNonExpressionFilter(options);
	                  }
	                }
	                function validateNonExpressionFilter(options) {
	                  var value = options.value;
	                  var key = options.key;
	                  if (getType(value) !== "array") {
	                    return [new ValidationError(key, value, "array expected, " + getType(value) + " found")];
	                  }
	                  var styleSpec = options.styleSpec;
	                  var type;
	                  var errors = [];
	                  if (value.length < 1) {
	                    return [new ValidationError(key, value, "filter array must have at least 1 element")];
	                  }
	                  errors = errors.concat(validateEnum({
	                    key: key + "[0]",
	                    value: value[0],
	                    valueSpec: styleSpec.filter_operator,
	                    style: options.style,
	                    styleSpec: options.styleSpec
	                  }));
	                  switch (unbundle(value[0])) {
	                    case "<":
	                    case "<=":
	                    case ">":
	                    case ">=":
	                      if (value.length >= 2 && unbundle(value[1]) === "$type") {
	                        errors.push(new ValidationError(key, value, '"$type" cannot be use with operator "' + value[0] + '"'));
	                      }
	                    case "==":
	                    case "!=":
	                      if (value.length !== 3) {
	                        errors.push(new ValidationError(key, value, 'filter array for operator "' + value[0] + '" must have 3 elements'));
	                      }
	                    case "in":
	                    case "!in":
	                      if (value.length >= 2) {
	                        type = getType(value[1]);
	                        if (type !== "string") {
	                          errors.push(new ValidationError(key + "[1]", value[1], "string expected, " + type + " found"));
	                        }
	                      }
	                      for (var i = 2; i < value.length; i++) {
	                        type = getType(value[i]);
	                        if (unbundle(value[1]) === "$type") {
	                          errors = errors.concat(validateEnum({
	                            key: key + "[" + i + "]",
	                            value: value[i],
	                            valueSpec: styleSpec.geometry_type,
	                            style: options.style,
	                            styleSpec: options.styleSpec
	                          }));
	                        } else if (type !== "string" && type !== "number" && type !== "boolean") {
	                          errors.push(new ValidationError(key + "[" + i + "]", value[i], "string, number, or boolean expected, " + type + " found"));
	                        }
	                      }
	                      break;
	                    case "any":
	                    case "all":
	                    case "none":
	                      for (var i$1 = 1; i$1 < value.length; i$1++) {
	                        errors = errors.concat(validateNonExpressionFilter({
	                          key: key + "[" + i$1 + "]",
	                          value: value[i$1],
	                          style: options.style,
	                          styleSpec: options.styleSpec
	                        }));
	                      }
	                      break;
	                    case "has":
	                    case "!has":
	                      type = getType(value[1]);
	                      if (value.length !== 2) {
	                        errors.push(new ValidationError(key, value, 'filter array for "' + value[0] + '" operator must have 2 elements'));
	                      } else if (type !== "string") {
	                        errors.push(new ValidationError(key + "[1]", value[1], "string expected, " + type + " found"));
	                      }
	                      break;
	                    case "within":
	                      type = getType(value[1]);
	                      if (value.length !== 2) {
	                        errors.push(new ValidationError(key, value, 'filter array for "' + value[0] + '" operator must have 2 elements'));
	                      } else if (type !== "object") {
	                        errors.push(new ValidationError(key + "[1]", value[1], "object expected, " + type + " found"));
	                      }
	                      break;
	                  }
	                  return errors;
	                }
	                function validateProperty(options, propertyType) {
	                  var key = options.key;
	                  var style = options.style;
	                  var styleSpec = options.styleSpec;
	                  var value = options.value;
	                  var propertyKey = options.objectKey;
	                  var layerSpec = styleSpec[propertyType + "_" + options.layerType];
	                  if (!layerSpec) {
	                    return [];
	                  }
	                  var transitionMatch = propertyKey.match(/^(.*)-transition$/);
	                  if (propertyType === "paint" && transitionMatch && layerSpec[transitionMatch[1]] && layerSpec[transitionMatch[1]].transition) {
	                    return validate({
	                      key,
	                      value,
	                      valueSpec: styleSpec.transition,
	                      style,
	                      styleSpec
	                    });
	                  }
	                  var valueSpec = options.valueSpec || layerSpec[propertyKey];
	                  if (!valueSpec) {
	                    return [new ValidationError(key, value, 'unknown property "' + propertyKey + '"')];
	                  }
	                  var tokenMatch;
	                  if (getType(value) === "string" && supportsPropertyExpression(valueSpec) && !valueSpec.tokens && (tokenMatch = /^{([^}]+)}$/.exec(value))) {
	                    return [new ValidationError(key, value, '"' + propertyKey + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(tokenMatch[1]) + " }`.")];
	                  }
	                  var errors = [];
	                  if (options.layerType === "symbol") {
	                    if (propertyKey === "text-field" && style && !style.glyphs) {
	                      errors.push(new ValidationError(key, value, 'use of "text-field" requires a style "glyphs" property'));
	                    }
	                    if (propertyKey === "text-font" && isFunction(deepUnbundle(value)) && unbundle(value.type) === "identity") {
	                      errors.push(new ValidationError(key, value, '"text-font" does not support identity functions'));
	                    }
	                  }
	                  return errors.concat(validate({
	                    key: options.key,
	                    value,
	                    valueSpec,
	                    style,
	                    styleSpec,
	                    expressionContext: "property",
	                    propertyType,
	                    propertyKey
	                  }));
	                }
	                function validatePaintProperty(options) {
	                  return validateProperty(options, "paint");
	                }
	                function validateLayoutProperty(options) {
	                  return validateProperty(options, "layout");
	                }
	                function validateLayer(options) {
	                  var errors = [];
	                  var layer2 = options.value;
	                  var key = options.key;
	                  var style = options.style;
	                  var styleSpec = options.styleSpec;
	                  if (!layer2.type && !layer2.ref) {
	                    errors.push(new ValidationError(key, layer2, 'either "type" or "ref" is required'));
	                  }
	                  var type = unbundle(layer2.type);
	                  var ref = unbundle(layer2.ref);
	                  if (layer2.id) {
	                    var layerId = unbundle(layer2.id);
	                    for (var i = 0; i < options.arrayIndex; i++) {
	                      var otherLayer = style.layers[i];
	                      if (unbundle(otherLayer.id) === layerId) {
	                        errors.push(new ValidationError(key, layer2.id, 'duplicate layer id "' + layer2.id + '", previously used at line ' + otherLayer.id.__line__));
	                      }
	                    }
	                  }
	                  if ("ref" in layer2) {
	                    [
	                      "type",
	                      "source",
	                      "source-layer",
	                      "filter",
	                      "layout"
	                    ].forEach(function(p) {
	                      if (p in layer2) {
	                        errors.push(new ValidationError(key, layer2[p], '"' + p + '" is prohibited for ref layers'));
	                      }
	                    });
	                    var parent;
	                    style.layers.forEach(function(layer3) {
	                      if (unbundle(layer3.id) === ref) {
	                        parent = layer3;
	                      }
	                    });
	                    if (!parent) {
	                      errors.push(new ValidationError(key, layer2.ref, 'ref layer "' + ref + '" not found'));
	                    } else if (parent.ref) {
	                      errors.push(new ValidationError(key, layer2.ref, "ref cannot reference another ref layer"));
	                    } else {
	                      type = unbundle(parent.type);
	                    }
	                  } else if (type !== "background") {
	                    if (!layer2.source) {
	                      errors.push(new ValidationError(key, layer2, 'missing required property "source"'));
	                    } else {
	                      var source2 = style.sources && style.sources[layer2.source];
	                      var sourceType = source2 && unbundle(source2.type);
	                      if (!source2) {
	                        errors.push(new ValidationError(key, layer2.source, 'source "' + layer2.source + '" not found'));
	                      } else if (sourceType === "vector" && type === "raster") {
	                        errors.push(new ValidationError(key, layer2.source, 'layer "' + layer2.id + '" requires a raster source'));
	                      } else if (sourceType === "raster" && type !== "raster") {
	                        errors.push(new ValidationError(key, layer2.source, 'layer "' + layer2.id + '" requires a vector source'));
	                      } else if (sourceType === "vector" && !layer2["source-layer"]) {
	                        errors.push(new ValidationError(key, layer2, 'layer "' + layer2.id + '" must specify a "source-layer"'));
	                      } else if (sourceType === "raster-dem" && type !== "hillshade") {
	                        errors.push(new ValidationError(key, layer2.source, "raster-dem source can only be used with layer type 'hillshade'."));
	                      } else if (type === "line" && layer2.paint && layer2.paint["line-gradient"] && (sourceType !== "geojson" || !source2.lineMetrics)) {
	                        errors.push(new ValidationError(key, layer2, 'layer "' + layer2.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.'));
	                      }
	                    }
	                  }
	                  errors = errors.concat(validateObject({
	                    key,
	                    value: layer2,
	                    valueSpec: styleSpec.layer,
	                    style: options.style,
	                    styleSpec: options.styleSpec,
	                    objectElementValidators: {
	                      "*": function _() {
	                        return [];
	                      },
	                      type: function type2() {
	                        return validate({
	                          key: key + ".type",
	                          value: layer2.type,
	                          valueSpec: styleSpec.layer.type,
	                          style: options.style,
	                          styleSpec: options.styleSpec,
	                          object: layer2,
	                          objectKey: "type"
	                        });
	                      },
	                      filter: validateFilter,
	                      layout: function layout2(options2) {
	                        return validateObject({
	                          layer: layer2,
	                          key: options2.key,
	                          value: options2.value,
	                          style: options2.style,
	                          styleSpec: options2.styleSpec,
	                          objectElementValidators: {
	                            "*": function _(options3) {
	                              return validateLayoutProperty(extend$1({ layerType: type }, options3));
	                            }
	                          }
	                        });
	                      },
	                      paint: function paint2(options2) {
	                        return validateObject({
	                          layer: layer2,
	                          key: options2.key,
	                          value: options2.value,
	                          style: options2.style,
	                          styleSpec: options2.styleSpec,
	                          objectElementValidators: {
	                            "*": function _(options3) {
	                              return validatePaintProperty(extend$1({ layerType: type }, options3));
	                            }
	                          }
	                        });
	                      }
	                    }
	                  }));
	                  return errors;
	                }
	                function validateString(options) {
	                  var value = options.value;
	                  var key = options.key;
	                  var type = getType(value);
	                  if (type !== "string") {
	                    return [new ValidationError(key, value, "string expected, " + type + " found")];
	                  }
	                  return [];
	                }
	                var objectElementValidators = { promoteId: validatePromoteId };
	                function validateSource(options) {
	                  var value = options.value;
	                  var key = options.key;
	                  var styleSpec = options.styleSpec;
	                  var style = options.style;
	                  if (!value.type) {
	                    return [new ValidationError(key, value, '"type" is required')];
	                  }
	                  var type = unbundle(value.type);
	                  var errors;
	                  switch (type) {
	                    case "vector":
	                    case "raster":
	                    case "raster-dem":
	                      errors = validateObject({
	                        key,
	                        value,
	                        valueSpec: styleSpec["source_" + type.replace("-", "_")],
	                        style: options.style,
	                        styleSpec,
	                        objectElementValidators
	                      });
	                      return errors;
	                    case "geojson":
	                      errors = validateObject({
	                        key,
	                        value,
	                        valueSpec: styleSpec.source_geojson,
	                        style,
	                        styleSpec,
	                        objectElementValidators
	                      });
	                      if (value.cluster) {
	                        for (var prop in value.clusterProperties) {
	                          var ref = value.clusterProperties[prop];
	                          var operator = ref[0];
	                          var mapExpr = ref[1];
	                          var reduceExpr = typeof operator === "string" ? [
	                            operator,
	                            ["accumulated"],
	                            [
	                              "get",
	                              prop
	                            ]
	                          ] : operator;
	                          errors.push.apply(errors, validateExpression({
	                            key: key + "." + prop + ".map",
	                            value: mapExpr,
	                            expressionContext: "cluster-map"
	                          }));
	                          errors.push.apply(errors, validateExpression({
	                            key: key + "." + prop + ".reduce",
	                            value: reduceExpr,
	                            expressionContext: "cluster-reduce"
	                          }));
	                        }
	                      }
	                      return errors;
	                    case "video":
	                      return validateObject({
	                        key,
	                        value,
	                        valueSpec: styleSpec.source_video,
	                        style,
	                        styleSpec
	                      });
	                    case "image":
	                      return validateObject({
	                        key,
	                        value,
	                        valueSpec: styleSpec.source_image,
	                        style,
	                        styleSpec
	                      });
	                    case "canvas":
	                      return [new ValidationError(key, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
	                    default:
	                      return validateEnum({
	                        key: key + ".type",
	                        value: value.type,
	                        valueSpec: {
	                          values: [
	                            "vector",
	                            "raster",
	                            "raster-dem",
	                            "geojson",
	                            "video",
	                            "image"
	                          ]
	                        },
	                        style,
	                        styleSpec
	                      });
	                  }
	                }
	                function validatePromoteId(ref) {
	                  var key = ref.key;
	                  var value = ref.value;
	                  if (getType(value) === "string") {
	                    return validateString({
	                      key,
	                      value
	                    });
	                  } else {
	                    var errors = [];
	                    for (var prop in value) {
	                      errors.push.apply(errors, validateString({
	                        key: key + "." + prop,
	                        value: value[prop]
	                      }));
	                    }
	                    return errors;
	                  }
	                }
	                function validateLight(options) {
	                  var light2 = options.value;
	                  var styleSpec = options.styleSpec;
	                  var lightSpec = styleSpec.light;
	                  var style = options.style;
	                  var errors = [];
	                  var rootType = getType(light2);
	                  if (light2 === undefined) {
	                    return errors;
	                  } else if (rootType !== "object") {
	                    errors = errors.concat([new ValidationError("light", light2, "object expected, " + rootType + " found")]);
	                    return errors;
	                  }
	                  for (var key in light2) {
	                    var transitionMatch = key.match(/^(.*)-transition$/);
	                    if (transitionMatch && lightSpec[transitionMatch[1]] && lightSpec[transitionMatch[1]].transition) {
	                      errors = errors.concat(validate({
	                        key,
	                        value: light2[key],
	                        valueSpec: styleSpec.transition,
	                        style,
	                        styleSpec
	                      }));
	                    } else if (lightSpec[key]) {
	                      errors = errors.concat(validate({
	                        key,
	                        value: light2[key],
	                        valueSpec: lightSpec[key],
	                        style,
	                        styleSpec
	                      }));
	                    } else {
	                      errors = errors.concat([new ValidationError(key, light2[key], 'unknown property "' + key + '"')]);
	                    }
	                  }
	                  return errors;
	                }
	                function validateFormatted(options) {
	                  if (validateString(options).length === 0) {
	                    return [];
	                  }
	                  return validateExpression(options);
	                }
	                function validateImage(options) {
	                  if (validateString(options).length === 0) {
	                    return [];
	                  }
	                  return validateExpression(options);
	                }
	                var VALIDATORS = {
	                  "*": function _() {
	                    return [];
	                  },
	                  "array": validateArray,
	                  "boolean": validateBoolean,
	                  "number": validateNumber,
	                  "color": validateColor,
	                  "constants": validateConstants,
	                  "enum": validateEnum,
	                  "filter": validateFilter,
	                  "function": validateFunction,
	                  "layer": validateLayer,
	                  "object": validateObject,
	                  "source": validateSource,
	                  "light": validateLight,
	                  "string": validateString,
	                  "formatted": validateFormatted,
	                  "resolvedImage": validateImage
	                };
	                function validate(options) {
	                  var value = options.value;
	                  var valueSpec = options.valueSpec;
	                  var styleSpec = options.styleSpec;
	                  if (valueSpec.expression && isFunction(unbundle(value))) {
	                    return validateFunction(options);
	                  } else if (valueSpec.expression && isExpression(deepUnbundle(value))) {
	                    return validateExpression(options);
	                  } else if (valueSpec.type && VALIDATORS[valueSpec.type]) {
	                    return VALIDATORS[valueSpec.type](options);
	                  } else {
	                    var valid = validateObject(extend$1({}, options, { valueSpec: valueSpec.type ? styleSpec[valueSpec.type] : valueSpec }));
	                    return valid;
	                  }
	                }
	                function validateGlyphsURL(options) {
	                  var value = options.value;
	                  var key = options.key;
	                  var errors = validateString(options);
	                  if (errors.length) {
	                    return errors;
	                  }
	                  if (value.indexOf("{fontstack}") === -1) {
	                    errors.push(new ValidationError(key, value, '"glyphs" url must include a "{fontstack}" token'));
	                  }
	                  if (value.indexOf("{range}") === -1) {
	                    errors.push(new ValidationError(key, value, '"glyphs" url must include a "{range}" token'));
	                  }
	                  return errors;
	                }
	                function validateStyleMin(style, styleSpec) {
	                  if (styleSpec === undefined)
	                    styleSpec = spec;
	                  var errors = [];
	                  errors = errors.concat(validate({
	                    key: "",
	                    value: style,
	                    valueSpec: styleSpec.$root,
	                    styleSpec,
	                    style,
	                    objectElementValidators: {
	                      glyphs: validateGlyphsURL,
	                      "*": function _() {
	                        return [];
	                      }
	                    }
	                  }));
	                  if (style.constants) {
	                    errors = errors.concat(validateConstants({
	                      key: "constants",
	                      value: style.constants,
	                      style,
	                      styleSpec
	                    }));
	                  }
	                  return sortErrors(errors);
	                }
	                validateStyleMin.source = wrapCleanErrors(validateSource);
	                validateStyleMin.light = wrapCleanErrors(validateLight);
	                validateStyleMin.layer = wrapCleanErrors(validateLayer);
	                validateStyleMin.filter = wrapCleanErrors(validateFilter);
	                validateStyleMin.paintProperty = wrapCleanErrors(validatePaintProperty);
	                validateStyleMin.layoutProperty = wrapCleanErrors(validateLayoutProperty);
	                function sortErrors(errors) {
	                  return [].concat(errors).sort(function(a, b) {
	                    return a.line - b.line;
	                  });
	                }
	                function wrapCleanErrors(inner) {
	                  return function() {
	                    var args = [], len = arguments.length;
	                    while (len--)
	                      args[len] = arguments[len];
	                    return sortErrors(inner.apply(this, args));
	                  };
	                }
	                var validateStyle = validateStyleMin;
	                var validateLight$1 = validateStyle.light;
	                var validatePaintProperty$1 = validateStyle.paintProperty;
	                var validateLayoutProperty$1 = validateStyle.layoutProperty;
	                function emitValidationErrors(emitter, errors) {
	                  var hasErrors = false;
	                  if (errors && errors.length) {
	                    for (var i = 0, list = errors; i < list.length; i += 1) {
	                      var error2 = list[i];
	                      emitter.fire(new ErrorEvent(new Error(error2.message)));
	                      hasErrors = true;
	                    }
	                  }
	                  return hasErrors;
	                }
	                var gridIndex = GridIndex;
	                var NUM_PARAMS = 3;
	                function GridIndex(extent2, n, padding) {
	                  var cells = this.cells = [];
	                  if (extent2 instanceof ArrayBuffer) {
	                    this.arrayBuffer = extent2;
	                    var array2 = new Int32Array(this.arrayBuffer);
	                    extent2 = array2[0];
	                    n = array2[1];
	                    padding = array2[2];
	                    this.d = n + 2 * padding;
	                    for (var k = 0; k < this.d * this.d; k++) {
	                      var start = array2[NUM_PARAMS + k];
	                      var end = array2[NUM_PARAMS + k + 1];
	                      cells.push(start === end ? null : array2.subarray(start, end));
	                    }
	                    var keysOffset = array2[NUM_PARAMS + cells.length];
	                    var bboxesOffset = array2[NUM_PARAMS + cells.length + 1];
	                    this.keys = array2.subarray(keysOffset, bboxesOffset);
	                    this.bboxes = array2.subarray(bboxesOffset);
	                    this.insert = this._insertReadonly;
	                  } else {
	                    this.d = n + 2 * padding;
	                    for (var i = 0; i < this.d * this.d; i++) {
	                      cells.push([]);
	                    }
	                    this.keys = [];
	                    this.bboxes = [];
	                  }
	                  this.n = n;
	                  this.extent = extent2;
	                  this.padding = padding;
	                  this.scale = n / extent2;
	                  this.uid = 0;
	                  var p = padding / n * extent2;
	                  this.min = -p;
	                  this.max = extent2 + p;
	                }
	                GridIndex.prototype.insert = function(key, x1, y1, x2, y2) {
	                  this._forEachCell(x1, y1, x2, y2, this._insertCell, this.uid++);
	                  this.keys.push(key);
	                  this.bboxes.push(x1);
	                  this.bboxes.push(y1);
	                  this.bboxes.push(x2);
	                  this.bboxes.push(y2);
	                };
	                GridIndex.prototype._insertReadonly = function() {
	                  throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
	                };
	                GridIndex.prototype._insertCell = function(x1, y1, x2, y2, cellIndex, uid) {
	                  this.cells[cellIndex].push(uid);
	                };
	                GridIndex.prototype.query = function(x1, y1, x2, y2, intersectionTest) {
	                  var min = this.min;
	                  var max = this.max;
	                  if (x1 <= min && y1 <= min && max <= x2 && max <= y2 && !intersectionTest) {
	                    return Array.prototype.slice.call(this.keys);
	                  } else {
	                    var result = [];
	                    var seenUids = {};
	                    this._forEachCell(x1, y1, x2, y2, this._queryCell, result, seenUids, intersectionTest);
	                    return result;
	                  }
	                };
	                GridIndex.prototype._queryCell = function(x1, y1, x2, y2, cellIndex, result, seenUids, intersectionTest) {
	                  var cell = this.cells[cellIndex];
	                  if (cell !== null) {
	                    var keys = this.keys;
	                    var bboxes = this.bboxes;
	                    for (var u = 0; u < cell.length; u++) {
	                      var uid = cell[u];
	                      if (seenUids[uid] === undefined) {
	                        var offset = uid * 4;
	                        if (intersectionTest ? intersectionTest(bboxes[offset + 0], bboxes[offset + 1], bboxes[offset + 2], bboxes[offset + 3]) : x1 <= bboxes[offset + 2] && y1 <= bboxes[offset + 3] && x2 >= bboxes[offset + 0] && y2 >= bboxes[offset + 1]) {
	                          seenUids[uid] = true;
	                          result.push(keys[uid]);
	                        } else {
	                          seenUids[uid] = false;
	                        }
	                      }
	                    }
	                  }
	                };
	                GridIndex.prototype._forEachCell = function(x1, y1, x2, y2, fn, arg1, arg2, intersectionTest) {
	                  var cx1 = this._convertToCellCoord(x1);
	                  var cy1 = this._convertToCellCoord(y1);
	                  var cx2 = this._convertToCellCoord(x2);
	                  var cy2 = this._convertToCellCoord(y2);
	                  for (var x = cx1; x <= cx2; x++) {
	                    for (var y = cy1; y <= cy2; y++) {
	                      var cellIndex = this.d * y + x;
	                      if (intersectionTest && !intersectionTest(this._convertFromCellCoord(x), this._convertFromCellCoord(y), this._convertFromCellCoord(x + 1), this._convertFromCellCoord(y + 1))) {
	                        continue;
	                      }
	                      if (fn.call(this, x1, y1, x2, y2, cellIndex, arg1, arg2, intersectionTest)) {
	                        return;
	                      }
	                    }
	                  }
	                };
	                GridIndex.prototype._convertFromCellCoord = function(x) {
	                  return (x - this.padding) / this.scale;
	                };
	                GridIndex.prototype._convertToCellCoord = function(x) {
	                  return Math.max(0, Math.min(this.d - 1, Math.floor(x * this.scale) + this.padding));
	                };
	                GridIndex.prototype.toArrayBuffer = function() {
	                  if (this.arrayBuffer) {
	                    return this.arrayBuffer;
	                  }
	                  var cells = this.cells;
	                  var metadataLength = NUM_PARAMS + this.cells.length + 1 + 1;
	                  var totalCellLength = 0;
	                  for (var i = 0; i < this.cells.length; i++) {
	                    totalCellLength += this.cells[i].length;
	                  }
	                  var array2 = new Int32Array(metadataLength + totalCellLength + this.keys.length + this.bboxes.length);
	                  array2[0] = this.extent;
	                  array2[1] = this.n;
	                  array2[2] = this.padding;
	                  var offset = metadataLength;
	                  for (var k = 0; k < cells.length; k++) {
	                    var cell = cells[k];
	                    array2[NUM_PARAMS + k] = offset;
	                    array2.set(cell, offset);
	                    offset += cell.length;
	                  }
	                  array2[NUM_PARAMS + cells.length] = offset;
	                  array2.set(this.keys, offset);
	                  offset += this.keys.length;
	                  array2[NUM_PARAMS + cells.length + 1] = offset;
	                  array2.set(this.bboxes, offset);
	                  offset += this.bboxes.length;
	                  return array2.buffer;
	                };
	                var ImageData2 = self.ImageData;
	                var ImageBitmap = self.ImageBitmap;
	                var registry = {};
	                function register(name3, klass, options) {
	                  if (options === undefined)
	                    options = {};
	                  Object.defineProperty(klass, "_classRegistryKey", {
	                    value: name3,
	                    writeable: false
	                  });
	                  registry[name3] = {
	                    klass,
	                    omit: options.omit || [],
	                    shallow: options.shallow || []
	                  };
	                }
	                register("Object", Object);
	                gridIndex.serialize = function serialize2(grid, transferables) {
	                  var buffer = grid.toArrayBuffer();
	                  if (transferables) {
	                    transferables.push(buffer);
	                  }
	                  return { buffer };
	                };
	                gridIndex.deserialize = function deserialize2(serialized) {
	                  return new gridIndex(serialized.buffer);
	                };
	                register("Grid", gridIndex);
	                register("Color", Color);
	                register("Error", Error);
	                register("ResolvedImage", ResolvedImage);
	                register("StylePropertyFunction", StylePropertyFunction);
	                register("StyleExpression", StyleExpression, { omit: ["_evaluator"] });
	                register("ZoomDependentExpression", ZoomDependentExpression);
	                register("ZoomConstantExpression", ZoomConstantExpression);
	                register("CompoundExpression", CompoundExpression, { omit: ["_evaluate"] });
	                for (var name2 in expressions) {
	                  if (expressions[name2]._classRegistryKey) {
	                    continue;
	                  }
	                  register("Expression_" + name2, expressions[name2]);
	                }
	                function isArrayBuffer(val) {
	                  return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || val.constructor && val.constructor.name === "ArrayBuffer");
	                }
	                function isImageBitmap(val) {
	                  return ImageBitmap && val instanceof ImageBitmap;
	                }
	                function serialize(input, transferables) {
	                  if (input === null || input === undefined || typeof input === "boolean" || typeof input === "number" || typeof input === "string" || input instanceof Boolean || input instanceof Number || input instanceof String || input instanceof Date || input instanceof RegExp) {
	                    return input;
	                  }
	                  if (isArrayBuffer(input) || isImageBitmap(input)) {
	                    if (transferables) {
	                      transferables.push(input);
	                    }
	                    return input;
	                  }
	                  if (ArrayBuffer.isView(input)) {
	                    var view = input;
	                    if (transferables) {
	                      transferables.push(view.buffer);
	                    }
	                    return view;
	                  }
	                  if (input instanceof ImageData2) {
	                    if (transferables) {
	                      transferables.push(input.data.buffer);
	                    }
	                    return input;
	                  }
	                  if (Array.isArray(input)) {
	                    var serialized = [];
	                    for (var i = 0, list = input; i < list.length; i += 1) {
	                      var item = list[i];
	                      serialized.push(serialize(item, transferables));
	                    }
	                    return serialized;
	                  }
	                  if (typeof input === "object") {
	                    var klass = input.constructor;
	                    var name3 = klass._classRegistryKey;
	                    if (!name3) {
	                      throw new Error("can't serialize object of unregistered class");
	                    }
	                    var properties2 = klass.serialize ? klass.serialize(input, transferables) : {};
	                    if (!klass.serialize) {
	                      for (var key in input) {
	                        if (!input.hasOwnProperty(key)) {
	                          continue;
	                        }
	                        if (registry[name3].omit.indexOf(key) >= 0) {
	                          continue;
	                        }
	                        var property = input[key];
	                        properties2[key] = registry[name3].shallow.indexOf(key) >= 0 ? property : serialize(property, transferables);
	                      }
	                      if (input instanceof Error) {
	                        properties2.message = input.message;
	                      }
	                    }
	                    if (properties2.$name) {
	                      throw new Error("$name property is reserved for worker serialization logic.");
	                    }
	                    if (name3 !== "Object") {
	                      properties2.$name = name3;
	                    }
	                    return properties2;
	                  }
	                  throw new Error("can't serialize object of type " + typeof input);
	                }
	                function deserialize(input) {
	                  if (input === null || input === undefined || typeof input === "boolean" || typeof input === "number" || typeof input === "string" || input instanceof Boolean || input instanceof Number || input instanceof String || input instanceof Date || input instanceof RegExp || isArrayBuffer(input) || isImageBitmap(input) || ArrayBuffer.isView(input) || input instanceof ImageData2) {
	                    return input;
	                  }
	                  if (Array.isArray(input)) {
	                    return input.map(deserialize);
	                  }
	                  if (typeof input === "object") {
	                    var name3 = input.$name || "Object";
	                    var ref = registry[name3];
	                    var klass = ref.klass;
	                    if (!klass) {
	                      throw new Error("can't deserialize unregistered class " + name3);
	                    }
	                    if (klass.deserialize) {
	                      return klass.deserialize(input);
	                    }
	                    var result = Object.create(klass.prototype);
	                    for (var i = 0, list = Object.keys(input); i < list.length; i += 1) {
	                      var key = list[i];
	                      if (key === "$name") {
	                        continue;
	                      }
	                      var value = input[key];
	                      result[key] = registry[name3].shallow.indexOf(key) >= 0 ? value : deserialize(value);
	                    }
	                    return result;
	                  }
	                  throw new Error("can't deserialize object of type " + typeof input);
	                }
	                var ZoomHistory = function ZoomHistory2() {
	                  this.first = true;
	                };
	                ZoomHistory.prototype.update = function update(z, now2) {
	                  var floorZ = Math.floor(z);
	                  if (this.first) {
	                    this.first = false;
	                    this.lastIntegerZoom = floorZ;
	                    this.lastIntegerZoomTime = 0;
	                    this.lastZoom = z;
	                    this.lastFloorZoom = floorZ;
	                    return true;
	                  }
	                  if (this.lastFloorZoom > floorZ) {
	                    this.lastIntegerZoom = floorZ + 1;
	                    this.lastIntegerZoomTime = now2;
	                  } else if (this.lastFloorZoom < floorZ) {
	                    this.lastIntegerZoom = floorZ;
	                    this.lastIntegerZoomTime = now2;
	                  }
	                  if (z !== this.lastZoom) {
	                    this.lastZoom = z;
	                    this.lastFloorZoom = floorZ;
	                    return true;
	                  }
	                  return false;
	                };
	                var unicodeBlockLookup = {
	                  "Latin-1 Supplement": function(char) {
	                    return char >= 128 && char <= 255;
	                  },
	                  "Arabic": function(char) {
	                    return char >= 1536 && char <= 1791;
	                  },
	                  "Arabic Supplement": function(char) {
	                    return char >= 1872 && char <= 1919;
	                  },
	                  "Arabic Extended-A": function(char) {
	                    return char >= 2208 && char <= 2303;
	                  },
	                  "Hangul Jamo": function(char) {
	                    return char >= 4352 && char <= 4607;
	                  },
	                  "Unified Canadian Aboriginal Syllabics": function(char) {
	                    return char >= 5120 && char <= 5759;
	                  },
	                  "Khmer": function(char) {
	                    return char >= 6016 && char <= 6143;
	                  },
	                  "Unified Canadian Aboriginal Syllabics Extended": function(char) {
	                    return char >= 6320 && char <= 6399;
	                  },
	                  "General Punctuation": function(char) {
	                    return char >= 8192 && char <= 8303;
	                  },
	                  "Letterlike Symbols": function(char) {
	                    return char >= 8448 && char <= 8527;
	                  },
	                  "Number Forms": function(char) {
	                    return char >= 8528 && char <= 8591;
	                  },
	                  "Miscellaneous Technical": function(char) {
	                    return char >= 8960 && char <= 9215;
	                  },
	                  "Control Pictures": function(char) {
	                    return char >= 9216 && char <= 9279;
	                  },
	                  "Optical Character Recognition": function(char) {
	                    return char >= 9280 && char <= 9311;
	                  },
	                  "Enclosed Alphanumerics": function(char) {
	                    return char >= 9312 && char <= 9471;
	                  },
	                  "Geometric Shapes": function(char) {
	                    return char >= 9632 && char <= 9727;
	                  },
	                  "Miscellaneous Symbols": function(char) {
	                    return char >= 9728 && char <= 9983;
	                  },
	                  "Miscellaneous Symbols and Arrows": function(char) {
	                    return char >= 11008 && char <= 11263;
	                  },
	                  "CJK Radicals Supplement": function(char) {
	                    return char >= 11904 && char <= 12031;
	                  },
	                  "Kangxi Radicals": function(char) {
	                    return char >= 12032 && char <= 12255;
	                  },
	                  "Ideographic Description Characters": function(char) {
	                    return char >= 12272 && char <= 12287;
	                  },
	                  "CJK Symbols and Punctuation": function(char) {
	                    return char >= 12288 && char <= 12351;
	                  },
	                  "Hiragana": function(char) {
	                    return char >= 12352 && char <= 12447;
	                  },
	                  "Katakana": function(char) {
	                    return char >= 12448 && char <= 12543;
	                  },
	                  "Bopomofo": function(char) {
	                    return char >= 12544 && char <= 12591;
	                  },
	                  "Hangul Compatibility Jamo": function(char) {
	                    return char >= 12592 && char <= 12687;
	                  },
	                  "Kanbun": function(char) {
	                    return char >= 12688 && char <= 12703;
	                  },
	                  "Bopomofo Extended": function(char) {
	                    return char >= 12704 && char <= 12735;
	                  },
	                  "CJK Strokes": function(char) {
	                    return char >= 12736 && char <= 12783;
	                  },
	                  "Katakana Phonetic Extensions": function(char) {
	                    return char >= 12784 && char <= 12799;
	                  },
	                  "Enclosed CJK Letters and Months": function(char) {
	                    return char >= 12800 && char <= 13055;
	                  },
	                  "CJK Compatibility": function(char) {
	                    return char >= 13056 && char <= 13311;
	                  },
	                  "CJK Unified Ideographs Extension A": function(char) {
	                    return char >= 13312 && char <= 19903;
	                  },
	                  "Yijing Hexagram Symbols": function(char) {
	                    return char >= 19904 && char <= 19967;
	                  },
	                  "CJK Unified Ideographs": function(char) {
	                    return char >= 19968 && char <= 40959;
	                  },
	                  "Yi Syllables": function(char) {
	                    return char >= 40960 && char <= 42127;
	                  },
	                  "Yi Radicals": function(char) {
	                    return char >= 42128 && char <= 42191;
	                  },
	                  "Hangul Jamo Extended-A": function(char) {
	                    return char >= 43360 && char <= 43391;
	                  },
	                  "Hangul Syllables": function(char) {
	                    return char >= 44032 && char <= 55215;
	                  },
	                  "Hangul Jamo Extended-B": function(char) {
	                    return char >= 55216 && char <= 55295;
	                  },
	                  "Private Use Area": function(char) {
	                    return char >= 57344 && char <= 63743;
	                  },
	                  "CJK Compatibility Ideographs": function(char) {
	                    return char >= 63744 && char <= 64255;
	                  },
	                  "Arabic Presentation Forms-A": function(char) {
	                    return char >= 64336 && char <= 65023;
	                  },
	                  "Vertical Forms": function(char) {
	                    return char >= 65040 && char <= 65055;
	                  },
	                  "CJK Compatibility Forms": function(char) {
	                    return char >= 65072 && char <= 65103;
	                  },
	                  "Small Form Variants": function(char) {
	                    return char >= 65104 && char <= 65135;
	                  },
	                  "Arabic Presentation Forms-B": function(char) {
	                    return char >= 65136 && char <= 65279;
	                  },
	                  "Halfwidth and Fullwidth Forms": function(char) {
	                    return char >= 65280 && char <= 65519;
	                  }
	                };
	                function allowsVerticalWritingMode(chars) {
	                  for (var i = 0, list = chars; i < list.length; i += 1) {
	                    var char = list[i];
	                    if (charHasUprightVerticalOrientation(char.charCodeAt(0))) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function allowsLetterSpacing(chars) {
	                  for (var i = 0, list = chars; i < list.length; i += 1) {
	                    var char = list[i];
	                    if (!charAllowsLetterSpacing(char.charCodeAt(0))) {
	                      return false;
	                    }
	                  }
	                  return true;
	                }
	                function charAllowsLetterSpacing(char) {
	                  if (unicodeBlockLookup["Arabic"](char)) {
	                    return false;
	                  }
	                  if (unicodeBlockLookup["Arabic Supplement"](char)) {
	                    return false;
	                  }
	                  if (unicodeBlockLookup["Arabic Extended-A"](char)) {
	                    return false;
	                  }
	                  if (unicodeBlockLookup["Arabic Presentation Forms-A"](char)) {
	                    return false;
	                  }
	                  if (unicodeBlockLookup["Arabic Presentation Forms-B"](char)) {
	                    return false;
	                  }
	                  return true;
	                }
	                function charAllowsIdeographicBreaking(char) {
	                  if (char < 11904) {
	                    return false;
	                  }
	                  if (unicodeBlockLookup["Bopomofo Extended"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Bopomofo"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility Forms"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility Ideographs"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Radicals Supplement"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Strokes"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Symbols and Punctuation"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Unified Ideographs Extension A"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Unified Ideographs"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Enclosed CJK Letters and Months"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Halfwidth and Fullwidth Forms"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hiragana"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Ideographic Description Characters"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Kangxi Radicals"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Katakana Phonetic Extensions"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Katakana"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Vertical Forms"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Yi Radicals"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Yi Syllables"](char)) {
	                    return true;
	                  }
	                  return false;
	                }
	                function charHasUprightVerticalOrientation(char) {
	                  if (char === 746 || char === 747) {
	                    return true;
	                  }
	                  if (char < 4352) {
	                    return false;
	                  }
	                  if (unicodeBlockLookup["Bopomofo Extended"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Bopomofo"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility Forms"](char)) {
	                    if (!(char >= 65097 && char <= 65103)) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility Ideographs"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Radicals Supplement"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Strokes"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Symbols and Punctuation"](char)) {
	                    if (!(char >= 12296 && char <= 12305) && !(char >= 12308 && char <= 12319) && char !== 12336) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["CJK Unified Ideographs Extension A"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Unified Ideographs"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Enclosed CJK Letters and Months"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hangul Compatibility Jamo"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hangul Jamo Extended-A"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hangul Jamo Extended-B"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hangul Jamo"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hangul Syllables"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Hiragana"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Ideographic Description Characters"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Kanbun"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Kangxi Radicals"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Katakana Phonetic Extensions"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Katakana"](char)) {
	                    if (char !== 12540) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["Halfwidth and Fullwidth Forms"](char)) {
	                    if (char !== 65288 && char !== 65289 && char !== 65293 && !(char >= 65306 && char <= 65310) && char !== 65339 && char !== 65341 && char !== 65343 && !(char >= 65371 && char <= 65503) && char !== 65507 && !(char >= 65512 && char <= 65519)) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["Small Form Variants"](char)) {
	                    if (!(char >= 65112 && char <= 65118) && !(char >= 65123 && char <= 65126)) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["Unified Canadian Aboriginal Syllabics"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Unified Canadian Aboriginal Syllabics Extended"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Vertical Forms"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Yijing Hexagram Symbols"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Yi Syllables"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Yi Radicals"](char)) {
	                    return true;
	                  }
	                  return false;
	                }
	                function charHasNeutralVerticalOrientation(char) {
	                  if (unicodeBlockLookup["Latin-1 Supplement"](char)) {
	                    if (char === 167 || char === 169 || char === 174 || char === 177 || char === 188 || char === 189 || char === 190 || char === 215 || char === 247) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["General Punctuation"](char)) {
	                    if (char === 8214 || char === 8224 || char === 8225 || char === 8240 || char === 8241 || char === 8251 || char === 8252 || char === 8258 || char === 8263 || char === 8264 || char === 8265 || char === 8273) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["Letterlike Symbols"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Number Forms"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Miscellaneous Technical"](char)) {
	                    if (char >= 8960 && char <= 8967 || char >= 8972 && char <= 8991 || char >= 8996 && char <= 9e3 || char === 9003 || char >= 9085 && char <= 9114 || char >= 9150 && char <= 9165 || char === 9167 || char >= 9169 && char <= 9179 || char >= 9186 && char <= 9215) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["Control Pictures"](char) && char !== 9251) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Optical Character Recognition"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Enclosed Alphanumerics"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Geometric Shapes"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Miscellaneous Symbols"](char)) {
	                    if (!(char >= 9754 && char <= 9759)) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["Miscellaneous Symbols and Arrows"](char)) {
	                    if (char >= 11026 && char <= 11055 || char >= 11088 && char <= 11097 || char >= 11192 && char <= 11243) {
	                      return true;
	                    }
	                  }
	                  if (unicodeBlockLookup["CJK Symbols and Punctuation"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Katakana"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Private Use Area"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["CJK Compatibility Forms"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Small Form Variants"](char)) {
	                    return true;
	                  }
	                  if (unicodeBlockLookup["Halfwidth and Fullwidth Forms"](char)) {
	                    return true;
	                  }
	                  if (char === 8734 || char === 8756 || char === 8757 || char >= 9984 && char <= 10087 || char >= 10102 && char <= 10131 || char === 65532 || char === 65533) {
	                    return true;
	                  }
	                  return false;
	                }
	                function charHasRotatedVerticalOrientation(char) {
	                  return !(charHasUprightVerticalOrientation(char) || charHasNeutralVerticalOrientation(char));
	                }
	                function charInComplexShapingScript(char) {
	                  return unicodeBlockLookup["Arabic"](char) || unicodeBlockLookup["Arabic Supplement"](char) || unicodeBlockLookup["Arabic Extended-A"](char) || unicodeBlockLookup["Arabic Presentation Forms-A"](char) || unicodeBlockLookup["Arabic Presentation Forms-B"](char);
	                }
	                function charInRTLScript(char) {
	                  return char >= 1424 && char <= 2303 || unicodeBlockLookup["Arabic Presentation Forms-A"](char) || unicodeBlockLookup["Arabic Presentation Forms-B"](char);
	                }
	                function charInSupportedScript(char, canRenderRTL) {
	                  if (!canRenderRTL && charInRTLScript(char)) {
	                    return false;
	                  }
	                  if (char >= 2304 && char <= 3583 || char >= 3840 && char <= 4255 || unicodeBlockLookup["Khmer"](char)) {
	                    return false;
	                  }
	                  return true;
	                }
	                function stringContainsRTLText(chars) {
	                  for (var i = 0, list = chars; i < list.length; i += 1) {
	                    var char = list[i];
	                    if (charInRTLScript(char.charCodeAt(0))) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function isStringInSupportedScript(chars, canRenderRTL) {
	                  for (var i = 0, list = chars; i < list.length; i += 1) {
	                    var char = list[i];
	                    if (!charInSupportedScript(char.charCodeAt(0), canRenderRTL)) {
	                      return false;
	                    }
	                  }
	                  return true;
	                }
	                var status = {
	                  unavailable: "unavailable",
	                  deferred: "deferred",
	                  loading: "loading",
	                  loaded: "loaded",
	                  error: "error"
	                };
	                var _completionCallback = null;
	                var pluginStatus = status.unavailable;
	                var pluginURL = null;
	                var triggerPluginCompletionEvent = function(error2) {
	                  if (error2 && typeof error2 === "string" && error2.indexOf("NetworkError") > -1) {
	                    pluginStatus = status.error;
	                  }
	                  if (_completionCallback) {
	                    _completionCallback(error2);
	                  }
	                };
	                function sendPluginStateToWorker() {
	                  evented.fire(new Event("pluginStateChange", {
	                    pluginStatus,
	                    pluginURL
	                  }));
	                }
	                var evented = new Evented();
	                var getRTLTextPluginStatus = function() {
	                  return pluginStatus;
	                };
	                var registerForPluginStateChange = function(callback) {
	                  callback({
	                    pluginStatus,
	                    pluginURL
	                  });
	                  evented.on("pluginStateChange", callback);
	                  return callback;
	                };
	                var setRTLTextPlugin = function(url, callback, deferred) {
	                  if (deferred === undefined)
	                    deferred = false;
	                  if (pluginStatus === status.deferred || pluginStatus === status.loading || pluginStatus === status.loaded) {
	                    throw new Error("setRTLTextPlugin cannot be called multiple times.");
	                  }
	                  pluginURL = exported.resolveURL(url);
	                  pluginStatus = status.deferred;
	                  _completionCallback = callback;
	                  sendPluginStateToWorker();
	                  if (!deferred) {
	                    downloadRTLTextPlugin();
	                  }
	                };
	                var downloadRTLTextPlugin = function() {
	                  if (pluginStatus !== status.deferred || !pluginURL) {
	                    throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
	                  }
	                  pluginStatus = status.loading;
	                  sendPluginStateToWorker();
	                  if (pluginURL) {
	                    getArrayBuffer({ url: pluginURL }, function(error2) {
	                      if (error2) {
	                        triggerPluginCompletionEvent(error2);
	                      } else {
	                        pluginStatus = status.loaded;
	                        sendPluginStateToWorker();
	                      }
	                    });
	                  }
	                };
	                var plugin = {
	                  applyArabicShaping: null,
	                  processBidirectionalText: null,
	                  processStyledBidirectionalText: null,
	                  isLoaded: function isLoaded() {
	                    return pluginStatus === status.loaded || plugin.applyArabicShaping != null;
	                  },
	                  isLoading: function isLoading() {
	                    return pluginStatus === status.loading;
	                  },
	                  setState: function setState(state) {
	                    pluginStatus = state.pluginStatus;
	                    pluginURL = state.pluginURL;
	                  },
	                  isParsed: function isParsed() {
	                    return plugin.applyArabicShaping != null && plugin.processBidirectionalText != null && plugin.processStyledBidirectionalText != null;
	                  },
	                  getPluginURL: function getPluginURL() {
	                    return pluginURL;
	                  }
	                };
	                var lazyLoadRTLTextPlugin = function() {
	                  if (!plugin.isLoading() && !plugin.isLoaded() && getRTLTextPluginStatus() === "deferred") {
	                    downloadRTLTextPlugin();
	                  }
	                };
	                var EvaluationParameters = function EvaluationParameters2(zoom, options) {
	                  this.zoom = zoom;
	                  if (options) {
	                    this.now = options.now;
	                    this.fadeDuration = options.fadeDuration;
	                    this.zoomHistory = options.zoomHistory;
	                    this.transition = options.transition;
	                  } else {
	                    this.now = 0;
	                    this.fadeDuration = 0;
	                    this.zoomHistory = new ZoomHistory();
	                    this.transition = {};
	                  }
	                };
	                EvaluationParameters.prototype.isSupportedScript = function isSupportedScript(str) {
	                  return isStringInSupportedScript(str, plugin.isLoaded());
	                };
	                EvaluationParameters.prototype.crossFadingFactor = function crossFadingFactor() {
	                  if (this.fadeDuration === 0) {
	                    return 1;
	                  } else {
	                    return Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
	                  }
	                };
	                EvaluationParameters.prototype.getCrossfadeParameters = function getCrossfadeParameters() {
	                  var z = this.zoom;
	                  var fraction = z - Math.floor(z);
	                  var t = this.crossFadingFactor();
	                  return z > this.zoomHistory.lastIntegerZoom ? {
	                    fromScale: 2,
	                    toScale: 1,
	                    t: fraction + (1 - fraction) * t
	                  } : {
	                    fromScale: 0.5,
	                    toScale: 1,
	                    t: 1 - (1 - t) * fraction
	                  };
	                };
	                var PropertyValue = function PropertyValue2(property, value) {
	                  this.property = property;
	                  this.value = value;
	                  this.expression = normalizePropertyExpression(value === undefined ? property.specification.default : value, property.specification);
	                };
	                PropertyValue.prototype.isDataDriven = function isDataDriven() {
	                  return this.expression.kind === "source" || this.expression.kind === "composite";
	                };
	                PropertyValue.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
	                  return this.property.possiblyEvaluate(this, parameters, canonical, availableImages);
	                };
	                var TransitionablePropertyValue = function TransitionablePropertyValue2(property) {
	                  this.property = property;
	                  this.value = new PropertyValue(property, undefined);
	                };
	                TransitionablePropertyValue.prototype.transitioned = function transitioned(parameters, prior) {
	                  return new TransitioningPropertyValue(this.property, this.value, prior, extend({}, parameters.transition, this.transition), parameters.now);
	                };
	                TransitionablePropertyValue.prototype.untransitioned = function untransitioned() {
	                  return new TransitioningPropertyValue(this.property, this.value, null, {}, 0);
	                };
	                var Transitionable = function Transitionable2(properties2) {
	                  this._properties = properties2;
	                  this._values = Object.create(properties2.defaultTransitionablePropertyValues);
	                };
	                Transitionable.prototype.getValue = function getValue(name3) {
	                  return clone(this._values[name3].value.value);
	                };
	                Transitionable.prototype.setValue = function setValue(name3, value) {
	                  if (!this._values.hasOwnProperty(name3)) {
	                    this._values[name3] = new TransitionablePropertyValue(this._values[name3].property);
	                  }
	                  this._values[name3].value = new PropertyValue(this._values[name3].property, value === null ? undefined : clone(value));
	                };
	                Transitionable.prototype.getTransition = function getTransition(name3) {
	                  return clone(this._values[name3].transition);
	                };
	                Transitionable.prototype.setTransition = function setTransition(name3, value) {
	                  if (!this._values.hasOwnProperty(name3)) {
	                    this._values[name3] = new TransitionablePropertyValue(this._values[name3].property);
	                  }
	                  this._values[name3].transition = clone(value) || undefined;
	                };
	                Transitionable.prototype.serialize = function serialize2() {
	                  var result = {};
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    var value = this.getValue(property);
	                    if (value !== undefined) {
	                      result[property] = value;
	                    }
	                    var transition2 = this.getTransition(property);
	                    if (transition2 !== undefined) {
	                      result[property + "-transition"] = transition2;
	                    }
	                  }
	                  return result;
	                };
	                Transitionable.prototype.transitioned = function transitioned(parameters, prior) {
	                  var result = new Transitioning(this._properties);
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    result._values[property] = this._values[property].transitioned(parameters, prior._values[property]);
	                  }
	                  return result;
	                };
	                Transitionable.prototype.untransitioned = function untransitioned() {
	                  var result = new Transitioning(this._properties);
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    result._values[property] = this._values[property].untransitioned();
	                  }
	                  return result;
	                };
	                var TransitioningPropertyValue = function TransitioningPropertyValue2(property, value, prior, transition2, now2) {
	                  this.property = property;
	                  this.value = value;
	                  this.begin = now2 + transition2.delay || 0;
	                  this.end = this.begin + transition2.duration || 0;
	                  if (property.specification.transition && (transition2.delay || transition2.duration)) {
	                    this.prior = prior;
	                  }
	                };
	                TransitioningPropertyValue.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
	                  var now2 = parameters.now || 0;
	                  var finalValue = this.value.possiblyEvaluate(parameters, canonical, availableImages);
	                  var prior = this.prior;
	                  if (!prior) {
	                    return finalValue;
	                  } else if (now2 > this.end) {
	                    this.prior = null;
	                    return finalValue;
	                  } else if (this.value.isDataDriven()) {
	                    this.prior = null;
	                    return finalValue;
	                  } else if (now2 < this.begin) {
	                    return prior.possiblyEvaluate(parameters, canonical, availableImages);
	                  } else {
	                    var t = (now2 - this.begin) / (this.end - this.begin);
	                    return this.property.interpolate(prior.possiblyEvaluate(parameters, canonical, availableImages), finalValue, easeCubicInOut(t));
	                  }
	                };
	                var Transitioning = function Transitioning2(properties2) {
	                  this._properties = properties2;
	                  this._values = Object.create(properties2.defaultTransitioningPropertyValues);
	                };
	                Transitioning.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
	                  var result = new PossiblyEvaluated(this._properties);
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    result._values[property] = this._values[property].possiblyEvaluate(parameters, canonical, availableImages);
	                  }
	                  return result;
	                };
	                Transitioning.prototype.hasTransition = function hasTransition() {
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    if (this._values[property].prior) {
	                      return true;
	                    }
	                  }
	                  return false;
	                };
	                var Layout = function Layout2(properties2) {
	                  this._properties = properties2;
	                  this._values = Object.create(properties2.defaultPropertyValues);
	                };
	                Layout.prototype.getValue = function getValue(name3) {
	                  return clone(this._values[name3].value);
	                };
	                Layout.prototype.setValue = function setValue(name3, value) {
	                  this._values[name3] = new PropertyValue(this._values[name3].property, value === null ? undefined : clone(value));
	                };
	                Layout.prototype.serialize = function serialize2() {
	                  var result = {};
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    var value = this.getValue(property);
	                    if (value !== undefined) {
	                      result[property] = value;
	                    }
	                  }
	                  return result;
	                };
	                Layout.prototype.possiblyEvaluate = function possiblyEvaluate(parameters, canonical, availableImages) {
	                  var result = new PossiblyEvaluated(this._properties);
	                  for (var i = 0, list = Object.keys(this._values); i < list.length; i += 1) {
	                    var property = list[i];
	                    result._values[property] = this._values[property].possiblyEvaluate(parameters, canonical, availableImages);
	                  }
	                  return result;
	                };
	                var PossiblyEvaluatedPropertyValue = function PossiblyEvaluatedPropertyValue2(property, value, parameters) {
	                  this.property = property;
	                  this.value = value;
	                  this.parameters = parameters;
	                };
	                PossiblyEvaluatedPropertyValue.prototype.isConstant = function isConstant2() {
	                  return this.value.kind === "constant";
	                };
	                PossiblyEvaluatedPropertyValue.prototype.constantOr = function constantOr(value) {
	                  if (this.value.kind === "constant") {
	                    return this.value.value;
	                  } else {
	                    return value;
	                  }
	                };
	                PossiblyEvaluatedPropertyValue.prototype.evaluate = function evaluate(feature, featureState, canonical, availableImages) {
	                  return this.property.evaluate(this.value, this.parameters, feature, featureState, canonical, availableImages);
	                };
	                var PossiblyEvaluated = function PossiblyEvaluated2(properties2) {
	                  this._properties = properties2;
	                  this._values = Object.create(properties2.defaultPossiblyEvaluatedValues);
	                };
	                PossiblyEvaluated.prototype.get = function get2(name3) {
	                  return this._values[name3];
	                };
	                var DataConstantProperty = function DataConstantProperty2(specification) {
	                  this.specification = specification;
	                };
	                DataConstantProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters) {
	                  return value.expression.evaluate(parameters);
	                };
	                DataConstantProperty.prototype.interpolate = function interpolate$1(a, b, t) {
	                  var interp = interpolate[this.specification.type];
	                  if (interp) {
	                    return interp(a, b, t);
	                  } else {
	                    return a;
	                  }
	                };
	                var DataDrivenProperty = function DataDrivenProperty2(specification, overrides) {
	                  this.specification = specification;
	                  this.overrides = overrides;
	                };
	                DataDrivenProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
	                  if (value.expression.kind === "constant" || value.expression.kind === "camera") {
	                    return new PossiblyEvaluatedPropertyValue(this, {
	                      kind: "constant",
	                      value: value.expression.evaluate(parameters, null, {}, canonical, availableImages)
	                    }, parameters);
	                  } else {
	                    return new PossiblyEvaluatedPropertyValue(this, value.expression, parameters);
	                  }
	                };
	                DataDrivenProperty.prototype.interpolate = function interpolate$2(a, b, t) {
	                  if (a.value.kind !== "constant" || b.value.kind !== "constant") {
	                    return a;
	                  }
	                  if (a.value.value === undefined || b.value.value === undefined) {
	                    return new PossiblyEvaluatedPropertyValue(this, {
	                      kind: "constant",
	                      value: undefined
	                    }, a.parameters);
	                  }
	                  var interp = interpolate[this.specification.type];
	                  if (interp) {
	                    return new PossiblyEvaluatedPropertyValue(this, {
	                      kind: "constant",
	                      value: interp(a.value.value, b.value.value, t)
	                    }, a.parameters);
	                  } else {
	                    return a;
	                  }
	                };
	                DataDrivenProperty.prototype.evaluate = function evaluate(value, parameters, feature, featureState, canonical, availableImages) {
	                  if (value.kind === "constant") {
	                    return value.value;
	                  } else {
	                    return value.evaluate(parameters, feature, featureState, canonical, availableImages);
	                  }
	                };
	                var CrossFadedDataDrivenProperty = function(DataDrivenProperty2) {
	                  function CrossFadedDataDrivenProperty2() {
	                    DataDrivenProperty2.apply(this, arguments);
	                  }
	                  CrossFadedDataDrivenProperty2.__proto__ = DataDrivenProperty2;
	                  CrossFadedDataDrivenProperty2.prototype = Object.create(DataDrivenProperty2.prototype);
	                  CrossFadedDataDrivenProperty2.prototype.constructor = CrossFadedDataDrivenProperty2;
	                  CrossFadedDataDrivenProperty2.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
	                    if (value.value === undefined) {
	                      return new PossiblyEvaluatedPropertyValue(this, {
	                        kind: "constant",
	                        value: undefined
	                      }, parameters);
	                    } else if (value.expression.kind === "constant") {
	                      var evaluatedValue = value.expression.evaluate(parameters, null, {}, canonical, availableImages);
	                      var isImageExpression = value.property.specification.type === "resolvedImage";
	                      var constantValue = isImageExpression && typeof evaluatedValue !== "string" ? evaluatedValue.name : evaluatedValue;
	                      var constant2 = this._calculate(constantValue, constantValue, constantValue, parameters);
	                      return new PossiblyEvaluatedPropertyValue(this, {
	                        kind: "constant",
	                        value: constant2
	                      }, parameters);
	                    } else if (value.expression.kind === "camera") {
	                      var cameraVal = this._calculate(value.expression.evaluate({ zoom: parameters.zoom - 1 }), value.expression.evaluate({ zoom: parameters.zoom }), value.expression.evaluate({ zoom: parameters.zoom + 1 }), parameters);
	                      return new PossiblyEvaluatedPropertyValue(this, {
	                        kind: "constant",
	                        value: cameraVal
	                      }, parameters);
	                    } else {
	                      return new PossiblyEvaluatedPropertyValue(this, value.expression, parameters);
	                    }
	                  };
	                  CrossFadedDataDrivenProperty2.prototype.evaluate = function evaluate(value, globals, feature, featureState, canonical, availableImages) {
	                    if (value.kind === "source") {
	                      var constant2 = value.evaluate(globals, feature, featureState, canonical, availableImages);
	                      return this._calculate(constant2, constant2, constant2, globals);
	                    } else if (value.kind === "composite") {
	                      return this._calculate(value.evaluate({ zoom: Math.floor(globals.zoom) - 1 }, feature, featureState), value.evaluate({ zoom: Math.floor(globals.zoom) }, feature, featureState), value.evaluate({ zoom: Math.floor(globals.zoom) + 1 }, feature, featureState), globals);
	                    } else {
	                      return value.value;
	                    }
	                  };
	                  CrossFadedDataDrivenProperty2.prototype._calculate = function _calculate(min, mid, max, parameters) {
	                    var z = parameters.zoom;
	                    return z > parameters.zoomHistory.lastIntegerZoom ? {
	                      from: min,
	                      to: mid
	                    } : {
	                      from: max,
	                      to: mid
	                    };
	                  };
	                  CrossFadedDataDrivenProperty2.prototype.interpolate = function interpolate2(a) {
	                    return a;
	                  };
	                  return CrossFadedDataDrivenProperty2;
	                }(DataDrivenProperty);
	                var CrossFadedProperty = function CrossFadedProperty2(specification) {
	                  this.specification = specification;
	                };
	                CrossFadedProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
	                  if (value.value === undefined) {
	                    return undefined;
	                  } else if (value.expression.kind === "constant") {
	                    var constant2 = value.expression.evaluate(parameters, null, {}, canonical, availableImages);
	                    return this._calculate(constant2, constant2, constant2, parameters);
	                  } else {
	                    return this._calculate(value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom - 1), parameters)), value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom), parameters)), value.expression.evaluate(new EvaluationParameters(Math.floor(parameters.zoom + 1), parameters)), parameters);
	                  }
	                };
	                CrossFadedProperty.prototype._calculate = function _calculate(min, mid, max, parameters) {
	                  var z = parameters.zoom;
	                  return z > parameters.zoomHistory.lastIntegerZoom ? {
	                    from: min,
	                    to: mid
	                  } : {
	                    from: max,
	                    to: mid
	                  };
	                };
	                CrossFadedProperty.prototype.interpolate = function interpolate2(a) {
	                  return a;
	                };
	                var ColorRampProperty = function ColorRampProperty2(specification) {
	                  this.specification = specification;
	                };
	                ColorRampProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters, canonical, availableImages) {
	                  return !!value.expression.evaluate(parameters, null, {}, canonical, availableImages);
	                };
	                ColorRampProperty.prototype.interpolate = function interpolate2() {
	                  return false;
	                };
	                var Properties = function Properties2(properties2) {
	                  this.properties = properties2;
	                  this.defaultPropertyValues = {};
	                  this.defaultTransitionablePropertyValues = {};
	                  this.defaultTransitioningPropertyValues = {};
	                  this.defaultPossiblyEvaluatedValues = {};
	                  this.overridableProperties = [];
	                  for (var property in properties2) {
	                    var prop = properties2[property];
	                    if (prop.specification.overridable) {
	                      this.overridableProperties.push(property);
	                    }
	                    var defaultPropertyValue = this.defaultPropertyValues[property] = new PropertyValue(prop, undefined);
	                    var defaultTransitionablePropertyValue = this.defaultTransitionablePropertyValues[property] = new TransitionablePropertyValue(prop);
	                    this.defaultTransitioningPropertyValues[property] = defaultTransitionablePropertyValue.untransitioned();
	                    this.defaultPossiblyEvaluatedValues[property] = defaultPropertyValue.possiblyEvaluate({});
	                  }
	                };
	                register("DataDrivenProperty", DataDrivenProperty);
	                register("DataConstantProperty", DataConstantProperty);
	                register("CrossFadedDataDrivenProperty", CrossFadedDataDrivenProperty);
	                register("CrossFadedProperty", CrossFadedProperty);
	                register("ColorRampProperty", ColorRampProperty);
	                var TRANSITION_SUFFIX = "-transition";
	                var StyleLayer = function(Evented2) {
	                  function StyleLayer2(layer2, properties2) {
	                    Evented2.call(this);
	                    this.id = layer2.id;
	                    this.type = layer2.type;
	                    this._featureFilter = {
	                      filter: function() {
	                        return true;
	                      },
	                      needGeometry: false
	                    };
	                    if (layer2.type === "custom") {
	                      return;
	                    }
	                    layer2 = layer2;
	                    this.metadata = layer2.metadata;
	                    this.minzoom = layer2.minzoom;
	                    this.maxzoom = layer2.maxzoom;
	                    if (layer2.type !== "background") {
	                      this.source = layer2.source;
	                      this.sourceLayer = layer2["source-layer"];
	                      this.filter = layer2.filter;
	                    }
	                    if (properties2.layout) {
	                      this._unevaluatedLayout = new Layout(properties2.layout);
	                    }
	                    if (properties2.paint) {
	                      this._transitionablePaint = new Transitionable(properties2.paint);
	                      for (var property in layer2.paint) {
	                        this.setPaintProperty(property, layer2.paint[property], { validate: false });
	                      }
	                      for (var property$1 in layer2.layout) {
	                        this.setLayoutProperty(property$1, layer2.layout[property$1], { validate: false });
	                      }
	                      this._transitioningPaint = this._transitionablePaint.untransitioned();
	                      this.paint = new PossiblyEvaluated(properties2.paint);
	                    }
	                  }
	                  StyleLayer2.__proto__ = Evented2;
	                  StyleLayer2.prototype = Object.create(Evented2.prototype);
	                  StyleLayer2.prototype.constructor = StyleLayer2;
	                  StyleLayer2.prototype.getCrossfadeParameters = function getCrossfadeParameters() {
	                    return this._crossfadeParameters;
	                  };
	                  StyleLayer2.prototype.getLayoutProperty = function getLayoutProperty(name3) {
	                    if (name3 === "visibility") {
	                      return this.visibility;
	                    }
	                    return this._unevaluatedLayout.getValue(name3);
	                  };
	                  StyleLayer2.prototype.setLayoutProperty = function setLayoutProperty(name3, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    if (value !== null && value !== undefined) {
	                      var key = "layers." + this.id + ".layout." + name3;
	                      if (this._validate(validateLayoutProperty$1, key, name3, value, options)) {
	                        return;
	                      }
	                    }
	                    if (name3 === "visibility") {
	                      this.visibility = value;
	                      return;
	                    }
	                    this._unevaluatedLayout.setValue(name3, value);
	                  };
	                  StyleLayer2.prototype.getPaintProperty = function getPaintProperty(name3) {
	                    if (endsWith(name3, TRANSITION_SUFFIX)) {
	                      return this._transitionablePaint.getTransition(name3.slice(0, -TRANSITION_SUFFIX.length));
	                    } else {
	                      return this._transitionablePaint.getValue(name3);
	                    }
	                  };
	                  StyleLayer2.prototype.setPaintProperty = function setPaintProperty(name3, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    if (value !== null && value !== undefined) {
	                      var key = "layers." + this.id + ".paint." + name3;
	                      if (this._validate(validatePaintProperty$1, key, name3, value, options)) {
	                        return false;
	                      }
	                    }
	                    if (endsWith(name3, TRANSITION_SUFFIX)) {
	                      this._transitionablePaint.setTransition(name3.slice(0, -TRANSITION_SUFFIX.length), value || undefined);
	                      return false;
	                    } else {
	                      var transitionable = this._transitionablePaint._values[name3];
	                      var isCrossFadedProperty = transitionable.property.specification["property-type"] === "cross-faded-data-driven";
	                      var wasDataDriven = transitionable.value.isDataDriven();
	                      var oldValue = transitionable.value;
	                      this._transitionablePaint.setValue(name3, value);
	                      this._handleSpecialPaintPropertyUpdate(name3);
	                      var newValue = this._transitionablePaint._values[name3].value;
	                      var isDataDriven = newValue.isDataDriven();
	                      return isDataDriven || wasDataDriven || isCrossFadedProperty || this._handleOverridablePaintPropertyUpdate(name3, oldValue, newValue);
	                    }
	                  };
	                  StyleLayer2.prototype._handleSpecialPaintPropertyUpdate = function _handleSpecialPaintPropertyUpdate(_) {
	                  };
	                  StyleLayer2.prototype._handleOverridablePaintPropertyUpdate = function _handleOverridablePaintPropertyUpdate(name3, oldValue, newValue) {
	                    return false;
	                  };
	                  StyleLayer2.prototype.isHidden = function isHidden(zoom) {
	                    if (this.minzoom && zoom < this.minzoom) {
	                      return true;
	                    }
	                    if (this.maxzoom && zoom >= this.maxzoom) {
	                      return true;
	                    }
	                    return this.visibility === "none";
	                  };
	                  StyleLayer2.prototype.updateTransitions = function updateTransitions(parameters) {
	                    this._transitioningPaint = this._transitionablePaint.transitioned(parameters, this._transitioningPaint);
	                  };
	                  StyleLayer2.prototype.hasTransition = function hasTransition() {
	                    return this._transitioningPaint.hasTransition();
	                  };
	                  StyleLayer2.prototype.recalculate = function recalculate(parameters, availableImages) {
	                    if (parameters.getCrossfadeParameters) {
	                      this._crossfadeParameters = parameters.getCrossfadeParameters();
	                    }
	                    if (this._unevaluatedLayout) {
	                      this.layout = this._unevaluatedLayout.possiblyEvaluate(parameters, undefined, availableImages);
	                    }
	                    this.paint = this._transitioningPaint.possiblyEvaluate(parameters, undefined, availableImages);
	                  };
	                  StyleLayer2.prototype.serialize = function serialize2() {
	                    var output = {
	                      "id": this.id,
	                      "type": this.type,
	                      "source": this.source,
	                      "source-layer": this.sourceLayer,
	                      "metadata": this.metadata,
	                      "minzoom": this.minzoom,
	                      "maxzoom": this.maxzoom,
	                      "filter": this.filter,
	                      "layout": this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
	                      "paint": this._transitionablePaint && this._transitionablePaint.serialize()
	                    };
	                    if (this.visibility) {
	                      output.layout = output.layout || {};
	                      output.layout.visibility = this.visibility;
	                    }
	                    return filterObject(output, function(value, key) {
	                      return value !== undefined && !(key === "layout" && !Object.keys(value).length) && !(key === "paint" && !Object.keys(value).length);
	                    });
	                  };
	                  StyleLayer2.prototype._validate = function _validate(validate2, key, name3, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    if (options && options.validate === false) {
	                      return false;
	                    }
	                    return emitValidationErrors(this, validate2.call(validateStyle, {
	                      key,
	                      layerType: this.type,
	                      objectKey: name3,
	                      value,
	                      styleSpec: spec,
	                      style: {
	                        glyphs: true,
	                        sprite: true
	                      }
	                    }));
	                  };
	                  StyleLayer2.prototype.is3D = function is3D() {
	                    return false;
	                  };
	                  StyleLayer2.prototype.isTileClipped = function isTileClipped() {
	                    return false;
	                  };
	                  StyleLayer2.prototype.hasOffscreenPass = function hasOffscreenPass() {
	                    return false;
	                  };
	                  StyleLayer2.prototype.resize = function resize() {
	                  };
	                  StyleLayer2.prototype.isStateDependent = function isStateDependent() {
	                    for (var property in this.paint._values) {
	                      var value = this.paint.get(property);
	                      if (!(value instanceof PossiblyEvaluatedPropertyValue) || !supportsPropertyExpression(value.property.specification)) {
	                        continue;
	                      }
	                      if ((value.value.kind === "source" || value.value.kind === "composite") && value.value.isStateDependent) {
	                        return true;
	                      }
	                    }
	                    return false;
	                  };
	                  return StyleLayer2;
	                }(Evented);
	                var viewTypes = {
	                  "Int8": Int8Array,
	                  "Uint8": Uint8Array,
	                  "Int16": Int16Array,
	                  "Uint16": Uint16Array,
	                  "Int32": Int32Array,
	                  "Uint32": Uint32Array,
	                  "Float32": Float32Array
	                };
	                var Struct = function Struct2(structArray, index) {
	                  this._structArray = structArray;
	                  this._pos1 = index * this.size;
	                  this._pos2 = this._pos1 / 2;
	                  this._pos4 = this._pos1 / 4;
	                  this._pos8 = this._pos1 / 8;
	                };
	                var DEFAULT_CAPACITY = 128;
	                var RESIZE_MULTIPLIER = 5;
	                var StructArray = function StructArray2() {
	                  this.isTransferred = false;
	                  this.capacity = -1;
	                  this.resize(0);
	                };
	                StructArray.serialize = function serialize2(array2, transferables) {
	                  array2._trim();
	                  if (transferables) {
	                    array2.isTransferred = true;
	                    transferables.push(array2.arrayBuffer);
	                  }
	                  return {
	                    length: array2.length,
	                    arrayBuffer: array2.arrayBuffer
	                  };
	                };
	                StructArray.deserialize = function deserialize2(input) {
	                  var structArray = Object.create(this.prototype);
	                  structArray.arrayBuffer = input.arrayBuffer;
	                  structArray.length = input.length;
	                  structArray.capacity = input.arrayBuffer.byteLength / structArray.bytesPerElement;
	                  structArray._refreshViews();
	                  return structArray;
	                };
	                StructArray.prototype._trim = function _trim() {
	                  if (this.length !== this.capacity) {
	                    this.capacity = this.length;
	                    this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement);
	                    this._refreshViews();
	                  }
	                };
	                StructArray.prototype.clear = function clear() {
	                  this.length = 0;
	                };
	                StructArray.prototype.resize = function resize(n) {
	                  this.reserve(n);
	                  this.length = n;
	                };
	                StructArray.prototype.reserve = function reserve(n) {
	                  if (n > this.capacity) {
	                    this.capacity = Math.max(n, Math.floor(this.capacity * RESIZE_MULTIPLIER), DEFAULT_CAPACITY);
	                    this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
	                    var oldUint8Array = this.uint8;
	                    this._refreshViews();
	                    if (oldUint8Array) {
	                      this.uint8.set(oldUint8Array);
	                    }
	                  }
	                };
	                StructArray.prototype._refreshViews = function _refreshViews() {
	                  throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
	                };
	                function createLayout(members2, alignment) {
	                  if (alignment === undefined)
	                    alignment = 1;
	                  var offset = 0;
	                  var maxSize = 0;
	                  var layoutMembers = members2.map(function(member) {
	                    var typeSize = sizeOf(member.type);
	                    var memberOffset = offset = align(offset, Math.max(alignment, typeSize));
	                    var components = member.components || 1;
	                    maxSize = Math.max(maxSize, typeSize);
	                    offset += typeSize * components;
	                    return {
	                      name: member.name,
	                      type: member.type,
	                      components,
	                      offset: memberOffset
	                    };
	                  });
	                  var size = align(offset, Math.max(maxSize, alignment));
	                  return {
	                    members: layoutMembers,
	                    size,
	                    alignment
	                  };
	                }
	                function sizeOf(type) {
	                  return viewTypes[type].BYTES_PER_ELEMENT;
	                }
	                function align(offset, size) {
	                  return Math.ceil(offset / size) * size;
	                }
	                var StructArrayLayout2i4 = function(StructArray2) {
	                  function StructArrayLayout2i42() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2i42.__proto__ = StructArray2;
	                  StructArrayLayout2i42.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2i42.prototype.constructor = StructArrayLayout2i42;
	                  StructArrayLayout2i42.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2i42.prototype.emplaceBack = function emplaceBack(v0, v1) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1);
	                  };
	                  StructArrayLayout2i42.prototype.emplace = function emplace(i, v0, v1) {
	                    var o2 = i * 2;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    return i;
	                  };
	                  return StructArrayLayout2i42;
	                }(StructArray);
	                StructArrayLayout2i4.prototype.bytesPerElement = 4;
	                register("StructArrayLayout2i4", StructArrayLayout2i4);
	                var StructArrayLayout4i8 = function(StructArray2) {
	                  function StructArrayLayout4i82() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout4i82.__proto__ = StructArray2;
	                  StructArrayLayout4i82.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout4i82.prototype.constructor = StructArrayLayout4i82;
	                  StructArrayLayout4i82.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout4i82.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3);
	                  };
	                  StructArrayLayout4i82.prototype.emplace = function emplace(i, v0, v1, v2, v3) {
	                    var o2 = i * 4;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    this.int16[o2 + 3] = v3;
	                    return i;
	                  };
	                  return StructArrayLayout4i82;
	                }(StructArray);
	                StructArrayLayout4i8.prototype.bytesPerElement = 8;
	                register("StructArrayLayout4i8", StructArrayLayout4i8);
	                var StructArrayLayout2i4i12 = function(StructArray2) {
	                  function StructArrayLayout2i4i122() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2i4i122.__proto__ = StructArray2;
	                  StructArrayLayout2i4i122.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2i4i122.prototype.constructor = StructArrayLayout2i4i122;
	                  StructArrayLayout2i4i122.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2i4i122.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5);
	                  };
	                  StructArrayLayout2i4i122.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5) {
	                    var o2 = i * 6;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    this.int16[o2 + 3] = v3;
	                    this.int16[o2 + 4] = v4;
	                    this.int16[o2 + 5] = v5;
	                    return i;
	                  };
	                  return StructArrayLayout2i4i122;
	                }(StructArray);
	                StructArrayLayout2i4i12.prototype.bytesPerElement = 12;
	                register("StructArrayLayout2i4i12", StructArrayLayout2i4i12);
	                var StructArrayLayout2i4ub8 = function(StructArray2) {
	                  function StructArrayLayout2i4ub82() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2i4ub82.__proto__ = StructArray2;
	                  StructArrayLayout2i4ub82.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2i4ub82.prototype.constructor = StructArrayLayout2i4ub82;
	                  StructArrayLayout2i4ub82.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2i4ub82.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5);
	                  };
	                  StructArrayLayout2i4ub82.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5) {
	                    var o2 = i * 4;
	                    var o1 = i * 8;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.uint8[o1 + 4] = v2;
	                    this.uint8[o1 + 5] = v3;
	                    this.uint8[o1 + 6] = v4;
	                    this.uint8[o1 + 7] = v5;
	                    return i;
	                  };
	                  return StructArrayLayout2i4ub82;
	                }(StructArray);
	                StructArrayLayout2i4ub8.prototype.bytesPerElement = 8;
	                register("StructArrayLayout2i4ub8", StructArrayLayout2i4ub8);
	                var StructArrayLayout8ui2ub18 = function(StructArray2) {
	                  function StructArrayLayout8ui2ub182() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout8ui2ub182.__proto__ = StructArray2;
	                  StructArrayLayout8ui2ub182.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout8ui2ub182.prototype.constructor = StructArrayLayout8ui2ub182;
	                  StructArrayLayout8ui2ub182.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout8ui2ub182.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
	                  };
	                  StructArrayLayout8ui2ub182.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
	                    var o2 = i * 9;
	                    var o1 = i * 18;
	                    this.uint16[o2 + 0] = v0;
	                    this.uint16[o2 + 1] = v1;
	                    this.uint16[o2 + 2] = v2;
	                    this.uint16[o2 + 3] = v3;
	                    this.uint16[o2 + 4] = v4;
	                    this.uint16[o2 + 5] = v5;
	                    this.uint16[o2 + 6] = v6;
	                    this.uint16[o2 + 7] = v7;
	                    this.uint8[o1 + 16] = v8;
	                    this.uint8[o1 + 17] = v9;
	                    return i;
	                  };
	                  return StructArrayLayout8ui2ub182;
	                }(StructArray);
	                StructArrayLayout8ui2ub18.prototype.bytesPerElement = 18;
	                register("StructArrayLayout8ui2ub18", StructArrayLayout8ui2ub18);
	                var StructArrayLayout4i4ui4i24 = function(StructArray2) {
	                  function StructArrayLayout4i4ui4i242() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout4i4ui4i242.__proto__ = StructArray2;
	                  StructArrayLayout4i4ui4i242.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout4i4ui4i242.prototype.constructor = StructArrayLayout4i4ui4i242;
	                  StructArrayLayout4i4ui4i242.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout4i4ui4i242.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11);
	                  };
	                  StructArrayLayout4i4ui4i242.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11) {
	                    var o2 = i * 12;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    this.int16[o2 + 3] = v3;
	                    this.uint16[o2 + 4] = v4;
	                    this.uint16[o2 + 5] = v5;
	                    this.uint16[o2 + 6] = v6;
	                    this.uint16[o2 + 7] = v7;
	                    this.int16[o2 + 8] = v8;
	                    this.int16[o2 + 9] = v9;
	                    this.int16[o2 + 10] = v10;
	                    this.int16[o2 + 11] = v11;
	                    return i;
	                  };
	                  return StructArrayLayout4i4ui4i242;
	                }(StructArray);
	                StructArrayLayout4i4ui4i24.prototype.bytesPerElement = 24;
	                register("StructArrayLayout4i4ui4i24", StructArrayLayout4i4ui4i24);
	                var StructArrayLayout3f12 = function(StructArray2) {
	                  function StructArrayLayout3f122() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout3f122.__proto__ = StructArray2;
	                  StructArrayLayout3f122.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout3f122.prototype.constructor = StructArrayLayout3f122;
	                  StructArrayLayout3f122.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout3f122.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2);
	                  };
	                  StructArrayLayout3f122.prototype.emplace = function emplace(i, v0, v1, v2) {
	                    var o4 = i * 3;
	                    this.float32[o4 + 0] = v0;
	                    this.float32[o4 + 1] = v1;
	                    this.float32[o4 + 2] = v2;
	                    return i;
	                  };
	                  return StructArrayLayout3f122;
	                }(StructArray);
	                StructArrayLayout3f12.prototype.bytesPerElement = 12;
	                register("StructArrayLayout3f12", StructArrayLayout3f12);
	                var StructArrayLayout1ul4 = function(StructArray2) {
	                  function StructArrayLayout1ul42() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout1ul42.__proto__ = StructArray2;
	                  StructArrayLayout1ul42.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout1ul42.prototype.constructor = StructArrayLayout1ul42;
	                  StructArrayLayout1ul42.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.uint32 = new Uint32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout1ul42.prototype.emplaceBack = function emplaceBack(v0) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0);
	                  };
	                  StructArrayLayout1ul42.prototype.emplace = function emplace(i, v0) {
	                    var o4 = i * 1;
	                    this.uint32[o4 + 0] = v0;
	                    return i;
	                  };
	                  return StructArrayLayout1ul42;
	                }(StructArray);
	                StructArrayLayout1ul4.prototype.bytesPerElement = 4;
	                register("StructArrayLayout1ul4", StructArrayLayout1ul4);
	                var StructArrayLayout6i1ul2ui20 = function(StructArray2) {
	                  function StructArrayLayout6i1ul2ui202() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout6i1ul2ui202.__proto__ = StructArray2;
	                  StructArrayLayout6i1ul2ui202.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout6i1ul2ui202.prototype.constructor = StructArrayLayout6i1ul2ui202;
	                  StructArrayLayout6i1ul2ui202.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                    this.uint32 = new Uint32Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout6i1ul2ui202.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8);
	                  };
	                  StructArrayLayout6i1ul2ui202.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8) {
	                    var o2 = i * 10;
	                    var o4 = i * 5;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    this.int16[o2 + 3] = v3;
	                    this.int16[o2 + 4] = v4;
	                    this.int16[o2 + 5] = v5;
	                    this.uint32[o4 + 3] = v6;
	                    this.uint16[o2 + 8] = v7;
	                    this.uint16[o2 + 9] = v8;
	                    return i;
	                  };
	                  return StructArrayLayout6i1ul2ui202;
	                }(StructArray);
	                StructArrayLayout6i1ul2ui20.prototype.bytesPerElement = 20;
	                register("StructArrayLayout6i1ul2ui20", StructArrayLayout6i1ul2ui20);
	                var StructArrayLayout2i2i2i12 = function(StructArray2) {
	                  function StructArrayLayout2i2i2i122() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2i2i2i122.__proto__ = StructArray2;
	                  StructArrayLayout2i2i2i122.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2i2i2i122.prototype.constructor = StructArrayLayout2i2i2i122;
	                  StructArrayLayout2i2i2i122.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2i2i2i122.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5);
	                  };
	                  StructArrayLayout2i2i2i122.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5) {
	                    var o2 = i * 6;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    this.int16[o2 + 3] = v3;
	                    this.int16[o2 + 4] = v4;
	                    this.int16[o2 + 5] = v5;
	                    return i;
	                  };
	                  return StructArrayLayout2i2i2i122;
	                }(StructArray);
	                StructArrayLayout2i2i2i12.prototype.bytesPerElement = 12;
	                register("StructArrayLayout2i2i2i12", StructArrayLayout2i2i2i12);
	                var StructArrayLayout2f1f2i16 = function(StructArray2) {
	                  function StructArrayLayout2f1f2i162() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2f1f2i162.__proto__ = StructArray2;
	                  StructArrayLayout2f1f2i162.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2f1f2i162.prototype.constructor = StructArrayLayout2f1f2i162;
	                  StructArrayLayout2f1f2i162.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2f1f2i162.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4);
	                  };
	                  StructArrayLayout2f1f2i162.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4) {
	                    var o4 = i * 4;
	                    var o2 = i * 8;
	                    this.float32[o4 + 0] = v0;
	                    this.float32[o4 + 1] = v1;
	                    this.float32[o4 + 2] = v2;
	                    this.int16[o2 + 6] = v3;
	                    this.int16[o2 + 7] = v4;
	                    return i;
	                  };
	                  return StructArrayLayout2f1f2i162;
	                }(StructArray);
	                StructArrayLayout2f1f2i16.prototype.bytesPerElement = 16;
	                register("StructArrayLayout2f1f2i16", StructArrayLayout2f1f2i16);
	                var StructArrayLayout2ub2f12 = function(StructArray2) {
	                  function StructArrayLayout2ub2f122() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2ub2f122.__proto__ = StructArray2;
	                  StructArrayLayout2ub2f122.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2ub2f122.prototype.constructor = StructArrayLayout2ub2f122;
	                  StructArrayLayout2ub2f122.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2ub2f122.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3);
	                  };
	                  StructArrayLayout2ub2f122.prototype.emplace = function emplace(i, v0, v1, v2, v3) {
	                    var o1 = i * 12;
	                    var o4 = i * 3;
	                    this.uint8[o1 + 0] = v0;
	                    this.uint8[o1 + 1] = v1;
	                    this.float32[o4 + 1] = v2;
	                    this.float32[o4 + 2] = v3;
	                    return i;
	                  };
	                  return StructArrayLayout2ub2f122;
	                }(StructArray);
	                StructArrayLayout2ub2f12.prototype.bytesPerElement = 12;
	                register("StructArrayLayout2ub2f12", StructArrayLayout2ub2f12);
	                var StructArrayLayout3ui6 = function(StructArray2) {
	                  function StructArrayLayout3ui62() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout3ui62.__proto__ = StructArray2;
	                  StructArrayLayout3ui62.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout3ui62.prototype.constructor = StructArrayLayout3ui62;
	                  StructArrayLayout3ui62.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout3ui62.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2);
	                  };
	                  StructArrayLayout3ui62.prototype.emplace = function emplace(i, v0, v1, v2) {
	                    var o2 = i * 3;
	                    this.uint16[o2 + 0] = v0;
	                    this.uint16[o2 + 1] = v1;
	                    this.uint16[o2 + 2] = v2;
	                    return i;
	                  };
	                  return StructArrayLayout3ui62;
	                }(StructArray);
	                StructArrayLayout3ui6.prototype.bytesPerElement = 6;
	                register("StructArrayLayout3ui6", StructArrayLayout3ui6);
	                var StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48 = function(StructArray2) {
	                  function StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.__proto__ = StructArray2;
	                  StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.prototype.constructor = StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482;
	                  StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                    this.uint32 = new Uint32Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16);
	                  };
	                  StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16) {
	                    var o2 = i * 24;
	                    var o4 = i * 12;
	                    var o1 = i * 48;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.uint16[o2 + 2] = v2;
	                    this.uint16[o2 + 3] = v3;
	                    this.uint32[o4 + 2] = v4;
	                    this.uint32[o4 + 3] = v5;
	                    this.uint32[o4 + 4] = v6;
	                    this.uint16[o2 + 10] = v7;
	                    this.uint16[o2 + 11] = v8;
	                    this.uint16[o2 + 12] = v9;
	                    this.float32[o4 + 7] = v10;
	                    this.float32[o4 + 8] = v11;
	                    this.uint8[o1 + 36] = v12;
	                    this.uint8[o1 + 37] = v13;
	                    this.uint8[o1 + 38] = v14;
	                    this.uint32[o4 + 10] = v15;
	                    this.int16[o2 + 22] = v16;
	                    return i;
	                  };
	                  return StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482;
	                }(StructArray);
	                StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48.prototype.bytesPerElement = 48;
	                register("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48);
	                var StructArrayLayout8i15ui1ul4f68 = function(StructArray2) {
	                  function StructArrayLayout8i15ui1ul4f682() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout8i15ui1ul4f682.__proto__ = StructArray2;
	                  StructArrayLayout8i15ui1ul4f682.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout8i15ui1ul4f682.prototype.constructor = StructArrayLayout8i15ui1ul4f682;
	                  StructArrayLayout8i15ui1ul4f682.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                    this.uint32 = new Uint32Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout8i15ui1ul4f682.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27);
	                  };
	                  StructArrayLayout8i15ui1ul4f682.prototype.emplace = function emplace(i, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21, v22, v23, v24, v25, v26, v27) {
	                    var o2 = i * 34;
	                    var o4 = i * 17;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    this.int16[o2 + 3] = v3;
	                    this.int16[o2 + 4] = v4;
	                    this.int16[o2 + 5] = v5;
	                    this.int16[o2 + 6] = v6;
	                    this.int16[o2 + 7] = v7;
	                    this.uint16[o2 + 8] = v8;
	                    this.uint16[o2 + 9] = v9;
	                    this.uint16[o2 + 10] = v10;
	                    this.uint16[o2 + 11] = v11;
	                    this.uint16[o2 + 12] = v12;
	                    this.uint16[o2 + 13] = v13;
	                    this.uint16[o2 + 14] = v14;
	                    this.uint16[o2 + 15] = v15;
	                    this.uint16[o2 + 16] = v16;
	                    this.uint16[o2 + 17] = v17;
	                    this.uint16[o2 + 18] = v18;
	                    this.uint16[o2 + 19] = v19;
	                    this.uint16[o2 + 20] = v20;
	                    this.uint16[o2 + 21] = v21;
	                    this.uint16[o2 + 22] = v22;
	                    this.uint32[o4 + 12] = v23;
	                    this.float32[o4 + 13] = v24;
	                    this.float32[o4 + 14] = v25;
	                    this.float32[o4 + 15] = v26;
	                    this.float32[o4 + 16] = v27;
	                    return i;
	                  };
	                  return StructArrayLayout8i15ui1ul4f682;
	                }(StructArray);
	                StructArrayLayout8i15ui1ul4f68.prototype.bytesPerElement = 68;
	                register("StructArrayLayout8i15ui1ul4f68", StructArrayLayout8i15ui1ul4f68);
	                var StructArrayLayout1f4 = function(StructArray2) {
	                  function StructArrayLayout1f42() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout1f42.__proto__ = StructArray2;
	                  StructArrayLayout1f42.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout1f42.prototype.constructor = StructArrayLayout1f42;
	                  StructArrayLayout1f42.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout1f42.prototype.emplaceBack = function emplaceBack(v0) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0);
	                  };
	                  StructArrayLayout1f42.prototype.emplace = function emplace(i, v0) {
	                    var o4 = i * 1;
	                    this.float32[o4 + 0] = v0;
	                    return i;
	                  };
	                  return StructArrayLayout1f42;
	                }(StructArray);
	                StructArrayLayout1f4.prototype.bytesPerElement = 4;
	                register("StructArrayLayout1f4", StructArrayLayout1f4);
	                var StructArrayLayout3i6 = function(StructArray2) {
	                  function StructArrayLayout3i62() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout3i62.__proto__ = StructArray2;
	                  StructArrayLayout3i62.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout3i62.prototype.constructor = StructArrayLayout3i62;
	                  StructArrayLayout3i62.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.int16 = new Int16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout3i62.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2);
	                  };
	                  StructArrayLayout3i62.prototype.emplace = function emplace(i, v0, v1, v2) {
	                    var o2 = i * 3;
	                    this.int16[o2 + 0] = v0;
	                    this.int16[o2 + 1] = v1;
	                    this.int16[o2 + 2] = v2;
	                    return i;
	                  };
	                  return StructArrayLayout3i62;
	                }(StructArray);
	                StructArrayLayout3i6.prototype.bytesPerElement = 6;
	                register("StructArrayLayout3i6", StructArrayLayout3i6);
	                var StructArrayLayout1ul2ui8 = function(StructArray2) {
	                  function StructArrayLayout1ul2ui82() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout1ul2ui82.__proto__ = StructArray2;
	                  StructArrayLayout1ul2ui82.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout1ul2ui82.prototype.constructor = StructArrayLayout1ul2ui82;
	                  StructArrayLayout1ul2ui82.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.uint32 = new Uint32Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout1ul2ui82.prototype.emplaceBack = function emplaceBack(v0, v1, v2) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2);
	                  };
	                  StructArrayLayout1ul2ui82.prototype.emplace = function emplace(i, v0, v1, v2) {
	                    var o4 = i * 2;
	                    var o2 = i * 4;
	                    this.uint32[o4 + 0] = v0;
	                    this.uint16[o2 + 2] = v1;
	                    this.uint16[o2 + 3] = v2;
	                    return i;
	                  };
	                  return StructArrayLayout1ul2ui82;
	                }(StructArray);
	                StructArrayLayout1ul2ui8.prototype.bytesPerElement = 8;
	                register("StructArrayLayout1ul2ui8", StructArrayLayout1ul2ui8);
	                var StructArrayLayout2ui4 = function(StructArray2) {
	                  function StructArrayLayout2ui42() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2ui42.__proto__ = StructArray2;
	                  StructArrayLayout2ui42.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2ui42.prototype.constructor = StructArrayLayout2ui42;
	                  StructArrayLayout2ui42.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2ui42.prototype.emplaceBack = function emplaceBack(v0, v1) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1);
	                  };
	                  StructArrayLayout2ui42.prototype.emplace = function emplace(i, v0, v1) {
	                    var o2 = i * 2;
	                    this.uint16[o2 + 0] = v0;
	                    this.uint16[o2 + 1] = v1;
	                    return i;
	                  };
	                  return StructArrayLayout2ui42;
	                }(StructArray);
	                StructArrayLayout2ui4.prototype.bytesPerElement = 4;
	                register("StructArrayLayout2ui4", StructArrayLayout2ui4);
	                var StructArrayLayout1ui2 = function(StructArray2) {
	                  function StructArrayLayout1ui22() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout1ui22.__proto__ = StructArray2;
	                  StructArrayLayout1ui22.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout1ui22.prototype.constructor = StructArrayLayout1ui22;
	                  StructArrayLayout1ui22.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.uint16 = new Uint16Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout1ui22.prototype.emplaceBack = function emplaceBack(v0) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0);
	                  };
	                  StructArrayLayout1ui22.prototype.emplace = function emplace(i, v0) {
	                    var o2 = i * 1;
	                    this.uint16[o2 + 0] = v0;
	                    return i;
	                  };
	                  return StructArrayLayout1ui22;
	                }(StructArray);
	                StructArrayLayout1ui2.prototype.bytesPerElement = 2;
	                register("StructArrayLayout1ui2", StructArrayLayout1ui2);
	                var StructArrayLayout2f8 = function(StructArray2) {
	                  function StructArrayLayout2f82() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout2f82.__proto__ = StructArray2;
	                  StructArrayLayout2f82.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout2f82.prototype.constructor = StructArrayLayout2f82;
	                  StructArrayLayout2f82.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout2f82.prototype.emplaceBack = function emplaceBack(v0, v1) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1);
	                  };
	                  StructArrayLayout2f82.prototype.emplace = function emplace(i, v0, v1) {
	                    var o4 = i * 2;
	                    this.float32[o4 + 0] = v0;
	                    this.float32[o4 + 1] = v1;
	                    return i;
	                  };
	                  return StructArrayLayout2f82;
	                }(StructArray);
	                StructArrayLayout2f8.prototype.bytesPerElement = 8;
	                register("StructArrayLayout2f8", StructArrayLayout2f8);
	                var StructArrayLayout4f16 = function(StructArray2) {
	                  function StructArrayLayout4f162() {
	                    StructArray2.apply(this, arguments);
	                  }
	                  StructArrayLayout4f162.__proto__ = StructArray2;
	                  StructArrayLayout4f162.prototype = Object.create(StructArray2.prototype);
	                  StructArrayLayout4f162.prototype.constructor = StructArrayLayout4f162;
	                  StructArrayLayout4f162.prototype._refreshViews = function _refreshViews() {
	                    this.uint8 = new Uint8Array(this.arrayBuffer);
	                    this.float32 = new Float32Array(this.arrayBuffer);
	                  };
	                  StructArrayLayout4f162.prototype.emplaceBack = function emplaceBack(v0, v1, v2, v3) {
	                    var i = this.length;
	                    this.resize(i + 1);
	                    return this.emplace(i, v0, v1, v2, v3);
	                  };
	                  StructArrayLayout4f162.prototype.emplace = function emplace(i, v0, v1, v2, v3) {
	                    var o4 = i * 4;
	                    this.float32[o4 + 0] = v0;
	                    this.float32[o4 + 1] = v1;
	                    this.float32[o4 + 2] = v2;
	                    this.float32[o4 + 3] = v3;
	                    return i;
	                  };
	                  return StructArrayLayout4f162;
	                }(StructArray);
	                StructArrayLayout4f16.prototype.bytesPerElement = 16;
	                register("StructArrayLayout4f16", StructArrayLayout4f16);
	                var CollisionBoxStruct = function(Struct2) {
	                  function CollisionBoxStruct2() {
	                    Struct2.apply(this, arguments);
	                  }
	                  CollisionBoxStruct2.__proto__ = Struct2;
	                  CollisionBoxStruct2.prototype = Object.create(Struct2.prototype);
	                  CollisionBoxStruct2.prototype.constructor = CollisionBoxStruct2;
	                  var prototypeAccessors2 = {
	                    anchorPointX: { configurable: true },
	                    anchorPointY: { configurable: true },
	                    x1: { configurable: true },
	                    y1: { configurable: true },
	                    x2: { configurable: true },
	                    y2: { configurable: true },
	                    featureIndex: { configurable: true },
	                    sourceLayerIndex: { configurable: true },
	                    bucketIndex: { configurable: true },
	                    anchorPoint: { configurable: true }
	                  };
	                  prototypeAccessors2.anchorPointX.get = function() {
	                    return this._structArray.int16[this._pos2 + 0];
	                  };
	                  prototypeAccessors2.anchorPointY.get = function() {
	                    return this._structArray.int16[this._pos2 + 1];
	                  };
	                  prototypeAccessors2.x1.get = function() {
	                    return this._structArray.int16[this._pos2 + 2];
	                  };
	                  prototypeAccessors2.y1.get = function() {
	                    return this._structArray.int16[this._pos2 + 3];
	                  };
	                  prototypeAccessors2.x2.get = function() {
	                    return this._structArray.int16[this._pos2 + 4];
	                  };
	                  prototypeAccessors2.y2.get = function() {
	                    return this._structArray.int16[this._pos2 + 5];
	                  };
	                  prototypeAccessors2.featureIndex.get = function() {
	                    return this._structArray.uint32[this._pos4 + 3];
	                  };
	                  prototypeAccessors2.sourceLayerIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 8];
	                  };
	                  prototypeAccessors2.bucketIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 9];
	                  };
	                  prototypeAccessors2.anchorPoint.get = function() {
	                    return new pointGeometry(this.anchorPointX, this.anchorPointY);
	                  };
	                  Object.defineProperties(CollisionBoxStruct2.prototype, prototypeAccessors2);
	                  return CollisionBoxStruct2;
	                }(Struct);
	                CollisionBoxStruct.prototype.size = 20;
	                var CollisionBoxArray = function(StructArrayLayout6i1ul2ui202) {
	                  function CollisionBoxArray2() {
	                    StructArrayLayout6i1ul2ui202.apply(this, arguments);
	                  }
	                  CollisionBoxArray2.__proto__ = StructArrayLayout6i1ul2ui202;
	                  CollisionBoxArray2.prototype = Object.create(StructArrayLayout6i1ul2ui202.prototype);
	                  CollisionBoxArray2.prototype.constructor = CollisionBoxArray2;
	                  CollisionBoxArray2.prototype.get = function get2(index) {
	                    return new CollisionBoxStruct(this, index);
	                  };
	                  return CollisionBoxArray2;
	                }(StructArrayLayout6i1ul2ui20);
	                register("CollisionBoxArray", CollisionBoxArray);
	                var PlacedSymbolStruct = function(Struct2) {
	                  function PlacedSymbolStruct2() {
	                    Struct2.apply(this, arguments);
	                  }
	                  PlacedSymbolStruct2.__proto__ = Struct2;
	                  PlacedSymbolStruct2.prototype = Object.create(Struct2.prototype);
	                  PlacedSymbolStruct2.prototype.constructor = PlacedSymbolStruct2;
	                  var prototypeAccessors$12 = {
	                    anchorX: { configurable: true },
	                    anchorY: { configurable: true },
	                    glyphStartIndex: { configurable: true },
	                    numGlyphs: { configurable: true },
	                    vertexStartIndex: { configurable: true },
	                    lineStartIndex: { configurable: true },
	                    lineLength: { configurable: true },
	                    segment: { configurable: true },
	                    lowerSize: { configurable: true },
	                    upperSize: { configurable: true },
	                    lineOffsetX: { configurable: true },
	                    lineOffsetY: { configurable: true },
	                    writingMode: { configurable: true },
	                    placedOrientation: { configurable: true },
	                    hidden: { configurable: true },
	                    crossTileID: { configurable: true },
	                    associatedIconIndex: { configurable: true }
	                  };
	                  prototypeAccessors$12.anchorX.get = function() {
	                    return this._structArray.int16[this._pos2 + 0];
	                  };
	                  prototypeAccessors$12.anchorY.get = function() {
	                    return this._structArray.int16[this._pos2 + 1];
	                  };
	                  prototypeAccessors$12.glyphStartIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 2];
	                  };
	                  prototypeAccessors$12.numGlyphs.get = function() {
	                    return this._structArray.uint16[this._pos2 + 3];
	                  };
	                  prototypeAccessors$12.vertexStartIndex.get = function() {
	                    return this._structArray.uint32[this._pos4 + 2];
	                  };
	                  prototypeAccessors$12.lineStartIndex.get = function() {
	                    return this._structArray.uint32[this._pos4 + 3];
	                  };
	                  prototypeAccessors$12.lineLength.get = function() {
	                    return this._structArray.uint32[this._pos4 + 4];
	                  };
	                  prototypeAccessors$12.segment.get = function() {
	                    return this._structArray.uint16[this._pos2 + 10];
	                  };
	                  prototypeAccessors$12.lowerSize.get = function() {
	                    return this._structArray.uint16[this._pos2 + 11];
	                  };
	                  prototypeAccessors$12.upperSize.get = function() {
	                    return this._structArray.uint16[this._pos2 + 12];
	                  };
	                  prototypeAccessors$12.lineOffsetX.get = function() {
	                    return this._structArray.float32[this._pos4 + 7];
	                  };
	                  prototypeAccessors$12.lineOffsetY.get = function() {
	                    return this._structArray.float32[this._pos4 + 8];
	                  };
	                  prototypeAccessors$12.writingMode.get = function() {
	                    return this._structArray.uint8[this._pos1 + 36];
	                  };
	                  prototypeAccessors$12.placedOrientation.get = function() {
	                    return this._structArray.uint8[this._pos1 + 37];
	                  };
	                  prototypeAccessors$12.placedOrientation.set = function(x) {
	                    this._structArray.uint8[this._pos1 + 37] = x;
	                  };
	                  prototypeAccessors$12.hidden.get = function() {
	                    return this._structArray.uint8[this._pos1 + 38];
	                  };
	                  prototypeAccessors$12.hidden.set = function(x) {
	                    this._structArray.uint8[this._pos1 + 38] = x;
	                  };
	                  prototypeAccessors$12.crossTileID.get = function() {
	                    return this._structArray.uint32[this._pos4 + 10];
	                  };
	                  prototypeAccessors$12.crossTileID.set = function(x) {
	                    this._structArray.uint32[this._pos4 + 10] = x;
	                  };
	                  prototypeAccessors$12.associatedIconIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 22];
	                  };
	                  Object.defineProperties(PlacedSymbolStruct2.prototype, prototypeAccessors$12);
	                  return PlacedSymbolStruct2;
	                }(Struct);
	                PlacedSymbolStruct.prototype.size = 48;
	                var PlacedSymbolArray = function(StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482) {
	                  function PlacedSymbolArray2() {
	                    StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.apply(this, arguments);
	                  }
	                  PlacedSymbolArray2.__proto__ = StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482;
	                  PlacedSymbolArray2.prototype = Object.create(StructArrayLayout2i2ui3ul3ui2f3ub1ul1i482.prototype);
	                  PlacedSymbolArray2.prototype.constructor = PlacedSymbolArray2;
	                  PlacedSymbolArray2.prototype.get = function get2(index) {
	                    return new PlacedSymbolStruct(this, index);
	                  };
	                  return PlacedSymbolArray2;
	                }(StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48);
	                register("PlacedSymbolArray", PlacedSymbolArray);
	                var SymbolInstanceStruct = function(Struct2) {
	                  function SymbolInstanceStruct2() {
	                    Struct2.apply(this, arguments);
	                  }
	                  SymbolInstanceStruct2.__proto__ = Struct2;
	                  SymbolInstanceStruct2.prototype = Object.create(Struct2.prototype);
	                  SymbolInstanceStruct2.prototype.constructor = SymbolInstanceStruct2;
	                  var prototypeAccessors$2 = {
	                    anchorX: { configurable: true },
	                    anchorY: { configurable: true },
	                    rightJustifiedTextSymbolIndex: { configurable: true },
	                    centerJustifiedTextSymbolIndex: { configurable: true },
	                    leftJustifiedTextSymbolIndex: { configurable: true },
	                    verticalPlacedTextSymbolIndex: { configurable: true },
	                    placedIconSymbolIndex: { configurable: true },
	                    verticalPlacedIconSymbolIndex: { configurable: true },
	                    key: { configurable: true },
	                    textBoxStartIndex: { configurable: true },
	                    textBoxEndIndex: { configurable: true },
	                    verticalTextBoxStartIndex: { configurable: true },
	                    verticalTextBoxEndIndex: { configurable: true },
	                    iconBoxStartIndex: { configurable: true },
	                    iconBoxEndIndex: { configurable: true },
	                    verticalIconBoxStartIndex: { configurable: true },
	                    verticalIconBoxEndIndex: { configurable: true },
	                    featureIndex: { configurable: true },
	                    numHorizontalGlyphVertices: { configurable: true },
	                    numVerticalGlyphVertices: { configurable: true },
	                    numIconVertices: { configurable: true },
	                    numVerticalIconVertices: { configurable: true },
	                    useRuntimeCollisionCircles: { configurable: true },
	                    crossTileID: { configurable: true },
	                    textBoxScale: { configurable: true },
	                    textOffset0: { configurable: true },
	                    textOffset1: { configurable: true },
	                    collisionCircleDiameter: { configurable: true }
	                  };
	                  prototypeAccessors$2.anchorX.get = function() {
	                    return this._structArray.int16[this._pos2 + 0];
	                  };
	                  prototypeAccessors$2.anchorY.get = function() {
	                    return this._structArray.int16[this._pos2 + 1];
	                  };
	                  prototypeAccessors$2.rightJustifiedTextSymbolIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 2];
	                  };
	                  prototypeAccessors$2.centerJustifiedTextSymbolIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 3];
	                  };
	                  prototypeAccessors$2.leftJustifiedTextSymbolIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 4];
	                  };
	                  prototypeAccessors$2.verticalPlacedTextSymbolIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 5];
	                  };
	                  prototypeAccessors$2.placedIconSymbolIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 6];
	                  };
	                  prototypeAccessors$2.verticalPlacedIconSymbolIndex.get = function() {
	                    return this._structArray.int16[this._pos2 + 7];
	                  };
	                  prototypeAccessors$2.key.get = function() {
	                    return this._structArray.uint16[this._pos2 + 8];
	                  };
	                  prototypeAccessors$2.textBoxStartIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 9];
	                  };
	                  prototypeAccessors$2.textBoxEndIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 10];
	                  };
	                  prototypeAccessors$2.verticalTextBoxStartIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 11];
	                  };
	                  prototypeAccessors$2.verticalTextBoxEndIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 12];
	                  };
	                  prototypeAccessors$2.iconBoxStartIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 13];
	                  };
	                  prototypeAccessors$2.iconBoxEndIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 14];
	                  };
	                  prototypeAccessors$2.verticalIconBoxStartIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 15];
	                  };
	                  prototypeAccessors$2.verticalIconBoxEndIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 16];
	                  };
	                  prototypeAccessors$2.featureIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 17];
	                  };
	                  prototypeAccessors$2.numHorizontalGlyphVertices.get = function() {
	                    return this._structArray.uint16[this._pos2 + 18];
	                  };
	                  prototypeAccessors$2.numVerticalGlyphVertices.get = function() {
	                    return this._structArray.uint16[this._pos2 + 19];
	                  };
	                  prototypeAccessors$2.numIconVertices.get = function() {
	                    return this._structArray.uint16[this._pos2 + 20];
	                  };
	                  prototypeAccessors$2.numVerticalIconVertices.get = function() {
	                    return this._structArray.uint16[this._pos2 + 21];
	                  };
	                  prototypeAccessors$2.useRuntimeCollisionCircles.get = function() {
	                    return this._structArray.uint16[this._pos2 + 22];
	                  };
	                  prototypeAccessors$2.crossTileID.get = function() {
	                    return this._structArray.uint32[this._pos4 + 12];
	                  };
	                  prototypeAccessors$2.crossTileID.set = function(x) {
	                    this._structArray.uint32[this._pos4 + 12] = x;
	                  };
	                  prototypeAccessors$2.textBoxScale.get = function() {
	                    return this._structArray.float32[this._pos4 + 13];
	                  };
	                  prototypeAccessors$2.textOffset0.get = function() {
	                    return this._structArray.float32[this._pos4 + 14];
	                  };
	                  prototypeAccessors$2.textOffset1.get = function() {
	                    return this._structArray.float32[this._pos4 + 15];
	                  };
	                  prototypeAccessors$2.collisionCircleDiameter.get = function() {
	                    return this._structArray.float32[this._pos4 + 16];
	                  };
	                  Object.defineProperties(SymbolInstanceStruct2.prototype, prototypeAccessors$2);
	                  return SymbolInstanceStruct2;
	                }(Struct);
	                SymbolInstanceStruct.prototype.size = 68;
	                var SymbolInstanceArray = function(StructArrayLayout8i15ui1ul4f682) {
	                  function SymbolInstanceArray2() {
	                    StructArrayLayout8i15ui1ul4f682.apply(this, arguments);
	                  }
	                  SymbolInstanceArray2.__proto__ = StructArrayLayout8i15ui1ul4f682;
	                  SymbolInstanceArray2.prototype = Object.create(StructArrayLayout8i15ui1ul4f682.prototype);
	                  SymbolInstanceArray2.prototype.constructor = SymbolInstanceArray2;
	                  SymbolInstanceArray2.prototype.get = function get2(index) {
	                    return new SymbolInstanceStruct(this, index);
	                  };
	                  return SymbolInstanceArray2;
	                }(StructArrayLayout8i15ui1ul4f68);
	                register("SymbolInstanceArray", SymbolInstanceArray);
	                var GlyphOffsetArray = function(StructArrayLayout1f42) {
	                  function GlyphOffsetArray2() {
	                    StructArrayLayout1f42.apply(this, arguments);
	                  }
	                  GlyphOffsetArray2.__proto__ = StructArrayLayout1f42;
	                  GlyphOffsetArray2.prototype = Object.create(StructArrayLayout1f42.prototype);
	                  GlyphOffsetArray2.prototype.constructor = GlyphOffsetArray2;
	                  GlyphOffsetArray2.prototype.getoffsetX = function getoffsetX(index) {
	                    return this.float32[index * 1 + 0];
	                  };
	                  return GlyphOffsetArray2;
	                }(StructArrayLayout1f4);
	                register("GlyphOffsetArray", GlyphOffsetArray);
	                var SymbolLineVertexArray = function(StructArrayLayout3i62) {
	                  function SymbolLineVertexArray2() {
	                    StructArrayLayout3i62.apply(this, arguments);
	                  }
	                  SymbolLineVertexArray2.__proto__ = StructArrayLayout3i62;
	                  SymbolLineVertexArray2.prototype = Object.create(StructArrayLayout3i62.prototype);
	                  SymbolLineVertexArray2.prototype.constructor = SymbolLineVertexArray2;
	                  SymbolLineVertexArray2.prototype.getx = function getx(index) {
	                    return this.int16[index * 3 + 0];
	                  };
	                  SymbolLineVertexArray2.prototype.gety = function gety(index) {
	                    return this.int16[index * 3 + 1];
	                  };
	                  SymbolLineVertexArray2.prototype.gettileUnitDistanceFromAnchor = function gettileUnitDistanceFromAnchor(index) {
	                    return this.int16[index * 3 + 2];
	                  };
	                  return SymbolLineVertexArray2;
	                }(StructArrayLayout3i6);
	                register("SymbolLineVertexArray", SymbolLineVertexArray);
	                var FeatureIndexStruct = function(Struct2) {
	                  function FeatureIndexStruct2() {
	                    Struct2.apply(this, arguments);
	                  }
	                  FeatureIndexStruct2.__proto__ = Struct2;
	                  FeatureIndexStruct2.prototype = Object.create(Struct2.prototype);
	                  FeatureIndexStruct2.prototype.constructor = FeatureIndexStruct2;
	                  var prototypeAccessors$3 = {
	                    featureIndex: { configurable: true },
	                    sourceLayerIndex: { configurable: true },
	                    bucketIndex: { configurable: true }
	                  };
	                  prototypeAccessors$3.featureIndex.get = function() {
	                    return this._structArray.uint32[this._pos4 + 0];
	                  };
	                  prototypeAccessors$3.sourceLayerIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 2];
	                  };
	                  prototypeAccessors$3.bucketIndex.get = function() {
	                    return this._structArray.uint16[this._pos2 + 3];
	                  };
	                  Object.defineProperties(FeatureIndexStruct2.prototype, prototypeAccessors$3);
	                  return FeatureIndexStruct2;
	                }(Struct);
	                FeatureIndexStruct.prototype.size = 8;
	                var FeatureIndexArray = function(StructArrayLayout1ul2ui82) {
	                  function FeatureIndexArray2() {
	                    StructArrayLayout1ul2ui82.apply(this, arguments);
	                  }
	                  FeatureIndexArray2.__proto__ = StructArrayLayout1ul2ui82;
	                  FeatureIndexArray2.prototype = Object.create(StructArrayLayout1ul2ui82.prototype);
	                  FeatureIndexArray2.prototype.constructor = FeatureIndexArray2;
	                  FeatureIndexArray2.prototype.get = function get2(index) {
	                    return new FeatureIndexStruct(this, index);
	                  };
	                  return FeatureIndexArray2;
	                }(StructArrayLayout1ul2ui8);
	                register("FeatureIndexArray", FeatureIndexArray);
	                var layout$1 = createLayout([{
	                  name: "a_pos",
	                  components: 2,
	                  type: "Int16"
	                }], 4);
	                var members = layout$1.members;
	                var SegmentVector = function SegmentVector2(segments) {
	                  if (segments === undefined)
	                    segments = [];
	                  this.segments = segments;
	                };
	                SegmentVector.prototype.prepareSegment = function prepareSegment(numVertices, layoutVertexArray, indexArray, sortKey) {
	                  var segment = this.segments[this.segments.length - 1];
	                  if (numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
	                    warnOnce("Max vertices per segment is " + SegmentVector.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + numVertices);
	                  }
	                  if (!segment || segment.vertexLength + numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH || segment.sortKey !== sortKey) {
	                    segment = {
	                      vertexOffset: layoutVertexArray.length,
	                      primitiveOffset: indexArray.length,
	                      vertexLength: 0,
	                      primitiveLength: 0
	                    };
	                    if (sortKey !== undefined) {
	                      segment.sortKey = sortKey;
	                    }
	                    this.segments.push(segment);
	                  }
	                  return segment;
	                };
	                SegmentVector.prototype.get = function get2() {
	                  return this.segments;
	                };
	                SegmentVector.prototype.destroy = function destroy() {
	                  for (var i = 0, list = this.segments; i < list.length; i += 1) {
	                    var segment = list[i];
	                    for (var k in segment.vaos) {
	                      segment.vaos[k].destroy();
	                    }
	                  }
	                };
	                SegmentVector.simpleSegment = function simpleSegment(vertexOffset, primitiveOffset, vertexLength, primitiveLength) {
	                  return new SegmentVector([{
	                    vertexOffset,
	                    primitiveOffset,
	                    vertexLength,
	                    primitiveLength,
	                    vaos: {},
	                    sortKey: 0
	                  }]);
	                };
	                SegmentVector.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1;
	                register("SegmentVector", SegmentVector);
	                function packUint8ToFloat(a, b) {
	                  a = clamp(Math.floor(a), 0, 255);
	                  b = clamp(Math.floor(b), 0, 255);
	                  return 256 * a + b;
	                }
	                var patternAttributes = createLayout([
	                  {
	                    name: "a_pattern_from",
	                    components: 4,
	                    type: "Uint16"
	                  },
	                  {
	                    name: "a_pattern_to",
	                    components: 4,
	                    type: "Uint16"
	                  },
	                  {
	                    name: "a_pixel_ratio_from",
	                    components: 1,
	                    type: "Uint8"
	                  },
	                  {
	                    name: "a_pixel_ratio_to",
	                    components: 1,
	                    type: "Uint8"
	                  }
	                ]);
	                var murmurhash3_gc = createCommonjsModule(function(module3) {
	                  function murmurhash3_32_gc(key, seed) {
	                    var remainder, bytes, h1, h1b, c1, c2, k1, i;
	                    remainder = key.length & 3;
	                    bytes = key.length - remainder;
	                    h1 = seed;
	                    c1 = 3432918353;
	                    c2 = 461845907;
	                    i = 0;
	                    while (i < bytes) {
	                      k1 = key.charCodeAt(i) & 255 | (key.charCodeAt(++i) & 255) << 8 | (key.charCodeAt(++i) & 255) << 16 | (key.charCodeAt(++i) & 255) << 24;
	                      ++i;
	                      k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
	                      k1 = k1 << 15 | k1 >>> 17;
	                      k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
	                      h1 ^= k1;
	                      h1 = h1 << 13 | h1 >>> 19;
	                      h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;
	                      h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
	                    }
	                    k1 = 0;
	                    switch (remainder) {
	                      case 3:
	                        k1 ^= (key.charCodeAt(i + 2) & 255) << 16;
	                      case 2:
	                        k1 ^= (key.charCodeAt(i + 1) & 255) << 8;
	                      case 1:
	                        k1 ^= key.charCodeAt(i) & 255;
	                        k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;
	                        k1 = k1 << 15 | k1 >>> 17;
	                        k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;
	                        h1 ^= k1;
	                    }
	                    h1 ^= key.length;
	                    h1 ^= h1 >>> 16;
	                    h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;
	                    h1 ^= h1 >>> 13;
	                    h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;
	                    h1 ^= h1 >>> 16;
	                    return h1 >>> 0;
	                  }
	                  {
	                    module3.exports = murmurhash3_32_gc;
	                  }
	                });
	                var murmurhash2_gc = createCommonjsModule(function(module3) {
	                  function murmurhash2_32_gc(str, seed) {
	                    var l = str.length, h = seed ^ l, i = 0, k;
	                    while (l >= 4) {
	                      k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
	                      k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
	                      k ^= k >>> 24;
	                      k = (k & 65535) * 1540483477 + (((k >>> 16) * 1540483477 & 65535) << 16);
	                      h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16) ^ k;
	                      l -= 4;
	                      ++i;
	                    }
	                    switch (l) {
	                      case 3:
	                        h ^= (str.charCodeAt(i + 2) & 255) << 16;
	                      case 2:
	                        h ^= (str.charCodeAt(i + 1) & 255) << 8;
	                      case 1:
	                        h ^= str.charCodeAt(i) & 255;
	                        h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
	                    }
	                    h ^= h >>> 13;
	                    h = (h & 65535) * 1540483477 + (((h >>> 16) * 1540483477 & 65535) << 16);
	                    h ^= h >>> 15;
	                    return h >>> 0;
	                  }
	                  {
	                    module3.exports = murmurhash2_32_gc;
	                  }
	                });
	                var murmurhashJs = murmurhash3_gc;
	                var murmur3_1 = murmurhash3_gc;
	                var murmur2_1 = murmurhash2_gc;
	                murmurhashJs.murmur3 = murmur3_1;
	                murmurhashJs.murmur2 = murmur2_1;
	                var FeaturePositionMap = function FeaturePositionMap2() {
	                  this.ids = [];
	                  this.positions = [];
	                  this.indexed = false;
	                };
	                FeaturePositionMap.prototype.add = function add2(id2, index, start, end) {
	                  this.ids.push(getNumericId(id2));
	                  this.positions.push(index, start, end);
	                };
	                FeaturePositionMap.prototype.getPositions = function getPositions(id2) {
	                  var intId = getNumericId(id2);
	                  var i = 0;
	                  var j = this.ids.length - 1;
	                  while (i < j) {
	                    var m = i + j >> 1;
	                    if (this.ids[m] >= intId) {
	                      j = m;
	                    } else {
	                      i = m + 1;
	                    }
	                  }
	                  var positions = [];
	                  while (this.ids[i] === intId) {
	                    var index = this.positions[3 * i];
	                    var start = this.positions[3 * i + 1];
	                    var end = this.positions[3 * i + 2];
	                    positions.push({
	                      index,
	                      start,
	                      end
	                    });
	                    i++;
	                  }
	                  return positions;
	                };
	                FeaturePositionMap.serialize = function serialize2(map2, transferables) {
	                  var ids = new Float64Array(map2.ids);
	                  var positions = new Uint32Array(map2.positions);
	                  sort(ids, positions, 0, ids.length - 1);
	                  if (transferables) {
	                    transferables.push(ids.buffer, positions.buffer);
	                  }
	                  return {
	                    ids,
	                    positions
	                  };
	                };
	                FeaturePositionMap.deserialize = function deserialize2(obj) {
	                  var map2 = new FeaturePositionMap();
	                  map2.ids = obj.ids;
	                  map2.positions = obj.positions;
	                  map2.indexed = true;
	                  return map2;
	                };
	                var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
	                function getNumericId(value) {
	                  var numValue = +value;
	                  if (!isNaN(numValue) && numValue <= MAX_SAFE_INTEGER) {
	                    return numValue;
	                  }
	                  return murmurhashJs(String(value));
	                }
	                function sort(ids, positions, left, right) {
	                  while (left < right) {
	                    var pivot = ids[left + right >> 1];
	                    var i = left - 1;
	                    var j = right + 1;
	                    while (true) {
	                      do {
	                        i++;
	                      } while (ids[i] < pivot);
	                      do {
	                        j--;
	                      } while (ids[j] > pivot);
	                      if (i >= j) {
	                        break;
	                      }
	                      swap(ids, i, j);
	                      swap(positions, 3 * i, 3 * j);
	                      swap(positions, 3 * i + 1, 3 * j + 1);
	                      swap(positions, 3 * i + 2, 3 * j + 2);
	                    }
	                    if (j - left < right - j) {
	                      sort(ids, positions, left, j);
	                      left = j + 1;
	                    } else {
	                      sort(ids, positions, j + 1, right);
	                      right = j;
	                    }
	                  }
	                }
	                function swap(arr, i, j) {
	                  var tmp = arr[i];
	                  arr[i] = arr[j];
	                  arr[j] = tmp;
	                }
	                register("FeaturePositionMap", FeaturePositionMap);
	                var Uniform = function Uniform2(context, location) {
	                  this.gl = context.gl;
	                  this.location = location;
	                };
	                var Uniform1i = function(Uniform2) {
	                  function Uniform1i2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = 0;
	                  }
	                  Uniform1i2.__proto__ = Uniform2;
	                  Uniform1i2.prototype = Object.create(Uniform2.prototype);
	                  Uniform1i2.prototype.constructor = Uniform1i2;
	                  Uniform1i2.prototype.set = function set(v) {
	                    if (this.current !== v) {
	                      this.current = v;
	                      this.gl.uniform1i(this.location, v);
	                    }
	                  };
	                  return Uniform1i2;
	                }(Uniform);
	                var Uniform1f = function(Uniform2) {
	                  function Uniform1f2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = 0;
	                  }
	                  Uniform1f2.__proto__ = Uniform2;
	                  Uniform1f2.prototype = Object.create(Uniform2.prototype);
	                  Uniform1f2.prototype.constructor = Uniform1f2;
	                  Uniform1f2.prototype.set = function set(v) {
	                    if (this.current !== v) {
	                      this.current = v;
	                      this.gl.uniform1f(this.location, v);
	                    }
	                  };
	                  return Uniform1f2;
	                }(Uniform);
	                var Uniform2f = function(Uniform2) {
	                  function Uniform2f2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = [
	                      0,
	                      0
	                    ];
	                  }
	                  Uniform2f2.__proto__ = Uniform2;
	                  Uniform2f2.prototype = Object.create(Uniform2.prototype);
	                  Uniform2f2.prototype.constructor = Uniform2f2;
	                  Uniform2f2.prototype.set = function set(v) {
	                    if (v[0] !== this.current[0] || v[1] !== this.current[1]) {
	                      this.current = v;
	                      this.gl.uniform2f(this.location, v[0], v[1]);
	                    }
	                  };
	                  return Uniform2f2;
	                }(Uniform);
	                var Uniform3f = function(Uniform2) {
	                  function Uniform3f2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = [
	                      0,
	                      0,
	                      0
	                    ];
	                  }
	                  Uniform3f2.__proto__ = Uniform2;
	                  Uniform3f2.prototype = Object.create(Uniform2.prototype);
	                  Uniform3f2.prototype.constructor = Uniform3f2;
	                  Uniform3f2.prototype.set = function set(v) {
	                    if (v[0] !== this.current[0] || v[1] !== this.current[1] || v[2] !== this.current[2]) {
	                      this.current = v;
	                      this.gl.uniform3f(this.location, v[0], v[1], v[2]);
	                    }
	                  };
	                  return Uniform3f2;
	                }(Uniform);
	                var Uniform4f = function(Uniform2) {
	                  function Uniform4f2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = [
	                      0,
	                      0,
	                      0,
	                      0
	                    ];
	                  }
	                  Uniform4f2.__proto__ = Uniform2;
	                  Uniform4f2.prototype = Object.create(Uniform2.prototype);
	                  Uniform4f2.prototype.constructor = Uniform4f2;
	                  Uniform4f2.prototype.set = function set(v) {
	                    if (v[0] !== this.current[0] || v[1] !== this.current[1] || v[2] !== this.current[2] || v[3] !== this.current[3]) {
	                      this.current = v;
	                      this.gl.uniform4f(this.location, v[0], v[1], v[2], v[3]);
	                    }
	                  };
	                  return Uniform4f2;
	                }(Uniform);
	                var UniformColor = function(Uniform2) {
	                  function UniformColor2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = Color.transparent;
	                  }
	                  UniformColor2.__proto__ = Uniform2;
	                  UniformColor2.prototype = Object.create(Uniform2.prototype);
	                  UniformColor2.prototype.constructor = UniformColor2;
	                  UniformColor2.prototype.set = function set(v) {
	                    if (v.r !== this.current.r || v.g !== this.current.g || v.b !== this.current.b || v.a !== this.current.a) {
	                      this.current = v;
	                      this.gl.uniform4f(this.location, v.r, v.g, v.b, v.a);
	                    }
	                  };
	                  return UniformColor2;
	                }(Uniform);
	                var emptyMat4 = new Float32Array(16);
	                var UniformMatrix4f = function(Uniform2) {
	                  function UniformMatrix4f2(context, location) {
	                    Uniform2.call(this, context, location);
	                    this.current = emptyMat4;
	                  }
	                  UniformMatrix4f2.__proto__ = Uniform2;
	                  UniformMatrix4f2.prototype = Object.create(Uniform2.prototype);
	                  UniformMatrix4f2.prototype.constructor = UniformMatrix4f2;
	                  UniformMatrix4f2.prototype.set = function set(v) {
	                    if (v[12] !== this.current[12] || v[0] !== this.current[0]) {
	                      this.current = v;
	                      this.gl.uniformMatrix4fv(this.location, false, v);
	                      return;
	                    }
	                    for (var i = 1; i < 16; i++) {
	                      if (v[i] !== this.current[i]) {
	                        this.current = v;
	                        this.gl.uniformMatrix4fv(this.location, false, v);
	                        break;
	                      }
	                    }
	                  };
	                  return UniformMatrix4f2;
	                }(Uniform);
	                function packColor(color2) {
	                  return [
	                    packUint8ToFloat(255 * color2.r, 255 * color2.g),
	                    packUint8ToFloat(255 * color2.b, 255 * color2.a)
	                  ];
	                }
	                var ConstantBinder = function ConstantBinder2(value, names, type) {
	                  this.value = value;
	                  this.uniformNames = names.map(function(name3) {
	                    return "u_" + name3;
	                  });
	                  this.type = type;
	                };
	                ConstantBinder.prototype.setUniform = function setUniform(uniform, globals, currentValue) {
	                  uniform.set(currentValue.constantOr(this.value));
	                };
	                ConstantBinder.prototype.getBinding = function getBinding(context, location, _) {
	                  return this.type === "color" ? new UniformColor(context, location) : new Uniform1f(context, location);
	                };
	                var CrossFadedConstantBinder = function CrossFadedConstantBinder2(value, names) {
	                  this.uniformNames = names.map(function(name3) {
	                    return "u_" + name3;
	                  });
	                  this.patternFrom = null;
	                  this.patternTo = null;
	                  this.pixelRatioFrom = 1;
	                  this.pixelRatioTo = 1;
	                };
	                CrossFadedConstantBinder.prototype.setConstantPatternPositions = function setConstantPatternPositions(posTo, posFrom) {
	                  this.pixelRatioFrom = posFrom.pixelRatio;
	                  this.pixelRatioTo = posTo.pixelRatio;
	                  this.patternFrom = posFrom.tlbr;
	                  this.patternTo = posTo.tlbr;
	                };
	                CrossFadedConstantBinder.prototype.setUniform = function setUniform(uniform, globals, currentValue, uniformName) {
	                  var pos = uniformName === "u_pattern_to" ? this.patternTo : uniformName === "u_pattern_from" ? this.patternFrom : uniformName === "u_pixel_ratio_to" ? this.pixelRatioTo : uniformName === "u_pixel_ratio_from" ? this.pixelRatioFrom : null;
	                  if (pos) {
	                    uniform.set(pos);
	                  }
	                };
	                CrossFadedConstantBinder.prototype.getBinding = function getBinding(context, location, name3) {
	                  return name3.substr(0, 9) === "u_pattern" ? new Uniform4f(context, location) : new Uniform1f(context, location);
	                };
	                var SourceExpressionBinder = function SourceExpressionBinder2(expression2, names, type, PaintVertexArray) {
	                  this.expression = expression2;
	                  this.type = type;
	                  this.maxValue = 0;
	                  this.paintVertexAttributes = names.map(function(name3) {
	                    return {
	                      name: "a_" + name3,
	                      type: "Float32",
	                      components: type === "color" ? 2 : 1,
	                      offset: 0
	                    };
	                  });
	                  this.paintVertexArray = new PaintVertexArray();
	                };
	                SourceExpressionBinder.prototype.populatePaintArray = function populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection) {
	                  var start = this.paintVertexArray.length;
	                  var value = this.expression.evaluate(new EvaluationParameters(0), feature, {}, canonical, [], formattedSection);
	                  this.paintVertexArray.resize(newLength);
	                  this._setPaintValue(start, newLength, value);
	                };
	                SourceExpressionBinder.prototype.updatePaintArray = function updatePaintArray(start, end, feature, featureState) {
	                  var value = this.expression.evaluate({ zoom: 0 }, feature, featureState);
	                  this._setPaintValue(start, end, value);
	                };
	                SourceExpressionBinder.prototype._setPaintValue = function _setPaintValue(start, end, value) {
	                  if (this.type === "color") {
	                    var color2 = packColor(value);
	                    for (var i = start; i < end; i++) {
	                      this.paintVertexArray.emplace(i, color2[0], color2[1]);
	                    }
	                  } else {
	                    for (var i$1 = start; i$1 < end; i$1++) {
	                      this.paintVertexArray.emplace(i$1, value);
	                    }
	                    this.maxValue = Math.max(this.maxValue, Math.abs(value));
	                  }
	                };
	                SourceExpressionBinder.prototype.upload = function upload(context) {
	                  if (this.paintVertexArray && this.paintVertexArray.arrayBuffer) {
	                    if (this.paintVertexBuffer && this.paintVertexBuffer.buffer) {
	                      this.paintVertexBuffer.updateData(this.paintVertexArray);
	                    } else {
	                      this.paintVertexBuffer = context.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent);
	                    }
	                  }
	                };
	                SourceExpressionBinder.prototype.destroy = function destroy() {
	                  if (this.paintVertexBuffer) {
	                    this.paintVertexBuffer.destroy();
	                  }
	                };
	                var CompositeExpressionBinder = function CompositeExpressionBinder2(expression2, names, type, useIntegerZoom, zoom, PaintVertexArray) {
	                  this.expression = expression2;
	                  this.uniformNames = names.map(function(name3) {
	                    return "u_" + name3 + "_t";
	                  });
	                  this.type = type;
	                  this.useIntegerZoom = useIntegerZoom;
	                  this.zoom = zoom;
	                  this.maxValue = 0;
	                  this.paintVertexAttributes = names.map(function(name3) {
	                    return {
	                      name: "a_" + name3,
	                      type: "Float32",
	                      components: type === "color" ? 4 : 2,
	                      offset: 0
	                    };
	                  });
	                  this.paintVertexArray = new PaintVertexArray();
	                };
	                CompositeExpressionBinder.prototype.populatePaintArray = function populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection) {
	                  var min = this.expression.evaluate(new EvaluationParameters(this.zoom), feature, {}, canonical, [], formattedSection);
	                  var max = this.expression.evaluate(new EvaluationParameters(this.zoom + 1), feature, {}, canonical, [], formattedSection);
	                  var start = this.paintVertexArray.length;
	                  this.paintVertexArray.resize(newLength);
	                  this._setPaintValue(start, newLength, min, max);
	                };
	                CompositeExpressionBinder.prototype.updatePaintArray = function updatePaintArray(start, end, feature, featureState) {
	                  var min = this.expression.evaluate({ zoom: this.zoom }, feature, featureState);
	                  var max = this.expression.evaluate({ zoom: this.zoom + 1 }, feature, featureState);
	                  this._setPaintValue(start, end, min, max);
	                };
	                CompositeExpressionBinder.prototype._setPaintValue = function _setPaintValue(start, end, min, max) {
	                  if (this.type === "color") {
	                    var minColor = packColor(min);
	                    var maxColor = packColor(max);
	                    for (var i = start; i < end; i++) {
	                      this.paintVertexArray.emplace(i, minColor[0], minColor[1], maxColor[0], maxColor[1]);
	                    }
	                  } else {
	                    for (var i$1 = start; i$1 < end; i$1++) {
	                      this.paintVertexArray.emplace(i$1, min, max);
	                    }
	                    this.maxValue = Math.max(this.maxValue, Math.abs(min), Math.abs(max));
	                  }
	                };
	                CompositeExpressionBinder.prototype.upload = function upload(context) {
	                  if (this.paintVertexArray && this.paintVertexArray.arrayBuffer) {
	                    if (this.paintVertexBuffer && this.paintVertexBuffer.buffer) {
	                      this.paintVertexBuffer.updateData(this.paintVertexArray);
	                    } else {
	                      this.paintVertexBuffer = context.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent);
	                    }
	                  }
	                };
	                CompositeExpressionBinder.prototype.destroy = function destroy() {
	                  if (this.paintVertexBuffer) {
	                    this.paintVertexBuffer.destroy();
	                  }
	                };
	                CompositeExpressionBinder.prototype.setUniform = function setUniform(uniform, globals) {
	                  var currentZoom = this.useIntegerZoom ? Math.floor(globals.zoom) : globals.zoom;
	                  var factor = clamp(this.expression.interpolationFactor(currentZoom, this.zoom, this.zoom + 1), 0, 1);
	                  uniform.set(factor);
	                };
	                CompositeExpressionBinder.prototype.getBinding = function getBinding(context, location, _) {
	                  return new Uniform1f(context, location);
	                };
	                var CrossFadedCompositeBinder = function CrossFadedCompositeBinder2(expression2, type, useIntegerZoom, zoom, PaintVertexArray, layerId) {
	                  this.expression = expression2;
	                  this.type = type;
	                  this.useIntegerZoom = useIntegerZoom;
	                  this.zoom = zoom;
	                  this.layerId = layerId;
	                  this.zoomInPaintVertexArray = new PaintVertexArray();
	                  this.zoomOutPaintVertexArray = new PaintVertexArray();
	                };
	                CrossFadedCompositeBinder.prototype.populatePaintArray = function populatePaintArray(length, feature, imagePositions) {
	                  var start = this.zoomInPaintVertexArray.length;
	                  this.zoomInPaintVertexArray.resize(length);
	                  this.zoomOutPaintVertexArray.resize(length);
	                  this._setPaintValues(start, length, feature.patterns && feature.patterns[this.layerId], imagePositions);
	                };
	                CrossFadedCompositeBinder.prototype.updatePaintArray = function updatePaintArray(start, end, feature, featureState, imagePositions) {
	                  this._setPaintValues(start, end, feature.patterns && feature.patterns[this.layerId], imagePositions);
	                };
	                CrossFadedCompositeBinder.prototype._setPaintValues = function _setPaintValues(start, end, patterns, positions) {
	                  if (!positions || !patterns) {
	                    return;
	                  }
	                  var min = patterns.min;
	                  var mid = patterns.mid;
	                  var max = patterns.max;
	                  var imageMin = positions[min];
	                  var imageMid = positions[mid];
	                  var imageMax = positions[max];
	                  if (!imageMin || !imageMid || !imageMax) {
	                    return;
	                  }
	                  for (var i = start; i < end; i++) {
	                    this.zoomInPaintVertexArray.emplace(i, imageMid.tl[0], imageMid.tl[1], imageMid.br[0], imageMid.br[1], imageMin.tl[0], imageMin.tl[1], imageMin.br[0], imageMin.br[1], imageMid.pixelRatio, imageMin.pixelRatio);
	                    this.zoomOutPaintVertexArray.emplace(i, imageMid.tl[0], imageMid.tl[1], imageMid.br[0], imageMid.br[1], imageMax.tl[0], imageMax.tl[1], imageMax.br[0], imageMax.br[1], imageMid.pixelRatio, imageMax.pixelRatio);
	                  }
	                };
	                CrossFadedCompositeBinder.prototype.upload = function upload(context) {
	                  if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
	                    this.zoomInPaintVertexBuffer = context.createVertexBuffer(this.zoomInPaintVertexArray, patternAttributes.members, this.expression.isStateDependent);
	                    this.zoomOutPaintVertexBuffer = context.createVertexBuffer(this.zoomOutPaintVertexArray, patternAttributes.members, this.expression.isStateDependent);
	                  }
	                };
	                CrossFadedCompositeBinder.prototype.destroy = function destroy() {
	                  if (this.zoomOutPaintVertexBuffer) {
	                    this.zoomOutPaintVertexBuffer.destroy();
	                  }
	                  if (this.zoomInPaintVertexBuffer) {
	                    this.zoomInPaintVertexBuffer.destroy();
	                  }
	                };
	                var ProgramConfiguration = function ProgramConfiguration2(layer2, zoom, filterProperties, layoutAttributes) {
	                  this.binders = {};
	                  this.layoutAttributes = layoutAttributes;
	                  this._buffers = [];
	                  var keys = [];
	                  for (var property in layer2.paint._values) {
	                    if (!filterProperties(property)) {
	                      continue;
	                    }
	                    var value = layer2.paint.get(property);
	                    if (!(value instanceof PossiblyEvaluatedPropertyValue) || !supportsPropertyExpression(value.property.specification)) {
	                      continue;
	                    }
	                    var names = paintAttributeNames(property, layer2.type);
	                    var expression2 = value.value;
	                    var type = value.property.specification.type;
	                    var useIntegerZoom = value.property.useIntegerZoom;
	                    var propType = value.property.specification["property-type"];
	                    var isCrossFaded = propType === "cross-faded" || propType === "cross-faded-data-driven";
	                    if (expression2.kind === "constant") {
	                      this.binders[property] = isCrossFaded ? new CrossFadedConstantBinder(expression2.value, names) : new ConstantBinder(expression2.value, names, type);
	                      keys.push("/u_" + property);
	                    } else if (expression2.kind === "source" || isCrossFaded) {
	                      var StructArrayLayout = layoutType(property, type, "source");
	                      this.binders[property] = isCrossFaded ? new CrossFadedCompositeBinder(expression2, type, useIntegerZoom, zoom, StructArrayLayout, layer2.id) : new SourceExpressionBinder(expression2, names, type, StructArrayLayout);
	                      keys.push("/a_" + property);
	                    } else {
	                      var StructArrayLayout$1 = layoutType(property, type, "composite");
	                      this.binders[property] = new CompositeExpressionBinder(expression2, names, type, useIntegerZoom, zoom, StructArrayLayout$1);
	                      keys.push("/z_" + property);
	                    }
	                  }
	                  this.cacheKey = keys.sort().join("");
	                };
	                ProgramConfiguration.prototype.getMaxValue = function getMaxValue(property) {
	                  var binder = this.binders[property];
	                  return binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder ? binder.maxValue : 0;
	                };
	                ProgramConfiguration.prototype.populatePaintArrays = function populatePaintArrays(newLength, feature, imagePositions, canonical, formattedSection) {
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) {
	                      binder.populatePaintArray(newLength, feature, imagePositions, canonical, formattedSection);
	                    }
	                  }
	                };
	                ProgramConfiguration.prototype.setConstantPatternPositions = function setConstantPatternPositions(posTo, posFrom) {
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (binder instanceof CrossFadedConstantBinder) {
	                      binder.setConstantPatternPositions(posTo, posFrom);
	                    }
	                  }
	                };
	                ProgramConfiguration.prototype.updatePaintArrays = function updatePaintArrays(featureStates, featureMap, vtLayer, layer2, imagePositions) {
	                  var dirty = false;
	                  for (var id2 in featureStates) {
	                    var positions = featureMap.getPositions(id2);
	                    for (var i = 0, list = positions; i < list.length; i += 1) {
	                      var pos = list[i];
	                      var feature = vtLayer.feature(pos.index);
	                      for (var property in this.binders) {
	                        var binder = this.binders[property];
	                        if ((binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) && binder.expression.isStateDependent === true) {
	                          var value = layer2.paint.get(property);
	                          binder.expression = value.value;
	                          binder.updatePaintArray(pos.start, pos.end, feature, featureStates[id2], imagePositions);
	                          dirty = true;
	                        }
	                      }
	                    }
	                  }
	                  return dirty;
	                };
	                ProgramConfiguration.prototype.defines = function defines() {
	                  var result = [];
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder) {
	                      result.push.apply(result, binder.uniformNames.map(function(name3) {
	                        return "#define HAS_UNIFORM_" + name3;
	                      }));
	                    }
	                  }
	                  return result;
	                };
	                ProgramConfiguration.prototype.getPaintVertexBuffers = function getPaintVertexBuffers() {
	                  return this._buffers;
	                };
	                ProgramConfiguration.prototype.getUniforms = function getUniforms(context, locations) {
	                  var uniforms = [];
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (binder instanceof ConstantBinder || binder instanceof CrossFadedConstantBinder || binder instanceof CompositeExpressionBinder) {
	                      for (var i = 0, list = binder.uniformNames; i < list.length; i += 1) {
	                        var name3 = list[i];
	                        if (locations[name3]) {
	                          var binding = binder.getBinding(context, locations[name3], name3);
	                          uniforms.push({
	                            name: name3,
	                            property,
	                            binding
	                          });
	                        }
	                      }
	                    }
	                  }
	                  return uniforms;
	                };
	                ProgramConfiguration.prototype.setUniforms = function setUniforms(context, binderUniforms, properties2, globals) {
	                  for (var i = 0, list = binderUniforms; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var name3 = ref.name;
	                    var property = ref.property;
	                    var binding = ref.binding;
	                    this.binders[property].setUniform(binding, globals, properties2.get(property), name3);
	                  }
	                };
	                ProgramConfiguration.prototype.updatePaintBuffers = function updatePaintBuffers(crossfade) {
	                  this._buffers = [];
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (crossfade && binder instanceof CrossFadedCompositeBinder) {
	                      var patternVertexBuffer = crossfade.fromScale === 2 ? binder.zoomInPaintVertexBuffer : binder.zoomOutPaintVertexBuffer;
	                      if (patternVertexBuffer) {
	                        this._buffers.push(patternVertexBuffer);
	                      }
	                    } else if ((binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder) && binder.paintVertexBuffer) {
	                      this._buffers.push(binder.paintVertexBuffer);
	                    }
	                  }
	                };
	                ProgramConfiguration.prototype.upload = function upload(context) {
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) {
	                      binder.upload(context);
	                    }
	                  }
	                  this.updatePaintBuffers();
	                };
	                ProgramConfiguration.prototype.destroy = function destroy() {
	                  for (var property in this.binders) {
	                    var binder = this.binders[property];
	                    if (binder instanceof SourceExpressionBinder || binder instanceof CompositeExpressionBinder || binder instanceof CrossFadedCompositeBinder) {
	                      binder.destroy();
	                    }
	                  }
	                };
	                var ProgramConfigurationSet = function ProgramConfigurationSet2(layoutAttributes, layers, zoom, filterProperties) {
	                  if (filterProperties === undefined)
	                    filterProperties = function() {
	                      return true;
	                    };
	                  this.programConfigurations = {};
	                  for (var i = 0, list = layers; i < list.length; i += 1) {
	                    var layer2 = list[i];
	                    this.programConfigurations[layer2.id] = new ProgramConfiguration(layer2, zoom, filterProperties, layoutAttributes);
	                  }
	                  this.needsUpload = false;
	                  this._featureMap = new FeaturePositionMap();
	                  this._bufferOffset = 0;
	                };
	                ProgramConfigurationSet.prototype.populatePaintArrays = function populatePaintArrays(length, feature, index, imagePositions, canonical, formattedSection) {
	                  for (var key in this.programConfigurations) {
	                    this.programConfigurations[key].populatePaintArrays(length, feature, imagePositions, canonical, formattedSection);
	                  }
	                  if (feature.id !== undefined) {
	                    this._featureMap.add(feature.id, index, this._bufferOffset, length);
	                  }
	                  this._bufferOffset = length;
	                  this.needsUpload = true;
	                };
	                ProgramConfigurationSet.prototype.updatePaintArrays = function updatePaintArrays(featureStates, vtLayer, layers, imagePositions) {
	                  for (var i = 0, list = layers; i < list.length; i += 1) {
	                    var layer2 = list[i];
	                    this.needsUpload = this.programConfigurations[layer2.id].updatePaintArrays(featureStates, this._featureMap, vtLayer, layer2, imagePositions) || this.needsUpload;
	                  }
	                };
	                ProgramConfigurationSet.prototype.get = function get2(layerId) {
	                  return this.programConfigurations[layerId];
	                };
	                ProgramConfigurationSet.prototype.upload = function upload(context) {
	                  if (!this.needsUpload) {
	                    return;
	                  }
	                  for (var layerId in this.programConfigurations) {
	                    this.programConfigurations[layerId].upload(context);
	                  }
	                  this.needsUpload = false;
	                };
	                ProgramConfigurationSet.prototype.destroy = function destroy() {
	                  for (var layerId in this.programConfigurations) {
	                    this.programConfigurations[layerId].destroy();
	                  }
	                };
	                function paintAttributeNames(property, type) {
	                  var attributeNameExceptions = {
	                    "text-opacity": ["opacity"],
	                    "icon-opacity": ["opacity"],
	                    "text-color": ["fill_color"],
	                    "icon-color": ["fill_color"],
	                    "text-halo-color": ["halo_color"],
	                    "icon-halo-color": ["halo_color"],
	                    "text-halo-blur": ["halo_blur"],
	                    "icon-halo-blur": ["halo_blur"],
	                    "text-halo-width": ["halo_width"],
	                    "icon-halo-width": ["halo_width"],
	                    "line-gap-width": ["gapwidth"],
	                    "line-pattern": [
	                      "pattern_to",
	                      "pattern_from",
	                      "pixel_ratio_to",
	                      "pixel_ratio_from"
	                    ],
	                    "fill-pattern": [
	                      "pattern_to",
	                      "pattern_from",
	                      "pixel_ratio_to",
	                      "pixel_ratio_from"
	                    ],
	                    "fill-extrusion-pattern": [
	                      "pattern_to",
	                      "pattern_from",
	                      "pixel_ratio_to",
	                      "pixel_ratio_from"
	                    ]
	                  };
	                  return attributeNameExceptions[property] || [property.replace(type + "-", "").replace(/-/g, "_")];
	                }
	                function getLayoutException(property) {
	                  var propertyExceptions = {
	                    "line-pattern": {
	                      "source": StructArrayLayout8ui2ub18,
	                      "composite": StructArrayLayout8ui2ub18
	                    },
	                    "fill-pattern": {
	                      "source": StructArrayLayout8ui2ub18,
	                      "composite": StructArrayLayout8ui2ub18
	                    },
	                    "fill-extrusion-pattern": {
	                      "source": StructArrayLayout8ui2ub18,
	                      "composite": StructArrayLayout8ui2ub18
	                    }
	                  };
	                  return propertyExceptions[property];
	                }
	                function layoutType(property, type, binderType) {
	                  var defaultLayouts = {
	                    "color": {
	                      "source": StructArrayLayout2f8,
	                      "composite": StructArrayLayout4f16
	                    },
	                    "number": {
	                      "source": StructArrayLayout1f4,
	                      "composite": StructArrayLayout2f8
	                    }
	                  };
	                  var layoutException = getLayoutException(property);
	                  return layoutException && layoutException[binderType] || defaultLayouts[type][binderType];
	                }
	                register("ConstantBinder", ConstantBinder);
	                register("CrossFadedConstantBinder", CrossFadedConstantBinder);
	                register("SourceExpressionBinder", SourceExpressionBinder);
	                register("CrossFadedCompositeBinder", CrossFadedCompositeBinder);
	                register("CompositeExpressionBinder", CompositeExpressionBinder);
	                register("ProgramConfiguration", ProgramConfiguration, { omit: ["_buffers"] });
	                register("ProgramConfigurationSet", ProgramConfigurationSet);
	                var EXTENT$1 = 8192;
	                function createBounds(bits) {
	                  return {
	                    min: -1 * Math.pow(2, bits - 1),
	                    max: Math.pow(2, bits - 1) - 1
	                  };
	                }
	                var bounds = createBounds(15);
	                function loadGeometry(feature) {
	                  var scale2 = EXTENT$1 / feature.extent;
	                  var geometry = feature.loadGeometry();
	                  for (var r = 0; r < geometry.length; r++) {
	                    var ring = geometry[r];
	                    for (var p = 0; p < ring.length; p++) {
	                      var point = ring[p];
	                      point.x = Math.round(point.x * scale2);
	                      point.y = Math.round(point.y * scale2);
	                      if (point.x < bounds.min || point.x > bounds.max || point.y < bounds.min || point.y > bounds.max) {
	                        warnOnce("Geometry exceeds allowed extent, reduce your vector tile buffer size");
	                        point.x = clamp(point.x, bounds.min, bounds.max);
	                        point.y = clamp(point.y, bounds.min, bounds.max);
	                      }
	                    }
	                  }
	                  return geometry;
	                }
	                function addCircleVertex(layoutVertexArray, x, y, extrudeX, extrudeY) {
	                  layoutVertexArray.emplaceBack(x * 2 + (extrudeX + 1) / 2, y * 2 + (extrudeY + 1) / 2);
	                }
	                var CircleBucket = function CircleBucket2(options) {
	                  this.zoom = options.zoom;
	                  this.overscaling = options.overscaling;
	                  this.layers = options.layers;
	                  this.layerIds = this.layers.map(function(layer2) {
	                    return layer2.id;
	                  });
	                  this.index = options.index;
	                  this.hasPattern = false;
	                  this.layoutVertexArray = new StructArrayLayout2i4();
	                  this.indexArray = new StructArrayLayout3ui6();
	                  this.segments = new SegmentVector();
	                  this.programConfigurations = new ProgramConfigurationSet(members, options.layers, options.zoom);
	                  this.stateDependentLayerIds = this.layers.filter(function(l) {
	                    return l.isStateDependent();
	                  }).map(function(l) {
	                    return l.id;
	                  });
	                };
	                CircleBucket.prototype.populate = function populate(features, options, canonical) {
	                  var styleLayer = this.layers[0];
	                  var bucketFeatures = [];
	                  var circleSortKey = null;
	                  if (styleLayer.type === "circle") {
	                    circleSortKey = styleLayer.layout.get("circle-sort-key");
	                  }
	                  for (var i = 0, list = features; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var feature = ref.feature;
	                    var id2 = ref.id;
	                    var index = ref.index;
	                    var sourceLayerIndex = ref.sourceLayerIndex;
	                    var needGeometry = this.layers[0]._featureFilter.needGeometry;
	                    var evaluationFeature = {
	                      type: feature.type,
	                      id: id2,
	                      properties: feature.properties,
	                      geometry: needGeometry ? loadGeometry(feature) : []
	                    };
	                    if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
	                      continue;
	                    }
	                    if (!needGeometry) {
	                      evaluationFeature.geometry = loadGeometry(feature);
	                    }
	                    var sortKey = circleSortKey ? circleSortKey.evaluate(evaluationFeature, {}, canonical) : undefined;
	                    var bucketFeature = {
	                      id: id2,
	                      properties: feature.properties,
	                      type: feature.type,
	                      sourceLayerIndex,
	                      index,
	                      geometry: evaluationFeature.geometry,
	                      patterns: {},
	                      sortKey
	                    };
	                    bucketFeatures.push(bucketFeature);
	                  }
	                  if (circleSortKey) {
	                    bucketFeatures.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                  for (var i$1 = 0, list$1 = bucketFeatures; i$1 < list$1.length; i$1 += 1) {
	                    var bucketFeature$1 = list$1[i$1];
	                    var ref$1 = bucketFeature$1;
	                    var geometry = ref$1.geometry;
	                    var index$1 = ref$1.index;
	                    var sourceLayerIndex$1 = ref$1.sourceLayerIndex;
	                    var feature$1 = features[index$1].feature;
	                    this.addFeature(bucketFeature$1, geometry, index$1, canonical);
	                    options.featureIndex.insert(feature$1, geometry, index$1, sourceLayerIndex$1, this.index);
	                  }
	                };
	                CircleBucket.prototype.update = function update(states, vtLayer, imagePositions) {
	                  if (!this.stateDependentLayers.length) {
	                    return;
	                  }
	                  this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
	                };
	                CircleBucket.prototype.isEmpty = function isEmpty2() {
	                  return this.layoutVertexArray.length === 0;
	                };
	                CircleBucket.prototype.uploadPending = function uploadPending() {
	                  return !this.uploaded || this.programConfigurations.needsUpload;
	                };
	                CircleBucket.prototype.upload = function upload(context) {
	                  if (!this.uploaded) {
	                    this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members);
	                    this.indexBuffer = context.createIndexBuffer(this.indexArray);
	                  }
	                  this.programConfigurations.upload(context);
	                  this.uploaded = true;
	                };
	                CircleBucket.prototype.destroy = function destroy() {
	                  if (!this.layoutVertexBuffer) {
	                    return;
	                  }
	                  this.layoutVertexBuffer.destroy();
	                  this.indexBuffer.destroy();
	                  this.programConfigurations.destroy();
	                  this.segments.destroy();
	                };
	                CircleBucket.prototype.addFeature = function addFeature2(feature, geometry, index, canonical) {
	                  for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
	                    var ring = list$1[i$1];
	                    for (var i = 0, list = ring; i < list.length; i += 1) {
	                      var point = list[i];
	                      var x = point.x;
	                      var y = point.y;
	                      if (x < 0 || x >= EXTENT$1 || y < 0 || y >= EXTENT$1) {
	                        continue;
	                      }
	                      var segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, feature.sortKey);
	                      var index$1 = segment.vertexLength;
	                      addCircleVertex(this.layoutVertexArray, x, y, -1, -1);
	                      addCircleVertex(this.layoutVertexArray, x, y, 1, -1);
	                      addCircleVertex(this.layoutVertexArray, x, y, 1, 1);
	                      addCircleVertex(this.layoutVertexArray, x, y, -1, 1);
	                      this.indexArray.emplaceBack(index$1, index$1 + 1, index$1 + 2);
	                      this.indexArray.emplaceBack(index$1, index$1 + 3, index$1 + 2);
	                      segment.vertexLength += 4;
	                      segment.primitiveLength += 2;
	                    }
	                  }
	                  this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, {}, canonical);
	                };
	                register("CircleBucket", CircleBucket, { omit: ["layers"] });
	                function polygonIntersectsPolygon(polygonA, polygonB) {
	                  for (var i = 0; i < polygonA.length; i++) {
	                    if (polygonContainsPoint(polygonB, polygonA[i])) {
	                      return true;
	                    }
	                  }
	                  for (var i$1 = 0; i$1 < polygonB.length; i$1++) {
	                    if (polygonContainsPoint(polygonA, polygonB[i$1])) {
	                      return true;
	                    }
	                  }
	                  if (lineIntersectsLine(polygonA, polygonB)) {
	                    return true;
	                  }
	                  return false;
	                }
	                function polygonIntersectsBufferedPoint(polygon, point, radius) {
	                  if (polygonContainsPoint(polygon, point)) {
	                    return true;
	                  }
	                  if (pointIntersectsBufferedLine(point, polygon, radius)) {
	                    return true;
	                  }
	                  return false;
	                }
	                function polygonIntersectsMultiPolygon(polygon, multiPolygon) {
	                  if (polygon.length === 1) {
	                    return multiPolygonContainsPoint(multiPolygon, polygon[0]);
	                  }
	                  for (var m = 0; m < multiPolygon.length; m++) {
	                    var ring = multiPolygon[m];
	                    for (var n = 0; n < ring.length; n++) {
	                      if (polygonContainsPoint(polygon, ring[n])) {
	                        return true;
	                      }
	                    }
	                  }
	                  for (var i = 0; i < polygon.length; i++) {
	                    if (multiPolygonContainsPoint(multiPolygon, polygon[i])) {
	                      return true;
	                    }
	                  }
	                  for (var k = 0; k < multiPolygon.length; k++) {
	                    if (lineIntersectsLine(polygon, multiPolygon[k])) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function polygonIntersectsBufferedMultiLine(polygon, multiLine, radius) {
	                  for (var i = 0; i < multiLine.length; i++) {
	                    var line = multiLine[i];
	                    if (polygon.length >= 3) {
	                      for (var k = 0; k < line.length; k++) {
	                        if (polygonContainsPoint(polygon, line[k])) {
	                          return true;
	                        }
	                      }
	                    }
	                    if (lineIntersectsBufferedLine(polygon, line, radius)) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function lineIntersectsBufferedLine(lineA, lineB, radius) {
	                  if (lineA.length > 1) {
	                    if (lineIntersectsLine(lineA, lineB)) {
	                      return true;
	                    }
	                    for (var j = 0; j < lineB.length; j++) {
	                      if (pointIntersectsBufferedLine(lineB[j], lineA, radius)) {
	                        return true;
	                      }
	                    }
	                  }
	                  for (var k = 0; k < lineA.length; k++) {
	                    if (pointIntersectsBufferedLine(lineA[k], lineB, radius)) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function lineIntersectsLine(lineA, lineB) {
	                  if (lineA.length === 0 || lineB.length === 0) {
	                    return false;
	                  }
	                  for (var i = 0; i < lineA.length - 1; i++) {
	                    var a0 = lineA[i];
	                    var a1 = lineA[i + 1];
	                    for (var j = 0; j < lineB.length - 1; j++) {
	                      var b0 = lineB[j];
	                      var b1 = lineB[j + 1];
	                      if (lineSegmentIntersectsLineSegment(a0, a1, b0, b1)) {
	                        return true;
	                      }
	                    }
	                  }
	                  return false;
	                }
	                function lineSegmentIntersectsLineSegment(a0, a1, b0, b1) {
	                  return isCounterClockwise(a0, b0, b1) !== isCounterClockwise(a1, b0, b1) && isCounterClockwise(a0, a1, b0) !== isCounterClockwise(a0, a1, b1);
	                }
	                function pointIntersectsBufferedLine(p, line, radius) {
	                  var radiusSquared = radius * radius;
	                  if (line.length === 1) {
	                    return p.distSqr(line[0]) < radiusSquared;
	                  }
	                  for (var i = 1; i < line.length; i++) {
	                    var v = line[i - 1], w = line[i];
	                    if (distToSegmentSquared(p, v, w) < radiusSquared) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function distToSegmentSquared(p, v, w) {
	                  var l2 = v.distSqr(w);
	                  if (l2 === 0) {
	                    return p.distSqr(v);
	                  }
	                  var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
	                  if (t < 0) {
	                    return p.distSqr(v);
	                  }
	                  if (t > 1) {
	                    return p.distSqr(w);
	                  }
	                  return p.distSqr(w.sub(v)._mult(t)._add(v));
	                }
	                function multiPolygonContainsPoint(rings, p) {
	                  var c = false, ring, p1, p2;
	                  for (var k = 0; k < rings.length; k++) {
	                    ring = rings[k];
	                    for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
	                      p1 = ring[i];
	                      p2 = ring[j];
	                      if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
	                        c = !c;
	                      }
	                    }
	                  }
	                  return c;
	                }
	                function polygonContainsPoint(ring, p) {
	                  var c = false;
	                  for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
	                    var p1 = ring[i];
	                    var p2 = ring[j];
	                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
	                      c = !c;
	                    }
	                  }
	                  return c;
	                }
	                function polygonIntersectsBox(ring, boxX1, boxY1, boxX2, boxY2) {
	                  for (var i$1 = 0, list = ring; i$1 < list.length; i$1 += 1) {
	                    var p = list[i$1];
	                    if (boxX1 <= p.x && boxY1 <= p.y && boxX2 >= p.x && boxY2 >= p.y) {
	                      return true;
	                    }
	                  }
	                  var corners = [
	                    new pointGeometry(boxX1, boxY1),
	                    new pointGeometry(boxX1, boxY2),
	                    new pointGeometry(boxX2, boxY2),
	                    new pointGeometry(boxX2, boxY1)
	                  ];
	                  if (ring.length > 2) {
	                    for (var i$2 = 0, list$1 = corners; i$2 < list$1.length; i$2 += 1) {
	                      var corner = list$1[i$2];
	                      if (polygonContainsPoint(ring, corner)) {
	                        return true;
	                      }
	                    }
	                  }
	                  for (var i = 0; i < ring.length - 1; i++) {
	                    var p1 = ring[i];
	                    var p2 = ring[i + 1];
	                    if (edgeIntersectsBox(p1, p2, corners)) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                function edgeIntersectsBox(e1, e2, corners) {
	                  var tl = corners[0];
	                  var br = corners[2];
	                  if (e1.x < tl.x && e2.x < tl.x || e1.x > br.x && e2.x > br.x || e1.y < tl.y && e2.y < tl.y || e1.y > br.y && e2.y > br.y) {
	                    return false;
	                  }
	                  var dir = isCounterClockwise(e1, e2, corners[0]);
	                  return dir !== isCounterClockwise(e1, e2, corners[1]) || dir !== isCounterClockwise(e1, e2, corners[2]) || dir !== isCounterClockwise(e1, e2, corners[3]);
	                }
	                function getMaximumPaintValue(property, layer2, bucket) {
	                  var value = layer2.paint.get(property).value;
	                  if (value.kind === "constant") {
	                    return value.value;
	                  } else {
	                    return bucket.programConfigurations.get(layer2.id).getMaxValue(property);
	                  }
	                }
	                function translateDistance(translate2) {
	                  return Math.sqrt(translate2[0] * translate2[0] + translate2[1] * translate2[1]);
	                }
	                function translate(queryGeometry, translate2, translateAnchor, bearing, pixelsToTileUnits) {
	                  if (!translate2[0] && !translate2[1]) {
	                    return queryGeometry;
	                  }
	                  var pt = pointGeometry.convert(translate2)._mult(pixelsToTileUnits);
	                  if (translateAnchor === "viewport") {
	                    pt._rotate(-bearing);
	                  }
	                  var translated = [];
	                  for (var i = 0; i < queryGeometry.length; i++) {
	                    var point = queryGeometry[i];
	                    translated.push(point.sub(pt));
	                  }
	                  return translated;
	                }
	                var layout$2 = new Properties({ "circle-sort-key": new DataDrivenProperty(spec["layout_circle"]["circle-sort-key"]) });
	                var paint$1 = new Properties({
	                  "circle-radius": new DataDrivenProperty(spec["paint_circle"]["circle-radius"]),
	                  "circle-color": new DataDrivenProperty(spec["paint_circle"]["circle-color"]),
	                  "circle-blur": new DataDrivenProperty(spec["paint_circle"]["circle-blur"]),
	                  "circle-opacity": new DataDrivenProperty(spec["paint_circle"]["circle-opacity"]),
	                  "circle-translate": new DataConstantProperty(spec["paint_circle"]["circle-translate"]),
	                  "circle-translate-anchor": new DataConstantProperty(spec["paint_circle"]["circle-translate-anchor"]),
	                  "circle-pitch-scale": new DataConstantProperty(spec["paint_circle"]["circle-pitch-scale"]),
	                  "circle-pitch-alignment": new DataConstantProperty(spec["paint_circle"]["circle-pitch-alignment"]),
	                  "circle-stroke-width": new DataDrivenProperty(spec["paint_circle"]["circle-stroke-width"]),
	                  "circle-stroke-color": new DataDrivenProperty(spec["paint_circle"]["circle-stroke-color"]),
	                  "circle-stroke-opacity": new DataDrivenProperty(spec["paint_circle"]["circle-stroke-opacity"])
	                });
	                var properties = {
	                  paint: paint$1,
	                  layout: layout$2
	                };
	                var ARRAY_TYPE = typeof Float32Array !== "undefined" ? Float32Array : Array;
	                if (!Math.hypot) {
	                  Math.hypot = function() {
	                    var arguments$1 = arguments;
	                    var y = 0, i = arguments.length;
	                    while (i--) {
	                      y += arguments$1[i] * arguments$1[i];
	                    }
	                    return Math.sqrt(y);
	                  };
	                }
	                function create() {
	                  var out = new ARRAY_TYPE(4);
	                  if (ARRAY_TYPE != Float32Array) {
	                    out[1] = 0;
	                    out[2] = 0;
	                  }
	                  out[0] = 1;
	                  out[3] = 1;
	                  return out;
	                }
	                function rotate(out, a, rad) {
	                  var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
	                  var s = Math.sin(rad);
	                  var c = Math.cos(rad);
	                  out[0] = a0 * c + a2 * s;
	                  out[1] = a1 * c + a3 * s;
	                  out[2] = a0 * -s + a2 * c;
	                  out[3] = a1 * -s + a3 * c;
	                  return out;
	                }
	                function create$1() {
	                  var out = new ARRAY_TYPE(9);
	                  if (ARRAY_TYPE != Float32Array) {
	                    out[1] = 0;
	                    out[2] = 0;
	                    out[3] = 0;
	                    out[5] = 0;
	                    out[6] = 0;
	                    out[7] = 0;
	                  }
	                  out[0] = 1;
	                  out[4] = 1;
	                  out[8] = 1;
	                  return out;
	                }
	                function fromRotation(out, rad) {
	                  var s = Math.sin(rad), c = Math.cos(rad);
	                  out[0] = c;
	                  out[1] = s;
	                  out[2] = 0;
	                  out[3] = -s;
	                  out[4] = c;
	                  out[5] = 0;
	                  out[6] = 0;
	                  out[7] = 0;
	                  out[8] = 1;
	                  return out;
	                }
	                function create$2() {
	                  var out = new ARRAY_TYPE(16);
	                  if (ARRAY_TYPE != Float32Array) {
	                    out[1] = 0;
	                    out[2] = 0;
	                    out[3] = 0;
	                    out[4] = 0;
	                    out[6] = 0;
	                    out[7] = 0;
	                    out[8] = 0;
	                    out[9] = 0;
	                    out[11] = 0;
	                    out[12] = 0;
	                    out[13] = 0;
	                    out[14] = 0;
	                  }
	                  out[0] = 1;
	                  out[5] = 1;
	                  out[10] = 1;
	                  out[15] = 1;
	                  return out;
	                }
	                function clone$1(a) {
	                  var out = new ARRAY_TYPE(16);
	                  out[0] = a[0];
	                  out[1] = a[1];
	                  out[2] = a[2];
	                  out[3] = a[3];
	                  out[4] = a[4];
	                  out[5] = a[5];
	                  out[6] = a[6];
	                  out[7] = a[7];
	                  out[8] = a[8];
	                  out[9] = a[9];
	                  out[10] = a[10];
	                  out[11] = a[11];
	                  out[12] = a[12];
	                  out[13] = a[13];
	                  out[14] = a[14];
	                  out[15] = a[15];
	                  return out;
	                }
	                function identity2(out) {
	                  out[0] = 1;
	                  out[1] = 0;
	                  out[2] = 0;
	                  out[3] = 0;
	                  out[4] = 0;
	                  out[5] = 1;
	                  out[6] = 0;
	                  out[7] = 0;
	                  out[8] = 0;
	                  out[9] = 0;
	                  out[10] = 1;
	                  out[11] = 0;
	                  out[12] = 0;
	                  out[13] = 0;
	                  out[14] = 0;
	                  out[15] = 1;
	                  return out;
	                }
	                function invert(out, a) {
	                  var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
	                  var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
	                  var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
	                  var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	                  var b00 = a00 * a11 - a01 * a10;
	                  var b01 = a00 * a12 - a02 * a10;
	                  var b02 = a00 * a13 - a03 * a10;
	                  var b03 = a01 * a12 - a02 * a11;
	                  var b04 = a01 * a13 - a03 * a11;
	                  var b05 = a02 * a13 - a03 * a12;
	                  var b06 = a20 * a31 - a21 * a30;
	                  var b07 = a20 * a32 - a22 * a30;
	                  var b08 = a20 * a33 - a23 * a30;
	                  var b09 = a21 * a32 - a22 * a31;
	                  var b10 = a21 * a33 - a23 * a31;
	                  var b11 = a22 * a33 - a23 * a32;
	                  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	                  if (!det) {
	                    return null;
	                  }
	                  det = 1 / det;
	                  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	                  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	                  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	                  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	                  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	                  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	                  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	                  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	                  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	                  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	                  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	                  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	                  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	                  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	                  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	                  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	                  return out;
	                }
	                function multiply(out, a, b) {
	                  var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
	                  var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
	                  var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
	                  var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
	                  var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
	                  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                  b0 = b[4];
	                  b1 = b[5];
	                  b2 = b[6];
	                  b3 = b[7];
	                  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                  b0 = b[8];
	                  b1 = b[9];
	                  b2 = b[10];
	                  b3 = b[11];
	                  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                  b0 = b[12];
	                  b1 = b[13];
	                  b2 = b[14];
	                  b3 = b[15];
	                  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	                  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	                  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	                  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	                  return out;
	                }
	                function translate$1(out, a, v) {
	                  var x = v[0], y = v[1], z = v[2];
	                  var a00, a01, a02, a03;
	                  var a10, a11, a12, a13;
	                  var a20, a21, a22, a23;
	                  if (a === out) {
	                    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
	                    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
	                    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
	                    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
	                  } else {
	                    a00 = a[0];
	                    a01 = a[1];
	                    a02 = a[2];
	                    a03 = a[3];
	                    a10 = a[4];
	                    a11 = a[5];
	                    a12 = a[6];
	                    a13 = a[7];
	                    a20 = a[8];
	                    a21 = a[9];
	                    a22 = a[10];
	                    a23 = a[11];
	                    out[0] = a00;
	                    out[1] = a01;
	                    out[2] = a02;
	                    out[3] = a03;
	                    out[4] = a10;
	                    out[5] = a11;
	                    out[6] = a12;
	                    out[7] = a13;
	                    out[8] = a20;
	                    out[9] = a21;
	                    out[10] = a22;
	                    out[11] = a23;
	                    out[12] = a00 * x + a10 * y + a20 * z + a[12];
	                    out[13] = a01 * x + a11 * y + a21 * z + a[13];
	                    out[14] = a02 * x + a12 * y + a22 * z + a[14];
	                    out[15] = a03 * x + a13 * y + a23 * z + a[15];
	                  }
	                  return out;
	                }
	                function scale(out, a, v) {
	                  var x = v[0], y = v[1], z = v[2];
	                  out[0] = a[0] * x;
	                  out[1] = a[1] * x;
	                  out[2] = a[2] * x;
	                  out[3] = a[3] * x;
	                  out[4] = a[4] * y;
	                  out[5] = a[5] * y;
	                  out[6] = a[6] * y;
	                  out[7] = a[7] * y;
	                  out[8] = a[8] * z;
	                  out[9] = a[9] * z;
	                  out[10] = a[10] * z;
	                  out[11] = a[11] * z;
	                  out[12] = a[12];
	                  out[13] = a[13];
	                  out[14] = a[14];
	                  out[15] = a[15];
	                  return out;
	                }
	                function rotateX(out, a, rad) {
	                  var s = Math.sin(rad);
	                  var c = Math.cos(rad);
	                  var a10 = a[4];
	                  var a11 = a[5];
	                  var a12 = a[6];
	                  var a13 = a[7];
	                  var a20 = a[8];
	                  var a21 = a[9];
	                  var a22 = a[10];
	                  var a23 = a[11];
	                  if (a !== out) {
	                    out[0] = a[0];
	                    out[1] = a[1];
	                    out[2] = a[2];
	                    out[3] = a[3];
	                    out[12] = a[12];
	                    out[13] = a[13];
	                    out[14] = a[14];
	                    out[15] = a[15];
	                  }
	                  out[4] = a10 * c + a20 * s;
	                  out[5] = a11 * c + a21 * s;
	                  out[6] = a12 * c + a22 * s;
	                  out[7] = a13 * c + a23 * s;
	                  out[8] = a20 * c - a10 * s;
	                  out[9] = a21 * c - a11 * s;
	                  out[10] = a22 * c - a12 * s;
	                  out[11] = a23 * c - a13 * s;
	                  return out;
	                }
	                function rotateZ(out, a, rad) {
	                  var s = Math.sin(rad);
	                  var c = Math.cos(rad);
	                  var a00 = a[0];
	                  var a01 = a[1];
	                  var a02 = a[2];
	                  var a03 = a[3];
	                  var a10 = a[4];
	                  var a11 = a[5];
	                  var a12 = a[6];
	                  var a13 = a[7];
	                  if (a !== out) {
	                    out[8] = a[8];
	                    out[9] = a[9];
	                    out[10] = a[10];
	                    out[11] = a[11];
	                    out[12] = a[12];
	                    out[13] = a[13];
	                    out[14] = a[14];
	                    out[15] = a[15];
	                  }
	                  out[0] = a00 * c + a10 * s;
	                  out[1] = a01 * c + a11 * s;
	                  out[2] = a02 * c + a12 * s;
	                  out[3] = a03 * c + a13 * s;
	                  out[4] = a10 * c - a00 * s;
	                  out[5] = a11 * c - a01 * s;
	                  out[6] = a12 * c - a02 * s;
	                  out[7] = a13 * c - a03 * s;
	                  return out;
	                }
	                function perspective(out, fovy, aspect, near, far) {
	                  var f = 1 / Math.tan(fovy / 2), nf;
	                  out[0] = f / aspect;
	                  out[1] = 0;
	                  out[2] = 0;
	                  out[3] = 0;
	                  out[4] = 0;
	                  out[5] = f;
	                  out[6] = 0;
	                  out[7] = 0;
	                  out[8] = 0;
	                  out[9] = 0;
	                  out[11] = -1;
	                  out[12] = 0;
	                  out[13] = 0;
	                  out[15] = 0;
	                  if (far != null && far !== Infinity) {
	                    nf = 1 / (near - far);
	                    out[10] = (far + near) * nf;
	                    out[14] = 2 * far * near * nf;
	                  } else {
	                    out[10] = -1;
	                    out[14] = -2 * near;
	                  }
	                  return out;
	                }
	                function ortho(out, left, right, bottom, top, near, far) {
	                  var lr = 1 / (left - right);
	                  var bt = 1 / (bottom - top);
	                  var nf = 1 / (near - far);
	                  out[0] = -2 * lr;
	                  out[1] = 0;
	                  out[2] = 0;
	                  out[3] = 0;
	                  out[4] = 0;
	                  out[5] = -2 * bt;
	                  out[6] = 0;
	                  out[7] = 0;
	                  out[8] = 0;
	                  out[9] = 0;
	                  out[10] = 2 * nf;
	                  out[11] = 0;
	                  out[12] = (left + right) * lr;
	                  out[13] = (top + bottom) * bt;
	                  out[14] = (far + near) * nf;
	                  out[15] = 1;
	                  return out;
	                }
	                var mul = multiply;
	                function create$3() {
	                  var out = new ARRAY_TYPE(3);
	                  if (ARRAY_TYPE != Float32Array) {
	                    out[0] = 0;
	                    out[1] = 0;
	                    out[2] = 0;
	                  }
	                  return out;
	                }
	                function clone$2(a) {
	                  var out = new ARRAY_TYPE(3);
	                  out[0] = a[0];
	                  out[1] = a[1];
	                  out[2] = a[2];
	                  return out;
	                }
	                function add(out, a, b) {
	                  out[0] = a[0] + b[0];
	                  out[1] = a[1] + b[1];
	                  out[2] = a[2] + b[2];
	                  return out;
	                }
	                function subtract(out, a, b) {
	                  out[0] = a[0] - b[0];
	                  out[1] = a[1] - b[1];
	                  out[2] = a[2] - b[2];
	                  return out;
	                }
	                function scale$1(out, a, b) {
	                  out[0] = a[0] * b;
	                  out[1] = a[1] * b;
	                  out[2] = a[2] * b;
	                  return out;
	                }
	                function normalize(out, a) {
	                  var x = a[0];
	                  var y = a[1];
	                  var z = a[2];
	                  var len = x * x + y * y + z * z;
	                  if (len > 0) {
	                    len = 1 / Math.sqrt(len);
	                  }
	                  out[0] = a[0] * len;
	                  out[1] = a[1] * len;
	                  out[2] = a[2] * len;
	                  return out;
	                }
	                function dot(a, b) {
	                  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	                }
	                function cross(out, a, b) {
	                  var ax = a[0], ay = a[1], az = a[2];
	                  var bx = b[0], by = b[1], bz = b[2];
	                  out[0] = ay * bz - az * by;
	                  out[1] = az * bx - ax * bz;
	                  out[2] = ax * by - ay * bx;
	                  return out;
	                }
	                function transformMat3(out, a, m) {
	                  var x = a[0], y = a[1], z = a[2];
	                  out[0] = x * m[0] + y * m[3] + z * m[6];
	                  out[1] = x * m[1] + y * m[4] + z * m[7];
	                  out[2] = x * m[2] + y * m[5] + z * m[8];
	                  return out;
	                }
	                var sub = subtract;
	                (function() {
	                  var vec = create$3();
	                  return function(a, stride, offset, count, fn, arg) {
	                    var i, l;
	                    if (!stride) {
	                      stride = 3;
	                    }
	                    if (!offset) {
	                      offset = 0;
	                    }
	                    if (count) {
	                      l = Math.min(count * stride + offset, a.length);
	                    } else {
	                      l = a.length;
	                    }
	                    for (i = offset; i < l; i += stride) {
	                      vec[0] = a[i];
	                      vec[1] = a[i + 1];
	                      vec[2] = a[i + 2];
	                      fn(vec, vec, arg);
	                      a[i] = vec[0];
	                      a[i + 1] = vec[1];
	                      a[i + 2] = vec[2];
	                    }
	                    return a;
	                  };
	                })();
	                function create$4() {
	                  var out = new ARRAY_TYPE(4);
	                  if (ARRAY_TYPE != Float32Array) {
	                    out[0] = 0;
	                    out[1] = 0;
	                    out[2] = 0;
	                    out[3] = 0;
	                  }
	                  return out;
	                }
	                function scale$2(out, a, b) {
	                  out[0] = a[0] * b;
	                  out[1] = a[1] * b;
	                  out[2] = a[2] * b;
	                  out[3] = a[3] * b;
	                  return out;
	                }
	                function dot$1(a, b) {
	                  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	                }
	                function transformMat4(out, a, m) {
	                  var x = a[0], y = a[1], z = a[2], w = a[3];
	                  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
	                  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
	                  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
	                  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
	                  return out;
	                }
	                (function() {
	                  var vec = create$4();
	                  return function(a, stride, offset, count, fn, arg) {
	                    var i, l;
	                    if (!stride) {
	                      stride = 4;
	                    }
	                    if (!offset) {
	                      offset = 0;
	                    }
	                    if (count) {
	                      l = Math.min(count * stride + offset, a.length);
	                    } else {
	                      l = a.length;
	                    }
	                    for (i = offset; i < l; i += stride) {
	                      vec[0] = a[i];
	                      vec[1] = a[i + 1];
	                      vec[2] = a[i + 2];
	                      vec[3] = a[i + 3];
	                      fn(vec, vec, arg);
	                      a[i] = vec[0];
	                      a[i + 1] = vec[1];
	                      a[i + 2] = vec[2];
	                      a[i + 3] = vec[3];
	                    }
	                    return a;
	                  };
	                })();
	                function create$5() {
	                  var out = new ARRAY_TYPE(2);
	                  if (ARRAY_TYPE != Float32Array) {
	                    out[0] = 0;
	                    out[1] = 0;
	                  }
	                  return out;
	                }
	                function squaredLength(a) {
	                  var x = a[0], y = a[1];
	                  return x * x + y * y;
	                }
	                var sqrLen = squaredLength;
	                (function() {
	                  var vec = create$5();
	                  return function(a, stride, offset, count, fn, arg) {
	                    var i, l;
	                    if (!stride) {
	                      stride = 2;
	                    }
	                    if (!offset) {
	                      offset = 0;
	                    }
	                    if (count) {
	                      l = Math.min(count * stride + offset, a.length);
	                    } else {
	                      l = a.length;
	                    }
	                    for (i = offset; i < l; i += stride) {
	                      vec[0] = a[i];
	                      vec[1] = a[i + 1];
	                      fn(vec, vec, arg);
	                      a[i] = vec[0];
	                      a[i + 1] = vec[1];
	                    }
	                    return a;
	                  };
	                })();
	                var CircleStyleLayer = function(StyleLayer2) {
	                  function CircleStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties);
	                  }
	                  CircleStyleLayer2.__proto__ = StyleLayer2;
	                  CircleStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  CircleStyleLayer2.prototype.constructor = CircleStyleLayer2;
	                  CircleStyleLayer2.prototype.createBucket = function createBucket(parameters) {
	                    return new CircleBucket(parameters);
	                  };
	                  CircleStyleLayer2.prototype.queryRadius = function queryRadius(bucket) {
	                    var circleBucket = bucket;
	                    return getMaximumPaintValue("circle-radius", this, circleBucket) + getMaximumPaintValue("circle-stroke-width", this, circleBucket) + translateDistance(this.paint.get("circle-translate"));
	                  };
	                  CircleStyleLayer2.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits, pixelPosMatrix) {
	                    var translatedPolygon = translate(queryGeometry, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), transform.angle, pixelsToTileUnits);
	                    var radius = this.paint.get("circle-radius").evaluate(feature, featureState);
	                    var stroke = this.paint.get("circle-stroke-width").evaluate(feature, featureState);
	                    var size = radius + stroke;
	                    var alignWithMap = this.paint.get("circle-pitch-alignment") === "map";
	                    var transformedPolygon = alignWithMap ? translatedPolygon : projectQueryGeometry(translatedPolygon, pixelPosMatrix);
	                    var transformedSize = alignWithMap ? size * pixelsToTileUnits : size;
	                    for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
	                      var ring = list$1[i$1];
	                      for (var i = 0, list = ring; i < list.length; i += 1) {
	                        var point = list[i];
	                        var transformedPoint = alignWithMap ? point : projectPoint(point, pixelPosMatrix);
	                        var adjustedSize = transformedSize;
	                        var projectedCenter = transformMat4([], [
	                          point.x,
	                          point.y,
	                          0,
	                          1
	                        ], pixelPosMatrix);
	                        if (this.paint.get("circle-pitch-scale") === "viewport" && this.paint.get("circle-pitch-alignment") === "map") {
	                          adjustedSize *= projectedCenter[3] / transform.cameraToCenterDistance;
	                        } else if (this.paint.get("circle-pitch-scale") === "map" && this.paint.get("circle-pitch-alignment") === "viewport") {
	                          adjustedSize *= transform.cameraToCenterDistance / projectedCenter[3];
	                        }
	                        if (polygonIntersectsBufferedPoint(transformedPolygon, transformedPoint, adjustedSize)) {
	                          return true;
	                        }
	                      }
	                    }
	                    return false;
	                  };
	                  return CircleStyleLayer2;
	                }(StyleLayer);
	                function projectPoint(p, pixelPosMatrix) {
	                  var point = transformMat4([], [
	                    p.x,
	                    p.y,
	                    0,
	                    1
	                  ], pixelPosMatrix);
	                  return new pointGeometry(point[0] / point[3], point[1] / point[3]);
	                }
	                function projectQueryGeometry(queryGeometry, pixelPosMatrix) {
	                  return queryGeometry.map(function(p) {
	                    return projectPoint(p, pixelPosMatrix);
	                  });
	                }
	                var HeatmapBucket = function(CircleBucket2) {
	                  function HeatmapBucket2() {
	                    CircleBucket2.apply(this, arguments);
	                  }
	                  HeatmapBucket2.__proto__ = CircleBucket2;
	                  HeatmapBucket2.prototype = Object.create(CircleBucket2.prototype);
	                  HeatmapBucket2.prototype.constructor = HeatmapBucket2;
	                  return HeatmapBucket2;
	                }(CircleBucket);
	                register("HeatmapBucket", HeatmapBucket, { omit: ["layers"] });
	                function createImage(image, ref, channels, data) {
	                  var width = ref.width;
	                  var height = ref.height;
	                  if (!data) {
	                    data = new Uint8Array(width * height * channels);
	                  } else if (data instanceof Uint8ClampedArray) {
	                    data = new Uint8Array(data.buffer);
	                  } else if (data.length !== width * height * channels) {
	                    throw new RangeError("mismatched image size");
	                  }
	                  image.width = width;
	                  image.height = height;
	                  image.data = data;
	                  return image;
	                }
	                function resizeImage(image, ref, channels) {
	                  var width = ref.width;
	                  var height = ref.height;
	                  if (width === image.width && height === image.height) {
	                    return;
	                  }
	                  var newImage = createImage({}, {
	                    width,
	                    height
	                  }, channels);
	                  copyImage(image, newImage, {
	                    x: 0,
	                    y: 0
	                  }, {
	                    x: 0,
	                    y: 0
	                  }, {
	                    width: Math.min(image.width, width),
	                    height: Math.min(image.height, height)
	                  }, channels);
	                  image.width = width;
	                  image.height = height;
	                  image.data = newImage.data;
	                }
	                function copyImage(srcImg, dstImg, srcPt, dstPt, size, channels) {
	                  if (size.width === 0 || size.height === 0) {
	                    return dstImg;
	                  }
	                  if (size.width > srcImg.width || size.height > srcImg.height || srcPt.x > srcImg.width - size.width || srcPt.y > srcImg.height - size.height) {
	                    throw new RangeError("out of range source coordinates for image copy");
	                  }
	                  if (size.width > dstImg.width || size.height > dstImg.height || dstPt.x > dstImg.width - size.width || dstPt.y > dstImg.height - size.height) {
	                    throw new RangeError("out of range destination coordinates for image copy");
	                  }
	                  var srcData = srcImg.data;
	                  var dstData = dstImg.data;
	                  for (var y = 0; y < size.height; y++) {
	                    var srcOffset = ((srcPt.y + y) * srcImg.width + srcPt.x) * channels;
	                    var dstOffset = ((dstPt.y + y) * dstImg.width + dstPt.x) * channels;
	                    for (var i = 0; i < size.width * channels; i++) {
	                      dstData[dstOffset + i] = srcData[srcOffset + i];
	                    }
	                  }
	                  return dstImg;
	                }
	                var AlphaImage = function AlphaImage2(size, data) {
	                  createImage(this, size, 1, data);
	                };
	                AlphaImage.prototype.resize = function resize(size) {
	                  resizeImage(this, size, 1);
	                };
	                AlphaImage.prototype.clone = function clone2() {
	                  return new AlphaImage({
	                    width: this.width,
	                    height: this.height
	                  }, new Uint8Array(this.data));
	                };
	                AlphaImage.copy = function copy(srcImg, dstImg, srcPt, dstPt, size) {
	                  copyImage(srcImg, dstImg, srcPt, dstPt, size, 1);
	                };
	                var RGBAImage = function RGBAImage2(size, data) {
	                  createImage(this, size, 4, data);
	                };
	                RGBAImage.prototype.resize = function resize(size) {
	                  resizeImage(this, size, 4);
	                };
	                RGBAImage.prototype.replace = function replace(data, copy) {
	                  if (copy) {
	                    this.data.set(data);
	                  } else if (data instanceof Uint8ClampedArray) {
	                    this.data = new Uint8Array(data.buffer);
	                  } else {
	                    this.data = data;
	                  }
	                };
	                RGBAImage.prototype.clone = function clone2() {
	                  return new RGBAImage({
	                    width: this.width,
	                    height: this.height
	                  }, new Uint8Array(this.data));
	                };
	                RGBAImage.copy = function copy(srcImg, dstImg, srcPt, dstPt, size) {
	                  copyImage(srcImg, dstImg, srcPt, dstPt, size, 4);
	                };
	                register("AlphaImage", AlphaImage);
	                register("RGBAImage", RGBAImage);
	                var paint$2 = new Properties({
	                  "heatmap-radius": new DataDrivenProperty(spec["paint_heatmap"]["heatmap-radius"]),
	                  "heatmap-weight": new DataDrivenProperty(spec["paint_heatmap"]["heatmap-weight"]),
	                  "heatmap-intensity": new DataConstantProperty(spec["paint_heatmap"]["heatmap-intensity"]),
	                  "heatmap-color": new ColorRampProperty(spec["paint_heatmap"]["heatmap-color"]),
	                  "heatmap-opacity": new DataConstantProperty(spec["paint_heatmap"]["heatmap-opacity"])
	                });
	                var properties$1 = { paint: paint$2 };
	                function renderColorRamp(expression2, colorRampEvaluationParameter) {
	                  var colorRampData = new Uint8Array(256 * 4);
	                  var evaluationGlobals = {};
	                  for (var i = 0, j = 0; i < 256; i++, j += 4) {
	                    evaluationGlobals[colorRampEvaluationParameter] = i / 255;
	                    var pxColor = expression2.evaluate(evaluationGlobals);
	                    colorRampData[j + 0] = Math.floor(pxColor.r * 255 / pxColor.a);
	                    colorRampData[j + 1] = Math.floor(pxColor.g * 255 / pxColor.a);
	                    colorRampData[j + 2] = Math.floor(pxColor.b * 255 / pxColor.a);
	                    colorRampData[j + 3] = Math.floor(pxColor.a * 255);
	                  }
	                  return new RGBAImage({
	                    width: 256,
	                    height: 1
	                  }, colorRampData);
	                }
	                var HeatmapStyleLayer = function(StyleLayer2) {
	                  function HeatmapStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$1);
	                    this._updateColorRamp();
	                  }
	                  HeatmapStyleLayer2.__proto__ = StyleLayer2;
	                  HeatmapStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  HeatmapStyleLayer2.prototype.constructor = HeatmapStyleLayer2;
	                  HeatmapStyleLayer2.prototype.createBucket = function createBucket(options) {
	                    return new HeatmapBucket(options);
	                  };
	                  HeatmapStyleLayer2.prototype._handleSpecialPaintPropertyUpdate = function _handleSpecialPaintPropertyUpdate(name3) {
	                    if (name3 === "heatmap-color") {
	                      this._updateColorRamp();
	                    }
	                  };
	                  HeatmapStyleLayer2.prototype._updateColorRamp = function _updateColorRamp() {
	                    var expression2 = this._transitionablePaint._values["heatmap-color"].value.expression;
	                    this.colorRamp = renderColorRamp(expression2, "heatmapDensity");
	                    this.colorRampTexture = null;
	                  };
	                  HeatmapStyleLayer2.prototype.resize = function resize() {
	                    if (this.heatmapFbo) {
	                      this.heatmapFbo.destroy();
	                      this.heatmapFbo = null;
	                    }
	                  };
	                  HeatmapStyleLayer2.prototype.queryRadius = function queryRadius() {
	                    return 0;
	                  };
	                  HeatmapStyleLayer2.prototype.queryIntersectsFeature = function queryIntersectsFeature() {
	                    return false;
	                  };
	                  HeatmapStyleLayer2.prototype.hasOffscreenPass = function hasOffscreenPass() {
	                    return this.paint.get("heatmap-opacity") !== 0 && this.visibility !== "none";
	                  };
	                  return HeatmapStyleLayer2;
	                }(StyleLayer);
	                var paint$3 = new Properties({
	                  "hillshade-illumination-direction": new DataConstantProperty(spec["paint_hillshade"]["hillshade-illumination-direction"]),
	                  "hillshade-illumination-anchor": new DataConstantProperty(spec["paint_hillshade"]["hillshade-illumination-anchor"]),
	                  "hillshade-exaggeration": new DataConstantProperty(spec["paint_hillshade"]["hillshade-exaggeration"]),
	                  "hillshade-shadow-color": new DataConstantProperty(spec["paint_hillshade"]["hillshade-shadow-color"]),
	                  "hillshade-highlight-color": new DataConstantProperty(spec["paint_hillshade"]["hillshade-highlight-color"]),
	                  "hillshade-accent-color": new DataConstantProperty(spec["paint_hillshade"]["hillshade-accent-color"])
	                });
	                var properties$2 = { paint: paint$3 };
	                var HillshadeStyleLayer = function(StyleLayer2) {
	                  function HillshadeStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$2);
	                  }
	                  HillshadeStyleLayer2.__proto__ = StyleLayer2;
	                  HillshadeStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  HillshadeStyleLayer2.prototype.constructor = HillshadeStyleLayer2;
	                  HillshadeStyleLayer2.prototype.hasOffscreenPass = function hasOffscreenPass() {
	                    return this.paint.get("hillshade-exaggeration") !== 0 && this.visibility !== "none";
	                  };
	                  return HillshadeStyleLayer2;
	                }(StyleLayer);
	                var layout$3 = createLayout([{
	                  name: "a_pos",
	                  components: 2,
	                  type: "Int16"
	                }], 4);
	                var members$1 = layout$3.members;
	                var earcut_1 = earcut;
	                var default_1 = earcut;
	                function earcut(data, holeIndices, dim) {
	                  dim = dim || 2;
	                  var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
	                  if (!outerNode || outerNode.next === outerNode.prev) {
	                    return triangles;
	                  }
	                  var minX, minY, maxX, maxY, x, y, invSize;
	                  if (hasHoles) {
	                    outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	                  }
	                  if (data.length > 80 * dim) {
	                    minX = maxX = data[0];
	                    minY = maxY = data[1];
	                    for (var i = dim; i < outerLen; i += dim) {
	                      x = data[i];
	                      y = data[i + 1];
	                      if (x < minX) {
	                        minX = x;
	                      }
	                      if (y < minY) {
	                        minY = y;
	                      }
	                      if (x > maxX) {
	                        maxX = x;
	                      }
	                      if (y > maxY) {
	                        maxY = y;
	                      }
	                    }
	                    invSize = Math.max(maxX - minX, maxY - minY);
	                    invSize = invSize !== 0 ? 1 / invSize : 0;
	                  }
	                  earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
	                  return triangles;
	                }
	                function linkedList(data, start, end, dim, clockwise) {
	                  var i, last;
	                  if (clockwise === signedArea(data, start, end, dim) > 0) {
	                    for (i = start; i < end; i += dim) {
	                      last = insertNode(i, data[i], data[i + 1], last);
	                    }
	                  } else {
	                    for (i = end - dim; i >= start; i -= dim) {
	                      last = insertNode(i, data[i], data[i + 1], last);
	                    }
	                  }
	                  if (last && equals(last, last.next)) {
	                    removeNode(last);
	                    last = last.next;
	                  }
	                  return last;
	                }
	                function filterPoints(start, end) {
	                  if (!start) {
	                    return start;
	                  }
	                  if (!end) {
	                    end = start;
	                  }
	                  var p = start, again;
	                  do {
	                    again = false;
	                    if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	                      removeNode(p);
	                      p = end = p.prev;
	                      if (p === p.next) {
	                        break;
	                      }
	                      again = true;
	                    } else {
	                      p = p.next;
	                    }
	                  } while (again || p !== end);
	                  return end;
	                }
	                function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	                  if (!ear) {
	                    return;
	                  }
	                  if (!pass && invSize) {
	                    indexCurve(ear, minX, minY, invSize);
	                  }
	                  var stop = ear, prev, next;
	                  while (ear.prev !== ear.next) {
	                    prev = ear.prev;
	                    next = ear.next;
	                    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	                      triangles.push(prev.i / dim);
	                      triangles.push(ear.i / dim);
	                      triangles.push(next.i / dim);
	                      removeNode(ear);
	                      ear = next.next;
	                      stop = next.next;
	                      continue;
	                    }
	                    ear = next;
	                    if (ear === stop) {
	                      if (!pass) {
	                        earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
	                      } else if (pass === 1) {
	                        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
	                        earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
	                      } else if (pass === 2) {
	                        splitEarcut(ear, triangles, dim, minX, minY, invSize);
	                      }
	                      break;
	                    }
	                  }
	                }
	                function isEar(ear) {
	                  var a = ear.prev, b = ear, c = ear.next;
	                  if (area(a, b, c) >= 0) {
	                    return false;
	                  }
	                  var p = ear.next.next;
	                  while (p !== ear.prev) {
	                    if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) {
	                      return false;
	                    }
	                    p = p.next;
	                  }
	                  return true;
	                }
	                function isEarHashed(ear, minX, minY, invSize) {
	                  var a = ear.prev, b = ear, c = ear.next;
	                  if (area(a, b, c) >= 0) {
	                    return false;
	                  }
	                  var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
	                  var minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
	                  var p = ear.prevZ, n = ear.nextZ;
	                  while (p && p.z >= minZ && n && n.z <= maxZ) {
	                    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) {
	                      return false;
	                    }
	                    p = p.prevZ;
	                    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) {
	                      return false;
	                    }
	                    n = n.nextZ;
	                  }
	                  while (p && p.z >= minZ) {
	                    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) {
	                      return false;
	                    }
	                    p = p.prevZ;
	                  }
	                  while (n && n.z <= maxZ) {
	                    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) {
	                      return false;
	                    }
	                    n = n.nextZ;
	                  }
	                  return true;
	                }
	                function cureLocalIntersections(start, triangles, dim) {
	                  var p = start;
	                  do {
	                    var a = p.prev, b = p.next.next;
	                    if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	                      triangles.push(a.i / dim);
	                      triangles.push(p.i / dim);
	                      triangles.push(b.i / dim);
	                      removeNode(p);
	                      removeNode(p.next);
	                      p = start = b;
	                    }
	                    p = p.next;
	                  } while (p !== start);
	                  return filterPoints(p);
	                }
	                function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	                  var a = start;
	                  do {
	                    var b = a.next.next;
	                    while (b !== a.prev) {
	                      if (a.i !== b.i && isValidDiagonal(a, b)) {
	                        var c = splitPolygon(a, b);
	                        a = filterPoints(a, a.next);
	                        c = filterPoints(c, c.next);
	                        earcutLinked(a, triangles, dim, minX, minY, invSize);
	                        earcutLinked(c, triangles, dim, minX, minY, invSize);
	                        return;
	                      }
	                      b = b.next;
	                    }
	                    a = a.next;
	                  } while (a !== start);
	                }
	                function eliminateHoles(data, holeIndices, outerNode, dim) {
	                  var queue = [], i, len, start, end, list;
	                  for (i = 0, len = holeIndices.length; i < len; i++) {
	                    start = holeIndices[i] * dim;
	                    end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	                    list = linkedList(data, start, end, dim, false);
	                    if (list === list.next) {
	                      list.steiner = true;
	                    }
	                    queue.push(getLeftmost(list));
	                  }
	                  queue.sort(compareX);
	                  for (i = 0; i < queue.length; i++) {
	                    eliminateHole(queue[i], outerNode);
	                    outerNode = filterPoints(outerNode, outerNode.next);
	                  }
	                  return outerNode;
	                }
	                function compareX(a, b) {
	                  return a.x - b.x;
	                }
	                function eliminateHole(hole, outerNode) {
	                  outerNode = findHoleBridge(hole, outerNode);
	                  if (outerNode) {
	                    var b = splitPolygon(outerNode, hole);
	                    filterPoints(outerNode, outerNode.next);
	                    filterPoints(b, b.next);
	                  }
	                }
	                function findHoleBridge(hole, outerNode) {
	                  var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
	                  do {
	                    if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	                      var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	                      if (x <= hx && x > qx) {
	                        qx = x;
	                        if (x === hx) {
	                          if (hy === p.y) {
	                            return p;
	                          }
	                          if (hy === p.next.y) {
	                            return p.next;
	                          }
	                        }
	                        m = p.x < p.next.x ? p : p.next;
	                      }
	                    }
	                    p = p.next;
	                  } while (p !== outerNode);
	                  if (!m) {
	                    return null;
	                  }
	                  if (hx === qx) {
	                    return m;
	                  }
	                  var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
	                  p = m;
	                  do {
	                    if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	                      tan = Math.abs(hy - p.y) / (hx - p.x);
	                      if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
	                        m = p;
	                        tanMin = tan;
	                      }
	                    }
	                    p = p.next;
	                  } while (p !== stop);
	                  return m;
	                }
	                function sectorContainsSector(m, p) {
	                  return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
	                }
	                function indexCurve(start, minX, minY, invSize) {
	                  var p = start;
	                  do {
	                    if (p.z === null) {
	                      p.z = zOrder(p.x, p.y, minX, minY, invSize);
	                    }
	                    p.prevZ = p.prev;
	                    p.nextZ = p.next;
	                    p = p.next;
	                  } while (p !== start);
	                  p.prevZ.nextZ = null;
	                  p.prevZ = null;
	                  sortLinked(p);
	                }
	                function sortLinked(list) {
	                  var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
	                  do {
	                    p = list;
	                    list = null;
	                    tail = null;
	                    numMerges = 0;
	                    while (p) {
	                      numMerges++;
	                      q = p;
	                      pSize = 0;
	                      for (i = 0; i < inSize; i++) {
	                        pSize++;
	                        q = q.nextZ;
	                        if (!q) {
	                          break;
	                        }
	                      }
	                      qSize = inSize;
	                      while (pSize > 0 || qSize > 0 && q) {
	                        if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                          e = p;
	                          p = p.nextZ;
	                          pSize--;
	                        } else {
	                          e = q;
	                          q = q.nextZ;
	                          qSize--;
	                        }
	                        if (tail) {
	                          tail.nextZ = e;
	                        } else {
	                          list = e;
	                        }
	                        e.prevZ = tail;
	                        tail = e;
	                      }
	                      p = q;
	                    }
	                    tail.nextZ = null;
	                    inSize *= 2;
	                  } while (numMerges > 1);
	                  return list;
	                }
	                function zOrder(x, y, minX, minY, invSize) {
	                  x = 32767 * (x - minX) * invSize;
	                  y = 32767 * (y - minY) * invSize;
	                  x = (x | x << 8) & 16711935;
	                  x = (x | x << 4) & 252645135;
	                  x = (x | x << 2) & 858993459;
	                  x = (x | x << 1) & 1431655765;
	                  y = (y | y << 8) & 16711935;
	                  y = (y | y << 4) & 252645135;
	                  y = (y | y << 2) & 858993459;
	                  y = (y | y << 1) & 1431655765;
	                  return x | y << 1;
	                }
	                function getLeftmost(start) {
	                  var p = start, leftmost = start;
	                  do {
	                    if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) {
	                      leftmost = p;
	                    }
	                    p = p.next;
	                  } while (p !== start);
	                  return leftmost;
	                }
	                function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	                  return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	                }
	                function isValidDiagonal(a, b) {
	                  return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && (area(a.prev, a, b.prev) || area(a, b.prev, b)) || equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0);
	                }
	                function area(p, q, r) {
	                  return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	                }
	                function equals(p1, p2) {
	                  return p1.x === p2.x && p1.y === p2.y;
	                }
	                function intersects(p1, q1, p2, q2) {
	                  var o1 = sign(area(p1, q1, p2));
	                  var o2 = sign(area(p1, q1, q2));
	                  var o3 = sign(area(p2, q2, p1));
	                  var o4 = sign(area(p2, q2, q1));
	                  if (o1 !== o2 && o3 !== o4) {
	                    return true;
	                  }
	                  if (o1 === 0 && onSegment(p1, p2, q1)) {
	                    return true;
	                  }
	                  if (o2 === 0 && onSegment(p1, q2, q1)) {
	                    return true;
	                  }
	                  if (o3 === 0 && onSegment(p2, p1, q2)) {
	                    return true;
	                  }
	                  if (o4 === 0 && onSegment(p2, q1, q2)) {
	                    return true;
	                  }
	                  return false;
	                }
	                function onSegment(p, q, r) {
	                  return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
	                }
	                function sign(num) {
	                  return num > 0 ? 1 : num < 0 ? -1 : 0;
	                }
	                function intersectsPolygon(a, b) {
	                  var p = a;
	                  do {
	                    if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) {
	                      return true;
	                    }
	                    p = p.next;
	                  } while (p !== a);
	                  return false;
	                }
	                function locallyInside(a, b) {
	                  return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	                }
	                function middleInside(a, b) {
	                  var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
	                  do {
	                    if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) {
	                      inside = !inside;
	                    }
	                    p = p.next;
	                  } while (p !== a);
	                  return inside;
	                }
	                function splitPolygon(a, b) {
	                  var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
	                  a.next = b;
	                  b.prev = a;
	                  a2.next = an;
	                  an.prev = a2;
	                  b2.next = a2;
	                  a2.prev = b2;
	                  bp.next = b2;
	                  b2.prev = bp;
	                  return b2;
	                }
	                function insertNode(i, x, y, last) {
	                  var p = new Node(i, x, y);
	                  if (!last) {
	                    p.prev = p;
	                    p.next = p;
	                  } else {
	                    p.next = last.next;
	                    p.prev = last;
	                    last.next.prev = p;
	                    last.next = p;
	                  }
	                  return p;
	                }
	                function removeNode(p) {
	                  p.next.prev = p.prev;
	                  p.prev.next = p.next;
	                  if (p.prevZ) {
	                    p.prevZ.nextZ = p.nextZ;
	                  }
	                  if (p.nextZ) {
	                    p.nextZ.prevZ = p.prevZ;
	                  }
	                }
	                function Node(i, x, y) {
	                  this.i = i;
	                  this.x = x;
	                  this.y = y;
	                  this.prev = null;
	                  this.next = null;
	                  this.z = null;
	                  this.prevZ = null;
	                  this.nextZ = null;
	                  this.steiner = false;
	                }
	                earcut.deviation = function(data, holeIndices, dim, triangles) {
	                  var hasHoles = holeIndices && holeIndices.length;
	                  var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	                  var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	                  if (hasHoles) {
	                    for (var i = 0, len = holeIndices.length; i < len; i++) {
	                      var start = holeIndices[i] * dim;
	                      var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	                      polygonArea -= Math.abs(signedArea(data, start, end, dim));
	                    }
	                  }
	                  var trianglesArea = 0;
	                  for (i = 0; i < triangles.length; i += 3) {
	                    var a = triangles[i] * dim;
	                    var b = triangles[i + 1] * dim;
	                    var c = triangles[i + 2] * dim;
	                    trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	                  }
	                  return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
	                };
	                function signedArea(data, start, end, dim) {
	                  var sum = 0;
	                  for (var i = start, j = end - dim; i < end; i += dim) {
	                    sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	                    j = i;
	                  }
	                  return sum;
	                }
	                earcut.flatten = function(data) {
	                  var dim = data[0][0].length, result = {
	                    vertices: [],
	                    holes: [],
	                    dimensions: dim
	                  }, holeIndex = 0;
	                  for (var i = 0; i < data.length; i++) {
	                    for (var j = 0; j < data[i].length; j++) {
	                      for (var d = 0; d < dim; d++) {
	                        result.vertices.push(data[i][j][d]);
	                      }
	                    }
	                    if (i > 0) {
	                      holeIndex += data[i - 1].length;
	                      result.holes.push(holeIndex);
	                    }
	                  }
	                  return result;
	                };
	                earcut_1.default = default_1;
	                function quickselect(arr, k, left, right, compare2) {
	                  quickselectStep(arr, k, left, right || arr.length - 1, compare2);
	                }
	                function quickselectStep(arr, k, left, right, compare2) {
	                  while (right > left) {
	                    if (right - left > 600) {
	                      var n = right - left + 1;
	                      var m = k - left + 1;
	                      var z = Math.log(n);
	                      var s = 0.5 * Math.exp(2 * z / 3);
	                      var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	                      var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	                      var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	                      quickselectStep(arr, k, newLeft, newRight, compare2);
	                    }
	                    var t = arr[k];
	                    var i = left;
	                    var j = right;
	                    swap$1(arr, left, k);
	                    if (compare2(arr[right], t) > 0) {
	                      swap$1(arr, left, right);
	                    }
	                    while (i < j) {
	                      swap$1(arr, i, j);
	                      i++;
	                      j--;
	                      while (compare2(arr[i], t) < 0) {
	                        i++;
	                      }
	                      while (compare2(arr[j], t) > 0) {
	                        j--;
	                      }
	                    }
	                    if (compare2(arr[left], t) === 0) {
	                      swap$1(arr, left, j);
	                    } else {
	                      j++;
	                      swap$1(arr, j, right);
	                    }
	                    if (j <= k) {
	                      left = j + 1;
	                    }
	                    if (k <= j) {
	                      right = j - 1;
	                    }
	                  }
	                }
	                function swap$1(arr, i, j) {
	                  var tmp = arr[i];
	                  arr[i] = arr[j];
	                  arr[j] = tmp;
	                }
	                function classifyRings(rings, maxRings) {
	                  var len = rings.length;
	                  if (len <= 1) {
	                    return [rings];
	                  }
	                  var polygons = [];
	                  var polygon, ccw;
	                  for (var i = 0; i < len; i++) {
	                    var area2 = calculateSignedArea(rings[i]);
	                    if (area2 === 0) {
	                      continue;
	                    }
	                    rings[i].area = Math.abs(area2);
	                    if (ccw === undefined) {
	                      ccw = area2 < 0;
	                    }
	                    if (ccw === area2 < 0) {
	                      if (polygon) {
	                        polygons.push(polygon);
	                      }
	                      polygon = [rings[i]];
	                    } else {
	                      polygon.push(rings[i]);
	                    }
	                  }
	                  if (polygon) {
	                    polygons.push(polygon);
	                  }
	                  if (maxRings > 1) {
	                    for (var j = 0; j < polygons.length; j++) {
	                      if (polygons[j].length <= maxRings) {
	                        continue;
	                      }
	                      quickselect(polygons[j], maxRings, 1, polygons[j].length - 1, compareAreas);
	                      polygons[j] = polygons[j].slice(0, maxRings);
	                    }
	                  }
	                  return polygons;
	                }
	                function compareAreas(a, b) {
	                  return b.area - a.area;
	                }
	                function hasPattern(type, layers, options) {
	                  var patterns = options.patternDependencies;
	                  var hasPattern2 = false;
	                  for (var i = 0, list = layers; i < list.length; i += 1) {
	                    var layer2 = list[i];
	                    var patternProperty = layer2.paint.get(type + "-pattern");
	                    if (!patternProperty.isConstant()) {
	                      hasPattern2 = true;
	                    }
	                    var constantPattern = patternProperty.constantOr(null);
	                    if (constantPattern) {
	                      hasPattern2 = true;
	                      patterns[constantPattern.to] = true;
	                      patterns[constantPattern.from] = true;
	                    }
	                  }
	                  return hasPattern2;
	                }
	                function addPatternDependencies(type, layers, patternFeature, zoom, options) {
	                  var patterns = options.patternDependencies;
	                  for (var i = 0, list = layers; i < list.length; i += 1) {
	                    var layer2 = list[i];
	                    var patternProperty = layer2.paint.get(type + "-pattern");
	                    var patternPropertyValue = patternProperty.value;
	                    if (patternPropertyValue.kind !== "constant") {
	                      var min = patternPropertyValue.evaluate({ zoom: zoom - 1 }, patternFeature, {}, options.availableImages);
	                      var mid = patternPropertyValue.evaluate({ zoom }, patternFeature, {}, options.availableImages);
	                      var max = patternPropertyValue.evaluate({ zoom: zoom + 1 }, patternFeature, {}, options.availableImages);
	                      min = min && min.name ? min.name : min;
	                      mid = mid && mid.name ? mid.name : mid;
	                      max = max && max.name ? max.name : max;
	                      patterns[min] = true;
	                      patterns[mid] = true;
	                      patterns[max] = true;
	                      patternFeature.patterns[layer2.id] = {
	                        min,
	                        mid,
	                        max
	                      };
	                    }
	                  }
	                  return patternFeature;
	                }
	                var EARCUT_MAX_RINGS = 500;
	                var FillBucket = function FillBucket2(options) {
	                  this.zoom = options.zoom;
	                  this.overscaling = options.overscaling;
	                  this.layers = options.layers;
	                  this.layerIds = this.layers.map(function(layer2) {
	                    return layer2.id;
	                  });
	                  this.index = options.index;
	                  this.hasPattern = false;
	                  this.patternFeatures = [];
	                  this.layoutVertexArray = new StructArrayLayout2i4();
	                  this.indexArray = new StructArrayLayout3ui6();
	                  this.indexArray2 = new StructArrayLayout2ui4();
	                  this.programConfigurations = new ProgramConfigurationSet(members$1, options.layers, options.zoom);
	                  this.segments = new SegmentVector();
	                  this.segments2 = new SegmentVector();
	                  this.stateDependentLayerIds = this.layers.filter(function(l) {
	                    return l.isStateDependent();
	                  }).map(function(l) {
	                    return l.id;
	                  });
	                };
	                FillBucket.prototype.populate = function populate(features, options, canonical) {
	                  this.hasPattern = hasPattern("fill", this.layers, options);
	                  var fillSortKey = this.layers[0].layout.get("fill-sort-key");
	                  var bucketFeatures = [];
	                  for (var i = 0, list = features; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var feature = ref.feature;
	                    var id2 = ref.id;
	                    var index = ref.index;
	                    var sourceLayerIndex = ref.sourceLayerIndex;
	                    var needGeometry = this.layers[0]._featureFilter.needGeometry;
	                    var evaluationFeature = {
	                      type: feature.type,
	                      id: id2,
	                      properties: feature.properties,
	                      geometry: needGeometry ? loadGeometry(feature) : []
	                    };
	                    if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
	                      continue;
	                    }
	                    if (!needGeometry) {
	                      evaluationFeature.geometry = loadGeometry(feature);
	                    }
	                    var sortKey = fillSortKey ? fillSortKey.evaluate(evaluationFeature, {}, canonical, options.availableImages) : undefined;
	                    var bucketFeature = {
	                      id: id2,
	                      properties: feature.properties,
	                      type: feature.type,
	                      sourceLayerIndex,
	                      index,
	                      geometry: evaluationFeature.geometry,
	                      patterns: {},
	                      sortKey
	                    };
	                    bucketFeatures.push(bucketFeature);
	                  }
	                  if (fillSortKey) {
	                    bucketFeatures.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                  for (var i$1 = 0, list$1 = bucketFeatures; i$1 < list$1.length; i$1 += 1) {
	                    var bucketFeature$1 = list$1[i$1];
	                    var ref$1 = bucketFeature$1;
	                    var geometry = ref$1.geometry;
	                    var index$1 = ref$1.index;
	                    var sourceLayerIndex$1 = ref$1.sourceLayerIndex;
	                    if (this.hasPattern) {
	                      var patternFeature = addPatternDependencies("fill", this.layers, bucketFeature$1, this.zoom, options);
	                      this.patternFeatures.push(patternFeature);
	                    } else {
	                      this.addFeature(bucketFeature$1, geometry, index$1, canonical, {});
	                    }
	                    var feature$1 = features[index$1].feature;
	                    options.featureIndex.insert(feature$1, geometry, index$1, sourceLayerIndex$1, this.index);
	                  }
	                };
	                FillBucket.prototype.update = function update(states, vtLayer, imagePositions) {
	                  if (!this.stateDependentLayers.length) {
	                    return;
	                  }
	                  this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
	                };
	                FillBucket.prototype.addFeatures = function addFeatures(options, canonical, imagePositions) {
	                  for (var i = 0, list = this.patternFeatures; i < list.length; i += 1) {
	                    var feature = list[i];
	                    this.addFeature(feature, feature.geometry, feature.index, canonical, imagePositions);
	                  }
	                };
	                FillBucket.prototype.isEmpty = function isEmpty2() {
	                  return this.layoutVertexArray.length === 0;
	                };
	                FillBucket.prototype.uploadPending = function uploadPending() {
	                  return !this.uploaded || this.programConfigurations.needsUpload;
	                };
	                FillBucket.prototype.upload = function upload(context) {
	                  if (!this.uploaded) {
	                    this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$1);
	                    this.indexBuffer = context.createIndexBuffer(this.indexArray);
	                    this.indexBuffer2 = context.createIndexBuffer(this.indexArray2);
	                  }
	                  this.programConfigurations.upload(context);
	                  this.uploaded = true;
	                };
	                FillBucket.prototype.destroy = function destroy() {
	                  if (!this.layoutVertexBuffer) {
	                    return;
	                  }
	                  this.layoutVertexBuffer.destroy();
	                  this.indexBuffer.destroy();
	                  this.indexBuffer2.destroy();
	                  this.programConfigurations.destroy();
	                  this.segments.destroy();
	                  this.segments2.destroy();
	                };
	                FillBucket.prototype.addFeature = function addFeature2(feature, geometry, index, canonical, imagePositions) {
	                  for (var i$4 = 0, list$2 = classifyRings(geometry, EARCUT_MAX_RINGS); i$4 < list$2.length; i$4 += 1) {
	                    var polygon = list$2[i$4];
	                    var numVertices = 0;
	                    for (var i$2 = 0, list = polygon; i$2 < list.length; i$2 += 1) {
	                      var ring = list[i$2];
	                      numVertices += ring.length;
	                    }
	                    var triangleSegment = this.segments.prepareSegment(numVertices, this.layoutVertexArray, this.indexArray);
	                    var triangleIndex = triangleSegment.vertexLength;
	                    var flattened = [];
	                    var holeIndices = [];
	                    for (var i$3 = 0, list$1 = polygon; i$3 < list$1.length; i$3 += 1) {
	                      var ring$1 = list$1[i$3];
	                      if (ring$1.length === 0) {
	                        continue;
	                      }
	                      if (ring$1 !== polygon[0]) {
	                        holeIndices.push(flattened.length / 2);
	                      }
	                      var lineSegment = this.segments2.prepareSegment(ring$1.length, this.layoutVertexArray, this.indexArray2);
	                      var lineIndex = lineSegment.vertexLength;
	                      this.layoutVertexArray.emplaceBack(ring$1[0].x, ring$1[0].y);
	                      this.indexArray2.emplaceBack(lineIndex + ring$1.length - 1, lineIndex);
	                      flattened.push(ring$1[0].x);
	                      flattened.push(ring$1[0].y);
	                      for (var i = 1; i < ring$1.length; i++) {
	                        this.layoutVertexArray.emplaceBack(ring$1[i].x, ring$1[i].y);
	                        this.indexArray2.emplaceBack(lineIndex + i - 1, lineIndex + i);
	                        flattened.push(ring$1[i].x);
	                        flattened.push(ring$1[i].y);
	                      }
	                      lineSegment.vertexLength += ring$1.length;
	                      lineSegment.primitiveLength += ring$1.length;
	                    }
	                    var indices = earcut_1(flattened, holeIndices);
	                    for (var i$1 = 0; i$1 < indices.length; i$1 += 3) {
	                      this.indexArray.emplaceBack(triangleIndex + indices[i$1], triangleIndex + indices[i$1 + 1], triangleIndex + indices[i$1 + 2]);
	                    }
	                    triangleSegment.vertexLength += numVertices;
	                    triangleSegment.primitiveLength += indices.length / 3;
	                  }
	                  this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
	                };
	                register("FillBucket", FillBucket, {
	                  omit: [
	                    "layers",
	                    "patternFeatures"
	                  ]
	                });
	                var layout$4 = new Properties({ "fill-sort-key": new DataDrivenProperty(spec["layout_fill"]["fill-sort-key"]) });
	                var paint$4 = new Properties({
	                  "fill-antialias": new DataConstantProperty(spec["paint_fill"]["fill-antialias"]),
	                  "fill-opacity": new DataDrivenProperty(spec["paint_fill"]["fill-opacity"]),
	                  "fill-color": new DataDrivenProperty(spec["paint_fill"]["fill-color"]),
	                  "fill-outline-color": new DataDrivenProperty(spec["paint_fill"]["fill-outline-color"]),
	                  "fill-translate": new DataConstantProperty(spec["paint_fill"]["fill-translate"]),
	                  "fill-translate-anchor": new DataConstantProperty(spec["paint_fill"]["fill-translate-anchor"]),
	                  "fill-pattern": new CrossFadedDataDrivenProperty(spec["paint_fill"]["fill-pattern"])
	                });
	                var properties$3 = {
	                  paint: paint$4,
	                  layout: layout$4
	                };
	                var FillStyleLayer = function(StyleLayer2) {
	                  function FillStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$3);
	                  }
	                  FillStyleLayer2.__proto__ = StyleLayer2;
	                  FillStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  FillStyleLayer2.prototype.constructor = FillStyleLayer2;
	                  FillStyleLayer2.prototype.recalculate = function recalculate(parameters, availableImages) {
	                    StyleLayer2.prototype.recalculate.call(this, parameters, availableImages);
	                    var outlineColor = this.paint._values["fill-outline-color"];
	                    if (outlineColor.value.kind === "constant" && outlineColor.value.value === undefined) {
	                      this.paint._values["fill-outline-color"] = this.paint._values["fill-color"];
	                    }
	                  };
	                  FillStyleLayer2.prototype.createBucket = function createBucket(parameters) {
	                    return new FillBucket(parameters);
	                  };
	                  FillStyleLayer2.prototype.queryRadius = function queryRadius() {
	                    return translateDistance(this.paint.get("fill-translate"));
	                  };
	                  FillStyleLayer2.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits) {
	                    var translatedPolygon = translate(queryGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), transform.angle, pixelsToTileUnits);
	                    return polygonIntersectsMultiPolygon(translatedPolygon, geometry);
	                  };
	                  FillStyleLayer2.prototype.isTileClipped = function isTileClipped() {
	                    return true;
	                  };
	                  return FillStyleLayer2;
	                }(StyleLayer);
	                var layout$5 = createLayout([
	                  {
	                    name: "a_pos",
	                    components: 2,
	                    type: "Int16"
	                  },
	                  {
	                    name: "a_normal_ed",
	                    components: 4,
	                    type: "Int16"
	                  }
	                ], 4);
	                var members$2 = layout$5.members;
	                var vectortilefeature = VectorTileFeature;
	                function VectorTileFeature(pbf2, end, extent2, keys, values2) {
	                  this.properties = {};
	                  this.extent = extent2;
	                  this.type = 0;
	                  this._pbf = pbf2;
	                  this._geometry = -1;
	                  this._keys = keys;
	                  this._values = values2;
	                  pbf2.readFields(readFeature, this, end);
	                }
	                function readFeature(tag, feature, pbf2) {
	                  if (tag == 1) {
	                    feature.id = pbf2.readVarint();
	                  } else if (tag == 2) {
	                    readTag(pbf2, feature);
	                  } else if (tag == 3) {
	                    feature.type = pbf2.readVarint();
	                  } else if (tag == 4) {
	                    feature._geometry = pbf2.pos;
	                  }
	                }
	                function readTag(pbf2, feature) {
	                  var end = pbf2.readVarint() + pbf2.pos;
	                  while (pbf2.pos < end) {
	                    var key = feature._keys[pbf2.readVarint()], value = feature._values[pbf2.readVarint()];
	                    feature.properties[key] = value;
	                  }
	                }
	                VectorTileFeature.types = [
	                  "Unknown",
	                  "Point",
	                  "LineString",
	                  "Polygon"
	                ];
	                VectorTileFeature.prototype.loadGeometry = function() {
	                  var pbf2 = this._pbf;
	                  pbf2.pos = this._geometry;
	                  var end = pbf2.readVarint() + pbf2.pos, cmd = 1, length = 0, x = 0, y = 0, lines = [], line;
	                  while (pbf2.pos < end) {
	                    if (length <= 0) {
	                      var cmdLen = pbf2.readVarint();
	                      cmd = cmdLen & 7;
	                      length = cmdLen >> 3;
	                    }
	                    length--;
	                    if (cmd === 1 || cmd === 2) {
	                      x += pbf2.readSVarint();
	                      y += pbf2.readSVarint();
	                      if (cmd === 1) {
	                        if (line) {
	                          lines.push(line);
	                        }
	                        line = [];
	                      }
	                      line.push(new pointGeometry(x, y));
	                    } else if (cmd === 7) {
	                      if (line) {
	                        line.push(line[0].clone());
	                      }
	                    } else {
	                      throw new Error("unknown command " + cmd);
	                    }
	                  }
	                  if (line) {
	                    lines.push(line);
	                  }
	                  return lines;
	                };
	                VectorTileFeature.prototype.bbox = function() {
	                  var pbf2 = this._pbf;
	                  pbf2.pos = this._geometry;
	                  var end = pbf2.readVarint() + pbf2.pos, cmd = 1, length = 0, x = 0, y = 0, x1 = Infinity, x2 = -Infinity, y1 = Infinity, y2 = -Infinity;
	                  while (pbf2.pos < end) {
	                    if (length <= 0) {
	                      var cmdLen = pbf2.readVarint();
	                      cmd = cmdLen & 7;
	                      length = cmdLen >> 3;
	                    }
	                    length--;
	                    if (cmd === 1 || cmd === 2) {
	                      x += pbf2.readSVarint();
	                      y += pbf2.readSVarint();
	                      if (x < x1) {
	                        x1 = x;
	                      }
	                      if (x > x2) {
	                        x2 = x;
	                      }
	                      if (y < y1) {
	                        y1 = y;
	                      }
	                      if (y > y2) {
	                        y2 = y;
	                      }
	                    } else if (cmd !== 7) {
	                      throw new Error("unknown command " + cmd);
	                    }
	                  }
	                  return [
	                    x1,
	                    y1,
	                    x2,
	                    y2
	                  ];
	                };
	                VectorTileFeature.prototype.toGeoJSON = function(x, y, z) {
	                  var size = this.extent * Math.pow(2, z), x0 = this.extent * x, y0 = this.extent * y, coords = this.loadGeometry(), type = VectorTileFeature.types[this.type], i, j;
	                  function project(line) {
	                    for (var j2 = 0; j2 < line.length; j2++) {
	                      var p = line[j2], y2 = 180 - (p.y + y0) * 360 / size;
	                      line[j2] = [
	                        (p.x + x0) * 360 / size - 180,
	                        360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90
	                      ];
	                    }
	                  }
	                  switch (this.type) {
	                    case 1:
	                      var points = [];
	                      for (i = 0; i < coords.length; i++) {
	                        points[i] = coords[i][0];
	                      }
	                      coords = points;
	                      project(coords);
	                      break;
	                    case 2:
	                      for (i = 0; i < coords.length; i++) {
	                        project(coords[i]);
	                      }
	                      break;
	                    case 3:
	                      coords = classifyRings$1(coords);
	                      for (i = 0; i < coords.length; i++) {
	                        for (j = 0; j < coords[i].length; j++) {
	                          project(coords[i][j]);
	                        }
	                      }
	                      break;
	                  }
	                  if (coords.length === 1) {
	                    coords = coords[0];
	                  } else {
	                    type = "Multi" + type;
	                  }
	                  var result = {
	                    type: "Feature",
	                    geometry: {
	                      type,
	                      coordinates: coords
	                    },
	                    properties: this.properties
	                  };
	                  if ("id" in this) {
	                    result.id = this.id;
	                  }
	                  return result;
	                };
	                function classifyRings$1(rings) {
	                  var len = rings.length;
	                  if (len <= 1) {
	                    return [rings];
	                  }
	                  var polygons = [], polygon, ccw;
	                  for (var i = 0; i < len; i++) {
	                    var area2 = signedArea$1(rings[i]);
	                    if (area2 === 0) {
	                      continue;
	                    }
	                    if (ccw === undefined) {
	                      ccw = area2 < 0;
	                    }
	                    if (ccw === area2 < 0) {
	                      if (polygon) {
	                        polygons.push(polygon);
	                      }
	                      polygon = [rings[i]];
	                    } else {
	                      polygon.push(rings[i]);
	                    }
	                  }
	                  if (polygon) {
	                    polygons.push(polygon);
	                  }
	                  return polygons;
	                }
	                function signedArea$1(ring) {
	                  var sum = 0;
	                  for (var i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
	                    p1 = ring[i];
	                    p2 = ring[j];
	                    sum += (p2.x - p1.x) * (p1.y + p2.y);
	                  }
	                  return sum;
	                }
	                var vectortilelayer = VectorTileLayer;
	                function VectorTileLayer(pbf2, end) {
	                  this.version = 1;
	                  this.name = null;
	                  this.extent = 4096;
	                  this.length = 0;
	                  this._pbf = pbf2;
	                  this._keys = [];
	                  this._values = [];
	                  this._features = [];
	                  pbf2.readFields(readLayer, this, end);
	                  this.length = this._features.length;
	                }
	                function readLayer(tag, layer2, pbf2) {
	                  if (tag === 15) {
	                    layer2.version = pbf2.readVarint();
	                  } else if (tag === 1) {
	                    layer2.name = pbf2.readString();
	                  } else if (tag === 5) {
	                    layer2.extent = pbf2.readVarint();
	                  } else if (tag === 2) {
	                    layer2._features.push(pbf2.pos);
	                  } else if (tag === 3) {
	                    layer2._keys.push(pbf2.readString());
	                  } else if (tag === 4) {
	                    layer2._values.push(readValueMessage(pbf2));
	                  }
	                }
	                function readValueMessage(pbf2) {
	                  var value = null, end = pbf2.readVarint() + pbf2.pos;
	                  while (pbf2.pos < end) {
	                    var tag = pbf2.readVarint() >> 3;
	                    value = tag === 1 ? pbf2.readString() : tag === 2 ? pbf2.readFloat() : tag === 3 ? pbf2.readDouble() : tag === 4 ? pbf2.readVarint64() : tag === 5 ? pbf2.readVarint() : tag === 6 ? pbf2.readSVarint() : tag === 7 ? pbf2.readBoolean() : null;
	                  }
	                  return value;
	                }
	                VectorTileLayer.prototype.feature = function(i) {
	                  if (i < 0 || i >= this._features.length) {
	                    throw new Error("feature index out of bounds");
	                  }
	                  this._pbf.pos = this._features[i];
	                  var end = this._pbf.readVarint() + this._pbf.pos;
	                  return new vectortilefeature(this._pbf, end, this.extent, this._keys, this._values);
	                };
	                var vectortile = VectorTile;
	                function VectorTile(pbf2, end) {
	                  this.layers = pbf2.readFields(readTile, {}, end);
	                }
	                function readTile(tag, layers, pbf2) {
	                  if (tag === 3) {
	                    var layer2 = new vectortilelayer(pbf2, pbf2.readVarint() + pbf2.pos);
	                    if (layer2.length) {
	                      layers[layer2.name] = layer2;
	                    }
	                  }
	                }
	                var VectorTile$1 = vectortile;
	                var VectorTileFeature$1 = vectortilefeature;
	                var VectorTileLayer$1 = vectortilelayer;
	                var vectorTile = {
	                  VectorTile: VectorTile$1,
	                  VectorTileFeature: VectorTileFeature$1,
	                  VectorTileLayer: VectorTileLayer$1
	                };
	                var vectorTileFeatureTypes = vectorTile.VectorTileFeature.types;
	                var EARCUT_MAX_RINGS$1 = 500;
	                var FACTOR = Math.pow(2, 13);
	                function addVertex(vertexArray, x, y, nx, ny, nz, t, e) {
	                  vertexArray.emplaceBack(x, y, Math.floor(nx * FACTOR) * 2 + t, ny * FACTOR * 2, nz * FACTOR * 2, Math.round(e));
	                }
	                var FillExtrusionBucket = function FillExtrusionBucket2(options) {
	                  this.zoom = options.zoom;
	                  this.overscaling = options.overscaling;
	                  this.layers = options.layers;
	                  this.layerIds = this.layers.map(function(layer2) {
	                    return layer2.id;
	                  });
	                  this.index = options.index;
	                  this.hasPattern = false;
	                  this.layoutVertexArray = new StructArrayLayout2i4i12();
	                  this.indexArray = new StructArrayLayout3ui6();
	                  this.programConfigurations = new ProgramConfigurationSet(members$2, options.layers, options.zoom);
	                  this.segments = new SegmentVector();
	                  this.stateDependentLayerIds = this.layers.filter(function(l) {
	                    return l.isStateDependent();
	                  }).map(function(l) {
	                    return l.id;
	                  });
	                };
	                FillExtrusionBucket.prototype.populate = function populate(features, options, canonical) {
	                  this.features = [];
	                  this.hasPattern = hasPattern("fill-extrusion", this.layers, options);
	                  for (var i = 0, list = features; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var feature = ref.feature;
	                    var id2 = ref.id;
	                    var index = ref.index;
	                    var sourceLayerIndex = ref.sourceLayerIndex;
	                    var needGeometry = this.layers[0]._featureFilter.needGeometry;
	                    var evaluationFeature = {
	                      type: feature.type,
	                      id: id2,
	                      properties: feature.properties,
	                      geometry: needGeometry ? loadGeometry(feature) : []
	                    };
	                    if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
	                      continue;
	                    }
	                    var patternFeature = {
	                      id: id2,
	                      sourceLayerIndex,
	                      index,
	                      geometry: needGeometry ? evaluationFeature.geometry : loadGeometry(feature),
	                      properties: feature.properties,
	                      type: feature.type,
	                      patterns: {}
	                    };
	                    if (typeof feature.id !== "undefined") {
	                      patternFeature.id = feature.id;
	                    }
	                    if (this.hasPattern) {
	                      this.features.push(addPatternDependencies("fill-extrusion", this.layers, patternFeature, this.zoom, options));
	                    } else {
	                      this.addFeature(patternFeature, patternFeature.geometry, index, canonical, {});
	                    }
	                    options.featureIndex.insert(feature, patternFeature.geometry, index, sourceLayerIndex, this.index, true);
	                  }
	                };
	                FillExtrusionBucket.prototype.addFeatures = function addFeatures(options, canonical, imagePositions) {
	                  for (var i = 0, list = this.features; i < list.length; i += 1) {
	                    var feature = list[i];
	                    var geometry = feature.geometry;
	                    this.addFeature(feature, geometry, feature.index, canonical, imagePositions);
	                  }
	                };
	                FillExtrusionBucket.prototype.update = function update(states, vtLayer, imagePositions) {
	                  if (!this.stateDependentLayers.length) {
	                    return;
	                  }
	                  this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
	                };
	                FillExtrusionBucket.prototype.isEmpty = function isEmpty2() {
	                  return this.layoutVertexArray.length === 0;
	                };
	                FillExtrusionBucket.prototype.uploadPending = function uploadPending() {
	                  return !this.uploaded || this.programConfigurations.needsUpload;
	                };
	                FillExtrusionBucket.prototype.upload = function upload(context) {
	                  if (!this.uploaded) {
	                    this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$2);
	                    this.indexBuffer = context.createIndexBuffer(this.indexArray);
	                  }
	                  this.programConfigurations.upload(context);
	                  this.uploaded = true;
	                };
	                FillExtrusionBucket.prototype.destroy = function destroy() {
	                  if (!this.layoutVertexBuffer) {
	                    return;
	                  }
	                  this.layoutVertexBuffer.destroy();
	                  this.indexBuffer.destroy();
	                  this.programConfigurations.destroy();
	                  this.segments.destroy();
	                };
	                FillExtrusionBucket.prototype.addFeature = function addFeature2(feature, geometry, index, canonical, imagePositions) {
	                  for (var i$4 = 0, list$3 = classifyRings(geometry, EARCUT_MAX_RINGS$1); i$4 < list$3.length; i$4 += 1) {
	                    var polygon = list$3[i$4];
	                    var numVertices = 0;
	                    for (var i$1 = 0, list = polygon; i$1 < list.length; i$1 += 1) {
	                      var ring = list[i$1];
	                      numVertices += ring.length;
	                    }
	                    var segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
	                    for (var i$2 = 0, list$1 = polygon; i$2 < list$1.length; i$2 += 1) {
	                      var ring$1 = list$1[i$2];
	                      if (ring$1.length === 0) {
	                        continue;
	                      }
	                      if (isEntirelyOutside(ring$1)) {
	                        continue;
	                      }
	                      var edgeDistance = 0;
	                      for (var p = 0; p < ring$1.length; p++) {
	                        var p1 = ring$1[p];
	                        if (p >= 1) {
	                          var p2 = ring$1[p - 1];
	                          if (!isBoundaryEdge(p1, p2)) {
	                            if (segment.vertexLength + 4 > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
	                              segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
	                            }
	                            var perp2 = p1.sub(p2)._perp()._unit();
	                            var dist = p2.dist(p1);
	                            if (edgeDistance + dist > 32768) {
	                              edgeDistance = 0;
	                            }
	                            addVertex(this.layoutVertexArray, p1.x, p1.y, perp2.x, perp2.y, 0, 0, edgeDistance);
	                            addVertex(this.layoutVertexArray, p1.x, p1.y, perp2.x, perp2.y, 0, 1, edgeDistance);
	                            edgeDistance += dist;
	                            addVertex(this.layoutVertexArray, p2.x, p2.y, perp2.x, perp2.y, 0, 0, edgeDistance);
	                            addVertex(this.layoutVertexArray, p2.x, p2.y, perp2.x, perp2.y, 0, 1, edgeDistance);
	                            var bottomRight = segment.vertexLength;
	                            this.indexArray.emplaceBack(bottomRight, bottomRight + 2, bottomRight + 1);
	                            this.indexArray.emplaceBack(bottomRight + 1, bottomRight + 2, bottomRight + 3);
	                            segment.vertexLength += 4;
	                            segment.primitiveLength += 2;
	                          }
	                        }
	                      }
	                    }
	                    if (segment.vertexLength + numVertices > SegmentVector.MAX_VERTEX_ARRAY_LENGTH) {
	                      segment = this.segments.prepareSegment(numVertices, this.layoutVertexArray, this.indexArray);
	                    }
	                    if (vectorTileFeatureTypes[feature.type] !== "Polygon") {
	                      continue;
	                    }
	                    var flattened = [];
	                    var holeIndices = [];
	                    var triangleIndex = segment.vertexLength;
	                    for (var i$3 = 0, list$2 = polygon; i$3 < list$2.length; i$3 += 1) {
	                      var ring$2 = list$2[i$3];
	                      if (ring$2.length === 0) {
	                        continue;
	                      }
	                      if (ring$2 !== polygon[0]) {
	                        holeIndices.push(flattened.length / 2);
	                      }
	                      for (var i = 0; i < ring$2.length; i++) {
	                        var p$1 = ring$2[i];
	                        addVertex(this.layoutVertexArray, p$1.x, p$1.y, 0, 0, 1, 1, 0);
	                        flattened.push(p$1.x);
	                        flattened.push(p$1.y);
	                      }
	                    }
	                    var indices = earcut_1(flattened, holeIndices);
	                    for (var j = 0; j < indices.length; j += 3) {
	                      this.indexArray.emplaceBack(triangleIndex + indices[j], triangleIndex + indices[j + 2], triangleIndex + indices[j + 1]);
	                    }
	                    segment.primitiveLength += indices.length / 3;
	                    segment.vertexLength += numVertices;
	                  }
	                  this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
	                };
	                register("FillExtrusionBucket", FillExtrusionBucket, {
	                  omit: [
	                    "layers",
	                    "features"
	                  ]
	                });
	                function isBoundaryEdge(p1, p2) {
	                  return p1.x === p2.x && (p1.x < 0 || p1.x > EXTENT$1) || p1.y === p2.y && (p1.y < 0 || p1.y > EXTENT$1);
	                }
	                function isEntirelyOutside(ring) {
	                  return ring.every(function(p) {
	                    return p.x < 0;
	                  }) || ring.every(function(p) {
	                    return p.x > EXTENT$1;
	                  }) || ring.every(function(p) {
	                    return p.y < 0;
	                  }) || ring.every(function(p) {
	                    return p.y > EXTENT$1;
	                  });
	                }
	                var paint$5 = new Properties({
	                  "fill-extrusion-opacity": new DataConstantProperty(spec["paint_fill-extrusion"]["fill-extrusion-opacity"]),
	                  "fill-extrusion-color": new DataDrivenProperty(spec["paint_fill-extrusion"]["fill-extrusion-color"]),
	                  "fill-extrusion-translate": new DataConstantProperty(spec["paint_fill-extrusion"]["fill-extrusion-translate"]),
	                  "fill-extrusion-translate-anchor": new DataConstantProperty(spec["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
	                  "fill-extrusion-pattern": new CrossFadedDataDrivenProperty(spec["paint_fill-extrusion"]["fill-extrusion-pattern"]),
	                  "fill-extrusion-height": new DataDrivenProperty(spec["paint_fill-extrusion"]["fill-extrusion-height"]),
	                  "fill-extrusion-base": new DataDrivenProperty(spec["paint_fill-extrusion"]["fill-extrusion-base"]),
	                  "fill-extrusion-vertical-gradient": new DataConstantProperty(spec["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
	                });
	                var properties$4 = { paint: paint$5 };
	                var FillExtrusionStyleLayer = function(StyleLayer2) {
	                  function FillExtrusionStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$4);
	                  }
	                  FillExtrusionStyleLayer2.__proto__ = StyleLayer2;
	                  FillExtrusionStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  FillExtrusionStyleLayer2.prototype.constructor = FillExtrusionStyleLayer2;
	                  FillExtrusionStyleLayer2.prototype.createBucket = function createBucket(parameters) {
	                    return new FillExtrusionBucket(parameters);
	                  };
	                  FillExtrusionStyleLayer2.prototype.queryRadius = function queryRadius() {
	                    return translateDistance(this.paint.get("fill-extrusion-translate"));
	                  };
	                  FillExtrusionStyleLayer2.prototype.is3D = function is3D() {
	                    return true;
	                  };
	                  FillExtrusionStyleLayer2.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits, pixelPosMatrix) {
	                    var translatedPolygon = translate(queryGeometry, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), transform.angle, pixelsToTileUnits);
	                    var height = this.paint.get("fill-extrusion-height").evaluate(feature, featureState);
	                    var base = this.paint.get("fill-extrusion-base").evaluate(feature, featureState);
	                    var projectedQueryGeometry = projectQueryGeometry$1(translatedPolygon, pixelPosMatrix, transform, 0);
	                    var projected = projectExtrusion(geometry, base, height, pixelPosMatrix);
	                    var projectedBase = projected[0];
	                    var projectedTop = projected[1];
	                    return checkIntersection(projectedBase, projectedTop, projectedQueryGeometry);
	                  };
	                  return FillExtrusionStyleLayer2;
	                }(StyleLayer);
	                function dot$2(a, b) {
	                  return a.x * b.x + a.y * b.y;
	                }
	                function getIntersectionDistance(projectedQueryGeometry, projectedFace) {
	                  if (projectedQueryGeometry.length === 1) {
	                    var i = 0;
	                    var a = projectedFace[i++];
	                    var b;
	                    while (!b || a.equals(b)) {
	                      b = projectedFace[i++];
	                      if (!b) {
	                        return Infinity;
	                      }
	                    }
	                    for (; i < projectedFace.length; i++) {
	                      var c = projectedFace[i];
	                      var p = projectedQueryGeometry[0];
	                      var ab = b.sub(a);
	                      var ac = c.sub(a);
	                      var ap = p.sub(a);
	                      var dotABAB = dot$2(ab, ab);
	                      var dotABAC = dot$2(ab, ac);
	                      var dotACAC = dot$2(ac, ac);
	                      var dotAPAB = dot$2(ap, ab);
	                      var dotAPAC = dot$2(ap, ac);
	                      var denom = dotABAB * dotACAC - dotABAC * dotABAC;
	                      var v = (dotACAC * dotAPAB - dotABAC * dotAPAC) / denom;
	                      var w = (dotABAB * dotAPAC - dotABAC * dotAPAB) / denom;
	                      var u = 1 - v - w;
	                      var distance = a.z * u + b.z * v + c.z * w;
	                      if (isFinite(distance)) {
	                        return distance;
	                      }
	                    }
	                    return Infinity;
	                  } else {
	                    var closestDistance = Infinity;
	                    for (var i$1 = 0, list = projectedFace; i$1 < list.length; i$1 += 1) {
	                      var p$1 = list[i$1];
	                      closestDistance = Math.min(closestDistance, p$1.z);
	                    }
	                    return closestDistance;
	                  }
	                }
	                function checkIntersection(projectedBase, projectedTop, projectedQueryGeometry) {
	                  var closestDistance = Infinity;
	                  if (polygonIntersectsMultiPolygon(projectedQueryGeometry, projectedTop)) {
	                    closestDistance = getIntersectionDistance(projectedQueryGeometry, projectedTop[0]);
	                  }
	                  for (var r = 0; r < projectedTop.length; r++) {
	                    var ringTop = projectedTop[r];
	                    var ringBase = projectedBase[r];
	                    for (var p = 0; p < ringTop.length - 1; p++) {
	                      var topA = ringTop[p];
	                      var topB = ringTop[p + 1];
	                      var baseA = ringBase[p];
	                      var baseB = ringBase[p + 1];
	                      var face = [
	                        topA,
	                        topB,
	                        baseB,
	                        baseA,
	                        topA
	                      ];
	                      if (polygonIntersectsPolygon(projectedQueryGeometry, face)) {
	                        closestDistance = Math.min(closestDistance, getIntersectionDistance(projectedQueryGeometry, face));
	                      }
	                    }
	                  }
	                  return closestDistance === Infinity ? false : closestDistance;
	                }
	                function projectExtrusion(geometry, zBase, zTop, m) {
	                  var projectedBase = [];
	                  var projectedTop = [];
	                  var baseXZ = m[8] * zBase;
	                  var baseYZ = m[9] * zBase;
	                  var baseZZ = m[10] * zBase;
	                  var baseWZ = m[11] * zBase;
	                  var topXZ = m[8] * zTop;
	                  var topYZ = m[9] * zTop;
	                  var topZZ = m[10] * zTop;
	                  var topWZ = m[11] * zTop;
	                  for (var i$1 = 0, list$1 = geometry; i$1 < list$1.length; i$1 += 1) {
	                    var r = list$1[i$1];
	                    var ringBase = [];
	                    var ringTop = [];
	                    for (var i = 0, list = r; i < list.length; i += 1) {
	                      var p = list[i];
	                      var x = p.x;
	                      var y = p.y;
	                      var sX = m[0] * x + m[4] * y + m[12];
	                      var sY = m[1] * x + m[5] * y + m[13];
	                      var sZ = m[2] * x + m[6] * y + m[14];
	                      var sW = m[3] * x + m[7] * y + m[15];
	                      var baseX = sX + baseXZ;
	                      var baseY = sY + baseYZ;
	                      var baseZ = sZ + baseZZ;
	                      var baseW = sW + baseWZ;
	                      var topX = sX + topXZ;
	                      var topY = sY + topYZ;
	                      var topZ = sZ + topZZ;
	                      var topW = sW + topWZ;
	                      var b = new pointGeometry(baseX / baseW, baseY / baseW);
	                      b.z = baseZ / baseW;
	                      ringBase.push(b);
	                      var t = new pointGeometry(topX / topW, topY / topW);
	                      t.z = topZ / topW;
	                      ringTop.push(t);
	                    }
	                    projectedBase.push(ringBase);
	                    projectedTop.push(ringTop);
	                  }
	                  return [
	                    projectedBase,
	                    projectedTop
	                  ];
	                }
	                function projectQueryGeometry$1(queryGeometry, pixelPosMatrix, transform, z) {
	                  var projectedQueryGeometry = [];
	                  for (var i = 0, list = queryGeometry; i < list.length; i += 1) {
	                    var p = list[i];
	                    var v = [
	                      p.x,
	                      p.y,
	                      z,
	                      1
	                    ];
	                    transformMat4(v, v, pixelPosMatrix);
	                    projectedQueryGeometry.push(new pointGeometry(v[0] / v[3], v[1] / v[3]));
	                  }
	                  return projectedQueryGeometry;
	                }
	                var lineLayoutAttributes = createLayout([
	                  {
	                    name: "a_pos_normal",
	                    components: 2,
	                    type: "Int16"
	                  },
	                  {
	                    name: "a_data",
	                    components: 4,
	                    type: "Uint8"
	                  }
	                ], 4);
	                var members$3 = lineLayoutAttributes.members;
	                var vectorTileFeatureTypes$1 = vectorTile.VectorTileFeature.types;
	                var EXTRUDE_SCALE = 63;
	                var COS_HALF_SHARP_CORNER = Math.cos(75 / 2 * (Math.PI / 180));
	                var SHARP_CORNER_OFFSET = 15;
	                var DEG_PER_TRIANGLE = 20;
	                var LINE_DISTANCE_BUFFER_BITS = 15;
	                var LINE_DISTANCE_SCALE = 1 / 2;
	                var MAX_LINE_DISTANCE = Math.pow(2, LINE_DISTANCE_BUFFER_BITS - 1) / LINE_DISTANCE_SCALE;
	                var LineBucket = function LineBucket2(options) {
	                  this.zoom = options.zoom;
	                  this.overscaling = options.overscaling;
	                  this.layers = options.layers;
	                  this.layerIds = this.layers.map(function(layer2) {
	                    return layer2.id;
	                  });
	                  this.index = options.index;
	                  this.hasPattern = false;
	                  this.patternFeatures = [];
	                  this.layoutVertexArray = new StructArrayLayout2i4ub8();
	                  this.indexArray = new StructArrayLayout3ui6();
	                  this.programConfigurations = new ProgramConfigurationSet(members$3, options.layers, options.zoom);
	                  this.segments = new SegmentVector();
	                  this.stateDependentLayerIds = this.layers.filter(function(l) {
	                    return l.isStateDependent();
	                  }).map(function(l) {
	                    return l.id;
	                  });
	                };
	                LineBucket.prototype.populate = function populate(features, options, canonical) {
	                  this.hasPattern = hasPattern("line", this.layers, options);
	                  var lineSortKey = this.layers[0].layout.get("line-sort-key");
	                  var bucketFeatures = [];
	                  for (var i = 0, list = features; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var feature = ref.feature;
	                    var id2 = ref.id;
	                    var index = ref.index;
	                    var sourceLayerIndex = ref.sourceLayerIndex;
	                    var needGeometry = this.layers[0]._featureFilter.needGeometry;
	                    var evaluationFeature = {
	                      type: feature.type,
	                      id: id2,
	                      properties: feature.properties,
	                      geometry: needGeometry ? loadGeometry(feature) : []
	                    };
	                    if (!this.layers[0]._featureFilter.filter(new EvaluationParameters(this.zoom), evaluationFeature, canonical)) {
	                      continue;
	                    }
	                    if (!needGeometry) {
	                      evaluationFeature.geometry = loadGeometry(feature);
	                    }
	                    var sortKey = lineSortKey ? lineSortKey.evaluate(evaluationFeature, {}, canonical) : undefined;
	                    var bucketFeature = {
	                      id: id2,
	                      properties: feature.properties,
	                      type: feature.type,
	                      sourceLayerIndex,
	                      index,
	                      geometry: evaluationFeature.geometry,
	                      patterns: {},
	                      sortKey
	                    };
	                    bucketFeatures.push(bucketFeature);
	                  }
	                  if (lineSortKey) {
	                    bucketFeatures.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                  for (var i$1 = 0, list$1 = bucketFeatures; i$1 < list$1.length; i$1 += 1) {
	                    var bucketFeature$1 = list$1[i$1];
	                    var ref$1 = bucketFeature$1;
	                    var geometry = ref$1.geometry;
	                    var index$1 = ref$1.index;
	                    var sourceLayerIndex$1 = ref$1.sourceLayerIndex;
	                    if (this.hasPattern) {
	                      var patternBucketFeature = addPatternDependencies("line", this.layers, bucketFeature$1, this.zoom, options);
	                      this.patternFeatures.push(patternBucketFeature);
	                    } else {
	                      this.addFeature(bucketFeature$1, geometry, index$1, canonical, {});
	                    }
	                    var feature$1 = features[index$1].feature;
	                    options.featureIndex.insert(feature$1, geometry, index$1, sourceLayerIndex$1, this.index);
	                  }
	                };
	                LineBucket.prototype.update = function update(states, vtLayer, imagePositions) {
	                  if (!this.stateDependentLayers.length) {
	                    return;
	                  }
	                  this.programConfigurations.updatePaintArrays(states, vtLayer, this.stateDependentLayers, imagePositions);
	                };
	                LineBucket.prototype.addFeatures = function addFeatures(options, canonical, imagePositions) {
	                  for (var i = 0, list = this.patternFeatures; i < list.length; i += 1) {
	                    var feature = list[i];
	                    this.addFeature(feature, feature.geometry, feature.index, canonical, imagePositions);
	                  }
	                };
	                LineBucket.prototype.isEmpty = function isEmpty2() {
	                  return this.layoutVertexArray.length === 0;
	                };
	                LineBucket.prototype.uploadPending = function uploadPending() {
	                  return !this.uploaded || this.programConfigurations.needsUpload;
	                };
	                LineBucket.prototype.upload = function upload(context) {
	                  if (!this.uploaded) {
	                    this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, members$3);
	                    this.indexBuffer = context.createIndexBuffer(this.indexArray);
	                  }
	                  this.programConfigurations.upload(context);
	                  this.uploaded = true;
	                };
	                LineBucket.prototype.destroy = function destroy() {
	                  if (!this.layoutVertexBuffer) {
	                    return;
	                  }
	                  this.layoutVertexBuffer.destroy();
	                  this.indexBuffer.destroy();
	                  this.programConfigurations.destroy();
	                  this.segments.destroy();
	                };
	                LineBucket.prototype.addFeature = function addFeature2(feature, geometry, index, canonical, imagePositions) {
	                  var layout2 = this.layers[0].layout;
	                  var join = layout2.get("line-join").evaluate(feature, {});
	                  var cap = layout2.get("line-cap");
	                  var miterLimit = layout2.get("line-miter-limit");
	                  var roundLimit = layout2.get("line-round-limit");
	                  for (var i = 0, list = geometry; i < list.length; i += 1) {
	                    var line = list[i];
	                    this.addLine(line, feature, join, cap, miterLimit, roundLimit);
	                  }
	                  this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, feature, index, imagePositions, canonical);
	                };
	                LineBucket.prototype.addLine = function addLine(vertices, feature, join, cap, miterLimit, roundLimit) {
	                  this.distance = 0;
	                  this.scaledDistance = 0;
	                  this.totalDistance = 0;
	                  if (!!feature.properties && feature.properties.hasOwnProperty("mapbox_clip_start") && feature.properties.hasOwnProperty("mapbox_clip_end")) {
	                    this.clipStart = +feature.properties["mapbox_clip_start"];
	                    this.clipEnd = +feature.properties["mapbox_clip_end"];
	                    for (var i = 0; i < vertices.length - 1; i++) {
	                      this.totalDistance += vertices[i].dist(vertices[i + 1]);
	                    }
	                    this.updateScaledDistance();
	                  }
	                  var isPolygon = vectorTileFeatureTypes$1[feature.type] === "Polygon";
	                  var len = vertices.length;
	                  while (len >= 2 && vertices[len - 1].equals(vertices[len - 2])) {
	                    len--;
	                  }
	                  var first = 0;
	                  while (first < len - 1 && vertices[first].equals(vertices[first + 1])) {
	                    first++;
	                  }
	                  if (len < (isPolygon ? 3 : 2)) {
	                    return;
	                  }
	                  if (join === "bevel") {
	                    miterLimit = 1.05;
	                  }
	                  var sharpCornerOffset = this.overscaling <= 16 ? SHARP_CORNER_OFFSET * EXTENT$1 / (512 * this.overscaling) : 0;
	                  var segment = this.segments.prepareSegment(len * 10, this.layoutVertexArray, this.indexArray);
	                  var currentVertex;
	                  var prevVertex = undefined;
	                  var nextVertex = undefined;
	                  var prevNormal = undefined;
	                  var nextNormal = undefined;
	                  this.e1 = this.e2 = -1;
	                  if (isPolygon) {
	                    currentVertex = vertices[len - 2];
	                    nextNormal = vertices[first].sub(currentVertex)._unit()._perp();
	                  }
	                  for (var i$1 = first; i$1 < len; i$1++) {
	                    nextVertex = i$1 === len - 1 ? isPolygon ? vertices[first + 1] : undefined : vertices[i$1 + 1];
	                    if (nextVertex && vertices[i$1].equals(nextVertex)) {
	                      continue;
	                    }
	                    if (nextNormal) {
	                      prevNormal = nextNormal;
	                    }
	                    if (currentVertex) {
	                      prevVertex = currentVertex;
	                    }
	                    currentVertex = vertices[i$1];
	                    nextNormal = nextVertex ? nextVertex.sub(currentVertex)._unit()._perp() : prevNormal;
	                    prevNormal = prevNormal || nextNormal;
	                    var joinNormal = prevNormal.add(nextNormal);
	                    if (joinNormal.x !== 0 || joinNormal.y !== 0) {
	                      joinNormal._unit();
	                    }
	                    var cosAngle = prevNormal.x * nextNormal.x + prevNormal.y * nextNormal.y;
	                    var cosHalfAngle = joinNormal.x * nextNormal.x + joinNormal.y * nextNormal.y;
	                    var miterLength = cosHalfAngle !== 0 ? 1 / cosHalfAngle : Infinity;
	                    var approxAngle = 2 * Math.sqrt(2 - 2 * cosHalfAngle);
	                    var isSharpCorner = cosHalfAngle < COS_HALF_SHARP_CORNER && prevVertex && nextVertex;
	                    var lineTurnsLeft = prevNormal.x * nextNormal.y - prevNormal.y * nextNormal.x > 0;
	                    if (isSharpCorner && i$1 > first) {
	                      var prevSegmentLength = currentVertex.dist(prevVertex);
	                      if (prevSegmentLength > 2 * sharpCornerOffset) {
	                        var newPrevVertex = currentVertex.sub(currentVertex.sub(prevVertex)._mult(sharpCornerOffset / prevSegmentLength)._round());
	                        this.updateDistance(prevVertex, newPrevVertex);
	                        this.addCurrentVertex(newPrevVertex, prevNormal, 0, 0, segment);
	                        prevVertex = newPrevVertex;
	                      }
	                    }
	                    var middleVertex = prevVertex && nextVertex;
	                    var currentJoin = middleVertex ? join : isPolygon ? "butt" : cap;
	                    if (middleVertex && currentJoin === "round") {
	                      if (miterLength < roundLimit) {
	                        currentJoin = "miter";
	                      } else if (miterLength <= 2) {
	                        currentJoin = "fakeround";
	                      }
	                    }
	                    if (currentJoin === "miter" && miterLength > miterLimit) {
	                      currentJoin = "bevel";
	                    }
	                    if (currentJoin === "bevel") {
	                      if (miterLength > 2) {
	                        currentJoin = "flipbevel";
	                      }
	                      if (miterLength < miterLimit) {
	                        currentJoin = "miter";
	                      }
	                    }
	                    if (prevVertex) {
	                      this.updateDistance(prevVertex, currentVertex);
	                    }
	                    if (currentJoin === "miter") {
	                      joinNormal._mult(miterLength);
	                      this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
	                    } else if (currentJoin === "flipbevel") {
	                      if (miterLength > 100) {
	                        joinNormal = nextNormal.mult(-1);
	                      } else {
	                        var bevelLength = miterLength * prevNormal.add(nextNormal).mag() / prevNormal.sub(nextNormal).mag();
	                        joinNormal._perp()._mult(bevelLength * (lineTurnsLeft ? -1 : 1));
	                      }
	                      this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
	                      this.addCurrentVertex(currentVertex, joinNormal.mult(-1), 0, 0, segment);
	                    } else if (currentJoin === "bevel" || currentJoin === "fakeround") {
	                      var offset = -Math.sqrt(miterLength * miterLength - 1);
	                      var offsetA = lineTurnsLeft ? offset : 0;
	                      var offsetB = lineTurnsLeft ? 0 : offset;
	                      if (prevVertex) {
	                        this.addCurrentVertex(currentVertex, prevNormal, offsetA, offsetB, segment);
	                      }
	                      if (currentJoin === "fakeround") {
	                        var n = Math.round(approxAngle * 180 / Math.PI / DEG_PER_TRIANGLE);
	                        for (var m = 1; m < n; m++) {
	                          var t = m / n;
	                          if (t !== 0.5) {
	                            var t22 = t - 0.5;
	                            var A = 1.0904 + cosAngle * (-3.2452 + cosAngle * (3.55645 - cosAngle * 1.43519));
	                            var B = 0.848013 + cosAngle * (-1.06021 + cosAngle * 0.215638);
	                            t = t + t * t22 * (t - 1) * (A * t22 * t22 + B);
	                          }
	                          var extrude = nextNormal.sub(prevNormal)._mult(t)._add(prevNormal)._unit()._mult(lineTurnsLeft ? -1 : 1);
	                          this.addHalfVertex(currentVertex, extrude.x, extrude.y, false, lineTurnsLeft, 0, segment);
	                        }
	                      }
	                      if (nextVertex) {
	                        this.addCurrentVertex(currentVertex, nextNormal, -offsetA, -offsetB, segment);
	                      }
	                    } else if (currentJoin === "butt") {
	                      this.addCurrentVertex(currentVertex, joinNormal, 0, 0, segment);
	                    } else if (currentJoin === "square") {
	                      var offset$1 = prevVertex ? 1 : -1;
	                      this.addCurrentVertex(currentVertex, joinNormal, offset$1, offset$1, segment);
	                    } else if (currentJoin === "round") {
	                      if (prevVertex) {
	                        this.addCurrentVertex(currentVertex, prevNormal, 0, 0, segment);
	                        this.addCurrentVertex(currentVertex, prevNormal, 1, 1, segment, true);
	                      }
	                      if (nextVertex) {
	                        this.addCurrentVertex(currentVertex, nextNormal, -1, -1, segment, true);
	                        this.addCurrentVertex(currentVertex, nextNormal, 0, 0, segment);
	                      }
	                    }
	                    if (isSharpCorner && i$1 < len - 1) {
	                      var nextSegmentLength = currentVertex.dist(nextVertex);
	                      if (nextSegmentLength > 2 * sharpCornerOffset) {
	                        var newCurrentVertex = currentVertex.add(nextVertex.sub(currentVertex)._mult(sharpCornerOffset / nextSegmentLength)._round());
	                        this.updateDistance(currentVertex, newCurrentVertex);
	                        this.addCurrentVertex(newCurrentVertex, nextNormal, 0, 0, segment);
	                        currentVertex = newCurrentVertex;
	                      }
	                    }
	                  }
	                };
	                LineBucket.prototype.addCurrentVertex = function addCurrentVertex(p, normal, endLeft, endRight, segment, round) {
	                  if (round === undefined)
	                    round = false;
	                  var leftX = normal.x + normal.y * endLeft;
	                  var leftY = normal.y - normal.x * endLeft;
	                  var rightX = -normal.x + normal.y * endRight;
	                  var rightY = -normal.y - normal.x * endRight;
	                  this.addHalfVertex(p, leftX, leftY, round, false, endLeft, segment);
	                  this.addHalfVertex(p, rightX, rightY, round, true, -endRight, segment);
	                  if (this.distance > MAX_LINE_DISTANCE / 2 && this.totalDistance === 0) {
	                    this.distance = 0;
	                    this.addCurrentVertex(p, normal, endLeft, endRight, segment, round);
	                  }
	                };
	                LineBucket.prototype.addHalfVertex = function addHalfVertex(ref, extrudeX, extrudeY, round, up, dir, segment) {
	                  var x = ref.x;
	                  var y = ref.y;
	                  var linesofar = this.scaledDistance * LINE_DISTANCE_SCALE;
	                  this.layoutVertexArray.emplaceBack((x << 1) + (round ? 1 : 0), (y << 1) + (up ? 1 : 0), Math.round(EXTRUDE_SCALE * extrudeX) + 128, Math.round(EXTRUDE_SCALE * extrudeY) + 128, (dir === 0 ? 0 : dir < 0 ? -1 : 1) + 1 | (linesofar & 63) << 2, linesofar >> 6);
	                  var e = segment.vertexLength++;
	                  if (this.e1 >= 0 && this.e2 >= 0) {
	                    this.indexArray.emplaceBack(this.e1, this.e2, e);
	                    segment.primitiveLength++;
	                  }
	                  if (up) {
	                    this.e2 = e;
	                  } else {
	                    this.e1 = e;
	                  }
	                };
	                LineBucket.prototype.updateScaledDistance = function updateScaledDistance() {
	                  this.scaledDistance = this.totalDistance > 0 ? (this.clipStart + (this.clipEnd - this.clipStart) * this.distance / this.totalDistance) * (MAX_LINE_DISTANCE - 1) : this.distance;
	                };
	                LineBucket.prototype.updateDistance = function updateDistance(prev, next) {
	                  this.distance += prev.dist(next);
	                  this.updateScaledDistance();
	                };
	                register("LineBucket", LineBucket, {
	                  omit: [
	                    "layers",
	                    "patternFeatures"
	                  ]
	                });
	                var layout$6 = new Properties({
	                  "line-cap": new DataConstantProperty(spec["layout_line"]["line-cap"]),
	                  "line-join": new DataDrivenProperty(spec["layout_line"]["line-join"]),
	                  "line-miter-limit": new DataConstantProperty(spec["layout_line"]["line-miter-limit"]),
	                  "line-round-limit": new DataConstantProperty(spec["layout_line"]["line-round-limit"]),
	                  "line-sort-key": new DataDrivenProperty(spec["layout_line"]["line-sort-key"])
	                });
	                var paint$6 = new Properties({
	                  "line-opacity": new DataDrivenProperty(spec["paint_line"]["line-opacity"]),
	                  "line-color": new DataDrivenProperty(spec["paint_line"]["line-color"]),
	                  "line-translate": new DataConstantProperty(spec["paint_line"]["line-translate"]),
	                  "line-translate-anchor": new DataConstantProperty(spec["paint_line"]["line-translate-anchor"]),
	                  "line-width": new DataDrivenProperty(spec["paint_line"]["line-width"]),
	                  "line-gap-width": new DataDrivenProperty(spec["paint_line"]["line-gap-width"]),
	                  "line-offset": new DataDrivenProperty(spec["paint_line"]["line-offset"]),
	                  "line-blur": new DataDrivenProperty(spec["paint_line"]["line-blur"]),
	                  "line-dasharray": new CrossFadedProperty(spec["paint_line"]["line-dasharray"]),
	                  "line-pattern": new CrossFadedDataDrivenProperty(spec["paint_line"]["line-pattern"]),
	                  "line-gradient": new ColorRampProperty(spec["paint_line"]["line-gradient"])
	                });
	                var properties$5 = {
	                  paint: paint$6,
	                  layout: layout$6
	                };
	                var LineFloorwidthProperty = function(DataDrivenProperty2) {
	                  function LineFloorwidthProperty2() {
	                    DataDrivenProperty2.apply(this, arguments);
	                  }
	                  LineFloorwidthProperty2.__proto__ = DataDrivenProperty2;
	                  LineFloorwidthProperty2.prototype = Object.create(DataDrivenProperty2.prototype);
	                  LineFloorwidthProperty2.prototype.constructor = LineFloorwidthProperty2;
	                  LineFloorwidthProperty2.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters) {
	                    parameters = new EvaluationParameters(Math.floor(parameters.zoom), {
	                      now: parameters.now,
	                      fadeDuration: parameters.fadeDuration,
	                      zoomHistory: parameters.zoomHistory,
	                      transition: parameters.transition
	                    });
	                    return DataDrivenProperty2.prototype.possiblyEvaluate.call(this, value, parameters);
	                  };
	                  LineFloorwidthProperty2.prototype.evaluate = function evaluate(value, globals, feature, featureState) {
	                    globals = extend({}, globals, { zoom: Math.floor(globals.zoom) });
	                    return DataDrivenProperty2.prototype.evaluate.call(this, value, globals, feature, featureState);
	                  };
	                  return LineFloorwidthProperty2;
	                }(DataDrivenProperty);
	                var lineFloorwidthProperty = new LineFloorwidthProperty(properties$5.paint.properties["line-width"].specification);
	                lineFloorwidthProperty.useIntegerZoom = true;
	                var LineStyleLayer = function(StyleLayer2) {
	                  function LineStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$5);
	                  }
	                  LineStyleLayer2.__proto__ = StyleLayer2;
	                  LineStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  LineStyleLayer2.prototype.constructor = LineStyleLayer2;
	                  LineStyleLayer2.prototype._handleSpecialPaintPropertyUpdate = function _handleSpecialPaintPropertyUpdate(name3) {
	                    if (name3 === "line-gradient") {
	                      this._updateGradient();
	                    }
	                  };
	                  LineStyleLayer2.prototype._updateGradient = function _updateGradient() {
	                    var expression2 = this._transitionablePaint._values["line-gradient"].value.expression;
	                    this.gradient = renderColorRamp(expression2, "lineProgress");
	                    this.gradientTexture = null;
	                  };
	                  LineStyleLayer2.prototype.recalculate = function recalculate(parameters, availableImages) {
	                    StyleLayer2.prototype.recalculate.call(this, parameters, availableImages);
	                    this.paint._values["line-floorwidth"] = lineFloorwidthProperty.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, parameters);
	                  };
	                  LineStyleLayer2.prototype.createBucket = function createBucket(parameters) {
	                    return new LineBucket(parameters);
	                  };
	                  LineStyleLayer2.prototype.queryRadius = function queryRadius(bucket) {
	                    var lineBucket = bucket;
	                    var width = getLineWidth(getMaximumPaintValue("line-width", this, lineBucket), getMaximumPaintValue("line-gap-width", this, lineBucket));
	                    var offset = getMaximumPaintValue("line-offset", this, lineBucket);
	                    return width / 2 + Math.abs(offset) + translateDistance(this.paint.get("line-translate"));
	                  };
	                  LineStyleLayer2.prototype.queryIntersectsFeature = function queryIntersectsFeature(queryGeometry, feature, featureState, geometry, zoom, transform, pixelsToTileUnits) {
	                    var translatedPolygon = translate(queryGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), transform.angle, pixelsToTileUnits);
	                    var halfWidth = pixelsToTileUnits / 2 * getLineWidth(this.paint.get("line-width").evaluate(feature, featureState), this.paint.get("line-gap-width").evaluate(feature, featureState));
	                    var lineOffset = this.paint.get("line-offset").evaluate(feature, featureState);
	                    if (lineOffset) {
	                      geometry = offsetLine(geometry, lineOffset * pixelsToTileUnits);
	                    }
	                    return polygonIntersectsBufferedMultiLine(translatedPolygon, geometry, halfWidth);
	                  };
	                  LineStyleLayer2.prototype.isTileClipped = function isTileClipped() {
	                    return true;
	                  };
	                  return LineStyleLayer2;
	                }(StyleLayer);
	                function getLineWidth(lineWidth, lineGapWidth) {
	                  if (lineGapWidth > 0) {
	                    return lineGapWidth + 2 * lineWidth;
	                  } else {
	                    return lineWidth;
	                  }
	                }
	                function offsetLine(rings, offset) {
	                  var newRings = [];
	                  var zero = new pointGeometry(0, 0);
	                  for (var k = 0; k < rings.length; k++) {
	                    var ring = rings[k];
	                    var newRing = [];
	                    for (var i = 0; i < ring.length; i++) {
	                      var a = ring[i - 1];
	                      var b = ring[i];
	                      var c = ring[i + 1];
	                      var aToB = i === 0 ? zero : b.sub(a)._unit()._perp();
	                      var bToC = i === ring.length - 1 ? zero : c.sub(b)._unit()._perp();
	                      var extrude = aToB._add(bToC)._unit();
	                      var cosHalfAngle = extrude.x * bToC.x + extrude.y * bToC.y;
	                      extrude._mult(1 / cosHalfAngle);
	                      newRing.push(extrude._mult(offset)._add(b));
	                    }
	                    newRings.push(newRing);
	                  }
	                  return newRings;
	                }
	                var symbolLayoutAttributes = createLayout([
	                  {
	                    name: "a_pos_offset",
	                    components: 4,
	                    type: "Int16"
	                  },
	                  {
	                    name: "a_data",
	                    components: 4,
	                    type: "Uint16"
	                  },
	                  {
	                    name: "a_pixeloffset",
	                    components: 4,
	                    type: "Int16"
	                  }
	                ], 4);
	                var dynamicLayoutAttributes = createLayout([{
	                  name: "a_projected_pos",
	                  components: 3,
	                  type: "Float32"
	                }], 4);
	                createLayout([{
	                  name: "a_fade_opacity",
	                  components: 1,
	                  type: "Uint32"
	                }], 4);
	                var collisionVertexAttributes = createLayout([
	                  {
	                    name: "a_placed",
	                    components: 2,
	                    type: "Uint8"
	                  },
	                  {
	                    name: "a_shift",
	                    components: 2,
	                    type: "Float32"
	                  }
	                ]);
	                createLayout([
	                  {
	                    type: "Int16",
	                    name: "anchorPointX"
	                  },
	                  {
	                    type: "Int16",
	                    name: "anchorPointY"
	                  },
	                  {
	                    type: "Int16",
	                    name: "x1"
	                  },
	                  {
	                    type: "Int16",
	                    name: "y1"
	                  },
	                  {
	                    type: "Int16",
	                    name: "x2"
	                  },
	                  {
	                    type: "Int16",
	                    name: "y2"
	                  },
	                  {
	                    type: "Uint32",
	                    name: "featureIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "sourceLayerIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "bucketIndex"
	                  }
	                ]);
	                var collisionBoxLayout = createLayout([
	                  {
	                    name: "a_pos",
	                    components: 2,
	                    type: "Int16"
	                  },
	                  {
	                    name: "a_anchor_pos",
	                    components: 2,
	                    type: "Int16"
	                  },
	                  {
	                    name: "a_extrude",
	                    components: 2,
	                    type: "Int16"
	                  }
	                ], 4);
	                var collisionCircleLayout = createLayout([
	                  {
	                    name: "a_pos",
	                    components: 2,
	                    type: "Float32"
	                  },
	                  {
	                    name: "a_radius",
	                    components: 1,
	                    type: "Float32"
	                  },
	                  {
	                    name: "a_flags",
	                    components: 2,
	                    type: "Int16"
	                  }
	                ], 4);
	                createLayout([{
	                  name: "triangle",
	                  components: 3,
	                  type: "Uint16"
	                }]);
	                createLayout([
	                  {
	                    type: "Int16",
	                    name: "anchorX"
	                  },
	                  {
	                    type: "Int16",
	                    name: "anchorY"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "glyphStartIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "numGlyphs"
	                  },
	                  {
	                    type: "Uint32",
	                    name: "vertexStartIndex"
	                  },
	                  {
	                    type: "Uint32",
	                    name: "lineStartIndex"
	                  },
	                  {
	                    type: "Uint32",
	                    name: "lineLength"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "segment"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "lowerSize"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "upperSize"
	                  },
	                  {
	                    type: "Float32",
	                    name: "lineOffsetX"
	                  },
	                  {
	                    type: "Float32",
	                    name: "lineOffsetY"
	                  },
	                  {
	                    type: "Uint8",
	                    name: "writingMode"
	                  },
	                  {
	                    type: "Uint8",
	                    name: "placedOrientation"
	                  },
	                  {
	                    type: "Uint8",
	                    name: "hidden"
	                  },
	                  {
	                    type: "Uint32",
	                    name: "crossTileID"
	                  },
	                  {
	                    type: "Int16",
	                    name: "associatedIconIndex"
	                  }
	                ]);
	                createLayout([
	                  {
	                    type: "Int16",
	                    name: "anchorX"
	                  },
	                  {
	                    type: "Int16",
	                    name: "anchorY"
	                  },
	                  {
	                    type: "Int16",
	                    name: "rightJustifiedTextSymbolIndex"
	                  },
	                  {
	                    type: "Int16",
	                    name: "centerJustifiedTextSymbolIndex"
	                  },
	                  {
	                    type: "Int16",
	                    name: "leftJustifiedTextSymbolIndex"
	                  },
	                  {
	                    type: "Int16",
	                    name: "verticalPlacedTextSymbolIndex"
	                  },
	                  {
	                    type: "Int16",
	                    name: "placedIconSymbolIndex"
	                  },
	                  {
	                    type: "Int16",
	                    name: "verticalPlacedIconSymbolIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "key"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "textBoxStartIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "textBoxEndIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "verticalTextBoxStartIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "verticalTextBoxEndIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "iconBoxStartIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "iconBoxEndIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "verticalIconBoxStartIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "verticalIconBoxEndIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "featureIndex"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "numHorizontalGlyphVertices"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "numVerticalGlyphVertices"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "numIconVertices"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "numVerticalIconVertices"
	                  },
	                  {
	                    type: "Uint16",
	                    name: "useRuntimeCollisionCircles"
	                  },
	                  {
	                    type: "Uint32",
	                    name: "crossTileID"
	                  },
	                  {
	                    type: "Float32",
	                    name: "textBoxScale"
	                  },
	                  {
	                    type: "Float32",
	                    components: 2,
	                    name: "textOffset"
	                  },
	                  {
	                    type: "Float32",
	                    name: "collisionCircleDiameter"
	                  }
	                ]);
	                createLayout([{
	                  type: "Float32",
	                  name: "offsetX"
	                }]);
	                createLayout([
	                  {
	                    type: "Int16",
	                    name: "x"
	                  },
	                  {
	                    type: "Int16",
	                    name: "y"
	                  },
	                  {
	                    type: "Int16",
	                    name: "tileUnitDistanceFromAnchor"
	                  }
	                ]);
	                function transformText(text, layer2, feature) {
	                  var transform = layer2.layout.get("text-transform").evaluate(feature, {});
	                  if (transform === "uppercase") {
	                    text = text.toLocaleUpperCase();
	                  } else if (transform === "lowercase") {
	                    text = text.toLocaleLowerCase();
	                  }
	                  if (plugin.applyArabicShaping) {
	                    text = plugin.applyArabicShaping(text);
	                  }
	                  return text;
	                }
	                function transformText$1(text, layer2, feature) {
	                  text.sections.forEach(function(section) {
	                    section.text = transformText(section.text, layer2, feature);
	                  });
	                  return text;
	                }
	                function mergeLines(features) {
	                  var leftIndex = {};
	                  var rightIndex = {};
	                  var mergedFeatures = [];
	                  var mergedIndex = 0;
	                  function add2(k2) {
	                    mergedFeatures.push(features[k2]);
	                    mergedIndex++;
	                  }
	                  function mergeFromRight(leftKey2, rightKey2, geom2) {
	                    var i2 = rightIndex[leftKey2];
	                    delete rightIndex[leftKey2];
	                    rightIndex[rightKey2] = i2;
	                    mergedFeatures[i2].geometry[0].pop();
	                    mergedFeatures[i2].geometry[0] = mergedFeatures[i2].geometry[0].concat(geom2[0]);
	                    return i2;
	                  }
	                  function mergeFromLeft(leftKey2, rightKey2, geom2) {
	                    var i2 = leftIndex[rightKey2];
	                    delete leftIndex[rightKey2];
	                    leftIndex[leftKey2] = i2;
	                    mergedFeatures[i2].geometry[0].shift();
	                    mergedFeatures[i2].geometry[0] = geom2[0].concat(mergedFeatures[i2].geometry[0]);
	                    return i2;
	                  }
	                  function getKey(text2, geom2, onRight) {
	                    var point = onRight ? geom2[0][geom2[0].length - 1] : geom2[0][0];
	                    return text2 + ":" + point.x + ":" + point.y;
	                  }
	                  for (var k = 0; k < features.length; k++) {
	                    var feature = features[k];
	                    var geom = feature.geometry;
	                    var text = feature.text ? feature.text.toString() : null;
	                    if (!text) {
	                      add2(k);
	                      continue;
	                    }
	                    var leftKey = getKey(text, geom), rightKey = getKey(text, geom, true);
	                    if (leftKey in rightIndex && rightKey in leftIndex && rightIndex[leftKey] !== leftIndex[rightKey]) {
	                      var j = mergeFromLeft(leftKey, rightKey, geom);
	                      var i = mergeFromRight(leftKey, rightKey, mergedFeatures[j].geometry);
	                      delete leftIndex[leftKey];
	                      delete rightIndex[rightKey];
	                      rightIndex[getKey(text, mergedFeatures[i].geometry, true)] = i;
	                      mergedFeatures[j].geometry = null;
	                    } else if (leftKey in rightIndex) {
	                      mergeFromRight(leftKey, rightKey, geom);
	                    } else if (rightKey in leftIndex) {
	                      mergeFromLeft(leftKey, rightKey, geom);
	                    } else {
	                      add2(k);
	                      leftIndex[leftKey] = mergedIndex - 1;
	                      rightIndex[rightKey] = mergedIndex - 1;
	                    }
	                  }
	                  return mergedFeatures.filter(function(f) {
	                    return f.geometry;
	                  });
	                }
	                var verticalizedCharacterMap = {
	                  "!": "︕",
	                  "#": "＃",
	                  "$": "＄",
	                  "%": "％",
	                  "&": "＆",
	                  "(": "︵",
	                  ")": "︶",
	                  "*": "＊",
	                  "+": "＋",
	                  ",": "︐",
	                  "-": "︲",
	                  ".": "・",
	                  "/": "／",
	                  ":": "︓",
	                  ";": "︔",
	                  "<": "︿",
	                  "=": "＝",
	                  ">": "﹀",
	                  "?": "︖",
	                  "@": "＠",
	                  "[": "﹇",
	                  "\\": "＼",
	                  "]": "﹈",
	                  "^": "＾",
	                  "_": "︳",
	                  "`": "｀",
	                  "{": "︷",
	                  "|": "―",
	                  "}": "︸",
	                  "~": "～",
	                  "¢": "￠",
	                  "£": "￡",
	                  "¥": "￥",
	                  "¦": "￤",
	                  "¬": "￢",
	                  "¯": "￣",
	                  "–": "︲",
	                  "—": "︱",
	                  "‘": "﹃",
	                  "’": "﹄",
	                  "“": "﹁",
	                  "”": "﹂",
	                  "…": "︙",
	                  "‧": "・",
	                  "₩": "￦",
	                  "、": "︑",
	                  "。": "︒",
	                  "〈": "︿",
	                  "〉": "﹀",
	                  "《": "︽",
	                  "》": "︾",
	                  "「": "﹁",
	                  "」": "﹂",
	                  "『": "﹃",
	                  "』": "﹄",
	                  "【": "︻",
	                  "】": "︼",
	                  "〔": "︹",
	                  "〕": "︺",
	                  "〖": "︗",
	                  "〗": "︘",
	                  "！": "︕",
	                  "（": "︵",
	                  "）": "︶",
	                  "，": "︐",
	                  "－": "︲",
	                  "．": "・",
	                  "：": "︓",
	                  "；": "︔",
	                  "＜": "︿",
	                  "＞": "﹀",
	                  "？": "︖",
	                  "［": "﹇",
	                  "］": "﹈",
	                  "＿": "︳",
	                  "｛": "︷",
	                  "｜": "―",
	                  "｝": "︸",
	                  "｟": "︵",
	                  "｠": "︶",
	                  "｡": "︒",
	                  "｢": "﹁",
	                  "｣": "﹂"
	                };
	                function verticalizePunctuation(input) {
	                  var output = "";
	                  for (var i = 0; i < input.length; i++) {
	                    var nextCharCode = input.charCodeAt(i + 1) || null;
	                    var prevCharCode = input.charCodeAt(i - 1) || null;
	                    var canReplacePunctuation = (!nextCharCode || !charHasRotatedVerticalOrientation(nextCharCode) || verticalizedCharacterMap[input[i + 1]]) && (!prevCharCode || !charHasRotatedVerticalOrientation(prevCharCode) || verticalizedCharacterMap[input[i - 1]]);
	                    if (canReplacePunctuation && verticalizedCharacterMap[input[i]]) {
	                      output += verticalizedCharacterMap[input[i]];
	                    } else {
	                      output += input[i];
	                    }
	                  }
	                  return output;
	                }
	                var ONE_EM = 24;
	                var read = function(buffer, offset, isLE, mLen, nBytes) {
	                  var e, m;
	                  var eLen = nBytes * 8 - mLen - 1;
	                  var eMax = (1 << eLen) - 1;
	                  var eBias = eMax >> 1;
	                  var nBits = -7;
	                  var i = isLE ? nBytes - 1 : 0;
	                  var d = isLE ? -1 : 1;
	                  var s = buffer[offset + i];
	                  i += d;
	                  e = s & (1 << -nBits) - 1;
	                  s >>= -nBits;
	                  nBits += eLen;
	                  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
	                  }
	                  m = e & (1 << -nBits) - 1;
	                  e >>= -nBits;
	                  nBits += mLen;
	                  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
	                  }
	                  if (e === 0) {
	                    e = 1 - eBias;
	                  } else if (e === eMax) {
	                    return m ? NaN : (s ? -1 : 1) * Infinity;
	                  } else {
	                    m = m + Math.pow(2, mLen);
	                    e = e - eBias;
	                  }
	                  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	                };
	                var write = function(buffer, value, offset, isLE, mLen, nBytes) {
	                  var e, m, c;
	                  var eLen = nBytes * 8 - mLen - 1;
	                  var eMax = (1 << eLen) - 1;
	                  var eBias = eMax >> 1;
	                  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	                  var i = isLE ? 0 : nBytes - 1;
	                  var d = isLE ? 1 : -1;
	                  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	                  value = Math.abs(value);
	                  if (isNaN(value) || value === Infinity) {
	                    m = isNaN(value) ? 1 : 0;
	                    e = eMax;
	                  } else {
	                    e = Math.floor(Math.log(value) / Math.LN2);
	                    if (value * (c = Math.pow(2, -e)) < 1) {
	                      e--;
	                      c *= 2;
	                    }
	                    if (e + eBias >= 1) {
	                      value += rt / c;
	                    } else {
	                      value += rt * Math.pow(2, 1 - eBias);
	                    }
	                    if (value * c >= 2) {
	                      e++;
	                      c /= 2;
	                    }
	                    if (e + eBias >= eMax) {
	                      m = 0;
	                      e = eMax;
	                    } else if (e + eBias >= 1) {
	                      m = (value * c - 1) * Math.pow(2, mLen);
	                      e = e + eBias;
	                    } else {
	                      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	                      e = 0;
	                    }
	                  }
	                  for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
	                  }
	                  e = e << mLen | m;
	                  eLen += mLen;
	                  for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
	                  }
	                  buffer[offset + i - d] |= s * 128;
	                };
	                var ieee754 = {
	                  read,
	                  write
	                };
	                var pbf = Pbf;
	                function Pbf(buf) {
	                  this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
	                  this.pos = 0;
	                  this.type = 0;
	                  this.length = this.buf.length;
	                }
	                Pbf.Varint = 0;
	                Pbf.Fixed64 = 1;
	                Pbf.Bytes = 2;
	                Pbf.Fixed32 = 5;
	                var SHIFT_LEFT_32 = (1 << 16) * (1 << 16), SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;
	                var TEXT_DECODER_MIN_LENGTH = 12;
	                var utf8TextDecoder = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf8");
	                Pbf.prototype = {
	                  destroy: function() {
	                    this.buf = null;
	                  },
	                  readFields: function(readField, result, end) {
	                    end = end || this.length;
	                    while (this.pos < end) {
	                      var val = this.readVarint(), tag = val >> 3, startPos = this.pos;
	                      this.type = val & 7;
	                      readField(tag, result, this);
	                      if (this.pos === startPos) {
	                        this.skip(val);
	                      }
	                    }
	                    return result;
	                  },
	                  readMessage: function(readField, result) {
	                    return this.readFields(readField, result, this.readVarint() + this.pos);
	                  },
	                  readFixed32: function() {
	                    var val = readUInt32(this.buf, this.pos);
	                    this.pos += 4;
	                    return val;
	                  },
	                  readSFixed32: function() {
	                    var val = readInt32(this.buf, this.pos);
	                    this.pos += 4;
	                    return val;
	                  },
	                  readFixed64: function() {
	                    var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
	                    this.pos += 8;
	                    return val;
	                  },
	                  readSFixed64: function() {
	                    var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
	                    this.pos += 8;
	                    return val;
	                  },
	                  readFloat: function() {
	                    var val = ieee754.read(this.buf, this.pos, true, 23, 4);
	                    this.pos += 4;
	                    return val;
	                  },
	                  readDouble: function() {
	                    var val = ieee754.read(this.buf, this.pos, true, 52, 8);
	                    this.pos += 8;
	                    return val;
	                  },
	                  readVarint: function(isSigned) {
	                    var buf = this.buf, val, b;
	                    b = buf[this.pos++];
	                    val = b & 127;
	                    if (b < 128) {
	                      return val;
	                    }
	                    b = buf[this.pos++];
	                    val |= (b & 127) << 7;
	                    if (b < 128) {
	                      return val;
	                    }
	                    b = buf[this.pos++];
	                    val |= (b & 127) << 14;
	                    if (b < 128) {
	                      return val;
	                    }
	                    b = buf[this.pos++];
	                    val |= (b & 127) << 21;
	                    if (b < 128) {
	                      return val;
	                    }
	                    b = buf[this.pos];
	                    val |= (b & 15) << 28;
	                    return readVarintRemainder(val, isSigned, this);
	                  },
	                  readVarint64: function() {
	                    return this.readVarint(true);
	                  },
	                  readSVarint: function() {
	                    var num = this.readVarint();
	                    return num % 2 === 1 ? (num + 1) / -2 : num / 2;
	                  },
	                  readBoolean: function() {
	                    return Boolean(this.readVarint());
	                  },
	                  readString: function() {
	                    var end = this.readVarint() + this.pos;
	                    var pos = this.pos;
	                    this.pos = end;
	                    if (end - pos >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder) {
	                      return readUtf8TextDecoder(this.buf, pos, end);
	                    }
	                    return readUtf8(this.buf, pos, end);
	                  },
	                  readBytes: function() {
	                    var end = this.readVarint() + this.pos, buffer = this.buf.subarray(this.pos, end);
	                    this.pos = end;
	                    return buffer;
	                  },
	                  readPackedVarint: function(arr, isSigned) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readVarint(isSigned));
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readVarint(isSigned));
	                    }
	                    return arr;
	                  },
	                  readPackedSVarint: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readSVarint());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readSVarint());
	                    }
	                    return arr;
	                  },
	                  readPackedBoolean: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readBoolean());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readBoolean());
	                    }
	                    return arr;
	                  },
	                  readPackedFloat: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readFloat());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readFloat());
	                    }
	                    return arr;
	                  },
	                  readPackedDouble: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readDouble());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readDouble());
	                    }
	                    return arr;
	                  },
	                  readPackedFixed32: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readFixed32());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readFixed32());
	                    }
	                    return arr;
	                  },
	                  readPackedSFixed32: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readSFixed32());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readSFixed32());
	                    }
	                    return arr;
	                  },
	                  readPackedFixed64: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readFixed64());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readFixed64());
	                    }
	                    return arr;
	                  },
	                  readPackedSFixed64: function(arr) {
	                    if (this.type !== Pbf.Bytes) {
	                      return arr.push(this.readSFixed64());
	                    }
	                    var end = readPackedEnd(this);
	                    arr = arr || [];
	                    while (this.pos < end) {
	                      arr.push(this.readSFixed64());
	                    }
	                    return arr;
	                  },
	                  skip: function(val) {
	                    var type = val & 7;
	                    if (type === Pbf.Varint) {
	                      while (this.buf[this.pos++] > 127) {
	                      }
	                    } else if (type === Pbf.Bytes) {
	                      this.pos = this.readVarint() + this.pos;
	                    } else if (type === Pbf.Fixed32) {
	                      this.pos += 4;
	                    } else if (type === Pbf.Fixed64) {
	                      this.pos += 8;
	                    } else {
	                      throw new Error("Unimplemented type: " + type);
	                    }
	                  },
	                  writeTag: function(tag, type) {
	                    this.writeVarint(tag << 3 | type);
	                  },
	                  realloc: function(min) {
	                    var length = this.length || 16;
	                    while (length < this.pos + min) {
	                      length *= 2;
	                    }
	                    if (length !== this.length) {
	                      var buf = new Uint8Array(length);
	                      buf.set(this.buf);
	                      this.buf = buf;
	                      this.length = length;
	                    }
	                  },
	                  finish: function() {
	                    this.length = this.pos;
	                    this.pos = 0;
	                    return this.buf.subarray(0, this.length);
	                  },
	                  writeFixed32: function(val) {
	                    this.realloc(4);
	                    writeInt32(this.buf, val, this.pos);
	                    this.pos += 4;
	                  },
	                  writeSFixed32: function(val) {
	                    this.realloc(4);
	                    writeInt32(this.buf, val, this.pos);
	                    this.pos += 4;
	                  },
	                  writeFixed64: function(val) {
	                    this.realloc(8);
	                    writeInt32(this.buf, val & -1, this.pos);
	                    writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
	                    this.pos += 8;
	                  },
	                  writeSFixed64: function(val) {
	                    this.realloc(8);
	                    writeInt32(this.buf, val & -1, this.pos);
	                    writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
	                    this.pos += 8;
	                  },
	                  writeVarint: function(val) {
	                    val = +val || 0;
	                    if (val > 268435455 || val < 0) {
	                      writeBigVarint(val, this);
	                      return;
	                    }
	                    this.realloc(4);
	                    this.buf[this.pos++] = val & 127 | (val > 127 ? 128 : 0);
	                    if (val <= 127) {
	                      return;
	                    }
	                    this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
	                    if (val <= 127) {
	                      return;
	                    }
	                    this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
	                    if (val <= 127) {
	                      return;
	                    }
	                    this.buf[this.pos++] = val >>> 7 & 127;
	                  },
	                  writeSVarint: function(val) {
	                    this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
	                  },
	                  writeBoolean: function(val) {
	                    this.writeVarint(Boolean(val));
	                  },
	                  writeString: function(str) {
	                    str = String(str);
	                    this.realloc(str.length * 4);
	                    this.pos++;
	                    var startPos = this.pos;
	                    this.pos = writeUtf8(this.buf, str, this.pos);
	                    var len = this.pos - startPos;
	                    if (len >= 128) {
	                      makeRoomForExtraLength(startPos, len, this);
	                    }
	                    this.pos = startPos - 1;
	                    this.writeVarint(len);
	                    this.pos += len;
	                  },
	                  writeFloat: function(val) {
	                    this.realloc(4);
	                    ieee754.write(this.buf, val, this.pos, true, 23, 4);
	                    this.pos += 4;
	                  },
	                  writeDouble: function(val) {
	                    this.realloc(8);
	                    ieee754.write(this.buf, val, this.pos, true, 52, 8);
	                    this.pos += 8;
	                  },
	                  writeBytes: function(buffer) {
	                    var len = buffer.length;
	                    this.writeVarint(len);
	                    this.realloc(len);
	                    for (var i = 0; i < len; i++) {
	                      this.buf[this.pos++] = buffer[i];
	                    }
	                  },
	                  writeRawMessage: function(fn, obj) {
	                    this.pos++;
	                    var startPos = this.pos;
	                    fn(obj, this);
	                    var len = this.pos - startPos;
	                    if (len >= 128) {
	                      makeRoomForExtraLength(startPos, len, this);
	                    }
	                    this.pos = startPos - 1;
	                    this.writeVarint(len);
	                    this.pos += len;
	                  },
	                  writeMessage: function(tag, fn, obj) {
	                    this.writeTag(tag, Pbf.Bytes);
	                    this.writeRawMessage(fn, obj);
	                  },
	                  writePackedVarint: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedVarint, arr);
	                    }
	                  },
	                  writePackedSVarint: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedSVarint, arr);
	                    }
	                  },
	                  writePackedBoolean: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedBoolean, arr);
	                    }
	                  },
	                  writePackedFloat: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedFloat, arr);
	                    }
	                  },
	                  writePackedDouble: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedDouble, arr);
	                    }
	                  },
	                  writePackedFixed32: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedFixed32, arr);
	                    }
	                  },
	                  writePackedSFixed32: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedSFixed32, arr);
	                    }
	                  },
	                  writePackedFixed64: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedFixed64, arr);
	                    }
	                  },
	                  writePackedSFixed64: function(tag, arr) {
	                    if (arr.length) {
	                      this.writeMessage(tag, writePackedSFixed64, arr);
	                    }
	                  },
	                  writeBytesField: function(tag, buffer) {
	                    this.writeTag(tag, Pbf.Bytes);
	                    this.writeBytes(buffer);
	                  },
	                  writeFixed32Field: function(tag, val) {
	                    this.writeTag(tag, Pbf.Fixed32);
	                    this.writeFixed32(val);
	                  },
	                  writeSFixed32Field: function(tag, val) {
	                    this.writeTag(tag, Pbf.Fixed32);
	                    this.writeSFixed32(val);
	                  },
	                  writeFixed64Field: function(tag, val) {
	                    this.writeTag(tag, Pbf.Fixed64);
	                    this.writeFixed64(val);
	                  },
	                  writeSFixed64Field: function(tag, val) {
	                    this.writeTag(tag, Pbf.Fixed64);
	                    this.writeSFixed64(val);
	                  },
	                  writeVarintField: function(tag, val) {
	                    this.writeTag(tag, Pbf.Varint);
	                    this.writeVarint(val);
	                  },
	                  writeSVarintField: function(tag, val) {
	                    this.writeTag(tag, Pbf.Varint);
	                    this.writeSVarint(val);
	                  },
	                  writeStringField: function(tag, str) {
	                    this.writeTag(tag, Pbf.Bytes);
	                    this.writeString(str);
	                  },
	                  writeFloatField: function(tag, val) {
	                    this.writeTag(tag, Pbf.Fixed32);
	                    this.writeFloat(val);
	                  },
	                  writeDoubleField: function(tag, val) {
	                    this.writeTag(tag, Pbf.Fixed64);
	                    this.writeDouble(val);
	                  },
	                  writeBooleanField: function(tag, val) {
	                    this.writeVarintField(tag, Boolean(val));
	                  }
	                };
	                function readVarintRemainder(l, s, p) {
	                  var buf = p.buf, h, b;
	                  b = buf[p.pos++];
	                  h = (b & 112) >> 4;
	                  if (b < 128) {
	                    return toNum(l, h, s);
	                  }
	                  b = buf[p.pos++];
	                  h |= (b & 127) << 3;
	                  if (b < 128) {
	                    return toNum(l, h, s);
	                  }
	                  b = buf[p.pos++];
	                  h |= (b & 127) << 10;
	                  if (b < 128) {
	                    return toNum(l, h, s);
	                  }
	                  b = buf[p.pos++];
	                  h |= (b & 127) << 17;
	                  if (b < 128) {
	                    return toNum(l, h, s);
	                  }
	                  b = buf[p.pos++];
	                  h |= (b & 127) << 24;
	                  if (b < 128) {
	                    return toNum(l, h, s);
	                  }
	                  b = buf[p.pos++];
	                  h |= (b & 1) << 31;
	                  if (b < 128) {
	                    return toNum(l, h, s);
	                  }
	                  throw new Error("Expected varint not more than 10 bytes");
	                }
	                function readPackedEnd(pbf2) {
	                  return pbf2.type === Pbf.Bytes ? pbf2.readVarint() + pbf2.pos : pbf2.pos + 1;
	                }
	                function toNum(low, high, isSigned) {
	                  if (isSigned) {
	                    return high * 4294967296 + (low >>> 0);
	                  }
	                  return (high >>> 0) * 4294967296 + (low >>> 0);
	                }
	                function writeBigVarint(val, pbf2) {
	                  var low, high;
	                  if (val >= 0) {
	                    low = val % 4294967296 | 0;
	                    high = val / 4294967296 | 0;
	                  } else {
	                    low = ~(-val % 4294967296);
	                    high = ~(-val / 4294967296);
	                    if (low ^ 4294967295) {
	                      low = low + 1 | 0;
	                    } else {
	                      low = 0;
	                      high = high + 1 | 0;
	                    }
	                  }
	                  if (val >= 18446744073709552e3 || val < -18446744073709552e3) {
	                    throw new Error("Given varint doesn't fit into 10 bytes");
	                  }
	                  pbf2.realloc(10);
	                  writeBigVarintLow(low, high, pbf2);
	                  writeBigVarintHigh(high, pbf2);
	                }
	                function writeBigVarintLow(low, high, pbf2) {
	                  pbf2.buf[pbf2.pos++] = low & 127 | 128;
	                  low >>>= 7;
	                  pbf2.buf[pbf2.pos++] = low & 127 | 128;
	                  low >>>= 7;
	                  pbf2.buf[pbf2.pos++] = low & 127 | 128;
	                  low >>>= 7;
	                  pbf2.buf[pbf2.pos++] = low & 127 | 128;
	                  low >>>= 7;
	                  pbf2.buf[pbf2.pos] = low & 127;
	                }
	                function writeBigVarintHigh(high, pbf2) {
	                  var lsb = (high & 7) << 4;
	                  pbf2.buf[pbf2.pos++] |= lsb | ((high >>>= 3) ? 128 : 0);
	                  if (!high) {
	                    return;
	                  }
	                  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
	                  if (!high) {
	                    return;
	                  }
	                  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
	                  if (!high) {
	                    return;
	                  }
	                  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
	                  if (!high) {
	                    return;
	                  }
	                  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
	                  if (!high) {
	                    return;
	                  }
	                  pbf2.buf[pbf2.pos++] = high & 127;
	                }
	                function makeRoomForExtraLength(startPos, len, pbf2) {
	                  var extraLen = len <= 16383 ? 1 : len <= 2097151 ? 2 : len <= 268435455 ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));
	                  pbf2.realloc(extraLen);
	                  for (var i = pbf2.pos - 1; i >= startPos; i--) {
	                    pbf2.buf[i + extraLen] = pbf2.buf[i];
	                  }
	                }
	                function writePackedVarint(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeVarint(arr[i]);
	                  }
	                }
	                function writePackedSVarint(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeSVarint(arr[i]);
	                  }
	                }
	                function writePackedFloat(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeFloat(arr[i]);
	                  }
	                }
	                function writePackedDouble(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeDouble(arr[i]);
	                  }
	                }
	                function writePackedBoolean(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeBoolean(arr[i]);
	                  }
	                }
	                function writePackedFixed32(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeFixed32(arr[i]);
	                  }
	                }
	                function writePackedSFixed32(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeSFixed32(arr[i]);
	                  }
	                }
	                function writePackedFixed64(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeFixed64(arr[i]);
	                  }
	                }
	                function writePackedSFixed64(arr, pbf2) {
	                  for (var i = 0; i < arr.length; i++) {
	                    pbf2.writeSFixed64(arr[i]);
	                  }
	                }
	                function readUInt32(buf, pos) {
	                  return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + buf[pos + 3] * 16777216;
	                }
	                function writeInt32(buf, val, pos) {
	                  buf[pos] = val;
	                  buf[pos + 1] = val >>> 8;
	                  buf[pos + 2] = val >>> 16;
	                  buf[pos + 3] = val >>> 24;
	                }
	                function readInt32(buf, pos) {
	                  return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + (buf[pos + 3] << 24);
	                }
	                function readUtf8(buf, pos, end) {
	                  var str = "";
	                  var i = pos;
	                  while (i < end) {
	                    var b0 = buf[i];
	                    var c = null;
	                    var bytesPerSequence = b0 > 239 ? 4 : b0 > 223 ? 3 : b0 > 191 ? 2 : 1;
	                    if (i + bytesPerSequence > end) {
	                      break;
	                    }
	                    var b1, b2, b3;
	                    if (bytesPerSequence === 1) {
	                      if (b0 < 128) {
	                        c = b0;
	                      }
	                    } else if (bytesPerSequence === 2) {
	                      b1 = buf[i + 1];
	                      if ((b1 & 192) === 128) {
	                        c = (b0 & 31) << 6 | b1 & 63;
	                        if (c <= 127) {
	                          c = null;
	                        }
	                      }
	                    } else if (bytesPerSequence === 3) {
	                      b1 = buf[i + 1];
	                      b2 = buf[i + 2];
	                      if ((b1 & 192) === 128 && (b2 & 192) === 128) {
	                        c = (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
	                        if (c <= 2047 || c >= 55296 && c <= 57343) {
	                          c = null;
	                        }
	                      }
	                    } else if (bytesPerSequence === 4) {
	                      b1 = buf[i + 1];
	                      b2 = buf[i + 2];
	                      b3 = buf[i + 3];
	                      if ((b1 & 192) === 128 && (b2 & 192) === 128 && (b3 & 192) === 128) {
	                        c = (b0 & 15) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
	                        if (c <= 65535 || c >= 1114112) {
	                          c = null;
	                        }
	                      }
	                    }
	                    if (c === null) {
	                      c = 65533;
	                      bytesPerSequence = 1;
	                    } else if (c > 65535) {
	                      c -= 65536;
	                      str += String.fromCharCode(c >>> 10 & 1023 | 55296);
	                      c = 56320 | c & 1023;
	                    }
	                    str += String.fromCharCode(c);
	                    i += bytesPerSequence;
	                  }
	                  return str;
	                }
	                function readUtf8TextDecoder(buf, pos, end) {
	                  return utf8TextDecoder.decode(buf.subarray(pos, end));
	                }
	                function writeUtf8(buf, str, pos) {
	                  for (var i = 0, c, lead; i < str.length; i++) {
	                    c = str.charCodeAt(i);
	                    if (c > 55295 && c < 57344) {
	                      if (lead) {
	                        if (c < 56320) {
	                          buf[pos++] = 239;
	                          buf[pos++] = 191;
	                          buf[pos++] = 189;
	                          lead = c;
	                          continue;
	                        } else {
	                          c = lead - 55296 << 10 | c - 56320 | 65536;
	                          lead = null;
	                        }
	                      } else {
	                        if (c > 56319 || i + 1 === str.length) {
	                          buf[pos++] = 239;
	                          buf[pos++] = 191;
	                          buf[pos++] = 189;
	                        } else {
	                          lead = c;
	                        }
	                        continue;
	                      }
	                    } else if (lead) {
	                      buf[pos++] = 239;
	                      buf[pos++] = 191;
	                      buf[pos++] = 189;
	                      lead = null;
	                    }
	                    if (c < 128) {
	                      buf[pos++] = c;
	                    } else {
	                      if (c < 2048) {
	                        buf[pos++] = c >> 6 | 192;
	                      } else {
	                        if (c < 65536) {
	                          buf[pos++] = c >> 12 | 224;
	                        } else {
	                          buf[pos++] = c >> 18 | 240;
	                          buf[pos++] = c >> 12 & 63 | 128;
	                        }
	                        buf[pos++] = c >> 6 & 63 | 128;
	                      }
	                      buf[pos++] = c & 63 | 128;
	                    }
	                  }
	                  return pos;
	                }
	                var border = 3;
	                function readFontstacks(tag, glyphs, pbf2) {
	                  if (tag === 1) {
	                    pbf2.readMessage(readFontstack, glyphs);
	                  }
	                }
	                function readFontstack(tag, glyphs, pbf2) {
	                  if (tag === 3) {
	                    var ref = pbf2.readMessage(readGlyph, {});
	                    var id2 = ref.id;
	                    var bitmap = ref.bitmap;
	                    var width = ref.width;
	                    var height = ref.height;
	                    var left = ref.left;
	                    var top = ref.top;
	                    var advance = ref.advance;
	                    glyphs.push({
	                      id: id2,
	                      bitmap: new AlphaImage({
	                        width: width + 2 * border,
	                        height: height + 2 * border
	                      }, bitmap),
	                      metrics: {
	                        width,
	                        height,
	                        left,
	                        top,
	                        advance
	                      }
	                    });
	                  }
	                }
	                function readGlyph(tag, glyph, pbf2) {
	                  if (tag === 1) {
	                    glyph.id = pbf2.readVarint();
	                  } else if (tag === 2) {
	                    glyph.bitmap = pbf2.readBytes();
	                  } else if (tag === 3) {
	                    glyph.width = pbf2.readVarint();
	                  } else if (tag === 4) {
	                    glyph.height = pbf2.readVarint();
	                  } else if (tag === 5) {
	                    glyph.left = pbf2.readSVarint();
	                  } else if (tag === 6) {
	                    glyph.top = pbf2.readSVarint();
	                  } else if (tag === 7) {
	                    glyph.advance = pbf2.readVarint();
	                  }
	                }
	                function parseGlyphPBF(data) {
	                  return new pbf(data).readFields(readFontstacks, []);
	                }
	                var GLYPH_PBF_BORDER = border;
	                function potpack(boxes) {
	                  var area2 = 0;
	                  var maxWidth = 0;
	                  for (var i$1 = 0, list = boxes; i$1 < list.length; i$1 += 1) {
	                    var box = list[i$1];
	                    area2 += box.w * box.h;
	                    maxWidth = Math.max(maxWidth, box.w);
	                  }
	                  boxes.sort(function(a, b) {
	                    return b.h - a.h;
	                  });
	                  var startWidth = Math.max(Math.ceil(Math.sqrt(area2 / 0.95)), maxWidth);
	                  var spaces = [{ x: 0, y: 0, w: startWidth, h: Infinity }];
	                  var width = 0;
	                  var height = 0;
	                  for (var i$2 = 0, list$1 = boxes; i$2 < list$1.length; i$2 += 1) {
	                    var box$1 = list$1[i$2];
	                    for (var i = spaces.length - 1; i >= 0; i--) {
	                      var space = spaces[i];
	                      if (box$1.w > space.w || box$1.h > space.h) {
	                        continue;
	                      }
	                      box$1.x = space.x;
	                      box$1.y = space.y;
	                      height = Math.max(height, box$1.y + box$1.h);
	                      width = Math.max(width, box$1.x + box$1.w);
	                      if (box$1.w === space.w && box$1.h === space.h) {
	                        var last = spaces.pop();
	                        if (i < spaces.length) {
	                          spaces[i] = last;
	                        }
	                      } else if (box$1.h === space.h) {
	                        space.x += box$1.w;
	                        space.w -= box$1.w;
	                      } else if (box$1.w === space.w) {
	                        space.y += box$1.h;
	                        space.h -= box$1.h;
	                      } else {
	                        spaces.push({
	                          x: space.x + box$1.w,
	                          y: space.y,
	                          w: space.w - box$1.w,
	                          h: box$1.h
	                        });
	                        space.y += box$1.h;
	                        space.h -= box$1.h;
	                      }
	                      break;
	                    }
	                  }
	                  return {
	                    w: width,
	                    // container width
	                    h: height,
	                    // container height
	                    fill: area2 / (width * height) || 0
	                    // space utilization
	                  };
	                }
	                var IMAGE_PADDING = 1;
	                var ImagePosition = function ImagePosition2(paddedRect, ref) {
	                  var pixelRatio = ref.pixelRatio;
	                  var version2 = ref.version;
	                  var stretchX = ref.stretchX;
	                  var stretchY = ref.stretchY;
	                  var content = ref.content;
	                  this.paddedRect = paddedRect;
	                  this.pixelRatio = pixelRatio;
	                  this.stretchX = stretchX;
	                  this.stretchY = stretchY;
	                  this.content = content;
	                  this.version = version2;
	                };
	                var prototypeAccessors = {
	                  tl: { configurable: true },
	                  br: { configurable: true },
	                  tlbr: { configurable: true },
	                  displaySize: { configurable: true }
	                };
	                prototypeAccessors.tl.get = function() {
	                  return [
	                    this.paddedRect.x + IMAGE_PADDING,
	                    this.paddedRect.y + IMAGE_PADDING
	                  ];
	                };
	                prototypeAccessors.br.get = function() {
	                  return [
	                    this.paddedRect.x + this.paddedRect.w - IMAGE_PADDING,
	                    this.paddedRect.y + this.paddedRect.h - IMAGE_PADDING
	                  ];
	                };
	                prototypeAccessors.tlbr.get = function() {
	                  return this.tl.concat(this.br);
	                };
	                prototypeAccessors.displaySize.get = function() {
	                  return [
	                    (this.paddedRect.w - IMAGE_PADDING * 2) / this.pixelRatio,
	                    (this.paddedRect.h - IMAGE_PADDING * 2) / this.pixelRatio
	                  ];
	                };
	                Object.defineProperties(ImagePosition.prototype, prototypeAccessors);
	                var ImageAtlas = function ImageAtlas2(icons, patterns) {
	                  var iconPositions = {}, patternPositions = {};
	                  this.haveRenderCallbacks = [];
	                  var bins = [];
	                  this.addImages(icons, iconPositions, bins);
	                  this.addImages(patterns, patternPositions, bins);
	                  var ref = potpack(bins);
	                  var w = ref.w;
	                  var h = ref.h;
	                  var image = new RGBAImage({
	                    width: w || 1,
	                    height: h || 1
	                  });
	                  for (var id2 in icons) {
	                    var src = icons[id2];
	                    var bin = iconPositions[id2].paddedRect;
	                    RGBAImage.copy(src.data, image, {
	                      x: 0,
	                      y: 0
	                    }, {
	                      x: bin.x + IMAGE_PADDING,
	                      y: bin.y + IMAGE_PADDING
	                    }, src.data);
	                  }
	                  for (var id$1 in patterns) {
	                    var src$1 = patterns[id$1];
	                    var bin$1 = patternPositions[id$1].paddedRect;
	                    var x = bin$1.x + IMAGE_PADDING, y = bin$1.y + IMAGE_PADDING, w$1 = src$1.data.width, h$1 = src$1.data.height;
	                    RGBAImage.copy(src$1.data, image, {
	                      x: 0,
	                      y: 0
	                    }, {
	                      x,
	                      y
	                    }, src$1.data);
	                    RGBAImage.copy(src$1.data, image, {
	                      x: 0,
	                      y: h$1 - 1
	                    }, {
	                      x,
	                      y: y - 1
	                    }, {
	                      width: w$1,
	                      height: 1
	                    });
	                    RGBAImage.copy(src$1.data, image, {
	                      x: 0,
	                      y: 0
	                    }, {
	                      x,
	                      y: y + h$1
	                    }, {
	                      width: w$1,
	                      height: 1
	                    });
	                    RGBAImage.copy(src$1.data, image, {
	                      x: w$1 - 1,
	                      y: 0
	                    }, {
	                      x: x - 1,
	                      y
	                    }, {
	                      width: 1,
	                      height: h$1
	                    });
	                    RGBAImage.copy(src$1.data, image, {
	                      x: 0,
	                      y: 0
	                    }, {
	                      x: x + w$1,
	                      y
	                    }, {
	                      width: 1,
	                      height: h$1
	                    });
	                  }
	                  this.image = image;
	                  this.iconPositions = iconPositions;
	                  this.patternPositions = patternPositions;
	                };
	                ImageAtlas.prototype.addImages = function addImages(images, positions, bins) {
	                  for (var id2 in images) {
	                    var src = images[id2];
	                    var bin = {
	                      x: 0,
	                      y: 0,
	                      w: src.data.width + 2 * IMAGE_PADDING,
	                      h: src.data.height + 2 * IMAGE_PADDING
	                    };
	                    bins.push(bin);
	                    positions[id2] = new ImagePosition(bin, src);
	                    if (src.hasRenderCallback) {
	                      this.haveRenderCallbacks.push(id2);
	                    }
	                  }
	                };
	                ImageAtlas.prototype.patchUpdatedImages = function patchUpdatedImages(imageManager, texture) {
	                  imageManager.dispatchRenderCallbacks(this.haveRenderCallbacks);
	                  for (var name3 in imageManager.updatedImages) {
	                    this.patchUpdatedImage(this.iconPositions[name3], imageManager.getImage(name3), texture);
	                    this.patchUpdatedImage(this.patternPositions[name3], imageManager.getImage(name3), texture);
	                  }
	                };
	                ImageAtlas.prototype.patchUpdatedImage = function patchUpdatedImage(position, image, texture) {
	                  if (!position || !image) {
	                    return;
	                  }
	                  if (position.version === image.version) {
	                    return;
	                  }
	                  position.version = image.version;
	                  var ref = position.tl;
	                  var x = ref[0];
	                  var y = ref[1];
	                  texture.update(image.data, undefined, {
	                    x,
	                    y
	                  });
	                };
	                register("ImagePosition", ImagePosition);
	                register("ImageAtlas", ImageAtlas);
	                var WritingMode = {
	                  horizontal: 1,
	                  vertical: 2,
	                  horizontalOnly: 3
	                };
	                var SHAPING_DEFAULT_OFFSET = -17;
	                function isEmpty(positionedLines) {
	                  for (var i = 0, list = positionedLines; i < list.length; i += 1) {
	                    var line = list[i];
	                    if (line.positionedGlyphs.length !== 0) {
	                      return false;
	                    }
	                  }
	                  return true;
	                }
	                var PUAbegin = 57344;
	                var PUAend = 63743;
	                var SectionOptions = function SectionOptions2() {
	                  this.scale = 1;
	                  this.fontStack = "";
	                  this.imageName = null;
	                };
	                SectionOptions.forText = function forText(scale2, fontStack) {
	                  var textOptions = new SectionOptions();
	                  textOptions.scale = scale2 || 1;
	                  textOptions.fontStack = fontStack;
	                  return textOptions;
	                };
	                SectionOptions.forImage = function forImage(imageName) {
	                  var imageOptions = new SectionOptions();
	                  imageOptions.imageName = imageName;
	                  return imageOptions;
	                };
	                var TaggedString = function TaggedString2() {
	                  this.text = "";
	                  this.sectionIndex = [];
	                  this.sections = [];
	                  this.imageSectionID = null;
	                };
	                TaggedString.fromFeature = function fromFeature(text, defaultFontStack) {
	                  var result = new TaggedString();
	                  for (var i = 0; i < text.sections.length; i++) {
	                    var section = text.sections[i];
	                    if (!section.image) {
	                      result.addTextSection(section, defaultFontStack);
	                    } else {
	                      result.addImageSection(section);
	                    }
	                  }
	                  return result;
	                };
	                TaggedString.prototype.length = function length() {
	                  return this.text.length;
	                };
	                TaggedString.prototype.getSection = function getSection(index) {
	                  return this.sections[this.sectionIndex[index]];
	                };
	                TaggedString.prototype.getSectionIndex = function getSectionIndex(index) {
	                  return this.sectionIndex[index];
	                };
	                TaggedString.prototype.getCharCode = function getCharCode(index) {
	                  return this.text.charCodeAt(index);
	                };
	                TaggedString.prototype.verticalizePunctuation = function verticalizePunctuation$1() {
	                  this.text = verticalizePunctuation(this.text);
	                };
	                TaggedString.prototype.trim = function trim() {
	                  var beginningWhitespace = 0;
	                  for (var i = 0; i < this.text.length && whitespace[this.text.charCodeAt(i)]; i++) {
	                    beginningWhitespace++;
	                  }
	                  var trailingWhitespace = this.text.length;
	                  for (var i$1 = this.text.length - 1; i$1 >= 0 && i$1 >= beginningWhitespace && whitespace[this.text.charCodeAt(i$1)]; i$1--) {
	                    trailingWhitespace--;
	                  }
	                  this.text = this.text.substring(beginningWhitespace, trailingWhitespace);
	                  this.sectionIndex = this.sectionIndex.slice(beginningWhitespace, trailingWhitespace);
	                };
	                TaggedString.prototype.substring = function substring(start, end) {
	                  var substring2 = new TaggedString();
	                  substring2.text = this.text.substring(start, end);
	                  substring2.sectionIndex = this.sectionIndex.slice(start, end);
	                  substring2.sections = this.sections;
	                  return substring2;
	                };
	                TaggedString.prototype.toString = function toString2() {
	                  return this.text;
	                };
	                TaggedString.prototype.getMaxScale = function getMaxScale() {
	                  var this$1$1 = this;
	                  return this.sectionIndex.reduce(function(max, index) {
	                    return Math.max(max, this$1$1.sections[index].scale);
	                  }, 0);
	                };
	                TaggedString.prototype.addTextSection = function addTextSection(section, defaultFontStack) {
	                  this.text += section.text;
	                  this.sections.push(SectionOptions.forText(section.scale, section.fontStack || defaultFontStack));
	                  var index = this.sections.length - 1;
	                  for (var i = 0; i < section.text.length; ++i) {
	                    this.sectionIndex.push(index);
	                  }
	                };
	                TaggedString.prototype.addImageSection = function addImageSection(section) {
	                  var imageName = section.image ? section.image.name : "";
	                  if (imageName.length === 0) {
	                    warnOnce("Can't add FormattedSection with an empty image.");
	                    return;
	                  }
	                  var nextImageSectionCharCode = this.getNextImageSectionCharCode();
	                  if (!nextImageSectionCharCode) {
	                    warnOnce("Reached maximum number of images " + (PUAend - PUAbegin + 2));
	                    return;
	                  }
	                  this.text += String.fromCharCode(nextImageSectionCharCode);
	                  this.sections.push(SectionOptions.forImage(imageName));
	                  this.sectionIndex.push(this.sections.length - 1);
	                };
	                TaggedString.prototype.getNextImageSectionCharCode = function getNextImageSectionCharCode() {
	                  if (!this.imageSectionID) {
	                    this.imageSectionID = PUAbegin;
	                    return this.imageSectionID;
	                  }
	                  if (this.imageSectionID >= PUAend) {
	                    return null;
	                  }
	                  return ++this.imageSectionID;
	                };
	                function breakLines(input, lineBreakPoints) {
	                  var lines = [];
	                  var text = input.text;
	                  var start = 0;
	                  for (var i = 0, list = lineBreakPoints; i < list.length; i += 1) {
	                    var lineBreak = list[i];
	                    lines.push(input.substring(start, lineBreak));
	                    start = lineBreak;
	                  }
	                  if (start < text.length) {
	                    lines.push(input.substring(start, text.length));
	                  }
	                  return lines;
	                }
	                function shapeText(text, glyphMap, glyphPositions, imagePositions, defaultFontStack, maxWidth, lineHeight, textAnchor, textJustify, spacing, translate2, writingMode, allowVerticalPlacement, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom) {
	                  var logicalInput = TaggedString.fromFeature(text, defaultFontStack);
	                  if (writingMode === WritingMode.vertical) {
	                    logicalInput.verticalizePunctuation();
	                  }
	                  var lines;
	                  var processBidirectionalText = plugin.processBidirectionalText;
	                  var processStyledBidirectionalText = plugin.processStyledBidirectionalText;
	                  if (processBidirectionalText && logicalInput.sections.length === 1) {
	                    lines = [];
	                    var untaggedLines = processBidirectionalText(logicalInput.toString(), determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize));
	                    for (var i$1 = 0, list = untaggedLines; i$1 < list.length; i$1 += 1) {
	                      var line = list[i$1];
	                      var taggedLine = new TaggedString();
	                      taggedLine.text = line;
	                      taggedLine.sections = logicalInput.sections;
	                      for (var i = 0; i < line.length; i++) {
	                        taggedLine.sectionIndex.push(0);
	                      }
	                      lines.push(taggedLine);
	                    }
	                  } else if (processStyledBidirectionalText) {
	                    lines = [];
	                    var processedLines = processStyledBidirectionalText(logicalInput.text, logicalInput.sectionIndex, determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize));
	                    for (var i$2 = 0, list$1 = processedLines; i$2 < list$1.length; i$2 += 1) {
	                      var line$1 = list$1[i$2];
	                      var taggedLine$1 = new TaggedString();
	                      taggedLine$1.text = line$1[0];
	                      taggedLine$1.sectionIndex = line$1[1];
	                      taggedLine$1.sections = logicalInput.sections;
	                      lines.push(taggedLine$1);
	                    }
	                  } else {
	                    lines = breakLines(logicalInput, determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize));
	                  }
	                  var positionedLines = [];
	                  var shaping = {
	                    positionedLines,
	                    text: logicalInput.toString(),
	                    top: translate2[1],
	                    bottom: translate2[1],
	                    left: translate2[0],
	                    right: translate2[0],
	                    writingMode,
	                    iconsInText: false,
	                    verticalizable: false
	                  };
	                  shapeLines(shaping, glyphMap, glyphPositions, imagePositions, lines, lineHeight, textAnchor, textJustify, writingMode, spacing, allowVerticalPlacement, layoutTextSizeThisZoom);
	                  if (isEmpty(positionedLines)) {
	                    return false;
	                  }
	                  return shaping;
	                }
	                var whitespace = {};
	                whitespace[9] = true;
	                whitespace[10] = true;
	                whitespace[11] = true;
	                whitespace[12] = true;
	                whitespace[13] = true;
	                whitespace[32] = true;
	                var breakable = {};
	                breakable[10] = true;
	                breakable[32] = true;
	                breakable[38] = true;
	                breakable[40] = true;
	                breakable[41] = true;
	                breakable[43] = true;
	                breakable[45] = true;
	                breakable[47] = true;
	                breakable[173] = true;
	                breakable[183] = true;
	                breakable[8203] = true;
	                breakable[8208] = true;
	                breakable[8211] = true;
	                breakable[8231] = true;
	                function getGlyphAdvance(codePoint, section, glyphMap, imagePositions, spacing, layoutTextSize) {
	                  if (!section.imageName) {
	                    var positions = glyphMap[section.fontStack];
	                    var glyph = positions && positions[codePoint];
	                    if (!glyph) {
	                      return 0;
	                    }
	                    return glyph.metrics.advance * section.scale + spacing;
	                  } else {
	                    var imagePosition = imagePositions[section.imageName];
	                    if (!imagePosition) {
	                      return 0;
	                    }
	                    return imagePosition.displaySize[0] * section.scale * ONE_EM / layoutTextSize + spacing;
	                  }
	                }
	                function determineAverageLineWidth(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize) {
	                  var totalWidth = 0;
	                  for (var index = 0; index < logicalInput.length(); index++) {
	                    var section = logicalInput.getSection(index);
	                    totalWidth += getGlyphAdvance(logicalInput.getCharCode(index), section, glyphMap, imagePositions, spacing, layoutTextSize);
	                  }
	                  var lineCount = Math.max(1, Math.ceil(totalWidth / maxWidth));
	                  return totalWidth / lineCount;
	                }
	                function calculateBadness(lineWidth, targetWidth, penalty, isLastBreak) {
	                  var raggedness = Math.pow(lineWidth - targetWidth, 2);
	                  if (isLastBreak) {
	                    if (lineWidth < targetWidth) {
	                      return raggedness / 2;
	                    } else {
	                      return raggedness * 2;
	                    }
	                  }
	                  return raggedness + Math.abs(penalty) * penalty;
	                }
	                function calculatePenalty(codePoint, nextCodePoint, penalizableIdeographicBreak) {
	                  var penalty = 0;
	                  if (codePoint === 10) {
	                    penalty -= 1e4;
	                  }
	                  if (penalizableIdeographicBreak) {
	                    penalty += 150;
	                  }
	                  if (codePoint === 40 || codePoint === 65288) {
	                    penalty += 50;
	                  }
	                  if (nextCodePoint === 41 || nextCodePoint === 65289) {
	                    penalty += 50;
	                  }
	                  return penalty;
	                }
	                function evaluateBreak(breakIndex, breakX, targetWidth, potentialBreaks, penalty, isLastBreak) {
	                  var bestPriorBreak = null;
	                  var bestBreakBadness = calculateBadness(breakX, targetWidth, penalty, isLastBreak);
	                  for (var i = 0, list = potentialBreaks; i < list.length; i += 1) {
	                    var potentialBreak = list[i];
	                    var lineWidth = breakX - potentialBreak.x;
	                    var breakBadness = calculateBadness(lineWidth, targetWidth, penalty, isLastBreak) + potentialBreak.badness;
	                    if (breakBadness <= bestBreakBadness) {
	                      bestPriorBreak = potentialBreak;
	                      bestBreakBadness = breakBadness;
	                    }
	                  }
	                  return {
	                    index: breakIndex,
	                    x: breakX,
	                    priorBreak: bestPriorBreak,
	                    badness: bestBreakBadness
	                  };
	                }
	                function leastBadBreaks(lastLineBreak) {
	                  if (!lastLineBreak) {
	                    return [];
	                  }
	                  return leastBadBreaks(lastLineBreak.priorBreak).concat(lastLineBreak.index);
	                }
	                function determineLineBreaks(logicalInput, spacing, maxWidth, glyphMap, imagePositions, symbolPlacement, layoutTextSize) {
	                  if (symbolPlacement !== "point") {
	                    return [];
	                  }
	                  if (!logicalInput) {
	                    return [];
	                  }
	                  var potentialLineBreaks = [];
	                  var targetWidth = determineAverageLineWidth(logicalInput, spacing, maxWidth, glyphMap, imagePositions, layoutTextSize);
	                  var hasServerSuggestedBreakpoints = logicalInput.text.indexOf("​") >= 0;
	                  var currentX = 0;
	                  for (var i = 0; i < logicalInput.length(); i++) {
	                    var section = logicalInput.getSection(i);
	                    var codePoint = logicalInput.getCharCode(i);
	                    if (!whitespace[codePoint]) {
	                      currentX += getGlyphAdvance(codePoint, section, glyphMap, imagePositions, spacing, layoutTextSize);
	                    }
	                    if (i < logicalInput.length() - 1) {
	                      var ideographicBreak = charAllowsIdeographicBreaking(codePoint);
	                      if (breakable[codePoint] || ideographicBreak || section.imageName) {
	                        potentialLineBreaks.push(evaluateBreak(i + 1, currentX, targetWidth, potentialLineBreaks, calculatePenalty(codePoint, logicalInput.getCharCode(i + 1), ideographicBreak && hasServerSuggestedBreakpoints), false));
	                      }
	                    }
	                  }
	                  return leastBadBreaks(evaluateBreak(logicalInput.length(), currentX, targetWidth, potentialLineBreaks, 0, true));
	                }
	                function getAnchorAlignment(anchor) {
	                  var horizontalAlign = 0.5, verticalAlign = 0.5;
	                  switch (anchor) {
	                    case "right":
	                    case "top-right":
	                    case "bottom-right":
	                      horizontalAlign = 1;
	                      break;
	                    case "left":
	                    case "top-left":
	                    case "bottom-left":
	                      horizontalAlign = 0;
	                      break;
	                  }
	                  switch (anchor) {
	                    case "bottom":
	                    case "bottom-right":
	                    case "bottom-left":
	                      verticalAlign = 1;
	                      break;
	                    case "top":
	                    case "top-right":
	                    case "top-left":
	                      verticalAlign = 0;
	                      break;
	                  }
	                  return {
	                    horizontalAlign,
	                    verticalAlign
	                  };
	                }
	                function shapeLines(shaping, glyphMap, glyphPositions, imagePositions, lines, lineHeight, textAnchor, textJustify, writingMode, spacing, allowVerticalPlacement, layoutTextSizeThisZoom) {
	                  var x = 0;
	                  var y = SHAPING_DEFAULT_OFFSET;
	                  var maxLineLength = 0;
	                  var maxLineHeight = 0;
	                  var justify = textJustify === "right" ? 1 : textJustify === "left" ? 0 : 0.5;
	                  var lineIndex = 0;
	                  for (var i$1 = 0, list = lines; i$1 < list.length; i$1 += 1) {
	                    var line = list[i$1];
	                    line.trim();
	                    var lineMaxScale = line.getMaxScale();
	                    var maxLineOffset = (lineMaxScale - 1) * ONE_EM;
	                    var positionedLine = {
	                      positionedGlyphs: [],
	                      lineOffset: 0
	                    };
	                    shaping.positionedLines[lineIndex] = positionedLine;
	                    var positionedGlyphs = positionedLine.positionedGlyphs;
	                    var lineOffset = 0;
	                    if (!line.length()) {
	                      y += lineHeight;
	                      ++lineIndex;
	                      continue;
	                    }
	                    for (var i = 0; i < line.length(); i++) {
	                      var section = line.getSection(i);
	                      var sectionIndex = line.getSectionIndex(i);
	                      var codePoint = line.getCharCode(i);
	                      var baselineOffset2 = 0;
	                      var metrics = null;
	                      var rect = null;
	                      var imageName = null;
	                      var verticalAdvance = ONE_EM;
	                      var vertical = !(writingMode === WritingMode.horizontal || !allowVerticalPlacement && !charHasUprightVerticalOrientation(codePoint) || allowVerticalPlacement && (whitespace[codePoint] || charInComplexShapingScript(codePoint)));
	                      if (!section.imageName) {
	                        var positions = glyphPositions[section.fontStack];
	                        var glyphPosition = positions && positions[codePoint];
	                        if (glyphPosition && glyphPosition.rect) {
	                          rect = glyphPosition.rect;
	                          metrics = glyphPosition.metrics;
	                        } else {
	                          var glyphs = glyphMap[section.fontStack];
	                          var glyph = glyphs && glyphs[codePoint];
	                          if (!glyph) {
	                            continue;
	                          }
	                          metrics = glyph.metrics;
	                        }
	                        baselineOffset2 = (lineMaxScale - section.scale) * ONE_EM;
	                      } else {
	                        var imagePosition = imagePositions[section.imageName];
	                        if (!imagePosition) {
	                          continue;
	                        }
	                        imageName = section.imageName;
	                        shaping.iconsInText = shaping.iconsInText || true;
	                        rect = imagePosition.paddedRect;
	                        var size = imagePosition.displaySize;
	                        section.scale = section.scale * ONE_EM / layoutTextSizeThisZoom;
	                        metrics = {
	                          width: size[0],
	                          height: size[1],
	                          left: IMAGE_PADDING,
	                          top: -3,
	                          advance: vertical ? size[1] : size[0]
	                        };
	                        var imageOffset = ONE_EM - size[1] * section.scale;
	                        baselineOffset2 = maxLineOffset + imageOffset;
	                        verticalAdvance = metrics.advance;
	                        var offset = vertical ? size[0] * section.scale - ONE_EM * lineMaxScale : size[1] * section.scale - ONE_EM * lineMaxScale;
	                        if (offset > 0 && offset > lineOffset) {
	                          lineOffset = offset;
	                        }
	                      }
	                      if (!vertical) {
	                        positionedGlyphs.push({
	                          glyph: codePoint,
	                          imageName,
	                          x,
	                          y: y + baselineOffset2,
	                          vertical,
	                          scale: section.scale,
	                          fontStack: section.fontStack,
	                          sectionIndex,
	                          metrics,
	                          rect
	                        });
	                        x += metrics.advance * section.scale + spacing;
	                      } else {
	                        shaping.verticalizable = true;
	                        positionedGlyphs.push({
	                          glyph: codePoint,
	                          imageName,
	                          x,
	                          y: y + baselineOffset2,
	                          vertical,
	                          scale: section.scale,
	                          fontStack: section.fontStack,
	                          sectionIndex,
	                          metrics,
	                          rect
	                        });
	                        x += verticalAdvance * section.scale + spacing;
	                      }
	                    }
	                    if (positionedGlyphs.length !== 0) {
	                      var lineLength = x - spacing;
	                      maxLineLength = Math.max(lineLength, maxLineLength);
	                      justifyLine(positionedGlyphs, 0, positionedGlyphs.length - 1, justify, lineOffset);
	                    }
	                    x = 0;
	                    var currentLineHeight = lineHeight * lineMaxScale + lineOffset;
	                    positionedLine.lineOffset = Math.max(lineOffset, maxLineOffset);
	                    y += currentLineHeight;
	                    maxLineHeight = Math.max(currentLineHeight, maxLineHeight);
	                    ++lineIndex;
	                  }
	                  var height = y - SHAPING_DEFAULT_OFFSET;
	                  var ref = getAnchorAlignment(textAnchor);
	                  var horizontalAlign = ref.horizontalAlign;
	                  var verticalAlign = ref.verticalAlign;
	                  align$1(shaping.positionedLines, justify, horizontalAlign, verticalAlign, maxLineLength, maxLineHeight, lineHeight, height, lines.length);
	                  shaping.top += -verticalAlign * height;
	                  shaping.bottom = shaping.top + height;
	                  shaping.left += -horizontalAlign * maxLineLength;
	                  shaping.right = shaping.left + maxLineLength;
	                }
	                function justifyLine(positionedGlyphs, start, end, justify, lineOffset) {
	                  if (!justify && !lineOffset) {
	                    return;
	                  }
	                  var lastPositionedGlyph = positionedGlyphs[end];
	                  var lastAdvance = lastPositionedGlyph.metrics.advance * lastPositionedGlyph.scale;
	                  var lineIndent = (positionedGlyphs[end].x + lastAdvance) * justify;
	                  for (var j = start; j <= end; j++) {
	                    positionedGlyphs[j].x -= lineIndent;
	                    positionedGlyphs[j].y += lineOffset;
	                  }
	                }
	                function align$1(positionedLines, justify, horizontalAlign, verticalAlign, maxLineLength, maxLineHeight, lineHeight, blockHeight, lineCount) {
	                  var shiftX = (justify - horizontalAlign) * maxLineLength;
	                  var shiftY = 0;
	                  if (maxLineHeight !== lineHeight) {
	                    shiftY = -blockHeight * verticalAlign - SHAPING_DEFAULT_OFFSET;
	                  } else {
	                    shiftY = (-verticalAlign * lineCount + 0.5) * lineHeight;
	                  }
	                  for (var i$1 = 0, list$1 = positionedLines; i$1 < list$1.length; i$1 += 1) {
	                    var line = list$1[i$1];
	                    for (var i = 0, list = line.positionedGlyphs; i < list.length; i += 1) {
	                      var positionedGlyph = list[i];
	                      positionedGlyph.x += shiftX;
	                      positionedGlyph.y += shiftY;
	                    }
	                  }
	                }
	                function shapeIcon(image, iconOffset, iconAnchor) {
	                  var ref = getAnchorAlignment(iconAnchor);
	                  var horizontalAlign = ref.horizontalAlign;
	                  var verticalAlign = ref.verticalAlign;
	                  var dx = iconOffset[0];
	                  var dy = iconOffset[1];
	                  var x1 = dx - image.displaySize[0] * horizontalAlign;
	                  var x2 = x1 + image.displaySize[0];
	                  var y1 = dy - image.displaySize[1] * verticalAlign;
	                  var y2 = y1 + image.displaySize[1];
	                  return {
	                    image,
	                    top: y1,
	                    bottom: y2,
	                    left: x1,
	                    right: x2
	                  };
	                }
	                function fitIconToText(shapedIcon, shapedText, textFit, padding, iconOffset, fontScale) {
	                  var image = shapedIcon.image;
	                  var collisionPadding;
	                  if (image.content) {
	                    var content = image.content;
	                    var pixelRatio = image.pixelRatio || 1;
	                    collisionPadding = [
	                      content[0] / pixelRatio,
	                      content[1] / pixelRatio,
	                      image.displaySize[0] - content[2] / pixelRatio,
	                      image.displaySize[1] - content[3] / pixelRatio
	                    ];
	                  }
	                  var textLeft = shapedText.left * fontScale;
	                  var textRight = shapedText.right * fontScale;
	                  var top, right, bottom, left;
	                  if (textFit === "width" || textFit === "both") {
	                    left = iconOffset[0] + textLeft - padding[3];
	                    right = iconOffset[0] + textRight + padding[1];
	                  } else {
	                    left = iconOffset[0] + (textLeft + textRight - image.displaySize[0]) / 2;
	                    right = left + image.displaySize[0];
	                  }
	                  var textTop = shapedText.top * fontScale;
	                  var textBottom = shapedText.bottom * fontScale;
	                  if (textFit === "height" || textFit === "both") {
	                    top = iconOffset[1] + textTop - padding[0];
	                    bottom = iconOffset[1] + textBottom + padding[2];
	                  } else {
	                    top = iconOffset[1] + (textTop + textBottom - image.displaySize[1]) / 2;
	                    bottom = top + image.displaySize[1];
	                  }
	                  return {
	                    image,
	                    top,
	                    right,
	                    bottom,
	                    left,
	                    collisionPadding
	                  };
	                }
	                var Anchor = function(Point2) {
	                  function Anchor2(x, y, angle, segment) {
	                    Point2.call(this, x, y);
	                    this.angle = angle;
	                    if (segment !== undefined) {
	                      this.segment = segment;
	                    }
	                  }
	                  Anchor2.__proto__ = Point2;
	                  Anchor2.prototype = Object.create(Point2.prototype);
	                  Anchor2.prototype.constructor = Anchor2;
	                  Anchor2.prototype.clone = function clone2() {
	                    return new Anchor2(this.x, this.y, this.angle, this.segment);
	                  };
	                  return Anchor2;
	                }(pointGeometry);
	                register("Anchor", Anchor);
	                var SIZE_PACK_FACTOR = 128;
	                function getSizeData(tileZoom, value) {
	                  var expression2 = value.expression;
	                  if (expression2.kind === "constant") {
	                    var layoutSize = expression2.evaluate(new EvaluationParameters(tileZoom + 1));
	                    return {
	                      kind: "constant",
	                      layoutSize
	                    };
	                  } else if (expression2.kind === "source") {
	                    return { kind: "source" };
	                  } else {
	                    var zoomStops = expression2.zoomStops;
	                    var interpolationType = expression2.interpolationType;
	                    var lower = 0;
	                    while (lower < zoomStops.length && zoomStops[lower] <= tileZoom) {
	                      lower++;
	                    }
	                    lower = Math.max(0, lower - 1);
	                    var upper = lower;
	                    while (upper < zoomStops.length && zoomStops[upper] < tileZoom + 1) {
	                      upper++;
	                    }
	                    upper = Math.min(zoomStops.length - 1, upper);
	                    var minZoom = zoomStops[lower];
	                    var maxZoom = zoomStops[upper];
	                    if (expression2.kind === "composite") {
	                      return {
	                        kind: "composite",
	                        minZoom,
	                        maxZoom,
	                        interpolationType
	                      };
	                    }
	                    var minSize = expression2.evaluate(new EvaluationParameters(minZoom));
	                    var maxSize = expression2.evaluate(new EvaluationParameters(maxZoom));
	                    return {
	                      kind: "camera",
	                      minZoom,
	                      maxZoom,
	                      minSize,
	                      maxSize,
	                      interpolationType
	                    };
	                  }
	                }
	                function evaluateSizeForFeature(sizeData, ref, ref$1) {
	                  var uSize = ref.uSize;
	                  var uSizeT = ref.uSizeT;
	                  var lowerSize = ref$1.lowerSize;
	                  var upperSize = ref$1.upperSize;
	                  if (sizeData.kind === "source") {
	                    return lowerSize / SIZE_PACK_FACTOR;
	                  } else if (sizeData.kind === "composite") {
	                    return number2(lowerSize / SIZE_PACK_FACTOR, upperSize / SIZE_PACK_FACTOR, uSizeT);
	                  }
	                  return uSize;
	                }
	                function evaluateSizeForZoom(sizeData, zoom) {
	                  var uSizeT = 0;
	                  var uSize = 0;
	                  if (sizeData.kind === "constant") {
	                    uSize = sizeData.layoutSize;
	                  } else if (sizeData.kind !== "source") {
	                    var interpolationType = sizeData.interpolationType;
	                    var minZoom = sizeData.minZoom;
	                    var maxZoom = sizeData.maxZoom;
	                    var t = !interpolationType ? 0 : clamp(Interpolate.interpolationFactor(interpolationType, zoom, minZoom, maxZoom), 0, 1);
	                    if (sizeData.kind === "camera") {
	                      uSize = number2(sizeData.minSize, sizeData.maxSize, t);
	                    } else {
	                      uSizeT = t;
	                    }
	                  }
	                  return {
	                    uSizeT,
	                    uSize
	                  };
	                }
	                var symbolSize = /* @__PURE__ */ Object.freeze({
	                  __proto__: null,
	                  getSizeData,
	                  evaluateSizeForFeature,
	                  evaluateSizeForZoom,
	                  SIZE_PACK_FACTOR
	                });
	                function checkMaxAngle(line, anchor, labelLength, windowSize, maxAngle) {
	                  if (anchor.segment === undefined) {
	                    return true;
	                  }
	                  var p = anchor;
	                  var index = anchor.segment + 1;
	                  var anchorDistance = 0;
	                  while (anchorDistance > -labelLength / 2) {
	                    index--;
	                    if (index < 0) {
	                      return false;
	                    }
	                    anchorDistance -= line[index].dist(p);
	                    p = line[index];
	                  }
	                  anchorDistance += line[index].dist(line[index + 1]);
	                  index++;
	                  var recentCorners = [];
	                  var recentAngleDelta = 0;
	                  while (anchorDistance < labelLength / 2) {
	                    var prev = line[index - 1];
	                    var current = line[index];
	                    var next = line[index + 1];
	                    if (!next) {
	                      return false;
	                    }
	                    var angleDelta = prev.angleTo(current) - current.angleTo(next);
	                    angleDelta = Math.abs((angleDelta + 3 * Math.PI) % (Math.PI * 2) - Math.PI);
	                    recentCorners.push({
	                      distance: anchorDistance,
	                      angleDelta
	                    });
	                    recentAngleDelta += angleDelta;
	                    while (anchorDistance - recentCorners[0].distance > windowSize) {
	                      recentAngleDelta -= recentCorners.shift().angleDelta;
	                    }
	                    if (recentAngleDelta > maxAngle) {
	                      return false;
	                    }
	                    index++;
	                    anchorDistance += current.dist(next);
	                  }
	                  return true;
	                }
	                function getLineLength(line) {
	                  var lineLength = 0;
	                  for (var k = 0; k < line.length - 1; k++) {
	                    lineLength += line[k].dist(line[k + 1]);
	                  }
	                  return lineLength;
	                }
	                function getAngleWindowSize(shapedText, glyphSize, boxScale) {
	                  return shapedText ? 3 / 5 * glyphSize * boxScale : 0;
	                }
	                function getShapedLabelLength(shapedText, shapedIcon) {
	                  return Math.max(shapedText ? shapedText.right - shapedText.left : 0, shapedIcon ? shapedIcon.right - shapedIcon.left : 0);
	                }
	                function getCenterAnchor(line, maxAngle, shapedText, shapedIcon, glyphSize, boxScale) {
	                  var angleWindowSize = getAngleWindowSize(shapedText, glyphSize, boxScale);
	                  var labelLength = getShapedLabelLength(shapedText, shapedIcon) * boxScale;
	                  var prevDistance = 0;
	                  var centerDistance = getLineLength(line) / 2;
	                  for (var i = 0; i < line.length - 1; i++) {
	                    var a = line[i], b = line[i + 1];
	                    var segmentDistance = a.dist(b);
	                    if (prevDistance + segmentDistance > centerDistance) {
	                      var t = (centerDistance - prevDistance) / segmentDistance, x = number2(a.x, b.x, t), y = number2(a.y, b.y, t);
	                      var anchor = new Anchor(x, y, b.angleTo(a), i);
	                      anchor._round();
	                      if (!angleWindowSize || checkMaxAngle(line, anchor, labelLength, angleWindowSize, maxAngle)) {
	                        return anchor;
	                      } else {
	                        return;
	                      }
	                    }
	                    prevDistance += segmentDistance;
	                  }
	                }
	                function getAnchors(line, spacing, maxAngle, shapedText, shapedIcon, glyphSize, boxScale, overscaling, tileExtent) {
	                  var angleWindowSize = getAngleWindowSize(shapedText, glyphSize, boxScale);
	                  var shapedLabelLength = getShapedLabelLength(shapedText, shapedIcon);
	                  var labelLength = shapedLabelLength * boxScale;
	                  var isLineContinued = line[0].x === 0 || line[0].x === tileExtent || line[0].y === 0 || line[0].y === tileExtent;
	                  if (spacing - labelLength < spacing / 4) {
	                    spacing = labelLength + spacing / 4;
	                  }
	                  var fixedExtraOffset = glyphSize * 2;
	                  var offset = !isLineContinued ? (shapedLabelLength / 2 + fixedExtraOffset) * boxScale * overscaling % spacing : spacing / 2 * overscaling % spacing;
	                  return resample(line, offset, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, false, tileExtent);
	                }
	                function resample(line, offset, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, placeAtMiddle, tileExtent) {
	                  var halfLabelLength = labelLength / 2;
	                  var lineLength = getLineLength(line);
	                  var distance = 0, markedDistance = offset - spacing;
	                  var anchors = [];
	                  for (var i = 0; i < line.length - 1; i++) {
	                    var a = line[i], b = line[i + 1];
	                    var segmentDist = a.dist(b), angle = b.angleTo(a);
	                    while (markedDistance + spacing < distance + segmentDist) {
	                      markedDistance += spacing;
	                      var t = (markedDistance - distance) / segmentDist, x = number2(a.x, b.x, t), y = number2(a.y, b.y, t);
	                      if (x >= 0 && x < tileExtent && y >= 0 && y < tileExtent && markedDistance - halfLabelLength >= 0 && markedDistance + halfLabelLength <= lineLength) {
	                        var anchor = new Anchor(x, y, angle, i);
	                        anchor._round();
	                        if (!angleWindowSize || checkMaxAngle(line, anchor, labelLength, angleWindowSize, maxAngle)) {
	                          anchors.push(anchor);
	                        }
	                      }
	                    }
	                    distance += segmentDist;
	                  }
	                  if (!placeAtMiddle && !anchors.length && !isLineContinued) {
	                    anchors = resample(line, distance / 2, spacing, angleWindowSize, maxAngle, labelLength, isLineContinued, true, tileExtent);
	                  }
	                  return anchors;
	                }
	                function clipLine(lines, x1, y1, x2, y2) {
	                  var clippedLines = [];
	                  for (var l = 0; l < lines.length; l++) {
	                    var line = lines[l];
	                    var clippedLine = undefined;
	                    for (var i = 0; i < line.length - 1; i++) {
	                      var p0 = line[i];
	                      var p1 = line[i + 1];
	                      if (p0.x < x1 && p1.x < x1) {
	                        continue;
	                      } else if (p0.x < x1) {
	                        p0 = new pointGeometry(x1, p0.y + (p1.y - p0.y) * ((x1 - p0.x) / (p1.x - p0.x)))._round();
	                      } else if (p1.x < x1) {
	                        p1 = new pointGeometry(x1, p0.y + (p1.y - p0.y) * ((x1 - p0.x) / (p1.x - p0.x)))._round();
	                      }
	                      if (p0.y < y1 && p1.y < y1) {
	                        continue;
	                      } else if (p0.y < y1) {
	                        p0 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y1 - p0.y) / (p1.y - p0.y)), y1)._round();
	                      } else if (p1.y < y1) {
	                        p1 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y1 - p0.y) / (p1.y - p0.y)), y1)._round();
	                      }
	                      if (p0.x >= x2 && p1.x >= x2) {
	                        continue;
	                      } else if (p0.x >= x2) {
	                        p0 = new pointGeometry(x2, p0.y + (p1.y - p0.y) * ((x2 - p0.x) / (p1.x - p0.x)))._round();
	                      } else if (p1.x >= x2) {
	                        p1 = new pointGeometry(x2, p0.y + (p1.y - p0.y) * ((x2 - p0.x) / (p1.x - p0.x)))._round();
	                      }
	                      if (p0.y >= y2 && p1.y >= y2) {
	                        continue;
	                      } else if (p0.y >= y2) {
	                        p0 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y2 - p0.y) / (p1.y - p0.y)), y2)._round();
	                      } else if (p1.y >= y2) {
	                        p1 = new pointGeometry(p0.x + (p1.x - p0.x) * ((y2 - p0.y) / (p1.y - p0.y)), y2)._round();
	                      }
	                      if (!clippedLine || !p0.equals(clippedLine[clippedLine.length - 1])) {
	                        clippedLine = [p0];
	                        clippedLines.push(clippedLine);
	                      }
	                      clippedLine.push(p1);
	                    }
	                  }
	                  return clippedLines;
	                }
	                var border$1 = IMAGE_PADDING;
	                function getIconQuads(shapedIcon, iconRotate, isSDFIcon, hasIconTextFit) {
	                  var quads = [];
	                  var image = shapedIcon.image;
	                  var pixelRatio = image.pixelRatio;
	                  var imageWidth = image.paddedRect.w - 2 * border$1;
	                  var imageHeight = image.paddedRect.h - 2 * border$1;
	                  var iconWidth = shapedIcon.right - shapedIcon.left;
	                  var iconHeight = shapedIcon.bottom - shapedIcon.top;
	                  var stretchX = image.stretchX || [[
	                    0,
	                    imageWidth
	                  ]];
	                  var stretchY = image.stretchY || [[
	                    0,
	                    imageHeight
	                  ]];
	                  var reduceRanges = function(sum, range2) {
	                    return sum + range2[1] - range2[0];
	                  };
	                  var stretchWidth = stretchX.reduce(reduceRanges, 0);
	                  var stretchHeight = stretchY.reduce(reduceRanges, 0);
	                  var fixedWidth = imageWidth - stretchWidth;
	                  var fixedHeight = imageHeight - stretchHeight;
	                  var stretchOffsetX = 0;
	                  var stretchContentWidth = stretchWidth;
	                  var stretchOffsetY = 0;
	                  var stretchContentHeight = stretchHeight;
	                  var fixedOffsetX = 0;
	                  var fixedContentWidth = fixedWidth;
	                  var fixedOffsetY = 0;
	                  var fixedContentHeight = fixedHeight;
	                  if (image.content && hasIconTextFit) {
	                    var content = image.content;
	                    stretchOffsetX = sumWithinRange(stretchX, 0, content[0]);
	                    stretchOffsetY = sumWithinRange(stretchY, 0, content[1]);
	                    stretchContentWidth = sumWithinRange(stretchX, content[0], content[2]);
	                    stretchContentHeight = sumWithinRange(stretchY, content[1], content[3]);
	                    fixedOffsetX = content[0] - stretchOffsetX;
	                    fixedOffsetY = content[1] - stretchOffsetY;
	                    fixedContentWidth = content[2] - content[0] - stretchContentWidth;
	                    fixedContentHeight = content[3] - content[1] - stretchContentHeight;
	                  }
	                  var makeBox = function(left, top, right, bottom) {
	                    var leftEm = getEmOffset(left.stretch - stretchOffsetX, stretchContentWidth, iconWidth, shapedIcon.left);
	                    var leftPx = getPxOffset(left.fixed - fixedOffsetX, fixedContentWidth, left.stretch, stretchWidth);
	                    var topEm = getEmOffset(top.stretch - stretchOffsetY, stretchContentHeight, iconHeight, shapedIcon.top);
	                    var topPx = getPxOffset(top.fixed - fixedOffsetY, fixedContentHeight, top.stretch, stretchHeight);
	                    var rightEm = getEmOffset(right.stretch - stretchOffsetX, stretchContentWidth, iconWidth, shapedIcon.left);
	                    var rightPx = getPxOffset(right.fixed - fixedOffsetX, fixedContentWidth, right.stretch, stretchWidth);
	                    var bottomEm = getEmOffset(bottom.stretch - stretchOffsetY, stretchContentHeight, iconHeight, shapedIcon.top);
	                    var bottomPx = getPxOffset(bottom.fixed - fixedOffsetY, fixedContentHeight, bottom.stretch, stretchHeight);
	                    var tl = new pointGeometry(leftEm, topEm);
	                    var tr = new pointGeometry(rightEm, topEm);
	                    var br = new pointGeometry(rightEm, bottomEm);
	                    var bl = new pointGeometry(leftEm, bottomEm);
	                    var pixelOffsetTL = new pointGeometry(leftPx / pixelRatio, topPx / pixelRatio);
	                    var pixelOffsetBR = new pointGeometry(rightPx / pixelRatio, bottomPx / pixelRatio);
	                    var angle = iconRotate * Math.PI / 180;
	                    if (angle) {
	                      var sin = Math.sin(angle), cos = Math.cos(angle), matrix = [
	                        cos,
	                        -sin,
	                        sin,
	                        cos
	                      ];
	                      tl._matMult(matrix);
	                      tr._matMult(matrix);
	                      bl._matMult(matrix);
	                      br._matMult(matrix);
	                    }
	                    var x12 = left.stretch + left.fixed;
	                    var x22 = right.stretch + right.fixed;
	                    var y12 = top.stretch + top.fixed;
	                    var y22 = bottom.stretch + bottom.fixed;
	                    var subRect = {
	                      x: image.paddedRect.x + border$1 + x12,
	                      y: image.paddedRect.y + border$1 + y12,
	                      w: x22 - x12,
	                      h: y22 - y12
	                    };
	                    var minFontScaleX = fixedContentWidth / pixelRatio / iconWidth;
	                    var minFontScaleY = fixedContentHeight / pixelRatio / iconHeight;
	                    return {
	                      tl,
	                      tr,
	                      bl,
	                      br,
	                      tex: subRect,
	                      writingMode: undefined,
	                      glyphOffset: [
	                        0,
	                        0
	                      ],
	                      sectionIndex: 0,
	                      pixelOffsetTL,
	                      pixelOffsetBR,
	                      minFontScaleX,
	                      minFontScaleY,
	                      isSDF: isSDFIcon
	                    };
	                  };
	                  if (!hasIconTextFit || !image.stretchX && !image.stretchY) {
	                    quads.push(makeBox({
	                      fixed: 0,
	                      stretch: -1
	                    }, {
	                      fixed: 0,
	                      stretch: -1
	                    }, {
	                      fixed: 0,
	                      stretch: imageWidth + 1
	                    }, {
	                      fixed: 0,
	                      stretch: imageHeight + 1
	                    }));
	                  } else {
	                    var xCuts = stretchZonesToCuts(stretchX, fixedWidth, stretchWidth);
	                    var yCuts = stretchZonesToCuts(stretchY, fixedHeight, stretchHeight);
	                    for (var xi = 0; xi < xCuts.length - 1; xi++) {
	                      var x1 = xCuts[xi];
	                      var x2 = xCuts[xi + 1];
	                      for (var yi = 0; yi < yCuts.length - 1; yi++) {
	                        var y1 = yCuts[yi];
	                        var y2 = yCuts[yi + 1];
	                        quads.push(makeBox(x1, y1, x2, y2));
	                      }
	                    }
	                  }
	                  return quads;
	                }
	                function sumWithinRange(ranges, min, max) {
	                  var sum = 0;
	                  for (var i = 0, list = ranges; i < list.length; i += 1) {
	                    var range2 = list[i];
	                    sum += Math.max(min, Math.min(max, range2[1])) - Math.max(min, Math.min(max, range2[0]));
	                  }
	                  return sum;
	                }
	                function stretchZonesToCuts(stretchZones, fixedSize, stretchSize) {
	                  var cuts = [{
	                    fixed: -1,
	                    stretch: 0
	                  }];
	                  for (var i = 0, list = stretchZones; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var c1 = ref[0];
	                    var c2 = ref[1];
	                    var last = cuts[cuts.length - 1];
	                    cuts.push({
	                      fixed: c1 - last.stretch,
	                      stretch: last.stretch
	                    });
	                    cuts.push({
	                      fixed: c1 - last.stretch,
	                      stretch: last.stretch + (c2 - c1)
	                    });
	                  }
	                  cuts.push({
	                    fixed: fixedSize + border$1,
	                    stretch: stretchSize
	                  });
	                  return cuts;
	                }
	                function getEmOffset(stretchOffset, stretchSize, iconSize, iconOffset) {
	                  return stretchOffset / stretchSize * iconSize + iconOffset;
	                }
	                function getPxOffset(fixedOffset, fixedSize, stretchOffset, stretchSize) {
	                  return fixedOffset - fixedSize * stretchOffset / stretchSize;
	                }
	                function getGlyphQuads(anchor, shaping, textOffset, layer2, alongLine, feature, imageMap, allowVerticalPlacement) {
	                  var textRotate = layer2.layout.get("text-rotate").evaluate(feature, {}) * Math.PI / 180;
	                  var quads = [];
	                  for (var i$1 = 0, list$1 = shaping.positionedLines; i$1 < list$1.length; i$1 += 1) {
	                    var line = list$1[i$1];
	                    for (var i = 0, list = line.positionedGlyphs; i < list.length; i += 1) {
	                      var positionedGlyph = list[i];
	                      if (!positionedGlyph.rect) {
	                        continue;
	                      }
	                      var textureRect = positionedGlyph.rect || {};
	                      var glyphPadding = 1;
	                      var rectBuffer = GLYPH_PBF_BORDER + glyphPadding;
	                      var isSDF = true;
	                      var pixelRatio = 1;
	                      var lineOffset = 0;
	                      var rotateVerticalGlyph = (alongLine || allowVerticalPlacement) && positionedGlyph.vertical;
	                      var halfAdvance = positionedGlyph.metrics.advance * positionedGlyph.scale / 2;
	                      if (allowVerticalPlacement && shaping.verticalizable) {
	                        var scaledGlyphOffset = (positionedGlyph.scale - 1) * ONE_EM;
	                        var imageOffset = (ONE_EM - positionedGlyph.metrics.width * positionedGlyph.scale) / 2;
	                        lineOffset = line.lineOffset / 2 - (positionedGlyph.imageName ? -imageOffset : scaledGlyphOffset);
	                      }
	                      if (positionedGlyph.imageName) {
	                        var image = imageMap[positionedGlyph.imageName];
	                        isSDF = image.sdf;
	                        pixelRatio = image.pixelRatio;
	                        rectBuffer = IMAGE_PADDING / pixelRatio;
	                      }
	                      var glyphOffset2 = alongLine ? [
	                        positionedGlyph.x + halfAdvance,
	                        positionedGlyph.y
	                      ] : [
	                        0,
	                        0
	                      ];
	                      var builtInOffset = alongLine ? [
	                        0,
	                        0
	                      ] : [
	                        positionedGlyph.x + halfAdvance + textOffset[0],
	                        positionedGlyph.y + textOffset[1] - lineOffset
	                      ];
	                      var verticalizedLabelOffset = [
	                        0,
	                        0
	                      ];
	                      if (rotateVerticalGlyph) {
	                        verticalizedLabelOffset = builtInOffset;
	                        builtInOffset = [
	                          0,
	                          0
	                        ];
	                      }
	                      var x1 = (positionedGlyph.metrics.left - rectBuffer) * positionedGlyph.scale - halfAdvance + builtInOffset[0];
	                      var y1 = (-positionedGlyph.metrics.top - rectBuffer) * positionedGlyph.scale + builtInOffset[1];
	                      var x2 = x1 + textureRect.w * positionedGlyph.scale / pixelRatio;
	                      var y2 = y1 + textureRect.h * positionedGlyph.scale / pixelRatio;
	                      var tl = new pointGeometry(x1, y1);
	                      var tr = new pointGeometry(x2, y1);
	                      var bl = new pointGeometry(x1, y2);
	                      var br = new pointGeometry(x2, y2);
	                      if (rotateVerticalGlyph) {
	                        var center = new pointGeometry(-halfAdvance, halfAdvance - SHAPING_DEFAULT_OFFSET);
	                        var verticalRotation = -Math.PI / 2;
	                        var xHalfWidthOffsetCorrection = ONE_EM / 2 - halfAdvance;
	                        var yImageOffsetCorrection = positionedGlyph.imageName ? xHalfWidthOffsetCorrection : 0;
	                        var halfWidthOffsetCorrection = new pointGeometry(5 - SHAPING_DEFAULT_OFFSET - xHalfWidthOffsetCorrection, -yImageOffsetCorrection);
	                        var verticalOffsetCorrection = new (Function.prototype.bind.apply(pointGeometry, [null].concat(verticalizedLabelOffset)))();
	                        tl._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
	                        tr._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
	                        bl._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
	                        br._rotateAround(verticalRotation, center)._add(halfWidthOffsetCorrection)._add(verticalOffsetCorrection);
	                      }
	                      if (textRotate) {
	                        var sin = Math.sin(textRotate), cos = Math.cos(textRotate), matrix = [
	                          cos,
	                          -sin,
	                          sin,
	                          cos
	                        ];
	                        tl._matMult(matrix);
	                        tr._matMult(matrix);
	                        bl._matMult(matrix);
	                        br._matMult(matrix);
	                      }
	                      var pixelOffsetTL = new pointGeometry(0, 0);
	                      var pixelOffsetBR = new pointGeometry(0, 0);
	                      var minFontScaleX = 0;
	                      var minFontScaleY = 0;
	                      quads.push({
	                        tl,
	                        tr,
	                        bl,
	                        br,
	                        tex: textureRect,
	                        writingMode: shaping.writingMode,
	                        glyphOffset: glyphOffset2,
	                        sectionIndex: positionedGlyph.sectionIndex,
	                        isSDF,
	                        pixelOffsetTL,
	                        pixelOffsetBR,
	                        minFontScaleX,
	                        minFontScaleY
	                      });
	                    }
	                  }
	                  return quads;
	                }
	                var CollisionFeature = function CollisionFeature2(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shaped, boxScale, padding, alignLine, rotate2) {
	                  this.boxStartIndex = collisionBoxArray.length;
	                  if (alignLine) {
	                    var top = shaped.top;
	                    var bottom = shaped.bottom;
	                    var collisionPadding = shaped.collisionPadding;
	                    if (collisionPadding) {
	                      top -= collisionPadding[1];
	                      bottom += collisionPadding[3];
	                    }
	                    var height = bottom - top;
	                    if (height > 0) {
	                      height = Math.max(10, height);
	                      this.circleDiameter = height;
	                    }
	                  } else {
	                    var y1 = shaped.top * boxScale - padding;
	                    var y2 = shaped.bottom * boxScale + padding;
	                    var x1 = shaped.left * boxScale - padding;
	                    var x2 = shaped.right * boxScale + padding;
	                    var collisionPadding$1 = shaped.collisionPadding;
	                    if (collisionPadding$1) {
	                      x1 -= collisionPadding$1[0] * boxScale;
	                      y1 -= collisionPadding$1[1] * boxScale;
	                      x2 += collisionPadding$1[2] * boxScale;
	                      y2 += collisionPadding$1[3] * boxScale;
	                    }
	                    if (rotate2) {
	                      var tl = new pointGeometry(x1, y1);
	                      var tr = new pointGeometry(x2, y1);
	                      var bl = new pointGeometry(x1, y2);
	                      var br = new pointGeometry(x2, y2);
	                      var rotateRadians = rotate2 * Math.PI / 180;
	                      tl._rotate(rotateRadians);
	                      tr._rotate(rotateRadians);
	                      bl._rotate(rotateRadians);
	                      br._rotate(rotateRadians);
	                      x1 = Math.min(tl.x, tr.x, bl.x, br.x);
	                      x2 = Math.max(tl.x, tr.x, bl.x, br.x);
	                      y1 = Math.min(tl.y, tr.y, bl.y, br.y);
	                      y2 = Math.max(tl.y, tr.y, bl.y, br.y);
	                    }
	                    collisionBoxArray.emplaceBack(anchor.x, anchor.y, x1, y1, x2, y2, featureIndex, sourceLayerIndex, bucketIndex);
	                  }
	                  this.boxEndIndex = collisionBoxArray.length;
	                };
	                var TinyQueue = function TinyQueue2(data, compare2) {
	                  if (data === undefined)
	                    data = [];
	                  if (compare2 === undefined)
	                    compare2 = defaultCompare$1;
	                  this.data = data;
	                  this.length = this.data.length;
	                  this.compare = compare2;
	                  if (this.length > 0) {
	                    for (var i = (this.length >> 1) - 1; i >= 0; i--) {
	                      this._down(i);
	                    }
	                  }
	                };
	                TinyQueue.prototype.push = function push(item) {
	                  this.data.push(item);
	                  this.length++;
	                  this._up(this.length - 1);
	                };
	                TinyQueue.prototype.pop = function pop() {
	                  if (this.length === 0) {
	                    return undefined;
	                  }
	                  var top = this.data[0];
	                  var bottom = this.data.pop();
	                  this.length--;
	                  if (this.length > 0) {
	                    this.data[0] = bottom;
	                    this._down(0);
	                  }
	                  return top;
	                };
	                TinyQueue.prototype.peek = function peek() {
	                  return this.data[0];
	                };
	                TinyQueue.prototype._up = function _up(pos) {
	                  var ref = this;
	                  var data = ref.data;
	                  var compare2 = ref.compare;
	                  var item = data[pos];
	                  while (pos > 0) {
	                    var parent = pos - 1 >> 1;
	                    var current = data[parent];
	                    if (compare2(item, current) >= 0) {
	                      break;
	                    }
	                    data[pos] = current;
	                    pos = parent;
	                  }
	                  data[pos] = item;
	                };
	                TinyQueue.prototype._down = function _down(pos) {
	                  var ref = this;
	                  var data = ref.data;
	                  var compare2 = ref.compare;
	                  var halfLength = this.length >> 1;
	                  var item = data[pos];
	                  while (pos < halfLength) {
	                    var left = (pos << 1) + 1;
	                    var best = data[left];
	                    var right = left + 1;
	                    if (right < this.length && compare2(data[right], best) < 0) {
	                      left = right;
	                      best = data[right];
	                    }
	                    if (compare2(best, item) >= 0) {
	                      break;
	                    }
	                    data[pos] = best;
	                    pos = left;
	                  }
	                  data[pos] = item;
	                };
	                function defaultCompare$1(a, b) {
	                  return a < b ? -1 : a > b ? 1 : 0;
	                }
	                function findPoleOfInaccessibility(polygonRings, precision, debug) {
	                  if (debug === undefined)
	                    debug = false;
	                  var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
	                  var outerRing = polygonRings[0];
	                  for (var i = 0; i < outerRing.length; i++) {
	                    var p = outerRing[i];
	                    if (!i || p.x < minX) {
	                      minX = p.x;
	                    }
	                    if (!i || p.y < minY) {
	                      minY = p.y;
	                    }
	                    if (!i || p.x > maxX) {
	                      maxX = p.x;
	                    }
	                    if (!i || p.y > maxY) {
	                      maxY = p.y;
	                    }
	                  }
	                  var width = maxX - minX;
	                  var height = maxY - minY;
	                  var cellSize = Math.min(width, height);
	                  var h = cellSize / 2;
	                  var cellQueue = new TinyQueue([], compareMax);
	                  if (cellSize === 0) {
	                    return new pointGeometry(minX, minY);
	                  }
	                  for (var x = minX; x < maxX; x += cellSize) {
	                    for (var y = minY; y < maxY; y += cellSize) {
	                      cellQueue.push(new Cell(x + h, y + h, h, polygonRings));
	                    }
	                  }
	                  var bestCell = getCentroidCell(polygonRings);
	                  var numProbes = cellQueue.length;
	                  while (cellQueue.length) {
	                    var cell = cellQueue.pop();
	                    if (cell.d > bestCell.d || !bestCell.d) {
	                      bestCell = cell;
	                      if (debug) {
	                        console.log("found best %d after %d probes", Math.round(1e4 * cell.d) / 1e4, numProbes);
	                      }
	                    }
	                    if (cell.max - bestCell.d <= precision) {
	                      continue;
	                    }
	                    h = cell.h / 2;
	                    cellQueue.push(new Cell(cell.p.x - h, cell.p.y - h, h, polygonRings));
	                    cellQueue.push(new Cell(cell.p.x + h, cell.p.y - h, h, polygonRings));
	                    cellQueue.push(new Cell(cell.p.x - h, cell.p.y + h, h, polygonRings));
	                    cellQueue.push(new Cell(cell.p.x + h, cell.p.y + h, h, polygonRings));
	                    numProbes += 4;
	                  }
	                  if (debug) {
	                    console.log("num probes: " + numProbes);
	                    console.log("best distance: " + bestCell.d);
	                  }
	                  return bestCell.p;
	                }
	                function compareMax(a, b) {
	                  return b.max - a.max;
	                }
	                function Cell(x, y, h, polygon) {
	                  this.p = new pointGeometry(x, y);
	                  this.h = h;
	                  this.d = pointToPolygonDist(this.p, polygon);
	                  this.max = this.d + this.h * Math.SQRT2;
	                }
	                function pointToPolygonDist(p, polygon) {
	                  var inside = false;
	                  var minDistSq = Infinity;
	                  for (var k = 0; k < polygon.length; k++) {
	                    var ring = polygon[k];
	                    for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
	                      var a = ring[i];
	                      var b = ring[j];
	                      if (a.y > p.y !== b.y > p.y && p.x < (b.x - a.x) * (p.y - a.y) / (b.y - a.y) + a.x) {
	                        inside = !inside;
	                      }
	                      minDistSq = Math.min(minDistSq, distToSegmentSquared(p, a, b));
	                    }
	                  }
	                  return (inside ? 1 : -1) * Math.sqrt(minDistSq);
	                }
	                function getCentroidCell(polygon) {
	                  var area2 = 0;
	                  var x = 0;
	                  var y = 0;
	                  var points = polygon[0];
	                  for (var i = 0, len = points.length, j = len - 1; i < len; j = i++) {
	                    var a = points[i];
	                    var b = points[j];
	                    var f = a.x * b.y - b.x * a.y;
	                    x += (a.x + b.x) * f;
	                    y += (a.y + b.y) * f;
	                    area2 += f * 3;
	                  }
	                  return new Cell(x / area2, y / area2, 0, polygon);
	                }
	                var baselineOffset = 7;
	                var INVALID_TEXT_OFFSET = Number.POSITIVE_INFINITY;
	                function evaluateVariableOffset(anchor, offset) {
	                  function fromRadialOffset(anchor2, radialOffset) {
	                    var x = 0, y = 0;
	                    if (radialOffset < 0) {
	                      radialOffset = 0;
	                    }
	                    var hypotenuse = radialOffset / Math.sqrt(2);
	                    switch (anchor2) {
	                      case "top-right":
	                      case "top-left":
	                        y = hypotenuse - baselineOffset;
	                        break;
	                      case "bottom-right":
	                      case "bottom-left":
	                        y = -hypotenuse + baselineOffset;
	                        break;
	                      case "bottom":
	                        y = -radialOffset + baselineOffset;
	                        break;
	                      case "top":
	                        y = radialOffset - baselineOffset;
	                        break;
	                    }
	                    switch (anchor2) {
	                      case "top-right":
	                      case "bottom-right":
	                        x = -hypotenuse;
	                        break;
	                      case "top-left":
	                      case "bottom-left":
	                        x = hypotenuse;
	                        break;
	                      case "left":
	                        x = radialOffset;
	                        break;
	                      case "right":
	                        x = -radialOffset;
	                        break;
	                    }
	                    return [
	                      x,
	                      y
	                    ];
	                  }
	                  function fromTextOffset(anchor2, offsetX, offsetY) {
	                    var x = 0, y = 0;
	                    offsetX = Math.abs(offsetX);
	                    offsetY = Math.abs(offsetY);
	                    switch (anchor2) {
	                      case "top-right":
	                      case "top-left":
	                      case "top":
	                        y = offsetY - baselineOffset;
	                        break;
	                      case "bottom-right":
	                      case "bottom-left":
	                      case "bottom":
	                        y = -offsetY + baselineOffset;
	                        break;
	                    }
	                    switch (anchor2) {
	                      case "top-right":
	                      case "bottom-right":
	                      case "right":
	                        x = -offsetX;
	                        break;
	                      case "top-left":
	                      case "bottom-left":
	                      case "left":
	                        x = offsetX;
	                        break;
	                    }
	                    return [
	                      x,
	                      y
	                    ];
	                  }
	                  return offset[1] !== INVALID_TEXT_OFFSET ? fromTextOffset(anchor, offset[0], offset[1]) : fromRadialOffset(anchor, offset[0]);
	                }
	                function performSymbolLayout(bucket, glyphMap, glyphPositions, imageMap, imagePositions, showCollisionBoxes, canonical) {
	                  bucket.createArrays();
	                  var tileSize = 512 * bucket.overscaling;
	                  bucket.tilePixelRatio = EXTENT$1 / tileSize;
	                  bucket.compareText = {};
	                  bucket.iconsNeedLinear = false;
	                  var layout2 = bucket.layers[0].layout;
	                  var unevaluatedLayoutValues = bucket.layers[0]._unevaluatedLayout._values;
	                  var sizes = {};
	                  if (bucket.textSizeData.kind === "composite") {
	                    var ref = bucket.textSizeData;
	                    var minZoom = ref.minZoom;
	                    var maxZoom = ref.maxZoom;
	                    sizes.compositeTextSizes = [
	                      unevaluatedLayoutValues["text-size"].possiblyEvaluate(new EvaluationParameters(minZoom), canonical),
	                      unevaluatedLayoutValues["text-size"].possiblyEvaluate(new EvaluationParameters(maxZoom), canonical)
	                    ];
	                  }
	                  if (bucket.iconSizeData.kind === "composite") {
	                    var ref$1 = bucket.iconSizeData;
	                    var minZoom$1 = ref$1.minZoom;
	                    var maxZoom$1 = ref$1.maxZoom;
	                    sizes.compositeIconSizes = [
	                      unevaluatedLayoutValues["icon-size"].possiblyEvaluate(new EvaluationParameters(minZoom$1), canonical),
	                      unevaluatedLayoutValues["icon-size"].possiblyEvaluate(new EvaluationParameters(maxZoom$1), canonical)
	                    ];
	                  }
	                  sizes.layoutTextSize = unevaluatedLayoutValues["text-size"].possiblyEvaluate(new EvaluationParameters(bucket.zoom + 1), canonical);
	                  sizes.layoutIconSize = unevaluatedLayoutValues["icon-size"].possiblyEvaluate(new EvaluationParameters(bucket.zoom + 1), canonical);
	                  sizes.textMaxSize = unevaluatedLayoutValues["text-size"].possiblyEvaluate(new EvaluationParameters(18));
	                  var lineHeight = layout2.get("text-line-height") * ONE_EM;
	                  var textAlongLine = layout2.get("text-rotation-alignment") === "map" && layout2.get("symbol-placement") !== "point";
	                  var keepUpright = layout2.get("text-keep-upright");
	                  var textSize = layout2.get("text-size");
	                  var loop = function() {
	                    var feature = list[i$1];
	                    var fontstack = layout2.get("text-font").evaluate(feature, {}, canonical).join(",");
	                    var layoutTextSizeThisZoom = textSize.evaluate(feature, {}, canonical);
	                    var layoutTextSize = sizes.layoutTextSize.evaluate(feature, {}, canonical);
	                    var layoutIconSize = sizes.layoutIconSize.evaluate(feature, {}, canonical);
	                    var shapedTextOrientations = {
	                      horizontal: {},
	                      vertical: undefined
	                    };
	                    var text = feature.text;
	                    var textOffset = [
	                      0,
	                      0
	                    ];
	                    if (text) {
	                      var unformattedText = text.toString();
	                      var spacing = layout2.get("text-letter-spacing").evaluate(feature, {}, canonical) * ONE_EM;
	                      var spacingIfAllowed = allowsLetterSpacing(unformattedText) ? spacing : 0;
	                      var textAnchor = layout2.get("text-anchor").evaluate(feature, {}, canonical);
	                      var variableTextAnchor = layout2.get("text-variable-anchor");
	                      if (!variableTextAnchor) {
	                        var radialOffset = layout2.get("text-radial-offset").evaluate(feature, {}, canonical);
	                        if (radialOffset) {
	                          textOffset = evaluateVariableOffset(textAnchor, [
	                            radialOffset * ONE_EM,
	                            INVALID_TEXT_OFFSET
	                          ]);
	                        } else {
	                          textOffset = layout2.get("text-offset").evaluate(feature, {}, canonical).map(function(t) {
	                            return t * ONE_EM;
	                          });
	                        }
	                      }
	                      var textJustify = textAlongLine ? "center" : layout2.get("text-justify").evaluate(feature, {}, canonical);
	                      var symbolPlacement = layout2.get("symbol-placement");
	                      var maxWidth = symbolPlacement === "point" ? layout2.get("text-max-width").evaluate(feature, {}, canonical) * ONE_EM : 0;
	                      var addVerticalShapingForPointLabelIfNeeded = function() {
	                        if (bucket.allowVerticalPlacement && allowsVerticalWritingMode(unformattedText)) {
	                          shapedTextOrientations.vertical = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, textAnchor, "left", spacingIfAllowed, textOffset, WritingMode.vertical, true, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
	                        }
	                      };
	                      if (!textAlongLine && variableTextAnchor) {
	                        var justifications = textJustify === "auto" ? variableTextAnchor.map(function(a) {
	                          return getAnchorJustification(a);
	                        }) : [textJustify];
	                        var singleLine = false;
	                        for (var i = 0; i < justifications.length; i++) {
	                          var justification = justifications[i];
	                          if (shapedTextOrientations.horizontal[justification]) {
	                            continue;
	                          }
	                          if (singleLine) {
	                            shapedTextOrientations.horizontal[justification] = shapedTextOrientations.horizontal[0];
	                          } else {
	                            var shaping = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, "center", justification, spacingIfAllowed, textOffset, WritingMode.horizontal, false, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
	                            if (shaping) {
	                              shapedTextOrientations.horizontal[justification] = shaping;
	                              singleLine = shaping.positionedLines.length === 1;
	                            }
	                          }
	                        }
	                        addVerticalShapingForPointLabelIfNeeded();
	                      } else {
	                        if (textJustify === "auto") {
	                          textJustify = getAnchorJustification(textAnchor);
	                        }
	                        var shaping$1 = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, textAnchor, textJustify, spacingIfAllowed, textOffset, WritingMode.horizontal, false, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
	                        if (shaping$1) {
	                          shapedTextOrientations.horizontal[textJustify] = shaping$1;
	                        }
	                        addVerticalShapingForPointLabelIfNeeded();
	                        if (allowsVerticalWritingMode(unformattedText) && textAlongLine && keepUpright) {
	                          shapedTextOrientations.vertical = shapeText(text, glyphMap, glyphPositions, imagePositions, fontstack, maxWidth, lineHeight, textAnchor, textJustify, spacingIfAllowed, textOffset, WritingMode.vertical, false, symbolPlacement, layoutTextSize, layoutTextSizeThisZoom);
	                        }
	                      }
	                    }
	                    var shapedIcon = undefined;
	                    var isSDFIcon = false;
	                    if (feature.icon && feature.icon.name) {
	                      var image = imageMap[feature.icon.name];
	                      if (image) {
	                        shapedIcon = shapeIcon(imagePositions[feature.icon.name], layout2.get("icon-offset").evaluate(feature, {}, canonical), layout2.get("icon-anchor").evaluate(feature, {}, canonical));
	                        isSDFIcon = image.sdf;
	                        if (bucket.sdfIcons === undefined) {
	                          bucket.sdfIcons = image.sdf;
	                        } else if (bucket.sdfIcons !== image.sdf) {
	                          warnOnce("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer");
	                        }
	                        if (image.pixelRatio !== bucket.pixelRatio) {
	                          bucket.iconsNeedLinear = true;
	                        } else if (layout2.get("icon-rotate").constantOr(1) !== 0) {
	                          bucket.iconsNeedLinear = true;
	                        }
	                      }
	                    }
	                    var shapedText = getDefaultHorizontalShaping(shapedTextOrientations.horizontal) || shapedTextOrientations.vertical;
	                    bucket.iconsInText = shapedText ? shapedText.iconsInText : false;
	                    if (shapedText || shapedIcon) {
	                      addFeature(bucket, feature, shapedTextOrientations, shapedIcon, imageMap, sizes, layoutTextSize, layoutIconSize, textOffset, isSDFIcon, canonical);
	                    }
	                  };
	                  for (var i$1 = 0, list = bucket.features; i$1 < list.length; i$1 += 1)
	                    loop();
	                  if (showCollisionBoxes) {
	                    bucket.generateCollisionDebugBuffers();
	                  }
	                }
	                function getAnchorJustification(anchor) {
	                  switch (anchor) {
	                    case "right":
	                    case "top-right":
	                    case "bottom-right":
	                      return "right";
	                    case "left":
	                    case "top-left":
	                    case "bottom-left":
	                      return "left";
	                  }
	                  return "center";
	                }
	                function addFeature(bucket, feature, shapedTextOrientations, shapedIcon, imageMap, sizes, layoutTextSize, layoutIconSize, textOffset, isSDFIcon, canonical) {
	                  var textMaxSize = sizes.textMaxSize.evaluate(feature, {});
	                  if (textMaxSize === undefined) {
	                    textMaxSize = layoutTextSize;
	                  }
	                  var layout2 = bucket.layers[0].layout;
	                  var iconOffset = layout2.get("icon-offset").evaluate(feature, {}, canonical);
	                  var defaultHorizontalShaping = getDefaultHorizontalShaping(shapedTextOrientations.horizontal);
	                  var glyphSize = 24, fontScale = layoutTextSize / glyphSize, textBoxScale = bucket.tilePixelRatio * fontScale, textMaxBoxScale = bucket.tilePixelRatio * textMaxSize / glyphSize, iconBoxScale = bucket.tilePixelRatio * layoutIconSize, symbolMinDistance = bucket.tilePixelRatio * layout2.get("symbol-spacing"), textPadding = layout2.get("text-padding") * bucket.tilePixelRatio, iconPadding = layout2.get("icon-padding") * bucket.tilePixelRatio, textMaxAngle = layout2.get("text-max-angle") / 180 * Math.PI, textAlongLine = layout2.get("text-rotation-alignment") === "map" && layout2.get("symbol-placement") !== "point", iconAlongLine = layout2.get("icon-rotation-alignment") === "map" && layout2.get("symbol-placement") !== "point", symbolPlacement = layout2.get("symbol-placement"), textRepeatDistance = symbolMinDistance / 2;
	                  var iconTextFit = layout2.get("icon-text-fit");
	                  var verticallyShapedIcon;
	                  if (shapedIcon && iconTextFit !== "none") {
	                    if (bucket.allowVerticalPlacement && shapedTextOrientations.vertical) {
	                      verticallyShapedIcon = fitIconToText(shapedIcon, shapedTextOrientations.vertical, iconTextFit, layout2.get("icon-text-fit-padding"), iconOffset, fontScale);
	                    }
	                    if (defaultHorizontalShaping) {
	                      shapedIcon = fitIconToText(shapedIcon, defaultHorizontalShaping, iconTextFit, layout2.get("icon-text-fit-padding"), iconOffset, fontScale);
	                    }
	                  }
	                  var addSymbolAtAnchor = function(line2, anchor2) {
	                    if (anchor2.x < 0 || anchor2.x >= EXTENT$1 || anchor2.y < 0 || anchor2.y >= EXTENT$1) {
	                      return;
	                    }
	                    addSymbol(bucket, anchor2, line2, shapedTextOrientations, shapedIcon, imageMap, verticallyShapedIcon, bucket.layers[0], bucket.collisionBoxArray, feature.index, feature.sourceLayerIndex, bucket.index, textBoxScale, textPadding, textAlongLine, textOffset, iconBoxScale, iconPadding, iconAlongLine, iconOffset, feature, sizes, isSDFIcon, canonical, layoutTextSize);
	                  };
	                  if (symbolPlacement === "line") {
	                    for (var i$1 = 0, list$1 = clipLine(feature.geometry, 0, 0, EXTENT$1, EXTENT$1); i$1 < list$1.length; i$1 += 1) {
	                      var line = list$1[i$1];
	                      var anchors = getAnchors(line, symbolMinDistance, textMaxAngle, shapedTextOrientations.vertical || defaultHorizontalShaping, shapedIcon, glyphSize, textMaxBoxScale, bucket.overscaling, EXTENT$1);
	                      for (var i = 0, list = anchors; i < list.length; i += 1) {
	                        var anchor = list[i];
	                        var shapedText = defaultHorizontalShaping;
	                        if (!shapedText || !anchorIsTooClose(bucket, shapedText.text, textRepeatDistance, anchor)) {
	                          addSymbolAtAnchor(line, anchor);
	                        }
	                      }
	                    }
	                  } else if (symbolPlacement === "line-center") {
	                    for (var i$2 = 0, list$2 = feature.geometry; i$2 < list$2.length; i$2 += 1) {
	                      var line$1 = list$2[i$2];
	                      if (line$1.length > 1) {
	                        var anchor$1 = getCenterAnchor(line$1, textMaxAngle, shapedTextOrientations.vertical || defaultHorizontalShaping, shapedIcon, glyphSize, textMaxBoxScale);
	                        if (anchor$1) {
	                          addSymbolAtAnchor(line$1, anchor$1);
	                        }
	                      }
	                    }
	                  } else if (feature.type === "Polygon") {
	                    for (var i$3 = 0, list$3 = classifyRings(feature.geometry, 0); i$3 < list$3.length; i$3 += 1) {
	                      var polygon = list$3[i$3];
	                      var poi = findPoleOfInaccessibility(polygon, 16);
	                      addSymbolAtAnchor(polygon[0], new Anchor(poi.x, poi.y, 0));
	                    }
	                  } else if (feature.type === "LineString") {
	                    for (var i$4 = 0, list$4 = feature.geometry; i$4 < list$4.length; i$4 += 1) {
	                      var line$2 = list$4[i$4];
	                      addSymbolAtAnchor(line$2, new Anchor(line$2[0].x, line$2[0].y, 0));
	                    }
	                  } else if (feature.type === "Point") {
	                    for (var i$6 = 0, list$6 = feature.geometry; i$6 < list$6.length; i$6 += 1) {
	                      var points = list$6[i$6];
	                      for (var i$5 = 0, list$5 = points; i$5 < list$5.length; i$5 += 1) {
	                        var point = list$5[i$5];
	                        addSymbolAtAnchor([point], new Anchor(point.x, point.y, 0));
	                      }
	                    }
	                  }
	                }
	                var MAX_GLYPH_ICON_SIZE = 255;
	                var MAX_PACKED_SIZE = MAX_GLYPH_ICON_SIZE * SIZE_PACK_FACTOR;
	                function addTextVertices(bucket, anchor, shapedText, imageMap, layer2, textAlongLine, feature, textOffset, lineArray, writingMode, placementTypes, placedTextSymbolIndices, placedIconIndex, sizes, canonical) {
	                  var glyphQuads = getGlyphQuads(anchor, shapedText, textOffset, layer2, textAlongLine, feature, imageMap, bucket.allowVerticalPlacement);
	                  var sizeData = bucket.textSizeData;
	                  var textSizeData = null;
	                  if (sizeData.kind === "source") {
	                    textSizeData = [SIZE_PACK_FACTOR * layer2.layout.get("text-size").evaluate(feature, {})];
	                    if (textSizeData[0] > MAX_PACKED_SIZE) {
	                      warnOnce(bucket.layerIds[0] + ': Value for "text-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "text-size".');
	                    }
	                  } else if (sizeData.kind === "composite") {
	                    textSizeData = [
	                      SIZE_PACK_FACTOR * sizes.compositeTextSizes[0].evaluate(feature, {}, canonical),
	                      SIZE_PACK_FACTOR * sizes.compositeTextSizes[1].evaluate(feature, {}, canonical)
	                    ];
	                    if (textSizeData[0] > MAX_PACKED_SIZE || textSizeData[1] > MAX_PACKED_SIZE) {
	                      warnOnce(bucket.layerIds[0] + ': Value for "text-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "text-size".');
	                    }
	                  }
	                  bucket.addSymbols(bucket.text, glyphQuads, textSizeData, textOffset, textAlongLine, feature, writingMode, anchor, lineArray.lineStartIndex, lineArray.lineLength, placedIconIndex, canonical);
	                  for (var i = 0, list = placementTypes; i < list.length; i += 1) {
	                    var placementType = list[i];
	                    placedTextSymbolIndices[placementType] = bucket.text.placedSymbolArray.length - 1;
	                  }
	                  return glyphQuads.length * 4;
	                }
	                function getDefaultHorizontalShaping(horizontalShaping) {
	                  for (var justification in horizontalShaping) {
	                    return horizontalShaping[justification];
	                  }
	                  return null;
	                }
	                function addSymbol(bucket, anchor, line, shapedTextOrientations, shapedIcon, imageMap, verticallyShapedIcon, layer2, collisionBoxArray, featureIndex, sourceLayerIndex, bucketIndex, textBoxScale, textPadding, textAlongLine, textOffset, iconBoxScale, iconPadding, iconAlongLine, iconOffset, feature, sizes, isSDFIcon, canonical, layoutTextSize) {
	                  var assign;
	                  var lineArray = bucket.addToLineVertexArray(anchor, line);
	                  var textCollisionFeature, iconCollisionFeature, verticalTextCollisionFeature, verticalIconCollisionFeature;
	                  var numIconVertices = 0;
	                  var numVerticalIconVertices = 0;
	                  var numHorizontalGlyphVertices = 0;
	                  var numVerticalGlyphVertices = 0;
	                  var placedIconSymbolIndex = -1;
	                  var verticalPlacedIconSymbolIndex = -1;
	                  var placedTextSymbolIndices = {};
	                  var key = murmurhashJs("");
	                  var textOffset0 = 0;
	                  var textOffset1 = 0;
	                  if (layer2._unevaluatedLayout.getValue("text-radial-offset") === undefined) {
	                    assign = layer2.layout.get("text-offset").evaluate(feature, {}, canonical).map(function(t) {
	                      return t * ONE_EM;
	                    }), textOffset0 = assign[0], textOffset1 = assign[1];
	                  } else {
	                    textOffset0 = layer2.layout.get("text-radial-offset").evaluate(feature, {}, canonical) * ONE_EM;
	                    textOffset1 = INVALID_TEXT_OFFSET;
	                  }
	                  if (bucket.allowVerticalPlacement && shapedTextOrientations.vertical) {
	                    var textRotation = layer2.layout.get("text-rotate").evaluate(feature, {}, canonical);
	                    var verticalTextRotation = textRotation + 90;
	                    var verticalShaping = shapedTextOrientations.vertical;
	                    verticalTextCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, verticalShaping, textBoxScale, textPadding, textAlongLine, verticalTextRotation);
	                    if (verticallyShapedIcon) {
	                      verticalIconCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, verticallyShapedIcon, iconBoxScale, iconPadding, textAlongLine, verticalTextRotation);
	                    }
	                  }
	                  if (shapedIcon) {
	                    var iconRotate = layer2.layout.get("icon-rotate").evaluate(feature, {});
	                    var hasIconTextFit = layer2.layout.get("icon-text-fit") !== "none";
	                    var iconQuads = getIconQuads(shapedIcon, iconRotate, isSDFIcon, hasIconTextFit);
	                    var verticalIconQuads = verticallyShapedIcon ? getIconQuads(verticallyShapedIcon, iconRotate, isSDFIcon, hasIconTextFit) : undefined;
	                    iconCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shapedIcon, iconBoxScale, iconPadding, false, iconRotate);
	                    numIconVertices = iconQuads.length * 4;
	                    var sizeData = bucket.iconSizeData;
	                    var iconSizeData = null;
	                    if (sizeData.kind === "source") {
	                      iconSizeData = [SIZE_PACK_FACTOR * layer2.layout.get("icon-size").evaluate(feature, {})];
	                      if (iconSizeData[0] > MAX_PACKED_SIZE) {
	                        warnOnce(bucket.layerIds[0] + ': Value for "icon-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "icon-size".');
	                      }
	                    } else if (sizeData.kind === "composite") {
	                      iconSizeData = [
	                        SIZE_PACK_FACTOR * sizes.compositeIconSizes[0].evaluate(feature, {}, canonical),
	                        SIZE_PACK_FACTOR * sizes.compositeIconSizes[1].evaluate(feature, {}, canonical)
	                      ];
	                      if (iconSizeData[0] > MAX_PACKED_SIZE || iconSizeData[1] > MAX_PACKED_SIZE) {
	                        warnOnce(bucket.layerIds[0] + ': Value for "icon-size" is >= ' + MAX_GLYPH_ICON_SIZE + '. Reduce your "icon-size".');
	                      }
	                    }
	                    bucket.addSymbols(bucket.icon, iconQuads, iconSizeData, iconOffset, iconAlongLine, feature, false, anchor, lineArray.lineStartIndex, lineArray.lineLength, -1, canonical);
	                    placedIconSymbolIndex = bucket.icon.placedSymbolArray.length - 1;
	                    if (verticalIconQuads) {
	                      numVerticalIconVertices = verticalIconQuads.length * 4;
	                      bucket.addSymbols(bucket.icon, verticalIconQuads, iconSizeData, iconOffset, iconAlongLine, feature, WritingMode.vertical, anchor, lineArray.lineStartIndex, lineArray.lineLength, -1, canonical);
	                      verticalPlacedIconSymbolIndex = bucket.icon.placedSymbolArray.length - 1;
	                    }
	                  }
	                  for (var justification in shapedTextOrientations.horizontal) {
	                    var shaping = shapedTextOrientations.horizontal[justification];
	                    if (!textCollisionFeature) {
	                      key = murmurhashJs(shaping.text);
	                      var textRotate = layer2.layout.get("text-rotate").evaluate(feature, {}, canonical);
	                      textCollisionFeature = new CollisionFeature(collisionBoxArray, anchor, featureIndex, sourceLayerIndex, bucketIndex, shaping, textBoxScale, textPadding, textAlongLine, textRotate);
	                    }
	                    var singleLine = shaping.positionedLines.length === 1;
	                    numHorizontalGlyphVertices += addTextVertices(bucket, anchor, shaping, imageMap, layer2, textAlongLine, feature, textOffset, lineArray, shapedTextOrientations.vertical ? WritingMode.horizontal : WritingMode.horizontalOnly, singleLine ? Object.keys(shapedTextOrientations.horizontal) : [justification], placedTextSymbolIndices, placedIconSymbolIndex, sizes, canonical);
	                    if (singleLine) {
	                      break;
	                    }
	                  }
	                  if (shapedTextOrientations.vertical) {
	                    numVerticalGlyphVertices += addTextVertices(bucket, anchor, shapedTextOrientations.vertical, imageMap, layer2, textAlongLine, feature, textOffset, lineArray, WritingMode.vertical, ["vertical"], placedTextSymbolIndices, verticalPlacedIconSymbolIndex, sizes, canonical);
	                  }
	                  var textBoxStartIndex = textCollisionFeature ? textCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
	                  var textBoxEndIndex = textCollisionFeature ? textCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
	                  var verticalTextBoxStartIndex = verticalTextCollisionFeature ? verticalTextCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
	                  var verticalTextBoxEndIndex = verticalTextCollisionFeature ? verticalTextCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
	                  var iconBoxStartIndex = iconCollisionFeature ? iconCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
	                  var iconBoxEndIndex = iconCollisionFeature ? iconCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
	                  var verticalIconBoxStartIndex = verticalIconCollisionFeature ? verticalIconCollisionFeature.boxStartIndex : bucket.collisionBoxArray.length;
	                  var verticalIconBoxEndIndex = verticalIconCollisionFeature ? verticalIconCollisionFeature.boxEndIndex : bucket.collisionBoxArray.length;
	                  var collisionCircleDiameter = -1;
	                  var getCollisionCircleHeight = function(feature2, prevHeight) {
	                    if (feature2 && feature2.circleDiameter) {
	                      return Math.max(feature2.circleDiameter, prevHeight);
	                    }
	                    return prevHeight;
	                  };
	                  collisionCircleDiameter = getCollisionCircleHeight(textCollisionFeature, collisionCircleDiameter);
	                  collisionCircleDiameter = getCollisionCircleHeight(verticalTextCollisionFeature, collisionCircleDiameter);
	                  collisionCircleDiameter = getCollisionCircleHeight(iconCollisionFeature, collisionCircleDiameter);
	                  collisionCircleDiameter = getCollisionCircleHeight(verticalIconCollisionFeature, collisionCircleDiameter);
	                  var useRuntimeCollisionCircles = collisionCircleDiameter > -1 ? 1 : 0;
	                  if (useRuntimeCollisionCircles) {
	                    collisionCircleDiameter *= layoutTextSize / ONE_EM;
	                  }
	                  if (bucket.glyphOffsetArray.length >= SymbolBucket.MAX_GLYPHS) {
	                    warnOnce("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");
	                  }
	                  if (feature.sortKey !== undefined) {
	                    bucket.addToSortKeyRanges(bucket.symbolInstances.length, feature.sortKey);
	                  }
	                  bucket.symbolInstances.emplaceBack(anchor.x, anchor.y, placedTextSymbolIndices.right >= 0 ? placedTextSymbolIndices.right : -1, placedTextSymbolIndices.center >= 0 ? placedTextSymbolIndices.center : -1, placedTextSymbolIndices.left >= 0 ? placedTextSymbolIndices.left : -1, placedTextSymbolIndices.vertical || -1, placedIconSymbolIndex, verticalPlacedIconSymbolIndex, key, textBoxStartIndex, textBoxEndIndex, verticalTextBoxStartIndex, verticalTextBoxEndIndex, iconBoxStartIndex, iconBoxEndIndex, verticalIconBoxStartIndex, verticalIconBoxEndIndex, featureIndex, numHorizontalGlyphVertices, numVerticalGlyphVertices, numIconVertices, numVerticalIconVertices, useRuntimeCollisionCircles, 0, textBoxScale, textOffset0, textOffset1, collisionCircleDiameter);
	                }
	                function anchorIsTooClose(bucket, text, repeatDistance, anchor) {
	                  var compareText = bucket.compareText;
	                  if (!(text in compareText)) {
	                    compareText[text] = [];
	                  } else {
	                    var otherAnchors = compareText[text];
	                    for (var k = otherAnchors.length - 1; k >= 0; k--) {
	                      if (anchor.dist(otherAnchors[k]) < repeatDistance) {
	                        return true;
	                      }
	                    }
	                  }
	                  compareText[text].push(anchor);
	                  return false;
	                }
	                var vectorTileFeatureTypes$2 = vectorTile.VectorTileFeature.types;
	                var shaderOpacityAttributes = [{
	                  name: "a_fade_opacity",
	                  components: 1,
	                  type: "Uint8",
	                  offset: 0
	                }];
	                function addVertex$1(array2, anchorX, anchorY, ox, oy, tx, ty, sizeVertex, isSDF, pixelOffsetX, pixelOffsetY, minFontScaleX, minFontScaleY) {
	                  var aSizeX = sizeVertex ? Math.min(MAX_PACKED_SIZE, Math.round(sizeVertex[0])) : 0;
	                  var aSizeY = sizeVertex ? Math.min(MAX_PACKED_SIZE, Math.round(sizeVertex[1])) : 0;
	                  array2.emplaceBack(anchorX, anchorY, Math.round(ox * 32), Math.round(oy * 32), tx, ty, (aSizeX << 1) + (isSDF ? 1 : 0), aSizeY, pixelOffsetX * 16, pixelOffsetY * 16, minFontScaleX * 256, minFontScaleY * 256);
	                }
	                function addDynamicAttributes(dynamicLayoutVertexArray, p, angle) {
	                  dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
	                  dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
	                  dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
	                  dynamicLayoutVertexArray.emplaceBack(p.x, p.y, angle);
	                }
	                function containsRTLText(formattedText) {
	                  for (var i = 0, list = formattedText.sections; i < list.length; i += 1) {
	                    var section = list[i];
	                    if (stringContainsRTLText(section.text)) {
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                var SymbolBuffers = function SymbolBuffers2(programConfigurations) {
	                  this.layoutVertexArray = new StructArrayLayout4i4ui4i24();
	                  this.indexArray = new StructArrayLayout3ui6();
	                  this.programConfigurations = programConfigurations;
	                  this.segments = new SegmentVector();
	                  this.dynamicLayoutVertexArray = new StructArrayLayout3f12();
	                  this.opacityVertexArray = new StructArrayLayout1ul4();
	                  this.placedSymbolArray = new PlacedSymbolArray();
	                };
	                SymbolBuffers.prototype.isEmpty = function isEmpty2() {
	                  return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
	                };
	                SymbolBuffers.prototype.upload = function upload(context, dynamicIndexBuffer, upload$1, update) {
	                  if (this.isEmpty()) {
	                    return;
	                  }
	                  if (upload$1) {
	                    this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, symbolLayoutAttributes.members);
	                    this.indexBuffer = context.createIndexBuffer(this.indexArray, dynamicIndexBuffer);
	                    this.dynamicLayoutVertexBuffer = context.createVertexBuffer(this.dynamicLayoutVertexArray, dynamicLayoutAttributes.members, true);
	                    this.opacityVertexBuffer = context.createVertexBuffer(this.opacityVertexArray, shaderOpacityAttributes, true);
	                    this.opacityVertexBuffer.itemSize = 1;
	                  }
	                  if (upload$1 || update) {
	                    this.programConfigurations.upload(context);
	                  }
	                };
	                SymbolBuffers.prototype.destroy = function destroy() {
	                  if (!this.layoutVertexBuffer) {
	                    return;
	                  }
	                  this.layoutVertexBuffer.destroy();
	                  this.indexBuffer.destroy();
	                  this.programConfigurations.destroy();
	                  this.segments.destroy();
	                  this.dynamicLayoutVertexBuffer.destroy();
	                  this.opacityVertexBuffer.destroy();
	                };
	                register("SymbolBuffers", SymbolBuffers);
	                var CollisionBuffers = function CollisionBuffers2(LayoutArray, layoutAttributes, IndexArray) {
	                  this.layoutVertexArray = new LayoutArray();
	                  this.layoutAttributes = layoutAttributes;
	                  this.indexArray = new IndexArray();
	                  this.segments = new SegmentVector();
	                  this.collisionVertexArray = new StructArrayLayout2ub2f12();
	                };
	                CollisionBuffers.prototype.upload = function upload(context) {
	                  this.layoutVertexBuffer = context.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes);
	                  this.indexBuffer = context.createIndexBuffer(this.indexArray);
	                  this.collisionVertexBuffer = context.createVertexBuffer(this.collisionVertexArray, collisionVertexAttributes.members, true);
	                };
	                CollisionBuffers.prototype.destroy = function destroy() {
	                  if (!this.layoutVertexBuffer) {
	                    return;
	                  }
	                  this.layoutVertexBuffer.destroy();
	                  this.indexBuffer.destroy();
	                  this.segments.destroy();
	                  this.collisionVertexBuffer.destroy();
	                };
	                register("CollisionBuffers", CollisionBuffers);
	                var SymbolBucket = function SymbolBucket2(options) {
	                  this.collisionBoxArray = options.collisionBoxArray;
	                  this.zoom = options.zoom;
	                  this.overscaling = options.overscaling;
	                  this.layers = options.layers;
	                  this.layerIds = this.layers.map(function(layer3) {
	                    return layer3.id;
	                  });
	                  this.index = options.index;
	                  this.pixelRatio = options.pixelRatio;
	                  this.sourceLayerIndex = options.sourceLayerIndex;
	                  this.hasPattern = false;
	                  this.hasRTLText = false;
	                  this.sortKeyRanges = [];
	                  this.collisionCircleArray = [];
	                  this.placementInvProjMatrix = identity2([]);
	                  this.placementViewportMatrix = identity2([]);
	                  var layer2 = this.layers[0];
	                  var unevaluatedLayoutValues = layer2._unevaluatedLayout._values;
	                  this.textSizeData = getSizeData(this.zoom, unevaluatedLayoutValues["text-size"]);
	                  this.iconSizeData = getSizeData(this.zoom, unevaluatedLayoutValues["icon-size"]);
	                  var layout2 = this.layers[0].layout;
	                  var sortKey = layout2.get("symbol-sort-key");
	                  var zOrder2 = layout2.get("symbol-z-order");
	                  this.sortFeaturesByKey = zOrder2 !== "viewport-y" && sortKey.constantOr(1) !== undefined;
	                  var zOrderByViewportY = zOrder2 === "viewport-y" || zOrder2 === "auto" && !this.sortFeaturesByKey;
	                  this.sortFeaturesByY = zOrderByViewportY && (layout2.get("text-allow-overlap") || layout2.get("icon-allow-overlap") || layout2.get("text-ignore-placement") || layout2.get("icon-ignore-placement"));
	                  if (layout2.get("symbol-placement") === "point") {
	                    this.writingModes = layout2.get("text-writing-mode").map(function(wm) {
	                      return WritingMode[wm];
	                    });
	                  }
	                  this.stateDependentLayerIds = this.layers.filter(function(l) {
	                    return l.isStateDependent();
	                  }).map(function(l) {
	                    return l.id;
	                  });
	                  this.sourceID = options.sourceID;
	                };
	                SymbolBucket.prototype.createArrays = function createArrays() {
	                  this.text = new SymbolBuffers(new ProgramConfigurationSet(symbolLayoutAttributes.members, this.layers, this.zoom, function(property) {
	                    return /^text/.test(property);
	                  }));
	                  this.icon = new SymbolBuffers(new ProgramConfigurationSet(symbolLayoutAttributes.members, this.layers, this.zoom, function(property) {
	                    return /^icon/.test(property);
	                  }));
	                  this.glyphOffsetArray = new GlyphOffsetArray();
	                  this.lineVertexArray = new SymbolLineVertexArray();
	                  this.symbolInstances = new SymbolInstanceArray();
	                };
	                SymbolBucket.prototype.calculateGlyphDependencies = function calculateGlyphDependencies(text, stack, textAlongLine, allowVerticalPlacement, doesAllowVerticalWritingMode) {
	                  for (var i = 0; i < text.length; i++) {
	                    stack[text.charCodeAt(i)] = true;
	                    if ((textAlongLine || allowVerticalPlacement) && doesAllowVerticalWritingMode) {
	                      var verticalChar = verticalizedCharacterMap[text.charAt(i)];
	                      if (verticalChar) {
	                        stack[verticalChar.charCodeAt(0)] = true;
	                      }
	                    }
	                  }
	                };
	                SymbolBucket.prototype.populate = function populate(features, options, canonical) {
	                  var layer2 = this.layers[0];
	                  var layout2 = layer2.layout;
	                  var textFont = layout2.get("text-font");
	                  var textField = layout2.get("text-field");
	                  var iconImage = layout2.get("icon-image");
	                  var hasText = (textField.value.kind !== "constant" || textField.value.value instanceof Formatted && !textField.value.value.isEmpty() || textField.value.value.toString().length > 0) && (textFont.value.kind !== "constant" || textFont.value.value.length > 0);
	                  var hasIcon = iconImage.value.kind !== "constant" || !!iconImage.value.value || Object.keys(iconImage.parameters).length > 0;
	                  var symbolSortKey = layout2.get("symbol-sort-key");
	                  this.features = [];
	                  if (!hasText && !hasIcon) {
	                    return;
	                  }
	                  var icons = options.iconDependencies;
	                  var stacks = options.glyphDependencies;
	                  var availableImages = options.availableImages;
	                  var globalProperties = new EvaluationParameters(this.zoom);
	                  for (var i$1 = 0, list$1 = features; i$1 < list$1.length; i$1 += 1) {
	                    var ref = list$1[i$1];
	                    var feature = ref.feature;
	                    var id2 = ref.id;
	                    var index = ref.index;
	                    var sourceLayerIndex = ref.sourceLayerIndex;
	                    var needGeometry = layer2._featureFilter.needGeometry;
	                    var evaluationFeature = {
	                      type: feature.type,
	                      id: id2,
	                      properties: feature.properties,
	                      geometry: needGeometry ? loadGeometry(feature) : []
	                    };
	                    if (!layer2._featureFilter.filter(globalProperties, evaluationFeature, canonical)) {
	                      continue;
	                    }
	                    if (!needGeometry) {
	                      evaluationFeature.geometry = loadGeometry(feature);
	                    }
	                    var text = undefined;
	                    if (hasText) {
	                      var resolvedTokens = layer2.getValueAndResolveTokens("text-field", evaluationFeature, canonical, availableImages);
	                      var formattedText = Formatted.factory(resolvedTokens);
	                      if (containsRTLText(formattedText)) {
	                        this.hasRTLText = true;
	                      }
	                      if (!this.hasRTLText || getRTLTextPluginStatus() === "unavailable" || this.hasRTLText && plugin.isParsed()) {
	                        text = transformText$1(formattedText, layer2, evaluationFeature);
	                      }
	                    }
	                    var icon = undefined;
	                    if (hasIcon) {
	                      var resolvedTokens$1 = layer2.getValueAndResolveTokens("icon-image", evaluationFeature, canonical, availableImages);
	                      if (resolvedTokens$1 instanceof ResolvedImage) {
	                        icon = resolvedTokens$1;
	                      } else {
	                        icon = ResolvedImage.fromString(resolvedTokens$1);
	                      }
	                    }
	                    if (!text && !icon) {
	                      continue;
	                    }
	                    var sortKey = this.sortFeaturesByKey ? symbolSortKey.evaluate(evaluationFeature, {}, canonical) : undefined;
	                    var symbolFeature = {
	                      id: id2,
	                      text,
	                      icon,
	                      index,
	                      sourceLayerIndex,
	                      geometry: loadGeometry(feature),
	                      properties: feature.properties,
	                      type: vectorTileFeatureTypes$2[feature.type],
	                      sortKey
	                    };
	                    this.features.push(symbolFeature);
	                    if (icon) {
	                      icons[icon.name] = true;
	                    }
	                    if (text) {
	                      var fontStack = textFont.evaluate(evaluationFeature, {}, canonical).join(",");
	                      var textAlongLine = layout2.get("text-rotation-alignment") === "map" && layout2.get("symbol-placement") !== "point";
	                      this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(WritingMode.vertical) >= 0;
	                      for (var i = 0, list = text.sections; i < list.length; i += 1) {
	                        var section = list[i];
	                        if (!section.image) {
	                          var doesAllowVerticalWritingMode = allowsVerticalWritingMode(text.toString());
	                          var sectionFont = section.fontStack || fontStack;
	                          var sectionStack = stacks[sectionFont] = stacks[sectionFont] || {};
	                          this.calculateGlyphDependencies(section.text, sectionStack, textAlongLine, this.allowVerticalPlacement, doesAllowVerticalWritingMode);
	                        } else {
	                          icons[section.image.name] = true;
	                        }
	                      }
	                    }
	                  }
	                  if (layout2.get("symbol-placement") === "line") {
	                    this.features = mergeLines(this.features);
	                  }
	                  if (this.sortFeaturesByKey) {
	                    this.features.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                };
	                SymbolBucket.prototype.update = function update(states, vtLayer, imagePositions) {
	                  if (!this.stateDependentLayers.length) {
	                    return;
	                  }
	                  this.text.programConfigurations.updatePaintArrays(states, vtLayer, this.layers, imagePositions);
	                  this.icon.programConfigurations.updatePaintArrays(states, vtLayer, this.layers, imagePositions);
	                };
	                SymbolBucket.prototype.isEmpty = function isEmpty2() {
	                  return this.symbolInstances.length === 0 && !this.hasRTLText;
	                };
	                SymbolBucket.prototype.uploadPending = function uploadPending() {
	                  return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
	                };
	                SymbolBucket.prototype.upload = function upload(context) {
	                  if (!this.uploaded && this.hasDebugData()) {
	                    this.textCollisionBox.upload(context);
	                    this.iconCollisionBox.upload(context);
	                  }
	                  this.text.upload(context, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload);
	                  this.icon.upload(context, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload);
	                  this.uploaded = true;
	                };
	                SymbolBucket.prototype.destroyDebugData = function destroyDebugData() {
	                  this.textCollisionBox.destroy();
	                  this.iconCollisionBox.destroy();
	                };
	                SymbolBucket.prototype.destroy = function destroy() {
	                  this.text.destroy();
	                  this.icon.destroy();
	                  if (this.hasDebugData()) {
	                    this.destroyDebugData();
	                  }
	                };
	                SymbolBucket.prototype.addToLineVertexArray = function addToLineVertexArray(anchor, line) {
	                  var lineStartIndex = this.lineVertexArray.length;
	                  if (anchor.segment !== undefined) {
	                    var sumForwardLength = anchor.dist(line[anchor.segment + 1]);
	                    var sumBackwardLength = anchor.dist(line[anchor.segment]);
	                    var vertices = {};
	                    for (var i = anchor.segment + 1; i < line.length; i++) {
	                      vertices[i] = {
	                        x: line[i].x,
	                        y: line[i].y,
	                        tileUnitDistanceFromAnchor: sumForwardLength
	                      };
	                      if (i < line.length - 1) {
	                        sumForwardLength += line[i + 1].dist(line[i]);
	                      }
	                    }
	                    for (var i$1 = anchor.segment || 0; i$1 >= 0; i$1--) {
	                      vertices[i$1] = {
	                        x: line[i$1].x,
	                        y: line[i$1].y,
	                        tileUnitDistanceFromAnchor: sumBackwardLength
	                      };
	                      if (i$1 > 0) {
	                        sumBackwardLength += line[i$1 - 1].dist(line[i$1]);
	                      }
	                    }
	                    for (var i$2 = 0; i$2 < line.length; i$2++) {
	                      var vertex = vertices[i$2];
	                      this.lineVertexArray.emplaceBack(vertex.x, vertex.y, vertex.tileUnitDistanceFromAnchor);
	                    }
	                  }
	                  return {
	                    lineStartIndex,
	                    lineLength: this.lineVertexArray.length - lineStartIndex
	                  };
	                };
	                SymbolBucket.prototype.addSymbols = function addSymbols(arrays, quads, sizeVertex, lineOffset, alongLine, feature, writingMode, labelAnchor, lineStartIndex, lineLength, associatedIconIndex, canonical) {
	                  var indexArray = arrays.indexArray;
	                  var layoutVertexArray = arrays.layoutVertexArray;
	                  var segment = arrays.segments.prepareSegment(4 * quads.length, layoutVertexArray, indexArray, feature.sortKey);
	                  var glyphOffsetArrayStart = this.glyphOffsetArray.length;
	                  var vertexStartIndex = segment.vertexLength;
	                  var angle = this.allowVerticalPlacement && writingMode === WritingMode.vertical ? Math.PI / 2 : 0;
	                  var sections = feature.text && feature.text.sections;
	                  for (var i = 0; i < quads.length; i++) {
	                    var ref = quads[i];
	                    var tl = ref.tl;
	                    var tr = ref.tr;
	                    var bl = ref.bl;
	                    var br = ref.br;
	                    var tex = ref.tex;
	                    var pixelOffsetTL = ref.pixelOffsetTL;
	                    var pixelOffsetBR = ref.pixelOffsetBR;
	                    var minFontScaleX = ref.minFontScaleX;
	                    var minFontScaleY = ref.minFontScaleY;
	                    var glyphOffset2 = ref.glyphOffset;
	                    var isSDF = ref.isSDF;
	                    var sectionIndex = ref.sectionIndex;
	                    var index = segment.vertexLength;
	                    var y = glyphOffset2[1];
	                    addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, tl.x, y + tl.y, tex.x, tex.y, sizeVertex, isSDF, pixelOffsetTL.x, pixelOffsetTL.y, minFontScaleX, minFontScaleY);
	                    addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, tr.x, y + tr.y, tex.x + tex.w, tex.y, sizeVertex, isSDF, pixelOffsetBR.x, pixelOffsetTL.y, minFontScaleX, minFontScaleY);
	                    addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, bl.x, y + bl.y, tex.x, tex.y + tex.h, sizeVertex, isSDF, pixelOffsetTL.x, pixelOffsetBR.y, minFontScaleX, minFontScaleY);
	                    addVertex$1(layoutVertexArray, labelAnchor.x, labelAnchor.y, br.x, y + br.y, tex.x + tex.w, tex.y + tex.h, sizeVertex, isSDF, pixelOffsetBR.x, pixelOffsetBR.y, minFontScaleX, minFontScaleY);
	                    addDynamicAttributes(arrays.dynamicLayoutVertexArray, labelAnchor, angle);
	                    indexArray.emplaceBack(index, index + 1, index + 2);
	                    indexArray.emplaceBack(index + 1, index + 2, index + 3);
	                    segment.vertexLength += 4;
	                    segment.primitiveLength += 2;
	                    this.glyphOffsetArray.emplaceBack(glyphOffset2[0]);
	                    if (i === quads.length - 1 || sectionIndex !== quads[i + 1].sectionIndex) {
	                      arrays.programConfigurations.populatePaintArrays(layoutVertexArray.length, feature, feature.index, {}, canonical, sections && sections[sectionIndex]);
	                    }
	                  }
	                  arrays.placedSymbolArray.emplaceBack(labelAnchor.x, labelAnchor.y, glyphOffsetArrayStart, this.glyphOffsetArray.length - glyphOffsetArrayStart, vertexStartIndex, lineStartIndex, lineLength, labelAnchor.segment, sizeVertex ? sizeVertex[0] : 0, sizeVertex ? sizeVertex[1] : 0, lineOffset[0], lineOffset[1], writingMode, 0, false, 0, associatedIconIndex);
	                };
	                SymbolBucket.prototype._addCollisionDebugVertex = function _addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, point, anchorX, anchorY, extrude) {
	                  collisionVertexArray.emplaceBack(0, 0);
	                  return layoutVertexArray.emplaceBack(point.x, point.y, anchorX, anchorY, Math.round(extrude.x), Math.round(extrude.y));
	                };
	                SymbolBucket.prototype.addCollisionDebugVertices = function addCollisionDebugVertices(x1, y1, x2, y2, arrays, boxAnchorPoint, symbolInstance2) {
	                  var segment = arrays.segments.prepareSegment(4, arrays.layoutVertexArray, arrays.indexArray);
	                  var index = segment.vertexLength;
	                  var layoutVertexArray = arrays.layoutVertexArray;
	                  var collisionVertexArray = arrays.collisionVertexArray;
	                  var anchorX = symbolInstance2.anchorX;
	                  var anchorY = symbolInstance2.anchorY;
	                  this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x1, y1));
	                  this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x2, y1));
	                  this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x2, y2));
	                  this._addCollisionDebugVertex(layoutVertexArray, collisionVertexArray, boxAnchorPoint, anchorX, anchorY, new pointGeometry(x1, y2));
	                  segment.vertexLength += 4;
	                  var indexArray = arrays.indexArray;
	                  indexArray.emplaceBack(index, index + 1);
	                  indexArray.emplaceBack(index + 1, index + 2);
	                  indexArray.emplaceBack(index + 2, index + 3);
	                  indexArray.emplaceBack(index + 3, index);
	                  segment.primitiveLength += 4;
	                };
	                SymbolBucket.prototype.addDebugCollisionBoxes = function addDebugCollisionBoxes(startIndex, endIndex, symbolInstance2, isText) {
	                  for (var b = startIndex; b < endIndex; b++) {
	                    var box = this.collisionBoxArray.get(b);
	                    var x1 = box.x1;
	                    var y1 = box.y1;
	                    var x2 = box.x2;
	                    var y2 = box.y2;
	                    this.addCollisionDebugVertices(x1, y1, x2, y2, isText ? this.textCollisionBox : this.iconCollisionBox, box.anchorPoint, symbolInstance2);
	                  }
	                };
	                SymbolBucket.prototype.generateCollisionDebugBuffers = function generateCollisionDebugBuffers() {
	                  if (this.hasDebugData()) {
	                    this.destroyDebugData();
	                  }
	                  this.textCollisionBox = new CollisionBuffers(StructArrayLayout2i2i2i12, collisionBoxLayout.members, StructArrayLayout2ui4);
	                  this.iconCollisionBox = new CollisionBuffers(StructArrayLayout2i2i2i12, collisionBoxLayout.members, StructArrayLayout2ui4);
	                  for (var i = 0; i < this.symbolInstances.length; i++) {
	                    var symbolInstance2 = this.symbolInstances.get(i);
	                    this.addDebugCollisionBoxes(symbolInstance2.textBoxStartIndex, symbolInstance2.textBoxEndIndex, symbolInstance2, true);
	                    this.addDebugCollisionBoxes(symbolInstance2.verticalTextBoxStartIndex, symbolInstance2.verticalTextBoxEndIndex, symbolInstance2, true);
	                    this.addDebugCollisionBoxes(symbolInstance2.iconBoxStartIndex, symbolInstance2.iconBoxEndIndex, symbolInstance2, false);
	                    this.addDebugCollisionBoxes(symbolInstance2.verticalIconBoxStartIndex, symbolInstance2.verticalIconBoxEndIndex, symbolInstance2, false);
	                  }
	                };
	                SymbolBucket.prototype._deserializeCollisionBoxesForSymbol = function _deserializeCollisionBoxesForSymbol(collisionBoxArray, textStartIndex, textEndIndex, verticalTextStartIndex, verticalTextEndIndex, iconStartIndex, iconEndIndex, verticalIconStartIndex, verticalIconEndIndex) {
	                  var collisionArrays = {};
	                  for (var k = textStartIndex; k < textEndIndex; k++) {
	                    var box = collisionBoxArray.get(k);
	                    collisionArrays.textBox = {
	                      x1: box.x1,
	                      y1: box.y1,
	                      x2: box.x2,
	                      y2: box.y2,
	                      anchorPointX: box.anchorPointX,
	                      anchorPointY: box.anchorPointY
	                    };
	                    collisionArrays.textFeatureIndex = box.featureIndex;
	                    break;
	                  }
	                  for (var k$1 = verticalTextStartIndex; k$1 < verticalTextEndIndex; k$1++) {
	                    var box$1 = collisionBoxArray.get(k$1);
	                    collisionArrays.verticalTextBox = {
	                      x1: box$1.x1,
	                      y1: box$1.y1,
	                      x2: box$1.x2,
	                      y2: box$1.y2,
	                      anchorPointX: box$1.anchorPointX,
	                      anchorPointY: box$1.anchorPointY
	                    };
	                    collisionArrays.verticalTextFeatureIndex = box$1.featureIndex;
	                    break;
	                  }
	                  for (var k$2 = iconStartIndex; k$2 < iconEndIndex; k$2++) {
	                    var box$2 = collisionBoxArray.get(k$2);
	                    collisionArrays.iconBox = {
	                      x1: box$2.x1,
	                      y1: box$2.y1,
	                      x2: box$2.x2,
	                      y2: box$2.y2,
	                      anchorPointX: box$2.anchorPointX,
	                      anchorPointY: box$2.anchorPointY
	                    };
	                    collisionArrays.iconFeatureIndex = box$2.featureIndex;
	                    break;
	                  }
	                  for (var k$3 = verticalIconStartIndex; k$3 < verticalIconEndIndex; k$3++) {
	                    var box$3 = collisionBoxArray.get(k$3);
	                    collisionArrays.verticalIconBox = {
	                      x1: box$3.x1,
	                      y1: box$3.y1,
	                      x2: box$3.x2,
	                      y2: box$3.y2,
	                      anchorPointX: box$3.anchorPointX,
	                      anchorPointY: box$3.anchorPointY
	                    };
	                    collisionArrays.verticalIconFeatureIndex = box$3.featureIndex;
	                    break;
	                  }
	                  return collisionArrays;
	                };
	                SymbolBucket.prototype.deserializeCollisionBoxes = function deserializeCollisionBoxes(collisionBoxArray) {
	                  this.collisionArrays = [];
	                  for (var i = 0; i < this.symbolInstances.length; i++) {
	                    var symbolInstance2 = this.symbolInstances.get(i);
	                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(collisionBoxArray, symbolInstance2.textBoxStartIndex, symbolInstance2.textBoxEndIndex, symbolInstance2.verticalTextBoxStartIndex, symbolInstance2.verticalTextBoxEndIndex, symbolInstance2.iconBoxStartIndex, symbolInstance2.iconBoxEndIndex, symbolInstance2.verticalIconBoxStartIndex, symbolInstance2.verticalIconBoxEndIndex));
	                  }
	                };
	                SymbolBucket.prototype.hasTextData = function hasTextData() {
	                  return this.text.segments.get().length > 0;
	                };
	                SymbolBucket.prototype.hasIconData = function hasIconData() {
	                  return this.icon.segments.get().length > 0;
	                };
	                SymbolBucket.prototype.hasDebugData = function hasDebugData() {
	                  return this.textCollisionBox && this.iconCollisionBox;
	                };
	                SymbolBucket.prototype.hasTextCollisionBoxData = function hasTextCollisionBoxData() {
	                  return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
	                };
	                SymbolBucket.prototype.hasIconCollisionBoxData = function hasIconCollisionBoxData() {
	                  return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
	                };
	                SymbolBucket.prototype.addIndicesForPlacedSymbol = function addIndicesForPlacedSymbol(iconOrText, placedSymbolIndex) {
	                  var placedSymbol = iconOrText.placedSymbolArray.get(placedSymbolIndex);
	                  var endIndex = placedSymbol.vertexStartIndex + placedSymbol.numGlyphs * 4;
	                  for (var vertexIndex = placedSymbol.vertexStartIndex; vertexIndex < endIndex; vertexIndex += 4) {
	                    iconOrText.indexArray.emplaceBack(vertexIndex, vertexIndex + 1, vertexIndex + 2);
	                    iconOrText.indexArray.emplaceBack(vertexIndex + 1, vertexIndex + 2, vertexIndex + 3);
	                  }
	                };
	                SymbolBucket.prototype.getSortedSymbolIndexes = function getSortedSymbolIndexes(angle) {
	                  if (this.sortedAngle === angle && this.symbolInstanceIndexes !== undefined) {
	                    return this.symbolInstanceIndexes;
	                  }
	                  var sin = Math.sin(angle);
	                  var cos = Math.cos(angle);
	                  var rotatedYs = [];
	                  var featureIndexes = [];
	                  var result = [];
	                  for (var i = 0; i < this.symbolInstances.length; ++i) {
	                    result.push(i);
	                    var symbolInstance2 = this.symbolInstances.get(i);
	                    rotatedYs.push(Math.round(sin * symbolInstance2.anchorX + cos * symbolInstance2.anchorY) | 0);
	                    featureIndexes.push(symbolInstance2.featureIndex);
	                  }
	                  result.sort(function(aIndex, bIndex) {
	                    return rotatedYs[aIndex] - rotatedYs[bIndex] || featureIndexes[bIndex] - featureIndexes[aIndex];
	                  });
	                  return result;
	                };
	                SymbolBucket.prototype.addToSortKeyRanges = function addToSortKeyRanges(symbolInstanceIndex, sortKey) {
	                  var last = this.sortKeyRanges[this.sortKeyRanges.length - 1];
	                  if (last && last.sortKey === sortKey) {
	                    last.symbolInstanceEnd = symbolInstanceIndex + 1;
	                  } else {
	                    this.sortKeyRanges.push({
	                      sortKey,
	                      symbolInstanceStart: symbolInstanceIndex,
	                      symbolInstanceEnd: symbolInstanceIndex + 1
	                    });
	                  }
	                };
	                SymbolBucket.prototype.sortFeatures = function sortFeatures(angle) {
	                  var this$1$1 = this;
	                  if (!this.sortFeaturesByY) {
	                    return;
	                  }
	                  if (this.sortedAngle === angle) {
	                    return;
	                  }
	                  if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1) {
	                    return;
	                  }
	                  this.symbolInstanceIndexes = this.getSortedSymbolIndexes(angle);
	                  this.sortedAngle = angle;
	                  this.text.indexArray.clear();
	                  this.icon.indexArray.clear();
	                  this.featureSortOrder = [];
	                  for (var i$1 = 0, list = this.symbolInstanceIndexes; i$1 < list.length; i$1 += 1) {
	                    var i = list[i$1];
	                    var symbolInstance2 = this.symbolInstances.get(i);
	                    this.featureSortOrder.push(symbolInstance2.featureIndex);
	                    [
	                      symbolInstance2.rightJustifiedTextSymbolIndex,
	                      symbolInstance2.centerJustifiedTextSymbolIndex,
	                      symbolInstance2.leftJustifiedTextSymbolIndex
	                    ].forEach(function(index, i2, array2) {
	                      if (index >= 0 && array2.indexOf(index) === i2) {
	                        this$1$1.addIndicesForPlacedSymbol(this$1$1.text, index);
	                      }
	                    });
	                    if (symbolInstance2.verticalPlacedTextSymbolIndex >= 0) {
	                      this.addIndicesForPlacedSymbol(this.text, symbolInstance2.verticalPlacedTextSymbolIndex);
	                    }
	                    if (symbolInstance2.placedIconSymbolIndex >= 0) {
	                      this.addIndicesForPlacedSymbol(this.icon, symbolInstance2.placedIconSymbolIndex);
	                    }
	                    if (symbolInstance2.verticalPlacedIconSymbolIndex >= 0) {
	                      this.addIndicesForPlacedSymbol(this.icon, symbolInstance2.verticalPlacedIconSymbolIndex);
	                    }
	                  }
	                  if (this.text.indexBuffer) {
	                    this.text.indexBuffer.updateData(this.text.indexArray);
	                  }
	                  if (this.icon.indexBuffer) {
	                    this.icon.indexBuffer.updateData(this.icon.indexArray);
	                  }
	                };
	                register("SymbolBucket", SymbolBucket, {
	                  omit: [
	                    "layers",
	                    "collisionBoxArray",
	                    "features",
	                    "compareText"
	                  ]
	                });
	                SymbolBucket.MAX_GLYPHS = 65535;
	                SymbolBucket.addDynamicAttributes = addDynamicAttributes;
	                function resolveTokens(properties2, text) {
	                  return text.replace(/{([^{}]+)}/g, function(match, key) {
	                    return key in properties2 ? String(properties2[key]) : "";
	                  });
	                }
	                var layout$7 = new Properties({
	                  "symbol-placement": new DataConstantProperty(spec["layout_symbol"]["symbol-placement"]),
	                  "symbol-spacing": new DataConstantProperty(spec["layout_symbol"]["symbol-spacing"]),
	                  "symbol-avoid-edges": new DataConstantProperty(spec["layout_symbol"]["symbol-avoid-edges"]),
	                  "symbol-sort-key": new DataDrivenProperty(spec["layout_symbol"]["symbol-sort-key"]),
	                  "symbol-z-order": new DataConstantProperty(spec["layout_symbol"]["symbol-z-order"]),
	                  "icon-allow-overlap": new DataConstantProperty(spec["layout_symbol"]["icon-allow-overlap"]),
	                  "icon-ignore-placement": new DataConstantProperty(spec["layout_symbol"]["icon-ignore-placement"]),
	                  "icon-optional": new DataConstantProperty(spec["layout_symbol"]["icon-optional"]),
	                  "icon-rotation-alignment": new DataConstantProperty(spec["layout_symbol"]["icon-rotation-alignment"]),
	                  "icon-size": new DataDrivenProperty(spec["layout_symbol"]["icon-size"]),
	                  "icon-text-fit": new DataConstantProperty(spec["layout_symbol"]["icon-text-fit"]),
	                  "icon-text-fit-padding": new DataConstantProperty(spec["layout_symbol"]["icon-text-fit-padding"]),
	                  "icon-image": new DataDrivenProperty(spec["layout_symbol"]["icon-image"]),
	                  "icon-rotate": new DataDrivenProperty(spec["layout_symbol"]["icon-rotate"]),
	                  "icon-padding": new DataConstantProperty(spec["layout_symbol"]["icon-padding"]),
	                  "icon-keep-upright": new DataConstantProperty(spec["layout_symbol"]["icon-keep-upright"]),
	                  "icon-offset": new DataDrivenProperty(spec["layout_symbol"]["icon-offset"]),
	                  "icon-anchor": new DataDrivenProperty(spec["layout_symbol"]["icon-anchor"]),
	                  "icon-pitch-alignment": new DataConstantProperty(spec["layout_symbol"]["icon-pitch-alignment"]),
	                  "text-pitch-alignment": new DataConstantProperty(spec["layout_symbol"]["text-pitch-alignment"]),
	                  "text-rotation-alignment": new DataConstantProperty(spec["layout_symbol"]["text-rotation-alignment"]),
	                  "text-field": new DataDrivenProperty(spec["layout_symbol"]["text-field"]),
	                  "text-font": new DataDrivenProperty(spec["layout_symbol"]["text-font"]),
	                  "text-size": new DataDrivenProperty(spec["layout_symbol"]["text-size"]),
	                  "text-max-width": new DataDrivenProperty(spec["layout_symbol"]["text-max-width"]),
	                  "text-line-height": new DataConstantProperty(spec["layout_symbol"]["text-line-height"]),
	                  "text-letter-spacing": new DataDrivenProperty(spec["layout_symbol"]["text-letter-spacing"]),
	                  "text-justify": new DataDrivenProperty(spec["layout_symbol"]["text-justify"]),
	                  "text-radial-offset": new DataDrivenProperty(spec["layout_symbol"]["text-radial-offset"]),
	                  "text-variable-anchor": new DataConstantProperty(spec["layout_symbol"]["text-variable-anchor"]),
	                  "text-anchor": new DataDrivenProperty(spec["layout_symbol"]["text-anchor"]),
	                  "text-max-angle": new DataConstantProperty(spec["layout_symbol"]["text-max-angle"]),
	                  "text-writing-mode": new DataConstantProperty(spec["layout_symbol"]["text-writing-mode"]),
	                  "text-rotate": new DataDrivenProperty(spec["layout_symbol"]["text-rotate"]),
	                  "text-padding": new DataConstantProperty(spec["layout_symbol"]["text-padding"]),
	                  "text-keep-upright": new DataConstantProperty(spec["layout_symbol"]["text-keep-upright"]),
	                  "text-transform": new DataDrivenProperty(spec["layout_symbol"]["text-transform"]),
	                  "text-offset": new DataDrivenProperty(spec["layout_symbol"]["text-offset"]),
	                  "text-allow-overlap": new DataConstantProperty(spec["layout_symbol"]["text-allow-overlap"]),
	                  "text-ignore-placement": new DataConstantProperty(spec["layout_symbol"]["text-ignore-placement"]),
	                  "text-optional": new DataConstantProperty(spec["layout_symbol"]["text-optional"])
	                });
	                var paint$7 = new Properties({
	                  "icon-opacity": new DataDrivenProperty(spec["paint_symbol"]["icon-opacity"]),
	                  "icon-color": new DataDrivenProperty(spec["paint_symbol"]["icon-color"]),
	                  "icon-halo-color": new DataDrivenProperty(spec["paint_symbol"]["icon-halo-color"]),
	                  "icon-halo-width": new DataDrivenProperty(spec["paint_symbol"]["icon-halo-width"]),
	                  "icon-halo-blur": new DataDrivenProperty(spec["paint_symbol"]["icon-halo-blur"]),
	                  "icon-translate": new DataConstantProperty(spec["paint_symbol"]["icon-translate"]),
	                  "icon-translate-anchor": new DataConstantProperty(spec["paint_symbol"]["icon-translate-anchor"]),
	                  "text-opacity": new DataDrivenProperty(spec["paint_symbol"]["text-opacity"]),
	                  "text-color": new DataDrivenProperty(spec["paint_symbol"]["text-color"], {
	                    runtimeType: ColorType,
	                    getOverride: function(o) {
	                      return o.textColor;
	                    },
	                    hasOverride: function(o) {
	                      return !!o.textColor;
	                    }
	                  }),
	                  "text-halo-color": new DataDrivenProperty(spec["paint_symbol"]["text-halo-color"]),
	                  "text-halo-width": new DataDrivenProperty(spec["paint_symbol"]["text-halo-width"]),
	                  "text-halo-blur": new DataDrivenProperty(spec["paint_symbol"]["text-halo-blur"]),
	                  "text-translate": new DataConstantProperty(spec["paint_symbol"]["text-translate"]),
	                  "text-translate-anchor": new DataConstantProperty(spec["paint_symbol"]["text-translate-anchor"])
	                });
	                var properties$6 = {
	                  paint: paint$7,
	                  layout: layout$7
	                };
	                var FormatSectionOverride = function FormatSectionOverride2(defaultValue) {
	                  this.type = defaultValue.property.overrides ? defaultValue.property.overrides.runtimeType : NullType;
	                  this.defaultValue = defaultValue;
	                };
	                FormatSectionOverride.prototype.evaluate = function evaluate(ctx) {
	                  if (ctx.formattedSection) {
	                    var overrides = this.defaultValue.property.overrides;
	                    if (overrides && overrides.hasOverride(ctx.formattedSection)) {
	                      return overrides.getOverride(ctx.formattedSection);
	                    }
	                  }
	                  if (ctx.feature && ctx.featureState) {
	                    return this.defaultValue.evaluate(ctx.feature, ctx.featureState);
	                  }
	                  return this.defaultValue.property.specification.default;
	                };
	                FormatSectionOverride.prototype.eachChild = function eachChild(fn) {
	                  if (!this.defaultValue.isConstant()) {
	                    var expr = this.defaultValue.value;
	                    fn(expr._styleExpression.expression);
	                  }
	                };
	                FormatSectionOverride.prototype.outputDefined = function outputDefined() {
	                  return false;
	                };
	                FormatSectionOverride.prototype.serialize = function serialize2() {
	                  return null;
	                };
	                register("FormatSectionOverride", FormatSectionOverride, { omit: ["defaultValue"] });
	                var SymbolStyleLayer = function(StyleLayer2) {
	                  function SymbolStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$6);
	                  }
	                  SymbolStyleLayer2.__proto__ = StyleLayer2;
	                  SymbolStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  SymbolStyleLayer2.prototype.constructor = SymbolStyleLayer2;
	                  SymbolStyleLayer2.prototype.recalculate = function recalculate(parameters, availableImages) {
	                    StyleLayer2.prototype.recalculate.call(this, parameters, availableImages);
	                    if (this.layout.get("icon-rotation-alignment") === "auto") {
	                      if (this.layout.get("symbol-placement") !== "point") {
	                        this.layout._values["icon-rotation-alignment"] = "map";
	                      } else {
	                        this.layout._values["icon-rotation-alignment"] = "viewport";
	                      }
	                    }
	                    if (this.layout.get("text-rotation-alignment") === "auto") {
	                      if (this.layout.get("symbol-placement") !== "point") {
	                        this.layout._values["text-rotation-alignment"] = "map";
	                      } else {
	                        this.layout._values["text-rotation-alignment"] = "viewport";
	                      }
	                    }
	                    if (this.layout.get("text-pitch-alignment") === "auto") {
	                      this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment");
	                    }
	                    if (this.layout.get("icon-pitch-alignment") === "auto") {
	                      this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment");
	                    }
	                    if (this.layout.get("symbol-placement") === "point") {
	                      var writingModes = this.layout.get("text-writing-mode");
	                      if (writingModes) {
	                        var deduped = [];
	                        for (var i = 0, list = writingModes; i < list.length; i += 1) {
	                          var m = list[i];
	                          if (deduped.indexOf(m) < 0) {
	                            deduped.push(m);
	                          }
	                        }
	                        this.layout._values["text-writing-mode"] = deduped;
	                      } else {
	                        this.layout._values["text-writing-mode"] = ["horizontal"];
	                      }
	                    }
	                    this._setPaintOverrides();
	                  };
	                  SymbolStyleLayer2.prototype.getValueAndResolveTokens = function getValueAndResolveTokens(name3, feature, canonical, availableImages) {
	                    var value = this.layout.get(name3).evaluate(feature, {}, canonical, availableImages);
	                    var unevaluated = this._unevaluatedLayout._values[name3];
	                    if (!unevaluated.isDataDriven() && !isExpression(unevaluated.value) && value) {
	                      return resolveTokens(feature.properties, value);
	                    }
	                    return value;
	                  };
	                  SymbolStyleLayer2.prototype.createBucket = function createBucket(parameters) {
	                    return new SymbolBucket(parameters);
	                  };
	                  SymbolStyleLayer2.prototype.queryRadius = function queryRadius() {
	                    return 0;
	                  };
	                  SymbolStyleLayer2.prototype.queryIntersectsFeature = function queryIntersectsFeature() {
	                    return false;
	                  };
	                  SymbolStyleLayer2.prototype._setPaintOverrides = function _setPaintOverrides() {
	                    for (var i = 0, list = properties$6.paint.overridableProperties; i < list.length; i += 1) {
	                      var overridable = list[i];
	                      if (!SymbolStyleLayer2.hasPaintOverride(this.layout, overridable)) {
	                        continue;
	                      }
	                      var overriden = this.paint.get(overridable);
	                      var override = new FormatSectionOverride(overriden);
	                      var styleExpression = new StyleExpression(override, overriden.property.specification);
	                      var expression2 = null;
	                      if (overriden.value.kind === "constant" || overriden.value.kind === "source") {
	                        expression2 = new ZoomConstantExpression("source", styleExpression);
	                      } else {
	                        expression2 = new ZoomDependentExpression("composite", styleExpression, overriden.value.zoomStops, overriden.value._interpolationType);
	                      }
	                      this.paint._values[overridable] = new PossiblyEvaluatedPropertyValue(overriden.property, expression2, overriden.parameters);
	                    }
	                  };
	                  SymbolStyleLayer2.prototype._handleOverridablePaintPropertyUpdate = function _handleOverridablePaintPropertyUpdate(name3, oldValue, newValue) {
	                    if (!this.layout || oldValue.isDataDriven() || newValue.isDataDriven()) {
	                      return false;
	                    }
	                    return SymbolStyleLayer2.hasPaintOverride(this.layout, name3);
	                  };
	                  SymbolStyleLayer2.hasPaintOverride = function hasPaintOverride(layout2, propertyName) {
	                    var textField = layout2.get("text-field");
	                    var property = properties$6.paint.properties[propertyName];
	                    var hasOverrides = false;
	                    var checkSections = function(sections) {
	                      for (var i = 0, list = sections; i < list.length; i += 1) {
	                        var section = list[i];
	                        if (property.overrides && property.overrides.hasOverride(section)) {
	                          hasOverrides = true;
	                          return;
	                        }
	                      }
	                    };
	                    if (textField.value.kind === "constant" && textField.value.value instanceof Formatted) {
	                      checkSections(textField.value.value.sections);
	                    } else if (textField.value.kind === "source") {
	                      var checkExpression = function(expression2) {
	                        if (hasOverrides) {
	                          return;
	                        }
	                        if (expression2 instanceof Literal && typeOf(expression2.value) === FormattedType) {
	                          var formatted = expression2.value;
	                          checkSections(formatted.sections);
	                        } else if (expression2 instanceof FormatExpression) {
	                          checkSections(expression2.sections);
	                        } else {
	                          expression2.eachChild(checkExpression);
	                        }
	                      };
	                      var expr = textField.value;
	                      if (expr._styleExpression) {
	                        checkExpression(expr._styleExpression.expression);
	                      }
	                    }
	                    return hasOverrides;
	                  };
	                  return SymbolStyleLayer2;
	                }(StyleLayer);
	                var paint$8 = new Properties({
	                  "background-color": new DataConstantProperty(spec["paint_background"]["background-color"]),
	                  "background-pattern": new CrossFadedProperty(spec["paint_background"]["background-pattern"]),
	                  "background-opacity": new DataConstantProperty(spec["paint_background"]["background-opacity"])
	                });
	                var properties$7 = { paint: paint$8 };
	                var BackgroundStyleLayer = function(StyleLayer2) {
	                  function BackgroundStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$7);
	                  }
	                  BackgroundStyleLayer2.__proto__ = StyleLayer2;
	                  BackgroundStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  BackgroundStyleLayer2.prototype.constructor = BackgroundStyleLayer2;
	                  return BackgroundStyleLayer2;
	                }(StyleLayer);
	                var paint$9 = new Properties({
	                  "raster-opacity": new DataConstantProperty(spec["paint_raster"]["raster-opacity"]),
	                  "raster-hue-rotate": new DataConstantProperty(spec["paint_raster"]["raster-hue-rotate"]),
	                  "raster-brightness-min": new DataConstantProperty(spec["paint_raster"]["raster-brightness-min"]),
	                  "raster-brightness-max": new DataConstantProperty(spec["paint_raster"]["raster-brightness-max"]),
	                  "raster-saturation": new DataConstantProperty(spec["paint_raster"]["raster-saturation"]),
	                  "raster-contrast": new DataConstantProperty(spec["paint_raster"]["raster-contrast"]),
	                  "raster-resampling": new DataConstantProperty(spec["paint_raster"]["raster-resampling"]),
	                  "raster-fade-duration": new DataConstantProperty(spec["paint_raster"]["raster-fade-duration"])
	                });
	                var properties$8 = { paint: paint$9 };
	                var RasterStyleLayer = function(StyleLayer2) {
	                  function RasterStyleLayer2(layer2) {
	                    StyleLayer2.call(this, layer2, properties$8);
	                  }
	                  RasterStyleLayer2.__proto__ = StyleLayer2;
	                  RasterStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  RasterStyleLayer2.prototype.constructor = RasterStyleLayer2;
	                  return RasterStyleLayer2;
	                }(StyleLayer);
	                function validateCustomStyleLayer(layerObject) {
	                  var errors = [];
	                  var id2 = layerObject.id;
	                  if (id2 === undefined) {
	                    errors.push({ message: "layers." + id2 + ': missing required property "id"' });
	                  }
	                  if (layerObject.render === undefined) {
	                    errors.push({ message: "layers." + id2 + ': missing required method "render"' });
	                  }
	                  if (layerObject.renderingMode && layerObject.renderingMode !== "2d" && layerObject.renderingMode !== "3d") {
	                    errors.push({ message: "layers." + id2 + ': property "renderingMode" must be either "2d" or "3d"' });
	                  }
	                  return errors;
	                }
	                var CustomStyleLayer = function(StyleLayer2) {
	                  function CustomStyleLayer2(implementation) {
	                    StyleLayer2.call(this, implementation, {});
	                    this.implementation = implementation;
	                  }
	                  CustomStyleLayer2.__proto__ = StyleLayer2;
	                  CustomStyleLayer2.prototype = Object.create(StyleLayer2.prototype);
	                  CustomStyleLayer2.prototype.constructor = CustomStyleLayer2;
	                  CustomStyleLayer2.prototype.is3D = function is3D() {
	                    return this.implementation.renderingMode === "3d";
	                  };
	                  CustomStyleLayer2.prototype.hasOffscreenPass = function hasOffscreenPass() {
	                    return this.implementation.prerender !== undefined;
	                  };
	                  CustomStyleLayer2.prototype.recalculate = function recalculate() {
	                  };
	                  CustomStyleLayer2.prototype.updateTransitions = function updateTransitions() {
	                  };
	                  CustomStyleLayer2.prototype.hasTransition = function hasTransition() {
	                  };
	                  CustomStyleLayer2.prototype.serialize = function serialize2() {
	                  };
	                  CustomStyleLayer2.prototype.onAdd = function onAdd(map2) {
	                    if (this.implementation.onAdd) {
	                      this.implementation.onAdd(map2, map2.painter.context.gl);
	                    }
	                  };
	                  CustomStyleLayer2.prototype.onRemove = function onRemove(map2) {
	                    if (this.implementation.onRemove) {
	                      this.implementation.onRemove(map2, map2.painter.context.gl);
	                    }
	                  };
	                  return CustomStyleLayer2;
	                }(StyleLayer);
	                var subclasses = {
	                  circle: CircleStyleLayer,
	                  heatmap: HeatmapStyleLayer,
	                  hillshade: HillshadeStyleLayer,
	                  fill: FillStyleLayer,
	                  "fill-extrusion": FillExtrusionStyleLayer,
	                  line: LineStyleLayer,
	                  symbol: SymbolStyleLayer,
	                  background: BackgroundStyleLayer,
	                  raster: RasterStyleLayer
	                };
	                function createStyleLayer(layer2) {
	                  if (layer2.type === "custom") {
	                    return new CustomStyleLayer(layer2);
	                  } else {
	                    return new subclasses[layer2.type](layer2);
	                  }
	                }
	                var HTMLImageElement2 = self.HTMLImageElement;
	                var HTMLCanvasElement2 = self.HTMLCanvasElement;
	                var HTMLVideoElement2 = self.HTMLVideoElement;
	                var ImageData$1 = self.ImageData;
	                var ImageBitmap$1 = self.ImageBitmap;
	                var Texture = function Texture2(context, image, format, options) {
	                  this.context = context;
	                  this.format = format;
	                  this.texture = context.gl.createTexture();
	                  this.update(image, options);
	                };
	                Texture.prototype.update = function update(image, options, position) {
	                  var width = image.width;
	                  var height = image.height;
	                  var resize = (!this.size || this.size[0] !== width || this.size[1] !== height) && !position;
	                  var ref = this;
	                  var context = ref.context;
	                  var gl2 = context.gl;
	                  this.useMipmap = Boolean(options && options.useMipmap);
	                  gl2.bindTexture(gl2.TEXTURE_2D, this.texture);
	                  context.pixelStoreUnpackFlipY.set(false);
	                  context.pixelStoreUnpack.set(1);
	                  context.pixelStoreUnpackPremultiplyAlpha.set(this.format === gl2.RGBA && (!options || options.premultiply !== false));
	                  if (resize) {
	                    this.size = [
	                      width,
	                      height
	                    ];
	                    if (image instanceof HTMLImageElement2 || image instanceof HTMLCanvasElement2 || image instanceof HTMLVideoElement2 || image instanceof ImageData$1 || ImageBitmap$1 && image instanceof ImageBitmap$1) {
	                      gl2.texImage2D(gl2.TEXTURE_2D, 0, this.format, this.format, gl2.UNSIGNED_BYTE, image);
	                    } else {
	                      gl2.texImage2D(gl2.TEXTURE_2D, 0, this.format, width, height, 0, this.format, gl2.UNSIGNED_BYTE, image.data);
	                    }
	                  } else {
	                    var ref$1 = position || {
	                      x: 0,
	                      y: 0
	                    };
	                    var x = ref$1.x;
	                    var y = ref$1.y;
	                    if (image instanceof HTMLImageElement2 || image instanceof HTMLCanvasElement2 || image instanceof HTMLVideoElement2 || image instanceof ImageData$1 || ImageBitmap$1 && image instanceof ImageBitmap$1) {
	                      gl2.texSubImage2D(gl2.TEXTURE_2D, 0, x, y, gl2.RGBA, gl2.UNSIGNED_BYTE, image);
	                    } else {
	                      gl2.texSubImage2D(gl2.TEXTURE_2D, 0, x, y, width, height, gl2.RGBA, gl2.UNSIGNED_BYTE, image.data);
	                    }
	                  }
	                  if (this.useMipmap && this.isSizePowerOfTwo()) {
	                    gl2.generateMipmap(gl2.TEXTURE_2D);
	                  }
	                };
	                Texture.prototype.bind = function bind(filter2, wrap2, minFilter) {
	                  var ref = this;
	                  var context = ref.context;
	                  var gl2 = context.gl;
	                  gl2.bindTexture(gl2.TEXTURE_2D, this.texture);
	                  if (minFilter === gl2.LINEAR_MIPMAP_NEAREST && !this.isSizePowerOfTwo()) {
	                    minFilter = gl2.LINEAR;
	                  }
	                  if (filter2 !== this.filter) {
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MAG_FILTER, filter2);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MIN_FILTER, minFilter || filter2);
	                    this.filter = filter2;
	                  }
	                  if (wrap2 !== this.wrap) {
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_S, wrap2);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_T, wrap2);
	                    this.wrap = wrap2;
	                  }
	                };
	                Texture.prototype.isSizePowerOfTwo = function isSizePowerOfTwo() {
	                  return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 === 0;
	                };
	                Texture.prototype.destroy = function destroy() {
	                  var ref = this.context;
	                  var gl2 = ref.gl;
	                  gl2.deleteTexture(this.texture);
	                  this.texture = null;
	                };
	                var ThrottledInvoker = function ThrottledInvoker2(callback) {
	                  var this$1$1 = this;
	                  this._callback = callback;
	                  this._triggered = false;
	                  if (typeof MessageChannel !== "undefined") {
	                    this._channel = new MessageChannel();
	                    this._channel.port2.onmessage = function() {
	                      this$1$1._triggered = false;
	                      this$1$1._callback();
	                    };
	                  }
	                };
	                ThrottledInvoker.prototype.trigger = function trigger() {
	                  var this$1$1 = this;
	                  if (!this._triggered) {
	                    this._triggered = true;
	                    if (this._channel) {
	                      this._channel.port1.postMessage(true);
	                    } else {
	                      setTimeout(function() {
	                        this$1$1._triggered = false;
	                        this$1$1._callback();
	                      }, 0);
	                    }
	                  }
	                };
	                ThrottledInvoker.prototype.remove = function remove() {
	                  delete this._channel;
	                  this._callback = function() {
	                  };
	                };
	                var Actor = function Actor2(target, parent, mapId) {
	                  this.target = target;
	                  this.parent = parent;
	                  this.mapId = mapId;
	                  this.callbacks = {};
	                  this.tasks = {};
	                  this.taskQueue = [];
	                  this.cancelCallbacks = {};
	                  bindAll([
	                    "receive",
	                    "process"
	                  ], this);
	                  this.invoker = new ThrottledInvoker(this.process);
	                  this.target.addEventListener("message", this.receive, false);
	                  this.globalScope = isWorker() ? target : self;
	                };
	                Actor.prototype.send = function send(type, data, callback, targetMapId, mustQueue) {
	                  var this$1$1 = this;
	                  if (mustQueue === undefined)
	                    mustQueue = false;
	                  var id2 = Math.round(Math.random() * 1e18).toString(36).substring(0, 10);
	                  if (callback) {
	                    this.callbacks[id2] = callback;
	                  }
	                  var buffers = isSafari(this.globalScope) ? undefined : [];
	                  this.target.postMessage({
	                    id: id2,
	                    type,
	                    hasCallback: !!callback,
	                    targetMapId,
	                    mustQueue,
	                    sourceMapId: this.mapId,
	                    data: serialize(data, buffers)
	                  }, buffers);
	                  return {
	                    cancel: function() {
	                      if (callback) {
	                        delete this$1$1.callbacks[id2];
	                      }
	                      this$1$1.target.postMessage({
	                        id: id2,
	                        type: "<cancel>",
	                        targetMapId,
	                        sourceMapId: this$1$1.mapId
	                      });
	                    }
	                  };
	                };
	                Actor.prototype.receive = function receive(message) {
	                  var data = message.data, id2 = data.id;
	                  if (!id2) {
	                    return;
	                  }
	                  if (data.targetMapId && this.mapId !== data.targetMapId) {
	                    return;
	                  }
	                  if (data.type === "<cancel>") {
	                    delete this.tasks[id2];
	                    var cancel2 = this.cancelCallbacks[id2];
	                    delete this.cancelCallbacks[id2];
	                    if (cancel2) {
	                      cancel2();
	                    }
	                  } else {
	                    if (isWorker() || data.mustQueue) {
	                      this.tasks[id2] = data;
	                      this.taskQueue.push(id2);
	                      this.invoker.trigger();
	                    } else {
	                      this.processTask(id2, data);
	                    }
	                  }
	                };
	                Actor.prototype.process = function process() {
	                  if (!this.taskQueue.length) {
	                    return;
	                  }
	                  var id2 = this.taskQueue.shift();
	                  var task = this.tasks[id2];
	                  delete this.tasks[id2];
	                  if (this.taskQueue.length) {
	                    this.invoker.trigger();
	                  }
	                  if (!task) {
	                    return;
	                  }
	                  this.processTask(id2, task);
	                };
	                Actor.prototype.processTask = function processTask(id2, task) {
	                  var this$1$1 = this;
	                  if (task.type === "<response>") {
	                    var callback = this.callbacks[id2];
	                    delete this.callbacks[id2];
	                    if (callback) {
	                      if (task.error) {
	                        callback(deserialize(task.error));
	                      } else {
	                        callback(null, deserialize(task.data));
	                      }
	                    }
	                  } else {
	                    var completed = false;
	                    var buffers = isSafari(this.globalScope) ? undefined : [];
	                    var done = task.hasCallback ? function(err, data) {
	                      completed = true;
	                      delete this$1$1.cancelCallbacks[id2];
	                      this$1$1.target.postMessage({
	                        id: id2,
	                        type: "<response>",
	                        sourceMapId: this$1$1.mapId,
	                        error: err ? serialize(err) : null,
	                        data: serialize(data, buffers)
	                      }, buffers);
	                    } : function(_) {
	                      completed = true;
	                    };
	                    var callback$1 = null;
	                    var params = deserialize(task.data);
	                    if (this.parent[task.type]) {
	                      callback$1 = this.parent[task.type](task.sourceMapId, params, done);
	                    } else if (this.parent.getWorkerSource) {
	                      var keys = task.type.split(".");
	                      var scope = this.parent.getWorkerSource(task.sourceMapId, keys[0], params.source);
	                      callback$1 = scope[keys[1]](params, done);
	                    } else {
	                      done(new Error("Could not find function " + task.type));
	                    }
	                    if (!completed && callback$1 && callback$1.cancel) {
	                      this.cancelCallbacks[id2] = callback$1.cancel;
	                    }
	                  }
	                };
	                Actor.prototype.remove = function remove() {
	                  this.invoker.remove();
	                  this.target.removeEventListener("message", this.receive, false);
	                };
	                function getTileBBox(x, y, z) {
	                  y = Math.pow(2, z) - y - 1;
	                  var min = getMercCoords(x * 256, y * 256, z), max = getMercCoords((x + 1) * 256, (y + 1) * 256, z);
	                  return min[0] + "," + min[1] + "," + max[0] + "," + max[1];
	                }
	                function getMercCoords(x, y, z) {
	                  var resolution = 2 * Math.PI * 6378137 / 256 / Math.pow(2, z), merc_x = x * resolution - 2 * Math.PI * 6378137 / 2, merc_y = y * resolution - 2 * Math.PI * 6378137 / 2;
	                  return [merc_x, merc_y];
	                }
	                var LngLatBounds = function LngLatBounds2(sw, ne) {
	                  if (!sw) ;
	                  else if (ne) {
	                    this.setSouthWest(sw).setNorthEast(ne);
	                  } else if (sw.length === 4) {
	                    this.setSouthWest([
	                      sw[0],
	                      sw[1]
	                    ]).setNorthEast([
	                      sw[2],
	                      sw[3]
	                    ]);
	                  } else {
	                    this.setSouthWest(sw[0]).setNorthEast(sw[1]);
	                  }
	                };
	                LngLatBounds.prototype.setNorthEast = function setNorthEast(ne) {
	                  this._ne = ne instanceof LngLat ? new LngLat(ne.lng, ne.lat) : LngLat.convert(ne);
	                  return this;
	                };
	                LngLatBounds.prototype.setSouthWest = function setSouthWest(sw) {
	                  this._sw = sw instanceof LngLat ? new LngLat(sw.lng, sw.lat) : LngLat.convert(sw);
	                  return this;
	                };
	                LngLatBounds.prototype.extend = function extend2(obj) {
	                  var sw = this._sw, ne = this._ne;
	                  var sw2, ne2;
	                  if (obj instanceof LngLat) {
	                    sw2 = obj;
	                    ne2 = obj;
	                  } else if (obj instanceof LngLatBounds) {
	                    sw2 = obj._sw;
	                    ne2 = obj._ne;
	                    if (!sw2 || !ne2) {
	                      return this;
	                    }
	                  } else {
	                    if (Array.isArray(obj)) {
	                      if (obj.length === 4 || obj.every(Array.isArray)) {
	                        var lngLatBoundsObj = obj;
	                        return this.extend(LngLatBounds.convert(lngLatBoundsObj));
	                      } else {
	                        var lngLatObj = obj;
	                        return this.extend(LngLat.convert(lngLatObj));
	                      }
	                    }
	                    return this;
	                  }
	                  if (!sw && !ne) {
	                    this._sw = new LngLat(sw2.lng, sw2.lat);
	                    this._ne = new LngLat(ne2.lng, ne2.lat);
	                  } else {
	                    sw.lng = Math.min(sw2.lng, sw.lng);
	                    sw.lat = Math.min(sw2.lat, sw.lat);
	                    ne.lng = Math.max(ne2.lng, ne.lng);
	                    ne.lat = Math.max(ne2.lat, ne.lat);
	                  }
	                  return this;
	                };
	                LngLatBounds.prototype.getCenter = function getCenter() {
	                  return new LngLat((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
	                };
	                LngLatBounds.prototype.getSouthWest = function getSouthWest() {
	                  return this._sw;
	                };
	                LngLatBounds.prototype.getNorthEast = function getNorthEast() {
	                  return this._ne;
	                };
	                LngLatBounds.prototype.getNorthWest = function getNorthWest() {
	                  return new LngLat(this.getWest(), this.getNorth());
	                };
	                LngLatBounds.prototype.getSouthEast = function getSouthEast() {
	                  return new LngLat(this.getEast(), this.getSouth());
	                };
	                LngLatBounds.prototype.getWest = function getWest() {
	                  return this._sw.lng;
	                };
	                LngLatBounds.prototype.getSouth = function getSouth() {
	                  return this._sw.lat;
	                };
	                LngLatBounds.prototype.getEast = function getEast() {
	                  return this._ne.lng;
	                };
	                LngLatBounds.prototype.getNorth = function getNorth() {
	                  return this._ne.lat;
	                };
	                LngLatBounds.prototype.toArray = function toArray() {
	                  return [
	                    this._sw.toArray(),
	                    this._ne.toArray()
	                  ];
	                };
	                LngLatBounds.prototype.toString = function toString2() {
	                  return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
	                };
	                LngLatBounds.prototype.isEmpty = function isEmpty2() {
	                  return !(this._sw && this._ne);
	                };
	                LngLatBounds.prototype.contains = function contains(lnglat) {
	                  var ref = LngLat.convert(lnglat);
	                  var lng = ref.lng;
	                  var lat = ref.lat;
	                  var containsLatitude = this._sw.lat <= lat && lat <= this._ne.lat;
	                  var containsLongitude = this._sw.lng <= lng && lng <= this._ne.lng;
	                  if (this._sw.lng > this._ne.lng) {
	                    containsLongitude = this._sw.lng >= lng && lng >= this._ne.lng;
	                  }
	                  return containsLatitude && containsLongitude;
	                };
	                LngLatBounds.convert = function convert(input) {
	                  if (!input || input instanceof LngLatBounds) {
	                    return input;
	                  }
	                  return new LngLatBounds(input);
	                };
	                var earthRadius = 63710088e-1;
	                var LngLat = function LngLat2(lng, lat) {
	                  if (isNaN(lng) || isNaN(lat)) {
	                    throw new Error("Invalid LngLat object: (" + lng + ", " + lat + ")");
	                  }
	                  this.lng = +lng;
	                  this.lat = +lat;
	                  if (this.lat > 90 || this.lat < -90) {
	                    throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
	                  }
	                };
	                LngLat.prototype.wrap = function wrap$1() {
	                  return new LngLat(wrap(this.lng, -180, 180), this.lat);
	                };
	                LngLat.prototype.toArray = function toArray() {
	                  return [
	                    this.lng,
	                    this.lat
	                  ];
	                };
	                LngLat.prototype.toString = function toString2() {
	                  return "LngLat(" + this.lng + ", " + this.lat + ")";
	                };
	                LngLat.prototype.distanceTo = function distanceTo(lngLat) {
	                  var rad = Math.PI / 180;
	                  var lat1 = this.lat * rad;
	                  var lat2 = lngLat.lat * rad;
	                  var a = Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos((lngLat.lng - this.lng) * rad);
	                  var maxMeters = earthRadius * Math.acos(Math.min(a, 1));
	                  return maxMeters;
	                };
	                LngLat.prototype.toBounds = function toBounds(radius) {
	                  if (radius === undefined)
	                    radius = 0;
	                  var earthCircumferenceInMetersAtEquator = 40075017;
	                  var latAccuracy = 360 * radius / earthCircumferenceInMetersAtEquator, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
	                  return new LngLatBounds(new LngLat(this.lng - lngAccuracy, this.lat - latAccuracy), new LngLat(this.lng + lngAccuracy, this.lat + latAccuracy));
	                };
	                LngLat.convert = function convert(input) {
	                  if (input instanceof LngLat) {
	                    return input;
	                  }
	                  if (Array.isArray(input) && (input.length === 2 || input.length === 3)) {
	                    return new LngLat(Number(input[0]), Number(input[1]));
	                  }
	                  if (!Array.isArray(input) && typeof input === "object" && input !== null) {
	                    return new LngLat(Number("lng" in input ? input.lng : input.lon), Number(input.lat));
	                  }
	                  throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
	                };
	                var earthCircumfrence = 2 * Math.PI * earthRadius;
	                function circumferenceAtLatitude(latitude) {
	                  return earthCircumfrence * Math.cos(latitude * Math.PI / 180);
	                }
	                function mercatorXfromLng$1(lng) {
	                  return (180 + lng) / 360;
	                }
	                function mercatorYfromLat$1(lat) {
	                  return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
	                }
	                function mercatorZfromAltitude(altitude, lat) {
	                  return altitude / circumferenceAtLatitude(lat);
	                }
	                function lngFromMercatorX(x) {
	                  return x * 360 - 180;
	                }
	                function latFromMercatorY(y) {
	                  var y2 = 180 - y * 360;
	                  return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
	                }
	                function altitudeFromMercatorZ(z, y) {
	                  return z * circumferenceAtLatitude(latFromMercatorY(y));
	                }
	                function mercatorScale(lat) {
	                  return 1 / Math.cos(lat * Math.PI / 180);
	                }
	                var MercatorCoordinate = function MercatorCoordinate2(x, y, z) {
	                  if (z === undefined)
	                    z = 0;
	                  this.x = +x;
	                  this.y = +y;
	                  this.z = +z;
	                };
	                MercatorCoordinate.fromLngLat = function fromLngLat(lngLatLike, altitude) {
	                  if (altitude === undefined)
	                    altitude = 0;
	                  var lngLat = LngLat.convert(lngLatLike);
	                  return new MercatorCoordinate(mercatorXfromLng$1(lngLat.lng), mercatorYfromLat$1(lngLat.lat), mercatorZfromAltitude(altitude, lngLat.lat));
	                };
	                MercatorCoordinate.prototype.toLngLat = function toLngLat() {
	                  return new LngLat(lngFromMercatorX(this.x), latFromMercatorY(this.y));
	                };
	                MercatorCoordinate.prototype.toAltitude = function toAltitude() {
	                  return altitudeFromMercatorZ(this.z, this.y);
	                };
	                MercatorCoordinate.prototype.meterInMercatorCoordinateUnits = function meterInMercatorCoordinateUnits() {
	                  return 1 / earthCircumfrence * mercatorScale(latFromMercatorY(this.y));
	                };
	                var CanonicalTileID = function CanonicalTileID2(z, x, y) {
	                  this.z = z;
	                  this.x = x;
	                  this.y = y;
	                  this.key = calculateKey(0, z, z, x, y);
	                };
	                CanonicalTileID.prototype.equals = function equals2(id2) {
	                  return this.z === id2.z && this.x === id2.x && this.y === id2.y;
	                };
	                CanonicalTileID.prototype.url = function url(urls, scheme) {
	                  var bbox = getTileBBox(this.x, this.y, this.z);
	                  var quadkey = getQuadkey(this.z, this.x, this.y);
	                  return urls[(this.x + this.y) % urls.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String(scheme === "tms" ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", quadkey).replace("{bbox-epsg-3857}", bbox);
	                };
	                CanonicalTileID.prototype.getTilePoint = function getTilePoint(coord) {
	                  var tilesAtZoom = Math.pow(2, this.z);
	                  return new pointGeometry((coord.x * tilesAtZoom - this.x) * EXTENT$1, (coord.y * tilesAtZoom - this.y) * EXTENT$1);
	                };
	                CanonicalTileID.prototype.toString = function toString2() {
	                  return this.z + "/" + this.x + "/" + this.y;
	                };
	                var UnwrappedTileID = function UnwrappedTileID2(wrap2, canonical) {
	                  this.wrap = wrap2;
	                  this.canonical = canonical;
	                  this.key = calculateKey(wrap2, canonical.z, canonical.z, canonical.x, canonical.y);
	                };
	                var OverscaledTileID = function OverscaledTileID2(overscaledZ, wrap2, z, x, y) {
	                  this.overscaledZ = overscaledZ;
	                  this.wrap = wrap2;
	                  this.canonical = new CanonicalTileID(z, +x, +y);
	                  this.key = calculateKey(wrap2, overscaledZ, z, x, y);
	                };
	                OverscaledTileID.prototype.equals = function equals2(id2) {
	                  return this.overscaledZ === id2.overscaledZ && this.wrap === id2.wrap && this.canonical.equals(id2.canonical);
	                };
	                OverscaledTileID.prototype.scaledTo = function scaledTo(targetZ) {
	                  var zDifference = this.canonical.z - targetZ;
	                  if (targetZ > this.canonical.z) {
	                    return new OverscaledTileID(targetZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
	                  } else {
	                    return new OverscaledTileID(targetZ, this.wrap, targetZ, this.canonical.x >> zDifference, this.canonical.y >> zDifference);
	                  }
	                };
	                OverscaledTileID.prototype.calculateScaledKey = function calculateScaledKey(targetZ, withWrap) {
	                  var zDifference = this.canonical.z - targetZ;
	                  if (targetZ > this.canonical.z) {
	                    return calculateKey(this.wrap * +withWrap, targetZ, this.canonical.z, this.canonical.x, this.canonical.y);
	                  } else {
	                    return calculateKey(this.wrap * +withWrap, targetZ, targetZ, this.canonical.x >> zDifference, this.canonical.y >> zDifference);
	                  }
	                };
	                OverscaledTileID.prototype.isChildOf = function isChildOf(parent) {
	                  if (parent.wrap !== this.wrap) {
	                    return false;
	                  }
	                  var zDifference = this.canonical.z - parent.canonical.z;
	                  return parent.overscaledZ === 0 || parent.overscaledZ < this.overscaledZ && parent.canonical.x === this.canonical.x >> zDifference && parent.canonical.y === this.canonical.y >> zDifference;
	                };
	                OverscaledTileID.prototype.children = function children(sourceMaxZoom) {
	                  if (this.overscaledZ >= sourceMaxZoom) {
	                    return [new OverscaledTileID(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
	                  }
	                  var z = this.canonical.z + 1;
	                  var x = this.canonical.x * 2;
	                  var y = this.canonical.y * 2;
	                  return [
	                    new OverscaledTileID(z, this.wrap, z, x, y),
	                    new OverscaledTileID(z, this.wrap, z, x + 1, y),
	                    new OverscaledTileID(z, this.wrap, z, x, y + 1),
	                    new OverscaledTileID(z, this.wrap, z, x + 1, y + 1)
	                  ];
	                };
	                OverscaledTileID.prototype.isLessThan = function isLessThan(rhs) {
	                  if (this.wrap < rhs.wrap) {
	                    return true;
	                  }
	                  if (this.wrap > rhs.wrap) {
	                    return false;
	                  }
	                  if (this.overscaledZ < rhs.overscaledZ) {
	                    return true;
	                  }
	                  if (this.overscaledZ > rhs.overscaledZ) {
	                    return false;
	                  }
	                  if (this.canonical.x < rhs.canonical.x) {
	                    return true;
	                  }
	                  if (this.canonical.x > rhs.canonical.x) {
	                    return false;
	                  }
	                  if (this.canonical.y < rhs.canonical.y) {
	                    return true;
	                  }
	                  return false;
	                };
	                OverscaledTileID.prototype.wrapped = function wrapped() {
	                  return new OverscaledTileID(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
	                };
	                OverscaledTileID.prototype.unwrapTo = function unwrapTo(wrap2) {
	                  return new OverscaledTileID(this.overscaledZ, wrap2, this.canonical.z, this.canonical.x, this.canonical.y);
	                };
	                OverscaledTileID.prototype.overscaleFactor = function overscaleFactor() {
	                  return Math.pow(2, this.overscaledZ - this.canonical.z);
	                };
	                OverscaledTileID.prototype.toUnwrapped = function toUnwrapped() {
	                  return new UnwrappedTileID(this.wrap, this.canonical);
	                };
	                OverscaledTileID.prototype.toString = function toString2() {
	                  return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
	                };
	                OverscaledTileID.prototype.getTilePoint = function getTilePoint(coord) {
	                  return this.canonical.getTilePoint(new MercatorCoordinate(coord.x - this.wrap, coord.y));
	                };
	                function calculateKey(wrap2, overscaledZ, z, x, y) {
	                  wrap2 *= 2;
	                  if (wrap2 < 0) {
	                    wrap2 = wrap2 * -1 - 1;
	                  }
	                  var dim = 1 << z;
	                  return (dim * dim * wrap2 + dim * y + x).toString(36) + z.toString(36) + overscaledZ.toString(36);
	                }
	                function getQuadkey(z, x, y) {
	                  var quadkey = "", mask;
	                  for (var i = z; i > 0; i--) {
	                    mask = 1 << i - 1;
	                    quadkey += (x & mask ? 1 : 0) + (y & mask ? 2 : 0);
	                  }
	                  return quadkey;
	                }
	                register("CanonicalTileID", CanonicalTileID);
	                register("OverscaledTileID", OverscaledTileID, { omit: ["posMatrix"] });
	                var DEMData = function DEMData2(uid, data, encoding) {
	                  this.uid = uid;
	                  if (data.height !== data.width) {
	                    throw new RangeError("DEM tiles must be square");
	                  }
	                  if (encoding && encoding !== "mapbox" && encoding !== "terrarium") {
	                    return warnOnce('"' + encoding + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
	                  }
	                  this.stride = data.height;
	                  var dim = this.dim = data.height - 2;
	                  this.data = new Uint32Array(data.data.buffer);
	                  this.encoding = encoding || "mapbox";
	                  for (var x = 0; x < dim; x++) {
	                    this.data[this._idx(-1, x)] = this.data[this._idx(0, x)];
	                    this.data[this._idx(dim, x)] = this.data[this._idx(dim - 1, x)];
	                    this.data[this._idx(x, -1)] = this.data[this._idx(x, 0)];
	                    this.data[this._idx(x, dim)] = this.data[this._idx(x, dim - 1)];
	                  }
	                  this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)];
	                  this.data[this._idx(dim, -1)] = this.data[this._idx(dim - 1, 0)];
	                  this.data[this._idx(-1, dim)] = this.data[this._idx(0, dim - 1)];
	                  this.data[this._idx(dim, dim)] = this.data[this._idx(dim - 1, dim - 1)];
	                };
	                DEMData.prototype.get = function get2(x, y) {
	                  var pixels = new Uint8Array(this.data.buffer);
	                  var index = this._idx(x, y) * 4;
	                  var unpack = this.encoding === "terrarium" ? this._unpackTerrarium : this._unpackMapbox;
	                  return unpack(pixels[index], pixels[index + 1], pixels[index + 2]);
	                };
	                DEMData.prototype.getUnpackVector = function getUnpackVector() {
	                  return this.encoding === "terrarium" ? [
	                    256,
	                    1,
	                    1 / 256,
	                    32768
	                  ] : [
	                    6553.6,
	                    25.6,
	                    0.1,
	                    1e4
	                  ];
	                };
	                DEMData.prototype._idx = function _idx(x, y) {
	                  if (x < -1 || x >= this.dim + 1 || y < -1 || y >= this.dim + 1) {
	                    throw new RangeError("out of range source coordinates for DEM data");
	                  }
	                  return (y + 1) * this.stride + (x + 1);
	                };
	                DEMData.prototype._unpackMapbox = function _unpackMapbox(r, g, b) {
	                  return (r * 256 * 256 + g * 256 + b) / 10 - 1e4;
	                };
	                DEMData.prototype._unpackTerrarium = function _unpackTerrarium(r, g, b) {
	                  return r * 256 + g + b / 256 - 32768;
	                };
	                DEMData.prototype.getPixels = function getPixels() {
	                  return new RGBAImage({
	                    width: this.stride,
	                    height: this.stride
	                  }, new Uint8Array(this.data.buffer));
	                };
	                DEMData.prototype.backfillBorder = function backfillBorder(borderTile, dx, dy) {
	                  if (this.dim !== borderTile.dim) {
	                    throw new Error("dem dimension mismatch");
	                  }
	                  var xMin = dx * this.dim, xMax = dx * this.dim + this.dim, yMin = dy * this.dim, yMax = dy * this.dim + this.dim;
	                  switch (dx) {
	                    case -1:
	                      xMin = xMax - 1;
	                      break;
	                    case 1:
	                      xMax = xMin + 1;
	                      break;
	                  }
	                  switch (dy) {
	                    case -1:
	                      yMin = yMax - 1;
	                      break;
	                    case 1:
	                      yMax = yMin + 1;
	                      break;
	                  }
	                  var ox = -dx * this.dim;
	                  var oy = -dy * this.dim;
	                  for (var y = yMin; y < yMax; y++) {
	                    for (var x = xMin; x < xMax; x++) {
	                      this.data[this._idx(x, y)] = borderTile.data[this._idx(x + ox, y + oy)];
	                    }
	                  }
	                };
	                register("DEMData", DEMData);
	                function deserialize$1(input, style) {
	                  var output = {};
	                  if (!style) {
	                    return output;
	                  }
	                  var loop = function() {
	                    var bucket = list$1[i$1];
	                    var layers = bucket.layerIds.map(function(id2) {
	                      return style.getLayer(id2);
	                    }).filter(Boolean);
	                    if (layers.length === 0) {
	                      return;
	                    }
	                    bucket.layers = layers;
	                    if (bucket.stateDependentLayerIds) {
	                      bucket.stateDependentLayers = bucket.stateDependentLayerIds.map(function(lId) {
	                        return layers.filter(function(l) {
	                          return l.id === lId;
	                        })[0];
	                      });
	                    }
	                    for (var i = 0, list = layers; i < list.length; i += 1) {
	                      var layer2 = list[i];
	                      output[layer2.id] = bucket;
	                    }
	                  };
	                  for (var i$1 = 0, list$1 = input; i$1 < list$1.length; i$1 += 1)
	                    loop();
	                  return output;
	                }
	                var DictionaryCoder = function DictionaryCoder2(strings) {
	                  this._stringToNumber = {};
	                  this._numberToString = [];
	                  for (var i = 0; i < strings.length; i++) {
	                    var string = strings[i];
	                    this._stringToNumber[string] = i;
	                    this._numberToString[i] = string;
	                  }
	                };
	                DictionaryCoder.prototype.encode = function encode(string) {
	                  return this._stringToNumber[string];
	                };
	                DictionaryCoder.prototype.decode = function decode(n) {
	                  return this._numberToString[n];
	                };
	                var Feature = function Feature2(vectorTileFeature, z, x, y, id2) {
	                  this.type = "Feature";
	                  this._vectorTileFeature = vectorTileFeature;
	                  vectorTileFeature._z = z;
	                  vectorTileFeature._x = x;
	                  vectorTileFeature._y = y;
	                  this.properties = vectorTileFeature.properties;
	                  this.id = id2;
	                };
	                var prototypeAccessors$1 = { geometry: { configurable: true } };
	                prototypeAccessors$1.geometry.get = function() {
	                  if (this._geometry === undefined) {
	                    this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry;
	                  }
	                  return this._geometry;
	                };
	                prototypeAccessors$1.geometry.set = function(g) {
	                  this._geometry = g;
	                };
	                Feature.prototype.toJSON = function toJSON() {
	                  var json = { geometry: this.geometry };
	                  for (var i in this) {
	                    if (i === "_geometry" || i === "_vectorTileFeature") {
	                      continue;
	                    }
	                    json[i] = this[i];
	                  }
	                  return json;
	                };
	                Object.defineProperties(Feature.prototype, prototypeAccessors$1);
	                var SourceFeatureState = function SourceFeatureState2() {
	                  this.state = {};
	                  this.stateChanges = {};
	                  this.deletedStates = {};
	                };
	                SourceFeatureState.prototype.updateState = function updateState(sourceLayer, featureId, newState) {
	                  var feature = String(featureId);
	                  this.stateChanges[sourceLayer] = this.stateChanges[sourceLayer] || {};
	                  this.stateChanges[sourceLayer][feature] = this.stateChanges[sourceLayer][feature] || {};
	                  extend(this.stateChanges[sourceLayer][feature], newState);
	                  if (this.deletedStates[sourceLayer] === null) {
	                    this.deletedStates[sourceLayer] = {};
	                    for (var ft in this.state[sourceLayer]) {
	                      if (ft !== feature) {
	                        this.deletedStates[sourceLayer][ft] = null;
	                      }
	                    }
	                  } else {
	                    var featureDeletionQueued = this.deletedStates[sourceLayer] && this.deletedStates[sourceLayer][feature] === null;
	                    if (featureDeletionQueued) {
	                      this.deletedStates[sourceLayer][feature] = {};
	                      for (var prop in this.state[sourceLayer][feature]) {
	                        if (!newState[prop]) {
	                          this.deletedStates[sourceLayer][feature][prop] = null;
	                        }
	                      }
	                    } else {
	                      for (var key in newState) {
	                        var deletionInQueue = this.deletedStates[sourceLayer] && this.deletedStates[sourceLayer][feature] && this.deletedStates[sourceLayer][feature][key] === null;
	                        if (deletionInQueue) {
	                          delete this.deletedStates[sourceLayer][feature][key];
	                        }
	                      }
	                    }
	                  }
	                };
	                SourceFeatureState.prototype.removeFeatureState = function removeFeatureState(sourceLayer, featureId, key) {
	                  var sourceLayerDeleted = this.deletedStates[sourceLayer] === null;
	                  if (sourceLayerDeleted) {
	                    return;
	                  }
	                  var feature = String(featureId);
	                  this.deletedStates[sourceLayer] = this.deletedStates[sourceLayer] || {};
	                  if (key && featureId !== undefined) {
	                    if (this.deletedStates[sourceLayer][feature] !== null) {
	                      this.deletedStates[sourceLayer][feature] = this.deletedStates[sourceLayer][feature] || {};
	                      this.deletedStates[sourceLayer][feature][key] = null;
	                    }
	                  } else if (featureId !== undefined) {
	                    var updateInQueue = this.stateChanges[sourceLayer] && this.stateChanges[sourceLayer][feature];
	                    if (updateInQueue) {
	                      this.deletedStates[sourceLayer][feature] = {};
	                      for (key in this.stateChanges[sourceLayer][feature]) {
	                        this.deletedStates[sourceLayer][feature][key] = null;
	                      }
	                    } else {
	                      this.deletedStates[sourceLayer][feature] = null;
	                    }
	                  } else {
	                    this.deletedStates[sourceLayer] = null;
	                  }
	                };
	                SourceFeatureState.prototype.getState = function getState(sourceLayer, featureId) {
	                  var feature = String(featureId);
	                  var base = this.state[sourceLayer] || {};
	                  var changes = this.stateChanges[sourceLayer] || {};
	                  var reconciledState = extend({}, base[feature], changes[feature]);
	                  if (this.deletedStates[sourceLayer] === null) {
	                    return {};
	                  } else if (this.deletedStates[sourceLayer]) {
	                    var featureDeletions = this.deletedStates[sourceLayer][featureId];
	                    if (featureDeletions === null) {
	                      return {};
	                    }
	                    for (var prop in featureDeletions) {
	                      delete reconciledState[prop];
	                    }
	                  }
	                  return reconciledState;
	                };
	                SourceFeatureState.prototype.initializeTileState = function initializeTileState(tile, painter) {
	                  tile.setFeatureState(this.state, painter);
	                };
	                SourceFeatureState.prototype.coalesceChanges = function coalesceChanges(tiles, painter) {
	                  var featuresChanged = {};
	                  for (var sourceLayer in this.stateChanges) {
	                    this.state[sourceLayer] = this.state[sourceLayer] || {};
	                    var layerStates = {};
	                    for (var feature in this.stateChanges[sourceLayer]) {
	                      if (!this.state[sourceLayer][feature]) {
	                        this.state[sourceLayer][feature] = {};
	                      }
	                      extend(this.state[sourceLayer][feature], this.stateChanges[sourceLayer][feature]);
	                      layerStates[feature] = this.state[sourceLayer][feature];
	                    }
	                    featuresChanged[sourceLayer] = layerStates;
	                  }
	                  for (var sourceLayer$1 in this.deletedStates) {
	                    this.state[sourceLayer$1] = this.state[sourceLayer$1] || {};
	                    var layerStates$1 = {};
	                    if (this.deletedStates[sourceLayer$1] === null) {
	                      for (var ft in this.state[sourceLayer$1]) {
	                        layerStates$1[ft] = {};
	                        this.state[sourceLayer$1][ft] = {};
	                      }
	                    } else {
	                      for (var feature$1 in this.deletedStates[sourceLayer$1]) {
	                        var deleteWholeFeatureState = this.deletedStates[sourceLayer$1][feature$1] === null;
	                        if (deleteWholeFeatureState) {
	                          this.state[sourceLayer$1][feature$1] = {};
	                        } else {
	                          for (var i = 0, list = Object.keys(this.deletedStates[sourceLayer$1][feature$1]); i < list.length; i += 1) {
	                            var key = list[i];
	                            delete this.state[sourceLayer$1][feature$1][key];
	                          }
	                        }
	                        layerStates$1[feature$1] = this.state[sourceLayer$1][feature$1];
	                      }
	                    }
	                    featuresChanged[sourceLayer$1] = featuresChanged[sourceLayer$1] || {};
	                    extend(featuresChanged[sourceLayer$1], layerStates$1);
	                  }
	                  this.stateChanges = {};
	                  this.deletedStates = {};
	                  if (Object.keys(featuresChanged).length === 0) {
	                    return;
	                  }
	                  for (var id2 in tiles) {
	                    var tile = tiles[id2];
	                    tile.setFeatureState(featuresChanged, painter);
	                  }
	                };
	                var FeatureIndex = function FeatureIndex2(tileID, promoteId2) {
	                  this.tileID = tileID;
	                  this.x = tileID.canonical.x;
	                  this.y = tileID.canonical.y;
	                  this.z = tileID.canonical.z;
	                  this.grid = new gridIndex(EXTENT$1, 16, 0);
	                  this.grid3D = new gridIndex(EXTENT$1, 16, 0);
	                  this.featureIndexArray = new FeatureIndexArray();
	                  this.promoteId = promoteId2;
	                };
	                FeatureIndex.prototype.insert = function insert(feature, geometry, featureIndex, sourceLayerIndex, bucketIndex, is3D) {
	                  var key = this.featureIndexArray.length;
	                  this.featureIndexArray.emplaceBack(featureIndex, sourceLayerIndex, bucketIndex);
	                  var grid = is3D ? this.grid3D : this.grid;
	                  for (var r = 0; r < geometry.length; r++) {
	                    var ring = geometry[r];
	                    var bbox = [
	                      Infinity,
	                      Infinity,
	                      -Infinity,
	                      -Infinity
	                    ];
	                    for (var i = 0; i < ring.length; i++) {
	                      var p = ring[i];
	                      bbox[0] = Math.min(bbox[0], p.x);
	                      bbox[1] = Math.min(bbox[1], p.y);
	                      bbox[2] = Math.max(bbox[2], p.x);
	                      bbox[3] = Math.max(bbox[3], p.y);
	                    }
	                    if (bbox[0] < EXTENT$1 && bbox[1] < EXTENT$1 && bbox[2] >= 0 && bbox[3] >= 0) {
	                      grid.insert(key, bbox[0], bbox[1], bbox[2], bbox[3]);
	                    }
	                  }
	                };
	                FeatureIndex.prototype.loadVTLayers = function loadVTLayers() {
	                  if (!this.vtLayers) {
	                    this.vtLayers = new vectorTile.VectorTile(new pbf(this.rawTileData)).layers;
	                    this.sourceLayerCoder = new DictionaryCoder(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]);
	                  }
	                  return this.vtLayers;
	                };
	                FeatureIndex.prototype.query = function query(args, styleLayers, serializedLayers, sourceFeatureState) {
	                  var this$1$1 = this;
	                  this.loadVTLayers();
	                  var params = args.params || {}, pixelsToTileUnits = EXTENT$1 / args.tileSize / args.scale, filter2 = createFilter(params.filter);
	                  var queryGeometry = args.queryGeometry;
	                  var queryPadding = args.queryPadding * pixelsToTileUnits;
	                  var bounds2 = getBounds(queryGeometry);
	                  var matching = this.grid.query(bounds2.minX - queryPadding, bounds2.minY - queryPadding, bounds2.maxX + queryPadding, bounds2.maxY + queryPadding);
	                  var cameraBounds = getBounds(args.cameraQueryGeometry);
	                  var matching3D = this.grid3D.query(cameraBounds.minX - queryPadding, cameraBounds.minY - queryPadding, cameraBounds.maxX + queryPadding, cameraBounds.maxY + queryPadding, function(bx1, by1, bx2, by2) {
	                    return polygonIntersectsBox(args.cameraQueryGeometry, bx1 - queryPadding, by1 - queryPadding, bx2 + queryPadding, by2 + queryPadding);
	                  });
	                  for (var i = 0, list = matching3D; i < list.length; i += 1) {
	                    var key = list[i];
	                    matching.push(key);
	                  }
	                  matching.sort(topDownFeatureComparator);
	                  var result = {};
	                  var previousIndex;
	                  var loop = function(k2) {
	                    var index = matching[k2];
	                    if (index === previousIndex) {
	                      return;
	                    }
	                    previousIndex = index;
	                    var match = this$1$1.featureIndexArray.get(index);
	                    var featureGeometry = null;
	                    this$1$1.loadMatchingFeature(result, match.bucketIndex, match.sourceLayerIndex, match.featureIndex, filter2, params.layers, params.availableImages, styleLayers, serializedLayers, sourceFeatureState, function(feature, styleLayer, featureState) {
	                      if (!featureGeometry) {
	                        featureGeometry = loadGeometry(feature);
	                      }
	                      return styleLayer.queryIntersectsFeature(queryGeometry, feature, featureState, featureGeometry, this$1$1.z, args.transform, pixelsToTileUnits, args.pixelPosMatrix);
	                    });
	                  };
	                  for (var k = 0; k < matching.length; k++)
	                    loop(k);
	                  return result;
	                };
	                FeatureIndex.prototype.loadMatchingFeature = function loadMatchingFeature(result, bucketIndex, sourceLayerIndex, featureIndex, filter2, filterLayerIDs, availableImages, styleLayers, serializedLayers, sourceFeatureState, intersectionTest) {
	                  var layerIDs = this.bucketLayerIDs[bucketIndex];
	                  if (filterLayerIDs && !arraysIntersect(filterLayerIDs, layerIDs)) {
	                    return;
	                  }
	                  var sourceLayerName = this.sourceLayerCoder.decode(sourceLayerIndex);
	                  var sourceLayer = this.vtLayers[sourceLayerName];
	                  var feature = sourceLayer.feature(featureIndex);
	                  if (!filter2.filter(new EvaluationParameters(this.tileID.overscaledZ), feature)) {
	                    return;
	                  }
	                  var id2 = this.getId(feature, sourceLayerName);
	                  for (var l = 0; l < layerIDs.length; l++) {
	                    var layerID = layerIDs[l];
	                    if (filterLayerIDs && filterLayerIDs.indexOf(layerID) < 0) {
	                      continue;
	                    }
	                    var styleLayer = styleLayers[layerID];
	                    if (!styleLayer) {
	                      continue;
	                    }
	                    var featureState = {};
	                    if (id2 !== undefined && sourceFeatureState) {
	                      featureState = sourceFeatureState.getState(styleLayer.sourceLayer || "_geojsonTileLayer", id2);
	                    }
	                    var serializedLayer = serializedLayers[layerID];
	                    serializedLayer.paint = evaluateProperties(serializedLayer.paint, styleLayer.paint, feature, featureState, availableImages);
	                    serializedLayer.layout = evaluateProperties(serializedLayer.layout, styleLayer.layout, feature, featureState, availableImages);
	                    var intersectionZ = !intersectionTest || intersectionTest(feature, styleLayer, featureState);
	                    if (!intersectionZ) {
	                      continue;
	                    }
	                    var geojsonFeature = new Feature(feature, this.z, this.x, this.y, id2);
	                    geojsonFeature.layer = serializedLayer;
	                    var layerResult = result[layerID];
	                    if (layerResult === undefined) {
	                      layerResult = result[layerID] = [];
	                    }
	                    layerResult.push({
	                      featureIndex,
	                      feature: geojsonFeature,
	                      intersectionZ
	                    });
	                  }
	                };
	                FeatureIndex.prototype.lookupSymbolFeatures = function lookupSymbolFeatures(symbolFeatureIndexes, serializedLayers, bucketIndex, sourceLayerIndex, filterSpec2, filterLayerIDs, availableImages, styleLayers) {
	                  var result = {};
	                  this.loadVTLayers();
	                  var filter2 = createFilter(filterSpec2);
	                  for (var i = 0, list = symbolFeatureIndexes; i < list.length; i += 1) {
	                    var symbolFeatureIndex = list[i];
	                    this.loadMatchingFeature(result, bucketIndex, sourceLayerIndex, symbolFeatureIndex, filter2, filterLayerIDs, availableImages, styleLayers, serializedLayers);
	                  }
	                  return result;
	                };
	                FeatureIndex.prototype.hasLayer = function hasLayer(id2) {
	                  for (var i$1 = 0, list$1 = this.bucketLayerIDs; i$1 < list$1.length; i$1 += 1) {
	                    var layerIDs = list$1[i$1];
	                    for (var i = 0, list = layerIDs; i < list.length; i += 1) {
	                      var layerID = list[i];
	                      if (id2 === layerID) {
	                        return true;
	                      }
	                    }
	                  }
	                  return false;
	                };
	                FeatureIndex.prototype.getId = function getId(feature, sourceLayerId) {
	                  var id2 = feature.id;
	                  if (this.promoteId) {
	                    var propName = typeof this.promoteId === "string" ? this.promoteId : this.promoteId[sourceLayerId];
	                    id2 = feature.properties[propName];
	                    if (typeof id2 === "boolean") {
	                      id2 = Number(id2);
	                    }
	                  }
	                  return id2;
	                };
	                register("FeatureIndex", FeatureIndex, {
	                  omit: [
	                    "rawTileData",
	                    "sourceLayerCoder"
	                  ]
	                });
	                function evaluateProperties(serializedProperties, styleLayerProperties, feature, featureState, availableImages) {
	                  return mapObject(serializedProperties, function(property, key) {
	                    var prop = styleLayerProperties instanceof PossiblyEvaluated ? styleLayerProperties.get(key) : null;
	                    return prop && prop.evaluate ? prop.evaluate(feature, featureState, availableImages) : prop;
	                  });
	                }
	                function getBounds(geometry) {
	                  var minX = Infinity;
	                  var minY = Infinity;
	                  var maxX = -Infinity;
	                  var maxY = -Infinity;
	                  for (var i = 0, list = geometry; i < list.length; i += 1) {
	                    var p = list[i];
	                    minX = Math.min(minX, p.x);
	                    minY = Math.min(minY, p.y);
	                    maxX = Math.max(maxX, p.x);
	                    maxY = Math.max(maxY, p.y);
	                  }
	                  return {
	                    minX,
	                    minY,
	                    maxX,
	                    maxY
	                  };
	                }
	                function topDownFeatureComparator(a, b) {
	                  return b - a;
	                }
	                var CLOCK_SKEW_RETRY_TIMEOUT = 3e4;
	                var Tile = function Tile2(tileID, size) {
	                  this.tileID = tileID;
	                  this.uid = uniqueId();
	                  this.uses = 0;
	                  this.tileSize = size;
	                  this.buckets = {};
	                  this.expirationTime = null;
	                  this.queryPadding = 0;
	                  this.hasSymbolBuckets = false;
	                  this.hasRTLText = false;
	                  this.dependencies = {};
	                  this.expiredRequestCount = 0;
	                  this.state = "loading";
	                };
	                Tile.prototype.registerFadeDuration = function registerFadeDuration(duration) {
	                  var fadeEndTime = duration + this.timeAdded;
	                  if (fadeEndTime < exported.now()) {
	                    return;
	                  }
	                  if (this.fadeEndTime && fadeEndTime < this.fadeEndTime) {
	                    return;
	                  }
	                  this.fadeEndTime = fadeEndTime;
	                };
	                Tile.prototype.wasRequested = function wasRequested() {
	                  return this.state === "errored" || this.state === "loaded" || this.state === "reloading";
	                };
	                Tile.prototype.loadVectorData = function loadVectorData(data, painter, justReloaded) {
	                  if (this.hasData()) {
	                    this.unloadVectorData();
	                  }
	                  this.state = "loaded";
	                  if (!data) {
	                    this.collisionBoxArray = new CollisionBoxArray();
	                    return;
	                  }
	                  if (data.featureIndex) {
	                    this.latestFeatureIndex = data.featureIndex;
	                    if (data.rawTileData) {
	                      this.latestRawTileData = data.rawTileData;
	                      this.latestFeatureIndex.rawTileData = data.rawTileData;
	                    } else if (this.latestRawTileData) {
	                      this.latestFeatureIndex.rawTileData = this.latestRawTileData;
	                    }
	                  }
	                  this.collisionBoxArray = data.collisionBoxArray;
	                  this.buckets = deserialize$1(data.buckets, painter.style);
	                  this.hasSymbolBuckets = false;
	                  for (var id2 in this.buckets) {
	                    var bucket = this.buckets[id2];
	                    if (bucket instanceof SymbolBucket) {
	                      this.hasSymbolBuckets = true;
	                      if (justReloaded) {
	                        bucket.justReloaded = true;
	                      } else {
	                        break;
	                      }
	                    }
	                  }
	                  this.hasRTLText = false;
	                  if (this.hasSymbolBuckets) {
	                    for (var id$1 in this.buckets) {
	                      var bucket$1 = this.buckets[id$1];
	                      if (bucket$1 instanceof SymbolBucket) {
	                        if (bucket$1.hasRTLText) {
	                          this.hasRTLText = true;
	                          lazyLoadRTLTextPlugin();
	                          break;
	                        }
	                      }
	                    }
	                  }
	                  this.queryPadding = 0;
	                  for (var id$2 in this.buckets) {
	                    var bucket$2 = this.buckets[id$2];
	                    this.queryPadding = Math.max(this.queryPadding, painter.style.getLayer(id$2).queryRadius(bucket$2));
	                  }
	                  if (data.imageAtlas) {
	                    this.imageAtlas = data.imageAtlas;
	                  }
	                  if (data.glyphAtlasImage) {
	                    this.glyphAtlasImage = data.glyphAtlasImage;
	                  }
	                };
	                Tile.prototype.unloadVectorData = function unloadVectorData() {
	                  for (var id2 in this.buckets) {
	                    this.buckets[id2].destroy();
	                  }
	                  this.buckets = {};
	                  if (this.imageAtlasTexture) {
	                    this.imageAtlasTexture.destroy();
	                  }
	                  if (this.imageAtlas) {
	                    this.imageAtlas = null;
	                  }
	                  if (this.glyphAtlasTexture) {
	                    this.glyphAtlasTexture.destroy();
	                  }
	                  this.latestFeatureIndex = null;
	                  this.state = "unloaded";
	                };
	                Tile.prototype.getBucket = function getBucket(layer2) {
	                  return this.buckets[layer2.id];
	                };
	                Tile.prototype.upload = function upload(context) {
	                  for (var id2 in this.buckets) {
	                    var bucket = this.buckets[id2];
	                    if (bucket.uploadPending()) {
	                      bucket.upload(context);
	                    }
	                  }
	                  var gl2 = context.gl;
	                  if (this.imageAtlas && !this.imageAtlas.uploaded) {
	                    this.imageAtlasTexture = new Texture(context, this.imageAtlas.image, gl2.RGBA);
	                    this.imageAtlas.uploaded = true;
	                  }
	                  if (this.glyphAtlasImage) {
	                    this.glyphAtlasTexture = new Texture(context, this.glyphAtlasImage, gl2.ALPHA);
	                    this.glyphAtlasImage = null;
	                  }
	                };
	                Tile.prototype.prepare = function prepare(imageManager) {
	                  if (this.imageAtlas) {
	                    this.imageAtlas.patchUpdatedImages(imageManager, this.imageAtlasTexture);
	                  }
	                };
	                Tile.prototype.queryRenderedFeatures = function queryRenderedFeatures(layers, serializedLayers, sourceFeatureState, queryGeometry, cameraQueryGeometry, scale2, params, transform, maxPitchScaleFactor, pixelPosMatrix) {
	                  if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) {
	                    return {};
	                  }
	                  return this.latestFeatureIndex.query({
	                    queryGeometry,
	                    cameraQueryGeometry,
	                    scale: scale2,
	                    tileSize: this.tileSize,
	                    pixelPosMatrix,
	                    transform,
	                    params,
	                    queryPadding: this.queryPadding * maxPitchScaleFactor
	                  }, layers, serializedLayers, sourceFeatureState);
	                };
	                Tile.prototype.querySourceFeatures = function querySourceFeatures(result, params) {
	                  var featureIndex = this.latestFeatureIndex;
	                  if (!featureIndex || !featureIndex.rawTileData) {
	                    return;
	                  }
	                  var vtLayers = featureIndex.loadVTLayers();
	                  var sourceLayer = params ? params.sourceLayer : "";
	                  var layer2 = vtLayers._geojsonTileLayer || vtLayers[sourceLayer];
	                  if (!layer2) {
	                    return;
	                  }
	                  var filter2 = createFilter(params && params.filter);
	                  var ref = this.tileID.canonical;
	                  var z = ref.z;
	                  var x = ref.x;
	                  var y = ref.y;
	                  var coord = {
	                    z,
	                    x,
	                    y
	                  };
	                  for (var i = 0; i < layer2.length; i++) {
	                    var feature = layer2.feature(i);
	                    if (filter2.filter(new EvaluationParameters(this.tileID.overscaledZ), feature)) {
	                      var id2 = featureIndex.getId(feature, sourceLayer);
	                      var geojsonFeature = new Feature(feature, z, x, y, id2);
	                      geojsonFeature.tile = coord;
	                      result.push(geojsonFeature);
	                    }
	                  }
	                };
	                Tile.prototype.hasData = function hasData() {
	                  return this.state === "loaded" || this.state === "reloading" || this.state === "expired";
	                };
	                Tile.prototype.patternsLoaded = function patternsLoaded() {
	                  return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
	                };
	                Tile.prototype.setExpiryData = function setExpiryData(data) {
	                  var prior = this.expirationTime;
	                  if (data.cacheControl) {
	                    var parsedCC = parseCacheControl(data.cacheControl);
	                    if (parsedCC["max-age"]) {
	                      this.expirationTime = Date.now() + parsedCC["max-age"] * 1e3;
	                    }
	                  } else if (data.expires) {
	                    this.expirationTime = new Date(data.expires).getTime();
	                  }
	                  if (this.expirationTime) {
	                    var now2 = Date.now();
	                    var isExpired = false;
	                    if (this.expirationTime > now2) {
	                      isExpired = false;
	                    } else if (!prior) {
	                      isExpired = true;
	                    } else if (this.expirationTime < prior) {
	                      isExpired = true;
	                    } else {
	                      var delta = this.expirationTime - prior;
	                      if (!delta) {
	                        isExpired = true;
	                      } else {
	                        this.expirationTime = now2 + Math.max(delta, CLOCK_SKEW_RETRY_TIMEOUT);
	                      }
	                    }
	                    if (isExpired) {
	                      this.expiredRequestCount++;
	                      this.state = "expired";
	                    } else {
	                      this.expiredRequestCount = 0;
	                    }
	                  }
	                };
	                Tile.prototype.getExpiryTimeout = function getExpiryTimeout() {
	                  if (this.expirationTime) {
	                    if (this.expiredRequestCount) {
	                      return 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31));
	                    } else {
	                      return Math.min(this.expirationTime - (/* @__PURE__ */ new Date()).getTime(), Math.pow(2, 31) - 1);
	                    }
	                  }
	                };
	                Tile.prototype.setFeatureState = function setFeatureState(states, painter) {
	                  if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || Object.keys(states).length === 0) {
	                    return;
	                  }
	                  var vtLayers = this.latestFeatureIndex.loadVTLayers();
	                  for (var id2 in this.buckets) {
	                    if (!painter.style.hasLayer(id2)) {
	                      continue;
	                    }
	                    var bucket = this.buckets[id2];
	                    var sourceLayerId = bucket.layers[0]["sourceLayer"] || "_geojsonTileLayer";
	                    var sourceLayer = vtLayers[sourceLayerId];
	                    var sourceLayerStates = states[sourceLayerId];
	                    if (!sourceLayer || !sourceLayerStates || Object.keys(sourceLayerStates).length === 0) {
	                      continue;
	                    }
	                    bucket.update(sourceLayerStates, sourceLayer, this.imageAtlas && this.imageAtlas.patternPositions || {});
	                    var layer2 = painter && painter.style && painter.style.getLayer(id2);
	                    if (layer2) {
	                      this.queryPadding = Math.max(this.queryPadding, layer2.queryRadius(bucket));
	                    }
	                  }
	                };
	                Tile.prototype.holdingForFade = function holdingForFade() {
	                  return this.symbolFadeHoldUntil !== undefined;
	                };
	                Tile.prototype.symbolFadeFinished = function symbolFadeFinished() {
	                  return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < exported.now();
	                };
	                Tile.prototype.clearFadeHold = function clearFadeHold() {
	                  this.symbolFadeHoldUntil = undefined;
	                };
	                Tile.prototype.setHoldDuration = function setHoldDuration(duration) {
	                  this.symbolFadeHoldUntil = exported.now() + duration;
	                };
	                Tile.prototype.setDependencies = function setDependencies(namespace, dependencies) {
	                  var index = {};
	                  for (var i = 0, list = dependencies; i < list.length; i += 1) {
	                    var dep = list[i];
	                    index[dep] = true;
	                  }
	                  this.dependencies[namespace] = index;
	                };
	                Tile.prototype.hasDependency = function hasDependency(namespaces, keys) {
	                  for (var i$1 = 0, list$1 = namespaces; i$1 < list$1.length; i$1 += 1) {
	                    var namespace = list$1[i$1];
	                    var dependencies = this.dependencies[namespace];
	                    if (dependencies) {
	                      for (var i = 0, list = keys; i < list.length; i += 1) {
	                        var key = list[i];
	                        if (dependencies[key]) {
	                          return true;
	                        }
	                      }
	                    }
	                  }
	                  return false;
	                };
	                var refProperties = [
	                  "type",
	                  "source",
	                  "source-layer",
	                  "minzoom",
	                  "maxzoom",
	                  "filter",
	                  "layout"
	                ];
	                var performance2 = self.performance;
	                var RequestPerformance = function RequestPerformance2(request) {
	                  this._marks = {
	                    start: [
	                      request.url,
	                      "start"
	                    ].join("#"),
	                    end: [
	                      request.url,
	                      "end"
	                    ].join("#"),
	                    measure: request.url.toString()
	                  };
	                  performance2.mark(this._marks.start);
	                };
	                RequestPerformance.prototype.finish = function finish() {
	                  performance2.mark(this._marks.end);
	                  var resourceTimingData = performance2.getEntriesByName(this._marks.measure);
	                  if (resourceTimingData.length === 0) {
	                    performance2.measure(this._marks.measure, this._marks.start, this._marks.end);
	                    resourceTimingData = performance2.getEntriesByName(this._marks.measure);
	                    performance2.clearMarks(this._marks.start);
	                    performance2.clearMarks(this._marks.end);
	                    performance2.clearMeasures(this._marks.measure);
	                  }
	                  return resourceTimingData;
	                };
	                exports2.Actor = Actor;
	                exports2.AlphaImage = AlphaImage;
	                exports2.CanonicalTileID = CanonicalTileID;
	                exports2.CollisionBoxArray = CollisionBoxArray;
	                exports2.Color = Color;
	                exports2.DEMData = DEMData;
	                exports2.DataConstantProperty = DataConstantProperty;
	                exports2.DictionaryCoder = DictionaryCoder;
	                exports2.EXTENT = EXTENT$1;
	                exports2.ErrorEvent = ErrorEvent;
	                exports2.EvaluationParameters = EvaluationParameters;
	                exports2.Event = Event;
	                exports2.Evented = Evented;
	                exports2.FeatureIndex = FeatureIndex;
	                exports2.FillBucket = FillBucket;
	                exports2.FillExtrusionBucket = FillExtrusionBucket;
	                exports2.ImageAtlas = ImageAtlas;
	                exports2.ImagePosition = ImagePosition;
	                exports2.LineBucket = LineBucket;
	                exports2.LngLat = LngLat;
	                exports2.LngLatBounds = LngLatBounds;
	                exports2.MercatorCoordinate = MercatorCoordinate;
	                exports2.ONE_EM = ONE_EM;
	                exports2.OverscaledTileID = OverscaledTileID;
	                exports2.Point = pointGeometry;
	                exports2.Point$1 = pointGeometry;
	                exports2.Properties = Properties;
	                exports2.Protobuf = pbf;
	                exports2.RGBAImage = RGBAImage;
	                exports2.RequestManager = RequestManager;
	                exports2.RequestPerformance = RequestPerformance;
	                exports2.ResourceType = ResourceType;
	                exports2.SegmentVector = SegmentVector;
	                exports2.SourceFeatureState = SourceFeatureState;
	                exports2.StructArrayLayout1ui2 = StructArrayLayout1ui2;
	                exports2.StructArrayLayout2f1f2i16 = StructArrayLayout2f1f2i16;
	                exports2.StructArrayLayout2i4 = StructArrayLayout2i4;
	                exports2.StructArrayLayout3ui6 = StructArrayLayout3ui6;
	                exports2.StructArrayLayout4i8 = StructArrayLayout4i8;
	                exports2.SymbolBucket = SymbolBucket;
	                exports2.Texture = Texture;
	                exports2.Tile = Tile;
	                exports2.Transitionable = Transitionable;
	                exports2.Uniform1f = Uniform1f;
	                exports2.Uniform1i = Uniform1i;
	                exports2.Uniform2f = Uniform2f;
	                exports2.Uniform3f = Uniform3f;
	                exports2.Uniform4f = Uniform4f;
	                exports2.UniformColor = UniformColor;
	                exports2.UniformMatrix4f = UniformMatrix4f;
	                exports2.UnwrappedTileID = UnwrappedTileID;
	                exports2.ValidationError = ValidationError;
	                exports2.WritingMode = WritingMode;
	                exports2.ZoomHistory = ZoomHistory;
	                exports2.add = add;
	                exports2.addDynamicAttributes = addDynamicAttributes;
	                exports2.asyncAll = asyncAll;
	                exports2.bezier = bezier;
	                exports2.bindAll = bindAll;
	                exports2.browser = exported;
	                exports2.cacheEntryPossiblyAdded = cacheEntryPossiblyAdded;
	                exports2.clamp = clamp;
	                exports2.clearTileCache = clearTileCache;
	                exports2.clipLine = clipLine;
	                exports2.clone = clone$1;
	                exports2.clone$1 = clone;
	                exports2.clone$2 = clone$2;
	                exports2.collisionCircleLayout = collisionCircleLayout;
	                exports2.config = config;
	                exports2.create = create$2;
	                exports2.create$1 = create$1;
	                exports2.create$2 = create;
	                exports2.createCommonjsModule = createCommonjsModule;
	                exports2.createExpression = createExpression;
	                exports2.createLayout = createLayout;
	                exports2.createStyleLayer = createStyleLayer;
	                exports2.cross = cross;
	                exports2.deepEqual = deepEqual;
	                exports2.dot = dot;
	                exports2.dot$1 = dot$1;
	                exports2.ease = ease;
	                exports2.emitValidationErrors = emitValidationErrors;
	                exports2.endsWith = endsWith;
	                exports2.enforceCacheSizeLimit = enforceCacheSizeLimit;
	                exports2.evaluateSizeForFeature = evaluateSizeForFeature;
	                exports2.evaluateSizeForZoom = evaluateSizeForZoom;
	                exports2.evaluateVariableOffset = evaluateVariableOffset;
	                exports2.evented = evented;
	                exports2.extend = extend;
	                exports2.featureFilter = createFilter;
	                exports2.filterObject = filterObject;
	                exports2.fromRotation = fromRotation;
	                exports2.getAnchorAlignment = getAnchorAlignment;
	                exports2.getAnchorJustification = getAnchorJustification;
	                exports2.getArrayBuffer = getArrayBuffer;
	                exports2.getImage = getImage;
	                exports2.getJSON = getJSON;
	                exports2.getRTLTextPluginStatus = getRTLTextPluginStatus;
	                exports2.getReferrer = getReferrer;
	                exports2.getVideo = getVideo;
	                exports2.identity = identity2;
	                exports2.invert = invert;
	                exports2.isChar = unicodeBlockLookup;
	                exports2.isMapboxURL = isMapboxURL;
	                exports2.keysDifference = keysDifference;
	                exports2.makeRequest = makeRequest;
	                exports2.mapObject = mapObject;
	                exports2.mercatorXfromLng = mercatorXfromLng$1;
	                exports2.mercatorYfromLat = mercatorYfromLat$1;
	                exports2.mercatorZfromAltitude = mercatorZfromAltitude;
	                exports2.mul = mul;
	                exports2.multiply = multiply;
	                exports2.mvt = vectorTile;
	                exports2.normalize = normalize;
	                exports2.number = number2;
	                exports2.offscreenCanvasSupported = offscreenCanvasSupported;
	                exports2.ortho = ortho;
	                exports2.parseGlyphPBF = parseGlyphPBF;
	                exports2.pbf = pbf;
	                exports2.performSymbolLayout = performSymbolLayout;
	                exports2.perspective = perspective;
	                exports2.pick = pick;
	                exports2.plugin = plugin;
	                exports2.polygonIntersectsPolygon = polygonIntersectsPolygon;
	                exports2.postMapLoadEvent = postMapLoadEvent;
	                exports2.postTurnstileEvent = postTurnstileEvent;
	                exports2.potpack = potpack;
	                exports2.refProperties = refProperties;
	                exports2.register = register;
	                exports2.registerForPluginStateChange = registerForPluginStateChange;
	                exports2.rotate = rotate;
	                exports2.rotateX = rotateX;
	                exports2.rotateZ = rotateZ;
	                exports2.scale = scale;
	                exports2.scale$1 = scale$2;
	                exports2.scale$2 = scale$1;
	                exports2.setCacheLimits = setCacheLimits;
	                exports2.setRTLTextPlugin = setRTLTextPlugin;
	                exports2.sphericalToCartesian = sphericalToCartesian;
	                exports2.sqrLen = sqrLen;
	                exports2.styleSpec = spec;
	                exports2.sub = sub;
	                exports2.symbolSize = symbolSize;
	                exports2.transformMat3 = transformMat3;
	                exports2.transformMat4 = transformMat4;
	                exports2.translate = translate$1;
	                exports2.triggerPluginCompletionEvent = triggerPluginCompletionEvent;
	                exports2.uniqueId = uniqueId;
	                exports2.validateCustomStyleLayer = validateCustomStyleLayer;
	                exports2.validateLight = validateLight$1;
	                exports2.validateStyle = validateStyle;
	                exports2.values = values;
	                exports2.vectorTile = vectorTile;
	                exports2.version = version;
	                exports2.warnOnce = warnOnce;
	                exports2.webpSupported = exported$1;
	                exports2.window = self;
	                exports2.wrap = wrap;
	              });
	              define2(["./shared"], function(performance$1) {
	                function stringify(obj) {
	                  var type = typeof obj;
	                  if (type === "number" || type === "boolean" || type === "string" || obj === undefined || obj === null) {
	                    return JSON.stringify(obj);
	                  }
	                  if (Array.isArray(obj)) {
	                    var str$1 = "[";
	                    for (var i$1 = 0, list = obj; i$1 < list.length; i$1 += 1) {
	                      var val = list[i$1];
	                      str$1 += stringify(val) + ",";
	                    }
	                    return str$1 + "]";
	                  }
	                  var keys = Object.keys(obj).sort();
	                  var str = "{";
	                  for (var i = 0; i < keys.length; i++) {
	                    str += JSON.stringify(keys[i]) + ":" + stringify(obj[keys[i]]) + ",";
	                  }
	                  return str + "}";
	                }
	                function getKey(layer) {
	                  var key = "";
	                  for (var i = 0, list = performance$1.refProperties; i < list.length; i += 1) {
	                    var k = list[i];
	                    key += "/" + stringify(layer[k]);
	                  }
	                  return key;
	                }
	                function groupByLayout(layers, cachedKeys) {
	                  var groups = {};
	                  for (var i = 0; i < layers.length; i++) {
	                    var k = cachedKeys && cachedKeys[layers[i].id] || getKey(layers[i]);
	                    if (cachedKeys) {
	                      cachedKeys[layers[i].id] = k;
	                    }
	                    var group = groups[k];
	                    if (!group) {
	                      group = groups[k] = [];
	                    }
	                    group.push(layers[i]);
	                  }
	                  var result = [];
	                  for (var k$1 in groups) {
	                    result.push(groups[k$1]);
	                  }
	                  return result;
	                }
	                var StyleLayerIndex = function StyleLayerIndex2(layerConfigs) {
	                  this.keyCache = {};
	                  if (layerConfigs) {
	                    this.replace(layerConfigs);
	                  }
	                };
	                StyleLayerIndex.prototype.replace = function replace(layerConfigs) {
	                  this._layerConfigs = {};
	                  this._layers = {};
	                  this.update(layerConfigs, []);
	                };
	                StyleLayerIndex.prototype.update = function update(layerConfigs, removedIds) {
	                  var this$1$1 = this;
	                  for (var i = 0, list = layerConfigs; i < list.length; i += 1) {
	                    var layerConfig = list[i];
	                    this._layerConfigs[layerConfig.id] = layerConfig;
	                    var layer = this._layers[layerConfig.id] = performance$1.createStyleLayer(layerConfig);
	                    layer._featureFilter = performance$1.featureFilter(layer.filter);
	                    if (this.keyCache[layerConfig.id]) {
	                      delete this.keyCache[layerConfig.id];
	                    }
	                  }
	                  for (var i$1 = 0, list$1 = removedIds; i$1 < list$1.length; i$1 += 1) {
	                    var id = list$1[i$1];
	                    delete this.keyCache[id];
	                    delete this._layerConfigs[id];
	                    delete this._layers[id];
	                  }
	                  this.familiesBySource = {};
	                  var groups = groupByLayout(performance$1.values(this._layerConfigs), this.keyCache);
	                  for (var i$2 = 0, list$2 = groups; i$2 < list$2.length; i$2 += 1) {
	                    var layerConfigs$1 = list$2[i$2];
	                    var layers = layerConfigs$1.map(function(layerConfig2) {
	                      return this$1$1._layers[layerConfig2.id];
	                    });
	                    var layer$1 = layers[0];
	                    if (layer$1.visibility === "none") {
	                      continue;
	                    }
	                    var sourceId = layer$1.source || "";
	                    var sourceGroup = this.familiesBySource[sourceId];
	                    if (!sourceGroup) {
	                      sourceGroup = this.familiesBySource[sourceId] = {};
	                    }
	                    var sourceLayerId = layer$1.sourceLayer || "_geojsonTileLayer";
	                    var sourceLayerFamilies = sourceGroup[sourceLayerId];
	                    if (!sourceLayerFamilies) {
	                      sourceLayerFamilies = sourceGroup[sourceLayerId] = [];
	                    }
	                    sourceLayerFamilies.push(layers);
	                  }
	                };
	                var padding = 1;
	                var GlyphAtlas = function GlyphAtlas2(stacks) {
	                  var positions = {};
	                  var bins = [];
	                  for (var stack in stacks) {
	                    var glyphs = stacks[stack];
	                    var stackPositions = positions[stack] = {};
	                    for (var id in glyphs) {
	                      var src = glyphs[+id];
	                      if (!src || src.bitmap.width === 0 || src.bitmap.height === 0) {
	                        continue;
	                      }
	                      var bin = {
	                        x: 0,
	                        y: 0,
	                        w: src.bitmap.width + 2 * padding,
	                        h: src.bitmap.height + 2 * padding
	                      };
	                      bins.push(bin);
	                      stackPositions[id] = {
	                        rect: bin,
	                        metrics: src.metrics
	                      };
	                    }
	                  }
	                  var ref = performance$1.potpack(bins);
	                  var w = ref.w;
	                  var h = ref.h;
	                  var image = new performance$1.AlphaImage({
	                    width: w || 1,
	                    height: h || 1
	                  });
	                  for (var stack$1 in stacks) {
	                    var glyphs$1 = stacks[stack$1];
	                    for (var id$1 in glyphs$1) {
	                      var src$1 = glyphs$1[+id$1];
	                      if (!src$1 || src$1.bitmap.width === 0 || src$1.bitmap.height === 0) {
	                        continue;
	                      }
	                      var bin$1 = positions[stack$1][id$1].rect;
	                      performance$1.AlphaImage.copy(src$1.bitmap, image, {
	                        x: 0,
	                        y: 0
	                      }, {
	                        x: bin$1.x + padding,
	                        y: bin$1.y + padding
	                      }, src$1.bitmap);
	                    }
	                  }
	                  this.image = image;
	                  this.positions = positions;
	                };
	                performance$1.register("GlyphAtlas", GlyphAtlas);
	                var WorkerTile = function WorkerTile2(params) {
	                  this.tileID = new performance$1.OverscaledTileID(params.tileID.overscaledZ, params.tileID.wrap, params.tileID.canonical.z, params.tileID.canonical.x, params.tileID.canonical.y);
	                  this.uid = params.uid;
	                  this.zoom = params.zoom;
	                  this.pixelRatio = params.pixelRatio;
	                  this.tileSize = params.tileSize;
	                  this.source = params.source;
	                  this.overscaling = this.tileID.overscaleFactor();
	                  this.showCollisionBoxes = params.showCollisionBoxes;
	                  this.collectResourceTiming = !!params.collectResourceTiming;
	                  this.returnDependencies = !!params.returnDependencies;
	                  this.promoteId = params.promoteId;
	                };
	                WorkerTile.prototype.parse = function parse(data, layerIndex, availableImages, actor, callback) {
	                  var this$1$1 = this;
	                  this.status = "parsing";
	                  this.data = data;
	                  this.collisionBoxArray = new performance$1.CollisionBoxArray();
	                  var sourceLayerCoder = new performance$1.DictionaryCoder(Object.keys(data.layers).sort());
	                  var featureIndex = new performance$1.FeatureIndex(this.tileID, this.promoteId);
	                  featureIndex.bucketLayerIDs = [];
	                  var buckets = {};
	                  var options = {
	                    featureIndex,
	                    iconDependencies: {},
	                    patternDependencies: {},
	                    glyphDependencies: {},
	                    availableImages
	                  };
	                  var layerFamilies = layerIndex.familiesBySource[this.source];
	                  for (var sourceLayerId in layerFamilies) {
	                    var sourceLayer = data.layers[sourceLayerId];
	                    if (!sourceLayer) {
	                      continue;
	                    }
	                    if (sourceLayer.version === 1) {
	                      performance$1.warnOnce('Vector tile source "' + this.source + '" layer "' + sourceLayerId + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
	                    }
	                    var sourceLayerIndex = sourceLayerCoder.encode(sourceLayerId);
	                    var features = [];
	                    for (var index = 0; index < sourceLayer.length; index++) {
	                      var feature = sourceLayer.feature(index);
	                      var id = featureIndex.getId(feature, sourceLayerId);
	                      features.push({
	                        feature,
	                        id,
	                        index,
	                        sourceLayerIndex
	                      });
	                    }
	                    for (var i = 0, list = layerFamilies[sourceLayerId]; i < list.length; i += 1) {
	                      var family = list[i];
	                      var layer = family[0];
	                      if (layer.minzoom && this.zoom < Math.floor(layer.minzoom)) {
	                        continue;
	                      }
	                      if (layer.maxzoom && this.zoom >= layer.maxzoom) {
	                        continue;
	                      }
	                      if (layer.visibility === "none") {
	                        continue;
	                      }
	                      recalculateLayers(family, this.zoom, availableImages);
	                      var bucket = buckets[layer.id] = layer.createBucket({
	                        index: featureIndex.bucketLayerIDs.length,
	                        layers: family,
	                        zoom: this.zoom,
	                        pixelRatio: this.pixelRatio,
	                        overscaling: this.overscaling,
	                        collisionBoxArray: this.collisionBoxArray,
	                        sourceLayerIndex,
	                        sourceID: this.source
	                      });
	                      bucket.populate(features, options, this.tileID.canonical);
	                      featureIndex.bucketLayerIDs.push(family.map(function(l) {
	                        return l.id;
	                      }));
	                    }
	                  }
	                  var error;
	                  var glyphMap;
	                  var iconMap;
	                  var patternMap;
	                  var stacks = performance$1.mapObject(options.glyphDependencies, function(glyphs) {
	                    return Object.keys(glyphs).map(Number);
	                  });
	                  if (Object.keys(stacks).length) {
	                    actor.send("getGlyphs", {
	                      uid: this.uid,
	                      stacks
	                    }, function(err, result) {
	                      if (!error) {
	                        error = err;
	                        glyphMap = result;
	                        maybePrepare.call(this$1$1);
	                      }
	                    });
	                  } else {
	                    glyphMap = {};
	                  }
	                  var icons = Object.keys(options.iconDependencies);
	                  if (icons.length) {
	                    actor.send("getImages", {
	                      icons,
	                      source: this.source,
	                      tileID: this.tileID,
	                      type: "icons"
	                    }, function(err, result) {
	                      if (!error) {
	                        error = err;
	                        iconMap = result;
	                        maybePrepare.call(this$1$1);
	                      }
	                    });
	                  } else {
	                    iconMap = {};
	                  }
	                  var patterns = Object.keys(options.patternDependencies);
	                  if (patterns.length) {
	                    actor.send("getImages", {
	                      icons: patterns,
	                      source: this.source,
	                      tileID: this.tileID,
	                      type: "patterns"
	                    }, function(err, result) {
	                      if (!error) {
	                        error = err;
	                        patternMap = result;
	                        maybePrepare.call(this$1$1);
	                      }
	                    });
	                  } else {
	                    patternMap = {};
	                  }
	                  maybePrepare.call(this);
	                  function maybePrepare() {
	                    if (error) {
	                      return callback(error);
	                    } else if (glyphMap && iconMap && patternMap) {
	                      var glyphAtlas = new GlyphAtlas(glyphMap);
	                      var imageAtlas = new performance$1.ImageAtlas(iconMap, patternMap);
	                      for (var key in buckets) {
	                        var bucket2 = buckets[key];
	                        if (bucket2 instanceof performance$1.SymbolBucket) {
	                          recalculateLayers(bucket2.layers, this.zoom, availableImages);
	                          performance$1.performSymbolLayout(bucket2, glyphMap, glyphAtlas.positions, iconMap, imageAtlas.iconPositions, this.showCollisionBoxes, this.tileID.canonical);
	                        } else if (bucket2.hasPattern && (bucket2 instanceof performance$1.LineBucket || bucket2 instanceof performance$1.FillBucket || bucket2 instanceof performance$1.FillExtrusionBucket)) {
	                          recalculateLayers(bucket2.layers, this.zoom, availableImages);
	                          bucket2.addFeatures(options, this.tileID.canonical, imageAtlas.patternPositions);
	                        }
	                      }
	                      this.status = "done";
	                      callback(null, {
	                        buckets: performance$1.values(buckets).filter(function(b) {
	                          return !b.isEmpty();
	                        }),
	                        featureIndex,
	                        collisionBoxArray: this.collisionBoxArray,
	                        glyphAtlasImage: glyphAtlas.image,
	                        imageAtlas,
	                        glyphMap: this.returnDependencies ? glyphMap : null,
	                        iconMap: this.returnDependencies ? iconMap : null,
	                        glyphPositions: this.returnDependencies ? glyphAtlas.positions : null
	                      });
	                    }
	                  }
	                };
	                function recalculateLayers(layers, zoom, availableImages) {
	                  var parameters = new performance$1.EvaluationParameters(zoom);
	                  for (var i = 0, list = layers; i < list.length; i += 1) {
	                    var layer = list[i];
	                    layer.recalculate(parameters, availableImages);
	                  }
	                }
	                function loadVectorTile(params, callback) {
	                  var request = performance$1.getArrayBuffer(params.request, function(err, data, cacheControl, expires) {
	                    if (err) {
	                      callback(err);
	                    } else if (data) {
	                      callback(null, {
	                        vectorTile: new performance$1.vectorTile.VectorTile(new performance$1.pbf(data)),
	                        rawData: data,
	                        cacheControl,
	                        expires
	                      });
	                    }
	                  });
	                  return function() {
	                    request.cancel();
	                    callback();
	                  };
	                }
	                var VectorTileWorkerSource = function VectorTileWorkerSource2(actor, layerIndex, availableImages, loadVectorData) {
	                  this.actor = actor;
	                  this.layerIndex = layerIndex;
	                  this.availableImages = availableImages;
	                  this.loadVectorData = loadVectorData || loadVectorTile;
	                  this.loading = {};
	                  this.loaded = {};
	                };
	                VectorTileWorkerSource.prototype.loadTile = function loadTile(params, callback) {
	                  var this$1$1 = this;
	                  var uid = params.uid;
	                  if (!this.loading) {
	                    this.loading = {};
	                  }
	                  var perf = params && params.request && params.request.collectResourceTiming ? new performance$1.RequestPerformance(params.request) : false;
	                  var workerTile = this.loading[uid] = new WorkerTile(params);
	                  workerTile.abort = this.loadVectorData(params, function(err, response) {
	                    delete this$1$1.loading[uid];
	                    if (err || !response) {
	                      workerTile.status = "done";
	                      this$1$1.loaded[uid] = workerTile;
	                      return callback(err);
	                    }
	                    var rawTileData = response.rawData;
	                    var cacheControl = {};
	                    if (response.expires) {
	                      cacheControl.expires = response.expires;
	                    }
	                    if (response.cacheControl) {
	                      cacheControl.cacheControl = response.cacheControl;
	                    }
	                    var resourceTiming = {};
	                    if (perf) {
	                      var resourceTimingData = perf.finish();
	                      if (resourceTimingData) {
	                        resourceTiming.resourceTiming = JSON.parse(JSON.stringify(resourceTimingData));
	                      }
	                    }
	                    workerTile.vectorTile = response.vectorTile;
	                    workerTile.parse(response.vectorTile, this$1$1.layerIndex, this$1$1.availableImages, this$1$1.actor, function(err2, result) {
	                      if (err2 || !result) {
	                        return callback(err2);
	                      }
	                      callback(null, performance$1.extend({ rawTileData: rawTileData.slice(0) }, result, cacheControl, resourceTiming));
	                    });
	                    this$1$1.loaded = this$1$1.loaded || {};
	                    this$1$1.loaded[uid] = workerTile;
	                  });
	                };
	                VectorTileWorkerSource.prototype.reloadTile = function reloadTile(params, callback) {
	                  var this$1$1 = this;
	                  var loaded = this.loaded, uid = params.uid, vtSource = this;
	                  if (loaded && loaded[uid]) {
	                    var workerTile = loaded[uid];
	                    workerTile.showCollisionBoxes = params.showCollisionBoxes;
	                    var done = function(err, data) {
	                      var reloadCallback = workerTile.reloadCallback;
	                      if (reloadCallback) {
	                        delete workerTile.reloadCallback;
	                        workerTile.parse(workerTile.vectorTile, vtSource.layerIndex, this$1$1.availableImages, vtSource.actor, reloadCallback);
	                      }
	                      callback(err, data);
	                    };
	                    if (workerTile.status === "parsing") {
	                      workerTile.reloadCallback = done;
	                    } else if (workerTile.status === "done") {
	                      if (workerTile.vectorTile) {
	                        workerTile.parse(workerTile.vectorTile, this.layerIndex, this.availableImages, this.actor, done);
	                      } else {
	                        done();
	                      }
	                    }
	                  }
	                };
	                VectorTileWorkerSource.prototype.abortTile = function abortTile(params, callback) {
	                  var loading = this.loading, uid = params.uid;
	                  if (loading && loading[uid] && loading[uid].abort) {
	                    loading[uid].abort();
	                    delete loading[uid];
	                  }
	                  callback();
	                };
	                VectorTileWorkerSource.prototype.removeTile = function removeTile(params, callback) {
	                  var loaded = this.loaded, uid = params.uid;
	                  if (loaded && loaded[uid]) {
	                    delete loaded[uid];
	                  }
	                  callback();
	                };
	                var ImageBitmap = performance$1.window.ImageBitmap;
	                var RasterDEMTileWorkerSource = function RasterDEMTileWorkerSource2() {
	                  this.loaded = {};
	                };
	                RasterDEMTileWorkerSource.prototype.loadTile = function loadTile(params, callback) {
	                  var uid = params.uid;
	                  var encoding = params.encoding;
	                  var rawImageData = params.rawImageData;
	                  var imagePixels = ImageBitmap && rawImageData instanceof ImageBitmap ? this.getImageData(rawImageData) : rawImageData;
	                  var dem = new performance$1.DEMData(uid, imagePixels, encoding);
	                  this.loaded = this.loaded || {};
	                  this.loaded[uid] = dem;
	                  callback(null, dem);
	                };
	                RasterDEMTileWorkerSource.prototype.getImageData = function getImageData(imgBitmap) {
	                  if (!this.offscreenCanvas || !this.offscreenCanvasContext) {
	                    this.offscreenCanvas = new OffscreenCanvas(imgBitmap.width, imgBitmap.height);
	                    this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d");
	                  }
	                  this.offscreenCanvas.width = imgBitmap.width;
	                  this.offscreenCanvas.height = imgBitmap.height;
	                  this.offscreenCanvasContext.drawImage(imgBitmap, 0, 0, imgBitmap.width, imgBitmap.height);
	                  var imgData = this.offscreenCanvasContext.getImageData(-1, -1, imgBitmap.width + 2, imgBitmap.height + 2);
	                  this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height);
	                  return new performance$1.RGBAImage({
	                    width: imgData.width,
	                    height: imgData.height
	                  }, imgData.data);
	                };
	                RasterDEMTileWorkerSource.prototype.removeTile = function removeTile(params) {
	                  var loaded = this.loaded, uid = params.uid;
	                  if (loaded && loaded[uid]) {
	                    delete loaded[uid];
	                  }
	                };
	                var geojsonRewind = rewind;
	                function rewind(gj, outer) {
	                  var type = gj && gj.type, i;
	                  if (type === "FeatureCollection") {
	                    for (i = 0; i < gj.features.length; i++) {
	                      rewind(gj.features[i], outer);
	                    }
	                  } else if (type === "GeometryCollection") {
	                    for (i = 0; i < gj.geometries.length; i++) {
	                      rewind(gj.geometries[i], outer);
	                    }
	                  } else if (type === "Feature") {
	                    rewind(gj.geometry, outer);
	                  } else if (type === "Polygon") {
	                    rewindRings(gj.coordinates, outer);
	                  } else if (type === "MultiPolygon") {
	                    for (i = 0; i < gj.coordinates.length; i++) {
	                      rewindRings(gj.coordinates[i], outer);
	                    }
	                  }
	                  return gj;
	                }
	                function rewindRings(rings, outer) {
	                  if (rings.length === 0) {
	                    return;
	                  }
	                  rewindRing(rings[0], outer);
	                  for (var i = 1; i < rings.length; i++) {
	                    rewindRing(rings[i], !outer);
	                  }
	                }
	                function rewindRing(ring, dir) {
	                  var area = 0;
	                  for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
	                    area += (ring[i][0] - ring[j][0]) * (ring[j][1] + ring[i][1]);
	                  }
	                  if (area >= 0 !== !!dir) {
	                    ring.reverse();
	                  }
	                }
	                var toGeoJSON = performance$1.vectorTile.VectorTileFeature.prototype.toGeoJSON;
	                var FeatureWrapper = function FeatureWrapper2(feature) {
	                  this._feature = feature;
	                  this.extent = performance$1.EXTENT;
	                  this.type = feature.type;
	                  this.properties = feature.tags;
	                  if ("id" in feature && !isNaN(feature.id)) {
	                    this.id = parseInt(feature.id, 10);
	                  }
	                };
	                FeatureWrapper.prototype.loadGeometry = function loadGeometry() {
	                  if (this._feature.type === 1) {
	                    var geometry = [];
	                    for (var i = 0, list = this._feature.geometry; i < list.length; i += 1) {
	                      var point = list[i];
	                      geometry.push([new performance$1.Point$1(point[0], point[1])]);
	                    }
	                    return geometry;
	                  } else {
	                    var geometry$1 = [];
	                    for (var i$2 = 0, list$2 = this._feature.geometry; i$2 < list$2.length; i$2 += 1) {
	                      var ring = list$2[i$2];
	                      var newRing = [];
	                      for (var i$1 = 0, list$1 = ring; i$1 < list$1.length; i$1 += 1) {
	                        var point$1 = list$1[i$1];
	                        newRing.push(new performance$1.Point$1(point$1[0], point$1[1]));
	                      }
	                      geometry$1.push(newRing);
	                    }
	                    return geometry$1;
	                  }
	                };
	                FeatureWrapper.prototype.toGeoJSON = function toGeoJSON$1(x, y, z) {
	                  return toGeoJSON.call(this, x, y, z);
	                };
	                var GeoJSONWrapper = function GeoJSONWrapper2(features) {
	                  this.layers = { "_geojsonTileLayer": this };
	                  this.name = "_geojsonTileLayer";
	                  this.extent = performance$1.EXTENT;
	                  this.length = features.length;
	                  this._features = features;
	                };
	                GeoJSONWrapper.prototype.feature = function feature(i) {
	                  return new FeatureWrapper(this._features[i]);
	                };
	                var VectorTileFeature = performance$1.vectorTile.VectorTileFeature;
	                var geojson_wrapper = GeoJSONWrapper$1;
	                function GeoJSONWrapper$1(features, options) {
	                  this.options = options || {};
	                  this.features = features;
	                  this.length = features.length;
	                }
	                GeoJSONWrapper$1.prototype.feature = function(i) {
	                  return new FeatureWrapper$1(this.features[i], this.options.extent);
	                };
	                function FeatureWrapper$1(feature, extent2) {
	                  this.id = typeof feature.id === "number" ? feature.id : undefined;
	                  this.type = feature.type;
	                  this.rawGeometry = feature.type === 1 ? [feature.geometry] : feature.geometry;
	                  this.properties = feature.tags;
	                  this.extent = extent2 || 4096;
	                }
	                FeatureWrapper$1.prototype.loadGeometry = function() {
	                  var rings = this.rawGeometry;
	                  this.geometry = [];
	                  for (var i = 0; i < rings.length; i++) {
	                    var ring = rings[i];
	                    var newRing = [];
	                    for (var j = 0; j < ring.length; j++) {
	                      newRing.push(new performance$1.Point$1(ring[j][0], ring[j][1]));
	                    }
	                    this.geometry.push(newRing);
	                  }
	                  return this.geometry;
	                };
	                FeatureWrapper$1.prototype.bbox = function() {
	                  if (!this.geometry) {
	                    this.loadGeometry();
	                  }
	                  var rings = this.geometry;
	                  var x1 = Infinity;
	                  var x2 = -Infinity;
	                  var y1 = Infinity;
	                  var y2 = -Infinity;
	                  for (var i = 0; i < rings.length; i++) {
	                    var ring = rings[i];
	                    for (var j = 0; j < ring.length; j++) {
	                      var coord = ring[j];
	                      x1 = Math.min(x1, coord.x);
	                      x2 = Math.max(x2, coord.x);
	                      y1 = Math.min(y1, coord.y);
	                      y2 = Math.max(y2, coord.y);
	                    }
	                  }
	                  return [
	                    x1,
	                    y1,
	                    x2,
	                    y2
	                  ];
	                };
	                FeatureWrapper$1.prototype.toGeoJSON = VectorTileFeature.prototype.toGeoJSON;
	                var vtPbf = fromVectorTileJs;
	                var fromVectorTileJs_1 = fromVectorTileJs;
	                var fromGeojsonVt_1 = fromGeojsonVt;
	                var GeoJSONWrapper_1 = geojson_wrapper;
	                function fromVectorTileJs(tile) {
	                  var out = new performance$1.pbf();
	                  writeTile(tile, out);
	                  return out.finish();
	                }
	                function fromGeojsonVt(layers, options) {
	                  options = options || {};
	                  var l = {};
	                  for (var k in layers) {
	                    l[k] = new geojson_wrapper(layers[k].features, options);
	                    l[k].name = k;
	                    l[k].version = options.version;
	                    l[k].extent = options.extent;
	                  }
	                  return fromVectorTileJs({ layers: l });
	                }
	                function writeTile(tile, pbf) {
	                  for (var key in tile.layers) {
	                    pbf.writeMessage(3, writeLayer, tile.layers[key]);
	                  }
	                }
	                function writeLayer(layer, pbf) {
	                  pbf.writeVarintField(15, layer.version || 1);
	                  pbf.writeStringField(1, layer.name || "");
	                  pbf.writeVarintField(5, layer.extent || 4096);
	                  var i;
	                  var context = {
	                    keys: [],
	                    values: [],
	                    keycache: {},
	                    valuecache: {}
	                  };
	                  for (i = 0; i < layer.length; i++) {
	                    context.feature = layer.feature(i);
	                    pbf.writeMessage(2, writeFeature, context);
	                  }
	                  var keys = context.keys;
	                  for (i = 0; i < keys.length; i++) {
	                    pbf.writeStringField(3, keys[i]);
	                  }
	                  var values = context.values;
	                  for (i = 0; i < values.length; i++) {
	                    pbf.writeMessage(4, writeValue, values[i]);
	                  }
	                }
	                function writeFeature(context, pbf) {
	                  var feature = context.feature;
	                  if (feature.id !== undefined) {
	                    pbf.writeVarintField(1, feature.id);
	                  }
	                  pbf.writeMessage(2, writeProperties, context);
	                  pbf.writeVarintField(3, feature.type);
	                  pbf.writeMessage(4, writeGeometry, feature);
	                }
	                function writeProperties(context, pbf) {
	                  var feature = context.feature;
	                  var keys = context.keys;
	                  var values = context.values;
	                  var keycache = context.keycache;
	                  var valuecache = context.valuecache;
	                  for (var key in feature.properties) {
	                    var keyIndex = keycache[key];
	                    if (typeof keyIndex === "undefined") {
	                      keys.push(key);
	                      keyIndex = keys.length - 1;
	                      keycache[key] = keyIndex;
	                    }
	                    pbf.writeVarint(keyIndex);
	                    var value = feature.properties[key];
	                    var type = typeof value;
	                    if (type !== "string" && type !== "boolean" && type !== "number") {
	                      value = JSON.stringify(value);
	                    }
	                    var valueKey = type + ":" + value;
	                    var valueIndex = valuecache[valueKey];
	                    if (typeof valueIndex === "undefined") {
	                      values.push(value);
	                      valueIndex = values.length - 1;
	                      valuecache[valueKey] = valueIndex;
	                    }
	                    pbf.writeVarint(valueIndex);
	                  }
	                }
	                function command(cmd, length) {
	                  return (length << 3) + (cmd & 7);
	                }
	                function zigzag(num) {
	                  return num << 1 ^ num >> 31;
	                }
	                function writeGeometry(feature, pbf) {
	                  var geometry = feature.loadGeometry();
	                  var type = feature.type;
	                  var x = 0;
	                  var y = 0;
	                  var rings = geometry.length;
	                  for (var r = 0; r < rings; r++) {
	                    var ring = geometry[r];
	                    var count = 1;
	                    if (type === 1) {
	                      count = ring.length;
	                    }
	                    pbf.writeVarint(command(1, count));
	                    var lineCount = type === 3 ? ring.length - 1 : ring.length;
	                    for (var i = 0; i < lineCount; i++) {
	                      if (i === 1 && type !== 1) {
	                        pbf.writeVarint(command(2, lineCount - 1));
	                      }
	                      var dx = ring[i].x - x;
	                      var dy = ring[i].y - y;
	                      pbf.writeVarint(zigzag(dx));
	                      pbf.writeVarint(zigzag(dy));
	                      x += dx;
	                      y += dy;
	                    }
	                    if (type === 3) {
	                      pbf.writeVarint(command(7, 1));
	                    }
	                  }
	                }
	                function writeValue(value, pbf) {
	                  var type = typeof value;
	                  if (type === "string") {
	                    pbf.writeStringField(1, value);
	                  } else if (type === "boolean") {
	                    pbf.writeBooleanField(7, value);
	                  } else if (type === "number") {
	                    if (value % 1 !== 0) {
	                      pbf.writeDoubleField(3, value);
	                    } else if (value < 0) {
	                      pbf.writeSVarintField(6, value);
	                    } else {
	                      pbf.writeVarintField(5, value);
	                    }
	                  }
	                }
	                vtPbf.fromVectorTileJs = fromVectorTileJs_1;
	                vtPbf.fromGeojsonVt = fromGeojsonVt_1;
	                vtPbf.GeoJSONWrapper = GeoJSONWrapper_1;
	                function sortKD(ids, coords, nodeSize, left, right, depth) {
	                  if (right - left <= nodeSize) {
	                    return;
	                  }
	                  var m = left + right >> 1;
	                  select(ids, coords, m, left, right, depth % 2);
	                  sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
	                  sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
	                }
	                function select(ids, coords, k, left, right, inc) {
	                  while (right > left) {
	                    if (right - left > 600) {
	                      var n = right - left + 1;
	                      var m = k - left + 1;
	                      var z = Math.log(n);
	                      var s = 0.5 * Math.exp(2 * z / 3);
	                      var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	                      var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	                      var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	                      select(ids, coords, k, newLeft, newRight, inc);
	                    }
	                    var t = coords[2 * k + inc];
	                    var i = left;
	                    var j = right;
	                    swapItem(ids, coords, left, k);
	                    if (coords[2 * right + inc] > t) {
	                      swapItem(ids, coords, left, right);
	                    }
	                    while (i < j) {
	                      swapItem(ids, coords, i, j);
	                      i++;
	                      j--;
	                      while (coords[2 * i + inc] < t) {
	                        i++;
	                      }
	                      while (coords[2 * j + inc] > t) {
	                        j--;
	                      }
	                    }
	                    if (coords[2 * left + inc] === t) {
	                      swapItem(ids, coords, left, j);
	                    } else {
	                      j++;
	                      swapItem(ids, coords, j, right);
	                    }
	                    if (j <= k) {
	                      left = j + 1;
	                    }
	                    if (k <= j) {
	                      right = j - 1;
	                    }
	                  }
	                }
	                function swapItem(ids, coords, i, j) {
	                  swap(ids, i, j);
	                  swap(coords, 2 * i, 2 * j);
	                  swap(coords, 2 * i + 1, 2 * j + 1);
	                }
	                function swap(arr, i, j) {
	                  var tmp = arr[i];
	                  arr[i] = arr[j];
	                  arr[j] = tmp;
	                }
	                function range2(ids, coords, minX, minY, maxX, maxY, nodeSize) {
	                  var stack = [
	                    0,
	                    ids.length - 1,
	                    0
	                  ];
	                  var result = [];
	                  var x, y;
	                  while (stack.length) {
	                    var axis = stack.pop();
	                    var right = stack.pop();
	                    var left = stack.pop();
	                    if (right - left <= nodeSize) {
	                      for (var i = left; i <= right; i++) {
	                        x = coords[2 * i];
	                        y = coords[2 * i + 1];
	                        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
	                          result.push(ids[i]);
	                        }
	                      }
	                      continue;
	                    }
	                    var m = Math.floor((left + right) / 2);
	                    x = coords[2 * m];
	                    y = coords[2 * m + 1];
	                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
	                      result.push(ids[m]);
	                    }
	                    var nextAxis = (axis + 1) % 2;
	                    if (axis === 0 ? minX <= x : minY <= y) {
	                      stack.push(left);
	                      stack.push(m - 1);
	                      stack.push(nextAxis);
	                    }
	                    if (axis === 0 ? maxX >= x : maxY >= y) {
	                      stack.push(m + 1);
	                      stack.push(right);
	                      stack.push(nextAxis);
	                    }
	                  }
	                  return result;
	                }
	                function within(ids, coords, qx, qy, r, nodeSize) {
	                  var stack = [
	                    0,
	                    ids.length - 1,
	                    0
	                  ];
	                  var result = [];
	                  var r2 = r * r;
	                  while (stack.length) {
	                    var axis = stack.pop();
	                    var right = stack.pop();
	                    var left = stack.pop();
	                    if (right - left <= nodeSize) {
	                      for (var i = left; i <= right; i++) {
	                        if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) {
	                          result.push(ids[i]);
	                        }
	                      }
	                      continue;
	                    }
	                    var m = Math.floor((left + right) / 2);
	                    var x = coords[2 * m];
	                    var y = coords[2 * m + 1];
	                    if (sqDist(x, y, qx, qy) <= r2) {
	                      result.push(ids[m]);
	                    }
	                    var nextAxis = (axis + 1) % 2;
	                    if (axis === 0 ? qx - r <= x : qy - r <= y) {
	                      stack.push(left);
	                      stack.push(m - 1);
	                      stack.push(nextAxis);
	                    }
	                    if (axis === 0 ? qx + r >= x : qy + r >= y) {
	                      stack.push(m + 1);
	                      stack.push(right);
	                      stack.push(nextAxis);
	                    }
	                  }
	                  return result;
	                }
	                function sqDist(ax, ay, bx, by) {
	                  var dx = ax - bx;
	                  var dy = ay - by;
	                  return dx * dx + dy * dy;
	                }
	                var defaultGetX = function(p) {
	                  return p[0];
	                };
	                var defaultGetY = function(p) {
	                  return p[1];
	                };
	                var KDBush = function KDBush2(points, getX2, getY2, nodeSize, ArrayType) {
	                  if (getX2 === undefined)
	                    getX2 = defaultGetX;
	                  if (getY2 === undefined)
	                    getY2 = defaultGetY;
	                  if (nodeSize === undefined)
	                    nodeSize = 64;
	                  if (ArrayType === undefined)
	                    ArrayType = Float64Array;
	                  this.nodeSize = nodeSize;
	                  this.points = points;
	                  var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
	                  var ids = this.ids = new IndexArrayType(points.length);
	                  var coords = this.coords = new ArrayType(points.length * 2);
	                  for (var i = 0; i < points.length; i++) {
	                    ids[i] = i;
	                    coords[2 * i] = getX2(points[i]);
	                    coords[2 * i + 1] = getY2(points[i]);
	                  }
	                  sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
	                };
	                KDBush.prototype.range = function range$1(minX, minY, maxX, maxY) {
	                  return range2(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
	                };
	                KDBush.prototype.within = function within$1(x, y, r) {
	                  return within(this.ids, this.coords, x, y, r, this.nodeSize);
	                };
	                var defaultOptions = {
	                  minZoom: 0,
	                  maxZoom: 16,
	                  radius: 40,
	                  extent: 512,
	                  nodeSize: 64,
	                  log: false,
	                  generateId: false,
	                  reduce: null,
	                  map: function(props) {
	                    return props;
	                  }
	                };
	                var Supercluster = function Supercluster2(options) {
	                  this.options = extend(Object.create(defaultOptions), options);
	                  this.trees = new Array(this.options.maxZoom + 1);
	                };
	                Supercluster.prototype.load = function load(points) {
	                  var ref = this.options;
	                  var log = ref.log;
	                  var minZoom = ref.minZoom;
	                  var maxZoom = ref.maxZoom;
	                  var nodeSize = ref.nodeSize;
	                  if (log) {
	                    console.time("total time");
	                  }
	                  var timerId = "prepare " + points.length + " points";
	                  if (log) {
	                    console.time(timerId);
	                  }
	                  this.points = points;
	                  var clusters = [];
	                  for (var i = 0; i < points.length; i++) {
	                    if (!points[i].geometry) {
	                      continue;
	                    }
	                    clusters.push(createPointCluster(points[i], i));
	                  }
	                  this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
	                  if (log) {
	                    console.timeEnd(timerId);
	                  }
	                  for (var z = maxZoom; z >= minZoom; z--) {
	                    var now = +Date.now();
	                    clusters = this._cluster(clusters, z);
	                    this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
	                    if (log) {
	                      console.log("z%d: %d clusters in %dms", z, clusters.length, +Date.now() - now);
	                    }
	                  }
	                  if (log) {
	                    console.timeEnd("total time");
	                  }
	                  return this;
	                };
	                Supercluster.prototype.getClusters = function getClusters(bbox, zoom) {
	                  var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
	                  var minLat = Math.max(-90, Math.min(90, bbox[1]));
	                  var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
	                  var maxLat = Math.max(-90, Math.min(90, bbox[3]));
	                  if (bbox[2] - bbox[0] >= 360) {
	                    minLng = -180;
	                    maxLng = 180;
	                  } else if (minLng > maxLng) {
	                    var easternHem = this.getClusters([
	                      minLng,
	                      minLat,
	                      180,
	                      maxLat
	                    ], zoom);
	                    var westernHem = this.getClusters([
	                      -180,
	                      minLat,
	                      maxLng,
	                      maxLat
	                    ], zoom);
	                    return easternHem.concat(westernHem);
	                  }
	                  var tree = this.trees[this._limitZoom(zoom)];
	                  var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
	                  var clusters = [];
	                  for (var i = 0, list = ids; i < list.length; i += 1) {
	                    var id = list[i];
	                    var c = tree.points[id];
	                    clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
	                  }
	                  return clusters;
	                };
	                Supercluster.prototype.getChildren = function getChildren(clusterId) {
	                  var originId = this._getOriginId(clusterId);
	                  var originZoom = this._getOriginZoom(clusterId);
	                  var errorMsg = "No cluster with the specified id.";
	                  var index = this.trees[originZoom];
	                  if (!index) {
	                    throw new Error(errorMsg);
	                  }
	                  var origin = index.points[originId];
	                  if (!origin) {
	                    throw new Error(errorMsg);
	                  }
	                  var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
	                  var ids = index.within(origin.x, origin.y, r);
	                  var children = [];
	                  for (var i = 0, list = ids; i < list.length; i += 1) {
	                    var id = list[i];
	                    var c = index.points[id];
	                    if (c.parentId === clusterId) {
	                      children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
	                    }
	                  }
	                  if (children.length === 0) {
	                    throw new Error(errorMsg);
	                  }
	                  return children;
	                };
	                Supercluster.prototype.getLeaves = function getLeaves(clusterId, limit, offset) {
	                  limit = limit || 10;
	                  offset = offset || 0;
	                  var leaves = [];
	                  this._appendLeaves(leaves, clusterId, limit, offset, 0);
	                  return leaves;
	                };
	                Supercluster.prototype.getTile = function getTile(z, x, y) {
	                  var tree = this.trees[this._limitZoom(z)];
	                  var z2 = Math.pow(2, z);
	                  var ref = this.options;
	                  var extent2 = ref.extent;
	                  var radius = ref.radius;
	                  var p = radius / extent2;
	                  var top = (y - p) / z2;
	                  var bottom = (y + 1 + p) / z2;
	                  var tile = { features: [] };
	                  this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.points, x, y, z2, tile);
	                  if (x === 0) {
	                    this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.points, z2, y, z2, tile);
	                  }
	                  if (x === z2 - 1) {
	                    this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.points, -1, y, z2, tile);
	                  }
	                  return tile.features.length ? tile : null;
	                };
	                Supercluster.prototype.getClusterExpansionZoom = function getClusterExpansionZoom(clusterId) {
	                  var expansionZoom = this._getOriginZoom(clusterId) - 1;
	                  while (expansionZoom <= this.options.maxZoom) {
	                    var children = this.getChildren(clusterId);
	                    expansionZoom++;
	                    if (children.length !== 1) {
	                      break;
	                    }
	                    clusterId = children[0].properties.cluster_id;
	                  }
	                  return expansionZoom;
	                };
	                Supercluster.prototype._appendLeaves = function _appendLeaves(result, clusterId, limit, offset, skipped) {
	                  var children = this.getChildren(clusterId);
	                  for (var i = 0, list = children; i < list.length; i += 1) {
	                    var child = list[i];
	                    var props = child.properties;
	                    if (props && props.cluster) {
	                      if (skipped + props.point_count <= offset) {
	                        skipped += props.point_count;
	                      } else {
	                        skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
	                      }
	                    } else if (skipped < offset) {
	                      skipped++;
	                    } else {
	                      result.push(child);
	                    }
	                    if (result.length === limit) {
	                      break;
	                    }
	                  }
	                  return skipped;
	                };
	                Supercluster.prototype._addTileFeatures = function _addTileFeatures(ids, points, x, y, z2, tile) {
	                  for (var i$1 = 0, list = ids; i$1 < list.length; i$1 += 1) {
	                    var i = list[i$1];
	                    var c = points[i];
	                    var isCluster = c.numPoints;
	                    var f = {
	                      type: 1,
	                      geometry: [[
	                        Math.round(this.options.extent * (c.x * z2 - x)),
	                        Math.round(this.options.extent * (c.y * z2 - y))
	                      ]],
	                      tags: isCluster ? getClusterProperties(c) : this.points[c.index].properties
	                    };
	                    var id = undefined;
	                    if (isCluster) {
	                      id = c.id;
	                    } else if (this.options.generateId) {
	                      id = c.index;
	                    } else if (this.points[c.index].id) {
	                      id = this.points[c.index].id;
	                    }
	                    if (id !== undefined) {
	                      f.id = id;
	                    }
	                    tile.features.push(f);
	                  }
	                };
	                Supercluster.prototype._limitZoom = function _limitZoom(z) {
	                  return Math.max(this.options.minZoom, Math.min(z, this.options.maxZoom + 1));
	                };
	                Supercluster.prototype._cluster = function _cluster(points, zoom) {
	                  var clusters = [];
	                  var ref = this.options;
	                  var radius = ref.radius;
	                  var extent2 = ref.extent;
	                  var reduce = ref.reduce;
	                  var r = radius / (extent2 * Math.pow(2, zoom));
	                  for (var i = 0; i < points.length; i++) {
	                    var p = points[i];
	                    if (p.zoom <= zoom) {
	                      continue;
	                    }
	                    p.zoom = zoom;
	                    var tree = this.trees[zoom + 1];
	                    var neighborIds = tree.within(p.x, p.y, r);
	                    var numPoints = p.numPoints || 1;
	                    var wx = p.x * numPoints;
	                    var wy = p.y * numPoints;
	                    var clusterProperties = reduce && numPoints > 1 ? this._map(p, true) : null;
	                    var id = (i << 5) + (zoom + 1) + this.points.length;
	                    for (var i$1 = 0, list = neighborIds; i$1 < list.length; i$1 += 1) {
	                      var neighborId = list[i$1];
	                      var b = tree.points[neighborId];
	                      if (b.zoom <= zoom) {
	                        continue;
	                      }
	                      b.zoom = zoom;
	                      var numPoints2 = b.numPoints || 1;
	                      wx += b.x * numPoints2;
	                      wy += b.y * numPoints2;
	                      numPoints += numPoints2;
	                      b.parentId = id;
	                      if (reduce) {
	                        if (!clusterProperties) {
	                          clusterProperties = this._map(p, true);
	                        }
	                        reduce(clusterProperties, this._map(b));
	                      }
	                    }
	                    if (numPoints === 1) {
	                      clusters.push(p);
	                    } else {
	                      p.parentId = id;
	                      clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));
	                    }
	                  }
	                  return clusters;
	                };
	                Supercluster.prototype._getOriginId = function _getOriginId(clusterId) {
	                  return clusterId - this.points.length >> 5;
	                };
	                Supercluster.prototype._getOriginZoom = function _getOriginZoom(clusterId) {
	                  return (clusterId - this.points.length) % 32;
	                };
	                Supercluster.prototype._map = function _map(point, clone) {
	                  if (point.numPoints) {
	                    return clone ? extend({}, point.properties) : point.properties;
	                  }
	                  var original = this.points[point.index].properties;
	                  var result = this.options.map(original);
	                  return clone && result === original ? extend({}, result) : result;
	                };
	                function createCluster(x, y, id, numPoints, properties) {
	                  return {
	                    x,
	                    y,
	                    zoom: Infinity,
	                    id,
	                    parentId: -1,
	                    numPoints,
	                    properties
	                  };
	                }
	                function createPointCluster(p, id) {
	                  var ref = p.geometry.coordinates;
	                  var x = ref[0];
	                  var y = ref[1];
	                  return {
	                    x: lngX(x),
	                    y: latY(y),
	                    zoom: Infinity,
	                    index: id,
	                    parentId: -1
	                  };
	                }
	                function getClusterJSON(cluster) {
	                  return {
	                    type: "Feature",
	                    id: cluster.id,
	                    properties: getClusterProperties(cluster),
	                    geometry: {
	                      type: "Point",
	                      coordinates: [
	                        xLng(cluster.x),
	                        yLat(cluster.y)
	                      ]
	                    }
	                  };
	                }
	                function getClusterProperties(cluster) {
	                  var count = cluster.numPoints;
	                  var abbrev = count >= 1e4 ? Math.round(count / 1e3) + "k" : count >= 1e3 ? Math.round(count / 100) / 10 + "k" : count;
	                  return extend(extend({}, cluster.properties), {
	                    cluster: true,
	                    cluster_id: cluster.id,
	                    point_count: count,
	                    point_count_abbreviated: abbrev
	                  });
	                }
	                function lngX(lng) {
	                  return lng / 360 + 0.5;
	                }
	                function latY(lat) {
	                  var sin = Math.sin(lat * Math.PI / 180);
	                  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
	                  return y < 0 ? 0 : y > 1 ? 1 : y;
	                }
	                function xLng(x) {
	                  return (x - 0.5) * 360;
	                }
	                function yLat(y) {
	                  var y2 = (180 - y * 360) * Math.PI / 180;
	                  return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
	                }
	                function extend(dest, src) {
	                  for (var id in src) {
	                    dest[id] = src[id];
	                  }
	                  return dest;
	                }
	                function getX(p) {
	                  return p.x;
	                }
	                function getY(p) {
	                  return p.y;
	                }
	                function simplify(coords, first, last, sqTolerance) {
	                  var maxSqDist = sqTolerance;
	                  var mid = last - first >> 1;
	                  var minPosToMid = last - first;
	                  var index;
	                  var ax = coords[first];
	                  var ay = coords[first + 1];
	                  var bx = coords[last];
	                  var by = coords[last + 1];
	                  for (var i = first + 3; i < last; i += 3) {
	                    var d = getSqSegDist(coords[i], coords[i + 1], ax, ay, bx, by);
	                    if (d > maxSqDist) {
	                      index = i;
	                      maxSqDist = d;
	                    } else if (d === maxSqDist) {
	                      var posToMid = Math.abs(i - mid);
	                      if (posToMid < minPosToMid) {
	                        index = i;
	                        minPosToMid = posToMid;
	                      }
	                    }
	                  }
	                  if (maxSqDist > sqTolerance) {
	                    if (index - first > 3) {
	                      simplify(coords, first, index, sqTolerance);
	                    }
	                    coords[index + 2] = maxSqDist;
	                    if (last - index > 3) {
	                      simplify(coords, index, last, sqTolerance);
	                    }
	                  }
	                }
	                function getSqSegDist(px, py, x, y, bx, by) {
	                  var dx = bx - x;
	                  var dy = by - y;
	                  if (dx !== 0 || dy !== 0) {
	                    var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);
	                    if (t > 1) {
	                      x = bx;
	                      y = by;
	                    } else if (t > 0) {
	                      x += dx * t;
	                      y += dy * t;
	                    }
	                  }
	                  dx = px - x;
	                  dy = py - y;
	                  return dx * dx + dy * dy;
	                }
	                function createFeature(id, type, geom, tags) {
	                  var feature = {
	                    id: typeof id === "undefined" ? null : id,
	                    type,
	                    geometry: geom,
	                    tags,
	                    minX: Infinity,
	                    minY: Infinity,
	                    maxX: -Infinity,
	                    maxY: -Infinity
	                  };
	                  calcBBox(feature);
	                  return feature;
	                }
	                function calcBBox(feature) {
	                  var geom = feature.geometry;
	                  var type = feature.type;
	                  if (type === "Point" || type === "MultiPoint" || type === "LineString") {
	                    calcLineBBox(feature, geom);
	                  } else if (type === "Polygon" || type === "MultiLineString") {
	                    for (var i = 0; i < geom.length; i++) {
	                      calcLineBBox(feature, geom[i]);
	                    }
	                  } else if (type === "MultiPolygon") {
	                    for (i = 0; i < geom.length; i++) {
	                      for (var j = 0; j < geom[i].length; j++) {
	                        calcLineBBox(feature, geom[i][j]);
	                      }
	                    }
	                  }
	                }
	                function calcLineBBox(feature, geom) {
	                  for (var i = 0; i < geom.length; i += 3) {
	                    feature.minX = Math.min(feature.minX, geom[i]);
	                    feature.minY = Math.min(feature.minY, geom[i + 1]);
	                    feature.maxX = Math.max(feature.maxX, geom[i]);
	                    feature.maxY = Math.max(feature.maxY, geom[i + 1]);
	                  }
	                }
	                function convert(data, options) {
	                  var features = [];
	                  if (data.type === "FeatureCollection") {
	                    for (var i = 0; i < data.features.length; i++) {
	                      convertFeature(features, data.features[i], options, i);
	                    }
	                  } else if (data.type === "Feature") {
	                    convertFeature(features, data, options);
	                  } else {
	                    convertFeature(features, { geometry: data }, options);
	                  }
	                  return features;
	                }
	                function convertFeature(features, geojson, options, index) {
	                  if (!geojson.geometry) {
	                    return;
	                  }
	                  var coords = geojson.geometry.coordinates;
	                  var type = geojson.geometry.type;
	                  var tolerance = Math.pow(options.tolerance / ((1 << options.maxZoom) * options.extent), 2);
	                  var geometry = [];
	                  var id = geojson.id;
	                  if (options.promoteId) {
	                    id = geojson.properties[options.promoteId];
	                  } else if (options.generateId) {
	                    id = index || 0;
	                  }
	                  if (type === "Point") {
	                    convertPoint(coords, geometry);
	                  } else if (type === "MultiPoint") {
	                    for (var i = 0; i < coords.length; i++) {
	                      convertPoint(coords[i], geometry);
	                    }
	                  } else if (type === "LineString") {
	                    convertLine(coords, geometry, tolerance, false);
	                  } else if (type === "MultiLineString") {
	                    if (options.lineMetrics) {
	                      for (i = 0; i < coords.length; i++) {
	                        geometry = [];
	                        convertLine(coords[i], geometry, tolerance, false);
	                        features.push(createFeature(id, "LineString", geometry, geojson.properties));
	                      }
	                      return;
	                    } else {
	                      convertLines(coords, geometry, tolerance, false);
	                    }
	                  } else if (type === "Polygon") {
	                    convertLines(coords, geometry, tolerance, true);
	                  } else if (type === "MultiPolygon") {
	                    for (i = 0; i < coords.length; i++) {
	                      var polygon = [];
	                      convertLines(coords[i], polygon, tolerance, true);
	                      geometry.push(polygon);
	                    }
	                  } else if (type === "GeometryCollection") {
	                    for (i = 0; i < geojson.geometry.geometries.length; i++) {
	                      convertFeature(features, {
	                        id,
	                        geometry: geojson.geometry.geometries[i],
	                        properties: geojson.properties
	                      }, options, index);
	                    }
	                    return;
	                  } else {
	                    throw new Error("Input data is not a valid GeoJSON object.");
	                  }
	                  features.push(createFeature(id, type, geometry, geojson.properties));
	                }
	                function convertPoint(coords, out) {
	                  out.push(projectX(coords[0]));
	                  out.push(projectY(coords[1]));
	                  out.push(0);
	                }
	                function convertLine(ring, out, tolerance, isPolygon) {
	                  var x0, y0;
	                  var size = 0;
	                  for (var j = 0; j < ring.length; j++) {
	                    var x = projectX(ring[j][0]);
	                    var y = projectY(ring[j][1]);
	                    out.push(x);
	                    out.push(y);
	                    out.push(0);
	                    if (j > 0) {
	                      if (isPolygon) {
	                        size += (x0 * y - x * y0) / 2;
	                      } else {
	                        size += Math.sqrt(Math.pow(x - x0, 2) + Math.pow(y - y0, 2));
	                      }
	                    }
	                    x0 = x;
	                    y0 = y;
	                  }
	                  var last = out.length - 3;
	                  out[2] = 1;
	                  simplify(out, 0, last, tolerance);
	                  out[last + 2] = 1;
	                  out.size = Math.abs(size);
	                  out.start = 0;
	                  out.end = out.size;
	                }
	                function convertLines(rings, out, tolerance, isPolygon) {
	                  for (var i = 0; i < rings.length; i++) {
	                    var geom = [];
	                    convertLine(rings[i], geom, tolerance, isPolygon);
	                    out.push(geom);
	                  }
	                }
	                function projectX(x) {
	                  return x / 360 + 0.5;
	                }
	                function projectY(y) {
	                  var sin = Math.sin(y * Math.PI / 180);
	                  var y2 = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
	                  return y2 < 0 ? 0 : y2 > 1 ? 1 : y2;
	                }
	                function clip(features, scale, k1, k2, axis, minAll, maxAll, options) {
	                  k1 /= scale;
	                  k2 /= scale;
	                  if (minAll >= k1 && maxAll < k2) {
	                    return features;
	                  } else if (maxAll < k1 || minAll >= k2) {
	                    return null;
	                  }
	                  var clipped = [];
	                  for (var i = 0; i < features.length; i++) {
	                    var feature = features[i];
	                    var geometry = feature.geometry;
	                    var type = feature.type;
	                    var min = axis === 0 ? feature.minX : feature.minY;
	                    var max = axis === 0 ? feature.maxX : feature.maxY;
	                    if (min >= k1 && max < k2) {
	                      clipped.push(feature);
	                      continue;
	                    } else if (max < k1 || min >= k2) {
	                      continue;
	                    }
	                    var newGeometry = [];
	                    if (type === "Point" || type === "MultiPoint") {
	                      clipPoints(geometry, newGeometry, k1, k2, axis);
	                    } else if (type === "LineString") {
	                      clipLine(geometry, newGeometry, k1, k2, axis, false, options.lineMetrics);
	                    } else if (type === "MultiLineString") {
	                      clipLines(geometry, newGeometry, k1, k2, axis, false);
	                    } else if (type === "Polygon") {
	                      clipLines(geometry, newGeometry, k1, k2, axis, true);
	                    } else if (type === "MultiPolygon") {
	                      for (var j = 0; j < geometry.length; j++) {
	                        var polygon = [];
	                        clipLines(geometry[j], polygon, k1, k2, axis, true);
	                        if (polygon.length) {
	                          newGeometry.push(polygon);
	                        }
	                      }
	                    }
	                    if (newGeometry.length) {
	                      if (options.lineMetrics && type === "LineString") {
	                        for (j = 0; j < newGeometry.length; j++) {
	                          clipped.push(createFeature(feature.id, type, newGeometry[j], feature.tags));
	                        }
	                        continue;
	                      }
	                      if (type === "LineString" || type === "MultiLineString") {
	                        if (newGeometry.length === 1) {
	                          type = "LineString";
	                          newGeometry = newGeometry[0];
	                        } else {
	                          type = "MultiLineString";
	                        }
	                      }
	                      if (type === "Point" || type === "MultiPoint") {
	                        type = newGeometry.length === 3 ? "Point" : "MultiPoint";
	                      }
	                      clipped.push(createFeature(feature.id, type, newGeometry, feature.tags));
	                    }
	                  }
	                  return clipped.length ? clipped : null;
	                }
	                function clipPoints(geom, newGeom, k1, k2, axis) {
	                  for (var i = 0; i < geom.length; i += 3) {
	                    var a = geom[i + axis];
	                    if (a >= k1 && a <= k2) {
	                      newGeom.push(geom[i]);
	                      newGeom.push(geom[i + 1]);
	                      newGeom.push(geom[i + 2]);
	                    }
	                  }
	                }
	                function clipLine(geom, newGeom, k1, k2, axis, isPolygon, trackMetrics) {
	                  var slice2 = newSlice(geom);
	                  var intersect = axis === 0 ? intersectX : intersectY;
	                  var len = geom.start;
	                  var segLen, t;
	                  for (var i = 0; i < geom.length - 3; i += 3) {
	                    var ax = geom[i];
	                    var ay = geom[i + 1];
	                    var az = geom[i + 2];
	                    var bx = geom[i + 3];
	                    var by = geom[i + 4];
	                    var a = axis === 0 ? ax : ay;
	                    var b = axis === 0 ? bx : by;
	                    var exited = false;
	                    if (trackMetrics) {
	                      segLen = Math.sqrt(Math.pow(ax - bx, 2) + Math.pow(ay - by, 2));
	                    }
	                    if (a < k1) {
	                      if (b > k1) {
	                        t = intersect(slice2, ax, ay, bx, by, k1);
	                        if (trackMetrics) {
	                          slice2.start = len + segLen * t;
	                        }
	                      }
	                    } else if (a > k2) {
	                      if (b < k2) {
	                        t = intersect(slice2, ax, ay, bx, by, k2);
	                        if (trackMetrics) {
	                          slice2.start = len + segLen * t;
	                        }
	                      }
	                    } else {
	                      addPoint(slice2, ax, ay, az);
	                    }
	                    if (b < k1 && a >= k1) {
	                      t = intersect(slice2, ax, ay, bx, by, k1);
	                      exited = true;
	                    }
	                    if (b > k2 && a <= k2) {
	                      t = intersect(slice2, ax, ay, bx, by, k2);
	                      exited = true;
	                    }
	                    if (!isPolygon && exited) {
	                      if (trackMetrics) {
	                        slice2.end = len + segLen * t;
	                      }
	                      newGeom.push(slice2);
	                      slice2 = newSlice(geom);
	                    }
	                    if (trackMetrics) {
	                      len += segLen;
	                    }
	                  }
	                  var last = geom.length - 3;
	                  ax = geom[last];
	                  ay = geom[last + 1];
	                  az = geom[last + 2];
	                  a = axis === 0 ? ax : ay;
	                  if (a >= k1 && a <= k2) {
	                    addPoint(slice2, ax, ay, az);
	                  }
	                  last = slice2.length - 3;
	                  if (isPolygon && last >= 3 && (slice2[last] !== slice2[0] || slice2[last + 1] !== slice2[1])) {
	                    addPoint(slice2, slice2[0], slice2[1], slice2[2]);
	                  }
	                  if (slice2.length) {
	                    newGeom.push(slice2);
	                  }
	                }
	                function newSlice(line) {
	                  var slice2 = [];
	                  slice2.size = line.size;
	                  slice2.start = line.start;
	                  slice2.end = line.end;
	                  return slice2;
	                }
	                function clipLines(geom, newGeom, k1, k2, axis, isPolygon) {
	                  for (var i = 0; i < geom.length; i++) {
	                    clipLine(geom[i], newGeom, k1, k2, axis, isPolygon, false);
	                  }
	                }
	                function addPoint(out, x, y, z) {
	                  out.push(x);
	                  out.push(y);
	                  out.push(z);
	                }
	                function intersectX(out, ax, ay, bx, by, x) {
	                  var t = (x - ax) / (bx - ax);
	                  out.push(x);
	                  out.push(ay + (by - ay) * t);
	                  out.push(1);
	                  return t;
	                }
	                function intersectY(out, ax, ay, bx, by, y) {
	                  var t = (y - ay) / (by - ay);
	                  out.push(ax + (bx - ax) * t);
	                  out.push(y);
	                  out.push(1);
	                  return t;
	                }
	                function wrap(features, options) {
	                  var buffer = options.buffer / options.extent;
	                  var merged = features;
	                  var left = clip(features, 1, -1 - buffer, buffer, 0, -1, 2, options);
	                  var right = clip(features, 1, 1 - buffer, 2 + buffer, 0, -1, 2, options);
	                  if (left || right) {
	                    merged = clip(features, 1, -buffer, 1 + buffer, 0, -1, 2, options) || [];
	                    if (left) {
	                      merged = shiftFeatureCoords(left, 1).concat(merged);
	                    }
	                    if (right) {
	                      merged = merged.concat(shiftFeatureCoords(right, -1));
	                    }
	                  }
	                  return merged;
	                }
	                function shiftFeatureCoords(features, offset) {
	                  var newFeatures = [];
	                  for (var i = 0; i < features.length; i++) {
	                    var feature = features[i], type = feature.type;
	                    var newGeometry;
	                    if (type === "Point" || type === "MultiPoint" || type === "LineString") {
	                      newGeometry = shiftCoords(feature.geometry, offset);
	                    } else if (type === "MultiLineString" || type === "Polygon") {
	                      newGeometry = [];
	                      for (var j = 0; j < feature.geometry.length; j++) {
	                        newGeometry.push(shiftCoords(feature.geometry[j], offset));
	                      }
	                    } else if (type === "MultiPolygon") {
	                      newGeometry = [];
	                      for (j = 0; j < feature.geometry.length; j++) {
	                        var newPolygon = [];
	                        for (var k = 0; k < feature.geometry[j].length; k++) {
	                          newPolygon.push(shiftCoords(feature.geometry[j][k], offset));
	                        }
	                        newGeometry.push(newPolygon);
	                      }
	                    }
	                    newFeatures.push(createFeature(feature.id, type, newGeometry, feature.tags));
	                  }
	                  return newFeatures;
	                }
	                function shiftCoords(points, offset) {
	                  var newPoints = [];
	                  newPoints.size = points.size;
	                  if (points.start !== undefined) {
	                    newPoints.start = points.start;
	                    newPoints.end = points.end;
	                  }
	                  for (var i = 0; i < points.length; i += 3) {
	                    newPoints.push(points[i] + offset, points[i + 1], points[i + 2]);
	                  }
	                  return newPoints;
	                }
	                function transformTile(tile, extent2) {
	                  if (tile.transformed) {
	                    return tile;
	                  }
	                  var z2 = 1 << tile.z, tx = tile.x, ty = tile.y, i, j, k;
	                  for (i = 0; i < tile.features.length; i++) {
	                    var feature = tile.features[i], geom = feature.geometry, type = feature.type;
	                    feature.geometry = [];
	                    if (type === 1) {
	                      for (j = 0; j < geom.length; j += 2) {
	                        feature.geometry.push(transformPoint(geom[j], geom[j + 1], extent2, z2, tx, ty));
	                      }
	                    } else {
	                      for (j = 0; j < geom.length; j++) {
	                        var ring = [];
	                        for (k = 0; k < geom[j].length; k += 2) {
	                          ring.push(transformPoint(geom[j][k], geom[j][k + 1], extent2, z2, tx, ty));
	                        }
	                        feature.geometry.push(ring);
	                      }
	                    }
	                  }
	                  tile.transformed = true;
	                  return tile;
	                }
	                function transformPoint(x, y, extent2, z2, tx, ty) {
	                  return [
	                    Math.round(extent2 * (x * z2 - tx)),
	                    Math.round(extent2 * (y * z2 - ty))
	                  ];
	                }
	                function createTile(features, z, tx, ty, options) {
	                  var tolerance = z === options.maxZoom ? 0 : options.tolerance / ((1 << z) * options.extent);
	                  var tile = {
	                    features: [],
	                    numPoints: 0,
	                    numSimplified: 0,
	                    numFeatures: 0,
	                    source: null,
	                    x: tx,
	                    y: ty,
	                    z,
	                    transformed: false,
	                    minX: 2,
	                    minY: 1,
	                    maxX: -1,
	                    maxY: 0
	                  };
	                  for (var i = 0; i < features.length; i++) {
	                    tile.numFeatures++;
	                    addFeature(tile, features[i], tolerance, options);
	                    var minX = features[i].minX;
	                    var minY = features[i].minY;
	                    var maxX = features[i].maxX;
	                    var maxY = features[i].maxY;
	                    if (minX < tile.minX) {
	                      tile.minX = minX;
	                    }
	                    if (minY < tile.minY) {
	                      tile.minY = minY;
	                    }
	                    if (maxX > tile.maxX) {
	                      tile.maxX = maxX;
	                    }
	                    if (maxY > tile.maxY) {
	                      tile.maxY = maxY;
	                    }
	                  }
	                  return tile;
	                }
	                function addFeature(tile, feature, tolerance, options) {
	                  var geom = feature.geometry, type = feature.type, simplified = [];
	                  if (type === "Point" || type === "MultiPoint") {
	                    for (var i = 0; i < geom.length; i += 3) {
	                      simplified.push(geom[i]);
	                      simplified.push(geom[i + 1]);
	                      tile.numPoints++;
	                      tile.numSimplified++;
	                    }
	                  } else if (type === "LineString") {
	                    addLine(simplified, geom, tile, tolerance, false, false);
	                  } else if (type === "MultiLineString" || type === "Polygon") {
	                    for (i = 0; i < geom.length; i++) {
	                      addLine(simplified, geom[i], tile, tolerance, type === "Polygon", i === 0);
	                    }
	                  } else if (type === "MultiPolygon") {
	                    for (var k = 0; k < geom.length; k++) {
	                      var polygon = geom[k];
	                      for (i = 0; i < polygon.length; i++) {
	                        addLine(simplified, polygon[i], tile, tolerance, true, i === 0);
	                      }
	                    }
	                  }
	                  if (simplified.length) {
	                    var tags = feature.tags || null;
	                    if (type === "LineString" && options.lineMetrics) {
	                      tags = {};
	                      for (var key in feature.tags) {
	                        tags[key] = feature.tags[key];
	                      }
	                      tags["mapbox_clip_start"] = geom.start / geom.size;
	                      tags["mapbox_clip_end"] = geom.end / geom.size;
	                    }
	                    var tileFeature = {
	                      geometry: simplified,
	                      type: type === "Polygon" || type === "MultiPolygon" ? 3 : type === "LineString" || type === "MultiLineString" ? 2 : 1,
	                      tags
	                    };
	                    if (feature.id !== null) {
	                      tileFeature.id = feature.id;
	                    }
	                    tile.features.push(tileFeature);
	                  }
	                }
	                function addLine(result, geom, tile, tolerance, isPolygon, isOuter) {
	                  var sqTolerance = tolerance * tolerance;
	                  if (tolerance > 0 && geom.size < (isPolygon ? sqTolerance : tolerance)) {
	                    tile.numPoints += geom.length / 3;
	                    return;
	                  }
	                  var ring = [];
	                  for (var i = 0; i < geom.length; i += 3) {
	                    if (tolerance === 0 || geom[i + 2] > sqTolerance) {
	                      tile.numSimplified++;
	                      ring.push(geom[i]);
	                      ring.push(geom[i + 1]);
	                    }
	                    tile.numPoints++;
	                  }
	                  if (isPolygon) {
	                    rewind$1(ring, isOuter);
	                  }
	                  result.push(ring);
	                }
	                function rewind$1(ring, clockwise) {
	                  var area = 0;
	                  for (var i = 0, len = ring.length, j = len - 2; i < len; j = i, i += 2) {
	                    area += (ring[i] - ring[j]) * (ring[i + 1] + ring[j + 1]);
	                  }
	                  if (area > 0 === clockwise) {
	                    for (i = 0, len = ring.length; i < len / 2; i += 2) {
	                      var x = ring[i];
	                      var y = ring[i + 1];
	                      ring[i] = ring[len - 2 - i];
	                      ring[i + 1] = ring[len - 1 - i];
	                      ring[len - 2 - i] = x;
	                      ring[len - 1 - i] = y;
	                    }
	                  }
	                }
	                function geojsonvt(data, options) {
	                  return new GeoJSONVT(data, options);
	                }
	                function GeoJSONVT(data, options) {
	                  options = this.options = extend$1(Object.create(this.options), options);
	                  var debug = options.debug;
	                  if (debug) {
	                    console.time("preprocess data");
	                  }
	                  if (options.maxZoom < 0 || options.maxZoom > 24) {
	                    throw new Error("maxZoom should be in the 0-24 range");
	                  }
	                  if (options.promoteId && options.generateId) {
	                    throw new Error("promoteId and generateId cannot be used together.");
	                  }
	                  var features = convert(data, options);
	                  this.tiles = {};
	                  this.tileCoords = [];
	                  if (debug) {
	                    console.timeEnd("preprocess data");
	                    console.log("index: maxZoom: %d, maxPoints: %d", options.indexMaxZoom, options.indexMaxPoints);
	                    console.time("generate tiles");
	                    this.stats = {};
	                    this.total = 0;
	                  }
	                  features = wrap(features, options);
	                  if (features.length) {
	                    this.splitTile(features, 0, 0, 0);
	                  }
	                  if (debug) {
	                    if (features.length) {
	                      console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints);
	                    }
	                    console.timeEnd("generate tiles");
	                    console.log("tiles generated:", this.total, JSON.stringify(this.stats));
	                  }
	                }
	                GeoJSONVT.prototype.options = {
	                  maxZoom: 14,
	                  indexMaxZoom: 5,
	                  indexMaxPoints: 1e5,
	                  tolerance: 3,
	                  extent: 4096,
	                  buffer: 64,
	                  lineMetrics: false,
	                  promoteId: null,
	                  generateId: false,
	                  debug: 0
	                };
	                GeoJSONVT.prototype.splitTile = function(features, z, x, y, cz, cx, cy) {
	                  var stack = [
	                    features,
	                    z,
	                    x,
	                    y
	                  ], options = this.options, debug = options.debug;
	                  while (stack.length) {
	                    y = stack.pop();
	                    x = stack.pop();
	                    z = stack.pop();
	                    features = stack.pop();
	                    var z2 = 1 << z, id = toID(z, x, y), tile = this.tiles[id];
	                    if (!tile) {
	                      if (debug > 1) {
	                        console.time("creation");
	                      }
	                      tile = this.tiles[id] = createTile(features, z, x, y, options);
	                      this.tileCoords.push({
	                        z,
	                        x,
	                        y
	                      });
	                      if (debug) {
	                        if (debug > 1) {
	                          console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", z, x, y, tile.numFeatures, tile.numPoints, tile.numSimplified);
	                          console.timeEnd("creation");
	                        }
	                        var key = "z" + z;
	                        this.stats[key] = (this.stats[key] || 0) + 1;
	                        this.total++;
	                      }
	                    }
	                    tile.source = features;
	                    if (!cz) {
	                      if (z === options.indexMaxZoom || tile.numPoints <= options.indexMaxPoints) {
	                        continue;
	                      }
	                    } else {
	                      if (z === options.maxZoom || z === cz) {
	                        continue;
	                      }
	                      var m = 1 << cz - z;
	                      if (x !== Math.floor(cx / m) || y !== Math.floor(cy / m)) {
	                        continue;
	                      }
	                    }
	                    tile.source = null;
	                    if (features.length === 0) {
	                      continue;
	                    }
	                    if (debug > 1) {
	                      console.time("clipping");
	                    }
	                    var k1 = 0.5 * options.buffer / options.extent, k2 = 0.5 - k1, k3 = 0.5 + k1, k4 = 1 + k1, tl, bl, tr, br, left, right;
	                    tl = bl = tr = br = null;
	                    left = clip(features, z2, x - k1, x + k3, 0, tile.minX, tile.maxX, options);
	                    right = clip(features, z2, x + k2, x + k4, 0, tile.minX, tile.maxX, options);
	                    features = null;
	                    if (left) {
	                      tl = clip(left, z2, y - k1, y + k3, 1, tile.minY, tile.maxY, options);
	                      bl = clip(left, z2, y + k2, y + k4, 1, tile.minY, tile.maxY, options);
	                      left = null;
	                    }
	                    if (right) {
	                      tr = clip(right, z2, y - k1, y + k3, 1, tile.minY, tile.maxY, options);
	                      br = clip(right, z2, y + k2, y + k4, 1, tile.minY, tile.maxY, options);
	                      right = null;
	                    }
	                    if (debug > 1) {
	                      console.timeEnd("clipping");
	                    }
	                    stack.push(tl || [], z + 1, x * 2, y * 2);
	                    stack.push(bl || [], z + 1, x * 2, y * 2 + 1);
	                    stack.push(tr || [], z + 1, x * 2 + 1, y * 2);
	                    stack.push(br || [], z + 1, x * 2 + 1, y * 2 + 1);
	                  }
	                };
	                GeoJSONVT.prototype.getTile = function(z, x, y) {
	                  var options = this.options, extent2 = options.extent, debug = options.debug;
	                  if (z < 0 || z > 24) {
	                    return null;
	                  }
	                  var z2 = 1 << z;
	                  x = (x % z2 + z2) % z2;
	                  var id = toID(z, x, y);
	                  if (this.tiles[id]) {
	                    return transformTile(this.tiles[id], extent2);
	                  }
	                  if (debug > 1) {
	                    console.log("drilling down to z%d-%d-%d", z, x, y);
	                  }
	                  var z0 = z, x0 = x, y0 = y, parent;
	                  while (!parent && z0 > 0) {
	                    z0--;
	                    x0 = Math.floor(x0 / 2);
	                    y0 = Math.floor(y0 / 2);
	                    parent = this.tiles[toID(z0, x0, y0)];
	                  }
	                  if (!parent || !parent.source) {
	                    return null;
	                  }
	                  if (debug > 1) {
	                    console.log("found parent tile z%d-%d-%d", z0, x0, y0);
	                  }
	                  if (debug > 1) {
	                    console.time("drilling down");
	                  }
	                  this.splitTile(parent.source, z0, x0, y0, z, x, y);
	                  if (debug > 1) {
	                    console.timeEnd("drilling down");
	                  }
	                  return this.tiles[id] ? transformTile(this.tiles[id], extent2) : null;
	                };
	                function toID(z, x, y) {
	                  return ((1 << z) * y + x) * 32 + z;
	                }
	                function extend$1(dest, src) {
	                  for (var i in src) {
	                    dest[i] = src[i];
	                  }
	                  return dest;
	                }
	                function loadGeoJSONTile(params, callback) {
	                  var canonical = params.tileID.canonical;
	                  if (!this._geoJSONIndex) {
	                    return callback(null, null);
	                  }
	                  var geoJSONTile = this._geoJSONIndex.getTile(canonical.z, canonical.x, canonical.y);
	                  if (!geoJSONTile) {
	                    return callback(null, null);
	                  }
	                  var geojsonWrapper = new GeoJSONWrapper(geoJSONTile.features);
	                  var pbf = vtPbf(geojsonWrapper);
	                  if (pbf.byteOffset !== 0 || pbf.byteLength !== pbf.buffer.byteLength) {
	                    pbf = new Uint8Array(pbf);
	                  }
	                  callback(null, {
	                    vectorTile: geojsonWrapper,
	                    rawData: pbf.buffer
	                  });
	                }
	                var GeoJSONWorkerSource = function(VectorTileWorkerSource2) {
	                  function GeoJSONWorkerSource2(actor, layerIndex, availableImages, loadGeoJSON) {
	                    VectorTileWorkerSource2.call(this, actor, layerIndex, availableImages, loadGeoJSONTile);
	                    if (loadGeoJSON) {
	                      this.loadGeoJSON = loadGeoJSON;
	                    }
	                  }
	                  GeoJSONWorkerSource2.__proto__ = VectorTileWorkerSource2;
	                  GeoJSONWorkerSource2.prototype = Object.create(VectorTileWorkerSource2.prototype);
	                  GeoJSONWorkerSource2.prototype.constructor = GeoJSONWorkerSource2;
	                  GeoJSONWorkerSource2.prototype.loadData = function loadData(params, callback) {
	                    if (this._pendingCallback) {
	                      this._pendingCallback(null, { abandoned: true });
	                    }
	                    this._pendingCallback = callback;
	                    this._pendingLoadDataParams = params;
	                    if (this._state && this._state !== "Idle") {
	                      this._state = "NeedsLoadData";
	                    } else {
	                      this._state = "Coalescing";
	                      this._loadData();
	                    }
	                  };
	                  GeoJSONWorkerSource2.prototype._loadData = function _loadData() {
	                    var this$1$1 = this;
	                    if (!this._pendingCallback || !this._pendingLoadDataParams) {
	                      return;
	                    }
	                    var callback = this._pendingCallback;
	                    var params = this._pendingLoadDataParams;
	                    delete this._pendingCallback;
	                    delete this._pendingLoadDataParams;
	                    var perf = params && params.request && params.request.collectResourceTiming ? new performance$1.RequestPerformance(params.request) : false;
	                    this.loadGeoJSON(params, function(err, data) {
	                      if (err || !data) {
	                        return callback(err);
	                      } else if (typeof data !== "object") {
	                        return callback(new Error("Input data given to '" + params.source + "' is not a valid GeoJSON object."));
	                      } else {
	                        geojsonRewind(data, true);
	                        try {
	                          this$1$1._geoJSONIndex = params.cluster ? new Supercluster(getSuperclusterOptions(params)).load(data.features) : geojsonvt(data, params.geojsonVtOptions);
	                        } catch (err2) {
	                          return callback(err2);
	                        }
	                        this$1$1.loaded = {};
	                        var result = {};
	                        if (perf) {
	                          var resourceTimingData = perf.finish();
	                          if (resourceTimingData) {
	                            result.resourceTiming = {};
	                            result.resourceTiming[params.source] = JSON.parse(JSON.stringify(resourceTimingData));
	                          }
	                        }
	                        callback(null, result);
	                      }
	                    });
	                  };
	                  GeoJSONWorkerSource2.prototype.coalesce = function coalesce() {
	                    if (this._state === "Coalescing") {
	                      this._state = "Idle";
	                    } else if (this._state === "NeedsLoadData") {
	                      this._state = "Coalescing";
	                      this._loadData();
	                    }
	                  };
	                  GeoJSONWorkerSource2.prototype.reloadTile = function reloadTile(params, callback) {
	                    var loaded = this.loaded, uid = params.uid;
	                    if (loaded && loaded[uid]) {
	                      return VectorTileWorkerSource2.prototype.reloadTile.call(this, params, callback);
	                    } else {
	                      return this.loadTile(params, callback);
	                    }
	                  };
	                  GeoJSONWorkerSource2.prototype.loadGeoJSON = function loadGeoJSON(params, callback) {
	                    if (params.request) {
	                      performance$1.getJSON(params.request, callback);
	                    } else if (typeof params.data === "string") {
	                      try {
	                        return callback(null, JSON.parse(params.data));
	                      } catch (e) {
	                        return callback(new Error("Input data given to '" + params.source + "' is not a valid GeoJSON object."));
	                      }
	                    } else {
	                      return callback(new Error("Input data given to '" + params.source + "' is not a valid GeoJSON object."));
	                    }
	                  };
	                  GeoJSONWorkerSource2.prototype.removeSource = function removeSource(params, callback) {
	                    if (this._pendingCallback) {
	                      this._pendingCallback(null, { abandoned: true });
	                    }
	                    callback();
	                  };
	                  GeoJSONWorkerSource2.prototype.getClusterExpansionZoom = function getClusterExpansionZoom(params, callback) {
	                    try {
	                      callback(null, this._geoJSONIndex.getClusterExpansionZoom(params.clusterId));
	                    } catch (e) {
	                      callback(e);
	                    }
	                  };
	                  GeoJSONWorkerSource2.prototype.getClusterChildren = function getClusterChildren(params, callback) {
	                    try {
	                      callback(null, this._geoJSONIndex.getChildren(params.clusterId));
	                    } catch (e) {
	                      callback(e);
	                    }
	                  };
	                  GeoJSONWorkerSource2.prototype.getClusterLeaves = function getClusterLeaves(params, callback) {
	                    try {
	                      callback(null, this._geoJSONIndex.getLeaves(params.clusterId, params.limit, params.offset));
	                    } catch (e) {
	                      callback(e);
	                    }
	                  };
	                  return GeoJSONWorkerSource2;
	                }(VectorTileWorkerSource);
	                function getSuperclusterOptions(ref) {
	                  var superclusterOptions = ref.superclusterOptions;
	                  var clusterProperties = ref.clusterProperties;
	                  if (!clusterProperties || !superclusterOptions) {
	                    return superclusterOptions;
	                  }
	                  var mapExpressions = {};
	                  var reduceExpressions = {};
	                  var globals = {
	                    accumulated: null,
	                    zoom: 0
	                  };
	                  var feature = { properties: null };
	                  var propertyNames = Object.keys(clusterProperties);
	                  for (var i = 0, list = propertyNames; i < list.length; i += 1) {
	                    var key = list[i];
	                    var ref$1 = clusterProperties[key];
	                    var operator = ref$1[0];
	                    var mapExpression = ref$1[1];
	                    var mapExpressionParsed = performance$1.createExpression(mapExpression);
	                    var reduceExpressionParsed = performance$1.createExpression(typeof operator === "string" ? [
	                      operator,
	                      ["accumulated"],
	                      [
	                        "get",
	                        key
	                      ]
	                    ] : operator);
	                    mapExpressions[key] = mapExpressionParsed.value;
	                    reduceExpressions[key] = reduceExpressionParsed.value;
	                  }
	                  superclusterOptions.map = function(pointProperties) {
	                    feature.properties = pointProperties;
	                    var properties = {};
	                    for (var i2 = 0, list2 = propertyNames; i2 < list2.length; i2 += 1) {
	                      var key2 = list2[i2];
	                      properties[key2] = mapExpressions[key2].evaluate(globals, feature);
	                    }
	                    return properties;
	                  };
	                  superclusterOptions.reduce = function(accumulated, clusterProperties2) {
	                    feature.properties = clusterProperties2;
	                    for (var i2 = 0, list2 = propertyNames; i2 < list2.length; i2 += 1) {
	                      var key2 = list2[i2];
	                      globals.accumulated = accumulated[key2];
	                      accumulated[key2] = reduceExpressions[key2].evaluate(globals, feature);
	                    }
	                  };
	                  return superclusterOptions;
	                }
	                var Worker2 = function Worker3(self2) {
	                  var this$1$1 = this;
	                  this.self = self2;
	                  this.actor = new performance$1.Actor(self2, this);
	                  this.layerIndexes = {};
	                  this.availableImages = {};
	                  this.workerSourceTypes = {
	                    vector: VectorTileWorkerSource,
	                    geojson: GeoJSONWorkerSource
	                  };
	                  this.workerSources = {};
	                  this.demWorkerSources = {};
	                  this.self.registerWorkerSource = function(name2, WorkerSource) {
	                    if (this$1$1.workerSourceTypes[name2]) {
	                      throw new Error('Worker source with name "' + name2 + '" already registered.');
	                    }
	                    this$1$1.workerSourceTypes[name2] = WorkerSource;
	                  };
	                  this.self.registerRTLTextPlugin = function(rtlTextPlugin) {
	                    if (performance$1.plugin.isParsed()) {
	                      throw new Error("RTL text plugin already registered.");
	                    }
	                    performance$1.plugin["applyArabicShaping"] = rtlTextPlugin.applyArabicShaping;
	                    performance$1.plugin["processBidirectionalText"] = rtlTextPlugin.processBidirectionalText;
	                    performance$1.plugin["processStyledBidirectionalText"] = rtlTextPlugin.processStyledBidirectionalText;
	                  };
	                };
	                Worker2.prototype.setReferrer = function setReferrer(mapID, referrer) {
	                  this.referrer = referrer;
	                };
	                Worker2.prototype.setImages = function setImages(mapId, images, callback) {
	                  this.availableImages[mapId] = images;
	                  for (var workerSource in this.workerSources[mapId]) {
	                    var ws = this.workerSources[mapId][workerSource];
	                    for (var source in ws) {
	                      ws[source].availableImages = images;
	                    }
	                  }
	                  callback();
	                };
	                Worker2.prototype.setLayers = function setLayers(mapId, layers, callback) {
	                  this.getLayerIndex(mapId).replace(layers);
	                  callback();
	                };
	                Worker2.prototype.updateLayers = function updateLayers(mapId, params, callback) {
	                  this.getLayerIndex(mapId).update(params.layers, params.removedIds);
	                  callback();
	                };
	                Worker2.prototype.loadTile = function loadTile(mapId, params, callback) {
	                  this.getWorkerSource(mapId, params.type, params.source).loadTile(params, callback);
	                };
	                Worker2.prototype.loadDEMTile = function loadDEMTile(mapId, params, callback) {
	                  this.getDEMWorkerSource(mapId, params.source).loadTile(params, callback);
	                };
	                Worker2.prototype.reloadTile = function reloadTile(mapId, params, callback) {
	                  this.getWorkerSource(mapId, params.type, params.source).reloadTile(params, callback);
	                };
	                Worker2.prototype.abortTile = function abortTile(mapId, params, callback) {
	                  this.getWorkerSource(mapId, params.type, params.source).abortTile(params, callback);
	                };
	                Worker2.prototype.removeTile = function removeTile(mapId, params, callback) {
	                  this.getWorkerSource(mapId, params.type, params.source).removeTile(params, callback);
	                };
	                Worker2.prototype.removeDEMTile = function removeDEMTile(mapId, params) {
	                  this.getDEMWorkerSource(mapId, params.source).removeTile(params);
	                };
	                Worker2.prototype.removeSource = function removeSource(mapId, params, callback) {
	                  if (!this.workerSources[mapId] || !this.workerSources[mapId][params.type] || !this.workerSources[mapId][params.type][params.source]) {
	                    return;
	                  }
	                  var worker2 = this.workerSources[mapId][params.type][params.source];
	                  delete this.workerSources[mapId][params.type][params.source];
	                  if (worker2.removeSource !== undefined) {
	                    worker2.removeSource(params, callback);
	                  } else {
	                    callback();
	                  }
	                };
	                Worker2.prototype.loadWorkerSource = function loadWorkerSource(map2, params, callback) {
	                  try {
	                    this.self.importScripts(params.url);
	                    callback();
	                  } catch (e) {
	                    callback(e.toString());
	                  }
	                };
	                Worker2.prototype.syncRTLPluginState = function syncRTLPluginState(map2, state, callback) {
	                  try {
	                    performance$1.plugin.setState(state);
	                    var pluginURL = performance$1.plugin.getPluginURL();
	                    if (performance$1.plugin.isLoaded() && !performance$1.plugin.isParsed() && pluginURL != null) {
	                      this.self.importScripts(pluginURL);
	                      var complete = performance$1.plugin.isParsed();
	                      var error = complete ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + pluginURL);
	                      callback(error, complete);
	                    }
	                  } catch (e) {
	                    callback(e.toString());
	                  }
	                };
	                Worker2.prototype.getAvailableImages = function getAvailableImages(mapId) {
	                  var availableImages = this.availableImages[mapId];
	                  if (!availableImages) {
	                    availableImages = [];
	                  }
	                  return availableImages;
	                };
	                Worker2.prototype.getLayerIndex = function getLayerIndex(mapId) {
	                  var layerIndexes = this.layerIndexes[mapId];
	                  if (!layerIndexes) {
	                    layerIndexes = this.layerIndexes[mapId] = new StyleLayerIndex();
	                  }
	                  return layerIndexes;
	                };
	                Worker2.prototype.getWorkerSource = function getWorkerSource(mapId, type, source) {
	                  var this$1$1 = this;
	                  if (!this.workerSources[mapId]) {
	                    this.workerSources[mapId] = {};
	                  }
	                  if (!this.workerSources[mapId][type]) {
	                    this.workerSources[mapId][type] = {};
	                  }
	                  if (!this.workerSources[mapId][type][source]) {
	                    var actor = {
	                      send: function(type2, data, callback) {
	                        this$1$1.actor.send(type2, data, callback, mapId);
	                      }
	                    };
	                    this.workerSources[mapId][type][source] = new this.workerSourceTypes[type](actor, this.getLayerIndex(mapId), this.getAvailableImages(mapId));
	                  }
	                  return this.workerSources[mapId][type][source];
	                };
	                Worker2.prototype.getDEMWorkerSource = function getDEMWorkerSource(mapId, source) {
	                  if (!this.demWorkerSources[mapId]) {
	                    this.demWorkerSources[mapId] = {};
	                  }
	                  if (!this.demWorkerSources[mapId][source]) {
	                    this.demWorkerSources[mapId][source] = new RasterDEMTileWorkerSource();
	                  }
	                  return this.demWorkerSources[mapId][source];
	                };
	                Worker2.prototype.enforceCacheSizeLimit = function enforceCacheSizeLimit$1(mapId, limit) {
	                  performance$1.enforceCacheSizeLimit(limit);
	                };
	                if (typeof WorkerGlobalScope !== "undefined" && typeof performance$1.window !== "undefined" && performance$1.window instanceof WorkerGlobalScope) {
	                  performance$1.window.worker = new Worker2(performance$1.window);
	                }
	                return Worker2;
	              });
	              define2(["./shared"], function(performance2) {
	                var mapboxGlSupported = performance2.createCommonjsModule(function(module3) {
	                  if (module3.exports) {
	                    module3.exports = isSupported;
	                  } else if (window) {
	                    window.mapboxgl = window.mapboxgl || {};
	                    window.mapboxgl.supported = isSupported;
	                    window.mapboxgl.notSupportedReason = notSupportedReason;
	                  }
	                  function isSupported(options) {
	                    return !notSupportedReason(options);
	                  }
	                  function notSupportedReason(options) {
	                    if (!isBrowser()) {
	                      return "not a browser";
	                    }
	                    if (!isArraySupported()) {
	                      return "insufficent Array support";
	                    }
	                    if (!isFunctionSupported()) {
	                      return "insufficient Function support";
	                    }
	                    if (!isObjectSupported()) {
	                      return "insufficient Object support";
	                    }
	                    if (!isJSONSupported()) {
	                      return "insufficient JSON support";
	                    }
	                    if (!isWorkerSupported()) {
	                      return "insufficient worker support";
	                    }
	                    if (!isUint8ClampedArraySupported()) {
	                      return "insufficient Uint8ClampedArray support";
	                    }
	                    if (!isArrayBufferSupported()) {
	                      return "insufficient ArrayBuffer support";
	                    }
	                    if (!isCanvasGetImageDataSupported()) {
	                      return "insufficient Canvas/getImageData support";
	                    }
	                    if (!isWebGLSupportedCached(options && options.failIfMajorPerformanceCaveat)) {
	                      return "insufficient WebGL support";
	                    }
	                  }
	                  function isBrowser() {
	                    return typeof window !== "undefined" && typeof document !== "undefined";
	                  }
	                  function isArraySupported() {
	                    return Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray;
	                  }
	                  function isFunctionSupported() {
	                    return Function.prototype && Function.prototype.bind;
	                  }
	                  function isObjectSupported() {
	                    return Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions;
	                  }
	                  function isJSONSupported() {
	                    return "JSON" in window && "parse" in JSON && "stringify" in JSON;
	                  }
	                  function isWorkerSupported() {
	                    if (!("Worker" in window && "Blob" in window && "URL" in window)) {
	                      return false;
	                    }
	                    var blob = new Blob([""], { type: "text/javascript" });
	                    var workerURL = URL.createObjectURL(blob);
	                    var supported;
	                    var worker2;
	                    try {
	                      worker2 = new Worker(workerURL);
	                      supported = true;
	                    } catch (e) {
	                      supported = false;
	                    }
	                    if (worker2) {
	                      worker2.terminate();
	                    }
	                    URL.revokeObjectURL(workerURL);
	                    return supported;
	                  }
	                  function isUint8ClampedArraySupported() {
	                    return "Uint8ClampedArray" in window;
	                  }
	                  function isArrayBufferSupported() {
	                    return ArrayBuffer.isView;
	                  }
	                  function isCanvasGetImageDataSupported() {
	                    var canvas = document.createElement("canvas");
	                    canvas.width = canvas.height = 1;
	                    var context = canvas.getContext("2d");
	                    if (!context) {
	                      return false;
	                    }
	                    var imageData = context.getImageData(0, 0, 1, 1);
	                    return imageData && imageData.width === canvas.width;
	                  }
	                  var isWebGLSupportedCache = {};
	                  function isWebGLSupportedCached(failIfMajorPerformanceCaveat) {
	                    if (isWebGLSupportedCache[failIfMajorPerformanceCaveat] === undefined) {
	                      isWebGLSupportedCache[failIfMajorPerformanceCaveat] = isWebGLSupported(failIfMajorPerformanceCaveat);
	                    }
	                    return isWebGLSupportedCache[failIfMajorPerformanceCaveat];
	                  }
	                  isSupported.webGLContextAttributes = {
	                    antialias: false,
	                    alpha: true,
	                    stencil: true,
	                    depth: true
	                  };
	                  function getWebGLContext(failIfMajorPerformanceCaveat) {
	                    var canvas = document.createElement("canvas");
	                    var attributes = Object.create(isSupported.webGLContextAttributes);
	                    attributes.failIfMajorPerformanceCaveat = failIfMajorPerformanceCaveat;
	                    if (canvas.probablySupportsContext) {
	                      return canvas.probablySupportsContext("webgl", attributes) || canvas.probablySupportsContext("experimental-webgl", attributes);
	                    } else if (canvas.supportsContext) {
	                      return canvas.supportsContext("webgl", attributes) || canvas.supportsContext("experimental-webgl", attributes);
	                    } else {
	                      return canvas.getContext("webgl", attributes) || canvas.getContext("experimental-webgl", attributes);
	                    }
	                  }
	                  function isWebGLSupported(failIfMajorPerformanceCaveat) {
	                    var gl2 = getWebGLContext(failIfMajorPerformanceCaveat);
	                    if (!gl2) {
	                      return false;
	                    }
	                    var shader = gl2.createShader(gl2.VERTEX_SHADER);
	                    if (!shader || gl2.isContextLost()) {
	                      return false;
	                    }
	                    gl2.shaderSource(shader, "void main() {}");
	                    gl2.compileShader(shader);
	                    return gl2.getShaderParameter(shader, gl2.COMPILE_STATUS) === true;
	                  }
	                });
	                var DOM = {};
	                DOM.create = function(tagName, className, container) {
	                  var el = performance2.window.document.createElement(tagName);
	                  if (className !== undefined) {
	                    el.className = className;
	                  }
	                  if (container) {
	                    container.appendChild(el);
	                  }
	                  return el;
	                };
	                DOM.createNS = function(namespaceURI, tagName) {
	                  var el = performance2.window.document.createElementNS(namespaceURI, tagName);
	                  return el;
	                };
	                var docStyle = performance2.window.document.documentElement.style;
	                function testProp(props) {
	                  if (!docStyle) {
	                    return props[0];
	                  }
	                  for (var i = 0; i < props.length; i++) {
	                    if (props[i] in docStyle) {
	                      return props[i];
	                    }
	                  }
	                  return props[0];
	                }
	                var selectProp = testProp([
	                  "userSelect",
	                  "MozUserSelect",
	                  "WebkitUserSelect",
	                  "msUserSelect"
	                ]);
	                var userSelect;
	                DOM.disableDrag = function() {
	                  if (docStyle && selectProp) {
	                    userSelect = docStyle[selectProp];
	                    docStyle[selectProp] = "none";
	                  }
	                };
	                DOM.enableDrag = function() {
	                  if (docStyle && selectProp) {
	                    docStyle[selectProp] = userSelect;
	                  }
	                };
	                var transformProp = testProp([
	                  "transform",
	                  "WebkitTransform"
	                ]);
	                DOM.setTransform = function(el, value) {
	                  el.style[transformProp] = value;
	                };
	                var passiveSupported = false;
	                try {
	                  var options$1 = Object.defineProperty({}, "passive", {
	                    get: function get() {
	                      passiveSupported = true;
	                    }
	                  });
	                  performance2.window.addEventListener("test", options$1, options$1);
	                  performance2.window.removeEventListener("test", options$1, options$1);
	                } catch (err) {
	                  passiveSupported = false;
	                }
	                DOM.addEventListener = function(target, type, callback, options) {
	                  if (options === undefined)
	                    options = {};
	                  if ("passive" in options && passiveSupported) {
	                    target.addEventListener(type, callback, options);
	                  } else {
	                    target.addEventListener(type, callback, options.capture);
	                  }
	                };
	                DOM.removeEventListener = function(target, type, callback, options) {
	                  if (options === undefined)
	                    options = {};
	                  if ("passive" in options && passiveSupported) {
	                    target.removeEventListener(type, callback, options);
	                  } else {
	                    target.removeEventListener(type, callback, options.capture);
	                  }
	                };
	                var suppressClick = function(e) {
	                  e.preventDefault();
	                  e.stopPropagation();
	                  performance2.window.removeEventListener("click", suppressClick, true);
	                };
	                DOM.suppressClick = function() {
	                  performance2.window.addEventListener("click", suppressClick, true);
	                  performance2.window.setTimeout(function() {
	                    performance2.window.removeEventListener("click", suppressClick, true);
	                  }, 0);
	                };
	                DOM.mousePos = function(el, e) {
	                  var rect = el.getBoundingClientRect();
	                  return new performance2.Point(e.clientX - rect.left - el.clientLeft, e.clientY - rect.top - el.clientTop);
	                };
	                DOM.touchPos = function(el, touches) {
	                  var rect = el.getBoundingClientRect(), points = [];
	                  for (var i = 0; i < touches.length; i++) {
	                    points.push(new performance2.Point(touches[i].clientX - rect.left - el.clientLeft, touches[i].clientY - rect.top - el.clientTop));
	                  }
	                  return points;
	                };
	                DOM.mouseButton = function(e) {
	                  if (typeof performance2.window.InstallTrigger !== "undefined" && e.button === 2 && e.ctrlKey && performance2.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0) {
	                    return 0;
	                  }
	                  return e.button;
	                };
	                DOM.remove = function(node) {
	                  if (node.parentNode) {
	                    node.parentNode.removeChild(node);
	                  }
	                };
	                function loadSprite(baseURL, requestManager, callback) {
	                  var json, image, error;
	                  var format = performance2.browser.devicePixelRatio > 1 ? "@2x" : "";
	                  var jsonRequest = performance2.getJSON(requestManager.transformRequest(requestManager.normalizeSpriteURL(baseURL, format, ".json"), performance2.ResourceType.SpriteJSON), function(err, data) {
	                    jsonRequest = null;
	                    if (!error) {
	                      error = err;
	                      json = data;
	                      maybeComplete();
	                    }
	                  });
	                  var imageRequest = performance2.getImage(requestManager.transformRequest(requestManager.normalizeSpriteURL(baseURL, format, ".png"), performance2.ResourceType.SpriteImage), function(err, img) {
	                    imageRequest = null;
	                    if (!error) {
	                      error = err;
	                      image = img;
	                      maybeComplete();
	                    }
	                  });
	                  function maybeComplete() {
	                    if (error) {
	                      callback(error);
	                    } else if (json && image) {
	                      var imageData = performance2.browser.getImageData(image);
	                      var result = {};
	                      for (var id in json) {
	                        var ref = json[id];
	                        var width = ref.width;
	                        var height = ref.height;
	                        var x = ref.x;
	                        var y = ref.y;
	                        var sdf = ref.sdf;
	                        var pixelRatio = ref.pixelRatio;
	                        var stretchX = ref.stretchX;
	                        var stretchY = ref.stretchY;
	                        var content = ref.content;
	                        var data = new performance2.RGBAImage({
	                          width,
	                          height
	                        });
	                        performance2.RGBAImage.copy(imageData, data, {
	                          x,
	                          y
	                        }, {
	                          x: 0,
	                          y: 0
	                        }, {
	                          width,
	                          height
	                        });
	                        result[id] = {
	                          data,
	                          pixelRatio,
	                          sdf,
	                          stretchX,
	                          stretchY,
	                          content
	                        };
	                      }
	                      callback(null, result);
	                    }
	                  }
	                  return {
	                    cancel: function cancel() {
	                      if (jsonRequest) {
	                        jsonRequest.cancel();
	                        jsonRequest = null;
	                      }
	                      if (imageRequest) {
	                        imageRequest.cancel();
	                        imageRequest = null;
	                      }
	                    }
	                  };
	                }
	                function renderStyleImage(image) {
	                  var userImage = image.userImage;
	                  if (userImage && userImage.render) {
	                    var updated = userImage.render();
	                    if (updated) {
	                      image.data.replace(new Uint8Array(userImage.data.buffer));
	                      return true;
	                    }
	                  }
	                  return false;
	                }
	                var padding = 1;
	                var ImageManager = function(Evented) {
	                  function ImageManager2() {
	                    Evented.call(this);
	                    this.images = {};
	                    this.updatedImages = {};
	                    this.callbackDispatchedThisFrame = {};
	                    this.loaded = false;
	                    this.requestors = [];
	                    this.patterns = {};
	                    this.atlasImage = new performance2.RGBAImage({
	                      width: 1,
	                      height: 1
	                    });
	                    this.dirty = true;
	                  }
	                  if (Evented)
	                    ImageManager2.__proto__ = Evented;
	                  ImageManager2.prototype = Object.create(Evented && Evented.prototype);
	                  ImageManager2.prototype.constructor = ImageManager2;
	                  ImageManager2.prototype.isLoaded = function isLoaded() {
	                    return this.loaded;
	                  };
	                  ImageManager2.prototype.setLoaded = function setLoaded(loaded) {
	                    if (this.loaded === loaded) {
	                      return;
	                    }
	                    this.loaded = loaded;
	                    if (loaded) {
	                      for (var i = 0, list = this.requestors; i < list.length; i += 1) {
	                        var ref = list[i];
	                        var ids = ref.ids;
	                        var callback = ref.callback;
	                        this._notify(ids, callback);
	                      }
	                      this.requestors = [];
	                    }
	                  };
	                  ImageManager2.prototype.getImage = function getImage(id) {
	                    return this.images[id];
	                  };
	                  ImageManager2.prototype.addImage = function addImage(id, image) {
	                    if (this._validate(id, image)) {
	                      this.images[id] = image;
	                    }
	                  };
	                  ImageManager2.prototype._validate = function _validate(id, image) {
	                    var valid = true;
	                    if (!this._validateStretch(image.stretchX, image.data && image.data.width)) {
	                      this.fire(new performance2.ErrorEvent(new Error('Image "' + id + '" has invalid "stretchX" value')));
	                      valid = false;
	                    }
	                    if (!this._validateStretch(image.stretchY, image.data && image.data.height)) {
	                      this.fire(new performance2.ErrorEvent(new Error('Image "' + id + '" has invalid "stretchY" value')));
	                      valid = false;
	                    }
	                    if (!this._validateContent(image.content, image)) {
	                      this.fire(new performance2.ErrorEvent(new Error('Image "' + id + '" has invalid "content" value')));
	                      valid = false;
	                    }
	                    return valid;
	                  };
	                  ImageManager2.prototype._validateStretch = function _validateStretch(stretch, size) {
	                    if (!stretch) {
	                      return true;
	                    }
	                    var last = 0;
	                    for (var i = 0, list = stretch; i < list.length; i += 1) {
	                      var part = list[i];
	                      if (part[0] < last || part[1] < part[0] || size < part[1]) {
	                        return false;
	                      }
	                      last = part[1];
	                    }
	                    return true;
	                  };
	                  ImageManager2.prototype._validateContent = function _validateContent(content, image) {
	                    if (!content) {
	                      return true;
	                    }
	                    if (content.length !== 4) {
	                      return false;
	                    }
	                    if (content[0] < 0 || image.data.width < content[0]) {
	                      return false;
	                    }
	                    if (content[1] < 0 || image.data.height < content[1]) {
	                      return false;
	                    }
	                    if (content[2] < 0 || image.data.width < content[2]) {
	                      return false;
	                    }
	                    if (content[3] < 0 || image.data.height < content[3]) {
	                      return false;
	                    }
	                    if (content[2] < content[0]) {
	                      return false;
	                    }
	                    if (content[3] < content[1]) {
	                      return false;
	                    }
	                    return true;
	                  };
	                  ImageManager2.prototype.updateImage = function updateImage(id, image) {
	                    var oldImage = this.images[id];
	                    image.version = oldImage.version + 1;
	                    this.images[id] = image;
	                    this.updatedImages[id] = true;
	                  };
	                  ImageManager2.prototype.removeImage = function removeImage(id) {
	                    var image = this.images[id];
	                    delete this.images[id];
	                    delete this.patterns[id];
	                    if (image.userImage && image.userImage.onRemove) {
	                      image.userImage.onRemove();
	                    }
	                  };
	                  ImageManager2.prototype.listImages = function listImages() {
	                    return Object.keys(this.images);
	                  };
	                  ImageManager2.prototype.getImages = function getImages(ids, callback) {
	                    var hasAllDependencies = true;
	                    if (!this.isLoaded()) {
	                      for (var i = 0, list = ids; i < list.length; i += 1) {
	                        var id = list[i];
	                        if (!this.images[id]) {
	                          hasAllDependencies = false;
	                        }
	                      }
	                    }
	                    if (this.isLoaded() || hasAllDependencies) {
	                      this._notify(ids, callback);
	                    } else {
	                      this.requestors.push({
	                        ids,
	                        callback
	                      });
	                    }
	                  };
	                  ImageManager2.prototype._notify = function _notify(ids, callback) {
	                    var response = {};
	                    for (var i = 0, list = ids; i < list.length; i += 1) {
	                      var id = list[i];
	                      if (!this.images[id]) {
	                        this.fire(new performance2.Event("styleimagemissing", { id }));
	                      }
	                      var image = this.images[id];
	                      if (image) {
	                        response[id] = {
	                          data: image.data.clone(),
	                          pixelRatio: image.pixelRatio,
	                          sdf: image.sdf,
	                          version: image.version,
	                          stretchX: image.stretchX,
	                          stretchY: image.stretchY,
	                          content: image.content,
	                          hasRenderCallback: Boolean(image.userImage && image.userImage.render)
	                        };
	                      } else {
	                        performance2.warnOnce('Image "' + id + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
	                      }
	                    }
	                    callback(null, response);
	                  };
	                  ImageManager2.prototype.getPixelSize = function getPixelSize() {
	                    var ref = this.atlasImage;
	                    var width = ref.width;
	                    var height = ref.height;
	                    return {
	                      width,
	                      height
	                    };
	                  };
	                  ImageManager2.prototype.getPattern = function getPattern(id) {
	                    var pattern = this.patterns[id];
	                    var image = this.getImage(id);
	                    if (!image) {
	                      return null;
	                    }
	                    if (pattern && pattern.position.version === image.version) {
	                      return pattern.position;
	                    }
	                    if (!pattern) {
	                      var w = image.data.width + padding * 2;
	                      var h = image.data.height + padding * 2;
	                      var bin = {
	                        w,
	                        h,
	                        x: 0,
	                        y: 0
	                      };
	                      var position = new performance2.ImagePosition(bin, image);
	                      this.patterns[id] = {
	                        bin,
	                        position
	                      };
	                    } else {
	                      pattern.position.version = image.version;
	                    }
	                    this._updatePatternAtlas();
	                    return this.patterns[id].position;
	                  };
	                  ImageManager2.prototype.bind = function bind(context) {
	                    var gl2 = context.gl;
	                    if (!this.atlasTexture) {
	                      this.atlasTexture = new performance2.Texture(context, this.atlasImage, gl2.RGBA);
	                    } else if (this.dirty) {
	                      this.atlasTexture.update(this.atlasImage);
	                      this.dirty = false;
	                    }
	                    this.atlasTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                  };
	                  ImageManager2.prototype._updatePatternAtlas = function _updatePatternAtlas() {
	                    var bins = [];
	                    for (var id in this.patterns) {
	                      bins.push(this.patterns[id].bin);
	                    }
	                    var ref = performance2.potpack(bins);
	                    var w = ref.w;
	                    var h = ref.h;
	                    var dst = this.atlasImage;
	                    dst.resize({
	                      width: w || 1,
	                      height: h || 1
	                    });
	                    for (var id$1 in this.patterns) {
	                      var ref$1 = this.patterns[id$1];
	                      var bin = ref$1.bin;
	                      var x = bin.x + padding;
	                      var y = bin.y + padding;
	                      var src = this.images[id$1].data;
	                      var w$1 = src.width;
	                      var h$1 = src.height;
	                      performance2.RGBAImage.copy(src, dst, {
	                        x: 0,
	                        y: 0
	                      }, {
	                        x,
	                        y
	                      }, {
	                        width: w$1,
	                        height: h$1
	                      });
	                      performance2.RGBAImage.copy(src, dst, {
	                        x: 0,
	                        y: h$1 - 1
	                      }, {
	                        x,
	                        y: y - 1
	                      }, {
	                        width: w$1,
	                        height: 1
	                      });
	                      performance2.RGBAImage.copy(src, dst, {
	                        x: 0,
	                        y: 0
	                      }, {
	                        x,
	                        y: y + h$1
	                      }, {
	                        width: w$1,
	                        height: 1
	                      });
	                      performance2.RGBAImage.copy(src, dst, {
	                        x: w$1 - 1,
	                        y: 0
	                      }, {
	                        x: x - 1,
	                        y
	                      }, {
	                        width: 1,
	                        height: h$1
	                      });
	                      performance2.RGBAImage.copy(src, dst, {
	                        x: 0,
	                        y: 0
	                      }, {
	                        x: x + w$1,
	                        y
	                      }, {
	                        width: 1,
	                        height: h$1
	                      });
	                    }
	                    this.dirty = true;
	                  };
	                  ImageManager2.prototype.beginFrame = function beginFrame() {
	                    this.callbackDispatchedThisFrame = {};
	                  };
	                  ImageManager2.prototype.dispatchRenderCallbacks = function dispatchRenderCallbacks(ids) {
	                    for (var i = 0, list = ids; i < list.length; i += 1) {
	                      var id = list[i];
	                      if (this.callbackDispatchedThisFrame[id]) {
	                        continue;
	                      }
	                      this.callbackDispatchedThisFrame[id] = true;
	                      var image = this.images[id];
	                      var updated = renderStyleImage(image);
	                      if (updated) {
	                        this.updateImage(id, image);
	                      }
	                    }
	                  };
	                  return ImageManager2;
	                }(performance2.Evented);
	                function loadGlyphRange(fontstack, range2, urlTemplate, requestManager, callback) {
	                  var begin = range2 * 256;
	                  var end = begin + 255;
	                  var request = requestManager.transformRequest(requestManager.normalizeGlyphsURL(urlTemplate).replace("{fontstack}", fontstack).replace("{range}", begin + "-" + end), performance2.ResourceType.Glyphs);
	                  performance2.getArrayBuffer(request, function(err, data) {
	                    if (err) {
	                      callback(err);
	                    } else if (data) {
	                      var glyphs = {};
	                      for (var i = 0, list = performance2.parseGlyphPBF(data); i < list.length; i += 1) {
	                        var glyph = list[i];
	                        glyphs[glyph.id] = glyph;
	                      }
	                      callback(null, glyphs);
	                    }
	                  });
	                }
	                var tinySdf = TinySDF;
	                var default_1 = TinySDF;
	                var INF = 1e20;
	                function TinySDF(fontSize, buffer, radius, cutoff, fontFamily, fontWeight) {
	                  this.fontSize = fontSize || 24;
	                  this.buffer = buffer === undefined ? 3 : buffer;
	                  this.cutoff = cutoff || 0.25;
	                  this.fontFamily = fontFamily || "sans-serif";
	                  this.fontWeight = fontWeight || "normal";
	                  this.radius = radius || 8;
	                  var size = this.size = this.fontSize + this.buffer * 2;
	                  this.canvas = document.createElement("canvas");
	                  this.canvas.width = this.canvas.height = size;
	                  this.ctx = this.canvas.getContext("2d");
	                  this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily;
	                  this.ctx.textBaseline = "middle";
	                  this.ctx.fillStyle = "black";
	                  this.gridOuter = new Float64Array(size * size);
	                  this.gridInner = new Float64Array(size * size);
	                  this.f = new Float64Array(size);
	                  this.d = new Float64Array(size);
	                  this.z = new Float64Array(size + 1);
	                  this.v = new Int16Array(size);
	                  this.middle = Math.round(size / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
	                }
	                TinySDF.prototype.draw = function(char) {
	                  this.ctx.clearRect(0, 0, this.size, this.size);
	                  this.ctx.fillText(char, this.buffer, this.middle);
	                  var imgData = this.ctx.getImageData(0, 0, this.size, this.size);
	                  var alphaChannel = new Uint8ClampedArray(this.size * this.size);
	                  for (var i = 0; i < this.size * this.size; i++) {
	                    var a = imgData.data[i * 4 + 3] / 255;
	                    this.gridOuter[i] = a === 1 ? 0 : a === 0 ? INF : Math.pow(Math.max(0, 0.5 - a), 2);
	                    this.gridInner[i] = a === 1 ? INF : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2);
	                  }
	                  edt(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z);
	                  edt(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z);
	                  for (i = 0; i < this.size * this.size; i++) {
	                    var d = this.gridOuter[i] - this.gridInner[i];
	                    alphaChannel[i] = Math.max(0, Math.min(255, Math.round(255 - 255 * (d / this.radius + this.cutoff))));
	                  }
	                  return alphaChannel;
	                };
	                function edt(data, width, height, f, d, v, z) {
	                  for (var x = 0; x < width; x++) {
	                    for (var y = 0; y < height; y++) {
	                      f[y] = data[y * width + x];
	                    }
	                    edt1d(f, d, v, z, height);
	                    for (y = 0; y < height; y++) {
	                      data[y * width + x] = d[y];
	                    }
	                  }
	                  for (y = 0; y < height; y++) {
	                    for (x = 0; x < width; x++) {
	                      f[x] = data[y * width + x];
	                    }
	                    edt1d(f, d, v, z, width);
	                    for (x = 0; x < width; x++) {
	                      data[y * width + x] = Math.sqrt(d[x]);
	                    }
	                  }
	                }
	                function edt1d(f, d, v, z, n) {
	                  v[0] = 0;
	                  z[0] = -1e20;
	                  z[1] = 1e20;
	                  for (var q = 1, k = 0; q < n; q++) {
	                    var s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
	                    while (s <= z[k]) {
	                      k--;
	                      s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
	                    }
	                    k++;
	                    v[k] = q;
	                    z[k] = s;
	                    z[k + 1] = 1e20;
	                  }
	                  for (q = 0, k = 0; q < n; q++) {
	                    while (z[k + 1] < q) {
	                      k++;
	                    }
	                    d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
	                  }
	                }
	                tinySdf.default = default_1;
	                var GlyphManager = function GlyphManager2(requestManager, localIdeographFontFamily) {
	                  this.requestManager = requestManager;
	                  this.localIdeographFontFamily = localIdeographFontFamily;
	                  this.entries = {};
	                };
	                GlyphManager.prototype.setURL = function setURL(url) {
	                  this.url = url;
	                };
	                GlyphManager.prototype.getGlyphs = function getGlyphs(glyphs, callback) {
	                  var this$1$1 = this;
	                  var all = [];
	                  for (var stack in glyphs) {
	                    for (var i = 0, list = glyphs[stack]; i < list.length; i += 1) {
	                      var id = list[i];
	                      all.push({
	                        stack,
	                        id
	                      });
	                    }
	                  }
	                  performance2.asyncAll(all, function(ref, callback2) {
	                    var stack2 = ref.stack;
	                    var id2 = ref.id;
	                    var entry = this$1$1.entries[stack2];
	                    if (!entry) {
	                      entry = this$1$1.entries[stack2] = {
	                        glyphs: {},
	                        requests: {},
	                        ranges: {}
	                      };
	                    }
	                    var glyph = entry.glyphs[id2];
	                    if (glyph !== undefined) {
	                      callback2(null, {
	                        stack: stack2,
	                        id: id2,
	                        glyph
	                      });
	                      return;
	                    }
	                    glyph = this$1$1._tinySDF(entry, stack2, id2);
	                    if (glyph) {
	                      entry.glyphs[id2] = glyph;
	                      callback2(null, {
	                        stack: stack2,
	                        id: id2,
	                        glyph
	                      });
	                      return;
	                    }
	                    var range2 = Math.floor(id2 / 256);
	                    if (range2 * 256 > 65535) {
	                      callback2(new Error("glyphs > 65535 not supported"));
	                      return;
	                    }
	                    if (entry.ranges[range2]) {
	                      callback2(null, {
	                        stack: stack2,
	                        id: id2,
	                        glyph
	                      });
	                      return;
	                    }
	                    var requests = entry.requests[range2];
	                    if (!requests) {
	                      requests = entry.requests[range2] = [];
	                      GlyphManager.loadGlyphRange(stack2, range2, this$1$1.url, this$1$1.requestManager, function(err, response) {
	                        if (response) {
	                          for (var id3 in response) {
	                            if (!this$1$1._doesCharSupportLocalGlyph(+id3)) {
	                              entry.glyphs[+id3] = response[+id3];
	                            }
	                          }
	                          entry.ranges[range2] = true;
	                        }
	                        for (var i2 = 0, list2 = requests; i2 < list2.length; i2 += 1) {
	                          var cb = list2[i2];
	                          cb(err, response);
	                        }
	                        delete entry.requests[range2];
	                      });
	                    }
	                    requests.push(function(err, result) {
	                      if (err) {
	                        callback2(err);
	                      } else if (result) {
	                        callback2(null, {
	                          stack: stack2,
	                          id: id2,
	                          glyph: result[id2] || null
	                        });
	                      }
	                    });
	                  }, function(err, glyphs2) {
	                    if (err) {
	                      callback(err);
	                    } else if (glyphs2) {
	                      var result = {};
	                      for (var i2 = 0, list2 = glyphs2; i2 < list2.length; i2 += 1) {
	                        var ref = list2[i2];
	                        var stack2 = ref.stack;
	                        var id2 = ref.id;
	                        var glyph = ref.glyph;
	                        (result[stack2] || (result[stack2] = {}))[id2] = glyph && {
	                          id: glyph.id,
	                          bitmap: glyph.bitmap.clone(),
	                          metrics: glyph.metrics
	                        };
	                      }
	                      callback(null, result);
	                    }
	                  });
	                };
	                GlyphManager.prototype._doesCharSupportLocalGlyph = function _doesCharSupportLocalGlyph(id) {
	                  return !!this.localIdeographFontFamily && (performance2.isChar["CJK Unified Ideographs"](id) || performance2.isChar["Hangul Syllables"](id) || performance2.isChar["Hiragana"](id) || performance2.isChar["Katakana"](id));
	                };
	                GlyphManager.prototype._tinySDF = function _tinySDF(entry, stack, id) {
	                  var family = this.localIdeographFontFamily;
	                  if (!family) {
	                    return;
	                  }
	                  if (!this._doesCharSupportLocalGlyph(id)) {
	                    return;
	                  }
	                  var tinySDF = entry.tinySDF;
	                  if (!tinySDF) {
	                    var fontWeight = "400";
	                    if (/bold/i.test(stack)) {
	                      fontWeight = "900";
	                    } else if (/medium/i.test(stack)) {
	                      fontWeight = "500";
	                    } else if (/light/i.test(stack)) {
	                      fontWeight = "200";
	                    }
	                    tinySDF = entry.tinySDF = new GlyphManager.TinySDF(24, 3, 8, 0.25, family, fontWeight);
	                  }
	                  return {
	                    id,
	                    bitmap: new performance2.AlphaImage({
	                      width: 30,
	                      height: 30
	                    }, tinySDF.draw(String.fromCharCode(id))),
	                    metrics: {
	                      width: 24,
	                      height: 24,
	                      left: 0,
	                      top: -8,
	                      advance: 24
	                    }
	                  };
	                };
	                GlyphManager.loadGlyphRange = loadGlyphRange;
	                GlyphManager.TinySDF = tinySdf;
	                var LightPositionProperty = function LightPositionProperty2() {
	                  this.specification = performance2.styleSpec.light.position;
	                };
	                LightPositionProperty.prototype.possiblyEvaluate = function possiblyEvaluate(value, parameters) {
	                  return performance2.sphericalToCartesian(value.expression.evaluate(parameters));
	                };
	                LightPositionProperty.prototype.interpolate = function interpolate$1(a, b, t) {
	                  return {
	                    x: performance2.number(a.x, b.x, t),
	                    y: performance2.number(a.y, b.y, t),
	                    z: performance2.number(a.z, b.z, t)
	                  };
	                };
	                var properties = new performance2.Properties({
	                  "anchor": new performance2.DataConstantProperty(performance2.styleSpec.light.anchor),
	                  "position": new LightPositionProperty(),
	                  "color": new performance2.DataConstantProperty(performance2.styleSpec.light.color),
	                  "intensity": new performance2.DataConstantProperty(performance2.styleSpec.light.intensity)
	                });
	                var TRANSITION_SUFFIX = "-transition";
	                var Light = function(Evented) {
	                  function Light2(lightOptions) {
	                    Evented.call(this);
	                    this._transitionable = new performance2.Transitionable(properties);
	                    this.setLight(lightOptions);
	                    this._transitioning = this._transitionable.untransitioned();
	                  }
	                  if (Evented)
	                    Light2.__proto__ = Evented;
	                  Light2.prototype = Object.create(Evented && Evented.prototype);
	                  Light2.prototype.constructor = Light2;
	                  Light2.prototype.getLight = function getLight() {
	                    return this._transitionable.serialize();
	                  };
	                  Light2.prototype.setLight = function setLight(light, options) {
	                    if (options === undefined)
	                      options = {};
	                    if (this._validate(performance2.validateLight, light, options)) {
	                      return;
	                    }
	                    for (var name2 in light) {
	                      var value = light[name2];
	                      if (performance2.endsWith(name2, TRANSITION_SUFFIX)) {
	                        this._transitionable.setTransition(name2.slice(0, -TRANSITION_SUFFIX.length), value);
	                      } else {
	                        this._transitionable.setValue(name2, value);
	                      }
	                    }
	                  };
	                  Light2.prototype.updateTransitions = function updateTransitions(parameters) {
	                    this._transitioning = this._transitionable.transitioned(parameters, this._transitioning);
	                  };
	                  Light2.prototype.hasTransition = function hasTransition() {
	                    return this._transitioning.hasTransition();
	                  };
	                  Light2.prototype.recalculate = function recalculate(parameters) {
	                    this.properties = this._transitioning.possiblyEvaluate(parameters);
	                  };
	                  Light2.prototype._validate = function _validate(validate, value, options) {
	                    if (options && options.validate === false) {
	                      return false;
	                    }
	                    return performance2.emitValidationErrors(this, validate.call(performance2.validateStyle, performance2.extend({
	                      value,
	                      style: {
	                        glyphs: true,
	                        sprite: true
	                      },
	                      styleSpec: performance2.styleSpec
	                    })));
	                  };
	                  return Light2;
	                }(performance2.Evented);
	                var LineAtlas = function LineAtlas2(width, height) {
	                  this.width = width;
	                  this.height = height;
	                  this.nextRow = 0;
	                  this.data = new Uint8Array(this.width * this.height);
	                  this.dashEntry = {};
	                };
	                LineAtlas.prototype.getDash = function getDash(dasharray, round) {
	                  var key = dasharray.join(",") + String(round);
	                  if (!this.dashEntry[key]) {
	                    this.dashEntry[key] = this.addDash(dasharray, round);
	                  }
	                  return this.dashEntry[key];
	                };
	                LineAtlas.prototype.getDashRanges = function getDashRanges(dasharray, lineAtlasWidth, stretch) {
	                  var oddDashArray = dasharray.length % 2 === 1;
	                  var ranges = [];
	                  var left = oddDashArray ? -dasharray[dasharray.length - 1] * stretch : 0;
	                  var right = dasharray[0] * stretch;
	                  var isDash = true;
	                  ranges.push({
	                    left,
	                    right,
	                    isDash,
	                    zeroLength: dasharray[0] === 0
	                  });
	                  var currentDashLength = dasharray[0];
	                  for (var i = 1; i < dasharray.length; i++) {
	                    isDash = !isDash;
	                    var dashLength = dasharray[i];
	                    left = currentDashLength * stretch;
	                    currentDashLength += dashLength;
	                    right = currentDashLength * stretch;
	                    ranges.push({
	                      left,
	                      right,
	                      isDash,
	                      zeroLength: dashLength === 0
	                    });
	                  }
	                  return ranges;
	                };
	                LineAtlas.prototype.addRoundDash = function addRoundDash(ranges, stretch, n) {
	                  var halfStretch = stretch / 2;
	                  for (var y = -n; y <= n; y++) {
	                    var row = this.nextRow + n + y;
	                    var index = this.width * row;
	                    var currIndex = 0;
	                    var range2 = ranges[currIndex];
	                    for (var x = 0; x < this.width; x++) {
	                      if (x / range2.right > 1) {
	                        range2 = ranges[++currIndex];
	                      }
	                      var distLeft = Math.abs(x - range2.left);
	                      var distRight = Math.abs(x - range2.right);
	                      var minDist = Math.min(distLeft, distRight);
	                      var signedDistance = undefined;
	                      var distMiddle = y / n * (halfStretch + 1);
	                      if (range2.isDash) {
	                        var distEdge = halfStretch - Math.abs(distMiddle);
	                        signedDistance = Math.sqrt(minDist * minDist + distEdge * distEdge);
	                      } else {
	                        signedDistance = halfStretch - Math.sqrt(minDist * minDist + distMiddle * distMiddle);
	                      }
	                      this.data[index + x] = Math.max(0, Math.min(255, signedDistance + 128));
	                    }
	                  }
	                };
	                LineAtlas.prototype.addRegularDash = function addRegularDash(ranges) {
	                  for (var i = ranges.length - 1; i >= 0; --i) {
	                    var part = ranges[i];
	                    var next = ranges[i + 1];
	                    if (part.zeroLength) {
	                      ranges.splice(i, 1);
	                    } else if (next && next.isDash === part.isDash) {
	                      next.left = part.left;
	                      ranges.splice(i, 1);
	                    }
	                  }
	                  var first = ranges[0];
	                  var last = ranges[ranges.length - 1];
	                  if (first.isDash === last.isDash) {
	                    first.left = last.left - this.width;
	                    last.right = first.right + this.width;
	                  }
	                  var index = this.width * this.nextRow;
	                  var currIndex = 0;
	                  var range2 = ranges[currIndex];
	                  for (var x = 0; x < this.width; x++) {
	                    if (x / range2.right > 1) {
	                      range2 = ranges[++currIndex];
	                    }
	                    var distLeft = Math.abs(x - range2.left);
	                    var distRight = Math.abs(x - range2.right);
	                    var minDist = Math.min(distLeft, distRight);
	                    var signedDistance = range2.isDash ? minDist : -minDist;
	                    this.data[index + x] = Math.max(0, Math.min(255, signedDistance + 128));
	                  }
	                };
	                LineAtlas.prototype.addDash = function addDash(dasharray, round) {
	                  var n = round ? 7 : 0;
	                  var height = 2 * n + 1;
	                  if (this.nextRow + height > this.height) {
	                    performance2.warnOnce("LineAtlas out of space");
	                    return null;
	                  }
	                  var length = 0;
	                  for (var i = 0; i < dasharray.length; i++) {
	                    length += dasharray[i];
	                  }
	                  if (length !== 0) {
	                    var stretch = this.width / length;
	                    var ranges = this.getDashRanges(dasharray, this.width, stretch);
	                    if (round) {
	                      this.addRoundDash(ranges, stretch, n);
	                    } else {
	                      this.addRegularDash(ranges);
	                    }
	                  }
	                  var dashEntry = {
	                    y: (this.nextRow + n + 0.5) / this.height,
	                    height: 2 * n / this.height,
	                    width: length
	                  };
	                  this.nextRow += height;
	                  this.dirty = true;
	                  return dashEntry;
	                };
	                LineAtlas.prototype.bind = function bind(context) {
	                  var gl2 = context.gl;
	                  if (!this.texture) {
	                    this.texture = gl2.createTexture();
	                    gl2.bindTexture(gl2.TEXTURE_2D, this.texture);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_S, gl2.REPEAT);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_T, gl2.REPEAT);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MIN_FILTER, gl2.LINEAR);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MAG_FILTER, gl2.LINEAR);
	                    gl2.texImage2D(gl2.TEXTURE_2D, 0, gl2.ALPHA, this.width, this.height, 0, gl2.ALPHA, gl2.UNSIGNED_BYTE, this.data);
	                  } else {
	                    gl2.bindTexture(gl2.TEXTURE_2D, this.texture);
	                    if (this.dirty) {
	                      this.dirty = false;
	                      gl2.texSubImage2D(gl2.TEXTURE_2D, 0, 0, 0, this.width, this.height, gl2.ALPHA, gl2.UNSIGNED_BYTE, this.data);
	                    }
	                  }
	                };
	                var Dispatcher = function Dispatcher2(workerPool, parent) {
	                  this.workerPool = workerPool;
	                  this.actors = [];
	                  this.currentActor = 0;
	                  this.id = performance2.uniqueId();
	                  var workers = this.workerPool.acquire(this.id);
	                  for (var i = 0; i < workers.length; i++) {
	                    var worker2 = workers[i];
	                    var actor = new Dispatcher2.Actor(worker2, parent, this.id);
	                    actor.name = "Worker " + i;
	                    this.actors.push(actor);
	                  }
	                };
	                Dispatcher.prototype.broadcast = function broadcast(type, data, cb) {
	                  cb = cb || function() {
	                  };
	                  performance2.asyncAll(this.actors, function(actor, done) {
	                    actor.send(type, data, done);
	                  }, cb);
	                };
	                Dispatcher.prototype.getActor = function getActor() {
	                  this.currentActor = (this.currentActor + 1) % this.actors.length;
	                  return this.actors[this.currentActor];
	                };
	                Dispatcher.prototype.remove = function remove() {
	                  this.actors.forEach(function(actor) {
	                    actor.remove();
	                  });
	                  this.actors = [];
	                  this.workerPool.release(this.id);
	                };
	                Dispatcher.Actor = performance2.Actor;
	                function loadTileJSON(options, requestManager, callback) {
	                  var loaded = function(err, tileJSON) {
	                    if (err) {
	                      return callback(err);
	                    } else if (tileJSON) {
	                      var result = performance2.pick(performance2.extend(tileJSON, options), [
	                        "tiles",
	                        "minzoom",
	                        "maxzoom",
	                        "attribution",
	                        "mapbox_logo",
	                        "bounds",
	                        "scheme",
	                        "tileSize",
	                        "encoding"
	                      ]);
	                      if (tileJSON.vector_layers) {
	                        result.vectorLayers = tileJSON.vector_layers;
	                        result.vectorLayerIds = result.vectorLayers.map(function(layer) {
	                          return layer.id;
	                        });
	                      }
	                      result.tiles = requestManager.canonicalizeTileset(result, options.url);
	                      callback(null, result);
	                    }
	                  };
	                  if (options.url) {
	                    return performance2.getJSON(requestManager.transformRequest(requestManager.normalizeSourceURL(options.url), performance2.ResourceType.Source), loaded);
	                  } else {
	                    return performance2.browser.frame(function() {
	                      return loaded(null, options);
	                    });
	                  }
	                }
	                var TileBounds = function TileBounds2(bounds, minzoom, maxzoom) {
	                  this.bounds = performance2.LngLatBounds.convert(this.validateBounds(bounds));
	                  this.minzoom = minzoom || 0;
	                  this.maxzoom = maxzoom || 24;
	                };
	                TileBounds.prototype.validateBounds = function validateBounds(bounds) {
	                  if (!Array.isArray(bounds) || bounds.length !== 4) {
	                    return [
	                      -180,
	                      -90,
	                      180,
	                      90
	                    ];
	                  }
	                  return [
	                    Math.max(-180, bounds[0]),
	                    Math.max(-90, bounds[1]),
	                    Math.min(180, bounds[2]),
	                    Math.min(90, bounds[3])
	                  ];
	                };
	                TileBounds.prototype.contains = function contains(tileID) {
	                  var worldSize = Math.pow(2, tileID.z);
	                  var level = {
	                    minX: Math.floor(performance2.mercatorXfromLng(this.bounds.getWest()) * worldSize),
	                    minY: Math.floor(performance2.mercatorYfromLat(this.bounds.getNorth()) * worldSize),
	                    maxX: Math.ceil(performance2.mercatorXfromLng(this.bounds.getEast()) * worldSize),
	                    maxY: Math.ceil(performance2.mercatorYfromLat(this.bounds.getSouth()) * worldSize)
	                  };
	                  var hit = tileID.x >= level.minX && tileID.x < level.maxX && tileID.y >= level.minY && tileID.y < level.maxY;
	                  return hit;
	                };
	                var VectorTileSource = function(Evented) {
	                  function VectorTileSource2(id, options, dispatcher, eventedParent) {
	                    Evented.call(this);
	                    this.id = id;
	                    this.dispatcher = dispatcher;
	                    this.type = "vector";
	                    this.minzoom = 0;
	                    this.maxzoom = 22;
	                    this.scheme = "xyz";
	                    this.tileSize = 512;
	                    this.reparseOverscaled = true;
	                    this.isTileClipped = true;
	                    this._loaded = false;
	                    performance2.extend(this, performance2.pick(options, [
	                      "url",
	                      "scheme",
	                      "tileSize",
	                      "promoteId"
	                    ]));
	                    this._options = performance2.extend({ type: "vector" }, options);
	                    this._collectResourceTiming = options.collectResourceTiming;
	                    if (this.tileSize !== 512) {
	                      throw new Error("vector tile sources must have a tileSize of 512");
	                    }
	                    this.setEventedParent(eventedParent);
	                  }
	                  if (Evented)
	                    VectorTileSource2.__proto__ = Evented;
	                  VectorTileSource2.prototype = Object.create(Evented && Evented.prototype);
	                  VectorTileSource2.prototype.constructor = VectorTileSource2;
	                  VectorTileSource2.prototype.load = function load() {
	                    var this$1$1 = this;
	                    this._loaded = false;
	                    this.fire(new performance2.Event("dataloading", { dataType: "source" }));
	                    this._tileJSONRequest = loadTileJSON(this._options, this.map._requestManager, function(err, tileJSON) {
	                      this$1$1._tileJSONRequest = null;
	                      this$1$1._loaded = true;
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                      } else if (tileJSON) {
	                        performance2.extend(this$1$1, tileJSON);
	                        if (tileJSON.bounds) {
	                          this$1$1.tileBounds = new TileBounds(tileJSON.bounds, this$1$1.minzoom, this$1$1.maxzoom);
	                        }
	                        performance2.postTurnstileEvent(tileJSON.tiles, this$1$1.map._requestManager._customAccessToken);
	                        performance2.postMapLoadEvent(tileJSON.tiles, this$1$1.map._getMapId(), this$1$1.map._requestManager._skuToken, this$1$1.map._requestManager._customAccessToken);
	                        this$1$1.fire(new performance2.Event("data", {
	                          dataType: "source",
	                          sourceDataType: "metadata"
	                        }));
	                        this$1$1.fire(new performance2.Event("data", {
	                          dataType: "source",
	                          sourceDataType: "content"
	                        }));
	                      }
	                    });
	                  };
	                  VectorTileSource2.prototype.loaded = function loaded() {
	                    return this._loaded;
	                  };
	                  VectorTileSource2.prototype.hasTile = function hasTile(tileID) {
	                    return !this.tileBounds || this.tileBounds.contains(tileID.canonical);
	                  };
	                  VectorTileSource2.prototype.onAdd = function onAdd(map2) {
	                    this.map = map2;
	                    this.load();
	                  };
	                  VectorTileSource2.prototype.onRemove = function onRemove() {
	                    if (this._tileJSONRequest) {
	                      this._tileJSONRequest.cancel();
	                      this._tileJSONRequest = null;
	                    }
	                  };
	                  VectorTileSource2.prototype.serialize = function serialize() {
	                    return performance2.extend({}, this._options);
	                  };
	                  VectorTileSource2.prototype.loadTile = function loadTile(tile, callback) {
	                    var url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme));
	                    var params = {
	                      request: this.map._requestManager.transformRequest(url, performance2.ResourceType.Tile),
	                      uid: tile.uid,
	                      tileID: tile.tileID,
	                      zoom: tile.tileID.overscaledZ,
	                      tileSize: this.tileSize * tile.tileID.overscaleFactor(),
	                      type: this.type,
	                      source: this.id,
	                      pixelRatio: performance2.browser.devicePixelRatio,
	                      showCollisionBoxes: this.map.showCollisionBoxes,
	                      promoteId: this.promoteId
	                    };
	                    params.request.collectResourceTiming = this._collectResourceTiming;
	                    if (!tile.actor || tile.state === "expired") {
	                      tile.actor = this.dispatcher.getActor();
	                      tile.request = tile.actor.send("loadTile", params, done.bind(this));
	                    } else if (tile.state === "loading") {
	                      tile.reloadCallback = callback;
	                    } else {
	                      tile.request = tile.actor.send("reloadTile", params, done.bind(this));
	                    }
	                    function done(err, data) {
	                      delete tile.request;
	                      if (tile.aborted) {
	                        return callback(null);
	                      }
	                      if (err && err.status !== 404) {
	                        return callback(err);
	                      }
	                      if (data && data.resourceTiming) {
	                        tile.resourceTiming = data.resourceTiming;
	                      }
	                      if (this.map._refreshExpiredTiles && data) {
	                        tile.setExpiryData(data);
	                      }
	                      tile.loadVectorData(data, this.map.painter);
	                      performance2.cacheEntryPossiblyAdded(this.dispatcher);
	                      callback(null);
	                      if (tile.reloadCallback) {
	                        this.loadTile(tile, tile.reloadCallback);
	                        tile.reloadCallback = null;
	                      }
	                    }
	                  };
	                  VectorTileSource2.prototype.abortTile = function abortTile(tile) {
	                    if (tile.request) {
	                      tile.request.cancel();
	                      delete tile.request;
	                    }
	                    if (tile.actor) {
	                      tile.actor.send("abortTile", {
	                        uid: tile.uid,
	                        type: this.type,
	                        source: this.id
	                      }, undefined);
	                    }
	                  };
	                  VectorTileSource2.prototype.unloadTile = function unloadTile(tile) {
	                    tile.unloadVectorData();
	                    if (tile.actor) {
	                      tile.actor.send("removeTile", {
	                        uid: tile.uid,
	                        type: this.type,
	                        source: this.id
	                      }, undefined);
	                    }
	                  };
	                  VectorTileSource2.prototype.hasTransition = function hasTransition() {
	                    return false;
	                  };
	                  return VectorTileSource2;
	                }(performance2.Evented);
	                var RasterTileSource = function(Evented) {
	                  function RasterTileSource2(id, options, dispatcher, eventedParent) {
	                    Evented.call(this);
	                    this.id = id;
	                    this.dispatcher = dispatcher;
	                    this.setEventedParent(eventedParent);
	                    this.type = "raster";
	                    this.minzoom = 0;
	                    this.maxzoom = 22;
	                    this.roundZoom = true;
	                    this.scheme = "xyz";
	                    this.tileSize = 512;
	                    this._loaded = false;
	                    this._options = performance2.extend({ type: "raster" }, options);
	                    performance2.extend(this, performance2.pick(options, [
	                      "url",
	                      "scheme",
	                      "tileSize"
	                    ]));
	                  }
	                  if (Evented)
	                    RasterTileSource2.__proto__ = Evented;
	                  RasterTileSource2.prototype = Object.create(Evented && Evented.prototype);
	                  RasterTileSource2.prototype.constructor = RasterTileSource2;
	                  RasterTileSource2.prototype.load = function load() {
	                    var this$1$1 = this;
	                    this._loaded = false;
	                    this.fire(new performance2.Event("dataloading", { dataType: "source" }));
	                    this._tileJSONRequest = loadTileJSON(this._options, this.map._requestManager, function(err, tileJSON) {
	                      this$1$1._tileJSONRequest = null;
	                      this$1$1._loaded = true;
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                      } else if (tileJSON) {
	                        performance2.extend(this$1$1, tileJSON);
	                        if (tileJSON.bounds) {
	                          this$1$1.tileBounds = new TileBounds(tileJSON.bounds, this$1$1.minzoom, this$1$1.maxzoom);
	                        }
	                        performance2.postTurnstileEvent(tileJSON.tiles);
	                        performance2.postMapLoadEvent(tileJSON.tiles, this$1$1.map._getMapId(), this$1$1.map._requestManager._skuToken);
	                        this$1$1.fire(new performance2.Event("data", {
	                          dataType: "source",
	                          sourceDataType: "metadata"
	                        }));
	                        this$1$1.fire(new performance2.Event("data", {
	                          dataType: "source",
	                          sourceDataType: "content"
	                        }));
	                      }
	                    });
	                  };
	                  RasterTileSource2.prototype.loaded = function loaded() {
	                    return this._loaded;
	                  };
	                  RasterTileSource2.prototype.onAdd = function onAdd(map2) {
	                    this.map = map2;
	                    this.load();
	                  };
	                  RasterTileSource2.prototype.onRemove = function onRemove() {
	                    if (this._tileJSONRequest) {
	                      this._tileJSONRequest.cancel();
	                      this._tileJSONRequest = null;
	                    }
	                  };
	                  RasterTileSource2.prototype.serialize = function serialize() {
	                    return performance2.extend({}, this._options);
	                  };
	                  RasterTileSource2.prototype.hasTile = function hasTile(tileID) {
	                    return !this.tileBounds || this.tileBounds.contains(tileID.canonical);
	                  };
	                  RasterTileSource2.prototype.loadTile = function loadTile(tile, callback) {
	                    var this$1$1 = this;
	                    var url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
	                    tile.request = performance2.getImage(this.map._requestManager.transformRequest(url, performance2.ResourceType.Tile), function(err, img) {
	                      delete tile.request;
	                      if (tile.aborted) {
	                        tile.state = "unloaded";
	                        callback(null);
	                      } else if (err) {
	                        tile.state = "errored";
	                        callback(err);
	                      } else if (img) {
	                        if (this$1$1.map._refreshExpiredTiles) {
	                          tile.setExpiryData(img);
	                        }
	                        delete img.cacheControl;
	                        delete img.expires;
	                        var context = this$1$1.map.painter.context;
	                        var gl2 = context.gl;
	                        tile.texture = this$1$1.map.painter.getTileTexture(img.width);
	                        if (tile.texture) {
	                          tile.texture.update(img, { useMipmap: true });
	                        } else {
	                          tile.texture = new performance2.Texture(context, img, gl2.RGBA, { useMipmap: true });
	                          tile.texture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE, gl2.LINEAR_MIPMAP_NEAREST);
	                          if (context.extTextureFilterAnisotropic) {
	                            gl2.texParameterf(gl2.TEXTURE_2D, context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, context.extTextureFilterAnisotropicMax);
	                          }
	                        }
	                        tile.state = "loaded";
	                        performance2.cacheEntryPossiblyAdded(this$1$1.dispatcher);
	                        callback(null);
	                      }
	                    });
	                  };
	                  RasterTileSource2.prototype.abortTile = function abortTile(tile, callback) {
	                    if (tile.request) {
	                      tile.request.cancel();
	                      delete tile.request;
	                    }
	                    callback();
	                  };
	                  RasterTileSource2.prototype.unloadTile = function unloadTile(tile, callback) {
	                    if (tile.texture) {
	                      this.map.painter.saveTileTexture(tile.texture);
	                    }
	                    callback();
	                  };
	                  RasterTileSource2.prototype.hasTransition = function hasTransition() {
	                    return false;
	                  };
	                  return RasterTileSource2;
	                }(performance2.Evented);
	                var RasterDEMTileSource = function(RasterTileSource2) {
	                  function RasterDEMTileSource2(id, options, dispatcher, eventedParent) {
	                    RasterTileSource2.call(this, id, options, dispatcher, eventedParent);
	                    this.type = "raster-dem";
	                    this.maxzoom = 22;
	                    this._options = performance2.extend({ type: "raster-dem" }, options);
	                    this.encoding = options.encoding || "mapbox";
	                  }
	                  RasterDEMTileSource2.__proto__ = RasterTileSource2;
	                  RasterDEMTileSource2.prototype = Object.create(RasterTileSource2.prototype);
	                  RasterDEMTileSource2.prototype.constructor = RasterDEMTileSource2;
	                  RasterDEMTileSource2.prototype.serialize = function serialize() {
	                    return {
	                      type: "raster-dem",
	                      url: this.url,
	                      tileSize: this.tileSize,
	                      tiles: this.tiles,
	                      bounds: this.bounds,
	                      encoding: this.encoding
	                    };
	                  };
	                  RasterDEMTileSource2.prototype.loadTile = function loadTile(tile, callback) {
	                    var url = this.map._requestManager.normalizeTileURL(tile.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
	                    tile.request = performance2.getImage(this.map._requestManager.transformRequest(url, performance2.ResourceType.Tile), imageLoaded.bind(this));
	                    tile.neighboringTiles = this._getNeighboringTiles(tile.tileID);
	                    function imageLoaded(err, img) {
	                      delete tile.request;
	                      if (tile.aborted) {
	                        tile.state = "unloaded";
	                        callback(null);
	                      } else if (err) {
	                        tile.state = "errored";
	                        callback(err);
	                      } else if (img) {
	                        if (this.map._refreshExpiredTiles) {
	                          tile.setExpiryData(img);
	                        }
	                        delete img.cacheControl;
	                        delete img.expires;
	                        var transfer = performance2.window.ImageBitmap && img instanceof performance2.window.ImageBitmap && performance2.offscreenCanvasSupported();
	                        var rawImageData = transfer ? img : performance2.browser.getImageData(img, 1);
	                        var params = {
	                          uid: tile.uid,
	                          coord: tile.tileID,
	                          source: this.id,
	                          rawImageData,
	                          encoding: this.encoding
	                        };
	                        if (!tile.actor || tile.state === "expired") {
	                          tile.actor = this.dispatcher.getActor();
	                          tile.actor.send("loadDEMTile", params, done.bind(this));
	                        }
	                      }
	                    }
	                    function done(err, dem) {
	                      if (err) {
	                        tile.state = "errored";
	                        callback(err);
	                      }
	                      if (dem) {
	                        tile.dem = dem;
	                        tile.needsHillshadePrepare = true;
	                        tile.state = "loaded";
	                        callback(null);
	                      }
	                    }
	                  };
	                  RasterDEMTileSource2.prototype._getNeighboringTiles = function _getNeighboringTiles(tileID) {
	                    var canonical = tileID.canonical;
	                    var dim = Math.pow(2, canonical.z);
	                    var px = (canonical.x - 1 + dim) % dim;
	                    var pxw = canonical.x === 0 ? tileID.wrap - 1 : tileID.wrap;
	                    var nx = (canonical.x + 1 + dim) % dim;
	                    var nxw = canonical.x + 1 === dim ? tileID.wrap + 1 : tileID.wrap;
	                    var neighboringTiles = {};
	                    neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, pxw, canonical.z, px, canonical.y).key] = { backfilled: false };
	                    neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y).key] = { backfilled: false };
	                    if (canonical.y > 0) {
	                      neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, pxw, canonical.z, px, canonical.y - 1).key] = { backfilled: false };
	                      neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, tileID.wrap, canonical.z, canonical.x, canonical.y - 1).key] = { backfilled: false };
	                      neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y - 1).key] = { backfilled: false };
	                    }
	                    if (canonical.y + 1 < dim) {
	                      neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, pxw, canonical.z, px, canonical.y + 1).key] = { backfilled: false };
	                      neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, tileID.wrap, canonical.z, canonical.x, canonical.y + 1).key] = { backfilled: false };
	                      neighboringTiles[new performance2.OverscaledTileID(tileID.overscaledZ, nxw, canonical.z, nx, canonical.y + 1).key] = { backfilled: false };
	                    }
	                    return neighboringTiles;
	                  };
	                  RasterDEMTileSource2.prototype.unloadTile = function unloadTile(tile) {
	                    if (tile.demTexture) {
	                      this.map.painter.saveTileTexture(tile.demTexture);
	                    }
	                    if (tile.fbo) {
	                      tile.fbo.destroy();
	                      delete tile.fbo;
	                    }
	                    if (tile.dem) {
	                      delete tile.dem;
	                    }
	                    delete tile.neighboringTiles;
	                    tile.state = "unloaded";
	                    if (tile.actor) {
	                      tile.actor.send("removeDEMTile", {
	                        uid: tile.uid,
	                        source: this.id
	                      });
	                    }
	                  };
	                  return RasterDEMTileSource2;
	                }(RasterTileSource);
	                var GeoJSONSource = function(Evented) {
	                  function GeoJSONSource2(id, options, dispatcher, eventedParent) {
	                    Evented.call(this);
	                    this.id = id;
	                    this.type = "geojson";
	                    this.minzoom = 0;
	                    this.maxzoom = 18;
	                    this.tileSize = 512;
	                    this.isTileClipped = true;
	                    this.reparseOverscaled = true;
	                    this._removed = false;
	                    this._loaded = false;
	                    this.actor = dispatcher.getActor();
	                    this.setEventedParent(eventedParent);
	                    this._data = options.data;
	                    this._options = performance2.extend({}, options);
	                    this._collectResourceTiming = options.collectResourceTiming;
	                    this._resourceTiming = [];
	                    if (options.maxzoom !== undefined) {
	                      this.maxzoom = options.maxzoom;
	                    }
	                    if (options.type) {
	                      this.type = options.type;
	                    }
	                    if (options.attribution) {
	                      this.attribution = options.attribution;
	                    }
	                    this.promoteId = options.promoteId;
	                    var scale = performance2.EXTENT / this.tileSize;
	                    this.workerOptions = performance2.extend({
	                      source: this.id,
	                      cluster: options.cluster || false,
	                      geojsonVtOptions: {
	                        buffer: (options.buffer !== undefined ? options.buffer : 128) * scale,
	                        tolerance: (options.tolerance !== undefined ? options.tolerance : 0.375) * scale,
	                        extent: performance2.EXTENT,
	                        maxZoom: this.maxzoom,
	                        lineMetrics: options.lineMetrics || false,
	                        generateId: options.generateId || false
	                      },
	                      superclusterOptions: {
	                        maxZoom: options.clusterMaxZoom !== undefined ? Math.min(options.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
	                        extent: performance2.EXTENT,
	                        radius: (options.clusterRadius || 50) * scale,
	                        log: false,
	                        generateId: options.generateId || false
	                      },
	                      clusterProperties: options.clusterProperties
	                    }, options.workerOptions);
	                  }
	                  if (Evented)
	                    GeoJSONSource2.__proto__ = Evented;
	                  GeoJSONSource2.prototype = Object.create(Evented && Evented.prototype);
	                  GeoJSONSource2.prototype.constructor = GeoJSONSource2;
	                  GeoJSONSource2.prototype.load = function load() {
	                    var this$1$1 = this;
	                    this.fire(new performance2.Event("dataloading", { dataType: "source" }));
	                    this._updateWorkerData(function(err) {
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                        return;
	                      }
	                      var data = {
	                        dataType: "source",
	                        sourceDataType: "metadata"
	                      };
	                      if (this$1$1._collectResourceTiming && this$1$1._resourceTiming && this$1$1._resourceTiming.length > 0) {
	                        data.resourceTiming = this$1$1._resourceTiming;
	                        this$1$1._resourceTiming = [];
	                      }
	                      this$1$1.fire(new performance2.Event("data", data));
	                    });
	                  };
	                  GeoJSONSource2.prototype.onAdd = function onAdd(map2) {
	                    this.map = map2;
	                    this.load();
	                  };
	                  GeoJSONSource2.prototype.setData = function setData(data) {
	                    var this$1$1 = this;
	                    this._data = data;
	                    this.fire(new performance2.Event("dataloading", { dataType: "source" }));
	                    this._updateWorkerData(function(err) {
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                        return;
	                      }
	                      var data2 = {
	                        dataType: "source",
	                        sourceDataType: "content"
	                      };
	                      if (this$1$1._collectResourceTiming && this$1$1._resourceTiming && this$1$1._resourceTiming.length > 0) {
	                        data2.resourceTiming = this$1$1._resourceTiming;
	                        this$1$1._resourceTiming = [];
	                      }
	                      this$1$1.fire(new performance2.Event("data", data2));
	                    });
	                    return this;
	                  };
	                  GeoJSONSource2.prototype.getClusterExpansionZoom = function getClusterExpansionZoom(clusterId, callback) {
	                    this.actor.send("geojson.getClusterExpansionZoom", {
	                      clusterId,
	                      source: this.id
	                    }, callback);
	                    return this;
	                  };
	                  GeoJSONSource2.prototype.getClusterChildren = function getClusterChildren(clusterId, callback) {
	                    this.actor.send("geojson.getClusterChildren", {
	                      clusterId,
	                      source: this.id
	                    }, callback);
	                    return this;
	                  };
	                  GeoJSONSource2.prototype.getClusterLeaves = function getClusterLeaves(clusterId, limit, offset, callback) {
	                    this.actor.send("geojson.getClusterLeaves", {
	                      source: this.id,
	                      clusterId,
	                      limit,
	                      offset
	                    }, callback);
	                    return this;
	                  };
	                  GeoJSONSource2.prototype._updateWorkerData = function _updateWorkerData(callback) {
	                    var this$1$1 = this;
	                    this._loaded = false;
	                    var options = performance2.extend({}, this.workerOptions);
	                    var data = this._data;
	                    if (typeof data === "string") {
	                      options.request = this.map._requestManager.transformRequest(performance2.browser.resolveURL(data), performance2.ResourceType.Source);
	                      options.request.collectResourceTiming = this._collectResourceTiming;
	                    } else {
	                      options.data = JSON.stringify(data);
	                    }
	                    this.actor.send(this.type + ".loadData", options, function(err, result) {
	                      if (this$1$1._removed || result && result.abandoned) {
	                        return;
	                      }
	                      this$1$1._loaded = true;
	                      if (result && result.resourceTiming && result.resourceTiming[this$1$1.id]) {
	                        this$1$1._resourceTiming = result.resourceTiming[this$1$1.id].slice(0);
	                      }
	                      this$1$1.actor.send(this$1$1.type + ".coalesce", { source: options.source }, null);
	                      callback(err);
	                    });
	                  };
	                  GeoJSONSource2.prototype.loaded = function loaded() {
	                    return this._loaded;
	                  };
	                  GeoJSONSource2.prototype.loadTile = function loadTile(tile, callback) {
	                    var this$1$1 = this;
	                    var message = !tile.actor ? "loadTile" : "reloadTile";
	                    tile.actor = this.actor;
	                    var params = {
	                      type: this.type,
	                      uid: tile.uid,
	                      tileID: tile.tileID,
	                      zoom: tile.tileID.overscaledZ,
	                      maxZoom: this.maxzoom,
	                      tileSize: this.tileSize,
	                      source: this.id,
	                      pixelRatio: performance2.browser.devicePixelRatio,
	                      showCollisionBoxes: this.map.showCollisionBoxes,
	                      promoteId: this.promoteId
	                    };
	                    tile.request = this.actor.send(message, params, function(err, data) {
	                      delete tile.request;
	                      tile.unloadVectorData();
	                      if (tile.aborted) {
	                        return callback(null);
	                      }
	                      if (err) {
	                        return callback(err);
	                      }
	                      tile.loadVectorData(data, this$1$1.map.painter, message === "reloadTile");
	                      return callback(null);
	                    });
	                  };
	                  GeoJSONSource2.prototype.abortTile = function abortTile(tile) {
	                    if (tile.request) {
	                      tile.request.cancel();
	                      delete tile.request;
	                    }
	                    tile.aborted = true;
	                  };
	                  GeoJSONSource2.prototype.unloadTile = function unloadTile(tile) {
	                    tile.unloadVectorData();
	                    this.actor.send("removeTile", {
	                      uid: tile.uid,
	                      type: this.type,
	                      source: this.id
	                    });
	                  };
	                  GeoJSONSource2.prototype.onRemove = function onRemove() {
	                    this._removed = true;
	                    this.actor.send("removeSource", {
	                      type: this.type,
	                      source: this.id
	                    });
	                  };
	                  GeoJSONSource2.prototype.serialize = function serialize() {
	                    return performance2.extend({}, this._options, {
	                      type: this.type,
	                      data: this._data
	                    });
	                  };
	                  GeoJSONSource2.prototype.hasTransition = function hasTransition() {
	                    return false;
	                  };
	                  return GeoJSONSource2;
	                }(performance2.Evented);
	                var rasterBoundsAttributes = performance2.createLayout([
	                  {
	                    name: "a_pos",
	                    type: "Int16",
	                    components: 2
	                  },
	                  {
	                    name: "a_texture_pos",
	                    type: "Int16",
	                    components: 2
	                  }
	                ]);
	                var ImageSource = function(Evented) {
	                  function ImageSource2(id, options, dispatcher, eventedParent) {
	                    Evented.call(this);
	                    this.id = id;
	                    this.dispatcher = dispatcher;
	                    this.coordinates = options.coordinates;
	                    this.type = "image";
	                    this.minzoom = 0;
	                    this.maxzoom = 22;
	                    this.tileSize = 512;
	                    this.tiles = {};
	                    this._loaded = false;
	                    this.setEventedParent(eventedParent);
	                    this.options = options;
	                  }
	                  if (Evented)
	                    ImageSource2.__proto__ = Evented;
	                  ImageSource2.prototype = Object.create(Evented && Evented.prototype);
	                  ImageSource2.prototype.constructor = ImageSource2;
	                  ImageSource2.prototype.load = function load(newCoordinates, successCallback) {
	                    var this$1$1 = this;
	                    this._loaded = false;
	                    this.fire(new performance2.Event("dataloading", { dataType: "source" }));
	                    this.url = this.options.url;
	                    performance2.getImage(this.map._requestManager.transformRequest(this.url, performance2.ResourceType.Image), function(err, image) {
	                      this$1$1._loaded = true;
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                      } else if (image) {
	                        this$1$1.image = image;
	                        if (newCoordinates) {
	                          this$1$1.coordinates = newCoordinates;
	                        }
	                        if (successCallback) {
	                          successCallback();
	                        }
	                        this$1$1._finishLoading();
	                      }
	                    });
	                  };
	                  ImageSource2.prototype.loaded = function loaded() {
	                    return this._loaded;
	                  };
	                  ImageSource2.prototype.updateImage = function updateImage(options) {
	                    var this$1$1 = this;
	                    if (!this.image || !options.url) {
	                      return this;
	                    }
	                    this.options.url = options.url;
	                    this.load(options.coordinates, function() {
	                      this$1$1.texture = null;
	                    });
	                    return this;
	                  };
	                  ImageSource2.prototype._finishLoading = function _finishLoading() {
	                    if (this.map) {
	                      this.setCoordinates(this.coordinates);
	                      this.fire(new performance2.Event("data", {
	                        dataType: "source",
	                        sourceDataType: "metadata"
	                      }));
	                    }
	                  };
	                  ImageSource2.prototype.onAdd = function onAdd(map2) {
	                    this.map = map2;
	                    this.load();
	                  };
	                  ImageSource2.prototype.setCoordinates = function setCoordinates(coordinates) {
	                    var this$1$1 = this;
	                    this.coordinates = coordinates;
	                    var cornerCoords = coordinates.map(performance2.MercatorCoordinate.fromLngLat);
	                    this.tileID = getCoordinatesCenterTileID(cornerCoords);
	                    this.minzoom = this.maxzoom = this.tileID.z;
	                    var tileCoords = cornerCoords.map(function(coord) {
	                      return this$1$1.tileID.getTilePoint(coord)._round();
	                    });
	                    this._boundsArray = new performance2.StructArrayLayout4i8();
	                    this._boundsArray.emplaceBack(tileCoords[0].x, tileCoords[0].y, 0, 0);
	                    this._boundsArray.emplaceBack(tileCoords[1].x, tileCoords[1].y, performance2.EXTENT, 0);
	                    this._boundsArray.emplaceBack(tileCoords[3].x, tileCoords[3].y, 0, performance2.EXTENT);
	                    this._boundsArray.emplaceBack(tileCoords[2].x, tileCoords[2].y, performance2.EXTENT, performance2.EXTENT);
	                    if (this.boundsBuffer) {
	                      this.boundsBuffer.destroy();
	                      delete this.boundsBuffer;
	                    }
	                    this.fire(new performance2.Event("data", {
	                      dataType: "source",
	                      sourceDataType: "content"
	                    }));
	                    return this;
	                  };
	                  ImageSource2.prototype.prepare = function prepare() {
	                    if (Object.keys(this.tiles).length === 0 || !this.image) {
	                      return;
	                    }
	                    var context = this.map.painter.context;
	                    var gl2 = context.gl;
	                    if (!this.boundsBuffer) {
	                      this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
	                    }
	                    if (!this.boundsSegments) {
	                      this.boundsSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 2);
	                    }
	                    if (!this.texture) {
	                      this.texture = new performance2.Texture(context, this.image, gl2.RGBA);
	                      this.texture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                    }
	                    for (var w in this.tiles) {
	                      var tile = this.tiles[w];
	                      if (tile.state !== "loaded") {
	                        tile.state = "loaded";
	                        tile.texture = this.texture;
	                      }
	                    }
	                  };
	                  ImageSource2.prototype.loadTile = function loadTile(tile, callback) {
	                    if (this.tileID && this.tileID.equals(tile.tileID.canonical)) {
	                      this.tiles[String(tile.tileID.wrap)] = tile;
	                      tile.buckets = {};
	                      callback(null);
	                    } else {
	                      tile.state = "errored";
	                      callback(null);
	                    }
	                  };
	                  ImageSource2.prototype.serialize = function serialize() {
	                    return {
	                      type: "image",
	                      url: this.options.url,
	                      coordinates: this.coordinates
	                    };
	                  };
	                  ImageSource2.prototype.hasTransition = function hasTransition() {
	                    return false;
	                  };
	                  return ImageSource2;
	                }(performance2.Evented);
	                function getCoordinatesCenterTileID(coords) {
	                  var minX = Infinity;
	                  var minY = Infinity;
	                  var maxX = -Infinity;
	                  var maxY = -Infinity;
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    minX = Math.min(minX, coord.x);
	                    minY = Math.min(minY, coord.y);
	                    maxX = Math.max(maxX, coord.x);
	                    maxY = Math.max(maxY, coord.y);
	                  }
	                  var dx = maxX - minX;
	                  var dy = maxY - minY;
	                  var dMax = Math.max(dx, dy);
	                  var zoom = Math.max(0, Math.floor(-Math.log(dMax) / Math.LN2));
	                  var tilesAtZoom = Math.pow(2, zoom);
	                  return new performance2.CanonicalTileID(zoom, Math.floor((minX + maxX) / 2 * tilesAtZoom), Math.floor((minY + maxY) / 2 * tilesAtZoom));
	                }
	                var VideoSource = function(ImageSource2) {
	                  function VideoSource2(id, options, dispatcher, eventedParent) {
	                    ImageSource2.call(this, id, options, dispatcher, eventedParent);
	                    this.roundZoom = true;
	                    this.type = "video";
	                    this.options = options;
	                  }
	                  VideoSource2.__proto__ = ImageSource2;
	                  VideoSource2.prototype = Object.create(ImageSource2.prototype);
	                  VideoSource2.prototype.constructor = VideoSource2;
	                  VideoSource2.prototype.load = function load() {
	                    var this$1$1 = this;
	                    this._loaded = false;
	                    var options = this.options;
	                    this.urls = [];
	                    for (var i = 0, list = options.urls; i < list.length; i += 1) {
	                      var url = list[i];
	                      this.urls.push(this.map._requestManager.transformRequest(url, performance2.ResourceType.Source).url);
	                    }
	                    performance2.getVideo(this.urls, function(err, video) {
	                      this$1$1._loaded = true;
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                      } else if (video) {
	                        this$1$1.video = video;
	                        this$1$1.video.loop = true;
	                        this$1$1.video.addEventListener("playing", function() {
	                          this$1$1.map.triggerRepaint();
	                        });
	                        if (this$1$1.map) {
	                          this$1$1.video.play();
	                        }
	                        this$1$1._finishLoading();
	                      }
	                    });
	                  };
	                  VideoSource2.prototype.pause = function pause() {
	                    if (this.video) {
	                      this.video.pause();
	                    }
	                  };
	                  VideoSource2.prototype.play = function play() {
	                    if (this.video) {
	                      this.video.play();
	                    }
	                  };
	                  VideoSource2.prototype.seek = function seek(seconds) {
	                    if (this.video) {
	                      var seekableRange = this.video.seekable;
	                      if (seconds < seekableRange.start(0) || seconds > seekableRange.end(0)) {
	                        this.fire(new performance2.ErrorEvent(new performance2.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + seekableRange.start(0) + " and " + seekableRange.end(0) + "-second mark.")));
	                      } else {
	                        this.video.currentTime = seconds;
	                      }
	                    }
	                  };
	                  VideoSource2.prototype.getVideo = function getVideo() {
	                    return this.video;
	                  };
	                  VideoSource2.prototype.onAdd = function onAdd(map2) {
	                    if (this.map) {
	                      return;
	                    }
	                    this.map = map2;
	                    this.load();
	                    if (this.video) {
	                      this.video.play();
	                      this.setCoordinates(this.coordinates);
	                    }
	                  };
	                  VideoSource2.prototype.prepare = function prepare() {
	                    if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) {
	                      return;
	                    }
	                    var context = this.map.painter.context;
	                    var gl2 = context.gl;
	                    if (!this.boundsBuffer) {
	                      this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
	                    }
	                    if (!this.boundsSegments) {
	                      this.boundsSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 2);
	                    }
	                    if (!this.texture) {
	                      this.texture = new performance2.Texture(context, this.video, gl2.RGBA);
	                      this.texture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                    } else if (!this.video.paused) {
	                      this.texture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                      gl2.texSubImage2D(gl2.TEXTURE_2D, 0, 0, 0, gl2.RGBA, gl2.UNSIGNED_BYTE, this.video);
	                    }
	                    for (var w in this.tiles) {
	                      var tile = this.tiles[w];
	                      if (tile.state !== "loaded") {
	                        tile.state = "loaded";
	                        tile.texture = this.texture;
	                      }
	                    }
	                  };
	                  VideoSource2.prototype.serialize = function serialize() {
	                    return {
	                      type: "video",
	                      urls: this.urls,
	                      coordinates: this.coordinates
	                    };
	                  };
	                  VideoSource2.prototype.hasTransition = function hasTransition() {
	                    return this.video && !this.video.paused;
	                  };
	                  return VideoSource2;
	                }(ImageSource);
	                var CanvasSource = function(ImageSource2) {
	                  function CanvasSource2(id, options, dispatcher, eventedParent) {
	                    ImageSource2.call(this, id, options, dispatcher, eventedParent);
	                    if (!options.coordinates) {
	                      this.fire(new performance2.ErrorEvent(new performance2.ValidationError("sources." + id, null, 'missing required property "coordinates"')));
	                    } else if (!Array.isArray(options.coordinates) || options.coordinates.length !== 4 || options.coordinates.some(function(c) {
	                      return !Array.isArray(c) || c.length !== 2 || c.some(function(l) {
	                        return typeof l !== "number";
	                      });
	                    })) {
	                      this.fire(new performance2.ErrorEvent(new performance2.ValidationError("sources." + id, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs')));
	                    }
	                    if (options.animate && typeof options.animate !== "boolean") {
	                      this.fire(new performance2.ErrorEvent(new performance2.ValidationError("sources." + id, null, 'optional "animate" property must be a boolean value')));
	                    }
	                    if (!options.canvas) {
	                      this.fire(new performance2.ErrorEvent(new performance2.ValidationError("sources." + id, null, 'missing required property "canvas"')));
	                    } else if (typeof options.canvas !== "string" && !(options.canvas instanceof performance2.window.HTMLCanvasElement)) {
	                      this.fire(new performance2.ErrorEvent(new performance2.ValidationError("sources." + id, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance')));
	                    }
	                    this.options = options;
	                    this.animate = options.animate !== undefined ? options.animate : true;
	                  }
	                  CanvasSource2.__proto__ = ImageSource2;
	                  CanvasSource2.prototype = Object.create(ImageSource2.prototype);
	                  CanvasSource2.prototype.constructor = CanvasSource2;
	                  CanvasSource2.prototype.load = function load() {
	                    this._loaded = true;
	                    if (!this.canvas) {
	                      this.canvas = this.options.canvas instanceof performance2.window.HTMLCanvasElement ? this.options.canvas : performance2.window.document.getElementById(this.options.canvas);
	                    }
	                    this.width = this.canvas.width;
	                    this.height = this.canvas.height;
	                    if (this._hasInvalidDimensions()) {
	                      this.fire(new performance2.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero.")));
	                      return;
	                    }
	                    this.play = function() {
	                      this._playing = true;
	                      this.map.triggerRepaint();
	                    };
	                    this.pause = function() {
	                      if (this._playing) {
	                        this.prepare();
	                        this._playing = false;
	                      }
	                    };
	                    this._finishLoading();
	                  };
	                  CanvasSource2.prototype.getCanvas = function getCanvas() {
	                    return this.canvas;
	                  };
	                  CanvasSource2.prototype.onAdd = function onAdd(map2) {
	                    this.map = map2;
	                    this.load();
	                    if (this.canvas) {
	                      if (this.animate) {
	                        this.play();
	                      }
	                    }
	                  };
	                  CanvasSource2.prototype.onRemove = function onRemove() {
	                    this.pause();
	                  };
	                  CanvasSource2.prototype.prepare = function prepare() {
	                    var resize = false;
	                    if (this.canvas.width !== this.width) {
	                      this.width = this.canvas.width;
	                      resize = true;
	                    }
	                    if (this.canvas.height !== this.height) {
	                      this.height = this.canvas.height;
	                      resize = true;
	                    }
	                    if (this._hasInvalidDimensions()) {
	                      return;
	                    }
	                    if (Object.keys(this.tiles).length === 0) {
	                      return;
	                    }
	                    var context = this.map.painter.context;
	                    var gl2 = context.gl;
	                    if (!this.boundsBuffer) {
	                      this.boundsBuffer = context.createVertexBuffer(this._boundsArray, rasterBoundsAttributes.members);
	                    }
	                    if (!this.boundsSegments) {
	                      this.boundsSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 2);
	                    }
	                    if (!this.texture) {
	                      this.texture = new performance2.Texture(context, this.canvas, gl2.RGBA, { premultiply: true });
	                    } else if (resize || this._playing) {
	                      this.texture.update(this.canvas, { premultiply: true });
	                    }
	                    for (var w in this.tiles) {
	                      var tile = this.tiles[w];
	                      if (tile.state !== "loaded") {
	                        tile.state = "loaded";
	                        tile.texture = this.texture;
	                      }
	                    }
	                  };
	                  CanvasSource2.prototype.serialize = function serialize() {
	                    return {
	                      type: "canvas",
	                      coordinates: this.coordinates
	                    };
	                  };
	                  CanvasSource2.prototype.hasTransition = function hasTransition() {
	                    return this._playing;
	                  };
	                  CanvasSource2.prototype._hasInvalidDimensions = function _hasInvalidDimensions() {
	                    for (var i = 0, list = [
	                      this.canvas.width,
	                      this.canvas.height
	                    ]; i < list.length; i += 1) {
	                      var x = list[i];
	                      if (isNaN(x) || x <= 0) {
	                        return true;
	                      }
	                    }
	                    return false;
	                  };
	                  return CanvasSource2;
	                }(ImageSource);
	                var sourceTypes = {
	                  vector: VectorTileSource,
	                  raster: RasterTileSource,
	                  "raster-dem": RasterDEMTileSource,
	                  geojson: GeoJSONSource,
	                  video: VideoSource,
	                  image: ImageSource,
	                  canvas: CanvasSource
	                };
	                var create = function(id, specification, dispatcher, eventedParent) {
	                  var source = new sourceTypes[specification.type](id, specification, dispatcher, eventedParent);
	                  if (source.id !== id) {
	                    throw new Error("Expected Source id to be " + id + " instead of " + source.id);
	                  }
	                  performance2.bindAll([
	                    "load",
	                    "abort",
	                    "unload",
	                    "serialize",
	                    "prepare"
	                  ], source);
	                  return source;
	                };
	                var getType = function(name2) {
	                  return sourceTypes[name2];
	                };
	                var setType = function(name2, type) {
	                  sourceTypes[name2] = type;
	                };
	                function getPixelPosMatrix(transform, tileID) {
	                  var t = performance2.identity([]);
	                  performance2.translate(t, t, [
	                    1,
	                    1,
	                    0
	                  ]);
	                  performance2.scale(t, t, [
	                    transform.width * 0.5,
	                    transform.height * 0.5,
	                    1
	                  ]);
	                  return performance2.multiply(t, t, transform.calculatePosMatrix(tileID.toUnwrapped()));
	                }
	                function queryIncludes3DLayer(layers, styleLayers, sourceID) {
	                  if (layers) {
	                    for (var i = 0, list = layers; i < list.length; i += 1) {
	                      var layerID = list[i];
	                      var layer = styleLayers[layerID];
	                      if (layer && layer.source === sourceID && layer.type === "fill-extrusion") {
	                        return true;
	                      }
	                    }
	                  } else {
	                    for (var key in styleLayers) {
	                      var layer$1 = styleLayers[key];
	                      if (layer$1.source === sourceID && layer$1.type === "fill-extrusion") {
	                        return true;
	                      }
	                    }
	                  }
	                  return false;
	                }
	                function queryRenderedFeatures(sourceCache, styleLayers, serializedLayers, queryGeometry, params, transform) {
	                  var has3DLayer = queryIncludes3DLayer(params && params.layers, styleLayers, sourceCache.id);
	                  var maxPitchScaleFactor = transform.maxPitchScaleFactor();
	                  var tilesIn = sourceCache.tilesIn(queryGeometry, maxPitchScaleFactor, has3DLayer);
	                  tilesIn.sort(sortTilesIn);
	                  var renderedFeatureLayers = [];
	                  for (var i = 0, list = tilesIn; i < list.length; i += 1) {
	                    var tileIn = list[i];
	                    renderedFeatureLayers.push({
	                      wrappedTileID: tileIn.tileID.wrapped().key,
	                      queryResults: tileIn.tile.queryRenderedFeatures(styleLayers, serializedLayers, sourceCache._state, tileIn.queryGeometry, tileIn.cameraQueryGeometry, tileIn.scale, params, transform, maxPitchScaleFactor, getPixelPosMatrix(sourceCache.transform, tileIn.tileID))
	                    });
	                  }
	                  var result = mergeRenderedFeatureLayers(renderedFeatureLayers);
	                  for (var layerID in result) {
	                    result[layerID].forEach(function(featureWrapper) {
	                      var feature = featureWrapper.feature;
	                      var state = sourceCache.getFeatureState(feature.layer["source-layer"], feature.id);
	                      feature.source = feature.layer.source;
	                      if (feature.layer["source-layer"]) {
	                        feature.sourceLayer = feature.layer["source-layer"];
	                      }
	                      feature.state = state;
	                    });
	                  }
	                  return result;
	                }
	                function queryRenderedSymbols(styleLayers, serializedLayers, sourceCaches, queryGeometry, params, collisionIndex, retainedQueryData) {
	                  var result = {};
	                  var renderedSymbols = collisionIndex.queryRenderedSymbols(queryGeometry);
	                  var bucketQueryData = [];
	                  for (var i = 0, list = Object.keys(renderedSymbols).map(Number); i < list.length; i += 1) {
	                    var bucketInstanceId = list[i];
	                    bucketQueryData.push(retainedQueryData[bucketInstanceId]);
	                  }
	                  bucketQueryData.sort(sortTilesIn);
	                  var loop = function() {
	                    var queryData = list$2[i$2];
	                    var bucketSymbols = queryData.featureIndex.lookupSymbolFeatures(renderedSymbols[queryData.bucketInstanceId], serializedLayers, queryData.bucketIndex, queryData.sourceLayerIndex, params.filter, params.layers, params.availableImages, styleLayers);
	                    for (var layerID in bucketSymbols) {
	                      var resultFeatures = result[layerID] = result[layerID] || [];
	                      var layerSymbols = bucketSymbols[layerID];
	                      layerSymbols.sort(function(a, b) {
	                        var featureSortOrder = queryData.featureSortOrder;
	                        if (featureSortOrder) {
	                          var sortedA = featureSortOrder.indexOf(a.featureIndex);
	                          var sortedB = featureSortOrder.indexOf(b.featureIndex);
	                          return sortedB - sortedA;
	                        } else {
	                          return b.featureIndex - a.featureIndex;
	                        }
	                      });
	                      for (var i$1 = 0, list$1 = layerSymbols; i$1 < list$1.length; i$1 += 1) {
	                        var symbolFeature = list$1[i$1];
	                        resultFeatures.push(symbolFeature);
	                      }
	                    }
	                  };
	                  for (var i$2 = 0, list$2 = bucketQueryData; i$2 < list$2.length; i$2 += 1)
	                    loop();
	                  var loop$1 = function(layerName2) {
	                    result[layerName2].forEach(function(featureWrapper) {
	                      var feature = featureWrapper.feature;
	                      var layer = styleLayers[layerName2];
	                      var sourceCache = sourceCaches[layer.source];
	                      var state = sourceCache.getFeatureState(feature.layer["source-layer"], feature.id);
	                      feature.source = feature.layer.source;
	                      if (feature.layer["source-layer"]) {
	                        feature.sourceLayer = feature.layer["source-layer"];
	                      }
	                      feature.state = state;
	                    });
	                  };
	                  for (var layerName in result)
	                    loop$1(layerName);
	                  return result;
	                }
	                function querySourceFeatures(sourceCache, params) {
	                  var tiles = sourceCache.getRenderableIds().map(function(id) {
	                    return sourceCache.getTileByID(id);
	                  });
	                  var result = [];
	                  var dataTiles = {};
	                  for (var i = 0; i < tiles.length; i++) {
	                    var tile = tiles[i];
	                    var dataID = tile.tileID.canonical.key;
	                    if (!dataTiles[dataID]) {
	                      dataTiles[dataID] = true;
	                      tile.querySourceFeatures(result, params);
	                    }
	                  }
	                  return result;
	                }
	                function sortTilesIn(a, b) {
	                  var idA = a.tileID;
	                  var idB = b.tileID;
	                  return idA.overscaledZ - idB.overscaledZ || idA.canonical.y - idB.canonical.y || idA.wrap - idB.wrap || idA.canonical.x - idB.canonical.x;
	                }
	                function mergeRenderedFeatureLayers(tiles) {
	                  var result = {};
	                  var wrappedIDLayerMap = {};
	                  for (var i$1 = 0, list$1 = tiles; i$1 < list$1.length; i$1 += 1) {
	                    var tile = list$1[i$1];
	                    var queryResults = tile.queryResults;
	                    var wrappedID = tile.wrappedTileID;
	                    var wrappedIDLayers = wrappedIDLayerMap[wrappedID] = wrappedIDLayerMap[wrappedID] || {};
	                    for (var layerID in queryResults) {
	                      var tileFeatures = queryResults[layerID];
	                      var wrappedIDFeatures = wrappedIDLayers[layerID] = wrappedIDLayers[layerID] || {};
	                      var resultFeatures = result[layerID] = result[layerID] || [];
	                      for (var i = 0, list = tileFeatures; i < list.length; i += 1) {
	                        var tileFeature = list[i];
	                        if (!wrappedIDFeatures[tileFeature.featureIndex]) {
	                          wrappedIDFeatures[tileFeature.featureIndex] = true;
	                          resultFeatures.push(tileFeature);
	                        }
	                      }
	                    }
	                  }
	                  return result;
	                }
	                var TileCache = function TileCache2(max, onRemove) {
	                  this.max = max;
	                  this.onRemove = onRemove;
	                  this.reset();
	                };
	                TileCache.prototype.reset = function reset() {
	                  for (var key in this.data) {
	                    for (var i = 0, list = this.data[key]; i < list.length; i += 1) {
	                      var removedData = list[i];
	                      if (removedData.timeout) {
	                        clearTimeout(removedData.timeout);
	                      }
	                      this.onRemove(removedData.value);
	                    }
	                  }
	                  this.data = {};
	                  this.order = [];
	                  return this;
	                };
	                TileCache.prototype.add = function add(tileID, data, expiryTimeout) {
	                  var this$1$1 = this;
	                  var key = tileID.wrapped().key;
	                  if (this.data[key] === undefined) {
	                    this.data[key] = [];
	                  }
	                  var dataWrapper = {
	                    value: data,
	                    timeout: undefined
	                  };
	                  if (expiryTimeout !== undefined) {
	                    dataWrapper.timeout = setTimeout(function() {
	                      this$1$1.remove(tileID, dataWrapper);
	                    }, expiryTimeout);
	                  }
	                  this.data[key].push(dataWrapper);
	                  this.order.push(key);
	                  if (this.order.length > this.max) {
	                    var removedData = this._getAndRemoveByKey(this.order[0]);
	                    if (removedData) {
	                      this.onRemove(removedData);
	                    }
	                  }
	                  return this;
	                };
	                TileCache.prototype.has = function has(tileID) {
	                  return tileID.wrapped().key in this.data;
	                };
	                TileCache.prototype.getAndRemove = function getAndRemove(tileID) {
	                  if (!this.has(tileID)) {
	                    return null;
	                  }
	                  return this._getAndRemoveByKey(tileID.wrapped().key);
	                };
	                TileCache.prototype._getAndRemoveByKey = function _getAndRemoveByKey(key) {
	                  var data = this.data[key].shift();
	                  if (data.timeout) {
	                    clearTimeout(data.timeout);
	                  }
	                  if (this.data[key].length === 0) {
	                    delete this.data[key];
	                  }
	                  this.order.splice(this.order.indexOf(key), 1);
	                  return data.value;
	                };
	                TileCache.prototype.getByKey = function getByKey(key) {
	                  var data = this.data[key];
	                  return data ? data[0].value : null;
	                };
	                TileCache.prototype.get = function get(tileID) {
	                  if (!this.has(tileID)) {
	                    return null;
	                  }
	                  var data = this.data[tileID.wrapped().key][0];
	                  return data.value;
	                };
	                TileCache.prototype.remove = function remove(tileID, value) {
	                  if (!this.has(tileID)) {
	                    return this;
	                  }
	                  var key = tileID.wrapped().key;
	                  var dataIndex = value === undefined ? 0 : this.data[key].indexOf(value);
	                  var data = this.data[key][dataIndex];
	                  this.data[key].splice(dataIndex, 1);
	                  if (data.timeout) {
	                    clearTimeout(data.timeout);
	                  }
	                  if (this.data[key].length === 0) {
	                    delete this.data[key];
	                  }
	                  this.onRemove(data.value);
	                  this.order.splice(this.order.indexOf(key), 1);
	                  return this;
	                };
	                TileCache.prototype.setMaxSize = function setMaxSize(max) {
	                  this.max = max;
	                  while (this.order.length > this.max) {
	                    var removedData = this._getAndRemoveByKey(this.order[0]);
	                    if (removedData) {
	                      this.onRemove(removedData);
	                    }
	                  }
	                  return this;
	                };
	                TileCache.prototype.filter = function filter(filterFn) {
	                  var removed = [];
	                  for (var key in this.data) {
	                    for (var i = 0, list = this.data[key]; i < list.length; i += 1) {
	                      var entry = list[i];
	                      if (!filterFn(entry.value)) {
	                        removed.push(entry);
	                      }
	                    }
	                  }
	                  for (var i$1 = 0, list$1 = removed; i$1 < list$1.length; i$1 += 1) {
	                    var r = list$1[i$1];
	                    this.remove(r.value.tileID, r);
	                  }
	                };
	                var IndexBuffer = function IndexBuffer2(context, array, dynamicDraw) {
	                  this.context = context;
	                  var gl2 = context.gl;
	                  this.buffer = gl2.createBuffer();
	                  this.dynamicDraw = Boolean(dynamicDraw);
	                  this.context.unbindVAO();
	                  context.bindElementBuffer.set(this.buffer);
	                  gl2.bufferData(gl2.ELEMENT_ARRAY_BUFFER, array.arrayBuffer, this.dynamicDraw ? gl2.DYNAMIC_DRAW : gl2.STATIC_DRAW);
	                  if (!this.dynamicDraw) {
	                    delete array.arrayBuffer;
	                  }
	                };
	                IndexBuffer.prototype.bind = function bind() {
	                  this.context.bindElementBuffer.set(this.buffer);
	                };
	                IndexBuffer.prototype.updateData = function updateData(array) {
	                  var gl2 = this.context.gl;
	                  this.context.unbindVAO();
	                  this.bind();
	                  gl2.bufferSubData(gl2.ELEMENT_ARRAY_BUFFER, 0, array.arrayBuffer);
	                };
	                IndexBuffer.prototype.destroy = function destroy() {
	                  var gl2 = this.context.gl;
	                  if (this.buffer) {
	                    gl2.deleteBuffer(this.buffer);
	                    delete this.buffer;
	                  }
	                };
	                var AttributeType = {
	                  Int8: "BYTE",
	                  Uint8: "UNSIGNED_BYTE",
	                  Int16: "SHORT",
	                  Uint16: "UNSIGNED_SHORT",
	                  Int32: "INT",
	                  Uint32: "UNSIGNED_INT",
	                  Float32: "FLOAT"
	                };
	                var VertexBuffer = function VertexBuffer2(context, array, attributes, dynamicDraw) {
	                  this.length = array.length;
	                  this.attributes = attributes;
	                  this.itemSize = array.bytesPerElement;
	                  this.dynamicDraw = dynamicDraw;
	                  this.context = context;
	                  var gl2 = context.gl;
	                  this.buffer = gl2.createBuffer();
	                  context.bindVertexBuffer.set(this.buffer);
	                  gl2.bufferData(gl2.ARRAY_BUFFER, array.arrayBuffer, this.dynamicDraw ? gl2.DYNAMIC_DRAW : gl2.STATIC_DRAW);
	                  if (!this.dynamicDraw) {
	                    delete array.arrayBuffer;
	                  }
	                };
	                VertexBuffer.prototype.bind = function bind() {
	                  this.context.bindVertexBuffer.set(this.buffer);
	                };
	                VertexBuffer.prototype.updateData = function updateData(array) {
	                  var gl2 = this.context.gl;
	                  this.bind();
	                  gl2.bufferSubData(gl2.ARRAY_BUFFER, 0, array.arrayBuffer);
	                };
	                VertexBuffer.prototype.enableAttributes = function enableAttributes(gl2, program) {
	                  for (var j = 0; j < this.attributes.length; j++) {
	                    var member = this.attributes[j];
	                    var attribIndex = program.attributes[member.name];
	                    if (attribIndex !== undefined) {
	                      gl2.enableVertexAttribArray(attribIndex);
	                    }
	                  }
	                };
	                VertexBuffer.prototype.setVertexAttribPointers = function setVertexAttribPointers(gl2, program, vertexOffset) {
	                  for (var j = 0; j < this.attributes.length; j++) {
	                    var member = this.attributes[j];
	                    var attribIndex = program.attributes[member.name];
	                    if (attribIndex !== undefined) {
	                      gl2.vertexAttribPointer(attribIndex, member.components, gl2[AttributeType[member.type]], false, this.itemSize, member.offset + this.itemSize * (vertexOffset || 0));
	                    }
	                  }
	                };
	                VertexBuffer.prototype.destroy = function destroy() {
	                  var gl2 = this.context.gl;
	                  if (this.buffer) {
	                    gl2.deleteBuffer(this.buffer);
	                    delete this.buffer;
	                  }
	                };
	                var BaseValue = function BaseValue2(context) {
	                  this.gl = context.gl;
	                  this.default = this.getDefault();
	                  this.current = this.default;
	                  this.dirty = false;
	                };
	                BaseValue.prototype.get = function get() {
	                  return this.current;
	                };
	                BaseValue.prototype.set = function set(value) {
	                };
	                BaseValue.prototype.getDefault = function getDefault() {
	                  return this.default;
	                };
	                BaseValue.prototype.setDefault = function setDefault() {
	                  this.set(this.default);
	                };
	                var ClearColor = function(BaseValue2) {
	                  function ClearColor2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  ClearColor2.__proto__ = BaseValue2;
	                  ClearColor2.prototype = Object.create(BaseValue2.prototype);
	                  ClearColor2.prototype.constructor = ClearColor2;
	                  ClearColor2.prototype.getDefault = function getDefault() {
	                    return performance2.Color.transparent;
	                  };
	                  ClearColor2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v.r === c.r && v.g === c.g && v.b === c.b && v.a === c.a && !this.dirty) {
	                      return;
	                    }
	                    this.gl.clearColor(v.r, v.g, v.b, v.a);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return ClearColor2;
	                }(BaseValue);
	                var ClearDepth = function(BaseValue2) {
	                  function ClearDepth2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  ClearDepth2.__proto__ = BaseValue2;
	                  ClearDepth2.prototype = Object.create(BaseValue2.prototype);
	                  ClearDepth2.prototype.constructor = ClearDepth2;
	                  ClearDepth2.prototype.getDefault = function getDefault() {
	                    return 1;
	                  };
	                  ClearDepth2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.clearDepth(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return ClearDepth2;
	                }(BaseValue);
	                var ClearStencil = function(BaseValue2) {
	                  function ClearStencil2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  ClearStencil2.__proto__ = BaseValue2;
	                  ClearStencil2.prototype = Object.create(BaseValue2.prototype);
	                  ClearStencil2.prototype.constructor = ClearStencil2;
	                  ClearStencil2.prototype.getDefault = function getDefault() {
	                    return 0;
	                  };
	                  ClearStencil2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.clearStencil(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return ClearStencil2;
	                }(BaseValue);
	                var ColorMask = function(BaseValue2) {
	                  function ColorMask2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  ColorMask2.__proto__ = BaseValue2;
	                  ColorMask2.prototype = Object.create(BaseValue2.prototype);
	                  ColorMask2.prototype.constructor = ColorMask2;
	                  ColorMask2.prototype.getDefault = function getDefault() {
	                    return [
	                      true,
	                      true,
	                      true,
	                      true
	                    ];
	                  };
	                  ColorMask2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && v[3] === c[3] && !this.dirty) {
	                      return;
	                    }
	                    this.gl.colorMask(v[0], v[1], v[2], v[3]);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return ColorMask2;
	                }(BaseValue);
	                var DepthMask = function(BaseValue2) {
	                  function DepthMask2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  DepthMask2.__proto__ = BaseValue2;
	                  DepthMask2.prototype = Object.create(BaseValue2.prototype);
	                  DepthMask2.prototype.constructor = DepthMask2;
	                  DepthMask2.prototype.getDefault = function getDefault() {
	                    return true;
	                  };
	                  DepthMask2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.depthMask(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return DepthMask2;
	                }(BaseValue);
	                var StencilMask = function(BaseValue2) {
	                  function StencilMask2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  StencilMask2.__proto__ = BaseValue2;
	                  StencilMask2.prototype = Object.create(BaseValue2.prototype);
	                  StencilMask2.prototype.constructor = StencilMask2;
	                  StencilMask2.prototype.getDefault = function getDefault() {
	                    return 255;
	                  };
	                  StencilMask2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.stencilMask(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return StencilMask2;
	                }(BaseValue);
	                var StencilFunc = function(BaseValue2) {
	                  function StencilFunc2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  StencilFunc2.__proto__ = BaseValue2;
	                  StencilFunc2.prototype = Object.create(BaseValue2.prototype);
	                  StencilFunc2.prototype.constructor = StencilFunc2;
	                  StencilFunc2.prototype.getDefault = function getDefault() {
	                    return {
	                      func: this.gl.ALWAYS,
	                      ref: 0,
	                      mask: 255
	                    };
	                  };
	                  StencilFunc2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v.func === c.func && v.ref === c.ref && v.mask === c.mask && !this.dirty) {
	                      return;
	                    }
	                    this.gl.stencilFunc(v.func, v.ref, v.mask);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return StencilFunc2;
	                }(BaseValue);
	                var StencilOp = function(BaseValue2) {
	                  function StencilOp2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  StencilOp2.__proto__ = BaseValue2;
	                  StencilOp2.prototype = Object.create(BaseValue2.prototype);
	                  StencilOp2.prototype.constructor = StencilOp2;
	                  StencilOp2.prototype.getDefault = function getDefault() {
	                    var gl2 = this.gl;
	                    return [
	                      gl2.KEEP,
	                      gl2.KEEP,
	                      gl2.KEEP
	                    ];
	                  };
	                  StencilOp2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && !this.dirty) {
	                      return;
	                    }
	                    this.gl.stencilOp(v[0], v[1], v[2]);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return StencilOp2;
	                }(BaseValue);
	                var StencilTest = function(BaseValue2) {
	                  function StencilTest2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  StencilTest2.__proto__ = BaseValue2;
	                  StencilTest2.prototype = Object.create(BaseValue2.prototype);
	                  StencilTest2.prototype.constructor = StencilTest2;
	                  StencilTest2.prototype.getDefault = function getDefault() {
	                    return false;
	                  };
	                  StencilTest2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    if (v) {
	                      gl2.enable(gl2.STENCIL_TEST);
	                    } else {
	                      gl2.disable(gl2.STENCIL_TEST);
	                    }
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return StencilTest2;
	                }(BaseValue);
	                var DepthRange = function(BaseValue2) {
	                  function DepthRange2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  DepthRange2.__proto__ = BaseValue2;
	                  DepthRange2.prototype = Object.create(BaseValue2.prototype);
	                  DepthRange2.prototype.constructor = DepthRange2;
	                  DepthRange2.prototype.getDefault = function getDefault() {
	                    return [
	                      0,
	                      1
	                    ];
	                  };
	                  DepthRange2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v[0] === c[0] && v[1] === c[1] && !this.dirty) {
	                      return;
	                    }
	                    this.gl.depthRange(v[0], v[1]);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return DepthRange2;
	                }(BaseValue);
	                var DepthTest = function(BaseValue2) {
	                  function DepthTest2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  DepthTest2.__proto__ = BaseValue2;
	                  DepthTest2.prototype = Object.create(BaseValue2.prototype);
	                  DepthTest2.prototype.constructor = DepthTest2;
	                  DepthTest2.prototype.getDefault = function getDefault() {
	                    return false;
	                  };
	                  DepthTest2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    if (v) {
	                      gl2.enable(gl2.DEPTH_TEST);
	                    } else {
	                      gl2.disable(gl2.DEPTH_TEST);
	                    }
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return DepthTest2;
	                }(BaseValue);
	                var DepthFunc = function(BaseValue2) {
	                  function DepthFunc2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  DepthFunc2.__proto__ = BaseValue2;
	                  DepthFunc2.prototype = Object.create(BaseValue2.prototype);
	                  DepthFunc2.prototype.constructor = DepthFunc2;
	                  DepthFunc2.prototype.getDefault = function getDefault() {
	                    return this.gl.LESS;
	                  };
	                  DepthFunc2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.depthFunc(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return DepthFunc2;
	                }(BaseValue);
	                var Blend = function(BaseValue2) {
	                  function Blend2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  Blend2.__proto__ = BaseValue2;
	                  Blend2.prototype = Object.create(BaseValue2.prototype);
	                  Blend2.prototype.constructor = Blend2;
	                  Blend2.prototype.getDefault = function getDefault() {
	                    return false;
	                  };
	                  Blend2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    if (v) {
	                      gl2.enable(gl2.BLEND);
	                    } else {
	                      gl2.disable(gl2.BLEND);
	                    }
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return Blend2;
	                }(BaseValue);
	                var BlendFunc = function(BaseValue2) {
	                  function BlendFunc2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BlendFunc2.__proto__ = BaseValue2;
	                  BlendFunc2.prototype = Object.create(BaseValue2.prototype);
	                  BlendFunc2.prototype.constructor = BlendFunc2;
	                  BlendFunc2.prototype.getDefault = function getDefault() {
	                    var gl2 = this.gl;
	                    return [
	                      gl2.ONE,
	                      gl2.ZERO
	                    ];
	                  };
	                  BlendFunc2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v[0] === c[0] && v[1] === c[1] && !this.dirty) {
	                      return;
	                    }
	                    this.gl.blendFunc(v[0], v[1]);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BlendFunc2;
	                }(BaseValue);
	                var BlendColor = function(BaseValue2) {
	                  function BlendColor2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BlendColor2.__proto__ = BaseValue2;
	                  BlendColor2.prototype = Object.create(BaseValue2.prototype);
	                  BlendColor2.prototype.constructor = BlendColor2;
	                  BlendColor2.prototype.getDefault = function getDefault() {
	                    return performance2.Color.transparent;
	                  };
	                  BlendColor2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v.r === c.r && v.g === c.g && v.b === c.b && v.a === c.a && !this.dirty) {
	                      return;
	                    }
	                    this.gl.blendColor(v.r, v.g, v.b, v.a);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BlendColor2;
	                }(BaseValue);
	                var BlendEquation = function(BaseValue2) {
	                  function BlendEquation2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BlendEquation2.__proto__ = BaseValue2;
	                  BlendEquation2.prototype = Object.create(BaseValue2.prototype);
	                  BlendEquation2.prototype.constructor = BlendEquation2;
	                  BlendEquation2.prototype.getDefault = function getDefault() {
	                    return this.gl.FUNC_ADD;
	                  };
	                  BlendEquation2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.blendEquation(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BlendEquation2;
	                }(BaseValue);
	                var CullFace = function(BaseValue2) {
	                  function CullFace2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  CullFace2.__proto__ = BaseValue2;
	                  CullFace2.prototype = Object.create(BaseValue2.prototype);
	                  CullFace2.prototype.constructor = CullFace2;
	                  CullFace2.prototype.getDefault = function getDefault() {
	                    return false;
	                  };
	                  CullFace2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    if (v) {
	                      gl2.enable(gl2.CULL_FACE);
	                    } else {
	                      gl2.disable(gl2.CULL_FACE);
	                    }
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return CullFace2;
	                }(BaseValue);
	                var CullFaceSide = function(BaseValue2) {
	                  function CullFaceSide2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  CullFaceSide2.__proto__ = BaseValue2;
	                  CullFaceSide2.prototype = Object.create(BaseValue2.prototype);
	                  CullFaceSide2.prototype.constructor = CullFaceSide2;
	                  CullFaceSide2.prototype.getDefault = function getDefault() {
	                    return this.gl.BACK;
	                  };
	                  CullFaceSide2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.cullFace(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return CullFaceSide2;
	                }(BaseValue);
	                var FrontFace = function(BaseValue2) {
	                  function FrontFace2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  FrontFace2.__proto__ = BaseValue2;
	                  FrontFace2.prototype = Object.create(BaseValue2.prototype);
	                  FrontFace2.prototype.constructor = FrontFace2;
	                  FrontFace2.prototype.getDefault = function getDefault() {
	                    return this.gl.CCW;
	                  };
	                  FrontFace2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.frontFace(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return FrontFace2;
	                }(BaseValue);
	                var Program = function(BaseValue2) {
	                  function Program2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  Program2.__proto__ = BaseValue2;
	                  Program2.prototype = Object.create(BaseValue2.prototype);
	                  Program2.prototype.constructor = Program2;
	                  Program2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  Program2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.useProgram(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return Program2;
	                }(BaseValue);
	                var ActiveTextureUnit = function(BaseValue2) {
	                  function ActiveTextureUnit2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  ActiveTextureUnit2.__proto__ = BaseValue2;
	                  ActiveTextureUnit2.prototype = Object.create(BaseValue2.prototype);
	                  ActiveTextureUnit2.prototype.constructor = ActiveTextureUnit2;
	                  ActiveTextureUnit2.prototype.getDefault = function getDefault() {
	                    return this.gl.TEXTURE0;
	                  };
	                  ActiveTextureUnit2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.gl.activeTexture(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return ActiveTextureUnit2;
	                }(BaseValue);
	                var Viewport = function(BaseValue2) {
	                  function Viewport2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  Viewport2.__proto__ = BaseValue2;
	                  Viewport2.prototype = Object.create(BaseValue2.prototype);
	                  Viewport2.prototype.constructor = Viewport2;
	                  Viewport2.prototype.getDefault = function getDefault() {
	                    var gl2 = this.gl;
	                    return [
	                      0,
	                      0,
	                      gl2.drawingBufferWidth,
	                      gl2.drawingBufferHeight
	                    ];
	                  };
	                  Viewport2.prototype.set = function set(v) {
	                    var c = this.current;
	                    if (v[0] === c[0] && v[1] === c[1] && v[2] === c[2] && v[3] === c[3] && !this.dirty) {
	                      return;
	                    }
	                    this.gl.viewport(v[0], v[1], v[2], v[3]);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return Viewport2;
	                }(BaseValue);
	                var BindFramebuffer = function(BaseValue2) {
	                  function BindFramebuffer2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BindFramebuffer2.__proto__ = BaseValue2;
	                  BindFramebuffer2.prototype = Object.create(BaseValue2.prototype);
	                  BindFramebuffer2.prototype.constructor = BindFramebuffer2;
	                  BindFramebuffer2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  BindFramebuffer2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.bindFramebuffer(gl2.FRAMEBUFFER, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BindFramebuffer2;
	                }(BaseValue);
	                var BindRenderbuffer = function(BaseValue2) {
	                  function BindRenderbuffer2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BindRenderbuffer2.__proto__ = BaseValue2;
	                  BindRenderbuffer2.prototype = Object.create(BaseValue2.prototype);
	                  BindRenderbuffer2.prototype.constructor = BindRenderbuffer2;
	                  BindRenderbuffer2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  BindRenderbuffer2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.bindRenderbuffer(gl2.RENDERBUFFER, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BindRenderbuffer2;
	                }(BaseValue);
	                var BindTexture = function(BaseValue2) {
	                  function BindTexture2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BindTexture2.__proto__ = BaseValue2;
	                  BindTexture2.prototype = Object.create(BaseValue2.prototype);
	                  BindTexture2.prototype.constructor = BindTexture2;
	                  BindTexture2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  BindTexture2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.bindTexture(gl2.TEXTURE_2D, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BindTexture2;
	                }(BaseValue);
	                var BindVertexBuffer = function(BaseValue2) {
	                  function BindVertexBuffer2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BindVertexBuffer2.__proto__ = BaseValue2;
	                  BindVertexBuffer2.prototype = Object.create(BaseValue2.prototype);
	                  BindVertexBuffer2.prototype.constructor = BindVertexBuffer2;
	                  BindVertexBuffer2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  BindVertexBuffer2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.bindBuffer(gl2.ARRAY_BUFFER, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BindVertexBuffer2;
	                }(BaseValue);
	                var BindElementBuffer = function(BaseValue2) {
	                  function BindElementBuffer2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  BindElementBuffer2.__proto__ = BaseValue2;
	                  BindElementBuffer2.prototype = Object.create(BaseValue2.prototype);
	                  BindElementBuffer2.prototype.constructor = BindElementBuffer2;
	                  BindElementBuffer2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  BindElementBuffer2.prototype.set = function set(v) {
	                    var gl2 = this.gl;
	                    gl2.bindBuffer(gl2.ELEMENT_ARRAY_BUFFER, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BindElementBuffer2;
	                }(BaseValue);
	                var BindVertexArrayOES = function(BaseValue2) {
	                  function BindVertexArrayOES2(context) {
	                    BaseValue2.call(this, context);
	                    this.vao = context.extVertexArrayObject;
	                  }
	                  BindVertexArrayOES2.__proto__ = BaseValue2;
	                  BindVertexArrayOES2.prototype = Object.create(BaseValue2.prototype);
	                  BindVertexArrayOES2.prototype.constructor = BindVertexArrayOES2;
	                  BindVertexArrayOES2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  BindVertexArrayOES2.prototype.set = function set(v) {
	                    if (!this.vao || v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.vao.bindVertexArrayOES(v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return BindVertexArrayOES2;
	                }(BaseValue);
	                var PixelStoreUnpack = function(BaseValue2) {
	                  function PixelStoreUnpack2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  PixelStoreUnpack2.__proto__ = BaseValue2;
	                  PixelStoreUnpack2.prototype = Object.create(BaseValue2.prototype);
	                  PixelStoreUnpack2.prototype.constructor = PixelStoreUnpack2;
	                  PixelStoreUnpack2.prototype.getDefault = function getDefault() {
	                    return 4;
	                  };
	                  PixelStoreUnpack2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.pixelStorei(gl2.UNPACK_ALIGNMENT, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return PixelStoreUnpack2;
	                }(BaseValue);
	                var PixelStoreUnpackPremultiplyAlpha = function(BaseValue2) {
	                  function PixelStoreUnpackPremultiplyAlpha2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  PixelStoreUnpackPremultiplyAlpha2.__proto__ = BaseValue2;
	                  PixelStoreUnpackPremultiplyAlpha2.prototype = Object.create(BaseValue2.prototype);
	                  PixelStoreUnpackPremultiplyAlpha2.prototype.constructor = PixelStoreUnpackPremultiplyAlpha2;
	                  PixelStoreUnpackPremultiplyAlpha2.prototype.getDefault = function getDefault() {
	                    return false;
	                  };
	                  PixelStoreUnpackPremultiplyAlpha2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.pixelStorei(gl2.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return PixelStoreUnpackPremultiplyAlpha2;
	                }(BaseValue);
	                var PixelStoreUnpackFlipY = function(BaseValue2) {
	                  function PixelStoreUnpackFlipY2() {
	                    BaseValue2.apply(this, arguments);
	                  }
	                  PixelStoreUnpackFlipY2.__proto__ = BaseValue2;
	                  PixelStoreUnpackFlipY2.prototype = Object.create(BaseValue2.prototype);
	                  PixelStoreUnpackFlipY2.prototype.constructor = PixelStoreUnpackFlipY2;
	                  PixelStoreUnpackFlipY2.prototype.getDefault = function getDefault() {
	                    return false;
	                  };
	                  PixelStoreUnpackFlipY2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    var gl2 = this.gl;
	                    gl2.pixelStorei(gl2.UNPACK_FLIP_Y_WEBGL, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return PixelStoreUnpackFlipY2;
	                }(BaseValue);
	                var FramebufferAttachment = function(BaseValue2) {
	                  function FramebufferAttachment2(context, parent) {
	                    BaseValue2.call(this, context);
	                    this.context = context;
	                    this.parent = parent;
	                  }
	                  FramebufferAttachment2.__proto__ = BaseValue2;
	                  FramebufferAttachment2.prototype = Object.create(BaseValue2.prototype);
	                  FramebufferAttachment2.prototype.constructor = FramebufferAttachment2;
	                  FramebufferAttachment2.prototype.getDefault = function getDefault() {
	                    return null;
	                  };
	                  return FramebufferAttachment2;
	                }(BaseValue);
	                var ColorAttachment = function(FramebufferAttachment2) {
	                  function ColorAttachment2() {
	                    FramebufferAttachment2.apply(this, arguments);
	                  }
	                  ColorAttachment2.__proto__ = FramebufferAttachment2;
	                  ColorAttachment2.prototype = Object.create(FramebufferAttachment2.prototype);
	                  ColorAttachment2.prototype.constructor = ColorAttachment2;
	                  ColorAttachment2.prototype.setDirty = function setDirty() {
	                    this.dirty = true;
	                  };
	                  ColorAttachment2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.context.bindFramebuffer.set(this.parent);
	                    var gl2 = this.gl;
	                    gl2.framebufferTexture2D(gl2.FRAMEBUFFER, gl2.COLOR_ATTACHMENT0, gl2.TEXTURE_2D, v, 0);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return ColorAttachment2;
	                }(FramebufferAttachment);
	                var DepthAttachment = function(FramebufferAttachment2) {
	                  function DepthAttachment2() {
	                    FramebufferAttachment2.apply(this, arguments);
	                  }
	                  DepthAttachment2.__proto__ = FramebufferAttachment2;
	                  DepthAttachment2.prototype = Object.create(FramebufferAttachment2.prototype);
	                  DepthAttachment2.prototype.constructor = DepthAttachment2;
	                  DepthAttachment2.prototype.set = function set(v) {
	                    if (v === this.current && !this.dirty) {
	                      return;
	                    }
	                    this.context.bindFramebuffer.set(this.parent);
	                    var gl2 = this.gl;
	                    gl2.framebufferRenderbuffer(gl2.FRAMEBUFFER, gl2.DEPTH_ATTACHMENT, gl2.RENDERBUFFER, v);
	                    this.current = v;
	                    this.dirty = false;
	                  };
	                  return DepthAttachment2;
	                }(FramebufferAttachment);
	                var Framebuffer = function Framebuffer2(context, width, height, hasDepth) {
	                  this.context = context;
	                  this.width = width;
	                  this.height = height;
	                  var gl2 = context.gl;
	                  var fbo = this.framebuffer = gl2.createFramebuffer();
	                  this.colorAttachment = new ColorAttachment(context, fbo);
	                  if (hasDepth) {
	                    this.depthAttachment = new DepthAttachment(context, fbo);
	                  }
	                };
	                Framebuffer.prototype.destroy = function destroy() {
	                  var gl2 = this.context.gl;
	                  var texture = this.colorAttachment.get();
	                  if (texture) {
	                    gl2.deleteTexture(texture);
	                  }
	                  if (this.depthAttachment) {
	                    var renderbuffer = this.depthAttachment.get();
	                    if (renderbuffer) {
	                      gl2.deleteRenderbuffer(renderbuffer);
	                    }
	                  }
	                  gl2.deleteFramebuffer(this.framebuffer);
	                };
	                var ALWAYS = 519;
	                var DepthMode = function DepthMode2(depthFunc, depthMask, depthRange) {
	                  this.func = depthFunc;
	                  this.mask = depthMask;
	                  this.range = depthRange;
	                };
	                DepthMode.ReadOnly = false;
	                DepthMode.ReadWrite = true;
	                DepthMode.disabled = new DepthMode(ALWAYS, DepthMode.ReadOnly, [
	                  0,
	                  1
	                ]);
	                var ALWAYS$1 = 519;
	                var KEEP = 7680;
	                var StencilMode = function StencilMode2(test, ref, mask, fail, depthFail, pass) {
	                  this.test = test;
	                  this.ref = ref;
	                  this.mask = mask;
	                  this.fail = fail;
	                  this.depthFail = depthFail;
	                  this.pass = pass;
	                };
	                StencilMode.disabled = new StencilMode({
	                  func: ALWAYS$1,
	                  mask: 0
	                }, 0, 0, KEEP, KEEP, KEEP);
	                var ZERO = 0;
	                var ONE = 1;
	                var ONE_MINUS_SRC_ALPHA = 771;
	                var ColorMode = function ColorMode2(blendFunction, blendColor, mask) {
	                  this.blendFunction = blendFunction;
	                  this.blendColor = blendColor;
	                  this.mask = mask;
	                };
	                ColorMode.Replace = [
	                  ONE,
	                  ZERO
	                ];
	                ColorMode.disabled = new ColorMode(ColorMode.Replace, performance2.Color.transparent, [
	                  false,
	                  false,
	                  false,
	                  false
	                ]);
	                ColorMode.unblended = new ColorMode(ColorMode.Replace, performance2.Color.transparent, [
	                  true,
	                  true,
	                  true,
	                  true
	                ]);
	                ColorMode.alphaBlended = new ColorMode([
	                  ONE,
	                  ONE_MINUS_SRC_ALPHA
	                ], performance2.Color.transparent, [
	                  true,
	                  true,
	                  true,
	                  true
	                ]);
	                var BACK = 1029;
	                var CCW = 2305;
	                var CullFaceMode = function CullFaceMode2(enable, mode, frontFace) {
	                  this.enable = enable;
	                  this.mode = mode;
	                  this.frontFace = frontFace;
	                };
	                CullFaceMode.disabled = new CullFaceMode(false, BACK, CCW);
	                CullFaceMode.backCCW = new CullFaceMode(true, BACK, CCW);
	                var Context = function Context2(gl2) {
	                  this.gl = gl2;
	                  this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object");
	                  this.clearColor = new ClearColor(this);
	                  this.clearDepth = new ClearDepth(this);
	                  this.clearStencil = new ClearStencil(this);
	                  this.colorMask = new ColorMask(this);
	                  this.depthMask = new DepthMask(this);
	                  this.stencilMask = new StencilMask(this);
	                  this.stencilFunc = new StencilFunc(this);
	                  this.stencilOp = new StencilOp(this);
	                  this.stencilTest = new StencilTest(this);
	                  this.depthRange = new DepthRange(this);
	                  this.depthTest = new DepthTest(this);
	                  this.depthFunc = new DepthFunc(this);
	                  this.blend = new Blend(this);
	                  this.blendFunc = new BlendFunc(this);
	                  this.blendColor = new BlendColor(this);
	                  this.blendEquation = new BlendEquation(this);
	                  this.cullFace = new CullFace(this);
	                  this.cullFaceSide = new CullFaceSide(this);
	                  this.frontFace = new FrontFace(this);
	                  this.program = new Program(this);
	                  this.activeTexture = new ActiveTextureUnit(this);
	                  this.viewport = new Viewport(this);
	                  this.bindFramebuffer = new BindFramebuffer(this);
	                  this.bindRenderbuffer = new BindRenderbuffer(this);
	                  this.bindTexture = new BindTexture(this);
	                  this.bindVertexBuffer = new BindVertexBuffer(this);
	                  this.bindElementBuffer = new BindElementBuffer(this);
	                  this.bindVertexArrayOES = this.extVertexArrayObject && new BindVertexArrayOES(this);
	                  this.pixelStoreUnpack = new PixelStoreUnpack(this);
	                  this.pixelStoreUnpackPremultiplyAlpha = new PixelStoreUnpackPremultiplyAlpha(this);
	                  this.pixelStoreUnpackFlipY = new PixelStoreUnpackFlipY(this);
	                  this.extTextureFilterAnisotropic = gl2.getExtension("EXT_texture_filter_anisotropic") || gl2.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl2.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
	                  if (this.extTextureFilterAnisotropic) {
	                    this.extTextureFilterAnisotropicMax = gl2.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
	                  }
	                  this.extTextureHalfFloat = gl2.getExtension("OES_texture_half_float");
	                  if (this.extTextureHalfFloat) {
	                    gl2.getExtension("OES_texture_half_float_linear");
	                    this.extRenderToTextureHalfFloat = gl2.getExtension("EXT_color_buffer_half_float");
	                  }
	                  this.extTimerQuery = gl2.getExtension("EXT_disjoint_timer_query");
	                };
	                Context.prototype.setDefault = function setDefault() {
	                  this.unbindVAO();
	                  this.clearColor.setDefault();
	                  this.clearDepth.setDefault();
	                  this.clearStencil.setDefault();
	                  this.colorMask.setDefault();
	                  this.depthMask.setDefault();
	                  this.stencilMask.setDefault();
	                  this.stencilFunc.setDefault();
	                  this.stencilOp.setDefault();
	                  this.stencilTest.setDefault();
	                  this.depthRange.setDefault();
	                  this.depthTest.setDefault();
	                  this.depthFunc.setDefault();
	                  this.blend.setDefault();
	                  this.blendFunc.setDefault();
	                  this.blendColor.setDefault();
	                  this.blendEquation.setDefault();
	                  this.cullFace.setDefault();
	                  this.cullFaceSide.setDefault();
	                  this.frontFace.setDefault();
	                  this.program.setDefault();
	                  this.activeTexture.setDefault();
	                  this.bindFramebuffer.setDefault();
	                  this.pixelStoreUnpack.setDefault();
	                  this.pixelStoreUnpackPremultiplyAlpha.setDefault();
	                  this.pixelStoreUnpackFlipY.setDefault();
	                };
	                Context.prototype.setDirty = function setDirty() {
	                  this.clearColor.dirty = true;
	                  this.clearDepth.dirty = true;
	                  this.clearStencil.dirty = true;
	                  this.colorMask.dirty = true;
	                  this.depthMask.dirty = true;
	                  this.stencilMask.dirty = true;
	                  this.stencilFunc.dirty = true;
	                  this.stencilOp.dirty = true;
	                  this.stencilTest.dirty = true;
	                  this.depthRange.dirty = true;
	                  this.depthTest.dirty = true;
	                  this.depthFunc.dirty = true;
	                  this.blend.dirty = true;
	                  this.blendFunc.dirty = true;
	                  this.blendColor.dirty = true;
	                  this.blendEquation.dirty = true;
	                  this.cullFace.dirty = true;
	                  this.cullFaceSide.dirty = true;
	                  this.frontFace.dirty = true;
	                  this.program.dirty = true;
	                  this.activeTexture.dirty = true;
	                  this.viewport.dirty = true;
	                  this.bindFramebuffer.dirty = true;
	                  this.bindRenderbuffer.dirty = true;
	                  this.bindTexture.dirty = true;
	                  this.bindVertexBuffer.dirty = true;
	                  this.bindElementBuffer.dirty = true;
	                  if (this.extVertexArrayObject) {
	                    this.bindVertexArrayOES.dirty = true;
	                  }
	                  this.pixelStoreUnpack.dirty = true;
	                  this.pixelStoreUnpackPremultiplyAlpha.dirty = true;
	                  this.pixelStoreUnpackFlipY.dirty = true;
	                };
	                Context.prototype.createIndexBuffer = function createIndexBuffer(array, dynamicDraw) {
	                  return new IndexBuffer(this, array, dynamicDraw);
	                };
	                Context.prototype.createVertexBuffer = function createVertexBuffer(array, attributes, dynamicDraw) {
	                  return new VertexBuffer(this, array, attributes, dynamicDraw);
	                };
	                Context.prototype.createRenderbuffer = function createRenderbuffer(storageFormat, width, height) {
	                  var gl2 = this.gl;
	                  var rbo = gl2.createRenderbuffer();
	                  this.bindRenderbuffer.set(rbo);
	                  gl2.renderbufferStorage(gl2.RENDERBUFFER, storageFormat, width, height);
	                  this.bindRenderbuffer.set(null);
	                  return rbo;
	                };
	                Context.prototype.createFramebuffer = function createFramebuffer(width, height, hasDepth) {
	                  return new Framebuffer(this, width, height, hasDepth);
	                };
	                Context.prototype.clear = function clear(ref) {
	                  var color = ref.color;
	                  var depth = ref.depth;
	                  var gl2 = this.gl;
	                  var mask = 0;
	                  if (color) {
	                    mask |= gl2.COLOR_BUFFER_BIT;
	                    this.clearColor.set(color);
	                    this.colorMask.set([
	                      true,
	                      true,
	                      true,
	                      true
	                    ]);
	                  }
	                  if (typeof depth !== "undefined") {
	                    mask |= gl2.DEPTH_BUFFER_BIT;
	                    this.depthRange.set([
	                      0,
	                      1
	                    ]);
	                    this.clearDepth.set(depth);
	                    this.depthMask.set(true);
	                  }
	                  gl2.clear(mask);
	                };
	                Context.prototype.setCullFace = function setCullFace(cullFaceMode) {
	                  if (cullFaceMode.enable === false) {
	                    this.cullFace.set(false);
	                  } else {
	                    this.cullFace.set(true);
	                    this.cullFaceSide.set(cullFaceMode.mode);
	                    this.frontFace.set(cullFaceMode.frontFace);
	                  }
	                };
	                Context.prototype.setDepthMode = function setDepthMode(depthMode) {
	                  if (depthMode.func === this.gl.ALWAYS && !depthMode.mask) {
	                    this.depthTest.set(false);
	                  } else {
	                    this.depthTest.set(true);
	                    this.depthFunc.set(depthMode.func);
	                    this.depthMask.set(depthMode.mask);
	                    this.depthRange.set(depthMode.range);
	                  }
	                };
	                Context.prototype.setStencilMode = function setStencilMode(stencilMode) {
	                  if (stencilMode.test.func === this.gl.ALWAYS && !stencilMode.mask) {
	                    this.stencilTest.set(false);
	                  } else {
	                    this.stencilTest.set(true);
	                    this.stencilMask.set(stencilMode.mask);
	                    this.stencilOp.set([
	                      stencilMode.fail,
	                      stencilMode.depthFail,
	                      stencilMode.pass
	                    ]);
	                    this.stencilFunc.set({
	                      func: stencilMode.test.func,
	                      ref: stencilMode.ref,
	                      mask: stencilMode.test.mask
	                    });
	                  }
	                };
	                Context.prototype.setColorMode = function setColorMode(colorMode) {
	                  if (performance2.deepEqual(colorMode.blendFunction, ColorMode.Replace)) {
	                    this.blend.set(false);
	                  } else {
	                    this.blend.set(true);
	                    this.blendFunc.set(colorMode.blendFunction);
	                    this.blendColor.set(colorMode.blendColor);
	                  }
	                  this.colorMask.set(colorMode.mask);
	                };
	                Context.prototype.unbindVAO = function unbindVAO() {
	                  if (this.extVertexArrayObject) {
	                    this.bindVertexArrayOES.set(null);
	                  }
	                };
	                var SourceCache = function(Evented) {
	                  function SourceCache2(id, options, dispatcher) {
	                    var this$1$1 = this;
	                    Evented.call(this);
	                    this.id = id;
	                    this.dispatcher = dispatcher;
	                    this.on("data", function(e) {
	                      if (e.dataType === "source" && e.sourceDataType === "metadata") {
	                        this$1$1._sourceLoaded = true;
	                      }
	                      if (this$1$1._sourceLoaded && !this$1$1._paused && e.dataType === "source" && e.sourceDataType === "content") {
	                        this$1$1.reload();
	                        if (this$1$1.transform) {
	                          this$1$1.update(this$1$1.transform);
	                        }
	                      }
	                    });
	                    this.on("error", function() {
	                      this$1$1._sourceErrored = true;
	                    });
	                    this._source = create(id, options, dispatcher, this);
	                    this._tiles = {};
	                    this._cache = new TileCache(0, this._unloadTile.bind(this));
	                    this._timers = {};
	                    this._cacheTimers = {};
	                    this._maxTileCacheSize = null;
	                    this._loadedParentTiles = {};
	                    this._coveredTiles = {};
	                    this._state = new performance2.SourceFeatureState();
	                  }
	                  if (Evented)
	                    SourceCache2.__proto__ = Evented;
	                  SourceCache2.prototype = Object.create(Evented && Evented.prototype);
	                  SourceCache2.prototype.constructor = SourceCache2;
	                  SourceCache2.prototype.onAdd = function onAdd(map2) {
	                    this.map = map2;
	                    this._maxTileCacheSize = map2 ? map2._maxTileCacheSize : null;
	                    if (this._source && this._source.onAdd) {
	                      this._source.onAdd(map2);
	                    }
	                  };
	                  SourceCache2.prototype.onRemove = function onRemove(map2) {
	                    if (this._source && this._source.onRemove) {
	                      this._source.onRemove(map2);
	                    }
	                  };
	                  SourceCache2.prototype.loaded = function loaded() {
	                    if (this._sourceErrored) {
	                      return true;
	                    }
	                    if (!this._sourceLoaded) {
	                      return false;
	                    }
	                    if (!this._source.loaded()) {
	                      return false;
	                    }
	                    for (var t in this._tiles) {
	                      var tile = this._tiles[t];
	                      if (tile.state !== "loaded" && tile.state !== "errored") {
	                        return false;
	                      }
	                    }
	                    return true;
	                  };
	                  SourceCache2.prototype.getSource = function getSource() {
	                    return this._source;
	                  };
	                  SourceCache2.prototype.pause = function pause() {
	                    this._paused = true;
	                  };
	                  SourceCache2.prototype.resume = function resume() {
	                    if (!this._paused) {
	                      return;
	                    }
	                    var shouldReload = this._shouldReloadOnResume;
	                    this._paused = false;
	                    this._shouldReloadOnResume = false;
	                    if (shouldReload) {
	                      this.reload();
	                    }
	                    if (this.transform) {
	                      this.update(this.transform);
	                    }
	                  };
	                  SourceCache2.prototype._loadTile = function _loadTile(tile, callback) {
	                    return this._source.loadTile(tile, callback);
	                  };
	                  SourceCache2.prototype._unloadTile = function _unloadTile(tile) {
	                    if (this._source.unloadTile) {
	                      return this._source.unloadTile(tile, function() {
	                      });
	                    }
	                  };
	                  SourceCache2.prototype._abortTile = function _abortTile(tile) {
	                    if (this._source.abortTile) {
	                      return this._source.abortTile(tile, function() {
	                      });
	                    }
	                  };
	                  SourceCache2.prototype.serialize = function serialize() {
	                    return this._source.serialize();
	                  };
	                  SourceCache2.prototype.prepare = function prepare(context) {
	                    if (this._source.prepare) {
	                      this._source.prepare();
	                    }
	                    this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
	                    for (var i in this._tiles) {
	                      var tile = this._tiles[i];
	                      tile.upload(context);
	                      tile.prepare(this.map.style.imageManager);
	                    }
	                  };
	                  SourceCache2.prototype.getIds = function getIds() {
	                    return performance2.values(this._tiles).map(function(tile) {
	                      return tile.tileID;
	                    }).sort(compareTileId).map(function(id) {
	                      return id.key;
	                    });
	                  };
	                  SourceCache2.prototype.getRenderableIds = function getRenderableIds(symbolLayer) {
	                    var this$1$1 = this;
	                    var renderables = [];
	                    for (var id in this._tiles) {
	                      if (this._isIdRenderable(id, symbolLayer)) {
	                        renderables.push(this._tiles[id]);
	                      }
	                    }
	                    if (symbolLayer) {
	                      return renderables.sort(function(a_, b_) {
	                        var a = a_.tileID;
	                        var b = b_.tileID;
	                        var rotatedA = new performance2.Point(a.canonical.x, a.canonical.y)._rotate(this$1$1.transform.angle);
	                        var rotatedB = new performance2.Point(b.canonical.x, b.canonical.y)._rotate(this$1$1.transform.angle);
	                        return a.overscaledZ - b.overscaledZ || rotatedB.y - rotatedA.y || rotatedB.x - rotatedA.x;
	                      }).map(function(tile) {
	                        return tile.tileID.key;
	                      });
	                    }
	                    return renderables.map(function(tile) {
	                      return tile.tileID;
	                    }).sort(compareTileId).map(function(id2) {
	                      return id2.key;
	                    });
	                  };
	                  SourceCache2.prototype.hasRenderableParent = function hasRenderableParent(tileID) {
	                    var parentTile = this.findLoadedParent(tileID, 0);
	                    if (parentTile) {
	                      return this._isIdRenderable(parentTile.tileID.key);
	                    }
	                    return false;
	                  };
	                  SourceCache2.prototype._isIdRenderable = function _isIdRenderable(id, symbolLayer) {
	                    return this._tiles[id] && this._tiles[id].hasData() && !this._coveredTiles[id] && (symbolLayer || !this._tiles[id].holdingForFade());
	                  };
	                  SourceCache2.prototype.reload = function reload() {
	                    if (this._paused) {
	                      this._shouldReloadOnResume = true;
	                      return;
	                    }
	                    this._cache.reset();
	                    for (var i in this._tiles) {
	                      if (this._tiles[i].state !== "errored") {
	                        this._reloadTile(i, "reloading");
	                      }
	                    }
	                  };
	                  SourceCache2.prototype._reloadTile = function _reloadTile(id, state) {
	                    var tile = this._tiles[id];
	                    if (!tile) {
	                      return;
	                    }
	                    if (tile.state !== "loading") {
	                      tile.state = state;
	                    }
	                    this._loadTile(tile, this._tileLoaded.bind(this, tile, id, state));
	                  };
	                  SourceCache2.prototype._tileLoaded = function _tileLoaded(tile, id, previousState, err) {
	                    if (err) {
	                      tile.state = "errored";
	                      if (err.status !== 404) {
	                        this._source.fire(new performance2.ErrorEvent(err, { tile }));
	                      } else {
	                        this.update(this.transform);
	                      }
	                      return;
	                    }
	                    tile.timeAdded = performance2.browser.now();
	                    if (previousState === "expired") {
	                      tile.refreshedUponExpiration = true;
	                    }
	                    this._setTileReloadTimer(id, tile);
	                    if (this.getSource().type === "raster-dem" && tile.dem) {
	                      this._backfillDEM(tile);
	                    }
	                    this._state.initializeTileState(tile, this.map ? this.map.painter : null);
	                    this._source.fire(new performance2.Event("data", {
	                      dataType: "source",
	                      tile,
	                      coord: tile.tileID
	                    }));
	                  };
	                  SourceCache2.prototype._backfillDEM = function _backfillDEM(tile) {
	                    var renderables = this.getRenderableIds();
	                    for (var i = 0; i < renderables.length; i++) {
	                      var borderId = renderables[i];
	                      if (tile.neighboringTiles && tile.neighboringTiles[borderId]) {
	                        var borderTile = this.getTileByID(borderId);
	                        fillBorder(tile, borderTile);
	                        fillBorder(borderTile, tile);
	                      }
	                    }
	                    function fillBorder(tile2, borderTile2) {
	                      tile2.needsHillshadePrepare = true;
	                      var dx = borderTile2.tileID.canonical.x - tile2.tileID.canonical.x;
	                      var dy = borderTile2.tileID.canonical.y - tile2.tileID.canonical.y;
	                      var dim = Math.pow(2, tile2.tileID.canonical.z);
	                      var borderId2 = borderTile2.tileID.key;
	                      if (dx === 0 && dy === 0) {
	                        return;
	                      }
	                      if (Math.abs(dy) > 1) {
	                        return;
	                      }
	                      if (Math.abs(dx) > 1) {
	                        if (Math.abs(dx + dim) === 1) {
	                          dx += dim;
	                        } else if (Math.abs(dx - dim) === 1) {
	                          dx -= dim;
	                        }
	                      }
	                      if (!borderTile2.dem || !tile2.dem) {
	                        return;
	                      }
	                      tile2.dem.backfillBorder(borderTile2.dem, dx, dy);
	                      if (tile2.neighboringTiles && tile2.neighboringTiles[borderId2]) {
	                        tile2.neighboringTiles[borderId2].backfilled = true;
	                      }
	                    }
	                  };
	                  SourceCache2.prototype.getTile = function getTile(tileID) {
	                    return this.getTileByID(tileID.key);
	                  };
	                  SourceCache2.prototype.getTileByID = function getTileByID(id) {
	                    return this._tiles[id];
	                  };
	                  SourceCache2.prototype._retainLoadedChildren = function _retainLoadedChildren(idealTiles, zoom, maxCoveringZoom, retain) {
	                    for (var id in this._tiles) {
	                      var tile = this._tiles[id];
	                      if (retain[id] || !tile.hasData() || tile.tileID.overscaledZ <= zoom || tile.tileID.overscaledZ > maxCoveringZoom) {
	                        continue;
	                      }
	                      var topmostLoadedID = tile.tileID;
	                      while (tile && tile.tileID.overscaledZ > zoom + 1) {
	                        var parentID = tile.tileID.scaledTo(tile.tileID.overscaledZ - 1);
	                        tile = this._tiles[parentID.key];
	                        if (tile && tile.hasData()) {
	                          topmostLoadedID = parentID;
	                        }
	                      }
	                      var tileID = topmostLoadedID;
	                      while (tileID.overscaledZ > zoom) {
	                        tileID = tileID.scaledTo(tileID.overscaledZ - 1);
	                        if (idealTiles[tileID.key]) {
	                          retain[topmostLoadedID.key] = topmostLoadedID;
	                          break;
	                        }
	                      }
	                    }
	                  };
	                  SourceCache2.prototype.findLoadedParent = function findLoadedParent(tileID, minCoveringZoom) {
	                    if (tileID.key in this._loadedParentTiles) {
	                      var parent = this._loadedParentTiles[tileID.key];
	                      if (parent && parent.tileID.overscaledZ >= minCoveringZoom) {
	                        return parent;
	                      } else {
	                        return null;
	                      }
	                    }
	                    for (var z = tileID.overscaledZ - 1; z >= minCoveringZoom; z--) {
	                      var parentTileID = tileID.scaledTo(z);
	                      var tile = this._getLoadedTile(parentTileID);
	                      if (tile) {
	                        return tile;
	                      }
	                    }
	                  };
	                  SourceCache2.prototype._getLoadedTile = function _getLoadedTile(tileID) {
	                    var tile = this._tiles[tileID.key];
	                    if (tile && tile.hasData()) {
	                      return tile;
	                    }
	                    var cachedTile = this._cache.getByKey(tileID.wrapped().key);
	                    return cachedTile;
	                  };
	                  SourceCache2.prototype.updateCacheSize = function updateCacheSize(transform) {
	                    var widthInTiles = Math.ceil(transform.width / this._source.tileSize) + 1;
	                    var heightInTiles = Math.ceil(transform.height / this._source.tileSize) + 1;
	                    var approxTilesInView = widthInTiles * heightInTiles;
	                    var commonZoomRange = 5;
	                    var viewDependentMaxSize = Math.floor(approxTilesInView * commonZoomRange);
	                    var maxSize = typeof this._maxTileCacheSize === "number" ? Math.min(this._maxTileCacheSize, viewDependentMaxSize) : viewDependentMaxSize;
	                    this._cache.setMaxSize(maxSize);
	                  };
	                  SourceCache2.prototype.handleWrapJump = function handleWrapJump(lng) {
	                    var prevLng = this._prevLng === undefined ? lng : this._prevLng;
	                    var lngDifference = lng - prevLng;
	                    var worldDifference = lngDifference / 360;
	                    var wrapDelta = Math.round(worldDifference);
	                    this._prevLng = lng;
	                    if (wrapDelta) {
	                      var tiles = {};
	                      for (var key in this._tiles) {
	                        var tile = this._tiles[key];
	                        tile.tileID = tile.tileID.unwrapTo(tile.tileID.wrap + wrapDelta);
	                        tiles[tile.tileID.key] = tile;
	                      }
	                      this._tiles = tiles;
	                      for (var id in this._timers) {
	                        clearTimeout(this._timers[id]);
	                        delete this._timers[id];
	                      }
	                      for (var id$1 in this._tiles) {
	                        var tile$1 = this._tiles[id$1];
	                        this._setTileReloadTimer(id$1, tile$1);
	                      }
	                    }
	                  };
	                  SourceCache2.prototype.update = function update(transform) {
	                    var this$1$1 = this;
	                    this.transform = transform;
	                    if (!this._sourceLoaded || this._paused) {
	                      return;
	                    }
	                    this.updateCacheSize(transform);
	                    this.handleWrapJump(this.transform.center.lng);
	                    this._coveredTiles = {};
	                    var idealTileIDs;
	                    if (!this.used) {
	                      idealTileIDs = [];
	                    } else if (this._source.tileID) {
	                      idealTileIDs = transform.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(unwrapped) {
	                        return new performance2.OverscaledTileID(unwrapped.canonical.z, unwrapped.wrap, unwrapped.canonical.z, unwrapped.canonical.x, unwrapped.canonical.y);
	                      });
	                    } else {
	                      idealTileIDs = transform.coveringTiles({
	                        tileSize: this._source.tileSize,
	                        minzoom: this._source.minzoom,
	                        maxzoom: this._source.maxzoom,
	                        roundZoom: this._source.roundZoom,
	                        reparseOverscaled: this._source.reparseOverscaled
	                      });
	                      if (this._source.hasTile) {
	                        idealTileIDs = idealTileIDs.filter(function(coord) {
	                          return this$1$1._source.hasTile(coord);
	                        });
	                      }
	                    }
	                    var zoom = transform.coveringZoomLevel(this._source);
	                    var minCoveringZoom = Math.max(zoom - SourceCache2.maxOverzooming, this._source.minzoom);
	                    var maxCoveringZoom = Math.max(zoom + SourceCache2.maxUnderzooming, this._source.minzoom);
	                    var retain = this._updateRetainedTiles(idealTileIDs, zoom);
	                    if (isRasterType(this._source.type)) {
	                      var parentsForFading = {};
	                      var fadingTiles = {};
	                      var ids = Object.keys(retain);
	                      for (var i = 0, list = ids; i < list.length; i += 1) {
	                        var id = list[i];
	                        var tileID = retain[id];
	                        var tile = this._tiles[id];
	                        if (!tile || tile.fadeEndTime && tile.fadeEndTime <= performance2.browser.now()) {
	                          continue;
	                        }
	                        var parentTile = this.findLoadedParent(tileID, minCoveringZoom);
	                        if (parentTile) {
	                          this._addTile(parentTile.tileID);
	                          parentsForFading[parentTile.tileID.key] = parentTile.tileID;
	                        }
	                        fadingTiles[id] = tileID;
	                      }
	                      this._retainLoadedChildren(fadingTiles, zoom, maxCoveringZoom, retain);
	                      for (var id$1 in parentsForFading) {
	                        if (!retain[id$1]) {
	                          this._coveredTiles[id$1] = true;
	                          retain[id$1] = parentsForFading[id$1];
	                        }
	                      }
	                    }
	                    for (var retainedId in retain) {
	                      this._tiles[retainedId].clearFadeHold();
	                    }
	                    var remove = performance2.keysDifference(this._tiles, retain);
	                    for (var i$1 = 0, list$1 = remove; i$1 < list$1.length; i$1 += 1) {
	                      var tileID$1 = list$1[i$1];
	                      var tile$1 = this._tiles[tileID$1];
	                      if (tile$1.hasSymbolBuckets && !tile$1.holdingForFade()) {
	                        tile$1.setHoldDuration(this.map._fadeDuration);
	                      } else if (!tile$1.hasSymbolBuckets || tile$1.symbolFadeFinished()) {
	                        this._removeTile(tileID$1);
	                      }
	                    }
	                    this._updateLoadedParentTileCache();
	                  };
	                  SourceCache2.prototype.releaseSymbolFadeTiles = function releaseSymbolFadeTiles() {
	                    for (var id in this._tiles) {
	                      if (this._tiles[id].holdingForFade()) {
	                        this._removeTile(id);
	                      }
	                    }
	                  };
	                  SourceCache2.prototype._updateRetainedTiles = function _updateRetainedTiles(idealTileIDs, zoom) {
	                    var retain = {};
	                    var checked = {};
	                    var minCoveringZoom = Math.max(zoom - SourceCache2.maxOverzooming, this._source.minzoom);
	                    var maxCoveringZoom = Math.max(zoom + SourceCache2.maxUnderzooming, this._source.minzoom);
	                    var missingTiles = {};
	                    for (var i = 0, list = idealTileIDs; i < list.length; i += 1) {
	                      var tileID = list[i];
	                      var tile = this._addTile(tileID);
	                      retain[tileID.key] = tileID;
	                      if (tile.hasData()) {
	                        continue;
	                      }
	                      if (zoom < this._source.maxzoom) {
	                        missingTiles[tileID.key] = tileID;
	                      }
	                    }
	                    this._retainLoadedChildren(missingTiles, zoom, maxCoveringZoom, retain);
	                    for (var i$1 = 0, list$1 = idealTileIDs; i$1 < list$1.length; i$1 += 1) {
	                      var tileID$1 = list$1[i$1];
	                      var tile$1 = this._tiles[tileID$1.key];
	                      if (tile$1.hasData()) {
	                        continue;
	                      }
	                      if (zoom + 1 > this._source.maxzoom) {
	                        var childCoord = tileID$1.children(this._source.maxzoom)[0];
	                        var childTile = this.getTile(childCoord);
	                        if (!!childTile && childTile.hasData()) {
	                          retain[childCoord.key] = childCoord;
	                          continue;
	                        }
	                      } else {
	                        var children = tileID$1.children(this._source.maxzoom);
	                        if (retain[children[0].key] && retain[children[1].key] && retain[children[2].key] && retain[children[3].key]) {
	                          continue;
	                        }
	                      }
	                      var parentWasRequested = tile$1.wasRequested();
	                      for (var overscaledZ = tileID$1.overscaledZ - 1; overscaledZ >= minCoveringZoom; --overscaledZ) {
	                        var parentId = tileID$1.scaledTo(overscaledZ);
	                        if (checked[parentId.key]) {
	                          break;
	                        }
	                        checked[parentId.key] = true;
	                        tile$1 = this.getTile(parentId);
	                        if (!tile$1 && parentWasRequested) {
	                          tile$1 = this._addTile(parentId);
	                        }
	                        if (tile$1) {
	                          retain[parentId.key] = parentId;
	                          parentWasRequested = tile$1.wasRequested();
	                          if (tile$1.hasData()) {
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    return retain;
	                  };
	                  SourceCache2.prototype._updateLoadedParentTileCache = function _updateLoadedParentTileCache() {
	                    this._loadedParentTiles = {};
	                    for (var tileKey in this._tiles) {
	                      var path = [];
	                      var parentTile = undefined;
	                      var currentId = this._tiles[tileKey].tileID;
	                      while (currentId.overscaledZ > 0) {
	                        if (currentId.key in this._loadedParentTiles) {
	                          parentTile = this._loadedParentTiles[currentId.key];
	                          break;
	                        }
	                        path.push(currentId.key);
	                        var parentId = currentId.scaledTo(currentId.overscaledZ - 1);
	                        parentTile = this._getLoadedTile(parentId);
	                        if (parentTile) {
	                          break;
	                        }
	                        currentId = parentId;
	                      }
	                      for (var i = 0, list = path; i < list.length; i += 1) {
	                        var key = list[i];
	                        this._loadedParentTiles[key] = parentTile;
	                      }
	                    }
	                  };
	                  SourceCache2.prototype._addTile = function _addTile(tileID) {
	                    var tile = this._tiles[tileID.key];
	                    if (tile) {
	                      return tile;
	                    }
	                    tile = this._cache.getAndRemove(tileID);
	                    if (tile) {
	                      this._setTileReloadTimer(tileID.key, tile);
	                      tile.tileID = tileID;
	                      this._state.initializeTileState(tile, this.map ? this.map.painter : null);
	                      if (this._cacheTimers[tileID.key]) {
	                        clearTimeout(this._cacheTimers[tileID.key]);
	                        delete this._cacheTimers[tileID.key];
	                        this._setTileReloadTimer(tileID.key, tile);
	                      }
	                    }
	                    var cached = Boolean(tile);
	                    if (!cached) {
	                      tile = new performance2.Tile(tileID, this._source.tileSize * tileID.overscaleFactor());
	                      this._loadTile(tile, this._tileLoaded.bind(this, tile, tileID.key, tile.state));
	                    }
	                    if (!tile) {
	                      return null;
	                    }
	                    tile.uses++;
	                    this._tiles[tileID.key] = tile;
	                    if (!cached) {
	                      this._source.fire(new performance2.Event("dataloading", {
	                        tile,
	                        coord: tile.tileID,
	                        dataType: "source"
	                      }));
	                    }
	                    return tile;
	                  };
	                  SourceCache2.prototype._setTileReloadTimer = function _setTileReloadTimer(id, tile) {
	                    var this$1$1 = this;
	                    if (id in this._timers) {
	                      clearTimeout(this._timers[id]);
	                      delete this._timers[id];
	                    }
	                    var expiryTimeout = tile.getExpiryTimeout();
	                    if (expiryTimeout) {
	                      this._timers[id] = setTimeout(function() {
	                        this$1$1._reloadTile(id, "expired");
	                        delete this$1$1._timers[id];
	                      }, expiryTimeout);
	                    }
	                  };
	                  SourceCache2.prototype._removeTile = function _removeTile(id) {
	                    var tile = this._tiles[id];
	                    if (!tile) {
	                      return;
	                    }
	                    tile.uses--;
	                    delete this._tiles[id];
	                    if (this._timers[id]) {
	                      clearTimeout(this._timers[id]);
	                      delete this._timers[id];
	                    }
	                    if (tile.uses > 0) {
	                      return;
	                    }
	                    if (tile.hasData() && tile.state !== "reloading") {
	                      this._cache.add(tile.tileID, tile, tile.getExpiryTimeout());
	                    } else {
	                      tile.aborted = true;
	                      this._abortTile(tile);
	                      this._unloadTile(tile);
	                    }
	                  };
	                  SourceCache2.prototype.clearTiles = function clearTiles() {
	                    this._shouldReloadOnResume = false;
	                    this._paused = false;
	                    for (var id in this._tiles) {
	                      this._removeTile(id);
	                    }
	                    this._cache.reset();
	                  };
	                  SourceCache2.prototype.tilesIn = function tilesIn(pointQueryGeometry, maxPitchScaleFactor, has3DLayer) {
	                    var this$1$1 = this;
	                    var tileResults = [];
	                    var transform = this.transform;
	                    if (!transform) {
	                      return tileResults;
	                    }
	                    var cameraPointQueryGeometry = has3DLayer ? transform.getCameraQueryGeometry(pointQueryGeometry) : pointQueryGeometry;
	                    var queryGeometry = pointQueryGeometry.map(function(p2) {
	                      return transform.pointCoordinate(p2);
	                    });
	                    var cameraQueryGeometry = cameraPointQueryGeometry.map(function(p2) {
	                      return transform.pointCoordinate(p2);
	                    });
	                    var ids = this.getIds();
	                    var minX = Infinity;
	                    var minY = Infinity;
	                    var maxX = -Infinity;
	                    var maxY = -Infinity;
	                    for (var i$1 = 0, list = cameraQueryGeometry; i$1 < list.length; i$1 += 1) {
	                      var p = list[i$1];
	                      minX = Math.min(minX, p.x);
	                      minY = Math.min(minY, p.y);
	                      maxX = Math.max(maxX, p.x);
	                      maxY = Math.max(maxY, p.y);
	                    }
	                    var loop = function(i2) {
	                      var tile = this$1$1._tiles[ids[i2]];
	                      if (tile.holdingForFade()) {
	                        return;
	                      }
	                      var tileID = tile.tileID;
	                      var scale = Math.pow(2, transform.zoom - tile.tileID.overscaledZ);
	                      var queryPadding = maxPitchScaleFactor * tile.queryPadding * performance2.EXTENT / tile.tileSize / scale;
	                      var tileSpaceBounds = [
	                        tileID.getTilePoint(new performance2.MercatorCoordinate(minX, minY)),
	                        tileID.getTilePoint(new performance2.MercatorCoordinate(maxX, maxY))
	                      ];
	                      if (tileSpaceBounds[0].x - queryPadding < performance2.EXTENT && tileSpaceBounds[0].y - queryPadding < performance2.EXTENT && tileSpaceBounds[1].x + queryPadding >= 0 && tileSpaceBounds[1].y + queryPadding >= 0) {
	                        var tileSpaceQueryGeometry = queryGeometry.map(function(c) {
	                          return tileID.getTilePoint(c);
	                        });
	                        var tileSpaceCameraQueryGeometry = cameraQueryGeometry.map(function(c) {
	                          return tileID.getTilePoint(c);
	                        });
	                        tileResults.push({
	                          tile,
	                          tileID,
	                          queryGeometry: tileSpaceQueryGeometry,
	                          cameraQueryGeometry: tileSpaceCameraQueryGeometry,
	                          scale
	                        });
	                      }
	                    };
	                    for (var i = 0; i < ids.length; i++)
	                      loop(i);
	                    return tileResults;
	                  };
	                  SourceCache2.prototype.getVisibleCoordinates = function getVisibleCoordinates(symbolLayer) {
	                    var this$1$1 = this;
	                    var coords = this.getRenderableIds(symbolLayer).map(function(id) {
	                      return this$1$1._tiles[id].tileID;
	                    });
	                    for (var i = 0, list = coords; i < list.length; i += 1) {
	                      var coord = list[i];
	                      coord.posMatrix = this.transform.calculatePosMatrix(coord.toUnwrapped());
	                    }
	                    return coords;
	                  };
	                  SourceCache2.prototype.hasTransition = function hasTransition() {
	                    if (this._source.hasTransition()) {
	                      return true;
	                    }
	                    if (isRasterType(this._source.type)) {
	                      for (var id in this._tiles) {
	                        var tile = this._tiles[id];
	                        if (tile.fadeEndTime !== undefined && tile.fadeEndTime >= performance2.browser.now()) {
	                          return true;
	                        }
	                      }
	                    }
	                    return false;
	                  };
	                  SourceCache2.prototype.setFeatureState = function setFeatureState(sourceLayer, featureId, state) {
	                    sourceLayer = sourceLayer || "_geojsonTileLayer";
	                    this._state.updateState(sourceLayer, featureId, state);
	                  };
	                  SourceCache2.prototype.removeFeatureState = function removeFeatureState(sourceLayer, featureId, key) {
	                    sourceLayer = sourceLayer || "_geojsonTileLayer";
	                    this._state.removeFeatureState(sourceLayer, featureId, key);
	                  };
	                  SourceCache2.prototype.getFeatureState = function getFeatureState(sourceLayer, featureId) {
	                    sourceLayer = sourceLayer || "_geojsonTileLayer";
	                    return this._state.getState(sourceLayer, featureId);
	                  };
	                  SourceCache2.prototype.setDependencies = function setDependencies(tileKey, namespace, dependencies) {
	                    var tile = this._tiles[tileKey];
	                    if (tile) {
	                      tile.setDependencies(namespace, dependencies);
	                    }
	                  };
	                  SourceCache2.prototype.reloadTilesForDependencies = function reloadTilesForDependencies(namespaces, keys) {
	                    for (var id in this._tiles) {
	                      var tile = this._tiles[id];
	                      if (tile.hasDependency(namespaces, keys)) {
	                        this._reloadTile(id, "reloading");
	                      }
	                    }
	                    this._cache.filter(function(tile2) {
	                      return !tile2.hasDependency(namespaces, keys);
	                    });
	                  };
	                  return SourceCache2;
	                }(performance2.Evented);
	                SourceCache.maxOverzooming = 10;
	                SourceCache.maxUnderzooming = 3;
	                function compareTileId(a, b) {
	                  var aWrap = Math.abs(a.wrap * 2) - +(a.wrap < 0);
	                  var bWrap = Math.abs(b.wrap * 2) - +(b.wrap < 0);
	                  return a.overscaledZ - b.overscaledZ || bWrap - aWrap || b.canonical.y - a.canonical.y || b.canonical.x - a.canonical.x;
	                }
	                function isRasterType(type) {
	                  return type === "raster" || type === "image" || type === "video";
	                }
	                function WebWorker() {
	                  return new performance2.window.Worker(exported.workerUrl);
	                }
	                var PRELOAD_POOL_ID = "mapboxgl_preloaded_worker_pool";
	                var WorkerPool = function WorkerPool2() {
	                  this.active = {};
	                };
	                WorkerPool.prototype.acquire = function acquire(mapId) {
	                  if (!this.workers) {
	                    this.workers = [];
	                    while (this.workers.length < WorkerPool.workerCount) {
	                      this.workers.push(new WebWorker());
	                    }
	                  }
	                  this.active[mapId] = true;
	                  return this.workers.slice();
	                };
	                WorkerPool.prototype.release = function release(mapId) {
	                  delete this.active[mapId];
	                  if (this.numActive() === 0) {
	                    this.workers.forEach(function(w) {
	                      w.terminate();
	                    });
	                    this.workers = null;
	                  }
	                };
	                WorkerPool.prototype.isPreloaded = function isPreloaded() {
	                  return !!this.active[PRELOAD_POOL_ID];
	                };
	                WorkerPool.prototype.numActive = function numActive() {
	                  return Object.keys(this.active).length;
	                };
	                var availableLogicalProcessors = Math.floor(performance2.browser.hardwareConcurrency / 2);
	                WorkerPool.workerCount = Math.max(Math.min(availableLogicalProcessors, 6), 1);
	                var globalWorkerPool;
	                function getGlobalWorkerPool() {
	                  if (!globalWorkerPool) {
	                    globalWorkerPool = new WorkerPool();
	                  }
	                  return globalWorkerPool;
	                }
	                function prewarm() {
	                  var workerPool = getGlobalWorkerPool();
	                  workerPool.acquire(PRELOAD_POOL_ID);
	                }
	                function clearPrewarmedResources() {
	                  var pool = globalWorkerPool;
	                  if (pool) {
	                    if (pool.isPreloaded() && pool.numActive() === 1) {
	                      pool.release(PRELOAD_POOL_ID);
	                      globalWorkerPool = null;
	                    } else {
	                      console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()");
	                    }
	                  }
	                }
	                function deref(layer, parent) {
	                  var result = {};
	                  for (var k in layer) {
	                    if (k !== "ref") {
	                      result[k] = layer[k];
	                    }
	                  }
	                  performance2.refProperties.forEach(function(k2) {
	                    if (k2 in parent) {
	                      result[k2] = parent[k2];
	                    }
	                  });
	                  return result;
	                }
	                function derefLayers(layers) {
	                  layers = layers.slice();
	                  var map2 = /* @__PURE__ */ Object.create(null);
	                  for (var i = 0; i < layers.length; i++) {
	                    map2[layers[i].id] = layers[i];
	                  }
	                  for (var i$1 = 0; i$1 < layers.length; i$1++) {
	                    if ("ref" in layers[i$1]) {
	                      layers[i$1] = deref(layers[i$1], map2[layers[i$1].ref]);
	                    }
	                  }
	                  return layers;
	                }
	                function emptyStyle() {
	                  var style = {};
	                  var version = performance2.styleSpec["$version"];
	                  for (var styleKey in performance2.styleSpec["$root"]) {
	                    var spec = performance2.styleSpec["$root"][styleKey];
	                    if (spec.required) {
	                      var value = null;
	                      if (styleKey === "version") {
	                        value = version;
	                      } else {
	                        if (spec.type === "array") {
	                          value = [];
	                        } else {
	                          value = {};
	                        }
	                      }
	                      if (value != null) {
	                        style[styleKey] = value;
	                      }
	                    }
	                  }
	                  return style;
	                }
	                var operations = {
	                  setStyle: "setStyle",
	                  addLayer: "addLayer",
	                  removeLayer: "removeLayer",
	                  setPaintProperty: "setPaintProperty",
	                  setLayoutProperty: "setLayoutProperty",
	                  setFilter: "setFilter",
	                  addSource: "addSource",
	                  removeSource: "removeSource",
	                  setGeoJSONSourceData: "setGeoJSONSourceData",
	                  setLayerZoomRange: "setLayerZoomRange",
	                  setLayerProperty: "setLayerProperty",
	                  setCenter: "setCenter",
	                  setZoom: "setZoom",
	                  setBearing: "setBearing",
	                  setPitch: "setPitch",
	                  setSprite: "setSprite",
	                  setGlyphs: "setGlyphs",
	                  setTransition: "setTransition",
	                  setLight: "setLight"
	                };
	                function addSource(sourceId, after, commands) {
	                  commands.push({
	                    command: operations.addSource,
	                    args: [
	                      sourceId,
	                      after[sourceId]
	                    ]
	                  });
	                }
	                function removeSource(sourceId, commands, sourcesRemoved) {
	                  commands.push({
	                    command: operations.removeSource,
	                    args: [sourceId]
	                  });
	                  sourcesRemoved[sourceId] = true;
	                }
	                function updateSource(sourceId, after, commands, sourcesRemoved) {
	                  removeSource(sourceId, commands, sourcesRemoved);
	                  addSource(sourceId, after, commands);
	                }
	                function canUpdateGeoJSON(before, after, sourceId) {
	                  var prop;
	                  for (prop in before[sourceId]) {
	                    if (!before[sourceId].hasOwnProperty(prop)) {
	                      continue;
	                    }
	                    if (prop !== "data" && !performance2.deepEqual(before[sourceId][prop], after[sourceId][prop])) {
	                      return false;
	                    }
	                  }
	                  for (prop in after[sourceId]) {
	                    if (!after[sourceId].hasOwnProperty(prop)) {
	                      continue;
	                    }
	                    if (prop !== "data" && !performance2.deepEqual(before[sourceId][prop], after[sourceId][prop])) {
	                      return false;
	                    }
	                  }
	                  return true;
	                }
	                function diffSources(before, after, commands, sourcesRemoved) {
	                  before = before || {};
	                  after = after || {};
	                  var sourceId;
	                  for (sourceId in before) {
	                    if (!before.hasOwnProperty(sourceId)) {
	                      continue;
	                    }
	                    if (!after.hasOwnProperty(sourceId)) {
	                      removeSource(sourceId, commands, sourcesRemoved);
	                    }
	                  }
	                  for (sourceId in after) {
	                    if (!after.hasOwnProperty(sourceId)) {
	                      continue;
	                    }
	                    if (!before.hasOwnProperty(sourceId)) {
	                      addSource(sourceId, after, commands);
	                    } else if (!performance2.deepEqual(before[sourceId], after[sourceId])) {
	                      if (before[sourceId].type === "geojson" && after[sourceId].type === "geojson" && canUpdateGeoJSON(before, after, sourceId)) {
	                        commands.push({
	                          command: operations.setGeoJSONSourceData,
	                          args: [
	                            sourceId,
	                            after[sourceId].data
	                          ]
	                        });
	                      } else {
	                        updateSource(sourceId, after, commands, sourcesRemoved);
	                      }
	                    }
	                  }
	                }
	                function diffLayerPropertyChanges(before, after, commands, layerId, klass, command) {
	                  before = before || {};
	                  after = after || {};
	                  var prop;
	                  for (prop in before) {
	                    if (!before.hasOwnProperty(prop)) {
	                      continue;
	                    }
	                    if (!performance2.deepEqual(before[prop], after[prop])) {
	                      commands.push({
	                        command,
	                        args: [
	                          layerId,
	                          prop,
	                          after[prop],
	                          klass
	                        ]
	                      });
	                    }
	                  }
	                  for (prop in after) {
	                    if (!after.hasOwnProperty(prop) || before.hasOwnProperty(prop)) {
	                      continue;
	                    }
	                    if (!performance2.deepEqual(before[prop], after[prop])) {
	                      commands.push({
	                        command,
	                        args: [
	                          layerId,
	                          prop,
	                          after[prop],
	                          klass
	                        ]
	                      });
	                    }
	                  }
	                }
	                function pluckId(layer) {
	                  return layer.id;
	                }
	                function indexById(group, layer) {
	                  group[layer.id] = layer;
	                  return group;
	                }
	                function diffLayers(before, after, commands) {
	                  before = before || [];
	                  after = after || [];
	                  var beforeOrder = before.map(pluckId);
	                  var afterOrder = after.map(pluckId);
	                  var beforeIndex = before.reduce(indexById, {});
	                  var afterIndex = after.reduce(indexById, {});
	                  var tracker = beforeOrder.slice();
	                  var clean = /* @__PURE__ */ Object.create(null);
	                  var i, d, layerId, beforeLayer, afterLayer, insertBeforeLayerId, prop;
	                  for (i = 0, d = 0; i < beforeOrder.length; i++) {
	                    layerId = beforeOrder[i];
	                    if (!afterIndex.hasOwnProperty(layerId)) {
	                      commands.push({
	                        command: operations.removeLayer,
	                        args: [layerId]
	                      });
	                      tracker.splice(tracker.indexOf(layerId, d), 1);
	                    } else {
	                      d++;
	                    }
	                  }
	                  for (i = 0, d = 0; i < afterOrder.length; i++) {
	                    layerId = afterOrder[afterOrder.length - 1 - i];
	                    if (tracker[tracker.length - 1 - i] === layerId) {
	                      continue;
	                    }
	                    if (beforeIndex.hasOwnProperty(layerId)) {
	                      commands.push({
	                        command: operations.removeLayer,
	                        args: [layerId]
	                      });
	                      tracker.splice(tracker.lastIndexOf(layerId, tracker.length - d), 1);
	                    } else {
	                      d++;
	                    }
	                    insertBeforeLayerId = tracker[tracker.length - i];
	                    commands.push({
	                      command: operations.addLayer,
	                      args: [
	                        afterIndex[layerId],
	                        insertBeforeLayerId
	                      ]
	                    });
	                    tracker.splice(tracker.length - i, 0, layerId);
	                    clean[layerId] = true;
	                  }
	                  for (i = 0; i < afterOrder.length; i++) {
	                    layerId = afterOrder[i];
	                    beforeLayer = beforeIndex[layerId];
	                    afterLayer = afterIndex[layerId];
	                    if (clean[layerId] || performance2.deepEqual(beforeLayer, afterLayer)) {
	                      continue;
	                    }
	                    if (!performance2.deepEqual(beforeLayer.source, afterLayer.source) || !performance2.deepEqual(beforeLayer["source-layer"], afterLayer["source-layer"]) || !performance2.deepEqual(beforeLayer.type, afterLayer.type)) {
	                      commands.push({
	                        command: operations.removeLayer,
	                        args: [layerId]
	                      });
	                      insertBeforeLayerId = tracker[tracker.lastIndexOf(layerId) + 1];
	                      commands.push({
	                        command: operations.addLayer,
	                        args: [
	                          afterLayer,
	                          insertBeforeLayerId
	                        ]
	                      });
	                      continue;
	                    }
	                    diffLayerPropertyChanges(beforeLayer.layout, afterLayer.layout, commands, layerId, null, operations.setLayoutProperty);
	                    diffLayerPropertyChanges(beforeLayer.paint, afterLayer.paint, commands, layerId, null, operations.setPaintProperty);
	                    if (!performance2.deepEqual(beforeLayer.filter, afterLayer.filter)) {
	                      commands.push({
	                        command: operations.setFilter,
	                        args: [
	                          layerId,
	                          afterLayer.filter
	                        ]
	                      });
	                    }
	                    if (!performance2.deepEqual(beforeLayer.minzoom, afterLayer.minzoom) || !performance2.deepEqual(beforeLayer.maxzoom, afterLayer.maxzoom)) {
	                      commands.push({
	                        command: operations.setLayerZoomRange,
	                        args: [
	                          layerId,
	                          afterLayer.minzoom,
	                          afterLayer.maxzoom
	                        ]
	                      });
	                    }
	                    for (prop in beforeLayer) {
	                      if (!beforeLayer.hasOwnProperty(prop)) {
	                        continue;
	                      }
	                      if (prop === "layout" || prop === "paint" || prop === "filter" || prop === "metadata" || prop === "minzoom" || prop === "maxzoom") {
	                        continue;
	                      }
	                      if (prop.indexOf("paint.") === 0) {
	                        diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), operations.setPaintProperty);
	                      } else if (!performance2.deepEqual(beforeLayer[prop], afterLayer[prop])) {
	                        commands.push({
	                          command: operations.setLayerProperty,
	                          args: [
	                            layerId,
	                            prop,
	                            afterLayer[prop]
	                          ]
	                        });
	                      }
	                    }
	                    for (prop in afterLayer) {
	                      if (!afterLayer.hasOwnProperty(prop) || beforeLayer.hasOwnProperty(prop)) {
	                        continue;
	                      }
	                      if (prop === "layout" || prop === "paint" || prop === "filter" || prop === "metadata" || prop === "minzoom" || prop === "maxzoom") {
	                        continue;
	                      }
	                      if (prop.indexOf("paint.") === 0) {
	                        diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), operations.setPaintProperty);
	                      } else if (!performance2.deepEqual(beforeLayer[prop], afterLayer[prop])) {
	                        commands.push({
	                          command: operations.setLayerProperty,
	                          args: [
	                            layerId,
	                            prop,
	                            afterLayer[prop]
	                          ]
	                        });
	                      }
	                    }
	                  }
	                }
	                function diffStyles(before, after) {
	                  if (!before) {
	                    return [{
	                      command: operations.setStyle,
	                      args: [after]
	                    }];
	                  }
	                  var commands = [];
	                  try {
	                    if (!performance2.deepEqual(before.version, after.version)) {
	                      return [{
	                        command: operations.setStyle,
	                        args: [after]
	                      }];
	                    }
	                    if (!performance2.deepEqual(before.center, after.center)) {
	                      commands.push({
	                        command: operations.setCenter,
	                        args: [after.center]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.zoom, after.zoom)) {
	                      commands.push({
	                        command: operations.setZoom,
	                        args: [after.zoom]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.bearing, after.bearing)) {
	                      commands.push({
	                        command: operations.setBearing,
	                        args: [after.bearing]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.pitch, after.pitch)) {
	                      commands.push({
	                        command: operations.setPitch,
	                        args: [after.pitch]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.sprite, after.sprite)) {
	                      commands.push({
	                        command: operations.setSprite,
	                        args: [after.sprite]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.glyphs, after.glyphs)) {
	                      commands.push({
	                        command: operations.setGlyphs,
	                        args: [after.glyphs]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.transition, after.transition)) {
	                      commands.push({
	                        command: operations.setTransition,
	                        args: [after.transition]
	                      });
	                    }
	                    if (!performance2.deepEqual(before.light, after.light)) {
	                      commands.push({
	                        command: operations.setLight,
	                        args: [after.light]
	                      });
	                    }
	                    var sourcesRemoved = {};
	                    var removeOrAddSourceCommands = [];
	                    diffSources(before.sources, after.sources, removeOrAddSourceCommands, sourcesRemoved);
	                    var beforeLayers = [];
	                    if (before.layers) {
	                      before.layers.forEach(function(layer) {
	                        if (sourcesRemoved[layer.source]) {
	                          commands.push({
	                            command: operations.removeLayer,
	                            args: [layer.id]
	                          });
	                        } else {
	                          beforeLayers.push(layer);
	                        }
	                      });
	                    }
	                    commands = commands.concat(removeOrAddSourceCommands);
	                    diffLayers(beforeLayers, after.layers, commands);
	                  } catch (e) {
	                    console.warn("Unable to compute style diff:", e);
	                    commands = [{
	                      command: operations.setStyle,
	                      args: [after]
	                    }];
	                  }
	                  return commands;
	                }
	                var PathInterpolator = function PathInterpolator2(points_, padding_) {
	                  this.reset(points_, padding_);
	                };
	                PathInterpolator.prototype.reset = function reset(points_, padding_) {
	                  this.points = points_ || [];
	                  this._distances = [0];
	                  for (var i = 1; i < this.points.length; i++) {
	                    this._distances[i] = this._distances[i - 1] + this.points[i].dist(this.points[i - 1]);
	                  }
	                  this.length = this._distances[this._distances.length - 1];
	                  this.padding = Math.min(padding_ || 0, this.length * 0.5);
	                  this.paddedLength = this.length - this.padding * 2;
	                };
	                PathInterpolator.prototype.lerp = function lerp(t) {
	                  if (this.points.length === 1) {
	                    return this.points[0];
	                  }
	                  t = performance2.clamp(t, 0, 1);
	                  var currentIndex = 1;
	                  var distOfCurrentIdx = this._distances[currentIndex];
	                  var distToTarget = t * this.paddedLength + this.padding;
	                  while (distOfCurrentIdx < distToTarget && currentIndex < this._distances.length) {
	                    distOfCurrentIdx = this._distances[++currentIndex];
	                  }
	                  var idxOfPrevPoint = currentIndex - 1;
	                  var distOfPrevIdx = this._distances[idxOfPrevPoint];
	                  var segmentLength = distOfCurrentIdx - distOfPrevIdx;
	                  var segmentT = segmentLength > 0 ? (distToTarget - distOfPrevIdx) / segmentLength : 0;
	                  return this.points[idxOfPrevPoint].mult(1 - segmentT).add(this.points[currentIndex].mult(segmentT));
	                };
	                var GridIndex = function GridIndex2(width, height, cellSize) {
	                  var boxCells = this.boxCells = [];
	                  var circleCells = this.circleCells = [];
	                  this.xCellCount = Math.ceil(width / cellSize);
	                  this.yCellCount = Math.ceil(height / cellSize);
	                  for (var i = 0; i < this.xCellCount * this.yCellCount; i++) {
	                    boxCells.push([]);
	                    circleCells.push([]);
	                  }
	                  this.circleKeys = [];
	                  this.boxKeys = [];
	                  this.bboxes = [];
	                  this.circles = [];
	                  this.width = width;
	                  this.height = height;
	                  this.xScale = this.xCellCount / width;
	                  this.yScale = this.yCellCount / height;
	                  this.boxUid = 0;
	                  this.circleUid = 0;
	                };
	                GridIndex.prototype.keysLength = function keysLength() {
	                  return this.boxKeys.length + this.circleKeys.length;
	                };
	                GridIndex.prototype.insert = function insert(key, x1, y1, x2, y2) {
	                  this._forEachCell(x1, y1, x2, y2, this._insertBoxCell, this.boxUid++);
	                  this.boxKeys.push(key);
	                  this.bboxes.push(x1);
	                  this.bboxes.push(y1);
	                  this.bboxes.push(x2);
	                  this.bboxes.push(y2);
	                };
	                GridIndex.prototype.insertCircle = function insertCircle(key, x, y, radius) {
	                  this._forEachCell(x - radius, y - radius, x + radius, y + radius, this._insertCircleCell, this.circleUid++);
	                  this.circleKeys.push(key);
	                  this.circles.push(x);
	                  this.circles.push(y);
	                  this.circles.push(radius);
	                };
	                GridIndex.prototype._insertBoxCell = function _insertBoxCell(x1, y1, x2, y2, cellIndex, uid) {
	                  this.boxCells[cellIndex].push(uid);
	                };
	                GridIndex.prototype._insertCircleCell = function _insertCircleCell(x1, y1, x2, y2, cellIndex, uid) {
	                  this.circleCells[cellIndex].push(uid);
	                };
	                GridIndex.prototype._query = function _query(x1, y1, x2, y2, hitTest, predicate) {
	                  if (x2 < 0 || x1 > this.width || y2 < 0 || y1 > this.height) {
	                    return hitTest ? false : [];
	                  }
	                  var result = [];
	                  if (x1 <= 0 && y1 <= 0 && this.width <= x2 && this.height <= y2) {
	                    if (hitTest) {
	                      return true;
	                    }
	                    for (var boxUid = 0; boxUid < this.boxKeys.length; boxUid++) {
	                      result.push({
	                        key: this.boxKeys[boxUid],
	                        x1: this.bboxes[boxUid * 4],
	                        y1: this.bboxes[boxUid * 4 + 1],
	                        x2: this.bboxes[boxUid * 4 + 2],
	                        y2: this.bboxes[boxUid * 4 + 3]
	                      });
	                    }
	                    for (var circleUid = 0; circleUid < this.circleKeys.length; circleUid++) {
	                      var x = this.circles[circleUid * 3];
	                      var y = this.circles[circleUid * 3 + 1];
	                      var radius = this.circles[circleUid * 3 + 2];
	                      result.push({
	                        key: this.circleKeys[circleUid],
	                        x1: x - radius,
	                        y1: y - radius,
	                        x2: x + radius,
	                        y2: y + radius
	                      });
	                    }
	                    return predicate ? result.filter(predicate) : result;
	                  } else {
	                    var queryArgs = {
	                      hitTest,
	                      seenUids: {
	                        box: {},
	                        circle: {}
	                      }
	                    };
	                    this._forEachCell(x1, y1, x2, y2, this._queryCell, result, queryArgs, predicate);
	                    return hitTest ? result.length > 0 : result;
	                  }
	                };
	                GridIndex.prototype._queryCircle = function _queryCircle(x, y, radius, hitTest, predicate) {
	                  var x1 = x - radius;
	                  var x2 = x + radius;
	                  var y1 = y - radius;
	                  var y2 = y + radius;
	                  if (x2 < 0 || x1 > this.width || y2 < 0 || y1 > this.height) {
	                    return hitTest ? false : [];
	                  }
	                  var result = [];
	                  var queryArgs = {
	                    hitTest,
	                    circle: {
	                      x,
	                      y,
	                      radius
	                    },
	                    seenUids: {
	                      box: {},
	                      circle: {}
	                    }
	                  };
	                  this._forEachCell(x1, y1, x2, y2, this._queryCellCircle, result, queryArgs, predicate);
	                  return hitTest ? result.length > 0 : result;
	                };
	                GridIndex.prototype.query = function query(x1, y1, x2, y2, predicate) {
	                  return this._query(x1, y1, x2, y2, false, predicate);
	                };
	                GridIndex.prototype.hitTest = function hitTest(x1, y1, x2, y2, predicate) {
	                  return this._query(x1, y1, x2, y2, true, predicate);
	                };
	                GridIndex.prototype.hitTestCircle = function hitTestCircle(x, y, radius, predicate) {
	                  return this._queryCircle(x, y, radius, true, predicate);
	                };
	                GridIndex.prototype._queryCell = function _queryCell(x1, y1, x2, y2, cellIndex, result, queryArgs, predicate) {
	                  var seenUids = queryArgs.seenUids;
	                  var boxCell = this.boxCells[cellIndex];
	                  if (boxCell !== null) {
	                    var bboxes = this.bboxes;
	                    for (var i = 0, list = boxCell; i < list.length; i += 1) {
	                      var boxUid = list[i];
	                      if (!seenUids.box[boxUid]) {
	                        seenUids.box[boxUid] = true;
	                        var offset = boxUid * 4;
	                        if (x1 <= bboxes[offset + 2] && y1 <= bboxes[offset + 3] && x2 >= bboxes[offset + 0] && y2 >= bboxes[offset + 1] && (!predicate || predicate(this.boxKeys[boxUid]))) {
	                          if (queryArgs.hitTest) {
	                            result.push(true);
	                            return true;
	                          } else {
	                            result.push({
	                              key: this.boxKeys[boxUid],
	                              x1: bboxes[offset],
	                              y1: bboxes[offset + 1],
	                              x2: bboxes[offset + 2],
	                              y2: bboxes[offset + 3]
	                            });
	                          }
	                        }
	                      }
	                    }
	                  }
	                  var circleCell = this.circleCells[cellIndex];
	                  if (circleCell !== null) {
	                    var circles = this.circles;
	                    for (var i$1 = 0, list$1 = circleCell; i$1 < list$1.length; i$1 += 1) {
	                      var circleUid = list$1[i$1];
	                      if (!seenUids.circle[circleUid]) {
	                        seenUids.circle[circleUid] = true;
	                        var offset$1 = circleUid * 3;
	                        if (this._circleAndRectCollide(circles[offset$1], circles[offset$1 + 1], circles[offset$1 + 2], x1, y1, x2, y2) && (!predicate || predicate(this.circleKeys[circleUid]))) {
	                          if (queryArgs.hitTest) {
	                            result.push(true);
	                            return true;
	                          } else {
	                            var x = circles[offset$1];
	                            var y = circles[offset$1 + 1];
	                            var radius = circles[offset$1 + 2];
	                            result.push({
	                              key: this.circleKeys[circleUid],
	                              x1: x - radius,
	                              y1: y - radius,
	                              x2: x + radius,
	                              y2: y + radius
	                            });
	                          }
	                        }
	                      }
	                    }
	                  }
	                };
	                GridIndex.prototype._queryCellCircle = function _queryCellCircle(x1, y1, x2, y2, cellIndex, result, queryArgs, predicate) {
	                  var circle2 = queryArgs.circle;
	                  var seenUids = queryArgs.seenUids;
	                  var boxCell = this.boxCells[cellIndex];
	                  if (boxCell !== null) {
	                    var bboxes = this.bboxes;
	                    for (var i = 0, list = boxCell; i < list.length; i += 1) {
	                      var boxUid = list[i];
	                      if (!seenUids.box[boxUid]) {
	                        seenUids.box[boxUid] = true;
	                        var offset = boxUid * 4;
	                        if (this._circleAndRectCollide(circle2.x, circle2.y, circle2.radius, bboxes[offset + 0], bboxes[offset + 1], bboxes[offset + 2], bboxes[offset + 3]) && (!predicate || predicate(this.boxKeys[boxUid]))) {
	                          result.push(true);
	                          return true;
	                        }
	                      }
	                    }
	                  }
	                  var circleCell = this.circleCells[cellIndex];
	                  if (circleCell !== null) {
	                    var circles = this.circles;
	                    for (var i$1 = 0, list$1 = circleCell; i$1 < list$1.length; i$1 += 1) {
	                      var circleUid = list$1[i$1];
	                      if (!seenUids.circle[circleUid]) {
	                        seenUids.circle[circleUid] = true;
	                        var offset$1 = circleUid * 3;
	                        if (this._circlesCollide(circles[offset$1], circles[offset$1 + 1], circles[offset$1 + 2], circle2.x, circle2.y, circle2.radius) && (!predicate || predicate(this.circleKeys[circleUid]))) {
	                          result.push(true);
	                          return true;
	                        }
	                      }
	                    }
	                  }
	                };
	                GridIndex.prototype._forEachCell = function _forEachCell(x1, y1, x2, y2, fn, arg1, arg2, predicate) {
	                  var cx1 = this._convertToXCellCoord(x1);
	                  var cy1 = this._convertToYCellCoord(y1);
	                  var cx2 = this._convertToXCellCoord(x2);
	                  var cy2 = this._convertToYCellCoord(y2);
	                  for (var x = cx1; x <= cx2; x++) {
	                    for (var y = cy1; y <= cy2; y++) {
	                      var cellIndex = this.xCellCount * y + x;
	                      if (fn.call(this, x1, y1, x2, y2, cellIndex, arg1, arg2, predicate)) {
	                        return;
	                      }
	                    }
	                  }
	                };
	                GridIndex.prototype._convertToXCellCoord = function _convertToXCellCoord(x) {
	                  return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(x * this.xScale)));
	                };
	                GridIndex.prototype._convertToYCellCoord = function _convertToYCellCoord(y) {
	                  return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(y * this.yScale)));
	                };
	                GridIndex.prototype._circlesCollide = function _circlesCollide(x1, y1, r1, x2, y2, r2) {
	                  var dx = x2 - x1;
	                  var dy = y2 - y1;
	                  var bothRadii = r1 + r2;
	                  return bothRadii * bothRadii > dx * dx + dy * dy;
	                };
	                GridIndex.prototype._circleAndRectCollide = function _circleAndRectCollide(circleX, circleY, radius, x1, y1, x2, y2) {
	                  var halfRectWidth = (x2 - x1) / 2;
	                  var distX = Math.abs(circleX - (x1 + halfRectWidth));
	                  if (distX > halfRectWidth + radius) {
	                    return false;
	                  }
	                  var halfRectHeight = (y2 - y1) / 2;
	                  var distY = Math.abs(circleY - (y1 + halfRectHeight));
	                  if (distY > halfRectHeight + radius) {
	                    return false;
	                  }
	                  if (distX <= halfRectWidth || distY <= halfRectHeight) {
	                    return true;
	                  }
	                  var dx = distX - halfRectWidth;
	                  var dy = distY - halfRectHeight;
	                  return dx * dx + dy * dy <= radius * radius;
	                };
	                function getLabelPlaneMatrix(posMatrix, pitchWithMap, rotateWithMap, transform, pixelsToTileUnits2) {
	                  var m = performance2.create();
	                  if (pitchWithMap) {
	                    performance2.scale(m, m, [
	                      1 / pixelsToTileUnits2,
	                      1 / pixelsToTileUnits2,
	                      1
	                    ]);
	                    if (!rotateWithMap) {
	                      performance2.rotateZ(m, m, transform.angle);
	                    }
	                  } else {
	                    performance2.multiply(m, transform.labelPlaneMatrix, posMatrix);
	                  }
	                  return m;
	                }
	                function getGlCoordMatrix(posMatrix, pitchWithMap, rotateWithMap, transform, pixelsToTileUnits2) {
	                  if (pitchWithMap) {
	                    var m = performance2.clone(posMatrix);
	                    performance2.scale(m, m, [
	                      pixelsToTileUnits2,
	                      pixelsToTileUnits2,
	                      1
	                    ]);
	                    if (!rotateWithMap) {
	                      performance2.rotateZ(m, m, -transform.angle);
	                    }
	                    return m;
	                  } else {
	                    return transform.glCoordMatrix;
	                  }
	                }
	                function project(point, matrix) {
	                  var pos = [
	                    point.x,
	                    point.y,
	                    0,
	                    1
	                  ];
	                  xyTransformMat4(pos, pos, matrix);
	                  var w = pos[3];
	                  return {
	                    point: new performance2.Point(pos[0] / w, pos[1] / w),
	                    signedDistanceFromCamera: w
	                  };
	                }
	                function getPerspectiveRatio(cameraToCenterDistance, signedDistanceFromCamera) {
	                  return 0.5 + 0.5 * (cameraToCenterDistance / signedDistanceFromCamera);
	                }
	                function isVisible(anchorPos, clippingBuffer) {
	                  var x = anchorPos[0] / anchorPos[3];
	                  var y = anchorPos[1] / anchorPos[3];
	                  var inPaddedViewport = x >= -clippingBuffer[0] && x <= clippingBuffer[0] && y >= -clippingBuffer[1] && y <= clippingBuffer[1];
	                  return inPaddedViewport;
	                }
	                function updateLineLabels(bucket, posMatrix, painter, isText, labelPlaneMatrix, glCoordMatrix, pitchWithMap, keepUpright) {
	                  var sizeData = isText ? bucket.textSizeData : bucket.iconSizeData;
	                  var partiallyEvaluatedSize = performance2.evaluateSizeForZoom(sizeData, painter.transform.zoom);
	                  var clippingBuffer = [
	                    256 / painter.width * 2 + 1,
	                    256 / painter.height * 2 + 1
	                  ];
	                  var dynamicLayoutVertexArray = isText ? bucket.text.dynamicLayoutVertexArray : bucket.icon.dynamicLayoutVertexArray;
	                  dynamicLayoutVertexArray.clear();
	                  var lineVertexArray = bucket.lineVertexArray;
	                  var placedSymbols = isText ? bucket.text.placedSymbolArray : bucket.icon.placedSymbolArray;
	                  var aspectRatio = painter.transform.width / painter.transform.height;
	                  var useVertical = false;
	                  for (var s = 0; s < placedSymbols.length; s++) {
	                    var symbol = placedSymbols.get(s);
	                    if (symbol.hidden || symbol.writingMode === performance2.WritingMode.vertical && !useVertical) {
	                      hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
	                      continue;
	                    }
	                    useVertical = false;
	                    var anchorPos = [
	                      symbol.anchorX,
	                      symbol.anchorY,
	                      0,
	                      1
	                    ];
	                    performance2.transformMat4(anchorPos, anchorPos, posMatrix);
	                    if (!isVisible(anchorPos, clippingBuffer)) {
	                      hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
	                      continue;
	                    }
	                    var cameraToAnchorDistance = anchorPos[3];
	                    var perspectiveRatio = getPerspectiveRatio(painter.transform.cameraToCenterDistance, cameraToAnchorDistance);
	                    var fontSize = performance2.evaluateSizeForFeature(sizeData, partiallyEvaluatedSize, symbol);
	                    var pitchScaledFontSize = pitchWithMap ? fontSize / perspectiveRatio : fontSize * perspectiveRatio;
	                    var tileAnchorPoint = new performance2.Point(symbol.anchorX, symbol.anchorY);
	                    var anchorPoint = project(tileAnchorPoint, labelPlaneMatrix).point;
	                    var projectionCache = {};
	                    var placeUnflipped = placeGlyphsAlongLine(symbol, pitchScaledFontSize, false, keepUpright, posMatrix, labelPlaneMatrix, glCoordMatrix, bucket.glyphOffsetArray, lineVertexArray, dynamicLayoutVertexArray, anchorPoint, tileAnchorPoint, projectionCache, aspectRatio);
	                    useVertical = placeUnflipped.useVertical;
	                    if (placeUnflipped.notEnoughRoom || useVertical || placeUnflipped.needsFlipping && placeGlyphsAlongLine(symbol, pitchScaledFontSize, true, keepUpright, posMatrix, labelPlaneMatrix, glCoordMatrix, bucket.glyphOffsetArray, lineVertexArray, dynamicLayoutVertexArray, anchorPoint, tileAnchorPoint, projectionCache, aspectRatio).notEnoughRoom) {
	                      hideGlyphs(symbol.numGlyphs, dynamicLayoutVertexArray);
	                    }
	                  }
	                  if (isText) {
	                    bucket.text.dynamicLayoutVertexBuffer.updateData(dynamicLayoutVertexArray);
	                  } else {
	                    bucket.icon.dynamicLayoutVertexBuffer.updateData(dynamicLayoutVertexArray);
	                  }
	                }
	                function placeFirstAndLastGlyph(fontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol, lineVertexArray, labelPlaneMatrix, projectionCache) {
	                  var glyphEndIndex = symbol.glyphStartIndex + symbol.numGlyphs;
	                  var lineStartIndex = symbol.lineStartIndex;
	                  var lineEndIndex = symbol.lineStartIndex + symbol.lineLength;
	                  var firstGlyphOffset = glyphOffsetArray.getoffsetX(symbol.glyphStartIndex);
	                  var lastGlyphOffset = glyphOffsetArray.getoffsetX(glyphEndIndex - 1);
	                  var firstPlacedGlyph = placeGlyphAlongLine(fontScale * firstGlyphOffset, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache);
	                  if (!firstPlacedGlyph) {
	                    return null;
	                  }
	                  var lastPlacedGlyph = placeGlyphAlongLine(fontScale * lastGlyphOffset, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache);
	                  if (!lastPlacedGlyph) {
	                    return null;
	                  }
	                  return {
	                    first: firstPlacedGlyph,
	                    last: lastPlacedGlyph
	                  };
	                }
	                function requiresOrientationChange(writingMode, firstPoint, lastPoint, aspectRatio) {
	                  if (writingMode === performance2.WritingMode.horizontal) {
	                    var rise = Math.abs(lastPoint.y - firstPoint.y);
	                    var run = Math.abs(lastPoint.x - firstPoint.x) * aspectRatio;
	                    if (rise > run) {
	                      return { useVertical: true };
	                    }
	                  }
	                  if (writingMode === performance2.WritingMode.vertical ? firstPoint.y < lastPoint.y : firstPoint.x > lastPoint.x) {
	                    return { needsFlipping: true };
	                  }
	                  return null;
	                }
	                function placeGlyphsAlongLine(symbol, fontSize, flip, keepUpright, posMatrix, labelPlaneMatrix, glCoordMatrix, glyphOffsetArray, lineVertexArray, dynamicLayoutVertexArray, anchorPoint, tileAnchorPoint, projectionCache, aspectRatio) {
	                  var fontScale = fontSize / 24;
	                  var lineOffsetX = symbol.lineOffsetX * fontScale;
	                  var lineOffsetY = symbol.lineOffsetY * fontScale;
	                  var placedGlyphs;
	                  if (symbol.numGlyphs > 1) {
	                    var glyphEndIndex = symbol.glyphStartIndex + symbol.numGlyphs;
	                    var lineStartIndex = symbol.lineStartIndex;
	                    var lineEndIndex = symbol.lineStartIndex + symbol.lineLength;
	                    var firstAndLastGlyph = placeFirstAndLastGlyph(fontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol, lineVertexArray, labelPlaneMatrix, projectionCache);
	                    if (!firstAndLastGlyph) {
	                      return { notEnoughRoom: true };
	                    }
	                    var firstPoint = project(firstAndLastGlyph.first.point, glCoordMatrix).point;
	                    var lastPoint = project(firstAndLastGlyph.last.point, glCoordMatrix).point;
	                    if (keepUpright && !flip) {
	                      var orientationChange = requiresOrientationChange(symbol.writingMode, firstPoint, lastPoint, aspectRatio);
	                      if (orientationChange) {
	                        return orientationChange;
	                      }
	                    }
	                    placedGlyphs = [firstAndLastGlyph.first];
	                    for (var glyphIndex = symbol.glyphStartIndex + 1; glyphIndex < glyphEndIndex - 1; glyphIndex++) {
	                      placedGlyphs.push(placeGlyphAlongLine(fontScale * glyphOffsetArray.getoffsetX(glyphIndex), lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache));
	                    }
	                    placedGlyphs.push(firstAndLastGlyph.last);
	                  } else {
	                    if (keepUpright && !flip) {
	                      var a = project(tileAnchorPoint, posMatrix).point;
	                      var tileVertexIndex = symbol.lineStartIndex + symbol.segment + 1;
	                      var tileSegmentEnd = new performance2.Point(lineVertexArray.getx(tileVertexIndex), lineVertexArray.gety(tileVertexIndex));
	                      var projectedVertex = project(tileSegmentEnd, posMatrix);
	                      var b = projectedVertex.signedDistanceFromCamera > 0 ? projectedVertex.point : projectTruncatedLineSegment(tileAnchorPoint, tileSegmentEnd, a, 1, posMatrix);
	                      var orientationChange$1 = requiresOrientationChange(symbol.writingMode, a, b, aspectRatio);
	                      if (orientationChange$1) {
	                        return orientationChange$1;
	                      }
	                    }
	                    var singleGlyph = placeGlyphAlongLine(fontScale * glyphOffsetArray.getoffsetX(symbol.glyphStartIndex), lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, symbol.segment, symbol.lineStartIndex, symbol.lineStartIndex + symbol.lineLength, lineVertexArray, labelPlaneMatrix, projectionCache);
	                    if (!singleGlyph) {
	                      return { notEnoughRoom: true };
	                    }
	                    placedGlyphs = [singleGlyph];
	                  }
	                  for (var i = 0, list = placedGlyphs; i < list.length; i += 1) {
	                    var glyph = list[i];
	                    performance2.addDynamicAttributes(dynamicLayoutVertexArray, glyph.point, glyph.angle);
	                  }
	                  return {};
	                }
	                function projectTruncatedLineSegment(previousTilePoint, currentTilePoint, previousProjectedPoint, minimumLength, projectionMatrix) {
	                  var projectedUnitVertex = project(previousTilePoint.add(previousTilePoint.sub(currentTilePoint)._unit()), projectionMatrix).point;
	                  var projectedUnitSegment = previousProjectedPoint.sub(projectedUnitVertex);
	                  return previousProjectedPoint.add(projectedUnitSegment._mult(minimumLength / projectedUnitSegment.mag()));
	                }
	                function placeGlyphAlongLine(offsetX, lineOffsetX, lineOffsetY, flip, anchorPoint, tileAnchorPoint, anchorSegment, lineStartIndex, lineEndIndex, lineVertexArray, labelPlaneMatrix, projectionCache) {
	                  var combinedOffsetX = flip ? offsetX - lineOffsetX : offsetX + lineOffsetX;
	                  var dir = combinedOffsetX > 0 ? 1 : -1;
	                  var angle = 0;
	                  if (flip) {
	                    dir *= -1;
	                    angle = Math.PI;
	                  }
	                  if (dir < 0) {
	                    angle += Math.PI;
	                  }
	                  var currentIndex = dir > 0 ? lineStartIndex + anchorSegment : lineStartIndex + anchorSegment + 1;
	                  var current = anchorPoint;
	                  var prev = anchorPoint;
	                  var distanceToPrev = 0;
	                  var currentSegmentDistance = 0;
	                  var absOffsetX = Math.abs(combinedOffsetX);
	                  var pathVertices = [];
	                  while (distanceToPrev + currentSegmentDistance <= absOffsetX) {
	                    currentIndex += dir;
	                    if (currentIndex < lineStartIndex || currentIndex >= lineEndIndex) {
	                      return null;
	                    }
	                    prev = current;
	                    pathVertices.push(current);
	                    current = projectionCache[currentIndex];
	                    if (current === undefined) {
	                      var currentVertex = new performance2.Point(lineVertexArray.getx(currentIndex), lineVertexArray.gety(currentIndex));
	                      var projection = project(currentVertex, labelPlaneMatrix);
	                      if (projection.signedDistanceFromCamera > 0) {
	                        current = projectionCache[currentIndex] = projection.point;
	                      } else {
	                        var previousLineVertexIndex = currentIndex - dir;
	                        var previousTilePoint = distanceToPrev === 0 ? tileAnchorPoint : new performance2.Point(lineVertexArray.getx(previousLineVertexIndex), lineVertexArray.gety(previousLineVertexIndex));
	                        current = projectTruncatedLineSegment(previousTilePoint, currentVertex, prev, absOffsetX - distanceToPrev + 1, labelPlaneMatrix);
	                      }
	                    }
	                    distanceToPrev += currentSegmentDistance;
	                    currentSegmentDistance = prev.dist(current);
	                  }
	                  var segmentInterpolationT = (absOffsetX - distanceToPrev) / currentSegmentDistance;
	                  var prevToCurrent = current.sub(prev);
	                  var p = prevToCurrent.mult(segmentInterpolationT)._add(prev);
	                  p._add(prevToCurrent._unit()._perp()._mult(lineOffsetY * dir));
	                  var segmentAngle = angle + Math.atan2(current.y - prev.y, current.x - prev.x);
	                  pathVertices.push(p);
	                  return {
	                    point: p,
	                    angle: segmentAngle,
	                    path: pathVertices
	                  };
	                }
	                var hiddenGlyphAttributes = new Float32Array([
	                  -Infinity,
	                  -Infinity,
	                  0,
	                  -Infinity,
	                  -Infinity,
	                  0,
	                  -Infinity,
	                  -Infinity,
	                  0,
	                  -Infinity,
	                  -Infinity,
	                  0
	                ]);
	                function hideGlyphs(num, dynamicLayoutVertexArray) {
	                  for (var i = 0; i < num; i++) {
	                    var offset = dynamicLayoutVertexArray.length;
	                    dynamicLayoutVertexArray.resize(offset + 4);
	                    dynamicLayoutVertexArray.float32.set(hiddenGlyphAttributes, offset * 3);
	                  }
	                }
	                function xyTransformMat4(out, a, m) {
	                  var x = a[0], y = a[1];
	                  out[0] = m[0] * x + m[4] * y + m[12];
	                  out[1] = m[1] * x + m[5] * y + m[13];
	                  out[3] = m[3] * x + m[7] * y + m[15];
	                  return out;
	                }
	                var viewportPadding = 100;
	                var CollisionIndex = function CollisionIndex2(transform, grid, ignoredGrid) {
	                  if (grid === undefined)
	                    grid = new GridIndex(transform.width + 2 * viewportPadding, transform.height + 2 * viewportPadding, 25);
	                  if (ignoredGrid === undefined)
	                    ignoredGrid = new GridIndex(transform.width + 2 * viewportPadding, transform.height + 2 * viewportPadding, 25);
	                  this.transform = transform;
	                  this.grid = grid;
	                  this.ignoredGrid = ignoredGrid;
	                  this.pitchfactor = Math.cos(transform._pitch) * transform.cameraToCenterDistance;
	                  this.screenRightBoundary = transform.width + viewportPadding;
	                  this.screenBottomBoundary = transform.height + viewportPadding;
	                  this.gridRightBoundary = transform.width + 2 * viewportPadding;
	                  this.gridBottomBoundary = transform.height + 2 * viewportPadding;
	                };
	                CollisionIndex.prototype.placeCollisionBox = function placeCollisionBox(collisionBox2, allowOverlap, textPixelRatio, posMatrix, collisionGroupPredicate) {
	                  var projectedPoint = this.projectAndGetPerspectiveRatio(posMatrix, collisionBox2.anchorPointX, collisionBox2.anchorPointY);
	                  var tileToViewport = textPixelRatio * projectedPoint.perspectiveRatio;
	                  var tlX = collisionBox2.x1 * tileToViewport + projectedPoint.point.x;
	                  var tlY = collisionBox2.y1 * tileToViewport + projectedPoint.point.y;
	                  var brX = collisionBox2.x2 * tileToViewport + projectedPoint.point.x;
	                  var brY = collisionBox2.y2 * tileToViewport + projectedPoint.point.y;
	                  if (!this.isInsideGrid(tlX, tlY, brX, brY) || !allowOverlap && this.grid.hitTest(tlX, tlY, brX, brY, collisionGroupPredicate)) {
	                    return {
	                      box: [],
	                      offscreen: false
	                    };
	                  }
	                  return {
	                    box: [
	                      tlX,
	                      tlY,
	                      brX,
	                      brY
	                    ],
	                    offscreen: this.isOffscreen(tlX, tlY, brX, brY)
	                  };
	                };
	                CollisionIndex.prototype.placeCollisionCircles = function placeCollisionCircles(allowOverlap, symbol, lineVertexArray, glyphOffsetArray, fontSize, posMatrix, labelPlaneMatrix, labelToScreenMatrix, showCollisionCircles, pitchWithMap, collisionGroupPredicate, circlePixelDiameter, textPixelPadding) {
	                  var placedCollisionCircles = [];
	                  var tileUnitAnchorPoint = new performance2.Point(symbol.anchorX, symbol.anchorY);
	                  var screenAnchorPoint = project(tileUnitAnchorPoint, posMatrix);
	                  var perspectiveRatio = getPerspectiveRatio(this.transform.cameraToCenterDistance, screenAnchorPoint.signedDistanceFromCamera);
	                  var labelPlaneFontSize = pitchWithMap ? fontSize / perspectiveRatio : fontSize * perspectiveRatio;
	                  var labelPlaneFontScale = labelPlaneFontSize / performance2.ONE_EM;
	                  var labelPlaneAnchorPoint = project(tileUnitAnchorPoint, labelPlaneMatrix).point;
	                  var projectionCache = {};
	                  var lineOffsetX = symbol.lineOffsetX * labelPlaneFontScale;
	                  var lineOffsetY = symbol.lineOffsetY * labelPlaneFontScale;
	                  var firstAndLastGlyph = placeFirstAndLastGlyph(labelPlaneFontScale, glyphOffsetArray, lineOffsetX, lineOffsetY, false, labelPlaneAnchorPoint, tileUnitAnchorPoint, symbol, lineVertexArray, labelPlaneMatrix, projectionCache);
	                  var collisionDetected = false;
	                  var inGrid = false;
	                  var entirelyOffscreen = true;
	                  if (firstAndLastGlyph) {
	                    var radius = circlePixelDiameter * 0.5 * perspectiveRatio + textPixelPadding;
	                    var screenPlaneMin = new performance2.Point(-100, -100);
	                    var screenPlaneMax = new performance2.Point(this.screenRightBoundary, this.screenBottomBoundary);
	                    var interpolator = new PathInterpolator();
	                    var first = firstAndLastGlyph.first;
	                    var last = firstAndLastGlyph.last;
	                    var projectedPath = [];
	                    for (var i = first.path.length - 1; i >= 1; i--) {
	                      projectedPath.push(first.path[i]);
	                    }
	                    for (var i$1 = 1; i$1 < last.path.length; i$1++) {
	                      projectedPath.push(last.path[i$1]);
	                    }
	                    var circleDist = radius * 2.5;
	                    if (labelToScreenMatrix) {
	                      var screenSpacePath = projectedPath.map(function(p) {
	                        return project(p, labelToScreenMatrix);
	                      });
	                      if (screenSpacePath.some(function(point) {
	                        return point.signedDistanceFromCamera <= 0;
	                      })) {
	                        projectedPath = [];
	                      } else {
	                        projectedPath = screenSpacePath.map(function(p) {
	                          return p.point;
	                        });
	                      }
	                    }
	                    var segments = [];
	                    if (projectedPath.length > 0) {
	                      var minPoint = projectedPath[0].clone();
	                      var maxPoint = projectedPath[0].clone();
	                      for (var i$2 = 1; i$2 < projectedPath.length; i$2++) {
	                        minPoint.x = Math.min(minPoint.x, projectedPath[i$2].x);
	                        minPoint.y = Math.min(minPoint.y, projectedPath[i$2].y);
	                        maxPoint.x = Math.max(maxPoint.x, projectedPath[i$2].x);
	                        maxPoint.y = Math.max(maxPoint.y, projectedPath[i$2].y);
	                      }
	                      if (minPoint.x >= screenPlaneMin.x && maxPoint.x <= screenPlaneMax.x && minPoint.y >= screenPlaneMin.y && maxPoint.y <= screenPlaneMax.y) {
	                        segments = [projectedPath];
	                      } else if (maxPoint.x < screenPlaneMin.x || minPoint.x > screenPlaneMax.x || maxPoint.y < screenPlaneMin.y || minPoint.y > screenPlaneMax.y) {
	                        segments = [];
	                      } else {
	                        segments = performance2.clipLine([projectedPath], screenPlaneMin.x, screenPlaneMin.y, screenPlaneMax.x, screenPlaneMax.y);
	                      }
	                    }
	                    for (var i$4 = 0, list = segments; i$4 < list.length; i$4 += 1) {
	                      var seg = list[i$4];
	                      interpolator.reset(seg, radius * 0.25);
	                      var numCircles = 0;
	                      if (interpolator.length <= 0.5 * radius) {
	                        numCircles = 1;
	                      } else {
	                        numCircles = Math.ceil(interpolator.paddedLength / circleDist) + 1;
	                      }
	                      for (var i$3 = 0; i$3 < numCircles; i$3++) {
	                        var t = i$3 / Math.max(numCircles - 1, 1);
	                        var circlePosition = interpolator.lerp(t);
	                        var centerX = circlePosition.x + viewportPadding;
	                        var centerY = circlePosition.y + viewportPadding;
	                        placedCollisionCircles.push(centerX, centerY, radius, 0);
	                        var x1 = centerX - radius;
	                        var y1 = centerY - radius;
	                        var x2 = centerX + radius;
	                        var y2 = centerY + radius;
	                        entirelyOffscreen = entirelyOffscreen && this.isOffscreen(x1, y1, x2, y2);
	                        inGrid = inGrid || this.isInsideGrid(x1, y1, x2, y2);
	                        if (!allowOverlap) {
	                          if (this.grid.hitTestCircle(centerX, centerY, radius, collisionGroupPredicate)) {
	                            collisionDetected = true;
	                            if (!showCollisionCircles) {
	                              return {
	                                circles: [],
	                                offscreen: false,
	                                collisionDetected
	                              };
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                  return {
	                    circles: !showCollisionCircles && collisionDetected || !inGrid ? [] : placedCollisionCircles,
	                    offscreen: entirelyOffscreen,
	                    collisionDetected
	                  };
	                };
	                CollisionIndex.prototype.queryRenderedSymbols = function queryRenderedSymbols2(viewportQueryGeometry) {
	                  if (viewportQueryGeometry.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) {
	                    return {};
	                  }
	                  var query = [];
	                  var minX = Infinity;
	                  var minY = Infinity;
	                  var maxX = -Infinity;
	                  var maxY = -Infinity;
	                  for (var i = 0, list = viewportQueryGeometry; i < list.length; i += 1) {
	                    var point = list[i];
	                    var gridPoint = new performance2.Point(point.x + viewportPadding, point.y + viewportPadding);
	                    minX = Math.min(minX, gridPoint.x);
	                    minY = Math.min(minY, gridPoint.y);
	                    maxX = Math.max(maxX, gridPoint.x);
	                    maxY = Math.max(maxY, gridPoint.y);
	                    query.push(gridPoint);
	                  }
	                  var features = this.grid.query(minX, minY, maxX, maxY).concat(this.ignoredGrid.query(minX, minY, maxX, maxY));
	                  var seenFeatures = {};
	                  var result = {};
	                  for (var i$1 = 0, list$1 = features; i$1 < list$1.length; i$1 += 1) {
	                    var feature = list$1[i$1];
	                    var featureKey = feature.key;
	                    if (seenFeatures[featureKey.bucketInstanceId] === undefined) {
	                      seenFeatures[featureKey.bucketInstanceId] = {};
	                    }
	                    if (seenFeatures[featureKey.bucketInstanceId][featureKey.featureIndex]) {
	                      continue;
	                    }
	                    var bbox = [
	                      new performance2.Point(feature.x1, feature.y1),
	                      new performance2.Point(feature.x2, feature.y1),
	                      new performance2.Point(feature.x2, feature.y2),
	                      new performance2.Point(feature.x1, feature.y2)
	                    ];
	                    if (!performance2.polygonIntersectsPolygon(query, bbox)) {
	                      continue;
	                    }
	                    seenFeatures[featureKey.bucketInstanceId][featureKey.featureIndex] = true;
	                    if (result[featureKey.bucketInstanceId] === undefined) {
	                      result[featureKey.bucketInstanceId] = [];
	                    }
	                    result[featureKey.bucketInstanceId].push(featureKey.featureIndex);
	                  }
	                  return result;
	                };
	                CollisionIndex.prototype.insertCollisionBox = function insertCollisionBox(collisionBox2, ignorePlacement, bucketInstanceId, featureIndex, collisionGroupID) {
	                  var grid = ignorePlacement ? this.ignoredGrid : this.grid;
	                  var key = {
	                    bucketInstanceId,
	                    featureIndex,
	                    collisionGroupID
	                  };
	                  grid.insert(key, collisionBox2[0], collisionBox2[1], collisionBox2[2], collisionBox2[3]);
	                };
	                CollisionIndex.prototype.insertCollisionCircles = function insertCollisionCircles(collisionCircles, ignorePlacement, bucketInstanceId, featureIndex, collisionGroupID) {
	                  var grid = ignorePlacement ? this.ignoredGrid : this.grid;
	                  var key = {
	                    bucketInstanceId,
	                    featureIndex,
	                    collisionGroupID
	                  };
	                  for (var k = 0; k < collisionCircles.length; k += 4) {
	                    grid.insertCircle(key, collisionCircles[k], collisionCircles[k + 1], collisionCircles[k + 2]);
	                  }
	                };
	                CollisionIndex.prototype.projectAndGetPerspectiveRatio = function projectAndGetPerspectiveRatio(posMatrix, x, y) {
	                  var p = [
	                    x,
	                    y,
	                    0,
	                    1
	                  ];
	                  xyTransformMat4(p, p, posMatrix);
	                  var a = new performance2.Point((p[0] / p[3] + 1) / 2 * this.transform.width + viewportPadding, (-p[1] / p[3] + 1) / 2 * this.transform.height + viewportPadding);
	                  return {
	                    point: a,
	                    perspectiveRatio: 0.5 + 0.5 * (this.transform.cameraToCenterDistance / p[3])
	                  };
	                };
	                CollisionIndex.prototype.isOffscreen = function isOffscreen(x1, y1, x2, y2) {
	                  return x2 < viewportPadding || x1 >= this.screenRightBoundary || y2 < viewportPadding || y1 > this.screenBottomBoundary;
	                };
	                CollisionIndex.prototype.isInsideGrid = function isInsideGrid(x1, y1, x2, y2) {
	                  return x2 >= 0 && x1 < this.gridRightBoundary && y2 >= 0 && y1 < this.gridBottomBoundary;
	                };
	                CollisionIndex.prototype.getViewportMatrix = function getViewportMatrix() {
	                  var m = performance2.identity([]);
	                  performance2.translate(m, m, [
	                    -100,
	                    -100,
	                    0
	                  ]);
	                  return m;
	                };
	                function pixelsToTileUnits(tile, pixelValue, z) {
	                  return pixelValue * (performance2.EXTENT / (tile.tileSize * Math.pow(2, z - tile.tileID.overscaledZ)));
	                }
	                var OpacityState = function OpacityState2(prevState, increment, placed, skipFade) {
	                  if (prevState) {
	                    this.opacity = Math.max(0, Math.min(1, prevState.opacity + (prevState.placed ? increment : -increment)));
	                  } else {
	                    this.opacity = skipFade && placed ? 1 : 0;
	                  }
	                  this.placed = placed;
	                };
	                OpacityState.prototype.isHidden = function isHidden() {
	                  return this.opacity === 0 && !this.placed;
	                };
	                var JointOpacityState = function JointOpacityState2(prevState, increment, placedText, placedIcon, skipFade) {
	                  this.text = new OpacityState(prevState ? prevState.text : null, increment, placedText, skipFade);
	                  this.icon = new OpacityState(prevState ? prevState.icon : null, increment, placedIcon, skipFade);
	                };
	                JointOpacityState.prototype.isHidden = function isHidden() {
	                  return this.text.isHidden() && this.icon.isHidden();
	                };
	                var JointPlacement = function JointPlacement2(text, icon, skipFade) {
	                  this.text = text;
	                  this.icon = icon;
	                  this.skipFade = skipFade;
	                };
	                var CollisionCircleArray = function CollisionCircleArray2() {
	                  this.invProjMatrix = performance2.create();
	                  this.viewportMatrix = performance2.create();
	                  this.circles = [];
	                };
	                var RetainedQueryData = function RetainedQueryData2(bucketInstanceId, featureIndex, sourceLayerIndex, bucketIndex, tileID) {
	                  this.bucketInstanceId = bucketInstanceId;
	                  this.featureIndex = featureIndex;
	                  this.sourceLayerIndex = sourceLayerIndex;
	                  this.bucketIndex = bucketIndex;
	                  this.tileID = tileID;
	                };
	                var CollisionGroups = function CollisionGroups2(crossSourceCollisions) {
	                  this.crossSourceCollisions = crossSourceCollisions;
	                  this.maxGroupID = 0;
	                  this.collisionGroups = {};
	                };
	                CollisionGroups.prototype.get = function get(sourceID) {
	                  if (!this.crossSourceCollisions) {
	                    if (!this.collisionGroups[sourceID]) {
	                      var nextGroupID = ++this.maxGroupID;
	                      this.collisionGroups[sourceID] = {
	                        ID: nextGroupID,
	                        predicate: function(key) {
	                          return key.collisionGroupID === nextGroupID;
	                        }
	                      };
	                    }
	                    return this.collisionGroups[sourceID];
	                  } else {
	                    return {
	                      ID: 0,
	                      predicate: null
	                    };
	                  }
	                };
	                function calculateVariableLayoutShift(anchor, width, height, textOffset, textBoxScale) {
	                  var ref = performance2.getAnchorAlignment(anchor);
	                  var horizontalAlign = ref.horizontalAlign;
	                  var verticalAlign = ref.verticalAlign;
	                  var shiftX = -(horizontalAlign - 0.5) * width;
	                  var shiftY = -(verticalAlign - 0.5) * height;
	                  var offset = performance2.evaluateVariableOffset(anchor, textOffset);
	                  return new performance2.Point(shiftX + offset[0] * textBoxScale, shiftY + offset[1] * textBoxScale);
	                }
	                function shiftVariableCollisionBox(collisionBox2, shiftX, shiftY, rotateWithMap, pitchWithMap, angle) {
	                  var x1 = collisionBox2.x1;
	                  var x2 = collisionBox2.x2;
	                  var y1 = collisionBox2.y1;
	                  var y2 = collisionBox2.y2;
	                  var anchorPointX = collisionBox2.anchorPointX;
	                  var anchorPointY = collisionBox2.anchorPointY;
	                  var rotatedOffset = new performance2.Point(shiftX, shiftY);
	                  if (rotateWithMap) {
	                    rotatedOffset._rotate(pitchWithMap ? angle : -angle);
	                  }
	                  return {
	                    x1: x1 + rotatedOffset.x,
	                    y1: y1 + rotatedOffset.y,
	                    x2: x2 + rotatedOffset.x,
	                    y2: y2 + rotatedOffset.y,
	                    anchorPointX,
	                    anchorPointY
	                  };
	                }
	                var Placement = function Placement2(transform, fadeDuration, crossSourceCollisions, prevPlacement) {
	                  this.transform = transform.clone();
	                  this.collisionIndex = new CollisionIndex(this.transform);
	                  this.placements = {};
	                  this.opacities = {};
	                  this.variableOffsets = {};
	                  this.stale = false;
	                  this.commitTime = 0;
	                  this.fadeDuration = fadeDuration;
	                  this.retainedQueryData = {};
	                  this.collisionGroups = new CollisionGroups(crossSourceCollisions);
	                  this.collisionCircleArrays = {};
	                  this.prevPlacement = prevPlacement;
	                  if (prevPlacement) {
	                    prevPlacement.prevPlacement = undefined;
	                  }
	                  this.placedOrientations = {};
	                };
	                Placement.prototype.getBucketParts = function getBucketParts(results, styleLayer, tile, sortAcrossTiles) {
	                  var symbolBucket = tile.getBucket(styleLayer);
	                  var bucketFeatureIndex = tile.latestFeatureIndex;
	                  if (!symbolBucket || !bucketFeatureIndex || styleLayer.id !== symbolBucket.layerIds[0]) {
	                    return;
	                  }
	                  var collisionBoxArray = tile.collisionBoxArray;
	                  var layout = symbolBucket.layers[0].layout;
	                  var scale = Math.pow(2, this.transform.zoom - tile.tileID.overscaledZ);
	                  var textPixelRatio = tile.tileSize / performance2.EXTENT;
	                  var posMatrix = this.transform.calculatePosMatrix(tile.tileID.toUnwrapped());
	                  var pitchWithMap = layout.get("text-pitch-alignment") === "map";
	                  var rotateWithMap = layout.get("text-rotation-alignment") === "map";
	                  var pixelsToTiles = pixelsToTileUnits(tile, 1, this.transform.zoom);
	                  var textLabelPlaneMatrix = getLabelPlaneMatrix(posMatrix, pitchWithMap, rotateWithMap, this.transform, pixelsToTiles);
	                  var labelToScreenMatrix = null;
	                  if (pitchWithMap) {
	                    var glMatrix = getGlCoordMatrix(posMatrix, pitchWithMap, rotateWithMap, this.transform, pixelsToTiles);
	                    labelToScreenMatrix = performance2.multiply([], this.transform.labelPlaneMatrix, glMatrix);
	                  }
	                  this.retainedQueryData[symbolBucket.bucketInstanceId] = new RetainedQueryData(symbolBucket.bucketInstanceId, bucketFeatureIndex, symbolBucket.sourceLayerIndex, symbolBucket.index, tile.tileID);
	                  var parameters = {
	                    bucket: symbolBucket,
	                    layout,
	                    posMatrix,
	                    textLabelPlaneMatrix,
	                    labelToScreenMatrix,
	                    scale,
	                    textPixelRatio,
	                    holdingForFade: tile.holdingForFade(),
	                    collisionBoxArray,
	                    partiallyEvaluatedTextSize: performance2.evaluateSizeForZoom(symbolBucket.textSizeData, this.transform.zoom),
	                    collisionGroup: this.collisionGroups.get(symbolBucket.sourceID)
	                  };
	                  if (sortAcrossTiles) {
	                    for (var i = 0, list = symbolBucket.sortKeyRanges; i < list.length; i += 1) {
	                      var range2 = list[i];
	                      var sortKey = range2.sortKey;
	                      var symbolInstanceStart = range2.symbolInstanceStart;
	                      var symbolInstanceEnd = range2.symbolInstanceEnd;
	                      results.push({
	                        sortKey,
	                        symbolInstanceStart,
	                        symbolInstanceEnd,
	                        parameters
	                      });
	                    }
	                  } else {
	                    results.push({
	                      symbolInstanceStart: 0,
	                      symbolInstanceEnd: symbolBucket.symbolInstances.length,
	                      parameters
	                    });
	                  }
	                };
	                Placement.prototype.attemptAnchorPlacement = function attemptAnchorPlacement(anchor, textBox, width, height, textBoxScale, rotateWithMap, pitchWithMap, textPixelRatio, posMatrix, collisionGroup, textAllowOverlap, symbolInstance, bucket, orientation, iconBox) {
	                  var textOffset = [
	                    symbolInstance.textOffset0,
	                    symbolInstance.textOffset1
	                  ];
	                  var shift = calculateVariableLayoutShift(anchor, width, height, textOffset, textBoxScale);
	                  var placedGlyphBoxes = this.collisionIndex.placeCollisionBox(shiftVariableCollisionBox(textBox, shift.x, shift.y, rotateWithMap, pitchWithMap, this.transform.angle), textAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
	                  if (iconBox) {
	                    var placedIconBoxes = this.collisionIndex.placeCollisionBox(shiftVariableCollisionBox(iconBox, shift.x, shift.y, rotateWithMap, pitchWithMap, this.transform.angle), textAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
	                    if (placedIconBoxes.box.length === 0) {
	                      return;
	                    }
	                  }
	                  if (placedGlyphBoxes.box.length > 0) {
	                    var prevAnchor;
	                    if (this.prevPlacement && this.prevPlacement.variableOffsets[symbolInstance.crossTileID] && this.prevPlacement.placements[symbolInstance.crossTileID] && this.prevPlacement.placements[symbolInstance.crossTileID].text) {
	                      prevAnchor = this.prevPlacement.variableOffsets[symbolInstance.crossTileID].anchor;
	                    }
	                    this.variableOffsets[symbolInstance.crossTileID] = {
	                      textOffset,
	                      width,
	                      height,
	                      anchor,
	                      textBoxScale,
	                      prevAnchor
	                    };
	                    this.markUsedJustification(bucket, anchor, symbolInstance, orientation);
	                    if (bucket.allowVerticalPlacement) {
	                      this.markUsedOrientation(bucket, orientation, symbolInstance);
	                      this.placedOrientations[symbolInstance.crossTileID] = orientation;
	                    }
	                    return {
	                      shift,
	                      placedGlyphBoxes
	                    };
	                  }
	                };
	                Placement.prototype.placeLayerBucketPart = function placeLayerBucketPart(bucketPart, seenCrossTileIDs, showCollisionBoxes) {
	                  var this$1$1 = this;
	                  var ref = bucketPart.parameters;
	                  var bucket = ref.bucket;
	                  var layout = ref.layout;
	                  var posMatrix = ref.posMatrix;
	                  var textLabelPlaneMatrix = ref.textLabelPlaneMatrix;
	                  var labelToScreenMatrix = ref.labelToScreenMatrix;
	                  var textPixelRatio = ref.textPixelRatio;
	                  var holdingForFade = ref.holdingForFade;
	                  var collisionBoxArray = ref.collisionBoxArray;
	                  var partiallyEvaluatedTextSize = ref.partiallyEvaluatedTextSize;
	                  var collisionGroup = ref.collisionGroup;
	                  var textOptional = layout.get("text-optional");
	                  var iconOptional = layout.get("icon-optional");
	                  var textAllowOverlap = layout.get("text-allow-overlap");
	                  var iconAllowOverlap = layout.get("icon-allow-overlap");
	                  var rotateWithMap = layout.get("text-rotation-alignment") === "map";
	                  var pitchWithMap = layout.get("text-pitch-alignment") === "map";
	                  var hasIconTextFit = layout.get("icon-text-fit") !== "none";
	                  var zOrderByViewportY = layout.get("symbol-z-order") === "viewport-y";
	                  var alwaysShowText = textAllowOverlap && (iconAllowOverlap || !bucket.hasIconData() || iconOptional);
	                  var alwaysShowIcon = iconAllowOverlap && (textAllowOverlap || !bucket.hasTextData() || textOptional);
	                  if (!bucket.collisionArrays && collisionBoxArray) {
	                    bucket.deserializeCollisionBoxes(collisionBoxArray);
	                  }
	                  var placeSymbol = function(symbolInstance, collisionArrays) {
	                    if (seenCrossTileIDs[symbolInstance.crossTileID]) {
	                      return;
	                    }
	                    if (holdingForFade) {
	                      this$1$1.placements[symbolInstance.crossTileID] = new JointPlacement(false, false, false);
	                      return;
	                    }
	                    var placeText = false;
	                    var placeIcon = false;
	                    var offscreen = true;
	                    var shift = null;
	                    var placed = {
	                      box: null,
	                      offscreen: null
	                    };
	                    var placedVerticalText = {
	                      box: null,
	                      offscreen: null
	                    };
	                    var placedGlyphBoxes = null;
	                    var placedGlyphCircles = null;
	                    var placedIconBoxes = null;
	                    var textFeatureIndex = 0;
	                    var verticalTextFeatureIndex = 0;
	                    var iconFeatureIndex = 0;
	                    if (collisionArrays.textFeatureIndex) {
	                      textFeatureIndex = collisionArrays.textFeatureIndex;
	                    } else if (symbolInstance.useRuntimeCollisionCircles) {
	                      textFeatureIndex = symbolInstance.featureIndex;
	                    }
	                    if (collisionArrays.verticalTextFeatureIndex) {
	                      verticalTextFeatureIndex = collisionArrays.verticalTextFeatureIndex;
	                    }
	                    var textBox = collisionArrays.textBox;
	                    if (textBox) {
	                      var updatePreviousOrientationIfNotPlaced = function(isPlaced) {
	                        var previousOrientation = performance2.WritingMode.horizontal;
	                        if (bucket.allowVerticalPlacement && !isPlaced && this$1$1.prevPlacement) {
	                          var prevPlacedOrientation = this$1$1.prevPlacement.placedOrientations[symbolInstance.crossTileID];
	                          if (prevPlacedOrientation) {
	                            this$1$1.placedOrientations[symbolInstance.crossTileID] = prevPlacedOrientation;
	                            previousOrientation = prevPlacedOrientation;
	                            this$1$1.markUsedOrientation(bucket, previousOrientation, symbolInstance);
	                          }
	                        }
	                        return previousOrientation;
	                      };
	                      var placeTextForPlacementModes = function(placeHorizontalFn, placeVerticalFn) {
	                        if (bucket.allowVerticalPlacement && symbolInstance.numVerticalGlyphVertices > 0 && collisionArrays.verticalTextBox) {
	                          for (var i3 = 0, list = bucket.writingModes; i3 < list.length; i3 += 1) {
	                            var placementMode = list[i3];
	                            if (placementMode === performance2.WritingMode.vertical) {
	                              placed = placeVerticalFn();
	                              placedVerticalText = placed;
	                            } else {
	                              placed = placeHorizontalFn();
	                            }
	                            if (placed && placed.box && placed.box.length) {
	                              break;
	                            }
	                          }
	                        } else {
	                          placed = placeHorizontalFn();
	                        }
	                      };
	                      if (!layout.get("text-variable-anchor")) {
	                        var placeBox = function(collisionTextBox, orientation) {
	                          var placedFeature = this$1$1.collisionIndex.placeCollisionBox(collisionTextBox, textAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
	                          if (placedFeature && placedFeature.box && placedFeature.box.length) {
	                            this$1$1.markUsedOrientation(bucket, orientation, symbolInstance);
	                            this$1$1.placedOrientations[symbolInstance.crossTileID] = orientation;
	                          }
	                          return placedFeature;
	                        };
	                        var placeHorizontal = function() {
	                          return placeBox(textBox, performance2.WritingMode.horizontal);
	                        };
	                        var placeVertical = function() {
	                          var verticalTextBox = collisionArrays.verticalTextBox;
	                          if (bucket.allowVerticalPlacement && symbolInstance.numVerticalGlyphVertices > 0 && verticalTextBox) {
	                            return placeBox(verticalTextBox, performance2.WritingMode.vertical);
	                          }
	                          return {
	                            box: null,
	                            offscreen: null
	                          };
	                        };
	                        placeTextForPlacementModes(placeHorizontal, placeVertical);
	                        updatePreviousOrientationIfNotPlaced(placed && placed.box && placed.box.length);
	                      } else {
	                        var anchors = layout.get("text-variable-anchor");
	                        if (this$1$1.prevPlacement && this$1$1.prevPlacement.variableOffsets[symbolInstance.crossTileID]) {
	                          var prevOffsets = this$1$1.prevPlacement.variableOffsets[symbolInstance.crossTileID];
	                          if (anchors.indexOf(prevOffsets.anchor) > 0) {
	                            anchors = anchors.filter(function(anchor) {
	                              return anchor !== prevOffsets.anchor;
	                            });
	                            anchors.unshift(prevOffsets.anchor);
	                          }
	                        }
	                        var placeBoxForVariableAnchors = function(collisionTextBox, collisionIconBox, orientation) {
	                          var width = collisionTextBox.x2 - collisionTextBox.x1;
	                          var height = collisionTextBox.y2 - collisionTextBox.y1;
	                          var textBoxScale = symbolInstance.textBoxScale;
	                          var variableIconBox = hasIconTextFit && !iconAllowOverlap ? collisionIconBox : null;
	                          var placedBox = {
	                            box: [],
	                            offscreen: false
	                          };
	                          var placementAttempts = textAllowOverlap ? anchors.length * 2 : anchors.length;
	                          for (var i3 = 0; i3 < placementAttempts; ++i3) {
	                            var anchor = anchors[i3 % anchors.length];
	                            var allowOverlap = i3 >= anchors.length;
	                            var result = this$1$1.attemptAnchorPlacement(anchor, collisionTextBox, width, height, textBoxScale, rotateWithMap, pitchWithMap, textPixelRatio, posMatrix, collisionGroup, allowOverlap, symbolInstance, bucket, orientation, variableIconBox);
	                            if (result) {
	                              placedBox = result.placedGlyphBoxes;
	                              if (placedBox && placedBox.box && placedBox.box.length) {
	                                placeText = true;
	                                shift = result.shift;
	                                break;
	                              }
	                            }
	                          }
	                          return placedBox;
	                        };
	                        var placeHorizontal$1 = function() {
	                          return placeBoxForVariableAnchors(textBox, collisionArrays.iconBox, performance2.WritingMode.horizontal);
	                        };
	                        var placeVertical$1 = function() {
	                          var verticalTextBox = collisionArrays.verticalTextBox;
	                          var wasPlaced = placed && placed.box && placed.box.length;
	                          if (bucket.allowVerticalPlacement && !wasPlaced && symbolInstance.numVerticalGlyphVertices > 0 && verticalTextBox) {
	                            return placeBoxForVariableAnchors(verticalTextBox, collisionArrays.verticalIconBox, performance2.WritingMode.vertical);
	                          }
	                          return {
	                            box: null,
	                            offscreen: null
	                          };
	                        };
	                        placeTextForPlacementModes(placeHorizontal$1, placeVertical$1);
	                        if (placed) {
	                          placeText = placed.box;
	                          offscreen = placed.offscreen;
	                        }
	                        var prevOrientation = updatePreviousOrientationIfNotPlaced(placed && placed.box);
	                        if (!placeText && this$1$1.prevPlacement) {
	                          var prevOffset = this$1$1.prevPlacement.variableOffsets[symbolInstance.crossTileID];
	                          if (prevOffset) {
	                            this$1$1.variableOffsets[symbolInstance.crossTileID] = prevOffset;
	                            this$1$1.markUsedJustification(bucket, prevOffset.anchor, symbolInstance, prevOrientation);
	                          }
	                        }
	                      }
	                    }
	                    placedGlyphBoxes = placed;
	                    placeText = placedGlyphBoxes && placedGlyphBoxes.box && placedGlyphBoxes.box.length > 0;
	                    offscreen = placedGlyphBoxes && placedGlyphBoxes.offscreen;
	                    if (symbolInstance.useRuntimeCollisionCircles) {
	                      var placedSymbol = bucket.text.placedSymbolArray.get(symbolInstance.centerJustifiedTextSymbolIndex);
	                      var fontSize = performance2.evaluateSizeForFeature(bucket.textSizeData, partiallyEvaluatedTextSize, placedSymbol);
	                      var textPixelPadding = layout.get("text-padding");
	                      var circlePixelDiameter = symbolInstance.collisionCircleDiameter;
	                      placedGlyphCircles = this$1$1.collisionIndex.placeCollisionCircles(textAllowOverlap, placedSymbol, bucket.lineVertexArray, bucket.glyphOffsetArray, fontSize, posMatrix, textLabelPlaneMatrix, labelToScreenMatrix, showCollisionBoxes, pitchWithMap, collisionGroup.predicate, circlePixelDiameter, textPixelPadding);
	                      placeText = textAllowOverlap || placedGlyphCircles.circles.length > 0 && !placedGlyphCircles.collisionDetected;
	                      offscreen = offscreen && placedGlyphCircles.offscreen;
	                    }
	                    if (collisionArrays.iconFeatureIndex) {
	                      iconFeatureIndex = collisionArrays.iconFeatureIndex;
	                    }
	                    if (collisionArrays.iconBox) {
	                      var placeIconFeature = function(iconBox) {
	                        var shiftedIconBox = hasIconTextFit && shift ? shiftVariableCollisionBox(iconBox, shift.x, shift.y, rotateWithMap, pitchWithMap, this$1$1.transform.angle) : iconBox;
	                        return this$1$1.collisionIndex.placeCollisionBox(shiftedIconBox, iconAllowOverlap, textPixelRatio, posMatrix, collisionGroup.predicate);
	                      };
	                      if (placedVerticalText && placedVerticalText.box && placedVerticalText.box.length && collisionArrays.verticalIconBox) {
	                        placedIconBoxes = placeIconFeature(collisionArrays.verticalIconBox);
	                        placeIcon = placedIconBoxes.box.length > 0;
	                      } else {
	                        placedIconBoxes = placeIconFeature(collisionArrays.iconBox);
	                        placeIcon = placedIconBoxes.box.length > 0;
	                      }
	                      offscreen = offscreen && placedIconBoxes.offscreen;
	                    }
	                    var iconWithoutText = textOptional || symbolInstance.numHorizontalGlyphVertices === 0 && symbolInstance.numVerticalGlyphVertices === 0;
	                    var textWithoutIcon = iconOptional || symbolInstance.numIconVertices === 0;
	                    if (!iconWithoutText && !textWithoutIcon) {
	                      placeIcon = placeText = placeIcon && placeText;
	                    } else if (!textWithoutIcon) {
	                      placeText = placeIcon && placeText;
	                    } else if (!iconWithoutText) {
	                      placeIcon = placeIcon && placeText;
	                    }
	                    if (placeText && placedGlyphBoxes && placedGlyphBoxes.box) {
	                      if (placedVerticalText && placedVerticalText.box && verticalTextFeatureIndex) {
	                        this$1$1.collisionIndex.insertCollisionBox(placedGlyphBoxes.box, layout.get("text-ignore-placement"), bucket.bucketInstanceId, verticalTextFeatureIndex, collisionGroup.ID);
	                      } else {
	                        this$1$1.collisionIndex.insertCollisionBox(placedGlyphBoxes.box, layout.get("text-ignore-placement"), bucket.bucketInstanceId, textFeatureIndex, collisionGroup.ID);
	                      }
	                    }
	                    if (placeIcon && placedIconBoxes) {
	                      this$1$1.collisionIndex.insertCollisionBox(placedIconBoxes.box, layout.get("icon-ignore-placement"), bucket.bucketInstanceId, iconFeatureIndex, collisionGroup.ID);
	                    }
	                    if (placedGlyphCircles) {
	                      if (placeText) {
	                        this$1$1.collisionIndex.insertCollisionCircles(placedGlyphCircles.circles, layout.get("text-ignore-placement"), bucket.bucketInstanceId, textFeatureIndex, collisionGroup.ID);
	                      }
	                      if (showCollisionBoxes) {
	                        var id = bucket.bucketInstanceId;
	                        var circleArray2 = this$1$1.collisionCircleArrays[id];
	                        if (circleArray2 === undefined) {
	                          circleArray2 = this$1$1.collisionCircleArrays[id] = new CollisionCircleArray();
	                        }
	                        for (var i2 = 0; i2 < placedGlyphCircles.circles.length; i2 += 4) {
	                          circleArray2.circles.push(placedGlyphCircles.circles[i2 + 0]);
	                          circleArray2.circles.push(placedGlyphCircles.circles[i2 + 1]);
	                          circleArray2.circles.push(placedGlyphCircles.circles[i2 + 2]);
	                          circleArray2.circles.push(placedGlyphCircles.collisionDetected ? 1 : 0);
	                        }
	                      }
	                    }
	                    this$1$1.placements[symbolInstance.crossTileID] = new JointPlacement(placeText || alwaysShowText, placeIcon || alwaysShowIcon, offscreen || bucket.justReloaded);
	                    seenCrossTileIDs[symbolInstance.crossTileID] = true;
	                  };
	                  if (zOrderByViewportY) {
	                    var symbolIndexes = bucket.getSortedSymbolIndexes(this.transform.angle);
	                    for (var i = symbolIndexes.length - 1; i >= 0; --i) {
	                      var symbolIndex = symbolIndexes[i];
	                      placeSymbol(bucket.symbolInstances.get(symbolIndex), bucket.collisionArrays[symbolIndex]);
	                    }
	                  } else {
	                    for (var i$1 = bucketPart.symbolInstanceStart; i$1 < bucketPart.symbolInstanceEnd; i$1++) {
	                      placeSymbol(bucket.symbolInstances.get(i$1), bucket.collisionArrays[i$1]);
	                    }
	                  }
	                  if (showCollisionBoxes && bucket.bucketInstanceId in this.collisionCircleArrays) {
	                    var circleArray = this.collisionCircleArrays[bucket.bucketInstanceId];
	                    performance2.invert(circleArray.invProjMatrix, posMatrix);
	                    circleArray.viewportMatrix = this.collisionIndex.getViewportMatrix();
	                  }
	                  bucket.justReloaded = false;
	                };
	                Placement.prototype.markUsedJustification = function markUsedJustification(bucket, placedAnchor, symbolInstance, orientation) {
	                  var justifications = {
	                    "left": symbolInstance.leftJustifiedTextSymbolIndex,
	                    "center": symbolInstance.centerJustifiedTextSymbolIndex,
	                    "right": symbolInstance.rightJustifiedTextSymbolIndex
	                  };
	                  var autoIndex;
	                  if (orientation === performance2.WritingMode.vertical) {
	                    autoIndex = symbolInstance.verticalPlacedTextSymbolIndex;
	                  } else {
	                    autoIndex = justifications[performance2.getAnchorJustification(placedAnchor)];
	                  }
	                  var indexes = [
	                    symbolInstance.leftJustifiedTextSymbolIndex,
	                    symbolInstance.centerJustifiedTextSymbolIndex,
	                    symbolInstance.rightJustifiedTextSymbolIndex,
	                    symbolInstance.verticalPlacedTextSymbolIndex
	                  ];
	                  for (var i = 0, list = indexes; i < list.length; i += 1) {
	                    var index = list[i];
	                    if (index >= 0) {
	                      if (autoIndex >= 0 && index !== autoIndex) {
	                        bucket.text.placedSymbolArray.get(index).crossTileID = 0;
	                      } else {
	                        bucket.text.placedSymbolArray.get(index).crossTileID = symbolInstance.crossTileID;
	                      }
	                    }
	                  }
	                };
	                Placement.prototype.markUsedOrientation = function markUsedOrientation(bucket, orientation, symbolInstance) {
	                  var horizontal = orientation === performance2.WritingMode.horizontal || orientation === performance2.WritingMode.horizontalOnly ? orientation : 0;
	                  var vertical = orientation === performance2.WritingMode.vertical ? orientation : 0;
	                  var horizontalIndexes = [
	                    symbolInstance.leftJustifiedTextSymbolIndex,
	                    symbolInstance.centerJustifiedTextSymbolIndex,
	                    symbolInstance.rightJustifiedTextSymbolIndex
	                  ];
	                  for (var i = 0, list = horizontalIndexes; i < list.length; i += 1) {
	                    var index = list[i];
	                    bucket.text.placedSymbolArray.get(index).placedOrientation = horizontal;
	                  }
	                  if (symbolInstance.verticalPlacedTextSymbolIndex) {
	                    bucket.text.placedSymbolArray.get(symbolInstance.verticalPlacedTextSymbolIndex).placedOrientation = vertical;
	                  }
	                };
	                Placement.prototype.commit = function commit(now) {
	                  this.commitTime = now;
	                  this.zoomAtLastRecencyCheck = this.transform.zoom;
	                  var prevPlacement = this.prevPlacement;
	                  var placementChanged = false;
	                  this.prevZoomAdjustment = prevPlacement ? prevPlacement.zoomAdjustment(this.transform.zoom) : 0;
	                  var increment = prevPlacement ? prevPlacement.symbolFadeChange(now) : 1;
	                  var prevOpacities = prevPlacement ? prevPlacement.opacities : {};
	                  var prevOffsets = prevPlacement ? prevPlacement.variableOffsets : {};
	                  var prevOrientations = prevPlacement ? prevPlacement.placedOrientations : {};
	                  for (var crossTileID in this.placements) {
	                    var jointPlacement = this.placements[crossTileID];
	                    var prevOpacity = prevOpacities[crossTileID];
	                    if (prevOpacity) {
	                      this.opacities[crossTileID] = new JointOpacityState(prevOpacity, increment, jointPlacement.text, jointPlacement.icon);
	                      placementChanged = placementChanged || jointPlacement.text !== prevOpacity.text.placed || jointPlacement.icon !== prevOpacity.icon.placed;
	                    } else {
	                      this.opacities[crossTileID] = new JointOpacityState(null, increment, jointPlacement.text, jointPlacement.icon, jointPlacement.skipFade);
	                      placementChanged = placementChanged || jointPlacement.text || jointPlacement.icon;
	                    }
	                  }
	                  for (var crossTileID$1 in prevOpacities) {
	                    var prevOpacity$1 = prevOpacities[crossTileID$1];
	                    if (!this.opacities[crossTileID$1]) {
	                      var jointOpacity = new JointOpacityState(prevOpacity$1, increment, false, false);
	                      if (!jointOpacity.isHidden()) {
	                        this.opacities[crossTileID$1] = jointOpacity;
	                        placementChanged = placementChanged || prevOpacity$1.text.placed || prevOpacity$1.icon.placed;
	                      }
	                    }
	                  }
	                  for (var crossTileID$2 in prevOffsets) {
	                    if (!this.variableOffsets[crossTileID$2] && this.opacities[crossTileID$2] && !this.opacities[crossTileID$2].isHidden()) {
	                      this.variableOffsets[crossTileID$2] = prevOffsets[crossTileID$2];
	                    }
	                  }
	                  for (var crossTileID$3 in prevOrientations) {
	                    if (!this.placedOrientations[crossTileID$3] && this.opacities[crossTileID$3] && !this.opacities[crossTileID$3].isHidden()) {
	                      this.placedOrientations[crossTileID$3] = prevOrientations[crossTileID$3];
	                    }
	                  }
	                  if (placementChanged) {
	                    this.lastPlacementChangeTime = now;
	                  } else if (typeof this.lastPlacementChangeTime !== "number") {
	                    this.lastPlacementChangeTime = prevPlacement ? prevPlacement.lastPlacementChangeTime : now;
	                  }
	                };
	                Placement.prototype.updateLayerOpacities = function updateLayerOpacities(styleLayer, tiles) {
	                  var seenCrossTileIDs = {};
	                  for (var i = 0, list = tiles; i < list.length; i += 1) {
	                    var tile = list[i];
	                    var symbolBucket = tile.getBucket(styleLayer);
	                    if (symbolBucket && tile.latestFeatureIndex && styleLayer.id === symbolBucket.layerIds[0]) {
	                      this.updateBucketOpacities(symbolBucket, seenCrossTileIDs, tile.collisionBoxArray);
	                    }
	                  }
	                };
	                Placement.prototype.updateBucketOpacities = function updateBucketOpacities(bucket, seenCrossTileIDs, collisionBoxArray) {
	                  var this$1$1 = this;
	                  if (bucket.hasTextData()) {
	                    bucket.text.opacityVertexArray.clear();
	                  }
	                  if (bucket.hasIconData()) {
	                    bucket.icon.opacityVertexArray.clear();
	                  }
	                  if (bucket.hasIconCollisionBoxData()) {
	                    bucket.iconCollisionBox.collisionVertexArray.clear();
	                  }
	                  if (bucket.hasTextCollisionBoxData()) {
	                    bucket.textCollisionBox.collisionVertexArray.clear();
	                  }
	                  var layout = bucket.layers[0].layout;
	                  var duplicateOpacityState = new JointOpacityState(null, 0, false, false, true);
	                  var textAllowOverlap = layout.get("text-allow-overlap");
	                  var iconAllowOverlap = layout.get("icon-allow-overlap");
	                  var variablePlacement = layout.get("text-variable-anchor");
	                  var rotateWithMap = layout.get("text-rotation-alignment") === "map";
	                  var pitchWithMap = layout.get("text-pitch-alignment") === "map";
	                  var hasIconTextFit = layout.get("icon-text-fit") !== "none";
	                  var defaultOpacityState = new JointOpacityState(null, 0, textAllowOverlap && (iconAllowOverlap || !bucket.hasIconData() || layout.get("icon-optional")), iconAllowOverlap && (textAllowOverlap || !bucket.hasTextData() || layout.get("text-optional")), true);
	                  if (!bucket.collisionArrays && collisionBoxArray && (bucket.hasIconCollisionBoxData() || bucket.hasTextCollisionBoxData())) {
	                    bucket.deserializeCollisionBoxes(collisionBoxArray);
	                  }
	                  var addOpacities = function(iconOrText, numVertices, opacity) {
	                    for (var i = 0; i < numVertices / 4; i++) {
	                      iconOrText.opacityVertexArray.emplaceBack(opacity);
	                    }
	                  };
	                  var loop = function(s2) {
	                    var symbolInstance = bucket.symbolInstances.get(s2);
	                    var numHorizontalGlyphVertices = symbolInstance.numHorizontalGlyphVertices;
	                    var numVerticalGlyphVertices = symbolInstance.numVerticalGlyphVertices;
	                    var crossTileID = symbolInstance.crossTileID;
	                    var isDuplicate = seenCrossTileIDs[crossTileID];
	                    var opacityState = this$1$1.opacities[crossTileID];
	                    if (isDuplicate) {
	                      opacityState = duplicateOpacityState;
	                    } else if (!opacityState) {
	                      opacityState = defaultOpacityState;
	                      this$1$1.opacities[crossTileID] = opacityState;
	                    }
	                    seenCrossTileIDs[crossTileID] = true;
	                    var hasText = numHorizontalGlyphVertices > 0 || numVerticalGlyphVertices > 0;
	                    var hasIcon = symbolInstance.numIconVertices > 0;
	                    var placedOrientation = this$1$1.placedOrientations[symbolInstance.crossTileID];
	                    var horizontalHidden = placedOrientation === performance2.WritingMode.vertical;
	                    var verticalHidden = placedOrientation === performance2.WritingMode.horizontal || placedOrientation === performance2.WritingMode.horizontalOnly;
	                    if (hasText) {
	                      var packedOpacity = packOpacity(opacityState.text);
	                      var horizontalOpacity = horizontalHidden ? PACKED_HIDDEN_OPACITY : packedOpacity;
	                      addOpacities(bucket.text, numHorizontalGlyphVertices, horizontalOpacity);
	                      var verticalOpacity = verticalHidden ? PACKED_HIDDEN_OPACITY : packedOpacity;
	                      addOpacities(bucket.text, numVerticalGlyphVertices, verticalOpacity);
	                      var symbolHidden = opacityState.text.isHidden();
	                      [
	                        symbolInstance.rightJustifiedTextSymbolIndex,
	                        symbolInstance.centerJustifiedTextSymbolIndex,
	                        symbolInstance.leftJustifiedTextSymbolIndex
	                      ].forEach(function(index) {
	                        if (index >= 0) {
	                          bucket.text.placedSymbolArray.get(index).hidden = symbolHidden || horizontalHidden ? 1 : 0;
	                        }
	                      });
	                      if (symbolInstance.verticalPlacedTextSymbolIndex >= 0) {
	                        bucket.text.placedSymbolArray.get(symbolInstance.verticalPlacedTextSymbolIndex).hidden = symbolHidden || verticalHidden ? 1 : 0;
	                      }
	                      var prevOffset = this$1$1.variableOffsets[symbolInstance.crossTileID];
	                      if (prevOffset) {
	                        this$1$1.markUsedJustification(bucket, prevOffset.anchor, symbolInstance, placedOrientation);
	                      }
	                      var prevOrientation = this$1$1.placedOrientations[symbolInstance.crossTileID];
	                      if (prevOrientation) {
	                        this$1$1.markUsedJustification(bucket, "left", symbolInstance, prevOrientation);
	                        this$1$1.markUsedOrientation(bucket, prevOrientation, symbolInstance);
	                      }
	                    }
	                    if (hasIcon) {
	                      var packedOpacity$1 = packOpacity(opacityState.icon);
	                      var useHorizontal = !(hasIconTextFit && symbolInstance.verticalPlacedIconSymbolIndex && horizontalHidden);
	                      if (symbolInstance.placedIconSymbolIndex >= 0) {
	                        var horizontalOpacity$1 = useHorizontal ? packedOpacity$1 : PACKED_HIDDEN_OPACITY;
	                        addOpacities(bucket.icon, symbolInstance.numIconVertices, horizontalOpacity$1);
	                        bucket.icon.placedSymbolArray.get(symbolInstance.placedIconSymbolIndex).hidden = opacityState.icon.isHidden();
	                      }
	                      if (symbolInstance.verticalPlacedIconSymbolIndex >= 0) {
	                        var verticalOpacity$1 = !useHorizontal ? packedOpacity$1 : PACKED_HIDDEN_OPACITY;
	                        addOpacities(bucket.icon, symbolInstance.numVerticalIconVertices, verticalOpacity$1);
	                        bucket.icon.placedSymbolArray.get(symbolInstance.verticalPlacedIconSymbolIndex).hidden = opacityState.icon.isHidden();
	                      }
	                    }
	                    if (bucket.hasIconCollisionBoxData() || bucket.hasTextCollisionBoxData()) {
	                      var collisionArrays = bucket.collisionArrays[s2];
	                      if (collisionArrays) {
	                        var shift = new performance2.Point(0, 0);
	                        if (collisionArrays.textBox || collisionArrays.verticalTextBox) {
	                          var used = true;
	                          if (variablePlacement) {
	                            var variableOffset = this$1$1.variableOffsets[crossTileID];
	                            if (variableOffset) {
	                              shift = calculateVariableLayoutShift(variableOffset.anchor, variableOffset.width, variableOffset.height, variableOffset.textOffset, variableOffset.textBoxScale);
	                              if (rotateWithMap) {
	                                shift._rotate(pitchWithMap ? this$1$1.transform.angle : -this$1$1.transform.angle);
	                              }
	                            } else {
	                              used = false;
	                            }
	                          }
	                          if (collisionArrays.textBox) {
	                            updateCollisionVertices(bucket.textCollisionBox.collisionVertexArray, opacityState.text.placed, !used || horizontalHidden, shift.x, shift.y);
	                          }
	                          if (collisionArrays.verticalTextBox) {
	                            updateCollisionVertices(bucket.textCollisionBox.collisionVertexArray, opacityState.text.placed, !used || verticalHidden, shift.x, shift.y);
	                          }
	                        }
	                        var verticalIconUsed = Boolean(!verticalHidden && collisionArrays.verticalIconBox);
	                        if (collisionArrays.iconBox) {
	                          updateCollisionVertices(bucket.iconCollisionBox.collisionVertexArray, opacityState.icon.placed, verticalIconUsed, hasIconTextFit ? shift.x : 0, hasIconTextFit ? shift.y : 0);
	                        }
	                        if (collisionArrays.verticalIconBox) {
	                          updateCollisionVertices(bucket.iconCollisionBox.collisionVertexArray, opacityState.icon.placed, !verticalIconUsed, hasIconTextFit ? shift.x : 0, hasIconTextFit ? shift.y : 0);
	                        }
	                      }
	                    }
	                  };
	                  for (var s = 0; s < bucket.symbolInstances.length; s++)
	                    loop(s);
	                  bucket.sortFeatures(this.transform.angle);
	                  if (this.retainedQueryData[bucket.bucketInstanceId]) {
	                    this.retainedQueryData[bucket.bucketInstanceId].featureSortOrder = bucket.featureSortOrder;
	                  }
	                  if (bucket.hasTextData() && bucket.text.opacityVertexBuffer) {
	                    bucket.text.opacityVertexBuffer.updateData(bucket.text.opacityVertexArray);
	                  }
	                  if (bucket.hasIconData() && bucket.icon.opacityVertexBuffer) {
	                    bucket.icon.opacityVertexBuffer.updateData(bucket.icon.opacityVertexArray);
	                  }
	                  if (bucket.hasIconCollisionBoxData() && bucket.iconCollisionBox.collisionVertexBuffer) {
	                    bucket.iconCollisionBox.collisionVertexBuffer.updateData(bucket.iconCollisionBox.collisionVertexArray);
	                  }
	                  if (bucket.hasTextCollisionBoxData() && bucket.textCollisionBox.collisionVertexBuffer) {
	                    bucket.textCollisionBox.collisionVertexBuffer.updateData(bucket.textCollisionBox.collisionVertexArray);
	                  }
	                  if (bucket.bucketInstanceId in this.collisionCircleArrays) {
	                    var instance = this.collisionCircleArrays[bucket.bucketInstanceId];
	                    bucket.placementInvProjMatrix = instance.invProjMatrix;
	                    bucket.placementViewportMatrix = instance.viewportMatrix;
	                    bucket.collisionCircleArray = instance.circles;
	                    delete this.collisionCircleArrays[bucket.bucketInstanceId];
	                  }
	                };
	                Placement.prototype.symbolFadeChange = function symbolFadeChange(now) {
	                  return this.fadeDuration === 0 ? 1 : (now - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
	                };
	                Placement.prototype.zoomAdjustment = function zoomAdjustment(zoom) {
	                  return Math.max(0, (this.transform.zoom - zoom) / 1.5);
	                };
	                Placement.prototype.hasTransitions = function hasTransitions(now) {
	                  return this.stale || now - this.lastPlacementChangeTime < this.fadeDuration;
	                };
	                Placement.prototype.stillRecent = function stillRecent(now, zoom) {
	                  var durationAdjustment = this.zoomAtLastRecencyCheck === zoom ? 1 - this.zoomAdjustment(zoom) : 1;
	                  this.zoomAtLastRecencyCheck = zoom;
	                  return this.commitTime + this.fadeDuration * durationAdjustment > now;
	                };
	                Placement.prototype.setStale = function setStale() {
	                  this.stale = true;
	                };
	                function updateCollisionVertices(collisionVertexArray, placed, notUsed, shiftX, shiftY) {
	                  collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
	                  collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
	                  collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
	                  collisionVertexArray.emplaceBack(placed ? 1 : 0, notUsed ? 1 : 0, shiftX || 0, shiftY || 0);
	                }
	                var shift25 = Math.pow(2, 25);
	                var shift24 = Math.pow(2, 24);
	                var shift17 = Math.pow(2, 17);
	                var shift16 = Math.pow(2, 16);
	                var shift9 = Math.pow(2, 9);
	                var shift8 = Math.pow(2, 8);
	                var shift1 = Math.pow(2, 1);
	                function packOpacity(opacityState) {
	                  if (opacityState.opacity === 0 && !opacityState.placed) {
	                    return 0;
	                  } else if (opacityState.opacity === 1 && opacityState.placed) {
	                    return 4294967295;
	                  }
	                  var targetBit = opacityState.placed ? 1 : 0;
	                  var opacityBits = Math.floor(opacityState.opacity * 127);
	                  return opacityBits * shift25 + targetBit * shift24 + opacityBits * shift17 + targetBit * shift16 + opacityBits * shift9 + targetBit * shift8 + opacityBits * shift1 + targetBit;
	                }
	                var PACKED_HIDDEN_OPACITY = 0;
	                var LayerPlacement = function LayerPlacement2(styleLayer) {
	                  this._sortAcrossTiles = styleLayer.layout.get("symbol-z-order") !== "viewport-y" && styleLayer.layout.get("symbol-sort-key").constantOr(1) !== undefined;
	                  this._currentTileIndex = 0;
	                  this._currentPartIndex = 0;
	                  this._seenCrossTileIDs = {};
	                  this._bucketParts = [];
	                };
	                LayerPlacement.prototype.continuePlacement = function continuePlacement(tiles, placement, showCollisionBoxes, styleLayer, shouldPausePlacement) {
	                  var bucketParts = this._bucketParts;
	                  while (this._currentTileIndex < tiles.length) {
	                    var tile = tiles[this._currentTileIndex];
	                    placement.getBucketParts(bucketParts, styleLayer, tile, this._sortAcrossTiles);
	                    this._currentTileIndex++;
	                    if (shouldPausePlacement()) {
	                      return true;
	                    }
	                  }
	                  if (this._sortAcrossTiles) {
	                    this._sortAcrossTiles = false;
	                    bucketParts.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                  while (this._currentPartIndex < bucketParts.length) {
	                    var bucketPart = bucketParts[this._currentPartIndex];
	                    placement.placeLayerBucketPart(bucketPart, this._seenCrossTileIDs, showCollisionBoxes);
	                    this._currentPartIndex++;
	                    if (shouldPausePlacement()) {
	                      return true;
	                    }
	                  }
	                  return false;
	                };
	                var PauseablePlacement = function PauseablePlacement2(transform, order, forceFullPlacement, showCollisionBoxes, fadeDuration, crossSourceCollisions, prevPlacement) {
	                  this.placement = new Placement(transform, fadeDuration, crossSourceCollisions, prevPlacement);
	                  this._currentPlacementIndex = order.length - 1;
	                  this._forceFullPlacement = forceFullPlacement;
	                  this._showCollisionBoxes = showCollisionBoxes;
	                  this._done = false;
	                };
	                PauseablePlacement.prototype.isDone = function isDone() {
	                  return this._done;
	                };
	                PauseablePlacement.prototype.continuePlacement = function continuePlacement(order, layers, layerTiles) {
	                  var this$1$1 = this;
	                  var startTime = performance2.browser.now();
	                  var shouldPausePlacement = function() {
	                    var elapsedTime = performance2.browser.now() - startTime;
	                    return this$1$1._forceFullPlacement ? false : elapsedTime > 2;
	                  };
	                  while (this._currentPlacementIndex >= 0) {
	                    var layerId = order[this._currentPlacementIndex];
	                    var layer = layers[layerId];
	                    var placementZoom = this.placement.collisionIndex.transform.zoom;
	                    if (layer.type === "symbol" && (!layer.minzoom || layer.minzoom <= placementZoom) && (!layer.maxzoom || layer.maxzoom > placementZoom)) {
	                      if (!this._inProgressLayer) {
	                        this._inProgressLayer = new LayerPlacement(layer);
	                      }
	                      var pausePlacement = this._inProgressLayer.continuePlacement(layerTiles[layer.source], this.placement, this._showCollisionBoxes, layer, shouldPausePlacement);
	                      if (pausePlacement) {
	                        return;
	                      }
	                      delete this._inProgressLayer;
	                    }
	                    this._currentPlacementIndex--;
	                  }
	                  this._done = true;
	                };
	                PauseablePlacement.prototype.commit = function commit(now) {
	                  this.placement.commit(now);
	                  return this.placement;
	                };
	                var roundingFactor = 512 / performance2.EXTENT / 2;
	                var TileLayerIndex = function TileLayerIndex2(tileID, symbolInstances, bucketInstanceId) {
	                  this.tileID = tileID;
	                  this.indexedSymbolInstances = {};
	                  this.bucketInstanceId = bucketInstanceId;
	                  for (var i = 0; i < symbolInstances.length; i++) {
	                    var symbolInstance = symbolInstances.get(i);
	                    var key = symbolInstance.key;
	                    if (!this.indexedSymbolInstances[key]) {
	                      this.indexedSymbolInstances[key] = [];
	                    }
	                    this.indexedSymbolInstances[key].push({
	                      crossTileID: symbolInstance.crossTileID,
	                      coord: this.getScaledCoordinates(symbolInstance, tileID)
	                    });
	                  }
	                };
	                TileLayerIndex.prototype.getScaledCoordinates = function getScaledCoordinates(symbolInstance, childTileID) {
	                  var zDifference = childTileID.canonical.z - this.tileID.canonical.z;
	                  var scale = roundingFactor / Math.pow(2, zDifference);
	                  return {
	                    x: Math.floor((childTileID.canonical.x * performance2.EXTENT + symbolInstance.anchorX) * scale),
	                    y: Math.floor((childTileID.canonical.y * performance2.EXTENT + symbolInstance.anchorY) * scale)
	                  };
	                };
	                TileLayerIndex.prototype.findMatches = function findMatches(symbolInstances, newTileID, zoomCrossTileIDs) {
	                  var tolerance = this.tileID.canonical.z < newTileID.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - newTileID.canonical.z);
	                  for (var i = 0; i < symbolInstances.length; i++) {
	                    var symbolInstance = symbolInstances.get(i);
	                    if (symbolInstance.crossTileID) {
	                      continue;
	                    }
	                    var indexedInstances = this.indexedSymbolInstances[symbolInstance.key];
	                    if (!indexedInstances) {
	                      continue;
	                    }
	                    var scaledSymbolCoord = this.getScaledCoordinates(symbolInstance, newTileID);
	                    for (var i$1 = 0, list = indexedInstances; i$1 < list.length; i$1 += 1) {
	                      var thisTileSymbol = list[i$1];
	                      if (Math.abs(thisTileSymbol.coord.x - scaledSymbolCoord.x) <= tolerance && Math.abs(thisTileSymbol.coord.y - scaledSymbolCoord.y) <= tolerance && !zoomCrossTileIDs[thisTileSymbol.crossTileID]) {
	                        zoomCrossTileIDs[thisTileSymbol.crossTileID] = true;
	                        symbolInstance.crossTileID = thisTileSymbol.crossTileID;
	                        break;
	                      }
	                    }
	                  }
	                };
	                var CrossTileIDs = function CrossTileIDs2() {
	                  this.maxCrossTileID = 0;
	                };
	                CrossTileIDs.prototype.generate = function generate() {
	                  return ++this.maxCrossTileID;
	                };
	                var CrossTileSymbolLayerIndex = function CrossTileSymbolLayerIndex2() {
	                  this.indexes = {};
	                  this.usedCrossTileIDs = {};
	                  this.lng = 0;
	                };
	                CrossTileSymbolLayerIndex.prototype.handleWrapJump = function handleWrapJump(lng) {
	                  var wrapDelta = Math.round((lng - this.lng) / 360);
	                  if (wrapDelta !== 0) {
	                    for (var zoom in this.indexes) {
	                      var zoomIndexes = this.indexes[zoom];
	                      var newZoomIndex = {};
	                      for (var key in zoomIndexes) {
	                        var index = zoomIndexes[key];
	                        index.tileID = index.tileID.unwrapTo(index.tileID.wrap + wrapDelta);
	                        newZoomIndex[index.tileID.key] = index;
	                      }
	                      this.indexes[zoom] = newZoomIndex;
	                    }
	                  }
	                  this.lng = lng;
	                };
	                CrossTileSymbolLayerIndex.prototype.addBucket = function addBucket(tileID, bucket, crossTileIDs) {
	                  if (this.indexes[tileID.overscaledZ] && this.indexes[tileID.overscaledZ][tileID.key]) {
	                    if (this.indexes[tileID.overscaledZ][tileID.key].bucketInstanceId === bucket.bucketInstanceId) {
	                      return false;
	                    } else {
	                      this.removeBucketCrossTileIDs(tileID.overscaledZ, this.indexes[tileID.overscaledZ][tileID.key]);
	                    }
	                  }
	                  for (var i = 0; i < bucket.symbolInstances.length; i++) {
	                    var symbolInstance = bucket.symbolInstances.get(i);
	                    symbolInstance.crossTileID = 0;
	                  }
	                  if (!this.usedCrossTileIDs[tileID.overscaledZ]) {
	                    this.usedCrossTileIDs[tileID.overscaledZ] = {};
	                  }
	                  var zoomCrossTileIDs = this.usedCrossTileIDs[tileID.overscaledZ];
	                  for (var zoom in this.indexes) {
	                    var zoomIndexes = this.indexes[zoom];
	                    if (Number(zoom) > tileID.overscaledZ) {
	                      for (var id in zoomIndexes) {
	                        var childIndex = zoomIndexes[id];
	                        if (childIndex.tileID.isChildOf(tileID)) {
	                          childIndex.findMatches(bucket.symbolInstances, tileID, zoomCrossTileIDs);
	                        }
	                      }
	                    } else {
	                      var parentCoord = tileID.scaledTo(Number(zoom));
	                      var parentIndex = zoomIndexes[parentCoord.key];
	                      if (parentIndex) {
	                        parentIndex.findMatches(bucket.symbolInstances, tileID, zoomCrossTileIDs);
	                      }
	                    }
	                  }
	                  for (var i$1 = 0; i$1 < bucket.symbolInstances.length; i$1++) {
	                    var symbolInstance$1 = bucket.symbolInstances.get(i$1);
	                    if (!symbolInstance$1.crossTileID) {
	                      symbolInstance$1.crossTileID = crossTileIDs.generate();
	                      zoomCrossTileIDs[symbolInstance$1.crossTileID] = true;
	                    }
	                  }
	                  if (this.indexes[tileID.overscaledZ] === undefined) {
	                    this.indexes[tileID.overscaledZ] = {};
	                  }
	                  this.indexes[tileID.overscaledZ][tileID.key] = new TileLayerIndex(tileID, bucket.symbolInstances, bucket.bucketInstanceId);
	                  return true;
	                };
	                CrossTileSymbolLayerIndex.prototype.removeBucketCrossTileIDs = function removeBucketCrossTileIDs(zoom, removedBucket) {
	                  for (var key in removedBucket.indexedSymbolInstances) {
	                    for (var i = 0, list = removedBucket.indexedSymbolInstances[key]; i < list.length; i += 1) {
	                      var symbolInstance = list[i];
	                      delete this.usedCrossTileIDs[zoom][symbolInstance.crossTileID];
	                    }
	                  }
	                };
	                CrossTileSymbolLayerIndex.prototype.removeStaleBuckets = function removeStaleBuckets(currentIDs) {
	                  var tilesChanged = false;
	                  for (var z in this.indexes) {
	                    var zoomIndexes = this.indexes[z];
	                    for (var tileKey in zoomIndexes) {
	                      if (!currentIDs[zoomIndexes[tileKey].bucketInstanceId]) {
	                        this.removeBucketCrossTileIDs(z, zoomIndexes[tileKey]);
	                        delete zoomIndexes[tileKey];
	                        tilesChanged = true;
	                      }
	                    }
	                  }
	                  return tilesChanged;
	                };
	                var CrossTileSymbolIndex = function CrossTileSymbolIndex2() {
	                  this.layerIndexes = {};
	                  this.crossTileIDs = new CrossTileIDs();
	                  this.maxBucketInstanceId = 0;
	                  this.bucketsInCurrentPlacement = {};
	                };
	                CrossTileSymbolIndex.prototype.addLayer = function addLayer(styleLayer, tiles, lng) {
	                  var layerIndex = this.layerIndexes[styleLayer.id];
	                  if (layerIndex === undefined) {
	                    layerIndex = this.layerIndexes[styleLayer.id] = new CrossTileSymbolLayerIndex();
	                  }
	                  var symbolBucketsChanged = false;
	                  var currentBucketIDs = {};
	                  layerIndex.handleWrapJump(lng);
	                  for (var i = 0, list = tiles; i < list.length; i += 1) {
	                    var tile = list[i];
	                    var symbolBucket = tile.getBucket(styleLayer);
	                    if (!symbolBucket || styleLayer.id !== symbolBucket.layerIds[0]) {
	                      continue;
	                    }
	                    if (!symbolBucket.bucketInstanceId) {
	                      symbolBucket.bucketInstanceId = ++this.maxBucketInstanceId;
	                    }
	                    if (layerIndex.addBucket(tile.tileID, symbolBucket, this.crossTileIDs)) {
	                      symbolBucketsChanged = true;
	                    }
	                    currentBucketIDs[symbolBucket.bucketInstanceId] = true;
	                  }
	                  if (layerIndex.removeStaleBuckets(currentBucketIDs)) {
	                    symbolBucketsChanged = true;
	                  }
	                  return symbolBucketsChanged;
	                };
	                CrossTileSymbolIndex.prototype.pruneUnusedLayers = function pruneUnusedLayers(usedLayers) {
	                  var usedLayerMap = {};
	                  usedLayers.forEach(function(usedLayer) {
	                    usedLayerMap[usedLayer] = true;
	                  });
	                  for (var layerId in this.layerIndexes) {
	                    if (!usedLayerMap[layerId]) {
	                      delete this.layerIndexes[layerId];
	                    }
	                  }
	                };
	                var emitValidationErrors = function(evented, errors) {
	                  return performance2.emitValidationErrors(evented, errors && errors.filter(function(error) {
	                    return error.identifier !== "source.canvas";
	                  }));
	                };
	                var supportedDiffOperations = performance2.pick(operations, [
	                  "addLayer",
	                  "removeLayer",
	                  "setPaintProperty",
	                  "setLayoutProperty",
	                  "setFilter",
	                  "addSource",
	                  "removeSource",
	                  "setLayerZoomRange",
	                  "setLight",
	                  "setTransition",
	                  "setGeoJSONSourceData"
	                ]);
	                var ignoredDiffOperations = performance2.pick(operations, [
	                  "setCenter",
	                  "setZoom",
	                  "setBearing",
	                  "setPitch"
	                ]);
	                var empty = emptyStyle();
	                var Style = function(Evented) {
	                  function Style2(map2, options) {
	                    var this$1$1 = this;
	                    if (options === undefined)
	                      options = {};
	                    Evented.call(this);
	                    this.map = map2;
	                    this.dispatcher = new Dispatcher(getGlobalWorkerPool(), this);
	                    this.imageManager = new ImageManager();
	                    this.imageManager.setEventedParent(this);
	                    this.glyphManager = new GlyphManager(map2._requestManager, options.localIdeographFontFamily);
	                    this.lineAtlas = new LineAtlas(256, 512);
	                    this.crossTileSymbolIndex = new CrossTileSymbolIndex();
	                    this._layers = {};
	                    this._serializedLayers = {};
	                    this._order = [];
	                    this.sourceCaches = {};
	                    this.zoomHistory = new performance2.ZoomHistory();
	                    this._loaded = false;
	                    this._availableImages = [];
	                    this._resetUpdates();
	                    this.dispatcher.broadcast("setReferrer", performance2.getReferrer());
	                    var self2 = this;
	                    this._rtlTextPluginCallback = Style2.registerForPluginStateChange(function(event) {
	                      var state = {
	                        pluginStatus: event.pluginStatus,
	                        pluginURL: event.pluginURL
	                      };
	                      self2.dispatcher.broadcast("syncRTLPluginState", state, function(err, results) {
	                        performance2.triggerPluginCompletionEvent(err);
	                        if (results) {
	                          var allComplete = results.every(function(elem) {
	                            return elem;
	                          });
	                          if (allComplete) {
	                            for (var id in self2.sourceCaches) {
	                              self2.sourceCaches[id].reload();
	                            }
	                          }
	                        }
	                      });
	                    });
	                    this.on("data", function(event) {
	                      if (event.dataType !== "source" || event.sourceDataType !== "metadata") {
	                        return;
	                      }
	                      var sourceCache = this$1$1.sourceCaches[event.sourceId];
	                      if (!sourceCache) {
	                        return;
	                      }
	                      var source = sourceCache.getSource();
	                      if (!source || !source.vectorLayerIds) {
	                        return;
	                      }
	                      for (var layerId in this$1$1._layers) {
	                        var layer = this$1$1._layers[layerId];
	                        if (layer.source === source.id) {
	                          this$1$1._validateLayer(layer);
	                        }
	                      }
	                    });
	                  }
	                  if (Evented)
	                    Style2.__proto__ = Evented;
	                  Style2.prototype = Object.create(Evented && Evented.prototype);
	                  Style2.prototype.constructor = Style2;
	                  Style2.prototype.loadURL = function loadURL(url, options) {
	                    var this$1$1 = this;
	                    if (options === undefined)
	                      options = {};
	                    this.fire(new performance2.Event("dataloading", { dataType: "style" }));
	                    var validate = typeof options.validate === "boolean" ? options.validate : !performance2.isMapboxURL(url);
	                    url = this.map._requestManager.normalizeStyleURL(url, options.accessToken);
	                    var request = this.map._requestManager.transformRequest(url, performance2.ResourceType.Style);
	                    this._request = performance2.getJSON(request, function(error, json) {
	                      this$1$1._request = null;
	                      if (error) {
	                        this$1$1.fire(new performance2.ErrorEvent(error));
	                      } else if (json) {
	                        this$1$1._load(json, validate);
	                      }
	                    });
	                  };
	                  Style2.prototype.loadJSON = function loadJSON(json, options) {
	                    var this$1$1 = this;
	                    if (options === undefined)
	                      options = {};
	                    this.fire(new performance2.Event("dataloading", { dataType: "style" }));
	                    this._request = performance2.browser.frame(function() {
	                      this$1$1._request = null;
	                      this$1$1._load(json, options.validate !== false);
	                    });
	                  };
	                  Style2.prototype.loadEmpty = function loadEmpty() {
	                    this.fire(new performance2.Event("dataloading", { dataType: "style" }));
	                    this._load(empty, false);
	                  };
	                  Style2.prototype._load = function _load(json, validate) {
	                    if (validate && emitValidationErrors(this, performance2.validateStyle(json))) {
	                      return;
	                    }
	                    this._loaded = true;
	                    this.stylesheet = json;
	                    for (var id in json.sources) {
	                      this.addSource(id, json.sources[id], { validate: false });
	                    }
	                    if (json.sprite) {
	                      this._loadSprite(json.sprite);
	                    } else {
	                      this.imageManager.setLoaded(true);
	                    }
	                    this.glyphManager.setURL(json.glyphs);
	                    var layers = derefLayers(this.stylesheet.layers);
	                    this._order = layers.map(function(layer2) {
	                      return layer2.id;
	                    });
	                    this._layers = {};
	                    this._serializedLayers = {};
	                    for (var i = 0, list = layers; i < list.length; i += 1) {
	                      var layer = list[i];
	                      layer = performance2.createStyleLayer(layer);
	                      layer.setEventedParent(this, { layer: { id: layer.id } });
	                      this._layers[layer.id] = layer;
	                      this._serializedLayers[layer.id] = layer.serialize();
	                    }
	                    this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order));
	                    this.light = new Light(this.stylesheet.light);
	                    this.fire(new performance2.Event("data", { dataType: "style" }));
	                    this.fire(new performance2.Event("style.load"));
	                  };
	                  Style2.prototype._loadSprite = function _loadSprite(url) {
	                    var this$1$1 = this;
	                    this._spriteRequest = loadSprite(url, this.map._requestManager, function(err, images) {
	                      this$1$1._spriteRequest = null;
	                      if (err) {
	                        this$1$1.fire(new performance2.ErrorEvent(err));
	                      } else if (images) {
	                        for (var id in images) {
	                          this$1$1.imageManager.addImage(id, images[id]);
	                        }
	                      }
	                      this$1$1.imageManager.setLoaded(true);
	                      this$1$1._availableImages = this$1$1.imageManager.listImages();
	                      this$1$1.dispatcher.broadcast("setImages", this$1$1._availableImages);
	                      this$1$1.fire(new performance2.Event("data", { dataType: "style" }));
	                    });
	                  };
	                  Style2.prototype._validateLayer = function _validateLayer(layer) {
	                    var sourceCache = this.sourceCaches[layer.source];
	                    if (!sourceCache) {
	                      return;
	                    }
	                    var sourceLayer = layer.sourceLayer;
	                    if (!sourceLayer) {
	                      return;
	                    }
	                    var source = sourceCache.getSource();
	                    if (source.type === "geojson" || source.vectorLayerIds && source.vectorLayerIds.indexOf(sourceLayer) === -1) {
	                      this.fire(new performance2.ErrorEvent(new Error('Source layer "' + sourceLayer + '" does not exist on source "' + source.id + '" as specified by style layer "' + layer.id + '"')));
	                    }
	                  };
	                  Style2.prototype.loaded = function loaded() {
	                    if (!this._loaded) {
	                      return false;
	                    }
	                    if (Object.keys(this._updatedSources).length) {
	                      return false;
	                    }
	                    for (var id in this.sourceCaches) {
	                      if (!this.sourceCaches[id].loaded()) {
	                        return false;
	                      }
	                    }
	                    if (!this.imageManager.isLoaded()) {
	                      return false;
	                    }
	                    return true;
	                  };
	                  Style2.prototype._serializeLayers = function _serializeLayers(ids) {
	                    var serializedLayers = [];
	                    for (var i = 0, list = ids; i < list.length; i += 1) {
	                      var id = list[i];
	                      var layer = this._layers[id];
	                      if (layer.type !== "custom") {
	                        serializedLayers.push(layer.serialize());
	                      }
	                    }
	                    return serializedLayers;
	                  };
	                  Style2.prototype.hasTransitions = function hasTransitions() {
	                    if (this.light && this.light.hasTransition()) {
	                      return true;
	                    }
	                    for (var id in this.sourceCaches) {
	                      if (this.sourceCaches[id].hasTransition()) {
	                        return true;
	                      }
	                    }
	                    for (var id$1 in this._layers) {
	                      if (this._layers[id$1].hasTransition()) {
	                        return true;
	                      }
	                    }
	                    return false;
	                  };
	                  Style2.prototype._checkLoaded = function _checkLoaded() {
	                    if (!this._loaded) {
	                      throw new Error("Style is not done loading");
	                    }
	                  };
	                  Style2.prototype.update = function update(parameters) {
	                    if (!this._loaded) {
	                      return;
	                    }
	                    var changed = this._changed;
	                    if (this._changed) {
	                      var updatedIds = Object.keys(this._updatedLayers);
	                      var removedIds = Object.keys(this._removedLayers);
	                      if (updatedIds.length || removedIds.length) {
	                        this._updateWorkerLayers(updatedIds, removedIds);
	                      }
	                      for (var id in this._updatedSources) {
	                        var action = this._updatedSources[id];
	                        if (action === "reload") {
	                          this._reloadSource(id);
	                        } else if (action === "clear") {
	                          this._clearSource(id);
	                        }
	                      }
	                      this._updateTilesForChangedImages();
	                      for (var id$1 in this._updatedPaintProps) {
	                        this._layers[id$1].updateTransitions(parameters);
	                      }
	                      this.light.updateTransitions(parameters);
	                      this._resetUpdates();
	                    }
	                    for (var sourceId in this.sourceCaches) {
	                      this.sourceCaches[sourceId].used = false;
	                    }
	                    for (var i = 0, list = this._order; i < list.length; i += 1) {
	                      var layerId = list[i];
	                      var layer = this._layers[layerId];
	                      layer.recalculate(parameters, this._availableImages);
	                      if (!layer.isHidden(parameters.zoom) && layer.source) {
	                        this.sourceCaches[layer.source].used = true;
	                      }
	                    }
	                    this.light.recalculate(parameters);
	                    this.z = parameters.zoom;
	                    if (changed) {
	                      this.fire(new performance2.Event("data", { dataType: "style" }));
	                    }
	                  };
	                  Style2.prototype._updateTilesForChangedImages = function _updateTilesForChangedImages() {
	                    var changedImages = Object.keys(this._changedImages);
	                    if (changedImages.length) {
	                      for (var name2 in this.sourceCaches) {
	                        this.sourceCaches[name2].reloadTilesForDependencies([
	                          "icons",
	                          "patterns"
	                        ], changedImages);
	                      }
	                      this._changedImages = {};
	                    }
	                  };
	                  Style2.prototype._updateWorkerLayers = function _updateWorkerLayers(updatedIds, removedIds) {
	                    this.dispatcher.broadcast("updateLayers", {
	                      layers: this._serializeLayers(updatedIds),
	                      removedIds
	                    });
	                  };
	                  Style2.prototype._resetUpdates = function _resetUpdates() {
	                    this._changed = false;
	                    this._updatedLayers = {};
	                    this._removedLayers = {};
	                    this._updatedSources = {};
	                    this._updatedPaintProps = {};
	                    this._changedImages = {};
	                  };
	                  Style2.prototype.setState = function setState(nextState) {
	                    var this$1$1 = this;
	                    this._checkLoaded();
	                    if (emitValidationErrors(this, performance2.validateStyle(nextState))) {
	                      return false;
	                    }
	                    nextState = performance2.clone$1(nextState);
	                    nextState.layers = derefLayers(nextState.layers);
	                    var changes = diffStyles(this.serialize(), nextState).filter(function(op) {
	                      return !(op.command in ignoredDiffOperations);
	                    });
	                    if (changes.length === 0) {
	                      return false;
	                    }
	                    var unimplementedOps = changes.filter(function(op) {
	                      return !(op.command in supportedDiffOperations);
	                    });
	                    if (unimplementedOps.length > 0) {
	                      throw new Error("Unimplemented: " + unimplementedOps.map(function(op) {
	                        return op.command;
	                      }).join(", ") + ".");
	                    }
	                    changes.forEach(function(op) {
	                      if (op.command === "setTransition") {
	                        return;
	                      }
	                      this$1$1[op.command].apply(this$1$1, op.args);
	                    });
	                    this.stylesheet = nextState;
	                    return true;
	                  };
	                  Style2.prototype.addImage = function addImage(id, image) {
	                    if (this.getImage(id)) {
	                      return this.fire(new performance2.ErrorEvent(new Error("An image with this name already exists.")));
	                    }
	                    this.imageManager.addImage(id, image);
	                    this._availableImages = this.imageManager.listImages();
	                    this._changedImages[id] = true;
	                    this._changed = true;
	                    this.fire(new performance2.Event("data", { dataType: "style" }));
	                  };
	                  Style2.prototype.updateImage = function updateImage(id, image) {
	                    this.imageManager.updateImage(id, image);
	                  };
	                  Style2.prototype.getImage = function getImage(id) {
	                    return this.imageManager.getImage(id);
	                  };
	                  Style2.prototype.removeImage = function removeImage(id) {
	                    if (!this.getImage(id)) {
	                      return this.fire(new performance2.ErrorEvent(new Error("No image with this name exists.")));
	                    }
	                    this.imageManager.removeImage(id);
	                    this._availableImages = this.imageManager.listImages();
	                    this._changedImages[id] = true;
	                    this._changed = true;
	                    this.fire(new performance2.Event("data", { dataType: "style" }));
	                  };
	                  Style2.prototype.listImages = function listImages() {
	                    this._checkLoaded();
	                    return this.imageManager.listImages();
	                  };
	                  Style2.prototype.addSource = function addSource2(id, source, options) {
	                    var this$1$1 = this;
	                    if (options === undefined)
	                      options = {};
	                    this._checkLoaded();
	                    if (this.sourceCaches[id] !== undefined) {
	                      throw new Error("There is already a source with this ID");
	                    }
	                    if (!source.type) {
	                      throw new Error("The type property must be defined, but the only the following properties were given: " + Object.keys(source).join(", ") + ".");
	                    }
	                    var builtIns = [
	                      "vector",
	                      "raster",
	                      "geojson",
	                      "video",
	                      "image"
	                    ];
	                    var shouldValidate = builtIns.indexOf(source.type) >= 0;
	                    if (shouldValidate && this._validate(performance2.validateStyle.source, "sources." + id, source, null, options)) {
	                      return;
	                    }
	                    if (this.map && this.map._collectResourceTiming) {
	                      source.collectResourceTiming = true;
	                    }
	                    var sourceCache = this.sourceCaches[id] = new SourceCache(id, source, this.dispatcher);
	                    sourceCache.style = this;
	                    sourceCache.setEventedParent(this, function() {
	                      return {
	                        isSourceLoaded: this$1$1.loaded(),
	                        source: sourceCache.serialize(),
	                        sourceId: id
	                      };
	                    });
	                    sourceCache.onAdd(this.map);
	                    this._changed = true;
	                  };
	                  Style2.prototype.removeSource = function removeSource2(id) {
	                    this._checkLoaded();
	                    if (this.sourceCaches[id] === undefined) {
	                      throw new Error("There is no source with this ID");
	                    }
	                    for (var layerId in this._layers) {
	                      if (this._layers[layerId].source === id) {
	                        return this.fire(new performance2.ErrorEvent(new Error('Source "' + id + '" cannot be removed while layer "' + layerId + '" is using it.')));
	                      }
	                    }
	                    var sourceCache = this.sourceCaches[id];
	                    delete this.sourceCaches[id];
	                    delete this._updatedSources[id];
	                    sourceCache.fire(new performance2.Event("data", {
	                      sourceDataType: "metadata",
	                      dataType: "source",
	                      sourceId: id
	                    }));
	                    sourceCache.setEventedParent(null);
	                    sourceCache.clearTiles();
	                    if (sourceCache.onRemove) {
	                      sourceCache.onRemove(this.map);
	                    }
	                    this._changed = true;
	                  };
	                  Style2.prototype.setGeoJSONSourceData = function setGeoJSONSourceData(id, data) {
	                    this._checkLoaded();
	                    var geojsonSource = this.sourceCaches[id].getSource();
	                    geojsonSource.setData(data);
	                    this._changed = true;
	                  };
	                  Style2.prototype.getSource = function getSource(id) {
	                    return this.sourceCaches[id] && this.sourceCaches[id].getSource();
	                  };
	                  Style2.prototype.addLayer = function addLayer(layerObject, before, options) {
	                    if (options === undefined)
	                      options = {};
	                    this._checkLoaded();
	                    var id = layerObject.id;
	                    if (this.getLayer(id)) {
	                      this.fire(new performance2.ErrorEvent(new Error('Layer with id "' + id + '" already exists on this map')));
	                      return;
	                    }
	                    var layer;
	                    if (layerObject.type === "custom") {
	                      if (emitValidationErrors(this, performance2.validateCustomStyleLayer(layerObject))) {
	                        return;
	                      }
	                      layer = performance2.createStyleLayer(layerObject);
	                    } else {
	                      if (typeof layerObject.source === "object") {
	                        this.addSource(id, layerObject.source);
	                        layerObject = performance2.clone$1(layerObject);
	                        layerObject = performance2.extend(layerObject, { source: id });
	                      }
	                      if (this._validate(performance2.validateStyle.layer, "layers." + id, layerObject, { arrayIndex: -1 }, options)) {
	                        return;
	                      }
	                      layer = performance2.createStyleLayer(layerObject);
	                      this._validateLayer(layer);
	                      layer.setEventedParent(this, { layer: { id } });
	                      this._serializedLayers[layer.id] = layer.serialize();
	                    }
	                    var index = before ? this._order.indexOf(before) : this._order.length;
	                    if (before && index === -1) {
	                      this.fire(new performance2.ErrorEvent(new Error('Layer with id "' + before + '" does not exist on this map.')));
	                      return;
	                    }
	                    this._order.splice(index, 0, id);
	                    this._layerOrderChanged = true;
	                    this._layers[id] = layer;
	                    if (this._removedLayers[id] && layer.source && layer.type !== "custom") {
	                      var removed = this._removedLayers[id];
	                      delete this._removedLayers[id];
	                      if (removed.type !== layer.type) {
	                        this._updatedSources[layer.source] = "clear";
	                      } else {
	                        this._updatedSources[layer.source] = "reload";
	                        this.sourceCaches[layer.source].pause();
	                      }
	                    }
	                    this._updateLayer(layer);
	                    if (layer.onAdd) {
	                      layer.onAdd(this.map);
	                    }
	                  };
	                  Style2.prototype.moveLayer = function moveLayer(id, before) {
	                    this._checkLoaded();
	                    this._changed = true;
	                    var layer = this._layers[id];
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + id + "' does not exist in the map's style and cannot be moved.")));
	                      return;
	                    }
	                    if (id === before) {
	                      return;
	                    }
	                    var index = this._order.indexOf(id);
	                    this._order.splice(index, 1);
	                    var newIndex = before ? this._order.indexOf(before) : this._order.length;
	                    if (before && newIndex === -1) {
	                      this.fire(new performance2.ErrorEvent(new Error('Layer with id "' + before + '" does not exist on this map.')));
	                      return;
	                    }
	                    this._order.splice(newIndex, 0, id);
	                    this._layerOrderChanged = true;
	                  };
	                  Style2.prototype.removeLayer = function removeLayer(id) {
	                    this._checkLoaded();
	                    var layer = this._layers[id];
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + id + "' does not exist in the map's style and cannot be removed.")));
	                      return;
	                    }
	                    layer.setEventedParent(null);
	                    var index = this._order.indexOf(id);
	                    this._order.splice(index, 1);
	                    this._layerOrderChanged = true;
	                    this._changed = true;
	                    this._removedLayers[id] = layer;
	                    delete this._layers[id];
	                    delete this._serializedLayers[id];
	                    delete this._updatedLayers[id];
	                    delete this._updatedPaintProps[id];
	                    if (layer.onRemove) {
	                      layer.onRemove(this.map);
	                    }
	                  };
	                  Style2.prototype.getLayer = function getLayer(id) {
	                    return this._layers[id];
	                  };
	                  Style2.prototype.hasLayer = function hasLayer(id) {
	                    return id in this._layers;
	                  };
	                  Style2.prototype.setLayerZoomRange = function setLayerZoomRange(layerId, minzoom, maxzoom) {
	                    this._checkLoaded();
	                    var layer = this.getLayer(layerId);
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + layerId + "' does not exist in the map's style and cannot have zoom extent.")));
	                      return;
	                    }
	                    if (layer.minzoom === minzoom && layer.maxzoom === maxzoom) {
	                      return;
	                    }
	                    if (minzoom != null) {
	                      layer.minzoom = minzoom;
	                    }
	                    if (maxzoom != null) {
	                      layer.maxzoom = maxzoom;
	                    }
	                    this._updateLayer(layer);
	                  };
	                  Style2.prototype.setFilter = function setFilter(layerId, filter, options) {
	                    if (options === undefined)
	                      options = {};
	                    this._checkLoaded();
	                    var layer = this.getLayer(layerId);
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + layerId + "' does not exist in the map's style and cannot be filtered.")));
	                      return;
	                    }
	                    if (performance2.deepEqual(layer.filter, filter)) {
	                      return;
	                    }
	                    if (filter === null || filter === undefined) {
	                      layer.filter = undefined;
	                      this._updateLayer(layer);
	                      return;
	                    }
	                    if (this._validate(performance2.validateStyle.filter, "layers." + layer.id + ".filter", filter, null, options)) {
	                      return;
	                    }
	                    layer.filter = performance2.clone$1(filter);
	                    this._updateLayer(layer);
	                  };
	                  Style2.prototype.getFilter = function getFilter(layer) {
	                    return performance2.clone$1(this.getLayer(layer).filter);
	                  };
	                  Style2.prototype.setLayoutProperty = function setLayoutProperty(layerId, name2, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    this._checkLoaded();
	                    var layer = this.getLayer(layerId);
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + layerId + "' does not exist in the map's style and cannot be styled.")));
	                      return;
	                    }
	                    if (performance2.deepEqual(layer.getLayoutProperty(name2), value)) {
	                      return;
	                    }
	                    layer.setLayoutProperty(name2, value, options);
	                    this._updateLayer(layer);
	                  };
	                  Style2.prototype.getLayoutProperty = function getLayoutProperty(layerId, name2) {
	                    var layer = this.getLayer(layerId);
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + layerId + "' does not exist in the map's style.")));
	                      return;
	                    }
	                    return layer.getLayoutProperty(name2);
	                  };
	                  Style2.prototype.setPaintProperty = function setPaintProperty(layerId, name2, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    this._checkLoaded();
	                    var layer = this.getLayer(layerId);
	                    if (!layer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The layer '" + layerId + "' does not exist in the map's style and cannot be styled.")));
	                      return;
	                    }
	                    if (performance2.deepEqual(layer.getPaintProperty(name2), value)) {
	                      return;
	                    }
	                    var requiresRelayout = layer.setPaintProperty(name2, value, options);
	                    if (requiresRelayout) {
	                      this._updateLayer(layer);
	                    }
	                    this._changed = true;
	                    this._updatedPaintProps[layerId] = true;
	                  };
	                  Style2.prototype.getPaintProperty = function getPaintProperty(layer, name2) {
	                    return this.getLayer(layer).getPaintProperty(name2);
	                  };
	                  Style2.prototype.setFeatureState = function setFeatureState(target, state) {
	                    this._checkLoaded();
	                    var sourceId = target.source;
	                    var sourceLayer = target.sourceLayer;
	                    var sourceCache = this.sourceCaches[sourceId];
	                    if (sourceCache === undefined) {
	                      this.fire(new performance2.ErrorEvent(new Error("The source '" + sourceId + "' does not exist in the map's style.")));
	                      return;
	                    }
	                    var sourceType = sourceCache.getSource().type;
	                    if (sourceType === "geojson" && sourceLayer) {
	                      this.fire(new performance2.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
	                      return;
	                    }
	                    if (sourceType === "vector" && !sourceLayer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
	                      return;
	                    }
	                    if (target.id === undefined) {
	                      this.fire(new performance2.ErrorEvent(new Error("The feature id parameter must be provided.")));
	                    }
	                    sourceCache.setFeatureState(sourceLayer, target.id, state);
	                  };
	                  Style2.prototype.removeFeatureState = function removeFeatureState(target, key) {
	                    this._checkLoaded();
	                    var sourceId = target.source;
	                    var sourceCache = this.sourceCaches[sourceId];
	                    if (sourceCache === undefined) {
	                      this.fire(new performance2.ErrorEvent(new Error("The source '" + sourceId + "' does not exist in the map's style.")));
	                      return;
	                    }
	                    var sourceType = sourceCache.getSource().type;
	                    var sourceLayer = sourceType === "vector" ? target.sourceLayer : undefined;
	                    if (sourceType === "vector" && !sourceLayer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
	                      return;
	                    }
	                    if (key && (typeof target.id !== "string" && typeof target.id !== "number")) {
	                      this.fire(new performance2.ErrorEvent(new Error("A feature id is requred to remove its specific state property.")));
	                      return;
	                    }
	                    sourceCache.removeFeatureState(sourceLayer, target.id, key);
	                  };
	                  Style2.prototype.getFeatureState = function getFeatureState(target) {
	                    this._checkLoaded();
	                    var sourceId = target.source;
	                    var sourceLayer = target.sourceLayer;
	                    var sourceCache = this.sourceCaches[sourceId];
	                    if (sourceCache === undefined) {
	                      this.fire(new performance2.ErrorEvent(new Error("The source '" + sourceId + "' does not exist in the map's style.")));
	                      return;
	                    }
	                    var sourceType = sourceCache.getSource().type;
	                    if (sourceType === "vector" && !sourceLayer) {
	                      this.fire(new performance2.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
	                      return;
	                    }
	                    if (target.id === undefined) {
	                      this.fire(new performance2.ErrorEvent(new Error("The feature id parameter must be provided.")));
	                    }
	                    return sourceCache.getFeatureState(sourceLayer, target.id);
	                  };
	                  Style2.prototype.getTransition = function getTransition() {
	                    return performance2.extend({
	                      duration: 300,
	                      delay: 0
	                    }, this.stylesheet && this.stylesheet.transition);
	                  };
	                  Style2.prototype.serialize = function serialize() {
	                    return performance2.filterObject({
	                      version: this.stylesheet.version,
	                      name: this.stylesheet.name,
	                      metadata: this.stylesheet.metadata,
	                      light: this.stylesheet.light,
	                      center: this.stylesheet.center,
	                      zoom: this.stylesheet.zoom,
	                      bearing: this.stylesheet.bearing,
	                      pitch: this.stylesheet.pitch,
	                      sprite: this.stylesheet.sprite,
	                      glyphs: this.stylesheet.glyphs,
	                      transition: this.stylesheet.transition,
	                      sources: performance2.mapObject(this.sourceCaches, function(source) {
	                        return source.serialize();
	                      }),
	                      layers: this._serializeLayers(this._order)
	                    }, function(value) {
	                      return value !== undefined;
	                    });
	                  };
	                  Style2.prototype._updateLayer = function _updateLayer(layer) {
	                    this._updatedLayers[layer.id] = true;
	                    if (layer.source && !this._updatedSources[layer.source] && this.sourceCaches[layer.source].getSource().type !== "raster") {
	                      this._updatedSources[layer.source] = "reload";
	                      this.sourceCaches[layer.source].pause();
	                    }
	                    this._changed = true;
	                  };
	                  Style2.prototype._flattenAndSortRenderedFeatures = function _flattenAndSortRenderedFeatures(sourceResults) {
	                    var this$1$1 = this;
	                    var isLayer3D = function(layerId2) {
	                      return this$1$1._layers[layerId2].type === "fill-extrusion";
	                    };
	                    var layerIndex = {};
	                    var features3D = [];
	                    for (var l = this._order.length - 1; l >= 0; l--) {
	                      var layerId = this._order[l];
	                      if (isLayer3D(layerId)) {
	                        layerIndex[layerId] = l;
	                        for (var i$2 = 0, list$1 = sourceResults; i$2 < list$1.length; i$2 += 1) {
	                          var sourceResult = list$1[i$2];
	                          var layerFeatures = sourceResult[layerId];
	                          if (layerFeatures) {
	                            for (var i$1 = 0, list = layerFeatures; i$1 < list.length; i$1 += 1) {
	                              var featureWrapper = list[i$1];
	                              features3D.push(featureWrapper);
	                            }
	                          }
	                        }
	                      }
	                    }
	                    features3D.sort(function(a, b) {
	                      return b.intersectionZ - a.intersectionZ;
	                    });
	                    var features = [];
	                    for (var l$1 = this._order.length - 1; l$1 >= 0; l$1--) {
	                      var layerId$1 = this._order[l$1];
	                      if (isLayer3D(layerId$1)) {
	                        for (var i = features3D.length - 1; i >= 0; i--) {
	                          var topmost3D = features3D[i].feature;
	                          if (layerIndex[topmost3D.layer.id] < l$1) {
	                            break;
	                          }
	                          features.push(topmost3D);
	                          features3D.pop();
	                        }
	                      } else {
	                        for (var i$4 = 0, list$3 = sourceResults; i$4 < list$3.length; i$4 += 1) {
	                          var sourceResult$1 = list$3[i$4];
	                          var layerFeatures$1 = sourceResult$1[layerId$1];
	                          if (layerFeatures$1) {
	                            for (var i$3 = 0, list$2 = layerFeatures$1; i$3 < list$2.length; i$3 += 1) {
	                              var featureWrapper$1 = list$2[i$3];
	                              features.push(featureWrapper$1.feature);
	                            }
	                          }
	                        }
	                      }
	                    }
	                    return features;
	                  };
	                  Style2.prototype.queryRenderedFeatures = function queryRenderedFeatures$1(queryGeometry, params, transform) {
	                    if (params && params.filter) {
	                      this._validate(performance2.validateStyle.filter, "queryRenderedFeatures.filter", params.filter, null, params);
	                    }
	                    var includedSources = {};
	                    if (params && params.layers) {
	                      if (!Array.isArray(params.layers)) {
	                        this.fire(new performance2.ErrorEvent(new Error("parameters.layers must be an Array.")));
	                        return [];
	                      }
	                      for (var i = 0, list = params.layers; i < list.length; i += 1) {
	                        var layerId = list[i];
	                        var layer = this._layers[layerId];
	                        if (!layer) {
	                          this.fire(new performance2.ErrorEvent(new Error("The layer '" + layerId + "' does not exist in the map's style and cannot be queried for features.")));
	                          return [];
	                        }
	                        includedSources[layer.source] = true;
	                      }
	                    }
	                    var sourceResults = [];
	                    params.availableImages = this._availableImages;
	                    for (var id in this.sourceCaches) {
	                      if (params.layers && !includedSources[id]) {
	                        continue;
	                      }
	                      sourceResults.push(queryRenderedFeatures(this.sourceCaches[id], this._layers, this._serializedLayers, queryGeometry, params, transform));
	                    }
	                    if (this.placement) {
	                      sourceResults.push(queryRenderedSymbols(this._layers, this._serializedLayers, this.sourceCaches, queryGeometry, params, this.placement.collisionIndex, this.placement.retainedQueryData));
	                    }
	                    return this._flattenAndSortRenderedFeatures(sourceResults);
	                  };
	                  Style2.prototype.querySourceFeatures = function querySourceFeatures$1(sourceID, params) {
	                    if (params && params.filter) {
	                      this._validate(performance2.validateStyle.filter, "querySourceFeatures.filter", params.filter, null, params);
	                    }
	                    var sourceCache = this.sourceCaches[sourceID];
	                    return sourceCache ? querySourceFeatures(sourceCache, params) : [];
	                  };
	                  Style2.prototype.addSourceType = function addSourceType(name2, SourceType, callback) {
	                    if (Style2.getSourceType(name2)) {
	                      return callback(new Error('A source type called "' + name2 + '" already exists.'));
	                    }
	                    Style2.setSourceType(name2, SourceType);
	                    if (!SourceType.workerSourceURL) {
	                      return callback(null, null);
	                    }
	                    this.dispatcher.broadcast("loadWorkerSource", {
	                      name: name2,
	                      url: SourceType.workerSourceURL
	                    }, callback);
	                  };
	                  Style2.prototype.getLight = function getLight() {
	                    return this.light.getLight();
	                  };
	                  Style2.prototype.setLight = function setLight(lightOptions, options) {
	                    if (options === undefined)
	                      options = {};
	                    this._checkLoaded();
	                    var light = this.light.getLight();
	                    var _update = false;
	                    for (var key in lightOptions) {
	                      if (!performance2.deepEqual(lightOptions[key], light[key])) {
	                        _update = true;
	                        break;
	                      }
	                    }
	                    if (!_update) {
	                      return;
	                    }
	                    var parameters = {
	                      now: performance2.browser.now(),
	                      transition: performance2.extend({
	                        duration: 300,
	                        delay: 0
	                      }, this.stylesheet.transition)
	                    };
	                    this.light.setLight(lightOptions, options);
	                    this.light.updateTransitions(parameters);
	                  };
	                  Style2.prototype._validate = function _validate(validate, key, value, props, options) {
	                    if (options === undefined)
	                      options = {};
	                    if (options && options.validate === false) {
	                      return false;
	                    }
	                    return emitValidationErrors(this, validate.call(performance2.validateStyle, performance2.extend({
	                      key,
	                      style: this.serialize(),
	                      value,
	                      styleSpec: performance2.styleSpec
	                    }, props)));
	                  };
	                  Style2.prototype._remove = function _remove() {
	                    if (this._request) {
	                      this._request.cancel();
	                      this._request = null;
	                    }
	                    if (this._spriteRequest) {
	                      this._spriteRequest.cancel();
	                      this._spriteRequest = null;
	                    }
	                    performance2.evented.off("pluginStateChange", this._rtlTextPluginCallback);
	                    for (var layerId in this._layers) {
	                      var layer = this._layers[layerId];
	                      layer.setEventedParent(null);
	                    }
	                    for (var id in this.sourceCaches) {
	                      this.sourceCaches[id].clearTiles();
	                      this.sourceCaches[id].setEventedParent(null);
	                    }
	                    this.imageManager.setEventedParent(null);
	                    this.setEventedParent(null);
	                    this.dispatcher.remove();
	                  };
	                  Style2.prototype._clearSource = function _clearSource(id) {
	                    this.sourceCaches[id].clearTiles();
	                  };
	                  Style2.prototype._reloadSource = function _reloadSource(id) {
	                    this.sourceCaches[id].resume();
	                    this.sourceCaches[id].reload();
	                  };
	                  Style2.prototype._updateSources = function _updateSources(transform) {
	                    for (var id in this.sourceCaches) {
	                      this.sourceCaches[id].update(transform);
	                    }
	                  };
	                  Style2.prototype._generateCollisionBoxes = function _generateCollisionBoxes() {
	                    for (var id in this.sourceCaches) {
	                      this._reloadSource(id);
	                    }
	                  };
	                  Style2.prototype._updatePlacement = function _updatePlacement(transform, showCollisionBoxes, fadeDuration, crossSourceCollisions, forceFullPlacement) {
	                    if (forceFullPlacement === undefined)
	                      forceFullPlacement = false;
	                    var symbolBucketsChanged = false;
	                    var placementCommitted = false;
	                    var layerTiles = {};
	                    for (var i = 0, list = this._order; i < list.length; i += 1) {
	                      var layerID = list[i];
	                      var styleLayer = this._layers[layerID];
	                      if (styleLayer.type !== "symbol") {
	                        continue;
	                      }
	                      if (!layerTiles[styleLayer.source]) {
	                        var sourceCache = this.sourceCaches[styleLayer.source];
	                        layerTiles[styleLayer.source] = sourceCache.getRenderableIds(true).map(function(id) {
	                          return sourceCache.getTileByID(id);
	                        }).sort(function(a, b) {
	                          return b.tileID.overscaledZ - a.tileID.overscaledZ || (a.tileID.isLessThan(b.tileID) ? -1 : 1);
	                        });
	                      }
	                      var layerBucketsChanged = this.crossTileSymbolIndex.addLayer(styleLayer, layerTiles[styleLayer.source], transform.center.lng);
	                      symbolBucketsChanged = symbolBucketsChanged || layerBucketsChanged;
	                    }
	                    this.crossTileSymbolIndex.pruneUnusedLayers(this._order);
	                    forceFullPlacement = forceFullPlacement || this._layerOrderChanged || fadeDuration === 0;
	                    if (forceFullPlacement || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(performance2.browser.now(), transform.zoom)) {
	                      this.pauseablePlacement = new PauseablePlacement(transform, this._order, forceFullPlacement, showCollisionBoxes, fadeDuration, crossSourceCollisions, this.placement);
	                      this._layerOrderChanged = false;
	                    }
	                    if (this.pauseablePlacement.isDone()) {
	                      this.placement.setStale();
	                    } else {
	                      this.pauseablePlacement.continuePlacement(this._order, this._layers, layerTiles);
	                      if (this.pauseablePlacement.isDone()) {
	                        this.placement = this.pauseablePlacement.commit(performance2.browser.now());
	                        placementCommitted = true;
	                      }
	                      if (symbolBucketsChanged) {
	                        this.pauseablePlacement.placement.setStale();
	                      }
	                    }
	                    if (placementCommitted || symbolBucketsChanged) {
	                      for (var i$1 = 0, list$1 = this._order; i$1 < list$1.length; i$1 += 1) {
	                        var layerID$1 = list$1[i$1];
	                        var styleLayer$1 = this._layers[layerID$1];
	                        if (styleLayer$1.type !== "symbol") {
	                          continue;
	                        }
	                        this.placement.updateLayerOpacities(styleLayer$1, layerTiles[styleLayer$1.source]);
	                      }
	                    }
	                    var needsRerender = !this.pauseablePlacement.isDone() || this.placement.hasTransitions(performance2.browser.now());
	                    return needsRerender;
	                  };
	                  Style2.prototype._releaseSymbolFadeTiles = function _releaseSymbolFadeTiles() {
	                    for (var id in this.sourceCaches) {
	                      this.sourceCaches[id].releaseSymbolFadeTiles();
	                    }
	                  };
	                  Style2.prototype.getImages = function getImages(mapId, params, callback) {
	                    this.imageManager.getImages(params.icons, callback);
	                    this._updateTilesForChangedImages();
	                    var sourceCache = this.sourceCaches[params.source];
	                    if (sourceCache) {
	                      sourceCache.setDependencies(params.tileID.key, params.type, params.icons);
	                    }
	                  };
	                  Style2.prototype.getGlyphs = function getGlyphs(mapId, params, callback) {
	                    this.glyphManager.getGlyphs(params.stacks, callback);
	                  };
	                  Style2.prototype.getResource = function getResource(mapId, params, callback) {
	                    return performance2.makeRequest(params, callback);
	                  };
	                  return Style2;
	                }(performance2.Evented);
	                Style.getSourceType = getType;
	                Style.setSourceType = setType;
	                Style.registerForPluginStateChange = performance2.registerForPluginStateChange;
	                var posAttributes = performance2.createLayout([{
	                  name: "a_pos",
	                  type: "Int16",
	                  components: 2
	                }]);
	                var preludeFrag = "#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif";
	                var preludeVert = "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}";
	                var backgroundFrag = "uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var backgroundVert = "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}";
	                var backgroundPatternFrag = "uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var backgroundPatternVert = "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}";
	                var circleFrag = "varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var circleVert = "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}";
	                var clippingMaskFrag = "void main() {gl_FragColor=vec4(1.0);}";
	                var clippingMaskVert = "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}";
	                var heatmapFrag = "uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var heatmapVert = "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}";
	                var heatmapTextureFrag = "uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}";
	                var heatmapTextureVert = "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}";
	                var collisionBoxFrag = "varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}";
	                var collisionBoxVert = "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}";
	                var collisionCircleFrag = "varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}";
	                var collisionCircleVert = "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}";
	                var debugFrag = "uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}";
	                var debugVert = "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}";
	                var fillFrag = "#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var fillVert = "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}";
	                var fillOutlineFrag = "varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var fillOutlineVert = "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}";
	                var fillOutlinePatternFrag = "uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var fillOutlinePatternVert = "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}";
	                var fillPatternFrag = "uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var fillPatternVert = "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}";
	                var fillExtrusionFrag = "varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var fillExtrusionVert = "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}";
	                var fillExtrusionPatternFrag = "uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var fillExtrusionPatternVert = "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}";
	                var hillshadePrepareFrag = "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var hillshadePrepareVert = "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}";
	                var hillshadeFrag = "uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var hillshadeVert = "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}";
	                var lineFrag = "uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var lineVert = "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}";
	                var lineGradientFrag = "uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var lineGradientVert = "\n#define MAX_LINE_DISTANCE 32767.0\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}";
	                var linePatternFrag = "uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var linePatternVert = "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}";
	                var lineSDFFrag = "uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var lineSDFVert = "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}";
	                var rasterFrag = "uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var rasterVert = "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}";
	                var symbolIconFrag = "uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var symbolIconVert = "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}";
	                var symbolSDFFrag = "#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var symbolSDFVert = "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}";
	                var symbolTextAndIconFrag = "#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}";
	                var symbolTextAndIconVert = "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}";
	                var prelude = compile(preludeFrag, preludeVert);
	                var background = compile(backgroundFrag, backgroundVert);
	                var backgroundPattern = compile(backgroundPatternFrag, backgroundPatternVert);
	                var circle = compile(circleFrag, circleVert);
	                var clippingMask = compile(clippingMaskFrag, clippingMaskVert);
	                var heatmap = compile(heatmapFrag, heatmapVert);
	                var heatmapTexture = compile(heatmapTextureFrag, heatmapTextureVert);
	                var collisionBox = compile(collisionBoxFrag, collisionBoxVert);
	                var collisionCircle = compile(collisionCircleFrag, collisionCircleVert);
	                var debug = compile(debugFrag, debugVert);
	                var fill = compile(fillFrag, fillVert);
	                var fillOutline = compile(fillOutlineFrag, fillOutlineVert);
	                var fillOutlinePattern = compile(fillOutlinePatternFrag, fillOutlinePatternVert);
	                var fillPattern = compile(fillPatternFrag, fillPatternVert);
	                var fillExtrusion = compile(fillExtrusionFrag, fillExtrusionVert);
	                var fillExtrusionPattern = compile(fillExtrusionPatternFrag, fillExtrusionPatternVert);
	                var hillshadePrepare = compile(hillshadePrepareFrag, hillshadePrepareVert);
	                var hillshade = compile(hillshadeFrag, hillshadeVert);
	                var line = compile(lineFrag, lineVert);
	                var lineGradient = compile(lineGradientFrag, lineGradientVert);
	                var linePattern = compile(linePatternFrag, linePatternVert);
	                var lineSDF = compile(lineSDFFrag, lineSDFVert);
	                var raster = compile(rasterFrag, rasterVert);
	                var symbolIcon = compile(symbolIconFrag, symbolIconVert);
	                var symbolSDF = compile(symbolSDFFrag, symbolSDFVert);
	                var symbolTextAndIcon = compile(symbolTextAndIconFrag, symbolTextAndIconVert);
	                function compile(fragmentSource, vertexSource) {
	                  var re = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g;
	                  var fragmentPragmas = {};
	                  fragmentSource = fragmentSource.replace(re, function(match, operation, precision, type, name2) {
	                    fragmentPragmas[name2] = true;
	                    if (operation === "define") {
	                      return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\nvarying " + precision + " " + type + " " + name2 + ";\n#else\nuniform " + precision + " " + type + " u_" + name2 + ";\n#endif\n";
	                    } else {
	                      return "\n#ifdef HAS_UNIFORM_u_" + name2 + "\n    " + precision + " " + type + " " + name2 + " = u_" + name2 + ";\n#endif\n";
	                    }
	                  });
	                  vertexSource = vertexSource.replace(re, function(match, operation, precision, type, name2) {
	                    var attrType = type === "float" ? "vec2" : "vec4";
	                    var unpackType = name2.match(/color/) ? "color" : attrType;
	                    if (fragmentPragmas[name2]) {
	                      if (operation === "define") {
	                        return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\nuniform lowp float u_" + name2 + "_t;\nattribute " + precision + " " + attrType + " a_" + name2 + ";\nvarying " + precision + " " + type + " " + name2 + ";\n#else\nuniform " + precision + " " + type + " u_" + name2 + ";\n#endif\n";
	                      } else {
	                        if (unpackType === "vec4") {
	                          return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\n    " + name2 + " = a_" + name2 + ";\n#else\n    " + precision + " " + type + " " + name2 + " = u_" + name2 + ";\n#endif\n";
	                        } else {
	                          return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\n    " + name2 + " = unpack_mix_" + unpackType + "(a_" + name2 + ", u_" + name2 + "_t);\n#else\n    " + precision + " " + type + " " + name2 + " = u_" + name2 + ";\n#endif\n";
	                        }
	                      }
	                    } else {
	                      if (operation === "define") {
	                        return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\nuniform lowp float u_" + name2 + "_t;\nattribute " + precision + " " + attrType + " a_" + name2 + ";\n#else\nuniform " + precision + " " + type + " u_" + name2 + ";\n#endif\n";
	                      } else {
	                        if (unpackType === "vec4") {
	                          return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\n    " + precision + " " + type + " " + name2 + " = a_" + name2 + ";\n#else\n    " + precision + " " + type + " " + name2 + " = u_" + name2 + ";\n#endif\n";
	                        } else {
	                          return "\n#ifndef HAS_UNIFORM_u_" + name2 + "\n    " + precision + " " + type + " " + name2 + " = unpack_mix_" + unpackType + "(a_" + name2 + ", u_" + name2 + "_t);\n#else\n    " + precision + " " + type + " " + name2 + " = u_" + name2 + ";\n#endif\n";
	                        }
	                      }
	                    }
	                  });
	                  return {
	                    fragmentSource,
	                    vertexSource
	                  };
	                }
	                var shaders = /* @__PURE__ */ Object.freeze({
	                  __proto__: null,
	                  prelude,
	                  background,
	                  backgroundPattern,
	                  circle,
	                  clippingMask,
	                  heatmap,
	                  heatmapTexture,
	                  collisionBox,
	                  collisionCircle,
	                  debug,
	                  fill,
	                  fillOutline,
	                  fillOutlinePattern,
	                  fillPattern,
	                  fillExtrusion,
	                  fillExtrusionPattern,
	                  hillshadePrepare,
	                  hillshade,
	                  line,
	                  lineGradient,
	                  linePattern,
	                  lineSDF,
	                  raster,
	                  symbolIcon,
	                  symbolSDF,
	                  symbolTextAndIcon
	                });
	                var VertexArrayObject = function VertexArrayObject2() {
	                  this.boundProgram = null;
	                  this.boundLayoutVertexBuffer = null;
	                  this.boundPaintVertexBuffers = [];
	                  this.boundIndexBuffer = null;
	                  this.boundVertexOffset = null;
	                  this.boundDynamicVertexBuffer = null;
	                  this.vao = null;
	                };
	                VertexArrayObject.prototype.bind = function bind(context, program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2) {
	                  this.context = context;
	                  var paintBuffersDiffer = this.boundPaintVertexBuffers.length !== paintVertexBuffers.length;
	                  for (var i = 0; !paintBuffersDiffer && i < paintVertexBuffers.length; i++) {
	                    if (this.boundPaintVertexBuffers[i] !== paintVertexBuffers[i]) {
	                      paintBuffersDiffer = true;
	                    }
	                  }
	                  var isFreshBindRequired = !this.vao || this.boundProgram !== program || this.boundLayoutVertexBuffer !== layoutVertexBuffer || paintBuffersDiffer || this.boundIndexBuffer !== indexBuffer || this.boundVertexOffset !== vertexOffset || this.boundDynamicVertexBuffer !== dynamicVertexBuffer || this.boundDynamicVertexBuffer2 !== dynamicVertexBuffer2;
	                  if (!context.extVertexArrayObject || isFreshBindRequired) {
	                    this.freshBind(program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2);
	                  } else {
	                    context.bindVertexArrayOES.set(this.vao);
	                    if (dynamicVertexBuffer) {
	                      dynamicVertexBuffer.bind();
	                    }
	                    if (indexBuffer && indexBuffer.dynamicDraw) {
	                      indexBuffer.bind();
	                    }
	                    if (dynamicVertexBuffer2) {
	                      dynamicVertexBuffer2.bind();
	                    }
	                  }
	                };
	                VertexArrayObject.prototype.freshBind = function freshBind(program, layoutVertexBuffer, paintVertexBuffers, indexBuffer, vertexOffset, dynamicVertexBuffer, dynamicVertexBuffer2) {
	                  var numPrevAttributes;
	                  var numNextAttributes = program.numAttributes;
	                  var context = this.context;
	                  var gl2 = context.gl;
	                  if (context.extVertexArrayObject) {
	                    if (this.vao) {
	                      this.destroy();
	                    }
	                    this.vao = context.extVertexArrayObject.createVertexArrayOES();
	                    context.bindVertexArrayOES.set(this.vao);
	                    numPrevAttributes = 0;
	                    this.boundProgram = program;
	                    this.boundLayoutVertexBuffer = layoutVertexBuffer;
	                    this.boundPaintVertexBuffers = paintVertexBuffers;
	                    this.boundIndexBuffer = indexBuffer;
	                    this.boundVertexOffset = vertexOffset;
	                    this.boundDynamicVertexBuffer = dynamicVertexBuffer;
	                    this.boundDynamicVertexBuffer2 = dynamicVertexBuffer2;
	                  } else {
	                    numPrevAttributes = context.currentNumAttributes || 0;
	                    for (var i = numNextAttributes; i < numPrevAttributes; i++) {
	                      gl2.disableVertexAttribArray(i);
	                    }
	                  }
	                  layoutVertexBuffer.enableAttributes(gl2, program);
	                  for (var i$1 = 0, list = paintVertexBuffers; i$1 < list.length; i$1 += 1) {
	                    var vertexBuffer = list[i$1];
	                    vertexBuffer.enableAttributes(gl2, program);
	                  }
	                  if (dynamicVertexBuffer) {
	                    dynamicVertexBuffer.enableAttributes(gl2, program);
	                  }
	                  if (dynamicVertexBuffer2) {
	                    dynamicVertexBuffer2.enableAttributes(gl2, program);
	                  }
	                  layoutVertexBuffer.bind();
	                  layoutVertexBuffer.setVertexAttribPointers(gl2, program, vertexOffset);
	                  for (var i$2 = 0, list$1 = paintVertexBuffers; i$2 < list$1.length; i$2 += 1) {
	                    var vertexBuffer$1 = list$1[i$2];
	                    vertexBuffer$1.bind();
	                    vertexBuffer$1.setVertexAttribPointers(gl2, program, vertexOffset);
	                  }
	                  if (dynamicVertexBuffer) {
	                    dynamicVertexBuffer.bind();
	                    dynamicVertexBuffer.setVertexAttribPointers(gl2, program, vertexOffset);
	                  }
	                  if (indexBuffer) {
	                    indexBuffer.bind();
	                  }
	                  if (dynamicVertexBuffer2) {
	                    dynamicVertexBuffer2.bind();
	                    dynamicVertexBuffer2.setVertexAttribPointers(gl2, program, vertexOffset);
	                  }
	                  context.currentNumAttributes = numNextAttributes;
	                };
	                VertexArrayObject.prototype.destroy = function destroy() {
	                  if (this.vao) {
	                    this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao);
	                    this.vao = null;
	                  }
	                };
	                var Program$1 = function Program2(context, source, configuration, fixedUniforms, showOverdrawInspector) {
	                  var gl2 = context.gl;
	                  this.program = gl2.createProgram();
	                  var defines = configuration ? configuration.defines() : [];
	                  if (showOverdrawInspector) {
	                    defines.push("#define OVERDRAW_INSPECTOR;");
	                  }
	                  var fragmentSource = defines.concat(prelude.fragmentSource, source.fragmentSource).join("\n");
	                  var vertexSource = defines.concat(prelude.vertexSource, source.vertexSource).join("\n");
	                  var fragmentShader = gl2.createShader(gl2.FRAGMENT_SHADER);
	                  if (gl2.isContextLost()) {
	                    this.failedToCreate = true;
	                    return;
	                  }
	                  gl2.shaderSource(fragmentShader, fragmentSource);
	                  gl2.compileShader(fragmentShader);
	                  gl2.attachShader(this.program, fragmentShader);
	                  var vertexShader = gl2.createShader(gl2.VERTEX_SHADER);
	                  if (gl2.isContextLost()) {
	                    this.failedToCreate = true;
	                    return;
	                  }
	                  gl2.shaderSource(vertexShader, vertexSource);
	                  gl2.compileShader(vertexShader);
	                  gl2.attachShader(this.program, vertexShader);
	                  var layoutAttributes = configuration ? configuration.layoutAttributes : [];
	                  for (var i = 0; i < layoutAttributes.length; i++) {
	                    gl2.bindAttribLocation(this.program, i, layoutAttributes[i].name);
	                  }
	                  gl2.linkProgram(this.program);
	                  gl2.deleteShader(vertexShader);
	                  gl2.deleteShader(fragmentShader);
	                  this.numAttributes = gl2.getProgramParameter(this.program, gl2.ACTIVE_ATTRIBUTES);
	                  this.attributes = {};
	                  var uniformLocations = {};
	                  for (var i$1 = 0; i$1 < this.numAttributes; i$1++) {
	                    var attribute = gl2.getActiveAttrib(this.program, i$1);
	                    if (attribute) {
	                      this.attributes[attribute.name] = gl2.getAttribLocation(this.program, attribute.name);
	                    }
	                  }
	                  var numUniforms = gl2.getProgramParameter(this.program, gl2.ACTIVE_UNIFORMS);
	                  for (var i$2 = 0; i$2 < numUniforms; i$2++) {
	                    var uniform = gl2.getActiveUniform(this.program, i$2);
	                    if (uniform) {
	                      uniformLocations[uniform.name] = gl2.getUniformLocation(this.program, uniform.name);
	                    }
	                  }
	                  this.fixedUniforms = fixedUniforms(context, uniformLocations);
	                  this.binderUniforms = configuration ? configuration.getUniforms(context, uniformLocations) : [];
	                };
	                Program$1.prototype.draw = function draw2(context, drawMode, depthMode, stencilMode, colorMode, cullFaceMode, uniformValues, layerID, layoutVertexBuffer, indexBuffer, segments, currentProperties, zoom, configuration, dynamicLayoutBuffer, dynamicLayoutBuffer2) {
	                  var obj;
	                  var gl2 = context.gl;
	                  if (this.failedToCreate) {
	                    return;
	                  }
	                  context.program.set(this.program);
	                  context.setDepthMode(depthMode);
	                  context.setStencilMode(stencilMode);
	                  context.setColorMode(colorMode);
	                  context.setCullFace(cullFaceMode);
	                  for (var name2 in this.fixedUniforms) {
	                    this.fixedUniforms[name2].set(uniformValues[name2]);
	                  }
	                  if (configuration) {
	                    configuration.setUniforms(context, this.binderUniforms, currentProperties, { zoom });
	                  }
	                  var primitiveSize = (obj = {}, obj[gl2.LINES] = 2, obj[gl2.TRIANGLES] = 3, obj[gl2.LINE_STRIP] = 1, obj)[drawMode];
	                  for (var i = 0, list = segments.get(); i < list.length; i += 1) {
	                    var segment = list[i];
	                    var vaos = segment.vaos || (segment.vaos = {});
	                    var vao = vaos[layerID] || (vaos[layerID] = new VertexArrayObject());
	                    vao.bind(context, this, layoutVertexBuffer, configuration ? configuration.getPaintVertexBuffers() : [], indexBuffer, segment.vertexOffset, dynamicLayoutBuffer, dynamicLayoutBuffer2);
	                    gl2.drawElements(drawMode, segment.primitiveLength * primitiveSize, gl2.UNSIGNED_SHORT, segment.primitiveOffset * primitiveSize * 2);
	                  }
	                };
	                function patternUniformValues(crossfade, painter, tile) {
	                  var tileRatio = 1 / pixelsToTileUnits(tile, 1, painter.transform.tileZoom);
	                  var numTiles = Math.pow(2, tile.tileID.overscaledZ);
	                  var tileSizeAtNearestZoom = tile.tileSize * Math.pow(2, painter.transform.tileZoom) / numTiles;
	                  var pixelX = tileSizeAtNearestZoom * (tile.tileID.canonical.x + tile.tileID.wrap * numTiles);
	                  var pixelY = tileSizeAtNearestZoom * tile.tileID.canonical.y;
	                  return {
	                    "u_image": 0,
	                    "u_texsize": tile.imageAtlasTexture.size,
	                    "u_scale": [
	                      tileRatio,
	                      crossfade.fromScale,
	                      crossfade.toScale
	                    ],
	                    "u_fade": crossfade.t,
	                    "u_pixel_coord_upper": [
	                      pixelX >> 16,
	                      pixelY >> 16
	                    ],
	                    "u_pixel_coord_lower": [
	                      pixelX & 65535,
	                      pixelY & 65535
	                    ]
	                  };
	                }
	                function bgPatternUniformValues(image, crossfade, painter, tile) {
	                  var imagePosA = painter.imageManager.getPattern(image.from.toString());
	                  var imagePosB = painter.imageManager.getPattern(image.to.toString());
	                  var ref = painter.imageManager.getPixelSize();
	                  var width = ref.width;
	                  var height = ref.height;
	                  var numTiles = Math.pow(2, tile.tileID.overscaledZ);
	                  var tileSizeAtNearestZoom = tile.tileSize * Math.pow(2, painter.transform.tileZoom) / numTiles;
	                  var pixelX = tileSizeAtNearestZoom * (tile.tileID.canonical.x + tile.tileID.wrap * numTiles);
	                  var pixelY = tileSizeAtNearestZoom * tile.tileID.canonical.y;
	                  return {
	                    "u_image": 0,
	                    "u_pattern_tl_a": imagePosA.tl,
	                    "u_pattern_br_a": imagePosA.br,
	                    "u_pattern_tl_b": imagePosB.tl,
	                    "u_pattern_br_b": imagePosB.br,
	                    "u_texsize": [
	                      width,
	                      height
	                    ],
	                    "u_mix": crossfade.t,
	                    "u_pattern_size_a": imagePosA.displaySize,
	                    "u_pattern_size_b": imagePosB.displaySize,
	                    "u_scale_a": crossfade.fromScale,
	                    "u_scale_b": crossfade.toScale,
	                    "u_tile_units_to_pixels": 1 / pixelsToTileUnits(tile, 1, painter.transform.tileZoom),
	                    "u_pixel_coord_upper": [
	                      pixelX >> 16,
	                      pixelY >> 16
	                    ],
	                    "u_pixel_coord_lower": [
	                      pixelX & 65535,
	                      pixelY & 65535
	                    ]
	                  };
	                }
	                var fillExtrusionUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_lightpos": new performance2.Uniform3f(context, locations.u_lightpos),
	                    "u_lightintensity": new performance2.Uniform1f(context, locations.u_lightintensity),
	                    "u_lightcolor": new performance2.Uniform3f(context, locations.u_lightcolor),
	                    "u_vertical_gradient": new performance2.Uniform1f(context, locations.u_vertical_gradient),
	                    "u_opacity": new performance2.Uniform1f(context, locations.u_opacity)
	                  };
	                };
	                var fillExtrusionPatternUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_lightpos": new performance2.Uniform3f(context, locations.u_lightpos),
	                    "u_lightintensity": new performance2.Uniform1f(context, locations.u_lightintensity),
	                    "u_lightcolor": new performance2.Uniform3f(context, locations.u_lightcolor),
	                    "u_vertical_gradient": new performance2.Uniform1f(context, locations.u_vertical_gradient),
	                    "u_height_factor": new performance2.Uniform1f(context, locations.u_height_factor),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_pixel_coord_upper": new performance2.Uniform2f(context, locations.u_pixel_coord_upper),
	                    "u_pixel_coord_lower": new performance2.Uniform2f(context, locations.u_pixel_coord_lower),
	                    "u_scale": new performance2.Uniform3f(context, locations.u_scale),
	                    "u_fade": new performance2.Uniform1f(context, locations.u_fade),
	                    "u_opacity": new performance2.Uniform1f(context, locations.u_opacity)
	                  };
	                };
	                var fillExtrusionUniformValues = function(matrix, painter, shouldUseVerticalGradient, opacity) {
	                  var light = painter.style.light;
	                  var _lp = light.properties.get("position");
	                  var lightPos = [
	                    _lp.x,
	                    _lp.y,
	                    _lp.z
	                  ];
	                  var lightMat = performance2.create$1();
	                  if (light.properties.get("anchor") === "viewport") {
	                    performance2.fromRotation(lightMat, -painter.transform.angle);
	                  }
	                  performance2.transformMat3(lightPos, lightPos, lightMat);
	                  var lightColor = light.properties.get("color");
	                  return {
	                    "u_matrix": matrix,
	                    "u_lightpos": lightPos,
	                    "u_lightintensity": light.properties.get("intensity"),
	                    "u_lightcolor": [
	                      lightColor.r,
	                      lightColor.g,
	                      lightColor.b
	                    ],
	                    "u_vertical_gradient": +shouldUseVerticalGradient,
	                    "u_opacity": opacity
	                  };
	                };
	                var fillExtrusionPatternUniformValues = function(matrix, painter, shouldUseVerticalGradient, opacity, coord, crossfade, tile) {
	                  return performance2.extend(fillExtrusionUniformValues(matrix, painter, shouldUseVerticalGradient, opacity), patternUniformValues(crossfade, painter, tile), { "u_height_factor": -Math.pow(2, coord.overscaledZ) / tile.tileSize / 8 });
	                };
	                var fillUniforms = function(context, locations) {
	                  return { "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix) };
	                };
	                var fillPatternUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_pixel_coord_upper": new performance2.Uniform2f(context, locations.u_pixel_coord_upper),
	                    "u_pixel_coord_lower": new performance2.Uniform2f(context, locations.u_pixel_coord_lower),
	                    "u_scale": new performance2.Uniform3f(context, locations.u_scale),
	                    "u_fade": new performance2.Uniform1f(context, locations.u_fade)
	                  };
	                };
	                var fillOutlineUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_world": new performance2.Uniform2f(context, locations.u_world)
	                  };
	                };
	                var fillOutlinePatternUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_world": new performance2.Uniform2f(context, locations.u_world),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_pixel_coord_upper": new performance2.Uniform2f(context, locations.u_pixel_coord_upper),
	                    "u_pixel_coord_lower": new performance2.Uniform2f(context, locations.u_pixel_coord_lower),
	                    "u_scale": new performance2.Uniform3f(context, locations.u_scale),
	                    "u_fade": new performance2.Uniform1f(context, locations.u_fade)
	                  };
	                };
	                var fillUniformValues = function(matrix) {
	                  return { "u_matrix": matrix };
	                };
	                var fillPatternUniformValues = function(matrix, painter, crossfade, tile) {
	                  return performance2.extend(fillUniformValues(matrix), patternUniformValues(crossfade, painter, tile));
	                };
	                var fillOutlineUniformValues = function(matrix, drawingBufferSize) {
	                  return {
	                    "u_matrix": matrix,
	                    "u_world": drawingBufferSize
	                  };
	                };
	                var fillOutlinePatternUniformValues = function(matrix, painter, crossfade, tile, drawingBufferSize) {
	                  return performance2.extend(fillPatternUniformValues(matrix, painter, crossfade, tile), { "u_world": drawingBufferSize });
	                };
	                var circleUniforms = function(context, locations) {
	                  return {
	                    "u_camera_to_center_distance": new performance2.Uniform1f(context, locations.u_camera_to_center_distance),
	                    "u_scale_with_map": new performance2.Uniform1i(context, locations.u_scale_with_map),
	                    "u_pitch_with_map": new performance2.Uniform1i(context, locations.u_pitch_with_map),
	                    "u_extrude_scale": new performance2.Uniform2f(context, locations.u_extrude_scale),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix)
	                  };
	                };
	                var circleUniformValues = function(painter, coord, tile, layer) {
	                  var transform = painter.transform;
	                  var pitchWithMap, extrudeScale;
	                  if (layer.paint.get("circle-pitch-alignment") === "map") {
	                    var pixelRatio = pixelsToTileUnits(tile, 1, transform.zoom);
	                    pitchWithMap = true;
	                    extrudeScale = [
	                      pixelRatio,
	                      pixelRatio
	                    ];
	                  } else {
	                    pitchWithMap = false;
	                    extrudeScale = transform.pixelsToGLUnits;
	                  }
	                  return {
	                    "u_camera_to_center_distance": transform.cameraToCenterDistance,
	                    "u_scale_with_map": +(layer.paint.get("circle-pitch-scale") === "map"),
	                    "u_matrix": painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get("circle-translate"), layer.paint.get("circle-translate-anchor")),
	                    "u_pitch_with_map": +pitchWithMap,
	                    "u_device_pixel_ratio": performance2.browser.devicePixelRatio,
	                    "u_extrude_scale": extrudeScale
	                  };
	                };
	                var collisionUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_camera_to_center_distance": new performance2.Uniform1f(context, locations.u_camera_to_center_distance),
	                    "u_pixels_to_tile_units": new performance2.Uniform1f(context, locations.u_pixels_to_tile_units),
	                    "u_extrude_scale": new performance2.Uniform2f(context, locations.u_extrude_scale),
	                    "u_overscale_factor": new performance2.Uniform1f(context, locations.u_overscale_factor)
	                  };
	                };
	                var collisionCircleUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_inv_matrix": new performance2.UniformMatrix4f(context, locations.u_inv_matrix),
	                    "u_camera_to_center_distance": new performance2.Uniform1f(context, locations.u_camera_to_center_distance),
	                    "u_viewport_size": new performance2.Uniform2f(context, locations.u_viewport_size)
	                  };
	                };
	                var collisionUniformValues = function(matrix, transform, tile) {
	                  var pixelRatio = pixelsToTileUnits(tile, 1, transform.zoom);
	                  var scale = Math.pow(2, transform.zoom - tile.tileID.overscaledZ);
	                  var overscaleFactor = tile.tileID.overscaleFactor();
	                  return {
	                    "u_matrix": matrix,
	                    "u_camera_to_center_distance": transform.cameraToCenterDistance,
	                    "u_pixels_to_tile_units": pixelRatio,
	                    "u_extrude_scale": [
	                      transform.pixelsToGLUnits[0] / (pixelRatio * scale),
	                      transform.pixelsToGLUnits[1] / (pixelRatio * scale)
	                    ],
	                    "u_overscale_factor": overscaleFactor
	                  };
	                };
	                var collisionCircleUniformValues = function(matrix, invMatrix, transform) {
	                  return {
	                    "u_matrix": matrix,
	                    "u_inv_matrix": invMatrix,
	                    "u_camera_to_center_distance": transform.cameraToCenterDistance,
	                    "u_viewport_size": [
	                      transform.width,
	                      transform.height
	                    ]
	                  };
	                };
	                var debugUniforms = function(context, locations) {
	                  return {
	                    "u_color": new performance2.UniformColor(context, locations.u_color),
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_overlay": new performance2.Uniform1i(context, locations.u_overlay),
	                    "u_overlay_scale": new performance2.Uniform1f(context, locations.u_overlay_scale)
	                  };
	                };
	                var debugUniformValues = function(matrix, color, scaleRatio) {
	                  if (scaleRatio === undefined)
	                    scaleRatio = 1;
	                  return {
	                    "u_matrix": matrix,
	                    "u_color": color,
	                    "u_overlay": 0,
	                    "u_overlay_scale": scaleRatio
	                  };
	                };
	                var clippingMaskUniforms = function(context, locations) {
	                  return { "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix) };
	                };
	                var clippingMaskUniformValues = function(matrix) {
	                  return { "u_matrix": matrix };
	                };
	                var heatmapUniforms = function(context, locations) {
	                  return {
	                    "u_extrude_scale": new performance2.Uniform1f(context, locations.u_extrude_scale),
	                    "u_intensity": new performance2.Uniform1f(context, locations.u_intensity),
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix)
	                  };
	                };
	                var heatmapTextureUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_world": new performance2.Uniform2f(context, locations.u_world),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_color_ramp": new performance2.Uniform1i(context, locations.u_color_ramp),
	                    "u_opacity": new performance2.Uniform1f(context, locations.u_opacity)
	                  };
	                };
	                var heatmapUniformValues = function(matrix, tile, zoom, intensity) {
	                  return {
	                    "u_matrix": matrix,
	                    "u_extrude_scale": pixelsToTileUnits(tile, 1, zoom),
	                    "u_intensity": intensity
	                  };
	                };
	                var heatmapTextureUniformValues = function(painter, layer, textureUnit, colorRampUnit) {
	                  var matrix = performance2.create();
	                  performance2.ortho(matrix, 0, painter.width, painter.height, 0, 0, 1);
	                  var gl2 = painter.context.gl;
	                  return {
	                    "u_matrix": matrix,
	                    "u_world": [
	                      gl2.drawingBufferWidth,
	                      gl2.drawingBufferHeight
	                    ],
	                    "u_image": textureUnit,
	                    "u_color_ramp": colorRampUnit,
	                    "u_opacity": layer.paint.get("heatmap-opacity")
	                  };
	                };
	                var hillshadeUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_latrange": new performance2.Uniform2f(context, locations.u_latrange),
	                    "u_light": new performance2.Uniform2f(context, locations.u_light),
	                    "u_shadow": new performance2.UniformColor(context, locations.u_shadow),
	                    "u_highlight": new performance2.UniformColor(context, locations.u_highlight),
	                    "u_accent": new performance2.UniformColor(context, locations.u_accent)
	                  };
	                };
	                var hillshadePrepareUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_dimension": new performance2.Uniform2f(context, locations.u_dimension),
	                    "u_zoom": new performance2.Uniform1f(context, locations.u_zoom),
	                    "u_maxzoom": new performance2.Uniform1f(context, locations.u_maxzoom),
	                    "u_unpack": new performance2.Uniform4f(context, locations.u_unpack)
	                  };
	                };
	                var hillshadeUniformValues = function(painter, tile, layer) {
	                  var shadow = layer.paint.get("hillshade-shadow-color");
	                  var highlight = layer.paint.get("hillshade-highlight-color");
	                  var accent = layer.paint.get("hillshade-accent-color");
	                  var azimuthal = layer.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
	                  if (layer.paint.get("hillshade-illumination-anchor") === "viewport") {
	                    azimuthal -= painter.transform.angle;
	                  }
	                  var align = !painter.options.moving;
	                  return {
	                    "u_matrix": painter.transform.calculatePosMatrix(tile.tileID.toUnwrapped(), align),
	                    "u_image": 0,
	                    "u_latrange": getTileLatRange(painter, tile.tileID),
	                    "u_light": [
	                      layer.paint.get("hillshade-exaggeration"),
	                      azimuthal
	                    ],
	                    "u_shadow": shadow,
	                    "u_highlight": highlight,
	                    "u_accent": accent
	                  };
	                };
	                var hillshadeUniformPrepareValues = function(tileID, dem, maxzoom) {
	                  var stride = dem.stride;
	                  var matrix = performance2.create();
	                  performance2.ortho(matrix, 0, performance2.EXTENT, -performance2.EXTENT, 0, 0, 1);
	                  performance2.translate(matrix, matrix, [
	                    0,
	                    -performance2.EXTENT,
	                    0
	                  ]);
	                  return {
	                    "u_matrix": matrix,
	                    "u_image": 1,
	                    "u_dimension": [
	                      stride,
	                      stride
	                    ],
	                    "u_zoom": tileID.overscaledZ,
	                    "u_maxzoom": maxzoom,
	                    "u_unpack": dem.getUnpackVector()
	                  };
	                };
	                function getTileLatRange(painter, tileID) {
	                  var tilesAtZoom = Math.pow(2, tileID.canonical.z);
	                  var y = tileID.canonical.y;
	                  return [
	                    new performance2.MercatorCoordinate(0, y / tilesAtZoom).toLngLat().lat,
	                    new performance2.MercatorCoordinate(0, (y + 1) / tilesAtZoom).toLngLat().lat
	                  ];
	                }
	                var lineUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_ratio": new performance2.Uniform1f(context, locations.u_ratio),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_units_to_pixels": new performance2.Uniform2f(context, locations.u_units_to_pixels)
	                  };
	                };
	                var lineGradientUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_ratio": new performance2.Uniform1f(context, locations.u_ratio),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_units_to_pixels": new performance2.Uniform2f(context, locations.u_units_to_pixels),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image)
	                  };
	                };
	                var linePatternUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_ratio": new performance2.Uniform1f(context, locations.u_ratio),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_units_to_pixels": new performance2.Uniform2f(context, locations.u_units_to_pixels),
	                    "u_scale": new performance2.Uniform3f(context, locations.u_scale),
	                    "u_fade": new performance2.Uniform1f(context, locations.u_fade)
	                  };
	                };
	                var lineSDFUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_ratio": new performance2.Uniform1f(context, locations.u_ratio),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_units_to_pixels": new performance2.Uniform2f(context, locations.u_units_to_pixels),
	                    "u_patternscale_a": new performance2.Uniform2f(context, locations.u_patternscale_a),
	                    "u_patternscale_b": new performance2.Uniform2f(context, locations.u_patternscale_b),
	                    "u_sdfgamma": new performance2.Uniform1f(context, locations.u_sdfgamma),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_tex_y_a": new performance2.Uniform1f(context, locations.u_tex_y_a),
	                    "u_tex_y_b": new performance2.Uniform1f(context, locations.u_tex_y_b),
	                    "u_mix": new performance2.Uniform1f(context, locations.u_mix)
	                  };
	                };
	                var lineUniformValues = function(painter, tile, layer) {
	                  var transform = painter.transform;
	                  return {
	                    "u_matrix": calculateMatrix(painter, tile, layer),
	                    "u_ratio": 1 / pixelsToTileUnits(tile, 1, transform.zoom),
	                    "u_device_pixel_ratio": performance2.browser.devicePixelRatio,
	                    "u_units_to_pixels": [
	                      1 / transform.pixelsToGLUnits[0],
	                      1 / transform.pixelsToGLUnits[1]
	                    ]
	                  };
	                };
	                var lineGradientUniformValues = function(painter, tile, layer) {
	                  return performance2.extend(lineUniformValues(painter, tile, layer), { "u_image": 0 });
	                };
	                var linePatternUniformValues = function(painter, tile, layer, crossfade) {
	                  var transform = painter.transform;
	                  var tileZoomRatio = calculateTileRatio(tile, transform);
	                  return {
	                    "u_matrix": calculateMatrix(painter, tile, layer),
	                    "u_texsize": tile.imageAtlasTexture.size,
	                    "u_ratio": 1 / pixelsToTileUnits(tile, 1, transform.zoom),
	                    "u_device_pixel_ratio": performance2.browser.devicePixelRatio,
	                    "u_image": 0,
	                    "u_scale": [
	                      tileZoomRatio,
	                      crossfade.fromScale,
	                      crossfade.toScale
	                    ],
	                    "u_fade": crossfade.t,
	                    "u_units_to_pixels": [
	                      1 / transform.pixelsToGLUnits[0],
	                      1 / transform.pixelsToGLUnits[1]
	                    ]
	                  };
	                };
	                var lineSDFUniformValues = function(painter, tile, layer, dasharray, crossfade) {
	                  var transform = painter.transform;
	                  var lineAtlas = painter.lineAtlas;
	                  var tileRatio = calculateTileRatio(tile, transform);
	                  var round = layer.layout.get("line-cap") === "round";
	                  var posA = lineAtlas.getDash(dasharray.from, round);
	                  var posB = lineAtlas.getDash(dasharray.to, round);
	                  var widthA = posA.width * crossfade.fromScale;
	                  var widthB = posB.width * crossfade.toScale;
	                  return performance2.extend(lineUniformValues(painter, tile, layer), {
	                    "u_patternscale_a": [
	                      tileRatio / widthA,
	                      -posA.height / 2
	                    ],
	                    "u_patternscale_b": [
	                      tileRatio / widthB,
	                      -posB.height / 2
	                    ],
	                    "u_sdfgamma": lineAtlas.width / (Math.min(widthA, widthB) * 256 * performance2.browser.devicePixelRatio) / 2,
	                    "u_image": 0,
	                    "u_tex_y_a": posA.y,
	                    "u_tex_y_b": posB.y,
	                    "u_mix": crossfade.t
	                  });
	                };
	                function calculateTileRatio(tile, transform) {
	                  return 1 / pixelsToTileUnits(tile, 1, transform.tileZoom);
	                }
	                function calculateMatrix(painter, tile, layer) {
	                  return painter.translatePosMatrix(tile.tileID.posMatrix, tile, layer.paint.get("line-translate"), layer.paint.get("line-translate-anchor"));
	                }
	                var rasterUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_tl_parent": new performance2.Uniform2f(context, locations.u_tl_parent),
	                    "u_scale_parent": new performance2.Uniform1f(context, locations.u_scale_parent),
	                    "u_buffer_scale": new performance2.Uniform1f(context, locations.u_buffer_scale),
	                    "u_fade_t": new performance2.Uniform1f(context, locations.u_fade_t),
	                    "u_opacity": new performance2.Uniform1f(context, locations.u_opacity),
	                    "u_image0": new performance2.Uniform1i(context, locations.u_image0),
	                    "u_image1": new performance2.Uniform1i(context, locations.u_image1),
	                    "u_brightness_low": new performance2.Uniform1f(context, locations.u_brightness_low),
	                    "u_brightness_high": new performance2.Uniform1f(context, locations.u_brightness_high),
	                    "u_saturation_factor": new performance2.Uniform1f(context, locations.u_saturation_factor),
	                    "u_contrast_factor": new performance2.Uniform1f(context, locations.u_contrast_factor),
	                    "u_spin_weights": new performance2.Uniform3f(context, locations.u_spin_weights)
	                  };
	                };
	                var rasterUniformValues = function(matrix, parentTL, parentScaleBy, fade, layer) {
	                  return {
	                    "u_matrix": matrix,
	                    "u_tl_parent": parentTL,
	                    "u_scale_parent": parentScaleBy,
	                    "u_buffer_scale": 1,
	                    "u_fade_t": fade.mix,
	                    "u_opacity": fade.opacity * layer.paint.get("raster-opacity"),
	                    "u_image0": 0,
	                    "u_image1": 1,
	                    "u_brightness_low": layer.paint.get("raster-brightness-min"),
	                    "u_brightness_high": layer.paint.get("raster-brightness-max"),
	                    "u_saturation_factor": saturationFactor(layer.paint.get("raster-saturation")),
	                    "u_contrast_factor": contrastFactor(layer.paint.get("raster-contrast")),
	                    "u_spin_weights": spinWeights(layer.paint.get("raster-hue-rotate"))
	                  };
	                };
	                function spinWeights(angle) {
	                  angle *= Math.PI / 180;
	                  var s = Math.sin(angle);
	                  var c = Math.cos(angle);
	                  return [
	                    (2 * c + 1) / 3,
	                    (-Math.sqrt(3) * s - c + 1) / 3,
	                    (Math.sqrt(3) * s - c + 1) / 3
	                  ];
	                }
	                function contrastFactor(contrast) {
	                  return contrast > 0 ? 1 / (1 - contrast) : 1 + contrast;
	                }
	                function saturationFactor(saturation) {
	                  return saturation > 0 ? 1 - 1 / (1.001 - saturation) : -saturation;
	                }
	                var symbolIconUniforms = function(context, locations) {
	                  return {
	                    "u_is_size_zoom_constant": new performance2.Uniform1i(context, locations.u_is_size_zoom_constant),
	                    "u_is_size_feature_constant": new performance2.Uniform1i(context, locations.u_is_size_feature_constant),
	                    "u_size_t": new performance2.Uniform1f(context, locations.u_size_t),
	                    "u_size": new performance2.Uniform1f(context, locations.u_size),
	                    "u_camera_to_center_distance": new performance2.Uniform1f(context, locations.u_camera_to_center_distance),
	                    "u_pitch": new performance2.Uniform1f(context, locations.u_pitch),
	                    "u_rotate_symbol": new performance2.Uniform1i(context, locations.u_rotate_symbol),
	                    "u_aspect_ratio": new performance2.Uniform1f(context, locations.u_aspect_ratio),
	                    "u_fade_change": new performance2.Uniform1f(context, locations.u_fade_change),
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_label_plane_matrix": new performance2.UniformMatrix4f(context, locations.u_label_plane_matrix),
	                    "u_coord_matrix": new performance2.UniformMatrix4f(context, locations.u_coord_matrix),
	                    "u_is_text": new performance2.Uniform1i(context, locations.u_is_text),
	                    "u_pitch_with_map": new performance2.Uniform1i(context, locations.u_pitch_with_map),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_texture": new performance2.Uniform1i(context, locations.u_texture)
	                  };
	                };
	                var symbolSDFUniforms = function(context, locations) {
	                  return {
	                    "u_is_size_zoom_constant": new performance2.Uniform1i(context, locations.u_is_size_zoom_constant),
	                    "u_is_size_feature_constant": new performance2.Uniform1i(context, locations.u_is_size_feature_constant),
	                    "u_size_t": new performance2.Uniform1f(context, locations.u_size_t),
	                    "u_size": new performance2.Uniform1f(context, locations.u_size),
	                    "u_camera_to_center_distance": new performance2.Uniform1f(context, locations.u_camera_to_center_distance),
	                    "u_pitch": new performance2.Uniform1f(context, locations.u_pitch),
	                    "u_rotate_symbol": new performance2.Uniform1i(context, locations.u_rotate_symbol),
	                    "u_aspect_ratio": new performance2.Uniform1f(context, locations.u_aspect_ratio),
	                    "u_fade_change": new performance2.Uniform1f(context, locations.u_fade_change),
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_label_plane_matrix": new performance2.UniformMatrix4f(context, locations.u_label_plane_matrix),
	                    "u_coord_matrix": new performance2.UniformMatrix4f(context, locations.u_coord_matrix),
	                    "u_is_text": new performance2.Uniform1i(context, locations.u_is_text),
	                    "u_pitch_with_map": new performance2.Uniform1i(context, locations.u_pitch_with_map),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_texture": new performance2.Uniform1i(context, locations.u_texture),
	                    "u_gamma_scale": new performance2.Uniform1f(context, locations.u_gamma_scale),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_is_halo": new performance2.Uniform1i(context, locations.u_is_halo)
	                  };
	                };
	                var symbolTextAndIconUniforms = function(context, locations) {
	                  return {
	                    "u_is_size_zoom_constant": new performance2.Uniform1i(context, locations.u_is_size_zoom_constant),
	                    "u_is_size_feature_constant": new performance2.Uniform1i(context, locations.u_is_size_feature_constant),
	                    "u_size_t": new performance2.Uniform1f(context, locations.u_size_t),
	                    "u_size": new performance2.Uniform1f(context, locations.u_size),
	                    "u_camera_to_center_distance": new performance2.Uniform1f(context, locations.u_camera_to_center_distance),
	                    "u_pitch": new performance2.Uniform1f(context, locations.u_pitch),
	                    "u_rotate_symbol": new performance2.Uniform1i(context, locations.u_rotate_symbol),
	                    "u_aspect_ratio": new performance2.Uniform1f(context, locations.u_aspect_ratio),
	                    "u_fade_change": new performance2.Uniform1f(context, locations.u_fade_change),
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_label_plane_matrix": new performance2.UniformMatrix4f(context, locations.u_label_plane_matrix),
	                    "u_coord_matrix": new performance2.UniformMatrix4f(context, locations.u_coord_matrix),
	                    "u_is_text": new performance2.Uniform1i(context, locations.u_is_text),
	                    "u_pitch_with_map": new performance2.Uniform1i(context, locations.u_pitch_with_map),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_texsize_icon": new performance2.Uniform2f(context, locations.u_texsize_icon),
	                    "u_texture": new performance2.Uniform1i(context, locations.u_texture),
	                    "u_texture_icon": new performance2.Uniform1i(context, locations.u_texture_icon),
	                    "u_gamma_scale": new performance2.Uniform1f(context, locations.u_gamma_scale),
	                    "u_device_pixel_ratio": new performance2.Uniform1f(context, locations.u_device_pixel_ratio),
	                    "u_is_halo": new performance2.Uniform1i(context, locations.u_is_halo)
	                  };
	                };
	                var symbolIconUniformValues = function(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, isText, texSize) {
	                  var transform = painter.transform;
	                  return {
	                    "u_is_size_zoom_constant": +(functionType === "constant" || functionType === "source"),
	                    "u_is_size_feature_constant": +(functionType === "constant" || functionType === "camera"),
	                    "u_size_t": size ? size.uSizeT : 0,
	                    "u_size": size ? size.uSize : 0,
	                    "u_camera_to_center_distance": transform.cameraToCenterDistance,
	                    "u_pitch": transform.pitch / 360 * 2 * Math.PI,
	                    "u_rotate_symbol": +rotateInShader,
	                    "u_aspect_ratio": transform.width / transform.height,
	                    "u_fade_change": painter.options.fadeDuration ? painter.symbolFadeChange : 1,
	                    "u_matrix": matrix,
	                    "u_label_plane_matrix": labelPlaneMatrix,
	                    "u_coord_matrix": glCoordMatrix,
	                    "u_is_text": +isText,
	                    "u_pitch_with_map": +pitchWithMap,
	                    "u_texsize": texSize,
	                    "u_texture": 0
	                  };
	                };
	                var symbolSDFUniformValues = function(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, isText, texSize, isHalo) {
	                  var transform = painter.transform;
	                  return performance2.extend(symbolIconUniformValues(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, isText, texSize), {
	                    "u_gamma_scale": pitchWithMap ? Math.cos(transform._pitch) * transform.cameraToCenterDistance : 1,
	                    "u_device_pixel_ratio": performance2.browser.devicePixelRatio,
	                    "u_is_halo": 1
	                  });
	                };
	                var symbolTextAndIconUniformValues = function(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, texSizeSDF, texSizeIcon) {
	                  return performance2.extend(symbolSDFUniformValues(functionType, size, rotateInShader, pitchWithMap, painter, matrix, labelPlaneMatrix, glCoordMatrix, true, texSizeSDF), {
	                    "u_texsize_icon": texSizeIcon,
	                    "u_texture_icon": 1
	                  });
	                };
	                var backgroundUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_opacity": new performance2.Uniform1f(context, locations.u_opacity),
	                    "u_color": new performance2.UniformColor(context, locations.u_color)
	                  };
	                };
	                var backgroundPatternUniforms = function(context, locations) {
	                  return {
	                    "u_matrix": new performance2.UniformMatrix4f(context, locations.u_matrix),
	                    "u_opacity": new performance2.Uniform1f(context, locations.u_opacity),
	                    "u_image": new performance2.Uniform1i(context, locations.u_image),
	                    "u_pattern_tl_a": new performance2.Uniform2f(context, locations.u_pattern_tl_a),
	                    "u_pattern_br_a": new performance2.Uniform2f(context, locations.u_pattern_br_a),
	                    "u_pattern_tl_b": new performance2.Uniform2f(context, locations.u_pattern_tl_b),
	                    "u_pattern_br_b": new performance2.Uniform2f(context, locations.u_pattern_br_b),
	                    "u_texsize": new performance2.Uniform2f(context, locations.u_texsize),
	                    "u_mix": new performance2.Uniform1f(context, locations.u_mix),
	                    "u_pattern_size_a": new performance2.Uniform2f(context, locations.u_pattern_size_a),
	                    "u_pattern_size_b": new performance2.Uniform2f(context, locations.u_pattern_size_b),
	                    "u_scale_a": new performance2.Uniform1f(context, locations.u_scale_a),
	                    "u_scale_b": new performance2.Uniform1f(context, locations.u_scale_b),
	                    "u_pixel_coord_upper": new performance2.Uniform2f(context, locations.u_pixel_coord_upper),
	                    "u_pixel_coord_lower": new performance2.Uniform2f(context, locations.u_pixel_coord_lower),
	                    "u_tile_units_to_pixels": new performance2.Uniform1f(context, locations.u_tile_units_to_pixels)
	                  };
	                };
	                var backgroundUniformValues = function(matrix, opacity, color) {
	                  return {
	                    "u_matrix": matrix,
	                    "u_opacity": opacity,
	                    "u_color": color
	                  };
	                };
	                var backgroundPatternUniformValues = function(matrix, opacity, painter, image, tile, crossfade) {
	                  return performance2.extend(bgPatternUniformValues(image, crossfade, painter, tile), {
	                    "u_matrix": matrix,
	                    "u_opacity": opacity
	                  });
	                };
	                var programUniforms = {
	                  fillExtrusion: fillExtrusionUniforms,
	                  fillExtrusionPattern: fillExtrusionPatternUniforms,
	                  fill: fillUniforms,
	                  fillPattern: fillPatternUniforms,
	                  fillOutline: fillOutlineUniforms,
	                  fillOutlinePattern: fillOutlinePatternUniforms,
	                  circle: circleUniforms,
	                  collisionBox: collisionUniforms,
	                  collisionCircle: collisionCircleUniforms,
	                  debug: debugUniforms,
	                  clippingMask: clippingMaskUniforms,
	                  heatmap: heatmapUniforms,
	                  heatmapTexture: heatmapTextureUniforms,
	                  hillshade: hillshadeUniforms,
	                  hillshadePrepare: hillshadePrepareUniforms,
	                  line: lineUniforms,
	                  lineGradient: lineGradientUniforms,
	                  linePattern: linePatternUniforms,
	                  lineSDF: lineSDFUniforms,
	                  raster: rasterUniforms,
	                  symbolIcon: symbolIconUniforms,
	                  symbolSDF: symbolSDFUniforms,
	                  symbolTextAndIcon: symbolTextAndIconUniforms,
	                  background: backgroundUniforms,
	                  backgroundPattern: backgroundPatternUniforms
	                };
	                var quadTriangles;
	                function drawCollisionDebug(painter, sourceCache, layer, coords, translate, translateAnchor, isText) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var program = painter.useProgram("collisionBox");
	                  var tileBatches = [];
	                  var circleCount = 0;
	                  var circleOffset = 0;
	                  for (var i = 0; i < coords.length; i++) {
	                    var coord = coords[i];
	                    var tile = sourceCache.getTile(coord);
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket) {
	                      continue;
	                    }
	                    var posMatrix = coord.posMatrix;
	                    if (translate[0] !== 0 || translate[1] !== 0) {
	                      posMatrix = painter.translatePosMatrix(coord.posMatrix, tile, translate, translateAnchor);
	                    }
	                    var buffers = isText ? bucket.textCollisionBox : bucket.iconCollisionBox;
	                    var circleArray = bucket.collisionCircleArray;
	                    if (circleArray.length > 0) {
	                      var invTransform = performance2.create();
	                      var transform = posMatrix;
	                      performance2.mul(invTransform, bucket.placementInvProjMatrix, painter.transform.glCoordMatrix);
	                      performance2.mul(invTransform, invTransform, bucket.placementViewportMatrix);
	                      tileBatches.push({
	                        circleArray,
	                        circleOffset,
	                        transform,
	                        invTransform
	                      });
	                      circleCount += circleArray.length / 4;
	                      circleOffset = circleCount;
	                    }
	                    if (!buffers) {
	                      continue;
	                    }
	                    program.draw(context, gl2.LINES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, collisionUniformValues(posMatrix, painter.transform, tile), layer.id, buffers.layoutVertexBuffer, buffers.indexBuffer, buffers.segments, null, painter.transform.zoom, null, null, buffers.collisionVertexBuffer);
	                  }
	                  if (!isText || !tileBatches.length) {
	                    return;
	                  }
	                  var circleProgram = painter.useProgram("collisionCircle");
	                  var vertexData = new performance2.StructArrayLayout2f1f2i16();
	                  vertexData.resize(circleCount * 4);
	                  vertexData._trim();
	                  var vertexOffset = 0;
	                  for (var i$2 = 0, list = tileBatches; i$2 < list.length; i$2 += 1) {
	                    var batch = list[i$2];
	                    for (var i$1 = 0; i$1 < batch.circleArray.length / 4; i$1++) {
	                      var circleIdx = i$1 * 4;
	                      var x = batch.circleArray[circleIdx + 0];
	                      var y = batch.circleArray[circleIdx + 1];
	                      var radius = batch.circleArray[circleIdx + 2];
	                      var collision = batch.circleArray[circleIdx + 3];
	                      vertexData.emplace(vertexOffset++, x, y, radius, collision, 0);
	                      vertexData.emplace(vertexOffset++, x, y, radius, collision, 1);
	                      vertexData.emplace(vertexOffset++, x, y, radius, collision, 2);
	                      vertexData.emplace(vertexOffset++, x, y, radius, collision, 3);
	                    }
	                  }
	                  if (!quadTriangles || quadTriangles.length < circleCount * 2) {
	                    quadTriangles = createQuadTriangles(circleCount);
	                  }
	                  var indexBuffer = context.createIndexBuffer(quadTriangles, true);
	                  var vertexBuffer = context.createVertexBuffer(vertexData, performance2.collisionCircleLayout.members, true);
	                  for (var i$3 = 0, list$1 = tileBatches; i$3 < list$1.length; i$3 += 1) {
	                    var batch$1 = list$1[i$3];
	                    var uniforms = collisionCircleUniformValues(batch$1.transform, batch$1.invTransform, painter.transform);
	                    circleProgram.draw(context, gl2.TRIANGLES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, uniforms, layer.id, vertexBuffer, indexBuffer, performance2.SegmentVector.simpleSegment(0, batch$1.circleOffset * 2, batch$1.circleArray.length, batch$1.circleArray.length / 2), null, painter.transform.zoom, null, null, null);
	                  }
	                  vertexBuffer.destroy();
	                  indexBuffer.destroy();
	                }
	                function createQuadTriangles(quadCount) {
	                  var triCount = quadCount * 2;
	                  var array = new performance2.StructArrayLayout3ui6();
	                  array.resize(triCount);
	                  array._trim();
	                  for (var i = 0; i < triCount; i++) {
	                    var idx = i * 6;
	                    array.uint16[idx + 0] = i * 4 + 0;
	                    array.uint16[idx + 1] = i * 4 + 1;
	                    array.uint16[idx + 2] = i * 4 + 2;
	                    array.uint16[idx + 3] = i * 4 + 2;
	                    array.uint16[idx + 4] = i * 4 + 3;
	                    array.uint16[idx + 5] = i * 4 + 0;
	                  }
	                  return array;
	                }
	                var identityMat4 = performance2.identity(new Float32Array(16));
	                function drawSymbols(painter, sourceCache, layer, coords, variableOffsets) {
	                  if (painter.renderPass !== "translucent") {
	                    return;
	                  }
	                  var stencilMode = StencilMode.disabled;
	                  var colorMode = painter.colorModeForRenderPass();
	                  var variablePlacement = layer.layout.get("text-variable-anchor");
	                  if (variablePlacement) {
	                    updateVariableAnchors(coords, painter, layer, sourceCache, layer.layout.get("text-rotation-alignment"), layer.layout.get("text-pitch-alignment"), variableOffsets);
	                  }
	                  if (layer.paint.get("icon-opacity").constantOr(1) !== 0) {
	                    drawLayerSymbols(painter, sourceCache, layer, coords, false, layer.paint.get("icon-translate"), layer.paint.get("icon-translate-anchor"), layer.layout.get("icon-rotation-alignment"), layer.layout.get("icon-pitch-alignment"), layer.layout.get("icon-keep-upright"), stencilMode, colorMode);
	                  }
	                  if (layer.paint.get("text-opacity").constantOr(1) !== 0) {
	                    drawLayerSymbols(painter, sourceCache, layer, coords, true, layer.paint.get("text-translate"), layer.paint.get("text-translate-anchor"), layer.layout.get("text-rotation-alignment"), layer.layout.get("text-pitch-alignment"), layer.layout.get("text-keep-upright"), stencilMode, colorMode);
	                  }
	                  if (sourceCache.map.showCollisionBoxes) {
	                    drawCollisionDebug(painter, sourceCache, layer, coords, layer.paint.get("text-translate"), layer.paint.get("text-translate-anchor"), true);
	                    drawCollisionDebug(painter, sourceCache, layer, coords, layer.paint.get("icon-translate"), layer.paint.get("icon-translate-anchor"), false);
	                  }
	                }
	                function calculateVariableRenderShift(anchor, width, height, textOffset, textBoxScale, renderTextSize) {
	                  var ref = performance2.getAnchorAlignment(anchor);
	                  var horizontalAlign = ref.horizontalAlign;
	                  var verticalAlign = ref.verticalAlign;
	                  var shiftX = -(horizontalAlign - 0.5) * width;
	                  var shiftY = -(verticalAlign - 0.5) * height;
	                  var variableOffset = performance2.evaluateVariableOffset(anchor, textOffset);
	                  return new performance2.Point((shiftX / textBoxScale + variableOffset[0]) * renderTextSize, (shiftY / textBoxScale + variableOffset[1]) * renderTextSize);
	                }
	                function updateVariableAnchors(coords, painter, layer, sourceCache, rotationAlignment, pitchAlignment, variableOffsets) {
	                  var tr = painter.transform;
	                  var rotateWithMap = rotationAlignment === "map";
	                  var pitchWithMap = pitchAlignment === "map";
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    var tile = sourceCache.getTile(coord);
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket || !bucket.text || !bucket.text.segments.get().length) {
	                      continue;
	                    }
	                    var sizeData = bucket.textSizeData;
	                    var size = performance2.evaluateSizeForZoom(sizeData, tr.zoom);
	                    var pixelToTileScale = pixelsToTileUnits(tile, 1, painter.transform.zoom);
	                    var labelPlaneMatrix = getLabelPlaneMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, pixelToTileScale);
	                    var updateTextFitIcon = layer.layout.get("icon-text-fit") !== "none" && bucket.hasIconData();
	                    if (size) {
	                      var tileScale = Math.pow(2, tr.zoom - tile.tileID.overscaledZ);
	                      updateVariableAnchorsForBucket(bucket, rotateWithMap, pitchWithMap, variableOffsets, performance2.symbolSize, tr, labelPlaneMatrix, coord.posMatrix, tileScale, size, updateTextFitIcon);
	                    }
	                  }
	                }
	                function updateVariableAnchorsForBucket(bucket, rotateWithMap, pitchWithMap, variableOffsets, symbolSize, transform, labelPlaneMatrix, posMatrix, tileScale, size, updateTextFitIcon) {
	                  var placedSymbols = bucket.text.placedSymbolArray;
	                  var dynamicTextLayoutVertexArray = bucket.text.dynamicLayoutVertexArray;
	                  var dynamicIconLayoutVertexArray = bucket.icon.dynamicLayoutVertexArray;
	                  var placedTextShifts = {};
	                  dynamicTextLayoutVertexArray.clear();
	                  for (var s = 0; s < placedSymbols.length; s++) {
	                    var symbol = placedSymbols.get(s);
	                    var skipOrientation = bucket.allowVerticalPlacement && !symbol.placedOrientation;
	                    var variableOffset = !symbol.hidden && symbol.crossTileID && !skipOrientation ? variableOffsets[symbol.crossTileID] : null;
	                    if (!variableOffset) {
	                      hideGlyphs(symbol.numGlyphs, dynamicTextLayoutVertexArray);
	                    } else {
	                      var tileAnchor = new performance2.Point(symbol.anchorX, symbol.anchorY);
	                      var projectedAnchor = project(tileAnchor, pitchWithMap ? posMatrix : labelPlaneMatrix);
	                      var perspectiveRatio = getPerspectiveRatio(transform.cameraToCenterDistance, projectedAnchor.signedDistanceFromCamera);
	                      var renderTextSize = symbolSize.evaluateSizeForFeature(bucket.textSizeData, size, symbol) * perspectiveRatio / performance2.ONE_EM;
	                      if (pitchWithMap) {
	                        renderTextSize *= bucket.tilePixelRatio / tileScale;
	                      }
	                      var width = variableOffset.width;
	                      var height = variableOffset.height;
	                      var anchor = variableOffset.anchor;
	                      var textOffset = variableOffset.textOffset;
	                      var textBoxScale = variableOffset.textBoxScale;
	                      var shift = calculateVariableRenderShift(anchor, width, height, textOffset, textBoxScale, renderTextSize);
	                      var shiftedAnchor = pitchWithMap ? project(tileAnchor.add(shift), labelPlaneMatrix).point : projectedAnchor.point.add(rotateWithMap ? shift.rotate(-transform.angle) : shift);
	                      var angle = bucket.allowVerticalPlacement && symbol.placedOrientation === performance2.WritingMode.vertical ? Math.PI / 2 : 0;
	                      for (var g = 0; g < symbol.numGlyphs; g++) {
	                        performance2.addDynamicAttributes(dynamicTextLayoutVertexArray, shiftedAnchor, angle);
	                      }
	                      if (updateTextFitIcon && symbol.associatedIconIndex >= 0) {
	                        placedTextShifts[symbol.associatedIconIndex] = {
	                          shiftedAnchor,
	                          angle
	                        };
	                      }
	                    }
	                  }
	                  if (updateTextFitIcon) {
	                    dynamicIconLayoutVertexArray.clear();
	                    var placedIcons = bucket.icon.placedSymbolArray;
	                    for (var i = 0; i < placedIcons.length; i++) {
	                      var placedIcon = placedIcons.get(i);
	                      if (placedIcon.hidden) {
	                        hideGlyphs(placedIcon.numGlyphs, dynamicIconLayoutVertexArray);
	                      } else {
	                        var shift$1 = placedTextShifts[i];
	                        if (!shift$1) {
	                          hideGlyphs(placedIcon.numGlyphs, dynamicIconLayoutVertexArray);
	                        } else {
	                          for (var g$1 = 0; g$1 < placedIcon.numGlyphs; g$1++) {
	                            performance2.addDynamicAttributes(dynamicIconLayoutVertexArray, shift$1.shiftedAnchor, shift$1.angle);
	                          }
	                        }
	                      }
	                    }
	                    bucket.icon.dynamicLayoutVertexBuffer.updateData(dynamicIconLayoutVertexArray);
	                  }
	                  bucket.text.dynamicLayoutVertexBuffer.updateData(dynamicTextLayoutVertexArray);
	                }
	                function getSymbolProgramName(isSDF, isText, bucket) {
	                  if (bucket.iconsInText && isText) {
	                    return "symbolTextAndIcon";
	                  } else if (isSDF) {
	                    return "symbolSDF";
	                  } else {
	                    return "symbolIcon";
	                  }
	                }
	                function drawLayerSymbols(painter, sourceCache, layer, coords, isText, translate, translateAnchor, rotationAlignment, pitchAlignment, keepUpright, stencilMode, colorMode) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var tr = painter.transform;
	                  var rotateWithMap = rotationAlignment === "map";
	                  var pitchWithMap = pitchAlignment === "map";
	                  var alongLine = rotateWithMap && layer.layout.get("symbol-placement") !== "point";
	                  var rotateInShader = rotateWithMap && !pitchWithMap && !alongLine;
	                  var sortFeaturesByKey = layer.layout.get("symbol-sort-key").constantOr(1) !== undefined;
	                  var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
	                  var variablePlacement = layer.layout.get("text-variable-anchor");
	                  var tileRenderState = [];
	                  for (var i$1 = 0, list$1 = coords; i$1 < list$1.length; i$1 += 1) {
	                    var coord = list$1[i$1];
	                    var tile = sourceCache.getTile(coord);
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket) {
	                      continue;
	                    }
	                    var buffers = isText ? bucket.text : bucket.icon;
	                    if (!buffers || !buffers.segments.get().length) {
	                      continue;
	                    }
	                    var programConfiguration = buffers.programConfigurations.get(layer.id);
	                    var isSDF = isText || bucket.sdfIcons;
	                    var sizeData = isText ? bucket.textSizeData : bucket.iconSizeData;
	                    var transformed = pitchWithMap || tr.pitch !== 0;
	                    var program = painter.useProgram(getSymbolProgramName(isSDF, isText, bucket), programConfiguration);
	                    var size = performance2.evaluateSizeForZoom(sizeData, tr.zoom);
	                    var texSize = undefined;
	                    var texSizeIcon = [
	                      0,
	                      0
	                    ];
	                    var atlasTexture = undefined;
	                    var atlasInterpolation = undefined;
	                    var atlasTextureIcon = null;
	                    var atlasInterpolationIcon = undefined;
	                    if (isText) {
	                      atlasTexture = tile.glyphAtlasTexture;
	                      atlasInterpolation = gl2.LINEAR;
	                      texSize = tile.glyphAtlasTexture.size;
	                      if (bucket.iconsInText) {
	                        texSizeIcon = tile.imageAtlasTexture.size;
	                        atlasTextureIcon = tile.imageAtlasTexture;
	                        var zoomDependentSize = sizeData.kind === "composite" || sizeData.kind === "camera";
	                        atlasInterpolationIcon = transformed || painter.options.rotating || painter.options.zooming || zoomDependentSize ? gl2.LINEAR : gl2.NEAREST;
	                      }
	                    } else {
	                      var iconScaled = layer.layout.get("icon-size").constantOr(0) !== 1 || bucket.iconsNeedLinear;
	                      atlasTexture = tile.imageAtlasTexture;
	                      atlasInterpolation = isSDF || painter.options.rotating || painter.options.zooming || iconScaled || transformed ? gl2.LINEAR : gl2.NEAREST;
	                      texSize = tile.imageAtlasTexture.size;
	                    }
	                    var s = pixelsToTileUnits(tile, 1, painter.transform.zoom);
	                    var labelPlaneMatrix = getLabelPlaneMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
	                    var glCoordMatrix = getGlCoordMatrix(coord.posMatrix, pitchWithMap, rotateWithMap, painter.transform, s);
	                    var hasVariableAnchors = variablePlacement && bucket.hasTextData();
	                    var updateTextFitIcon = layer.layout.get("icon-text-fit") !== "none" && hasVariableAnchors && bucket.hasIconData();
	                    if (alongLine) {
	                      updateLineLabels(bucket, coord.posMatrix, painter, isText, labelPlaneMatrix, glCoordMatrix, pitchWithMap, keepUpright);
	                    }
	                    var matrix = painter.translatePosMatrix(coord.posMatrix, tile, translate, translateAnchor), uLabelPlaneMatrix = alongLine || isText && variablePlacement || updateTextFitIcon ? identityMat4 : labelPlaneMatrix, uglCoordMatrix = painter.translatePosMatrix(glCoordMatrix, tile, translate, translateAnchor, true);
	                    var hasHalo = isSDF && layer.paint.get(isText ? "text-halo-width" : "icon-halo-width").constantOr(1) !== 0;
	                    var uniformValues = undefined;
	                    if (isSDF) {
	                      if (!bucket.iconsInText) {
	                        uniformValues = symbolSDFUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, isText, texSize);
	                      } else {
	                        uniformValues = symbolTextAndIconUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, texSize, texSizeIcon);
	                      }
	                    } else {
	                      uniformValues = symbolIconUniformValues(sizeData.kind, size, rotateInShader, pitchWithMap, painter, matrix, uLabelPlaneMatrix, uglCoordMatrix, isText, texSize);
	                    }
	                    var state = {
	                      program,
	                      buffers,
	                      uniformValues,
	                      atlasTexture,
	                      atlasTextureIcon,
	                      atlasInterpolation,
	                      atlasInterpolationIcon,
	                      isSDF,
	                      hasHalo
	                    };
	                    if (sortFeaturesByKey) {
	                      var oldSegments = buffers.segments.get();
	                      for (var i = 0, list = oldSegments; i < list.length; i += 1) {
	                        var segment = list[i];
	                        tileRenderState.push({
	                          segments: new performance2.SegmentVector([segment]),
	                          sortKey: segment.sortKey,
	                          state
	                        });
	                      }
	                    } else {
	                      tileRenderState.push({
	                        segments: buffers.segments,
	                        sortKey: 0,
	                        state
	                      });
	                    }
	                  }
	                  if (sortFeaturesByKey) {
	                    tileRenderState.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                  for (var i$2 = 0, list$2 = tileRenderState; i$2 < list$2.length; i$2 += 1) {
	                    var segmentState = list$2[i$2];
	                    var state$1 = segmentState.state;
	                    context.activeTexture.set(gl2.TEXTURE0);
	                    state$1.atlasTexture.bind(state$1.atlasInterpolation, gl2.CLAMP_TO_EDGE);
	                    if (state$1.atlasTextureIcon) {
	                      context.activeTexture.set(gl2.TEXTURE1);
	                      if (state$1.atlasTextureIcon) {
	                        state$1.atlasTextureIcon.bind(state$1.atlasInterpolationIcon, gl2.CLAMP_TO_EDGE);
	                      }
	                    }
	                    if (state$1.isSDF) {
	                      var uniformValues$1 = state$1.uniformValues;
	                      if (state$1.hasHalo) {
	                        uniformValues$1["u_is_halo"] = 1;
	                        drawSymbolElements(state$1.buffers, segmentState.segments, layer, painter, state$1.program, depthMode, stencilMode, colorMode, uniformValues$1);
	                      }
	                      uniformValues$1["u_is_halo"] = 0;
	                    }
	                    drawSymbolElements(state$1.buffers, segmentState.segments, layer, painter, state$1.program, depthMode, stencilMode, colorMode, state$1.uniformValues);
	                  }
	                }
	                function drawSymbolElements(buffers, segments, layer, painter, program, depthMode, stencilMode, colorMode, uniformValues) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  program.draw(context, gl2.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, layer.id, buffers.layoutVertexBuffer, buffers.indexBuffer, segments, layer.paint, painter.transform.zoom, buffers.programConfigurations.get(layer.id), buffers.dynamicLayoutVertexBuffer, buffers.opacityVertexBuffer);
	                }
	                function drawCircles(painter, sourceCache, layer, coords) {
	                  if (painter.renderPass !== "translucent") {
	                    return;
	                  }
	                  var opacity = layer.paint.get("circle-opacity");
	                  var strokeWidth = layer.paint.get("circle-stroke-width");
	                  var strokeOpacity = layer.paint.get("circle-stroke-opacity");
	                  var sortFeaturesByKey = layer.layout.get("circle-sort-key").constantOr(1) !== undefined;
	                  if (opacity.constantOr(1) === 0 && (strokeWidth.constantOr(1) === 0 || strokeOpacity.constantOr(1) === 0)) {
	                    return;
	                  }
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
	                  var stencilMode = StencilMode.disabled;
	                  var colorMode = painter.colorModeForRenderPass();
	                  var segmentsRenderStates = [];
	                  for (var i = 0; i < coords.length; i++) {
	                    var coord = coords[i];
	                    var tile = sourceCache.getTile(coord);
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket) {
	                      continue;
	                    }
	                    var programConfiguration = bucket.programConfigurations.get(layer.id);
	                    var program = painter.useProgram("circle", programConfiguration);
	                    var layoutVertexBuffer = bucket.layoutVertexBuffer;
	                    var indexBuffer = bucket.indexBuffer;
	                    var uniformValues = circleUniformValues(painter, coord, tile, layer);
	                    var state = {
	                      programConfiguration,
	                      program,
	                      layoutVertexBuffer,
	                      indexBuffer,
	                      uniformValues
	                    };
	                    if (sortFeaturesByKey) {
	                      var oldSegments = bucket.segments.get();
	                      for (var i$1 = 0, list = oldSegments; i$1 < list.length; i$1 += 1) {
	                        var segment = list[i$1];
	                        segmentsRenderStates.push({
	                          segments: new performance2.SegmentVector([segment]),
	                          sortKey: segment.sortKey,
	                          state
	                        });
	                      }
	                    } else {
	                      segmentsRenderStates.push({
	                        segments: bucket.segments,
	                        sortKey: 0,
	                        state
	                      });
	                    }
	                  }
	                  if (sortFeaturesByKey) {
	                    segmentsRenderStates.sort(function(a, b) {
	                      return a.sortKey - b.sortKey;
	                    });
	                  }
	                  for (var i$2 = 0, list$1 = segmentsRenderStates; i$2 < list$1.length; i$2 += 1) {
	                    var segmentsState = list$1[i$2];
	                    var ref = segmentsState.state;
	                    var programConfiguration$1 = ref.programConfiguration;
	                    var program$1 = ref.program;
	                    var layoutVertexBuffer$1 = ref.layoutVertexBuffer;
	                    var indexBuffer$1 = ref.indexBuffer;
	                    var uniformValues$1 = ref.uniformValues;
	                    var segments = segmentsState.segments;
	                    program$1.draw(context, gl2.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues$1, layer.id, layoutVertexBuffer$1, indexBuffer$1, segments, layer.paint, painter.transform.zoom, programConfiguration$1);
	                  }
	                }
	                function drawHeatmap(painter, sourceCache, layer, coords) {
	                  if (layer.paint.get("heatmap-opacity") === 0) {
	                    return;
	                  }
	                  if (painter.renderPass === "offscreen") {
	                    var context = painter.context;
	                    var gl2 = context.gl;
	                    var stencilMode = StencilMode.disabled;
	                    var colorMode = new ColorMode([
	                      gl2.ONE,
	                      gl2.ONE
	                    ], performance2.Color.transparent, [
	                      true,
	                      true,
	                      true,
	                      true
	                    ]);
	                    bindFramebuffer(context, painter, layer);
	                    context.clear({ color: performance2.Color.transparent });
	                    for (var i = 0; i < coords.length; i++) {
	                      var coord = coords[i];
	                      if (sourceCache.hasRenderableParent(coord)) {
	                        continue;
	                      }
	                      var tile = sourceCache.getTile(coord);
	                      var bucket = tile.getBucket(layer);
	                      if (!bucket) {
	                        continue;
	                      }
	                      var programConfiguration = bucket.programConfigurations.get(layer.id);
	                      var program = painter.useProgram("heatmap", programConfiguration);
	                      var ref = painter.transform;
	                      var zoom = ref.zoom;
	                      program.draw(context, gl2.TRIANGLES, DepthMode.disabled, stencilMode, colorMode, CullFaceMode.disabled, heatmapUniformValues(coord.posMatrix, tile, zoom, layer.paint.get("heatmap-intensity")), layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration);
	                    }
	                    context.viewport.set([
	                      0,
	                      0,
	                      painter.width,
	                      painter.height
	                    ]);
	                  } else if (painter.renderPass === "translucent") {
	                    painter.context.setColorMode(painter.colorModeForRenderPass());
	                    renderTextureToMap(painter, layer);
	                  }
	                }
	                function bindFramebuffer(context, painter, layer) {
	                  var gl2 = context.gl;
	                  context.activeTexture.set(gl2.TEXTURE1);
	                  context.viewport.set([
	                    0,
	                    0,
	                    painter.width / 4,
	                    painter.height / 4
	                  ]);
	                  var fbo = layer.heatmapFbo;
	                  if (!fbo) {
	                    var texture = gl2.createTexture();
	                    gl2.bindTexture(gl2.TEXTURE_2D, texture);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_S, gl2.CLAMP_TO_EDGE);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_WRAP_T, gl2.CLAMP_TO_EDGE);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MIN_FILTER, gl2.LINEAR);
	                    gl2.texParameteri(gl2.TEXTURE_2D, gl2.TEXTURE_MAG_FILTER, gl2.LINEAR);
	                    fbo = layer.heatmapFbo = context.createFramebuffer(painter.width / 4, painter.height / 4, false);
	                    bindTextureToFramebuffer(context, painter, texture, fbo);
	                  } else {
	                    gl2.bindTexture(gl2.TEXTURE_2D, fbo.colorAttachment.get());
	                    context.bindFramebuffer.set(fbo.framebuffer);
	                  }
	                }
	                function bindTextureToFramebuffer(context, painter, texture, fbo) {
	                  var gl2 = context.gl;
	                  var internalFormat = context.extRenderToTextureHalfFloat ? context.extTextureHalfFloat.HALF_FLOAT_OES : gl2.UNSIGNED_BYTE;
	                  gl2.texImage2D(gl2.TEXTURE_2D, 0, gl2.RGBA, painter.width / 4, painter.height / 4, 0, gl2.RGBA, internalFormat, null);
	                  fbo.colorAttachment.set(texture);
	                }
	                function renderTextureToMap(painter, layer) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var fbo = layer.heatmapFbo;
	                  if (!fbo) {
	                    return;
	                  }
	                  context.activeTexture.set(gl2.TEXTURE0);
	                  gl2.bindTexture(gl2.TEXTURE_2D, fbo.colorAttachment.get());
	                  context.activeTexture.set(gl2.TEXTURE1);
	                  var colorRampTexture = layer.colorRampTexture;
	                  if (!colorRampTexture) {
	                    colorRampTexture = layer.colorRampTexture = new performance2.Texture(context, layer.colorRamp, gl2.RGBA);
	                  }
	                  colorRampTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                  painter.useProgram("heatmapTexture").draw(context, gl2.TRIANGLES, DepthMode.disabled, StencilMode.disabled, painter.colorModeForRenderPass(), CullFaceMode.disabled, heatmapTextureUniformValues(painter, layer, 0, 1), layer.id, painter.viewportBuffer, painter.quadTriangleIndexBuffer, painter.viewportSegments, layer.paint, painter.transform.zoom);
	                }
	                function drawLine(painter, sourceCache, layer, coords) {
	                  if (painter.renderPass !== "translucent") {
	                    return;
	                  }
	                  var opacity = layer.paint.get("line-opacity");
	                  var width = layer.paint.get("line-width");
	                  if (opacity.constantOr(1) === 0 || width.constantOr(1) === 0) {
	                    return;
	                  }
	                  var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
	                  var colorMode = painter.colorModeForRenderPass();
	                  var dasharray = layer.paint.get("line-dasharray");
	                  var patternProperty = layer.paint.get("line-pattern");
	                  var image = patternProperty.constantOr(1);
	                  var gradient = layer.paint.get("line-gradient");
	                  var crossfade = layer.getCrossfadeParameters();
	                  var programId = image ? "linePattern" : dasharray ? "lineSDF" : gradient ? "lineGradient" : "line";
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var firstTile = true;
	                  if (gradient) {
	                    context.activeTexture.set(gl2.TEXTURE0);
	                    var gradientTexture = layer.gradientTexture;
	                    if (!layer.gradient) {
	                      return;
	                    }
	                    if (!gradientTexture) {
	                      gradientTexture = layer.gradientTexture = new performance2.Texture(context, layer.gradient, gl2.RGBA);
	                    }
	                    gradientTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                  }
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    var tile = sourceCache.getTile(coord);
	                    if (image && !tile.patternsLoaded()) {
	                      continue;
	                    }
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket) {
	                      continue;
	                    }
	                    var programConfiguration = bucket.programConfigurations.get(layer.id);
	                    var prevProgram = painter.context.program.get();
	                    var program = painter.useProgram(programId, programConfiguration);
	                    var programChanged = firstTile || program.program !== prevProgram;
	                    var constantPattern = patternProperty.constantOr(null);
	                    if (constantPattern && tile.imageAtlas) {
	                      var atlas = tile.imageAtlas;
	                      var posTo = atlas.patternPositions[constantPattern.to.toString()];
	                      var posFrom = atlas.patternPositions[constantPattern.from.toString()];
	                      if (posTo && posFrom) {
	                        programConfiguration.setConstantPatternPositions(posTo, posFrom);
	                      }
	                    }
	                    var uniformValues = image ? linePatternUniformValues(painter, tile, layer, crossfade) : dasharray ? lineSDFUniformValues(painter, tile, layer, dasharray, crossfade) : gradient ? lineGradientUniformValues(painter, tile, layer) : lineUniformValues(painter, tile, layer);
	                    if (image) {
	                      context.activeTexture.set(gl2.TEXTURE0);
	                      tile.imageAtlasTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                      programConfiguration.updatePaintBuffers(crossfade);
	                    } else if (dasharray && (programChanged || painter.lineAtlas.dirty)) {
	                      context.activeTexture.set(gl2.TEXTURE0);
	                      painter.lineAtlas.bind(context);
	                    }
	                    program.draw(context, gl2.TRIANGLES, depthMode, painter.stencilModeForClipping(coord), colorMode, CullFaceMode.disabled, uniformValues, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration);
	                    firstTile = false;
	                  }
	                }
	                function drawFill(painter, sourceCache, layer, coords) {
	                  var color = layer.paint.get("fill-color");
	                  var opacity = layer.paint.get("fill-opacity");
	                  if (opacity.constantOr(1) === 0) {
	                    return;
	                  }
	                  var colorMode = painter.colorModeForRenderPass();
	                  var pattern = layer.paint.get("fill-pattern");
	                  var pass = painter.opaquePassEnabledForLayer() && (!pattern.constantOr(1) && color.constantOr(performance2.Color.transparent).a === 1 && opacity.constantOr(0) === 1) ? "opaque" : "translucent";
	                  if (painter.renderPass === pass) {
	                    var depthMode = painter.depthModeForSublayer(1, painter.renderPass === "opaque" ? DepthMode.ReadWrite : DepthMode.ReadOnly);
	                    drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, false);
	                  }
	                  if (painter.renderPass === "translucent" && layer.paint.get("fill-antialias")) {
	                    var depthMode$1 = painter.depthModeForSublayer(layer.getPaintProperty("fill-outline-color") ? 2 : 0, DepthMode.ReadOnly);
	                    drawFillTiles(painter, sourceCache, layer, coords, depthMode$1, colorMode, true);
	                  }
	                }
	                function drawFillTiles(painter, sourceCache, layer, coords, depthMode, colorMode, isOutline) {
	                  var gl2 = painter.context.gl;
	                  var patternProperty = layer.paint.get("fill-pattern");
	                  var image = patternProperty && patternProperty.constantOr(1);
	                  var crossfade = layer.getCrossfadeParameters();
	                  var drawMode, programName, uniformValues, indexBuffer, segments;
	                  if (!isOutline) {
	                    programName = image ? "fillPattern" : "fill";
	                    drawMode = gl2.TRIANGLES;
	                  } else {
	                    programName = image && !layer.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline";
	                    drawMode = gl2.LINES;
	                  }
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    var tile = sourceCache.getTile(coord);
	                    if (image && !tile.patternsLoaded()) {
	                      continue;
	                    }
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket) {
	                      continue;
	                    }
	                    var programConfiguration = bucket.programConfigurations.get(layer.id);
	                    var program = painter.useProgram(programName, programConfiguration);
	                    if (image) {
	                      painter.context.activeTexture.set(gl2.TEXTURE0);
	                      tile.imageAtlasTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                      programConfiguration.updatePaintBuffers(crossfade);
	                    }
	                    var constantPattern = patternProperty.constantOr(null);
	                    if (constantPattern && tile.imageAtlas) {
	                      var atlas = tile.imageAtlas;
	                      var posTo = atlas.patternPositions[constantPattern.to.toString()];
	                      var posFrom = atlas.patternPositions[constantPattern.from.toString()];
	                      if (posTo && posFrom) {
	                        programConfiguration.setConstantPatternPositions(posTo, posFrom);
	                      }
	                    }
	                    var tileMatrix = painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get("fill-translate"), layer.paint.get("fill-translate-anchor"));
	                    if (!isOutline) {
	                      indexBuffer = bucket.indexBuffer;
	                      segments = bucket.segments;
	                      uniformValues = image ? fillPatternUniformValues(tileMatrix, painter, crossfade, tile) : fillUniformValues(tileMatrix);
	                    } else {
	                      indexBuffer = bucket.indexBuffer2;
	                      segments = bucket.segments2;
	                      var drawingBufferSize = [
	                        gl2.drawingBufferWidth,
	                        gl2.drawingBufferHeight
	                      ];
	                      uniformValues = programName === "fillOutlinePattern" && image ? fillOutlinePatternUniformValues(tileMatrix, painter, crossfade, tile, drawingBufferSize) : fillOutlineUniformValues(tileMatrix, drawingBufferSize);
	                    }
	                    program.draw(painter.context, drawMode, depthMode, painter.stencilModeForClipping(coord), colorMode, CullFaceMode.disabled, uniformValues, layer.id, bucket.layoutVertexBuffer, indexBuffer, segments, layer.paint, painter.transform.zoom, programConfiguration);
	                  }
	                }
	                function draw(painter, source, layer, coords) {
	                  var opacity = layer.paint.get("fill-extrusion-opacity");
	                  if (opacity === 0) {
	                    return;
	                  }
	                  if (painter.renderPass === "translucent") {
	                    var depthMode = new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D);
	                    if (opacity === 1 && !layer.paint.get("fill-extrusion-pattern").constantOr(1)) {
	                      var colorMode = painter.colorModeForRenderPass();
	                      drawExtrusionTiles(painter, source, layer, coords, depthMode, StencilMode.disabled, colorMode);
	                    } else {
	                      drawExtrusionTiles(painter, source, layer, coords, depthMode, StencilMode.disabled, ColorMode.disabled);
	                      drawExtrusionTiles(painter, source, layer, coords, depthMode, painter.stencilModeFor3D(), painter.colorModeForRenderPass());
	                    }
	                  }
	                }
	                function drawExtrusionTiles(painter, source, layer, coords, depthMode, stencilMode, colorMode) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var patternProperty = layer.paint.get("fill-extrusion-pattern");
	                  var image = patternProperty.constantOr(1);
	                  var crossfade = layer.getCrossfadeParameters();
	                  var opacity = layer.paint.get("fill-extrusion-opacity");
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    var tile = source.getTile(coord);
	                    var bucket = tile.getBucket(layer);
	                    if (!bucket) {
	                      continue;
	                    }
	                    var programConfiguration = bucket.programConfigurations.get(layer.id);
	                    var program = painter.useProgram(image ? "fillExtrusionPattern" : "fillExtrusion", programConfiguration);
	                    if (image) {
	                      painter.context.activeTexture.set(gl2.TEXTURE0);
	                      tile.imageAtlasTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                      programConfiguration.updatePaintBuffers(crossfade);
	                    }
	                    var constantPattern = patternProperty.constantOr(null);
	                    if (constantPattern && tile.imageAtlas) {
	                      var atlas = tile.imageAtlas;
	                      var posTo = atlas.patternPositions[constantPattern.to.toString()];
	                      var posFrom = atlas.patternPositions[constantPattern.from.toString()];
	                      if (posTo && posFrom) {
	                        programConfiguration.setConstantPatternPositions(posTo, posFrom);
	                      }
	                    }
	                    var matrix = painter.translatePosMatrix(coord.posMatrix, tile, layer.paint.get("fill-extrusion-translate"), layer.paint.get("fill-extrusion-translate-anchor"));
	                    var shouldUseVerticalGradient = layer.paint.get("fill-extrusion-vertical-gradient");
	                    var uniformValues = image ? fillExtrusionPatternUniformValues(matrix, painter, shouldUseVerticalGradient, opacity, coord, crossfade, tile) : fillExtrusionUniformValues(matrix, painter, shouldUseVerticalGradient, opacity);
	                    program.draw(context, context.gl.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.backCCW, uniformValues, layer.id, bucket.layoutVertexBuffer, bucket.indexBuffer, bucket.segments, layer.paint, painter.transform.zoom, programConfiguration);
	                  }
	                }
	                function drawHillshade(painter, sourceCache, layer, tileIDs) {
	                  if (painter.renderPass !== "offscreen" && painter.renderPass !== "translucent") {
	                    return;
	                  }
	                  var context = painter.context;
	                  var sourceMaxZoom = sourceCache.getSource().maxzoom;
	                  var depthMode = painter.depthModeForSublayer(0, DepthMode.ReadOnly);
	                  var colorMode = painter.colorModeForRenderPass();
	                  var ref = painter.renderPass === "translucent" ? painter.stencilConfigForOverlap(tileIDs) : [
	                    {},
	                    tileIDs
	                  ];
	                  var stencilModes = ref[0];
	                  var coords = ref[1];
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    var tile = sourceCache.getTile(coord);
	                    if (tile.needsHillshadePrepare && painter.renderPass === "offscreen") {
	                      prepareHillshade(painter, tile, layer, sourceMaxZoom, depthMode, StencilMode.disabled, colorMode);
	                    } else if (painter.renderPass === "translucent") {
	                      renderHillshade(painter, tile, layer, depthMode, stencilModes[coord.overscaledZ], colorMode);
	                    }
	                  }
	                  context.viewport.set([
	                    0,
	                    0,
	                    painter.width,
	                    painter.height
	                  ]);
	                }
	                function renderHillshade(painter, tile, layer, depthMode, stencilMode, colorMode) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var fbo = tile.fbo;
	                  if (!fbo) {
	                    return;
	                  }
	                  var program = painter.useProgram("hillshade");
	                  context.activeTexture.set(gl2.TEXTURE0);
	                  gl2.bindTexture(gl2.TEXTURE_2D, fbo.colorAttachment.get());
	                  var uniformValues = hillshadeUniformValues(painter, tile, layer);
	                  program.draw(context, gl2.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
	                }
	                function prepareHillshade(painter, tile, layer, sourceMaxZoom, depthMode, stencilMode, colorMode) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var dem = tile.dem;
	                  if (dem && dem.data) {
	                    var tileSize = dem.dim;
	                    var textureStride = dem.stride;
	                    var pixelData = dem.getPixels();
	                    context.activeTexture.set(gl2.TEXTURE1);
	                    context.pixelStoreUnpackPremultiplyAlpha.set(false);
	                    tile.demTexture = tile.demTexture || painter.getTileTexture(textureStride);
	                    if (tile.demTexture) {
	                      var demTexture = tile.demTexture;
	                      demTexture.update(pixelData, { premultiply: false });
	                      demTexture.bind(gl2.NEAREST, gl2.CLAMP_TO_EDGE);
	                    } else {
	                      tile.demTexture = new performance2.Texture(context, pixelData, gl2.RGBA, { premultiply: false });
	                      tile.demTexture.bind(gl2.NEAREST, gl2.CLAMP_TO_EDGE);
	                    }
	                    context.activeTexture.set(gl2.TEXTURE0);
	                    var fbo = tile.fbo;
	                    if (!fbo) {
	                      var renderTexture = new performance2.Texture(context, {
	                        width: tileSize,
	                        height: tileSize,
	                        data: null
	                      }, gl2.RGBA);
	                      renderTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                      fbo = tile.fbo = context.createFramebuffer(tileSize, tileSize, true);
	                      fbo.colorAttachment.set(renderTexture.texture);
	                    }
	                    context.bindFramebuffer.set(fbo.framebuffer);
	                    context.viewport.set([
	                      0,
	                      0,
	                      tileSize,
	                      tileSize
	                    ]);
	                    painter.useProgram("hillshadePrepare").draw(context, gl2.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, hillshadeUniformPrepareValues(tile.tileID, dem, sourceMaxZoom), layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
	                    tile.needsHillshadePrepare = false;
	                  }
	                }
	                function drawRaster(painter, sourceCache, layer, tileIDs) {
	                  if (painter.renderPass !== "translucent") {
	                    return;
	                  }
	                  if (layer.paint.get("raster-opacity") === 0) {
	                    return;
	                  }
	                  if (!tileIDs.length) {
	                    return;
	                  }
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var source = sourceCache.getSource();
	                  var program = painter.useProgram("raster");
	                  var colorMode = painter.colorModeForRenderPass();
	                  var ref = source instanceof ImageSource ? [
	                    {},
	                    tileIDs
	                  ] : painter.stencilConfigForOverlap(tileIDs);
	                  var stencilModes = ref[0];
	                  var coords = ref[1];
	                  var minTileZ = coords[coords.length - 1].overscaledZ;
	                  var align = !painter.options.moving;
	                  for (var i = 0, list = coords; i < list.length; i += 1) {
	                    var coord = list[i];
	                    var depthMode = painter.depthModeForSublayer(coord.overscaledZ - minTileZ, layer.paint.get("raster-opacity") === 1 ? DepthMode.ReadWrite : DepthMode.ReadOnly, gl2.LESS);
	                    var tile = sourceCache.getTile(coord);
	                    var posMatrix = painter.transform.calculatePosMatrix(coord.toUnwrapped(), align);
	                    tile.registerFadeDuration(layer.paint.get("raster-fade-duration"));
	                    var parentTile = sourceCache.findLoadedParent(coord, 0), fade = getFadeValues(tile, parentTile, sourceCache, layer, painter.transform);
	                    var parentScaleBy = undefined, parentTL = undefined;
	                    var textureFilter = layer.paint.get("raster-resampling") === "nearest" ? gl2.NEAREST : gl2.LINEAR;
	                    context.activeTexture.set(gl2.TEXTURE0);
	                    tile.texture.bind(textureFilter, gl2.CLAMP_TO_EDGE, gl2.LINEAR_MIPMAP_NEAREST);
	                    context.activeTexture.set(gl2.TEXTURE1);
	                    if (parentTile) {
	                      parentTile.texture.bind(textureFilter, gl2.CLAMP_TO_EDGE, gl2.LINEAR_MIPMAP_NEAREST);
	                      parentScaleBy = Math.pow(2, parentTile.tileID.overscaledZ - tile.tileID.overscaledZ);
	                      parentTL = [
	                        tile.tileID.canonical.x * parentScaleBy % 1,
	                        tile.tileID.canonical.y * parentScaleBy % 1
	                      ];
	                    } else {
	                      tile.texture.bind(textureFilter, gl2.CLAMP_TO_EDGE, gl2.LINEAR_MIPMAP_NEAREST);
	                    }
	                    var uniformValues = rasterUniformValues(posMatrix, parentTL || [
	                      0,
	                      0
	                    ], parentScaleBy || 1, fade, layer);
	                    if (source instanceof ImageSource) {
	                      program.draw(context, gl2.TRIANGLES, depthMode, StencilMode.disabled, colorMode, CullFaceMode.disabled, uniformValues, layer.id, source.boundsBuffer, painter.quadTriangleIndexBuffer, source.boundsSegments);
	                    } else {
	                      program.draw(context, gl2.TRIANGLES, depthMode, stencilModes[coord.overscaledZ], colorMode, CullFaceMode.disabled, uniformValues, layer.id, painter.rasterBoundsBuffer, painter.quadTriangleIndexBuffer, painter.rasterBoundsSegments);
	                    }
	                  }
	                }
	                function getFadeValues(tile, parentTile, sourceCache, layer, transform) {
	                  var fadeDuration = layer.paint.get("raster-fade-duration");
	                  if (fadeDuration > 0) {
	                    var now = performance2.browser.now();
	                    var sinceTile = (now - tile.timeAdded) / fadeDuration;
	                    var sinceParent = parentTile ? (now - parentTile.timeAdded) / fadeDuration : -1;
	                    var source = sourceCache.getSource();
	                    var idealZ = transform.coveringZoomLevel({
	                      tileSize: source.tileSize,
	                      roundZoom: source.roundZoom
	                    });
	                    var fadeIn = !parentTile || Math.abs(parentTile.tileID.overscaledZ - idealZ) > Math.abs(tile.tileID.overscaledZ - idealZ);
	                    var childOpacity = fadeIn && tile.refreshedUponExpiration ? 1 : performance2.clamp(fadeIn ? sinceTile : 1 - sinceParent, 0, 1);
	                    if (tile.refreshedUponExpiration && sinceTile >= 1) {
	                      tile.refreshedUponExpiration = false;
	                    }
	                    if (parentTile) {
	                      return {
	                        opacity: 1,
	                        mix: 1 - childOpacity
	                      };
	                    } else {
	                      return {
	                        opacity: childOpacity,
	                        mix: 0
	                      };
	                    }
	                  } else {
	                    return {
	                      opacity: 1,
	                      mix: 0
	                    };
	                  }
	                }
	                function drawBackground(painter, sourceCache, layer) {
	                  var color = layer.paint.get("background-color");
	                  var opacity = layer.paint.get("background-opacity");
	                  if (opacity === 0) {
	                    return;
	                  }
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var transform = painter.transform;
	                  var tileSize = transform.tileSize;
	                  var image = layer.paint.get("background-pattern");
	                  if (painter.isPatternMissing(image)) {
	                    return;
	                  }
	                  var pass = !image && color.a === 1 && opacity === 1 && painter.opaquePassEnabledForLayer() ? "opaque" : "translucent";
	                  if (painter.renderPass !== pass) {
	                    return;
	                  }
	                  var stencilMode = StencilMode.disabled;
	                  var depthMode = painter.depthModeForSublayer(0, pass === "opaque" ? DepthMode.ReadWrite : DepthMode.ReadOnly);
	                  var colorMode = painter.colorModeForRenderPass();
	                  var program = painter.useProgram(image ? "backgroundPattern" : "background");
	                  var tileIDs = transform.coveringTiles({ tileSize });
	                  if (image) {
	                    context.activeTexture.set(gl2.TEXTURE0);
	                    painter.imageManager.bind(painter.context);
	                  }
	                  var crossfade = layer.getCrossfadeParameters();
	                  for (var i = 0, list = tileIDs; i < list.length; i += 1) {
	                    var tileID = list[i];
	                    var matrix = painter.transform.calculatePosMatrix(tileID.toUnwrapped());
	                    var uniformValues = image ? backgroundPatternUniformValues(matrix, opacity, painter, image, {
	                      tileID,
	                      tileSize
	                    }, crossfade) : backgroundUniformValues(matrix, opacity, color);
	                    program.draw(context, gl2.TRIANGLES, depthMode, stencilMode, colorMode, CullFaceMode.disabled, uniformValues, layer.id, painter.tileExtentBuffer, painter.quadTriangleIndexBuffer, painter.tileExtentSegments);
	                  }
	                }
	                var topColor = new performance2.Color(1, 0, 0, 1);
	                var btmColor = new performance2.Color(0, 1, 0, 1);
	                var leftColor = new performance2.Color(0, 0, 1, 1);
	                var rightColor = new performance2.Color(1, 0, 1, 1);
	                var centerColor = new performance2.Color(0, 1, 1, 1);
	                function drawDebugPadding(painter) {
	                  var padding2 = painter.transform.padding;
	                  var lineWidth = 3;
	                  drawHorizontalLine(painter, painter.transform.height - (padding2.top || 0), lineWidth, topColor);
	                  drawHorizontalLine(painter, padding2.bottom || 0, lineWidth, btmColor);
	                  drawVerticalLine(painter, padding2.left || 0, lineWidth, leftColor);
	                  drawVerticalLine(painter, painter.transform.width - (padding2.right || 0), lineWidth, rightColor);
	                  var center = painter.transform.centerPoint;
	                  drawCrosshair(painter, center.x, painter.transform.height - center.y, centerColor);
	                }
	                function drawCrosshair(painter, x, y, color) {
	                  var size = 20;
	                  var lineWidth = 2;
	                  drawDebugSSRect(painter, x - lineWidth / 2, y - size / 2, lineWidth, size, color);
	                  drawDebugSSRect(painter, x - size / 2, y - lineWidth / 2, size, lineWidth, color);
	                }
	                function drawHorizontalLine(painter, y, lineWidth, color) {
	                  drawDebugSSRect(painter, 0, y + lineWidth / 2, painter.transform.width, lineWidth, color);
	                }
	                function drawVerticalLine(painter, x, lineWidth, color) {
	                  drawDebugSSRect(painter, x - lineWidth / 2, 0, lineWidth, painter.transform.height, color);
	                }
	                function drawDebugSSRect(painter, x, y, width, height, color) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  gl2.enable(gl2.SCISSOR_TEST);
	                  gl2.scissor(x * performance2.browser.devicePixelRatio, y * performance2.browser.devicePixelRatio, width * performance2.browser.devicePixelRatio, height * performance2.browser.devicePixelRatio);
	                  context.clear({ color });
	                  gl2.disable(gl2.SCISSOR_TEST);
	                }
	                function drawDebug(painter, sourceCache, coords) {
	                  for (var i = 0; i < coords.length; i++) {
	                    drawDebugTile(painter, sourceCache, coords[i]);
	                  }
	                }
	                function drawDebugTile(painter, sourceCache, coord) {
	                  var context = painter.context;
	                  var gl2 = context.gl;
	                  var posMatrix = coord.posMatrix;
	                  var program = painter.useProgram("debug");
	                  var depthMode = DepthMode.disabled;
	                  var stencilMode = StencilMode.disabled;
	                  var colorMode = painter.colorModeForRenderPass();
	                  var id = "$debug";
	                  context.activeTexture.set(gl2.TEXTURE0);
	                  painter.emptyTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                  program.draw(context, gl2.LINE_STRIP, depthMode, stencilMode, colorMode, CullFaceMode.disabled, debugUniformValues(posMatrix, performance2.Color.red), id, painter.debugBuffer, painter.tileBorderIndexBuffer, painter.debugSegments);
	                  var tileRawData = sourceCache.getTileByID(coord.key).latestRawTileData;
	                  var tileByteLength = tileRawData && tileRawData.byteLength || 0;
	                  var tileSizeKb = Math.floor(tileByteLength / 1024);
	                  var tileSize = sourceCache.getTile(coord).tileSize;
	                  var scaleRatio = 512 / Math.min(tileSize, 512) * (coord.overscaledZ / painter.transform.zoom) * 0.5;
	                  var tileIdText = coord.canonical.toString();
	                  if (coord.overscaledZ !== coord.canonical.z) {
	                    tileIdText += " => " + coord.overscaledZ;
	                  }
	                  var tileLabel = tileIdText + " " + tileSizeKb + "kb";
	                  drawTextToOverlay(painter, tileLabel);
	                  program.draw(context, gl2.TRIANGLES, depthMode, stencilMode, ColorMode.alphaBlended, CullFaceMode.disabled, debugUniformValues(posMatrix, performance2.Color.transparent, scaleRatio), id, painter.debugBuffer, painter.quadTriangleIndexBuffer, painter.debugSegments);
	                }
	                function drawTextToOverlay(painter, text) {
	                  painter.initDebugOverlayCanvas();
	                  var canvas = painter.debugOverlayCanvas;
	                  var gl2 = painter.context.gl;
	                  var ctx2d = painter.debugOverlayCanvas.getContext("2d");
	                  ctx2d.clearRect(0, 0, canvas.width, canvas.height);
	                  ctx2d.shadowColor = "white";
	                  ctx2d.shadowBlur = 2;
	                  ctx2d.lineWidth = 1.5;
	                  ctx2d.strokeStyle = "white";
	                  ctx2d.textBaseline = "top";
	                  ctx2d.font = "bold 36px Open Sans, sans-serif";
	                  ctx2d.fillText(text, 5, 5);
	                  ctx2d.strokeText(text, 5, 5);
	                  painter.debugOverlayTexture.update(canvas);
	                  painter.debugOverlayTexture.bind(gl2.LINEAR, gl2.CLAMP_TO_EDGE);
	                }
	                function drawCustom(painter, sourceCache, layer) {
	                  var context = painter.context;
	                  var implementation = layer.implementation;
	                  if (painter.renderPass === "offscreen") {
	                    var prerender = implementation.prerender;
	                    if (prerender) {
	                      painter.setCustomLayerDefaults();
	                      context.setColorMode(painter.colorModeForRenderPass());
	                      prerender.call(implementation, context.gl, painter.transform.customLayerMatrix());
	                      context.setDirty();
	                      painter.setBaseState();
	                    }
	                  } else if (painter.renderPass === "translucent") {
	                    painter.setCustomLayerDefaults();
	                    context.setColorMode(painter.colorModeForRenderPass());
	                    context.setStencilMode(StencilMode.disabled);
	                    var depthMode = implementation.renderingMode === "3d" ? new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D) : painter.depthModeForSublayer(0, DepthMode.ReadOnly);
	                    context.setDepthMode(depthMode);
	                    implementation.render(context.gl, painter.transform.customLayerMatrix());
	                    context.setDirty();
	                    painter.setBaseState();
	                    context.bindFramebuffer.set(null);
	                  }
	                }
	                var draw$1 = {
	                  symbol: drawSymbols,
	                  circle: drawCircles,
	                  heatmap: drawHeatmap,
	                  line: drawLine,
	                  fill: drawFill,
	                  "fill-extrusion": draw,
	                  hillshade: drawHillshade,
	                  raster: drawRaster,
	                  background: drawBackground,
	                  debug: drawDebug,
	                  custom: drawCustom
	                };
	                var Painter = function Painter2(gl2, transform) {
	                  this.context = new Context(gl2);
	                  this.transform = transform;
	                  this._tileTextures = {};
	                  this.setup();
	                  this.numSublayers = SourceCache.maxUnderzooming + SourceCache.maxOverzooming + 1;
	                  this.depthEpsilon = 1 / Math.pow(2, 16);
	                  this.crossTileSymbolIndex = new CrossTileSymbolIndex();
	                  this.gpuTimers = {};
	                };
	                Painter.prototype.resize = function resize(width, height) {
	                  this.width = width * performance2.browser.devicePixelRatio;
	                  this.height = height * performance2.browser.devicePixelRatio;
	                  this.context.viewport.set([
	                    0,
	                    0,
	                    this.width,
	                    this.height
	                  ]);
	                  if (this.style) {
	                    for (var i = 0, list = this.style._order; i < list.length; i += 1) {
	                      var layerId = list[i];
	                      this.style._layers[layerId].resize();
	                    }
	                  }
	                };
	                Painter.prototype.setup = function setup() {
	                  var context = this.context;
	                  var tileExtentArray = new performance2.StructArrayLayout2i4();
	                  tileExtentArray.emplaceBack(0, 0);
	                  tileExtentArray.emplaceBack(performance2.EXTENT, 0);
	                  tileExtentArray.emplaceBack(0, performance2.EXTENT);
	                  tileExtentArray.emplaceBack(performance2.EXTENT, performance2.EXTENT);
	                  this.tileExtentBuffer = context.createVertexBuffer(tileExtentArray, posAttributes.members);
	                  this.tileExtentSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 2);
	                  var debugArray = new performance2.StructArrayLayout2i4();
	                  debugArray.emplaceBack(0, 0);
	                  debugArray.emplaceBack(performance2.EXTENT, 0);
	                  debugArray.emplaceBack(0, performance2.EXTENT);
	                  debugArray.emplaceBack(performance2.EXTENT, performance2.EXTENT);
	                  this.debugBuffer = context.createVertexBuffer(debugArray, posAttributes.members);
	                  this.debugSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 5);
	                  var rasterBoundsArray = new performance2.StructArrayLayout4i8();
	                  rasterBoundsArray.emplaceBack(0, 0, 0, 0);
	                  rasterBoundsArray.emplaceBack(performance2.EXTENT, 0, performance2.EXTENT, 0);
	                  rasterBoundsArray.emplaceBack(0, performance2.EXTENT, 0, performance2.EXTENT);
	                  rasterBoundsArray.emplaceBack(performance2.EXTENT, performance2.EXTENT, performance2.EXTENT, performance2.EXTENT);
	                  this.rasterBoundsBuffer = context.createVertexBuffer(rasterBoundsArray, rasterBoundsAttributes.members);
	                  this.rasterBoundsSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 2);
	                  var viewportArray = new performance2.StructArrayLayout2i4();
	                  viewportArray.emplaceBack(0, 0);
	                  viewportArray.emplaceBack(1, 0);
	                  viewportArray.emplaceBack(0, 1);
	                  viewportArray.emplaceBack(1, 1);
	                  this.viewportBuffer = context.createVertexBuffer(viewportArray, posAttributes.members);
	                  this.viewportSegments = performance2.SegmentVector.simpleSegment(0, 0, 4, 2);
	                  var tileLineStripIndices = new performance2.StructArrayLayout1ui2();
	                  tileLineStripIndices.emplaceBack(0);
	                  tileLineStripIndices.emplaceBack(1);
	                  tileLineStripIndices.emplaceBack(3);
	                  tileLineStripIndices.emplaceBack(2);
	                  tileLineStripIndices.emplaceBack(0);
	                  this.tileBorderIndexBuffer = context.createIndexBuffer(tileLineStripIndices);
	                  var quadTriangleIndices = new performance2.StructArrayLayout3ui6();
	                  quadTriangleIndices.emplaceBack(0, 1, 2);
	                  quadTriangleIndices.emplaceBack(2, 1, 3);
	                  this.quadTriangleIndexBuffer = context.createIndexBuffer(quadTriangleIndices);
	                  this.emptyTexture = new performance2.Texture(context, {
	                    width: 1,
	                    height: 1,
	                    data: new Uint8Array([
	                      0,
	                      0,
	                      0,
	                      0
	                    ])
	                  }, context.gl.RGBA);
	                  var gl2 = this.context.gl;
	                  this.stencilClearMode = new StencilMode({
	                    func: gl2.ALWAYS,
	                    mask: 0
	                  }, 0, 255, gl2.ZERO, gl2.ZERO, gl2.ZERO);
	                };
	                Painter.prototype.clearStencil = function clearStencil() {
	                  var context = this.context;
	                  var gl2 = context.gl;
	                  this.nextStencilID = 1;
	                  this.currentStencilSource = undefined;
	                  var matrix = performance2.create();
	                  performance2.ortho(matrix, 0, this.width, this.height, 0, 0, 1);
	                  performance2.scale(matrix, matrix, [
	                    gl2.drawingBufferWidth,
	                    gl2.drawingBufferHeight,
	                    0
	                  ]);
	                  this.useProgram("clippingMask").draw(context, gl2.TRIANGLES, DepthMode.disabled, this.stencilClearMode, ColorMode.disabled, CullFaceMode.disabled, clippingMaskUniformValues(matrix), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
	                };
	                Painter.prototype._renderTileClippingMasks = function _renderTileClippingMasks(layer, tileIDs) {
	                  if (this.currentStencilSource === layer.source || !layer.isTileClipped() || !tileIDs || !tileIDs.length) {
	                    return;
	                  }
	                  this.currentStencilSource = layer.source;
	                  var context = this.context;
	                  var gl2 = context.gl;
	                  if (this.nextStencilID + tileIDs.length > 256) {
	                    this.clearStencil();
	                  }
	                  context.setColorMode(ColorMode.disabled);
	                  context.setDepthMode(DepthMode.disabled);
	                  var program = this.useProgram("clippingMask");
	                  this._tileClippingMaskIDs = {};
	                  for (var i = 0, list = tileIDs; i < list.length; i += 1) {
	                    var tileID = list[i];
	                    var id = this._tileClippingMaskIDs[tileID.key] = this.nextStencilID++;
	                    program.draw(context, gl2.TRIANGLES, DepthMode.disabled, new StencilMode({
	                      func: gl2.ALWAYS,
	                      mask: 0
	                    }, id, 255, gl2.KEEP, gl2.KEEP, gl2.REPLACE), ColorMode.disabled, CullFaceMode.disabled, clippingMaskUniformValues(tileID.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
	                  }
	                };
	                Painter.prototype.stencilModeFor3D = function stencilModeFor3D() {
	                  this.currentStencilSource = undefined;
	                  if (this.nextStencilID + 1 > 256) {
	                    this.clearStencil();
	                  }
	                  var id = this.nextStencilID++;
	                  var gl2 = this.context.gl;
	                  return new StencilMode({
	                    func: gl2.NOTEQUAL,
	                    mask: 255
	                  }, id, 255, gl2.KEEP, gl2.KEEP, gl2.REPLACE);
	                };
	                Painter.prototype.stencilModeForClipping = function stencilModeForClipping(tileID) {
	                  var gl2 = this.context.gl;
	                  return new StencilMode({
	                    func: gl2.EQUAL,
	                    mask: 255
	                  }, this._tileClippingMaskIDs[tileID.key], 0, gl2.KEEP, gl2.KEEP, gl2.REPLACE);
	                };
	                Painter.prototype.stencilConfigForOverlap = function stencilConfigForOverlap(tileIDs) {
	                  var obj;
	                  var gl2 = this.context.gl;
	                  var coords = tileIDs.sort(function(a, b) {
	                    return b.overscaledZ - a.overscaledZ;
	                  });
	                  var minTileZ = coords[coords.length - 1].overscaledZ;
	                  var stencilValues = coords[0].overscaledZ - minTileZ + 1;
	                  if (stencilValues > 1) {
	                    this.currentStencilSource = undefined;
	                    if (this.nextStencilID + stencilValues > 256) {
	                      this.clearStencil();
	                    }
	                    var zToStencilMode = {};
	                    for (var i = 0; i < stencilValues; i++) {
	                      zToStencilMode[i + minTileZ] = new StencilMode({
	                        func: gl2.GEQUAL,
	                        mask: 255
	                      }, i + this.nextStencilID, 255, gl2.KEEP, gl2.KEEP, gl2.REPLACE);
	                    }
	                    this.nextStencilID += stencilValues;
	                    return [
	                      zToStencilMode,
	                      coords
	                    ];
	                  }
	                  return [
	                    (obj = {}, obj[minTileZ] = StencilMode.disabled, obj),
	                    coords
	                  ];
	                };
	                Painter.prototype.colorModeForRenderPass = function colorModeForRenderPass() {
	                  var gl2 = this.context.gl;
	                  if (this._showOverdrawInspector) {
	                    var numOverdrawSteps = 8;
	                    var a = 1 / numOverdrawSteps;
	                    return new ColorMode([
	                      gl2.CONSTANT_COLOR,
	                      gl2.ONE
	                    ], new performance2.Color(a, a, a, 0), [
	                      true,
	                      true,
	                      true,
	                      true
	                    ]);
	                  } else if (this.renderPass === "opaque") {
	                    return ColorMode.unblended;
	                  } else {
	                    return ColorMode.alphaBlended;
	                  }
	                };
	                Painter.prototype.depthModeForSublayer = function depthModeForSublayer(n, mask, func) {
	                  if (!this.opaquePassEnabledForLayer()) {
	                    return DepthMode.disabled;
	                  }
	                  var depth = 1 - ((1 + this.currentLayer) * this.numSublayers + n) * this.depthEpsilon;
	                  return new DepthMode(func || this.context.gl.LEQUAL, mask, [
	                    depth,
	                    depth
	                  ]);
	                };
	                Painter.prototype.opaquePassEnabledForLayer = function opaquePassEnabledForLayer() {
	                  return this.currentLayer < this.opaquePassCutoff;
	                };
	                Painter.prototype.render = function render(style, options) {
	                  var this$1$1 = this;
	                  this.style = style;
	                  this.options = options;
	                  this.lineAtlas = style.lineAtlas;
	                  this.imageManager = style.imageManager;
	                  this.glyphManager = style.glyphManager;
	                  this.symbolFadeChange = style.placement.symbolFadeChange(performance2.browser.now());
	                  this.imageManager.beginFrame();
	                  var layerIds = this.style._order;
	                  var sourceCaches = this.style.sourceCaches;
	                  for (var id in sourceCaches) {
	                    var sourceCache = sourceCaches[id];
	                    if (sourceCache.used) {
	                      sourceCache.prepare(this.context);
	                    }
	                  }
	                  var coordsAscending = {};
	                  var coordsDescending = {};
	                  var coordsDescendingSymbol = {};
	                  for (var id$1 in sourceCaches) {
	                    var sourceCache$1 = sourceCaches[id$1];
	                    coordsAscending[id$1] = sourceCache$1.getVisibleCoordinates();
	                    coordsDescending[id$1] = coordsAscending[id$1].slice().reverse();
	                    coordsDescendingSymbol[id$1] = sourceCache$1.getVisibleCoordinates(true).reverse();
	                  }
	                  this.opaquePassCutoff = Infinity;
	                  for (var i = 0; i < layerIds.length; i++) {
	                    var layerId = layerIds[i];
	                    if (this.style._layers[layerId].is3D()) {
	                      this.opaquePassCutoff = i;
	                      break;
	                    }
	                  }
	                  this.renderPass = "offscreen";
	                  for (var i$1 = 0, list = layerIds; i$1 < list.length; i$1 += 1) {
	                    var layerId$1 = list[i$1];
	                    var layer = this.style._layers[layerId$1];
	                    if (!layer.hasOffscreenPass() || layer.isHidden(this.transform.zoom)) {
	                      continue;
	                    }
	                    var coords = coordsDescending[layer.source];
	                    if (layer.type !== "custom" && !coords.length) {
	                      continue;
	                    }
	                    this.renderLayer(this, sourceCaches[layer.source], layer, coords);
	                  }
	                  this.context.bindFramebuffer.set(null);
	                  this.context.clear({
	                    color: options.showOverdrawInspector ? performance2.Color.black : performance2.Color.transparent,
	                    depth: 1
	                  });
	                  this.clearStencil();
	                  this._showOverdrawInspector = options.showOverdrawInspector;
	                  this.depthRangeFor3D = [
	                    0,
	                    1 - (style._order.length + 2) * this.numSublayers * this.depthEpsilon
	                  ];
	                  this.renderPass = "opaque";
	                  for (this.currentLayer = layerIds.length - 1; this.currentLayer >= 0; this.currentLayer--) {
	                    var layer$1 = this.style._layers[layerIds[this.currentLayer]];
	                    var sourceCache$2 = sourceCaches[layer$1.source];
	                    var coords$1 = coordsAscending[layer$1.source];
	                    this._renderTileClippingMasks(layer$1, coords$1);
	                    this.renderLayer(this, sourceCache$2, layer$1, coords$1);
	                  }
	                  this.renderPass = "translucent";
	                  for (this.currentLayer = 0; this.currentLayer < layerIds.length; this.currentLayer++) {
	                    var layer$2 = this.style._layers[layerIds[this.currentLayer]];
	                    var sourceCache$3 = sourceCaches[layer$2.source];
	                    var coords$2 = (layer$2.type === "symbol" ? coordsDescendingSymbol : coordsDescending)[layer$2.source];
	                    this._renderTileClippingMasks(layer$2, coordsAscending[layer$2.source]);
	                    this.renderLayer(this, sourceCache$3, layer$2, coords$2);
	                  }
	                  if (this.options.showTileBoundaries) {
	                    var selectedSource;
	                    var sourceCache$4;
	                    var layers = performance2.values(this.style._layers);
	                    layers.forEach(function(layer2) {
	                      if (layer2.source && !layer2.isHidden(this$1$1.transform.zoom)) {
	                        if (layer2.source !== (sourceCache$4 && sourceCache$4.id)) {
	                          sourceCache$4 = this$1$1.style.sourceCaches[layer2.source];
	                        }
	                        if (!selectedSource || selectedSource.getSource().maxzoom < sourceCache$4.getSource().maxzoom) {
	                          selectedSource = sourceCache$4;
	                        }
	                      }
	                    });
	                    if (selectedSource) {
	                      draw$1.debug(this, selectedSource, selectedSource.getVisibleCoordinates());
	                    }
	                  }
	                  if (this.options.showPadding) {
	                    drawDebugPadding(this);
	                  }
	                  this.context.setDefault();
	                };
	                Painter.prototype.renderLayer = function renderLayer(painter, sourceCache, layer, coords) {
	                  if (layer.isHidden(this.transform.zoom)) {
	                    return;
	                  }
	                  if (layer.type !== "background" && layer.type !== "custom" && !coords.length) {
	                    return;
	                  }
	                  this.id = layer.id;
	                  this.gpuTimingStart(layer);
	                  draw$1[layer.type](painter, sourceCache, layer, coords, this.style.placement.variableOffsets);
	                  this.gpuTimingEnd();
	                };
	                Painter.prototype.gpuTimingStart = function gpuTimingStart(layer) {
	                  if (!this.options.gpuTiming) {
	                    return;
	                  }
	                  var ext = this.context.extTimerQuery;
	                  var layerTimer = this.gpuTimers[layer.id];
	                  if (!layerTimer) {
	                    layerTimer = this.gpuTimers[layer.id] = {
	                      calls: 0,
	                      cpuTime: 0,
	                      query: ext.createQueryEXT()
	                    };
	                  }
	                  layerTimer.calls++;
	                  ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, layerTimer.query);
	                };
	                Painter.prototype.gpuTimingEnd = function gpuTimingEnd() {
	                  if (!this.options.gpuTiming) {
	                    return;
	                  }
	                  var ext = this.context.extTimerQuery;
	                  ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
	                };
	                Painter.prototype.collectGpuTimers = function collectGpuTimers() {
	                  var currentLayerTimers = this.gpuTimers;
	                  this.gpuTimers = {};
	                  return currentLayerTimers;
	                };
	                Painter.prototype.queryGpuTimers = function queryGpuTimers(gpuTimers) {
	                  var layers = {};
	                  for (var layerId in gpuTimers) {
	                    var gpuTimer = gpuTimers[layerId];
	                    var ext = this.context.extTimerQuery;
	                    var gpuTime = ext.getQueryObjectEXT(gpuTimer.query, ext.QUERY_RESULT_EXT) / (1e3 * 1e3);
	                    ext.deleteQueryEXT(gpuTimer.query);
	                    layers[layerId] = gpuTime;
	                  }
	                  return layers;
	                };
	                Painter.prototype.translatePosMatrix = function translatePosMatrix(matrix, tile, translate, translateAnchor, inViewportPixelUnitsUnits) {
	                  if (!translate[0] && !translate[1]) {
	                    return matrix;
	                  }
	                  var angle = inViewportPixelUnitsUnits ? translateAnchor === "map" ? this.transform.angle : 0 : translateAnchor === "viewport" ? -this.transform.angle : 0;
	                  if (angle) {
	                    var sinA = Math.sin(angle);
	                    var cosA = Math.cos(angle);
	                    translate = [
	                      translate[0] * cosA - translate[1] * sinA,
	                      translate[0] * sinA + translate[1] * cosA
	                    ];
	                  }
	                  var translation = [
	                    inViewportPixelUnitsUnits ? translate[0] : pixelsToTileUnits(tile, translate[0], this.transform.zoom),
	                    inViewportPixelUnitsUnits ? translate[1] : pixelsToTileUnits(tile, translate[1], this.transform.zoom),
	                    0
	                  ];
	                  var translatedMatrix = new Float32Array(16);
	                  performance2.translate(translatedMatrix, matrix, translation);
	                  return translatedMatrix;
	                };
	                Painter.prototype.saveTileTexture = function saveTileTexture(texture) {
	                  var textures = this._tileTextures[texture.size[0]];
	                  if (!textures) {
	                    this._tileTextures[texture.size[0]] = [texture];
	                  } else {
	                    textures.push(texture);
	                  }
	                };
	                Painter.prototype.getTileTexture = function getTileTexture(size) {
	                  var textures = this._tileTextures[size];
	                  return textures && textures.length > 0 ? textures.pop() : null;
	                };
	                Painter.prototype.isPatternMissing = function isPatternMissing(image) {
	                  if (!image) {
	                    return false;
	                  }
	                  if (!image.from || !image.to) {
	                    return true;
	                  }
	                  var imagePosA = this.imageManager.getPattern(image.from.toString());
	                  var imagePosB = this.imageManager.getPattern(image.to.toString());
	                  return !imagePosA || !imagePosB;
	                };
	                Painter.prototype.useProgram = function useProgram(name2, programConfiguration) {
	                  this.cache = this.cache || {};
	                  var key = "" + name2 + (programConfiguration ? programConfiguration.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
	                  if (!this.cache[key]) {
	                    this.cache[key] = new Program$1(this.context, shaders[name2], programConfiguration, programUniforms[name2], this._showOverdrawInspector);
	                  }
	                  return this.cache[key];
	                };
	                Painter.prototype.setCustomLayerDefaults = function setCustomLayerDefaults() {
	                  this.context.unbindVAO();
	                  this.context.cullFace.setDefault();
	                  this.context.activeTexture.setDefault();
	                  this.context.pixelStoreUnpack.setDefault();
	                  this.context.pixelStoreUnpackPremultiplyAlpha.setDefault();
	                  this.context.pixelStoreUnpackFlipY.setDefault();
	                };
	                Painter.prototype.setBaseState = function setBaseState() {
	                  var gl2 = this.context.gl;
	                  this.context.cullFace.set(false);
	                  this.context.viewport.set([
	                    0,
	                    0,
	                    this.width,
	                    this.height
	                  ]);
	                  this.context.blendEquation.set(gl2.FUNC_ADD);
	                };
	                Painter.prototype.initDebugOverlayCanvas = function initDebugOverlayCanvas() {
	                  if (this.debugOverlayCanvas == null) {
	                    this.debugOverlayCanvas = performance2.window.document.createElement("canvas");
	                    this.debugOverlayCanvas.width = 512;
	                    this.debugOverlayCanvas.height = 512;
	                    var gl2 = this.context.gl;
	                    this.debugOverlayTexture = new performance2.Texture(this.context, this.debugOverlayCanvas, gl2.RGBA);
	                  }
	                };
	                Painter.prototype.destroy = function destroy() {
	                  this.emptyTexture.destroy();
	                  if (this.debugOverlayTexture) {
	                    this.debugOverlayTexture.destroy();
	                  }
	                };
	                var Frustum = function Frustum2(points_, planes_) {
	                  this.points = points_;
	                  this.planes = planes_;
	                };
	                Frustum.fromInvProjectionMatrix = function fromInvProjectionMatrix(invProj, worldSize, zoom) {
	                  var clipSpaceCorners = [
	                    [
	                      -1,
	                      1,
	                      -1,
	                      1
	                    ],
	                    [
	                      1,
	                      1,
	                      -1,
	                      1
	                    ],
	                    [
	                      1,
	                      -1,
	                      -1,
	                      1
	                    ],
	                    [
	                      -1,
	                      -1,
	                      -1,
	                      1
	                    ],
	                    [
	                      -1,
	                      1,
	                      1,
	                      1
	                    ],
	                    [
	                      1,
	                      1,
	                      1,
	                      1
	                    ],
	                    [
	                      1,
	                      -1,
	                      1,
	                      1
	                    ],
	                    [
	                      -1,
	                      -1,
	                      1,
	                      1
	                    ]
	                  ];
	                  var scale = Math.pow(2, zoom);
	                  var frustumCoords = clipSpaceCorners.map(function(v) {
	                    return performance2.transformMat4([], v, invProj);
	                  }).map(function(v) {
	                    return performance2.scale$1([], v, 1 / v[3] / worldSize * scale);
	                  });
	                  var frustumPlanePointIndices = [
	                    [
	                      0,
	                      1,
	                      2
	                    ],
	                    [
	                      6,
	                      5,
	                      4
	                    ],
	                    [
	                      0,
	                      3,
	                      7
	                    ],
	                    [
	                      2,
	                      1,
	                      5
	                    ],
	                    [
	                      3,
	                      2,
	                      6
	                    ],
	                    [
	                      0,
	                      4,
	                      5
	                    ]
	                  ];
	                  var frustumPlanes = frustumPlanePointIndices.map(function(p) {
	                    var a = performance2.sub([], frustumCoords[p[0]], frustumCoords[p[1]]);
	                    var b = performance2.sub([], frustumCoords[p[2]], frustumCoords[p[1]]);
	                    var n = performance2.normalize([], performance2.cross([], a, b));
	                    var d = -performance2.dot(n, frustumCoords[p[1]]);
	                    return n.concat(d);
	                  });
	                  return new Frustum(frustumCoords, frustumPlanes);
	                };
	                var Aabb = function Aabb2(min_, max_) {
	                  this.min = min_;
	                  this.max = max_;
	                  this.center = performance2.scale$2([], performance2.add([], this.min, this.max), 0.5);
	                };
	                Aabb.prototype.quadrant = function quadrant(index) {
	                  var split = [
	                    index % 2 === 0,
	                    index < 2
	                  ];
	                  var qMin = performance2.clone$2(this.min);
	                  var qMax = performance2.clone$2(this.max);
	                  for (var axis = 0; axis < split.length; axis++) {
	                    qMin[axis] = split[axis] ? this.min[axis] : this.center[axis];
	                    qMax[axis] = split[axis] ? this.center[axis] : this.max[axis];
	                  }
	                  qMax[2] = this.max[2];
	                  return new Aabb(qMin, qMax);
	                };
	                Aabb.prototype.distanceX = function distanceX(point) {
	                  var pointOnAabb = Math.max(Math.min(this.max[0], point[0]), this.min[0]);
	                  return pointOnAabb - point[0];
	                };
	                Aabb.prototype.distanceY = function distanceY(point) {
	                  var pointOnAabb = Math.max(Math.min(this.max[1], point[1]), this.min[1]);
	                  return pointOnAabb - point[1];
	                };
	                Aabb.prototype.intersects = function intersects(frustum) {
	                  var aabbPoints = [
	                    [
	                      this.min[0],
	                      this.min[1],
	                      0,
	                      1
	                    ],
	                    [
	                      this.max[0],
	                      this.min[1],
	                      0,
	                      1
	                    ],
	                    [
	                      this.max[0],
	                      this.max[1],
	                      0,
	                      1
	                    ],
	                    [
	                      this.min[0],
	                      this.max[1],
	                      0,
	                      1
	                    ]
	                  ];
	                  var fullyInside = true;
	                  for (var p = 0; p < frustum.planes.length; p++) {
	                    var plane = frustum.planes[p];
	                    var pointsInside = 0;
	                    for (var i = 0; i < aabbPoints.length; i++) {
	                      pointsInside += performance2.dot$1(plane, aabbPoints[i]) >= 0;
	                    }
	                    if (pointsInside === 0) {
	                      return 0;
	                    }
	                    if (pointsInside !== aabbPoints.length) {
	                      fullyInside = false;
	                    }
	                  }
	                  if (fullyInside) {
	                    return 2;
	                  }
	                  for (var axis = 0; axis < 3; axis++) {
	                    var projMin = Number.MAX_VALUE;
	                    var projMax = -Number.MAX_VALUE;
	                    for (var p$1 = 0; p$1 < frustum.points.length; p$1++) {
	                      var projectedPoint = frustum.points[p$1][axis] - this.min[axis];
	                      projMin = Math.min(projMin, projectedPoint);
	                      projMax = Math.max(projMax, projectedPoint);
	                    }
	                    if (projMax < 0 || projMin > this.max[axis] - this.min[axis]) {
	                      return 0;
	                    }
	                  }
	                  return 1;
	                };
	                var EdgeInsets = function EdgeInsets2(top, bottom, left, right) {
	                  if (top === undefined)
	                    top = 0;
	                  if (bottom === undefined)
	                    bottom = 0;
	                  if (left === undefined)
	                    left = 0;
	                  if (right === undefined)
	                    right = 0;
	                  if (isNaN(top) || top < 0 || isNaN(bottom) || bottom < 0 || isNaN(left) || left < 0 || isNaN(right) || right < 0) {
	                    throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
	                  }
	                  this.top = top;
	                  this.bottom = bottom;
	                  this.left = left;
	                  this.right = right;
	                };
	                EdgeInsets.prototype.interpolate = function interpolate(start, target, t) {
	                  if (target.top != null && start.top != null) {
	                    this.top = performance2.number(start.top, target.top, t);
	                  }
	                  if (target.bottom != null && start.bottom != null) {
	                    this.bottom = performance2.number(start.bottom, target.bottom, t);
	                  }
	                  if (target.left != null && start.left != null) {
	                    this.left = performance2.number(start.left, target.left, t);
	                  }
	                  if (target.right != null && start.right != null) {
	                    this.right = performance2.number(start.right, target.right, t);
	                  }
	                  return this;
	                };
	                EdgeInsets.prototype.getCenter = function getCenter(width, height) {
	                  var x = performance2.clamp((this.left + width - this.right) / 2, 0, width);
	                  var y = performance2.clamp((this.top + height - this.bottom) / 2, 0, height);
	                  return new performance2.Point(x, y);
	                };
	                EdgeInsets.prototype.equals = function equals(other) {
	                  return this.top === other.top && this.bottom === other.bottom && this.left === other.left && this.right === other.right;
	                };
	                EdgeInsets.prototype.clone = function clone() {
	                  return new EdgeInsets(this.top, this.bottom, this.left, this.right);
	                };
	                EdgeInsets.prototype.toJSON = function toJSON() {
	                  return {
	                    top: this.top,
	                    bottom: this.bottom,
	                    left: this.left,
	                    right: this.right
	                  };
	                };
	                var Transform = function Transform2(minZoom, maxZoom, minPitch, maxPitch, renderWorldCopies) {
	                  this.tileSize = 512;
	                  this.maxValidLatitude = 85.051129;
	                  this._renderWorldCopies = renderWorldCopies === undefined ? true : renderWorldCopies;
	                  this._minZoom = minZoom || 0;
	                  this._maxZoom = maxZoom || 22;
	                  this._minPitch = minPitch === undefined || minPitch === null ? 0 : minPitch;
	                  this._maxPitch = maxPitch === undefined || maxPitch === null ? 60 : maxPitch;
	                  this.setMaxBounds();
	                  this.width = 0;
	                  this.height = 0;
	                  this._center = new performance2.LngLat(0, 0);
	                  this.zoom = 0;
	                  this.angle = 0;
	                  this._fov = 0.6435011087932844;
	                  this._pitch = 0;
	                  this._unmodified = true;
	                  this._edgeInsets = new EdgeInsets();
	                  this._posMatrixCache = {};
	                  this._alignedPosMatrixCache = {};
	                };
	                var prototypeAccessors = {
	                  minZoom: { configurable: true },
	                  maxZoom: { configurable: true },
	                  minPitch: { configurable: true },
	                  maxPitch: { configurable: true },
	                  renderWorldCopies: { configurable: true },
	                  worldSize: { configurable: true },
	                  centerOffset: { configurable: true },
	                  size: { configurable: true },
	                  bearing: { configurable: true },
	                  pitch: { configurable: true },
	                  fov: { configurable: true },
	                  zoom: { configurable: true },
	                  center: { configurable: true },
	                  padding: { configurable: true },
	                  centerPoint: { configurable: true },
	                  unmodified: { configurable: true },
	                  point: { configurable: true }
	                };
	                Transform.prototype.clone = function clone() {
	                  var clone2 = new Transform(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
	                  clone2.tileSize = this.tileSize;
	                  clone2.latRange = this.latRange;
	                  clone2.width = this.width;
	                  clone2.height = this.height;
	                  clone2._center = this._center;
	                  clone2.zoom = this.zoom;
	                  clone2.angle = this.angle;
	                  clone2._fov = this._fov;
	                  clone2._pitch = this._pitch;
	                  clone2._unmodified = this._unmodified;
	                  clone2._edgeInsets = this._edgeInsets.clone();
	                  clone2._calcMatrices();
	                  return clone2;
	                };
	                prototypeAccessors.minZoom.get = function() {
	                  return this._minZoom;
	                };
	                prototypeAccessors.minZoom.set = function(zoom) {
	                  if (this._minZoom === zoom) {
	                    return;
	                  }
	                  this._minZoom = zoom;
	                  this.zoom = Math.max(this.zoom, zoom);
	                };
	                prototypeAccessors.maxZoom.get = function() {
	                  return this._maxZoom;
	                };
	                prototypeAccessors.maxZoom.set = function(zoom) {
	                  if (this._maxZoom === zoom) {
	                    return;
	                  }
	                  this._maxZoom = zoom;
	                  this.zoom = Math.min(this.zoom, zoom);
	                };
	                prototypeAccessors.minPitch.get = function() {
	                  return this._minPitch;
	                };
	                prototypeAccessors.minPitch.set = function(pitch) {
	                  if (this._minPitch === pitch) {
	                    return;
	                  }
	                  this._minPitch = pitch;
	                  this.pitch = Math.max(this.pitch, pitch);
	                };
	                prototypeAccessors.maxPitch.get = function() {
	                  return this._maxPitch;
	                };
	                prototypeAccessors.maxPitch.set = function(pitch) {
	                  if (this._maxPitch === pitch) {
	                    return;
	                  }
	                  this._maxPitch = pitch;
	                  this.pitch = Math.min(this.pitch, pitch);
	                };
	                prototypeAccessors.renderWorldCopies.get = function() {
	                  return this._renderWorldCopies;
	                };
	                prototypeAccessors.renderWorldCopies.set = function(renderWorldCopies) {
	                  if (renderWorldCopies === undefined) {
	                    renderWorldCopies = true;
	                  } else if (renderWorldCopies === null) {
	                    renderWorldCopies = false;
	                  }
	                  this._renderWorldCopies = renderWorldCopies;
	                };
	                prototypeAccessors.worldSize.get = function() {
	                  return this.tileSize * this.scale;
	                };
	                prototypeAccessors.centerOffset.get = function() {
	                  return this.centerPoint._sub(this.size._div(2));
	                };
	                prototypeAccessors.size.get = function() {
	                  return new performance2.Point(this.width, this.height);
	                };
	                prototypeAccessors.bearing.get = function() {
	                  return -this.angle / Math.PI * 180;
	                };
	                prototypeAccessors.bearing.set = function(bearing) {
	                  var b = -performance2.wrap(bearing, -180, 180) * Math.PI / 180;
	                  if (this.angle === b) {
	                    return;
	                  }
	                  this._unmodified = false;
	                  this.angle = b;
	                  this._calcMatrices();
	                  this.rotationMatrix = performance2.create$2();
	                  performance2.rotate(this.rotationMatrix, this.rotationMatrix, this.angle);
	                };
	                prototypeAccessors.pitch.get = function() {
	                  return this._pitch / Math.PI * 180;
	                };
	                prototypeAccessors.pitch.set = function(pitch) {
	                  var p = performance2.clamp(pitch, this.minPitch, this.maxPitch) / 180 * Math.PI;
	                  if (this._pitch === p) {
	                    return;
	                  }
	                  this._unmodified = false;
	                  this._pitch = p;
	                  this._calcMatrices();
	                };
	                prototypeAccessors.fov.get = function() {
	                  return this._fov / Math.PI * 180;
	                };
	                prototypeAccessors.fov.set = function(fov) {
	                  fov = Math.max(0.01, Math.min(60, fov));
	                  if (this._fov === fov) {
	                    return;
	                  }
	                  this._unmodified = false;
	                  this._fov = fov / 180 * Math.PI;
	                  this._calcMatrices();
	                };
	                prototypeAccessors.zoom.get = function() {
	                  return this._zoom;
	                };
	                prototypeAccessors.zoom.set = function(zoom) {
	                  var z = Math.min(Math.max(zoom, this.minZoom), this.maxZoom);
	                  if (this._zoom === z) {
	                    return;
	                  }
	                  this._unmodified = false;
	                  this._zoom = z;
	                  this.scale = this.zoomScale(z);
	                  this.tileZoom = Math.floor(z);
	                  this.zoomFraction = z - this.tileZoom;
	                  this._constrain();
	                  this._calcMatrices();
	                };
	                prototypeAccessors.center.get = function() {
	                  return this._center;
	                };
	                prototypeAccessors.center.set = function(center) {
	                  if (center.lat === this._center.lat && center.lng === this._center.lng) {
	                    return;
	                  }
	                  this._unmodified = false;
	                  this._center = center;
	                  this._constrain();
	                  this._calcMatrices();
	                };
	                prototypeAccessors.padding.get = function() {
	                  return this._edgeInsets.toJSON();
	                };
	                prototypeAccessors.padding.set = function(padding2) {
	                  if (this._edgeInsets.equals(padding2)) {
	                    return;
	                  }
	                  this._unmodified = false;
	                  this._edgeInsets.interpolate(this._edgeInsets, padding2, 1);
	                  this._calcMatrices();
	                };
	                prototypeAccessors.centerPoint.get = function() {
	                  return this._edgeInsets.getCenter(this.width, this.height);
	                };
	                Transform.prototype.isPaddingEqual = function isPaddingEqual(padding2) {
	                  return this._edgeInsets.equals(padding2);
	                };
	                Transform.prototype.interpolatePadding = function interpolatePadding(start, target, t) {
	                  this._unmodified = false;
	                  this._edgeInsets.interpolate(start, target, t);
	                  this._constrain();
	                  this._calcMatrices();
	                };
	                Transform.prototype.coveringZoomLevel = function coveringZoomLevel(options) {
	                  var z = (options.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / options.tileSize));
	                  return Math.max(0, z);
	                };
	                Transform.prototype.getVisibleUnwrappedCoordinates = function getVisibleUnwrappedCoordinates(tileID) {
	                  var result = [new performance2.UnwrappedTileID(0, tileID)];
	                  if (this._renderWorldCopies) {
	                    var utl = this.pointCoordinate(new performance2.Point(0, 0));
	                    var utr = this.pointCoordinate(new performance2.Point(this.width, 0));
	                    var ubl = this.pointCoordinate(new performance2.Point(this.width, this.height));
	                    var ubr = this.pointCoordinate(new performance2.Point(0, this.height));
	                    var w0 = Math.floor(Math.min(utl.x, utr.x, ubl.x, ubr.x));
	                    var w1 = Math.floor(Math.max(utl.x, utr.x, ubl.x, ubr.x));
	                    var extraWorldCopy = 1;
	                    for (var w = w0 - extraWorldCopy; w <= w1 + extraWorldCopy; w++) {
	                      if (w === 0) {
	                        continue;
	                      }
	                      result.push(new performance2.UnwrappedTileID(w, tileID));
	                    }
	                  }
	                  return result;
	                };
	                Transform.prototype.coveringTiles = function coveringTiles(options) {
	                  var z = this.coveringZoomLevel(options);
	                  var actualZ = z;
	                  if (options.minzoom !== undefined && z < options.minzoom) {
	                    return [];
	                  }
	                  if (options.maxzoom !== undefined && z > options.maxzoom) {
	                    z = options.maxzoom;
	                  }
	                  var centerCoord = performance2.MercatorCoordinate.fromLngLat(this.center);
	                  var numTiles = Math.pow(2, z);
	                  var centerPoint = [
	                    numTiles * centerCoord.x,
	                    numTiles * centerCoord.y,
	                    0
	                  ];
	                  var cameraFrustum = Frustum.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, z);
	                  var minZoom = options.minzoom || 0;
	                  if (this.pitch <= 60 && this._edgeInsets.top < 0.1) {
	                    minZoom = z;
	                  }
	                  var radiusOfMaxLvlLodInTiles = 3;
	                  var newRootTile = function(wrap) {
	                    return {
	                      aabb: new Aabb([
	                        wrap * numTiles,
	                        0,
	                        0
	                      ], [
	                        (wrap + 1) * numTiles,
	                        numTiles,
	                        0
	                      ]),
	                      zoom: 0,
	                      x: 0,
	                      y: 0,
	                      wrap,
	                      fullyVisible: false
	                    };
	                  };
	                  var stack = [];
	                  var result = [];
	                  var maxZoom = z;
	                  var overscaledZ = options.reparseOverscaled ? actualZ : z;
	                  if (this._renderWorldCopies) {
	                    for (var i = 1; i <= 3; i++) {
	                      stack.push(newRootTile(-i));
	                      stack.push(newRootTile(i));
	                    }
	                  }
	                  stack.push(newRootTile(0));
	                  while (stack.length > 0) {
	                    var it = stack.pop();
	                    var x = it.x;
	                    var y = it.y;
	                    var fullyVisible = it.fullyVisible;
	                    if (!fullyVisible) {
	                      var intersectResult = it.aabb.intersects(cameraFrustum);
	                      if (intersectResult === 0) {
	                        continue;
	                      }
	                      fullyVisible = intersectResult === 2;
	                    }
	                    var distanceX = it.aabb.distanceX(centerPoint);
	                    var distanceY = it.aabb.distanceY(centerPoint);
	                    var longestDim = Math.max(Math.abs(distanceX), Math.abs(distanceY));
	                    var distToSplit = radiusOfMaxLvlLodInTiles + (1 << maxZoom - it.zoom) - 2;
	                    if (it.zoom === maxZoom || longestDim > distToSplit && it.zoom >= minZoom) {
	                      result.push({
	                        tileID: new performance2.OverscaledTileID(it.zoom === maxZoom ? overscaledZ : it.zoom, it.wrap, it.zoom, x, y),
	                        distanceSq: performance2.sqrLen([
	                          centerPoint[0] - 0.5 - x,
	                          centerPoint[1] - 0.5 - y
	                        ])
	                      });
	                      continue;
	                    }
	                    for (var i$1 = 0; i$1 < 4; i$1++) {
	                      var childX = (x << 1) + i$1 % 2;
	                      var childY = (y << 1) + (i$1 >> 1);
	                      stack.push({
	                        aabb: it.aabb.quadrant(i$1),
	                        zoom: it.zoom + 1,
	                        x: childX,
	                        y: childY,
	                        wrap: it.wrap,
	                        fullyVisible
	                      });
	                    }
	                  }
	                  return result.sort(function(a, b) {
	                    return a.distanceSq - b.distanceSq;
	                  }).map(function(a) {
	                    return a.tileID;
	                  });
	                };
	                Transform.prototype.resize = function resize(width, height) {
	                  this.width = width;
	                  this.height = height;
	                  this.pixelsToGLUnits = [
	                    2 / width,
	                    -2 / height
	                  ];
	                  this._constrain();
	                  this._calcMatrices();
	                };
	                prototypeAccessors.unmodified.get = function() {
	                  return this._unmodified;
	                };
	                Transform.prototype.zoomScale = function zoomScale(zoom) {
	                  return Math.pow(2, zoom);
	                };
	                Transform.prototype.scaleZoom = function scaleZoom(scale) {
	                  return Math.log(scale) / Math.LN2;
	                };
	                Transform.prototype.project = function project2(lnglat) {
	                  var lat = performance2.clamp(lnglat.lat, -this.maxValidLatitude, this.maxValidLatitude);
	                  return new performance2.Point(performance2.mercatorXfromLng(lnglat.lng) * this.worldSize, performance2.mercatorYfromLat(lat) * this.worldSize);
	                };
	                Transform.prototype.unproject = function unproject(point) {
	                  return new performance2.MercatorCoordinate(point.x / this.worldSize, point.y / this.worldSize).toLngLat();
	                };
	                prototypeAccessors.point.get = function() {
	                  return this.project(this.center);
	                };
	                Transform.prototype.setLocationAtPoint = function setLocationAtPoint(lnglat, point) {
	                  var a = this.pointCoordinate(point);
	                  var b = this.pointCoordinate(this.centerPoint);
	                  var loc = this.locationCoordinate(lnglat);
	                  var newCenter = new performance2.MercatorCoordinate(loc.x - (a.x - b.x), loc.y - (a.y - b.y));
	                  this.center = this.coordinateLocation(newCenter);
	                  if (this._renderWorldCopies) {
	                    this.center = this.center.wrap();
	                  }
	                };
	                Transform.prototype.locationPoint = function locationPoint(lnglat) {
	                  return this.coordinatePoint(this.locationCoordinate(lnglat));
	                };
	                Transform.prototype.pointLocation = function pointLocation(p) {
	                  return this.coordinateLocation(this.pointCoordinate(p));
	                };
	                Transform.prototype.locationCoordinate = function locationCoordinate(lnglat) {
	                  return performance2.MercatorCoordinate.fromLngLat(lnglat);
	                };
	                Transform.prototype.coordinateLocation = function coordinateLocation(coord) {
	                  return coord.toLngLat();
	                };
	                Transform.prototype.pointCoordinate = function pointCoordinate(p) {
	                  var targetZ = 0;
	                  var coord0 = [
	                    p.x,
	                    p.y,
	                    0,
	                    1
	                  ];
	                  var coord1 = [
	                    p.x,
	                    p.y,
	                    1,
	                    1
	                  ];
	                  performance2.transformMat4(coord0, coord0, this.pixelMatrixInverse);
	                  performance2.transformMat4(coord1, coord1, this.pixelMatrixInverse);
	                  var w0 = coord0[3];
	                  var w1 = coord1[3];
	                  var x0 = coord0[0] / w0;
	                  var x1 = coord1[0] / w1;
	                  var y0 = coord0[1] / w0;
	                  var y1 = coord1[1] / w1;
	                  var z0 = coord0[2] / w0;
	                  var z1 = coord1[2] / w1;
	                  var t = z0 === z1 ? 0 : (targetZ - z0) / (z1 - z0);
	                  return new performance2.MercatorCoordinate(performance2.number(x0, x1, t) / this.worldSize, performance2.number(y0, y1, t) / this.worldSize);
	                };
	                Transform.prototype.coordinatePoint = function coordinatePoint(coord) {
	                  var p = [
	                    coord.x * this.worldSize,
	                    coord.y * this.worldSize,
	                    0,
	                    1
	                  ];
	                  performance2.transformMat4(p, p, this.pixelMatrix);
	                  return new performance2.Point(p[0] / p[3], p[1] / p[3]);
	                };
	                Transform.prototype.getBounds = function getBounds() {
	                  return new performance2.LngLatBounds().extend(this.pointLocation(new performance2.Point(0, 0))).extend(this.pointLocation(new performance2.Point(this.width, 0))).extend(this.pointLocation(new performance2.Point(this.width, this.height))).extend(this.pointLocation(new performance2.Point(0, this.height)));
	                };
	                Transform.prototype.getMaxBounds = function getMaxBounds() {
	                  if (!this.latRange || this.latRange.length !== 2 || !this.lngRange || this.lngRange.length !== 2) {
	                    return null;
	                  }
	                  return new performance2.LngLatBounds([
	                    this.lngRange[0],
	                    this.latRange[0]
	                  ], [
	                    this.lngRange[1],
	                    this.latRange[1]
	                  ]);
	                };
	                Transform.prototype.setMaxBounds = function setMaxBounds(bounds) {
	                  if (bounds) {
	                    this.lngRange = [
	                      bounds.getWest(),
	                      bounds.getEast()
	                    ];
	                    this.latRange = [
	                      bounds.getSouth(),
	                      bounds.getNorth()
	                    ];
	                    this._constrain();
	                  } else {
	                    this.lngRange = null;
	                    this.latRange = [
	                      -this.maxValidLatitude,
	                      this.maxValidLatitude
	                    ];
	                  }
	                };
	                Transform.prototype.calculatePosMatrix = function calculatePosMatrix(unwrappedTileID, aligned) {
	                  if (aligned === undefined)
	                    aligned = false;
	                  var posMatrixKey = unwrappedTileID.key;
	                  var cache = aligned ? this._alignedPosMatrixCache : this._posMatrixCache;
	                  if (cache[posMatrixKey]) {
	                    return cache[posMatrixKey];
	                  }
	                  var canonical = unwrappedTileID.canonical;
	                  var scale = this.worldSize / this.zoomScale(canonical.z);
	                  var unwrappedX = canonical.x + Math.pow(2, canonical.z) * unwrappedTileID.wrap;
	                  var posMatrix = performance2.identity(new Float64Array(16));
	                  performance2.translate(posMatrix, posMatrix, [
	                    unwrappedX * scale,
	                    canonical.y * scale,
	                    0
	                  ]);
	                  performance2.scale(posMatrix, posMatrix, [
	                    scale / performance2.EXTENT,
	                    scale / performance2.EXTENT,
	                    1
	                  ]);
	                  performance2.multiply(posMatrix, aligned ? this.alignedProjMatrix : this.projMatrix, posMatrix);
	                  cache[posMatrixKey] = new Float32Array(posMatrix);
	                  return cache[posMatrixKey];
	                };
	                Transform.prototype.customLayerMatrix = function customLayerMatrix() {
	                  return this.mercatorMatrix.slice();
	                };
	                Transform.prototype._constrain = function _constrain() {
	                  if (!this.center || !this.width || !this.height || this._constraining) {
	                    return;
	                  }
	                  this._constraining = true;
	                  var minY = -90;
	                  var maxY = 90;
	                  var minX = -180;
	                  var maxX = 180;
	                  var sy, sx, x2, y2;
	                  var size = this.size, unmodified = this._unmodified;
	                  if (this.latRange) {
	                    var latRange = this.latRange;
	                    minY = performance2.mercatorYfromLat(latRange[1]) * this.worldSize;
	                    maxY = performance2.mercatorYfromLat(latRange[0]) * this.worldSize;
	                    sy = maxY - minY < size.y ? size.y / (maxY - minY) : 0;
	                  }
	                  if (this.lngRange) {
	                    var lngRange = this.lngRange;
	                    minX = performance2.mercatorXfromLng(lngRange[0]) * this.worldSize;
	                    maxX = performance2.mercatorXfromLng(lngRange[1]) * this.worldSize;
	                    sx = maxX - minX < size.x ? size.x / (maxX - minX) : 0;
	                  }
	                  var point = this.point;
	                  var s = Math.max(sx || 0, sy || 0);
	                  if (s) {
	                    this.center = this.unproject(new performance2.Point(sx ? (maxX + minX) / 2 : point.x, sy ? (maxY + minY) / 2 : point.y));
	                    this.zoom += this.scaleZoom(s);
	                    this._unmodified = unmodified;
	                    this._constraining = false;
	                    return;
	                  }
	                  if (this.latRange) {
	                    var y = point.y, h2 = size.y / 2;
	                    if (y - h2 < minY) {
	                      y2 = minY + h2;
	                    }
	                    if (y + h2 > maxY) {
	                      y2 = maxY - h2;
	                    }
	                  }
	                  if (this.lngRange) {
	                    var x = point.x, w2 = size.x / 2;
	                    if (x - w2 < minX) {
	                      x2 = minX + w2;
	                    }
	                    if (x + w2 > maxX) {
	                      x2 = maxX - w2;
	                    }
	                  }
	                  if (x2 !== undefined || y2 !== undefined) {
	                    this.center = this.unproject(new performance2.Point(x2 !== undefined ? x2 : point.x, y2 !== undefined ? y2 : point.y));
	                  }
	                  this._unmodified = unmodified;
	                  this._constraining = false;
	                };
	                Transform.prototype._calcMatrices = function _calcMatrices() {
	                  if (!this.height) {
	                    return;
	                  }
	                  var halfFov = this._fov / 2;
	                  var offset = this.centerOffset;
	                  this.cameraToCenterDistance = 0.5 / Math.tan(halfFov) * this.height;
	                  var groundAngle = Math.PI / 2 + this._pitch;
	                  var fovAboveCenter = this._fov * (0.5 + offset.y / this.height);
	                  var topHalfSurfaceDistance = Math.sin(fovAboveCenter) * this.cameraToCenterDistance / Math.sin(performance2.clamp(Math.PI - groundAngle - fovAboveCenter, 0.01, Math.PI - 0.01));
	                  var point = this.point;
	                  var x = point.x, y = point.y;
	                  var furthestDistance = Math.cos(Math.PI / 2 - this._pitch) * topHalfSurfaceDistance + this.cameraToCenterDistance;
	                  var farZ = furthestDistance * 1.01;
	                  var nearZ = this.height / 50;
	                  var m = new Float64Array(16);
	                  performance2.perspective(m, this._fov, this.width / this.height, nearZ, farZ);
	                  m[8] = -offset.x * 2 / this.width;
	                  m[9] = offset.y * 2 / this.height;
	                  performance2.scale(m, m, [
	                    1,
	                    -1,
	                    1
	                  ]);
	                  performance2.translate(m, m, [
	                    0,
	                    0,
	                    -this.cameraToCenterDistance
	                  ]);
	                  performance2.rotateX(m, m, this._pitch);
	                  performance2.rotateZ(m, m, this.angle);
	                  performance2.translate(m, m, [
	                    -x,
	                    -y,
	                    0
	                  ]);
	                  this.mercatorMatrix = performance2.scale([], m, [
	                    this.worldSize,
	                    this.worldSize,
	                    this.worldSize
	                  ]);
	                  performance2.scale(m, m, [
	                    1,
	                    1,
	                    performance2.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
	                    1
	                  ]);
	                  this.projMatrix = m;
	                  this.invProjMatrix = performance2.invert([], this.projMatrix);
	                  var xShift = this.width % 2 / 2, yShift = this.height % 2 / 2, angleCos = Math.cos(this.angle), angleSin = Math.sin(this.angle), dx = x - Math.round(x) + angleCos * xShift + angleSin * yShift, dy = y - Math.round(y) + angleCos * yShift + angleSin * xShift;
	                  var alignedM = new Float64Array(m);
	                  performance2.translate(alignedM, alignedM, [
	                    dx > 0.5 ? dx - 1 : dx,
	                    dy > 0.5 ? dy - 1 : dy,
	                    0
	                  ]);
	                  this.alignedProjMatrix = alignedM;
	                  m = performance2.create();
	                  performance2.scale(m, m, [
	                    this.width / 2,
	                    -this.height / 2,
	                    1
	                  ]);
	                  performance2.translate(m, m, [
	                    1,
	                    -1,
	                    0
	                  ]);
	                  this.labelPlaneMatrix = m;
	                  m = performance2.create();
	                  performance2.scale(m, m, [
	                    1,
	                    -1,
	                    1
	                  ]);
	                  performance2.translate(m, m, [
	                    -1,
	                    -1,
	                    0
	                  ]);
	                  performance2.scale(m, m, [
	                    2 / this.width,
	                    2 / this.height,
	                    1
	                  ]);
	                  this.glCoordMatrix = m;
	                  this.pixelMatrix = performance2.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix);
	                  m = performance2.invert(new Float64Array(16), this.pixelMatrix);
	                  if (!m) {
	                    throw new Error("failed to invert matrix");
	                  }
	                  this.pixelMatrixInverse = m;
	                  this._posMatrixCache = {};
	                  this._alignedPosMatrixCache = {};
	                };
	                Transform.prototype.maxPitchScaleFactor = function maxPitchScaleFactor() {
	                  if (!this.pixelMatrixInverse) {
	                    return 1;
	                  }
	                  var coord = this.pointCoordinate(new performance2.Point(0, 0));
	                  var p = [
	                    coord.x * this.worldSize,
	                    coord.y * this.worldSize,
	                    0,
	                    1
	                  ];
	                  var topPoint = performance2.transformMat4(p, p, this.pixelMatrix);
	                  return topPoint[3] / this.cameraToCenterDistance;
	                };
	                Transform.prototype.getCameraPoint = function getCameraPoint() {
	                  var pitch = this._pitch;
	                  var yOffset = Math.tan(pitch) * (this.cameraToCenterDistance || 1);
	                  return this.centerPoint.add(new performance2.Point(0, yOffset));
	                };
	                Transform.prototype.getCameraQueryGeometry = function getCameraQueryGeometry(queryGeometry) {
	                  var c = this.getCameraPoint();
	                  if (queryGeometry.length === 1) {
	                    return [
	                      queryGeometry[0],
	                      c
	                    ];
	                  } else {
	                    var minX = c.x;
	                    var minY = c.y;
	                    var maxX = c.x;
	                    var maxY = c.y;
	                    for (var i = 0, list = queryGeometry; i < list.length; i += 1) {
	                      var p = list[i];
	                      minX = Math.min(minX, p.x);
	                      minY = Math.min(minY, p.y);
	                      maxX = Math.max(maxX, p.x);
	                      maxY = Math.max(maxY, p.y);
	                    }
	                    return [
	                      new performance2.Point(minX, minY),
	                      new performance2.Point(maxX, minY),
	                      new performance2.Point(maxX, maxY),
	                      new performance2.Point(minX, maxY),
	                      new performance2.Point(minX, minY)
	                    ];
	                  }
	                };
	                Object.defineProperties(Transform.prototype, prototypeAccessors);
	                function throttle(fn, time) {
	                  var pending = false;
	                  var timerId = null;
	                  var later = function() {
	                    timerId = null;
	                    if (pending) {
	                      fn();
	                      timerId = setTimeout(later, time);
	                      pending = false;
	                    }
	                  };
	                  return function() {
	                    pending = true;
	                    if (!timerId) {
	                      later();
	                    }
	                    return timerId;
	                  };
	                }
	                var Hash = function Hash2(hashName) {
	                  this._hashName = hashName && encodeURIComponent(hashName);
	                  performance2.bindAll([
	                    "_getCurrentHash",
	                    "_onHashChange",
	                    "_updateHash"
	                  ], this);
	                  this._updateHash = throttle(this._updateHashUnthrottled.bind(this), 30 * 1e3 / 100);
	                };
	                Hash.prototype.addTo = function addTo(map2) {
	                  this._map = map2;
	                  performance2.window.addEventListener("hashchange", this._onHashChange, false);
	                  this._map.on("moveend", this._updateHash);
	                  return this;
	                };
	                Hash.prototype.remove = function remove() {
	                  performance2.window.removeEventListener("hashchange", this._onHashChange, false);
	                  this._map.off("moveend", this._updateHash);
	                  clearTimeout(this._updateHash());
	                  delete this._map;
	                  return this;
	                };
	                Hash.prototype.getHashString = function getHashString(mapFeedback) {
	                  var center = this._map.getCenter(), zoom = Math.round(this._map.getZoom() * 100) / 100, precision = Math.ceil((zoom * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), m = Math.pow(10, precision), lng = Math.round(center.lng * m) / m, lat = Math.round(center.lat * m) / m, bearing = this._map.getBearing(), pitch = this._map.getPitch();
	                  var hash = "";
	                  if (mapFeedback) {
	                    hash += "/" + lng + "/" + lat + "/" + zoom;
	                  } else {
	                    hash += zoom + "/" + lat + "/" + lng;
	                  }
	                  if (bearing || pitch) {
	                    hash += "/" + Math.round(bearing * 10) / 10;
	                  }
	                  if (pitch) {
	                    hash += "/" + Math.round(pitch);
	                  }
	                  if (this._hashName) {
	                    var hashName = this._hashName;
	                    var found = false;
	                    var parts = performance2.window.location.hash.slice(1).split("&").map(function(part) {
	                      var key = part.split("=")[0];
	                      if (key === hashName) {
	                        found = true;
	                        return key + "=" + hash;
	                      }
	                      return part;
	                    }).filter(function(a) {
	                      return a;
	                    });
	                    if (!found) {
	                      parts.push(hashName + "=" + hash);
	                    }
	                    return "#" + parts.join("&");
	                  }
	                  return "#" + hash;
	                };
	                Hash.prototype._getCurrentHash = function _getCurrentHash() {
	                  var this$1$1 = this;
	                  var hash = performance2.window.location.hash.replace("#", "");
	                  if (this._hashName) {
	                    var keyval;
	                    hash.split("&").map(function(part) {
	                      return part.split("=");
	                    }).forEach(function(part) {
	                      if (part[0] === this$1$1._hashName) {
	                        keyval = part;
	                      }
	                    });
	                    return (keyval ? keyval[1] || "" : "").split("/");
	                  }
	                  return hash.split("/");
	                };
	                Hash.prototype._onHashChange = function _onHashChange() {
	                  var loc = this._getCurrentHash();
	                  if (loc.length >= 3 && !loc.some(function(v) {
	                    return isNaN(v);
	                  })) {
	                    var bearing = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(loc[3] || 0) : this._map.getBearing();
	                    this._map.jumpTo({
	                      center: [
	                        +loc[2],
	                        +loc[1]
	                      ],
	                      zoom: +loc[0],
	                      bearing,
	                      pitch: +(loc[4] || 0)
	                    });
	                    return true;
	                  }
	                  return false;
	                };
	                Hash.prototype._updateHashUnthrottled = function _updateHashUnthrottled() {
	                  var hash = this.getHashString();
	                  try {
	                    performance2.window.history.replaceState(performance2.window.history.state, "", hash);
	                  } catch (SecurityError) {
	                  }
	                };
	                var defaultInertiaOptions = {
	                  linearity: 0.3,
	                  easing: performance2.bezier(0, 0, 0.3, 1)
	                };
	                var defaultPanInertiaOptions = performance2.extend({
	                  deceleration: 2500,
	                  maxSpeed: 1400
	                }, defaultInertiaOptions);
	                var defaultZoomInertiaOptions = performance2.extend({
	                  deceleration: 20,
	                  maxSpeed: 1400
	                }, defaultInertiaOptions);
	                var defaultBearingInertiaOptions = performance2.extend({
	                  deceleration: 1e3,
	                  maxSpeed: 360
	                }, defaultInertiaOptions);
	                var defaultPitchInertiaOptions = performance2.extend({
	                  deceleration: 1e3,
	                  maxSpeed: 90
	                }, defaultInertiaOptions);
	                var HandlerInertia = function HandlerInertia2(map2) {
	                  this._map = map2;
	                  this.clear();
	                };
	                HandlerInertia.prototype.clear = function clear() {
	                  this._inertiaBuffer = [];
	                };
	                HandlerInertia.prototype.record = function record(settings) {
	                  this._drainInertiaBuffer();
	                  this._inertiaBuffer.push({
	                    time: performance2.browser.now(),
	                    settings
	                  });
	                };
	                HandlerInertia.prototype._drainInertiaBuffer = function _drainInertiaBuffer() {
	                  var inertia = this._inertiaBuffer, now = performance2.browser.now(), cutoff = 160;
	                  while (inertia.length > 0 && now - inertia[0].time > cutoff) {
	                    inertia.shift();
	                  }
	                };
	                HandlerInertia.prototype._onMoveEnd = function _onMoveEnd(panInertiaOptions) {
	                  this._drainInertiaBuffer();
	                  if (this._inertiaBuffer.length < 2) {
	                    return;
	                  }
	                  var deltas = {
	                    zoom: 0,
	                    bearing: 0,
	                    pitch: 0,
	                    pan: new performance2.Point(0, 0),
	                    pinchAround: undefined,
	                    around: undefined
	                  };
	                  for (var i = 0, list = this._inertiaBuffer; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var settings = ref.settings;
	                    deltas.zoom += settings.zoomDelta || 0;
	                    deltas.bearing += settings.bearingDelta || 0;
	                    deltas.pitch += settings.pitchDelta || 0;
	                    if (settings.panDelta) {
	                      deltas.pan._add(settings.panDelta);
	                    }
	                    if (settings.around) {
	                      deltas.around = settings.around;
	                    }
	                    if (settings.pinchAround) {
	                      deltas.pinchAround = settings.pinchAround;
	                    }
	                  }
	                  var lastEntry = this._inertiaBuffer[this._inertiaBuffer.length - 1];
	                  var duration = lastEntry.time - this._inertiaBuffer[0].time;
	                  var easeOptions = {};
	                  if (deltas.pan.mag()) {
	                    var result = calculateEasing(deltas.pan.mag(), duration, performance2.extend({}, defaultPanInertiaOptions, panInertiaOptions || {}));
	                    easeOptions.offset = deltas.pan.mult(result.amount / deltas.pan.mag());
	                    easeOptions.center = this._map.transform.center;
	                    extendDuration(easeOptions, result);
	                  }
	                  if (deltas.zoom) {
	                    var result$1 = calculateEasing(deltas.zoom, duration, defaultZoomInertiaOptions);
	                    easeOptions.zoom = this._map.transform.zoom + result$1.amount;
	                    extendDuration(easeOptions, result$1);
	                  }
	                  if (deltas.bearing) {
	                    var result$2 = calculateEasing(deltas.bearing, duration, defaultBearingInertiaOptions);
	                    easeOptions.bearing = this._map.transform.bearing + performance2.clamp(result$2.amount, -179, 179);
	                    extendDuration(easeOptions, result$2);
	                  }
	                  if (deltas.pitch) {
	                    var result$3 = calculateEasing(deltas.pitch, duration, defaultPitchInertiaOptions);
	                    easeOptions.pitch = this._map.transform.pitch + result$3.amount;
	                    extendDuration(easeOptions, result$3);
	                  }
	                  if (easeOptions.zoom || easeOptions.bearing) {
	                    var last = deltas.pinchAround === undefined ? deltas.around : deltas.pinchAround;
	                    easeOptions.around = last ? this._map.unproject(last) : this._map.getCenter();
	                  }
	                  this.clear();
	                  return performance2.extend(easeOptions, { noMoveStart: true });
	                };
	                function extendDuration(easeOptions, result) {
	                  if (!easeOptions.duration || easeOptions.duration < result.duration) {
	                    easeOptions.duration = result.duration;
	                    easeOptions.easing = result.easing;
	                  }
	                }
	                function calculateEasing(amount, inertiaDuration, inertiaOptions) {
	                  var maxSpeed = inertiaOptions.maxSpeed;
	                  var linearity = inertiaOptions.linearity;
	                  var deceleration = inertiaOptions.deceleration;
	                  var speed = performance2.clamp(amount * linearity / (inertiaDuration / 1e3), -maxSpeed, maxSpeed);
	                  var duration = Math.abs(speed) / (deceleration * linearity);
	                  return {
	                    easing: inertiaOptions.easing,
	                    duration: duration * 1e3,
	                    amount: speed * (duration / 2)
	                  };
	                }
	                var MapMouseEvent = function(Event) {
	                  function MapMouseEvent2(type, map2, originalEvent, data) {
	                    if (data === undefined)
	                      data = {};
	                    var point = DOM.mousePos(map2.getCanvasContainer(), originalEvent);
	                    var lngLat = map2.unproject(point);
	                    Event.call(this, type, performance2.extend({
	                      point,
	                      lngLat,
	                      originalEvent
	                    }, data));
	                    this._defaultPrevented = false;
	                    this.target = map2;
	                  }
	                  if (Event)
	                    MapMouseEvent2.__proto__ = Event;
	                  MapMouseEvent2.prototype = Object.create(Event && Event.prototype);
	                  MapMouseEvent2.prototype.constructor = MapMouseEvent2;
	                  var prototypeAccessors2 = { defaultPrevented: { configurable: true } };
	                  MapMouseEvent2.prototype.preventDefault = function preventDefault() {
	                    this._defaultPrevented = true;
	                  };
	                  prototypeAccessors2.defaultPrevented.get = function() {
	                    return this._defaultPrevented;
	                  };
	                  Object.defineProperties(MapMouseEvent2.prototype, prototypeAccessors2);
	                  return MapMouseEvent2;
	                }(performance2.Event);
	                var MapTouchEvent = function(Event) {
	                  function MapTouchEvent2(type, map2, originalEvent) {
	                    var touches = type === "touchend" ? originalEvent.changedTouches : originalEvent.touches;
	                    var points = DOM.touchPos(map2.getCanvasContainer(), touches);
	                    var lngLats = points.map(function(t) {
	                      return map2.unproject(t);
	                    });
	                    var point = points.reduce(function(prev, curr, i, arr) {
	                      return prev.add(curr.div(arr.length));
	                    }, new performance2.Point(0, 0));
	                    var lngLat = map2.unproject(point);
	                    Event.call(this, type, {
	                      points,
	                      point,
	                      lngLats,
	                      lngLat,
	                      originalEvent
	                    });
	                    this._defaultPrevented = false;
	                  }
	                  if (Event)
	                    MapTouchEvent2.__proto__ = Event;
	                  MapTouchEvent2.prototype = Object.create(Event && Event.prototype);
	                  MapTouchEvent2.prototype.constructor = MapTouchEvent2;
	                  var prototypeAccessors$1 = { defaultPrevented: { configurable: true } };
	                  MapTouchEvent2.prototype.preventDefault = function preventDefault() {
	                    this._defaultPrevented = true;
	                  };
	                  prototypeAccessors$1.defaultPrevented.get = function() {
	                    return this._defaultPrevented;
	                  };
	                  Object.defineProperties(MapTouchEvent2.prototype, prototypeAccessors$1);
	                  return MapTouchEvent2;
	                }(performance2.Event);
	                var MapWheelEvent = function(Event) {
	                  function MapWheelEvent2(type, map2, originalEvent) {
	                    Event.call(this, type, { originalEvent });
	                    this._defaultPrevented = false;
	                  }
	                  if (Event)
	                    MapWheelEvent2.__proto__ = Event;
	                  MapWheelEvent2.prototype = Object.create(Event && Event.prototype);
	                  MapWheelEvent2.prototype.constructor = MapWheelEvent2;
	                  var prototypeAccessors$2 = { defaultPrevented: { configurable: true } };
	                  MapWheelEvent2.prototype.preventDefault = function preventDefault() {
	                    this._defaultPrevented = true;
	                  };
	                  prototypeAccessors$2.defaultPrevented.get = function() {
	                    return this._defaultPrevented;
	                  };
	                  Object.defineProperties(MapWheelEvent2.prototype, prototypeAccessors$2);
	                  return MapWheelEvent2;
	                }(performance2.Event);
	                var MapEventHandler = function MapEventHandler2(map2, options) {
	                  this._map = map2;
	                  this._clickTolerance = options.clickTolerance;
	                };
	                MapEventHandler.prototype.reset = function reset() {
	                  delete this._mousedownPos;
	                };
	                MapEventHandler.prototype.wheel = function wheel(e) {
	                  return this._firePreventable(new MapWheelEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.mousedown = function mousedown(e, point) {
	                  this._mousedownPos = point;
	                  return this._firePreventable(new MapMouseEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.mouseup = function mouseup(e) {
	                  this._map.fire(new MapMouseEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.click = function click(e, point) {
	                  if (this._mousedownPos && this._mousedownPos.dist(point) >= this._clickTolerance) {
	                    return;
	                  }
	                  this._map.fire(new MapMouseEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.dblclick = function dblclick(e) {
	                  return this._firePreventable(new MapMouseEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.mouseover = function mouseover(e) {
	                  this._map.fire(new MapMouseEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.mouseout = function mouseout(e) {
	                  this._map.fire(new MapMouseEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.touchstart = function touchstart(e) {
	                  return this._firePreventable(new MapTouchEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.touchmove = function touchmove(e) {
	                  this._map.fire(new MapTouchEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.touchend = function touchend(e) {
	                  this._map.fire(new MapTouchEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype.touchcancel = function touchcancel(e) {
	                  this._map.fire(new MapTouchEvent(e.type, this._map, e));
	                };
	                MapEventHandler.prototype._firePreventable = function _firePreventable(mapEvent) {
	                  this._map.fire(mapEvent);
	                  if (mapEvent.defaultPrevented) {
	                    return {};
	                  }
	                };
	                MapEventHandler.prototype.isEnabled = function isEnabled() {
	                  return true;
	                };
	                MapEventHandler.prototype.isActive = function isActive() {
	                  return false;
	                };
	                MapEventHandler.prototype.enable = function enable() {
	                };
	                MapEventHandler.prototype.disable = function disable() {
	                };
	                var BlockableMapEventHandler = function BlockableMapEventHandler2(map2) {
	                  this._map = map2;
	                };
	                BlockableMapEventHandler.prototype.reset = function reset() {
	                  this._delayContextMenu = false;
	                  delete this._contextMenuEvent;
	                };
	                BlockableMapEventHandler.prototype.mousemove = function mousemove(e) {
	                  this._map.fire(new MapMouseEvent(e.type, this._map, e));
	                };
	                BlockableMapEventHandler.prototype.mousedown = function mousedown() {
	                  this._delayContextMenu = true;
	                };
	                BlockableMapEventHandler.prototype.mouseup = function mouseup() {
	                  this._delayContextMenu = false;
	                  if (this._contextMenuEvent) {
	                    this._map.fire(new MapMouseEvent("contextmenu", this._map, this._contextMenuEvent));
	                    delete this._contextMenuEvent;
	                  }
	                };
	                BlockableMapEventHandler.prototype.contextmenu = function contextmenu(e) {
	                  if (this._delayContextMenu) {
	                    this._contextMenuEvent = e;
	                  } else {
	                    this._map.fire(new MapMouseEvent(e.type, this._map, e));
	                  }
	                  if (this._map.listens("contextmenu")) {
	                    e.preventDefault();
	                  }
	                };
	                BlockableMapEventHandler.prototype.isEnabled = function isEnabled() {
	                  return true;
	                };
	                BlockableMapEventHandler.prototype.isActive = function isActive() {
	                  return false;
	                };
	                BlockableMapEventHandler.prototype.enable = function enable() {
	                };
	                BlockableMapEventHandler.prototype.disable = function disable() {
	                };
	                var BoxZoomHandler = function BoxZoomHandler2(map2, options) {
	                  this._map = map2;
	                  this._el = map2.getCanvasContainer();
	                  this._container = map2.getContainer();
	                  this._clickTolerance = options.clickTolerance || 1;
	                };
	                BoxZoomHandler.prototype.isEnabled = function isEnabled() {
	                  return !!this._enabled;
	                };
	                BoxZoomHandler.prototype.isActive = function isActive() {
	                  return !!this._active;
	                };
	                BoxZoomHandler.prototype.enable = function enable() {
	                  if (this.isEnabled()) {
	                    return;
	                  }
	                  this._enabled = true;
	                };
	                BoxZoomHandler.prototype.disable = function disable() {
	                  if (!this.isEnabled()) {
	                    return;
	                  }
	                  this._enabled = false;
	                };
	                BoxZoomHandler.prototype.mousedown = function mousedown(e, point) {
	                  if (!this.isEnabled()) {
	                    return;
	                  }
	                  if (!(e.shiftKey && e.button === 0)) {
	                    return;
	                  }
	                  DOM.disableDrag();
	                  this._startPos = this._lastPos = point;
	                  this._active = true;
	                };
	                BoxZoomHandler.prototype.mousemoveWindow = function mousemoveWindow(e, point) {
	                  if (!this._active) {
	                    return;
	                  }
	                  var pos = point;
	                  if (this._lastPos.equals(pos) || !this._box && pos.dist(this._startPos) < this._clickTolerance) {
	                    return;
	                  }
	                  var p0 = this._startPos;
	                  this._lastPos = pos;
	                  if (!this._box) {
	                    this._box = DOM.create("div", "mapboxgl-boxzoom", this._container);
	                    this._container.classList.add("mapboxgl-crosshair");
	                    this._fireEvent("boxzoomstart", e);
	                  }
	                  var minX = Math.min(p0.x, pos.x), maxX = Math.max(p0.x, pos.x), minY = Math.min(p0.y, pos.y), maxY = Math.max(p0.y, pos.y);
	                  DOM.setTransform(this._box, "translate(" + minX + "px," + minY + "px)");
	                  this._box.style.width = maxX - minX + "px";
	                  this._box.style.height = maxY - minY + "px";
	                };
	                BoxZoomHandler.prototype.mouseupWindow = function mouseupWindow(e, point) {
	                  var this$1$1 = this;
	                  if (!this._active) {
	                    return;
	                  }
	                  if (e.button !== 0) {
	                    return;
	                  }
	                  var p0 = this._startPos, p1 = point;
	                  this.reset();
	                  DOM.suppressClick();
	                  if (p0.x === p1.x && p0.y === p1.y) {
	                    this._fireEvent("boxzoomcancel", e);
	                  } else {
	                    this._map.fire(new performance2.Event("boxzoomend", { originalEvent: e }));
	                    return {
	                      cameraAnimation: function(map2) {
	                        return map2.fitScreenCoordinates(p0, p1, this$1$1._map.getBearing(), { linear: true });
	                      }
	                    };
	                  }
	                };
	                BoxZoomHandler.prototype.keydown = function keydown(e) {
	                  if (!this._active) {
	                    return;
	                  }
	                  if (e.keyCode === 27) {
	                    this.reset();
	                    this._fireEvent("boxzoomcancel", e);
	                  }
	                };
	                BoxZoomHandler.prototype.reset = function reset() {
	                  this._active = false;
	                  this._container.classList.remove("mapboxgl-crosshair");
	                  if (this._box) {
	                    DOM.remove(this._box);
	                    this._box = null;
	                  }
	                  DOM.enableDrag();
	                  delete this._startPos;
	                  delete this._lastPos;
	                };
	                BoxZoomHandler.prototype._fireEvent = function _fireEvent(type, e) {
	                  return this._map.fire(new performance2.Event(type, { originalEvent: e }));
	                };
	                function indexTouches(touches, points) {
	                  var obj = {};
	                  for (var i = 0; i < touches.length; i++) {
	                    obj[touches[i].identifier] = points[i];
	                  }
	                  return obj;
	                }
	                function getCentroid(points) {
	                  var sum = new performance2.Point(0, 0);
	                  for (var i = 0, list = points; i < list.length; i += 1) {
	                    var point = list[i];
	                    sum._add(point);
	                  }
	                  return sum.div(points.length);
	                }
	                var MAX_TAP_INTERVAL = 500;
	                var MAX_TOUCH_TIME = 500;
	                var MAX_DIST = 30;
	                var SingleTapRecognizer = function SingleTapRecognizer2(options) {
	                  this.reset();
	                  this.numTouches = options.numTouches;
	                };
	                SingleTapRecognizer.prototype.reset = function reset() {
	                  delete this.centroid;
	                  delete this.startTime;
	                  delete this.touches;
	                  this.aborted = false;
	                };
	                SingleTapRecognizer.prototype.touchstart = function touchstart(e, points, mapTouches) {
	                  if (this.centroid || mapTouches.length > this.numTouches) {
	                    this.aborted = true;
	                  }
	                  if (this.aborted) {
	                    return;
	                  }
	                  if (this.startTime === undefined) {
	                    this.startTime = e.timeStamp;
	                  }
	                  if (mapTouches.length === this.numTouches) {
	                    this.centroid = getCentroid(points);
	                    this.touches = indexTouches(mapTouches, points);
	                  }
	                };
	                SingleTapRecognizer.prototype.touchmove = function touchmove(e, points, mapTouches) {
	                  if (this.aborted || !this.centroid) {
	                    return;
	                  }
	                  var newTouches = indexTouches(mapTouches, points);
	                  for (var id in this.touches) {
	                    var prevPos = this.touches[id];
	                    var pos = newTouches[id];
	                    if (!pos || pos.dist(prevPos) > MAX_DIST) {
	                      this.aborted = true;
	                    }
	                  }
	                };
	                SingleTapRecognizer.prototype.touchend = function touchend(e, points, mapTouches) {
	                  if (!this.centroid || e.timeStamp - this.startTime > MAX_TOUCH_TIME) {
	                    this.aborted = true;
	                  }
	                  if (mapTouches.length === 0) {
	                    var centroid = !this.aborted && this.centroid;
	                    this.reset();
	                    if (centroid) {
	                      return centroid;
	                    }
	                  }
	                };
	                var TapRecognizer = function TapRecognizer2(options) {
	                  this.singleTap = new SingleTapRecognizer(options);
	                  this.numTaps = options.numTaps;
	                  this.reset();
	                };
	                TapRecognizer.prototype.reset = function reset() {
	                  this.lastTime = Infinity;
	                  delete this.lastTap;
	                  this.count = 0;
	                  this.singleTap.reset();
	                };
	                TapRecognizer.prototype.touchstart = function touchstart(e, points, mapTouches) {
	                  this.singleTap.touchstart(e, points, mapTouches);
	                };
	                TapRecognizer.prototype.touchmove = function touchmove(e, points, mapTouches) {
	                  this.singleTap.touchmove(e, points, mapTouches);
	                };
	                TapRecognizer.prototype.touchend = function touchend(e, points, mapTouches) {
	                  var tap = this.singleTap.touchend(e, points, mapTouches);
	                  if (tap) {
	                    var soonEnough = e.timeStamp - this.lastTime < MAX_TAP_INTERVAL;
	                    var closeEnough = !this.lastTap || this.lastTap.dist(tap) < MAX_DIST;
	                    if (!soonEnough || !closeEnough) {
	                      this.reset();
	                    }
	                    this.count++;
	                    this.lastTime = e.timeStamp;
	                    this.lastTap = tap;
	                    if (this.count === this.numTaps) {
	                      this.reset();
	                      return tap;
	                    }
	                  }
	                };
	                var TapZoomHandler = function TapZoomHandler2() {
	                  this._zoomIn = new TapRecognizer({
	                    numTouches: 1,
	                    numTaps: 2
	                  });
	                  this._zoomOut = new TapRecognizer({
	                    numTouches: 2,
	                    numTaps: 1
	                  });
	                  this.reset();
	                };
	                TapZoomHandler.prototype.reset = function reset() {
	                  this._active = false;
	                  this._zoomIn.reset();
	                  this._zoomOut.reset();
	                };
	                TapZoomHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
	                  this._zoomIn.touchstart(e, points, mapTouches);
	                  this._zoomOut.touchstart(e, points, mapTouches);
	                };
	                TapZoomHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
	                  this._zoomIn.touchmove(e, points, mapTouches);
	                  this._zoomOut.touchmove(e, points, mapTouches);
	                };
	                TapZoomHandler.prototype.touchend = function touchend(e, points, mapTouches) {
	                  var this$1$1 = this;
	                  var zoomInPoint = this._zoomIn.touchend(e, points, mapTouches);
	                  var zoomOutPoint = this._zoomOut.touchend(e, points, mapTouches);
	                  if (zoomInPoint) {
	                    this._active = true;
	                    e.preventDefault();
	                    setTimeout(function() {
	                      return this$1$1.reset();
	                    }, 0);
	                    return {
	                      cameraAnimation: function(map2) {
	                        return map2.easeTo({
	                          duration: 300,
	                          zoom: map2.getZoom() + 1,
	                          around: map2.unproject(zoomInPoint)
	                        }, { originalEvent: e });
	                      }
	                    };
	                  } else if (zoomOutPoint) {
	                    this._active = true;
	                    e.preventDefault();
	                    setTimeout(function() {
	                      return this$1$1.reset();
	                    }, 0);
	                    return {
	                      cameraAnimation: function(map2) {
	                        return map2.easeTo({
	                          duration: 300,
	                          zoom: map2.getZoom() - 1,
	                          around: map2.unproject(zoomOutPoint)
	                        }, { originalEvent: e });
	                      }
	                    };
	                  }
	                };
	                TapZoomHandler.prototype.touchcancel = function touchcancel() {
	                  this.reset();
	                };
	                TapZoomHandler.prototype.enable = function enable() {
	                  this._enabled = true;
	                };
	                TapZoomHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                TapZoomHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                TapZoomHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                var LEFT_BUTTON = 0;
	                var RIGHT_BUTTON = 2;
	                var MouseHandler = function MouseHandler2(options) {
	                  this.reset();
	                  this._clickTolerance = options.clickTolerance || 1;
	                };
	                MouseHandler.prototype.reset = function reset() {
	                  this._active = false;
	                  this._moved = false;
	                  delete this._lastPoint;
	                  delete this._eventButton;
	                };
	                MouseHandler.prototype._correctButton = function _correctButton(e, button) {
	                  return false;
	                };
	                MouseHandler.prototype._move = function _move(lastPoint, point) {
	                  return {};
	                };
	                MouseHandler.prototype.mousedown = function mousedown(e, point) {
	                  if (this._lastPoint) {
	                    return;
	                  }
	                  var eventButton = DOM.mouseButton(e);
	                  if (!this._correctButton(e, eventButton)) {
	                    return;
	                  }
	                  this._lastPoint = point;
	                  this._eventButton = eventButton;
	                };
	                MouseHandler.prototype.mousemoveWindow = function mousemoveWindow(e, point) {
	                  var lastPoint = this._lastPoint;
	                  if (!lastPoint) {
	                    return;
	                  }
	                  e.preventDefault();
	                  if (!this._moved && point.dist(lastPoint) < this._clickTolerance) {
	                    return;
	                  }
	                  this._moved = true;
	                  this._lastPoint = point;
	                  return this._move(lastPoint, point);
	                };
	                MouseHandler.prototype.mouseupWindow = function mouseupWindow(e) {
	                  var eventButton = DOM.mouseButton(e);
	                  if (eventButton !== this._eventButton) {
	                    return;
	                  }
	                  if (this._moved) {
	                    DOM.suppressClick();
	                  }
	                  this.reset();
	                };
	                MouseHandler.prototype.enable = function enable() {
	                  this._enabled = true;
	                };
	                MouseHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                MouseHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                MouseHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                var MousePanHandler = function(MouseHandler2) {
	                  function MousePanHandler2() {
	                    MouseHandler2.apply(this, arguments);
	                  }
	                  MousePanHandler2.__proto__ = MouseHandler2;
	                  MousePanHandler2.prototype = Object.create(MouseHandler2.prototype);
	                  MousePanHandler2.prototype.constructor = MousePanHandler2;
	                  MousePanHandler2.prototype.mousedown = function mousedown(e, point) {
	                    MouseHandler2.prototype.mousedown.call(this, e, point);
	                    if (this._lastPoint) {
	                      this._active = true;
	                    }
	                  };
	                  MousePanHandler2.prototype._correctButton = function _correctButton(e, button) {
	                    return button === LEFT_BUTTON && !e.ctrlKey;
	                  };
	                  MousePanHandler2.prototype._move = function _move(lastPoint, point) {
	                    return {
	                      around: point,
	                      panDelta: point.sub(lastPoint)
	                    };
	                  };
	                  return MousePanHandler2;
	                }(MouseHandler);
	                var MouseRotateHandler = function(MouseHandler2) {
	                  function MouseRotateHandler2() {
	                    MouseHandler2.apply(this, arguments);
	                  }
	                  MouseRotateHandler2.__proto__ = MouseHandler2;
	                  MouseRotateHandler2.prototype = Object.create(MouseHandler2.prototype);
	                  MouseRotateHandler2.prototype.constructor = MouseRotateHandler2;
	                  MouseRotateHandler2.prototype._correctButton = function _correctButton(e, button) {
	                    return button === LEFT_BUTTON && e.ctrlKey || button === RIGHT_BUTTON;
	                  };
	                  MouseRotateHandler2.prototype._move = function _move(lastPoint, point) {
	                    var degreesPerPixelMoved = 0.8;
	                    var bearingDelta = (point.x - lastPoint.x) * degreesPerPixelMoved;
	                    if (bearingDelta) {
	                      this._active = true;
	                      return { bearingDelta };
	                    }
	                  };
	                  MouseRotateHandler2.prototype.contextmenu = function contextmenu(e) {
	                    e.preventDefault();
	                  };
	                  return MouseRotateHandler2;
	                }(MouseHandler);
	                var MousePitchHandler = function(MouseHandler2) {
	                  function MousePitchHandler2() {
	                    MouseHandler2.apply(this, arguments);
	                  }
	                  MousePitchHandler2.__proto__ = MouseHandler2;
	                  MousePitchHandler2.prototype = Object.create(MouseHandler2.prototype);
	                  MousePitchHandler2.prototype.constructor = MousePitchHandler2;
	                  MousePitchHandler2.prototype._correctButton = function _correctButton(e, button) {
	                    return button === LEFT_BUTTON && e.ctrlKey || button === RIGHT_BUTTON;
	                  };
	                  MousePitchHandler2.prototype._move = function _move(lastPoint, point) {
	                    var degreesPerPixelMoved = -0.5;
	                    var pitchDelta = (point.y - lastPoint.y) * degreesPerPixelMoved;
	                    if (pitchDelta) {
	                      this._active = true;
	                      return { pitchDelta };
	                    }
	                  };
	                  MousePitchHandler2.prototype.contextmenu = function contextmenu(e) {
	                    e.preventDefault();
	                  };
	                  return MousePitchHandler2;
	                }(MouseHandler);
	                var TouchPanHandler = function TouchPanHandler2(options) {
	                  this._minTouches = 1;
	                  this._clickTolerance = options.clickTolerance || 1;
	                  this.reset();
	                };
	                TouchPanHandler.prototype.reset = function reset() {
	                  this._active = false;
	                  this._touches = {};
	                  this._sum = new performance2.Point(0, 0);
	                };
	                TouchPanHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
	                  return this._calculateTransform(e, points, mapTouches);
	                };
	                TouchPanHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
	                  if (!this._active) {
	                    return;
	                  }
	                  e.preventDefault();
	                  return this._calculateTransform(e, points, mapTouches);
	                };
	                TouchPanHandler.prototype.touchend = function touchend(e, points, mapTouches) {
	                  this._calculateTransform(e, points, mapTouches);
	                  if (this._active && mapTouches.length < this._minTouches) {
	                    this.reset();
	                  }
	                };
	                TouchPanHandler.prototype.touchcancel = function touchcancel() {
	                  this.reset();
	                };
	                TouchPanHandler.prototype._calculateTransform = function _calculateTransform(e, points, mapTouches) {
	                  if (mapTouches.length > 0) {
	                    this._active = true;
	                  }
	                  var touches = indexTouches(mapTouches, points);
	                  var touchPointSum = new performance2.Point(0, 0);
	                  var touchDeltaSum = new performance2.Point(0, 0);
	                  var touchDeltaCount = 0;
	                  for (var identifier in touches) {
	                    var point = touches[identifier];
	                    var prevPoint = this._touches[identifier];
	                    if (prevPoint) {
	                      touchPointSum._add(point);
	                      touchDeltaSum._add(point.sub(prevPoint));
	                      touchDeltaCount++;
	                      touches[identifier] = point;
	                    }
	                  }
	                  this._touches = touches;
	                  if (touchDeltaCount < this._minTouches || !touchDeltaSum.mag()) {
	                    return;
	                  }
	                  var panDelta = touchDeltaSum.div(touchDeltaCount);
	                  this._sum._add(panDelta);
	                  if (this._sum.mag() < this._clickTolerance) {
	                    return;
	                  }
	                  var around = touchPointSum.div(touchDeltaCount);
	                  return {
	                    around,
	                    panDelta
	                  };
	                };
	                TouchPanHandler.prototype.enable = function enable() {
	                  this._enabled = true;
	                };
	                TouchPanHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                TouchPanHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                TouchPanHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                var TwoTouchHandler = function TwoTouchHandler2() {
	                  this.reset();
	                };
	                TwoTouchHandler.prototype.reset = function reset() {
	                  this._active = false;
	                  delete this._firstTwoTouches;
	                };
	                TwoTouchHandler.prototype._start = function _start(points) {
	                };
	                TwoTouchHandler.prototype._move = function _move(points, pinchAround, e) {
	                  return {};
	                };
	                TwoTouchHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
	                  if (this._firstTwoTouches || mapTouches.length < 2) {
	                    return;
	                  }
	                  this._firstTwoTouches = [
	                    mapTouches[0].identifier,
	                    mapTouches[1].identifier
	                  ];
	                  this._start([
	                    points[0],
	                    points[1]
	                  ]);
	                };
	                TwoTouchHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
	                  if (!this._firstTwoTouches) {
	                    return;
	                  }
	                  e.preventDefault();
	                  var ref = this._firstTwoTouches;
	                  var idA = ref[0];
	                  var idB = ref[1];
	                  var a = getTouchById(mapTouches, points, idA);
	                  var b = getTouchById(mapTouches, points, idB);
	                  if (!a || !b) {
	                    return;
	                  }
	                  var pinchAround = this._aroundCenter ? null : a.add(b).div(2);
	                  return this._move([
	                    a,
	                    b
	                  ], pinchAround, e);
	                };
	                TwoTouchHandler.prototype.touchend = function touchend(e, points, mapTouches) {
	                  if (!this._firstTwoTouches) {
	                    return;
	                  }
	                  var ref = this._firstTwoTouches;
	                  var idA = ref[0];
	                  var idB = ref[1];
	                  var a = getTouchById(mapTouches, points, idA);
	                  var b = getTouchById(mapTouches, points, idB);
	                  if (a && b) {
	                    return;
	                  }
	                  if (this._active) {
	                    DOM.suppressClick();
	                  }
	                  this.reset();
	                };
	                TwoTouchHandler.prototype.touchcancel = function touchcancel() {
	                  this.reset();
	                };
	                TwoTouchHandler.prototype.enable = function enable(options) {
	                  this._enabled = true;
	                  this._aroundCenter = !!options && options.around === "center";
	                };
	                TwoTouchHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                TwoTouchHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                TwoTouchHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                function getTouchById(mapTouches, points, identifier) {
	                  for (var i = 0; i < mapTouches.length; i++) {
	                    if (mapTouches[i].identifier === identifier) {
	                      return points[i];
	                    }
	                  }
	                }
	                var ZOOM_THRESHOLD = 0.1;
	                function getZoomDelta(distance, lastDistance) {
	                  return Math.log(distance / lastDistance) / Math.LN2;
	                }
	                var TouchZoomHandler = function(TwoTouchHandler2) {
	                  function TouchZoomHandler2() {
	                    TwoTouchHandler2.apply(this, arguments);
	                  }
	                  TouchZoomHandler2.__proto__ = TwoTouchHandler2;
	                  TouchZoomHandler2.prototype = Object.create(TwoTouchHandler2.prototype);
	                  TouchZoomHandler2.prototype.constructor = TouchZoomHandler2;
	                  TouchZoomHandler2.prototype.reset = function reset() {
	                    TwoTouchHandler2.prototype.reset.call(this);
	                    delete this._distance;
	                    delete this._startDistance;
	                  };
	                  TouchZoomHandler2.prototype._start = function _start(points) {
	                    this._startDistance = this._distance = points[0].dist(points[1]);
	                  };
	                  TouchZoomHandler2.prototype._move = function _move(points, pinchAround) {
	                    var lastDistance = this._distance;
	                    this._distance = points[0].dist(points[1]);
	                    if (!this._active && Math.abs(getZoomDelta(this._distance, this._startDistance)) < ZOOM_THRESHOLD) {
	                      return;
	                    }
	                    this._active = true;
	                    return {
	                      zoomDelta: getZoomDelta(this._distance, lastDistance),
	                      pinchAround
	                    };
	                  };
	                  return TouchZoomHandler2;
	                }(TwoTouchHandler);
	                var ROTATION_THRESHOLD = 25;
	                function getBearingDelta(a, b) {
	                  return a.angleWith(b) * 180 / Math.PI;
	                }
	                var TouchRotateHandler = function(TwoTouchHandler2) {
	                  function TouchRotateHandler2() {
	                    TwoTouchHandler2.apply(this, arguments);
	                  }
	                  TouchRotateHandler2.__proto__ = TwoTouchHandler2;
	                  TouchRotateHandler2.prototype = Object.create(TwoTouchHandler2.prototype);
	                  TouchRotateHandler2.prototype.constructor = TouchRotateHandler2;
	                  TouchRotateHandler2.prototype.reset = function reset() {
	                    TwoTouchHandler2.prototype.reset.call(this);
	                    delete this._minDiameter;
	                    delete this._startVector;
	                    delete this._vector;
	                  };
	                  TouchRotateHandler2.prototype._start = function _start(points) {
	                    this._startVector = this._vector = points[0].sub(points[1]);
	                    this._minDiameter = points[0].dist(points[1]);
	                  };
	                  TouchRotateHandler2.prototype._move = function _move(points, pinchAround) {
	                    var lastVector = this._vector;
	                    this._vector = points[0].sub(points[1]);
	                    if (!this._active && this._isBelowThreshold(this._vector)) {
	                      return;
	                    }
	                    this._active = true;
	                    return {
	                      bearingDelta: getBearingDelta(this._vector, lastVector),
	                      pinchAround
	                    };
	                  };
	                  TouchRotateHandler2.prototype._isBelowThreshold = function _isBelowThreshold(vector) {
	                    this._minDiameter = Math.min(this._minDiameter, vector.mag());
	                    var circumference = Math.PI * this._minDiameter;
	                    var threshold = ROTATION_THRESHOLD / circumference * 360;
	                    var bearingDeltaSinceStart = getBearingDelta(vector, this._startVector);
	                    return Math.abs(bearingDeltaSinceStart) < threshold;
	                  };
	                  return TouchRotateHandler2;
	                }(TwoTouchHandler);
	                function isVertical(vector) {
	                  return Math.abs(vector.y) > Math.abs(vector.x);
	                }
	                var ALLOWED_SINGLE_TOUCH_TIME = 100;
	                var TouchPitchHandler = function(TwoTouchHandler2) {
	                  function TouchPitchHandler2() {
	                    TwoTouchHandler2.apply(this, arguments);
	                  }
	                  TouchPitchHandler2.__proto__ = TwoTouchHandler2;
	                  TouchPitchHandler2.prototype = Object.create(TwoTouchHandler2.prototype);
	                  TouchPitchHandler2.prototype.constructor = TouchPitchHandler2;
	                  TouchPitchHandler2.prototype.reset = function reset() {
	                    TwoTouchHandler2.prototype.reset.call(this);
	                    this._valid = undefined;
	                    delete this._firstMove;
	                    delete this._lastPoints;
	                  };
	                  TouchPitchHandler2.prototype._start = function _start(points) {
	                    this._lastPoints = points;
	                    if (isVertical(points[0].sub(points[1]))) {
	                      this._valid = false;
	                    }
	                  };
	                  TouchPitchHandler2.prototype._move = function _move(points, center, e) {
	                    var vectorA = points[0].sub(this._lastPoints[0]);
	                    var vectorB = points[1].sub(this._lastPoints[1]);
	                    this._valid = this.gestureBeginsVertically(vectorA, vectorB, e.timeStamp);
	                    if (!this._valid) {
	                      return;
	                    }
	                    this._lastPoints = points;
	                    this._active = true;
	                    var yDeltaAverage = (vectorA.y + vectorB.y) / 2;
	                    var degreesPerPixelMoved = -0.5;
	                    return { pitchDelta: yDeltaAverage * degreesPerPixelMoved };
	                  };
	                  TouchPitchHandler2.prototype.gestureBeginsVertically = function gestureBeginsVertically(vectorA, vectorB, timeStamp) {
	                    if (this._valid !== undefined) {
	                      return this._valid;
	                    }
	                    var threshold = 2;
	                    var movedA = vectorA.mag() >= threshold;
	                    var movedB = vectorB.mag() >= threshold;
	                    if (!movedA && !movedB) {
	                      return;
	                    }
	                    if (!movedA || !movedB) {
	                      if (this._firstMove === undefined) {
	                        this._firstMove = timeStamp;
	                      }
	                      if (timeStamp - this._firstMove < ALLOWED_SINGLE_TOUCH_TIME) {
	                        return undefined;
	                      } else {
	                        return false;
	                      }
	                    }
	                    var isSameDirection = vectorA.y > 0 === vectorB.y > 0;
	                    return isVertical(vectorA) && isVertical(vectorB) && isSameDirection;
	                  };
	                  return TouchPitchHandler2;
	                }(TwoTouchHandler);
	                var defaultOptions = {
	                  panStep: 100,
	                  bearingStep: 15,
	                  pitchStep: 10
	                };
	                var KeyboardHandler = function KeyboardHandler2() {
	                  var stepOptions = defaultOptions;
	                  this._panStep = stepOptions.panStep;
	                  this._bearingStep = stepOptions.bearingStep;
	                  this._pitchStep = stepOptions.pitchStep;
	                };
	                KeyboardHandler.prototype.reset = function reset() {
	                  this._active = false;
	                };
	                KeyboardHandler.prototype.keydown = function keydown(e) {
	                  var this$1$1 = this;
	                  if (e.altKey || e.ctrlKey || e.metaKey) {
	                    return;
	                  }
	                  var zoomDir = 0;
	                  var bearingDir = 0;
	                  var pitchDir = 0;
	                  var xDir = 0;
	                  var yDir = 0;
	                  switch (e.keyCode) {
	                    case 61:
	                    case 107:
	                    case 171:
	                    case 187:
	                      zoomDir = 1;
	                      break;
	                    case 189:
	                    case 109:
	                    case 173:
	                      zoomDir = -1;
	                      break;
	                    case 37:
	                      if (e.shiftKey) {
	                        bearingDir = -1;
	                      } else {
	                        e.preventDefault();
	                        xDir = -1;
	                      }
	                      break;
	                    case 39:
	                      if (e.shiftKey) {
	                        bearingDir = 1;
	                      } else {
	                        e.preventDefault();
	                        xDir = 1;
	                      }
	                      break;
	                    case 38:
	                      if (e.shiftKey) {
	                        pitchDir = 1;
	                      } else {
	                        e.preventDefault();
	                        yDir = -1;
	                      }
	                      break;
	                    case 40:
	                      if (e.shiftKey) {
	                        pitchDir = -1;
	                      } else {
	                        e.preventDefault();
	                        yDir = 1;
	                      }
	                      break;
	                    default:
	                      return;
	                  }
	                  return {
	                    cameraAnimation: function(map2) {
	                      var zoom = map2.getZoom();
	                      map2.easeTo({
	                        duration: 300,
	                        easeId: "keyboardHandler",
	                        easing: easeOut,
	                        zoom: zoomDir ? Math.round(zoom) + zoomDir * (e.shiftKey ? 2 : 1) : zoom,
	                        bearing: map2.getBearing() + bearingDir * this$1$1._bearingStep,
	                        pitch: map2.getPitch() + pitchDir * this$1$1._pitchStep,
	                        offset: [
	                          -xDir * this$1$1._panStep,
	                          -yDir * this$1$1._panStep
	                        ],
	                        center: map2.getCenter()
	                      }, { originalEvent: e });
	                    }
	                  };
	                };
	                KeyboardHandler.prototype.enable = function enable() {
	                  this._enabled = true;
	                };
	                KeyboardHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                KeyboardHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                KeyboardHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                function easeOut(t) {
	                  return t * (2 - t);
	                }
	                var wheelZoomDelta = 4.000244140625;
	                var defaultZoomRate = 1 / 100;
	                var wheelZoomRate = 1 / 450;
	                var maxScalePerFrame = 2;
	                var ScrollZoomHandler = function ScrollZoomHandler2(map2, handler) {
	                  this._map = map2;
	                  this._el = map2.getCanvasContainer();
	                  this._handler = handler;
	                  this._delta = 0;
	                  this._defaultZoomRate = defaultZoomRate;
	                  this._wheelZoomRate = wheelZoomRate;
	                  performance2.bindAll([
	                    "_onWheel",
	                    "_onTimeout",
	                    "_onScrollFrame",
	                    "_onScrollFinished"
	                  ], this);
	                };
	                ScrollZoomHandler.prototype.setZoomRate = function setZoomRate(zoomRate) {
	                  this._defaultZoomRate = zoomRate;
	                };
	                ScrollZoomHandler.prototype.setWheelZoomRate = function setWheelZoomRate(wheelZoomRate2) {
	                  this._wheelZoomRate = wheelZoomRate2;
	                };
	                ScrollZoomHandler.prototype.isEnabled = function isEnabled() {
	                  return !!this._enabled;
	                };
	                ScrollZoomHandler.prototype.isActive = function isActive() {
	                  return !!this._active || this._finishTimeout !== undefined;
	                };
	                ScrollZoomHandler.prototype.isZooming = function isZooming() {
	                  return !!this._zooming;
	                };
	                ScrollZoomHandler.prototype.enable = function enable(options) {
	                  if (this.isEnabled()) {
	                    return;
	                  }
	                  this._enabled = true;
	                  this._aroundCenter = options && options.around === "center";
	                };
	                ScrollZoomHandler.prototype.disable = function disable() {
	                  if (!this.isEnabled()) {
	                    return;
	                  }
	                  this._enabled = false;
	                };
	                ScrollZoomHandler.prototype.wheel = function wheel(e) {
	                  if (!this.isEnabled()) {
	                    return;
	                  }
	                  var value = e.deltaMode === performance2.window.WheelEvent.DOM_DELTA_LINE ? e.deltaY * 40 : e.deltaY;
	                  var now = performance2.browser.now(), timeDelta = now - (this._lastWheelEventTime || 0);
	                  this._lastWheelEventTime = now;
	                  if (value !== 0 && value % wheelZoomDelta === 0) {
	                    this._type = "wheel";
	                  } else if (value !== 0 && Math.abs(value) < 4) {
	                    this._type = "trackpad";
	                  } else if (timeDelta > 400) {
	                    this._type = null;
	                    this._lastValue = value;
	                    this._timeout = setTimeout(this._onTimeout, 40, e);
	                  } else if (!this._type) {
	                    this._type = Math.abs(timeDelta * value) < 200 ? "trackpad" : "wheel";
	                    if (this._timeout) {
	                      clearTimeout(this._timeout);
	                      this._timeout = null;
	                      value += this._lastValue;
	                    }
	                  }
	                  if (e.shiftKey && value) {
	                    value = value / 4;
	                  }
	                  if (this._type) {
	                    this._lastWheelEvent = e;
	                    this._delta -= value;
	                    if (!this._active) {
	                      this._start(e);
	                    }
	                  }
	                  e.preventDefault();
	                };
	                ScrollZoomHandler.prototype._onTimeout = function _onTimeout(initialEvent) {
	                  this._type = "wheel";
	                  this._delta -= this._lastValue;
	                  if (!this._active) {
	                    this._start(initialEvent);
	                  }
	                };
	                ScrollZoomHandler.prototype._start = function _start(e) {
	                  if (!this._delta) {
	                    return;
	                  }
	                  if (this._frameId) {
	                    this._frameId = null;
	                  }
	                  this._active = true;
	                  if (!this.isZooming()) {
	                    this._zooming = true;
	                  }
	                  if (this._finishTimeout) {
	                    clearTimeout(this._finishTimeout);
	                    delete this._finishTimeout;
	                  }
	                  var pos = DOM.mousePos(this._el, e);
	                  this._around = performance2.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(pos));
	                  this._aroundPoint = this._map.transform.locationPoint(this._around);
	                  if (!this._frameId) {
	                    this._frameId = true;
	                    this._handler._triggerRenderFrame();
	                  }
	                };
	                ScrollZoomHandler.prototype.renderFrame = function renderFrame() {
	                  return this._onScrollFrame();
	                };
	                ScrollZoomHandler.prototype._onScrollFrame = function _onScrollFrame() {
	                  var this$1$1 = this;
	                  if (!this._frameId) {
	                    return;
	                  }
	                  this._frameId = null;
	                  if (!this.isActive()) {
	                    return;
	                  }
	                  var tr = this._map.transform;
	                  if (this._delta !== 0) {
	                    var zoomRate = this._type === "wheel" && Math.abs(this._delta) > wheelZoomDelta ? this._wheelZoomRate : this._defaultZoomRate;
	                    var scale = maxScalePerFrame / (1 + Math.exp(-Math.abs(this._delta * zoomRate)));
	                    if (this._delta < 0 && scale !== 0) {
	                      scale = 1 / scale;
	                    }
	                    var fromScale = typeof this._targetZoom === "number" ? tr.zoomScale(this._targetZoom) : tr.scale;
	                    this._targetZoom = Math.min(tr.maxZoom, Math.max(tr.minZoom, tr.scaleZoom(fromScale * scale)));
	                    if (this._type === "wheel") {
	                      this._startZoom = tr.zoom;
	                      this._easing = this._smoothOutEasing(200);
	                    }
	                    this._delta = 0;
	                  }
	                  var targetZoom = typeof this._targetZoom === "number" ? this._targetZoom : tr.zoom;
	                  var startZoom = this._startZoom;
	                  var easing = this._easing;
	                  var finished = false;
	                  var zoom;
	                  if (this._type === "wheel" && startZoom && easing) {
	                    var t = Math.min((performance2.browser.now() - this._lastWheelEventTime) / 200, 1);
	                    var k = easing(t);
	                    zoom = performance2.number(startZoom, targetZoom, k);
	                    if (t < 1) {
	                      if (!this._frameId) {
	                        this._frameId = true;
	                      }
	                    } else {
	                      finished = true;
	                    }
	                  } else {
	                    zoom = targetZoom;
	                    finished = true;
	                  }
	                  this._active = true;
	                  if (finished) {
	                    this._active = false;
	                    this._finishTimeout = setTimeout(function() {
	                      this$1$1._zooming = false;
	                      this$1$1._handler._triggerRenderFrame();
	                      delete this$1$1._targetZoom;
	                      delete this$1$1._finishTimeout;
	                    }, 200);
	                  }
	                  return {
	                    noInertia: true,
	                    needsRenderFrame: !finished,
	                    zoomDelta: zoom - tr.zoom,
	                    around: this._aroundPoint,
	                    originalEvent: this._lastWheelEvent
	                  };
	                };
	                ScrollZoomHandler.prototype._smoothOutEasing = function _smoothOutEasing(duration) {
	                  var easing = performance2.ease;
	                  if (this._prevEase) {
	                    var ease = this._prevEase, t = (performance2.browser.now() - ease.start) / ease.duration, speed = ease.easing(t + 0.01) - ease.easing(t), x = 0.27 / Math.sqrt(speed * speed + 1e-4) * 0.01, y = Math.sqrt(0.27 * 0.27 - x * x);
	                    easing = performance2.bezier(x, y, 0.25, 1);
	                  }
	                  this._prevEase = {
	                    start: performance2.browser.now(),
	                    duration,
	                    easing
	                  };
	                  return easing;
	                };
	                ScrollZoomHandler.prototype.reset = function reset() {
	                  this._active = false;
	                };
	                var DoubleClickZoomHandler = function DoubleClickZoomHandler2(clickZoom, TapZoom) {
	                  this._clickZoom = clickZoom;
	                  this._tapZoom = TapZoom;
	                };
	                DoubleClickZoomHandler.prototype.enable = function enable() {
	                  this._clickZoom.enable();
	                  this._tapZoom.enable();
	                };
	                DoubleClickZoomHandler.prototype.disable = function disable() {
	                  this._clickZoom.disable();
	                  this._tapZoom.disable();
	                };
	                DoubleClickZoomHandler.prototype.isEnabled = function isEnabled() {
	                  return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
	                };
	                DoubleClickZoomHandler.prototype.isActive = function isActive() {
	                  return this._clickZoom.isActive() || this._tapZoom.isActive();
	                };
	                var ClickZoomHandler = function ClickZoomHandler2() {
	                  this.reset();
	                };
	                ClickZoomHandler.prototype.reset = function reset() {
	                  this._active = false;
	                };
	                ClickZoomHandler.prototype.dblclick = function dblclick(e, point) {
	                  e.preventDefault();
	                  return {
	                    cameraAnimation: function(map2) {
	                      map2.easeTo({
	                        duration: 300,
	                        zoom: map2.getZoom() + (e.shiftKey ? -1 : 1),
	                        around: map2.unproject(point)
	                      }, { originalEvent: e });
	                    }
	                  };
	                };
	                ClickZoomHandler.prototype.enable = function enable() {
	                  this._enabled = true;
	                };
	                ClickZoomHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                ClickZoomHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                ClickZoomHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                var TapDragZoomHandler = function TapDragZoomHandler2() {
	                  this._tap = new TapRecognizer({
	                    numTouches: 1,
	                    numTaps: 1
	                  });
	                  this.reset();
	                };
	                TapDragZoomHandler.prototype.reset = function reset() {
	                  this._active = false;
	                  delete this._swipePoint;
	                  delete this._swipeTouch;
	                  delete this._tapTime;
	                  this._tap.reset();
	                };
	                TapDragZoomHandler.prototype.touchstart = function touchstart(e, points, mapTouches) {
	                  if (this._swipePoint) {
	                    return;
	                  }
	                  if (this._tapTime && e.timeStamp - this._tapTime > MAX_TAP_INTERVAL) {
	                    this.reset();
	                  }
	                  if (!this._tapTime) {
	                    this._tap.touchstart(e, points, mapTouches);
	                  } else if (mapTouches.length > 0) {
	                    this._swipePoint = points[0];
	                    this._swipeTouch = mapTouches[0].identifier;
	                  }
	                };
	                TapDragZoomHandler.prototype.touchmove = function touchmove(e, points, mapTouches) {
	                  if (!this._tapTime) {
	                    this._tap.touchmove(e, points, mapTouches);
	                  } else if (this._swipePoint) {
	                    if (mapTouches[0].identifier !== this._swipeTouch) {
	                      return;
	                    }
	                    var newSwipePoint = points[0];
	                    var dist = newSwipePoint.y - this._swipePoint.y;
	                    this._swipePoint = newSwipePoint;
	                    e.preventDefault();
	                    this._active = true;
	                    return { zoomDelta: dist / 128 };
	                  }
	                };
	                TapDragZoomHandler.prototype.touchend = function touchend(e, points, mapTouches) {
	                  if (!this._tapTime) {
	                    var point = this._tap.touchend(e, points, mapTouches);
	                    if (point) {
	                      this._tapTime = e.timeStamp;
	                    }
	                  } else if (this._swipePoint) {
	                    if (mapTouches.length === 0) {
	                      this.reset();
	                    }
	                  }
	                };
	                TapDragZoomHandler.prototype.touchcancel = function touchcancel() {
	                  this.reset();
	                };
	                TapDragZoomHandler.prototype.enable = function enable() {
	                  this._enabled = true;
	                };
	                TapDragZoomHandler.prototype.disable = function disable() {
	                  this._enabled = false;
	                  this.reset();
	                };
	                TapDragZoomHandler.prototype.isEnabled = function isEnabled() {
	                  return this._enabled;
	                };
	                TapDragZoomHandler.prototype.isActive = function isActive() {
	                  return this._active;
	                };
	                var DragPanHandler = function DragPanHandler2(el, mousePan, touchPan) {
	                  this._el = el;
	                  this._mousePan = mousePan;
	                  this._touchPan = touchPan;
	                };
	                DragPanHandler.prototype.enable = function enable(options) {
	                  this._inertiaOptions = options || {};
	                  this._mousePan.enable();
	                  this._touchPan.enable();
	                  this._el.classList.add("mapboxgl-touch-drag-pan");
	                };
	                DragPanHandler.prototype.disable = function disable() {
	                  this._mousePan.disable();
	                  this._touchPan.disable();
	                  this._el.classList.remove("mapboxgl-touch-drag-pan");
	                };
	                DragPanHandler.prototype.isEnabled = function isEnabled() {
	                  return this._mousePan.isEnabled() && this._touchPan.isEnabled();
	                };
	                DragPanHandler.prototype.isActive = function isActive() {
	                  return this._mousePan.isActive() || this._touchPan.isActive();
	                };
	                var DragRotateHandler = function DragRotateHandler2(options, mouseRotate, mousePitch) {
	                  this._pitchWithRotate = options.pitchWithRotate;
	                  this._mouseRotate = mouseRotate;
	                  this._mousePitch = mousePitch;
	                };
	                DragRotateHandler.prototype.enable = function enable() {
	                  this._mouseRotate.enable();
	                  if (this._pitchWithRotate) {
	                    this._mousePitch.enable();
	                  }
	                };
	                DragRotateHandler.prototype.disable = function disable() {
	                  this._mouseRotate.disable();
	                  this._mousePitch.disable();
	                };
	                DragRotateHandler.prototype.isEnabled = function isEnabled() {
	                  return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
	                };
	                DragRotateHandler.prototype.isActive = function isActive() {
	                  return this._mouseRotate.isActive() || this._mousePitch.isActive();
	                };
	                var TouchZoomRotateHandler = function TouchZoomRotateHandler2(el, touchZoom, touchRotate, tapDragZoom) {
	                  this._el = el;
	                  this._touchZoom = touchZoom;
	                  this._touchRotate = touchRotate;
	                  this._tapDragZoom = tapDragZoom;
	                  this._rotationDisabled = false;
	                  this._enabled = true;
	                };
	                TouchZoomRotateHandler.prototype.enable = function enable(options) {
	                  this._touchZoom.enable(options);
	                  if (!this._rotationDisabled) {
	                    this._touchRotate.enable(options);
	                  }
	                  this._tapDragZoom.enable();
	                  this._el.classList.add("mapboxgl-touch-zoom-rotate");
	                };
	                TouchZoomRotateHandler.prototype.disable = function disable() {
	                  this._touchZoom.disable();
	                  this._touchRotate.disable();
	                  this._tapDragZoom.disable();
	                  this._el.classList.remove("mapboxgl-touch-zoom-rotate");
	                };
	                TouchZoomRotateHandler.prototype.isEnabled = function isEnabled() {
	                  return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
	                };
	                TouchZoomRotateHandler.prototype.isActive = function isActive() {
	                  return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
	                };
	                TouchZoomRotateHandler.prototype.disableRotation = function disableRotation() {
	                  this._rotationDisabled = true;
	                  this._touchRotate.disable();
	                };
	                TouchZoomRotateHandler.prototype.enableRotation = function enableRotation() {
	                  this._rotationDisabled = false;
	                  if (this._touchZoom.isEnabled()) {
	                    this._touchRotate.enable();
	                  }
	                };
	                var isMoving = function(p) {
	                  return p.zoom || p.drag || p.pitch || p.rotate;
	                };
	                var RenderFrameEvent = function(Event) {
	                  function RenderFrameEvent2() {
	                    Event.apply(this, arguments);
	                  }
	                  if (Event)
	                    RenderFrameEvent2.__proto__ = Event;
	                  RenderFrameEvent2.prototype = Object.create(Event && Event.prototype);
	                  RenderFrameEvent2.prototype.constructor = RenderFrameEvent2;
	                  return RenderFrameEvent2;
	                }(performance2.Event);
	                function hasChange(result) {
	                  return result.panDelta && result.panDelta.mag() || result.zoomDelta || result.bearingDelta || result.pitchDelta;
	                }
	                var HandlerManager = function HandlerManager2(map2, options) {
	                  this._map = map2;
	                  this._el = this._map.getCanvasContainer();
	                  this._handlers = [];
	                  this._handlersById = {};
	                  this._changes = [];
	                  this._inertia = new HandlerInertia(map2);
	                  this._bearingSnap = options.bearingSnap;
	                  this._previousActiveHandlers = {};
	                  this._eventsInProgress = {};
	                  this._addDefaultHandlers(options);
	                  performance2.bindAll([
	                    "handleEvent",
	                    "handleWindowEvent"
	                  ], this);
	                  var el = this._el;
	                  this._listeners = [
	                    [
	                      el,
	                      "touchstart",
	                      { passive: false }
	                    ],
	                    [
	                      el,
	                      "touchmove",
	                      { passive: false }
	                    ],
	                    [
	                      el,
	                      "touchend",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "touchcancel",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "mousedown",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "mousemove",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "mouseup",
	                      undefined
	                    ],
	                    [
	                      performance2.window.document,
	                      "mousemove",
	                      { capture: true }
	                    ],
	                    [
	                      performance2.window.document,
	                      "mouseup",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "mouseover",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "mouseout",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "dblclick",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "click",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "keydown",
	                      { capture: false }
	                    ],
	                    [
	                      el,
	                      "keyup",
	                      undefined
	                    ],
	                    [
	                      el,
	                      "wheel",
	                      { passive: false }
	                    ],
	                    [
	                      el,
	                      "contextmenu",
	                      undefined
	                    ],
	                    [
	                      performance2.window,
	                      "blur",
	                      undefined
	                    ]
	                  ];
	                  for (var i = 0, list = this._listeners; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var target = ref[0];
	                    var type = ref[1];
	                    var listenerOptions = ref[2];
	                    DOM.addEventListener(target, type, target === performance2.window.document ? this.handleWindowEvent : this.handleEvent, listenerOptions);
	                  }
	                };
	                HandlerManager.prototype.destroy = function destroy() {
	                  for (var i = 0, list = this._listeners; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var target = ref[0];
	                    var type = ref[1];
	                    var listenerOptions = ref[2];
	                    DOM.removeEventListener(target, type, target === performance2.window.document ? this.handleWindowEvent : this.handleEvent, listenerOptions);
	                  }
	                };
	                HandlerManager.prototype._addDefaultHandlers = function _addDefaultHandlers(options) {
	                  var map2 = this._map;
	                  var el = map2.getCanvasContainer();
	                  this._add("mapEvent", new MapEventHandler(map2, options));
	                  var boxZoom = map2.boxZoom = new BoxZoomHandler(map2, options);
	                  this._add("boxZoom", boxZoom);
	                  var tapZoom = new TapZoomHandler();
	                  var clickZoom = new ClickZoomHandler();
	                  map2.doubleClickZoom = new DoubleClickZoomHandler(clickZoom, tapZoom);
	                  this._add("tapZoom", tapZoom);
	                  this._add("clickZoom", clickZoom);
	                  var tapDragZoom = new TapDragZoomHandler();
	                  this._add("tapDragZoom", tapDragZoom);
	                  var touchPitch = map2.touchPitch = new TouchPitchHandler();
	                  this._add("touchPitch", touchPitch);
	                  var mouseRotate = new MouseRotateHandler(options);
	                  var mousePitch = new MousePitchHandler(options);
	                  map2.dragRotate = new DragRotateHandler(options, mouseRotate, mousePitch);
	                  this._add("mouseRotate", mouseRotate, ["mousePitch"]);
	                  this._add("mousePitch", mousePitch, ["mouseRotate"]);
	                  var mousePan = new MousePanHandler(options);
	                  var touchPan = new TouchPanHandler(options);
	                  map2.dragPan = new DragPanHandler(el, mousePan, touchPan);
	                  this._add("mousePan", mousePan);
	                  this._add("touchPan", touchPan, [
	                    "touchZoom",
	                    "touchRotate"
	                  ]);
	                  var touchRotate = new TouchRotateHandler();
	                  var touchZoom = new TouchZoomHandler();
	                  map2.touchZoomRotate = new TouchZoomRotateHandler(el, touchZoom, touchRotate, tapDragZoom);
	                  this._add("touchRotate", touchRotate, [
	                    "touchPan",
	                    "touchZoom"
	                  ]);
	                  this._add("touchZoom", touchZoom, [
	                    "touchPan",
	                    "touchRotate"
	                  ]);
	                  var scrollZoom = map2.scrollZoom = new ScrollZoomHandler(map2, this);
	                  this._add("scrollZoom", scrollZoom, ["mousePan"]);
	                  var keyboard = map2.keyboard = new KeyboardHandler();
	                  this._add("keyboard", keyboard);
	                  this._add("blockableMapEvent", new BlockableMapEventHandler(map2));
	                  for (var i = 0, list = [
	                    "boxZoom",
	                    "doubleClickZoom",
	                    "tapDragZoom",
	                    "touchPitch",
	                    "dragRotate",
	                    "dragPan",
	                    "touchZoomRotate",
	                    "scrollZoom",
	                    "keyboard"
	                  ]; i < list.length; i += 1) {
	                    var name2 = list[i];
	                    if (options.interactive && options[name2]) {
	                      map2[name2].enable(options[name2]);
	                    }
	                  }
	                };
	                HandlerManager.prototype._add = function _add(handlerName, handler, allowed) {
	                  this._handlers.push({
	                    handlerName,
	                    handler,
	                    allowed
	                  });
	                  this._handlersById[handlerName] = handler;
	                };
	                HandlerManager.prototype.stop = function stop() {
	                  if (this._updatingCamera) {
	                    return;
	                  }
	                  for (var i = 0, list = this._handlers; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var handler = ref.handler;
	                    handler.reset();
	                  }
	                  this._inertia.clear();
	                  this._fireEvents({}, {});
	                  this._changes = [];
	                };
	                HandlerManager.prototype.isActive = function isActive() {
	                  for (var i = 0, list = this._handlers; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var handler = ref.handler;
	                    if (handler.isActive()) {
	                      return true;
	                    }
	                  }
	                  return false;
	                };
	                HandlerManager.prototype.isZooming = function isZooming() {
	                  return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
	                };
	                HandlerManager.prototype.isRotating = function isRotating() {
	                  return !!this._eventsInProgress.rotate;
	                };
	                HandlerManager.prototype.isMoving = function isMoving$1() {
	                  return Boolean(isMoving(this._eventsInProgress)) || this.isZooming();
	                };
	                HandlerManager.prototype._blockedByActive = function _blockedByActive(activeHandlers, allowed, myName) {
	                  for (var name2 in activeHandlers) {
	                    if (name2 === myName) {
	                      continue;
	                    }
	                    if (!allowed || allowed.indexOf(name2) < 0) {
	                      return true;
	                    }
	                  }
	                  return false;
	                };
	                HandlerManager.prototype.handleWindowEvent = function handleWindowEvent(e) {
	                  this.handleEvent(e, e.type + "Window");
	                };
	                HandlerManager.prototype._getMapTouches = function _getMapTouches(touches) {
	                  var mapTouches = [];
	                  for (var i = 0, list = touches; i < list.length; i += 1) {
	                    var t = list[i];
	                    var target = t.target;
	                    if (this._el.contains(target)) {
	                      mapTouches.push(t);
	                    }
	                  }
	                  return mapTouches;
	                };
	                HandlerManager.prototype.handleEvent = function handleEvent(e, eventName) {
	                  if (e.type === "blur") {
	                    this.stop();
	                    return;
	                  }
	                  this._updatingCamera = true;
	                  var inputEvent = e.type === "renderFrame" ? undefined : e;
	                  var mergedHandlerResult = { needsRenderFrame: false };
	                  var eventsInProgress = {};
	                  var activeHandlers = {};
	                  var mapTouches = e.touches ? this._getMapTouches(e.touches) : undefined;
	                  var points = mapTouches ? DOM.touchPos(this._el, mapTouches) : DOM.mousePos(this._el, e);
	                  for (var i = 0, list = this._handlers; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var handlerName = ref.handlerName;
	                    var handler = ref.handler;
	                    var allowed = ref.allowed;
	                    if (!handler.isEnabled()) {
	                      continue;
	                    }
	                    var data = undefined;
	                    if (this._blockedByActive(activeHandlers, allowed, handlerName)) {
	                      handler.reset();
	                    } else {
	                      if (handler[eventName || e.type]) {
	                        data = handler[eventName || e.type](e, points, mapTouches);
	                        this.mergeHandlerResult(mergedHandlerResult, eventsInProgress, data, handlerName, inputEvent);
	                        if (data && data.needsRenderFrame) {
	                          this._triggerRenderFrame();
	                        }
	                      }
	                    }
	                    if (data || handler.isActive()) {
	                      activeHandlers[handlerName] = handler;
	                    }
	                  }
	                  var deactivatedHandlers = {};
	                  for (var name2 in this._previousActiveHandlers) {
	                    if (!activeHandlers[name2]) {
	                      deactivatedHandlers[name2] = inputEvent;
	                    }
	                  }
	                  this._previousActiveHandlers = activeHandlers;
	                  if (Object.keys(deactivatedHandlers).length || hasChange(mergedHandlerResult)) {
	                    this._changes.push([
	                      mergedHandlerResult,
	                      eventsInProgress,
	                      deactivatedHandlers
	                    ]);
	                    this._triggerRenderFrame();
	                  }
	                  if (Object.keys(activeHandlers).length || hasChange(mergedHandlerResult)) {
	                    this._map._stop(true);
	                  }
	                  this._updatingCamera = false;
	                  var cameraAnimation = mergedHandlerResult.cameraAnimation;
	                  if (cameraAnimation) {
	                    this._inertia.clear();
	                    this._fireEvents({}, {});
	                    this._changes = [];
	                    cameraAnimation(this._map);
	                  }
	                };
	                HandlerManager.prototype.mergeHandlerResult = function mergeHandlerResult(mergedHandlerResult, eventsInProgress, handlerResult, name2, e) {
	                  if (!handlerResult) {
	                    return;
	                  }
	                  performance2.extend(mergedHandlerResult, handlerResult);
	                  var eventData = {
	                    handlerName: name2,
	                    originalEvent: handlerResult.originalEvent || e
	                  };
	                  if (handlerResult.zoomDelta !== undefined) {
	                    eventsInProgress.zoom = eventData;
	                  }
	                  if (handlerResult.panDelta !== undefined) {
	                    eventsInProgress.drag = eventData;
	                  }
	                  if (handlerResult.pitchDelta !== undefined) {
	                    eventsInProgress.pitch = eventData;
	                  }
	                  if (handlerResult.bearingDelta !== undefined) {
	                    eventsInProgress.rotate = eventData;
	                  }
	                };
	                HandlerManager.prototype._applyChanges = function _applyChanges() {
	                  var combined = {};
	                  var combinedEventsInProgress = {};
	                  var combinedDeactivatedHandlers = {};
	                  for (var i = 0, list = this._changes; i < list.length; i += 1) {
	                    var ref = list[i];
	                    var change = ref[0];
	                    var eventsInProgress = ref[1];
	                    var deactivatedHandlers = ref[2];
	                    if (change.panDelta) {
	                      combined.panDelta = (combined.panDelta || new performance2.Point(0, 0))._add(change.panDelta);
	                    }
	                    if (change.zoomDelta) {
	                      combined.zoomDelta = (combined.zoomDelta || 0) + change.zoomDelta;
	                    }
	                    if (change.bearingDelta) {
	                      combined.bearingDelta = (combined.bearingDelta || 0) + change.bearingDelta;
	                    }
	                    if (change.pitchDelta) {
	                      combined.pitchDelta = (combined.pitchDelta || 0) + change.pitchDelta;
	                    }
	                    if (change.around !== undefined) {
	                      combined.around = change.around;
	                    }
	                    if (change.pinchAround !== undefined) {
	                      combined.pinchAround = change.pinchAround;
	                    }
	                    if (change.noInertia) {
	                      combined.noInertia = change.noInertia;
	                    }
	                    performance2.extend(combinedEventsInProgress, eventsInProgress);
	                    performance2.extend(combinedDeactivatedHandlers, deactivatedHandlers);
	                  }
	                  this._updateMapTransform(combined, combinedEventsInProgress, combinedDeactivatedHandlers);
	                  this._changes = [];
	                };
	                HandlerManager.prototype._updateMapTransform = function _updateMapTransform(combinedResult, combinedEventsInProgress, deactivatedHandlers) {
	                  var map2 = this._map;
	                  var tr = map2.transform;
	                  if (!hasChange(combinedResult)) {
	                    return this._fireEvents(combinedEventsInProgress, deactivatedHandlers);
	                  }
	                  var panDelta = combinedResult.panDelta;
	                  var zoomDelta = combinedResult.zoomDelta;
	                  var bearingDelta = combinedResult.bearingDelta;
	                  var pitchDelta = combinedResult.pitchDelta;
	                  var around = combinedResult.around;
	                  var pinchAround = combinedResult.pinchAround;
	                  if (pinchAround !== undefined) {
	                    around = pinchAround;
	                  }
	                  map2._stop(true);
	                  around = around || map2.transform.centerPoint;
	                  var loc = tr.pointLocation(panDelta ? around.sub(panDelta) : around);
	                  if (bearingDelta) {
	                    tr.bearing += bearingDelta;
	                  }
	                  if (pitchDelta) {
	                    tr.pitch += pitchDelta;
	                  }
	                  if (zoomDelta) {
	                    tr.zoom += zoomDelta;
	                  }
	                  tr.setLocationAtPoint(loc, around);
	                  this._map._update();
	                  if (!combinedResult.noInertia) {
	                    this._inertia.record(combinedResult);
	                  }
	                  this._fireEvents(combinedEventsInProgress, deactivatedHandlers);
	                };
	                HandlerManager.prototype._fireEvents = function _fireEvents(newEventsInProgress, deactivatedHandlers) {
	                  var this$1$1 = this;
	                  var wasMoving = isMoving(this._eventsInProgress);
	                  var nowMoving = isMoving(newEventsInProgress);
	                  var startEvents = {};
	                  for (var eventName in newEventsInProgress) {
	                    var ref = newEventsInProgress[eventName];
	                    var originalEvent = ref.originalEvent;
	                    if (!this._eventsInProgress[eventName]) {
	                      startEvents[eventName + "start"] = originalEvent;
	                    }
	                    this._eventsInProgress[eventName] = newEventsInProgress[eventName];
	                  }
	                  if (!wasMoving && nowMoving) {
	                    this._fireEvent("movestart", nowMoving.originalEvent);
	                  }
	                  for (var name2 in startEvents) {
	                    this._fireEvent(name2, startEvents[name2]);
	                  }
	                  if (newEventsInProgress.rotate) {
	                    this._bearingChanged = true;
	                  }
	                  if (nowMoving) {
	                    this._fireEvent("move", nowMoving.originalEvent);
	                  }
	                  for (var eventName$1 in newEventsInProgress) {
	                    var ref$1 = newEventsInProgress[eventName$1];
	                    var originalEvent$1 = ref$1.originalEvent;
	                    this._fireEvent(eventName$1, originalEvent$1);
	                  }
	                  var endEvents = {};
	                  var originalEndEvent;
	                  for (var eventName$2 in this._eventsInProgress) {
	                    var ref$2 = this._eventsInProgress[eventName$2];
	                    var handlerName = ref$2.handlerName;
	                    var originalEvent$2 = ref$2.originalEvent;
	                    if (!this._handlersById[handlerName].isActive()) {
	                      delete this._eventsInProgress[eventName$2];
	                      originalEndEvent = deactivatedHandlers[handlerName] || originalEvent$2;
	                      endEvents[eventName$2 + "end"] = originalEndEvent;
	                    }
	                  }
	                  for (var name$1 in endEvents) {
	                    this._fireEvent(name$1, endEvents[name$1]);
	                  }
	                  var stillMoving = isMoving(this._eventsInProgress);
	                  if ((wasMoving || nowMoving) && !stillMoving) {
	                    this._updatingCamera = true;
	                    var inertialEase = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions);
	                    var shouldSnapToNorth = function(bearing) {
	                      return bearing !== 0 && -this$1$1._bearingSnap < bearing && bearing < this$1$1._bearingSnap;
	                    };
	                    if (inertialEase) {
	                      if (shouldSnapToNorth(inertialEase.bearing || this._map.getBearing())) {
	                        inertialEase.bearing = 0;
	                      }
	                      this._map.easeTo(inertialEase, { originalEvent: originalEndEvent });
	                    } else {
	                      this._map.fire(new performance2.Event("moveend", { originalEvent: originalEndEvent }));
	                      if (shouldSnapToNorth(this._map.getBearing())) {
	                        this._map.resetNorth();
	                      }
	                    }
	                    this._bearingChanged = false;
	                    this._updatingCamera = false;
	                  }
	                };
	                HandlerManager.prototype._fireEvent = function _fireEvent(type, e) {
	                  this._map.fire(new performance2.Event(type, e ? { originalEvent: e } : {}));
	                };
	                HandlerManager.prototype._triggerRenderFrame = function _triggerRenderFrame() {
	                  var this$1$1 = this;
	                  if (this._frameId === undefined) {
	                    this._frameId = this._map._requestRenderFrame(function(timeStamp) {
	                      delete this$1$1._frameId;
	                      this$1$1.handleEvent(new RenderFrameEvent("renderFrame", { timeStamp }));
	                      this$1$1._applyChanges();
	                    });
	                  }
	                };
	                var Camera = function(Evented) {
	                  function Camera2(transform, options) {
	                    Evented.call(this);
	                    this._moving = false;
	                    this._zooming = false;
	                    this.transform = transform;
	                    this._bearingSnap = options.bearingSnap;
	                    performance2.bindAll(["_renderFrameCallback"], this);
	                  }
	                  if (Evented)
	                    Camera2.__proto__ = Evented;
	                  Camera2.prototype = Object.create(Evented && Evented.prototype);
	                  Camera2.prototype.constructor = Camera2;
	                  Camera2.prototype.getCenter = function getCenter() {
	                    return new performance2.LngLat(this.transform.center.lng, this.transform.center.lat);
	                  };
	                  Camera2.prototype.setCenter = function setCenter(center, eventData) {
	                    return this.jumpTo({ center }, eventData);
	                  };
	                  Camera2.prototype.panBy = function panBy(offset, options, eventData) {
	                    offset = performance2.Point.convert(offset).mult(-1);
	                    return this.panTo(this.transform.center, performance2.extend({ offset }, options), eventData);
	                  };
	                  Camera2.prototype.panTo = function panTo(lnglat, options, eventData) {
	                    return this.easeTo(performance2.extend({ center: lnglat }, options), eventData);
	                  };
	                  Camera2.prototype.getZoom = function getZoom() {
	                    return this.transform.zoom;
	                  };
	                  Camera2.prototype.setZoom = function setZoom(zoom, eventData) {
	                    this.jumpTo({ zoom }, eventData);
	                    return this;
	                  };
	                  Camera2.prototype.zoomTo = function zoomTo(zoom, options, eventData) {
	                    return this.easeTo(performance2.extend({ zoom }, options), eventData);
	                  };
	                  Camera2.prototype.zoomIn = function zoomIn(options, eventData) {
	                    this.zoomTo(this.getZoom() + 1, options, eventData);
	                    return this;
	                  };
	                  Camera2.prototype.zoomOut = function zoomOut(options, eventData) {
	                    this.zoomTo(this.getZoom() - 1, options, eventData);
	                    return this;
	                  };
	                  Camera2.prototype.getBearing = function getBearing() {
	                    return this.transform.bearing;
	                  };
	                  Camera2.prototype.setBearing = function setBearing(bearing, eventData) {
	                    this.jumpTo({ bearing }, eventData);
	                    return this;
	                  };
	                  Camera2.prototype.getPadding = function getPadding() {
	                    return this.transform.padding;
	                  };
	                  Camera2.prototype.setPadding = function setPadding(padding2, eventData) {
	                    this.jumpTo({ padding: padding2 }, eventData);
	                    return this;
	                  };
	                  Camera2.prototype.rotateTo = function rotateTo(bearing, options, eventData) {
	                    return this.easeTo(performance2.extend({ bearing }, options), eventData);
	                  };
	                  Camera2.prototype.resetNorth = function resetNorth(options, eventData) {
	                    this.rotateTo(0, performance2.extend({ duration: 1e3 }, options), eventData);
	                    return this;
	                  };
	                  Camera2.prototype.resetNorthPitch = function resetNorthPitch(options, eventData) {
	                    this.easeTo(performance2.extend({
	                      bearing: 0,
	                      pitch: 0,
	                      duration: 1e3
	                    }, options), eventData);
	                    return this;
	                  };
	                  Camera2.prototype.snapToNorth = function snapToNorth(options, eventData) {
	                    if (Math.abs(this.getBearing()) < this._bearingSnap) {
	                      return this.resetNorth(options, eventData);
	                    }
	                    return this;
	                  };
	                  Camera2.prototype.getPitch = function getPitch() {
	                    return this.transform.pitch;
	                  };
	                  Camera2.prototype.setPitch = function setPitch(pitch, eventData) {
	                    this.jumpTo({ pitch }, eventData);
	                    return this;
	                  };
	                  Camera2.prototype.cameraForBounds = function cameraForBounds(bounds, options) {
	                    bounds = performance2.LngLatBounds.convert(bounds);
	                    return this._cameraForBoxAndBearing(bounds.getNorthWest(), bounds.getSouthEast(), 0, options);
	                  };
	                  Camera2.prototype._cameraForBoxAndBearing = function _cameraForBoxAndBearing(p0, p1, bearing, options) {
	                    var defaultPadding = {
	                      top: 0,
	                      bottom: 0,
	                      right: 0,
	                      left: 0
	                    };
	                    options = performance2.extend({
	                      padding: defaultPadding,
	                      offset: [
	                        0,
	                        0
	                      ],
	                      maxZoom: this.transform.maxZoom
	                    }, options);
	                    if (typeof options.padding === "number") {
	                      var p = options.padding;
	                      options.padding = {
	                        top: p,
	                        bottom: p,
	                        right: p,
	                        left: p
	                      };
	                    }
	                    options.padding = performance2.extend(defaultPadding, options.padding);
	                    var tr = this.transform;
	                    var edgePadding = tr.padding;
	                    var p0world = tr.project(performance2.LngLat.convert(p0));
	                    var p1world = tr.project(performance2.LngLat.convert(p1));
	                    var p0rotated = p0world.rotate(-bearing * Math.PI / 180);
	                    var p1rotated = p1world.rotate(-bearing * Math.PI / 180);
	                    var upperRight = new performance2.Point(Math.max(p0rotated.x, p1rotated.x), Math.max(p0rotated.y, p1rotated.y));
	                    var lowerLeft = new performance2.Point(Math.min(p0rotated.x, p1rotated.x), Math.min(p0rotated.y, p1rotated.y));
	                    var size = upperRight.sub(lowerLeft);
	                    var scaleX = (tr.width - (edgePadding.left + edgePadding.right + options.padding.left + options.padding.right)) / size.x;
	                    var scaleY = (tr.height - (edgePadding.top + edgePadding.bottom + options.padding.top + options.padding.bottom)) / size.y;
	                    if (scaleY < 0 || scaleX < 0) {
	                      performance2.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
	                      return;
	                    }
	                    var zoom = Math.min(tr.scaleZoom(tr.scale * Math.min(scaleX, scaleY)), options.maxZoom);
	                    var offset = performance2.Point.convert(options.offset);
	                    var paddingOffsetX = (options.padding.left - options.padding.right) / 2;
	                    var paddingOffsetY = (options.padding.top - options.padding.bottom) / 2;
	                    var offsetAtInitialZoom = new performance2.Point(offset.x + paddingOffsetX, offset.y + paddingOffsetY);
	                    var offsetAtFinalZoom = offsetAtInitialZoom.mult(tr.scale / tr.zoomScale(zoom));
	                    var center = tr.unproject(p0world.add(p1world).div(2).sub(offsetAtFinalZoom));
	                    return {
	                      center,
	                      zoom,
	                      bearing
	                    };
	                  };
	                  Camera2.prototype.fitBounds = function fitBounds(bounds, options, eventData) {
	                    return this._fitInternal(this.cameraForBounds(bounds, options), options, eventData);
	                  };
	                  Camera2.prototype.fitScreenCoordinates = function fitScreenCoordinates(p0, p1, bearing, options, eventData) {
	                    return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(performance2.Point.convert(p0)), this.transform.pointLocation(performance2.Point.convert(p1)), bearing, options), options, eventData);
	                  };
	                  Camera2.prototype._fitInternal = function _fitInternal(calculatedOptions, options, eventData) {
	                    if (!calculatedOptions) {
	                      return this;
	                    }
	                    options = performance2.extend(calculatedOptions, options);
	                    delete options.padding;
	                    return options.linear ? this.easeTo(options, eventData) : this.flyTo(options, eventData);
	                  };
	                  Camera2.prototype.jumpTo = function jumpTo(options, eventData) {
	                    this.stop();
	                    var tr = this.transform;
	                    var zoomChanged = false, bearingChanged = false, pitchChanged = false;
	                    if ("zoom" in options && tr.zoom !== +options.zoom) {
	                      zoomChanged = true;
	                      tr.zoom = +options.zoom;
	                    }
	                    if (options.center !== undefined) {
	                      tr.center = performance2.LngLat.convert(options.center);
	                    }
	                    if ("bearing" in options && tr.bearing !== +options.bearing) {
	                      bearingChanged = true;
	                      tr.bearing = +options.bearing;
	                    }
	                    if ("pitch" in options && tr.pitch !== +options.pitch) {
	                      pitchChanged = true;
	                      tr.pitch = +options.pitch;
	                    }
	                    if (options.padding != null && !tr.isPaddingEqual(options.padding)) {
	                      tr.padding = options.padding;
	                    }
	                    this.fire(new performance2.Event("movestart", eventData)).fire(new performance2.Event("move", eventData));
	                    if (zoomChanged) {
	                      this.fire(new performance2.Event("zoomstart", eventData)).fire(new performance2.Event("zoom", eventData)).fire(new performance2.Event("zoomend", eventData));
	                    }
	                    if (bearingChanged) {
	                      this.fire(new performance2.Event("rotatestart", eventData)).fire(new performance2.Event("rotate", eventData)).fire(new performance2.Event("rotateend", eventData));
	                    }
	                    if (pitchChanged) {
	                      this.fire(new performance2.Event("pitchstart", eventData)).fire(new performance2.Event("pitch", eventData)).fire(new performance2.Event("pitchend", eventData));
	                    }
	                    return this.fire(new performance2.Event("moveend", eventData));
	                  };
	                  Camera2.prototype.easeTo = function easeTo(options, eventData) {
	                    var this$1$1 = this;
	                    this._stop(false, options.easeId);
	                    options = performance2.extend({
	                      offset: [
	                        0,
	                        0
	                      ],
	                      duration: 500,
	                      easing: performance2.ease
	                    }, options);
	                    if (options.animate === false || !options.essential && performance2.browser.prefersReducedMotion) {
	                      options.duration = 0;
	                    }
	                    var tr = this.transform, startZoom = this.getZoom(), startBearing = this.getBearing(), startPitch = this.getPitch(), startPadding = this.getPadding(), zoom = "zoom" in options ? +options.zoom : startZoom, bearing = "bearing" in options ? this._normalizeBearing(options.bearing, startBearing) : startBearing, pitch = "pitch" in options ? +options.pitch : startPitch, padding2 = "padding" in options ? options.padding : tr.padding;
	                    var offsetAsPoint = performance2.Point.convert(options.offset);
	                    var pointAtOffset = tr.centerPoint.add(offsetAsPoint);
	                    var locationAtOffset = tr.pointLocation(pointAtOffset);
	                    var center = performance2.LngLat.convert(options.center || locationAtOffset);
	                    this._normalizeCenter(center);
	                    var from = tr.project(locationAtOffset);
	                    var delta = tr.project(center).sub(from);
	                    var finalScale = tr.zoomScale(zoom - startZoom);
	                    var around, aroundPoint;
	                    if (options.around) {
	                      around = performance2.LngLat.convert(options.around);
	                      aroundPoint = tr.locationPoint(around);
	                    }
	                    var currently = {
	                      moving: this._moving,
	                      zooming: this._zooming,
	                      rotating: this._rotating,
	                      pitching: this._pitching
	                    };
	                    this._zooming = this._zooming || zoom !== startZoom;
	                    this._rotating = this._rotating || startBearing !== bearing;
	                    this._pitching = this._pitching || pitch !== startPitch;
	                    this._padding = !tr.isPaddingEqual(padding2);
	                    this._easeId = options.easeId;
	                    this._prepareEase(eventData, options.noMoveStart, currently);
	                    clearTimeout(this._easeEndTimeoutID);
	                    this._ease(function(k) {
	                      if (this$1$1._zooming) {
	                        tr.zoom = performance2.number(startZoom, zoom, k);
	                      }
	                      if (this$1$1._rotating) {
	                        tr.bearing = performance2.number(startBearing, bearing, k);
	                      }
	                      if (this$1$1._pitching) {
	                        tr.pitch = performance2.number(startPitch, pitch, k);
	                      }
	                      if (this$1$1._padding) {
	                        tr.interpolatePadding(startPadding, padding2, k);
	                        pointAtOffset = tr.centerPoint.add(offsetAsPoint);
	                      }
	                      if (around) {
	                        tr.setLocationAtPoint(around, aroundPoint);
	                      } else {
	                        var scale = tr.zoomScale(tr.zoom - startZoom);
	                        var base = zoom > startZoom ? Math.min(2, finalScale) : Math.max(0.5, finalScale);
	                        var speedup = Math.pow(base, 1 - k);
	                        var newCenter = tr.unproject(from.add(delta.mult(k * speedup)).mult(scale));
	                        tr.setLocationAtPoint(tr.renderWorldCopies ? newCenter.wrap() : newCenter, pointAtOffset);
	                      }
	                      this$1$1._fireMoveEvents(eventData);
	                    }, function(interruptingEaseId) {
	                      this$1$1._afterEase(eventData, interruptingEaseId);
	                    }, options);
	                    return this;
	                  };
	                  Camera2.prototype._prepareEase = function _prepareEase(eventData, noMoveStart, currently) {
	                    if (currently === undefined)
	                      currently = {};
	                    this._moving = true;
	                    if (!noMoveStart && !currently.moving) {
	                      this.fire(new performance2.Event("movestart", eventData));
	                    }
	                    if (this._zooming && !currently.zooming) {
	                      this.fire(new performance2.Event("zoomstart", eventData));
	                    }
	                    if (this._rotating && !currently.rotating) {
	                      this.fire(new performance2.Event("rotatestart", eventData));
	                    }
	                    if (this._pitching && !currently.pitching) {
	                      this.fire(new performance2.Event("pitchstart", eventData));
	                    }
	                  };
	                  Camera2.prototype._fireMoveEvents = function _fireMoveEvents(eventData) {
	                    this.fire(new performance2.Event("move", eventData));
	                    if (this._zooming) {
	                      this.fire(new performance2.Event("zoom", eventData));
	                    }
	                    if (this._rotating) {
	                      this.fire(new performance2.Event("rotate", eventData));
	                    }
	                    if (this._pitching) {
	                      this.fire(new performance2.Event("pitch", eventData));
	                    }
	                  };
	                  Camera2.prototype._afterEase = function _afterEase(eventData, easeId) {
	                    if (this._easeId && easeId && this._easeId === easeId) {
	                      return;
	                    }
	                    delete this._easeId;
	                    var wasZooming = this._zooming;
	                    var wasRotating = this._rotating;
	                    var wasPitching = this._pitching;
	                    this._moving = false;
	                    this._zooming = false;
	                    this._rotating = false;
	                    this._pitching = false;
	                    this._padding = false;
	                    if (wasZooming) {
	                      this.fire(new performance2.Event("zoomend", eventData));
	                    }
	                    if (wasRotating) {
	                      this.fire(new performance2.Event("rotateend", eventData));
	                    }
	                    if (wasPitching) {
	                      this.fire(new performance2.Event("pitchend", eventData));
	                    }
	                    this.fire(new performance2.Event("moveend", eventData));
	                  };
	                  Camera2.prototype.flyTo = function flyTo(options, eventData) {
	                    var this$1$1 = this;
	                    if (!options.essential && performance2.browser.prefersReducedMotion) {
	                      var coercedOptions = performance2.pick(options, [
	                        "center",
	                        "zoom",
	                        "bearing",
	                        "pitch",
	                        "around"
	                      ]);
	                      return this.jumpTo(coercedOptions, eventData);
	                    }
	                    this.stop();
	                    options = performance2.extend({
	                      offset: [
	                        0,
	                        0
	                      ],
	                      speed: 1.2,
	                      curve: 1.42,
	                      easing: performance2.ease
	                    }, options);
	                    var tr = this.transform, startZoom = this.getZoom(), startBearing = this.getBearing(), startPitch = this.getPitch(), startPadding = this.getPadding();
	                    var zoom = "zoom" in options ? performance2.clamp(+options.zoom, tr.minZoom, tr.maxZoom) : startZoom;
	                    var bearing = "bearing" in options ? this._normalizeBearing(options.bearing, startBearing) : startBearing;
	                    var pitch = "pitch" in options ? +options.pitch : startPitch;
	                    var padding2 = "padding" in options ? options.padding : tr.padding;
	                    var scale = tr.zoomScale(zoom - startZoom);
	                    var offsetAsPoint = performance2.Point.convert(options.offset);
	                    var pointAtOffset = tr.centerPoint.add(offsetAsPoint);
	                    var locationAtOffset = tr.pointLocation(pointAtOffset);
	                    var center = performance2.LngLat.convert(options.center || locationAtOffset);
	                    this._normalizeCenter(center);
	                    var from = tr.project(locationAtOffset);
	                    var delta = tr.project(center).sub(from);
	                    var rho = options.curve;
	                    var w0 = Math.max(tr.width, tr.height), w1 = w0 / scale, u1 = delta.mag();
	                    if ("minZoom" in options) {
	                      var minZoom = performance2.clamp(Math.min(options.minZoom, startZoom, zoom), tr.minZoom, tr.maxZoom);
	                      var wMax = w0 / tr.zoomScale(minZoom - startZoom);
	                      rho = Math.sqrt(wMax / u1 * 2);
	                    }
	                    var rho2 = rho * rho;
	                    function r(i) {
	                      var b = (w1 * w1 - w0 * w0 + (i ? -1 : 1) * rho2 * rho2 * u1 * u1) / (2 * (i ? w1 : w0) * rho2 * u1);
	                      return Math.log(Math.sqrt(b * b + 1) - b);
	                    }
	                    function sinh(n) {
	                      return (Math.exp(n) - Math.exp(-n)) / 2;
	                    }
	                    function cosh(n) {
	                      return (Math.exp(n) + Math.exp(-n)) / 2;
	                    }
	                    function tanh(n) {
	                      return sinh(n) / cosh(n);
	                    }
	                    var r0 = r(0);
	                    var w = function(s) {
	                      return cosh(r0) / cosh(r0 + rho * s);
	                    };
	                    var u = function(s) {
	                      return w0 * ((cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2) / u1;
	                    };
	                    var S = (r(1) - r0) / rho;
	                    if (Math.abs(u1) < 1e-6 || !isFinite(S)) {
	                      if (Math.abs(w0 - w1) < 1e-6) {
	                        return this.easeTo(options, eventData);
	                      }
	                      var k = w1 < w0 ? -1 : 1;
	                      S = Math.abs(Math.log(w1 / w0)) / rho;
	                      u = function() {
	                        return 0;
	                      };
	                      w = function(s) {
	                        return Math.exp(k * rho * s);
	                      };
	                    }
	                    if ("duration" in options) {
	                      options.duration = +options.duration;
	                    } else {
	                      var V = "screenSpeed" in options ? +options.screenSpeed / rho : +options.speed;
	                      options.duration = 1e3 * S / V;
	                    }
	                    if (options.maxDuration && options.duration > options.maxDuration) {
	                      options.duration = 0;
	                    }
	                    this._zooming = true;
	                    this._rotating = startBearing !== bearing;
	                    this._pitching = pitch !== startPitch;
	                    this._padding = !tr.isPaddingEqual(padding2);
	                    this._prepareEase(eventData, false);
	                    this._ease(function(k2) {
	                      var s = k2 * S;
	                      var scale2 = 1 / w(s);
	                      tr.zoom = k2 === 1 ? zoom : startZoom + tr.scaleZoom(scale2);
	                      if (this$1$1._rotating) {
	                        tr.bearing = performance2.number(startBearing, bearing, k2);
	                      }
	                      if (this$1$1._pitching) {
	                        tr.pitch = performance2.number(startPitch, pitch, k2);
	                      }
	                      if (this$1$1._padding) {
	                        tr.interpolatePadding(startPadding, padding2, k2);
	                        pointAtOffset = tr.centerPoint.add(offsetAsPoint);
	                      }
	                      var newCenter = k2 === 1 ? center : tr.unproject(from.add(delta.mult(u(s))).mult(scale2));
	                      tr.setLocationAtPoint(tr.renderWorldCopies ? newCenter.wrap() : newCenter, pointAtOffset);
	                      this$1$1._fireMoveEvents(eventData);
	                    }, function() {
	                      return this$1$1._afterEase(eventData);
	                    }, options);
	                    return this;
	                  };
	                  Camera2.prototype.isEasing = function isEasing() {
	                    return !!this._easeFrameId;
	                  };
	                  Camera2.prototype.stop = function stop() {
	                    return this._stop();
	                  };
	                  Camera2.prototype._stop = function _stop(allowGestures, easeId) {
	                    if (this._easeFrameId) {
	                      this._cancelRenderFrame(this._easeFrameId);
	                      delete this._easeFrameId;
	                      delete this._onEaseFrame;
	                    }
	                    if (this._onEaseEnd) {
	                      var onEaseEnd = this._onEaseEnd;
	                      delete this._onEaseEnd;
	                      onEaseEnd.call(this, easeId);
	                    }
	                    if (!allowGestures) {
	                      var handlers = this.handlers;
	                      if (handlers) {
	                        handlers.stop();
	                      }
	                    }
	                    return this;
	                  };
	                  Camera2.prototype._ease = function _ease(frame, finish, options) {
	                    if (options.animate === false || options.duration === 0) {
	                      frame(1);
	                      finish();
	                    } else {
	                      this._easeStart = performance2.browser.now();
	                      this._easeOptions = options;
	                      this._onEaseFrame = frame;
	                      this._onEaseEnd = finish;
	                      this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback);
	                    }
	                  };
	                  Camera2.prototype._renderFrameCallback = function _renderFrameCallback() {
	                    var t = Math.min((performance2.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
	                    this._onEaseFrame(this._easeOptions.easing(t));
	                    if (t < 1) {
	                      this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback);
	                    } else {
	                      this.stop();
	                    }
	                  };
	                  Camera2.prototype._normalizeBearing = function _normalizeBearing(bearing, currentBearing) {
	                    bearing = performance2.wrap(bearing, -180, 180);
	                    var diff = Math.abs(bearing - currentBearing);
	                    if (Math.abs(bearing - 360 - currentBearing) < diff) {
	                      bearing -= 360;
	                    }
	                    if (Math.abs(bearing + 360 - currentBearing) < diff) {
	                      bearing += 360;
	                    }
	                    return bearing;
	                  };
	                  Camera2.prototype._normalizeCenter = function _normalizeCenter(center) {
	                    var tr = this.transform;
	                    if (!tr.renderWorldCopies || tr.lngRange) {
	                      return;
	                    }
	                    var delta = center.lng - tr.center.lng;
	                    center.lng += delta > 180 ? -360 : delta < -180 ? 360 : 0;
	                  };
	                  return Camera2;
	                }(performance2.Evented);
	                var AttributionControl = function AttributionControl2(options) {
	                  if (options === undefined)
	                    options = {};
	                  this.options = options;
	                  performance2.bindAll([
	                    "_updateEditLink",
	                    "_updateData",
	                    "_updateCompact"
	                  ], this);
	                };
	                AttributionControl.prototype.getDefaultPosition = function getDefaultPosition() {
	                  return "bottom-right";
	                };
	                AttributionControl.prototype.onAdd = function onAdd(map2) {
	                  var compact = this.options && this.options.compact;
	                  this._map = map2;
	                  this._container = DOM.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib");
	                  this._innerContainer = DOM.create("div", "mapboxgl-ctrl-attrib-inner", this._container);
	                  if (compact) {
	                    this._container.classList.add("mapboxgl-compact");
	                  }
	                  this._updateAttributions();
	                  this._updateEditLink();
	                  this._map.on("styledata", this._updateData);
	                  this._map.on("sourcedata", this._updateData);
	                  this._map.on("moveend", this._updateEditLink);
	                  if (compact === undefined) {
	                    this._map.on("resize", this._updateCompact);
	                    this._updateCompact();
	                  }
	                  return this._container;
	                };
	                AttributionControl.prototype.onRemove = function onRemove() {
	                  DOM.remove(this._container);
	                  this._map.off("styledata", this._updateData);
	                  this._map.off("sourcedata", this._updateData);
	                  this._map.off("moveend", this._updateEditLink);
	                  this._map.off("resize", this._updateCompact);
	                  this._map = undefined;
	                  this._attribHTML = undefined;
	                };
	                AttributionControl.prototype._updateEditLink = function _updateEditLink() {
	                  var editLink = this._editLink;
	                  if (!editLink) {
	                    editLink = this._editLink = this._container.querySelector(".mapbox-improve-map");
	                  }
	                  var params = [
	                    {
	                      key: "owner",
	                      value: this.styleOwner
	                    },
	                    {
	                      key: "id",
	                      value: this.styleId
	                    },
	                    {
	                      key: "access_token",
	                      value: this._map._requestManager._customAccessToken || performance2.config.ACCESS_TOKEN
	                    }
	                  ];
	                  if (editLink) {
	                    var paramString = params.reduce(function(acc, next, i) {
	                      if (next.value) {
	                        acc += next.key + "=" + next.value + (i < params.length - 1 ? "&" : "");
	                      }
	                      return acc;
	                    }, "?");
	                    editLink.href = performance2.config.FEEDBACK_URL + "/" + paramString + (this._map._hash ? this._map._hash.getHashString(true) : "");
	                    editLink.rel = "noopener nofollow";
	                  }
	                };
	                AttributionControl.prototype._updateData = function _updateData(e) {
	                  if (e && (e.sourceDataType === "metadata" || e.dataType === "style")) {
	                    this._updateAttributions();
	                    this._updateEditLink();
	                  }
	                };
	                AttributionControl.prototype._updateAttributions = function _updateAttributions() {
	                  if (!this._map.style) {
	                    return;
	                  }
	                  var attributions = [];
	                  if (this.options.customAttribution) {
	                    if (Array.isArray(this.options.customAttribution)) {
	                      attributions = attributions.concat(this.options.customAttribution.map(function(attribution) {
	                        if (typeof attribution !== "string") {
	                          return "";
	                        }
	                        return attribution;
	                      }));
	                    } else if (typeof this.options.customAttribution === "string") {
	                      attributions.push(this.options.customAttribution);
	                    }
	                  }
	                  if (this._map.style.stylesheet) {
	                    var stylesheet = this._map.style.stylesheet;
	                    this.styleOwner = stylesheet.owner;
	                    this.styleId = stylesheet.id;
	                  }
	                  var sourceCaches = this._map.style.sourceCaches;
	                  for (var id in sourceCaches) {
	                    var sourceCache = sourceCaches[id];
	                    if (sourceCache.used) {
	                      var source = sourceCache.getSource();
	                      if (source.attribution && attributions.indexOf(source.attribution) < 0) {
	                        attributions.push(source.attribution);
	                      }
	                    }
	                  }
	                  attributions.sort(function(a, b) {
	                    return a.length - b.length;
	                  });
	                  attributions = attributions.filter(function(attrib, i) {
	                    for (var j = i + 1; j < attributions.length; j++) {
	                      if (attributions[j].indexOf(attrib) >= 0) {
	                        return false;
	                      }
	                    }
	                    return true;
	                  });
	                  var attribHTML = attributions.join(" | ");
	                  if (attribHTML === this._attribHTML) {
	                    return;
	                  }
	                  this._attribHTML = attribHTML;
	                  if (attributions.length) {
	                    this._innerContainer.innerHTML = attribHTML;
	                    this._container.classList.remove("mapboxgl-attrib-empty");
	                  } else {
	                    this._container.classList.add("mapboxgl-attrib-empty");
	                  }
	                  this._editLink = null;
	                };
	                AttributionControl.prototype._updateCompact = function _updateCompact() {
	                  if (this._map.getCanvasContainer().offsetWidth <= 640) {
	                    this._container.classList.add("mapboxgl-compact");
	                  } else {
	                    this._container.classList.remove("mapboxgl-compact");
	                  }
	                };
	                var LogoControl = function LogoControl2() {
	                  performance2.bindAll(["_updateLogo"], this);
	                  performance2.bindAll(["_updateCompact"], this);
	                };
	                LogoControl.prototype.onAdd = function onAdd(map2) {
	                  this._map = map2;
	                  this._container = DOM.create("div", "mapboxgl-ctrl");
	                  var anchor = DOM.create("a", "mapboxgl-ctrl-logo");
	                  anchor.target = "_blank";
	                  anchor.rel = "noopener nofollow";
	                  anchor.href = "https://www.mapbox.com/";
	                  anchor.setAttribute("aria-label", this._map._getUIString("LogoControl.Title"));
	                  anchor.setAttribute("rel", "noopener nofollow");
	                  this._container.appendChild(anchor);
	                  this._container.style.display = "none";
	                  this._map.on("sourcedata", this._updateLogo);
	                  this._updateLogo();
	                  this._map.on("resize", this._updateCompact);
	                  this._updateCompact();
	                  return this._container;
	                };
	                LogoControl.prototype.onRemove = function onRemove() {
	                  DOM.remove(this._container);
	                  this._map.off("sourcedata", this._updateLogo);
	                  this._map.off("resize", this._updateCompact);
	                };
	                LogoControl.prototype.getDefaultPosition = function getDefaultPosition() {
	                  return "bottom-left";
	                };
	                LogoControl.prototype._updateLogo = function _updateLogo(e) {
	                  if (!e || e.sourceDataType === "metadata") {
	                    this._container.style.display = this._logoRequired() ? "block" : "none";
	                  }
	                };
	                LogoControl.prototype._logoRequired = function _logoRequired() {
	                  if (!this._map.style) {
	                    return;
	                  }
	                  var sourceCaches = this._map.style.sourceCaches;
	                  for (var id in sourceCaches) {
	                    var source = sourceCaches[id].getSource();
	                    if (source.mapbox_logo) {
	                      return true;
	                    }
	                  }
	                  return false;
	                };
	                LogoControl.prototype._updateCompact = function _updateCompact() {
	                  var containerChildren = this._container.children;
	                  if (containerChildren.length) {
	                    var anchor = containerChildren[0];
	                    if (this._map.getCanvasContainer().offsetWidth < 250) {
	                      anchor.classList.add("mapboxgl-compact");
	                    } else {
	                      anchor.classList.remove("mapboxgl-compact");
	                    }
	                  }
	                };
	                var TaskQueue = function TaskQueue2() {
	                  this._queue = [];
	                  this._id = 0;
	                  this._cleared = false;
	                  this._currentlyRunning = false;
	                };
	                TaskQueue.prototype.add = function add(callback) {
	                  var id = ++this._id;
	                  var queue = this._queue;
	                  queue.push({
	                    callback,
	                    id,
	                    cancelled: false
	                  });
	                  return id;
	                };
	                TaskQueue.prototype.remove = function remove(id) {
	                  var running = this._currentlyRunning;
	                  var queue = running ? this._queue.concat(running) : this._queue;
	                  for (var i = 0, list = queue; i < list.length; i += 1) {
	                    var task = list[i];
	                    if (task.id === id) {
	                      task.cancelled = true;
	                      return;
	                    }
	                  }
	                };
	                TaskQueue.prototype.run = function run(timeStamp) {
	                  if (timeStamp === undefined)
	                    timeStamp = 0;
	                  var queue = this._currentlyRunning = this._queue;
	                  this._queue = [];
	                  for (var i = 0, list = queue; i < list.length; i += 1) {
	                    var task = list[i];
	                    if (task.cancelled) {
	                      continue;
	                    }
	                    task.callback(timeStamp);
	                    if (this._cleared) {
	                      break;
	                    }
	                  }
	                  this._cleared = false;
	                  this._currentlyRunning = false;
	                };
	                TaskQueue.prototype.clear = function clear() {
	                  if (this._currentlyRunning) {
	                    this._cleared = true;
	                  }
	                  this._queue = [];
	                };
	                var defaultLocale = {
	                  "FullscreenControl.Enter": "Enter fullscreen",
	                  "FullscreenControl.Exit": "Exit fullscreen",
	                  "GeolocateControl.FindMyLocation": "Find my location",
	                  "GeolocateControl.LocationNotAvailable": "Location not available",
	                  "LogoControl.Title": "Mapbox logo",
	                  "NavigationControl.ResetBearing": "Reset bearing to north",
	                  "NavigationControl.ZoomIn": "Zoom in",
	                  "NavigationControl.ZoomOut": "Zoom out",
	                  "ScaleControl.Feet": "ft",
	                  "ScaleControl.Meters": "m",
	                  "ScaleControl.Kilometers": "km",
	                  "ScaleControl.Miles": "mi",
	                  "ScaleControl.NauticalMiles": "nm"
	                };
	                var HTMLImageElement2 = performance2.window.HTMLImageElement;
	                var HTMLElement2 = performance2.window.HTMLElement;
	                var ImageBitmap = performance2.window.ImageBitmap;
	                var defaultMinZoom = -2;
	                var defaultMaxZoom = 22;
	                var defaultMinPitch = 0;
	                var defaultMaxPitch = 60;
	                var defaultOptions$1 = {
	                  center: [
	                    0,
	                    0
	                  ],
	                  zoom: 0,
	                  bearing: 0,
	                  pitch: 0,
	                  minZoom: defaultMinZoom,
	                  maxZoom: defaultMaxZoom,
	                  minPitch: defaultMinPitch,
	                  maxPitch: defaultMaxPitch,
	                  interactive: true,
	                  scrollZoom: true,
	                  boxZoom: true,
	                  dragRotate: true,
	                  dragPan: true,
	                  keyboard: true,
	                  doubleClickZoom: true,
	                  touchZoomRotate: true,
	                  touchPitch: true,
	                  bearingSnap: 7,
	                  clickTolerance: 3,
	                  pitchWithRotate: true,
	                  hash: false,
	                  attributionControl: true,
	                  failIfMajorPerformanceCaveat: false,
	                  preserveDrawingBuffer: false,
	                  trackResize: true,
	                  renderWorldCopies: true,
	                  refreshExpiredTiles: true,
	                  maxTileCacheSize: null,
	                  localIdeographFontFamily: "sans-serif",
	                  transformRequest: null,
	                  accessToken: null,
	                  fadeDuration: 300,
	                  crossSourceCollisions: true
	                };
	                var Map2 = function(Camera2) {
	                  function Map3(options) {
	                    var this$1$1 = this;
	                    options = performance2.extend({}, defaultOptions$1, options);
	                    if (options.minZoom != null && options.maxZoom != null && options.minZoom > options.maxZoom) {
	                      throw new Error("maxZoom must be greater than or equal to minZoom");
	                    }
	                    if (options.minPitch != null && options.maxPitch != null && options.minPitch > options.maxPitch) {
	                      throw new Error("maxPitch must be greater than or equal to minPitch");
	                    }
	                    if (options.minPitch != null && options.minPitch < defaultMinPitch) {
	                      throw new Error("minPitch must be greater than or equal to " + defaultMinPitch);
	                    }
	                    if (options.maxPitch != null && options.maxPitch > defaultMaxPitch) {
	                      throw new Error("maxPitch must be less than or equal to " + defaultMaxPitch);
	                    }
	                    var transform = new Transform(options.minZoom, options.maxZoom, options.minPitch, options.maxPitch, options.renderWorldCopies);
	                    Camera2.call(this, transform, options);
	                    this._interactive = options.interactive;
	                    this._maxTileCacheSize = options.maxTileCacheSize;
	                    this._failIfMajorPerformanceCaveat = options.failIfMajorPerformanceCaveat;
	                    this._preserveDrawingBuffer = options.preserveDrawingBuffer;
	                    this._antialias = options.antialias;
	                    this._trackResize = options.trackResize;
	                    this._bearingSnap = options.bearingSnap;
	                    this._refreshExpiredTiles = options.refreshExpiredTiles;
	                    this._fadeDuration = options.fadeDuration;
	                    this._crossSourceCollisions = options.crossSourceCollisions;
	                    this._crossFadingFactor = 1;
	                    this._collectResourceTiming = options.collectResourceTiming;
	                    this._renderTaskQueue = new TaskQueue();
	                    this._controls = [];
	                    this._mapId = performance2.uniqueId();
	                    this._locale = performance2.extend({}, defaultLocale, options.locale);
	                    this._requestManager = new performance2.RequestManager(options.transformRequest, options.accessToken);
	                    if (typeof options.container === "string") {
	                      this._container = performance2.window.document.getElementById(options.container);
	                      if (!this._container) {
	                        throw new Error("Container '" + options.container + "' not found.");
	                      }
	                    } else if (options.container instanceof HTMLElement2) {
	                      this._container = options.container;
	                    } else {
	                      throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
	                    }
	                    if (options.maxBounds) {
	                      this.setMaxBounds(options.maxBounds);
	                    }
	                    performance2.bindAll([
	                      "_onWindowOnline",
	                      "_onWindowResize",
	                      "_contextLost",
	                      "_contextRestored"
	                    ], this);
	                    this._setupContainer();
	                    this._setupPainter();
	                    if (this.painter === undefined) {
	                      throw new Error("Failed to initialize WebGL.");
	                    }
	                    this.on("move", function() {
	                      return this$1$1._update(false);
	                    });
	                    this.on("moveend", function() {
	                      return this$1$1._update(false);
	                    });
	                    this.on("zoom", function() {
	                      return this$1$1._update(true);
	                    });
	                    if (typeof performance2.window !== "undefined") {
	                      performance2.window.addEventListener("online", this._onWindowOnline, false);
	                      performance2.window.addEventListener("resize", this._onWindowResize, false);
	                    }
	                    this.handlers = new HandlerManager(this, options);
	                    var hashName = typeof options.hash === "string" && options.hash || undefined;
	                    this._hash = options.hash && new Hash(hashName).addTo(this);
	                    if (!this._hash || !this._hash._onHashChange()) {
	                      this.jumpTo({
	                        center: options.center,
	                        zoom: options.zoom,
	                        bearing: options.bearing,
	                        pitch: options.pitch
	                      });
	                      if (options.bounds) {
	                        this.resize();
	                        this.fitBounds(options.bounds, performance2.extend({}, options.fitBoundsOptions, { duration: 0 }));
	                      }
	                    }
	                    this.resize();
	                    this._localIdeographFontFamily = options.localIdeographFontFamily;
	                    if (options.style) {
	                      this.setStyle(options.style, { localIdeographFontFamily: options.localIdeographFontFamily });
	                    }
	                    if (options.attributionControl) {
	                      this.addControl(new AttributionControl({ customAttribution: options.customAttribution }));
	                    }
	                    this.addControl(new LogoControl(), options.logoPosition);
	                    this.on("style.load", function() {
	                      if (this$1$1.transform.unmodified) {
	                        this$1$1.jumpTo(this$1$1.style.stylesheet);
	                      }
	                    });
	                    this.on("data", function(event) {
	                      this$1$1._update(event.dataType === "style");
	                      this$1$1.fire(new performance2.Event(event.dataType + "data", event));
	                    });
	                    this.on("dataloading", function(event) {
	                      this$1$1.fire(new performance2.Event(event.dataType + "dataloading", event));
	                    });
	                  }
	                  Map3.__proto__ = Camera2;
	                  Map3.prototype = Object.create(Camera2.prototype);
	                  Map3.prototype.constructor = Map3;
	                  var prototypeAccessors2 = {
	                    showTileBoundaries: { configurable: true },
	                    showPadding: { configurable: true },
	                    showCollisionBoxes: { configurable: true },
	                    showOverdrawInspector: { configurable: true },
	                    repaint: { configurable: true },
	                    vertices: { configurable: true },
	                    version: { configurable: true }
	                  };
	                  Map3.prototype._getMapId = function _getMapId() {
	                    return this._mapId;
	                  };
	                  Map3.prototype.addControl = function addControl(control, position) {
	                    if (position === undefined && control.getDefaultPosition) {
	                      position = control.getDefaultPosition();
	                    }
	                    if (position === undefined) {
	                      position = "top-right";
	                    }
	                    if (!control || !control.onAdd) {
	                      return this.fire(new performance2.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
	                    }
	                    var controlElement = control.onAdd(this);
	                    this._controls.push(control);
	                    var positionContainer = this._controlPositions[position];
	                    if (position.indexOf("bottom") !== -1) {
	                      positionContainer.insertBefore(controlElement, positionContainer.firstChild);
	                    } else {
	                      positionContainer.appendChild(controlElement);
	                    }
	                    return this;
	                  };
	                  Map3.prototype.removeControl = function removeControl(control) {
	                    if (!control || !control.onRemove) {
	                      return this.fire(new performance2.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
	                    }
	                    var ci = this._controls.indexOf(control);
	                    if (ci > -1) {
	                      this._controls.splice(ci, 1);
	                    }
	                    control.onRemove(this);
	                    return this;
	                  };
	                  Map3.prototype.resize = function resize(eventData) {
	                    var dimensions = this._containerDimensions();
	                    var width = dimensions[0];
	                    var height = dimensions[1];
	                    this._resizeCanvas(width, height);
	                    this.transform.resize(width, height);
	                    this.painter.resize(width, height);
	                    var fireMoving = !this._moving;
	                    if (fireMoving) {
	                      this.stop();
	                      this.fire(new performance2.Event("movestart", eventData)).fire(new performance2.Event("move", eventData));
	                    }
	                    this.fire(new performance2.Event("resize", eventData));
	                    if (fireMoving) {
	                      this.fire(new performance2.Event("moveend", eventData));
	                    }
	                    return this;
	                  };
	                  Map3.prototype.getBounds = function getBounds() {
	                    return this.transform.getBounds();
	                  };
	                  Map3.prototype.getMaxBounds = function getMaxBounds() {
	                    return this.transform.getMaxBounds();
	                  };
	                  Map3.prototype.setMaxBounds = function setMaxBounds(bounds) {
	                    this.transform.setMaxBounds(performance2.LngLatBounds.convert(bounds));
	                    return this._update();
	                  };
	                  Map3.prototype.setMinZoom = function setMinZoom(minZoom) {
	                    minZoom = minZoom === null || minZoom === undefined ? defaultMinZoom : minZoom;
	                    if (minZoom >= defaultMinZoom && minZoom <= this.transform.maxZoom) {
	                      this.transform.minZoom = minZoom;
	                      this._update();
	                      if (this.getZoom() < minZoom) {
	                        this.setZoom(minZoom);
	                      }
	                      return this;
	                    } else {
	                      throw new Error("minZoom must be between " + defaultMinZoom + " and the current maxZoom, inclusive");
	                    }
	                  };
	                  Map3.prototype.getMinZoom = function getMinZoom() {
	                    return this.transform.minZoom;
	                  };
	                  Map3.prototype.setMaxZoom = function setMaxZoom(maxZoom) {
	                    maxZoom = maxZoom === null || maxZoom === undefined ? defaultMaxZoom : maxZoom;
	                    if (maxZoom >= this.transform.minZoom) {
	                      this.transform.maxZoom = maxZoom;
	                      this._update();
	                      if (this.getZoom() > maxZoom) {
	                        this.setZoom(maxZoom);
	                      }
	                      return this;
	                    } else {
	                      throw new Error("maxZoom must be greater than the current minZoom");
	                    }
	                  };
	                  Map3.prototype.getMaxZoom = function getMaxZoom() {
	                    return this.transform.maxZoom;
	                  };
	                  Map3.prototype.setMinPitch = function setMinPitch(minPitch) {
	                    minPitch = minPitch === null || minPitch === undefined ? defaultMinPitch : minPitch;
	                    if (minPitch < defaultMinPitch) {
	                      throw new Error("minPitch must be greater than or equal to " + defaultMinPitch);
	                    }
	                    if (minPitch >= defaultMinPitch && minPitch <= this.transform.maxPitch) {
	                      this.transform.minPitch = minPitch;
	                      this._update();
	                      if (this.getPitch() < minPitch) {
	                        this.setPitch(minPitch);
	                      }
	                      return this;
	                    } else {
	                      throw new Error("minPitch must be between " + defaultMinPitch + " and the current maxPitch, inclusive");
	                    }
	                  };
	                  Map3.prototype.getMinPitch = function getMinPitch() {
	                    return this.transform.minPitch;
	                  };
	                  Map3.prototype.setMaxPitch = function setMaxPitch(maxPitch) {
	                    maxPitch = maxPitch === null || maxPitch === undefined ? defaultMaxPitch : maxPitch;
	                    if (maxPitch > defaultMaxPitch) {
	                      throw new Error("maxPitch must be less than or equal to " + defaultMaxPitch);
	                    }
	                    if (maxPitch >= this.transform.minPitch) {
	                      this.transform.maxPitch = maxPitch;
	                      this._update();
	                      if (this.getPitch() > maxPitch) {
	                        this.setPitch(maxPitch);
	                      }
	                      return this;
	                    } else {
	                      throw new Error("maxPitch must be greater than the current minPitch");
	                    }
	                  };
	                  Map3.prototype.getMaxPitch = function getMaxPitch() {
	                    return this.transform.maxPitch;
	                  };
	                  Map3.prototype.getRenderWorldCopies = function getRenderWorldCopies() {
	                    return this.transform.renderWorldCopies;
	                  };
	                  Map3.prototype.setRenderWorldCopies = function setRenderWorldCopies(renderWorldCopies) {
	                    this.transform.renderWorldCopies = renderWorldCopies;
	                    return this._update();
	                  };
	                  Map3.prototype.project = function project2(lnglat) {
	                    return this.transform.locationPoint(performance2.LngLat.convert(lnglat));
	                  };
	                  Map3.prototype.unproject = function unproject(point) {
	                    return this.transform.pointLocation(performance2.Point.convert(point));
	                  };
	                  Map3.prototype.isMoving = function isMoving2() {
	                    return this._moving || this.handlers.isMoving();
	                  };
	                  Map3.prototype.isZooming = function isZooming() {
	                    return this._zooming || this.handlers.isZooming();
	                  };
	                  Map3.prototype.isRotating = function isRotating() {
	                    return this._rotating || this.handlers.isRotating();
	                  };
	                  Map3.prototype._createDelegatedListener = function _createDelegatedListener(type, layerId, listener) {
	                    var this$1$1 = this;
	                    var obj;
	                    if (type === "mouseenter" || type === "mouseover") {
	                      var mousein = false;
	                      var mousemove = function(e) {
	                        var features = this$1$1.getLayer(layerId) ? this$1$1.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
	                        if (!features.length) {
	                          mousein = false;
	                        } else if (!mousein) {
	                          mousein = true;
	                          listener.call(this$1$1, new MapMouseEvent(type, this$1$1, e.originalEvent, { features }));
	                        }
	                      };
	                      var mouseout = function() {
	                        mousein = false;
	                      };
	                      return {
	                        layer: layerId,
	                        listener,
	                        delegates: {
	                          mousemove,
	                          mouseout
	                        }
	                      };
	                    } else if (type === "mouseleave" || type === "mouseout") {
	                      var mousein$1 = false;
	                      var mousemove$1 = function(e) {
	                        var features = this$1$1.getLayer(layerId) ? this$1$1.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
	                        if (features.length) {
	                          mousein$1 = true;
	                        } else if (mousein$1) {
	                          mousein$1 = false;
	                          listener.call(this$1$1, new MapMouseEvent(type, this$1$1, e.originalEvent));
	                        }
	                      };
	                      var mouseout$1 = function(e) {
	                        if (mousein$1) {
	                          mousein$1 = false;
	                          listener.call(this$1$1, new MapMouseEvent(type, this$1$1, e.originalEvent));
	                        }
	                      };
	                      return {
	                        layer: layerId,
	                        listener,
	                        delegates: {
	                          mousemove: mousemove$1,
	                          mouseout: mouseout$1
	                        }
	                      };
	                    } else {
	                      var delegate = function(e) {
	                        var features = this$1$1.getLayer(layerId) ? this$1$1.queryRenderedFeatures(e.point, { layers: [layerId] }) : [];
	                        if (features.length) {
	                          e.features = features;
	                          listener.call(this$1$1, e);
	                          delete e.features;
	                        }
	                      };
	                      return {
	                        layer: layerId,
	                        listener,
	                        delegates: (obj = {}, obj[type] = delegate, obj)
	                      };
	                    }
	                  };
	                  Map3.prototype.on = function on(type, layerId, listener) {
	                    if (listener === undefined) {
	                      return Camera2.prototype.on.call(this, type, layerId);
	                    }
	                    var delegatedListener = this._createDelegatedListener(type, layerId, listener);
	                    this._delegatedListeners = this._delegatedListeners || {};
	                    this._delegatedListeners[type] = this._delegatedListeners[type] || [];
	                    this._delegatedListeners[type].push(delegatedListener);
	                    for (var event in delegatedListener.delegates) {
	                      this.on(event, delegatedListener.delegates[event]);
	                    }
	                    return this;
	                  };
	                  Map3.prototype.once = function once(type, layerId, listener) {
	                    if (listener === undefined) {
	                      return Camera2.prototype.once.call(this, type, layerId);
	                    }
	                    var delegatedListener = this._createDelegatedListener(type, layerId, listener);
	                    for (var event in delegatedListener.delegates) {
	                      this.once(event, delegatedListener.delegates[event]);
	                    }
	                    return this;
	                  };
	                  Map3.prototype.off = function off(type, layerId, listener) {
	                    var this$1$1 = this;
	                    if (listener === undefined) {
	                      return Camera2.prototype.off.call(this, type, layerId);
	                    }
	                    var removeDelegatedListener = function(delegatedListeners) {
	                      var listeners = delegatedListeners[type];
	                      for (var i = 0; i < listeners.length; i++) {
	                        var delegatedListener = listeners[i];
	                        if (delegatedListener.layer === layerId && delegatedListener.listener === listener) {
	                          for (var event in delegatedListener.delegates) {
	                            this$1$1.off(event, delegatedListener.delegates[event]);
	                          }
	                          listeners.splice(i, 1);
	                          return this$1$1;
	                        }
	                      }
	                    };
	                    if (this._delegatedListeners && this._delegatedListeners[type]) {
	                      removeDelegatedListener(this._delegatedListeners);
	                    }
	                    return this;
	                  };
	                  Map3.prototype.queryRenderedFeatures = function queryRenderedFeatures2(geometry, options) {
	                    if (!this.style) {
	                      return [];
	                    }
	                    if (options === undefined && geometry !== undefined && !(geometry instanceof performance2.Point) && !Array.isArray(geometry)) {
	                      options = geometry;
	                      geometry = undefined;
	                    }
	                    options = options || {};
	                    geometry = geometry || [
	                      [
	                        0,
	                        0
	                      ],
	                      [
	                        this.transform.width,
	                        this.transform.height
	                      ]
	                    ];
	                    var queryGeometry;
	                    if (geometry instanceof performance2.Point || typeof geometry[0] === "number") {
	                      queryGeometry = [performance2.Point.convert(geometry)];
	                    } else {
	                      var tl = performance2.Point.convert(geometry[0]);
	                      var br = performance2.Point.convert(geometry[1]);
	                      queryGeometry = [
	                        tl,
	                        new performance2.Point(br.x, tl.y),
	                        br,
	                        new performance2.Point(tl.x, br.y),
	                        tl
	                      ];
	                    }
	                    return this.style.queryRenderedFeatures(queryGeometry, options, this.transform);
	                  };
	                  Map3.prototype.querySourceFeatures = function querySourceFeatures2(sourceId, parameters) {
	                    return this.style.querySourceFeatures(sourceId, parameters);
	                  };
	                  Map3.prototype.setStyle = function setStyle(style, options) {
	                    options = performance2.extend({}, { localIdeographFontFamily: this._localIdeographFontFamily }, options);
	                    if (options.diff !== false && options.localIdeographFontFamily === this._localIdeographFontFamily && this.style && style) {
	                      this._diffStyle(style, options);
	                      return this;
	                    } else {
	                      this._localIdeographFontFamily = options.localIdeographFontFamily;
	                      return this._updateStyle(style, options);
	                    }
	                  };
	                  Map3.prototype._getUIString = function _getUIString(key) {
	                    var str = this._locale[key];
	                    if (str == null) {
	                      throw new Error("Missing UI string '" + key + "'");
	                    }
	                    return str;
	                  };
	                  Map3.prototype._updateStyle = function _updateStyle(style, options) {
	                    if (this.style) {
	                      this.style.setEventedParent(null);
	                      this.style._remove();
	                    }
	                    if (!style) {
	                      delete this.style;
	                      return this;
	                    } else {
	                      this.style = new Style(this, options || {});
	                    }
	                    this.style.setEventedParent(this, { style: this.style });
	                    if (typeof style === "string") {
	                      this.style.loadURL(style);
	                    } else {
	                      this.style.loadJSON(style);
	                    }
	                    return this;
	                  };
	                  Map3.prototype._lazyInitEmptyStyle = function _lazyInitEmptyStyle() {
	                    if (!this.style) {
	                      this.style = new Style(this, {});
	                      this.style.setEventedParent(this, { style: this.style });
	                      this.style.loadEmpty();
	                    }
	                  };
	                  Map3.prototype._diffStyle = function _diffStyle(style, options) {
	                    var this$1$1 = this;
	                    if (typeof style === "string") {
	                      var url = this._requestManager.normalizeStyleURL(style);
	                      var request = this._requestManager.transformRequest(url, performance2.ResourceType.Style);
	                      performance2.getJSON(request, function(error, json) {
	                        if (error) {
	                          this$1$1.fire(new performance2.ErrorEvent(error));
	                        } else if (json) {
	                          this$1$1._updateDiff(json, options);
	                        }
	                      });
	                    } else if (typeof style === "object") {
	                      this._updateDiff(style, options);
	                    }
	                  };
	                  Map3.prototype._updateDiff = function _updateDiff(style, options) {
	                    try {
	                      if (this.style.setState(style)) {
	                        this._update(true);
	                      }
	                    } catch (e) {
	                      performance2.warnOnce("Unable to perform style diff: " + (e.message || e.error || e) + ".  Rebuilding the style from scratch.");
	                      this._updateStyle(style, options);
	                    }
	                  };
	                  Map3.prototype.getStyle = function getStyle() {
	                    if (this.style) {
	                      return this.style.serialize();
	                    }
	                  };
	                  Map3.prototype.isStyleLoaded = function isStyleLoaded() {
	                    if (!this.style) {
	                      return performance2.warnOnce("There is no style added to the map.");
	                    }
	                    return this.style.loaded();
	                  };
	                  Map3.prototype.addSource = function addSource2(id, source) {
	                    this._lazyInitEmptyStyle();
	                    this.style.addSource(id, source);
	                    return this._update(true);
	                  };
	                  Map3.prototype.isSourceLoaded = function isSourceLoaded(id) {
	                    var source = this.style && this.style.sourceCaches[id];
	                    if (source === undefined) {
	                      this.fire(new performance2.ErrorEvent(new Error("There is no source with ID '" + id + "'")));
	                      return;
	                    }
	                    return source.loaded();
	                  };
	                  Map3.prototype.areTilesLoaded = function areTilesLoaded() {
	                    var sources = this.style && this.style.sourceCaches;
	                    for (var id in sources) {
	                      var source = sources[id];
	                      var tiles = source._tiles;
	                      for (var t in tiles) {
	                        var tile = tiles[t];
	                        if (!(tile.state === "loaded" || tile.state === "errored")) {
	                          return false;
	                        }
	                      }
	                    }
	                    return true;
	                  };
	                  Map3.prototype.addSourceType = function addSourceType(name2, SourceType, callback) {
	                    this._lazyInitEmptyStyle();
	                    return this.style.addSourceType(name2, SourceType, callback);
	                  };
	                  Map3.prototype.removeSource = function removeSource2(id) {
	                    this.style.removeSource(id);
	                    return this._update(true);
	                  };
	                  Map3.prototype.getSource = function getSource(id) {
	                    return this.style.getSource(id);
	                  };
	                  Map3.prototype.addImage = function addImage(id, image, ref) {
	                    if (ref === undefined)
	                      ref = {};
	                    var pixelRatio = ref.pixelRatio;
	                    if (pixelRatio === undefined)
	                      pixelRatio = 1;
	                    var sdf = ref.sdf;
	                    if (sdf === undefined)
	                      sdf = false;
	                    var stretchX = ref.stretchX;
	                    var stretchY = ref.stretchY;
	                    var content = ref.content;
	                    this._lazyInitEmptyStyle();
	                    var version = 0;
	                    if (image instanceof HTMLImageElement2 || ImageBitmap && image instanceof ImageBitmap) {
	                      var ref$1 = performance2.browser.getImageData(image);
	                      var width = ref$1.width;
	                      var height = ref$1.height;
	                      var data = ref$1.data;
	                      this.style.addImage(id, {
	                        data: new performance2.RGBAImage({
	                          width,
	                          height
	                        }, data),
	                        pixelRatio,
	                        stretchX,
	                        stretchY,
	                        content,
	                        sdf,
	                        version
	                      });
	                    } else if (image.width === undefined || image.height === undefined) {
	                      return this.fire(new performance2.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
	                    } else {
	                      var width$1 = image.width;
	                      var height$1 = image.height;
	                      var data$1 = image.data;
	                      var userImage = image;
	                      this.style.addImage(id, {
	                        data: new performance2.RGBAImage({
	                          width: width$1,
	                          height: height$1
	                        }, new Uint8Array(data$1)),
	                        pixelRatio,
	                        stretchX,
	                        stretchY,
	                        content,
	                        sdf,
	                        version,
	                        userImage
	                      });
	                      if (userImage.onAdd) {
	                        userImage.onAdd(this, id);
	                      }
	                    }
	                  };
	                  Map3.prototype.updateImage = function updateImage(id, image) {
	                    var existingImage = this.style.getImage(id);
	                    if (!existingImage) {
	                      return this.fire(new performance2.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
	                    }
	                    var imageData = image instanceof HTMLImageElement2 || ImageBitmap && image instanceof ImageBitmap ? performance2.browser.getImageData(image) : image;
	                    var width = imageData.width;
	                    var height = imageData.height;
	                    var data = imageData.data;
	                    if (width === undefined || height === undefined) {
	                      return this.fire(new performance2.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
	                    }
	                    if (width !== existingImage.data.width || height !== existingImage.data.height) {
	                      return this.fire(new performance2.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
	                    }
	                    var copy = !(image instanceof HTMLImageElement2 || ImageBitmap && image instanceof ImageBitmap);
	                    existingImage.data.replace(data, copy);
	                    this.style.updateImage(id, existingImage);
	                  };
	                  Map3.prototype.hasImage = function hasImage(id) {
	                    if (!id) {
	                      this.fire(new performance2.ErrorEvent(new Error("Missing required image id")));
	                      return false;
	                    }
	                    return !!this.style.getImage(id);
	                  };
	                  Map3.prototype.removeImage = function removeImage(id) {
	                    this.style.removeImage(id);
	                  };
	                  Map3.prototype.loadImage = function loadImage(url, callback) {
	                    performance2.getImage(this._requestManager.transformRequest(url, performance2.ResourceType.Image), callback);
	                  };
	                  Map3.prototype.listImages = function listImages() {
	                    return this.style.listImages();
	                  };
	                  Map3.prototype.addLayer = function addLayer(layer, beforeId) {
	                    this._lazyInitEmptyStyle();
	                    this.style.addLayer(layer, beforeId);
	                    return this._update(true);
	                  };
	                  Map3.prototype.moveLayer = function moveLayer(id, beforeId) {
	                    this.style.moveLayer(id, beforeId);
	                    return this._update(true);
	                  };
	                  Map3.prototype.removeLayer = function removeLayer(id) {
	                    this.style.removeLayer(id);
	                    return this._update(true);
	                  };
	                  Map3.prototype.getLayer = function getLayer(id) {
	                    return this.style.getLayer(id);
	                  };
	                  Map3.prototype.setLayerZoomRange = function setLayerZoomRange(layerId, minzoom, maxzoom) {
	                    this.style.setLayerZoomRange(layerId, minzoom, maxzoom);
	                    return this._update(true);
	                  };
	                  Map3.prototype.setFilter = function setFilter(layerId, filter, options) {
	                    if (options === undefined)
	                      options = {};
	                    this.style.setFilter(layerId, filter, options);
	                    return this._update(true);
	                  };
	                  Map3.prototype.getFilter = function getFilter(layerId) {
	                    return this.style.getFilter(layerId);
	                  };
	                  Map3.prototype.setPaintProperty = function setPaintProperty(layerId, name2, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    this.style.setPaintProperty(layerId, name2, value, options);
	                    return this._update(true);
	                  };
	                  Map3.prototype.getPaintProperty = function getPaintProperty(layerId, name2) {
	                    return this.style.getPaintProperty(layerId, name2);
	                  };
	                  Map3.prototype.setLayoutProperty = function setLayoutProperty(layerId, name2, value, options) {
	                    if (options === undefined)
	                      options = {};
	                    this.style.setLayoutProperty(layerId, name2, value, options);
	                    return this._update(true);
	                  };
	                  Map3.prototype.getLayoutProperty = function getLayoutProperty(layerId, name2) {
	                    return this.style.getLayoutProperty(layerId, name2);
	                  };
	                  Map3.prototype.setLight = function setLight(light, options) {
	                    if (options === undefined)
	                      options = {};
	                    this._lazyInitEmptyStyle();
	                    this.style.setLight(light, options);
	                    return this._update(true);
	                  };
	                  Map3.prototype.getLight = function getLight() {
	                    return this.style.getLight();
	                  };
	                  Map3.prototype.setFeatureState = function setFeatureState(feature, state) {
	                    this.style.setFeatureState(feature, state);
	                    return this._update();
	                  };
	                  Map3.prototype.removeFeatureState = function removeFeatureState(target, key) {
	                    this.style.removeFeatureState(target, key);
	                    return this._update();
	                  };
	                  Map3.prototype.getFeatureState = function getFeatureState(feature) {
	                    return this.style.getFeatureState(feature);
	                  };
	                  Map3.prototype.getContainer = function getContainer() {
	                    return this._container;
	                  };
	                  Map3.prototype.getCanvasContainer = function getCanvasContainer() {
	                    return this._canvasContainer;
	                  };
	                  Map3.prototype.getCanvas = function getCanvas() {
	                    return this._canvas;
	                  };
	                  Map3.prototype._containerDimensions = function _containerDimensions() {
	                    var width = 0;
	                    var height = 0;
	                    if (this._container) {
	                      width = this._container.clientWidth || 400;
	                      height = this._container.clientHeight || 300;
	                    }
	                    return [
	                      width,
	                      height
	                    ];
	                  };
	                  Map3.prototype._detectMissingCSS = function _detectMissingCSS() {
	                    var computedColor = performance2.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color");
	                    if (computedColor !== "rgb(250, 128, 114)") {
	                      performance2.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
	                    }
	                  };
	                  Map3.prototype._setupContainer = function _setupContainer() {
	                    var container = this._container;
	                    container.classList.add("mapboxgl-map");
	                    var missingCSSCanary = this._missingCSSCanary = DOM.create("div", "mapboxgl-canary", container);
	                    missingCSSCanary.style.visibility = "hidden";
	                    this._detectMissingCSS();
	                    var canvasContainer = this._canvasContainer = DOM.create("div", "mapboxgl-canvas-container", container);
	                    if (this._interactive) {
	                      canvasContainer.classList.add("mapboxgl-interactive");
	                    }
	                    this._canvas = DOM.create("canvas", "mapboxgl-canvas", canvasContainer);
	                    this._canvas.addEventListener("webglcontextlost", this._contextLost, false);
	                    this._canvas.addEventListener("webglcontextrestored", this._contextRestored, false);
	                    this._canvas.setAttribute("tabindex", "0");
	                    this._canvas.setAttribute("aria-label", "Map");
	                    var dimensions = this._containerDimensions();
	                    this._resizeCanvas(dimensions[0], dimensions[1]);
	                    var controlContainer = this._controlContainer = DOM.create("div", "mapboxgl-control-container", container);
	                    var positions = this._controlPositions = {};
	                    [
	                      "top-left",
	                      "top-right",
	                      "bottom-left",
	                      "bottom-right"
	                    ].forEach(function(positionName) {
	                      positions[positionName] = DOM.create("div", "mapboxgl-ctrl-" + positionName, controlContainer);
	                    });
	                  };
	                  Map3.prototype._resizeCanvas = function _resizeCanvas(width, height) {
	                    var pixelRatio = performance2.browser.devicePixelRatio || 1;
	                    this._canvas.width = pixelRatio * width;
	                    this._canvas.height = pixelRatio * height;
	                    this._canvas.style.width = width + "px";
	                    this._canvas.style.height = height + "px";
	                  };
	                  Map3.prototype._setupPainter = function _setupPainter() {
	                    var attributes = performance2.extend({}, mapboxGlSupported.webGLContextAttributes, {
	                      failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
	                      preserveDrawingBuffer: this._preserveDrawingBuffer,
	                      antialias: this._antialias || false
	                    });
	                    var gl2 = this._canvas.getContext("webgl", attributes) || this._canvas.getContext("experimental-webgl", attributes);
	                    if (!gl2) {
	                      this.fire(new performance2.ErrorEvent(new Error("Failed to initialize WebGL")));
	                      return;
	                    }
	                    this.painter = new Painter(gl2, this.transform);
	                    performance2.webpSupported.testSupport(gl2);
	                  };
	                  Map3.prototype._contextLost = function _contextLost(event) {
	                    event.preventDefault();
	                    if (this._frame) {
	                      this._frame.cancel();
	                      this._frame = null;
	                    }
	                    this.fire(new performance2.Event("webglcontextlost", { originalEvent: event }));
	                  };
	                  Map3.prototype._contextRestored = function _contextRestored(event) {
	                    this._setupPainter();
	                    this.resize();
	                    this._update();
	                    this.fire(new performance2.Event("webglcontextrestored", { originalEvent: event }));
	                  };
	                  Map3.prototype.loaded = function loaded() {
	                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
	                  };
	                  Map3.prototype._update = function _update(updateStyle) {
	                    if (!this.style) {
	                      return this;
	                    }
	                    this._styleDirty = this._styleDirty || updateStyle;
	                    this._sourcesDirty = true;
	                    this.triggerRepaint();
	                    return this;
	                  };
	                  Map3.prototype._requestRenderFrame = function _requestRenderFrame(callback) {
	                    this._update();
	                    return this._renderTaskQueue.add(callback);
	                  };
	                  Map3.prototype._cancelRenderFrame = function _cancelRenderFrame(id) {
	                    this._renderTaskQueue.remove(id);
	                  };
	                  Map3.prototype._render = function _render(paintStartTimeStamp) {
	                    var this$1$1 = this;
	                    var gpuTimer, frameStartTime = 0;
	                    var extTimerQuery = this.painter.context.extTimerQuery;
	                    if (this.listens("gpu-timing-frame")) {
	                      gpuTimer = extTimerQuery.createQueryEXT();
	                      extTimerQuery.beginQueryEXT(extTimerQuery.TIME_ELAPSED_EXT, gpuTimer);
	                      frameStartTime = performance2.browser.now();
	                    }
	                    this.painter.context.setDirty();
	                    this.painter.setBaseState();
	                    this._renderTaskQueue.run(paintStartTimeStamp);
	                    if (this._removed) {
	                      return;
	                    }
	                    var crossFading = false;
	                    if (this.style && this._styleDirty) {
	                      this._styleDirty = false;
	                      var zoom = this.transform.zoom;
	                      var now = performance2.browser.now();
	                      this.style.zoomHistory.update(zoom, now);
	                      var parameters = new performance2.EvaluationParameters(zoom, {
	                        now,
	                        fadeDuration: this._fadeDuration,
	                        zoomHistory: this.style.zoomHistory,
	                        transition: this.style.getTransition()
	                      });
	                      var factor = parameters.crossFadingFactor();
	                      if (factor !== 1 || factor !== this._crossFadingFactor) {
	                        crossFading = true;
	                        this._crossFadingFactor = factor;
	                      }
	                      this.style.update(parameters);
	                    }
	                    if (this.style && this._sourcesDirty) {
	                      this._sourcesDirty = false;
	                      this.style._updateSources(this.transform);
	                    }
	                    this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions);
	                    this.painter.render(this.style, {
	                      showTileBoundaries: this.showTileBoundaries,
	                      showOverdrawInspector: this._showOverdrawInspector,
	                      rotating: this.isRotating(),
	                      zooming: this.isZooming(),
	                      moving: this.isMoving(),
	                      fadeDuration: this._fadeDuration,
	                      showPadding: this.showPadding,
	                      gpuTiming: !!this.listens("gpu-timing-layer")
	                    });
	                    this.fire(new performance2.Event("render"));
	                    if (this.loaded() && !this._loaded) {
	                      this._loaded = true;
	                      this.fire(new performance2.Event("load"));
	                    }
	                    if (this.style && (this.style.hasTransitions() || crossFading)) {
	                      this._styleDirty = true;
	                    }
	                    if (this.style && !this._placementDirty) {
	                      this.style._releaseSymbolFadeTiles();
	                    }
	                    if (this.listens("gpu-timing-frame")) {
	                      var renderCPUTime = performance2.browser.now() - frameStartTime;
	                      extTimerQuery.endQueryEXT(extTimerQuery.TIME_ELAPSED_EXT, gpuTimer);
	                      setTimeout(function() {
	                        var renderGPUTime = extTimerQuery.getQueryObjectEXT(gpuTimer, extTimerQuery.QUERY_RESULT_EXT) / (1e3 * 1e3);
	                        extTimerQuery.deleteQueryEXT(gpuTimer);
	                        this$1$1.fire(new performance2.Event("gpu-timing-frame", {
	                          cpuTime: renderCPUTime,
	                          gpuTime: renderGPUTime
	                        }));
	                      }, 50);
	                    }
	                    if (this.listens("gpu-timing-layer")) {
	                      var frameLayerQueries = this.painter.collectGpuTimers();
	                      setTimeout(function() {
	                        var renderedLayerTimes = this$1$1.painter.queryGpuTimers(frameLayerQueries);
	                        this$1$1.fire(new performance2.Event("gpu-timing-layer", { layerTimes: renderedLayerTimes }));
	                      }, 50);
	                    }
	                    var somethingDirty = this._sourcesDirty || this._styleDirty || this._placementDirty;
	                    if (somethingDirty || this._repaint) {
	                      this.triggerRepaint();
	                    } else if (!this.isMoving() && this.loaded()) {
	                      if (!this._fullyLoaded) {
	                        this._fullyLoaded = true;
	                      }
	                      this.fire(new performance2.Event("idle"));
	                    }
	                    return this;
	                  };
	                  Map3.prototype.remove = function remove() {
	                    if (this._hash) {
	                      this._hash.remove();
	                    }
	                    for (var i = 0, list = this._controls; i < list.length; i += 1) {
	                      var control = list[i];
	                      control.onRemove(this);
	                    }
	                    this._controls = [];
	                    if (this._frame) {
	                      this._frame.cancel();
	                      this._frame = null;
	                    }
	                    this._renderTaskQueue.clear();
	                    this.painter.destroy();
	                    this.handlers.destroy();
	                    delete this.handlers;
	                    this.setStyle(null);
	                    if (typeof performance2.window !== "undefined") {
	                      performance2.window.removeEventListener("resize", this._onWindowResize, false);
	                      performance2.window.removeEventListener("online", this._onWindowOnline, false);
	                    }
	                    var extension = this.painter.context.gl.getExtension("WEBGL_lose_context");
	                    if (extension) {
	                      extension.loseContext();
	                    }
	                    removeNode(this._canvasContainer);
	                    removeNode(this._controlContainer);
	                    removeNode(this._missingCSSCanary);
	                    this._container.classList.remove("mapboxgl-map");
	                    this._removed = true;
	                    this.fire(new performance2.Event("remove"));
	                  };
	                  Map3.prototype.triggerRepaint = function triggerRepaint() {
	                    var this$1$1 = this;
	                    if (this.style && !this._frame) {
	                      this._frame = performance2.browser.frame(function(paintStartTimeStamp) {
	                        this$1$1._frame = null;
	                        this$1$1._render(paintStartTimeStamp);
	                      });
	                    }
	                  };
	                  Map3.prototype._onWindowOnline = function _onWindowOnline() {
	                    this._update();
	                  };
	                  Map3.prototype._onWindowResize = function _onWindowResize(event) {
	                    if (this._trackResize) {
	                      this.resize({ originalEvent: event })._update();
	                    }
	                  };
	                  prototypeAccessors2.showTileBoundaries.get = function() {
	                    return !!this._showTileBoundaries;
	                  };
	                  prototypeAccessors2.showTileBoundaries.set = function(value) {
	                    if (this._showTileBoundaries === value) {
	                      return;
	                    }
	                    this._showTileBoundaries = value;
	                    this._update();
	                  };
	                  prototypeAccessors2.showPadding.get = function() {
	                    return !!this._showPadding;
	                  };
	                  prototypeAccessors2.showPadding.set = function(value) {
	                    if (this._showPadding === value) {
	                      return;
	                    }
	                    this._showPadding = value;
	                    this._update();
	                  };
	                  prototypeAccessors2.showCollisionBoxes.get = function() {
	                    return !!this._showCollisionBoxes;
	                  };
	                  prototypeAccessors2.showCollisionBoxes.set = function(value) {
	                    if (this._showCollisionBoxes === value) {
	                      return;
	                    }
	                    this._showCollisionBoxes = value;
	                    if (value) {
	                      this.style._generateCollisionBoxes();
	                    } else {
	                      this._update();
	                    }
	                  };
	                  prototypeAccessors2.showOverdrawInspector.get = function() {
	                    return !!this._showOverdrawInspector;
	                  };
	                  prototypeAccessors2.showOverdrawInspector.set = function(value) {
	                    if (this._showOverdrawInspector === value) {
	                      return;
	                    }
	                    this._showOverdrawInspector = value;
	                    this._update();
	                  };
	                  prototypeAccessors2.repaint.get = function() {
	                    return !!this._repaint;
	                  };
	                  prototypeAccessors2.repaint.set = function(value) {
	                    if (this._repaint !== value) {
	                      this._repaint = value;
	                      this.triggerRepaint();
	                    }
	                  };
	                  prototypeAccessors2.vertices.get = function() {
	                    return !!this._vertices;
	                  };
	                  prototypeAccessors2.vertices.set = function(value) {
	                    this._vertices = value;
	                    this._update();
	                  };
	                  Map3.prototype._setCacheLimits = function _setCacheLimits(limit, checkThreshold) {
	                    performance2.setCacheLimits(limit, checkThreshold);
	                  };
	                  prototypeAccessors2.version.get = function() {
	                    return performance2.version;
	                  };
	                  Object.defineProperties(Map3.prototype, prototypeAccessors2);
	                  return Map3;
	                }(Camera);
	                function removeNode(node) {
	                  if (node.parentNode) {
	                    node.parentNode.removeChild(node);
	                  }
	                }
	                var defaultOptions$2 = {
	                  showCompass: true,
	                  showZoom: true,
	                  visualizePitch: false
	                };
	                var NavigationControl = function NavigationControl2(options) {
	                  var this$1$1 = this;
	                  this.options = performance2.extend({}, defaultOptions$2, options);
	                  this._container = DOM.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group");
	                  this._container.addEventListener("contextmenu", function(e) {
	                    return e.preventDefault();
	                  });
	                  if (this.options.showZoom) {
	                    performance2.bindAll([
	                      "_setButtonTitle",
	                      "_updateZoomButtons"
	                    ], this);
	                    this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function(e) {
	                      return this$1$1._map.zoomIn({}, { originalEvent: e });
	                    });
	                    DOM.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", true);
	                    this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function(e) {
	                      return this$1$1._map.zoomOut({}, { originalEvent: e });
	                    });
	                    DOM.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", true);
	                  }
	                  if (this.options.showCompass) {
	                    performance2.bindAll(["_rotateCompassArrow"], this);
	                    this._compass = this._createButton("mapboxgl-ctrl-compass", function(e) {
	                      if (this$1$1.options.visualizePitch) {
	                        this$1$1._map.resetNorthPitch({}, { originalEvent: e });
	                      } else {
	                        this$1$1._map.resetNorth({}, { originalEvent: e });
	                      }
	                    });
	                    this._compassIcon = DOM.create("span", "mapboxgl-ctrl-icon", this._compass);
	                    this._compassIcon.setAttribute("aria-hidden", true);
	                  }
	                };
	                NavigationControl.prototype._updateZoomButtons = function _updateZoomButtons() {
	                  var zoom = this._map.getZoom();
	                  this._zoomInButton.disabled = zoom === this._map.getMaxZoom();
	                  this._zoomOutButton.disabled = zoom === this._map.getMinZoom();
	                };
	                NavigationControl.prototype._rotateCompassArrow = function _rotateCompassArrow() {
	                  var rotate = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), 0.5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
	                  this._compassIcon.style.transform = rotate;
	                };
	                NavigationControl.prototype.onAdd = function onAdd(map2) {
	                  this._map = map2;
	                  if (this.options.showZoom) {
	                    this._setButtonTitle(this._zoomInButton, "ZoomIn");
	                    this._setButtonTitle(this._zoomOutButton, "ZoomOut");
	                    this._map.on("zoom", this._updateZoomButtons);
	                    this._updateZoomButtons();
	                  }
	                  if (this.options.showCompass) {
	                    this._setButtonTitle(this._compass, "ResetBearing");
	                    if (this.options.visualizePitch) {
	                      this._map.on("pitch", this._rotateCompassArrow);
	                    }
	                    this._map.on("rotate", this._rotateCompassArrow);
	                    this._rotateCompassArrow();
	                    this._handler = new MouseRotateWrapper(this._map, this._compass, this.options.visualizePitch);
	                  }
	                  return this._container;
	                };
	                NavigationControl.prototype.onRemove = function onRemove() {
	                  DOM.remove(this._container);
	                  if (this.options.showZoom) {
	                    this._map.off("zoom", this._updateZoomButtons);
	                  }
	                  if (this.options.showCompass) {
	                    if (this.options.visualizePitch) {
	                      this._map.off("pitch", this._rotateCompassArrow);
	                    }
	                    this._map.off("rotate", this._rotateCompassArrow);
	                    this._handler.off();
	                    delete this._handler;
	                  }
	                  delete this._map;
	                };
	                NavigationControl.prototype._createButton = function _createButton(className, fn) {
	                  var a = DOM.create("button", className, this._container);
	                  a.type = "button";
	                  a.addEventListener("click", fn);
	                  return a;
	                };
	                NavigationControl.prototype._setButtonTitle = function _setButtonTitle(button, title) {
	                  var str = this._map._getUIString("NavigationControl." + title);
	                  button.title = str;
	                  button.setAttribute("aria-label", str);
	                };
	                var MouseRotateWrapper = function MouseRotateWrapper2(map2, element, pitch) {
	                  if (pitch === undefined)
	                    pitch = false;
	                  this._clickTolerance = 10;
	                  this.element = element;
	                  this.mouseRotate = new MouseRotateHandler({ clickTolerance: map2.dragRotate._mouseRotate._clickTolerance });
	                  this.map = map2;
	                  if (pitch) {
	                    this.mousePitch = new MousePitchHandler({ clickTolerance: map2.dragRotate._mousePitch._clickTolerance });
	                  }
	                  performance2.bindAll([
	                    "mousedown",
	                    "mousemove",
	                    "mouseup",
	                    "touchstart",
	                    "touchmove",
	                    "touchend",
	                    "reset"
	                  ], this);
	                  DOM.addEventListener(element, "mousedown", this.mousedown);
	                  DOM.addEventListener(element, "touchstart", this.touchstart, { passive: false });
	                  DOM.addEventListener(element, "touchmove", this.touchmove);
	                  DOM.addEventListener(element, "touchend", this.touchend);
	                  DOM.addEventListener(element, "touchcancel", this.reset);
	                };
	                MouseRotateWrapper.prototype.down = function down(e, point) {
	                  this.mouseRotate.mousedown(e, point);
	                  if (this.mousePitch) {
	                    this.mousePitch.mousedown(e, point);
	                  }
	                  DOM.disableDrag();
	                };
	                MouseRotateWrapper.prototype.move = function move(e, point) {
	                  var map2 = this.map;
	                  var r = this.mouseRotate.mousemoveWindow(e, point);
	                  if (r && r.bearingDelta) {
	                    map2.setBearing(map2.getBearing() + r.bearingDelta);
	                  }
	                  if (this.mousePitch) {
	                    var p = this.mousePitch.mousemoveWindow(e, point);
	                    if (p && p.pitchDelta) {
	                      map2.setPitch(map2.getPitch() + p.pitchDelta);
	                    }
	                  }
	                };
	                MouseRotateWrapper.prototype.off = function off() {
	                  var element = this.element;
	                  DOM.removeEventListener(element, "mousedown", this.mousedown);
	                  DOM.removeEventListener(element, "touchstart", this.touchstart, { passive: false });
	                  DOM.removeEventListener(element, "touchmove", this.touchmove);
	                  DOM.removeEventListener(element, "touchend", this.touchend);
	                  DOM.removeEventListener(element, "touchcancel", this.reset);
	                  this.offTemp();
	                };
	                MouseRotateWrapper.prototype.offTemp = function offTemp() {
	                  DOM.enableDrag();
	                  DOM.removeEventListener(performance2.window, "mousemove", this.mousemove);
	                  DOM.removeEventListener(performance2.window, "mouseup", this.mouseup);
	                };
	                MouseRotateWrapper.prototype.mousedown = function mousedown(e) {
	                  this.down(performance2.extend({}, e, {
	                    ctrlKey: true,
	                    preventDefault: function() {
	                      return e.preventDefault();
	                    }
	                  }), DOM.mousePos(this.element, e));
	                  DOM.addEventListener(performance2.window, "mousemove", this.mousemove);
	                  DOM.addEventListener(performance2.window, "mouseup", this.mouseup);
	                };
	                MouseRotateWrapper.prototype.mousemove = function mousemove(e) {
	                  this.move(e, DOM.mousePos(this.element, e));
	                };
	                MouseRotateWrapper.prototype.mouseup = function mouseup(e) {
	                  this.mouseRotate.mouseupWindow(e);
	                  if (this.mousePitch) {
	                    this.mousePitch.mouseupWindow(e);
	                  }
	                  this.offTemp();
	                };
	                MouseRotateWrapper.prototype.touchstart = function touchstart(e) {
	                  if (e.targetTouches.length !== 1) {
	                    this.reset();
	                  } else {
	                    this._startPos = this._lastPos = DOM.touchPos(this.element, e.targetTouches)[0];
	                    this.down({
	                      type: "mousedown",
	                      button: 0,
	                      ctrlKey: true,
	                      preventDefault: function() {
	                        return e.preventDefault();
	                      }
	                    }, this._startPos);
	                  }
	                };
	                MouseRotateWrapper.prototype.touchmove = function touchmove(e) {
	                  if (e.targetTouches.length !== 1) {
	                    this.reset();
	                  } else {
	                    this._lastPos = DOM.touchPos(this.element, e.targetTouches)[0];
	                    this.move({
	                      preventDefault: function() {
	                        return e.preventDefault();
	                      }
	                    }, this._lastPos);
	                  }
	                };
	                MouseRotateWrapper.prototype.touchend = function touchend(e) {
	                  if (e.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance) {
	                    this.element.click();
	                  }
	                  this.reset();
	                };
	                MouseRotateWrapper.prototype.reset = function reset() {
	                  this.mouseRotate.reset();
	                  if (this.mousePitch) {
	                    this.mousePitch.reset();
	                  }
	                  delete this._startPos;
	                  delete this._lastPos;
	                  this.offTemp();
	                };
	                function smartWrap(lngLat, priorPos, transform) {
	                  lngLat = new performance2.LngLat(lngLat.lng, lngLat.lat);
	                  if (priorPos) {
	                    var left = new performance2.LngLat(lngLat.lng - 360, lngLat.lat);
	                    var right = new performance2.LngLat(lngLat.lng + 360, lngLat.lat);
	                    var delta = transform.locationPoint(lngLat).distSqr(priorPos);
	                    if (transform.locationPoint(left).distSqr(priorPos) < delta) {
	                      lngLat = left;
	                    } else if (transform.locationPoint(right).distSqr(priorPos) < delta) {
	                      lngLat = right;
	                    }
	                  }
	                  while (Math.abs(lngLat.lng - transform.center.lng) > 180) {
	                    var pos = transform.locationPoint(lngLat);
	                    if (pos.x >= 0 && pos.y >= 0 && pos.x <= transform.width && pos.y <= transform.height) {
	                      break;
	                    }
	                    if (lngLat.lng > transform.center.lng) {
	                      lngLat.lng -= 360;
	                    } else {
	                      lngLat.lng += 360;
	                    }
	                  }
	                  return lngLat;
	                }
	                var anchorTranslate = {
	                  "center": "translate(-50%,-50%)",
	                  "top": "translate(-50%,0)",
	                  "top-left": "translate(0,0)",
	                  "top-right": "translate(-100%,0)",
	                  "bottom": "translate(-50%,-100%)",
	                  "bottom-left": "translate(0,-100%)",
	                  "bottom-right": "translate(-100%,-100%)",
	                  "left": "translate(0,-50%)",
	                  "right": "translate(-100%,-50%)"
	                };
	                function applyAnchorClass(element, anchor, prefix) {
	                  var classList = element.classList;
	                  for (var key in anchorTranslate) {
	                    classList.remove("mapboxgl-" + prefix + "-anchor-" + key);
	                  }
	                  classList.add("mapboxgl-" + prefix + "-anchor-" + anchor);
	                }
	                var Marker = function(Evented) {
	                  function Marker2(options, legacyOptions) {
	                    var this$1$1 = this;
	                    Evented.call(this);
	                    if (options instanceof performance2.window.HTMLElement || legacyOptions) {
	                      options = performance2.extend({ element: options }, legacyOptions);
	                    }
	                    performance2.bindAll([
	                      "_update",
	                      "_onMove",
	                      "_onUp",
	                      "_addDragHandler",
	                      "_onMapClick",
	                      "_onKeyPress"
	                    ], this);
	                    this._anchor = options && options.anchor || "center";
	                    this._color = options && options.color || "#3FB1CE";
	                    this._draggable = options && options.draggable || false;
	                    this._state = "inactive";
	                    this._rotation = options && options.rotation || 0;
	                    this._rotationAlignment = options && options.rotationAlignment || "auto";
	                    this._pitchAlignment = options && options.pitchAlignment && options.pitchAlignment !== "auto" ? options.pitchAlignment : this._rotationAlignment;
	                    if (!options || !options.element) {
	                      this._defaultMarker = true;
	                      this._element = DOM.create("div");
	                      this._element.setAttribute("aria-label", "Map marker");
	                      var svg = DOM.createNS("http://www.w3.org/2000/svg", "svg");
	                      svg.setAttributeNS(null, "display", "block");
	                      svg.setAttributeNS(null, "height", "41px");
	                      svg.setAttributeNS(null, "width", "27px");
	                      svg.setAttributeNS(null, "viewBox", "0 0 27 41");
	                      var markerLarge = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      markerLarge.setAttributeNS(null, "stroke", "none");
	                      markerLarge.setAttributeNS(null, "stroke-width", "1");
	                      markerLarge.setAttributeNS(null, "fill", "none");
	                      markerLarge.setAttributeNS(null, "fill-rule", "evenodd");
	                      var page1 = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      page1.setAttributeNS(null, "fill-rule", "nonzero");
	                      var shadow = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      shadow.setAttributeNS(null, "transform", "translate(3.0, 29.0)");
	                      shadow.setAttributeNS(null, "fill", "#000000");
	                      var ellipses = [
	                        {
	                          "rx": "10.5",
	                          "ry": "5.25002273"
	                        },
	                        {
	                          "rx": "10.5",
	                          "ry": "5.25002273"
	                        },
	                        {
	                          "rx": "9.5",
	                          "ry": "4.77275007"
	                        },
	                        {
	                          "rx": "8.5",
	                          "ry": "4.29549936"
	                        },
	                        {
	                          "rx": "7.5",
	                          "ry": "3.81822308"
	                        },
	                        {
	                          "rx": "6.5",
	                          "ry": "3.34094679"
	                        },
	                        {
	                          "rx": "5.5",
	                          "ry": "2.86367051"
	                        },
	                        {
	                          "rx": "4.5",
	                          "ry": "2.38636864"
	                        }
	                      ];
	                      for (var i = 0, list = ellipses; i < list.length; i += 1) {
	                        var data = list[i];
	                        var ellipse = DOM.createNS("http://www.w3.org/2000/svg", "ellipse");
	                        ellipse.setAttributeNS(null, "opacity", "0.04");
	                        ellipse.setAttributeNS(null, "cx", "10.5");
	                        ellipse.setAttributeNS(null, "cy", "5.80029008");
	                        ellipse.setAttributeNS(null, "rx", data["rx"]);
	                        ellipse.setAttributeNS(null, "ry", data["ry"]);
	                        shadow.appendChild(ellipse);
	                      }
	                      var background2 = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      background2.setAttributeNS(null, "fill", this._color);
	                      var bgPath = DOM.createNS("http://www.w3.org/2000/svg", "path");
	                      bgPath.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z");
	                      background2.appendChild(bgPath);
	                      var border = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      border.setAttributeNS(null, "opacity", "0.25");
	                      border.setAttributeNS(null, "fill", "#000000");
	                      var borderPath = DOM.createNS("http://www.w3.org/2000/svg", "path");
	                      borderPath.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z");
	                      border.appendChild(borderPath);
	                      var maki = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      maki.setAttributeNS(null, "transform", "translate(6.0, 7.0)");
	                      maki.setAttributeNS(null, "fill", "#FFFFFF");
	                      var circleContainer = DOM.createNS("http://www.w3.org/2000/svg", "g");
	                      circleContainer.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
	                      var circle1 = DOM.createNS("http://www.w3.org/2000/svg", "circle");
	                      circle1.setAttributeNS(null, "fill", "#000000");
	                      circle1.setAttributeNS(null, "opacity", "0.25");
	                      circle1.setAttributeNS(null, "cx", "5.5");
	                      circle1.setAttributeNS(null, "cy", "5.5");
	                      circle1.setAttributeNS(null, "r", "5.4999962");
	                      var circle2 = DOM.createNS("http://www.w3.org/2000/svg", "circle");
	                      circle2.setAttributeNS(null, "fill", "#FFFFFF");
	                      circle2.setAttributeNS(null, "cx", "5.5");
	                      circle2.setAttributeNS(null, "cy", "5.5");
	                      circle2.setAttributeNS(null, "r", "5.4999962");
	                      circleContainer.appendChild(circle1);
	                      circleContainer.appendChild(circle2);
	                      page1.appendChild(shadow);
	                      page1.appendChild(background2);
	                      page1.appendChild(border);
	                      page1.appendChild(maki);
	                      page1.appendChild(circleContainer);
	                      svg.appendChild(page1);
	                      this._element.appendChild(svg);
	                      this._offset = performance2.Point.convert(options && options.offset || [
	                        0,
	                        -14
	                      ]);
	                    } else {
	                      this._element = options.element;
	                      this._offset = performance2.Point.convert(options && options.offset || [
	                        0,
	                        0
	                      ]);
	                    }
	                    this._element.classList.add("mapboxgl-marker");
	                    this._element.addEventListener("dragstart", function(e) {
	                      e.preventDefault();
	                    });
	                    this._element.addEventListener("mousedown", function(e) {
	                      e.preventDefault();
	                    });
	                    this._element.addEventListener("focus", function() {
	                      var el = this$1$1._map.getContainer();
	                      el.scrollTop = 0;
	                      el.scrollLeft = 0;
	                    });
	                    applyAnchorClass(this._element, this._anchor, "marker");
	                    this._popup = null;
	                  }
	                  if (Evented)
	                    Marker2.__proto__ = Evented;
	                  Marker2.prototype = Object.create(Evented && Evented.prototype);
	                  Marker2.prototype.constructor = Marker2;
	                  Marker2.prototype.addTo = function addTo(map2) {
	                    this.remove();
	                    this._map = map2;
	                    map2.getCanvasContainer().appendChild(this._element);
	                    map2.on("move", this._update);
	                    map2.on("moveend", this._update);
	                    this.setDraggable(this._draggable);
	                    this._update();
	                    this._map.on("click", this._onMapClick);
	                    return this;
	                  };
	                  Marker2.prototype.remove = function remove() {
	                    if (this._map) {
	                      this._map.off("click", this._onMapClick);
	                      this._map.off("move", this._update);
	                      this._map.off("moveend", this._update);
	                      this._map.off("mousedown", this._addDragHandler);
	                      this._map.off("touchstart", this._addDragHandler);
	                      this._map.off("mouseup", this._onUp);
	                      this._map.off("touchend", this._onUp);
	                      this._map.off("mousemove", this._onMove);
	                      this._map.off("touchmove", this._onMove);
	                      delete this._map;
	                    }
	                    DOM.remove(this._element);
	                    if (this._popup) {
	                      this._popup.remove();
	                    }
	                    return this;
	                  };
	                  Marker2.prototype.getLngLat = function getLngLat() {
	                    return this._lngLat;
	                  };
	                  Marker2.prototype.setLngLat = function setLngLat(lnglat) {
	                    this._lngLat = performance2.LngLat.convert(lnglat);
	                    this._pos = null;
	                    if (this._popup) {
	                      this._popup.setLngLat(this._lngLat);
	                    }
	                    this._update();
	                    return this;
	                  };
	                  Marker2.prototype.getElement = function getElement() {
	                    return this._element;
	                  };
	                  Marker2.prototype.setPopup = function setPopup(popup) {
	                    if (this._popup) {
	                      this._popup.remove();
	                      this._popup = null;
	                      this._element.removeEventListener("keypress", this._onKeyPress);
	                      if (!this._originalTabIndex) {
	                        this._element.removeAttribute("tabindex");
	                      }
	                    }
	                    if (popup) {
	                      if (!("offset" in popup.options)) {
	                        var markerHeight = 41 - 5.8 / 2;
	                        var markerRadius = 13.5;
	                        var linearOffset = Math.sqrt(Math.pow(markerRadius, 2) / 2);
	                        popup.options.offset = this._defaultMarker ? {
	                          "top": [
	                            0,
	                            0
	                          ],
	                          "top-left": [
	                            0,
	                            0
	                          ],
	                          "top-right": [
	                            0,
	                            0
	                          ],
	                          "bottom": [
	                            0,
	                            -markerHeight
	                          ],
	                          "bottom-left": [
	                            linearOffset,
	                            (markerHeight - markerRadius + linearOffset) * -1
	                          ],
	                          "bottom-right": [
	                            -linearOffset,
	                            (markerHeight - markerRadius + linearOffset) * -1
	                          ],
	                          "left": [
	                            markerRadius,
	                            (markerHeight - markerRadius) * -1
	                          ],
	                          "right": [
	                            -markerRadius,
	                            (markerHeight - markerRadius) * -1
	                          ]
	                        } : this._offset;
	                      }
	                      this._popup = popup;
	                      if (this._lngLat) {
	                        this._popup.setLngLat(this._lngLat);
	                      }
	                      this._originalTabIndex = this._element.getAttribute("tabindex");
	                      if (!this._originalTabIndex) {
	                        this._element.setAttribute("tabindex", "0");
	                      }
	                      this._element.addEventListener("keypress", this._onKeyPress);
	                    }
	                    return this;
	                  };
	                  Marker2.prototype._onKeyPress = function _onKeyPress(e) {
	                    var code = e.code;
	                    var legacyCode = e.charCode || e.keyCode;
	                    if (code === "Space" || code === "Enter" || legacyCode === 32 || legacyCode === 13) {
	                      this.togglePopup();
	                    }
	                  };
	                  Marker2.prototype._onMapClick = function _onMapClick(e) {
	                    var targetElement = e.originalEvent.target;
	                    var element = this._element;
	                    if (this._popup && (targetElement === element || element.contains(targetElement))) {
	                      this.togglePopup();
	                    }
	                  };
	                  Marker2.prototype.getPopup = function getPopup() {
	                    return this._popup;
	                  };
	                  Marker2.prototype.togglePopup = function togglePopup() {
	                    var popup = this._popup;
	                    if (!popup) {
	                      return this;
	                    } else if (popup.isOpen()) {
	                      popup.remove();
	                    } else {
	                      popup.addTo(this._map);
	                    }
	                    return this;
	                  };
	                  Marker2.prototype._update = function _update(e) {
	                    if (!this._map) {
	                      return;
	                    }
	                    if (this._map.transform.renderWorldCopies) {
	                      this._lngLat = smartWrap(this._lngLat, this._pos, this._map.transform);
	                    }
	                    this._pos = this._map.project(this._lngLat)._add(this._offset);
	                    var rotation = "";
	                    if (this._rotationAlignment === "viewport" || this._rotationAlignment === "auto") {
	                      rotation = "rotateZ(" + this._rotation + "deg)";
	                    } else if (this._rotationAlignment === "map") {
	                      rotation = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)";
	                    }
	                    var pitch = "";
	                    if (this._pitchAlignment === "viewport" || this._pitchAlignment === "auto") {
	                      pitch = "rotateX(0deg)";
	                    } else if (this._pitchAlignment === "map") {
	                      pitch = "rotateX(" + this._map.getPitch() + "deg)";
	                    }
	                    if (!e || e.type === "moveend") {
	                      this._pos = this._pos.round();
	                    }
	                    DOM.setTransform(this._element, anchorTranslate[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + pitch + " " + rotation);
	                  };
	                  Marker2.prototype.getOffset = function getOffset() {
	                    return this._offset;
	                  };
	                  Marker2.prototype.setOffset = function setOffset(offset) {
	                    this._offset = performance2.Point.convert(offset);
	                    this._update();
	                    return this;
	                  };
	                  Marker2.prototype._onMove = function _onMove(e) {
	                    this._pos = e.point.sub(this._positionDelta);
	                    this._lngLat = this._map.unproject(this._pos);
	                    this.setLngLat(this._lngLat);
	                    this._element.style.pointerEvents = "none";
	                    if (this._state === "pending") {
	                      this._state = "active";
	                      this.fire(new performance2.Event("dragstart"));
	                    }
	                    this.fire(new performance2.Event("drag"));
	                  };
	                  Marker2.prototype._onUp = function _onUp() {
	                    this._element.style.pointerEvents = "auto";
	                    this._positionDelta = null;
	                    this._map.off("mousemove", this._onMove);
	                    this._map.off("touchmove", this._onMove);
	                    if (this._state === "active") {
	                      this.fire(new performance2.Event("dragend"));
	                    }
	                    this._state = "inactive";
	                  };
	                  Marker2.prototype._addDragHandler = function _addDragHandler(e) {
	                    if (this._element.contains(e.originalEvent.target)) {
	                      e.preventDefault();
	                      this._positionDelta = e.point.sub(this._pos).add(this._offset);
	                      this._state = "pending";
	                      this._map.on("mousemove", this._onMove);
	                      this._map.on("touchmove", this._onMove);
	                      this._map.once("mouseup", this._onUp);
	                      this._map.once("touchend", this._onUp);
	                    }
	                  };
	                  Marker2.prototype.setDraggable = function setDraggable(shouldBeDraggable) {
	                    this._draggable = !!shouldBeDraggable;
	                    if (this._map) {
	                      if (shouldBeDraggable) {
	                        this._map.on("mousedown", this._addDragHandler);
	                        this._map.on("touchstart", this._addDragHandler);
	                      } else {
	                        this._map.off("mousedown", this._addDragHandler);
	                        this._map.off("touchstart", this._addDragHandler);
	                      }
	                    }
	                    return this;
	                  };
	                  Marker2.prototype.isDraggable = function isDraggable() {
	                    return this._draggable;
	                  };
	                  Marker2.prototype.setRotation = function setRotation(rotation) {
	                    this._rotation = rotation || 0;
	                    this._update();
	                    return this;
	                  };
	                  Marker2.prototype.getRotation = function getRotation() {
	                    return this._rotation;
	                  };
	                  Marker2.prototype.setRotationAlignment = function setRotationAlignment(alignment) {
	                    this._rotationAlignment = alignment || "auto";
	                    this._update();
	                    return this;
	                  };
	                  Marker2.prototype.getRotationAlignment = function getRotationAlignment() {
	                    return this._rotationAlignment;
	                  };
	                  Marker2.prototype.setPitchAlignment = function setPitchAlignment(alignment) {
	                    this._pitchAlignment = alignment && alignment !== "auto" ? alignment : this._rotationAlignment;
	                    this._update();
	                    return this;
	                  };
	                  Marker2.prototype.getPitchAlignment = function getPitchAlignment() {
	                    return this._pitchAlignment;
	                  };
	                  return Marker2;
	                }(performance2.Evented);
	                var defaultOptions$3 = {
	                  positionOptions: {
	                    enableHighAccuracy: false,
	                    maximumAge: 0,
	                    timeout: 6e3
	                  },
	                  fitBoundsOptions: { maxZoom: 15 },
	                  trackUserLocation: false,
	                  showAccuracyCircle: true,
	                  showUserLocation: true
	                };
	                var supportsGeolocation;
	                function checkGeolocationSupport(callback) {
	                  if (supportsGeolocation !== undefined) {
	                    callback(supportsGeolocation);
	                  } else if (performance2.window.navigator.permissions !== undefined) {
	                    performance2.window.navigator.permissions.query({ name: "geolocation" }).then(function(p) {
	                      supportsGeolocation = p.state !== "denied";
	                      callback(supportsGeolocation);
	                    });
	                  } else {
	                    supportsGeolocation = !!performance2.window.navigator.geolocation;
	                    callback(supportsGeolocation);
	                  }
	                }
	                var numberOfWatches = 0;
	                var noTimeout = false;
	                var GeolocateControl = function(Evented) {
	                  function GeolocateControl2(options) {
	                    Evented.call(this);
	                    this.options = performance2.extend({}, defaultOptions$3, options);
	                    performance2.bindAll([
	                      "_onSuccess",
	                      "_onError",
	                      "_onZoom",
	                      "_finish",
	                      "_setupUI",
	                      "_updateCamera",
	                      "_updateMarker"
	                    ], this);
	                  }
	                  if (Evented)
	                    GeolocateControl2.__proto__ = Evented;
	                  GeolocateControl2.prototype = Object.create(Evented && Evented.prototype);
	                  GeolocateControl2.prototype.constructor = GeolocateControl2;
	                  GeolocateControl2.prototype.onAdd = function onAdd(map2) {
	                    this._map = map2;
	                    this._container = DOM.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group");
	                    checkGeolocationSupport(this._setupUI);
	                    return this._container;
	                  };
	                  GeolocateControl2.prototype.onRemove = function onRemove() {
	                    if (this._geolocationWatchID !== undefined) {
	                      performance2.window.navigator.geolocation.clearWatch(this._geolocationWatchID);
	                      this._geolocationWatchID = undefined;
	                    }
	                    if (this.options.showUserLocation && this._userLocationDotMarker) {
	                      this._userLocationDotMarker.remove();
	                    }
	                    if (this.options.showAccuracyCircle && this._accuracyCircleMarker) {
	                      this._accuracyCircleMarker.remove();
	                    }
	                    DOM.remove(this._container);
	                    this._map.off("zoom", this._onZoom);
	                    this._map = undefined;
	                    numberOfWatches = 0;
	                    noTimeout = false;
	                  };
	                  GeolocateControl2.prototype._isOutOfMapMaxBounds = function _isOutOfMapMaxBounds(position) {
	                    var bounds = this._map.getMaxBounds();
	                    var coordinates = position.coords;
	                    return bounds && (coordinates.longitude < bounds.getWest() || coordinates.longitude > bounds.getEast() || coordinates.latitude < bounds.getSouth() || coordinates.latitude > bounds.getNorth());
	                  };
	                  GeolocateControl2.prototype._setErrorState = function _setErrorState() {
	                    switch (this._watchState) {
	                      case "WAITING_ACTIVE":
	                        this._watchState = "ACTIVE_ERROR";
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active");
	                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
	                        break;
	                      case "ACTIVE_LOCK":
	                        this._watchState = "ACTIVE_ERROR";
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active");
	                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
	                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
	                        break;
	                      case "BACKGROUND":
	                        this._watchState = "BACKGROUND_ERROR";
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background");
	                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
	                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
	                        break;
	                    }
	                  };
	                  GeolocateControl2.prototype._onSuccess = function _onSuccess(position) {
	                    if (!this._map) {
	                      return;
	                    }
	                    if (this._isOutOfMapMaxBounds(position)) {
	                      this._setErrorState();
	                      this.fire(new performance2.Event("outofmaxbounds", position));
	                      this._updateMarker();
	                      this._finish();
	                      return;
	                    }
	                    if (this.options.trackUserLocation) {
	                      this._lastKnownPosition = position;
	                      switch (this._watchState) {
	                        case "WAITING_ACTIVE":
	                        case "ACTIVE_LOCK":
	                        case "ACTIVE_ERROR":
	                          this._watchState = "ACTIVE_LOCK";
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting");
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error");
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
	                          break;
	                        case "BACKGROUND":
	                        case "BACKGROUND_ERROR":
	                          this._watchState = "BACKGROUND";
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting");
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error");
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
	                          break;
	                      }
	                    }
	                    if (this.options.showUserLocation && this._watchState !== "OFF") {
	                      this._updateMarker(position);
	                    }
	                    if (!this.options.trackUserLocation || this._watchState === "ACTIVE_LOCK") {
	                      this._updateCamera(position);
	                    }
	                    if (this.options.showUserLocation) {
	                      this._dotElement.classList.remove("mapboxgl-user-location-dot-stale");
	                    }
	                    this.fire(new performance2.Event("geolocate", position));
	                    this._finish();
	                  };
	                  GeolocateControl2.prototype._updateCamera = function _updateCamera(position) {
	                    var center = new performance2.LngLat(position.coords.longitude, position.coords.latitude);
	                    var radius = position.coords.accuracy;
	                    var bearing = this._map.getBearing();
	                    var options = performance2.extend({ bearing }, this.options.fitBoundsOptions);
	                    this._map.fitBounds(center.toBounds(radius), options, { geolocateSource: true });
	                  };
	                  GeolocateControl2.prototype._updateMarker = function _updateMarker(position) {
	                    if (position) {
	                      var center = new performance2.LngLat(position.coords.longitude, position.coords.latitude);
	                      this._accuracyCircleMarker.setLngLat(center).addTo(this._map);
	                      this._userLocationDotMarker.setLngLat(center).addTo(this._map);
	                      this._accuracy = position.coords.accuracy;
	                      if (this.options.showUserLocation && this.options.showAccuracyCircle) {
	                        this._updateCircleRadius();
	                      }
	                    } else {
	                      this._userLocationDotMarker.remove();
	                      this._accuracyCircleMarker.remove();
	                    }
	                  };
	                  GeolocateControl2.prototype._updateCircleRadius = function _updateCircleRadius() {
	                    var y = this._map._container.clientHeight / 2;
	                    var a = this._map.unproject([
	                      0,
	                      y
	                    ]);
	                    var b = this._map.unproject([
	                      1,
	                      y
	                    ]);
	                    var metersPerPixel = a.distanceTo(b);
	                    var circleDiameter = Math.ceil(2 * this._accuracy / metersPerPixel);
	                    this._circleElement.style.width = circleDiameter + "px";
	                    this._circleElement.style.height = circleDiameter + "px";
	                  };
	                  GeolocateControl2.prototype._onZoom = function _onZoom() {
	                    if (this.options.showUserLocation && this.options.showAccuracyCircle) {
	                      this._updateCircleRadius();
	                    }
	                  };
	                  GeolocateControl2.prototype._onError = function _onError(error) {
	                    if (!this._map) {
	                      return;
	                    }
	                    if (this.options.trackUserLocation) {
	                      if (error.code === 1) {
	                        this._watchState = "OFF";
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting");
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active");
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error");
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background");
	                        this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error");
	                        this._geolocateButton.disabled = true;
	                        var title = this._map._getUIString("GeolocateControl.LocationNotAvailable");
	                        this._geolocateButton.title = title;
	                        this._geolocateButton.setAttribute("aria-label", title);
	                        if (this._geolocationWatchID !== undefined) {
	                          this._clearWatch();
	                        }
	                      } else if (error.code === 3 && noTimeout) {
	                        return;
	                      } else {
	                        this._setErrorState();
	                      }
	                    }
	                    if (this._watchState !== "OFF" && this.options.showUserLocation) {
	                      this._dotElement.classList.add("mapboxgl-user-location-dot-stale");
	                    }
	                    this.fire(new performance2.Event("error", error));
	                    this._finish();
	                  };
	                  GeolocateControl2.prototype._finish = function _finish() {
	                    if (this._timeoutId) {
	                      clearTimeout(this._timeoutId);
	                    }
	                    this._timeoutId = undefined;
	                  };
	                  GeolocateControl2.prototype._setupUI = function _setupUI(supported) {
	                    var this$1$1 = this;
	                    this._container.addEventListener("contextmenu", function(e) {
	                      return e.preventDefault();
	                    });
	                    this._geolocateButton = DOM.create("button", "mapboxgl-ctrl-geolocate", this._container);
	                    DOM.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", true);
	                    this._geolocateButton.type = "button";
	                    if (supported === false) {
	                      performance2.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
	                      var title = this._map._getUIString("GeolocateControl.LocationNotAvailable");
	                      this._geolocateButton.disabled = true;
	                      this._geolocateButton.title = title;
	                      this._geolocateButton.setAttribute("aria-label", title);
	                    } else {
	                      var title$1 = this._map._getUIString("GeolocateControl.FindMyLocation");
	                      this._geolocateButton.title = title$1;
	                      this._geolocateButton.setAttribute("aria-label", title$1);
	                    }
	                    if (this.options.trackUserLocation) {
	                      this._geolocateButton.setAttribute("aria-pressed", "false");
	                      this._watchState = "OFF";
	                    }
	                    if (this.options.showUserLocation) {
	                      this._dotElement = DOM.create("div", "mapboxgl-user-location-dot");
	                      this._userLocationDotMarker = new Marker(this._dotElement);
	                      this._circleElement = DOM.create("div", "mapboxgl-user-location-accuracy-circle");
	                      this._accuracyCircleMarker = new Marker({
	                        element: this._circleElement,
	                        pitchAlignment: "map"
	                      });
	                      if (this.options.trackUserLocation) {
	                        this._watchState = "OFF";
	                      }
	                      this._map.on("zoom", this._onZoom);
	                    }
	                    this._geolocateButton.addEventListener("click", this.trigger.bind(this));
	                    this._setup = true;
	                    if (this.options.trackUserLocation) {
	                      this._map.on("movestart", function(event) {
	                        var fromResize = event.originalEvent && event.originalEvent.type === "resize";
	                        if (!event.geolocateSource && this$1$1._watchState === "ACTIVE_LOCK" && !fromResize) {
	                          this$1$1._watchState = "BACKGROUND";
	                          this$1$1._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
	                          this$1$1._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active");
	                          this$1$1.fire(new performance2.Event("trackuserlocationend"));
	                        }
	                      });
	                    }
	                  };
	                  GeolocateControl2.prototype.trigger = function trigger() {
	                    if (!this._setup) {
	                      performance2.warnOnce("Geolocate control triggered before added to a map");
	                      return false;
	                    }
	                    if (this.options.trackUserLocation) {
	                      switch (this._watchState) {
	                        case "OFF":
	                          this._watchState = "WAITING_ACTIVE";
	                          this.fire(new performance2.Event("trackuserlocationstart"));
	                          break;
	                        case "WAITING_ACTIVE":
	                        case "ACTIVE_LOCK":
	                        case "ACTIVE_ERROR":
	                        case "BACKGROUND_ERROR":
	                          numberOfWatches--;
	                          noTimeout = false;
	                          this._watchState = "OFF";
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting");
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active");
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error");
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background");
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error");
	                          this.fire(new performance2.Event("trackuserlocationend"));
	                          break;
	                        case "BACKGROUND":
	                          this._watchState = "ACTIVE_LOCK";
	                          this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background");
	                          if (this._lastKnownPosition) {
	                            this._updateCamera(this._lastKnownPosition);
	                          }
	                          this.fire(new performance2.Event("trackuserlocationstart"));
	                          break;
	                      }
	                      switch (this._watchState) {
	                        case "WAITING_ACTIVE":
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
	                          break;
	                        case "ACTIVE_LOCK":
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
	                          break;
	                        case "ACTIVE_ERROR":
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
	                          break;
	                        case "BACKGROUND":
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
	                          break;
	                        case "BACKGROUND_ERROR":
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
	                          this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
	                          break;
	                      }
	                      if (this._watchState === "OFF" && this._geolocationWatchID !== undefined) {
	                        this._clearWatch();
	                      } else if (this._geolocationWatchID === undefined) {
	                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
	                        this._geolocateButton.setAttribute("aria-pressed", "true");
	                        numberOfWatches++;
	                        var positionOptions;
	                        if (numberOfWatches > 1) {
	                          positionOptions = {
	                            maximumAge: 6e5,
	                            timeout: 0
	                          };
	                          noTimeout = true;
	                        } else {
	                          positionOptions = this.options.positionOptions;
	                          noTimeout = false;
	                        }
	                        this._geolocationWatchID = performance2.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, positionOptions);
	                      }
	                    } else {
	                      performance2.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions);
	                      this._timeoutId = setTimeout(this._finish, 1e4);
	                    }
	                    return true;
	                  };
	                  GeolocateControl2.prototype._clearWatch = function _clearWatch() {
	                    performance2.window.navigator.geolocation.clearWatch(this._geolocationWatchID);
	                    this._geolocationWatchID = undefined;
	                    this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting");
	                    this._geolocateButton.setAttribute("aria-pressed", "false");
	                    if (this.options.showUserLocation) {
	                      this._updateMarker(null);
	                    }
	                  };
	                  return GeolocateControl2;
	                }(performance2.Evented);
	                var defaultOptions$4 = {
	                  maxWidth: 100,
	                  unit: "metric"
	                };
	                var ScaleControl = function ScaleControl2(options) {
	                  this.options = performance2.extend({}, defaultOptions$4, options);
	                  performance2.bindAll([
	                    "_onMove",
	                    "setUnit"
	                  ], this);
	                };
	                ScaleControl.prototype.getDefaultPosition = function getDefaultPosition() {
	                  return "bottom-left";
	                };
	                ScaleControl.prototype._onMove = function _onMove() {
	                  updateScale(this._map, this._container, this.options);
	                };
	                ScaleControl.prototype.onAdd = function onAdd(map2) {
	                  this._map = map2;
	                  this._container = DOM.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", map2.getContainer());
	                  this._map.on("move", this._onMove);
	                  this._onMove();
	                  return this._container;
	                };
	                ScaleControl.prototype.onRemove = function onRemove() {
	                  DOM.remove(this._container);
	                  this._map.off("move", this._onMove);
	                  this._map = undefined;
	                };
	                ScaleControl.prototype.setUnit = function setUnit(unit) {
	                  this.options.unit = unit;
	                  updateScale(this._map, this._container, this.options);
	                };
	                function updateScale(map2, container, options) {
	                  var maxWidth = options && options.maxWidth || 100;
	                  var y = map2._container.clientHeight / 2;
	                  var left = map2.unproject([
	                    0,
	                    y
	                  ]);
	                  var right = map2.unproject([
	                    maxWidth,
	                    y
	                  ]);
	                  var maxMeters = left.distanceTo(right);
	                  if (options && options.unit === "imperial") {
	                    var maxFeet = 3.2808 * maxMeters;
	                    if (maxFeet > 5280) {
	                      var maxMiles = maxFeet / 5280;
	                      setScale(container, maxWidth, maxMiles, map2._getUIString("ScaleControl.Miles"));
	                    } else {
	                      setScale(container, maxWidth, maxFeet, map2._getUIString("ScaleControl.Feet"));
	                    }
	                  } else if (options && options.unit === "nautical") {
	                    var maxNauticals = maxMeters / 1852;
	                    setScale(container, maxWidth, maxNauticals, map2._getUIString("ScaleControl.NauticalMiles"));
	                  } else if (maxMeters >= 1e3) {
	                    setScale(container, maxWidth, maxMeters / 1e3, map2._getUIString("ScaleControl.Kilometers"));
	                  } else {
	                    setScale(container, maxWidth, maxMeters, map2._getUIString("ScaleControl.Meters"));
	                  }
	                }
	                function setScale(container, maxWidth, maxDistance, unit) {
	                  var distance = getRoundNum(maxDistance);
	                  var ratio = distance / maxDistance;
	                  container.style.width = maxWidth * ratio + "px";
	                  container.innerHTML = distance + "&nbsp;" + unit;
	                }
	                function getDecimalRoundNum(d) {
	                  var multiplier = Math.pow(10, Math.ceil(-Math.log(d) / Math.LN10));
	                  return Math.round(d * multiplier) / multiplier;
	                }
	                function getRoundNum(num) {
	                  var pow10 = Math.pow(10, ("" + Math.floor(num)).length - 1);
	                  var d = num / pow10;
	                  d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : d >= 1 ? 1 : getDecimalRoundNum(d);
	                  return pow10 * d;
	                }
	                var FullscreenControl = function FullscreenControl2(options) {
	                  this._fullscreen = false;
	                  if (options && options.container) {
	                    if (options.container instanceof performance2.window.HTMLElement) {
	                      this._container = options.container;
	                    } else {
	                      performance2.warnOnce("Full screen control 'container' must be a DOM element.");
	                    }
	                  }
	                  performance2.bindAll([
	                    "_onClickFullscreen",
	                    "_changeIcon"
	                  ], this);
	                  if ("onfullscreenchange" in performance2.window.document) {
	                    this._fullscreenchange = "fullscreenchange";
	                  } else if ("onmozfullscreenchange" in performance2.window.document) {
	                    this._fullscreenchange = "mozfullscreenchange";
	                  } else if ("onwebkitfullscreenchange" in performance2.window.document) {
	                    this._fullscreenchange = "webkitfullscreenchange";
	                  } else if ("onmsfullscreenchange" in performance2.window.document) {
	                    this._fullscreenchange = "MSFullscreenChange";
	                  }
	                };
	                FullscreenControl.prototype.onAdd = function onAdd(map2) {
	                  this._map = map2;
	                  if (!this._container) {
	                    this._container = this._map.getContainer();
	                  }
	                  this._controlContainer = DOM.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group");
	                  if (this._checkFullscreenSupport()) {
	                    this._setupUI();
	                  } else {
	                    this._controlContainer.style.display = "none";
	                    performance2.warnOnce("This device does not support fullscreen mode.");
	                  }
	                  return this._controlContainer;
	                };
	                FullscreenControl.prototype.onRemove = function onRemove() {
	                  DOM.remove(this._controlContainer);
	                  this._map = null;
	                  performance2.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
	                };
	                FullscreenControl.prototype._checkFullscreenSupport = function _checkFullscreenSupport() {
	                  return !!(performance2.window.document.fullscreenEnabled || performance2.window.document.mozFullScreenEnabled || performance2.window.document.msFullscreenEnabled || performance2.window.document.webkitFullscreenEnabled);
	                };
	                FullscreenControl.prototype._setupUI = function _setupUI() {
	                  var button = this._fullscreenButton = DOM.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
	                  DOM.create("span", "mapboxgl-ctrl-icon", button).setAttribute("aria-hidden", true);
	                  button.type = "button";
	                  this._updateTitle();
	                  this._fullscreenButton.addEventListener("click", this._onClickFullscreen);
	                  performance2.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
	                };
	                FullscreenControl.prototype._updateTitle = function _updateTitle() {
	                  var title = this._getTitle();
	                  this._fullscreenButton.setAttribute("aria-label", title);
	                  this._fullscreenButton.title = title;
	                };
	                FullscreenControl.prototype._getTitle = function _getTitle() {
	                  return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
	                };
	                FullscreenControl.prototype._isFullscreen = function _isFullscreen() {
	                  return this._fullscreen;
	                };
	                FullscreenControl.prototype._changeIcon = function _changeIcon() {
	                  var fullscreenElement = performance2.window.document.fullscreenElement || performance2.window.document.mozFullScreenElement || performance2.window.document.webkitFullscreenElement || performance2.window.document.msFullscreenElement;
	                  if (fullscreenElement === this._container !== this._fullscreen) {
	                    this._fullscreen = !this._fullscreen;
	                    this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink");
	                    this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen");
	                    this._updateTitle();
	                  }
	                };
	                FullscreenControl.prototype._onClickFullscreen = function _onClickFullscreen() {
	                  if (this._isFullscreen()) {
	                    if (performance2.window.document.exitFullscreen) {
	                      performance2.window.document.exitFullscreen();
	                    } else if (performance2.window.document.mozCancelFullScreen) {
	                      performance2.window.document.mozCancelFullScreen();
	                    } else if (performance2.window.document.msExitFullscreen) {
	                      performance2.window.document.msExitFullscreen();
	                    } else if (performance2.window.document.webkitCancelFullScreen) {
	                      performance2.window.document.webkitCancelFullScreen();
	                    }
	                  } else if (this._container.requestFullscreen) {
	                    this._container.requestFullscreen();
	                  } else if (this._container.mozRequestFullScreen) {
	                    this._container.mozRequestFullScreen();
	                  } else if (this._container.msRequestFullscreen) {
	                    this._container.msRequestFullscreen();
	                  } else if (this._container.webkitRequestFullscreen) {
	                    this._container.webkitRequestFullscreen();
	                  }
	                };
	                var defaultOptions$5 = {
	                  closeButton: true,
	                  closeOnClick: true,
	                  className: "",
	                  maxWidth: "240px"
	                };
	                var Popup = function(Evented) {
	                  function Popup2(options) {
	                    Evented.call(this);
	                    this.options = performance2.extend(Object.create(defaultOptions$5), options);
	                    performance2.bindAll([
	                      "_update",
	                      "_onClose",
	                      "remove",
	                      "_onMouseMove",
	                      "_onMouseUp",
	                      "_onDrag"
	                    ], this);
	                  }
	                  if (Evented)
	                    Popup2.__proto__ = Evented;
	                  Popup2.prototype = Object.create(Evented && Evented.prototype);
	                  Popup2.prototype.constructor = Popup2;
	                  Popup2.prototype.addTo = function addTo(map2) {
	                    if (this._map) {
	                      this.remove();
	                    }
	                    this._map = map2;
	                    if (this.options.closeOnClick) {
	                      this._map.on("click", this._onClose);
	                    }
	                    if (this.options.closeOnMove) {
	                      this._map.on("move", this._onClose);
	                    }
	                    this._map.on("remove", this.remove);
	                    this._update();
	                    if (this._trackPointer) {
	                      this._map.on("mousemove", this._onMouseMove);
	                      this._map.on("mouseup", this._onMouseUp);
	                      if (this._container) {
	                        this._container.classList.add("mapboxgl-popup-track-pointer");
	                      }
	                      this._map._canvasContainer.classList.add("mapboxgl-track-pointer");
	                    } else {
	                      this._map.on("move", this._update);
	                    }
	                    this.fire(new performance2.Event("open"));
	                    return this;
	                  };
	                  Popup2.prototype.isOpen = function isOpen() {
	                    return !!this._map;
	                  };
	                  Popup2.prototype.remove = function remove() {
	                    if (this._content) {
	                      DOM.remove(this._content);
	                    }
	                    if (this._container) {
	                      DOM.remove(this._container);
	                      delete this._container;
	                    }
	                    if (this._map) {
	                      this._map.off("move", this._update);
	                      this._map.off("move", this._onClose);
	                      this._map.off("click", this._onClose);
	                      this._map.off("remove", this.remove);
	                      this._map.off("mousemove", this._onMouseMove);
	                      this._map.off("mouseup", this._onMouseUp);
	                      this._map.off("drag", this._onDrag);
	                      delete this._map;
	                    }
	                    this.fire(new performance2.Event("close"));
	                    return this;
	                  };
	                  Popup2.prototype.getLngLat = function getLngLat() {
	                    return this._lngLat;
	                  };
	                  Popup2.prototype.setLngLat = function setLngLat(lnglat) {
	                    this._lngLat = performance2.LngLat.convert(lnglat);
	                    this._pos = null;
	                    this._trackPointer = false;
	                    this._update();
	                    if (this._map) {
	                      this._map.on("move", this._update);
	                      this._map.off("mousemove", this._onMouseMove);
	                      if (this._container) {
	                        this._container.classList.remove("mapboxgl-popup-track-pointer");
	                      }
	                      this._map._canvasContainer.classList.remove("mapboxgl-track-pointer");
	                    }
	                    return this;
	                  };
	                  Popup2.prototype.trackPointer = function trackPointer() {
	                    this._trackPointer = true;
	                    this._pos = null;
	                    this._update();
	                    if (this._map) {
	                      this._map.off("move", this._update);
	                      this._map.on("mousemove", this._onMouseMove);
	                      this._map.on("drag", this._onDrag);
	                      if (this._container) {
	                        this._container.classList.add("mapboxgl-popup-track-pointer");
	                      }
	                      this._map._canvasContainer.classList.add("mapboxgl-track-pointer");
	                    }
	                    return this;
	                  };
	                  Popup2.prototype.getElement = function getElement() {
	                    return this._container;
	                  };
	                  Popup2.prototype.setText = function setText(text) {
	                    return this.setDOMContent(performance2.window.document.createTextNode(text));
	                  };
	                  Popup2.prototype.setHTML = function setHTML(html) {
	                    var frag = performance2.window.document.createDocumentFragment();
	                    var temp = performance2.window.document.createElement("body");
	                    var child;
	                    temp.innerHTML = html;
	                    while (true) {
	                      child = temp.firstChild;
	                      if (!child) {
	                        break;
	                      }
	                      frag.appendChild(child);
	                    }
	                    return this.setDOMContent(frag);
	                  };
	                  Popup2.prototype.getMaxWidth = function getMaxWidth() {
	                    return this._container && this._container.style.maxWidth;
	                  };
	                  Popup2.prototype.setMaxWidth = function setMaxWidth(maxWidth) {
	                    this.options.maxWidth = maxWidth;
	                    this._update();
	                    return this;
	                  };
	                  Popup2.prototype.setDOMContent = function setDOMContent(htmlNode) {
	                    this._createContent();
	                    this._content.appendChild(htmlNode);
	                    this._update();
	                    return this;
	                  };
	                  Popup2.prototype.addClassName = function addClassName(className) {
	                    if (this._container) {
	                      this._container.classList.add(className);
	                    }
	                  };
	                  Popup2.prototype.removeClassName = function removeClassName(className) {
	                    if (this._container) {
	                      this._container.classList.remove(className);
	                    }
	                  };
	                  Popup2.prototype.toggleClassName = function toggleClassName(className) {
	                    if (this._container) {
	                      return this._container.classList.toggle(className);
	                    }
	                  };
	                  Popup2.prototype._createContent = function _createContent() {
	                    if (this._content) {
	                      DOM.remove(this._content);
	                    }
	                    this._content = DOM.create("div", "mapboxgl-popup-content", this._container);
	                    if (this.options.closeButton) {
	                      this._closeButton = DOM.create("button", "mapboxgl-popup-close-button", this._content);
	                      this._closeButton.type = "button";
	                      this._closeButton.setAttribute("aria-label", "Close popup");
	                      this._closeButton.innerHTML = "&#215;";
	                      this._closeButton.addEventListener("click", this._onClose);
	                    }
	                  };
	                  Popup2.prototype._onMouseUp = function _onMouseUp(event) {
	                    this._update(event.point);
	                  };
	                  Popup2.prototype._onMouseMove = function _onMouseMove(event) {
	                    this._update(event.point);
	                  };
	                  Popup2.prototype._onDrag = function _onDrag(event) {
	                    this._update(event.point);
	                  };
	                  Popup2.prototype._update = function _update(cursor) {
	                    var this$1$1 = this;
	                    var hasPosition = this._lngLat || this._trackPointer;
	                    if (!this._map || !hasPosition || !this._content) {
	                      return;
	                    }
	                    if (!this._container) {
	                      this._container = DOM.create("div", "mapboxgl-popup", this._map.getContainer());
	                      this._tip = DOM.create("div", "mapboxgl-popup-tip", this._container);
	                      this._container.appendChild(this._content);
	                      if (this.options.className) {
	                        this.options.className.split(" ").forEach(function(name2) {
	                          return this$1$1._container.classList.add(name2);
	                        });
	                      }
	                      if (this._trackPointer) {
	                        this._container.classList.add("mapboxgl-popup-track-pointer");
	                      }
	                    }
	                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth) {
	                      this._container.style.maxWidth = this.options.maxWidth;
	                    }
	                    if (this._map.transform.renderWorldCopies && !this._trackPointer) {
	                      this._lngLat = smartWrap(this._lngLat, this._pos, this._map.transform);
	                    }
	                    if (this._trackPointer && !cursor) {
	                      return;
	                    }
	                    var pos = this._pos = this._trackPointer && cursor ? cursor : this._map.project(this._lngLat);
	                    var anchor = this.options.anchor;
	                    var offset = normalizeOffset(this.options.offset);
	                    if (!anchor) {
	                      var width = this._container.offsetWidth;
	                      var height = this._container.offsetHeight;
	                      var anchorComponents;
	                      if (pos.y + offset.bottom.y < height) {
	                        anchorComponents = ["top"];
	                      } else if (pos.y > this._map.transform.height - height) {
	                        anchorComponents = ["bottom"];
	                      } else {
	                        anchorComponents = [];
	                      }
	                      if (pos.x < width / 2) {
	                        anchorComponents.push("left");
	                      } else if (pos.x > this._map.transform.width - width / 2) {
	                        anchorComponents.push("right");
	                      }
	                      if (anchorComponents.length === 0) {
	                        anchor = "bottom";
	                      } else {
	                        anchor = anchorComponents.join("-");
	                      }
	                    }
	                    var offsetedPos = pos.add(offset[anchor]).round();
	                    DOM.setTransform(this._container, anchorTranslate[anchor] + " translate(" + offsetedPos.x + "px," + offsetedPos.y + "px)");
	                    applyAnchorClass(this._container, anchor, "popup");
	                  };
	                  Popup2.prototype._onClose = function _onClose() {
	                    this.remove();
	                  };
	                  return Popup2;
	                }(performance2.Evented);
	                function normalizeOffset(offset) {
	                  if (!offset) {
	                    return normalizeOffset(new performance2.Point(0, 0));
	                  } else if (typeof offset === "number") {
	                    var cornerOffset = Math.round(Math.sqrt(0.5 * Math.pow(offset, 2)));
	                    return {
	                      "center": new performance2.Point(0, 0),
	                      "top": new performance2.Point(0, offset),
	                      "top-left": new performance2.Point(cornerOffset, cornerOffset),
	                      "top-right": new performance2.Point(-cornerOffset, cornerOffset),
	                      "bottom": new performance2.Point(0, -offset),
	                      "bottom-left": new performance2.Point(cornerOffset, -cornerOffset),
	                      "bottom-right": new performance2.Point(-cornerOffset, -cornerOffset),
	                      "left": new performance2.Point(offset, 0),
	                      "right": new performance2.Point(-offset, 0)
	                    };
	                  } else if (offset instanceof performance2.Point || Array.isArray(offset)) {
	                    var convertedOffset = performance2.Point.convert(offset);
	                    return {
	                      "center": convertedOffset,
	                      "top": convertedOffset,
	                      "top-left": convertedOffset,
	                      "top-right": convertedOffset,
	                      "bottom": convertedOffset,
	                      "bottom-left": convertedOffset,
	                      "bottom-right": convertedOffset,
	                      "left": convertedOffset,
	                      "right": convertedOffset
	                    };
	                  } else {
	                    return {
	                      "center": performance2.Point.convert(offset["center"] || [
	                        0,
	                        0
	                      ]),
	                      "top": performance2.Point.convert(offset["top"] || [
	                        0,
	                        0
	                      ]),
	                      "top-left": performance2.Point.convert(offset["top-left"] || [
	                        0,
	                        0
	                      ]),
	                      "top-right": performance2.Point.convert(offset["top-right"] || [
	                        0,
	                        0
	                      ]),
	                      "bottom": performance2.Point.convert(offset["bottom"] || [
	                        0,
	                        0
	                      ]),
	                      "bottom-left": performance2.Point.convert(offset["bottom-left"] || [
	                        0,
	                        0
	                      ]),
	                      "bottom-right": performance2.Point.convert(offset["bottom-right"] || [
	                        0,
	                        0
	                      ]),
	                      "left": performance2.Point.convert(offset["left"] || [
	                        0,
	                        0
	                      ]),
	                      "right": performance2.Point.convert(offset["right"] || [
	                        0,
	                        0
	                      ])
	                    };
	                  }
	                }
	                var exported = {
	                  version: performance2.version,
	                  supported: mapboxGlSupported,
	                  setRTLTextPlugin: performance2.setRTLTextPlugin,
	                  getRTLTextPluginStatus: performance2.getRTLTextPluginStatus,
	                  Map: Map2,
	                  NavigationControl,
	                  GeolocateControl,
	                  AttributionControl,
	                  ScaleControl,
	                  FullscreenControl,
	                  Popup,
	                  Marker,
	                  Style,
	                  LngLat: performance2.LngLat,
	                  LngLatBounds: performance2.LngLatBounds,
	                  Point: performance2.Point,
	                  MercatorCoordinate: performance2.MercatorCoordinate,
	                  Evented: performance2.Evented,
	                  config: performance2.config,
	                  prewarm,
	                  clearPrewarmedResources,
	                  get accessToken() {
	                    return performance2.config.ACCESS_TOKEN;
	                  },
	                  set accessToken(token) {
	                    performance2.config.ACCESS_TOKEN = token;
	                  },
	                  get baseApiUrl() {
	                    return performance2.config.API_URL;
	                  },
	                  set baseApiUrl(url) {
	                    performance2.config.API_URL = url;
	                  },
	                  get workerCount() {
	                    return WorkerPool.workerCount;
	                  },
	                  set workerCount(count) {
	                    WorkerPool.workerCount = count;
	                  },
	                  get maxParallelImageRequests() {
	                    return performance2.config.MAX_PARALLEL_IMAGE_REQUESTS;
	                  },
	                  set maxParallelImageRequests(numRequests) {
	                    performance2.config.MAX_PARALLEL_IMAGE_REQUESTS = numRequests;
	                  },
	                  clearStorage: function clearStorage(callback) {
	                    performance2.clearTileCache(callback);
	                  },
	                  workerUrl: ""
	                };
	                return exported;
	              });
	              return mapboxgl;
	            });
	          }
	        ),
	        /***/
	        27084: (
	          /***/
	          function(module2) {
	            module2.exports = Math.log2 || function(x) {
	              return Math.log(x) * Math.LOG2E;
	            };
	          }
	        ),
	        /***/
	        16825: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = mouseListen;
	            var mouse = __webpack_require__2(74311);
	            function mouseListen(element, callback) {
	              if (!callback) {
	                callback = element;
	                element = window;
	              }
	              var buttonState = 0;
	              var x = 0;
	              var y = 0;
	              var mods = {
	                shift: false,
	                alt: false,
	                control: false,
	                meta: false
	              };
	              var attached = false;
	              function updateMods(ev) {
	                var changed = false;
	                if ("altKey" in ev) {
	                  changed = changed || ev.altKey !== mods.alt;
	                  mods.alt = !!ev.altKey;
	                }
	                if ("shiftKey" in ev) {
	                  changed = changed || ev.shiftKey !== mods.shift;
	                  mods.shift = !!ev.shiftKey;
	                }
	                if ("ctrlKey" in ev) {
	                  changed = changed || ev.ctrlKey !== mods.control;
	                  mods.control = !!ev.ctrlKey;
	                }
	                if ("metaKey" in ev) {
	                  changed = changed || ev.metaKey !== mods.meta;
	                  mods.meta = !!ev.metaKey;
	                }
	                return changed;
	              }
	              function handleEvent(nextButtons, ev) {
	                var nextX = mouse.x(ev);
	                var nextY = mouse.y(ev);
	                if ("buttons" in ev) {
	                  nextButtons = ev.buttons | 0;
	                }
	                if (nextButtons !== buttonState || nextX !== x || nextY !== y || updateMods(ev)) {
	                  buttonState = nextButtons | 0;
	                  x = nextX || 0;
	                  y = nextY || 0;
	                  callback && callback(buttonState, x, y, mods);
	                }
	              }
	              function clearState(ev) {
	                handleEvent(0, ev);
	              }
	              function handleBlur() {
	                if (buttonState || x || y || mods.shift || mods.alt || mods.meta || mods.control) {
	                  x = y = 0;
	                  buttonState = 0;
	                  mods.shift = mods.alt = mods.control = mods.meta = false;
	                  callback && callback(0, 0, 0, mods);
	                }
	              }
	              function handleMods(ev) {
	                if (updateMods(ev)) {
	                  callback && callback(buttonState, x, y, mods);
	                }
	              }
	              function handleMouseMove(ev) {
	                if (mouse.buttons(ev) === 0) {
	                  handleEvent(0, ev);
	                } else {
	                  handleEvent(buttonState, ev);
	                }
	              }
	              function handleMouseDown(ev) {
	                handleEvent(buttonState | mouse.buttons(ev), ev);
	              }
	              function handleMouseUp(ev) {
	                handleEvent(buttonState & ~mouse.buttons(ev), ev);
	              }
	              function attachListeners() {
	                if (attached) {
	                  return;
	                }
	                attached = true;
	                element.addEventListener("mousemove", handleMouseMove);
	                element.addEventListener("mousedown", handleMouseDown);
	                element.addEventListener("mouseup", handleMouseUp);
	                element.addEventListener("mouseleave", clearState);
	                element.addEventListener("mouseenter", clearState);
	                element.addEventListener("mouseout", clearState);
	                element.addEventListener("mouseover", clearState);
	                element.addEventListener("blur", handleBlur);
	                element.addEventListener("keyup", handleMods);
	                element.addEventListener("keydown", handleMods);
	                element.addEventListener("keypress", handleMods);
	                if (element !== window) {
	                  window.addEventListener("blur", handleBlur);
	                  window.addEventListener("keyup", handleMods);
	                  window.addEventListener("keydown", handleMods);
	                  window.addEventListener("keypress", handleMods);
	                }
	              }
	              function detachListeners() {
	                if (!attached) {
	                  return;
	                }
	                attached = false;
	                element.removeEventListener("mousemove", handleMouseMove);
	                element.removeEventListener("mousedown", handleMouseDown);
	                element.removeEventListener("mouseup", handleMouseUp);
	                element.removeEventListener("mouseleave", clearState);
	                element.removeEventListener("mouseenter", clearState);
	                element.removeEventListener("mouseout", clearState);
	                element.removeEventListener("mouseover", clearState);
	                element.removeEventListener("blur", handleBlur);
	                element.removeEventListener("keyup", handleMods);
	                element.removeEventListener("keydown", handleMods);
	                element.removeEventListener("keypress", handleMods);
	                if (element !== window) {
	                  window.removeEventListener("blur", handleBlur);
	                  window.removeEventListener("keyup", handleMods);
	                  window.removeEventListener("keydown", handleMods);
	                  window.removeEventListener("keypress", handleMods);
	                }
	              }
	              attachListeners();
	              var result = {
	                element
	              };
	              Object.defineProperties(result, {
	                enabled: {
	                  get: function() {
	                    return attached;
	                  },
	                  set: function(f) {
	                    if (f) {
	                      attachListeners();
	                    } else {
	                      detachListeners();
	                    }
	                  },
	                  enumerable: true
	                },
	                buttons: {
	                  get: function() {
	                    return buttonState;
	                  },
	                  enumerable: true
	                },
	                x: {
	                  get: function() {
	                    return x;
	                  },
	                  enumerable: true
	                },
	                y: {
	                  get: function() {
	                    return y;
	                  },
	                  enumerable: true
	                },
	                mods: {
	                  get: function() {
	                    return mods;
	                  },
	                  enumerable: true
	                }
	              });
	              return result;
	            }
	          }
	        ),
	        /***/
	        48956: (
	          /***/
	          function(module2) {
	            var rootPosition = { left: 0, top: 0 };
	            module2.exports = mouseEventOffset;
	            function mouseEventOffset(ev, target, out) {
	              target = target || ev.currentTarget || ev.srcElement;
	              if (!Array.isArray(out)) {
	                out = [0, 0];
	              }
	              var cx = ev.clientX || 0;
	              var cy = ev.clientY || 0;
	              var rect = getBoundingClientOffset(target);
	              out[0] = cx - rect.left;
	              out[1] = cy - rect.top;
	              return out;
	            }
	            function getBoundingClientOffset(element) {
	              if (element === window || element === document || element === document.body) {
	                return rootPosition;
	              } else {
	                return element.getBoundingClientRect();
	              }
	            }
	          }
	        ),
	        /***/
	        74311: (
	          /***/
	          function(__unused_webpack_module, exports2) {
	            function mouseButtons(ev) {
	              if (typeof ev === "object") {
	                if ("buttons" in ev) {
	                  return ev.buttons;
	                } else if ("which" in ev) {
	                  var b = ev.which;
	                  if (b === 2) {
	                    return 4;
	                  } else if (b === 3) {
	                    return 2;
	                  } else if (b > 0) {
	                    return 1 << b - 1;
	                  }
	                } else if ("button" in ev) {
	                  var b = ev.button;
	                  if (b === 1) {
	                    return 4;
	                  } else if (b === 2) {
	                    return 2;
	                  } else if (b >= 0) {
	                    return 1 << b;
	                  }
	                }
	              }
	              return 0;
	            }
	            exports2.buttons = mouseButtons;
	            function mouseElement(ev) {
	              return ev.target || ev.srcElement || window;
	            }
	            exports2.element = mouseElement;
	            function mouseRelativeX(ev) {
	              if (typeof ev === "object") {
	                if ("offsetX" in ev) {
	                  return ev.offsetX;
	                }
	                var target = mouseElement(ev);
	                var bounds = target.getBoundingClientRect();
	                return ev.clientX - bounds.left;
	              }
	              return 0;
	            }
	            exports2.x = mouseRelativeX;
	            function mouseRelativeY(ev) {
	              if (typeof ev === "object") {
	                if ("offsetY" in ev) {
	                  return ev.offsetY;
	                }
	                var target = mouseElement(ev);
	                var bounds = target.getBoundingClientRect();
	                return ev.clientY - bounds.top;
	              }
	              return 0;
	            }
	            exports2.y = mouseRelativeY;
	          }
	        ),
	        /***/
	        1195: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var toPX = __webpack_require__2(75686);
	            module2.exports = mouseWheelListen;
	            function mouseWheelListen(element, callback, noScroll) {
	              if (typeof element === "function") {
	                noScroll = !!callback;
	                callback = element;
	                element = window;
	              }
	              var lineHeight = toPX("ex", element);
	              var listener = function(ev) {
	                if (noScroll) {
	                  ev.preventDefault();
	                }
	                var dx = ev.deltaX || 0;
	                var dy = ev.deltaY || 0;
	                var dz = ev.deltaZ || 0;
	                var mode = ev.deltaMode;
	                var scale = 1;
	                switch (mode) {
	                  case 1:
	                    scale = lineHeight;
	                    break;
	                  case 2:
	                    scale = window.innerHeight;
	                    break;
	                }
	                dx *= scale;
	                dy *= scale;
	                dz *= scale;
	                if (dx || dy || dz) {
	                  return callback(dx, dy, dz, ev);
	                }
	              };
	              element.addEventListener("wheel", listener);
	              return listener;
	            }
	          }
	        ),
	        /***/
	        7417: (
	          /***/
	          function(module2, exports2, __webpack_require__2) {
	            var __WEBPACK_AMD_DEFINE_RESULT__;
	            /*! Native Promise Only
	                v0.8.1 (c) Kyle Simpson
	                MIT License: http://getify.mit-license.org
	            */
	            (function UMD(name2, context, definition) {
	              context[name2] = context[name2] || definition();
	              if (module2.exports) {
	                module2.exports = context[name2];
	              } else {
	                !(__WEBPACK_AMD_DEFINE_RESULT__ = function $AMD$() {
	                  return context[name2];
	                }.call(exports2, __webpack_require__2, exports2, module2), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module2.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	              }
	            })("Promise", typeof __webpack_require__2.g != "undefined" ? __webpack_require__2.g : this, function DEF() {
	              var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer2(fn) {
	                return setImmediate(fn);
	              } : setTimeout;
	              try {
	                Object.defineProperty({}, "x", {});
	                builtInProp = function builtInProp2(obj, name2, val, config) {
	                  return Object.defineProperty(obj, name2, {
	                    value: val,
	                    writable: true,
	                    configurable: config !== false
	                  });
	                };
	              } catch (err) {
	                builtInProp = function builtInProp2(obj, name2, val) {
	                  obj[name2] = val;
	                  return obj;
	                };
	              }
	              scheduling_queue = /* @__PURE__ */ function Queue() {
	                var first, last, item;
	                function Item(fn, self2) {
	                  this.fn = fn;
	                  this.self = self2;
	                  this.next = undefined;
	                }
	                return {
	                  add: function add(fn, self2) {
	                    item = new Item(fn, self2);
	                    if (last) {
	                      last.next = item;
	                    } else {
	                      first = item;
	                    }
	                    last = item;
	                    item = undefined;
	                  },
	                  drain: function drain() {
	                    var f = first;
	                    first = last = cycle = undefined;
	                    while (f) {
	                      f.fn.call(f.self);
	                      f = f.next;
	                    }
	                  }
	                };
	              }();
	              function schedule(fn, self2) {
	                scheduling_queue.add(fn, self2);
	                if (!cycle) {
	                  cycle = timer(scheduling_queue.drain);
	                }
	              }
	              function isThenable(o) {
	                var _then, o_type = typeof o;
	                if (o != null && (o_type == "object" || o_type == "function")) {
	                  _then = o.then;
	                }
	                return typeof _then == "function" ? _then : false;
	              }
	              function notify() {
	                for (var i = 0; i < this.chain.length; i++) {
	                  notifyIsolated(
	                    this,
	                    this.state === 1 ? this.chain[i].success : this.chain[i].failure,
	                    this.chain[i]
	                  );
	                }
	                this.chain.length = 0;
	              }
	              function notifyIsolated(self2, cb, chain) {
	                var ret, _then;
	                try {
	                  if (cb === false) {
	                    chain.reject(self2.msg);
	                  } else {
	                    if (cb === true) {
	                      ret = self2.msg;
	                    } else {
	                      ret = cb.call(void 0, self2.msg);
	                    }
	                    if (ret === chain.promise) {
	                      chain.reject(TypeError("Promise-chain cycle"));
	                    } else if (_then = isThenable(ret)) {
	                      _then.call(ret, chain.resolve, chain.reject);
	                    } else {
	                      chain.resolve(ret);
	                    }
	                  }
	                } catch (err) {
	                  chain.reject(err);
	                }
	              }
	              function resolve(msg) {
	                var _then, self2 = this;
	                if (self2.triggered) {
	                  return;
	                }
	                self2.triggered = true;
	                if (self2.def) {
	                  self2 = self2.def;
	                }
	                try {
	                  if (_then = isThenable(msg)) {
	                    schedule(function() {
	                      var def_wrapper = new MakeDefWrapper(self2);
	                      try {
	                        _then.call(
	                          msg,
	                          function $resolve$() {
	                            resolve.apply(def_wrapper, arguments);
	                          },
	                          function $reject$() {
	                            reject.apply(def_wrapper, arguments);
	                          }
	                        );
	                      } catch (err) {
	                        reject.call(def_wrapper, err);
	                      }
	                    });
	                  } else {
	                    self2.msg = msg;
	                    self2.state = 1;
	                    if (self2.chain.length > 0) {
	                      schedule(notify, self2);
	                    }
	                  }
	                } catch (err) {
	                  reject.call(new MakeDefWrapper(self2), err);
	                }
	              }
	              function reject(msg) {
	                var self2 = this;
	                if (self2.triggered) {
	                  return;
	                }
	                self2.triggered = true;
	                if (self2.def) {
	                  self2 = self2.def;
	                }
	                self2.msg = msg;
	                self2.state = 2;
	                if (self2.chain.length > 0) {
	                  schedule(notify, self2);
	                }
	              }
	              function iteratePromises(Constructor, arr, resolver, rejecter) {
	                for (var idx = 0; idx < arr.length; idx++) {
	                  (function IIFE(idx2) {
	                    Constructor.resolve(arr[idx2]).then(
	                      function $resolver$(msg) {
	                        resolver(idx2, msg);
	                      },
	                      rejecter
	                    );
	                  })(idx);
	                }
	              }
	              function MakeDefWrapper(self2) {
	                this.def = self2;
	                this.triggered = false;
	              }
	              function MakeDef(self2) {
	                this.promise = self2;
	                this.state = 0;
	                this.triggered = false;
	                this.chain = [];
	                this.msg = undefined;
	              }
	              function Promise2(executor) {
	                if (typeof executor != "function") {
	                  throw TypeError("Not a function");
	                }
	                if (this.__NPO__ !== 0) {
	                  throw TypeError("Not a promise");
	                }
	                this.__NPO__ = 1;
	                var def = new MakeDef(this);
	                this["then"] = function then(success, failure) {
	                  var o = {
	                    success: typeof success == "function" ? success : true,
	                    failure: typeof failure == "function" ? failure : false
	                  };
	                  o.promise = new this.constructor(function extractChain(resolve2, reject2) {
	                    if (typeof resolve2 != "function" || typeof reject2 != "function") {
	                      throw TypeError("Not a function");
	                    }
	                    o.resolve = resolve2;
	                    o.reject = reject2;
	                  });
	                  def.chain.push(o);
	                  if (def.state !== 0) {
	                    schedule(notify, def);
	                  }
	                  return o.promise;
	                };
	                this["catch"] = function $catch$(failure) {
	                  return this.then(undefined, failure);
	                };
	                try {
	                  executor.call(
	                    void 0,
	                    function publicResolve(msg) {
	                      resolve.call(def, msg);
	                    },
	                    function publicReject(msg) {
	                      reject.call(def, msg);
	                    }
	                  );
	                } catch (err) {
	                  reject.call(def, err);
	                }
	              }
	              var PromisePrototype = builtInProp(
	                {},
	                "constructor",
	                Promise2,
	                /*configurable=*/
	                false
	              );
	              Promise2.prototype = PromisePrototype;
	              builtInProp(
	                PromisePrototype,
	                "__NPO__",
	                0,
	                /*configurable=*/
	                false
	              );
	              builtInProp(Promise2, "resolve", function Promise$resolve(msg) {
	                var Constructor = this;
	                if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
	                  return msg;
	                }
	                return new Constructor(function executor(resolve2, reject2) {
	                  if (typeof resolve2 != "function" || typeof reject2 != "function") {
	                    throw TypeError("Not a function");
	                  }
	                  resolve2(msg);
	                });
	              });
	              builtInProp(Promise2, "reject", function Promise$reject(msg) {
	                return new this(function executor(resolve2, reject2) {
	                  if (typeof resolve2 != "function" || typeof reject2 != "function") {
	                    throw TypeError("Not a function");
	                  }
	                  reject2(msg);
	                });
	              });
	              builtInProp(Promise2, "all", function Promise$all(arr) {
	                var Constructor = this;
	                if (ToString.call(arr) != "[object Array]") {
	                  return Constructor.reject(TypeError("Not an array"));
	                }
	                if (arr.length === 0) {
	                  return Constructor.resolve([]);
	                }
	                return new Constructor(function executor(resolve2, reject2) {
	                  if (typeof resolve2 != "function" || typeof reject2 != "function") {
	                    throw TypeError("Not a function");
	                  }
	                  var len = arr.length, msgs = Array(len), count = 0;
	                  iteratePromises(Constructor, arr, function resolver(idx, msg) {
	                    msgs[idx] = msg;
	                    if (++count === len) {
	                      resolve2(msgs);
	                    }
	                  }, reject2);
	                });
	              });
	              builtInProp(Promise2, "race", function Promise$race(arr) {
	                var Constructor = this;
	                if (ToString.call(arr) != "[object Array]") {
	                  return Constructor.reject(TypeError("Not an array"));
	                }
	                return new Constructor(function executor(resolve2, reject2) {
	                  if (typeof resolve2 != "function" || typeof reject2 != "function") {
	                    throw TypeError("Not a function");
	                  }
	                  iteratePromises(Constructor, arr, function resolver(idx, msg) {
	                    resolve2(msg);
	                  }, reject2);
	                });
	              });
	              return Promise2;
	            });
	          }
	        ),
	        /***/
	        18625: (
	          /***/
	          function(module2) {
	            var π = Math.PI;
	            var _120 = radians(120);
	            module2.exports = normalize;
	            function normalize(path) {
	              var prev;
	              var result = [];
	              var bezierX = 0;
	              var bezierY = 0;
	              var startX = 0;
	              var startY = 0;
	              var quadX = null;
	              var quadY = null;
	              var x = 0;
	              var y = 0;
	              for (var i = 0, len = path.length; i < len; i++) {
	                var seg = path[i];
	                var command = seg[0];
	                switch (command) {
	                  case "M":
	                    startX = seg[1];
	                    startY = seg[2];
	                    break;
	                  case "A":
	                    seg = arc(x, y, seg[1], seg[2], radians(seg[3]), seg[4], seg[5], seg[6], seg[7]);
	                    seg.unshift("C");
	                    if (seg.length > 7) {
	                      result.push(seg.splice(0, 7));
	                      seg.unshift("C");
	                    }
	                    break;
	                  case "S":
	                    var cx = x;
	                    var cy = y;
	                    if (prev == "C" || prev == "S") {
	                      cx += cx - bezierX;
	                      cy += cy - bezierY;
	                    }
	                    seg = ["C", cx, cy, seg[1], seg[2], seg[3], seg[4]];
	                    break;
	                  case "T":
	                    if (prev == "Q" || prev == "T") {
	                      quadX = x * 2 - quadX;
	                      quadY = y * 2 - quadY;
	                    } else {
	                      quadX = x;
	                      quadY = y;
	                    }
	                    seg = quadratic(x, y, quadX, quadY, seg[1], seg[2]);
	                    break;
	                  case "Q":
	                    quadX = seg[1];
	                    quadY = seg[2];
	                    seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4]);
	                    break;
	                  case "L":
	                    seg = line(x, y, seg[1], seg[2]);
	                    break;
	                  case "H":
	                    seg = line(x, y, seg[1], y);
	                    break;
	                  case "V":
	                    seg = line(x, y, x, seg[1]);
	                    break;
	                  case "Z":
	                    seg = line(x, y, startX, startY);
	                    break;
	                }
	                prev = command;
	                x = seg[seg.length - 2];
	                y = seg[seg.length - 1];
	                if (seg.length > 4) {
	                  bezierX = seg[seg.length - 4];
	                  bezierY = seg[seg.length - 3];
	                } else {
	                  bezierX = x;
	                  bezierY = y;
	                }
	                result.push(seg);
	              }
	              return result;
	            }
	            function line(x1, y1, x2, y2) {
	              return ["C", x1, y1, x2, y2, x2, y2];
	            }
	            function quadratic(x1, y1, cx, cy, x2, y2) {
	              return [
	                "C",
	                x1 / 3 + 2 / 3 * cx,
	                y1 / 3 + 2 / 3 * cy,
	                x2 / 3 + 2 / 3 * cx,
	                y2 / 3 + 2 / 3 * cy,
	                x2,
	                y2
	              ];
	            }
	            function arc(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	              if (!recursive) {
	                var xy = rotate(x1, y1, -angle);
	                x1 = xy.x;
	                y1 = xy.y;
	                xy = rotate(x2, y2, -angle);
	                x2 = xy.x;
	                y2 = xy.y;
	                var x = (x1 - x2) / 2;
	                var y = (y1 - y2) / 2;
	                var h = x * x / (rx * rx) + y * y / (ry * ry);
	                if (h > 1) {
	                  h = Math.sqrt(h);
	                  rx = h * rx;
	                  ry = h * ry;
	                }
	                var rx2 = rx * rx;
	                var ry2 = ry * ry;
	                var k = (large_arc_flag == sweep_flag ? -1 : 1) * Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)));
	                if (k == Infinity) k = 1;
	                var cx = k * rx * y / ry + (x1 + x2) / 2;
	                var cy = k * -ry * x / rx + (y1 + y2) / 2;
	                var f1 = Math.asin(((y1 - cy) / ry).toFixed(9));
	                var f2 = Math.asin(((y2 - cy) / ry).toFixed(9));
	                f1 = x1 < cx ? π - f1 : f1;
	                f2 = x2 < cx ? π - f2 : f2;
	                if (f1 < 0) f1 = π * 2 + f1;
	                if (f2 < 0) f2 = π * 2 + f2;
	                if (sweep_flag && f1 > f2) f1 = f1 - π * 2;
	                if (!sweep_flag && f2 > f1) f2 = f2 - π * 2;
	              } else {
	                f1 = recursive[0];
	                f2 = recursive[1];
	                cx = recursive[2];
	                cy = recursive[3];
	              }
	              if (Math.abs(f2 - f1) > _120) {
	                var f2old = f2;
	                var x2old = x2;
	                var y2old = y2;
	                f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	                x2 = cx + rx * Math.cos(f2);
	                y2 = cy + ry * Math.sin(f2);
	                var res = arc(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	              }
	              var t = Math.tan((f2 - f1) / 4);
	              var hx = 4 / 3 * rx * t;
	              var hy = 4 / 3 * ry * t;
	              var curve = [
	                2 * x1 - (x1 + hx * Math.sin(f1)),
	                2 * y1 - (y1 - hy * Math.cos(f1)),
	                x2 + hx * Math.sin(f2),
	                y2 - hy * Math.cos(f2),
	                x2,
	                y2
	              ];
	              if (recursive) return curve;
	              if (res) curve = curve.concat(res);
	              for (var i = 0; i < curve.length; ) {
	                var rot = rotate(curve[i], curve[i + 1], angle);
	                curve[i++] = rot.x;
	                curve[i++] = rot.y;
	              }
	              return curve;
	            }
	            function rotate(x, y, rad) {
	              return {
	                x: x * Math.cos(rad) - y * Math.sin(rad),
	                y: x * Math.sin(rad) + y * Math.cos(rad)
	              };
	            }
	            function radians(degress) {
	              return degress * (π / 180);
	            }
	          }
	        ),
	        /***/
	        56131: (
	          /***/
	          function(module2) {
	            /*
	            object-assign
	            (c) Sindre Sorhus
	            @license MIT
	            */
	            var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	            var hasOwnProperty2 = Object.prototype.hasOwnProperty;
	            var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	            function toObject(val) {
	              if (val === null || val === undefined) {
	                throw new TypeError("Object.assign cannot be called with null or undefined");
	              }
	              return Object(val);
	            }
	            function shouldUseNative() {
	              try {
	                if (!Object.assign) {
	                  return false;
	                }
	                var test1 = new String("abc");
	                test1[5] = "de";
	                if (Object.getOwnPropertyNames(test1)[0] === "5") {
	                  return false;
	                }
	                var test2 = {};
	                for (var i = 0; i < 10; i++) {
	                  test2["_" + String.fromCharCode(i)] = i;
	                }
	                var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
	                  return test2[n];
	                });
	                if (order2.join("") !== "0123456789") {
	                  return false;
	                }
	                var test3 = {};
	                "abcdefghijklmnopqrst".split("").forEach(function(letter) {
	                  test3[letter] = letter;
	                });
	                if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
	                  return false;
	                }
	                return true;
	              } catch (err) {
	                return false;
	              }
	            }
	            module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
	              var from;
	              var to = toObject(target);
	              var symbols;
	              for (var s = 1; s < arguments.length; s++) {
	                from = Object(arguments[s]);
	                for (var key in from) {
	                  if (hasOwnProperty2.call(from, key)) {
	                    to[key] = from[key];
	                  }
	                }
	                if (getOwnPropertySymbols) {
	                  symbols = getOwnPropertySymbols(from);
	                  for (var i = 0; i < symbols.length; i++) {
	                    if (propIsEnumerable.call(from, symbols[i])) {
	                      to[symbols[i]] = from[symbols[i]];
	                    }
	                  }
	                }
	              }
	              return to;
	            };
	          }
	        ),
	        /***/
	        65848: (
	          /***/
	          function(module2) {
	            var numberIsNaN = function(value) {
	              return value !== value;
	            };
	            module2.exports = function is(a, b) {
	              if (a === 0 && b === 0) {
	                return 1 / a === 1 / b;
	              }
	              if (a === b) {
	                return true;
	              }
	              if (numberIsNaN(a) && numberIsNaN(b)) {
	                return true;
	              }
	              return false;
	            };
	          }
	        ),
	        /***/
	        64003: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var define2 = __webpack_require__2(17045);
	            var callBind = __webpack_require__2(68222);
	            var implementation = __webpack_require__2(65848);
	            var getPolyfill = __webpack_require__2(27015);
	            var shim = __webpack_require__2(55572);
	            var polyfill = callBind(getPolyfill(), Object);
	            define2(polyfill, {
	              getPolyfill,
	              implementation,
	              shim
	            });
	            module2.exports = polyfill;
	          }
	        ),
	        /***/
	        27015: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var implementation = __webpack_require__2(65848);
	            module2.exports = function getPolyfill() {
	              return typeof Object.is === "function" ? Object.is : implementation;
	            };
	          }
	        ),
	        /***/
	        55572: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getPolyfill = __webpack_require__2(27015);
	            var define2 = __webpack_require__2(17045);
	            module2.exports = function shimObjectIs() {
	              var polyfill = getPolyfill();
	              define2(Object, { is: polyfill }, {
	                is: function testObjectIs() {
	                  return Object.is !== polyfill;
	                }
	              });
	              return polyfill;
	            };
	          }
	        ),
	        /***/
	        99019: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var keysShim;
	            if (!Object.keys) {
	              var has = Object.prototype.hasOwnProperty;
	              var toStr = Object.prototype.toString;
	              var isArgs = __webpack_require__2(64178);
	              var isEnumerable = Object.prototype.propertyIsEnumerable;
	              var hasDontEnumBug = !isEnumerable.call({ toString: null }, "toString");
	              var hasProtoEnumBug = isEnumerable.call(function() {
	              }, "prototype");
	              var dontEnums = [
	                "toString",
	                "toLocaleString",
	                "valueOf",
	                "hasOwnProperty",
	                "isPrototypeOf",
	                "propertyIsEnumerable",
	                "constructor"
	              ];
	              var equalsConstructorPrototype = function(o) {
	                var ctor = o.constructor;
	                return ctor && ctor.prototype === o;
	              };
	              var excludedKeys = {
	                $applicationCache: true,
	                $console: true,
	                $external: true,
	                $frame: true,
	                $frameElement: true,
	                $frames: true,
	                $innerHeight: true,
	                $innerWidth: true,
	                $onmozfullscreenchange: true,
	                $onmozfullscreenerror: true,
	                $outerHeight: true,
	                $outerWidth: true,
	                $pageXOffset: true,
	                $pageYOffset: true,
	                $parent: true,
	                $scrollLeft: true,
	                $scrollTop: true,
	                $scrollX: true,
	                $scrollY: true,
	                $self: true,
	                $webkitIndexedDB: true,
	                $webkitStorageInfo: true,
	                $window: true
	              };
	              var hasAutomationEqualityBug = function() {
	                if (typeof window === "undefined") {
	                  return false;
	                }
	                for (var k in window) {
	                  try {
	                    if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") {
	                      try {
	                        equalsConstructorPrototype(window[k]);
	                      } catch (e) {
	                        return true;
	                      }
	                    }
	                  } catch (e) {
	                    return true;
	                  }
	                }
	                return false;
	              }();
	              var equalsConstructorPrototypeIfNotBuggy = function(o) {
	                if (typeof window === "undefined" || !hasAutomationEqualityBug) {
	                  return equalsConstructorPrototype(o);
	                }
	                try {
	                  return equalsConstructorPrototype(o);
	                } catch (e) {
	                  return false;
	                }
	              };
	              keysShim = function keys(object) {
	                var isObject = object !== null && typeof object === "object";
	                var isFunction = toStr.call(object) === "[object Function]";
	                var isArguments = isArgs(object);
	                var isString = isObject && toStr.call(object) === "[object String]";
	                var theKeys = [];
	                if (!isObject && !isFunction && !isArguments) {
	                  throw new TypeError("Object.keys called on a non-object");
	                }
	                var skipProto = hasProtoEnumBug && isFunction;
	                if (isString && object.length > 0 && !has.call(object, 0)) {
	                  for (var i = 0; i < object.length; ++i) {
	                    theKeys.push(String(i));
	                  }
	                }
	                if (isArguments && object.length > 0) {
	                  for (var j = 0; j < object.length; ++j) {
	                    theKeys.push(String(j));
	                  }
	                } else {
	                  for (var name2 in object) {
	                    if (!(skipProto && name2 === "prototype") && has.call(object, name2)) {
	                      theKeys.push(String(name2));
	                    }
	                  }
	                }
	                if (hasDontEnumBug) {
	                  var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	                  for (var k = 0; k < dontEnums.length; ++k) {
	                    if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) {
	                      theKeys.push(dontEnums[k]);
	                    }
	                  }
	                }
	                return theKeys;
	              };
	            }
	            module2.exports = keysShim;
	          }
	        ),
	        /***/
	        8709: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var slice2 = Array.prototype.slice;
	            var isArgs = __webpack_require__2(64178);
	            var origKeys = Object.keys;
	            var keysShim = origKeys ? function keys(o) {
	              return origKeys(o);
	            } : __webpack_require__2(99019);
	            var originalKeys = Object.keys;
	            keysShim.shim = function shimObjectKeys() {
	              if (Object.keys) {
	                var keysWorksWithArguments = function() {
	                  var args = Object.keys(arguments);
	                  return args && args.length === arguments.length;
	                }(1, 2);
	                if (!keysWorksWithArguments) {
	                  Object.keys = function keys(object) {
	                    if (isArgs(object)) {
	                      return originalKeys(slice2.call(object));
	                    }
	                    return originalKeys(object);
	                  };
	                }
	              } else {
	                Object.keys = keysShim;
	              }
	              return Object.keys || keysShim;
	            };
	            module2.exports = keysShim;
	          }
	        ),
	        /***/
	        64178: (
	          /***/
	          function(module2) {
	            var toStr = Object.prototype.toString;
	            module2.exports = function isArguments(value) {
	              var str = toStr.call(value);
	              var isArgs = str === "[object Arguments]";
	              if (!isArgs) {
	                isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
	              }
	              return isArgs;
	            };
	          }
	        ),
	        /***/
	        88641: (
	          /***/
	          function(module2) {
	            function parse(str, opts) {
	              if (typeof str !== "string") return [str];
	              var res = [str];
	              if (typeof opts === "string" || Array.isArray(opts)) {
	                opts = { brackets: opts };
	              } else if (!opts) opts = {};
	              var brackets = opts.brackets ? Array.isArray(opts.brackets) ? opts.brackets : [opts.brackets] : ["{}", "[]", "()"];
	              var escape2 = opts.escape || "___";
	              var flat = !!opts.flat;
	              brackets.forEach(function(bracket) {
	                var pRE = new RegExp(["\\", bracket[0], "[^\\", bracket[0], "\\", bracket[1], "]*\\", bracket[1]].join(""));
	                var ids = [];
	                function replaceToken(token, idx, str2) {
	                  var refId = res.push(token.slice(bracket[0].length, -bracket[1].length)) - 1;
	                  ids.push(refId);
	                  return escape2 + refId + escape2;
	                }
	                res.forEach(function(str2, i) {
	                  var prevStr;
	                  var a = 0;
	                  while (str2 != prevStr) {
	                    prevStr = str2;
	                    str2 = str2.replace(pRE, replaceToken);
	                    if (a++ > 1e4) throw Error("References have circular dependency. Please, check them.");
	                  }
	                  res[i] = str2;
	                });
	                ids = ids.reverse();
	                res = res.map(function(str2) {
	                  ids.forEach(function(id) {
	                    str2 = str2.replace(new RegExp("(\\" + escape2 + id + "\\" + escape2 + ")", "g"), bracket[0] + "$1" + bracket[1]);
	                  });
	                  return str2;
	                });
	              });
	              var re = new RegExp("\\" + escape2 + "([0-9]+)\\" + escape2);
	              function nest(str2, refs, escape3) {
	                var res2 = [], match;
	                var a = 0;
	                while (match = re.exec(str2)) {
	                  if (a++ > 1e4) throw Error("Circular references in parenthesis");
	                  res2.push(str2.slice(0, match.index));
	                  res2.push(nest(refs[match[1]], refs));
	                  str2 = str2.slice(match.index + match[0].length);
	                }
	                res2.push(str2);
	                return res2;
	              }
	              return flat ? res : nest(res[0], res);
	            }
	            function stringify(arg, opts) {
	              if (opts && opts.flat) {
	                var escape2 = opts && opts.escape || "___";
	                var str = arg[0], prevStr;
	                if (!str) return "";
	                var re = new RegExp("\\" + escape2 + "([0-9]+)\\" + escape2);
	                var a = 0;
	                while (str != prevStr) {
	                  if (a++ > 1e4) throw Error("Circular references in " + arg);
	                  prevStr = str;
	                  str = str.replace(re, replaceRef);
	                }
	                return str;
	              }
	              return arg.reduce(function f(prev, curr) {
	                if (Array.isArray(curr)) {
	                  curr = curr.reduce(f, "");
	                }
	                return prev + curr;
	              }, "");
	              function replaceRef(match, idx) {
	                if (arg[idx] == null) throw Error("Reference " + idx + "is undefined");
	                return arg[idx];
	              }
	            }
	            function parenthesis(arg, opts) {
	              if (Array.isArray(arg)) {
	                return stringify(arg, opts);
	              } else {
	                return parse(arg, opts);
	              }
	            }
	            parenthesis.parse = parse;
	            parenthesis.stringify = stringify;
	            module2.exports = parenthesis;
	          }
	        ),
	        /***/
	        18863: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var pick = __webpack_require__2(71299);
	            module2.exports = parseRect;
	            function parseRect(arg) {
	              var rect;
	              if (arguments.length > 1) {
	                arg = arguments;
	              }
	              if (typeof arg === "string") {
	                arg = arg.split(/\s/).map(parseFloat);
	              } else if (typeof arg === "number") {
	                arg = [arg];
	              }
	              if (arg.length && typeof arg[0] === "number") {
	                if (arg.length === 1) {
	                  rect = {
	                    width: arg[0],
	                    height: arg[0],
	                    x: 0,
	                    y: 0
	                  };
	                } else if (arg.length === 2) {
	                  rect = {
	                    width: arg[0],
	                    height: arg[1],
	                    x: 0,
	                    y: 0
	                  };
	                } else {
	                  rect = {
	                    x: arg[0],
	                    y: arg[1],
	                    width: arg[2] - arg[0] || 0,
	                    height: arg[3] - arg[1] || 0
	                  };
	                }
	              } else if (arg) {
	                arg = pick(arg, {
	                  left: "x l left Left",
	                  top: "y t top Top",
	                  width: "w width W Width",
	                  height: "h height W Width",
	                  bottom: "b bottom Bottom",
	                  right: "r right Right"
	                });
	                rect = {
	                  x: arg.left || 0,
	                  y: arg.top || 0
	                };
	                if (arg.width == null) {
	                  if (arg.right) rect.width = arg.right - rect.x;
	                  else rect.width = 0;
	                } else {
	                  rect.width = arg.width;
	                }
	                if (arg.height == null) {
	                  if (arg.bottom) rect.height = arg.bottom - rect.y;
	                  else rect.height = 0;
	                } else {
	                  rect.height = arg.height;
	                }
	              }
	              return rect;
	            }
	          }
	        ),
	        /***/
	        95616: (
	          /***/
	          function(module2) {
	            module2.exports = parse;
	            var length = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 };
	            var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
	            function parse(path) {
	              var data = [];
	              path.replace(segment, function(_, command, args) {
	                var type = command.toLowerCase();
	                args = parseValues(args);
	                if (type == "m" && args.length > 2) {
	                  data.push([command].concat(args.splice(0, 2)));
	                  type = "l";
	                  command = command == "m" ? "l" : "L";
	                }
	                while (true) {
	                  if (args.length == length[type]) {
	                    args.unshift(command);
	                    return data.push(args);
	                  }
	                  if (args.length < length[type]) throw new Error("malformed path data");
	                  data.push([command].concat(args.splice(0, length[type])));
	                }
	              });
	              return data;
	            }
	            var number2 = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
	            function parseValues(args) {
	              var numbers = args.match(number2);
	              return numbers ? numbers.map(Number) : [];
	            }
	          }
	        ),
	        /***/
	        25677: (
	          /***/
	          function(module2) {
	            module2.exports = function parseUnit(str, out) {
	              if (!out)
	                out = [0, ""];
	              str = String(str);
	              var num = parseFloat(str, 10);
	              out[0] = num;
	              out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || "";
	              return out;
	            };
	          }
	        ),
	        /***/
	        9748: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            (function() {
	              var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	              if (typeof performance !== "undefined" && performance !== null && performance.now) {
	                module2.exports = function() {
	                  return performance.now();
	                };
	              } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
	                module2.exports = function() {
	                  return (getNanoSeconds() - nodeLoadTime) / 1e6;
	                };
	                hrtime = process.hrtime;
	                getNanoSeconds = function() {
	                  var hr;
	                  hr = hrtime();
	                  return hr[0] * 1e9 + hr[1];
	                };
	                moduleLoadTime = getNanoSeconds();
	                upTime = process.uptime() * 1e9;
	                nodeLoadTime = moduleLoadTime - upTime;
	              } else if (Date.now) {
	                module2.exports = function() {
	                  return Date.now() - loadTime;
	                };
	                loadTime = Date.now();
	              } else {
	                module2.exports = function() {
	                  return (/* @__PURE__ */ new Date()).getTime() - loadTime;
	                };
	                loadTime = (/* @__PURE__ */ new Date()).getTime();
	              }
	            }).call(this);
	          }
	        ),
	        /***/
	        71299: (
	          /***/
	          function(module2) {
	            module2.exports = function pick(src, props, keepRest) {
	              var result = {}, prop, i;
	              if (typeof props === "string") props = toList(props);
	              if (Array.isArray(props)) {
	                var res = {};
	                for (i = 0; i < props.length; i++) {
	                  res[props[i]] = true;
	                }
	                props = res;
	              }
	              for (prop in props) {
	                props[prop] = toList(props[prop]);
	              }
	              var occupied = {};
	              for (prop in props) {
	                var aliases = props[prop];
	                if (Array.isArray(aliases)) {
	                  for (i = 0; i < aliases.length; i++) {
	                    var alias = aliases[i];
	                    if (keepRest) {
	                      occupied[alias] = true;
	                    }
	                    if (alias in src) {
	                      result[prop] = src[alias];
	                      if (keepRest) {
	                        for (var j = i; j < aliases.length; j++) {
	                          occupied[aliases[j]] = true;
	                        }
	                      }
	                      break;
	                    }
	                  }
	                } else if (prop in src) {
	                  if (props[prop]) {
	                    result[prop] = src[prop];
	                  }
	                  if (keepRest) {
	                    occupied[prop] = true;
	                  }
	                }
	              }
	              if (keepRest) {
	                for (prop in src) {
	                  if (occupied[prop]) continue;
	                  result[prop] = src[prop];
	                }
	              }
	              return result;
	            };
	            var CACHE = {};
	            function toList(arg) {
	              if (CACHE[arg]) return CACHE[arg];
	              if (typeof arg === "string") {
	                arg = CACHE[arg] = arg.split(/\s*,\s*|\s+/);
	              }
	              return arg;
	            }
	          }
	        ),
	        /***/
	        38258: (
	          /***/
	          function(module2) {
	            module2.exports = function pointInPolygonNested(point, vs, start, end) {
	              var x = point[0], y = point[1];
	              var inside = false;
	              if (start === undefined) start = 0;
	              if (end === undefined) end = vs.length;
	              var len = end - start;
	              for (var i = 0, j = len - 1; i < len; j = i++) {
	                var xi = vs[i + start][0], yi = vs[i + start][1];
	                var xj = vs[j + start][0], yj = vs[j + start][1];
	                var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
	                if (intersect) inside = !inside;
	              }
	              return inside;
	            };
	          }
	        ),
	        /***/
	        52142: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            /*
	             * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
	             * @license MIT
	             * @preserve Project Home: https://github.com/voidqk/polybooljs
	             */
	            var BuildLog = __webpack_require__2(69444);
	            var Epsilon = __webpack_require__2(29023);
	            var Intersecter = __webpack_require__2(87263);
	            var SegmentChainer = __webpack_require__2(11328);
	            var SegmentSelector = __webpack_require__2(55968);
	            var GeoJSON = __webpack_require__2(10670);
	            var buildLog = false;
	            var epsilon = Epsilon();
	            var PolyBool;
	            PolyBool = {
	              // getter/setter for buildLog
	              buildLog: function(bl) {
	                if (bl === true)
	                  buildLog = BuildLog();
	                else if (bl === false)
	                  buildLog = false;
	                return buildLog === false ? false : buildLog.list;
	              },
	              // getter/setter for epsilon
	              epsilon: function(v) {
	                return epsilon.epsilon(v);
	              },
	              // core API
	              segments: function(poly) {
	                var i = Intersecter(true, epsilon, buildLog);
	                poly.regions.forEach(i.addRegion);
	                return {
	                  segments: i.calculate(poly.inverted),
	                  inverted: poly.inverted
	                };
	              },
	              combine: function(segments1, segments2) {
	                var i3 = Intersecter(false, epsilon, buildLog);
	                return {
	                  combined: i3.calculate(
	                    segments1.segments,
	                    segments1.inverted,
	                    segments2.segments,
	                    segments2.inverted
	                  ),
	                  inverted1: segments1.inverted,
	                  inverted2: segments2.inverted
	                };
	              },
	              selectUnion: function(combined) {
	                return {
	                  segments: SegmentSelector.union(combined.combined, buildLog),
	                  inverted: combined.inverted1 || combined.inverted2
	                };
	              },
	              selectIntersect: function(combined) {
	                return {
	                  segments: SegmentSelector.intersect(combined.combined, buildLog),
	                  inverted: combined.inverted1 && combined.inverted2
	                };
	              },
	              selectDifference: function(combined) {
	                return {
	                  segments: SegmentSelector.difference(combined.combined, buildLog),
	                  inverted: combined.inverted1 && !combined.inverted2
	                };
	              },
	              selectDifferenceRev: function(combined) {
	                return {
	                  segments: SegmentSelector.differenceRev(combined.combined, buildLog),
	                  inverted: !combined.inverted1 && combined.inverted2
	                };
	              },
	              selectXor: function(combined) {
	                return {
	                  segments: SegmentSelector.xor(combined.combined, buildLog),
	                  inverted: combined.inverted1 !== combined.inverted2
	                };
	              },
	              polygon: function(segments) {
	                return {
	                  regions: SegmentChainer(segments.segments, epsilon, buildLog),
	                  inverted: segments.inverted
	                };
	              },
	              // GeoJSON converters
	              polygonFromGeoJSON: function(geojson) {
	                return GeoJSON.toPolygon(PolyBool, geojson);
	              },
	              polygonToGeoJSON: function(poly) {
	                return GeoJSON.fromPolygon(PolyBool, epsilon, poly);
	              },
	              // helper functions for common operations
	              union: function(poly1, poly2) {
	                return operate(poly1, poly2, PolyBool.selectUnion);
	              },
	              intersect: function(poly1, poly2) {
	                return operate(poly1, poly2, PolyBool.selectIntersect);
	              },
	              difference: function(poly1, poly2) {
	                return operate(poly1, poly2, PolyBool.selectDifference);
	              },
	              differenceRev: function(poly1, poly2) {
	                return operate(poly1, poly2, PolyBool.selectDifferenceRev);
	              },
	              xor: function(poly1, poly2) {
	                return operate(poly1, poly2, PolyBool.selectXor);
	              }
	            };
	            function operate(poly1, poly2, selector) {
	              var seg1 = PolyBool.segments(poly1);
	              var seg2 = PolyBool.segments(poly2);
	              var comb = PolyBool.combine(seg1, seg2);
	              var seg3 = selector(comb);
	              return PolyBool.polygon(seg3);
	            }
	            if (typeof window === "object")
	              window.PolyBool = PolyBool;
	            module2.exports = PolyBool;
	          }
	        ),
	        /***/
	        69444: (
	          /***/
	          function(module2) {
	            function BuildLog() {
	              var my;
	              var nextSegmentId = 0;
	              var curVert = false;
	              function push(type, data) {
	                my.list.push({
	                  type,
	                  data: data ? JSON.parse(JSON.stringify(data)) : undefined
	                });
	                return my;
	              }
	              my = {
	                list: [],
	                segmentId: function() {
	                  return nextSegmentId++;
	                },
	                checkIntersection: function(seg1, seg2) {
	                  return push("check", { seg1, seg2 });
	                },
	                segmentChop: function(seg, end) {
	                  push("div_seg", { seg, pt: end });
	                  return push("chop", { seg, pt: end });
	                },
	                statusRemove: function(seg) {
	                  return push("pop_seg", { seg });
	                },
	                segmentUpdate: function(seg) {
	                  return push("seg_update", { seg });
	                },
	                segmentNew: function(seg, primary) {
	                  return push("new_seg", { seg, primary });
	                },
	                segmentRemove: function(seg) {
	                  return push("rem_seg", { seg });
	                },
	                tempStatus: function(seg, above, below) {
	                  return push("temp_status", { seg, above, below });
	                },
	                rewind: function(seg) {
	                  return push("rewind", { seg });
	                },
	                status: function(seg, above, below) {
	                  return push("status", { seg, above, below });
	                },
	                vert: function(x) {
	                  if (x === curVert)
	                    return my;
	                  curVert = x;
	                  return push("vert", { x });
	                },
	                log: function(data) {
	                  if (typeof data !== "string")
	                    data = JSON.stringify(data, false, "  ");
	                  return push("log", { txt: data });
	                },
	                reset: function() {
	                  return push("reset");
	                },
	                selected: function(segs) {
	                  return push("selected", { segs });
	                },
	                chainStart: function(seg) {
	                  return push("chain_start", { seg });
	                },
	                chainRemoveHead: function(index, pt) {
	                  return push("chain_rem_head", { index, pt });
	                },
	                chainRemoveTail: function(index, pt) {
	                  return push("chain_rem_tail", { index, pt });
	                },
	                chainNew: function(pt1, pt2) {
	                  return push("chain_new", { pt1, pt2 });
	                },
	                chainMatch: function(index) {
	                  return push("chain_match", { index });
	                },
	                chainClose: function(index) {
	                  return push("chain_close", { index });
	                },
	                chainAddHead: function(index, pt) {
	                  return push("chain_add_head", { index, pt });
	                },
	                chainAddTail: function(index, pt) {
	                  return push("chain_add_tail", { index, pt });
	                },
	                chainConnect: function(index1, index2) {
	                  return push("chain_con", { index1, index2 });
	                },
	                chainReverse: function(index) {
	                  return push("chain_rev", { index });
	                },
	                chainJoin: function(index1, index2) {
	                  return push("chain_join", { index1, index2 });
	                },
	                done: function() {
	                  return push("done");
	                }
	              };
	              return my;
	            }
	            module2.exports = BuildLog;
	          }
	        ),
	        /***/
	        29023: (
	          /***/
	          function(module2) {
	            function Epsilon(eps) {
	              if (typeof eps !== "number")
	                eps = 1e-10;
	              var my = {
	                epsilon: function(v) {
	                  if (typeof v === "number")
	                    eps = v;
	                  return eps;
	                },
	                pointAboveOrOnLine: function(pt, left, right) {
	                  var Ax = left[0];
	                  var Ay = left[1];
	                  var Bx = right[0];
	                  var By = right[1];
	                  var Cx = pt[0];
	                  var Cy = pt[1];
	                  return (Bx - Ax) * (Cy - Ay) - (By - Ay) * (Cx - Ax) >= -eps;
	                },
	                pointBetween: function(p, left, right) {
	                  var d_py_ly = p[1] - left[1];
	                  var d_rx_lx = right[0] - left[0];
	                  var d_px_lx = p[0] - left[0];
	                  var d_ry_ly = right[1] - left[1];
	                  var dot = d_px_lx * d_rx_lx + d_py_ly * d_ry_ly;
	                  if (dot < eps)
	                    return false;
	                  var sqlen = d_rx_lx * d_rx_lx + d_ry_ly * d_ry_ly;
	                  if (dot - sqlen > -eps)
	                    return false;
	                  return true;
	                },
	                pointsSameX: function(p1, p2) {
	                  return Math.abs(p1[0] - p2[0]) < eps;
	                },
	                pointsSameY: function(p1, p2) {
	                  return Math.abs(p1[1] - p2[1]) < eps;
	                },
	                pointsSame: function(p1, p2) {
	                  return my.pointsSameX(p1, p2) && my.pointsSameY(p1, p2);
	                },
	                pointsCompare: function(p1, p2) {
	                  if (my.pointsSameX(p1, p2))
	                    return my.pointsSameY(p1, p2) ? 0 : p1[1] < p2[1] ? -1 : 1;
	                  return p1[0] < p2[0] ? -1 : 1;
	                },
	                pointsCollinear: function(pt1, pt2, pt3) {
	                  var dx1 = pt1[0] - pt2[0];
	                  var dy1 = pt1[1] - pt2[1];
	                  var dx2 = pt2[0] - pt3[0];
	                  var dy2 = pt2[1] - pt3[1];
	                  return Math.abs(dx1 * dy2 - dx2 * dy1) < eps;
	                },
	                linesIntersect: function(a0, a1, b0, b1) {
	                  var adx = a1[0] - a0[0];
	                  var ady = a1[1] - a0[1];
	                  var bdx = b1[0] - b0[0];
	                  var bdy = b1[1] - b0[1];
	                  var axb = adx * bdy - ady * bdx;
	                  if (Math.abs(axb) < eps)
	                    return false;
	                  var dx = a0[0] - b0[0];
	                  var dy = a0[1] - b0[1];
	                  var A = (bdx * dy - bdy * dx) / axb;
	                  var B = (adx * dy - ady * dx) / axb;
	                  var ret = {
	                    alongA: 0,
	                    alongB: 0,
	                    pt: [
	                      a0[0] + A * adx,
	                      a0[1] + A * ady
	                    ]
	                  };
	                  if (A <= -eps)
	                    ret.alongA = -2;
	                  else if (A < eps)
	                    ret.alongA = -1;
	                  else if (A - 1 <= -eps)
	                    ret.alongA = 0;
	                  else if (A - 1 < eps)
	                    ret.alongA = 1;
	                  else
	                    ret.alongA = 2;
	                  if (B <= -eps)
	                    ret.alongB = -2;
	                  else if (B < eps)
	                    ret.alongB = -1;
	                  else if (B - 1 <= -eps)
	                    ret.alongB = 0;
	                  else if (B - 1 < eps)
	                    ret.alongB = 1;
	                  else
	                    ret.alongB = 2;
	                  return ret;
	                },
	                pointInsideRegion: function(pt, region) {
	                  var x = pt[0];
	                  var y = pt[1];
	                  var last_x = region[region.length - 1][0];
	                  var last_y = region[region.length - 1][1];
	                  var inside = false;
	                  for (var i = 0; i < region.length; i++) {
	                    var curr_x = region[i][0];
	                    var curr_y = region[i][1];
	                    if (curr_y - y > eps != last_y - y > eps && (last_x - curr_x) * (y - curr_y) / (last_y - curr_y) + curr_x - x > eps)
	                      inside = !inside;
	                    last_x = curr_x;
	                    last_y = curr_y;
	                  }
	                  return inside;
	                }
	              };
	              return my;
	            }
	            module2.exports = Epsilon;
	          }
	        ),
	        /***/
	        10670: (
	          /***/
	          function(module2) {
	            var GeoJSON = {
	              // convert a GeoJSON object to a PolyBool polygon
	              toPolygon: function(PolyBool, geojson) {
	                function GeoPoly(coords) {
	                  if (coords.length <= 0)
	                    return PolyBool.segments({ inverted: false, regions: [] });
	                  function LineString(ls) {
	                    var reg = ls.slice(0, ls.length - 1);
	                    return PolyBool.segments({ inverted: false, regions: [reg] });
	                  }
	                  var out2 = LineString(coords[0]);
	                  for (var i2 = 1; i2 < coords.length; i2++)
	                    out2 = PolyBool.selectDifference(PolyBool.combine(out2, LineString(coords[i2])));
	                  return out2;
	                }
	                if (geojson.type === "Polygon") {
	                  return PolyBool.polygon(GeoPoly(geojson.coordinates));
	                } else if (geojson.type === "MultiPolygon") {
	                  var out = PolyBool.segments({ inverted: false, regions: [] });
	                  for (var i = 0; i < geojson.coordinates.length; i++)
	                    out = PolyBool.selectUnion(PolyBool.combine(out, GeoPoly(geojson.coordinates[i])));
	                  return PolyBool.polygon(out);
	                }
	                throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
	              },
	              // convert a PolyBool polygon to a GeoJSON object
	              fromPolygon: function(PolyBool, eps, poly) {
	                poly = PolyBool.polygon(PolyBool.segments(poly));
	                function regionInsideRegion(r1, r2) {
	                  return eps.pointInsideRegion([
	                    (r1[0][0] + r1[1][0]) * 0.5,
	                    (r1[0][1] + r1[1][1]) * 0.5
	                  ], r2);
	                }
	                function newNode(region2) {
	                  return {
	                    region: region2,
	                    children: []
	                  };
	                }
	                var roots = newNode(null);
	                function addChild(root, region2) {
	                  for (var i2 = 0; i2 < root.children.length; i2++) {
	                    var child = root.children[i2];
	                    if (regionInsideRegion(region2, child.region)) {
	                      addChild(child, region2);
	                      return;
	                    }
	                  }
	                  var node = newNode(region2);
	                  for (var i2 = 0; i2 < root.children.length; i2++) {
	                    var child = root.children[i2];
	                    if (regionInsideRegion(child.region, region2)) {
	                      node.children.push(child);
	                      root.children.splice(i2, 1);
	                      i2--;
	                    }
	                  }
	                  root.children.push(node);
	                }
	                for (var i = 0; i < poly.regions.length; i++) {
	                  var region = poly.regions[i];
	                  if (region.length < 3)
	                    continue;
	                  addChild(roots, region);
	                }
	                function forceWinding(region2, clockwise) {
	                  var winding = 0;
	                  var last_x = region2[region2.length - 1][0];
	                  var last_y = region2[region2.length - 1][1];
	                  var copy = [];
	                  for (var i2 = 0; i2 < region2.length; i2++) {
	                    var curr_x = region2[i2][0];
	                    var curr_y = region2[i2][1];
	                    copy.push([curr_x, curr_y]);
	                    winding += curr_y * last_x - curr_x * last_y;
	                    last_x = curr_x;
	                    last_y = curr_y;
	                  }
	                  var isclockwise = winding < 0;
	                  if (isclockwise !== clockwise)
	                    copy.reverse();
	                  copy.push([copy[0][0], copy[0][1]]);
	                  return copy;
	                }
	                var geopolys = [];
	                function addExterior(node) {
	                  var poly2 = [forceWinding(node.region, false)];
	                  geopolys.push(poly2);
	                  for (var i2 = 0; i2 < node.children.length; i2++)
	                    poly2.push(getInterior(node.children[i2]));
	                }
	                function getInterior(node) {
	                  for (var i2 = 0; i2 < node.children.length; i2++)
	                    addExterior(node.children[i2]);
	                  return forceWinding(node.region, true);
	                }
	                for (var i = 0; i < roots.children.length; i++)
	                  addExterior(roots.children[i]);
	                if (geopolys.length <= 0)
	                  return { type: "Polygon", coordinates: [] };
	                if (geopolys.length == 1)
	                  return { type: "Polygon", coordinates: geopolys[0] };
	                return {
	                  // otherwise, use a GeoJSON MultiPolygon
	                  type: "MultiPolygon",
	                  coordinates: geopolys
	                };
	              }
	            };
	            module2.exports = GeoJSON;
	          }
	        ),
	        /***/
	        87263: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var LinkedList = __webpack_require__2(26859);
	            function Intersecter(selfIntersection, eps, buildLog) {
	              function segmentNew(start, end) {
	                return {
	                  id: buildLog ? buildLog.segmentId() : -1,
	                  start,
	                  end,
	                  myFill: {
	                    above: null,
	                    // is there fill above us?
	                    below: null
	                    // is there fill below us?
	                  },
	                  otherFill: null
	                };
	              }
	              function segmentCopy(start, end, seg) {
	                return {
	                  id: buildLog ? buildLog.segmentId() : -1,
	                  start,
	                  end,
	                  myFill: {
	                    above: seg.myFill.above,
	                    below: seg.myFill.below
	                  },
	                  otherFill: null
	                };
	              }
	              var event_root = LinkedList.create();
	              function eventCompare(p1_isStart, p1_1, p1_2, p2_isStart, p2_1, p2_2) {
	                var comp = eps.pointsCompare(p1_1, p2_1);
	                if (comp !== 0)
	                  return comp;
	                if (eps.pointsSame(p1_2, p2_2))
	                  return 0;
	                if (p1_isStart !== p2_isStart)
	                  return p1_isStart ? 1 : -1;
	                return eps.pointAboveOrOnLine(
	                  p1_2,
	                  p2_isStart ? p2_1 : p2_2,
	                  // order matters
	                  p2_isStart ? p2_2 : p2_1
	                ) ? 1 : -1;
	              }
	              function eventAdd(ev, other_pt) {
	                event_root.insertBefore(ev, function(here) {
	                  var comp = eventCompare(
	                    ev.isStart,
	                    ev.pt,
	                    other_pt,
	                    here.isStart,
	                    here.pt,
	                    here.other.pt
	                  );
	                  return comp < 0;
	                });
	              }
	              function eventAddSegmentStart(seg, primary) {
	                var ev_start = LinkedList.node({
	                  isStart: true,
	                  pt: seg.start,
	                  seg,
	                  primary,
	                  other: null,
	                  status: null
	                });
	                eventAdd(ev_start, seg.end);
	                return ev_start;
	              }
	              function eventAddSegmentEnd(ev_start, seg, primary) {
	                var ev_end = LinkedList.node({
	                  isStart: false,
	                  pt: seg.end,
	                  seg,
	                  primary,
	                  other: ev_start,
	                  status: null
	                });
	                ev_start.other = ev_end;
	                eventAdd(ev_end, ev_start.pt);
	              }
	              function eventAddSegment(seg, primary) {
	                var ev_start = eventAddSegmentStart(seg, primary);
	                eventAddSegmentEnd(ev_start, seg, primary);
	                return ev_start;
	              }
	              function eventUpdateEnd(ev, end) {
	                if (buildLog)
	                  buildLog.segmentChop(ev.seg, end);
	                ev.other.remove();
	                ev.seg.end = end;
	                ev.other.pt = end;
	                eventAdd(ev.other, ev.pt);
	              }
	              function eventDivide(ev, pt) {
	                var ns = segmentCopy(pt, ev.seg.end, ev.seg);
	                eventUpdateEnd(ev, pt);
	                return eventAddSegment(ns, ev.primary);
	              }
	              function calculate(primaryPolyInverted, secondaryPolyInverted) {
	                var status_root = LinkedList.create();
	                function statusCompare(ev1, ev2) {
	                  var a1 = ev1.seg.start;
	                  var a2 = ev1.seg.end;
	                  var b1 = ev2.seg.start;
	                  var b2 = ev2.seg.end;
	                  if (eps.pointsCollinear(a1, b1, b2)) {
	                    if (eps.pointsCollinear(a2, b1, b2))
	                      return 1;
	                    return eps.pointAboveOrOnLine(a2, b1, b2) ? 1 : -1;
	                  }
	                  return eps.pointAboveOrOnLine(a1, b1, b2) ? 1 : -1;
	                }
	                function statusFindSurrounding(ev2) {
	                  return status_root.findTransition(function(here) {
	                    var comp = statusCompare(ev2, here.ev);
	                    return comp > 0;
	                  });
	                }
	                function checkIntersection(ev1, ev2) {
	                  var seg1 = ev1.seg;
	                  var seg2 = ev2.seg;
	                  var a1 = seg1.start;
	                  var a2 = seg1.end;
	                  var b1 = seg2.start;
	                  var b2 = seg2.end;
	                  if (buildLog)
	                    buildLog.checkIntersection(seg1, seg2);
	                  var i = eps.linesIntersect(a1, a2, b1, b2);
	                  if (i === false) {
	                    if (!eps.pointsCollinear(a1, a2, b1))
	                      return false;
	                    if (eps.pointsSame(a1, b2) || eps.pointsSame(a2, b1))
	                      return false;
	                    var a1_equ_b1 = eps.pointsSame(a1, b1);
	                    var a2_equ_b2 = eps.pointsSame(a2, b2);
	                    if (a1_equ_b1 && a2_equ_b2)
	                      return ev2;
	                    var a1_between = !a1_equ_b1 && eps.pointBetween(a1, b1, b2);
	                    var a2_between = !a2_equ_b2 && eps.pointBetween(a2, b1, b2);
	                    if (a1_equ_b1) {
	                      if (a2_between) {
	                        eventDivide(ev2, a2);
	                      } else {
	                        eventDivide(ev1, b2);
	                      }
	                      return ev2;
	                    } else if (a1_between) {
	                      if (!a2_equ_b2) {
	                        if (a2_between) {
	                          eventDivide(ev2, a2);
	                        } else {
	                          eventDivide(ev1, b2);
	                        }
	                      }
	                      eventDivide(ev2, a1);
	                    }
	                  } else {
	                    if (i.alongA === 0) {
	                      if (i.alongB === -1)
	                        eventDivide(ev1, b1);
	                      else if (i.alongB === 0)
	                        eventDivide(ev1, i.pt);
	                      else if (i.alongB === 1)
	                        eventDivide(ev1, b2);
	                    }
	                    if (i.alongB === 0) {
	                      if (i.alongA === -1)
	                        eventDivide(ev2, a1);
	                      else if (i.alongA === 0)
	                        eventDivide(ev2, i.pt);
	                      else if (i.alongA === 1)
	                        eventDivide(ev2, a2);
	                    }
	                  }
	                  return false;
	                }
	                var segments = [];
	                while (!event_root.isEmpty()) {
	                  var ev = event_root.getHead();
	                  if (buildLog)
	                    buildLog.vert(ev.pt[0]);
	                  if (ev.isStart) {
	                    let checkBothIntersections2 = function() {
	                      if (above) {
	                        var eve2 = checkIntersection(ev, above);
	                        if (eve2)
	                          return eve2;
	                      }
	                      if (below)
	                        return checkIntersection(ev, below);
	                      return false;
	                    };
	                    if (buildLog)
	                      buildLog.segmentNew(ev.seg, ev.primary);
	                    var surrounding = statusFindSurrounding(ev);
	                    var above = surrounding.before ? surrounding.before.ev : null;
	                    var below = surrounding.after ? surrounding.after.ev : null;
	                    if (buildLog) {
	                      buildLog.tempStatus(
	                        ev.seg,
	                        above ? above.seg : false,
	                        below ? below.seg : false
	                      );
	                    }
	                    var eve = checkBothIntersections2();
	                    if (eve) {
	                      if (selfIntersection) {
	                        var toggle;
	                        if (ev.seg.myFill.below === null)
	                          toggle = true;
	                        else
	                          toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
	                        if (toggle)
	                          eve.seg.myFill.above = !eve.seg.myFill.above;
	                      } else {
	                        eve.seg.otherFill = ev.seg.myFill;
	                      }
	                      if (buildLog)
	                        buildLog.segmentUpdate(eve.seg);
	                      ev.other.remove();
	                      ev.remove();
	                    }
	                    if (event_root.getHead() !== ev) {
	                      if (buildLog)
	                        buildLog.rewind(ev.seg);
	                      continue;
	                    }
	                    if (selfIntersection) {
	                      var toggle;
	                      if (ev.seg.myFill.below === null)
	                        toggle = true;
	                      else
	                        toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
	                      if (!below) {
	                        ev.seg.myFill.below = primaryPolyInverted;
	                      } else {
	                        ev.seg.myFill.below = below.seg.myFill.above;
	                      }
	                      if (toggle)
	                        ev.seg.myFill.above = !ev.seg.myFill.below;
	                      else
	                        ev.seg.myFill.above = ev.seg.myFill.below;
	                    } else {
	                      if (ev.seg.otherFill === null) {
	                        var inside;
	                        if (!below) {
	                          inside = ev.primary ? secondaryPolyInverted : primaryPolyInverted;
	                        } else {
	                          if (ev.primary === below.primary)
	                            inside = below.seg.otherFill.above;
	                          else
	                            inside = below.seg.myFill.above;
	                        }
	                        ev.seg.otherFill = {
	                          above: inside,
	                          below: inside
	                        };
	                      }
	                    }
	                    if (buildLog) {
	                      buildLog.status(
	                        ev.seg,
	                        above ? above.seg : false,
	                        below ? below.seg : false
	                      );
	                    }
	                    ev.other.status = surrounding.insert(LinkedList.node({ ev }));
	                  } else {
	                    var st = ev.status;
	                    if (st === null) {
	                      throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
	                    }
	                    if (status_root.exists(st.prev) && status_root.exists(st.next))
	                      checkIntersection(st.prev.ev, st.next.ev);
	                    if (buildLog)
	                      buildLog.statusRemove(st.ev.seg);
	                    st.remove();
	                    if (!ev.primary) {
	                      var s = ev.seg.myFill;
	                      ev.seg.myFill = ev.seg.otherFill;
	                      ev.seg.otherFill = s;
	                    }
	                    segments.push(ev.seg);
	                  }
	                  event_root.getHead().remove();
	                }
	                if (buildLog)
	                  buildLog.done();
	                return segments;
	              }
	              if (!selfIntersection) {
	                return {
	                  calculate: function(segments1, inverted1, segments2, inverted2) {
	                    segments1.forEach(function(seg) {
	                      eventAddSegment(segmentCopy(seg.start, seg.end, seg), true);
	                    });
	                    segments2.forEach(function(seg) {
	                      eventAddSegment(segmentCopy(seg.start, seg.end, seg), false);
	                    });
	                    return calculate(inverted1, inverted2);
	                  }
	                };
	              }
	              return {
	                addRegion: function(region) {
	                  var pt1;
	                  var pt2 = region[region.length - 1];
	                  for (var i = 0; i < region.length; i++) {
	                    pt1 = pt2;
	                    pt2 = region[i];
	                    var forward = eps.pointsCompare(pt1, pt2);
	                    if (forward === 0)
	                      continue;
	                    eventAddSegment(
	                      segmentNew(
	                        forward < 0 ? pt1 : pt2,
	                        forward < 0 ? pt2 : pt1
	                      ),
	                      true
	                    );
	                  }
	                },
	                calculate: function(inverted) {
	                  return calculate(inverted, false);
	                }
	              };
	            }
	            module2.exports = Intersecter;
	          }
	        ),
	        /***/
	        26859: (
	          /***/
	          function(module2) {
	            var LinkedList = {
	              create: function() {
	                var my = {
	                  root: { root: true, next: null },
	                  exists: function(node) {
	                    if (node === null || node === my.root)
	                      return false;
	                    return true;
	                  },
	                  isEmpty: function() {
	                    return my.root.next === null;
	                  },
	                  getHead: function() {
	                    return my.root.next;
	                  },
	                  insertBefore: function(node, check) {
	                    var last = my.root;
	                    var here = my.root.next;
	                    while (here !== null) {
	                      if (check(here)) {
	                        node.prev = here.prev;
	                        node.next = here;
	                        here.prev.next = node;
	                        here.prev = node;
	                        return;
	                      }
	                      last = here;
	                      here = here.next;
	                    }
	                    last.next = node;
	                    node.prev = last;
	                    node.next = null;
	                  },
	                  findTransition: function(check) {
	                    var prev = my.root;
	                    var here = my.root.next;
	                    while (here !== null) {
	                      if (check(here))
	                        break;
	                      prev = here;
	                      here = here.next;
	                    }
	                    return {
	                      before: prev === my.root ? null : prev,
	                      after: here,
	                      insert: function(node) {
	                        node.prev = prev;
	                        node.next = here;
	                        prev.next = node;
	                        if (here !== null)
	                          here.prev = node;
	                        return node;
	                      }
	                    };
	                  }
	                };
	                return my;
	              },
	              node: function(data) {
	                data.prev = null;
	                data.next = null;
	                data.remove = function() {
	                  data.prev.next = data.next;
	                  if (data.next)
	                    data.next.prev = data.prev;
	                  data.prev = null;
	                  data.next = null;
	                };
	                return data;
	              }
	            };
	            module2.exports = LinkedList;
	          }
	        ),
	        /***/
	        11328: (
	          /***/
	          function(module2) {
	            function SegmentChainer(segments, eps, buildLog) {
	              var chains = [];
	              var regions = [];
	              segments.forEach(function(seg) {
	                var pt1 = seg.start;
	                var pt2 = seg.end;
	                if (eps.pointsSame(pt1, pt2)) {
	                  console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
	                  return;
	                }
	                if (buildLog)
	                  buildLog.chainStart(seg);
	                var first_match = {
	                  index: 0,
	                  matches_head: false,
	                  matches_pt1: false
	                };
	                var second_match = {
	                  index: 0,
	                  matches_head: false,
	                  matches_pt1: false
	                };
	                var next_match = first_match;
	                function setMatch(index2, matches_head, matches_pt1) {
	                  next_match.index = index2;
	                  next_match.matches_head = matches_head;
	                  next_match.matches_pt1 = matches_pt1;
	                  if (next_match === first_match) {
	                    next_match = second_match;
	                    return false;
	                  }
	                  next_match = null;
	                  return true;
	                }
	                for (var i = 0; i < chains.length; i++) {
	                  var chain = chains[i];
	                  var head = chain[0];
	                  chain[1];
	                  var tail = chain[chain.length - 1];
	                  chain[chain.length - 2];
	                  if (eps.pointsSame(head, pt1)) {
	                    if (setMatch(i, true, true))
	                      break;
	                  } else if (eps.pointsSame(head, pt2)) {
	                    if (setMatch(i, true, false))
	                      break;
	                  } else if (eps.pointsSame(tail, pt1)) {
	                    if (setMatch(i, false, true))
	                      break;
	                  } else if (eps.pointsSame(tail, pt2)) {
	                    if (setMatch(i, false, false))
	                      break;
	                  }
	                }
	                if (next_match === first_match) {
	                  chains.push([pt1, pt2]);
	                  if (buildLog)
	                    buildLog.chainNew(pt1, pt2);
	                  return;
	                }
	                if (next_match === second_match) {
	                  if (buildLog)
	                    buildLog.chainMatch(first_match.index);
	                  var index = first_match.index;
	                  var pt = first_match.matches_pt1 ? pt2 : pt1;
	                  var addToHead = first_match.matches_head;
	                  var chain = chains[index];
	                  var grow = addToHead ? chain[0] : chain[chain.length - 1];
	                  var grow2 = addToHead ? chain[1] : chain[chain.length - 2];
	                  var oppo = addToHead ? chain[chain.length - 1] : chain[0];
	                  var oppo2 = addToHead ? chain[chain.length - 2] : chain[1];
	                  if (eps.pointsCollinear(grow2, grow, pt)) {
	                    if (addToHead) {
	                      if (buildLog)
	                        buildLog.chainRemoveHead(first_match.index, pt);
	                      chain.shift();
	                    } else {
	                      if (buildLog)
	                        buildLog.chainRemoveTail(first_match.index, pt);
	                      chain.pop();
	                    }
	                    grow = grow2;
	                  }
	                  if (eps.pointsSame(oppo, pt)) {
	                    chains.splice(index, 1);
	                    if (eps.pointsCollinear(oppo2, oppo, grow)) {
	                      if (addToHead) {
	                        if (buildLog)
	                          buildLog.chainRemoveTail(first_match.index, grow);
	                        chain.pop();
	                      } else {
	                        if (buildLog)
	                          buildLog.chainRemoveHead(first_match.index, grow);
	                        chain.shift();
	                      }
	                    }
	                    if (buildLog)
	                      buildLog.chainClose(first_match.index);
	                    regions.push(chain);
	                    return;
	                  }
	                  if (addToHead) {
	                    if (buildLog)
	                      buildLog.chainAddHead(first_match.index, pt);
	                    chain.unshift(pt);
	                  } else {
	                    if (buildLog)
	                      buildLog.chainAddTail(first_match.index, pt);
	                    chain.push(pt);
	                  }
	                  return;
	                }
	                function reverseChain(index2) {
	                  if (buildLog)
	                    buildLog.chainReverse(index2);
	                  chains[index2].reverse();
	                }
	                function appendChain(index1, index2) {
	                  var chain1 = chains[index1];
	                  var chain2 = chains[index2];
	                  var tail3 = chain1[chain1.length - 1];
	                  var tail22 = chain1[chain1.length - 2];
	                  var head3 = chain2[0];
	                  var head22 = chain2[1];
	                  if (eps.pointsCollinear(tail22, tail3, head3)) {
	                    if (buildLog)
	                      buildLog.chainRemoveTail(index1, tail3);
	                    chain1.pop();
	                    tail3 = tail22;
	                  }
	                  if (eps.pointsCollinear(tail3, head3, head22)) {
	                    if (buildLog)
	                      buildLog.chainRemoveHead(index2, head3);
	                    chain2.shift();
	                  }
	                  if (buildLog)
	                    buildLog.chainJoin(index1, index2);
	                  chains[index1] = chain1.concat(chain2);
	                  chains.splice(index2, 1);
	                }
	                var F = first_match.index;
	                var S = second_match.index;
	                if (buildLog)
	                  buildLog.chainConnect(F, S);
	                var reverseF = chains[F].length < chains[S].length;
	                if (first_match.matches_head) {
	                  if (second_match.matches_head) {
	                    if (reverseF) {
	                      reverseChain(F);
	                      appendChain(F, S);
	                    } else {
	                      reverseChain(S);
	                      appendChain(S, F);
	                    }
	                  } else {
	                    appendChain(S, F);
	                  }
	                } else {
	                  if (second_match.matches_head) {
	                    appendChain(F, S);
	                  } else {
	                    if (reverseF) {
	                      reverseChain(F);
	                      appendChain(S, F);
	                    } else {
	                      reverseChain(S);
	                      appendChain(F, S);
	                    }
	                  }
	                }
	              });
	              return regions;
	            }
	            module2.exports = SegmentChainer;
	          }
	        ),
	        /***/
	        55968: (
	          /***/
	          function(module2) {
	            function select(segments, selection, buildLog) {
	              var result = [];
	              segments.forEach(function(seg) {
	                var index = (seg.myFill.above ? 8 : 0) + (seg.myFill.below ? 4 : 0) + (seg.otherFill && seg.otherFill.above ? 2 : 0) + (seg.otherFill && seg.otherFill.below ? 1 : 0);
	                if (selection[index] !== 0) {
	                  result.push({
	                    id: buildLog ? buildLog.segmentId() : -1,
	                    start: seg.start,
	                    end: seg.end,
	                    myFill: {
	                      above: selection[index] === 1,
	                      // 1 if filled above
	                      below: selection[index] === 2
	                      // 2 if filled below
	                    },
	                    otherFill: null
	                  });
	                }
	              });
	              if (buildLog)
	                buildLog.selected(result);
	              return result;
	            }
	            var SegmentSelector = {
	              union: function(segments, buildLog) {
	                return select(segments, [
	                  0,
	                  2,
	                  1,
	                  0,
	                  2,
	                  2,
	                  0,
	                  0,
	                  1,
	                  0,
	                  1,
	                  0,
	                  0,
	                  0,
	                  0,
	                  0
	                ], buildLog);
	              },
	              intersect: function(segments, buildLog) {
	                return select(segments, [
	                  0,
	                  0,
	                  0,
	                  0,
	                  0,
	                  2,
	                  0,
	                  2,
	                  0,
	                  0,
	                  1,
	                  1,
	                  0,
	                  2,
	                  1,
	                  0
	                ], buildLog);
	              },
	              difference: function(segments, buildLog) {
	                return select(segments, [
	                  0,
	                  0,
	                  0,
	                  0,
	                  2,
	                  0,
	                  2,
	                  0,
	                  1,
	                  1,
	                  0,
	                  0,
	                  0,
	                  1,
	                  2,
	                  0
	                ], buildLog);
	              },
	              differenceRev: function(segments, buildLog) {
	                return select(segments, [
	                  0,
	                  2,
	                  1,
	                  0,
	                  0,
	                  0,
	                  1,
	                  1,
	                  0,
	                  2,
	                  0,
	                  2,
	                  0,
	                  0,
	                  0,
	                  0
	                ], buildLog);
	              },
	              xor: function(segments, buildLog) {
	                return select(segments, [
	                  0,
	                  2,
	                  1,
	                  0,
	                  2,
	                  0,
	                  0,
	                  1,
	                  1,
	                  0,
	                  0,
	                  2,
	                  0,
	                  1,
	                  2,
	                  0
	                ], buildLog);
	              }
	            };
	            module2.exports = SegmentSelector;
	          }
	        ),
	        /***/
	        14847: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Transform = __webpack_require__2(21630).Transform;
	            var streamParser = __webpack_require__2(90715);
	            function ParserStream() {
	              Transform.call(this, { readableObjectMode: true });
	            }
	            ParserStream.prototype = Object.create(Transform.prototype);
	            ParserStream.prototype.constructor = ParserStream;
	            streamParser(ParserStream.prototype);
	            exports2.OF = function(src, start, dest) {
	              for (var i = start, j = 0; j < dest.length; ) {
	                if (src[i++] !== dest[j++]) return false;
	              }
	              return true;
	            };
	            exports2.eG = function(str, format) {
	              var arr = [], i = 0;
	              if (format && format === "hex") {
	                while (i < str.length) {
	                  arr.push(parseInt(str.slice(i, i + 2), 16));
	                  i += 2;
	                }
	              } else {
	                for (; i < str.length; i++) {
	                  arr.push(str.charCodeAt(i) & 255);
	                }
	              }
	              return arr;
	            };
	            exports2.mP = function(data, offset) {
	              return data[offset] | data[offset + 1] << 8;
	            };
	            exports2.n8 = function(data, offset) {
	              return data[offset + 1] | data[offset] << 8;
	            };
	            exports2.nm = function(data, offset) {
	              return data[offset] | data[offset + 1] << 8 | data[offset + 2] << 16 | data[offset + 3] * 16777216;
	            };
	            exports2.Ag = function(data, offset) {
	              return data[offset + 3] | data[offset + 2] << 8 | data[offset + 1] << 16 | data[offset] * 16777216;
	            };
	            function ProbeError(message, code, statusCode) {
	              Error.call(this);
	              if (Error.captureStackTrace) {
	                Error.captureStackTrace(this, this.constructor);
	              } else {
	                this.stack = new Error().stack || "";
	              }
	              this.name = this.constructor.name;
	              this.message = message;
	              if (code) this.code = code;
	              if (statusCode) this.statusCode = statusCode;
	            }
	            ProbeError.prototype = Object.create(Error.prototype);
	            ProbeError.prototype.constructor = ProbeError;
	          }
	        ),
	        /***/
	        71371: (
	          /***/
	          function(module2) {
	            function error(message, code) {
	              var err = new Error(message);
	              err.code = code;
	              return err;
	            }
	            function utf8_decode(str) {
	              try {
	                return decodeURIComponent(escape(str));
	              } catch (_) {
	                return str;
	              }
	            }
	            function ExifParser(jpeg_bin, exif_start, exif_end) {
	              this.input = jpeg_bin.subarray(exif_start, exif_end);
	              this.start = exif_start;
	              var sig = String.fromCharCode.apply(null, this.input.subarray(0, 4));
	              if (sig !== "II*\0" && sig !== "MM\0*") {
	                throw error("invalid TIFF signature", "EBADDATA");
	              }
	              this.big_endian = sig[0] === "M";
	            }
	            ExifParser.prototype.each = function(on_entry) {
	              this.aborted = false;
	              var offset = this.read_uint32(4);
	              this.ifds_to_read = [{
	                id: 0,
	                offset
	              }];
	              while (this.ifds_to_read.length > 0 && !this.aborted) {
	                var i = this.ifds_to_read.shift();
	                if (!i.offset) continue;
	                this.scan_ifd(i.id, i.offset, on_entry);
	              }
	            };
	            ExifParser.prototype.read_uint16 = function(offset) {
	              var d = this.input;
	              if (offset + 2 > d.length) throw error("unexpected EOF", "EBADDATA");
	              return this.big_endian ? d[offset] * 256 + d[offset + 1] : d[offset] + d[offset + 1] * 256;
	            };
	            ExifParser.prototype.read_uint32 = function(offset) {
	              var d = this.input;
	              if (offset + 4 > d.length) throw error("unexpected EOF", "EBADDATA");
	              return this.big_endian ? d[offset] * 16777216 + d[offset + 1] * 65536 + d[offset + 2] * 256 + d[offset + 3] : d[offset] + d[offset + 1] * 256 + d[offset + 2] * 65536 + d[offset + 3] * 16777216;
	            };
	            ExifParser.prototype.is_subifd_link = function(ifd, tag) {
	              return ifd === 0 && tag === 34665 || // SubIFD
	              ifd === 0 && tag === 34853 || // GPS Info
	              ifd === 34665 && tag === 40965;
	            };
	            ExifParser.prototype.exif_format_length = function(format) {
	              switch (format) {
	                case 1:
	                case 2:
	                case 6:
	                case 7:
	                  return 1;
	                case 3:
	                case 8:
	                  return 2;
	                case 4:
	                case 9:
	                case 11:
	                  return 4;
	                case 5:
	                case 10:
	                case 12:
	                  return 8;
	                default:
	                  return 0;
	              }
	            };
	            ExifParser.prototype.exif_format_read = function(format, offset) {
	              var v;
	              switch (format) {
	                case 1:
	                case 2:
	                  v = this.input[offset];
	                  return v;
	                case 6:
	                  v = this.input[offset];
	                  return v | (v & 128) * 33554430;
	                case 3:
	                  v = this.read_uint16(offset);
	                  return v;
	                case 8:
	                  v = this.read_uint16(offset);
	                  return v | (v & 32768) * 131070;
	                case 4:
	                  v = this.read_uint32(offset);
	                  return v;
	                case 9:
	                  v = this.read_uint32(offset);
	                  return v | 0;
	                case 5:
	                case 10:
	                case 11:
	                case 12:
	                  return null;
	                case 7:
	                  return null;
	                default:
	                  return null;
	              }
	            };
	            ExifParser.prototype.scan_ifd = function(ifd_no, offset, on_entry) {
	              var entry_count = this.read_uint16(offset);
	              offset += 2;
	              for (var i = 0; i < entry_count; i++) {
	                var tag = this.read_uint16(offset);
	                var format = this.read_uint16(offset + 2);
	                var count = this.read_uint32(offset + 4);
	                var comp_length = this.exif_format_length(format);
	                var data_length = count * comp_length;
	                var data_offset = data_length <= 4 ? offset + 8 : this.read_uint32(offset + 8);
	                var is_subifd_link = false;
	                if (data_offset + data_length > this.input.length) {
	                  throw error("unexpected EOF", "EBADDATA");
	                }
	                var value = [];
	                var comp_offset = data_offset;
	                for (var j = 0; j < count; j++, comp_offset += comp_length) {
	                  var item = this.exif_format_read(format, comp_offset);
	                  if (item === null) {
	                    value = null;
	                    break;
	                  }
	                  value.push(item);
	                }
	                if (Array.isArray(value) && format === 2) {
	                  value = utf8_decode(String.fromCharCode.apply(null, value));
	                  if (value && value[value.length - 1] === "\0") value = value.slice(0, -1);
	                }
	                if (this.is_subifd_link(ifd_no, tag)) {
	                  if (Array.isArray(value) && Number.isInteger(value[0]) && value[0] > 0) {
	                    this.ifds_to_read.push({
	                      id: tag,
	                      offset: value[0]
	                    });
	                    is_subifd_link = true;
	                  }
	                }
	                var entry = {
	                  is_big_endian: this.big_endian,
	                  ifd: ifd_no,
	                  tag,
	                  format,
	                  count,
	                  entry_offset: offset + this.start,
	                  data_length,
	                  data_offset: data_offset + this.start,
	                  value,
	                  is_subifd_link
	                };
	                if (on_entry(entry) === false) {
	                  this.aborted = true;
	                  return;
	                }
	                offset += 12;
	              }
	              if (ifd_no === 0) {
	                this.ifds_to_read.push({
	                  id: 1,
	                  offset: this.read_uint32(offset)
	                });
	              }
	            };
	            module2.exports.ExifParser = ExifParser;
	            module2.exports.get_orientation = function(data) {
	              var orientation = 0;
	              try {
	                new ExifParser(data, 0, data.length).each(function(entry) {
	                  if (entry.ifd === 0 && entry.tag === 274 && Array.isArray(entry.value)) {
	                    orientation = entry.value[0];
	                    return false;
	                  }
	                });
	                return orientation;
	              } catch (err) {
	                return -1;
	              }
	            };
	          }
	        ),
	        /***/
	        76767: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var readUInt16BE = __webpack_require__2(14847).n8;
	            var readUInt32BE = __webpack_require__2(14847).Ag;
	            function unbox(data, offset) {
	              if (data.length < 4 + offset) return null;
	              var size = readUInt32BE(data, offset);
	              if (data.length < size + offset || size < 8) return null;
	              return {
	                boxtype: String.fromCharCode.apply(null, data.slice(offset + 4, offset + 8)),
	                data: data.slice(offset + 8, offset + size),
	                end: offset + size
	              };
	            }
	            module2.exports.unbox = unbox;
	            function scan_ipco(data, sandbox) {
	              var offset = 0;
	              for (; ; ) {
	                var box = unbox(data, offset);
	                if (!box) break;
	                switch (box.boxtype) {
	                  case "ispe":
	                    sandbox.sizes.push({
	                      width: readUInt32BE(box.data, 4),
	                      height: readUInt32BE(box.data, 8)
	                    });
	                    break;
	                  case "irot":
	                    sandbox.transforms.push({
	                      type: "irot",
	                      value: box.data[0] & 3
	                    });
	                    break;
	                  case "imir":
	                    sandbox.transforms.push({
	                      type: "imir",
	                      value: box.data[0] & 1
	                    });
	                    break;
	                }
	                offset = box.end;
	              }
	            }
	            function readUIntBE(data, offset, size) {
	              var result = 0;
	              for (var i = 0; i < size; i++) {
	                result = result * 256 + (data[offset + i] || 0);
	              }
	              return result;
	            }
	            function scan_iloc(data, sandbox) {
	              var offset_size = data[4] >> 4 & 15;
	              var length_size = data[4] & 15;
	              var base_offset_size = data[5] >> 4 & 15;
	              var item_count = readUInt16BE(data, 6);
	              var offset = 8;
	              for (var i = 0; i < item_count; i++) {
	                var item_ID = readUInt16BE(data, offset);
	                offset += 2;
	                var data_reference_index = readUInt16BE(data, offset);
	                offset += 2;
	                var base_offset = readUIntBE(data, offset, base_offset_size);
	                offset += base_offset_size;
	                var extent_count = readUInt16BE(data, offset);
	                offset += 2;
	                if (data_reference_index === 0 && extent_count === 1) {
	                  var first_extent_offset = readUIntBE(data, offset, offset_size);
	                  var first_extent_length = readUIntBE(data, offset + offset_size, length_size);
	                  sandbox.item_loc[item_ID] = { length: first_extent_length, offset: first_extent_offset + base_offset };
	                }
	                offset += extent_count * (offset_size + length_size);
	              }
	            }
	            function scan_iinf(data, sandbox) {
	              var item_count = readUInt16BE(data, 4);
	              var offset = 6;
	              for (var i = 0; i < item_count; i++) {
	                var box = unbox(data, offset);
	                if (!box) break;
	                if (box.boxtype === "infe") {
	                  var item_id = readUInt16BE(box.data, 4);
	                  var item_name = "";
	                  for (var pos = 8; pos < box.data.length && box.data[pos]; pos++) {
	                    item_name += String.fromCharCode(box.data[pos]);
	                  }
	                  sandbox.item_inf[item_name] = item_id;
	                }
	                offset = box.end;
	              }
	            }
	            function scan_iprp(data, sandbox) {
	              var offset = 0;
	              for (; ; ) {
	                var box = unbox(data, offset);
	                if (!box) break;
	                if (box.boxtype === "ipco") scan_ipco(box.data, sandbox);
	                offset = box.end;
	              }
	            }
	            function scan_meta(data, sandbox) {
	              var offset = 4;
	              for (; ; ) {
	                var box = unbox(data, offset);
	                if (!box) break;
	                if (box.boxtype === "iprp") scan_iprp(box.data, sandbox);
	                if (box.boxtype === "iloc") scan_iloc(box.data, sandbox);
	                if (box.boxtype === "iinf") scan_iinf(box.data, sandbox);
	                offset = box.end;
	              }
	            }
	            function getMaxSize(sizes) {
	              var maxWidthSize = sizes.reduce(function(a, b) {
	                return a.width > b.width || a.width === b.width && a.height > b.height ? a : b;
	              });
	              var maxHeightSize = sizes.reduce(function(a, b) {
	                return a.height > b.height || a.height === b.height && a.width > b.width ? a : b;
	              });
	              var maxSize;
	              if (maxWidthSize.width > maxHeightSize.height || maxWidthSize.width === maxHeightSize.height && maxWidthSize.height > maxHeightSize.width) {
	                maxSize = maxWidthSize;
	              } else {
	                maxSize = maxHeightSize;
	              }
	              return maxSize;
	            }
	            module2.exports.readSizeFromMeta = function(data) {
	              var sandbox = {
	                sizes: [],
	                transforms: [],
	                item_inf: {},
	                item_loc: {}
	              };
	              scan_meta(data, sandbox);
	              if (!sandbox.sizes.length) return;
	              var maxSize = getMaxSize(sandbox.sizes);
	              var orientation = 1;
	              sandbox.transforms.forEach(function(transform) {
	                var rotate_ccw = { 1: 6, 2: 5, 3: 8, 4: 7, 5: 4, 6: 3, 7: 2, 8: 1 };
	                var mirror_vert = { 1: 4, 2: 3, 3: 2, 4: 1, 5: 6, 6: 5, 7: 8, 8: 7 };
	                if (transform.type === "imir") {
	                  if (transform.value === 0) {
	                    orientation = mirror_vert[orientation];
	                  } else {
	                    orientation = mirror_vert[orientation];
	                    orientation = rotate_ccw[orientation];
	                    orientation = rotate_ccw[orientation];
	                  }
	                }
	                if (transform.type === "irot") {
	                  for (var i = 0; i < transform.value; i++) {
	                    orientation = rotate_ccw[orientation];
	                  }
	                }
	              });
	              var exif_location = null;
	              if (sandbox.item_inf.Exif) {
	                exif_location = sandbox.item_loc[sandbox.item_inf.Exif];
	              }
	              return {
	                width: maxSize.width,
	                height: maxSize.height,
	                orientation: sandbox.transforms.length ? orientation : null,
	                variants: sandbox.sizes,
	                exif_location
	              };
	            };
	            module2.exports.getMimeType = function(data) {
	              var brand = String.fromCharCode.apply(null, data.slice(0, 4));
	              var compat = {};
	              compat[brand] = true;
	              for (var i = 8; i < data.length; i += 4) {
	                compat[String.fromCharCode.apply(null, data.slice(i, i + 4))] = true;
	              }
	              if (!compat.mif1 && !compat.msf1 && !compat.miaf) return;
	              if (brand === "avif" || brand === "avis" || brand === "avio") {
	                return { type: "avif", mime: "image/avif" };
	              }
	              if (brand === "heic" || brand === "heix") {
	                return { type: "heic", mime: "image/heic" };
	              }
	              if (brand === "hevc" || brand === "hevx") {
	                return { type: "heic", mime: "image/heic-sequence" };
	              }
	              if (compat.avif || compat.avis) {
	                return { type: "avif", mime: "image/avif" };
	              }
	              if (compat.heic || compat.heix || compat.hevc || compat.hevx || compat.heis) {
	                if (compat.msf1) {
	                  return { type: "heif", mime: "image/heif-sequence" };
	                }
	                return { type: "heif", mime: "image/heif" };
	              }
	              return { type: "avif", mime: "image/avif" };
	            };
	          }
	        ),
	        /***/
	        24461: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt32BE = __webpack_require__2(14847).Ag;
	            var miaf = __webpack_require__2(76767);
	            var exif = __webpack_require__2(71371);
	            var SIG_FTYP = str2arr("ftyp");
	            module2.exports = function(data) {
	              if (!sliceEq(data, 4, SIG_FTYP)) return;
	              var firstBox = miaf.unbox(data, 0);
	              if (!firstBox) return;
	              var fileType = miaf.getMimeType(firstBox.data);
	              if (!fileType) return;
	              var meta, offset = firstBox.end;
	              for (; ; ) {
	                var box = miaf.unbox(data, offset);
	                if (!box) break;
	                offset = box.end;
	                if (box.boxtype === "mdat") return;
	                if (box.boxtype === "meta") {
	                  meta = box.data;
	                  break;
	                }
	              }
	              if (!meta) return;
	              var imgSize = miaf.readSizeFromMeta(meta);
	              if (!imgSize) return;
	              var result = {
	                width: imgSize.width,
	                height: imgSize.height,
	                type: fileType.type,
	                mime: fileType.mime,
	                wUnits: "px",
	                hUnits: "px"
	              };
	              if (imgSize.variants.length > 1) {
	                result.variants = imgSize.variants;
	              }
	              if (imgSize.orientation) {
	                result.orientation = imgSize.orientation;
	              }
	              if (imgSize.exif_location && imgSize.exif_location.offset + imgSize.exif_location.length <= data.length) {
	                var sig_offset = readUInt32BE(data, imgSize.exif_location.offset);
	                var exif_data = data.slice(
	                  imgSize.exif_location.offset + sig_offset + 4,
	                  imgSize.exif_location.offset + imgSize.exif_location.length
	                );
	                var orientation = exif.get_orientation(exif_data);
	                if (orientation > 0) result.orientation = orientation;
	              }
	              return result;
	            };
	          }
	        ),
	        /***/
	        2504: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt16LE = __webpack_require__2(14847).mP;
	            var SIG_BM = str2arr("BM");
	            module2.exports = function(data) {
	              if (data.length < 26) return;
	              if (!sliceEq(data, 0, SIG_BM)) return;
	              return {
	                width: readUInt16LE(data, 18),
	                height: readUInt16LE(data, 22),
	                type: "bmp",
	                mime: "image/bmp",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            };
	          }
	        ),
	        /***/
	        47342: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt16LE = __webpack_require__2(14847).mP;
	            var SIG_GIF87a = str2arr("GIF87a");
	            var SIG_GIF89a = str2arr("GIF89a");
	            module2.exports = function(data) {
	              if (data.length < 10) return;
	              if (!sliceEq(data, 0, SIG_GIF87a) && !sliceEq(data, 0, SIG_GIF89a)) return;
	              return {
	                width: readUInt16LE(data, 6),
	                height: readUInt16LE(data, 8),
	                type: "gif",
	                mime: "image/gif",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            };
	          }
	        ),
	        /***/
	        31355: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var readUInt16LE = __webpack_require__2(14847).mP;
	            var HEADER = 0;
	            var TYPE_ICO = 1;
	            var INDEX_SIZE = 16;
	            module2.exports = function(data) {
	              var header = readUInt16LE(data, 0);
	              var type = readUInt16LE(data, 2);
	              var numImages = readUInt16LE(data, 4);
	              if (header !== HEADER || type !== TYPE_ICO || !numImages) {
	                return;
	              }
	              var variants = [];
	              var maxSize = { width: 0, height: 0 };
	              for (var i = 0; i < numImages; i++) {
	                var width = data[6 + INDEX_SIZE * i] || 256;
	                var height = data[6 + INDEX_SIZE * i + 1] || 256;
	                var size = { width, height };
	                variants.push(size);
	                if (width > maxSize.width || height > maxSize.height) {
	                  maxSize = size;
	                }
	              }
	              return {
	                width: maxSize.width,
	                height: maxSize.height,
	                variants,
	                type: "ico",
	                mime: "image/x-icon",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            };
	          }
	        ),
	        /***/
	        54261: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var readUInt16BE = __webpack_require__2(14847).n8;
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var exif = __webpack_require__2(71371);
	            var SIG_EXIF = str2arr("Exif\0\0");
	            module2.exports = function(data) {
	              if (data.length < 2) return;
	              if (data[0] !== 255 || data[1] !== 216 || data[2] !== 255) return;
	              var offset = 2;
	              for (; ; ) {
	                for (; ; ) {
	                  if (data.length - offset < 2) return;
	                  if (data[offset++] === 255) break;
	                }
	                var code = data[offset++];
	                var length;
	                while (code === 255) code = data[offset++];
	                if (208 <= code && code <= 217 || code === 1) {
	                  length = 0;
	                } else if (192 <= code && code <= 254) {
	                  if (data.length - offset < 2) return;
	                  length = readUInt16BE(data, offset) - 2;
	                  offset += 2;
	                } else {
	                  return;
	                }
	                if (code === 217 || code === 218) {
	                  return;
	                }
	                var orientation;
	                if (code === 225 && length >= 10 && sliceEq(data, offset, SIG_EXIF)) {
	                  orientation = exif.get_orientation(data.slice(offset + 6, offset + length));
	                }
	                if (length >= 5 && (192 <= code && code <= 207) && code !== 196 && code !== 200 && code !== 204) {
	                  if (data.length - offset < length) return;
	                  var result = {
	                    width: readUInt16BE(data, offset + 3),
	                    height: readUInt16BE(data, offset + 1),
	                    type: "jpg",
	                    mime: "image/jpeg",
	                    wUnits: "px",
	                    hUnits: "px"
	                  };
	                  if (orientation > 0) {
	                    result.orientation = orientation;
	                  }
	                  return result;
	                }
	                offset += length;
	              }
	            };
	          }
	        ),
	        /***/
	        6303: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt32BE = __webpack_require__2(14847).Ag;
	            var SIG_PNG = str2arr("PNG\r\n\n");
	            var SIG_IHDR = str2arr("IHDR");
	            module2.exports = function(data) {
	              if (data.length < 24) return;
	              if (!sliceEq(data, 0, SIG_PNG)) return;
	              if (!sliceEq(data, 12, SIG_IHDR)) return;
	              return {
	                width: readUInt32BE(data, 16),
	                height: readUInt32BE(data, 20),
	                type: "png",
	                mime: "image/png",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            };
	          }
	        ),
	        /***/
	        38689: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt32BE = __webpack_require__2(14847).Ag;
	            var SIG_8BPS = str2arr("8BPS\0");
	            module2.exports = function(data) {
	              if (data.length < 6 + 16) return;
	              if (!sliceEq(data, 0, SIG_8BPS)) return;
	              return {
	                width: readUInt32BE(data, 6 + 12),
	                height: readUInt32BE(data, 6 + 8),
	                type: "psd",
	                mime: "image/vnd.adobe.photoshop",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            };
	          }
	        ),
	        /***/
	        6881: (
	          /***/
	          function(module2) {
	            function isWhiteSpace(chr) {
	              return chr === 32 || chr === 9 || chr === 13 || chr === 10;
	            }
	            function isFinitePositive(val) {
	              return typeof val === "number" && isFinite(val) && val > 0;
	            }
	            function canBeSvg(buf) {
	              var i = 0, max = buf.length;
	              if (buf[0] === 239 && buf[1] === 187 && buf[2] === 191) i = 3;
	              while (i < max && isWhiteSpace(buf[i])) i++;
	              if (i === max) return false;
	              return buf[i] === 60;
	            }
	            var SVG_HEADER_RE = /<[-_.:a-zA-Z0-9][^>]*>/;
	            var SVG_TAG_RE = /^<([-_.:a-zA-Z0-9]+:)?svg\s/;
	            var SVG_WIDTH_RE = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/;
	            var SVG_HEIGHT_RE = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/;
	            var SVG_VIEWBOX_RE = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/;
	            var SVG_UNITS_RE = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;
	            function svgAttrs(str) {
	              var width = str.match(SVG_WIDTH_RE);
	              var height = str.match(SVG_HEIGHT_RE);
	              var viewbox = str.match(SVG_VIEWBOX_RE);
	              return {
	                width: width && (width[1] || width[2]),
	                height: height && (height[1] || height[2]),
	                viewbox: viewbox && (viewbox[1] || viewbox[2])
	              };
	            }
	            function units(str) {
	              if (!SVG_UNITS_RE.test(str)) return "px";
	              return str.match(SVG_UNITS_RE)[0];
	            }
	            module2.exports = function(data) {
	              if (!canBeSvg(data)) return;
	              var str = "";
	              for (var i = 0; i < data.length; i++) {
	                str += String.fromCharCode(data[i]);
	              }
	              var svgTag = (str.match(SVG_HEADER_RE) || [""])[0];
	              if (!SVG_TAG_RE.test(svgTag)) return;
	              var attrs = svgAttrs(svgTag);
	              var width = parseFloat(attrs.width);
	              var height = parseFloat(attrs.height);
	              if (attrs.width && attrs.height) {
	                if (!isFinitePositive(width) || !isFinitePositive(height)) return;
	                return {
	                  width,
	                  height,
	                  type: "svg",
	                  mime: "image/svg+xml",
	                  wUnits: units(attrs.width),
	                  hUnits: units(attrs.height)
	                };
	              }
	              var parts = (attrs.viewbox || "").split(" ");
	              var viewbox = {
	                width: parts[2],
	                height: parts[3]
	              };
	              var vbWidth = parseFloat(viewbox.width);
	              var vbHeight = parseFloat(viewbox.height);
	              if (!isFinitePositive(vbWidth) || !isFinitePositive(vbHeight)) return;
	              if (units(viewbox.width) !== units(viewbox.height)) return;
	              var ratio = vbWidth / vbHeight;
	              if (attrs.width) {
	                if (!isFinitePositive(width)) return;
	                return {
	                  width,
	                  height: width / ratio,
	                  type: "svg",
	                  mime: "image/svg+xml",
	                  wUnits: units(attrs.width),
	                  hUnits: units(attrs.width)
	                };
	              }
	              if (attrs.height) {
	                if (!isFinitePositive(height)) return;
	                return {
	                  width: height * ratio,
	                  height,
	                  type: "svg",
	                  mime: "image/svg+xml",
	                  wUnits: units(attrs.height),
	                  hUnits: units(attrs.height)
	                };
	              }
	              return {
	                width: vbWidth,
	                height: vbHeight,
	                type: "svg",
	                mime: "image/svg+xml",
	                wUnits: units(viewbox.width),
	                hUnits: units(viewbox.height)
	              };
	            };
	          }
	        ),
	        /***/
	        66278: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt16LE = __webpack_require__2(14847).mP;
	            var readUInt16BE = __webpack_require__2(14847).n8;
	            var readUInt32LE = __webpack_require__2(14847).nm;
	            var readUInt32BE = __webpack_require__2(14847).Ag;
	            var SIG_1 = str2arr("II*\0");
	            var SIG_2 = str2arr("MM\0*");
	            function readUInt16(buffer, offset, is_big_endian) {
	              return is_big_endian ? readUInt16BE(buffer, offset) : readUInt16LE(buffer, offset);
	            }
	            function readUInt32(buffer, offset, is_big_endian) {
	              return is_big_endian ? readUInt32BE(buffer, offset) : readUInt32LE(buffer, offset);
	            }
	            function readIFDValue(data, data_offset, is_big_endian) {
	              var type = readUInt16(data, data_offset + 2, is_big_endian);
	              var values = readUInt32(data, data_offset + 4, is_big_endian);
	              if (values !== 1 || type !== 3 && type !== 4) return null;
	              if (type === 3) {
	                return readUInt16(data, data_offset + 8, is_big_endian);
	              }
	              return readUInt32(data, data_offset + 8, is_big_endian);
	            }
	            module2.exports = function(data) {
	              if (data.length < 8) return;
	              if (!sliceEq(data, 0, SIG_1) && !sliceEq(data, 0, SIG_2)) return;
	              var is_big_endian = data[0] === 77;
	              var count = readUInt32(data, 4, is_big_endian) - 8;
	              if (count < 0) return;
	              var offset = count + 8;
	              if (data.length - offset < 2) return;
	              var ifd_size = readUInt16(data, offset + 0, is_big_endian) * 12;
	              if (ifd_size <= 0) return;
	              offset += 2;
	              if (data.length - offset < ifd_size) return;
	              var i, width, height, tag;
	              for (i = 0; i < ifd_size; i += 12) {
	                tag = readUInt16(data, offset + i, is_big_endian);
	                if (tag === 256) {
	                  width = readIFDValue(data, offset + i, is_big_endian);
	                } else if (tag === 257) {
	                  height = readIFDValue(data, offset + i, is_big_endian);
	                }
	              }
	              if (width && height) {
	                return {
	                  width,
	                  height,
	                  type: "tiff",
	                  mime: "image/tiff",
	                  wUnits: "px",
	                  hUnits: "px"
	                };
	              }
	            };
	          }
	        ),
	        /***/
	        90784: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var str2arr = __webpack_require__2(14847).eG;
	            var sliceEq = __webpack_require__2(14847).OF;
	            var readUInt16LE = __webpack_require__2(14847).mP;
	            var readUInt32LE = __webpack_require__2(14847).nm;
	            var exif = __webpack_require__2(71371);
	            var SIG_RIFF = str2arr("RIFF");
	            var SIG_WEBP = str2arr("WEBP");
	            function parseVP8(data, offset) {
	              if (data[offset + 3] !== 157 || data[offset + 4] !== 1 || data[offset + 5] !== 42) {
	                return;
	              }
	              return {
	                width: readUInt16LE(data, offset + 6) & 16383,
	                height: readUInt16LE(data, offset + 8) & 16383,
	                type: "webp",
	                mime: "image/webp",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            }
	            function parseVP8L(data, offset) {
	              if (data[offset] !== 47) return;
	              var bits = readUInt32LE(data, offset + 1);
	              return {
	                width: (bits & 16383) + 1,
	                height: (bits >> 14 & 16383) + 1,
	                type: "webp",
	                mime: "image/webp",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            }
	            function parseVP8X(data, offset) {
	              return {
	                // TODO: replace with `data.readUIntLE(8, 3) + 1`
	                //       when 0.10 support is dropped
	                width: (data[offset + 6] << 16 | data[offset + 5] << 8 | data[offset + 4]) + 1,
	                height: (data[offset + 9] << offset | data[offset + 8] << 8 | data[offset + 7]) + 1,
	                type: "webp",
	                mime: "image/webp",
	                wUnits: "px",
	                hUnits: "px"
	              };
	            }
	            module2.exports = function(data) {
	              if (data.length < 16) return;
	              if (!sliceEq(data, 0, SIG_RIFF) && !sliceEq(data, 8, SIG_WEBP)) return;
	              var offset = 12;
	              var result = null;
	              var exif_orientation = 0;
	              var fileLength = readUInt32LE(data, 4) + 8;
	              if (fileLength > data.length) return;
	              while (offset + 8 < fileLength) {
	                if (data[offset] === 0) {
	                  offset++;
	                  continue;
	                }
	                var header = String.fromCharCode.apply(null, data.slice(offset, offset + 4));
	                var length = readUInt32LE(data, offset + 4);
	                if (header === "VP8 " && length >= 10) {
	                  result = result || parseVP8(data, offset + 8);
	                } else if (header === "VP8L" && length >= 9) {
	                  result = result || parseVP8L(data, offset + 8);
	                } else if (header === "VP8X" && length >= 10) {
	                  result = result || parseVP8X(data, offset + 8);
	                } else if (header === "EXIF") {
	                  exif_orientation = exif.get_orientation(data.slice(offset + 8, offset + 8 + length));
	                  offset = Infinity;
	                }
	                offset += 8 + length;
	              }
	              if (!result) return;
	              if (exif_orientation > 0) {
	                result.orientation = exif_orientation;
	              }
	              return result;
	            };
	          }
	        ),
	        /***/
	        91497: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = {
	              avif: __webpack_require__2(24461),
	              bmp: __webpack_require__2(2504),
	              gif: __webpack_require__2(47342),
	              ico: __webpack_require__2(31355),
	              jpeg: __webpack_require__2(54261),
	              png: __webpack_require__2(6303),
	              psd: __webpack_require__2(38689),
	              svg: __webpack_require__2(6881),
	              tiff: __webpack_require__2(66278),
	              webp: __webpack_require__2(90784)
	            };
	          }
	        ),
	        /***/
	        33575: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parsers = __webpack_require__2(91497);
	            function probeBuffer(buffer) {
	              var parser_names = Object.keys(parsers);
	              for (var i = 0; i < parser_names.length; i++) {
	                var result = parsers[parser_names[i]](buffer);
	                if (result) return result;
	              }
	              return null;
	            }
	            module2.exports = function get_image_size(src) {
	              return probeBuffer(src);
	            };
	            module2.exports.parsers = parsers;
	          }
	        ),
	        /***/
	        90386: (
	          /***/
	          function(module2) {
	            var process = module2.exports = {};
	            var cachedSetTimeout;
	            var cachedClearTimeout;
	            function defaultSetTimout() {
	              throw new Error("setTimeout has not been defined");
	            }
	            function defaultClearTimeout() {
	              throw new Error("clearTimeout has not been defined");
	            }
	            (function() {
	              try {
	                if (typeof setTimeout === "function") {
	                  cachedSetTimeout = setTimeout;
	                } else {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	              } catch (e) {
	                cachedSetTimeout = defaultSetTimout;
	              }
	              try {
	                if (typeof clearTimeout === "function") {
	                  cachedClearTimeout = clearTimeout;
	                } else {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              } catch (e) {
	                cachedClearTimeout = defaultClearTimeout;
	              }
	            })();
	            function runTimeout(fun) {
	              if (cachedSetTimeout === setTimeout) {
	                return setTimeout(fun, 0);
	              }
	              if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                cachedSetTimeout = setTimeout;
	                return setTimeout(fun, 0);
	              }
	              try {
	                return cachedSetTimeout(fun, 0);
	              } catch (e) {
	                try {
	                  return cachedSetTimeout.call(null, fun, 0);
	                } catch (e2) {
	                  return cachedSetTimeout.call(this, fun, 0);
	                }
	              }
	            }
	            function runClearTimeout(marker) {
	              if (cachedClearTimeout === clearTimeout) {
	                return clearTimeout(marker);
	              }
	              if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                cachedClearTimeout = clearTimeout;
	                return clearTimeout(marker);
	              }
	              try {
	                return cachedClearTimeout(marker);
	              } catch (e) {
	                try {
	                  return cachedClearTimeout.call(null, marker);
	                } catch (e2) {
	                  return cachedClearTimeout.call(this, marker);
	                }
	              }
	            }
	            var queue = [];
	            var draining = false;
	            var currentQueue;
	            var queueIndex = -1;
	            function cleanUpNextTick() {
	              if (!draining || !currentQueue) {
	                return;
	              }
	              draining = false;
	              if (currentQueue.length) {
	                queue = currentQueue.concat(queue);
	              } else {
	                queueIndex = -1;
	              }
	              if (queue.length) {
	                drainQueue();
	              }
	            }
	            function drainQueue() {
	              if (draining) {
	                return;
	              }
	              var timeout = runTimeout(cleanUpNextTick);
	              draining = true;
	              var len = queue.length;
	              while (len) {
	                currentQueue = queue;
	                queue = [];
	                while (++queueIndex < len) {
	                  if (currentQueue) {
	                    currentQueue[queueIndex].run();
	                  }
	                }
	                queueIndex = -1;
	                len = queue.length;
	              }
	              currentQueue = null;
	              draining = false;
	              runClearTimeout(timeout);
	            }
	            process.nextTick = function(fun) {
	              var args = new Array(arguments.length - 1);
	              if (arguments.length > 1) {
	                for (var i = 1; i < arguments.length; i++) {
	                  args[i - 1] = arguments[i];
	                }
	              }
	              queue.push(new Item(fun, args));
	              if (queue.length === 1 && !draining) {
	                runTimeout(drainQueue);
	              }
	            };
	            function Item(fun, array) {
	              this.fun = fun;
	              this.array = array;
	            }
	            Item.prototype.run = function() {
	              this.fun.apply(null, this.array);
	            };
	            process.title = "browser";
	            process.browser = true;
	            process.env = {};
	            process.argv = [];
	            process.version = "";
	            process.versions = {};
	            function noop() {
	            }
	            process.on = noop;
	            process.addListener = noop;
	            process.once = noop;
	            process.off = noop;
	            process.removeListener = noop;
	            process.removeAllListeners = noop;
	            process.emit = noop;
	            process.prependListener = noop;
	            process.prependOnceListener = noop;
	            process.listeners = function(name2) {
	              return [];
	            };
	            process.binding = function(name2) {
	              throw new Error("process.binding is not supported");
	            };
	            process.cwd = function() {
	              return "/";
	            };
	            process.chdir = function(dir) {
	              throw new Error("process.chdir is not supported");
	            };
	            process.umask = function() {
	              return 0;
	            };
	          }
	        ),
	        /***/
	        5877: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var now = __webpack_require__2(9748), root = typeof window === "undefined" ? __webpack_require__2.g : window, vendors = ["moz", "webkit"], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
	            for (var i = 0; !raf && i < vendors.length; i++) {
	              raf = root[vendors[i] + "Request" + suffix];
	              caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
	            }
	            if (!raf || !caf) {
	              var last = 0, id = 0, queue = [], frameDuration = 1e3 / 60;
	              raf = function(callback) {
	                if (queue.length === 0) {
	                  var _now = now(), next = Math.max(0, frameDuration - (_now - last));
	                  last = next + _now;
	                  setTimeout(function() {
	                    var cp = queue.slice(0);
	                    queue.length = 0;
	                    for (var i2 = 0; i2 < cp.length; i2++) {
	                      if (!cp[i2].cancelled) {
	                        try {
	                          cp[i2].callback(last);
	                        } catch (e) {
	                          setTimeout(function() {
	                            throw e;
	                          }, 0);
	                        }
	                      }
	                    }
	                  }, Math.round(next));
	                }
	                queue.push({
	                  handle: ++id,
	                  callback,
	                  cancelled: false
	                });
	                return id;
	              };
	              caf = function(handle) {
	                for (var i2 = 0; i2 < queue.length; i2++) {
	                  if (queue[i2].handle === handle) {
	                    queue[i2].cancelled = true;
	                  }
	                }
	              };
	            }
	            module2.exports = function(fn) {
	              return raf.call(root, fn);
	            };
	            module2.exports.cancel = function() {
	              caf.apply(root, arguments);
	            };
	            module2.exports.polyfill = function(object) {
	              if (!object) {
	                object = root;
	              }
	              object.requestAnimationFrame = raf;
	              object.cancelAnimationFrame = caf;
	            };
	          }
	        ),
	        /***/
	        3593: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getBounds = __webpack_require__2(21527);
	            var rgba = __webpack_require__2(25075);
	            var updateDiff = __webpack_require__2(93447);
	            var pick = __webpack_require__2(71299);
	            var extend = __webpack_require__2(56131);
	            var flatten = __webpack_require__2(30120);
	            var ref = __webpack_require__2(57060);
	            var float32 = ref.float32;
	            var fract32 = ref.fract32;
	            module2.exports = Error2D;
	            var WEIGHTS = [
	              //direction, lineWidth shift, capSize shift
	              // x-error bar
	              [1, 0, 0, 1, 0, 0],
	              [1, 0, 0, -1, 0, 0],
	              [-1, 0, 0, -1, 0, 0],
	              [-1, 0, 0, -1, 0, 0],
	              [-1, 0, 0, 1, 0, 0],
	              [1, 0, 0, 1, 0, 0],
	              // x-error right cap
	              [1, 0, -1, 0, 0, 1],
	              [1, 0, -1, 0, 0, -1],
	              [1, 0, 1, 0, 0, -1],
	              [1, 0, 1, 0, 0, -1],
	              [1, 0, 1, 0, 0, 1],
	              [1, 0, -1, 0, 0, 1],
	              // x-error left cap
	              [-1, 0, -1, 0, 0, 1],
	              [-1, 0, -1, 0, 0, -1],
	              [-1, 0, 1, 0, 0, -1],
	              [-1, 0, 1, 0, 0, -1],
	              [-1, 0, 1, 0, 0, 1],
	              [-1, 0, -1, 0, 0, 1],
	              // y-error bar
	              [0, 1, 1, 0, 0, 0],
	              [0, 1, -1, 0, 0, 0],
	              [0, -1, -1, 0, 0, 0],
	              [0, -1, -1, 0, 0, 0],
	              [0, 1, 1, 0, 0, 0],
	              [0, -1, 1, 0, 0, 0],
	              // y-error top cap
	              [0, 1, 0, -1, 1, 0],
	              [0, 1, 0, -1, -1, 0],
	              [0, 1, 0, 1, -1, 0],
	              [0, 1, 0, 1, 1, 0],
	              [0, 1, 0, -1, 1, 0],
	              [0, 1, 0, 1, -1, 0],
	              // y-error bottom cap
	              [0, -1, 0, -1, 1, 0],
	              [0, -1, 0, -1, -1, 0],
	              [0, -1, 0, 1, -1, 0],
	              [0, -1, 0, 1, 1, 0],
	              [0, -1, 0, -1, 1, 0],
	              [0, -1, 0, 1, -1, 0]
	            ];
	            function Error2D(regl, options) {
	              if (typeof regl === "function") {
	                if (!options) {
	                  options = {};
	                }
	                options.regl = regl;
	              } else {
	                options = regl;
	              }
	              if (options.length) {
	                options.positions = options;
	              }
	              regl = options.regl;
	              if (!regl.hasExtension("ANGLE_instanced_arrays")) {
	                throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
	              }
	              var gl2 = regl._gl, drawErrors, positionBuffer, positionFractBuffer, colorBuffer, errorBuffer, meshBuffer, defaults = {
	                color: "black",
	                capSize: 5,
	                lineWidth: 1,
	                opacity: 1,
	                viewport: null,
	                range: null,
	                offset: 0,
	                count: 0,
	                bounds: null,
	                positions: [],
	                errors: []
	              }, groups = [];
	              colorBuffer = regl.buffer({
	                usage: "dynamic",
	                type: "uint8",
	                data: new Uint8Array(0)
	              });
	              positionBuffer = regl.buffer({
	                usage: "dynamic",
	                type: "float",
	                data: new Uint8Array(0)
	              });
	              positionFractBuffer = regl.buffer({
	                usage: "dynamic",
	                type: "float",
	                data: new Uint8Array(0)
	              });
	              errorBuffer = regl.buffer({
	                usage: "dynamic",
	                type: "float",
	                data: new Uint8Array(0)
	              });
	              meshBuffer = regl.buffer({
	                usage: "static",
	                type: "float",
	                data: WEIGHTS
	              });
	              update(options);
	              drawErrors = regl({
	                vert: "\n		precision highp float;\n\n		attribute vec2 position, positionFract;\n		attribute vec4 error;\n		attribute vec4 color;\n\n		attribute vec2 direction, lineOffset, capOffset;\n\n		uniform vec4 viewport;\n		uniform float lineWidth, capSize;\n		uniform vec2 scale, scaleFract, translate, translateFract;\n\n		varying vec4 fragColor;\n\n		void main() {\n			fragColor = color / 255.;\n\n			vec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n			vec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n			vec2 position = position + dxy;\n\n			vec2 pos = (position + translate) * scale\n				+ (positionFract + translateFract) * scale\n				+ (position + translate) * scaleFract\n				+ (positionFract + translateFract) * scaleFract;\n\n			pos += pixelOffset / viewport.zw;\n\n			gl_Position = vec4(pos * 2. - 1., 0, 1);\n		}\n		",
	                frag: "\n		precision highp float;\n\n		varying vec4 fragColor;\n\n		uniform float opacity;\n\n		void main() {\n			gl_FragColor = fragColor;\n			gl_FragColor.a *= opacity;\n		}\n		",
	                uniforms: {
	                  range: regl.prop("range"),
	                  lineWidth: regl.prop("lineWidth"),
	                  capSize: regl.prop("capSize"),
	                  opacity: regl.prop("opacity"),
	                  scale: regl.prop("scale"),
	                  translate: regl.prop("translate"),
	                  scaleFract: regl.prop("scaleFract"),
	                  translateFract: regl.prop("translateFract"),
	                  viewport: function(ctx, prop) {
	                    return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight];
	                  }
	                },
	                attributes: {
	                  //dynamic attributes
	                  color: {
	                    buffer: colorBuffer,
	                    offset: function(ctx, prop) {
	                      return prop.offset * 4;
	                    },
	                    divisor: 1
	                  },
	                  position: {
	                    buffer: positionBuffer,
	                    offset: function(ctx, prop) {
	                      return prop.offset * 8;
	                    },
	                    divisor: 1
	                  },
	                  positionFract: {
	                    buffer: positionFractBuffer,
	                    offset: function(ctx, prop) {
	                      return prop.offset * 8;
	                    },
	                    divisor: 1
	                  },
	                  error: {
	                    buffer: errorBuffer,
	                    offset: function(ctx, prop) {
	                      return prop.offset * 16;
	                    },
	                    divisor: 1
	                  },
	                  //static attributes
	                  direction: {
	                    buffer: meshBuffer,
	                    stride: 24,
	                    offset: 0
	                  },
	                  lineOffset: {
	                    buffer: meshBuffer,
	                    stride: 24,
	                    offset: 8
	                  },
	                  capOffset: {
	                    buffer: meshBuffer,
	                    stride: 24,
	                    offset: 16
	                  }
	                },
	                primitive: "triangles",
	                blend: {
	                  enable: true,
	                  color: [0, 0, 0, 0],
	                  equation: {
	                    rgb: "add",
	                    alpha: "add"
	                  },
	                  func: {
	                    srcRGB: "src alpha",
	                    dstRGB: "one minus src alpha",
	                    srcAlpha: "one minus dst alpha",
	                    dstAlpha: "one"
	                  }
	                },
	                depth: {
	                  enable: false
	                },
	                scissor: {
	                  enable: true,
	                  box: regl.prop("viewport")
	                },
	                viewport: regl.prop("viewport"),
	                stencil: false,
	                instances: regl.prop("count"),
	                count: WEIGHTS.length
	              });
	              extend(error2d, {
	                update,
	                draw,
	                destroy,
	                regl,
	                gl: gl2,
	                canvas: gl2.canvas,
	                groups
	              });
	              return error2d;
	              function error2d(opts) {
	                if (opts) {
	                  update(opts);
	                } else if (opts === null) {
	                  destroy();
	                }
	                draw();
	              }
	              function draw(options2) {
	                if (typeof options2 === "number") {
	                  return drawGroup(options2);
	                }
	                if (options2 && !Array.isArray(options2)) {
	                  options2 = [options2];
	                }
	                regl._refresh();
	                groups.forEach(function(s, i) {
	                  if (!s) {
	                    return;
	                  }
	                  if (options2) {
	                    if (!options2[i]) {
	                      s.draw = false;
	                    } else {
	                      s.draw = true;
	                    }
	                  }
	                  if (!s.draw) {
	                    s.draw = true;
	                    return;
	                  }
	                  drawGroup(i);
	                });
	              }
	              function drawGroup(s) {
	                if (typeof s === "number") {
	                  s = groups[s];
	                }
	                if (s == null) {
	                  return;
	                }
	                if (!(s && s.count && s.color && s.opacity && s.positions && s.positions.length > 1)) {
	                  return;
	                }
	                s.scaleRatio = [
	                  s.scale[0] * s.viewport.width,
	                  s.scale[1] * s.viewport.height
	                ];
	                drawErrors(s);
	                if (s.after) {
	                  s.after(s);
	                }
	              }
	              function update(options2) {
	                if (!options2) {
	                  return;
	                }
	                if (options2.length != null) {
	                  if (typeof options2[0] === "number") {
	                    options2 = [{ positions: options2 }];
	                  }
	                } else if (!Array.isArray(options2)) {
	                  options2 = [options2];
	                }
	                var pointCount = 0, errorCount = 0;
	                error2d.groups = groups = options2.map(function(options3, i) {
	                  var group = groups[i];
	                  if (!options3) {
	                    return group;
	                  } else if (typeof options3 === "function") {
	                    options3 = { after: options3 };
	                  } else if (typeof options3[0] === "number") {
	                    options3 = { positions: options3 };
	                  }
	                  options3 = pick(options3, {
	                    color: "color colors fill",
	                    capSize: "capSize cap capsize cap-size",
	                    lineWidth: "lineWidth line-width width line thickness",
	                    opacity: "opacity alpha",
	                    range: "range dataBox",
	                    viewport: "viewport viewBox",
	                    errors: "errors error",
	                    positions: "positions position data points"
	                  });
	                  if (!group) {
	                    groups[i] = group = {
	                      id: i,
	                      scale: null,
	                      translate: null,
	                      scaleFract: null,
	                      translateFract: null,
	                      draw: true
	                    };
	                    options3 = extend({}, defaults, options3);
	                  }
	                  updateDiff(group, options3, [{
	                    lineWidth: function(v) {
	                      return +v * 0.5;
	                    },
	                    capSize: function(v) {
	                      return +v * 0.5;
	                    },
	                    opacity: parseFloat,
	                    errors: function(errors) {
	                      errors = flatten(errors);
	                      errorCount += errors.length;
	                      return errors;
	                    },
	                    positions: function(positions, state) {
	                      positions = flatten(positions, "float64");
	                      state.count = Math.floor(positions.length / 2);
	                      state.bounds = getBounds(positions, 2);
	                      state.offset = pointCount;
	                      pointCount += state.count;
	                      return positions;
	                    }
	                  }, {
	                    color: function(colors, state) {
	                      var count = state.count;
	                      if (!colors) {
	                        colors = "transparent";
	                      }
	                      if (!Array.isArray(colors) || typeof colors[0] === "number") {
	                        var color = colors;
	                        colors = Array(count);
	                        for (var i2 = 0; i2 < count; i2++) {
	                          colors[i2] = color;
	                        }
	                      }
	                      if (colors.length < count) {
	                        throw Error("Not enough colors");
	                      }
	                      var colorData2 = new Uint8Array(count * 4);
	                      for (var i$1 = 0; i$1 < count; i$1++) {
	                        var c = rgba(colors[i$1], "uint8");
	                        colorData2.set(c, i$1 * 4);
	                      }
	                      return colorData2;
	                    },
	                    range: function(range2, state, options4) {
	                      var bounds = state.bounds;
	                      if (!range2) {
	                        range2 = bounds;
	                      }
	                      state.scale = [1 / (range2[2] - range2[0]), 1 / (range2[3] - range2[1])];
	                      state.translate = [-range2[0], -range2[1]];
	                      state.scaleFract = fract32(state.scale);
	                      state.translateFract = fract32(state.translate);
	                      return range2;
	                    },
	                    viewport: function(vp) {
	                      var viewport;
	                      if (Array.isArray(vp)) {
	                        viewport = {
	                          x: vp[0],
	                          y: vp[1],
	                          width: vp[2] - vp[0],
	                          height: vp[3] - vp[1]
	                        };
	                      } else if (vp) {
	                        viewport = {
	                          x: vp.x || vp.left || 0,
	                          y: vp.y || vp.top || 0
	                        };
	                        if (vp.right) {
	                          viewport.width = vp.right - viewport.x;
	                        } else {
	                          viewport.width = vp.w || vp.width || 0;
	                        }
	                        if (vp.bottom) {
	                          viewport.height = vp.bottom - viewport.y;
	                        } else {
	                          viewport.height = vp.h || vp.height || 0;
	                        }
	                      } else {
	                        viewport = {
	                          x: 0,
	                          y: 0,
	                          width: gl2.drawingBufferWidth,
	                          height: gl2.drawingBufferHeight
	                        };
	                      }
	                      return viewport;
	                    }
	                  }]);
	                  return group;
	                });
	                if (pointCount || errorCount) {
	                  var len = groups.reduce(function(acc, group, i) {
	                    return acc + (group ? group.count : 0);
	                  }, 0);
	                  var positionData = new Float64Array(len * 2);
	                  var colorData = new Uint8Array(len * 4);
	                  var errorData = new Float32Array(len * 4);
	                  groups.forEach(function(group, i) {
	                    if (!group) {
	                      return;
	                    }
	                    var positions = group.positions;
	                    var count = group.count;
	                    var offset = group.offset;
	                    var color = group.color;
	                    var errors = group.errors;
	                    if (!count) {
	                      return;
	                    }
	                    colorData.set(color, offset * 4);
	                    errorData.set(errors, offset * 4);
	                    positionData.set(positions, offset * 2);
	                  });
	                  var float_data = float32(positionData);
	                  positionBuffer(float_data);
	                  var frac_data = fract32(positionData, float_data);
	                  positionFractBuffer(frac_data);
	                  colorBuffer(colorData);
	                  errorBuffer(errorData);
	                }
	              }
	              function destroy() {
	                positionBuffer.destroy();
	                positionFractBuffer.destroy();
	                colorBuffer.destroy();
	                errorBuffer.destroy();
	                meshBuffer.destroy();
	              }
	            }
	          }
	        ),
	        /***/
	        46075: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var rgba = __webpack_require__2(25075);
	            var getBounds = __webpack_require__2(21527);
	            var extend = __webpack_require__2(56131);
	            var glslify = __webpack_require__2(56068);
	            var pick = __webpack_require__2(71299);
	            var flatten = __webpack_require__2(30120);
	            var triangulate = __webpack_require__2(11474);
	            var normalize = __webpack_require__2(54);
	            var ref = __webpack_require__2(57060);
	            var float32 = ref.float32;
	            var fract32 = ref.fract32;
	            var WeakMap2 = __webpack_require__2(83522);
	            var parseRect = __webpack_require__2(18863);
	            var findIndex = __webpack_require__2(6851);
	            module2.exports = Line2D;
	            function Line2D(regl, options) {
	              if (!(this instanceof Line2D)) {
	                return new Line2D(regl, options);
	              }
	              if (typeof regl === "function") {
	                if (!options) {
	                  options = {};
	                }
	                options.regl = regl;
	              } else {
	                options = regl;
	              }
	              if (options.length) {
	                options.positions = options;
	              }
	              regl = options.regl;
	              if (!regl.hasExtension("ANGLE_instanced_arrays")) {
	                throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
	              }
	              this.gl = regl._gl;
	              this.regl = regl;
	              this.passes = [];
	              this.shaders = Line2D.shaders.has(regl) ? Line2D.shaders.get(regl) : Line2D.shaders.set(regl, Line2D.createShaders(regl)).get(regl);
	              this.update(options);
	            }
	            Line2D.dashMult = 2;
	            Line2D.maxPatternLength = 256;
	            Line2D.precisionThreshold = 3e6;
	            Line2D.maxPoints = 1e4;
	            Line2D.maxLines = 2048;
	            Line2D.shaders = new WeakMap2();
	            Line2D.createShaders = function(regl) {
	              var offsetBuffer = regl.buffer({
	                usage: "static",
	                type: "float",
	                data: [0, 1, 0, 0, 1, 1, 1, 0]
	              });
	              var shaderOptions = {
	                primitive: "triangle strip",
	                instances: regl.prop("count"),
	                count: 4,
	                offset: 0,
	                uniforms: {
	                  miterMode: function(ctx, prop) {
	                    return prop.join === "round" ? 2 : 1;
	                  },
	                  miterLimit: regl.prop("miterLimit"),
	                  scale: regl.prop("scale"),
	                  scaleFract: regl.prop("scaleFract"),
	                  translateFract: regl.prop("translateFract"),
	                  translate: regl.prop("translate"),
	                  thickness: regl.prop("thickness"),
	                  dashTexture: regl.prop("dashTexture"),
	                  opacity: regl.prop("opacity"),
	                  pixelRatio: regl.context("pixelRatio"),
	                  id: regl.prop("id"),
	                  dashLength: regl.prop("dashLength"),
	                  viewport: function(c, p) {
	                    return [p.viewport.x, p.viewport.y, c.viewportWidth, c.viewportHeight];
	                  },
	                  depth: regl.prop("depth")
	                },
	                blend: {
	                  enable: true,
	                  color: [0, 0, 0, 0],
	                  equation: {
	                    rgb: "add",
	                    alpha: "add"
	                  },
	                  func: {
	                    srcRGB: "src alpha",
	                    dstRGB: "one minus src alpha",
	                    srcAlpha: "one minus dst alpha",
	                    dstAlpha: "one"
	                  }
	                },
	                depth: {
	                  enable: function(c, p) {
	                    return !p.overlay;
	                  }
	                },
	                stencil: { enable: false },
	                scissor: {
	                  enable: true,
	                  box: regl.prop("viewport")
	                },
	                viewport: regl.prop("viewport")
	              };
	              var drawRectLine = regl(extend({
	                vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n	// the order is important\n	return position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n	float lineStart = 1. - lineEnd;\n	float lineOffset = lineTop * 2. - 1.;\n\n	vec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n	tangent = normalize(diff * scale * viewport.zw);\n	vec2 normal = vec2(-tangent.y, tangent.x);\n\n	vec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n		+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n		+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n	gl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n	fragColor = color / 255.;\n}\n"]),
	                frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform float dashLength, pixelRatio, thickness, opacity, id;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n	float alpha = 1.;\n\n	float t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n	float dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n	gl_FragColor = fragColor;\n	gl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
	                attributes: {
	                  // if point is at the end of segment
	                  lineEnd: {
	                    buffer: offsetBuffer,
	                    divisor: 0,
	                    stride: 8,
	                    offset: 0
	                  },
	                  // if point is at the top of segment
	                  lineTop: {
	                    buffer: offsetBuffer,
	                    divisor: 0,
	                    stride: 8,
	                    offset: 4
	                  },
	                  // beginning of line coordinate
	                  aCoord: {
	                    buffer: regl.prop("positionBuffer"),
	                    stride: 8,
	                    offset: 8,
	                    divisor: 1
	                  },
	                  // end of line coordinate
	                  bCoord: {
	                    buffer: regl.prop("positionBuffer"),
	                    stride: 8,
	                    offset: 16,
	                    divisor: 1
	                  },
	                  aCoordFract: {
	                    buffer: regl.prop("positionFractBuffer"),
	                    stride: 8,
	                    offset: 8,
	                    divisor: 1
	                  },
	                  bCoordFract: {
	                    buffer: regl.prop("positionFractBuffer"),
	                    stride: 8,
	                    offset: 16,
	                    divisor: 1
	                  },
	                  color: {
	                    buffer: regl.prop("colorBuffer"),
	                    stride: 4,
	                    offset: 0,
	                    divisor: 1
	                  }
	                }
	              }, shaderOptions));
	              var drawMiterLine;
	              try {
	                drawMiterLine = regl(extend({
	                  // culling removes polygon creasing
	                  cull: {
	                    enable: true,
	                    face: "back"
	                  },
	                  vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n	vec2 diff = b - a;\n	vec2 perp = normalize(vec2(-diff.y, diff.x));\n	return dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n	vec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n	vec2 normalWidth = thickness / scaleRatio;\n\n	float lineStart = 1. - lineEnd;\n	float lineBot = 1. - lineTop;\n\n	fragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n	if (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n	if (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n	if (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n	vec2 prevDiff = aCoord - prevCoord;\n	vec2 currDiff = bCoord - aCoord;\n	vec2 nextDiff = nextCoord - bCoord;\n\n	vec2 prevTangent = normalize(prevDiff * scaleRatio);\n	vec2 currTangent = normalize(currDiff * scaleRatio);\n	vec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n	vec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n	vec2 currNormal = vec2(-currTangent.y, currTangent.x);\n	vec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n	vec2 startJoinDirection = normalize(prevTangent - currTangent);\n	vec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n	// collapsed/unidirectional segment cases\n	// FIXME: there should be more elegant solution\n	vec2 prevTanDiff = abs(prevTangent - currTangent);\n	vec2 nextTanDiff = abs(nextTangent - currTangent);\n	if (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n		startJoinDirection = currNormal;\n	}\n	if (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n		endJoinDirection = currNormal;\n	}\n	if (aCoord == bCoord) {\n		endJoinDirection = startJoinDirection;\n		currNormal = prevNormal;\n		currTangent = prevTangent;\n	}\n\n	tangent = currTangent;\n\n	//calculate join shifts relative to normals\n	float startJoinShift = dot(currNormal, startJoinDirection);\n	float endJoinShift = dot(currNormal, endJoinDirection);\n\n	float startMiterRatio = abs(1. / startJoinShift);\n	float endMiterRatio = abs(1. / endJoinShift);\n\n	vec2 startJoin = startJoinDirection * startMiterRatio;\n	vec2 endJoin = endJoinDirection * endMiterRatio;\n\n	vec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n	startTopJoin = sign(startJoinShift) * startJoin * .5;\n	startBotJoin = -startTopJoin;\n\n	endTopJoin = sign(endJoinShift) * endJoin * .5;\n	endBotJoin = -endTopJoin;\n\n	vec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n	vec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n	vec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n	vec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n	//miter anti-clipping\n	float baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n	float abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n	//prevent close to reverse direction switch\n	bool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n	bool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n	if (prevReverse) {\n		//make join rectangular\n		vec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n		float normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n		aBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n		aTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n	}\n	else if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n		//handle miter clipping\n		bTopCoord -= normalWidth * endTopJoin;\n		bTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n	}\n\n	if (nextReverse) {\n		//make join rectangular\n		vec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n		float normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n		bBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n		bTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n	}\n	else if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n		//handle miter clipping\n		aBotCoord -= normalWidth * startBotJoin;\n		aBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n	}\n\n	vec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n	vec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n	vec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n	vec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n	//position is normalized 0..1 coord on the screen\n	vec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n	startCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n	endCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n	gl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n	enableStartMiter = step(dot(currTangent, prevTangent), .5);\n	enableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n	//bevel miter cutoffs\n	if (miterMode == 1.) {\n		if (enableStartMiter == 1.) {\n			vec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n			startCutoff = vec4(aCoord, aCoord);\n			startCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n			startCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			startCutoff += viewport.xyxy;\n			startCutoff += startMiterWidth.xyxy;\n		}\n\n		if (enableEndMiter == 1.) {\n			vec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n			endCutoff = vec4(bCoord, bCoord);\n			endCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n			endCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			endCutoff += viewport.xyxy;\n			endCutoff += endMiterWidth.xyxy;\n		}\n	}\n\n	//round miter cutoffs\n	else if (miterMode == 2.) {\n		if (enableStartMiter == 1.) {\n			vec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n			startCutoff = vec4(aCoord, aCoord);\n			startCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n			startCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			startCutoff += viewport.xyxy;\n			startCutoff += startMiterWidth.xyxy;\n		}\n\n		if (enableEndMiter == 1.) {\n			vec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n			endCutoff = vec4(bCoord, bCoord);\n			endCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n			endCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n			endCutoff += viewport.xyxy;\n			endCutoff += endMiterWidth.xyxy;\n		}\n	}\n}\n"]),
	                  frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform float dashLength, pixelRatio, thickness, opacity, id, miterMode;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n	vec2 diff = b - a;\n	vec2 perp = normalize(vec2(-diff.y, diff.x));\n	return dot(p - a, perp);\n}\n\nvoid main() {\n	float alpha = 1., distToStart, distToEnd;\n	float cutoff = thickness * .5;\n\n	//bevel miter\n	if (miterMode == 1.) {\n		if (enableStartMiter == 1.) {\n			distToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n			if (distToStart < -1.) {\n				discard;\n				return;\n			}\n			alpha *= min(max(distToStart + 1., 0.), 1.);\n		}\n\n		if (enableEndMiter == 1.) {\n			distToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n			if (distToEnd < -1.) {\n				discard;\n				return;\n			}\n			alpha *= min(max(distToEnd + 1., 0.), 1.);\n		}\n	}\n\n	// round miter\n	else if (miterMode == 2.) {\n		if (enableStartMiter == 1.) {\n			distToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n			if (distToStart < 0.) {\n				float radius = length(gl_FragCoord.xy - startCoord);\n\n				if(radius > cutoff + .5) {\n					discard;\n					return;\n				}\n\n				alpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n			}\n		}\n\n		if (enableEndMiter == 1.) {\n			distToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n			if (distToEnd < 0.) {\n				float radius = length(gl_FragCoord.xy - endCoord);\n\n				if(radius > cutoff + .5) {\n					discard;\n					return;\n				}\n\n				alpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n			}\n		}\n	}\n\n	float t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n	float dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n	gl_FragColor = fragColor;\n	gl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
	                  attributes: {
	                    // is line end
	                    lineEnd: {
	                      buffer: offsetBuffer,
	                      divisor: 0,
	                      stride: 8,
	                      offset: 0
	                    },
	                    // is line top
	                    lineTop: {
	                      buffer: offsetBuffer,
	                      divisor: 0,
	                      stride: 8,
	                      offset: 4
	                    },
	                    // left color
	                    aColor: {
	                      buffer: regl.prop("colorBuffer"),
	                      stride: 4,
	                      offset: 0,
	                      divisor: 1
	                    },
	                    // right color
	                    bColor: {
	                      buffer: regl.prop("colorBuffer"),
	                      stride: 4,
	                      offset: 4,
	                      divisor: 1
	                    },
	                    prevCoord: {
	                      buffer: regl.prop("positionBuffer"),
	                      stride: 8,
	                      offset: 0,
	                      divisor: 1
	                    },
	                    aCoord: {
	                      buffer: regl.prop("positionBuffer"),
	                      stride: 8,
	                      offset: 8,
	                      divisor: 1
	                    },
	                    bCoord: {
	                      buffer: regl.prop("positionBuffer"),
	                      stride: 8,
	                      offset: 16,
	                      divisor: 1
	                    },
	                    nextCoord: {
	                      buffer: regl.prop("positionBuffer"),
	                      stride: 8,
	                      offset: 24,
	                      divisor: 1
	                    }
	                  }
	                }, shaderOptions));
	              } catch (e) {
	                drawMiterLine = drawRectLine;
	              }
	              var drawFill = regl({
	                primitive: "triangle",
	                elements: function(ctx, prop) {
	                  return prop.triangles;
	                },
	                offset: 0,
	                vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n	float depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n	vec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n	gl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n	fragColor = color / 255.;\n	fragColor.a *= opacity;\n}\n"]),
	                frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n	gl_FragColor = fragColor;\n}\n"]),
	                uniforms: {
	                  scale: regl.prop("scale"),
	                  color: regl.prop("fill"),
	                  scaleFract: regl.prop("scaleFract"),
	                  translateFract: regl.prop("translateFract"),
	                  translate: regl.prop("translate"),
	                  opacity: regl.prop("opacity"),
	                  pixelRatio: regl.context("pixelRatio"),
	                  id: regl.prop("id"),
	                  viewport: function(ctx, prop) {
	                    return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight];
	                  }
	                },
	                attributes: {
	                  position: {
	                    buffer: regl.prop("positionBuffer"),
	                    stride: 8,
	                    offset: 8
	                  },
	                  positionFract: {
	                    buffer: regl.prop("positionFractBuffer"),
	                    stride: 8,
	                    offset: 8
	                  }
	                },
	                blend: shaderOptions.blend,
	                depth: { enable: false },
	                scissor: shaderOptions.scissor,
	                stencil: shaderOptions.stencil,
	                viewport: shaderOptions.viewport
	              });
	              return {
	                fill: drawFill,
	                rect: drawRectLine,
	                miter: drawMiterLine
	              };
	            };
	            Line2D.defaults = {
	              dashes: null,
	              join: "miter",
	              miterLimit: 1,
	              thickness: 10,
	              cap: "square",
	              color: "black",
	              opacity: 1,
	              overlay: false,
	              viewport: null,
	              range: null,
	              close: false,
	              fill: null
	            };
	            Line2D.prototype.render = function() {
	              var ref2;
	              var args = [], len = arguments.length;
	              while (len--) args[len] = arguments[len];
	              if (args.length) {
	                (ref2 = this).update.apply(ref2, args);
	              }
	              this.draw();
	            };
	            Line2D.prototype.draw = function() {
	              var this$1$1 = this;
	              var args = [], len = arguments.length;
	              while (len--) args[len] = arguments[len];
	              (args.length ? args : this.passes).forEach(function(s, i) {
	                var ref2;
	                if (s && Array.isArray(s)) {
	                  return (ref2 = this$1$1).draw.apply(ref2, s);
	                }
	                if (typeof s === "number") {
	                  s = this$1$1.passes[s];
	                }
	                if (!(s && s.count > 1 && s.opacity)) {
	                  return;
	                }
	                this$1$1.regl._refresh();
	                if (s.fill && s.triangles && s.triangles.length > 2) {
	                  this$1$1.shaders.fill(s);
	                }
	                if (!s.thickness) {
	                  return;
	                }
	                if (s.scale[0] * s.viewport.width > Line2D.precisionThreshold || s.scale[1] * s.viewport.height > Line2D.precisionThreshold) {
	                  this$1$1.shaders.rect(s);
	                } else if (s.join === "rect" || !s.join && (s.thickness <= 2 || s.count >= Line2D.maxPoints)) {
	                  this$1$1.shaders.rect(s);
	                } else {
	                  this$1$1.shaders.miter(s);
	                }
	              });
	              return this;
	            };
	            Line2D.prototype.update = function(options) {
	              var this$1$1 = this;
	              if (!options) {
	                return;
	              }
	              if (options.length != null) {
	                if (typeof options[0] === "number") {
	                  options = [{ positions: options }];
	                }
	              } else if (!Array.isArray(options)) {
	                options = [options];
	              }
	              var ref2 = this;
	              var regl = ref2.regl;
	              var gl2 = ref2.gl;
	              options.forEach(function(o, i2) {
	                var state = this$1$1.passes[i2];
	                if (o === undefined) {
	                  return;
	                }
	                if (o === null) {
	                  this$1$1.passes[i2] = null;
	                  return;
	                }
	                if (typeof o[0] === "number") {
	                  o = { positions: o };
	                }
	                o = pick(o, {
	                  positions: "positions points data coords",
	                  thickness: "thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth",
	                  join: "lineJoin linejoin join type mode",
	                  miterLimit: "miterlimit miterLimit",
	                  dashes: "dash dashes dasharray dash-array dashArray",
	                  color: "color colour stroke colors colours stroke-color strokeColor",
	                  fill: "fill fill-color fillColor",
	                  opacity: "alpha opacity",
	                  overlay: "overlay crease overlap intersect",
	                  close: "closed close closed-path closePath",
	                  range: "range dataBox",
	                  viewport: "viewport viewBox",
	                  hole: "holes hole hollow",
	                  splitNull: "splitNull"
	                });
	                if (!state) {
	                  this$1$1.passes[i2] = state = {
	                    id: i2,
	                    scale: null,
	                    scaleFract: null,
	                    translate: null,
	                    translateFract: null,
	                    count: 0,
	                    hole: [],
	                    depth: 0,
	                    dashLength: 1,
	                    dashTexture: regl.texture({
	                      channels: 1,
	                      data: new Uint8Array([255]),
	                      width: 1,
	                      height: 1,
	                      mag: "linear",
	                      min: "linear"
	                    }),
	                    colorBuffer: regl.buffer({
	                      usage: "dynamic",
	                      type: "uint8",
	                      data: new Uint8Array()
	                    }),
	                    positionBuffer: regl.buffer({
	                      usage: "dynamic",
	                      type: "float",
	                      data: new Uint8Array()
	                    }),
	                    positionFractBuffer: regl.buffer({
	                      usage: "dynamic",
	                      type: "float",
	                      data: new Uint8Array()
	                    })
	                  };
	                  o = extend({}, Line2D.defaults, o);
	                }
	                if (o.thickness != null) {
	                  state.thickness = parseFloat(o.thickness);
	                }
	                if (o.opacity != null) {
	                  state.opacity = parseFloat(o.opacity);
	                }
	                if (o.miterLimit != null) {
	                  state.miterLimit = parseFloat(o.miterLimit);
	                }
	                if (o.overlay != null) {
	                  state.overlay = !!o.overlay;
	                  if (i2 < Line2D.maxLines) {
	                    state.depth = 2 * (Line2D.maxLines - 1 - i2 % Line2D.maxLines) / Line2D.maxLines - 1;
	                  }
	                }
	                if (o.join != null) {
	                  state.join = o.join;
	                }
	                if (o.hole != null) {
	                  state.hole = o.hole;
	                }
	                if (o.fill != null) {
	                  state.fill = !o.fill ? null : rgba(o.fill, "uint8");
	                }
	                if (o.viewport != null) {
	                  state.viewport = parseRect(o.viewport);
	                }
	                if (!state.viewport) {
	                  state.viewport = parseRect([
	                    gl2.drawingBufferWidth,
	                    gl2.drawingBufferHeight
	                  ]);
	                }
	                if (o.close != null) {
	                  state.close = o.close;
	                }
	                if (o.positions === null) {
	                  o.positions = [];
	                }
	                if (o.positions) {
	                  var positions, count;
	                  if (o.positions.x && o.positions.y) {
	                    var xPos = o.positions.x;
	                    var yPos = o.positions.y;
	                    count = state.count = Math.max(
	                      xPos.length,
	                      yPos.length
	                    );
	                    positions = new Float64Array(count * 2);
	                    for (var i$12 = 0; i$12 < count; i$12++) {
	                      positions[i$12 * 2] = xPos[i$12];
	                      positions[i$12 * 2 + 1] = yPos[i$12];
	                    }
	                  } else {
	                    positions = flatten(o.positions, "float64");
	                    count = state.count = Math.floor(positions.length / 2);
	                  }
	                  var bounds = state.bounds = getBounds(positions, 2);
	                  if (state.fill) {
	                    var pos = [];
	                    var ids = {};
	                    var lastId = 0;
	                    for (var i$2 = 0, ptr = 0, l = state.count; i$2 < l; i$2++) {
	                      var x = positions[i$2 * 2];
	                      var y = positions[i$2 * 2 + 1];
	                      if (isNaN(x) || isNaN(y) || x == null || y == null) {
	                        x = positions[lastId * 2];
	                        y = positions[lastId * 2 + 1];
	                        ids[i$2] = lastId;
	                      } else {
	                        lastId = i$2;
	                      }
	                      pos[ptr++] = x;
	                      pos[ptr++] = y;
	                    }
	                    if (o.splitNull) {
	                      if (!(state.count - 1 in ids)) {
	                        ids[state.count] = state.count - 1;
	                      }
	                      var splits = Object.keys(ids).map(Number).sort(function(a, b) {
	                        return a - b;
	                      });
	                      var split_triangles = [];
	                      var base = 0;
	                      var hole_base = state.hole != null ? state.hole[0] : null;
	                      if (hole_base != null) {
	                        var last_id = findIndex(splits, function(e) {
	                          return e >= hole_base;
	                        });
	                        splits = splits.slice(0, last_id);
	                        splits.push(hole_base);
	                      }
	                      var loop = function(i3) {
	                        var seg_pos = pos.slice(base * 2, splits[i3] * 2).concat(
	                          hole_base ? pos.slice(hole_base * 2) : []
	                        );
	                        var hole = (state.hole || []).map(function(e) {
	                          return e - hole_base + (splits[i3] - base);
	                        });
	                        var triangles = triangulate(seg_pos, hole);
	                        triangles = triangles.map(
	                          function(e) {
	                            return e + base + (e + base < splits[i3] ? 0 : hole_base - splits[i3]);
	                          }
	                        );
	                        split_triangles.push.apply(split_triangles, triangles);
	                        base = splits[i3] + 1;
	                      };
	                      for (var i$3 = 0; i$3 < splits.length; i$3++)
	                        loop(i$3);
	                      for (var i$4 = 0, l$1 = split_triangles.length; i$4 < l$1; i$4++) {
	                        if (ids[split_triangles[i$4]] != null) {
	                          split_triangles[i$4] = ids[split_triangles[i$4]];
	                        }
	                      }
	                      state.triangles = split_triangles;
	                    } else {
	                      var triangles$1 = triangulate(pos, state.hole || []);
	                      for (var i$5 = 0, l$2 = triangles$1.length; i$5 < l$2; i$5++) {
	                        if (ids[triangles$1[i$5]] != null) {
	                          triangles$1[i$5] = ids[triangles$1[i$5]];
	                        }
	                      }
	                      state.triangles = triangles$1;
	                    }
	                  }
	                  var npos = new Float64Array(positions);
	                  normalize(npos, 2, bounds);
	                  var positionData = new Float64Array(count * 2 + 6);
	                  if (state.close) {
	                    if (positions[0] === positions[count * 2 - 2] && positions[1] === positions[count * 2 - 1]) {
	                      positionData[0] = npos[count * 2 - 4];
	                      positionData[1] = npos[count * 2 - 3];
	                    } else {
	                      positionData[0] = npos[count * 2 - 2];
	                      positionData[1] = npos[count * 2 - 1];
	                    }
	                  } else {
	                    positionData[0] = npos[0];
	                    positionData[1] = npos[1];
	                  }
	                  positionData.set(npos, 2);
	                  if (state.close) {
	                    if (positions[0] === positions[count * 2 - 2] && positions[1] === positions[count * 2 - 1]) {
	                      positionData[count * 2 + 2] = npos[2];
	                      positionData[count * 2 + 3] = npos[3];
	                      state.count -= 1;
	                    } else {
	                      positionData[count * 2 + 2] = npos[0];
	                      positionData[count * 2 + 3] = npos[1];
	                      positionData[count * 2 + 4] = npos[2];
	                      positionData[count * 2 + 5] = npos[3];
	                    }
	                  } else {
	                    positionData[count * 2 + 2] = npos[count * 2 - 2];
	                    positionData[count * 2 + 3] = npos[count * 2 - 1];
	                    positionData[count * 2 + 4] = npos[count * 2 - 2];
	                    positionData[count * 2 + 5] = npos[count * 2 - 1];
	                  }
	                  var float_data = float32(positionData);
	                  state.positionBuffer(float_data);
	                  var frac_data = fract32(positionData, float_data);
	                  state.positionFractBuffer(frac_data);
	                }
	                if (o.range) {
	                  state.range = o.range;
	                } else if (!state.range) {
	                  state.range = state.bounds;
	                }
	                if ((o.range || o.positions) && state.count) {
	                  var bounds$1 = state.bounds;
	                  var boundsW = bounds$1[2] - bounds$1[0], boundsH = bounds$1[3] - bounds$1[1];
	                  var rangeW = state.range[2] - state.range[0], rangeH = state.range[3] - state.range[1];
	                  state.scale = [
	                    boundsW / rangeW,
	                    boundsH / rangeH
	                  ];
	                  state.translate = [
	                    -state.range[0] / rangeW + bounds$1[0] / rangeW || 0,
	                    -state.range[1] / rangeH + bounds$1[1] / rangeH || 0
	                  ];
	                  state.scaleFract = fract32(state.scale);
	                  state.translateFract = fract32(state.translate);
	                }
	                if (o.dashes) {
	                  var dashLength = 0, dashData;
	                  if (!o.dashes || o.dashes.length < 2) {
	                    dashLength = 1;
	                    dashData = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255]);
	                  } else {
	                    dashLength = 0;
	                    for (var i$6 = 0; i$6 < o.dashes.length; ++i$6) {
	                      dashLength += o.dashes[i$6];
	                    }
	                    dashData = new Uint8Array(dashLength * Line2D.dashMult);
	                    var ptr$1 = 0;
	                    var fillColor = 255;
	                    for (var k = 0; k < 2; k++) {
	                      for (var i$7 = 0; i$7 < o.dashes.length; ++i$7) {
	                        for (var j = 0, l$3 = o.dashes[i$7] * Line2D.dashMult * 0.5; j < l$3; ++j) {
	                          dashData[ptr$1++] = fillColor;
	                        }
	                        fillColor ^= 255;
	                      }
	                    }
	                  }
	                  state.dashLength = dashLength;
	                  state.dashTexture({
	                    channels: 1,
	                    data: dashData,
	                    width: dashData.length,
	                    height: 1,
	                    mag: "linear",
	                    min: "linear"
	                  }, 0, 0);
	                }
	                if (o.color) {
	                  var count$1 = state.count;
	                  var colors = o.color;
	                  if (!colors) {
	                    colors = "transparent";
	                  }
	                  var colorData = new Uint8Array(count$1 * 4 + 4);
	                  if (!Array.isArray(colors) || typeof colors[0] === "number") {
	                    var c = rgba(colors, "uint8");
	                    for (var i$8 = 0; i$8 < count$1 + 1; i$8++) {
	                      colorData.set(c, i$8 * 4);
	                    }
	                  } else {
	                    for (var i$9 = 0; i$9 < count$1; i$9++) {
	                      var c$1 = rgba(colors[i$9], "uint8");
	                      colorData.set(c$1, i$9 * 4);
	                    }
	                    colorData.set(rgba(colors[0], "uint8"), count$1 * 4);
	                  }
	                  state.colorBuffer({
	                    usage: "dynamic",
	                    type: "uint8",
	                    data: colorData
	                  });
	                }
	              });
	              if (options.length < this.passes.length) {
	                for (var i = options.length; i < this.passes.length; i++) {
	                  var pass = this.passes[i];
	                  if (!pass) {
	                    continue;
	                  }
	                  pass.colorBuffer.destroy();
	                  pass.positionBuffer.destroy();
	                  pass.dashTexture.destroy();
	                }
	                this.passes.length = options.length;
	              }
	              var passes = [];
	              for (var i$1 = 0; i$1 < this.passes.length; i$1++) {
	                if (this.passes[i$1] !== null) {
	                  passes.push(this.passes[i$1]);
	                }
	              }
	              this.passes = passes;
	              return this;
	            };
	            Line2D.prototype.destroy = function() {
	              this.passes.forEach(function(pass) {
	                pass.colorBuffer.destroy();
	                pass.positionBuffer.destroy();
	                pass.dashTexture.destroy();
	              });
	              this.passes.length = 0;
	              return this;
	            };
	          }
	        ),
	        /***/
	        11870: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            function _iterableToArrayLimit(arr, i) {
	              var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
	              if (null != _i) {
	                var _s, _e, _x, _r, _arr = [], _n = true, _d = false;
	                try {
	                  if (_x = (_i = _i.call(arr)).next, 0 === i) ; else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = true) ;
	                } catch (err) {
	                  _d = true, _e = err;
	                } finally {
	                  try {
	                    if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
	                  } finally {
	                    if (_d) throw _e;
	                  }
	                }
	                return _arr;
	              }
	            }
	            function _slicedToArray(arr, i) {
	              return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	            }
	            function _toConsumableArray(arr) {
	              return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	            }
	            function _arrayWithoutHoles(arr) {
	              if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	            }
	            function _arrayWithHoles(arr) {
	              if (Array.isArray(arr)) return arr;
	            }
	            function _iterableToArray(iter) {
	              if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	            }
	            function _unsupportedIterableToArray(o, minLen) {
	              if (!o) return;
	              if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	              var n = Object.prototype.toString.call(o).slice(8, -1);
	              if (n === "Object" && o.constructor) n = o.constructor.name;
	              if (n === "Map" || n === "Set") return Array.from(o);
	              if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	            }
	            function _arrayLikeToArray(arr, len) {
	              if (len == null || len > arr.length) len = arr.length;
	              for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	              return arr2;
	            }
	            function _nonIterableSpread() {
	              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	            }
	            function _nonIterableRest() {
	              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	            }
	            var rgba = __webpack_require__2(25075);
	            var getBounds = __webpack_require__2(21527);
	            var colorId = __webpack_require__2(6475);
	            var cluster = __webpack_require__2(88294);
	            var extend = __webpack_require__2(56131);
	            var glslify = __webpack_require__2(56068);
	            var pick = __webpack_require__2(71299);
	            var updateDiff = __webpack_require__2(93447);
	            var flatten = __webpack_require__2(30120);
	            var ie = __webpack_require__2(62683);
	            var f32 = __webpack_require__2(57060);
	            var parseRect = __webpack_require__2(18863);
	            var scatter = Scatter;
	            function Scatter(regl, options) {
	              var _this = this;
	              if (!(this instanceof Scatter)) return new Scatter(regl, options);
	              if (typeof regl === "function") {
	                if (!options) options = {};
	                options.regl = regl;
	              } else {
	                options = regl;
	                regl = null;
	              }
	              if (options && options.length) options.positions = options;
	              regl = options.regl;
	              var gl2 = regl._gl, paletteTexture, palette = [], paletteIds = {}, groups = [], markerTextures = [null], markerCache = [null];
	              var maxColors = 255, maxSize = 100;
	              this.tooManyColors = ie;
	              paletteTexture = regl.texture({
	                data: new Uint8Array(maxColors * 4),
	                width: maxColors,
	                height: 1,
	                type: "uint8",
	                format: "rgba",
	                wrapS: "clamp",
	                wrapT: "clamp",
	                mag: "nearest",
	                min: "nearest"
	              });
	              extend(this, {
	                regl,
	                gl: gl2,
	                groups,
	                markerCache,
	                markerTextures,
	                palette,
	                paletteIds,
	                paletteTexture,
	                maxColors,
	                maxSize,
	                canvas: gl2.canvas
	              });
	              this.update(options);
	              var shaderOptions = {
	                uniforms: {
	                  constPointSize: !!options.constPointSize,
	                  opacity: regl.prop("opacity"),
	                  paletteSize: function paletteSize(ctx, prop) {
	                    return [_this.tooManyColors ? 0 : maxColors, paletteTexture.height];
	                  },
	                  pixelRatio: regl.context("pixelRatio"),
	                  scale: regl.prop("scale"),
	                  scaleFract: regl.prop("scaleFract"),
	                  translate: regl.prop("translate"),
	                  translateFract: regl.prop("translateFract"),
	                  markerTexture: regl.prop("markerTexture"),
	                  paletteTexture
	                },
	                attributes: {
	                  // FIXME: optimize these parts
	                  x: function x(ctx, prop) {
	                    return prop.xAttr || {
	                      buffer: prop.positionBuffer,
	                      stride: 8,
	                      offset: 0
	                    };
	                  },
	                  y: function y(ctx, prop) {
	                    return prop.yAttr || {
	                      buffer: prop.positionBuffer,
	                      stride: 8,
	                      offset: 4
	                    };
	                  },
	                  xFract: function xFract(ctx, prop) {
	                    return prop.xAttr ? {
	                      constant: [0, 0]
	                    } : {
	                      buffer: prop.positionFractBuffer,
	                      stride: 8,
	                      offset: 0
	                    };
	                  },
	                  yFract: function yFract(ctx, prop) {
	                    return prop.yAttr ? {
	                      constant: [0, 0]
	                    } : {
	                      buffer: prop.positionFractBuffer,
	                      stride: 8,
	                      offset: 4
	                    };
	                  },
	                  size: function size(ctx, prop) {
	                    return prop.size.length ? {
	                      buffer: prop.sizeBuffer,
	                      stride: 2,
	                      offset: 0
	                    } : {
	                      constant: [Math.round(prop.size * 255 / _this.maxSize)]
	                    };
	                  },
	                  borderSize: function borderSize(ctx, prop) {
	                    return prop.borderSize.length ? {
	                      buffer: prop.sizeBuffer,
	                      stride: 2,
	                      offset: 1
	                    } : {
	                      constant: [Math.round(prop.borderSize * 255 / _this.maxSize)]
	                    };
	                  },
	                  colorId: function colorId2(ctx, prop) {
	                    return prop.color.length ? {
	                      buffer: prop.colorBuffer,
	                      stride: _this.tooManyColors ? 8 : 4,
	                      offset: 0
	                    } : {
	                      constant: _this.tooManyColors ? palette.slice(prop.color * 4, prop.color * 4 + 4) : [prop.color]
	                    };
	                  },
	                  borderColorId: function borderColorId(ctx, prop) {
	                    return prop.borderColor.length ? {
	                      buffer: prop.colorBuffer,
	                      stride: _this.tooManyColors ? 8 : 4,
	                      offset: _this.tooManyColors ? 4 : 2
	                    } : {
	                      constant: _this.tooManyColors ? palette.slice(prop.borderColor * 4, prop.borderColor * 4 + 4) : [prop.borderColor]
	                    };
	                  },
	                  isActive: function isActive(ctx, prop) {
	                    return prop.activation === true ? {
	                      constant: [1]
	                    } : prop.activation ? prop.activation : {
	                      constant: [0]
	                    };
	                  }
	                },
	                blend: {
	                  enable: true,
	                  color: [0, 0, 0, 1],
	                  // photoshop blending
	                  func: {
	                    srcRGB: "src alpha",
	                    dstRGB: "one minus src alpha",
	                    srcAlpha: "one minus dst alpha",
	                    dstAlpha: "one"
	                  }
	                },
	                scissor: {
	                  enable: true,
	                  box: regl.prop("viewport")
	                },
	                viewport: regl.prop("viewport"),
	                stencil: {
	                  enable: false
	                },
	                depth: {
	                  enable: false
	                },
	                elements: regl.prop("elements"),
	                count: regl.prop("count"),
	                offset: regl.prop("offset"),
	                primitive: "points"
	              };
	              var markerOptions = extend({}, shaderOptions);
	              markerOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform float opacity;\nuniform sampler2D markerTexture;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(markerTexture, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"]);
	              markerOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pointSizeScale;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}"]);
	              this.drawMarker = regl(markerOptions);
	              var circleOptions = extend({}, shaderOptions);
	              circleOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nuniform float opacity;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n	float t;\n	t = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n	return t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n	float radius, alpha = 1.0, delta = fragWidth;\n\n	radius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n	if (radius > 1.0 + delta) {\n		discard;\n	}\n\n	alpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n	float borderRadius = fragBorderRadius;\n	float ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n	vec4 color = mix(fragColor, fragBorderColor, ratio);\n	color.a *= alpha * opacity;\n	gl_FragColor = color;\n}\n"]);
	              circleOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 paletteSize, scale, scaleFract, translate, translateFract;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pointSizeScale;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"]);
	              if (ie) {
	                circleOptions.frag = circleOptions.frag.replace("smoothstep", "smoothStep");
	                markerOptions.frag = markerOptions.frag.replace("smoothstep", "smoothStep");
	              }
	              this.drawCircle = regl(circleOptions);
	            }
	            Scatter.defaults = {
	              color: "black",
	              borderColor: "transparent",
	              borderSize: 0,
	              size: 12,
	              opacity: 1,
	              marker: undefined,
	              viewport: null,
	              range: null,
	              pixelSize: null,
	              count: 0,
	              offset: 0,
	              bounds: null,
	              positions: [],
	              snap: 1e4
	            };
	            Scatter.prototype.render = function() {
	              if (arguments.length) {
	                this.update.apply(this, arguments);
	              }
	              this.draw();
	              return this;
	            };
	            Scatter.prototype.draw = function() {
	              var _this2 = this;
	              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	              }
	              var groups = this.groups;
	              if (args.length === 1 && Array.isArray(args[0]) && (args[0][0] === null || Array.isArray(args[0][0]))) {
	                args = args[0];
	              }
	              this.regl._refresh();
	              if (args.length) {
	                for (var i = 0; i < args.length; i++) {
	                  this.drawItem(i, args[i]);
	                }
	              } else {
	                groups.forEach(function(group, i2) {
	                  _this2.drawItem(i2);
	                });
	              }
	              return this;
	            };
	            Scatter.prototype.drawItem = function(id, els) {
	              var groups = this.groups;
	              var group = groups[id];
	              if (typeof els === "number") {
	                id = els;
	                group = groups[els];
	                els = null;
	              }
	              if (!(group && group.count && group.opacity)) return;
	              if (group.activation[0]) {
	                this.drawCircle(this.getMarkerDrawOptions(0, group, els));
	              }
	              var batch = [];
	              for (var i = 1; i < group.activation.length; i++) {
	                if (!group.activation[i] || group.activation[i] !== true && !group.activation[i].data.length) continue;
	                batch.push.apply(batch, _toConsumableArray(this.getMarkerDrawOptions(i, group, els)));
	              }
	              if (batch.length) {
	                this.drawMarker(batch);
	              }
	            };
	            Scatter.prototype.getMarkerDrawOptions = function(markerId, group, elements) {
	              var range2 = group.range, tree = group.tree, viewport = group.viewport, activation = group.activation, selectionBuffer = group.selectionBuffer, count = group.count;
	              this.regl;
	              if (!tree) {
	                if (elements) {
	                  return [extend({}, group, {
	                    markerTexture: this.markerTextures[markerId],
	                    activation: activation[markerId],
	                    count: elements.length,
	                    elements,
	                    offset: 0
	                  })];
	                }
	                return [extend({}, group, {
	                  markerTexture: this.markerTextures[markerId],
	                  activation: activation[markerId],
	                  offset: 0
	                })];
	              }
	              var batch = [];
	              var lod = tree.range(range2, {
	                lod: true,
	                px: [(range2[2] - range2[0]) / viewport.width, (range2[3] - range2[1]) / viewport.height]
	              });
	              if (elements) {
	                var markerActivation = activation[markerId];
	                var mask = markerActivation.data;
	                var data = new Uint8Array(count);
	                for (var i = 0; i < elements.length; i++) {
	                  var id = elements[i];
	                  data[id] = mask ? mask[id] : 1;
	                }
	                selectionBuffer.subdata(data);
	              }
	              for (var l = lod.length; l--; ) {
	                var _lod$l = _slicedToArray(lod[l], 2), from = _lod$l[0], to = _lod$l[1];
	                batch.push(extend({}, group, {
	                  markerTexture: this.markerTextures[markerId],
	                  activation: elements ? selectionBuffer : activation[markerId],
	                  offset: from,
	                  count: to - from
	                }));
	              }
	              return batch;
	            };
	            Scatter.prototype.update = function() {
	              var _this3 = this;
	              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                args[_key2] = arguments[_key2];
	              }
	              if (!args.length) return;
	              if (args.length === 1 && Array.isArray(args[0])) args = args[0];
	              var groups = this.groups, gl2 = this.gl, regl = this.regl, maxSize = this.maxSize, maxColors = this.maxColors, palette = this.palette;
	              this.groups = groups = args.map(function(options, i) {
	                var group = groups[i];
	                if (options === undefined) return group;
	                if (options === null) options = {
	                  positions: null
	                };
	                else if (typeof options === "function") options = {
	                  ondraw: options
	                };
	                else if (typeof options[0] === "number") options = {
	                  positions: options
	                };
	                options = pick(options, {
	                  positions: "positions data points",
	                  snap: "snap cluster lod tree",
	                  size: "sizes size radius",
	                  borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
	                  color: "colors color fill fill-color fillColor",
	                  borderColor: "borderColors borderColor stroke stroke-color strokeColor",
	                  marker: "markers marker shape",
	                  range: "range dataBox databox",
	                  viewport: "viewport viewPort viewBox viewbox",
	                  opacity: "opacity alpha transparency",
	                  bounds: "bound bounds boundaries limits",
	                  tooManyColors: "tooManyColors palette paletteMode optimizePalette enablePalette"
	                });
	                if (options.positions === null) options.positions = [];
	                if (options.tooManyColors != null) _this3.tooManyColors = options.tooManyColors;
	                if (!group) {
	                  groups[i] = group = {
	                    id: i,
	                    scale: null,
	                    translate: null,
	                    scaleFract: null,
	                    translateFract: null,
	                    // buffers for active markers
	                    activation: [],
	                    // buffer for filtered markers
	                    selectionBuffer: regl.buffer({
	                      data: new Uint8Array(0),
	                      usage: "stream",
	                      type: "uint8"
	                    }),
	                    // buffers with data: it is faster to switch them per-pass
	                    // than provide one congregate buffer
	                    sizeBuffer: regl.buffer({
	                      data: new Uint8Array(0),
	                      usage: "dynamic",
	                      type: "uint8"
	                    }),
	                    colorBuffer: regl.buffer({
	                      data: new Uint8Array(0),
	                      usage: "dynamic",
	                      type: "uint8"
	                    }),
	                    positionBuffer: regl.buffer({
	                      data: new Uint8Array(0),
	                      usage: "dynamic",
	                      type: "float"
	                    }),
	                    positionFractBuffer: regl.buffer({
	                      data: new Uint8Array(0),
	                      usage: "dynamic",
	                      type: "float"
	                    })
	                  };
	                  options = extend({}, Scatter.defaults, options);
	                }
	                if (options.positions && !("marker" in options)) {
	                  options.marker = group.marker;
	                  delete group.marker;
	                }
	                if (options.marker && !("positions" in options)) {
	                  options.positions = group.positions;
	                  delete group.positions;
	                }
	                var hasSize = 0, hasColor = 0;
	                updateDiff(group, options, [{
	                  snap: true,
	                  size: function size2(s, group2) {
	                    if (s == null) s = Scatter.defaults.size;
	                    hasSize += s && s.length ? 1 : 0;
	                    return s;
	                  },
	                  borderSize: function borderSize2(s, group2) {
	                    if (s == null) s = Scatter.defaults.borderSize;
	                    hasSize += s && s.length ? 1 : 0;
	                    return s;
	                  },
	                  opacity: parseFloat,
	                  // add colors to palette, save references
	                  color: function color2(c, group2) {
	                    if (c == null) c = Scatter.defaults.color;
	                    c = _this3.updateColor(c);
	                    hasColor++;
	                    return c;
	                  },
	                  borderColor: function borderColor2(c, group2) {
	                    if (c == null) c = Scatter.defaults.borderColor;
	                    c = _this3.updateColor(c);
	                    hasColor++;
	                    return c;
	                  },
	                  bounds: function bounds(_bounds, group2, options2) {
	                    if (!("range" in options2)) options2.range = null;
	                    return _bounds;
	                  },
	                  positions: function positions(_positions, group2, options2) {
	                    var snap = group2.snap;
	                    var positionBuffer = group2.positionBuffer, positionFractBuffer = group2.positionFractBuffer, selectionBuffer = group2.selectionBuffer;
	                    if (_positions.x || _positions.y) {
	                      if (_positions.x.length) {
	                        group2.xAttr = {
	                          buffer: regl.buffer(_positions.x),
	                          offset: 0,
	                          stride: 4,
	                          count: _positions.x.length
	                        };
	                      } else {
	                        group2.xAttr = {
	                          buffer: _positions.x.buffer,
	                          offset: _positions.x.offset * 4 || 0,
	                          stride: (_positions.x.stride || 1) * 4,
	                          count: _positions.x.count
	                        };
	                      }
	                      if (_positions.y.length) {
	                        group2.yAttr = {
	                          buffer: regl.buffer(_positions.y),
	                          offset: 0,
	                          stride: 4,
	                          count: _positions.y.length
	                        };
	                      } else {
	                        group2.yAttr = {
	                          buffer: _positions.y.buffer,
	                          offset: _positions.y.offset * 4 || 0,
	                          stride: (_positions.y.stride || 1) * 4,
	                          count: _positions.y.count
	                        };
	                      }
	                      group2.count = Math.max(group2.xAttr.count, group2.yAttr.count);
	                      return _positions;
	                    }
	                    _positions = flatten(_positions, "float64");
	                    var count2 = group2.count = Math.floor(_positions.length / 2);
	                    var bounds = group2.bounds = count2 ? getBounds(_positions, 2) : null;
	                    if (!options2.range && !group2.range) {
	                      delete group2.range;
	                      options2.range = bounds;
	                    }
	                    if (!options2.marker && !group2.marker) {
	                      delete group2.marker;
	                      options2.marker = null;
	                    }
	                    if (snap && (snap === true || count2 > snap)) {
	                      group2.tree = cluster(_positions, {
	                        bounds
	                      });
	                    } else if (snap && snap.length) {
	                      group2.tree = snap;
	                    }
	                    if (group2.tree) {
	                      var opts = {
	                        primitive: "points",
	                        usage: "static",
	                        data: group2.tree,
	                        type: "uint32"
	                      };
	                      if (group2.elements) group2.elements(opts);
	                      else group2.elements = regl.elements(opts);
	                    }
	                    var float_data = f32.float32(_positions);
	                    positionBuffer({
	                      data: float_data,
	                      usage: "dynamic"
	                    });
	                    var frac_data = f32.fract32(_positions, float_data);
	                    positionFractBuffer({
	                      data: frac_data,
	                      usage: "dynamic"
	                    });
	                    selectionBuffer({
	                      data: new Uint8Array(count2),
	                      type: "uint8",
	                      usage: "stream"
	                    });
	                    return _positions;
	                  }
	                }, {
	                  // create marker ids corresponding to known marker textures
	                  marker: function marker(markers, group2, options2) {
	                    var activation = group2.activation;
	                    activation.forEach(function(buffer) {
	                      return buffer && buffer.destroy && buffer.destroy();
	                    });
	                    activation.length = 0;
	                    if (!markers || typeof markers[0] === "number") {
	                      var id = _this3.addMarker(markers);
	                      activation[id] = true;
	                    } else {
	                      var markerMasks = [];
	                      for (var _i = 0, l = Math.min(markers.length, group2.count); _i < l; _i++) {
	                        var _id = _this3.addMarker(markers[_i]);
	                        if (!markerMasks[_id]) markerMasks[_id] = new Uint8Array(group2.count);
	                        markerMasks[_id][_i] = 1;
	                      }
	                      for (var _id2 = 0; _id2 < markerMasks.length; _id2++) {
	                        if (!markerMasks[_id2]) continue;
	                        var opts = {
	                          data: markerMasks[_id2],
	                          type: "uint8",
	                          usage: "static"
	                        };
	                        if (!activation[_id2]) {
	                          activation[_id2] = regl.buffer(opts);
	                        } else {
	                          activation[_id2](opts);
	                        }
	                        activation[_id2].data = markerMasks[_id2];
	                      }
	                    }
	                    return markers;
	                  },
	                  range: function range2(_range, group2, options2) {
	                    var bounds = group2.bounds;
	                    if (!bounds) return;
	                    if (!_range) _range = bounds;
	                    group2.scale = [1 / (_range[2] - _range[0]), 1 / (_range[3] - _range[1])];
	                    group2.translate = [-_range[0], -_range[1]];
	                    group2.scaleFract = f32.fract(group2.scale);
	                    group2.translateFract = f32.fract(group2.translate);
	                    return _range;
	                  },
	                  viewport: function viewport(vp) {
	                    var rect = parseRect(vp || [gl2.drawingBufferWidth, gl2.drawingBufferHeight]);
	                    return rect;
	                  }
	                }]);
	                if (hasSize) {
	                  var _group = group, count = _group.count, size = _group.size, borderSize = _group.borderSize, sizeBuffer = _group.sizeBuffer;
	                  var sizes = new Uint8Array(count * 2);
	                  if (size.length || borderSize.length) {
	                    for (var _i2 = 0; _i2 < count; _i2++) {
	                      sizes[_i2 * 2] = Math.round((size[_i2] == null ? size : size[_i2]) * 255 / maxSize);
	                      sizes[_i2 * 2 + 1] = Math.round((borderSize[_i2] == null ? borderSize : borderSize[_i2]) * 255 / maxSize);
	                    }
	                  }
	                  sizeBuffer({
	                    data: sizes,
	                    usage: "dynamic"
	                  });
	                }
	                if (hasColor) {
	                  var _group2 = group, _count = _group2.count, color = _group2.color, borderColor = _group2.borderColor, colorBuffer = _group2.colorBuffer;
	                  var colors;
	                  if (_this3.tooManyColors) {
	                    if (color.length || borderColor.length) {
	                      colors = new Uint8Array(_count * 8);
	                      for (var _i3 = 0; _i3 < _count; _i3++) {
	                        var _colorId = color[_i3];
	                        colors[_i3 * 8] = palette[_colorId * 4];
	                        colors[_i3 * 8 + 1] = palette[_colorId * 4 + 1];
	                        colors[_i3 * 8 + 2] = palette[_colorId * 4 + 2];
	                        colors[_i3 * 8 + 3] = palette[_colorId * 4 + 3];
	                        var borderColorId = borderColor[_i3];
	                        colors[_i3 * 8 + 4] = palette[borderColorId * 4];
	                        colors[_i3 * 8 + 5] = palette[borderColorId * 4 + 1];
	                        colors[_i3 * 8 + 6] = palette[borderColorId * 4 + 2];
	                        colors[_i3 * 8 + 7] = palette[borderColorId * 4 + 3];
	                      }
	                    }
	                  } else {
	                    if (color.length || borderColor.length) {
	                      colors = new Uint8Array(_count * 4 + 2);
	                      for (var _i4 = 0; _i4 < _count; _i4++) {
	                        if (color[_i4] != null) {
	                          colors[_i4 * 4] = color[_i4] % maxColors;
	                          colors[_i4 * 4 + 1] = Math.floor(color[_i4] / maxColors);
	                        }
	                        if (borderColor[_i4] != null) {
	                          colors[_i4 * 4 + 2] = borderColor[_i4] % maxColors;
	                          colors[_i4 * 4 + 3] = Math.floor(borderColor[_i4] / maxColors);
	                        }
	                      }
	                    }
	                  }
	                  colorBuffer({
	                    data: colors || new Uint8Array(0),
	                    type: "uint8",
	                    usage: "dynamic"
	                  });
	                }
	                return group;
	              });
	            };
	            Scatter.prototype.addMarker = function(sdf) {
	              var markerTextures = this.markerTextures, regl = this.regl, markerCache = this.markerCache;
	              var pos = sdf == null ? 0 : markerCache.indexOf(sdf);
	              if (pos >= 0) return pos;
	              var distArr;
	              if (sdf instanceof Uint8Array || sdf instanceof Uint8ClampedArray) {
	                distArr = sdf;
	              } else {
	                distArr = new Uint8Array(sdf.length);
	                for (var i = 0, l = sdf.length; i < l; i++) {
	                  distArr[i] = sdf[i] * 255;
	                }
	              }
	              var radius = Math.floor(Math.sqrt(distArr.length));
	              pos = markerTextures.length;
	              markerCache.push(sdf);
	              markerTextures.push(regl.texture({
	                channels: 1,
	                data: distArr,
	                radius,
	                mag: "linear",
	                min: "linear"
	              }));
	              return pos;
	            };
	            Scatter.prototype.updateColor = function(colors) {
	              var paletteIds = this.paletteIds, palette = this.palette, maxColors = this.maxColors;
	              if (!Array.isArray(colors)) {
	                colors = [colors];
	              }
	              var idx = [];
	              if (typeof colors[0] === "number") {
	                var grouped = [];
	                if (Array.isArray(colors)) {
	                  for (var i = 0; i < colors.length; i += 4) {
	                    grouped.push(colors.slice(i, i + 4));
	                  }
	                } else {
	                  for (var _i5 = 0; _i5 < colors.length; _i5 += 4) {
	                    grouped.push(colors.subarray(_i5, _i5 + 4));
	                  }
	                }
	                colors = grouped;
	              }
	              for (var _i6 = 0; _i6 < colors.length; _i6++) {
	                var color = colors[_i6];
	                color = rgba(color, "uint8");
	                var id = colorId(color, false);
	                if (paletteIds[id] == null) {
	                  var pos = palette.length;
	                  paletteIds[id] = Math.floor(pos / 4);
	                  palette[pos] = color[0];
	                  palette[pos + 1] = color[1];
	                  palette[pos + 2] = color[2];
	                  palette[pos + 3] = color[3];
	                }
	                idx[_i6] = paletteIds[id];
	              }
	              if (!this.tooManyColors && palette.length > maxColors * 4) this.tooManyColors = true;
	              this.updatePalette(palette);
	              return idx.length === 1 ? idx[0] : idx;
	            };
	            Scatter.prototype.updatePalette = function(palette) {
	              if (this.tooManyColors) return;
	              var maxColors = this.maxColors, paletteTexture = this.paletteTexture;
	              var requiredHeight = Math.ceil(palette.length * 0.25 / maxColors);
	              if (requiredHeight > 1) {
	                palette = palette.slice();
	                for (var i = palette.length * 0.25 % maxColors; i < requiredHeight * maxColors; i++) {
	                  palette.push(0, 0, 0, 0);
	                }
	              }
	              if (paletteTexture.height < requiredHeight) {
	                paletteTexture.resize(maxColors, requiredHeight);
	              }
	              paletteTexture.subimage({
	                width: Math.min(palette.length * 0.25, maxColors),
	                height: requiredHeight,
	                data: palette
	              }, 0, 0);
	            };
	            Scatter.prototype.destroy = function() {
	              this.groups.forEach(function(group) {
	                group.sizeBuffer.destroy();
	                group.positionBuffer.destroy();
	                group.positionFractBuffer.destroy();
	                group.colorBuffer.destroy();
	                group.activation.forEach(function(b) {
	                  return b && b.destroy && b.destroy();
	                });
	                group.selectionBuffer.destroy();
	                if (group.elements) group.elements.destroy();
	              });
	              this.groups.length = 0;
	              this.paletteTexture.destroy();
	              this.markerTextures.forEach(function(txt) {
	                return txt && txt.destroy && txt.destroy();
	              });
	              return this;
	            };
	            var extend$1 = __webpack_require__2(56131);
	            var reglScatter2d = function reglScatter2d2(regl, options) {
	              var scatter$1 = new scatter(regl, options);
	              var render = scatter$1.render.bind(scatter$1);
	              extend$1(render, {
	                render,
	                update: scatter$1.update.bind(scatter$1),
	                draw: scatter$1.draw.bind(scatter$1),
	                destroy: scatter$1.destroy.bind(scatter$1),
	                regl: scatter$1.regl,
	                gl: scatter$1.gl,
	                canvas: scatter$1.gl.canvas,
	                groups: scatter$1.groups,
	                markers: scatter$1.markerCache,
	                palette: scatter$1.palette
	              });
	              return render;
	            };
	            module2.exports = reglScatter2d;
	          }
	        ),
	        /***/
	        60487: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var createScatter = __webpack_require__2(11870);
	            var pick = __webpack_require__2(71299);
	            var getBounds = __webpack_require__2(21527);
	            var raf = __webpack_require__2(5877);
	            var arrRange = __webpack_require__2(57471);
	            var rect = __webpack_require__2(18863);
	            var flatten = __webpack_require__2(30120);
	            module2.exports = SPLOM;
	            function SPLOM(regl, options) {
	              if (!(this instanceof SPLOM)) {
	                return new SPLOM(regl);
	              }
	              this.traces = [];
	              this.passes = {};
	              this.regl = regl;
	              this.scatter = createScatter(regl);
	              this.canvas = this.scatter.canvas;
	            }
	            SPLOM.prototype.render = function() {
	              var this$1$1 = this;
	              var ref;
	              var args = [], len = arguments.length;
	              while (len--) args[len] = arguments[len];
	              if (args.length) {
	                (ref = this).update.apply(ref, args);
	              }
	              if (this.regl.attributes.preserveDrawingBuffer) {
	                return this.draw();
	              }
	              if (this.dirty) {
	                if (this.planned == null) {
	                  this.planned = raf(function() {
	                    this$1$1.draw();
	                    this$1$1.dirty = true;
	                    this$1$1.planned = null;
	                  });
	                }
	              } else {
	                this.draw();
	                this.dirty = true;
	                raf(function() {
	                  this$1$1.dirty = false;
	                });
	              }
	              return this;
	            };
	            SPLOM.prototype.update = function() {
	              var ref;
	              var args = [], len = arguments.length;
	              while (len--) args[len] = arguments[len];
	              if (!args.length) {
	                return;
	              }
	              for (var i = 0; i < args.length; i++) {
	                this.updateItem(i, args[i]);
	              }
	              this.traces = this.traces.filter(Boolean);
	              var passes = [];
	              var offset = 0;
	              for (var i$1 = 0; i$1 < this.traces.length; i$1++) {
	                var trace = this.traces[i$1];
	                var tracePasses = this.traces[i$1].passes;
	                for (var j = 0; j < tracePasses.length; j++) {
	                  passes.push(this.passes[tracePasses[j]]);
	                }
	                trace.passOffset = offset;
	                offset += trace.passes.length;
	              }
	              (ref = this.scatter).update.apply(ref, passes);
	              return this;
	            };
	            SPLOM.prototype.updateItem = function(i, options) {
	              var ref = this;
	              var regl = ref.regl;
	              if (options === null) {
	                this.traces[i] = null;
	                return this;
	              }
	              if (!options) {
	                return this;
	              }
	              var o = pick(options, {
	                data: "data items columns rows values dimensions samples x",
	                snap: "snap cluster",
	                size: "sizes size radius",
	                color: "colors color fill fill-color fillColor",
	                opacity: "opacity alpha transparency opaque",
	                borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
	                borderColor: "borderColors borderColor bordercolor stroke stroke-color strokeColor",
	                marker: "markers marker shape",
	                range: "range ranges databox dataBox",
	                viewport: "viewport viewBox viewbox",
	                domain: "domain domains area areas",
	                padding: "pad padding paddings pads margin margins",
	                transpose: "transpose transposed",
	                diagonal: "diagonal diag showDiagonal",
	                upper: "upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf",
	                lower: "lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower"
	              });
	              var trace = this.traces[i] || (this.traces[i] = {
	                id: i,
	                buffer: regl.buffer({
	                  usage: "dynamic",
	                  type: "float",
	                  data: new Uint8Array()
	                }),
	                color: "black",
	                marker: null,
	                size: 12,
	                borderColor: "transparent",
	                borderSize: 1,
	                viewport: rect([regl._gl.drawingBufferWidth, regl._gl.drawingBufferHeight]),
	                padding: [0, 0, 0, 0],
	                opacity: 1,
	                diagonal: true,
	                upper: true,
	                lower: true
	              });
	              if (o.color != null) {
	                trace.color = o.color;
	              }
	              if (o.size != null) {
	                trace.size = o.size;
	              }
	              if (o.marker != null) {
	                trace.marker = o.marker;
	              }
	              if (o.borderColor != null) {
	                trace.borderColor = o.borderColor;
	              }
	              if (o.borderSize != null) {
	                trace.borderSize = o.borderSize;
	              }
	              if (o.opacity != null) {
	                trace.opacity = o.opacity;
	              }
	              if (o.viewport) {
	                trace.viewport = rect(o.viewport);
	              }
	              if (o.diagonal != null) {
	                trace.diagonal = o.diagonal;
	              }
	              if (o.upper != null) {
	                trace.upper = o.upper;
	              }
	              if (o.lower != null) {
	                trace.lower = o.lower;
	              }
	              if (o.data) {
	                trace.buffer(flatten(o.data));
	                trace.columns = o.data.length;
	                trace.count = o.data[0].length;
	                trace.bounds = [];
	                for (var i$1 = 0; i$1 < trace.columns; i$1++) {
	                  trace.bounds[i$1] = getBounds(o.data[i$1], 1);
	                }
	              }
	              var multirange;
	              if (o.range) {
	                trace.range = o.range;
	                multirange = trace.range && typeof trace.range[0] !== "number";
	              }
	              if (o.domain) {
	                trace.domain = o.domain;
	              }
	              var multipadding = false;
	              if (o.padding != null) {
	                if (Array.isArray(o.padding) && o.padding.length === trace.columns && typeof o.padding[o.padding.length - 1] === "number") {
	                  trace.padding = o.padding.map(getPad);
	                  multipadding = true;
	                } else {
	                  trace.padding = getPad(o.padding);
	                }
	              }
	              var m = trace.columns;
	              var n = trace.count;
	              var w = trace.viewport.width;
	              var h = trace.viewport.height;
	              var left = trace.viewport.x;
	              var top = trace.viewport.y;
	              var iw = w / m;
	              var ih = h / m;
	              trace.passes = [];
	              for (var i$2 = 0; i$2 < m; i$2++) {
	                for (var j = 0; j < m; j++) {
	                  if (!trace.diagonal && j === i$2) {
	                    continue;
	                  }
	                  if (!trace.upper && i$2 > j) {
	                    continue;
	                  }
	                  if (!trace.lower && i$2 < j) {
	                    continue;
	                  }
	                  var key = passId(trace.id, i$2, j);
	                  var pass = this.passes[key] || (this.passes[key] = {});
	                  if (o.data) {
	                    if (o.transpose) {
	                      pass.positions = {
	                        x: { buffer: trace.buffer, offset: j, count: n, stride: m },
	                        y: { buffer: trace.buffer, offset: i$2, count: n, stride: m }
	                      };
	                    } else {
	                      pass.positions = {
	                        x: { buffer: trace.buffer, offset: j * n, count: n },
	                        y: { buffer: trace.buffer, offset: i$2 * n, count: n }
	                      };
	                    }
	                    pass.bounds = getBox(trace.bounds, i$2, j);
	                  }
	                  if (o.domain || o.viewport || o.data) {
	                    var pad = multipadding ? getBox(trace.padding, i$2, j) : trace.padding;
	                    if (trace.domain) {
	                      var ref$1 = getBox(trace.domain, i$2, j);
	                      var lox = ref$1[0];
	                      var loy = ref$1[1];
	                      var hix = ref$1[2];
	                      var hiy = ref$1[3];
	                      pass.viewport = [
	                        left + lox * w + pad[0],
	                        top + loy * h + pad[1],
	                        left + hix * w - pad[2],
	                        top + hiy * h - pad[3]
	                      ];
	                    } else {
	                      pass.viewport = [
	                        left + j * iw + iw * pad[0],
	                        top + i$2 * ih + ih * pad[1],
	                        left + (j + 1) * iw - iw * pad[2],
	                        top + (i$2 + 1) * ih - ih * pad[3]
	                      ];
	                    }
	                  }
	                  if (o.color) {
	                    pass.color = trace.color;
	                  }
	                  if (o.size) {
	                    pass.size = trace.size;
	                  }
	                  if (o.marker) {
	                    pass.marker = trace.marker;
	                  }
	                  if (o.borderSize) {
	                    pass.borderSize = trace.borderSize;
	                  }
	                  if (o.borderColor) {
	                    pass.borderColor = trace.borderColor;
	                  }
	                  if (o.opacity) {
	                    pass.opacity = trace.opacity;
	                  }
	                  if (o.range) {
	                    pass.range = multirange ? getBox(trace.range, i$2, j) : trace.range || pass.bounds;
	                  }
	                  trace.passes.push(key);
	                }
	              }
	              return this;
	            };
	            SPLOM.prototype.draw = function() {
	              var ref$2;
	              var args = [], len = arguments.length;
	              while (len--) args[len] = arguments[len];
	              if (!args.length) {
	                this.scatter.draw();
	              } else {
	                var idx = [];
	                for (var i = 0; i < args.length; i++) {
	                  if (typeof args[i] === "number") {
	                    var ref = this.traces[args[i]];
	                    var passes = ref.passes;
	                    var passOffset = ref.passOffset;
	                    idx.push.apply(idx, arrRange(passOffset, passOffset + passes.length));
	                  } else if (args[i].length) {
	                    var els = args[i];
	                    var ref$1 = this.traces[i];
	                    var passes$1 = ref$1.passes;
	                    var passOffset$1 = ref$1.passOffset;
	                    passes$1 = passes$1.map(function(passId2, i2) {
	                      idx[passOffset$1 + i2] = els;
	                    });
	                  }
	                }
	                (ref$2 = this.scatter).draw.apply(ref$2, idx);
	              }
	              return this;
	            };
	            SPLOM.prototype.destroy = function() {
	              this.traces.forEach(function(trace) {
	                if (trace.buffer && trace.buffer.destroy) {
	                  trace.buffer.destroy();
	                }
	              });
	              this.traces = null;
	              this.passes = null;
	              this.scatter.destroy();
	              return this;
	            };
	            function passId(trace, i, j) {
	              var id = trace.id != null ? trace.id : trace;
	              var n = i;
	              var m = j;
	              var key = id << 16 | (n & 255) << 8 | m & 255;
	              return key;
	            }
	            function getBox(items, i, j) {
	              var iloy, ihiy, jlox, jhix;
	              var iitem = items[i], jitem = items[j];
	              if (iitem.length > 2) {
	                iitem[0];
	                iitem[2];
	                iloy = iitem[1];
	                ihiy = iitem[3];
	              } else if (iitem.length) {
	                iloy = iitem[0];
	                ihiy = iitem[1];
	              } else {
	                iitem.x;
	                iloy = iitem.y;
	                iitem.x + iitem.width;
	                ihiy = iitem.y + iitem.height;
	              }
	              if (jitem.length > 2) {
	                jlox = jitem[0];
	                jhix = jitem[2];
	                jitem[1];
	                jitem[3];
	              } else if (jitem.length) {
	                jlox = jitem[0];
	                jhix = jitem[1];
	              } else {
	                jlox = jitem.x;
	                jitem.y;
	                jhix = jitem.x + jitem.width;
	                jitem.y + jitem.height;
	              }
	              return [jlox, iloy, jhix, ihiy];
	            }
	            function getPad(arg) {
	              if (typeof arg === "number") {
	                return [arg, arg, arg, arg];
	              } else if (arg.length === 2) {
	                return [arg[0], arg[1], arg[0], arg[1]];
	              } else {
	                var box = rect(arg);
	                return [box.x, box.y, box.x + box.width, box.y + box.height];
	              }
	            }
	          }
	        ),
	        /***/
	        98580: (
	          /***/
	          function(module2) {
	            (function(da, ea) {
	              module2.exports = ea() ;
	            })(this, function() {
	              function da(a, b) {
	                this.id = Db++;
	                this.type = a;
	                this.data = b;
	              }
	              function ea(a) {
	                if (0 === a.length) return [];
	                var b = a.charAt(0), c = a.charAt(a.length - 1);
	                if (1 < a.length && b === c && ('"' === b || "'" === b)) return ['"' + a.substr(1, a.length - 2).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'];
	                if (b = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(a)) return ea(a.substr(
	                  0,
	                  b.index
	                )).concat(ea(b[1])).concat(ea(a.substr(b.index + b[0].length)));
	                b = a.split(".");
	                if (1 === b.length) return ['"' + a.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'];
	                a = [];
	                for (c = 0; c < b.length; ++c) a = a.concat(ea(b[c]));
	                return a;
	              }
	              function bb(a) {
	                return "[" + ea(a).join("][") + "]";
	              }
	              function cb(a, b) {
	                if ("function" === typeof a) return new da(0, a);
	                if ("number" === typeof a || "boolean" === typeof a) return new da(5, a);
	                if (Array.isArray(a)) return new da(6, a.map(function(a2, d) {
	                  return cb(a2);
	                }));
	                if (a instanceof da) return a;
	              }
	              function Eb() {
	                var a = { "": 0 }, b = [""];
	                return { id: function(c) {
	                  var d = a[c];
	                  if (d) return d;
	                  d = a[c] = b.length;
	                  b.push(c);
	                  return d;
	                }, str: function(a2) {
	                  return b[a2];
	                } };
	              }
	              function Fb(a, b, c) {
	                function d() {
	                  var b2 = window.innerWidth, d2 = window.innerHeight;
	                  a !== document.body && (d2 = f.getBoundingClientRect(), b2 = d2.right - d2.left, d2 = d2.bottom - d2.top);
	                  f.width = c * b2;
	                  f.height = c * d2;
	                }
	                var f = document.createElement("canvas");
	                O(f.style, { border: 0, margin: 0, padding: 0, top: 0, left: 0, width: "100%", height: "100%" });
	                a.appendChild(f);
	                a === document.body && (f.style.position = "absolute", O(a.style, { margin: 0, padding: 0 }));
	                var e;
	                a !== document.body && "function" === typeof ResizeObserver ? (e = new ResizeObserver(function() {
	                  setTimeout(d);
	                }), e.observe(a)) : window.addEventListener("resize", d, false);
	                d();
	                return { canvas: f, onDestroy: function() {
	                  e ? e.disconnect() : window.removeEventListener("resize", d);
	                  a.removeChild(f);
	                } };
	              }
	              function Gb(a, b) {
	                function c(c2) {
	                  try {
	                    return a.getContext(c2, b);
	                  } catch (f) {
	                    return null;
	                  }
	                }
	                return c("webgl") || c("experimental-webgl") || c("webgl-experimental");
	              }
	              function db(a) {
	                return "string" === typeof a ? a.split() : a;
	              }
	              function eb(a) {
	                return "string" === typeof a ? document.querySelector(a) : a;
	              }
	              function Hb(a) {
	                var b = a || {}, c, d, f, e;
	                a = {};
	                var m = [], q = [], u = "undefined" === typeof window ? 1 : window.devicePixelRatio, r = false, k = {}, n = function(a2) {
	                }, t = function() {
	                };
	                "string" === typeof b ? c = document.querySelector(b) : "object" === typeof b && ("string" === typeof b.nodeName && "function" === typeof b.appendChild && "function" === typeof b.getBoundingClientRect ? c = b : "function" === typeof b.drawArrays || "function" === typeof b.drawElements ? (e = b, f = e.canvas) : ("gl" in b ? e = b.gl : "canvas" in b ? f = eb(b.canvas) : "container" in b && (d = eb(b.container)), "attributes" in b && (a = b.attributes), "extensions" in b && (m = db(b.extensions)), "optionalExtensions" in b && (q = db(b.optionalExtensions)), "onDone" in b && (n = b.onDone), "profile" in b && (r = !!b.profile), "pixelRatio" in b && (u = +b.pixelRatio), "cachedCode" in b && (k = b.cachedCode)));
	                c && ("canvas" === c.nodeName.toLowerCase() ? f = c : d = c);
	                if (!e) {
	                  if (!f) {
	                    c = Fb(d || document.body, n, u);
	                    if (!c) return null;
	                    f = c.canvas;
	                    t = c.onDestroy;
	                  }
	                  undefined === a.premultipliedAlpha && (a.premultipliedAlpha = true);
	                  e = Gb(f, a);
	                }
	                return e ? { gl: e, canvas: f, container: d, extensions: m, optionalExtensions: q, pixelRatio: u, profile: r, cachedCode: k, onDone: n, onDestroy: t } : (t(), n("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"), null);
	              }
	              function Ib(a, b) {
	                function c(b2) {
	                  b2 = b2.toLowerCase();
	                  var c2;
	                  try {
	                    c2 = d[b2] = a.getExtension(b2);
	                  } catch (f2) {
	                  }
	                  return !!c2;
	                }
	                for (var d = {}, f = 0; f < b.extensions.length; ++f) {
	                  var e = b.extensions[f];
	                  if (!c(e)) return b.onDestroy(), b.onDone('"' + e + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser'), null;
	                }
	                b.optionalExtensions.forEach(c);
	                return { extensions: d, restore: function() {
	                  Object.keys(d).forEach(function(a2) {
	                    if (d[a2] && !c(a2)) throw Error("(regl): error restoring extension " + a2);
	                  });
	                } };
	              }
	              function S(a, b) {
	                for (var c = Array(a), d = 0; d < a; ++d) c[d] = b(d);
	                return c;
	              }
	              function fb(a) {
	                var b, c;
	                b = (65535 < a) << 4;
	                a >>>= b;
	                c = (255 < a) << 3;
	                a >>>= c;
	                b |= c;
	                c = (15 < a) << 2;
	                a >>>= c;
	                b |= c;
	                c = (3 < a) << 1;
	                return b | c | a >>> c >> 1;
	              }
	              function gb() {
	                function a(a2) {
	                  a: {
	                    for (var b2 = 16; 268435456 >= b2; b2 *= 16) if (a2 <= b2) {
	                      a2 = b2;
	                      break a;
	                    }
	                    a2 = 0;
	                  }
	                  b2 = c[fb(a2) >> 2];
	                  return 0 < b2.length ? b2.pop() : new ArrayBuffer(a2);
	                }
	                function b(a2) {
	                  c[fb(a2.byteLength) >> 2].push(a2);
	                }
	                var c = S(8, function() {
	                  return [];
	                });
	                return { alloc: a, free: b, allocType: function(b2, c2) {
	                  var e = null;
	                  switch (b2) {
	                    case 5120:
	                      e = new Int8Array(a(c2), 0, c2);
	                      break;
	                    case 5121:
	                      e = new Uint8Array(a(c2), 0, c2);
	                      break;
	                    case 5122:
	                      e = new Int16Array(a(2 * c2), 0, c2);
	                      break;
	                    case 5123:
	                      e = new Uint16Array(a(2 * c2), 0, c2);
	                      break;
	                    case 5124:
	                      e = new Int32Array(a(4 * c2), 0, c2);
	                      break;
	                    case 5125:
	                      e = new Uint32Array(a(4 * c2), 0, c2);
	                      break;
	                    case 5126:
	                      e = new Float32Array(a(4 * c2), 0, c2);
	                      break;
	                    default:
	                      return null;
	                  }
	                  return e.length !== c2 ? e.subarray(0, c2) : e;
	                }, freeType: function(a2) {
	                  b(a2.buffer);
	                } };
	              }
	              function fa(a) {
	                return !!a && "object" === typeof a && Array.isArray(a.shape) && Array.isArray(a.stride) && "number" === typeof a.offset && a.shape.length === a.stride.length && (Array.isArray(a.data) || P(a.data));
	              }
	              function hb(a, b, c, d, f, e) {
	                for (var m = 0; m < b; ++m) for (var q = a[m], u = 0; u < c; ++u) for (var r = q[u], k = 0; k < d; ++k) f[e++] = r[k];
	              }
	              function ib(a, b, c, d, f) {
	                for (var e = 1, m = c + 1; m < b.length; ++m) e *= b[m];
	                var q = b[c];
	                if (4 === b.length - c) {
	                  var u = b[c + 1], r = b[c + 2];
	                  b = b[c + 3];
	                  for (m = 0; m < q; ++m) hb(
	                    a[m],
	                    u,
	                    r,
	                    b,
	                    d,
	                    f
	                  ), f += e;
	                } else for (m = 0; m < q; ++m) ib(a[m], b, c + 1, d, f), f += e;
	              }
	              function Ha(a) {
	                return Ia[Object.prototype.toString.call(a)] | 0;
	              }
	              function jb(a, b) {
	                for (var c = 0; c < b.length; ++c) a[c] = b[c];
	              }
	              function kb(a, b, c, d, f, e, m) {
	                for (var q = 0, u = 0; u < c; ++u) for (var r = 0; r < d; ++r) a[q++] = b[f * u + e * r + m];
	              }
	              function Jb(a, b, c, d) {
	                function f(b2) {
	                  this.id = u++;
	                  this.buffer = a.createBuffer();
	                  this.type = b2;
	                  this.usage = 35044;
	                  this.byteLength = 0;
	                  this.dimension = 1;
	                  this.dtype = 5121;
	                  this.persistentData = null;
	                  c.profile && (this.stats = { size: 0 });
	                }
	                function e(b2, c2, d2) {
	                  b2.byteLength = c2.byteLength;
	                  a.bufferData(b2.type, c2, d2);
	                }
	                function m(a2, b2, c2, d2, h, p) {
	                  a2.usage = c2;
	                  if (Array.isArray(b2)) {
	                    if (a2.dtype = d2 || 5126, 0 < b2.length) if (Array.isArray(b2[0])) {
	                      h = lb(b2);
	                      for (var y = d2 = 1; y < h.length; ++y) d2 *= h[y];
	                      a2.dimension = d2;
	                      b2 = Ua(b2, h, a2.dtype);
	                      e(a2, b2, c2);
	                      p ? a2.persistentData = b2 : B.freeType(b2);
	                    } else "number" === typeof b2[0] ? (a2.dimension = h, h = B.allocType(a2.dtype, b2.length), jb(h, b2), e(a2, h, c2), p ? a2.persistentData = h : B.freeType(h)) : P(b2[0]) && (a2.dimension = b2[0].length, a2.dtype = d2 || Ha(b2[0]) || 5126, b2 = Ua(b2, [b2.length, b2[0].length], a2.dtype), e(a2, b2, c2), p ? a2.persistentData = b2 : B.freeType(b2));
	                  } else if (P(b2)) a2.dtype = d2 || Ha(b2), a2.dimension = h, e(a2, b2, c2), p && (a2.persistentData = new Uint8Array(new Uint8Array(b2.buffer)));
	                  else if (fa(b2)) {
	                    h = b2.shape;
	                    var f2 = b2.stride, y = b2.offset, w = 0, z = 0, k2 = 0, m2 = 0;
	                    1 === h.length ? (w = h[0], z = 1, k2 = f2[0], m2 = 0) : 2 === h.length && (w = h[0], z = h[1], k2 = f2[0], m2 = f2[1]);
	                    a2.dtype = d2 || Ha(b2.data) || 5126;
	                    a2.dimension = z;
	                    h = B.allocType(a2.dtype, w * z);
	                    kb(h, b2.data, w, z, k2, m2, y);
	                    e(a2, h, c2);
	                    p ? a2.persistentData = h : B.freeType(h);
	                  } else b2 instanceof ArrayBuffer && (a2.dtype = 5121, a2.dimension = h, e(
	                    a2,
	                    b2,
	                    c2
	                  ), p && (a2.persistentData = new Uint8Array(new Uint8Array(b2))));
	                }
	                function q(c2) {
	                  b.bufferCount--;
	                  d(c2);
	                  a.deleteBuffer(c2.buffer);
	                  c2.buffer = null;
	                  delete r[c2.id];
	                }
	                var u = 0, r = {};
	                f.prototype.bind = function() {
	                  a.bindBuffer(this.type, this.buffer);
	                };
	                f.prototype.destroy = function() {
	                  q(this);
	                };
	                var k = [];
	                c.profile && (b.getTotalBufferSize = function() {
	                  var a2 = 0;
	                  Object.keys(r).forEach(function(b2) {
	                    a2 += r[b2].stats.size;
	                  });
	                  return a2;
	                });
	                return { create: function(d2, e2, g, l) {
	                  function h(b2) {
	                    var d3 = 35044, n = null, g2 = 0, e3 = 0, f2 = 1;
	                    Array.isArray(b2) || P(b2) || fa(b2) || b2 instanceof ArrayBuffer ? n = b2 : "number" === typeof b2 ? g2 = b2 | 0 : b2 && ("data" in b2 && (n = b2.data), "usage" in b2 && (d3 = mb[b2.usage]), "type" in b2 && (e3 = Ja[b2.type]), "dimension" in b2 && (f2 = b2.dimension | 0), "length" in b2 && (g2 = b2.length | 0));
	                    p.bind();
	                    n ? m(p, n, d3, e3, f2, l) : (g2 && a.bufferData(p.type, g2, d3), p.dtype = e3 || 5121, p.usage = d3, p.dimension = f2, p.byteLength = g2);
	                    c.profile && (p.stats.size = p.byteLength * ja[p.dtype]);
	                    return h;
	                  }
	                  b.bufferCount++;
	                  var p = new f(e2);
	                  r[p.id] = p;
	                  g || h(d2);
	                  h._reglType = "buffer";
	                  h._buffer = p;
	                  h.subdata = function(b2, c2) {
	                    var d3 = (c2 || 0) | 0, n;
	                    p.bind();
	                    if (P(b2) || b2 instanceof ArrayBuffer) a.bufferSubData(p.type, d3, b2);
	                    else if (Array.isArray(b2)) {
	                      if (0 < b2.length) {
	                        if ("number" === typeof b2[0]) {
	                          var g2 = B.allocType(p.dtype, b2.length);
	                          jb(g2, b2);
	                          a.bufferSubData(p.type, d3, g2);
	                          B.freeType(g2);
	                        } else if (Array.isArray(b2[0]) || P(b2[0])) n = lb(b2), g2 = Ua(b2, n, p.dtype), a.bufferSubData(p.type, d3, g2), B.freeType(g2);
	                      }
	                    } else if (fa(b2)) {
	                      n = b2.shape;
	                      var e3 = b2.stride, l2 = g2 = 0, f2 = 0, v = 0;
	                      1 === n.length ? (g2 = n[0], l2 = 1, f2 = e3[0], v = 0) : 2 === n.length && (g2 = n[0], l2 = n[1], f2 = e3[0], v = e3[1]);
	                      n = Array.isArray(b2.data) ? p.dtype : Ha(b2.data);
	                      n = B.allocType(
	                        n,
	                        g2 * l2
	                      );
	                      kb(n, b2.data, g2, l2, f2, v, b2.offset);
	                      a.bufferSubData(p.type, d3, n);
	                      B.freeType(n);
	                    }
	                    return h;
	                  };
	                  c.profile && (h.stats = p.stats);
	                  h.destroy = function() {
	                    q(p);
	                  };
	                  return h;
	                }, createStream: function(a2, b2) {
	                  var c2 = k.pop();
	                  c2 || (c2 = new f(a2));
	                  c2.bind();
	                  m(c2, b2, 35040, 0, 1, false);
	                  return c2;
	                }, destroyStream: function(a2) {
	                  k.push(a2);
	                }, clear: function() {
	                  T(r).forEach(q);
	                  k.forEach(q);
	                }, getBuffer: function(a2) {
	                  return a2 && a2._buffer instanceof f ? a2._buffer : null;
	                }, restore: function() {
	                  T(r).forEach(function(b2) {
	                    b2.buffer = a.createBuffer();
	                    a.bindBuffer(b2.type, b2.buffer);
	                    a.bufferData(b2.type, b2.persistentData || b2.byteLength, b2.usage);
	                  });
	                }, _initBuffer: m };
	              }
	              function Kb(a, b, c, d) {
	                function f(a2) {
	                  this.id = u++;
	                  q[this.id] = this;
	                  this.buffer = a2;
	                  this.primType = 4;
	                  this.type = this.vertCount = 0;
	                }
	                function e(d2, e2, g, l, h, f2, y) {
	                  d2.buffer.bind();
	                  var k2;
	                  e2 ? ((k2 = y) || P(e2) && (!fa(e2) || P(e2.data)) || (k2 = b.oes_element_index_uint ? 5125 : 5123), c._initBuffer(d2.buffer, e2, g, k2, 3)) : (a.bufferData(34963, f2, g), d2.buffer.dtype = k2 || 5121, d2.buffer.usage = g, d2.buffer.dimension = 3, d2.buffer.byteLength = f2);
	                  k2 = y;
	                  if (!y) {
	                    switch (d2.buffer.dtype) {
	                      case 5121:
	                      case 5120:
	                        k2 = 5121;
	                        break;
	                      case 5123:
	                      case 5122:
	                        k2 = 5123;
	                        break;
	                      case 5125:
	                      case 5124:
	                        k2 = 5125;
	                    }
	                    d2.buffer.dtype = k2;
	                  }
	                  d2.type = k2;
	                  e2 = h;
	                  0 > e2 && (e2 = d2.buffer.byteLength, 5123 === k2 ? e2 >>= 1 : 5125 === k2 && (e2 >>= 2));
	                  d2.vertCount = e2;
	                  e2 = l;
	                  0 > l && (e2 = 4, l = d2.buffer.dimension, 1 === l && (e2 = 0), 2 === l && (e2 = 1), 3 === l && (e2 = 4));
	                  d2.primType = e2;
	                }
	                function m(a2) {
	                  d.elementsCount--;
	                  delete q[a2.id];
	                  a2.buffer.destroy();
	                  a2.buffer = null;
	                }
	                var q = {}, u = 0, r = { uint8: 5121, uint16: 5123 };
	                b.oes_element_index_uint && (r.uint32 = 5125);
	                f.prototype.bind = function() {
	                  this.buffer.bind();
	                };
	                var k = [];
	                return { create: function(a2, b2) {
	                  function g(a3) {
	                    if (a3) if ("number" === typeof a3) l(a3), h.primType = 4, h.vertCount = a3 | 0, h.type = 5121;
	                    else {
	                      var b3 = null, c2 = 35044, d2 = -1, f2 = -1, n = 0, k2 = 0;
	                      if (Array.isArray(a3) || P(a3) || fa(a3)) b3 = a3;
	                      else if ("data" in a3 && (b3 = a3.data), "usage" in a3 && (c2 = mb[a3.usage]), "primitive" in a3 && (d2 = Ka[a3.primitive]), "count" in a3 && (f2 = a3.count | 0), "type" in a3 && (k2 = r[a3.type]), "length" in a3) n = a3.length | 0;
	                      else if (n = f2, 5123 === k2 || 5122 === k2) n *= 2;
	                      else if (5125 === k2 || 5124 === k2) n *= 4;
	                      e(h, b3, c2, d2, f2, n, k2);
	                    }
	                    else l(), h.primType = 4, h.vertCount = 0, h.type = 5121;
	                    return g;
	                  }
	                  var l = c.create(
	                    null,
	                    34963,
	                    true
	                  ), h = new f(l._buffer);
	                  d.elementsCount++;
	                  g(a2);
	                  g._reglType = "elements";
	                  g._elements = h;
	                  g.subdata = function(a3, b3) {
	                    l.subdata(a3, b3);
	                    return g;
	                  };
	                  g.destroy = function() {
	                    m(h);
	                  };
	                  return g;
	                }, createStream: function(a2) {
	                  var b2 = k.pop();
	                  b2 || (b2 = new f(c.create(null, 34963, true, false)._buffer));
	                  e(b2, a2, 35040, -1, -1, 0, 0);
	                  return b2;
	                }, destroyStream: function(a2) {
	                  k.push(a2);
	                }, getElements: function(a2) {
	                  return "function" === typeof a2 && a2._elements instanceof f ? a2._elements : null;
	                }, clear: function() {
	                  T(q).forEach(m);
	                } };
	              }
	              function ob(a) {
	                for (var b = B.allocType(
	                  5123,
	                  a.length
	                ), c = 0; c < a.length; ++c) if (isNaN(a[c])) b[c] = 65535;
	                else if (Infinity === a[c]) b[c] = 31744;
	                else if (-Infinity === a[c]) b[c] = 64512;
	                else {
	                  pb[0] = a[c];
	                  var d = Lb[0], f = d >>> 31 << 15, e = (d << 1 >>> 24) - 127, d = d >> 13 & 1023;
	                  b[c] = -24 > e ? f : -14 > e ? f + (d + 1024 >> -14 - e) : 15 < e ? f + 31744 : f + (e + 15 << 10) + d;
	                }
	                return b;
	              }
	              function qa(a) {
	                return Array.isArray(a) || P(a);
	              }
	              function ra(a) {
	                return "[object " + a + "]";
	              }
	              function qb(a) {
	                return Array.isArray(a) && (0 === a.length || "number" === typeof a[0]);
	              }
	              function rb(a) {
	                return Array.isArray(a) && 0 !== a.length && qa(a[0]) ? true : false;
	              }
	              function R(a) {
	                return Object.prototype.toString.call(a);
	              }
	              function Va(a) {
	                if (!a) return false;
	                var b = R(a);
	                return 0 <= Mb.indexOf(b) ? true : qb(a) || rb(a) || fa(a);
	              }
	              function sb(a, b) {
	                36193 === a.type ? (a.data = ob(b), B.freeType(b)) : a.data = b;
	              }
	              function La(a, b, c, d, f, e) {
	                a = "undefined" !== typeof G[a] ? G[a] : U[a] * ya[b];
	                e && (a *= 6);
	                if (f) {
	                  for (d = 0; 1 <= c; ) d += a * c * c, c /= 2;
	                  return d;
	                }
	                return a * c * d;
	              }
	              function Nb(a, b, c, d, f, e, m) {
	                function q() {
	                  this.format = this.internalformat = 6408;
	                  this.type = 5121;
	                  this.flipY = this.premultiplyAlpha = this.compressed = false;
	                  this.unpackAlignment = 1;
	                  this.colorSpace = 37444;
	                  this.channels = this.height = this.width = 0;
	                }
	                function u(a2, b2) {
	                  a2.internalformat = b2.internalformat;
	                  a2.format = b2.format;
	                  a2.type = b2.type;
	                  a2.compressed = b2.compressed;
	                  a2.premultiplyAlpha = b2.premultiplyAlpha;
	                  a2.flipY = b2.flipY;
	                  a2.unpackAlignment = b2.unpackAlignment;
	                  a2.colorSpace = b2.colorSpace;
	                  a2.width = b2.width;
	                  a2.height = b2.height;
	                  a2.channels = b2.channels;
	                }
	                function r(a2, b2) {
	                  if ("object" === typeof b2 && b2) {
	                    "premultiplyAlpha" in b2 && (a2.premultiplyAlpha = b2.premultiplyAlpha);
	                    "flipY" in b2 && (a2.flipY = b2.flipY);
	                    "alignment" in b2 && (a2.unpackAlignment = b2.alignment);
	                    "colorSpace" in b2 && (a2.colorSpace = Ob[b2.colorSpace]);
	                    "type" in b2 && (a2.type = W[b2.type]);
	                    var c2 = a2.width, d2 = a2.height, e2 = a2.channels, h2 = false;
	                    "shape" in b2 ? (c2 = b2.shape[0], d2 = b2.shape[1], 3 === b2.shape.length && (e2 = b2.shape[2], h2 = true)) : ("radius" in b2 && (c2 = d2 = b2.radius), "width" in b2 && (c2 = b2.width), "height" in b2 && (d2 = b2.height), "channels" in b2 && (e2 = b2.channels, h2 = true));
	                    a2.width = c2 | 0;
	                    a2.height = d2 | 0;
	                    a2.channels = e2 | 0;
	                    c2 = false;
	                    "format" in b2 && (c2 = b2.format, d2 = a2.internalformat = Q[c2], a2.format = Ea[d2], c2 in W && !("type" in b2) && (a2.type = W[c2]), c2 in I && (a2.compressed = true), c2 = true);
	                    !h2 && c2 ? a2.channels = U[a2.format] : h2 && !c2 && a2.channels !== Na[a2.format] && (a2.format = a2.internalformat = Na[a2.channels]);
	                  }
	                }
	                function k(b2) {
	                  a.pixelStorei(37440, b2.flipY);
	                  a.pixelStorei(37441, b2.premultiplyAlpha);
	                  a.pixelStorei(37443, b2.colorSpace);
	                  a.pixelStorei(3317, b2.unpackAlignment);
	                }
	                function n() {
	                  q.call(this);
	                  this.yOffset = this.xOffset = 0;
	                  this.data = null;
	                  this.needsFree = false;
	                  this.element = null;
	                  this.needsCopy = false;
	                }
	                function t(a2, b2) {
	                  var c2 = null;
	                  Va(b2) ? c2 = b2 : b2 && (r(a2, b2), "x" in b2 && (a2.xOffset = b2.x | 0), "y" in b2 && (a2.yOffset = b2.y | 0), Va(b2.data) && (c2 = b2.data));
	                  if (b2.copy) {
	                    var d2 = f.viewportWidth, e2 = f.viewportHeight;
	                    a2.width = a2.width || d2 - a2.xOffset;
	                    a2.height = a2.height || e2 - a2.yOffset;
	                    a2.needsCopy = true;
	                  } else if (!c2) a2.width = a2.width || 1, a2.height = a2.height || 1, a2.channels = a2.channels || 4;
	                  else if (P(c2)) a2.channels = a2.channels || 4, a2.data = c2, "type" in b2 || 5121 !== a2.type || (a2.type = Ia[Object.prototype.toString.call(c2)] | 0);
	                  else if (qb(c2)) {
	                    a2.channels = a2.channels || 4;
	                    d2 = c2;
	                    e2 = d2.length;
	                    switch (a2.type) {
	                      case 5121:
	                      case 5123:
	                      case 5125:
	                      case 5126:
	                        e2 = B.allocType(a2.type, e2);
	                        e2.set(d2);
	                        a2.data = e2;
	                        break;
	                      case 36193:
	                        a2.data = ob(d2);
	                    }
	                    a2.alignment = 1;
	                    a2.needsFree = true;
	                  } else if (fa(c2)) {
	                    d2 = c2.data;
	                    Array.isArray(d2) || 5121 !== a2.type || (a2.type = Ia[Object.prototype.toString.call(d2)] | 0);
	                    var e2 = c2.shape, h2 = c2.stride, g2, l2, v2, k2;
	                    3 === e2.length ? (v2 = e2[2], k2 = h2[2]) : k2 = v2 = 1;
	                    g2 = e2[0];
	                    l2 = e2[1];
	                    e2 = h2[0];
	                    h2 = h2[1];
	                    a2.alignment = 1;
	                    a2.width = g2;
	                    a2.height = l2;
	                    a2.channels = v2;
	                    a2.format = a2.internalformat = Na[v2];
	                    a2.needsFree = true;
	                    g2 = k2;
	                    c2 = c2.offset;
	                    v2 = a2.width;
	                    k2 = a2.height;
	                    l2 = a2.channels;
	                    for (var n2 = B.allocType(36193 === a2.type ? 5126 : a2.type, v2 * k2 * l2), x = 0, F = 0; F < k2; ++F) for (var aa = 0; aa < v2; ++aa) for (var Fa = 0; Fa < l2; ++Fa) n2[x++] = d2[e2 * aa + h2 * F + g2 * Fa + c2];
	                    sb(a2, n2);
	                  } else if (R(c2) === Wa || R(c2) === Xa || R(c2) === ub) R(c2) === Wa || R(c2) === Xa ? a2.element = c2 : a2.element = c2.canvas, a2.width = a2.element.width, a2.height = a2.element.height, a2.channels = 4;
	                  else if (R(c2) === vb) a2.element = c2, a2.width = c2.width, a2.height = c2.height, a2.channels = 4;
	                  else if (R(c2) === wb) a2.element = c2, a2.width = c2.naturalWidth, a2.height = c2.naturalHeight, a2.channels = 4;
	                  else if (R(c2) === xb) a2.element = c2, a2.width = c2.videoWidth, a2.height = c2.videoHeight, a2.channels = 4;
	                  else if (rb(c2)) {
	                    d2 = a2.width || c2[0].length;
	                    e2 = a2.height || c2.length;
	                    h2 = a2.channels;
	                    h2 = qa(c2[0][0]) ? h2 || c2[0][0].length : h2 || 1;
	                    g2 = Pa.shape(c2);
	                    v2 = 1;
	                    for (k2 = 0; k2 < g2.length; ++k2) v2 *= g2[k2];
	                    v2 = B.allocType(36193 === a2.type ? 5126 : a2.type, v2);
	                    Pa.flatten(c2, g2, "", v2);
	                    sb(a2, v2);
	                    a2.alignment = 1;
	                    a2.width = d2;
	                    a2.height = e2;
	                    a2.channels = h2;
	                    a2.format = a2.internalformat = Na[h2];
	                    a2.needsFree = true;
	                  }
	                }
	                function g(b2, c2, e2, h2, g2) {
	                  var v2 = b2.element, l2 = b2.data, f2 = b2.internalformat, n2 = b2.format, y2 = b2.type, w2 = b2.width, x = b2.height;
	                  k(b2);
	                  v2 ? a.texSubImage2D(c2, g2, e2, h2, n2, y2, v2) : b2.compressed ? a.compressedTexSubImage2D(c2, g2, e2, h2, f2, w2, x, l2) : b2.needsCopy ? (d(), a.copyTexSubImage2D(
	                    c2,
	                    g2,
	                    e2,
	                    h2,
	                    b2.xOffset,
	                    b2.yOffset,
	                    w2,
	                    x
	                  )) : a.texSubImage2D(c2, g2, e2, h2, w2, x, n2, y2, l2);
	                }
	                function l() {
	                  return Qa.pop() || new n();
	                }
	                function h(a2) {
	                  a2.needsFree && B.freeType(a2.data);
	                  n.call(a2);
	                  Qa.push(a2);
	                }
	                function p() {
	                  q.call(this);
	                  this.genMipmaps = false;
	                  this.mipmapHint = 4352;
	                  this.mipmask = 0;
	                  this.images = Array(16);
	                }
	                function y(a2, b2, c2) {
	                  var d2 = a2.images[0] = l();
	                  a2.mipmask = 1;
	                  d2.width = a2.width = b2;
	                  d2.height = a2.height = c2;
	                  d2.channels = a2.channels = 4;
	                }
	                function C(a2, b2) {
	                  var c2 = null;
	                  if (Va(b2)) c2 = a2.images[0] = l(), u(c2, a2), t(c2, b2), a2.mipmask = 1;
	                  else if (r(a2, b2), Array.isArray(b2.mipmap)) for (var d2 = b2.mipmap, e2 = 0; e2 < d2.length; ++e2) c2 = a2.images[e2] = l(), u(c2, a2), c2.width >>= e2, c2.height >>= e2, t(c2, d2[e2]), a2.mipmask |= 1 << e2;
	                  else c2 = a2.images[0] = l(), u(c2, a2), t(c2, b2), a2.mipmask = 1;
	                  u(a2, a2.images[0]);
	                }
	                function w(b2, c2) {
	                  for (var e2 = b2.images, h2 = 0; h2 < e2.length && e2[h2]; ++h2) {
	                    var g2 = e2[h2], v2 = c2, l2 = h2, f2 = g2.element, n2 = g2.data, y2 = g2.internalformat, w2 = g2.format, x = g2.type, F = g2.width, aa = g2.height;
	                    k(g2);
	                    f2 ? a.texImage2D(v2, l2, w2, w2, x, f2) : g2.compressed ? a.compressedTexImage2D(v2, l2, y2, F, aa, 0, n2) : g2.needsCopy ? (d(), a.copyTexImage2D(v2, l2, w2, g2.xOffset, g2.yOffset, F, aa, 0)) : a.texImage2D(
	                      v2,
	                      l2,
	                      w2,
	                      F,
	                      aa,
	                      0,
	                      w2,
	                      x,
	                      n2 || null
	                    );
	                  }
	                }
	                function z() {
	                  var a2 = S2.pop() || new p();
	                  q.call(a2);
	                  for (var b2 = a2.mipmask = 0; 16 > b2; ++b2) a2.images[b2] = null;
	                  return a2;
	                }
	                function wa(a2) {
	                  for (var b2 = a2.images, c2 = 0; c2 < b2.length; ++c2) b2[c2] && h(b2[c2]), b2[c2] = null;
	                  S2.push(a2);
	                }
	                function E2() {
	                  this.magFilter = this.minFilter = 9728;
	                  this.wrapT = this.wrapS = 33071;
	                  this.anisotropic = 1;
	                  this.genMipmaps = false;
	                  this.mipmapHint = 4352;
	                }
	                function nb(a2, b2) {
	                  "min" in b2 && (a2.minFilter = V[b2.min], 0 <= Pb.indexOf(a2.minFilter) && !("faces" in b2) && (a2.genMipmaps = true));
	                  "mag" in b2 && (a2.magFilter = na[b2.mag]);
	                  var c2 = a2.wrapS, d2 = a2.wrapT;
	                  if ("wrap" in b2) {
	                    var e2 = b2.wrap;
	                    "string" === typeof e2 ? c2 = d2 = oa[e2] : Array.isArray(e2) && (c2 = oa[e2[0]], d2 = oa[e2[1]]);
	                  } else "wrapS" in b2 && (c2 = oa[b2.wrapS]), "wrapT" in b2 && (d2 = oa[b2.wrapT]);
	                  a2.wrapS = c2;
	                  a2.wrapT = d2;
	                  "anisotropic" in b2 && (a2.anisotropic = b2.anisotropic);
	                  if ("mipmap" in b2) {
	                    c2 = false;
	                    switch (typeof b2.mipmap) {
	                      case "string":
	                        a2.mipmapHint = J[b2.mipmap];
	                        c2 = a2.genMipmaps = true;
	                        break;
	                      case "boolean":
	                        c2 = a2.genMipmaps = b2.mipmap;
	                        break;
	                      case "object":
	                        a2.genMipmaps = false, c2 = true;
	                    }
	                    !c2 || "min" in b2 || (a2.minFilter = 9984);
	                  }
	                }
	                function D(c2, d2) {
	                  a.texParameteri(
	                    d2,
	                    10241,
	                    c2.minFilter
	                  );
	                  a.texParameteri(d2, 10240, c2.magFilter);
	                  a.texParameteri(d2, 10242, c2.wrapS);
	                  a.texParameteri(d2, 10243, c2.wrapT);
	                  b.ext_texture_filter_anisotropic && a.texParameteri(d2, 34046, c2.anisotropic);
	                  c2.genMipmaps && (a.hint(33170, c2.mipmapHint), a.generateMipmap(d2));
	                }
	                function v(b2) {
	                  q.call(this);
	                  this.mipmask = 0;
	                  this.internalformat = 6408;
	                  this.id = Z2++;
	                  this.refCount = 1;
	                  this.target = b2;
	                  this.texture = a.createTexture();
	                  this.unit = -1;
	                  this.bindCount = 0;
	                  this.texInfo = new E2();
	                  m.profile && (this.stats = { size: 0 });
	                }
	                function ba(b2) {
	                  a.activeTexture(33984);
	                  a.bindTexture(b2.target, b2.texture);
	                }
	                function za() {
	                  var b2 = X[0];
	                  b2 ? a.bindTexture(b2.target, b2.texture) : a.bindTexture(3553, null);
	                }
	                function A(b2) {
	                  var c2 = b2.texture, d2 = b2.unit, h2 = b2.target;
	                  0 <= d2 && (a.activeTexture(33984 + d2), a.bindTexture(h2, null), X[d2] = null);
	                  a.deleteTexture(c2);
	                  b2.texture = null;
	                  b2.params = null;
	                  b2.pixels = null;
	                  b2.refCount = 0;
	                  delete ka[b2.id];
	                  e.textureCount--;
	                }
	                var J = { "don't care": 4352, "dont care": 4352, nice: 4354, fast: 4353 }, oa = { repeat: 10497, clamp: 33071, mirror: 33648 }, na = { nearest: 9728, linear: 9729 }, V = O({
	                  mipmap: 9987,
	                  "nearest mipmap nearest": 9984,
	                  "linear mipmap nearest": 9985,
	                  "nearest mipmap linear": 9986,
	                  "linear mipmap linear": 9987
	                }, na), Ob = { none: 0, browser: 37444 }, W = { uint8: 5121, rgba4: 32819, rgb565: 33635, "rgb5 a1": 32820 }, Q = { alpha: 6406, luminance: 6409, "luminance alpha": 6410, rgb: 6407, rgba: 6408, rgba4: 32854, "rgb5 a1": 32855, rgb565: 36194 }, I = {};
	                b.ext_srgb && (Q.srgb = 35904, Q.srgba = 35906);
	                b.oes_texture_float && (W.float32 = W["float"] = 5126);
	                b.oes_texture_half_float && (W.float16 = W["half float"] = 36193);
	                b.webgl_depth_texture && (O(Q, { depth: 6402, "depth stencil": 34041 }), O(W, { uint16: 5123, uint32: 5125, "depth stencil": 34042 }));
	                b.webgl_compressed_texture_s3tc && O(I, { "rgb s3tc dxt1": 33776, "rgba s3tc dxt1": 33777, "rgba s3tc dxt3": 33778, "rgba s3tc dxt5": 33779 });
	                b.webgl_compressed_texture_atc && O(I, { "rgb atc": 35986, "rgba atc explicit alpha": 35987, "rgba atc interpolated alpha": 34798 });
	                b.webgl_compressed_texture_pvrtc && O(I, { "rgb pvrtc 4bppv1": 35840, "rgb pvrtc 2bppv1": 35841, "rgba pvrtc 4bppv1": 35842, "rgba pvrtc 2bppv1": 35843 });
	                b.webgl_compressed_texture_etc1 && (I["rgb etc1"] = 36196);
	                var K2 = Array.prototype.slice.call(a.getParameter(34467));
	                Object.keys(I).forEach(function(a2) {
	                  var b2 = I[a2];
	                  0 <= K2.indexOf(b2) && (Q[a2] = b2);
	                });
	                var G2 = Object.keys(Q);
	                c.textureFormats = G2;
	                var H2 = [];
	                Object.keys(Q).forEach(function(a2) {
	                  H2[Q[a2]] = a2;
	                });
	                var xa = [];
	                Object.keys(W).forEach(function(a2) {
	                  xa[W[a2]] = a2;
	                });
	                var L2 = [];
	                Object.keys(na).forEach(function(a2) {
	                  L2[na[a2]] = a2;
	                });
	                var pa = [];
	                Object.keys(V).forEach(function(a2) {
	                  pa[V[a2]] = a2;
	                });
	                var ga = [];
	                Object.keys(oa).forEach(function(a2) {
	                  ga[oa[a2]] = a2;
	                });
	                var Ea = G2.reduce(function(a2, c2) {
	                  var d2 = Q[c2];
	                  6409 === d2 || 6406 === d2 || 6409 === d2 || 6410 === d2 || 6402 === d2 || 34041 === d2 || b.ext_srgb && (35904 === d2 || 35906 === d2) ? a2[d2] = d2 : 32855 === d2 || 0 <= c2.indexOf("rgba") ? a2[d2] = 6408 : a2[d2] = 6407;
	                  return a2;
	                }, {}), Qa = [], S2 = [], Z2 = 0, ka = {}, ha = c.maxTextureUnits, X = Array(ha).map(function() {
	                  return null;
	                });
	                O(v.prototype, { bind: function() {
	                  this.bindCount += 1;
	                  var b2 = this.unit;
	                  if (0 > b2) {
	                    for (var c2 = 0; c2 < ha; ++c2) {
	                      var d2 = X[c2];
	                      if (d2) {
	                        if (0 < d2.bindCount) continue;
	                        d2.unit = -1;
	                      }
	                      X[c2] = this;
	                      b2 = c2;
	                      break;
	                    }
	                    m.profile && e.maxTextureUnits < b2 + 1 && (e.maxTextureUnits = b2 + 1);
	                    this.unit = b2;
	                    a.activeTexture(33984 + b2);
	                    a.bindTexture(this.target, this.texture);
	                  }
	                  return b2;
	                }, unbind: function() {
	                  --this.bindCount;
	                }, decRef: function() {
	                  0 >= --this.refCount && A(this);
	                } });
	                m.profile && (e.getTotalTextureSize = function() {
	                  var a2 = 0;
	                  Object.keys(ka).forEach(function(b2) {
	                    a2 += ka[b2].stats.size;
	                  });
	                  return a2;
	                });
	                return { create2D: function(b2, c2) {
	                  function d2(a2, b3) {
	                    var c3 = f2.texInfo;
	                    E2.call(c3);
	                    var e2 = z();
	                    "number" === typeof a2 ? "number" === typeof b3 ? y(e2, a2 | 0, b3 | 0) : y(e2, a2 | 0, a2 | 0) : a2 ? (nb(c3, a2), C(e2, a2)) : y(e2, 1, 1);
	                    c3.genMipmaps && (e2.mipmask = (e2.width << 1) - 1);
	                    f2.mipmask = e2.mipmask;
	                    u(
	                      f2,
	                      e2
	                    );
	                    f2.internalformat = e2.internalformat;
	                    d2.width = e2.width;
	                    d2.height = e2.height;
	                    ba(f2);
	                    w(e2, 3553);
	                    D(c3, 3553);
	                    za();
	                    wa(e2);
	                    m.profile && (f2.stats.size = La(f2.internalformat, f2.type, e2.width, e2.height, c3.genMipmaps, false));
	                    d2.format = H2[f2.internalformat];
	                    d2.type = xa[f2.type];
	                    d2.mag = L2[c3.magFilter];
	                    d2.min = pa[c3.minFilter];
	                    d2.wrapS = ga[c3.wrapS];
	                    d2.wrapT = ga[c3.wrapT];
	                    return d2;
	                  }
	                  var f2 = new v(3553);
	                  ka[f2.id] = f2;
	                  e.textureCount++;
	                  d2(b2, c2);
	                  d2.subimage = function(a2, b3, c3, e2) {
	                    b3 |= 0;
	                    c3 |= 0;
	                    e2 |= 0;
	                    var v2 = l();
	                    u(v2, f2);
	                    v2.width = 0;
	                    v2.height = 0;
	                    t(v2, a2);
	                    v2.width = v2.width || (f2.width >> e2) - b3;
	                    v2.height = v2.height || (f2.height >> e2) - c3;
	                    ba(f2);
	                    g(v2, 3553, b3, c3, e2);
	                    za();
	                    h(v2);
	                    return d2;
	                  };
	                  d2.resize = function(b3, c3) {
	                    var e2 = b3 | 0, h2 = c3 | 0 || e2;
	                    if (e2 === f2.width && h2 === f2.height) return d2;
	                    d2.width = f2.width = e2;
	                    d2.height = f2.height = h2;
	                    ba(f2);
	                    for (var g2 = 0; f2.mipmask >> g2; ++g2) {
	                      var v2 = e2 >> g2, l2 = h2 >> g2;
	                      if (!v2 || !l2) break;
	                      a.texImage2D(3553, g2, f2.format, v2, l2, 0, f2.format, f2.type, null);
	                    }
	                    za();
	                    m.profile && (f2.stats.size = La(f2.internalformat, f2.type, e2, h2, false, false));
	                    return d2;
	                  };
	                  d2._reglType = "texture2d";
	                  d2._texture = f2;
	                  m.profile && (d2.stats = f2.stats);
	                  d2.destroy = function() {
	                    f2.decRef();
	                  };
	                  return d2;
	                }, createCube: function(b2, c2, d2, f2, k2, n2) {
	                  function p2(a2, b3, c3, d3, e2, h2) {
	                    var f3, g2 = A2.texInfo;
	                    E2.call(g2);
	                    for (f3 = 0; 6 > f3; ++f3) J2[f3] = z();
	                    if ("number" === typeof a2 || !a2) for (a2 = a2 | 0 || 1, f3 = 0; 6 > f3; ++f3) y(J2[f3], a2, a2);
	                    else if ("object" === typeof a2) if (b3) C(J2[0], a2), C(J2[1], b3), C(J2[2], c3), C(J2[3], d3), C(J2[4], e2), C(J2[5], h2);
	                    else if (nb(g2, a2), r(A2, a2), "faces" in a2) for (a2 = a2.faces, f3 = 0; 6 > f3; ++f3) u(J2[f3], A2), C(J2[f3], a2[f3]);
	                    else for (f3 = 0; 6 > f3; ++f3) C(J2[f3], a2);
	                    u(A2, J2[0]);
	                    A2.mipmask = g2.genMipmaps ? (J2[0].width << 1) - 1 : J2[0].mipmask;
	                    A2.internalformat = J2[0].internalformat;
	                    p2.width = J2[0].width;
	                    p2.height = J2[0].height;
	                    ba(A2);
	                    for (f3 = 0; 6 > f3; ++f3) w(J2[f3], 34069 + f3);
	                    D(g2, 34067);
	                    za();
	                    m.profile && (A2.stats.size = La(A2.internalformat, A2.type, p2.width, p2.height, g2.genMipmaps, true));
	                    p2.format = H2[A2.internalformat];
	                    p2.type = xa[A2.type];
	                    p2.mag = L2[g2.magFilter];
	                    p2.min = pa[g2.minFilter];
	                    p2.wrapS = ga[g2.wrapS];
	                    p2.wrapT = ga[g2.wrapT];
	                    for (f3 = 0; 6 > f3; ++f3) wa(J2[f3]);
	                    return p2;
	                  }
	                  var A2 = new v(34067);
	                  ka[A2.id] = A2;
	                  e.cubeCount++;
	                  var J2 = Array(6);
	                  p2(b2, c2, d2, f2, k2, n2);
	                  p2.subimage = function(a2, b3, c3, d3, e2) {
	                    c3 |= 0;
	                    d3 |= 0;
	                    e2 |= 0;
	                    var f3 = l();
	                    u(f3, A2);
	                    f3.width = 0;
	                    f3.height = 0;
	                    t(f3, b3);
	                    f3.width = f3.width || (A2.width >> e2) - c3;
	                    f3.height = f3.height || (A2.height >> e2) - d3;
	                    ba(A2);
	                    g(f3, 34069 + a2, c3, d3, e2);
	                    za();
	                    h(f3);
	                    return p2;
	                  };
	                  p2.resize = function(b3) {
	                    b3 |= 0;
	                    if (b3 !== A2.width) {
	                      p2.width = A2.width = b3;
	                      p2.height = A2.height = b3;
	                      ba(A2);
	                      for (var c3 = 0; 6 > c3; ++c3) for (var x = 0; A2.mipmask >> x; ++x) a.texImage2D(34069 + c3, x, A2.format, b3 >> x, b3 >> x, 0, A2.format, A2.type, null);
	                      za();
	                      m.profile && (A2.stats.size = La(A2.internalformat, A2.type, p2.width, p2.height, false, true));
	                      return p2;
	                    }
	                  };
	                  p2._reglType = "textureCube";
	                  p2._texture = A2;
	                  m.profile && (p2.stats = A2.stats);
	                  p2.destroy = function() {
	                    A2.decRef();
	                  };
	                  return p2;
	                }, clear: function() {
	                  for (var b2 = 0; b2 < ha; ++b2) a.activeTexture(33984 + b2), a.bindTexture(3553, null), X[b2] = null;
	                  T(ka).forEach(A);
	                  e.cubeCount = 0;
	                  e.textureCount = 0;
	                }, getTexture: function(a2) {
	                  return null;
	                }, restore: function() {
	                  for (var b2 = 0; b2 < ha; ++b2) {
	                    var c2 = X[b2];
	                    c2 && (c2.bindCount = 0, c2.unit = -1, X[b2] = null);
	                  }
	                  T(ka).forEach(function(b3) {
	                    b3.texture = a.createTexture();
	                    a.bindTexture(b3.target, b3.texture);
	                    for (var c3 = 0; 32 > c3; ++c3) if (0 !== (b3.mipmask & 1 << c3)) if (3553 === b3.target) a.texImage2D(
	                      3553,
	                      c3,
	                      b3.internalformat,
	                      b3.width >> c3,
	                      b3.height >> c3,
	                      0,
	                      b3.internalformat,
	                      b3.type,
	                      null
	                    );
	                    else for (var d2 = 0; 6 > d2; ++d2) a.texImage2D(34069 + d2, c3, b3.internalformat, b3.width >> c3, b3.height >> c3, 0, b3.internalformat, b3.type, null);
	                    D(b3.texInfo, b3.target);
	                  });
	                }, refresh: function() {
	                  for (var b2 = 0; b2 < ha; ++b2) {
	                    var c2 = X[b2];
	                    c2 && (c2.bindCount = 0, c2.unit = -1, X[b2] = null);
	                    a.activeTexture(33984 + b2);
	                    a.bindTexture(3553, null);
	                    a.bindTexture(34067, null);
	                  }
	                } };
	              }
	              function Qb(a, b, c, d, f, e) {
	                function m(a2, b2, c2) {
	                  this.target = a2;
	                  this.texture = b2;
	                  this.renderbuffer = c2;
	                  var d2 = a2 = 0;
	                  b2 ? (a2 = b2.width, d2 = b2.height) : c2 && (a2 = c2.width, d2 = c2.height);
	                  this.width = a2;
	                  this.height = d2;
	                }
	                function q(a2) {
	                  a2 && (a2.texture && a2.texture._texture.decRef(), a2.renderbuffer && a2.renderbuffer._renderbuffer.decRef());
	                }
	                function u(a2, b2, c2) {
	                  a2 && (a2.texture ? a2.texture._texture.refCount += 1 : a2.renderbuffer._renderbuffer.refCount += 1);
	                }
	                function r(b2, c2) {
	                  c2 && (c2.texture ? a.framebufferTexture2D(36160, b2, c2.target, c2.texture._texture.texture, 0) : a.framebufferRenderbuffer(36160, b2, 36161, c2.renderbuffer._renderbuffer.renderbuffer));
	                }
	                function k(a2) {
	                  var b2 = 3553, c2 = null, d2 = null, e2 = a2;
	                  "object" === typeof a2 && (e2 = a2.data, "target" in a2 && (b2 = a2.target | 0));
	                  a2 = e2._reglType;
	                  "texture2d" === a2 ? c2 = e2 : "textureCube" === a2 ? c2 = e2 : "renderbuffer" === a2 && (d2 = e2, b2 = 36161);
	                  return new m(b2, c2, d2);
	                }
	                function n(a2, b2, c2, e2, g2) {
	                  if (c2) return a2 = d.create2D({ width: a2, height: b2, format: e2, type: g2 }), a2._texture.refCount = 0, new m(3553, a2, null);
	                  a2 = f.create({ width: a2, height: b2, format: e2 });
	                  a2._renderbuffer.refCount = 0;
	                  return new m(36161, null, a2);
	                }
	                function t(a2) {
	                  return a2 && (a2.texture || a2.renderbuffer);
	                }
	                function g(a2, b2, c2) {
	                  a2 && (a2.texture ? a2.texture.resize(b2, c2) : a2.renderbuffer && a2.renderbuffer.resize(b2, c2), a2.width = b2, a2.height = c2);
	                }
	                function l() {
	                  this.id = B2++;
	                  D[this.id] = this;
	                  this.framebuffer = a.createFramebuffer();
	                  this.height = this.width = 0;
	                  this.colorAttachments = [];
	                  this.depthStencilAttachment = this.stencilAttachment = this.depthAttachment = null;
	                }
	                function h(a2) {
	                  a2.colorAttachments.forEach(q);
	                  q(a2.depthAttachment);
	                  q(a2.stencilAttachment);
	                  q(a2.depthStencilAttachment);
	                }
	                function p(b2) {
	                  a.deleteFramebuffer(b2.framebuffer);
	                  b2.framebuffer = null;
	                  e.framebufferCount--;
	                  delete D[b2.id];
	                }
	                function y(b2) {
	                  var d2;
	                  a.bindFramebuffer(36160, b2.framebuffer);
	                  var e2 = b2.colorAttachments;
	                  for (d2 = 0; d2 < e2.length; ++d2) r(36064 + d2, e2[d2]);
	                  for (d2 = e2.length; d2 < c.maxColorAttachments; ++d2) a.framebufferTexture2D(36160, 36064 + d2, 3553, null, 0);
	                  a.framebufferTexture2D(36160, 33306, 3553, null, 0);
	                  a.framebufferTexture2D(36160, 36096, 3553, null, 0);
	                  a.framebufferTexture2D(36160, 36128, 3553, null, 0);
	                  r(36096, b2.depthAttachment);
	                  r(36128, b2.stencilAttachment);
	                  r(33306, b2.depthStencilAttachment);
	                  a.checkFramebufferStatus(36160);
	                  a.isContextLost();
	                  a.bindFramebuffer(36160, w.next ? w.next.framebuffer : null);
	                  w.cur = w.next;
	                  a.getError();
	                }
	                function C(a2, b2) {
	                  function c2(a3, b3) {
	                    var e2, f2 = 0, g2 = 0, l2 = true, w2 = true;
	                    e2 = null;
	                    var p2 = true, v = "rgba", m2 = "uint8", r2 = 1, C2 = null, q2 = null, pa = null, ga = false;
	                    if ("number" === typeof a3) f2 = a3 | 0, g2 = b3 | 0 || f2;
	                    else if (a3) {
	                      "shape" in a3 ? (g2 = a3.shape, f2 = g2[0], g2 = g2[1]) : ("radius" in a3 && (f2 = g2 = a3.radius), "width" in a3 && (f2 = a3.width), "height" in a3 && (g2 = a3.height));
	                      if ("color" in a3 || "colors" in a3) e2 = a3.color || a3.colors;
	                      if (!e2) {
	                        "colorCount" in a3 && (r2 = a3.colorCount | 0);
	                        "colorTexture" in a3 && (p2 = !!a3.colorTexture, v = "rgba4");
	                        if ("colorType" in a3 && (m2 = a3.colorType, !p2)) {
	                          if ("half float" === m2 || "float16" === m2) v = "rgba16f";
	                          else if ("float" === m2 || "float32" === m2) v = "rgba32f";
	                        }
	                        "colorFormat" in a3 && (v = a3.colorFormat, 0 <= z.indexOf(v) ? p2 = true : 0 <= wa.indexOf(v) && (p2 = false));
	                      }
	                      if ("depthTexture" in a3 || "depthStencilTexture" in a3) ga = !(!a3.depthTexture && !a3.depthStencilTexture);
	                      "depth" in a3 && ("boolean" === typeof a3.depth ? l2 = a3.depth : (C2 = a3.depth, w2 = false));
	                      "stencil" in a3 && ("boolean" === typeof a3.stencil ? w2 = a3.stencil : (q2 = a3.stencil, l2 = false));
	                      "depthStencil" in a3 && ("boolean" === typeof a3.depthStencil ? l2 = w2 = a3.depthStencil : (pa = a3.depthStencil, w2 = l2 = false));
	                    } else f2 = g2 = 1;
	                    var D2 = null, ba = null, E3 = null, B3 = null;
	                    if (Array.isArray(e2)) D2 = e2.map(k);
	                    else if (e2) D2 = [k(e2)];
	                    else for (D2 = Array(r2), e2 = 0; e2 < r2; ++e2) D2[e2] = n(f2, g2, p2, v, m2);
	                    f2 = f2 || D2[0].width;
	                    g2 = g2 || D2[0].height;
	                    C2 ? ba = k(C2) : l2 && !w2 && (ba = n(f2, g2, ga, "depth", "uint32"));
	                    q2 ? E3 = k(q2) : w2 && !l2 && (E3 = n(f2, g2, false, "stencil", "uint8"));
	                    pa ? B3 = k(pa) : !C2 && !q2 && w2 && l2 && (B3 = n(f2, g2, ga, "depth stencil", "depth stencil"));
	                    l2 = null;
	                    for (e2 = 0; e2 < D2.length; ++e2) u(D2[e2]), D2[e2] && D2[e2].texture && (w2 = Ya[D2[e2].texture._texture.format] * Ra[D2[e2].texture._texture.type], null === l2 && (l2 = w2));
	                    u(ba);
	                    u(E3);
	                    u(B3);
	                    h(d2);
	                    d2.width = f2;
	                    d2.height = g2;
	                    d2.colorAttachments = D2;
	                    d2.depthAttachment = ba;
	                    d2.stencilAttachment = E3;
	                    d2.depthStencilAttachment = B3;
	                    c2.color = D2.map(t);
	                    c2.depth = t(ba);
	                    c2.stencil = t(E3);
	                    c2.depthStencil = t(B3);
	                    c2.width = d2.width;
	                    c2.height = d2.height;
	                    y(d2);
	                    return c2;
	                  }
	                  var d2 = new l();
	                  e.framebufferCount++;
	                  c2(a2, b2);
	                  return O(c2, { resize: function(a3, b3) {
	                    var e2 = Math.max(a3 | 0, 1), f2 = Math.max(b3 | 0 || e2, 1);
	                    if (e2 === d2.width && f2 === d2.height) return c2;
	                    for (var h2 = d2.colorAttachments, l2 = 0; l2 < h2.length; ++l2) g(h2[l2], e2, f2);
	                    g(d2.depthAttachment, e2, f2);
	                    g(
	                      d2.stencilAttachment,
	                      e2,
	                      f2
	                    );
	                    g(d2.depthStencilAttachment, e2, f2);
	                    d2.width = c2.width = e2;
	                    d2.height = c2.height = f2;
	                    y(d2);
	                    return c2;
	                  }, _reglType: "framebuffer", _framebuffer: d2, destroy: function() {
	                    p(d2);
	                    h(d2);
	                  }, use: function(a3) {
	                    w.setFBO({ framebuffer: c2 }, a3);
	                  } });
	                }
	                var w = { cur: null, next: null, dirty: false, setFBO: null }, z = ["rgba"], wa = ["rgba4", "rgb565", "rgb5 a1"];
	                b.ext_srgb && wa.push("srgba");
	                b.ext_color_buffer_half_float && wa.push("rgba16f", "rgb16f");
	                b.webgl_color_buffer_float && wa.push("rgba32f");
	                var E2 = ["uint8"];
	                b.oes_texture_half_float && E2.push("half float", "float16");
	                b.oes_texture_float && E2.push("float", "float32");
	                var B2 = 0, D = {};
	                return O(w, {
	                  getFramebuffer: function(a2) {
	                    return "function" === typeof a2 && "framebuffer" === a2._reglType && (a2 = a2._framebuffer, a2 instanceof l) ? a2 : null;
	                  },
	                  create: C,
	                  createCube: function(a2) {
	                    function b2(a3) {
	                      var e2, f2 = { color: null }, g2 = 0, h2 = null;
	                      e2 = "rgba";
	                      var l2 = "uint8", k2 = 1;
	                      if ("number" === typeof a3) g2 = a3 | 0;
	                      else if (a3) {
	                        "shape" in a3 ? g2 = a3.shape[0] : ("radius" in a3 && (g2 = a3.radius | 0), "width" in a3 ? g2 = a3.width | 0 : "height" in a3 && (g2 = a3.height | 0));
	                        if ("color" in a3 || "colors" in a3) h2 = a3.color || a3.colors;
	                        h2 || ("colorCount" in a3 && (k2 = a3.colorCount | 0), "colorType" in a3 && (l2 = a3.colorType), "colorFormat" in a3 && (e2 = a3.colorFormat));
	                        "depth" in a3 && (f2.depth = a3.depth);
	                        "stencil" in a3 && (f2.stencil = a3.stencil);
	                        "depthStencil" in a3 && (f2.depthStencil = a3.depthStencil);
	                      } else g2 = 1;
	                      if (h2) if (Array.isArray(h2)) for (a3 = [], e2 = 0; e2 < h2.length; ++e2) a3[e2] = h2[e2];
	                      else a3 = [h2];
	                      else for (a3 = Array(k2), h2 = { radius: g2, format: e2, type: l2 }, e2 = 0; e2 < k2; ++e2) a3[e2] = d.createCube(h2);
	                      f2.color = Array(a3.length);
	                      for (e2 = 0; e2 < a3.length; ++e2) k2 = a3[e2], g2 = g2 || k2.width, f2.color[e2] = {
	                        target: 34069,
	                        data: a3[e2]
	                      };
	                      for (e2 = 0; 6 > e2; ++e2) {
	                        for (k2 = 0; k2 < a3.length; ++k2) f2.color[k2].target = 34069 + e2;
	                        0 < e2 && (f2.depth = c2[0].depth, f2.stencil = c2[0].stencil, f2.depthStencil = c2[0].depthStencil);
	                        if (c2[e2]) c2[e2](f2);
	                        else c2[e2] = C(f2);
	                      }
	                      return O(b2, { width: g2, height: g2, color: a3 });
	                    }
	                    var c2 = Array(6);
	                    b2(a2);
	                    return O(b2, { faces: c2, resize: function(a3) {
	                      var d2 = a3 | 0;
	                      if (d2 === b2.width) return b2;
	                      var e2 = b2.color;
	                      for (a3 = 0; a3 < e2.length; ++a3) e2[a3].resize(d2);
	                      for (a3 = 0; 6 > a3; ++a3) c2[a3].resize(d2);
	                      b2.width = b2.height = d2;
	                      return b2;
	                    }, _reglType: "framebufferCube", destroy: function() {
	                      c2.forEach(function(a3) {
	                        a3.destroy();
	                      });
	                    } });
	                  },
	                  clear: function() {
	                    T(D).forEach(p);
	                  },
	                  restore: function() {
	                    w.cur = null;
	                    w.next = null;
	                    w.dirty = true;
	                    T(D).forEach(function(b2) {
	                      b2.framebuffer = a.createFramebuffer();
	                      y(b2);
	                    });
	                  }
	                });
	              }
	              function Za() {
	                this.w = this.z = this.y = this.x = this.state = 0;
	                this.buffer = null;
	                this.size = 0;
	                this.normalized = false;
	                this.type = 5126;
	                this.divisor = this.stride = this.offset = 0;
	              }
	              function Rb(a, b, c, d, f, e, m) {
	                function q(a2) {
	                  if (a2 !== p.currentVAO) {
	                    var c2 = b.oes_vertex_array_object;
	                    a2 ? c2.bindVertexArrayOES(a2.vao) : c2.bindVertexArrayOES(null);
	                    p.currentVAO = a2;
	                  }
	                }
	                function u(c2) {
	                  if (c2 !== p.currentVAO) {
	                    if (c2) c2.bindAttrs();
	                    else {
	                      for (var d2 = b.angle_instanced_arrays, e2 = 0; e2 < g.length; ++e2) {
	                        var f2 = g[e2];
	                        f2.buffer ? (a.enableVertexAttribArray(e2), f2.buffer.bind(), a.vertexAttribPointer(e2, f2.size, f2.type, f2.normalized, f2.stride, f2.offfset), d2 && f2.divisor && d2.vertexAttribDivisorANGLE(e2, f2.divisor)) : (a.disableVertexAttribArray(e2), a.vertexAttrib4f(e2, f2.x, f2.y, f2.z, f2.w));
	                      }
	                      m.elements ? a.bindBuffer(34963, m.elements.buffer.buffer) : a.bindBuffer(34963, null);
	                    }
	                    p.currentVAO = c2;
	                  }
	                }
	                function r() {
	                  T(h).forEach(function(a2) {
	                    a2.destroy();
	                  });
	                }
	                function k() {
	                  this.id = ++l;
	                  this.attributes = [];
	                  this.elements = null;
	                  this.ownsElements = false;
	                  this.offset = this.count = 0;
	                  this.instances = -1;
	                  this.primitive = 4;
	                  var a2 = b.oes_vertex_array_object;
	                  this.vao = a2 ? a2.createVertexArrayOES() : null;
	                  h[this.id] = this;
	                  this.buffers = [];
	                }
	                function n() {
	                  b.oes_vertex_array_object && T(h).forEach(function(a2) {
	                    a2.refresh();
	                  });
	                }
	                var t = c.maxAttributes, g = Array(t);
	                for (c = 0; c < t; ++c) g[c] = new Za();
	                var l = 0, h = {}, p = {
	                  Record: Za,
	                  scope: {},
	                  state: g,
	                  currentVAO: null,
	                  targetVAO: null,
	                  restore: b.oes_vertex_array_object ? n : function() {
	                  },
	                  createVAO: function(a2) {
	                    function b2(a3) {
	                      var d2;
	                      Array.isArray(a3) ? (d2 = a3, c2.elements && c2.ownsElements && c2.elements.destroy(), c2.elements = null, c2.ownsElements = false, c2.offset = 0, c2.count = 0, c2.instances = -1, c2.primitive = 4) : (a3.elements ? (d2 = a3.elements, c2.ownsElements ? ("function" === typeof d2 && "elements" === d2._reglType ? c2.elements.destroy() : c2.elements(d2), c2.ownsElements = false) : e.getElements(a3.elements) ? (c2.elements = a3.elements, c2.ownsElements = false) : (c2.elements = e.create(a3.elements), c2.ownsElements = true)) : (c2.elements = null, c2.ownsElements = false), d2 = a3.attributes, c2.offset = 0, c2.count = -1, c2.instances = -1, c2.primitive = 4, c2.elements && (c2.count = c2.elements._elements.vertCount, c2.primitive = c2.elements._elements.primType), "offset" in a3 && (c2.offset = a3.offset | 0), "count" in a3 && (c2.count = a3.count | 0), "instances" in a3 && (c2.instances = a3.instances | 0), "primitive" in a3 && (c2.primitive = Ka[a3.primitive]));
	                      a3 = {};
	                      var g2 = c2.attributes;
	                      g2.length = d2.length;
	                      for (var h2 = 0; h2 < d2.length; ++h2) {
	                        var l2 = d2[h2], k2 = g2[h2] = new Za(), n2 = l2.data || l2;
	                        if (Array.isArray(n2) || P(n2) || fa(n2)) {
	                          var p2;
	                          c2.buffers[h2] && (p2 = c2.buffers[h2], P(n2) && p2._buffer.byteLength >= n2.byteLength ? p2.subdata(n2) : (p2.destroy(), c2.buffers[h2] = null));
	                          c2.buffers[h2] || (p2 = c2.buffers[h2] = f.create(l2, 34962, false, true));
	                          k2.buffer = f.getBuffer(p2);
	                          k2.size = k2.buffer.dimension | 0;
	                          k2.normalized = false;
	                          k2.type = k2.buffer.dtype;
	                          k2.offset = 0;
	                          k2.stride = 0;
	                          k2.divisor = 0;
	                          k2.state = 1;
	                          a3[h2] = 1;
	                        } else f.getBuffer(l2) ? (k2.buffer = f.getBuffer(l2), k2.size = k2.buffer.dimension | 0, k2.normalized = false, k2.type = k2.buffer.dtype, k2.offset = 0, k2.stride = 0, k2.divisor = 0, k2.state = 1) : f.getBuffer(l2.buffer) ? (k2.buffer = f.getBuffer(l2.buffer), k2.size = (+l2.size || k2.buffer.dimension) | 0, k2.normalized = !!l2.normalized || false, k2.type = "type" in l2 ? Ja[l2.type] : k2.buffer.dtype, k2.offset = (l2.offset || 0) | 0, k2.stride = (l2.stride || 0) | 0, k2.divisor = (l2.divisor || 0) | 0, k2.state = 1) : "x" in l2 && (k2.x = +l2.x || 0, k2.y = +l2.y || 0, k2.z = +l2.z || 0, k2.w = +l2.w || 0, k2.state = 2);
	                      }
	                      for (p2 = 0; p2 < c2.buffers.length; ++p2) !a3[p2] && c2.buffers[p2] && (c2.buffers[p2].destroy(), c2.buffers[p2] = null);
	                      c2.refresh();
	                      return b2;
	                    }
	                    var c2 = new k();
	                    d.vaoCount += 1;
	                    b2.destroy = function() {
	                      for (var a3 = 0; a3 < c2.buffers.length; ++a3) c2.buffers[a3] && c2.buffers[a3].destroy();
	                      c2.buffers.length = 0;
	                      c2.ownsElements && (c2.elements.destroy(), c2.elements = null, c2.ownsElements = false);
	                      c2.destroy();
	                    };
	                    b2._vao = c2;
	                    b2._reglType = "vao";
	                    return b2(a2);
	                  },
	                  getVAO: function(a2) {
	                    return "function" === typeof a2 && a2._vao ? a2._vao : null;
	                  },
	                  destroyBuffer: function(b2) {
	                    for (var c2 = 0; c2 < g.length; ++c2) {
	                      var d2 = g[c2];
	                      d2.buffer === b2 && (a.disableVertexAttribArray(c2), d2.buffer = null);
	                    }
	                  },
	                  setVAO: b.oes_vertex_array_object ? q : u,
	                  clear: b.oes_vertex_array_object ? r : function() {
	                  }
	                };
	                k.prototype.bindAttrs = function() {
	                  for (var c2 = b.angle_instanced_arrays, d2 = this.attributes, f2 = 0; f2 < d2.length; ++f2) {
	                    var g2 = d2[f2];
	                    g2.buffer ? (a.enableVertexAttribArray(f2), a.bindBuffer(34962, g2.buffer.buffer), a.vertexAttribPointer(f2, g2.size, g2.type, g2.normalized, g2.stride, g2.offset), c2 && g2.divisor && c2.vertexAttribDivisorANGLE(f2, g2.divisor)) : (a.disableVertexAttribArray(f2), a.vertexAttrib4f(f2, g2.x, g2.y, g2.z, g2.w));
	                  }
	                  for (c2 = d2.length; c2 < t; ++c2) a.disableVertexAttribArray(c2);
	                  (c2 = e.getElements(this.elements)) ? a.bindBuffer(34963, c2.buffer.buffer) : a.bindBuffer(34963, null);
	                };
	                k.prototype.refresh = function() {
	                  var a2 = b.oes_vertex_array_object;
	                  a2 && (a2.bindVertexArrayOES(this.vao), this.bindAttrs(), p.currentVAO = null, a2.bindVertexArrayOES(null));
	                };
	                k.prototype.destroy = function() {
	                  if (this.vao) {
	                    var a2 = b.oes_vertex_array_object;
	                    this === p.currentVAO && (p.currentVAO = null, a2.bindVertexArrayOES(null));
	                    a2.deleteVertexArrayOES(this.vao);
	                    this.vao = null;
	                  }
	                  this.ownsElements && (this.elements.destroy(), this.elements = null, this.ownsElements = false);
	                  h[this.id] && (delete h[this.id], --d.vaoCount);
	                };
	                return p;
	              }
	              function Sb(a, b, c, d) {
	                function f(a2, b2, c2, d2) {
	                  this.name = a2;
	                  this.id = b2;
	                  this.location = c2;
	                  this.info = d2;
	                }
	                function e(a2, b2) {
	                  for (var c2 = 0; c2 < a2.length; ++c2) if (a2[c2].id === b2.id) {
	                    a2[c2].location = b2.location;
	                    return;
	                  }
	                  a2.push(b2);
	                }
	                function m(c2, d2, e2) {
	                  e2 = 35632 === c2 ? r : k;
	                  var f2 = e2[d2];
	                  if (!f2) {
	                    var g2 = b.str(d2), f2 = a.createShader(c2);
	                    a.shaderSource(f2, g2);
	                    a.compileShader(f2);
	                    e2[d2] = f2;
	                  }
	                  return f2;
	                }
	                function q(a2, b2) {
	                  this.id = g++;
	                  this.fragId = a2;
	                  this.vertId = b2;
	                  this.program = null;
	                  this.uniforms = [];
	                  this.attributes = [];
	                  this.refCount = 1;
	                  d.profile && (this.stats = { uniformsCount: 0, attributesCount: 0 });
	                }
	                function u(c2, g2, k2) {
	                  var n2;
	                  n2 = m(35632, c2.fragId);
	                  var t2 = m(35633, c2.vertId);
	                  g2 = c2.program = a.createProgram();
	                  a.attachShader(g2, n2);
	                  a.attachShader(g2, t2);
	                  if (k2) for (n2 = 0; n2 < k2.length; ++n2) t2 = k2[n2], a.bindAttribLocation(g2, t2[0], t2[1]);
	                  a.linkProgram(g2);
	                  t2 = a.getProgramParameter(g2, 35718);
	                  d.profile && (c2.stats.uniformsCount = t2);
	                  var r2 = c2.uniforms;
	                  for (n2 = 0; n2 < t2; ++n2) if (k2 = a.getActiveUniform(g2, n2)) if (1 < k2.size) for (var q2 = 0; q2 < k2.size; ++q2) {
	                    var u2 = k2.name.replace("[0]", "[" + q2 + "]");
	                    e(r2, new f(u2, b.id(u2), a.getUniformLocation(g2, u2), k2));
	                  }
	                  else e(r2, new f(k2.name, b.id(k2.name), a.getUniformLocation(g2, k2.name), k2));
	                  t2 = a.getProgramParameter(g2, 35721);
	                  d.profile && (c2.stats.attributesCount = t2);
	                  c2 = c2.attributes;
	                  for (n2 = 0; n2 < t2; ++n2) (k2 = a.getActiveAttrib(g2, n2)) && e(c2, new f(k2.name, b.id(k2.name), a.getAttribLocation(g2, k2.name), k2));
	                }
	                var r = {}, k = {}, n = {}, t = [], g = 0;
	                d.profile && (c.getMaxUniformsCount = function() {
	                  var a2 = 0;
	                  t.forEach(function(b2) {
	                    b2.stats.uniformsCount > a2 && (a2 = b2.stats.uniformsCount);
	                  });
	                  return a2;
	                }, c.getMaxAttributesCount = function() {
	                  var a2 = 0;
	                  t.forEach(function(b2) {
	                    b2.stats.attributesCount > a2 && (a2 = b2.stats.attributesCount);
	                  });
	                  return a2;
	                });
	                return { clear: function() {
	                  var b2 = a.deleteShader.bind(a);
	                  T(r).forEach(b2);
	                  r = {};
	                  T(k).forEach(b2);
	                  k = {};
	                  t.forEach(function(b3) {
	                    a.deleteProgram(b3.program);
	                  });
	                  t.length = 0;
	                  n = {};
	                  c.shaderCount = 0;
	                }, program: function(b2, d2, e2, f2) {
	                  var g2 = n[d2];
	                  g2 || (g2 = n[d2] = {});
	                  var m2 = g2[b2];
	                  if (m2 && (m2.refCount++, !f2)) return m2;
	                  var z = new q(d2, b2);
	                  c.shaderCount++;
	                  u(z, e2, f2);
	                  m2 || (g2[b2] = z);
	                  t.push(z);
	                  return O(z, { destroy: function() {
	                    z.refCount--;
	                    if (0 >= z.refCount) {
	                      a.deleteProgram(z.program);
	                      var b3 = t.indexOf(z);
	                      t.splice(b3, 1);
	                      c.shaderCount--;
	                    }
	                    0 >= g2[z.vertId].refCount && (a.deleteShader(k[z.vertId]), delete k[z.vertId], delete n[z.fragId][z.vertId]);
	                    Object.keys(n[z.fragId]).length || (a.deleteShader(r[z.fragId]), delete r[z.fragId], delete n[z.fragId]);
	                  } });
	                }, restore: function() {
	                  r = {};
	                  k = {};
	                  for (var a2 = 0; a2 < t.length; ++a2) u(t[a2], null, t[a2].attributes.map(function(a3) {
	                    return [a3.location, a3.name];
	                  }));
	                }, shader: m, frag: -1, vert: -1 };
	              }
	              function Tb(a, b, c, d, f, e, m) {
	                function q(e2) {
	                  var f2;
	                  f2 = null === b.next ? 5121 : b.next.colorAttachments[0].texture._texture.type;
	                  var n = 0, t = 0, g = d.framebufferWidth, l = d.framebufferHeight, h = null;
	                  P(e2) ? h = e2 : e2 && (n = e2.x | 0, t = e2.y | 0, g = (e2.width || d.framebufferWidth - n) | 0, l = (e2.height || d.framebufferHeight - t) | 0, h = e2.data || null);
	                  c();
	                  e2 = g * l * 4;
	                  h || (5121 === f2 ? h = new Uint8Array(e2) : 5126 === f2 && (h = h || new Float32Array(e2)));
	                  a.pixelStorei(3333, 4);
	                  a.readPixels(n, t, g, l, 6408, f2, h);
	                  return h;
	                }
	                function u(a2) {
	                  var c2;
	                  b.setFBO({ framebuffer: a2.framebuffer }, function() {
	                    c2 = q(a2);
	                  });
	                  return c2;
	                }
	                return function(a2) {
	                  return a2 && "framebuffer" in a2 ? u(a2) : q(a2);
	                };
	              }
	              function Ub(a) {
	                for (var b = Array(a.length >> 2), c = 0; c < b.length; c++) b[c] = 0;
	                for (c = 0; c < 8 * a.length; c += 8) b[c >> 5] |= (a.charCodeAt(c / 8) & 255) << 24 - c % 32;
	                var d = 8 * a.length;
	                a = [
	                  1779033703,
	                  -1150833019,
	                  1013904242,
	                  -1521486534,
	                  1359893119,
	                  -1694144372,
	                  528734635,
	                  1541459225
	                ];
	                var c = Array(64), f, e, m, q, u, r, k, n, t, g, l;
	                b[d >> 5] |= 128 << 24 - d % 32;
	                b[(d + 64 >> 9 << 4) + 15] = d;
	                for (n = 0; n < b.length; n += 16) {
	                  d = a[0];
	                  f = a[1];
	                  e = a[2];
	                  m = a[3];
	                  q = a[4];
	                  u = a[5];
	                  r = a[6];
	                  k = a[7];
	                  for (t = 0; 64 > t; t++) {
	                    if (16 > t) c[t] = b[t + n];
	                    else {
	                      g = t;
	                      l = c[t - 2];
	                      l = Y(l, 17) ^ Y(l, 19) ^ l >>> 10;
	                      l = H(l, c[t - 7]);
	                      var h;
	                      h = c[t - 15];
	                      h = Y(h, 7) ^ Y(h, 18) ^ h >>> 3;
	                      c[g] = H(H(l, h), c[t - 16]);
	                    }
	                    g = q;
	                    g = Y(g, 6) ^ Y(g, 11) ^ Y(g, 25);
	                    g = H(H(H(H(k, g), q & u ^ ~q & r), Vb[t]), c[t]);
	                    k = d;
	                    k = Y(k, 2) ^ Y(k, 13) ^ Y(k, 22);
	                    l = H(k, d & f ^ d & e ^ f & e);
	                    k = r;
	                    r = u;
	                    u = q;
	                    q = H(m, g);
	                    m = e;
	                    e = f;
	                    f = d;
	                    d = H(g, l);
	                  }
	                  a[0] = H(d, a[0]);
	                  a[1] = H(f, a[1]);
	                  a[2] = H(e, a[2]);
	                  a[3] = H(m, a[3]);
	                  a[4] = H(q, a[4]);
	                  a[5] = H(u, a[5]);
	                  a[6] = H(r, a[6]);
	                  a[7] = H(k, a[7]);
	                }
	                b = "";
	                for (c = 0; c < 32 * a.length; c += 8) b += String.fromCharCode(a[c >> 5] >>> 24 - c % 32 & 255);
	                return b;
	              }
	              function Wb(a) {
	                for (var b = "", c, d = 0; d < a.length; d++) c = a.charCodeAt(d), b += "0123456789abcdef".charAt(c >>> 4 & 15) + "0123456789abcdef".charAt(c & 15);
	                return b;
	              }
	              function Xb(a) {
	                for (var b = "", c = -1, d, f; ++c < a.length; ) d = a.charCodeAt(c), f = c + 1 < a.length ? a.charCodeAt(c + 1) : 0, 55296 <= d && 56319 >= d && 56320 <= f && 57343 >= f && (d = 65536 + ((d & 1023) << 10) + (f & 1023), c++), 127 >= d ? b += String.fromCharCode(d) : 2047 >= d ? b += String.fromCharCode(192 | d >>> 6 & 31, 128 | d & 63) : 65535 >= d ? b += String.fromCharCode(224 | d >>> 12 & 15, 128 | d >>> 6 & 63, 128 | d & 63) : 2097151 >= d && (b += String.fromCharCode(240 | d >>> 18 & 7, 128 | d >>> 12 & 63, 128 | d >>> 6 & 63, 128 | d & 63));
	                return b;
	              }
	              function Y(a, b) {
	                return a >>> b | a << 32 - b;
	              }
	              function H(a, b) {
	                var c = (a & 65535) + (b & 65535);
	                return (a >> 16) + (b >> 16) + (c >> 16) << 16 | c & 65535;
	              }
	              function Aa(a) {
	                return Array.prototype.slice.call(a);
	              }
	              function Ba(a) {
	                return Aa(a).join("");
	              }
	              function Yb(a) {
	                function b() {
	                  var a2 = [], b2 = [];
	                  return O(function() {
	                    a2.push.apply(a2, Aa(arguments));
	                  }, { def: function() {
	                    var c2 = "v" + f++;
	                    b2.push(c2);
	                    0 < arguments.length && (a2.push(c2, "="), a2.push.apply(a2, Aa(arguments)), a2.push(";"));
	                    return c2;
	                  }, toString: function() {
	                    return Ba([0 < b2.length ? "var " + b2.join(",") + ";" : "", Ba(a2)]);
	                  } });
	                }
	                function c() {
	                  function a2(b2, e3) {
	                    d2(b2, e3, "=", c2.def(b2, e3), ";");
	                  }
	                  var c2 = b(), d2 = b(), e2 = c2.toString, f2 = d2.toString;
	                  return O(function() {
	                    c2.apply(c2, Aa(arguments));
	                  }, { def: c2.def, entry: c2, exit: d2, save: a2, set: function(b2, d3, e3) {
	                    a2(b2, d3);
	                    c2(b2, d3, "=", e3, ";");
	                  }, toString: function() {
	                    return e2() + f2();
	                  } });
	                }
	                var d = a.cache, f = 0, e = [], m = [], q = [], u = b(), r = {};
	                return {
	                  global: u,
	                  link: function(a2, b2) {
	                    var c2 = b2 && b2.stable;
	                    if (!c2) {
	                      for (var d2 = 0; d2 < m.length; ++d2) if (m[d2] === a2 && !q[d2]) return e[d2];
	                    }
	                    d2 = "g" + f++;
	                    e.push(d2);
	                    m.push(a2);
	                    q.push(c2);
	                    return d2;
	                  },
	                  block: b,
	                  proc: function(a2, b2) {
	                    function d2() {
	                      var a3 = "a" + e2.length;
	                      e2.push(a3);
	                      return a3;
	                    }
	                    var e2 = [];
	                    b2 = b2 || 0;
	                    for (var f2 = 0; f2 < b2; ++f2) d2();
	                    var f2 = c(), h = f2.toString;
	                    return r[a2] = O(f2, { arg: d2, toString: function() {
	                      return Ba(["function(", e2.join(), "){", h(), "}"]);
	                    } });
	                  },
	                  scope: c,
	                  cond: function() {
	                    var a2 = Ba(arguments), b2 = c(), d2 = c(), e2 = b2.toString, f2 = d2.toString;
	                    return O(b2, { then: function() {
	                      b2.apply(b2, Aa(arguments));
	                      return this;
	                    }, "else": function() {
	                      d2.apply(d2, Aa(arguments));
	                      return this;
	                    }, toString: function() {
	                      var b3 = f2();
	                      b3 && (b3 = "else{" + b3 + "}");
	                      return Ba(["if(", a2, "){", e2(), "}", b3]);
	                    } });
	                  },
	                  compile: function() {
	                    var a2 = ['"use strict";', u, "return {"];
	                    Object.keys(r).forEach(function(b3) {
	                      a2.push('"', b3, '":', r[b3].toString(), ",");
	                    });
	                    a2.push("}");
	                    var b2 = Ba(a2).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(
	                      /{/g,
	                      "{\n"
	                    ), c2;
	                    if (d && (c2 = Wb(Ub(Xb(b2))), d[c2])) return d[c2].apply(null, m);
	                    b2 = Function.apply(null, e.concat(b2));
	                    d && (d[c2] = b2);
	                    return b2.apply(null, m);
	                  }
	                };
	              }
	              function Sa(a) {
	                return Array.isArray(a) || P(a) || fa(a);
	              }
	              function yb(a) {
	                return a.sort(function(a2, c) {
	                  return "viewport" === a2 ? -1 : "viewport" === c ? 1 : a2 < c ? -1 : 1;
	                });
	              }
	              function K(a, b, c, d) {
	                this.thisDep = a;
	                this.contextDep = b;
	                this.propDep = c;
	                this.append = d;
	              }
	              function la(a) {
	                return a && !(a.thisDep || a.contextDep || a.propDep);
	              }
	              function E(a) {
	                return new K(false, false, false, a);
	              }
	              function L(a, b) {
	                var c = a.type;
	                if (0 === c) return c = a.data.length, new K(true, 1 <= c, 2 <= c, b);
	                if (4 === c) return c = a.data, new K(c.thisDep, c.contextDep, c.propDep, b);
	                if (5 === c) return new K(false, false, false, b);
	                if (6 === c) {
	                  for (var d = c = false, f = false, e = 0; e < a.data.length; ++e) {
	                    var m = a.data[e];
	                    1 === m.type ? f = true : 2 === m.type ? d = true : 3 === m.type ? c = true : 0 === m.type ? (c = true, m = m.data, 1 <= m && (d = true), 2 <= m && (f = true)) : 4 === m.type && (c = c || m.data.thisDep, d = d || m.data.contextDep, f = f || m.data.propDep);
	                  }
	                  return new K(c, d, f, b);
	                }
	                return new K(3 === c, 2 === c, 1 === c, b);
	              }
	              function Zb(a, b, c, d, f, e, m, q, u, r, k, n, t, g, l, h) {
	                function p(a2) {
	                  return a2.replace(
	                    ".",
	                    "_"
	                  );
	                }
	                function y(a2, b2, c2) {
	                  var d2 = p(a2);
	                  Ma.push(a2);
	                  Da[d2] = ta[d2] = !!c2;
	                  ua[d2] = b2;
	                }
	                function C(a2, b2, c2) {
	                  var d2 = p(a2);
	                  Ma.push(a2);
	                  Array.isArray(c2) ? (ta[d2] = c2.slice(), Da[d2] = c2.slice()) : ta[d2] = Da[d2] = c2;
	                  ma[d2] = b2;
	                }
	                function w() {
	                  var a2 = Yb({ cache: l }), c2 = a2.link, d2 = a2.global;
	                  a2.id = ra2++;
	                  a2.batchId = "0";
	                  var e2 = c2(tb), f2 = a2.shared = { props: "a0" };
	                  Object.keys(tb).forEach(function(a3) {
	                    f2[a3] = d2.def(e2, ".", a3);
	                  });
	                  var g2 = a2.next = {}, k2 = a2.current = {};
	                  Object.keys(ma).forEach(function(a3) {
	                    Array.isArray(ta[a3]) && (g2[a3] = d2.def(f2.next, ".", a3), k2[a3] = d2.def(f2.current, ".", a3));
	                  });
	                  var ca = a2.constants = {};
	                  Object.keys(Oa).forEach(function(a3) {
	                    ca[a3] = d2.def(JSON.stringify(Oa[a3]));
	                  });
	                  a2.invoke = function(b2, d3) {
	                    switch (d3.type) {
	                      case 0:
	                        var e3 = ["this", f2.context, f2.props, a2.batchId];
	                        return b2.def(c2(d3.data), ".call(", e3.slice(0, Math.max(d3.data.length + 1, 4)), ")");
	                      case 1:
	                        return b2.def(f2.props, d3.data);
	                      case 2:
	                        return b2.def(f2.context, d3.data);
	                      case 3:
	                        return b2.def("this", d3.data);
	                      case 4:
	                        return d3.data.append(a2, b2), d3.data.ref;
	                      case 5:
	                        return d3.data.toString();
	                      case 6:
	                        return d3.data.map(function(c3) {
	                          return a2.invoke(b2, c3);
	                        });
	                    }
	                  };
	                  a2.attribCache = {};
	                  var N = {};
	                  a2.scopeAttrib = function(a3) {
	                    a3 = b.id(a3);
	                    if (a3 in N) return N[a3];
	                    var d3 = r.scope[a3];
	                    d3 || (d3 = r.scope[a3] = new ha());
	                    return N[a3] = c2(d3);
	                  };
	                  return a2;
	                }
	                function z(a2) {
	                  var b2 = a2["static"];
	                  a2 = a2.dynamic;
	                  var c2;
	                  if ("profile" in b2) {
	                    var d2 = !!b2.profile;
	                    c2 = E(function(a3, b3) {
	                      return d2;
	                    });
	                    c2.enable = d2;
	                  } else if ("profile" in a2) {
	                    var e2 = a2.profile;
	                    c2 = L(e2, function(a3, b3) {
	                      return a3.invoke(b3, e2);
	                    });
	                  }
	                  return c2;
	                }
	                function B2(a2, b2) {
	                  var c2 = a2["static"], d2 = a2.dynamic;
	                  if ("framebuffer" in c2) {
	                    var e2 = c2.framebuffer;
	                    return e2 ? (e2 = q.getFramebuffer(e2), E(function(a3, b3) {
	                      var c3 = a3.link(e2), d3 = a3.shared;
	                      b3.set(d3.framebuffer, ".next", c3);
	                      d3 = d3.context;
	                      b3.set(d3, ".framebufferWidth", c3 + ".width");
	                      b3.set(d3, ".framebufferHeight", c3 + ".height");
	                      return c3;
	                    })) : E(function(a3, b3) {
	                      var c3 = a3.shared;
	                      b3.set(c3.framebuffer, ".next", "null");
	                      c3 = c3.context;
	                      b3.set(c3, ".framebufferWidth", c3 + ".drawingBufferWidth");
	                      b3.set(c3, ".framebufferHeight", c3 + ".drawingBufferHeight");
	                      return "null";
	                    });
	                  }
	                  if ("framebuffer" in d2) {
	                    var f2 = d2.framebuffer;
	                    return L(f2, function(a3, b3) {
	                      var c3 = a3.invoke(b3, f2), d3 = a3.shared, e3 = d3.framebuffer, c3 = b3.def(e3, ".getFramebuffer(", c3, ")");
	                      b3.set(
	                        e3,
	                        ".next",
	                        c3
	                      );
	                      d3 = d3.context;
	                      b3.set(d3, ".framebufferWidth", c3 + "?" + c3 + ".width:" + d3 + ".drawingBufferWidth");
	                      b3.set(d3, ".framebufferHeight", c3 + "?" + c3 + ".height:" + d3 + ".drawingBufferHeight");
	                      return c3;
	                    });
	                  }
	                  return null;
	                }
	                function H2(a2, b2, c2) {
	                  function d2(a3) {
	                    if (a3 in e2) {
	                      var c3 = e2[a3];
	                      a3 = true;
	                      var x = c3.x | 0, g3 = c3.y | 0, k2, h2;
	                      "width" in c3 ? k2 = c3.width | 0 : a3 = false;
	                      "height" in c3 ? h2 = c3.height | 0 : a3 = false;
	                      return new K(!a3 && b2 && b2.thisDep, !a3 && b2 && b2.contextDep, !a3 && b2 && b2.propDep, function(a4, b3) {
	                        var d3 = a4.shared.context, e3 = k2;
	                        "width" in c3 || (e3 = b3.def(d3, ".", "framebufferWidth", "-", x));
	                        var f3 = h2;
	                        "height" in c3 || (f3 = b3.def(d3, ".", "framebufferHeight", "-", g3));
	                        return [x, g3, e3, f3];
	                      });
	                    }
	                    if (a3 in f2) {
	                      var aa = f2[a3];
	                      a3 = L(aa, function(a4, b3) {
	                        var c4 = a4.invoke(b3, aa), d3 = a4.shared.context, e3 = b3.def(c4, ".x|0"), f3 = b3.def(c4, ".y|0"), N = b3.def('"width" in ', c4, "?", c4, ".width|0:", "(", d3, ".", "framebufferWidth", "-", e3, ")"), c4 = b3.def('"height" in ', c4, "?", c4, ".height|0:", "(", d3, ".", "framebufferHeight", "-", f3, ")");
	                        return [e3, f3, N, c4];
	                      });
	                      b2 && (a3.thisDep = a3.thisDep || b2.thisDep, a3.contextDep = a3.contextDep || b2.contextDep, a3.propDep = a3.propDep || b2.propDep);
	                      return a3;
	                    }
	                    return b2 ? new K(b2.thisDep, b2.contextDep, b2.propDep, function(a4, b3) {
	                      var c4 = a4.shared.context;
	                      return [0, 0, b3.def(c4, ".", "framebufferWidth"), b3.def(c4, ".", "framebufferHeight")];
	                    }) : null;
	                  }
	                  var e2 = a2["static"], f2 = a2.dynamic;
	                  if (a2 = d2("viewport")) {
	                    var g2 = a2;
	                    a2 = new K(a2.thisDep, a2.contextDep, a2.propDep, function(a3, b3) {
	                      var c3 = g2.append(a3, b3), d3 = a3.shared.context;
	                      b3.set(d3, ".viewportWidth", c3[2]);
	                      b3.set(d3, ".viewportHeight", c3[3]);
	                      return c3;
	                    });
	                  }
	                  return { viewport: a2, scissor_box: d2("scissor.box") };
	                }
	                function G2(a2, b2) {
	                  var c2 = a2["static"];
	                  if ("string" === typeof c2.frag && "string" === typeof c2.vert) {
	                    if (0 < Object.keys(b2.dynamic).length) return null;
	                    var c2 = b2["static"], d2 = Object.keys(c2);
	                    if (0 < d2.length && "number" === typeof c2[d2[0]]) {
	                      for (var e2 = [], f2 = 0; f2 < d2.length; ++f2) e2.push([c2[d2[f2]] | 0, d2[f2]]);
	                      return e2;
	                    }
	                  }
	                  return null;
	                }
	                function D(a2, c2, d2) {
	                  function e2(a3) {
	                    if (a3 in f2) {
	                      var c3 = b.id(f2[a3]);
	                      a3 = E(function() {
	                        return c3;
	                      });
	                      a3.id = c3;
	                      return a3;
	                    }
	                    if (a3 in g2) {
	                      var d3 = g2[a3];
	                      return L(d3, function(a4, b2) {
	                        var c4 = a4.invoke(b2, d3);
	                        return b2.def(a4.shared.strings, ".id(", c4, ")");
	                      });
	                    }
	                    return null;
	                  }
	                  var f2 = a2["static"], g2 = a2.dynamic, h2 = e2("frag"), ca = e2("vert"), N = null;
	                  la(h2) && la(ca) ? (N = k.program(ca.id, h2.id, null, d2), a2 = E(function(a3, b2) {
	                    return a3.link(N);
	                  })) : a2 = new K(h2 && h2.thisDep || ca && ca.thisDep, h2 && h2.contextDep || ca && ca.contextDep, h2 && h2.propDep || ca && ca.propDep, function(a3, b2) {
	                    var c3 = a3.shared.shader, d3;
	                    d3 = h2 ? h2.append(a3, b2) : b2.def(c3, ".", "frag");
	                    var e3;
	                    e3 = ca ? ca.append(a3, b2) : b2.def(c3, ".", "vert");
	                    return b2.def(c3 + ".program(" + e3 + "," + d3 + ")");
	                  });
	                  return { frag: h2, vert: ca, progVar: a2, program: N };
	                }
	                function v(a2, b2) {
	                  function c2(a3, b3) {
	                    if (a3 in d2) {
	                      var e2 = d2[a3] | 0;
	                      b3 ? g2.offset = e2 : g2.instances = e2;
	                      return E(function(a4, c3) {
	                        b3 && (a4.OFFSET = e2);
	                        return e2;
	                      });
	                    }
	                    if (a3 in f2) {
	                      var x = f2[a3];
	                      return L(x, function(a4, c3) {
	                        var d3 = a4.invoke(c3, x);
	                        b3 && (a4.OFFSET = d3);
	                        return d3;
	                      });
	                    }
	                    if (b3) {
	                      if (N) return E(function(a4, b4) {
	                        return a4.OFFSET = 0;
	                      });
	                      if (k2) return new K(h2.thisDep, h2.contextDep, h2.propDep, function(a4, b4) {
	                        return b4.def(a4.shared.vao + ".currentVAO?" + a4.shared.vao + ".currentVAO.offset:0");
	                      });
	                    } else if (k2) return new K(h2.thisDep, h2.contextDep, h2.propDep, function(a4, b4) {
	                      return b4.def(a4.shared.vao + ".currentVAO?" + a4.shared.vao + ".currentVAO.instances:-1");
	                    });
	                    return null;
	                  }
	                  var d2 = a2["static"], f2 = a2.dynamic, g2 = {}, k2 = false, h2 = function() {
	                    if ("vao" in d2) {
	                      var a3 = d2.vao;
	                      null !== a3 && null === r.getVAO(a3) && (a3 = r.createVAO(a3));
	                      k2 = true;
	                      g2.vao = a3;
	                      return E(function(b4) {
	                        var c3 = r.getVAO(a3);
	                        return c3 ? b4.link(c3) : "null";
	                      });
	                    }
	                    if ("vao" in f2) {
	                      k2 = true;
	                      var b3 = f2.vao;
	                      return L(b3, function(a4, c3) {
	                        var d3 = a4.invoke(c3, b3);
	                        return c3.def(a4.shared.vao + ".getVAO(" + d3 + ")");
	                      });
	                    }
	                    return null;
	                  }(), N = false, ia = function() {
	                    if ("elements" in d2) {
	                      var a3 = d2.elements;
	                      g2.elements = a3;
	                      if (Sa(a3)) {
	                        var b3 = g2.elements = e.create(a3, true), a3 = e.getElements(b3);
	                        N = true;
	                      } else a3 && (a3 = e.getElements(a3), N = true);
	                      b3 = E(function(b4, c4) {
	                        if (a3) {
	                          var d3 = b4.link(a3);
	                          return b4.ELEMENTS = d3;
	                        }
	                        return b4.ELEMENTS = null;
	                      });
	                      b3.value = a3;
	                      return b3;
	                    }
	                    if ("elements" in f2) {
	                      N = true;
	                      var c3 = f2.elements;
	                      return L(c3, function(a4, b4) {
	                        var d3 = a4.shared, e2 = d3.isBufferArgs, d3 = d3.elements, f3 = a4.invoke(b4, c3), N2 = b4.def("null"), e2 = b4.def(e2, "(", f3, ")"), f3 = a4.cond(e2).then(N2, "=", d3, ".createStream(", f3, ");")["else"](N2, "=", d3, ".getElements(", f3, ");");
	                        b4.entry(f3);
	                        b4.exit(a4.cond(e2).then(d3, ".destroyStream(", N2, ");"));
	                        return a4.ELEMENTS = N2;
	                      });
	                    }
	                    return k2 ? new K(h2.thisDep, h2.contextDep, h2.propDep, function(a4, b4) {
	                      return b4.def(a4.shared.vao + ".currentVAO?" + a4.shared.elements + ".getElements(" + a4.shared.vao + ".currentVAO.elements):null");
	                    }) : null;
	                  }(), va = c2("offset", true), l2 = function() {
	                    if ("primitive" in d2) {
	                      var a3 = d2.primitive;
	                      g2.primitive = a3;
	                      return E(function(b4, c3) {
	                        return Ka[a3];
	                      });
	                    }
	                    if ("primitive" in f2) {
	                      var b3 = f2.primitive;
	                      return L(b3, function(a4, c3) {
	                        var d3 = a4.constants.primTypes, e2 = a4.invoke(c3, b3);
	                        return c3.def(d3, "[", e2, "]");
	                      });
	                    }
	                    return N ? la(ia) ? ia.value ? E(function(a4, b4) {
	                      return b4.def(a4.ELEMENTS, ".primType");
	                    }) : E(function() {
	                      return 4;
	                    }) : new K(
	                      ia.thisDep,
	                      ia.contextDep,
	                      ia.propDep,
	                      function(a4, b4) {
	                        var c3 = a4.ELEMENTS;
	                        return b4.def(c3, "?", c3, ".primType:", 4);
	                      }
	                    ) : k2 ? new K(h2.thisDep, h2.contextDep, h2.propDep, function(a4, b4) {
	                      return b4.def(a4.shared.vao + ".currentVAO?" + a4.shared.vao + ".currentVAO.primitive:4");
	                    }) : null;
	                  }(), n2 = function() {
	                    if ("count" in d2) {
	                      var a3 = d2.count | 0;
	                      g2.count = a3;
	                      return E(function() {
	                        return a3;
	                      });
	                    }
	                    if ("count" in f2) {
	                      var b3 = f2.count;
	                      return L(b3, function(a4, c3) {
	                        return a4.invoke(c3, b3);
	                      });
	                    }
	                    return N ? la(ia) ? ia ? va ? new K(va.thisDep, va.contextDep, va.propDep, function(a4, b4) {
	                      return b4.def(a4.ELEMENTS, ".vertCount-", a4.OFFSET);
	                    }) : E(function(a4, b4) {
	                      return b4.def(a4.ELEMENTS, ".vertCount");
	                    }) : E(function() {
	                      return -1;
	                    }) : new K(ia.thisDep || va.thisDep, ia.contextDep || va.contextDep, ia.propDep || va.propDep, function(a4, b4) {
	                      var c3 = a4.ELEMENTS;
	                      return a4.OFFSET ? b4.def(c3, "?", c3, ".vertCount-", a4.OFFSET, ":-1") : b4.def(c3, "?", c3, ".vertCount:-1");
	                    }) : k2 ? new K(h2.thisDep, h2.contextDep, h2.propDep, function(a4, b4) {
	                      return b4.def(a4.shared.vao, ".currentVAO?", a4.shared.vao, ".currentVAO.count:-1");
	                    }) : null;
	                  }(), m2 = c2("instances", false);
	                  return {
	                    elements: ia,
	                    primitive: l2,
	                    count: n2,
	                    instances: m2,
	                    offset: va,
	                    vao: h2,
	                    vaoActive: k2,
	                    elementsActive: N,
	                    "static": g2
	                  };
	                }
	                function ba(a2, b2) {
	                  var c2 = a2["static"], d2 = a2.dynamic, e2 = {};
	                  Ma.forEach(function(a3) {
	                    function b3(N, g2) {
	                      if (a3 in c2) {
	                        var x = N(c2[a3]);
	                        e2[f2] = E(function() {
	                          return x;
	                        });
	                      } else if (a3 in d2) {
	                        var F = d2[a3];
	                        e2[f2] = L(F, function(a4, b4) {
	                          return g2(a4, b4, a4.invoke(b4, F));
	                        });
	                      }
	                    }
	                    var f2 = p(a3);
	                    switch (a3) {
	                      case "cull.enable":
	                      case "blend.enable":
	                      case "dither":
	                      case "stencil.enable":
	                      case "depth.enable":
	                      case "scissor.enable":
	                      case "polygonOffset.enable":
	                      case "sample.alpha":
	                      case "sample.enable":
	                      case "depth.mask":
	                        return b3(
	                          function(a4) {
	                            return a4;
	                          },
	                          function(a4, b4, c3) {
	                            return c3;
	                          }
	                        );
	                      case "depth.func":
	                        return b3(function(a4) {
	                          return $a[a4];
	                        }, function(a4, b4, c3) {
	                          return b4.def(a4.constants.compareFuncs, "[", c3, "]");
	                        });
	                      case "depth.range":
	                        return b3(function(a4) {
	                          return a4;
	                        }, function(a4, b4, c3) {
	                          a4 = b4.def("+", c3, "[0]");
	                          b4 = b4.def("+", c3, "[1]");
	                          return [a4, b4];
	                        });
	                      case "blend.func":
	                        return b3(function(a4) {
	                          return [Ga["srcRGB" in a4 ? a4.srcRGB : a4.src], Ga["dstRGB" in a4 ? a4.dstRGB : a4.dst], Ga["srcAlpha" in a4 ? a4.srcAlpha : a4.src], Ga["dstAlpha" in a4 ? a4.dstAlpha : a4.dst]];
	                        }, function(a4, b4, c3) {
	                          function d3(a5, e4) {
	                            return b4.def(
	                              '"',
	                              a5,
	                              e4,
	                              '" in ',
	                              c3,
	                              "?",
	                              c3,
	                              ".",
	                              a5,
	                              e4,
	                              ":",
	                              c3,
	                              ".",
	                              a5
	                            );
	                          }
	                          a4 = a4.constants.blendFuncs;
	                          var e3 = d3("src", "RGB"), f3 = d3("dst", "RGB"), e3 = b4.def(a4, "[", e3, "]"), g2 = b4.def(a4, "[", d3("src", "Alpha"), "]"), f3 = b4.def(a4, "[", f3, "]");
	                          a4 = b4.def(a4, "[", d3("dst", "Alpha"), "]");
	                          return [e3, f3, g2, a4];
	                        });
	                      case "blend.equation":
	                        return b3(function(a4) {
	                          if ("string" === typeof a4) return [X[a4], X[a4]];
	                          if ("object" === typeof a4) return [X[a4.rgb], X[a4.alpha]];
	                        }, function(a4, b4, c3) {
	                          var d3 = a4.constants.blendEquations, e3 = b4.def(), f3 = b4.def();
	                          a4 = a4.cond("typeof ", c3, '==="string"');
	                          a4.then(
	                            e3,
	                            "=",
	                            f3,
	                            "=",
	                            d3,
	                            "[",
	                            c3,
	                            "];"
	                          );
	                          a4["else"](e3, "=", d3, "[", c3, ".rgb];", f3, "=", d3, "[", c3, ".alpha];");
	                          b4(a4);
	                          return [e3, f3];
	                        });
	                      case "blend.color":
	                        return b3(function(a4) {
	                          return S(4, function(b4) {
	                            return +a4[b4];
	                          });
	                        }, function(a4, b4, c3) {
	                          return S(4, function(a5) {
	                            return b4.def("+", c3, "[", a5, "]");
	                          });
	                        });
	                      case "stencil.mask":
	                        return b3(function(a4) {
	                          return a4 | 0;
	                        }, function(a4, b4, c3) {
	                          return b4.def(c3, "|0");
	                        });
	                      case "stencil.func":
	                        return b3(function(a4) {
	                          return [$a[a4.cmp || "keep"], a4.ref || 0, "mask" in a4 ? a4.mask : -1];
	                        }, function(a4, b4, c3) {
	                          a4 = b4.def(
	                            '"cmp" in ',
	                            c3,
	                            "?",
	                            a4.constants.compareFuncs,
	                            "[",
	                            c3,
	                            ".cmp]",
	                            ":",
	                            7680
	                          );
	                          var d3 = b4.def(c3, ".ref|0");
	                          b4 = b4.def('"mask" in ', c3, "?", c3, ".mask|0:-1");
	                          return [a4, d3, b4];
	                        });
	                      case "stencil.opFront":
	                      case "stencil.opBack":
	                        return b3(function(b4) {
	                          return ["stencil.opBack" === a3 ? 1029 : 1028, Ta[b4.fail || "keep"], Ta[b4.zfail || "keep"], Ta[b4.zpass || "keep"]];
	                        }, function(b4, c3, d3) {
	                          function e3(a4) {
	                            return c3.def('"', a4, '" in ', d3, "?", f3, "[", d3, ".", a4, "]:", 7680);
	                          }
	                          var f3 = b4.constants.stencilOps;
	                          return ["stencil.opBack" === a3 ? 1029 : 1028, e3("fail"), e3("zfail"), e3("zpass")];
	                        });
	                      case "polygonOffset.offset":
	                        return b3(function(a4) {
	                          return [a4.factor | 0, a4.units | 0];
	                        }, function(a4, b4, c3) {
	                          a4 = b4.def(c3, ".factor|0");
	                          b4 = b4.def(c3, ".units|0");
	                          return [a4, b4];
	                        });
	                      case "cull.face":
	                        return b3(function(a4) {
	                          var b4 = 0;
	                          "front" === a4 ? b4 = 1028 : "back" === a4 && (b4 = 1029);
	                          return b4;
	                        }, function(a4, b4, c3) {
	                          return b4.def(c3, '==="front"?', 1028, ":", 1029);
	                        });
	                      case "lineWidth":
	                        return b3(function(a4) {
	                          return a4;
	                        }, function(a4, b4, c3) {
	                          return c3;
	                        });
	                      case "frontFace":
	                        return b3(function(a4) {
	                          return zb[a4];
	                        }, function(a4, b4, c3) {
	                          return b4.def(c3 + '==="cw"?2304:2305');
	                        });
	                      case "colorMask":
	                        return b3(
	                          function(a4) {
	                            return a4.map(function(a5) {
	                              return !!a5;
	                            });
	                          },
	                          function(a4, b4, c3) {
	                            return S(4, function(a5) {
	                              return "!!" + c3 + "[" + a5 + "]";
	                            });
	                          }
	                        );
	                      case "sample.coverage":
	                        return b3(function(a4) {
	                          return ["value" in a4 ? a4.value : 1, !!a4.invert];
	                        }, function(a4, b4, c3) {
	                          a4 = b4.def('"value" in ', c3, "?+", c3, ".value:1");
	                          b4 = b4.def("!!", c3, ".invert");
	                          return [a4, b4];
	                        });
	                    }
	                  });
	                  return e2;
	                }
	                function P2(a2, b2) {
	                  var c2 = a2["static"], d2 = a2.dynamic, e2 = {};
	                  Object.keys(c2).forEach(function(a3) {
	                    var b3 = c2[a3], d3;
	                    if ("number" === typeof b3 || "boolean" === typeof b3) d3 = E(function() {
	                      return b3;
	                    });
	                    else if ("function" === typeof b3) {
	                      var f2 = b3._reglType;
	                      if ("texture2d" === f2 || "textureCube" === f2) d3 = E(function(a4) {
	                        return a4.link(b3);
	                      });
	                      else if ("framebuffer" === f2 || "framebufferCube" === f2) d3 = E(function(a4) {
	                        return a4.link(b3.color[0]);
	                      });
	                    } else qa(b3) && (d3 = E(function(a4) {
	                      return a4.global.def("[", S(b3.length, function(a5) {
	                        return b3[a5];
	                      }), "]");
	                    }));
	                    d3.value = b3;
	                    e2[a3] = d3;
	                  });
	                  Object.keys(d2).forEach(function(a3) {
	                    var b3 = d2[a3];
	                    e2[a3] = L(b3, function(a4, c3) {
	                      return a4.invoke(c3, b3);
	                    });
	                  });
	                  return e2;
	                }
	                function A(a2, c2) {
	                  var d2 = a2["static"], e2 = a2.dynamic, g2 = {};
	                  Object.keys(d2).forEach(function(a3) {
	                    var c3 = d2[a3], e3 = b.id(a3), x = new ha();
	                    if (Sa(c3)) x.state = 1, x.buffer = f.getBuffer(f.create(c3, 34962, false, true)), x.type = 0;
	                    else {
	                      var F = f.getBuffer(c3);
	                      if (F) x.state = 1, x.buffer = F, x.type = 0;
	                      else if ("constant" in c3) {
	                        var h2 = c3.constant;
	                        x.buffer = "null";
	                        x.state = 2;
	                        "number" === typeof h2 ? x.x = h2 : Ca.forEach(function(a4, b2) {
	                          b2 < h2.length && (x[a4] = h2[b2]);
	                        });
	                      } else {
	                        var F = Sa(c3.buffer) ? f.getBuffer(f.create(c3.buffer, 34962, false, true)) : f.getBuffer(c3.buffer), k2 = c3.offset | 0, l2 = c3.stride | 0, n2 = c3.size | 0, Fa = !!c3.normalized, m2 = 0;
	                        "type" in c3 && (m2 = Ja[c3.type]);
	                        c3 = c3.divisor | 0;
	                        x.buffer = F;
	                        x.state = 1;
	                        x.size = n2;
	                        x.normalized = Fa;
	                        x.type = m2 || F.dtype;
	                        x.offset = k2;
	                        x.stride = l2;
	                        x.divisor = c3;
	                      }
	                    }
	                    g2[a3] = E(function(a4, b2) {
	                      var c4 = a4.attribCache;
	                      if (e3 in c4) return c4[e3];
	                      var d3 = { isStream: false };
	                      Object.keys(x).forEach(function(a5) {
	                        d3[a5] = x[a5];
	                      });
	                      x.buffer && (d3.buffer = a4.link(x.buffer), d3.type = d3.type || d3.buffer + ".dtype");
	                      return c4[e3] = d3;
	                    });
	                  });
	                  Object.keys(e2).forEach(function(a3) {
	                    var b2 = e2[a3];
	                    g2[a3] = L(b2, function(a4, c3) {
	                      function d3(a5) {
	                        c3(F[a5], "=", e3, ".", a5, "|0;");
	                      }
	                      var e3 = a4.invoke(c3, b2), f2 = a4.shared, g3 = a4.constants, x = f2.isBufferArgs, f2 = f2.buffer, F = { isStream: c3.def(false) }, h2 = new ha();
	                      h2.state = 1;
	                      Object.keys(h2).forEach(function(a5) {
	                        F[a5] = c3.def("" + h2[a5]);
	                      });
	                      var k2 = F.buffer, l2 = F.type;
	                      c3(
	                        "if(",
	                        x,
	                        "(",
	                        e3,
	                        ")){",
	                        F.isStream,
	                        "=true;",
	                        k2,
	                        "=",
	                        f2,
	                        ".createStream(",
	                        34962,
	                        ",",
	                        e3,
	                        ");",
	                        l2,
	                        "=",
	                        k2,
	                        ".dtype;",
	                        "}else{",
	                        k2,
	                        "=",
	                        f2,
	                        ".getBuffer(",
	                        e3,
	                        ");",
	                        "if(",
	                        k2,
	                        "){",
	                        l2,
	                        "=",
	                        k2,
	                        ".dtype;",
	                        '}else if("constant" in ',
	                        e3,
	                        "){",
	                        F.state,
	                        "=",
	                        2,
	                        ";",
	                        "if(typeof " + e3 + '.constant === "number"){',
	                        F[Ca[0]],
	                        "=",
	                        e3,
	                        ".constant;",
	                        Ca.slice(1).map(function(a5) {
	                          return F[a5];
	                        }).join("="),
	                        "=0;",
	                        "}else{",
	                        Ca.map(function(a5, b3) {
	                          return F[a5] + "=" + e3 + ".constant.length>" + b3 + "?" + e3 + ".constant[" + b3 + "]:0;";
	                        }).join(""),
	                        "}}else{",
	                        "if(",
	                        x,
	                        "(",
	                        e3,
	                        ".buffer)){",
	                        k2,
	                        "=",
	                        f2,
	                        ".createStream(",
	                        34962,
	                        ",",
	                        e3,
	                        ".buffer);",
	                        "}else{",
	                        k2,
	                        "=",
	                        f2,
	                        ".getBuffer(",
	                        e3,
	                        ".buffer);",
	                        "}",
	                        l2,
	                        '="type" in ',
	                        e3,
	                        "?",
	                        g3.glTypes,
	                        "[",
	                        e3,
	                        ".type]:",
	                        k2,
	                        ".dtype;",
	                        F.normalized,
	                        "=!!",
	                        e3,
	                        ".normalized;"
	                      );
	                      d3("size");
	                      d3("offset");
	                      d3("stride");
	                      d3("divisor");
	                      c3("}}");
	                      c3.exit("if(", F.isStream, "){", f2, ".destroyStream(", k2, ");", "}");
	                      return F;
	                    });
	                  });
	                  return g2;
	                }
	                function J(a2) {
	                  var b2 = a2["static"], c2 = a2.dynamic, d2 = {};
	                  Object.keys(b2).forEach(function(a3) {
	                    var c3 = b2[a3];
	                    d2[a3] = E(function(a4, b3) {
	                      return "number" === typeof c3 || "boolean" === typeof c3 ? "" + c3 : a4.link(c3);
	                    });
	                  });
	                  Object.keys(c2).forEach(function(a3) {
	                    var b3 = c2[a3];
	                    d2[a3] = L(b3, function(a4, c3) {
	                      return a4.invoke(c3, b3);
	                    });
	                  });
	                  return d2;
	                }
	                function oa(a2, b2, d2, e2, f2) {
	                  function g2(a3) {
	                    var b3 = l2[a3];
	                    b3 && (m2[a3] = b3);
	                  }
	                  var k2 = G2(a2, b2), h2 = B2(a2), l2 = H2(a2, h2), n2 = v(a2), m2 = ba(a2), q2 = D(a2, f2, k2);
	                  g2("viewport");
	                  g2(p("scissor.box"));
	                  var t2 = 0 < Object.keys(m2).length, h2 = { framebuffer: h2, draw: n2, shader: q2, state: m2, dirty: t2, scopeVAO: null, drawVAO: null, useVAO: false, attributes: {} };
	                  h2.profile = z(a2);
	                  h2.uniforms = P2(d2);
	                  h2.drawVAO = h2.scopeVAO = n2.vao;
	                  if (!h2.drawVAO && q2.program && !k2 && c.angle_instanced_arrays && n2["static"].elements) {
	                    var u2 = true;
	                    a2 = q2.program.attributes.map(function(a3) {
	                      a3 = b2["static"][a3];
	                      u2 = u2 && !!a3;
	                      return a3;
	                    });
	                    if (u2 && 0 < a2.length) {
	                      var $b = r.getVAO(r.createVAO({ attributes: a2, elements: n2["static"].elements }));
	                      h2.drawVAO = new K(null, null, null, function(a3, b3) {
	                        return a3.link($b);
	                      });
	                      h2.useVAO = true;
	                    }
	                  }
	                  k2 ? h2.useVAO = true : h2.attributes = A(b2);
	                  h2.context = J(e2);
	                  return h2;
	                }
	                function na(a2, b2, c2) {
	                  var d2 = a2.shared.context, e2 = a2.scope();
	                  Object.keys(c2).forEach(function(f2) {
	                    b2.save(d2, "." + f2);
	                    var g2 = c2[f2].append(
	                      a2,
	                      b2
	                    );
	                    Array.isArray(g2) ? e2(d2, ".", f2, "=[", g2.join(), "];") : e2(d2, ".", f2, "=", g2, ";");
	                  });
	                  b2(e2);
	                }
	                function V(a2, b2, c2, d2) {
	                  var e2 = a2.shared, f2 = e2.gl, g2 = e2.framebuffer, h2;
	                  R2 && (h2 = b2.def(e2.extensions, ".webgl_draw_buffers"));
	                  var k2 = a2.constants, e2 = k2.drawBuffer, k2 = k2.backBuffer;
	                  a2 = c2 ? c2.append(a2, b2) : b2.def(g2, ".next");
	                  d2 || b2("if(", a2, "!==", g2, ".cur){");
	                  b2("if(", a2, "){", f2, ".bindFramebuffer(", 36160, ",", a2, ".framebuffer);");
	                  R2 && b2(h2, ".drawBuffersWEBGL(", e2, "[", a2, ".colorAttachments.length]);");
	                  b2("}else{", f2, ".bindFramebuffer(", 36160, ",null);");
	                  R2 && b2(
	                    h2,
	                    ".drawBuffersWEBGL(",
	                    k2,
	                    ");"
	                  );
	                  b2("}", g2, ".cur=", a2, ";");
	                  d2 || b2("}");
	                }
	                function T2(a2, b2, c2) {
	                  var d2 = a2.shared, e2 = d2.gl, f2 = a2.current, g2 = a2.next, h2 = d2.current, k2 = d2.next, l2 = a2.cond(h2, ".dirty");
	                  Ma.forEach(function(b3) {
	                    b3 = p(b3);
	                    if (!(b3 in c2.state)) {
	                      var d3, F;
	                      if (b3 in g2) {
	                        d3 = g2[b3];
	                        F = f2[b3];
	                        var n2 = S(ta[b3].length, function(a3) {
	                          return l2.def(d3, "[", a3, "]");
	                        });
	                        l2(a2.cond(n2.map(function(a3, b4) {
	                          return a3 + "!==" + F + "[" + b4 + "]";
	                        }).join("||")).then(e2, ".", ma[b3], "(", n2, ");", n2.map(function(a3, b4) {
	                          return F + "[" + b4 + "]=" + a3;
	                        }).join(";"), ";"));
	                      } else d3 = l2.def(k2, ".", b3), n2 = a2.cond(d3, "!==", h2, ".", b3), l2(n2), b3 in ua ? n2(a2.cond(d3).then(e2, ".enable(", ua[b3], ");")["else"](e2, ".disable(", ua[b3], ");"), h2, ".", b3, "=", d3, ";") : n2(e2, ".", ma[b3], "(", d3, ");", h2, ".", b3, "=", d3, ";");
	                    }
	                  });
	                  0 === Object.keys(c2.state).length && l2(h2, ".dirty=false;");
	                  b2(l2);
	                }
	                function W(a2, b2, c2, d2) {
	                  var e2 = a2.shared, f2 = a2.current, g2 = e2.current, h2 = e2.gl, k2;
	                  yb(Object.keys(c2)).forEach(function(e3) {
	                    var l2 = c2[e3];
	                    if (!d2 || d2(l2)) {
	                      var n2 = l2.append(a2, b2);
	                      if (ua[e3]) {
	                        var m2 = ua[e3];
	                        la(l2) ? (k2 = a2.link(n2, { stable: true }), b2(a2.cond(k2).then(h2, ".enable(", m2, ");")["else"](h2, ".disable(", m2, ");")), b2(g2, ".", e3, "=", k2, ";")) : (b2(a2.cond(n2).then(
	                          h2,
	                          ".enable(",
	                          m2,
	                          ");"
	                        )["else"](h2, ".disable(", m2, ");")), b2(g2, ".", e3, "=", n2, ";"));
	                      } else if (qa(n2)) {
	                        var p2 = f2[e3];
	                        b2(h2, ".", ma[e3], "(", n2, ");", n2.map(function(a3, b3) {
	                          return p2 + "[" + b3 + "]=" + a3;
	                        }).join(";"), ";");
	                      } else la(l2) ? (k2 = a2.link(n2, { stable: true }), b2(h2, ".", ma[e3], "(", k2, ");", g2, ".", e3, "=", k2, ";")) : b2(h2, ".", ma[e3], "(", n2, ");", g2, ".", e3, "=", n2, ";");
	                    }
	                  });
	                }
	                function Q(a2, b2) {
	                  sa && (a2.instancing = b2.def(a2.shared.extensions, ".angle_instanced_arrays"));
	                }
	                function I(a2, b2, c2, d2, e2) {
	                  function f2() {
	                    return "undefined" === typeof performance ? "Date.now()" : "performance.now()";
	                  }
	                  function h2(a3) {
	                    t2 = b2.def();
	                    a3(t2, "=", f2(), ";");
	                    "string" === typeof e2 ? a3(m2, ".count+=", e2, ";") : a3(m2, ".count++;");
	                    g && (d2 ? (r2 = b2.def(), a3(r2, "=", q2, ".getNumPendingQueries();")) : a3(q2, ".beginQuery(", m2, ");"));
	                  }
	                  function k2(a3) {
	                    a3(m2, ".cpuTime+=", f2(), "-", t2, ";");
	                    g && (d2 ? a3(q2, ".pushScopeStats(", r2, ",", q2, ".getNumPendingQueries(),", m2, ");") : a3(q2, ".endQuery();"));
	                  }
	                  function l2(a3) {
	                    var c3 = b2.def(p2, ".profile");
	                    b2(p2, ".profile=", a3, ";");
	                    b2.exit(p2, ".profile=", c3, ";");
	                  }
	                  var n2 = a2.shared, m2 = a2.stats, p2 = n2.current, q2 = n2.timer;
	                  c2 = c2.profile;
	                  var t2, r2;
	                  if (c2) {
	                    if (la(c2)) {
	                      c2.enable ? (h2(b2), k2(b2.exit), l2("true")) : l2("false");
	                      return;
	                    }
	                    c2 = c2.append(a2, b2);
	                    l2(c2);
	                  } else c2 = b2.def(p2, ".profile");
	                  n2 = a2.block();
	                  h2(n2);
	                  b2("if(", c2, "){", n2, "}");
	                  a2 = a2.block();
	                  k2(a2);
	                  b2.exit("if(", c2, "){", a2, "}");
	                }
	                function M2(a2, b2, c2, d2, e2) {
	                  function f2(a3) {
	                    switch (a3) {
	                      case 35664:
	                      case 35667:
	                      case 35671:
	                        return 2;
	                      case 35665:
	                      case 35668:
	                      case 35672:
	                        return 3;
	                      case 35666:
	                      case 35669:
	                      case 35673:
	                        return 4;
	                      default:
	                        return 1;
	                    }
	                  }
	                  function g2(c3, d3, e3) {
	                    function f3() {
	                      b2("if(!", m2, ".buffer){", n2, ".enableVertexAttribArray(", l2, ");}");
	                      var c4 = e3.type, g3;
	                      g3 = e3.size ? b2.def(
	                        e3.size,
	                        "||",
	                        d3
	                      ) : d3;
	                      b2("if(", m2, ".type!==", c4, "||", m2, ".size!==", g3, "||", q2.map(function(a3) {
	                        return m2 + "." + a3 + "!==" + e3[a3];
	                      }).join("||"), "){", n2, ".bindBuffer(", 34962, ",", p2, ".buffer);", n2, ".vertexAttribPointer(", [l2, g3, c4, e3.normalized, e3.stride, e3.offset], ");", m2, ".type=", c4, ";", m2, ".size=", g3, ";", q2.map(function(a3) {
	                        return m2 + "." + a3 + "=" + e3[a3] + ";";
	                      }).join(""), "}");
	                      sa && (c4 = e3.divisor, b2("if(", m2, ".divisor!==", c4, "){", a2.instancing, ".vertexAttribDivisorANGLE(", [l2, c4], ");", m2, ".divisor=", c4, ";}"));
	                    }
	                    function k2() {
	                      b2(
	                        "if(",
	                        m2,
	                        ".buffer){",
	                        n2,
	                        ".disableVertexAttribArray(",
	                        l2,
	                        ");",
	                        m2,
	                        ".buffer=null;",
	                        "}if(",
	                        Ca.map(function(a3, b3) {
	                          return m2 + "." + a3 + "!==" + aa[b3];
	                        }).join("||"),
	                        "){",
	                        n2,
	                        ".vertexAttrib4f(",
	                        l2,
	                        ",",
	                        aa,
	                        ");",
	                        Ca.map(function(a3, b3) {
	                          return m2 + "." + a3 + "=" + aa[b3] + ";";
	                        }).join(""),
	                        "}"
	                      );
	                    }
	                    var n2 = h2.gl, l2 = b2.def(c3, ".location"), m2 = b2.def(h2.attributes, "[", l2, "]");
	                    c3 = e3.state;
	                    var p2 = e3.buffer, aa = [e3.x, e3.y, e3.z, e3.w], q2 = ["buffer", "normalized", "offset", "stride"];
	                    1 === c3 ? f3() : 2 === c3 ? k2() : (b2("if(", c3, "===", 1, "){"), f3(), b2("}else{"), k2(), b2("}"));
	                  }
	                  var h2 = a2.shared;
	                  d2.forEach(function(d3) {
	                    var h3 = d3.name, k2 = c2.attributes[h3], l2;
	                    if (k2) {
	                      if (!e2(k2)) return;
	                      l2 = k2.append(a2, b2);
	                    } else {
	                      if (!e2(Ab)) return;
	                      var n2 = a2.scopeAttrib(h3);
	                      l2 = {};
	                      Object.keys(new ha()).forEach(function(a3) {
	                        l2[a3] = b2.def(n2, ".", a3);
	                      });
	                    }
	                    g2(a2.link(d3), f2(d3.info.type), l2);
	                  });
	                }
	                function U2(a2, c2, d2, e2, f2, g2) {
	                  for (var h2 = a2.shared, k2 = h2.gl, l2, n2 = 0; n2 < e2.length; ++n2) {
	                    var m2 = e2[n2], p2 = m2.name, q2 = m2.info.type, t2 = d2.uniforms[p2], m2 = a2.link(m2) + ".location", r2;
	                    if (t2) {
	                      if (!f2(t2)) continue;
	                      if (la(t2)) {
	                        p2 = t2.value;
	                        if (35678 === q2 || 35680 === q2) q2 = a2.link(p2._texture || p2.color[0]._texture), c2(k2, ".uniform1i(", m2, ",", q2 + ".bind());"), c2.exit(q2, ".unbind();");
	                        else if (35674 === q2 || 35675 === q2 || 35676 === q2) p2 = a2.global.def("new Float32Array([" + Array.prototype.slice.call(p2) + "])"), t2 = 2, 35675 === q2 ? t2 = 3 : 35676 === q2 && (t2 = 4), c2(k2, ".uniformMatrix", t2, "fv(", m2, ",false,", p2, ");");
	                        else {
	                          switch (q2) {
	                            case 5126:
	                              l2 = "1f";
	                              break;
	                            case 35664:
	                              l2 = "2f";
	                              break;
	                            case 35665:
	                              l2 = "3f";
	                              break;
	                            case 35666:
	                              l2 = "4f";
	                              break;
	                            case 35670:
	                              l2 = "1i";
	                              break;
	                            case 5124:
	                              l2 = "1i";
	                              break;
	                            case 35671:
	                              l2 = "2i";
	                              break;
	                            case 35667:
	                              l2 = "2i";
	                              break;
	                            case 35672:
	                              l2 = "3i";
	                              break;
	                            case 35668:
	                              l2 = "3i";
	                              break;
	                            case 35673:
	                              l2 = "4i";
	                              break;
	                            case 35669:
	                              l2 = "4i";
	                          }
	                          c2(k2, ".uniform", l2, "(", m2, ",", qa(p2) ? Array.prototype.slice.call(p2) : p2, ");");
	                        }
	                        continue;
	                      } else r2 = t2.append(a2, c2);
	                    } else {
	                      if (!f2(Ab)) continue;
	                      r2 = c2.def(h2.uniforms, "[", b.id(p2), "]");
	                    }
	                    35678 === q2 ? c2("if(", r2, "&&", r2, '._reglType==="framebuffer"){', r2, "=", r2, ".color[0];", "}") : 35680 === q2 && c2("if(", r2, "&&", r2, '._reglType==="framebufferCube"){', r2, "=", r2, ".color[0];", "}");
	                    p2 = 1;
	                    switch (q2) {
	                      case 35678:
	                      case 35680:
	                        q2 = c2.def(r2, "._texture");
	                        c2(k2, ".uniform1i(", m2, ",", q2, ".bind());");
	                        c2.exit(q2, ".unbind();");
	                        continue;
	                      case 5124:
	                      case 35670:
	                        l2 = "1i";
	                        break;
	                      case 35667:
	                      case 35671:
	                        l2 = "2i";
	                        p2 = 2;
	                        break;
	                      case 35668:
	                      case 35672:
	                        l2 = "3i";
	                        p2 = 3;
	                        break;
	                      case 35669:
	                      case 35673:
	                        l2 = "4i";
	                        p2 = 4;
	                        break;
	                      case 5126:
	                        l2 = "1f";
	                        break;
	                      case 35664:
	                        l2 = "2f";
	                        p2 = 2;
	                        break;
	                      case 35665:
	                        l2 = "3f";
	                        p2 = 3;
	                        break;
	                      case 35666:
	                        l2 = "4f";
	                        p2 = 4;
	                        break;
	                      case 35674:
	                        l2 = "Matrix2fv";
	                        break;
	                      case 35675:
	                        l2 = "Matrix3fv";
	                        break;
	                      case 35676:
	                        l2 = "Matrix4fv";
	                    }
	                    if ("M" === l2.charAt(0)) {
	                      c2(k2, ".uniform", l2, "(", m2, ",");
	                      var m2 = Math.pow(q2 - 35674 + 2, 2), u2 = a2.global.def("new Float32Array(", m2, ")");
	                      Array.isArray(r2) ? c2("false,(", S(m2, function(a3) {
	                        return u2 + "[" + a3 + "]=" + r2[a3];
	                      }), ",", u2, ")") : c2(
	                        "false,(Array.isArray(",
	                        r2,
	                        ")||",
	                        r2,
	                        " instanceof Float32Array)?",
	                        r2,
	                        ":(",
	                        S(m2, function(a3) {
	                          return u2 + "[" + a3 + "]=" + r2 + "[" + a3 + "]";
	                        }),
	                        ",",
	                        u2,
	                        ")"
	                      );
	                      c2(");");
	                    } else {
	                      if (1 < p2) {
	                        for (var q2 = [], v2 = [], t2 = 0; t2 < p2; ++t2) Array.isArray(r2) ? v2.push(r2[t2]) : v2.push(c2.def(r2 + "[" + t2 + "]")), g2 && q2.push(c2.def());
	                        g2 && c2("if(!", a2.batchId, "||", q2.map(function(a3, b2) {
	                          return a3 + "!==" + v2[b2];
	                        }).join("||"), "){", q2.map(function(a3, b2) {
	                          return a3 + "=" + v2[b2] + ";";
	                        }).join(""));
	                        c2(k2, ".uniform", l2, "(", m2, ",", v2.join(","), ");");
	                      } else g2 && (q2 = c2.def(), c2("if(!", a2.batchId, "||", q2, "!==", r2, "){", q2, "=", r2, ";")), c2(k2, ".uniform", l2, "(", m2, ",", r2, ");");
	                      g2 && c2("}");
	                    }
	                  }
	                }
	                function Y2(a2, b2, c2, d2) {
	                  function e2(f3) {
	                    var g3 = n2[f3];
	                    return g3 ? g3.contextDep && d2.contextDynamic || g3.propDep ? g3.append(a2, c2) : g3.append(a2, b2) : b2.def(l2, ".", f3);
	                  }
	                  function f2() {
	                    function a3() {
	                      c2(u2, ".drawElementsInstancedANGLE(", [p2, t2, v2, q2 + "<<((" + v2 + "-5121)>>1)", r2], ");");
	                    }
	                    function b3() {
	                      c2(u2, ".drawArraysInstancedANGLE(", [p2, q2, t2, r2], ");");
	                    }
	                    m2 && "null" !== m2 ? y2 ? a3() : (c2("if(", m2, "){"), a3(), c2("}else{"), b3(), c2("}")) : b3();
	                  }
	                  function g2() {
	                    function a3() {
	                      c2(k2 + ".drawElements(" + [p2, t2, v2, q2 + "<<((" + v2 + "-5121)>>1)"] + ");");
	                    }
	                    function b3() {
	                      c2(k2 + ".drawArrays(" + [p2, q2, t2] + ");");
	                    }
	                    m2 && "null" !== m2 ? y2 ? a3() : (c2("if(", m2, "){"), a3(), c2("}else{"), b3(), c2("}")) : b3();
	                  }
	                  var h2 = a2.shared, k2 = h2.gl, l2 = h2.draw, n2 = d2.draw, m2 = function() {
	                    var e3 = n2.elements, f3 = b2;
	                    if (e3) {
	                      if (e3.contextDep && d2.contextDynamic || e3.propDep) f3 = c2;
	                      e3 = e3.append(a2, f3);
	                      n2.elementsActive && f3("if(" + e3 + ")" + k2 + ".bindBuffer(34963," + e3 + ".buffer.buffer);");
	                    } else e3 = f3.def(), f3(e3, "=", l2, ".", "elements", ";", "if(", e3, "){", k2, ".bindBuffer(", 34963, ",", e3, ".buffer.buffer);}", "else if(", h2.vao, ".currentVAO){", e3, "=", a2.shared.elements + ".getElements(" + h2.vao, ".currentVAO.elements);", ja2 ? "" : "if(" + e3 + ")" + k2 + ".bindBuffer(34963," + e3 + ".buffer.buffer);", "}");
	                    return e3;
	                  }(), p2 = e2("primitive"), q2 = e2("offset"), t2 = function() {
	                    var e3 = n2.count, f3 = b2;
	                    if (e3) {
	                      if (e3.contextDep && d2.contextDynamic || e3.propDep) f3 = c2;
	                      e3 = e3.append(a2, f3);
	                    } else e3 = f3.def(l2, ".", "count");
	                    return e3;
	                  }();
	                  if ("number" === typeof t2) {
	                    if (0 === t2) return;
	                  } else c2("if(", t2, "){"), c2.exit("}");
	                  var r2, u2;
	                  sa && (r2 = e2("instances"), u2 = a2.instancing);
	                  var v2 = m2 + ".type", y2 = n2.elements && la(n2.elements) && !n2.vaoActive;
	                  sa && ("number" !== typeof r2 || 0 <= r2) ? "string" === typeof r2 ? (c2("if(", r2, ">0){"), f2(), c2(
	                    "}else if(",
	                    r2,
	                    "<0){"
	                  ), g2(), c2("}")) : f2() : g2();
	                }
	                function xa(a2, b2, c2, d2, e2) {
	                  b2 = w();
	                  e2 = b2.proc("body", e2);
	                  sa && (b2.instancing = e2.def(b2.shared.extensions, ".angle_instanced_arrays"));
	                  a2(b2, e2, c2, d2);
	                  return b2.compile().body;
	                }
	                function da2(a2, b2, c2, d2) {
	                  Q(a2, b2);
	                  c2.useVAO ? c2.drawVAO ? b2(a2.shared.vao, ".setVAO(", c2.drawVAO.append(a2, b2), ");") : b2(a2.shared.vao, ".setVAO(", a2.shared.vao, ".targetVAO);") : (b2(a2.shared.vao, ".setVAO(null);"), M2(a2, b2, c2, d2.attributes, function() {
	                    return true;
	                  }));
	                  U2(a2, b2, c2, d2.uniforms, function() {
	                    return true;
	                  }, false);
	                  Y2(a2, b2, b2, c2);
	                }
	                function pa(a2, b2) {
	                  var c2 = a2.proc(
	                    "draw",
	                    1
	                  );
	                  Q(a2, c2);
	                  na(a2, c2, b2.context);
	                  V(a2, c2, b2.framebuffer);
	                  T2(a2, c2, b2);
	                  W(a2, c2, b2.state);
	                  I(a2, c2, b2, false, true);
	                  var d2 = b2.shader.progVar.append(a2, c2);
	                  c2(a2.shared.gl, ".useProgram(", d2, ".program);");
	                  if (b2.shader.program) da2(a2, c2, b2, b2.shader.program);
	                  else {
	                    c2(a2.shared.vao, ".setVAO(null);");
	                    var e2 = a2.global.def("{}"), f2 = c2.def(d2, ".id"), g2 = c2.def(e2, "[", f2, "]");
	                    c2(a2.cond(g2).then(g2, ".call(this,a0);")["else"](g2, "=", e2, "[", f2, "]=", a2.link(function(c3) {
	                      return xa(da2, a2, b2, c3, 1);
	                    }), "(", d2, ");", g2, ".call(this,a0);"));
	                  }
	                  0 < Object.keys(b2.state).length && c2(
	                    a2.shared.current,
	                    ".dirty=true;"
	                  );
	                  a2.shared.vao && c2(a2.shared.vao, ".setVAO(null);");
	                }
	                function ga(a2, b2, c2, d2) {
	                  function e2() {
	                    return true;
	                  }
	                  a2.batchId = "a1";
	                  Q(a2, b2);
	                  M2(a2, b2, c2, d2.attributes, e2);
	                  U2(a2, b2, c2, d2.uniforms, e2, false);
	                  Y2(a2, b2, b2, c2);
	                }
	                function Ea(a2, b2, c2, d2) {
	                  function e2(a3) {
	                    return a3.contextDep && g2 || a3.propDep;
	                  }
	                  function f2(a3) {
	                    return !e2(a3);
	                  }
	                  Q(a2, b2);
	                  var g2 = c2.contextDep, h2 = b2.def(), k2 = b2.def();
	                  a2.shared.props = k2;
	                  a2.batchId = h2;
	                  var l2 = a2.scope(), n2 = a2.scope();
	                  b2(l2.entry, "for(", h2, "=0;", h2, "<", "a1", ";++", h2, "){", k2, "=", "a0", "[", h2, "];", n2, "}", l2.exit);
	                  c2.needsContext && na(a2, n2, c2.context);
	                  c2.needsFramebuffer && V(a2, n2, c2.framebuffer);
	                  W(a2, n2, c2.state, e2);
	                  c2.profile && e2(c2.profile) && I(a2, n2, c2, false, true);
	                  d2 ? (c2.useVAO ? c2.drawVAO ? e2(c2.drawVAO) ? n2(a2.shared.vao, ".setVAO(", c2.drawVAO.append(a2, n2), ");") : l2(a2.shared.vao, ".setVAO(", c2.drawVAO.append(a2, l2), ");") : l2(a2.shared.vao, ".setVAO(", a2.shared.vao, ".targetVAO);") : (l2(a2.shared.vao, ".setVAO(null);"), M2(a2, l2, c2, d2.attributes, f2), M2(a2, n2, c2, d2.attributes, e2)), U2(a2, l2, c2, d2.uniforms, f2, false), U2(a2, n2, c2, d2.uniforms, e2, true), Y2(a2, l2, n2, c2)) : (b2 = a2.global.def("{}"), d2 = c2.shader.progVar.append(a2, n2), k2 = n2.def(
	                    d2,
	                    ".id"
	                  ), l2 = n2.def(b2, "[", k2, "]"), n2(a2.shared.gl, ".useProgram(", d2, ".program);", "if(!", l2, "){", l2, "=", b2, "[", k2, "]=", a2.link(function(b3) {
	                    return xa(ga, a2, c2, b3, 2);
	                  }), "(", d2, ");}", l2, ".call(this,a0[", h2, "],", h2, ");"));
	                }
	                function Qa(a2, b2) {
	                  function c2(a3) {
	                    return a3.contextDep && e2 || a3.propDep;
	                  }
	                  var d2 = a2.proc("batch", 2);
	                  a2.batchId = "0";
	                  Q(a2, d2);
	                  var e2 = false, f2 = true;
	                  Object.keys(b2.context).forEach(function(a3) {
	                    e2 = e2 || b2.context[a3].propDep;
	                  });
	                  e2 || (na(a2, d2, b2.context), f2 = false);
	                  var g2 = b2.framebuffer, h2 = false;
	                  g2 ? (g2.propDep ? e2 = h2 = true : g2.contextDep && e2 && (h2 = true), h2 || V(a2, d2, g2)) : V(
	                    a2,
	                    d2,
	                    null
	                  );
	                  b2.state.viewport && b2.state.viewport.propDep && (e2 = true);
	                  T2(a2, d2, b2);
	                  W(a2, d2, b2.state, function(a3) {
	                    return !c2(a3);
	                  });
	                  b2.profile && c2(b2.profile) || I(a2, d2, b2, false, "a1");
	                  b2.contextDep = e2;
	                  b2.needsContext = f2;
	                  b2.needsFramebuffer = h2;
	                  f2 = b2.shader.progVar;
	                  if (f2.contextDep && e2 || f2.propDep) Ea(a2, d2, b2, null);
	                  else if (f2 = f2.append(a2, d2), d2(a2.shared.gl, ".useProgram(", f2, ".program);"), b2.shader.program) Ea(a2, d2, b2, b2.shader.program);
	                  else {
	                    d2(a2.shared.vao, ".setVAO(null);");
	                    var g2 = a2.global.def("{}"), h2 = d2.def(f2, ".id"), k2 = d2.def(g2, "[", h2, "]");
	                    d2(a2.cond(k2).then(k2, ".call(this,a0,a1);")["else"](
	                      k2,
	                      "=",
	                      g2,
	                      "[",
	                      h2,
	                      "]=",
	                      a2.link(function(c3) {
	                        return xa(Ea, a2, b2, c3, 2);
	                      }),
	                      "(",
	                      f2,
	                      ");",
	                      k2,
	                      ".call(this,a0,a1);"
	                    ));
	                  }
	                  0 < Object.keys(b2.state).length && d2(a2.shared.current, ".dirty=true;");
	                  a2.shared.vao && d2(a2.shared.vao, ".setVAO(null);");
	                }
	                function ea2(a2, c2) {
	                  function d2(b2) {
	                    var g3 = c2.shader[b2];
	                    g3 && (g3 = g3.append(a2, e2), isNaN(g3) ? e2.set(f2.shader, "." + b2, g3) : e2.set(f2.shader, "." + b2, a2.link(g3, { stable: true })));
	                  }
	                  var e2 = a2.proc("scope", 3);
	                  a2.batchId = "a2";
	                  var f2 = a2.shared, g2 = f2.current;
	                  na(a2, e2, c2.context);
	                  c2.framebuffer && c2.framebuffer.append(a2, e2);
	                  yb(Object.keys(c2.state)).forEach(function(b2) {
	                    var d3 = c2.state[b2], g3 = d3.append(a2, e2);
	                    qa(g3) ? g3.forEach(function(c3, d4) {
	                      isNaN(c3) ? e2.set(a2.next[b2], "[" + d4 + "]", c3) : e2.set(a2.next[b2], "[" + d4 + "]", a2.link(c3, { stable: true }));
	                    }) : la(d3) ? e2.set(f2.next, "." + b2, a2.link(g3, { stable: true })) : e2.set(f2.next, "." + b2, g3);
	                  });
	                  I(a2, e2, c2, true, true);
	                  ["elements", "offset", "count", "instances", "primitive"].forEach(function(b2) {
	                    var d3 = c2.draw[b2];
	                    d3 && (d3 = d3.append(a2, e2), isNaN(d3) ? e2.set(f2.draw, "." + b2, d3) : e2.set(f2.draw, "." + b2, a2.link(d3), { stable: true }));
	                  });
	                  Object.keys(c2.uniforms).forEach(function(d3) {
	                    var g3 = c2.uniforms[d3].append(a2, e2);
	                    Array.isArray(g3) && (g3 = "[" + g3.map(function(b2) {
	                      return isNaN(b2) ? b2 : a2.link(b2, { stable: true });
	                    }) + "]");
	                    e2.set(f2.uniforms, "[" + a2.link(b.id(d3), { stable: true }) + "]", g3);
	                  });
	                  Object.keys(c2.attributes).forEach(function(b2) {
	                    var d3 = c2.attributes[b2].append(a2, e2), f3 = a2.scopeAttrib(b2);
	                    Object.keys(new ha()).forEach(function(a3) {
	                      e2.set(f3, "." + a3, d3[a3]);
	                    });
	                  });
	                  if (c2.scopeVAO) {
	                    var h2 = c2.scopeVAO.append(a2, e2);
	                    isNaN(h2) ? e2.set(f2.vao, ".targetVAO", h2) : e2.set(f2.vao, ".targetVAO", a2.link(h2, { stable: true }));
	                  }
	                  d2("vert");
	                  d2("frag");
	                  0 < Object.keys(c2.state).length && (e2(g2, ".dirty=true;"), e2.exit(
	                    g2,
	                    ".dirty=true;"
	                  ));
	                  e2("a1(", a2.shared.context, ",a0,", a2.batchId, ");");
	                }
	                function fa2(a2) {
	                  if ("object" === typeof a2 && !qa(a2)) {
	                    for (var b2 = Object.keys(a2), c2 = 0; c2 < b2.length; ++c2) if (Z.isDynamic(a2[b2[c2]])) return true;
	                    return false;
	                  }
	                }
	                function ka(a2, b2, c2) {
	                  function d2(a3, b3) {
	                    g2.forEach(function(c3) {
	                      var d3 = e2[c3];
	                      Z.isDynamic(d3) && (d3 = a3.invoke(b3, d3), b3(n2, ".", c3, "=", d3, ";"));
	                    });
	                  }
	                  var e2 = b2["static"][c2];
	                  if (e2 && fa2(e2)) {
	                    var f2 = a2.global, g2 = Object.keys(e2), h2 = false, k2 = false, l2 = false, n2 = a2.global.def("{}");
	                    g2.forEach(function(b3) {
	                      var c3 = e2[b3];
	                      if (Z.isDynamic(c3)) "function" === typeof c3 && (c3 = e2[b3] = Z.unbox(c3)), b3 = L(c3, null), h2 = h2 || b3.thisDep, l2 = l2 || b3.propDep, k2 = k2 || b3.contextDep;
	                      else {
	                        f2(n2, ".", b3, "=");
	                        switch (typeof c3) {
	                          case "number":
	                            f2(c3);
	                            break;
	                          case "string":
	                            f2('"', c3, '"');
	                            break;
	                          case "object":
	                            Array.isArray(c3) && f2("[", c3.join(), "]");
	                            break;
	                          default:
	                            f2(a2.link(c3));
	                        }
	                        f2(";");
	                      }
	                    });
	                    b2.dynamic[c2] = new Z.DynamicVariable(4, { thisDep: h2, contextDep: k2, propDep: l2, ref: n2, append: d2 });
	                    delete b2["static"][c2];
	                  }
	                }
	                var ha = r.Record, X = { add: 32774, subtract: 32778, "reverse subtract": 32779 };
	                c.ext_blend_minmax && (X.min = 32775, X.max = 32776);
	                var sa = c.angle_instanced_arrays, R2 = c.webgl_draw_buffers, ja2 = c.oes_vertex_array_object, ta = { dirty: true, profile: h.profile }, Da = {}, Ma = [], ua = {}, ma = {};
	                y("dither", 3024);
	                y("blend.enable", 3042);
	                C("blend.color", "blendColor", [0, 0, 0, 0]);
	                C("blend.equation", "blendEquationSeparate", [32774, 32774]);
	                C("blend.func", "blendFuncSeparate", [1, 0, 1, 0]);
	                y("depth.enable", 2929, true);
	                C("depth.func", "depthFunc", 513);
	                C("depth.range", "depthRange", [0, 1]);
	                C("depth.mask", "depthMask", true);
	                C("colorMask", "colorMask", [true, true, true, true]);
	                y("cull.enable", 2884);
	                C(
	                  "cull.face",
	                  "cullFace",
	                  1029
	                );
	                C("frontFace", "frontFace", 2305);
	                C("lineWidth", "lineWidth", 1);
	                y("polygonOffset.enable", 32823);
	                C("polygonOffset.offset", "polygonOffset", [0, 0]);
	                y("sample.alpha", 32926);
	                y("sample.enable", 32928);
	                C("sample.coverage", "sampleCoverage", [1, false]);
	                y("stencil.enable", 2960);
	                C("stencil.mask", "stencilMask", -1);
	                C("stencil.func", "stencilFunc", [519, 0, -1]);
	                C("stencil.opFront", "stencilOpSeparate", [1028, 7680, 7680, 7680]);
	                C("stencil.opBack", "stencilOpSeparate", [1029, 7680, 7680, 7680]);
	                y("scissor.enable", 3089);
	                C(
	                  "scissor.box",
	                  "scissor",
	                  [0, 0, a.drawingBufferWidth, a.drawingBufferHeight]
	                );
	                C("viewport", "viewport", [0, 0, a.drawingBufferWidth, a.drawingBufferHeight]);
	                var tb = { gl: a, context: t, strings: b, next: Da, current: ta, draw: n, elements: e, buffer: f, shader: k, attributes: r.state, vao: r, uniforms: u, framebuffer: q, extensions: c, timer: g, isBufferArgs: Sa }, Oa = { primTypes: Ka, compareFuncs: $a, blendFuncs: Ga, blendEquations: X, stencilOps: Ta, glTypes: Ja, orientationType: zb };
	                R2 && (Oa.backBuffer = [1029], Oa.drawBuffer = S(d.maxDrawbuffers, function(a2) {
	                  return 0 === a2 ? [0] : S(a2, function(a3) {
	                    return 36064 + a3;
	                  });
	                }));
	                var ra2 = 0;
	                return { next: Da, current: ta, procs: function() {
	                  var a2 = w(), b2 = a2.proc("poll"), e2 = a2.proc("refresh"), f2 = a2.block();
	                  b2(f2);
	                  e2(f2);
	                  var g2 = a2.shared, h2 = g2.gl, k2 = g2.next, l2 = g2.current;
	                  f2(l2, ".dirty=false;");
	                  V(a2, b2);
	                  V(a2, e2, null, true);
	                  var n2;
	                  sa && (n2 = a2.link(sa));
	                  c.oes_vertex_array_object && e2(a2.link(c.oes_vertex_array_object), ".bindVertexArrayOES(null);");
	                  var g2 = e2.def(g2.attributes), m2 = e2.def(0), p2 = a2.cond(m2, ".buffer");
	                  p2.then(
	                    h2,
	                    ".enableVertexAttribArray(i);",
	                    h2,
	                    ".bindBuffer(",
	                    34962,
	                    ",",
	                    m2,
	                    ".buffer.buffer);",
	                    h2,
	                    ".vertexAttribPointer(i,",
	                    m2,
	                    ".size,",
	                    m2,
	                    ".type,",
	                    m2,
	                    ".normalized,",
	                    m2,
	                    ".stride,",
	                    m2,
	                    ".offset);"
	                  )["else"](h2, ".disableVertexAttribArray(i);", h2, ".vertexAttrib4f(i,", m2, ".x,", m2, ".y,", m2, ".z,", m2, ".w);", m2, ".buffer=null;");
	                  var q2 = a2.link(d.maxAttributes, { stable: true });
	                  e2("for(var i=0;i<", q2, ";++i){", m2, "=", g2, "[i];", p2, "}");
	                  sa && e2("for(var i=0;i<", q2, ";++i){", n2, ".vertexAttribDivisorANGLE(i,", g2, "[i].divisor);", "}");
	                  e2(a2.shared.vao, ".currentVAO=null;", a2.shared.vao, ".setVAO(", a2.shared.vao, ".targetVAO);");
	                  Object.keys(ua).forEach(function(c2) {
	                    var d2 = ua[c2], g3 = f2.def(k2, ".", c2), n3 = a2.block();
	                    n3("if(", g3, "){", h2, ".enable(", d2, ")}else{", h2, ".disable(", d2, ")}", l2, ".", c2, "=", g3, ";");
	                    e2(n3);
	                    b2("if(", g3, "!==", l2, ".", c2, "){", n3, "}");
	                  });
	                  Object.keys(ma).forEach(function(c2) {
	                    var d2 = ma[c2], g3 = ta[c2], n3, m3, p3 = a2.block();
	                    p3(h2, ".", d2, "(");
	                    qa(g3) ? (d2 = g3.length, n3 = a2.global.def(k2, ".", c2), m3 = a2.global.def(l2, ".", c2), p3(S(d2, function(a3) {
	                      return n3 + "[" + a3 + "]";
	                    }), ");", S(d2, function(a3) {
	                      return m3 + "[" + a3 + "]=" + n3 + "[" + a3 + "];";
	                    }).join("")), b2("if(", S(d2, function(a3) {
	                      return n3 + "[" + a3 + "]!==" + m3 + "[" + a3 + "]";
	                    }).join("||"), "){", p3, "}")) : (n3 = f2.def(k2, ".", c2), m3 = f2.def(l2, ".", c2), p3(n3, ");", l2, ".", c2, "=", n3, ";"), b2("if(", n3, "!==", m3, "){", p3, "}"));
	                    e2(p3);
	                  });
	                  return a2.compile();
	                }(), compile: function(a2, b2, c2, d2, e2) {
	                  var f2 = w();
	                  f2.stats = f2.link(e2);
	                  Object.keys(b2["static"]).forEach(function(a3) {
	                    ka(f2, b2, a3);
	                  });
	                  ac.forEach(function(b3) {
	                    ka(f2, a2, b3);
	                  });
	                  var g2 = oa(a2, b2, c2, d2, f2);
	                  g2.shader.program && (g2.shader.program.attributes.sort(function(a3, b3) {
	                    return a3.name < b3.name ? -1 : 1;
	                  }), g2.shader.program.uniforms.sort(function(a3, b3) {
	                    return a3.name < b3.name ? -1 : 1;
	                  }));
	                  pa(f2, g2);
	                  ea2(f2, g2);
	                  Qa(f2, g2);
	                  return O(
	                    f2.compile(),
	                    { destroy: function() {
	                      g2.shader.program.destroy();
	                    } }
	                  );
	                } };
	              }
	              function Bb(a, b) {
	                for (var c = 0; c < a.length; ++c) if (a[c] === b) return c;
	                return -1;
	              }
	              var O = function(a, b) {
	                for (var c = Object.keys(b), d = 0; d < c.length; ++d) a[c[d]] = b[c[d]];
	                return a;
	              }, Db = 0, Z = { DynamicVariable: da, define: function(a, b) {
	                return new da(a, bb(b + ""));
	              }, isDynamic: function(a) {
	                return "function" === typeof a && !a._reglType || a instanceof da;
	              }, unbox: cb, accessor: bb }, ab = { next: "function" === typeof requestAnimationFrame ? function(a) {
	                return requestAnimationFrame(a);
	              } : function(a) {
	                return setTimeout(
	                  a,
	                  16
	                );
	              }, cancel: "function" === typeof cancelAnimationFrame ? function(a) {
	                return cancelAnimationFrame(a);
	              } : clearTimeout }, Cb = "undefined" !== typeof performance && performance.now ? function() {
	                return performance.now();
	              } : function() {
	                return +/* @__PURE__ */ new Date();
	              }, B = gb();
	              B.zero = gb();
	              var bc = function(a, b) {
	                var c = 1;
	                b.ext_texture_filter_anisotropic && (c = a.getParameter(34047));
	                var d = 1, f = 1;
	                b.webgl_draw_buffers && (d = a.getParameter(34852), f = a.getParameter(36063));
	                var e = !!b.oes_texture_float;
	                if (e) {
	                  e = a.createTexture();
	                  a.bindTexture(3553, e);
	                  a.texImage2D(
	                    3553,
	                    0,
	                    6408,
	                    1,
	                    1,
	                    0,
	                    6408,
	                    5126,
	                    null
	                  );
	                  var m = a.createFramebuffer();
	                  a.bindFramebuffer(36160, m);
	                  a.framebufferTexture2D(36160, 36064, 3553, e, 0);
	                  a.bindTexture(3553, null);
	                  if (36053 !== a.checkFramebufferStatus(36160)) e = false;
	                  else {
	                    a.viewport(0, 0, 1, 1);
	                    a.clearColor(1, 0, 0, 1);
	                    a.clear(16384);
	                    var q = B.allocType(5126, 4);
	                    a.readPixels(0, 0, 1, 1, 6408, 5126, q);
	                    a.getError() ? e = false : (a.deleteFramebuffer(m), a.deleteTexture(e), e = 1 === q[0]);
	                    B.freeType(q);
	                  }
	                }
	                q = true;
	                "undefined" !== typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent)) || (q = a.createTexture(), m = B.allocType(5121, 36), a.activeTexture(33984), a.bindTexture(34067, q), a.texImage2D(34069, 0, 6408, 3, 3, 0, 6408, 5121, m), B.freeType(m), a.bindTexture(34067, null), a.deleteTexture(q), q = !a.getError());
	                return {
	                  colorBits: [a.getParameter(3410), a.getParameter(3411), a.getParameter(3412), a.getParameter(3413)],
	                  depthBits: a.getParameter(3414),
	                  stencilBits: a.getParameter(3415),
	                  subpixelBits: a.getParameter(3408),
	                  extensions: Object.keys(b).filter(function(a2) {
	                    return !!b[a2];
	                  }),
	                  maxAnisotropic: c,
	                  maxDrawbuffers: d,
	                  maxColorAttachments: f,
	                  pointSizeDims: a.getParameter(33901),
	                  lineWidthDims: a.getParameter(33902),
	                  maxViewportDims: a.getParameter(3386),
	                  maxCombinedTextureUnits: a.getParameter(35661),
	                  maxCubeMapSize: a.getParameter(34076),
	                  maxRenderbufferSize: a.getParameter(34024),
	                  maxTextureUnits: a.getParameter(34930),
	                  maxTextureSize: a.getParameter(3379),
	                  maxAttributes: a.getParameter(34921),
	                  maxVertexUniforms: a.getParameter(36347),
	                  maxVertexTextureUnits: a.getParameter(35660),
	                  maxVaryingVectors: a.getParameter(36348),
	                  maxFragmentUniforms: a.getParameter(36349),
	                  glsl: a.getParameter(35724),
	                  renderer: a.getParameter(7937),
	                  vendor: a.getParameter(7936),
	                  version: a.getParameter(7938),
	                  readFloat: e,
	                  npotTextureCube: q
	                };
	              }, P = function(a) {
	                return a instanceof Uint8Array || a instanceof Uint16Array || a instanceof Uint32Array || a instanceof Int8Array || a instanceof Int16Array || a instanceof Int32Array || a instanceof Float32Array || a instanceof Float64Array || a instanceof Uint8ClampedArray;
	              }, T = function(a) {
	                return Object.keys(a).map(function(b) {
	                  return a[b];
	                });
	              }, Pa = { shape: function(a) {
	                for (var b = []; a.length; a = a[0]) b.push(a.length);
	                return b;
	              }, flatten: function(a, b, c, d) {
	                var f = 1;
	                if (b.length) for (var e = 0; e < b.length; ++e) f *= b[e];
	                else f = 0;
	                c = d || B.allocType(c, f);
	                switch (b.length) {
	                  case 0:
	                    break;
	                  case 1:
	                    d = b[0];
	                    for (b = 0; b < d; ++b) c[b] = a[b];
	                    break;
	                  case 2:
	                    d = b[0];
	                    b = b[1];
	                    for (e = f = 0; e < d; ++e) for (var m = a[e], q = 0; q < b; ++q) c[f++] = m[q];
	                    break;
	                  case 3:
	                    hb(a, b[0], b[1], b[2], c, 0);
	                    break;
	                  default:
	                    ib(a, b, 0, c, 0);
	                }
	                return c;
	              } }, Ia = {
	                "[object Int8Array]": 5120,
	                "[object Int16Array]": 5122,
	                "[object Int32Array]": 5124,
	                "[object Uint8Array]": 5121,
	                "[object Uint8ClampedArray]": 5121,
	                "[object Uint16Array]": 5123,
	                "[object Uint32Array]": 5125,
	                "[object Float32Array]": 5126,
	                "[object Float64Array]": 5121,
	                "[object ArrayBuffer]": 5121
	              }, Ja = { int8: 5120, int16: 5122, int32: 5124, uint8: 5121, uint16: 5123, uint32: 5125, "float": 5126, float32: 5126 }, mb = { dynamic: 35048, stream: 35040, "static": 35044 }, Ua = Pa.flatten, lb = Pa.shape, ja = [];
	              ja[5120] = 1;
	              ja[5122] = 2;
	              ja[5124] = 4;
	              ja[5121] = 1;
	              ja[5123] = 2;
	              ja[5125] = 4;
	              ja[5126] = 4;
	              var Ka = {
	                points: 0,
	                point: 0,
	                lines: 1,
	                line: 1,
	                triangles: 4,
	                triangle: 4,
	                "line loop": 2,
	                "line strip": 3,
	                "triangle strip": 5,
	                "triangle fan": 6
	              }, pb = new Float32Array(1), Lb = new Uint32Array(pb.buffer), Pb = [9984, 9986, 9985, 9987], Na = [0, 6409, 6410, 6407, 6408], U = {};
	              U[6409] = U[6406] = U[6402] = 1;
	              U[34041] = U[6410] = 2;
	              U[6407] = U[35904] = 3;
	              U[6408] = U[35906] = 4;
	              var Wa = ra("HTMLCanvasElement"), Xa = ra("OffscreenCanvas"), ub = ra("CanvasRenderingContext2D"), vb = ra("ImageBitmap"), wb = ra("HTMLImageElement"), xb = ra("HTMLVideoElement"), Mb = Object.keys(Ia).concat([Wa, Xa, ub, vb, wb, xb]), ya = [];
	              ya[5121] = 1;
	              ya[5126] = 4;
	              ya[36193] = 2;
	              ya[5123] = 2;
	              ya[5125] = 4;
	              var G = [];
	              G[32854] = 2;
	              G[32855] = 2;
	              G[36194] = 2;
	              G[34041] = 4;
	              G[33776] = 0.5;
	              G[33777] = 0.5;
	              G[33778] = 1;
	              G[33779] = 1;
	              G[35986] = 0.5;
	              G[35987] = 1;
	              G[34798] = 1;
	              G[35840] = 0.5;
	              G[35841] = 0.25;
	              G[35842] = 0.5;
	              G[35843] = 0.25;
	              G[36196] = 0.5;
	              var M = [];
	              M[32854] = 2;
	              M[32855] = 2;
	              M[36194] = 2;
	              M[33189] = 2;
	              M[36168] = 1;
	              M[34041] = 4;
	              M[35907] = 4;
	              M[34836] = 16;
	              M[34842] = 8;
	              M[34843] = 6;
	              var cc = function(a, b, c, d, f) {
	                function e(a2) {
	                  this.id = r++;
	                  this.refCount = 1;
	                  this.renderbuffer = a2;
	                  this.format = 32854;
	                  this.height = this.width = 0;
	                  f.profile && (this.stats = { size: 0 });
	                }
	                function m(b2) {
	                  var c2 = b2.renderbuffer;
	                  a.bindRenderbuffer(36161, null);
	                  a.deleteRenderbuffer(c2);
	                  b2.renderbuffer = null;
	                  b2.refCount = 0;
	                  delete k[b2.id];
	                  d.renderbufferCount--;
	                }
	                var q = { rgba4: 32854, rgb565: 36194, "rgb5 a1": 32855, depth: 33189, stencil: 36168, "depth stencil": 34041 };
	                b.ext_srgb && (q.srgba = 35907);
	                b.ext_color_buffer_half_float && (q.rgba16f = 34842, q.rgb16f = 34843);
	                b.webgl_color_buffer_float && (q.rgba32f = 34836);
	                var u = [];
	                Object.keys(q).forEach(function(a2) {
	                  u[q[a2]] = a2;
	                });
	                var r = 0, k = {};
	                e.prototype.decRef = function() {
	                  0 >= --this.refCount && m(this);
	                };
	                f.profile && (d.getTotalRenderbufferSize = function() {
	                  var a2 = 0;
	                  Object.keys(k).forEach(function(b2) {
	                    a2 += k[b2].stats.size;
	                  });
	                  return a2;
	                });
	                return { create: function(b2, c2) {
	                  function g(b3, c3) {
	                    var d2 = 0, e2 = 0, k2 = 32854;
	                    "object" === typeof b3 && b3 ? ("shape" in b3 ? (e2 = b3.shape, d2 = e2[0] | 0, e2 = e2[1] | 0) : ("radius" in b3 && (d2 = e2 = b3.radius | 0), "width" in b3 && (d2 = b3.width | 0), "height" in b3 && (e2 = b3.height | 0)), "format" in b3 && (k2 = q[b3.format])) : "number" === typeof b3 ? (d2 = b3 | 0, e2 = "number" === typeof c3 ? c3 | 0 : d2) : b3 || (d2 = e2 = 1);
	                    if (d2 !== l.width || e2 !== l.height || k2 !== l.format) return g.width = l.width = d2, g.height = l.height = e2, l.format = k2, a.bindRenderbuffer(36161, l.renderbuffer), a.renderbufferStorage(36161, k2, d2, e2), f.profile && (l.stats.size = M[l.format] * l.width * l.height), g.format = u[l.format], g;
	                  }
	                  var l = new e(a.createRenderbuffer());
	                  k[l.id] = l;
	                  d.renderbufferCount++;
	                  g(b2, c2);
	                  g.resize = function(b3, c3) {
	                    var d2 = b3 | 0, e2 = c3 | 0 || d2;
	                    if (d2 === l.width && e2 === l.height) return g;
	                    g.width = l.width = d2;
	                    g.height = l.height = e2;
	                    a.bindRenderbuffer(36161, l.renderbuffer);
	                    a.renderbufferStorage(36161, l.format, d2, e2);
	                    f.profile && (l.stats.size = M[l.format] * l.width * l.height);
	                    return g;
	                  };
	                  g._reglType = "renderbuffer";
	                  g._renderbuffer = l;
	                  f.profile && (g.stats = l.stats);
	                  g.destroy = function() {
	                    l.decRef();
	                  };
	                  return g;
	                }, clear: function() {
	                  T(k).forEach(m);
	                }, restore: function() {
	                  T(k).forEach(function(b2) {
	                    b2.renderbuffer = a.createRenderbuffer();
	                    a.bindRenderbuffer(36161, b2.renderbuffer);
	                    a.renderbufferStorage(36161, b2.format, b2.width, b2.height);
	                  });
	                  a.bindRenderbuffer(36161, null);
	                } };
	              }, Ya = [];
	              Ya[6408] = 4;
	              Ya[6407] = 3;
	              var Ra = [];
	              Ra[5121] = 1;
	              Ra[5126] = 4;
	              Ra[36193] = 2;
	              var Vb = [
	                1116352408,
	                1899447441,
	                -1245643825,
	                -373957723,
	                961987163,
	                1508970993,
	                -1841331548,
	                -1424204075,
	                -670586216,
	                310598401,
	                607225278,
	                1426881987,
	                1925078388,
	                -2132889090,
	                -1680079193,
	                -1046744716,
	                -459576895,
	                -272742522,
	                264347078,
	                604807628,
	                770255983,
	                1249150122,
	                1555081692,
	                1996064986,
	                -1740746414,
	                -1473132947,
	                -1341970488,
	                -1084653625,
	                -958395405,
	                -710438585,
	                113926993,
	                338241895,
	                666307205,
	                773529912,
	                1294757372,
	                1396182291,
	                1695183700,
	                1986661051,
	                -2117940946,
	                -1838011259,
	                -1564481375,
	                -1474664885,
	                -1035236496,
	                -949202525,
	                -778901479,
	                -694614492,
	                -200395387,
	                275423344,
	                430227734,
	                506948616,
	                659060556,
	                883997877,
	                958139571,
	                1322822218,
	                1537002063,
	                1747873779,
	                1955562222,
	                2024104815,
	                -2067236844,
	                -1933114872,
	                -1866530822,
	                -1538233109,
	                -1090935817,
	                -965641998
	              ], Ca = ["x", "y", "z", "w"], ac = "blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "), Ga = {
	                0: 0,
	                1: 1,
	                zero: 0,
	                one: 1,
	                "src color": 768,
	                "one minus src color": 769,
	                "src alpha": 770,
	                "one minus src alpha": 771,
	                "dst color": 774,
	                "one minus dst color": 775,
	                "dst alpha": 772,
	                "one minus dst alpha": 773,
	                "constant color": 32769,
	                "one minus constant color": 32770,
	                "constant alpha": 32771,
	                "one minus constant alpha": 32772,
	                "src alpha saturate": 776
	              }, $a = { never: 512, less: 513, "<": 513, equal: 514, "=": 514, "==": 514, "===": 514, lequal: 515, "<=": 515, greater: 516, ">": 516, notequal: 517, "!=": 517, "!==": 517, gequal: 518, ">=": 518, always: 519 }, Ta = { 0: 0, zero: 0, keep: 7680, replace: 7681, increment: 7682, decrement: 7683, "increment wrap": 34055, "decrement wrap": 34056, invert: 5386 }, zb = { cw: 2304, ccw: 2305 }, Ab = new K(false, false, false, function() {
	              }), dc = function(a, b) {
	                function c() {
	                  this.endQueryIndex = this.startQueryIndex = -1;
	                  this.sum = 0;
	                  this.stats = null;
	                }
	                function d(a2, b2, d2) {
	                  var e2 = m.pop() || new c();
	                  e2.startQueryIndex = a2;
	                  e2.endQueryIndex = b2;
	                  e2.sum = 0;
	                  e2.stats = d2;
	                  q.push(e2);
	                }
	                if (!b.ext_disjoint_timer_query) return null;
	                var f = [], e = [], m = [], q = [], u = [], r = [];
	                return {
	                  beginQuery: function(a2) {
	                    var c2 = f.pop() || b.ext_disjoint_timer_query.createQueryEXT();
	                    b.ext_disjoint_timer_query.beginQueryEXT(35007, c2);
	                    e.push(c2);
	                    d(e.length - 1, e.length, a2);
	                  },
	                  endQuery: function() {
	                    b.ext_disjoint_timer_query.endQueryEXT(35007);
	                  },
	                  pushScopeStats: d,
	                  update: function() {
	                    var a2, c2;
	                    a2 = e.length;
	                    if (0 !== a2) {
	                      r.length = Math.max(r.length, a2 + 1);
	                      u.length = Math.max(u.length, a2 + 1);
	                      u[0] = 0;
	                      var d2 = r[0] = 0;
	                      for (c2 = a2 = 0; c2 < e.length; ++c2) {
	                        var g = e[c2];
	                        b.ext_disjoint_timer_query.getQueryObjectEXT(g, 34919) ? (d2 += b.ext_disjoint_timer_query.getQueryObjectEXT(g, 34918), f.push(g)) : e[a2++] = g;
	                        u[c2 + 1] = d2;
	                        r[c2 + 1] = a2;
	                      }
	                      e.length = a2;
	                      for (c2 = a2 = 0; c2 < q.length; ++c2) {
	                        var d2 = q[c2], l = d2.startQueryIndex, g = d2.endQueryIndex;
	                        d2.sum += u[g] - u[l];
	                        l = r[l];
	                        g = r[g];
	                        g === l ? (d2.stats.gpuTime += d2.sum / 1e6, m.push(d2)) : (d2.startQueryIndex = l, d2.endQueryIndex = g, q[a2++] = d2);
	                      }
	                      q.length = a2;
	                    }
	                  },
	                  getNumPendingQueries: function() {
	                    return e.length;
	                  },
	                  clear: function() {
	                    f.push.apply(f, e);
	                    for (var a2 = 0; a2 < f.length; a2++) b.ext_disjoint_timer_query.deleteQueryEXT(f[a2]);
	                    e.length = 0;
	                    f.length = 0;
	                  },
	                  restore: function() {
	                    e.length = 0;
	                    f.length = 0;
	                  }
	                };
	              };
	              return function(a) {
	                function b() {
	                  if (0 === I.length) z && z.update(), R2 = null;
	                  else {
	                    R2 = ab.next(b);
	                    k();
	                    for (var a2 = I.length - 1; 0 <= a2; --a2) {
	                      var c2 = I[a2];
	                      c2 && c2(D, null, 0);
	                    }
	                    g.flush();
	                    z && z.update();
	                  }
	                }
	                function c() {
	                  !R2 && 0 < I.length && (R2 = ab.next(b));
	                }
	                function d() {
	                  R2 && (ab.cancel(b), R2 = null);
	                }
	                function f(a2) {
	                  a2.preventDefault();
	                  d();
	                  S2.forEach(function(a3) {
	                    a3();
	                  });
	                }
	                function e(a2) {
	                  g.getError();
	                  h.restore();
	                  J.restore();
	                  G2.restore();
	                  L2.restore();
	                  P2.restore();
	                  V.restore();
	                  A.restore();
	                  z && z.restore();
	                  M2.procs.refresh();
	                  c();
	                  T2.forEach(function(a3) {
	                    a3();
	                  });
	                }
	                function m(a2) {
	                  function b2(a3, c3) {
	                    var d3 = {}, e3 = {};
	                    Object.keys(a3).forEach(function(b3) {
	                      var f3 = a3[b3];
	                      if (Z.isDynamic(f3)) e3[b3] = Z.unbox(f3, b3);
	                      else {
	                        if (c3 && Array.isArray(f3)) {
	                          for (var g3 = 0; g3 < f3.length; ++g3) if (Z.isDynamic(f3[g3])) {
	                            e3[b3] = Z.unbox(f3, b3);
	                            return;
	                          }
	                        }
	                        d3[b3] = f3;
	                      }
	                    });
	                    return { dynamic: e3, "static": d3 };
	                  }
	                  function c2(a3) {
	                    for (; n2.length < a3; ) n2.push(null);
	                    return n2;
	                  }
	                  var d2 = b2(a2.context || {}, true), e2 = b2(a2.uniforms || {}, true), f2 = b2(a2.attributes || {}, false);
	                  a2 = b2(function(a3) {
	                    function b3(a4) {
	                      if (a4 in c3) {
	                        var d3 = c3[a4];
	                        delete c3[a4];
	                        Object.keys(d3).forEach(function(b4) {
	                          c3[a4 + "." + b4] = d3[b4];
	                        });
	                      }
	                    }
	                    var c3 = O({}, a3);
	                    delete c3.uniforms;
	                    delete c3.attributes;
	                    delete c3.context;
	                    delete c3.vao;
	                    "stencil" in c3 && c3.stencil.op && (c3.stencil.opBack = c3.stencil.opFront = c3.stencil.op, delete c3.stencil.op);
	                    b3("blend");
	                    b3("depth");
	                    b3("cull");
	                    b3("stencil");
	                    b3("polygonOffset");
	                    b3("scissor");
	                    b3("sample");
	                    "vao" in a3 && (c3.vao = a3.vao);
	                    return c3;
	                  }(a2), false);
	                  var g2 = { gpuTime: 0, cpuTime: 0, count: 0 }, h2 = M2.compile(a2, f2, e2, d2, g2), k2 = h2.draw, l2 = h2.batch, m2 = h2.scope, n2 = [];
	                  return O(function(a3, b3) {
	                    var d3;
	                    if ("function" === typeof a3) return m2.call(this, null, a3, 0);
	                    if ("function" === typeof b3) if ("number" === typeof a3) for (d3 = 0; d3 < a3; ++d3) m2.call(this, null, b3, d3);
	                    else if (Array.isArray(a3)) for (d3 = 0; d3 < a3.length; ++d3) m2.call(this, a3[d3], b3, d3);
	                    else return m2.call(this, a3, b3, 0);
	                    else if ("number" === typeof a3) {
	                      if (0 < a3) return l2.call(this, c2(a3 | 0), a3 | 0);
	                    } else if (Array.isArray(a3)) {
	                      if (a3.length) return l2.call(
	                        this,
	                        a3,
	                        a3.length
	                      );
	                    } else return k2.call(this, a3);
	                  }, { stats: g2, destroy: function() {
	                    h2.destroy();
	                  } });
	                }
	                function q(a2, b2) {
	                  var c2 = 0;
	                  M2.procs.poll();
	                  var d2 = b2.color;
	                  d2 && (g.clearColor(+d2[0] || 0, +d2[1] || 0, +d2[2] || 0, +d2[3] || 0), c2 |= 16384);
	                  "depth" in b2 && (g.clearDepth(+b2.depth), c2 |= 256);
	                  "stencil" in b2 && (g.clearStencil(b2.stencil | 0), c2 |= 1024);
	                  g.clear(c2);
	                }
	                function u(a2) {
	                  I.push(a2);
	                  c();
	                  return { cancel: function() {
	                    function b2() {
	                      var a3 = Bb(I, b2);
	                      I[a3] = I[I.length - 1];
	                      --I.length;
	                      0 >= I.length && d();
	                    }
	                    var c2 = Bb(I, a2);
	                    I[c2] = b2;
	                  } };
	                }
	                function r() {
	                  var a2 = W.viewport, b2 = W.scissor_box;
	                  a2[0] = a2[1] = b2[0] = b2[1] = 0;
	                  D.viewportWidth = D.framebufferWidth = D.drawingBufferWidth = a2[2] = b2[2] = g.drawingBufferWidth;
	                  D.viewportHeight = D.framebufferHeight = D.drawingBufferHeight = a2[3] = b2[3] = g.drawingBufferHeight;
	                }
	                function k() {
	                  D.tick += 1;
	                  D.time = t();
	                  r();
	                  M2.procs.poll();
	                }
	                function n() {
	                  L2.refresh();
	                  r();
	                  M2.procs.refresh();
	                  z && z.update();
	                }
	                function t() {
	                  return (Cb() - E2) / 1e3;
	                }
	                a = Hb(a);
	                if (!a) return null;
	                var g = a.gl, l = g.getContextAttributes();
	                g.isContextLost();
	                var h = Ib(g, a);
	                if (!h) return null;
	                var p = Eb(), y = {
	                  vaoCount: 0,
	                  bufferCount: 0,
	                  elementsCount: 0,
	                  framebufferCount: 0,
	                  shaderCount: 0,
	                  textureCount: 0,
	                  cubeCount: 0,
	                  renderbufferCount: 0,
	                  maxTextureUnits: 0
	                }, C = a.cachedCode || {}, w = h.extensions, z = dc(g, w), E2 = Cb(), B2 = g.drawingBufferWidth, H2 = g.drawingBufferHeight, D = { tick: 0, time: 0, viewportWidth: B2, viewportHeight: H2, framebufferWidth: B2, framebufferHeight: H2, drawingBufferWidth: B2, drawingBufferHeight: H2, pixelRatio: a.pixelRatio }, B2 = { elements: null, primitive: 4, count: -1, offset: 0, instances: -1 }, v = bc(g, w), G2 = Jb(g, y, a, function(a2) {
	                  return A.destroyBuffer(a2);
	                }), K2 = Kb(g, w, G2, y), A = Rb(
	                  g,
	                  w,
	                  v,
	                  y,
	                  G2,
	                  K2,
	                  B2
	                ), J = Sb(g, p, y, a), L2 = Nb(g, w, v, function() {
	                  M2.procs.poll();
	                }, D, y, a), P2 = cc(g, w, v, y, a), V = Qb(g, w, v, L2, P2, y), M2 = Zb(g, p, w, v, G2, K2, L2, V, {}, A, J, B2, D, z, C, a), p = Tb(g, V, M2.procs.poll, D), W = M2.next, Q = g.canvas, I = [], S2 = [], T2 = [], U2 = [a.onDestroy], R2 = null;
	                Q && (Q.addEventListener("webglcontextlost", f, false), Q.addEventListener("webglcontextrestored", e, false));
	                var Y2 = V.setFBO = m({ framebuffer: Z.define.call(null, 1, "framebuffer") });
	                n();
	                l = O(m, {
	                  clear: function(a2) {
	                    if ("framebuffer" in a2) if (a2.framebuffer && "framebufferCube" === a2.framebuffer_reglType) for (var b2 = 0; 6 > b2; ++b2) Y2(O({ framebuffer: a2.framebuffer.faces[b2] }, a2), q);
	                    else Y2(a2, q);
	                    else q(null, a2);
	                  },
	                  prop: Z.define.bind(null, 1),
	                  context: Z.define.bind(null, 2),
	                  "this": Z.define.bind(null, 3),
	                  draw: m({}),
	                  buffer: function(a2) {
	                    return G2.create(a2, 34962, false, false);
	                  },
	                  elements: function(a2) {
	                    return K2.create(a2, false);
	                  },
	                  texture: L2.create2D,
	                  cube: L2.createCube,
	                  renderbuffer: P2.create,
	                  framebuffer: V.create,
	                  framebufferCube: V.createCube,
	                  vao: A.createVAO,
	                  attributes: l,
	                  frame: u,
	                  on: function(a2, b2) {
	                    var c2;
	                    switch (a2) {
	                      case "frame":
	                        return u(b2);
	                      case "lost":
	                        c2 = S2;
	                        break;
	                      case "restore":
	                        c2 = T2;
	                        break;
	                      case "destroy":
	                        c2 = U2;
	                    }
	                    c2.push(b2);
	                    return { cancel: function() {
	                      for (var a3 = 0; a3 < c2.length; ++a3) if (c2[a3] === b2) {
	                        c2[a3] = c2[c2.length - 1];
	                        c2.pop();
	                        break;
	                      }
	                    } };
	                  },
	                  limits: v,
	                  hasExtension: function(a2) {
	                    return 0 <= v.extensions.indexOf(a2.toLowerCase());
	                  },
	                  read: p,
	                  destroy: function() {
	                    I.length = 0;
	                    d();
	                    Q && (Q.removeEventListener("webglcontextlost", f), Q.removeEventListener("webglcontextrestored", e));
	                    J.clear();
	                    V.clear();
	                    P2.clear();
	                    A.clear();
	                    L2.clear();
	                    K2.clear();
	                    G2.clear();
	                    z && z.clear();
	                    U2.forEach(function(a2) {
	                      a2();
	                    });
	                  },
	                  _gl: g,
	                  _refresh: n,
	                  poll: function() {
	                    k();
	                    z && z.update();
	                  },
	                  now: t,
	                  stats: y,
	                  getCachedCode: function() {
	                    return C;
	                  },
	                  preloadCachedCode: function(a2) {
	                    Object.entries(a2).forEach(function(a3) {
	                      C[a3[0]] = a3[1];
	                    });
	                  }
	                });
	                a.onDone(null, l);
	                return l;
	              };
	            });
	          }
	        ),
	        /***/
	        71665: (
	          /***/
	          function(module2, exports2, __webpack_require__2) {
	            /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
	            var buffer = __webpack_require__2(12856);
	            var Buffer2 = buffer.Buffer;
	            function copyProps(src, dst) {
	              for (var key in src) {
	                dst[key] = src[key];
	              }
	            }
	            if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) {
	              module2.exports = buffer;
	            } else {
	              copyProps(buffer, exports2);
	              exports2.Buffer = SafeBuffer;
	            }
	            function SafeBuffer(arg, encodingOrOffset, length) {
	              return Buffer2(arg, encodingOrOffset, length);
	            }
	            SafeBuffer.prototype = Object.create(Buffer2.prototype);
	            copyProps(Buffer2, SafeBuffer);
	            SafeBuffer.from = function(arg, encodingOrOffset, length) {
	              if (typeof arg === "number") {
	                throw new TypeError("Argument must not be a number");
	              }
	              return Buffer2(arg, encodingOrOffset, length);
	            };
	            SafeBuffer.alloc = function(size, fill, encoding) {
	              if (typeof size !== "number") {
	                throw new TypeError("Argument must be a number");
	              }
	              var buf = Buffer2(size);
	              if (fill !== undefined) {
	                if (typeof encoding === "string") {
	                  buf.fill(fill, encoding);
	                } else {
	                  buf.fill(fill);
	                }
	              } else {
	                buf.fill(0);
	              }
	              return buf;
	            };
	            SafeBuffer.allocUnsafe = function(size) {
	              if (typeof size !== "number") {
	                throw new TypeError("Argument must be a number");
	              }
	              return Buffer2(size);
	            };
	            SafeBuffer.allocUnsafeSlow = function(size) {
	              if (typeof size !== "number") {
	                throw new TypeError("Argument must be a number");
	              }
	              return buffer.SlowBuffer(size);
	            };
	          }
	        ),
	        /***/
	        21630: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = Stream;
	            var EE = __webpack_require__2(15398).EventEmitter;
	            var inherits = __webpack_require__2(42018);
	            inherits(Stream, EE);
	            Stream.Readable = __webpack_require__2(40410);
	            Stream.Writable = __webpack_require__2(37493);
	            Stream.Duplex = __webpack_require__2(37865);
	            Stream.Transform = __webpack_require__2(74308);
	            Stream.PassThrough = __webpack_require__2(66897);
	            Stream.finished = __webpack_require__2(12726);
	            Stream.pipeline = __webpack_require__2(10168);
	            Stream.Stream = Stream;
	            function Stream() {
	              EE.call(this);
	            }
	            Stream.prototype.pipe = function(dest, options) {
	              var source = this;
	              function ondata(chunk) {
	                if (dest.writable) {
	                  if (false === dest.write(chunk) && source.pause) {
	                    source.pause();
	                  }
	                }
	              }
	              source.on("data", ondata);
	              function ondrain() {
	                if (source.readable && source.resume) {
	                  source.resume();
	                }
	              }
	              dest.on("drain", ondrain);
	              if (!dest._isStdio && (!options || options.end !== false)) {
	                source.on("end", onend);
	                source.on("close", onclose);
	              }
	              var didOnEnd = false;
	              function onend() {
	                if (didOnEnd) return;
	                didOnEnd = true;
	                dest.end();
	              }
	              function onclose() {
	                if (didOnEnd) return;
	                didOnEnd = true;
	                if (typeof dest.destroy === "function") dest.destroy();
	              }
	              function onerror(er) {
	                cleanup();
	                if (EE.listenerCount(this, "error") === 0) {
	                  throw er;
	                }
	              }
	              source.on("error", onerror);
	              dest.on("error", onerror);
	              function cleanup() {
	                source.removeListener("data", ondata);
	                dest.removeListener("drain", ondrain);
	                source.removeListener("end", onend);
	                source.removeListener("close", onclose);
	                source.removeListener("error", onerror);
	                dest.removeListener("error", onerror);
	                source.removeListener("end", cleanup);
	                source.removeListener("close", cleanup);
	                dest.removeListener("close", cleanup);
	              }
	              source.on("end", cleanup);
	              source.on("close", cleanup);
	              dest.on("close", cleanup);
	              dest.emit("pipe", source);
	              return dest;
	            };
	          }
	        ),
	        /***/
	        74322: (
	          /***/
	          function(module2) {
	            function _inheritsLoose(subClass, superClass) {
	              subClass.prototype = Object.create(superClass.prototype);
	              subClass.prototype.constructor = subClass;
	              subClass.__proto__ = superClass;
	            }
	            var codes = {};
	            function createErrorType(code, message, Base) {
	              if (!Base) {
	                Base = Error;
	              }
	              function getMessage(arg1, arg2, arg3) {
	                if (typeof message === "string") {
	                  return message;
	                } else {
	                  return message(arg1, arg2, arg3);
	                }
	              }
	              var NodeError = /* @__PURE__ */ function(_Base) {
	                _inheritsLoose(NodeError2, _Base);
	                function NodeError2(arg1, arg2, arg3) {
	                  return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
	                }
	                return NodeError2;
	              }(Base);
	              NodeError.prototype.name = Base.name;
	              NodeError.prototype.code = code;
	              codes[code] = NodeError;
	            }
	            function oneOf(expected, thing) {
	              if (Array.isArray(expected)) {
	                var len = expected.length;
	                expected = expected.map(function(i) {
	                  return String(i);
	                });
	                if (len > 2) {
	                  return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
	                } else if (len === 2) {
	                  return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
	                } else {
	                  return "of ".concat(thing, " ").concat(expected[0]);
	                }
	              } else {
	                return "of ".concat(thing, " ").concat(String(expected));
	              }
	            }
	            function startsWith(str, search, pos) {
	              return str.substr(0 , search.length) === search;
	            }
	            function endsWith(str, search, this_len) {
	              if (this_len === undefined || this_len > str.length) {
	                this_len = str.length;
	              }
	              return str.substring(this_len - search.length, this_len) === search;
	            }
	            function includes(str, search, start) {
	              if (typeof start !== "number") {
	                start = 0;
	              }
	              if (start + search.length > str.length) {
	                return false;
	              } else {
	                return str.indexOf(search, start) !== -1;
	              }
	            }
	            createErrorType("ERR_INVALID_OPT_VALUE", function(name2, value) {
	              return 'The value "' + value + '" is invalid for option "' + name2 + '"';
	            }, TypeError);
	            createErrorType("ERR_INVALID_ARG_TYPE", function(name2, expected, actual) {
	              var determiner;
	              if (typeof expected === "string" && startsWith(expected, "not ")) {
	                determiner = "must not be";
	                expected = expected.replace(/^not /, "");
	              } else {
	                determiner = "must be";
	              }
	              var msg;
	              if (endsWith(name2, " argument")) {
	                msg = "The ".concat(name2, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
	              } else {
	                var type = includes(name2, ".") ? "property" : "argument";
	                msg = 'The "'.concat(name2, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
	              }
	              msg += ". Received type ".concat(typeof actual);
	              return msg;
	            }, TypeError);
	            createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
	            createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name2) {
	              return "The " + name2 + " method is not implemented";
	            });
	            createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
	            createErrorType("ERR_STREAM_DESTROYED", function(name2) {
	              return "Cannot call " + name2 + " after a stream was destroyed";
	            });
	            createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
	            createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
	            createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
	            createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
	            createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
	              return "Unknown encoding: " + arg;
	            }, TypeError);
	            createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
	            module2.exports.q = codes;
	          }
	        ),
	        /***/
	        37865: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            var objectKeys = Object.keys || function(obj) {
	              var keys2 = [];
	              for (var key in obj) {
	                keys2.push(key);
	              }
	              return keys2;
	            };
	            module2.exports = Duplex;
	            var Readable = __webpack_require__2(40410);
	            var Writable = __webpack_require__2(37493);
	            __webpack_require__2(42018)(Duplex, Readable);
	            {
	              var keys = objectKeys(Writable.prototype);
	              for (var v = 0; v < keys.length; v++) {
	                var method = keys[v];
	                if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	              }
	            }
	            function Duplex(options) {
	              if (!(this instanceof Duplex)) return new Duplex(options);
	              Readable.call(this, options);
	              Writable.call(this, options);
	              this.allowHalfOpen = true;
	              if (options) {
	                if (options.readable === false) this.readable = false;
	                if (options.writable === false) this.writable = false;
	                if (options.allowHalfOpen === false) {
	                  this.allowHalfOpen = false;
	                  this.once("end", onend);
	                }
	              }
	            }
	            Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._writableState.highWaterMark;
	              }
	            });
	            Object.defineProperty(Duplex.prototype, "writableBuffer", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._writableState && this._writableState.getBuffer();
	              }
	            });
	            Object.defineProperty(Duplex.prototype, "writableLength", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._writableState.length;
	              }
	            });
	            function onend() {
	              if (this._writableState.ended) return;
	              process.nextTick(onEndNT, this);
	            }
	            function onEndNT(self2) {
	              self2.end();
	            }
	            Object.defineProperty(Duplex.prototype, "destroyed", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                if (this._readableState === undefined || this._writableState === undefined) {
	                  return false;
	                }
	                return this._readableState.destroyed && this._writableState.destroyed;
	              },
	              set: function set(value) {
	                if (this._readableState === undefined || this._writableState === undefined) {
	                  return;
	                }
	                this._readableState.destroyed = value;
	                this._writableState.destroyed = value;
	              }
	            });
	          }
	        ),
	        /***/
	        66897: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = PassThrough;
	            var Transform = __webpack_require__2(74308);
	            __webpack_require__2(42018)(PassThrough, Transform);
	            function PassThrough(options) {
	              if (!(this instanceof PassThrough)) return new PassThrough(options);
	              Transform.call(this, options);
	            }
	            PassThrough.prototype._transform = function(chunk, encoding, cb) {
	              cb(null, chunk);
	            };
	          }
	        ),
	        /***/
	        40410: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            module2.exports = Readable;
	            var Duplex;
	            Readable.ReadableState = ReadableState;
	            __webpack_require__2(15398).EventEmitter;
	            var EElistenerCount = function EElistenerCount2(emitter, type) {
	              return emitter.listeners(type).length;
	            };
	            var Stream = __webpack_require__2(71405);
	            var Buffer2 = __webpack_require__2(12856).Buffer;
	            var OurUint8Array = __webpack_require__2.g.Uint8Array || function() {
	            };
	            function _uint8ArrayToBuffer(chunk) {
	              return Buffer2.from(chunk);
	            }
	            function _isUint8Array(obj) {
	              return Buffer2.isBuffer(obj) || obj instanceof OurUint8Array;
	            }
	            var debugUtil = __webpack_require__2(40964);
	            var debug;
	            if (debugUtil && debugUtil.debuglog) {
	              debug = debugUtil.debuglog("stream");
	            } else {
	              debug = function debug2() {
	              };
	            }
	            var BufferList = __webpack_require__2(31125);
	            var destroyImpl = __webpack_require__2(65756);
	            var _require = __webpack_require__2(56306), getHighWaterMark = _require.getHighWaterMark;
	            var _require$codes = __webpack_require__2(74322).q, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
	            var StringDecoder;
	            var createReadableStreamAsyncIterator;
	            var from;
	            __webpack_require__2(42018)(Readable, Stream);
	            var errorOrDestroy = destroyImpl.errorOrDestroy;
	            var kProxyEvents = ["error", "close", "destroy", "pause", "resume"];
	            function prependListener(emitter, event, fn) {
	              if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
	              if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
	              else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
	              else emitter._events[event] = [fn, emitter._events[event]];
	            }
	            function ReadableState(options, stream, isDuplex) {
	              Duplex = Duplex || __webpack_require__2(37865);
	              options = options || {};
	              if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
	              this.objectMode = !!options.objectMode;
	              if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	              this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
	              this.buffer = new BufferList();
	              this.length = 0;
	              this.pipes = null;
	              this.pipesCount = 0;
	              this.flowing = null;
	              this.ended = false;
	              this.endEmitted = false;
	              this.reading = false;
	              this.sync = true;
	              this.needReadable = false;
	              this.emittedReadable = false;
	              this.readableListening = false;
	              this.resumeScheduled = false;
	              this.paused = true;
	              this.emitClose = options.emitClose !== false;
	              this.autoDestroy = !!options.autoDestroy;
	              this.destroyed = false;
	              this.defaultEncoding = options.defaultEncoding || "utf8";
	              this.awaitDrain = 0;
	              this.readingMore = false;
	              this.decoder = null;
	              this.encoding = null;
	              if (options.encoding) {
	                if (!StringDecoder) StringDecoder = __webpack_require__2(68019).s;
	                this.decoder = new StringDecoder(options.encoding);
	                this.encoding = options.encoding;
	              }
	            }
	            function Readable(options) {
	              Duplex = Duplex || __webpack_require__2(37865);
	              if (!(this instanceof Readable)) return new Readable(options);
	              var isDuplex = this instanceof Duplex;
	              this._readableState = new ReadableState(options, this, isDuplex);
	              this.readable = true;
	              if (options) {
	                if (typeof options.read === "function") this._read = options.read;
	                if (typeof options.destroy === "function") this._destroy = options.destroy;
	              }
	              Stream.call(this);
	            }
	            Object.defineProperty(Readable.prototype, "destroyed", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                if (this._readableState === undefined) {
	                  return false;
	                }
	                return this._readableState.destroyed;
	              },
	              set: function set(value) {
	                if (!this._readableState) {
	                  return;
	                }
	                this._readableState.destroyed = value;
	              }
	            });
	            Readable.prototype.destroy = destroyImpl.destroy;
	            Readable.prototype._undestroy = destroyImpl.undestroy;
	            Readable.prototype._destroy = function(err, cb) {
	              cb(err);
	            };
	            Readable.prototype.push = function(chunk, encoding) {
	              var state = this._readableState;
	              var skipChunkCheck;
	              if (!state.objectMode) {
	                if (typeof chunk === "string") {
	                  encoding = encoding || state.defaultEncoding;
	                  if (encoding !== state.encoding) {
	                    chunk = Buffer2.from(chunk, encoding);
	                    encoding = "";
	                  }
	                  skipChunkCheck = true;
	                }
	              } else {
	                skipChunkCheck = true;
	              }
	              return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	            };
	            Readable.prototype.unshift = function(chunk) {
	              return readableAddChunk(this, chunk, null, true, false);
	            };
	            function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	              debug("readableAddChunk", chunk);
	              var state = stream._readableState;
	              if (chunk === null) {
	                state.reading = false;
	                onEofChunk(stream, state);
	              } else {
	                var er;
	                if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	                if (er) {
	                  errorOrDestroy(stream, er);
	                } else if (state.objectMode || chunk && chunk.length > 0) {
	                  if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer2.prototype) {
	                    chunk = _uint8ArrayToBuffer(chunk);
	                  }
	                  if (addToFront) {
	                    if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
	                    else addChunk(stream, state, chunk, true);
	                  } else if (state.ended) {
	                    errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
	                  } else if (state.destroyed) {
	                    return false;
	                  } else {
	                    state.reading = false;
	                    if (state.decoder && !encoding) {
	                      chunk = state.decoder.write(chunk);
	                      if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
	                      else maybeReadMore(stream, state);
	                    } else {
	                      addChunk(stream, state, chunk, false);
	                    }
	                  }
	                } else if (!addToFront) {
	                  state.reading = false;
	                  maybeReadMore(stream, state);
	                }
	              }
	              return !state.ended && (state.length < state.highWaterMark || state.length === 0);
	            }
	            function addChunk(stream, state, chunk, addToFront) {
	              if (state.flowing && state.length === 0 && !state.sync) {
	                state.awaitDrain = 0;
	                stream.emit("data", chunk);
	              } else {
	                state.length += state.objectMode ? 1 : chunk.length;
	                if (addToFront) state.buffer.unshift(chunk);
	                else state.buffer.push(chunk);
	                if (state.needReadable) emitReadable(stream);
	              }
	              maybeReadMore(stream, state);
	            }
	            function chunkInvalid(state, chunk) {
	              var er;
	              if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) {
	                er = new ERR_INVALID_ARG_TYPE("chunk", ["string", "Buffer", "Uint8Array"], chunk);
	              }
	              return er;
	            }
	            Readable.prototype.isPaused = function() {
	              return this._readableState.flowing === false;
	            };
	            Readable.prototype.setEncoding = function(enc) {
	              if (!StringDecoder) StringDecoder = __webpack_require__2(68019).s;
	              var decoder = new StringDecoder(enc);
	              this._readableState.decoder = decoder;
	              this._readableState.encoding = this._readableState.decoder.encoding;
	              var p = this._readableState.buffer.head;
	              var content = "";
	              while (p !== null) {
	                content += decoder.write(p.data);
	                p = p.next;
	              }
	              this._readableState.buffer.clear();
	              if (content !== "") this._readableState.buffer.push(content);
	              this._readableState.length = content.length;
	              return this;
	            };
	            var MAX_HWM = 1073741824;
	            function computeNewHighWaterMark(n) {
	              if (n >= MAX_HWM) {
	                n = MAX_HWM;
	              } else {
	                n--;
	                n |= n >>> 1;
	                n |= n >>> 2;
	                n |= n >>> 4;
	                n |= n >>> 8;
	                n |= n >>> 16;
	                n++;
	              }
	              return n;
	            }
	            function howMuchToRead(n, state) {
	              if (n <= 0 || state.length === 0 && state.ended) return 0;
	              if (state.objectMode) return 1;
	              if (n !== n) {
	                if (state.flowing && state.length) return state.buffer.head.data.length;
	                else return state.length;
	              }
	              if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	              if (n <= state.length) return n;
	              if (!state.ended) {
	                state.needReadable = true;
	                return 0;
	              }
	              return state.length;
	            }
	            Readable.prototype.read = function(n) {
	              debug("read", n);
	              n = parseInt(n, 10);
	              var state = this._readableState;
	              var nOrig = n;
	              if (n !== 0) state.emittedReadable = false;
	              if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
	                debug("read: emitReadable", state.length, state.ended);
	                if (state.length === 0 && state.ended) endReadable(this);
	                else emitReadable(this);
	                return null;
	              }
	              n = howMuchToRead(n, state);
	              if (n === 0 && state.ended) {
	                if (state.length === 0) endReadable(this);
	                return null;
	              }
	              var doRead = state.needReadable;
	              debug("need readable", doRead);
	              if (state.length === 0 || state.length - n < state.highWaterMark) {
	                doRead = true;
	                debug("length less than watermark", doRead);
	              }
	              if (state.ended || state.reading) {
	                doRead = false;
	                debug("reading or ended", doRead);
	              } else if (doRead) {
	                debug("do read");
	                state.reading = true;
	                state.sync = true;
	                if (state.length === 0) state.needReadable = true;
	                this._read(state.highWaterMark);
	                state.sync = false;
	                if (!state.reading) n = howMuchToRead(nOrig, state);
	              }
	              var ret;
	              if (n > 0) ret = fromList(n, state);
	              else ret = null;
	              if (ret === null) {
	                state.needReadable = state.length <= state.highWaterMark;
	                n = 0;
	              } else {
	                state.length -= n;
	                state.awaitDrain = 0;
	              }
	              if (state.length === 0) {
	                if (!state.ended) state.needReadable = true;
	                if (nOrig !== n && state.ended) endReadable(this);
	              }
	              if (ret !== null) this.emit("data", ret);
	              return ret;
	            };
	            function onEofChunk(stream, state) {
	              debug("onEofChunk");
	              if (state.ended) return;
	              if (state.decoder) {
	                var chunk = state.decoder.end();
	                if (chunk && chunk.length) {
	                  state.buffer.push(chunk);
	                  state.length += state.objectMode ? 1 : chunk.length;
	                }
	              }
	              state.ended = true;
	              if (state.sync) {
	                emitReadable(stream);
	              } else {
	                state.needReadable = false;
	                if (!state.emittedReadable) {
	                  state.emittedReadable = true;
	                  emitReadable_(stream);
	                }
	              }
	            }
	            function emitReadable(stream) {
	              var state = stream._readableState;
	              debug("emitReadable", state.needReadable, state.emittedReadable);
	              state.needReadable = false;
	              if (!state.emittedReadable) {
	                debug("emitReadable", state.flowing);
	                state.emittedReadable = true;
	                process.nextTick(emitReadable_, stream);
	              }
	            }
	            function emitReadable_(stream) {
	              var state = stream._readableState;
	              debug("emitReadable_", state.destroyed, state.length, state.ended);
	              if (!state.destroyed && (state.length || state.ended)) {
	                stream.emit("readable");
	                state.emittedReadable = false;
	              }
	              state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
	              flow(stream);
	            }
	            function maybeReadMore(stream, state) {
	              if (!state.readingMore) {
	                state.readingMore = true;
	                process.nextTick(maybeReadMore_, stream, state);
	              }
	            }
	            function maybeReadMore_(stream, state) {
	              while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
	                var len = state.length;
	                debug("maybeReadMore read 0");
	                stream.read(0);
	                if (len === state.length)
	                  break;
	              }
	              state.readingMore = false;
	            }
	            Readable.prototype._read = function(n) {
	              errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
	            };
	            Readable.prototype.pipe = function(dest, pipeOpts) {
	              var src = this;
	              var state = this._readableState;
	              switch (state.pipesCount) {
	                case 0:
	                  state.pipes = dest;
	                  break;
	                case 1:
	                  state.pipes = [state.pipes, dest];
	                  break;
	                default:
	                  state.pipes.push(dest);
	                  break;
	              }
	              state.pipesCount += 1;
	              debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
	              var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	              var endFn = doEnd ? onend : unpipe;
	              if (state.endEmitted) process.nextTick(endFn);
	              else src.once("end", endFn);
	              dest.on("unpipe", onunpipe);
	              function onunpipe(readable, unpipeInfo) {
	                debug("onunpipe");
	                if (readable === src) {
	                  if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	                    unpipeInfo.hasUnpiped = true;
	                    cleanup();
	                  }
	                }
	              }
	              function onend() {
	                debug("onend");
	                dest.end();
	              }
	              var ondrain = pipeOnDrain(src);
	              dest.on("drain", ondrain);
	              var cleanedUp = false;
	              function cleanup() {
	                debug("cleanup");
	                dest.removeListener("close", onclose);
	                dest.removeListener("finish", onfinish);
	                dest.removeListener("drain", ondrain);
	                dest.removeListener("error", onerror);
	                dest.removeListener("unpipe", onunpipe);
	                src.removeListener("end", onend);
	                src.removeListener("end", unpipe);
	                src.removeListener("data", ondata);
	                cleanedUp = true;
	                if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	              }
	              src.on("data", ondata);
	              function ondata(chunk) {
	                debug("ondata");
	                var ret = dest.write(chunk);
	                debug("dest.write", ret);
	                if (ret === false) {
	                  if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	                    debug("false write response, pause", state.awaitDrain);
	                    state.awaitDrain++;
	                  }
	                  src.pause();
	                }
	              }
	              function onerror(er) {
	                debug("onerror", er);
	                unpipe();
	                dest.removeListener("error", onerror);
	                if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
	              }
	              prependListener(dest, "error", onerror);
	              function onclose() {
	                dest.removeListener("finish", onfinish);
	                unpipe();
	              }
	              dest.once("close", onclose);
	              function onfinish() {
	                debug("onfinish");
	                dest.removeListener("close", onclose);
	                unpipe();
	              }
	              dest.once("finish", onfinish);
	              function unpipe() {
	                debug("unpipe");
	                src.unpipe(dest);
	              }
	              dest.emit("pipe", src);
	              if (!state.flowing) {
	                debug("pipe resume");
	                src.resume();
	              }
	              return dest;
	            };
	            function pipeOnDrain(src) {
	              return function pipeOnDrainFunctionResult() {
	                var state = src._readableState;
	                debug("pipeOnDrain", state.awaitDrain);
	                if (state.awaitDrain) state.awaitDrain--;
	                if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
	                  state.flowing = true;
	                  flow(src);
	                }
	              };
	            }
	            Readable.prototype.unpipe = function(dest) {
	              var state = this._readableState;
	              var unpipeInfo = {
	                hasUnpiped: false
	              };
	              if (state.pipesCount === 0) return this;
	              if (state.pipesCount === 1) {
	                if (dest && dest !== state.pipes) return this;
	                if (!dest) dest = state.pipes;
	                state.pipes = null;
	                state.pipesCount = 0;
	                state.flowing = false;
	                if (dest) dest.emit("unpipe", this, unpipeInfo);
	                return this;
	              }
	              if (!dest) {
	                var dests = state.pipes;
	                var len = state.pipesCount;
	                state.pipes = null;
	                state.pipesCount = 0;
	                state.flowing = false;
	                for (var i = 0; i < len; i++) {
	                  dests[i].emit("unpipe", this, {
	                    hasUnpiped: false
	                  });
	                }
	                return this;
	              }
	              var index = indexOf(state.pipes, dest);
	              if (index === -1) return this;
	              state.pipes.splice(index, 1);
	              state.pipesCount -= 1;
	              if (state.pipesCount === 1) state.pipes = state.pipes[0];
	              dest.emit("unpipe", this, unpipeInfo);
	              return this;
	            };
	            Readable.prototype.on = function(ev, fn) {
	              var res = Stream.prototype.on.call(this, ev, fn);
	              var state = this._readableState;
	              if (ev === "data") {
	                state.readableListening = this.listenerCount("readable") > 0;
	                if (state.flowing !== false) this.resume();
	              } else if (ev === "readable") {
	                if (!state.endEmitted && !state.readableListening) {
	                  state.readableListening = state.needReadable = true;
	                  state.flowing = false;
	                  state.emittedReadable = false;
	                  debug("on readable", state.length, state.reading);
	                  if (state.length) {
	                    emitReadable(this);
	                  } else if (!state.reading) {
	                    process.nextTick(nReadingNextTick, this);
	                  }
	                }
	              }
	              return res;
	            };
	            Readable.prototype.addListener = Readable.prototype.on;
	            Readable.prototype.removeListener = function(ev, fn) {
	              var res = Stream.prototype.removeListener.call(this, ev, fn);
	              if (ev === "readable") {
	                process.nextTick(updateReadableListening, this);
	              }
	              return res;
	            };
	            Readable.prototype.removeAllListeners = function(ev) {
	              var res = Stream.prototype.removeAllListeners.apply(this, arguments);
	              if (ev === "readable" || ev === undefined) {
	                process.nextTick(updateReadableListening, this);
	              }
	              return res;
	            };
	            function updateReadableListening(self2) {
	              var state = self2._readableState;
	              state.readableListening = self2.listenerCount("readable") > 0;
	              if (state.resumeScheduled && !state.paused) {
	                state.flowing = true;
	              } else if (self2.listenerCount("data") > 0) {
	                self2.resume();
	              }
	            }
	            function nReadingNextTick(self2) {
	              debug("readable nexttick read 0");
	              self2.read(0);
	            }
	            Readable.prototype.resume = function() {
	              var state = this._readableState;
	              if (!state.flowing) {
	                debug("resume");
	                state.flowing = !state.readableListening;
	                resume(this, state);
	              }
	              state.paused = false;
	              return this;
	            };
	            function resume(stream, state) {
	              if (!state.resumeScheduled) {
	                state.resumeScheduled = true;
	                process.nextTick(resume_, stream, state);
	              }
	            }
	            function resume_(stream, state) {
	              debug("resume", state.reading);
	              if (!state.reading) {
	                stream.read(0);
	              }
	              state.resumeScheduled = false;
	              stream.emit("resume");
	              flow(stream);
	              if (state.flowing && !state.reading) stream.read(0);
	            }
	            Readable.prototype.pause = function() {
	              debug("call pause flowing=%j", this._readableState.flowing);
	              if (this._readableState.flowing !== false) {
	                debug("pause");
	                this._readableState.flowing = false;
	                this.emit("pause");
	              }
	              this._readableState.paused = true;
	              return this;
	            };
	            function flow(stream) {
	              var state = stream._readableState;
	              debug("flow", state.flowing);
	              while (state.flowing && stream.read() !== null) {
	              }
	            }
	            Readable.prototype.wrap = function(stream) {
	              var _this = this;
	              var state = this._readableState;
	              var paused = false;
	              stream.on("end", function() {
	                debug("wrapped end");
	                if (state.decoder && !state.ended) {
	                  var chunk = state.decoder.end();
	                  if (chunk && chunk.length) _this.push(chunk);
	                }
	                _this.push(null);
	              });
	              stream.on("data", function(chunk) {
	                debug("wrapped data");
	                if (state.decoder) chunk = state.decoder.write(chunk);
	                if (state.objectMode && (chunk === null || chunk === undefined)) return;
	                else if (!state.objectMode && (!chunk || !chunk.length)) return;
	                var ret = _this.push(chunk);
	                if (!ret) {
	                  paused = true;
	                  stream.pause();
	                }
	              });
	              for (var i in stream) {
	                if (this[i] === undefined && typeof stream[i] === "function") {
	                  this[i] = /* @__PURE__ */ function methodWrap(method) {
	                    return function methodWrapReturnFunction() {
	                      return stream[method].apply(stream, arguments);
	                    };
	                  }(i);
	                }
	              }
	              for (var n = 0; n < kProxyEvents.length; n++) {
	                stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	              }
	              this._read = function(n2) {
	                debug("wrapped _read", n2);
	                if (paused) {
	                  paused = false;
	                  stream.resume();
	                }
	              };
	              return this;
	            };
	            if (typeof Symbol === "function") {
	              Readable.prototype[Symbol.asyncIterator] = function() {
	                if (createReadableStreamAsyncIterator === undefined) {
	                  createReadableStreamAsyncIterator = __webpack_require__2(68221);
	                }
	                return createReadableStreamAsyncIterator(this);
	              };
	            }
	            Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._readableState.highWaterMark;
	              }
	            });
	            Object.defineProperty(Readable.prototype, "readableBuffer", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._readableState && this._readableState.buffer;
	              }
	            });
	            Object.defineProperty(Readable.prototype, "readableFlowing", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._readableState.flowing;
	              },
	              set: function set(state) {
	                if (this._readableState) {
	                  this._readableState.flowing = state;
	                }
	              }
	            });
	            Readable._fromList = fromList;
	            Object.defineProperty(Readable.prototype, "readableLength", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._readableState.length;
	              }
	            });
	            function fromList(n, state) {
	              if (state.length === 0) return null;
	              var ret;
	              if (state.objectMode) ret = state.buffer.shift();
	              else if (!n || n >= state.length) {
	                if (state.decoder) ret = state.buffer.join("");
	                else if (state.buffer.length === 1) ret = state.buffer.first();
	                else ret = state.buffer.concat(state.length);
	                state.buffer.clear();
	              } else {
	                ret = state.buffer.consume(n, state.decoder);
	              }
	              return ret;
	            }
	            function endReadable(stream) {
	              var state = stream._readableState;
	              debug("endReadable", state.endEmitted);
	              if (!state.endEmitted) {
	                state.ended = true;
	                process.nextTick(endReadableNT, state, stream);
	              }
	            }
	            function endReadableNT(state, stream) {
	              debug("endReadableNT", state.endEmitted, state.length);
	              if (!state.endEmitted && state.length === 0) {
	                state.endEmitted = true;
	                stream.readable = false;
	                stream.emit("end");
	                if (state.autoDestroy) {
	                  var wState = stream._writableState;
	                  if (!wState || wState.autoDestroy && wState.finished) {
	                    stream.destroy();
	                  }
	                }
	              }
	            }
	            if (typeof Symbol === "function") {
	              Readable.from = function(iterable, opts) {
	                if (from === undefined) {
	                  from = __webpack_require__2(31748);
	                }
	                return from(Readable, iterable, opts);
	              };
	            }
	            function indexOf(xs, x) {
	              for (var i = 0, l = xs.length; i < l; i++) {
	                if (xs[i] === x) return i;
	              }
	              return -1;
	            }
	          }
	        ),
	        /***/
	        74308: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = Transform;
	            var _require$codes = __webpack_require__2(74322).q, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
	            var Duplex = __webpack_require__2(37865);
	            __webpack_require__2(42018)(Transform, Duplex);
	            function afterTransform(er, data) {
	              var ts = this._transformState;
	              ts.transforming = false;
	              var cb = ts.writecb;
	              if (cb === null) {
	                return this.emit("error", new ERR_MULTIPLE_CALLBACK());
	              }
	              ts.writechunk = null;
	              ts.writecb = null;
	              if (data != null)
	                this.push(data);
	              cb(er);
	              var rs = this._readableState;
	              rs.reading = false;
	              if (rs.needReadable || rs.length < rs.highWaterMark) {
	                this._read(rs.highWaterMark);
	              }
	            }
	            function Transform(options) {
	              if (!(this instanceof Transform)) return new Transform(options);
	              Duplex.call(this, options);
	              this._transformState = {
	                afterTransform: afterTransform.bind(this),
	                needTransform: false,
	                transforming: false,
	                writecb: null,
	                writechunk: null,
	                writeencoding: null
	              };
	              this._readableState.needReadable = true;
	              this._readableState.sync = false;
	              if (options) {
	                if (typeof options.transform === "function") this._transform = options.transform;
	                if (typeof options.flush === "function") this._flush = options.flush;
	              }
	              this.on("prefinish", prefinish);
	            }
	            function prefinish() {
	              var _this = this;
	              if (typeof this._flush === "function" && !this._readableState.destroyed) {
	                this._flush(function(er, data) {
	                  done(_this, er, data);
	                });
	              } else {
	                done(this, null, null);
	              }
	            }
	            Transform.prototype.push = function(chunk, encoding) {
	              this._transformState.needTransform = false;
	              return Duplex.prototype.push.call(this, chunk, encoding);
	            };
	            Transform.prototype._transform = function(chunk, encoding, cb) {
	              cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
	            };
	            Transform.prototype._write = function(chunk, encoding, cb) {
	              var ts = this._transformState;
	              ts.writecb = cb;
	              ts.writechunk = chunk;
	              ts.writeencoding = encoding;
	              if (!ts.transforming) {
	                var rs = this._readableState;
	                if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	              }
	            };
	            Transform.prototype._read = function(n) {
	              var ts = this._transformState;
	              if (ts.writechunk !== null && !ts.transforming) {
	                ts.transforming = true;
	                this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	              } else {
	                ts.needTransform = true;
	              }
	            };
	            Transform.prototype._destroy = function(err, cb) {
	              Duplex.prototype._destroy.call(this, err, function(err2) {
	                cb(err2);
	              });
	            };
	            function done(stream, er, data) {
	              if (er) return stream.emit("error", er);
	              if (data != null)
	                stream.push(data);
	              if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
	              if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
	              return stream.push(null);
	            }
	          }
	        ),
	        /***/
	        37493: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            module2.exports = Writable;
	            function CorkedRequest(state) {
	              var _this = this;
	              this.next = null;
	              this.entry = null;
	              this.finish = function() {
	                onCorkedFinish(_this, state);
	              };
	            }
	            var Duplex;
	            Writable.WritableState = WritableState;
	            var internalUtil = {
	              deprecate: __webpack_require__2(20588)
	            };
	            var Stream = __webpack_require__2(71405);
	            var Buffer2 = __webpack_require__2(12856).Buffer;
	            var OurUint8Array = __webpack_require__2.g.Uint8Array || function() {
	            };
	            function _uint8ArrayToBuffer(chunk) {
	              return Buffer2.from(chunk);
	            }
	            function _isUint8Array(obj) {
	              return Buffer2.isBuffer(obj) || obj instanceof OurUint8Array;
	            }
	            var destroyImpl = __webpack_require__2(65756);
	            var _require = __webpack_require__2(56306), getHighWaterMark = _require.getHighWaterMark;
	            var _require$codes = __webpack_require__2(74322).q, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
	            var errorOrDestroy = destroyImpl.errorOrDestroy;
	            __webpack_require__2(42018)(Writable, Stream);
	            function nop() {
	            }
	            function WritableState(options, stream, isDuplex) {
	              Duplex = Duplex || __webpack_require__2(37865);
	              options = options || {};
	              if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
	              this.objectMode = !!options.objectMode;
	              if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	              this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
	              this.finalCalled = false;
	              this.needDrain = false;
	              this.ending = false;
	              this.ended = false;
	              this.finished = false;
	              this.destroyed = false;
	              var noDecode = options.decodeStrings === false;
	              this.decodeStrings = !noDecode;
	              this.defaultEncoding = options.defaultEncoding || "utf8";
	              this.length = 0;
	              this.writing = false;
	              this.corked = 0;
	              this.sync = true;
	              this.bufferProcessing = false;
	              this.onwrite = function(er) {
	                onwrite(stream, er);
	              };
	              this.writecb = null;
	              this.writelen = 0;
	              this.bufferedRequest = null;
	              this.lastBufferedRequest = null;
	              this.pendingcb = 0;
	              this.prefinished = false;
	              this.errorEmitted = false;
	              this.emitClose = options.emitClose !== false;
	              this.autoDestroy = !!options.autoDestroy;
	              this.bufferedRequestCount = 0;
	              this.corkedRequestsFree = new CorkedRequest(this);
	            }
	            WritableState.prototype.getBuffer = function getBuffer() {
	              var current = this.bufferedRequest;
	              var out = [];
	              while (current) {
	                out.push(current);
	                current = current.next;
	              }
	              return out;
	            };
	            (function() {
	              try {
	                Object.defineProperty(WritableState.prototype, "buffer", {
	                  get: internalUtil.deprecate(function writableStateBufferGetter() {
	                    return this.getBuffer();
	                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
	                });
	              } catch (_) {
	              }
	            })();
	            var realHasInstance;
	            if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
	              realHasInstance = Function.prototype[Symbol.hasInstance];
	              Object.defineProperty(Writable, Symbol.hasInstance, {
	                value: function value(object) {
	                  if (realHasInstance.call(this, object)) return true;
	                  if (this !== Writable) return false;
	                  return object && object._writableState instanceof WritableState;
	                }
	              });
	            } else {
	              realHasInstance = function realHasInstance2(object) {
	                return object instanceof this;
	              };
	            }
	            function Writable(options) {
	              Duplex = Duplex || __webpack_require__2(37865);
	              var isDuplex = this instanceof Duplex;
	              if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
	              this._writableState = new WritableState(options, this, isDuplex);
	              this.writable = true;
	              if (options) {
	                if (typeof options.write === "function") this._write = options.write;
	                if (typeof options.writev === "function") this._writev = options.writev;
	                if (typeof options.destroy === "function") this._destroy = options.destroy;
	                if (typeof options.final === "function") this._final = options.final;
	              }
	              Stream.call(this);
	            }
	            Writable.prototype.pipe = function() {
	              errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
	            };
	            function writeAfterEnd(stream, cb) {
	              var er = new ERR_STREAM_WRITE_AFTER_END();
	              errorOrDestroy(stream, er);
	              process.nextTick(cb, er);
	            }
	            function validChunk(stream, state, chunk, cb) {
	              var er;
	              if (chunk === null) {
	                er = new ERR_STREAM_NULL_VALUES();
	              } else if (typeof chunk !== "string" && !state.objectMode) {
	                er = new ERR_INVALID_ARG_TYPE("chunk", ["string", "Buffer"], chunk);
	              }
	              if (er) {
	                errorOrDestroy(stream, er);
	                process.nextTick(cb, er);
	                return false;
	              }
	              return true;
	            }
	            Writable.prototype.write = function(chunk, encoding, cb) {
	              var state = this._writableState;
	              var ret = false;
	              var isBuf = !state.objectMode && _isUint8Array(chunk);
	              if (isBuf && !Buffer2.isBuffer(chunk)) {
	                chunk = _uint8ArrayToBuffer(chunk);
	              }
	              if (typeof encoding === "function") {
	                cb = encoding;
	                encoding = null;
	              }
	              if (isBuf) encoding = "buffer";
	              else if (!encoding) encoding = state.defaultEncoding;
	              if (typeof cb !== "function") cb = nop;
	              if (state.ending) writeAfterEnd(this, cb);
	              else if (isBuf || validChunk(this, state, chunk, cb)) {
	                state.pendingcb++;
	                ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	              }
	              return ret;
	            };
	            Writable.prototype.cork = function() {
	              this._writableState.corked++;
	            };
	            Writable.prototype.uncork = function() {
	              var state = this._writableState;
	              if (state.corked) {
	                state.corked--;
	                if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	              }
	            };
	            Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	              if (typeof encoding === "string") encoding = encoding.toLowerCase();
	              if (!(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
	              this._writableState.defaultEncoding = encoding;
	              return this;
	            };
	            Object.defineProperty(Writable.prototype, "writableBuffer", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._writableState && this._writableState.getBuffer();
	              }
	            });
	            function decodeChunk(state, chunk, encoding) {
	              if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") {
	                chunk = Buffer2.from(chunk, encoding);
	              }
	              return chunk;
	            }
	            Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._writableState.highWaterMark;
	              }
	            });
	            function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	              if (!isBuf) {
	                var newChunk = decodeChunk(state, chunk, encoding);
	                if (chunk !== newChunk) {
	                  isBuf = true;
	                  encoding = "buffer";
	                  chunk = newChunk;
	                }
	              }
	              var len = state.objectMode ? 1 : chunk.length;
	              state.length += len;
	              var ret = state.length < state.highWaterMark;
	              if (!ret) state.needDrain = true;
	              if (state.writing || state.corked) {
	                var last = state.lastBufferedRequest;
	                state.lastBufferedRequest = {
	                  chunk,
	                  encoding,
	                  isBuf,
	                  callback: cb,
	                  next: null
	                };
	                if (last) {
	                  last.next = state.lastBufferedRequest;
	                } else {
	                  state.bufferedRequest = state.lastBufferedRequest;
	                }
	                state.bufferedRequestCount += 1;
	              } else {
	                doWrite(stream, state, false, len, chunk, encoding, cb);
	              }
	              return ret;
	            }
	            function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	              state.writelen = len;
	              state.writecb = cb;
	              state.writing = true;
	              state.sync = true;
	              if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
	              else if (writev) stream._writev(chunk, state.onwrite);
	              else stream._write(chunk, encoding, state.onwrite);
	              state.sync = false;
	            }
	            function onwriteError(stream, state, sync, er, cb) {
	              --state.pendingcb;
	              if (sync) {
	                process.nextTick(cb, er);
	                process.nextTick(finishMaybe, stream, state);
	                stream._writableState.errorEmitted = true;
	                errorOrDestroy(stream, er);
	              } else {
	                cb(er);
	                stream._writableState.errorEmitted = true;
	                errorOrDestroy(stream, er);
	                finishMaybe(stream, state);
	              }
	            }
	            function onwriteStateUpdate(state) {
	              state.writing = false;
	              state.writecb = null;
	              state.length -= state.writelen;
	              state.writelen = 0;
	            }
	            function onwrite(stream, er) {
	              var state = stream._writableState;
	              var sync = state.sync;
	              var cb = state.writecb;
	              if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
	              onwriteStateUpdate(state);
	              if (er) onwriteError(stream, state, sync, er, cb);
	              else {
	                var finished = needFinish(state) || stream.destroyed;
	                if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	                  clearBuffer(stream, state);
	                }
	                if (sync) {
	                  process.nextTick(afterWrite, stream, state, finished, cb);
	                } else {
	                  afterWrite(stream, state, finished, cb);
	                }
	              }
	            }
	            function afterWrite(stream, state, finished, cb) {
	              if (!finished) onwriteDrain(stream, state);
	              state.pendingcb--;
	              cb();
	              finishMaybe(stream, state);
	            }
	            function onwriteDrain(stream, state) {
	              if (state.length === 0 && state.needDrain) {
	                state.needDrain = false;
	                stream.emit("drain");
	              }
	            }
	            function clearBuffer(stream, state) {
	              state.bufferProcessing = true;
	              var entry = state.bufferedRequest;
	              if (stream._writev && entry && entry.next) {
	                var l = state.bufferedRequestCount;
	                var buffer = new Array(l);
	                var holder = state.corkedRequestsFree;
	                holder.entry = entry;
	                var count = 0;
	                var allBuffers = true;
	                while (entry) {
	                  buffer[count] = entry;
	                  if (!entry.isBuf) allBuffers = false;
	                  entry = entry.next;
	                  count += 1;
	                }
	                buffer.allBuffers = allBuffers;
	                doWrite(stream, state, true, state.length, buffer, "", holder.finish);
	                state.pendingcb++;
	                state.lastBufferedRequest = null;
	                if (holder.next) {
	                  state.corkedRequestsFree = holder.next;
	                  holder.next = null;
	                } else {
	                  state.corkedRequestsFree = new CorkedRequest(state);
	                }
	                state.bufferedRequestCount = 0;
	              } else {
	                while (entry) {
	                  var chunk = entry.chunk;
	                  var encoding = entry.encoding;
	                  var cb = entry.callback;
	                  var len = state.objectMode ? 1 : chunk.length;
	                  doWrite(stream, state, false, len, chunk, encoding, cb);
	                  entry = entry.next;
	                  state.bufferedRequestCount--;
	                  if (state.writing) {
	                    break;
	                  }
	                }
	                if (entry === null) state.lastBufferedRequest = null;
	              }
	              state.bufferedRequest = entry;
	              state.bufferProcessing = false;
	            }
	            Writable.prototype._write = function(chunk, encoding, cb) {
	              cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
	            };
	            Writable.prototype._writev = null;
	            Writable.prototype.end = function(chunk, encoding, cb) {
	              var state = this._writableState;
	              if (typeof chunk === "function") {
	                cb = chunk;
	                chunk = null;
	                encoding = null;
	              } else if (typeof encoding === "function") {
	                cb = encoding;
	                encoding = null;
	              }
	              if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	              if (state.corked) {
	                state.corked = 1;
	                this.uncork();
	              }
	              if (!state.ending) endWritable(this, state, cb);
	              return this;
	            };
	            Object.defineProperty(Writable.prototype, "writableLength", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                return this._writableState.length;
	              }
	            });
	            function needFinish(state) {
	              return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	            }
	            function callFinal(stream, state) {
	              stream._final(function(err) {
	                state.pendingcb--;
	                if (err) {
	                  errorOrDestroy(stream, err);
	                }
	                state.prefinished = true;
	                stream.emit("prefinish");
	                finishMaybe(stream, state);
	              });
	            }
	            function prefinish(stream, state) {
	              if (!state.prefinished && !state.finalCalled) {
	                if (typeof stream._final === "function" && !state.destroyed) {
	                  state.pendingcb++;
	                  state.finalCalled = true;
	                  process.nextTick(callFinal, stream, state);
	                } else {
	                  state.prefinished = true;
	                  stream.emit("prefinish");
	                }
	              }
	            }
	            function finishMaybe(stream, state) {
	              var need = needFinish(state);
	              if (need) {
	                prefinish(stream, state);
	                if (state.pendingcb === 0) {
	                  state.finished = true;
	                  stream.emit("finish");
	                  if (state.autoDestroy) {
	                    var rState = stream._readableState;
	                    if (!rState || rState.autoDestroy && rState.endEmitted) {
	                      stream.destroy();
	                    }
	                  }
	                }
	              }
	              return need;
	            }
	            function endWritable(stream, state, cb) {
	              state.ending = true;
	              finishMaybe(stream, state);
	              if (cb) {
	                if (state.finished) process.nextTick(cb);
	                else stream.once("finish", cb);
	              }
	              state.ended = true;
	              stream.writable = false;
	            }
	            function onCorkedFinish(corkReq, state, err) {
	              var entry = corkReq.entry;
	              corkReq.entry = null;
	              while (entry) {
	                var cb = entry.callback;
	                state.pendingcb--;
	                cb(err);
	                entry = entry.next;
	              }
	              state.corkedRequestsFree.next = corkReq;
	            }
	            Object.defineProperty(Writable.prototype, "destroyed", {
	              // making it explicit this property is not enumerable
	              // because otherwise some prototype manipulation in
	              // userland will fail
	              enumerable: false,
	              get: function get() {
	                if (this._writableState === undefined) {
	                  return false;
	                }
	                return this._writableState.destroyed;
	              },
	              set: function set(value) {
	                if (!this._writableState) {
	                  return;
	                }
	                this._writableState.destroyed = value;
	              }
	            });
	            Writable.prototype.destroy = destroyImpl.destroy;
	            Writable.prototype._undestroy = destroyImpl.undestroy;
	            Writable.prototype._destroy = function(err, cb) {
	              cb(err);
	            };
	          }
	        ),
	        /***/
	        68221: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            var _Object$setPrototypeO;
	            function _defineProperty(obj, key, value) {
	              if (key in obj) {
	                Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
	              } else {
	                obj[key] = value;
	              }
	              return obj;
	            }
	            var finished = __webpack_require__2(12726);
	            var kLastResolve = Symbol("lastResolve");
	            var kLastReject = Symbol("lastReject");
	            var kError = Symbol("error");
	            var kEnded = Symbol("ended");
	            var kLastPromise = Symbol("lastPromise");
	            var kHandlePromise = Symbol("handlePromise");
	            var kStream = Symbol("stream");
	            function createIterResult(value, done) {
	              return {
	                value,
	                done
	              };
	            }
	            function readAndResolve(iter) {
	              var resolve = iter[kLastResolve];
	              if (resolve !== null) {
	                var data = iter[kStream].read();
	                if (data !== null) {
	                  iter[kLastPromise] = null;
	                  iter[kLastResolve] = null;
	                  iter[kLastReject] = null;
	                  resolve(createIterResult(data, false));
	                }
	              }
	            }
	            function onReadable(iter) {
	              process.nextTick(readAndResolve, iter);
	            }
	            function wrapForNext(lastPromise, iter) {
	              return function(resolve, reject) {
	                lastPromise.then(function() {
	                  if (iter[kEnded]) {
	                    resolve(createIterResult(undefined, true));
	                    return;
	                  }
	                  iter[kHandlePromise](resolve, reject);
	                }, reject);
	              };
	            }
	            var AsyncIteratorPrototype = Object.getPrototypeOf(function() {
	            });
	            var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
	              get stream() {
	                return this[kStream];
	              },
	              next: function next() {
	                var _this = this;
	                var error = this[kError];
	                if (error !== null) {
	                  return Promise.reject(error);
	                }
	                if (this[kEnded]) {
	                  return Promise.resolve(createIterResult(undefined, true));
	                }
	                if (this[kStream].destroyed) {
	                  return new Promise(function(resolve, reject) {
	                    process.nextTick(function() {
	                      if (_this[kError]) {
	                        reject(_this[kError]);
	                      } else {
	                        resolve(createIterResult(undefined, true));
	                      }
	                    });
	                  });
	                }
	                var lastPromise = this[kLastPromise];
	                var promise;
	                if (lastPromise) {
	                  promise = new Promise(wrapForNext(lastPromise, this));
	                } else {
	                  var data = this[kStream].read();
	                  if (data !== null) {
	                    return Promise.resolve(createIterResult(data, false));
	                  }
	                  promise = new Promise(this[kHandlePromise]);
	                }
	                this[kLastPromise] = promise;
	                return promise;
	              }
	            }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
	              return this;
	            }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
	              var _this2 = this;
	              return new Promise(function(resolve, reject) {
	                _this2[kStream].destroy(null, function(err) {
	                  if (err) {
	                    reject(err);
	                    return;
	                  }
	                  resolve(createIterResult(undefined, true));
	                });
	              });
	            }), _Object$setPrototypeO), AsyncIteratorPrototype);
	            var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator2(stream) {
	              var _Object$create;
	              var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
	                value: stream,
	                writable: true
	              }), _defineProperty(_Object$create, kLastResolve, {
	                value: null,
	                writable: true
	              }), _defineProperty(_Object$create, kLastReject, {
	                value: null,
	                writable: true
	              }), _defineProperty(_Object$create, kError, {
	                value: null,
	                writable: true
	              }), _defineProperty(_Object$create, kEnded, {
	                value: stream._readableState.endEmitted,
	                writable: true
	              }), _defineProperty(_Object$create, kHandlePromise, {
	                value: function value(resolve, reject) {
	                  var data = iterator[kStream].read();
	                  if (data) {
	                    iterator[kLastPromise] = null;
	                    iterator[kLastResolve] = null;
	                    iterator[kLastReject] = null;
	                    resolve(createIterResult(data, false));
	                  } else {
	                    iterator[kLastResolve] = resolve;
	                    iterator[kLastReject] = reject;
	                  }
	                },
	                writable: true
	              }), _Object$create));
	              iterator[kLastPromise] = null;
	              finished(stream, function(err) {
	                if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
	                  var reject = iterator[kLastReject];
	                  if (reject !== null) {
	                    iterator[kLastPromise] = null;
	                    iterator[kLastResolve] = null;
	                    iterator[kLastReject] = null;
	                    reject(err);
	                  }
	                  iterator[kError] = err;
	                  return;
	                }
	                var resolve = iterator[kLastResolve];
	                if (resolve !== null) {
	                  iterator[kLastPromise] = null;
	                  iterator[kLastResolve] = null;
	                  iterator[kLastReject] = null;
	                  resolve(createIterResult(undefined, true));
	                }
	                iterator[kEnded] = true;
	              });
	              stream.on("readable", onReadable.bind(null, iterator));
	              return iterator;
	            };
	            module2.exports = createReadableStreamAsyncIterator;
	          }
	        ),
	        /***/
	        31125: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            function ownKeys(object, enumerableOnly) {
	              var keys = Object.keys(object);
	              if (Object.getOwnPropertySymbols) {
	                var symbols = Object.getOwnPropertySymbols(object);
	                if (enumerableOnly) symbols = symbols.filter(function(sym) {
	                  return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	                });
	                keys.push.apply(keys, symbols);
	              }
	              return keys;
	            }
	            function _objectSpread(target) {
	              for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i] != null ? arguments[i] : {};
	                if (i % 2) {
	                  ownKeys(Object(source), true).forEach(function(key) {
	                    _defineProperty(target, key, source[key]);
	                  });
	                } else if (Object.getOwnPropertyDescriptors) {
	                  Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	                } else {
	                  ownKeys(Object(source)).forEach(function(key) {
	                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	                  });
	                }
	              }
	              return target;
	            }
	            function _defineProperty(obj, key, value) {
	              if (key in obj) {
	                Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
	              } else {
	                obj[key] = value;
	              }
	              return obj;
	            }
	            function _classCallCheck(instance, Constructor) {
	              if (!(instance instanceof Constructor)) {
	                throw new TypeError("Cannot call a class as a function");
	              }
	            }
	            function _defineProperties(target, props) {
	              for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	              }
	            }
	            function _createClass(Constructor, protoProps, staticProps) {
	              _defineProperties(Constructor.prototype, protoProps);
	              return Constructor;
	            }
	            var _require = __webpack_require__2(12856), Buffer2 = _require.Buffer;
	            var _require2 = __webpack_require__2(69862), inspect = _require2.inspect;
	            var custom = inspect && inspect.custom || "inspect";
	            function copyBuffer(src, target, offset) {
	              Buffer2.prototype.copy.call(src, target, offset);
	            }
	            module2.exports = /* @__PURE__ */ function() {
	              function BufferList() {
	                _classCallCheck(this, BufferList);
	                this.head = null;
	                this.tail = null;
	                this.length = 0;
	              }
	              _createClass(BufferList, [{
	                key: "push",
	                value: function push(v) {
	                  var entry = {
	                    data: v,
	                    next: null
	                  };
	                  if (this.length > 0) this.tail.next = entry;
	                  else this.head = entry;
	                  this.tail = entry;
	                  ++this.length;
	                }
	              }, {
	                key: "unshift",
	                value: function unshift(v) {
	                  var entry = {
	                    data: v,
	                    next: this.head
	                  };
	                  if (this.length === 0) this.tail = entry;
	                  this.head = entry;
	                  ++this.length;
	                }
	              }, {
	                key: "shift",
	                value: function shift() {
	                  if (this.length === 0) return;
	                  var ret = this.head.data;
	                  if (this.length === 1) this.head = this.tail = null;
	                  else this.head = this.head.next;
	                  --this.length;
	                  return ret;
	                }
	              }, {
	                key: "clear",
	                value: function clear() {
	                  this.head = this.tail = null;
	                  this.length = 0;
	                }
	              }, {
	                key: "join",
	                value: function join(s) {
	                  if (this.length === 0) return "";
	                  var p = this.head;
	                  var ret = "" + p.data;
	                  while (p = p.next) {
	                    ret += s + p.data;
	                  }
	                  return ret;
	                }
	              }, {
	                key: "concat",
	                value: function concat(n) {
	                  if (this.length === 0) return Buffer2.alloc(0);
	                  var ret = Buffer2.allocUnsafe(n >>> 0);
	                  var p = this.head;
	                  var i = 0;
	                  while (p) {
	                    copyBuffer(p.data, ret, i);
	                    i += p.data.length;
	                    p = p.next;
	                  }
	                  return ret;
	                }
	                // Consumes a specified amount of bytes or characters from the buffered data.
	              }, {
	                key: "consume",
	                value: function consume(n, hasStrings) {
	                  var ret;
	                  if (n < this.head.data.length) {
	                    ret = this.head.data.slice(0, n);
	                    this.head.data = this.head.data.slice(n);
	                  } else if (n === this.head.data.length) {
	                    ret = this.shift();
	                  } else {
	                    ret = hasStrings ? this._getString(n) : this._getBuffer(n);
	                  }
	                  return ret;
	                }
	              }, {
	                key: "first",
	                value: function first() {
	                  return this.head.data;
	                }
	                // Consumes a specified amount of characters from the buffered data.
	              }, {
	                key: "_getString",
	                value: function _getString(n) {
	                  var p = this.head;
	                  var c = 1;
	                  var ret = p.data;
	                  n -= ret.length;
	                  while (p = p.next) {
	                    var str = p.data;
	                    var nb = n > str.length ? str.length : n;
	                    if (nb === str.length) ret += str;
	                    else ret += str.slice(0, n);
	                    n -= nb;
	                    if (n === 0) {
	                      if (nb === str.length) {
	                        ++c;
	                        if (p.next) this.head = p.next;
	                        else this.head = this.tail = null;
	                      } else {
	                        this.head = p;
	                        p.data = str.slice(nb);
	                      }
	                      break;
	                    }
	                    ++c;
	                  }
	                  this.length -= c;
	                  return ret;
	                }
	                // Consumes a specified amount of bytes from the buffered data.
	              }, {
	                key: "_getBuffer",
	                value: function _getBuffer(n) {
	                  var ret = Buffer2.allocUnsafe(n);
	                  var p = this.head;
	                  var c = 1;
	                  p.data.copy(ret);
	                  n -= p.data.length;
	                  while (p = p.next) {
	                    var buf = p.data;
	                    var nb = n > buf.length ? buf.length : n;
	                    buf.copy(ret, ret.length - n, 0, nb);
	                    n -= nb;
	                    if (n === 0) {
	                      if (nb === buf.length) {
	                        ++c;
	                        if (p.next) this.head = p.next;
	                        else this.head = this.tail = null;
	                      } else {
	                        this.head = p;
	                        p.data = buf.slice(nb);
	                      }
	                      break;
	                    }
	                    ++c;
	                  }
	                  this.length -= c;
	                  return ret;
	                }
	                // Make sure the linked list only shows the minimal necessary information.
	              }, {
	                key: custom,
	                value: function value(_, options) {
	                  return inspect(this, _objectSpread({}, options, {
	                    // Only inspect one level.
	                    depth: 0,
	                    // It should not recurse.
	                    customInspect: false
	                  }));
	                }
	              }]);
	              return BufferList;
	            }();
	          }
	        ),
	        /***/
	        65756: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            function destroy(err, cb) {
	              var _this = this;
	              var readableDestroyed = this._readableState && this._readableState.destroyed;
	              var writableDestroyed = this._writableState && this._writableState.destroyed;
	              if (readableDestroyed || writableDestroyed) {
	                if (cb) {
	                  cb(err);
	                } else if (err) {
	                  if (!this._writableState) {
	                    process.nextTick(emitErrorNT, this, err);
	                  } else if (!this._writableState.errorEmitted) {
	                    this._writableState.errorEmitted = true;
	                    process.nextTick(emitErrorNT, this, err);
	                  }
	                }
	                return this;
	              }
	              if (this._readableState) {
	                this._readableState.destroyed = true;
	              }
	              if (this._writableState) {
	                this._writableState.destroyed = true;
	              }
	              this._destroy(err || null, function(err2) {
	                if (!cb && err2) {
	                  if (!_this._writableState) {
	                    process.nextTick(emitErrorAndCloseNT, _this, err2);
	                  } else if (!_this._writableState.errorEmitted) {
	                    _this._writableState.errorEmitted = true;
	                    process.nextTick(emitErrorAndCloseNT, _this, err2);
	                  } else {
	                    process.nextTick(emitCloseNT, _this);
	                  }
	                } else if (cb) {
	                  process.nextTick(emitCloseNT, _this);
	                  cb(err2);
	                } else {
	                  process.nextTick(emitCloseNT, _this);
	                }
	              });
	              return this;
	            }
	            function emitErrorAndCloseNT(self2, err) {
	              emitErrorNT(self2, err);
	              emitCloseNT(self2);
	            }
	            function emitCloseNT(self2) {
	              if (self2._writableState && !self2._writableState.emitClose) return;
	              if (self2._readableState && !self2._readableState.emitClose) return;
	              self2.emit("close");
	            }
	            function undestroy() {
	              if (this._readableState) {
	                this._readableState.destroyed = false;
	                this._readableState.reading = false;
	                this._readableState.ended = false;
	                this._readableState.endEmitted = false;
	              }
	              if (this._writableState) {
	                this._writableState.destroyed = false;
	                this._writableState.ended = false;
	                this._writableState.ending = false;
	                this._writableState.finalCalled = false;
	                this._writableState.prefinished = false;
	                this._writableState.finished = false;
	                this._writableState.errorEmitted = false;
	              }
	            }
	            function emitErrorNT(self2, err) {
	              self2.emit("error", err);
	            }
	            function errorOrDestroy(stream, err) {
	              var rState = stream._readableState;
	              var wState = stream._writableState;
	              if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
	              else stream.emit("error", err);
	            }
	            module2.exports = {
	              destroy,
	              undestroy,
	              errorOrDestroy
	            };
	          }
	        ),
	        /***/
	        12726: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__2(74322).q.ERR_STREAM_PREMATURE_CLOSE;
	            function once(callback) {
	              var called = false;
	              return function() {
	                if (called) return;
	                called = true;
	                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	                  args[_key] = arguments[_key];
	                }
	                callback.apply(this, args);
	              };
	            }
	            function noop() {
	            }
	            function isRequest(stream) {
	              return stream.setHeader && typeof stream.abort === "function";
	            }
	            function eos(stream, opts, callback) {
	              if (typeof opts === "function") return eos(stream, null, opts);
	              if (!opts) opts = {};
	              callback = once(callback || noop);
	              var readable = opts.readable || opts.readable !== false && stream.readable;
	              var writable = opts.writable || opts.writable !== false && stream.writable;
	              var onlegacyfinish = function onlegacyfinish2() {
	                if (!stream.writable) onfinish();
	              };
	              var writableEnded = stream._writableState && stream._writableState.finished;
	              var onfinish = function onfinish2() {
	                writable = false;
	                writableEnded = true;
	                if (!readable) callback.call(stream);
	              };
	              var readableEnded = stream._readableState && stream._readableState.endEmitted;
	              var onend = function onend2() {
	                readable = false;
	                readableEnded = true;
	                if (!writable) callback.call(stream);
	              };
	              var onerror = function onerror2(err) {
	                callback.call(stream, err);
	              };
	              var onclose = function onclose2() {
	                var err;
	                if (readable && !readableEnded) {
	                  if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
	                  return callback.call(stream, err);
	                }
	                if (writable && !writableEnded) {
	                  if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
	                  return callback.call(stream, err);
	                }
	              };
	              var onrequest = function onrequest2() {
	                stream.req.on("finish", onfinish);
	              };
	              if (isRequest(stream)) {
	                stream.on("complete", onfinish);
	                stream.on("abort", onclose);
	                if (stream.req) onrequest();
	                else stream.on("request", onrequest);
	              } else if (writable && !stream._writableState) {
	                stream.on("end", onlegacyfinish);
	                stream.on("close", onlegacyfinish);
	              }
	              stream.on("end", onend);
	              stream.on("finish", onfinish);
	              if (opts.error !== false) stream.on("error", onerror);
	              stream.on("close", onclose);
	              return function() {
	                stream.removeListener("complete", onfinish);
	                stream.removeListener("abort", onclose);
	                stream.removeListener("request", onrequest);
	                if (stream.req) stream.req.removeListener("finish", onfinish);
	                stream.removeListener("end", onlegacyfinish);
	                stream.removeListener("close", onlegacyfinish);
	                stream.removeListener("finish", onfinish);
	                stream.removeListener("end", onend);
	                stream.removeListener("error", onerror);
	                stream.removeListener("close", onclose);
	              };
	            }
	            module2.exports = eos;
	          }
	        ),
	        /***/
	        31748: (
	          /***/
	          function(module2) {
	            module2.exports = function() {
	              throw new Error("Readable.from is not available in the browser");
	            };
	          }
	        ),
	        /***/
	        10168: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var eos;
	            function once(callback) {
	              var called = false;
	              return function() {
	                if (called) return;
	                called = true;
	                callback.apply(undefined, arguments);
	              };
	            }
	            var _require$codes = __webpack_require__2(74322).q, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
	            function noop(err) {
	              if (err) throw err;
	            }
	            function isRequest(stream) {
	              return stream.setHeader && typeof stream.abort === "function";
	            }
	            function destroyer(stream, reading, writing, callback) {
	              callback = once(callback);
	              var closed = false;
	              stream.on("close", function() {
	                closed = true;
	              });
	              if (eos === undefined) eos = __webpack_require__2(12726);
	              eos(stream, {
	                readable: reading,
	                writable: writing
	              }, function(err) {
	                if (err) return callback(err);
	                closed = true;
	                callback();
	              });
	              var destroyed = false;
	              return function(err) {
	                if (closed) return;
	                if (destroyed) return;
	                destroyed = true;
	                if (isRequest(stream)) return stream.abort();
	                if (typeof stream.destroy === "function") return stream.destroy();
	                callback(err || new ERR_STREAM_DESTROYED("pipe"));
	              };
	            }
	            function call(fn) {
	              fn();
	            }
	            function pipe(from, to) {
	              return from.pipe(to);
	            }
	            function popCallback(streams) {
	              if (!streams.length) return noop;
	              if (typeof streams[streams.length - 1] !== "function") return noop;
	              return streams.pop();
	            }
	            function pipeline() {
	              for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
	                streams[_key] = arguments[_key];
	              }
	              var callback = popCallback(streams);
	              if (Array.isArray(streams[0])) streams = streams[0];
	              if (streams.length < 2) {
	                throw new ERR_MISSING_ARGS("streams");
	              }
	              var error;
	              var destroys = streams.map(function(stream, i) {
	                var reading = i < streams.length - 1;
	                var writing = i > 0;
	                return destroyer(stream, reading, writing, function(err) {
	                  if (!error) error = err;
	                  if (err) destroys.forEach(call);
	                  if (reading) return;
	                  destroys.forEach(call);
	                  callback(error);
	                });
	              });
	              return streams.reduce(pipe);
	            }
	            module2.exports = pipeline;
	          }
	        ),
	        /***/
	        56306: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var ERR_INVALID_OPT_VALUE = __webpack_require__2(74322).q.ERR_INVALID_OPT_VALUE;
	            function highWaterMarkFrom(options, isDuplex, duplexKey) {
	              return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
	            }
	            function getHighWaterMark(state, options, duplexKey, isDuplex) {
	              var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
	              if (hwm != null) {
	                if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
	                  var name2 = isDuplex ? duplexKey : "highWaterMark";
	                  throw new ERR_INVALID_OPT_VALUE(name2, hwm);
	                }
	                return Math.floor(hwm);
	              }
	              return state.objectMode ? 16 : 16 * 1024;
	            }
	            module2.exports = {
	              getHighWaterMark
	            };
	          }
	        ),
	        /***/
	        71405: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = __webpack_require__2(15398).EventEmitter;
	          }
	        ),
	        /***/
	        68019: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var Buffer2 = __webpack_require__2(71665).Buffer;
	            var isEncoding = Buffer2.isEncoding || function(encoding) {
	              encoding = "" + encoding;
	              switch (encoding && encoding.toLowerCase()) {
	                case "hex":
	                case "utf8":
	                case "utf-8":
	                case "ascii":
	                case "binary":
	                case "base64":
	                case "ucs2":
	                case "ucs-2":
	                case "utf16le":
	                case "utf-16le":
	                case "raw":
	                  return true;
	                default:
	                  return false;
	              }
	            };
	            function _normalizeEncoding(enc) {
	              if (!enc) return "utf8";
	              var retried;
	              while (true) {
	                switch (enc) {
	                  case "utf8":
	                  case "utf-8":
	                    return "utf8";
	                  case "ucs2":
	                  case "ucs-2":
	                  case "utf16le":
	                  case "utf-16le":
	                    return "utf16le";
	                  case "latin1":
	                  case "binary":
	                    return "latin1";
	                  case "base64":
	                  case "ascii":
	                  case "hex":
	                    return enc;
	                  default:
	                    if (retried) return;
	                    enc = ("" + enc).toLowerCase();
	                    retried = true;
	                }
	              }
	            }
	            function normalizeEncoding(enc) {
	              var nenc = _normalizeEncoding(enc);
	              if (typeof nenc !== "string" && (Buffer2.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
	              return nenc || enc;
	            }
	            exports2.s = StringDecoder;
	            function StringDecoder(encoding) {
	              this.encoding = normalizeEncoding(encoding);
	              var nb;
	              switch (this.encoding) {
	                case "utf16le":
	                  this.text = utf16Text;
	                  this.end = utf16End;
	                  nb = 4;
	                  break;
	                case "utf8":
	                  this.fillLast = utf8FillLast;
	                  nb = 4;
	                  break;
	                case "base64":
	                  this.text = base64Text;
	                  this.end = base64End;
	                  nb = 3;
	                  break;
	                default:
	                  this.write = simpleWrite;
	                  this.end = simpleEnd;
	                  return;
	              }
	              this.lastNeed = 0;
	              this.lastTotal = 0;
	              this.lastChar = Buffer2.allocUnsafe(nb);
	            }
	            StringDecoder.prototype.write = function(buf) {
	              if (buf.length === 0) return "";
	              var r;
	              var i;
	              if (this.lastNeed) {
	                r = this.fillLast(buf);
	                if (r === undefined) return "";
	                i = this.lastNeed;
	                this.lastNeed = 0;
	              } else {
	                i = 0;
	              }
	              if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	              return r || "";
	            };
	            StringDecoder.prototype.end = utf8End;
	            StringDecoder.prototype.text = utf8Text;
	            StringDecoder.prototype.fillLast = function(buf) {
	              if (this.lastNeed <= buf.length) {
	                buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	                return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	              }
	              buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	              this.lastNeed -= buf.length;
	            };
	            function utf8CheckByte(byte) {
	              if (byte <= 127) return 0;
	              else if (byte >> 5 === 6) return 2;
	              else if (byte >> 4 === 14) return 3;
	              else if (byte >> 3 === 30) return 4;
	              return byte >> 6 === 2 ? -1 : -2;
	            }
	            function utf8CheckIncomplete(self2, buf, i) {
	              var j = buf.length - 1;
	              if (j < i) return 0;
	              var nb = utf8CheckByte(buf[j]);
	              if (nb >= 0) {
	                if (nb > 0) self2.lastNeed = nb - 1;
	                return nb;
	              }
	              if (--j < i || nb === -2) return 0;
	              nb = utf8CheckByte(buf[j]);
	              if (nb >= 0) {
	                if (nb > 0) self2.lastNeed = nb - 2;
	                return nb;
	              }
	              if (--j < i || nb === -2) return 0;
	              nb = utf8CheckByte(buf[j]);
	              if (nb >= 0) {
	                if (nb > 0) {
	                  if (nb === 2) nb = 0;
	                  else self2.lastNeed = nb - 3;
	                }
	                return nb;
	              }
	              return 0;
	            }
	            function utf8CheckExtraBytes(self2, buf, p) {
	              if ((buf[0] & 192) !== 128) {
	                self2.lastNeed = 0;
	                return "�";
	              }
	              if (self2.lastNeed > 1 && buf.length > 1) {
	                if ((buf[1] & 192) !== 128) {
	                  self2.lastNeed = 1;
	                  return "�";
	                }
	                if (self2.lastNeed > 2 && buf.length > 2) {
	                  if ((buf[2] & 192) !== 128) {
	                    self2.lastNeed = 2;
	                    return "�";
	                  }
	                }
	              }
	            }
	            function utf8FillLast(buf) {
	              var p = this.lastTotal - this.lastNeed;
	              var r = utf8CheckExtraBytes(this, buf);
	              if (r !== undefined) return r;
	              if (this.lastNeed <= buf.length) {
	                buf.copy(this.lastChar, p, 0, this.lastNeed);
	                return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	              }
	              buf.copy(this.lastChar, p, 0, buf.length);
	              this.lastNeed -= buf.length;
	            }
	            function utf8Text(buf, i) {
	              var total = utf8CheckIncomplete(this, buf, i);
	              if (!this.lastNeed) return buf.toString("utf8", i);
	              this.lastTotal = total;
	              var end = buf.length - (total - this.lastNeed);
	              buf.copy(this.lastChar, 0, end);
	              return buf.toString("utf8", i, end);
	            }
	            function utf8End(buf) {
	              var r = buf && buf.length ? this.write(buf) : "";
	              if (this.lastNeed) return r + "�";
	              return r;
	            }
	            function utf16Text(buf, i) {
	              if ((buf.length - i) % 2 === 0) {
	                var r = buf.toString("utf16le", i);
	                if (r) {
	                  var c = r.charCodeAt(r.length - 1);
	                  if (c >= 55296 && c <= 56319) {
	                    this.lastNeed = 2;
	                    this.lastTotal = 4;
	                    this.lastChar[0] = buf[buf.length - 2];
	                    this.lastChar[1] = buf[buf.length - 1];
	                    return r.slice(0, -1);
	                  }
	                }
	                return r;
	              }
	              this.lastNeed = 1;
	              this.lastTotal = 2;
	              this.lastChar[0] = buf[buf.length - 1];
	              return buf.toString("utf16le", i, buf.length - 1);
	            }
	            function utf16End(buf) {
	              var r = buf && buf.length ? this.write(buf) : "";
	              if (this.lastNeed) {
	                var end = this.lastTotal - this.lastNeed;
	                return r + this.lastChar.toString("utf16le", 0, end);
	              }
	              return r;
	            }
	            function base64Text(buf, i) {
	              var n = (buf.length - i) % 3;
	              if (n === 0) return buf.toString("base64", i);
	              this.lastNeed = 3 - n;
	              this.lastTotal = 3;
	              if (n === 1) {
	                this.lastChar[0] = buf[buf.length - 1];
	              } else {
	                this.lastChar[0] = buf[buf.length - 2];
	                this.lastChar[1] = buf[buf.length - 1];
	              }
	              return buf.toString("base64", i, buf.length - n);
	            }
	            function base64End(buf) {
	              var r = buf && buf.length ? this.write(buf) : "";
	              if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
	              return r;
	            }
	            function simpleWrite(buf) {
	              return buf.toString(this.encoding);
	            }
	            function simpleEnd(buf) {
	              return buf && buf.length ? this.write(buf) : "";
	            }
	          }
	        ),
	        /***/
	        90715: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var assert = __webpack_require__2(32791);
	            var debug = __webpack_require__2(41633)("stream-parser");
	            module2.exports = Parser;
	            var INIT = -1;
	            var BUFFERING = 0;
	            var SKIPPING = 1;
	            var PASSTHROUGH = 2;
	            function Parser(stream) {
	              var isTransform = stream && "function" == typeof stream._transform;
	              var isWritable = stream && "function" == typeof stream._write;
	              if (!isTransform && !isWritable) throw new Error("must pass a Writable or Transform stream in");
	              debug("extending Parser into stream");
	              stream._bytes = _bytes;
	              stream._skipBytes = _skipBytes;
	              if (isTransform) stream._passthrough = _passthrough;
	              if (isTransform) {
	                stream._transform = transform;
	              } else {
	                stream._write = write;
	              }
	            }
	            function init(stream) {
	              debug("initializing parser stream");
	              stream._parserBytesLeft = 0;
	              stream._parserBuffers = [];
	              stream._parserBuffered = 0;
	              stream._parserState = INIT;
	              stream._parserCallback = null;
	              if ("function" == typeof stream.push) {
	                stream._parserOutput = stream.push.bind(stream);
	              }
	              stream._parserInit = true;
	            }
	            function _bytes(n, fn) {
	              assert(!this._parserCallback, 'there is already a "callback" set!');
	              assert(isFinite(n) && n > 0, 'can only buffer a finite number of bytes > 0, got "' + n + '"');
	              if (!this._parserInit) init(this);
	              debug("buffering %o bytes", n);
	              this._parserBytesLeft = n;
	              this._parserCallback = fn;
	              this._parserState = BUFFERING;
	            }
	            function _skipBytes(n, fn) {
	              assert(!this._parserCallback, 'there is already a "callback" set!');
	              assert(n > 0, 'can only skip > 0 bytes, got "' + n + '"');
	              if (!this._parserInit) init(this);
	              debug("skipping %o bytes", n);
	              this._parserBytesLeft = n;
	              this._parserCallback = fn;
	              this._parserState = SKIPPING;
	            }
	            function _passthrough(n, fn) {
	              assert(!this._parserCallback, 'There is already a "callback" set!');
	              assert(n > 0, 'can only pass through > 0 bytes, got "' + n + '"');
	              if (!this._parserInit) init(this);
	              debug("passing through %o bytes", n);
	              this._parserBytesLeft = n;
	              this._parserCallback = fn;
	              this._parserState = PASSTHROUGH;
	            }
	            function write(chunk, encoding, fn) {
	              if (!this._parserInit) init(this);
	              debug("write(%o bytes)", chunk.length);
	              if ("function" == typeof encoding) fn = encoding;
	              data(this, chunk, null, fn);
	            }
	            function transform(chunk, output, fn) {
	              if (!this._parserInit) init(this);
	              debug("transform(%o bytes)", chunk.length);
	              if ("function" != typeof output) {
	                output = this._parserOutput;
	              }
	              data(this, chunk, output, fn);
	            }
	            function _data(stream, chunk, output, fn) {
	              if (stream._parserBytesLeft <= 0) {
	                return fn(new Error("got data but not currently parsing anything"));
	              }
	              if (chunk.length <= stream._parserBytesLeft) {
	                return function() {
	                  return process(stream, chunk, output, fn);
	                };
	              } else {
	                return function() {
	                  var b = chunk.slice(0, stream._parserBytesLeft);
	                  return process(stream, b, output, function(err) {
	                    if (err) return fn(err);
	                    if (chunk.length > b.length) {
	                      return function() {
	                        return _data(stream, chunk.slice(b.length), output, fn);
	                      };
	                    }
	                  });
	                };
	              }
	            }
	            function process(stream, chunk, output, fn) {
	              stream._parserBytesLeft -= chunk.length;
	              debug("%o bytes left for stream piece", stream._parserBytesLeft);
	              if (stream._parserState === BUFFERING) {
	                stream._parserBuffers.push(chunk);
	                stream._parserBuffered += chunk.length;
	              } else if (stream._parserState === PASSTHROUGH) {
	                output(chunk);
	              }
	              if (0 === stream._parserBytesLeft) {
	                var cb = stream._parserCallback;
	                if (cb && stream._parserState === BUFFERING && stream._parserBuffers.length > 1) {
	                  chunk = Buffer.concat(stream._parserBuffers, stream._parserBuffered);
	                }
	                if (stream._parserState !== BUFFERING) {
	                  chunk = null;
	                }
	                stream._parserCallback = null;
	                stream._parserBuffered = 0;
	                stream._parserState = INIT;
	                stream._parserBuffers.splice(0);
	                if (cb) {
	                  var args = [];
	                  if (chunk) {
	                    args.push(chunk);
	                  }
	                  if (output) {
	                    args.push(output);
	                  }
	                  var async = cb.length > args.length;
	                  if (async) {
	                    args.push(trampoline(fn));
	                  }
	                  var rtn = cb.apply(stream, args);
	                  if (!async || fn === rtn) return fn;
	                }
	              } else {
	                return fn;
	              }
	            }
	            var data = trampoline(_data);
	            function trampoline(fn) {
	              return function() {
	                var result = fn.apply(this, arguments);
	                while ("function" == typeof result) {
	                  result = result();
	                }
	                return result;
	              };
	            }
	          }
	        ),
	        /***/
	        41633: (
	          /***/
	          function(module2, exports2, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            exports2 = module2.exports = __webpack_require__2(74469);
	            exports2.log = log;
	            exports2.formatArgs = formatArgs;
	            exports2.save = save;
	            exports2.load = load;
	            exports2.useColors = useColors;
	            exports2.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
	            exports2.colors = [
	              "lightseagreen",
	              "forestgreen",
	              "goldenrod",
	              "dodgerblue",
	              "darkorchid",
	              "crimson"
	            ];
	            function useColors() {
	              if (typeof window !== "undefined" && window.process && window.process.type === "renderer") {
	                return true;
	              }
	              return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
	              typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
	              // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	              typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
	              typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
	            }
	            exports2.formatters.j = function(v) {
	              try {
	                return JSON.stringify(v);
	              } catch (err) {
	                return "[UnexpectedJSONParseError]: " + err.message;
	              }
	            };
	            function formatArgs(args) {
	              var useColors2 = this.useColors;
	              args[0] = (useColors2 ? "%c" : "") + this.namespace + (useColors2 ? " %c" : " ") + args[0] + (useColors2 ? "%c " : " ") + "+" + exports2.humanize(this.diff);
	              if (!useColors2) return;
	              var c = "color: " + this.color;
	              args.splice(1, 0, c, "color: inherit");
	              var index = 0;
	              var lastC = 0;
	              args[0].replace(/%[a-zA-Z%]/g, function(match) {
	                if ("%%" === match) return;
	                index++;
	                if ("%c" === match) {
	                  lastC = index;
	                }
	              });
	              args.splice(lastC, 0, c);
	            }
	            function log() {
	              return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
	            }
	            function save(namespaces) {
	              try {
	                if (null == namespaces) {
	                  exports2.storage.removeItem("debug");
	                } else {
	                  exports2.storage.debug = namespaces;
	                }
	              } catch (e) {
	              }
	            }
	            function load() {
	              var r;
	              try {
	                r = exports2.storage.debug;
	              } catch (e) {
	              }
	              if (!r && typeof process !== "undefined" && "env" in process) {
	                r = process.env.DEBUG;
	              }
	              return r;
	            }
	            exports2.enable(load());
	            function localstorage() {
	              try {
	                return window.localStorage;
	              } catch (e) {
	              }
	            }
	          }
	        ),
	        /***/
	        74469: (
	          /***/
	          function(module2, exports2, __webpack_require__2) {
	            exports2 = module2.exports = createDebug.debug = createDebug["default"] = createDebug;
	            exports2.coerce = coerce;
	            exports2.disable = disable;
	            exports2.enable = enable;
	            exports2.enabled = enabled;
	            exports2.humanize = __webpack_require__2(11375);
	            exports2.names = [];
	            exports2.skips = [];
	            exports2.formatters = {};
	            var prevTime;
	            function selectColor(namespace) {
	              var hash = 0, i;
	              for (i in namespace) {
	                hash = (hash << 5) - hash + namespace.charCodeAt(i);
	                hash |= 0;
	              }
	              return exports2.colors[Math.abs(hash) % exports2.colors.length];
	            }
	            function createDebug(namespace) {
	              function debug() {
	                if (!debug.enabled) return;
	                var self2 = debug;
	                var curr = +/* @__PURE__ */ new Date();
	                var ms = curr - (prevTime || curr);
	                self2.diff = ms;
	                self2.prev = prevTime;
	                self2.curr = curr;
	                prevTime = curr;
	                var args = new Array(arguments.length);
	                for (var i = 0; i < args.length; i++) {
	                  args[i] = arguments[i];
	                }
	                args[0] = exports2.coerce(args[0]);
	                if ("string" !== typeof args[0]) {
	                  args.unshift("%O");
	                }
	                var index = 0;
	                args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	                  if (match === "%%") return match;
	                  index++;
	                  var formatter = exports2.formatters[format];
	                  if ("function" === typeof formatter) {
	                    var val = args[index];
	                    match = formatter.call(self2, val);
	                    args.splice(index, 1);
	                    index--;
	                  }
	                  return match;
	                });
	                exports2.formatArgs.call(self2, args);
	                var logFn = debug.log || exports2.log || console.log.bind(console);
	                logFn.apply(self2, args);
	              }
	              debug.namespace = namespace;
	              debug.enabled = exports2.enabled(namespace);
	              debug.useColors = exports2.useColors();
	              debug.color = selectColor(namespace);
	              if ("function" === typeof exports2.init) {
	                exports2.init(debug);
	              }
	              return debug;
	            }
	            function enable(namespaces) {
	              exports2.save(namespaces);
	              exports2.names = [];
	              exports2.skips = [];
	              var split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
	              var len = split.length;
	              for (var i = 0; i < len; i++) {
	                if (!split[i]) continue;
	                namespaces = split[i].replace(/\*/g, ".*?");
	                if (namespaces[0] === "-") {
	                  exports2.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
	                } else {
	                  exports2.names.push(new RegExp("^" + namespaces + "$"));
	                }
	              }
	            }
	            function disable() {
	              exports2.enable("");
	            }
	            function enabled(name2) {
	              var i, len;
	              for (i = 0, len = exports2.skips.length; i < len; i++) {
	                if (exports2.skips[i].test(name2)) {
	                  return false;
	                }
	              }
	              for (i = 0, len = exports2.names.length; i < len; i++) {
	                if (exports2.names[i].test(name2)) {
	                  return true;
	                }
	              }
	              return false;
	            }
	            function coerce(val) {
	              if (val instanceof Error) return val.stack || val.message;
	              return val;
	            }
	          }
	        ),
	        /***/
	        11375: (
	          /***/
	          function(module2) {
	            var s = 1e3;
	            var m = s * 60;
	            var h = m * 60;
	            var d = h * 24;
	            var y = d * 365.25;
	            module2.exports = function(val, options) {
	              options = options || {};
	              var type = typeof val;
	              if (type === "string" && val.length > 0) {
	                return parse(val);
	              } else if (type === "number" && isNaN(val) === false) {
	                return options.long ? fmtLong(val) : fmtShort(val);
	              }
	              throw new Error(
	                "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
	              );
	            };
	            function parse(str) {
	              str = String(str);
	              if (str.length > 100) {
	                return;
	              }
	              var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	                str
	              );
	              if (!match) {
	                return;
	              }
	              var n = parseFloat(match[1]);
	              var type = (match[2] || "ms").toLowerCase();
	              switch (type) {
	                case "years":
	                case "year":
	                case "yrs":
	                case "yr":
	                case "y":
	                  return n * y;
	                case "days":
	                case "day":
	                case "d":
	                  return n * d;
	                case "hours":
	                case "hour":
	                case "hrs":
	                case "hr":
	                case "h":
	                  return n * h;
	                case "minutes":
	                case "minute":
	                case "mins":
	                case "min":
	                case "m":
	                  return n * m;
	                case "seconds":
	                case "second":
	                case "secs":
	                case "sec":
	                case "s":
	                  return n * s;
	                case "milliseconds":
	                case "millisecond":
	                case "msecs":
	                case "msec":
	                case "ms":
	                  return n;
	                default:
	                  return undefined;
	              }
	            }
	            function fmtShort(ms) {
	              if (ms >= d) {
	                return Math.round(ms / d) + "d";
	              }
	              if (ms >= h) {
	                return Math.round(ms / h) + "h";
	              }
	              if (ms >= m) {
	                return Math.round(ms / m) + "m";
	              }
	              if (ms >= s) {
	                return Math.round(ms / s) + "s";
	              }
	              return ms + "ms";
	            }
	            function fmtLong(ms) {
	              return plural(ms, d, "day") || plural(ms, h, "hour") || plural(ms, m, "minute") || plural(ms, s, "second") || ms + " ms";
	            }
	            function plural(ms, n, name2) {
	              if (ms < n) {
	                return;
	              }
	              if (ms < n * 1.5) {
	                return Math.floor(ms / n) + " " + name2;
	              }
	              return Math.ceil(ms / n) + " " + name2 + "s";
	            }
	          }
	        ),
	        /***/
	        99011: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var paren = __webpack_require__2(88641);
	            module2.exports = function splitBy(string, separator, o) {
	              if (string == null) throw Error("First argument should be a string");
	              if (separator == null) throw Error("Separator should be a string or a RegExp");
	              if (!o) o = {};
	              else if (typeof o === "string" || Array.isArray(o)) {
	                o = { ignore: o };
	              }
	              if (o.escape == null) o.escape = true;
	              if (o.ignore == null) o.ignore = ["[]", "()", "{}", "<>", '""', "''", "``", "“”", "«»"];
	              else {
	                if (typeof o.ignore === "string") {
	                  o.ignore = [o.ignore];
	                }
	                o.ignore = o.ignore.map(function(pair) {
	                  if (pair.length === 1) pair = pair + pair;
	                  return pair;
	                });
	              }
	              var tokens = paren.parse(string, { flat: true, brackets: o.ignore });
	              var str = tokens[0];
	              var parts = str.split(separator);
	              if (o.escape) {
	                var cleanParts = [];
	                for (var i = 0; i < parts.length; i++) {
	                  var prev = parts[i];
	                  var part = parts[i + 1];
	                  if (prev[prev.length - 1] === "\\" && prev[prev.length - 2] !== "\\") {
	                    cleanParts.push(prev + separator + part);
	                    i++;
	                  } else {
	                    cleanParts.push(prev);
	                  }
	                }
	                parts = cleanParts;
	              }
	              for (var i = 0; i < parts.length; i++) {
	                tokens[0] = parts[i];
	                parts[i] = paren.stringify(tokens, { flat: true });
	              }
	              return parts;
	            };
	          }
	        ),
	        /***/
	        68664: (
	          /***/
	          function(module2) {
	            module2.exports = stronglyConnectedComponents;
	            function stronglyConnectedComponents(adjList) {
	              var numVertices = adjList.length;
	              var index = new Array(numVertices);
	              var lowValue = new Array(numVertices);
	              var active = new Array(numVertices);
	              var child = new Array(numVertices);
	              var scc = new Array(numVertices);
	              var sccLinks = new Array(numVertices);
	              for (var i = 0; i < numVertices; ++i) {
	                index[i] = -1;
	                lowValue[i] = 0;
	                active[i] = false;
	                child[i] = 0;
	                scc[i] = -1;
	                sccLinks[i] = [];
	              }
	              var count = 0;
	              var components = [];
	              var sccAdjList = [];
	              function strongConnect(v) {
	                var S = [v], T = [v];
	                index[v] = lowValue[v] = count;
	                active[v] = true;
	                count += 1;
	                while (T.length > 0) {
	                  v = T[T.length - 1];
	                  var e2 = adjList[v];
	                  if (child[v] < e2.length) {
	                    for (var i2 = child[v]; i2 < e2.length; ++i2) {
	                      var u = e2[i2];
	                      if (index[u] < 0) {
	                        index[u] = lowValue[u] = count;
	                        active[u] = true;
	                        count += 1;
	                        S.push(u);
	                        T.push(u);
	                        break;
	                      } else if (active[u]) {
	                        lowValue[v] = Math.min(lowValue[v], lowValue[u]) | 0;
	                      }
	                      if (scc[u] >= 0) {
	                        sccLinks[v].push(scc[u]);
	                      }
	                    }
	                    child[v] = i2;
	                  } else {
	                    if (lowValue[v] === index[v]) {
	                      var component = [];
	                      var links = [], linkCount = 0;
	                      for (var i2 = S.length - 1; i2 >= 0; --i2) {
	                        var w = S[i2];
	                        active[w] = false;
	                        component.push(w);
	                        links.push(sccLinks[w]);
	                        linkCount += sccLinks[w].length;
	                        scc[w] = components.length;
	                        if (w === v) {
	                          S.length = i2;
	                          break;
	                        }
	                      }
	                      components.push(component);
	                      var allLinks = new Array(linkCount);
	                      for (var i2 = 0; i2 < links.length; i2++) {
	                        for (var j2 = 0; j2 < links[i2].length; j2++) {
	                          allLinks[--linkCount] = links[i2][j2];
	                        }
	                      }
	                      sccAdjList.push(allLinks);
	                    }
	                    T.pop();
	                  }
	                }
	              }
	              for (var i = 0; i < numVertices; ++i) {
	                if (index[i] < 0) {
	                  strongConnect(i);
	                }
	              }
	              var newE;
	              for (var i = 0; i < sccAdjList.length; i++) {
	                var e = sccAdjList[i];
	                if (e.length === 0) continue;
	                e.sort(function(a, b) {
	                  return a - b;
	                });
	                newE = [e[0]];
	                for (var j = 1; j < e.length; j++) {
	                  if (e[j] !== e[j - 1]) {
	                    newE.push(e[j]);
	                  }
	                }
	                sccAdjList[i] = newE;
	              }
	              return { components, adjacencyList: sccAdjList };
	            }
	          }
	        ),
	        /***/
	        7095: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.r(__webpack_exports__2);
	            var _slicedToArray = /* @__PURE__ */ function() {
	              function sliceIterator(arr, i) {
	                var _arr = [];
	                var _n = true;
	                var _d = false;
	                var _e = undefined;
	                try {
	                  for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	                    _arr.push(_s.value);
	                    if (i && _arr.length === i) break;
	                  }
	                } catch (err) {
	                  _d = true;
	                  _e = err;
	                } finally {
	                  try {
	                    if (!_n && _i["return"]) _i["return"]();
	                  } finally {
	                    if (_d) throw _e;
	                  }
	                }
	                return _arr;
	              }
	              return function(arr, i) {
	                if (Array.isArray(arr)) {
	                  return arr;
	                } else if (Symbol.iterator in Object(arr)) {
	                  return sliceIterator(arr, i);
	                } else {
	                  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	                }
	              };
	            }();
	            var TAU = Math.PI * 2;
	            var mapToEllipse = function mapToEllipse2(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
	              var x = _ref.x, y = _ref.y;
	              x *= rx;
	              y *= ry;
	              var xp = cosphi * x - sinphi * y;
	              var yp = sinphi * x + cosphi * y;
	              return {
	                x: xp + centerx,
	                y: yp + centery
	              };
	            };
	            var approxUnitArc = function approxUnitArc2(ang1, ang2) {
	              var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
	              var x1 = Math.cos(ang1);
	              var y1 = Math.sin(ang1);
	              var x2 = Math.cos(ang1 + ang2);
	              var y2 = Math.sin(ang1 + ang2);
	              return [{
	                x: x1 - y1 * a,
	                y: y1 + x1 * a
	              }, {
	                x: x2 + y2 * a,
	                y: y2 - x2 * a
	              }, {
	                x: x2,
	                y: y2
	              }];
	            };
	            var vectorAngle = function vectorAngle2(ux, uy, vx, vy) {
	              var sign = ux * vy - uy * vx < 0 ? -1 : 1;
	              var dot = ux * vx + uy * vy;
	              if (dot > 1) {
	                dot = 1;
	              }
	              if (dot < -1) {
	                dot = -1;
	              }
	              return sign * Math.acos(dot);
	            };
	            var getArcCenter = function getArcCenter2(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
	              var rxsq = Math.pow(rx, 2);
	              var rysq = Math.pow(ry, 2);
	              var pxpsq = Math.pow(pxp, 2);
	              var pypsq = Math.pow(pyp, 2);
	              var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
	              if (radicant < 0) {
	                radicant = 0;
	              }
	              radicant /= rxsq * pypsq + rysq * pxpsq;
	              radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
	              var centerxp = radicant * rx / ry * pyp;
	              var centeryp = radicant * -ry / rx * pxp;
	              var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
	              var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
	              var vx1 = (pxp - centerxp) / rx;
	              var vy1 = (pyp - centeryp) / ry;
	              var vx2 = (-pxp - centerxp) / rx;
	              var vy2 = (-pyp - centeryp) / ry;
	              var ang1 = vectorAngle(1, 0, vx1, vy1);
	              var ang2 = vectorAngle(vx1, vy1, vx2, vy2);
	              if (sweepFlag === 0 && ang2 > 0) {
	                ang2 -= TAU;
	              }
	              if (sweepFlag === 1 && ang2 < 0) {
	                ang2 += TAU;
	              }
	              return [centerx, centery, ang1, ang2];
	            };
	            var arcToBezier = function arcToBezier2(_ref2) {
	              var px = _ref2.px, py = _ref2.py, cx = _ref2.cx, cy = _ref2.cy, rx = _ref2.rx, ry = _ref2.ry, _ref2$xAxisRotation = _ref2.xAxisRotation, xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation, _ref2$largeArcFlag = _ref2.largeArcFlag, largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag, _ref2$sweepFlag = _ref2.sweepFlag, sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
	              var curves = [];
	              if (rx === 0 || ry === 0) {
	                return [];
	              }
	              var sinphi = Math.sin(xAxisRotation * TAU / 360);
	              var cosphi = Math.cos(xAxisRotation * TAU / 360);
	              var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
	              var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
	              if (pxp === 0 && pyp === 0) {
	                return [];
	              }
	              rx = Math.abs(rx);
	              ry = Math.abs(ry);
	              var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
	              if (lambda > 1) {
	                rx *= Math.sqrt(lambda);
	                ry *= Math.sqrt(lambda);
	              }
	              var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp), _getArcCenter2 = _slicedToArray(_getArcCenter, 4), centerx = _getArcCenter2[0], centery = _getArcCenter2[1], ang1 = _getArcCenter2[2], ang2 = _getArcCenter2[3];
	              var ratio = Math.abs(ang2) / (TAU / 4);
	              if (Math.abs(1 - ratio) < 1e-7) {
	                ratio = 1;
	              }
	              var segments = Math.max(Math.ceil(ratio), 1);
	              ang2 /= segments;
	              for (var i = 0; i < segments; i++) {
	                curves.push(approxUnitArc(ang1, ang2));
	                ang1 += ang2;
	              }
	              return curves.map(function(curve) {
	                var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery), x1 = _mapToEllipse.x, y1 = _mapToEllipse.y;
	                var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery), x2 = _mapToEllipse2.x, y2 = _mapToEllipse2.y;
	                var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery), x = _mapToEllipse3.x, y = _mapToEllipse3.y;
	                return { x1, y1, x2, y2, x, y };
	              });
	            };
	            __webpack_exports__2["default"] = arcToBezier;
	          }
	        ),
	        /***/
	        1750: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parse = __webpack_require__2(95616);
	            var abs = __webpack_require__2(65185);
	            var normalize = __webpack_require__2(29988);
	            var isSvgPath = __webpack_require__2(89546);
	            var assert = __webpack_require__2(32791);
	            module2.exports = pathBounds;
	            function pathBounds(path) {
	              if (Array.isArray(path) && path.length === 1 && typeof path[0] === "string") path = path[0];
	              if (typeof path === "string") {
	                assert(isSvgPath(path), "String is not an SVG path.");
	                path = parse(path);
	              }
	              assert(Array.isArray(path), "Argument should be a string or an array of path segments.");
	              path = abs(path);
	              path = normalize(path);
	              if (!path.length) return [0, 0, 0, 0];
	              var bounds = [Infinity, Infinity, -Infinity, -Infinity];
	              for (var i = 0, l = path.length; i < l; i++) {
	                var points = path[i].slice(1);
	                for (var j = 0; j < points.length; j += 2) {
	                  if (points[j + 0] < bounds[0]) bounds[0] = points[j + 0];
	                  if (points[j + 1] < bounds[1]) bounds[1] = points[j + 1];
	                  if (points[j + 0] > bounds[2]) bounds[2] = points[j + 0];
	                  if (points[j + 1] > bounds[3]) bounds[3] = points[j + 1];
	                }
	              }
	              return bounds;
	            }
	          }
	        ),
	        /***/
	        29988: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = normalize;
	            var arcToCurve = __webpack_require__2(7095);
	            function normalize(path) {
	              var prev;
	              var result = [];
	              var bezierX = 0;
	              var bezierY = 0;
	              var startX = 0;
	              var startY = 0;
	              var quadX = null;
	              var quadY = null;
	              var x = 0;
	              var y = 0;
	              for (var i = 0, len = path.length; i < len; i++) {
	                var seg = path[i];
	                var command = seg[0];
	                switch (command) {
	                  case "M":
	                    startX = seg[1];
	                    startY = seg[2];
	                    break;
	                  case "A":
	                    var curves = arcToCurve({
	                      px: x,
	                      py: y,
	                      cx: seg[6],
	                      cy: seg[7],
	                      rx: seg[1],
	                      ry: seg[2],
	                      xAxisRotation: seg[3],
	                      largeArcFlag: seg[4],
	                      sweepFlag: seg[5]
	                    });
	                    if (!curves.length) continue;
	                    for (var j = 0, c; j < curves.length; j++) {
	                      c = curves[j];
	                      seg = ["C", c.x1, c.y1, c.x2, c.y2, c.x, c.y];
	                      if (j < curves.length - 1) result.push(seg);
	                    }
	                    break;
	                  case "S":
	                    var cx = x;
	                    var cy = y;
	                    if (prev == "C" || prev == "S") {
	                      cx += cx - bezierX;
	                      cy += cy - bezierY;
	                    }
	                    seg = ["C", cx, cy, seg[1], seg[2], seg[3], seg[4]];
	                    break;
	                  case "T":
	                    if (prev == "Q" || prev == "T") {
	                      quadX = x * 2 - quadX;
	                      quadY = y * 2 - quadY;
	                    } else {
	                      quadX = x;
	                      quadY = y;
	                    }
	                    seg = quadratic(x, y, quadX, quadY, seg[1], seg[2]);
	                    break;
	                  case "Q":
	                    quadX = seg[1];
	                    quadY = seg[2];
	                    seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4]);
	                    break;
	                  case "L":
	                    seg = line(x, y, seg[1], seg[2]);
	                    break;
	                  case "H":
	                    seg = line(x, y, seg[1], y);
	                    break;
	                  case "V":
	                    seg = line(x, y, x, seg[1]);
	                    break;
	                  case "Z":
	                    seg = line(x, y, startX, startY);
	                    break;
	                }
	                prev = command;
	                x = seg[seg.length - 2];
	                y = seg[seg.length - 1];
	                if (seg.length > 4) {
	                  bezierX = seg[seg.length - 4];
	                  bezierY = seg[seg.length - 3];
	                } else {
	                  bezierX = x;
	                  bezierY = y;
	                }
	                result.push(seg);
	              }
	              return result;
	            }
	            function line(x1, y1, x2, y2) {
	              return ["C", x1, y1, x2, y2, x2, y2];
	            }
	            function quadratic(x1, y1, cx, cy, x2, y2) {
	              return [
	                "C",
	                x1 / 3 + 2 / 3 * cx,
	                y1 / 3 + 2 / 3 * cy,
	                x2 / 3 + 2 / 3 * cx,
	                y2 / 3 + 2 / 3 * cy,
	                x2,
	                y2
	              ];
	            }
	          }
	        ),
	        /***/
	        82019: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var pathBounds = __webpack_require__2(1750);
	            var parsePath = __webpack_require__2(95616);
	            var drawPath = __webpack_require__2(31457);
	            var isSvgPath = __webpack_require__2(89546);
	            var bitmapSdf = __webpack_require__2(44781);
	            var canvas = document.createElement("canvas");
	            var ctx = canvas.getContext("2d");
	            module2.exports = pathSdf;
	            function pathSdf(path, options) {
	              if (!isSvgPath(path)) throw Error("Argument should be valid svg path string");
	              if (!options) options = {};
	              var w, h;
	              if (options.shape) {
	                w = options.shape[0];
	                h = options.shape[1];
	              } else {
	                w = canvas.width = options.w || options.width || 200;
	                h = canvas.height = options.h || options.height || 200;
	              }
	              var size = Math.min(w, h);
	              var stroke = options.stroke || 0;
	              var viewbox = options.viewbox || options.viewBox || pathBounds(path);
	              var scale = [w / (viewbox[2] - viewbox[0]), h / (viewbox[3] - viewbox[1])];
	              var maxScale = Math.min(scale[0] || 0, scale[1] || 0) / 2;
	              ctx.fillStyle = "black";
	              ctx.fillRect(0, 0, w, h);
	              ctx.fillStyle = "white";
	              if (stroke) {
	                if (typeof stroke != "number") stroke = 1;
	                if (stroke > 0) {
	                  ctx.strokeStyle = "white";
	                } else {
	                  ctx.strokeStyle = "black";
	                }
	                ctx.lineWidth = Math.abs(stroke);
	              }
	              ctx.translate(w * 0.5, h * 0.5);
	              ctx.scale(maxScale, maxScale);
	              if (isPath2DSupported()) {
	                var path2d = new Path2D(path);
	                ctx.fill(path2d);
	                stroke && ctx.stroke(path2d);
	              } else {
	                var segments = parsePath(path);
	                drawPath(ctx, segments);
	                ctx.fill();
	                stroke && ctx.stroke();
	              }
	              ctx.setTransform(1, 0, 0, 1, 0, 0);
	              var data = bitmapSdf(ctx, {
	                cutoff: options.cutoff != null ? options.cutoff : 0.5,
	                radius: options.radius != null ? options.radius : size * 0.5
	              });
	              return data;
	            }
	            var path2DSupported;
	            function isPath2DSupported() {
	              if (path2DSupported != null) return path2DSupported;
	              var ctx2 = document.createElement("canvas").getContext("2d");
	              ctx2.canvas.width = ctx2.canvas.height = 1;
	              if (!window.Path2D) return path2DSupported = false;
	              var path = new Path2D("M0,0h1v1h-1v-1Z");
	              ctx2.fillStyle = "black";
	              ctx2.fill(path);
	              var idata = ctx2.getImageData(0, 0, 1, 1);
	              return path2DSupported = idata && idata.data && idata.data[3] === 255;
	            }
	          }
	        ),
	        /***/
	        84267: (
	          /***/
	          function(module2, exports2, __webpack_require__2) {
	            var __WEBPACK_AMD_DEFINE_RESULT__;
	            (function(Math2) {
	              var trimLeft = /^\s+/, trimRight = /\s+$/, tinyCounter = 0, mathRound = Math2.round, mathMin = Math2.min, mathMax = Math2.max, mathRandom = Math2.random;
	              function tinycolor(color, opts) {
	                color = color ? color : "";
	                opts = opts || {};
	                if (color instanceof tinycolor) {
	                  return color;
	                }
	                if (!(this instanceof tinycolor)) {
	                  return new tinycolor(color, opts);
	                }
	                var rgb = inputToRGB(color);
	                this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
	                this._gradientType = opts.gradientType;
	                if (this._r < 1) {
	                  this._r = mathRound(this._r);
	                }
	                if (this._g < 1) {
	                  this._g = mathRound(this._g);
	                }
	                if (this._b < 1) {
	                  this._b = mathRound(this._b);
	                }
	                this._ok = rgb.ok;
	                this._tc_id = tinyCounter++;
	              }
	              tinycolor.prototype = {
	                isDark: function() {
	                  return this.getBrightness() < 128;
	                },
	                isLight: function() {
	                  return !this.isDark();
	                },
	                isValid: function() {
	                  return this._ok;
	                },
	                getOriginalInput: function() {
	                  return this._originalInput;
	                },
	                getFormat: function() {
	                  return this._format;
	                },
	                getAlpha: function() {
	                  return this._a;
	                },
	                getBrightness: function() {
	                  var rgb = this.toRgb();
	                  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
	                },
	                getLuminance: function() {
	                  var rgb = this.toRgb();
	                  var RsRGB, GsRGB, BsRGB, R, G, B;
	                  RsRGB = rgb.r / 255;
	                  GsRGB = rgb.g / 255;
	                  BsRGB = rgb.b / 255;
	                  if (RsRGB <= 0.03928) {
	                    R = RsRGB / 12.92;
	                  } else {
	                    R = Math2.pow((RsRGB + 0.055) / 1.055, 2.4);
	                  }
	                  if (GsRGB <= 0.03928) {
	                    G = GsRGB / 12.92;
	                  } else {
	                    G = Math2.pow((GsRGB + 0.055) / 1.055, 2.4);
	                  }
	                  if (BsRGB <= 0.03928) {
	                    B = BsRGB / 12.92;
	                  } else {
	                    B = Math2.pow((BsRGB + 0.055) / 1.055, 2.4);
	                  }
	                  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
	                },
	                setAlpha: function(value) {
	                  this._a = boundAlpha(value);
	                  this._roundA = mathRound(100 * this._a) / 100;
	                  return this;
	                },
	                toHsv: function() {
	                  var hsv = rgbToHsv(this._r, this._g, this._b);
	                  return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	                },
	                toHsvString: function() {
	                  var hsv = rgbToHsv(this._r, this._g, this._b);
	                  var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	                  return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
	                },
	                toHsl: function() {
	                  var hsl = rgbToHsl(this._r, this._g, this._b);
	                  return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	                },
	                toHslString: function() {
	                  var hsl = rgbToHsl(this._r, this._g, this._b);
	                  var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	                  return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
	                },
	                toHex: function(allow3Char) {
	                  return rgbToHex(this._r, this._g, this._b, allow3Char);
	                },
	                toHexString: function(allow3Char) {
	                  return "#" + this.toHex(allow3Char);
	                },
	                toHex8: function(allow4Char) {
	                  return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	                },
	                toHex8String: function(allow4Char) {
	                  return "#" + this.toHex8(allow4Char);
	                },
	                toRgb: function() {
	                  return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	                },
	                toRgbString: function() {
	                  return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	                },
	                toPercentageRgb: function() {
	                  return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	                },
	                toPercentageRgbString: function() {
	                  return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	                },
	                toName: function() {
	                  if (this._a === 0) {
	                    return "transparent";
	                  }
	                  if (this._a < 1) {
	                    return false;
	                  }
	                  return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	                },
	                toFilter: function(secondColor) {
	                  var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	                  var secondHex8String = hex8String;
	                  var gradientType = this._gradientType ? "GradientType = 1, " : "";
	                  if (secondColor) {
	                    var s = tinycolor(secondColor);
	                    secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	                  }
	                  return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
	                },
	                toString: function(format) {
	                  var formatSet = !!format;
	                  format = format || this._format;
	                  var formattedString = false;
	                  var hasAlpha = this._a < 1 && this._a >= 0;
	                  var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	                  if (needsAlphaFormat) {
	                    if (format === "name" && this._a === 0) {
	                      return this.toName();
	                    }
	                    return this.toRgbString();
	                  }
	                  if (format === "rgb") {
	                    formattedString = this.toRgbString();
	                  }
	                  if (format === "prgb") {
	                    formattedString = this.toPercentageRgbString();
	                  }
	                  if (format === "hex" || format === "hex6") {
	                    formattedString = this.toHexString();
	                  }
	                  if (format === "hex3") {
	                    formattedString = this.toHexString(true);
	                  }
	                  if (format === "hex4") {
	                    formattedString = this.toHex8String(true);
	                  }
	                  if (format === "hex8") {
	                    formattedString = this.toHex8String();
	                  }
	                  if (format === "name") {
	                    formattedString = this.toName();
	                  }
	                  if (format === "hsl") {
	                    formattedString = this.toHslString();
	                  }
	                  if (format === "hsv") {
	                    formattedString = this.toHsvString();
	                  }
	                  return formattedString || this.toHexString();
	                },
	                clone: function() {
	                  return tinycolor(this.toString());
	                },
	                _applyModification: function(fn, args) {
	                  var color = fn.apply(null, [this].concat([].slice.call(args)));
	                  this._r = color._r;
	                  this._g = color._g;
	                  this._b = color._b;
	                  this.setAlpha(color._a);
	                  return this;
	                },
	                lighten: function() {
	                  return this._applyModification(lighten, arguments);
	                },
	                brighten: function() {
	                  return this._applyModification(brighten, arguments);
	                },
	                darken: function() {
	                  return this._applyModification(darken, arguments);
	                },
	                desaturate: function() {
	                  return this._applyModification(desaturate, arguments);
	                },
	                saturate: function() {
	                  return this._applyModification(saturate, arguments);
	                },
	                greyscale: function() {
	                  return this._applyModification(greyscale, arguments);
	                },
	                spin: function() {
	                  return this._applyModification(spin, arguments);
	                },
	                _applyCombination: function(fn, args) {
	                  return fn.apply(null, [this].concat([].slice.call(args)));
	                },
	                analogous: function() {
	                  return this._applyCombination(analogous, arguments);
	                },
	                complement: function() {
	                  return this._applyCombination(complement, arguments);
	                },
	                monochromatic: function() {
	                  return this._applyCombination(monochromatic, arguments);
	                },
	                splitcomplement: function() {
	                  return this._applyCombination(splitcomplement, arguments);
	                },
	                triad: function() {
	                  return this._applyCombination(triad, arguments);
	                },
	                tetrad: function() {
	                  return this._applyCombination(tetrad, arguments);
	                }
	              };
	              tinycolor.fromRatio = function(color, opts) {
	                if (typeof color == "object") {
	                  var newColor = {};
	                  for (var i in color) {
	                    if (color.hasOwnProperty(i)) {
	                      if (i === "a") {
	                        newColor[i] = color[i];
	                      } else {
	                        newColor[i] = convertToPercentage(color[i]);
	                      }
	                    }
	                  }
	                  color = newColor;
	                }
	                return tinycolor(color, opts);
	              };
	              function inputToRGB(color) {
	                var rgb = { r: 0, g: 0, b: 0 };
	                var a = 1;
	                var s = null;
	                var v = null;
	                var l = null;
	                var ok = false;
	                var format = false;
	                if (typeof color == "string") {
	                  color = stringInputToObject(color);
	                }
	                if (typeof color == "object") {
	                  if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	                    rgb = rgbToRgb(color.r, color.g, color.b);
	                    ok = true;
	                    format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	                  } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	                    s = convertToPercentage(color.s);
	                    v = convertToPercentage(color.v);
	                    rgb = hsvToRgb(color.h, s, v);
	                    ok = true;
	                    format = "hsv";
	                  } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	                    s = convertToPercentage(color.s);
	                    l = convertToPercentage(color.l);
	                    rgb = hslToRgb(color.h, s, l);
	                    ok = true;
	                    format = "hsl";
	                  }
	                  if (color.hasOwnProperty("a")) {
	                    a = color.a;
	                  }
	                }
	                a = boundAlpha(a);
	                return {
	                  ok,
	                  format: color.format || format,
	                  r: mathMin(255, mathMax(rgb.r, 0)),
	                  g: mathMin(255, mathMax(rgb.g, 0)),
	                  b: mathMin(255, mathMax(rgb.b, 0)),
	                  a
	                };
	              }
	              function rgbToRgb(r, g, b) {
	                return {
	                  r: bound01(r, 255) * 255,
	                  g: bound01(g, 255) * 255,
	                  b: bound01(b, 255) * 255
	                };
	              }
	              function rgbToHsl(r, g, b) {
	                r = bound01(r, 255);
	                g = bound01(g, 255);
	                b = bound01(b, 255);
	                var max = mathMax(r, g, b), min = mathMin(r, g, b);
	                var h, s, l = (max + min) / 2;
	                if (max == min) {
	                  h = s = 0;
	                } else {
	                  var d = max - min;
	                  s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	                  switch (max) {
	                    case r:
	                      h = (g - b) / d + (g < b ? 6 : 0);
	                      break;
	                    case g:
	                      h = (b - r) / d + 2;
	                      break;
	                    case b:
	                      h = (r - g) / d + 4;
	                      break;
	                  }
	                  h /= 6;
	                }
	                return { h, s, l };
	              }
	              function hslToRgb(h, s, l) {
	                var r, g, b;
	                h = bound01(h, 360);
	                s = bound01(s, 100);
	                l = bound01(l, 100);
	                function hue2rgb(p2, q2, t) {
	                  if (t < 0) t += 1;
	                  if (t > 1) t -= 1;
	                  if (t < 1 / 6) return p2 + (q2 - p2) * 6 * t;
	                  if (t < 1 / 2) return q2;
	                  if (t < 2 / 3) return p2 + (q2 - p2) * (2 / 3 - t) * 6;
	                  return p2;
	                }
	                if (s === 0) {
	                  r = g = b = l;
	                } else {
	                  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	                  var p = 2 * l - q;
	                  r = hue2rgb(p, q, h + 1 / 3);
	                  g = hue2rgb(p, q, h);
	                  b = hue2rgb(p, q, h - 1 / 3);
	                }
	                return { r: r * 255, g: g * 255, b: b * 255 };
	              }
	              function rgbToHsv(r, g, b) {
	                r = bound01(r, 255);
	                g = bound01(g, 255);
	                b = bound01(b, 255);
	                var max = mathMax(r, g, b), min = mathMin(r, g, b);
	                var h, s, v = max;
	                var d = max - min;
	                s = max === 0 ? 0 : d / max;
	                if (max == min) {
	                  h = 0;
	                } else {
	                  switch (max) {
	                    case r:
	                      h = (g - b) / d + (g < b ? 6 : 0);
	                      break;
	                    case g:
	                      h = (b - r) / d + 2;
	                      break;
	                    case b:
	                      h = (r - g) / d + 4;
	                      break;
	                  }
	                  h /= 6;
	                }
	                return { h, s, v };
	              }
	              function hsvToRgb(h, s, v) {
	                h = bound01(h, 360) * 6;
	                s = bound01(s, 100);
	                v = bound01(v, 100);
	                var i = Math2.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [v, q, p, p, t, v][mod], g = [t, v, v, q, p, p][mod], b = [p, p, t, v, v, q][mod];
	                return { r: r * 255, g: g * 255, b: b * 255 };
	              }
	              function rgbToHex(r, g, b, allow3Char) {
	                var hex = [
	                  pad2(mathRound(r).toString(16)),
	                  pad2(mathRound(g).toString(16)),
	                  pad2(mathRound(b).toString(16))
	                ];
	                if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	                  return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	                }
	                return hex.join("");
	              }
	              function rgbaToHex(r, g, b, a, allow4Char) {
	                var hex = [
	                  pad2(mathRound(r).toString(16)),
	                  pad2(mathRound(g).toString(16)),
	                  pad2(mathRound(b).toString(16)),
	                  pad2(convertDecimalToHex(a))
	                ];
	                if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	                  return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	                }
	                return hex.join("");
	              }
	              function rgbaToArgbHex(r, g, b, a) {
	                var hex = [
	                  pad2(convertDecimalToHex(a)),
	                  pad2(mathRound(r).toString(16)),
	                  pad2(mathRound(g).toString(16)),
	                  pad2(mathRound(b).toString(16))
	                ];
	                return hex.join("");
	              }
	              tinycolor.equals = function(color1, color2) {
	                if (!color1 || !color2) {
	                  return false;
	                }
	                return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	              };
	              tinycolor.random = function() {
	                return tinycolor.fromRatio({
	                  r: mathRandom(),
	                  g: mathRandom(),
	                  b: mathRandom()
	                });
	              };
	              function desaturate(color, amount) {
	                amount = amount === 0 ? 0 : amount || 10;
	                var hsl = tinycolor(color).toHsl();
	                hsl.s -= amount / 100;
	                hsl.s = clamp01(hsl.s);
	                return tinycolor(hsl);
	              }
	              function saturate(color, amount) {
	                amount = amount === 0 ? 0 : amount || 10;
	                var hsl = tinycolor(color).toHsl();
	                hsl.s += amount / 100;
	                hsl.s = clamp01(hsl.s);
	                return tinycolor(hsl);
	              }
	              function greyscale(color) {
	                return tinycolor(color).desaturate(100);
	              }
	              function lighten(color, amount) {
	                amount = amount === 0 ? 0 : amount || 10;
	                var hsl = tinycolor(color).toHsl();
	                hsl.l += amount / 100;
	                hsl.l = clamp01(hsl.l);
	                return tinycolor(hsl);
	              }
	              function brighten(color, amount) {
	                amount = amount === 0 ? 0 : amount || 10;
	                var rgb = tinycolor(color).toRgb();
	                rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
	                rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
	                rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
	                return tinycolor(rgb);
	              }
	              function darken(color, amount) {
	                amount = amount === 0 ? 0 : amount || 10;
	                var hsl = tinycolor(color).toHsl();
	                hsl.l -= amount / 100;
	                hsl.l = clamp01(hsl.l);
	                return tinycolor(hsl);
	              }
	              function spin(color, amount) {
	                var hsl = tinycolor(color).toHsl();
	                var hue = (hsl.h + amount) % 360;
	                hsl.h = hue < 0 ? 360 + hue : hue;
	                return tinycolor(hsl);
	              }
	              function complement(color) {
	                var hsl = tinycolor(color).toHsl();
	                hsl.h = (hsl.h + 180) % 360;
	                return tinycolor(hsl);
	              }
	              function triad(color) {
	                var hsl = tinycolor(color).toHsl();
	                var h = hsl.h;
	                return [
	                  tinycolor(color),
	                  tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	                  tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	                ];
	              }
	              function tetrad(color) {
	                var hsl = tinycolor(color).toHsl();
	                var h = hsl.h;
	                return [
	                  tinycolor(color),
	                  tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	                  tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	                  tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	                ];
	              }
	              function splitcomplement(color) {
	                var hsl = tinycolor(color).toHsl();
	                var h = hsl.h;
	                return [
	                  tinycolor(color),
	                  tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
	                  tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l })
	                ];
	              }
	              function analogous(color, results, slices) {
	                results = results || 6;
	                slices = slices || 30;
	                var hsl = tinycolor(color).toHsl();
	                var part = 360 / slices;
	                var ret = [tinycolor(color)];
	                for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
	                  hsl.h = (hsl.h + part) % 360;
	                  ret.push(tinycolor(hsl));
	                }
	                return ret;
	              }
	              function monochromatic(color, results) {
	                results = results || 6;
	                var hsv = tinycolor(color).toHsv();
	                var h = hsv.h, s = hsv.s, v = hsv.v;
	                var ret = [];
	                var modification = 1 / results;
	                while (results--) {
	                  ret.push(tinycolor({ h, s, v }));
	                  v = (v + modification) % 1;
	                }
	                return ret;
	              }
	              tinycolor.mix = function(color1, color2, amount) {
	                amount = amount === 0 ? 0 : amount || 50;
	                var rgb1 = tinycolor(color1).toRgb();
	                var rgb2 = tinycolor(color2).toRgb();
	                var p = amount / 100;
	                var rgba = {
	                  r: (rgb2.r - rgb1.r) * p + rgb1.r,
	                  g: (rgb2.g - rgb1.g) * p + rgb1.g,
	                  b: (rgb2.b - rgb1.b) * p + rgb1.b,
	                  a: (rgb2.a - rgb1.a) * p + rgb1.a
	                };
	                return tinycolor(rgba);
	              };
	              tinycolor.readability = function(color1, color2) {
	                var c1 = tinycolor(color1);
	                var c2 = tinycolor(color2);
	                return (Math2.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math2.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
	              };
	              tinycolor.isReadable = function(color1, color2, wcag2) {
	                var readability = tinycolor.readability(color1, color2);
	                var wcag2Parms, out;
	                out = false;
	                wcag2Parms = validateWCAG2Parms(wcag2);
	                switch (wcag2Parms.level + wcag2Parms.size) {
	                  case "AAsmall":
	                  case "AAAlarge":
	                    out = readability >= 4.5;
	                    break;
	                  case "AAlarge":
	                    out = readability >= 3;
	                    break;
	                  case "AAAsmall":
	                    out = readability >= 7;
	                    break;
	                }
	                return out;
	              };
	              tinycolor.mostReadable = function(baseColor, colorList, args) {
	                var bestColor = null;
	                var bestScore = 0;
	                var readability;
	                var includeFallbackColors, level, size;
	                args = args || {};
	                includeFallbackColors = args.includeFallbackColors;
	                level = args.level;
	                size = args.size;
	                for (var i = 0; i < colorList.length; i++) {
	                  readability = tinycolor.readability(baseColor, colorList[i]);
	                  if (readability > bestScore) {
	                    bestScore = readability;
	                    bestColor = tinycolor(colorList[i]);
	                  }
	                }
	                if (tinycolor.isReadable(baseColor, bestColor, { "level": level, "size": size }) || !includeFallbackColors) {
	                  return bestColor;
	                } else {
	                  args.includeFallbackColors = false;
	                  return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
	                }
	              };
	              var names = tinycolor.names = {
	                aliceblue: "f0f8ff",
	                antiquewhite: "faebd7",
	                aqua: "0ff",
	                aquamarine: "7fffd4",
	                azure: "f0ffff",
	                beige: "f5f5dc",
	                bisque: "ffe4c4",
	                black: "000",
	                blanchedalmond: "ffebcd",
	                blue: "00f",
	                blueviolet: "8a2be2",
	                brown: "a52a2a",
	                burlywood: "deb887",
	                burntsienna: "ea7e5d",
	                cadetblue: "5f9ea0",
	                chartreuse: "7fff00",
	                chocolate: "d2691e",
	                coral: "ff7f50",
	                cornflowerblue: "6495ed",
	                cornsilk: "fff8dc",
	                crimson: "dc143c",
	                cyan: "0ff",
	                darkblue: "00008b",
	                darkcyan: "008b8b",
	                darkgoldenrod: "b8860b",
	                darkgray: "a9a9a9",
	                darkgreen: "006400",
	                darkgrey: "a9a9a9",
	                darkkhaki: "bdb76b",
	                darkmagenta: "8b008b",
	                darkolivegreen: "556b2f",
	                darkorange: "ff8c00",
	                darkorchid: "9932cc",
	                darkred: "8b0000",
	                darksalmon: "e9967a",
	                darkseagreen: "8fbc8f",
	                darkslateblue: "483d8b",
	                darkslategray: "2f4f4f",
	                darkslategrey: "2f4f4f",
	                darkturquoise: "00ced1",
	                darkviolet: "9400d3",
	                deeppink: "ff1493",
	                deepskyblue: "00bfff",
	                dimgray: "696969",
	                dimgrey: "696969",
	                dodgerblue: "1e90ff",
	                firebrick: "b22222",
	                floralwhite: "fffaf0",
	                forestgreen: "228b22",
	                fuchsia: "f0f",
	                gainsboro: "dcdcdc",
	                ghostwhite: "f8f8ff",
	                gold: "ffd700",
	                goldenrod: "daa520",
	                gray: "808080",
	                green: "008000",
	                greenyellow: "adff2f",
	                grey: "808080",
	                honeydew: "f0fff0",
	                hotpink: "ff69b4",
	                indianred: "cd5c5c",
	                indigo: "4b0082",
	                ivory: "fffff0",
	                khaki: "f0e68c",
	                lavender: "e6e6fa",
	                lavenderblush: "fff0f5",
	                lawngreen: "7cfc00",
	                lemonchiffon: "fffacd",
	                lightblue: "add8e6",
	                lightcoral: "f08080",
	                lightcyan: "e0ffff",
	                lightgoldenrodyellow: "fafad2",
	                lightgray: "d3d3d3",
	                lightgreen: "90ee90",
	                lightgrey: "d3d3d3",
	                lightpink: "ffb6c1",
	                lightsalmon: "ffa07a",
	                lightseagreen: "20b2aa",
	                lightskyblue: "87cefa",
	                lightslategray: "789",
	                lightslategrey: "789",
	                lightsteelblue: "b0c4de",
	                lightyellow: "ffffe0",
	                lime: "0f0",
	                limegreen: "32cd32",
	                linen: "faf0e6",
	                magenta: "f0f",
	                maroon: "800000",
	                mediumaquamarine: "66cdaa",
	                mediumblue: "0000cd",
	                mediumorchid: "ba55d3",
	                mediumpurple: "9370db",
	                mediumseagreen: "3cb371",
	                mediumslateblue: "7b68ee",
	                mediumspringgreen: "00fa9a",
	                mediumturquoise: "48d1cc",
	                mediumvioletred: "c71585",
	                midnightblue: "191970",
	                mintcream: "f5fffa",
	                mistyrose: "ffe4e1",
	                moccasin: "ffe4b5",
	                navajowhite: "ffdead",
	                navy: "000080",
	                oldlace: "fdf5e6",
	                olive: "808000",
	                olivedrab: "6b8e23",
	                orange: "ffa500",
	                orangered: "ff4500",
	                orchid: "da70d6",
	                palegoldenrod: "eee8aa",
	                palegreen: "98fb98",
	                paleturquoise: "afeeee",
	                palevioletred: "db7093",
	                papayawhip: "ffefd5",
	                peachpuff: "ffdab9",
	                peru: "cd853f",
	                pink: "ffc0cb",
	                plum: "dda0dd",
	                powderblue: "b0e0e6",
	                purple: "800080",
	                rebeccapurple: "663399",
	                red: "f00",
	                rosybrown: "bc8f8f",
	                royalblue: "4169e1",
	                saddlebrown: "8b4513",
	                salmon: "fa8072",
	                sandybrown: "f4a460",
	                seagreen: "2e8b57",
	                seashell: "fff5ee",
	                sienna: "a0522d",
	                silver: "c0c0c0",
	                skyblue: "87ceeb",
	                slateblue: "6a5acd",
	                slategray: "708090",
	                slategrey: "708090",
	                snow: "fffafa",
	                springgreen: "00ff7f",
	                steelblue: "4682b4",
	                tan: "d2b48c",
	                teal: "008080",
	                thistle: "d8bfd8",
	                tomato: "ff6347",
	                turquoise: "40e0d0",
	                violet: "ee82ee",
	                wheat: "f5deb3",
	                white: "fff",
	                whitesmoke: "f5f5f5",
	                yellow: "ff0",
	                yellowgreen: "9acd32"
	              };
	              var hexNames = tinycolor.hexNames = flip(names);
	              function flip(o) {
	                var flipped = {};
	                for (var i in o) {
	                  if (o.hasOwnProperty(i)) {
	                    flipped[o[i]] = i;
	                  }
	                }
	                return flipped;
	              }
	              function boundAlpha(a) {
	                a = parseFloat(a);
	                if (isNaN(a) || a < 0 || a > 1) {
	                  a = 1;
	                }
	                return a;
	              }
	              function bound01(n, max) {
	                if (isOnePointZero(n)) {
	                  n = "100%";
	                }
	                var processPercent = isPercentage(n);
	                n = mathMin(max, mathMax(0, parseFloat(n)));
	                if (processPercent) {
	                  n = parseInt(n * max, 10) / 100;
	                }
	                if (Math2.abs(n - max) < 1e-6) {
	                  return 1;
	                }
	                return n % max / parseFloat(max);
	              }
	              function clamp01(val) {
	                return mathMin(1, mathMax(0, val));
	              }
	              function parseIntFromHex(val) {
	                return parseInt(val, 16);
	              }
	              function isOnePointZero(n) {
	                return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
	              }
	              function isPercentage(n) {
	                return typeof n === "string" && n.indexOf("%") != -1;
	              }
	              function pad2(c) {
	                return c.length == 1 ? "0" + c : "" + c;
	              }
	              function convertToPercentage(n) {
	                if (n <= 1) {
	                  n = n * 100 + "%";
	                }
	                return n;
	              }
	              function convertDecimalToHex(d) {
	                return Math2.round(parseFloat(d) * 255).toString(16);
	              }
	              function convertHexToDecimal(h) {
	                return parseIntFromHex(h) / 255;
	              }
	              var matchers = function() {
	                var CSS_INTEGER = "[-\\+]?\\d+%?";
	                var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	                var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	                var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	                var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	                return {
	                  CSS_UNIT: new RegExp(CSS_UNIT),
	                  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	                  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	                  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	                  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	                  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	                  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	                  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	                  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	                  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	                  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	                };
	              }();
	              function isValidCSSUnit(color) {
	                return !!matchers.CSS_UNIT.exec(color);
	              }
	              function stringInputToObject(color) {
	                color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
	                var named = false;
	                if (names[color]) {
	                  color = names[color];
	                  named = true;
	                } else if (color == "transparent") {
	                  return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	                }
	                var match;
	                if (match = matchers.rgb.exec(color)) {
	                  return { r: match[1], g: match[2], b: match[3] };
	                }
	                if (match = matchers.rgba.exec(color)) {
	                  return { r: match[1], g: match[2], b: match[3], a: match[4] };
	                }
	                if (match = matchers.hsl.exec(color)) {
	                  return { h: match[1], s: match[2], l: match[3] };
	                }
	                if (match = matchers.hsla.exec(color)) {
	                  return { h: match[1], s: match[2], l: match[3], a: match[4] };
	                }
	                if (match = matchers.hsv.exec(color)) {
	                  return { h: match[1], s: match[2], v: match[3] };
	                }
	                if (match = matchers.hsva.exec(color)) {
	                  return { h: match[1], s: match[2], v: match[3], a: match[4] };
	                }
	                if (match = matchers.hex8.exec(color)) {
	                  return {
	                    r: parseIntFromHex(match[1]),
	                    g: parseIntFromHex(match[2]),
	                    b: parseIntFromHex(match[3]),
	                    a: convertHexToDecimal(match[4]),
	                    format: named ? "name" : "hex8"
	                  };
	                }
	                if (match = matchers.hex6.exec(color)) {
	                  return {
	                    r: parseIntFromHex(match[1]),
	                    g: parseIntFromHex(match[2]),
	                    b: parseIntFromHex(match[3]),
	                    format: named ? "name" : "hex"
	                  };
	                }
	                if (match = matchers.hex4.exec(color)) {
	                  return {
	                    r: parseIntFromHex(match[1] + "" + match[1]),
	                    g: parseIntFromHex(match[2] + "" + match[2]),
	                    b: parseIntFromHex(match[3] + "" + match[3]),
	                    a: convertHexToDecimal(match[4] + "" + match[4]),
	                    format: named ? "name" : "hex8"
	                  };
	                }
	                if (match = matchers.hex3.exec(color)) {
	                  return {
	                    r: parseIntFromHex(match[1] + "" + match[1]),
	                    g: parseIntFromHex(match[2] + "" + match[2]),
	                    b: parseIntFromHex(match[3] + "" + match[3]),
	                    format: named ? "name" : "hex"
	                  };
	                }
	                return false;
	              }
	              function validateWCAG2Parms(parms) {
	                var level, size;
	                parms = parms || { "level": "AA", "size": "small" };
	                level = (parms.level || "AA").toUpperCase();
	                size = (parms.size || "small").toLowerCase();
	                if (level !== "AA" && level !== "AAA") {
	                  level = "AA";
	                }
	                if (size !== "small" && size !== "large") {
	                  size = "small";
	                }
	                return { "level": level, "size": size };
	              }
	              if (module2.exports) {
	                module2.exports = tinycolor;
	              } else {
	                !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                  return tinycolor;
	                }.call(exports2, __webpack_require__2, exports2, module2), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module2.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	              }
	            })(Math);
	          }
	        ),
	        /***/
	        57060: (
	          /***/
	          function(module2) {
	            module2.exports = float32;
	            module2.exports.float32 = module2.exports.float = float32;
	            module2.exports.fract32 = module2.exports.fract = fract32;
	            var narr = new Float32Array(1);
	            function fract32(arr, fract) {
	              if (arr.length) {
	                if (arr instanceof Float32Array) return new Float32Array(arr.length);
	                if (!(fract instanceof Float32Array)) fract = float32(arr);
	                for (var i = 0, l = fract.length; i < l; i++) {
	                  fract[i] = arr[i] - fract[i];
	                }
	                return fract;
	              }
	              return float32(arr - float32(arr));
	            }
	            function float32(arr) {
	              if (arr.length) {
	                if (arr instanceof Float32Array) return arr;
	                return new Float32Array(arr);
	              }
	              narr[0] = arr;
	              return narr[0];
	            }
	          }
	        ),
	        /***/
	        75686: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var parseUnit = __webpack_require__2(25677);
	            module2.exports = toPX;
	            var PIXELS_PER_INCH = 96;
	            function getPropertyInPX(element, prop) {
	              var parts = parseUnit(getComputedStyle(element).getPropertyValue(prop));
	              return parts[0] * toPX(parts[1], element);
	            }
	            function getSizeBrutal(unit, element) {
	              var testDIV = document.createElement("div");
	              testDIV.style["font-size"] = "128" + unit;
	              element.appendChild(testDIV);
	              var size = getPropertyInPX(testDIV, "font-size") / 128;
	              element.removeChild(testDIV);
	              return size;
	            }
	            function toPX(str, element) {
	              element = element || document.body;
	              str = (str || "px").trim().toLowerCase();
	              if (element === window || element === document) {
	                element = document.body;
	              }
	              switch (str) {
	                case "%":
	                  return element.clientHeight / 100;
	                case "ch":
	                case "ex":
	                  return getSizeBrutal(str, element);
	                case "em":
	                  return getPropertyInPX(element, "font-size");
	                case "rem":
	                  return getPropertyInPX(document.body, "font-size");
	                case "vw":
	                  return window.innerWidth / 100;
	                case "vh":
	                  return window.innerHeight / 100;
	                case "vmin":
	                  return Math.min(window.innerWidth, window.innerHeight) / 100;
	                case "vmax":
	                  return Math.max(window.innerWidth, window.innerHeight) / 100;
	                case "in":
	                  return PIXELS_PER_INCH;
	                case "cm":
	                  return PIXELS_PER_INCH / 2.54;
	                case "mm":
	                  return PIXELS_PER_INCH / 25.4;
	                case "pt":
	                  return PIXELS_PER_INCH / 72;
	                case "pc":
	                  return PIXELS_PER_INCH / 6;
	              }
	              return 1;
	            }
	          }
	        ),
	        /***/
	        96892: (
	          /***/
	          function(__unused_webpack_module, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              zL: function() {
	                return (
	                  /* reexport */
	                  feature
	                );
	              }
	            });
	            function reverse(array, n) {
	              var t, j = array.length, i = j - n;
	              while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	            }
	            function identity2(x) {
	              return x;
	            }
	            function transform(transform2) {
	              if (transform2 == null) return identity2;
	              var x0, y0, kx = transform2.scale[0], ky = transform2.scale[1], dx = transform2.translate[0], dy = transform2.translate[1];
	              return function(input, i) {
	                if (!i) x0 = y0 = 0;
	                var j = 2, n = input.length, output = new Array(n);
	                output[0] = (x0 += input[0]) * kx + dx;
	                output[1] = (y0 += input[1]) * ky + dy;
	                while (j < n) output[j] = input[j], ++j;
	                return output;
	              };
	            }
	            function feature(topology, o) {
	              if (typeof o === "string") o = topology.objects[o];
	              return o.type === "GeometryCollection" ? { type: "FeatureCollection", features: o.geometries.map(function(o2) {
	                return feature_feature(topology, o2);
	              }) } : feature_feature(topology, o);
	            }
	            function feature_feature(topology, o) {
	              var id = o.id, bbox = o.bbox, properties = o.properties == null ? {} : o.properties, geometry = object(topology, o);
	              return id == null && bbox == null ? { type: "Feature", properties, geometry } : bbox == null ? { type: "Feature", id, properties, geometry } : { type: "Feature", id, bbox, properties, geometry };
	            }
	            function object(topology, o) {
	              var transformPoint = transform(topology.transform), arcs = topology.arcs;
	              function arc(i, points) {
	                if (points.length) points.pop();
	                for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	                  points.push(transformPoint(a[k], k));
	                }
	                if (i < 0) reverse(points, n);
	              }
	              function point(p) {
	                return transformPoint(p);
	              }
	              function line(arcs2) {
	                var points = [];
	                for (var i = 0, n = arcs2.length; i < n; ++i) arc(arcs2[i], points);
	                if (points.length < 2) points.push(points[0]);
	                return points;
	              }
	              function ring(arcs2) {
	                var points = line(arcs2);
	                while (points.length < 4) points.push(points[0]);
	                return points;
	              }
	              function polygon(arcs2) {
	                return arcs2.map(ring);
	              }
	              function geometry(o2) {
	                var type = o2.type, coordinates;
	                switch (type) {
	                  case "GeometryCollection":
	                    return { type, geometries: o2.geometries.map(geometry) };
	                  case "Point":
	                    coordinates = point(o2.coordinates);
	                    break;
	                  case "MultiPoint":
	                    coordinates = o2.coordinates.map(point);
	                    break;
	                  case "LineString":
	                    coordinates = line(o2.arcs);
	                    break;
	                  case "MultiLineString":
	                    coordinates = o2.arcs.map(line);
	                    break;
	                  case "Polygon":
	                    coordinates = polygon(o2.arcs);
	                    break;
	                  case "MultiPolygon":
	                    coordinates = o2.arcs.map(polygon);
	                    break;
	                  default:
	                    return null;
	                }
	                return { type, coordinates };
	              }
	              return geometry(o);
	            }
	          }
	        ),
	        /***/
	        73116: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isPrototype = __webpack_require__2(24511);
	            module2.exports = function(value) {
	              if (typeof value !== "function") return false;
	              if (!hasOwnProperty.call(value, "length")) return false;
	              try {
	                if (typeof value.length !== "number") return false;
	                if (typeof value.call !== "function") return false;
	                if (typeof value.apply !== "function") return false;
	              } catch (error) {
	                return false;
	              }
	              return !isPrototype(value);
	            };
	          }
	        ),
	        /***/
	        69190: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(24582), isObject = __webpack_require__2(47403), stringCoerce = __webpack_require__2(9234), toShortString = __webpack_require__2(6048);
	            var resolveMessage = function(message, value) {
	              return message.replace("%v", toShortString(value));
	            };
	            module2.exports = function(value, defaultMessage, inputOptions) {
	              if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));
	              if (!isValue(value)) {
	                if ("default" in inputOptions) return inputOptions["default"];
	                if (inputOptions.isOptional) return null;
	              }
	              var errorMessage = stringCoerce(inputOptions.errorMessage);
	              if (!isValue(errorMessage)) errorMessage = defaultMessage;
	              throw new TypeError(resolveMessage(errorMessage, value));
	            };
	          }
	        ),
	        /***/
	        18497: (
	          /***/
	          function(module2) {
	            module2.exports = function(value) {
	              try {
	                return value.toString();
	              } catch (error) {
	                try {
	                  return String(value);
	                } catch (error2) {
	                  return null;
	                }
	              }
	            };
	          }
	        ),
	        /***/
	        6048: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var safeToString = __webpack_require__2(18497);
	            var reNewLine = /[\n\r\u2028\u2029]/g;
	            module2.exports = function(value) {
	              var string = safeToString(value);
	              if (string === null) return "<Non-coercible to string value>";
	              if (string.length > 100) string = string.slice(0, 99) + "…";
	              string = string.replace(reNewLine, function(char) {
	                switch (char) {
	                  case "\n":
	                    return "\\n";
	                  case "\r":
	                    return "\\r";
	                  case "\u2028":
	                    return "\\u2028";
	                  case "\u2029":
	                    return "\\u2029";
	                  default:
	                    throw new Error("Unexpected character");
	                }
	              });
	              return string;
	            };
	          }
	        ),
	        /***/
	        47403: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(24582);
	            var possibleTypes = {
	              "object": true,
	              "function": true,
	              "undefined": true
	              /* document.all */
	            };
	            module2.exports = function(value) {
	              if (!isValue(value)) return false;
	              return hasOwnProperty.call(possibleTypes, typeof value);
	            };
	          }
	        ),
	        /***/
	        82527: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var resolveException = __webpack_require__2(69190), is = __webpack_require__2(84985);
	            module2.exports = function(value) {
	              if (is(value)) return value;
	              return resolveException(value, "%v is not a plain function", arguments[1]);
	            };
	          }
	        ),
	        /***/
	        84985: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isFunction = __webpack_require__2(73116);
	            var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;
	            module2.exports = function(value) {
	              if (!isFunction(value)) return false;
	              if (classRe.test(functionToString.call(value))) return false;
	              return true;
	            };
	          }
	        ),
	        /***/
	        24511: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isObject = __webpack_require__2(47403);
	            module2.exports = function(value) {
	              if (!isObject(value)) return false;
	              try {
	                if (!value.constructor) return false;
	                return value.constructor.prototype === value;
	              } catch (error) {
	                return false;
	              }
	            };
	          }
	        ),
	        /***/
	        9234: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var isValue = __webpack_require__2(24582), isObject = __webpack_require__2(47403);
	            var objectToString = Object.prototype.toString;
	            module2.exports = function(value) {
	              if (!isValue(value)) return null;
	              if (isObject(value)) {
	                var valueToString = value.toString;
	                if (typeof valueToString !== "function") return null;
	                if (valueToString === objectToString) return null;
	              }
	              try {
	                return "" + value;
	              } catch (error) {
	                return null;
	              }
	            };
	          }
	        ),
	        /***/
	        10424: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var resolveException = __webpack_require__2(69190), is = __webpack_require__2(24582);
	            module2.exports = function(value) {
	              if (is(value)) return value;
	              return resolveException(value, "Cannot use %v", arguments[1]);
	            };
	          }
	        ),
	        /***/
	        24582: (
	          /***/
	          function(module2) {
	            var _undefined = undefined;
	            module2.exports = function(value) {
	              return value !== _undefined && value !== null;
	            };
	          }
	        ),
	        /***/
	        58404: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var bits = __webpack_require__2(13547);
	            var dup = __webpack_require__2(12129);
	            var Buffer2 = __webpack_require__2(12856).Buffer;
	            if (!__webpack_require__2.g.__TYPEDARRAY_POOL) {
	              __webpack_require__2.g.__TYPEDARRAY_POOL = {
	                UINT8: dup([32, 0]),
	                UINT16: dup([32, 0]),
	                UINT32: dup([32, 0]),
	                BIGUINT64: dup([32, 0]),
	                INT8: dup([32, 0]),
	                INT16: dup([32, 0]),
	                INT32: dup([32, 0]),
	                BIGINT64: dup([32, 0]),
	                FLOAT: dup([32, 0]),
	                DOUBLE: dup([32, 0]),
	                DATA: dup([32, 0]),
	                UINT8C: dup([32, 0]),
	                BUFFER: dup([32, 0])
	              };
	            }
	            var hasUint8C = typeof Uint8ClampedArray !== "undefined";
	            var hasBigUint64 = typeof BigUint64Array !== "undefined";
	            var hasBigInt64 = typeof BigInt64Array !== "undefined";
	            var POOL = __webpack_require__2.g.__TYPEDARRAY_POOL;
	            if (!POOL.UINT8C) {
	              POOL.UINT8C = dup([32, 0]);
	            }
	            if (!POOL.BIGUINT64) {
	              POOL.BIGUINT64 = dup([32, 0]);
	            }
	            if (!POOL.BIGINT64) {
	              POOL.BIGINT64 = dup([32, 0]);
	            }
	            if (!POOL.BUFFER) {
	              POOL.BUFFER = dup([32, 0]);
	            }
	            var DATA = POOL.DATA, BUFFER = POOL.BUFFER;
	            exports2.free = function free(array) {
	              if (Buffer2.isBuffer(array)) {
	                BUFFER[bits.log2(array.length)].push(array);
	              } else {
	                if (Object.prototype.toString.call(array) !== "[object ArrayBuffer]") {
	                  array = array.buffer;
	                }
	                if (!array) {
	                  return;
	                }
	                var n = array.length || array.byteLength;
	                var log_n = bits.log2(n) | 0;
	                DATA[log_n].push(array);
	              }
	            };
	            function freeArrayBuffer(buffer) {
	              if (!buffer) {
	                return;
	              }
	              var n = buffer.length || buffer.byteLength;
	              var log_n = bits.log2(n);
	              DATA[log_n].push(buffer);
	            }
	            function freeTypedArray(array) {
	              freeArrayBuffer(array.buffer);
	            }
	            exports2.freeUint8 = exports2.freeUint16 = exports2.freeUint32 = exports2.freeBigUint64 = exports2.freeInt8 = exports2.freeInt16 = exports2.freeInt32 = exports2.freeBigInt64 = exports2.freeFloat32 = exports2.freeFloat = exports2.freeFloat64 = exports2.freeDouble = exports2.freeUint8Clamped = exports2.freeDataView = freeTypedArray;
	            exports2.freeArrayBuffer = freeArrayBuffer;
	            exports2.freeBuffer = function freeBuffer(array) {
	              BUFFER[bits.log2(array.length)].push(array);
	            };
	            exports2.malloc = function malloc(n, dtype) {
	              if (dtype === undefined || dtype === "arraybuffer") {
	                return mallocArrayBuffer(n);
	              } else {
	                switch (dtype) {
	                  case "uint8":
	                    return mallocUint8(n);
	                  case "uint16":
	                    return mallocUint16(n);
	                  case "uint32":
	                    return mallocUint32(n);
	                  case "int8":
	                    return mallocInt8(n);
	                  case "int16":
	                    return mallocInt16(n);
	                  case "int32":
	                    return mallocInt32(n);
	                  case "float":
	                  case "float32":
	                    return mallocFloat(n);
	                  case "double":
	                  case "float64":
	                    return mallocDouble(n);
	                  case "uint8_clamped":
	                    return mallocUint8Clamped(n);
	                  case "bigint64":
	                    return mallocBigInt64(n);
	                  case "biguint64":
	                    return mallocBigUint64(n);
	                  case "buffer":
	                    return mallocBuffer(n);
	                  case "data":
	                  case "dataview":
	                    return mallocDataView(n);
	                  default:
	                    return null;
	                }
	              }
	              return null;
	            };
	            function mallocArrayBuffer(n) {
	              var n = bits.nextPow2(n);
	              var log_n = bits.log2(n);
	              var d = DATA[log_n];
	              if (d.length > 0) {
	                return d.pop();
	              }
	              return new ArrayBuffer(n);
	            }
	            exports2.mallocArrayBuffer = mallocArrayBuffer;
	            function mallocUint8(n) {
	              return new Uint8Array(mallocArrayBuffer(n), 0, n);
	            }
	            exports2.mallocUint8 = mallocUint8;
	            function mallocUint16(n) {
	              return new Uint16Array(mallocArrayBuffer(2 * n), 0, n);
	            }
	            exports2.mallocUint16 = mallocUint16;
	            function mallocUint32(n) {
	              return new Uint32Array(mallocArrayBuffer(4 * n), 0, n);
	            }
	            exports2.mallocUint32 = mallocUint32;
	            function mallocInt8(n) {
	              return new Int8Array(mallocArrayBuffer(n), 0, n);
	            }
	            exports2.mallocInt8 = mallocInt8;
	            function mallocInt16(n) {
	              return new Int16Array(mallocArrayBuffer(2 * n), 0, n);
	            }
	            exports2.mallocInt16 = mallocInt16;
	            function mallocInt32(n) {
	              return new Int32Array(mallocArrayBuffer(4 * n), 0, n);
	            }
	            exports2.mallocInt32 = mallocInt32;
	            function mallocFloat(n) {
	              return new Float32Array(mallocArrayBuffer(4 * n), 0, n);
	            }
	            exports2.mallocFloat32 = exports2.mallocFloat = mallocFloat;
	            function mallocDouble(n) {
	              return new Float64Array(mallocArrayBuffer(8 * n), 0, n);
	            }
	            exports2.mallocFloat64 = exports2.mallocDouble = mallocDouble;
	            function mallocUint8Clamped(n) {
	              if (hasUint8C) {
	                return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n);
	              } else {
	                return mallocUint8(n);
	              }
	            }
	            exports2.mallocUint8Clamped = mallocUint8Clamped;
	            function mallocBigUint64(n) {
	              if (hasBigUint64) {
	                return new BigUint64Array(mallocArrayBuffer(8 * n), 0, n);
	              } else {
	                return null;
	              }
	            }
	            exports2.mallocBigUint64 = mallocBigUint64;
	            function mallocBigInt64(n) {
	              if (hasBigInt64) {
	                return new BigInt64Array(mallocArrayBuffer(8 * n), 0, n);
	              } else {
	                return null;
	              }
	            }
	            exports2.mallocBigInt64 = mallocBigInt64;
	            function mallocDataView(n) {
	              return new DataView(mallocArrayBuffer(n), 0, n);
	            }
	            exports2.mallocDataView = mallocDataView;
	            function mallocBuffer(n) {
	              n = bits.nextPow2(n);
	              var log_n = bits.log2(n);
	              var cache = BUFFER[log_n];
	              if (cache.length > 0) {
	                return cache.pop();
	              }
	              return new Buffer2(n);
	            }
	            exports2.mallocBuffer = mallocBuffer;
	            exports2.clearCache = function clearCache() {
	              for (var i = 0; i < 32; ++i) {
	                POOL.UINT8[i].length = 0;
	                POOL.UINT16[i].length = 0;
	                POOL.UINT32[i].length = 0;
	                POOL.INT8[i].length = 0;
	                POOL.INT16[i].length = 0;
	                POOL.INT32[i].length = 0;
	                POOL.FLOAT[i].length = 0;
	                POOL.DOUBLE[i].length = 0;
	                POOL.BIGUINT64[i].length = 0;
	                POOL.BIGINT64[i].length = 0;
	                POOL.UINT8C[i].length = 0;
	                DATA[i].length = 0;
	                BUFFER[i].length = 0;
	              }
	            };
	          }
	        ),
	        /***/
	        90448: (
	          /***/
	          function(module2) {
	            var reg = /[\'\"]/;
	            module2.exports = function unquote(str) {
	              if (!str) {
	                return "";
	              }
	              if (reg.test(str.charAt(0))) {
	                str = str.substr(1);
	              }
	              if (reg.test(str.charAt(str.length - 1))) {
	                str = str.substr(0, str.length - 1);
	              }
	              return str;
	            };
	          }
	        ),
	        /***/
	        93447: (
	          /***/
	          function(module2) {
	            module2.exports = function updateDiff(obj, diff, mappers) {
	              if (!Array.isArray(mappers)) mappers = [].slice.call(arguments, 2);
	              for (var i = 0, l = mappers.length; i < l; i++) {
	                var dict = mappers[i];
	                for (var prop in dict) {
	                  if (diff[prop] !== undefined && !Array.isArray(diff[prop]) && obj[prop] === diff[prop]) continue;
	                  if (prop in diff) {
	                    var result;
	                    if (dict[prop] === true) result = diff[prop];
	                    else if (dict[prop] === false) continue;
	                    else if (typeof dict[prop] === "function") {
	                      result = dict[prop](diff[prop], obj, diff);
	                      if (result === undefined) continue;
	                    }
	                    obj[prop] = result;
	                  }
	                }
	              }
	              return obj;
	            };
	          }
	        ),
	        /***/
	        20588: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            module2.exports = deprecate;
	            function deprecate(fn, msg) {
	              if (config("noDeprecation")) {
	                return fn;
	              }
	              var warned = false;
	              function deprecated() {
	                if (!warned) {
	                  if (config("throwDeprecation")) {
	                    throw new Error(msg);
	                  } else if (config("traceDeprecation")) {
	                    console.trace(msg);
	                  } else {
	                    console.warn(msg);
	                  }
	                  warned = true;
	                }
	                return fn.apply(this, arguments);
	              }
	              return deprecated;
	            }
	            function config(name2) {
	              try {
	                if (!__webpack_require__2.g.localStorage) return false;
	              } catch (_) {
	                return false;
	              }
	              var val = __webpack_require__2.g.localStorage[name2];
	              if (null == val) return false;
	              return String(val).toLowerCase() === "true";
	            }
	          }
	        ),
	        /***/
	        45920: (
	          /***/
	          function(module2) {
	            module2.exports = function isBuffer(arg) {
	              return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
	            };
	          }
	        ),
	        /***/
	        4936: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var isArgumentsObject = __webpack_require__2(47216);
	            var isGeneratorFunction = __webpack_require__2(65481);
	            var whichTypedArray = __webpack_require__2(21099);
	            var isTypedArray = __webpack_require__2(9187);
	            function uncurryThis(f) {
	              return f.call.bind(f);
	            }
	            var BigIntSupported = typeof BigInt !== "undefined";
	            var SymbolSupported = typeof Symbol !== "undefined";
	            var ObjectToString = uncurryThis(Object.prototype.toString);
	            var numberValue = uncurryThis(Number.prototype.valueOf);
	            var stringValue = uncurryThis(String.prototype.valueOf);
	            var booleanValue = uncurryThis(Boolean.prototype.valueOf);
	            if (BigIntSupported) {
	              var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
	            }
	            if (SymbolSupported) {
	              var symbolValue = uncurryThis(Symbol.prototype.valueOf);
	            }
	            function checkBoxedPrimitive(value, prototypeValueOf) {
	              if (typeof value !== "object") {
	                return false;
	              }
	              try {
	                prototypeValueOf(value);
	                return true;
	              } catch (e) {
	                return false;
	              }
	            }
	            exports2.isArgumentsObject = isArgumentsObject;
	            exports2.isGeneratorFunction = isGeneratorFunction;
	            exports2.isTypedArray = isTypedArray;
	            function isPromise(input) {
	              return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
	            }
	            exports2.isPromise = isPromise;
	            function isArrayBufferView(value) {
	              if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
	                return ArrayBuffer.isView(value);
	              }
	              return isTypedArray(value) || isDataView(value);
	            }
	            exports2.isArrayBufferView = isArrayBufferView;
	            function isUint8Array(value) {
	              return whichTypedArray(value) === "Uint8Array";
	            }
	            exports2.isUint8Array = isUint8Array;
	            function isUint8ClampedArray(value) {
	              return whichTypedArray(value) === "Uint8ClampedArray";
	            }
	            exports2.isUint8ClampedArray = isUint8ClampedArray;
	            function isUint16Array(value) {
	              return whichTypedArray(value) === "Uint16Array";
	            }
	            exports2.isUint16Array = isUint16Array;
	            function isUint32Array(value) {
	              return whichTypedArray(value) === "Uint32Array";
	            }
	            exports2.isUint32Array = isUint32Array;
	            function isInt8Array(value) {
	              return whichTypedArray(value) === "Int8Array";
	            }
	            exports2.isInt8Array = isInt8Array;
	            function isInt16Array(value) {
	              return whichTypedArray(value) === "Int16Array";
	            }
	            exports2.isInt16Array = isInt16Array;
	            function isInt32Array(value) {
	              return whichTypedArray(value) === "Int32Array";
	            }
	            exports2.isInt32Array = isInt32Array;
	            function isFloat32Array(value) {
	              return whichTypedArray(value) === "Float32Array";
	            }
	            exports2.isFloat32Array = isFloat32Array;
	            function isFloat64Array(value) {
	              return whichTypedArray(value) === "Float64Array";
	            }
	            exports2.isFloat64Array = isFloat64Array;
	            function isBigInt64Array(value) {
	              return whichTypedArray(value) === "BigInt64Array";
	            }
	            exports2.isBigInt64Array = isBigInt64Array;
	            function isBigUint64Array(value) {
	              return whichTypedArray(value) === "BigUint64Array";
	            }
	            exports2.isBigUint64Array = isBigUint64Array;
	            function isMapToString(value) {
	              return ObjectToString(value) === "[object Map]";
	            }
	            isMapToString.working = typeof Map !== "undefined" && isMapToString(/* @__PURE__ */ new Map());
	            function isMap(value) {
	              if (typeof Map === "undefined") {
	                return false;
	              }
	              return isMapToString.working ? isMapToString(value) : value instanceof Map;
	            }
	            exports2.isMap = isMap;
	            function isSetToString(value) {
	              return ObjectToString(value) === "[object Set]";
	            }
	            isSetToString.working = typeof Set !== "undefined" && isSetToString(/* @__PURE__ */ new Set());
	            function isSet(value) {
	              if (typeof Set === "undefined") {
	                return false;
	              }
	              return isSetToString.working ? isSetToString(value) : value instanceof Set;
	            }
	            exports2.isSet = isSet;
	            function isWeakMapToString(value) {
	              return ObjectToString(value) === "[object WeakMap]";
	            }
	            isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(/* @__PURE__ */ new WeakMap());
	            function isWeakMap(value) {
	              if (typeof WeakMap === "undefined") {
	                return false;
	              }
	              return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
	            }
	            exports2.isWeakMap = isWeakMap;
	            function isWeakSetToString(value) {
	              return ObjectToString(value) === "[object WeakSet]";
	            }
	            isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(/* @__PURE__ */ new WeakSet());
	            function isWeakSet(value) {
	              return isWeakSetToString(value);
	            }
	            exports2.isWeakSet = isWeakSet;
	            function isArrayBufferToString(value) {
	              return ObjectToString(value) === "[object ArrayBuffer]";
	            }
	            isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
	            function isArrayBuffer(value) {
	              if (typeof ArrayBuffer === "undefined") {
	                return false;
	              }
	              return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
	            }
	            exports2.isArrayBuffer = isArrayBuffer;
	            function isDataViewToString(value) {
	              return ObjectToString(value) === "[object DataView]";
	            }
	            isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
	            function isDataView(value) {
	              if (typeof DataView === "undefined") {
	                return false;
	              }
	              return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
	            }
	            exports2.isDataView = isDataView;
	            var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
	            function isSharedArrayBufferToString(value) {
	              return ObjectToString(value) === "[object SharedArrayBuffer]";
	            }
	            function isSharedArrayBuffer(value) {
	              if (typeof SharedArrayBufferCopy === "undefined") {
	                return false;
	              }
	              if (typeof isSharedArrayBufferToString.working === "undefined") {
	                isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
	              }
	              return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
	            }
	            exports2.isSharedArrayBuffer = isSharedArrayBuffer;
	            function isAsyncFunction(value) {
	              return ObjectToString(value) === "[object AsyncFunction]";
	            }
	            exports2.isAsyncFunction = isAsyncFunction;
	            function isMapIterator(value) {
	              return ObjectToString(value) === "[object Map Iterator]";
	            }
	            exports2.isMapIterator = isMapIterator;
	            function isSetIterator(value) {
	              return ObjectToString(value) === "[object Set Iterator]";
	            }
	            exports2.isSetIterator = isSetIterator;
	            function isGeneratorObject(value) {
	              return ObjectToString(value) === "[object Generator]";
	            }
	            exports2.isGeneratorObject = isGeneratorObject;
	            function isWebAssemblyCompiledModule(value) {
	              return ObjectToString(value) === "[object WebAssembly.Module]";
	            }
	            exports2.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
	            function isNumberObject(value) {
	              return checkBoxedPrimitive(value, numberValue);
	            }
	            exports2.isNumberObject = isNumberObject;
	            function isStringObject(value) {
	              return checkBoxedPrimitive(value, stringValue);
	            }
	            exports2.isStringObject = isStringObject;
	            function isBooleanObject(value) {
	              return checkBoxedPrimitive(value, booleanValue);
	            }
	            exports2.isBooleanObject = isBooleanObject;
	            function isBigIntObject(value) {
	              return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
	            }
	            exports2.isBigIntObject = isBigIntObject;
	            function isSymbolObject(value) {
	              return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
	            }
	            exports2.isSymbolObject = isSymbolObject;
	            function isBoxedPrimitive(value) {
	              return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
	            }
	            exports2.isBoxedPrimitive = isBoxedPrimitive;
	            function isAnyArrayBuffer(value) {
	              return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
	            }
	            exports2.isAnyArrayBuffer = isAnyArrayBuffer;
	            ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(method) {
	              Object.defineProperty(exports2, method, {
	                enumerable: false,
	                value: function() {
	                  throw new Error(method + " is not supported in userland");
	                }
	              });
	            });
	          }
	        ),
	        /***/
	        43827: (
	          /***/
	          function(__unused_webpack_module, exports2, __webpack_require__2) {
	            var process = __webpack_require__2(90386);
	            var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
	              var keys = Object.keys(obj);
	              var descriptors = {};
	              for (var i = 0; i < keys.length; i++) {
	                descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
	              }
	              return descriptors;
	            };
	            var formatRegExp = /%[sdj%]/g;
	            exports2.format = function(f) {
	              if (!isString(f)) {
	                var objects = [];
	                for (var i = 0; i < arguments.length; i++) {
	                  objects.push(inspect(arguments[i]));
	                }
	                return objects.join(" ");
	              }
	              var i = 1;
	              var args = arguments;
	              var len = args.length;
	              var str = String(f).replace(formatRegExp, function(x2) {
	                if (x2 === "%%") return "%";
	                if (i >= len) return x2;
	                switch (x2) {
	                  case "%s":
	                    return String(args[i++]);
	                  case "%d":
	                    return Number(args[i++]);
	                  case "%j":
	                    try {
	                      return JSON.stringify(args[i++]);
	                    } catch (_) {
	                      return "[Circular]";
	                    }
	                  default:
	                    return x2;
	                }
	              });
	              for (var x = args[i]; i < len; x = args[++i]) {
	                if (isNull(x) || !isObject(x)) {
	                  str += " " + x;
	                } else {
	                  str += " " + inspect(x);
	                }
	              }
	              return str;
	            };
	            exports2.deprecate = function(fn, msg) {
	              if (typeof process !== "undefined" && process.noDeprecation === true) {
	                return fn;
	              }
	              if (typeof process === "undefined") {
	                return function() {
	                  return exports2.deprecate(fn, msg).apply(this, arguments);
	                };
	              }
	              var warned = false;
	              function deprecated() {
	                if (!warned) {
	                  if (process.throwDeprecation) {
	                    throw new Error(msg);
	                  } else if (process.traceDeprecation) {
	                    console.trace(msg);
	                  } else {
	                    console.error(msg);
	                  }
	                  warned = true;
	                }
	                return fn.apply(this, arguments);
	              }
	              return deprecated;
	            };
	            var debugs = {};
	            var debugEnvRegex = /^$/;
	            if (process.env.NODE_DEBUG) {
	              var debugEnv = process.env.NODE_DEBUG;
	              debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
	              debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
	            }
	            exports2.debuglog = function(set) {
	              set = set.toUpperCase();
	              if (!debugs[set]) {
	                if (debugEnvRegex.test(set)) {
	                  var pid = process.pid;
	                  debugs[set] = function() {
	                    var msg = exports2.format.apply(exports2, arguments);
	                    console.error("%s %d: %s", set, pid, msg);
	                  };
	                } else {
	                  debugs[set] = function() {
	                  };
	                }
	              }
	              return debugs[set];
	            };
	            function inspect(obj, opts) {
	              var ctx = {
	                seen: [],
	                stylize: stylizeNoColor
	              };
	              if (arguments.length >= 3) ctx.depth = arguments[2];
	              if (arguments.length >= 4) ctx.colors = arguments[3];
	              if (isBoolean(opts)) {
	                ctx.showHidden = opts;
	              } else if (opts) {
	                exports2._extend(ctx, opts);
	              }
	              if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	              if (isUndefined(ctx.depth)) ctx.depth = 2;
	              if (isUndefined(ctx.colors)) ctx.colors = false;
	              if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	              if (ctx.colors) ctx.stylize = stylizeWithColor;
	              return formatValue(ctx, obj, ctx.depth);
	            }
	            exports2.inspect = inspect;
	            inspect.colors = {
	              "bold": [1, 22],
	              "italic": [3, 23],
	              "underline": [4, 24],
	              "inverse": [7, 27],
	              "white": [37, 39],
	              "grey": [90, 39],
	              "black": [30, 39],
	              "blue": [34, 39],
	              "cyan": [36, 39],
	              "green": [32, 39],
	              "magenta": [35, 39],
	              "red": [31, 39],
	              "yellow": [33, 39]
	            };
	            inspect.styles = {
	              "special": "cyan",
	              "number": "yellow",
	              "boolean": "yellow",
	              "undefined": "grey",
	              "null": "bold",
	              "string": "green",
	              "date": "magenta",
	              // "name": intentionally not styling
	              "regexp": "red"
	            };
	            function stylizeWithColor(str, styleType) {
	              var style = inspect.styles[styleType];
	              if (style) {
	                return "\x1B[" + inspect.colors[style][0] + "m" + str + "\x1B[" + inspect.colors[style][1] + "m";
	              } else {
	                return str;
	              }
	            }
	            function stylizeNoColor(str, styleType) {
	              return str;
	            }
	            function arrayToHash(array) {
	              var hash = {};
	              array.forEach(function(val, idx) {
	                hash[val] = true;
	              });
	              return hash;
	            }
	            function formatValue(ctx, value, recurseTimes) {
	              if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
	              value.inspect !== exports2.inspect && // Also filter out any prototype objects using the circular check.
	              !(value.constructor && value.constructor.prototype === value)) {
	                var ret = value.inspect(recurseTimes, ctx);
	                if (!isString(ret)) {
	                  ret = formatValue(ctx, ret, recurseTimes);
	                }
	                return ret;
	              }
	              var primitive = formatPrimitive(ctx, value);
	              if (primitive) {
	                return primitive;
	              }
	              var keys = Object.keys(value);
	              var visibleKeys = arrayToHash(keys);
	              if (ctx.showHidden) {
	                keys = Object.getOwnPropertyNames(value);
	              }
	              if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) {
	                return formatError(value);
	              }
	              if (keys.length === 0) {
	                if (isFunction(value)) {
	                  var name2 = value.name ? ": " + value.name : "";
	                  return ctx.stylize("[Function" + name2 + "]", "special");
	                }
	                if (isRegExp(value)) {
	                  return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
	                }
	                if (isDate(value)) {
	                  return ctx.stylize(Date.prototype.toString.call(value), "date");
	                }
	                if (isError(value)) {
	                  return formatError(value);
	                }
	              }
	              var base = "", array = false, braces = ["{", "}"];
	              if (isArray(value)) {
	                array = true;
	                braces = ["[", "]"];
	              }
	              if (isFunction(value)) {
	                var n = value.name ? ": " + value.name : "";
	                base = " [Function" + n + "]";
	              }
	              if (isRegExp(value)) {
	                base = " " + RegExp.prototype.toString.call(value);
	              }
	              if (isDate(value)) {
	                base = " " + Date.prototype.toUTCString.call(value);
	              }
	              if (isError(value)) {
	                base = " " + formatError(value);
	              }
	              if (keys.length === 0 && (!array || value.length == 0)) {
	                return braces[0] + base + braces[1];
	              }
	              if (recurseTimes < 0) {
	                if (isRegExp(value)) {
	                  return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
	                } else {
	                  return ctx.stylize("[Object]", "special");
	                }
	              }
	              ctx.seen.push(value);
	              var output;
	              if (array) {
	                output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	              } else {
	                output = keys.map(function(key) {
	                  return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	                });
	              }
	              ctx.seen.pop();
	              return reduceToSingleString(output, base, braces);
	            }
	            function formatPrimitive(ctx, value) {
	              if (isUndefined(value))
	                return ctx.stylize("undefined", "undefined");
	              if (isString(value)) {
	                var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
	                return ctx.stylize(simple, "string");
	              }
	              if (isNumber(value))
	                return ctx.stylize("" + value, "number");
	              if (isBoolean(value))
	                return ctx.stylize("" + value, "boolean");
	              if (isNull(value))
	                return ctx.stylize("null", "null");
	            }
	            function formatError(value) {
	              return "[" + Error.prototype.toString.call(value) + "]";
	            }
	            function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	              var output = [];
	              for (var i = 0, l = value.length; i < l; ++i) {
	                if (hasOwnProperty2(value, String(i))) {
	                  output.push(formatProperty(
	                    ctx,
	                    value,
	                    recurseTimes,
	                    visibleKeys,
	                    String(i),
	                    true
	                  ));
	                } else {
	                  output.push("");
	                }
	              }
	              keys.forEach(function(key) {
	                if (!key.match(/^\d+$/)) {
	                  output.push(formatProperty(
	                    ctx,
	                    value,
	                    recurseTimes,
	                    visibleKeys,
	                    key,
	                    true
	                  ));
	                }
	              });
	              return output;
	            }
	            function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	              var name2, str, desc;
	              desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	              if (desc.get) {
	                if (desc.set) {
	                  str = ctx.stylize("[Getter/Setter]", "special");
	                } else {
	                  str = ctx.stylize("[Getter]", "special");
	                }
	              } else {
	                if (desc.set) {
	                  str = ctx.stylize("[Setter]", "special");
	                }
	              }
	              if (!hasOwnProperty2(visibleKeys, key)) {
	                name2 = "[" + key + "]";
	              }
	              if (!str) {
	                if (ctx.seen.indexOf(desc.value) < 0) {
	                  if (isNull(recurseTimes)) {
	                    str = formatValue(ctx, desc.value, null);
	                  } else {
	                    str = formatValue(ctx, desc.value, recurseTimes - 1);
	                  }
	                  if (str.indexOf("\n") > -1) {
	                    if (array) {
	                      str = str.split("\n").map(function(line) {
	                        return "  " + line;
	                      }).join("\n").slice(2);
	                    } else {
	                      str = "\n" + str.split("\n").map(function(line) {
	                        return "   " + line;
	                      }).join("\n");
	                    }
	                  }
	                } else {
	                  str = ctx.stylize("[Circular]", "special");
	                }
	              }
	              if (isUndefined(name2)) {
	                if (array && key.match(/^\d+$/)) {
	                  return str;
	                }
	                name2 = JSON.stringify("" + key);
	                if (name2.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	                  name2 = name2.slice(1, -1);
	                  name2 = ctx.stylize(name2, "name");
	                } else {
	                  name2 = name2.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
	                  name2 = ctx.stylize(name2, "string");
	                }
	              }
	              return name2 + ": " + str;
	            }
	            function reduceToSingleString(output, base, braces) {
	              var length = output.reduce(function(prev, cur) {
	                if (cur.indexOf("\n") >= 0) ;
	                return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
	              }, 0);
	              if (length > 60) {
	                return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
	              }
	              return braces[0] + base + " " + output.join(", ") + " " + braces[1];
	            }
	            exports2.types = __webpack_require__2(4936);
	            function isArray(ar) {
	              return Array.isArray(ar);
	            }
	            exports2.isArray = isArray;
	            function isBoolean(arg) {
	              return typeof arg === "boolean";
	            }
	            exports2.isBoolean = isBoolean;
	            function isNull(arg) {
	              return arg === null;
	            }
	            exports2.isNull = isNull;
	            function isNullOrUndefined(arg) {
	              return arg == null;
	            }
	            exports2.isNullOrUndefined = isNullOrUndefined;
	            function isNumber(arg) {
	              return typeof arg === "number";
	            }
	            exports2.isNumber = isNumber;
	            function isString(arg) {
	              return typeof arg === "string";
	            }
	            exports2.isString = isString;
	            function isSymbol(arg) {
	              return typeof arg === "symbol";
	            }
	            exports2.isSymbol = isSymbol;
	            function isUndefined(arg) {
	              return arg === undefined;
	            }
	            exports2.isUndefined = isUndefined;
	            function isRegExp(re) {
	              return isObject(re) && objectToString(re) === "[object RegExp]";
	            }
	            exports2.isRegExp = isRegExp;
	            exports2.types.isRegExp = isRegExp;
	            function isObject(arg) {
	              return typeof arg === "object" && arg !== null;
	            }
	            exports2.isObject = isObject;
	            function isDate(d) {
	              return isObject(d) && objectToString(d) === "[object Date]";
	            }
	            exports2.isDate = isDate;
	            exports2.types.isDate = isDate;
	            function isError(e) {
	              return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
	            }
	            exports2.isError = isError;
	            exports2.types.isNativeError = isError;
	            function isFunction(arg) {
	              return typeof arg === "function";
	            }
	            exports2.isFunction = isFunction;
	            function isPrimitive(arg) {
	              return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
	              typeof arg === "undefined";
	            }
	            exports2.isPrimitive = isPrimitive;
	            exports2.isBuffer = __webpack_require__2(45920);
	            function objectToString(o) {
	              return Object.prototype.toString.call(o);
	            }
	            function pad(n) {
	              return n < 10 ? "0" + n.toString(10) : n.toString(10);
	            }
	            var months = [
	              "Jan",
	              "Feb",
	              "Mar",
	              "Apr",
	              "May",
	              "Jun",
	              "Jul",
	              "Aug",
	              "Sep",
	              "Oct",
	              "Nov",
	              "Dec"
	            ];
	            function timestamp() {
	              var d = /* @__PURE__ */ new Date();
	              var time = [
	                pad(d.getHours()),
	                pad(d.getMinutes()),
	                pad(d.getSeconds())
	              ].join(":");
	              return [d.getDate(), months[d.getMonth()], time].join(" ");
	            }
	            exports2.log = function() {
	              console.log("%s - %s", timestamp(), exports2.format.apply(exports2, arguments));
	            };
	            exports2.inherits = __webpack_require__2(42018);
	            exports2._extend = function(origin, add) {
	              if (!add || !isObject(add)) return origin;
	              var keys = Object.keys(add);
	              var i = keys.length;
	              while (i--) {
	                origin[keys[i]] = add[keys[i]];
	              }
	              return origin;
	            };
	            function hasOwnProperty2(obj, prop) {
	              return Object.prototype.hasOwnProperty.call(obj, prop);
	            }
	            var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
	            exports2.promisify = function promisify(original) {
	              if (typeof original !== "function")
	                throw new TypeError('The "original" argument must be of type Function');
	              if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
	                var fn = original[kCustomPromisifiedSymbol];
	                if (typeof fn !== "function") {
	                  throw new TypeError('The "util.promisify.custom" argument must be of type Function');
	                }
	                Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	                  value: fn,
	                  enumerable: false,
	                  writable: false,
	                  configurable: true
	                });
	                return fn;
	              }
	              function fn() {
	                var promiseResolve, promiseReject;
	                var promise = new Promise(function(resolve, reject) {
	                  promiseResolve = resolve;
	                  promiseReject = reject;
	                });
	                var args = [];
	                for (var i = 0; i < arguments.length; i++) {
	                  args.push(arguments[i]);
	                }
	                args.push(function(err, value) {
	                  if (err) {
	                    promiseReject(err);
	                  } else {
	                    promiseResolve(value);
	                  }
	                });
	                try {
	                  original.apply(this, args);
	                } catch (err) {
	                  promiseReject(err);
	                }
	                return promise;
	              }
	              Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
	              if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	                value: fn,
	                enumerable: false,
	                writable: false,
	                configurable: true
	              });
	              return Object.defineProperties(
	                fn,
	                getOwnPropertyDescriptors(original)
	              );
	            };
	            exports2.promisify.custom = kCustomPromisifiedSymbol;
	            function callbackifyOnRejected(reason, cb) {
	              if (!reason) {
	                var newReason = new Error("Promise was rejected with a falsy value");
	                newReason.reason = reason;
	                reason = newReason;
	              }
	              return cb(reason);
	            }
	            function callbackify(original) {
	              if (typeof original !== "function") {
	                throw new TypeError('The "original" argument must be of type Function');
	              }
	              function callbackified() {
	                var args = [];
	                for (var i = 0; i < arguments.length; i++) {
	                  args.push(arguments[i]);
	                }
	                var maybeCb = args.pop();
	                if (typeof maybeCb !== "function") {
	                  throw new TypeError("The last argument must be of type Function");
	                }
	                var self2 = this;
	                var cb = function() {
	                  return maybeCb.apply(self2, arguments);
	                };
	                original.apply(this, args).then(
	                  function(ret) {
	                    process.nextTick(cb.bind(null, null, ret));
	                  },
	                  function(rej) {
	                    process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
	                  }
	                );
	              }
	              Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
	              Object.defineProperties(
	                callbackified,
	                getOwnPropertyDescriptors(original)
	              );
	              return callbackified;
	            }
	            exports2.callbackify = callbackify;
	          }
	        ),
	        /***/
	        40372: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var getContext = __webpack_require__2(86249);
	            module2.exports = function getWebGLContext(opt) {
	              return getContext("webgl", opt);
	            };
	          }
	        ),
	        /***/
	        21099: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var forEach = __webpack_require__2(31353);
	            var availableTypedArrays = __webpack_require__2(72077);
	            var callBound = __webpack_require__2(6614);
	            var gOPD = __webpack_require__2(40383);
	            var $toString = callBound("Object.prototype.toString");
	            var hasToStringTag = __webpack_require__2(84543)();
	            var g = typeof globalThis === "undefined" ? __webpack_require__2.g : globalThis;
	            var typedArrays = availableTypedArrays();
	            var $slice = callBound("String.prototype.slice");
	            var toStrTags = {};
	            var getPrototypeOf = Object.getPrototypeOf;
	            if (hasToStringTag && gOPD && getPrototypeOf) {
	              forEach(typedArrays, function(typedArray) {
	                if (typeof g[typedArray] === "function") {
	                  var arr = new g[typedArray]();
	                  if (Symbol.toStringTag in arr) {
	                    var proto = getPrototypeOf(arr);
	                    var descriptor = gOPD(proto, Symbol.toStringTag);
	                    if (!descriptor) {
	                      var superProto = getPrototypeOf(proto);
	                      descriptor = gOPD(superProto, Symbol.toStringTag);
	                    }
	                    toStrTags[typedArray] = descriptor.get;
	                  }
	                }
	              });
	            }
	            var tryTypedArrays = function tryAllTypedArrays(value) {
	              var foundName = false;
	              forEach(toStrTags, function(getter, typedArray) {
	                if (!foundName) {
	                  try {
	                    var name2 = getter.call(value);
	                    if (name2 === typedArray) {
	                      foundName = name2;
	                    }
	                  } catch (e) {
	                  }
	                }
	              });
	              return foundName;
	            };
	            var isTypedArray = __webpack_require__2(9187);
	            module2.exports = function whichTypedArray(value) {
	              if (!isTypedArray(value)) {
	                return false;
	              }
	              if (!hasToStringTag || !(Symbol.toStringTag in value)) {
	                return $slice($toString(value), 8, -1);
	              }
	              return tryTypedArrays(value);
	            };
	          }
	        ),
	        /***/
	        3961: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            var gregorianCalendar = main.instance();
	            function ChineseCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            ChineseCalendar.prototype = new main.baseCalendar();
	            assign(ChineseCalendar.prototype, {
	              /** The calendar name.
	                  @memberof ChineseCalendar */
	              name: "Chinese",
	              /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
	                 @memberof GregorianCalendar */
	              jdEpoch: 17214255e-1,
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof ChineseCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  This calendar uses month indices to account for intercalary months. 
	                  @memberof ChineseCalendar */
	              minMonth: 0,
	              /** The first month in the year.
	                  This calendar uses month indices to account for intercalary months. 
	                  @memberof ChineseCalendar */
	              firstMonth: 0,
	              /** The minimum day number.
	                  @memberof ChineseCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof ChineseCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Chinese",
	                  epochs: ["BEC", "EC"],
	                  monthNumbers: function(date, padded) {
	                    if (typeof date === "string") {
	                      var match = date.match(MONTH_NUMBER_REGEXP);
	                      return match ? match[0] : "";
	                    }
	                    var year = this._validateYear(date);
	                    var monthIndex = date.month();
	                    var month = "" + this.toChineseMonth(year, monthIndex);
	                    if (padded && month.length < 2) {
	                      month = "0" + month;
	                    }
	                    if (this.isIntercalaryMonth(year, monthIndex)) {
	                      month += "i";
	                    }
	                    return month;
	                  },
	                  monthNames: function(date) {
	                    if (typeof date === "string") {
	                      var match = date.match(MONTH_NAME_REGEXP);
	                      return match ? match[0] : "";
	                    }
	                    var year = this._validateYear(date);
	                    var monthIndex = date.month();
	                    var month = this.toChineseMonth(year, monthIndex);
	                    var monthName = [
	                      "一月",
	                      "二月",
	                      "三月",
	                      "四月",
	                      "五月",
	                      "六月",
	                      "七月",
	                      "八月",
	                      "九月",
	                      "十月",
	                      "十一月",
	                      "十二月"
	                    ][month - 1];
	                    if (this.isIntercalaryMonth(year, monthIndex)) {
	                      monthName = "闰" + monthName;
	                    }
	                    return monthName;
	                  },
	                  monthNamesShort: function(date) {
	                    if (typeof date === "string") {
	                      var match = date.match(MONTH_SHORT_NAME_REGEXP);
	                      return match ? match[0] : "";
	                    }
	                    var year = this._validateYear(date);
	                    var monthIndex = date.month();
	                    var month = this.toChineseMonth(year, monthIndex);
	                    var monthName = [
	                      "一",
	                      "二",
	                      "三",
	                      "四",
	                      "五",
	                      "六",
	                      "七",
	                      "八",
	                      "九",
	                      "十",
	                      "十一",
	                      "十二"
	                    ][month - 1];
	                    if (this.isIntercalaryMonth(year, monthIndex)) {
	                      monthName = "闰" + monthName;
	                    }
	                    return monthName;
	                  },
	                  parseMonth: function(year, monthString) {
	                    year = this._validateYear(year);
	                    var month = parseInt(monthString);
	                    var isIntercalary;
	                    if (!isNaN(month)) {
	                      var i = monthString[monthString.length - 1];
	                      isIntercalary = i === "i" || i === "I";
	                    } else {
	                      if (monthString[0] === "闰") {
	                        isIntercalary = true;
	                        monthString = monthString.substring(1);
	                      }
	                      if (monthString[monthString.length - 1] === "月") {
	                        monthString = monthString.substring(0, monthString.length - 1);
	                      }
	                      month = 1 + [
	                        "一",
	                        "二",
	                        "三",
	                        "四",
	                        "五",
	                        "六",
	                        "七",
	                        "八",
	                        "九",
	                        "十",
	                        "十一",
	                        "十二"
	                      ].indexOf(monthString);
	                    }
	                    var monthIndex = this.toMonthIndex(year, month, isIntercalary);
	                    return monthIndex;
	                  },
	                  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	                  digits: null,
	                  dateFormat: "yyyy/mm/dd",
	                  firstDay: 1,
	                  isRTL: false
	                }
	              },
	              /** Check that a candidate date is from the same calendar and is valid.
	                  @memberof BaseCalendar
	                  @private
	                  @param year {CDate|number} The date or the year to validate.
	                  @param error {string} Error message if invalid.
	                  @return {number} The year.
	                  @throws Error if year out of range. */
	              _validateYear: function(year, error) {
	                if (year.year) {
	                  year = year.year();
	                }
	                if (typeof year !== "number" || year < 1888 || year > 2111) {
	                  throw error.replace(/\{0\}/, this.local.name);
	                }
	                return year;
	              },
	              /** Retrieve the month index (i.e. accounting for intercalary months).
	                  @memberof ChineseCalendar
	                  @param year {number} The year.
	                  @param month {number} The month (1 for first month).
	                  @param [isIntercalary=false] {boolean} If month is intercalary.
	                  @return {number} The month index (0 for first month).
	                  @throws Error if an invalid month/year or a different calendar used. */
	              toMonthIndex: function(year, month, isIntercalary) {
	                var intercalaryMonth = this.intercalaryMonth(year);
	                var invalidIntercalaryMonth = isIntercalary && month !== intercalaryMonth;
	                if (invalidIntercalaryMonth || month < 1 || month > 12) {
	                  throw main.local.invalidMonth.replace(/\{0\}/, this.local.name);
	                }
	                var monthIndex;
	                if (!intercalaryMonth) {
	                  monthIndex = month - 1;
	                } else if (!isIntercalary && month <= intercalaryMonth) {
	                  monthIndex = month - 1;
	                } else {
	                  monthIndex = month;
	                }
	                return monthIndex;
	              },
	              /** Retrieve the month (i.e. accounting for intercalary months).
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date or the year to examine.
	                  @param monthIndex {number} The month index (0 for first month).
	                  @return {number} The month (1 for first month).
	                  @throws Error if an invalid month/year or a different calendar used. */
	              toChineseMonth: function(year, monthIndex) {
	                if (year.year) {
	                  year = year.year();
	                  monthIndex = year.month();
	                }
	                var intercalaryMonth = this.intercalaryMonth(year);
	                var maxMonthIndex = intercalaryMonth ? 12 : 11;
	                if (monthIndex < 0 || monthIndex > maxMonthIndex) {
	                  throw main.local.invalidMonth.replace(/\{0\}/, this.local.name);
	                }
	                var month;
	                if (!intercalaryMonth) {
	                  month = monthIndex + 1;
	                } else if (monthIndex < intercalaryMonth) {
	                  month = monthIndex + 1;
	                } else {
	                  month = monthIndex;
	                }
	                return month;
	              },
	              /** Determine the intercalary month of a year (if any).
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The intercalary month number, or 0 if none.
	                  @throws Error if an invalid year or a different calendar used. */
	              intercalaryMonth: function(year) {
	                year = this._validateYear(year);
	                var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
	                var intercalaryMonth = monthDaysTable >> 13;
	                return intercalaryMonth;
	              },
	              /** Determine whether this date is an intercalary month.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [monthIndex] {number} The month index to examine.
	                  @return {boolean} <code>true</code> if this is an intercalary month, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              isIntercalaryMonth: function(year, monthIndex) {
	                if (year.year) {
	                  year = year.year();
	                  monthIndex = year.month();
	                }
	                var intercalaryMonth = this.intercalaryMonth(year);
	                return !!intercalaryMonth && intercalaryMonth === monthIndex;
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                return this.intercalaryMonth(year) !== 0;
	              },
	              /** Determine the week of the year for a date - ISO 8601.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [monthIndex] {number} The month index to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, monthIndex, day) {
	                var validatedYear = this._validateYear(year, main.local.invalidyear);
	                var packedDate = CHINESE_NEW_YEAR[validatedYear - CHINESE_NEW_YEAR[0]];
	                var y = packedDate >> 9 & 4095;
	                var m = packedDate >> 5 & 15;
	                var d = packedDate & 31;
	                var firstThursday;
	                firstThursday = gregorianCalendar.newDate(y, m, d);
	                firstThursday.add(4 - (firstThursday.dayOfWeek() || 7), "d");
	                var offset = this.toJD(year, monthIndex, day) - firstThursday.toJD();
	                return 1 + Math.floor(offset / 7);
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                return this.leapYear(year) ? 13 : 12;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [monthIndex] {number} The month index.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, monthIndex) {
	                if (year.year) {
	                  monthIndex = year.month();
	                  year = year.year();
	                }
	                year = this._validateYear(year);
	                var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
	                var intercalaryMonth = monthDaysTable >> 13;
	                var maxMonthIndex = intercalaryMonth ? 12 : 11;
	                if (monthIndex > maxMonthIndex) {
	                  throw main.local.invalidMonth.replace(/\{0\}/, this.local.name);
	                }
	                var daysInMonth = monthDaysTable & 1 << 12 - monthIndex ? 30 : 29;
	                return daysInMonth;
	              },
	              /** Determine whether this date is a week day.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [monthIndex] {number} The month index to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, monthIndex, day) {
	                return (this.dayOfWeek(year, monthIndex, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof ChineseCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [monthIndex] {number} The month index to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, monthIndex, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = this._validateYear(date.year());
	                monthIndex = date.month();
	                day = date.day();
	                var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
	                var month = this.toChineseMonth(year, monthIndex);
	                var solar = toSolar(year, month, day, isIntercalary);
	                return gregorianCalendar.toJD(solar.year, solar.month, solar.day);
	              },
	              /** Create a new date from a Julian date.
	                  @memberof ChineseCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var date = gregorianCalendar.fromJD(jd);
	                var lunar = toLunar(date.year(), date.month(), date.day());
	                var monthIndex = this.toMonthIndex(
	                  lunar.year,
	                  lunar.month,
	                  lunar.isIntercalary
	                );
	                return this.newDate(lunar.year, monthIndex, lunar.day);
	              },
	              /** Create a new date from a string.
	                  @memberof ChineseCalendar
	                  @param dateString {string} String representing a Chinese date
	                  @return {CDate} The new date.
	                  @throws Error if an invalid date. */
	              fromString: function(dateString) {
	                var match = dateString.match(DATE_REGEXP);
	                var year = this._validateYear(+match[1]);
	                var month = +match[2];
	                var isIntercalary = !!match[3];
	                var monthIndex = this.toMonthIndex(year, month, isIntercalary);
	                var day = +match[4];
	                return this.newDate(year, monthIndex, day);
	              },
	              /** Add period(s) to a date.
	                  Cater for no year zero.
	                  @memberof ChineseCalendar
	                  @param date {CDate} The starting date.
	                  @param offset {number} The number of periods to adjust by.
	                  @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	                  @return {CDate} The updated date.
	                  @throws Error if a different calendar used. */
	              add: function(date, offset, period) {
	                var year = date.year();
	                var monthIndex = date.month();
	                var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
	                var month = this.toChineseMonth(year, monthIndex);
	                var cdate = Object.getPrototypeOf(ChineseCalendar.prototype).add.call(this, date, offset, period);
	                if (period === "y") {
	                  var resultYear = cdate.year();
	                  var resultMonthIndex = cdate.month();
	                  var resultCanBeIntercalaryMonth = this.isIntercalaryMonth(resultYear, month);
	                  var correctedMonthIndex = isIntercalary && resultCanBeIntercalaryMonth ? this.toMonthIndex(resultYear, month, true) : this.toMonthIndex(resultYear, month, false);
	                  if (correctedMonthIndex !== resultMonthIndex) {
	                    cdate.month(correctedMonthIndex);
	                  }
	                }
	                return cdate;
	              }
	            });
	            var DATE_REGEXP = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m;
	            var MONTH_NUMBER_REGEXP = /^\d?\d[iI]?/m;
	            var MONTH_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?月/m;
	            var MONTH_SHORT_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?/m;
	            main.calendars.chinese = ChineseCalendar;
	            var LUNAR_MONTH_DAYS = [
	              1887,
	              5780,
	              5802,
	              19157,
	              2742,
	              50359,
	              1198,
	              2646,
	              46378,
	              7466,
	              3412,
	              30122,
	              5482,
	              67949,
	              2396,
	              5294,
	              43597,
	              6732,
	              6954,
	              36181,
	              2772,
	              4954,
	              18781,
	              2396,
	              54427,
	              5274,
	              6730,
	              47781,
	              5800,
	              6868,
	              21210,
	              4790,
	              59703,
	              2350,
	              5270,
	              46667,
	              3402,
	              3496,
	              38325,
	              1388,
	              4782,
	              18735,
	              2350,
	              52374,
	              6804,
	              7498,
	              44457,
	              2906,
	              1388,
	              29294,
	              4700,
	              63789,
	              6442,
	              6804,
	              56138,
	              5802,
	              2772,
	              38235,
	              1210,
	              4698,
	              22827,
	              5418,
	              63125,
	              3476,
	              5802,
	              43701,
	              2484,
	              5302,
	              27223,
	              2646,
	              70954,
	              7466,
	              3412,
	              54698,
	              5482,
	              2412,
	              38062,
	              5294,
	              2636,
	              32038,
	              6954,
	              60245,
	              2772,
	              4826,
	              43357,
	              2394,
	              5274,
	              39501,
	              6730,
	              72357,
	              5800,
	              5844,
	              53978,
	              4790,
	              2358,
	              38039,
	              5270,
	              87627,
	              3402,
	              3496,
	              54708,
	              5484,
	              4782,
	              43311,
	              2350,
	              3222,
	              27978,
	              7498,
	              68965,
	              2904,
	              5484,
	              45677,
	              4700,
	              6444,
	              39573,
	              6804,
	              6986,
	              19285,
	              2772,
	              62811,
	              1210,
	              4698,
	              47403,
	              5418,
	              5780,
	              38570,
	              5546,
	              76469,
	              2420,
	              5302,
	              51799,
	              2646,
	              5414,
	              36501,
	              3412,
	              5546,
	              18869,
	              2412,
	              54446,
	              5276,
	              6732,
	              48422,
	              6822,
	              2900,
	              28010,
	              4826,
	              92509,
	              2394,
	              5274,
	              55883,
	              6730,
	              6820,
	              47956,
	              5812,
	              2778,
	              18779,
	              2358,
	              62615,
	              5270,
	              5450,
	              46757,
	              3492,
	              5556,
	              27318,
	              4718,
	              67887,
	              2350,
	              3222,
	              52554,
	              7498,
	              3428,
	              38252,
	              5468,
	              4700,
	              31022,
	              6444,
	              64149,
	              6804,
	              6986,
	              43861,
	              2772,
	              5338,
	              35421,
	              2650,
	              70955,
	              5418,
	              5780,
	              54954,
	              5546,
	              2740,
	              38074,
	              5302,
	              2646,
	              29991,
	              3366,
	              61011,
	              3412,
	              5546,
	              43445,
	              2412,
	              5294,
	              35406,
	              6732,
	              72998,
	              6820,
	              6996,
	              52586,
	              2778,
	              2396,
	              38045,
	              5274,
	              6698,
	              23333,
	              6820,
	              64338,
	              5812,
	              2746,
	              43355,
	              2358,
	              5270,
	              39499,
	              5450,
	              79525,
	              3492,
	              5548
	            ];
	            var CHINESE_NEW_YEAR = [
	              1887,
	              966732,
	              967231,
	              967733,
	              968265,
	              968766,
	              969297,
	              969798,
	              970298,
	              970829,
	              971330,
	              971830,
	              972362,
	              972863,
	              973395,
	              973896,
	              974397,
	              974928,
	              975428,
	              975929,
	              976461,
	              976962,
	              977462,
	              977994,
	              978494,
	              979026,
	              979526,
	              980026,
	              980558,
	              981059,
	              981559,
	              982091,
	              982593,
	              983124,
	              983624,
	              984124,
	              984656,
	              985157,
	              985656,
	              986189,
	              986690,
	              987191,
	              987722,
	              988222,
	              988753,
	              989254,
	              989754,
	              990286,
	              990788,
	              991288,
	              991819,
	              992319,
	              992851,
	              993352,
	              993851,
	              994383,
	              994885,
	              995385,
	              995917,
	              996418,
	              996918,
	              997450,
	              997949,
	              998481,
	              998982,
	              999483,
	              1000014,
	              1000515,
	              1001016,
	              1001548,
	              1002047,
	              1002578,
	              1003080,
	              1003580,
	              1004111,
	              1004613,
	              1005113,
	              1005645,
	              1006146,
	              1006645,
	              1007177,
	              1007678,
	              1008209,
	              1008710,
	              1009211,
	              1009743,
	              1010243,
	              1010743,
	              1011275,
	              1011775,
	              1012306,
	              1012807,
	              1013308,
	              1013840,
	              1014341,
	              1014841,
	              1015373,
	              1015874,
	              1016404,
	              1016905,
	              1017405,
	              1017937,
	              1018438,
	              1018939,
	              1019471,
	              1019972,
	              1020471,
	              1021002,
	              1021503,
	              1022035,
	              1022535,
	              1023036,
	              1023568,
	              1024069,
	              1024568,
	              1025100,
	              1025601,
	              1026102,
	              1026633,
	              1027133,
	              1027666,
	              1028167,
	              1028666,
	              1029198,
	              1029699,
	              1030199,
	              1030730,
	              1031231,
	              1031763,
	              1032264,
	              1032764,
	              1033296,
	              1033797,
	              1034297,
	              1034828,
	              1035329,
	              1035830,
	              1036362,
	              1036861,
	              1037393,
	              1037894,
	              1038394,
	              1038925,
	              1039427,
	              1039927,
	              1040459,
	              1040959,
	              1041491,
	              1041992,
	              1042492,
	              1043023,
	              1043524,
	              1044024,
	              1044556,
	              1045057,
	              1045558,
	              1046090,
	              1046590,
	              1047121,
	              1047622,
	              1048122,
	              1048654,
	              1049154,
	              1049655,
	              1050187,
	              1050689,
	              1051219,
	              1051720,
	              1052220,
	              1052751,
	              1053252,
	              1053752,
	              1054284,
	              1054786,
	              1055285,
	              1055817,
	              1056317,
	              1056849,
	              1057349,
	              1057850,
	              1058382,
	              1058883,
	              1059383,
	              1059915,
	              1060415,
	              1060947,
	              1061447,
	              1061947,
	              1062479,
	              1062981,
	              1063480,
	              1064012,
	              1064514,
	              1065014,
	              1065545,
	              1066045,
	              1066577,
	              1067078,
	              1067578,
	              1068110,
	              1068611,
	              1069112,
	              1069642,
	              1070142,
	              1070674,
	              1071175,
	              1071675,
	              1072207,
	              1072709,
	              1073209,
	              1073740,
	              1074241,
	              1074741,
	              1075273,
	              1075773,
	              1076305,
	              1076807,
	              1077308,
	              1077839,
	              1078340,
	              1078840,
	              1079372,
	              1079871,
	              1080403,
	              1080904
	            ];
	            function toLunar(yearOrDate, monthOrResult, day, result) {
	              var solarDate;
	              var lunarDate;
	              if (typeof yearOrDate === "object") {
	                solarDate = yearOrDate;
	                lunarDate = monthOrResult || {};
	              } else {
	                var isValidYear = typeof yearOrDate === "number" && yearOrDate >= 1888 && yearOrDate <= 2111;
	                if (!isValidYear)
	                  throw new Error("Solar year outside range 1888-2111");
	                var isValidMonth = typeof monthOrResult === "number" && monthOrResult >= 1 && monthOrResult <= 12;
	                if (!isValidMonth)
	                  throw new Error("Solar month outside range 1 - 12");
	                var isValidDay = typeof day === "number" && day >= 1 && day <= 31;
	                if (!isValidDay)
	                  throw new Error("Solar day outside range 1 - 31");
	                solarDate = {
	                  year: yearOrDate,
	                  month: monthOrResult,
	                  day
	                };
	                lunarDate = {};
	              }
	              var chineseNewYearPackedDate = CHINESE_NEW_YEAR[solarDate.year - CHINESE_NEW_YEAR[0]];
	              var packedDate = solarDate.year << 9 | solarDate.month << 5 | solarDate.day;
	              lunarDate.year = packedDate >= chineseNewYearPackedDate ? solarDate.year : solarDate.year - 1;
	              chineseNewYearPackedDate = CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];
	              var y = chineseNewYearPackedDate >> 9 & 4095;
	              var m = chineseNewYearPackedDate >> 5 & 15;
	              var d = chineseNewYearPackedDate & 31;
	              var daysFromNewYear;
	              var chineseNewYearJSDate = new Date(y, m - 1, d);
	              var jsDate = new Date(solarDate.year, solarDate.month - 1, solarDate.day);
	              daysFromNewYear = Math.round(
	                (jsDate - chineseNewYearJSDate) / (24 * 3600 * 1e3)
	              );
	              var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
	              var i;
	              for (i = 0; i < 13; i++) {
	                var daysInMonth = monthDaysTable & 1 << 12 - i ? 30 : 29;
	                if (daysFromNewYear < daysInMonth) {
	                  break;
	                }
	                daysFromNewYear -= daysInMonth;
	              }
	              var intercalaryMonth = monthDaysTable >> 13;
	              if (!intercalaryMonth || i < intercalaryMonth) {
	                lunarDate.isIntercalary = false;
	                lunarDate.month = 1 + i;
	              } else if (i === intercalaryMonth) {
	                lunarDate.isIntercalary = true;
	                lunarDate.month = i;
	              } else {
	                lunarDate.isIntercalary = false;
	                lunarDate.month = i;
	              }
	              lunarDate.day = 1 + daysFromNewYear;
	              return lunarDate;
	            }
	            function toSolar(yearOrDate, monthOrResult, day, isIntercalaryOrResult, result) {
	              var solarDate;
	              var lunarDate;
	              if (typeof yearOrDate === "object") {
	                lunarDate = yearOrDate;
	                solarDate = monthOrResult || {};
	              } else {
	                var isValidYear = typeof yearOrDate === "number" && yearOrDate >= 1888 && yearOrDate <= 2111;
	                if (!isValidYear)
	                  throw new Error("Lunar year outside range 1888-2111");
	                var isValidMonth = typeof monthOrResult === "number" && monthOrResult >= 1 && monthOrResult <= 12;
	                if (!isValidMonth)
	                  throw new Error("Lunar month outside range 1 - 12");
	                var isValidDay = typeof day === "number" && day >= 1 && day <= 30;
	                if (!isValidDay)
	                  throw new Error("Lunar day outside range 1 - 30");
	                var isIntercalary;
	                if (typeof isIntercalaryOrResult === "object") {
	                  isIntercalary = false;
	                  solarDate = isIntercalaryOrResult;
	                } else {
	                  isIntercalary = !!isIntercalaryOrResult;
	                  solarDate = {};
	                }
	                lunarDate = {
	                  year: yearOrDate,
	                  month: monthOrResult,
	                  day,
	                  isIntercalary
	                };
	              }
	              var daysFromNewYear;
	              daysFromNewYear = lunarDate.day - 1;
	              var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
	              var intercalaryMonth = monthDaysTable >> 13;
	              var monthsFromNewYear;
	              if (!intercalaryMonth) {
	                monthsFromNewYear = lunarDate.month - 1;
	              } else if (lunarDate.month > intercalaryMonth) {
	                monthsFromNewYear = lunarDate.month;
	              } else if (lunarDate.isIntercalary) {
	                monthsFromNewYear = lunarDate.month;
	              } else {
	                monthsFromNewYear = lunarDate.month - 1;
	              }
	              for (var i = 0; i < monthsFromNewYear; i++) {
	                var daysInMonth = monthDaysTable & 1 << 12 - i ? 30 : 29;
	                daysFromNewYear += daysInMonth;
	              }
	              var packedDate = CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];
	              var y = packedDate >> 9 & 4095;
	              var m = packedDate >> 5 & 15;
	              var d = packedDate & 31;
	              var jsDate = new Date(y, m - 1, d + daysFromNewYear);
	              solarDate.year = jsDate.getFullYear();
	              solarDate.month = 1 + jsDate.getMonth();
	              solarDate.day = jsDate.getDate();
	              return solarDate;
	            }
	          }
	        ),
	        /***/
	        38751: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function CopticCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            CopticCalendar.prototype = new main.baseCalendar();
	            assign(CopticCalendar.prototype, {
	              /** The calendar name.
	                  @memberof CopticCalendar */
	              name: "Coptic",
	              /** Julian date of start of Coptic epoch: 29 August 284 CE (Gregorian).
	                  @memberof CopticCalendar */
	              jdEpoch: 18250295e-1,
	              /** Days per month in a common year.
	                  @memberof CopticCalendar */
	              daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof CopticCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof CopticCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof CopticCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof CopticCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof CopticCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Coptic",
	                  epochs: ["BAM", "AM"],
	                  monthNames: [
	                    "Thout",
	                    "Paopi",
	                    "Hathor",
	                    "Koiak",
	                    "Tobi",
	                    "Meshir",
	                    "Paremhat",
	                    "Paremoude",
	                    "Pashons",
	                    "Paoni",
	                    "Epip",
	                    "Mesori",
	                    "Pi Kogi Enavot"
	                  ],
	                  monthNamesShort: [
	                    "Tho",
	                    "Pao",
	                    "Hath",
	                    "Koi",
	                    "Tob",
	                    "Mesh",
	                    "Pat",
	                    "Pad",
	                    "Pash",
	                    "Pao",
	                    "Epi",
	                    "Meso",
	                    "PiK"
	                  ],
	                  dayNames: ["Tkyriaka", "Pesnau", "Pshoment", "Peftoou", "Ptiou", "Psoou", "Psabbaton"],
	                  dayNamesShort: ["Tky", "Pes", "Psh", "Pef", "Pti", "Pso", "Psa"],
	                  dayNamesMin: ["Tk", "Pes", "Psh", "Pef", "Pt", "Pso", "Psa"],
	                  digits: null,
	                  dateFormat: "dd/mm/yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof CopticCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = date.year() + (date.year() < 0 ? 1 : 0);
	                return year % 4 === 3 || year % 4 === -1;
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof CopticCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  main.local.invalidYear || main.regionalOptions[""].invalidYear
	                );
	                return 13;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof CopticCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number) the month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof CopticCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof CopticCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param month {number} The month to examine.
	                  @param day {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof CopticCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number) the month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year();
	                if (year < 0) {
	                  year++;
	                }
	                return date.day() + (date.month() - 1) * 30 + (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof CopticCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var c = Math.floor(jd) + 0.5 - this.jdEpoch;
	                var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
	                if (year <= 0) {
	                  year--;
	                }
	                c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
	                var month = Math.floor(c / 30) + 1;
	                var day = c - (month - 1) * 30 + 1;
	                return this.newDate(year, month, day);
	              }
	            });
	            main.calendars.coptic = CopticCalendar;
	          }
	        ),
	        /***/
	        86825: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function DiscworldCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            DiscworldCalendar.prototype = new main.baseCalendar();
	            assign(DiscworldCalendar.prototype, {
	              /** The calendar name.
	                  @memberof DiscworldCalendar */
	              name: "Discworld",
	              /** Julian date of start of Discworld epoch: 1 January 0001 CE.
	                  @memberof DiscworldCalendar */
	              jdEpoch: 17214255e-1,
	              /** Days per month in a common year.
	                  @memberof DiscworldCalendar */
	              daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof DiscworldCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof DiscworldCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof DiscworldCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof DiscworldCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof DiscworldCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Discworld",
	                  epochs: ["BUC", "UC"],
	                  monthNames: [
	                    "Ick",
	                    "Offle",
	                    "February",
	                    "March",
	                    "April",
	                    "May",
	                    "June",
	                    "Grune",
	                    "August",
	                    "Spune",
	                    "Sektober",
	                    "Ember",
	                    "December"
	                  ],
	                  monthNamesShort: ["Ick", "Off", "Feb", "Mar", "Apr", "May", "Jun", "Gru", "Aug", "Spu", "Sek", "Emb", "Dec"],
	                  dayNames: ["Sunday", "Octeday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                  dayNamesShort: ["Sun", "Oct", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                  dayNamesMin: ["Su", "Oc", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	                  digits: null,
	                  dateFormat: "yyyy/mm/dd",
	                  firstDay: 2,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return false;
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return 13;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return 400;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 8) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1];
	              },
	              /** Retrieve the number of days in a week.
	                  @memberof DiscworldCalendar
	                  @return {number} The number of days. */
	              daysInWeek: function() {
	                return 8;
	              },
	              /** Retrieve the day of the week for a date.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The day of the week: 0 to number of days - 1.
	                  @throws Error if an invalid date or a different calendar used. */
	              dayOfWeek: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                return (date.day() + 1) % 8;
	              },
	              /** Determine whether this date is a week day.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                var dow = this.dayOfWeek(year, month, day);
	                return dow >= 2 && dow <= 6;
	              },
	              /** Retrieve additional information about a date.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {object} Additional information - contents depends on calendar.
	                  @throws Error if an invalid date or a different calendar used. */
	              extraInfo: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                return { century: centuries[Math.floor((date.year() - 1) / 100) + 1] || "" };
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof DiscworldCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year() + (date.year() < 0 ? 1 : 0);
	                month = date.month();
	                day = date.day();
	                return day + (month > 1 ? 16 : 0) + (month > 2 ? (month - 2) * 32 : 0) + (year - 1) * 400 + this.jdEpoch - 1;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof DiscworldCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                jd = Math.floor(jd + 0.5) - Math.floor(this.jdEpoch) - 1;
	                var year = Math.floor(jd / 400) + 1;
	                jd -= (year - 1) * 400;
	                jd += jd > 15 ? 16 : 0;
	                var month = Math.floor(jd / 32) + 1;
	                var day = jd - (month - 1) * 32 + 1;
	                return this.newDate(year <= 0 ? year - 1 : year, month, day);
	              }
	            });
	            var centuries = {
	              20: "Fruitbat",
	              21: "Anchovy"
	            };
	            main.calendars.discworld = DiscworldCalendar;
	          }
	        ),
	        /***/
	        37715: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function EthiopianCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            EthiopianCalendar.prototype = new main.baseCalendar();
	            assign(EthiopianCalendar.prototype, {
	              /** The calendar name.
	                  @memberof EthiopianCalendar */
	              name: "Ethiopian",
	              /** Julian date of start of Ethiopian epoch: 27 August 8 CE (Gregorian).
	                  @memberof EthiopianCalendar */
	              jdEpoch: 17242205e-1,
	              /** Days per month in a common year.
	                  @memberof EthiopianCalendar */
	              daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof EthiopianCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof EthiopianCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof EthiopianCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof EthiopianCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof EthiopianCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Ethiopian",
	                  epochs: ["BEE", "EE"],
	                  monthNames: [
	                    "Meskerem",
	                    "Tikemet",
	                    "Hidar",
	                    "Tahesas",
	                    "Tir",
	                    "Yekatit",
	                    "Megabit",
	                    "Miazia",
	                    "Genbot",
	                    "Sene",
	                    "Hamle",
	                    "Nehase",
	                    "Pagume"
	                  ],
	                  monthNamesShort: [
	                    "Mes",
	                    "Tik",
	                    "Hid",
	                    "Tah",
	                    "Tir",
	                    "Yek",
	                    "Meg",
	                    "Mia",
	                    "Gen",
	                    "Sen",
	                    "Ham",
	                    "Neh",
	                    "Pag"
	                  ],
	                  dayNames: ["Ehud", "Segno", "Maksegno", "Irob", "Hamus", "Arb", "Kidame"],
	                  dayNamesShort: ["Ehu", "Seg", "Mak", "Iro", "Ham", "Arb", "Kid"],
	                  dayNamesMin: ["Eh", "Se", "Ma", "Ir", "Ha", "Ar", "Ki"],
	                  digits: null,
	                  dateFormat: "dd/mm/yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof EthiopianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = date.year() + (date.year() < 0 ? 1 : 0);
	                return year % 4 === 3 || year % 4 === -1;
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof EthiopianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  main.local.invalidYear || main.regionalOptions[""].invalidYear
	                );
	                return 13;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof EthiopianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof EthiopianCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof EthiopianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof EthiopianCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year();
	                if (year < 0) {
	                  year++;
	                }
	                return date.day() + (date.month() - 1) * 30 + (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof EthiopianCalendar
	                  @param jd {number} the Julian date to convert.
	                  @return {CDate} the equivalent date. */
	              fromJD: function(jd) {
	                var c = Math.floor(jd) + 0.5 - this.jdEpoch;
	                var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
	                if (year <= 0) {
	                  year--;
	                }
	                c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
	                var month = Math.floor(c / 30) + 1;
	                var day = c - (month - 1) * 30 + 1;
	                return this.newDate(year, month, day);
	              }
	            });
	            main.calendars.ethiopian = EthiopianCalendar;
	          }
	        ),
	        /***/
	        99384: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function HebrewCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            HebrewCalendar.prototype = new main.baseCalendar();
	            assign(HebrewCalendar.prototype, {
	              /** The calendar name.
	                  @memberof HebrewCalendar */
	              name: "Hebrew",
	              /** Julian date of start of Hebrew epoch: 7 October 3761 BCE.
	                  @memberof HebrewCalendar */
	              jdEpoch: 347995.5,
	              /** Days per month in a common year.
	                  @memberof HebrewCalendar */
	              daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof HebrewCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof HebrewCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof HebrewCalendar */
	              firstMonth: 7,
	              /** The minimum day number.
	                  @memberof HebrewCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof HebrewCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Hebrew",
	                  epochs: ["BAM", "AM"],
	                  monthNames: [
	                    "Nisan",
	                    "Iyar",
	                    "Sivan",
	                    "Tammuz",
	                    "Av",
	                    "Elul",
	                    "Tishrei",
	                    "Cheshvan",
	                    "Kislev",
	                    "Tevet",
	                    "Shevat",
	                    "Adar",
	                    "Adar II"
	                  ],
	                  monthNamesShort: ["Nis", "Iya", "Siv", "Tam", "Av", "Elu", "Tis", "Che", "Kis", "Tev", "She", "Ada", "Ad2"],
	                  dayNames: ["Yom Rishon", "Yom Sheni", "Yom Shlishi", "Yom Revi'i", "Yom Chamishi", "Yom Shishi", "Yom Shabbat"],
	                  dayNamesShort: ["Ris", "She", "Shl", "Rev", "Cha", "Shi", "Sha"],
	                  dayNamesMin: ["Ri", "She", "Shl", "Re", "Ch", "Shi", "Sha"],
	                  digits: null,
	                  dateFormat: "dd/mm/yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return this._leapYear(date.year());
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof HebrewCalendar
	                  @private
	                  @param year {number} The year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              _leapYear: function(year) {
	                year = year < 0 ? year + 1 : year;
	                return mod(year * 7 + 1, 19) < 7;
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return this._leapYear(year.year ? year.year() : year) ? 13 : 12;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                year = date.year();
	                return this.toJD(year === -1 ? 1 : year + 1, 7, 1) - this.toJD(year, 7, 1);
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                if (year.year) {
	                  month = year.month();
	                  year = year.year();
	                }
	                this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return month === 12 && this.leapYear(year) ? 30 : (
	                  // Adar I
	                  month === 8 && mod(this.daysInYear(year), 10) === 5 ? 30 : (
	                    // Cheshvan in shlemah year
	                    month === 9 && mod(this.daysInYear(year), 10) === 3 ? 29 : (
	                      // Kislev in chaserah year
	                      this.daysPerMonth[month - 1]
	                    )
	                  )
	                );
	              },
	              /** Determine whether this date is a week day.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return this.dayOfWeek(year, month, day) !== 6;
	              },
	              /** Retrieve additional information about a date - year type.
	                  @memberof HebrewCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {object} Additional information - contents depends on calendar.
	                  @throws Error if an invalid date or a different calendar used. */
	              extraInfo: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                return { yearType: (this.leapYear(date) ? "embolismic" : "common") + " " + ["deficient", "regular", "complete"][this.daysInYear(date) % 10 - 3] };
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof HebrewCalendar
	                  @param year {CDate)|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year();
	                month = date.month();
	                day = date.day();
	                var adjYear = year <= 0 ? year + 1 : year;
	                var jd = this.jdEpoch + this._delay1(adjYear) + this._delay2(adjYear) + day + 1;
	                if (month < 7) {
	                  for (var m = 7; m <= this.monthsInYear(year); m++) {
	                    jd += this.daysInMonth(year, m);
	                  }
	                  for (var m = 1; m < month; m++) {
	                    jd += this.daysInMonth(year, m);
	                  }
	                } else {
	                  for (var m = 7; m < month; m++) {
	                    jd += this.daysInMonth(year, m);
	                  }
	                }
	                return jd;
	              },
	              /** Test for delay of start of new year and to avoid
	                  Sunday, Wednesday, or Friday as start of the new year.
	                  @memberof HebrewCalendar
	                  @private
	                  @param year {number} The year to examine.
	                  @return {number} The days to offset by. */
	              _delay1: function(year) {
	                var months = Math.floor((235 * year - 234) / 19);
	                var parts = 12084 + 13753 * months;
	                var day = months * 29 + Math.floor(parts / 25920);
	                if (mod(3 * (day + 1), 7) < 3) {
	                  day++;
	                }
	                return day;
	              },
	              /** Check for delay in start of new year due to length of adjacent years.
	                  @memberof HebrewCalendar
	                  @private
	                  @param year {number} The year to examine.
	                  @return {number} The days to offset by. */
	              _delay2: function(year) {
	                var last = this._delay1(year - 1);
	                var present = this._delay1(year);
	                var next = this._delay1(year + 1);
	                return next - present === 356 ? 2 : present - last === 382 ? 1 : 0;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof HebrewCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                jd = Math.floor(jd) + 0.5;
	                var year = Math.floor((jd - this.jdEpoch) * 98496 / 35975351) - 1;
	                while (jd >= this.toJD(year === -1 ? 1 : year + 1, 7, 1)) {
	                  year++;
	                }
	                var month = jd < this.toJD(year, 1, 1) ? 7 : 1;
	                while (jd > this.toJD(year, month, this.daysInMonth(year, month))) {
	                  month++;
	                }
	                var day = jd - this.toJD(year, month, 1) + 1;
	                return this.newDate(year, month, day);
	              }
	            });
	            function mod(a, b) {
	              return a - b * Math.floor(a / b);
	            }
	            main.calendars.hebrew = HebrewCalendar;
	          }
	        ),
	        /***/
	        43805: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function IslamicCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            IslamicCalendar.prototype = new main.baseCalendar();
	            assign(IslamicCalendar.prototype, {
	              /** The calendar name.
	                  @memberof IslamicCalendar */
	              name: "Islamic",
	              /** Julian date of start of Islamic epoch: 16 July 622 CE.
	                  @memberof IslamicCalendar */
	              jdEpoch: 19484395e-1,
	              /** Days per month in a common year.
	                  @memberof IslamicCalendar */
	              daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof IslamicCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof IslamicCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof IslamicCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof IslamicCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof IslamicCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Islamic",
	                  epochs: ["BH", "AH"],
	                  monthNames: [
	                    "Muharram",
	                    "Safar",
	                    "Rabi' al-awwal",
	                    "Rabi' al-thani",
	                    "Jumada al-awwal",
	                    "Jumada al-thani",
	                    "Rajab",
	                    "Sha'aban",
	                    "Ramadan",
	                    "Shawwal",
	                    "Dhu al-Qi'dah",
	                    "Dhu al-Hijjah"
	                  ],
	                  monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
	                  dayNames: [
	                    "Yawm al-ahad",
	                    "Yawm al-ithnayn",
	                    "Yawm ath-thulaathaa'",
	                    "Yawm al-arbi'aa'",
	                    "Yawm al-khamīs",
	                    "Yawm al-jum'a",
	                    "Yawm as-sabt"
	                  ],
	                  dayNamesShort: ["Aha", "Ith", "Thu", "Arb", "Kha", "Jum", "Sab"],
	                  dayNamesMin: ["Ah", "It", "Th", "Ar", "Kh", "Ju", "Sa"],
	                  digits: null,
	                  dateFormat: "yyyy/mm/dd",
	                  firstDay: 6,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof IslamicCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return (date.year() * 11 + 14) % 30 < 11;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof IslamicCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof IslamicCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                return this.leapYear(year) ? 355 : 354;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof IslamicCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof IslamicCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return this.dayOfWeek(year, month, day) !== 5;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof IslamicCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year();
	                month = date.month();
	                day = date.day();
	                year = year <= 0 ? year + 1 : year;
	                return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + this.jdEpoch - 1;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof IslamicCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                jd = Math.floor(jd) + 0.5;
	                var year = Math.floor((30 * (jd - this.jdEpoch) + 10646) / 10631);
	                year = year <= 0 ? year - 1 : year;
	                var month = Math.min(12, Math.ceil((jd - 29 - this.toJD(year, 1, 1)) / 29.5) + 1);
	                var day = jd - this.toJD(year, month, 1) + 1;
	                return this.newDate(year, month, day);
	              }
	            });
	            main.calendars.islamic = IslamicCalendar;
	          }
	        ),
	        /***/
	        88874: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function JulianCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            JulianCalendar.prototype = new main.baseCalendar();
	            assign(JulianCalendar.prototype, {
	              /** The calendar name.
	                  @memberof JulianCalendar */
	              name: "Julian",
	              /** Julian date of start of Julian epoch: 1 January 0001 AD = 30 December 0001 BCE.
	                  @memberof JulianCalendar */
	              jdEpoch: 17214235e-1,
	              /** Days per month in a common year.
	                  @memberof JulianCalendar */
	              daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof JulianCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof JulianCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof JulianCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof JulianCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof JulianCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Julian",
	                  epochs: ["BC", "AD"],
	                  monthNames: [
	                    "January",
	                    "February",
	                    "March",
	                    "April",
	                    "May",
	                    "June",
	                    "July",
	                    "August",
	                    "September",
	                    "October",
	                    "November",
	                    "December"
	                  ],
	                  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	                  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	                  digits: null,
	                  dateFormat: "mm/dd/yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof JulianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = date.year() < 0 ? date.year() + 1 : date.year();
	                return year % 4 === 0;
	              },
	              /** Determine the week of the year for a date - ISO 8601.
	                  @memberof JulianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(4 - (checkDate.dayOfWeek() || 7), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof JulianCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof JulianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} True if a week day, false if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof JulianCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year();
	                month = date.month();
	                day = date.day();
	                if (year < 0) {
	                  year++;
	                }
	                if (month <= 2) {
	                  year--;
	                  month += 12;
	                }
	                return Math.floor(365.25 * (year + 4716)) + Math.floor(30.6001 * (month + 1)) + day - 1524.5;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof JulianCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var a = Math.floor(jd + 0.5);
	                var b = a + 1524;
	                var c = Math.floor((b - 122.1) / 365.25);
	                var d = Math.floor(365.25 * c);
	                var e = Math.floor((b - d) / 30.6001);
	                var month = e - Math.floor(e < 14 ? 1 : 13);
	                var year = c - Math.floor(month > 2 ? 4716 : 4715);
	                var day = b - d - Math.floor(30.6001 * e);
	                if (year <= 0) {
	                  year--;
	                }
	                return this.newDate(year, month, day);
	              }
	            });
	            main.calendars.julian = JulianCalendar;
	          }
	        ),
	        /***/
	        83290: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function MayanCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            MayanCalendar.prototype = new main.baseCalendar();
	            assign(MayanCalendar.prototype, {
	              /** The calendar name.
	                  @memberof MayanCalendar */
	              name: "Mayan",
	              /** Julian date of start of Mayan epoch: 11 August 3114 BCE.
	                  @memberof MayanCalendar */
	              jdEpoch: 584282.5,
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof MayanCalendar */
	              hasYearZero: true,
	              /** The minimum month number.
	                  @memberof MayanCalendar */
	              minMonth: 0,
	              /** The first month in the year.
	                  @memberof MayanCalendar */
	              firstMonth: 0,
	              /** The minimum day number.
	                  @memberof MayanCalendar */
	              minDay: 0,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof MayanCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left.
	                  @property haabMonths {string[]} The names of the Haab months.
	                  @property tzolkinMonths {string[]} The names of the Tzolkin months. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Mayan",
	                  epochs: ["", ""],
	                  monthNames: [
	                    "0",
	                    "1",
	                    "2",
	                    "3",
	                    "4",
	                    "5",
	                    "6",
	                    "7",
	                    "8",
	                    "9",
	                    "10",
	                    "11",
	                    "12",
	                    "13",
	                    "14",
	                    "15",
	                    "16",
	                    "17"
	                  ],
	                  monthNamesShort: [
	                    "0",
	                    "1",
	                    "2",
	                    "3",
	                    "4",
	                    "5",
	                    "6",
	                    "7",
	                    "8",
	                    "9",
	                    "10",
	                    "11",
	                    "12",
	                    "13",
	                    "14",
	                    "15",
	                    "16",
	                    "17"
	                  ],
	                  dayNames: [
	                    "0",
	                    "1",
	                    "2",
	                    "3",
	                    "4",
	                    "5",
	                    "6",
	                    "7",
	                    "8",
	                    "9",
	                    "10",
	                    "11",
	                    "12",
	                    "13",
	                    "14",
	                    "15",
	                    "16",
	                    "17",
	                    "18",
	                    "19"
	                  ],
	                  dayNamesShort: [
	                    "0",
	                    "1",
	                    "2",
	                    "3",
	                    "4",
	                    "5",
	                    "6",
	                    "7",
	                    "8",
	                    "9",
	                    "10",
	                    "11",
	                    "12",
	                    "13",
	                    "14",
	                    "15",
	                    "16",
	                    "17",
	                    "18",
	                    "19"
	                  ],
	                  dayNamesMin: [
	                    "0",
	                    "1",
	                    "2",
	                    "3",
	                    "4",
	                    "5",
	                    "6",
	                    "7",
	                    "8",
	                    "9",
	                    "10",
	                    "11",
	                    "12",
	                    "13",
	                    "14",
	                    "15",
	                    "16",
	                    "17",
	                    "18",
	                    "19"
	                  ],
	                  digits: null,
	                  dateFormat: "YYYY.m.d",
	                  firstDay: 0,
	                  isRTL: false,
	                  haabMonths: [
	                    "Pop",
	                    "Uo",
	                    "Zip",
	                    "Zotz",
	                    "Tzec",
	                    "Xul",
	                    "Yaxkin",
	                    "Mol",
	                    "Chen",
	                    "Yax",
	                    "Zac",
	                    "Ceh",
	                    "Mac",
	                    "Kankin",
	                    "Muan",
	                    "Pax",
	                    "Kayab",
	                    "Cumku",
	                    "Uayeb"
	                  ],
	                  tzolkinMonths: [
	                    "Imix",
	                    "Ik",
	                    "Akbal",
	                    "Kan",
	                    "Chicchan",
	                    "Cimi",
	                    "Manik",
	                    "Lamat",
	                    "Muluc",
	                    "Oc",
	                    "Chuen",
	                    "Eb",
	                    "Ben",
	                    "Ix",
	                    "Men",
	                    "Cib",
	                    "Caban",
	                    "Etznab",
	                    "Cauac",
	                    "Ahau"
	                  ]
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return false;
	              },
	              /** Format the year, if not a simple sequential number.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to format or the year to format.
	                  @return {string} The formatted year.
	                  @throws Error if an invalid year or a different calendar used. */
	              formatYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                year = date.year();
	                var baktun = Math.floor(year / 400);
	                year = year % 400;
	                year += year < 0 ? 400 : 0;
	                var katun = Math.floor(year / 20);
	                return baktun + "." + katun + "." + year % 20;
	              },
	              /** Convert from the formatted year back to a single number.
	                  @memberof MayanCalendar
	                  @param years {string} The year as n.n.n.
	                  @return {number} The sequential year.
	                  @throws Error if an invalid value is supplied. */
	              forYear: function(years) {
	                years = years.split(".");
	                if (years.length < 3) {
	                  throw "Invalid Mayan year";
	                }
	                var year = 0;
	                for (var i = 0; i < years.length; i++) {
	                  var y = parseInt(years[i], 10);
	                  if (Math.abs(y) > 19 || i > 0 && y < 0) {
	                    throw "Invalid Mayan year";
	                  }
	                  year = year * 20 + y;
	                }
	                return year;
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return 18;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                this._validate(year, month, day, main.local.invalidDate);
	                return 0;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return 360;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return 20;
	              },
	              /** Retrieve the number of days in a week.
	                  @memberof MayanCalendar
	                  @return {number} The number of days. */
	              daysInWeek: function() {
	                return 5;
	              },
	              /** Retrieve the day of the week for a date.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The day of the week: 0 to number of days - 1.
	                  @throws Error if an invalid date or a different calendar used. */
	              dayOfWeek: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                return date.day();
	              },
	              /** Determine whether this date is a week day.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                this._validate(year, month, day, main.local.invalidDate);
	                return true;
	              },
	              /** Retrieve additional information about a date - Haab and Tzolkin equivalents.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {object} Additional information - contents depends on calendar.
	                  @throws Error if an invalid date or a different calendar used. */
	              extraInfo: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                var jd = date.toJD();
	                var haab = this._toHaab(jd);
	                var tzolkin = this._toTzolkin(jd);
	                return {
	                  haabMonthName: this.local.haabMonths[haab[0] - 1],
	                  haabMonth: haab[0],
	                  haabDay: haab[1],
	                  tzolkinDayName: this.local.tzolkinMonths[tzolkin[0] - 1],
	                  tzolkinDay: tzolkin[0],
	                  tzolkinTrecena: tzolkin[1]
	                };
	              },
	              /** Retrieve Haab date from a Julian date.
	                  @memberof MayanCalendar
	                  @private
	                  @param jd  {number} The Julian date.
	                  @return {number[]} Corresponding Haab month and day. */
	              _toHaab: function(jd) {
	                jd -= this.jdEpoch;
	                var day = mod(jd + 8 + (18 - 1) * 20, 365);
	                return [Math.floor(day / 20) + 1, mod(day, 20)];
	              },
	              /** Retrieve Tzolkin date from a Julian date.
	                  @memberof MayanCalendar
	                  @private
	                  @param jd {number} The Julian date.
	                  @return {number[]} Corresponding Tzolkin day and trecena. */
	              _toTzolkin: function(jd) {
	                jd -= this.jdEpoch;
	                return [amod(jd + 20, 20), amod(jd + 4, 13)];
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof MayanCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                return date.day() + date.month() * 20 + date.year() * 360 + this.jdEpoch;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof MayanCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                jd = Math.floor(jd) + 0.5 - this.jdEpoch;
	                var year = Math.floor(jd / 360);
	                jd = jd % 360;
	                jd += jd < 0 ? 360 : 0;
	                var month = Math.floor(jd / 20);
	                var day = jd % 20;
	                return this.newDate(year, month, day);
	              }
	            });
	            function mod(a, b) {
	              return a - b * Math.floor(a / b);
	            }
	            function amod(a, b) {
	              return mod(a - 1, b) + 1;
	            }
	            main.calendars.mayan = MayanCalendar;
	          }
	        ),
	        /***/
	        29108: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function NanakshahiCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            NanakshahiCalendar.prototype = new main.baseCalendar();
	            var gregorian = main.instance("gregorian");
	            assign(NanakshahiCalendar.prototype, {
	              /** The calendar name.
	                  @memberof NanakshahiCalendar */
	              name: "Nanakshahi",
	              /** Julian date of start of Nanakshahi epoch: 14 March 1469 CE.
	                  @memberof NanakshahiCalendar */
	              jdEpoch: 22576735e-1,
	              /** Days per month in a common year.
	                  @memberof NanakshahiCalendar */
	              daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof NanakshahiCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof NanakshahiCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof NanakshahiCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof NanakshahiCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof NanakshahiCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Nanakshahi",
	                  epochs: ["BN", "AN"],
	                  monthNames: [
	                    "Chet",
	                    "Vaisakh",
	                    "Jeth",
	                    "Harh",
	                    "Sawan",
	                    "Bhadon",
	                    "Assu",
	                    "Katak",
	                    "Maghar",
	                    "Poh",
	                    "Magh",
	                    "Phagun"
	                  ],
	                  monthNamesShort: ["Che", "Vai", "Jet", "Har", "Saw", "Bha", "Ass", "Kat", "Mgr", "Poh", "Mgh", "Pha"],
	                  dayNames: ["Somvaar", "Mangalvar", "Budhvaar", "Veervaar", "Shukarvaar", "Sanicharvaar", "Etvaar"],
	                  dayNamesShort: ["Som", "Mangal", "Budh", "Veer", "Shukar", "Sanichar", "Et"],
	                  dayNamesMin: ["So", "Ma", "Bu", "Ve", "Sh", "Sa", "Et"],
	                  digits: null,
	                  dateFormat: "dd-mm-yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof NanakshahiCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  main.local.invalidYear || main.regionalOptions[""].invalidYear
	                );
	                return gregorian.leapYear(date.year() + (date.year() < 1 ? 1 : 0) + 1469);
	              },
	              /** Determine the week of the year for a date.
	                  @memberof NanakshahiCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(1 - (checkDate.dayOfWeek() || 7), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof NanakshahiCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof NanakshahiCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof NanakshahiCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidMonth);
	                var year = date.year();
	                if (year < 0) {
	                  year++;
	                }
	                var doy = date.day();
	                for (var m = 1; m < date.month(); m++) {
	                  doy += this.daysPerMonth[m - 1];
	                }
	                return doy + gregorian.toJD(year + 1468, 3, 13);
	              },
	              /** Create a new date from a Julian date.
	                  @memberof NanakshahiCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                jd = Math.floor(jd + 0.5);
	                var year = Math.floor((jd - (this.jdEpoch - 1)) / 366);
	                while (jd >= this.toJD(year + 1, 1, 1)) {
	                  year++;
	                }
	                var day = jd - Math.floor(this.toJD(year, 1, 1) + 0.5) + 1;
	                var month = 1;
	                while (day > this.daysInMonth(year, month)) {
	                  day -= this.daysInMonth(year, month);
	                  month++;
	                }
	                return this.newDate(year, month, day);
	              }
	            });
	            main.calendars.nanakshahi = NanakshahiCalendar;
	          }
	        ),
	        /***/
	        55422: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function NepaliCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            NepaliCalendar.prototype = new main.baseCalendar();
	            assign(NepaliCalendar.prototype, {
	              /** The calendar name.
	                  @memberof NepaliCalendar */
	              name: "Nepali",
	              /** Julian date of start of Nepali epoch: 14 April 57 BCE.
	                  @memberof NepaliCalendar */
	              jdEpoch: 17007095e-1,
	              /** Days per month in a common year.
	                  @memberof NepaliCalendar */
	              daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof NepaliCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof NepaliCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof NepaliCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof NepaliCalendar */
	              minDay: 1,
	              /** The number of days in the year.
	                  @memberof NepaliCalendar */
	              daysPerYear: 365,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof NepaliCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Nepali",
	                  epochs: ["BBS", "ABS"],
	                  monthNames: [
	                    "Baisakh",
	                    "Jestha",
	                    "Ashadh",
	                    "Shrawan",
	                    "Bhadra",
	                    "Ashwin",
	                    "Kartik",
	                    "Mangsir",
	                    "Paush",
	                    "Mangh",
	                    "Falgun",
	                    "Chaitra"
	                  ],
	                  monthNamesShort: ["Bai", "Je", "As", "Shra", "Bha", "Ash", "Kar", "Mang", "Pau", "Ma", "Fal", "Chai"],
	                  dayNames: ["Aaitabaar", "Sombaar", "Manglbaar", "Budhabaar", "Bihibaar", "Shukrabaar", "Shanibaar"],
	                  dayNamesShort: ["Aaita", "Som", "Mangl", "Budha", "Bihi", "Shukra", "Shani"],
	                  dayNamesMin: ["Aai", "So", "Man", "Bu", "Bi", "Shu", "Sha"],
	                  digits: null,
	                  dateFormat: "dd/mm/yyyy",
	                  firstDay: 1,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof NepaliCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                return this.daysInYear(year) !== this.daysPerYear;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof NepaliCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof NepaliCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                year = date.year();
	                if (typeof this.NEPALI_CALENDAR_DATA[year] === "undefined") {
	                  return this.daysPerYear;
	                }
	                var daysPerYear = 0;
	                for (var month_number = this.minMonth; month_number <= 12; month_number++) {
	                  daysPerYear += this.NEPALI_CALENDAR_DATA[year][month_number];
	                }
	                return daysPerYear;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof NepaliCalendar
	                  @param year {CDate|number| The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                if (year.year) {
	                  month = year.month();
	                  year = year.year();
	                }
	                this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return typeof this.NEPALI_CALENDAR_DATA[year] === "undefined" ? this.daysPerMonth[month - 1] : this.NEPALI_CALENDAR_DATA[year][month];
	              },
	              /** Determine whether this date is a week day.
	                  @memberof NepaliCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return this.dayOfWeek(year, month, day) !== 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof NepaliCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(nepaliYear, nepaliMonth, nepaliDay) {
	                var date = this._validate(nepaliYear, nepaliMonth, nepaliDay, main.local.invalidDate);
	                nepaliYear = date.year();
	                nepaliMonth = date.month();
	                nepaliDay = date.day();
	                var gregorianCalendar = main.instance();
	                var gregorianDayOfYear = 0;
	                var nepaliMonthToCheck = nepaliMonth;
	                var nepaliYearToCheck = nepaliYear;
	                this._createMissingCalendarData(nepaliYear);
	                var gregorianYear = nepaliYear - (nepaliMonthToCheck > 9 || nepaliMonthToCheck === 9 && nepaliDay >= this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0] ? 56 : 57);
	                if (nepaliMonth !== 9) {
	                  gregorianDayOfYear = nepaliDay;
	                  nepaliMonthToCheck--;
	                }
	                while (nepaliMonthToCheck !== 9) {
	                  if (nepaliMonthToCheck <= 0) {
	                    nepaliMonthToCheck = 12;
	                    nepaliYearToCheck--;
	                  }
	                  gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][nepaliMonthToCheck];
	                  nepaliMonthToCheck--;
	                }
	                if (nepaliMonth === 9) {
	                  gregorianDayOfYear += nepaliDay - this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
	                  if (gregorianDayOfYear < 0) {
	                    gregorianDayOfYear += gregorianCalendar.daysInYear(gregorianYear);
	                  }
	                } else {
	                  gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][9] - this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
	                }
	                return gregorianCalendar.newDate(gregorianYear, 1, 1).add(gregorianDayOfYear, "d").toJD();
	              },
	              /** Create a new date from a Julian date.
	                  @memberof NepaliCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var gregorianCalendar = main.instance();
	                var gregorianDate = gregorianCalendar.fromJD(jd);
	                var gregorianYear = gregorianDate.year();
	                var gregorianDayOfYear = gregorianDate.dayOfYear();
	                var nepaliYear = gregorianYear + 56;
	                this._createMissingCalendarData(nepaliYear);
	                var nepaliMonth = 9;
	                var dayOfFirstJanInPaush = this.NEPALI_CALENDAR_DATA[nepaliYear][0];
	                var daysSinceJanFirstToEndOfNepaliMonth = this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] - dayOfFirstJanInPaush + 1;
	                while (gregorianDayOfYear > daysSinceJanFirstToEndOfNepaliMonth) {
	                  nepaliMonth++;
	                  if (nepaliMonth > 12) {
	                    nepaliMonth = 1;
	                    nepaliYear++;
	                  }
	                  daysSinceJanFirstToEndOfNepaliMonth += this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth];
	                }
	                var nepaliDayOfMonth = this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] - (daysSinceJanFirstToEndOfNepaliMonth - gregorianDayOfYear);
	                return this.newDate(nepaliYear, nepaliMonth, nepaliDayOfMonth);
	              },
	              /** Creates missing data in the NEPALI_CALENDAR_DATA table.
	                  This data will not be correct but just give an estimated result. Mostly -/+ 1 day
	                  @private
	                  @param nepaliYear {number} The missing year number. */
	              _createMissingCalendarData: function(nepaliYear) {
	                var tmp_calendar_data = this.daysPerMonth.slice(0);
	                tmp_calendar_data.unshift(17);
	                for (var nepaliYearToCreate = nepaliYear - 1; nepaliYearToCreate < nepaliYear + 2; nepaliYearToCreate++) {
	                  if (typeof this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] === "undefined") {
	                    this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] = tmp_calendar_data;
	                  }
	                }
	              },
	              NEPALI_CALENDAR_DATA: {
	                // These data are from http://www.ashesh.com.np
	                1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
	                1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
	                1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
	                1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
	                1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                // These data are from http://nepalicalendar.rat32.com/index.php
	                1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2e3: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
	                2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
	                2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
	                2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
	                2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
	                2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
	                2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
	                2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
	                2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
	                2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
	                2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
	                2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
	                2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
	                2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
	                2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
	                2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
	                // These data are from http://www.ashesh.com.np/nepali-calendar/
	                2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
	                2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
	                2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
	                2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
	                2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
	                2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
	                2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
	                2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
	                2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
	                2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
	                2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
	                2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
	                2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]
	              }
	            });
	            main.calendars.nepali = NepaliCalendar;
	          }
	        ),
	        /***/
	        94320: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function PersianCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            PersianCalendar.prototype = new main.baseCalendar();
	            assign(PersianCalendar.prototype, {
	              /** The calendar name.
	                  @memberof PersianCalendar */
	              name: "Persian",
	              /** Julian date of start of Persian epoch: 19 March 622 CE.
	                  @memberof PersianCalendar */
	              jdEpoch: 19483205e-1,
	              /** Days per month in a common year.
	                  @memberof PersianCalendar */
	              daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof PersianCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof PersianCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof PersianCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof PersianCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof PersianCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Persian",
	                  epochs: ["BP", "AP"],
	                  monthNames: [
	                    "Farvardin",
	                    "Ordibehesht",
	                    "Khordad",
	                    "Tir",
	                    "Mordad",
	                    "Shahrivar",
	                    "Mehr",
	                    "Aban",
	                    "Azar",
	                    "Day",
	                    "Bahman",
	                    "Esfand"
	                  ],
	                  monthNamesShort: ["Far", "Ord", "Kho", "Tir", "Mor", "Sha", "Meh", "Aba", "Aza", "Day", "Bah", "Esf"],
	                  dayNames: ["Yekshambe", "Doshambe", "Seshambe", "Chæharshambe", "Panjshambe", "Jom'e", "Shambe"],
	                  dayNamesShort: ["Yek", "Do", "Se", "Chæ", "Panj", "Jom", "Sha"],
	                  dayNamesMin: ["Ye", "Do", "Se", "Ch", "Pa", "Jo", "Sh"],
	                  digits: null,
	                  dateFormat: "yyyy/mm/dd",
	                  firstDay: 6,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof PersianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return ((date.year() - (date.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) * 682 % 2816 < 682;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof PersianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-((checkDate.dayOfWeek() + 1) % 7), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof PersianCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof PersianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return this.dayOfWeek(year, month, day) !== 5;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof PersianCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                year = date.year();
	                month = date.month();
	                day = date.day();
	                var epBase = year - (year >= 0 ? 474 : 473);
	                var epYear = 474 + mod(epBase, 2820);
	                return day + (month <= 7 ? (month - 1) * 31 : (month - 1) * 30 + 6) + Math.floor((epYear * 682 - 110) / 2816) + (epYear - 1) * 365 + Math.floor(epBase / 2820) * 1029983 + this.jdEpoch - 1;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof PersianCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                jd = Math.floor(jd) + 0.5;
	                var depoch = jd - this.toJD(475, 1, 1);
	                var cycle = Math.floor(depoch / 1029983);
	                var cyear = mod(depoch, 1029983);
	                var ycycle = 2820;
	                if (cyear !== 1029982) {
	                  var aux1 = Math.floor(cyear / 366);
	                  var aux2 = mod(cyear, 366);
	                  ycycle = Math.floor((2134 * aux1 + 2816 * aux2 + 2815) / 1028522) + aux1 + 1;
	                }
	                var year = ycycle + 2820 * cycle + 474;
	                year = year <= 0 ? year - 1 : year;
	                var yday = jd - this.toJD(year, 1, 1) + 1;
	                var month = yday <= 186 ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30);
	                var day = jd - this.toJD(year, month, 1) + 1;
	                return this.newDate(year, month, day);
	              }
	            });
	            function mod(a, b) {
	              return a - b * Math.floor(a / b);
	            }
	            main.calendars.persian = PersianCalendar;
	            main.calendars.jalali = PersianCalendar;
	          }
	        ),
	        /***/
	        31320: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            var gregorianCalendar = main.instance();
	            function TaiwanCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            TaiwanCalendar.prototype = new main.baseCalendar();
	            assign(TaiwanCalendar.prototype, {
	              /** The calendar name.
	                  @memberof TaiwanCalendar */
	              name: "Taiwan",
	              /** Julian date of start of Taiwan epoch: 1 January 1912 CE (Gregorian).
	                  @memberof TaiwanCalendar */
	              jdEpoch: 24194025e-1,
	              /** Difference in years between Taiwan and Gregorian calendars.
	                  @memberof TaiwanCalendar */
	              yearsOffset: 1911,
	              /** Days per month in a common year.
	                  @memberof TaiwanCalendar */
	              daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof TaiwanCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof TaiwanCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof TaiwanCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof TaiwanCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof TaiwanCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Taiwan",
	                  epochs: ["BROC", "ROC"],
	                  monthNames: [
	                    "January",
	                    "February",
	                    "March",
	                    "April",
	                    "May",
	                    "June",
	                    "July",
	                    "August",
	                    "September",
	                    "October",
	                    "November",
	                    "December"
	                  ],
	                  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	                  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	                  digits: null,
	                  dateFormat: "yyyy/mm/dd",
	                  firstDay: 1,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof TaiwanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = this._t2gYear(date.year());
	                return gregorianCalendar.leapYear(year);
	              },
	              /** Determine the week of the year for a date - ISO 8601.
	                  @memberof TaiwanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = this._t2gYear(date.year());
	                return gregorianCalendar.weekOfYear(year, date.month(), date.day());
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof TaiwanCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof TaiwanCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof TaiwanCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                var year = this._t2gYear(date.year());
	                return gregorianCalendar.toJD(year, date.month(), date.day());
	              },
	              /** Create a new date from a Julian date.
	                  @memberof TaiwanCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var date = gregorianCalendar.fromJD(jd);
	                var year = this._g2tYear(date.year());
	                return this.newDate(year, date.month(), date.day());
	              },
	              /** Convert Taiwanese to Gregorian year.
	                  @memberof TaiwanCalendar
	                  @private
	                  @param year {number} The Taiwanese year.
	                  @return {number} The corresponding Gregorian year. */
	              _t2gYear: function(year) {
	                return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
	              },
	              /** Convert Gregorian to Taiwanese year.
	                  @memberof TaiwanCalendar
	                  @private
	                  @param year {number} The Gregorian year.
	                  @return {number} The corresponding Taiwanese year. */
	              _g2tYear: function(year) {
	                return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
	              }
	            });
	            main.calendars.taiwan = TaiwanCalendar;
	          }
	        ),
	        /***/
	        51367: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            var gregorianCalendar = main.instance();
	            function ThaiCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            ThaiCalendar.prototype = new main.baseCalendar();
	            assign(ThaiCalendar.prototype, {
	              /** The calendar name.
	                  @memberof ThaiCalendar */
	              name: "Thai",
	              /** Julian date of start of Thai epoch: 1 January 543 BCE (Gregorian).
	                  @memberof ThaiCalendar */
	              jdEpoch: 15230985e-1,
	              /** Difference in years between Thai and Gregorian calendars.
	                  @memberof ThaiCalendar */
	              yearsOffset: 543,
	              /** Days per month in a common year.
	                  @memberof ThaiCalendar */
	              daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof ThaiCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof ThaiCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof ThaiCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof ThaiCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof ThaiCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Thai",
	                  epochs: ["BBE", "BE"],
	                  monthNames: [
	                    "January",
	                    "February",
	                    "March",
	                    "April",
	                    "May",
	                    "June",
	                    "July",
	                    "August",
	                    "September",
	                    "October",
	                    "November",
	                    "December"
	                  ],
	                  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	                  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	                  digits: null,
	                  dateFormat: "dd/mm/yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof ThaiCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = this._t2gYear(date.year());
	                return gregorianCalendar.leapYear(year);
	              },
	              /** Determine the week of the year for a date - ISO 8601.
	                  @memberof ThaiCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                var year = this._t2gYear(date.year());
	                return gregorianCalendar.weekOfYear(year, date.month(), date.day());
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof ThaiCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof ThaiCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof ThaiCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                var year = this._t2gYear(date.year());
	                return gregorianCalendar.toJD(year, date.month(), date.day());
	              },
	              /** Create a new date from a Julian date.
	                  @memberof ThaiCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var date = gregorianCalendar.fromJD(jd);
	                var year = this._g2tYear(date.year());
	                return this.newDate(year, date.month(), date.day());
	              },
	              /** Convert Thai to Gregorian year.
	                  @memberof ThaiCalendar
	                  @private
	                  @param year {number} The Thai year.
	                  @return {number} The corresponding Gregorian year. */
	              _t2gYear: function(year) {
	                return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
	              },
	              /** Convert Gregorian to Thai year.
	                  @memberof ThaiCalendar
	                  @private
	                  @param year {number} The Gregorian year.
	                  @return {number} The corresponding Thai year. */
	              _g2tYear: function(year) {
	                return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
	              }
	            });
	            main.calendars.thai = ThaiCalendar;
	          }
	        ),
	        /***/
	        21457: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var main = __webpack_require__2(63489);
	            var assign = __webpack_require__2(56131);
	            function UmmAlQuraCalendar(language) {
	              this.local = this.regionalOptions[language || ""] || this.regionalOptions[""];
	            }
	            UmmAlQuraCalendar.prototype = new main.baseCalendar();
	            assign(UmmAlQuraCalendar.prototype, {
	              /** The calendar name.
	                  @memberof UmmAlQuraCalendar */
	              name: "UmmAlQura",
	              //jdEpoch: 1948440, // Julian date of start of UmmAlQura epoch: 14 March 1937 CE
	              //daysPerMonth: // Days per month in a common year, replaced by a method.
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                  @memberof UmmAlQuraCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof UmmAlQuraCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof UmmAlQuraCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                  @memberof UmmAlQuraCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof UmmAlQuraCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Umm al-Qura",
	                  epochs: ["BH", "AH"],
	                  monthNames: [
	                    "Al-Muharram",
	                    "Safar",
	                    "Rabi' al-awwal",
	                    "Rabi' Al-Thani",
	                    "Jumada Al-Awwal",
	                    "Jumada Al-Thani",
	                    "Rajab",
	                    "Sha'aban",
	                    "Ramadan",
	                    "Shawwal",
	                    "Dhu al-Qi'dah",
	                    "Dhu al-Hijjah"
	                  ],
	                  monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"],
	                  dayNames: ["Yawm al-Ahad", "Yawm al-Ithnain", "Yawm al-Thalāthā’", "Yawm al-Arba‘ā’", "Yawm al-Khamīs", "Yawm al-Jum‘a", "Yawm al-Sabt"],
	                  dayNamesMin: ["Ah", "Ith", "Th", "Ar", "Kh", "Ju", "Sa"],
	                  digits: null,
	                  dateFormat: "yyyy/mm/dd",
	                  firstDay: 6,
	                  isRTL: true
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof UmmAlQuraCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
	                return this.daysInYear(date.year()) === 355;
	              },
	              /** Determine the week of the year for a date.
	                  @memberof UmmAlQuraCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(-checkDate.dayOfWeek(), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof UmmAlQuraCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                var daysCount = 0;
	                for (var i = 1; i <= 12; i++) {
	                  daysCount += this.daysInMonth(year, i);
	                }
	                return daysCount;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof UmmAlQuraCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
	                var mcjdn = date.toJD() - 24e5 + 0.5;
	                var index = 0;
	                for (var i = 0; i < ummalqura_dat.length; i++) {
	                  if (ummalqura_dat[i] > mcjdn) {
	                    return ummalqura_dat[index] - ummalqura_dat[index - 1];
	                  }
	                  index++;
	                }
	                return 30;
	              },
	              /** Determine whether this date is a week day.
	                  @memberof UmmAlQuraCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return this.dayOfWeek(year, month, day) !== 5;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof UmmAlQuraCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(year, month, day, main.local.invalidDate);
	                var index = 12 * (date.year() - 1) + date.month() - 15292;
	                var mcjdn = date.day() + ummalqura_dat[index - 1] - 1;
	                return mcjdn + 24e5 - 0.5;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof UmmAlQuraCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var mcjdn = jd - 24e5 + 0.5;
	                var index = 0;
	                for (var i = 0; i < ummalqura_dat.length; i++) {
	                  if (ummalqura_dat[i] > mcjdn) break;
	                  index++;
	                }
	                var lunation = index + 15292;
	                var ii = Math.floor((lunation - 1) / 12);
	                var year = ii + 1;
	                var month = lunation - 12 * ii;
	                var day = mcjdn - ummalqura_dat[index - 1] + 1;
	                return this.newDate(year, month, day);
	              },
	              /** Determine whether a date is valid for this calendar.
	                  @memberof UmmAlQuraCalendar
	                  @param year {number} The year to examine.
	                  @param month {number} The month to examine.
	                  @param day {number} The day to examine.
	                  @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
	              isValid: function(year, month, day) {
	                var valid = main.baseCalendar.prototype.isValid.apply(this, arguments);
	                if (valid) {
	                  year = year.year != null ? year.year : year;
	                  valid = year >= 1276 && year <= 1500;
	                }
	                return valid;
	              },
	              /** Check that a candidate date is from the same calendar and is valid.
	                  @memberof UmmAlQuraCalendar
	                  @private
	                  @param year {CDate|number} The date to validate or the year to validate.
	                  @param month {number} The month to validate.
	                  @param day {number} The day to validate.
	                  @param error {string} Error message if invalid.
	                  @throws Error if different calendars used or invalid date. */
	              _validate: function(year, month, day, error) {
	                var date = main.baseCalendar.prototype._validate.apply(this, arguments);
	                if (date.year < 1276 || date.year > 1500) {
	                  throw error.replace(/\{0\}/, this.local.name);
	                }
	                return date;
	              }
	            });
	            main.calendars.ummalqura = UmmAlQuraCalendar;
	            var ummalqura_dat = [
	              20,
	              50,
	              79,
	              109,
	              138,
	              168,
	              197,
	              227,
	              256,
	              286,
	              315,
	              345,
	              374,
	              404,
	              433,
	              463,
	              492,
	              522,
	              551,
	              581,
	              611,
	              641,
	              670,
	              700,
	              729,
	              759,
	              788,
	              818,
	              847,
	              877,
	              906,
	              936,
	              965,
	              995,
	              1024,
	              1054,
	              1083,
	              1113,
	              1142,
	              1172,
	              1201,
	              1231,
	              1260,
	              1290,
	              1320,
	              1350,
	              1379,
	              1409,
	              1438,
	              1468,
	              1497,
	              1527,
	              1556,
	              1586,
	              1615,
	              1645,
	              1674,
	              1704,
	              1733,
	              1763,
	              1792,
	              1822,
	              1851,
	              1881,
	              1910,
	              1940,
	              1969,
	              1999,
	              2028,
	              2058,
	              2087,
	              2117,
	              2146,
	              2176,
	              2205,
	              2235,
	              2264,
	              2294,
	              2323,
	              2353,
	              2383,
	              2413,
	              2442,
	              2472,
	              2501,
	              2531,
	              2560,
	              2590,
	              2619,
	              2649,
	              2678,
	              2708,
	              2737,
	              2767,
	              2796,
	              2826,
	              2855,
	              2885,
	              2914,
	              2944,
	              2973,
	              3003,
	              3032,
	              3062,
	              3091,
	              3121,
	              3150,
	              3180,
	              3209,
	              3239,
	              3268,
	              3298,
	              3327,
	              3357,
	              3386,
	              3416,
	              3446,
	              3476,
	              3505,
	              3535,
	              3564,
	              3594,
	              3623,
	              3653,
	              3682,
	              3712,
	              3741,
	              3771,
	              3800,
	              3830,
	              3859,
	              3889,
	              3918,
	              3948,
	              3977,
	              4007,
	              4036,
	              4066,
	              4095,
	              4125,
	              4155,
	              4185,
	              4214,
	              4244,
	              4273,
	              4303,
	              4332,
	              4362,
	              4391,
	              4421,
	              4450,
	              4480,
	              4509,
	              4539,
	              4568,
	              4598,
	              4627,
	              4657,
	              4686,
	              4716,
	              4745,
	              4775,
	              4804,
	              4834,
	              4863,
	              4893,
	              4922,
	              4952,
	              4981,
	              5011,
	              5040,
	              5070,
	              5099,
	              5129,
	              5158,
	              5188,
	              5218,
	              5248,
	              5277,
	              5307,
	              5336,
	              5366,
	              5395,
	              5425,
	              5454,
	              5484,
	              5513,
	              5543,
	              5572,
	              5602,
	              5631,
	              5661,
	              5690,
	              5720,
	              5749,
	              5779,
	              5808,
	              5838,
	              5867,
	              5897,
	              5926,
	              5956,
	              5985,
	              6015,
	              6044,
	              6074,
	              6103,
	              6133,
	              6162,
	              6192,
	              6221,
	              6251,
	              6281,
	              6311,
	              6340,
	              6370,
	              6399,
	              6429,
	              6458,
	              6488,
	              6517,
	              6547,
	              6576,
	              6606,
	              6635,
	              6665,
	              6694,
	              6724,
	              6753,
	              6783,
	              6812,
	              6842,
	              6871,
	              6901,
	              6930,
	              6960,
	              6989,
	              7019,
	              7048,
	              7078,
	              7107,
	              7137,
	              7166,
	              7196,
	              7225,
	              7255,
	              7284,
	              7314,
	              7344,
	              7374,
	              7403,
	              7433,
	              7462,
	              7492,
	              7521,
	              7551,
	              7580,
	              7610,
	              7639,
	              7669,
	              7698,
	              7728,
	              7757,
	              7787,
	              7816,
	              7846,
	              7875,
	              7905,
	              7934,
	              7964,
	              7993,
	              8023,
	              8053,
	              8083,
	              8112,
	              8142,
	              8171,
	              8201,
	              8230,
	              8260,
	              8289,
	              8319,
	              8348,
	              8378,
	              8407,
	              8437,
	              8466,
	              8496,
	              8525,
	              8555,
	              8584,
	              8614,
	              8643,
	              8673,
	              8702,
	              8732,
	              8761,
	              8791,
	              8821,
	              8850,
	              8880,
	              8909,
	              8938,
	              8968,
	              8997,
	              9027,
	              9056,
	              9086,
	              9115,
	              9145,
	              9175,
	              9205,
	              9234,
	              9264,
	              9293,
	              9322,
	              9352,
	              9381,
	              9410,
	              9440,
	              9470,
	              9499,
	              9529,
	              9559,
	              9589,
	              9618,
	              9648,
	              9677,
	              9706,
	              9736,
	              9765,
	              9794,
	              9824,
	              9853,
	              9883,
	              9913,
	              9943,
	              9972,
	              10002,
	              10032,
	              10061,
	              10090,
	              10120,
	              10149,
	              10178,
	              10208,
	              10237,
	              10267,
	              10297,
	              10326,
	              10356,
	              10386,
	              10415,
	              10445,
	              10474,
	              10504,
	              10533,
	              10562,
	              10592,
	              10621,
	              10651,
	              10680,
	              10710,
	              10740,
	              10770,
	              10799,
	              10829,
	              10858,
	              10888,
	              10917,
	              10947,
	              10976,
	              11005,
	              11035,
	              11064,
	              11094,
	              11124,
	              11153,
	              11183,
	              11213,
	              11242,
	              11272,
	              11301,
	              11331,
	              11360,
	              11389,
	              11419,
	              11448,
	              11478,
	              11507,
	              11537,
	              11567,
	              11596,
	              11626,
	              11655,
	              11685,
	              11715,
	              11744,
	              11774,
	              11803,
	              11832,
	              11862,
	              11891,
	              11921,
	              11950,
	              11980,
	              12010,
	              12039,
	              12069,
	              12099,
	              12128,
	              12158,
	              12187,
	              12216,
	              12246,
	              12275,
	              12304,
	              12334,
	              12364,
	              12393,
	              12423,
	              12453,
	              12483,
	              12512,
	              12542,
	              12571,
	              12600,
	              12630,
	              12659,
	              12688,
	              12718,
	              12747,
	              12777,
	              12807,
	              12837,
	              12866,
	              12896,
	              12926,
	              12955,
	              12984,
	              13014,
	              13043,
	              13072,
	              13102,
	              13131,
	              13161,
	              13191,
	              13220,
	              13250,
	              13280,
	              13310,
	              13339,
	              13368,
	              13398,
	              13427,
	              13456,
	              13486,
	              13515,
	              13545,
	              13574,
	              13604,
	              13634,
	              13664,
	              13693,
	              13723,
	              13752,
	              13782,
	              13811,
	              13840,
	              13870,
	              13899,
	              13929,
	              13958,
	              13988,
	              14018,
	              14047,
	              14077,
	              14107,
	              14136,
	              14166,
	              14195,
	              14224,
	              14254,
	              14283,
	              14313,
	              14342,
	              14372,
	              14401,
	              14431,
	              14461,
	              14490,
	              14520,
	              14550,
	              14579,
	              14609,
	              14638,
	              14667,
	              14697,
	              14726,
	              14756,
	              14785,
	              14815,
	              14844,
	              14874,
	              14904,
	              14933,
	              14963,
	              14993,
	              15021,
	              15051,
	              15081,
	              15110,
	              15140,
	              15169,
	              15199,
	              15228,
	              15258,
	              15287,
	              15317,
	              15347,
	              15377,
	              15406,
	              15436,
	              15465,
	              15494,
	              15524,
	              15553,
	              15582,
	              15612,
	              15641,
	              15671,
	              15701,
	              15731,
	              15760,
	              15790,
	              15820,
	              15849,
	              15878,
	              15908,
	              15937,
	              15966,
	              15996,
	              16025,
	              16055,
	              16085,
	              16114,
	              16144,
	              16174,
	              16204,
	              16233,
	              16262,
	              16292,
	              16321,
	              16350,
	              16380,
	              16409,
	              16439,
	              16468,
	              16498,
	              16528,
	              16558,
	              16587,
	              16617,
	              16646,
	              16676,
	              16705,
	              16734,
	              16764,
	              16793,
	              16823,
	              16852,
	              16882,
	              16912,
	              16941,
	              16971,
	              17001,
	              17030,
	              17060,
	              17089,
	              17118,
	              17148,
	              17177,
	              17207,
	              17236,
	              17266,
	              17295,
	              17325,
	              17355,
	              17384,
	              17414,
	              17444,
	              17473,
	              17502,
	              17532,
	              17561,
	              17591,
	              17620,
	              17650,
	              17679,
	              17709,
	              17738,
	              17768,
	              17798,
	              17827,
	              17857,
	              17886,
	              17916,
	              17945,
	              17975,
	              18004,
	              18034,
	              18063,
	              18093,
	              18122,
	              18152,
	              18181,
	              18211,
	              18241,
	              18270,
	              18300,
	              18330,
	              18359,
	              18388,
	              18418,
	              18447,
	              18476,
	              18506,
	              18535,
	              18565,
	              18595,
	              18625,
	              18654,
	              18684,
	              18714,
	              18743,
	              18772,
	              18802,
	              18831,
	              18860,
	              18890,
	              18919,
	              18949,
	              18979,
	              19008,
	              19038,
	              19068,
	              19098,
	              19127,
	              19156,
	              19186,
	              19215,
	              19244,
	              19274,
	              19303,
	              19333,
	              19362,
	              19392,
	              19422,
	              19452,
	              19481,
	              19511,
	              19540,
	              19570,
	              19599,
	              19628,
	              19658,
	              19687,
	              19717,
	              19746,
	              19776,
	              19806,
	              19836,
	              19865,
	              19895,
	              19924,
	              19954,
	              19983,
	              20012,
	              20042,
	              20071,
	              20101,
	              20130,
	              20160,
	              20190,
	              20219,
	              20249,
	              20279,
	              20308,
	              20338,
	              20367,
	              20396,
	              20426,
	              20455,
	              20485,
	              20514,
	              20544,
	              20573,
	              20603,
	              20633,
	              20662,
	              20692,
	              20721,
	              20751,
	              20780,
	              20810,
	              20839,
	              20869,
	              20898,
	              20928,
	              20957,
	              20987,
	              21016,
	              21046,
	              21076,
	              21105,
	              21135,
	              21164,
	              21194,
	              21223,
	              21253,
	              21282,
	              21312,
	              21341,
	              21371,
	              21400,
	              21430,
	              21459,
	              21489,
	              21519,
	              21548,
	              21578,
	              21607,
	              21637,
	              21666,
	              21696,
	              21725,
	              21754,
	              21784,
	              21813,
	              21843,
	              21873,
	              21902,
	              21932,
	              21962,
	              21991,
	              22021,
	              22050,
	              22080,
	              22109,
	              22138,
	              22168,
	              22197,
	              22227,
	              22256,
	              22286,
	              22316,
	              22346,
	              22375,
	              22405,
	              22434,
	              22464,
	              22493,
	              22522,
	              22552,
	              22581,
	              22611,
	              22640,
	              22670,
	              22700,
	              22730,
	              22759,
	              22789,
	              22818,
	              22848,
	              22877,
	              22906,
	              22936,
	              22965,
	              22994,
	              23024,
	              23054,
	              23083,
	              23113,
	              23143,
	              23173,
	              23202,
	              23232,
	              23261,
	              23290,
	              23320,
	              23349,
	              23379,
	              23408,
	              23438,
	              23467,
	              23497,
	              23527,
	              23556,
	              23586,
	              23616,
	              23645,
	              23674,
	              23704,
	              23733,
	              23763,
	              23792,
	              23822,
	              23851,
	              23881,
	              23910,
	              23940,
	              23970,
	              23999,
	              24029,
	              24058,
	              24088,
	              24117,
	              24147,
	              24176,
	              24206,
	              24235,
	              24265,
	              24294,
	              24324,
	              24353,
	              24383,
	              24413,
	              24442,
	              24472,
	              24501,
	              24531,
	              24560,
	              24590,
	              24619,
	              24648,
	              24678,
	              24707,
	              24737,
	              24767,
	              24796,
	              24826,
	              24856,
	              24885,
	              24915,
	              24944,
	              24974,
	              25003,
	              25032,
	              25062,
	              25091,
	              25121,
	              25150,
	              25180,
	              25210,
	              25240,
	              25269,
	              25299,
	              25328,
	              25358,
	              25387,
	              25416,
	              25446,
	              25475,
	              25505,
	              25534,
	              25564,
	              25594,
	              25624,
	              25653,
	              25683,
	              25712,
	              25742,
	              25771,
	              25800,
	              25830,
	              25859,
	              25888,
	              25918,
	              25948,
	              25977,
	              26007,
	              26037,
	              26067,
	              26096,
	              26126,
	              26155,
	              26184,
	              26214,
	              26243,
	              26272,
	              26302,
	              26332,
	              26361,
	              26391,
	              26421,
	              26451,
	              26480,
	              26510,
	              26539,
	              26568,
	              26598,
	              26627,
	              26656,
	              26686,
	              26715,
	              26745,
	              26775,
	              26805,
	              26834,
	              26864,
	              26893,
	              26923,
	              26952,
	              26982,
	              27011,
	              27041,
	              27070,
	              27099,
	              27129,
	              27159,
	              27188,
	              27218,
	              27248,
	              27277,
	              27307,
	              27336,
	              27366,
	              27395,
	              27425,
	              27454,
	              27484,
	              27513,
	              27542,
	              27572,
	              27602,
	              27631,
	              27661,
	              27691,
	              27720,
	              27750,
	              27779,
	              27809,
	              27838,
	              27868,
	              27897,
	              27926,
	              27956,
	              27985,
	              28015,
	              28045,
	              28074,
	              28104,
	              28134,
	              28163,
	              28193,
	              28222,
	              28252,
	              28281,
	              28310,
	              28340,
	              28369,
	              28399,
	              28428,
	              28458,
	              28488,
	              28517,
	              28547,
	              28577,
	              // From 1356
	              28607,
	              28636,
	              28665,
	              28695,
	              28724,
	              28754,
	              28783,
	              28813,
	              28843,
	              28872,
	              28901,
	              28931,
	              28960,
	              28990,
	              29019,
	              29049,
	              29078,
	              29108,
	              29137,
	              29167,
	              29196,
	              29226,
	              29255,
	              29285,
	              29315,
	              29345,
	              29375,
	              29404,
	              29434,
	              29463,
	              29492,
	              29522,
	              29551,
	              29580,
	              29610,
	              29640,
	              29669,
	              29699,
	              29729,
	              29759,
	              29788,
	              29818,
	              29847,
	              29876,
	              29906,
	              29935,
	              29964,
	              29994,
	              30023,
	              30053,
	              30082,
	              30112,
	              30141,
	              30171,
	              30200,
	              30230,
	              30259,
	              30289,
	              30318,
	              30348,
	              30378,
	              30408,
	              30437,
	              30467,
	              30496,
	              30526,
	              30555,
	              30585,
	              30614,
	              30644,
	              30673,
	              30703,
	              30732,
	              30762,
	              30791,
	              30821,
	              30850,
	              30880,
	              30909,
	              30939,
	              30968,
	              30998,
	              31027,
	              31057,
	              31086,
	              31116,
	              31145,
	              31175,
	              31204,
	              31234,
	              31263,
	              31293,
	              31322,
	              31352,
	              31381,
	              31411,
	              31441,
	              31471,
	              31500,
	              31530,
	              31559,
	              31589,
	              31618,
	              31648,
	              31676,
	              31706,
	              31736,
	              31766,
	              31795,
	              31825,
	              31854,
	              31884,
	              31913,
	              31943,
	              31972,
	              32002,
	              32031,
	              32061,
	              32090,
	              32120,
	              32150,
	              32180,
	              32209,
	              32239,
	              32268,
	              32298,
	              32327,
	              32357,
	              32386,
	              32416,
	              32445,
	              32475,
	              32504,
	              32534,
	              32563,
	              32593,
	              32622,
	              32652,
	              32681,
	              32711,
	              32740,
	              32770,
	              32799,
	              32829,
	              32858,
	              32888,
	              32917,
	              32947,
	              32976,
	              33006,
	              33035,
	              33065,
	              33094,
	              33124,
	              33153,
	              33183,
	              33213,
	              33243,
	              33272,
	              33302,
	              33331,
	              33361,
	              33390,
	              33420,
	              33450,
	              33479,
	              33509,
	              33539,
	              33568,
	              33598,
	              33627,
	              33657,
	              33686,
	              33716,
	              33745,
	              33775,
	              33804,
	              33834,
	              33863,
	              33893,
	              33922,
	              33952,
	              33981,
	              34011,
	              34040,
	              34069,
	              34099,
	              34128,
	              34158,
	              34187,
	              34217,
	              34247,
	              34277,
	              34306,
	              34336,
	              34365,
	              34395,
	              34424,
	              34454,
	              34483,
	              34512,
	              34542,
	              34571,
	              34601,
	              34631,
	              34660,
	              34690,
	              34719,
	              34749,
	              34778,
	              34808,
	              34837,
	              34867,
	              34896,
	              34926,
	              34955,
	              34985,
	              35015,
	              35044,
	              35074,
	              35103,
	              35133,
	              35162,
	              35192,
	              35222,
	              35251,
	              35280,
	              35310,
	              35340,
	              35370,
	              35399,
	              35429,
	              35458,
	              35488,
	              35517,
	              35547,
	              35576,
	              35605,
	              35635,
	              35665,
	              35694,
	              35723,
	              35753,
	              35782,
	              35811,
	              35841,
	              35871,
	              35901,
	              35930,
	              35960,
	              35989,
	              36019,
	              36048,
	              36078,
	              36107,
	              36136,
	              36166,
	              36195,
	              36225,
	              36254,
	              36284,
	              36314,
	              36343,
	              36373,
	              36403,
	              36433,
	              36462,
	              36492,
	              36521,
	              36551,
	              36580,
	              36610,
	              36639,
	              36669,
	              36698,
	              36728,
	              36757,
	              36786,
	              36816,
	              36845,
	              36875,
	              36904,
	              36934,
	              36963,
	              36993,
	              37022,
	              37052,
	              37081,
	              37111,
	              37141,
	              37170,
	              37200,
	              37229,
	              37259,
	              37288,
	              37318,
	              37347,
	              37377,
	              37406,
	              37436,
	              37465,
	              37495,
	              37524,
	              37554,
	              37584,
	              37613,
	              37643,
	              37672,
	              37701,
	              37731,
	              37760,
	              37790,
	              37819,
	              37849,
	              37878,
	              37908,
	              37938,
	              37967,
	              37997,
	              38027,
	              38056,
	              38085,
	              38115,
	              38144,
	              38174,
	              38203,
	              38233,
	              38262,
	              38292,
	              38322,
	              38351,
	              38381,
	              38410,
	              38440,
	              38469,
	              38499,
	              38528,
	              38558,
	              38587,
	              38617,
	              38646,
	              38676,
	              38705,
	              38735,
	              38764,
	              38794,
	              38823,
	              38853,
	              38882,
	              38912,
	              38941,
	              38971,
	              39001,
	              39030,
	              39059,
	              39089,
	              39118,
	              39148,
	              39178,
	              39208,
	              39237,
	              39267,
	              39297,
	              39326,
	              39355,
	              39385,
	              39414,
	              39444,
	              39473,
	              39503,
	              39532,
	              39562,
	              39592,
	              39621,
	              39650,
	              39680,
	              39709,
	              39739,
	              39768,
	              39798,
	              39827,
	              39857,
	              39886,
	              39916,
	              39946,
	              39975,
	              40005,
	              40035,
	              40064,
	              40094,
	              40123,
	              40153,
	              40182,
	              40212,
	              40241,
	              40271,
	              40300,
	              40330,
	              40359,
	              40389,
	              40418,
	              40448,
	              40477,
	              40507,
	              40536,
	              40566,
	              40595,
	              40625,
	              40655,
	              40685,
	              40714,
	              40744,
	              40773,
	              40803,
	              40832,
	              40862,
	              40892,
	              40921,
	              40951,
	              40980,
	              41009,
	              41039,
	              41068,
	              41098,
	              41127,
	              41157,
	              41186,
	              41216,
	              41245,
	              41275,
	              41304,
	              41334,
	              41364,
	              41393,
	              41422,
	              41452,
	              41481,
	              41511,
	              41540,
	              41570,
	              41599,
	              41629,
	              41658,
	              41688,
	              41718,
	              41748,
	              41777,
	              41807,
	              41836,
	              41865,
	              41894,
	              41924,
	              41953,
	              41983,
	              42012,
	              42042,
	              42072,
	              42102,
	              42131,
	              42161,
	              42190,
	              42220,
	              42249,
	              42279,
	              42308,
	              42337,
	              42367,
	              42397,
	              42426,
	              42456,
	              42485,
	              42515,
	              42545,
	              42574,
	              42604,
	              42633,
	              42662,
	              42692,
	              42721,
	              42751,
	              42780,
	              42810,
	              42839,
	              42869,
	              42899,
	              42929,
	              42958,
	              42988,
	              43017,
	              43046,
	              43076,
	              43105,
	              43135,
	              43164,
	              43194,
	              43223,
	              43253,
	              43283,
	              43312,
	              43342,
	              43371,
	              43401,
	              43430,
	              43460,
	              43489,
	              43519,
	              43548,
	              43578,
	              43607,
	              43637,
	              43666,
	              43696,
	              43726,
	              43755,
	              43785,
	              43814,
	              43844,
	              43873,
	              43903,
	              43932,
	              43962,
	              43991,
	              44021,
	              44050,
	              44080,
	              44109,
	              44139,
	              44169,
	              44198,
	              44228,
	              44258,
	              44287,
	              44317,
	              44346,
	              44375,
	              44405,
	              44434,
	              44464,
	              44493,
	              44523,
	              44553,
	              44582,
	              44612,
	              44641,
	              44671,
	              44700,
	              44730,
	              44759,
	              44788,
	              44818,
	              44847,
	              44877,
	              44906,
	              44936,
	              44966,
	              44996,
	              45025,
	              45055,
	              45084,
	              45114,
	              45143,
	              45172,
	              45202,
	              45231,
	              45261,
	              45290,
	              45320,
	              45350,
	              45380,
	              45409,
	              45439,
	              45468,
	              45498,
	              45527,
	              45556,
	              45586,
	              45615,
	              45644,
	              45674,
	              45704,
	              45733,
	              45763,
	              45793,
	              45823,
	              45852,
	              45882,
	              45911,
	              45940,
	              45970,
	              45999,
	              46028,
	              46058,
	              46088,
	              46117,
	              46147,
	              46177,
	              46206,
	              46236,
	              46265,
	              46295,
	              46324,
	              46354,
	              46383,
	              46413,
	              46442,
	              46472,
	              46501,
	              46531,
	              46560,
	              46590,
	              46620,
	              46649,
	              46679,
	              46708,
	              46738,
	              46767,
	              46797,
	              46826,
	              46856,
	              46885,
	              46915,
	              46944,
	              46974,
	              47003,
	              47033,
	              47063,
	              47092,
	              47122,
	              47151,
	              47181,
	              47210,
	              47240,
	              47269,
	              47298,
	              47328,
	              47357,
	              47387,
	              47417,
	              47446,
	              47476,
	              47506,
	              47535,
	              47565,
	              47594,
	              47624,
	              47653,
	              47682,
	              47712,
	              47741,
	              47771,
	              47800,
	              47830,
	              47860,
	              47890,
	              47919,
	              47949,
	              47978,
	              48008,
	              48037,
	              48066,
	              48096,
	              48125,
	              48155,
	              48184,
	              48214,
	              48244,
	              48273,
	              48303,
	              48333,
	              48362,
	              48392,
	              48421,
	              48450,
	              48480,
	              48509,
	              48538,
	              48568,
	              48598,
	              48627,
	              48657,
	              48687,
	              48717,
	              48746,
	              48776,
	              48805,
	              48834,
	              48864,
	              48893,
	              48922,
	              48952,
	              48982,
	              49011,
	              49041,
	              49071,
	              49100,
	              49130,
	              49160,
	              49189,
	              49218,
	              49248,
	              49277,
	              49306,
	              49336,
	              49365,
	              49395,
	              49425,
	              49455,
	              49484,
	              49514,
	              49543,
	              49573,
	              49602,
	              49632,
	              49661,
	              49690,
	              49720,
	              49749,
	              49779,
	              49809,
	              49838,
	              49868,
	              49898,
	              49927,
	              49957,
	              49986,
	              50016,
	              50045,
	              50075,
	              50104,
	              50133,
	              50163,
	              50192,
	              50222,
	              50252,
	              50281,
	              50311,
	              50340,
	              50370,
	              50400,
	              50429,
	              50459,
	              50488,
	              50518,
	              50547,
	              50576,
	              50606,
	              50635,
	              50665,
	              50694,
	              50724,
	              50754,
	              50784,
	              50813,
	              50843,
	              50872,
	              50902,
	              50931,
	              50960,
	              50990,
	              51019,
	              51049,
	              51078,
	              51108,
	              51138,
	              51167,
	              51197,
	              51227,
	              51256,
	              51286,
	              51315,
	              51345,
	              51374,
	              51403,
	              51433,
	              51462,
	              51492,
	              51522,
	              51552,
	              51582,
	              51611,
	              51641,
	              51670,
	              51699,
	              51729,
	              51758,
	              51787,
	              51816,
	              51846,
	              51876,
	              51906,
	              51936,
	              51965,
	              51995,
	              52025,
	              52054,
	              52083,
	              52113,
	              52142,
	              52171,
	              52200,
	              52230,
	              52260,
	              52290,
	              52319,
	              52349,
	              52379,
	              52408,
	              52438,
	              52467,
	              52497,
	              52526,
	              52555,
	              52585,
	              52614,
	              52644,
	              52673,
	              52703,
	              52733,
	              52762,
	              52792,
	              52822,
	              52851,
	              52881,
	              52910,
	              52939,
	              52969,
	              52998,
	              53028,
	              53057,
	              53087,
	              53116,
	              53146,
	              53176,
	              53205,
	              53235,
	              53264,
	              53294,
	              53324,
	              53353,
	              53383,
	              53412,
	              53441,
	              53471,
	              53500,
	              53530,
	              53559,
	              53589,
	              53619,
	              53648,
	              53678,
	              53708,
	              53737,
	              53767,
	              53796,
	              53825,
	              53855,
	              53884,
	              53913,
	              53943,
	              53973,
	              54003,
	              54032,
	              54062,
	              54092,
	              54121,
	              54151,
	              54180,
	              54209,
	              54239,
	              54268,
	              54297,
	              54327,
	              54357,
	              54387,
	              54416,
	              54446,
	              54476,
	              54505,
	              54535,
	              54564,
	              54593,
	              54623,
	              54652,
	              54681,
	              54711,
	              54741,
	              54770,
	              54800,
	              54830,
	              54859,
	              54889,
	              54919,
	              54948,
	              54977,
	              55007,
	              55036,
	              55066,
	              55095,
	              55125,
	              55154,
	              55184,
	              55213,
	              55243,
	              55273,
	              55302,
	              55332,
	              55361,
	              55391,
	              55420,
	              55450,
	              55479,
	              55508,
	              55538,
	              55567,
	              55597,
	              55627,
	              55657,
	              55686,
	              55716,
	              55745,
	              55775,
	              55804,
	              55834,
	              55863,
	              55892,
	              55922,
	              55951,
	              55981,
	              56011,
	              56040,
	              56070,
	              56100,
	              56129,
	              56159,
	              56188,
	              56218,
	              56247,
	              56276,
	              56306,
	              56335,
	              56365,
	              56394,
	              56424,
	              56454,
	              56483,
	              56513,
	              56543,
	              56572,
	              56601,
	              56631,
	              56660,
	              56690,
	              56719,
	              56749,
	              56778,
	              56808,
	              56837,
	              56867,
	              56897,
	              56926,
	              56956,
	              56985,
	              57015,
	              57044,
	              57074,
	              57103,
	              57133,
	              57162,
	              57192,
	              57221,
	              57251,
	              57280,
	              57310,
	              57340,
	              57369,
	              57399,
	              57429,
	              57458,
	              57487,
	              57517,
	              57546,
	              57576,
	              57605,
	              57634,
	              57664,
	              57694,
	              57723,
	              57753,
	              57783,
	              57813,
	              57842,
	              57871,
	              57901,
	              57930,
	              57959,
	              57989,
	              58018,
	              58048,
	              58077,
	              58107,
	              58137,
	              58167,
	              58196,
	              58226,
	              58255,
	              58285,
	              58314,
	              58343,
	              58373,
	              58402,
	              58432,
	              58461,
	              58491,
	              58521,
	              58551,
	              58580,
	              58610,
	              58639,
	              58669,
	              58698,
	              58727,
	              58757,
	              58786,
	              58816,
	              58845,
	              58875,
	              58905,
	              58934,
	              58964,
	              58994,
	              59023,
	              59053,
	              59082,
	              59111,
	              59141,
	              59170,
	              59200,
	              59229,
	              59259,
	              59288,
	              59318,
	              59348,
	              59377,
	              59407,
	              59436,
	              59466,
	              59495,
	              59525,
	              59554,
	              59584,
	              59613,
	              59643,
	              59672,
	              59702,
	              59731,
	              59761,
	              59791,
	              59820,
	              59850,
	              59879,
	              59909,
	              59939,
	              59968,
	              59997,
	              60027,
	              60056,
	              60086,
	              60115,
	              60145,
	              60174,
	              60204,
	              60234,
	              60264,
	              60293,
	              60323,
	              60352,
	              60381,
	              60411,
	              60440,
	              60469,
	              60499,
	              60528,
	              60558,
	              60588,
	              60618,
	              60648,
	              60677,
	              60707,
	              60736,
	              60765,
	              60795,
	              60824,
	              60853,
	              60883,
	              60912,
	              60942,
	              60972,
	              61002,
	              61031,
	              61061,
	              61090,
	              61120,
	              61149,
	              61179,
	              61208,
	              61237,
	              61267,
	              61296,
	              61326,
	              61356,
	              61385,
	              61415,
	              61445,
	              61474,
	              61504,
	              61533,
	              61563,
	              61592,
	              61621,
	              61651,
	              61680,
	              61710,
	              61739,
	              61769,
	              61799,
	              61828,
	              61858,
	              61888,
	              61917,
	              61947,
	              61976,
	              62006,
	              62035,
	              62064,
	              62094,
	              62123,
	              62153,
	              62182,
	              62212,
	              62242,
	              62271,
	              62301,
	              62331,
	              62360,
	              62390,
	              62419,
	              62448,
	              62478,
	              62507,
	              62537,
	              62566,
	              62596,
	              62625,
	              62655,
	              62685,
	              62715,
	              62744,
	              62774,
	              62803,
	              62832,
	              62862,
	              62891,
	              62921,
	              62950,
	              62980,
	              63009,
	              63039,
	              63069,
	              63099,
	              63128,
	              63157,
	              63187,
	              63216,
	              63246,
	              63275,
	              63305,
	              63334,
	              63363,
	              63393,
	              63423,
	              63453,
	              63482,
	              63512,
	              63541,
	              63571,
	              63600,
	              63630,
	              63659,
	              63689,
	              63718,
	              63747,
	              63777,
	              63807,
	              63836,
	              63866,
	              63895,
	              63925,
	              63955,
	              63984,
	              64014,
	              64043,
	              64073,
	              64102,
	              64131,
	              64161,
	              64190,
	              64220,
	              64249,
	              64279,
	              64309,
	              64339,
	              64368,
	              64398,
	              64427,
	              64457,
	              64486,
	              64515,
	              64545,
	              64574,
	              64603,
	              64633,
	              64663,
	              64692,
	              64722,
	              64752,
	              64782,
	              64811,
	              64841,
	              64870,
	              64899,
	              64929,
	              64958,
	              64987,
	              65017,
	              65047,
	              65076,
	              65106,
	              65136,
	              65166,
	              65195,
	              65225,
	              65254,
	              65283,
	              65313,
	              65342,
	              65371,
	              65401,
	              65431,
	              65460,
	              65490,
	              65520,
	              65549,
	              65579,
	              65608,
	              65638,
	              65667,
	              65697,
	              65726,
	              65755,
	              65785,
	              65815,
	              65844,
	              65874,
	              65903,
	              65933,
	              65963,
	              65992,
	              66022,
	              66051,
	              66081,
	              66110,
	              66140,
	              66169,
	              66199,
	              66228,
	              66258,
	              66287,
	              66317,
	              66346,
	              66376,
	              66405,
	              66435,
	              66465,
	              66494,
	              66524,
	              66553,
	              66583,
	              66612,
	              66641,
	              66671,
	              66700,
	              66730,
	              66760,
	              66789,
	              66819,
	              66849,
	              66878,
	              66908,
	              66937,
	              66967,
	              66996,
	              67025,
	              67055,
	              67084,
	              67114,
	              67143,
	              67173,
	              67203,
	              67233,
	              67262,
	              67292,
	              67321,
	              67351,
	              67380,
	              67409,
	              67439,
	              67468,
	              67497,
	              67527,
	              67557,
	              67587,
	              67617,
	              67646,
	              67676,
	              67705,
	              67735,
	              67764,
	              67793,
	              67823,
	              67852,
	              67882,
	              67911,
	              67941,
	              67971,
	              68e3,
	              68030,
	              68060,
	              68089,
	              68119,
	              68148,
	              68177,
	              68207,
	              68236,
	              68266,
	              68295,
	              68325,
	              68354,
	              68384,
	              68414,
	              68443,
	              68473,
	              68502,
	              68532,
	              68561,
	              68591,
	              68620,
	              68650,
	              68679,
	              68708,
	              68738,
	              68768,
	              68797,
	              68827,
	              68857,
	              68886,
	              68916,
	              68946,
	              68975,
	              69004,
	              69034,
	              69063,
	              69092,
	              69122,
	              69152,
	              69181,
	              69211,
	              69240,
	              69270,
	              69300,
	              69330,
	              69359,
	              69388,
	              69418,
	              69447,
	              69476,
	              69506,
	              69535,
	              69565,
	              69595,
	              69624,
	              69654,
	              69684,
	              69713,
	              69743,
	              69772,
	              69802,
	              69831,
	              69861,
	              69890,
	              69919,
	              69949,
	              69978,
	              70008,
	              70038,
	              70067,
	              70097,
	              70126,
	              70156,
	              70186,
	              70215,
	              70245,
	              70274,
	              70303,
	              70333,
	              70362,
	              70392,
	              70421,
	              70451,
	              70481,
	              70510,
	              70540,
	              70570,
	              70599,
	              70629,
	              70658,
	              70687,
	              70717,
	              70746,
	              70776,
	              70805,
	              70835,
	              70864,
	              70894,
	              70924,
	              70954,
	              70983,
	              71013,
	              71042,
	              71071,
	              71101,
	              71130,
	              71159,
	              71189,
	              71218,
	              71248,
	              71278,
	              71308,
	              71337,
	              71367,
	              71397,
	              71426,
	              71455,
	              71485,
	              71514,
	              71543,
	              71573,
	              71602,
	              71632,
	              71662,
	              71691,
	              71721,
	              71751,
	              71781,
	              71810,
	              71839,
	              71869,
	              71898,
	              71927,
	              71957,
	              71986,
	              72016,
	              72046,
	              72075,
	              72105,
	              72135,
	              72164,
	              72194,
	              72223,
	              72253,
	              72282,
	              72311,
	              72341,
	              72370,
	              72400,
	              72429,
	              72459,
	              72489,
	              72518,
	              72548,
	              72577,
	              72607,
	              72637,
	              72666,
	              72695,
	              72725,
	              72754,
	              72784,
	              72813,
	              72843,
	              72872,
	              72902,
	              72931,
	              72961,
	              72991,
	              73020,
	              73050,
	              73080,
	              73109,
	              73139,
	              73168,
	              73197,
	              73227,
	              73256,
	              73286,
	              73315,
	              73345,
	              73375,
	              73404,
	              73434,
	              73464,
	              73493,
	              73523,
	              73552,
	              73581,
	              73611,
	              73640,
	              73669,
	              73699,
	              73729,
	              73758,
	              73788,
	              73818,
	              73848,
	              73877,
	              73907,
	              73936,
	              73965,
	              73995,
	              74024,
	              74053,
	              74083,
	              74113,
	              74142,
	              74172,
	              74202,
	              74231,
	              74261,
	              74291,
	              74320,
	              74349,
	              74379,
	              74408,
	              74437,
	              74467,
	              74497,
	              74526,
	              74556,
	              74586,
	              74615,
	              74645,
	              74675,
	              74704,
	              74733,
	              74763,
	              74792,
	              74822,
	              74851,
	              74881,
	              74910,
	              74940,
	              74969,
	              74999,
	              75029,
	              75058,
	              75088,
	              75117,
	              75147,
	              75176,
	              75206,
	              75235,
	              75264,
	              75294,
	              75323,
	              75353,
	              75383,
	              75412,
	              75442,
	              75472,
	              75501,
	              75531,
	              75560,
	              75590,
	              75619,
	              75648,
	              75678,
	              75707,
	              75737,
	              75766,
	              75796,
	              75826,
	              75856,
	              75885,
	              75915,
	              75944,
	              75974,
	              76003,
	              76032,
	              76062,
	              76091,
	              76121,
	              76150,
	              76180,
	              76210,
	              76239,
	              76269,
	              76299,
	              76328,
	              76358,
	              76387,
	              76416,
	              76446,
	              76475,
	              76505,
	              76534,
	              76564,
	              76593,
	              76623,
	              76653,
	              76682,
	              76712,
	              76741,
	              76771,
	              76801,
	              76830,
	              76859,
	              76889,
	              76918,
	              76948,
	              76977,
	              77007,
	              77036,
	              77066,
	              77096,
	              77125,
	              77155,
	              77185,
	              77214,
	              77243,
	              77273,
	              77302,
	              77332,
	              77361,
	              77390,
	              77420,
	              77450,
	              77479,
	              77509,
	              77539,
	              77569,
	              77598,
	              77627,
	              77657,
	              77686,
	              77715,
	              77745,
	              77774,
	              77804,
	              77833,
	              77863,
	              77893,
	              77923,
	              77952,
	              77982,
	              78011,
	              78041,
	              78070,
	              78099,
	              78129,
	              78158,
	              78188,
	              78217,
	              78247,
	              78277,
	              78307,
	              78336,
	              78366,
	              78395,
	              78425,
	              78454,
	              78483,
	              78513,
	              78542,
	              78572,
	              78601,
	              78631,
	              78661,
	              78690,
	              78720,
	              78750,
	              78779,
	              78808,
	              78838,
	              78867,
	              78897,
	              78926,
	              78956,
	              78985,
	              79015,
	              79044,
	              79074,
	              79104,
	              79133,
	              79163,
	              79192,
	              79222,
	              79251,
	              79281,
	              79310,
	              79340,
	              79369,
	              79399,
	              79428,
	              79458,
	              79487,
	              79517,
	              79546,
	              79576,
	              79606,
	              79635,
	              79665,
	              79695,
	              79724,
	              79753,
	              79783,
	              79812,
	              79841,
	              79871,
	              79900,
	              79930,
	              79960,
	              79990
	            ];
	          }
	        ),
	        /***/
	        63489: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var assign = __webpack_require__2(56131);
	            function Calendars() {
	              this.regionalOptions = [];
	              this.regionalOptions[""] = {
	                invalidCalendar: "Calendar {0} not found",
	                invalidDate: "Invalid {0} date",
	                invalidMonth: "Invalid {0} month",
	                invalidYear: "Invalid {0} year",
	                differentCalendars: "Cannot mix {0} and {1} dates"
	              };
	              this.local = this.regionalOptions[""];
	              this.calendars = {};
	              this._localCals = {};
	            }
	            assign(Calendars.prototype, {
	              /** Obtain a calendar implementation and localisation.
	                  @memberof Calendars
	                  @param [name='gregorian'] {string} The name of the calendar, e.g. 'gregorian', 'persian', 'islamic'.
	                  @param [language=''] {string} The language code to use for localisation (default is English).
	                  @return {Calendar} The calendar and localisation.
	                  @throws Error if calendar not found. */
	              instance: function(name2, language) {
	                name2 = (name2 || "gregorian").toLowerCase();
	                language = language || "";
	                var cal = this._localCals[name2 + "-" + language];
	                if (!cal && this.calendars[name2]) {
	                  cal = new this.calendars[name2](language);
	                  this._localCals[name2 + "-" + language] = cal;
	                }
	                if (!cal) {
	                  throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, name2);
	                }
	                return cal;
	              },
	              /** Create a new date - for today if no other parameters given.
	                  @memberof Calendars
	                  @param year {CDate|number} The date to copy or the year for the date.
	                  @param [month] {number} The month for the date.
	                  @param [day] {number} The day for the date.
	                  @param [calendar='gregorian'] {BaseCalendar|string} The underlying calendar or the name of the calendar.
	                  @param [language=''] {string} The language to use for localisation (default English).
	                  @return {CDate} The new date.
	                  @throws Error if an invalid date. */
	              newDate: function(year, month, day, calendar, language) {
	                calendar = (year != null && year.year ? year.calendar() : typeof calendar === "string" ? this.instance(calendar, language) : calendar) || this.instance();
	                return calendar.newDate(year, month, day);
	              },
	              /** A simple digit substitution function for localising numbers via the Calendar digits option.
	                  @member Calendars
	                  @param digits {string[]} The substitute digits, for 0 through 9.
	                  @return {function} The substitution function. */
	              substituteDigits: function(digits) {
	                return function(value) {
	                  return (value + "").replace(/[0-9]/g, function(digit) {
	                    return digits[digit];
	                  });
	                };
	              },
	              /** Digit substitution function for localising Chinese style numbers via the Calendar digits option.
	                  @member Calendars
	                  @param digits {string[]} The substitute digits, for 0 through 9.
	                  @param powers {string[]} The characters denoting powers of 10, i.e. 1, 10, 100, 1000.
	                  @return {function} The substitution function. */
	              substituteChineseDigits: function(digits, powers) {
	                return function(value) {
	                  var localNumber = "";
	                  var power = 0;
	                  while (value > 0) {
	                    var units = value % 10;
	                    localNumber = (units === 0 ? "" : digits[units] + powers[power]) + localNumber;
	                    power++;
	                    value = Math.floor(value / 10);
	                  }
	                  if (localNumber.indexOf(digits[1] + powers[1]) === 0) {
	                    localNumber = localNumber.substr(1);
	                  }
	                  return localNumber || digits[0];
	                };
	              }
	            });
	            function CDate(calendar, year, month, day) {
	              this._calendar = calendar;
	              this._year = year;
	              this._month = month;
	              this._day = day;
	              if (this._calendar._validateLevel === 0 && !this._calendar.isValid(this._year, this._month, this._day)) {
	                throw (_exports.local.invalidDate || _exports.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
	              }
	            }
	            function pad(value, length) {
	              value = "" + value;
	              return "000000".substring(0, length - value.length) + value;
	            }
	            assign(CDate.prototype, {
	              /** Create a new date.
	                  @memberof CDate
	                  @param [year] {CDate|number} The date to copy or the year for the date (default this date).
	                  @param [month] {number} The month for the date.
	                  @param [day] {number} The day for the date.
	                  @return {CDate} The new date.
	                  @throws Error if an invalid date. */
	              newDate: function(year, month, day) {
	                return this._calendar.newDate(year == null ? this : year, month, day);
	              },
	              /** Set or retrieve the year for this date.
	                  @memberof CDate
	                  @param [year] {number} The year for the date.
	                  @return {number|CDate} The date's year (if no parameter) or the updated date.
	                  @throws Error if an invalid date. */
	              year: function(year) {
	                return arguments.length === 0 ? this._year : this.set(year, "y");
	              },
	              /** Set or retrieve the month for this date.
	                  @memberof CDate
	                  @param [month] {number} The month for the date.
	                  @return {number|CDate} The date's month (if no parameter) or the updated date.
	                  @throws Error if an invalid date. */
	              month: function(month) {
	                return arguments.length === 0 ? this._month : this.set(month, "m");
	              },
	              /** Set or retrieve the day for this date.
	                  @memberof CDate
	                  @param [day] {number} The day for the date.
	                  @return {number|CData} The date's day (if no parameter) or the updated date.
	                  @throws Error if an invalid date. */
	              day: function(day) {
	                return arguments.length === 0 ? this._day : this.set(day, "d");
	              },
	              /** Set new values for this date.
	                  @memberof CDate
	                  @param year {number} The year for the date.
	                  @param month {number} The month for the date.
	                  @param day {number} The day for the date.
	                  @return {CDate} The updated date.
	                  @throws Error if an invalid date. */
	              date: function(year, month, day) {
	                if (!this._calendar.isValid(year, month, day)) {
	                  throw (_exports.local.invalidDate || _exports.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
	                }
	                this._year = year;
	                this._month = month;
	                this._day = day;
	                return this;
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof CDate
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not. */
	              leapYear: function() {
	                return this._calendar.leapYear(this);
	              },
	              /** Retrieve the epoch designator for this date, e.g. BCE or CE.
	                  @memberof CDate
	                  @return {string} The current epoch. */
	              epoch: function() {
	                return this._calendar.epoch(this);
	              },
	              /** Format the year, if not a simple sequential number.
	                  @memberof CDate
	                  @return {string} The formatted year. */
	              formatYear: function() {
	                return this._calendar.formatYear(this);
	              },
	              /** Retrieve the month of the year for this date,
	                  i.e. the month's position within a numbered year.
	                  @memberof CDate
	                  @return {number} The month of the year: <code>minMonth</code> to months per year. */
	              monthOfYear: function() {
	                return this._calendar.monthOfYear(this);
	              },
	              /** Retrieve the week of the year for this date.
	                  @memberof CDate
	                  @return {number} The week of the year: 1 to weeks per year. */
	              weekOfYear: function() {
	                return this._calendar.weekOfYear(this);
	              },
	              /** Retrieve the number of days in the year for this date.
	                  @memberof CDate
	                  @return {number} The number of days in this year. */
	              daysInYear: function() {
	                return this._calendar.daysInYear(this);
	              },
	              /** Retrieve the day of the year for this date.
	                  @memberof CDate
	                  @return {number} The day of the year: 1 to days per year. */
	              dayOfYear: function() {
	                return this._calendar.dayOfYear(this);
	              },
	              /** Retrieve the number of days in the month for this date.
	                  @memberof CDate
	                  @return {number} The number of days. */
	              daysInMonth: function() {
	                return this._calendar.daysInMonth(this);
	              },
	              /** Retrieve the day of the week for this date.
	                  @memberof CDate
	                  @return {number} The day of the week: 0 to number of days - 1. */
	              dayOfWeek: function() {
	                return this._calendar.dayOfWeek(this);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof CDate
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not. */
	              weekDay: function() {
	                return this._calendar.weekDay(this);
	              },
	              /** Retrieve additional information about this date.
	                  @memberof CDate
	                  @return {object} Additional information - contents depends on calendar. */
	              extraInfo: function() {
	                return this._calendar.extraInfo(this);
	              },
	              /** Add period(s) to a date.
	                  @memberof CDate
	                  @param offset {number} The number of periods to adjust by.
	                  @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	                  @return {CDate} The updated date. */
	              add: function(offset, period) {
	                return this._calendar.add(this, offset, period);
	              },
	              /** Set a portion of the date.
	                  @memberof CDate
	                  @param value {number} The new value for the period.
	                  @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
	                  @return {CDate} The updated date.
	                  @throws Error if not a valid date. */
	              set: function(value, period) {
	                return this._calendar.set(this, value, period);
	              },
	              /** Compare this date to another date.
	                  @memberof CDate
	                  @param date {CDate} The other date.
	                  @return {number} -1 if this date is before the other date,
	                          0 if they are equal, or +1 if this date is after the other date. */
	              compareTo: function(date) {
	                if (this._calendar.name !== date._calendar.name) {
	                  throw (_exports.local.differentCalendars || _exports.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, date._calendar.local.name);
	                }
	                var c = this._year !== date._year ? this._year - date._year : this._month !== date._month ? this.monthOfYear() - date.monthOfYear() : this._day - date._day;
	                return c === 0 ? 0 : c < 0 ? -1 : 1;
	              },
	              /** Retrieve the calendar backing this date.
	                  @memberof CDate
	                  @return {BaseCalendar} The calendar implementation. */
	              calendar: function() {
	                return this._calendar;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof CDate
	                  @return {number} The equivalent Julian date. */
	              toJD: function() {
	                return this._calendar.toJD(this);
	              },
	              /** Create a new date from a Julian date.
	                  @memberof CDate
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                return this._calendar.fromJD(jd);
	              },
	              /** Convert this date to a standard (Gregorian) JavaScript Date.
	                  @memberof CDate
	                  @return {Date} The equivalent JavaScript date. */
	              toJSDate: function() {
	                return this._calendar.toJSDate(this);
	              },
	              /** Create a new date from a standard (Gregorian) JavaScript Date.
	                  @memberof CDate
	                  @param jsd {Date} The JavaScript date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJSDate: function(jsd) {
	                return this._calendar.fromJSDate(jsd);
	              },
	              /** Convert to a string for display.
	                  @memberof CDate
	                  @return {string} This date as a string. */
	              toString: function() {
	                return (this.year() < 0 ? "-" : "") + pad(Math.abs(this.year()), 4) + "-" + pad(this.month(), 2) + "-" + pad(this.day(), 2);
	              }
	            });
	            function BaseCalendar() {
	              this.shortYearCutoff = "+10";
	            }
	            assign(BaseCalendar.prototype, {
	              _validateLevel: 0,
	              // "Stack" to turn validation on/off
	              /** Create a new date within this calendar - today if no parameters given.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to duplicate or the year for the date.
	                  @param [month] {number} The month for the date.
	                  @param [day] {number} The day for the date.
	                  @return {CDate} The new date.
	                  @throws Error if not a valid date or a different calendar used. */
	              newDate: function(year, month, day) {
	                if (year == null) {
	                  return this.today();
	                }
	                if (year.year) {
	                  this._validate(
	                    year,
	                    month,
	                    day,
	                    _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                  );
	                  day = year.day();
	                  month = year.month();
	                  year = year.year();
	                }
	                return new CDate(this, year, month, day);
	              },
	              /** Create a new date for today.
	                  @memberof BaseCalendar
	                  @return {CDate} Today's date. */
	              today: function() {
	                return this.fromJSDate(/* @__PURE__ */ new Date());
	              },
	              /** Retrieve the epoch designator for this date.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {string} The current epoch.
	                  @throws Error if an invalid year or a different calendar used. */
	              epoch: function(year) {
	                var date = this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidYear || _exports.regionalOptions[""].invalidYear
	                );
	                return date.year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
	              },
	              /** Format the year, if not a simple sequential number
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to format or the year to format.
	                  @return {string} The formatted year.
	                  @throws Error if an invalid year or a different calendar used. */
	              formatYear: function(year) {
	                var date = this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidYear || _exports.regionalOptions[""].invalidYear
	                );
	                return (date.year() < 0 ? "-" : "") + pad(Math.abs(date.year()), 4);
	              },
	              /** Retrieve the number of months in a year.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of months.
	                  @throws Error if an invalid year or a different calendar used. */
	              monthsInYear: function(year) {
	                this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidYear || _exports.regionalOptions[""].invalidYear
	                );
	                return 12;
	              },
	              /** Calculate the month's ordinal position within the year -
	                  for those calendars that don't start at month 1!
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param month {number} The month to examine.
	                  @return {number} The ordinal position, starting from <code>minMonth</code>.
	                  @throws Error if an invalid year/month or a different calendar used. */
	              monthOfYear: function(year, month) {
	                var date = this._validate(
	                  year,
	                  month,
	                  this.minDay,
	                  _exports.local.invalidMonth || _exports.regionalOptions[""].invalidMonth
	                );
	                return (date.month() + this.monthsInYear(date) - this.firstMonth) % this.monthsInYear(date) + this.minMonth;
	              },
	              /** Calculate actual month from ordinal position, starting from minMonth.
	                  @memberof BaseCalendar
	                  @param year {number} The year to examine.
	                  @param ord {number} The month's ordinal position.
	                  @return {number} The month's number.
	                  @throws Error if an invalid year/month. */
	              fromMonthOfYear: function(year, ord) {
	                var m = (ord + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(year) + this.minMonth;
	                this._validate(
	                  year,
	                  m,
	                  this.minDay,
	                  _exports.local.invalidMonth || _exports.regionalOptions[""].invalidMonth
	                );
	                return m;
	              },
	              /** Retrieve the number of days in a year.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {number} The number of days.
	                  @throws Error if an invalid year or a different calendar used. */
	              daysInYear: function(year) {
	                var date = this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidYear || _exports.regionalOptions[""].invalidYear
	                );
	                return this.leapYear(date) ? 366 : 365;
	              },
	              /** Retrieve the day of the year for a date.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The day of the year.
	                  @throws Error if an invalid date or a different calendar used. */
	              dayOfYear: function(year, month, day) {
	                var date = this._validate(
	                  year,
	                  month,
	                  day,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                return date.toJD() - this.newDate(
	                  date.year(),
	                  this.fromMonthOfYear(date.year(), this.minMonth),
	                  this.minDay
	                ).toJD() + 1;
	              },
	              /** Retrieve the number of days in a week.
	                  @memberof BaseCalendar
	                  @return {number} The number of days. */
	              daysInWeek: function() {
	                return 7;
	              },
	              /** Retrieve the day of the week for a date.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The day of the week: 0 to number of days - 1.
	                  @throws Error if an invalid date or a different calendar used. */
	              dayOfWeek: function(year, month, day) {
	                var date = this._validate(
	                  year,
	                  month,
	                  day,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                return (Math.floor(this.toJD(date)) + 2) % this.daysInWeek();
	              },
	              /** Retrieve additional information about a date.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {object} Additional information - contents depends on calendar.
	                  @throws Error if an invalid date or a different calendar used. */
	              extraInfo: function(year, month, day) {
	                this._validate(
	                  year,
	                  month,
	                  day,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                return {};
	              },
	              /** Add period(s) to a date.
	                  Cater for no year zero.
	                  @memberof BaseCalendar
	                  @param date {CDate} The starting date.
	                  @param offset {number} The number of periods to adjust by.
	                  @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	                  @return {CDate} The updated date.
	                  @throws Error if a different calendar used. */
	              add: function(date, offset, period) {
	                this._validate(
	                  date,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                return this._correctAdd(date, this._add(date, offset, period), offset, period);
	              },
	              /** Add period(s) to a date.
	                  @memberof BaseCalendar
	                  @private
	                  @param date {CDate} The starting date.
	                  @param offset {number} The number of periods to adjust by.
	                  @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	                  @return {CDate} The updated date. */
	              _add: function(date, offset, period) {
	                this._validateLevel++;
	                if (period === "d" || period === "w") {
	                  var jd = date.toJD() + offset * (period === "w" ? this.daysInWeek() : 1);
	                  var d = date.calendar().fromJD(jd);
	                  this._validateLevel--;
	                  return [d.year(), d.month(), d.day()];
	                }
	                try {
	                  var y = date.year() + (period === "y" ? offset : 0);
	                  var m = date.monthOfYear() + (period === "m" ? offset : 0);
	                  var d = date.day();
	                  var resyncYearMonth = function(calendar) {
	                    while (m < calendar.minMonth) {
	                      y--;
	                      m += calendar.monthsInYear(y);
	                    }
	                    var yearMonths = calendar.monthsInYear(y);
	                    while (m > yearMonths - 1 + calendar.minMonth) {
	                      y++;
	                      m -= yearMonths;
	                      yearMonths = calendar.monthsInYear(y);
	                    }
	                  };
	                  if (period === "y") {
	                    if (date.month() !== this.fromMonthOfYear(y, m)) {
	                      m = this.newDate(y, date.month(), this.minDay).monthOfYear();
	                    }
	                    m = Math.min(m, this.monthsInYear(y));
	                    d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
	                  } else if (period === "m") {
	                    resyncYearMonth(this);
	                    d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
	                  }
	                  var ymd = [y, this.fromMonthOfYear(y, m), d];
	                  this._validateLevel--;
	                  return ymd;
	                } catch (e) {
	                  this._validateLevel--;
	                  throw e;
	                }
	              },
	              /** Correct a candidate date after adding period(s) to a date.
	                  Handle no year zero if necessary.
	                  @memberof BaseCalendar
	                  @private
	                  @param date {CDate} The starting date.
	                  @param ymd {number[]} The added date.
	                  @param offset {number} The number of periods to adjust by.
	                  @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
	                  @return {CDate} The updated date. */
	              _correctAdd: function(date, ymd, offset, period) {
	                if (!this.hasYearZero && (period === "y" || period === "m")) {
	                  if (ymd[0] === 0 || // In year zero
	                  date.year() > 0 !== ymd[0] > 0) {
	                    var adj = {
	                      y: [1, 1, "y"],
	                      m: [1, this.monthsInYear(-1), "m"],
	                      w: [this.daysInWeek(), this.daysInYear(-1), "d"],
	                      d: [1, this.daysInYear(-1), "d"]
	                    }[period];
	                    var dir = offset < 0 ? -1 : 1;
	                    ymd = this._add(date, offset * adj[0] + dir * adj[1], adj[2]);
	                  }
	                }
	                return date.date(ymd[0], ymd[1], ymd[2]);
	              },
	              /** Set a portion of the date.
	                  @memberof BaseCalendar
	                  @param date {CDate} The starting date.
	                  @param value {number} The new value for the period.
	                  @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
	                  @return {CDate} The updated date.
	                  @throws Error if an invalid date or a different calendar used. */
	              set: function(date, value, period) {
	                this._validate(
	                  date,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                var y = period === "y" ? value : date.year();
	                var m = period === "m" ? value : date.month();
	                var d = period === "d" ? value : date.day();
	                if (period === "y" || period === "m") {
	                  d = Math.min(d, this.daysInMonth(y, m));
	                }
	                return date.date(y, m, d);
	              },
	              /** Determine whether a date is valid for this calendar.
	                  @memberof BaseCalendar
	                  @param year {number} The year to examine.
	                  @param month {number} The month to examine.
	                  @param day {number} The day to examine.
	                  @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
	              isValid: function(year, month, day) {
	                this._validateLevel++;
	                var valid = this.hasYearZero || year !== 0;
	                if (valid) {
	                  var date = this.newDate(year, month, this.minDay);
	                  valid = month >= this.minMonth && month - this.minMonth < this.monthsInYear(date) && (day >= this.minDay && day - this.minDay < this.daysInMonth(date));
	                }
	                this._validateLevel--;
	                return valid;
	              },
	              /** Convert the date to a standard (Gregorian) JavaScript Date.
	                  @memberof BaseCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {Date} The equivalent JavaScript date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJSDate: function(year, month, day) {
	                var date = this._validate(
	                  year,
	                  month,
	                  day,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                return _exports.instance().fromJD(this.toJD(date)).toJSDate();
	              },
	              /** Convert the date from a standard (Gregorian) JavaScript Date.
	                  @memberof BaseCalendar
	                  @param jsd {Date} The JavaScript date.
	                  @return {CDate} The equivalent calendar date. */
	              fromJSDate: function(jsd) {
	                return this.fromJD(_exports.instance().fromJSDate(jsd).toJD());
	              },
	              /** Check that a candidate date is from the same calendar and is valid.
	                  @memberof BaseCalendar
	                  @private
	                  @param year {CDate|number} The date to validate or the year to validate.
	                  @param [month] {number} The month to validate.
	                  @param [day] {number} The day to validate.
	                  @param error {string} Rrror message if invalid.
	                  @throws Error if different calendars used or invalid date. */
	              _validate: function(year, month, day, error) {
	                if (year.year) {
	                  if (this._validateLevel === 0 && this.name !== year.calendar().name) {
	                    throw (_exports.local.differentCalendars || _exports.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, year.calendar().local.name);
	                  }
	                  return year;
	                }
	                try {
	                  this._validateLevel++;
	                  if (this._validateLevel === 1 && !this.isValid(year, month, day)) {
	                    throw error.replace(/\{0\}/, this.local.name);
	                  }
	                  var date = this.newDate(year, month, day);
	                  this._validateLevel--;
	                  return date;
	                } catch (e) {
	                  this._validateLevel--;
	                  throw e;
	                }
	              }
	            });
	            function GregorianCalendar(language) {
	              this.local = this.regionalOptions[language] || this.regionalOptions[""];
	            }
	            GregorianCalendar.prototype = new BaseCalendar();
	            assign(GregorianCalendar.prototype, {
	              /** The calendar name.
	                  @memberof GregorianCalendar */
	              name: "Gregorian",
	              /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
	                 @memberof GregorianCalendar */
	              jdEpoch: 17214255e-1,
	              /** Days per month in a common year.
	                 @memberof GregorianCalendar */
	              daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	              /** <code>true</code> if has a year zero, <code>false</code> if not.
	                 @memberof GregorianCalendar */
	              hasYearZero: false,
	              /** The minimum month number.
	                  @memberof GregorianCalendar */
	              minMonth: 1,
	              /** The first month in the year.
	                  @memberof GregorianCalendar */
	              firstMonth: 1,
	              /** The minimum day number.
	                 @memberof GregorianCalendar */
	              minDay: 1,
	              /** Localisations for the plugin.
	                  Entries are objects indexed by the language code ('' being the default US/English).
	                  Each object has the following attributes.
	                  @memberof GregorianCalendar
	                  @property name {string} The calendar name.
	                  @property epochs {string[]} The epoch names.
	                  @property monthNames {string[]} The long names of the months of the year.
	                  @property monthNamesShort {string[]} The short names of the months of the year.
	                  @property dayNames {string[]} The long names of the days of the week.
	                  @property dayNamesShort {string[]} The short names of the days of the week.
	                  @property dayNamesMin {string[]} The minimal names of the days of the week.
	                  @property dateFormat {string} The date format for this calendar.
	                          See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
	                  @property firstDay {number} The number of the first day of the week, starting at 0.
	                  @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
	              regionalOptions: {
	                // Localisations
	                "": {
	                  name: "Gregorian",
	                  epochs: ["BCE", "CE"],
	                  monthNames: [
	                    "January",
	                    "February",
	                    "March",
	                    "April",
	                    "May",
	                    "June",
	                    "July",
	                    "August",
	                    "September",
	                    "October",
	                    "November",
	                    "December"
	                  ],
	                  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	                  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	                  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	                  digits: null,
	                  dateFormat: "mm/dd/yyyy",
	                  firstDay: 0,
	                  isRTL: false
	                }
	              },
	              /** Determine whether this date is in a leap year.
	                  @memberof GregorianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
	                  @throws Error if an invalid year or a different calendar used. */
	              leapYear: function(year) {
	                var date = this._validate(
	                  year,
	                  this.minMonth,
	                  this.minDay,
	                  _exports.local.invalidYear || _exports.regionalOptions[""].invalidYear
	                );
	                var year = date.year() + (date.year() < 0 ? 1 : 0);
	                return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
	              },
	              /** Determine the week of the year for a date - ISO 8601.
	                  @memberof GregorianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {number} The week of the year, starting from 1.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekOfYear: function(year, month, day) {
	                var checkDate = this.newDate(year, month, day);
	                checkDate.add(4 - (checkDate.dayOfWeek() || 7), "d");
	                return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
	              },
	              /** Retrieve the number of days in a month.
	                  @memberof GregorianCalendar
	                  @param year {CDate|number} The date to examine or the year of the month.
	                  @param [month] {number} The month.
	                  @return {number} The number of days in this month.
	                  @throws Error if an invalid month/year or a different calendar used. */
	              daysInMonth: function(year, month) {
	                var date = this._validate(
	                  year,
	                  month,
	                  this.minDay,
	                  _exports.local.invalidMonth || _exports.regionalOptions[""].invalidMonth
	                );
	                return this.daysPerMonth[date.month() - 1] + (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
	              },
	              /** Determine whether this date is a week day.
	                  @memberof GregorianCalendar
	                  @param year {CDate|number} The date to examine or the year to examine.
	                  @param [month] {number} The month to examine.
	                  @param [day] {number} The day to examine.
	                  @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
	                  @throws Error if an invalid date or a different calendar used. */
	              weekDay: function(year, month, day) {
	                return (this.dayOfWeek(year, month, day) || 7) < 6;
	              },
	              /** Retrieve the Julian date equivalent for this date,
	                  i.e. days since January 1, 4713 BCE Greenwich noon.
	                  @memberof GregorianCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {number} The equivalent Julian date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJD: function(year, month, day) {
	                var date = this._validate(
	                  year,
	                  month,
	                  day,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                year = date.year();
	                month = date.month();
	                day = date.day();
	                if (year < 0) {
	                  year++;
	                }
	                if (month < 3) {
	                  month += 12;
	                  year--;
	                }
	                var a = Math.floor(year / 100);
	                var b = 2 - a + Math.floor(a / 4);
	                return Math.floor(365.25 * (year + 4716)) + Math.floor(30.6001 * (month + 1)) + day + b - 1524.5;
	              },
	              /** Create a new date from a Julian date.
	                  @memberof GregorianCalendar
	                  @param jd {number} The Julian date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJD: function(jd) {
	                var z = Math.floor(jd + 0.5);
	                var a = Math.floor((z - 186721625e-2) / 36524.25);
	                a = z + 1 + a - Math.floor(a / 4);
	                var b = a + 1524;
	                var c = Math.floor((b - 122.1) / 365.25);
	                var d = Math.floor(365.25 * c);
	                var e = Math.floor((b - d) / 30.6001);
	                var day = b - d - Math.floor(e * 30.6001);
	                var month = e - (e > 13.5 ? 13 : 1);
	                var year = c - (month > 2.5 ? 4716 : 4715);
	                if (year <= 0) {
	                  year--;
	                }
	                return this.newDate(year, month, day);
	              },
	              /** Convert this date to a standard (Gregorian) JavaScript Date.
	                  @memberof GregorianCalendar
	                  @param year {CDate|number} The date to convert or the year to convert.
	                  @param [month] {number} The month to convert.
	                  @param [day] {number} The day to convert.
	                  @return {Date} The equivalent JavaScript date.
	                  @throws Error if an invalid date or a different calendar used. */
	              toJSDate: function(year, month, day) {
	                var date = this._validate(
	                  year,
	                  month,
	                  day,
	                  _exports.local.invalidDate || _exports.regionalOptions[""].invalidDate
	                );
	                var jsd = new Date(date.year(), date.month() - 1, date.day());
	                jsd.setHours(0);
	                jsd.setMinutes(0);
	                jsd.setSeconds(0);
	                jsd.setMilliseconds(0);
	                jsd.setHours(jsd.getHours() > 12 ? jsd.getHours() + 2 : 0);
	                return jsd;
	              },
	              /** Create a new date from a standard (Gregorian) JavaScript Date.
	                  @memberof GregorianCalendar
	                  @param jsd {Date} The JavaScript date to convert.
	                  @return {CDate} The equivalent date. */
	              fromJSDate: function(jsd) {
	                return this.newDate(jsd.getFullYear(), jsd.getMonth() + 1, jsd.getDate());
	              }
	            });
	            var _exports = module2.exports = new Calendars();
	            _exports.cdate = CDate;
	            _exports.baseCalendar = BaseCalendar;
	            _exports.calendars.gregorian = GregorianCalendar;
	          }
	        ),
	        /***/
	        94338: (
	          /***/
	          function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__2) {
	            var assign = __webpack_require__2(56131);
	            var main = __webpack_require__2(63489);
	            assign(main.regionalOptions[""], {
	              invalidArguments: "Invalid arguments",
	              invalidFormat: "Cannot format a date from another calendar",
	              missingNumberAt: "Missing number at position {0}",
	              unknownNameAt: "Unknown name at position {0}",
	              unexpectedLiteralAt: "Unexpected literal at position {0}",
	              unexpectedText: "Additional text found at end"
	            });
	            main.local = main.regionalOptions[""];
	            assign(main.cdate.prototype, {
	              /** Format this date.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof CDate
	                  @param [format] {string} The date format to use (see <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a>).
	                  @param [settings] {object} Options for the <code>formatDate</code> function.
	                  @return {string} The formatted date. */
	              formatDate: function(format, settings) {
	                if (typeof format !== "string") {
	                  settings = format;
	                  format = "";
	                }
	                return this._calendar.formatDate(format || "", this, settings);
	              }
	            });
	            assign(main.baseCalendar.prototype, {
	              UNIX_EPOCH: main.instance().newDate(1970, 1, 1).toJD(),
	              SECS_PER_DAY: 24 * 60 * 60,
	              TICKS_EPOCH: main.instance().jdEpoch,
	              // 1 January 0001 CE
	              TICKS_PER_DAY: 24 * 60 * 60 * 1e7,
	              /** Date form for ATOM (RFC 3339/ISO 8601).
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              ATOM: "yyyy-mm-dd",
	              /** Date form for cookies.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              COOKIE: "D, dd M yyyy",
	              /** Date form for full date.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              FULL: "DD, MM d, yyyy",
	              /** Date form for ISO 8601.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              ISO_8601: "yyyy-mm-dd",
	              /** Date form for Julian date.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              JULIAN: "J",
	              /** Date form for RFC 822.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              RFC_822: "D, d M yy",
	              /** Date form for RFC 850.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              RFC_850: "DD, dd-M-yy",
	              /** Date form for RFC 1036.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              RFC_1036: "D, d M yy",
	              /** Date form for RFC 1123.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              RFC_1123: "D, d M yyyy",
	              /** Date form for RFC 2822.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              RFC_2822: "D, d M yyyy",
	              /** Date form for RSS (RFC 822).
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              RSS: "D, d M yy",
	              /** Date form for Windows ticks.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              TICKS: "!",
	              /** Date form for Unix timestamp.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              TIMESTAMP: "@",
	              /** Date form for W3c (ISO 8601).
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar */
	              W3C: "yyyy-mm-dd",
	              /** Format a date object into a string value.
	                  The format can be combinations of the following:
	                  <ul>
	                  <li>d  - day of month (no leading zero)</li>
	                  <li>dd - day of month (two digit)</li>
	                  <li>o  - day of year (no leading zeros)</li>
	                  <li>oo - day of year (three digit)</li>
	                  <li>D  - day name short</li>
	                  <li>DD - day name long</li>
	                  <li>w  - week of year (no leading zero)</li>
	                  <li>ww - week of year (two digit)</li>
	                  <li>m  - month of year (no leading zero)</li>
	                  <li>mm - month of year (two digit)</li>
	                  <li>M  - month name short</li>
	                  <li>MM - month name long</li>
	                  <li>yy - year (two digit)</li>
	                  <li>yyyy - year (four digit)</li>
	                  <li>YYYY - formatted year</li>
	                  <li>J  - Julian date (days since January 1, 4713 BCE Greenwich noon)</li>
	                  <li>@  - Unix timestamp (s since 01/01/1970)</li>
	                  <li>!  - Windows ticks (100ns since 01/01/0001)</li>
	                  <li>'...' - literal text</li>
	                  <li>'' - single quote</li>
	                  </ul>
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar
	                  @param [format] {string} The desired format of the date (defaults to calendar format).
	                  @param date {CDate} The date value to format.
	                  @param [settings] {object} Addition options, whose attributes include:
	                  @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
	                  @property [dayNames] {string[]} Names of the days from Sunday.
	                  @property [monthNamesShort] {string[]} Abbreviated names of the months.
	                  @property [monthNames] {string[]} Names of the months.
	                  @property [calculateWeek] {CalendarsPickerCalculateWeek} Function that determines week of the year.
	                  @property [localNumbers=false] {boolean} <code>true</code> to localise numbers (if available),
	                            <code>false</code> to use normal Arabic numerals.
	                  @return {string} The date in the above format.
	                  @throws Errors if the date is from a different calendar. */
	              formatDate: function(format, date, settings) {
	                if (typeof format !== "string") {
	                  settings = date;
	                  date = format;
	                  format = "";
	                }
	                if (!date) {
	                  return "";
	                }
	                if (date.calendar() !== this) {
	                  throw main.local.invalidFormat || main.regionalOptions[""].invalidFormat;
	                }
	                format = format || this.local.dateFormat;
	                settings = settings || {};
	                var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
	                var dayNames = settings.dayNames || this.local.dayNames;
	                var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
	                var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
	                var monthNames = settings.monthNames || this.local.monthNames;
	                settings.calculateWeek || this.local.calculateWeek;
	                var doubled = function(match, step) {
	                  var matches = 1;
	                  while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
	                    matches++;
	                  }
	                  iFormat += matches - 1;
	                  return Math.floor(matches / (step || 1)) > 1;
	                };
	                var formatNumber = function(match, value, len, step) {
	                  var num = "" + value;
	                  if (doubled(match, step)) {
	                    while (num.length < len) {
	                      num = "0" + num;
	                    }
	                  }
	                  return num;
	                };
	                var formatName = function(match, value, shortNames, longNames) {
	                  return doubled(match) ? longNames[value] : shortNames[value];
	                };
	                var calendar = this;
	                var formatMonth = function(date2) {
	                  return typeof monthNumbers === "function" ? monthNumbers.call(calendar, date2, doubled("m")) : localiseNumbers(formatNumber("m", date2.month(), 2));
	                };
	                var formatMonthName = function(date2, useLongName) {
	                  if (useLongName) {
	                    return typeof monthNames === "function" ? monthNames.call(calendar, date2) : monthNames[date2.month() - calendar.minMonth];
	                  } else {
	                    return typeof monthNamesShort === "function" ? monthNamesShort.call(calendar, date2) : monthNamesShort[date2.month() - calendar.minMonth];
	                  }
	                };
	                var digits = this.local.digits;
	                var localiseNumbers = function(value) {
	                  return settings.localNumbers && digits ? digits(value) : value;
	                };
	                var output = "";
	                var literal = false;
	                for (var iFormat = 0; iFormat < format.length; iFormat++) {
	                  if (literal) {
	                    if (format.charAt(iFormat) === "'" && !doubled("'")) {
	                      literal = false;
	                    } else {
	                      output += format.charAt(iFormat);
	                    }
	                  } else {
	                    switch (format.charAt(iFormat)) {
	                      case "d":
	                        output += localiseNumbers(formatNumber("d", date.day(), 2));
	                        break;
	                      case "D":
	                        output += formatName(
	                          "D",
	                          date.dayOfWeek(),
	                          dayNamesShort,
	                          dayNames
	                        );
	                        break;
	                      case "o":
	                        output += formatNumber("o", date.dayOfYear(), 3);
	                        break;
	                      case "w":
	                        output += formatNumber("w", date.weekOfYear(), 2);
	                        break;
	                      case "m":
	                        output += formatMonth(date);
	                        break;
	                      case "M":
	                        output += formatMonthName(date, doubled("M"));
	                        break;
	                      case "y":
	                        output += doubled("y", 2) ? date.year() : (date.year() % 100 < 10 ? "0" : "") + date.year() % 100;
	                        break;
	                      case "Y":
	                        doubled("Y", 2);
	                        output += date.formatYear();
	                        break;
	                      case "J":
	                        output += date.toJD();
	                        break;
	                      case "@":
	                        output += (date.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
	                        break;
	                      case "!":
	                        output += (date.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
	                        break;
	                      case "'":
	                        if (doubled("'")) {
	                          output += "'";
	                        } else {
	                          literal = true;
	                        }
	                        break;
	                      default:
	                        output += format.charAt(iFormat);
	                    }
	                  }
	                }
	                return output;
	              },
	              /** Parse a string value into a date object.
	                  See <a href="#formatDate"><code>formatDate</code></a> for the possible formats, plus:
	                  <ul>
	                  <li>* - ignore rest of string</li>
	                  </ul>
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar
	                  @param format {string} The expected format of the date ('' for default calendar format).
	                  @param value {string} The date in the above format.
	                  @param [settings] {object} Additional options whose attributes include:
	                  @property [shortYearCutoff] {number} The cutoff year for determining the century.
	                  @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
	                  @property [dayNames] {string[]} Names of the days from Sunday.
	                  @property [monthNamesShort] {string[]} Abbreviated names of the months.
	                  @property [monthNames] {string[]} Names of the months.
	                  @return {CDate} The extracted date value or <code>null</code> if value is blank.
	                  @throws Errors if the format and/or value are missing,
	                          if the value doesn't match the format, or if the date is invalid. */
	              parseDate: function(format, value, settings) {
	                if (value == null) {
	                  throw main.local.invalidArguments || main.regionalOptions[""].invalidArguments;
	                }
	                value = typeof value === "object" ? value.toString() : value + "";
	                if (value === "") {
	                  return null;
	                }
	                format = format || this.local.dateFormat;
	                settings = settings || {};
	                var shortYearCutoff = settings.shortYearCutoff || this.shortYearCutoff;
	                shortYearCutoff = typeof shortYearCutoff !== "string" ? shortYearCutoff : this.today().year() % 100 + parseInt(shortYearCutoff, 10);
	                var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
	                var dayNames = settings.dayNames || this.local.dayNames;
	                var parseMonth = settings.parseMonth || this.local.parseMonth;
	                var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
	                var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
	                var monthNames = settings.monthNames || this.local.monthNames;
	                var jd = -1;
	                var year = -1;
	                var month = -1;
	                var day = -1;
	                var doy = -1;
	                var shortYear = false;
	                var literal = false;
	                var doubled = function(match, step) {
	                  var matches = 1;
	                  while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
	                    matches++;
	                  }
	                  iFormat += matches - 1;
	                  return Math.floor(matches / (step || 1)) > 1;
	                };
	                var getNumber = function(match, step) {
	                  var isDoubled = doubled(match, step);
	                  var size = [2, 3, isDoubled ? 4 : 2, isDoubled ? 4 : 2, 10, 11, 20]["oyYJ@!".indexOf(match) + 1];
	                  var digits = new RegExp("^-?\\d{1," + size + "}");
	                  var num = value.substring(iValue).match(digits);
	                  if (!num) {
	                    throw (main.local.missingNumberAt || main.regionalOptions[""].missingNumberAt).replace(/\{0\}/, iValue);
	                  }
	                  iValue += num[0].length;
	                  return parseInt(num[0], 10);
	                };
	                var calendar = this;
	                var getMonthNumber = function() {
	                  if (typeof monthNumbers === "function") {
	                    doubled("m");
	                    var month2 = monthNumbers.call(calendar, value.substring(iValue));
	                    iValue += month2.length;
	                    return month2;
	                  }
	                  return getNumber("m");
	                };
	                var getName = function(match, shortNames, longNames, step) {
	                  var names = doubled(match, step) ? longNames : shortNames;
	                  for (var i = 0; i < names.length; i++) {
	                    if (value.substr(iValue, names[i].length).toLowerCase() === names[i].toLowerCase()) {
	                      iValue += names[i].length;
	                      return i + calendar.minMonth;
	                    }
	                  }
	                  throw (main.local.unknownNameAt || main.regionalOptions[""].unknownNameAt).replace(/\{0\}/, iValue);
	                };
	                var getMonthName = function() {
	                  if (typeof monthNames === "function") {
	                    var month2 = doubled("M") ? monthNames.call(calendar, value.substring(iValue)) : monthNamesShort.call(calendar, value.substring(iValue));
	                    iValue += month2.length;
	                    return month2;
	                  }
	                  return getName("M", monthNamesShort, monthNames);
	                };
	                var checkLiteral = function() {
	                  if (value.charAt(iValue) !== format.charAt(iFormat)) {
	                    throw (main.local.unexpectedLiteralAt || main.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, iValue);
	                  }
	                  iValue++;
	                };
	                var iValue = 0;
	                for (var iFormat = 0; iFormat < format.length; iFormat++) {
	                  if (literal) {
	                    if (format.charAt(iFormat) === "'" && !doubled("'")) {
	                      literal = false;
	                    } else {
	                      checkLiteral();
	                    }
	                  } else {
	                    switch (format.charAt(iFormat)) {
	                      case "d":
	                        day = getNumber("d");
	                        break;
	                      case "D":
	                        getName("D", dayNamesShort, dayNames);
	                        break;
	                      case "o":
	                        doy = getNumber("o");
	                        break;
	                      case "w":
	                        getNumber("w");
	                        break;
	                      case "m":
	                        month = getMonthNumber();
	                        break;
	                      case "M":
	                        month = getMonthName();
	                        break;
	                      case "y":
	                        var iSave = iFormat;
	                        shortYear = !doubled("y", 2);
	                        iFormat = iSave;
	                        year = getNumber("y", 2);
	                        break;
	                      case "Y":
	                        year = getNumber("Y", 2);
	                        break;
	                      case "J":
	                        jd = getNumber("J") + 0.5;
	                        if (value.charAt(iValue) === ".") {
	                          iValue++;
	                          getNumber("J");
	                        }
	                        break;
	                      case "@":
	                        jd = getNumber("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
	                        break;
	                      case "!":
	                        jd = getNumber("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
	                        break;
	                      case "*":
	                        iValue = value.length;
	                        break;
	                      case "'":
	                        if (doubled("'")) {
	                          checkLiteral();
	                        } else {
	                          literal = true;
	                        }
	                        break;
	                      default:
	                        checkLiteral();
	                    }
	                  }
	                }
	                if (iValue < value.length) {
	                  throw main.local.unexpectedText || main.regionalOptions[""].unexpectedText;
	                }
	                if (year === -1) {
	                  year = this.today().year();
	                } else if (year < 100 && shortYear) {
	                  year += shortYearCutoff === -1 ? 1900 : this.today().year() - this.today().year() % 100 - (year <= shortYearCutoff ? 0 : 100);
	                }
	                if (typeof month === "string") {
	                  month = parseMonth.call(this, year, month);
	                }
	                if (doy > -1) {
	                  month = 1;
	                  day = doy;
	                  for (var dim = this.daysInMonth(year, month); day > dim; dim = this.daysInMonth(year, month)) {
	                    month++;
	                    day -= dim;
	                  }
	                }
	                return jd > -1 ? this.fromJD(jd) : this.newDate(year, month, day);
	              },
	              /** A date may be specified as an exact value or a relative one.
	                  Found in the <code>jquery.calendars.plus.js</code> module.
	                  @memberof BaseCalendar
	                  @param dateSpec {CDate|number|string} The date as an object or string in the given format or
	                          an offset - numeric days from today, or string amounts and periods, e.g. '+1m +2w'.
	                  @param defaultDate {CDate} The date to use if no other supplied, may be <code>null</code>.
	                  @param currentDate {CDate} The current date as a possible basis for relative dates,
	                          if <code>null</code> today is used (optional)
	                  @param [dateFormat] {string} The expected date format - see <a href="#formatDate"><code>formatDate</code></a>.
	                  @param [settings] {object} Additional options whose attributes include:
	                  @property [shortYearCutoff] {number} The cutoff year for determining the century.
	                  @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
	                  @property [dayNames] {string[]} Names of the days from Sunday.
	                  @property [monthNamesShort] {string[]} Abbreviated names of the months.
	                  @property [monthNames] {string[]} Names of the months.
	                  @return {CDate} The decoded date. */
	              determineDate: function(dateSpec, defaultDate, currentDate, dateFormat, settings) {
	                if (currentDate && typeof currentDate !== "object") {
	                  settings = dateFormat;
	                  dateFormat = currentDate;
	                  currentDate = null;
	                }
	                if (typeof dateFormat !== "string") {
	                  settings = dateFormat;
	                  dateFormat = "";
	                }
	                var calendar = this;
	                var offsetString = function(offset) {
	                  try {
	                    return calendar.parseDate(dateFormat, offset, settings);
	                  } catch (e) {
	                  }
	                  offset = offset.toLowerCase();
	                  var date = (offset.match(/^c/) && currentDate ? currentDate.newDate() : null) || calendar.today();
	                  var pattern = /([+-]?[0-9]+)\s*(d|w|m|y)?/g;
	                  var matches = pattern.exec(offset);
	                  while (matches) {
	                    date.add(parseInt(matches[1], 10), matches[2] || "d");
	                    matches = pattern.exec(offset);
	                  }
	                  return date;
	                };
	                defaultDate = defaultDate ? defaultDate.newDate() : null;
	                dateSpec = dateSpec == null ? defaultDate : typeof dateSpec === "string" ? offsetString(dateSpec) : typeof dateSpec === "number" ? isNaN(dateSpec) || dateSpec === Infinity || dateSpec === -Infinity ? defaultDate : calendar.today().add(dateSpec, "d") : calendar.newDate(dateSpec);
	                return dateSpec;
	              }
	            });
	          }
	        ),
	        /***/
	        69862: (
	          /***/
	          function() {
	          }
	        ),
	        /***/
	        40964: (
	          /***/
	          function() {
	          }
	        ),
	        /***/
	        72077: (
	          /***/
	          function(module2, __unused_webpack_exports, __webpack_require__2) {
	            var possibleNames = [
	              "BigInt64Array",
	              "BigUint64Array",
	              "Float32Array",
	              "Float64Array",
	              "Int16Array",
	              "Int32Array",
	              "Int8Array",
	              "Uint16Array",
	              "Uint32Array",
	              "Uint8Array",
	              "Uint8ClampedArray"
	            ];
	            var g = typeof globalThis === "undefined" ? __webpack_require__2.g : globalThis;
	            module2.exports = function availableTypedArrays() {
	              var out = [];
	              for (var i = 0; i < possibleNames.length; i++) {
	                if (typeof g[possibleNames[i]] === "function") {
	                  out[out.length] = possibleNames[i];
	                }
	              }
	              return out;
	            };
	          }
	        ),
	        /***/
	        81684: (
	          /***/
	          function(__unused_webpack___webpack_module__, __webpack_exports__2, __webpack_require__2) {
	            __webpack_require__2.d(__webpack_exports__2, {
	              sX: function() {
	                return (
	                  /* reexport */
	                  value
	                );
	              },
	              k4: function() {
	                return (
	                  /* reexport */
	                  number2
	                );
	              }
	            });
	            function src_define(constructor, factory, prototype) {
	              constructor.prototype = factory.prototype = prototype;
	              prototype.constructor = constructor;
	            }
	            function extend(parent, definition) {
	              var prototype = Object.create(parent.prototype);
	              for (var key in definition) prototype[key] = definition[key];
	              return prototype;
	            }
	            function Color() {
	            }
	            var _darker = 0.7;
	            var _brighter = 1 / _darker;
	            var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(".concat(reI, ",").concat(reI, ",").concat(reI, "\\)$")), reRgbPercent = new RegExp("^rgb\\(".concat(reP, ",").concat(reP, ",").concat(reP, "\\)$")), reRgbaInteger = new RegExp("^rgba\\(".concat(reI, ",").concat(reI, ",").concat(reI, ",").concat(reN, "\\)$")), reRgbaPercent = new RegExp("^rgba\\(".concat(reP, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$")), reHslPercent = new RegExp("^hsl\\(".concat(reN, ",").concat(reP, ",").concat(reP, "\\)$")), reHslaPercent = new RegExp("^hsla\\(".concat(reN, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$"));
	            var named = {
	              aliceblue: 15792383,
	              antiquewhite: 16444375,
	              aqua: 65535,
	              aquamarine: 8388564,
	              azure: 15794175,
	              beige: 16119260,
	              bisque: 16770244,
	              black: 0,
	              blanchedalmond: 16772045,
	              blue: 255,
	              blueviolet: 9055202,
	              brown: 10824234,
	              burlywood: 14596231,
	              cadetblue: 6266528,
	              chartreuse: 8388352,
	              chocolate: 13789470,
	              coral: 16744272,
	              cornflowerblue: 6591981,
	              cornsilk: 16775388,
	              crimson: 14423100,
	              cyan: 65535,
	              darkblue: 139,
	              darkcyan: 35723,
	              darkgoldenrod: 12092939,
	              darkgray: 11119017,
	              darkgreen: 25600,
	              darkgrey: 11119017,
	              darkkhaki: 12433259,
	              darkmagenta: 9109643,
	              darkolivegreen: 5597999,
	              darkorange: 16747520,
	              darkorchid: 10040012,
	              darkred: 9109504,
	              darksalmon: 15308410,
	              darkseagreen: 9419919,
	              darkslateblue: 4734347,
	              darkslategray: 3100495,
	              darkslategrey: 3100495,
	              darkturquoise: 52945,
	              darkviolet: 9699539,
	              deeppink: 16716947,
	              deepskyblue: 49151,
	              dimgray: 6908265,
	              dimgrey: 6908265,
	              dodgerblue: 2003199,
	              firebrick: 11674146,
	              floralwhite: 16775920,
	              forestgreen: 2263842,
	              fuchsia: 16711935,
	              gainsboro: 14474460,
	              ghostwhite: 16316671,
	              gold: 16766720,
	              goldenrod: 14329120,
	              gray: 8421504,
	              green: 32768,
	              greenyellow: 11403055,
	              grey: 8421504,
	              honeydew: 15794160,
	              hotpink: 16738740,
	              indianred: 13458524,
	              indigo: 4915330,
	              ivory: 16777200,
	              khaki: 15787660,
	              lavender: 15132410,
	              lavenderblush: 16773365,
	              lawngreen: 8190976,
	              lemonchiffon: 16775885,
	              lightblue: 11393254,
	              lightcoral: 15761536,
	              lightcyan: 14745599,
	              lightgoldenrodyellow: 16448210,
	              lightgray: 13882323,
	              lightgreen: 9498256,
	              lightgrey: 13882323,
	              lightpink: 16758465,
	              lightsalmon: 16752762,
	              lightseagreen: 2142890,
	              lightskyblue: 8900346,
	              lightslategray: 7833753,
	              lightslategrey: 7833753,
	              lightsteelblue: 11584734,
	              lightyellow: 16777184,
	              lime: 65280,
	              limegreen: 3329330,
	              linen: 16445670,
	              magenta: 16711935,
	              maroon: 8388608,
	              mediumaquamarine: 6737322,
	              mediumblue: 205,
	              mediumorchid: 12211667,
	              mediumpurple: 9662683,
	              mediumseagreen: 3978097,
	              mediumslateblue: 8087790,
	              mediumspringgreen: 64154,
	              mediumturquoise: 4772300,
	              mediumvioletred: 13047173,
	              midnightblue: 1644912,
	              mintcream: 16121850,
	              mistyrose: 16770273,
	              moccasin: 16770229,
	              navajowhite: 16768685,
	              navy: 128,
	              oldlace: 16643558,
	              olive: 8421376,
	              olivedrab: 7048739,
	              orange: 16753920,
	              orangered: 16729344,
	              orchid: 14315734,
	              palegoldenrod: 15657130,
	              palegreen: 10025880,
	              paleturquoise: 11529966,
	              palevioletred: 14381203,
	              papayawhip: 16773077,
	              peachpuff: 16767673,
	              peru: 13468991,
	              pink: 16761035,
	              plum: 14524637,
	              powderblue: 11591910,
	              purple: 8388736,
	              rebeccapurple: 6697881,
	              red: 16711680,
	              rosybrown: 12357519,
	              royalblue: 4286945,
	              saddlebrown: 9127187,
	              salmon: 16416882,
	              sandybrown: 16032864,
	              seagreen: 3050327,
	              seashell: 16774638,
	              sienna: 10506797,
	              silver: 12632256,
	              skyblue: 8900331,
	              slateblue: 6970061,
	              slategray: 7372944,
	              slategrey: 7372944,
	              snow: 16775930,
	              springgreen: 65407,
	              steelblue: 4620980,
	              tan: 13808780,
	              teal: 32896,
	              thistle: 14204888,
	              tomato: 16737095,
	              turquoise: 4251856,
	              violet: 15631086,
	              wheat: 16113331,
	              white: 16777215,
	              whitesmoke: 16119285,
	              yellow: 16776960,
	              yellowgreen: 10145074
	            };
	            src_define(Color, color, {
	              copy: function copy(channels) {
	                return Object.assign(new this.constructor(), this, channels);
	              },
	              displayable: function displayable() {
	                return this.rgb().displayable();
	              },
	              hex: color_formatHex,
	              // Deprecated! Use color.formatHex.
	              formatHex: color_formatHex,
	              formatHex8: color_formatHex8,
	              formatHsl: color_formatHsl,
	              formatRgb: color_formatRgb,
	              toString: color_formatRgb
	            });
	            function color_formatHex() {
	              return this.rgb().formatHex();
	            }
	            function color_formatHex8() {
	              return this.rgb().formatHex8();
	            }
	            function color_formatHsl() {
	              return hslConvert(this).formatHsl();
	            }
	            function color_formatRgb() {
	              return this.rgb().formatRgb();
	            }
	            function color(format) {
	              var m, l;
	              format = (format + "").trim().toLowerCase();
	              return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
	            }
	            function rgbn(n) {
	              return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
	            }
	            function rgba(r, g, b, a) {
	              if (a <= 0) r = g = b = NaN;
	              return new Rgb(r, g, b, a);
	            }
	            function rgbConvert(o) {
	              if (!(o instanceof Color)) o = color(o);
	              if (!o) return new Rgb();
	              o = o.rgb();
	              return new Rgb(o.r, o.g, o.b, o.opacity);
	            }
	            function color_rgb(r, g, b, opacity) {
	              return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	            }
	            function Rgb(r, g, b, opacity) {
	              this.r = +r;
	              this.g = +g;
	              this.b = +b;
	              this.opacity = +opacity;
	            }
	            src_define(Rgb, color_rgb, extend(Color, {
	              brighter: function brighter(k) {
	                k = k == null ? _brighter : Math.pow(_brighter, k);
	                return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	              },
	              darker: function darker(k) {
	                k = k == null ? _darker : Math.pow(_darker, k);
	                return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	              },
	              rgb: function rgb2() {
	                return this;
	              },
	              clamp: function clamp() {
	                return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
	              },
	              displayable: function displayable() {
	                return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
	              },
	              hex: rgb_formatHex,
	              // Deprecated! Use color.formatHex.
	              formatHex: rgb_formatHex,
	              formatHex8: rgb_formatHex8,
	              formatRgb: rgb_formatRgb,
	              toString: rgb_formatRgb
	            }));
	            function rgb_formatHex() {
	              return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b));
	            }
	            function rgb_formatHex8() {
	              return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b)).concat(hex((isNaN(this.opacity) ? 1 : this.opacity) * 255));
	            }
	            function rgb_formatRgb() {
	              var a = clampa(this.opacity);
	              return "".concat(a === 1 ? "rgb(" : "rgba(").concat(clampi(this.r), ", ").concat(clampi(this.g), ", ").concat(clampi(this.b)).concat(a === 1 ? ")" : ", ".concat(a, ")"));
	            }
	            function clampa(opacity) {
	              return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
	            }
	            function clampi(value2) {
	              return Math.max(0, Math.min(255, Math.round(value2) || 0));
	            }
	            function hex(value2) {
	              value2 = clampi(value2);
	              return (value2 < 16 ? "0" : "") + value2.toString(16);
	            }
	            function hsla(h, s, l, a) {
	              if (a <= 0) h = s = l = NaN;
	              else if (l <= 0 || l >= 1) h = s = NaN;
	              else if (s <= 0) h = NaN;
	              return new Hsl(h, s, l, a);
	            }
	            function hslConvert(o) {
	              if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	              if (!(o instanceof Color)) o = color(o);
	              if (!o) return new Hsl();
	              if (o instanceof Hsl) return o;
	              o = o.rgb();
	              var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
	              if (s) {
	                if (r === max) h = (g - b) / s + (g < b) * 6;
	                else if (g === max) h = (b - r) / s + 2;
	                else h = (r - g) / s + 4;
	                s /= l < 0.5 ? max + min : 2 - max - min;
	                h *= 60;
	              } else {
	                s = l > 0 && l < 1 ? 0 : h;
	              }
	              return new Hsl(h, s, l, o.opacity);
	            }
	            function hsl(h, s, l, opacity) {
	              return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	            }
	            function Hsl(h, s, l, opacity) {
	              this.h = +h;
	              this.s = +s;
	              this.l = +l;
	              this.opacity = +opacity;
	            }
	            src_define(Hsl, hsl, extend(Color, {
	              brighter: function brighter(k) {
	                k = k == null ? _brighter : Math.pow(_brighter, k);
	                return new Hsl(this.h, this.s, this.l * k, this.opacity);
	              },
	              darker: function darker(k) {
	                k = k == null ? _darker : Math.pow(_darker, k);
	                return new Hsl(this.h, this.s, this.l * k, this.opacity);
	              },
	              rgb: function rgb2() {
	                var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
	                return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
	              },
	              clamp: function clamp() {
	                return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
	              },
	              displayable: function displayable() {
	                return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
	              },
	              formatHsl: function formatHsl() {
	                var a = clampa(this.opacity);
	                return "".concat(a === 1 ? "hsl(" : "hsla(").concat(clamph(this.h), ", ").concat(clampt(this.s) * 100, "%, ").concat(clampt(this.l) * 100, "%").concat(a === 1 ? ")" : ", ".concat(a, ")"));
	              }
	            }));
	            function clamph(value2) {
	              value2 = (value2 || 0) % 360;
	              return value2 < 0 ? value2 + 360 : value2;
	            }
	            function clampt(value2) {
	              return Math.max(0, Math.min(1, value2 || 0));
	            }
	            function hsl2rgb(h, m1, m2) {
	              return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
	            }
	            var src_constant = function(x) {
	              return function() {
	                return x;
	              };
	            };
	            function linear(a, d) {
	              return function(t) {
	                return a + t * d;
	              };
	            }
	            function exponential(a, b, y) {
	              return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	                return Math.pow(a + t * b, y);
	              };
	            }
	            function gamma(y) {
	              return (y = +y) === 1 ? nogamma : function(a, b) {
	                return b - a ? exponential(a, b, y) : src_constant(isNaN(a) ? b : a);
	              };
	            }
	            function nogamma(a, b) {
	              var d = b - a;
	              return d ? linear(a, d) : src_constant(isNaN(a) ? b : a);
	            }
	            var rgb = function rgbGamma(y) {
	              var color2 = gamma(y);
	              function rgb2(start, end) {
	                var r = color2((start = color_rgb(start)).r, (end = color_rgb(end)).r), g = color2(start.g, end.g), b = color2(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
	                return function(t) {
	                  start.r = r(t);
	                  start.g = g(t);
	                  start.b = b(t);
	                  start.opacity = opacity(t);
	                  return start + "";
	                };
	              }
	              rgb2.gamma = rgbGamma;
	              return rgb2;
	            }(1);
	            function genericArray(a, b) {
	              var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
	              for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	              for (; i < nb; ++i) c[i] = b[i];
	              return function(t) {
	                for (i = 0; i < na; ++i) c[i] = x[i](t);
	                return c;
	              };
	            }
	            function date(a, b) {
	              var d = /* @__PURE__ */ new Date();
	              return a = +a, b = +b, function(t) {
	                return d.setTime(a * (1 - t) + b * t), d;
	              };
	            }
	            function number2(a, b) {
	              return a = +a, b = +b, function(t) {
	                return a * (1 - t) + b * t;
	              };
	            }
	            function _typeof(obj) {
	              "@babel/helpers - typeof";
	              return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
	                return typeof obj2;
	              } : function(obj2) {
	                return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	              }, _typeof(obj);
	            }
	            function object(a, b) {
	              var i = {}, c = {}, k;
	              if (a === null || _typeof(a) !== "object") a = {};
	              if (b === null || _typeof(b) !== "object") b = {};
	              for (k in b) {
	                if (k in a) {
	                  i[k] = value(a[k], b[k]);
	                } else {
	                  c[k] = b[k];
	                }
	              }
	              return function(t) {
	                for (k in i) c[k] = i[k](t);
	                return c;
	              };
	            }
	            var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
	            function zero(b) {
	              return function() {
	                return b;
	              };
	            }
	            function one(b) {
	              return function(t) {
	                return b(t) + "";
	              };
	            }
	            function string(a, b) {
	              var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	              a = a + "", b = b + "";
	              while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
	                if ((bs = bm.index) > bi) {
	                  bs = b.slice(bi, bs);
	                  if (s[i]) s[i] += bs;
	                  else s[++i] = bs;
	                }
	                if ((am = am[0]) === (bm = bm[0])) {
	                  if (s[i]) s[i] += bm;
	                  else s[++i] = bm;
	                } else {
	                  s[++i] = null;
	                  q.push({
	                    i,
	                    x: number2(am, bm)
	                  });
	                }
	                bi = reB.lastIndex;
	              }
	              if (bi < b.length) {
	                bs = b.slice(bi);
	                if (s[i]) s[i] += bs;
	                else s[++i] = bs;
	              }
	              return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
	                for (var i2 = 0, o; i2 < b; ++i2) s[(o = q[i2]).i] = o.x(t);
	                return s.join("");
	              });
	            }
	            function src_numberArray(a, b) {
	              if (!b) b = [];
	              var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
	              return function(t) {
	                for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	                return c;
	              };
	            }
	            function numberArray_isNumberArray(x) {
	              return ArrayBuffer.isView(x) && !(x instanceof DataView);
	            }
	            function value_typeof(obj) {
	              "@babel/helpers - typeof";
	              return value_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
	                return typeof obj2;
	              } : function(obj2) {
	                return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
	              }, value_typeof(obj);
	            }
	            function value(a, b) {
	              var t = value_typeof(b), c;
	              return b == null || t === "boolean" ? src_constant(b) : (t === "number" ? number2 : t === "string" ? (c = color(b)) ? (b = c, rgb) : string : b instanceof color ? rgb : b instanceof Date ? date : numberArray_isNumberArray(b) ? src_numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object : number2)(a, b);
	            }
	          }
	        ),
	        /***/
	        40402: (
	          /***/
	          function(module2) {
	            module2.exports = JSON.parse('["xx-small","x-small","small","medium","large","x-large","xx-large","larger","smaller"]');
	          }
	        ),
	        /***/
	        83794: (
	          /***/
	          function(module2) {
	            module2.exports = JSON.parse('["normal","condensed","semi-condensed","extra-condensed","ultra-condensed","expanded","semi-expanded","extra-expanded","ultra-expanded"]');
	          }
	        ),
	        /***/
	        96209: (
	          /***/
	          function(module2) {
	            module2.exports = JSON.parse('["normal","italic","oblique"]');
	          }
	        ),
	        /***/
	        15659: (
	          /***/
	          function(module2) {
	            module2.exports = JSON.parse('["normal","bold","bolder","lighter","100","200","300","400","500","600","700","800","900"]');
	          }
	        ),
	        /***/
	        38732: (
	          /***/
	          function(module2) {
	            module2.exports = JSON.parse('["inherit","initial","unset"]');
	          }
	        ),
	        /***/
	        41901: (
	          /***/
	          function(module2) {
	            module2.exports = JSON.parse('["caption","icon","menu","message-box","small-caption","status-bar"]');
	          }
	        )
	        /******/
	      };
	      var __webpack_module_cache__ = {};
	      function __webpack_require__(moduleId) {
	        var cachedModule = __webpack_module_cache__[moduleId];
	        if (cachedModule !== undefined) {
	          return cachedModule.exports;
	        }
	        var module2 = __webpack_module_cache__[moduleId] = {
	          /******/
	          // no module.id needed
	          /******/
	          // no module.loaded needed
	          /******/
	          exports: {}
	          /******/
	        };
	        __webpack_modules__[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
	        return module2.exports;
	      }
	      !function() {
	        __webpack_require__.n = function(module2) {
	          var getter = module2 && module2.__esModule ? (
	            /******/
	            function() {
	              return module2["default"];
	            }
	          ) : (
	            /******/
	            function() {
	              return module2;
	            }
	          );
	          __webpack_require__.d(getter, { a: getter });
	          return getter;
	        };
	      }();
	      !function() {
	        __webpack_require__.d = function(exports2, definition) {
	          for (var key in definition) {
	            if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports2, key)) {
	              Object.defineProperty(exports2, key, { enumerable: true, get: definition[key] });
	            }
	          }
	        };
	      }();
	      !function() {
	        __webpack_require__.g = function() {
	          if (typeof globalThis === "object") return globalThis;
	          try {
	            return this || new Function("return this")();
	          } catch (e) {
	            if (typeof window === "object") return window;
	          }
	        }();
	      }();
	      !function() {
	        __webpack_require__.o = function(obj, prop) {
	          return Object.prototype.hasOwnProperty.call(obj, prop);
	        };
	      }();
	      !function() {
	        __webpack_require__.r = function(exports2) {
	          if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	            Object.defineProperty(exports2, Symbol.toStringTag, { value: "Module" });
	          }
	          Object.defineProperty(exports2, "__esModule", { value: true });
	        };
	      }();
	      var __webpack_exports__ = __webpack_require__(27909);
	      return __webpack_exports__;
	    }()
	  );
	}); 
} (plotly));

var plotlyExports = plotly.exports;

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = undefined;

	var _factory = _interopRequireDefault(factory);

	var _plotly = _interopRequireDefault(plotlyExports);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var PlotComponent = (0, _factory["default"])(_plotly["default"]);
	var _default = PlotComponent;
	exports["default"] = _default;
	
} (reactPlotly));

const Plot = /*@__PURE__*/getDefaultExportFromCjs(reactPlotly);

const styles$1 = `
.heading {
  width:30%;
}
.region {
  border-top:none !important;
}
`;
const RenderGraphData = (props) => {
  let responseArray = props.response.reply;
  let api = props.response?.api;
  useState(false);
  const regex2 = /plt\.title\('([^']+?)'\)/;
  const graphType = props.response.graphData.includes("pie");
  const match = props.response.graphData.match(/(px\.(\w+)|plt\.(\w+))/);
  const Title = props.response.graphData.match(regex2);
  React.useEffect(() => {
    props.setFeedbackButtonsVisible(true);
    props.enableSend();
    props.promptResult(true);
  }, []);
  useEffect(() => {
    const fluentAccordionItem = document.querySelectorAll(
      "fluent-accordion-item"
    );
    if (fluentAccordionItem.length > 0) {
      let style = document.createElement("style");
      style.innerHTML = styles$1;
      fluentAccordionItem[fluentAccordionItem.length - 1].shadowRoot.appendChild(style);
    }
  }, [props.response.query]);
  const config = {
    displaylogo: false,
    modeBarButtons: [["toImage"]]
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    props.response.rephrasedQuestion && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      "I assume you are asking about the",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: props.response.rephrasedQuestion })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        style: {
          maxWidth: props.isFullScreen ? "760px" : "400px",
          overflowX: "auto",
          marginTop: "15px"
        },
        children: api ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Plot,
          {
            data: responseArray.data,
            layout: { ...responseArray.layout, width: 600 },
            config
          }
        ) : !graphType ? /* @__PURE__ */ jsxRuntimeExports.jsx(BarChart, { chartData: responseArray, title: Title, match }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PieChart, { pieData: responseArray, title: Title, match })
      }
    )
  ] });
};
const BarChart = ({ chartData, title, match }) => {
  const filteredData = chartData.data.filter((item) => {
    const numericValue = Number(item[1]);
    const isNumeric = !isNaN(numericValue) && item[1] !== null;
    return isNumeric;
  });
  const config = {
    displaylogo: false,
    modeBarButtons: [["toImage"]]
  };
  const data = {
    x: filteredData.map((item) => item[0]),
    y: filteredData.map((item) => item[1]),
    type: match[2] || match[3]
  };
  const layout = { width: "500px", height: "200px" };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Plot, { data: [data], layout, config }) });
};
const PieChart = ({ pieData, title, match }) => {
  const filteredData = pieData.data.filter((item) => {
    const numericValue = Number(item[1]);
    const isNumeric = !isNaN(numericValue) && item[1] !== null;
    return isNumeric;
  });
  const layout = {
    width: 500,
    height: 200,
    margin: {
      l: 0,
      r: 0,
      t: 0,
      b: 0
    }
  };
  const config = {
    displaylogo: false
  };
  const data = {
    labels: filteredData.map((item) => item[0]),
    values: filteredData.map((item) => item[1]),
    type: "pie",
    textinfo: "none"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Plot, { data: [data], layout, config }) });
};

function ok$1() {}

function unreachable() {}

/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */

/**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function parse$2(value) {
  /** @type {Array<string>} */
  const tokens = [];
  const input = String(value || '');
  let index = input.indexOf(',');
  let start = 0;
  /** @type {boolean} */
  let end = false;

  while (!end) {
    if (index === -1) {
      index = input.length;
      end = true;
    }

    const token = input.slice(start, index).trim();

    if (token || !end) {
      tokens.push(token);
    }

    start = index + 1;
    index = input.indexOf(',', start);
  }

  return tokens
}

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function stringify$1(values, options) {
  const settings = {};

  // Ensure the last empty entry is seen.
  const input = values[values.length - 1] === '' ? [...values, ''] : values;

  return input
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */

const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;

/** @type {Options} */
const emptyOptions$3 = {};

/**
 * Checks if the given value is a valid identifier name.
 *
 * @param {string} name
 *   Identifier to check.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {boolean}
 *   Whether `name` can be an identifier.
 */
function name$5(name, options) {
  const settings = emptyOptions$3;
  const re = settings.jsx ? nameReJsx : nameRe;
  return re.test(name)
}

/**
 * @typedef {import('hast').Nodes} Nodes
 */

// HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const re = /[ \t\n\f\r]/g;

/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {Nodes | string} thing
 *   Thing to check (`Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`); if a node is passed it must be a `Text` node,
 *   whose `value` field is checked.
 */
function whitespace(thing) {
  return typeof thing === 'object'
    ? thing.type === 'text'
      ? empty$1(thing.value)
      : false
    : empty$1(thing)
}

/**
 * @param {string} value
 * @returns {boolean}
 */
function empty$1(value) {
  return value.replace(re, '') === ''
}

/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

let Schema$2 = class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) {
      this.space = space;
    }
  }
};

/** @type {Properties} */
Schema$2.prototype.property = {};
/** @type {Normal} */
Schema$2.prototype.normal = {};
/** @type {string|null} */
Schema$2.prototype.space = null;

/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */


/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge$2(definitions, space) {
  /** @type {Properties} */
  const property = {};
  /** @type {Normal} */
  const normal = {};
  let index = -1;

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property);
    Object.assign(normal, definitions[index].normal);
  }

  return new Schema$2(property, normal, space)
}

/**
 * @param {string} value
 * @returns {string}
 */
function normalize$3(value) {
  return value.toLowerCase()
}

let Info$2 = class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property;
    /** @type {string} */
    this.attribute = attribute;
  }
};

/** @type {string|null} */
Info$2.prototype.space = null;
Info$2.prototype.boolean = false;
Info$2.prototype.booleanish = false;
Info$2.prototype.overloadedBoolean = false;
Info$2.prototype.number = false;
Info$2.prototype.commaSeparated = false;
Info$2.prototype.spaceSeparated = false;
Info$2.prototype.commaOrSpaceSeparated = false;
Info$2.prototype.mustUseProperty = false;
Info$2.prototype.defined = false;

let powers$2 = 0;

const boolean$2 = increment$2();
const booleanish$2 = increment$2();
const overloadedBoolean$2 = increment$2();
const number$2 = increment$2();
const spaceSeparated$2 = increment$2();
const commaSeparated$2 = increment$2();
const commaOrSpaceSeparated$2 = increment$2();

function increment$2() {
  return 2 ** ++powers$2
}

const types$2 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	boolean: boolean$2,
	booleanish: booleanish$2,
	commaOrSpaceSeparated: commaOrSpaceSeparated$2,
	commaSeparated: commaSeparated$2,
	number: number$2,
	overloadedBoolean: overloadedBoolean$2,
	spaceSeparated: spaceSeparated$2
}, Symbol.toStringTag, { value: 'Module' }));

/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks$2 = Object.keys(types$2);

let DefinedInfo$2 = class DefinedInfo extends Info$2 {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1;

    super(property, attribute);

    mark$2(this, 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks$2.length) {
        const check = checks$2[index];
        mark$2(this, checks$2[index], (mask & types$2[check]) === types$2[check]);
      }
    }
  }
};

DefinedInfo$2.prototype.defined = true;

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark$2(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
  }
}

/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */


const own$7 = {}.hasOwnProperty;

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create$2(definition) {
  /** @type {Properties} */
  const property = {};
  /** @type {Normal} */
  const normal = {};
  /** @type {string} */
  let prop;

  for (prop in definition.properties) {
    if (own$7.call(definition.properties, prop)) {
      const value = definition.properties[prop];
      const info = new DefinedInfo$2(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      );

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true;
      }

      property[prop] = info;

      normal[normalize$3(prop)] = prop;
      normal[normalize$3(info.attribute)] = prop;
    }
  }

  return new Schema$2(property, normal, definition.space)
}

const xlink$2 = create$2({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});

const xml$2 = create$2({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
});

/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform$2(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform$2(attributes, property) {
  return caseSensitiveTransform$2(attributes, property.toLowerCase())
}

const xmlns$2 = create$2({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform$2,
  properties: {xmlns: null, xmlnsXLink: null}
});

const aria$2 = create$2({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$2,
    ariaAutoComplete: null,
    ariaBusy: booleanish$2,
    ariaChecked: booleanish$2,
    ariaColCount: number$2,
    ariaColIndex: number$2,
    ariaColSpan: number$2,
    ariaControls: spaceSeparated$2,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$2,
    ariaDetails: null,
    ariaDisabled: booleanish$2,
    ariaDropEffect: spaceSeparated$2,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$2,
    ariaFlowTo: spaceSeparated$2,
    ariaGrabbed: booleanish$2,
    ariaHasPopup: null,
    ariaHidden: booleanish$2,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$2,
    ariaLevel: number$2,
    ariaLive: null,
    ariaModal: booleanish$2,
    ariaMultiLine: booleanish$2,
    ariaMultiSelectable: booleanish$2,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$2,
    ariaPlaceholder: null,
    ariaPosInSet: number$2,
    ariaPressed: booleanish$2,
    ariaReadOnly: booleanish$2,
    ariaRelevant: null,
    ariaRequired: booleanish$2,
    ariaRoleDescription: spaceSeparated$2,
    ariaRowCount: number$2,
    ariaRowIndex: number$2,
    ariaRowSpan: number$2,
    ariaSelected: booleanish$2,
    ariaSetSize: number$2,
    ariaSort: null,
    ariaValueMax: number$2,
    ariaValueMin: number$2,
    ariaValueNow: number$2,
    ariaValueText: null,
    role: null
  }
});

const html$7 = create$2({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform$2,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated$2,
    acceptCharset: spaceSeparated$2,
    accessKey: spaceSeparated$2,
    action: null,
    allow: null,
    allowFullScreen: boolean$2,
    allowPaymentRequest: boolean$2,
    allowUserMedia: boolean$2,
    alt: null,
    as: null,
    async: boolean$2,
    autoCapitalize: null,
    autoComplete: spaceSeparated$2,
    autoFocus: boolean$2,
    autoPlay: boolean$2,
    blocking: spaceSeparated$2,
    capture: null,
    charSet: null,
    checked: boolean$2,
    cite: null,
    className: spaceSeparated$2,
    cols: number$2,
    colSpan: null,
    content: null,
    contentEditable: booleanish$2,
    controls: boolean$2,
    controlsList: spaceSeparated$2,
    coords: number$2 | commaSeparated$2,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean$2,
    defer: boolean$2,
    dir: null,
    dirName: null,
    disabled: boolean$2,
    download: overloadedBoolean$2,
    draggable: booleanish$2,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean$2,
    formTarget: null,
    headers: spaceSeparated$2,
    height: number$2,
    hidden: boolean$2,
    high: number$2,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated$2,
    httpEquiv: spaceSeparated$2,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean$2,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean$2,
    itemId: null,
    itemProp: spaceSeparated$2,
    itemRef: spaceSeparated$2,
    itemScope: boolean$2,
    itemType: spaceSeparated$2,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean$2,
    low: number$2,
    manifest: null,
    max: null,
    maxLength: number$2,
    media: null,
    method: null,
    min: null,
    minLength: number$2,
    multiple: boolean$2,
    muted: boolean$2,
    name: null,
    nonce: null,
    noModule: boolean$2,
    noValidate: boolean$2,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean$2,
    optimum: number$2,
    pattern: null,
    ping: spaceSeparated$2,
    placeholder: null,
    playsInline: boolean$2,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean$2,
    referrerPolicy: null,
    rel: spaceSeparated$2,
    required: boolean$2,
    reversed: boolean$2,
    rows: number$2,
    rowSpan: number$2,
    sandbox: spaceSeparated$2,
    scope: null,
    scoped: boolean$2,
    seamless: boolean$2,
    selected: boolean$2,
    shadowRootClonable: boolean$2,
    shadowRootDelegatesFocus: boolean$2,
    shadowRootMode: null,
    shape: null,
    size: number$2,
    sizes: null,
    slot: null,
    span: number$2,
    spellCheck: booleanish$2,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$2,
    step: null,
    style: null,
    tabIndex: number$2,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean$2,
    useMap: null,
    value: booleanish$2,
    width: number$2,
    wrap: null,
    writingSuggestions: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated$2, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number$2, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$2, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean$2, // Lists. Use CSS to reduce space between items instead
    declare: boolean$2, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number$2, // `<img>` and `<object>`
    leftMargin: number$2, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number$2, // `<body>`
    marginWidth: number$2, // `<body>`
    noResize: boolean$2, // `<frame>`
    noHref: boolean$2, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean$2, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean$2, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number$2, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish$2, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number$2, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$2, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean$2,
    disableRemotePlayback: boolean$2,
    prefix: null,
    property: null,
    results: number$2,
    security: null,
    unselectable: null
  }
});

const svg$5 = create$2({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform$2,
  properties: {
    about: commaOrSpaceSeparated$2,
    accentHeight: number$2,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$2,
    amplitude: number$2,
    arabicForm: null,
    ascent: number$2,
    attributeName: null,
    attributeType: null,
    azimuth: number$2,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$2,
    by: null,
    calcMode: null,
    capHeight: number$2,
    className: spaceSeparated$2,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$2,
    diffuseConstant: number$2,
    direction: null,
    display: null,
    dur: null,
    divisor: number$2,
    dominantBaseline: null,
    download: boolean$2,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$2,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$2,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$2,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated$2,
    g2: commaSeparated$2,
    glyphName: commaSeparated$2,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$2,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$2,
    horizOriginX: number$2,
    horizOriginY: number$2,
    id: null,
    ideographic: number$2,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number$2,
    k: number$2,
    k1: number$2,
    k2: number$2,
    k3: number$2,
    k4: number$2,
    kernelMatrix: commaOrSpaceSeparated$2,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$2,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$2,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$2,
    overlineThickness: number$2,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$2,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated$2,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$2,
    pointsAtY: number$2,
    pointsAtZ: number$2,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated$2,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated$2,
    rev: commaOrSpaceSeparated$2,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated$2,
    requiredFeatures: commaOrSpaceSeparated$2,
    requiredFonts: commaOrSpaceSeparated$2,
    requiredFormats: commaOrSpaceSeparated$2,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$2,
    specularExponent: number$2,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$2,
    strikethroughThickness: number$2,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated$2,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$2,
    strokeOpacity: number$2,
    strokeWidth: null,
    style: null,
    surfaceScale: number$2,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated$2,
    tabIndex: number$2,
    tableValues: null,
    target: null,
    targetX: number$2,
    targetY: number$2,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated$2,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$2,
    underlineThickness: number$2,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$2,
    values: null,
    vAlphabetic: number$2,
    vMathematical: number$2,
    vectorEffect: null,
    vHanging: number$2,
    vIdeographic: number$2,
    version: null,
    vertAdvY: number$2,
    vertOriginX: number$2,
    vertOriginY: number$2,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$2,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
});

/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */


const valid$2 = /^data[-\w.:]+$/i;
const dash$2 = /-[a-z]/g;
const cap$3 = /[A-Z]/g;

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find$2(schema, value) {
  const normal = normalize$3(value);
  let prop = value;
  let Type = Info$2;

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid$2.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash$2, camelcase$2);
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4);

      if (!dash$2.test(rest)) {
        let dashes = rest.replace(cap$3, kebab$2);

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }

        value = 'data' + dashes;
      }
    }

    Type = DefinedInfo$2;
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab$2($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase$2($0) {
  return $0.charAt(1).toUpperCase()
}

/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
};

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */

const html$6 = merge$2([xml$2, xlink$2, xmlns$2, aria$2, html$7], 'html');
const svg$4 = merge$2([xml$2, xlink$2, xmlns$2, aria$2, svg$5], 'svg');

/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function parse$1(value) {
  const input = String(value || '').trim();
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function stringify(values) {
  return values.join(' ').trim()
}

var cjs = {};

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
var inlineStyleParser = function (style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function (node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) ; else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var __importDefault = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(cjs, "__esModule", { value: true });
var inline_style_parser_1 = __importDefault(inlineStyleParser);
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */
function StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== 'string') {
        return styleObject;
    }
    var declarations = (0, inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === 'function';
    declarations.forEach(function (declaration) {
        if (declaration.type !== 'declaration') {
            return;
        }
        var property = declaration.property, value = declaration.value;
        if (hasIterator) {
            iterator(property, value, declaration);
        }
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}
var _default = cjs.default = StyleToObject;

// ensure compatibility with rollup umd build
const styleToObject = _default.default || _default;

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointEnd = point$3('end');

/**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointStart = point$3('start');

/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */
function point$3(type) {
  return point

  /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {};

    if (
      typeof point.line === 'number' &&
      point.line > 0 &&
      typeof point.column === 'number' &&
      point.column > 0
    ) {
      return {
        line: point.line,
        column: point.column,
        offset:
          typeof point.offset === 'number' && point.offset > -1
            ? point.offset
            : undefined
      }
    }
  }
}

/**
 * Get the positional info of `node`.
 *
 * @param {Node | NodeLike | null | undefined} [node]
 *   Node.
 * @returns {Position | undefined}
 *   Position.
 */
function position$2(node) {
  const start = pointStart(node);
  const end = pointEnd(node);

  if (start && end) {
    return {start, end}
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */

/**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position$1(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position$1(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point$2(value)
  }

  // ?
  return ''
}

/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */
function point$2(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */
function position$1(pos) {
  return point$2(pos && pos.start) + '-' + point$2(pos && pos.end)
}

/**
 * @param {number | null | undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */


/**
 * Message.
 */
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super();

    if (typeof optionsOrParentOrPlace === 'string') {
      origin = optionsOrParentOrPlace;
      optionsOrParentOrPlace = undefined;
    }

    /** @type {string} */
    let reason = '';
    /** @type {Options} */
    let options = {};
    let legacyCause = false;

    if (optionsOrParentOrPlace) {
      // Point.
      if (
        'line' in optionsOrParentOrPlace &&
        'column' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace};
      }
      // Position.
      else if (
        'start' in optionsOrParentOrPlace &&
        'end' in optionsOrParentOrPlace
      ) {
        options = {place: optionsOrParentOrPlace};
      }
      // Node.
      else if ('type' in optionsOrParentOrPlace) {
        options = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      }
      // Options.
      else {
        options = {...optionsOrParentOrPlace};
      }
    }

    if (typeof causeOrReason === 'string') {
      reason = causeOrReason;
    }
    // Error.
    else if (!options.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options.cause = causeOrReason;
    }

    if (!options.ruleId && !options.source && typeof origin === 'string') {
      const index = origin.indexOf(':');

      if (index === -1) {
        options.ruleId = origin;
      } else {
        options.source = origin.slice(0, index);
        options.ruleId = origin.slice(index + 1);
      }
    }

    if (!options.place && options.ancestors && options.ancestors) {
      const parent = options.ancestors[options.ancestors.length - 1];

      if (parent) {
        options.place = parent.position;
      }
    }

    const start =
      options.place && 'start' in options.place
        ? options.place.start
        : options.place;

    /* eslint-disable no-unused-expressions */
    /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */
    this.ancestors = options.ancestors || undefined;

    /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */
    this.cause = options.cause || undefined;

    /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */
    this.column = start ? start.column : undefined;

    /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */
    this.fatal = undefined;

    /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */
    this.file;

    // Field from `Error`.
    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.message = reason;

    /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */
    this.line = start ? start.line : undefined;

    // Field from `Error`.
    /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */
    this.name = stringifyPosition(options.place) || '1:1';

    /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */
    this.place = options.place || undefined;

    /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */
    this.reason = this.message;

    /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */
    this.ruleId = options.ruleId || undefined;

    /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */
    this.source = options.source || undefined;

    // Field from `Error`.
    /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */
    this.stack =
      legacyCause && options.cause && typeof options.cause.stack === 'string'
        ? options.cause.stack
        : '';

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */
    this.actual;

    /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */
    this.expected;

    /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */
    this.note;

    /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */
    this.url;
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = '';
VFileMessage.prototype.name = '';
VFileMessage.prototype.reason = '';
VFileMessage.prototype.message = '';
VFileMessage.prototype.stack = '';
VFileMessage.prototype.column = undefined;
VFileMessage.prototype.line = undefined;
VFileMessage.prototype.ancestors = undefined;
VFileMessage.prototype.cause = undefined;
VFileMessage.prototype.fatal = undefined;
VFileMessage.prototype.place = undefined;
VFileMessage.prototype.ruleId = undefined;
VFileMessage.prototype.source = undefined;

// Register MDX nodes in mdast:
/// <reference types="mdast-util-mdx-expression" />
/// <reference types="mdast-util-mdx-jsx" />
/// <reference types="mdast-util-mdxjs-esm" />


const own$6 = {}.hasOwnProperty;

/** @type {Map<string, number>} */
const emptyMap = new Map();

const cap$2 = /[A-Z]/g;
const dashSomething = /-([a-z])/g;

// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.

// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const tableElements = new Set(['table', 'tbody', 'thead', 'tfoot', 'tr']);

const tableCellElement = new Set(['td', 'th']);

const docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';

/**
 * Transform a hast tree to preact, react, solid, svelte, vue, etc.,
 * with an automatic JSX runtime.
 *
 * @param {Nodes} tree
 *   Tree to transform.
 * @param {Options} options
 *   Configuration (required).
 * @returns {JSX.Element}
 *   JSX element.
 */

function toJsxRuntime(tree, options) {
  if (!options || options.Fragment === undefined) {
    throw new TypeError('Expected `Fragment` in options')
  }

  const filePath = options.filePath || undefined;
  /** @type {Create} */
  let create;

  if (options.development) {
    if (typeof options.jsxDEV !== 'function') {
      throw new TypeError(
        'Expected `jsxDEV` in options when `development: true`'
      )
    }

    create = developmentCreate(filePath, options.jsxDEV);
  } else {
    if (typeof options.jsx !== 'function') {
      throw new TypeError('Expected `jsx` in production options')
    }

    if (typeof options.jsxs !== 'function') {
      throw new TypeError('Expected `jsxs` in production options')
    }

    create = productionCreate(filePath, options.jsx, options.jsxs);
  }

  /** @type {State} */
  const state = {
    Fragment: options.Fragment,
    ancestors: [],
    components: options.components || {},
    create,
    elementAttributeNameCase: options.elementAttributeNameCase || 'react',
    evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
    filePath,
    ignoreInvalidStyle: options.ignoreInvalidStyle || false,
    passKeys: options.passKeys !== false,
    passNode: options.passNode || false,
    schema: options.space === 'svg' ? svg$4 : html$6,
    stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
    tableCellAlignToStyle: options.tableCellAlignToStyle !== false
  };

  const result = one$3(state, tree, undefined);

  // JSX element.
  if (result && typeof result !== 'string') {
    return result
  }

  // Text node or something that turned into nothing.
  return state.create(
    tree,
    state.Fragment,
    {children: result || undefined},
    undefined
  )
}

/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function one$3(state, node, key) {
  if (node.type === 'element') {
    return element$4(state, node, key)
  }

  if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') {
    return mdxExpression(state, node)
  }

  if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') {
    return mdxJsxElement(state, node, key)
  }

  if (node.type === 'mdxjsEsm') {
    return mdxEsm(state, node)
  }

  if (node.type === 'root') {
    return root$6(state, node, key)
  }

  if (node.type === 'text') {
    return text$7(state, node)
  }
}

/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function element$4(state, node, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;

  if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
    schema = svg$4;
    state.schema = schema;
  }

  state.ancestors.push(node);

  const type = findComponentFromName(state, node.tagName, false);
  const props = createElementProps(state, node);
  let children = createChildren(state, node);

  if (tableElements.has(node.tagName)) {
    children = children.filter(function (child) {
      return typeof child === 'string' ? !whitespace(child) : true
    });
  }

  addNode(state, props, type, node);
  addChildren(props, children);

  // Restore.
  state.ancestors.pop();
  state.schema = parentSchema;

  return state.create(node, type, props, key)
}

/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpression | MdxTextExpression} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxExpression(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    const program = node.data.estree;
    const expression = program.body[0];
    ok$1(expression.type === 'ExpressionStatement');

    // Assume result is a child.
    return /** @type {Child | undefined} */ (
      state.evaluater.evaluateExpression(expression.expression)
    )
  }

  crashEstree(state, node.position);
}

/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsm} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxEsm(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    // Assume result is a child.
    return /** @type {Child | undefined} */ (
      state.evaluater.evaluateProgram(node.data.estree)
    )
  }

  crashEstree(state, node.position);
}

/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function mdxJsxElement(state, node, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;

  if (node.name === 'svg' && parentSchema.space === 'html') {
    schema = svg$4;
    state.schema = schema;
  }

  state.ancestors.push(node);

  const type =
    node.name === null
      ? state.Fragment
      : findComponentFromName(state, node.name, true);
  const props = createJsxElementProps(state, node);
  const children = createChildren(state, node);

  addNode(state, props, type, node);
  addChildren(props, children);

  // Restore.
  state.ancestors.pop();
  state.schema = parentSchema;

  return state.create(node, type, props, key)
}

/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function root$6(state, node, key) {
  /** @type {Props} */
  const props = {};

  addChildren(props, createChildren(state, node));

  return state.create(node, state.Fragment, props, key)
}

/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */
function text$7(_, node) {
  return node.value
}

/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElement | MdxJsxTextElement} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */
function addNode(state, props, type, node) {
  // If this is swapped out for a component:
  if (typeof type !== 'string' && type !== state.Fragment && state.passNode) {
    props.node = node;
  }
}

/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */
function addChildren(props, children) {
  if (children.length > 0) {
    const value = children.length > 1 ? children : children[0];

    if (value) {
      props.children = value;
    }
  }
}

/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */
function productionCreate(_, jsx, jsxs) {
  return create
  /** @type {Create} */
  function create(_, type, props, key) {
    // Only an array when there are 2 or more children.
    const isStaticChildren = Array.isArray(props.children);
    const fn = isStaticChildren ? jsxs : jsx;
    return key ? fn(type, props, key) : fn(type, props)
  }
}

/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */
function developmentCreate(filePath, jsxDEV) {
  return create
  /** @type {Create} */
  function create(node, type, props, key) {
    // Only an array when there are 2 or more children.
    const isStaticChildren = Array.isArray(props.children);
    const point = pointStart(node);
    return jsxDEV(
      type,
      props,
      key,
      isStaticChildren,
      {
        columnNumber: point ? point.column - 1 : undefined,
        fileName: filePath,
        lineNumber: point ? point.line : undefined
      },
      undefined
    )
  }
}

/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */
function createElementProps(state, node) {
  /** @type {Props} */
  const props = {};
  /** @type {string | undefined} */
  let alignValue;
  /** @type {string} */
  let prop;

  for (prop in node.properties) {
    if (prop !== 'children' && own$6.call(node.properties, prop)) {
      const result = createProperty$1(state, prop, node.properties[prop]);

      if (result) {
        const [key, value] = result;

        if (
          state.tableCellAlignToStyle &&
          key === 'align' &&
          typeof value === 'string' &&
          tableCellElement.has(node.tagName)
        ) {
          alignValue = value;
        } else {
          props[key] = value;
        }
      }
    }
  }

  if (alignValue) {
    // Assume style is an object.
    const style = /** @type {Style} */ (props.style || (props.style = {}));
    style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] =
      alignValue;
  }

  return props
}

/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */
function createJsxElementProps(state, node) {
  /** @type {Props} */
  const props = {};

  for (const attribute of node.attributes) {
    if (attribute.type === 'mdxJsxExpressionAttribute') {
      if (attribute.data && attribute.data.estree && state.evaluater) {
        const program = attribute.data.estree;
        const expression = program.body[0];
        ok$1(expression.type === 'ExpressionStatement');
        const objectExpression = expression.expression;
        ok$1(objectExpression.type === 'ObjectExpression');
        const property = objectExpression.properties[0];
        ok$1(property.type === 'SpreadElement');

        Object.assign(
          props,
          state.evaluater.evaluateExpression(property.argument)
        );
      } else {
        crashEstree(state, node.position);
      }
    } else {
      // For JSX, the author is responsible of passing in the correct values.
      const name = attribute.name;
      /** @type {unknown} */
      let value;

      if (attribute.value && typeof attribute.value === 'object') {
        if (
          attribute.value.data &&
          attribute.value.data.estree &&
          state.evaluater
        ) {
          const program = attribute.value.data.estree;
          const expression = program.body[0];
          ok$1(expression.type === 'ExpressionStatement');
          value = state.evaluater.evaluateExpression(expression.expression);
        } else {
          crashEstree(state, node.position);
        }
      } else {
        value = attribute.value === null ? true : attribute.value;
      }

      // Assume a prop.
      props[name] = /** @type {Props[keyof Props]} */ (value);
    }
  }

  return props
}

/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */
function createChildren(state, node) {
  /** @type {Array<Child>} */
  const children = [];
  let index = -1;
  /** @type {Map<string, number>} */
  // Note: test this when Solid doesn’t want to merge my upcoming PR.
  /* c8 ignore next */
  const countsByName = state.passKeys ? new Map() : emptyMap;

  while (++index < node.children.length) {
    const child = node.children[index];
    /** @type {string | undefined} */
    let key;

    if (state.passKeys) {
      const name =
        child.type === 'element'
          ? child.tagName
          : child.type === 'mdxJsxFlowElement' ||
              child.type === 'mdxJsxTextElement'
            ? child.name
            : undefined;

      if (name) {
        const count = countsByName.get(name) || 0;
        key = name + '-' + count;
        countsByName.set(name, count + 1);
      }
    }

    const result = one$3(state, child, key);
    if (result !== undefined) children.push(result);
  }

  return children
}

/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */
function createProperty$1(state, prop, value) {
  const info = find$2(state.schema, prop);

  // Ignore nullish and `NaN` values.
  if (
    value === null ||
    value === undefined ||
    (typeof value === 'number' && Number.isNaN(value))
  ) {
    return
  }

  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? stringify$1(value) : stringify(value);
  }

  // React only accepts `style` as object.
  if (info.property === 'style') {
    let styleObject =
      typeof value === 'object' ? value : parseStyle(state, String(value));

    if (state.stylePropertyNameCase === 'css') {
      styleObject = transformStylesToCssCasing(styleObject);
    }

    return ['style', styleObject]
  }

  return [
    state.elementAttributeNameCase === 'react' && info.space
      ? hastToReact[info.property] || info.property
      : info.attribute,
    value
  ]
}

/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */
function parseStyle(state, value) {
  /** @type {Style} */
  const result = {};

  try {
    // @ts-expect-error: `style-to-object` types are broken.
    styleToObject(value, replacer);
  } catch (error) {
    if (!state.ignoreInvalidStyle) {
      const cause = /** @type {Error} */ (error);
      const message = new VFileMessage('Cannot parse `style` attribute', {
        ancestors: state.ancestors,
        cause,
        ruleId: 'style',
        source: 'hast-util-to-jsx-runtime'
      });
      message.file = state.filePath || undefined;
      message.url = docs + '#cannot-parse-style-attribute';

      throw message
    }
  }

  return result

  /**
   * Add a CSS property (normal, so with dashes) to `result` as a DOM CSS
   * property.
   *
   * @param {string} name
   *   Key.
   * @param {string} value
   *   Value
   * @returns {undefined}
   *   Nothing.
   */
  function replacer(name, value) {
    let key = name;

    if (key.slice(0, 2) !== '--') {
      if (key.slice(0, 4) === '-ms-') key = 'ms-' + key.slice(4);
      key = key.replace(dashSomething, toCamel);
    }

    result[key] = value;
  }
}

/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */
function findComponentFromName(state, name, allowExpression) {
  /** @type {Identifier | Literal | MemberExpression} */
  let result;

  if (!allowExpression) {
    result = {type: 'Literal', value: name};
  } else if (name.includes('.')) {
    const identifiers = name.split('.');
    let index = -1;
    /** @type {Identifier | Literal | MemberExpression | undefined} */
    let node;

    while (++index < identifiers.length) {
      /** @type {Identifier | Literal} */
      const prop = name$5(identifiers[index])
        ? {type: 'Identifier', name: identifiers[index]}
        : {type: 'Literal', value: identifiers[index]};
      node = node
        ? {
            type: 'MemberExpression',
            object: node,
            property: prop,
            computed: Boolean(index && prop.type === 'Literal'),
            optional: false
          }
        : prop;
    }
    result = node;
  } else {
    result =
      name$5(name) && !/^[a-z]/.test(name)
        ? {type: 'Identifier', name}
        : {type: 'Literal', value: name};
  }

  // Only literals can be passed in `components` currently.
  // No identifiers / member expressions.
  if (result.type === 'Literal') {
    const name = /** @type {keyof JSX.IntrinsicElements} */ (result.value);

    return own$6.call(state.components, name) ? state.components[name] : name
  }

  // Assume component.
  if (state.evaluater) {
    return state.evaluater.evaluateExpression(result)
  }

  crashEstree(state);
}

/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */
function crashEstree(state, place) {
  const message = new VFileMessage(
    'Cannot handle MDX estrees without `createEvaluater`',
    {
      ancestors: state.ancestors,
      place,
      ruleId: 'mdx-estree',
      source: 'hast-util-to-jsx-runtime'
    }
  );
  message.file = state.filePath || undefined;
  message.url = docs + '#cannot-handle-mdx-estrees-without-createevaluater';

  throw message
}

/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */
function transformStylesToCssCasing(domCasing) {
  /** @type {Style} */
  const cssCasing = {};
  /** @type {string} */
  let from;

  for (from in domCasing) {
    if (own$6.call(domCasing, from)) {
      cssCasing[transformStyleToCssCasing(from)] = domCasing[from];
    }
  }

  return cssCasing
}

/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */
function transformStyleToCssCasing(from) {
  let to = from.replace(cap$2, toDash);
  // Handle `ms-xxx` -> `-ms-xxx`.
  if (to.slice(0, 3) === 'ms-') to = '-' + to;
  return to
}

/**
 * Make `$1` capitalized.
 *
 * @param {string} _
 *   Whatever.
 * @param {string} $1
 *   Single ASCII alphabetical.
 * @returns {string}
 *   Capitalized `$1`.
 */
function toCamel(_, $1) {
  return $1.toUpperCase()
}

/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */
function toDash($0) {
  return '-' + $0.toLowerCase()
}

/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */
const urlAttributes = {
  action: ['form'],
  cite: ['blockquote', 'del', 'ins', 'q'],
  data: ['object'],
  formAction: ['button', 'input'],
  href: ['a', 'area', 'base', 'link'],
  icon: ['menuitem'],
  itemId: null,
  manifest: ['html'],
  ping: ['a', 'area'],
  poster: ['video'],
  src: [
    'audio',
    'embed',
    'iframe',
    'img',
    'input',
    'script',
    'source',
    'track',
    'video'
  ]
};

/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */

/** @type {Options} */
const emptyOptions$2 = {};

/**
 * Get the text content of a node or list of nodes.
 *
 * Prefers the node’s plain-text fields, otherwise serializes its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} [value]
 *   Thing to serialize, typically `Node`.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {string}
 *   Serialized `value`.
 */
function toString$2(value, options) {
  const settings = emptyOptions$2;
  const includeImageAlt =
    typeof settings.includeImageAlt === 'boolean'
      ? settings.includeImageAlt
      : true;
  const includeHtml =
    typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;

  return one$2(value, includeImageAlt, includeHtml)
}

/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */
function one$2(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ('value' in value) {
      return value.type === 'html' && !includeHtml ? '' : value.value
    }

    if (includeImageAlt && 'alt' in value && value.alt) {
      return value.alt
    }

    if ('children' in value) {
      return all$3(value.children, includeImageAlt, includeHtml)
    }
  }

  if (Array.isArray(value)) {
    return all$3(value, includeImageAlt, includeHtml)
  }

  return ''
}

/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */
function all$3(values, includeImageAlt, includeHtml) {
  /** @type {Array<string>} */
  const result = [];
  let index = -1;

  while (++index < values.length) {
    result[index] = one$2(values[index], includeImageAlt, includeHtml);
  }

  return result.join('')
}

/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */
function node(value) {
  return Boolean(value && typeof value === 'object')
}

/// <reference lib="dom" />

/* eslint-env browser */

const element$3 = document.createElement('i');

/**
 * @param {string} value
 * @returns {string|false}
 */
function decodeNamedCharacterReference(value) {
  const characterReference = '&' + value + ';';
  element$3.innerHTML = characterReference;
  const char = element$3.textContent;

  // Some named character references do not require the closing semicolon
  // (`&not`, for instance), which leads to situations where parsing the assumed
  // named reference of `&notit;` will result in the string `¬it;`.
  // When we encounter a trailing semicolon after parsing, and the character
  // reference to decode was not a semicolon (`&semi;`), we can assume that the
  // matching was not complete.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  if (char.charCodeAt(char.length - 1) === 59 /* `;` */ && value !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the character reference was
  // not valid.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  return char === characterReference ? false : char
}

/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */
function splice(list, start, remove, items) {
  const end = list.length;
  let chunkStart = 0;
  /** @type {Array<unknown>} */
  let parameters;

  // Make start between zero and `end` (included).
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0;

  // No need to chunk the items if there’s only a couple (10k) items.
  if (items.length < 10000) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    // @ts-expect-error Hush, it’s fine.
    list.splice(...parameters);
  } else {
    // Delete `remove` items starting from `start`
    if (remove) list.splice(start, remove);

    // Insert the items in chunks to not cause stack overflows.
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000);
      parameters.unshift(start, 0);
      // @ts-expect-error Hush, it’s fine.
      list.splice(...parameters);
      chunkStart += 10000;
      start += 10000;
    }
  }
}

/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {Array<T>} items
 *   Items to add to `list`.
 * @returns {Array<T>}
 *   Either `list` or `items`.
 */
function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items);
    return list
  }
  return items
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */


const hasOwnProperty$2 = {}.hasOwnProperty;

/**
 * Combine multiple syntax extensions into one.
 *
 * @param {Array<Extension>} extensions
 *   List of syntax extensions.
 * @returns {NormalizedExtension}
 *   A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {};
  let index = -1;

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index]);
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */
function syntaxExtension(all, extension) {
  /** @type {keyof Extension} */
  let hook;

  for (hook in extension) {
    const maybe = hasOwnProperty$2.call(all, hook) ? all[hook] : undefined;
    /** @type {Record<string, unknown>} */
    const left = maybe || (all[hook] = {});
    /** @type {Record<string, unknown> | undefined} */
    const right = extension[hook];
    /** @type {string} */
    let code;

    if (right) {
      for (code in right) {
        if (!hasOwnProperty$2.call(left, code)) left[code] = [];
        const value = right[code];
        constructs(
          // @ts-expect-error Looks like a list.
          left[code],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */
function constructs(existing, list) {
  let index = -1;
  /** @type {Array<unknown>} */
  const before = [];

  while (++index < list.length) {
(list[index].add === 'after' ? existing : before).push(list[index]);
  }

  splice(existing, 0, 0, before);
}

/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base);
  if (
  // C0 except for HT, LF, FF, CR, space.
  code < 9 || code === 11 || code > 13 && code < 32 ||
  // Control character (DEL) of C0, and C1 controls.
  code > 126 && code < 160 ||
  // Lone high surrogates and low surrogates.
  code > 55_295 && code < 57_344 ||
  // Noncharacters.
  code > 64_975 && code < 65_008 || /* eslint-disable no-bitwise */
  (code & 65_535) === 65_535 || (code & 65_535) === 65_534 || /* eslint-enable no-bitwise */
  // Out of range
  code > 1_114_111) {
    return "\uFFFD";
  }
  return String.fromCodePoint(code);
}

/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */
function normalizeIdentifier(value) {
  return (
    value
      // Collapse markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ')
      // Trim.
      .replace(/^ | $/g, '')
      // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAlpha = regexCheck(/[A-Za-z]/);

/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);

/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);

/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  );
}

/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiDigit = regexCheck(/\d/);

/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);

/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);

/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEnding(code) {
  return code !== null && code < -2;
}

/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32);
}

/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32;
}

// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodePunctuation = regexCheck(/\p{P}|\p{S}/u);

/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodeWhitespace = regexCheck(/\s/);

/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */
function regexCheck(regex) {
  return check;

  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */
  function check(code) {
    return code !== null && code > -1 && regex.test(String.fromCharCode(code));
  }
}

/**
 * Normalize a URL.
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 *   URI to normalize.
 * @returns {string}
 *   Normalized URI.
 */
function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = [];
  let index = -1;
  let start = 0;
  let skip = 0;
  while (++index < value.length) {
    const code = value.charCodeAt(index);
    /** @type {string} */
    let replace = '';

    // A correct percent encoded value.
    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2;
    }
    // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code);
      }
    }
    // Astral.
    else if (code > 55_295 && code < 57_344) {
      const next = value.charCodeAt(index + 1);

      // A correct surrogate pair.
      if (code < 56_320 && next > 56_319 && next < 57_344) {
        replace = String.fromCharCode(code, next);
        skip = 1;
      }
      // Lone surrogate.
      else {
        replace = '\uFFFD';
      }
    }
    // Unicode.
    else {
      replace = String.fromCharCode(code);
    }
    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace));
      start = index + skip + 1;
      replace = '';
    }
    if (skip) {
      index += skip;
      skip = 0;
    }
  }
  return result.join('') + value.slice(start)
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */


// To do: implement `spaceOrTab`, `spaceOrTabMinMax`, `spaceOrTabWithOptions`.

/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   spaces in markdown are often optional, in which case this factory can be
 *     used and `ok` will be switched to whether spaces were found or not
 * *   one line ending or space can be detected with `markdownSpace(code)` right
 *     before using `factorySpace`
 *
 * ###### Examples
 *
 * Where `␉` represents a tab (plus how much it expands) and `␠` represents a
 * single space.
 *
 * ```markdown
 * ␉
 * ␠␠␠␠
 * ␉␠
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {TokenType} type
 *   Type (`' \t'`).
 * @param {number | undefined} [max=Infinity]
 *   Max (exclusive).
 * @returns {State}
 *   Start state.
 */
function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start

  /** @type {State} */
  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type);
      return prefix(code)
    }
    return ok(code)
  }

  /** @type {State} */
  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code);
      return prefix
    }
    effects.exit(type);
    return ok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/** @type {InitialConstruct} */
const content$1 = {
  tokenize: initializeContent
};

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  );
  /** @type {Token} */
  let previous;
  return contentStart

  /** @type {State} */
  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return
    }
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace(effects, contentStart, 'linePrefix')
  }

  /** @type {State} */
  function paragraphInitial(code) {
    effects.enter('paragraph');
    return lineStart(code)
  }

  /** @type {State} */
  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    });
    if (previous) {
      previous.next = token;
    }
    previous = token;
    return data(code)
  }

  /** @type {State} */
  function data(code) {
    if (code === null) {
      effects.exit('chunkText');
      effects.exit('paragraph');
      effects.consume(code);
      return
    }
    if (markdownLineEnding(code)) {
      effects.consume(code);
      effects.exit('chunkText');
      return lineStart
    }

    // Data.
    effects.consume(code);
    return data
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {InitialConstruct} */
const document$2 = {
  tokenize: initializeDocument
};

/** @type {Construct} */
const containerConstruct = {
  tokenize: tokenizeContainer
};

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeDocument(effects) {
  const self = this;
  /** @type {Array<StackItem>} */
  const stack = [];
  let continued = 0;
  /** @type {TokenizeContext | undefined} */
  let childFlow;
  /** @type {Token | undefined} */
  let childToken;
  /** @type {number} */
  let lineStartOffset;
  return start

  /** @type {State} */
  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued];
      self.containerState = item[1];
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    }

    // Done.
    return checkNewContainers(code)
  }

  /** @type {State} */
  function documentContinue(code) {
    continued++;

    // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.
    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined;
      if (childFlow) {
        closeFlow();
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.
      const indexBeforeExits = self.events.length;
      let indexBeforeFlow = indexBeforeExits;
      /** @type {Point | undefined} */
      let point;

      // Find the flow chunk.
      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end;
          break
        }
      }
      exitContainers(continued);

      // Fix positions.
      let index = indexBeforeExits;
      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point);
        index++;
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      );

      // Discard the duplicate exits.
      self.events.length = index;
      return checkNewContainers(code)
    }
    return start(code)
  }

  /** @type {State} */
  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      }

      // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      }

      // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.
      // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
      // needed in micromark-extension-gfm-table@1.0.6).
      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      );
    }

    // Check if there is a new container.
    self.containerState = {};
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }

  /** @type {State} */
  function thereIsANewContainer(code) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code)
  }

  /** @type {State} */
  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length;
    lineStartOffset = self.now().offset;
    return flowStart(code)
  }

  /** @type {State} */
  function documentContinued(code) {
    // Try new containers.
    self.containerState = {};
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }

  /** @type {State} */
  function containerContinue(code) {
    continued++;
    stack.push([self.currentConstruct, self.containerState]);
    // Try another.
    return documentContinued(code)
  }

  /** @type {State} */
  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code);
      return
    }
    childFlow = childFlow || self.parser.flow(self.now());
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    });
    return flowContinue(code)
  }

  /** @type {State} */
  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true);
      exitContainers(0);
      effects.consume(code);
      return
    }
    if (markdownLineEnding(code)) {
      effects.consume(code);
      writeToChild(effects.exit('chunkFlow'));
      // Get ready for the next line.
      continued = 0;
      self.interrupt = undefined;
      return start
    }
    effects.consume(code);
    return flowContinue
  }

  /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {undefined}
   */
  function writeToChild(token, eof) {
    const stream = self.sliceStream(token);
    if (eof) stream.push(null);
    token.previous = childToken;
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream);

    // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.
    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length;
      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset &&
          // …and either is not ended yet…
          (!childFlow.events[index][1].end ||
            // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.
      const indexBeforeExits = self.events.length;
      let indexBeforeFlow = indexBeforeExits;
      /** @type {boolean | undefined} */
      let seen;
      /** @type {Point | undefined} */
      let point;

      // Find the previous chunk (the one before the lazy line).
      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end;
            break
          }
          seen = true;
        }
      }
      exitContainers(continued);

      // Fix positions.
      index = indexBeforeExits;
      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point);
        index++;
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      );

      // Discard the duplicate exits.
      self.events.length = index;
    }
  }

  /**
   * @param {number} size
   * @returns {undefined}
   */
  function exitContainers(size) {
    let index = stack.length;

    // Exit open containers.
    while (index-- > size) {
      const entry = stack[index];
      self.containerState = entry[1];
      entry[0].exit.call(self, effects);
    }
    stack.length = size;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = undefined;
    childFlow = undefined;
    self.containerState._closeFlow = undefined;
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContainer(effects, ok, nok) {
  // Always populated by defaults.

  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Classify whether a code represents whitespace, punctuation, or something
 * else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * > 👉 **Note**: eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 *   Code.
 * @returns {typeof constants.characterGroupWhitespace | typeof constants.characterGroupPunctuation | undefined}
 *   Group.
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }
  if (unicodePunctuation(code)) {
    return 2
  }
}

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */
function resolveAll(constructs, events, context) {
  /** @type {Array<Resolver>} */
  const called = [];
  let index = -1;

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll;

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }

  return events
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};

/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */
// eslint-disable-next-line complexity
function resolveAllAttention(events, context) {
  let index = -1;
  /** @type {number} */
  let open;
  /** @type {Token} */
  let group;
  /** @type {Token} */
  let text;
  /** @type {Token} */
  let openingSequence;
  /** @type {Token} */
  let closingSequence;
  /** @type {number} */
  let use;
  /** @type {Array<Event>} */
  let nextEvents;
  /** @type {number} */
  let offset;

  // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.
  while (++index < events.length) {
    // Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
      open = index;

      // Now walk back to find an opener.
      while (open--) {
        // Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open &&
        // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) {
            continue;
          }

          // Number of markers to use from the sequence.
          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
          const start = Object.assign({}, events[open][1].end);
          const end = Object.assign({}, events[index][1].start);
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: Object.assign({}, events[open][1].end)
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, events[index][1].start),
            end
          };
          text = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          };
          group = {
            type: use > 1 ? "strong" : "emphasis",
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          };
          events[open][1].end = Object.assign({}, openingSequence.start);
          events[index][1].start = Object.assign({}, closingSequence.end);
          nextEvents = [];

          // If there are more markers in the opening, add them before.
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [['enter', events[open][1], context], ['exit', events[open][1], context]]);
          }

          // Opening.
          nextEvents = push(nextEvents, [['enter', group, context], ['enter', openingSequence, context], ['exit', openingSequence, context], ['enter', text, context]]);

          // Always populated by defaults.

          // Between.
          nextEvents = push(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));

          // Closing.
          nextEvents = push(nextEvents, [['exit', text, context], ['enter', closingSequence, context], ['exit', closingSequence, context], ['exit', group, context]]);

          // If there are more markers in the closing, add them after.
          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2;
            nextEvents = push(nextEvents, [['enter', events[index][1], context], ['exit', events[index][1], context]]);
          } else {
            offset = 0;
          }
          splice(events, open - 1, index - open + 3, nextEvents);
          index = open + nextEvents.length - offset - 2;
          break;
        }
      }
    }
  }

  // Remove remaining sequences.
  index = -1;
  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data';
    }
  }
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null;
  const previous = this.previous;
  const before = classifyCharacter(previous);

  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    marker = code;
    effects.enter('attentionSequence');
    return inside(code);
  }

  /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code);
      return inside;
    }
    const token = effects.exit('attentionSequence');

    // To do: next major: move this to resolver, just like `markdown-rs`.
    const after = classifyCharacter(code);

    // Always populated by defaults.

    const open = !after || after === 2 && before || attentionMarkers.includes(code);
    const close = !before || before === 2 && after || attentionMarkers.includes(previous);
    token._open = Boolean(marker === 42 ? open : open && (before || !close));
    token._close = Boolean(marker === 42 ? close : close && (after || !open));
    return ok(code);
  }
}

/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {undefined}
 */
function movePoint(point, offset) {
  point.column += offset;
  point.offset += offset;
  point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeAutolink(effects, ok, nok) {
  let size = 0;
  return start;

  /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }

  /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return schemeOrEmailAtext;
    }
    if (code === 64) {
      return nok(code);
    }
    return emailAtext(code);
  }

  /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeOrEmailAtext(code) {
    // ASCII alphanumeric and `+`, `-`, and `.`.
    if (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) {
      // Count the previous alphabetical from `open` too.
      size = 1;
      return schemeInsideOrEmailAtext(code);
    }
    return emailAtext(code);
  }

  /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code);
      size = 0;
      return urlInside;
    }

    // ASCII alphanumeric and `+`, `-`, and `.`.
    if ((code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) && size++ < 32) {
      effects.consume(code);
      return schemeInsideOrEmailAtext;
    }
    size = 0;
    return emailAtext(code);
  }

  /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */
  function urlInside(code) {
    if (code === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }

    // ASCII control, space, or `<`.
    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code);
    }
    effects.consume(code);
    return urlInside;
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */
  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code)) {
      effects.consume(code);
      return emailAtext;
    }
    return nok(code);
  }

  /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */
  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code);
  }

  /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */
  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code);
      size = 0;
      return emailAtSignOrDot;
    }
    if (code === 62) {
      // Exit, then change the token type.
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }
    return emailValue(code);
  }

  /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function emailValue(code) {
    // ASCII alphanumeric or `-`.
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      const next = code === 45 ? emailValue : emailLabel;
      effects.consume(code);
      return next;
    }
    return nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlankLine(effects, ok, nok) {
  return start;

  /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    return markdownSpace(code) ? factorySpace(effects, after, "linePrefix")(code) : after(code);
  }

  /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$1
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 62) {
      const state = self.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code);
      effects.exit("blockQuoteMarker");
      return after;
    }
    return nok(code);
  }

  /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (markdownSpace(code)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok;
    }
    effects.exit("blockQuotePrefix");
    return ok(code);
  }
}

/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  const self = this;
  return contStart;

  /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contStart(code) {
    if (markdownSpace(code)) {
      // Always populated by defaults.

      return factorySpace(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
    return contBefore(code);
  }

  /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contBefore(code) {
    return effects.attempt(blockQuote, ok, nok)(code);
  }
}

/** @type {Exiter} */
function exit$1(effects) {
  effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCharacterEscape(effects, ok, nok) {
  return start;

  /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code);
    effects.exit("escapeMarker");
    return inside;
  }

  /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // ASCII punctuation.
    if (asciiPunctuation(code)) {
      effects.enter("characterEscapeValue");
      effects.consume(code);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok;
    }
    return nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCharacterReference(effects, ok, nok) {
  const self = this;
  let size = 0;
  /** @type {number} */
  let max;
  /** @type {(code: Code) => boolean} */
  let test;
  return start;

  /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code);
    effects.exit("characterReferenceMarker");
    return open;
  }

  /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric;
    }
    effects.enter("characterReferenceValue");
    max = 31;
    test = asciiAlphanumeric;
    return value(code);
  }

  /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */
  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max = 7;
    test = asciiDigit;
    return value(code);
  }

  /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */
  function value(code) {
    if (code === 59 && size) {
      const token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self.sliceSerialize(token))) {
        return nok(code);
      }

      // To do: `markdown-rs` uses a different name:
      // `CharacterReferenceMarkerSemi`.
      effects.enter("characterReferenceMarker");
      effects.consume(code);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok;
    }
    if (test(code) && size++ < max) {
      effects.consume(code);
      return value;
    }
    return nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: true
};

/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeFenced(effects, ok, nok) {
  const self = this;
  /** @type {Construct} */
  const closeStart = {
    tokenize: tokenizeCloseStart,
    partial: true
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse whitespace like `markdown-rs`.
    return beforeSequenceOpen(code);
  }

  /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeSequenceOpen(code) {
    const tail = self.events[self.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code);
  }

  /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === marker) {
      sizeOpen++;
      effects.consume(code);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code) ? factorySpace(effects, infoBefore, "whitespace")(code) : infoBefore(code);
  }

  /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function infoBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFencedFence");
      return self.interrupt ? ok(code) : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code);
  }

  /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function info(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code);
    }
    if (markdownSpace(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code);
    }
    if (code === 96 && code === marker) {
      return nok(code);
    }
    effects.consume(code);
    return info;
  }

  /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function metaBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return infoBefore(code);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta(code);
  }

  /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code);
    }
    if (code === 96 && code === marker) {
      return nok(code);
    }
    effects.consume(code);
    return meta;
  }

  /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function atNonLazyBreak(code) {
    return effects.attempt(closeStart, after, contentBefore)(code);
  }

  /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentBefore(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return contentStart;
  }

  /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentStart(code) {
    return initialPrefix > 0 && markdownSpace(code) ? factorySpace(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
  }

  /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeContentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code);
  }

  /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code);
    }
    effects.consume(code);
    return contentChunk;
  }

  /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    effects.exit("codeFenced");
    return ok(code);
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeCloseStart(effects, ok, nok) {
    let size = 0;
    return startBefore;

    /**
     *
     *
     * @type {State}
     */
    function startBefore(code) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return start;
    }

    /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function start(code) {
      // Always populated by defaults.

      // To do: `enter` here or in next state?
      effects.enter("codeFencedFence");
      return markdownSpace(code) ? factorySpace(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
    }

    /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function beforeSequenceClose(code) {
      if (code === marker) {
        effects.enter("codeFencedFenceSequence");
        return sequenceClose(code);
      }
      return nok(code);
    }

    /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function sequenceClose(code) {
      if (code === marker) {
        size++;
        effects.consume(code);
        return sequenceClose;
      }
      if (size >= sizeOpen) {
        effects.exit("codeFencedFenceSequence");
        return markdownSpace(code) ? factorySpace(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
      }
      return nok(code);
    }

    /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */
    function sequenceCloseAfter(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit("codeFencedFence");
        return ok(code);
      }
      return nok(code);
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuation(effects, ok, nok) {
  const self = this;
  return start;

  /**
   *
   *
   * @type {State}
   */
  function start(code) {
    if (code === null) {
      return nok(code);
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return lineStart;
  }

  /**
   *
   *
   * @type {State}
   */
  function lineStart(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
};

/** @type {Construct} */
const furtherStart = {
  tokenize: tokenizeFurtherStart,
  partial: true
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeIndented(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: manually check if interrupting like `markdown-rs`.

    effects.enter("codeIndented");
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code);
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
  }

  /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === null) {
      return after(code);
    }
    if (markdownLineEnding(code)) {
      return effects.attempt(furtherStart, atBreak, after)(code);
    }
    effects.enter("codeFlowValue");
    return inside(code);
  }

  /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFlowValue");
      return atBreak(code);
    }
    effects.consume(code);
    return inside;
  }

  /** @type {State} */
  function after(code) {
    effects.exit("codeIndented");
    // To do: allow interrupting like `markdown-rs`.
    // Feel free to interrupt.
    // tokenizer.interrupt = false
    return ok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeFurtherStart(effects, ok, nok) {
  const self = this;
  return furtherStart;

  /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */
  function furtherStart(code) {
    // To do: improve `lazy` / `pierce` handling.
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return furtherStart;
    }

    // To do: the code here in `micromark-js` is a bit different from
    // `markdown-rs` because there it can attempt spaces.
    // We can’t yet.
    //
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code);
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : markdownLineEnding(code) ? furtherStart(code) : nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous: previous$1
};

// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4;
  let headEnterIndex = 3;
  /** @type {number} */
  let index;
  /** @type {number | undefined} */
  let enter;

  // If we start and end with an EOL or a space.
  if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
    index = headEnterIndex;

    // And we have data.
    while (++index < tailExitIndex) {
      if (events[index][1].type === "codeTextData") {
        // Then we have padding.
        events[headEnterIndex][1].type = "codeTextPadding";
        events[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }

  // Merge adjacent spaces and data.
  index = headEnterIndex - 1;
  tailExitIndex++;
  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== "lineEnding") {
        enter = index;
      }
    } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
      events[enter][1].type = "codeTextData";
      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end;
        events.splice(enter + 2, index - enter - 2);
        tailExitIndex -= index - enter - 2;
        index = enter + 2;
      }
      enter = undefined;
    }
  }
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previous$1(code) {
  // If there is a previous code, there will always be a tail.
  return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeText(effects, ok, nok) {
  let sizeOpen = 0;
  /** @type {number} */
  let size;
  /** @type {Token} */
  let token;
  return start;

  /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code);
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 96) {
      effects.consume(code);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code);
  }

  /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */
  function between(code) {
    // EOF.
    if (code === null) {
      return nok(code);
    }

    // To do: next major: don’t do spaces in resolve, but when compiling,
    // like `markdown-rs`.
    // Tabs don’t work, and virtual spaces don’t make sense.
    if (code === 32) {
      effects.enter('space');
      effects.consume(code);
      effects.exit('space');
      return between;
    }

    // Closing fence? Could also be data.
    if (code === 96) {
      token = effects.enter("codeTextSequence");
      size = 0;
      return sequenceClose(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return between;
    }

    // Data.
    effects.enter("codeTextData");
    return data(code);
  }

  /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (code === null || code === 32 || code === 96 || markdownLineEnding(code)) {
      effects.exit("codeTextData");
      return between(code);
    }
    effects.consume(code);
    return data;
  }

  /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */
  function sequenceClose(code) {
    // More.
    if (code === 96) {
      effects.consume(code);
      size++;
      return sequenceClose;
    }

    // Done!
    if (size === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok(code);
    }

    // More or less accents: mark as data.
    token.type = "codeTextData";
    return data(code);
  }
}

/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push[...newElements]` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial) {
    /** @type {Array<T>} */
    this.left = initial ? [...initial] : [];
    /** @type {Array<T>} */
    this.right = [];
  }

  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index) {
    if (index < 0 || index >= this.left.length + this.right.length) {
      throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
    }
    if (index < this.left.length) return this.left[index];
    return this.right[this.right.length - index + this.left.length - 1];
  }

  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }

  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    this.setCursor(0);
    return this.right.pop();
  }

  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start, end) {
    /** @type {number} */
    const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
    if (stop < this.left.length) {
      return this.left.slice(start, stop);
    }
    if (start > this.left.length) {
      return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
    }
    return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }

  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start, deleteCount, items) {
    /** @type {number} */
    const count = deleteCount || 0;
    this.setCursor(Math.trunc(start));
    const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
    if (items) chunkedPush(this.left, items);
    return removed.reverse();
  }

  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    this.setCursor(Number.POSITIVE_INFINITY);
    return this.left.pop();
  }

  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY);
    this.left.push(item);
  }

  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY);
    chunkedPush(this.left, items);
  }

  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0);
    this.right.push(item);
  }

  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0);
    chunkedPush(this.right, items.reverse());
  }

  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
    if (n < this.left.length) {
      // Move cursor to the this.left
      const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
      chunkedPush(this.right, removed.reverse());
    } else {
      // Move cursor to the this.right
      const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
      chunkedPush(this.left, removed.reverse());
    }
  }
}

/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */
function chunkedPush(list, right) {
  /** @type {number} */
  let chunkStart = 0;
  if (right.length < 10000) {
    list.push(...right);
  } else {
    while (chunkStart < right.length) {
      list.push(...right.slice(chunkStart, chunkStart + 10000));
      chunkStart += 10000;
    }
  }
}

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */


/**
 * Tokenize subcontent.
 *
 * @param {Array<Event>} eventsArray
 *   List of events.
 * @returns {boolean}
 *   Whether subtokens were found.
 */
// eslint-disable-next-line complexity
function subtokenize(eventsArray) {
  /** @type {Record<string, number>} */
  const jumps = {};
  let index = -1;
  /** @type {Event} */
  let event;
  /** @type {number | undefined} */
  let lineIndex;
  /** @type {number} */
  let otherIndex;
  /** @type {Event} */
  let otherEvent;
  /** @type {Array<Event>} */
  let parameters;
  /** @type {Array<Event>} */
  let subevents;
  /** @type {boolean | undefined} */
  let more;
  const events = new SpliceBuffer(eventsArray);
  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index];
    }
    event = events.get(index);

    // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.
    if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }

    // Enter.
    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index));
        index = jumps[index];
        more = true;
      }
    }
    // Exit.
    else if (event[1]._container) {
      otherIndex = index;
      lineIndex = undefined;
      while (otherIndex--) {
        otherEvent = events.get(otherIndex);
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events.get(lineIndex)[1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else {
          break;
        }
      }
      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events.get(lineIndex)[1].start);

        // Switch container exit w/ line endings.
        parameters = events.slice(lineIndex, index);
        parameters.unshift(event);
        events.splice(lineIndex, index - lineIndex + 1, parameters);
      }
    }
  }

  // The changes to the `events` buffer must be copied back into the eventsArray
  splice(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
  return !more;
}

/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */
function subcontent(events, eventIndex) {
  const token = events.get(eventIndex)[1];
  const context = events.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  /** @type {Array<number>} */
  const startPositions = [];
  const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
  const childEvents = tokenizer.events;
  /** @type {Array<[number, number]>} */
  const jumps = [];
  /** @type {Record<string, number>} */
  const gaps = {};
  /** @type {Array<Chunk>} */
  let stream;
  /** @type {Token | undefined} */
  let previous;
  let index = -1;
  /** @type {Token | undefined} */
  let current = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start];

  // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.
  while (current) {
    // Find the position of the event for this token.
    while (events.get(++startPosition)[1] !== current) {
      // Empty.
    }
    startPositions.push(startPosition);
    if (!current._tokenizer) {
      stream = context.sliceStream(current);
      if (!current.next) {
        stream.push(null);
      }
      if (previous) {
        tokenizer.defineSkip(current.start);
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined;
      }
    }

    // Unravel the next token.
    previous = current;
    current = current.next;
  }

  // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.
  current = token;
  while (++index < childEvents.length) {
    if (
    // Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
      start = index + 1;
      breaks.push(start);
      // Help GC.
      current._tokenizer = undefined;
      current.previous = undefined;
      current = current.next;
    }
  }

  // Help GC.
  tokenizer.events = [];

  // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.
  if (current) {
    // Help GC.
    current._tokenizer = undefined;
    current.previous = undefined;
  } else {
    breaks.pop();
  }

  // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.
  index = breaks.length;
  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1]);
    const start = startPositions.pop();
    jumps.push([start, start + slice.length - 1]);
    events.splice(start, 2, slice);
  }
  jumps.reverse();
  index = -1;
  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
    adjust += jumps[index][1] - jumps[index][0] - 1;
  }
  return gaps;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
};

/** @type {Construct} */
const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
};

/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */
function resolveContent(events) {
  subtokenize(events);
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContent(effects, ok) {
  /** @type {Token | undefined} */
  let previous;
  return chunkStart;

  /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */
  function chunkStart(code) {
    effects.enter("content");
    previous = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code);
  }

  /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */
  function chunkInside(code) {
    if (code === null) {
      return contentEnd(code);
    }

    // To do: in `markdown-rs`, each line is parsed on its own, and everything
    // is stitched together resolving.
    if (markdownLineEnding(code)) {
      return effects.check(continuationConstruct, contentContinue, contentEnd)(code);
    }

    // Data.
    effects.consume(code);
    return chunkInside;
  }

  /**
   *
   *
   * @type {State}
   */
  function contentEnd(code) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok(code);
  }

  /**
   *
   *
   * @type {State}
   */
  function contentContinue(code) {
    effects.consume(code);
    effects.exit("chunkContent");
    previous.next = effects.enter("chunkContent", {
      contentType: "content",
      previous
    });
    previous = previous.next;
    return chunkInside;
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContinuation(effects, ok, nok) {
  const self = this;
  return startLookahead;

  /**
   *
   *
   * @type {State}
   */
  function startLookahead(code) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }

  /**
   *
   *
   * @type {State}
   */
  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code);
    }

    // Always populated by defaults.

    const tail = self.events[self.events.length - 1];
    if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok(code);
    }
    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */

/**
 * Parse destinations.
 *
 * ###### Examples
 *
 * ```markdown
 * <a>
 * <a\>b>
 * <a b>
 * <a)>
 * a
 * a\)b
 * a(b)c
 * a(b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type for whole (`<a>` or `b`).
 * @param {TokenType} literalType
 *   Type when enclosed (`<a>`).
 * @param {TokenType} literalMarkerType
 *   Type for enclosing (`<` and `>`).
 * @param {TokenType} rawType
 *   Type when not enclosed (`b`).
 * @param {TokenType} stringType
 *   Type for the value (`a` or `b`).
 * @param {number | undefined} [max=Infinity]
 *   Depth of nested parens (inclusive).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start

  /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      return enclosedBefore
    }

    // ASCII control, space, closing paren.
    if (code === null || code === 32 || code === 41 || asciiControl(code)) {
      return nok(code)
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return raw(code)
  }

  /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok
    }
    effects.enter(stringType);
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return enclosed(code)
  }

  /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosed(code) {
    if (code === 62) {
      effects.exit('chunkString');
      effects.exit(stringType);
      return enclosedBefore(code)
    }
    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }
    effects.consume(code);
    return code === 92 ? enclosedEscape : enclosed
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */
  function enclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code);
      return enclosed
    }
    return enclosed(code)
  }

  /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function raw(code) {
    if (
      !balance &&
      (code === null || code === 41 || markdownLineEndingOrSpace(code))
    ) {
      effects.exit('chunkString');
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok(code)
    }
    if (balance < limit && code === 40) {
      effects.consume(code);
      balance++;
      return raw
    }
    if (code === 41) {
      effects.consume(code);
      balance--;
      return raw
    }

    // ASCII control (but *not* `\0`) and space and `(`.
    // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
    // doesn’t.
    if (code === null || code === 32 || code === 40 || asciiControl(code)) {
      return nok(code)
    }
    effects.consume(code);
    return code === 92 ? rawEscape : raw
  }

  /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */
  function rawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code);
      return raw
    }
    return raw(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */

/**
 * Parse labels.
 *
 * > 👉 **Note**: labels in markdown are capped at 999 characters in the string.
 *
 * ###### Examples
 *
 * ```markdown
 * [a]
 * [a
 * b]
 * [a\]b]
 * ```
 *
 * @this {TokenizeContext}
 *   Tokenize context.
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole label (`[a]`).
 * @param {TokenType} markerType
 *   Type for the markers (`[` and `]`).
 * @param {TokenType} stringType
 *   Type for the identifier (`a`).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this;
  let size = 0;
  /** @type {boolean} */
  let seen;
  return start

  /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak
  }

  /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (
      size > 999 ||
      code === null ||
      code === 91 ||
      (code === 93 && !seen) ||
      // To do: remove in the future once we’ve switched from
      // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
      // which doesn’t need this.
      // Hidden footnotes hook.
      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok
    }

    // To do: indent? Link chunks and EOLs together?
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return atBreak
    }
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return labelInside(code)
  }

  /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString');
      return atBreak(code)
    }
    effects.consume(code);
    if (!seen) seen = !markdownSpace(code);
    return code === 92 ? labelEscape : labelInside
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return labelInside
    }
    return labelInside(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */

/**
 * Parse titles.
 *
 * ###### Examples
 *
 * ```markdown
 * "a"
 * 'b'
 * (c)
 * "a
 * b"
 * 'a
 *     b'
 * (a\)b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole title (`"a"`, `'b'`, `(c)`).
 * @param {TokenType} markerType
 *   Type for the markers (`"`, `'`, `(`, and `)`).
 * @param {TokenType} stringType
 *   Type for the value (`a`).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker;
  return start

  /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 34 || code === 39 || code === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      marker = code === 40 ? 41 : code;
      return begin
    }
    return nok(code)
  }

  /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function begin(code) {
    if (code === marker) {
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok
    }
    effects.enter(stringType);
    return atBreak(code)
  }

  /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.exit(stringType);
      return begin(marker)
    }
    if (code === null) {
      return nok(code)
    }

    // Note: blank lines can’t exist in content.
    if (markdownLineEnding(code)) {
      // To do: use `space_or_tab_eol_with_options`, connect.
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return factorySpace(effects, atBreak, 'linePrefix')
    }
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return inside(code)
  }

  /**
   *
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString');
      return atBreak(code)
    }
    effects.consume(code);
    return code === 92 ? escape : inside
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */
  function escape(code) {
    if (code === marker || code === 92) {
      effects.consume(code);
      return inside
    }
    return inside(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   line endings or spaces in markdown are often optional, in which case this
 *     factory can be used and `ok` will be switched to whether spaces were found
 *     or not
 * *   one line ending or space can be detected with
 *     `markdownLineEndingOrSpace(code)` right before using `factoryWhitespace`
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @returns {State}
 *   Start state.
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen;
  return start

  /** @type {State} */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      seen = true;
      return start
    }
    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }
    return ok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const definition$1 = {
  name: 'definition',
  tokenize: tokenizeDefinition
};

/** @type {Construct} */
const titleBefore = {
  tokenize: tokenizeTitleBefore,
  partial: true
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinition(effects, ok, nok) {
  const self = this;
  /** @type {string} */
  let identifier;
  return start;

  /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Do not interrupt paragraphs (but do follow definitions).
    // To do: do `interrupt` the way `markdown-rs` does.
    // To do: parse whitespace the way `markdown-rs` does.
    effects.enter("definition");
    return before(code);
  }

  /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    // To do: parse whitespace the way `markdown-rs` does.

    return factoryLabel.call(self, effects, labelAfter,
    // Note: we don’t need to reset the way `markdown-rs` does.
    nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
  }

  /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    identifier = normalizeIdentifier(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
    if (code === 58) {
      effects.enter("definitionMarker");
      effects.consume(code);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code);
  }

  /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */
  function markerAfter(code) {
    // Note: whitespace is optional.
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, destinationBefore)(code) : destinationBefore(code);
  }

  /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */
  function destinationBefore(code) {
    return factoryDestination(effects, destinationAfter,
    // Note: we don’t need to reset the way `markdown-rs` does.
    nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
  }

  /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function destinationAfter(code) {
    return effects.attempt(titleBefore, after, after)(code);
  }

  /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return markdownSpace(code) ? factorySpace(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
  }

  /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function afterWhitespace(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("definition");

      // Note: we don’t care about uniqueness.
      // It’s likely that that doesn’t happen very frequently.
      // It is more likely that it wastes precious time.
      self.parser.defined.push(identifier);

      // To do: `markdown-rs` interrupt.
      // // You’d be interrupting.
      // tokenizer.interrupt = true
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTitleBefore(effects, ok, nok) {
  return titleBefore;

  /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function titleBefore(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, beforeMarker)(code) : nok(code);
  }

  /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function beforeMarker(code) {
    return factoryTitle(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
  }

  /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfter(code) {
    return markdownSpace(code) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
  }

  /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfterOptionalWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start;

  /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("hardBreakEscape");
    effects.consume(code);
    return after;
  }

  /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */
  function after(code) {
    if (markdownLineEnding(code)) {
      effects.exit("hardBreakEscape");
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};

/** @type {Resolver} */
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2;
  let contentStart = 3;
  /** @type {Token} */
  let content;
  /** @type {Token} */
  let text;

  // Prefix whitespace, part of the opening.
  if (events[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }

  // Suffix whitespace, part of the closing.
  if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content = {
      type: "atxHeadingText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text = {
      type: "chunkText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: "text"
    };
    splice(events, contentStart, contentEnd - contentStart + 1, [['enter', content, context], ['enter', text, context], ['exit', text, context], ['exit', content, context]]);
  }
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHeadingAtx(effects, ok, nok) {
  let size = 0;
  return start;

  /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    effects.enter("atxHeading");
    return before(code);
  }

  /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code);
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code);
      return sequenceOpen;
    }

    // Always at least one `#`.
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code);
    }
    return nok(code);
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code);
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("atxHeading");
      // To do: interrupt like `markdown-rs`.
      // // Feel free to interrupt.
      // tokenizer.interrupt = false
      return ok(code);
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, "whitespace")(code);
    }

    // To do: generate `data` tokens, add the `text` token later.
    // Needs edit map, see: `markdown.rs`.
    effects.enter("atxHeadingText");
    return data(code);
  }

  /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */
  function sequenceFurther(code) {
    if (code === 35) {
      effects.consume(code);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code);
  }

  /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit("atxHeadingText");
      return atBreak(code);
    }
    effects.consume(code);
    return data;
  }
}

/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'search',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];

/**
 * List of lowercase HTML “raw” tag names.
 *
 * The list, when parsing HTML (flow), results in HTML that can include lines
 * without exiting, until a closing tag also in this list is found (condition
 * 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea'];

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
};

/** @type {Construct} */
const blankLineBefore = {
  tokenize: tokenizeBlankLineBefore,
  partial: true
};
const nonLazyContinuationStart = {
  tokenize: tokenizeNonLazyContinuationStart,
  partial: true
};

/** @type {Resolver} */
function resolveToHtmlFlow(events) {
  let index = events.length;
  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") {
      break;
    }
  }
  if (index > 1 && events[index - 2][1].type === "linePrefix") {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start;
    // Add the prefix start to the HTML line token.
    events[index + 1][1].start = events[index - 2][1].start;
    // Remove the line prefix.
    events.splice(index - 2, 2);
  }
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this;
  /** @type {number} */
  let marker;
  /** @type {boolean} */
  let closingTag;
  /** @type {string} */
  let buffer;
  /** @type {number} */
  let index;
  /** @type {Code} */
  let markerB;
  return start;

  /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    return before(code);
  }

  /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code);
    return open;
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      closingTag = true;
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      marker = 3;
      // To do:
      // tokenizer.concrete = true
      // To do: use `markdown-rs` style interrupt.
      // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.
      return self.interrupt ? ok : continuationDeclarationInside;
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      // @ts-expect-error: not null.
      buffer = String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      marker = 2;
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      marker = 5;
      index = 0;
      return cdataOpenInside;
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      marker = 4;
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code);
  }

  /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code);
  }

  /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = "CDATA[";
    if (code === value.charCodeAt(index++)) {
      effects.consume(code);
      if (index === value.length) {
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code);
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      // @ts-expect-error: not null.
      buffer = String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }

  /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */
  function tagName(code) {
    if (code === null || code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      const slash = code === 47;
      const name = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name)) {
        marker = 1;
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code);
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code);
          return basicSelfClosing;
        }

        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code);
      }
      marker = 7;
      // Do not support complete HTML when interrupting.
      return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
    }

    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }

  /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */
  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code);
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuation;
    }
    return nok(code);
  }

  /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeClosingTagAfter;
    }
    return completeEnd(code);
  }

  /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code);
      return completeEnd;
    }

    // ASCII alphanumerical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameBefore;
    }
    return completeEnd(code);
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeName(code) {
    // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code);
  }

  /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code);
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      markerB = code;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code);
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuoted(code) {
    if (code === markerB) {
      effects.consume(code);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code === null || markdownLineEnding(code)) {
      return nok(code);
    }
    effects.consume(code);
    return completeAttributeValueQuoted;
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || markdownLineEndingOrSpace(code)) {
      return completeAttributeNameAfter(code);
    }
    effects.consume(code);
    return completeAttributeValueUnquoted;
  }

  /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code);
    }
    return nok(code);
  }

  /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */
  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }

  /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      // // Do not form containers.
      // tokenizer.concrete = true
      return continuation(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }

  /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */
  function continuation(code) {
    if (code === 45 && marker === 2) {
      effects.consume(code);
      return continuationCommentInside;
    }
    if (code === 60 && marker === 1) {
      effects.consume(code);
      return continuationRawTagOpen;
    }
    if (code === 62 && marker === 4) {
      effects.consume(code);
      return continuationClose;
    }
    if (code === 63 && marker === 3) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    if (code === 93 && marker === 5) {
      effects.consume(code);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(blankLineBefore, continuationAfter, continuationStart)(code);
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("htmlFlowData");
      return continuationStart(code);
    }
    effects.consume(code);
    return continuation;
  }

  /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStart(code) {
    return effects.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
  }

  /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStartNonLazy(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return continuationBefore;
  }

  /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */
  function continuationBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return continuationStart(code);
    }
    effects.enter("htmlFlowData");
    return continuation(code);
  }

  /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */
  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }

  /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */
  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code);
      buffer = '';
      return continuationRawEndTag;
    }
    return continuation(code);
  }

  /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */
  function continuationRawEndTag(code) {
    if (code === 62) {
      const name = buffer.toLowerCase();
      if (htmlRawNames.includes(name)) {
        effects.consume(code);
        return continuationClose;
      }
      return continuation(code);
    }
    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code);
      // @ts-expect-error: not null.
      buffer += String.fromCharCode(code);
      return continuationRawEndTag;
    }
    return continuation(code);
  }

  /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */
  function continuationCdataInside(code) {
    if (code === 93) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }

  /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */
  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code);
      return continuationClose;
    }

    // More dashes.
    if (code === 45 && marker === 2) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }

  /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code);
    }
    effects.consume(code);
    return continuationClose;
  }

  /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationAfter(code) {
    effects.exit("htmlFlow");
    // // Feel free to interrupt.
    // tokenizer.interrupt = false
    // // No longer concrete.
    // tokenizer.concrete = false
    return ok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return after;
    }
    return nok(code);
  }

  /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlankLineBefore(effects, ok, nok) {
  return start;

  /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok, nok);
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHtmlText(effects, ok, nok) {
  const self = this;
  /** @type {NonNullable<Code> | undefined} */
  let marker;
  /** @type {number} */
  let index;
  /** @type {State} */
  let returnState;
  return start;

  /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code);
    return open;
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      return instruction;
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagOpen;
    }
    return nok(code);
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      index = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      return declaration;
    }
    return nok(code);
  }

  /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      return commentEnd;
    }
    return nok(code);
  }

  /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function comment(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 45) {
      effects.consume(code);
      return commentClose;
    }
    if (markdownLineEnding(code)) {
      returnState = comment;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return comment;
  }

  /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */
  function commentClose(code) {
    if (code === 45) {
      effects.consume(code);
      return commentEnd;
    }
    return comment(code);
  }

  /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */
  function commentEnd(code) {
    return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
  }

  /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = "CDATA[";
    if (code === value.charCodeAt(index++)) {
      effects.consume(code);
      return index === value.length ? cdata : cdataOpenInside;
    }
    return nok(code);
  }

  /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */
  function cdata(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataClose;
    }
    if (markdownLineEnding(code)) {
      returnState = cdata;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return cdata;
  }

  /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }

  /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */
  function cdataEnd(code) {
    if (code === 62) {
      return end(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }

  /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function declaration(code) {
    if (code === null || code === 62) {
      return end(code);
    }
    if (markdownLineEnding(code)) {
      returnState = declaration;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return declaration;
  }

  /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function instruction(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 63) {
      effects.consume(code);
      return instructionClose;
    }
    if (markdownLineEnding(code)) {
      returnState = instruction;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return instruction;
  }

  /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code);
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagClose;
    }
    return nok(code);
  }

  /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagClose(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagClose;
    }
    return tagCloseBetween(code);
  }

  /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagCloseBetween;
    }
    return end(code);
  }

  /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpen(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpen;
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }

  /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code);
      return end;
    }

    // ASCII alphabetical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenBetween;
    }
    return end(code);
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeName(code) {
    // ASCII alphabetical and `-`, `.`, `:`, and `_`.
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code);
  }

  /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code);
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code);
      marker = undefined;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code === null) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueQuoted;
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) {
      return nok(code);
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  }

  /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }

  /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function end(code) {
    if (code === 62) {
      effects.consume(code);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok;
    }
    return nok(code);
  }

  /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */
  function lineEndingBefore(code) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }

  /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfter(code) {
    // Always populated by defaults.

    return markdownSpace(code) ? factorySpace(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
  }

  /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfterPrefix(code) {
    effects.enter("htmlTextData");
    return returnState(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
};

/** @type {Construct} */
const resourceConstruct = {
  tokenize: tokenizeResource
};
/** @type {Construct} */
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
/** @type {Construct} */
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};

/** @type {Resolver} */
function resolveAllLabelEnd(events) {
  let index = -1;
  while (++index < events.length) {
    const token = events[index][1];
    if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      // Remove the marker.
      events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
      token.type = "data";
      index++;
    }
  }
  return events;
}

/** @type {Resolver} */
function resolveToLabelEnd(events, context) {
  let index = events.length;
  let offset = 0;
  /** @type {Token} */
  let token;
  /** @type {number | undefined} */
  let open;
  /** @type {number | undefined} */
  let close;
  /** @type {Array<Event>} */
  let media;

  // Find an opening.
  while (index--) {
    token = events[index][1];
    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }

      // Mark other link openings as inactive, as we can’t have links in
      // links.
      if (events[index][0] === 'enter' && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index;
        if (token.type !== "labelLink") {
          offset = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index;
    }
  }
  const group = {
    type: events[open][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const label = {
    type: "label",
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  };
  const text = {
    type: "labelText",
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  };
  media = [['enter', group, context], ['enter', label, context]];

  // Opening marker.
  media = push(media, events.slice(open + 1, open + offset + 3));

  // Text open.
  media = push(media, [['enter', text, context]]);

  // Always populated by defaults.

  // Between.
  media = push(media, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));

  // Text close, marker close, label close.
  media = push(media, [['exit', text, context], events[close - 2], events[close - 1], ['exit', label, context]]);

  // Reference, resource, or so.
  media = push(media, events.slice(close + 1));

  // Media close.
  media = push(media, [['exit', group, context]]);
  splice(events, open, events.length, media);
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelEnd(effects, ok, nok) {
  const self = this;
  let index = self.events.length;
  /** @type {Token} */
  let labelStart;
  /** @type {boolean} */
  let defined;

  // Find an opening.
  while (index--) {
    if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
      labelStart = self.events[index][1];
      break;
    }
  }
  return start;

  /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // If there is not an okay opening.
    if (!labelStart) {
      return nok(code);
    }

    // If the corresponding label (link) start is marked as inactive,
    // it means we’d be wrapping a link, like this:
    //
    // ```markdown
    // > | a [b [c](d) e](f) g.
    //                  ^
    // ```
    //
    // We can’t have that, so it’s just balanced brackets.
    if (labelStart._inactive) {
      return labelEndNok(code);
    }
    defined = self.parser.defined.includes(normalizeIdentifier(self.sliceSerialize({
      start: labelStart.end,
      end: self.now()
    })));
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after;
  }

  /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
    // an extension.

    // Resource (`[asd](fgh)`)?
    if (code === 40) {
      return effects.attempt(resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
    }

    // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
    if (code === 91) {
      return effects.attempt(referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
    }

    // Shortcut (`[asd]`) reference?
    return defined ? labelEndOk(code) : labelEndNok(code);
  }

  /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceNotFull(code) {
    return effects.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
  }

  /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndOk(code) {
    // Note: `markdown-rs` does a bunch of stuff here.
    return ok(code);
  }

  /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndNok(code) {
    labelStart._balanced = true;
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeResource(effects, ok, nok) {
  return resourceStart;

  /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */
  function resourceStart(code) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code);
    effects.exit("resourceMarker");
    return resourceBefore;
  }

  /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceBefore(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceOpen)(code) : resourceOpen(code);
  }

  /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceOpen(code) {
    if (code === 41) {
      return resourceEnd(code);
    }
    return factoryDestination(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
  }

  /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceBetween)(code) : resourceEnd(code);
  }

  /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationMissing(code) {
    return nok(code);
  }

  /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */
  function resourceBetween(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
    }
    return resourceEnd(code);
  }

  /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */
  function resourceTitleAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceEnd)(code) : resourceEnd(code);
  }

  /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceEnd(code) {
    if (code === 41) {
      effects.enter("resourceMarker");
      effects.consume(code);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok;
    }
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeReferenceFull(effects, ok, nok) {
  const self = this;
  return referenceFull;

  /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFull(code) {
    return factoryLabel.call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
  }

  /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */
  function referenceFullAfter(code) {
    return self.parser.defined.includes(normalizeIdentifier(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
  }

  /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFullMissing(code) {
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeReferenceCollapsed(effects, ok, nok) {
  return referenceCollapsedStart;

  /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceCollapsedStart(code) {
    // We only attempt a collapsed label if there’s a `[`.

    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }

  /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */
  function referenceCollapsedOpen(code) {
    if (code === 93) {
      effects.enter("referenceMarker");
      effects.consume(code);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok;
    }
    return nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code);
    effects.exit("labelImageMarker");
    return open;
  }

  /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 91) {
      effects.enter("labelMarker");
      effects.consume(code);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after;
    }
    return nok(code);
  }

  /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // To do: use a new field to do this, this is still needed for
    // `micromark-extension-gfm-footnote`, but the `label-start-link`
    // behavior isn’t.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this;
  return start;

  /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after;
  }

  /** @type {State} */
  function after(code) {
    // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
    // remove.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLineEnding(effects, ok) {
  return start;

  /** @type {State} */
  function start(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, ok, "linePrefix");
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const thematicBreak$2 = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
};

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0;
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter("thematicBreak");
    // To do: parse indent like `markdown-rs`.
    return before(code);
  }

  /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    marker = code;
    return atBreak(code);
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code);
    }
    if (size >= 3 && (code === null || markdownLineEnding(code))) {
      effects.exit("thematicBreak");
      return ok(code);
    }
    return nok(code);
  }

  /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequence(code) {
    if (code === marker) {
      effects.consume(code);
      size++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code) ? factorySpace(effects, atBreak, "whitespace")(code) : atBreak(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const list$2 = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
};

/** @type {Construct} */
const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
};

/** @type {Construct} */
const indentConstruct = {
  tokenize: tokenizeIndent$1,
  partial: true
};

// To do: `markdown-rs` parses list items on their own and later stitches them
// together.

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListStart(effects, ok, nok) {
  const self = this;
  const tail = self.events[self.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size = 0;
  return start;

  /** @type {State} */
  function start(code) {
    const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : asciiDigit(code)) {
      if (!self.containerState.type) {
        self.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code === 42 || code === 45 ? effects.check(thematicBreak$2, nok, atMarker)(code) : atMarker(code);
      }
      if (!self.interrupt || code === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside(code);
      }
    }
    return nok(code);
  }

  /** @type {State} */
  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code);
      return inside;
    }
    if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
      effects.exit("listItemValue");
      return atMarker(code);
    }
    return nok(code);
  }

  /**
   * @type {State}
   **/
  function atMarker(code) {
    effects.enter("listItemMarker");
    effects.consume(code);
    effects.exit("listItemMarker");
    self.containerState.marker = self.containerState.marker || code;
    return effects.check(blankLine,
    // Can’t be empty when interrupting.
    self.interrupt ? nok : onBlank, effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
  }

  /** @type {State} */
  function onBlank(code) {
    self.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code);
  }

  /** @type {State} */
  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code);
  }

  /** @type {State} */
  function endOfPrefix(code) {
    self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok(code);
  }
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListContinuation(effects, ok, nok) {
  const self = this;
  self.containerState._closeFlow = undefined;
  return effects.check(blankLine, onBlank, notBlank);

  /** @type {State} */
  function onBlank(code) {
    self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;

    // We have a blank line.
    // Still, try to consume at most the items size.
    return factorySpace(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
  }

  /** @type {State} */
  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined;
      self.containerState.initialBlankLine = undefined;
      return notInCurrentItem(code);
    }
    self.containerState.furtherBlankLines = undefined;
    self.containerState.initialBlankLine = undefined;
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code);
  }

  /** @type {State} */
  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true;
    // As we’re closing flow, we’re no longer interrupting.
    self.interrupt = undefined;
    // Always populated by defaults.

    return factorySpace(effects, effects.attempt(list$2, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
  }
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeIndent$1(effects, ok, nok) {
  const self = this;
  return factorySpace(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
  }
}

/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this;

  // Always populated by defaults.

  return factorySpace(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4 + 1);

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return !markdownSpace(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};

/** @type {Resolver} */
function resolveToSetextUnderline(events, context) {
  // To do: resolve like `markdown-rs`.
  let index = events.length;
  /** @type {number | undefined} */
  let content;
  /** @type {number | undefined} */
  let text;
  /** @type {number | undefined} */
  let definition;

  // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.
  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === "content") {
        content = index;
        break;
      }
      if (events[index][1].type === "paragraph") {
        text = index;
      }
    }
    // Exit
    else {
      if (events[index][1].type === "content") {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
      }
      if (!definition && events[index][1].type === "definition") {
        definition = index;
      }
    }
  }
  const heading = {
    type: "setextHeading",
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };

  // Change the paragraph to setext heading text.
  events[text][1].type = "setextHeadingText";

  // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.
  if (definition) {
    events.splice(text, 0, ['enter', heading, context]);
    events.splice(definition + 1, 0, ['exit', events[content][1], context]);
    events[content][1].end = Object.assign({}, events[definition][1].end);
  } else {
    events[content][1] = heading;
  }

  // Add the heading exit at the end.
  events.push(['exit', heading, context]);
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this;
  /** @type {NonNullable<Code>} */
  let marker;
  return start;

  /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    let index = self.events.length;
    /** @type {boolean | undefined} */
    let paragraph;
    // Find an opening.
    while (index--) {
      // Skip enter/exit of line ending, line prefix, and content.
      // We can now either have a definition or a paragraph.
      if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
        paragraph = self.events[index][1].type === "paragraph";
        break;
      }
    }

    // To do: handle lazy/pierce like `markdown-rs`.
    // To do: parse indent like `markdown-rs`.
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      marker = code;
      return before(code);
    }
    return nok(code);
  }

  /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter("setextHeadingLineSequence");
    return inside(code);
  }

  /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code);
      return inside;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code) ? factorySpace(effects, after, "lineSuffix")(code) : after(code);
  }

  /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("setextHeadingLine");
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/** @type {InitialConstruct} */
const flow$1 = {
  tokenize: initializeFlow
};

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeFlow(effects) {
  const self = this;
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  );
  return initial

  /** @type {State} */
  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code);
      return
    }
    effects.enter('lineEndingBlank');
    effects.consume(code);
    effects.exit('lineEndingBlank');
    self.currentConstruct = undefined;
    return initial
  }

  /** @type {State} */
  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return
    }
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    self.currentConstruct = undefined;
    return initial
  }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

const resolver = {
  resolveAll: createResolver()
};
const string$3 = initializeFactory('string');
const text$6 = initializeFactory('text');

/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }

  /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */
  function initializeText(effects) {
    const self = this;
    const constructs = this.parser.constructs[field];
    const text = effects.attempt(constructs, start, notText);
    return start

    /** @type {State} */
    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }

    /** @type {State} */
    function notText(code) {
      if (code === null) {
        effects.consume(code);
        return
      }
      effects.enter('data');
      effects.consume(code);
      return data
    }

    /** @type {State} */
    function data(code) {
      if (atBreak(code)) {
        effects.exit('data');
        return text(code)
      }

      // Data.
      effects.consume(code);
      return data
    }

    /**
     * @param {Code} code
     * @returns {boolean}
     */
    function atBreak(code) {
      if (code === null) {
        return true
      }
      const list = constructs[code];
      let index = -1;
      if (list) {
        // Always populated by defaults.

        while (++index < list.length) {
          const item = list[index];
          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }
      return false
    }
  }
}

/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */
function createResolver(extraResolver) {
  return resolveAllText

  /** @type {Resolver} */
  function resolveAllText(events, context) {
    let index = -1;
    /** @type {number | undefined} */
    let enter;

    // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.
    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index;
          index++;
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end;
          events.splice(enter + 2, index - enter - 2);
          index = enter + 2;
        }
        enter = undefined;
      }
    }
    return extraResolver ? extraResolver(events, context) : events
  }
}

/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0; // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index = chunks.length;
      let bufferIndex = -1;
      let size = 0;
      /** @type {boolean | undefined} */
      let tabs;
      while (index--) {
        const chunk = chunks[index];
        if (typeof chunk === 'string') {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++;
            bufferIndex--;
          }
          if (bufferIndex) break
          bufferIndex = -1;
        }
        // Number
        else if (chunk === -2) {
          tabs = true;
          size++;
        } else if (chunk === -1) ; else {
          // Replacement character, exit.
          index++;
          break
        }
      }
      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        };
        data.end = Object.assign({}, token.start);
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          );
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events
}

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_bufferIndex' | '_index'> | undefined} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  /** @type {Record<string, number>} */
  const columnStart = {};
  /** @type {Array<Construct>} */
  const resolveAllConstructs = [];
  /** @type {Array<Chunk>} */
  let chunks = [];
  /** @type {Array<Token>} */
  let stack = [];

  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */
  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };

  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */
  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  };

  /**
   * The state function.
   *
   * @type {State | undefined}
   */
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context

  /** @type {TokenizeContext['write']} */
  function write(slice) {
    chunks = push(chunks, slice);
    main();

    // Exit if we’re not done, resolve might change stuff.
    if (chunks[chunks.length - 1] !== null) {
      return []
    }
    addResult(initialize, 0);

    // Otherwise, resolve, and exit.
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events
  }

  //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }

  /** @type {TokenizeContext['sliceStream']} */
  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }

  /** @type {TokenizeContext['now']} */
  function now() {
    // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
    const {line, column, offset, _index, _bufferIndex} = point;
    return {
      line,
      column,
      offset,
      _index,
      _bufferIndex
    }
  }

  /** @type {TokenizeContext['defineSkip']} */
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }

  //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   */
  function main() {
    /** @type {number} */
    let chunkIndex;
    while (point._index < chunks.length) {
      const chunk = chunks[point._index];

      // If we’re in a buffer chunk, loop through it.
      if (typeof chunk === 'string') {
        chunkIndex = point._index;
        if (point._bufferIndex < 0) {
          point._bufferIndex = 0;
        }
        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }

  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {undefined}
   */
  function go(code) {
    state = state(code);
  }

  /** @type {Effects['consume']} */
  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++;
      point.column = 1;
      point.offset += code === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code !== -1) {
      point.column++;
      point.offset++;
    }

    // Not in a string chunk.
    if (point._bufferIndex < 0) {
      point._index++;
    } else {
      point._bufferIndex++;

      // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.
      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1;
        point._index++;
      }
    }

    // Expose the previous character.
    context.previous = code;
  }

  /** @type {Effects['enter']} */
  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(['enter', token, context]);
    stack.push(token);
    return token
  }

  /** @type {Effects['exit']} */
  function exit(type) {
    const token = stack.pop();
    token.end = now();
    context.events.push(['exit', token, context]);
    return token
  }

  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }

  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulcheck(_, info) {
    info.restore();
  }

  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */
  function constructFactory(onreturn, fields) {
    return hook

    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */
    function hook(constructs, returnState, bogusState) {
      /** @type {Array<Construct>} */
      let listOfConstructs;
      /** @type {number} */
      let constructIndex;
      /** @type {Construct} */
      let currentConstruct;
      /** @type {Info} */
      let info;
      return Array.isArray(constructs) /* c8 ignore next 1 */
        ? handleListOfConstructs(constructs)
        : 'tokenize' in constructs
        ? // @ts-expect-error Looks like a construct.
          handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)

      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */
      function handleMapOfConstructs(map) {
        return start

        /** @type {State} */
        function start(code) {
          const def = code !== null && map[code];
          const all = code !== null && map.null;
          const list = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ];
          return handleListOfConstructs(list)(code)
        }
      }

      /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */
      function handleListOfConstructs(list) {
        listOfConstructs = list;
        constructIndex = 0;
        if (list.length === 0) {
          return bogusState
        }
        return handleConstruct(list[constructIndex])
      }

      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */
      function handleConstruct(construct) {
        return start

        /** @type {State} */
        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }

          // Always populated by defaults.

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok()
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }

      /** @type {State} */
      function ok(code) {
        onreturn(currentConstruct, info);
        return returnState
      }

      /** @type {State} */
      function nok(code) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }
        return bogusState
      }
    }
  }

  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {undefined}
   */
  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      );
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }

  /**
   * Store state.
   *
   * @returns {Info}
   */
  function store() {
    const startPoint = now();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      restore,
      from: startEventsIndex
    }

    /**
     * Restore state.
     *
     * @returns {undefined}
     */
    function restore() {
      point = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }

  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   */
  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line];
      point.offset += columnStart[point.line] - 1;
    }
  }
}

/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */
function sliceChunks(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  /** @type {Array<Chunk>} */
  let view;
  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === 'string') {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view
}

/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */
function serializeChunks(chunks, expandTabs) {
  let index = -1;
  /** @type {Array<string>} */
  const result = [];
  /** @type {boolean | undefined} */
  let atTab;
  while (++index < chunks.length) {
    const chunk = chunks[index];
    /** @type {string} */
    let value;
    if (typeof chunk === 'string') {
      value = chunk;
    } else
      switch (chunk) {
        case -5: {
          value = '\r';
          break
        }
        case -4: {
          value = '\n';
          break
        }
        case -3: {
          value = '\r' + '\n';
          break
        }
        case -2: {
          value = expandTabs ? ' ' : '\t';
          break
        }
        case -1: {
          if (!expandTabs && atTab) continue
          value = ' ';
          break
        }
        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk);
        }
      }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join('')
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */


/** @satisfies {Extension['document']} */
const document$1 = {
  [42]: list$2,
  [43]: list$2,
  [45]: list$2,
  [48]: list$2,
  [49]: list$2,
  [50]: list$2,
  [51]: list$2,
  [52]: list$2,
  [53]: list$2,
  [54]: list$2,
  [55]: list$2,
  [56]: list$2,
  [57]: list$2,
  [62]: blockQuote
};

/** @satisfies {Extension['contentInitial']} */
const contentInitial = {
  [91]: definition$1
};

/** @satisfies {Extension['flowInitial']} */
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};

/** @satisfies {Extension['flow']} */
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak$2,
  [45]: [setextUnderline, thematicBreak$2],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak$2,
  [96]: codeFenced,
  [126]: codeFenced
};

/** @satisfies {Extension['string']} */
const string$2 = {
  [38]: characterReference,
  [92]: characterEscape
};

/** @satisfies {Extension['text']} */
const text$5 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};

/** @satisfies {Extension['insideSpan']} */
const insideSpan = {
  null: [attention, resolver]
};

/** @satisfies {Extension['attentionMarkers']} */
const attentionMarkers = {
  null: [42, 95]
};

/** @satisfies {Extension['disable']} */
const disable = {
  null: []
};

const defaultConstructs = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	attentionMarkers,
	contentInitial,
	disable,
	document: document$1,
	flow,
	flowInitial,
	insideSpan,
	string: string$2,
	text: text$5
}, Symbol.toStringTag, { value: 'Module' }));

/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */


/**
 * @param {ParseOptions | null | undefined} [options]
 * @returns {ParseContext}
 */
function parse(options) {
  const settings = options || {};
  const constructs =
    /** @type {FullNormalizedExtension} */
    combineExtensions([defaultConstructs, ...(settings.extensions || [])]);

  /** @type {ParseContext} */
  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content$1),
    document: create(document$2),
    flow: create(flow$1),
    string: create(string$3),
    text: create(text$6)
  };
  return parser

  /**
   * @param {InitialConstruct} initial
   */
  function create(initial) {
    return creator
    /** @type {Create} */
    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

/**
 * @typedef {import('micromark-util-types').Event} Event
 */


/**
 * @param {Array<Event>} events
 * @returns {Array<Event>}
 */
function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }
  return events
}

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */

const search$1 = /[\0\t\n\r]/g;

/**
 * @returns {Preprocessor}
 */
function preprocess() {
  let column = 1;
  let buffer = '';
  /** @type {boolean | undefined} */
  let start = true;
  /** @type {boolean | undefined} */
  let atCarriageReturn;
  return preprocessor

  /** @type {Preprocessor} */
  // eslint-disable-next-line complexity
  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = [];
    /** @type {RegExpMatchArray | null} */
    let match;
    /** @type {number} */
    let next;
    /** @type {number} */
    let startPosition;
    /** @type {number} */
    let endPosition;
    /** @type {Code} */
    let code;
    value =
      buffer +
      (typeof value === 'string'
        ? value.toString()
        : new TextDecoder(encoding || undefined).decode(value));
    startPosition = 0;
    buffer = '';
    if (start) {
      // To do: `markdown-rs` actually parses BOMs (byte order mark).
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = undefined;
    }
    while (startPosition < value.length) {
      search$1.lastIndex = startPosition;
      match = search$1.exec(value);
      endPosition =
        match && match.index !== undefined ? match.index : value.length;
      code = value.charCodeAt(endPosition);
      if (!match) {
        buffer = value.slice(startPosition);
        break
      }
      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = undefined;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = undefined;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        switch (code) {
          case 0: {
            chunks.push(65533);
            column++;
            break
          }
          case 9: {
            next = Math.ceil(column / 4) * 4;
            chunks.push(-2);
            while (column++ < next) chunks.push(-1);
            break
          }
          case 10: {
            chunks.push(-4);
            column = 1;
            break
          }
          default: {
            atCarriageReturn = true;
            column = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks
  }
}

const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;

/**
 * Decode markdown strings (which occur in places such as fenced code info
 * strings, destinations, labels, and titles).
 *
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 *   Value to decode.
 * @returns {string}
 *   Decoded value.
 */
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */
function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  }

  // Reference.
  const head = $2.charCodeAt(0);
  if (head === 35) {
    const head = $2.charCodeAt(1);
    const hex = head === 120 || head === 88;
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }
  return decodeNamedCharacterReference($2) || $0
}

/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('../index.js').CompileData} CompileData
 */

const own$5 = {}.hasOwnProperty;

/**
 * Turn markdown into a syntax tree.
 *
 * @overload
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {Options | null | undefined} [options]
 * @returns {Root}
 *
 * @overload
 * @param {Value} value
 * @param {Options | null | undefined} [options]
 * @returns {Root}
 *
 * @param {Value} value
 *   Markdown to parse.
 * @param {Encoding | Options | null | undefined} [encoding]
 *   Character encoding for when `value` is `Buffer`.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {Root}
 *   mdast tree.
 */
function fromMarkdown(value, encoding, options) {
  if (typeof encoding !== 'string') {
    options = encoding;
    encoding = undefined;
  }
  return compiler(options)(postprocess(parse(options).document().write(preprocess()(value, encoding, true))));
}

/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */
function compiler(options) {
  /** @type {Config} */
  const config = {
    transforms: [],
    canContainEols: ['emphasis', 'fragment', 'heading', 'paragraph', 'strong'],
    enter: {
      autolink: opener(link),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading),
      blockQuote: opener(blockQuote),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis),
      hardBreakEscape: opener(hardBreak),
      hardBreakTrailing: opener(hardBreak),
      htmlFlow: opener(html, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html, buffer),
      htmlTextData: onenterdata,
      image: opener(image),
      label: buffer,
      link: opener(link),
      listItem: opener(listItem),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list, onenterlistordered),
      listUnordered: opener(list),
      paragraph: opener(paragraph),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading),
      strong: opener(strong),
      thematicBreak: opener(thematicBreak)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      characterReference: onexitcharacterreference,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  };
  configure(config, (options || {}).mdastExtensions || []);

  /** @type {CompileData} */
  const data = {};
  return compile;

  /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */
  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    };
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */
    const context = {
      stack: [tree],
      tokenStack: [],
      config,
      enter,
      exit,
      buffer,
      resume,
      data
    };
    /** @type {Array<number>} */
    const listStack = [];
    let index = -1;
    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
        if (events[index][0] === 'enter') {
          listStack.push(index);
        } else {
          const tail = listStack.pop();
          index = prepareList(events, tail, index);
        }
      }
    }
    index = -1;
    while (++index < events.length) {
      const handler = config[events[index][0]];
      if (own$5.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(Object.assign({
          sliceSerialize: events[index][2].sliceSerialize
        }, context), events[index][1]);
      }
    }

    // Handle tokens still being open.
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1];
      const handler = tail[1] || defaultOnError;
      handler.call(context, undefined, tail[0]);
    }

    // Figure out `root` position.
    tree.position = {
      start: point$1(events.length > 0 ? events[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point$1(events.length > 0 ? events[events.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    };

    // Call transforms.
    index = -1;
    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree;
    }
    return tree;
  }

  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */
  function prepareList(events, start, length) {
    let index = start - 1;
    let containerBalance = -1;
    let listSpread = false;
    /** @type {Token | undefined} */
    let listItem;
    /** @type {number | undefined} */
    let lineIndex;
    /** @type {number | undefined} */
    let firstBlankLineIndex;
    /** @type {boolean | undefined} */
    let atMarker;
    while (++index <= length) {
      const event = events[index];
      switch (event[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote":
          {
            if (event[0] === 'enter') {
              containerBalance++;
            } else {
              containerBalance--;
            }
            atMarker = undefined;
            break;
          }
        case "lineEndingBlank":
          {
            if (event[0] === 'enter') {
              if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) {
                firstBlankLineIndex = index;
              }
              atMarker = undefined;
            }
            break;
          }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          {
            // Empty.

            break;
          }
        default:
          {
            atMarker = undefined;
          }
      }
      if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
        if (listItem) {
          let tailIndex = index;
          lineIndex = undefined;
          while (tailIndex--) {
            const tailEvent = events[tailIndex];
            if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
              if (tailEvent[0] === 'exit') continue;
              if (lineIndex) {
                events[lineIndex][1].type = "lineEndingBlank";
                listSpread = true;
              }
              tailEvent[1].type = "lineEnding";
              lineIndex = tailIndex;
            } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ; else {
              break;
            }
          }
          if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) {
            listItem._spread = true;
          }

          // Fix position.
          listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]]);
          index++;
          length++;
        }

        // Create a new list item.
        if (event[1].type === "listItemPrefix") {
          /** @type {Token} */
          const item = {
            type: 'listItem',
            _spread: false,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: undefined
          };
          listItem = item;
          events.splice(index, 0, ['enter', item, event[2]]);
          index++;
          length++;
          firstBlankLineIndex = undefined;
          atMarker = true;
        }
      }
    }
    events[start][1]._spread = listSpread;
    return length;
  }

  /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function opener(create, and) {
    return open;

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */
    function open(token) {
      enter.call(this, create(token), token);
      if (and) and.call(this, token);
    }
  }

  /**
   * @this {CompileContext}
   * @returns {undefined}
   */
  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    });
  }

  /**
   * @this {CompileContext}
   *   Context.
   * @param {Nodes} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {undefined}
   *   Nothing.
   */
  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1];
    /** @type {Array<Nodes>} */
    const siblings = parent.children;
    siblings.push(node);
    this.stack.push(node);
    this.tokenStack.push([token, errorHandler]);
    node.position = {
      start: point$1(token.start),
      // @ts-expect-error: `end` will be patched later.
      end: undefined
    };
  }

  /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function closer(and) {
    return close;

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */
    function close(token) {
      if (and) and.call(this, token);
      exit.call(this, token);
    }
  }

  /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {undefined}
   *   Nothing.
   */
  function exit(token, onExitError) {
    const node = this.stack.pop();
    const open = this.tokenStack.pop();
    if (!open) {
      throw new Error('Cannot close `' + token.type + '` (' + stringifyPosition({
        start: token.start,
        end: token.end
      }) + '): it’s not open');
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0]);
      } else {
        const handler = open[1] || defaultOnError;
        handler.call(this, token, open[0]);
      }
    }
    node.position.end = point$1(token.end);
  }

  /**
   * @this {CompileContext}
   * @returns {string}
   */
  function resume() {
    return toString$2(this.stack.pop());
  }

  //
  // Handlers.
  //

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistordered() {
    this.data.expectingFirstListItemValue = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistitemvalue(token) {
    if (this.data.expectingFirstListItemValue) {
      const ancestor = this.stack[this.stack.length - 2];
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
      this.data.expectingFirstListItemValue = undefined;
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfenceinfo() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.lang = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfencemeta() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.meta = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (this.data.flowCodeInside) return;
    this.buffer();
    this.data.flowCodeInside = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefenced() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
    this.data.flowCodeInside = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodeindented() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data.replace(/(\r?\n|\r)$/g, '');
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitionlabelstring(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiontitlestring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.title = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiondestinationstring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.url = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitatxheadingsequence(token) {
    const node = this.stack[this.stack.length - 1];
    if (!node.depth) {
      const depth = this.sliceSerialize(token).length;
      node.depth = depth;
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadingtext() {
    this.data.setextHeadingSlurpLineEnding = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadinglinesequence(token) {
    const node = this.stack[this.stack.length - 1];
    node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheading() {
    this.data.setextHeadingSlurpLineEnding = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterdata(token) {
    const node = this.stack[this.stack.length - 1];
    /** @type {Array<Nodes>} */
    const siblings = node.children;
    let tail = siblings[siblings.length - 1];
    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text();
      tail.position = {
        start: point$1(token.start),
        // @ts-expect-error: we’ll add `end` later.
        end: undefined
      };
      siblings.push(tail);
    }
    this.stack.push(tail);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitdata(token) {
    const tail = this.stack.pop();
    tail.value += this.sliceSerialize(token);
    tail.position.end = point$1(token.end);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1];
    // If we’re at a hard break, include the line ending in there.
    if (this.data.atHardBreak) {
      const tail = context.children[context.children.length - 1];
      tail.position.end = point$1(token.end);
      this.data.atHardBreak = undefined;
      return;
    }
    if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
      onenterdata.call(this, token);
      onexitdata.call(this, token);
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithardbreak() {
    this.data.atHardBreak = true;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmlflow() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmltext() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcodetext() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.value = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlink() {
    const node = this.stack[this.stack.length - 1];
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.

    // To do: clean.
    if (this.data.inReference) {
      /** @type {ReferenceType} */
      const referenceType = this.data.referenceType || 'shortcut';
      node.type += 'Reference';
      // @ts-expect-error: mutate.
      node.referenceType = referenceType;
      // @ts-expect-error: mutate.
      delete node.url;
      delete node.title;
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier;
      // @ts-expect-error: mutate.
      delete node.label;
    }
    this.data.referenceType = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitimage() {
    const node = this.stack[this.stack.length - 1];
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.

    // To do: clean.
    if (this.data.inReference) {
      /** @type {ReferenceType} */
      const referenceType = this.data.referenceType || 'shortcut';
      node.type += 'Reference';
      // @ts-expect-error: mutate.
      node.referenceType = referenceType;
      // @ts-expect-error: mutate.
      delete node.url;
      delete node.title;
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier;
      // @ts-expect-error: mutate.
      delete node.label;
    }
    this.data.referenceType = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabeltext(token) {
    const string = this.sliceSerialize(token);
    const ancestor = this.stack[this.stack.length - 2];
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    ancestor.label = decodeString(string);
    // @ts-expect-error: same as above.
    ancestor.identifier = normalizeIdentifier(string).toLowerCase();
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1];
    const value = this.resume();
    const node = this.stack[this.stack.length - 1];
    // Assume a reference.
    this.data.inReference = true;
    if (node.type === 'link') {
      /** @type {Array<PhrasingContent>} */
      const children = fragment.children;
      node.children = children;
    } else {
      node.alt = value;
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcedestinationstring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.url = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcetitlestring() {
    const data = this.resume();
    const node = this.stack[this.stack.length - 1];
    node.title = data;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresource() {
    this.data.inReference = undefined;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterreference() {
    this.data.referenceType = 'collapsed';
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitreferencestring(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    node.label = label;
    // @ts-expect-error: same as above.
    node.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
    this.data.referenceType = 'full';
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcharacterreferencemarker(token) {
    this.data.characterReferenceType = token.type;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token);
    const type = this.data.characterReferenceType;
    /** @type {string} */
    let value;
    if (type) {
      value = decodeNumericCharacterReference(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
      this.data.characterReferenceType = undefined;
    } else {
      const result = decodeNamedCharacterReference(data);
      value = result;
    }
    const tail = this.stack[this.stack.length - 1];
    tail.value += value;
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcharacterreference(token) {
    const tail = this.stack.pop();
    tail.position.end = point$1(token.end);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token);
    const node = this.stack[this.stack.length - 1];
    node.url = this.sliceSerialize(token);
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkemail(token) {
    onexitdata.call(this, token);
    const node = this.stack[this.stack.length - 1];
    node.url = 'mailto:' + this.sliceSerialize(token);
  }

  //
  // Creaters.
  //

  /** @returns {Blockquote} */
  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    };
  }

  /** @returns {Code} */
  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    };
  }

  /** @returns {InlineCode} */
  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    };
  }

  /** @returns {Definition} */
  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    };
  }

  /** @returns {Emphasis} */
  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    };
  }

  /** @returns {Heading} */
  function heading() {
    return {
      type: 'heading',
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }

  /** @returns {Break} */
  function hardBreak() {
    return {
      type: 'break'
    };
  }

  /** @returns {Html} */
  function html() {
    return {
      type: 'html',
      value: ''
    };
  }

  /** @returns {Image} */
  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    };
  }

  /** @returns {Link} */
  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    };
  }

  /**
   * @param {Token} token
   * @returns {List}
   */
  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      spread: token._spread,
      children: []
    };
  }

  /**
   * @param {Token} token
   * @returns {ListItem}
   */
  function listItem(token) {
    return {
      type: 'listItem',
      spread: token._spread,
      checked: null,
      children: []
    };
  }

  /** @returns {Paragraph} */
  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    };
  }

  /** @returns {Strong} */
  function strong() {
    return {
      type: 'strong',
      children: []
    };
  }

  /** @returns {Text} */
  function text() {
    return {
      type: 'text',
      value: ''
    };
  }

  /** @returns {ThematicBreak} */
  function thematicBreak() {
    return {
      type: 'thematicBreak'
    };
  }
}

/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */
function point$1(d) {
  return {
    line: d.line,
    column: d.column,
    offset: d.offset
  };
}

/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */
function configure(combined, extensions) {
  let index = -1;
  while (++index < extensions.length) {
    const value = extensions[index];
    if (Array.isArray(value)) {
      configure(combined, value);
    } else {
      extension(combined, value);
    }
  }
}

/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */
function extension(combined, extension) {
  /** @type {keyof Extension} */
  let key;
  for (key in extension) {
    if (own$5.call(extension, key)) {
      switch (key) {
        case 'canContainEols':
          {
            const right = extension[key];
            if (right) {
              combined[key].push(...right);
            }
            break;
          }
        case 'transforms':
          {
            const right = extension[key];
            if (right) {
              combined[key].push(...right);
            }
            break;
          }
        case 'enter':
        case 'exit':
          {
            const right = extension[key];
            if (right) {
              Object.assign(combined[key], right);
            }
            break;
          }
        // No default
      }
    }
  }
}

/** @type {OnEnterError} */
function defaultOnError(left, right) {
  if (left) {
    throw new Error('Cannot close `' + left.type + '` (' + stringifyPosition({
      start: left.start,
      end: left.end
    }) + '): a different token (`' + right.type + '`, ' + stringifyPosition({
      start: right.start,
      end: right.end
    }) + ') is open');
  } else {
    throw new Error('Cannot close document, a token (`' + right.type + '`, ' + stringifyPosition({
      start: right.start,
      end: right.end
    }) + ') is still open');
  }
}

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */


/**
 * Aadd support for parsing from markdown.
 *
 * @param {Readonly<Options> | null | undefined} [options]
 *   Configuration (optional).
 * @returns {undefined}
 *   Nothing.
 */
function remarkParse(options) {
  /** @type {Processor} */
  // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
  const self = this;

  self.parser = parser;

  /**
   * @type {Parser}
   */
  function parser(doc) {
    return fromMarkdown(doc, {
      ...self.data('settings'),
      ...options,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self.data('micromarkExtensions') || [],
      mdastExtensions: self.data('fromMarkdownExtensions') || []
    })
  }
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function blockquote$1(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'blockquote',
    properties: {},
    children: state.wrap(state.all(node), true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */
function hardBreak$1(state, node) {
  /** @type {Element} */
  const result = {type: 'element', tagName: 'br', properties: {}, children: []};
  state.patch(node, result);
  return [state.applyData(node, result), {type: 'text', value: '\n'}]
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function code$2(state, node) {
  const value = node.value ? node.value + '\n' : '';
  /** @type {Properties} */
  const properties = {};

  if (node.lang) {
    properties.className = ['language-' + node.lang];
  }

  // Create `<code>`.
  /** @type {Element} */
  let result = {
    type: 'element',
    tagName: 'code',
    properties,
    children: [{type: 'text', value}]
  };

  if (node.meta) {
    result.data = {meta: node.meta};
  }

  state.patch(node, result);
  result = state.applyData(node, result);

  // Create `<pre>`.
  result = {type: 'element', tagName: 'pre', properties: {}, children: [result]};
  state.patch(node, result);
  return result
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strikethrough(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'del',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function emphasis$1(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'em',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `footnoteReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {FootnoteReference} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnoteReference$1(state, node) {
  const clobberPrefix =
    typeof state.options.clobberPrefix === 'string'
      ? state.options.clobberPrefix
      : 'user-content-';
  const id = String(node.identifier).toUpperCase();
  const safeId = normalizeUri(id.toLowerCase());
  const index = state.footnoteOrder.indexOf(id);
  /** @type {number} */
  let counter;

  let reuseCounter = state.footnoteCounts.get(id);

  if (reuseCounter === undefined) {
    reuseCounter = 0;
    state.footnoteOrder.push(id);
    counter = state.footnoteOrder.length;
  } else {
    counter = index + 1;
  }

  reuseCounter += 1;
  state.footnoteCounts.set(id, reuseCounter);

  /** @type {Element} */
  const link = {
    type: 'element',
    tagName: 'a',
    properties: {
      href: '#' + clobberPrefix + 'fn-' + safeId,
      id:
        clobberPrefix +
        'fnref-' +
        safeId +
        (reuseCounter > 1 ? '-' + reuseCounter : ''),
      dataFootnoteRef: true,
      ariaDescribedBy: ['footnote-label']
    },
    children: [{type: 'text', value: String(counter)}]
  };
  state.patch(node, link);

  /** @type {Element} */
  const sup = {
    type: 'element',
    tagName: 'sup',
    properties: {},
    children: [link]
  };
  state.patch(node, sup);
  return state.applyData(node, sup)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function heading$1(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'h' + node.depth,
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */


/**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */
function html$5(state, node) {
  if (state.options.allowDangerousHtml) {
    /** @type {Raw} */
    const result = {type: 'raw', value: node.value};
    state.patch(node, result);
    return state.applyData(node, result)
  }

  return undefined
}

/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */


/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */
function revert(state, node) {
  const subtype = node.referenceType;
  let suffix = ']';

  if (subtype === 'collapsed') {
    suffix += '[]';
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']';
  }

  if (node.type === 'imageReference') {
    return [{type: 'text', value: '![' + node.alt + suffix}]
  }

  const contents = state.all(node);
  const head = contents[0];

  if (head && head.type === 'text') {
    head.value = '[' + head.value;
  } else {
    contents.unshift({type: 'text', value: '['});
  }

  const tail = contents[contents.length - 1];

  if (tail && tail.type === 'text') {
    tail.value += suffix;
  } else {
    contents.push({type: 'text', value: suffix});
  }

  return contents
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `imageReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ImageReference} node
 *   mdast node.
 * @returns {Array<ElementContent> | ElementContent}
 *   hast node.
 */
function imageReference$1(state, node) {
  const id = String(node.identifier).toUpperCase();
  const definition = state.definitionById.get(id);

  if (!definition) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {src: normalizeUri(definition.url || ''), alt: node.alt};

  if (definition.title !== null && definition.title !== undefined) {
    properties.title = definition.title;
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `image` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Image} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function image$1(state, node) {
  /** @type {Properties} */
  const properties = {src: normalizeUri(node.url)};

  if (node.alt !== null && node.alt !== undefined) {
    properties.alt = node.alt;
  }

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title;
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function inlineCode$1(state, node) {
  /** @type {Text} */
  const text = {type: 'text', value: node.value.replace(/\r?\n|\r/g, ' ')};
  state.patch(node, text);

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'code',
    properties: {},
    children: [text]
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `linkReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {LinkReference} node
 *   mdast node.
 * @returns {Array<ElementContent> | ElementContent}
 *   hast node.
 */
function linkReference$1(state, node) {
  const id = String(node.identifier).toUpperCase();
  const definition = state.definitionById.get(id);

  if (!definition) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {href: normalizeUri(definition.url || '')};

  if (definition.title !== null && definition.title !== undefined) {
    properties.title = definition.title;
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `link` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Link} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function link$1(state, node) {
  /** @type {Properties} */
  const properties = {href: normalizeUri(node.url)};

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title;
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function listItem$1(state, node, parent) {
  const results = state.all(node);
  const loose = parent ? listLoose(parent) : listItemLoose(node);
  /** @type {Properties} */
  const properties = {};
  /** @type {Array<ElementContent>} */
  const children = [];

  if (typeof node.checked === 'boolean') {
    const head = results[0];
    /** @type {Element} */
    let paragraph;

    if (head && head.type === 'element' && head.tagName === 'p') {
      paragraph = head;
    } else {
      paragraph = {type: 'element', tagName: 'p', properties: {}, children: []};
      results.unshift(paragraph);
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift({type: 'text', value: ' '});
    }

    paragraph.children.unshift({
      type: 'element',
      tagName: 'input',
      properties: {type: 'checkbox', checked: node.checked, disabled: true},
      children: []
    });

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    properties.className = ['task-list-item'];
  }

  let index = -1;

  while (++index < results.length) {
    const child = results[index];

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      children.push({type: 'text', value: '\n'});
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      children.push(...child.children);
    } else {
      children.push(child);
    }
  }

  const tail = results[results.length - 1];

  // Add a final eol.
  if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) {
    children.push({type: 'text', value: '\n'});
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'li', properties, children};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @param {Parents} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = false;
  if (node.type === 'list') {
    loose = node.spread || false;
    const children = node.children;
    let index = -1;

    while (!loose && ++index < children.length) {
      loose = listItemLoose(children[index]);
    }
  }

  return loose
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread;

  return spread === null || spread === undefined
    ? node.children.length > 1
    : spread
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function list$1(state, node) {
  /** @type {Properties} */
  const properties = {};
  const results = state.all(node);
  let index = -1;

  if (typeof node.start === 'number' && node.start !== 1) {
    properties.start = node.start;
  }

  // Like GitHub, add a class for custom styling.
  while (++index < results.length) {
    const child = results[index];

    if (
      child.type === 'element' &&
      child.tagName === 'li' &&
      child.properties &&
      Array.isArray(child.properties.className) &&
      child.properties.className.includes('task-list-item')
    ) {
      properties.className = ['contains-task-list'];
      break
    }
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: node.ordered ? 'ol' : 'ul',
    properties,
    children: state.wrap(results, true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function paragraph$1(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'p',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */
function root$5(state, node) {
  /** @type {HastRoot} */
  const result = {type: 'root', children: state.wrap(state.all(node))};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strong$1(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'strong',
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `table` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Table} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function table(state, node) {
  const rows = state.all(node);
  const firstRow = rows.shift();
  /** @type {Array<Element>} */
  const tableContent = [];

  if (firstRow) {
    /** @type {Element} */
    const head = {
      type: 'element',
      tagName: 'thead',
      properties: {},
      children: state.wrap([firstRow], true)
    };
    state.patch(node.children[0], head);
    tableContent.push(head);
  }

  if (rows.length > 0) {
    /** @type {Element} */
    const body = {
      type: 'element',
      tagName: 'tbody',
      properties: {},
      children: state.wrap(rows, true)
    };

    const start = pointStart(node.children[1]);
    const end = pointEnd(node.children[node.children.length - 1]);
    if (start && end) body.position = {start, end};
    tableContent.push(body);
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'table',
    properties: {},
    children: state.wrap(tableContent, true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function tableRow(state, node, parent) {
  const siblings = parent ? parent.children : undefined;
  // Generate a body row when without parent.
  const rowIndex = siblings ? siblings.indexOf(node) : 1;
  const tagName = rowIndex === 0 ? 'th' : 'td';
  // To do: option to use `style`?
  const align = parent && parent.type === 'table' ? parent.align : undefined;
  const length = align ? align.length : node.children.length;
  let cellIndex = -1;
  /** @type {Array<ElementContent>} */
  const cells = [];

  while (++cellIndex < length) {
    // Note: can also be undefined.
    const cell = node.children[cellIndex];
    /** @type {Properties} */
    const properties = {};
    const alignValue = align ? align[cellIndex] : undefined;

    if (alignValue) {
      properties.align = alignValue;
    }

    /** @type {Element} */
    let result = {type: 'element', tagName, properties, children: []};

    if (cell) {
      result.children = state.all(cell);
      state.patch(cell, result);
      result = state.applyData(cell, result);
    }

    cells.push(result);
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'tr',
    properties: {},
    children: state.wrap(cells, true)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function tableCell(state, node) {
  // Note: this function is normally not called: see `table-row` for how rows
  // and their cells are compiled.
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'td', // Assume body cell.
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

const tab = 9; /* `\t` */
const space = 32; /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value);
  const search = /\r?\n|\r/g;
  let match = search.exec(source);
  let last = 0;
  /** @type {Array<string>} */
  const lines = [];

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    );

    last = match.index + match[0].length;
    match = search.exec(source);
  }

  lines.push(trimLine(source.slice(last), last > 0, false));

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0;
  let endIndex = value.length;

  if (start) {
    let code = value.codePointAt(startIndex);

    while (code === tab || code === space) {
      startIndex++;
      code = value.codePointAt(startIndex);
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1);

    while (code === tab || code === space) {
      endIndex--;
      code = value.codePointAt(endIndex - 1);
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `text` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastText} node
 *   mdast node.
 * @returns {HastElement | HastText}
 *   hast node.
 */
function text$4(state, node) {
  /** @type {HastText} */
  const result = {type: 'text', value: trimLines(String(node.value))};
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */


/**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function thematicBreak$1(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'hr',
    properties: {},
    children: []
  };
  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * Default handlers for nodes.
 *
 * @satisfies {import('../state.js').Handlers}
 */
const handlers = {
  blockquote: blockquote$1,
  break: hardBreak$1,
  code: code$2,
  delete: strikethrough,
  emphasis: emphasis$1,
  footnoteReference: footnoteReference$1,
  heading: heading$1,
  html: html$5,
  imageReference: imageReference$1,
  image: image$1,
  inlineCode: inlineCode$1,
  linkReference: linkReference$1,
  link: link$1,
  listItem: listItem$1,
  list: list$1,
  paragraph: paragraph$1,
  // @ts-expect-error: root is different, but hard to type.
  root: root$5,
  strong: strong$1,
  table,
  tableCell,
  tableRow,
  text: text$4,
  thematicBreak: thematicBreak$1,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};

// Return nothing for nodes that are ignored.
function ignore() {
  return undefined
}

const VOID       = -1;
const PRIMITIVE  = 0;
const ARRAY      = 1;
const OBJECT     = 2;
const DATE       = 3;
const REGEXP     = 4;
const MAP        = 5;
const SET        = 6;
const ERROR      = 7;
const BIGINT     = 8;
// export const SYMBOL = 9;

const env = typeof self === "object" ? self : globalThis;
const deserializer = ($, _) => {
  const as = (out, index) => {
    $.set(index, out);
    return out;
  };
  const unpair = (index) => {
    if ($.has(index))
      return $.get(index);
    const [type, value] = _[index];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY: {
        const arr = as([], index);
        for (const index2 of value)
          arr.push(unpair(index2));
        return arr;
      }
      case OBJECT: {
        const object = as({}, index);
        for (const [key, index2] of value)
          object[unpair(key)] = unpair(index2);
        return object;
      }
      case DATE:
        return as(new Date(value), index);
      case REGEXP: {
        const { source, flags } = value;
        return as(new RegExp(source, flags), index);
      }
      case MAP: {
        const map = as(/* @__PURE__ */ new Map(), index);
        for (const [key, index2] of value)
          map.set(unpair(key), unpair(index2));
        return map;
      }
      case SET: {
        const set = as(/* @__PURE__ */ new Set(), index);
        for (const index2 of value)
          set.add(unpair(index2));
        return set;
      }
      case ERROR: {
        const { name, message } = value;
        return as(new env[name](message), index);
      }
      case BIGINT:
        return as(BigInt(value), index);
      case "BigInt":
        return as(Object(BigInt(value)), index);
    }
    return as(new env[type](value), index);
  };
  return unpair;
};
const deserialize = (serialized) => deserializer(/* @__PURE__ */ new Map(), serialized)(0);

const EMPTY = '';

const {toString: toString$1} = {};
const {keys} = Object;

const typeOf = value => {
  const type = typeof value;
  if (type !== 'object' || !value)
    return [PRIMITIVE, type];

  const asString = toString$1.call(value).slice(8, -1);
  switch (asString) {
    case 'Array':
      return [ARRAY, EMPTY];
    case 'Object':
      return [OBJECT, EMPTY];
    case 'Date':
      return [DATE, EMPTY];
    case 'RegExp':
      return [REGEXP, EMPTY];
    case 'Map':
      return [MAP, EMPTY];
    case 'Set':
      return [SET, EMPTY];
  }

  if (asString.includes('Array'))
    return [ARRAY, asString];

  if (asString.includes('Error'))
    return [ERROR, asString];

  return [OBJECT, asString];
};

const shouldSkip = ([TYPE, type]) => (
  TYPE === PRIMITIVE &&
  (type === 'function' || type === 'symbol')
);

const serializer = (strict, json, $, _) => {

  const as = (out, value) => {
    const index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };

  const pair = value => {
    if ($.has(value))
      return $.get(value);

    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case 'bigint':
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case 'function':
          case 'symbol':
            if (strict)
              throw new TypeError('unable to serialize ' + type);
            entry = null;
            break;
          case 'undefined':
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type)
          return as([type, [...value]], value);
  
        const arr = [];
        const index = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case 'BigInt':
              return as([type, value.toString()], value);
            case 'Boolean':
            case 'Number':
            case 'String':
              return as([type, value.valueOf()], value);
          }
        }

        if (json && ('toJSON' in value))
          return pair(value.toJSON());

        const entries = [];
        const index = as([TYPE, entries], value);
        for (const key of keys(value)) {
          if (strict || !shouldSkip(typeOf(value[key])))
            entries.push([pair(key), pair(value[key])]);
        }
        return index;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const {source, flags} = value;
        return as([TYPE, {source, flags}], value);
      }
      case MAP: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const [key, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key), pair(entry)]);
        }
        return index;
      }
      case SET: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index;
      }
    }

    const {message} = value;
    return as([TYPE, {name: type, message}], value);
  };

  return pair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} value a serializable value.
 * @param {{json?: boolean, lossy?: boolean}?} options an object with a `lossy` or `json` property that,
 *  if `true`, will not throw errors on incompatible types, and behave more
 *  like JSON stringify would behave. Symbol and Function will be discarded.
 * @returns {Record[]}
 */
 const serialize$1 = (value, {json, lossy} = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, new Map, _)(value), _;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */
const structuredClone$1 = typeof structuredClone === "function" ?
  /* c8 ignore start */
  (any, options) => (
    options && ('json' in options || 'lossy' in options) ?
      deserialize(serialize$1(any, options)) : structuredClone(any)
  ) :
  (any, options) => deserialize(serialize$1(any, options));

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */


/**
 * Generate the default content that GitHub uses on backreferences.
 *
 * @param {number} _
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent>}
 *   Content.
 */
function defaultFootnoteBackContent(_, rereferenceIndex) {
  /** @type {Array<ElementContent>} */
  const result = [{type: 'text', value: '↩'}];

  if (rereferenceIndex > 1) {
    result.push({
      type: 'element',
      tagName: 'sup',
      properties: {},
      children: [{type: 'text', value: String(rereferenceIndex)}]
    });
  }

  return result
}

/**
 * Generate the default label that GitHub uses on backreferences.
 *
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Label.
 */
function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
  return (
    'Back to reference ' +
    (referenceIndex + 1) +
    (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
  )
}

/**
 * Generate a hast footer for called footnote definitions.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Element | undefined}
 *   `section` element or `undefined`.
 */
// eslint-disable-next-line complexity
function footer(state) {
  const clobberPrefix =
    typeof state.options.clobberPrefix === 'string'
      ? state.options.clobberPrefix
      : 'user-content-';
  const footnoteBackContent =
    state.options.footnoteBackContent || defaultFootnoteBackContent;
  const footnoteBackLabel =
    state.options.footnoteBackLabel || defaultFootnoteBackLabel;
  const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
  const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
  const footnoteLabelProperties = state.options.footnoteLabelProperties || {
    className: ['sr-only']
  };
  /** @type {Array<ElementContent>} */
  const listItems = [];
  let referenceIndex = -1;

  while (++referenceIndex < state.footnoteOrder.length) {
    const definition = state.footnoteById.get(
      state.footnoteOrder[referenceIndex]
    );

    if (!definition) {
      continue
    }

    const content = state.all(definition);
    const id = String(definition.identifier).toUpperCase();
    const safeId = normalizeUri(id.toLowerCase());
    let rereferenceIndex = 0;
    /** @type {Array<ElementContent>} */
    const backReferences = [];
    const counts = state.footnoteCounts.get(id);

    // eslint-disable-next-line no-unmodified-loop-condition
    while (counts !== undefined && ++rereferenceIndex <= counts) {
      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '});
      }

      let children =
        typeof footnoteBackContent === 'string'
          ? footnoteBackContent
          : footnoteBackContent(referenceIndex, rereferenceIndex);

      if (typeof children === 'string') {
        children = {type: 'text', value: children};
      }

      backReferences.push({
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            clobberPrefix +
            'fnref-' +
            safeId +
            (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
          dataFootnoteBackref: '',
          ariaLabel:
            typeof footnoteBackLabel === 'string'
              ? footnoteBackLabel
              : footnoteBackLabel(referenceIndex, rereferenceIndex),
          className: ['data-footnote-backref']
        },
        children: Array.isArray(children) ? children : [children]
      });
    }

    const tail = content[content.length - 1];

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1];
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' ';
      } else {
        tail.children.push({type: 'text', value: ' '});
      }

      tail.children.push(...backReferences);
    } else {
      content.push(...backReferences);
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: clobberPrefix + 'fn-' + safeId},
      children: state.wrap(content, true)
    };

    state.patch(definition, listItem);

    listItems.push(listItem);
  }

  if (listItems.length === 0) {
    return
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: footnoteLabelTagName,
        properties: {
          ...structuredClone$1(footnoteLabelProperties),
          id: 'footnote-label'
        },
        children: [{type: 'text', value: footnoteLabel}]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: state.wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */


/**
 * Generate an assertion from a test.
 *
 * Useful if you’re going to test many nodes, for example when creating a
 * utility where something else passes a compatible test.
 *
 * The created function is a bit faster because it expects valid input only:
 * a `node`, `index`, and `parent`.
 *
 * @param {Test} test
 *   *   when nullish, checks if `node` is a `Node`.
 *   *   when `string`, works like passing `(node) => node.type === test`.
 *   *   when `function` checks if function passed the node is true.
 *   *   when `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
 *   *   when `array`, checks if any one of the subtests pass.
 * @returns {Check}
 *   An assertion.
 */
const convert =
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  (
    /**
     * @param {Test} [test]
     * @returns {Check}
     */
    function (test) {
      if (test === null || test === undefined) {
        return ok
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  );

/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */
function anyFactory(tests) {
  /** @type {Array<Check>} */
  const checks = [];
  let index = -1;

  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @type {TestFunction}
   */
  function any(...parameters) {
    let index = -1;

    while (++index < checks.length) {
      if (checks[index].apply(this, parameters)) return true
    }

    return false
  }
}

/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */
function propsFactory(check) {
  const checkAsRecord = /** @type {Record<string, unknown>} */ (check);

  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    const nodeAsRecord = /** @type {Record<string, unknown>} */ (
      /** @type {unknown} */ (node)
    );

    /** @type {string} */
    let key;

    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false
    }

    return true
  }
}

/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */
function castFactory(testFunction) {
  return check

  /**
   * @this {unknown}
   * @type {Check}
   */
  function check(value, index, parent) {
    return Boolean(
      looksLikeANode(value) &&
        testFunction.call(
          this,
          value,
          typeof index === 'number' ? index : undefined,
          parent || undefined
        )
    )
  }
}

function ok() {
  return true
}

/**
 * @param {unknown} value
 * @returns {value is Node}
 */
function looksLikeANode(value) {
  return value !== null && typeof value === 'object' && 'type' in value
}

/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */


/** @type {Readonly<ActionTuple>} */
const empty = [];

/**
 * Continue traversing as normal.
 */
const CONTINUE = true;

/**
 * Stop traversing immediately.
 */
const EXIT = false;

/**
 * Do not traverse this node’s children.
 */
const SKIP = 'skip';

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} test
 *   `unist-util-is`-compatible test
 * @param {Visitor | boolean | null | undefined} [visitor]
 *   Handle each node.
 * @param {boolean | null | undefined} [reverse]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visitParents(tree, test, visitor, reverse) {
  /** @type {Test} */
  let check;

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor;
    // @ts-expect-error no visitor given, so `visitor` is test.
    visitor = test;
  } else {
    // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
  }

  const is = convert(check);
  const step = reverse ? -1 : 1;

  factory(tree, undefined, [])();

  /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */
  function factory(node, index, parents) {
    const value = /** @type {Record<string, unknown>} */ (
      node && typeof node === 'object' ? node : {}
    );

    if (typeof value.type === 'string') {
      const name =
        // `hast`
        typeof value.tagName === 'string'
          ? value.tagName
          : // `xast`
          typeof value.name === 'string'
          ? value.name
          : undefined;

      Object.defineProperty(visit, 'name', {
        value:
          'node (' + color(node.type + (name ? '<' + name + '>' : '')) + ')'
      });
    }

    return visit

    function visit() {
      /** @type {Readonly<ActionTuple>} */
      let result = empty;
      /** @type {Readonly<ActionTuple>} */
      let subresult;
      /** @type {number} */
      let offset;
      /** @type {Array<UnistParent>} */
      let grandparents;

      if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
        // @ts-expect-error: `visitor` is now a visitor.
        result = toResult(visitor(node, parents));

        if (result[0] === EXIT) {
          return result
        }
      }

      if ('children' in node && node.children) {
        const nodeAsParent = /** @type {UnistParent} */ (node);

        if (nodeAsParent.children && result[0] !== SKIP) {
          offset = (reverse ? nodeAsParent.children.length : -1) + step;
          grandparents = parents.concat(nodeAsParent);

          while (offset > -1 && offset < nodeAsParent.children.length) {
            const child = nodeAsParent.children[offset];

            subresult = factory(child, offset, grandparents)();

            if (subresult[0] === EXIT) {
              return subresult
            }

            offset =
              typeof subresult[1] === 'number' ? subresult[1] : offset + step;
          }
        }
      }

      return result
    }
  }
}

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return value === null || value === undefined ? empty : [value]
}

/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */


/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @overload
 * @param {Tree} tree
 * @param {Check} check
 * @param {BuildVisitor<Tree, Check>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @overload
 * @param {Tree} tree
 * @param {BuildVisitor<Tree>} visitor
 * @param {boolean | null | undefined} [reverse]
 * @returns {undefined}
 *
 * @param {UnistNode} tree
 *   Tree to traverse.
 * @param {Visitor | Test} testOrVisitor
 *   `unist-util-is`-compatible test (optional, omit to pass a visitor).
 * @param {Visitor | boolean | null | undefined} [visitorOrReverse]
 *   Handle each node (when test is omitted, pass `reverse`).
 * @param {boolean | null | undefined} [maybeReverse=false]
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns {undefined}
 *   Nothing.
 *
 * @template {UnistNode} Tree
 *   Node type.
 * @template {Test} Check
 *   `unist-util-is`-compatible test.
 */
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  /** @type {boolean | null | undefined} */
  let reverse;
  /** @type {Test} */
  let test;
  /** @type {Visitor} */
  let visitor;

  if (
    typeof testOrVisitor === 'function' &&
    typeof visitorOrReverse !== 'function'
  ) {
    test = undefined;
    visitor = testOrVisitor;
    reverse = visitorOrReverse;
  } else {
    // @ts-expect-error: assume the overload with test was given.
    test = testOrVisitor;
    // @ts-expect-error: assume the overload with test was given.
    visitor = visitorOrReverse;
    reverse = maybeReverse;
  }

  visitParents(tree, test, overload, reverse);

  /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */
  function overload(node, parents) {
    const parent = parents[parents.length - 1];
    const index = parent ? parent.children.indexOf(node) : undefined;
    return visitor(node, index, parent)
  }
}

/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */


const own$4 = {}.hasOwnProperty;

/** @type {Options} */
const emptyOptions$1 = {};

/**
 * Create `state` from an mdast tree.
 *
 * @param {MdastNodes} tree
 *   mdast node to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {State}
 *   `state` function.
 */
function createState(tree, options) {
  const settings = options || emptyOptions$1;
  /** @type {Map<string, MdastDefinition>} */
  const definitionById = new Map();
  /** @type {Map<string, MdastFootnoteDefinition>} */
  const footnoteById = new Map();
  /** @type {Map<string, number>} */
  const footnoteCounts = new Map();
  /** @type {Handlers} */
  // @ts-expect-error: the root handler returns a root.
  // Hard to type.
  const handlers$1 = {...handlers, ...settings.handlers};

  /** @type {State} */
  const state = {
    all,
    applyData,
    definitionById,
    footnoteById,
    footnoteCounts,
    footnoteOrder: [],
    handlers: handlers$1,
    one,
    options: settings,
    patch: patch$2,
    wrap: wrap$1
  };

  visit(tree, function (node) {
    if (node.type === 'definition' || node.type === 'footnoteDefinition') {
      const map = node.type === 'definition' ? definitionById : footnoteById;
      const id = String(node.identifier).toUpperCase();

      // Mimick CM behavior of link definitions.
      // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
      if (!map.has(id)) {
        // @ts-expect-error: node type matches map.
        map.set(id, node);
      }
    }
  });

  return state

  /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */
  function one(node, parent) {
    const type = node.type;
    const handle = state.handlers[type];

    if (own$4.call(state.handlers, type) && handle) {
      return handle(state, node, parent)
    }

    if (state.options.passThrough && state.options.passThrough.includes(type)) {
      if ('children' in node) {
        const {children, ...shallow} = node;
        const result = structuredClone$1(shallow);
        // @ts-expect-error: TS doesn’t understand…
        result.children = state.all(node);
        // @ts-expect-error: TS doesn’t understand…
        return result
      }

      // @ts-expect-error: it’s custom.
      return structuredClone$1(node)
    }

    const unknown = state.options.unknownHandler || defaultUnknownHandler;

    return unknown(state, node, parent)
  }

  /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */
  function all(parent) {
    /** @type {Array<HastElementContent>} */
    const values = [];

    if ('children' in parent) {
      const nodes = parent.children;
      let index = -1;
      while (++index < nodes.length) {
        const result = state.one(nodes[index], parent);

        // To do: see if we van clean this? Can we merge texts?
        if (result) {
          if (index && nodes[index - 1].type === 'break') {
            if (!Array.isArray(result) && result.type === 'text') {
              result.value = trimMarkdownSpaceStart(result.value);
            }

            if (!Array.isArray(result) && result.type === 'element') {
              const head = result.children[0];

              if (head && head.type === 'text') {
                head.value = trimMarkdownSpaceStart(head.value);
              }
            }
          }

          if (Array.isArray(result)) {
            values.push(...result);
          } else {
            values.push(result);
          }
        }
      }
    }

    return values
  }
}

/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */
function patch$2(from, to) {
  if (from.position) to.position = position$2(from);
}

/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */
function applyData(from, to) {
  /** @type {HastElement | Type} */
  let result = to;

  // Handle `data.hName`, `data.hProperties, `data.hChildren`.
  if (from && from.data) {
    const hName = from.data.hName;
    const hChildren = from.data.hChildren;
    const hProperties = from.data.hProperties;

    if (typeof hName === 'string') {
      // Transforming the node resulted in an element with a different name
      // than wanted:
      if (result.type === 'element') {
        result.tagName = hName;
      }
      // Transforming the node resulted in a non-element, which happens for
      // raw, text, and root nodes (unless custom handlers are passed).
      // The intent of `hName` is to create an element, but likely also to keep
      // the content around (otherwise: pass `hChildren`).
      else {
        /** @type {Array<HastElementContent>} */
        // @ts-expect-error: assume no doctypes in `root`.
        const children = 'children' in result ? result.children : [result];
        result = {type: 'element', tagName: hName, properties: {}, children};
      }
    }

    if (result.type === 'element' && hProperties) {
      Object.assign(result.properties, structuredClone$1(hProperties));
    }

    if (
      'children' in result &&
      result.children &&
      hChildren !== null &&
      hChildren !== undefined
    ) {
      result.children = hChildren;
    }
  }

  return result
}

/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */
function defaultUnknownHandler(state, node) {
  const data = node.data || {};
  /** @type {HastElement | HastText} */
  const result =
    'value' in node &&
    !(own$4.call(data, 'hProperties') || own$4.call(data, 'hChildren'))
      ? {type: 'text', value: node.value}
      : {
          type: 'element',
          tagName: 'div',
          properties: {},
          children: state.all(node)
        };

  state.patch(node, result);
  return state.applyData(node, result)
}

/**
 * Wrap `nodes` with line endings between each node.
 *
 * @template {HastRootContent} Type
 *   Node type.
 * @param {Array<Type>} nodes
 *   List of nodes to wrap.
 * @param {boolean | undefined} [loose=false]
 *   Whether to add line endings at start and end (default: `false`).
 * @returns {Array<HastText | Type>}
 *   Wrapped nodes.
 */
function wrap$1(nodes, loose) {
  /** @type {Array<HastText | Type>} */
  const result = [];
  let index = -1;

  if (loose) {
    result.push({type: 'text', value: '\n'});
  }

  while (++index < nodes.length) {
    if (index) result.push({type: 'text', value: '\n'});
    result.push(nodes[index]);
  }

  if (loose && nodes.length > 0) {
    result.push({type: 'text', value: '\n'});
  }

  return result
}

/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */
function trimMarkdownSpaceStart(value) {
  let index = 0;
  let code = value.charCodeAt(index);

  while (code === 9 || code === 32) {
    index++;
    code = value.charCodeAt(index);
  }

  return value.slice(index)
}

/**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */


/**
 * Transform mdast to hast.
 *
 * ##### Notes
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most utilities ignore `raw` nodes but two notable ones don’t:
 *
 * *   `hast-util-to-html` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful
 *     if you completely trust authors
 * *   `hast-util-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only
 *     way to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `mdast-util-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * Example: headings (DOM clobbering) in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @param {MdastNodes} tree
 *   mdast tree.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {HastNodes}
 *   hast tree.
 */
function toHast(tree, options) {
  const state = createState(tree, options);
  const node = state.one(tree, undefined);
  const foot = footer(state);
  /** @type {HastNodes} */
  const result = Array.isArray(node)
    ? {type: 'root', children: node}
    : node || {type: 'root', children: []};

  if (foot) {
    result.children.push({type: 'text', value: '\n'}, foot);
  }

  return result
}

// Include `data` fields in mdast and `raw` nodes in hast.
/// <reference types="mdast-util-to-hast" />


/**
 * Turn markdown into HTML.
 *
 * ##### Notes
 *
 * ###### Signature
 *
 * *   if a processor is given, runs the (rehype) plugins used on it with a
 *     hast tree, then discards the result (*bridge mode*)
 * *   otherwise, returns a hast tree, the plugins used after `remarkRehype`
 *     are rehype plugins (*mutate mode*)
 *
 * > 👉 **Note**: It’s highly unlikely that you want to pass a `processor`.
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most plugins ignore `raw` nodes but two notable ones don’t:
 *
 * *   `rehype-stringify` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful if
 *     you completely trust authors
 * *   `rehype-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only way
 *     to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `remark-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * *Example: headings (DOM clobbering)* in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @overload
 * @param {Processor} processor
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformBridge}
 *
 * @overload
 * @param {Readonly<Options> | null | undefined} [options]
 * @returns {TransformMutate}
 *
 * @param {Readonly<Options> | Processor | null | undefined} [destination]
 *   Processor or configuration (optional).
 * @param {Readonly<Options> | null | undefined} [options]
 *   When a processor was given, configuration (optional).
 * @returns {TransformBridge | TransformMutate}
 *   Transform.
 */
function remarkRehype(destination, options) {
  if (destination && 'run' in destination) {
    /**
     * @type {TransformBridge}
     */
    return async function (tree, file) {
      // Cast because root in -> root out.
      const hastTree = /** @type {HastRoot} */ (
        toHast(tree, {file, ...options})
      );
      await destination.run(hastTree, file);
    }
  }

  /**
   * @type {TransformMutate}
   */
  return function (tree, file) {
    // Cast because root in -> root out.
    return /** @type {HastRoot} */ (
      toHast(tree, {file, ...(options || destination)})
    )
  }
}

/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject$4 = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return undefined;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

var extend = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject$4(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject$4(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

const extend$1 = /*@__PURE__*/getDefaultExportFromCjs(extend);

function isPlainObject$3(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.

/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = [];
  /** @type {Pipeline} */
  const pipeline = {run, use};

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1;
    /** @type {Callback} */
    const callback = values.pop();

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values);

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index = -1;

      if (error) {
        callback(error);
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index];
        }
      }

      // Save the newly created `output` for the next call.
      values = output;

      // Next or done.
      if (fn) {
        wrap(fn, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware);
    return pipeline
  }
}

/**
 * Wrap `middleware` into a uniform interface.
 *
 * You can pass all input to the resulting function.
 * `callback` is then called with the output of `middleware`.
 *
 * If `middleware` accepts more arguments than the later given in input,
 * an extra `done` function is passed to it after that input,
 * which must be called by `middleware`.
 *
 * The first value in `input` is the main input value.
 * All other input values are the rest input values.
 * The values given to `callback` are the input values,
 * merged with every non-nullish output value.
 *
 * * if `middleware` throws an error,
 *   returns a promise that is rejected,
 *   or calls the given `done` function with an error,
 *   `callback` is called with that error
 * * if `middleware` returns a value or returns a promise that is resolved,
 *   that value is the main output value
 * * if `middleware` calls `done`,
 *   all non-nullish values except for the first one (the error) overwrite the
 *   output values
 *
 * @param {Middleware} middleware
 *   Function to wrap.
 * @param {Callback} callback
 *   Callback called with the output of `middleware`.
 * @returns {Run}
 *   Wrapped middleware.
 */
function wrap(middleware, callback) {
  /** @type {boolean} */
  let called;

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    /** @type {any} */
    let result;

    if (fnExpectsCallback) {
      parameters.push(done);
    }

    try {
      result = middleware.apply(this, parameters);
    } catch (error) {
      const exception = /** @type {Error} */ (error);

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result && result.then && typeof result.then === 'function') {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }

  /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value);
  }
}

// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const minpath = {basename, dirname, extname, join, sep: '/'};

/* eslint-disable max-depth, complexity */

/**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */
function basename(path, extname) {
  if (extname !== undefined && typeof extname !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath$1(path);
  let start = 0;
  let end = -1;
  let index = path.length;
  /** @type {boolean | undefined} */
  let seenNonSlash;

  if (
    extname === undefined ||
    extname.length === 0 ||
    extname.length > path.length
  ) {
    while (index--) {
      if (path.codePointAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1;
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true;
        end = index + 1;
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (extname === path) {
    return ''
  }

  let firstNonSlashEnd = -1;
  let extnameIndex = extname.length - 1;

  while (index--) {
    if (path.codePointAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1;
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true;
        firstNonSlashEnd = index + 1;
      }

      if (extnameIndex > -1) {
        // Try to match the explicit extension.
        if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index;
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path.length;
  }

  return path.slice(start, end)
}

/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
function dirname(path) {
  assertPath$1(path);

  if (path.length === 0) {
    return '.'
  }

  let end = -1;
  let index = path.length;
  /** @type {boolean | undefined} */
  let unmatchedSlash;

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.codePointAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index;
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true;
    }
  }

  return end < 0
    ? path.codePointAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.codePointAt(0) === 47 /* `/` */
      ? '//'
      : path.slice(0, end)
}

/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */
function extname(path) {
  assertPath$1(path);

  let index = path.length;

  let end = -1;
  let startPart = 0;
  let startDot = -1;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0;
  /** @type {boolean | undefined} */
  let unmatchedSlash;

  while (index--) {
    const code = path.codePointAt(index);

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1;
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true;
      end = index + 1;
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1;
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */
function join(...segments) {
  let index = -1;
  /** @type {string | undefined} */
  let joined;

  while (++index < segments.length) {
    assertPath$1(segments[index]);

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
  }

  return joined === undefined ? '.' : normalize$2(joined)
}

/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function normalize$2(path) {
  assertPath$1(path);

  const absolute = path.codePointAt(0) === 47; /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute);

  if (value.length === 0 && !absolute) {
    value = '.';
  }

  if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */) {
    value += '/';
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */
function normalizeString(path, allowAboveRoot) {
  let result = '';
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index = -1;
  /** @type {number | undefined} */
  let code;
  /** @type {number} */
  let lastSlashIndex;

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.codePointAt(index);
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47; /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) ; else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.codePointAt(result.length - 1) !== 46 /* `.` */ ||
          result.codePointAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/');

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = '';
                lastSegmentLength = 0;
              } else {
                result = result.slice(0, lastSlashIndex);
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
              }

              lastSlash = index;
              dots = 0;
              continue
            }
          } else if (result.length > 0) {
            result = '';
            lastSegmentLength = 0;
            lastSlash = index;
            dots = 0;
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..';
          lastSegmentLength = 2;
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index);
        } else {
          result = path.slice(lastSlash + 1, index);
        }

        lastSegmentLength = index - lastSlash - 1;
      }

      lastSlash = index;
      dots = 0;
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }

  return result
}

/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */
function assertPath$1(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const minproc = {cwd};

function cwd() {
  return '/'
}

/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */
// From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null &&
      typeof fileUrlOrPath === 'object' &&
      'href' in fileUrlOrPath &&
      fileUrlOrPath.href &&
      'protocol' in fileUrlOrPath &&
      fileUrlOrPath.protocol &&
      // @ts-expect-error: indexing is fine.
      fileUrlOrPath.auth === undefined
  )
}

// See: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js>

/**
 * @param {URL | string} path
 *   File URL.
 * @returns {string}
 *   File URL.
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path);
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    );
    error.code = 'ERR_INVALID_ARG_TYPE';
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file');
    error.code = 'ERR_INVALID_URL_SCHEME';
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = 'ERR_INVALID_FILE_URL_HOST';
    throw error
  }

  const pathname = url.pathname;
  let index = -1;

  while (++index < pathname.length) {
    if (
      pathname.codePointAt(index) === 37 /* `%` */ &&
      pathname.codePointAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.codePointAt(index + 2);
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        );
        error.code = 'ERR_INVALID_FILE_URL_PATH';
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}

/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */
const order = /** @type {const} */ ([
  'history',
  'path',
  'basename',
  'stem',
  'extname',
  'dirname'
]);

class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    /** @type {Options | VFile} */
    let options;

    if (!value) {
      options = {};
    } else if (isUrl(value)) {
      options = {path: value};
    } else if (typeof value === 'string' || isUint8Array$1(value)) {
      options = {value};
    } else {
      options = value;
    }

    /* eslint-disable no-unused-expressions */

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */
    // Prevent calling `cwd` (which could be expensive) if it’s not needed;
    // the empty string will be overridden in the next block.
    this.cwd = 'cwd' in options ? '' : minproc.cwd();

    /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */
    this.data = {};

    /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */
    this.history = [];

    /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */
    this.messages = [];

    /**
     * Raw value.
     *
     * @type {Value}
     */
    this.value;

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.
    /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */
    this.map;

    /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */
    this.result;

    /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */
    this.stored;
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1;

    while (++index < order.length) {
      const field = order[index];

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (
        field in options &&
        options[field] !== undefined &&
        options[field] !== null
      ) {
        // @ts-expect-error: TS doesn’t understand basic reality.
        this[field] = field === 'history' ? [...options[field]] : options[field];
      }
    }

    /** @type {string} */
    let field;

    // Set non-path related properties.
    for (field in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(field)) {
        // @ts-expect-error: fine to set other things.
        this[field] = options[field];
      }
    }
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === 'string'
      ? minpath.basename(this.path)
      : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = minpath.join(this.dirname || '', basename);
  }

  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === 'string'
      ? minpath.dirname(this.path)
      : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname) {
    assertPath(this.basename, 'dirname');
    this.path = minpath.join(dirname || '', this.basename);
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === 'string'
      ? minpath.extname(this.path)
      : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname) {
    assertPart(extname, 'extname');
    assertPath(this.dirname, 'extname');

    if (extname) {
      if (extname.codePointAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = minpath.join(this.dirname, this.stem + (extname || ''));
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path);
    }

    assertNonEmpty(path, 'path');

    if (this.path !== path) {
      this.history.push(path);
    }
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === 'string'
      ? minpath.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = minpath.join(this.dirname || '', stem + (this.extname || ''));
  }

  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    // @ts-expect-error: the overloads are fine.
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);

    message.fatal = true;

    throw message
  }

  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    // @ts-expect-error: the overloads are fine.
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);

    message.fatal = undefined;

    return message
  }

  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );

    if (this.path) {
      message.name = this.path + ':' + message.name;
      message.file = this.path;
    }

    message.fatal = false;

    this.messages.push(message);

    return message
  }

  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === undefined) {
      return ''
    }

    if (typeof this.value === 'string') {
      return this.value
    }

    const decoder = new TextDecoder(encoding || undefined);
    return decoder.decode(this.value)
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */
function assertPart(part, name) {
  if (part && part.includes(minpath.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + minpath.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */
function isUint8Array$1(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'byteLength' in value &&
      'byteOffset' in value
  )
}

const CallableInstance =
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  (
    /** @type {unknown} */
    (
      /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */
      function (property) {
        const self = this;
        const constr = self.constructor;
        const proto = /** @type {Record<string | symbol, Function>} */ (
          // Prototypes do exist.
          // type-coverage:ignore-next-line
          constr.prototype
        );
        const value = proto[property];
        /** @type {(...parameters: Array<unknown>) => unknown} */
        const apply = function () {
          return value.apply(apply, arguments)
        };

        Object.setPrototypeOf(apply, proto);

        // Not needed for us in `unified`: we only call this on the `copy`
        // function,
        // and we don't need to add its fields (`length`, `name`)
        // over.
        // See also: GH-246.
        // const names = Object.getOwnPropertyNames(value)
        //
        // for (const p of names) {
        //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
        //   if (descriptor) Object.defineProperty(apply, p, descriptor)
        // }

        return apply
      }
    )
  );

/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.

// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.

const own$3 = {}.hasOwnProperty;

/**
 * @template {Node | undefined} [ParseTree=undefined]
 *   Output of `parse` (optional).
 * @template {Node | undefined} [HeadTree=undefined]
 *   Input for `run` (optional).
 * @template {Node | undefined} [TailTree=undefined]
 *   Output for `run` (optional).
 * @template {Node | undefined} [CompileTree=undefined]
 *   Input of `stringify` (optional).
 * @template {CompileResults | undefined} [CompileResult=undefined]
 *   Output of `stringify` (optional).
 * @extends {CallableInstance<[], Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>>}
 */
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    // If `Processor()` is called (w/o new), `copy` is called instead.
    super('copy');

    /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */
    this.Compiler = undefined;

    /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */
    this.Parser = undefined;

    // Note: the following fields are considered private.
    // However, they are needed for tests, and TSC generates an untyped
    // `private freezeIndex` field for, which trips `type-coverage` up.
    // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
    /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */
    this.attachers = [];

    /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */
    this.compiler = undefined;

    /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */
    this.freezeIndex = -1;

    /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */
    this.frozen = undefined;

    /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */
    this.namespace = {};

    /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */
    this.parser = undefined;

    /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */
    this.transformers = trough();
  }

  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    // Cast as the type parameters will be the same after attaching.
    const destination =
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ (
        new Processor()
      );
    let index = -1;

    while (++index < this.attachers.length) {
      const attacher = this.attachers[index];
      destination.use(...attacher);
    }

    destination.data(extend$1(true, {}, this.namespace));

    return destination
  }

  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', this.frozen);
        this.namespace[key] = value;
        return this
      }

      // Get `key`.
      return (own$3.call(this.namespace, key) && this.namespace[key]) || undefined
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', this.frozen);
      this.namespace = key;
      return this
    }

    // Get space.
    return this.namespace
  }

  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this
    }

    // Cast so that we can type plugins easier.
    // Plugins are supposed to be usable on different processors, not just on
    // this exact processor.
    const self = /** @type {Processor} */ (/** @type {unknown} */ (this));

    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options] = this.attachers[this.freezeIndex];

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined;
      }

      const transformer = attacher.call(self, ...options);

      if (typeof transformer === 'function') {
        this.transformers.use(transformer);
      }
    }

    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;

    return this
  }

  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file);
    const parser = this.parser || this.Parser;
    assertParser('parse', parser);
    return parser(String(realFile), realFile)
  }

  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self = this;

    this.freeze();
    assertParser('process', this.parser || this.Parser);
    assertCompiler('process', this.compiler || this.Compiler);

    return done ? executor(undefined, done) : new Promise(executor)

    // Note: `void`s needed for TS.
    /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */
    function executor(resolve, reject) {
      const realFile = vfile(file);
      // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
      // input of the first transform).
      const parseTree =
        /** @type {HeadTree extends undefined ? Node : HeadTree} */ (
          /** @type {unknown} */ (self.parse(realFile))
        );

      self.run(parseTree, realFile, function (error, tree, file) {
        if (error || !tree || !file) {
          return realDone(error)
        }

        // Assume `TailTree` (the output of the last transform) matches
        // `CompileTree` (the input of the compiler).
        const compileTree =
          /** @type {CompileTree extends undefined ? Node : CompileTree} */ (
            /** @type {unknown} */ (tree)
          );

        const compileResult = self.stringify(compileTree, file);

        if (looksLikeAValue(compileResult)) {
          file.value = compileResult;
        } else {
          file.result = compileResult;
        }

        realDone(error, /** @type {VFileWithOutput<CompileResult>} */ (file));
      });

      /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */
      function realDone(error, file) {
        if (error || !file) {
          reject(error);
        } else if (resolve) {
          resolve(file);
        } else {
          done(undefined, file);
        }
      }
    }
  }

  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    /** @type {boolean} */
    let complete = false;
    /** @type {VFileWithOutput<CompileResult> | undefined} */
    let result;

    this.freeze();
    assertParser('processSync', this.parser || this.Parser);
    assertCompiler('processSync', this.compiler || this.Compiler);

    this.process(file, realDone);
    assertDone('processSync', 'process', complete);

    return result

    /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */
    function realDone(error, file) {
      complete = true;
      bail(error);
      result = file;
    }
  }

  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree);
    this.freeze();

    const transformers = this.transformers;

    if (!done && typeof file === 'function') {
      done = file;
      file = undefined;
    }

    return done ? executor(undefined, done) : new Promise(executor)

    // Note: `void`s needed for TS.
    /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */
    function executor(resolve, reject) {
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);

      /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */
      function realDone(error, outputTree, file) {
        const resultingTree =
          /** @type {TailTree extends undefined ? Node : TailTree} */ (
            outputTree || tree
          );

        if (error) {
          reject(error);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(undefined, resultingTree, file);
        }
      }
    }
  }

  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    /** @type {boolean} */
    let complete = false;
    /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */
    let result;

    this.run(tree, file, realDone);

    assertDone('runSync', 'run', complete);
    return result

    /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */
    function realDone(error, tree) {
      bail(error);
      result = tree;
      complete = true;
    }
  }

  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler('stringify', compiler);
    assertNode(tree);

    return compiler(tree, realFile)
  }

  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;

    assertUnfrozen('use', this.frozen);

    if (value === null || value === undefined) ; else if (typeof value === 'function') {
      addPlugin(value, parameters);
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    return this

    /**
     * @param {Pluggable} value
     * @returns {undefined}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value, []);
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...parameters] =
            /** @type {PluginTuple<Array<unknown>>} */ (value);
          addPlugin(plugin, parameters);
        } else {
          addPreset(value);
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {undefined}
     */
    function addPreset(result) {
      if (!('plugins' in result) && !('settings' in result)) {
        throw new Error(
          'Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither'
        )
      }

      addList(result.plugins);

      if (result.settings) {
        namespace.settings = extend$1(true, namespace.settings, result.settings);
      }
    }

    /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */
    function addList(plugins) {
      let index = -1;

      if (plugins === null || plugins === undefined) ; else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index];
          add(thing);
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */
    function addPlugin(plugin, parameters) {
      let index = -1;
      let entryIndex = -1;

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entryIndex = index;
          break
        }
      }

      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters]);
      }
      // Only set if there was at least a `primary` value, otherwise we’d change
      // `arguments.length`.
      else if (parameters.length > 0) {
        let [primary, ...rest] = parameters;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject$3(currentPrimary) && isPlainObject$3(primary)) {
          primary = extend$1(true, currentPrimary, primary);
        }

        attachers[entryIndex] = [plugin, primary, ...rest];
      }
    }
  }
}

// Note: this returns a *callable* instance.
// That’s why it’s documented as a function.
/**
 * Create a new processor.
 *
 * @example
 *   This example shows how a new processor can be created (from `remark`) and linked
 *   to **stdin**(4) and **stdout**(4).
 *
 *   ```js
 *   import process from 'node:process'
 *   import concatStream from 'concat-stream'
 *   import {remark} from 'remark'
 *
 *   process.stdin.pipe(
 *     concatStream(function (buf) {
 *       process.stdout.write(String(remark().processSync(buf)))
 *     })
 *   )
 *   ```
 *
 * @returns
 *   New *unfrozen* processor (`processor`).
 *
 *   This processor is configured to work the same as its ancestor.
 *   When the descendant processor is configured in the future it does not
 *   affect the ancestral processor.
 */
const unified = new Processor().freeze();

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject$3(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */
function looksLikeAValue(value) {
  return typeof value === 'string' || isUint8Array(value)
}

/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */
function isUint8Array(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'byteLength' in value &&
      'byteOffset' in value
  )
}

// Register `Raw` in tree:
/// <reference types="mdast-util-to-hast" />


const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';

/** @type {PluggableList} */
const emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */
const emptyRemarkRehypeOptions = {allowDangerousHtml: true};
const safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;

// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */
const deprecations = [
  {from: 'astPlugins', id: 'remove-buggy-html-in-markdown-parser'},
  {from: 'allowDangerousHtml', id: 'remove-buggy-html-in-markdown-parser'},
  {
    from: 'allowNode',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'allowElement'
  },
  {
    from: 'allowedTypes',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'allowedElements'
  },
  {
    from: 'disallowedTypes',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes',
    to: 'disallowedElements'
  },
  {from: 'escapeHtml', id: 'remove-buggy-html-in-markdown-parser'},
  {from: 'includeElementIndex', id: '#remove-includeelementindex'},
  {
    from: 'includeNodeIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  },
  {from: 'linkTarget', id: 'remove-linktarget'},
  {from: 'plugins', id: 'change-plugins-to-remarkplugins', to: 'remarkPlugins'},
  {from: 'rawSourcePos', id: '#remove-rawsourcepos'},
  {from: 'renderers', id: 'change-renderers-to-components', to: 'components'},
  {from: 'source', id: 'change-source-to-children', to: 'children'},
  {from: 'sourcePos', id: '#remove-sourcepos'},
  {from: 'transformImageUri', id: '#add-urltransform', to: 'urlTransform'},
  {from: 'transformLinkUri', id: '#add-urltransform', to: 'urlTransform'}
];

/**
 * Component to render markdown.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {JSX.Element}
 *   React element.
 */
function Markdown(options) {
  const allowedElements = options.allowedElements;
  const allowElement = options.allowElement;
  const children = options.children || '';
  const className = options.className;
  const components = options.components;
  const disallowedElements = options.disallowedElements;
  const rehypePlugins = options.rehypePlugins || emptyPlugins;
  const remarkPlugins = options.remarkPlugins || emptyPlugins;
  const remarkRehypeOptions = options.remarkRehypeOptions
    ? {...options.remarkRehypeOptions, ...emptyRemarkRehypeOptions}
    : emptyRemarkRehypeOptions;
  const skipHtml = options.skipHtml;
  const unwrapDisallowed = options.unwrapDisallowed;
  const urlTransform = options.urlTransform || defaultUrlTransform;

  const processor = unified()
    .use(remarkParse)
    .use(remarkPlugins)
    .use(remarkRehype, remarkRehypeOptions)
    .use(rehypePlugins);

  const file = new VFile();

  if (typeof children === 'string') {
    file.value = children;
  }

  for (const deprecation of deprecations) {
    if (Object.hasOwn(options, deprecation.from)) {
      unreachable(
        'Unexpected `' +
          deprecation.from +
          '` prop, ' +
          (deprecation.to
            ? 'use `' + deprecation.to + '` instead'
            : 'remove it') +
          ' (see <' +
          changelog +
          '#' +
          deprecation.id +
          '> for more info)'
      );
    }
  }

  const mdastTree = processor.parse(file);
  /** @type {Nodes} */
  let hastTree = processor.runSync(mdastTree, file);

  // Wrap in `div` if there’s a class name.
  if (className) {
    hastTree = {
      type: 'element',
      tagName: 'div',
      properties: {className},
      // Assume no doctypes.
      children: /** @type {Array<ElementContent>} */ (
        hastTree.type === 'root' ? hastTree.children : [hastTree]
      )
    };
  }

  visit(hastTree, transform);

  return toJsxRuntime(hastTree, {
    Fragment: jsxRuntimeExports.Fragment,
    components,
    ignoreInvalidStyle: true,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: true,
    passNode: true
  })

  /** @type {Visitor} */
  function transform(node, index, parent) {
    if (node.type === 'raw' && parent && typeof index === 'number') {
      if (skipHtml) {
        parent.children.splice(index, 1);
      } else {
        parent.children[index] = {type: 'text', value: node.value};
      }

      return index
    }

    if (node.type === 'element') {
      /** @type {string} */
      let key;

      for (key in urlAttributes) {
        if (
          Object.hasOwn(urlAttributes, key) &&
          Object.hasOwn(node.properties, key)
        ) {
          const value = node.properties[key];
          const test = urlAttributes[key];
          if (test === null || test.includes(node.tagName)) {
            node.properties[key] = urlTransform(String(value || ''), key, node);
          }
        }
      }
    }

    if (node.type === 'element') {
      let remove = allowedElements
        ? !allowedElements.includes(node.tagName)
        : disallowedElements
        ? disallowedElements.includes(node.tagName)
        : false;

      if (!remove && allowElement && typeof index === 'number') {
        remove = !allowElement(node, index, parent);
      }

      if (remove && parent && typeof index === 'number') {
        if (unwrapDisallowed && node.children) {
          parent.children.splice(index, 1, ...node.children);
        } else {
          parent.children.splice(index, 1);
        }

        return index
      }
    }
  }
}

/**
 * Make a URL safe.
 *
 * @satisfies {UrlTransform}
 * @param {string} value
 *   URL.
 * @returns {string}
 *   Safe URL.
 */
function defaultUrlTransform(value) {
  // Same as:
  // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
  // But without the `encode` part.
  const colon = value.indexOf(':');
  const questionMark = value.indexOf('?');
  const numberSign = value.indexOf('#');
  const slash = value.indexOf('/');

  if (
    // If there is no protocol, it’s relative.
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) ||
    // It is a protocol, it should be allowed.
    safeProtocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}

/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value);

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0;
  let index = source.indexOf(character);

  while (index !== -1) {
    count++;
    index = source.indexOf(character, index + character.length);
  }

  return count
}

function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

function findAndReplace(tree, list, options) {
  const settings = options;
  const ignored = convert(settings.ignore || []);
  const pairs = toPairs(list);
  let pairIndex = -1;
  while (++pairIndex < pairs.length) {
    visitParents(tree, "text", visitor);
  }
  function visitor(node, parents) {
    let index = -1;
    let grandparent;
    while (++index < parents.length) {
      const parent = parents[index];
      const siblings = grandparent ? grandparent.children : undefined;
      if (ignored(
        parent,
        siblings ? siblings.indexOf(parent) : undefined,
        grandparent
      )) {
        return;
      }
      grandparent = parent;
    }
    if (grandparent) {
      return handler(node, parents);
    }
  }
  function handler(node, parents) {
    const parent = parents[parents.length - 1];
    const find = pairs[pairIndex][0];
    const replace = pairs[pairIndex][1];
    let start = 0;
    const siblings = parent.children;
    const index = siblings.indexOf(node);
    let change = false;
    let nodes = [];
    find.lastIndex = 0;
    let match = find.exec(node.value);
    while (match) {
      const position = match.index;
      const matchObject = {
        index: match.index,
        input: match.input,
        stack: [...parents, node]
      };
      let value = replace(...match, matchObject);
      if (typeof value === "string") {
        value = value.length > 0 ? { type: "text", value } : undefined;
      }
      if (value === false) {
        find.lastIndex = position + 1;
      } else {
        if (start !== position) {
          nodes.push({
            type: "text",
            value: node.value.slice(start, position)
          });
        }
        if (Array.isArray(value)) {
          nodes.push(...value);
        } else if (value) {
          nodes.push(value);
        }
        start = position + match[0].length;
        change = true;
      }
      if (!find.global) {
        break;
      }
      match = find.exec(node.value);
    }
    if (change) {
      if (start < node.value.length) {
        nodes.push({ type: "text", value: node.value.slice(start) });
      }
      parent.children.splice(index, 1, ...nodes);
    } else {
      nodes = [node];
    }
    return index + nodes.length;
  }
}
function toPairs(tupleOrList) {
  const result = [];
  if (!Array.isArray(tupleOrList)) {
    throw new TypeError("Expected find and replace tuple or list of tuples");
  }
  const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [tupleOrList];
  let index = -1;
  while (++index < list.length) {
    const tuple = list[index];
    result.push([toExpression(tuple[0]), toFunction(tuple[1])]);
  }
  return result;
}
function toExpression(find) {
  return typeof find === "string" ? new RegExp(escapeStringRegexp(find), "g") : find;
}
function toFunction(replace) {
  return typeof replace === "function" ? replace : function() {
    return replace;
  };
}

/**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */


/** @type {ConstructName} */
const inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */
const notInConstruct = ['autolink', 'link', 'image', 'label'];

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM autolink
 * literals in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM autolink literals.
 */
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM autolink
 * literals in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM autolink literals.
 */
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: '@',
        before: '[+\\-.\\w]',
        after: '[\\-.\\w]',
        inConstruct,
        notInConstruct
      },
      {
        character: '.',
        before: '[Ww]',
        after: '[\\-.\\w]',
        inConstruct,
        notInConstruct
      },
      {
        character: ':',
        before: '[ps]',
        after: '\\/',
        inConstruct,
        notInConstruct
      }
    ]
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolink(token) {
  this.enter({type: 'link', title: null, url: '', children: []}, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token);
  const node = this.stack[this.stack.length - 1];
  ok$1(node.type === 'link');
  node.url = 'http://' + this.sliceSerialize(token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolink(token) {
  this.exit(token);
}

/** @type {FromMarkdownTransform} */
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, findEmail]
    ],
    {ignore: ['link', 'linkReference']}
  );
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */
// eslint-disable-next-line max-params
function findUrl(_, protocol, domain, path, match) {
  let prefix = '';

  // Not an expected previous character.
  if (!previous(match)) {
    return false
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain;
    protocol = '';
    prefix = 'http://';
  }

  if (!isCorrectDomain(domain)) {
    return false
  }

  const parts = splitUrl(domain + path);

  if (!parts[0]) return false

  /** @type {Link} */
  const result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{type: 'text', value: protocol + parts[0]}]
  };

  if (parts[1]) {
    return [result, {type: 'text', value: parts[1]}]
  }

  return result
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !previous(match, true) ||
    // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false
  }

  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{type: 'text', value: atext + '@' + label}]
  }
}

/**
 * @param {string} domain
 * @returns {boolean}
 */
function isCorrectDomain(domain) {
  const parts = domain.split('.');

  if (
    parts.length < 2 ||
    (parts[parts.length - 1] &&
      (/_/.test(parts[parts.length - 1]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 1]))) ||
    (parts[parts.length - 2] &&
      (/_/.test(parts[parts.length - 2]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 2])))
  ) {
    return false
  }

  return true
}

/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);

  if (!trailExec) {
    return [url, undefined]
  }

  url = url.slice(0, trailExec.index);

  let trail = trailExec[0];
  let closingParenIndex = trail.indexOf(')');
  const openingParens = ccount(url, '(');
  let closingParens = ccount(url, ')');

  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail.slice(0, closingParenIndex + 1);
    trail = trail.slice(closingParenIndex + 1);
    closingParenIndex = trail.indexOf(')');
    closingParens++;
  }

  return [url, trail]
}

/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */
function previous(match, email) {
  const code = match.input.charCodeAt(match.index - 1);

  return (
    (match.index === 0 ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)) &&
    // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47)
  )
}

/**
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */


footnoteReference.peek = footnoteReferencePeek;

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM footnotes
 * in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown`.
 */
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteDefinition: enterFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteCallString: enterFootnoteCallString
    },
    exit: {
      gfmFootnoteDefinition: exitFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteCallString: exitFootnoteCallString
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM footnotes
 * in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown`.
 */
function gfmFootnoteToMarkdown() {
  return {
    // This is on by default already.
    unsafe: [{character: '[', inConstruct: ['phrasing', 'label', 'reference']}],
    handlers: {footnoteDefinition, footnoteReference}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteDefinition(token) {
  this.enter(
    {type: 'footnoteDefinition', identifier: '', label: '', children: []},
    token
  );
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteDefinitionLabelString(token) {
  const label = this.resume();
  const node = this.stack[this.stack.length - 1];
  ok$1(node.type === 'footnoteDefinition');
  node.label = label;
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase();
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteDefinition(token) {
  this.exit(token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteCall(token) {
  this.enter({type: 'footnoteReference', identifier: '', label: ''}, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteCallString() {
  this.buffer();
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteCallString(token) {
  const label = this.resume();
  const node = this.stack[this.stack.length - 1];
  ok$1(node.type === 'footnoteReference');
  node.label = label;
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase();
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteCall(token) {
  this.exit(token);
}

/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */
function footnoteReference(node, _, state, info) {
  const tracker = state.createTracker(info);
  let value = tracker.move('[^');
  const exit = state.enter('footnoteReference');
  const subexit = state.enter('reference');
  value += tracker.move(
    state.safe(state.associationId(node), {
      ...tracker.current(),
      before: value,
      after: ']'
    })
  );
  subexit();
  exit();
  value += tracker.move(']');
  return value
}

/** @type {ToMarkdownHandle} */
function footnoteReferencePeek() {
  return '['
}

/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */
function footnoteDefinition(node, _, state, info) {
  const tracker = state.createTracker(info);
  let value = tracker.move('[^');
  const exit = state.enter('footnoteDefinition');
  const subexit = state.enter('label');
  value += tracker.move(
    state.safe(state.associationId(node), {
      ...tracker.current(),
      before: value,
      after: ']'
    })
  );
  subexit();
  value += tracker.move(
    ']:' + (node.children && node.children.length > 0 ? ' ' : '')
  );
  tracker.shift(4);
  value += tracker.move(
    state.indentLines(state.containerFlow(node, tracker.current()), map$2)
  );
  exit();

  return value
}

/** @type {Map} */
function map$2(line, index, blank) {
  if (index === 0) {
    return line
  }

  return (blank ? '' : '    ') + line
}

/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */

/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */
const constructsWithoutStrikethrough = [
  'autolink',
  'destinationLiteral',
  'destinationRaw',
  'reference',
  'titleQuote',
  'titleApostrophe'
];

handleDelete.peek = peekDelete;

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM
 * strikethrough in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown` to enable GFM strikethrough.
 */
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ['delete'],
    enter: {strikethrough: enterStrikethrough},
    exit: {strikethrough: exitStrikethrough}
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM
 * strikethrough in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM strikethrough.
 */
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: '~',
        inConstruct: 'phrasing',
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: {delete: handleDelete}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterStrikethrough(token) {
  this.enter({type: 'delete', children: []}, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitStrikethrough(token) {
  this.exit(token);
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, state, info) {
  const tracker = state.createTracker(info);
  const exit = state.enter('strikethrough');
  let value = tracker.move('~~');
  value += state.containerPhrasing(node, {
    ...tracker.current(),
    before: value,
    after: '~'
  });
  value += tracker.move('~~');
  exit();
  return value
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~'
}

/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */

/**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */

/**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat();
  const stringLength = options.stringLength || defaultStringLength;
  /** @type {Array<number>} Character codes as symbols for alignment per column. */
  const alignments = [];
  /** @type {Array<Array<string>>} Cells per row. */
  const cellMatrix = [];
  /** @type {Array<Array<number>>} Sizes of each cell per row. */
  const sizeMatrix = [];
  /** @type {Array<number>} */
  const longestCellByColumn = [];
  let mostCellsPerRow = 0;
  let rowIndex = -1;

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < table.length) {
    /** @type {Array<string>} */
    const row = [];
    /** @type {Array<number>} */
    const sizes = [];
    let columnIndex = -1;

    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length;
    }

    while (++columnIndex < table[rowIndex].length) {
      const cell = serialize(table[rowIndex][columnIndex]);

      if (options.alignDelimiters !== false) {
        const size = stringLength(cell);
        sizes[columnIndex] = size;

        if (
          longestCellByColumn[columnIndex] === undefined ||
          size > longestCellByColumn[columnIndex]
        ) {
          longestCellByColumn[columnIndex] = size;
        }
      }

      row.push(cell);
    }

    cellMatrix[rowIndex] = row;
    sizeMatrix[rowIndex] = sizes;
  }

  // Figure out which alignments to use.
  let columnIndex = -1;

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex]);
    }
  } else {
    const code = toAlignment(align);

    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code;
    }
  }

  // Inject the alignment row.
  columnIndex = -1;
  /** @type {Array<string>} */
  const row = [];
  /** @type {Array<number>} */
  const sizes = [];

  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex];
    let before = '';
    let after = '';

    if (code === 99 /* `c` */) {
      before = ':';
      after = ':';
    } else if (code === 108 /* `l` */) {
      before = ':';
    } else if (code === 114 /* `r` */) {
      after = ':';
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    let size =
      options.alignDelimiters === false
        ? 1
        : Math.max(
            1,
            longestCellByColumn[columnIndex] - before.length - after.length
          );

    const cell = before + '-'.repeat(size) + after;

    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length;

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size;
      }

      sizes[columnIndex] = size;
    }

    row[columnIndex] = cell;
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row);
  sizeMatrix.splice(1, 0, sizes);

  rowIndex = -1;
  /** @type {Array<string>} */
  const lines = [];

  while (++rowIndex < cellMatrix.length) {
    const row = cellMatrix[rowIndex];
    const sizes = sizeMatrix[rowIndex];
    columnIndex = -1;
    /** @type {Array<string>} */
    const line = [];

    while (++columnIndex < mostCellsPerRow) {
      const cell = row[columnIndex] || '';
      let before = '';
      let after = '';

      if (options.alignDelimiters !== false) {
        const size =
          longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
        const code = alignments[columnIndex];

        if (code === 114 /* `r` */) {
          before = ' '.repeat(size);
        } else if (code === 99 /* `c` */) {
          if (size % 2) {
            before = ' '.repeat(size / 2 + 0.5);
            after = ' '.repeat(size / 2 - 0.5);
          } else {
            before = ' '.repeat(size / 2);
            after = before;
          }
        } else {
          after = ' '.repeat(size);
        }
      }

      if (options.delimiterStart !== false && !columnIndex) {
        line.push('|');
      }

      if (
        options.padding !== false &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(options.alignDelimiters === false && cell === '') &&
        (options.delimiterStart !== false || columnIndex)
      ) {
        line.push(' ');
      }

      if (options.alignDelimiters !== false) {
        line.push(before);
      }

      line.push(cell);

      if (options.alignDelimiters !== false) {
        line.push(after);
      }

      if (options.padding !== false) {
        line.push(' ');
      }

      if (
        options.delimiterEnd !== false ||
        columnIndex !== mostCellsPerRow - 1
      ) {
        line.push('|');
      }
    }

    lines.push(
      options.delimiterEnd === false
        ? line.join('').replace(/ +$/, '')
        : line.join('')
    );
  }

  return lines.join('\n')
}

/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */
function serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

/**
 * @param {string} value
 * @returns {number}
 */
function defaultStringLength(value) {
  return value.length
}

/**
 * @param {string|null|undefined} value
 * @returns {number}
 */
function toAlignment(value) {
  const code = typeof value === 'string' ? value.codePointAt(0) : 0;

  return code === 67 /* `C` */ || code === 99 /* `c` */
    ? 99 /* `c` */
    : code === 76 /* `L` */ || code === 108 /* `l` */
    ? 108 /* `l` */
    : code === 82 /* `R` */ || code === 114 /* `r` */
    ? 114 /* `r` */
    : 0
}

/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */

/**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */

/**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */

/**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */

const own$2 = {}.hasOwnProperty;

/**
 * Handle values based on a field.
 *
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @param {string} key
 *   Field to switch on.
 * @param {Options<Invalid, Unknown, Handlers>} [options]
 *   Configuration (required).
 * @returns {{unknown: Unknown, invalid: Invalid, handlers: Handlers, (...parameters: Parameters<Handlers[keyof Handlers]>): ReturnType<Handlers[keyof Handlers]>, (...parameters: Parameters<Unknown>): ReturnType<Unknown>}}
 */
function zwitch(key, options) {
  const settings = options || {};

  /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */
  function one(value, ...parameters) {
    /** @type {Handler|undefined} */
    let fn = one.invalid;
    const handlers = one.handlers;

    if (value && own$2.call(value, key)) {
      // @ts-expect-error Indexable.
      const id = String(value[key]);
      // @ts-expect-error Indexable.
      fn = own$2.call(handlers, id) ? handlers[id] : one.unknown;
    }

    if (fn) {
      return fn.call(this, value, ...parameters)
    }
  }

  one.handlers = settings.handlers || {};
  one.invalid = settings.invalid;
  one.unknown = settings.unknown;

  // @ts-expect-error: matches!
  return one
}

/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function blockquote(node, _, state, info) {
  const exit = state.enter('blockquote');
  const tracker = state.createTracker(info);
  tracker.move('> ');
  tracker.shift(2);
  const value = state.indentLines(
    state.containerFlow(node, tracker.current()),
    map$1
  );
  exit();
  return value
}

/** @type {Map} */
function map$1(line, _, blank) {
  return '>' + (blank ? '' : ' ') + line
}

/**
 * @typedef {import('../types.js').ConstructName} ConstructName
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */
function patternInScope(stack, pattern) {
  return (
    listInScope(stack, pattern.inConstruct, true) &&
    !listInScope(stack, pattern.notInConstruct, false)
  )
}

/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */
function listInScope(stack, list, none) {
  if (typeof list === 'string') {
    list = [list];
  }

  if (!list || list.length === 0) {
    return none
  }

  let index = -1;

  while (++index < list.length) {
    if (stack.includes(list[index])) {
      return true
    }
  }

  return false
}

/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Break} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function hardBreak(_, _1, state, info) {
  let index = -1;

  while (++index < state.unsafe.length) {
    // If we can’t put eols in this construct (setext headings, tables), use a
    // space instead.
    if (
      state.unsafe[index].character === '\n' &&
      patternInScope(state.stack, state.unsafe[index])
    ) {
      return /[ \t]/.test(info.before) ? '' : ' '
    }
  }

  return '\\\n'
}

/**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */
function longestStreak(value, substring) {
  const source = String(value);
  let index = source.indexOf(substring);
  let expected = index;
  let count = 0;
  let max = 0;

  if (typeof substring !== 'string') {
    throw new TypeError('Expected substring')
  }

  while (index !== -1) {
    if (index === expected) {
      if (++count > max) {
        max = count;
      }
    } else {
      count = 1;
    }

    expected = index + substring.length;
    index = source.indexOf(substring, expected);
  }

  return max
}

/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */
function formatCodeAsIndented(node, state) {
  return Boolean(
    state.options.fences === false &&
      node.value &&
      // If there’s no info…
      !node.lang &&
      // And there’s a non-whitespace character…
      /[^ \r\n]/.test(node.value) &&
      // And the value doesn’t start or end in a blank…
      !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value)
  )
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */
function checkFence(state) {
  const marker = state.options.fence || '`';

  if (marker !== '`' && marker !== '~') {
    throw new Error(
      'Cannot serialize code with `' +
        marker +
        '` for `options.fence`, expected `` ` `` or `~`'
    )
  }

  return marker
}

/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Code} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function code$1(node, _, state, info) {
  const marker = checkFence(state);
  const raw = node.value || '';
  const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';

  if (formatCodeAsIndented(node, state)) {
    const exit = state.enter('codeIndented');
    const value = state.indentLines(raw, map);
    exit();
    return value
  }

  const tracker = state.createTracker(info);
  const sequence = marker.repeat(Math.max(longestStreak(raw, marker) + 1, 3));
  const exit = state.enter('codeFenced');
  let value = tracker.move(sequence);

  if (node.lang) {
    const subexit = state.enter(`codeFencedLang${suffix}`);
    value += tracker.move(
      state.safe(node.lang, {
        before: value,
        after: ' ',
        encode: ['`'],
        ...tracker.current()
      })
    );
    subexit();
  }

  if (node.lang && node.meta) {
    const subexit = state.enter(`codeFencedMeta${suffix}`);
    value += tracker.move(' ');
    value += tracker.move(
      state.safe(node.meta, {
        before: value,
        after: '\n',
        encode: ['`'],
        ...tracker.current()
      })
    );
    subexit();
  }

  value += tracker.move('\n');

  if (raw) {
    value += tracker.move(raw + '\n');
  }

  value += tracker.move(sequence);
  exit();
  return value
}

/** @type {Map} */
function map(line, _, blank) {
  return (blank ? '' : '    ') + line
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */
function checkQuote(state) {
  const marker = state.options.quote || '"';

  if (marker !== '"' && marker !== "'") {
    throw new Error(
      'Cannot serialize title with `' +
        marker +
        '` for `options.quote`, expected `"`, or `\'`'
    )
  }

  return marker
}

/**
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Definition} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function definition(node, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
  const exit = state.enter('definition');
  let subexit = state.enter('label');
  const tracker = state.createTracker(info);
  let value = tracker.move('[');
  value += tracker.move(
    state.safe(state.associationId(node), {
      before: value,
      after: ']',
      ...tracker.current()
    })
  );
  value += tracker.move(']: ');

  subexit();

  if (
    // If there’s no url, or…
    !node.url ||
    // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)
  ) {
    subexit = state.enter('destinationLiteral');
    value += tracker.move('<');
    value += tracker.move(
      state.safe(node.url, {before: value, after: '>', ...tracker.current()})
    );
    value += tracker.move('>');
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw');
    value += tracker.move(
      state.safe(node.url, {
        before: value,
        after: node.title ? ' ' : '\n',
        ...tracker.current()
      })
    );
  }

  subexit();

  if (node.title) {
    subexit = state.enter(`title${suffix}`);
    value += tracker.move(' ' + quote);
    value += tracker.move(
      state.safe(node.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }

  exit();

  return value
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */
function checkEmphasis(state) {
  const marker = state.options.emphasis || '*';

  if (marker !== '*' && marker !== '_') {
    throw new Error(
      'Cannot serialize emphasis with `' +
        marker +
        '` for `options.emphasis`, expected `*`, or `_`'
    )
  }

  return marker
}

/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


emphasis.peek = emphasisPeek;

// To do: there are cases where emphasis cannot “form” depending on the
// previous or next character of sequences.
// There’s no way around that though, except for injecting zero-width stuff.
// Do we need to safeguard against that?
/**
 * @param {Emphasis} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function emphasis(node, _, state, info) {
  const marker = checkEmphasis(state);
  const exit = state.enter('emphasis');
  const tracker = state.createTracker(info);
  let value = tracker.move(marker);
  value += tracker.move(
    state.containerPhrasing(node, {
      before: value,
      after: marker,
      ...tracker.current()
    })
  );
  value += tracker.move(marker);
  exit();
  return value
}

/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */
function emphasisPeek(_, _1, state) {
  return state.options.emphasis || '*'
}

/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Heading} node
 * @param {State} state
 * @returns {boolean}
 */
function formatHeadingAsSetext(node, state) {
  let literalWithBreak = false;

  // Look for literals with a line break.
  // Note that this also
  visit(node, function (node) {
    if (
      ('value' in node && /\r?\n|\r/.test(node.value)) ||
      node.type === 'break'
    ) {
      literalWithBreak = true;
      return EXIT
    }
  });

  return Boolean(
    (!node.depth || node.depth < 3) &&
      toString$2(node) &&
      (state.options.setext || literalWithBreak)
  )
}

/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Heading} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function heading(node, _, state, info) {
  const rank = Math.max(Math.min(6, node.depth || 1), 1);
  const tracker = state.createTracker(info);

  if (formatHeadingAsSetext(node, state)) {
    const exit = state.enter('headingSetext');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, {
      ...tracker.current(),
      before: '\n',
      after: '\n'
    });
    subexit();
    exit();

    return (
      value +
      '\n' +
      (rank === 1 ? '=' : '-').repeat(
        // The whole size…
        value.length -
          // Minus the position of the character after the last EOL (or
          // 0 if there is none)…
          (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1)
      )
    )
  }

  const sequence = '#'.repeat(rank);
  const exit = state.enter('headingAtx');
  const subexit = state.enter('phrasing');

  // Note: for proper tracking, we should reset the output positions when there
  // is no content returned, because then the space is not output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.
  tracker.move(sequence + ' ');

  let value = state.containerPhrasing(node, {
    before: '# ',
    after: '\n',
    ...tracker.current()
  });

  if (/^[\t ]/.test(value)) {
    // To do: what effect has the character reference on tracking?
    value =
      '&#x' +
      value.charCodeAt(0).toString(16).toUpperCase() +
      ';' +
      value.slice(1);
  }

  value = value ? sequence + ' ' + value : sequence;

  if (state.options.closeAtx) {
    value += ' ' + sequence;
  }

  subexit();
  exit();

  return value
}

/**
 * @typedef {import('mdast').Html} Html
 */

html$4.peek = htmlPeek;

/**
 * @param {Html} node
 * @returns {string}
 */
function html$4(node) {
  return node.value || ''
}

/**
 * @returns {string}
 */
function htmlPeek() {
  return '<'
}

/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


image.peek = imagePeek;

/**
 * @param {Image} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function image(node, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
  const exit = state.enter('image');
  let subexit = state.enter('label');
  const tracker = state.createTracker(info);
  let value = tracker.move('![');
  value += tracker.move(
    state.safe(node.alt, {before: value, after: ']', ...tracker.current()})
  );
  value += tracker.move('](');

  subexit();

  if (
    // If there’s no url but there is a title…
    (!node.url && node.title) ||
    // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)
  ) {
    subexit = state.enter('destinationLiteral');
    value += tracker.move('<');
    value += tracker.move(
      state.safe(node.url, {before: value, after: '>', ...tracker.current()})
    );
    value += tracker.move('>');
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw');
    value += tracker.move(
      state.safe(node.url, {
        before: value,
        after: node.title ? ' ' : ')',
        ...tracker.current()
      })
    );
  }

  subexit();

  if (node.title) {
    subexit = state.enter(`title${suffix}`);
    value += tracker.move(' ' + quote);
    value += tracker.move(
      state.safe(node.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }

  value += tracker.move(')');
  exit();

  return value
}

/**
 * @returns {string}
 */
function imagePeek() {
  return '!'
}

/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

imageReference.peek = imageReferencePeek;

/**
 * @param {ImageReference} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function imageReference(node, _, state, info) {
  const type = node.referenceType;
  const exit = state.enter('imageReference');
  let subexit = state.enter('label');
  const tracker = state.createTracker(info);
  let value = tracker.move('![');
  const alt = state.safe(node.alt, {
    before: value,
    after: ']',
    ...tracker.current()
  });
  value += tracker.move(alt + '][');

  subexit();
  // Hide the fact that we’re in phrasing, because escapes don’t work.
  const stack = state.stack;
  state.stack = [];
  subexit = state.enter('reference');
  // Note: for proper tracking, we should reset the output positions when we end
  // up making a `shortcut` reference, because then there is no brace output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.
  const reference = state.safe(state.associationId(node), {
    before: value,
    after: ']',
    ...tracker.current()
  });
  subexit();
  state.stack = stack;
  exit();

  if (type === 'full' || !alt || alt !== reference) {
    value += tracker.move(reference + ']');
  } else if (type === 'shortcut') {
    // Remove the unwanted `[`.
    value = value.slice(0, -1);
  } else {
    value += tracker.move(']');
  }

  return value
}

/**
 * @returns {string}
 */
function imageReferencePeek() {
  return '!'
}

/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').State} State
 */

inlineCode.peek = inlineCodePeek;

/**
 * @param {InlineCode} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */
function inlineCode(node, _, state) {
  let value = node.value || '';
  let sequence = '`';
  let index = -1;

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`';
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (
    /[^ \r\n]/.test(value) &&
    ((/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value)) || /^`|`$/.test(value))
  ) {
    value = ' ' + value + ' ';
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < state.unsafe.length) {
    const pattern = state.unsafe[index];
    const expression = state.compilePattern(pattern);
    /** @type {RegExpExecArray | null} */
    let match;

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue

    while ((match = expression.exec(value))) {
      let position = match.index;

      // Support CRLF (patterns only look for one of the characters).
      if (
        value.charCodeAt(position) === 10 /* `\n` */ &&
        value.charCodeAt(position - 1) === 13 /* `\r` */
      ) {
        position--;
      }

      value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
    }
  }

  return sequence + value + sequence
}

/**
 * @returns {string}
 */
function inlineCodePeek() {
  return '`'
}

/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Link} node
 * @param {State} state
 * @returns {boolean}
 */
function formatLinkAsAutolink(node, state) {
  const raw = toString$2(node);

  return Boolean(
    !state.options.resourceLink &&
      // If there’s a url…
      node.url &&
      // And there’s a no title…
      !node.title &&
      // And the content of `node` is a single text node…
      node.children &&
      node.children.length === 1 &&
      node.children[0].type === 'text' &&
      // And if the url is the same as the content…
      (raw === node.url || 'mailto:' + raw === node.url) &&
      // And that starts w/ a protocol…
      /^[a-z][a-z+.-]+:/i.test(node.url) &&
      // And that doesn’t contain ASCII control codes (character escapes and
      // references don’t work), space, or angle brackets…
      !/[\0- <>\u007F]/.test(node.url)
  )
}

/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Exit} Exit
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


link.peek = linkPeek;

/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function link(node, _, state, info) {
  const quote = checkQuote(state);
  const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
  const tracker = state.createTracker(info);
  /** @type {Exit} */
  let exit;
  /** @type {Exit} */
  let subexit;

  if (formatLinkAsAutolink(node, state)) {
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    exit = state.enter('autolink');
    let value = tracker.move('<');
    value += tracker.move(
      state.containerPhrasing(node, {
        before: value,
        after: '>',
        ...tracker.current()
      })
    );
    value += tracker.move('>');
    exit();
    state.stack = stack;
    return value
  }

  exit = state.enter('link');
  subexit = state.enter('label');
  let value = tracker.move('[');
  value += tracker.move(
    state.containerPhrasing(node, {
      before: value,
      after: '](',
      ...tracker.current()
    })
  );
  value += tracker.move('](');
  subexit();

  if (
    // If there’s no url but there is a title…
    (!node.url && node.title) ||
    // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)
  ) {
    subexit = state.enter('destinationLiteral');
    value += tracker.move('<');
    value += tracker.move(
      state.safe(node.url, {before: value, after: '>', ...tracker.current()})
    );
    value += tracker.move('>');
  } else {
    // No whitespace, raw is prettier.
    subexit = state.enter('destinationRaw');
    value += tracker.move(
      state.safe(node.url, {
        before: value,
        after: node.title ? ' ' : ')',
        ...tracker.current()
      })
    );
  }

  subexit();

  if (node.title) {
    subexit = state.enter(`title${suffix}`);
    value += tracker.move(' ' + quote);
    value += tracker.move(
      state.safe(node.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }

  value += tracker.move(')');

  exit();
  return value
}

/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */
function linkPeek(node, _, state) {
  return formatLinkAsAutolink(node, state) ? '<' : '['
}

/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

linkReference.peek = linkReferencePeek;

/**
 * @param {LinkReference} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function linkReference(node, _, state, info) {
  const type = node.referenceType;
  const exit = state.enter('linkReference');
  let subexit = state.enter('label');
  const tracker = state.createTracker(info);
  let value = tracker.move('[');
  const text = state.containerPhrasing(node, {
    before: value,
    after: ']',
    ...tracker.current()
  });
  value += tracker.move(text + '][');

  subexit();
  // Hide the fact that we’re in phrasing, because escapes don’t work.
  const stack = state.stack;
  state.stack = [];
  subexit = state.enter('reference');
  // Note: for proper tracking, we should reset the output positions when we end
  // up making a `shortcut` reference, because then there is no brace output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.
  const reference = state.safe(state.associationId(node), {
    before: value,
    after: ']',
    ...tracker.current()
  });
  subexit();
  state.stack = stack;
  exit();

  if (type === 'full' || !text || text !== reference) {
    value += tracker.move(reference + ']');
  } else if (type === 'shortcut') {
    // Remove the unwanted `[`.
    value = value.slice(0, -1);
  } else {
    value += tracker.move(']');
  }

  return value
}

/**
 * @returns {string}
 */
function linkReferencePeek() {
  return '['
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */
function checkBullet(state) {
  const marker = state.options.bullet || '*';

  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bullet`, expected `*`, `+`, or `-`'
    )
  }

  return marker
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */
function checkBulletOther(state) {
  const bullet = checkBullet(state);
  const bulletOther = state.options.bulletOther;

  if (!bulletOther) {
    return bullet === '*' ? '-' : '*'
  }

  if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        bulletOther +
        '` for `options.bulletOther`, expected `*`, `+`, or `-`'
    )
  }

  if (bulletOther === bullet) {
    throw new Error(
      'Expected `bullet` (`' +
        bullet +
        '`) and `bulletOther` (`' +
        bulletOther +
        '`) to be different'
    )
  }

  return bulletOther
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */
function checkBulletOrdered(state) {
  const marker = state.options.bulletOrdered || '.';

  if (marker !== '.' && marker !== ')') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bulletOrdered`, expected `.` or `)`'
    )
  }

  return marker
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */
function checkRule(state) {
  const marker = state.options.rule || '*';

  if (marker !== '*' && marker !== '-' && marker !== '_') {
    throw new Error(
      'Cannot serialize rules with `' +
        marker +
        '` for `options.rule`, expected `*`, `-`, or `_`'
    )
  }

  return marker
}

/**
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {List} node
 * @param {Parents | undefined} parent
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function list(node, parent, state, info) {
  const exit = state.enter('list');
  const bulletCurrent = state.bulletCurrent;
  /** @type {string} */
  let bullet = node.ordered ? checkBulletOrdered(state) : checkBullet(state);
  /** @type {string} */
  const bulletOther = node.ordered
    ? bullet === '.'
      ? ')'
      : '.'
    : checkBulletOther(state);
  let useDifferentMarker =
    parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;

  if (!node.ordered) {
    const firstListItem = node.children ? node.children[0] : undefined;

    // If there’s an empty first list item directly in two list items,
    // we have to use a different bullet:
    //
    // ```markdown
    // * - *
    // ```
    //
    // …because otherwise it would become one big thematic break.
    if (
      // Bullet could be used as a thematic break marker:
      (bullet === '*' || bullet === '-') &&
      // Empty first list item:
      firstListItem &&
      (!firstListItem.children || !firstListItem.children[0]) &&
      // Directly in two other list items:
      state.stack[state.stack.length - 1] === 'list' &&
      state.stack[state.stack.length - 2] === 'listItem' &&
      state.stack[state.stack.length - 3] === 'list' &&
      state.stack[state.stack.length - 4] === 'listItem' &&
      // That are each the first child.
      state.indexStack[state.indexStack.length - 1] === 0 &&
      state.indexStack[state.indexStack.length - 2] === 0 &&
      state.indexStack[state.indexStack.length - 3] === 0
    ) {
      useDifferentMarker = true;
    }

    // If there’s a thematic break at the start of the first list item,
    // we have to use a different bullet:
    //
    // ```markdown
    // * ---
    // ```
    //
    // …because otherwise it would become one big thematic break.
    if (checkRule(state) === bullet && firstListItem) {
      let index = -1;

      while (++index < node.children.length) {
        const item = node.children[index];

        if (
          item &&
          item.type === 'listItem' &&
          item.children &&
          item.children[0] &&
          item.children[0].type === 'thematicBreak'
        ) {
          useDifferentMarker = true;
          break
        }
      }
    }
  }

  if (useDifferentMarker) {
    bullet = bulletOther;
  }

  state.bulletCurrent = bullet;
  const value = state.containerFlow(node, info);
  state.bulletLastUsed = bullet;
  state.bulletCurrent = bulletCurrent;
  exit();
  return value
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */
function checkListItemIndent(state) {
  const style = state.options.listItemIndent || 'one';

  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error(
      'Cannot serialize items with `' +
        style +
        '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`'
    )
  }

  return style
}

/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {ListItem} node
 * @param {Parents | undefined} parent
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function listItem(node, parent, state, info) {
  const listItemIndent = checkListItemIndent(state);
  let bullet = state.bulletCurrent || checkBullet(state);

  // Add the marker value for ordered lists.
  if (parent && parent.type === 'list' && parent.ordered) {
    bullet =
      (typeof parent.start === 'number' && parent.start > -1
        ? parent.start
        : 1) +
      (state.options.incrementListMarker === false
        ? 0
        : parent.children.indexOf(node)) +
      bullet;
  }

  let size = bullet.length + 1;

  if (
    listItemIndent === 'tab' ||
    (listItemIndent === 'mixed' &&
      ((parent && parent.type === 'list' && parent.spread) || node.spread))
  ) {
    size = Math.ceil(size / 4) * 4;
  }

  const tracker = state.createTracker(info);
  tracker.move(bullet + ' '.repeat(size - bullet.length));
  tracker.shift(size);
  const exit = state.enter('listItem');
  const value = state.indentLines(
    state.containerFlow(node, tracker.current()),
    map
  );
  exit();

  return value

  /** @type {Map} */
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line
  }
}

/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function paragraph(node, _, state, info) {
  const exit = state.enter('paragraph');
  const subexit = state.enter('phrasing');
  const value = state.containerPhrasing(node, info);
  subexit();
  exit();
  return value
}

/**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */


/**
 * Check if the given value is *phrasing content*.
 *
 * > 👉 **Note**: Excludes `html`, which can be both phrasing or flow.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @returns
 *   Whether `value` is phrasing content.
 */

const phrasing =
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  (
    convert([
      'break',
      'delete',
      'emphasis',
      // To do: next major: removed since footnotes were added to GFM.
      'footnote',
      'footnoteReference',
      'image',
      'imageReference',
      'inlineCode',
      // Enabled by `mdast-util-math`:
      'inlineMath',
      'link',
      'linkReference',
      // Enabled by `mdast-util-mdx`:
      'mdxJsxTextElement',
      // Enabled by `mdast-util-mdx`:
      'mdxTextExpression',
      'strong',
      'text',
      // Enabled by `mdast-util-directive`:
      'textDirective'
    ])
  );

/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {Root} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function root$4(node, _, state, info) {
  // Note: `html` nodes are ambiguous.
  const hasPhrasing = node.children.some(function (d) {
    return phrasing(d)
  });
  const fn = hasPhrasing ? state.containerPhrasing : state.containerFlow;
  return fn.call(state, node, info)
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */
function checkStrong(state) {
  const marker = state.options.strong || '*';

  if (marker !== '*' && marker !== '_') {
    throw new Error(
      'Cannot serialize strong with `' +
        marker +
        '` for `options.strong`, expected `*`, or `_`'
    )
  }

  return marker
}

/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */


strong.peek = strongPeek;

// To do: there are cases where emphasis cannot “form” depending on the
// previous or next character of sequences.
// There’s no way around that though, except for injecting zero-width stuff.
// Do we need to safeguard against that?
/**
 * @param {Strong} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function strong(node, _, state, info) {
  const marker = checkStrong(state);
  const exit = state.enter('strong');
  const tracker = state.createTracker(info);
  let value = tracker.move(marker + marker);
  value += tracker.move(
    state.containerPhrasing(node, {
      before: value,
      after: marker,
      ...tracker.current()
    })
  );
  value += tracker.move(marker + marker);
  exit();
  return value
}

/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */
function strongPeek(_, _1, state) {
  return state.options.strong || '*'
}

/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function text$3(node, _, state, info) {
  return state.safe(node.value, info)
}

/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */
function checkRuleRepetition(state) {
  const repetition = state.options.ruleRepetition || 3;

  if (repetition < 3) {
    throw new Error(
      'Cannot serialize rules with repetition `' +
        repetition +
        '` for `options.ruleRepetition`, expected `3` or more'
    )
  }

  return repetition
}

/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../types.js').State} State
 */


/**
 * @param {ThematicBreak} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */
function thematicBreak(_, _1, state) {
  const value = (
    checkRule(state) + (state.options.ruleSpaces ? ' ' : '')
  ).repeat(checkRuleRepetition(state));

  return state.options.ruleSpaces ? value.slice(0, -1) : value
}

/**
 * Default (CommonMark) handlers.
 */
const handle = {
  blockquote,
  break: hardBreak,
  code: code$1,
  definition,
  emphasis,
  hardBreak,
  heading,
  html: html$4,
  image,
  imageReference,
  inlineCode,
  link,
  linkReference,
  list,
  listItem,
  paragraph,
  root: root$4,
  strong,
  text: text$3,
  thematicBreak
};

/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */


/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM tables in
 * markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown` to enable GFM tables.
 */
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterTable(token) {
  const align = token._align;
  this.enter(
    {
      type: 'table',
      align: align.map(function (d) {
        return d === 'none' ? null : d
      }),
      children: []
    },
    token
  );
  this.data.inTable = true;
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitTable(token) {
  this.exit(token);
  this.data.inTable = undefined;
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterRow(token) {
  this.enter({type: 'tableRow', children: []}, token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exit(token) {
  this.exit(token);
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterCell(token) {
  this.enter({type: 'tableCell', children: []}, token);
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCodeText(token) {
  let value = this.resume();

  if (this.data.inTable) {
    value = value.replace(/\\([\\|])/g, replace);
  }

  const node = this.stack[this.stack.length - 1];
  ok$1(node.type === 'inlineCode');
  node.value = value;
  this.exit(token);
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM tables in
 * markdown.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM tables.
 */
function gfmTableToMarkdown(options) {
  const settings = options;
  const padding = settings.tableCellPadding;
  const alignDelimiters = settings.tablePipeAlign;
  const stringLength = settings.stringLength;
  const around = padding ? ' ' : '|';

  return {
    unsafe: [
      {character: '\r', inConstruct: 'tableCell'},
      {character: '\n', inConstruct: 'tableCell'},
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      {atBreak: true, character: '|', after: '[\t :-]'},
      // A pipe in a cell must be encoded.
      {character: '|', inConstruct: 'tableCell'},
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      {atBreak: true, character: ':', after: '-'},
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      {atBreak: true, character: '-', after: '[:|-]'}
    ],
    handlers: {
      inlineCode: inlineCodeWithTable,
      table: handleTable,
      tableCell: handleTableCell,
      tableRow: handleTableRow
    }
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */
  function handleTable(node, _, state, info) {
    return serializeData(handleTableAsData(node, state, info), node.align)
  }

  /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */
  function handleTableRow(node, _, state, info) {
    const row = handleTableRowAsData(node, state, info);
    const value = serializeData([row]);
    // `markdown-table` will always add an align row
    return value.slice(0, value.indexOf('\n'))
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */
  function handleTableCell(node, _, state, info) {
    const exit = state.enter('tableCell');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, {
      ...info,
      before: around,
      after: around
    });
    subexit();
    exit();
    return value
  }

  /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength
    })
  }

  /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */
  function handleTableAsData(node, state, info) {
    const children = node.children;
    let index = -1;
    /** @type {Array<Array<string>>} */
    const result = [];
    const subexit = state.enter('table');

    while (++index < children.length) {
      result[index] = handleTableRowAsData(children[index], state, info);
    }

    subexit();

    return result
  }

  /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */
  function handleTableRowAsData(node, state, info) {
    const children = node.children;
    let index = -1;
    /** @type {Array<string>} */
    const result = [];
    const subexit = state.enter('tableRow');

    while (++index < children.length) {
      // Note: the positional info as used here is incorrect.
      // Making it correct would be impossible due to aligning cells?
      // And it would need copy/pasting `markdown-table` into this project.
      result[index] = handleTableCell(children[index], node, state, info);
    }

    subexit();

    return result
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */
  function inlineCodeWithTable(node, parent, state) {
    let value = handle.inlineCode(node, parent, state);

    if (state.stack.includes('tableCell')) {
      value = value.replace(/\|/g, '\\$&');
    }

    return value
  }
}

/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */


/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM task
 * list items in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown` to enable GFM task list items.
 */
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM task list
 * items in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM task list items.
 */
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{atBreak: true, character: '-', after: '[:|-]'}],
    handlers: {listItem: listItemWithTaskListItem}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCheck(token) {
  // We’re always in a paragraph, in a list item.
  const node = this.stack[this.stack.length - 2];
  ok$1(node.type === 'listItem');
  node.checked = token.type === 'taskListCheckValueChecked';
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitParagraphWithTaskListItem(token) {
  const parent = this.stack[this.stack.length - 2];

  if (
    parent &&
    parent.type === 'listItem' &&
    typeof parent.checked === 'boolean'
  ) {
    const node = this.stack[this.stack.length - 1];
    ok$1(node.type === 'paragraph');
    const head = node.children[0];

    if (head && head.type === 'text') {
      const siblings = parent.children;
      let index = -1;
      /** @type {Paragraph | undefined} */
      let firstParaghraph;

      while (++index < siblings.length) {
        const sibling = siblings[index];
        if (sibling.type === 'paragraph') {
          firstParaghraph = sibling;
          break
        }
      }

      if (firstParaghraph === node) {
        // Must start with a space or a tab.
        head.value = head.value.slice(1);

        if (head.value.length === 0) {
          node.children.shift();
        } else if (
          node.position &&
          head.position &&
          typeof head.position.start.offset === 'number'
        ) {
          head.position.start.column++;
          head.position.start.offset++;
          node.position.start = Object.assign({}, head.position.start);
        }
      }
    }
  }

  this.exit(token);
}

/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */
function listItemWithTaskListItem(node, parent, state, info) {
  const head = node.children[0];
  const checkable =
    typeof node.checked === 'boolean' && head && head.type === 'paragraph';
  const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
  const tracker = state.createTracker(info);

  if (checkable) {
    tracker.move(checkbox);
  }

  let value = handle.listItem(node, parent, state, {
    ...info,
    ...tracker.current()
  });

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }

  return value

  /**
   * @param {string} $0
   * @returns {string}
   */
  function check($0) {
    return $0 + checkbox
  }
}

/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */


/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM (autolink
 * literals, footnotes, strikethrough, tables, tasklists).
 *
 * @returns {Array<FromMarkdownExtension>}
 *   Extension for `mdast-util-from-markdown` to enable GFM (autolink literals,
 *   footnotes, strikethrough, tables, tasklists).
 */
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ]
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM (autolink
 * literals, footnotes, strikethrough, tables, tasklists).
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM (autolink literals,
 *   footnotes, strikethrough, tables, tasklists).
 */
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown()
    ]
  }
}

/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */

const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
};
const domain = {
  tokenize: tokenizeDomain,
  partial: true
};
const path = {
  tokenize: tokenizePath,
  partial: true
};
const trail = {
  tokenize: tokenizeTrail,
  partial: true
};
const emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
};
const wwwAutolink = {
  name: 'wwwAutolink',
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
const protocolAutolink = {
  name: 'protocolAutolink',
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
};
const emailAutolink = {
  name: 'emailAutolink',
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};

/** @type {ConstructRecord} */
const text$2 = {};

/**
 * Create an extension for `micromark` to support GitHub autolink literal
 * syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   autolink literal syntax.
 */
function gfmAutolinkLiteral() {
  return {
    text: text$2
  };
}

/** @type {Code} */
let code = 48;

// Add alphanumerics.
while (code < 123) {
  text$2[code] = emailAutolink;
  code++;
  if (code === 58) code = 65;else if (code === 91) code = 97;
}
text$2[43] = emailAutolink;
text$2[45] = emailAutolink;
text$2[46] = emailAutolink;
text$2[95] = emailAutolink;
text$2[72] = [emailAutolink, protocolAutolink];
text$2[104] = [emailAutolink, protocolAutolink];
text$2[87] = [emailAutolink, wwwAutolink];
text$2[119] = [emailAutolink, wwwAutolink];

// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.

/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailAutolink(effects, ok, nok) {
  const self = this;
  /** @type {boolean | undefined} */
  let dot;
  /** @type {boolean} */
  let data;
  return start;

  /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (!gfmAtext(code) || !previousEmail.call(self, self.previous) || previousUnbalanced(self.events)) {
      return nok(code);
    }
    effects.enter('literalAutolink');
    effects.enter('literalAutolinkEmail');
    return atext(code);
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code);
      return atext;
    }
    if (code === 64) {
      effects.consume(code);
      return emailDomain;
    }
    return nok(code);
  }

  /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */
  function emailDomain(code) {
    // Dot followed by alphanumerical (not `-` or `_`).
    if (code === 46) {
      return effects.check(emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
    }

    // Alphanumerical, `-`, and `_`.
    if (code === 45 || code === 95 || asciiAlphanumeric(code)) {
      data = true;
      effects.consume(code);
      return emailDomain;
    }

    // To do: `/` if xmpp.

    // Note: normally we’d truncate trailing punctuation from the link.
    // However, email autolink literals cannot contain any of those markers,
    // except for `.`, but that can only occur if it isn’t trailing.
    // So we can ignore truncating!
    return emailDomainAfter(code);
  }

  /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */
  function emailDomainDot(code) {
    effects.consume(code);
    dot = true;
    return emailDomain;
  }

  /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function emailDomainAfter(code) {
    // Domain must not be empty, must include a dot, and must end in alphabetical.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
    if (data && dot && asciiAlpha(self.previous)) {
      effects.exit('literalAutolinkEmail');
      effects.exit('literalAutolink');
      return ok(code);
    }
    return nok(code);
  }
}

/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwAutolink(effects, ok, nok) {
  const self = this;
  return wwwStart;

  /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function wwwStart(code) {
    if (code !== 87 && code !== 119 || !previousWww.call(self, self.previous) || previousUnbalanced(self.events)) {
      return nok(code);
    }
    effects.enter('literalAutolink');
    effects.enter('literalAutolinkWww');
    // Note: we *check*, so we can discard the `www.` we parsed.
    // If it worked, we consider it as a part of the domain.
    return effects.check(wwwPrefix, effects.attempt(domain, effects.attempt(path, wwwAfter), nok), nok)(code);
  }

  /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */
  function wwwAfter(code) {
    effects.exit('literalAutolinkWww');
    effects.exit('literalAutolink');
    return ok(code);
  }
}

/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeProtocolAutolink(effects, ok, nok) {
  const self = this;
  let buffer = '';
  let seen = false;
  return protocolStart;

  /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function protocolStart(code) {
    if ((code === 72 || code === 104) && previousProtocol.call(self, self.previous) && !previousUnbalanced(self.events)) {
      effects.enter('literalAutolink');
      effects.enter('literalAutolinkHttp');
      buffer += String.fromCodePoint(code);
      effects.consume(code);
      return protocolPrefixInside;
    }
    return nok(code);
  }

  /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */
  function protocolPrefixInside(code) {
    // `5` is size of `https`
    if (asciiAlpha(code) && buffer.length < 5) {
      // @ts-expect-error: definitely number.
      buffer += String.fromCodePoint(code);
      effects.consume(code);
      return protocolPrefixInside;
    }
    if (code === 58) {
      const protocol = buffer.toLowerCase();
      if (protocol === 'http' || protocol === 'https') {
        effects.consume(code);
        return protocolSlashesInside;
      }
    }
    return nok(code);
  }

  /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */
  function protocolSlashesInside(code) {
    if (code === 47) {
      effects.consume(code);
      if (seen) {
        return afterProtocol;
      }
      seen = true;
      return protocolSlashesInside;
    }
    return nok(code);
  }

  /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */
  function afterProtocol(code) {
    // To do: this is different from `markdown-rs`:
    // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
    return code === null || asciiControl(code) || markdownLineEndingOrSpace(code) || unicodeWhitespace(code) || unicodePunctuation(code) ? nok(code) : effects.attempt(domain, effects.attempt(path, protocolAfter), nok)(code);
  }

  /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */
  function protocolAfter(code) {
    effects.exit('literalAutolinkHttp');
    effects.exit('literalAutolink');
    return ok(code);
  }
}

/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwPrefix(effects, ok, nok) {
  let size = 0;
  return wwwPrefixInside;

  /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixInside(code) {
    if ((code === 87 || code === 119) && size < 3) {
      size++;
      effects.consume(code);
      return wwwPrefixInside;
    }
    if (code === 46 && size === 3) {
      effects.consume(code);
      return wwwPrefixAfter;
    }
    return nok(code);
  }

  /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixAfter(code) {
    // If there is *anything*, we can link.
    return code === null ? nok(code) : ok(code);
  }
}

/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDomain(effects, ok, nok) {
  /** @type {boolean | undefined} */
  let underscoreInLastSegment;
  /** @type {boolean | undefined} */
  let underscoreInLastLastSegment;
  /** @type {boolean | undefined} */
  let seen;
  return domainInside;

  /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */
  function domainInside(code) {
    // Check whether this marker, which is a trailing punctuation
    // marker, optionally followed by more trailing markers, and then
    // followed by an end.
    if (code === 46 || code === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code);
    }

    // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
    if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code) || code !== 45 && unicodePunctuation(code)) {
      return domainAfter(code);
    }
    seen = true;
    effects.consume(code);
    return domainInside;
  }

  /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */
  function domainAtPunctuation(code) {
    // There is an underscore in the last segment of the domain
    if (code === 95) {
      underscoreInLastSegment = true;
    }
    // Otherwise, it’s a `.`: save the last segment underscore in the
    // penultimate segment slot.
    else {
      underscoreInLastLastSegment = underscoreInLastSegment;
      underscoreInLastSegment = undefined;
    }
    effects.consume(code);
    return domainInside;
  }

  /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */
  function domainAfter(code) {
    // Note: that’s GH says a dot is needed, but it’s not true:
    // <https://github.com/github/cmark-gfm/issues/279>
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code);
    }
    return ok(code);
  }
}

/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePath(effects, ok) {
  let sizeOpen = 0;
  let sizeClose = 0;
  return pathInside;

  /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */
  function pathInside(code) {
    if (code === 40) {
      sizeOpen++;
      effects.consume(code);
      return pathInside;
    }

    // To do: `markdown-rs` also needs this.
    // If this is a paren, and there are less closings than openings,
    // we don’t check for a trail.
    if (code === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code);
    }

    // Check whether this trailing punctuation marker is optionally
    // followed by more trailing markers, and then followed
    // by an end.
    if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) {
      return effects.check(trail, ok, pathAtPunctuation)(code);
    }
    if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
      return ok(code);
    }
    effects.consume(code);
    return pathInside;
  }

  /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function pathAtPunctuation(code) {
    // Count closing parens.
    if (code === 41) {
      sizeClose++;
    }
    effects.consume(code);
    return pathInside;
  }
}

/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTrail(effects, ok, nok) {
  return trail;

  /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */
  function trail(code) {
    // Regular trailing punctuation.
    if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
      effects.consume(code);
      return trail;
    }

    // `&` followed by one or more alphabeticals and then a `;`, is
    // as a whole considered as trailing punctuation.
    // In all other cases, it is considered as continuation of the URL.
    if (code === 38) {
      effects.consume(code);
      return trailCharacterReferenceStart;
    }

    // Needed because we allow literals after `[`, as we fix:
    // <https://github.com/github/cmark-gfm/issues/278>.
    // Check that it is not followed by `(` or `[`.
    if (code === 93) {
      effects.consume(code);
      return trailBracketAfter;
    }
    if (
    // `<` is an end.
    code === 60 ||
    // So is whitespace.
    code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
      return ok(code);
    }
    return nok(code);
  }

  /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailBracketAfter(code) {
    // Whitespace or something that could start a resource or reference is the end.
    // Switch back to trail otherwise.
    if (code === null || code === 40 || code === 91 || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
      return ok(code);
    }
    return trail(code);
  }

  /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharacterReferenceStart(code) {
    // When non-alpha, it’s not a trail.
    return asciiAlpha(code) ? trailCharacterReferenceInside(code) : nok(code);
  }

  /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharacterReferenceInside(code) {
    // Switch back to trail if this is well-formed.
    if (code === 59) {
      effects.consume(code);
      return trail;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      return trailCharacterReferenceInside;
    }

    // It’s not a trail.
    return nok(code);
  }
}

/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailDomainDotTrail(effects, ok, nok) {
  return start;

  /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Must be dot.
    effects.consume(code);
    return after;
  }

  /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Not a trail if alphanumeric.
    return asciiAlphanumeric(code) ? nok(code) : ok(code);
  }
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */
function previousWww(code) {
  return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || markdownLineEndingOrSpace(code);
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */
function previousProtocol(code) {
  return !asciiAlpha(code);
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previousEmail(code) {
  // Do not allow a slash “inside” atext.
  // The reference code is a bit weird, but that’s what it results in.
  // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
  // Other than slash, every preceding character is allowed.
  return !(code === 47 || gfmAtext(code));
}

/**
 * @param {Code} code
 * @returns {boolean}
 */
function gfmAtext(code) {
  return code === 43 || code === 45 || code === 46 || code === 95 || asciiAlphanumeric(code);
}

/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */
function previousUnbalanced(events) {
  let index = events.length;
  let result = false;
  while (index--) {
    const token = events[index][1];
    if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
      result = true;
      break;
    }

    // If we’ve seen this token, and it was marked as not having any unbalanced
    // bracket before it, we can exit.
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false;
      break;
    }
  }
  if (events.length > 0 && !result) {
    // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
  }
  return result;
}

/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */

const indent = {
  tokenize: tokenizeIndent,
  partial: true
};

// To do: micromark should support a `_hiddenGfmFootnoteSupport`, which only
// affects label start (image).
// That will let us drop `tokenizePotentialGfmFootnote*`.
// It currently has a `_hiddenFootnoteSupport`, which affects that and more.
// That can be removed when `micromark-extension-footnote` is archived.

/**
 * Create an extension for `micromark` to enable GFM footnote syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to
 *   enable GFM footnote syntax.
 */
function gfmFootnote() {
  /** @type {Extension} */
  return {
    document: {
      [91]: {
        name: 'gfmFootnoteDefinition',
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        name: 'gfmFootnoteCall',
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        name: 'gfmPotentialFootnoteCall',
        add: 'after',
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}

// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
  const self = this;
  let index = self.events.length;
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  /** @type {Token} */
  let labelStart;

  // Find an opening.
  while (index--) {
    const token = self.events[index][1];
    if (token.type === "labelImage") {
      labelStart = token;
      break;
    }

    // Exit if we’ve walked far enough.
    if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") {
      break;
    }
  }
  return start;

  /**
   * @type {State}
   */
  function start(code) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code);
    }
    const id = normalizeIdentifier(self.sliceSerialize({
      start: labelStart.end,
      end: self.now()
    }));
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code);
    }
    effects.enter('gfmFootnoteCallLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallLabelMarker');
    return ok(code);
  }
}

// To do: remove after micromark update.
/** @type {Resolver} */
function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length;

  // Find an opening.
  while (index--) {
    if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
      events[index][1];
      break;
    }
  }
  // Change the `labelImageMarker` to a `data`.
  events[index + 1][1].type = "data";
  events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';

  // The whole (without `!`):
  /** @type {Token} */
  const call = {
    type: 'gfmFootnoteCall',
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  // The `^` marker
  /** @type {Token} */
  const marker = {
    type: 'gfmFootnoteCallMarker',
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  };
  // Increment the end 1 character.
  marker.end.column++;
  marker.end.offset++;
  marker.end._bufferIndex++;
  /** @type {Token} */
  const string = {
    type: 'gfmFootnoteCallString',
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  };
  /** @type {Token} */
  const chunk = {
    type: "chunkString",
    contentType: 'string',
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  };

  /** @type {Array<Event>} */
  const replacement = [
  // Take the `labelImageMarker` (now `data`, the `!`)
  events[index + 1], events[index + 2], ['enter', call, context],
  // The `[`
  events[index + 3], events[index + 4],
  // The `^`.
  ['enter', marker, context], ['exit', marker, context],
  // Everything in between.
  ['enter', string, context], ['enter', chunk, context], ['exit', chunk, context], ['exit', string, context],
  // The ending (`]`, properly parsed and labelled).
  events[events.length - 2], events[events.length - 1], ['exit', call, context]];
  events.splice(index, events.length - index + 1, ...replacement);
  return events;
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeGfmFootnoteCall(effects, ok, nok) {
  const self = this;
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  let size = 0;
  /** @type {boolean} */
  let data;

  // Note: the implementation of `markdown-rs` is different, because it houses
  // core *and* extensions in one project.
  // Therefore, it can include footnote logic inside `label-end`.
  // We can’t do that, but luckily, we can parse footnotes in a simpler way than
  // needed for labels.
  return start;

  /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('gfmFootnoteCall');
    effects.enter('gfmFootnoteCallLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallLabelMarker');
    return callStart;
  }

  /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function callStart(code) {
    if (code !== 94) return nok(code);
    effects.enter('gfmFootnoteCallMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallMarker');
    effects.enter('gfmFootnoteCallString');
    effects.enter('chunkString').contentType = 'string';
    return callData;
  }

  /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */
  function callData(code) {
    if (
    // Too long.
    size > 999 ||
    // Closing brace with nothing.
    code === 93 && !data ||
    // Space or tab is not supported by GFM for some reason.
    // `\n` and `[` not being supported makes sense.
    code === null || code === 91 || markdownLineEndingOrSpace(code)) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit('chunkString');
      const token = effects.exit('gfmFootnoteCallString');
      if (!defined.includes(normalizeIdentifier(self.sliceSerialize(token)))) {
        return nok(code);
      }
      effects.enter('gfmFootnoteCallLabelMarker');
      effects.consume(code);
      effects.exit('gfmFootnoteCallLabelMarker');
      effects.exit('gfmFootnoteCall');
      return ok;
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true;
    }
    size++;
    effects.consume(code);
    return code === 92 ? callEscape : callData;
  }

  /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */
  function callEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return callData;
    }
    return callData(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinitionStart(effects, ok, nok) {
  const self = this;
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  /** @type {string} */
  let identifier;
  let size = 0;
  /** @type {boolean | undefined} */
  let data;
  return start;

  /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('gfmFootnoteDefinition')._container = true;
    effects.enter('gfmFootnoteDefinitionLabel');
    effects.enter('gfmFootnoteDefinitionLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteDefinitionLabelMarker');
    return labelAtMarker;
  }

  /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelAtMarker(code) {
    if (code === 94) {
      effects.enter('gfmFootnoteDefinitionMarker');
      effects.consume(code);
      effects.exit('gfmFootnoteDefinitionMarker');
      effects.enter('gfmFootnoteDefinitionLabelString');
      effects.enter('chunkString').contentType = 'string';
      return labelInside;
    }
    return nok(code);
  }

  /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (
    // Too long.
    size > 999 ||
    // Closing brace with nothing.
    code === 93 && !data ||
    // Space or tab is not supported by GFM for some reason.
    // `\n` and `[` not being supported makes sense.
    code === null || code === 91 || markdownLineEndingOrSpace(code)) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit('chunkString');
      const token = effects.exit('gfmFootnoteDefinitionLabelString');
      identifier = normalizeIdentifier(self.sliceSerialize(token));
      effects.enter('gfmFootnoteDefinitionLabelMarker');
      effects.consume(code);
      effects.exit('gfmFootnoteDefinitionLabelMarker');
      effects.exit('gfmFootnoteDefinitionLabel');
      return labelAfter;
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true;
    }
    size++;
    effects.consume(code);
    return code === 92 ? labelEscape : labelInside;
  }

  /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return labelInside;
    }
    return labelInside(code);
  }

  /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    if (code === 58) {
      effects.enter('definitionMarker');
      effects.consume(code);
      effects.exit('definitionMarker');
      if (!defined.includes(identifier)) {
        defined.push(identifier);
      }

      // Any whitespace after the marker is eaten, forming indented code
      // is not possible.
      // No space is also fine, just like a block quote marker.
      return factorySpace(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
    }
    return nok(code);
  }

  /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */
  function whitespaceAfter(code) {
    // `markdown-rs` has a wrapping token for the prefix that is closed here.
    return ok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinitionContinuation(effects, ok, nok) {
  /// Start of footnote definition continuation.
  ///
  /// ```markdown
  ///   | [^a]: b
  /// > |     c
  ///     ^
  /// ```
  //
  // Either a blank line, which is okay, or an indented thing.
  return effects.check(blankLine, ok, effects.attempt(indent, ok, nok));
}

/** @type {Exiter} */
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit('gfmFootnoteDefinition');
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeIndent(effects, ok, nok) {
  const self = this;
  return factorySpace(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 4 + 1);

  /**
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
  }
}

/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */

/**
 * Create an extension for `micromark` to enable GFM strikethrough syntax.
 *
 * @param {Options | null | undefined} [options={}]
 *   Configuration.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions`, to
 *   enable GFM strikethrough syntax.
 */
function gfmStrikethrough(options) {
  const options_ = options;
  let single = options_.singleTilde;
  const tokenizer = {
    name: 'strikethrough',
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };
  if (single === null || single === undefined) {
    single = true;
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  };

  /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */
  function resolveAllStrikethrough(events, context) {
    let index = -1;

    // Walk through all events.
    while (++index < events.length) {
      // Find a token that can close.
      if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
        let open = index;

        // Now walk back to find an opener.
        while (open--) {
          // Find a token that can open the closer.
          if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open &&
          // If the sizes are the same:
          events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
            events[index][1].type = 'strikethroughSequence';
            events[open][1].type = 'strikethroughSequence';

            /** @type {Token} */
            const strikethrough = {
              type: 'strikethrough',
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            };

            /** @type {Token} */
            const text = {
              type: 'strikethroughText',
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            };

            // Opening.
            /** @type {Array<Event>} */
            const nextEvents = [['enter', strikethrough, context], ['enter', events[open][1], context], ['exit', events[open][1], context], ['enter', text, context]];
            const insideSpan = context.parser.constructs.insideSpan.null;
            if (insideSpan) {
              // Between.
              splice(nextEvents, nextEvents.length, 0, resolveAll(insideSpan, events.slice(open + 1, index), context));
            }

            // Closing.
            splice(nextEvents, nextEvents.length, 0, [['exit', text, context], ['enter', events[index][1], context], ['exit', events[index][1], context], ['exit', strikethrough, context]]);
            splice(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - 2;
            break;
          }
        }
      }
    }
    index = -1;
    while (++index < events.length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = "data";
      }
    }
    return events;
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeStrikethrough(effects, ok, nok) {
    const previous = this.previous;
    const events = this.events;
    let size = 0;
    return start;

    /** @type {State} */
    function start(code) {
      if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") {
        return nok(code);
      }
      effects.enter('strikethroughSequenceTemporary');
      return more(code);
    }

    /** @type {State} */
    function more(code) {
      const before = classifyCharacter(previous);
      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code);
        effects.consume(code);
        size++;
        return more;
      }
      if (size < 2 && !single) return nok(code);
      const token = effects.exit('strikethroughSequenceTemporary');
      const after = classifyCharacter(code);
      token._open = !after || after === 2 && Boolean(before);
      token._close = !before || before === 2 && Boolean(after);
      return ok(code);
    }
  }
}

/**
 * @import {Event} from 'micromark-util-types'
 */

// Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.

// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.

/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */

/**
 * Tracks a bunch of edits.
 */
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */
    this.map = [];
  }

  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(index, remove, add) {
    addImplementation(this, index, remove, add);
  }

  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }

  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(events) {
    this.map.sort(function (a, b) {
      return a[0] - b[0];
    });

    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
    if (this.map.length === 0) {
      return;
    }

    // To do: if links are added in events, like they are in `markdown-rs`,
    // this is needed.
    // // Calculate jumps: where items in the current list move to.
    // /** @type {Array<Jump>} */
    // const jumps = []
    // let index = 0
    // let addAcc = 0
    // let removeAcc = 0
    // while (index < this.map.length) {
    //   const [at, remove, add] = this.map[index]
    //   removeAcc += remove
    //   addAcc += add.length
    //   jumps.push([at, removeAcc, addAcc])
    //   index += 1
    // }
    //
    // . shiftLinks(events, jumps)

    let index = this.map.length;
    /** @type {Array<Array<Event>>} */
    const vecs = [];
    while (index > 0) {
      index -= 1;
      vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);

      // Truncate rest.
      events.length = this.map[index][0];
    }
    vecs.push([...events]);
    events.length = 0;
    let slice = vecs.pop();
    while (slice) {
      events.push(...slice);
      slice = vecs.pop();
    }

    // Truncate everything.
    this.map.length = 0;
  }
}

/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */
function addImplementation(editMap, at, remove, add) {
  let index = 0;

  /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
  if (remove === 0 && add.length === 0) {
    return;
  }
  while (index < editMap.map.length) {
    if (editMap.map[index][0] === at) {
      editMap.map[index][1] += remove;

      // To do: before not used by tables, use when moving to micromark.
      // if (before) {
      //   add.push(...editMap.map[index][2])
      //   editMap.map[index][2] = add
      // } else {
      editMap.map[index][2].push(...add);
      // }

      return;
    }
    index += 1;
  }
  editMap.map.push([at, remove, add]);
}

// /**
//  * Shift `previous` and `next` links according to `jumps`.
//  *
//  * This fixes links in case there are events removed or added between them.
//  *
//  * @param {Array<Event>} events
//  * @param {Array<Jump>} jumps
//  */
// function shiftLinks(events, jumps) {
//   let jumpIndex = 0
//   let index = 0
//   let add = 0
//   let rm = 0

//   while (index < events.length) {
//     const rmCurr = rm

//     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
//       add = jumps[jumpIndex][2]
//       rm = jumps[jumpIndex][1]
//       jumpIndex += 1
//     }

//     // Ignore items that will be removed.
//     if (rm > rmCurr) {
//       index += rm - rmCurr
//     } else {
//       // ?
//       // if let Some(link) = &events[index].link {
//       //     if let Some(next) = link.next {
//       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
//       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
//       //             add = jumps[jumpIndex].2;
//       //             rm = jumps[jumpIndex].1;
//       //             jumpIndex += 1;
//       //         }
//       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
//       //         index = next;
//       //         continue;
//       //     }
//       // }
//       index += 1
//     }
//   }
// }

/**
 * @import {Event} from 'micromark-util-types'
 */

/**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */

/**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */
function gfmTableAlign(events, index) {
  let inDelimiterRow = false;
  /** @type {Array<Align>} */
  const align = [];
  while (index < events.length) {
    const event = events[index];
    if (inDelimiterRow) {
      if (event[0] === 'enter') {
        // Start of alignment value: set a new column.
        // To do: `markdown-rs` uses `tableDelimiterCellValue`.
        if (event[1].type === 'tableContent') {
          align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
        }
      }
      // Exits:
      // End of alignment value: change the column.
      // To do: `markdown-rs` uses `tableDelimiterCellValue`.
      else if (event[1].type === 'tableContent') {
        if (events[index - 1][1].type === 'tableDelimiterMarker') {
          const alignIndex = align.length - 1;
          align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
        }
      }
      // Done!
      else if (event[1].type === 'tableDelimiterRow') {
        break;
      }
    } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') {
      inDelimiterRow = true;
    }
    index += 1;
  }
  return align;
}

/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */


/**
 * Create an HTML extension for `micromark` to support GitHub tables syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   table syntax.
 */
function gfmTable() {
  return {
    flow: {
      null: {
        name: 'table',
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTable(effects, ok, nok) {
  const self = this;
  let size = 0;
  let sizeB = 0;
  /** @type {boolean | undefined} */
  let seen;
  return start;

  /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */
  function start(code) {
    let index = self.events.length - 1;
    while (index > -1) {
      const type = self.events[index][1].type;
      if (type === "lineEnding" ||
      // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      type === "linePrefix") index--;else break;
    }
    const tail = index > -1 ? self.events[index][1].type : null;
    const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;

    // Don’t allow lazy body rows.
    if (next === bodyRowStart && self.parser.lazy[self.now().line]) {
      return nok(code);
    }
    return next(code);
  }

  /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBefore(code) {
    effects.enter('tableHead');
    effects.enter('tableRow');
    return headRowStart(code);
  }

  /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowStart(code) {
    if (code === 124) {
      return headRowBreak(code);
    }

    // To do: micromark-js should let us parse our own whitespace in extensions,
    // like `markdown-rs`:
    //
    // ```js
    // // 4+ spaces.
    // if (markdownSpace(code)) {
    //   return nok(code)
    // }
    // ```

    seen = true;
    // Count the first character, that isn’t a pipe, double.
    sizeB += 1;
    return headRowBreak(code);
  }

  /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBreak(code) {
    if (code === null) {
      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
      if (sizeB > 1) {
        sizeB = 0;
        // To do: check if this works.
        // Feel free to interrupt:
        self.interrupt = true;
        effects.exit('tableRow');
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return headDelimiterStart;
      }

      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code);
    }
    if (markdownSpace(code)) {
      // To do: check if this is fine.
      // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
      // State::Retry(space_or_tab(tokenizer))
      return factorySpace(effects, headRowBreak, "whitespace")(code);
    }
    sizeB += 1;
    if (seen) {
      seen = false;
      // Header cell count.
      size += 1;
    }
    if (code === 124) {
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      // Whether a delimiter was seen.
      seen = true;
      return headRowBreak;
    }

    // Anything else is cell data.
    effects.enter("data");
    return headRowData(code);
  }

  /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit("data");
      return headRowBreak(code);
    }
    effects.consume(code);
    return code === 92 ? headRowEscape : headRowData;
  }

  /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */
  function headRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code);
      return headRowData;
    }
    return headRowData(code);
  }

  /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterStart(code) {
    // Reset `interrupt`.
    self.interrupt = false;

    // Note: in `markdown-rs`, we need to handle piercing here too.
    if (self.parser.lazy[self.now().line]) {
      return nok(code);
    }
    effects.enter('tableDelimiterRow');
    // Track if we’ve seen a `:` or `|`.
    seen = false;
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
    return headDelimiterBefore(code);
  }

  /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterBefore(code) {
    if (code === 45 || code === 58) {
      return headDelimiterValueBefore(code);
    }
    if (code === 124) {
      seen = true;
      // If we start with a pipe, we open a cell marker.
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      return headDelimiterCellBefore;
    }

    // More whitespace / empty row not allowed at start.
    return headDelimiterNok(code);
  }

  /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellBefore(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterValueBefore, "whitespace")(code);
    }
    return headDelimiterValueBefore(code);
  }

  /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterValueBefore(code) {
    // Align: left.
    if (code === 58) {
      sizeB += 1;
      seen = true;
      effects.enter('tableDelimiterMarker');
      effects.consume(code);
      effects.exit('tableDelimiterMarker');
      return headDelimiterLeftAlignmentAfter;
    }

    // Align: none.
    if (code === 45) {
      sizeB += 1;
      // To do: seems weird that this *isn’t* left aligned, but that state is used?
      return headDelimiterLeftAlignmentAfter(code);
    }
    if (code === null || markdownLineEnding(code)) {
      return headDelimiterCellAfter(code);
    }
    return headDelimiterNok(code);
  }

  /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterLeftAlignmentAfter(code) {
    if (code === 45) {
      effects.enter('tableDelimiterFiller');
      return headDelimiterFiller(code);
    }

    // Anything else is not ok after the left-align colon.
    return headDelimiterNok(code);
  }

  /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterFiller(code) {
    if (code === 45) {
      effects.consume(code);
      return headDelimiterFiller;
    }

    // Align is `center` if it was `left`, `right` otherwise.
    if (code === 58) {
      seen = true;
      effects.exit('tableDelimiterFiller');
      effects.enter('tableDelimiterMarker');
      effects.consume(code);
      effects.exit('tableDelimiterMarker');
      return headDelimiterRightAlignmentAfter;
    }
    effects.exit('tableDelimiterFiller');
    return headDelimiterRightAlignmentAfter(code);
  }

  /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterRightAlignmentAfter(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterCellAfter, "whitespace")(code);
    }
    return headDelimiterCellAfter(code);
  }

  /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellAfter(code) {
    if (code === 124) {
      return headDelimiterBefore(code);
    }
    if (code === null || markdownLineEnding(code)) {
      // Exit when:
      // * there was no `:` or `|` at all (it’s a thematic break or setext
      //   underline instead)
      // * the header cell count is not the delimiter cell count
      if (!seen || size !== sizeB) {
        return headDelimiterNok(code);
      }

      // Note: in markdown-rs`, a reset is needed here.
      effects.exit('tableDelimiterRow');
      effects.exit('tableHead');
      // To do: in `markdown-rs`, resolvers need to be registered manually.
      // effects.register_resolver(ResolveName::GfmTable)
      return ok(code);
    }
    return headDelimiterNok(code);
  }

  /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterNok(code) {
    // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
    return nok(code);
  }

  /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */
  function bodyRowStart(code) {
    // Note: in `markdown-rs` we need to manually take care of a prefix,
    // but in `micromark-js` that is done for us, so if we’re here, we’re
    // never at whitespace.
    effects.enter('tableRow');
    return bodyRowBreak(code);
  }

  /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowBreak(code) {
    if (code === 124) {
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      return bodyRowBreak;
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('tableRow');
      return ok(code);
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, bodyRowBreak, "whitespace")(code);
    }

    // Anything else is cell content.
    effects.enter("data");
    return bodyRowData(code);
  }

  /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */
  function bodyRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit("data");
      return bodyRowBreak(code);
    }
    effects.consume(code);
    return code === 92 ? bodyRowEscape : bodyRowData;
  }

  /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code);
      return bodyRowData;
    }
    return bodyRowData(code);
  }
}

/** @type {Resolver} */

function resolveTable(events, context) {
  let index = -1;
  let inFirstCellAwaitingPipe = true;
  /** @type {RowKind} */
  let rowKind = 0;
  /** @type {Range} */
  let lastCell = [0, 0, 0, 0];
  /** @type {Range} */
  let cell = [0, 0, 0, 0];
  let afterHeadAwaitingFirstBodyRow = false;
  let lastTableEnd = 0;
  /** @type {Token | undefined} */
  let currentTable;
  /** @type {Token | undefined} */
  let currentBody;
  /** @type {Token | undefined} */
  let currentCell;
  const map = new EditMap();
  while (++index < events.length) {
    const event = events[index];
    const token = event[1];
    if (event[0] === 'enter') {
      // Start of head.
      if (token.type === 'tableHead') {
        afterHeadAwaitingFirstBodyRow = false;

        // Inject previous (body end and) table end.
        if (lastTableEnd !== 0) {
          flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
          currentBody = undefined;
          lastTableEnd = 0;
        }

        // Inject table start.
        currentTable = {
          type: 'table',
          start: Object.assign({}, token.start),
          // Note: correct end is set later.
          end: Object.assign({}, token.end)
        };
        map.add(index, 0, [['enter', currentTable, context]]);
      } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
        inFirstCellAwaitingPipe = true;
        currentCell = undefined;
        lastCell = [0, 0, 0, 0];
        cell = [0, index + 1, 0, 0];

        // Inject table body start.
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false;
          currentBody = {
            type: 'tableBody',
            start: Object.assign({}, token.start),
            // Note: correct end is set later.
            end: Object.assign({}, token.end)
          };
          map.add(index, 0, [['enter', currentBody, context]]);
        }
        rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
      }
      // Cell data.
      else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
        inFirstCellAwaitingPipe = false;

        // First value in cell.
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(map, context, lastCell, rowKind, undefined, currentCell);
            lastCell = [0, 0, 0, 0];
          }
          cell[2] = index;
        }
      } else if (token.type === 'tableCellDivider') {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false;
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(map, context, lastCell, rowKind, undefined, currentCell);
          }
          lastCell = cell;
          cell = [lastCell[1], index, 0, 0];
        }
      }
    }
    // Exit events.
    else if (token.type === 'tableHead') {
      afterHeadAwaitingFirstBodyRow = true;
      lastTableEnd = index;
    } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
      lastTableEnd = index;
      if (lastCell[1] !== 0) {
        cell[0] = cell[1];
        currentCell = flushCell(map, context, lastCell, rowKind, index, currentCell);
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map, context, cell, rowKind, index, currentCell);
      }
      rowKind = 0;
    } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
      cell[3] = index;
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
  }
  map.consume(context.events);

  // To do: move this into `html`, when events are exposed there.
  // That’s what `markdown-rs` does.
  // That needs updates to `mdast-util-gfm-table`.
  index = -1;
  while (++index < context.events.length) {
    const event = context.events[index];
    if (event[0] === 'enter' && event[1].type === 'table') {
      event[1]._align = gfmTableAlign(context.events, index);
    }
  }
  return events;
}

/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */
// eslint-disable-next-line max-params
function flushCell(map, context, range, rowKind, rowEnd, previousCell) {
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
  const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
  const valueName = 'tableContent';

  // Insert an exit for the previous cell, if there is one.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //          ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]));
    map.add(range[0], 0, [['exit', previousCell, context]]);
  }

  // Insert enter of this cell.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //           ^-- enter
  //           ^^^^-- this cell
  // ```
  const now = getPoint(context.events, range[1]);
  previousCell = {
    type: groupName,
    start: Object.assign({}, now),
    // Note: correct end is set later.
    end: Object.assign({}, now)
  };
  map.add(range[1], 0, [['enter', previousCell, context]]);

  // Insert text start at first data start and end at last data end, and
  // remove events between.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //            ^-- enter
  //             ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2]);
    const relatedEnd = getPoint(context.events, range[3]);
    /** @type {Token} */
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    };
    map.add(range[2], 0, [['enter', valueToken, context]]);
    if (rowKind !== 2) {
      // Fix positional info on remaining events
      const start = context.events[range[2]];
      const end = context.events[range[3]];
      start[1].end = Object.assign({}, end[1].end);
      start[1].type = "chunkText";
      start[1].contentType = "text";

      // Remove if needed.
      if (range[3] > range[2] + 1) {
        const a = range[2] + 1;
        const b = range[3] - range[2] - 1;
        map.add(a, b, []);
      }
    }
    map.add(range[3] + 1, 0, [['exit', valueToken, context]]);
  }

  // Insert an exit for the last cell, if at the row end.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //                    ^-- exit
  //               ^^^^^^-- this cell (the last one contains two “between” parts)
  // ```
  if (rowEnd !== undefined) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd));
    map.add(rowEnd, 0, [['exit', previousCell, context]]);
    previousCell = undefined;
  }
  return previousCell;
}

/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */
// eslint-disable-next-line max-params
function flushTableEnd(map, context, index, table, tableBody) {
  /** @type {Array<Event>} */
  const exits = [];
  const related = getPoint(context.events, index);
  if (tableBody) {
    tableBody.end = Object.assign({}, related);
    exits.push(['exit', tableBody, context]);
  }
  table.end = Object.assign({}, related);
  exits.push(['exit', table, context]);
  map.add(index + 1, 0, exits);
}

/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */
function getPoint(events, index) {
  const event = events[index];
  const side = event[0] === 'enter' ? 'start' : 'end';
  return event[1][side];
}

/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */

const tasklistCheck = {
  name: 'tasklistCheck',
  tokenize: tokenizeTasklistCheck
};

/**
 * Create an HTML extension for `micromark` to support GFM task list items
 * syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */
function gfmTaskListItem() {
  return {
    text: {
      [91]: tasklistCheck
    }
  };
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTasklistCheck(effects, ok, nok) {
  const self = this;
  return open;

  /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (
    // Exit if there’s stuff before.
    self.previous !== null ||
    // Exit if not in the first content that is the first child of a list
    // item.
    !self._gfmTasklistFirstContentOfListItem) {
      return nok(code);
    }
    effects.enter('taskListCheck');
    effects.enter('taskListCheckMarker');
    effects.consume(code);
    effects.exit('taskListCheckMarker');
    return inside;
  }

  /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // Currently we match how GH works in files.
    // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
    // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
    if (markdownLineEndingOrSpace(code)) {
      effects.enter('taskListCheckValueUnchecked');
      effects.consume(code);
      effects.exit('taskListCheckValueUnchecked');
      return close;
    }
    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked');
      effects.consume(code);
      effects.exit('taskListCheckValueChecked');
      return close;
    }
    return nok(code);
  }

  /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */
  function close(code) {
    if (code === 93) {
      effects.enter('taskListCheckMarker');
      effects.consume(code);
      effects.exit('taskListCheckMarker');
      effects.exit('taskListCheck');
      return after;
    }
    return nok(code);
  }

  /**
   * @type {State}
   */
  function after(code) {
    // EOL in paragraph means there must be something else after it.
    if (markdownLineEnding(code)) {
      return ok(code);
    }

    // Space or tab?
    // Check what comes after.
    if (markdownSpace(code)) {
      return effects.check({
        tokenize: spaceThenNonSpace
      }, ok, nok)(code);
    }

    // EOF, or non-whitespace, both wrong.
    return nok(code);
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function spaceThenNonSpace(effects, ok, nok) {
  return factorySpace(effects, after, "whitespace");

  /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // EOF means there was nothing, so bad.
    // EOL means there’s content after it, so good.
    // Impossible to have more spaces.
    // Anything else is good.
    return code === null ? nok(code) : ok(code);
  }
}

/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */


/**
 * Create an extension for `micromark` to enable GFM syntax.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 *
 *   Passed to `micromark-extens-gfm-strikethrough`.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   syntax.
 */
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable(),
    gfmTaskListItem()
  ])
}

/// <reference types="remark-parse" />
/// <reference types="remark-stringify" />


/** @type {Options} */
const emptyOptions = {};

/**
 * Add support GFM (autolink literals, footnotes, strikethrough, tables,
 * tasklists).
 *
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {undefined}
 *   Nothing.
 */
function remarkGfm(options) {
  // @ts-expect-error: TS is wrong about `this`.
  // eslint-disable-next-line unicorn/no-this-assignment
  const self = /** @type {Processor} */ (this);
  const settings = options || emptyOptions;
  const data = self.data();

  const micromarkExtensions =
    data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions =
    data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
  const toMarkdownExtensions =
    data.toMarkdownExtensions || (data.toMarkdownExtensions = []);

  micromarkExtensions.push(gfm(settings));
  fromMarkdownExtensions.push(gfmFromMarkdown());
  toMarkdownExtensions.push(gfmToMarkdown(settings));
}

const RenderMarkdownData$1 = (props) => {
  const { suggestionLinks, isTypewritingOn } = props;
  const messageText = (props.response?.reply || props.response?.data?.errorMessage).replace(/<Cell>/g, "").replace(/<\/Cell>/g, "").replace(/Cell>/g, "");
  const openLinkInNewTab = (link) => {
    window.open(link, "_blank");
  };
  const LinkRenderer = ({ href, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children });
  const MarkdownRenderer = ({ messageText: messageText2 }) => {
    const hasLinks = suggestionLinks.some((link) => link.link !== "");
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "markdown-table", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { components: { a: LinkRenderer }, remarkPlugins: [remarkGfm], children: messageText2 }),
      hasLinks && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Learn More:" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: suggestionLinks.filter((link) => link.link).map((link, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            className: "custom-links",
            target: "_blank",
            onClick: (e) => {
              e.preventDefault();
              openLinkInNewTab(link.link);
            },
            children: `${link.title}`
          }
        ) }, index)) })
      ] })
    ] });
  };
  React.useEffect(() => {
    props.setFeedbackButtonsVisible(true);
    props.promptResult(true);
    const jsx2 = /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText });
    const htmlString = renderToString(jsx2);
    props.setCopyText(htmlString);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "markdown-table", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText }) });
};

const openedByHoverPreviewManager = [];
function addOpenedByHoverPreview(id, closeCallback) {
  openedByHoverPreviewManager.push({
    id,
    closeCallback
  });
}
function removeOpenedByHoverPreview(id) {
  let index = openedByHoverPreviewManager.findIndex(preview => preview.id === id);
  while (index !== -1) {
    openedByHoverPreviewManager.splice(index, 1);
    index = openedByHoverPreviewManager.findIndex(preview => preview.id === id);
  }
}
function closeAllOpenedByHoverPreviews(id) {
  for (const openedPreview of openedByHoverPreviewManager) {
    if (openedPreview.id !== id) {
      openedPreview.closeCallback();
    }
  }
  openedByHoverPreviewManager.length = 0;
}

const POPOVER_MOUSE_DELAY = 250;
const POPOVER_KEYBOARD_HIDE_DELAY = 0;
const getDelay = (type, popoverMouseHideDelay) => {
  if (type === 'focus' || type === 'blur') {
    return POPOVER_KEYBOARD_HIDE_DELAY;
  }
  return popoverMouseHideDelay;
};
/**
 * Create the state required to render Preview.
 *
 * The returned state can be modified with hooks such as usePreviewStyles_unstable,
 * before being passed to renderPreview_unstable.
 *
 * @param props - props from this instance of Preview
 * @param ref - reference to root HTMLElement of Preview
 */
const usePreview_unstable = props => {
  const {
    hideDelay = POPOVER_MOUSE_DELAY,
    onOpenChange,
    open,
    positioning,
    showDelay = POPOVER_MOUSE_DELAY,
    unstable_disableAutoFocus
  } = props;
  const children = React.Children.toArray(props.children);
  const {
    targetDocument
  } = useFluent();
  const [setEnterTimeout, clearEnterTimeout] = useTimeout();
  const [setLeaveTimeout, clearLeaveTimeout] = useTimeout();
  const [disableAutoFocus, setDisableAutoFocus] = React.useState(true);
  const {
    current: previewInternalState
  } = React.useRef({
    openByClick: false,
    openByHoverOverTrigger: false,
    openByHoverOverPopover: false,
    openByKeyboard: false
  });
  const triggerMousedOver = React.useRef(false);
  const isOpen = () => {
    return previewInternalState.openByClick || previewInternalState.openByHoverOverTrigger || previewInternalState.openByHoverOverPopover || previewInternalState.openByKeyboard;
  };
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
  const preventDefaultClose = React.useRef(false);
  let popoverTrigger = undefined;
  let popoverSurface = undefined;
  if (children.length === 2) {
    popoverTrigger = children[0];
    popoverSurface = children[1];
  } else if (children.length === 1) {
    popoverSurface = children[0];
  }
  const popoverSurfaceId = useId('preview-surface', popoverSurface === null || popoverSurface === undefined ? undefined : popoverSurface.props.id);
  const closeCallback = () => {
    previewInternalState.openByClick = false;
    previewInternalState.openByHoverOverTrigger = false;
    previewInternalState.openByHoverOverPopover = false;
    previewInternalState.openByKeyboard = false;
    setIsPopoverOpen(isOpen());
    clearEnterTimeout();
  };
  React.useEffect(() => {
    return () => {
      // Remove all instances of the current popover from the openedByHoverPreviewManager when the component is unmounted.
      removeOpenedByHoverPreview(popoverSurfaceId);
    };
  }, [popoverSurfaceId]);
  if (popoverSurface && popoverTrigger) {
    const handleTriggerTargetEnter = e => {
      previewInternalState.openByHoverOverTrigger = true;
      triggerMousedOver.current = true;
      // We want to disable auto focus only if the popover is being opened by hovering over the trigger
      if (!previewInternalState.openByClick && !previewInternalState.openByKeyboard && !isPopoverOpen) {
        setDisableAutoFocus(true);
        closeAllOpenedByHoverPreviews(popoverSurfaceId);
      }
      setEnterTimeout(() => {
        if (!previewInternalState.openByClick && !previewInternalState.openByKeyboard && !isPopoverOpen && isOpen()) {
          onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
            open: true
          });
          addOpenedByHoverPreview(popoverSurfaceId, closeCallback);
        }
        setIsPopoverOpen(isOpen());
      }, showDelay);
    };
    const handleTriggerTargetLeave = e => {
      previewInternalState.openByHoverOverTrigger = false;
      triggerMousedOver.current = false;
      setLeaveTimeout(() => {
        setIsPopoverOpen(isOpen());
        // We want to call onOpenChange only if the popover is actually closing when leaving the trigger
        if (!previewInternalState.openByClick && !previewInternalState.openByKeyboard && !previewInternalState.openByHoverOverPopover && isPopoverOpen) {
          onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
            open: false
          });
          removeOpenedByHoverPreview(popoverSurfaceId);
        }
      }, getDelay(e.type, hideDelay));
    };
    const handleTriggerClick = e => {
      // Setting preventDefaultClose so that onPopoverOpenChange does not apply its logic when click is on the trigger as we want to control that behavior.
      preventDefaultClose.current = true;
      // We set disableAutoFocus to false so that interactive elements within popover can be focused when it opens via click.
      setDisableAutoFocus(false);
      const tmpOpenByHoverOverTrigger = previewInternalState.openByHoverOverTrigger;
      // If openByKeyboard is true, then the popover was already opened via keyboard and we always want to close it.
      previewInternalState.openByClick = previewInternalState.openByKeyboard ? false : !previewInternalState.openByClick;
      previewInternalState.openByHoverOverTrigger = false;
      previewInternalState.openByHoverOverPopover = false;
      previewInternalState.openByKeyboard = false;
      // We set triggerMousedOver to false when clicking, since we just interacted with the trigger via click, and not hover.
      if (triggerMousedOver.current) {
        previewInternalState.openByClick = false;
        triggerMousedOver.current = false;
      } else {
        e.preventDefault();
      }
      if (!tmpOpenByHoverOverTrigger) {
        onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
          open: previewInternalState.openByClick
        });
      }
      if (!isOpen()) {
        removeOpenedByHoverPreview(popoverSurfaceId);
      }
      setIsPopoverOpen(isOpen());
    };
    const handleTriggerKeyDown = e => {
      if (e.key === Enter) {
        clearLeaveTimeout();
        // Setting default prevented so that Enter key does not trigger a click event or onPopoverOpenChange.
        e.preventDefault();
        // We set disableAutoFocus to false so that interactive elements within popover can be focused when it opens via keyboard.
        setDisableAutoFocus(false);
        const tmpOpenByHoverOverTrigger = previewInternalState.openByHoverOverTrigger;
        // If openByClick is true, then the popover was already opened via click and we always want to close it.
        previewInternalState.openByKeyboard = previewInternalState.openByClick ? false : !previewInternalState.openByKeyboard;
        previewInternalState.openByClick = false;
        previewInternalState.openByHoverOverTrigger = false;
        previewInternalState.openByHoverOverPopover = false;
        if (!tmpOpenByHoverOverTrigger) {
          onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
            open: previewInternalState.openByKeyboard
          });
        }
        if (!isOpen()) {
          removeOpenedByHoverPreview(popoverSurfaceId);
        }
        setIsPopoverOpen(isOpen());
      }
    };
    const handlePopoverTargetEnter = e => {
      previewInternalState.openByHoverOverPopover = true;
      setIsPopoverOpen(isOpen());
    };
    const handlePopoverTargetLeave = e => {
      previewInternalState.openByHoverOverPopover = false;
      setLeaveTimeout(() => {
        setIsPopoverOpen(isOpen());
        // We want to call onOpenChange only if the popover is actually closing when leaving the popover
        if (!previewInternalState.openByClick && !previewInternalState.openByKeyboard && !previewInternalState.openByHoverOverTrigger) {
          onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
            open: false
          });
          removeOpenedByHoverPreview(popoverSurfaceId);
        }
      }, getDelay(e.type, hideDelay));
    };
    popoverTrigger = React.cloneElement(popoverTrigger, {
      ...popoverTrigger.props,
      children: React.cloneElement(popoverTrigger.props.children, {
        ...popoverTrigger.props.children.props,
        onBlur: mergeCallbacks(popoverTrigger.props.children.props.onBlur, handleTriggerTargetLeave),
        onClick: mergeCallbacks(popoverTrigger.props.children.props.onClick, handleTriggerClick),
        onKeyDown: mergeCallbacks(popoverTrigger.props.children.props.onKeyDown, handleTriggerKeyDown),
        onMouseEnter: mergeCallbacks(popoverTrigger.props.children.props.onMouseEnter, handleTriggerTargetEnter),
        onMouseLeave: mergeCallbacks(popoverTrigger.props.children.props.onMouseLeave, handleTriggerTargetLeave)
      })
    });
    var _popoverSurface_props_arialabelledby;
    popoverSurface = React.cloneElement(popoverSurface, {
      ...popoverSurface.props,
      'aria-labelledby': (_popoverSurface_props_arialabelledby = popoverSurface.props['aria-labelledby']) !== null && _popoverSurface_props_arialabelledby !== undefined ? _popoverSurface_props_arialabelledby : popoverSurface.props['aria-label'] ? undefined : popoverSurfaceId,
      id: popoverSurfaceId,
      onMouseEnter: mergeCallbacks(popoverSurface.props.onMouseEnter, handlePopoverTargetEnter),
      onMouseLeave: mergeCallbacks(popoverSurface.props.onMouseLeave, handlePopoverTargetLeave),
      onFocus: mergeCallbacks(popoverSurface.props.onFocus, handlePopoverTargetEnter)
    });
  }
  // Hitting Escape key should close the popover if it was opened by hover.
  // This is necessary to attach to the document because focus is likely not within the trigger or popover.
  useIsomorphicLayoutEffect(() => {
    if (isPopoverOpen) {
      const onDocumentKeyDown = e => {
        const openedByHover = !previewInternalState.openByClick && !previewInternalState.openByKeyboard;
        if (openedByHover && e.key === Escape) {
          clearLeaveTimeout();
          // We set state back to its default if the Escape key has been pressed
          setDisableAutoFocus(true);
          closeCallback();
          removeOpenedByHoverPreview(popoverSurfaceId);
          onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, {
            open: false
          });
          e.stopPropagation();
        }
      };
      targetDocument === null || targetDocument === undefined ? undefined : targetDocument.addEventListener('keydown', onDocumentKeyDown, {
        capture: true
      });
      return () => {
        targetDocument === null || targetDocument === undefined ? undefined : targetDocument.removeEventListener('keydown', onDocumentKeyDown, {
          capture: true
        });
      };
    }
  }, [targetDocument, isPopoverOpen]);
  const onPopoverOpenChange = (e, data) => {
    if (!preventDefaultClose.current) {
      // We set all open state to false if preventDefaultClose was not set to true and the popover is closing.
      if (!data.open) {
        clearLeaveTimeout();
        closeCallback();
        removeOpenedByHoverPreview(popoverSurfaceId);
      }
      onOpenChange === null || onOpenChange === undefined ? undefined : onOpenChange(e, data);
    }
    preventDefaultClose.current = false;
  };
  let resolvedChildren = children;
  if (popoverSurface) {
    if (popoverTrigger) {
      resolvedChildren = [popoverTrigger, popoverSurface];
    } else {
      resolvedChildren = popoverSurface;
    }
  }
  const popoverState = usePopover_unstable({
    ...props,
    children: resolvedChildren,
    onOpenChange: onPopoverOpenChange,
    open: open !== null && open !== undefined ? open : isPopoverOpen,
    positioning: typeof positioning === 'string' ? {
      autoSize: true,
      ...resolvePositioningShorthand(positioning)
    } : {
      autoSize: true,
      ...positioning
    },
    unstable_disableAutoFocus: unstable_disableAutoFocus !== null && unstable_disableAutoFocus !== undefined ? unstable_disableAutoFocus : disableAutoFocus
  });
  return {
    ...popoverState,
    isPreviewLocked: previewInternalState.openByClick || previewInternalState.openByKeyboard
  };
};

const PreviewContext = createContext(undefined);
const PreviewContextProvider = PreviewContext.Provider;

/**
 * Render the final JSX of Preview
 */
const renderPreview_unstable = state => {
  const {
    appearance,
    arrowRef,
    contentRef,
    inertTrapFocus,
    inline,
    isPreviewLocked,
    mountNode,
    open,
    openOnContext,
    openOnHover,
    setOpen,
    size,
    toggleOpen,
    trapFocus,
    triggerRef,
    withArrow
  } = state;
  return /*#__PURE__*/React.createElement(PreviewContextProvider, {
    value: {
      appearance,
      arrowRef,
      contentRef,
      inertTrapFocus,
      inline,
      isPreviewLocked,
      mountNode,
      open,
      openOnContext,
      openOnHover,
      setOpen,
      size,
      toggleOpen,
      trapFocus,
      triggerRef,
      withArrow
    }
  }, renderPopover_unstable(state));
};

const Preview = props => {
  const state = usePreview_unstable(props);
  return renderPreview_unstable(state);
};
Preview.displayName = 'Preview';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render PreviewSurface.
 *
 * The returned state can be modified with hooks such as usePreviewSurfaceStyles_unstable,
 * before being passed to renderPreviewSurface_unstable.
 *
 * @param props - props from this instance of PreviewSurface
 * @param ref - reference to root HTMLElement of PreviewSurface
 */
const usePreviewSurface_unstable = (props, ref) => {
  return usePopoverSurface_unstable(props, ref);
};

/**
 * Render the final JSX of PreviewSurface
 */
const renderPreviewSurface_unstable = state => {
  return renderPopoverSurface_unstable(state);
};

const previewSurfaceClassNames = {
  root: 'fai-PreviewSurface'
};
/**
 * Styles for the root slot
 */
const useRootStyles = __styles({
  base: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f16d74zd",
    B7ck84d: "f1ewtqcl"
  }
}, {
  d: [[".f16d74zd{padding:var(--spacingVerticalXS) var(--spacingHorizontalXS);}", {
    p: -1
  }], ".f1ewtqcl{box-sizing:border-box;}"]
});
/**
 * Apply styling to the PreviewSurface slots based on the state
 */
const usePreviewSurfaceStyles_unstable = state => {
  'use no memo';

  const rootStyles = useRootStyles();
  state.root.className = mergeClasses(previewSurfaceClassNames.root, rootStyles.base, state.root.className);
  usePopoverSurfaceStyles_unstable(state);
  return state;
};

const PreviewSurface = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = usePreviewSurface_unstable(props, ref);
  usePreviewSurfaceStyles_unstable(state);
  return renderPreviewSurface_unstable(state);
});
PreviewSurface.displayName = 'PreviewSurface';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render PreviewTrigger.
 *
 * The returned state can be modified with hooks such as usePreviewTriggerStyles_unstable,
 * before being passed to renderPreviewTrigger_unstable.
 *
 * @param props - props from this instance of PreviewTrigger
 * @param ref - reference to root HTMLElement of PreviewTrigger
 */
const usePreviewTrigger_unstable = props => {
  return usePopoverTrigger_unstable(props);
};

/**
 * Render the final JSX of PreviewTrigger
 */
const renderPreviewTrigger_unstable = state => {
  return renderPopoverTrigger_unstable(state);
};

const PreviewTrigger = props => {
  const state = usePreviewTrigger_unstable(props);
  return renderPreviewTrigger_unstable(state);
};
PreviewTrigger.displayName = 'PreviewTrigger';

/**
 * Create the state required to render PreviewContent.
 *
 * The returned state can be modified with hooks such as usePreviewContentStyles_unstable,
 * before being passed to renderPreviewContent_unstable.
 *
 * @param props - props from this instance of PreviewContent
 * @param ref - reference to root HTMLElement of PreviewContent
 */
const usePreviewContent_unstable = (props, ref) => {
  return {
    components: {
      root: 'div'
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      ...props
    }), {
      elementType: 'div'
    })
  };
};

/**
 * Render the final JSX of PreviewContent
 */
const renderPreviewContent_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsx(state.root, {});
};

const previewContentClassNames = {
  root: 'fai-PreviewContent'
};
/**
 * Styles for the root slot
 */
const useRootBaseClassName = __resetStyles("rd6u8g", null, [".rd6u8g{color:var(--colorNeutralForeground3);display:flex;flex-direction:column;max-width:calc(256px - var(--spacingHorizontalXS) * 2);padding:var(--spacingVerticalS) var(--spacingHorizontalS);row-gap:var(--spacingVerticalXS);word-break:break-word;box-sizing:border-box;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase200);}"]);
/**
 * Apply styling to the PreviewContent slots based on the state
 */
const usePreviewContentStyles_unstable = state => {
  'use no memo';

  const rootBaseClassName = useRootBaseClassName();
  state.root.className = mergeClasses(previewContentClassNames.root, rootBaseClassName, state.root.className);
  return state;
};

const PreviewContent = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = usePreviewContent_unstable(props, ref);
  usePreviewContentStyles_unstable(state);
  return renderPreviewContent_unstable(state);
});
PreviewContent.displayName = 'PreviewContent';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render SensitivityTooltip.
 *
 * The returned state can be modified with hooks such as useSensitivityTooltipStyles_unstable,
 * before being passed to renderSensitivityTooltip_unstable.
 *
 * @param props - props from this instance of SensitivityTooltip
 * @param ref - reference to root HTMLElement of SensitivityTooltip
 */
const useSensitivityTooltip_unstable = (props, ref) => {
  const {
    withBackplate = false
  } = props;
  return {
    positioning: {
      offset: 8,
      ...resolvePositioningShorthand(props.positioning)
    },
    withBackplate,
    components: {
      root: 'span',
      heading: 'span',
      message: 'span',
      previewSurface: PreviewSurface,
      trigger: 'span'
    },
    root: always(getIntrinsicElementProps('span', {
      ref,
      ...props
    }), {
      elementType: 'span'
    }),
    heading: optional(props.heading, {
      elementType: 'span'
    }),
    message: optional(props.message, {
      elementType: 'span'
    }),
    previewSurface: optional(props.previewSurface, {
      defaultProps: {
        tabIndex: 0
      },
      elementType: PreviewSurface,
      renderByDefault: true
    }),
    trigger: optional(props.trigger, {
      elementType: 'span',
      defaultProps: {
        children: props.children
      },
      renderByDefault: true
    })
  };
};

/**
 * Render the final JSX of SensitivityTooltip
 */
const renderSensitivityTooltip_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsx(state.root, {
    children: state.previewSurface && /*#__PURE__*/jsxs(Preview, {
      trapFocus: true,
      positioning: state.positioning,
      children: [/*#__PURE__*/jsx(PreviewTrigger, {
        children: state.trigger && /*#__PURE__*/jsx(state.trigger, {})
      }), /*#__PURE__*/jsx(state.previewSurface, {
        children: /*#__PURE__*/jsxs(PreviewContent, {
          children: [state.heading && /*#__PURE__*/jsx(state.heading, {}), state.message && /*#__PURE__*/jsx(state.message, {})]
        })
      })]
    })
  });
};

const sensitivityTooltipClassNames = {
  root: 'fai-SensitivityTooltip',
  heading: 'fai-SensitivityTooltip__heading',
  message: 'fai-SensitivityTooltip__message',
  previewSurface: 'fai-SensitivityTooltip__previewSurface',
  trigger: 'fai-SensitivityTooltip__trigger'
};
/**
 * Styles for the root slot
 */
const useStyles$y = __styles({
  root: {
    Bt984gj: "f1q9h2pe",
    B7ck84d: "f1ewtqcl",
    mc9l5x: "ftuwxu6",
    Brf1p80: "f4d9j23",
    sshi5w: "f1pha7fy"
  },
  heading: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "flh3ekv",
    Bg96gwp: "fwrc4pm",
    sj55zd: "f19n0e5"
  },
  message: {},
  previewSurface: {
    B2u0y6b: "fwf794f"
  },
  trigger: {
    Bt984gj: "f122n59",
    mc9l5x: "ftuwxu6"
  },
  backplate: {
    De3pzq: "f16xq7d1",
    B4j52fo: "f192inf7",
    Bekrc4i: ["f5tn483", "f1ojsxk5"],
    Bn0qgzm: "f1vxd6vx",
    ibv6hh: ["f1ojsxk5", "f5tn483"],
    icvyot: "fzkkow9",
    vrafjx: ["fcdblym", "fjik90z"],
    oivjwe: "fg706s2",
    wvpqe5: ["fjik90z", "fcdblym"],
    g2u3we: "f68mrw8",
    h3c5rm: ["f7pw515", "fw35ms5"],
    B9xav0g: "frpde29",
    zhjwy3: ["fw35ms5", "f7pw515"],
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fa9u6mc",
    Jwef8y: "f1h648pw",
    Bgoe8wy: "fvcxoqz",
    Bwzppfd: ["f1ub3y4t", "f1m52nbi"],
    oetu4i: "f1xlaoq0",
    gg5e9n: ["f1m52nbi", "f1ub3y4t"],
    Bi91k9c: "fnwyq0v"
  },
  ":hover:active": {
    De3pzq: "f1xndk82",
    g2u3we: "f1q2k61k",
    h3c5rm: ["f1qqrid1", "f148nk5o"],
    B9xav0g: "f6uf0aq",
    zhjwy3: ["f148nk5o", "f1qqrid1"],
    sj55zd: "f20gb8v"
  }
}, {
  d: [".f1q9h2pe{align-items:stretch;}", ".f1ewtqcl{box-sizing:border-box;}", ".ftuwxu6{display:inline-flex;}", ".f4d9j23{justify-content:center;}", ".f1pha7fy{min-height:24px;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".flh3ekv{font-weight:var(--fontWeightBold);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".fwf794f{max-width:293px;}", ".f122n59{align-items:center;}", ".f16xq7d1{background-color:var(--colorNeutralBackground3);}", ".f192inf7{border-top-width:var(--strokeWidthThin);}", ".f5tn483{border-right-width:var(--strokeWidthThin);}", ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}", ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f68mrw8{border-top-color:var(--colorNeutralStroke2);}", ".f7pw515{border-right-color:var(--colorNeutralStroke2);}", ".fw35ms5{border-left-color:var(--colorNeutralStroke2);}", ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".fa9u6mc{padding:var(--spacingVerticalXXS) var(--spacingHorizontalXS);}", {
    p: -1
  }], ".f1xndk82{background-color:var(--colorNeutralBackground3Pressed);}", ".f1q2k61k{border-top-color:var(--colorNeutralStroke1Pressed);}", ".f1qqrid1{border-right-color:var(--colorNeutralStroke1Pressed);}", ".f148nk5o{border-left-color:var(--colorNeutralStroke1Pressed);}", ".f6uf0aq{border-bottom-color:var(--colorNeutralStroke1Pressed);}", ".f20gb8v{color:var(--colorNeutralForeground2Pressed);}"],
  h: [".f1h648pw:hover{background-color:var(--colorNeutralBackground3Hover);}", ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}", ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}", ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}", ".f1xlaoq0:hover{border-bottom-color:var(--colorNeutralStroke1Hover);}", ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}"]
});
/**
 * Apply styling to the SensitivityTooltip slots based on the state
 */
const useSensitivityTooltipStyles_unstable = state => {
  'use no memo';

  const {
    withBackplate
  } = state;
  const styles = useStyles$y();
  state.root.className = mergeClasses(sensitivityTooltipClassNames.root, styles.root, state.root.className);
  if (state.heading) {
    state.heading.className = mergeClasses(sensitivityTooltipClassNames.heading, styles.heading, state.heading.className);
  }
  if (state.message) {
    state.message.className = mergeClasses(sensitivityTooltipClassNames.message, styles.message, state.message.className);
  }
  if (state.previewSurface) {
    state.previewSurface.className = mergeClasses(sensitivityTooltipClassNames.previewSurface, styles.previewSurface, state.previewSurface.className);
  }
  if (state.trigger) {
    state.trigger.className = mergeClasses(sensitivityTooltipClassNames.trigger, styles.trigger, withBackplate && styles.backplate, state.trigger.className);
  }
  return state;
};

// SensitivityTooltip component - TODO: add more docs
const SensitivityTooltip = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useSensitivityTooltip_unstable(props, ref);
  useSensitivityTooltipStyles_unstable(state);
  return renderSensitivityTooltip_unstable(state);
});
SensitivityTooltip.displayName = 'SensitivityTooltip';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render SensitivityLabel.
 *
 * The returned state can be modified with hooks such as useSensitivityLabelStyles_unstable,
 * before being passed to renderSensitivityLabel_unstable.
 *
 * @param props - props from this instance of SensitivityLabel
 * @param ref - reference to root HTMLElement of SensitivityLabel
 */
const useSensitivityLabel_unstable = (props, ref) => {
  const label = optional(props.label, {
    elementType: 'span',
    defaultProps: {
      children: props.children
    },
    renderByDefault: true
  });
  const defaultTooltipHeading = typeof (label === null || label === undefined ? undefined : label.children) !== 'boolean' ? label === null || label === undefined ? undefined : label.children : undefined;
  return {
    components: {
      root: 'span',
      label: 'span',
      tooltip: SensitivityTooltip
    },
    root: always(getIntrinsicElementProps('span', {
      ref,
      ...props
    }), {
      elementType: 'span'
    }),
    label,
    tooltip: optional(props.tooltip, {
      defaultProps: {
        heading: defaultTooltipHeading,
        message: props.description
      },
      elementType: SensitivityTooltip,
      renderByDefault: true
    })
  };
};

/**
 * Render the final JSX of SensitivityLabel
 */
const renderSensitivityLabel_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsx(state.root, {
    children: state.tooltip ? /*#__PURE__*/jsx(state.tooltip, {
      children: state.label && /*#__PURE__*/jsx(state.label, {})
    }) : state.label && /*#__PURE__*/jsx(state.label, {})
  });
};

const sensitivityLabelClassNames = {
  root: 'fai-SensitivityLabel',
  label: 'fai-SensitivityLabel__label',
  tooltip: 'fai-SensitivityLabel__tooltip'
};
/**
 * Styles for the root slot
 */
const useStyles$x = __styles({
  root: {},
  label: {
    mc9l5x: "ftuwxu6",
    Beiy3e4: "f1063pyq",
    Bt984gj: "f122n59",
    Bqenvij: "f11p92ab",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    sj55zd: "f11d4kpn",
    De3pzq: "f3vzo32",
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fcpl73t",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1fz5haj"
  },
  tooltip: {}
}, {
  d: [".ftuwxu6{display:inline-flex;}", ".f1063pyq{flex-direction:row;}", ".f122n59{align-items:center;}", ".f11p92ab{height:var(--lineHeightBase300);}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f3vzo32{background-color:var(--colorNeutralBackground5);}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", [".f1fz5haj{padding:0 var(--spacingHorizontalSNudge);}", {
    p: -1
  }]]
});
/**
 * Apply styling to the SensitivityLabel slots based on the state
 */
const useSensitivityLabelStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$x();
  state.root.className = mergeClasses(sensitivityLabelClassNames.root, styles.root, state.root.className);
  if (state.label) {
    state.label.className = mergeClasses(sensitivityLabelClassNames.label, styles.label, state.label.className);
  }
  if (state.tooltip) {
    state.tooltip.className = mergeClasses(sensitivityLabelClassNames.tooltip, styles.tooltip, state.tooltip.className);
  }
  return state;
};

// SensitivityLabel component - TODO: add more docs
const SensitivityLabel = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useSensitivityLabel_unstable(props, ref);
  useSensitivityLabelStyles_unstable(state);
  return renderSensitivityLabel_unstable(state);
});
SensitivityLabel.displayName = 'SensitivityLabel';

const ConfidentialNote$1 = ({ note = "Confidential data not included" }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SensitivityLabel, { style: { marginTop: 10, marginBottom: 10 }, children: note });
};

const copilotLightThemeExtension = {
  // rgba() format is used for these colors as the
  // default Flair animation expects to transition
  // the colors to/from transparent versions (e.g., `rgba($r, $g, $b, 0)`)
  // and this format makes that more obvious and readable.
  // When overriding if you can use hex (both #RGB and #RGBA formats), rgb() or rgba() formats.
  colorBrandFlair1: 'rgba(24, 90, 189, 1)',
  colorBrandFlair2: 'rgba(71, 207, 250, 1)',
  colorBrandFlair3: 'rgba(180, 124, 248, 1)',
  colorBrandFlair1Transparent: 'rgba(24, 90, 189, 0)',
  colorBrandFlair2Transparent: 'rgba(71, 207, 250, 0)',
  colorBrandFlair3Transparent: 'rgba(180, 124, 248, 0)',
  colorHCFlair1: 'Highlight',
  colorHCFlair2: 'HighlightText',
  colorHCFlair3: 'Highlight',
  borderRadius2XL: '12px',
  borderRadius3XL: '16px',
  borderRadius4XL: '24px'
};

const tokens = {
  colorBrandFlair1: 'var(--fai-colorBrandFlair1)',
  colorBrandFlair2: 'var(--fai-colorBrandFlair2)',
  colorBrandFlair3: 'var(--fai-colorBrandFlair3)',
  colorBrandFlair1Transparent: 'var(--fai-colorBrandFlair1Transparent)',
  colorBrandFlair2Transparent: 'var(--fai-colorBrandFlair2Transparent)',
  colorBrandFlair3Transparent: 'var(--fai-colorBrandFlair3Transparent)',
  // high contrast flair colors
  colorHCFlair1: 'var(--fai-colorHCFlair1)',
  colorHCFlair2: 'var(--fai-colorHCFlair2)',
  colorHCFlair3: 'var(--fai-colorHCFlair3)',
  borderRadius2XL: `var(--fai-borderRadius2XL)`,
  borderRadius3XL: `var(--fai-borderRadius3XL)`,
  borderRadius4XL: `var(--fai-borderRadius4XL)`
};

/**
 * @internal
 */
const CustomStyleHooksContext = React.createContext(undefined);
const noop$3 = () => {};
/**
 * @internal
 */
const CustomStyleHooksProvider = CustomStyleHooksContext.Provider;
/**
 * Gets a custom style hook
 * @param hook - One of the hook properties in CustomStyleHooksContextValue
 * @returns The corresponding hook when defined, otherwise a no-op function.
 */
const useCustomStyleHook = hook => {
  var _React_useContext;
  var _React_useContext_hook;
  return (_React_useContext_hook = (_React_useContext = React.useContext(CustomStyleHooksContext)) === null || _React_useContext === undefined ? undefined : _React_useContext[hook]) !== null && _React_useContext_hook !== undefined ? _React_useContext_hook : noop$3;
};

/** The duration the message needs to be in present in DOM for screen readers to register a change and announce */
const MESSAGE_DURATION = 500;
const visuallyHiddenStyles = {
  clip: 'rect(0px, 0px, 0px, 0px)',
  height: '1px',
  margin: '-1px',
  width: '1px',
  position: 'absolute',
  overflow: 'hidden',
  textWrap: 'nowrap'
};
/**
 * Create the state required to render Announce.
 *
 * The returned state can be modified with hooks such as useAnnounceStyles_unstable,
 * before being passed to renderAnnounce_unstable.
 *
 * @param props - props from this instance of Announce
 */
const useAnnounce = () => {
  const {
    targetDocument
  } = useFluent();
  const timeoutRef = React.useRef(undefined);
  const [setAnnounceTimeout, clearAnnounceTimeout] = useTimeout();
  const elementRef = React.useRef(null);
  const order = React.useRef(0);
  // investigate alert implementation later
  // const [alertList, setAlertList] = React.useState<string[]>([]);
  const batchMessages = React.useRef([]);
  const [messageQueue] = React.useState(() => createPriorityQueue((a, b) => {
    if (a.priority !== b.priority) {
      return b.priority - a.priority;
    } else {
      return a.createdAt - b.createdAt;
    }
  }));
  const queueMessage = React.useCallback(() => {
    if (timeoutRef.current) {
      return;
    }
    const runCycle = () => {
      if (!elementRef.current) {
        return;
      }
      if (targetDocument && messageQueue.peek()) {
        // need a wrapping element for Narrator/Edge, which currently does not pick up text-only live region changes consistently
        // if this is fixed, we can set textContent to the string directly
        const wrappingEl = targetDocument.createElement('span');
        wrappingEl.innerText = messageQueue.all().filter(msg => msg.message.trim().length > 0).reduce((prevText, currMsg) => prevText + currMsg.message + '. ', '');
        elementRef.current.innerText = '';
        elementRef.current.appendChild(wrappingEl);
        messageQueue.clear();
        batchMessages.current = [];
        // begin new cycle to clear (or update) messages
        timeoutRef.current = setAnnounceTimeout(() => {
          runCycle();
        }, MESSAGE_DURATION);
      } else {
        elementRef.current.textContent = '';
        clearAnnounceTimeout();
        timeoutRef.current = undefined;
      }
    };
    runCycle();
  }, [clearAnnounceTimeout, messageQueue, setAnnounceTimeout, targetDocument]);
  const announce = React.useMemo(() => (message, options = {}) => {
    const {
      alert: isAlert = false,
      priority = 0,
      batchId
    } = options;
    const liveMessage = {
      message,
      createdAt: order.current++,
      priority,
      batchId
    };
    // check if batchId exists
    if (batchId) {
      // update associated msg if it does
      const msg = batchMessages.current.find(msg => msg.batchId === batchId);
      if (msg) {
        // replace existing message in queue
        messageQueue.remove(msg.message);
        // update list of existing batchIds w/ most recent message
        msg.message = liveMessage;
      } else {
        // update list of existing batchIds, add new if doesn't already exist
        batchMessages.current = [...batchMessages.current, {
          batchId,
          message: liveMessage
        }];
      }
    }
    // add new message
    messageQueue.enqueue(liveMessage);
    queueMessage();
  }, [messageQueue, queueMessage]);
  React.useEffect(() => {
    if (elementRef.current || !targetDocument) {
      return;
    }
    elementRef.current = targetDocument.createElement('div');
    elementRef.current.setAttribute('aria-live', 'assertive');
    Object.assign(elementRef.current.style, visuallyHiddenStyles);
    targetDocument.body.append(elementRef.current);
    return () => {
      var _elementRef_current;
      (_elementRef_current = elementRef.current) === null || _elementRef_current === undefined ? undefined : _elementRef_current.remove();
      elementRef.current = null;
    };
  }, [targetDocument]);
  return announce;
};

const CopilotProvider = props => {
  const {
    announce,
    themeExtension,
    mode,
    customStyleHooks,
    ...otherProps
  } = props;
  const announceDefault = useAnnounce();
  const style = React.useMemo(() => {
    const mergedTheme = shallowMerge(copilotLightThemeExtension, themeExtension);
    const style = {};
    for (const [key, value] of Object.entries(mergedTheme)) {
      style[`--fai-${key}`] = value;
    }
    return shallowMerge(style, otherProps.style);
  }, [themeExtension, otherProps.style]);
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    ...otherProps,
    style: style
  }, /*#__PURE__*/React.createElement(ModeContext.Provider, {
    value: {
      mode: mode !== null && mode !== undefined ? mode : 'canvas'
    }
  }, /*#__PURE__*/React.createElement(AnnounceProvider, {
    value: {
      announce: announce !== null && announce !== undefined ? announce : announceDefault
    }
  }, /*#__PURE__*/React.createElement(CustomStyleHooksProvider, {
    value: customStyleHooks
  }, props.children))));
};
function shallowMerge(a, b) {
  // Merge impacts perf: we should like to avoid it if it's possible
  if (a && b) {
    return {
      ...a,
      ...b
    };
  }
  if (a) {
    return a;
  }
  return b;
}
// hiding this for now, if we need to we can export it later
const ModeContext = /*#__PURE__*/React.createContext({
  mode: 'canvas'
});
/**
 * A hook that returns default mode always. If defaultMode is not provided,
 * it will return the mode from the context, or 'canvas' if there is no context.
 * @param defaultMode - Usually the 'mode' prop from a component.
 * @returns -'canvas' or 'sidecar'
 */
const useCopilotMode = defaultMode => {
  const modeFromContext = React.useContext(ModeContext).mode;
  var _ref;
  return (_ref = defaultMode !== null && defaultMode !== undefined ? defaultMode : modeFromContext) !== null && _ref !== undefined ? _ref : 'canvas';
};
CopilotProvider.displayName = 'CopilotProvider';

const useStyles$w = __styles({
  hidden: {
    mc9l5x: "fjseox"
  }
}, {
  d: [".fjseox{display:none;}"]
});
/**
 * Hook to package a `ReferenceGroupToggle` and `ReferenceList` together and
 * maintain their `isOpen` state.
 *
 * When rendering a group of references, prefer to use this hook
 * hook to ensure state is maintained correctly
 */
const useReferenceGroup = props => {
  const [isOpen, setIsOpen] = React.useState(false);
  const styles = useStyles$w();
  const referenceListId = useId('reference-list', props.referenceListId);
  return React.useMemo(() => {
    const handleClick = () => {
      setIsOpen(isOpen => !isOpen);
    };
    const referenceGroupToggleProps = {
      'aria-controls': referenceListId,
      isOpen,
      onClick: handleClick
    };
    const referenceListProps = {
      className: isOpen ? undefined : styles.hidden,
      id: referenceListId
    };
    return {
      referenceGroupToggleProps,
      referenceListProps
    };
  }, [isOpen, referenceListId, styles.hidden]);
};

/** deprecated Use ReferenceListV2 component, hooks and types instead. */
const referenceListClassNames = {
  root: 'fai-ReferenceList'
};
/** deprecated Use ReferenceListV2 component, hooks and types instead. */
const referenceListItemClassName = 'fai-ReferenceList__item';
/**
 * Styles for the root slot
 */
const useRootClassName$2 = __resetStyles("rc0s888", null, [".rc0s888{padding:0;margin:0;display:flex;flex-direction:column;gap:var(--spacingVerticalS);}", ".rc0s888>.fai-ReferenceList__item{list-style-type:none;}"]);
/**
 * Apply styling to the ReferenceList slots based on the state
 *
 * deprecated Use ReferenceListV2 component, hooks and types instead.
 */
const useReferenceListStyles_unstable = state => {
  'use no memo';

  state.root.className = mergeClasses(referenceListClassNames.root, useRootClassName$2(), state.root.className);
  return state;
};

/**
 * Create the state required to render ReferenceList.
 *
 * The returned state can be modified with hooks such as useReferenceListStyles_unstable,
 * before being passed to renderReferenceList_unstable.
 *
 * @param props - props from this instance of ReferenceList
 * @param ref - reference to root HTMLElement of ReferenceList
 *
 * deprecated Use ReferenceListV2 component, hooks and types instead.
 */
const useReferenceList_unstable = (props, ref) => {
  return {
    components: {
      root: 'ol'
    },
    root: always(getIntrinsicElementProps('ol', {
      ref,
      ...props,
      children: React.Children.map(props.children, child => /*#__PURE__*/React.createElement("li", {
        className: referenceListItemClassName
      }, child))
    }), {
      elementType: 'ol'
    })
  };
};

/** deprecated Use ReferenceListV2 component, hooks and types instead. */
const renderReferenceList_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsx(state.root, {});
};

/** deprecated Use ReferenceListV2 component, hooks and types instead. */
const ReferenceList = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useReferenceList_unstable(props, ref);
  useReferenceListStyles_unstable(state);
  useCustomStyleHook('useReferenceListStyles')(state);
  return renderReferenceList_unstable(state);
});
ReferenceList.displayName = 'ReferenceList';

/**
 * Create the state required to render ReferenceGroupToggle.
 *
 * The returned state can be modified with hooks such as useReferenceGroupToggleStyles_unstable,
 * before being passed to renderReferenceGroupToggle_unstable.
 *
 * @param props - props from this instance of ReferenceGroupToggle
 * @param ref - reference to root HTMLElement of ReferenceGroupToggle
 */
const useReferenceGroupToggle_unstable = (props, ref) => {
  const {
    isOpen = false
  } = props;
  const mode = useCopilotMode(props.mode);
  return {
    mode,
    isOpen,
    components: {
      root: 'button',
      icon: 'span'
    },
    root: always(getIntrinsicElementProps('button', {
      ref,
      'aria-expanded': isOpen,
      type: 'button',
      ...props
    }), {
      elementType: 'button'
    }),
    icon: optional(props.icon, {
      defaultProps: {
        children: isOpen ? /*#__PURE__*/React.createElement(ChevronUp16Regular, null) : /*#__PURE__*/React.createElement(ChevronDown16Regular, null)
      },
      renderByDefault: true,
      elementType: 'span'
    })
  };
};

/**
 * Render the final JSX of ReferenceGroupToggle
 */
const renderReferenceGroupToggle_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.root.children, state.icon && /*#__PURE__*/jsx(state.icon, {})]
  });
};

const referenceGroupToggleClassNames = {
  root: 'fai-ReferenceGroupToggle',
  icon: 'fai-ReferenceGroupToggle__icon'
};
const useButtonBaseClassName = __resetStyles("rqbbkgr", null, [".rqbbkgr{display:inline-flex;column-gap:var(--spacingHorizontalSNudge);align-items:center;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase200);border:0;background-color:var(--colorTransparentBackground);color:var(--colorNeutralForeground3);cursor:pointer;width:max-content;padding:var(--spacingVerticalXS) 0;}"]);
const useIconBaseClassName = __resetStyles("r18biwo", null, [".r18biwo{display:inline-flex;align-items:center;}"]);
const useStyles$v = __styles({
  canvas: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fwrc4pm"
  },
  sidecar: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fcpl73t"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fcpl73t{line-height:var(--lineHeightBase100);}"]
});
/**
 * Apply styling to the ReferenceGroupToggle slots based on the state
 */
const useReferenceGroupToggleStyles_unstable = state => {
  'use no memo';

  const {
    mode
  } = state;
  const styles = useStyles$v();
  const iconBaseClassName = useIconBaseClassName();
  const buttonBaseClassName = useButtonBaseClassName();
  state.root.className = mergeClasses(referenceGroupToggleClassNames.root, buttonBaseClassName, styles[mode], state.root.className);
  if (state.icon) {
    state.icon.className = mergeClasses(referenceGroupToggleClassNames.icon, iconBaseClassName, state.icon.className);
  }
  return state;
};

/** deprecated The ReferenceGroup pattern is deprecated and will be removed in a future release. */
const ReferenceGroupToggle = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useReferenceGroupToggle_unstable(props, ref);
  useReferenceGroupToggleStyles_unstable(state);
  return renderReferenceGroupToggle_unstable(state);
});
ReferenceGroupToggle.displayName = 'ReferenceGroupToggle';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render CopilotChat.
 *
 * The returned state can be modified with hooks such as useCopilotChatStyles_unstable,
 * before being passed to renderCopilotChat_unstable.
 *
 * @param props - props from this instance of CopilotChat
 * @param ref - reference to root HTMLElement of CopilotChat
 */
const useCopilotChat_unstable = (props, ref) => {
  const arrowAttrs = useArrowNavigationGroup({
    memorizeCurrent: true,
    unstable_hasDefault: true
  });
  const state = {
    components: {
      root: 'div'
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      role: 'feed',
      ...props,
      ...arrowAttrs
    }), {
      elementType: 'div'
    })
  };
  return state;
};

/**
 * Render the final JSX of CopilotChat
 */
const renderCopilotChat_unstable = state => {
  assertSlots(state);
  // TODO Add additional slots in the appropriate place
  return /*#__PURE__*/jsx(state.root, {});
};

const copilotChatClassNames = {
  root: 'fai-CopilotChat'
};
/**
 * Styles for the root slot
 */
const useStyles$u = __styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    Belr9w4: "f1noh358"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", ".f1noh358{row-gap:var(--spacingVerticalM);}"]
});
/**
 * Apply styling to the CopilotChat slots based on the state
 */
const useCopilotChatStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$u();
  state.root.className = mergeClasses(copilotChatClassNames.root, styles.root, state.root.className);
  // TODO Add class names to slots, for example:
  // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);
  return state;
};

// CopilotChat component - TODO: add more docs
const CopilotChat = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useCopilotChat_unstable(props, ref);
  useCopilotChatStyles_unstable(state);
  return renderCopilotChat_unstable(state);
});
CopilotChat.displayName = 'CopilotChat';

const hasMozElement = () => {
  var _document;
  return typeof ((_document = document) == null ? undefined : _document.mozSetImageElement) === "function";
};
const hasWebkitCanvas = () => {
  var _document;
  return typeof ((_document = document) == null ? undefined : _document.getCSSCanvasContext) === "function";
};
const hasHoudini = () => {
  return (
    // This will hold regardless of the specific `window` object
    // eslint-disable-next-line no-restricted-globals
    typeof window !== "undefined" && // This will hold regardless of the specific `window` object
    // eslint-disable-next-line no-restricted-globals
    window.CSS && "paintWorklet" in CSS && "registerProperty" in CSS
  );
};

/**
 * Add a PaintWorklet module to the CSS Paint API.
 * @param baseUrl Base URL (e.g., https://cdn.example.com/paintworklets/)
 * @param fileName Name of the PaintWorklet file (e.g., "Flair.min.js")
 * @returns Promise that resolves when the module is added and throws when there is an error.
 */ const addModule = (baseUrl, fileName)=>{
    if (hasHoudini()) {
        const url = `${baseUrl}${fileName}`;
        return CSS.paintWorklet.addModule(url);
    }
    return Promise.resolve();
};

const lerp = (start, end, currentTime, duration, delay = 0)=>{
    const totalDuration = delay + duration;
    if (currentTime <= delay) {
        return start;
    } else if (currentTime >= totalDuration) {
        return end;
    }
    if (typeof start === 'number') {
        return doLerp(start, end, currentTime / totalDuration);
    } else {
        return start.map((s, i)=>doLerp(s, end[i], currentTime / totalDuration));
    }
};
const doLerp = (start, end, t)=>{
    const value = start + (end - start) * t;
    return start > end ? Math.max(value, end) : Math.min(value, end);
};

const parseRgba = (rgbaHex)=>{
    const color = parseInt(rgbaHex, 16);
    const r = color >> 24 & 255;
    const g = color >> 16 & 255;
    const b = color >> 8 & 255;
    const a = color & 255;
    return [
        r,
        g,
        b,
        Math.trunc(a / 255 * 100) / 100
    ];
};
const hexToRgba = (hex)=>{
    let color = hex.charAt(0) === '#' ? hex.substring(1) : hex;
    const len = color.length;
    // See: https://developer.mozilla.org/en-US/docs/Web/CSS/hex-color
    if (len === 8) ; else if (len === 6) {
        // RGB
        color = `${color}ff`;
    } else if (len === 3) {
        // RGB shorthand
        color = `${color[0]}${color[0]}${color[1]}${color[1]}${color[2]}${color[2]}ff`;
    } else if (len === 4) {
        // RGBA shorthand
        color = `${color[0]}${color[0]}${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
    }
    return parseRgba(color);
};

const stepValueToPercentage = (stepKey)=>{
    var _stepKey_match;
    const [, percentage] = (_stepKey_match = stepKey.match(/(\d+)%/)) != null ? _stepKey_match : [];
    if (percentage === undefined) {
        if (stepKey === 'to') {
            return 1;
        }
        return 0;
    }
    return parseFloat(percentage) / 100;
};
const timeToNumber = (time)=>{
    return parseFloat(time.trim().replace(/m?s/, ''));
};
const processTimingFunction = ()=>{
    return 'linear';
};
const matchColor = (color)=>{
    let matches = color.match(/rgba\((\d+),\s?(\d+),\s?(\d+),\s(\d*\.?\d+)\)/);
    if (matches) {
        // Parse rgba() syntax
        return matches == null ? undefined : matches.slice(1, 5).map(parseFloat); // [ r, g, b, a ]
    } else {
        // Is it a hex color?
        matches = color.match(/#([0-9a-fA-F]{3,8})/);
        if (matches) {
            return hexToRgba(matches[1]);
        }
    }
    return undefined;
};
const parseValue = (value, key, styles)=>{
    const floatValue = parseFloat(value);
    if (!Number.isNaN(floatValue)) {
        return floatValue;
    }
    const rgba = matchColor(value);
    if (rgba) {
        return rgba;
    }
    const matches = value.match(/var\(([-a-zA-Z0-9]+)\)/);
    if (!matches) {
        console.error('Could not parse value', value, 'key', key);
        return;
    }
    const [, varName] = matches;
    const styleValue = styles.getPropertyValue(varName);
    if (!styleValue) {
        console.error('Could not parse value', value, 'varName', varName);
    }
    return matchColor(styleValue);
};
const arrayToRgba = ([r, g, b, a])=>{
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};

const eases = {
  linear: lerp
};
const createKeyframeAnimation = ({ animations, delay, duration, timingFunction, iterationCount = [
  1
], target }) => {
  const iterations = iterationCount;
  const durations = duration.split(",").map(timeToNumber);
  const delays = delay.split(",").map(timeToNumber);
  const timingFunctions = timingFunction.split(",").map(processTimingFunction);
  const anims = [];
  let overallDuration = 0;
  const styles = getComputedStyle(target);
  for (let animationIndex = 0; animationIndex < animations.length; animationIndex++) {
    const animation = animations[animationIndex];
    const steps = Object.entries(animation);
    if (steps.length < 2) {
      console.error("Animation must have at least 2 steps");
      return;
    }
    var _iterations_animationIndex;
    const iterationCount2 = (_iterations_animationIndex = iterations[animationIndex]) != null ? _iterations_animationIndex : 1;
    var _delays_animationIndex;
    const delay2 = (_delays_animationIndex = delays[animationIndex]) != null ? _delays_animationIndex : 0;
    var _durations_animationIndex;
    const duration2 = (_durations_animationIndex = durations[animationIndex]) != null ? _durations_animationIndex : 0;
    const animDuration = delay2 + duration2;
    if (animDuration > overallDuration) {
      overallDuration = animDuration;
    }
    var _timingFunctions_animationIndex;
    const timingFunction2 = (_timingFunctions_animationIndex = timingFunctions[animationIndex]) != null ? _timingFunctions_animationIndex : "linear";
    const anim = {
      currentValues: {},
      keyframes: []
    };
    anims.push(anim);
    for (let endIndex = 1; endIndex < steps.length; endIndex++) {
      const startIndex = endIndex - 1;
      const [startKey, startValues] = steps[startIndex];
      const [endKey, endValues] = steps[endIndex];
      const startPercentage = stepValueToPercentage(startKey);
      const endPercentage = stepValueToPercentage(endKey);
      const startTime = duration2 * startPercentage + delay2;
      const endTime = Math.min(duration2 * endPercentage + delay2, overallDuration);
      const tweenStartValues = {};
      const tweenEndValues = {};
      for (const value of Object.keys(startValues)) {
        var _anim_currentValues, _value, _tweenStartValues, _value1;
        const v = parseValue(startValues[value], value, styles);
        if (v === undefined) {
          return;
        }
        var _;
        (_ = (_anim_currentValues = anim.currentValues)[_value = value]) != null ? _ : _anim_currentValues[_value] = v;
        var _1;
        (_1 = (_tweenStartValues = tweenStartValues)[_value1 = value]) != null ? _1 : _tweenStartValues[_value1] = v;
      }
      for (const value of Object.keys(endValues)) {
        var _tweenEndValues, _value2;
        const v = parseValue(endValues[value], value, styles);
        if (v === undefined) {
          return;
        }
        var _2;
        (_2 = (_tweenEndValues = tweenEndValues)[_value2 = value]) != null ? _2 : _tweenEndValues[_value2] = v;
      }
      anim.keyframes.push({
        iterationCount: iterationCount2,
        startTime,
        endTime,
        duration: endTime - startTime,
        ease: eases[timingFunction2],
        startValues: tweenStartValues,
        endValues: tweenEndValues
      });
    }
  }
  return {
    anims,
    overallDuration
  };
};

const animate = (params) => {
  const { onComplete, isStopped, onUpdate, ...otherParams } = params;
  const result = createKeyframeAnimation(otherParams);
  if (!result) {
    console.error("Unable to create keyframe animation.");
    return;
  }
  const { anims, overallDuration } = result;
  tick(anims, overallDuration, onComplete, onUpdate, isStopped);
};
const stringifyValue = (value) => typeof value === "number" ? String(value) : arrayToRgba(value);
const tick = (anims, overallDuration, onComplete, onUpdate, isStopped) => {
  let start = performance.now();
  const currentValues = /* @__PURE__ */ new Map();
  let currentIteration = 1;
  const raf = (time = performance.now()) => {
    const currentDuration = time - start;
    currentValues.clear();
    const initialFrame = (animValue) => {
      for (const [key, value] of Object.entries(animValue.keyframes[0].startValues)) {
        currentValues.set(key, stringifyValue(value));
      }
    };
    const lastFrame = (animValue) => {
      for (const [key, value] of Object.entries(animValue.keyframes[animValue.keyframes.length - 1].endValues)) {
        currentValues.set(key, stringifyValue(value));
      }
    };
    const nextFrame = (animValue) => {
      const animData = animValue.keyframes.find((animData2) => currentDuration >= animData2.startTime && currentDuration <= animData2.endTime);
      if (!animData) {
        console.error("Could not find animData for currentDuration", currentDuration);
        return;
      }
      for (const key of Object.keys(animData.startValues)) {
        const startValue = animData.startValues[key];
        const endValue = animData.endValues[key];
        const value = animData.ease(startValue, endValue, currentDuration - animData.startTime, animData.duration);
        animValue.currentValues[key] = value;
        currentValues.set(key, stringifyValue(value));
      }
    };
    for (const animValue of anims) {
      if (currentIteration > animValue.keyframes[0].iterationCount) {
        lastFrame(animValue);
      } else if (currentDuration <= animValue.keyframes[0].startTime) {
        initialFrame(animValue);
      } else if (currentDuration >= animValue.keyframes[animValue.keyframes.length - 1].endTime) {
        lastFrame(animValue);
      } else {
        nextFrame(animValue);
      }
    }
    if (isStopped()) {
      for (const animValue of anims) {
        initialFrame(animValue);
      }
      onComplete(currentValues);
    } else if (currentDuration >= overallDuration && anims.some((anim) => anim.keyframes.some((keyframe) => currentIteration < keyframe.iterationCount))) {
      currentIteration++;
      start = performance.now();
      requestAnimationFrame(raf);
    } else if (currentDuration >= overallDuration) {
      onComplete(currentValues);
    } else {
      requestAnimationFrame(raf);
    }
    onUpdate(currentValues);
  };
  raf();
};

const createMozContext = (id) => {
  const canvas = document.createElement("canvas");
  canvas.id = id;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    console.error("Unable to create moz-element rendering context");
    return null;
  }
  ctx.canvas.style.position = "absolute";
  ctx.canvas.style.top = "-99999px";
  ctx.canvas.style.left = "-99999px";
  return ctx;
};
const createDataUrlContext = (id) => {
  return createMozContext(id);
};
const createWebkitContext = (id, width, height) => {
  var _document_getCSSCanvasContext;
  const ctx = (_document_getCSSCanvasContext = document.getCSSCanvasContext == null ? undefined : document.getCSSCanvasContext.call(document, "2d", id, width, height)) != null ? _document_getCSSCanvasContext : null;
  if (!ctx) {
    return null;
  }
  ctx.canvas.style.position = "absolute";
  return ctx;
};
const appendCanvas = (parent, canvas) => {
  if (!canvas.isConnected) {
    parent.appendChild(canvas);
  }
};
const handleCanvasResize = (wrapper, ctx, id, width, height) => {
  if (!ctx) {
    const newCtx = createWebkitContext(id, width, height);
    if (!newCtx) {
      return null;
    }
    appendCanvas(wrapper, newCtx.canvas);
    return newCtx;
  }
  const canvas = ctx.canvas;
  canvas.width = width;
  canvas.height = height;
  return ctx;
};

const playAnim = (state, paintWorklet, animationParams) => {
  const props = /* @__PURE__ */ new Map();
  const styles = getComputedStyle(state.target);
  const rect = {
    width: 0,
    height: 0
  };
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target === state.target) {
        if (Array.isArray(entry.borderBoxSize)) {
          rect.width = entry.borderBoxSize[0].inlineSize;
          rect.height = entry.borderBoxSize[0].blockSize;
        } else {
          const { width, height } = entry.target.getBoundingClientRect();
          rect.width = width;
          rect.height = height;
        }
        state.ctx = handleCanvasResize(state.wrapper, state.ctx, state.id, rect.width, rect.height);
      }
    }
  });
  return (onComplete, onUpdate) => {
    state.running = true;
    resizeObserver.observe(state.target);
    const onAnimUpdate = (currentValues) => {
      var _paintWorklet_constructor_inputProperties;
      const inputProperties = (_paintWorklet_constructor_inputProperties = paintWorklet.constructor.inputProperties) != null ? _paintWorklet_constructor_inputProperties : [];
      for (const prop of inputProperties) {
        props.set(prop, styles.getPropertyValue(prop));
      }
      if (!state.ctx) {
        return;
      }
      for (const [key, value] of currentValues.entries()) {
        props.set(key, value);
      }
      paintWorklet.paint(state.ctx, rect, props);
      if (hasMozElement()) {
        state.target.style.backgroundImage = `-moz-element(#${state.id})`;
      } else if (hasWebkitCanvas()) {
        state.target.style.backgroundImage = `-webkit-canvas(#${state.id})`;
      } else {
        const urlBackgroundImage = `url(${state.ctx.canvas.toDataURL("image/png")})`;
        state.target.style.backgroundImage = urlBackgroundImage;
      }
      onUpdate == null ? undefined : onUpdate(currentValues);
    };
    animate({
      ...animationParams,
      target: state.target,
      isStopped: () => !state.running,
      onUpdate: onAnimUpdate,
      onComplete: (currentValues) => {
        state.running = false;
        resizeObserver.unobserve(state.target);
        onComplete(currentValues);
      }
    });
  };
};

const createWrapper = (id) => {
  let wrapper = document.getElementById(id);
  if (!wrapper) {
    wrapper = document.createElement("div");
    wrapper.id = id;
    wrapper.style.position = "fixed";
    wrapper.style.overflow = "hidden";
    wrapper.style.width = "1px";
    wrapper.style.height = "1px";
    wrapper.style.left = "0";
    wrapper.style.top = "0";
    wrapper.style.opacity = "0";
    wrapper.style.contain = "strict";
    wrapper.style.userSelect = "none";
    wrapper.tabIndex = -1;
  }
  return wrapper;
};
const appendWrapper = (parent, id = "foo") => {
  const wrapper = createWrapper(id);
  if (!wrapper.isConnected) {
    parent.appendChild(wrapper);
  }
  return wrapper;
};

const cannotDraw = {
  id: "",
  canvas: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  play: () => {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  cleanup: () => {
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  stop: () => {
  }
};
let flairFallbackId = 0;
const fallbackPaintAnimation = (target, paintWorklet, animationParams) => {
  var _state_ctx;
  const state = {
    target,
    ctx: null,
    mode: "to-data-url",
    id: `houdini-fallback-${++flairFallbackId}`,
    wrapper: null,
    running: false
  };
  if (!state.wrapper) {
    state.wrapper = appendWrapper(document.body);
  }
  if (hasMozElement()) {
    const ctx = createMozContext(state.id);
    if (!ctx) {
      return cannotDraw;
    }
    state.ctx = ctx;
    state.mode = "moz-element";
    appendCanvas(state.wrapper, state.ctx.canvas);
  } else if (hasWebkitCanvas()) {
    state.mode = "webkit-canvas";
  } else {
    const ctx = createDataUrlContext(state.id);
    if (!ctx) {
      return cannotDraw;
    }
    state.ctx = ctx;
    state.mode = "to-data-url";
    appendCanvas(state.wrapper, state.ctx.canvas);
  }
  const play = playAnim(state, paintWorklet, animationParams);
  const stop = () => {
    state.running = false;
  };
  const cleanup = () => {
    var _state_ctx2, _state_wrapper;
    (_state_ctx2 = state.ctx) == null ? undefined : _state_ctx2.canvas.remove();
    if (((_state_wrapper = state.wrapper) == null ? undefined : _state_wrapper.childElementCount) === 0) {
      state.wrapper.remove();
    }
  };
  var _state_ctx_canvas;
  return {
    id: state.id,
    canvas: (_state_ctx_canvas = (_state_ctx = state.ctx) == null ? undefined : _state_ctx.canvas) != null ? _state_ctx_canvas : null,
    play,
    cleanup,
    stop
  };
};

const DEFAULT_RADII = [0, 0, 0, 0];
/**
 * Fallback implementation of `roundRect()`.
 * See: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/roundRect
 * @param ctx Canvas rendering context
 * @param x The x-axis coordinate of the rectangle's starting point, in pixels.
 * @param y The y-axis coordinate of the rectangle's starting point, in pixels.
 * @param w The rectangle's width. Positive values are to the right, and negative to the left.
 * @param h The rectangle's height. Positive values are down, and negative are up.
 * @param radii A number or list specifying the radii of the circular arc to be used for the corners of the rectangle. See link for more details: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/roundRect
 */
const roundRect = (ctx, x, y, w, h, radii) => {
  let rad = DEFAULT_RADII;
  if (Array.isArray(radii)) {
    if (radii.length === 4) {
      rad = radii;
    } else if (radii.length === 1) {
      rad = new Array(4).fill(radii[0]);
    } else if (radii.length === 2) {
      rad = [radii[0], radii[1], radii[0], radii[1]];
    } else if (radii.length === 3) {
      rad = [radii[0], radii[1], radii[2], radii[1]];
    }
  } else if (typeof radii === 'number') {
    rad = new Array(4).fill(radii);
  }
  ctx.moveTo(x + rad[0], y);
  ctx.arcTo(x + w, y, x + w, y + h, rad[1]);
  ctx.arcTo(x + w, y + h, x, y + h, rad[2]);
  ctx.arcTo(x, y + h, x, y, rad[3]);
  ctx.arcTo(x, y, x + w, y, rad[0]);
  ctx.closePath();
};

class Flair {
  static get inputProperties() {
    return ["--fai-flair-angle", "--fai-flair-color-1", "--fai-flair-color-2", "--fai-flair-color-3", "--fai-flair-stroke-width", "border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"];
  }
  paint(ctx, size, props) {
    const angle = parseFloat(String(props.get("--fai-flair-angle")));
    const {
      width,
      height
    } = size;
    const midX = width / 2;
    const midY = height / 2;
    const length = Math.sqrt(midX * midX + midY * midY);
    const lenX = Math.cos(angle) * length;
    const lenY = Math.sin(angle) * length;
    const x1 = midX - lenX;
    const y1 = midY - lenY;
    const x2 = midX + lenX;
    const y2 = midY + lenY;
    const gradient = ctx.createLinearGradient(x1, y1, x2, y2);
    gradient.addColorStop(0, String(props.get(`--fai-flair-color-1`)));
    gradient.addColorStop(0.5, String(props.get(`--fai-flair-color-2`)));
    gradient.addColorStop(1, String(props.get(`--fai-flair-color-3`)));
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);
    const tmpOp = ctx.globalCompositeOperation;
    ctx.globalCompositeOperation = "destination-out";
    const strokeWidth = parseFloat(String(props.get("--fai-flair-stroke-width")));
    const strokes = {
      top: strokeWidth,
      right: strokeWidth,
      bottom: strokeWidth,
      left: strokeWidth
    };
    const radii = [Math.max(parseFloat(String(props.get("border-top-left-radius"))) - strokeWidth, 0), Math.max(parseFloat(String(props.get("border-top-right-radius"))) - strokeWidth, 0), Math.max(parseFloat(String(props.get("border-bottom-right-radius"))) - strokeWidth, 0), Math.max(parseFloat(String(props.get("border-bottom-left-radius"))) - strokeWidth, 0)];
    ctx.fillStyle = "blue";
    ctx.beginPath();
    if (ctx.roundRect) {
      ctx.roundRect(strokes.left, strokes.top, width - strokes.right * 2, height - strokes.bottom * 2, radii);
    } else {
      roundRect(ctx, strokes.left, strokes.top, width - strokes.right * 2, height - strokes.bottom * 2, radii);
    }
    ctx.fill();
    ctx.globalCompositeOperation = tmpOp;
  }
}
try {
  registerPaint("flair", Flair);
} catch (e) {
}

/**
 * Initializes the CSS custom properties needed for Flair
 * @returns Promise<void> This Promise will return an error if the initialization process fails.
 */
const initializeFlairCustomProperties = () => {
  if (hasHoudini()) {
    try {
      CSS.registerProperty({
        // Radians!
        name: '--fai-flair-angle',
        syntax: '<number>',
        inherits: true,
        initialValue: String(3 * Math.PI / 4)
      });
      CSS.registerProperty({
        name: '--fai-flair-color-1',
        syntax: '<color>',
        inherits: true,
        initialValue: 'transparent'
      });
      CSS.registerProperty({
        name: '--fai-flair-color-2',
        syntax: '<color>',
        inherits: true,
        initialValue: 'transparent'
      });
      CSS.registerProperty({
        name: '--fai-flair-color-3',
        syntax: '<color>',
        inherits: true,
        initialValue: 'transparent'
      });
      CSS.registerProperty({
        name: '--fai-flair-stroke-width',
        syntax: '<length>',
        inherits: true,
        initialValue: '2px'
      });
    } catch (e) {
      // This can only be called once and things like hot module replacement
      // can trigger it multiple times. Discard errors.
    }
  }
};

const START_ANGLE = 3 * Math.PI / 4;
const flairTokens = {
  startAngle: String(START_ANGLE),
  endAngle: String(START_ANGLE + 2 * Math.PI),
  color1Transparent: tokens.colorBrandFlair1Transparent,
  color2Transparent: tokens.colorBrandFlair2Transparent,
  color3Transparent: tokens.colorBrandFlair3Transparent,
  color1Opaque: tokens.colorBrandFlair1,
  color2Opaque: tokens.colorBrandFlair2,
  color3Opaque: tokens.colorBrandFlair3,
  // High contrast tokens
  color1HC: tokens.colorHCFlair1,
  color2HC: tokens.colorHCFlair2,
  color3HC: tokens.colorHCFlair3,
  backgroundImage: 'paint(flair)',
  flairAnimationDuration: '2000ms, 1200ms, 1200ms, 1200ms',
  flairAnimationDelay: '0ms, 0ms, 200ms, 400ms',
  flairAnimationTimingFunction: 'linear, linear, linear, linear',
  flairColorStop1: '0%',
  flairColorStop2: '33%',
  flairColorStop3: '83%',
  flairColorStop4: '100%'
};
const flairAnimationTokens = {
  angleAnimation: {
    '0%': {
      '--fai-flair-angle': flairTokens.startAngle
    },
    '100%': {
      '--fai-flair-angle': flairTokens.endAngle
    }
  },
  color1Animation: {
    [flairTokens.flairColorStop1]: {
      '--fai-flair-color-1': flairTokens.color1Transparent
    },
    [flairTokens.flairColorStop2]: {
      '--fai-flair-color-1': flairTokens.color1Opaque
    },
    [flairTokens.flairColorStop3]: {
      '--fai-flair-color-1': flairTokens.color1Opaque
    },
    [flairTokens.flairColorStop4]: {
      '--fai-flair-color-1': flairTokens.color1Transparent
    }
  },
  color2Animation: {
    [flairTokens.flairColorStop1]: {
      '--fai-flair-color-2': flairTokens.color2Transparent
    },
    [flairTokens.flairColorStop2]: {
      '--fai-flair-color-2': flairTokens.color2Opaque
    },
    [flairTokens.flairColorStop3]: {
      '--fai-flair-color-2': flairTokens.color2Opaque
    },
    [flairTokens.flairColorStop4]: {
      '--fai-flair-color-2': flairTokens.color2Transparent
    }
  },
  color3Animation: {
    [flairTokens.flairColorStop1]: {
      '--fai-flair-color-3': flairTokens.color3Transparent
    },
    [flairTokens.flairColorStop2]: {
      '--fai-flair-color-3': flairTokens.color3Opaque
    },
    [flairTokens.flairColorStop3]: {
      '--fai-flair-color-3': flairTokens.color3Opaque
    },
    [flairTokens.flairColorStop4]: {
      '--fai-flair-color-3': flairTokens.color3Transparent
    }
  },
  colorHC1Animation: {
    [flairTokens.flairColorStop1]: {
      '--fai-flair-color-1': flairTokens.color3Transparent
    },
    [flairTokens.flairColorStop2]: {
      '--fai-flair-color-1': flairTokens.color1HC
    },
    [flairTokens.flairColorStop3]: {
      '--fai-flair-color-1': flairTokens.color1HC
    },
    [flairTokens.flairColorStop4]: {
      '--fai-flair-color-1': flairTokens.color3Transparent
    }
  },
  colorHC2Animation: {
    [flairTokens.flairColorStop1]: {
      '--fai-flair-color-2': flairTokens.color3Transparent
    },
    [flairTokens.flairColorStop2]: {
      '--fai-flair-color-2': flairTokens.color2HC
    },
    [flairTokens.flairColorStop3]: {
      '--fai-flair-color-2': flairTokens.color2HC
    },
    [flairTokens.flairColorStop4]: {
      '--fai-flair-color-2': flairTokens.color3Transparent
    }
  },
  colorHC3Animation: {
    [flairTokens.flairColorStop1]: {
      '--fai-flair-color-3': flairTokens.color3Transparent
    },
    [flairTokens.flairColorStop2]: {
      '--fai-flair-color-3': flairTokens.color3HC
    },
    [flairTokens.flairColorStop3]: {
      '--fai-flair-color-3': flairTokens.color3HC
    },
    [flairTokens.flairColorStop4]: {
      '--fai-flair-color-3': flairTokens.color3Transparent
    }
  }
};

const FLUENT_CDN_BASE_URL = 'https://res-1.cdn.office.net/files/fabric-cdn-prod_20240228.001';
const DEFAULT_BASE_URL = `${FLUENT_CDN_BASE_URL}/assets/animations/flair/`;
const DEFAULT_FILE_URL = 'flair.min.js';

const flair = target => {
  return fallbackPaintAnimation(target, new Flair(), {
    animations: [flairAnimationTokens.angleAnimation, flairAnimationTokens.color1Animation, flairAnimationTokens.color2Animation, flairAnimationTokens.color3Animation],
    delay: flairTokens.flairAnimationDelay,
    duration: flairTokens.flairAnimationDuration,
    timingFunction: flairTokens.flairAnimationTimingFunction
  });
};

const initializedModules = {};
initializeFlairCustomProperties();
const useHoudiniStyles = __styles({
  base: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1kijzfu",
    Bcmaq0h: "fvrkw42"
  }
}, {
  d: [[".f1kijzfu{border-radius:var(--borderRadiusXLarge);}", {
    p: -1
  }], ".fvrkw42{background-image:paint(flair);}"]
});
const useFlairClassName = __resetStyles("r1x1johe", "rpvaigb", {
  r: [".r1x1johe{animation-duration:2000ms,1200ms,1200ms,1200ms;animation-delay:0ms,0ms,200ms,400ms;animation-timing-function:linear,linear,linear,linear;animation-fill-mode:forwards,forwards,forwards,forwards;animation-name:rcttjya,r1qhzb60,rxwm6xz,r1ule99e;}", "@keyframes rcttjya{0%{--fai-flair-angle:2.356194490192345;}100%{--fai-flair-angle:8.63937979737193;}}", "@keyframes r1qhzb60{0%{--fai-flair-color-1:var(--fai-colorBrandFlair1Transparent);}33%{--fai-flair-color-1:var(--fai-colorBrandFlair1);}83%{--fai-flair-color-1:var(--fai-colorBrandFlair1);}100%{--fai-flair-color-1:var(--fai-colorBrandFlair1Transparent);}}", "@keyframes rxwm6xz{0%{--fai-flair-color-2:var(--fai-colorBrandFlair2Transparent);}33%{--fai-flair-color-2:var(--fai-colorBrandFlair2);}83%{--fai-flair-color-2:var(--fai-colorBrandFlair2);}100%{--fai-flair-color-2:var(--fai-colorBrandFlair2Transparent);}}", "@keyframes r1ule99e{0%{--fai-flair-color-3:var(--fai-colorBrandFlair3Transparent);}33%{--fai-flair-color-3:var(--fai-colorBrandFlair3);}83%{--fai-flair-color-3:var(--fai-colorBrandFlair3);}100%{--fai-flair-color-3:var(--fai-colorBrandFlair3Transparent);}}", ".rpvaigb{animation-duration:2000ms,1200ms,1200ms,1200ms;animation-delay:0ms,0ms,200ms,400ms;animation-timing-function:linear,linear,linear,linear;animation-fill-mode:forwards,forwards,forwards,forwards;animation-name:rcttjya,r1qhzb60,rxwm6xz,r1ule99e;}"],
  s: ["@media (forced-colors: active){.r1x1johe{forced-color-adjust:none;background-color:Canvas;color:CanvasText;animation-duration:2000ms,1200ms,1200ms,1200ms;animation-delay:0ms,0ms,200ms,400ms;animation-timing-function:linear,linear,linear,linear;animation-fill-mode:forwards,forwards,forwards,forwards;animation-name:rcttjya,r1c3vx44,r9mtrlt,rkmtvhk;}@keyframes rcttjya{0%{--fai-flair-angle:2.356194490192345;}100%{--fai-flair-angle:8.63937979737193;}}@keyframes r1c3vx44{0%{--fai-flair-color-1:var(--fai-colorBrandFlair3Transparent);}33%{--fai-flair-color-1:var(--fai-colorHCFlair1);}83%{--fai-flair-color-1:var(--fai-colorHCFlair1);}100%{--fai-flair-color-1:var(--fai-colorBrandFlair3Transparent);}}@keyframes r9mtrlt{0%{--fai-flair-color-2:var(--fai-colorBrandFlair3Transparent);}33%{--fai-flair-color-2:var(--fai-colorHCFlair2);}83%{--fai-flair-color-2:var(--fai-colorHCFlair2);}100%{--fai-flair-color-2:var(--fai-colorBrandFlair3Transparent);}}@keyframes rkmtvhk{0%{--fai-flair-color-3:var(--fai-colorBrandFlair3Transparent);}33%{--fai-flair-color-3:var(--fai-colorHCFlair3);}83%{--fai-flair-color-3:var(--fai-colorHCFlair3);}100%{--fai-flair-color-3:var(--fai-colorBrandFlair3Transparent);}}}", "@media (forced-colors: active){.rpvaigb{forced-color-adjust:none;background-color:Canvas;color:CanvasText;animation-duration:2000ms,1200ms,1200ms,1200ms;animation-delay:0ms,0ms,200ms,400ms;animation-timing-function:linear,linear,linear,linear;animation-fill-mode:forwards,forwards,forwards,forwards;animation-name:rcttjya,r1c3vx44,r9mtrlt,rkmtvhk;}}"]
});
const useHoudiniFlair = ({
  baseUrl = DEFAULT_BASE_URL,
  fileName = DEFAULT_FILE_URL
} = {}) => {
  React.useEffect(() => {
    const path = `${baseUrl}${fileName}`;
    if (!initializedModules[path]) {
      addModule(baseUrl, fileName).then(() => {
        initializedModules[path] = true;
      }).catch(err => {
        initializedModules[path] = false;
      });
    }
  }, [baseUrl, fileName]);
  const playClassName = useFlairClassName();
  const styles = useHoudiniStyles();
  const targetRef = React.useRef(null);
  const styleMap = {
    rest: '',
    play: playClassName
  };
  const [state, setState] = React.useState('rest');
  const play = () => {
    if (state === 'rest' && targetRef.current) {
      var _targetRef_current, _targetRef_current1, _targetRef_current2;
      setState('play');
      let animCount = 0;
      const onAnimationStart = () => {
        animCount++;
      };
      const onAnimationEnd = () => {
        animCount--;
        if (animCount <= 0) {
          var _targetRef_current, _targetRef_current1, _targetRef_current2;
          setState('rest');
          (_targetRef_current = targetRef.current) === null || _targetRef_current === undefined ? undefined : _targetRef_current.removeEventListener('animationstart', onAnimationStart);
          (_targetRef_current1 = targetRef.current) === null || _targetRef_current1 === undefined ? undefined : _targetRef_current1.removeEventListener('animationend', onAnimationEnd);
          (_targetRef_current2 = targetRef.current) === null || _targetRef_current2 === undefined ? undefined : _targetRef_current2.removeEventListener('animationcancel', onAnimationCancel);
        }
      };
      const onAnimationCancel = () => {
        var _targetRef_current, _targetRef_current1, _targetRef_current2;
        setState('rest');
        (_targetRef_current = targetRef.current) === null || _targetRef_current === undefined ? undefined : _targetRef_current.removeEventListener('animationstart', onAnimationStart);
        (_targetRef_current1 = targetRef.current) === null || _targetRef_current1 === undefined ? undefined : _targetRef_current1.removeEventListener('animationend', onAnimationEnd);
        (_targetRef_current2 = targetRef.current) === null || _targetRef_current2 === undefined ? undefined : _targetRef_current2.removeEventListener('animationcancel', onAnimationCancel);
      };
      (_targetRef_current = targetRef.current) === null || _targetRef_current === undefined ? undefined : _targetRef_current.addEventListener('animationstart', onAnimationStart);
      (_targetRef_current1 = targetRef.current) === null || _targetRef_current1 === undefined ? undefined : _targetRef_current1.addEventListener('animationend', onAnimationEnd);
      (_targetRef_current2 = targetRef.current) === null || _targetRef_current2 === undefined ? undefined : _targetRef_current2.addEventListener('animationcancel', onAnimationCancel);
    }
  };
  return {
    className: mergeClasses(styles.base, styleMap[state], state),
    play,
    targetRef
  };
};

const useFlairStyles = __styles({
  base: {
    Em4edj: "f13vsbc6",
    Bjfw52h: "fam6ru7",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1kijzfu",
    Bcmaq0h: "feli345"
  }
}, {
  d: [".f13vsbc6{--fai-flair-stroke-width:var(--strokeWidthThick);}", ".fam6ru7{--fai-flair-background-image:none;}", [".f1kijzfu{border-radius:var(--borderRadiusXLarge);}", {
    p: -1
  }], ".feli345{background-image:var(--fai-flair-background-image);}"]
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop$2 = () => {};
const useFallbackFlair = () => {
  const styles = useFlairStyles();
  const stateRef = React.useRef('rest');
  const className = React.useCallback(() => {
    return mergeClasses(styles.base, 'fallback-flair', stateRef.current);
  }, [styles.base]);
  const targetRef = React.useCallback(node => {
    const props = {
      className: className(),
      targetRef
    };
    if (node) {
      const {
        play
      } = flair(node);
      const onComplete = () => {
        stateRef.current = 'rest';
        setFlairState({
          ...props,
          className: className()
        });
      };
      props.play = () => {
        if (stateRef.current === 'rest') {
          stateRef.current = 'play';
          setFlairState({
            ...props,
            className: className()
          });
          play(onComplete, () => true);
        }
      };
    } else {
      props.style = {};
      props.play = noop$2;
    }
    setFlairState({
      ...props,
      className: className()
    });
  }, [className]);
  const [flairState, setFlairState] = React.useState({
    className: className(),
    play: noop$2,
    targetRef
  });
  return flairState;
};

const useFlair = hasHoudini() ? useHoudiniFlair : useFallbackFlair;

/**
 * Create the state required to render OutputCard.
 *
 * The returned state can be modified with hooks such as useOutputCardStyles_unstable,
 * before being passed to renderOutputCard_unstable.
 *
 * @param props - props from this instance of OutputCard
 * @param ref - reference to root HTMLElement of OutputCard
 */
const useOutputCard_unstable = (props, ref) => {
  const {
    play,
    targetRef,
    ...flairProps
  } = useFlair();
  var _props_isLoading;
  const state = {
    isLoading: (_props_isLoading = props.isLoading) !== null && _props_isLoading !== undefined ? _props_isLoading : false,
    mode: useCopilotMode(props.mode),
    components: {
      root: 'div',
      progress: ProgressBar
    },
    root: always({
      ...getIntrinsicElementProps('div', {
        ref: useMergedRefs(targetRef, ref),
        ...props
      }),
      ...flairProps,
      className: mergeClasses(flairProps.className, props.className),
      style: {
        ...flairProps.style,
        ...props.style
      }
    }, {
      elementType: 'div'
    }),
    progress: optional(props.progress, {
      defaultProps: {
        shape: 'square',
        thickness: 'large',
        'aria-label': 'Loading'
      },
      elementType: ProgressBar,
      renderByDefault: false
    })
  };
  const previousIsLoading = usePrevious(state.isLoading);
  React.useEffect(() => {
    if (!state.isLoading && previousIsLoading) {
      play();
    }
  }, [state.isLoading, previousIsLoading, play]);
  return state;
};

/**
 * Render the final JSX of OutputCard
 */
const renderOutputCard_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.root.children, " ", state.progress && /*#__PURE__*/jsx(state.progress, {})]
  });
};

// eslint-disable
const outputCardClassNames = {
  root: 'fai-OutputCard',
  progress: 'fai-OutputCard__progress'
};
/**
 * Styles for the root slot
 */
const useStyles$t = __styles({
  root: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1kijzfu",
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    qhf8xq: "f10pi13n",
    Bj3rh1h: "f11zp4z2",
    De3pzq: "fxugw4r",
    B7ck84d: "f1ewtqcl",
    E5pizo: "f1whvlc6",
    Bw0xxkn: 0,
    oeaueh: 0,
    Bpd4iqm: 0,
    Befb4lg: "f1iepc6i"
  },
  sidecar: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fdgaxb"
  },
  canvas: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f6lrzt8"
  },
  progressRoot: {
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    Bpg54ce: "f1a3p1vp",
    a9b677: "f14z66ap",
    qhf8xq: "f1euv43f",
    B5kzvoi: "f1yab3r1",
    oyh7mz: ["f1vgc2s3", "f1e31b4d"],
    j35jbq: ["f1e31b4d", "f1vgc2s3"],
    Bqenvij: "fniina8",
    Beyfa6y: ["frrelxk", "f1ldthgs"],
    Bbmb7ep: ["f1ldthgs", "frrelxk"],
    Bgl5zvf: "f5aapo6",
    Bn62ygk: 0,
    Cwk7ip: 0,
    B3o57yi: 0,
    Bmy1vo4: 0,
    Bkqvd7p: 0,
    Bi2q7bf: "fxqei6h"
  },
  progressIsLoading: {
    Bqenvij: "f1x82gua"
  },
  bar: {
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "fokr779"
  },
  regularProgressBarStyles: {
    Bqenvij: "f1l02sjl",
    Bcmaq0h: "fx7worf"
  },
  indeterminateProgressBarStyles: {
    vin17d: "f1a27w2r",
    Bqenvij: "f1l02sjl",
    De3pzq: "f1c21dwh",
    Bcmaq0h: "f1hxqsn5",
    jpy9cc: "f3z2g5w",
    Bqo2lbl: "fz5izi4",
    I82g5a: "f1uj6jbf",
    B6plc1d: "fv40pdu"
  },
  indeterminateBarNotIsLoading: {
    Bh6m77q: "f1yav1uu"
  }
}, {
  d: [[".f1kijzfu{border-radius:var(--borderRadiusXLarge);}", {
    p: -1
  }], ".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", ".f10pi13n{position:relative;}", ".f11zp4z2{z-index:0;}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f1ewtqcl{box-sizing:border-box;}", ".f1whvlc6{box-shadow:var(--shadow4);}", [".f1iepc6i{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }], [".fdgaxb{padding:var(--spacingVerticalM) var(--spacingHorizontalL);}", {
    p: -1
  }], [".f6lrzt8{padding:var(--spacingVerticalL) var(--spacingVerticalXL);}", {
    p: -1
  }], [".f1a3p1vp{overflow:hidden;}", {
    p: -1
  }], ".f14z66ap{width:auto;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".f1euv43f{position:absolute;}", ".f1yab3r1{bottom:0;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", ".fniina8{height:0;}", ".frrelxk{border-bottom-left-radius:var(--borderRadiusLarge);}", ".f1ldthgs{border-bottom-right-radius:var(--borderRadiusLarge);}", ".f5aapo6{clip-path:polygon(0px 4px, 100% 4px, 100% 8px, 0px 8px);}", [".fxqei6h{transition:height var(--durationSlow) var(--curveDecelerateMin);}", {
    p: -1
  }], ".f1x82gua{height:8px;}", [".fokr779{border-radius:0;}", {
    p: -1
  }], ".f1l02sjl{height:100%;}", ".fx7worf{background-image:linear-gradient(90deg, var(--fai-colorBrandFlair1) 35%, var(--fai-colorBrandFlair2) 70%, var(--fai-colorBrandFlair3) 92%);}", ".f1a27w2r{animation-duration:3s;}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1hxqsn5{background-image:linear-gradient(90deg, rgba(0,0,0,0) 0%, var(--fai-colorBrandFlair1) 35%, var(--fai-colorBrandFlair2) 70%, var(--fai-colorBrandFlair3) 92%,  rgba(0,0,0,0));}", ".f1yav1uu{animation-play-state:paused;}"],
  m: [["@media screen and (prefers-reduced-motion: reduce){.f3z2g5w{max-width:100%;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.fz5izi4{animation-iteration-count:infinite;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f1uj6jbf{animation-name:ftc26vs;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.fv40pdu{animation-duration:3s;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }]],
  k: ["@keyframes ftc26vs{0%{opacity:.2;}50%{opacity:1;}100%{opacity:.2;}}"]
});
const useOutputCardStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$t();
  state.root.className = mergeClasses(outputCardClassNames.root, styles.root, styles[state.mode], state.root.className);
  if (state.progress) {
    state.progress.className = mergeClasses(outputCardClassNames.progress, styles.progressRoot, state.isLoading && styles.progressIsLoading, state.progress.className);
    const bar = optional(state.progress.bar, {
      elementType: 'div',
      renderByDefault: true
    });
    if (bar) {
      if (state.progress.value === undefined) {
        bar.className = mergeClasses(styles.bar, styles.indeterminateProgressBarStyles, !state.isLoading && styles.indeterminateBarNotIsLoading, bar.className);
      } else {
        bar.className = mergeClasses(styles.regularProgressBarStyles, styles.bar, bar.className);
      }
      state.progress.bar = bar;
    }
  }
  return state;
};

// OutputCard component - TODO: add more docs
const OutputCard = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useOutputCard_unstable(props, ref);
  useOutputCardStyles_unstable(state);
  useCustomStyleHook('useOutputCardStyles')(state);
  return renderOutputCard_unstable(state);
});
OutputCard.displayName = 'OutputCard';

const useMessageAttributes$1 = ({
  id,
  defaultFocused
}) => {
  // Initialize groupper
  useFocusableGroup();
  const accessibleProps = {
    role: 'article',
    tabIndex: 0,
    id,
    'aria-labelledby': `${id}`
  };
  const tabsterProps = useTabsterAttributes({
    groupper: {
      tabbability: 2 /*limitedTrapFocus*/
    },
    focusable: {
      isDefault: defaultFocused
    }
  });
  return {
    ...accessibleProps,
    ...tabsterProps
  };
};

/**
 * Create the state required to render CopilotMessage.
 *
 * The returned state can be modified with hooks such as useCopilotMessageStyles_unstable,
 * before being passed to renderCopilotMessage_unstable.
 *
 * @deprecated CopilotMessage use CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 *
 * @param props - props from this instance of CopilotMessage
 * @param ref - reference to root HTMLElement of CopilotMessage
 */
const useCopilotMessage_unstable = (props, ref) => {
  const {
    announcement,
    accessibleHeading,
    isLoading
  } = props;
  const cardState = useOutputCard_unstable(props, ref);
  const id = useId('copilot-message-', props.id);
  const rootRef = React.useRef(null);
  const {
    announce
  } = useAnnounce$1();
  // timeout for announcing "loading" at 10s intervals
  const [setLoadingAnnounceTimeout, clearLoadingAnnounceTimeout] = useTimeout();
  // track whether the message has loading; this should only change once from false -> true
  const hasLoaded = React.useRef(!isLoading);
  // if the message is loading when first mounted, kick off loading announcements
  const isFirstMount = useFirstMount();
  if (isFirstMount && !announcement && isLoading) {
    const announceLoading = () => {
      // check for the announcement when this function runs as well
      if (!announcement) {
        announce('loading...', {
          batchId: id
        });
      }
      setLoadingAnnounceTimeout(() => {
        announceLoading();
      }, 10000);
    };
    announceLoading();
  }
  // fire tabster event on first mount to focus new message when it appears
  React.useEffect(() => {
    if (isFirstMount) {
      var _rootRef_current;
      const tabsterMoverEvent = new CustomEvent('tabster:mover:memorized-element', {
        bubbles: true,
        detail: {
          memorizedElement: rootRef.current
        }
      });
      (_rootRef_current = rootRef.current) === null || _rootRef_current === undefined ? undefined : _rootRef_current.dispatchEvent(tabsterMoverEvent);
    }
  }, [isFirstMount]);
  // announce the announcement message every time the prop changes
  React.useEffect(() => {
    if (announcement) {
      clearLoadingAnnounceTimeout();
      announce(announcement, {
        batchId: id
      });
    }
  }, [announce, announcement, clearLoadingAnnounceTimeout, id]);
  // automatically announce when loading is complete, if announcement is not defined
  React.useEffect(() => {
    if (!hasLoaded.current && !isLoading) {
      // flag message as having finished loading, and stop loading announcements
      hasLoaded.current = true;
      clearLoadingAnnounceTimeout();
      if (announcement === undefined) {
        var _rootRef_current;
        const messageText = (_rootRef_current = rootRef.current) === null || _rootRef_current === undefined ? undefined : _rootRef_current.textContent;
        // clear any queued batched announcements and announce the full message
        announce('', {
          batchId: id
        });
        messageText && announce(messageText);
      }
    }
  }, [announce, announcement, clearLoadingAnnounceTimeout, id, isLoading]);
  const accessibleProps = {
    id,
    'aria-labelledby': `${id}`
  };
  return {
    ...cardState,
    components: {
      ...cardState.components,
      accessibleHeading: 'h6'
    },
    root: {
      ...cardState.root,
      ...useMessageAttributes$1({
        id,
        defaultFocused: props.defaultFocused
      }),
      ...accessibleProps,
      ref: useMergedRefs(rootRef, cardState.root.ref)
    },
    accessibleHeading: optional(accessibleHeading, {
      defaultProps: {
        children: 'Copilot said: '
      },
      elementType: 'h6',
      renderByDefault: true
    })
  };
};

/**
 * Render the final JSX of CopilotMessage
 * @deprecated CopilotMessage use CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 */
const renderCopilotMessage_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.accessibleHeading && /*#__PURE__*/jsx(state.accessibleHeading, {}), state.root.children, state.progress && /*#__PURE__*/jsx(state.progress, {})]
  });
};

const copilotMessageClassNames = {
  root: 'fai-CopilotMessage',
  accessibleHeading: 'fai-CopilotMessage__accessibleHeading',
  progress: 'fai-CopilotMessage__progress'
};
const useStyles$s = __styles({
  root: {
    Brovlpu: "ftqa4ok",
    B486eqv: "f2hkw1w",
    B8q5s1w: "f8hki3x",
    Bci5o5g: ["f1d2448m", "ffh67wi"],
    n8qw10: "f1bjia2o",
    Bdrgwmp: ["ffh67wi", "f1d2448m"],
    Bqhya38: "f1j6vpng",
    Bwxa6fj: ["f1pniga2", "f1ffjurs"],
    Bdhvstf: "f987i1v",
    B7zbvrb: ["f1ffjurs", "f1pniga2"],
    Bm4h7ae: "f15bsgw9",
    B7ys5i9: "f14e48fq",
    Busjfv9: "f18yb2kv",
    Bhk32uz: "fd6o370",
    f6g5ot: 0,
    Boxcth7: 0,
    Bhdgwq3: 0,
    hgwjuy: 0,
    Bshpdp8: 0,
    Bsom6fd: 0,
    Blkhhs4: 0,
    Bonggc9: 0,
    Ddfuxk: 0,
    i03rao: 0,
    kclons: 0,
    clg4pj: 0,
    Bpqj9nj: 0,
    B6dhp37: 0,
    Bf4ptjt: 0,
    Bqtpl0w: 0,
    i4rwgc: "ffwy5si",
    Dah5zi: 0,
    B1tsrr9: 0,
    qqdqy8: 0,
    Bkh64rk: 0,
    e3fwne: "f3znvyf",
    J0r882: "f57olzd",
    Bule8hv: ["f4stah7", "fs1por5"],
    Bjwuhne: "f480a47",
    Ghsupd: ["fs1por5", "f4stah7"]
  }
}, {
  f: [".ftqa4ok:focus{outline-style:none;}"],
  i: [".f2hkw1w:focus-visible{outline-style:none;}"],
  d: [".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}", ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}", ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}", ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}", ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}", ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}", ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}", ".fd6o370[data-fui-focus-visible]::after{z-index:1;}", [".ffwy5si[data-fui-focus-visible]::after{border:2px solid var(--colorStrokeFocus2);}", {
    p: -2
  }], [".f3znvyf[data-fui-focus-visible]::after{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}", ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}", ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}", ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}"],
  m: [["@media (forced-colors: active){.f1j6vpng[data-fui-focus-visible]::after{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ffjurs[data-fui-focus-visible]::after{border-left-color:Highlight;}.f1pniga2[data-fui-focus-visible]::after{border-right-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f987i1v[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }]]
});
/**
 * Styles for the hidden heading slot
 */
const useHeadingStyles$2 = __resetStyles("rhgro0h", null, [".rhgro0h{clip:rect(0px, 0px, 0px, 0px);height:1px;margin:-1px;width:1px;position:absolute;overflow:hidden;white-space:nowrap;}"]);
/**
 * Styles for CopilotMessage
 * @deprecated CopilotMessage use CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 */
const useCopilotMessageStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$s();
  const headingStyles = useHeadingStyles$2();
  state = useOutputCardStyles_unstable(state);
  state.root.className = mergeClasses(copilotMessageClassNames.root, styles.root, state.root.className);
  state.progress && (state.progress.className = mergeClasses(copilotMessageClassNames.progress, state.progress.className));
  if (state.accessibleHeading) {
    state.accessibleHeading.className = mergeClasses(copilotMessageClassNames.accessibleHeading, headingStyles, state.accessibleHeading.className);
  }
  return state;
};

/**
 * @deprecated CopilotMessage use CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 * */
const CopilotMessage = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useCopilotMessage_unstable(props, ref);
  useCopilotMessageStyles_unstable(state);
  return renderCopilotMessage_unstable(state);
});
CopilotMessage.displayName = 'CopilotMessage';

/**
 * Create the state required to render UserMessage.
 *
 * The returned state can be modified with hooks such as useUserMessageStyles_unstable,
 * before being passed to renderUserMessage_unstable.
 *
 * @deprecated UserMessage use UserMessageV2 instead
 * Deprecated on 07/30/2024
 *
 * @param props - props from this instance of UserMessage
 * @param ref - reference to root HTMLElement of UserMessage
 */
const useUserMessage_unstable$1 = (props, ref) => {
  const {
    announcement,
    accessibleHeading
  } = props;
  const messageId = useId('user-message-', props.id);
  const rootRef = React.useRef(null);
  const {
    announce
  } = useAnnounce$1();
  const {
    id,
    ...copilotChatAttributes
  } = useMessageAttributes$1({
    id: messageId
  });
  React.useEffect(() => {
    announcement && announce(announcement, {
      batchId: id
    });
  }, [announce, announcement, id]);
  return {
    components: {
      root: 'div',
      accessibleHeading: 'h5'
    },
    root: always(getIntrinsicElementProps('div', {
      ref: useMergedRefs(rootRef, ref),
      id,
      ...copilotChatAttributes,
      ...props
    }), {
      elementType: 'div'
    }),
    accessibleHeading: optional(accessibleHeading, {
      defaultProps: {
        children: 'You said: '
      },
      elementType: 'h5',
      renderByDefault: true
    })
  };
};

/**
 * Render the final JSX of UserMessage
 * @deprecated UserMessage use UserMessageV2 instead
 * Deprecated on 07/30/2024
 */
const renderUserMessage_unstable$1 = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.accessibleHeading && /*#__PURE__*/jsx(state.accessibleHeading, {}), state.root.children]
  });
};

const userMessageClassNames$1 = {
  root: 'fai-UserMessage',
  accessibleHeading: 'fai-UserMessage__accessibleHeading'
};
/**
 * Styles for the root slot
 */
const useStyles$r = __styles({
  root: {
    qb2dma: "f1locze1",
    qhf8xq: "f10pi13n",
    Brovlpu: "ftqa4ok",
    B486eqv: "f2hkw1w",
    B8q5s1w: "f8hki3x",
    Bci5o5g: ["f1d2448m", "ffh67wi"],
    n8qw10: "f1bjia2o",
    Bdrgwmp: ["ffh67wi", "f1d2448m"],
    Bqhya38: "f1j6vpng",
    Bwxa6fj: ["f1pniga2", "f1ffjurs"],
    Bdhvstf: "f987i1v",
    B7zbvrb: ["f1ffjurs", "f1pniga2"],
    Bm4h7ae: "f15bsgw9",
    B7ys5i9: "f14e48fq",
    Busjfv9: "f18yb2kv",
    Bhk32uz: "fd6o370",
    f6g5ot: 0,
    Boxcth7: 0,
    Bhdgwq3: 0,
    hgwjuy: 0,
    Bshpdp8: 0,
    Bsom6fd: 0,
    Blkhhs4: 0,
    Bonggc9: 0,
    Ddfuxk: 0,
    i03rao: 0,
    kclons: 0,
    clg4pj: 0,
    Bpqj9nj: 0,
    B6dhp37: 0,
    Bf4ptjt: 0,
    Bqtpl0w: 0,
    i4rwgc: "ffwy5si",
    Dah5zi: 0,
    B1tsrr9: 0,
    qqdqy8: 0,
    Bkh64rk: 0,
    e3fwne: "f3znvyf",
    J0r882: "f57olzd",
    Bule8hv: ["f4stah7", "fs1por5"],
    Bjwuhne: "f480a47",
    Ghsupd: ["fs1por5", "f4stah7"],
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1ye8poq",
    De3pzq: "f16xkysk",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1kijzfu",
    Bw0xxkn: 0,
    oeaueh: 0,
    Bpd4iqm: 0,
    Befb4lg: "f1iepc6i"
  }
}, {
  d: [".f1locze1{align-self:end;}", ".f10pi13n{position:relative;}", ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}", ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}", ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}", ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}", ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}", ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}", ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}", ".fd6o370[data-fui-focus-visible]::after{z-index:1;}", [".ffwy5si[data-fui-focus-visible]::after{border:2px solid var(--colorStrokeFocus2);}", {
    p: -2
  }], [".f3znvyf[data-fui-focus-visible]::after{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}", ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}", ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}", ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}", [".f1ye8poq{padding:var(--spacingVerticalS) var(--spacingHorizontalL);}", {
    p: -1
  }], ".f16xkysk{background-color:var(--colorBrandBackground2);}", [".f1kijzfu{border-radius:var(--borderRadiusXLarge);}", {
    p: -1
  }], [".f1iepc6i{outline:1px solid var(--colorTransparentStroke);}", {
    p: -1
  }]],
  f: [".ftqa4ok:focus{outline-style:none;}"],
  i: [".f2hkw1w:focus-visible{outline-style:none;}"],
  m: [["@media (forced-colors: active){.f1j6vpng[data-fui-focus-visible]::after{border-top-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ffjurs[data-fui-focus-visible]::after{border-left-color:Highlight;}.f1pniga2[data-fui-focus-visible]::after{border-right-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f987i1v[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}", {
    m: "(forced-colors: active)"
  }]]
});
/**
 * Styles for the hidden heading slot
 */
const useHeadingStyles$1 = __resetStyles("rhgro0h", null, [".rhgro0h{clip:rect(0px, 0px, 0px, 0px);height:1px;margin:-1px;width:1px;position:absolute;overflow:hidden;white-space:nowrap;}"]);
/**
 * Apply styling to the UserMessage slots based on the state
 * @deprecated UserMessage use UserMessageV2 instead
 * Deprecated on 07/30/2024
 */
const useUserMessageStyles_unstable$1 = state => {
  'use no memo';

  const styles = useStyles$r();
  const headingStyles = useHeadingStyles$1();
  state.root.className = mergeClasses(userMessageClassNames$1.root, styles.root, state.root.className);
  if (state.accessibleHeading) {
    state.accessibleHeading.className = mergeClasses(userMessageClassNames$1.accessibleHeading, headingStyles, state.accessibleHeading.className);
  }
  return state;
};

/**
 * @deprecated UserMessage use UserMessageV2 instead
 * Deprecated on 07/30/2024
 */
const UserMessage$1 = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useUserMessage_unstable$1(props, ref);
  useUserMessageStyles_unstable$1(state);
  return renderUserMessage_unstable$1(state);
});
UserMessage$1.displayName = 'UserMessage';

const aiGeneratedDisclaimerClassNames = {
  root: 'fai-AiGeneratedDisclaimer'
};
const useStyles$q = __styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fcpl73t",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fy44vh6",
    mc9l5x: "f14t3ns0",
    sj55zd: "f11d4kpn",
    De3pzq: "f3vzo32"
  },
  canvas: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fza2tcr"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".fy44vh6{padding:calc(var(--spacingVerticalXXS) / 2) var(--spacingHorizontalXS) calc(var(--spacingVerticalXXS) / 2) var(--spacingHorizontalXS);}", {
    p: -1
  }], ".f14t3ns0{display:inline-block;}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f3vzo32{background-color:var(--colorNeutralBackground5);}", [".fza2tcr{padding:calc(var(--spacingVerticalSNudge) / 2) var(--spacingHorizontalSNudge) calc(var(--spacingVerticalSNudge) / 2)var(--spacingHorizontalSNudge);}", {
    p: -1
  }]]
});
const useAiGeneratedDisclaimerStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$q();
  state.root.className = mergeClasses(aiGeneratedDisclaimerClassNames.root, styles.root, state.mode === 'canvas' && styles.canvas, state.root.className);
  return state;
};

const AiGeneratedDisclaimer = /*#__PURE__*/React.forwardRef((props, ref) => {
  'use no memo';

  const state = useText_unstable({
    as: 'span',
    ...props
  }, ref);
  state.mode = useCopilotMode(props.mode);
  useAiGeneratedDisclaimerStyles_unstable(state);
  return renderText_unstable(state);
});
AiGeneratedDisclaimer.displayName = 'AiGeneratedDisclaimer';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render CopilotMessageFooter.
 *
 * The returned state can be modified with hooks such as useCopilotMessageFooterStyles_unstable,
 * before being passed to renderCopilotMessageFooter_unstable.
 *
 * @deprecated CopilotMessageFooter use the footnote slot in CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 *
 * @param props - props from this instance of CopilotMessageFooter
 * @param ref - reference to root HTMLElement of CopilotMessageFooter
 */
const useCopilotMessageFooter_unstable = (props, ref) => {
  const mode = useCopilotMode(props.mode);
  // We only need the divider in canvas mode and when the slots we need to differentiate are present
  const shouldShowDivider = mode === 'canvas' && !!props.responseCount && (!!props.feedback || !!props.aiDisclaimer);
  return {
    mode,
    components: {
      root: 'div',
      aiDisclaimer: 'span',
      content: 'div',
      divider: Divider,
      feedback: 'span',
      referenceList: 'div',
      referenceListToggle: 'span',
      responseCount: 'span',
      sensitivity: 'span',
      sensitivityDisclaimerContainer: 'span'
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      ...props
    }), {
      elementType: 'div'
    }),
    content: optional(props.content, {
      elementType: 'div',
      defaultProps: {
        children: props.children
      },
      renderByDefault: !!props.children
    }),
    responseCount: optional(props.responseCount, {
      elementType: 'span'
    }),
    feedback: optional(props.feedback, {
      elementType: 'span'
    }),
    aiDisclaimer: optional(props.aiDisclaimer, {
      elementType: 'span'
    }),
    referenceList: optional(props.referenceList, {
      elementType: 'div'
    }),
    referenceListToggle: optional(props.referenceListToggle, {
      elementType: 'span'
    }),
    divider: optional(shouldShowDivider ? props.divider : undefined, {
      elementType: Divider,
      defaultProps: {
        vertical: true
      },
      renderByDefault: shouldShowDivider
    }),
    sensitivity: optional(props.sensitivity, {
      elementType: 'span'
    }),
    sensitivityDisclaimerContainer: optional(props.sensitivityDisclaimerContainer, {
      elementType: 'span',
      renderByDefault: !!props.sensitivity || !!props.aiDisclaimer
    })
  };
};

/**
 * Render the final JSX of CopilotMessageFooter
 * @deprecated CopilotMessageFooter use the footnote slot in CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 */
const renderCopilotMessageFooter_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.content && /*#__PURE__*/jsx(state.content, {}), state.mode === 'sidecar' ? /*#__PURE__*/jsxs(Fragment, {
      children: [state.sensitivityDisclaimerContainer && /*#__PURE__*/jsxs(state.sensitivityDisclaimerContainer, {
        children: [state.sensitivity && /*#__PURE__*/jsx(state.sensitivity, {}), state.aiDisclaimer && /*#__PURE__*/jsx(state.aiDisclaimer, {})]
      }), state.feedback && /*#__PURE__*/jsx(state.feedback, {}), state.referenceListToggle && /*#__PURE__*/jsx(state.referenceListToggle, {}), state.responseCount && /*#__PURE__*/jsx(state.responseCount, {}), state.referenceList && /*#__PURE__*/jsx(state.referenceList, {})]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [state.referenceListToggle && /*#__PURE__*/jsx(state.referenceListToggle, {}), state.responseCount && /*#__PURE__*/jsx(state.responseCount, {}), state.divider && /*#__PURE__*/jsx(state.divider, {}), state.sensitivityDisclaimerContainer && /*#__PURE__*/jsxs(state.sensitivityDisclaimerContainer, {
        children: [state.sensitivity && /*#__PURE__*/jsx(state.sensitivity, {}), state.aiDisclaimer && /*#__PURE__*/jsx(state.aiDisclaimer, {})]
      }), state.feedback && /*#__PURE__*/jsx(state.feedback, {}), state.referenceList && /*#__PURE__*/jsx(state.referenceList, {})]
    })]
  });
};

const copilotMessageFooterClassNames = {
  root: 'fai-CopilotMessageFooter',
  content: 'fai-CopilotMessageFooter__content',
  responseCount: 'fai-CopilotMessageFooter__responseCount',
  feedback: 'fai-CopilotMessageFooter__feedback',
  aiDisclaimer: 'fai-CopilotMessageFooter__aiDisclaimer',
  referenceList: 'fai-CopilotMessageFooter__referenceList',
  referenceListToggle: 'fai-CopilotMessageFooter__referenceListToggle',
  divider: 'fai-CopilotMessageFooter__divider',
  sensitivity: 'fai-CopilotMessageFooter__sensitivity',
  sensitivityDisclaimerContainer: 'fai-CopilotMessageFooter__sensitivityDisclaimerContainer'
};
/**
 * Styles for the root slot
 */
const useStyles$p = __styles({
  root: {
    mc9l5x: "f13qh94s",
    Bt984gj: "f122n59",
    Belr9w4: "f778t4r",
    i8kkvl: "fsnqrgy"
  },
  sidecar: {
    zoa1oz: "f1uzz097",
    Budl1dq: "fjxzuw"
  },
  canvas: {
    zoa1oz: "fro7rzp",
    Budl1dq: "f1c2z91y"
  },
  content: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "fqi5tbq"
  },
  responseCount: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "f17uwb22",
    mc9l5x: "ftuwxu6",
    Brf1p80: "f9c4gz4",
    sshi5w: "f1pha7fy"
  },
  feedback: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "f465pga",
    mc9l5x: "ftuwxu6",
    Brf1p80: "f9c4gz4"
  },
  aiDisclaimer: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62"
  },
  referenceList: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "ff8dls1"
  },
  referenceListToggle: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "fv863o0"
  },
  divider: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "f60jx07",
    sshi5w: "f1dlyyta",
    Bxyxcbc: "f1gb6uef",
    a9b677: "f18ezo4q"
  },
  sensitivity: {
    Bt984gj: "f122n59",
    mc9l5x: "f22iagw"
  },
  sensitivityDisclaimer: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "fdz5vnw",
    Bt984gj: "f122n59",
    mc9l5x: "f22iagw",
    Beiy3e4: "f1063pyq",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "faqewft"
  }
}, {
  d: [".f13qh94s{display:grid;}", ".f122n59{align-items:center;}", ".f778t4r{row-gap:var(--spacingVerticalXS);}", ".fsnqrgy{column-gap:var(--spacingHorizontalS);}", ".f1uzz097{grid-template-areas:\"content                       content                        content\" \"sensitivityDisclaimer         sensitivityDisclaimer          feedback\" \"referenceToggle               responseCount                  responseCount\" \"referenceList                 referenceList                  referenceList\";}", ".fjxzuw{grid-template-columns:auto 1fr;}", ".fro7rzp{grid-template-areas:\"content             content            content             content                       content\" \"referenceToggle     responseCount      divider             sensitivityDisclaimer         feedback\" \"referenceList       referenceList      referenceList       referenceList                 referenceList\";}", ".f1c2z91y{grid-template-columns:1fr;}", [".fqi5tbq{grid-area:content;}", {
    p: -1
  }], [".f17uwb22{grid-area:responseCount;}", {
    p: -1
  }], ".ftuwxu6{display:inline-flex;}", ".f9c4gz4{justify-content:flex-end;}", ".f1pha7fy{min-height:24px;}", [".f465pga{grid-area:feedback;}", {
    p: -1
  }], ".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", [".ff8dls1{grid-area:referenceList;}", {
    p: -1
  }], [".fv863o0{grid-area:referenceToggle;}", {
    p: -1
  }], [".f60jx07{grid-area:divider;}", {
    p: -1
  }], ".f1dlyyta{min-height:var(--lineHeightBase100);}", ".f1gb6uef{max-height:var(--lineHeightBase100);}", ".f18ezo4q{width:var(--spacingHorizontalM);}", [".fdz5vnw{grid-area:sensitivityDisclaimer;}", {
    p: -1
  }], ".f1063pyq{flex-direction:row;}", [".faqewft{gap:var(--spacingHorizontalS);}", {
    p: -1
  }]]
});
/**
 * Apply styling to the CopilotMessageFooter slots based on the state
 * @deprecated CopilotMessageFooter use the footnote slot in CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 */
const useCopilotMessageFooterStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$p();
  state.root.className = mergeClasses(copilotMessageFooterClassNames.root, styles.root, styles[state.mode], state.root.className);
  if (state.content) {
    state.content.className = mergeClasses(copilotMessageFooterClassNames.content, styles.content, state.content.className);
  }
  if (state.responseCount) {
    state.responseCount.className = mergeClasses(copilotMessageFooterClassNames.responseCount, styles.responseCount, state.responseCount.className);
  }
  if (state.feedback) {
    state.feedback.className = mergeClasses(copilotMessageFooterClassNames.feedback, styles.feedback, state.feedback.className);
  }
  if (state.aiDisclaimer) {
    state.aiDisclaimer.className = mergeClasses(copilotMessageFooterClassNames.aiDisclaimer, styles.aiDisclaimer, state.aiDisclaimer.className);
  }
  if (state.referenceList) {
    state.referenceList.className = mergeClasses(copilotMessageFooterClassNames.referenceList, styles.referenceList, state.referenceList.className);
  }
  if (state.referenceListToggle) {
    state.referenceListToggle.className = mergeClasses(copilotMessageFooterClassNames.referenceListToggle, styles.referenceListToggle, state.referenceListToggle.className);
  }
  if (state.divider) {
    state.divider.className = mergeClasses(copilotMessageFooterClassNames.divider, styles.divider, state.divider.className);
  }
  if (state.sensitivity) {
    state.sensitivity.className = mergeClasses(copilotMessageFooterClassNames.sensitivity, styles.sensitivity, state.sensitivity.className);
  }
  if (state.sensitivityDisclaimerContainer) {
    state.sensitivityDisclaimerContainer.className = mergeClasses(copilotMessageFooterClassNames.sensitivityDisclaimerContainer, styles.sensitivityDisclaimer, state.sensitivityDisclaimerContainer.className);
  }
  return state;
};

/**
 * @deprecated CopilotMessageFooter use the footnote slot in CopilotMessageV2 instead
 * Deprecated on 07/30/2024
 * */
const CopilotMessageFooter = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useCopilotMessageFooter_unstable(props, ref);
  useCopilotMessageFooterStyles_unstable(state);
  return renderCopilotMessageFooter_unstable(state);
});
CopilotMessageFooter.displayName = 'CopilotMessageFooter';

const useMessageAttributes = ({
  contentId,
  headingId,
  defaultFocused
}) => {
  // Initialize groupper
  useFocusableGroup();
  const accessibleProps = {
    role: 'article',
    tabIndex: 0,
    'aria-labelledby': `${headingId} ${contentId}`
  };
  const tabsterProps = useTabsterAttributes({
    groupper: {
      tabbability: 2 /*limitedTrapFocus*/
    },
    focusable: {
      isDefault: defaultFocused
    }
  });
  return {
    ...accessibleProps,
    ...tabsterProps
  };
};

function useUserMessagePositioning(props) {
  // Set a default set of fallback positions to try if the dropdown does not fit on screen
  const fallbackPositions = ['below', 'after', 'after-top', 'before', 'before-top'];
  const popperOptions = {
    position: 'above',
    align: 'end',
    offset: {
      crossAxis: 0,
      mainAxis: 2
    },
    fallbackPositions,
    autoSize: true
  };
  const {
    targetRef,
    containerRef
  } = usePositioning(popperOptions);
  return [containerRef, targetRef];
}

/**
 * @internal
 * @returns  actionBar slot with desired behaviour and props
 */
function useActionBarSlot(actionBarSlotFromProp, options) {
  const {
    popoverRef,
    isFocused,
    isHovered
  } = options;
  const actionBarId = useId('fluentai-actionbar', isResolvedShorthand(actionBarSlotFromProp) ? actionBarSlotFromProp.id : undefined);
  const actionBarSlot = optional(actionBarSlotFromProp, {
    elementType: Toolbar,
    defaultProps: {
      id: actionBarId,
      size: 'small'
    }
  });
  /**
  * Clicking on the actionBar should never blur the trigger
  * in a UserMessage
  */
  const actionBarRef = useMergedRefs(actionBarSlot === null || actionBarSlot === undefined ? undefined : actionBarSlot.ref, popoverRef);
  if (actionBarSlot) {
    actionBarSlot.ref = actionBarRef;
  }
  return isFocused || isHovered ? actionBarSlot : undefined;
}

/**
 * Create the state required to render UserMessage.
 *
 * The returned state can be modified with hooks such as useUserMessageStyles_unstable,
 * before being passed to renderUserMessage_unstable.
 *
 * @param props - props from this instance of UserMessage
 * @param ref - reference to root HTMLElement of UserMessage
 */
const useUserMessage_unstable = (props, ref) => {
  const {
    announcement,
    accessibleHeading,
    actionBarAccessibleButton,
    actionBar,
    message,
    timestamp
  } = props;
  const messageId = useId('user-message-', props.id);
  const headingId = `${messageId}-title`;
  const [userMessagePopupRef, userMessageTargetRef] = useUserMessagePositioning();
  const {
    announce
  } = useAnnounce$1();
  const {
    ...copilotChatAttributes
  } = useMessageAttributes({
    contentId: messageId,
    headingId
  });
  const [isHovered, setIsHovered] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);
  const rootRef = React.useRef(null);
  React.useEffect(() => {
    announcement && announce(announcement, {
      batchId: messageId
    });
  }, [announce, announcement, messageId]);
  const state = {
    components: {
      root: 'div',
      accessibleHeading: 'h5',
      timestamp: 'span',
      actionBarAccessibleButton: 'button',
      actionBar: Toolbar,
      message: 'div'
    },
    root: always(getIntrinsicElementProps('div', {
      ref: useMergedRefs(rootRef, ref),
      ...copilotChatAttributes,
      ...props
    }), {
      elementType: 'div'
    }),
    accessibleHeading: optional(accessibleHeading, {
      defaultProps: {
        children: 'You said: ',
        id: headingId
      },
      elementType: 'h5',
      renderByDefault: true
    }),
    timestamp: optional(timestamp, {
      elementType: 'span'
    }),
    actionBarAccessibleButton: actionBar ? optional(actionBarAccessibleButton, {
      defaultProps: {
        'aria-label': 'More actions',
        tabIndex: -1
      },
      ...copilotChatAttributes,
      elementType: 'button',
      renderByDefault: true
    }) : undefined,
    actionBar: useActionBarSlot(actionBar, {
      popoverRef: userMessagePopupRef,
      triggerRef: userMessageTargetRef,
      isFocused,
      isHovered
    }),
    message: always(message, {
      defaultProps: {
        children: props.children,
        id: messageId,
        ref: userMessageTargetRef
      },
      elementType: 'div'
    })
  };
  const onBlur = e => {
    const nextFocusedElement = e.relatedTarget;
    if (nextFocusedElement !== rootRef.current && !elementContains(rootRef.current, nextFocusedElement)) {
      setIsFocused(false);
    }
  };
  const onFocus = e => {
    setIsFocused(true);
  };
  const onMouseEnter = e => {
    setIsHovered(true);
  };
  const onMouseLeave = e => {
    setIsHovered(false);
  };
  state.root.onBlur = useEventCallback(mergeCallbacks(onBlur, props.onBlur));
  state.root.onFocus = useEventCallback(mergeCallbacks(onFocus, props.onFocus));
  state.root.onMouseEnter = useEventCallback(mergeCallbacks(onMouseEnter, props.onMouseEnter));
  state.root.onMouseLeave = useEventCallback(mergeCallbacks(onMouseLeave, props.onMouseLeave));
  return state;
};

/**
 * Render the final JSX of UserMessage
 */
const renderUserMessage_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.accessibleHeading && /*#__PURE__*/jsx(state.accessibleHeading, {}), state.timestamp && /*#__PURE__*/jsx(state.timestamp, {}), state.actionBarAccessibleButton && /*#__PURE__*/jsx(state.actionBarAccessibleButton, {}), state.actionBar && /*#__PURE__*/jsx(state.actionBar, {}), /*#__PURE__*/jsx(state.message, {})]
  });
};

const userMessageClassNames = {
  root: 'fai-UserMessage',
  accessibleHeading: 'fai-UserMessage__accessibleHeading',
  timestamp: 'fai-UserMessage__timestamp',
  actionBarAccessibleButton: 'fai-UserMessage__actionBarAccessibleButton',
  actionBar: 'fai-UserMessage__actionBar',
  message: 'fai-UserMessage__message'
};
/**
 * Styles for the root slot
 */
const useRootClassName$1 = __resetStyles("rucmimq", null, [".rucmimq{position:relative;display:grid;grid-auto-rows:max-content;grid-auto-flow:column;align-self:flex-end;grid-template-areas:\"start timestamp\" \"button  button\" \"message message\";color:var(--colorNeutralForeground1);column-gap:var(--spacingHorizontalS);padding:var(--spacingVerticalS) var(--spacingHorizontalL);border-radius:var(--borderRadiusXLarge);}", ".rucmimq:focus{outline:none;}", ".rucmimq:focus .fai-UserMessage__message{outline:var(--strokeWidthThick) solid var(--colorNeutralForeground1);}", ".rucmimq:focus:not(:focus-visible) .fai-UserMessage__message{outline:none;}"]);
/**
 * Styles for the hidden heading slot
 */
const useHeadingStyles = __resetStyles("r183b29h", null, [".r183b29h{clip:rect(0px, 0px, 0px, 0px);grid-area:start;height:1px;margin:-1px;width:1px;position:absolute;overflow:hidden;white-space:nowrap;}"]);
/**
 * Styles for the name slot
 */
const useTimestampStyles = __resetStyles("rl37xzm", null, [".rl37xzm{color:var(--colorNeutralForeground3);grid-area:timestamp;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase200);}"]);
/**
 * Styles for the accessible button slot
 */
const useActionBarAccessibleButtonStyles = __resetStyles("rb330c", null, [".rb330c{grid-area:button;clip:rect(0px, 0px, 0px, 0px);height:1px;margin:-1px;width:1px;position:absolute;overflow:hidden;white-space:nowrap;}"]);
/**
 * Styles for the action bar slot
 */
const useActionBarStyles = __styles({
  root: {
    mc9l5x: "f22iagw",
    Brf1p80: "f9c4gz4",
    De3pzq: "fxugw4r",
    E5pizo: "fz58gqq",
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "ft85np5",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "fvt3ank"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f9c4gz4{justify-content:flex-end;}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".fz58gqq{box-shadow:var(--shadow8);}", [".ft85np5{border-radius:var(--borderRadiusMedium);}", {
    p: -1
  }], [".fvt3ank{gap:0 var(--spacingHorizontalS);}", {
    p: -1
  }]]
});
/**
 * Styles for the message slot
 */
const useMessageStyles = __resetStyles("r1eqwv3i", "rmft1wd", [".r1eqwv3i{grid-area:message;background-color:var(--colorBrandBackground2);padding-top:var(--spacingVerticalS);padding-bottom:var(--spacingVerticalS);padding-left:var(--spacingHorizontalL);padding-right:var(--spacingHorizontalL);border-radius:var(--borderRadiusXLarge);}", ".rmft1wd{grid-area:message;background-color:var(--colorBrandBackground2);padding-top:var(--spacingVerticalS);padding-bottom:var(--spacingVerticalS);padding-right:var(--spacingHorizontalL);padding-left:var(--spacingHorizontalL);border-radius:var(--borderRadiusXLarge);}"]);
/**
 * Apply styling to the UserMessage slots based on the state
 */
const useUserMessageStyles_unstable = state => {
  'use no memo';

  const rootClassName = useRootClassName$1();
  const headingStyles = useHeadingStyles();
  const timestampStyles = useTimestampStyles();
  const actionBarAccessibleButtonStyles = useActionBarAccessibleButtonStyles();
  const actionBarStyles = useActionBarStyles();
  const messageStyles = useMessageStyles();
  state.root.className = mergeClasses(userMessageClassNames.root, rootClassName, state.root.className);
  if (state.accessibleHeading) {
    state.accessibleHeading.className = mergeClasses(userMessageClassNames.accessibleHeading, headingStyles, state.accessibleHeading.className);
  }
  if (state.timestamp) {
    state.timestamp.className = mergeClasses(userMessageClassNames.timestamp, timestampStyles, state.timestamp.className);
  }
  if (state.actionBarAccessibleButton) {
    state.actionBarAccessibleButton.className = mergeClasses(userMessageClassNames.actionBarAccessibleButton, actionBarAccessibleButtonStyles, state.actionBarAccessibleButton.className);
  }
  if (state.actionBar) {
    state.actionBar.className = mergeClasses(userMessageClassNames.actionBar, actionBarStyles.root, state.actionBar.className);
  }
  state.message.className = mergeClasses(userMessageClassNames.message, messageStyles, state.message.className);
  return state;
};

// UserMessage component - TODO: add more docs
const UserMessage = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useUserMessage_unstable(props, ref);
  useUserMessageStyles_unstable(state);
  useCustomStyleHook('useUserMessageStyles')(state);
  return renderUserMessage_unstable(state);
});
UserMessage.displayName = 'UserMessage';

const Query = ({ queryText = "" }) => {
  React.useState(false);
  const { referenceGroupToggleProps, referenceListProps } = useReferenceGroup(
    {}
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CopilotMessageFooter,
    {
      referenceList: /* @__PURE__ */ jsxRuntimeExports.jsx(ReferenceList, { ...referenceListProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        CopilotMessage,
        {
          style: {
            border: "1px solid #efefef",
            boxShadow: "none",
            padding: "10px",
            fontSize: "12px"
          },
          children: queryText.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "").replace(/`/g, "")
        }
      ) }),
      referenceListToggle: /* @__PURE__ */ jsxRuntimeExports.jsx(ReferenceGroupToggle, { ...referenceGroupToggleProps, children: "Query" })
    }
  );
};

const dbCopilotResponseTypes = ["text", "htmltable", "error", "command"];
const responseSources = [
	"dbcopilot",
	"cloudgpt",
	"greetings",
	"aisearch",
	"command",
	"copilot",
];
const responseSourcesnl2dbcopilot = ["nl2sqldbcopilot"];

const eventType = {
	"Event": ["Closed","Started","New Conversation","Default Prompt Selected","Opened","View Prompt Invoked","Prompt Library Selected","Chat cleared","Slash prompt teams selected","Slash prompt project selected","Slash prompt invoked"],
	"Query": ["Inquiry Started","Inquiry failed"],
	"CopilotPanelActions": ["Positive feedback clicked","Negative feedback clicked","Create support ticket clicked","Copy button clicked"],
	"Command": ["Generate","Rewrite"],
};

const SuggestionRecordsToGet = "5";
const SuggestionRecordsToShow = 2;
const promptlimit = 6;
const askQuestion = "Ask a question or request";
const coachmarkData = {
	coachmarkTitle: "Sample prompts",
	coachmarkCloseButtontext: "Got it",
	ariaAlertText: "A coachmark has appeared",
	ariaDescribedBy: "Copilot coachmark guide",
	ariaLabelledBy: "Copilot coachmark",
	ariaDescribedByText:
		"Press enter or alt + C to open the coachmark notification",
	ariaLabelledByText: "Coachmark notification",
	close: "Close",
	coachmarkContent:
		"These are few prompt suggestions tailored to the current page you're viewing.",
};
const tooltipContent = "Suggested prompts";
const promptsButton = {
	ariaLabel: "pluggins",
	appearance: "transparent",
	role: "Prompts Button",
	labelText: "View prompts",
};
const noDataCaptured =
	"Not captured due to appinsights's character limitations";
const appInsightsCharacterLimit = 8192;
const createIncidentButtonText = "Create a Support Ticket";

const newConversation = "New conversation";
const headerSubTitle =
	"An AI assistant ready to do a wide range of tasks";

const LearnMoreText = "Learn More";
const noteInformation = "Confidential data not included";
const ShowMoreText = "Show more";
const ShowLessText = "Show less";

const defaultErrorMessage =
	"Sorry the Delivery Copilot service is down right now. Please try again later.";
const defaultBotMessage =
	"Sorry, we couldn't find an answer to your query. Please rephrase your question and try again.";
	
const nl2sqldbcopilotErrorMessage = "The requested data is currently unavailable. We are working to include it and kindly ask that you check back later.";

const textAllKPINotAvailable =
	"Summaries for all KPIs are curently unavailable. The system will generate summaries for each KPI followed by Executive Summary. Shall we Proceed?";
const textFewKPINotAvailable =
	"The Executive Summary is created from individual KPI status summaries. For some KPIs, summaries are missing.";
const howProceed = "How would you like to proceed?";
const GenerateExecutiveSummary = "Generate Executive Summary";
const modalOptions = [
	{
		key: "generateSummaries",
		text: "Generate missing KPI summaries, then create the Executive Summary.",
	},
	{
		key: "proceedAsIs",
		text: "Create the Executive Summary using the available KPI summaries.",
	},
	
];
const loadingText = "Loading...";
const SystemIssue =
	"We are currently facing a technical issue that is preventing us from retrieving the requested information. Kindly try again after some time.";

const RenderMarkdownData = (props) => {
  const responseObj = props?.response;
  const MarkdownRenderer = ({ messageText }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "markdown-table", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Markdown,
      {
        remarkPlugins: [remarkGfm],
        components: {
          a: ({ node, ...props2 }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { ...props2, target: "_blank", rel: "noopener noreferrer" })
        },
        children: messageText.markDownResult ? messageText.markDownResult : nl2sqldbcopilotErrorMessage
      }
    ) });
  };
  React.useEffect(() => {
    props.setFeedbackButtonsVisible(true);
    props.promptResult(true);
    if (responseObj?.responseType?.toLowerCase() !== "error") {
      if (responseObj?.data?.isChart) ; else {
        const jsx2 = /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText: responseObj?.data });
        const htmlString = renderToString(jsx2);
        props.setCopyText(htmlString);
      }
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        style: {
          width: "100%",
          overflowX: "auto"
        },
        children: [
          responseObj?.responseType?.toLowerCase() === "error" && responseObj?.data?.errorCode && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: responseObj?.data?.errorMessage }),
          responseObj?.responseType?.toLowerCase() !== "error" && (responseObj?.data?.isChart ? responseObj?.data?.chartData !== "" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Plot,
            {
              data: JSON.parse(responseObj?.data?.chartData).data,
              layout: JSON.parse(responseObj?.data?.chartData).layout,
              config: { displayModeBar: false, scrollZoom: false }
            }
          ) : responseObj?.data?.markDownResult !== "" ? /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText: responseObj.data }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Sorry there is issue in processing your request. Please try again" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText: responseObj.data }))
        ]
      }
    ),
    responseObj?.responseType?.toLowerCase() !== "error" && responseObj?.data?.isChart && responseObj?.data?.chartData === "" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-note", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Sorry there is issue in processing the chart. Please try again" }) }) : null,
    responseObj?.responseType?.toLowerCase() !== "error" && responseObj?.data?.additionaNote !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "additional-note", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: responseObj?.data?.additionaNote }) }),
    responseObj?.responseType?.toLowerCase() !== "error" && responseObj?.data?.confidentailNote && /* @__PURE__ */ jsxRuntimeExports.jsx(ConfidentialNote$1, { note: responseObj?.data?.confidentailNote }),
    responseObj?.responseType?.toLowerCase() !== "error" && responseObj?.data?.resultStatistics && Object.keys(responseObj?.data?.resultStatistics).length !== 0 && responseObj?.data?.resultStatistics?.FinalSQLQuery !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(Query, { queryText: responseObj?.data?.resultStatistics?.FinalSQLQuery })
  ] });
};

const useStyles$o = makeStyles({
  buttonIncident: {
    marginTop: "10px",
    marginRight: "10px"
  }
});
const CreateIncidentButton = ({ onShowIrisBot, additionalHelpButtonCallback }) => {
  const styles = useStyles$o();
  const configInfo = useSelector((state) => state.config.config);
  const buttonText = configInfo?.createSupportTicketButtonText || createIncidentButtonText;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CopilotMessageFooter, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { className: styles.buttonIncident, size: "small", style: { display: configInfo?.isCreateIncidentButtonVisible ? "inline-block" : "none" }, onClick: onShowIrisBot, children: [
      " ",
      buttonText
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { className: styles.buttonIncident, size: "small", style: { display: configInfo?.addionalHelpButtonSetting?.visible ? "inline-block" : "none" }, onClick: additionalHelpButtonCallback, children: [
      " ",
      configInfo?.addionalHelpButtonSetting?.buttonText
    ] })
  ] });
};

function useTrackCustomEvents$1() {
 
    const trackCopilotEvent = useCallback((key,value, trackCustomEvents,config) => {
        const navgigationLogURL = config?.pageInfo?.split("/")?.pop();
        const appInsightObj = initializeAppInsights(
            config?.appInsightConfig?.instrumentationKey
        );
        const name = config?.mcapsBotContext?.featureName + " " + key;
        const eventTypeResult = getEventTypeQuestionAnserV1(key, value, eventType);
        const eventValues = {
            userName: config?.mcapsBotContext?.currentUserName,
            conversationId: (typeof value === 'object' && value !== ""  && value !== null && value?.conversationId) ? value.conversationId : config?.chatConversationID,
            messageId: (typeof value === 'object' && value !== ""  && value !== null && value?.botConversationId) ? value.botConversationId : config?.botConversationId,
            PageName: navgigationLogURL || "Home",
            applicationName: config?.mcapsBotContext.appName,
            type: eventTypeResult?.type,
        };
        if(eventTypeResult?.userQuestion && eventTypeResult?.userQuestion !== "" && eventTypeResult?.userQuestion !== null){
            eventValues["userQuestion"] = eventTypeResult?.userQuestion;
        }
        if(eventTypeResult?.botResponse && eventTypeResult?.botResponse !== "" && eventTypeResult?.botResponse !== null){
            eventValues["botResponse"] = eventTypeResult?.botResponse;
        }

        setTimeout(() => {
            if (trackCustomEvents) {
                trackCustomEvents(name, key, eventValues);
                //console.log("trackCustomEvents called: ", name, key, eventValues);
            } else {
                appInsightObj?.trackEvent({
                    name: name, properties: {additionalInfo: eventValues}
                  });
            }
        }, 200);
    }, []);
    return {trackCopilotEvent: trackCopilotEvent}
}

const useStyles$n = makeStyles({
  messageFooter: {
    rowGap: "4px"
  },
  innerWrapper: {
    alignItems: "start",
    display: "flex"
  },
  outerWrapper: {
    display: "flex",
    flexDirection: "column",
    rowGap: "15px"
  }
});
const Copy20 = bundleIcon(Copy20Filled, Copy20Regular);
const CopyButton = ({ textToCopy, trackCustomEvents, messageText }) => {
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  let tempMessage = messageText?.message;
  if (tempMessage && !tempMessage.hasOwnProperty("question")) {
    tempMessage = { ...tempMessage, question: messageText.question };
  }
  const [tooltipText, setTooltipText] = useState("Copy");
  const config = useSelector((state) => state.config.config);
  const copyToClipboard = () => {
    const tempElement = document.createElement("pre");
    tempElement.innerHTML = textToCopy;
    document.body.appendChild(tempElement);
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(tempElement);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    document.body.removeChild(tempElement);
    setTooltipText("Copied!");
    trackCopilotEvent("Copy button clicked", getQuesAns(tempMessage), trackCustomEvents, config);
    setTimeout(() => {
      setTooltipText("Copy");
    }, 1e4);
  };
  const styles = useStyles$n();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotMessageFooter, { className: styles.messageFooter, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.outerWrapper, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.innerWrapper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { content: tooltipText, withArrow: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { size: "small", icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Copy20, {}), onClick: copyToClipboard, title: "Copy" }) }) }) }) });
};

const ThumbLikeIcon16 = bundleIcon(ThumbLike16Filled, ThumbLike16Regular);
const ThumbLikeIcon20 = bundleIcon(ThumbLike20Filled, ThumbLike20Regular);
const ThumbDislikeIcon16 = bundleIcon(ThumbDislike16Filled, ThumbDislike16Regular);
const ThumbDislikeIcon20 = bundleIcon(ThumbDislike20Filled, ThumbDislike20Regular);
/**
 * Create the state required to render FeedbackButtons.
 *
 * The returned state can be modified with hooks such as useFeedbackButtonsStyles_unstable,
 * before being passed to renderFeedbackButtons_unstable.
 *
 * @param props - props from this instance of FeedbackButtons
 * @param ref - reference to root HTMLElement of CopilotF eedback
 */
const useFeedbackButtons_unstable = (props, ref) => {
  const mode = useCopilotMode(props.mode);
  const ThumbLikeIcon = mode === 'sidecar' ? ThumbLikeIcon16 : ThumbLikeIcon20;
  const ThumbDislikeIcon = mode === 'sidecar' ? ThumbDislikeIcon16 : ThumbDislikeIcon20;
  const buttonSize = mode === 'sidecar' ? 'small' : 'medium';
  return {
    mode,
    disabled: props.disabled || false,
    selected: props.selected,
    components: {
      root: 'div',
      positiveFeedbackButton: Button,
      positiveFeedbackTooltip: Tooltip,
      negativeFeedbackButton: Button,
      negativeFeedbackTooltip: Tooltip
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      ...props
    }), {
      elementType: 'div'
    }),
    positiveFeedbackButton: optional(props.positiveFeedbackButton, {
      defaultProps: {
        icon: /*#__PURE__*/React.createElement(ThumbLikeIcon, null),
        size: buttonSize,
        disabled: props.disabled,
        appearance: 'transparent'
      },
      elementType: Button,
      renderByDefault: true
    }),
    positiveFeedbackTooltip: optional(props.positiveFeedbackTooltip, {
      defaultProps: {
        relationship: 'label',
        content: 'Like',
        withArrow: true
      },
      elementType: Tooltip,
      renderByDefault: true
    }),
    negativeFeedbackButton: optional(props.negativeFeedbackButton, {
      defaultProps: {
        icon: /*#__PURE__*/React.createElement(ThumbDislikeIcon, null),
        size: buttonSize,
        disabled: props.disabled,
        appearance: 'transparent'
      },
      elementType: Button,
      renderByDefault: true
    }),
    negativeFeedbackTooltip: optional(props.negativeFeedbackTooltip, {
      defaultProps: {
        relationship: 'label',
        content: 'Dislike',
        withArrow: true
      },
      elementType: Tooltip,
      renderByDefault: true
    })
  };
};

/**
 * Render the final JSX of FeedbackButtons
 */
const renderFeedbackButtons_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.positiveFeedbackButton && state.positiveFeedbackTooltip && /*#__PURE__*/jsx(state.positiveFeedbackTooltip, {
      children: /*#__PURE__*/jsx(state.positiveFeedbackButton, {})
    }), state.positiveFeedbackButton && !state.positiveFeedbackTooltip && /*#__PURE__*/jsx(state.positiveFeedbackButton, {}), state.negativeFeedbackButton && state.negativeFeedbackTooltip && /*#__PURE__*/jsx(state.negativeFeedbackTooltip, {
      children: /*#__PURE__*/jsx(state.negativeFeedbackButton, {})
    }), state.negativeFeedbackButton && !state.negativeFeedbackTooltip && /*#__PURE__*/jsx(state.negativeFeedbackButton, {})]
  });
};

const feedbackButtonsClassNames = {
  root: 'fai-FeedbackButtons',
  negativeFeedbackButton: 'fai-FeedbackButtons__negativeFeedbackButton',
  negativeFeedbackTooltip: 'fai-FeedbackButtons__negativeFeedbackTooltip',
  positiveFeedbackButton: 'fai-FeedbackButtons__positiveFeedbackButton',
  positiveFeedbackTooltip: 'fai-FeedbackButtons__positiveFeedbackTooltip'
};
const useStyles$m = __styles({
  root: {
    mc9l5x: "f22iagw",
    i8kkvl: "f1ufnopg"
  },
  selected: {
    sj55zd: "f1qj7y59",
    D0sxk3: "fxoiby5",
    t6yez3: "f15q0o9g"
  },
  disabledSelected: {
    Bk3fhr4: "ft1hn21",
    Bmfj8id: "fuxngvv",
    em6i61: "f1dfjoow",
    vm6p8p: "f1j98vj9"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1ufnopg{column-gap:var(--spacingHorizontalXS);}", ".f1qj7y59{color:var(--colorNeutralForeground2BrandSelected);}", ".fxoiby5 .fui-Icon-filled{display:inline;}", ".f15q0o9g .fui-Icon-regular{display:none;}"],
  h: [".ft1hn21:hover .fui-Icon-filled{display:inline;}", ".fuxngvv:hover .fui-Icon-regular{display:none;}", ".f1dfjoow:hover:active .fui-Icon-filled{display:inline;}", ".f1j98vj9:hover:active .fui-Icon-regular{display:none;}"]
});
const useFeedbackButtonsStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$m();
  state.root.className = mergeClasses(feedbackButtonsClassNames.root, styles.root, state.root.className);
  if (state.positiveFeedbackButton) {
    state.positiveFeedbackButton.className = mergeClasses(feedbackButtonsClassNames.positiveFeedbackButton, state.selected === 'positive' && styles.selected, state.selected === 'positive' && state.disabled && styles.disabledSelected, state.positiveFeedbackButton.className);
  }
  if (state.negativeFeedbackButton) {
    state.negativeFeedbackButton.className = mergeClasses(feedbackButtonsClassNames.negativeFeedbackButton, state.selected === 'negative' && styles.selected, state.selected === 'negative' && state.disabled && styles.disabledSelected, state.negativeFeedbackButton.className);
  }
  return state;
};

// FeedbackButtons component - TODO: add more docs
const FeedbackButtons = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useFeedbackButtons_unstable(props, ref);
  useFeedbackButtonsStyles_unstable(state);
  useCustomStyleHook('useFeedbackButtonsStyles')(state);
  return renderFeedbackButtons_unstable(state);
});
FeedbackButtons.displayName = 'FeedbackButtons';

const useStyles$l = makeStyles({
  aiGenerate: {
    backgroundColor: "#dddddd"
  }
});
const AIGenerate = ({
  id,
  positiveFeedback,
  negativeFeedback,
  updateMessage,
  ocvData,
  messageText,
  trackCustomEvents
}) => {
  const styles = useStyles$l();
  const [aiResponse, setAiResponse] = useState("");
  const [selected, setSelected] = useState(undefined);
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  const config = useSelector((state) => state.config.config);
  let tempMessage = messageText?.message;
  if (tempMessage && !tempMessage.hasOwnProperty("question")) {
    tempMessage = { ...tempMessage, question: messageText.question };
  }
  const onFeedbackPositiveClick = () => {
    trackCopilotEvent("Positive feedback clicked", getQuesAns(tempMessage), trackCustomEvents, config);
    setSelected(selected === "positive" ? undefined : "positive");
    if (updateMessage) {
      const message = updateMessage(id, { isFeedbackUpvoted: true });
      positiveFeedback();
      if (!message) return;
    }
  };
  const onFeedbackNegativeClick = () => {
    trackCopilotEvent("Negative feedback clicked", getQuesAns(tempMessage), trackCustomEvents, config);
    setSelected(selected === "negative" ? undefined : "negative");
    if (updateMessage) {
      const message = updateMessage(id, { isFeedbackUpvoted: false });
      negativeFeedback();
      setAiResponse(message);
      ocvData(false, message);
      if (!message) return;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CopilotMessageFooter,
    {
      feedback: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FeedbackButtons,
        {
          selected,
          positiveFeedbackButton: {
            onClick: onFeedbackPositiveClick,
            disabled: selected !== undefined
          },
          positiveFeedbackTooltip: {
            content: selected === "positive" ? "Like, Feedback sent" : "Like"
          },
          negativeFeedbackButton: {
            onClick: onFeedbackNegativeClick,
            disabled: selected !== undefined
          },
          negativeFeedbackTooltip: {
            content: selected === "negative" ? "Dislike, Feedback sent" : "Dislike"
          }
        }
      ),
      aiDisclaimer: /* @__PURE__ */ jsxRuntimeExports.jsx(AiGeneratedDisclaimer, { className: styles.aiGenerate, children: "AI-generated content may be incorrect" })
    }
  );
};

const styles = `
.heading {
  width:30%;
}
.region {
  border-top:none !important;
}
`;
function TypewriterEffect({
  text,
  setFeedbackButtonsVisible,
  //enableSend,
  promptResult,
  isToggled,
  typewriterFlag,
  welcomeMess,
  setCopyText
}) {
  const [wordsToDisplay, setWordsToDisplay] = useState([]);
  const [plainText, setplainText] = useState("");
  useState(false);
  useState(
    text?.query ? text?.query.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "") : null
  );
  useState(text.note ? text.note : null);
  useEffect(() => {
    let processedText = text;
    processedText = processedText?.contentData ? processedText?.contentData.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "") : processedText;
    processedText = processedText?.aiResponseData ? processedText.aiResponseData : processedText;
    if (typeof processedText === "string") {
      processedText = processedText.replace(/Cell>/g, "");
      processedText = processedText.replace(/</g, "");
      processedText = processedText.replace(/>/g, "");
      processedText = processedText.replace(/\n/g, " </br> ");
    } else {
      if (processedText?.data?.reply)
        processedText = processedText?.data?.reply;
    }
    setplainText(
      processedText ? processedText : wordsToDisplay.length > 0 ? wordsToDisplay.join(" ") : welcomeMess
    );
    setCopyText(
      processedText ? processedText : wordsToDisplay.length > 0 ? wordsToDisplay.join(" ") : welcomeMess
    );
    if (!typewriterFlag) {
      setFeedbackButtonsVisible(true);
      promptResult(true);
    } else {
      const words = text.split(" ");
      let currentIndex = 0;
      const intervalId = setInterval(() => {
        setWordsToDisplay((prevWords) => {
          if (currentIndex >= words.length) {
            setFeedbackButtonsVisible(true);
            clearInterval(intervalId);
            const divElement2 = document.getElementById("chatMessagesBody");
            if (divElement2) {
              divElement2.scrollTop = divElement2.scrollHeight;
            }
            promptResult(true);
            return prevWords;
          }
          const nextWord = words[currentIndex];
          currentIndex += 1;
          const divElement = document.getElementById("chatMessagesBody");
          if (divElement) {
            divElement.scrollTop = divElement.scrollHeight;
          }
          return [...prevWords, nextWord];
        });
      }, 100);
      return () => clearInterval(intervalId);
    }
  }, [text]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { marginBottom: "10px" }, children: typewriterFlag ? wordsToDisplay.map((word, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
    word === "</br>" ? /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}) : word,
    index < wordsToDisplay.length - 1 && " "
  ] }, index)) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: plainText } }) });
}
const Message$1 = ({
  id,
  index,
  messageText,
  suggestions = [],
  isFeedbackButtonsVisible,
  isFeedbackPositive = null,
  isSentByUser,
  feedbackDisabled,
  timestamp,
  updateMessage,
  enableSend,
  sendMessage,
  isFullScreen = false,
  welcomeMess,
  isToggled,
  onShowIrisBot,
  positiveFeedback,
  negativeFeedback,
  ocvData,
  isCreateIncidentButtonVisible,
  isCopyButtonVisible,
  trackCustomEvents,
  additionalHelpButtonCallback
}) => {
  const [isLoading, setIsLoading] = useState(false);
  React__default.useContext(MCAPSBotContext$1);
  const [feedbackButtonsVisible, setFeedbackButtonsVisible] = useState(false);
  const [promptflag, setpromptflag] = useState(false);
  useState("Copy");
  const [plainText, setPlainText] = React__default.useState("");
  const typewriterFlag = useSelector(
    (state) => state.config.config.isTypewritingOn
  );
  const [query, setquery] = useState(
    messageText?.message?.query ? messageText?.message?.query.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "") : null
  );
  const [note, setNote] = useState(
    messageText?.message?.note ? messageText?.message?.note : null
  );
  let suggestionLinks = [];
  if (messageText?.message?.docs) {
    var simplifiedData = JSON.parse(messageText?.message?.docs);
    const simplifiedData_ = simplifiedData.docs.map((item) => {
      const metadata = item.metadata || {};
      const url = metadata.url || "";
      return {
        title: metadata.title.replace(/[_-]/g, " ") || "",
        link: url ? url : ""
      };
    });
    const uniqueArray = simplifiedData_.filter(
      (item, index2, self) => index2 === self.findIndex((t) => t.title === item.title)
    );
    suggestionLinks = uniqueArray;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (() => {
    switch (messageText.from) {
      case "bot": {
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          CopilotMessage,
          {
            className: styles.card,
            progress: { value: undefined },
            isLoading,
            defaultFocused: true,
            "aria-live": "polite",
            "aria-atomic": "true",
            children: [
              messageText?.responseType == "markdown" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                RenderMarkdownData$1,
                {
                  response: messageText.message,
                  enableSend,
                  setFeedbackButtonsVisible,
                  promptResult: setpromptflag,
                  isToggled,
                  suggestionLinks,
                  typewriterFlag,
                  setCopyText: setPlainText,
                  isFullScreen
                }
              ) : messageText?.responseType == "graph" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                RenderGraphData,
                {
                  response: messageText.message,
                  setFeedbackButtonsVisible,
                  enableSend,
                  promptResult: setpromptflag,
                  isFullScreen
                }
              ) : dbCopilotResponseTypes.includes(
                messageText?.responseType
              ) && responseSources.includes(messageText?.responseSource) && (messageText?.message?.reply || messageText?.message?.data || messageText?.message?.aiResponseData) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                DbCopilotResponse,
                {
                  response: messageText.message,
                  enableSend,
                  setFeedbackButtonsVisible,
                  promptResult: setpromptflag,
                  isToggled,
                  suggestionLinks,
                  typewriterFlag,
                  setCopyText: setPlainText,
                  isFullScreen
                }
              ) : dbCopilotResponseTypes.includes(
                messageText?.responseType
              ) && responseSourcesnl2dbcopilot.includes(messageText?.responseSource) && (messageText?.message?.reply || messageText?.message?.data || messageText?.message?.data?.markDownResult) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                RenderMarkdownData,
                {
                  response: messageText.message,
                  enableSend,
                  setFeedbackButtonsVisible,
                  promptResult: setpromptflag,
                  isToggled,
                  suggestionLinks,
                  typewriterFlag,
                  setCopyText: setPlainText,
                  isFullScreen
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                TypewriterEffect,
                {
                  text: messageText.message,
                  setFeedbackButtonsVisible,
                  promptResult: setpromptflag,
                  isToggled,
                  typewriterFlag,
                  welcomeMess,
                  setCopyText: setPlainText
                }
              ),
              note && /* @__PURE__ */ jsxRuntimeExports.jsx(ConfidentialNote$1, { note }),
              query && /* @__PURE__ */ jsxRuntimeExports.jsx(Query, { queryText: query }),
              !isSentByUser && !messageText?.message?.greeting && promptflag && messageText?.responseType != "command" && messageText?.message != "" && (messageText?.message?.reply !== undefined || messageText?.message?.aiResponseData !== undefined || messageText?.message?.contentData !== undefined) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: messageText?.message?.graphData == undefined && isCopyButtonVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
                CopyButton,
                {
                  textToCopy: plainText,
                  trackCustomEvents,
                  messageText
                }
              ) }) : null,
              !isSentByUser && !messageText?.message?.greeting && responseSourcesnl2dbcopilot.includes(messageText?.responseSource) && promptflag && messageText?.responseType != "command" && messageText?.message != "" && (messageText?.message?.data !== undefined || messageText?.message?.data?.markDownResult !== undefined) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (messageText?.message?.data?.isChart === false || messageText?.message?.data?.chartData === null) && isCopyButtonVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
                CopyButton,
                {
                  textToCopy: plainText,
                  trackCustomEvents,
                  messageText
                }
              ) }) : null,
              messageText?.responseType != "command" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                CreateIncidentButton,
                {
                  onShowIrisBot,
                  additionalHelpButtonCallback
                }
              ),
              isFeedbackButtonsVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
                AIGenerate,
                {
                  id,
                  positiveFeedback,
                  negativeFeedback,
                  updateMessage,
                  ocvData,
                  messageText,
                  trackCustomEvents
                }
              )
            ]
          },
          `CopilotMessage-${index}`
        );
      }
      case "user": {
        return [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UserMessage$1,
            {
              "aria-live": "polite",
              "aria-atomic": "true",
              children: messageText.message
            },
            `UserMessage-${index}`
          )
        ];
      }
      case "system": {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          SystemMessageWrapper,
          {
            ...messageText
          },
          `SystemMessage-${index}`
        );
      }
    }
  })() });
};

const MessageBody = ({
  messages,
  updateMessage,
  setTextFieldValue,
  isSpinnerActive,
  enableSend,
  sendMessage,
  isFullScreen = false,
  welcomeMessage,
  isToggled,
  onShowIrisBot,
  positiveFeedback,
  negativeFeedback,
  ocvData,
  isCreateIncidentButtonVisible,
  isCopyButtonVisible,
  IrisBotMessage,
  trackCustomEvents,
  additionalHelpButtonCallback
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: messages.map((item, index) => {
    item.from == "user" ? "#e0e7ff" : "white";
    if (item.type === "message") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Message$1,
        {
          id: item.id,
          index,
          messageText: item,
          isFeedbackButtonsVisible: item.isFeedbackEnabled,
          isFeedbackPositive: item.isFeedbackUpvoted,
          isSentByUser: item.from === "user",
          isSuggestion: item.isSuggestion,
          feedbackDisabled: isSpinnerActive,
          timestamp: item.dateTime,
          updateMessage,
          enableSend,
          suggestions: item.suggestions,
          sendMessage,
          isFullScreen,
          welcomeMess: welcomeMessage,
          isToggled,
          onShowIrisBot,
          IrisBotMessage,
          positiveFeedback,
          negativeFeedback,
          ocvData,
          isCreateIncidentButtonVisible,
          isCopyButtonVisible,
          trackCustomEvents,
          additionalHelpButtonCallback
        },
        `messageBody-${index}`
      );
    } else if (item.type === "seperator") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "seperatorContainer", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "seperatorLine" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { minWidth: 120, textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { children: newConversation }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "seperatorLine" })
      ] });
    } else return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  }) });
};

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render LatencyWrapper.
 *
 * The returned state can be modified with hooks such as useLatencyWrapperStyles_unstable,
 * before being passed to renderLatencyWrapper_unstable.
 *
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 *
 * @param props - props from this instance of LatencyWrapper
 * @param ref - reference to root HTMLElement of LatencyWrapper
 */
const useLatencyWrapper_unstable = (props, ref) => {
  return {
    components: {
      root: 'div'
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      ...props
    }), {
      elementType: 'div'
    })
  };
};

/**
 * Render the final JSX of LatencyWrapper
 *
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 */
const renderLatencyWrapper_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsx(state.root, {});
};

const latencyWrapperClassNames = {
  root: 'fai-LatencyWrapper'
};
/**
 * Styles for the root slot
 */
const useStyles$k = __styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    Bt984gj: "f122n59"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", ".f122n59{align-items:center;}"]
});
/**
 * Apply styling to the LatencyWrapper slots based on the state
 *
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 */
const useLatencyWrapperStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$k();
  state.root.className = mergeClasses(latencyWrapperClassNames.root, styles.root, state.root.className);
  // TODO Add class names to slots, for example:
  // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);
  return state;
};

/**
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 */
const LatencyWrapper = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useLatencyWrapper_unstable(props, ref);
  useLatencyWrapperStyles_unstable(state);
  useCustomStyleHook('useLatencyWrapperStyles')(state);
  return renderLatencyWrapper_unstable(state);
});
LatencyWrapper.displayName = 'LatencyWrapper';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render LatencyLoader.
 *
 * The returned state can be modified with hooks such as useLatencyLoaderStyles_unstable,
 * before being passed to renderLatencyLoader_unstable.
 *
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 *
 * @param props - props from this instance of LatencyLoader
 * @param ref - reference to root HTMLElement of LatencyLoader
 */
const useLatencyLoader_unstable = (props, ref) => {
  var _state_header;
  const {
    header,
    progress
  } = props;
  const {
    announce
  } = useAnnounce$1();
  const announceBatchId = useId();
  const headerRef = React.useRef(null);
  const [announcement, setAnnouncement] = useControllableState({
    state: props.announcement,
    initialState: ''
  });
  const state = {
    components: {
      root: 'div',
      header: 'h3',
      progress: ProgressBar
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      ...props
    }), {
      elementType: 'div'
    }),
    header: optional(header, {
      elementType: 'h3'
    }),
    progress: optional(progress, {
      defaultProps: {
        shape: 'rounded',
        thickness: 'large',
        'aria-label': 'Loading'
      },
      elementType: ProgressBar,
      renderByDefault: true
    })
  };
  // handle live region announcement message
  const mergedHeaderRef = useMergedRefs((_state_header = state.header) === null || _state_header === undefined ? undefined : _state_header.ref, headerRef);
  if (state.header) {
    state.header.ref = mergedHeaderRef;
  }
  // handle cacluating default announcement from header slot
  React.useEffect(() => {
    var _state_header;
    if (!state.header) {
      setAnnouncement('');
      return;
    }
    if (typeof ((_state_header = state.header) === null || _state_header === undefined ? undefined : _state_header.children) === 'string') {
      setAnnouncement(state.header.children);
    } else {
      var _headerRef_current;
      var _headerRef_current_textContent;
      setAnnouncement((_headerRef_current_textContent = (_headerRef_current = headerRef.current) === null || _headerRef_current === undefined ? undefined : _headerRef_current.textContent) !== null && _headerRef_current_textContent !== undefined ? _headerRef_current_textContent : '');
    }
  }, [setAnnouncement, state.header]);
  // call announce() if announcement message changes
  React.useEffect(() => {
    announcement && announce(announcement, {
      batchId: announceBatchId
    });
  }, [announce, announceBatchId, announcement]);
  return state;
};

/**
 * Render the final JSX of LatencyLoader
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 */
const renderLatencyLoader_unstable = state => {
  assertSlots(state);
  // TODO Add additional slots in the appropriate place
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.header && /*#__PURE__*/jsx(state.header, {}), state.root.children, state.progress && /*#__PURE__*/jsx(state.progress, {})]
  });
};

const latencyLoaderClassNames = {
  root: 'fai-LatencyLoader',
  header: 'fai-LatencyLoader__header',
  progress: 'fai-LatencyLoader__progress'
};
/**
 * Styles for the root slot
 */
const useStyles$j = __styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    De3pzq: "fxugw4r",
    Bbmb7ep: ["fnivh3a", "fc7yr5o"],
    Beyfa6y: ["fc7yr5o", "fnivh3a"],
    B7oj6ja: ["f1el4m67", "f8yange"],
    Btl43ni: ["f8yange", "f1el4m67"],
    z8tnut: "f1nbblvp",
    z189sj: ["f1njcayn", "f1k4q41u"],
    Byoj8tv: "f1ov4xf1",
    uwmqm3: ["f1k4q41u", "f1njcayn"],
    E5pizo: "f1whvlc6",
    qhf8xq: "f10pi13n",
    B68tc82: "f1p9o1ba",
    Bmxbyg5: "f1sil6mw",
    Bpd4iqm: "fpvhumw",
    oeaueh: "f1yog68k",
    Bw0xxkn: "f13sgyd8",
    a9b677: "fly5x3f",
    B7ck84d: "f1ewtqcl"
  },
  rootWithChildren: {
    Byoj8tv: "fdxej3c"
  },
  progressRoot: {
    a9b677: "fly5x3f",
    qhf8xq: "f1euv43f",
    B5kzvoi: "f1yab3r1",
    oyh7mz: ["f1vgc2s3", "f1e31b4d"],
    j35jbq: ["f1e31b4d", "f1vgc2s3"],
    Bqenvij: "f6ywr7j",
    Beyfa6y: ["f1deotkl", "f1krrbdw"],
    Btl43ni: ["f1ozlkrg", "f10ostut"]
  },
  regularProgressBarStyles: {
    Bqenvij: "f1l02sjl",
    Bcmaq0h: "fx7worf"
  },
  indeterminateProgressBarStyles: {
    Bqenvij: "f1l02sjl",
    De3pzq: "f1c21dwh",
    Bcmaq0h: "f1hxqsn5",
    jpy9cc: "f3z2g5w",
    Bqo2lbl: "fz5izi4",
    B6plc1d: "fv40pdu",
    I82g5a: "f1uj6jbf"
  },
  header: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".fnivh3a{border-bottom-right-radius:var(--borderRadiusXLarge);}", ".fc7yr5o{border-bottom-left-radius:var(--borderRadiusXLarge);}", ".f1el4m67{border-top-right-radius:var(--borderRadiusXLarge);}", ".f8yange{border-top-left-radius:var(--borderRadiusXLarge);}", ".f1nbblvp{padding-top:0px;}", ".f1njcayn{padding-right:var(--spacingVerticalL);}", ".f1k4q41u{padding-left:var(--spacingVerticalL);}", ".f1ov4xf1{padding-bottom:0px;}", ".f1whvlc6{box-shadow:var(--shadow4);}", ".f10pi13n{position:relative;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".fpvhumw{outline-width:1px;}", ".f1yog68k{outline-style:solid;}", ".f13sgyd8{outline-color:var(--colorTransparentStroke);}", ".fly5x3f{width:100%;}", ".f1ewtqcl{box-sizing:border-box;}", ".fdxej3c{padding-bottom:var(--spacingVerticalL);}", ".f1euv43f{position:absolute;}", ".f1yab3r1{bottom:0;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", ".f6ywr7j{height:4px;}", ".f1deotkl{border-bottom-left-radius:0;}", ".f1krrbdw{border-bottom-right-radius:0;}", ".f1ozlkrg{border-top-left-radius:0;}", ".f10ostut{border-top-right-radius:0;}", ".f1l02sjl{height:100%;}", ".fx7worf{background-image:linear-gradient(90deg, var(--fai-colorBrandFlair1) 35%, var(--fai-colorBrandFlair2) 70%, var(--fai-colorBrandFlair3) 92%);}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f1hxqsn5{background-image:linear-gradient(90deg, rgba(0,0,0,0) 0%, var(--fai-colorBrandFlair1) 35%, var(--fai-colorBrandFlair2) 70%, var(--fai-colorBrandFlair3) 92%,  rgba(0,0,0,0));}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"],
  m: [["@media screen and (prefers-reduced-motion: reduce){.f3z2g5w{max-width:100%;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.fz5izi4{animation-iteration-count:infinite;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.fv40pdu{animation-duration:3s;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f1uj6jbf{animation-name:ftc26vs;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }]],
  k: ["@keyframes ftc26vs{0%{opacity:.2;}50%{opacity:1;}100%{opacity:.2;}}"]
});
/**
 * Apply styling to the LatencyLoader slots based on the state
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 */
const useLatencyLoaderStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$j();
  const {
    root
  } = state;
  state.root.className = mergeClasses(latencyLoaderClassNames.root, styles.root, root.children ? styles.rootWithChildren : undefined, state.root.className);
  if (state.header) {
    state.header.className = mergeClasses(latencyLoaderClassNames.header, styles.header, state.header.className);
  }
  if (state.progress) {
    state.progress.className = mergeClasses(latencyLoaderClassNames.progress, styles.progressRoot, state.progress.className);
    const bar = resolveShorthand(state.progress.bar, {
      required: true
    });
    if (bar) {
      if (state.progress.value === undefined) {
        bar.className = mergeClasses(styles.indeterminateProgressBarStyles, bar.className);
      } else {
        bar.className = mergeClasses(styles.regularProgressBarStyles, bar.className);
      }
      state.progress.bar = bar;
    }
  }
  return state;
};

/**
 * @deprecated use the isLoading prop of CopilotMessage instead
 * Deprecated on 07/22/2024
 */
const LatencyLoader = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useLatencyLoader_unstable(props, ref);
  useLatencyLoaderStyles_unstable(state);
  useCustomStyleHook('useLatencyLoaderStyles')(state);
  return renderLatencyLoader_unstable(state);
});
LatencyLoader.displayName = 'LatencyLoader';

const ProgressIndicator = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LatencyWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(LatencyLoader, { ...props, header: props.message }) });
};

/**
 * Create the state required to render PromptStarter.
 *
 * The returned state can be modified with hooks such as usePromptStarterStyles_unstable,
 * before being passed to renderPromptStarter_unstable.
 *
 * @param props - props from this instance of PromptStarter
 * @param ref - reference to root HTMLElement of PromptStarter
 */
const usePromptStarter_unstable = (props, ref) => {
  return {
    components: {
      root: 'button',
      icon: 'span',
      category: 'span',
      prompt: 'span',
      badge: Badge
    },
    root: always(getIntrinsicElementProps('button', {
      ref,
      ...props
    }), {
      elementType: 'button'
    }),
    icon: always(props.icon, {
      elementType: 'span'
    }),
    category: always(props.category, {
      elementType: 'span'
    }),
    prompt: optional(props.prompt, {
      elementType: 'span'
    }),
    badge: optional(props.badge, {
      defaultProps: {
        appearance: 'tint'
      },
      elementType: Badge
    })
  };
};

const renderPromptStarter_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [/*#__PURE__*/jsx(state.icon, {}), /*#__PURE__*/jsxs(state.category, {
      children: [state.category.children, " ", state.badge && /*#__PURE__*/jsx(state.badge, {})]
    }), state.prompt && /*#__PURE__*/jsx(state.prompt, {})]
  });
};

const promptStarterClassNames = {
  root: 'fai-PromptStarter',
  category: 'fai-PromptStarter__category',
  icon: 'fai-PromptStarter__icon',
  prompt: 'fai-PromptStarter__prompt',
  badge: 'fai-PromptStarter__badge'
};
const useRootResetStyles = __resetStyles("r1imcuat", "r16caqmn", {
  r: [".r1imcuat{position:relative;display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto auto;grid-template-areas:\"icon category\" \".    prompt\";background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);font-family:var(--fontFamilyBase);cursor:pointer;outline-style:none;text-align:left;gap:0px 8px;padding:6px 8px 8px 8px;border-top-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-color:var(--colorNeutralStroke1);border-right-color:var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStroke1);border-left-color:var(--colorNeutralStroke1);border-radius:var(--borderRadiusMedium);}", ".r1imcuat:hover{background-color:var(--colorNeutralBackground1Hover);border-top-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-color:var(--colorNeutralStroke1Hover);border-right-color:var(--colorNeutralStroke1Hover);border-bottom-color:var(--colorNeutralStroke1Hover);border-left-color:var(--colorNeutralStroke1Hover);}", ".r1imcuat:active{background-color:var(--colorNeutralBackground1Pressed);border-top-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-color:var(--colorNeutralStroke1Pressed);border-right-color:var(--colorNeutralStroke1Pressed);border-bottom-color:var(--colorNeutralStroke1Pressed);border-left-color:var(--colorNeutralStroke1Pressed);}", ".r1imcuat:focus{outline-style:none;}", ".r1imcuat:focus-visible{outline-style:none;}", ".r1imcuat[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}", ".r1imcuat[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}", ".r16caqmn{position:relative;display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto auto;grid-template-areas:\"icon category\" \".    prompt\";background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);font-family:var(--fontFamilyBase);cursor:pointer;outline-style:none;text-align:right;gap:0px 8px;padding:6px 8px 8px 8px;border-top-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-color:var(--colorNeutralStroke1);border-left-color:var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStroke1);border-right-color:var(--colorNeutralStroke1);border-radius:var(--borderRadiusMedium);}", ".r16caqmn:hover{background-color:var(--colorNeutralBackground1Hover);border-top-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-color:var(--colorNeutralStroke1Hover);border-left-color:var(--colorNeutralStroke1Hover);border-bottom-color:var(--colorNeutralStroke1Hover);border-right-color:var(--colorNeutralStroke1Hover);}", ".r16caqmn:active{background-color:var(--colorNeutralBackground1Pressed);border-top-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-color:var(--colorNeutralStroke1Pressed);border-left-color:var(--colorNeutralStroke1Pressed);border-bottom-color:var(--colorNeutralStroke1Pressed);border-right-color:var(--colorNeutralStroke1Pressed);}", ".r16caqmn:focus{outline-style:none;}", ".r16caqmn:focus-visible{outline-style:none;}", ".r16caqmn[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}", ".r16caqmn[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"],
  s: ["@media (forced-colors: active){.r1imcuat[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}", "@media (forced-colors: active){.r16caqmn[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"]
});
const useStyles$i = __styles({
  disabled: {
    Bceei9c: "fdrzuqr",
    De3pzq: "f1bg9a2p",
    B4j52fo: "f192inf7",
    Bekrc4i: ["f5tn483", "f1ojsxk5"],
    Bn0qgzm: "f1vxd6vx",
    ibv6hh: ["f1ojsxk5", "f5tn483"],
    icvyot: "fzkkow9",
    vrafjx: ["fcdblym", "fjik90z"],
    oivjwe: "fg706s2",
    wvpqe5: ["fjik90z", "fcdblym"],
    g2u3we: "f1jj8ep1",
    h3c5rm: ["f15xbau", "fy0fskl"],
    B9xav0g: "f4ikngz",
    zhjwy3: ["fy0fskl", "f15xbau"],
    Jwef8y: "f1falr9n",
    ckks6v: "f7ic3uo",
    B2zwrfe: ["f1omjgsz", "f1snvl17"],
    xv9156: "fn6xmsl",
    dt87k2: ["f1snvl17", "f1omjgsz"],
    Bf40cpq: "f1sn8sm0",
    Bop6t4b: ["f1wovo5e", "f716mnf"],
    gvrnp0: "fm0h710",
    Beu9t3s: ["f716mnf", "f1wovo5e"],
    Bgoe8wy: "f12mpcsy",
    Bwzppfd: ["f1gwvigk", "f18rmfxp"],
    oetu4i: "f1jnshp0",
    gg5e9n: ["f18rmfxp", "f1gwvigk"],
    ecr2s2: "f1ryyzvn",
    uqwnxt: "fk7lb2a",
    Bvecx4l: ["f1knhbbd", "f17itt0b"],
    Bs0cc2w: "f15pjvi3",
    e1hlit: ["f17itt0b", "f1knhbbd"],
    e2sjt0: "f6ginmj",
    Bbcopvn: ["f1grcyuh", "fgzu20w"],
    Bj33j0h: "fk1xjsr",
    f7epvg: ["fgzu20w", "f1grcyuh"],
    B6oc9vd: "fdi4vxw",
    ak43y8: ["f4ryxzl", "fkdgpbx"],
    wmxk5l: "fcmhn06",
    B50zh58: ["fkdgpbx", "f4ryxzl"]
  },
  icon: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "f1atrtdw",
    mc9l5x: "f22iagw",
    qb2dma: "f7nlbp4"
  },
  category: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f1i3iumi",
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "fq22uu8"
  },
  prompt: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi",
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "f1t16na1"
  },
  disabledText: {
    sj55zd: "f1s2aq7o"
  },
  disabledBadge: {
    abs64n: "fege8ms"
  }
}, {
  d: [".fdrzuqr{cursor:not-allowed;}", ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}", ".f192inf7{border-top-width:var(--strokeWidthThin);}", ".f5tn483{border-right-width:var(--strokeWidthThin);}", ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}", ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}", ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}", [".f1atrtdw{grid-area:icon;}", {
    p: -1
  }], ".f22iagw{display:flex;}", ".f7nlbp4{align-self:center;}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}", [".fq22uu8{grid-area:category;}", {
    p: -1
  }], ".figsok6{font-weight:var(--fontWeightRegular);}", [".f1t16na1{grid-area:prompt;}", {
    p: -1
  }], ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}", ".fege8ms{opacity:40%;}"],
  h: [".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}", ".f7ic3uo:hover{border-top-width:var(--strokeWidthThin);}", ".f1omjgsz:hover{border-right-width:var(--strokeWidthThin);}", ".f1snvl17:hover{border-left-width:var(--strokeWidthThin);}", ".fn6xmsl:hover{border-bottom-width:var(--strokeWidthThin);}", ".f1sn8sm0:hover{border-top-style:solid;}", ".f1wovo5e:hover{border-right-style:solid;}", ".f716mnf:hover{border-left-style:solid;}", ".fm0h710:hover{border-bottom-style:solid;}", ".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}", ".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}"],
  a: [".f1ryyzvn:active{background-color:var(--colorNeutralBackgroundDisabled);}", ".fk7lb2a:active{border-top-width:var(--strokeWidthThin);}", ".f1knhbbd:active{border-right-width:var(--strokeWidthThin);}", ".f17itt0b:active{border-left-width:var(--strokeWidthThin);}", ".f15pjvi3:active{border-bottom-width:var(--strokeWidthThin);}", ".f6ginmj:active{border-top-style:solid;}", ".f1grcyuh:active{border-right-style:solid;}", ".fgzu20w:active{border-left-style:solid;}", ".fk1xjsr:active{border-bottom-style:solid;}", ".fdi4vxw:active{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f4ryxzl:active{border-right-color:var(--colorNeutralStrokeDisabled);}", ".fkdgpbx:active{border-left-color:var(--colorNeutralStrokeDisabled);}", ".fcmhn06:active{border-bottom-color:var(--colorNeutralStrokeDisabled);}"]
});
const usePromptStarterStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$i();
  const rootResetStyles = useRootResetStyles();
  state.root.className = mergeClasses(promptStarterClassNames.root, rootResetStyles, state.root.disabled && styles.disabled, state.root.className);
  state.icon.className = mergeClasses(promptStarterClassNames.icon, styles.icon, state.root.disabled && styles.disabledText, state.icon.className);
  state.category.className = mergeClasses(promptStarterClassNames.category, styles.category, state.category.className, state.root.disabled && styles.disabledText);
  if (state.prompt) {
    state.prompt.className = mergeClasses(promptStarterClassNames.prompt, styles.prompt, state.root.disabled && styles.disabledText, state.prompt.className);
  }
  if (state.badge) {
    state.badge.className = mergeClasses(promptStarterClassNames.badge, state.root.disabled && styles.disabledBadge, state.badge.className);
  }
  return state;
};

const PromptStarter = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = usePromptStarter_unstable(props, ref);
  usePromptStarterStyles_unstable(state);
  useCustomStyleHook('usePromptStarterStyles')(state);
  return renderPromptStarter_unstable(state);
});
PromptStarter.displayName = 'PromptStarter';

const suggestionClassNames = {
  root: 'fai-Suggestion',
  icon: 'fai-Suggestion__icon'
};
const useSuggestionStylesStyles = __styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fy9rknc",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fwrc4pm",
    B4j52fo: "f5ogflp",
    Bekrc4i: ["f1hqa2wf", "finvdd3"],
    Bn0qgzm: "f1f09k3d",
    ibv6hh: ["finvdd3", "f1hqa2wf"],
    icvyot: "fzkkow9",
    vrafjx: ["fcdblym", "fjik90z"],
    oivjwe: "fg706s2",
    wvpqe5: ["fjik90z", "fcdblym"],
    g2u3we: "f161y7kd",
    h3c5rm: ["f1c8dzaj", "f1sl6hi9"],
    B9xav0g: "f1619yhw",
    zhjwy3: ["f1sl6hi9", "f1c8dzaj"],
    Beyfa6y: 0,
    Bbmb7ep: 0,
    Btl43ni: 0,
    B7oj6ja: 0,
    Dimara: "f1kijzfu",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fcca7b8",
    sj55zd: "fkfq4zb",
    fsow6f: "fpgzoln"
  },
  enabled: {
    B9di4we: "fxuoarf",
    B1f0e9u: ["f1qi0eim", "fiwk2rq"],
    bb0oo: "f1jsw6og",
    B88lpqa: ["fiwk2rq", "f1qi0eim"],
    grrwut: "f1ggo121",
    Bejlia0: "f1jg9xd",
    v5djml: "fihmelj",
    Bptf8dt: ["fs1n9un", "f1u9p12n"],
    j4j8r: "f12ds35j",
    H566xl: ["f1u9p12n", "fs1n9un"],
    a9g2gr: "fezean8",
    rgbxn1: "f1yr11xb"
  },
  canvas: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1m1tk10"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}", ".f5ogflp{border-top-width:1px;}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".f1f09k3d{border-bottom-width:1px;}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f161y7kd{border-top-color:var(--colorBrandStroke2);}", ".f1c8dzaj{border-right-color:var(--colorBrandStroke2);}", ".f1sl6hi9{border-left-color:var(--colorBrandStroke2);}", ".f1619yhw{border-bottom-color:var(--colorBrandStroke2);}", [".f1kijzfu{border-radius:var(--borderRadiusXLarge);}", {
    p: -1
  }], [".fcca7b8{padding:var(--spacingVerticalXS) var(--spacingVerticalS);}", {
    p: -1
  }], ".fkfq4zb{color:var(--colorNeutralForeground2);}", ".fpgzoln{text-align:start;}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}", [".f1m1tk10{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalM);}", {
    p: -1
  }]],
  m: [["@media (forced-colors: none){.fxuoarf:hover{border-top-color:var(--colorBrandStroke2Hover);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f1qi0eim:hover{border-right-color:var(--colorBrandStroke2Hover);}.fiwk2rq:hover{border-left-color:var(--colorBrandStroke2Hover);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f1jsw6og:hover{border-bottom-color:var(--colorBrandStroke2Hover);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f1ggo121:hover{color:var(--colorBrandForeground2Hover);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f1jg9xd:hover{background-color:var(--colorBrandBackground2Hover);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.fihmelj:active:hover{border-top-color:var(--colorBrandStroke2Pressed);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f1u9p12n:active:hover{border-left-color:var(--colorBrandStroke2Pressed);}.fs1n9un:active:hover{border-right-color:var(--colorBrandStroke2Pressed);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f12ds35j:active:hover{border-bottom-color:var(--colorBrandStroke2Pressed);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.fezean8:active:hover{color:var(--colorBrandForeground2Pressed);}}", {
    m: "(forced-colors: none)"
  }], ["@media (forced-colors: none){.f1yr11xb:active:hover{background-color:var(--colorBrandBackground2Pressed);}}", {
    m: "(forced-colors: none)"
  }]]
});
const useSuggestionStyles_unstable = state => {
  'use no memo';

  const styles = useSuggestionStylesStyles();
  state.root.className = mergeClasses(suggestionClassNames.root, styles.root, state.mode === 'canvas' && styles.canvas, !state.disabled && styles.enabled, state.root.className);
  return state;
};

const useSuggestion_unstable = (props, ref) => {
  const buttonState = useButton_unstable(props, ref);
  const mode = useCopilotMode(props.mode);
  return {
    ...buttonState,
    mode
  };
};

// Suggestion component - TODO: add more docs
const Suggestion = /*#__PURE__*/React.forwardRef((props, ref) => {
  'use no memo';

  const state = useSuggestion_unstable(props, ref);
  state.appearance = props.appearance || 'outline';
  useButtonStyles_unstable(state);
  useSuggestionStyles_unstable(state);
  useCustomStyleHook('useSuggestionStyles')(state);
  return renderButton_unstable(state);
});
Suggestion.displayName = 'Suggestion';

// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render SuggestionList.
 *
 * The returned state can be modified with hooks such as useSuggestionListStyles_unstable,
 * before being passed to renderSuggestionList_unstable.
 *
 * @param props - props from this instance of SuggestionList
 * @param ref - reference to root HTMLElement of SuggestionList
 */
const useSuggestionList_unstable = (props, ref) => {
  const {
    action,
    reload
  } = props;
  const ReloadIcon = bundleIcon(ArrowCounterclockwise16Filled, ArrowCounterclockwise16Regular);
  return {
    components: {
      root: 'div',
      reload: Button,
      reloadTooltip: Tooltip,
      action: 'span'
    },
    root: always(getIntrinsicElementProps('div', {
      ref,
      role: 'toolbar',
      'aria-label': 'suggestions',
      ...props,
      ...useArrowNavigationGroup({
        axis: 'both',
        circular: true
      })
    }), {
      elementType: 'div'
    }),
    reloadTooltip: optional(props.reloadTooltip, {
      defaultProps: {
        relationship: 'label',
        content: 'Reload',
        withArrow: reload !== undefined
      },
      renderByDefault: true,
      elementType: Tooltip
    }),
    reload: optional(reload, {
      defaultProps: {
        icon: /*#__PURE__*/React.createElement(ReloadIcon, null),
        size: 'small',
        appearance: 'transparent'
      },
      elementType: Button
    }),
    action: optional(action, {
      elementType: 'span'
    })
  };
};

/**
 * Render the final JSX of SuggestionList
 */
const renderSuggestionList_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [state.root.children, state.reload && state.reloadTooltip && /*#__PURE__*/jsx(state.reloadTooltip, {
      children: /*#__PURE__*/jsx(state.reload, {})
    }), state.reload && !state.reloadTooltip && /*#__PURE__*/jsx(state.reload, {}), state.action && !state.reload && /*#__PURE__*/jsx(state.action, {})]
  });
};

const suggestionListClassNames = {
  root: 'fai-SuggestionList',
  reload: 'fai-SuggestionList__reload',
  reloadTooltip: 'fai-SuggestionList__reloadTooltip',
  action: 'fai-SuggestionList__action'
};
/**
 * Styles for the root slot
 */
const useStyles$h = __styles({
  root: {
    mc9l5x: "f22iagw",
    Eh141a: "fni485r",
    Brf1p80: "f9c4gz4",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "f1yhwmi5",
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: ["f4bgq6r", "f83tq75"],
    Beptln2: "fr3gje9"
  },
  reload: {
    Bf4jedk: "f79feoa",
    B2u0y6b: "f1cs043"
  },
  action: {
    Bf4jedk: "f79feoa",
    B2u0y6b: "f1cs043"
  }
}, {
  d: [".f22iagw{display:flex;}", ".fni485r{flex-wrap:wrap;}", ".f9c4gz4{justify-content:flex-end;}", [".f1yhwmi5{gap:var(--spacingVerticalS);}", {
    p: -1
  }], [".f4bgq6r{margin:var(--spacingVerticalNone) var(--spacingHorizontalNone) var(--spacingVerticalS) var(--spacingHorizontalNone);}", {
    p: -1
  }], [".f83tq75{margin:var(--spacingVerticalNone) var(--spacingHorizontalNone) var(--spacingVerticalS) var(--spacingHorizontalNone);}", {
    p: -1
  }], ".fr3gje9>:nth-last-of-type(2){max-width:calc(100% - var(--spacingHorizontalXXL) - var(--spacingVerticalS));}", ".f79feoa{min-width:var(--spacingHorizontalXXL);}", ".f1cs043{max-width:var(--spacingHorizontalXXL);}"]
});
/**
 * Apply styling to the SuggestionList slots based on the state
 */
const useSuggestionListStyles_unstable = state => {
  'use no memo';

  const styles = useStyles$h();
  state.root.className = mergeClasses(suggestionListClassNames.root, styles.root, state.root.className);
  if (state.reload) {
    state.reload.className = mergeClasses(suggestionListClassNames.reload, styles.reload, state.reload.className);
  }
  if (state.action) {
    state.action.className = mergeClasses(suggestionListClassNames.action, styles.action, state.action.className);
  }
  return state;
};

// SuggestionList component - TODO: add more docs
const SuggestionList = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useSuggestionList_unstable(props, ref);
  useSuggestionListStyles_unstable(state);
  useCustomStyleHook('useSuggestionListStyles')(state);
  return renderSuggestionList_unstable(state);
});
SuggestionList.displayName = 'SuggestionList';

const SendIcon = bundleIcon(SendFilled, SendRegular);
/**
 * Create the state required to render Textarea.
 *
 * The returned state can be modified with hooks such as useTextareaStyles_unstable,
 * before being passed to renderTextarea_unstable.
 *
 * @param props - props from this instance of Textarea
 * @param ref - reference to primary Textarea element
 */
const useTextarea_unstable = (props, ref) => {
  const {
    characterCount,
    disabled = false,
    maxLength = 500,
    onChange,
    onSubmit,
    showCount,
    appearance = 'multi',
    disableSend = false
  } = props;
  const mode = useCopilotMode(props.mode);
  const {
    announce
  } = useAnnounce$1();
  const [hasTextareaFocus, setHasTextareaFocus] = React.useState(false);
  const [value, setValue] = useControllableState({
    state: props.value,
    defaultState: props.defaultValue,
    initialState: ''
  });
  var _value_length;
  const [count, setCount] = useControllableState({
    state: characterCount,
    initialState: (_value_length = value === null || value === undefined ? undefined : value.length) !== null && _value_length !== undefined ? _value_length : 0
  });
  const updateValue = React.useCallback(value => {
    setCount(value.length);
    setValue(value);
    // announce when the user reaches the maximum character limit
    if (maxLength && value.length >= maxLength && announce) {
      announce('Warning: reached maximum character limit');
    }
  }, [announce, maxLength, setCount, setValue]);
  const nativeProps = getPartitionedNativeProps({
    props,
    primarySlotTagName: 'textarea',
    excludedPropNames: ['onChange', 'onSubmit', 'value', 'defaultValue']
  });
  const countSlot = (showCount !== null && showCount !== undefined ? showCount : maxLength && mode === 'canvas') ? optional(props.count, {
    defaultProps: {
      children: `${count} / ${maxLength}`
    },
    elementType: 'span',
    renderByDefault: true
  }) : undefined;
  const isSendDisabled = disableSend && !disabled;
  const state = {
    appearance,
    components: {
      root: 'div',
      textarea: 'textarea',
      count: 'span',
      contentAfter: 'span',
      send: Button
    },
    root: always(props.root, {
      elementType: 'div',
      defaultProps: nativeProps.root
    }),
    textarea: always(props.textarea, {
      defaultProps: {
        ref,
        maxLength,
        ...nativeProps.primary
      },
      elementType: 'textarea'
    }),
    count: countSlot,
    contentAfter: always(props.contentAfter, {
      elementType: 'span'
    }),
    send: optional(props.send, {
      defaultProps: {
        appearance: 'transparent',
        disabled: isSendDisabled,
        disabledFocusable: isSendDisabled ? true : undefined,
        icon: /*#__PURE__*/React.createElement(SendIcon, null),
        'aria-disabled': isSendDisabled ? true : undefined,
        'aria-label': 'Send',
        type: 'submit',
        tabIndex: isSendDisabled ? -1 : undefined
      },
      elementType: Button,
      renderByDefault: true
    }),
    disabled,
    hasTextareaFocus,
    mode,
    disableSend
  };
  if (state.appearance === 'single') {
    state.textarea.rows = 1;
  }
  state.textarea.value = value;
  state.textarea.onChange = useEventCallback(ev => {
    const newValue = ev.target.value;
    onChange === null || onChange === undefined ? undefined : onChange(ev, {
      value: newValue
    });
    updateValue(newValue);
  });
  // Check if the textarea slot is overridden with a function. If it is, we won't implement auto-grow behavior for the textarea
  if (typeof props.textarea !== 'function') {
    // set data-value here, since it will not be included in resolveShorthand
    // this is used to set the height of the textarea
    // 1275 is the number of characters needed to reach the max height, using the smallest character ("i")
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state.root['data-value'] = value === null || value === undefined ? undefined : value.substring(0, 1275);
  }
  // detect when focus is in the textarea slot in order to apply the focus style
  // this is slightly more flexible than a CSS selector, since it allows the <textarea> to be replaced
  const {
    onFocus,
    onBlur
  } = state.textarea;
  state.textarea.onFocus = useEventCallback(mergeCallbacks(onFocus, () => {
    setHasTextareaFocus(true);
  }));
  state.textarea.onBlur = useEventCallback(mergeCallbacks(onBlur, () => {
    setHasTextareaFocus(false);
  }));
  // Submit the form when the send button is clicked, or on ctrl+enter/cmd+enter in the textarea
  const {
    onKeyDown
  } = state.textarea;
  state.textarea.onKeyDown = useEventCallback(mergeCallbacks(onKeyDown, ev => {
    const {
      key,
      shiftKey
    } = ev;
    if (!shiftKey && key === Enter && disableSend === false) {
      onSubmit === null || onSubmit === undefined ? undefined : onSubmit(ev, {
        value
      });
      ev.preventDefault();
    }
  }));
  const {
    onClick
  } = state.send || {};
  const onSendClick = useEventCallback(mergeCallbacks(onClick, ev => {
    if (disableSend) {
      ev.preventDefault();
    }
    onSubmit === null || onSubmit === undefined ? undefined : onSubmit(ev, {
      value
    });
  }));
  if (state.send) {
    state.send.onClick = onSendClick;
  }
  return state;
};

/**
 * Render the final JSX of Textarea
 */
const renderTextarea_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/jsxs(state.root, {
    children: [/*#__PURE__*/jsx(state.textarea, {}), state.count && state.appearance !== 'single' ? /*#__PURE__*/jsx(state.count, {}) : null, /*#__PURE__*/jsxs(state.contentAfter, {
      children: [state.contentAfter.children, state.send && /*#__PURE__*/jsx(state.send, {})]
    })]
  });
};

const textareaClassNames = {
  root: 'fai-Textarea',
  textarea: 'fai-Textarea__textarea',
  count: 'fai-Textarea__count',
  contentAfter: 'fai-Textarea__contentAfter',
  send: 'fai-Textarea__send'
};
/**
 * Base classname with makeResetStyles
 */
const useRootClassName = __resetStyles("r9dgl1y", "r1f7xsp8", {
  r: [".r9dgl1y{box-sizing:border-box;display:grid;justify-items:start;gap:var(--spacingVerticalS);background-color:var(--colorNeutralBackground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);border-radius:var(--borderRadiusLarge);position:relative;margin:0;max-width:720px;}", ".r9dgl1y::before{box-sizing:border-box;content:attr(data-value) ' ';grid-area:input;overflow:scroll;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);visibility:hidden;white-space:pre-wrap;justify-self:stretch;margin-right:var(--spacingHorizontalXS);margin-left:var(--spacingHorizontalXS);}", ".r9dgl1y::after{box-sizing:border-box;content:\"\";position:absolute;left:-1px;bottom:-1px;right:-1px;height:var(--borderRadiusLarge);border-bottom-left-radius:var(--borderRadiusLarge);border-bottom-right-radius:var(--borderRadiusLarge);border-bottom:var(--strokeWidthThick) solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - var(--strokeWidthThick)) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}", ".r1f7xsp8{box-sizing:border-box;display:grid;justify-items:start;gap:var(--spacingVerticalS);background-color:var(--colorNeutralBackground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);border-radius:var(--borderRadiusLarge);position:relative;margin:0;max-width:720px;}", ".r1f7xsp8::before{box-sizing:border-box;content:attr(data-value) ' ';grid-area:input;overflow:scroll;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);visibility:hidden;white-space:pre-wrap;justify-self:stretch;margin-left:var(--spacingHorizontalXS);margin-right:var(--spacingHorizontalXS);}", ".r1f7xsp8::after{box-sizing:border-box;content:\"\";position:absolute;right:-1px;bottom:-1px;left:-1px;height:var(--borderRadiusLarge);border-bottom-right-radius:var(--borderRadiusLarge);border-bottom-left-radius:var(--borderRadiusLarge);border-bottom:var(--strokeWidthThick) solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - var(--strokeWidthThick)) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}"],
  s: ["@media screen and (prefers-reduced-motion: reduce){.r9dgl1y::after{transition-duration:0.01ms;transition-delay:0.01ms;}}", "@media screen and (prefers-reduced-motion: reduce){.r1f7xsp8::after{transition-duration:0.01ms;transition-delay:0.01ms;}}"]
});
/**
 * Textarea classname with makeResetStyles
 */
const useTextareaClassName = __resetStyles("r143pavp", null, [".r143pavp{border-style:none;margin:0;background-color:transparent;box-sizing:border-box;color:var(--colorNeutralForeground1);grid-area:input;outline-style:none;overflow-y:auto;padding:0;resize:none;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);justify-self:stretch;}", ".r143pavp::-webkit-input-placeholder{color:var(--colorNeutralForeground4);opacity:1;}", ".r143pavp::-moz-placeholder{color:var(--colorNeutralForeground4);opacity:1;}", ".r143pavp::placeholder{color:var(--colorNeutralForeground4);opacity:1;}", ".r143pavp::selection{color:var(--colorNeutralForegroundInverted);background-color:var(--colorNeutralBackgroundInverted);}"]);
/**
 * Slot styles
 */
const useStyles$g = __styles({
  canvas: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: ["f1o5x5nw", "f14lg2cn"],
    zkzzav: "f1rudd1n",
    Bbdr6tz: "ffvxoe4"
  },
  sidecar: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: ["f1o5x5nw", "f14lg2cn"],
    zkzzav: "f18edmzq",
    Bbdr6tz: "f6inzf1"
  },
  single: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fm5eomj",
    wkccdc: "f1u7ey36",
    Budl1dq: "fz17x9o",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "faqewft",
    zoa1oz: "fowb98k",
    Br0sdwz: "fjookjo"
  },
  multi: {
    wkccdc: "f1y0tuzo",
    Budl1dq: "f1ea4fvb",
    zoa1oz: "fw1q1kl"
  },
  focus: {
    b1kco5: "f16t1kdf",
    Ba2ppi3: "fhwpy7i",
    F2fol1: "f15cmg8x",
    lck23g: "f491wbe",
    wi16st: "fsrmcvb",
    ywj3b2: "f1t3k7v9",
    jgq6uv: "f73i0vf"
  },
  interactive: {
    Bgoe8wy: "fvcxoqz",
    Bwzppfd: ["f1ub3y4t", "f1m52nbi"],
    oetu4i: "f1xlaoq0",
    gg5e9n: ["f1m52nbi", "f1ub3y4t"],
    B6oc9vd: "fvs00aa",
    ak43y8: ["f1assf6x", "f4ruux4"],
    wmxk5l: "fumykes",
    B50zh58: ["f4ruux4", "f1assf6x"]
  },
  disabled: {
    De3pzq: "f1c21dwh",
    B4j52fo: "f192inf7",
    Bekrc4i: ["f5tn483", "f1ojsxk5"],
    Bn0qgzm: "f1vxd6vx",
    ibv6hh: ["f1ojsxk5", "f5tn483"],
    icvyot: "fzkkow9",
    vrafjx: ["fcdblym", "fjik90z"],
    oivjwe: "fg706s2",
    wvpqe5: ["fjik90z", "fcdblym"],
    g2u3we: "f1jj8ep1",
    h3c5rm: ["f15xbau", "fy0fskl"],
    B9xav0g: "f4ikngz",
    zhjwy3: ["fy0fskl", "f15xbau"],
    Bcq6wej: "f9dbb4x",
    Jcjdmf: ["f3qs60o", "f5u9ap2"],
    sc4o1m: "fwd1oij",
    Bosien3: ["f5u9ap2", "f3qs60o"]
  },
  disabledCount: {
    sj55zd: "f1s2aq7o"
  },
  count: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "fhw3785",
    qb2dma: "f7nlbp4",
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "f1t35pdg",
    sj55zd: "fxc4j92",
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "figsok6",
    Bg96gwp: "fcpl73t"
  },
  contentAfter: {
    Bw0ie65: 0,
    Br312pm: 0,
    nk6f5a: 0,
    Ijaq50: 0,
    Bq1tomu: "fceb517",
    B7ck84d: "f1ewtqcl",
    mc9l5x: "f22iagw",
    Eh141a: "fni485r",
    a9b677: "fly5x3f",
    Brf1p80: "f9c4gz4"
  },
  send: {}
}, {
  d: [[".f1o5x5nw{padding:var(--spacingVerticalM) var(--spacingHorizontalS) var(--spacingVerticalSNudge) var(--spacingHorizontalS);}", {
    p: -1
  }], [".f14lg2cn{padding:var(--spacingVerticalM) var(--spacingHorizontalS) var(--spacingVerticalSNudge) var(--spacingHorizontalS);}", {
    p: -1
  }], ".f1rudd1n::before{min-height:32px;}", ".ffvxoe4::before{max-height:172px;}", [".f1o5x5nw{padding:var(--spacingVerticalM) var(--spacingHorizontalS) var(--spacingVerticalSNudge) var(--spacingHorizontalS);}", {
    p: -1
  }], [".f14lg2cn{padding:var(--spacingVerticalM) var(--spacingHorizontalS) var(--spacingVerticalSNudge) var(--spacingHorizontalS);}", {
    p: -1
  }], ".f18edmzq::before{min-height:20px;}", ".f6inzf1::before{max-height:192px;}", [".fm5eomj{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalS);}", {
    p: -1
  }], ".f1u7ey36{grid-template-rows:1fr;}", ".fz17x9o{grid-template-columns:1fr auto;}", [".faqewft{gap:var(--spacingHorizontalS);}", {
    p: -1
  }], ".fowb98k{grid-template-areas:\"input actions\";}", ".fjookjo::before{display:none;}", ".f1y0tuzo{grid-template-rows:1fr auto;}", ".f1ea4fvb{grid-template-columns:auto auto;}", ".fw1q1kl{grid-template-areas:\"input input\" \"count actions\";}", ".f16t1kdf::after{transform:scaleX(1);}", ".fhwpy7i::after{transition-property:transform;}", ".f15cmg8x::after{transition-duration:var(--durationNormal);}", ".f491wbe::after{transition-delay:var(--curveDecelerateMid);}", ".f1c21dwh{background-color:var(--colorTransparentBackground);}", ".f192inf7{border-top-width:var(--strokeWidthThin);}", ".f5tn483{border-right-width:var(--strokeWidthThin);}", ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}", ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}", ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}", ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}", ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}", [".fhw3785{grid-area:count;}", {
    p: -1
  }], ".f7nlbp4{align-self:center;}", [".f1t35pdg{padding:var(--spacingHorizontalXS);}", {
    p: -1
  }], ".fxc4j92{color:var(--colorNeutralForeground4);}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", [".fceb517{grid-area:actions;}", {
    p: -1
  }], ".f1ewtqcl{box-sizing:border-box;}", ".f22iagw{display:flex;}", ".fni485r{flex-wrap:wrap;}", ".fly5x3f{width:100%;}", ".f9c4gz4{justify-content:flex-end;}"],
  m: [["@media screen and (prefers-reduced-motion: reduce){.fsrmcvb::after{transition-duration:0.01ms;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.f1t3k7v9::after{transition-delay:0.01ms;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }], ["@media (forced-colors: active){.f9dbb4x{border-top-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f3qs60o{border-right-color:GrayText;}.f5u9ap2{border-left-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }], ["@media (forced-colors: active){.fwd1oij{border-bottom-color:GrayText;}}", {
    m: "(forced-colors: active)"
  }]],
  a: [".f73i0vf:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}", ".fvs00aa:active{border-top-color:var(--colorNeutralStroke1Pressed);}", ".f1assf6x:active{border-right-color:var(--colorNeutralStroke1Pressed);}", ".f4ruux4:active{border-left-color:var(--colorNeutralStroke1Pressed);}", ".fumykes:active{border-bottom-color:var(--colorNeutralStroke1Pressed);}"],
  h: [".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}", ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}", ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}", ".f1xlaoq0:hover{border-bottom-color:var(--colorNeutralStroke1Hover);}"]
});
const useTextareaStyles = __styles({
  disabled: {
    Bceei9c: "fdrzuqr",
    yvdlaj: "fahhnxm"
  },
  canvas: {
    sshi5w: "f1nxs5xn",
    Bxyxcbc: "f1bviyq2",
    t21cq0: ["fm0x6gh", "fbyavb5"],
    Frg6f3: ["fbyavb5", "fm0x6gh"]
  },
  sidecar: {
    sshi5w: "f16gbxbe",
    Bxyxcbc: "f7sc4q2",
    t21cq0: ["fm0x6gh", "fbyavb5"],
    Frg6f3: ["fbyavb5", "fm0x6gh"]
  },
  single: {
    z8tnut: "fp2oml8",
    Byoj8tv: "f1tdddsa",
    Bmxbyg5: "f1sil6mw",
    B68tc82: "f1p9o1ba",
    Huce71: "fz5stix"
  }
}, {
  d: [".fdrzuqr{cursor:not-allowed;}", ".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}", ".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}", ".f1nxs5xn{min-height:32px;}", ".f1bviyq2{max-height:172px;}", ".fm0x6gh{margin-right:var(--spacingHorizontalXS);}", ".fbyavb5{margin-left:var(--spacingHorizontalXS);}", ".f16gbxbe{min-height:20px;}", ".f7sc4q2{max-height:192px;}", ".fp2oml8{padding-top:var(--spacingVerticalSNudge);}", ".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}", ".f1sil6mw{overflow-y:hidden;}", ".f1p9o1ba{overflow-x:hidden;}", ".fz5stix{white-space:nowrap;}"]
});
/**
 * Apply styling to the Textarea slots based on the state
 */
const useTextareaStyles_unstable = state => {
  'use no memo';

  const {
    disabled,
    hasTextareaFocus,
    mode,
    appearance
  } = state;
  const rootClassName = useRootClassName();
  const textareaClassName = useTextareaClassName();
  const styles = useStyles$g();
  const textareaStyles = useTextareaStyles();
  state.root.className = mergeClasses(textareaClassNames.root, rootClassName, styles[mode], styles[appearance], disabled && styles.disabled, !disabled && styles.interactive, hasTextareaFocus && styles.focus, state.root.className);
  state.textarea.className = mergeClasses(textareaClassNames.textarea, textareaClassName, textareaStyles[mode], disabled && textareaStyles.disabled, appearance === 'single' && textareaStyles.single, state.textarea.className);
  if (state.count) {
    state.count.className = mergeClasses(textareaClassNames.count, styles.count, disabled && styles.disabledCount, state.count.className);
  }
  if (state.contentAfter) {
    state.contentAfter.className = mergeClasses(textareaClassNames.contentAfter, styles.contentAfter, state.contentAfter.className);
  }
  if (state.send) {
    state.send.className = mergeClasses(textareaClassNames.send, styles.send, state.send.className);
  }
  return state;
};

const Textarea = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useTextarea_unstable(props, ref);
  useTextareaStyles_unstable(state);
  useCustomStyleHook('useTextareaStyles')(state);
  return renderTextarea_unstable(state);
});
Textarea.displayName = 'Textarea';

const useStyles$f = makeStyles({
  card: {
    rowGap: tokens$2.spacingHorizontalM
  },
  prompts: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens$2.spacingHorizontalS
  },
  promptHighlight: {
    color: tokens$2.colorBrandForegroundLink
  }
});
const WelcomePrompt = () => {
  useStyles$f();
  const userInfo = useSelector((state) => state.user);
  const configInfo = useSelector((state) => state.config.config);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    configInfo?.isUserNameVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs(Body1, { children: [
      "Hi ",
      userInfo.user,
      ","
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Body1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { dangerouslySetInnerHTML: { __html: configInfo.botWelcomeMessage } }) })
  ] });
};

const useStyles$e = makeStyles({
  card: {
    rowGap: tokens$2.spacingHorizontalM,
    marginLeft: "5px",
    marginRight: "5px",
    marginTop: "10px"
  },
  prompts: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens$2.spacingHorizontalS
  },
  promptHighlight: {
    color: tokens$2.colorBrandForegroundLink
  }
});
const SuggestionPrompt = ({
  prompts = [],
  onPromptSelected,
  trackCustomEvents
}) => {
  const styles = useStyles$e();
  const config = useSelector((state) => state.config.config);
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  const onClickPrompt = (prompt) => {
    onPromptSelected?.(prompt);
    trackCopilotEvent("Default Prompt Selected", prompt, trackCustomEvents, config);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CopilotMessage, { className: styles.card, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WelcomePrompt, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.prompts, children: prompts.map((prompt, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      PromptStarter,
      {
        prompt: /* @__PURE__ */ jsxRuntimeExports.jsx(Body1, { children: prompt }),
        onClick: () => onClickPrompt(prompt)
      },
      `prompt-${i}`
    )) })
  ] });
};

const changetopicWhite = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.9412%209.47059C17.9412%204.79241%2014.1488%201%209.47059%201C4.79241%201%201%204.79241%201%209.47059L1.00781%209.83726L1.03468%2010.2417C1.13164%2011.3153%201.43052%2012.3491%201.91238%2013.2986L1.97941%2013.4253L1.01581%2017.2833L1.00121%2017.372L1.00139%2017.4581C1.02776%2017.7685%201.32958%2018.0074%201.65762%2017.9254L5.51694%2016.9618L5.64473%2017.0298C6.8192%2017.6254%208.12248%2017.9412%209.47059%2017.9412C9.56059%2017.9412%209.65016%2017.9398%209.73942%2017.9369C9.46943%2017.6094%209.23453%2017.2519%209.04051%2016.8701C7.90742%2016.8053%206.82108%2016.485%205.84625%2015.9374L5.75444%2015.8967L5.65748%2015.8742C5.59172%2015.8655%205.52429%2015.869%205.45875%2015.8853L2.25682%2016.6833L3.05702%2013.4848L3.07203%2013.3854C3.07752%2013.2855%203.0546%2013.1854%203.0049%2013.097C2.38763%2011.9988%202.05882%2010.7592%202.05882%209.47059C2.05882%205.37719%205.37719%202.05882%209.47059%202.05882C13.4196%202.05882%2016.6473%205.14725%2016.8701%209.04049C17.2519%209.23453%2017.6094%209.46943%2017.9369%209.73942C17.9398%209.65016%2017.9412%209.56059%2017.9412%209.47059ZM19%2014.2353C19%2016.8668%2016.8668%2019%2014.2353%2019C11.6038%2019%209.47059%2016.8668%209.47059%2014.2353C9.47059%2011.6038%2011.6038%209.47059%2014.2353%209.47059C16.8668%209.47059%2019%2011.6038%2019%2014.2353ZM14.8571%2014.1429H16.6429C16.84%2014.1429%2017%2014.3029%2017%2014.5C17%2014.6971%2016.84%2014.8571%2016.6429%2014.8571H14.8571V16.6429C14.8571%2016.84%2014.6971%2017%2014.5%2017C14.3029%2017%2014.1429%2016.84%2014.1429%2016.6429V14.8571H12.3571C12.16%2014.8571%2012%2014.6971%2012%2014.5C12%2014.3029%2012.16%2014.1429%2012.3571%2014.1429H14.1429V12.3571C14.1429%2012.16%2014.3029%2012%2014.5%2012C14.6971%2012%2014.8571%2012.16%2014.8571%2012.3571V14.1429Z'%20fill='%23fff'%20stroke-width='2'/%3e%3c/svg%3e";

const changetopicBlack = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%202C17.5228%202%2022%206.47715%2022%2012C22%2012.2628%2021.9899%2012.5232%2021.97%2012.7809C21.5319%2012.3658%2021.0361%2012.0111%2020.4958%2011.73C20.3532%207.16054%2016.6041%203.5%2012%203.5C7.30558%203.5%203.5%207.30558%203.5%2012C3.5%2013.4696%203.87277%2014.8834%204.57303%2016.1375L4.72368%2016.4072L3.61096%2020.3914L7.59755%2019.2792L7.86709%2019.4295C9.04305%2020.0852%2010.3592%2020.4531%2011.73%2020.4958C12.0111%2021.0361%2012.3658%2021.5319%2012.7809%2021.97C12.5232%2021.9899%2012.2628%2022%2012%2022C10.3817%2022%208.81782%2021.6146%207.41286%2020.888L3.58704%2021.9553C2.92212%2022.141%202.23258%2021.7525%202.04691%2021.0876C1.98546%2020.8676%201.98549%2020.6349%202.04695%2020.4151L3.11461%2016.5922C2.38637%2015.186%202%2013.6203%202%2012C2%206.47715%206.47715%202%2012%202ZM23%2017.5C23%2014.4624%2020.5376%2012%2017.5%2012C14.4624%2012%2012%2014.4624%2012%2017.5C12%2020.5376%2014.4624%2023%2017.5%2023C20.5376%2023%2023%2020.5376%2023%2017.5ZM18.0006%2018L18.0011%2020.5035C18.0011%2020.7797%2017.7773%2021.0035%2017.5011%2021.0035C17.225%2021.0035%2017.0011%2020.7797%2017.0011%2020.5035L17.0006%2018H14.4956C14.2197%2018%2013.9961%2017.7762%2013.9961%2017.5C13.9961%2017.2239%2014.2197%2017%2014.4956%2017H17.0005L17%2014.4993C17%2014.2231%2017.2239%2013.9993%2017.5%2013.9993C17.7761%2013.9993%2018%2014.2231%2018%2014.4993L18.0005%2017H20.4966C20.7725%2017%2020.9961%2017.2239%2020.9961%2017.5C20.9961%2017.7762%2020.7725%2018%2020.4966%2018H18.0006Z'%3e%3c/path%3e%3c/svg%3e";

const useStyles$d = makeStyles({
  card: {
    rowGap: tokens$2.spacingHorizontalM,
    marginLeft: "5px",
    marginRight: "5px",
    marginTop: "0px",
    backgroundColor: "#fff"
  },
  prompts: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens$2.spacingHorizontalS
  },
  promptHighlight: {
    color: tokens$2.colorBrandForegroundLink
  }
});
const SuggestionPopUp = ({ prompts = [], onPromptSelected, SetTextareaChatValue, setCount, SetShowChangeTopic }) => {
  const styles = useStyles$d();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const firstPromptRef = useRef(null);
  useEffect(() => {
    if (firstPromptRef.current) {
      firstPromptRef.current.focus();
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isModalOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    CopilotMessage,
    {
      className: styles.card,
      style: {
        maxWidth: "none",
        marginLeft: "0px",
        marginRight: "35px",
        border: "2px solid darkgrey"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.prompts, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { color: "grey", marginTop: "4px", marginBottom: "2px" }, children: "Related search topics on this page" }),
        prompts.map((promp, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          PromptStarter,
          {
            onClick: () => {
              setIsModalOpen(false);
              SetTextareaChatValue(promp);
              setCount(promp.length);
              SetShowChangeTopic(true);
            },
            onKeyDown: (event) => {
              if (event.key === "Enter" || event.key === " ") {
                setIsModalOpen(false);
                SetTextareaChatValue(promp);
                setCount(promp.length);
                SetShowChangeTopic(true);
              }
            },
            prompt: /* @__PURE__ */ jsxRuntimeExports.jsx(Body1, { children: promp })
          },
          `prompt-${i}`
        ))
      ] })
    }
  ) });
};

const get = {
	"api/Configuration": {
		ApplicationName: "Delivery Copilot",
		BotWelcomeMessage: "Hello! How can I assist you today?",
		IsCopyButtonVisible: "true",
		IsCreateIncidentButtonVisible: "true",
		IsToggleVisible: "false",
		IsTypewritingOn: "false",
		IsVersionVisible: "false",
		ShowSuggestionPopup: "true",
		SuggestionPopupCharacterThreshold: "5",
		SuggestionPopupCount: "6",
		TextBoxLength: "4000",
		VirtuosoCopilotErrorMessage: "Sorry the Delivery Copilot service is down right now. Please try again later.",
		appName: "Delivery Copilot",
		createIncidentButtonText: "Create a Support Ticket",
		isPanelVisible: "true"
	}
};
const post = {
	"/api/VwwCopilot/AutoSuggestion": [
		"How is the report emailed directly from virtuoso?",
		"What does the virtuoso meta data dashboard provide?",
		"What is the contact for virtuoso issues?",
		"Who is responsible for ensuring the timely submission of the ppv form in virtuoso?",
		"What are the virtuoso kpis used for in the enhanced application support (eas) project?"
	],
	"/api/VwwCopilot/SuggestQuestions": [
		{
			suggestion: "What is the role of virtuoso in risk management?",
			relevence: 0.8132985234260559,
			roles: [
				"Project manager"
			],
			tags: [
				"#tag3",
				"#tag7"
			],
			features: [
				"RiskManagement"
			],
			sourceSystem: [
				"SDM"
			],
			question: null
		},
		{
			suggestion: "What is the role of virtuoso in the risk management process?",
			relevence: 0.8090691566467285,
			roles: [
				"Project manager"
			],
			tags: [
				"#tag1",
				"#tag6"
			],
			features: [
				"Risk Management"
			],
			sourceSystem: [
				"SDM"
			],
			question: null
		},
		{
			suggestion: "What does the virtuoso project team provide an overview of?",
			relevence: 0.7899513244628906,
			roles: [
				"PM",
				"CDL"
			],
			tags: [
				"#tag1",
				"#tag6"
			],
			features: [
				"ISD Key Reports"
			],
			sourceSystem: [
				"SDM"
			],
			question: null
		},
		{
			suggestion: "What does the virtuoso meta data provide?",
			relevence: 0.7823355197906494,
			roles: [
				"PM",
				"CDL"
			],
			tags: [
				"#tag1",
				"#tag6"
			],
			features: [
				"ISD Key Reports"
			],
			sourceSystem: [
				"SDM"
			],
			question: null
		},
		{
			suggestion: "What is the definition of a program in the context of virtuoso?",
			relevence: 0.7822262644767761,
			roles: [
				"PM",
				"CDL"
			],
			tags: [
				"#tag3",
				"#tag7"
			],
			features: [
				"Program Management Principles"
			],
			sourceSystem: [
				"SDM"
			],
			question: null
		}
	],
	"/api/VwwCopilot/Question": {
		text: {
			conversationId: null,
			question: "What is cost overrun and how does it account for Risk reserve?",
			responseType: "text",
			source: "cloudgpt",
			data: "{\"reply\":\"Cost overrun is a situation where the actual cost of a project exceeds the planned cost. In terms of risk reserve, projects are marked as Overrun where Actual Cost > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Cost Overrun is the overrun beyond Risk Reserve Usage. You can refer to Domain Delivery Insights - Domain_Delivery_Insights - Power BI (Financials YTD Cost Overrun and RR) for further details. \",\"id\":\"896d6acc-4295-45cc-8bec-06693f0ac982\",\"messages\":\"[\\r\\n  {\\r\\n    \\\"role\\\": \\\"assistant\\\",\\r\\n    \\\"type\\\": \\\"text\\\",\\r\\n    \\\"content\\\": \\\"Cost overrun is a situation where the actual cost of a project exceeds the planned cost. In terms of risk reserve, projects are marked as Overrun where Actual Cost > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Cost Overrun is the overrun beyond Risk Reserve Usage. You can refer to Domain Delivery Insights - Domain_Delivery_Insights - Power BI (Financials YTD Cost Overrun and RR) for further details. \\\"\\r\\n  }\\r\\n]\",\"conversationId\":\"896d6acc-4295-45cc-8bec-06693f0ac982\",\"docs\":\"{\\r\\n  \\\"docs\\\": [\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" do you determine if practices were followed?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"The LED Adherence tab of Domain Delivery Insights (Domain_Delivery_Insights - Power BI) provides details about the adoption of DevOps foundation practices.Please refer to [Foundation Adoption - Overview (azure.com)](https://dev.azure.com/servicesdocs/DevOps/_wiki/wikis/LED%20Adherence/11419/LED-Adherenceanchor=projects-not-considered-for-led-(not-considered)) for further details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are risk reserves accounted for Projected Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Projects are marked as Overrun where Planned Cost (CFP Cost) > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Projected Cost Overrun is the overrun beyond projected Risk Reserve Usage.Refer to [Domain Delivery Insights](https://msit.powerbi.com/groups/me/reports/7f40738b-1eef-43fd-80e0-15b965b93d16/ReportSection2537019904b37d5e0d09) for further details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"Regarding Projected Cost Overrun - How are risk reserves accounted for?\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How does the NPS metric take into account multiple surveys of one customer?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"We do not average or do anything unique per account.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How does our NPS metric compare to others in the industry?\\\\\\\",\\\\n NPS.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 7527,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          7523,\\r\\n          7524,\\r\\n          7525,\\r\\n          7526,\\r\\n          7527,\\r\\n          7528,\\r\\n          7529,\\r\\n          7530,\\r\\n          7531\\r\\n        ],\\r\\n        \\\"token_size\\\": 497,\\r\\n        \\\"score\\\": \\\"0.7558571\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Is ISD always what we communicate externally?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"For the time being, yes.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Regarding YTD Actual Cost Overrun - How far back to you go in terms of years?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"It only takes into account the projects with delivery completed in the current fiscal year.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are risk reserves accounted for YTD Actual Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Projects are marked as Overrun where Actual Cost > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Cost Overrun is the overrun beyond Risk Reserve Usage. Refer to Domain Delivery Insights - Domain_Delivery_Insights - Power BI  (Financials – YTD Cost Overrun and RR)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"Regarding YTD Actual Cost Overrun - How are risk reserves accounted for?\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are amendments counted for YTD Actual Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Finances are at all up-level taking into account all Amendments. Cost Overrun is calculated at an Engagement level (includes base contract + All Amendments) and for a Portfolio of Engagements.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n I have no access to the data in our TZ DV report. I have the link, but how do I get access?\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 7603,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          7598,\\r\\n          7599,\\r\\n          7600,\\r\\n          7601,\\r\\n          7602,\\r\\n          7603,\\r\\n          7604,\\r\\n          7605,\\r\\n          7606,\\r\\n          7607,\\r\\n          7608\\r\\n        ],\\r\\n        \\\"token_size\\\": 486,\\r\\n        \\\"score\\\": \\\"0.75530696\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Regarding LED Adherence (as part of the DHI metric) - How do you determine if practices were followed?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"The LED Adherence tab of Domain Delivery Insights (Domain_Delivery_Insights - Power BI) provides details about the adoption of DevOps foundation practices.Please refer to [Foundation Adoption - Overview (azure.com)](https://dev.azure.com/servicesdocs/DevOps/_wiki/wikis/LED%20Adherence/11419/LED-Adherenceanchor=projects-not-considered-for-led-(not-considered)) for further details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are risk reserves accounted for Projected Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Projects are marked as Overrun where Planned Cost (CFP Cost) > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Projected Cost Overrun is the overrun beyond projected Risk Reserve Usage.Refer to [Domain Delivery Insights](https://msit.powerbi.com/groups/me/reports/7f40738b-1eef-43fd-80e0-15b965b93d16/ReportSection2537019904b37d5e0d09) for further details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"Regarding Projected Cost Overrun - How are risk reserves accounted for?\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How does the NPS metric take into account multiple surveys of one customer?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"We do not average or do anything unique per account.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How does our NPS metric compare to others in the industry?\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 7526,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          7522,\\r\\n          7523,\\r\\n          7524,\\r\\n          7525,\\r\\n          7526,\\r\\n          7527,\\r\\n          7528,\\r\\n          7529,\\r\\n          7530\\r\\n        ],\\r\\n        \\\"token_size\\\": 462,\\r\\n        \\\"score\\\": \\\"0.7419146\\\"\\r\\n      }\\r\\n    }\\r\\n  ],\\r\\n  \\\"metadata\\\": {\\r\\n    \\\"processingMode\\\": \\\"default\\\",\\r\\n    \\\"precessingStatus\\\": \\\"\\\",\\r\\n    \\\"query\\\": \\\"What is cost overrun and how does it account for Risk reserve?\\\"\\r\\n  },\\r\\n  \\\"latency\\\": 270\\r\\n}\",\"parentId\":\"896d6acc-4295-45cc-8bec-06693f0ac982\",\"intent\":\"cloudgpt\"}"
		},
		markdown: {
			conversationId: null,
			question: "what is cost overrun. show me in markdown formatted table",
			responseType: "markdown",
			source: "cloudgpt",
			data: "{\"reply\":\"Cost overrun is the difference between the actual cost of a project and the budgeted or planned cost. Here is a markdown formatted table to show how cost overrun is calculated for YTD Actual Cost Overrun:\\n\\n| Calculation | Description |\\n| --- | --- |\\n| Actual Cost | The total cost incurred for the project to date |\\n| Sold Cost | The total cost sold to the customer for the project to date, including the overall allocated risk reserve |\\n| Risk Reserve Usage | The amount of the risk reserve that has been used to cover project costs |\\n| Cost Overrun | The difference between Actual Cost and Sold Cost, minus Risk Reserve Usage |\\n\\nI hope this helps! Let me know if you have any other questions.\",\"id\":\"3a0e04c8-6e2a-40bc-a7d8-7084e40f6ede\",\"messages\":\"[\\r\\n  {\\r\\n    \\\"role\\\": \\\"assistant\\\",\\r\\n    \\\"type\\\": \\\"text\\\",\\r\\n    \\\"content\\\": \\\"Cost overrun is the difference between the actual cost of a project and the budgeted or planned cost. Here is a markdown formatted table to show how cost overrun is calculated for YTD Actual Cost Overrun:\\\\n\\\\n| Calculation | Description |\\\\n| --- | --- |\\\\n| Actual Cost | The total cost incurred for the project to date |\\\\n| Sold Cost | The total cost sold to the customer for the project to date, including the overall allocated risk reserve |\\\\n| Risk Reserve Usage | The amount of the risk reserve that has been used to cover project costs |\\\\n| Cost Overrun | The difference between Actual Cost and Sold Cost, minus Risk Reserve Usage |\\\\n\\\\nI hope this helps! Let me know if you have any other questions.\\\"\\r\\n  }\\r\\n]\",\"conversationId\":\"3a0e04c8-6e2a-40bc-a7d8-7084e40f6ede\",\"docs\":\"{\\r\\n  \\\"docs\\\": [\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are risk reserves accounted for YTD Actual Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Projects are marked as Overrun where Actual Cost > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Cost Overrun is the overrun beyond Risk Reserve Usage. Refer to Domain Delivery Insights - Domain_Delivery_Insights - Power BI  (Financials – YTD Cost Overrun and RR)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"Regarding YTD Actual Cost Overrun - How are risk reserves accounted for?\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are amendments counted for YTD Actual Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Finances are at all up-level taking into account all Amendments. Cost Overrun is calculated at an Engagement level (includes base contract + All Amendments) and for a Portfolio of Engagements.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Currently, I have no access to the data in our TZ DV report. I have the link, but how do I get access?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"On the cover page is a link to '3 steps access'.. https://microsoft.sharepoint.com/teams/ServicesInsights/SitePages/How-To-Get-Access.aspx\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Why are Opportunities not visible in CompassOne?\\\\\\\",\\\\n  \\\\\\\"Answer\\\\\\\": \\\\\\\"Please check if the Opportunity has a price level or the associated licensing program is updated correctly. These fields should be updated in MSX to proceed with this request.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 7606,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          7601,\\r\\n          7602,\\r\\n          7603,\\r\\n          7604,\\r\\n          7605,\\r\\n          7606,\\r\\n          7607,\\r\\n          7608,\\r\\n          7609,\\r\\n          7610,\\r\\n          7611\\r\\n        ],\\r\\n        \\\"token_size\\\": 463,\\r\\n        \\\"score\\\": \\\"0.5813993\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"/_wiki/wikis/LED%20Adherence/11419/LED-Adherenceanchor=projects-not-considered-for-led-(not-considered)).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Regarding YTD Actual Cost Overrun - Are these only current year projects that are closed?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Yes, considers all projects with delivery complete in the current fiscal year where Actual Cost  > Sold Cost.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are amendments counted for Projected Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Finances are at all up-level taking into account all Amendments. Cost Overrun is calculated at an Engagement level (includes base contract + All Amendments) and for a Portfolio of Engagements.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Regarding Projected Cost Overrun - If a project goes inactive, how does this affect the metric?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Only \\\\\\\\\\\\\\\"Active\\\\\\\\\\\\\\\" projects are accounted for in this metric. Closed, On-Hold, and Technically Complete projects are excluded from this metric. Any Overrun on Closed and Technically Complete projects will be reported under YTD Actual Cost Overrun.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Regarding % Portfolio Under Stress - Are there any projects excluded from this?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Excludes Projects that are not “Active”, and projects with project category \\\\\\\\\\\\\\\"Business As Usual\\\\\\\\\\\\\\\"\\\\\\\",\\\\nTool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 7511,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          7507,\\r\\n          7508,\\r\\n          7509,\\r\\n          7510,\\r\\n          7511,\\r\\n          7512,\\r\\n          7513,\\r\\n          7514,\\r\\n          7515,\\r\\n          7516,\\r\\n          7517\\r\\n        ],\\r\\n        \\\"token_size\\\": 487,\\r\\n        \\\"score\\\": \\\"0.5813993\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Is ISD always what we communicate externally?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"For the time being, yes.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Regarding YTD Actual Cost Overrun - How far back to you go in terms of years?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"It only takes into account the projects with delivery completed in the current fiscal year.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are risk reserves accounted for YTD Actual Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Projects are marked as Overrun where Actual Cost > Sold Cost. Sold Cost includes the overall Allocated Risk Reserve. Cost Overrun is the overrun beyond Risk Reserve Usage. Refer to Domain Delivery Insights - Domain_Delivery_Insights - Power BI  (Financials – YTD Cost Overrun and RR)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"Regarding YTD Actual Cost Overrun - How are risk reserves accounted for?\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How are amendments counted for YTD Actual Cost Overrun?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Finances are at all up-level taking into account all Amendments. Cost Overrun is calculated at an Engagement level (includes base contract + All Amendments) and for a Portfolio of Engagements.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"Not Role Specific\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Connected Customer Experience - CCE\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n I have no access to the data in our TZ DV report. I have the link, but how do I get access?\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 7603,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          7598,\\r\\n          7599,\\r\\n          7600,\\r\\n          7601,\\r\\n          7602,\\r\\n          7603,\\r\\n          7604,\\r\\n          7605,\\r\\n          7606,\\r\\n          7607,\\r\\n          7608\\r\\n        ],\\r\\n        \\\"token_size\\\": 486,\\r\\n        \\\"score\\\": \\\"0.5812391\\\"\\r\\n      }\\r\\n    }\\r\\n  ],\\r\\n  \\\"metadata\\\": {\\r\\n    \\\"processingMode\\\": \\\"default\\\",\\r\\n    \\\"precessingStatus\\\": \\\"\\\",\\r\\n    \\\"query\\\": \\\"what is cost overrun. show me in markdown formatted table\\\"\\r\\n  },\\r\\n  \\\"latency\\\": 73\\r\\n}\",\"parentId\":\"3a0e04c8-6e2a-40bc-a7d8-7084e40f6ede\",\"intent\":\"cloudgpt\"}"
		},
		table: {
			conversationId: null,
			question: "Cannot view M365 data. What access do I need? Show me as table",
			responseType: "markdown",
			source: "cloudgpt",
			data: "{\"reply\":\"To view MAU data for M365 Data, you need to have access to the [**MSSales-Access-M365**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx) SharePoint site. Here is the required access:\\n\\n| Access | Description |\\n| --- | --- |\\n| Read | To view the data |\\n| Contribute | To upload data |\\n| Full Control | To manage the site |\\n\\nPlease note that access to this site is granted by the Delivery Excellence team. If you do not have access, please reach out to your Virtuoso Engagement Manager or Delivery Manager for assistance. \",\"id\":\"895469b0-3a98-4930-a6a0-8e7a3a9aa378\",\"messages\":\"[\\r\\n  {\\r\\n    \\\"role\\\": \\\"assistant\\\",\\r\\n    \\\"type\\\": \\\"text\\\",\\r\\n    \\\"content\\\": \\\"To view MAU data for M365 Data, you need to have access to the [**MSSales-Access-M365**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx) SharePoint site. Here is the required access:\\\\n\\\\n| Access | Description |\\\\n| --- | --- |\\\\n| Read | To view the data |\\\\n| Contribute | To upload data |\\\\n| Full Control | To manage the site |\\\\n\\\\nPlease note that access to this site is granted by the Delivery Excellence team. If you do not have access, please reach out to your Virtuoso Engagement Manager or Delivery Manager for assistance. \\\"\\r\\n  }\\r\\n]\",\"conversationId\":\"895469b0-3a98-4930-a6a0-8e7a3a9aa378\",\"docs\":\"{\\r\\n  \\\"docs\\\": [\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On average how many Success Expectations can be there on a project?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"There is no limit to the number of Success Expectations in an engagement. The more the customer needs at an engagement level are understood the better the delivery team is likely to meet the customer's business objectives through a successful delivery. It is important to note that Success Expectations should not add to the project scope unless it is contractually approved.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On what basis a Virtuoso engagement is marked as confidential?\\\\\\\",\\\\nFAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18910,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912,\\r\\n          18913,\\r\\n          18914,\\r\\n          18915,\\r\\n          18916,\\r\\n          18917\\r\\n        ],\\r\\n        \\\"token_size\\\": 505,\\r\\n        \\\"score\\\": \\\"0.6221193\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" number, with no negative and no decimal value.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Next Step Proposal (NSP)\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"NSP is a global program that bridges the gap between delivery and sales through simple processes, like standard reporting, and tracking. This helps to identify and act on the right next steps for our customers.Within your project in Virtuoso, open/click \\\\\\\\\\\\\\\"**Project Info**\\\\\\\\\\\\\\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18907,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18903,\\r\\n          18904,\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912\\r\\n        ],\\r\\n        \\\"token_size\\\": 468,\\r\\n        \\\"score\\\": \\\"0.61280525\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"  \\\\\\\"Answer\\\\\\\": \\\\\\\"Follow the below steps to view list of findings associated to Review:1.\\\\\\\\\\\\\\\\tNavigate to the Project and click 'Review'.2.\\\\\\\\\\\\\\\\tThen click 'Review ID'. This is a hyperlink and will display Review Page Details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view M365 MAU Data in Virtuoso?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view MAU data for M365 Data?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view project initiation completed activities?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Widget is automatically updated when an activity is completed in Virtuoso, or when an activity is marked as complete in a project schedule. By clicking on any of the focus areas in the widget, the user is directed to the project initiation health status details page. This page provides a detailed status view of  individual initiation activities.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view risk in Risk Repository?\\\\\\\",\\\\n If you want to add risks to the RAID, use the search functionality tab to search risk and add to RAID.\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18356,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18351,\\r\\n          18352,\\r\\n          18353,\\r\\n          18354,\\r\\n          18355,\\r\\n          18356,\\r\\n          18357,\\r\\n          18358,\\r\\n          18359,\\r\\n          18360,\\r\\n          18361\\r\\n        ],\\r\\n        \\\"token_size\\\": 489,\\r\\n        \\\"score\\\": \\\"0.603126\\\"\\r\\n      }\\r\\n    }\\r\\n  ],\\r\\n  \\\"metadata\\\": {\\r\\n    \\\"processingMode\\\": \\\"default\\\",\\r\\n    \\\"precessingStatus\\\": \\\"\\\",\\r\\n    \\\"query\\\": \\\"Cannot view M365 data. What access do I need? Show me as table\\\"\\r\\n  },\\r\\n  \\\"latency\\\": 66\\r\\n}\",\"parentId\":\"895469b0-3a98-4930-a6a0-8e7a3a9aa378\",\"intent\":\"cloudgpt\"}"
		},
		html: {
			conversationId: null,
			question: "Cannot view M365 data. What access do I need? Show me as table",
			responseType: "markdown",
			source: "cloudgpt",
			data: "{\"reply\":\"To view MAU data for M365 Data, you need to have access to the [**MSSales-Access-M365**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx) SharePoint site. Here is the required access:\\n\\n| Access | Description |\\n| --- | --- |\\n| Read | To view the data |\\n| Contribute | To upload data |\\n| Full Control | To manage the site |\\n\\nPlease note that access to this site is granted by the Delivery Excellence team. If you do not have access, please reach out to your Virtuoso Engagement Manager or Delivery Manager for assistance. \",\"id\":\"895469b0-3a98-4930-a6a0-8e7a3a9aa378\",\"messages\":\"[\\r\\n  {\\r\\n    \\\"role\\\": \\\"assistant\\\",\\r\\n    \\\"type\\\": \\\"text\\\",\\r\\n    \\\"content\\\": \\\"To view MAU data for M365 Data, you need to have access to the [**MSSales-Access-M365**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx) SharePoint site. Here is the required access:\\\\n\\\\n| Access | Description |\\\\n| --- | --- |\\\\n| Read | To view the data |\\\\n| Contribute | To upload data |\\\\n| Full Control | To manage the site |\\\\n\\\\nPlease note that access to this site is granted by the Delivery Excellence team. If you do not have access, please reach out to your Virtuoso Engagement Manager or Delivery Manager for assistance. \\\"\\r\\n  }\\r\\n]\",\"conversationId\":\"895469b0-3a98-4930-a6a0-8e7a3a9aa378\",\"docs\":\"{\\r\\n  \\\"docs\\\": [\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On average how many Success Expectations can be there on a project?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"There is no limit to the number of Success Expectations in an engagement. The more the customer needs at an engagement level are understood the better the delivery team is likely to meet the customer's business objectives through a successful delivery. It is important to note that Success Expectations should not add to the project scope unless it is contractually approved.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On what basis a Virtuoso engagement is marked as confidential?\\\\\\\",\\\\nFAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18910,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912,\\r\\n          18913,\\r\\n          18914,\\r\\n          18915,\\r\\n          18916,\\r\\n          18917\\r\\n        ],\\r\\n        \\\"token_size\\\": 505,\\r\\n        \\\"score\\\": \\\"0.6221193\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" number, with no negative and no decimal value.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Next Step Proposal (NSP)\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"NSP is a global program that bridges the gap between delivery and sales through simple processes, like standard reporting, and tracking. This helps to identify and act on the right next steps for our customers.Within your project in Virtuoso, open/click \\\\\\\\\\\\\\\"**Project Info**\\\\\\\\\\\\\\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18907,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18903,\\r\\n          18904,\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912\\r\\n        ],\\r\\n        \\\"token_size\\\": 468,\\r\\n        \\\"score\\\": \\\"0.61280525\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"  \\\\\\\"Answer\\\\\\\": \\\\\\\"Follow the below steps to view list of findings associated to Review:1.\\\\\\\\\\\\\\\\tNavigate to the Project and click 'Review'.2.\\\\\\\\\\\\\\\\tThen click 'Review ID'. This is a hyperlink and will display Review Page Details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view M365 MAU Data in Virtuoso?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view MAU data for M365 Data?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view project initiation completed activities?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Widget is automatically updated when an activity is completed in Virtuoso, or when an activity is marked as complete in a project schedule. By clicking on any of the focus areas in the widget, the user is directed to the project initiation health status details page. This page provides a detailed status view of  individual initiation activities.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view risk in Risk Repository?\\\\\\\",\\\\n If you want to add risks to the RAID, use the search functionality tab to search risk and add to RAID.\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18356,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18351,\\r\\n          18352,\\r\\n          18353,\\r\\n          18354,\\r\\n          18355,\\r\\n          18356,\\r\\n          18357,\\r\\n          18358,\\r\\n          18359,\\r\\n          18360,\\r\\n          18361\\r\\n        ],\\r\\n        \\\"token_size\\\": 489,\\r\\n        \\\"score\\\": \\\"0.603126\\\"\\r\\n      }\\r\\n    }\\r\\n  ],\\r\\n  \\\"metadata\\\": {\\r\\n    \\\"processingMode\\\": \\\"default\\\",\\r\\n    \\\"precessingStatus\\\": \\\"\\\",\\r\\n    \\\"query\\\": \\\"Cannot view M365 data. What access do I need? Show me as table\\\"\\r\\n  },\\r\\n  \\\"latency\\\": 66\\r\\n}\",\"parentId\":\"895469b0-3a98-4930-a6a0-8e7a3a9aa378\",\"intent\":\"cloudgpt\"}"
		},
		graph: {
			conversationId: null,
			question: "Cannot view M365 data. What access do I need? Show me as graph",
			responseType: "text",
			source: "cloudgpt",
			data: "{\"reply\":\"To view MAU data for M365 Data, you can refer to this [link](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx). The link provides information on how to access the data and view it as a graph. Let me know if you have any other questions.\",\"id\":\"165f1220-29dc-4e9b-aad8-c3622586f967\",\"messages\":\"[\\r\\n  {\\r\\n    \\\"role\\\": \\\"assistant\\\",\\r\\n    \\\"type\\\": \\\"text\\\",\\r\\n    \\\"content\\\": \\\"To view MAU data for M365 Data, you can refer to this [link](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx). The link provides information on how to access the data and view it as a graph. Let me know if you have any other questions.\\\"\\r\\n  }\\r\\n]\",\"conversationId\":\"165f1220-29dc-4e9b-aad8-c3622586f967\",\"docs\":\"{\\r\\n  \\\"docs\\\": [\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On average how many Success Expectations can be there on a project?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"There is no limit to the number of Success Expectations in an engagement. The more the customer needs at an engagement level are understood the better the delivery team is likely to meet the customer's business objectives through a successful delivery. It is important to note that Success Expectations should not add to the project scope unless it is contractually approved.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On what basis a Virtuoso engagement is marked as confidential?\\\\\\\",\\\\nFAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18910,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912,\\r\\n          18913,\\r\\n          18914,\\r\\n          18915,\\r\\n          18916,\\r\\n          18917\\r\\n        ],\\r\\n        \\\"token_size\\\": 505,\\r\\n        \\\"score\\\": \\\"0.63186336\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" number, with no negative and no decimal value.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Next Step Proposal (NSP)\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"NSP is a global program that bridges the gap between delivery and sales through simple processes, like standard reporting, and tracking. This helps to identify and act on the right next steps for our customers.Within your project in Virtuoso, open/click \\\\\\\\\\\\\\\"**Project Info**\\\\\\\\\\\\\\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18907,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18903,\\r\\n          18904,\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912\\r\\n        ],\\r\\n        \\\"token_size\\\": 468,\\r\\n        \\\"score\\\": \\\"0.61969984\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"  \\\\\\\"Answer\\\\\\\": \\\\\\\"Follow the below steps to view list of findings associated to Review:1.\\\\\\\\\\\\\\\\tNavigate to the Project and click 'Review'.2.\\\\\\\\\\\\\\\\tThen click 'Review ID'. This is a hyperlink and will display Review Page Details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view M365 MAU Data in Virtuoso?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view MAU data for M365 Data?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view project initiation completed activities?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Widget is automatically updated when an activity is completed in Virtuoso, or when an activity is marked as complete in a project schedule. By clicking on any of the focus areas in the widget, the user is directed to the project initiation health status details page. This page provides a detailed status view of  individual initiation activities.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view risk in Risk Repository?\\\\\\\",\\\\n If you want to add risks to the RAID, use the search functionality tab to search risk and add to RAID.\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18356,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18351,\\r\\n          18352,\\r\\n          18353,\\r\\n          18354,\\r\\n          18355,\\r\\n          18356,\\r\\n          18357,\\r\\n          18358,\\r\\n          18359,\\r\\n          18360,\\r\\n          18361\\r\\n        ],\\r\\n        \\\"token_size\\\": 489,\\r\\n        \\\"score\\\": \\\"0.61863995\\\"\\r\\n      }\\r\\n    }\\r\\n  ],\\r\\n  \\\"metadata\\\": {\\r\\n    \\\"processingMode\\\": \\\"default\\\",\\r\\n    \\\"precessingStatus\\\": \\\"\\\",\\r\\n    \\\"query\\\": \\\"Cannot view M365 data. What access do I need? Show me as graph\\\"\\r\\n  },\\r\\n  \\\"latency\\\": 83\\r\\n}\",\"parentId\":\"165f1220-29dc-4e9b-aad8-c3622586f967\",\"intent\":\"cloudgpt\"}"
		},
		image: {
			conversationId: null,
			question: "Cannot view M365 data. What access do I need? Show me as image",
			responseType: "text",
			source: "cloudgpt",
			data: "{\"reply\":\"To view MAU data for M365 Data, you need to refer to this [link](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx). Here is an image that shows the steps to access the data:\\n\\n![M365 Access Steps](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/M365_Access_Steps.png)\\n\\n\",\"id\":\"c027e28a-15e2-4c48-8e51-027820c5006e\",\"messages\":\"[\\r\\n  {\\r\\n    \\\"role\\\": \\\"assistant\\\",\\r\\n    \\\"type\\\": \\\"text\\\",\\r\\n    \\\"content\\\": \\\"To view MAU data for M365 Data, you need to refer to this [link](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx). Here is an image that shows the steps to access the data:\\\\n\\\\n![M365 Access Steps](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/M365_Access_Steps.png)\\\\n\\\\n\\\"\\r\\n  }\\r\\n]\",\"conversationId\":\"c027e28a-15e2-4c48-8e51-027820c5006e\",\"docs\":\"{\\r\\n  \\\"docs\\\": [\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On average how many Success Expectations can be there on a project?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"There is no limit to the number of Success Expectations in an engagement. The more the customer needs at an engagement level are understood the better the delivery team is likely to meet the customer's business objectives through a successful delivery. It is important to note that Success Expectations should not add to the project scope unless it is contractually approved.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"On what basis a Virtuoso engagement is marked as confidential?\\\\\\\",\\\\nFAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18910,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912,\\r\\n          18913,\\r\\n          18914,\\r\\n          18915,\\r\\n          18916,\\r\\n          18917\\r\\n        ],\\r\\n        \\\"token_size\\\": 505,\\r\\n        \\\"score\\\": \\\"0.6366456\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\" number, with no negative and no decimal value.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Next Step Proposal (NSP)\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"NSP is a global program that bridges the gap between delivery and sales through simple processes, like standard reporting, and tracking. This helps to identify and act on the right next steps for our customers.Within your project in Virtuoso, open/click \\\\\\\\\\\\\\\"**Project Info**\\\\\\\\\\\\\\\" tab and it is at the end on the drop-down menu.![NSP](https://irisstorageaccdev.z5.web.core.windows.net/iris-resources/mcs_images/NSP.png)\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to see MAU data for M365 MAU Data\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"Not able to view MAU data for M365 MAU Data.\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18907,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18903,\\r\\n          18904,\\r\\n          18905,\\r\\n          18906,\\r\\n          18907,\\r\\n          18908,\\r\\n          18909,\\r\\n          18910,\\r\\n          18911,\\r\\n          18912\\r\\n        ],\\r\\n        \\\"token_size\\\": 468,\\r\\n        \\\"score\\\": \\\"0.6254807\\\"\\r\\n      }\\r\\n    },\\r\\n    {\\r\\n      \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n      \\\"content\\\": \\\"  \\\\\\\"Answer\\\\\\\": \\\\\\\"Follow the below steps to view list of findings associated to Review:1.\\\\\\\\\\\\\\\\tNavigate to the Project and click 'Review'.2.\\\\\\\\\\\\\\\\tThen click 'Review ID'. This is a hyperlink and will display Review Page Details.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view M365 MAU Data in Virtuoso?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view MAU data for M365 Data?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"To view MAU data for M365 Data, refer to this [**link**](https://microsoft.sharepoint.com/teams/DeliveryExcellenceServices/SitePages/Consumption%20In%20Delivery/M365/MSSales-Access-M365.aspx).\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view project initiation completed activities?\\\\\\\",\\\\n    \\\\\\\"Answer\\\\\\\": \\\\\\\"Widget is automatically updated when an activity is completed in Virtuoso, or when an activity is marked as complete in a project schedule. By clicking on any of the focus areas in the widget, the user is directed to the project initiation health status details page. This page provides a detailed status view of  individual initiation activities.\\\\\\\",\\\\n    \\\\\\\"FAQAlternateQuestion\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"RoleSpecific\\\\\\\": \\\\\\\"\\\\\\\",\\\\n    \\\\\\\"Tool\\\\\\\": \\\\\\\"Virtuoso Support\\\\\\\",\\\\n    \\\\\\\"Reference URL\\\\\\\": \\\\\\\"none\\\\\\\"\\\\n  },\\\\n  {\\\\n    \\\\\\\"Question\\\\\\\": \\\\\\\"How to view risk in Risk Repository?\\\\\\\",\\\\n If you want to add risks to the RAID, use the search functionality tab to search risk and add to RAID.\\\\\\\",\\\",\\r\\n      \\\"link\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n      \\\"metadata\\\": {\\r\\n        \\\"title\\\": \\\"\\\\\\\"Question\\\\\\\": \\\\\\\"Is the Risk Model the same for MDM?\\\\\\\",\\\",\\r\\n        \\\"batch_id\\\": \\\"20240318\\\",\\r\\n        \\\"source\\\": \\\"copilot/copilot/faq.txt\\\",\\r\\n        \\\"chunk_id\\\": 18356,\\r\\n        \\\"expanded_chunk_ids\\\": [\\r\\n          18351,\\r\\n          18352,\\r\\n          18353,\\r\\n          18354,\\r\\n          18355,\\r\\n          18356,\\r\\n          18357,\\r\\n          18358,\\r\\n          18359,\\r\\n          18360,\\r\\n          18361\\r\\n        ],\\r\\n        \\\"token_size\\\": 489,\\r\\n        \\\"score\\\": \\\"0.6092752\\\"\\r\\n      }\\r\\n    }\\r\\n  ],\\r\\n  \\\"metadata\\\": {\\r\\n    \\\"processingMode\\\": \\\"default\\\",\\r\\n    \\\"precessingStatus\\\": \\\"\\\",\\r\\n    \\\"query\\\": \\\"Cannot view M365 data. What access do I need? Show me as image\\\"\\r\\n  },\\r\\n  \\\"latency\\\": 88\\r\\n}\",\"parentId\":\"c027e28a-15e2-4c48-8e51-027820c5006e\",\"intent\":\"cloudgpt\"}"
		}
	}
};
const put$1 = {
};
const mockResponses = {
	get: get,
	post: post,
	put: put$1,
	"delete": {
}
};

const responseTypes = [
	"text",
	"markdown",
	"table",
	"html",
	"graph",
	"image"
];

/**
 * ApiService provides methods to make GET and POST requests.
 * It supports using mock responses based on session storage settings.
 */
function ApiService$1() {
	const useMock = sessionStorage.getItem("useMockUiResponse") === "true";

	/**
	 * Makes an asynchronous GET request to the specified URI.
	 * @param {Function} getBearerTokenCallback - A callback function to get the bearer token.
	 * @param {string} uri - The URI to send the GET request to.
	 * @returns {Promise<Object>} The response data.
	 */
	const GetAsync = async (getBearerTokenCallback, uri) => {
		uri = new URL(uri);
		const apiEndpoint = uri.pathname;

		if (useMock) {
			return mockResponses.get[apiEndpoint];
		}

		const requestOptions = {
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + (await getBearerTokenCallback()),
			},
		};

		try {
			const response = await axios.get(uri, requestOptions);
			if (response.status === 200) {
				const data = await response.json();
				return data;
			} else {
				return {};
			}
		} catch (error) {
			console.error(error);
		}
	};

	/**
	 * Makes an asynchronous POST request to the specified URI.
	 * @param {Function} getBearerTokenCallback - A callback function to get the bearer token.
	 * @param {string} uri - The URI to send the POST request to.
	 * @param {Object} data - The data to send in the POST request.
	 * @param {Function} [getAdditionalHeaderCallback] - A callback function to get additional headers.
	 * @returns {Promise<Object>} The response data.
	 */
	const PostAsync = async (
		getBearerTokenCallback,
		uri,
		data,
		getAdditionalHeaderCallback = () => {}
	) => {
		uri = new URL(uri);
		let apiEndpoint = uri.pathname;
		const jsonObj = JSON.parse(data);
		const request = jsonObj?.question ? jsonObj.question.toLowerCase() : "";
		const responseType = responseTypes.find((type) => request.includes(type));
		if (useMock) {
			return GetMockResponseByResponseType(apiEndpoint, responseType, "post");
		}

		const requestOptions = {
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const additionalHeaders = await getAdditionalHeaderCallback();

		if (
			additionalHeaders &&
			typeof additionalHeaders === "object" &&
			Object.keys(additionalHeaders).length > 0
		) {
			Object.assign(requestOptions.headers, additionalHeaders);
		} else {
			Object.assign(requestOptions.headers, {
				Authorization: "Bearer " + (await getBearerTokenCallback()),
			});
		}

		try {
			const response = await axios.post(uri, data, requestOptions);
			if (response.status === 200) {
				return response.data;
			}
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
		} catch (error) {
			console.error(error);
		}
	};

	/**
	 * Gets a mock response based on the response type and method.
	 * @param {string} url - The URL to get the mock response for.
	 * @param {string} responseType - The type of response to get.
	 * @param {string} method - The HTTP method (GET or POST).
	 * @returns {Object} The mock response.
	 */
	const GetMockResponseByResponseType = (url, responseType, method) => {
		if (!responseType) {
			responseType = "text";
		}
		const mockResponse =
			mockResponses[method]?.[url]?.[responseType] ||
			mockResponses[method]?.[url];
		return mockResponse;
	};

	return { GetAsync, PostAsync, GetMockResponseByResponseType };
}

const { GetAsync, PostAsync, GetMockResponseByResponseType } =
	ApiService$1();

const useStyles$c = makeStyles({
  parentDiv: { marginLeft: "20px", marginRight: "20px" },
  suggestion: { display: "flex", alignItems: "right", justifyContent: "right" }
});
const ViewSuggestions = (props) => {
  const styles = useStyles$c();
  const suggestionListRef = React__default.useRef(null);
  const [startIndex, setStartIndex] = React__default.useState(0);
  useEffect(() => {
    setStartIndex(0);
    setTimeout(() => {
      let suggestionHeight = suggestionListRef.current?.clientHeight;
      console.log("ht", suggestionHeight);
      props.onSuggestionHeightChange(suggestionHeight);
    }, 0);
  }, [props.suggestionQuestions]);
  const onSuggestionsReload = () => {
    setStartIndex(startIndex + SuggestionRecordsToShow);
    if (startIndex + SuggestionRecordsToShow >= props.suggestionQuestions?.length) {
      setStartIndex(0);
    }
  };
  const handleSubmit = (suggestion) => {
    props.onSuggestionSubmit(suggestion);
  };
  const ReloadIcon = bundleIcon(ArrowClockwiseFilled, ArrowClockwiseRegular);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.parentDiv, children: props.suggestionQuestions?.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
    SuggestionList,
    {
      action: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { relationship: "label", content: "Refresh", withArrow: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ReloadIcon, {}),
          size: "small",
          appearance: "transparent",
          onClick: onSuggestionsReload
        }
      ) }),
      className: styles.parentDiv,
      ref: suggestionListRef,
      children: props.suggestionQuestions?.map((item, i) => i >= startIndex + SuggestionRecordsToShow || i < startIndex ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.suggestion, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Suggestion,
        {
          onClick: () => handleSubmit(item.suggestion),
          children: item.suggestion
        },
        `suggestion-${i}`
      ) }, `suggestionParentdiv-${i}`))
    }
  ) });
};

const useStyles$b = makeStyles({
  headerBtton: {
    fontSize: "18px",
    border: "none !important",
    margin: "0px 0px 0px -7px",
    right: "8px",
    position: "absolute",
    top: "8px"
  },
  headerTag: {
    color: "rgb(128 128 128 / 76%)",
    marginTop: "-2px",
    marginBottom: "10px",
    fontSize: "13px",
    fontWeight: "500"
  },
  promptMessageBox: {
    marginLeft: "25px",
    marginRight: "18px",
    Height: "60%",
    overflowY: "auto",
    bottom: "115px",
    position: "absolute",
    width: "90%"
  }
});
const PromptSuggestion = ({
  prompts = [],
  SetTextareaChatValue,
  setCount,
  setIsPromptVisible,
  handlePromptSuggestions,
  handlePromptSelected,
  trackCustomEvents
}) => {
  const config = useSelector((state) => state.config.config);
  const styles = useStyles$b();
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  const onClickPrompt = (prompt) => {
    SetTextareaChatValue(prompt);
    setCount(prompt.length);
    handlePromptSelected(prompt);
    handlePromptSuggestions();
    trackCopilotEvent("Prompt Library Selected", prompt, trackCustomEvents, config);
  };
  const closeModal = () => {
    setIsPromptVisible(false);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setIsPromptVisible(false);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    CopilotMessage,
    {
      style: {
        marginLeft: "25px",
        marginRight: "18px",
        Height: "60%",
        overflowY: "auto",
        bottom: "60px",
        position: "fixed",
        width: "90%",
        boxShadow: "2px 2px 10px 1px grey"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { class: "promptMainArea", "aria-live": "polite", "aria-atomic": "true", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FocusTrapZone,
        {
          isClickableOutsideFocusTrap: true,
          forceFocusInsideTrap: false,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "div",
              {
                class: "promptArea",
                style: { display: "flex", marginBottom: "10px" },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "h3",
                    {
                      style: {
                        color: "rgb(128 128 128 / 76%)",
                        marginTop: "-2px",
                        marginBottom: "6px",
                        fontSize: "15px",
                        fontWeight: "500"
                      },
                      children: "Suggested prompts"
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Button,
                    {
                      tabIndex: 0,
                      className: styles.headerBtton,
                      class: "promptCloseButton",
                      title: "Close",
                      role: "button",
                      onClick: closeModal,
                      onKeyDown: (event) => handleKeyDown(event),
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(DismissRegular, { className: styles.headerBttonIcon }),
                      "aria-label": "Close"
                    }
                  )
                ]
              }
            ),
            prompts.length > 0 && prompts.slice(0, promptlimit).map((promp, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              PromptStarter,
              {
                style: { marginBottom: "6px", width: "100%" },
                prompt: /* @__PURE__ */ jsxRuntimeExports.jsx(Body1, { children: promp }),
                tabIndex: 0,
                onClick: () => onClickPrompt(promp)
              },
              `prompt-${i}`
            ))
          ]
        }
      ) })
    }
  ) });
};

const setLocalStorage = (localStorageKey, value) => {
    localStorage.setItem(localStorageKey, value);
};
const getLocalStorage = (localStorageKey) => {
    return localStorage.getItem(localStorageKey);
};

const useStyles$a = makeStyles({
  coachMark: {
    marginLeft: "15px"
  }
});
const calloutProps = { gapSpace: 0 };
const hostStyles = { root: { display: "inline-block" } };
const TeachingBubblePopup = ({ handlePromptSuggestions }) => {
  const targetButton = useRef(null);
  useStyles$a();
  const [isCoachmarkVisible, setIsCoachmarkVisible] = React__default.useState(false);
  const configInfo = useSelector((state) => state.config.config);
  const [teachingBubbleVisible, setTeachingBubbleVisible] = useState(true);
  const localStorageName = "isPromptCoachmarkVisible";
  const handleTeachingBubble = () => {
    console.log("handleTeachingBubble");
    setIsCoachmarkVisible(!isCoachmarkVisible);
    setTeachingBubbleVisible(!teachingBubbleVisible);
  };
  const closeTeachingBubble = () => {
    setIsCoachmarkVisible(false);
    setTeachingBubbleVisible(false);
  };
  const finalTeachingBubble = () => {
    setIsCoachmarkVisible(false);
    setTeachingBubbleVisible(false);
    setLocalStorage(localStorageName, "true");
  };
  useEffect(() => {
    const showCoachMark = getLocalStorage(localStorageName);
    if (showCoachMark === "true") {
      setTeachingBubbleVisible(false);
    } else {
      setTeachingBubbleVisible(true);
    }
  }, []);
  const tooltipId = useId$1("tooltip");
  const primaryButtonProps = {
    children: coachmarkData.coachmarkCloseButtontext,
    onClick: finalTeachingBubble
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { ref: targetButton, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TooltipHost,
      {
        content: tooltipContent,
        id: tooltipId,
        calloutProps,
        styles: hostStyles,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            "aria-label": promptsButton.ariaLabel,
            appearance: promptsButton.appearance,
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Book20Regular, {}),
            onClick: handlePromptSuggestions,
            role: promptsButton.role,
            "aria-describedby": tooltipId
          }
        )
      }
    ) }),
    isCoachmarkVisible && configInfo?.isPromptCoachmarkVisible && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: handleTeachingBubble, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Coachmark,
      {
        target: targetButton.current,
        positioningContainerProps: {
          directionalHint: DirectionalHint.topAutoEdge,
          doNotLayer: false
        },
        ariaAlertText: coachmarkData?.ariaAlertText,
        ariaDescribedBy: coachmarkData?.ariaAlertText,
        ariaLabelledBy: coachmarkData?.ariaAlertText,
        ariaDescribedByText: coachmarkData?.ariaAlertText,
        ariaLabelledByText: coachmarkData?.ariaAlertText,
        id: "promptscoachmark"
      }
    ) }),
    teachingBubbleVisible && configInfo?.isPromptCoachmarkVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TeachingBubble,
      {
        target: targetButton.current,
        primaryButtonProps,
        calloutProps: { directionalHint: DirectionalHint.topAutoEdge },
        onDismiss: closeTeachingBubble,
        headline: coachmarkData?.coachmarkTitle,
        hasCloseButton: true,
        closeButtonAriaLabel: "Close",
        children: coachmarkData?.coachmarkContent
      }
    )
  ] });
};

const Program = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%3e%3cg%20id='Group_4'%20data-name='Group%204'%20transform='translate(-262%20-191)'%3e%3crect%20id='Rectangle_3'%20data-name='Rectangle%203'%20width='16'%20height='16'%20transform='translate(262%20191)'%20fill='rgba(255,255,255,0)'/%3e%3cpath%20id='Path_1'%20data-name='Path%201'%20d='M15,5a.969.969,0,0,1,.391.078,1.1,1.1,0,0,1,.531.531A.969.969,0,0,1,16,6v9H2V11H0V1A.969.969,0,0,1,.078.609,1,1,0,0,1,.289.3,1.031,1.031,0,0,1,.609.078.969.969,0,0,1,1,0H4.75a2.032,2.032,0,0,1,.6.078A2.005,2.005,0,0,1,5.8.258,2.2,2.2,0,0,1,6.156.5q.164.133.32.242A2.2,2.2,0,0,0,6.82.93,1.219,1.219,0,0,0,7.25,1H13a.969.969,0,0,1,.391.078A.941.941,0,0,1,13.7,1.3a.941.941,0,0,1,.219.313A.969.969,0,0,1,14,2V5ZM1,1V2H4.75a1.526,1.526,0,0,0,.328-.031,1.266,1.266,0,0,0,.258-.1,2.193,2.193,0,0,0,.227-.156q.117-.094.25-.211-.133-.117-.25-.2a1.259,1.259,0,0,0-.227-.156.86.86,0,0,0-.258-.1A1.232,1.232,0,0,0,4.75,1Zm1,9V5a.969.969,0,0,1,.078-.391A1,1,0,0,1,2.289,4.3a1.031,1.031,0,0,1,.32-.219A.969.969,0,0,1,3,4H6.75a2.032,2.032,0,0,1,.6.078,2.006,2.006,0,0,1,.453.18,2.062,2.062,0,0,1,.359.242q.156.133.313.242a2.2,2.2,0,0,0,.344.188A1.219,1.219,0,0,0,9.25,5H13V2H7.25a1.109,1.109,0,0,0-.43.078,1.8,1.8,0,0,0-.344.18q-.156.109-.312.242a2.062,2.062,0,0,1-.359.242,2.281,2.281,0,0,1-.453.188,2.244,2.244,0,0,1-.6.07H1v7ZM7.813,5.5q-.133-.117-.25-.2a1.259,1.259,0,0,0-.227-.156.86.86,0,0,0-.258-.1A1.232,1.232,0,0,0,6.75,5H3V6H6.75a1.526,1.526,0,0,0,.328-.031,1.266,1.266,0,0,0,.258-.1,2.193,2.193,0,0,0,.227-.156Q7.68,5.617,7.813,5.5ZM15,6H9.25a1.109,1.109,0,0,0-.43.078,1.8,1.8,0,0,0-.344.18q-.156.109-.312.242a2.062,2.062,0,0,1-.359.242,2.281,2.281,0,0,1-.453.188,2.244,2.244,0,0,1-.6.07H3v7H15Z'%20transform='translate(262%20191)'%20fill='%23323130'/%3e%3c/g%3e%3c/svg%3e";

const Project = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%3e%3cg%20id='Group_6'%20data-name='Group%206'%20transform='translate(-262%20-210)'%3e%3crect%20id='Rectangle_4'%20data-name='Rectangle%204'%20width='16'%20height='16'%20transform='translate(262%20210)'%20fill='rgba(255,255,255,0)'/%3e%3cpath%20id='Path_2'%20data-name='Path%202'%20d='M0,6.289V15H16V2H4.289ZM4,6H1.711L4,3.711ZM1,14V7H5V3H15V14Z'%20transform='translate(262%20210)'%20fill='%23323130'/%3e%3c/g%3e%3c/svg%3e";

initializeIcons();
const generateStyles$1 = (theme) => {
  const { fonts } = theme;
  return mergeStyleSets({
    itemCell: [
      getFocusStyle(theme, { inset: -1 }),
      {
        minHeight: 30,
        padding: 10,
        boxSizing: "border-box",
        // borderBottom: `1px solid ${semanticColors.bodyDivider}`,
        display: "flex",
        alignItems: "center",
        borderRadius: 5,
        selectors: {
          "&:hover": { background: "#f3f2f1" }
        }
      }
    ],
    itemImage: {
      flexShrink: 0,
      paddingTop: 5,
      border: "1px solid #FFFFFF"
    },
    itemContent: {
      marginLeft: 10,
      overflow: "hidden",
      flexGrow: 1,
      color: "rgb(50, 49, 48)"
    },
    itemName: [
      fonts.medium,
      {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    ],
    itemIndex: {
      fontSize: 10,
      color: "rgb(96, 94, 92)"
    },
    calloutContainer: {
      height: "280px"
    },
    pivotItem: {
      borderTop: "1px solid rgb(237, 235, 233)"
    },
    pivotHeader: {
      padding: "10px"
    },
    activePivotItem: {},
    teamItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px"
    },
    projectItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px"
    },
    allItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px"
    },
    listContainer: {
      overflowY: "auto",
      height: "220px"
    },
    noDataFoundContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "220px"
    },
    noDataFoundText: {
      color: "rgb(50, 49, 48)"
    }
  });
};
const CopilotSlashPrompt$1 = ({ getProjectTeamsData, searchData, onItemClick, isFullScreen }) => {
  const [activeTab, setActiveTab] = useState(getProjectTeamsData[0].itemKey);
  const theme = useTheme$1();
  const classNames = useMemo(() => generateStyles$1(theme), [theme]);
  const pivotTypes = getProjectTeamsData;
  const [searchString, setSearchString] = useState("");
  const debounce = (func, delay) => {
    let debounceTimer;
    return function(...args) {
      const context = this;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };
  const debouncedSearch = useCallback(debounce((searchData2, getProjectTeamsData2) => {
    let activeTabData = getProjectTeamsData2.find((item) => item.itemKey === activeTab);
    activeTabData.onSearch(searchData2, getProjectTeamsData2);
    setSearchString(searchData2);
  }, 1e3), []);
  useEffect(() => {
    if (searchData && searchData.length >= 4) {
      debouncedSearch(searchData, getProjectTeamsData);
    }
  }, [searchData, debouncedSearch]);
  const handleTabChange = (item) => {
    setActiveTab(item.props.itemKey);
  };
  const handleItemClick = (data) => {
    onItemClick(data, activeTab, searchString);
  };
  const getItems = (itemKey, items) => {
    switch (itemKey) {
      case "Project":
        return items?.map((project2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames.itemCell, "data-is-focusable": true, onClick: () => handleItemClick(project2), tabIndex: 0, onKeyDown: (e) => {
          if (e.keyCode === 13) handleItemClick(project2);
        }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Image$2,
            {
              className: classNames.itemImage,
              src: project2.IsProgram ? Program : Project,
              width: 28,
              height: 28,
              imageFit: ImageFit.contain,
              alt: project2.IsProgram ? "Program" : "Project"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames.itemContent, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.itemName, children: project2.ProjectName }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames.itemIndex, children: [
              project2.IsProgram ? "Program ID: " : "Project ID: ",
              project2.ProjectId
            ] })
          ] })
        ] }));
      case "Team":
        return items?.map((team) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.itemCell, "data-is-focusable": true, onClick: () => handleItemClick(team), tabIndex: 0, onKeyDown: (e) => {
          if (e.keyCode === 13) handleItemClick(project);
        }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Persona,
          {
            imageInitials: getInitials$1(team.name),
            text: team.name,
            secondaryText: team.email,
            showSecondaryText: true,
            size: PersonaSize.size32,
            presence: PersonaPresence$1.none
          }
        ) }));
      default:
        return [];
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Callout,
    {
      className: classNames.calloutContainer,
      target: `#footer-textarea`,
      isBeakVisible: false,
      directionalHint: DirectionalHint.topCenter,
      gapSpace: 5,
      styles: {
        root: {
          width: isFullScreen ? "790px" : "450px"
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Pivot, { onLinkClick: handleTabChange, children: pivotTypes.map((pivotType) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        PivotItem,
        {
          onRenderItemLink: () => {
            return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.pivotHeader, children: pivotType.headerText });
          },
          itemKey: pivotType.itemKey,
          className: mergeClasses(classNames.pivotItem, activeTab === pivotType.itemKey && classNames.activePivotItem),
          children: pivotType.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.noDataFoundContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { label: "Loading...", ariaLive: "assertive", labelPosition: "right" }) }) : pivotType.items && pivotType.items.length !== 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.listContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            List,
            {
              items: getItems(pivotType.itemKey, pivotType.items),
              onRenderCell: (item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.listItem, children: item }, index)
            }
          ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.noDataFoundContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { variant: "large", block: true, children: "No results found." }) })
        }
      )) })
    }
  );
};

const useStyles$9 = makeStyles({
  changeTopicOuter: {
    alignItems: "center",
    textAlign: "-webkit-center",
    marginBottom: "15px"
  },
  suggestion: { alignItems: "center", textAlign: "-webkit-center" },
  changeTopicInner: {
    alignItems: "center",
    display: "flex",
    cursor: "pointer",
    width: "fit-content"
  },
  spanText: { marginLeft: "10px" },
  imageIcon: { width: "20px", height: "20px" },
  footer: {
    ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
    backgroundColor: tokens$2.colorNeutralBackground3,
    position: "fixed",
    width: "100%",
    bottom: "2px",
    paddingLeft: "10px",
    paddingRight: "10px"
  },
  footerMedia: {
    "@media screen and (minResolution: 350dpi)": {
      position: "relative"
    }
  },
  promptLibrary: {
    ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
    position: "fixed",
    width: "100%",
    //bottom: "2px",
    paddingLeft: "0px",
    paddingRight: "0px",
    paddingTop: "0px",
    paddingBottom: "0px",
    zIndex: "1"
    // "@media screen and (min-resolution: 350dpi)": {
    //   position: "relative",
    //   bottom: "-164px"
    // }
  }
});
const FooterMessageBox = ({
  handleSendMessage,
  handleResetConversation,
  isToggled,
  theme,
  textareaValue,
  apiBaseUrl,
  suggestionPopupCount,
  isAutoSuggestionEnabled,
  suggestionPopupCharacterThreshold,
  getBearerTokenCallback,
  AutoSuggestionApiEndpoint,
  isResponseSuggestionEnabled,
  suggestionQuestions,
  onSuggestionHeightChange,
  handlePromptSelected,
  trackCustomEvents,
  getProjectTeamsData,
  IsSlashCommandEnabled,
  isFullScreen
}) => {
  const styles = useStyles$9();
  const configInfo = useSelector((state) => state.config.config);
  const [count, setCount] = useState(0);
  const [maxCount, SetMaxCount] = useState(0);
  const [isToggleVisible, SetisToggleVisible] = useState(false);
  const [textareaChatValue, SetTextareaChatValue] = useState("");
  const [disableSend, SetDisableSend] = useState(true);
  const [audiobuttonmode, setaudiobuttonmode] = React__default.useState(false);
  const [isSuggestionPopUpEnabled, setshowSuggestionPopUpComponent] = useState(false);
  const [showChangeTopic, SetShowChangeTopic] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchActive, setSearchActive] = useState("");
  const [searchIndex, setSearchIndex] = useState(0);
  const [suggestionPopUpList, setsuggestionPopUpList] = useState([]);
  const [isPromptVisible, setIsPromptVisible] = useState(false);
  const [isSlashPromptVisible, setIsSlashPromptVisible] = useState(false);
  const textareaRef = useRef(null);
  const promptsButtonRef = useRef(null);
  const config = useSelector((state) => state.config.config);
  const { height, width } = useWindowDimensions();
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  const footerMedia = mergeClasses(styles.footer, width < "3240" && styles.footerMedia);
  let recognition;
  let data = [];
  useEffect(() => {
    SetMaxCount(configInfo.maxCharacterAllowed);
    SetisToggleVisible(configInfo.isToggleVisible);
  }, [configInfo]);
  useEffect(() => {
    SetTextareaChatValue(textareaValue);
    if (textareaValue.length > 0) {
      SetDisableSend(false);
      textareaRef.current.focus();
    } else SetDisableSend(true);
  }, [textareaValue]);
  const handlePromptSuggestions = () => {
    trackCopilotEvent("View Prompt Invoked", "", trackCustomEvents, config);
    setIsPromptVisible(!isPromptVisible);
  };
  const GetSuggestionForSuggestionPopup = async (data2) => {
    const requestPayload = JSON.stringify({
      searchString: data2,
      numberOfRecords: suggestionPopupCount.toString()
    });
    const suggestions = await PostAsync(
      getBearerTokenCallback,
      config?.apiUrls?.autoSuggestionApi,
      requestPayload
    );
    if (suggestions?.length > 0) {
      setsuggestionPopUpList(suggestions);
      setshowSuggestionPopUpComponent(true);
      SetShowChangeTopic(false);
    } else {
      setsuggestionPopUpList([]);
      setshowSuggestionPopUpComponent(false);
      SetShowChangeTopic(true);
    }
  };
  const handleKeyDownFooter = (event) => {
    if (event.key === "/") {
      if (!searchActive) {
        setSearchActive(true);
        setIsSlashPromptVisible(true);
        trackCopilotEvent("Slash prompt invoked", "", trackCustomEvents, config);
      }
    }
    if (event.key === "Escape") {
      if (searchActive) {
        setSearchActive(false);
        setSearchText("");
        setIsSlashPromptVisible(false);
        setSearchIndex(textareaChatValue.length);
      }
    }
  };
  useEffect(() => {
    if (!isSlashPromptVisible) {
      setSearchActive(false);
      setSearchText("");
    }
  }, [isSlashPromptVisible]);
  useEffect(() => {
    if (IsSlashCommandEnabled) {
      if (textareaChatValue.trim() === "") {
        setSearchActive(false);
        setIsSlashPromptVisible(false);
        setSearchIndex(textareaChatValue.length);
        setSearchText("");
        getProjectTeamsData[0].onReset(getProjectTeamsData);
      }
      if (searchActive && searchIndex === 0) {
        let indexOfSlash = textareaChatValue.indexOf("/");
        let text = textareaChatValue.substring(indexOfSlash + 1);
        if (text.startsWith(" ") || text.endsWith("   ")) {
          setIsSlashPromptVisible(false);
          setSearchText("");
          getProjectTeamsData[0].onReset(getProjectTeamsData);
          setSearchIndex(textareaChatValue.length);
          return;
        }
        setSearchText(text);
      }
      if (searchActive && searchIndex > 0) {
        if (searchIndex + 1 === textareaChatValue.length) {
          let text = textareaChatValue.substring(searchIndex + 1);
          if (text.startsWith(" ") || text.endsWith("   ")) {
            setIsSlashPromptVisible(false);
            setSearchText("");
            getProjectTeamsData[0].onReset(getProjectTeamsData);
            setSearchIndex(textareaChatValue.length);
            return;
          }
          setSearchText(text);
        } else {
          let indexOfSlash = textareaChatValue.indexOf("/", searchIndex);
          let text = textareaChatValue.substring(indexOfSlash + 1);
          if (text.startsWith(" ") || text.endsWith("   ")) {
            setIsSlashPromptVisible(false);
            setSearchText("");
            getProjectTeamsData[0].onReset(getProjectTeamsData);
            setSearchIndex(textareaChatValue.length);
            return;
          }
          setSearchText(text);
        }
      }
    }
  }, [textareaChatValue]);
  const getSearchText = useMemo(() => {
    if (IsSlashCommandEnabled) {
      if (searchActive && searchText.length > 3) {
        return searchText;
      } else if (searchActive && (searchText.length === 0 || searchText === "")) {
        getProjectTeamsData[0].onReset(getProjectTeamsData);
      }
      return "";
    }
  }, [searchActive, searchText]);
  const onItemClick = (item, activeTab, searchString) => {
    if (activeTab === getProjectTeamsData[0].itemKey) {
      let text = textareaChatValue.endsWith("/" + searchString) ? textareaChatValue.slice(0, -(searchString.length + 1)) : textareaChatValue;
      let projectProgramText = item?.IsProgram ? "Program ID " : "Project ID ";
      let tempText = text + projectProgramText + item.ProjectId;
      setSearchText("");
      setSearchActive(false);
      SetTextareaChatValue(tempText);
      setSearchIndex(tempText.length);
      setIsSlashPromptVisible(false);
      let telemetrytext = item.ProjectName + "(" + projectProgramText + item.ProjectId + ")";
      trackCopilotEvent("Slash prompt project selected", telemetrytext, trackCustomEvents, config);
    }
    if (activeTab === getProjectTeamsData[1].itemKey) {
      let text = textareaChatValue.endsWith("/" + searchString) ? textareaChatValue.slice(0, -(searchString.length + 1)) : textareaChatValue;
      let tempText = text + " " + item.email;
      setSearchText("");
      setSearchActive(false);
      SetTextareaChatValue(tempText);
      setSearchIndex(tempText.length);
      setIsSlashPromptVisible(false);
      let telemetrytext = item.name + "(" + item.email + ")";
      trackCopilotEvent("Slash prompt teams selected", telemetrytext, trackCustomEvents, config);
    }
  };
  const handleOnChange = (event, data2) => {
    if (data2.value.length > 0) SetDisableSend(false);
    else SetDisableSend(true);
    if (data2.value.length <= maxCount) {
      setCount(data2.value.length);
      SetTextareaChatValue(data2.value);
    }
    if (data2.value.length >= suggestionPopupCharacterThreshold && isAutoSuggestionEnabled) {
      GetSuggestionForSuggestionPopup(data2.value);
    } else {
      setsuggestionPopUpList([]);
      setshowSuggestionPopUpComponent(false);
      SetShowChangeTopic(true);
    }
  };
  const handleSubmit = (userMessage) => {
    try {
      SetTextareaChatValue("");
      handleSendMessage(userMessage);
      setCount(0);
      SetDisableSend(true);
      setshowSuggestionPopUpComponent(false);
      SetShowChangeTopic(true);
    } catch (e) {
      console.log(e);
    }
  };
  const runSpeechRecognition = () => {
    setaudiobuttonmode(true);
    recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    recognition.onresult = handleRecognitionResult;
    recognition.start();
    recognition.continuous = true;
  };
  const handleRecognitionResult = (event) => {
    const newTranscript = event.results[0][0].transcript;
    data.push(newTranscript);
    SetTextareaChatValue(data.join(" "));
    setCount(data.join(" ").length);
    SetDisableSend(false);
  };
  const handleStopRecognition = () => {
    setaudiobuttonmode(false);
    if (recognition) {
      recognition.stop();
    }
  };
  const handleKeyDown = (event, purpose) => {
    if (event.key === "Enter") {
      clearConversation();
    }
  };
  const clearConversation = () => {
    trackCopilotEvent("New Conversation", "", trackCustomEvents, config);
    SetTextareaChatValue("");
    setCount(0);
    SetDisableSend(true);
    handleResetConversation();
    setshowSuggestionPopUpComponent(false);
  };
  const onSuggestionSubmit = (suggestion) => {
    SetTextareaChatValue(suggestion);
    setCount(suggestion.length);
    SetDisableSend(false);
    textareaRef?.current?.focus();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.promptLibrary, children: isPromptVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
      PromptSuggestion,
      {
        prompts: configInfo?.promptsLibrarySuggestions,
        SetTextareaChatValue,
        setCount,
        isPromptVisible,
        setIsPromptVisible,
        textareaRef,
        handlePromptSuggestions,
        handlePromptSelected,
        trackCustomEvents
      }
    ) }),
    isSlashPromptVisible && IsSlashCommandEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotSlashPrompt$1, { getProjectTeamsData, searchData: getSearchText, onItemClick, isFullScreen }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: footerMedia, children: [
      showChangeTopic && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.changeTopicOuter, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.changeTopicOuter, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: styles.changeTopicInner,
          onClick: clearConversation,
          onKeyDown: handleKeyDown,
          tabIndex: 0,
          role: "button",
          "aria-label": newConversation,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: theme == "dark" ? changetopicWhite : changetopicBlack,
                alt: "Icon Image",
                className: styles.imageIcon
              }
            ),
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: styles.spanText, children: newConversation })
          ]
        }
      ) }) }),
      isResponseSuggestionEnabled && suggestionQuestions ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.suggestion, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ViewSuggestions,
        {
          onSuggestionSubmit,
          suggestionQuestions,
          onSuggestionHeightChange
        }
      ) }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "footer-textarea", children: [
        isSuggestionPopUpEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
          SuggestionPopUp,
          {
            prompts: suggestionPopUpList,
            onPromptSelected: handlePromptSelected,
            SetTextareaChatValue,
            setCount,
            SetShowChangeTopic,
            textareaRef
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Textarea,
          {
            ref: textareaRef,
            className: "textarea-chat",
            role: "textbox",
            showCount: true,
            count: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
              count,
              "/",
              maxCount
            ] }),
            rows: 3,
            cols: 5,
            maxLength: maxCount,
            onChange: handleOnChange,
            onKeyDown: (e) => handleKeyDownFooter(e),
            onSubmit: () => handleSubmit(textareaChatValue),
            disableSend,
            value: textareaChatValue,
            send: { role: "button", "aria-label": "send", title: "send" },
            style: {
              maxWidth: "none",
              marginRight: 0,
              maxHeight: "97px",
              marginTop: isPromptVisible ? "0px" : "2px"
            },
            contentAfter: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              isToggleVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { display: "flex", alignItems: "center" }, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Button,
                  {
                    "aria-label": "voice-input",
                    role: "button",
                    appearance: "transparent",
                    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Mic20Regular, {}),
                    disabled: !isToggled,
                    onMouseDown: runSpeechRecognition,
                    onMouseUp: handleStopRecognition,
                    onMouseLeave: handleStopRecognition,
                    title: "hold and speak"
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { margin: "0 4px" }, vertical: true })
              ] }),
              configInfo?.isPromptButtonVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "span",
                {
                  style: { display: "flex", alignItems: "center" },
                  ref: promptsButtonRef,
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      TeachingBubblePopup,
                      {
                        handlePromptSuggestions
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { margin: "0 4px" }, vertical: true })
                  ]
                }
              )
            ] }),
            "aria-label": "Copilot Chat",
            placeholder: askQuestion
          }
        )
      ] })
    ] })
  ] });
};

const useStyles$8 = makeStyles({
  provider: {
    backgroundColor: tokens$2.colorNeutralBackground3,
    ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
    ...shorthands.borderRadius(tokens$2.borderRadiusXLarge),
    display: "flex",
    rowGap: "16px",
    flexDirection: "column"
  },
  chat: {
    height: "auto",
    ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    scrollBehavior: "smooth",
    backgroundColor: tokens$2.colorNeutralBackground3
  },
  outerChat: {
    height: "calc(100vh - 280px)",
    // (props) => (props?.copilotHeight == "auto" ? "auto" : "calc(100vh - 266px)"),
    backgroundColor: tokens$2.colorNeutralBackground3
  },
  outerChatMedia: {
    "@media screen and (min-resolution: 350dpi)": {
      height: "auto"
    }
  },
  sugesstionChat: {
    height: "calc(100vh - 370px)",
    ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
    overflowY: "auto",
    backgroundColor: tokens$2.colorNeutralBackground3
  },
  suggestionOuterChat: {
    height: "calc(100vh - 340px)",
    backgroundColor: tokens$2.colorNeutralBackground3
  },
  footer: {
    ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
    backgroundColor: tokens$2.colorNeutralBackground3,
    position: "fixed",
    width: "100%",
    bottom: "2px",
    paddingLeft: "10px",
    paddingRight: "10px"
  },
  footerMedia: {
    "@media screen and (min-resolution: 350dpi)": {
      position: "relative"
    }
  }
});
const RootChat = ({
  mcapsBotContext,
  alias,
  messages,
  welcomeGreeting,
  setMessages,
  handleMessageHistory,
  setIsSpinnerActive,
  isSpinnerActive,
  isFullScreen,
  isToggled,
  onShowIrisBot,
  sessionId,
  parentId,
  setParentId,
  setSessionId,
  positiveFeedback,
  negativeFeedback,
  ocvData,
  authToken,
  pageInfo,
  trackCustomEvents,
  getBearerTokenCallback,
  getAdditionalHeaderCallback,
  textBoxLength,
  isCreateIncidentButtonVisible,
  isCopyButtonVisible,
  isVersionVisible,
  IrisBotMessage,
  theme,
  suggestionPopupCharacterThreshold,
  suggestionPopupCount,
  isAutoSuggestionEnabled,
  apiBaseUrl,
  isResponseSuggestionEnabled,
  additionalContextDetails,
  receivedCommandFromExternalSystem,
  additionalHelpButtonCallback,
  isHistoryLoaded,
  isContextChanged,
  getProjectTeamsData,
  IsSlashCommandEnabled
}) => {
  const { height, width } = useWindowDimensions();
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  const styles = useStyles$8();
  const outerChatWithMedia = mergeClasses(
    styles.outerChat,
    width < "3240" && styles.outerChatMedia
  );
  const scrollDiv = React__default.useRef(null);
  const dispatch = useDispatch();
  const config = useSelector((state) => state.config.config);
  const [isSendDisabled, setIsSendDisabled] = useState(false);
  const [conversationId, setConversationId] = useState("");
  const [appInsights, setappInsights] = useState(null);
  const [textareaValue, setTextareaValue] = useState("");
  const [suggestionQuestions, setSuggestionQuestions] = useState([]);
  const [navgigationLogURL, setnavgigationLogURL] = useState(
    pageInfo?.split("/")?.pop()
  );
  const [suggestionControlHeight, setSuggestionControlHeight] = useState(0);
  const [isExternalCommandReceived, setIsExternalCommandReceived] = useState(false);
  const [latencyLoaderProps, setLatencyLoaderProps] = useState({
    isLoading: true,
    delay: 300,
    message: "Loading data...",
    ariaLabel: "Loading",
    spinnerSize: "medium",
    onCancel: () => {
      console.log("Loading cancelled");
    }
  });
  const [isSendGreeting, setIsSendGreeting] = useState(false);
  useEffect(() => {
    if (!isSendGreeting) {
      sendGreeting();
      const appInsightObj = initializeAppInsights(
        config?.appInsightConfig?.instrumentationKey
      );
      setappInsights(appInsightObj);
      setSuggestionQuestions([]);
      setIsSendGreeting(true);
    }
  }, []);
  useEffect(() => {
    if (receivedCommandFromExternalSystem?.LoaderText) {
      setLatencyLoaderProps((prevProps) => ({
        ...prevProps,
        message: receivedCommandFromExternalSystem.LoaderText
      }));
    }
    if (receivedCommandFromExternalSystem?.Type === "Command") {
      handleCommand(receivedCommandFromExternalSystem);
    }
  }, [receivedCommandFromExternalSystem]);
  const handleCommand = async (receivedCommandFromExternalSystem2) => {
    setIsSendDisabled(true);
    setIsSpinnerActive(true);
    setIsExternalCommandReceived(true);
    let conversationArray = messages;
    try {
      let response = await PostAsync(
        getBearerTokenCallback,
        config?.apiUrls?.commandApi,
        JSON.stringify(receivedCommandFromExternalSystem2),
        getAdditionalHeaderCallback
      );
      response = { reply: response };
      if (response.reply && typeof response.reply == "string") {
        response.reply = JSON.parse(response.reply);
      }
      let responseObject = response.reply;
      if (response.reply?.data && typeof response.reply?.data == "string") {
        response.reply = JSON.parse(response.reply?.data);
      }
      if (response.reply && typeof response.reply == "string") {
        response.reply = JSON.parse(response.reply);
      }
      let conversationArray2 = messages;
      conversationArray2.push({
        id: generateId(),
        from: "bot",
        type: "message",
        receivedCommandFromExternalSystem: receivedCommandFromExternalSystem2,
        responseType: responseObject?.responseType,
        responseSource: responseObject?.source,
        message: response.reply && response.reply.data ? response.reply.data : response.reply ? response.reply : response.reply.data ? response : "",
        isFeedbackEnabled: true,
        isFeedbackUpvoted: null,
        dateTime: getDateTime()
      });
      let pid = response.data && response.data.parentId ? response.data.parentId : response.reply && response.reply.parentId ? response.reply.parentId : parentId;
      setMessages(conversationArray2);
      handleMessageHistory(conversationArray2);
      setIsSendDisabled(false);
      setIsSpinnerActive(false);
    } catch (error) {
      console.log("Error: ", error);
      const botResponseMessageId = generateId();
      conversationArray.push({
        id: botResponseMessageId,
        from: "bot",
        type: "message",
        receivedCommandFromExternalSystem: receivedCommandFromExternalSystem2,
        message: SystemIssue,
        dateTime: getDateTime()
      });
      setMessages(conversationArray);
      handleMessageHistory(conversationArray);
      trackCustomEvents ? trackCustomEvents(
        mcapsBotContext.appName + " Command failed",
        "User question: " + receivedCommandFromExternalSystem2.Payload.data,
        JSON.stringify({
          userName: mcapsBotContext.currentUserName,
          conversationId,
          messageId: conversationId,
          userQuestion: receivedCommandFromExternalSystem2.Payload.data,
          botResponse: error.toString(),
          pageInfo: navgigationLogURL ? navgigationLogURL : "Home"
        })
      ) : appInsights?.trackEvent({
        name: mcapsBotContext.appName + " Command failed",
        properties: {
          "User question": receivedCommandFromExternalSystem2.Payload.data,
          additionalInfo: JSON.stringify({
            userName: mcapsBotContext.currentUserName,
            conversationId,
            messageId: conversationId,
            userQuestion: receivedCommandFromExternalSystem2.Payload.data,
            botResponse: error.toString(),
            pageInfo: navgigationLogURL ? navgigationLogURL : "Home"
          })
        }
      });
      setIsSpinnerActive(false);
      setSuggestionQuestions([]);
    }
  };
  React__default.useEffect(() => {
    setTimeout(() => {
      scrollDiv.current?.scrollTo({ top: scrollDiv?.current?.scrollHeight });
    }, 0);
  });
  const enableSend = () => {
    setIsSendDisabled(false);
  };
  const sendMessage = async (question) => {
    try {
      setTextareaValue("");
      let suggestions = config?.botSuggestionMessage;
      let suggestionFlag = false;
      if (suggestions && typeof suggestions == "string") {
        suggestions = suggestions.replace(/&quot;/g, '"');
        suggestions = JSON.parse(suggestions);
      }
      suggestionFlag = suggestions?.includes(question);
      ocvData && ocvData(true, null);
      setIsSendDisabled(true);
      setIsSpinnerActive(true);
      setIsExternalCommandReceived(false);
      let conversationArray = messages;
      conversationArray.push({
        id: generateId(),
        from: "user",
        type: "message",
        message: question,
        dateTime: getDateTime()
      });
      setMessages(conversationArray);
      handleMessageHistory(conversationArray);
      const getAdditionalContextDetails = additionalContextDetails || {};
      const getPidContext = getAdditionalContextDetails?.pid;
      const getIsProgramContext = getAdditionalContextDetails?.isProgram === "True" ? true : getAdditionalContextDetails?.isProgram === "False" ? false : getAdditionalContextDetails?.isProgram;
      const pageLocation = getAdditionalContextDetails?.pageLocation;
      try {
        const requestBody = JSON.stringify({
          question,
          parentId: suggestionFlag ? "" : parentId,
          sessionId,
          conversationId,
          additionalContextDetails: getAdditionalContextDetails,
          pid: getPidContext,
          isProgram: getIsProgramContext,
          pageLocation
        });
        let response = await PostAsync(
          getBearerTokenCallback,
          config?.apiUrls?.questionApi,
          requestBody,
          getAdditionalHeaderCallback
        );
        trackCopilotEvent("Inquiry Started", getQuesAns(response), trackCustomEvents, config);
        if (response.responseType == "command" && response.data && typeof response.data == "string" && JSON.parse(response.data).intent === "createsupportticket") {
          onShowIrisBot();
        }
        response = { reply: response };
        if (response.reply && typeof response.reply == "string") {
          response.reply = JSON.parse(response.reply);
        }
        let responseObject = response.reply;
        if (response.reply?.data && typeof response.reply?.data == "string") {
          response.reply = JSON.parse(response.reply?.data);
        }
        if (response.reply && typeof response.reply == "string") {
          response.reply = JSON.parse(response.reply);
        }
        let conversationArray2 = messages;
        conversationArray2.push({
          id: generateId(),
          from: "bot",
          type: "message",
          question,
          responseType: responseObject?.responseType,
          responseSource: responseObject?.source,
          message: response.data && response.data.reply ? response.data.reply : response.reply ? response.reply : response.data ? response : "",
          isFeedbackEnabled: true,
          isFeedbackUpvoted: null,
          dateTime: getDateTime()
        });
        let pid = response.data && response.data.parentId ? response.data.parentId : response.reply && response.reply.parentId ? response.reply.parentId : parentId;
        setParentId(suggestionFlag ? "" : pid);
        setMessages(conversationArray2);
        handleMessageHistory(conversationArray2);
        let botResponse = typeof response.reply?.reply === "string" ? response.reply?.reply?.replace(/:/g, "") : typeof response.reply?.aiResponseData === "string" ? response.reply?.aiResponseData?.replace(/:/g, "") : response.reply?.reply ? response.reply?.reply : typeof response.reply?.contentData === "string" ? response.reply?.contentData.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "") : response.reply ? response.reply : response.data ? response : "";
        botResponse = responseObject?.responseType == "graph" || responseObject?.responseType == "markdown" & botResponse && botResponse.length >= appInsightsCharacterLimit ? noDataCaptured : botResponse;
        setIsSpinnerActive(false);
        if (isResponseSuggestionEnabled && response) {
          const requestBody2 = JSON.stringify({
            searchString: response.reply?.reply,
            numberOfRecords: SuggestionRecordsToGet
          });
          let suggestionsData = await PostAsync(
            getBearerTokenCallback,
            config?.apiUrls?.responseSuggestionApi,
            requestBody2,
            getAdditionalHeaderCallback
          );
          let suggestionsArray = suggestionsData.filter(
            (item) => item.suggestion
          );
          setSuggestionQuestions(suggestionsArray ? suggestionsArray : []);
        }
      } catch (error) {
        console.log(error);
        let errorObject = {
          question,
          conversationId,
          data: {
            errorCode: 500,
            errorMessage: error
          }
        };
        trackCopilotEvent("Inquiry failed", getQuesAns(errorObject), trackCustomEvents, config);
        const botResponseMessageId = generateId();
        conversationArray.push({
          id: botResponseMessageId,
          from: "bot",
          type: "message",
          question,
          message: SystemIssue,
          dateTime: getDateTime()
        });
        setMessages(conversationArray);
        handleMessageHistory(conversationArray);
        setIsSpinnerActive(false);
        setSuggestionQuestions([]);
      }
    } catch (error) {
      console.log("cst copilot outer try", error);
      appInsights?.trackEvent({
        name: mcapsBotContext.appName + " Inquiry",
        properties: {
          "User question": question,
          additionalInfo: JSON.stringify({
            userName: mcapsBotContext.currentUserName,
            conversationId,
            messageId: conversationId,
            userQuestion: question,
            botResponse: error,
            PageName: navgigationLogURL ? navgigationLogURL : "Home"
            // Assuming you want an empty string if response.data?.reply is undefined
          })
        }
      });
    }
  };
  const updateMessage = (id, messageProperties) => {
    let updatedMessage = null;
    const updatedMessages = messages.map((message) => {
      if (message.id === id) {
        updatedMessage = {
          ...message,
          ...messageProperties,
          conversationId
        };
        return updatedMessage;
      } else {
        return message;
      }
    });
    setMessages(updatedMessages);
    handleMessageHistory(updatedMessages);
    return updatedMessage;
  };
  const sendGreeting = async () => {
    const tempConversationID = generateId();
    setIsSendDisabled(true);
    setConversationId(generateId());
    setSessionId(generateId());
    setSessionId(tempConversationID);
    dispatch(
      set_configuration({
        ...config,
        chatConversationID: tempConversationID
      })
    );
    trackCopilotEvent("Opened", "", trackCustomEvents, config);
    setIsSpinnerActive(true);
    generateId();
    welcomeGreeting?.suggestions?.length > 0 && welcomeGreeting?.suggestions?.map((item) => {
      return { value: item.replace(/&quot;/g, '"'), isSelected: false };
    });
    setIsSpinnerActive(false);
  };
  const handleSendMessage = (data) => {
    sendMessage(data);
  };
  const handlePromptSelected = (PromptData) => {
    setTextareaValue(PromptData);
  };
  useEffect(() => {
    if (isHistoryLoaded && isContextChanged) {
      handleResetConversation();
    }
  }, [isHistoryLoaded, isContextChanged]);
  const handleResetConversation = () => {
    try {
      setConversationId(generateId());
      setConversationId(generateId());
      let conversationArray = messages;
      if (conversationArray[conversationArray.length - 1].type !== "seperator") {
        console.log("Resetting conversation-", conversationArray.length);
        setParentId("");
        conversationArray.push({
          id: generateId(),
          from: "newConversation",
          type: "seperator",
          question: "",
          message: "",
          isFeedbackEnabled: false,
          isFeedbackUpvoted: null,
          dateTime: getDateTime()
        });
        setMessages(conversationArray);
        handleMessageHistory(conversationArray);
        setTimeout(() => {
          trackCustomEvents ? trackCustomEvents(
            mcapsBotContext.appName + " Chat reset",
            "Chat reset",
            JSON.stringify({
              userName: mcapsBotContext.currentUserName,
              conversationId,
              messageId: conversationId,
              PageName: navgigationLogURL ? navgigationLogURL : "Home"
            })
          ) : appInsights?.trackEvent({
            name: mcapsBotContext.appName + " Chat reset",
            properties: {
              additionalInfo: JSON.stringify({
                userName: mcapsBotContext.currentUserName,
                conversationId,
                messageId: conversationId,
                PageName: navgigationLogURL ? navgigationLogURL : "Home"
              })
            }
          });
        }, 200);
      } else {
        console.log("Not resetting conversation-", conversationArray.length);
      }
    } catch (error) {
      console.error("Error resetting conversation: ", error);
    }
  };
  const CreateAutoBotResponse = () => {
    onShowIrisBot();
    try {
      let userMessage = {
        id: generateId(),
        from: "user",
        type: "message",
        message: "Create a Support Ticket",
        dateTime: getDateTime()
      };
      let botResponse = IrisBotMessage;
      let botMessage = {
        id: generateId(),
        from: "bot",
        type: "message",
        message: botResponse,
        dateTime: getDateTime(),
        isCreateIncidentButtonVisible: false
      };
      let conversationArray = [...messages, userMessage, botMessage];
      setMessages(conversationArray);
      handleMessageHistory(conversationArray);
      console.log("Conversation Array: ", conversationArray);
    } catch (error) {
      console.error("Error sending message: ", error);
    }
  };
  const onSuggestionHeightChange = (height2) => {
    setSuggestionControlHeight(height2);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FluentProvider, { theme: theme == "dark" ? webDarkTheme : webLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    CopilotProvider,
    {
      mode: "sidecar",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CopilotChat,
          {
            className: isResponseSuggestionEnabled ? styles.suggestionOuterChat : outerChatWithMedia,
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              CopilotChat,
              {
                className: isResponseSuggestionEnabled ? styles.sugesstionChat : styles.chat,
                ref: scrollDiv,
                children: [
                  authToken ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    config?.botSuggestionMessage && /* @__PURE__ */ jsxRuntimeExports.jsx(
                      SuggestionPrompt,
                      {
                        prompts: config?.botSuggestionMessage,
                        onPromptSelected: handlePromptSelected,
                        trackCustomEvents
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      MessageBody,
                      {
                        messages,
                        updateMessage,
                        sendMessage,
                        enableSend,
                        isSpinnerActive,
                        isSendDisabled,
                        isFullScreen,
                        welcomeMessage: welcomeGreeting.message,
                        isToggled,
                        onShowIrisBot,
                        IrisBotMessage: CreateAutoBotResponse,
                        positiveFeedback,
                        negativeFeedback,
                        ocvData,
                        isCreateIncidentButtonVisible,
                        isCopyButtonVisible,
                        trackCustomEvents,
                        additionalHelpButtonCallback
                      }
                    )
                  ] }) : isExternalCommandReceived ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}),
                  isSpinnerActive && (isExternalCommandReceived ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    ProgressIndicator,
                    {
                      ...latencyLoaderProps
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}))
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FooterMessageBox,
          {
            handleSendMessage,
            handleResetConversation,
            isToggled,
            theme,
            textareaValue,
            suggestionPopupCharacterThreshold,
            suggestionPopupCount,
            isAutoSuggestionEnabled,
            getBearerTokenCallback,
            apiBaseUrl,
            isResponseSuggestionEnabled,
            suggestionQuestions,
            onSuggestionHeightChange,
            handlePromptSelected,
            trackCustomEvents,
            getProjectTeamsData,
            IsSlashCommandEnabled,
            isFullScreen
          }
        )
      ]
    }
  ) }) });
};

const SET_HISTORY = "SET_HISTORY";
const set_history = (message) => ({
  type: SET_HISTORY,
  message
});
const initialState$4 = {
  message: []
};
const historyReducer = (state = initialState$4, action) => {
  switch (action.type) {
    case SET_HISTORY:
      const { message } = action;
      return { ...state, message };
    default:
      return state;
  }
};

initializeIcons();
const useStyles$7 = makeStyles({
  leftSection: {
    float: "left",
    width: "60%",
    display: "flex",
    "@media (min-resolution: 350dpi)": {
      alignItems: "center",
      justifyContent: "center",
      height: "auto",
      textAlign: "center"
    }
  },
  headTag: {
    fontWeight: 600,
    paddingLeft: "30px",
    fontFamily: "Segoe UI",
    fontSize: "16px",
    textAlign: "left",
    marginTop: "2px",
    alignItems: "start",
    position: "absolute",
    display: "flex",
    "@media (min-resolution: 350dpi)": {
      left: "10px",
      paddingLeft: "none",
      marginTop: "8px"
    }
  },
  imageTag: {
    height: "24px",
    width: "24px",
    rowGap: "4px",
    opacity: "0px",
    "@media (min-resolution: 350dpi)": {
      // width: "10px",
      // height: "10px",
      left: "10px",
      position: "absolute"
    }
  },
  centerSection: {
    right: "2px",
    width: "9%"
  },
  rightSection: {
    float: "left",
    right: "2px",
    position: "absolute",
    width: "30%",
    textAlign: "end",
    display: "flex"
  },
  headerBtton: {
    fontSize: "18px",
    backgroundColor: tokens$2.colorNeutralBackground3,
    border: "none !important",
    margin: "0px"
  },
  // headerBttonIcon: {
  //   "@media (max-width: 2400px) and (max-height: 1600px) and (min-resolution: 150dpi)": {
  //     fontSize: "10px",
  //   },
  // },
  buttonArea: {
    right: "5px",
    position: "fixed",
    "@media (min-resolution: 350dpi)": {
      marginTop: "-16px",
      justifyContent: "end",
      right: "2px",
      position: "absolute"
    }
  }
});
const DBCopilotBot = (props) => {
  const styles = useStyles$7();
  const dispatch = useDispatch();
  const history = useSelector((state) => state.history);
  const [messages, setMessages] = React__default.useState([]);
  const [isSpinnerActive, setIsSpinnerActive] = React__default.useState(false);
  const [welcomeGreeting, setWelcomeGreeting] = React__default.useState({
    message: "",
    suggestions: []
  });
  const { height, width } = useWindowDimensions();
  const [sessionId, setSessionId] = React__default.useState(generateId());
  const [parentId, setParentId] = React__default.useState("");
  const [authToken, setAuthToken] = React__default.useState(null);
  const [isFullScreen, setIsFullScreen] = React__default.useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [isHistoryLoaded, setIsHistoryLoaded] = useState(false);
  const [isContextChanged, setIsContextChanged] = useState(false);
  const botConversationid = useSelector((state) => state.config.config);
  const config = useSelector((state) => state.config.config);
  useSelector((state) => state.appname.appName);
  const { trackCopilotEvent } = useTrackCustomEvents$1();
  initializeAppInsights(props.appInsightConfig?.instrumentationKey);
  const getPanelWidth = 0.25 * width < 500 ? isFullScreen ? "745px" : "480px" : 0.25 * width + "px";
  useEffect(() => {
    if (isFullScreen) {
      if (getPanelWidth === "745px") {
        $('div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"]').addClass("copilot-fullscreen");
      } else {
        if (getPanelWidth < "745px") {
          $('div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"]').addClass("copilot-fullscreenlg");
        }
      }
    } else {
      $('div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"]').removeClass("copilot-fullscreen");
      $('div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"]').removeClass("copilot-fullscreenlg");
    }
  }, [isFullScreen, getPanelWidth]);
  useEffect(() => {
    if (props.isHistoryFetched) {
      const historyMessages = props.maintainHistory && props.maintainHistory("GET").data && JSON.parse(props.maintainHistory("GET").data);
      const contextChanged = props.maintainHistory && props.maintainHistory("GET").isContextChanged;
      if (messages.length === 0 && history?.message.length > 0) {
        setMessages(history?.message);
        setIsHistoryLoaded(false);
        setIsContextChanged(contextChanged);
      } else if (messages.length === 0 && historyMessages && historyMessages.length > 0) {
        setMessages(historyMessages);
        setIsHistoryLoaded(true);
        setIsContextChanged(contextChanged);
      }
      props.maintainHistory("RESET");
    }
  }, [props.isHistoryFetched]);
  useEffect(() => {
    if (messages.length === 0 && history?.message.length > 0) {
      setMessages(history?.message);
      setIsHistoryLoaded(false);
    }
  }, [history?.message]);
  const handleMessageHistory = (message) => {
    dispatch(set_history(messages));
    props.maintainHistory && props.maintainHistory("SET", message);
  };
  const mcapsBotContext = {
    appName: props.appName,
    currentUserName: props.currentUserName,
    featureName: props.featureName
  };
  props.pageInfo?.split("/")?.pop();
  let suggestionsArray = props.botSuggestionMessage;
  let promptsSuggestionsArray = props.promptsSuggestions;
  if (suggestionsArray && typeof suggestionsArray == "string") {
    suggestionsArray = suggestionsArray.replace(/&quot;/g, '"');
    suggestionsArray = JSON.parse(suggestionsArray);
  }
  if (promptsSuggestionsArray && typeof promptsSuggestionsArray == "string") {
    promptsSuggestionsArray = promptsSuggestionsArray.replace(/&quot;/g, '"');
    promptsSuggestionsArray = JSON.parse(promptsSuggestionsArray);
  }
  const configuration = {
    apiUrls: props.apiUrls,
    msalInstance: props.msalInstance,
    appInsightConfig: {
      instrumentationKey: props.appInsightConfig?.instrumentationKey
    },
    botWelcomeMessage: props.botWelcomeMessage,
    botSuggestionMessage: suggestionsArray,
    promptsLibrarySuggestions: promptsSuggestionsArray,
    isToggleVisible: props.isToggleVisible,
    isTypewritingOn: props.isTypewritingOn,
    chatConversationID: botConversationid?.chatConversationID,
    maxCharacterAllowed: props.textBoxLength,
    IrisBotMessage: props.IrisBotMessage,
    theme: props.theme,
    createSupportTicketButtonText: props.createSupportTicketButtonText,
    isUserNameVisible: props.isUserNameVisible,
    isPromptButtonVisible: props.isPromptButtonVisible,
    pageInfo: props.pageInfo,
    mcapsBotContext,
    isPromptCoachmarkVisible: props.isPromptCoachmarkVisible,
    isCreateIncidentButtonVisible: props.isCreateIncidentButtonVisible,
    addionalHelpButtonSetting: props.addionalHelpButtonSetting,
    isCopyButtonVisible: props.isCopyButtonVisible,
    isVersionVisible: props.isVersionVisible
  };
  const handleToggleChange = (event, checked) => {
    setIsToggled(!!checked);
  };
  const handleAuthToken = async () => {
    if (props.getBearerTokenCallback) {
      try {
        const accessToken = await props.getBearerTokenCallback();
        configuration.accessToken = accessToken;
        setAuthToken(accessToken);
      } catch (error) {
        console.error("Error fetching access token:", error);
      }
    } else {
      configuration.accessToken = "default";
    }
  };
  const handleClearChat = () => {
    generateId();
    setMessages([]);
    setSessionId(generateId());
    setParentId("");
    dispatch(set_history([]));
    props.maintainHistory && props.maintainHistory("SET", null);
    trackCopilotEvent("Chat cleared", "", props.trackCustomEvents, config);
  };
  useLayoutEffect(() => {
    handleAuthToken();
    let response = props.botWelcomeMessage;
    let suggestionsArray2 = props.botSuggestionMessage;
    if (suggestionsArray2 && typeof suggestionsArray2 == "string") {
      suggestionsArray2 = suggestionsArray2.replace(/&quot;/g, '"');
      suggestionsArray2 = JSON.parse(suggestionsArray2);
    }
    response = response && response.replace(/&#(\d+);/g, (match, dec) => {
      return String.fromCharCode(dec);
    });
    response = response && response.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");
    setWelcomeGreeting({ message: response, suggestions: suggestionsArray2 });
  }, []);
  useEffect(() => {
    updateConfiguration();
  }, []);
  const updateConfiguration = () => {
    dispatch(set_user(props.currentUserName));
    dispatch(set_appName(mcapsBotContext.appName));
    dispatch(get_appName());
    dispatch(set_configuration(configuration));
    dispatch(get_configuration());
  };
  const closeCopilotChatBot = () => {
    trackCopilotEvent("Closed", "", props.trackCustomEvents, config);
    props.onPanelDismiss(false);
  };
  const onShowIrisBotClicked = () => {
    trackCopilotEvent("Create support ticket clicked", "", props.trackCustomEvents, config);
    props.onShowIrisBot();
  };
  const onAddionalHelpButtonClicked = () => {
    trackCopilotEvent(configuration.addionalHelpButtonSetting.buttonText + " Clicked", "", props.trackCustomEvents, config);
    props.additionalHelpButtonCallback();
  };
  const handleKeyDown = (event, purpose) => {
    if (event.key === "Enter") {
      switch (purpose) {
        case "ToggleAudio":
          handleToggleChange(event, event.target.checked);
          break;
        case "ExpandCollapse":
          setIsFullScreen(isFullScreen);
          break;
        case "Refresh":
          handleClearChat();
          break;
        case "Close":
          closeCopilotChatBot();
          break;
      }
    }
  };
  const renderDefaultHeader = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      FluentProvider,
      {
        theme: props.theme == "dark" ? webDarkTheme : webLightTheme,
        style: {
          width: "100%",
          padding: "18px",
          verticalAlign: "center",
          backgroundColor: tokens$2.colorNeutralBackground3,
          "@media (min-resolution: 350dpi)": {
            padding: "10px"
          }
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.leftSection, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: props.image, alt: "Icon Image", className: styles.imageTag }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { variant: "xLarge", className: styles.headTag, children: mcapsBotContext.featureName })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.rightSection, children: [
            configuration.isToggleVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Toggle,
              {
                title: isToggled ? "Toggle audio off" : "Toggle audio on",
                styles: {
                  root: {
                    cursor: "pointer",
                    border: "0.5px solid #000",
                    borderRadius: "20px",
                    width: "25%"
                  },
                  main: {
                    width: "25%"
                  }
                },
                checked: isToggled,
                onChange: handleToggleChange,
                onKeyDown: (event) => handleKeyDown(event, "ToggleAudio"),
                tabIndex: 0,
                role: "button",
                "aria-label": "toggle audio"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.buttonArea, children: [
              !isFullScreen ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button,
                {
                  "aria-label": "Expand",
                  className: styles.headerBtton,
                  title: "Expand",
                  role: "button",
                  tabIndex: 0,
                  onClick: () => setIsFullScreen(!isFullScreen),
                  onKeyDown: (event) => handleKeyDown(event, "ExpandCollapse"),
                  icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowMaximizeRegular, { className: styles.headerBttonIcon })
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button,
                {
                  title: "Collapse",
                  name: "Colapse",
                  role: "button",
                  onKeyDown: (event) => handleKeyDown(event, "ExpandCollapse"),
                  onClick: () => setIsFullScreen(!isFullScreen),
                  tabIndex: 0,
                  "aria-label": "Colapse",
                  icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowMinimizeRegular, { className: styles.headerBttonIcon }),
                  className: styles.headerBtton
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button,
                {
                  title: "Refresh",
                  tabIndex: 0,
                  onClick: handleClearChat,
                  onKeyDown: (event) => handleKeyDown(event, "Refresh"),
                  icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowClockwiseRegular, { className: styles.headerBttonIcon }),
                  role: "button",
                  "aria-label": "Refresh",
                  className: styles.headerBtton
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button,
                {
                  className: styles.headerBtton,
                  title: "Close",
                  role: "button",
                  onClick: closeCopilotChatBot,
                  onKeyDown: (event) => handleKeyDown(event, "Close"),
                  icon: /* @__PURE__ */ jsxRuntimeExports.jsx(DismissRegular, { className: styles.headerBttonIcon }),
                  "aria-label": "Close",
                  tabIndex: 0
                }
              )
            ] })
          ] })
        ]
      }
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppContextProvider$1, { mcapsBotContext, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    FocusTrapZone,
    {
      isClickableOutsideFocusTrap: true,
      forceFocusInsideTrap: false,
      children: [
        "        ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Panel,
          {
            styles: {
              ...props.panelStyles,
              closeButton: {
                display: "none"
              }
            },
            headerText: mcapsBotContext.featureName,
            isBlocking: false,
            isOpen: props.isPanelVisible,
            onRenderHeader: renderDefaultHeader,
            customWidth: getPanelWidth || "25%",
            type: PanelType.custom,
            headerClassName: "panelHeader",
            className: "mcapsBotPanel",
            allowTouchBodyScroll: true,
            ...props.panelProps,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              RootChat,
              {
                mcapsBotContext,
                alias: "",
                messages,
                welcomeGreeting,
                setMessages,
                handleMessageHistory,
                setIsSpinnerActive,
                isSpinnerActive,
                isFullScreen,
                isToggled,
                onShowIrisBot: () => {
                  onShowIrisBotClicked();
                },
                additionalHelpButtonCallback: () => {
                  onAddionalHelpButtonClicked();
                },
                sessionId,
                parentId,
                setParentId,
                setSessionId,
                positiveFeedback: props.positiveFeedback,
                negativeFeedback: props.negativeFeedback,
                ocvData: props.ocvData,
                authToken,
                pageInfo: props.pageInfo,
                trackCustomEvents: props.trackCustomEvents,
                getBearerTokenCallback: props.getBearerTokenCallback,
                getAdditionalHeaderCallback: props.getAdditionalHeaderCallback,
                textBoxLength: props.textBoxLength,
                isCreateIncidentButtonVisible: props.isCreateIncidentButtonVisible,
                isCopyButtonVisible: props.isCopyButtonVisible,
                isVersionVisible: props.isVersionVisible,
                IrisBotMessage: props.IrisBotMessage,
                theme: props.theme,
                suggestionPopupCharacterThreshold: props.suggestionPopupCharacterThreshold,
                suggestionPopupCount: props.suggestionPopupCount,
                isAutoSuggestionEnabled: props.isAutoSuggestionEnabled,
                apiBaseUrl: props.apiBaseUrl,
                isResponseSuggestionEnabled: props.isResponseSuggestionEnabled,
                additionalContextDetails: props.additionalContextDetails,
                receivedCommandFromExternalSystem: props.receivedCommandFromExternalSystem,
                isHistoryLoaded,
                isContextChanged,
                getProjectTeamsData: props.getProjectTeamsData,
                IsSlashCommandEnabled: props.IsSlashCommandEnabled
              }
            )
          }
        )
      ]
    }
  ) });
};

const DialogData = (props) => {
  const messageText = props.messages.reply.replace(/<Cell>/g, "").replace(/<\/Cell>/g, "").replace(/Cell>/g, "");
  const LinkRenderer = ({ href, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children });
  const MarkdownRenderer = ({ messageText: messageText2 }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "markdown-table", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { components: { a: LinkRenderer }, remarkPlugins: [remarkGfm], children: messageText2 }) });
  };
  React.useEffect(() => {
    const jsx2 = /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText });
    const htmlString = renderToString(jsx2);
    props.setCopyText(htmlString);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { tabIndex: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText }) });
};

var toastr$1 = {exports: {}};

var jquery = {exports: {}};

/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */

var hasRequiredJquery;

function requireJquery () {
	if (hasRequiredJquery) return jquery.exports;
	hasRequiredJquery = 1;
	(function (module) {
		(function(global, factory) {
		  {
		    module.exports = global.document ? factory(global, true) : function(w) {
		      if (!w.document) {
		        throw new Error("jQuery requires a window with a document");
		      }
		      return factory(w);
		    };
		  }
		})(typeof window !== "undefined" ? window : commonjsGlobal$1, function(window2, noGlobal) {
		  var arr = [];
		  var getProto = Object.getPrototypeOf;
		  var slice = arr.slice;
		  var flat = arr.flat ? function(array) {
		    return arr.flat.call(array);
		  } : function(array) {
		    return arr.concat.apply([], array);
		  };
		  var push = arr.push;
		  var indexOf = arr.indexOf;
		  var class2type = {};
		  var toString = class2type.toString;
		  var hasOwn = class2type.hasOwnProperty;
		  var fnToString = hasOwn.toString;
		  var ObjectFunctionString = fnToString.call(Object);
		  var support = {};
		  var isFunction = function isFunction2(obj) {
		    return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
		  };
		  var isWindow = function isWindow2(obj) {
		    return obj != null && obj === obj.window;
		  };
		  var document = window2.document;
		  var preservedScriptAttributes = {
		    type: true,
		    src: true,
		    nonce: true,
		    noModule: true
		  };
		  function DOMEval(code, node, doc) {
		    doc = doc || document;
		    var i, val, script = doc.createElement("script");
		    script.text = code;
		    if (node) {
		      for (i in preservedScriptAttributes) {
		        val = node[i] || node.getAttribute && node.getAttribute(i);
		        if (val) {
		          script.setAttribute(i, val);
		        }
		      }
		    }
		    doc.head.appendChild(script).parentNode.removeChild(script);
		  }
		  function toType(obj) {
		    if (obj == null) {
		      return obj + "";
		    }
		    return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
		  }
		  var version = "3.7.1", rhtmlSuffix = /HTML$/i, jQuery = function(selector, context) {
		    return new jQuery.fn.init(selector, context);
		  };
		  jQuery.fn = jQuery.prototype = {
		    // The current version of jQuery being used
		    jquery: version,
		    constructor: jQuery,
		    // The default length of a jQuery object is 0
		    length: 0,
		    toArray: function() {
		      return slice.call(this);
		    },
		    // Get the Nth element in the matched element set OR
		    // Get the whole matched element set as a clean array
		    get: function(num) {
		      if (num == null) {
		        return slice.call(this);
		      }
		      return num < 0 ? this[num + this.length] : this[num];
		    },
		    // Take an array of elements and push it onto the stack
		    // (returning the new matched element set)
		    pushStack: function(elems) {
		      var ret = jQuery.merge(this.constructor(), elems);
		      ret.prevObject = this;
		      return ret;
		    },
		    // Execute a callback for every element in the matched set.
		    each: function(callback) {
		      return jQuery.each(this, callback);
		    },
		    map: function(callback) {
		      return this.pushStack(jQuery.map(this, function(elem, i) {
		        return callback.call(elem, i, elem);
		      }));
		    },
		    slice: function() {
		      return this.pushStack(slice.apply(this, arguments));
		    },
		    first: function() {
		      return this.eq(0);
		    },
		    last: function() {
		      return this.eq(-1);
		    },
		    even: function() {
		      return this.pushStack(jQuery.grep(this, function(_elem, i) {
		        return (i + 1) % 2;
		      }));
		    },
		    odd: function() {
		      return this.pushStack(jQuery.grep(this, function(_elem, i) {
		        return i % 2;
		      }));
		    },
		    eq: function(i) {
		      var len = this.length, j = +i + (i < 0 ? len : 0);
		      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
		    },
		    end: function() {
		      return this.prevObject || this.constructor();
		    },
		    // For internal use only.
		    // Behaves like an Array's method, not like a jQuery method.
		    push,
		    sort: arr.sort,
		    splice: arr.splice
		  };
		  jQuery.extend = jQuery.fn.extend = function() {
		    var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
		    if (typeof target === "boolean") {
		      deep = target;
		      target = arguments[i] || {};
		      i++;
		    }
		    if (typeof target !== "object" && !isFunction(target)) {
		      target = {};
		    }
		    if (i === length) {
		      target = this;
		      i--;
		    }
		    for (; i < length; i++) {
		      if ((options = arguments[i]) != null) {
		        for (name in options) {
		          copy = options[name];
		          if (name === "__proto__" || target === copy) {
		            continue;
		          }
		          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
		            src = target[name];
		            if (copyIsArray && !Array.isArray(src)) {
		              clone = [];
		            } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
		              clone = {};
		            } else {
		              clone = src;
		            }
		            copyIsArray = false;
		            target[name] = jQuery.extend(deep, clone, copy);
		          } else if (copy !== undefined) {
		            target[name] = copy;
		          }
		        }
		      }
		    }
		    return target;
		  };
		  jQuery.extend({
		    // Unique for each copy of jQuery on the page
		    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
		    // Assume jQuery is ready without the ready module
		    isReady: true,
		    error: function(msg) {
		      throw new Error(msg);
		    },
		    noop: function() {
		    },
		    isPlainObject: function(obj) {
		      var proto, Ctor;
		      if (!obj || toString.call(obj) !== "[object Object]") {
		        return false;
		      }
		      proto = getProto(obj);
		      if (!proto) {
		        return true;
		      }
		      Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
		      return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
		    },
		    isEmptyObject: function(obj) {
		      var name;
		      for (name in obj) {
		        return false;
		      }
		      return true;
		    },
		    // Evaluates a script in a provided context; falls back to the global one
		    // if not specified.
		    globalEval: function(code, options, doc) {
		      DOMEval(code, { nonce: options && options.nonce }, doc);
		    },
		    each: function(obj, callback) {
		      var length, i = 0;
		      if (isArrayLike(obj)) {
		        length = obj.length;
		        for (; i < length; i++) {
		          if (callback.call(obj[i], i, obj[i]) === false) {
		            break;
		          }
		        }
		      } else {
		        for (i in obj) {
		          if (callback.call(obj[i], i, obj[i]) === false) {
		            break;
		          }
		        }
		      }
		      return obj;
		    },
		    // Retrieve the text value of an array of DOM nodes
		    text: function(elem) {
		      var node, ret = "", i = 0, nodeType = elem.nodeType;
		      if (!nodeType) {
		        while (node = elem[i++]) {
		          ret += jQuery.text(node);
		        }
		      }
		      if (nodeType === 1 || nodeType === 11) {
		        return elem.textContent;
		      }
		      if (nodeType === 9) {
		        return elem.documentElement.textContent;
		      }
		      if (nodeType === 3 || nodeType === 4) {
		        return elem.nodeValue;
		      }
		      return ret;
		    },
		    // results is for internal usage only
		    makeArray: function(arr2, results) {
		      var ret = results || [];
		      if (arr2 != null) {
		        if (isArrayLike(Object(arr2))) {
		          jQuery.merge(
		            ret,
		            typeof arr2 === "string" ? [arr2] : arr2
		          );
		        } else {
		          push.call(ret, arr2);
		        }
		      }
		      return ret;
		    },
		    inArray: function(elem, arr2, i) {
		      return arr2 == null ? -1 : indexOf.call(arr2, elem, i);
		    },
		    isXMLDoc: function(elem) {
		      var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
		      return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
		    },
		    // Support: Android <=4.0 only, PhantomJS 1 only
		    // push.apply(_, arraylike) throws on ancient WebKit
		    merge: function(first, second) {
		      var len = +second.length, j = 0, i = first.length;
		      for (; j < len; j++) {
		        first[i++] = second[j];
		      }
		      first.length = i;
		      return first;
		    },
		    grep: function(elems, callback, invert) {
		      var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
		      for (; i < length; i++) {
		        callbackInverse = !callback(elems[i], i);
		        if (callbackInverse !== callbackExpect) {
		          matches.push(elems[i]);
		        }
		      }
		      return matches;
		    },
		    // arg is for internal usage only
		    map: function(elems, callback, arg) {
		      var length, value, i = 0, ret = [];
		      if (isArrayLike(elems)) {
		        length = elems.length;
		        for (; i < length; i++) {
		          value = callback(elems[i], i, arg);
		          if (value != null) {
		            ret.push(value);
		          }
		        }
		      } else {
		        for (i in elems) {
		          value = callback(elems[i], i, arg);
		          if (value != null) {
		            ret.push(value);
		          }
		        }
		      }
		      return flat(ret);
		    },
		    // A global GUID counter for objects
		    guid: 1,
		    // jQuery.support is not used in Core but other projects attach their
		    // properties to it so it needs to exist.
		    support
		  });
		  if (typeof Symbol === "function") {
		    jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
		  }
		  jQuery.each(
		    "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
		    function(_i, name) {
		      class2type["[object " + name + "]"] = name.toLowerCase();
		    }
		  );
		  function isArrayLike(obj) {
		    var length = !!obj && "length" in obj && obj.length, type = toType(obj);
		    if (isFunction(obj) || isWindow(obj)) {
		      return false;
		    }
		    return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
		  }
		  function nodeName(elem, name) {
		    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		  }
		  var pop = arr.pop;
		  var sort = arr.sort;
		  var splice = arr.splice;
		  var whitespace = "[\\x20\\t\\r\\n\\f]";
		  var rtrimCSS = new RegExp(
		    "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		    "g"
		  );
		  jQuery.contains = function(a, b) {
		    var bup = b && b.parentNode;
		    return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
		    // IE doesn't have `contains` on SVG.
		    (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
		  };
		  var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
		  function fcssescape(ch, asCodePoint) {
		    if (asCodePoint) {
		      if (ch === "\0") {
		        return "�";
		      }
		      return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
		    }
		    return "\\" + ch;
		  }
		  jQuery.escapeSelector = function(sel) {
		    return (sel + "").replace(rcssescape, fcssescape);
		  };
		  var preferredDoc = document, pushNative = push;
		  (function() {
		    var i, Expr, outermostContext, sortInput, hasDuplicate, push2 = pushNative, document2, documentElement2, documentIsHTML, rbuggyQSA, matches, expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
		      if (a === b) {
		        hasDuplicate = true;
		      }
		      return 0;
		    }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
		    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		    `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + attributes + ")*)|.*)\\)|)", rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
		      ID: new RegExp("^#(" + identifier + ")"),
		      CLASS: new RegExp("^\\.(" + identifier + ")"),
		      TAG: new RegExp("^(" + identifier + "|[*])"),
		      ATTR: new RegExp("^" + attributes),
		      PSEUDO: new RegExp("^" + pseudos),
		      CHILD: new RegExp(
		        "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)",
		        "i"
		      ),
		      bool: new RegExp("^(?:" + booleans + ")$", "i"),
		      // For use in libraries implementing .is()
		      // We use this for POS matching in `select`
		      needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
		    }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rquickExpr2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
		      var high = "0x" + escape.slice(1) - 65536;
		      if (nonHex) {
		        return nonHex;
		      }
		      return high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
		    }, unloadHandler = function() {
		      setDocument();
		    }, inDisabledFieldset = addCombinator(
		      function(elem) {
		        return elem.disabled === true && nodeName(elem, "fieldset");
		      },
		      { dir: "parentNode", next: "legend" }
		    );
		    function safeActiveElement() {
		      try {
		        return document2.activeElement;
		      } catch (err) {
		      }
		    }
		    try {
		      push2.apply(
		        arr = slice.call(preferredDoc.childNodes),
		        preferredDoc.childNodes
		      );
		      arr[preferredDoc.childNodes.length].nodeType;
		    } catch (e) {
		      push2 = {
		        apply: function(target, els) {
		          pushNative.apply(target, slice.call(els));
		        },
		        call: function(target) {
		          pushNative.apply(target, slice.call(arguments, 1));
		        }
		      };
		    }
		    function find(selector, context, results, seed) {
		      var m, i2, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, nodeType = context ? context.nodeType : 9;
		      results = results || [];
		      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
		        return results;
		      }
		      if (!seed) {
		        setDocument(context);
		        context = context || document2;
		        if (documentIsHTML) {
		          if (nodeType !== 11 && (match = rquickExpr2.exec(selector))) {
		            if (m = match[1]) {
		              if (nodeType === 9) {
		                if (elem = context.getElementById(m)) {
		                  if (elem.id === m) {
		                    push2.call(results, elem);
		                    return results;
		                  }
		                } else {
		                  return results;
		                }
		              } else {
		                if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
		                  push2.call(results, elem);
		                  return results;
		                }
		              }
		            } else if (match[2]) {
		              push2.apply(results, context.getElementsByTagName(selector));
		              return results;
		            } else if ((m = match[3]) && context.getElementsByClassName) {
		              push2.apply(results, context.getElementsByClassName(m));
		              return results;
		            }
		          }
		          if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
		            newSelector = selector;
		            newContext = context;
		            if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
		              newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
		              if (newContext != context || !support.scope) {
		                if (nid = context.getAttribute("id")) {
		                  nid = jQuery.escapeSelector(nid);
		                } else {
		                  context.setAttribute("id", nid = expando);
		                }
		              }
		              groups = tokenize(selector);
		              i2 = groups.length;
		              while (i2--) {
		                groups[i2] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i2]);
		              }
		              newSelector = groups.join(",");
		            }
		            try {
		              push2.apply(
		                results,
		                newContext.querySelectorAll(newSelector)
		              );
		              return results;
		            } catch (qsaError) {
		              nonnativeSelectorCache(selector, true);
		            } finally {
		              if (nid === expando) {
		                context.removeAttribute("id");
		              }
		            }
		          }
		        }
		      }
		      return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
		    }
		    function createCache() {
		      var keys = [];
		      function cache(key, value) {
		        if (keys.push(key + " ") > Expr.cacheLength) {
		          delete cache[keys.shift()];
		        }
		        return cache[key + " "] = value;
		      }
		      return cache;
		    }
		    function markFunction(fn) {
		      fn[expando] = true;
		      return fn;
		    }
		    function assert(fn) {
		      var el = document2.createElement("fieldset");
		      try {
		        return !!fn(el);
		      } catch (e) {
		        return false;
		      } finally {
		        if (el.parentNode) {
		          el.parentNode.removeChild(el);
		        }
		        el = null;
		      }
		    }
		    function createInputPseudo(type) {
		      return function(elem) {
		        return nodeName(elem, "input") && elem.type === type;
		      };
		    }
		    function createButtonPseudo(type) {
		      return function(elem) {
		        return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
		      };
		    }
		    function createDisabledPseudo(disabled) {
		      return function(elem) {
		        if ("form" in elem) {
		          if (elem.parentNode && elem.disabled === false) {
		            if ("label" in elem) {
		              if ("label" in elem.parentNode) {
		                return elem.parentNode.disabled === disabled;
		              } else {
		                return elem.disabled === disabled;
		              }
		            }
		            return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
		            elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
		          }
		          return elem.disabled === disabled;
		        } else if ("label" in elem) {
		          return elem.disabled === disabled;
		        }
		        return false;
		      };
		    }
		    function createPositionalPseudo(fn) {
		      return markFunction(function(argument) {
		        argument = +argument;
		        return markFunction(function(seed, matches2) {
		          var j, matchIndexes = fn([], seed.length, argument), i2 = matchIndexes.length;
		          while (i2--) {
		            if (seed[j = matchIndexes[i2]]) {
		              seed[j] = !(matches2[j] = seed[j]);
		            }
		          }
		        });
		      });
		    }
		    function testContext(context) {
		      return context && typeof context.getElementsByTagName !== "undefined" && context;
		    }
		    function setDocument(node) {
		      var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
		      if (doc == document2 || doc.nodeType !== 9 || !doc.documentElement) {
		        return document2;
		      }
		      document2 = doc;
		      documentElement2 = document2.documentElement;
		      documentIsHTML = !jQuery.isXMLDoc(document2);
		      matches = documentElement2.matches || documentElement2.webkitMatchesSelector || documentElement2.msMatchesSelector;
		      if (documentElement2.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
		      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		      // two documents; shallow comparisons work.
		      // eslint-disable-next-line eqeqeq
		      preferredDoc != document2 && (subWindow = document2.defaultView) && subWindow.top !== subWindow) {
		        subWindow.addEventListener("unload", unloadHandler);
		      }
		      support.getById = assert(function(el) {
		        documentElement2.appendChild(el).id = jQuery.expando;
		        return !document2.getElementsByName || !document2.getElementsByName(jQuery.expando).length;
		      });
		      support.disconnectedMatch = assert(function(el) {
		        return matches.call(el, "*");
		      });
		      support.scope = assert(function() {
		        return document2.querySelectorAll(":scope");
		      });
		      support.cssHas = assert(function() {
		        try {
		          document2.querySelector(":has(*,:jqfake)");
		          return false;
		        } catch (e) {
		          return true;
		        }
		      });
		      if (support.getById) {
		        Expr.filter.ID = function(id) {
		          var attrId = id.replace(runescape, funescape);
		          return function(elem) {
		            return elem.getAttribute("id") === attrId;
		          };
		        };
		        Expr.find.ID = function(id, context) {
		          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
		            var elem = context.getElementById(id);
		            return elem ? [elem] : [];
		          }
		        };
		      } else {
		        Expr.filter.ID = function(id) {
		          var attrId = id.replace(runescape, funescape);
		          return function(elem) {
		            var node2 = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
		            return node2 && node2.value === attrId;
		          };
		        };
		        Expr.find.ID = function(id, context) {
		          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
		            var node2, i2, elems, elem = context.getElementById(id);
		            if (elem) {
		              node2 = elem.getAttributeNode("id");
		              if (node2 && node2.value === id) {
		                return [elem];
		              }
		              elems = context.getElementsByName(id);
		              i2 = 0;
		              while (elem = elems[i2++]) {
		                node2 = elem.getAttributeNode("id");
		                if (node2 && node2.value === id) {
		                  return [elem];
		                }
		              }
		            }
		            return [];
		          }
		        };
		      }
		      Expr.find.TAG = function(tag, context) {
		        if (typeof context.getElementsByTagName !== "undefined") {
		          return context.getElementsByTagName(tag);
		        } else {
		          return context.querySelectorAll(tag);
		        }
		      };
		      Expr.find.CLASS = function(className, context) {
		        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
		          return context.getElementsByClassName(className);
		        }
		      };
		      rbuggyQSA = [];
		      assert(function(el) {
		        var input;
		        documentElement2.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a><select id='" + expando + "-\r\\' disabled='disabled'><option selected=''></option></select>";
		        if (!el.querySelectorAll("[selected]").length) {
		          rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
		        }
		        if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
		          rbuggyQSA.push("~=");
		        }
		        if (!el.querySelectorAll("a#" + expando + "+*").length) {
		          rbuggyQSA.push(".#.+[+~]");
		        }
		        if (!el.querySelectorAll(":checked").length) {
		          rbuggyQSA.push(":checked");
		        }
		        input = document2.createElement("input");
		        input.setAttribute("type", "hidden");
		        el.appendChild(input).setAttribute("name", "D");
		        documentElement2.appendChild(el).disabled = true;
		        if (el.querySelectorAll(":disabled").length !== 2) {
		          rbuggyQSA.push(":enabled", ":disabled");
		        }
		        input = document2.createElement("input");
		        input.setAttribute("name", "");
		        el.appendChild(input);
		        if (!el.querySelectorAll("[name='']").length) {
		          rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + `*(?:''|"")`);
		        }
		      });
		      if (!support.cssHas) {
		        rbuggyQSA.push(":has");
		      }
		      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
		      sortOrder = function(a, b) {
		        if (a === b) {
		          hasDuplicate = true;
		          return 0;
		        }
		        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		        if (compare) {
		          return compare;
		        }
		        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : (
		          // Otherwise we know they are disconnected
		          1
		        );
		        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
		          if (a === document2 || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
		            return -1;
		          }
		          if (b === document2 || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
		            return 1;
		          }
		          return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
		        }
		        return compare & 4 ? -1 : 1;
		      };
		      return document2;
		    }
		    find.matches = function(expr, elements) {
		      return find(expr, null, null, elements);
		    };
		    find.matchesSelector = function(elem, expr) {
		      setDocument(elem);
		      if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
		        try {
		          var ret = matches.call(elem, expr);
		          if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
		          // fragment in IE 9
		          elem.document && elem.document.nodeType !== 11) {
		            return ret;
		          }
		        } catch (e) {
		          nonnativeSelectorCache(expr, true);
		        }
		      }
		      return find(expr, document2, null, [elem]).length > 0;
		    };
		    find.contains = function(context, elem) {
		      if ((context.ownerDocument || context) != document2) {
		        setDocument(context);
		      }
		      return jQuery.contains(context, elem);
		    };
		    find.attr = function(elem, name) {
		      if ((elem.ownerDocument || elem) != document2) {
		        setDocument(elem);
		      }
		      var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
		      if (val !== undefined) {
		        return val;
		      }
		      return elem.getAttribute(name);
		    };
		    find.error = function(msg) {
		      throw new Error("Syntax error, unrecognized expression: " + msg);
		    };
		    jQuery.uniqueSort = function(results) {
		      var elem, duplicates = [], j = 0, i2 = 0;
		      hasDuplicate = !support.sortStable;
		      sortInput = !support.sortStable && slice.call(results, 0);
		      sort.call(results, sortOrder);
		      if (hasDuplicate) {
		        while (elem = results[i2++]) {
		          if (elem === results[i2]) {
		            j = duplicates.push(i2);
		          }
		        }
		        while (j--) {
		          splice.call(results, duplicates[j], 1);
		        }
		      }
		      sortInput = null;
		      return results;
		    };
		    jQuery.fn.uniqueSort = function() {
		      return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
		    };
		    Expr = jQuery.expr = {
		      // Can be adjusted by the user
		      cacheLength: 50,
		      createPseudo: markFunction,
		      match: matchExpr,
		      attrHandle: {},
		      find: {},
		      relative: {
		        ">": { dir: "parentNode", first: true },
		        " ": { dir: "parentNode" },
		        "+": { dir: "previousSibling", first: true },
		        "~": { dir: "previousSibling" }
		      },
		      preFilter: {
		        ATTR: function(match) {
		          match[1] = match[1].replace(runescape, funescape);
		          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
		          if (match[2] === "~=") {
		            match[3] = " " + match[3] + " ";
		          }
		          return match.slice(0, 4);
		        },
		        CHILD: function(match) {
		          match[1] = match[1].toLowerCase();
		          if (match[1].slice(0, 3) === "nth") {
		            if (!match[3]) {
		              find.error(match[0]);
		            }
		            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
		            match[5] = +(match[7] + match[8] || match[3] === "odd");
		          } else if (match[3]) {
		            find.error(match[0]);
		          }
		          return match;
		        },
		        PSEUDO: function(match) {
		          var excess, unquoted = !match[6] && match[2];
		          if (matchExpr.CHILD.test(match[0])) {
		            return null;
		          }
		          if (match[3]) {
		            match[2] = match[4] || match[5] || "";
		          } else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
		          (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
		          (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
		            match[0] = match[0].slice(0, excess);
		            match[2] = unquoted.slice(0, excess);
		          }
		          return match.slice(0, 3);
		        }
		      },
		      filter: {
		        TAG: function(nodeNameSelector) {
		          var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
		          return nodeNameSelector === "*" ? function() {
		            return true;
		          } : function(elem) {
		            return nodeName(elem, expectedNodeName);
		          };
		        },
		        CLASS: function(className) {
		          var pattern = classCache[className + " "];
		          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
		            return pattern.test(
		              typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || ""
		            );
		          });
		        },
		        ATTR: function(name, operator, check) {
		          return function(elem) {
		            var result = find.attr(elem, name);
		            if (result == null) {
		              return operator === "!=";
		            }
		            if (!operator) {
		              return true;
		            }
		            result += "";
		            if (operator === "=") {
		              return result === check;
		            }
		            if (operator === "!=") {
		              return result !== check;
		            }
		            if (operator === "^=") {
		              return check && result.indexOf(check) === 0;
		            }
		            if (operator === "*=") {
		              return check && result.indexOf(check) > -1;
		            }
		            if (operator === "$=") {
		              return check && result.slice(-check.length) === check;
		            }
		            if (operator === "~=") {
		              return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
		            }
		            if (operator === "|=") {
		              return result === check || result.slice(0, check.length + 1) === check + "-";
		            }
		            return false;
		          };
		        },
		        CHILD: function(type, what, _argument, first, last) {
		          var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
		          return first === 1 && last === 0 ? (
		            // Shortcut for :nth-*(n)
		            function(elem) {
		              return !!elem.parentNode;
		            }
		          ) : function(elem, _context, xml) {
		            var cache, outerCache, node, nodeIndex, start, dir2 = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
		            if (parent) {
		              if (simple) {
		                while (dir2) {
		                  node = elem;
		                  while (node = node[dir2]) {
		                    if (ofType ? nodeName(node, name) : node.nodeType === 1) {
		                      return false;
		                    }
		                  }
		                  start = dir2 = type === "only" && !start && "nextSibling";
		                }
		                return true;
		              }
		              start = [forward ? parent.firstChild : parent.lastChild];
		              if (forward && useCache) {
		                outerCache = parent[expando] || (parent[expando] = {});
		                cache = outerCache[type] || [];
		                nodeIndex = cache[0] === dirruns && cache[1];
		                diff = nodeIndex && cache[2];
		                node = nodeIndex && parent.childNodes[nodeIndex];
		                while (node = ++nodeIndex && node && node[dir2] || // Fallback to seeking `elem` from the start
		                (diff = nodeIndex = 0) || start.pop()) {
		                  if (node.nodeType === 1 && ++diff && node === elem) {
		                    outerCache[type] = [dirruns, nodeIndex, diff];
		                    break;
		                  }
		                }
		              } else {
		                if (useCache) {
		                  outerCache = elem[expando] || (elem[expando] = {});
		                  cache = outerCache[type] || [];
		                  nodeIndex = cache[0] === dirruns && cache[1];
		                  diff = nodeIndex;
		                }
		                if (diff === false) {
		                  while (node = ++nodeIndex && node && node[dir2] || (diff = nodeIndex = 0) || start.pop()) {
		                    if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
		                      if (useCache) {
		                        outerCache = node[expando] || (node[expando] = {});
		                        outerCache[type] = [dirruns, diff];
		                      }
		                      if (node === elem) {
		                        break;
		                      }
		                    }
		                  }
		                }
		              }
		              diff -= last;
		              return diff === first || diff % first === 0 && diff / first >= 0;
		            }
		          };
		        },
		        PSEUDO: function(pseudo, argument) {
		          var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
		          if (fn[expando]) {
		            return fn(argument);
		          }
		          if (fn.length > 1) {
		            args = [pseudo, pseudo, "", argument];
		            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches2) {
		              var idx, matched = fn(seed, argument), i2 = matched.length;
		              while (i2--) {
		                idx = indexOf.call(seed, matched[i2]);
		                seed[idx] = !(matches2[idx] = matched[i2]);
		              }
		            }) : function(elem) {
		              return fn(elem, 0, args);
		            };
		          }
		          return fn;
		        }
		      },
		      pseudos: {
		        // Potentially complex pseudos
		        not: markFunction(function(selector) {
		          var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
		          return matcher[expando] ? markFunction(function(seed, matches2, _context, xml) {
		            var elem, unmatched = matcher(seed, null, xml, []), i2 = seed.length;
		            while (i2--) {
		              if (elem = unmatched[i2]) {
		                seed[i2] = !(matches2[i2] = elem);
		              }
		            }
		          }) : function(elem, _context, xml) {
		            input[0] = elem;
		            matcher(input, null, xml, results);
		            input[0] = null;
		            return !results.pop();
		          };
		        }),
		        has: markFunction(function(selector) {
		          return function(elem) {
		            return find(selector, elem).length > 0;
		          };
		        }),
		        contains: markFunction(function(text) {
		          text = text.replace(runescape, funescape);
		          return function(elem) {
		            return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
		          };
		        }),
		        // "Whether an element is represented by a :lang() selector
		        // is based solely on the element's language value
		        // being equal to the identifier C,
		        // or beginning with the identifier C immediately followed by "-".
		        // The matching of C against the element's language value is performed case-insensitively.
		        // The identifier C does not have to be a valid language name."
		        // https://www.w3.org/TR/selectors/#lang-pseudo
		        lang: markFunction(function(lang) {
		          if (!ridentifier.test(lang || "")) {
		            find.error("unsupported lang: " + lang);
		          }
		          lang = lang.replace(runescape, funescape).toLowerCase();
		          return function(elem) {
		            var elemLang;
		            do {
		              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
		                elemLang = elemLang.toLowerCase();
		                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
		              }
		            } while ((elem = elem.parentNode) && elem.nodeType === 1);
		            return false;
		          };
		        }),
		        // Miscellaneous
		        target: function(elem) {
		          var hash = window2.location && window2.location.hash;
		          return hash && hash.slice(1) === elem.id;
		        },
		        root: function(elem) {
		          return elem === documentElement2;
		        },
		        focus: function(elem) {
		          return elem === safeActiveElement() && document2.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
		        },
		        // Boolean properties
		        enabled: createDisabledPseudo(false),
		        disabled: createDisabledPseudo(true),
		        checked: function(elem) {
		          return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
		        },
		        selected: function(elem) {
		          if (elem.parentNode) {
		            elem.parentNode.selectedIndex;
		          }
		          return elem.selected === true;
		        },
		        // Contents
		        empty: function(elem) {
		          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
		            if (elem.nodeType < 6) {
		              return false;
		            }
		          }
		          return true;
		        },
		        parent: function(elem) {
		          return !Expr.pseudos.empty(elem);
		        },
		        // Element/input types
		        header: function(elem) {
		          return rheader.test(elem.nodeName);
		        },
		        input: function(elem) {
		          return rinputs.test(elem.nodeName);
		        },
		        button: function(elem) {
		          return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
		        },
		        text: function(elem) {
		          var attr;
		          return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
		          // New HTML5 attribute values (e.g., "search") appear
		          // with elem.type === "text"
		          ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
		        },
		        // Position-in-collection
		        first: createPositionalPseudo(function() {
		          return [0];
		        }),
		        last: createPositionalPseudo(function(_matchIndexes, length) {
		          return [length - 1];
		        }),
		        eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
		          return [argument < 0 ? argument + length : argument];
		        }),
		        even: createPositionalPseudo(function(matchIndexes, length) {
		          var i2 = 0;
		          for (; i2 < length; i2 += 2) {
		            matchIndexes.push(i2);
		          }
		          return matchIndexes;
		        }),
		        odd: createPositionalPseudo(function(matchIndexes, length) {
		          var i2 = 1;
		          for (; i2 < length; i2 += 2) {
		            matchIndexes.push(i2);
		          }
		          return matchIndexes;
		        }),
		        lt: createPositionalPseudo(function(matchIndexes, length, argument) {
		          var i2;
		          if (argument < 0) {
		            i2 = argument + length;
		          } else if (argument > length) {
		            i2 = length;
		          } else {
		            i2 = argument;
		          }
		          for (; --i2 >= 0; ) {
		            matchIndexes.push(i2);
		          }
		          return matchIndexes;
		        }),
		        gt: createPositionalPseudo(function(matchIndexes, length, argument) {
		          var i2 = argument < 0 ? argument + length : argument;
		          for (; ++i2 < length; ) {
		            matchIndexes.push(i2);
		          }
		          return matchIndexes;
		        })
		      }
		    };
		    Expr.pseudos.nth = Expr.pseudos.eq;
		    for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
		      Expr.pseudos[i] = createInputPseudo(i);
		    }
		    for (i in { submit: true, reset: true }) {
		      Expr.pseudos[i] = createButtonPseudo(i);
		    }
		    function setFilters() {
		    }
		    setFilters.prototype = Expr.filters = Expr.pseudos;
		    Expr.setFilters = new setFilters();
		    function tokenize(selector, parseOnly) {
		      var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
		      if (cached) {
		        return parseOnly ? 0 : cached.slice(0);
		      }
		      soFar = selector;
		      groups = [];
		      preFilters = Expr.preFilter;
		      while (soFar) {
		        if (!matched || (match = rcomma.exec(soFar))) {
		          if (match) {
		            soFar = soFar.slice(match[0].length) || soFar;
		          }
		          groups.push(tokens = []);
		        }
		        matched = false;
		        if (match = rleadingCombinator.exec(soFar)) {
		          matched = match.shift();
		          tokens.push({
		            value: matched,
		            // Cast descendant combinators to space
		            type: match[0].replace(rtrimCSS, " ")
		          });
		          soFar = soFar.slice(matched.length);
		        }
		        for (type in Expr.filter) {
		          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
		            matched = match.shift();
		            tokens.push({
		              value: matched,
		              type,
		              matches: match
		            });
		            soFar = soFar.slice(matched.length);
		          }
		        }
		        if (!matched) {
		          break;
		        }
		      }
		      if (parseOnly) {
		        return soFar.length;
		      }
		      return soFar ? find.error(selector) : (
		        // Cache the tokens
		        tokenCache(selector, groups).slice(0)
		      );
		    }
		    function toSelector(tokens) {
		      var i2 = 0, len = tokens.length, selector = "";
		      for (; i2 < len; i2++) {
		        selector += tokens[i2].value;
		      }
		      return selector;
		    }
		    function addCombinator(matcher, combinator, base) {
		      var dir2 = combinator.dir, skip = combinator.next, key = skip || dir2, checkNonElements = base && key === "parentNode", doneName = done++;
		      return combinator.first ? (
		        // Check against closest ancestor/preceding element
		        function(elem, context, xml) {
		          while (elem = elem[dir2]) {
		            if (elem.nodeType === 1 || checkNonElements) {
		              return matcher(elem, context, xml);
		            }
		          }
		          return false;
		        }
		      ) : (
		        // Check against all ancestor/preceding elements
		        function(elem, context, xml) {
		          var oldCache, outerCache, newCache = [dirruns, doneName];
		          if (xml) {
		            while (elem = elem[dir2]) {
		              if (elem.nodeType === 1 || checkNonElements) {
		                if (matcher(elem, context, xml)) {
		                  return true;
		                }
		              }
		            }
		          } else {
		            while (elem = elem[dir2]) {
		              if (elem.nodeType === 1 || checkNonElements) {
		                outerCache = elem[expando] || (elem[expando] = {});
		                if (skip && nodeName(elem, skip)) {
		                  elem = elem[dir2] || elem;
		                } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
		                  return newCache[2] = oldCache[2];
		                } else {
		                  outerCache[key] = newCache;
		                  if (newCache[2] = matcher(elem, context, xml)) {
		                    return true;
		                  }
		                }
		              }
		            }
		          }
		          return false;
		        }
		      );
		    }
		    function elementMatcher(matchers) {
		      return matchers.length > 1 ? function(elem, context, xml) {
		        var i2 = matchers.length;
		        while (i2--) {
		          if (!matchers[i2](elem, context, xml)) {
		            return false;
		          }
		        }
		        return true;
		      } : matchers[0];
		    }
		    function multipleContexts(selector, contexts, results) {
		      var i2 = 0, len = contexts.length;
		      for (; i2 < len; i2++) {
		        find(selector, contexts[i2], results);
		      }
		      return results;
		    }
		    function condense(unmatched, map, filter, context, xml) {
		      var elem, newUnmatched = [], i2 = 0, len = unmatched.length, mapped = map != null;
		      for (; i2 < len; i2++) {
		        if (elem = unmatched[i2]) {
		          if (!filter || filter(elem, context, xml)) {
		            newUnmatched.push(elem);
		            if (mapped) {
		              map.push(i2);
		            }
		          }
		        }
		      }
		      return newUnmatched;
		    }
		    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
		      if (postFilter && !postFilter[expando]) {
		        postFilter = setMatcher(postFilter);
		      }
		      if (postFinder && !postFinder[expando]) {
		        postFinder = setMatcher(postFinder, postSelector);
		      }
		      return markFunction(function(seed, results, context, xml) {
		        var temp, i2, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(
		          selector || "*",
		          context.nodeType ? [context] : context,
		          []
		        ), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
		        if (matcher) {
		          matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? (
		            // ...intermediate processing is necessary
		            []
		          ) : (
		            // ...otherwise use results directly
		            results
		          );
		          matcher(matcherIn, matcherOut, context, xml);
		        } else {
		          matcherOut = matcherIn;
		        }
		        if (postFilter) {
		          temp = condense(matcherOut, postMap);
		          postFilter(temp, [], context, xml);
		          i2 = temp.length;
		          while (i2--) {
		            if (elem = temp[i2]) {
		              matcherOut[postMap[i2]] = !(matcherIn[postMap[i2]] = elem);
		            }
		          }
		        }
		        if (seed) {
		          if (postFinder || preFilter) {
		            if (postFinder) {
		              temp = [];
		              i2 = matcherOut.length;
		              while (i2--) {
		                if (elem = matcherOut[i2]) {
		                  temp.push(matcherIn[i2] = elem);
		                }
		              }
		              postFinder(null, matcherOut = [], temp, xml);
		            }
		            i2 = matcherOut.length;
		            while (i2--) {
		              if ((elem = matcherOut[i2]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i2]) > -1) {
		                seed[temp] = !(results[temp] = elem);
		              }
		            }
		          }
		        } else {
		          matcherOut = condense(
		            matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
		          );
		          if (postFinder) {
		            postFinder(null, results, matcherOut, xml);
		          } else {
		            push2.apply(results, matcherOut);
		          }
		        }
		      });
		    }
		    function matcherFromTokens(tokens) {
		      var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i2 = leadingRelative ? 1 : 0, matchContext = addCombinator(function(elem) {
		        return elem === checkContext;
		      }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
		        return indexOf.call(checkContext, elem) > -1;
		      }, implicitRelative, true), matchers = [function(elem, context, xml) {
		        var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
		        checkContext = null;
		        return ret;
		      }];
		      for (; i2 < len; i2++) {
		        if (matcher = Expr.relative[tokens[i2].type]) {
		          matchers = [addCombinator(elementMatcher(matchers), matcher)];
		        } else {
		          matcher = Expr.filter[tokens[i2].type].apply(null, tokens[i2].matches);
		          if (matcher[expando]) {
		            j = ++i2;
		            for (; j < len; j++) {
		              if (Expr.relative[tokens[j].type]) {
		                break;
		              }
		            }
		            return setMatcher(
		              i2 > 1 && elementMatcher(matchers),
		              i2 > 1 && toSelector(
		                // If the preceding token was a descendant combinator, insert an implicit any-element `*`
		                tokens.slice(0, i2 - 1).concat({ value: tokens[i2 - 2].type === " " ? "*" : "" })
		              ).replace(rtrimCSS, "$1"),
		              matcher,
		              i2 < j && matcherFromTokens(tokens.slice(i2, j)),
		              j < len && matcherFromTokens(tokens = tokens.slice(j)),
		              j < len && toSelector(tokens)
		            );
		          }
		          matchers.push(matcher);
		        }
		      }
		      return elementMatcher(matchers);
		    }
		    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
		      var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
		        var elem, j, matcher, matchedCount = 0, i2 = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG("*", outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
		        if (outermost) {
		          outermostContext = context == document2 || context || outermost;
		        }
		        for (; i2 !== len && (elem = elems[i2]) != null; i2++) {
		          if (byElement && elem) {
		            j = 0;
		            if (!context && elem.ownerDocument != document2) {
		              setDocument(elem);
		              xml = !documentIsHTML;
		            }
		            while (matcher = elementMatchers[j++]) {
		              if (matcher(elem, context || document2, xml)) {
		                push2.call(results, elem);
		                break;
		              }
		            }
		            if (outermost) {
		              dirruns = dirrunsUnique;
		            }
		          }
		          if (bySet) {
		            if (elem = !matcher && elem) {
		              matchedCount--;
		            }
		            if (seed) {
		              unmatched.push(elem);
		            }
		          }
		        }
		        matchedCount += i2;
		        if (bySet && i2 !== matchedCount) {
		          j = 0;
		          while (matcher = setMatchers[j++]) {
		            matcher(unmatched, setMatched, context, xml);
		          }
		          if (seed) {
		            if (matchedCount > 0) {
		              while (i2--) {
		                if (!(unmatched[i2] || setMatched[i2])) {
		                  setMatched[i2] = pop.call(results);
		                }
		              }
		            }
		            setMatched = condense(setMatched);
		          }
		          push2.apply(results, setMatched);
		          if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
		            jQuery.uniqueSort(results);
		          }
		        }
		        if (outermost) {
		          dirruns = dirrunsUnique;
		          outermostContext = contextBackup;
		        }
		        return unmatched;
		      };
		      return bySet ? markFunction(superMatcher) : superMatcher;
		    }
		    function compile(selector, match) {
		      var i2, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
		      if (!cached) {
		        if (!match) {
		          match = tokenize(selector);
		        }
		        i2 = match.length;
		        while (i2--) {
		          cached = matcherFromTokens(match[i2]);
		          if (cached[expando]) {
		            setMatchers.push(cached);
		          } else {
		            elementMatchers.push(cached);
		          }
		        }
		        cached = compilerCache(
		          selector,
		          matcherFromGroupMatchers(elementMatchers, setMatchers)
		        );
		        cached.selector = selector;
		      }
		      return cached;
		    }
		    function select(selector, context, results, seed) {
		      var i2, tokens, token, type, find2, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
		      results = results || [];
		      if (match.length === 1) {
		        tokens = match[0] = match[0].slice(0);
		        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
		          context = (Expr.find.ID(
		            token.matches[0].replace(runescape, funescape),
		            context
		          ) || [])[0];
		          if (!context) {
		            return results;
		          } else if (compiled) {
		            context = context.parentNode;
		          }
		          selector = selector.slice(tokens.shift().value.length);
		        }
		        i2 = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
		        while (i2--) {
		          token = tokens[i2];
		          if (Expr.relative[type = token.type]) {
		            break;
		          }
		          if (find2 = Expr.find[type]) {
		            if (seed = find2(
		              token.matches[0].replace(runescape, funescape),
		              rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
		            )) {
		              tokens.splice(i2, 1);
		              selector = seed.length && toSelector(tokens);
		              if (!selector) {
		                push2.apply(results, seed);
		                return results;
		              }
		              break;
		            }
		          }
		        }
		      }
		      (compiled || compile(selector, match))(
		        seed,
		        context,
		        !documentIsHTML,
		        results,
		        !context || rsibling.test(selector) && testContext(context.parentNode) || context
		      );
		      return results;
		    }
		    support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
		    setDocument();
		    support.sortDetached = assert(function(el) {
		      return el.compareDocumentPosition(document2.createElement("fieldset")) & 1;
		    });
		    jQuery.find = find;
		    jQuery.expr[":"] = jQuery.expr.pseudos;
		    jQuery.unique = jQuery.uniqueSort;
		    find.compile = compile;
		    find.select = select;
		    find.setDocument = setDocument;
		    find.tokenize = tokenize;
		    find.escape = jQuery.escapeSelector;
		    find.getText = jQuery.text;
		    find.isXML = jQuery.isXMLDoc;
		    find.selectors = jQuery.expr;
		    find.support = jQuery.support;
		    find.uniqueSort = jQuery.uniqueSort;
		  })();
		  var dir = function(elem, dir2, until) {
		    var matched = [], truncate = until !== undefined;
		    while ((elem = elem[dir2]) && elem.nodeType !== 9) {
		      if (elem.nodeType === 1) {
		        if (truncate && jQuery(elem).is(until)) {
		          break;
		        }
		        matched.push(elem);
		      }
		    }
		    return matched;
		  };
		  var siblings = function(n, elem) {
		    var matched = [];
		    for (; n; n = n.nextSibling) {
		      if (n.nodeType === 1 && n !== elem) {
		        matched.push(n);
		      }
		    }
		    return matched;
		  };
		  var rneedsContext = jQuery.expr.match.needsContext;
		  var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
		  function winnow(elements, qualifier, not) {
		    if (isFunction(qualifier)) {
		      return jQuery.grep(elements, function(elem, i) {
		        return !!qualifier.call(elem, i, elem) !== not;
		      });
		    }
		    if (qualifier.nodeType) {
		      return jQuery.grep(elements, function(elem) {
		        return elem === qualifier !== not;
		      });
		    }
		    if (typeof qualifier !== "string") {
		      return jQuery.grep(elements, function(elem) {
		        return indexOf.call(qualifier, elem) > -1 !== not;
		      });
		    }
		    return jQuery.filter(qualifier, elements, not);
		  }
		  jQuery.filter = function(expr, elems, not) {
		    var elem = elems[0];
		    if (not) {
		      expr = ":not(" + expr + ")";
		    }
		    if (elems.length === 1 && elem.nodeType === 1) {
		      return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
		    }
		    return jQuery.find.matches(expr, jQuery.grep(elems, function(elem2) {
		      return elem2.nodeType === 1;
		    }));
		  };
		  jQuery.fn.extend({
		    find: function(selector) {
		      var i, ret, len = this.length, self = this;
		      if (typeof selector !== "string") {
		        return this.pushStack(jQuery(selector).filter(function() {
		          for (i = 0; i < len; i++) {
		            if (jQuery.contains(self[i], this)) {
		              return true;
		            }
		          }
		        }));
		      }
		      ret = this.pushStack([]);
		      for (i = 0; i < len; i++) {
		        jQuery.find(selector, self[i], ret);
		      }
		      return len > 1 ? jQuery.uniqueSort(ret) : ret;
		    },
		    filter: function(selector) {
		      return this.pushStack(winnow(this, selector || [], false));
		    },
		    not: function(selector) {
		      return this.pushStack(winnow(this, selector || [], true));
		    },
		    is: function(selector) {
		      return !!winnow(
		        this,
		        // If this is a positional/relative selector, check membership in the returned set
		        // so $("p:first").is("p:last") won't return true for a doc with two "p".
		        typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [],
		        false
		      ).length;
		    }
		  });
		  var rootjQuery, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
		    var match, elem;
		    if (!selector) {
		      return this;
		    }
		    root = root || rootjQuery;
		    if (typeof selector === "string") {
		      if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
		        match = [null, selector, null];
		      } else {
		        match = rquickExpr.exec(selector);
		      }
		      if (match && (match[1] || !context)) {
		        if (match[1]) {
		          context = context instanceof jQuery ? context[0] : context;
		          jQuery.merge(this, jQuery.parseHTML(
		            match[1],
		            context && context.nodeType ? context.ownerDocument || context : document,
		            true
		          ));
		          if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
		            for (match in context) {
		              if (isFunction(this[match])) {
		                this[match](context[match]);
		              } else {
		                this.attr(match, context[match]);
		              }
		            }
		          }
		          return this;
		        } else {
		          elem = document.getElementById(match[2]);
		          if (elem) {
		            this[0] = elem;
		            this.length = 1;
		          }
		          return this;
		        }
		      } else if (!context || context.jquery) {
		        return (context || root).find(selector);
		      } else {
		        return this.constructor(context).find(selector);
		      }
		    } else if (selector.nodeType) {
		      this[0] = selector;
		      this.length = 1;
		      return this;
		    } else if (isFunction(selector)) {
		      return root.ready !== undefined ? root.ready(selector) : (
		        // Execute immediately if ready is not present
		        selector(jQuery)
		      );
		    }
		    return jQuery.makeArray(selector, this);
		  };
		  init.prototype = jQuery.fn;
		  rootjQuery = jQuery(document);
		  var rparentsprev = /^(?:parents|prev(?:Until|All))/, guaranteedUnique = {
		    children: true,
		    contents: true,
		    next: true,
		    prev: true
		  };
		  jQuery.fn.extend({
		    has: function(target) {
		      var targets = jQuery(target, this), l = targets.length;
		      return this.filter(function() {
		        var i = 0;
		        for (; i < l; i++) {
		          if (jQuery.contains(this, targets[i])) {
		            return true;
		          }
		        }
		      });
		    },
		    closest: function(selectors, context) {
		      var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
		      if (!rneedsContext.test(selectors)) {
		        for (; i < l; i++) {
		          for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
		            if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : (
		              // Don't pass non-elements to jQuery#find
		              cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors)
		            ))) {
		              matched.push(cur);
		              break;
		            }
		          }
		        }
		      }
		      return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
		    },
		    // Determine the position of an element within the set
		    index: function(elem) {
		      if (!elem) {
		        return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
		      }
		      if (typeof elem === "string") {
		        return indexOf.call(jQuery(elem), this[0]);
		      }
		      return indexOf.call(
		        this,
		        // If it receives a jQuery object, the first element is used
		        elem.jquery ? elem[0] : elem
		      );
		    },
		    add: function(selector, context) {
		      return this.pushStack(
		        jQuery.uniqueSort(
		          jQuery.merge(this.get(), jQuery(selector, context))
		        )
		      );
		    },
		    addBack: function(selector) {
		      return this.add(
		        selector == null ? this.prevObject : this.prevObject.filter(selector)
		      );
		    }
		  });
		  function sibling(cur, dir2) {
		    while ((cur = cur[dir2]) && cur.nodeType !== 1) {
		    }
		    return cur;
		  }
		  jQuery.each({
		    parent: function(elem) {
		      var parent = elem.parentNode;
		      return parent && parent.nodeType !== 11 ? parent : null;
		    },
		    parents: function(elem) {
		      return dir(elem, "parentNode");
		    },
		    parentsUntil: function(elem, _i, until) {
		      return dir(elem, "parentNode", until);
		    },
		    next: function(elem) {
		      return sibling(elem, "nextSibling");
		    },
		    prev: function(elem) {
		      return sibling(elem, "previousSibling");
		    },
		    nextAll: function(elem) {
		      return dir(elem, "nextSibling");
		    },
		    prevAll: function(elem) {
		      return dir(elem, "previousSibling");
		    },
		    nextUntil: function(elem, _i, until) {
		      return dir(elem, "nextSibling", until);
		    },
		    prevUntil: function(elem, _i, until) {
		      return dir(elem, "previousSibling", until);
		    },
		    siblings: function(elem) {
		      return siblings((elem.parentNode || {}).firstChild, elem);
		    },
		    children: function(elem) {
		      return siblings(elem.firstChild);
		    },
		    contents: function(elem) {
		      if (elem.contentDocument != null && // Support: IE 11+
		      // <object> elements with no `data` attribute has an object
		      // `contentDocument` with a `null` prototype.
		      getProto(elem.contentDocument)) {
		        return elem.contentDocument;
		      }
		      if (nodeName(elem, "template")) {
		        elem = elem.content || elem;
		      }
		      return jQuery.merge([], elem.childNodes);
		    }
		  }, function(name, fn) {
		    jQuery.fn[name] = function(until, selector) {
		      var matched = jQuery.map(this, fn, until);
		      if (name.slice(-5) !== "Until") {
		        selector = until;
		      }
		      if (selector && typeof selector === "string") {
		        matched = jQuery.filter(selector, matched);
		      }
		      if (this.length > 1) {
		        if (!guaranteedUnique[name]) {
		          jQuery.uniqueSort(matched);
		        }
		        if (rparentsprev.test(name)) {
		          matched.reverse();
		        }
		      }
		      return this.pushStack(matched);
		    };
		  });
		  var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
		  function createOptions(options) {
		    var object = {};
		    jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
		      object[flag] = true;
		    });
		    return object;
		  }
		  jQuery.Callbacks = function(options) {
		    options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
		    var firing, memory, fired, locked, list = [], queue = [], firingIndex = -1, fire = function() {
		      locked = locked || options.once;
		      fired = firing = true;
		      for (; queue.length; firingIndex = -1) {
		        memory = queue.shift();
		        while (++firingIndex < list.length) {
		          if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
		            firingIndex = list.length;
		            memory = false;
		          }
		        }
		      }
		      if (!options.memory) {
		        memory = false;
		      }
		      firing = false;
		      if (locked) {
		        if (memory) {
		          list = [];
		        } else {
		          list = "";
		        }
		      }
		    }, self = {
		      // Add a callback or a collection of callbacks to the list
		      add: function() {
		        if (list) {
		          if (memory && !firing) {
		            firingIndex = list.length - 1;
		            queue.push(memory);
		          }
		          (function add(args) {
		            jQuery.each(args, function(_, arg) {
		              if (isFunction(arg)) {
		                if (!options.unique || !self.has(arg)) {
		                  list.push(arg);
		                }
		              } else if (arg && arg.length && toType(arg) !== "string") {
		                add(arg);
		              }
		            });
		          })(arguments);
		          if (memory && !firing) {
		            fire();
		          }
		        }
		        return this;
		      },
		      // Remove a callback from the list
		      remove: function() {
		        jQuery.each(arguments, function(_, arg) {
		          var index;
		          while ((index = jQuery.inArray(arg, list, index)) > -1) {
		            list.splice(index, 1);
		            if (index <= firingIndex) {
		              firingIndex--;
		            }
		          }
		        });
		        return this;
		      },
		      // Check if a given callback is in the list.
		      // If no argument is given, return whether or not list has callbacks attached.
		      has: function(fn) {
		        return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
		      },
		      // Remove all callbacks from the list
		      empty: function() {
		        if (list) {
		          list = [];
		        }
		        return this;
		      },
		      // Disable .fire and .add
		      // Abort any current/pending executions
		      // Clear all callbacks and values
		      disable: function() {
		        locked = queue = [];
		        list = memory = "";
		        return this;
		      },
		      disabled: function() {
		        return !list;
		      },
		      // Disable .fire
		      // Also disable .add unless we have memory (since it would have no effect)
		      // Abort any pending executions
		      lock: function() {
		        locked = queue = [];
		        if (!memory && !firing) {
		          list = memory = "";
		        }
		        return this;
		      },
		      locked: function() {
		        return !!locked;
		      },
		      // Call all callbacks with the given context and arguments
		      fireWith: function(context, args) {
		        if (!locked) {
		          args = args || [];
		          args = [context, args.slice ? args.slice() : args];
		          queue.push(args);
		          if (!firing) {
		            fire();
		          }
		        }
		        return this;
		      },
		      // Call all the callbacks with the given arguments
		      fire: function() {
		        self.fireWith(this, arguments);
		        return this;
		      },
		      // To know if the callbacks have already been called at least once
		      fired: function() {
		        return !!fired;
		      }
		    };
		    return self;
		  };
		  function Identity(v) {
		    return v;
		  }
		  function Thrower(ex) {
		    throw ex;
		  }
		  function adoptValue(value, resolve, reject, noValue) {
		    var method;
		    try {
		      if (value && isFunction(method = value.promise)) {
		        method.call(value).done(resolve).fail(reject);
		      } else if (value && isFunction(method = value.then)) {
		        method.call(value, resolve, reject);
		      } else {
		        resolve.apply(void 0, [value].slice(noValue));
		      }
		    } catch (value2) {
		      reject.apply(undefined, [value2]);
		    }
		  }
		  jQuery.extend({
		    Deferred: function(func) {
		      var tuples = [
		        // action, add listener, callbacks,
		        // ... .then handlers, argument index, [final state]
		        [
		          "notify",
		          "progress",
		          jQuery.Callbacks("memory"),
		          jQuery.Callbacks("memory"),
		          2
		        ],
		        [
		          "resolve",
		          "done",
		          jQuery.Callbacks("once memory"),
		          jQuery.Callbacks("once memory"),
		          0,
		          "resolved"
		        ],
		        [
		          "reject",
		          "fail",
		          jQuery.Callbacks("once memory"),
		          jQuery.Callbacks("once memory"),
		          1,
		          "rejected"
		        ]
		      ], state = "pending", promise = {
		        state: function() {
		          return state;
		        },
		        always: function() {
		          deferred.done(arguments).fail(arguments);
		          return this;
		        },
		        "catch": function(fn) {
		          return promise.then(null, fn);
		        },
		        // Keep pipe for back-compat
		        pipe: function() {
		          var fns = arguments;
		          return jQuery.Deferred(function(newDefer) {
		            jQuery.each(tuples, function(_i, tuple) {
		              var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
		              deferred[tuple[1]](function() {
		                var returned = fn && fn.apply(this, arguments);
		                if (returned && isFunction(returned.promise)) {
		                  returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
		                } else {
		                  newDefer[tuple[0] + "With"](
		                    this,
		                    fn ? [returned] : arguments
		                  );
		                }
		              });
		            });
		            fns = null;
		          }).promise();
		        },
		        then: function(onFulfilled, onRejected, onProgress) {
		          var maxDepth = 0;
		          function resolve(depth, deferred2, handler, special) {
		            return function() {
		              var that = this, args = arguments, mightThrow = function() {
		                var returned, then;
		                if (depth < maxDepth) {
		                  return;
		                }
		                returned = handler.apply(that, args);
		                if (returned === deferred2.promise()) {
		                  throw new TypeError("Thenable self-resolution");
		                }
		                then = returned && // Support: Promises/A+ section 2.3.4
		                // https://promisesaplus.com/#point-64
		                // Only check objects and functions for thenability
		                (typeof returned === "object" || typeof returned === "function") && returned.then;
		                if (isFunction(then)) {
		                  if (special) {
		                    then.call(
		                      returned,
		                      resolve(maxDepth, deferred2, Identity, special),
		                      resolve(maxDepth, deferred2, Thrower, special)
		                    );
		                  } else {
		                    maxDepth++;
		                    then.call(
		                      returned,
		                      resolve(maxDepth, deferred2, Identity, special),
		                      resolve(maxDepth, deferred2, Thrower, special),
		                      resolve(
		                        maxDepth,
		                        deferred2,
		                        Identity,
		                        deferred2.notifyWith
		                      )
		                    );
		                  }
		                } else {
		                  if (handler !== Identity) {
		                    that = undefined;
		                    args = [returned];
		                  }
		                  (special || deferred2.resolveWith)(that, args);
		                }
		              }, process = special ? mightThrow : function() {
		                try {
		                  mightThrow();
		                } catch (e) {
		                  if (jQuery.Deferred.exceptionHook) {
		                    jQuery.Deferred.exceptionHook(
		                      e,
		                      process.error
		                    );
		                  }
		                  if (depth + 1 >= maxDepth) {
		                    if (handler !== Thrower) {
		                      that = undefined;
		                      args = [e];
		                    }
		                    deferred2.rejectWith(that, args);
		                  }
		                }
		              };
		              if (depth) {
		                process();
		              } else {
		                if (jQuery.Deferred.getErrorHook) {
		                  process.error = jQuery.Deferred.getErrorHook();
		                } else if (jQuery.Deferred.getStackHook) {
		                  process.error = jQuery.Deferred.getStackHook();
		                }
		                window2.setTimeout(process);
		              }
		            };
		          }
		          return jQuery.Deferred(function(newDefer) {
		            tuples[0][3].add(
		              resolve(
		                0,
		                newDefer,
		                isFunction(onProgress) ? onProgress : Identity,
		                newDefer.notifyWith
		              )
		            );
		            tuples[1][3].add(
		              resolve(
		                0,
		                newDefer,
		                isFunction(onFulfilled) ? onFulfilled : Identity
		              )
		            );
		            tuples[2][3].add(
		              resolve(
		                0,
		                newDefer,
		                isFunction(onRejected) ? onRejected : Thrower
		              )
		            );
		          }).promise();
		        },
		        // Get a promise for this deferred
		        // If obj is provided, the promise aspect is added to the object
		        promise: function(obj) {
		          return obj != null ? jQuery.extend(obj, promise) : promise;
		        }
		      }, deferred = {};
		      jQuery.each(tuples, function(i, tuple) {
		        var list = tuple[2], stateString = tuple[5];
		        promise[tuple[1]] = list.add;
		        if (stateString) {
		          list.add(
		            function() {
		              state = stateString;
		            },
		            // rejected_callbacks.disable
		            // fulfilled_callbacks.disable
		            tuples[3 - i][2].disable,
		            // rejected_handlers.disable
		            // fulfilled_handlers.disable
		            tuples[3 - i][3].disable,
		            // progress_callbacks.lock
		            tuples[0][2].lock,
		            // progress_handlers.lock
		            tuples[0][3].lock
		          );
		        }
		        list.add(tuple[3].fire);
		        deferred[tuple[0]] = function() {
		          deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
		          return this;
		        };
		        deferred[tuple[0] + "With"] = list.fireWith;
		      });
		      promise.promise(deferred);
		      if (func) {
		        func.call(deferred, deferred);
		      }
		      return deferred;
		    },
		    // Deferred helper
		    when: function(singleValue) {
		      var remaining = arguments.length, i = remaining, resolveContexts = Array(i), resolveValues = slice.call(arguments), primary = jQuery.Deferred(), updateFunc = function(i2) {
		        return function(value) {
		          resolveContexts[i2] = this;
		          resolveValues[i2] = arguments.length > 1 ? slice.call(arguments) : value;
		          if (!--remaining) {
		            primary.resolveWith(resolveContexts, resolveValues);
		          }
		        };
		      };
		      if (remaining <= 1) {
		        adoptValue(
		          singleValue,
		          primary.done(updateFunc(i)).resolve,
		          primary.reject,
		          !remaining
		        );
		        if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
		          return primary.then();
		        }
		      }
		      while (i--) {
		        adoptValue(resolveValues[i], updateFunc(i), primary.reject);
		      }
		      return primary.promise();
		    }
		  });
		  var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
		  jQuery.Deferred.exceptionHook = function(error, asyncError) {
		    if (window2.console && window2.console.warn && error && rerrorNames.test(error.name)) {
		      window2.console.warn(
		        "jQuery.Deferred exception: " + error.message,
		        error.stack,
		        asyncError
		      );
		    }
		  };
		  jQuery.readyException = function(error) {
		    window2.setTimeout(function() {
		      throw error;
		    });
		  };
		  var readyList = jQuery.Deferred();
		  jQuery.fn.ready = function(fn) {
		    readyList.then(fn).catch(function(error) {
		      jQuery.readyException(error);
		    });
		    return this;
		  };
		  jQuery.extend({
		    // Is the DOM ready to be used? Set to true once it occurs.
		    isReady: false,
		    // A counter to track how many items to wait for before
		    // the ready event fires. See trac-6781
		    readyWait: 1,
		    // Handle when the DOM is ready
		    ready: function(wait) {
		      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
		        return;
		      }
		      jQuery.isReady = true;
		      if (wait !== true && --jQuery.readyWait > 0) {
		        return;
		      }
		      readyList.resolveWith(document, [jQuery]);
		    }
		  });
		  jQuery.ready.then = readyList.then;
		  function completed() {
		    document.removeEventListener("DOMContentLoaded", completed);
		    window2.removeEventListener("load", completed);
		    jQuery.ready();
		  }
		  if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
		    window2.setTimeout(jQuery.ready);
		  } else {
		    document.addEventListener("DOMContentLoaded", completed);
		    window2.addEventListener("load", completed);
		  }
		  var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
		    var i = 0, len = elems.length, bulk = key == null;
		    if (toType(key) === "object") {
		      chainable = true;
		      for (i in key) {
		        access(elems, fn, i, key[i], true, emptyGet, raw);
		      }
		    } else if (value !== undefined) {
		      chainable = true;
		      if (!isFunction(value)) {
		        raw = true;
		      }
		      if (bulk) {
		        if (raw) {
		          fn.call(elems, value);
		          fn = null;
		        } else {
		          bulk = fn;
		          fn = function(elem, _key, value2) {
		            return bulk.call(jQuery(elem), value2);
		          };
		        }
		      }
		      if (fn) {
		        for (; i < len; i++) {
		          fn(
		            elems[i],
		            key,
		            raw ? value : value.call(elems[i], i, fn(elems[i], key))
		          );
		        }
		      }
		    }
		    if (chainable) {
		      return elems;
		    }
		    if (bulk) {
		      return fn.call(elems);
		    }
		    return len ? fn(elems[0], key) : emptyGet;
		  };
		  var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
		  function fcamelCase(_all, letter) {
		    return letter.toUpperCase();
		  }
		  function camelCase(string) {
		    return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
		  }
		  var acceptData = function(owner) {
		    return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
		  };
		  function Data() {
		    this.expando = jQuery.expando + Data.uid++;
		  }
		  Data.uid = 1;
		  Data.prototype = {
		    cache: function(owner) {
		      var value = owner[this.expando];
		      if (!value) {
		        value = {};
		        if (acceptData(owner)) {
		          if (owner.nodeType) {
		            owner[this.expando] = value;
		          } else {
		            Object.defineProperty(owner, this.expando, {
		              value,
		              configurable: true
		            });
		          }
		        }
		      }
		      return value;
		    },
		    set: function(owner, data, value) {
		      var prop, cache = this.cache(owner);
		      if (typeof data === "string") {
		        cache[camelCase(data)] = value;
		      } else {
		        for (prop in data) {
		          cache[camelCase(prop)] = data[prop];
		        }
		      }
		      return cache;
		    },
		    get: function(owner, key) {
		      return key === undefined ? this.cache(owner) : (
		        // Always use camelCase key (gh-2257)
		        owner[this.expando] && owner[this.expando][camelCase(key)]
		      );
		    },
		    access: function(owner, key, value) {
		      if (key === undefined || key && typeof key === "string" && value === undefined) {
		        return this.get(owner, key);
		      }
		      this.set(owner, key, value);
		      return value !== undefined ? value : key;
		    },
		    remove: function(owner, key) {
		      var i, cache = owner[this.expando];
		      if (cache === undefined) {
		        return;
		      }
		      if (key !== undefined) {
		        if (Array.isArray(key)) {
		          key = key.map(camelCase);
		        } else {
		          key = camelCase(key);
		          key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
		        }
		        i = key.length;
		        while (i--) {
		          delete cache[key[i]];
		        }
		      }
		      if (key === undefined || jQuery.isEmptyObject(cache)) {
		        if (owner.nodeType) {
		          owner[this.expando] = undefined;
		        } else {
		          delete owner[this.expando];
		        }
		      }
		    },
		    hasData: function(owner) {
		      var cache = owner[this.expando];
		      return cache !== undefined && !jQuery.isEmptyObject(cache);
		    }
		  };
		  var dataPriv = new Data();
		  var dataUser = new Data();
		  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
		  function getData(data) {
		    if (data === "true") {
		      return true;
		    }
		    if (data === "false") {
		      return false;
		    }
		    if (data === "null") {
		      return null;
		    }
		    if (data === +data + "") {
		      return +data;
		    }
		    if (rbrace.test(data)) {
		      return JSON.parse(data);
		    }
		    return data;
		  }
		  function dataAttr(elem, key, data) {
		    var name;
		    if (data === undefined && elem.nodeType === 1) {
		      name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
		      data = elem.getAttribute(name);
		      if (typeof data === "string") {
		        try {
		          data = getData(data);
		        } catch (e) {
		        }
		        dataUser.set(elem, key, data);
		      } else {
		        data = undefined;
		      }
		    }
		    return data;
		  }
		  jQuery.extend({
		    hasData: function(elem) {
		      return dataUser.hasData(elem) || dataPriv.hasData(elem);
		    },
		    data: function(elem, name, data) {
		      return dataUser.access(elem, name, data);
		    },
		    removeData: function(elem, name) {
		      dataUser.remove(elem, name);
		    },
		    // TODO: Now that all calls to _data and _removeData have been replaced
		    // with direct calls to dataPriv methods, these can be deprecated.
		    _data: function(elem, name, data) {
		      return dataPriv.access(elem, name, data);
		    },
		    _removeData: function(elem, name) {
		      dataPriv.remove(elem, name);
		    }
		  });
		  jQuery.fn.extend({
		    data: function(key, value) {
		      var i, name, data, elem = this[0], attrs = elem && elem.attributes;
		      if (key === undefined) {
		        if (this.length) {
		          data = dataUser.get(elem);
		          if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
		            i = attrs.length;
		            while (i--) {
		              if (attrs[i]) {
		                name = attrs[i].name;
		                if (name.indexOf("data-") === 0) {
		                  name = camelCase(name.slice(5));
		                  dataAttr(elem, name, data[name]);
		                }
		              }
		            }
		            dataPriv.set(elem, "hasDataAttrs", true);
		          }
		        }
		        return data;
		      }
		      if (typeof key === "object") {
		        return this.each(function() {
		          dataUser.set(this, key);
		        });
		      }
		      return access(this, function(value2) {
		        var data2;
		        if (elem && value2 === undefined) {
		          data2 = dataUser.get(elem, key);
		          if (data2 !== undefined) {
		            return data2;
		          }
		          data2 = dataAttr(elem, key);
		          if (data2 !== undefined) {
		            return data2;
		          }
		          return;
		        }
		        this.each(function() {
		          dataUser.set(this, key, value2);
		        });
		      }, null, value, arguments.length > 1, null, true);
		    },
		    removeData: function(key) {
		      return this.each(function() {
		        dataUser.remove(this, key);
		      });
		    }
		  });
		  jQuery.extend({
		    queue: function(elem, type, data) {
		      var queue;
		      if (elem) {
		        type = (type || "fx") + "queue";
		        queue = dataPriv.get(elem, type);
		        if (data) {
		          if (!queue || Array.isArray(data)) {
		            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
		          } else {
		            queue.push(data);
		          }
		        }
		        return queue || [];
		      }
		    },
		    dequeue: function(elem, type) {
		      type = type || "fx";
		      var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
		        jQuery.dequeue(elem, type);
		      };
		      if (fn === "inprogress") {
		        fn = queue.shift();
		        startLength--;
		      }
		      if (fn) {
		        if (type === "fx") {
		          queue.unshift("inprogress");
		        }
		        delete hooks.stop;
		        fn.call(elem, next, hooks);
		      }
		      if (!startLength && hooks) {
		        hooks.empty.fire();
		      }
		    },
		    // Not public - generate a queueHooks object, or return the current one
		    _queueHooks: function(elem, type) {
		      var key = type + "queueHooks";
		      return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
		        empty: jQuery.Callbacks("once memory").add(function() {
		          dataPriv.remove(elem, [type + "queue", key]);
		        })
		      });
		    }
		  });
		  jQuery.fn.extend({
		    queue: function(type, data) {
		      var setter = 2;
		      if (typeof type !== "string") {
		        data = type;
		        type = "fx";
		        setter--;
		      }
		      if (arguments.length < setter) {
		        return jQuery.queue(this[0], type);
		      }
		      return data === undefined ? this : this.each(function() {
		        var queue = jQuery.queue(this, type, data);
		        jQuery._queueHooks(this, type);
		        if (type === "fx" && queue[0] !== "inprogress") {
		          jQuery.dequeue(this, type);
		        }
		      });
		    },
		    dequeue: function(type) {
		      return this.each(function() {
		        jQuery.dequeue(this, type);
		      });
		    },
		    clearQueue: function(type) {
		      return this.queue(type || "fx", []);
		    },
		    // Get a promise resolved when queues of a certain type
		    // are emptied (fx is the type by default)
		    promise: function(type, obj) {
		      var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
		        if (!--count) {
		          defer.resolveWith(elements, [elements]);
		        }
		      };
		      if (typeof type !== "string") {
		        obj = type;
		        type = undefined;
		      }
		      type = type || "fx";
		      while (i--) {
		        tmp = dataPriv.get(elements[i], type + "queueHooks");
		        if (tmp && tmp.empty) {
		          count++;
		          tmp.empty.add(resolve);
		        }
		      }
		      resolve();
		      return defer.promise(obj);
		    }
		  });
		  var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
		  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
		  var cssExpand = ["Top", "Right", "Bottom", "Left"];
		  var documentElement = document.documentElement;
		  var isAttached = function(elem) {
		    return jQuery.contains(elem.ownerDocument, elem);
		  }, composed = { composed: true };
		  if (documentElement.getRootNode) {
		    isAttached = function(elem) {
		      return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
		    };
		  }
		  var isHiddenWithinTree = function(elem, el) {
		    elem = el || elem;
		    return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
		    // Support: Firefox <=43 - 45
		    // Disconnected elements can have computed display: none, so first confirm that elem is
		    // in the document.
		    isAttached(elem) && jQuery.css(elem, "display") === "none";
		  };
		  function adjustCSS(elem, prop, valueParts, tween) {
		    var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
		      return tween.cur();
		    } : function() {
		      return jQuery.css(elem, prop, "");
		    }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
		    if (initialInUnit && initialInUnit[3] !== unit) {
		      initial = initial / 2;
		      unit = unit || initialInUnit[3];
		      initialInUnit = +initial || 1;
		      while (maxIterations--) {
		        jQuery.style(elem, prop, initialInUnit + unit);
		        if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
		          maxIterations = 0;
		        }
		        initialInUnit = initialInUnit / scale;
		      }
		      initialInUnit = initialInUnit * 2;
		      jQuery.style(elem, prop, initialInUnit + unit);
		      valueParts = valueParts || [];
		    }
		    if (valueParts) {
		      initialInUnit = +initialInUnit || +initial || 0;
		      adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
		      if (tween) {
		        tween.unit = unit;
		        tween.start = initialInUnit;
		        tween.end = adjusted;
		      }
		    }
		    return adjusted;
		  }
		  var defaultDisplayMap = {};
		  function getDefaultDisplay(elem) {
		    var temp, doc = elem.ownerDocument, nodeName2 = elem.nodeName, display = defaultDisplayMap[nodeName2];
		    if (display) {
		      return display;
		    }
		    temp = doc.body.appendChild(doc.createElement(nodeName2));
		    display = jQuery.css(temp, "display");
		    temp.parentNode.removeChild(temp);
		    if (display === "none") {
		      display = "block";
		    }
		    defaultDisplayMap[nodeName2] = display;
		    return display;
		  }
		  function showHide(elements, show) {
		    var display, elem, values = [], index = 0, length = elements.length;
		    for (; index < length; index++) {
		      elem = elements[index];
		      if (!elem.style) {
		        continue;
		      }
		      display = elem.style.display;
		      if (show) {
		        if (display === "none") {
		          values[index] = dataPriv.get(elem, "display") || null;
		          if (!values[index]) {
		            elem.style.display = "";
		          }
		        }
		        if (elem.style.display === "" && isHiddenWithinTree(elem)) {
		          values[index] = getDefaultDisplay(elem);
		        }
		      } else {
		        if (display !== "none") {
		          values[index] = "none";
		          dataPriv.set(elem, "display", display);
		        }
		      }
		    }
		    for (index = 0; index < length; index++) {
		      if (values[index] != null) {
		        elements[index].style.display = values[index];
		      }
		    }
		    return elements;
		  }
		  jQuery.fn.extend({
		    show: function() {
		      return showHide(this, true);
		    },
		    hide: function() {
		      return showHide(this);
		    },
		    toggle: function(state) {
		      if (typeof state === "boolean") {
		        return state ? this.show() : this.hide();
		      }
		      return this.each(function() {
		        if (isHiddenWithinTree(this)) {
		          jQuery(this).show();
		        } else {
		          jQuery(this).hide();
		        }
		      });
		    }
		  });
		  var rcheckableType = /^(?:checkbox|radio)$/i;
		  var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
		  var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
		  (function() {
		    var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
		    input.setAttribute("type", "radio");
		    input.setAttribute("checked", "checked");
		    input.setAttribute("name", "t");
		    div.appendChild(input);
		    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
		    div.innerHTML = "<textarea>x</textarea>";
		    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
		    div.innerHTML = "<option></option>";
		    support.option = !!div.lastChild;
		  })();
		  var wrapMap = {
		    // XHTML parsers do not magically insert elements in the
		    // same way that tag soup parsers do. So we cannot shorten
		    // this by omitting <tbody> or other required elements.
		    thead: [1, "<table>", "</table>"],
		    col: [2, "<table><colgroup>", "</colgroup></table>"],
		    tr: [2, "<table><tbody>", "</tbody></table>"],
		    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
		    _default: [0, "", ""]
		  };
		  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
		  wrapMap.th = wrapMap.td;
		  if (!support.option) {
		    wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
		  }
		  function getAll(context, tag) {
		    var ret;
		    if (typeof context.getElementsByTagName !== "undefined") {
		      ret = context.getElementsByTagName(tag || "*");
		    } else if (typeof context.querySelectorAll !== "undefined") {
		      ret = context.querySelectorAll(tag || "*");
		    } else {
		      ret = [];
		    }
		    if (tag === undefined || tag && nodeName(context, tag)) {
		      return jQuery.merge([context], ret);
		    }
		    return ret;
		  }
		  function setGlobalEval(elems, refElements) {
		    var i = 0, l = elems.length;
		    for (; i < l; i++) {
		      dataPriv.set(
		        elems[i],
		        "globalEval",
		        !refElements || dataPriv.get(refElements[i], "globalEval")
		      );
		    }
		  }
		  var rhtml = /<|&#?\w+;/;
		  function buildFragment(elems, context, scripts, selection, ignored) {
		    var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
		    for (; i < l; i++) {
		      elem = elems[i];
		      if (elem || elem === 0) {
		        if (toType(elem) === "object") {
		          jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
		        } else if (!rhtml.test(elem)) {
		          nodes.push(context.createTextNode(elem));
		        } else {
		          tmp = tmp || fragment.appendChild(context.createElement("div"));
		          tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
		          wrap = wrapMap[tag] || wrapMap._default;
		          tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
		          j = wrap[0];
		          while (j--) {
		            tmp = tmp.lastChild;
		          }
		          jQuery.merge(nodes, tmp.childNodes);
		          tmp = fragment.firstChild;
		          tmp.textContent = "";
		        }
		      }
		    }
		    fragment.textContent = "";
		    i = 0;
		    while (elem = nodes[i++]) {
		      if (selection && jQuery.inArray(elem, selection) > -1) {
		        if (ignored) {
		          ignored.push(elem);
		        }
		        continue;
		      }
		      attached = isAttached(elem);
		      tmp = getAll(fragment.appendChild(elem), "script");
		      if (attached) {
		        setGlobalEval(tmp);
		      }
		      if (scripts) {
		        j = 0;
		        while (elem = tmp[j++]) {
		          if (rscriptType.test(elem.type || "")) {
		            scripts.push(elem);
		          }
		        }
		      }
		    }
		    return fragment;
		  }
		  var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
		  function returnTrue() {
		    return true;
		  }
		  function returnFalse() {
		    return false;
		  }
		  function on(elem, types, selector, data, fn, one) {
		    var origFn, type;
		    if (typeof types === "object") {
		      if (typeof selector !== "string") {
		        data = data || selector;
		        selector = undefined;
		      }
		      for (type in types) {
		        on(elem, type, selector, data, types[type], one);
		      }
		      return elem;
		    }
		    if (data == null && fn == null) {
		      fn = selector;
		      data = selector = undefined;
		    } else if (fn == null) {
		      if (typeof selector === "string") {
		        fn = data;
		        data = undefined;
		      } else {
		        fn = data;
		        data = selector;
		        selector = undefined;
		      }
		    }
		    if (fn === false) {
		      fn = returnFalse;
		    } else if (!fn) {
		      return elem;
		    }
		    if (one === 1) {
		      origFn = fn;
		      fn = function(event) {
		        jQuery().off(event);
		        return origFn.apply(this, arguments);
		      };
		      fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
		    }
		    return elem.each(function() {
		      jQuery.event.add(this, types, fn, data, selector);
		    });
		  }
		  jQuery.event = {
		    global: {},
		    add: function(elem, types, handler, data, selector) {
		      var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
		      if (!acceptData(elem)) {
		        return;
		      }
		      if (handler.handler) {
		        handleObjIn = handler;
		        handler = handleObjIn.handler;
		        selector = handleObjIn.selector;
		      }
		      if (selector) {
		        jQuery.find.matchesSelector(documentElement, selector);
		      }
		      if (!handler.guid) {
		        handler.guid = jQuery.guid++;
		      }
		      if (!(events = elemData.events)) {
		        events = elemData.events = /* @__PURE__ */ Object.create(null);
		      }
		      if (!(eventHandle = elemData.handle)) {
		        eventHandle = elemData.handle = function(e) {
		          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
		        };
		      }
		      types = (types || "").match(rnothtmlwhite) || [""];
		      t = types.length;
		      while (t--) {
		        tmp = rtypenamespace.exec(types[t]) || [];
		        type = origType = tmp[1];
		        namespaces = (tmp[2] || "").split(".").sort();
		        if (!type) {
		          continue;
		        }
		        special = jQuery.event.special[type] || {};
		        type = (selector ? special.delegateType : special.bindType) || type;
		        special = jQuery.event.special[type] || {};
		        handleObj = jQuery.extend({
		          type,
		          origType,
		          data,
		          handler,
		          guid: handler.guid,
		          selector,
		          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
		          namespace: namespaces.join(".")
		        }, handleObjIn);
		        if (!(handlers = events[type])) {
		          handlers = events[type] = [];
		          handlers.delegateCount = 0;
		          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
		            if (elem.addEventListener) {
		              elem.addEventListener(type, eventHandle);
		            }
		          }
		        }
		        if (special.add) {
		          special.add.call(elem, handleObj);
		          if (!handleObj.handler.guid) {
		            handleObj.handler.guid = handler.guid;
		          }
		        }
		        if (selector) {
		          handlers.splice(handlers.delegateCount++, 0, handleObj);
		        } else {
		          handlers.push(handleObj);
		        }
		        jQuery.event.global[type] = true;
		      }
		    },
		    // Detach an event or set of events from an element
		    remove: function(elem, types, handler, selector, mappedTypes) {
		      var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
		      if (!elemData || !(events = elemData.events)) {
		        return;
		      }
		      types = (types || "").match(rnothtmlwhite) || [""];
		      t = types.length;
		      while (t--) {
		        tmp = rtypenamespace.exec(types[t]) || [];
		        type = origType = tmp[1];
		        namespaces = (tmp[2] || "").split(".").sort();
		        if (!type) {
		          for (type in events) {
		            jQuery.event.remove(elem, type + types[t], handler, selector, true);
		          }
		          continue;
		        }
		        special = jQuery.event.special[type] || {};
		        type = (selector ? special.delegateType : special.bindType) || type;
		        handlers = events[type] || [];
		        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
		        origCount = j = handlers.length;
		        while (j--) {
		          handleObj = handlers[j];
		          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
		            handlers.splice(j, 1);
		            if (handleObj.selector) {
		              handlers.delegateCount--;
		            }
		            if (special.remove) {
		              special.remove.call(elem, handleObj);
		            }
		          }
		        }
		        if (origCount && !handlers.length) {
		          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
		            jQuery.removeEvent(elem, type, elemData.handle);
		          }
		          delete events[type];
		        }
		      }
		      if (jQuery.isEmptyObject(events)) {
		        dataPriv.remove(elem, "handle events");
		      }
		    },
		    dispatch: function(nativeEvent) {
		      var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || /* @__PURE__ */ Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
		      args[0] = event;
		      for (i = 1; i < arguments.length; i++) {
		        args[i] = arguments[i];
		      }
		      event.delegateTarget = this;
		      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
		        return;
		      }
		      handlerQueue = jQuery.event.handlers.call(this, event, handlers);
		      i = 0;
		      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
		        event.currentTarget = matched.elem;
		        j = 0;
		        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
		          if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
		            event.handleObj = handleObj;
		            event.data = handleObj.data;
		            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
		            if (ret !== undefined) {
		              if ((event.result = ret) === false) {
		                event.preventDefault();
		                event.stopPropagation();
		              }
		            }
		          }
		        }
		      }
		      if (special.postDispatch) {
		        special.postDispatch.call(this, event);
		      }
		      return event.result;
		    },
		    handlers: function(event, handlers) {
		      var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
		      if (delegateCount && // Support: IE <=9
		      // Black-hole SVG <use> instance trees (trac-13180)
		      cur.nodeType && // Support: Firefox <=42
		      // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
		      // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
		      // Support: IE 11 only
		      // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
		      !(event.type === "click" && event.button >= 1)) {
		        for (; cur !== this; cur = cur.parentNode || this) {
		          if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
		            matchedHandlers = [];
		            matchedSelectors = {};
		            for (i = 0; i < delegateCount; i++) {
		              handleObj = handlers[i];
		              sel = handleObj.selector + " ";
		              if (matchedSelectors[sel] === undefined) {
		                matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
		              }
		              if (matchedSelectors[sel]) {
		                matchedHandlers.push(handleObj);
		              }
		            }
		            if (matchedHandlers.length) {
		              handlerQueue.push({ elem: cur, handlers: matchedHandlers });
		            }
		          }
		        }
		      }
		      cur = this;
		      if (delegateCount < handlers.length) {
		        handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
		      }
		      return handlerQueue;
		    },
		    addProp: function(name, hook) {
		      Object.defineProperty(jQuery.Event.prototype, name, {
		        enumerable: true,
		        configurable: true,
		        get: isFunction(hook) ? function() {
		          if (this.originalEvent) {
		            return hook(this.originalEvent);
		          }
		        } : function() {
		          if (this.originalEvent) {
		            return this.originalEvent[name];
		          }
		        },
		        set: function(value) {
		          Object.defineProperty(this, name, {
		            enumerable: true,
		            configurable: true,
		            writable: true,
		            value
		          });
		        }
		      });
		    },
		    fix: function(originalEvent) {
		      return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
		    },
		    special: {
		      load: {
		        // Prevent triggered image.load events from bubbling to window.load
		        noBubble: true
		      },
		      click: {
		        // Utilize native event to ensure correct state for checkable inputs
		        setup: function(data) {
		          var el = this || data;
		          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
		            leverageNative(el, "click", true);
		          }
		          return false;
		        },
		        trigger: function(data) {
		          var el = this || data;
		          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
		            leverageNative(el, "click");
		          }
		          return true;
		        },
		        // For cross-browser consistency, suppress native .click() on links
		        // Also prevent it if we're currently inside a leveraged native-event stack
		        _default: function(event) {
		          var target = event.target;
		          return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
		        }
		      },
		      beforeunload: {
		        postDispatch: function(event) {
		          if (event.result !== undefined && event.originalEvent) {
		            event.originalEvent.returnValue = event.result;
		          }
		        }
		      }
		    }
		  };
		  function leverageNative(el, type, isSetup) {
		    if (!isSetup) {
		      if (dataPriv.get(el, type) === undefined) {
		        jQuery.event.add(el, type, returnTrue);
		      }
		      return;
		    }
		    dataPriv.set(el, type, false);
		    jQuery.event.add(el, type, {
		      namespace: false,
		      handler: function(event) {
		        var result, saved = dataPriv.get(this, type);
		        if (event.isTrigger & 1 && this[type]) {
		          if (!saved) {
		            saved = slice.call(arguments);
		            dataPriv.set(this, type, saved);
		            this[type]();
		            result = dataPriv.get(this, type);
		            dataPriv.set(this, type, false);
		            if (saved !== result) {
		              event.stopImmediatePropagation();
		              event.preventDefault();
		              return result;
		            }
		          } else if ((jQuery.event.special[type] || {}).delegateType) {
		            event.stopPropagation();
		          }
		        } else if (saved) {
		          dataPriv.set(this, type, jQuery.event.trigger(
		            saved[0],
		            saved.slice(1),
		            this
		          ));
		          event.stopPropagation();
		          event.isImmediatePropagationStopped = returnTrue;
		        }
		      }
		    });
		  }
		  jQuery.removeEvent = function(elem, type, handle) {
		    if (elem.removeEventListener) {
		      elem.removeEventListener(type, handle);
		    }
		  };
		  jQuery.Event = function(src, props) {
		    if (!(this instanceof jQuery.Event)) {
		      return new jQuery.Event(src, props);
		    }
		    if (src && src.type) {
		      this.originalEvent = src;
		      this.type = src.type;
		      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
		      src.returnValue === false ? returnTrue : returnFalse;
		      this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
		      this.currentTarget = src.currentTarget;
		      this.relatedTarget = src.relatedTarget;
		    } else {
		      this.type = src;
		    }
		    if (props) {
		      jQuery.extend(this, props);
		    }
		    this.timeStamp = src && src.timeStamp || Date.now();
		    this[jQuery.expando] = true;
		  };
		  jQuery.Event.prototype = {
		    constructor: jQuery.Event,
		    isDefaultPrevented: returnFalse,
		    isPropagationStopped: returnFalse,
		    isImmediatePropagationStopped: returnFalse,
		    isSimulated: false,
		    preventDefault: function() {
		      var e = this.originalEvent;
		      this.isDefaultPrevented = returnTrue;
		      if (e && !this.isSimulated) {
		        e.preventDefault();
		      }
		    },
		    stopPropagation: function() {
		      var e = this.originalEvent;
		      this.isPropagationStopped = returnTrue;
		      if (e && !this.isSimulated) {
		        e.stopPropagation();
		      }
		    },
		    stopImmediatePropagation: function() {
		      var e = this.originalEvent;
		      this.isImmediatePropagationStopped = returnTrue;
		      if (e && !this.isSimulated) {
		        e.stopImmediatePropagation();
		      }
		      this.stopPropagation();
		    }
		  };
		  jQuery.each({
		    altKey: true,
		    bubbles: true,
		    cancelable: true,
		    changedTouches: true,
		    ctrlKey: true,
		    detail: true,
		    eventPhase: true,
		    metaKey: true,
		    pageX: true,
		    pageY: true,
		    shiftKey: true,
		    view: true,
		    "char": true,
		    code: true,
		    charCode: true,
		    key: true,
		    keyCode: true,
		    button: true,
		    buttons: true,
		    clientX: true,
		    clientY: true,
		    offsetX: true,
		    offsetY: true,
		    pointerId: true,
		    pointerType: true,
		    screenX: true,
		    screenY: true,
		    targetTouches: true,
		    toElement: true,
		    touches: true,
		    which: true
		  }, jQuery.event.addProp);
		  jQuery.each({ focus: "focusin", blur: "focusout" }, function(type, delegateType) {
		    function focusMappedHandler(nativeEvent) {
		      if (document.documentMode) {
		        var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
		        event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
		        event.isSimulated = true;
		        handle(nativeEvent);
		        if (event.target === event.currentTarget) {
		          handle(event);
		        }
		      } else {
		        jQuery.event.simulate(
		          delegateType,
		          nativeEvent.target,
		          jQuery.event.fix(nativeEvent)
		        );
		      }
		    }
		    jQuery.event.special[type] = {
		      // Utilize native event if possible so blur/focus sequence is correct
		      setup: function() {
		        var attaches;
		        leverageNative(this, type, true);
		        if (document.documentMode) {
		          attaches = dataPriv.get(this, delegateType);
		          if (!attaches) {
		            this.addEventListener(delegateType, focusMappedHandler);
		          }
		          dataPriv.set(this, delegateType, (attaches || 0) + 1);
		        } else {
		          return false;
		        }
		      },
		      trigger: function() {
		        leverageNative(this, type);
		        return true;
		      },
		      teardown: function() {
		        var attaches;
		        if (document.documentMode) {
		          attaches = dataPriv.get(this, delegateType) - 1;
		          if (!attaches) {
		            this.removeEventListener(delegateType, focusMappedHandler);
		            dataPriv.remove(this, delegateType);
		          } else {
		            dataPriv.set(this, delegateType, attaches);
		          }
		        } else {
		          return false;
		        }
		      },
		      // Suppress native focus or blur if we're currently inside
		      // a leveraged native-event stack
		      _default: function(event) {
		        return dataPriv.get(event.target, type);
		      },
		      delegateType
		    };
		    jQuery.event.special[delegateType] = {
		      setup: function() {
		        var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
		        if (!attaches) {
		          if (document.documentMode) {
		            this.addEventListener(delegateType, focusMappedHandler);
		          } else {
		            doc.addEventListener(type, focusMappedHandler, true);
		          }
		        }
		        dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
		      },
		      teardown: function() {
		        var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
		        if (!attaches) {
		          if (document.documentMode) {
		            this.removeEventListener(delegateType, focusMappedHandler);
		          } else {
		            doc.removeEventListener(type, focusMappedHandler, true);
		          }
		          dataPriv.remove(dataHolder, delegateType);
		        } else {
		          dataPriv.set(dataHolder, delegateType, attaches);
		        }
		      }
		    };
		  });
		  jQuery.each({
		    mouseenter: "mouseover",
		    mouseleave: "mouseout",
		    pointerenter: "pointerover",
		    pointerleave: "pointerout"
		  }, function(orig, fix) {
		    jQuery.event.special[orig] = {
		      delegateType: fix,
		      bindType: fix,
		      handle: function(event) {
		        var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
		        if (!related || related !== target && !jQuery.contains(target, related)) {
		          event.type = handleObj.origType;
		          ret = handleObj.handler.apply(this, arguments);
		          event.type = fix;
		        }
		        return ret;
		      }
		    };
		  });
		  jQuery.fn.extend({
		    on: function(types, selector, data, fn) {
		      return on(this, types, selector, data, fn);
		    },
		    one: function(types, selector, data, fn) {
		      return on(this, types, selector, data, fn, 1);
		    },
		    off: function(types, selector, fn) {
		      var handleObj, type;
		      if (types && types.preventDefault && types.handleObj) {
		        handleObj = types.handleObj;
		        jQuery(types.delegateTarget).off(
		          handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
		          handleObj.selector,
		          handleObj.handler
		        );
		        return this;
		      }
		      if (typeof types === "object") {
		        for (type in types) {
		          this.off(type, selector, types[type]);
		        }
		        return this;
		      }
		      if (selector === false || typeof selector === "function") {
		        fn = selector;
		        selector = undefined;
		      }
		      if (fn === false) {
		        fn = returnFalse;
		      }
		      return this.each(function() {
		        jQuery.event.remove(this, types, fn, selector);
		      });
		    }
		  });
		  var rnoInnerhtml = /<script|<style|<link/i, rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
		  function manipulationTarget(elem, content) {
		    if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
		      return jQuery(elem).children("tbody")[0] || elem;
		    }
		    return elem;
		  }
		  function disableScript(elem) {
		    elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		    return elem;
		  }
		  function restoreScript(elem) {
		    if ((elem.type || "").slice(0, 5) === "true/") {
		      elem.type = elem.type.slice(5);
		    } else {
		      elem.removeAttribute("type");
		    }
		    return elem;
		  }
		  function cloneCopyEvent(src, dest) {
		    var i, l, type, pdataOld, udataOld, udataCur, events;
		    if (dest.nodeType !== 1) {
		      return;
		    }
		    if (dataPriv.hasData(src)) {
		      pdataOld = dataPriv.get(src);
		      events = pdataOld.events;
		      if (events) {
		        dataPriv.remove(dest, "handle events");
		        for (type in events) {
		          for (i = 0, l = events[type].length; i < l; i++) {
		            jQuery.event.add(dest, type, events[type][i]);
		          }
		        }
		      }
		    }
		    if (dataUser.hasData(src)) {
		      udataOld = dataUser.access(src);
		      udataCur = jQuery.extend({}, udataOld);
		      dataUser.set(dest, udataCur);
		    }
		  }
		  function fixInput(src, dest) {
		    var nodeName2 = dest.nodeName.toLowerCase();
		    if (nodeName2 === "input" && rcheckableType.test(src.type)) {
		      dest.checked = src.checked;
		    } else if (nodeName2 === "input" || nodeName2 === "textarea") {
		      dest.defaultValue = src.defaultValue;
		    }
		  }
		  function domManip(collection, args, callback, ignored) {
		    args = flat(args);
		    var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
		    if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
		      return collection.each(function(index) {
		        var self = collection.eq(index);
		        if (valueIsFunction) {
		          args[0] = value.call(this, index, self.html());
		        }
		        domManip(self, args, callback, ignored);
		      });
		    }
		    if (l) {
		      fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
		      first = fragment.firstChild;
		      if (fragment.childNodes.length === 1) {
		        fragment = first;
		      }
		      if (first || ignored) {
		        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
		        hasScripts = scripts.length;
		        for (; i < l; i++) {
		          node = fragment;
		          if (i !== iNoClone) {
		            node = jQuery.clone(node, true, true);
		            if (hasScripts) {
		              jQuery.merge(scripts, getAll(node, "script"));
		            }
		          }
		          callback.call(collection[i], node, i);
		        }
		        if (hasScripts) {
		          doc = scripts[scripts.length - 1].ownerDocument;
		          jQuery.map(scripts, restoreScript);
		          for (i = 0; i < hasScripts; i++) {
		            node = scripts[i];
		            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
		              if (node.src && (node.type || "").toLowerCase() !== "module") {
		                if (jQuery._evalUrl && !node.noModule) {
		                  jQuery._evalUrl(node.src, {
		                    nonce: node.nonce || node.getAttribute("nonce")
		                  }, doc);
		                }
		              } else {
		                DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
		              }
		            }
		          }
		        }
		      }
		    }
		    return collection;
		  }
		  function remove(elem, selector, keepData) {
		    var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
		    for (; (node = nodes[i]) != null; i++) {
		      if (!keepData && node.nodeType === 1) {
		        jQuery.cleanData(getAll(node));
		      }
		      if (node.parentNode) {
		        if (keepData && isAttached(node)) {
		          setGlobalEval(getAll(node, "script"));
		        }
		        node.parentNode.removeChild(node);
		      }
		    }
		    return elem;
		  }
		  jQuery.extend({
		    htmlPrefilter: function(html) {
		      return html;
		    },
		    clone: function(elem, dataAndEvents, deepDataAndEvents) {
		      var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
		      if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
		        destElements = getAll(clone);
		        srcElements = getAll(elem);
		        for (i = 0, l = srcElements.length; i < l; i++) {
		          fixInput(srcElements[i], destElements[i]);
		        }
		      }
		      if (dataAndEvents) {
		        if (deepDataAndEvents) {
		          srcElements = srcElements || getAll(elem);
		          destElements = destElements || getAll(clone);
		          for (i = 0, l = srcElements.length; i < l; i++) {
		            cloneCopyEvent(srcElements[i], destElements[i]);
		          }
		        } else {
		          cloneCopyEvent(elem, clone);
		        }
		      }
		      destElements = getAll(clone, "script");
		      if (destElements.length > 0) {
		        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
		      }
		      return clone;
		    },
		    cleanData: function(elems) {
		      var data, elem, type, special = jQuery.event.special, i = 0;
		      for (; (elem = elems[i]) !== undefined; i++) {
		        if (acceptData(elem)) {
		          if (data = elem[dataPriv.expando]) {
		            if (data.events) {
		              for (type in data.events) {
		                if (special[type]) {
		                  jQuery.event.remove(elem, type);
		                } else {
		                  jQuery.removeEvent(elem, type, data.handle);
		                }
		              }
		            }
		            elem[dataPriv.expando] = undefined;
		          }
		          if (elem[dataUser.expando]) {
		            elem[dataUser.expando] = undefined;
		          }
		        }
		      }
		    }
		  });
		  jQuery.fn.extend({
		    detach: function(selector) {
		      return remove(this, selector, true);
		    },
		    remove: function(selector) {
		      return remove(this, selector);
		    },
		    text: function(value) {
		      return access(this, function(value2) {
		        return value2 === undefined ? jQuery.text(this) : this.empty().each(function() {
		          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
		            this.textContent = value2;
		          }
		        });
		      }, null, value, arguments.length);
		    },
		    append: function() {
		      return domManip(this, arguments, function(elem) {
		        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
		          var target = manipulationTarget(this, elem);
		          target.appendChild(elem);
		        }
		      });
		    },
		    prepend: function() {
		      return domManip(this, arguments, function(elem) {
		        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
		          var target = manipulationTarget(this, elem);
		          target.insertBefore(elem, target.firstChild);
		        }
		      });
		    },
		    before: function() {
		      return domManip(this, arguments, function(elem) {
		        if (this.parentNode) {
		          this.parentNode.insertBefore(elem, this);
		        }
		      });
		    },
		    after: function() {
		      return domManip(this, arguments, function(elem) {
		        if (this.parentNode) {
		          this.parentNode.insertBefore(elem, this.nextSibling);
		        }
		      });
		    },
		    empty: function() {
		      var elem, i = 0;
		      for (; (elem = this[i]) != null; i++) {
		        if (elem.nodeType === 1) {
		          jQuery.cleanData(getAll(elem, false));
		          elem.textContent = "";
		        }
		      }
		      return this;
		    },
		    clone: function(dataAndEvents, deepDataAndEvents) {
		      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
		      return this.map(function() {
		        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
		      });
		    },
		    html: function(value) {
		      return access(this, function(value2) {
		        var elem = this[0] || {}, i = 0, l = this.length;
		        if (value2 === undefined && elem.nodeType === 1) {
		          return elem.innerHTML;
		        }
		        if (typeof value2 === "string" && !rnoInnerhtml.test(value2) && !wrapMap[(rtagName.exec(value2) || ["", ""])[1].toLowerCase()]) {
		          value2 = jQuery.htmlPrefilter(value2);
		          try {
		            for (; i < l; i++) {
		              elem = this[i] || {};
		              if (elem.nodeType === 1) {
		                jQuery.cleanData(getAll(elem, false));
		                elem.innerHTML = value2;
		              }
		            }
		            elem = 0;
		          } catch (e) {
		          }
		        }
		        if (elem) {
		          this.empty().append(value2);
		        }
		      }, null, value, arguments.length);
		    },
		    replaceWith: function() {
		      var ignored = [];
		      return domManip(this, arguments, function(elem) {
		        var parent = this.parentNode;
		        if (jQuery.inArray(this, ignored) < 0) {
		          jQuery.cleanData(getAll(this));
		          if (parent) {
		            parent.replaceChild(elem, this);
		          }
		        }
		      }, ignored);
		    }
		  });
		  jQuery.each({
		    appendTo: "append",
		    prependTo: "prepend",
		    insertBefore: "before",
		    insertAfter: "after",
		    replaceAll: "replaceWith"
		  }, function(name, original) {
		    jQuery.fn[name] = function(selector) {
		      var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
		      for (; i <= last; i++) {
		        elems = i === last ? this : this.clone(true);
		        jQuery(insert[i])[original](elems);
		        push.apply(ret, elems.get());
		      }
		      return this.pushStack(ret);
		    };
		  });
		  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
		  var rcustomProp = /^--/;
		  var getStyles = function(elem) {
		    var view = elem.ownerDocument.defaultView;
		    if (!view || !view.opener) {
		      view = window2;
		    }
		    return view.getComputedStyle(elem);
		  };
		  var swap = function(elem, options, callback) {
		    var ret, name, old = {};
		    for (name in options) {
		      old[name] = elem.style[name];
		      elem.style[name] = options[name];
		    }
		    ret = callback.call(elem);
		    for (name in options) {
		      elem.style[name] = old[name];
		    }
		    return ret;
		  };
		  var rboxStyle = new RegExp(cssExpand.join("|"), "i");
		  (function() {
		    function computeStyleTests() {
		      if (!div) {
		        return;
		      }
		      container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
		      div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
		      documentElement.appendChild(container).appendChild(div);
		      var divStyle = window2.getComputedStyle(div);
		      pixelPositionVal = divStyle.top !== "1%";
		      reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
		      div.style.right = "60%";
		      pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
		      boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
		      div.style.position = "absolute";
		      scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
		      documentElement.removeChild(container);
		      div = null;
		    }
		    function roundPixelMeasures(measure) {
		      return Math.round(parseFloat(measure));
		    }
		    var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
		    if (!div.style) {
		      return;
		    }
		    div.style.backgroundClip = "content-box";
		    div.cloneNode(true).style.backgroundClip = "";
		    support.clearCloneStyle = div.style.backgroundClip === "content-box";
		    jQuery.extend(support, {
		      boxSizingReliable: function() {
		        computeStyleTests();
		        return boxSizingReliableVal;
		      },
		      pixelBoxStyles: function() {
		        computeStyleTests();
		        return pixelBoxStylesVal;
		      },
		      pixelPosition: function() {
		        computeStyleTests();
		        return pixelPositionVal;
		      },
		      reliableMarginLeft: function() {
		        computeStyleTests();
		        return reliableMarginLeftVal;
		      },
		      scrollboxSize: function() {
		        computeStyleTests();
		        return scrollboxSizeVal;
		      },
		      // Support: IE 9 - 11+, Edge 15 - 18+
		      // IE/Edge misreport `getComputedStyle` of table rows with width/height
		      // set in CSS while `offset*` properties report correct values.
		      // Behavior in IE 9 is more subtle than in newer versions & it passes
		      // some versions of this test; make sure not to make it pass there!
		      //
		      // Support: Firefox 70+
		      // Only Firefox includes border widths
		      // in computed dimensions. (gh-4529)
		      reliableTrDimensions: function() {
		        var table, tr, trChild, trStyle;
		        if (reliableTrDimensionsVal == null) {
		          table = document.createElement("table");
		          tr = document.createElement("tr");
		          trChild = document.createElement("div");
		          table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
		          tr.style.cssText = "box-sizing:content-box;border:1px solid";
		          tr.style.height = "1px";
		          trChild.style.height = "9px";
		          trChild.style.display = "block";
		          documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
		          trStyle = window2.getComputedStyle(tr);
		          reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
		          documentElement.removeChild(table);
		        }
		        return reliableTrDimensionsVal;
		      }
		    });
		  })();
		  function curCSS(elem, name, computed) {
		    var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), style = elem.style;
		    computed = computed || getStyles(elem);
		    if (computed) {
		      ret = computed.getPropertyValue(name) || computed[name];
		      if (isCustomProp && ret) {
		        ret = ret.replace(rtrimCSS, "$1") || undefined;
		      }
		      if (ret === "" && !isAttached(elem)) {
		        ret = jQuery.style(elem, name);
		      }
		      if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
		        width = style.width;
		        minWidth = style.minWidth;
		        maxWidth = style.maxWidth;
		        style.minWidth = style.maxWidth = style.width = ret;
		        ret = computed.width;
		        style.width = width;
		        style.minWidth = minWidth;
		        style.maxWidth = maxWidth;
		      }
		    }
		    return ret !== undefined ? (
		      // Support: IE <=9 - 11 only
		      // IE returns zIndex value as an integer.
		      ret + ""
		    ) : ret;
		  }
		  function addGetHookIf(conditionFn, hookFn) {
		    return {
		      get: function() {
		        if (conditionFn()) {
		          delete this.get;
		          return;
		        }
		        return (this.get = hookFn).apply(this, arguments);
		      }
		    };
		  }
		  var cssPrefixes = ["Webkit", "Moz", "ms"], emptyStyle = document.createElement("div").style, vendorProps = {};
		  function vendorPropName(name) {
		    var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
		    while (i--) {
		      name = cssPrefixes[i] + capName;
		      if (name in emptyStyle) {
		        return name;
		      }
		    }
		  }
		  function finalPropName(name) {
		    var final = jQuery.cssProps[name] || vendorProps[name];
		    if (final) {
		      return final;
		    }
		    if (name in emptyStyle) {
		      return name;
		    }
		    return vendorProps[name] = vendorPropName(name) || name;
		  }
		  var rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
		    letterSpacing: "0",
		    fontWeight: "400"
		  };
		  function setPositiveNumber(_elem, value, subtract) {
		    var matches = rcssNum.exec(value);
		    return matches ? (
		      // Guard against undefined "subtract", e.g., when used as in cssHooks
		      Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
		    ) : value;
		  }
		  function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
		    var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
		    if (box === (isBorderBox ? "border" : "content")) {
		      return 0;
		    }
		    for (; i < 4; i += 2) {
		      if (box === "margin") {
		        marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
		      }
		      if (!isBorderBox) {
		        delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
		        if (box !== "padding") {
		          delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
		        } else {
		          extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
		        }
		      } else {
		        if (box === "content") {
		          delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
		        }
		        if (box !== "margin") {
		          delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
		        }
		      }
		    }
		    if (!isBorderBox && computedVal >= 0) {
		      delta += Math.max(0, Math.ceil(
		        elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5
		        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		        // Use an explicit zero to avoid NaN (gh-3964)
		      )) || 0;
		    }
		    return delta + marginDelta;
		  }
		  function getWidthOrHeight(elem, dimension, extra) {
		    var styles = getStyles(elem), boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
		    if (rnumnonpx.test(val)) {
		      if (!extra) {
		        return val;
		      }
		      val = "auto";
		    }
		    if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
		    // IE/Edge misreport `getComputedStyle` of table rows with width/height
		    // set in CSS while `offset*` properties report correct values.
		    // Interestingly, in some cases IE 9 doesn't suffer from this issue.
		    !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
		    // This happens for inline elements with no explicit setting (gh-3571)
		    val === "auto" || // Support: Android <=4.1 - 4.3 only
		    // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		    !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
		    elem.getClientRects().length) {
		      isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
		      valueIsBorderBox = offsetProp in elem;
		      if (valueIsBorderBox) {
		        val = elem[offsetProp];
		      }
		    }
		    val = parseFloat(val) || 0;
		    return val + boxModelAdjustment(
		      elem,
		      dimension,
		      extra || (isBorderBox ? "border" : "content"),
		      valueIsBorderBox,
		      styles,
		      // Provide the current computed size to request scroll gutter calculation (gh-3589)
		      val
		    ) + "px";
		  }
		  jQuery.extend({
		    // Add in style property hooks for overriding the default
		    // behavior of getting and setting a style property
		    cssHooks: {
		      opacity: {
		        get: function(elem, computed) {
		          if (computed) {
		            var ret = curCSS(elem, "opacity");
		            return ret === "" ? "1" : ret;
		          }
		        }
		      }
		    },
		    // Don't automatically add "px" to these possibly-unitless properties
		    cssNumber: {
		      animationIterationCount: true,
		      aspectRatio: true,
		      borderImageSlice: true,
		      columnCount: true,
		      flexGrow: true,
		      flexShrink: true,
		      fontWeight: true,
		      gridArea: true,
		      gridColumn: true,
		      gridColumnEnd: true,
		      gridColumnStart: true,
		      gridRow: true,
		      gridRowEnd: true,
		      gridRowStart: true,
		      lineHeight: true,
		      opacity: true,
		      order: true,
		      orphans: true,
		      scale: true,
		      widows: true,
		      zIndex: true,
		      zoom: true,
		      // SVG-related
		      fillOpacity: true,
		      floodOpacity: true,
		      stopOpacity: true,
		      strokeMiterlimit: true,
		      strokeOpacity: true
		    },
		    // Add in properties whose names you wish to fix before
		    // setting or getting the value
		    cssProps: {},
		    // Get and set the style property on a DOM Node
		    style: function(elem, name, value, extra) {
		      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
		        return;
		      }
		      var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
		      if (!isCustomProp) {
		        name = finalPropName(origName);
		      }
		      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
		      if (value !== undefined) {
		        type = typeof value;
		        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
		          value = adjustCSS(elem, name, ret);
		          type = "number";
		        }
		        if (value == null || value !== value) {
		          return;
		        }
		        if (type === "number" && !isCustomProp) {
		          value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
		        }
		        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
		          style[name] = "inherit";
		        }
		        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
		          if (isCustomProp) {
		            style.setProperty(name, value);
		          } else {
		            style[name] = value;
		          }
		        }
		      } else {
		        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
		          return ret;
		        }
		        return style[name];
		      }
		    },
		    css: function(elem, name, extra, styles) {
		      var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
		      if (!isCustomProp) {
		        name = finalPropName(origName);
		      }
		      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
		      if (hooks && "get" in hooks) {
		        val = hooks.get(elem, true, extra);
		      }
		      if (val === undefined) {
		        val = curCSS(elem, name, styles);
		      }
		      if (val === "normal" && name in cssNormalTransform) {
		        val = cssNormalTransform[name];
		      }
		      if (extra === "" || extra) {
		        num = parseFloat(val);
		        return extra === true || isFinite(num) ? num || 0 : val;
		      }
		      return val;
		    }
		  });
		  jQuery.each(["height", "width"], function(_i, dimension) {
		    jQuery.cssHooks[dimension] = {
		      get: function(elem, computed, extra) {
		        if (computed) {
		          return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
		          // Table columns in Safari have non-zero offsetWidth & zero
		          // getBoundingClientRect().width unless display is changed.
		          // Support: IE <=11 only
		          // Running getBoundingClientRect on a disconnected node
		          // in IE throws an error.
		          (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
		            return getWidthOrHeight(elem, dimension, extra);
		          }) : getWidthOrHeight(elem, dimension, extra);
		        }
		      },
		      set: function(elem, value, extra) {
		        var matches, styles = getStyles(elem), scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(
		          elem,
		          dimension,
		          extra,
		          isBorderBox,
		          styles
		        ) : 0;
		        if (isBorderBox && scrollboxSizeBuggy) {
		          subtract -= Math.ceil(
		            elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5
		          );
		        }
		        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
		          elem.style[dimension] = value;
		          value = jQuery.css(elem, dimension);
		        }
		        return setPositiveNumber(elem, value, subtract);
		      }
		    };
		  });
		  jQuery.cssHooks.marginLeft = addGetHookIf(
		    support.reliableMarginLeft,
		    function(elem, computed) {
		      if (computed) {
		        return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function() {
		          return elem.getBoundingClientRect().left;
		        })) + "px";
		      }
		    }
		  );
		  jQuery.each({
		    margin: "",
		    padding: "",
		    border: "Width"
		  }, function(prefix, suffix) {
		    jQuery.cssHooks[prefix + suffix] = {
		      expand: function(value) {
		        var i = 0, expanded = {}, parts = typeof value === "string" ? value.split(" ") : [value];
		        for (; i < 4; i++) {
		          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
		        }
		        return expanded;
		      }
		    };
		    if (prefix !== "margin") {
		      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
		    }
		  });
		  jQuery.fn.extend({
		    css: function(name, value) {
		      return access(this, function(elem, name2, value2) {
		        var styles, len, map = {}, i = 0;
		        if (Array.isArray(name2)) {
		          styles = getStyles(elem);
		          len = name2.length;
		          for (; i < len; i++) {
		            map[name2[i]] = jQuery.css(elem, name2[i], false, styles);
		          }
		          return map;
		        }
		        return value2 !== undefined ? jQuery.style(elem, name2, value2) : jQuery.css(elem, name2);
		      }, name, value, arguments.length > 1);
		    }
		  });
		  function Tween(elem, options, prop, end, easing) {
		    return new Tween.prototype.init(elem, options, prop, end, easing);
		  }
		  jQuery.Tween = Tween;
		  Tween.prototype = {
		    constructor: Tween,
		    init: function(elem, options, prop, end, easing, unit) {
		      this.elem = elem;
		      this.prop = prop;
		      this.easing = easing || jQuery.easing._default;
		      this.options = options;
		      this.start = this.now = this.cur();
		      this.end = end;
		      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
		    },
		    cur: function() {
		      var hooks = Tween.propHooks[this.prop];
		      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
		    },
		    run: function(percent) {
		      var eased, hooks = Tween.propHooks[this.prop];
		      if (this.options.duration) {
		        this.pos = eased = jQuery.easing[this.easing](
		          percent,
		          this.options.duration * percent,
		          0,
		          1,
		          this.options.duration
		        );
		      } else {
		        this.pos = eased = percent;
		      }
		      this.now = (this.end - this.start) * eased + this.start;
		      if (this.options.step) {
		        this.options.step.call(this.elem, this.now, this);
		      }
		      if (hooks && hooks.set) {
		        hooks.set(this);
		      } else {
		        Tween.propHooks._default.set(this);
		      }
		      return this;
		    }
		  };
		  Tween.prototype.init.prototype = Tween.prototype;
		  Tween.propHooks = {
		    _default: {
		      get: function(tween) {
		        var result;
		        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
		          return tween.elem[tween.prop];
		        }
		        result = jQuery.css(tween.elem, tween.prop, "");
		        return !result || result === "auto" ? 0 : result;
		      },
		      set: function(tween) {
		        if (jQuery.fx.step[tween.prop]) {
		          jQuery.fx.step[tween.prop](tween);
		        } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
		          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
		        } else {
		          tween.elem[tween.prop] = tween.now;
		        }
		      }
		    }
		  };
		  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		    set: function(tween) {
		      if (tween.elem.nodeType && tween.elem.parentNode) {
		        tween.elem[tween.prop] = tween.now;
		      }
		    }
		  };
		  jQuery.easing = {
		    linear: function(p) {
		      return p;
		    },
		    swing: function(p) {
		      return 0.5 - Math.cos(p * Math.PI) / 2;
		    },
		    _default: "swing"
		  };
		  jQuery.fx = Tween.prototype.init;
		  jQuery.fx.step = {};
		  var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
		  function schedule() {
		    if (inProgress) {
		      if (document.hidden === false && window2.requestAnimationFrame) {
		        window2.requestAnimationFrame(schedule);
		      } else {
		        window2.setTimeout(schedule, jQuery.fx.interval);
		      }
		      jQuery.fx.tick();
		    }
		  }
		  function createFxNow() {
		    window2.setTimeout(function() {
		      fxNow = undefined;
		    });
		    return fxNow = Date.now();
		  }
		  function genFx(type, includeWidth) {
		    var which, i = 0, attrs = { height: type };
		    includeWidth = includeWidth ? 1 : 0;
		    for (; i < 4; i += 2 - includeWidth) {
		      which = cssExpand[i];
		      attrs["margin" + which] = attrs["padding" + which] = type;
		    }
		    if (includeWidth) {
		      attrs.opacity = attrs.width = type;
		    }
		    return attrs;
		  }
		  function createTween(value, prop, animation) {
		    var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
		    for (; index < length; index++) {
		      if (tween = collection[index].call(animation, prop, value)) {
		        return tween;
		      }
		    }
		  }
		  function defaultPrefilter(elem, props, opts) {
		    var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
		    if (!opts.queue) {
		      hooks = jQuery._queueHooks(elem, "fx");
		      if (hooks.unqueued == null) {
		        hooks.unqueued = 0;
		        oldfire = hooks.empty.fire;
		        hooks.empty.fire = function() {
		          if (!hooks.unqueued) {
		            oldfire();
		          }
		        };
		      }
		      hooks.unqueued++;
		      anim.always(function() {
		        anim.always(function() {
		          hooks.unqueued--;
		          if (!jQuery.queue(elem, "fx").length) {
		            hooks.empty.fire();
		          }
		        });
		      });
		    }
		    for (prop in props) {
		      value = props[prop];
		      if (rfxtypes.test(value)) {
		        delete props[prop];
		        toggle = toggle || value === "toggle";
		        if (value === (hidden ? "hide" : "show")) {
		          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
		            hidden = true;
		          } else {
		            continue;
		          }
		        }
		        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
		      }
		    }
		    propTween = !jQuery.isEmptyObject(props);
		    if (!propTween && jQuery.isEmptyObject(orig)) {
		      return;
		    }
		    if (isBox && elem.nodeType === 1) {
		      opts.overflow = [style.overflow, style.overflowX, style.overflowY];
		      restoreDisplay = dataShow && dataShow.display;
		      if (restoreDisplay == null) {
		        restoreDisplay = dataPriv.get(elem, "display");
		      }
		      display = jQuery.css(elem, "display");
		      if (display === "none") {
		        if (restoreDisplay) {
		          display = restoreDisplay;
		        } else {
		          showHide([elem], true);
		          restoreDisplay = elem.style.display || restoreDisplay;
		          display = jQuery.css(elem, "display");
		          showHide([elem]);
		        }
		      }
		      if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
		        if (jQuery.css(elem, "float") === "none") {
		          if (!propTween) {
		            anim.done(function() {
		              style.display = restoreDisplay;
		            });
		            if (restoreDisplay == null) {
		              display = style.display;
		              restoreDisplay = display === "none" ? "" : display;
		            }
		          }
		          style.display = "inline-block";
		        }
		      }
		    }
		    if (opts.overflow) {
		      style.overflow = "hidden";
		      anim.always(function() {
		        style.overflow = opts.overflow[0];
		        style.overflowX = opts.overflow[1];
		        style.overflowY = opts.overflow[2];
		      });
		    }
		    propTween = false;
		    for (prop in orig) {
		      if (!propTween) {
		        if (dataShow) {
		          if ("hidden" in dataShow) {
		            hidden = dataShow.hidden;
		          }
		        } else {
		          dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
		        }
		        if (toggle) {
		          dataShow.hidden = !hidden;
		        }
		        if (hidden) {
		          showHide([elem], true);
		        }
		        anim.done(function() {
		          if (!hidden) {
		            showHide([elem]);
		          }
		          dataPriv.remove(elem, "fxshow");
		          for (prop in orig) {
		            jQuery.style(elem, prop, orig[prop]);
		          }
		        });
		      }
		      propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
		      if (!(prop in dataShow)) {
		        dataShow[prop] = propTween.start;
		        if (hidden) {
		          propTween.end = propTween.start;
		          propTween.start = 0;
		        }
		      }
		    }
		  }
		  function propFilter(props, specialEasing) {
		    var index, name, easing, value, hooks;
		    for (index in props) {
		      name = camelCase(index);
		      easing = specialEasing[name];
		      value = props[index];
		      if (Array.isArray(value)) {
		        easing = value[1];
		        value = props[index] = value[0];
		      }
		      if (index !== name) {
		        props[name] = value;
		        delete props[index];
		      }
		      hooks = jQuery.cssHooks[name];
		      if (hooks && "expand" in hooks) {
		        value = hooks.expand(value);
		        delete props[name];
		        for (index in value) {
		          if (!(index in props)) {
		            props[index] = value[index];
		            specialEasing[index] = easing;
		          }
		        }
		      } else {
		        specialEasing[name] = easing;
		      }
		    }
		  }
		  function Animation(elem, properties, options) {
		    var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
		      delete tick.elem;
		    }), tick = function() {
		      if (stopped) {
		        return false;
		      }
		      var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), temp = remaining / animation.duration || 0, percent = 1 - temp, index2 = 0, length2 = animation.tweens.length;
		      for (; index2 < length2; index2++) {
		        animation.tweens[index2].run(percent);
		      }
		      deferred.notifyWith(elem, [animation, percent, remaining]);
		      if (percent < 1 && length2) {
		        return remaining;
		      }
		      if (!length2) {
		        deferred.notifyWith(elem, [animation, 1, 0]);
		      }
		      deferred.resolveWith(elem, [animation]);
		      return false;
		    }, animation = deferred.promise({
		      elem,
		      props: jQuery.extend({}, properties),
		      opts: jQuery.extend(true, {
		        specialEasing: {},
		        easing: jQuery.easing._default
		      }, options),
		      originalProperties: properties,
		      originalOptions: options,
		      startTime: fxNow || createFxNow(),
		      duration: options.duration,
		      tweens: [],
		      createTween: function(prop, end) {
		        var tween = jQuery.Tween(
		          elem,
		          animation.opts,
		          prop,
		          end,
		          animation.opts.specialEasing[prop] || animation.opts.easing
		        );
		        animation.tweens.push(tween);
		        return tween;
		      },
		      stop: function(gotoEnd) {
		        var index2 = 0, length2 = gotoEnd ? animation.tweens.length : 0;
		        if (stopped) {
		          return this;
		        }
		        stopped = true;
		        for (; index2 < length2; index2++) {
		          animation.tweens[index2].run(1);
		        }
		        if (gotoEnd) {
		          deferred.notifyWith(elem, [animation, 1, 0]);
		          deferred.resolveWith(elem, [animation, gotoEnd]);
		        } else {
		          deferred.rejectWith(elem, [animation, gotoEnd]);
		        }
		        return this;
		      }
		    }), props = animation.props;
		    propFilter(props, animation.opts.specialEasing);
		    for (; index < length; index++) {
		      result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
		      if (result) {
		        if (isFunction(result.stop)) {
		          jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
		        }
		        return result;
		      }
		    }
		    jQuery.map(props, createTween, animation);
		    if (isFunction(animation.opts.start)) {
		      animation.opts.start.call(elem, animation);
		    }
		    animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
		    jQuery.fx.timer(
		      jQuery.extend(tick, {
		        elem,
		        anim: animation,
		        queue: animation.opts.queue
		      })
		    );
		    return animation;
		  }
		  jQuery.Animation = jQuery.extend(Animation, {
		    tweeners: {
		      "*": [function(prop, value) {
		        var tween = this.createTween(prop, value);
		        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
		        return tween;
		      }]
		    },
		    tweener: function(props, callback) {
		      if (isFunction(props)) {
		        callback = props;
		        props = ["*"];
		      } else {
		        props = props.match(rnothtmlwhite);
		      }
		      var prop, index = 0, length = props.length;
		      for (; index < length; index++) {
		        prop = props[index];
		        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
		        Animation.tweeners[prop].unshift(callback);
		      }
		    },
		    prefilters: [defaultPrefilter],
		    prefilter: function(callback, prepend) {
		      if (prepend) {
		        Animation.prefilters.unshift(callback);
		      } else {
		        Animation.prefilters.push(callback);
		      }
		    }
		  });
		  jQuery.speed = function(speed, easing, fn) {
		    var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
		      complete: fn || !fn && easing || isFunction(speed) && speed,
		      duration: speed,
		      easing: fn && easing || easing && !isFunction(easing) && easing
		    };
		    if (jQuery.fx.off) {
		      opt.duration = 0;
		    } else {
		      if (typeof opt.duration !== "number") {
		        if (opt.duration in jQuery.fx.speeds) {
		          opt.duration = jQuery.fx.speeds[opt.duration];
		        } else {
		          opt.duration = jQuery.fx.speeds._default;
		        }
		      }
		    }
		    if (opt.queue == null || opt.queue === true) {
		      opt.queue = "fx";
		    }
		    opt.old = opt.complete;
		    opt.complete = function() {
		      if (isFunction(opt.old)) {
		        opt.old.call(this);
		      }
		      if (opt.queue) {
		        jQuery.dequeue(this, opt.queue);
		      }
		    };
		    return opt;
		  };
		  jQuery.fn.extend({
		    fadeTo: function(speed, to, easing, callback) {
		      return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
		    },
		    animate: function(prop, speed, easing, callback) {
		      var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
		        var anim = Animation(this, jQuery.extend({}, prop), optall);
		        if (empty || dataPriv.get(this, "finish")) {
		          anim.stop(true);
		        }
		      };
		      doAnimation.finish = doAnimation;
		      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
		    },
		    stop: function(type, clearQueue, gotoEnd) {
		      var stopQueue = function(hooks) {
		        var stop = hooks.stop;
		        delete hooks.stop;
		        stop(gotoEnd);
		      };
		      if (typeof type !== "string") {
		        gotoEnd = clearQueue;
		        clearQueue = type;
		        type = undefined;
		      }
		      if (clearQueue) {
		        this.queue(type || "fx", []);
		      }
		      return this.each(function() {
		        var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
		        if (index) {
		          if (data[index] && data[index].stop) {
		            stopQueue(data[index]);
		          }
		        } else {
		          for (index in data) {
		            if (data[index] && data[index].stop && rrun.test(index)) {
		              stopQueue(data[index]);
		            }
		          }
		        }
		        for (index = timers.length; index--; ) {
		          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
		            timers[index].anim.stop(gotoEnd);
		            dequeue = false;
		            timers.splice(index, 1);
		          }
		        }
		        if (dequeue || !gotoEnd) {
		          jQuery.dequeue(this, type);
		        }
		      });
		    },
		    finish: function(type) {
		      if (type !== false) {
		        type = type || "fx";
		      }
		      return this.each(function() {
		        var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
		        data.finish = true;
		        jQuery.queue(this, type, []);
		        if (hooks && hooks.stop) {
		          hooks.stop.call(this, true);
		        }
		        for (index = timers.length; index--; ) {
		          if (timers[index].elem === this && timers[index].queue === type) {
		            timers[index].anim.stop(true);
		            timers.splice(index, 1);
		          }
		        }
		        for (index = 0; index < length; index++) {
		          if (queue[index] && queue[index].finish) {
		            queue[index].finish.call(this);
		          }
		        }
		        delete data.finish;
		      });
		    }
		  });
		  jQuery.each(["toggle", "show", "hide"], function(_i, name) {
		    var cssFn = jQuery.fn[name];
		    jQuery.fn[name] = function(speed, easing, callback) {
		      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
		    };
		  });
		  jQuery.each({
		    slideDown: genFx("show"),
		    slideUp: genFx("hide"),
		    slideToggle: genFx("toggle"),
		    fadeIn: { opacity: "show" },
		    fadeOut: { opacity: "hide" },
		    fadeToggle: { opacity: "toggle" }
		  }, function(name, props) {
		    jQuery.fn[name] = function(speed, easing, callback) {
		      return this.animate(props, speed, easing, callback);
		    };
		  });
		  jQuery.timers = [];
		  jQuery.fx.tick = function() {
		    var timer, i = 0, timers = jQuery.timers;
		    fxNow = Date.now();
		    for (; i < timers.length; i++) {
		      timer = timers[i];
		      if (!timer() && timers[i] === timer) {
		        timers.splice(i--, 1);
		      }
		    }
		    if (!timers.length) {
		      jQuery.fx.stop();
		    }
		    fxNow = undefined;
		  };
		  jQuery.fx.timer = function(timer) {
		    jQuery.timers.push(timer);
		    jQuery.fx.start();
		  };
		  jQuery.fx.interval = 13;
		  jQuery.fx.start = function() {
		    if (inProgress) {
		      return;
		    }
		    inProgress = true;
		    schedule();
		  };
		  jQuery.fx.stop = function() {
		    inProgress = null;
		  };
		  jQuery.fx.speeds = {
		    slow: 600,
		    fast: 200,
		    // Default speed
		    _default: 400
		  };
		  jQuery.fn.delay = function(time, type) {
		    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
		    type = type || "fx";
		    return this.queue(type, function(next, hooks) {
		      var timeout = window2.setTimeout(next, time);
		      hooks.stop = function() {
		        window2.clearTimeout(timeout);
		      };
		    });
		  };
		  (function() {
		    var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
		    input.type = "checkbox";
		    support.checkOn = input.value !== "";
		    support.optSelected = opt.selected;
		    input = document.createElement("input");
		    input.value = "t";
		    input.type = "radio";
		    support.radioValue = input.value === "t";
		  })();
		  var boolHook, attrHandle = jQuery.expr.attrHandle;
		  jQuery.fn.extend({
		    attr: function(name, value) {
		      return access(this, jQuery.attr, name, value, arguments.length > 1);
		    },
		    removeAttr: function(name) {
		      return this.each(function() {
		        jQuery.removeAttr(this, name);
		      });
		    }
		  });
		  jQuery.extend({
		    attr: function(elem, name, value) {
		      var ret, hooks, nType = elem.nodeType;
		      if (nType === 3 || nType === 8 || nType === 2) {
		        return;
		      }
		      if (typeof elem.getAttribute === "undefined") {
		        return jQuery.prop(elem, name, value);
		      }
		      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
		        hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
		      }
		      if (value !== undefined) {
		        if (value === null) {
		          jQuery.removeAttr(elem, name);
		          return;
		        }
		        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
		          return ret;
		        }
		        elem.setAttribute(name, value + "");
		        return value;
		      }
		      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
		        return ret;
		      }
		      ret = jQuery.find.attr(elem, name);
		      return ret == null ? undefined : ret;
		    },
		    attrHooks: {
		      type: {
		        set: function(elem, value) {
		          if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
		            var val = elem.value;
		            elem.setAttribute("type", value);
		            if (val) {
		              elem.value = val;
		            }
		            return value;
		          }
		        }
		      }
		    },
		    removeAttr: function(elem, value) {
		      var name, i = 0, attrNames = value && value.match(rnothtmlwhite);
		      if (attrNames && elem.nodeType === 1) {
		        while (name = attrNames[i++]) {
		          elem.removeAttribute(name);
		        }
		      }
		    }
		  });
		  boolHook = {
		    set: function(elem, value, name) {
		      if (value === false) {
		        jQuery.removeAttr(elem, name);
		      } else {
		        elem.setAttribute(name, name);
		      }
		      return name;
		    }
		  };
		  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
		    var getter = attrHandle[name] || jQuery.find.attr;
		    attrHandle[name] = function(elem, name2, isXML) {
		      var ret, handle, lowercaseName = name2.toLowerCase();
		      if (!isXML) {
		        handle = attrHandle[lowercaseName];
		        attrHandle[lowercaseName] = ret;
		        ret = getter(elem, name2, isXML) != null ? lowercaseName : null;
		        attrHandle[lowercaseName] = handle;
		      }
		      return ret;
		    };
		  });
		  var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
		  jQuery.fn.extend({
		    prop: function(name, value) {
		      return access(this, jQuery.prop, name, value, arguments.length > 1);
		    },
		    removeProp: function(name) {
		      return this.each(function() {
		        delete this[jQuery.propFix[name] || name];
		      });
		    }
		  });
		  jQuery.extend({
		    prop: function(elem, name, value) {
		      var ret, hooks, nType = elem.nodeType;
		      if (nType === 3 || nType === 8 || nType === 2) {
		        return;
		      }
		      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
		        name = jQuery.propFix[name] || name;
		        hooks = jQuery.propHooks[name];
		      }
		      if (value !== undefined) {
		        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
		          return ret;
		        }
		        return elem[name] = value;
		      }
		      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
		        return ret;
		      }
		      return elem[name];
		    },
		    propHooks: {
		      tabIndex: {
		        get: function(elem) {
		          var tabindex = jQuery.find.attr(elem, "tabindex");
		          if (tabindex) {
		            return parseInt(tabindex, 10);
		          }
		          if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
		            return 0;
		          }
		          return -1;
		        }
		      }
		    },
		    propFix: {
		      "for": "htmlFor",
		      "class": "className"
		    }
		  });
		  if (!support.optSelected) {
		    jQuery.propHooks.selected = {
		      get: function(elem) {
		        var parent = elem.parentNode;
		        if (parent && parent.parentNode) {
		          parent.parentNode.selectedIndex;
		        }
		        return null;
		      },
		      set: function(elem) {
		        var parent = elem.parentNode;
		        if (parent) {
		          parent.selectedIndex;
		          if (parent.parentNode) {
		            parent.parentNode.selectedIndex;
		          }
		        }
		      }
		    };
		  }
		  jQuery.each([
		    "tabIndex",
		    "readOnly",
		    "maxLength",
		    "cellSpacing",
		    "cellPadding",
		    "rowSpan",
		    "colSpan",
		    "useMap",
		    "frameBorder",
		    "contentEditable"
		  ], function() {
		    jQuery.propFix[this.toLowerCase()] = this;
		  });
		  function stripAndCollapse(value) {
		    var tokens = value.match(rnothtmlwhite) || [];
		    return tokens.join(" ");
		  }
		  function getClass(elem) {
		    return elem.getAttribute && elem.getAttribute("class") || "";
		  }
		  function classesToArray(value) {
		    if (Array.isArray(value)) {
		      return value;
		    }
		    if (typeof value === "string") {
		      return value.match(rnothtmlwhite) || [];
		    }
		    return [];
		  }
		  jQuery.fn.extend({
		    addClass: function(value) {
		      var classNames, cur, curValue, className, i, finalValue;
		      if (isFunction(value)) {
		        return this.each(function(j) {
		          jQuery(this).addClass(value.call(this, j, getClass(this)));
		        });
		      }
		      classNames = classesToArray(value);
		      if (classNames.length) {
		        return this.each(function() {
		          curValue = getClass(this);
		          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
		          if (cur) {
		            for (i = 0; i < classNames.length; i++) {
		              className = classNames[i];
		              if (cur.indexOf(" " + className + " ") < 0) {
		                cur += className + " ";
		              }
		            }
		            finalValue = stripAndCollapse(cur);
		            if (curValue !== finalValue) {
		              this.setAttribute("class", finalValue);
		            }
		          }
		        });
		      }
		      return this;
		    },
		    removeClass: function(value) {
		      var classNames, cur, curValue, className, i, finalValue;
		      if (isFunction(value)) {
		        return this.each(function(j) {
		          jQuery(this).removeClass(value.call(this, j, getClass(this)));
		        });
		      }
		      if (!arguments.length) {
		        return this.attr("class", "");
		      }
		      classNames = classesToArray(value);
		      if (classNames.length) {
		        return this.each(function() {
		          curValue = getClass(this);
		          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
		          if (cur) {
		            for (i = 0; i < classNames.length; i++) {
		              className = classNames[i];
		              while (cur.indexOf(" " + className + " ") > -1) {
		                cur = cur.replace(" " + className + " ", " ");
		              }
		            }
		            finalValue = stripAndCollapse(cur);
		            if (curValue !== finalValue) {
		              this.setAttribute("class", finalValue);
		            }
		          }
		        });
		      }
		      return this;
		    },
		    toggleClass: function(value, stateVal) {
		      var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
		      if (isFunction(value)) {
		        return this.each(function(i2) {
		          jQuery(this).toggleClass(
		            value.call(this, i2, getClass(this), stateVal),
		            stateVal
		          );
		        });
		      }
		      if (typeof stateVal === "boolean" && isValidValue) {
		        return stateVal ? this.addClass(value) : this.removeClass(value);
		      }
		      classNames = classesToArray(value);
		      return this.each(function() {
		        if (isValidValue) {
		          self = jQuery(this);
		          for (i = 0; i < classNames.length; i++) {
		            className = classNames[i];
		            if (self.hasClass(className)) {
		              self.removeClass(className);
		            } else {
		              self.addClass(className);
		            }
		          }
		        } else if (value === undefined || type === "boolean") {
		          className = getClass(this);
		          if (className) {
		            dataPriv.set(this, "__className__", className);
		          }
		          if (this.setAttribute) {
		            this.setAttribute(
		              "class",
		              className || value === false ? "" : dataPriv.get(this, "__className__") || ""
		            );
		          }
		        }
		      });
		    },
		    hasClass: function(selector) {
		      var className, elem, i = 0;
		      className = " " + selector + " ";
		      while (elem = this[i++]) {
		        if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
		          return true;
		        }
		      }
		      return false;
		    }
		  });
		  var rreturn = /\r/g;
		  jQuery.fn.extend({
		    val: function(value) {
		      var hooks, ret, valueIsFunction, elem = this[0];
		      if (!arguments.length) {
		        if (elem) {
		          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
		          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
		            return ret;
		          }
		          ret = elem.value;
		          if (typeof ret === "string") {
		            return ret.replace(rreturn, "");
		          }
		          return ret == null ? "" : ret;
		        }
		        return;
		      }
		      valueIsFunction = isFunction(value);
		      return this.each(function(i) {
		        var val;
		        if (this.nodeType !== 1) {
		          return;
		        }
		        if (valueIsFunction) {
		          val = value.call(this, i, jQuery(this).val());
		        } else {
		          val = value;
		        }
		        if (val == null) {
		          val = "";
		        } else if (typeof val === "number") {
		          val += "";
		        } else if (Array.isArray(val)) {
		          val = jQuery.map(val, function(value2) {
		            return value2 == null ? "" : value2 + "";
		          });
		        }
		        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
		        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
		          this.value = val;
		        }
		      });
		    }
		  });
		  jQuery.extend({
		    valHooks: {
		      option: {
		        get: function(elem) {
		          var val = jQuery.find.attr(elem, "value");
		          return val != null ? val : (
		            // Support: IE <=10 - 11 only
		            // option.text throws exceptions (trac-14686, trac-14858)
		            // Strip and collapse whitespace
		            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
		            stripAndCollapse(jQuery.text(elem))
		          );
		        }
		      },
		      select: {
		        get: function(elem) {
		          var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
		          if (index < 0) {
		            i = max;
		          } else {
		            i = one ? index : 0;
		          }
		          for (; i < max; i++) {
		            option = options[i];
		            if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
		            !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
		              value = jQuery(option).val();
		              if (one) {
		                return value;
		              }
		              values.push(value);
		            }
		          }
		          return values;
		        },
		        set: function(elem, value) {
		          var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
		          while (i--) {
		            option = options[i];
		            if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
		              optionSet = true;
		            }
		          }
		          if (!optionSet) {
		            elem.selectedIndex = -1;
		          }
		          return values;
		        }
		      }
		    }
		  });
		  jQuery.each(["radio", "checkbox"], function() {
		    jQuery.valHooks[this] = {
		      set: function(elem, value) {
		        if (Array.isArray(value)) {
		          return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
		        }
		      }
		    };
		    if (!support.checkOn) {
		      jQuery.valHooks[this].get = function(elem) {
		        return elem.getAttribute("value") === null ? "on" : elem.value;
		      };
		    }
		  });
		  var location = window2.location;
		  var nonce = { guid: Date.now() };
		  var rquery = /\?/;
		  jQuery.parseXML = function(data) {
		    var xml, parserErrorElem;
		    if (!data || typeof data !== "string") {
		      return null;
		    }
		    try {
		      xml = new window2.DOMParser().parseFromString(data, "text/xml");
		    } catch (e) {
		    }
		    parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
		    if (!xml || parserErrorElem) {
		      jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
		        return el.textContent;
		      }).join("\n") : data));
		    }
		    return xml;
		  };
		  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
		    e.stopPropagation();
		  };
		  jQuery.extend(jQuery.event, {
		    trigger: function(event, data, elem, onlyHandlers) {
		      var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
		      cur = lastElement = tmp = elem = elem || document;
		      if (elem.nodeType === 3 || elem.nodeType === 8) {
		        return;
		      }
		      if (rfocusMorph.test(type + jQuery.event.triggered)) {
		        return;
		      }
		      if (type.indexOf(".") > -1) {
		        namespaces = type.split(".");
		        type = namespaces.shift();
		        namespaces.sort();
		      }
		      ontype = type.indexOf(":") < 0 && "on" + type;
		      event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
		      event.isTrigger = onlyHandlers ? 2 : 3;
		      event.namespace = namespaces.join(".");
		      event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
		      event.result = undefined;
		      if (!event.target) {
		        event.target = elem;
		      }
		      data = data == null ? [event] : jQuery.makeArray(data, [event]);
		      special = jQuery.event.special[type] || {};
		      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
		        return;
		      }
		      if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
		        bubbleType = special.delegateType || type;
		        if (!rfocusMorph.test(bubbleType + type)) {
		          cur = cur.parentNode;
		        }
		        for (; cur; cur = cur.parentNode) {
		          eventPath.push(cur);
		          tmp = cur;
		        }
		        if (tmp === (elem.ownerDocument || document)) {
		          eventPath.push(tmp.defaultView || tmp.parentWindow || window2);
		        }
		      }
		      i = 0;
		      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
		        lastElement = cur;
		        event.type = i > 1 ? bubbleType : special.bindType || type;
		        handle = (dataPriv.get(cur, "events") || /* @__PURE__ */ Object.create(null))[event.type] && dataPriv.get(cur, "handle");
		        if (handle) {
		          handle.apply(cur, data);
		        }
		        handle = ontype && cur[ontype];
		        if (handle && handle.apply && acceptData(cur)) {
		          event.result = handle.apply(cur, data);
		          if (event.result === false) {
		            event.preventDefault();
		          }
		        }
		      }
		      event.type = type;
		      if (!onlyHandlers && !event.isDefaultPrevented()) {
		        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
		          if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
		            tmp = elem[ontype];
		            if (tmp) {
		              elem[ontype] = null;
		            }
		            jQuery.event.triggered = type;
		            if (event.isPropagationStopped()) {
		              lastElement.addEventListener(type, stopPropagationCallback);
		            }
		            elem[type]();
		            if (event.isPropagationStopped()) {
		              lastElement.removeEventListener(type, stopPropagationCallback);
		            }
		            jQuery.event.triggered = undefined;
		            if (tmp) {
		              elem[ontype] = tmp;
		            }
		          }
		        }
		      }
		      return event.result;
		    },
		    // Piggyback on a donor event to simulate a different one
		    // Used only for `focus(in | out)` events
		    simulate: function(type, elem, event) {
		      var e = jQuery.extend(
		        new jQuery.Event(),
		        event,
		        {
		          type,
		          isSimulated: true
		        }
		      );
		      jQuery.event.trigger(e, null, elem);
		    }
		  });
		  jQuery.fn.extend({
		    trigger: function(type, data) {
		      return this.each(function() {
		        jQuery.event.trigger(type, data, this);
		      });
		    },
		    triggerHandler: function(type, data) {
		      var elem = this[0];
		      if (elem) {
		        return jQuery.event.trigger(type, data, elem, true);
		      }
		    }
		  });
		  var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
		  function buildParams(prefix, obj, traditional, add) {
		    var name;
		    if (Array.isArray(obj)) {
		      jQuery.each(obj, function(i, v) {
		        if (traditional || rbracket.test(prefix)) {
		          add(prefix, v);
		        } else {
		          buildParams(
		            prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
		            v,
		            traditional,
		            add
		          );
		        }
		      });
		    } else if (!traditional && toType(obj) === "object") {
		      for (name in obj) {
		        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
		      }
		    } else {
		      add(prefix, obj);
		    }
		  }
		  jQuery.param = function(a, traditional) {
		    var prefix, s = [], add = function(key, valueOrFunction) {
		      var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
		      s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
		    };
		    if (a == null) {
		      return "";
		    }
		    if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
		      jQuery.each(a, function() {
		        add(this.name, this.value);
		      });
		    } else {
		      for (prefix in a) {
		        buildParams(prefix, a[prefix], traditional, add);
		      }
		    }
		    return s.join("&");
		  };
		  jQuery.fn.extend({
		    serialize: function() {
		      return jQuery.param(this.serializeArray());
		    },
		    serializeArray: function() {
		      return this.map(function() {
		        var elements = jQuery.prop(this, "elements");
		        return elements ? jQuery.makeArray(elements) : this;
		      }).filter(function() {
		        var type = this.type;
		        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
		      }).map(function(_i, elem) {
		        var val = jQuery(this).val();
		        if (val == null) {
		          return null;
		        }
		        if (Array.isArray(val)) {
		          return jQuery.map(val, function(val2) {
		            return { name: elem.name, value: val2.replace(rCRLF, "\r\n") };
		          });
		        }
		        return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
		      }).get();
		    }
		  });
		  var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, prefilters = {}, transports = {}, allTypes = "*/".concat("*"), originAnchor = document.createElement("a");
		  originAnchor.href = location.href;
		  function addToPrefiltersOrTransports(structure) {
		    return function(dataTypeExpression, func) {
		      if (typeof dataTypeExpression !== "string") {
		        func = dataTypeExpression;
		        dataTypeExpression = "*";
		      }
		      var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
		      if (isFunction(func)) {
		        while (dataType = dataTypes[i++]) {
		          if (dataType[0] === "+") {
		            dataType = dataType.slice(1) || "*";
		            (structure[dataType] = structure[dataType] || []).unshift(func);
		          } else {
		            (structure[dataType] = structure[dataType] || []).push(func);
		          }
		        }
		      }
		    };
		  }
		  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
		    var inspected = {}, seekingTransport = structure === transports;
		    function inspect(dataType) {
		      var selected;
		      inspected[dataType] = true;
		      jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
		        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
		        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
		          options.dataTypes.unshift(dataTypeOrTransport);
		          inspect(dataTypeOrTransport);
		          return false;
		        } else if (seekingTransport) {
		          return !(selected = dataTypeOrTransport);
		        }
		      });
		      return selected;
		    }
		    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
		  }
		  function ajaxExtend(target, src) {
		    var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
		    for (key in src) {
		      if (src[key] !== undefined) {
		        (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
		      }
		    }
		    if (deep) {
		      jQuery.extend(true, target, deep);
		    }
		    return target;
		  }
		  function ajaxHandleResponses(s, jqXHR, responses) {
		    var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
		    while (dataTypes[0] === "*") {
		      dataTypes.shift();
		      if (ct === undefined) {
		        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		      }
		    }
		    if (ct) {
		      for (type in contents) {
		        if (contents[type] && contents[type].test(ct)) {
		          dataTypes.unshift(type);
		          break;
		        }
		      }
		    }
		    if (dataTypes[0] in responses) {
		      finalDataType = dataTypes[0];
		    } else {
		      for (type in responses) {
		        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
		          finalDataType = type;
		          break;
		        }
		        if (!firstDataType) {
		          firstDataType = type;
		        }
		      }
		      finalDataType = finalDataType || firstDataType;
		    }
		    if (finalDataType) {
		      if (finalDataType !== dataTypes[0]) {
		        dataTypes.unshift(finalDataType);
		      }
		      return responses[finalDataType];
		    }
		  }
		  function ajaxConvert(s, response, jqXHR, isSuccess) {
		    var conv2, current, conv, tmp, prev, converters = {}, dataTypes = s.dataTypes.slice();
		    if (dataTypes[1]) {
		      for (conv in s.converters) {
		        converters[conv.toLowerCase()] = s.converters[conv];
		      }
		    }
		    current = dataTypes.shift();
		    while (current) {
		      if (s.responseFields[current]) {
		        jqXHR[s.responseFields[current]] = response;
		      }
		      if (!prev && isSuccess && s.dataFilter) {
		        response = s.dataFilter(response, s.dataType);
		      }
		      prev = current;
		      current = dataTypes.shift();
		      if (current) {
		        if (current === "*") {
		          current = prev;
		        } else if (prev !== "*" && prev !== current) {
		          conv = converters[prev + " " + current] || converters["* " + current];
		          if (!conv) {
		            for (conv2 in converters) {
		              tmp = conv2.split(" ");
		              if (tmp[1] === current) {
		                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
		                if (conv) {
		                  if (conv === true) {
		                    conv = converters[conv2];
		                  } else if (converters[conv2] !== true) {
		                    current = tmp[0];
		                    dataTypes.unshift(tmp[1]);
		                  }
		                  break;
		                }
		              }
		            }
		          }
		          if (conv !== true) {
		            if (conv && s.throws) {
		              response = conv(response);
		            } else {
		              try {
		                response = conv(response);
		              } catch (e) {
		                return {
		                  state: "parsererror",
		                  error: conv ? e : "No conversion from " + prev + " to " + current
		                };
		              }
		            }
		          }
		        }
		      }
		    }
		    return { state: "success", data: response };
		  }
		  jQuery.extend({
		    // Counter for holding the number of active queries
		    active: 0,
		    // Last-Modified header cache for next request
		    lastModified: {},
		    etag: {},
		    ajaxSettings: {
		      url: location.href,
		      type: "GET",
		      isLocal: rlocalProtocol.test(location.protocol),
		      global: true,
		      processData: true,
		      async: true,
		      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		      /*
		      timeout: 0,
		      data: null,
		      dataType: null,
		      username: null,
		      password: null,
		      cache: null,
		      throws: false,
		      traditional: false,
		      headers: {},
		      */
		      accepts: {
		        "*": allTypes,
		        text: "text/plain",
		        html: "text/html",
		        xml: "application/xml, text/xml",
		        json: "application/json, text/javascript"
		      },
		      contents: {
		        xml: /\bxml\b/,
		        html: /\bhtml/,
		        json: /\bjson\b/
		      },
		      responseFields: {
		        xml: "responseXML",
		        text: "responseText",
		        json: "responseJSON"
		      },
		      // Data converters
		      // Keys separate source (or catchall "*") and destination types with a single space
		      converters: {
		        // Convert anything to text
		        "* text": String,
		        // Text to html (true = no transformation)
		        "text html": true,
		        // Evaluate text as a json expression
		        "text json": JSON.parse,
		        // Parse text as xml
		        "text xml": jQuery.parseXML
		      },
		      // For options that shouldn't be deep extended:
		      // you can add your own custom options here if
		      // and when you create one that shouldn't be
		      // deep extended (see ajaxExtend)
		      flatOptions: {
		        url: true,
		        context: true
		      }
		    },
		    // Creates a full fledged settings object into target
		    // with both ajaxSettings and settings fields.
		    // If target is omitted, writes into ajaxSettings.
		    ajaxSetup: function(target, settings) {
		      return settings ? (
		        // Building a settings object
		        ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
		      ) : (
		        // Extending ajaxSettings
		        ajaxExtend(jQuery.ajaxSettings, target)
		      );
		    },
		    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
		    ajaxTransport: addToPrefiltersOrTransports(transports),
		    // Main method
		    ajax: function(url, options) {
		      if (typeof url === "object") {
		        options = url;
		        url = undefined;
		      }
		      options = options || {};
		      var transport, cacheURL, responseHeadersString, responseHeaders, timeoutTimer, urlAnchor, completed2, fireGlobals, i, uncached, s = jQuery.ajaxSetup({}, options), callbackContext = s.context || s, globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), statusCode = s.statusCode || {}, requestHeaders = {}, requestHeadersNames = {}, strAbort = "canceled", jqXHR = {
		        readyState: 0,
		        // Builds headers hashtable if needed
		        getResponseHeader: function(key) {
		          var match;
		          if (completed2) {
		            if (!responseHeaders) {
		              responseHeaders = {};
		              while (match = rheaders.exec(responseHeadersString)) {
		                responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
		              }
		            }
		            match = responseHeaders[key.toLowerCase() + " "];
		          }
		          return match == null ? null : match.join(", ");
		        },
		        // Raw string
		        getAllResponseHeaders: function() {
		          return completed2 ? responseHeadersString : null;
		        },
		        // Caches the header
		        setRequestHeader: function(name, value) {
		          if (completed2 == null) {
		            name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
		            requestHeaders[name] = value;
		          }
		          return this;
		        },
		        // Overrides response content-type header
		        overrideMimeType: function(type) {
		          if (completed2 == null) {
		            s.mimeType = type;
		          }
		          return this;
		        },
		        // Status-dependent callbacks
		        statusCode: function(map) {
		          var code;
		          if (map) {
		            if (completed2) {
		              jqXHR.always(map[jqXHR.status]);
		            } else {
		              for (code in map) {
		                statusCode[code] = [statusCode[code], map[code]];
		              }
		            }
		          }
		          return this;
		        },
		        // Cancel the request
		        abort: function(statusText) {
		          var finalText = statusText || strAbort;
		          if (transport) {
		            transport.abort(finalText);
		          }
		          done(0, finalText);
		          return this;
		        }
		      };
		      deferred.promise(jqXHR);
		      s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
		      s.type = options.method || options.type || s.method || s.type;
		      s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
		      if (s.crossDomain == null) {
		        urlAnchor = document.createElement("a");
		        try {
		          urlAnchor.href = s.url;
		          urlAnchor.href = urlAnchor.href;
		          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
		        } catch (e) {
		          s.crossDomain = true;
		        }
		      }
		      if (s.data && s.processData && typeof s.data !== "string") {
		        s.data = jQuery.param(s.data, s.traditional);
		      }
		      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
		      if (completed2) {
		        return jqXHR;
		      }
		      fireGlobals = jQuery.event && s.global;
		      if (fireGlobals && jQuery.active++ === 0) {
		        jQuery.event.trigger("ajaxStart");
		      }
		      s.type = s.type.toUpperCase();
		      s.hasContent = !rnoContent.test(s.type);
		      cacheURL = s.url.replace(rhash, "");
		      if (!s.hasContent) {
		        uncached = s.url.slice(cacheURL.length);
		        if (s.data && (s.processData || typeof s.data === "string")) {
		          cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
		          delete s.data;
		        }
		        if (s.cache === false) {
		          cacheURL = cacheURL.replace(rantiCache, "$1");
		          uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
		        }
		        s.url = cacheURL + uncached;
		      } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
		        s.data = s.data.replace(r20, "+");
		      }
		      if (s.ifModified) {
		        if (jQuery.lastModified[cacheURL]) {
		          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
		        }
		        if (jQuery.etag[cacheURL]) {
		          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
		        }
		      }
		      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
		        jqXHR.setRequestHeader("Content-Type", s.contentType);
		      }
		      jqXHR.setRequestHeader(
		        "Accept",
		        s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]
		      );
		      for (i in s.headers) {
		        jqXHR.setRequestHeader(i, s.headers[i]);
		      }
		      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed2)) {
		        return jqXHR.abort();
		      }
		      strAbort = "abort";
		      completeDeferred.add(s.complete);
		      jqXHR.done(s.success);
		      jqXHR.fail(s.error);
		      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
		      if (!transport) {
		        done(-1, "No Transport");
		      } else {
		        jqXHR.readyState = 1;
		        if (fireGlobals) {
		          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
		        }
		        if (completed2) {
		          return jqXHR;
		        }
		        if (s.async && s.timeout > 0) {
		          timeoutTimer = window2.setTimeout(function() {
		            jqXHR.abort("timeout");
		          }, s.timeout);
		        }
		        try {
		          completed2 = false;
		          transport.send(requestHeaders, done);
		        } catch (e) {
		          if (completed2) {
		            throw e;
		          }
		          done(-1, e);
		        }
		      }
		      function done(status, nativeStatusText, responses, headers) {
		        var isSuccess, success, error, response, modified, statusText = nativeStatusText;
		        if (completed2) {
		          return;
		        }
		        completed2 = true;
		        if (timeoutTimer) {
		          window2.clearTimeout(timeoutTimer);
		        }
		        transport = undefined;
		        responseHeadersString = headers || "";
		        jqXHR.readyState = status > 0 ? 4 : 0;
		        isSuccess = status >= 200 && status < 300 || status === 304;
		        if (responses) {
		          response = ajaxHandleResponses(s, jqXHR, responses);
		        }
		        if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
		          s.converters["text script"] = function() {
		          };
		        }
		        response = ajaxConvert(s, response, jqXHR, isSuccess);
		        if (isSuccess) {
		          if (s.ifModified) {
		            modified = jqXHR.getResponseHeader("Last-Modified");
		            if (modified) {
		              jQuery.lastModified[cacheURL] = modified;
		            }
		            modified = jqXHR.getResponseHeader("etag");
		            if (modified) {
		              jQuery.etag[cacheURL] = modified;
		            }
		          }
		          if (status === 204 || s.type === "HEAD") {
		            statusText = "nocontent";
		          } else if (status === 304) {
		            statusText = "notmodified";
		          } else {
		            statusText = response.state;
		            success = response.data;
		            error = response.error;
		            isSuccess = !error;
		          }
		        } else {
		          error = statusText;
		          if (status || !statusText) {
		            statusText = "error";
		            if (status < 0) {
		              status = 0;
		            }
		          }
		        }
		        jqXHR.status = status;
		        jqXHR.statusText = (nativeStatusText || statusText) + "";
		        if (isSuccess) {
		          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
		        } else {
		          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
		        }
		        jqXHR.statusCode(statusCode);
		        statusCode = undefined;
		        if (fireGlobals) {
		          globalEventContext.trigger(
		            isSuccess ? "ajaxSuccess" : "ajaxError",
		            [jqXHR, s, isSuccess ? success : error]
		          );
		        }
		        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
		        if (fireGlobals) {
		          globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
		          if (!--jQuery.active) {
		            jQuery.event.trigger("ajaxStop");
		          }
		        }
		      }
		      return jqXHR;
		    },
		    getJSON: function(url, data, callback) {
		      return jQuery.get(url, data, callback, "json");
		    },
		    getScript: function(url, callback) {
		      return jQuery.get(url, undefined, callback, "script");
		    }
		  });
		  jQuery.each(["get", "post"], function(_i, method) {
		    jQuery[method] = function(url, data, callback, type) {
		      if (isFunction(data)) {
		        type = type || callback;
		        callback = data;
		        data = undefined;
		      }
		      return jQuery.ajax(jQuery.extend({
		        url,
		        type: method,
		        dataType: type,
		        data,
		        success: callback
		      }, jQuery.isPlainObject(url) && url));
		    };
		  });
		  jQuery.ajaxPrefilter(function(s) {
		    var i;
		    for (i in s.headers) {
		      if (i.toLowerCase() === "content-type") {
		        s.contentType = s.headers[i] || "";
		      }
		    }
		  });
		  jQuery._evalUrl = function(url, options, doc) {
		    return jQuery.ajax({
		      url,
		      // Make this explicit, since user can override this through ajaxSetup (trac-11264)
		      type: "GET",
		      dataType: "script",
		      cache: true,
		      async: false,
		      global: false,
		      // Only evaluate the response if it is successful (gh-4126)
		      // dataFilter is not invoked for failure responses, so using it instead
		      // of the default converter is kludgy but it works.
		      converters: {
		        "text script": function() {
		        }
		      },
		      dataFilter: function(response) {
		        jQuery.globalEval(response, options, doc);
		      }
		    });
		  };
		  jQuery.fn.extend({
		    wrapAll: function(html) {
		      var wrap;
		      if (this[0]) {
		        if (isFunction(html)) {
		          html = html.call(this[0]);
		        }
		        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
		        if (this[0].parentNode) {
		          wrap.insertBefore(this[0]);
		        }
		        wrap.map(function() {
		          var elem = this;
		          while (elem.firstElementChild) {
		            elem = elem.firstElementChild;
		          }
		          return elem;
		        }).append(this);
		      }
		      return this;
		    },
		    wrapInner: function(html) {
		      if (isFunction(html)) {
		        return this.each(function(i) {
		          jQuery(this).wrapInner(html.call(this, i));
		        });
		      }
		      return this.each(function() {
		        var self = jQuery(this), contents = self.contents();
		        if (contents.length) {
		          contents.wrapAll(html);
		        } else {
		          self.append(html);
		        }
		      });
		    },
		    wrap: function(html) {
		      var htmlIsFunction = isFunction(html);
		      return this.each(function(i) {
		        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
		      });
		    },
		    unwrap: function(selector) {
		      this.parent(selector).not("body").each(function() {
		        jQuery(this).replaceWith(this.childNodes);
		      });
		      return this;
		    }
		  });
		  jQuery.expr.pseudos.hidden = function(elem) {
		    return !jQuery.expr.pseudos.visible(elem);
		  };
		  jQuery.expr.pseudos.visible = function(elem) {
		    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
		  };
		  jQuery.ajaxSettings.xhr = function() {
		    try {
		      return new window2.XMLHttpRequest();
		    } catch (e) {
		    }
		  };
		  var xhrSuccessStatus = {
		    // File protocol always yields status code 0, assume 200
		    0: 200,
		    // Support: IE <=9 only
		    // trac-1450: sometimes IE returns 1223 when it should be 204
		    1223: 204
		  }, xhrSupported = jQuery.ajaxSettings.xhr();
		  support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
		  support.ajax = xhrSupported = !!xhrSupported;
		  jQuery.ajaxTransport(function(options) {
		    var callback, errorCallback;
		    if (support.cors || xhrSupported && !options.crossDomain) {
		      return {
		        send: function(headers, complete) {
		          var i, xhr = options.xhr();
		          xhr.open(
		            options.type,
		            options.url,
		            options.async,
		            options.username,
		            options.password
		          );
		          if (options.xhrFields) {
		            for (i in options.xhrFields) {
		              xhr[i] = options.xhrFields[i];
		            }
		          }
		          if (options.mimeType && xhr.overrideMimeType) {
		            xhr.overrideMimeType(options.mimeType);
		          }
		          if (!options.crossDomain && !headers["X-Requested-With"]) {
		            headers["X-Requested-With"] = "XMLHttpRequest";
		          }
		          for (i in headers) {
		            xhr.setRequestHeader(i, headers[i]);
		          }
		          callback = function(type) {
		            return function() {
		              if (callback) {
		                callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
		                if (type === "abort") {
		                  xhr.abort();
		                } else if (type === "error") {
		                  if (typeof xhr.status !== "number") {
		                    complete(0, "error");
		                  } else {
		                    complete(
		                      // File: protocol always yields status 0; see trac-8605, trac-14207
		                      xhr.status,
		                      xhr.statusText
		                    );
		                  }
		                } else {
		                  complete(
		                    xhrSuccessStatus[xhr.status] || xhr.status,
		                    xhr.statusText,
		                    // Support: IE <=9 only
		                    // IE9 has no XHR2 but throws on binary (trac-11426)
		                    // For XHR2 non-text, let the caller handle it (gh-2498)
		                    (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText },
		                    xhr.getAllResponseHeaders()
		                  );
		                }
		              }
		            };
		          };
		          xhr.onload = callback();
		          errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
		          if (xhr.onabort !== undefined) {
		            xhr.onabort = errorCallback;
		          } else {
		            xhr.onreadystatechange = function() {
		              if (xhr.readyState === 4) {
		                window2.setTimeout(function() {
		                  if (callback) {
		                    errorCallback();
		                  }
		                });
		              }
		            };
		          }
		          callback = callback("abort");
		          try {
		            xhr.send(options.hasContent && options.data || null);
		          } catch (e) {
		            if (callback) {
		              throw e;
		            }
		          }
		        },
		        abort: function() {
		          if (callback) {
		            callback();
		          }
		        }
		      };
		    }
		  });
		  jQuery.ajaxPrefilter(function(s) {
		    if (s.crossDomain) {
		      s.contents.script = false;
		    }
		  });
		  jQuery.ajaxSetup({
		    accepts: {
		      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		    },
		    contents: {
		      script: /\b(?:java|ecma)script\b/
		    },
		    converters: {
		      "text script": function(text) {
		        jQuery.globalEval(text);
		        return text;
		      }
		    }
		  });
		  jQuery.ajaxPrefilter("script", function(s) {
		    if (s.cache === undefined) {
		      s.cache = false;
		    }
		    if (s.crossDomain) {
		      s.type = "GET";
		    }
		  });
		  jQuery.ajaxTransport("script", function(s) {
		    if (s.crossDomain || s.scriptAttrs) {
		      var script, callback;
		      return {
		        send: function(_, complete) {
		          script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", callback = function(evt) {
		            script.remove();
		            callback = null;
		            if (evt) {
		              complete(evt.type === "error" ? 404 : 200, evt.type);
		            }
		          });
		          document.head.appendChild(script[0]);
		        },
		        abort: function() {
		          if (callback) {
		            callback();
		          }
		        }
		      };
		    }
		  });
		  var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
		  jQuery.ajaxSetup({
		    jsonp: "callback",
		    jsonpCallback: function() {
		      var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
		      this[callback] = true;
		      return callback;
		    }
		  });
		  jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
		    var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
		    if (jsonProp || s.dataTypes[0] === "jsonp") {
		      callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
		      if (jsonProp) {
		        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
		      } else if (s.jsonp !== false) {
		        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
		      }
		      s.converters["script json"] = function() {
		        if (!responseContainer) {
		          jQuery.error(callbackName + " was not called");
		        }
		        return responseContainer[0];
		      };
		      s.dataTypes[0] = "json";
		      overwritten = window2[callbackName];
		      window2[callbackName] = function() {
		        responseContainer = arguments;
		      };
		      jqXHR.always(function() {
		        if (overwritten === undefined) {
		          jQuery(window2).removeProp(callbackName);
		        } else {
		          window2[callbackName] = overwritten;
		        }
		        if (s[callbackName]) {
		          s.jsonpCallback = originalSettings.jsonpCallback;
		          oldCallbacks.push(callbackName);
		        }
		        if (responseContainer && isFunction(overwritten)) {
		          overwritten(responseContainer[0]);
		        }
		        responseContainer = overwritten = undefined;
		      });
		      return "script";
		    }
		  });
		  support.createHTMLDocument = function() {
		    var body = document.implementation.createHTMLDocument("").body;
		    body.innerHTML = "<form></form><form></form>";
		    return body.childNodes.length === 2;
		  }();
		  jQuery.parseHTML = function(data, context, keepScripts) {
		    if (typeof data !== "string") {
		      return [];
		    }
		    if (typeof context === "boolean") {
		      keepScripts = context;
		      context = false;
		    }
		    var base, parsed, scripts;
		    if (!context) {
		      if (support.createHTMLDocument) {
		        context = document.implementation.createHTMLDocument("");
		        base = context.createElement("base");
		        base.href = document.location.href;
		        context.head.appendChild(base);
		      } else {
		        context = document;
		      }
		    }
		    parsed = rsingleTag.exec(data);
		    scripts = !keepScripts && [];
		    if (parsed) {
		      return [context.createElement(parsed[1])];
		    }
		    parsed = buildFragment([data], context, scripts);
		    if (scripts && scripts.length) {
		      jQuery(scripts).remove();
		    }
		    return jQuery.merge([], parsed.childNodes);
		  };
		  jQuery.fn.load = function(url, params, callback) {
		    var selector, type, response, self = this, off = url.indexOf(" ");
		    if (off > -1) {
		      selector = stripAndCollapse(url.slice(off));
		      url = url.slice(0, off);
		    }
		    if (isFunction(params)) {
		      callback = params;
		      params = undefined;
		    } else if (params && typeof params === "object") {
		      type = "POST";
		    }
		    if (self.length > 0) {
		      jQuery.ajax({
		        url,
		        // If "type" variable is undefined, then "GET" method will be used.
		        // Make value of this field explicit since
		        // user can override it through ajaxSetup method
		        type: type || "GET",
		        dataType: "html",
		        data: params
		      }).done(function(responseText) {
		        response = arguments;
		        self.html(selector ? (
		          // If a selector was specified, locate the right elements in a dummy div
		          // Exclude scripts to avoid IE 'Permission Denied' errors
		          jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector)
		        ) : (
		          // Otherwise use the full result
		          responseText
		        ));
		      }).always(callback && function(jqXHR, status) {
		        self.each(function() {
		          callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
		        });
		      });
		    }
		    return this;
		  };
		  jQuery.expr.pseudos.animated = function(elem) {
		    return jQuery.grep(jQuery.timers, function(fn) {
		      return elem === fn.elem;
		    }).length;
		  };
		  jQuery.offset = {
		    setOffset: function(elem, options, i) {
		      var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
		      if (position === "static") {
		        elem.style.position = "relative";
		      }
		      curOffset = curElem.offset();
		      curCSSTop = jQuery.css(elem, "top");
		      curCSSLeft = jQuery.css(elem, "left");
		      calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
		      if (calculatePosition) {
		        curPosition = curElem.position();
		        curTop = curPosition.top;
		        curLeft = curPosition.left;
		      } else {
		        curTop = parseFloat(curCSSTop) || 0;
		        curLeft = parseFloat(curCSSLeft) || 0;
		      }
		      if (isFunction(options)) {
		        options = options.call(elem, i, jQuery.extend({}, curOffset));
		      }
		      if (options.top != null) {
		        props.top = options.top - curOffset.top + curTop;
		      }
		      if (options.left != null) {
		        props.left = options.left - curOffset.left + curLeft;
		      }
		      if ("using" in options) {
		        options.using.call(elem, props);
		      } else {
		        curElem.css(props);
		      }
		    }
		  };
		  jQuery.fn.extend({
		    // offset() relates an element's border box to the document origin
		    offset: function(options) {
		      if (arguments.length) {
		        return options === undefined ? this : this.each(function(i) {
		          jQuery.offset.setOffset(this, options, i);
		        });
		      }
		      var rect, win, elem = this[0];
		      if (!elem) {
		        return;
		      }
		      if (!elem.getClientRects().length) {
		        return { top: 0, left: 0 };
		      }
		      rect = elem.getBoundingClientRect();
		      win = elem.ownerDocument.defaultView;
		      return {
		        top: rect.top + win.pageYOffset,
		        left: rect.left + win.pageXOffset
		      };
		    },
		    // position() relates an element's margin box to its offset parent's padding box
		    // This corresponds to the behavior of CSS absolute positioning
		    position: function() {
		      if (!this[0]) {
		        return;
		      }
		      var offsetParent, offset, doc, elem = this[0], parentOffset = { top: 0, left: 0 };
		      if (jQuery.css(elem, "position") === "fixed") {
		        offset = elem.getBoundingClientRect();
		      } else {
		        offset = this.offset();
		        doc = elem.ownerDocument;
		        offsetParent = elem.offsetParent || doc.documentElement;
		        while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
		          offsetParent = offsetParent.parentNode;
		        }
		        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
		          parentOffset = jQuery(offsetParent).offset();
		          parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
		          parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
		        }
		      }
		      return {
		        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
		        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
		      };
		    },
		    // This method will return documentElement in the following cases:
		    // 1) For the element inside the iframe without offsetParent, this method will return
		    //    documentElement of the parent window
		    // 2) For the hidden or detached element
		    // 3) For body or html element, i.e. in case of the html node - it will return itself
		    //
		    // but those exceptions were never presented as a real life use-cases
		    // and might be considered as more preferable results.
		    //
		    // This logic, however, is not guaranteed and can change at any point in the future
		    offsetParent: function() {
		      return this.map(function() {
		        var offsetParent = this.offsetParent;
		        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
		          offsetParent = offsetParent.offsetParent;
		        }
		        return offsetParent || documentElement;
		      });
		    }
		  });
		  jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(method, prop) {
		    var top = "pageYOffset" === prop;
		    jQuery.fn[method] = function(val) {
		      return access(this, function(elem, method2, val2) {
		        var win;
		        if (isWindow(elem)) {
		          win = elem;
		        } else if (elem.nodeType === 9) {
		          win = elem.defaultView;
		        }
		        if (val2 === undefined) {
		          return win ? win[prop] : elem[method2];
		        }
		        if (win) {
		          win.scrollTo(
		            !top ? val2 : win.pageXOffset,
		            top ? val2 : win.pageYOffset
		          );
		        } else {
		          elem[method2] = val2;
		        }
		      }, method, val, arguments.length);
		    };
		  });
		  jQuery.each(["top", "left"], function(_i, prop) {
		    jQuery.cssHooks[prop] = addGetHookIf(
		      support.pixelPosition,
		      function(elem, computed) {
		        if (computed) {
		          computed = curCSS(elem, prop);
		          return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
		        }
		      }
		    );
		  });
		  jQuery.each({ Height: "height", Width: "width" }, function(name, type) {
		    jQuery.each({
		      padding: "inner" + name,
		      content: type,
		      "": "outer" + name
		    }, function(defaultExtra, funcName) {
		      jQuery.fn[funcName] = function(margin, value) {
		        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
		        return access(this, function(elem, type2, value2) {
		          var doc;
		          if (isWindow(elem)) {
		            return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
		          }
		          if (elem.nodeType === 9) {
		            doc = elem.documentElement;
		            return Math.max(
		              elem.body["scroll" + name],
		              doc["scroll" + name],
		              elem.body["offset" + name],
		              doc["offset" + name],
		              doc["client" + name]
		            );
		          }
		          return value2 === undefined ? (
		            // Get width or height on the element, requesting but not forcing parseFloat
		            jQuery.css(elem, type2, extra)
		          ) : (
		            // Set width or height on the element
		            jQuery.style(elem, type2, value2, extra)
		          );
		        }, type, chainable ? margin : undefined, chainable);
		      };
		    });
		  });
		  jQuery.each([
		    "ajaxStart",
		    "ajaxStop",
		    "ajaxComplete",
		    "ajaxError",
		    "ajaxSuccess",
		    "ajaxSend"
		  ], function(_i, type) {
		    jQuery.fn[type] = function(fn) {
		      return this.on(type, fn);
		    };
		  });
		  jQuery.fn.extend({
		    bind: function(types, data, fn) {
		      return this.on(types, null, data, fn);
		    },
		    unbind: function(types, fn) {
		      return this.off(types, null, fn);
		    },
		    delegate: function(selector, types, data, fn) {
		      return this.on(types, selector, data, fn);
		    },
		    undelegate: function(selector, types, fn) {
		      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
		    },
		    hover: function(fnOver, fnOut) {
		      return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
		    }
		  });
		  jQuery.each(
		    "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
		    function(_i, name) {
		      jQuery.fn[name] = function(data, fn) {
		        return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
		      };
		    }
		  );
		  var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
		  jQuery.proxy = function(fn, context) {
		    var tmp, args, proxy;
		    if (typeof context === "string") {
		      tmp = fn[context];
		      context = fn;
		      fn = tmp;
		    }
		    if (!isFunction(fn)) {
		      return undefined;
		    }
		    args = slice.call(arguments, 2);
		    proxy = function() {
		      return fn.apply(context || this, args.concat(slice.call(arguments)));
		    };
		    proxy.guid = fn.guid = fn.guid || jQuery.guid++;
		    return proxy;
		  };
		  jQuery.holdReady = function(hold) {
		    if (hold) {
		      jQuery.readyWait++;
		    } else {
		      jQuery.ready(true);
		    }
		  };
		  jQuery.isArray = Array.isArray;
		  jQuery.parseJSON = JSON.parse;
		  jQuery.nodeName = nodeName;
		  jQuery.isFunction = isFunction;
		  jQuery.isWindow = isWindow;
		  jQuery.camelCase = camelCase;
		  jQuery.type = toType;
		  jQuery.now = Date.now;
		  jQuery.isNumeric = function(obj) {
		    var type = jQuery.type(obj);
		    return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
		    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		    // subtraction forces infinities to NaN
		    !isNaN(obj - parseFloat(obj));
		  };
		  jQuery.trim = function(text) {
		    return text == null ? "" : (text + "").replace(rtrim, "$1");
		  };
		  var _jQuery = window2.jQuery, _$ = window2.$;
		  jQuery.noConflict = function(deep) {
		    if (window2.$ === jQuery) {
		      window2.$ = _$;
		    }
		    if (deep && window2.jQuery === jQuery) {
		      window2.jQuery = _jQuery;
		    }
		    return jQuery;
		  };
		  if (typeof noGlobal === "undefined") {
		    window2.jQuery = window2.$ = jQuery;
		  }
		  return jQuery;
		}); 
	} (jquery));
	return jquery.exports;
}

(function (module) {
	(function(define2) {
	  define2(["jquery"], function($) {
	    return /* @__PURE__ */ function() {
	      var $container;
	      var listener;
	      var toastId = 0;
	      var toastType = {
	        error: "error",
	        info: "info",
	        success: "success",
	        warning: "warning"
	      };
	      var toastr = {
	        clear,
	        remove,
	        error,
	        getContainer,
	        info,
	        options: {},
	        subscribe,
	        success,
	        version: "2.1.4",
	        warning
	      };
	      var previousToast;
	      return toastr;
	      function error(message, title, optionsOverride) {
	        return notify({
	          type: toastType.error,
	          iconClass: getOptions().iconClasses.error,
	          message,
	          optionsOverride,
	          title
	        });
	      }
	      function getContainer(options, create) {
	        if (!options) {
	          options = getOptions();
	        }
	        $container = $("#" + options.containerId);
	        if ($container.length) {
	          return $container;
	        }
	        if (create) {
	          $container = createContainer(options);
	        }
	        return $container;
	      }
	      function info(message, title, optionsOverride) {
	        return notify({
	          type: toastType.info,
	          iconClass: getOptions().iconClasses.info,
	          message,
	          optionsOverride,
	          title
	        });
	      }
	      function subscribe(callback) {
	        listener = callback;
	      }
	      function success(message, title, optionsOverride) {
	        return notify({
	          type: toastType.success,
	          iconClass: getOptions().iconClasses.success,
	          message,
	          optionsOverride,
	          title
	        });
	      }
	      function warning(message, title, optionsOverride) {
	        return notify({
	          type: toastType.warning,
	          iconClass: getOptions().iconClasses.warning,
	          message,
	          optionsOverride,
	          title
	        });
	      }
	      function clear($toastElement, clearOptions) {
	        var options = getOptions();
	        if (!$container) {
	          getContainer(options);
	        }
	        if (!clearToast($toastElement, options, clearOptions)) {
	          clearContainer(options);
	        }
	      }
	      function remove($toastElement) {
	        var options = getOptions();
	        if (!$container) {
	          getContainer(options);
	        }
	        if ($toastElement && $(":focus", $toastElement).length === 0) {
	          removeToast($toastElement);
	          return;
	        }
	        if ($container.children().length) {
	          $container.remove();
	        }
	      }
	      function clearContainer(options) {
	        var toastsToClear = $container.children();
	        for (var i = toastsToClear.length - 1; i >= 0; i--) {
	          clearToast($(toastsToClear[i]), options);
	        }
	      }
	      function clearToast($toastElement, options, clearOptions) {
	        var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	        if ($toastElement && (force || $(":focus", $toastElement).length === 0)) {
	          $toastElement[options.hideMethod]({
	            duration: options.hideDuration,
	            easing: options.hideEasing,
	            complete: function() {
	              removeToast($toastElement);
	            }
	          });
	          return true;
	        }
	        return false;
	      }
	      function createContainer(options) {
	        $container = $("<div/>").attr("id", options.containerId).addClass(options.positionClass);
	        $container.appendTo($(options.target));
	        return $container;
	      }
	      function getDefaults() {
	        return {
	          tapToDismiss: true,
	          toastClass: "toast",
	          containerId: "toast-container",
	          debug: false,
	          showMethod: "fadeIn",
	          //fadeIn, slideDown, and show are built into jQuery
	          showDuration: 300,
	          showEasing: "swing",
	          //swing and linear are built into jQuery
	          onShown: undefined,
	          hideMethod: "fadeOut",
	          hideDuration: 1e3,
	          hideEasing: "swing",
	          onHidden: undefined,
	          closeMethod: false,
	          closeDuration: false,
	          closeEasing: false,
	          closeOnHover: true,
	          extendedTimeOut: 1e3,
	          iconClasses: {
	            error: "toast-error",
	            info: "toast-info",
	            success: "toast-success",
	            warning: "toast-warning"
	          },
	          iconClass: "toast-info",
	          positionClass: "toast-top-right",
	          timeOut: 5e3,
	          // Set timeOut and extendedTimeOut to 0 to make it sticky
	          titleClass: "toast-title",
	          messageClass: "toast-message",
	          escapeHtml: false,
	          target: "body",
	          closeHtml: '<button type="button">&times;</button>',
	          closeClass: "toast-close-button",
	          newestOnTop: true,
	          preventDuplicates: false,
	          progressBar: false,
	          progressClass: "toast-progress",
	          rtl: false
	        };
	      }
	      function publish(args) {
	        if (!listener) {
	          return;
	        }
	        listener(args);
	      }
	      function notify(map) {
	        var options = getOptions();
	        var iconClass = map.iconClass || options.iconClass;
	        if (typeof map.optionsOverride !== "undefined") {
	          options = $.extend(options, map.optionsOverride);
	          iconClass = map.optionsOverride.iconClass || iconClass;
	        }
	        if (shouldExit(options, map)) {
	          return;
	        }
	        toastId++;
	        $container = getContainer(options, true);
	        var intervalId = null;
	        var $toastElement = $("<div/>");
	        var $titleElement = $("<div/>");
	        var $messageElement = $("<div/>");
	        var $progressElement = $("<div/>");
	        var $closeElement = $(options.closeHtml);
	        var progressBar = {
	          intervalId: null,
	          hideEta: null,
	          maxHideTime: null
	        };
	        var response = {
	          toastId,
	          state: "visible",
	          startTime: /* @__PURE__ */ new Date(),
	          options,
	          map
	        };
	        personalizeToast();
	        displayToast();
	        handleEvents();
	        publish(response);
	        if (options.debug && console) {
	          console.log(response);
	        }
	        return $toastElement;
	        function escapeHtml(source) {
	          if (source == null) {
	            source = "";
	          }
	          return source.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
	        }
	        function personalizeToast() {
	          setIcon();
	          setTitle();
	          setMessage();
	          setCloseButton();
	          setProgressBar();
	          setRTL();
	          setSequence();
	          setAria();
	        }
	        function setAria() {
	          var ariaValue = "";
	          switch (map.iconClass) {
	            case "toast-success":
	            case "toast-info":
	              ariaValue = "polite";
	              break;
	            default:
	              ariaValue = "assertive";
	          }
	          $toastElement.attr("aria-live", ariaValue);
	        }
	        function handleEvents() {
	          if (options.closeOnHover) {
	            $toastElement.hover(stickAround, delayedHideToast);
	          }
	          if (!options.onclick && options.tapToDismiss) {
	            $toastElement.click(hideToast);
	          }
	          if (options.closeButton && $closeElement) {
	            $closeElement.click(function(event) {
	              if (event.stopPropagation) {
	                event.stopPropagation();
	              } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                event.cancelBubble = true;
	              }
	              if (options.onCloseClick) {
	                options.onCloseClick(event);
	              }
	              hideToast(true);
	            });
	          }
	          if (options.onclick) {
	            $toastElement.click(function(event) {
	              options.onclick(event);
	              hideToast();
	            });
	          }
	        }
	        function displayToast() {
	          $toastElement.hide();
	          $toastElement[options.showMethod](
	            { duration: options.showDuration, easing: options.showEasing, complete: options.onShown }
	          );
	          if (options.timeOut > 0) {
	            intervalId = setTimeout(hideToast, options.timeOut);
	            progressBar.maxHideTime = parseFloat(options.timeOut);
	            progressBar.hideEta = (/* @__PURE__ */ new Date()).getTime() + progressBar.maxHideTime;
	            if (options.progressBar) {
	              progressBar.intervalId = setInterval(updateProgress, 10);
	            }
	          }
	        }
	        function setIcon() {
	          if (map.iconClass) {
	            $toastElement.addClass(options.toastClass).addClass(iconClass);
	          }
	        }
	        function setSequence() {
	          if (options.newestOnTop) {
	            $container.prepend($toastElement);
	          } else {
	            $container.append($toastElement);
	          }
	        }
	        function setTitle() {
	          if (map.title) {
	            var suffix = map.title;
	            if (options.escapeHtml) {
	              suffix = escapeHtml(map.title);
	            }
	            $titleElement.append(suffix).addClass(options.titleClass);
	            $toastElement.append($titleElement);
	          }
	        }
	        function setMessage() {
	          if (map.message) {
	            var suffix = map.message;
	            if (options.escapeHtml) {
	              suffix = escapeHtml(map.message);
	            }
	            $messageElement.append(suffix).addClass(options.messageClass);
	            $toastElement.append($messageElement);
	          }
	        }
	        function setCloseButton() {
	          if (options.closeButton) {
	            $closeElement.addClass(options.closeClass).attr("role", "button");
	            $toastElement.prepend($closeElement);
	          }
	        }
	        function setProgressBar() {
	          if (options.progressBar) {
	            $progressElement.addClass(options.progressClass);
	            $toastElement.prepend($progressElement);
	          }
	        }
	        function setRTL() {
	          if (options.rtl) {
	            $toastElement.addClass("rtl");
	          }
	        }
	        function shouldExit(options2, map2) {
	          if (options2.preventDuplicates) {
	            if (map2.message === previousToast) {
	              return true;
	            } else {
	              previousToast = map2.message;
	            }
	          }
	          return false;
	        }
	        function hideToast(override) {
	          var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	          var duration = override && options.closeDuration !== false ? options.closeDuration : options.hideDuration;
	          var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	          if ($(":focus", $toastElement).length && !override) {
	            return;
	          }
	          clearTimeout(progressBar.intervalId);
	          return $toastElement[method]({
	            duration,
	            easing,
	            complete: function() {
	              removeToast($toastElement);
	              clearTimeout(intervalId);
	              if (options.onHidden && response.state !== "hidden") {
	                options.onHidden();
	              }
	              response.state = "hidden";
	              response.endTime = /* @__PURE__ */ new Date();
	              publish(response);
	            }
	          });
	        }
	        function delayedHideToast() {
	          if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	            intervalId = setTimeout(hideToast, options.extendedTimeOut);
	            progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	            progressBar.hideEta = (/* @__PURE__ */ new Date()).getTime() + progressBar.maxHideTime;
	          }
	        }
	        function stickAround() {
	          clearTimeout(intervalId);
	          progressBar.hideEta = 0;
	          $toastElement.stop(true, true)[options.showMethod](
	            { duration: options.showDuration, easing: options.showEasing }
	          );
	        }
	        function updateProgress() {
	          var percentage = (progressBar.hideEta - (/* @__PURE__ */ new Date()).getTime()) / progressBar.maxHideTime * 100;
	          $progressElement.width(percentage + "%");
	        }
	      }
	      function getOptions() {
	        return $.extend({}, getDefaults(), toastr.options);
	      }
	      function removeToast($toastElement) {
	        if (!$container) {
	          $container = getContainer();
	        }
	        if ($toastElement.is(":visible")) {
	          return;
	        }
	        $toastElement.remove();
	        $toastElement = null;
	        if ($container.children().length === 0) {
	          $container.remove();
	          previousToast = undefined;
	        }
	      }
	    }();
	  });
	})(function(deps, factory) {
	  if (module.exports) {
	    module.exports = factory(requireJquery());
	  } else {
	    window.toastr = factory(window.jQuery);
	  }
	}); 
} (toastr$1));

const CopilotDialog = (props) => {
  const {
    isDialogVisible,
    handleDialogClose,
    title,
    children,
    minWidth,
    dialogFooter,
    minHeight,
    isBlocking = true
  } = props;
  const CopilotDialogStyles = {
    main: {
      borderRadius: "8px",
      minHeight,
      selectors: {
        ".ms-Dialog-header": {
          display: "none"
        },
        ".ms-Dialog-inner": {
          padding: 0
        }
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Dialog,
    {
      hidden: !isDialogVisible,
      onDismiss: () => handleDialogClose(false),
      dialogContentProps: {
        type: DialogType.normal,
        title
      },
      modalProps: {
        isBlocking,
        styles: CopilotDialogStyles
      },
      className: "copilot-dialog",
      children: [
        children ? children : null,
        dialogFooter ? /* @__PURE__ */ jsxRuntimeExports.jsx(DialogFooter, { children: dialogFooter }) : null
      ]
    }
  );
};

const useStyles$6 = makeStyles({
  draftWithCopilotLoadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 0,
    margin: "10px",
    height: "40px"
    },
  title: {
    color: "#242424",
    fontSize: "14px",
    fontWeight: 600,
    padding: "0 5px",
  },
  stopGeneratingIcon: {
    color: "#242424",
    fontSize: "28px",
    fontWeight: 600,
    padding: "0 5px",
  },
  draftWithCopilotLoadingLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "spece-between",
  },
  draftWithCopilotLoadingRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "spece-between",
    cursor: "pointer",
  },
  escRegularIcon: {
    border: "1px solid #e0e0e0",
    margin: "0 8px",
    padding: "0 5px",
    color: "#616161",
    fontSize: '12px',
    fontWeight: 400,
  },
  draftWithCopilotLoading: {
    backgroundColor: "#F3F2F1",
    borderRadius: "8px",
    padding: "10px",
  },
});

const DraftWithCopilotLoading = (props) => {
  const { isDialogVisible, handleDialogClose, minWidth, theme } = props;
  React.useLayoutEffect(() => {
    const copilotThemeExtension = {
      "fai-colorBrandFlair1": "#0078d4",
      "fai-colorBrandFlair2": "#0078d4",
      "fai-colorBrandFlair3": "#0078d4"
    };
    const cssRule = createCSSRuleFromTheme(":root", {
      ...webLightTheme,
      webDarkTheme,
      ...copilotThemeExtension
    });
    const style = document.createElement("style");
    document.head.appendChild(style);
    style.sheet?.insertRule(cssRule);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const styles = useStyles$6();
  const handleClick = () => {
    handleDialogClose();
  };
  const copilotLogoSrc = "https://res-2-sdf.cdn.office.net/files/fabric-cdn-prod_20240411.001/assets/brand-icons/product/svg/copilot_24x1.svg";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CopilotProvider,
    {
      mode: "sidecar",
      theme: theme == "dark" ? webDarkTheme : webLightTheme,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        CopilotDialog,
        {
          isDialogVisible,
          handleDialogClose,
          minWidth,
          minHeight: 40,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(OutputCard, { progress: { value: undefined }, isLoading: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.draftWithCopilotLoadingContainer, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.draftWithCopilotLoadingLeft, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Avatar,
                {
                  size: 20,
                  image: { src: copilotLogoSrc, alt: "Copilot Logo" }
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: styles.title, children: "Creating a draft..." })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "div",
              {
                className: styles.draftWithCopilotLoadingRight,
                onClick: handleClick,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    SquareDismissRegular,
                    {
                      className: styles.stopGeneratingIcon,
                      style: { fontSize: 28, color: "#424242" },
                      onClick: handleClick
                    }
                  ),
                  " ",
                  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: handleClick, children: "Stop generating" }),
                  " ",
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: styles.escRegularIcon, children: "ESC" })
                ]
              }
            )
          ] }) })
        }
      )
    }
  );
};

const dialogContentPropsAllKPINotAvailable = {
  type: DialogType.normal,
  title: GenerateExecutiveSummary,
  closeButtonAriaLabel: "Close",
  subText: textAllKPINotAvailable
};
const ExecutiveSummaryDialog = ({
  theme,
  isConfirmationDialog,
  setIsProceed,
  setisConfirmationDialog,
  setLoadingStopped
}) => {
  const [showDialog, setShowDialog] = useState(isConfirmationDialog);
  useEffect(() => {
    if (showDialog !== isConfirmationDialog) {
      setShowDialog(isConfirmationDialog);
    }
  }, [isConfirmationDialog]);
  const modalProps = () => ({
    isBlocking: true,
    styles: { main: { minWidth: 800 } }
    // Increase the width here      
  });
  const toggleHideDialog = (result) => {
    switch (result) {
      case "Cancel":
        setIsProceed(false);
        setisConfirmationDialog(false);
        setLoadingStopped(false);
        break;
      case "Proceed":
        setIsProceed(true);
        setisConfirmationDialog(false);
        setLoadingStopped(false);
        break;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FluentProvider, { theme: theme == "dark" ? webDarkTheme : webLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      hidden: !showDialog,
      onDismiss: toggleHideDialog,
      dialogContentProps: dialogContentPropsAllKPINotAvailable,
      modalProps,
      minWidth: 600,
      maxWidth: 600,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(DialogFooter, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(PrimaryButton, { className: "Proceed", onClick: () => toggleHideDialog("Proceed"), text: "Proceed" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultButton, { className: "CancelDialog", onClick: () => toggleHideDialog("Cancel"), text: "Cancel" })
      ] })
    }
  ) });
};

const dialogContentPropsFewKPINotAvailable = {
  type: DialogType.normal,
  title: GenerateExecutiveSummary,
  closeButtonAriaLabel: "Close",
  subText: textFewKPINotAvailable
};
const ExecutiveSummaryDialogMissingKpi = ({
  theme,
  isConfirmationDialogMissingKpi,
  setIsProceedMissingKpi,
  setisConfirmationDialogMissingKpi,
  setLoadingStopped,
  selectedKeyMissingKpi,
  setSelectedKeyMissingKpi
}) => {
  const onChange = (event, option, index, value) => {
    setSelectedKeyMissingKpi(option ? option.key : undefined);
  };
  const [showDialog, setShowDialog] = useState(isConfirmationDialogMissingKpi);
  useEffect(() => {
    if (showDialog !== isConfirmationDialogMissingKpi) {
      setShowDialog(isConfirmationDialogMissingKpi);
    }
  }, [isConfirmationDialogMissingKpi]);
  const modalProps = () => ({
    isBlocking: true,
    styles: { main: { minWidth: 800 } }
    // Increase the width here      
  });
  const toggleHideDialog = (result) => {
    switch (result) {
      case "Cancel":
        setIsProceedMissingKpi(false);
        setisConfirmationDialogMissingKpi(false);
        setLoadingStopped(false);
        setSelectedKeyMissingKpi(modalOptions[0].key);
        break;
      case "Proceed":
        setIsProceedMissingKpi(true);
        setisConfirmationDialogMissingKpi(false);
        setLoadingStopped(false);
        break;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FluentProvider, { theme: theme == "dark" ? webDarkTheme : webLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Dialog,
    {
      hidden: !showDialog,
      onDismiss: toggleHideDialog,
      dialogContentProps: dialogContentPropsFewKPINotAvailable,
      modalProps,
      minWidth: 625,
      maxWidth: 625,
      className: "executive-dialog-container",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "modalText", children: howProceed }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChoiceGroup,
            {
              className: "modal-options",
              options: modalOptions,
              selectedKey: selectedKeyMissingKpi,
              onChange,
              styles: { root: { marginBottom: 20 } }
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(DialogFooter, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(PrimaryButton, { className: "Proceed", onClick: () => toggleHideDialog("Proceed"), text: "Proceed" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultButton, { className: "CancelDialog", onClick: () => toggleHideDialog("Cancel"), text: "Cancel" })
        ] })
      ]
    }
  ) });
};

const useStyles$5 = makeStyles({
  aiGenerate: {
    backgroundColor: "#dddddd"
  },
  innerContentDialog: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between"
  },
  footerText: {
    fontSize: "12px"
  },
  dialogModal: {
    width: "650px",
    padding: "0px 15px 15px",
    borderRadius: "4px",
    border: "3px solid #0078D4 !important"
  },
  headerText: {
    fontWeight: "500"
  },
  copyButton: {
    minWidth: "32px"
  },
  contenArea: {
    maxHeight: "350px",
    overflowY: "auto"
  },
  bannerContainer: {
    display: "flex",
    alignItems: "inherit",
    columnGap: "7px"
  },
  footerMessage: {
    display: "flex",
    justifyContent: "flex-end",
    columnGap: "10px",
    paddingTop: "5px",
    "& .ms-Button": {
      borderRadius: "4px"
    }
  }
});
const RootChatDialog = ({
  mcapsBotContext,
  messages,
  setMessages,
  setIsSpinnerActive,
  isSpinnerActive,
  positiveFeedback,
  negativeFeedback,
  pageInfo,
  trackCustomEvents,
  theme,
  ocvData,
  receivedCommandFromExternalSystem,
  setReplaceText,
  getBearerTokenCallback,
  getAdditionalHeaderCallback
}) => {
  const scrollDiv = React__default.useRef(null);
  useDispatch();
  const styles = useStyles$5();
  const ApplicationName = useSelector((state) => state.appname.appname);
  const config = useSelector((state) => {
    return state.config.config;
  });
  const [isExternalCommandReceived, setIsExternalCommandReceived] = useState(false);
  const [isMessageDialog, setIsMessageDilaog] = useState(false);
  const [selected, setSelected] = useState(undefined);
  const [plainText, setPlainText] = React__default.useState("");
  const [tooltipText, setTooltipText] = useState("Copy");
  const [controlName, setControlName] = useState("");
  const [type, setType] = useState("");
  const [appInsights, setappInsights] = useState(null);
  const [navgigationLogURL, setnavgigationLogURL] = useState(
    pageInfo?.split("/")?.pop()
  );
  const [isLoadingStopped, setLoadingStopped] = useState(false);
  const [telemetryData, setTelemetryData] = useState("");
  const [kpiData, setKpiData] = useState(null);
  const [isConfirmationDialog, setisConfirmationDialog] = useState(false);
  const [isProceed, setIsProceed] = useState(false);
  const [isConfirmationDialogMissingKpi, setisConfirmationDialogMissingKpi] = useState(false);
  const [isProceedMissingKpi, setIsProceedMissingKpi] = useState(false);
  const [selectedKeyMissingKpi, setSelectedKeyMissingKpi] = useState(modalOptions[0].key);
  const copilotLogoSrc = "https://res-2-sdf.cdn.office.net/files/fabric-cdn-prod_20240411.001/assets/brand-icons/product/svg/copilot_24x1.svg";
  useEffect(() => {
    if (config?.appInsightConfig?.instrumentationKey) {
      const appInsightObj = initializeAppInsights(
        config?.appInsightConfig?.instrumentationKey
      );
      setappInsights(appInsightObj);
    }
  }, [config]);
  useEffect(() => {
    if (!isLoadingStopped && kpiData) {
      const responses = kpiData;
      if (responses.some((response) => response === null)) {
        return;
      }
      const parseResponse2 = (reply) => {
        if (reply && typeof reply === "string") {
          return JSON.parse(reply);
        }
        return reply;
      };
      const processResponse = ({ kpi, response }) => {
        let processedResponse = { reply: response };
        processedResponse.reply = parseResponse2(processedResponse.reply);
        processedResponse.reply = parseResponse2(processedResponse.reply?.data);
        return {
          kpi,
          iframeId: receivedCommandFromExternalSystem.iframeIds[kpi],
          kpiTelemetry: receivedCommandFromExternalSystem.kpiTelemetryData[kpi],
          data: processedResponse.reply?.data || processedResponse.reply || processedResponse
        };
      };
      const tempMessage = responses.map(processResponse);
      tempMessage.forEach((message, index) => {
        if (isLoadingStopped) {
          return;
        }
        const formattedMessage = formatKpiData(message.data.reply);
        replaceTextKpi(formattedMessage, message.iframeId);
        setKpiTelemetry(formattedMessage, message.kpiTelemetry);
        receivedCommandFromExternalSystem.payload.Payload.data[message.kpi] = formattedMessage;
      });
      setisConfirmationDialog(false);
      setisConfirmationDialogMissingKpi(false);
      handleCommand(receivedCommandFromExternalSystem, true);
      setKpiData(null);
    }
  }, [isLoadingStopped, kpiData]);
  useEffect(() => {
    if (receivedCommandFromExternalSystem?.payload?.Type === "Command" && receivedCommandFromExternalSystem?.payload?.SubCommand !== "GenerateExecutiveSummary") {
      handleCommand(receivedCommandFromExternalSystem, true);
    }
    if (receivedCommandFromExternalSystem?.payload?.SubCommand == "GenerateExecutiveSummary") {
      if (receivedCommandFromExternalSystem?.isKpiBlank) {
        setisConfirmationDialog(true);
      }
      if (!receivedCommandFromExternalSystem?.isDataInAllKPI && !receivedCommandFromExternalSystem?.isKpiBlank) {
        setisConfirmationDialogMissingKpi(true);
      }
      if (receivedCommandFromExternalSystem?.isDataInAllKPI) {
        setisConfirmationDialog(false);
        setisConfirmationDialogMissingKpi(false);
        handleCommand(receivedCommandFromExternalSystem, true);
      }
    }
    if (receivedCommandFromExternalSystem?.type) {
      setType(receivedCommandFromExternalSystem.type);
    }
    if (receivedCommandFromExternalSystem?.iframeId) {
      setControlName(receivedCommandFromExternalSystem.iframeId);
    }
    if (receivedCommandFromExternalSystem?.telemetry) {
      setTelemetryData(receivedCommandFromExternalSystem.telemetry);
    }
  }, [receivedCommandFromExternalSystem]);
  useEffect(() => {
    if (isProceed) {
      handleCommand(receivedCommandFromExternalSystem, false);
    }
  }, [isProceed]);
  useEffect(() => {
    if (isProceedMissingKpi) {
      handleCommand(receivedCommandFromExternalSystem, false);
    }
  }, [isProceedMissingKpi]);
  const LinkRenderer = ({ href, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children });
  const MarkdownRenderer = ({ messageText }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "markdown-table", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { components: { a: LinkRenderer }, remarkPlugins: [remarkGfm], children: messageText }) });
  };
  const formatKpiData = (messageText) => {
    const jsx2 = /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, { messageText });
    return renderToString(jsx2);
  };
  const filterMissingKpiData = (allKpiData, missingKpi) => {
    let filteredData = {};
    missingKpi.forEach((kpi) => {
      if (allKpiData[kpi]) {
        filteredData[kpi] = allKpiData[kpi];
      }
    });
    return filteredData;
  };
  const handleCommand = async (receivedCommandFromExternalSystem2, calledFromExecutiveGenerate) => {
    console.log("Handle External Command : ", receivedCommandFromExternalSystem2);
    try {
      if (receivedCommandFromExternalSystem2?.kpiPayload && !calledFromExecutiveGenerate) {
        setLoadingStopped(false);
        setIsSpinnerActive(true);
        setIsExternalCommandReceived(true);
        setIsProceed(false);
        setIsProceedMissingKpi(false);
        await handleKpiPayload(receivedCommandFromExternalSystem2);
      } else {
        setIsProceed(false);
        setIsProceedMissingKpi(false);
        if (receivedCommandFromExternalSystem2?.payload?.SubCommand == "GenerateExecutiveSummary") {
          receivedCommandFromExternalSystem2.payload.Payload.data = JSON.stringify(receivedCommandFromExternalSystem2.payload.Payload.data);
        }
        await handleExternalCommand(receivedCommandFromExternalSystem2);
        if (receivedCommandFromExternalSystem2?.payload?.SubCommand == "GenerateExecutiveSummary") {
          virtuoso.pprcheckin.globals.showTextModifiedMessage(false);
        }
      }
    } catch (error) {
      handleError(error);
    }
  };
  const handleKpiPayload = async (receivedCommandFromExternalSystem2) => {
    if (receivedCommandFromExternalSystem2?.isKpiBlank) {
      await processMissingKpi(receivedCommandFromExternalSystem2);
    } else if (!receivedCommandFromExternalSystem2?.isDataInAllKPI && !receivedCommandFromExternalSystem2?.isKpiBlank && selectedKeyMissingKpi == "generateSummaries") {
      await processMissingKpi(receivedCommandFromExternalSystem2);
    } else {
      handleCommand(receivedCommandFromExternalSystem2, true);
    }
    setIsProceed(false);
  };
  const processMissingKpi = async (receivedCommandFromExternalSystem2) => {
    const missingKpiPayload = filterMissingKpiData(receivedCommandFromExternalSystem2.kpiPayload, receivedCommandFromExternalSystem2.missingKpi);
    const missingKpiPromises = Object.keys(missingKpiPayload).map(
      (kpi) => PostAsync(
        getBearerTokenCallback,
        config?.apiUrls?.commandApi,
        JSON.stringify(missingKpiPayload[kpi]),
        getAdditionalHeaderCallback
      ).then((response) => {
        if (isLoadingStopped) {
          return null;
        }
        return { kpi, response };
      })
    );
    const responses = await Promise.all(missingKpiPromises);
    setKpiData(responses);
  };
  const handleExternalCommand = async (receivedCommandFromExternalSystem2) => {
    setLoadingStopped(false);
    setIsSpinnerActive(true);
    setIsExternalCommandReceived(true);
    let response = await PostAsync(
      getBearerTokenCallback,
      config?.apiUrls?.commandApi,
      JSON.stringify(receivedCommandFromExternalSystem2.payload),
      getAdditionalHeaderCallback
    );
    response = parseResponse(response);
    setMessages(response);
    setIsSpinnerActive(false);
    setIsMessageDilaog(true);
  };
  const parseResponse = (response) => {
    response = { reply: response };
    if (response.reply && typeof response.reply == "string") {
      response.reply = JSON.parse(response.reply);
    }
    if (response.reply?.data && typeof response.reply?.data == "string") {
      response.reply = JSON.parse(response.reply?.data);
    }
    if (response.reply && typeof response.reply == "string") {
      response.reply = JSON.parse(response.reply);
    }
    return response.reply && response.reply.data ? response.reply.data : response.reply ? response.reply : response.reply.data ? response : "";
  };
  const handleError = (error) => {
    console.log("Error: ", error);
    setIsSpinnerActive(false);
    setLoadingStopped(false);
    setisConfirmationDialog(false);
    if (receivedCommandFromExternalSystem?.payload?.SubCommand == "GenerateExecutiveSummary") {
      if (receivedCommandFromExternalSystem?.missingKpi.length > 0) {
        var missingKpiIframIds = filterMissingKpiData(receivedCommandFromExternalSystem.iframeIds, receivedCommandFromExternalSystem.missingKpi);
        resetAllKpiData(missingKpiIframIds);
      }
    }
    toastr.error("An error occurred while processing your request. Please try again later.", "Operation Unsuccessful");
    const eventValues = JSON.stringify({
      userName: mcapsBotContext.currentUserName,
      PageName: navgigationLogURL ? navgigationLogURL : "Home",
      applicationName: mcapsBotContext.appName,
      type: "Command",
      userQuestion: telemetryData,
      botResponse: error.message
    });
    setTimeout(() => {
      if (trackCustomEvents) {
        trackCustomEvents(mcapsBotContext.featureName + " " + telemetryData, getActionName() + "Failed", eventValues);
      } else {
        appInsights?.trackEvent({
          name: mcapsBotContext.featureName + " " + telemetryData,
          properties: { additionalInfo: eventValues }
        });
      }
    }, 200);
  };
  React__default.useEffect(() => {
    setTimeout(() => {
      scrollDiv.current?.scrollTo({ top: scrollDiv?.current?.scrollHeight });
    }, 0);
  });
  const onFeedbackPositiveClick = () => {
    handleTrackCustomEvents(plainText, "Positive feedback clicked");
    setSelected(selected === "positive" ? undefined : "positive");
    positiveFeedback();
  };
  const generateId = () => {
    const timestamp = Date.now().toString();
    const random = Math.random().toString().substring(2);
    const id = `${timestamp}${random}`;
    return id;
  };
  const onFeedbackNegativeClick = () => {
    setSelected(selected === "negative" ? undefined : "negative");
    negativeFeedback();
    handleTrackCustomEvents(plainText, "Negative feedback clicked");
    if (receivedCommandFromExternalSystem?.payload?.Payload?.data) {
      let conversationId = generateId();
      let messageId = generateId();
      let tempMessage = {
        "Conversation Id": conversationId,
        "Message Id": messageId,
        "Page Name": "Status Checkin",
        "Question": JSON.stringify(receivedCommandFromExternalSystem.payload?.Payload.data),
        "Answer": messages
      };
      ocvData(false, tempMessage);
    }
  };
  const handleTrackCustomEvents = (text, action) => {
    const eventValues = JSON.stringify({
      userName: mcapsBotContext.currentUserName,
      PageName: navgigationLogURL ? navgigationLogURL : "Home",
      applicationName: mcapsBotContext.appName,
      type: "Command",
      userQuestion: telemetryData,
      botResponse: getCommandResponse(text),
      action
    });
    setTimeout(() => {
      if (trackCustomEvents) {
        trackCustomEvents(mcapsBotContext.featureName + " " + telemetryData, getActionName(), eventValues);
      } else {
        appInsights?.trackEvent({
          name: mcapsBotContext.featureName + " " + telemetryData,
          properties: { additionalInfo: eventValues }
        });
      }
    }, 200);
  };
  const copyToClipboard = () => {
    const tempElement = document.createElement("pre");
    tempElement.innerHTML = plainText;
    document.body.appendChild(tempElement);
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(tempElement);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    document.body.removeChild(tempElement);
    setTooltipText("Copied!");
    handleTrackCustomEvents(plainText, "Copy button clicked");
    setTimeout(() => {
      setTooltipText("Copy");
    }, 1e4);
  };
  const getActionName = () => {
    return telemetryData.includes("Generate") ? "Generate" : "Rewrite";
  };
  const replaceText = (type2) => {
    handleTrackCustomEvents(plainText, "Replace button clicked");
    sendData(type2);
  };
  const keepText = (type2) => {
    handleTrackCustomEvents(plainText, "Keep it button clicked");
    sendData(type2);
  };
  const insertText = (type2) => {
    handleTrackCustomEvents(plainText, "Insert above button clicked");
    sendData(type2);
  };
  const sendData = (type2) => {
    if (type2 !== "RESET") {
      setReplaceText(plainText, controlName, type2, false);
    }
    setIsSpinnerActive(false);
    setIsMessageDilaog(false);
    setPlainText("");
    setControlName("");
    setType("");
    setSelected(undefined);
    setTelemetryData("");
  };
  const resetAllKpiData = (kpiIframeIds) => {
    Object.values(kpiIframeIds).forEach((iframeId) => {
      if (iframeId !== "OverallComments_100_ifr") {
        setReplaceText("", iframeId, "REPLACE", true);
      }
    });
  };
  const setActualText = (text) => {
    const eventValues = JSON.stringify({
      userName: mcapsBotContext.currentUserName,
      PageName: navgigationLogURL ? navgigationLogURL : "Home",
      applicationName: mcapsBotContext.appName,
      type: "Command",
      userQuestion: telemetryData,
      botResponse: getCommandResponse(text)
    });
    setTimeout(() => {
      if (trackCustomEvents) {
        trackCustomEvents(telemetryData, getActionName(), eventValues);
      } else {
        appInsights?.trackEvent({
          name: mcapsBotContext.featureName + " " + telemetryData,
          properties: { additionalInfo: eventValues }
        });
      }
    }, 200);
    setPlainText(text);
  };
  const setKpiTelemetry = (text, kpiTelemetryData) => {
    let actionName = kpiTelemetryData.includes("Generate") ? "Generate" : "Rewrite";
    generateId();
    const eventValues = JSON.stringify({
      userName: mcapsBotContext.currentUserName,
      PageName: navgigationLogURL ? navgigationLogURL : "Home",
      applicationName: mcapsBotContext.appName,
      type: "Command",
      userQuestion: kpiTelemetryData,
      botResponse: getCommandResponse(text)
    });
    setTimeout(() => {
      if (trackCustomEvents) {
        trackCustomEvents(mcapsBotContext.featureName + " " + kpiTelemetryData, actionName, eventValues);
      } else {
        appInsights?.trackEvent({
          name: mcapsBotContext.featureName + " " + kpiTelemetryData,
          properties: { additionalInfo: eventValues }
        });
      }
    }, 200);
  };
  const replaceTextKpi = (plainText2, controlName2) => {
    setReplaceText(plainText2, controlName2, "REPLACE", true);
  };
  const handleCopilotLoadingDialogClose = () => {
    if (receivedCommandFromExternalSystem?.missingKpi) {
      var missingKpiIframIds = filterMissingKpiData(receivedCommandFromExternalSystem.iframeIds, receivedCommandFromExternalSystem.missingKpi);
      resetAllKpiData(missingKpiIframIds);
    }
    setLoadingStopped(true);
    sendData("RESET");
    const eventValues = JSON.stringify({
      userName: mcapsBotContext.currentUserName,
      PageName: navgigationLogURL ? navgigationLogURL : "Home",
      applicationName: mcapsBotContext.appName,
      type: "Command",
      userQuestion: telemetryData,
      botResponse: "",
      action: "Operation Cancelled"
    });
    setTimeout(() => {
      if (trackCustomEvents) {
        trackCustomEvents(mcapsBotContext.featureName + " " + telemetryData, getActionName(), eventValues);
      } else {
        appInsights?.trackEvent({
          name: mcapsBotContext.featureName + " " + telemetryData,
          properties: { additionalInfo: eventValues }
        });
      }
    }, 200);
  };
  const cancelDialog = (type2) => {
    handleTrackCustomEvents(plainText, "Cancel button clicked");
    sendData(type2);
  };
  if (isConfirmationDialog) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExecutiveSummaryDialog,
      {
        isConfirmationDialog,
        setIsProceed,
        setisConfirmationDialog,
        setLoadingStopped
      }
    ) });
  } else if (isConfirmationDialogMissingKpi) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ExecutiveSummaryDialogMissingKpi,
      {
        isConfirmationDialogMissingKpi,
        setisConfirmationDialogMissingKpi,
        setIsProceedMissingKpi,
        selectedKeyMissingKpi,
        setSelectedKeyMissingKpi,
        setLoadingStopped
      }
    );
  } else
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isExternalCommandReceived && isSpinnerActive ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      DraftWithCopilotLoading,
      {
        isDialogVisible: isSpinnerActive,
        handleDialogClose: handleCopilotLoadingDialogClose
      }
    ) : !isLoadingStopped ? /* @__PURE__ */ jsxRuntimeExports.jsx(FluentProvider, { theme: theme == "dark" ? webDarkTheme : webLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        containerClassName: styles.dialogModal,
        isOpen: isMessageDialog,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.innerContentDialog, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.bannerContainer, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Avatar,
                {
                  size: 20,
                  image: { src: copilotLogoSrc, alt: "Copilot Logo" }
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: styles.headerText, variant: "xLarge", children: "Draft with " + ApplicationName })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.footerText, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              CopilotMessageFooter,
              {
                feedback: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  FeedbackButtons,
                  {
                    selected,
                    positiveFeedbackButton: {
                      onClick: onFeedbackPositiveClick,
                      disabled: selected !== undefined
                    },
                    positiveFeedbackTooltip: {
                      content: selected === "positive" ? "Like, Feedback sent" : "Like"
                    },
                    negativeFeedbackButton: {
                      onClick: onFeedbackNegativeClick,
                      disabled: selected !== undefined
                    },
                    negativeFeedbackTooltip: {
                      content: selected === "negative" ? "Dislike, Feedback sent" : "Dislike"
                    }
                  }
                ),
                aiDisclaimer: /* @__PURE__ */ jsxRuntimeExports.jsx(AiGeneratedDisclaimer, { className: styles.aiGenerate, children: "AI-generated content may be incorrect" })
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.contenArea, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogData, { messages, setCopyText: setActualText }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.footerMessage, children: [
            type === "Generate" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              PrimaryButton,
              {
                id: "generate-primary",
                text: "Keep it",
                onClick: () => keepText("REPLACE"),
                iconProps: { iconName: "CheckMark" },
                className: "Replace-Popup"
              }
            ),
            type === "Rewrite" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              PrimaryButton,
              {
                id: "rewrite-primary",
                text: "Replace",
                onClick: () => replaceText("REPLACE"),
                iconProps: {},
                onRenderIcon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ArrowTurnLeftUpRegular,
                  {
                    style: { fontSize: 20 },
                    className: "Replace-Popup"
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              DefaultButton,
              {
                title: "Copy",
                iconProps: {},
                className: styles.copyButton,
                onRenderIcon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(CopyRegular, { style: { fontSize: 22 } }),
                onClick: copyToClipboard
              }
            ),
            type === "Rewrite" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              DefaultButton,
              {
                text: "Insert above",
                iconProps: {},
                onRenderIcon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(InsertRegular, { style: { fontSize: 20 } }),
                onClick: () => insertText("ADD")
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              DefaultButton,
              {
                text: "Cancel",
                iconProps: { iconName: "Cancel" },
                onClick: () => cancelDialog("RESET")
              }
            )
          ] })
        ]
      }
    ) }) : null });
};

initializeIcons();
const DBCopilotBotDialog = (props) => {
  const dispatch = useDispatch();
  const [messages, setMessages] = React__default.useState([]);
  const [isSpinnerActive, setIsSpinnerActive] = React__default.useState(false);
  const [authToken, setAuthToken] = React__default.useState(null);
  const mcapsBotContext = {
    appName: props.appName,
    currentUserName: props.currentUserName,
    featureName: props.featureName
  };
  const configuration = {
    apiUrls: props.apiUrls,
    appInsightConfig: {
      instrumentationKey: props.appInsightConfig?.instrumentationKey
    },
    theme: props.theme,
    isUserNameVisible: props.isUserNameVisible,
    pageInfo: props.pageInfo,
    mcapsBotContext
  };
  const handleAuthToken = async () => {
    if (props.getBearerTokenCallback) {
      try {
        const accessToken = await props.getBearerTokenCallback();
        configuration.accessToken = accessToken;
        setAuthToken(accessToken);
      } catch (error) {
        console.error("Error fetching access token:", error);
      }
    } else {
      configuration.accessToken = "default";
    }
  };
  useLayoutEffect(() => {
    handleAuthToken();
  }, []);
  useEffect(() => {
    updateConfiguration();
  }, []);
  useEffect(() => {
    updateConfiguration();
  }, [props]);
  const updateConfiguration = () => {
    dispatch(set_user(props.currentUserName));
    dispatch(set_appName(props.appName));
    dispatch(get_appName());
    dispatch(set_configuration(configuration));
    dispatch(get_configuration());
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RootChatDialog,
    {
      mcapsBotContext,
      messages,
      setMessages,
      setIsSpinnerActive,
      isSpinnerActive,
      positiveFeedback: props.positiveFeedback,
      negativeFeedback: props.negativeFeedback,
      pageInfo: props.pageInfo,
      trackCustomEvents: props.trackCustomEvents,
      textBoxLength: props.textBoxLength,
      theme: props.theme,
      setReplaceText: props.setReplaceText,
      receivedCommandFromExternalSystem: props.receivedCommandFromExternalSystem,
      ocvData: props.ocvData,
      getBearerTokenCallback: props.getBearerTokenCallback,
      getAdditionalHeaderCallback: props.getAdditionalHeaderCallback
    }
  );
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (undefined !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage$2(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable$1 = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString$1 = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes$1 = {
  INIT: "@@redux/INIT" + randomString$1(),
  REPLACE: "@@redux/REPLACE" + randomString$1(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString$1();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$2(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf$1(val) {
  if (val === undefined) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate$1(val)) return 'date';
  if (isError$1(val)) return 'error';
  var constructorName = ctorName$1(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName$1(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError$1(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate$1(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf$1(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf$1(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore$1(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf$1(enhancer) + "'");
    }

    return enhancer(createStore$1)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf$1(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(4) : "Expected the listener to be a function. Instead, received: '" + kindOf$1(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$2(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf$1(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf$1(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes$1.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(11) : "Expected the observer to be an object. Instead, received: '" + kindOf$1(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable$1] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes$1.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable$1] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$1(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage$1(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes$1.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject$2(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf$1(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes$1.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape$1(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes$1.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes$1.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes$1.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers$1(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (process.env.NODE_ENV !== 'production') {
      if (typeof reducers[key] === 'undefined') {
        warning$1("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (process.env.NODE_ENV !== 'production') {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape$1(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === undefined) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (process.env.NODE_ENV !== 'production') {
      var warningMessage = getUnexpectedStateShapeWarningMessage$1(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning$1(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose$1() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware$1() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(undefined, arguments);

      var _dispatch = function dispatch() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$2(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose$1.apply(undefined, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL$1 =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');

var undef = function undef(v) {
  return v === null || v === undefined;
};
var notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var func = function func(f) {
  return typeof f === 'function';
};
var string$1 = function string(s) {
  return typeof s === 'string';
};
var array$1 = Array.isArray;
var object = function object(obj) {
  return obj && !array$1(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
  return p && func(p.then);
};
var iterator = function iterator(it) {
  return it && func(it.next) && func(it.throw);
};
var task = function task(t) {
  return t && t[TASK];
};
var buffer = function buffer(buf) {
  return buf && func(buf.isEmpty) && func(buf.take) && func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (string$1(pat) || symbol$1(pat) || func(pat) || array$1(pat) && pat.every(pattern));
};
var channel$1 = function channel(ch) {
  return ch && func(ch.take) && func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return func(f) && f.hasOwnProperty('toString');
};
var symbol$1 = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return channel$1(ch) && ch[MULTICAST];
};
var effect = function effect(eff) {
  return eff && eff[IO];
};

var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === undefined) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (process.env.NODE_ENV !== 'production' && ms > MAX_SIGNED_INT) {
    throw new Error('delay only supports a maximum value of ' + MAX_SIGNED_INT + 'ms');
  }

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[CANCEL$1] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var noop$1 = function noop() {};

if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
  noop$1 =
  /*#__PURE__*/
  new Proxy(noop$1, {
    set: function set() {
      throw internalErr('There was an attempt to assign a property to internal `noop` function.');
    }
  });
}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  _extends(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === undefined) {
    thro = kThrow;
  }

  if (name === undefined) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (process.env.NODE_ENV !== 'production') {
      check(action, function (ac) {
        return !Object.isFrozen(ac);
      }, FROZEN_ACTION_ERROR);
    }

    return dispatch(Object.defineProperty(action, SAGA_ACTION, {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === TERMINATE;
};
var shouldCancel = function shouldCancel(res) {
  return res === TASK_CANCEL;
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (process.env.NODE_ENV !== 'production') {
    check(totalCount, function (c) {
      return c > 0;
    }, 'createAllStyleChildCallbacks: get an empty array or object');
  }

  var completedCount = 0;
  var completed;
  var results = array$1(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop$1;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[SAGA_LOCATION];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

function ringBuffer(limit, overflowAction) {
  if (limit === undefined) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

        }
      }
    },
    take: take,
    flush: flush
  };
}
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED$1 = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
function take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === undefined) {
    patternOrChannel = '*';
  }

  if (process.env.NODE_ENV !== 'production' && arguments.length) {
    check(arguments[0], notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }

  if (pattern(patternOrChannel)) {
    if (notUndef(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (multicast(patternOrChannel) && notUndef(multicastPattern) && pattern(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (channel$1(patternOrChannel)) {
    if (notUndef(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    throw new Error("take(patternOrChannel): argument " + patternOrChannel + " is not valid channel or a valid pattern");
  }
}
function put(channel$1$1, action) {
  if (process.env.NODE_ENV !== 'production') {
    if (arguments.length > 1) {
      check(channel$1$1, notUndef, 'put(channel, action): argument channel is undefined');
      check(channel$1$1, channel$1, "put(channel, action): argument " + channel$1$1 + " is not a valid channel");
      check(action, notUndef, 'put(channel, action): argument action is undefined');
    } else {
      check(channel$1$1, notUndef, 'put(action): argument action is undefined');
    }
  }

  if (undef(action)) {
    action = channel$1$1; // `undefined` instead of `null` to make default parameter work

    channel$1$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1$1,
    action: action
  });
}

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  check(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array$1(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    check(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    check(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    check(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string$1(fn)) {
    check(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  check(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if (func(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if (array$1(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && string$1(fn) && func(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== delay;
};

function call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (process.env.NODE_ENV !== 'production') {
    var arg0 = typeof args[0] === 'number' ? args[0] : 'ms';
    check(fnDescriptor, isNotDelayEffect, "instead of writing `yield call(delay, " + arg0 + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + arg0 + ")`");
    validateFnDescriptor('call', fnDescriptor);
  }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function fork(fnDescriptor) {
  if (process.env.NODE_ENV !== 'production') {
    validateFnDescriptor('fork', fnDescriptor);
    check(fnDescriptor, function (arg) {
      return !effect(arg);
    }, 'fork: argument must not be an effect');
  }

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function cancel(taskOrTasks) {
  if (taskOrTasks === undefined) {
    taskOrTasks = SELF_CANCELLATION;
  }

  if (process.env.NODE_ENV !== 'production') {
    if (arguments.length > 1) {
      throw new Error('cancel(...tasks) is not supported any more. Please use cancel([...tasks]) to cancel multiple tasks.');
    }

    if (array$1(taskOrTasks)) {
      taskOrTasks.forEach(function (t) {
        check(t, task, "cancel([...tasks]): argument " + t + " is not a valid Task object " + TEST_HINT);
      });
    } else if (taskOrTasks !== SELF_CANCELLATION && notUndef(taskOrTasks)) {
      check(taskOrTasks, task, "cancel(task): argument " + taskOrTasks + " is not a valid Task object " + TEST_HINT);
    }
  }

  return makeEffect(CANCEL, taskOrTasks);
}
var delay =
/*#__PURE__*/
call.bind(null, delayP);

function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}

var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return kTrue;
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : string$1(pattern) ? string : array$1(pattern) ? array : stringableFunc(pattern) ? string : func(pattern) ? predicate : symbol$1(pattern) ? symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: CHANNEL_END_TYPE
};
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function channel(buffer$1) {
  if (buffer$1 === undefined) {
    buffer$1 = expanding();
  }

  var closed = false;
  var takers = [];

  if (process.env.NODE_ENV !== 'production') {
    check(buffer$1, buffer, INVALID_BUFFER);
  }

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw internalErr('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check(input, notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check(cb, func, "channel.take's callback must be a function");
    }

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        remove(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check(cb, func, "channel.flush' callback must be a function");
    }

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
    }

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
    }

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[MULTICAST] = true, _ref.put = function put(input) {
    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
      check(input, notUndef, UNDEFINED_INPUT_ERROR);
    }

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[MATCH](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === undefined) {
      matcher = wildcard;
    }

    if (process.env.NODE_ENV !== 'production') {
      checkForbiddenStates();
    }

    if (closed) {
      cb(END);
      return;
    }

    cb[MATCH] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = once(function () {
      ensureCanMutateNextTakers();
      remove(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[SAGA_ACTION]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[CANCEL$1];

  if (func(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var current$1 = 0;
var nextSagaId = (function () {
  return ++current$1;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return getMetaInfo(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if (iterator(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !promise(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return makeIterator(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return makeIterator(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && promise(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === undefined ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(TERMINATE);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, notUndef(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if (promise(result)) {
      resolvePromise(result, cb);
      return;
    }

    if (iterator(result)) {
      // resolve iterator
      proc(env, result, task.context, current$1, getMetaInfo(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if (undef(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current$1, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) remove(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if (array$1(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = createAllStyleChildCallbacks(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === SELF_CANCELLATION) {
    cancelSingleTask(task);
  } else if (array$1(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current$1;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb(array$1(effects) ? [] : {});
    return;
  }

  var childCallbacks = createAllStyleChildCallbacks(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current$1;
  var keys = Object.keys(effects);
  var response = array$1(effects) ? createEmptyArray(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = noop$1;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  assignWithSymbols(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[TAKE] = runTakeEffect, _effectRunnerMap[PUT] = runPutEffect, _effectRunnerMap[ALL] = runAllEffect, _effectRunnerMap[RACE] = runRaceEffect, _effectRunnerMap[CALL] = runCallEffect, _effectRunnerMap[CPS] = runCPSEffect, _effectRunnerMap[FORK] = runForkEffect, _effectRunnerMap[JOIN] = runJoinEffect, _effectRunnerMap[CANCEL] = runCancelEffect, _effectRunnerMap[SELECT] = runSelectEffect, _effectRunnerMap[ACTION_CHANNEL] = runChannelEffect, _effectRunnerMap[CANCELLED$1] = runCancelledEffect, _effectRunnerMap[FLUSH] = runFlushEffect, _effectRunnerMap[GET_CONTEXT] = runGetContextEffect, _effectRunnerMap[SET_CONTEXT] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      remove(tasks, task);
      task.cont = noop$1;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = noop$1;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = getLocation(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = flatMap(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === undefined) {
    cont = noop$1;
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(TASK_CANCEL, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === TASK_CANCEL) {
        status = CANCELLED;
      } else if (status !== CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (process.env.NODE_ENV !== 'production') {
      check(props, object, createSetContextWarning('task', props));
    }

    assignWithSymbols(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = deferred();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === CANCELLED || status === RUNNING && mainTask.status === CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (process.env.NODE_ENV !== 'production' && iterator$1[asyncIteratorSymbol]) {
    throw new Error("redux-saga doesn't support async generators, please use only regular ones");
  }

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = noop$1;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = CANCELLED;
      next(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if (shouldCancel(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = func(iterator$1.return) ? iterator$1.return(TASK_CANCEL) : {
          done: true,
          value: TASK_CANCEL
        };
      } else if (shouldTerminate(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = func(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if (promise(effect)) {
      resolvePromise(effect, currCb);
    } else if (iterator(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[IO]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === undefined) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = noop$1; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = noop$1; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = noop$1; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === undefined ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === undefined ? logError : _ref$onError;

  if (process.env.NODE_ENV !== 'production') {
    check(saga, func, NON_GENERATOR_ERR);
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(undefined, args);

  if (process.env.NODE_ENV !== 'production') {
    check(iterator$1, iterator, NON_GENERATOR_ERR);
  }

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || noop$1;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || noop$1;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || noop$1;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || noop$1;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || noop$1;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || noop$1;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (notUndef(dispatch)) {
      check(dispatch, func, 'dispatch must be a function');
    }

    if (notUndef(getState)) {
      check(getState, func, 'getState must be a function');
    }

    if (notUndef(effectMiddlewares)) {
      var MIDDLEWARE_TYPE_ERROR = 'effectMiddlewares must be an array of functions';
      check(effectMiddlewares, array$1, MIDDLEWARE_TYPE_ERROR);
      effectMiddlewares.forEach(function (effectMiddleware) {
        return check(effectMiddleware, func, MIDDLEWARE_TYPE_ERROR);
      });
    }

    check(onError, func, 'onError passed to the redux-saga is not a function!');
  }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = compose$1.apply(undefined, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = identity;
  }

  var env = {
    channel: channel,
    dispatch: wrapSagaDispatch(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, getMetaInfo(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = {} ,
      _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === undefined ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = _objectWithoutPropertiesLoose(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (process.env.NODE_ENV !== 'production') {
    check(channel, channel$1, 'options.channel passed to the Saga middleware is not a channel');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, _extends({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (process.env.NODE_ENV !== 'production' && !boundRunSaga) {
      throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    }

    return boundRunSaga.apply(undefined, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (process.env.NODE_ENV !== 'production') {
      check(props, object, createSetContextWarning('sagaMiddleware', props));
    }

    assignWithSymbols(context, props);
  };

  return sagaMiddleware;
}

var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if (channel$1(patternOrChannel)) {
    return 'channel';
  }

  if (stringableFunc(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (func(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return makeIterator(next, function (error) {
    return next(null, error);
  }, name);
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(undefined, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: cancel(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check(worker, notUndef, fn.name + " requires a saga parameter");
};
function takeLatest$1(patternOrChannel, worker) {
  if (process.env.NODE_ENV !== 'production') {
    validateTakeEffect(takeLatest$1, patternOrChannel, worker);
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return fork.apply(undefined, [takeLatest, patternOrChannel, worker].concat(args));
}

const SET_DATA = "SET_DATA";
const GET_DATA = "GET_DATA";
const set_data = (data) => ({
  type: SET_DATA,
  data
});

function requestdata() {
  return axios.request({
    method: "get",
    url: "https://dog.ceo/api/breeds/image/random"
  });
}

function* handledata(action) {
  try {
    const response = yield call(requestdata);
    const { data } = response;
    yield put(set_data(data));
  } catch (error) {
    console.log(error);
  }
}

function* watcherSaga() {
  yield takeLatest$1(GET_DATA, handledata);
}

const reducer = combineReducers$1({
  user: useReducer,
  appname: appReducer,
  config: configReducer,
  history: historyReducer
});
const sagaMiddleware = sagaMiddlewareFactory();
const middleware = [sagaMiddleware];
const store = createStore$1(reducer, {}, applyMiddleware$1(...middleware));
sagaMiddleware.run(watcherSaga);

const CopilotCommandExtention = (props) => {
  const linkRef = useRef(null);
  const [showContextualMenu, setShowContextualMenu] = useState(false);
  const onShowContextualMenu = useCallback((ev) => {
    ev.preventDefault();
    setShowContextualMenu(true);
  }, []);
  const onHideContextualMenu = useCallback(
    () => setShowContextualMenu(false),
    []
  );
  const menuStyles = {
    container: {
      position: "fixed"
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref: props.divRef,
      style: {
        position: "absolute",
        padding: "10px",
        borderRadius: "5px"
        //marginLeft: "60%",
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: onShowContextualMenu, className: "commandExtentionBlock", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: props.image, ref: linkRef, className: "CommandExtentionLogo" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { className: "commandExtentionDownArrow", iconName: "ChevronDown" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ContextualMenu,
          {
            items: props.menuItems,
            hidden: !showContextualMenu,
            target: linkRef,
            onItemClick: onHideContextualMenu,
            onDismiss: onHideContextualMenu,
            className: "commandExtentionMenu",
            styles: menuStyles
          }
        )
      ]
    }
  );
};

const MCAPSBotContext = React__default.createContext(null);
const useMCAPSBotContext = () => {
  return useContext(MCAPSBotContext);
};
const AppContextProvider = ({ mcapsBotContext, children }) => {
  const { width } = useWindowDimensions();
  const [isFullScreen, setIsFullScreen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(false);
  const isTeamsApp = mcapsBotContext.applicationNameForCopilot === "Teams" ? true : false;
  const copilotContent = {
    isFullScreen,
    setIsFullScreen,
    isMobile,
    zoomLevel,
    isTeamsApp,
    ...mcapsBotContext
  };
  useEffect(() => {
    setIsMobile(width <= 768);
    setZoomLevel(Math.round(window.devicePixelRatio * 100));
  }, [width]);
  useEffect(() => {
    if (isFullScreen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }, [isFullScreen]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotContext.Provider, { value: copilotContent, children });
};

// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage$1(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function isPlainObject$1(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/kindOf.ts
function miniKindOf(val) {
  if (val === undefined)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(2) : `Expected the root reducer to be a function. Instead, received: '${kindOf(reducer)}'`);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = undefined;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(1) : `Expected the enhancer to be a function. Instead, received: '${kindOf(enhancer)}'`);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(4) : `Expected the listener to be a function. Instead, received: '${kindOf(listener)}'`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(7) : `Actions must be plain objects. Instead, the actual type was: '${kindOf(action)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (typeof action.type !== "string") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(17) : `Action "type" property must be a string. Instead, the actual type was: '${kindOf(action.type)}'. Value was: '${action.type}' (stringified)`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(10) : `Expected the nextReducer to be a function. Instead, received: '${kindOf(nextReducer)}`);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(11) : `Expected the observer to be an object. Instead, received: '${kindOf(observer)}'`);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}

// src/utils/warning.ts
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}

// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!isPlainObject$1(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(undefined, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(12) : `The slice reducer for key "${key}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    }
    if (typeof reducer(undefined, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(13) : `The slice reducer for key "${key}" returned undefined when probed with a random type. Don't try to handle '${actionTypes_default.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (process.env.NODE_ENV !== "production") {
      if (typeof reducers[key] === "undefined") {
        warning(`No reducer provided for key "${key}"`);
      }
    }
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (process.env.NODE_ENV !== "production") {
    unexpectedKeyCache = {};
  }
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (process.env.NODE_ENV !== "production") {
      const warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(14) : `When called with an action of type ${actionType ? `"${String(actionType)}"` : "(unknown type)"}, the slice reducer for key "${key}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function isAction(action) {
  return isPlainObject$1(action) && "type" in action && typeof action.type === "string";
}

// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");

// src/utils/errors.ts
var errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(plugin) {
    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error, ...args) {
  if (process.env.NODE_ENV !== "production") {
    const e = errors[error];
    const msg = typeof e === "function" ? e.apply(null, args) : e;
    throw new Error(`[Immer] ${msg}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== undefined && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : undefined;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (process.env.NODE_ENV !== "production" && childValue === targetObject)
    die(5);
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : undefined;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== undefined || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== undefined || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== undefined || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (process.env.NODE_ENV !== "production" && isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, undefined);
};
arrayTraps.set = function(state, prop, value) {
  if (process.env.NODE_ENV !== "production" && prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : undefined;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return undefined;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return undefined;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== undefined && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, undefined);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === undefined)
          result = base;
        if (result === NOTHING)
          result = undefined;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, undefined);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(undefined, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);

// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

// src/index.ts
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return undefined;
  if (typeof arguments[0] === "object") return compose;
  return compose.apply(null, arguments);
};

// src/tsHelpers.ts
var hasMatchFunction = (v) => {
  return v && typeof v.match === "function";
};

// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "prepareAction did not return an object");
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  hasMatchFunction(action);
}

// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
  const splitType = type ? `${type}`.split("/") : [];
  const actionName = splitType[splitType.length - 1] || "actionCreator";
  return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  }
  const {
    isActionCreator: isActionCreator2 = isActionCreator
  } = options;
  return () => (next) => (action) => {
    if (isActionCreator2(action)) {
      console.warn(getMessage(action.type));
    }
    return next(action);
  };
}
function getTimeMeasureUtils(maxDelay, fnName) {
  let elapsed = 0;
  return {
    measureTime(fn) {
      const started = Date.now();
      try {
        return fn();
      } finally {
        const finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
      }
    }
  };
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function getOrInsertComputed(map, key, compute) {
  if (map.has(key)) return map.get(key);
  return map.set(key, compute(key)).get(key);
}

// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations() {
      return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
  const tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    for (const key in obj) {
      const childPath = path ? path + "." + key : key;
      if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
        continue;
      }
      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
  const prevObj = trackedProperty ? trackedProperty.value : undefined;
  const sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  const keysToDetect = {};
  for (let key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (let key in obj) {
    keysToDetect[key] = true;
  }
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (let key in keysToDetect) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result.wasMutated) {
      return result;
    }
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    let stringify2 = function(obj, serializer, indent, decycler) {
      return JSON.stringify(obj, getSerialize2(serializer, decycler), indent);
    }, getSerialize2 = function(serializer, decycler) {
      let stack = [], keys = [];
      if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
      };
      return function(key, value) {
        if (stack.length > 0) {
          var thisPos = stack.indexOf(this);
          ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
          ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
          if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
      };
    };
    let {
      isImmutable = isImmutableDefault,
      ignoredPaths,
      warnAfter = 32
    } = options;
    const track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return ({
      getState
    }) => {
      let state = getState();
      let tracker = track(state);
      let result;
      return (next) => (action) => {
        const measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
        measureUtils.measureTime(() => {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          if (result.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(19) : `A state mutation was detected between dispatches, in the path '${result.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        const dispatchedAction = next(action);
        measureUtils.measureTime(() => {
          state = getState();
          result = tracker.detectMutations();
          tracker = track(state);
          if (result.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(20) : `A state mutation was detected inside a dispatch, in the path: ${result.path || ""}. Take a look at the reducer(s) handling the action ${stringify2(action)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  }
}
function isPlain(val) {
  const type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject$1(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
  let foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache?.has(value)) return false;
  const entries = getEntries != null ? getEntries(value) : Object.entries(value);
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (const [key, nestedValue] of entries) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath,
        value: nestedValue
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (const nestedValue of Object.values(value)) {
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    const {
      isSerializable = isPlain,
      getEntries,
      ignoredActions = [],
      ignoredActionPaths = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths = [],
      warnAfter = 32,
      ignoreState = false,
      ignoreActions = false,
      disableCache = false
    } = options;
    const cache = !disableCache && WeakSet ? /* @__PURE__ */ new WeakSet() : undefined;
    return (storeAPI) => (next) => (action) => {
      if (!isAction(action)) {
        return next(action);
      }
      const result = next(action);
      const measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
      if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
        measureUtils.measureTime(() => {
          const foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
          if (foundActionNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundActionNonSerializableValue;
            console.error(`A non-serializable value was detected in an action, in the path: \`${keyPath}\`. Value:`, value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
          }
        });
      }
      if (!ignoreState) {
        measureUtils.measureTime(() => {
          const state = storeAPI.getState();
          const foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
          if (foundStateNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundStateNonSerializableValue;
            console.error(`A non-serializable value was detected in the state, in the path: \`${keyPath}\`. Value:`, value, `
Take a look at the reducer(s) handling this action type: ${action.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        });
        measureUtils.warnIfExceeded();
      }
      return result;
    };
  }
}

// src/getDefaultMiddleware.ts
function isBoolean(x) {
  return typeof x === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (immutableCheck) {
      let immutableOptions = {};
      if (!isBoolean(immutableCheck)) {
        immutableOptions = immutableCheck;
      }
      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
    }
    if (serializableCheck) {
      let serializableOptions = {};
      if (!isBoolean(serializableCheck)) {
        serializableOptions = serializableCheck;
      }
      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
    if (actionCreatorCheck) {
      let actionCreatorOptions = {};
      if (!isBoolean(actionCreatorCheck)) {
        actionCreatorOptions = actionCreatorCheck;
      }
      middlewareArray.unshift(createActionCreatorInvariantMiddleware(actionCreatorOptions));
    }
  }
  return middlewareArray;
};

// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10)
  ) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};

// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : undefined));
  }
  return enhancerArray;
};

// src/configureStore.ts
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = undefined,
    middleware,
    devTools = true,
    preloadedState = undefined,
    enhancers = undefined
  } = options;
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  }
  if (process.env.NODE_ENV !== "production" && middleware && typeof middleware !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "`middleware` field must be a callback");
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(finalMiddleware)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "when using a middleware builder function, an array of middleware must be returned");
    }
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "each middleware provided to configureStore must be a function");
  }
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: process.env.NODE_ENV !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  if (process.env.NODE_ENV !== "production" && enhancers && typeof enhancers !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "`enhancers` field must be a callback");
  }
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(storeEnhancers)) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "`enhancers` callback must return an array");
  }
  if (process.env.NODE_ENV !== "production" && storeEnhancers.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "each enhancer provided to configureStore must be a function");
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) {
    console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  }
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (actionMatchers.length > 0) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        }
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
        }
      }
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(28) : "`builder.addCase` cannot be called with an empty action type");
      }
      if (type in actionsMap) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${type}'`);
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
        }
      }
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(31) : "`builder.addDefaultCase` can only be called once");
        }
      }
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof mapOrBuilderCallback === "object") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
    }
  }
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = () => freezeDraftable(initialState());
  } else {
    const frozenInitialState = freezeDraftable(initialState);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === undefined) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === undefined) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}

// src/matchers.ts
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}

// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id = "";
  let i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: undefined,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg) {
      return (dispatch, getState, extra) => {
        const requestId = options?.idGenerator ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        const promise = async function() {
          let finalAction;
          try {
            let conditionResult = options?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, options?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}

// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
      if (options.initialState === undefined) {
        console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
      }
    }
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : "`context.addCase` cannot be called with an empty action type");
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + type);
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher, reducer2) {
        context.sliceMatchers.push({
          matcher,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer2) {
        context.sliceCaseReducersByName[name2] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      if (process.env.NODE_ENV !== "production") {
        if (typeof options.extraReducers === "object") {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
        }
      }
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = undefined] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m of actionMatchers) {
          builder.addMatcher(m.matcher, m.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getInitialState();
          } else if (process.env.NODE_ENV !== "production") {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "selectSlice returned undefined for an uninjected slice reducer");
          }
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, () => /* @__PURE__ */ new WeakMap());
        return getOrInsertComputed(selectorCache, selectState, () => {
          const map = {};
          for (const [name2, selector] of Object.entries(options.selectors ?? {})) {
            map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
          }
          return map;
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice = {
      name,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config);
        return {
          ...slice,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice;
  };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      } else if (process.env.NODE_ENV !== "production") {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "selectState returned undefined for an uninjected slice reducer");
      }
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return {
      _reducerDefinitionType: "asyncThunk" /* asyncThunk */,
      payloadCreator,
      ...config
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer" /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */,
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */;
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk);
  if (fulfilled) {
    context.addCase(thunk.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop,
    pending: pending || noop,
    rejected: rejected || noop,
    settled: settled || noop
  });
}
function noop() {
}

// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

class ApiService {
    constructor() {
    }

    async post(
        uri,
        data,
        getAdditionalHeaderCallback = () => {
        }
    ) {
        console.log('Question API: ', uri);
        const requestOptions = {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };
        const additionalHeaders = await getAdditionalHeaderCallback();
        if (additionalHeaders && typeof additionalHeaders === 'object' && Object.keys(additionalHeaders).length > 0) {
            Object.assign(requestOptions.headers, additionalHeaders);
        }
        const response = await axios.post(uri, data, requestOptions);
        if (response.status === 200) {
            return response.data;
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    }
}

const initialState$3 = {
    isLoading: false,
    error: null,
    answer: null,
};

const name$4 = "copilot";
const postQuestion = createAsyncThunk(name$4 + "/Question",
    async ({apiUrl, requestBody, getAdditionalHeaderCallback}, {dispatch}) => {
        dispatch(postQuestionBegin());
        try {
            const apiService = new ApiService();
            return await apiService.post(apiUrl, requestBody, getAdditionalHeaderCallback);
        } catch (err) {
            dispatch(postQuestionError(err));
        }
    }
);

const questionSlice = createSlice({
        name: name$4,
        initialState: initialState$3,
        reducers: {
            postQuestionBegin: (state) => {
                state.isLoading = true;
                state.error = null;
            },
            postQuestionError: (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            },
            clearQuestionState: (state) => {
                state.answer = null;
                state.error = null;
                state.isLoading = false;
            }
        },
        extraReducers: (builder) => {
            builder.addCase(postQuestion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.answer = action.payload;
            });
        }
    }
);

const {
    postQuestionBegin,
    postQuestionError,
    clearQuestionState
} = questionSlice.actions;

const initialState$2 = {
    history: [],
};
const name$3 = "copilot/conversationsHistory";
const conversationsHistorySlice = createSlice({
        name: name$3,
        initialState: initialState$2,
        reducers: {
            setConversationsHistory: (state, action) => {
                state.history = state.history.concat(action.payload);
            },
            resetConversationsHistory: (state) => {
                state.history = [];
            },
            updateConversationsHistory: (state, action) => {
                const message = action.payload;
                state.history = state.history.map(conversation =>
                    conversation.id === message.id ? message : conversation  
                );
                console.log("message", message);
                console.log(" state.history",  state.history);
            }
        }
    }
);
const {
    setConversationsHistory,
    resetConversationsHistory,
    updateConversationsHistory
} = conversationsHistorySlice.actions;

function useTrackCustomEvents() {
    const {userName, navigationLogURL, trackCustomEvents, appInsightConfig,applicationNameForCopilot} = useMCAPSBotContext();
    const trackCopilotEvent = useCallback((name, key, value, formState) => {
        const eventTypeResult = getEventTypeQuestionAnser(key, value, formState, eventType);
        const eventValues = JSON.stringify({
            userName: userName,
            conversationId: value?.conversationId,
            messageId: value?.botConversationId,
            PageName: navigationLogURL || "Home",
            applicationName: applicationNameForCopilot,
            type: eventTypeResult?.type,
            userQuestion: eventTypeResult?.userQuestion,
            botResponse: eventTypeResult?.botResponse,
        });
        setTimeout(() => {
            if (trackCustomEvents) {
                trackCustomEvents(name, key, eventValues);
                console.log("trackCustomEvents called: ", name, key, eventValues);
            } else {
                const appInsightObj = initializeAppInsights(appInsightConfig?.instrumentationKey);
                appInsightObj?.trackEvent({name: name, properties: {additionalInfo: eventValues}});
                console.log(" appInsightObj trackEvent called: ", {
                    name: name,
                    properties: {additionalInfo: eventValues}
                });
            }
        }, 200);
    }, []);
    return {trackCopilotEvent: trackCopilotEvent}
}

const MCAPSBotMessageContext = React__default.createContext(null);
const useMCAPSBotMessageContext = () => {
  return useContext(MCAPSBotMessageContext);
};
const MCAPSBotMessageContextProvider = ({ mcapsBotMessageContext, children }) => {
  const dispatch = useDispatch();
  const { maintainHistory, supportTicket, isHistoryFetched, setIsFullScreen, featureName } = useContext(MCAPSBotContext);
  let [conversations, setConversations] = useState([]);
  const { history } = useSelector((state) => state.conversationsHistory);
  const question = useSelector((state) => state.question);
  const { isLoading, answer, error } = question;
  const { trackCopilotEvent } = useTrackCustomEvents();
  const updateSupportTicketStyles = () => {
    setIsFullScreen(false);
    const style = document.createElement("style");
    style.textContent = `
          div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"] {
            left: -787px !important;
          }
          div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"] > div {
            box-shadow: none !important;
          }
        `;
    document.head.appendChild(style);
  };
  useEffect(() => {
    if (answer != null && answer.conversationId) {
      const conversation = {
        id: generateId(),
        from: "bot",
        type: "message",
        dateTime: getDateTime(),
        isFeedbackEnabled: true,
        isFeedbackUpvoted: null,
        ...answer
      };
      if (answer.responseType === "error" && answer?.data?.errorCode && answer?.data?.errorCode !== null && answer?.data?.errorCode !== undefined) {
        trackCopilotEvent(
          featureName + " Inquiry failed",
          "Inquiry failed",
          getQuesAns(answer)
        );
      } else {
        trackCopilotEvent(
          featureName + " Inquiry Started",
          "Inquiry Started",
          getQuesAns(answer)
        );
      }
      if (answer.responseType === "command" && answer.data && typeof answer.data == "string" && JSON.parse(answer.data).intent === "createsupportticket") {
        updateSupportTicketStyles();
        supportTicket();
      }
      setConversations((prevConversations) => [...prevConversations, { ...conversation }]);
      dispatch(setConversationsHistory(conversation));
      dispatch(clearQuestionState());
    }
  }, [answer, dispatch, supportTicket]);
  useEffect(() => {
    if (error) {
      const conversation = {
        id: generateId(),
        from: "bot",
        type: "message",
        dateTime: getDateTime(),
        responseType: "error",
        isFeedbackEnabled: false,
        isFeedbackUpvoted: null
      };
      trackCopilotEvent(featureName + " Inquiry failed", "Inquiry failed", getErrorResponse(error));
      setConversations((prevConversations) => [...prevConversations, { ...conversation }]);
      dispatch(setConversationsHistory(conversation));
      dispatch(clearQuestionState());
    }
  }, [dispatch, error]);
  useEffect(() => {
    if (history && history?.length > 0) {
      maintainHistory("SET", history);
    }
  }, [history, maintainHistory]);
  useEffect(() => {
    if (conversations?.length === 0 && maintainHistory !== "undefined" && isHistoryFetched) {
      const historyData = maintainHistory("GET")?.data;
      if (historyData) {
        try {
          const parsedData = JSON.parse(historyData);
          setConversations([...parsedData]);
        } catch (error2) {
          console.error("Error parsing JSON:", error2);
        }
      }
    }
  }, [isHistoryFetched, conversations, maintainHistory]);
  conversations = isHistoryFetched && conversations && conversations.length > 0 ? conversations : history || [];
  const messageContext = { ...mcapsBotMessageContext, conversations, setConversations, isLoading, error };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotMessageContext.Provider, { value: messageContext, children });
};

const MCAPSBotFormContext = createContext$1(null);
const useMCAPSBotFormContext = () => {
  return useContext(MCAPSBotFormContext);
};
const MCAPSBotFormContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.question);
  const { setConversations } = useMCAPSBotMessageContext();
  const { trackCopilotEvent } = useTrackCustomEvents();
  const {
    maxCharacterAllowed,
    isToggleVisible,
    getAdditionalHeaderCallback,
    apiUrls,
    promptsSuggestionsV2,
    additionalContextDetails,
    maintainHistory,
    isHistoryFetched,
    ocvData,
    getProjectTeamsData,
    IsSlashCommandEnabled,
    featureName
  } = useMCAPSBotContext();
  const [formState, setFormState] = useState({
    conversationId: generateId(),
    botConversationId: generateId(),
    sessionId: generateId(),
    parentId: "",
    isHistoryLoaded: false,
    // form state
    count: 0,
    maxCount: maxCharacterAllowed || 4e3,
    isToggleVisible: isToggleVisible || false,
    textareaChatValue: "",
    disableSend: true,
    audiobuttonmode: false,
    isSuggestionPopUpEnabled: false,
    showChangeTopic: false,
    textareaValue: "",
    conversationArray: [],
    messages: null,
    searchText: "",
    searchActive: false,
    searchIndex: 0,
    isSlashPromptVisible: false
  });
  const textareaRef = useRef(null);
  let recognition;
  let data = [];
  useEffect(() => {
    const isDisabledSend = formState?.textareaValue?.length === 0 || isLoading;
    setFormState((prevState) => {
      return {
        ...prevState,
        textareaChatValue: formState?.textareaValue,
        disableSend: isDisabledSend
      };
    });
    if (isDisabledSend) {
      textareaRef?.current?.focus();
    }
  }, [formState?.textareaValue, isLoading]);
  const onClearSearch = (textareaChatValue) => {
    setFormState((prevState) => {
      return {
        ...prevState,
        searchActive: false,
        isSlashPromptVisible: false,
        searchText: "",
        searchIndex: textareaChatValue.length
      };
    });
    onReset(getProjectTeamsData);
  };
  useEffect(() => {
    const { textareaChatValue, searchActive, searchIndex } = formState;
    if (textareaChatValue.trim() === "") {
      onClearSearch(textareaChatValue);
    } else if (textareaChatValue === "/") {
      setFormState((prevState) => {
        return {
          ...prevState,
          searchText: "",
          searchIndex: 0
        };
      });
      onReset(getProjectTeamsData);
    } else if (searchActive && searchIndex === 0) {
      let indexOfSlash = textareaChatValue.indexOf("/");
      let text = textareaChatValue.substring(indexOfSlash + 1);
      if (text.startsWith(" ") || text.endsWith("   ")) {
        onClearSearch(textareaChatValue);
        return;
      }
      setFormState((prevState) => {
        return {
          ...prevState,
          searchText: text
        };
      });
    } else if (searchActive && searchIndex > 0) {
      let tempText = "";
      if (searchIndex + 1 === textareaChatValue.length) {
        tempText = textareaChatValue.substring(searchIndex + 1);
        if (tempText.startsWith(" ") || tempText.endsWith("   ")) {
          onClearSearch();
          return;
        }
      } else {
        let indexOfSlash = textareaChatValue.indexOf("/", searchIndex);
        tempText = textareaChatValue.substring(indexOfSlash + 1);
        if (tempText.startsWith(" ") || tempText.endsWith("   ")) {
          onClearSearch(textareaChatValue);
          return;
        }
      }
      setFormState((prevState) => {
        return {
          ...prevState,
          searchText: tempText
        };
      });
    }
  }, [formState?.textareaChatValue]);
  const handleOnClickPrompt = (prompt) => {
    const questionLength = prompt?.length;
    questionLength <= formState?.maxCount;
    setFormState((prevState) => {
      return {
        ...prevState,
        count: questionLength <= formState?.maxCount ? prompt?.length : formState?.count,
        textareaChatValue: prompt,
        textareaValue: prompt
      };
    });
    textareaRef?.current?.focus();
  };
  const handleOnChange = (event, data2) => {
    const questionLength = data2?.value?.length;
    const isLessThenMaxCount = questionLength <= formState?.maxCount;
    setFormState((prevState) => {
      return {
        ...prevState,
        // disableSend: (questionLength > 0) ? false : true,
        count: questionLength <= formState?.maxCount ? data2?.value?.length : formState?.count,
        textareaChatValue: isLessThenMaxCount ? data2?.value : formState?.textareaChatValue,
        textareaValue: isLessThenMaxCount ? data2?.value : formState?.textareaValue
      };
    });
  };
  const handleKeyDown = (event) => {
    const { searchActive, textareaChatValue } = formState;
    if (event.key === "/") {
      if (!searchActive) {
        setFormState((prevState) => {
          return {
            ...prevState,
            searchActive: true,
            isSlashPromptVisible: true
          };
        });
        trackCopilotEvent(featureName + " Slash prompt invoked", "Slash prompt invoked", formState);
      }
    }
    if (event.key === "Escape") {
      if (searchActive) {
        onClearSearch(textareaChatValue);
      }
    }
  };
  const onReset = (getProjectTeamsData2) => {
    getProjectTeamsData2[0].onReset(getProjectTeamsData2);
  };
  const searchData = useMemo(() => {
    const { searchActive, searchText } = formState;
    if (searchActive && searchText.length > 3) {
      return searchText;
    } else if (searchActive && (searchText.length === 0 || searchText === "")) {
      onReset(getProjectTeamsData);
    }
    return "";
  }, [formState?.searchText, formState?.searchActive]);
  const onItemClick = (item, activeTab, searchString) => {
    const { textareaChatValue } = formState;
    let tempText = "";
    if (activeTab === getProjectTeamsData[0].itemKey) {
      let text = textareaChatValue.endsWith("/" + searchString) ? textareaChatValue.slice(0, -(searchString.length + 1)) : textareaChatValue;
      let projectProgramText = item?.IsProgram ? "Program ID " : "Project ID ";
      tempText = text + projectProgramText + item.ProjectId;
      let telemetrytext = item.ProjectName + "(" + projectProgramText + item.ProjectId + ")";
      trackCopilotEvent(featureName + " Slash prompt project selected", "Slash prompt project selected", formState, telemetrytext);
    }
    if (activeTab === getProjectTeamsData[1].itemKey) {
      let text = textareaChatValue.endsWith("/" + searchString) ? textareaChatValue.slice(0, -(searchString.length + 1)) : textareaChatValue;
      tempText = text + " " + item.email;
      let telemetrytext = item.name + "(" + item.email + ")";
      trackCopilotEvent(featureName + " Slash prompt teams selected", "Slash prompt teams selected", formState, telemetrytext);
    }
    setFormState((prevState) => {
      return {
        ...prevState,
        searchText: "",
        searchActive: false,
        textareaChatValue: tempText,
        searchIndex: tempText.length,
        isSlashPromptVisible: false
      };
    });
    onReset(getProjectTeamsData);
  };
  const handleAddQuestionToMessages = (question) => {
    const conversation = {
      id: generateId(),
      from: "user",
      type: "message",
      message: question,
      dateTime: getDateTime(),
      showNewConversation: false
    };
    setConversations((prevConversations) => [...prevConversations, { ...conversation }]);
    dispatch(setConversationsHistory(conversation));
  };
  const handleSendMessage = (question) => {
    const isFromSuggestion = promptsSuggestionsV2?.length > 0 && isQuestionExitInSuggestions(promptsSuggestionsV2, question);
    setFormState((prevState) => {
      return {
        ...prevState,
        disableSend: true,
        count: 0,
        textareaChatValue: "",
        textareaValue: ""
      };
    });
    const requestBody = JSON.stringify({
      question,
      parentId: isFromSuggestion ? "" : formState?.parentId,
      sessionId: formState.sessionId,
      conversationId: formState.conversationId,
      pid: additionalContextDetails?.pid || "",
      isProgram: additionalContextDetails?.isProgram === "True",
      pageLocation: additionalContextDetails?.pageLocation
    });
    const sendMessageParams = {
      apiUrl: apiUrls.questionApi,
      requestBody,
      getAdditionalHeaderCallback
    };
    handleAddQuestionToMessages(question);
    dispatch(postQuestion(sendMessageParams));
    ocvData && ocvData(true, null);
  };
  const clearConversation = () => {
    setFormState((prevState) => {
      return {
        ...prevState,
        disableSend: true,
        count: 0,
        textareaChatValue: "",
        conversationId: generateId(),
        parentId: ""
      };
    });
    maintainHistory("RESET");
    setConversations([]);
    dispatch(resetConversationsHistory());
  };
  const handleNewConversation = () => {
    setFormState((prevState) => {
      return {
        ...prevState,
        disableSend: true,
        count: 0,
        textareaChatValue: "",
        conversationId: generateId(),
        parentId: ""
      };
    });
    const conversation = {
      id: generateId(),
      type: "message",
      dateTime: getDateTime(),
      showNewConversation: true,
      separator: "NewConversation"
    };
    setConversations((prevConversations) => {
      if (prevConversations.length > 0) {
        const lastConversation = prevConversations[prevConversations.length - 1];
        if (lastConversation && lastConversation.separator === "NewConversation") {
          return prevConversations;
        } else {
          dispatch(setConversationsHistory(conversation));
          return [...prevConversations, { ...conversation }];
        }
      }
      return prevConversations;
    });
  };
  const handleRecognitionResult = (event) => {
    const newTranscript = event.results[0][0].transcript;
    data.push(newTranscript);
    setFormState((prevState) => {
      return {
        ...prevState,
        textareaChatValue: data.join(" "),
        count: data.join(" ").length,
        disableSend: false
      };
    });
  };
  const runSpeechRecognition = () => {
    setFormState((prevState) => {
      return {
        ...prevState,
        audiobuttonmode: true
      };
    });
    recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    recognition.onresult = handleRecognitionResult;
    recognition.start();
    recognition.continuous = true;
  };
  const handleStopRecognition = () => {
    setFormState((prevState) => {
      return {
        ...prevState,
        audiobuttonmode: false
      };
    });
    if (recognition) {
      recognition.stop();
    }
  };
  useEffect(() => {
    if (isHistoryFetched) {
      const isContextChanged = maintainHistory("GET")?.isContextChanged;
      if (isContextChanged) {
        clearConversation();
      }
    }
  }, [isHistoryFetched, maintainHistory]);
  const formContextValue = {
    textareaRef,
    formState,
    searchData,
    onReset,
    onItemClick,
    setFormState,
    handleOnClickPrompt,
    handleOnChange,
    handleKeyDown,
    handleSendMessage,
    clearConversation,
    handleNewConversation,
    runSpeechRecognition,
    handleStopRecognition
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotFormContext.Provider, { value: formContextValue, children });
};

const useStyles$4 = makeStyles({
    footerWarperContainer: {
        bottom: 0,
        left: 0,
        width: "100%",
    },
    footerContainer: {
        ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
        backgroundColor: tokens$2.colorNeutralBackground1Hover,
        padding: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    footer: {
        ...shorthands.padding(tokens$2.spacingVerticalL, tokens$2.spacingHorizontalL),
        padding: "0",
    },
    chatTextAreaContainer: {
        padding: "0",
    },
    chatTextArea: {
        backgroundColor: tokens$2.colorNeutralBackground1,
        "& input[type='text']:not(.ms-ComboBox-Input):not(.ms-TextField-fieldGroup>input)": {
            border: "none !important",
            fontSize: "14px",
        },
        "& textarea:not(.ms-TextField-fieldGroup>textarea)": {
            border: "none !important",
            fontSize: "14px",
        }
    },
    promptsButtonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
    },
    promptsButton: {
        padding: "0 12px 8px",
    },
    promptsContainer: {
        position: "relative",
    }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {};
function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$3;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$2 = freeGlobal || freeSelf || Function("return this")();
var _root = root$2;
var root$1$1 = _root;
var now$1 = function() {
  return root$1$1.Date.now();
};
var now_1 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var root$3 = _root;
var Symbol$2 = root$3.Symbol;
var _Symbol = Symbol$2;
var Symbol$1 = _Symbol;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
var nativeObjectToString$1 = objectProto$1.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto = Object.prototype;
var nativeObjectToString = objectProto.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var symbolTag = "[object Symbol]";
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1;
var baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject$1 = isObject_1, now = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce$1(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce$1;
var debounce = debounce_1, isObject = isObject_1;
var FUNC_ERROR_TEXT = "Expected a function";
function throttle(func, wait, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var throttle_1 = throttle;
var patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
  switch (refreshMode) {
    case "debounce":
      return debounce_1(resizeCallback, refreshRate, refreshOptions);
    case "throttle":
      return throttle_1(resizeCallback, refreshRate, refreshOptions);
    default:
      return resizeCallback;
  }
};
var isFunction = function(fn) {
  return typeof fn === "function";
};
var isSSR = function() {
  return typeof window === "undefined";
};
var isDOMElement = function(element) {
  return element instanceof Element || element instanceof HTMLDocument;
};
var createNotifier = function(onResize, setSize, handleWidth, handleHeight) {
  return function(_a) {
    var width = _a.width, height = _a.height;
    setSize(function(prev) {
      if (prev.width === width && prev.height === height) {
        return prev;
      }
      if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) {
        return prev;
      }
      if (onResize && isFunction(onResize)) {
        onResize(width, height);
      }
      return { width, height };
    });
  };
};
(
  /** @class */
  (function(_super) {
    __extends(ResizeDetector2, _super);
    function ResizeDetector2(props) {
      var _this = _super.call(this, props) || this;
      _this.cancelHandler = function() {
        if (_this.resizeHandler && _this.resizeHandler.cancel) {
          _this.resizeHandler.cancel();
          _this.resizeHandler = null;
        }
      };
      _this.attachObserver = function() {
        var _a2 = _this.props, targetRef = _a2.targetRef, observerOptions = _a2.observerOptions;
        if (isSSR()) {
          return;
        }
        if (targetRef && targetRef.current) {
          _this.targetRef.current = targetRef.current;
        }
        var element = _this.getElement();
        if (!element) {
          return;
        }
        if (_this.observableElement && _this.observableElement === element) {
          return;
        }
        _this.observableElement = element;
        _this.resizeObserver.observe(element, observerOptions);
      };
      _this.getElement = function() {
        var _a2 = _this.props, querySelector = _a2.querySelector, targetDomEl = _a2.targetDomEl;
        if (isSSR())
          return null;
        if (querySelector)
          return document.querySelector(querySelector);
        if (targetDomEl && isDOMElement(targetDomEl))
          return targetDomEl;
        if (_this.targetRef && isDOMElement(_this.targetRef.current))
          return _this.targetRef.current;
        var currentElement = findDOMNode(_this);
        if (!currentElement)
          return null;
        var renderType = _this.getRenderType();
        switch (renderType) {
          case "renderProp":
            return currentElement;
          case "childFunction":
            return currentElement;
          case "child":
            return currentElement;
          case "childArray":
            return currentElement;
          default:
            return currentElement.parentElement;
        }
      };
      _this.createResizeHandler = function(entries) {
        var _a2 = _this.props, _b = _a2.handleWidth, handleWidth = _b === undefined ? true : _b, _c = _a2.handleHeight, handleHeight = _c === undefined ? true : _c, onResize = _a2.onResize;
        if (!handleWidth && !handleHeight)
          return;
        var notifyResize = createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
        entries.forEach(function(entry) {
          var _a3 = entry && entry.contentRect || {}, width = _a3.width, height = _a3.height;
          var shouldSetSize = !_this.skipOnMount && !isSSR();
          if (shouldSetSize) {
            notifyResize({ width, height });
          }
          _this.skipOnMount = false;
        });
      };
      _this.getRenderType = function() {
        var _a2 = _this.props, render = _a2.render, children = _a2.children;
        if (isFunction(render)) {
          return "renderProp";
        }
        if (isFunction(children)) {
          return "childFunction";
        }
        if (isValidElement(children)) {
          return "child";
        }
        if (Array.isArray(children)) {
          return "childArray";
        }
        return "parent";
      };
      var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === undefined ? 1e3 : _a, refreshOptions = props.refreshOptions;
      _this.state = {
        width: undefined,
        height: undefined
      };
      _this.skipOnMount = skipOnMount;
      _this.targetRef = createRef();
      _this.observableElement = null;
      if (isSSR()) {
        return _this;
      }
      _this.resizeHandler = patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
      _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
      return _this;
    }
    ResizeDetector2.prototype.componentDidMount = function() {
      this.attachObserver();
    };
    ResizeDetector2.prototype.componentDidUpdate = function() {
      this.attachObserver();
    };
    ResizeDetector2.prototype.componentWillUnmount = function() {
      if (isSSR()) {
        return;
      }
      this.resizeObserver.disconnect();
      this.cancelHandler();
    };
    ResizeDetector2.prototype.render = function() {
      var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === undefined ? "div" : _b;
      var _c = this.state, width = _c.width, height = _c.height;
      var childProps = { width, height, targetRef: this.targetRef };
      var renderType = this.getRenderType();
      var typedChildren;
      switch (renderType) {
        case "renderProp":
          return render && render(childProps);
        case "childFunction":
          typedChildren = children;
          return typedChildren(childProps);
        case "child":
          typedChildren = children;
          if (typedChildren.type && typeof typedChildren.type === "string") {
            childProps.targetRef;
            var nativeProps = __rest(childProps, ["targetRef"]);
            return cloneElement(typedChildren, nativeProps);
          }
          return cloneElement(typedChildren, childProps);
        case "childArray":
          typedChildren = children;
          return typedChildren.map(function(el) {
            return !!el && cloneElement(el, childProps);
          });
        default:
          return React.createElement(WrapperTag, null);
      }
    };
    return ResizeDetector2;
  })(PureComponent)
);
var useEnhancedEffect = isSSR() ? useEffect : useLayoutEffect;
function useResizeDetector(props) {
  if (props === undefined) {
    props = {};
  }
  var _a = props.skipOnMount, skipOnMount = _a === undefined ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === undefined ? 1e3 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === undefined ? true : _c, _d = props.handleHeight, handleHeight = _d === undefined ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
  var skipResize = useRef(skipOnMount);
  var localRef = useRef(null);
  var ref = targetRef !== null && targetRef !== undefined ? targetRef : localRef;
  var resizeHandler = useRef();
  var _e = useState({
    width: undefined,
    height: undefined
  }), size = _e[0], setSize = _e[1];
  useEnhancedEffect(function() {
    if (isSSR()) {
      return;
    }
    var notifyResize = createNotifier(onResize, setSize, handleWidth, handleHeight);
    var resizeCallback = function(entries) {
      if (!handleWidth && !handleHeight)
        return;
      entries.forEach(function(entry) {
        var _a2 = entry && entry.contentRect || {}, width = _a2.width, height = _a2.height;
        var shouldSetSize = !skipResize.current && !isSSR();
        if (shouldSetSize) {
          notifyResize({ width, height });
        }
        skipResize.current = false;
      });
    };
    resizeHandler.current = patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
    var resizeObserver = new window.ResizeObserver(resizeHandler.current);
    if (ref.current) {
      resizeObserver.observe(ref.current, observerOptions);
    }
    return function() {
      resizeObserver.disconnect();
      var patchedResizeHandler = resizeHandler.current;
      if (patchedResizeHandler && patchedResizeHandler.cancel) {
        patchedResizeHandler.cancel();
      }
    };
  }, [refreshMode, refreshRate, refreshOptions, handleWidth, handleHeight, onResize, observerOptions, ref.current]);
  return __assign({ ref }, size);
}

var defaultBreakpoints = {
    xxxl: { width: 1920, items: 6 },
    xxl: { width: 1366, items: 4 },
    xl: { width: 1024, items: 4 },
    l: { width: 640, items: 2 },
    m: { width: 480, items: 2 },
    s: { width: 320, items: 1 }
};

var iconMap = {
    Add: AddRegular,
    AlignCenter: TextAlignCenterRegular,
    AlignLeft: TextAlignLeftRegular,
    AlignRight: TextAlignRightRegular,
    Back: ArrowLeftRegular,
    Bold: TextBoldRegular,
    Cancel: DismissRegular,
    Checkbox: CheckboxUncheckedRegular,
    Checkmark: CheckmarkRegular,
    ChevronDown: ChevronDownRegular,
    ChevronDownMed: ChevronDownRegular,
    ChevronLeft: ChevronLeftRegular,
    ChevronRight: ChevronRightRegular,
    ChevronUp: ChevronUpRegular,
    ChromeClose: DismissRegular,
    ClearFormatting: TextClearFormattingRegular,
    Clock: ClockRegular,
    Code: CodeRegular,
    Completed: CheckmarkCircleRegular,
    Contact: PersonRegular,
    DecreaseIndentLegacy: TextIndentDecreaseLtrRegular,
    Devices: PhoneLaptopRegular,
    Down: ArrowDownRegular,
    Edit: EditRegular,
    ErrorBadge: DismissCircleRegular,
    Filter: FilterRegular,
    Font: TextFontRegular,
    FontColor: TextColorRegular,
    FontSize: TextFontSizeRegular,
    FullScreen: ArrowMaximizeRegular,
    GlobalNavButton: NavigationRegular,
    Group: PeopleCommunityRegular,
    Headset: HeadsetRegular,
    Hide3: EyeOffRegular,
    Highlight: HighlightRegular,
    Home: HomeRegular,
    IncidentTriangle: WarningFilled,
    IncreaseIndentLegacy: TextIndentIncreaseLtrRegular,
    Info: InfoRegular,
    Italic: TextItalicRegular,
    Link: LinkSquareRegular,
    List: ListRegular,
    LockSolid: LockClosedFilled,
    More: MoreHorizontalRegular,
    NumberedList: TextNumberListLtrRegular,
    PaymentCard: PaymentRegular,
    Redo: ArrowRedoRegular,
    Refresh: ArrowClockwiseRegular,
    RightDoubleQuote: TextQuoteFilled,
    Save: SaveRegular,
    Settings: SettingsRegular,
    Strikethrough: TextStrikethroughRegular,
    Subscript: TextSubscriptRegular,
    Superscript: TextSuperscriptRegular,
    Underline: TextUnderlineRegular,
    Undo: ArrowUndoRegular,
    Unlock: LockOpenRegular,
    Up: ArrowUpRegular,
    View: EyeRegular,
    Warning: WarningRegular
};
var addIconPropsToObject = function (iconObject) {
    var iconName = iconObject === null || iconObject === undefined ? undefined : iconObject.iconName;
    if (iconObject && iconName) {
        var SvgIcon = iconMap[iconName];
        if (SvgIcon) {
            var name_1 = createName(iconName);
            iconObject.iconName = name_1;
            registerSvg(name_1, SvgIcon);
        }
    }
};
var createName = function (name) { return "".concat(name, "svg"); };
var registerSvg = function (name, SvgIcon) {
    var _a;
    if (!getIcon(name)) {
        registerIcons({
            icons: (_a = {},
                _a[name] = React__default.createElement(SvgIcon, { style: { transform: 'scale(1.2)' } }),
                _a)
        });
    }
};

var SvgIconButtonShim = function (_a) {
    var svgIconsEnabled = _a.svgIconsEnabled, Button = _a.buttonAs, rest = __rest$1(_a, ["svgIconsEnabled", "buttonAs"]);
    if (svgIconsEnabled) {
        var menuIconProps = rest.menuIconProps, iconProps = rest.iconProps;
        mutateIconProps({ menuIconProps: menuIconProps, iconProps: iconProps });
    }
    return React__default.createElement(Button, __assign$2({}, rest));
};
var mutateIconProps = function (_a) {
    var menuIconProps = _a.menuIconProps, iconProps = _a.iconProps;
    addIconPropsToObject(menuIconProps);
    addIconPropsToObject(iconProps);
};

var getSlides = function (arr, size) {
    if (!arr || !size)
        return [];
    return Array.from({ length: Math.ceil(arr.length / size) }, function (v, i) { return arr.slice(i * size, i * size + size); });
};
var getWindowSize = function (width, breakpoints) {
    var breakpoint = {
        width: width,
        items: 1
    };
    Object.values(breakpoints)
        .sort(function (a, b) { return b.width - a.width; })
        .every(function (b) {
        if (width >= b.width) {
            breakpoint = b;
            return false;
        }
        return true;
    });
    return breakpoint;
};

var getClassNames$1 = classNamesFunction();
var FeedCarouselBase = function (props) {
    var _a, _b;
    var styles = props.styles, theme = props.theme, width = props.width, cardsPerSlide = props.cardsPerSlide, responsive = props.responsive, itemWidth = props.itemWidth, prevItemAriaLabel = props.prevItemAriaLabel, nextItemAriaLabel = props.nextItemAriaLabel, _c = props.announceStartMessage, announceStartMessage = _c === undefined ? 'Showing cards' : _c;
    var classNames = getClassNames$1(styles, {
        theme: theme,
        responsive: responsive,
        cardsPerSlide: cardsPerSlide,
        itemWidth: itemWidth
    });
    var itemCount = props.items.length;
    var defaultItemWidth = itemWidth ? Math.floor(width / itemWidth) : 0;
    var defaultCardsPerSlide = itemWidth && !responsive ? (defaultItemWidth ? defaultItemWidth : 1) : cardsPerSlide;
    var _d = React__default.useState(itemCount <= defaultCardsPerSlide), isLastSlide = _d[0], setIsLastSlide = _d[1];
    var _e = React__default.useState(true), isFirstSlide = _e[0], setIsFirstSlide = _e[1];
    var _f = React__default.useState(0), currentSlide = _f[0], setCurrentSlide = _f[1];
    var _g = React__default.useState(0), scrollPosition = _g[0], setScrollPosition = _g[1];
    var _h = React__default.useState(0), lastNumFocus = _h[0], setLastNumFocus = _h[1];
    var translateScrollPosition = { transform: "translate(".concat(scrollPosition, "%, 0px)") };
    var firstCardIndex = currentSlide * defaultCardsPerSlide + 1;
    var lastCardIndex = Math.min((currentSlide + 1) * defaultCardsPerSlide, itemCount);
    var announcementMessage = "".concat(announceStartMessage, " ").concat(firstCardIndex, " to ").concat(lastCardIndex, " of ").concat(itemCount);
    var resetCarousel = function () {
        setScrollPosition(0);
        setIsFirstSlide(true);
        setCurrentSlide(0);
        setIsLastSlide(itemCount <= defaultCardsPerSlide);
    };
    React__default.useEffect(function () {
        resetCarousel();
    }, [defaultCardsPerSlide]);
    var cal = itemCount / defaultCardsPerSlide - 1;
    var numberOfSlides = Math.floor(Number.isInteger(cal) ? cal : cal + 1);
    var slideWidth = 100;
    var handleLeftClick = function () {
        if (currentSlide != 0) {
            var newSlide = currentSlide - 1;
            setIsLastSlide(false);
            setCurrentSlide(newSlide);
            setScrollPosition(scrollPosition + slideWidth);
            setIsFirstSlide(newSlide == 0);
        }
    };
    var handleRightClick = function () {
        if (currentSlide !== numberOfSlides) {
            var newSlide = currentSlide + 1;
            setIsFirstSlide(false);
            setCurrentSlide(newSlide);
            setScrollPosition(scrollPosition - slideWidth);
            setIsLastSlide(newSlide === numberOfSlides);
        }
    };
    var current = props.currentFocusElement ? props.currentFocusElement : 0;
    var carouselItemCount = defaultCardsPerSlide;
    if (lastNumFocus < current && current % carouselItemCount === 0) {
        handleRightClick();
        setLastNumFocus(current);
    }
    else if (lastNumFocus > current && (current + 1) % carouselItemCount === 0) {
        handleLeftClick();
        setLastNumFocus(current);
    }
    var slides = getSlides(props === null || props === undefined ? undefined : props.items, defaultCardsPerSlide);
    var defaultCardWidth = itemWidth ? itemWidth : defaultCardsPerSlide / 100;
    var widthOfItems = defaultCardsPerSlide * defaultCardWidth;
    var padding = width && !responsive ? (width - widthOfItems) / 2 : 0;
    var slideContainerStyles = {
        root: {
            width: "".concat(width, "px"),
            padding: "0 ".concat(padding, "px"),
            boxSizing: 'border-box'
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: classNames.headerContainer },
            React__default.createElement(Text$1, { as: 'h2', className: classNames.header }, props.header),
            React__default.createElement(Announced, { message: announcementMessage }),
            React__default.createElement("div", { className: (_a = classNames.supplementContainer) !== null && _a !== undefined ? _a : classNames.supplimentContainer },
                props.viewAllLink !== undefined && props.viewAllLink !== null && (React__default.createElement(Link, { as: 'a', className: classNames.viewAllLink, href: props.viewAllLink, onClick: props.viewAllOnClick }, (_b = props.viewAllText) !== null && _b !== undefined ? _b : "View all ".concat(itemCount))),
                itemCount && (React__default.createElement("div", { className: classNames.buttonContainer },
                    React__default.createElement(SvgIconButtonShim, { className: classNames.leftButton, svgIconsEnabled: theme === null || theme === undefined ? undefined : theme.svgIconsEnabled, buttonAs: IconButton, "data-testid": "".concat(props.header, "-leftArrow"), iconProps: { iconName: 'ChevronLeft' }, disabled: isFirstSlide, onClick: handleLeftClick, ariaLabel: prevItemAriaLabel !== null && prevItemAriaLabel !== undefined ? prevItemAriaLabel : 'Previous' }),
                    React__default.createElement(SvgIconButtonShim, { className: classNames.rightButton, svgIconsEnabled: theme === null || theme === undefined ? undefined : theme.svgIconsEnabled, buttonAs: IconButton, "data-testid": "".concat(props.header, "-rightArrow"), iconProps: { iconName: 'ChevronRight' }, disabled: isLastSlide, onClick: handleRightClick, ariaLabel: nextItemAriaLabel !== null && nextItemAriaLabel !== undefined ? nextItemAriaLabel : 'Next' }))))),
        React__default.createElement("div", { className: classNames.scrollContainer, "data-test-id": "carousel" },
            React__default.createElement("div", { className: classNames.scroll, style: translateScrollPosition },
                React__default.createElement(Stack, { horizontal: true, className: classNames.cardContainer, "aria-live": "polite" }, slides === null || slides === undefined ? undefined : slides.map(function (slide, index) {
                    return (React__default.createElement(StackItem, { className: classNames.slideContainer, key: index, styles: slideContainerStyles, "aria-hidden": index !== currentSlide },
                        React__default.createElement(StackItem, { className: classNames.slide, key: index }, slide.map(function (item, index2) { return (React__default.createElement(StackItem, { className: css(classNames.card), key: index2 }, item)); }))));
                }))))));
};

var actionButton = function (theme) {
    return {
        color: theme.palette.neutralPrimary,
        height: '24px',
        width: '24px',
        zIndex: '1',
        marginLeft: '24px',
        fontSize: FontSizes.size18,
        fontWeight: FontWeights.regular,
        selectors: {
            ':hover': {
                color: theme.palette.neutralPrimary
            },
            ':active, :focus': {
                color: theme.palette.neutralPrimary
            },
            '&.is-disabled': {
                background: 'transparent'
            }
        }
    };
};
var getStyles = function (props) {
    var theme = props.theme, responsive = props.responsive, cardsPerSlide = props.cardsPerSlide, itemWidth = props.itemWidth;
    return {
        buttonContainer: {
            display: 'flex',
            flex: '1',
            justifyContent: 'flex-end'
        },
        leftButton: actionButton(theme),
        rightButton: actionButton(theme),
        header: {
            color: theme.palette.neutralPrimary,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginTop: '0px',
            marginBottom: '0px',
            marginRight: '24px',
            paddingBottom: '1px',
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.semibold,
            selectors: {
                '@media screen and (max-width: 479px)': {
                    flex: 1,
                    whiteSpace: 'normal',
                    overflow: 'auto'
                }
            }
        },
        headerContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            lineHeight: '24px',
            alignItems: 'baseline',
            marginBottom: '24px',
            selectors: {
                '@media screen and (max-width: 479px)': {
                    display: 'block'
                }
            }
        },
        card: [
            {
                displayName: 'coher-CardItem',
                boxSizing: 'border-box',
                paddingLeft: '8px',
                paddingRight: '8px',
                width: "".concat(itemWidth, "px")
            },
            responsive && {
                width: "".concat(100 / cardsPerSlide, "%")
            }
        ],
        cardContainer: {
            display: 'flex',
            flexDirection: 'row'
        },
        slide: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 1,
                overflow: 'hidden',
                width: '100%'
            },
            responsive && {
                margin: '0 -8px'
            }
        ],
        slideContainer: {
            display: 'flex',
            flexDirection: 'row',
            overflow: 'hidden'
        },
        scroll: {
            flex: '1',
            display: 'flex',
            transition: 'transform 0.2s cubic-bezier(0.8,0,0.2,1) 0s'
        },
        scrollContainer: {
            overflow: 'hidden'
        },
        supplementContainer: {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            alignItems: 'baseline',
            lineHeight: '24px',
            marginTop: '0px',
            selectors: {
                '@media screen and (max-width: 479px)': {
                    marginLeft: '0px',
                    marginTop: '8px'
                }
            }
        },
        viewAllLink: {
            display: 'flex',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular
        }
    };
};

var FeedCarousel = styled(FeedCarouselBase, getStyles);

var getClassNames = classNamesFunction();
var CarouselBase = function (props) {
    var _a = useState(3), cardsPerSlide = _a[0], setCardsPerSlide = _a[1];
    var _b = props.breakpoints, breakpoints = _b === undefined ? defaultBreakpoints : _b, prevItemAriaLabel = props.prevItemAriaLabel, nextItemAriaLabel = props.nextItemAriaLabel;
    var onResize = useCallback(function (width) {
        if (width) {
            var cardItemsPerSlide = getWindowSize(width, breakpoints).items;
            setCardsPerSlide(cardItemsPerSlide);
        }
    }, []);
    var _c = useResizeDetector({
        onResize: onResize,
        refreshMode: 'throttle',
        refreshOptions: {
            trailing: true
        }
    }), width = _c.width, ref = _c.ref;
    var itemNo = useState(0)[0];
    var classNames = getClassNames(props.styles);
    var title = props.title, viewAllLink = props.viewAllLink, viewAllOnClick = props.viewAllOnClick, viewAllText = props.viewAllText, items = props.items, itemWidth = props.itemWidth, responsive = props.responsive;
    return (React__default.createElement("div", { className: classNames.container, ref: ref }, !!width && (React__default.createElement(FeedCarousel, { currentFocusElement: itemNo, header: title, viewAllLink: viewAllLink, viewAllOnClick: viewAllOnClick, viewAllText: viewAllText, items: items, width: width, cardsPerSlide: cardsPerSlide, responsive: responsive, itemWidth: itemWidth, prevItemAriaLabel: prevItemAriaLabel, nextItemAriaLabel: nextItemAriaLabel }))));
};

var getCarouselStyles = function (_props) {
    return {
        container: {
            width: '100%'
        }
    };
};

var Carousel = styled(CarouselBase, getCarouselStyles);

const useStyles$3 = makeStyles({
  card: {
    padding: "16px 20px",
    margin: "2px",
    gap: "8px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  cardTitleContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center"
  },
  title: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "600",
    margin: "0",
    color: `${tokens$2.colorNeutralForeground2LinkHover} !important`
  },
  description: {
    fontSize: "14px",
    lineHeight: "20px",
    height: "40px",
    lineClamp: 3,
    textOverflow: "ellipsis",
    overflow: "hidden",
    paddingBottom: "18px",
    margin: "0"
  },
  icon: {
    fontSize: "24px",
    color: tokens$2.colorBrandForegroundLink
  }
});
const CopilotPromptCard = ({ prompt, setShowPrompts, sectionName, promptSource }) => {
  const styles = useStyles$3();
  const { theme, featureName } = useMCAPSBotContext();
  const { handleOnClickPrompt, formState } = useMCAPSBotFormContext();
  const { trackCopilotEvent } = useTrackCustomEvents();
  const { suggestion, category } = prompt;
  const handleOnClick = () => {
    const question = {
      Question: suggestion,
      SectionName: sectionName,
      Category: category
    };
    handleOnClickPrompt(suggestion);
    let promptSourceText = promptSource === "ViewPrompt" ? "Prompt Library" : "Default Prompt";
    trackCopilotEvent(featureName + " " + promptSourceText + " Selected", promptSourceText + " Selected", formState, question);
    if (setShowPrompts && typeof setShowPrompts === "function") {
      setShowPrompts(false);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleOnClick();
    }
  };
  const iconsMap = {
    Act: /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentHeader20Regular, { className: styles.icon }),
    Catchup: /* @__PURE__ */ jsxRuntimeExports.jsx(MailRead20Regular, { className: styles.icon }),
    Learn: /* @__PURE__ */ jsxRuntimeExports.jsx(BookOpen20Regular, { className: styles.icon }),
    Analyze: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckmarkStarburst20Regular, { className: styles.icon }),
    Analyse: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckmarkStarburst20Regular, { className: styles.icon }),
    Prepare: /* @__PURE__ */ jsxRuntimeExports.jsx(Clipboard20Regular, { className: styles.icon })
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Card,
    {
      theme: theme === "dark" ? webDarkTheme : webLightTheme,
      onClick: handleOnClick,
      onKeyDown: handleKeyDown,
      className: styles.card,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.cardTitleContainer, children: [
          iconsMap[category] ? iconsMap[category] : /* @__PURE__ */ jsxRuntimeExports.jsx(ChatHelp20Regular, { className: styles.icon }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { className: styles.title, children: [
            " ",
            category
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.description, title: suggestion, children: suggestion })
      ]
    }
  );
};

const CopilotPromptSlider = ({ suggestions, sectionName, setShowPrompts, source }) => {
  const { theme, isFullScreen, zoomLevel } = useMCAPSBotContext();
  const { width } = useWindowDimensions();
  const renderPrompts = suggestions?.map((prompt) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotPromptCard, { prompt, setShowPrompts, sectionName, promptSource: source }, prompt.suggestion);
  });
  const carouselProps = {
    items: renderPrompts,
    title: sectionName,
    responsive: true,
    itemWidth: 220,
    height: "100%",
    wrap: true,
    styles: {
      container: {
        padding: "0px 0 16px 0",
        h2: {
          fontSize: "18px",
          lineHeight: "20px",
          fontWeight: "600",
          marginBottom: "12px",
          color: `${tokens$2.colorNeutralForeground2LinkHover} !important`
        },
        "& > div": {
          marginBottom: 0,
          span: {
            color: `${tokens$2.colorNeutralForeground2LinkHover} !important`
          }
        },
        buttonContainer: {
          zIndex: 0
        },
        button: {
          marginLeft: "8px"
        }
      }
    },
    theme: theme === "dark" ? webDarkTheme : webLightTheme,
    breakpoints: {
      xxxl: { width: 1805, items: 8 },
      xxl: { width: 1366, items: 6 },
      xl: { width: 1024, items: 3 },
      l: { width: 640, items: 3 },
      m: { width: 480, items: 2 },
      s: { width: 320, items: 1 }
    }
  };
  useEffect(() => {
  }, [width, isFullScreen, zoomLevel]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Carousel, { ...carouselProps });
};

const MCAPSBotPromptSliderContext = createContext$1(null);
const MCAPSBotPromptSliderContextProvider = ({ suggestions, children }) => {
  const { zoomLevel, slideToShowConfig = 3 } = useMCAPSBotContext();
  let noSlidesToScroll = suggestions?.length > slideToShowConfig ? slideToShowConfig : suggestions?.length;
  if (zoomLevel > 400) {
    noSlidesToScroll = 1;
  } else if (zoomLevel > 250) {
    noSlidesToScroll = 2;
  }
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(
    suggestions.length > slideToShowConfig ? false : true
  );
  const [totalSlide, setTotalSlide] = useState(suggestions.length);
  const [visitedSlide, setVisitedSlide] = useState(
    Math.min(noSlidesToScroll, suggestions.length)
  );
  let sliderRef = useRef(null);
  var settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: noSlidesToScroll,
    slidesToScroll: noSlidesToScroll,
    initialSlide: 0,
    accessibility: true,
    keyboard: true,
    /* responsive: [
         {
             breakpoint: 1024,
             settings: {
                 slidesToShow: 3,
                 slidesToScroll: 3,
                 infinite: true,
                 dots: true,
             },
         },
         {
             breakpoint: 600,
             settings: {
                 slidesToShow: 2,
                 slidesToScroll: 2,
                 initialSlide: 2,
             },
         },
         {
             breakpoint: 480,
             settings: {
                 slidesToShow: 1,
                 slidesToScroll: 1,
             },
         },
     ],*/
    afterChange: (index) => {
      setCurrentSlide(index);
      setIsFirstSlide(index === 0);
      const slidesToShow = noSlidesToScroll;
      const totalSlide2 = suggestions.length;
      let currentSlideIndex = index;
      const lastIndex = Math.min(
        currentSlideIndex + slidesToShow - 1,
        totalSlide2 - 1
      );
      setVisitedSlide(lastIndex + 1);
      setIsLastSlide(lastIndex === totalSlide2 - 1);
    }
  };
  const promptSliderContext = {
    settings,
    sliderRef,
    slideToShowConfig,
    noSlidesToScroll,
    currentSlide,
    setCurrentSlide,
    isFirstSlide,
    setIsFirstSlide,
    isLastSlide,
    setIsLastSlide,
    totalSlide,
    setTotalSlide,
    visitedSlide,
    setVisitedSlide
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotPromptSliderContext.Provider, { value: promptSliderContext, children });
};

const useStyles$2 = makeStyles({
  prompts: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens$2.spacingHorizontalS,
    margin: "0 auto",
    padding: 0,
    backgroundColor: tokens$2.colorNeutralBackground1Hover
  },
  promptHighlight: {
    color: tokens$2.colorBrandForegroundLink
  },
  promptsContainer: {
    backgroundColor: tokens$2.colorNeutralBackground1Hover,
    padding: 0,
    margin: 0
  },
  showMoreLink: {
    fontSize: "14px",
    textAlign: "center",
    display: "inline-block",
    width: "80px",
    margin: "20px auto",
    color: tokens$2.colorBrandForegroundLink
  },
  loading: {
    height: "120px",
    padding: "40px"
  }
});
const CopilotSuggestionPrompt = ({ setShowPrompts, source }) => {
  const styles = useStyles$2();
  const { theme, isFullScreen, promptsSuggestionsV2, suggestionsMapLoading } = useMCAPSBotContext();
  const [showMore, setShowMore] = useState(false);
  let suggestionsMap = promptsSuggestionsV2 || [];
  const promptsToShow = 3;
  suggestionsMap = suggestionsMap?.slice(0, showMore ? suggestionsMap?.length : promptsToShow);
  if (suggestionsMapLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.loading, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { label: loadingText }) });
  }
  const handleShowMoreFocus = () => {
    setTimeout(() => {
      const scrollableDiv = document.querySelector(".ms-Panel-scrollableContent");
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    }, 500);
  };
  const handleShowMore = () => {
    setShowMore(!showMore);
    handleShowMoreFocus();
  };
  const renderCopilotSuggestionPrompt = () => {
    if (suggestionsMap.length > 0) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FluentProvider,
        {
          theme: theme === "dark" ? webDarkTheme : webLightTheme,
          className: styles.prompts,
          children: [
            suggestionsMap?.length > 0 && suggestionsMap?.map(({ suggestions, sectionName }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              MCAPSBotPromptSliderContextProvider,
              {
                suggestions,
                styles: styles.promptsContainer,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  CopilotPromptSlider,
                  {
                    suggestions,
                    sectionName,
                    isFullScreen,
                    setShowPrompts,
                    source
                  }
                )
              },
              sectionName
            )),
            promptsSuggestionsV2?.length > promptsToShow && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: styles.showMoreLink, onClick: handleShowMore, onFocus: handleShowMoreFocus, children: showMore ? ShowLessText : ShowMoreText })
          ]
        }
      );
    }
    return null;
  };
  return renderCopilotSuggestionPrompt();
};

const FooterViewPrompts = ({ setShowPrompts }) => {
  const { theme } = useMCAPSBotContext();
  const copilotTheme = theme === "dark" ? webDarkTheme : webLightTheme;
  const titleId = useId$1("title");
  const hideModal = () => setShowPrompts(false);
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      width: "900px",
      overflowY: "hidden",
      borderRadius: "5px",
      backgroundColor: copilotTheme.colorNeutralBackground1Hover
    },
    header: [
      getTheme().fonts.xLargePlus,
      {
        flex: "1 1 auto",
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "0 0 14px 0"
      }
    ],
    heading: {
      color: getTheme().palette.neutralPrimary,
      fontWeight: FontWeights.semibold,
      fontSize: "18px",
      margin: "18px 0 0 18px"
    },
    promptContainter: {
      padding: "0 18px"
    }
  });
  const iconButtonStyles = {
    root: {
      color: getTheme().palette.neutralPrimary,
      margin: "18px 18px 0 auto "
    },
    rootHovered: {
      color: getTheme().palette.neutralDark
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      theme: getTheme(),
      titleAriaId: titleId,
      isOpen: true,
      onDismiss: hideModal,
      isBlocking: false,
      containerClassName: contentStyles.container,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: contentStyles.header, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: contentStyles.heading, id: titleId, children: "Suggested prompts" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              styles: iconButtonStyles,
              iconProps: { iconName: "Cancel" },
              ariaLabel: "Close popup modal",
              onClick: hideModal
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: contentStyles.promptContainter, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotSuggestionPrompt, { setShowPrompts, source: "ViewPrompt" }) })
      ]
    }
  );
};

initializeIcons();
const generateStyles = (theme) => {
  const { fonts } = theme;
  return mergeStyleSets({
    itemCell: [
      getFocusStyle(theme, { inset: -1 }),
      {
        minHeight: 30,
        padding: 10,
        boxSizing: "border-box",
        // borderBottom: `1px solid ${semanticColors.bodyDivider}`,
        display: "flex",
        alignItems: "center",
        borderRadius: 5,
        selectors: {
          "&:hover": { background: "#f3f2f1" }
        }
      }
    ],
    itemImage: {
      flexShrink: 0,
      paddingTop: 5,
      border: "1px solid #FFFFFF"
    },
    itemContent: {
      marginLeft: 10,
      overflow: "hidden",
      flexGrow: 1,
      color: "rgb(50, 49, 48)"
    },
    itemName: [
      fonts.medium,
      {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    ],
    itemIndex: {
      fontSize: 10,
      color: "rgb(96, 94, 92)"
    },
    calloutContainer: {
      height: "280px"
    },
    pivotItem: {
      borderTop: "1px solid rgb(237, 235, 233)"
    },
    pivotHeader: {
      padding: "10px"
    },
    activePivotItem: {},
    teamItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px"
    },
    projectItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px"
    },
    allItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "10px"
    },
    listContainer: {
      overflowY: "auto",
      height: "220px"
    },
    noDataFoundContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "220px"
    },
    noDataFoundText: {
      color: "rgb(50, 49, 48)"
    }
  });
};
const CopilotSlashPrompt = () => {
  const { theme, isFullScreen, isMobile, isToggled, maxWidth = "1024px", featureName, getProjectTeamsData, IsSlashCommandEnabled } = useMCAPSBotContext();
  const {
    searchData,
    onItemClick
  } = useMCAPSBotFormContext();
  const Fluenttheme = useTheme$1();
  const classNames = useMemo(() => generateStyles(Fluenttheme), [Fluenttheme]);
  const [activeTab, setActiveTab] = useState(getProjectTeamsData[0].itemKey);
  const pivotTypes = getProjectTeamsData;
  const [searchString, setSearchString] = useState("");
  const debounce = (func, delay) => {
    let debounceTimer;
    return function(...args) {
      const context = this;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };
  const debouncedSearch = useCallback(debounce((searchData2, getProjectTeamsData2) => {
    let activeTabData = getProjectTeamsData2.find((item) => item.itemKey === activeTab);
    activeTabData.onSearch(searchData2, getProjectTeamsData2);
    setSearchString(searchData2);
  }, 1e3), []);
  useEffect(() => {
    if (searchData && searchData.length >= 4) {
      console.log("searchData", searchData);
      debouncedSearch(searchData, getProjectTeamsData);
    }
  }, [searchData, debouncedSearch]);
  const handleTabChange = (item) => {
    setActiveTab(item.props.itemKey);
  };
  const handleItemClick = (data) => {
    onItemClick(data, activeTab, searchString);
  };
  const getItems = (itemKey, items) => {
    switch (itemKey) {
      case "Project":
        return items?.map((project2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames.itemCell, "data-is-focusable": true, onClick: () => handleItemClick(project2), tabIndex: 0, onKeyDown: (e) => {
          if (e.keyCode === 13) handleItemClick(project2);
        }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Image$2,
            {
              className: classNames.itemImage,
              src: project2.IsProgram ? Program : Project,
              width: 28,
              height: 28,
              imageFit: ImageFit.contain,
              alt: project2.IsProgram ? "Program" : "Project"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames.itemContent, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.itemName, children: project2.ProjectName }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames.itemIndex, children: [
              project2.IsProgram ? "Program ID: " : "Project ID: ",
              project2.ProjectId
            ] })
          ] })
        ] }));
      case "Team":
        return items?.map((team) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.itemCell, "data-is-focusable": true, onClick: () => handleItemClick(team), tabIndex: 0, onKeyDown: (e) => {
          if (e.keyCode === 13) handleItemClick(project);
        }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Persona,
          {
            imageInitials: getInitials$1(team.name),
            text: team.name,
            secondaryText: team.email,
            showSecondaryText: true,
            size: PersonaSize.size32,
            presence: PersonaPresence$1.none
          }
        ) }));
      default:
        return [];
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FluentProvider,
    {
      theme: theme === "dark" ? webDarkTheme : webLightTheme,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Callout,
        {
          className: classNames.calloutContainer,
          target: `#footer-textarea`,
          isBeakVisible: false,
          directionalHint: DirectionalHint.topCenter,
          gapSpace: 5,
          styles: {
            root: {
              width: isFullScreen && !isMobile ? maxWidth : "766px"
            }
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Pivot, { onLinkClick: handleTabChange, children: pivotTypes.map((pivotType) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            PivotItem,
            {
              onRenderItemLink: () => {
                return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.pivotHeader, children: pivotType.headerText });
              },
              itemKey: pivotType.itemKey,
              className: mergeClasses(classNames.pivotItem, activeTab === pivotType.itemKey && classNames.activePivotItem),
              children: pivotType.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.noDataFoundContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { label: "Loading...", ariaLive: "assertive", labelPosition: "right" }) }) : pivotType.items && pivotType.items.length !== 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.listContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                List,
                {
                  items: getItems(pivotType.itemKey, pivotType.items),
                  onRenderCell: (item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.listItem, children: item }, index)
                }
              ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames.noDataFoundContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { variant: "large", block: true, children: "No results found." }) })
            }
          )) })
        }
      )
    }
  );
};

const FooterChatInput = () => {
  const styles = useStyles$4();
  const tooltipId = useId$1("tooltip");
  const [showPrompts, setShowPrompts] = useState(false);
  const { trackCopilotEvent } = useTrackCustomEvents();
  const { theme, isFullScreen, isMobile, isToggled, maxWidth = "1024px", featureName, getProjectTeamsData, IsSlashCommandEnabled } = useMCAPSBotContext();
  const {
    textareaRef,
    formState,
    handleOnChange,
    handleKeyDown,
    runSpeechRecognition,
    handleStopRecognition,
    handleSendMessage
  } = useMCAPSBotFormContext();
  const tempFormState = { ...formState };
  const {
    count,
    maxCount,
    disableSend,
    textareaChatValue,
    isPromptVisible,
    isToggleVisible,
    isSlashPromptVisible
  } = formState;
  const Count = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
    count,
    "/",
    maxCount
  ] });
  const handlePromptSuggestions = () => {
    trackCopilotEvent(featureName + " View Prompt Invoked", "View Prompt Invoked", tempFormState);
    setShowPrompts(true);
  };
  const ContentAfter = isToggleVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        "aria-label": "voice-input",
        role: "button",
        appearance: "transparent",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Mic20Regular, {}),
        disabled: !isToggled,
        onMouseDown: runSpeechRecognition,
        onMouseUp: handleStopRecognition,
        onMouseLeave: handleStopRecognition,
        title: "hold and speak"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: { margin: "0 4px" }, vertical: true })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FluentProvider,
    {
      theme: theme === "dark" ? webDarkTheme : webLightTheme,
      className: styles.footerContainer,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        CopilotProvider,
        {
          mode: "sidecar",
          className: styles.footer,
          style: { width: isFullScreen && !isMobile ? maxWidth : "766px" },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.promptsButtonContainer, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button,
                {
                  "aria-label": promptsButton.labelText,
                  appearance: promptsButton.appearance,
                  className: styles.promptsButton,
                  icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Book20Regular, {}),
                  onClick: handlePromptSuggestions,
                  role: promptsButton.role,
                  "aria-describedby": tooltipId,
                  children: promptsButton.labelText
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.promptsContainer, children: showPrompts && /* @__PURE__ */ jsxRuntimeExports.jsx(FooterViewPrompts, { setShowPrompts }) })
            ] }),
            IsSlashCommandEnabled && isSlashPromptVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotSlashPrompt, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.chatTextAreaContainer, id: "footer-textarea", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Textarea,
              {
                ref: textareaRef,
                className: styles.chatTextArea,
                role: "textbox",
                showCount: true,
                count: /* @__PURE__ */ jsxRuntimeExports.jsx(Count, {}),
                rows: 7,
                cols: 5,
                maxLength: maxCount,
                onChange: handleOnChange,
                onKeyDown: handleKeyDown,
                onSubmit: () => handleSendMessage(textareaChatValue),
                disableSend,
                value: textareaChatValue,
                send: { role: "button", "aria-label": "send", title: "send" },
                style: {
                  maxWidth: "none",
                  marginRight: 0,
                  marginTop: isPromptVisible ? "0px" : "2px",
                  height: isFullScreen && !isMobile ? "118px" : !isFullScreen && !isMobile ? "118px" : "70px"
                },
                contentAfter: ContentAfter,
                "aria-label": "Copilot Chat",
                placeholder: askQuestion
              }
            ) })
          ]
        }
      )
    }
  );
};

const CopilotFooter = () => {
  const className = useStyles$4();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: className.footerWarperContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FooterChatInput, {}) });
};

const useBrandStyles = makeStyles({
    headerBrandContainer: {
        margin: "0 auto",
        alignItems: "center",
    },
    headerBrandInnerContainer: {
        display: "flex",
        justifyContent: "center",
        padding: "18px 0 16px",
    },
    headerLogoContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageTag: {
        height: "48px",
        width: "48px",
    },
    headTag: {
        fontFamily: "Segoe UI",
        fontSize: "40px",
        fontWeight: 600,
        padding: "0 0 0 16px !important",
        margin: "0 !important",
        color:`${tokens$2.colorNeutralForeground2LinkHover} !important`,
        display: "flex",
        alignItems: "center",
    },
    headerSubTitle: {
        fontFamily: "Segoe UI",
        fontSize: "20px",
        color:`${tokens$2.colorNeutralForeground2LinkHover} !important`,
        textAlign: "center",
        paddingBottom: '12px',
        display: "block"
    },
    headerButtonsContainer: {
        display: "flex",
        justifyContent: "flex-end",
        padding: 0,
        margin: 0,
    },
    buttonArea: {
        top: "16px",
        right: "8px",
        position: "fixed",
        "@media (minResolution: 350dpi)": {
            top: "3px",
            right: "5px",
            position: "fixed",
        }
    },
    headerButton: {
        fontSize: "18px",
        margin: "0 2px",
        backgroundColor: "none",
        border: "none !important",
    },
    headerButtonIcon: {
        height: "20px",
        width: "20px",
    }
});

const HeaderBrand = () => {
  const styles = useBrandStyles();
  const {
    theme,
    image,
    featureName,
    applicationDescription
  } = useMCAPSBotContext();
  const textStyle = theme === "dark" ? "#fff" : "#222";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.headerBrandContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.headerBrandInnerContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.headerLogoContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          src: image,
          alt: headerSubTitle,
          className: styles.imageTag
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: styles.headTag, style: { color: textStyle }, children: featureName })
    ] }),
    applicationDescription && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { variant: "large", className: styles.headerSubTitle, style: { color: textStyle }, children: applicationDescription })
  ] });
};

const headerButtonsStyles = makeStyles({
    headerButtonsContainer: {
        display: "flex",
        alignItems: "center",
    },
    buttonArea: {
        "@media (min-resolution: 350dpi)": {
            top: "3px",
            right: "6px",
        }
    },
    headerButton: {
        fontSize: "18px",
        margin: "0 2px",
        border: "none !important",
        backgroundColor: tokens$2.colorNeutralBackground1Hover,

    },
    headerButtonIcon: {
        fontWeight: "400",
        backgroundColor: "none !important",
        height: "20px",
        width: "20px",
        color: tokens$2.colorNeutralBackgroundInverted,
        transition: "transform 0.3s ease",
        ':hover': {
            transform: "scale(1.2)",
        },
    }
});

const HeaderButtons = () => {
  const { trackCopilotEvent } = useTrackCustomEvents();
  const styles = headerButtonsStyles();
  const {
    handleToggleChange,
    setIsFullScreen,
    isToggleVisible,
    isFullScreen,
    isToggled,
    closeBot,
    featureName,
    isHostedOnTeamsPlatform,
    isTeamsApp
  } = useMCAPSBotContext();
  const { clearConversation, formState } = useMCAPSBotFormContext();
  const closeCopilotChatBot = () => {
    trackCopilotEvent(featureName + " Closed", "Closed", formState);
    closeBot();
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  };
  const handleKeyDown = (event, purpose) => {
    if (event.key === "Enter") {
      switch (purpose) {
        case "ToggleAudio":
          handleToggleChange(event, event.target.checked);
          break;
        case "ExpandCollapse":
          setIsFullScreen(!isFullScreen);
          break;
        case "Close":
          closeCopilotChatBot();
          break;
        case "NewChat":
          clearConversation();
          trackCopilotEvent(featureName + " New Conversation", "New Conversation", formState);
          break;
      }
    }
  };
  const TeamsHeaderButton = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.teamsHeaderButtonContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        title: "New Chat",
        tabIndex: 0,
        onClick: () => {
          clearConversation();
          trackCopilotEvent(featureName + " New Conversation", "New Conversation", formState);
        },
        onKeyDown: (event) => handleKeyDown(event, "NewChat"),
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ChatAddRegular, {}),
        role: "button",
        "aria-label": newConversation,
        children: "New Chat"
      }
    ) });
  };
  return isTeamsApp ? /* @__PURE__ */ jsxRuntimeExports.jsx(TeamsHeaderButton, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.headerButtonsContainer, children: [
    isToggleVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Toggle,
      {
        title: isToggled ? "Toggle audio off" : "Toggle audio on",
        styles: {
          root: {
            cursor: "pointer",
            border: "0.5px solid #000",
            borderRadius: "20px",
            width: "25%"
          },
          main: {
            width: "25%"
          }
        },
        checked: isToggled,
        onChange: handleToggleChange,
        onKeyDown: (event) => handleKeyDown(event, "ToggleAudio"),
        tabIndex: 0,
        role: "button",
        "aria-label": "toggle audio"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.buttonArea, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          title: newConversation,
          tabIndex: 0,
          onClick: () => {
            clearConversation();
            trackCopilotEvent(featureName + " New Conversation", "New Conversation", formState);
          },
          onKeyDown: (event) => handleKeyDown(event, "NewChat"),
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ChatAddRegular, { className: styles.headerButtonIcon }),
          role: "button",
          "aria-label": newConversation,
          className: styles.headerButton
        }
      ),
      !isHostedOnTeamsPlatform && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        !isFullScreen ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            "aria-label": "Expand",
            className: styles.headerButton,
            title: "Expand",
            role: "button",
            tabIndex: 0,
            onClick: () => setIsFullScreen(!isFullScreen),
            onKeyDown: (event) => handleKeyDown(event, "ExpandCollapse"),
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowMaximizeRegular, { className: styles.headerButtonIcon })
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            title: "Collapse",
            name: "Colapse",
            role: "button",
            onKeyDown: (event) => handleKeyDown(event, "ExpandCollapse"),
            onClick: () => setIsFullScreen(!isFullScreen),
            tabIndex: 0,
            "aria-label": "Colapse",
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowMinimizeRegular, { className: styles.headerButtonIcon }),
            className: styles.headerButton
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            className: styles.headerButton,
            title: "Close",
            role: "button",
            onClick: closeCopilotChatBot,
            onKeyDown: (event) => handleKeyDown(event, "Close"),
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(DismissRegular, { className: styles.headerButtonIcon }),
            "aria-label": "Close",
            tabIndex: 0
          }
        )
      ] })
    ] })
  ] });
};

const copilotHeaderStyles = {
    copilotCompactHeaderContainer: {
        position: "relative",
        width: "100%",
        display: "flex",
        overFlow: "none",
        zIndex: "1000 !important",
    },
    copilotCompactHeaderInnerContainer: {
        width: "100%",
        display: "flex",
        backgroundColor: tokens$2.colorNeutralBackground1Hover,
        padding: "0",
        zIndex: "1001 !important",
    },
    copilotWideHeaderContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: tokens$2.colorNeutralBackground1Hover,
    },
    copilotWideHeaderRightContainer: {
        top: "30px",
        right: "18px",
        position: "absolute",
    },
    copilotHeaderInnerContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "fixed !important",
        width: "95%",
        height: "40px",
        zIndex: 1,
        padding: "5px 10px"
    },
    copilotCompactLeftSection: {
        padding: "10px 18px",
        display: "flex",
        alignItems: "center",
        "@media (min-resolution: 350dpi)": {
            padding: "0px !important",
        },
    },
    copilotCompactImageTag: {
        display: "flex",
        alignItems: "center",
        marginRight: "10px",
        height: "24px",
        width: "24px",
        "@media (min-resolution: 420dpi)": {
           margin: "0 10px !important",
        },
    },
    copilotCompactHeadTag: {
        display: "flex",
        alignItems: "center !important",
        fontSize: "16px !important",
        fontWeight: 500,
        color: tokens$2.colorNeutralBackgroundInverted,
        padding: "0 !important",
        margin: "0 !important",
    },
    compactHeaderRightSection: {
        display: "flex",
        alignItems: "normal !important",
        justifyContent: "flex-end",
        padding: "10px 18px",
        flexGrow: 1,
        "@media (min-resolution: 350dpi)": {
            padding: "0px !important",
            "& selectors": {
                "& button": {
                    maxWidth: "16px !important",
                    minWidth: "16px !important",
                }
            },
        },
    },
    copilotTeamsHeaderContainer: {
        display: "flex",
        alignItems: "center",
        backgroundColor: tokens$2.colorNeutralBackground1Hover,
        paddingBottom: "10px",
    },
    copilotTeamHeaderRightContainer: {
        display: "flex",
        justifyContent: "flex-end",
        width: "1024px",
        margin: "10px auto 0",
    },
};

const useCopilotHeaderStyles = makeStyles(copilotHeaderStyles);

const CopilotHeader = () => {
  const {
    theme,
    isFullScreen,
    isMobile,
    featureName,
    image,
    isTeamsApp
  } = useMCAPSBotContext();
  const styles = useCopilotHeaderStyles();
  const textStyle = theme === "dark" ? "#fff" : "#222";
  const { conversations } = useMCAPSBotMessageContext();
  const CompactHeader = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FluentProvider,
      {
        theme: theme === "dark" ? webDarkTheme : webLightTheme,
        className: styles.copilotCompactHeaderContainer,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: styles.copilotCompactHeaderInnerContainer,
            style: { boxShadow: isFullScreen ? tokens$2.shadow2 : null },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.copilotCompactLeftSection, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Image$2, { src: image, alt: "Icon Image", className: styles.copilotCompactImageTag }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: styles.copilotCompactHeadTag, style: { color: textStyle }, children: [
                  " ",
                  featureName,
                  " "
                ] })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.compactHeaderRightSection, children: /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderButtons, {}) })
            ]
          }
        )
      }
    );
  };
  const WideHeader = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      FluentProvider,
      {
        theme: theme === "dark" ? webDarkTheme : webLightTheme,
        className: styles.copilotWideHeaderContainer,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderBrand, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.copilotWideHeaderRightContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderButtons, {}) })
        ]
      }
    );
  };
  const TeamsHeader = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FluentProvider,
      {
        theme: theme === "dark" ? webDarkTheme : webLightTheme,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.copilotTeamsHeaderContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.copilotTeamHeaderRightContainer, children: [
          conversations.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderBrand, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderButtons, {})
        ] }) })
      }
    );
  };
  const renderHeader = () => isTeamsApp ? /* @__PURE__ */ jsxRuntimeExports.jsx(TeamsHeader, {}) : isFullScreen && !isMobile && conversations.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(WideHeader, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(CompactHeader, {});
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.copilotHeaderContainer, children: renderHeader() });
};

const useChatbotLoadingStyles = makeStyles({
    chatbotLoadingContainer: {
        padding: "20px 18px",
        margin: "0 4px",
    },
    chatbotLoading: {
        padding: "18px 8px"
    }
});

const useCopilotMessageHeadingStyles = makeStyles({
        copilotMessageHeading: {
            display: "flex",
            justifyContent: "left",
            width: "100%",
            padding: "0",
            margin: "0",
        },
        applicationName: {
            fontSize: "16px",
            fontWeight: "600",
            padding: "0 10px",
        },
        copilotMessageContainer: {
            width: "100%",
        },
        // Graph Styles
        graphContainer: {
            width: "100%",
            display: "block",
        }

    }
);

const CopilotMessageHeading = () => {
  const styles = useCopilotMessageHeadingStyles();
  const { image, featureName } = useMCAPSBotContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.copilotMessageHeading, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Image$1, { src: image, height: 22, width: 22 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { className: styles.applicationName, children: featureName }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AiGeneratedDisclaimer, { children: "AI-generated content may be incorrect" })
  ] });
};

const ChatbotLoading = () => {
  const styles = useChatbotLoadingStyles();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(OutputCard, { className: styles.chatbotLoadingContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotMessageHeading, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ProgressIndicator$1, { className: styles.chatbotLoading, label: "Loading..." })
  ] });
};

/**
 * Classifies messages into Today, Yesterday, and Older based on their dateTime.
 * @param {Array} messages - Array of messages with dateTime field.
 * @returns {Object} - Classified messages with "today", "yesterday", and "older" categories.
 */

const classifyMessagesByDate = (messages) => {
    const today = hooks();
    const yesterday = hooks().subtract(1, 'days');

    const classifiedMessages = {
        todayConversations: [],
        yesterdayConversations: [],
        olderConversations: []
    };

    messages?.forEach((msg) => {
        const messageDate = hooks(msg.dateTime, 'YYYY-MM-DD HH:mm:ss');

        if (messageDate.isSame(today, 'day')) {
            classifiedMessages.todayConversations.push(msg);
        } else if (messageDate.isSame(yesterday, 'day')) {
            classifiedMessages.yesterdayConversations.push(msg);
        } else {
            classifiedMessages.olderConversations.push(msg);
        }
    });

    return {...classifiedMessages};
};

/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */

/** @type {SchemaType} */
let Schema$1 = class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(property, normal, space) {
    this.normal = normal;
    this.property = property;

    if (space) {
      this.space = space;
    }
  }
};

Schema$1.prototype.normal = {};
Schema$1.prototype.property = {};
Schema$1.prototype.space = undefined;

/**
 * @import {Info, Space} from 'property-information'
 */


/**
 * @param {ReadonlyArray<Schema>} definitions
 *   Definitions.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns {Schema}
 *   Schema.
 */
function merge$1(definitions, space) {
  /** @type {Record<string, Info>} */
  const property = {};
  /** @type {Record<string, string>} */
  const normal = {};

  for (const definition of definitions) {
    Object.assign(property, definition.property);
    Object.assign(normal, definition.normal);
  }

  return new Schema$1(property, normal, space)
}

/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */
function normalize$1(value) {
  return value.toLowerCase()
}

/**
 * @import {Info as InfoType} from 'property-information'
 */

/** @type {InfoType} */
let Info$1 = class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(property, attribute) {
    this.attribute = attribute;
    this.property = property;
  }
};

Info$1.prototype.attribute = '';
Info$1.prototype.booleanish = false;
Info$1.prototype.boolean = false;
Info$1.prototype.commaOrSpaceSeparated = false;
Info$1.prototype.commaSeparated = false;
Info$1.prototype.defined = false;
Info$1.prototype.mustUseProperty = false;
Info$1.prototype.number = false;
Info$1.prototype.overloadedBoolean = false;
Info$1.prototype.property = '';
Info$1.prototype.spaceSeparated = false;
Info$1.prototype.space = undefined;

let powers$1 = 0;

const boolean$1 = increment$1();
const booleanish$1 = increment$1();
const overloadedBoolean$1 = increment$1();
const number$1 = increment$1();
const spaceSeparated$1 = increment$1();
const commaSeparated$1 = increment$1();
const commaOrSpaceSeparated$1 = increment$1();

function increment$1() {
  return 2 ** ++powers$1
}

const types$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	boolean: boolean$1,
	booleanish: booleanish$1,
	commaOrSpaceSeparated: commaOrSpaceSeparated$1,
	commaSeparated: commaSeparated$1,
	number: number$1,
	overloadedBoolean: overloadedBoolean$1,
	spaceSeparated: spaceSeparated$1
}, Symbol.toStringTag, { value: 'Module' }));

/**
 * @import {Space} from 'property-information'
 */


const checks$1 = /** @type {ReadonlyArray<keyof typeof types>} */ (
  Object.keys(types$1)
);

let DefinedInfo$1 = class DefinedInfo extends Info$1 {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(property, attribute, mask, space) {
    let index = -1;

    super(property, attribute);

    mark$1(this, 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks$1.length) {
        const check = checks$1[index];
        mark$1(this, checks$1[index], (mask & types$1[check]) === types$1[check]);
      }
    }
  }
};

DefinedInfo$1.prototype.defined = true;

/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */
function mark$1(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

/**
 * @import {Info, Space} from 'property-information'
 */


/**
 * @param {Definition} definition
 *   Definition.
 * @returns {Schema}
 *   Schema.
 */
function create$1(definition) {
  /** @type {Record<string, Info>} */
  const properties = {};
  /** @type {Record<string, string>} */
  const normals = {};

  for (const [property, value] of Object.entries(definition.properties)) {
    const info = new DefinedInfo$1(
      property,
      definition.transform(definition.attributes || {}, property),
      value,
      definition.space
    );

    if (
      definition.mustUseProperty &&
      definition.mustUseProperty.includes(property)
    ) {
      info.mustUseProperty = true;
    }

    properties[property] = info;

    normals[normalize$1(property)] = property;
    normals[normalize$1(info.attribute)] = property;
  }

  return new Schema$1(properties, normals, definition.space)
}

const aria$1 = create$1({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish$1,
    ariaAutoComplete: null,
    ariaBusy: booleanish$1,
    ariaChecked: booleanish$1,
    ariaColCount: number$1,
    ariaColIndex: number$1,
    ariaColSpan: number$1,
    ariaControls: spaceSeparated$1,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated$1,
    ariaDetails: null,
    ariaDisabled: booleanish$1,
    ariaDropEffect: spaceSeparated$1,
    ariaErrorMessage: null,
    ariaExpanded: booleanish$1,
    ariaFlowTo: spaceSeparated$1,
    ariaGrabbed: booleanish$1,
    ariaHasPopup: null,
    ariaHidden: booleanish$1,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated$1,
    ariaLevel: number$1,
    ariaLive: null,
    ariaModal: booleanish$1,
    ariaMultiLine: booleanish$1,
    ariaMultiSelectable: booleanish$1,
    ariaOrientation: null,
    ariaOwns: spaceSeparated$1,
    ariaPlaceholder: null,
    ariaPosInSet: number$1,
    ariaPressed: booleanish$1,
    ariaReadOnly: booleanish$1,
    ariaRelevant: null,
    ariaRequired: booleanish$1,
    ariaRoleDescription: spaceSeparated$1,
    ariaRowCount: number$1,
    ariaRowIndex: number$1,
    ariaRowSpan: number$1,
    ariaSelected: booleanish$1,
    ariaSetSize: number$1,
    ariaSort: null,
    ariaValueMax: number$1,
    ariaValueMin: number$1,
    ariaValueNow: number$1,
    ariaValueText: null,
    role: null
  },
  transform(_, property) {
    return property === 'role'
      ? property
      : 'aria-' + property.slice(4).toLowerCase()
  }
});

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */
function caseSensitiveTransform$1(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Transformed property.
 */
function caseInsensitiveTransform$1(attributes, property) {
  return caseSensitiveTransform$1(attributes, property.toLowerCase())
}

const html$3 = create$1({
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated$1,
    acceptCharset: spaceSeparated$1,
    accessKey: spaceSeparated$1,
    action: null,
    allow: null,
    allowFullScreen: boolean$1,
    allowPaymentRequest: boolean$1,
    allowUserMedia: boolean$1,
    alt: null,
    as: null,
    async: boolean$1,
    autoCapitalize: null,
    autoComplete: spaceSeparated$1,
    autoFocus: boolean$1,
    autoPlay: boolean$1,
    blocking: spaceSeparated$1,
    capture: null,
    charSet: null,
    checked: boolean$1,
    cite: null,
    className: spaceSeparated$1,
    cols: number$1,
    colSpan: null,
    content: null,
    contentEditable: booleanish$1,
    controls: boolean$1,
    controlsList: spaceSeparated$1,
    coords: number$1 | commaSeparated$1,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean$1,
    defer: boolean$1,
    dir: null,
    dirName: null,
    disabled: boolean$1,
    download: overloadedBoolean$1,
    draggable: booleanish$1,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean$1,
    formTarget: null,
    headers: spaceSeparated$1,
    height: number$1,
    hidden: boolean$1,
    high: number$1,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated$1,
    httpEquiv: spaceSeparated$1,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean$1,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean$1,
    itemId: null,
    itemProp: spaceSeparated$1,
    itemRef: spaceSeparated$1,
    itemScope: boolean$1,
    itemType: spaceSeparated$1,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean$1,
    low: number$1,
    manifest: null,
    max: null,
    maxLength: number$1,
    media: null,
    method: null,
    min: null,
    minLength: number$1,
    multiple: boolean$1,
    muted: boolean$1,
    name: null,
    nonce: null,
    noModule: boolean$1,
    noValidate: boolean$1,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean$1,
    optimum: number$1,
    pattern: null,
    ping: spaceSeparated$1,
    placeholder: null,
    playsInline: boolean$1,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean$1,
    referrerPolicy: null,
    rel: spaceSeparated$1,
    required: boolean$1,
    reversed: boolean$1,
    rows: number$1,
    rowSpan: number$1,
    sandbox: spaceSeparated$1,
    scope: null,
    scoped: boolean$1,
    seamless: boolean$1,
    selected: boolean$1,
    shadowRootClonable: boolean$1,
    shadowRootDelegatesFocus: boolean$1,
    shadowRootMode: null,
    shape: null,
    size: number$1,
    sizes: null,
    slot: null,
    span: number$1,
    spellCheck: booleanish$1,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$1,
    step: null,
    style: null,
    tabIndex: number$1,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean$1,
    useMap: null,
    value: booleanish$1,
    width: number$1,
    wrap: null,
    writingSuggestions: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated$1, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number$1, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$1, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean$1, // Lists. Use CSS to reduce space between items instead
    declare: boolean$1, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number$1, // `<img>` and `<object>`
    leftMargin: number$1, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number$1, // `<body>`
    marginWidth: number$1, // `<body>`
    noResize: boolean$1, // `<frame>`
    noHref: boolean$1, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean$1, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean$1, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number$1, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish$1, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number$1, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$1, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean$1,
    disableRemotePlayback: boolean$1,
    prefix: null,
    property: null,
    results: number$1,
    security: null,
    unselectable: null
  },
  space: 'html',
  transform: caseInsensitiveTransform$1
});

const svg$3 = create$1({
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  properties: {
    about: commaOrSpaceSeparated$1,
    accentHeight: number$1,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$1,
    amplitude: number$1,
    arabicForm: null,
    ascent: number$1,
    attributeName: null,
    attributeType: null,
    azimuth: number$1,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$1,
    by: null,
    calcMode: null,
    capHeight: number$1,
    className: spaceSeparated$1,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$1,
    diffuseConstant: number$1,
    direction: null,
    display: null,
    dur: null,
    divisor: number$1,
    dominantBaseline: null,
    download: boolean$1,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$1,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$1,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$1,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated$1,
    g2: commaSeparated$1,
    glyphName: commaSeparated$1,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$1,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$1,
    horizOriginX: number$1,
    horizOriginY: number$1,
    id: null,
    ideographic: number$1,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number$1,
    k: number$1,
    k1: number$1,
    k2: number$1,
    k3: number$1,
    k4: number$1,
    kernelMatrix: commaOrSpaceSeparated$1,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$1,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$1,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$1,
    overlineThickness: number$1,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$1,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated$1,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$1,
    pointsAtY: number$1,
    pointsAtZ: number$1,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated$1,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated$1,
    rev: commaOrSpaceSeparated$1,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated$1,
    requiredFeatures: commaOrSpaceSeparated$1,
    requiredFonts: commaOrSpaceSeparated$1,
    requiredFormats: commaOrSpaceSeparated$1,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$1,
    specularExponent: number$1,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$1,
    strikethroughThickness: number$1,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated$1,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$1,
    strokeOpacity: number$1,
    strokeWidth: null,
    style: null,
    surfaceScale: number$1,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated$1,
    tabIndex: number$1,
    tableValues: null,
    target: null,
    targetX: number$1,
    targetY: number$1,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated$1,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$1,
    underlineThickness: number$1,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$1,
    values: null,
    vAlphabetic: number$1,
    vMathematical: number$1,
    vectorEffect: null,
    vHanging: number$1,
    vIdeographic: number$1,
    version: null,
    vertAdvY: number$1,
    vertOriginX: number$1,
    vertOriginY: number$1,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$1,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: 'svg',
  transform: caseSensitiveTransform$1
});

const xlink$1 = create$1({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: 'xlink',
  transform(_, property) {
    return 'xlink:' + property.slice(5).toLowerCase()
  }
});

const xmlns$1 = create$1({
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  properties: {xmlnsXLink: null, xmlns: null},
  space: 'xmlns',
  transform: caseInsensitiveTransform$1
});

const xml$1 = create$1({
  properties: {xmlBase: null, xmlLang: null, xmlSpace: null},
  space: 'xml',
  transform(_, property) {
    return 'xml:' + property.slice(3).toLowerCase()
  }
});

/**
 * @import {Schema} from 'property-information'
 */


const cap$1 = /[A-Z]/g;
const dash$1 = /-[a-z]/g;
const valid$1 = /^data[-\w.:]+$/i;

/**
 * Look up info on a property.
 *
 * In most cases the given `schema` contains info on the property.
 * All standard,
 * most legacy,
 * and some non-standard properties are supported.
 * For these cases,
 * the returned `Info` has hints about the value of the property.
 *
 * `name` can also be a valid data attribute or property,
 * in which case an `Info` object with the correctly cased `attribute` and
 * `property` is returned.
 *
 * `name` can be an unknown attribute,
 * in which case an `Info` object with `attribute` and `property` set to the
 * given name is returned.
 * It is not recommended to provide unsupported legacy or recently specced
 * properties.
 *
 *
 * @param {Schema} schema
 *   Schema;
 *   either the `html` or `svg` export.
 * @param {string} value
 *   An attribute-like or property-like name;
 *   it will be passed through `normalize` to hopefully find the correct info.
 * @returns {Info}
 *   Info.
 */
function find$1(schema, value) {
  const normal = normalize$1(value);
  let property = value;
  let Type = Info$1;

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid$1.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash$1, camelcase$1);
      property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4);

      if (!dash$1.test(rest)) {
        let dashes = rest.replace(cap$1, kebab$1);

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }

        value = 'data' + dashes;
      }
    }

    Type = DefinedInfo$1;
  }

  return new Type(property, value)
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */
function kebab$1($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */
function camelcase$1($0) {
  return $0.charAt(1).toUpperCase()
}

// Note: types exposed from `index.d.ts`.

const html$2 = merge$1([aria$1, html$3, xlink$1, xmlns$1, xml$1], 'html');

const svg$2 = merge$1([aria$1, svg$3, xlink$1, xmlns$1, xml$1], 'svg');

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 */

/**
 * @template {string} SimpleSelector
 *   Selector type.
 * @template {string} DefaultTagName
 *   Default tag name.
 * @typedef {(
 *   SimpleSelector extends ''
 *     ? DefaultTagName
 *     : SimpleSelector extends `${infer TagName}.${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends `${infer TagName}#${infer Rest}`
 *     ? ExtractTagName<TagName, DefaultTagName>
 *     : SimpleSelector extends string
 *     ? SimpleSelector
 *     : DefaultTagName
 * )} ExtractTagName
 *   Extract tag name from a simple selector.
 */

const search = /[#.]/g;

/**
 * Create a hast element from a simple CSS selector.
 *
 * @template {string} Selector
 *   Type of selector.
 * @template {string} [DefaultTagName='div']
 *   Type of default tag name (default: `'div'`).
 * @param {Selector | null | undefined} [selector]
 *   Simple CSS selector (optional).
 *
 *   Can contain a tag name (`foo`), classes (`.bar`), and an ID (`#baz`).
 *   Multiple classes are allowed.
 *   Uses the last ID if multiple IDs are found.
 * @param {DefaultTagName | null | undefined} [defaultTagName='div']
 *   Tag name to use if `selector` does not specify one (default: `'div'`).
 * @returns {Element & {tagName: ExtractTagName<Selector, DefaultTagName>}}
 *   Built element.
 */
function parseSelector(selector, defaultTagName) {
  const value = selector || '';
  /** @type {Properties} */
  const props = {};
  let start = 0;
  /** @type {string | undefined} */
  let previous;
  /** @type {string | undefined} */
  let tagName;

  while (start < value.length) {
    search.lastIndex = start;
    const match = search.exec(value);
    const subvalue = value.slice(start, match ? match.index : value.length);

    if (subvalue) {
      if (!previous) {
        tagName = subvalue;
      } else if (previous === '#') {
        props.id = subvalue;
      } else if (Array.isArray(props.className)) {
        props.className.push(subvalue);
      } else {
        props.className = [subvalue];
      }

      start += subvalue.length;
    }

    if (match) {
      previous = match[0];
      start++;
    }
  }

  return {
    type: 'element',
    // @ts-expect-error: tag name is parsed.
    tagName: tagName || defaultTagName || 'div',
    properties: props,
    children: []
  }
}

/**
 * @import {Element, Nodes, RootContent, Root} from 'hast'
 * @import {Info, Schema} from 'property-information'
 */


/**
 * @param {Schema} schema
 *   Schema to use.
 * @param {string} defaultTagName
 *   Default tag name.
 * @param {ReadonlyArray<string> | undefined} [caseSensitive]
 *   Case-sensitive tag names (default: `undefined`).
 * @returns
 *   `h`.
 */
function createH(schema, defaultTagName, caseSensitive) {
  const adjust = caseSensitive ? createAdjustMap(caseSensitive) : undefined;

  /**
   * Hyperscript compatible DSL for creating virtual hast trees.
   *
   * @overload
   * @param {null | undefined} [selector]
   * @param {...Child} children
   * @returns {Root}
   *
   * @overload
   * @param {string} selector
   * @param {Properties} properties
   * @param {...Child} children
   * @returns {Element}
   *
   * @overload
   * @param {string} selector
   * @param {...Child} children
   * @returns {Element}
   *
   * @param {string | null | undefined} [selector]
   *   Selector.
   * @param {Child | Properties | null | undefined} [properties]
   *   Properties (or first child) (default: `undefined`).
   * @param {...Child} children
   *   Children.
   * @returns {Result}
   *   Result.
   */
  function h(selector, properties, ...children) {
    /** @type {Result} */
    let node;

    if (selector === null || selector === undefined) {
      node = {type: 'root', children: []};
      // Properties are not supported for roots.
      const child = /** @type {Child} */ (properties);
      children.unshift(child);
    } else {
      node = parseSelector(selector, defaultTagName);
      // Normalize the name.
      const lower = node.tagName.toLowerCase();
      const adjusted = adjust ? adjust.get(lower) : undefined;
      node.tagName = adjusted || lower;

      // Handle properties.
      if (isChild(properties)) {
        children.unshift(properties);
      } else {
        for (const [key, value] of Object.entries(properties)) {
          addProperty(schema, node.properties, key, value);
        }
      }
    }

    // Handle children.
    for (const child of children) {
      addChild(node.children, child);
    }

    if (node.type === 'element' && node.tagName === 'template') {
      node.content = {type: 'root', children: node.children};
      node.children = [];
    }

    return node
  }

  return h
}

/**
 * Check if something is properties or a child.
 *
 * @param {Child | Properties} value
 *   Value to check.
 * @returns {value is Child}
 *   Whether `value` is definitely a child.
 */
function isChild(value) {
  // Never properties if not an object.
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return true
  }

  // Never node without `type`; that’s the main discriminator.
  if (typeof value.type !== 'string') return false

  // Slower check: never property value if object or array with
  // non-number/strings.
  const record = /** @type {Record<string, unknown>} */ (value);
  const keys = Object.keys(value);

  for (const key of keys) {
    const value = record[key];

    if (value && typeof value === 'object') {
      if (!Array.isArray(value)) return true

      const list = /** @type {ReadonlyArray<unknown>} */ (value);

      for (const item of list) {
        if (typeof item !== 'number' && typeof item !== 'string') {
          return true
        }
      }
    }
  }

  // Also see empty `children` as a node.
  if ('children' in value && Array.isArray(value.children)) {
    return true
  }

  // Default to properties, someone can always pass an empty object,
  // put `data: {}` in a node,
  // or wrap it in an array.
  return false
}

/**
 * @param {Schema} schema
 *   Schema.
 * @param {Properties} properties
 *   Properties object.
 * @param {string} key
 *   Property name.
 * @param {PropertyValue | Style} value
 *   Property value.
 * @returns {undefined}
 *   Nothing.
 */
function addProperty(schema, properties, key, value) {
  const info = find$1(schema, key);
  /** @type {PropertyValue} */
  let result;

  // Ignore nullish and NaN values.
  if (value === null || value === undefined) return

  if (typeof value === 'number') {
    // Ignore NaN.
    if (Number.isNaN(value)) return

    result = value;
  }
  // Booleans.
  else if (typeof value === 'boolean') {
    result = value;
  }
  // Handle list values.
  else if (typeof value === 'string') {
    if (info.spaceSeparated) {
      result = parse$1(value);
    } else if (info.commaSeparated) {
      result = parse$2(value);
    } else if (info.commaOrSpaceSeparated) {
      result = parse$1(parse$2(value).join(' '));
    } else {
      result = parsePrimitive(info, info.property, value);
    }
  } else if (Array.isArray(value)) {
    result = [...value];
  } else {
    result = info.property === 'style' ? style(value) : String(value);
  }

  if (Array.isArray(result)) {
    /** @type {Array<number | string>} */
    const finalResult = [];

    for (const item of result) {
      // Assume no booleans in array.
      finalResult.push(
        /** @type {number | string} */ (
          parsePrimitive(info, info.property, item)
        )
      );
    }

    result = finalResult;
  }

  // Class names (which can be added both on the `selector` and here).
  if (info.property === 'className' && Array.isArray(properties.className)) {
    // Assume no booleans in `className`.
    result = properties.className.concat(
      /** @type {Array<number | string> | number | string} */ (result)
    );
  }

  properties[info.property] = result;
}

/**
 * @param {Array<RootContent>} nodes
 *   Children.
 * @param {Child} value
 *   Child.
 * @returns {undefined}
 *   Nothing.
 */
function addChild(nodes, value) {
  if (value === null || value === undefined) ; else if (typeof value === 'number' || typeof value === 'string') {
    nodes.push({type: 'text', value: String(value)});
  } else if (Array.isArray(value)) {
    for (const child of value) {
      addChild(nodes, child);
    }
  } else if (typeof value === 'object' && 'type' in value) {
    if (value.type === 'root') {
      addChild(nodes, value.children);
    } else {
      nodes.push(value);
    }
  } else {
    throw new Error('Expected node, nodes, or string, got `' + value + '`')
  }
}

/**
 * Parse a single primitives.
 *
 * @param {Info} info
 *   Property information.
 * @param {string} name
 *   Property name.
 * @param {PrimitiveValue} value
 *   Property value.
 * @returns {PrimitiveValue}
 *   Property value.
 */
function parsePrimitive(info, name, value) {
  if (typeof value === 'string') {
    if (info.number && value && !Number.isNaN(Number(value))) {
      return Number(value)
    }

    if (
      (info.boolean || info.overloadedBoolean) &&
      (value === '' || normalize$1(value) === normalize$1(name))
    ) {
      return true
    }
  }

  return value
}

/**
 * Serialize a `style` object as a string.
 *
 * @param {Style} styles
 *   Style object.
 * @returns {string}
 *   CSS string.
 */
function style(styles) {
  /** @type {Array<string>} */
  const result = [];

  for (const [key, value] of Object.entries(styles)) {
    result.push([key, value].join(': '));
  }

  return result.join('; ')
}

/**
 * Create a map to adjust casing.
 *
 * @param {ReadonlyArray<string>} values
 *   List of properly cased keys.
 * @returns {Map<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */
function createAdjustMap(values) {
  /** @type {Map<string, string>} */
  const result = new Map();

  for (const value of values) {
    result.set(value.toLowerCase(), value);
  }

  return result
}

/**
 * List of case-sensitive SVG tag names.
 *
 * @type {ReadonlyArray<string>}
 */
const svgCaseSensitiveTagNames = [
  'altGlyph',
  'altGlyphDef',
  'altGlyphItem',
  'animateColor',
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDistantLight',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'glyphRef',
  'linearGradient',
  'radialGradient',
  'solidColor',
  'textArea',
  'textPath'
];

// Register the JSX namespace on `h`.
/**
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 */


// Note: this explicit type is needed, otherwise TS creates broken types.
/** @type {ReturnType<createH>} */
const h = createH(html$2, 'div');

// Note: this explicit type is needed, otherwise TS creates broken types.
/** @type {ReturnType<createH>} */
const s = createH(svg$2, 'g', svgCaseSensitiveTagNames);

/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */

/** @type {SchemaType} */
class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(property, normal, space) {
    this.normal = normal;
    this.property = property;

    if (space) {
      this.space = space;
    }
  }
}

Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = undefined;

/**
 * @import {Info, Space} from 'property-information'
 */


/**
 * @param {ReadonlyArray<Schema>} definitions
 *   Definitions.
 * @param {Space | undefined} [space]
 *   Space.
 * @returns {Schema}
 *   Schema.
 */
function merge(definitions, space) {
  /** @type {Record<string, Info>} */
  const property = {};
  /** @type {Record<string, string>} */
  const normal = {};

  for (const definition of definitions) {
    Object.assign(property, definition.property);
    Object.assign(normal, definition.normal);
  }

  return new Schema(property, normal, space)
}

/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */
function normalize(value) {
  return value.toLowerCase()
}

/**
 * @import {Info as InfoType} from 'property-information'
 */

/** @type {InfoType} */
class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(property, attribute) {
    this.attribute = attribute;
    this.property = property;
  }
}

Info.prototype.attribute = '';
Info.prototype.booleanish = false;
Info.prototype.boolean = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.commaSeparated = false;
Info.prototype.defined = false;
Info.prototype.mustUseProperty = false;
Info.prototype.number = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.property = '';
Info.prototype.spaceSeparated = false;
Info.prototype.space = undefined;

let powers = 0;

const boolean = increment();
const booleanish = increment();
const overloadedBoolean = increment();
const number = increment();
const spaceSeparated = increment();
const commaSeparated = increment();
const commaOrSpaceSeparated = increment();

function increment() {
  return 2 ** ++powers
}

const types = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	boolean,
	booleanish,
	commaOrSpaceSeparated,
	commaSeparated,
	number,
	overloadedBoolean,
	spaceSeparated
}, Symbol.toStringTag, { value: 'Module' }));

/**
 * @import {Space} from 'property-information'
 */


const checks = /** @type {ReadonlyArray<keyof typeof types>} */ (
  Object.keys(types)
);

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(property, attribute, mask, space) {
    let index = -1;

    super(property, attribute);

    mark(this, 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index];
        mark(this, checks[index], (mask & types[check]) === types[check]);
      }
    }
  }
}

DefinedInfo.prototype.defined = true;

/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */
function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

/**
 * @import {Info, Space} from 'property-information'
 */


/**
 * @param {Definition} definition
 *   Definition.
 * @returns {Schema}
 *   Schema.
 */
function create(definition) {
  /** @type {Record<string, Info>} */
  const properties = {};
  /** @type {Record<string, string>} */
  const normals = {};

  for (const [property, value] of Object.entries(definition.properties)) {
    const info = new DefinedInfo(
      property,
      definition.transform(definition.attributes || {}, property),
      value,
      definition.space
    );

    if (
      definition.mustUseProperty &&
      definition.mustUseProperty.includes(property)
    ) {
      info.mustUseProperty = true;
    }

    properties[property] = info;

    normals[normalize(property)] = property;
    normals[normalize(info.attribute)] = property;
  }

  return new Schema(properties, normals, definition.space)
}

const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(_, property) {
    return property === 'role'
      ? property
      : 'aria-' + property.slice(4).toLowerCase()
  }
});

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Transformed property.
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

const html$1 = create({
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean, // Lists. Use CSS to reduce space between items instead
    declare: boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: boolean, // `<frame>`
    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: 'html',
  transform: caseInsensitiveTransform
});

const svg$1 = create({
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: 'svg',
  transform: caseSensitiveTransform
});

const xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: 'xlink',
  transform(_, property) {
    return 'xlink:' + property.slice(5).toLowerCase()
  }
});

const xmlns = create({
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  properties: {xmlnsXLink: null, xmlns: null},
  space: 'xmlns',
  transform: caseInsensitiveTransform
});

const xml = create({
  properties: {xmlBase: null, xmlLang: null, xmlSpace: null},
  space: 'xml',
  transform(_, property) {
    return 'xml:' + property.slice(3).toLowerCase()
  }
});

/**
 * @import {Schema} from 'property-information'
 */


const cap = /[A-Z]/g;
const dash = /-[a-z]/g;
const valid = /^data[-\w.:]+$/i;

/**
 * Look up info on a property.
 *
 * In most cases the given `schema` contains info on the property.
 * All standard,
 * most legacy,
 * and some non-standard properties are supported.
 * For these cases,
 * the returned `Info` has hints about the value of the property.
 *
 * `name` can also be a valid data attribute or property,
 * in which case an `Info` object with the correctly cased `attribute` and
 * `property` is returned.
 *
 * `name` can be an unknown attribute,
 * in which case an `Info` object with `attribute` and `property` set to the
 * given name is returned.
 * It is not recommended to provide unsupported legacy or recently specced
 * properties.
 *
 *
 * @param {Schema} schema
 *   Schema;
 *   either the `html` or `svg` export.
 * @param {string} value
 *   An attribute-like or property-like name;
 *   it will be passed through `normalize` to hopefully find the correct info.
 * @returns {Info}
 *   Info.
 */
function find(schema, value) {
  const normal = normalize(value);
  let property = value;
  let Type = Info;

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase);
      property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4);

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab);

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }

        value = 'data' + dashes;
      }
    }

    Type = DefinedInfo;
  }

  return new Type(property, value)
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

// Note: types exposed from `index.d.ts`.

const html = merge([aria, html$1, xlink, xmlns, xml], 'html');

const svg = merge([aria, svg$1, xlink, xmlns, xml], 'svg');

/**
 * @import {VFile, Value} from 'vfile'
 * @import {Location} from 'vfile-location'
 */

/**
 * Create an index of the given document to translate between line/column and
 * offset based positional info.
 *
 * Also implemented in Rust in [`wooorm/markdown-rs`][markdown-rs].
 *
 * [markdown-rs]: https://github.com/wooorm/markdown-rs/blob/main/src/util/location.rs
 *
 * @param {VFile | Value} file
 *   File to index.
 * @returns {Location}
 *   Accessors for index.
 */
function location$1(file) {
  const value = String(file);
  /**
   * List, where each index is a line number (0-based), and each value is the
   * byte index *after* where the line ends.
   *
   * @type {Array<number>}
   */
  const indices = [];

  return {toOffset, toPoint}

  /** @type {Location['toPoint']} */
  function toPoint(offset) {
    if (typeof offset === 'number' && offset > -1 && offset <= value.length) {
      let index = 0;

      while (true) {
        let end = indices[index];

        if (end === undefined) {
          const eol = next(value, indices[index - 1]);
          end = eol === -1 ? value.length + 1 : eol + 1;
          indices[index] = end;
        }

        if (end > offset) {
          return {
            line: index + 1,
            column: offset - (index > 0 ? indices[index - 1] : 0) + 1,
            offset
          }
        }

        index++;
      }
    }
  }

  /** @type {Location['toOffset']} */
  function toOffset(point) {
    if (
      point &&
      typeof point.line === 'number' &&
      typeof point.column === 'number' &&
      !Number.isNaN(point.line) &&
      !Number.isNaN(point.column)
    ) {
      while (indices.length < point.line) {
        const from = indices[indices.length - 1];
        const eol = next(value, from);
        const end = eol === -1 ? value.length + 1 : eol + 1;
        if (from === end) break
        indices.push(end);
      }

      const offset =
        (point.line > 1 ? indices[point.line - 2] : 0) + point.column - 1;
      // The given `column` could not exist on this line.
      if (offset < indices[point.line - 1]) return offset
    }
  }
}

/**
 * @param {string} value
 * @param {number} from
 */
function next(value, from) {
  const cr = value.indexOf('\r', from);
  const lf = value.indexOf('\n', from);
  if (lf === -1) return cr
  if (cr === -1 || cr + 1 === lf) return lf
  return cr < lf ? cr : lf
}

/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */
const webNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/'
};

/**
 * @import {ElementData, Element, Nodes, RootContent, Root} from 'hast'
 * @import {DefaultTreeAdapterMap, Token} from 'parse5'
 * @import {Schema} from 'property-information'
 * @import {Point, Position} from 'unist'
 * @import {VFile} from 'vfile'
 * @import {Options} from 'hast-util-from-parse5'
 */


const own$1 = {}.hasOwnProperty;
/** @type {unknown} */
// type-coverage:ignore-next-line
const proto = Object.prototype;

/**
 * Transform a `parse5` AST to hast.
 *
 * @param {DefaultTreeAdapterMap['node']} tree
 *   `parse5` tree to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {Nodes}
 *   hast tree.
 */
function fromParse5(tree, options) {
  const settings = options;

  return one$1(
    {
      file: settings.file || undefined,
      location: false,
      schema: settings.space === 'svg' ? svg : html,
      verbose: settings.verbose || false
    },
    tree
  )
}

/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} node
 *   p5 node.
 * @returns {Nodes}
 *   hast node.
 */
function one$1(state, node) {
  /** @type {Nodes} */
  let result;

  switch (node.nodeName) {
    case '#comment': {
      const reference = /** @type {DefaultTreeAdapterMap['commentNode']} */ (
        node
      );
      result = {type: 'comment', value: reference.data};
      patch$1(state, reference, result);
      return result
    }

    case '#document':
    case '#document-fragment': {
      const reference =
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */ (
          node
        );
      const quirksMode =
        'mode' in reference
          ? reference.mode === 'quirks' || reference.mode === 'limited-quirks'
          : false;

      result = {
        type: 'root',
        children: all$2(state, node.childNodes),
        data: {quirksMode}
      };

      if (state.file && state.location) {
        const document = String(state.file);
        const loc = location$1(document);
        const start = loc.toPoint(0);
        const end = loc.toPoint(document.length);
        result.position = {start, end};
      }

      return result
    }

    case '#documentType': {
      const reference = /** @type {DefaultTreeAdapterMap['documentType']} */ (
        node
      );
      result = {type: 'doctype'};
      patch$1(state, reference, result);
      return result
    }

    case '#text': {
      const reference = /** @type {DefaultTreeAdapterMap['textNode']} */ (node);
      result = {type: 'text', value: reference.value};
      patch$1(state, reference, result);
      return result
    }

    // Element.
    default: {
      const reference = /** @type {DefaultTreeAdapterMap['element']} */ (node);
      result = element$2(state, reference);
      return result
    }
  }
}

/**
 * Transform children.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Array<DefaultTreeAdapterMap['node']>} nodes
 *   Nodes.
 * @returns {Array<RootContent>}
 *   hast nodes.
 */
function all$2(state, nodes) {
  let index = -1;
  /** @type {Array<RootContent>} */
  const results = [];

  while (++index < nodes.length) {
    // Assume no roots in `nodes`.
    const result = /** @type {RootContent} */ (one$1(state, nodes[index]));
    results.push(result);
  }

  return results
}

/**
 * Transform an element.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['element']} node
 *   `parse5` node to transform.
 * @returns {Element}
 *   hast node.
 */
function element$2(state, node) {
  const schema = state.schema;

  state.schema = node.namespaceURI === webNamespaces.svg ? svg : html;

  // Props.
  let index = -1;
  /** @type {Record<string, string>} */
  const properties = {};

  while (++index < node.attrs.length) {
    const attribute = node.attrs[index];
    const name =
      (attribute.prefix ? attribute.prefix + ':' : '') + attribute.name;
    if (!own$1.call(proto, name)) {
      properties[name] = attribute.value;
    }
  }

  // Build.
  const x = state.schema.space === 'svg' ? s : h;
  const result = x(node.tagName, properties, all$2(state, node.childNodes));
  patch$1(state, node, result);

  // Switch content.
  if (result.tagName === 'template') {
    const reference = /** @type {DefaultTreeAdapterMap['template']} */ (node);
    const pos = reference.sourceCodeLocation;
    const startTag = pos && pos.startTag && position(pos.startTag);
    const endTag = pos && pos.endTag && position(pos.endTag);

    // Root in, root out.
    const content = /** @type {Root} */ (one$1(state, reference.content));

    if (startTag && endTag && state.file) {
      content.position = {start: startTag.end, end: endTag.start};
    }

    result.content = content;
  }

  state.schema = schema;

  return result
}

/**
 * Patch positional info from `from` onto `to`.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {DefaultTreeAdapterMap['node']} from
 *   p5 node.
 * @param {Nodes} to
 *   hast node.
 * @returns {undefined}
 *   Nothing.
 */
function patch$1(state, from, to) {
  if ('sourceCodeLocation' in from && from.sourceCodeLocation && state.file) {
    const position = createLocation(state, to, from.sourceCodeLocation);

    if (position) {
      state.location = true;
      to.position = position;
    }
  }
}

/**
 * Create clean positional information.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   hast node.
 * @param {Token.ElementLocation} location
 *   p5 location info.
 * @returns {Position | undefined}
 *   Position, or nothing.
 */
function createLocation(state, node, location) {
  const result = position(location);

  if (node.type === 'element') {
    const tail = node.children[node.children.length - 1];

    // Bug for unclosed with children.
    // See: <https://github.com/inikulin/parse5/issues/109>.
    if (
      result &&
      !location.endTag &&
      tail &&
      tail.position &&
      tail.position.end
    ) {
      result.end = Object.assign({}, tail.position.end);
    }

    if (state.verbose) {
      /** @type {Record<string, Position | undefined>} */
      const properties = {};
      /** @type {string} */
      let key;

      if (location.attrs) {
        for (key in location.attrs) {
          if (own$1.call(location.attrs, key)) {
            properties[find(state.schema, key).property] = position(
              location.attrs[key]
            );
          }
        }
      }

      ok$1(location.startTag);
      const opening = position(location.startTag);
      const closing = location.endTag ? position(location.endTag) : undefined;
      /** @type {ElementData['position']} */
      const data = {opening};
      if (closing) data.closing = closing;
      data.properties = properties;

      node.data = {position: data};
    }
  }

  return result
}

/**
 * Turn a p5 location into a position.
 *
 * @param {Token.Location} loc
 *   Location.
 * @returns {Position | undefined}
 *   Position or nothing.
 */
function position(loc) {
  const start = point({
    line: loc.startLine,
    column: loc.startCol,
    offset: loc.startOffset
  });
  const end = point({
    line: loc.endLine,
    column: loc.endCol,
    offset: loc.endOffset
  });

  // @ts-expect-error: we do use `undefined` for points if one or the other
  // exists.
  return start || end ? {start, end} : undefined
}

/**
 * Filter out invalid points.
 *
 * @param {Point} point
 *   Point with potentially `undefined` values.
 * @returns {Point | undefined}
 *   Point or nothing.
 */
function point(point) {
  return point.line && point.column ? point : undefined
}

/**
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Doctype} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').RootContent} RootContent
 * @typedef {import('hast').Text} Text
 *
 * @typedef {import('parse5').DefaultTreeAdapterMap['document']} Parse5Document
 * @typedef {import('parse5').DefaultTreeAdapterMap['documentFragment']} Parse5Fragment
 * @typedef {import('parse5').DefaultTreeAdapterMap['element']} Parse5Element
 * @typedef {import('parse5').DefaultTreeAdapterMap['node']} Parse5Nodes
 * @typedef {import('parse5').DefaultTreeAdapterMap['documentType']} Parse5Doctype
 * @typedef {import('parse5').DefaultTreeAdapterMap['commentNode']} Parse5Comment
 * @typedef {import('parse5').DefaultTreeAdapterMap['textNode']} Parse5Text
 * @typedef {import('parse5').DefaultTreeAdapterMap['parentNode']} Parse5Parent
 * @typedef {import('parse5').Token.Attribute} Parse5Attribute
 *
 * @typedef {import('property-information').Schema} Schema
 */


const own = {}.hasOwnProperty;

const one = zwitch('type', {handlers: {root: root$1, element: element$1, text: text$1, comment: comment$1, doctype: doctype$1}});

/**
 * Transform a hast tree to a `parse5` AST.
 *
 * @param {Nodes} tree
 *   Tree to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {Parse5Nodes}
 *   `parse5` node.
 */
function toParse5(tree, options) {
  const settings = options;
  const space = settings.space;
  return one(tree, space === 'svg' ? svg$4 : html$6)
}

/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Document}
 *   Parse5 node.
 */
function root$1(node, schema) {
  /** @type {Parse5Document} */
  const result = {
    nodeName: '#document',
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (node.data || {}).quirksMode ? 'quirks' : 'no-quirks',
    childNodes: []
  };
  result.childNodes = all$1(node.children, result, schema);
  patch(node, result);
  return result
}

/**
 * @param {Root} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Fragment}
 *   Parse5 node.
 */
function fragment(node, schema) {
  /** @type {Parse5Fragment} */
  const result = {nodeName: '#document-fragment', childNodes: []};
  result.childNodes = all$1(node.children, result, schema);
  patch(node, result);
  return result
}

/**
 * @param {Doctype} node
 *   Node (hast) to transform.
 * @returns {Parse5Doctype}
 *   Parse5 node.
 */
function doctype$1(node) {
  /** @type {Parse5Doctype} */
  const result = {
    nodeName: '#documentType',
    name: 'html',
    publicId: '',
    systemId: '',
    parentNode: null
  };

  patch(node, result);
  return result
}

/**
 * @param {Text} node
 *   Node (hast) to transform.
 * @returns {Parse5Text}
 *   Parse5 node.
 */
function text$1(node) {
  /** @type {Parse5Text} */
  const result = {
    nodeName: '#text',
    value: node.value,
    parentNode: null
  };
  patch(node, result);
  return result
}

/**
 * @param {Comment} node
 *   Node (hast) to transform.
 * @returns {Parse5Comment}
 *   Parse5 node.
 */
function comment$1(node) {
  /** @type {Parse5Comment} */
  const result = {
    nodeName: '#comment',
    data: node.value,
    parentNode: null
  };

  patch(node, result);

  return result
}

/**
 * @param {Element} node
 *   Node (hast) to transform.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Parse5Element}
 *   Parse5 node.
 */
function element$1(node, schema) {
  const parentSchema = schema;
  let currentSchema = parentSchema;

  if (
    node.type === 'element' &&
    node.tagName.toLowerCase() === 'svg' &&
    parentSchema.space === 'html'
  ) {
    currentSchema = svg$4;
  }

  /** @type {Array<Parse5Attribute>} */
  const attrs = [];
  /** @type {string} */
  let prop;

  if (node.properties) {
    for (prop in node.properties) {
      if (prop !== 'children' && own.call(node.properties, prop)) {
        const result = createProperty(
          currentSchema,
          prop,
          node.properties[prop]
        );

        if (result) {
          attrs.push(result);
        }
      }
    }
  }

  const space = currentSchema.space;

  /** @type {Parse5Element} */
  const result = {
    nodeName: node.tagName,
    tagName: node.tagName,
    attrs,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: webNamespaces[space],
    childNodes: [],
    parentNode: null
  };
  result.childNodes = all$1(node.children, result, currentSchema);
  patch(node, result);

  if (node.tagName === 'template' && node.content) {
    // @ts-expect-error: `parse5` types are wrong.
    result.content = fragment(node.content, currentSchema);
  }

  return result
}

/**
 * Handle a property.
 *
 * @param {Schema} schema
 *   Current schema.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Parse5Attribute | undefined}
 *   Field for runtime, optional.
 */
function createProperty(schema, prop, value) {
  const info = find$2(schema, prop);

  // Ignore nullish and `NaN` values.
  if (
    value === false ||
    value === null ||
    value === undefined ||
    (typeof value === 'number' && Number.isNaN(value)) ||
    (!value && info.boolean)
  ) {
    return
  }

  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? stringify$1(value) : stringify(value);
  }

  /** @type {Parse5Attribute} */
  const attribute = {
    name: info.attribute,
    value: value === true ? '' : String(value)
  };

  if (info.space && info.space !== 'html' && info.space !== 'svg') {
    const index = attribute.name.indexOf(':');

    if (index < 0) {
      attribute.prefix = '';
    } else {
      attribute.name = attribute.name.slice(index + 1);
      attribute.prefix = info.attribute.slice(0, index);
    }

    attribute.namespace = webNamespaces[info.space];
  }

  return attribute
}

/**
 * Transform all hast nodes.
 *
 * @param {Array<RootContent>} children
 *   List of children.
 * @param {Parse5Parent} parentNode
 *   `parse5` parent node.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Array<Parse5Content>}
 *   Transformed children.
 */
function all$1(children, parentNode, schema) {
  let index = -1;
  /** @type {Array<Parse5Content>} */
  const results = [];

  if (children) {
    while (++index < children.length) {
      /** @type {Parse5Content} */
      const child = one(children[index], schema);

      child.parentNode = parentNode;

      results.push(child);
    }
  }

  return results
}

/**
 * Add position info from `from` to `to`.
 *
 * @param {Nodes} from
 *   hast node.
 * @param {Parse5Nodes} to
 *   `parse5` node.
 * @returns {undefined}
 *   Nothing.
 */
function patch(from, to) {
  const position = from.position;

  if (position && position.start && position.end) {
    ok$1(typeof position.start.offset === 'number');
    ok$1(typeof position.end.offset === 'number');

    to.sourceCodeLocation = {
      startLine: position.start.line,
      startCol: position.start.column,
      startOffset: position.start.offset,
      endLine: position.end.line,
      endCol: position.end.column,
      endOffset: position.end.offset
    };
  }
}

/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */
const htmlVoidElements = [
  'area',
  'base',
  'basefont',
  'bgsound',
  'br',
  'col',
  'command',
  'embed',
  'frame',
  'hr',
  'image',
  'img',
  'input',
  'keygen',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr'
];

const UNDEFINED_CODE_POINTS = new Set([
    65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214,
    393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894,
    720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574,
    1048575, 1114110, 1114111,
]);
const REPLACEMENT_CHARACTER = '\uFFFD';
var CODE_POINTS;
(function (CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
})(CODE_POINTS || (CODE_POINTS = {}));
const SEQUENCES = {
    DASH_DASH: '--',
    CDATA_START: '[CDATA[',
    DOCTYPE: 'doctype',
    SCRIPT: 'script',
    PUBLIC: 'public',
    SYSTEM: 'system',
};
//Surrogates
function isSurrogate(cp) {
    return cp >= 55296 && cp <= 57343;
}
function isSurrogatePair(cp) {
    return cp >= 56320 && cp <= 57343;
}
function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
}
//NOTE: excluding NULL and ASCII whitespace
function isControlCodePoint(cp) {
    return ((cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f) ||
        (cp >= 0x7f && cp <= 0x9f));
}
function isUndefinedCodePoint(cp) {
    return (cp >= 64976 && cp <= 65007) || UNDEFINED_CODE_POINTS.has(cp);
}

var ERR;
(function (ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
})(ERR || (ERR = {}));

//Const
const DEFAULT_BUFFER_WATERLINE = 1 << 16;
//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
class Preprocessor {
    constructor(handler) {
        this.handler = handler;
        this.html = '';
        this.pos = -1;
        // NOTE: Initial `lastGapPos` is -2, to ensure `col` on initialisation is 0
        this.lastGapPos = -2;
        this.gapStack = [];
        this.skipNextNewLine = false;
        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;
        this.line = 1;
        //NOTE: avoid reporting errors twice on advance/retreat
        this.lastErrOffset = -1;
    }
    /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
    get col() {
        return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
    get offset() {
        return this.droppedBufferSize + this.pos;
    }
    getError(code, cpOffset) {
        const { line, col, offset } = this;
        const startCol = col + cpOffset;
        const startOffset = offset + cpOffset;
        return {
            code,
            startLine: line,
            endLine: line,
            startCol,
            endCol: startCol,
            startOffset,
            endOffset: startOffset,
        };
    }
    _err(code) {
        if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
            this.lastErrOffset = this.offset;
            this.handler.onParseError(this.getError(code, 0));
        }
    }
    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }
    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.html.length - 1) {
            const nextCp = this.html.charCodeAt(this.pos + 1);
            if (isSurrogatePair(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;
                //NOTE: add a gap that should be avoided during retreat
                this._addGap();
                return getSurrogatePairCodePoint(cp, nextCp);
            }
        }
        //NOTE: we are at the end of a chunk, therefore we can't infer the surrogate pair yet.
        else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return CODE_POINTS.EOF;
        }
        //NOTE: isolated surrogate
        this._err(ERR.surrogateInInputStream);
        return cp;
    }
    willDropParsedChunk() {
        return this.pos > this.bufferWaterline;
    }
    dropParsedChunk() {
        if (this.willDropParsedChunk()) {
            this.html = this.html.substring(this.pos);
            this.lineStartPos -= this.pos;
            this.droppedBufferSize += this.pos;
            this.pos = 0;
            this.lastGapPos = -2;
            this.gapStack.length = 0;
        }
    }
    write(chunk, isLastChunk) {
        if (this.html.length > 0) {
            this.html += chunk;
        }
        else {
            this.html = chunk;
        }
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }
    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
        this.endOfChunkHit = false;
    }
    startsWith(pattern, caseSensitive) {
        // Check if our buffer has enough characters
        if (this.pos + pattern.length > this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return false;
        }
        if (caseSensitive) {
            return this.html.startsWith(pattern, this.pos);
        }
        for (let i = 0; i < pattern.length; i++) {
            const cp = this.html.charCodeAt(this.pos + i) | 0x20;
            if (cp !== pattern.charCodeAt(i)) {
                return false;
            }
        }
        return true;
    }
    peek(offset) {
        const pos = this.pos + offset;
        if (pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return CODE_POINTS.EOF;
        }
        const code = this.html.charCodeAt(pos);
        return code === CODE_POINTS.CARRIAGE_RETURN ? CODE_POINTS.LINE_FEED : code;
    }
    advance() {
        this.pos++;
        //NOTE: LF should be in the last column of the line
        if (this.isEol) {
            this.isEol = false;
            this.line++;
            this.lineStartPos = this.pos;
        }
        if (this.pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return CODE_POINTS.EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === CODE_POINTS.CARRIAGE_RETURN) {
            this.isEol = true;
            this.skipNextNewLine = true;
            return CODE_POINTS.LINE_FEED;
        }
        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (cp === CODE_POINTS.LINE_FEED) {
            this.isEol = true;
            if (this.skipNextNewLine) {
                // `line` will be bumped again in the recursive call.
                this.line--;
                this.skipNextNewLine = false;
                this._addGap();
                return this.advance();
            }
        }
        this.skipNextNewLine = false;
        if (isSurrogate(cp)) {
            cp = this._processSurrogate(cp);
        }
        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange = this.handler.onParseError === null ||
            (cp > 0x1f && cp < 0x7f) ||
            cp === CODE_POINTS.LINE_FEED ||
            cp === CODE_POINTS.CARRIAGE_RETURN ||
            (cp > 0x9f && cp < 64976);
        if (!isCommonValidRange) {
            this._checkForProblematicCharacters(cp);
        }
        return cp;
    }
    _checkForProblematicCharacters(cp) {
        if (isControlCodePoint(cp)) {
            this._err(ERR.controlCharacterInInputStream);
        }
        else if (isUndefinedCodePoint(cp)) {
            this._err(ERR.noncharacterInInputStream);
        }
    }
    retreat(count) {
        this.pos -= count;
        while (this.pos < this.lastGapPos) {
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }
        this.isEol = false;
    }
}

var TokenType;
(function (TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
})(TokenType || (TokenType = {}));
function getTokenAttr(token, attrName) {
    for (let i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName) {
            return token.attrs[i].value;
        }
    }
    return null;
}

// Generated using scripts/write-decode-map.ts
const htmlDecodeTree = new Uint16Array(
// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c"
    .split("")
    .map((c) => c.charCodeAt(0)));

// Generated using scripts/write-decode-map.ts
const xmlDecodeTree = new Uint16Array(
// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022"
    .split("")
    .map((c) => c.charCodeAt(0)));

// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var _a;
const decodeMap = new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376],
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */
const fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
(_a = String.fromCodePoint) !== null && _a !== undefined ? _a : function (codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */
function replaceCodePoint(codePoint) {
    var _a;
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return 0xfffd;
    }
    return (_a = decodeMap.get(codePoint)) !== null && _a !== undefined ? _a : codePoint;
}

var CharCodes;
(function (CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */
const TO_LOWER_BIT = 0b100000;
var BinTrieFlags;
(function (BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber(code) {
    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
function isHexadecimalCharacter(code) {
    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F) ||
        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F));
}
function isAsciiAlphaNumeric$1(code) {
    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z) ||
        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z) ||
        isNumber(code));
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */
function isEntityInAttributeInvalidEnd(code) {
    return code === CharCodes.EQUALS || isAsciiAlphaNumeric$1(code);
}
var EntityDecoderState;
(function (EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function (DecodingMode) {
    /** Entities in text nodes that can end with any character. */
    DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */
    DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */
    DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */
class EntityDecoder {
    constructor(
    /** The tree used to decode entities. */
    decodeTree, 
    /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */
    emitCodePoint, 
    /** An object that is used to produce errors. */
    errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */
        this.state = EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */
        this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */
        this.result = 0;
        /** The current index in the decode tree. */
        this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */
        this.excess = 1;
        /** The mode in which the decoder is operating. */
        this.decodeMode = DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */
    startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    write(str, offset) {
        switch (this.state) {
            case EntityDecoderState.EntityStart: {
                if (str.charCodeAt(offset) === CharCodes.NUM) {
                    this.state = EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            }
            case EntityDecoderState.NumericStart: {
                return this.stateNumericStart(str, offset);
            }
            case EntityDecoderState.NumericDecimal: {
                return this.stateNumericDecimal(str, offset);
            }
            case EntityDecoderState.NumericHex: {
                return this.stateNumericHex(str, offset);
            }
            case EntityDecoderState.NamedEntity: {
                return this.stateNamedEntity(str, offset);
            }
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNumericStart(str, offset) {
        if (offset >= str.length) {
            return -1;
        }
        if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
            this.state = EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result =
                this.result * Math.pow(base, digitCount) +
                    parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNumericHex(str, offset) {
        const startIdx = offset;
        while (offset < str.length) {
            const char = str.charCodeAt(offset);
            if (isNumber(char) || isHexadecimalCharacter(char)) {
                offset += 1;
            }
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while (offset < str.length) {
            const char = str.charCodeAt(offset);
            if (isNumber(char)) {
                offset += 1;
            }
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */
    emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === undefined ? undefined : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === CharCodes.SEMI) {
            this.consumed += 1;
        }
        else if (this.decodeMode === DecodingMode.Strict) {
            return 0;
        }
        this.emitCodePoint(replaceCodePoint(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== CharCodes.SEMI) {
                this.errors.missingSemicolonAfterCharacterReference();
            }
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */
    stateNamedEntity(str, offset) {
        const { decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
        for (; offset < str.length; offset++, this.excess++) {
            const char = str.charCodeAt(offset);
            this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) {
                return this.result === 0 ||
                    // If we are parsing an attribute
                    (this.decodeMode === DecodingMode.Attribute &&
                        // We shouldn't have consumed any characters after the entity,
                        (valueLength === 0 ||
                            // And there should be no invalid characters.
                            isEntityInAttributeInvalidEnd(char)))
                    ? 0
                    : this.emitNotTerminatedNamedEntity();
            }
            current = decodeTree[this.treeIndex];
            valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === CharCodes.SEMI) {
                    return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                }
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */
    emitNotTerminatedNamedEntity() {
        var _a;
        const { result, decodeTree } = this;
        const valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === undefined ? undefined : _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */
    emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree } = this;
        this.emitCodePoint(valueLength === 1
            ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH
            : decodeTree[result + 1], consumed);
        if (valueLength === 3) {
            // For multi-byte values, we need to emit the second byte.
            this.emitCodePoint(decodeTree[result + 2], consumed);
        }
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */
    end() {
        var _a;
        switch (this.state) {
            case EntityDecoderState.NamedEntity: {
                // Emit a named entity if we have one.
                return this.result !== 0 &&
                    (this.decodeMode !== DecodingMode.Attribute ||
                        this.result === this.treeIndex)
                    ? this.emitNotTerminatedNamedEntity()
                    : 0;
            }
            // Otherwise, emit a numeric entity if we have one.
            case EntityDecoderState.NumericDecimal: {
                return this.emitNumericEntity(0, 2);
            }
            case EntityDecoderState.NumericHex: {
                return this.emitNumericEntity(0, 3);
            }
            case EntityDecoderState.NumericStart: {
                (_a = this.errors) === null || _a === undefined ? undefined : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            }
            case EntityDecoderState.EntityStart: {
                // Return 0 if we have no entity.
                return 0;
            }
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */
function getDecoder(decodeTree) {
    let ret = "";
    const decoder = new EntityDecoder(decodeTree, (str) => (ret += fromCodePoint(str)));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while ((offset = str.indexOf("&", offset)) >= 0) {
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, 
            // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */
function determineBranch(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) {
        return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    }
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount
            ? -1
            : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while (lo <= hi) {
        const mid = (lo + hi) >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) {
            lo = mid + 1;
        }
        else if (midVal > char) {
            hi = mid - 1;
        }
        else {
            return decodeTree[mid + branchCount];
        }
    }
    return -1;
}
getDecoder(htmlDecodeTree);
getDecoder(xmlDecodeTree);

/** All valid namespaces in HTML. */
var NS;
(function (NS) {
    NS["HTML"] = "http://www.w3.org/1999/xhtml";
    NS["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS["SVG"] = "http://www.w3.org/2000/svg";
    NS["XLINK"] = "http://www.w3.org/1999/xlink";
    NS["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})(NS || (NS = {}));
var ATTRS;
(function (ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
})(ATTRS || (ATTRS = {}));
/**
 * The mode of the document.
 *
 * @see {@link https://dom.spec.whatwg.org/#concept-document-limited-quirks}
 */
var DOCUMENT_MODE;
(function (DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
})(DOCUMENT_MODE || (DOCUMENT_MODE = {}));
var TAG_NAMES;
(function (TAG_NAMES) {
    TAG_NAMES["A"] = "a";
    TAG_NAMES["ADDRESS"] = "address";
    TAG_NAMES["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES["APPLET"] = "applet";
    TAG_NAMES["AREA"] = "area";
    TAG_NAMES["ARTICLE"] = "article";
    TAG_NAMES["ASIDE"] = "aside";
    TAG_NAMES["B"] = "b";
    TAG_NAMES["BASE"] = "base";
    TAG_NAMES["BASEFONT"] = "basefont";
    TAG_NAMES["BGSOUND"] = "bgsound";
    TAG_NAMES["BIG"] = "big";
    TAG_NAMES["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES["BODY"] = "body";
    TAG_NAMES["BR"] = "br";
    TAG_NAMES["BUTTON"] = "button";
    TAG_NAMES["CAPTION"] = "caption";
    TAG_NAMES["CENTER"] = "center";
    TAG_NAMES["CODE"] = "code";
    TAG_NAMES["COL"] = "col";
    TAG_NAMES["COLGROUP"] = "colgroup";
    TAG_NAMES["DD"] = "dd";
    TAG_NAMES["DESC"] = "desc";
    TAG_NAMES["DETAILS"] = "details";
    TAG_NAMES["DIALOG"] = "dialog";
    TAG_NAMES["DIR"] = "dir";
    TAG_NAMES["DIV"] = "div";
    TAG_NAMES["DL"] = "dl";
    TAG_NAMES["DT"] = "dt";
    TAG_NAMES["EM"] = "em";
    TAG_NAMES["EMBED"] = "embed";
    TAG_NAMES["FIELDSET"] = "fieldset";
    TAG_NAMES["FIGCAPTION"] = "figcaption";
    TAG_NAMES["FIGURE"] = "figure";
    TAG_NAMES["FONT"] = "font";
    TAG_NAMES["FOOTER"] = "footer";
    TAG_NAMES["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES["FORM"] = "form";
    TAG_NAMES["FRAME"] = "frame";
    TAG_NAMES["FRAMESET"] = "frameset";
    TAG_NAMES["H1"] = "h1";
    TAG_NAMES["H2"] = "h2";
    TAG_NAMES["H3"] = "h3";
    TAG_NAMES["H4"] = "h4";
    TAG_NAMES["H5"] = "h5";
    TAG_NAMES["H6"] = "h6";
    TAG_NAMES["HEAD"] = "head";
    TAG_NAMES["HEADER"] = "header";
    TAG_NAMES["HGROUP"] = "hgroup";
    TAG_NAMES["HR"] = "hr";
    TAG_NAMES["HTML"] = "html";
    TAG_NAMES["I"] = "i";
    TAG_NAMES["IMG"] = "img";
    TAG_NAMES["IMAGE"] = "image";
    TAG_NAMES["INPUT"] = "input";
    TAG_NAMES["IFRAME"] = "iframe";
    TAG_NAMES["KEYGEN"] = "keygen";
    TAG_NAMES["LABEL"] = "label";
    TAG_NAMES["LI"] = "li";
    TAG_NAMES["LINK"] = "link";
    TAG_NAMES["LISTING"] = "listing";
    TAG_NAMES["MAIN"] = "main";
    TAG_NAMES["MALIGNMARK"] = "malignmark";
    TAG_NAMES["MARQUEE"] = "marquee";
    TAG_NAMES["MATH"] = "math";
    TAG_NAMES["MENU"] = "menu";
    TAG_NAMES["META"] = "meta";
    TAG_NAMES["MGLYPH"] = "mglyph";
    TAG_NAMES["MI"] = "mi";
    TAG_NAMES["MO"] = "mo";
    TAG_NAMES["MN"] = "mn";
    TAG_NAMES["MS"] = "ms";
    TAG_NAMES["MTEXT"] = "mtext";
    TAG_NAMES["NAV"] = "nav";
    TAG_NAMES["NOBR"] = "nobr";
    TAG_NAMES["NOFRAMES"] = "noframes";
    TAG_NAMES["NOEMBED"] = "noembed";
    TAG_NAMES["NOSCRIPT"] = "noscript";
    TAG_NAMES["OBJECT"] = "object";
    TAG_NAMES["OL"] = "ol";
    TAG_NAMES["OPTGROUP"] = "optgroup";
    TAG_NAMES["OPTION"] = "option";
    TAG_NAMES["P"] = "p";
    TAG_NAMES["PARAM"] = "param";
    TAG_NAMES["PLAINTEXT"] = "plaintext";
    TAG_NAMES["PRE"] = "pre";
    TAG_NAMES["RB"] = "rb";
    TAG_NAMES["RP"] = "rp";
    TAG_NAMES["RT"] = "rt";
    TAG_NAMES["RTC"] = "rtc";
    TAG_NAMES["RUBY"] = "ruby";
    TAG_NAMES["S"] = "s";
    TAG_NAMES["SCRIPT"] = "script";
    TAG_NAMES["SEARCH"] = "search";
    TAG_NAMES["SECTION"] = "section";
    TAG_NAMES["SELECT"] = "select";
    TAG_NAMES["SOURCE"] = "source";
    TAG_NAMES["SMALL"] = "small";
    TAG_NAMES["SPAN"] = "span";
    TAG_NAMES["STRIKE"] = "strike";
    TAG_NAMES["STRONG"] = "strong";
    TAG_NAMES["STYLE"] = "style";
    TAG_NAMES["SUB"] = "sub";
    TAG_NAMES["SUMMARY"] = "summary";
    TAG_NAMES["SUP"] = "sup";
    TAG_NAMES["TABLE"] = "table";
    TAG_NAMES["TBODY"] = "tbody";
    TAG_NAMES["TEMPLATE"] = "template";
    TAG_NAMES["TEXTAREA"] = "textarea";
    TAG_NAMES["TFOOT"] = "tfoot";
    TAG_NAMES["TD"] = "td";
    TAG_NAMES["TH"] = "th";
    TAG_NAMES["THEAD"] = "thead";
    TAG_NAMES["TITLE"] = "title";
    TAG_NAMES["TR"] = "tr";
    TAG_NAMES["TRACK"] = "track";
    TAG_NAMES["TT"] = "tt";
    TAG_NAMES["U"] = "u";
    TAG_NAMES["UL"] = "ul";
    TAG_NAMES["SVG"] = "svg";
    TAG_NAMES["VAR"] = "var";
    TAG_NAMES["WBR"] = "wbr";
    TAG_NAMES["XMP"] = "xmp";
})(TAG_NAMES || (TAG_NAMES = {}));
/**
 * Tag IDs are numeric IDs for known tag names.
 *
 * We use tag IDs to improve the performance of tag name comparisons.
 */
var TAG_ID;
(function (TAG_ID) {
    TAG_ID[TAG_ID["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID[TAG_ID["A"] = 1] = "A";
    TAG_ID[TAG_ID["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID[TAG_ID["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID[TAG_ID["APPLET"] = 4] = "APPLET";
    TAG_ID[TAG_ID["AREA"] = 5] = "AREA";
    TAG_ID[TAG_ID["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID[TAG_ID["ASIDE"] = 7] = "ASIDE";
    TAG_ID[TAG_ID["B"] = 8] = "B";
    TAG_ID[TAG_ID["BASE"] = 9] = "BASE";
    TAG_ID[TAG_ID["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID[TAG_ID["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID[TAG_ID["BIG"] = 12] = "BIG";
    TAG_ID[TAG_ID["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID[TAG_ID["BODY"] = 14] = "BODY";
    TAG_ID[TAG_ID["BR"] = 15] = "BR";
    TAG_ID[TAG_ID["BUTTON"] = 16] = "BUTTON";
    TAG_ID[TAG_ID["CAPTION"] = 17] = "CAPTION";
    TAG_ID[TAG_ID["CENTER"] = 18] = "CENTER";
    TAG_ID[TAG_ID["CODE"] = 19] = "CODE";
    TAG_ID[TAG_ID["COL"] = 20] = "COL";
    TAG_ID[TAG_ID["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID[TAG_ID["DD"] = 22] = "DD";
    TAG_ID[TAG_ID["DESC"] = 23] = "DESC";
    TAG_ID[TAG_ID["DETAILS"] = 24] = "DETAILS";
    TAG_ID[TAG_ID["DIALOG"] = 25] = "DIALOG";
    TAG_ID[TAG_ID["DIR"] = 26] = "DIR";
    TAG_ID[TAG_ID["DIV"] = 27] = "DIV";
    TAG_ID[TAG_ID["DL"] = 28] = "DL";
    TAG_ID[TAG_ID["DT"] = 29] = "DT";
    TAG_ID[TAG_ID["EM"] = 30] = "EM";
    TAG_ID[TAG_ID["EMBED"] = 31] = "EMBED";
    TAG_ID[TAG_ID["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID[TAG_ID["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID[TAG_ID["FIGURE"] = 34] = "FIGURE";
    TAG_ID[TAG_ID["FONT"] = 35] = "FONT";
    TAG_ID[TAG_ID["FOOTER"] = 36] = "FOOTER";
    TAG_ID[TAG_ID["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID[TAG_ID["FORM"] = 38] = "FORM";
    TAG_ID[TAG_ID["FRAME"] = 39] = "FRAME";
    TAG_ID[TAG_ID["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID[TAG_ID["H1"] = 41] = "H1";
    TAG_ID[TAG_ID["H2"] = 42] = "H2";
    TAG_ID[TAG_ID["H3"] = 43] = "H3";
    TAG_ID[TAG_ID["H4"] = 44] = "H4";
    TAG_ID[TAG_ID["H5"] = 45] = "H5";
    TAG_ID[TAG_ID["H6"] = 46] = "H6";
    TAG_ID[TAG_ID["HEAD"] = 47] = "HEAD";
    TAG_ID[TAG_ID["HEADER"] = 48] = "HEADER";
    TAG_ID[TAG_ID["HGROUP"] = 49] = "HGROUP";
    TAG_ID[TAG_ID["HR"] = 50] = "HR";
    TAG_ID[TAG_ID["HTML"] = 51] = "HTML";
    TAG_ID[TAG_ID["I"] = 52] = "I";
    TAG_ID[TAG_ID["IMG"] = 53] = "IMG";
    TAG_ID[TAG_ID["IMAGE"] = 54] = "IMAGE";
    TAG_ID[TAG_ID["INPUT"] = 55] = "INPUT";
    TAG_ID[TAG_ID["IFRAME"] = 56] = "IFRAME";
    TAG_ID[TAG_ID["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID[TAG_ID["LABEL"] = 58] = "LABEL";
    TAG_ID[TAG_ID["LI"] = 59] = "LI";
    TAG_ID[TAG_ID["LINK"] = 60] = "LINK";
    TAG_ID[TAG_ID["LISTING"] = 61] = "LISTING";
    TAG_ID[TAG_ID["MAIN"] = 62] = "MAIN";
    TAG_ID[TAG_ID["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID[TAG_ID["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID[TAG_ID["MATH"] = 65] = "MATH";
    TAG_ID[TAG_ID["MENU"] = 66] = "MENU";
    TAG_ID[TAG_ID["META"] = 67] = "META";
    TAG_ID[TAG_ID["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID[TAG_ID["MI"] = 69] = "MI";
    TAG_ID[TAG_ID["MO"] = 70] = "MO";
    TAG_ID[TAG_ID["MN"] = 71] = "MN";
    TAG_ID[TAG_ID["MS"] = 72] = "MS";
    TAG_ID[TAG_ID["MTEXT"] = 73] = "MTEXT";
    TAG_ID[TAG_ID["NAV"] = 74] = "NAV";
    TAG_ID[TAG_ID["NOBR"] = 75] = "NOBR";
    TAG_ID[TAG_ID["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID[TAG_ID["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID[TAG_ID["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID[TAG_ID["OBJECT"] = 79] = "OBJECT";
    TAG_ID[TAG_ID["OL"] = 80] = "OL";
    TAG_ID[TAG_ID["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID[TAG_ID["OPTION"] = 82] = "OPTION";
    TAG_ID[TAG_ID["P"] = 83] = "P";
    TAG_ID[TAG_ID["PARAM"] = 84] = "PARAM";
    TAG_ID[TAG_ID["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID[TAG_ID["PRE"] = 86] = "PRE";
    TAG_ID[TAG_ID["RB"] = 87] = "RB";
    TAG_ID[TAG_ID["RP"] = 88] = "RP";
    TAG_ID[TAG_ID["RT"] = 89] = "RT";
    TAG_ID[TAG_ID["RTC"] = 90] = "RTC";
    TAG_ID[TAG_ID["RUBY"] = 91] = "RUBY";
    TAG_ID[TAG_ID["S"] = 92] = "S";
    TAG_ID[TAG_ID["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID[TAG_ID["SEARCH"] = 94] = "SEARCH";
    TAG_ID[TAG_ID["SECTION"] = 95] = "SECTION";
    TAG_ID[TAG_ID["SELECT"] = 96] = "SELECT";
    TAG_ID[TAG_ID["SOURCE"] = 97] = "SOURCE";
    TAG_ID[TAG_ID["SMALL"] = 98] = "SMALL";
    TAG_ID[TAG_ID["SPAN"] = 99] = "SPAN";
    TAG_ID[TAG_ID["STRIKE"] = 100] = "STRIKE";
    TAG_ID[TAG_ID["STRONG"] = 101] = "STRONG";
    TAG_ID[TAG_ID["STYLE"] = 102] = "STYLE";
    TAG_ID[TAG_ID["SUB"] = 103] = "SUB";
    TAG_ID[TAG_ID["SUMMARY"] = 104] = "SUMMARY";
    TAG_ID[TAG_ID["SUP"] = 105] = "SUP";
    TAG_ID[TAG_ID["TABLE"] = 106] = "TABLE";
    TAG_ID[TAG_ID["TBODY"] = 107] = "TBODY";
    TAG_ID[TAG_ID["TEMPLATE"] = 108] = "TEMPLATE";
    TAG_ID[TAG_ID["TEXTAREA"] = 109] = "TEXTAREA";
    TAG_ID[TAG_ID["TFOOT"] = 110] = "TFOOT";
    TAG_ID[TAG_ID["TD"] = 111] = "TD";
    TAG_ID[TAG_ID["TH"] = 112] = "TH";
    TAG_ID[TAG_ID["THEAD"] = 113] = "THEAD";
    TAG_ID[TAG_ID["TITLE"] = 114] = "TITLE";
    TAG_ID[TAG_ID["TR"] = 115] = "TR";
    TAG_ID[TAG_ID["TRACK"] = 116] = "TRACK";
    TAG_ID[TAG_ID["TT"] = 117] = "TT";
    TAG_ID[TAG_ID["U"] = 118] = "U";
    TAG_ID[TAG_ID["UL"] = 119] = "UL";
    TAG_ID[TAG_ID["SVG"] = 120] = "SVG";
    TAG_ID[TAG_ID["VAR"] = 121] = "VAR";
    TAG_ID[TAG_ID["WBR"] = 122] = "WBR";
    TAG_ID[TAG_ID["XMP"] = 123] = "XMP";
})(TAG_ID || (TAG_ID = {}));
const TAG_NAME_TO_ID = new Map([
    [TAG_NAMES.A, TAG_ID.A],
    [TAG_NAMES.ADDRESS, TAG_ID.ADDRESS],
    [TAG_NAMES.ANNOTATION_XML, TAG_ID.ANNOTATION_XML],
    [TAG_NAMES.APPLET, TAG_ID.APPLET],
    [TAG_NAMES.AREA, TAG_ID.AREA],
    [TAG_NAMES.ARTICLE, TAG_ID.ARTICLE],
    [TAG_NAMES.ASIDE, TAG_ID.ASIDE],
    [TAG_NAMES.B, TAG_ID.B],
    [TAG_NAMES.BASE, TAG_ID.BASE],
    [TAG_NAMES.BASEFONT, TAG_ID.BASEFONT],
    [TAG_NAMES.BGSOUND, TAG_ID.BGSOUND],
    [TAG_NAMES.BIG, TAG_ID.BIG],
    [TAG_NAMES.BLOCKQUOTE, TAG_ID.BLOCKQUOTE],
    [TAG_NAMES.BODY, TAG_ID.BODY],
    [TAG_NAMES.BR, TAG_ID.BR],
    [TAG_NAMES.BUTTON, TAG_ID.BUTTON],
    [TAG_NAMES.CAPTION, TAG_ID.CAPTION],
    [TAG_NAMES.CENTER, TAG_ID.CENTER],
    [TAG_NAMES.CODE, TAG_ID.CODE],
    [TAG_NAMES.COL, TAG_ID.COL],
    [TAG_NAMES.COLGROUP, TAG_ID.COLGROUP],
    [TAG_NAMES.DD, TAG_ID.DD],
    [TAG_NAMES.DESC, TAG_ID.DESC],
    [TAG_NAMES.DETAILS, TAG_ID.DETAILS],
    [TAG_NAMES.DIALOG, TAG_ID.DIALOG],
    [TAG_NAMES.DIR, TAG_ID.DIR],
    [TAG_NAMES.DIV, TAG_ID.DIV],
    [TAG_NAMES.DL, TAG_ID.DL],
    [TAG_NAMES.DT, TAG_ID.DT],
    [TAG_NAMES.EM, TAG_ID.EM],
    [TAG_NAMES.EMBED, TAG_ID.EMBED],
    [TAG_NAMES.FIELDSET, TAG_ID.FIELDSET],
    [TAG_NAMES.FIGCAPTION, TAG_ID.FIGCAPTION],
    [TAG_NAMES.FIGURE, TAG_ID.FIGURE],
    [TAG_NAMES.FONT, TAG_ID.FONT],
    [TAG_NAMES.FOOTER, TAG_ID.FOOTER],
    [TAG_NAMES.FOREIGN_OBJECT, TAG_ID.FOREIGN_OBJECT],
    [TAG_NAMES.FORM, TAG_ID.FORM],
    [TAG_NAMES.FRAME, TAG_ID.FRAME],
    [TAG_NAMES.FRAMESET, TAG_ID.FRAMESET],
    [TAG_NAMES.H1, TAG_ID.H1],
    [TAG_NAMES.H2, TAG_ID.H2],
    [TAG_NAMES.H3, TAG_ID.H3],
    [TAG_NAMES.H4, TAG_ID.H4],
    [TAG_NAMES.H5, TAG_ID.H5],
    [TAG_NAMES.H6, TAG_ID.H6],
    [TAG_NAMES.HEAD, TAG_ID.HEAD],
    [TAG_NAMES.HEADER, TAG_ID.HEADER],
    [TAG_NAMES.HGROUP, TAG_ID.HGROUP],
    [TAG_NAMES.HR, TAG_ID.HR],
    [TAG_NAMES.HTML, TAG_ID.HTML],
    [TAG_NAMES.I, TAG_ID.I],
    [TAG_NAMES.IMG, TAG_ID.IMG],
    [TAG_NAMES.IMAGE, TAG_ID.IMAGE],
    [TAG_NAMES.INPUT, TAG_ID.INPUT],
    [TAG_NAMES.IFRAME, TAG_ID.IFRAME],
    [TAG_NAMES.KEYGEN, TAG_ID.KEYGEN],
    [TAG_NAMES.LABEL, TAG_ID.LABEL],
    [TAG_NAMES.LI, TAG_ID.LI],
    [TAG_NAMES.LINK, TAG_ID.LINK],
    [TAG_NAMES.LISTING, TAG_ID.LISTING],
    [TAG_NAMES.MAIN, TAG_ID.MAIN],
    [TAG_NAMES.MALIGNMARK, TAG_ID.MALIGNMARK],
    [TAG_NAMES.MARQUEE, TAG_ID.MARQUEE],
    [TAG_NAMES.MATH, TAG_ID.MATH],
    [TAG_NAMES.MENU, TAG_ID.MENU],
    [TAG_NAMES.META, TAG_ID.META],
    [TAG_NAMES.MGLYPH, TAG_ID.MGLYPH],
    [TAG_NAMES.MI, TAG_ID.MI],
    [TAG_NAMES.MO, TAG_ID.MO],
    [TAG_NAMES.MN, TAG_ID.MN],
    [TAG_NAMES.MS, TAG_ID.MS],
    [TAG_NAMES.MTEXT, TAG_ID.MTEXT],
    [TAG_NAMES.NAV, TAG_ID.NAV],
    [TAG_NAMES.NOBR, TAG_ID.NOBR],
    [TAG_NAMES.NOFRAMES, TAG_ID.NOFRAMES],
    [TAG_NAMES.NOEMBED, TAG_ID.NOEMBED],
    [TAG_NAMES.NOSCRIPT, TAG_ID.NOSCRIPT],
    [TAG_NAMES.OBJECT, TAG_ID.OBJECT],
    [TAG_NAMES.OL, TAG_ID.OL],
    [TAG_NAMES.OPTGROUP, TAG_ID.OPTGROUP],
    [TAG_NAMES.OPTION, TAG_ID.OPTION],
    [TAG_NAMES.P, TAG_ID.P],
    [TAG_NAMES.PARAM, TAG_ID.PARAM],
    [TAG_NAMES.PLAINTEXT, TAG_ID.PLAINTEXT],
    [TAG_NAMES.PRE, TAG_ID.PRE],
    [TAG_NAMES.RB, TAG_ID.RB],
    [TAG_NAMES.RP, TAG_ID.RP],
    [TAG_NAMES.RT, TAG_ID.RT],
    [TAG_NAMES.RTC, TAG_ID.RTC],
    [TAG_NAMES.RUBY, TAG_ID.RUBY],
    [TAG_NAMES.S, TAG_ID.S],
    [TAG_NAMES.SCRIPT, TAG_ID.SCRIPT],
    [TAG_NAMES.SEARCH, TAG_ID.SEARCH],
    [TAG_NAMES.SECTION, TAG_ID.SECTION],
    [TAG_NAMES.SELECT, TAG_ID.SELECT],
    [TAG_NAMES.SOURCE, TAG_ID.SOURCE],
    [TAG_NAMES.SMALL, TAG_ID.SMALL],
    [TAG_NAMES.SPAN, TAG_ID.SPAN],
    [TAG_NAMES.STRIKE, TAG_ID.STRIKE],
    [TAG_NAMES.STRONG, TAG_ID.STRONG],
    [TAG_NAMES.STYLE, TAG_ID.STYLE],
    [TAG_NAMES.SUB, TAG_ID.SUB],
    [TAG_NAMES.SUMMARY, TAG_ID.SUMMARY],
    [TAG_NAMES.SUP, TAG_ID.SUP],
    [TAG_NAMES.TABLE, TAG_ID.TABLE],
    [TAG_NAMES.TBODY, TAG_ID.TBODY],
    [TAG_NAMES.TEMPLATE, TAG_ID.TEMPLATE],
    [TAG_NAMES.TEXTAREA, TAG_ID.TEXTAREA],
    [TAG_NAMES.TFOOT, TAG_ID.TFOOT],
    [TAG_NAMES.TD, TAG_ID.TD],
    [TAG_NAMES.TH, TAG_ID.TH],
    [TAG_NAMES.THEAD, TAG_ID.THEAD],
    [TAG_NAMES.TITLE, TAG_ID.TITLE],
    [TAG_NAMES.TR, TAG_ID.TR],
    [TAG_NAMES.TRACK, TAG_ID.TRACK],
    [TAG_NAMES.TT, TAG_ID.TT],
    [TAG_NAMES.U, TAG_ID.U],
    [TAG_NAMES.UL, TAG_ID.UL],
    [TAG_NAMES.SVG, TAG_ID.SVG],
    [TAG_NAMES.VAR, TAG_ID.VAR],
    [TAG_NAMES.WBR, TAG_ID.WBR],
    [TAG_NAMES.XMP, TAG_ID.XMP],
]);
function getTagID(tagName) {
    var _a;
    return (_a = TAG_NAME_TO_ID.get(tagName)) !== null && _a !== undefined ? _a : TAG_ID.UNKNOWN;
}
const $$1 = TAG_ID;
const SPECIAL_ELEMENTS = {
    [NS.HTML]: new Set([
        $$1.ADDRESS,
        $$1.APPLET,
        $$1.AREA,
        $$1.ARTICLE,
        $$1.ASIDE,
        $$1.BASE,
        $$1.BASEFONT,
        $$1.BGSOUND,
        $$1.BLOCKQUOTE,
        $$1.BODY,
        $$1.BR,
        $$1.BUTTON,
        $$1.CAPTION,
        $$1.CENTER,
        $$1.COL,
        $$1.COLGROUP,
        $$1.DD,
        $$1.DETAILS,
        $$1.DIR,
        $$1.DIV,
        $$1.DL,
        $$1.DT,
        $$1.EMBED,
        $$1.FIELDSET,
        $$1.FIGCAPTION,
        $$1.FIGURE,
        $$1.FOOTER,
        $$1.FORM,
        $$1.FRAME,
        $$1.FRAMESET,
        $$1.H1,
        $$1.H2,
        $$1.H3,
        $$1.H4,
        $$1.H5,
        $$1.H6,
        $$1.HEAD,
        $$1.HEADER,
        $$1.HGROUP,
        $$1.HR,
        $$1.HTML,
        $$1.IFRAME,
        $$1.IMG,
        $$1.INPUT,
        $$1.LI,
        $$1.LINK,
        $$1.LISTING,
        $$1.MAIN,
        $$1.MARQUEE,
        $$1.MENU,
        $$1.META,
        $$1.NAV,
        $$1.NOEMBED,
        $$1.NOFRAMES,
        $$1.NOSCRIPT,
        $$1.OBJECT,
        $$1.OL,
        $$1.P,
        $$1.PARAM,
        $$1.PLAINTEXT,
        $$1.PRE,
        $$1.SCRIPT,
        $$1.SECTION,
        $$1.SELECT,
        $$1.SOURCE,
        $$1.STYLE,
        $$1.SUMMARY,
        $$1.TABLE,
        $$1.TBODY,
        $$1.TD,
        $$1.TEMPLATE,
        $$1.TEXTAREA,
        $$1.TFOOT,
        $$1.TH,
        $$1.THEAD,
        $$1.TITLE,
        $$1.TR,
        $$1.TRACK,
        $$1.UL,
        $$1.WBR,
        $$1.XMP,
    ]),
    [NS.MATHML]: new Set([$$1.MI, $$1.MO, $$1.MN, $$1.MS, $$1.MTEXT, $$1.ANNOTATION_XML]),
    [NS.SVG]: new Set([$$1.TITLE, $$1.FOREIGN_OBJECT, $$1.DESC]),
    [NS.XLINK]: new Set(),
    [NS.XML]: new Set(),
    [NS.XMLNS]: new Set(),
};
const NUMBERED_HEADERS = new Set([$$1.H1, $$1.H2, $$1.H3, $$1.H4, $$1.H5, $$1.H6]);
new Set([
    TAG_NAMES.STYLE,
    TAG_NAMES.SCRIPT,
    TAG_NAMES.XMP,
    TAG_NAMES.IFRAME,
    TAG_NAMES.NOEMBED,
    TAG_NAMES.NOFRAMES,
    TAG_NAMES.PLAINTEXT,
]);

//States
var State;
(function (State) {
    State[State["DATA"] = 0] = "DATA";
    State[State["RCDATA"] = 1] = "RCDATA";
    State[State["RAWTEXT"] = 2] = "RAWTEXT";
    State[State["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
    State[State["PLAINTEXT"] = 4] = "PLAINTEXT";
    State[State["TAG_OPEN"] = 5] = "TAG_OPEN";
    State[State["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
    State[State["TAG_NAME"] = 7] = "TAG_NAME";
    State[State["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
    State[State["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
    State[State["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
    State[State["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
    State[State["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
    State[State["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
    State[State["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
    State[State["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
    State[State["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
    State[State["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
    State[State["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
    State[State["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
    State[State["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
    State[State["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
    State[State["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
    State[State["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
    State[State["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
    State[State["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
    State[State["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
    State[State["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
    State[State["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
    State[State["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
    State[State["COMMENT_START"] = 42] = "COMMENT_START";
    State[State["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
    State[State["COMMENT"] = 44] = "COMMENT";
    State[State["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
    State[State["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
    State[State["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
    State[State["COMMENT_END"] = 50] = "COMMENT_END";
    State[State["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
    State[State["DOCTYPE"] = 52] = "DOCTYPE";
    State[State["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
    State[State["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
    State[State["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
    State[State["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
    State[State["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
    State[State["CDATA_SECTION"] = 68] = "CDATA_SECTION";
    State[State["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
    State[State["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
    State[State["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
    State[State["AMBIGUOUS_AMPERSAND"] = 72] = "AMBIGUOUS_AMPERSAND";
})(State || (State = {}));
//Tokenizer initial states for different modes
const TokenizerMode = {
    DATA: State.DATA,
    RCDATA: State.RCDATA,
    RAWTEXT: State.RAWTEXT,
    SCRIPT_DATA: State.SCRIPT_DATA,
    PLAINTEXT: State.PLAINTEXT,
    CDATA_SECTION: State.CDATA_SECTION,
};
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isAsciiDigit(cp) {
    return cp >= CODE_POINTS.DIGIT_0 && cp <= CODE_POINTS.DIGIT_9;
}
function isAsciiUpper(cp) {
    return cp >= CODE_POINTS.LATIN_CAPITAL_A && cp <= CODE_POINTS.LATIN_CAPITAL_Z;
}
function isAsciiLower(cp) {
    return cp >= CODE_POINTS.LATIN_SMALL_A && cp <= CODE_POINTS.LATIN_SMALL_Z;
}
function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}
function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}
function toAsciiLower(cp) {
    return cp + 32;
}
function isWhitespace(cp) {
    return cp === CODE_POINTS.SPACE || cp === CODE_POINTS.LINE_FEED || cp === CODE_POINTS.TABULATION || cp === CODE_POINTS.FORM_FEED;
}
function isScriptDataDoubleEscapeSequenceEnd(cp) {
    return isWhitespace(cp) || cp === CODE_POINTS.SOLIDUS || cp === CODE_POINTS.GREATER_THAN_SIGN;
}
function getErrorForNumericCharacterReference(code) {
    if (code === CODE_POINTS.NULL) {
        return ERR.nullCharacterReference;
    }
    else if (code > 1114111) {
        return ERR.characterReferenceOutsideUnicodeRange;
    }
    else if (isSurrogate(code)) {
        return ERR.surrogateCharacterReference;
    }
    else if (isUndefinedCodePoint(code)) {
        return ERR.noncharacterCharacterReference;
    }
    else if (isControlCodePoint(code) || code === CODE_POINTS.CARRIAGE_RETURN) {
        return ERR.controlCharacterReference;
    }
    return null;
}
//Tokenizer
class Tokenizer {
    constructor(options, handler) {
        this.options = options;
        this.handler = handler;
        this.paused = false;
        /** Ensures that the parsing loop isn't run multiple times at once. */
        this.inLoop = false;
        /**
         * Indicates that the current adjusted node exists, is not an element in the HTML namespace,
         * and that it is not an integration point for either MathML or HTML.
         *
         * @see {@link https://html.spec.whatwg.org/multipage/parsing.html#tree-construction}
         */
        this.inForeignNode = false;
        this.lastStartTagName = '';
        this.active = false;
        this.state = State.DATA;
        this.returnState = State.DATA;
        this.entityStartPos = 0;
        this.consumedAfterSnapshot = -1;
        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = { name: '', value: '' };
        this.preprocessor = new Preprocessor(handler);
        this.currentLocation = this.getCurrentLocation(-1);
        this.entityDecoder = new EntityDecoder(htmlDecodeTree, (cp, consumed) => {
            // Note: Set `pos` _before_ flushing, as flushing might drop
            // the current chunk and invalidate `entityStartPos`.
            this.preprocessor.pos = this.entityStartPos + consumed - 1;
            this._flushCodePointConsumedAsCharacterReference(cp);
        }, handler.onParseError
            ? {
                missingSemicolonAfterCharacterReference: () => {
                    this._err(ERR.missingSemicolonAfterCharacterReference, 1);
                },
                absenceOfDigitsInNumericCharacterReference: (consumed) => {
                    this._err(ERR.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + consumed);
                },
                validateNumericCharacterReference: (code) => {
                    const error = getErrorForNumericCharacterReference(code);
                    if (error)
                        this._err(error, 1);
                },
            }
            : undefined);
    }
    //Errors
    _err(code, cpOffset = 0) {
        var _a, _b;
        (_b = (_a = this.handler).onParseError) === null || _b === undefined ? undefined : _b.call(_a, this.preprocessor.getError(code, cpOffset));
    }
    // NOTE: `offset` may never run across line boundaries.
    getCurrentLocation(offset) {
        if (!this.options.sourceCodeLocationInfo) {
            return null;
        }
        return {
            startLine: this.preprocessor.line,
            startCol: this.preprocessor.col - offset,
            startOffset: this.preprocessor.offset - offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1,
        };
    }
    _runParsingLoop() {
        if (this.inLoop)
            return;
        this.inLoop = true;
        while (this.active && !this.paused) {
            this.consumedAfterSnapshot = 0;
            const cp = this._consume();
            if (!this._ensureHibernation()) {
                this._callState(cp);
            }
        }
        this.inLoop = false;
    }
    //API
    pause() {
        this.paused = true;
    }
    resume(writeCallback) {
        if (!this.paused) {
            throw new Error('Parser was already resumed');
        }
        this.paused = false;
        // Necessary for synchronous resume.
        if (this.inLoop)
            return;
        this._runParsingLoop();
        if (!this.paused) {
            writeCallback === null || writeCallback === undefined ? undefined : writeCallback();
        }
    }
    write(chunk, isLastChunk, writeCallback) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
        this._runParsingLoop();
        if (!this.paused) {
            writeCallback === null || writeCallback === undefined ? undefined : writeCallback();
        }
    }
    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
        this._runParsingLoop();
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            this.preprocessor.retreat(this.consumedAfterSnapshot);
            this.consumedAfterSnapshot = 0;
            this.active = false;
            return true;
        }
        return false;
    }
    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }
    _advanceBy(count) {
        this.consumedAfterSnapshot += count;
        for (let i = 0; i < count; i++) {
            this.preprocessor.advance();
        }
    }
    _consumeSequenceIfMatch(pattern, caseSensitive) {
        if (this.preprocessor.startsWith(pattern, caseSensitive)) {
            // We will already have consumed one character before calling this method.
            this._advanceBy(pattern.length - 1);
            return true;
        }
        return false;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: TokenType.START_TAG,
            tagName: '',
            tagID: TAG_ID.UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(1),
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: TokenType.END_TAG,
            tagName: '',
            tagID: TAG_ID.UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(2),
        };
    }
    _createCommentToken(offset) {
        this.currentToken = {
            type: TokenType.COMMENT,
            data: '',
            location: this.getCurrentLocation(offset),
        };
    }
    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: TokenType.DOCTYPE,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null,
            location: this.currentLocation,
        };
    }
    _createCharacterToken(type, chars) {
        this.currentCharacterToken = {
            type,
            chars,
            location: this.currentLocation,
        };
    }
    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: '',
        };
        this.currentLocation = this.getCurrentLocation(0);
    }
    _leaveAttrName() {
        var _a;
        var _b;
        const token = this.currentToken;
        if (getTokenAttr(token, this.currentAttr.name) === null) {
            token.attrs.push(this.currentAttr);
            if (token.location && this.currentLocation) {
                const attrLocations = ((_a = (_b = token.location).attrs) !== null && _a !== undefined ? _a : (_b.attrs = Object.create(null)));
                attrLocations[this.currentAttr.name] = this.currentLocation;
                // Set end location
                this._leaveAttrValue();
            }
        }
        else {
            this._err(ERR.duplicateAttribute);
        }
    }
    _leaveAttrValue() {
        if (this.currentLocation) {
            this.currentLocation.endLine = this.preprocessor.line;
            this.currentLocation.endCol = this.preprocessor.col;
            this.currentLocation.endOffset = this.preprocessor.offset;
        }
    }
    //Token emission
    prepareToken(ct) {
        this._emitCurrentCharacterToken(ct.location);
        this.currentToken = null;
        if (ct.location) {
            ct.location.endLine = this.preprocessor.line;
            ct.location.endCol = this.preprocessor.col + 1;
            ct.location.endOffset = this.preprocessor.offset + 1;
        }
        this.currentLocation = this.getCurrentLocation(-1);
    }
    emitCurrentTagToken() {
        const ct = this.currentToken;
        this.prepareToken(ct);
        ct.tagID = getTagID(ct.tagName);
        if (ct.type === TokenType.START_TAG) {
            this.lastStartTagName = ct.tagName;
            this.handler.onStartTag(ct);
        }
        else {
            if (ct.attrs.length > 0) {
                this._err(ERR.endTagWithAttributes);
            }
            if (ct.selfClosing) {
                this._err(ERR.endTagWithTrailingSolidus);
            }
            this.handler.onEndTag(ct);
        }
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentComment(ct) {
        this.prepareToken(ct);
        this.handler.onComment(ct);
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentDoctype(ct) {
        this.prepareToken(ct);
        this.handler.onDoctype(ct);
        this.preprocessor.dropParsedChunk();
    }
    _emitCurrentCharacterToken(nextLocation) {
        if (this.currentCharacterToken) {
            //NOTE: if we have a pending character token, make it's end location equal to the
            //current token's start location.
            if (nextLocation && this.currentCharacterToken.location) {
                this.currentCharacterToken.location.endLine = nextLocation.startLine;
                this.currentCharacterToken.location.endCol = nextLocation.startCol;
                this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
            }
            switch (this.currentCharacterToken.type) {
                case TokenType.CHARACTER: {
                    this.handler.onCharacter(this.currentCharacterToken);
                    break;
                }
                case TokenType.NULL_CHARACTER: {
                    this.handler.onNullCharacter(this.currentCharacterToken);
                    break;
                }
                case TokenType.WHITESPACE_CHARACTER: {
                    this.handler.onWhitespaceCharacter(this.currentCharacterToken);
                    break;
                }
            }
            this.currentCharacterToken = null;
        }
    }
    _emitEOFToken() {
        const location = this.getCurrentLocation(0);
        if (location) {
            location.endLine = location.startLine;
            location.endCol = location.startCol;
            location.endOffset = location.startOffset;
        }
        this._emitCurrentCharacterToken(location);
        this.handler.onEof({ type: TokenType.EOF, location });
        this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: The specification uses only one type of character token (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken) {
            if (this.currentCharacterToken.type === type) {
                this.currentCharacterToken.chars += ch;
                return;
            }
            else {
                this.currentLocation = this.getCurrentLocation(0);
                this._emitCurrentCharacterToken(this.currentLocation);
                this.preprocessor.dropParsedChunk();
            }
        }
        this._createCharacterToken(type, ch);
    }
    _emitCodePoint(cp) {
        const type = isWhitespace(cp)
            ? TokenType.WHITESPACE_CHARACTER
            : cp === CODE_POINTS.NULL
                ? TokenType.NULL_CHARACTER
                : TokenType.CHARACTER;
        this._appendCharToCurrentCharacterToken(type, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken(TokenType.CHARACTER, ch);
    }
    // Character reference helpers
    _startCharacterReference() {
        this.returnState = this.state;
        this.state = State.CHARACTER_REFERENCE;
        this.entityStartPos = this.preprocessor.pos;
        this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? DecodingMode.Attribute : DecodingMode.Legacy);
    }
    _isCharacterReferenceInAttribute() {
        return (this.returnState === State.ATTRIBUTE_VALUE_DOUBLE_QUOTED ||
            this.returnState === State.ATTRIBUTE_VALUE_SINGLE_QUOTED ||
            this.returnState === State.ATTRIBUTE_VALUE_UNQUOTED);
    }
    _flushCodePointConsumedAsCharacterReference(cp) {
        if (this._isCharacterReferenceInAttribute()) {
            this.currentAttr.value += String.fromCodePoint(cp);
        }
        else {
            this._emitCodePoint(cp);
        }
    }
    // Calling states this way turns out to be much faster than any other approach.
    _callState(cp) {
        switch (this.state) {
            case State.DATA: {
                this._stateData(cp);
                break;
            }
            case State.RCDATA: {
                this._stateRcdata(cp);
                break;
            }
            case State.RAWTEXT: {
                this._stateRawtext(cp);
                break;
            }
            case State.SCRIPT_DATA: {
                this._stateScriptData(cp);
                break;
            }
            case State.PLAINTEXT: {
                this._statePlaintext(cp);
                break;
            }
            case State.TAG_OPEN: {
                this._stateTagOpen(cp);
                break;
            }
            case State.END_TAG_OPEN: {
                this._stateEndTagOpen(cp);
                break;
            }
            case State.TAG_NAME: {
                this._stateTagName(cp);
                break;
            }
            case State.RCDATA_LESS_THAN_SIGN: {
                this._stateRcdataLessThanSign(cp);
                break;
            }
            case State.RCDATA_END_TAG_OPEN: {
                this._stateRcdataEndTagOpen(cp);
                break;
            }
            case State.RCDATA_END_TAG_NAME: {
                this._stateRcdataEndTagName(cp);
                break;
            }
            case State.RAWTEXT_LESS_THAN_SIGN: {
                this._stateRawtextLessThanSign(cp);
                break;
            }
            case State.RAWTEXT_END_TAG_OPEN: {
                this._stateRawtextEndTagOpen(cp);
                break;
            }
            case State.RAWTEXT_END_TAG_NAME: {
                this._stateRawtextEndTagName(cp);
                break;
            }
            case State.SCRIPT_DATA_LESS_THAN_SIGN: {
                this._stateScriptDataLessThanSign(cp);
                break;
            }
            case State.SCRIPT_DATA_END_TAG_OPEN: {
                this._stateScriptDataEndTagOpen(cp);
                break;
            }
            case State.SCRIPT_DATA_END_TAG_NAME: {
                this._stateScriptDataEndTagName(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPE_START: {
                this._stateScriptDataEscapeStart(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPE_START_DASH: {
                this._stateScriptDataEscapeStartDash(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPED: {
                this._stateScriptDataEscaped(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPED_DASH: {
                this._stateScriptDataEscapedDash(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPED_DASH_DASH: {
                this._stateScriptDataEscapedDashDash(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
                this._stateScriptDataEscapedLessThanSign(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
                this._stateScriptDataEscapedEndTagOpen(cp);
                break;
            }
            case State.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
                this._stateScriptDataEscapedEndTagName(cp);
                break;
            }
            case State.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
                this._stateScriptDataDoubleEscapeStart(cp);
                break;
            }
            case State.SCRIPT_DATA_DOUBLE_ESCAPED: {
                this._stateScriptDataDoubleEscaped(cp);
                break;
            }
            case State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
                this._stateScriptDataDoubleEscapedDash(cp);
                break;
            }
            case State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
                this._stateScriptDataDoubleEscapedDashDash(cp);
                break;
            }
            case State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
                this._stateScriptDataDoubleEscapedLessThanSign(cp);
                break;
            }
            case State.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
                this._stateScriptDataDoubleEscapeEnd(cp);
                break;
            }
            case State.BEFORE_ATTRIBUTE_NAME: {
                this._stateBeforeAttributeName(cp);
                break;
            }
            case State.ATTRIBUTE_NAME: {
                this._stateAttributeName(cp);
                break;
            }
            case State.AFTER_ATTRIBUTE_NAME: {
                this._stateAfterAttributeName(cp);
                break;
            }
            case State.BEFORE_ATTRIBUTE_VALUE: {
                this._stateBeforeAttributeValue(cp);
                break;
            }
            case State.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
                this._stateAttributeValueDoubleQuoted(cp);
                break;
            }
            case State.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
                this._stateAttributeValueSingleQuoted(cp);
                break;
            }
            case State.ATTRIBUTE_VALUE_UNQUOTED: {
                this._stateAttributeValueUnquoted(cp);
                break;
            }
            case State.AFTER_ATTRIBUTE_VALUE_QUOTED: {
                this._stateAfterAttributeValueQuoted(cp);
                break;
            }
            case State.SELF_CLOSING_START_TAG: {
                this._stateSelfClosingStartTag(cp);
                break;
            }
            case State.BOGUS_COMMENT: {
                this._stateBogusComment(cp);
                break;
            }
            case State.MARKUP_DECLARATION_OPEN: {
                this._stateMarkupDeclarationOpen(cp);
                break;
            }
            case State.COMMENT_START: {
                this._stateCommentStart(cp);
                break;
            }
            case State.COMMENT_START_DASH: {
                this._stateCommentStartDash(cp);
                break;
            }
            case State.COMMENT: {
                this._stateComment(cp);
                break;
            }
            case State.COMMENT_LESS_THAN_SIGN: {
                this._stateCommentLessThanSign(cp);
                break;
            }
            case State.COMMENT_LESS_THAN_SIGN_BANG: {
                this._stateCommentLessThanSignBang(cp);
                break;
            }
            case State.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
                this._stateCommentLessThanSignBangDash(cp);
                break;
            }
            case State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
                this._stateCommentLessThanSignBangDashDash(cp);
                break;
            }
            case State.COMMENT_END_DASH: {
                this._stateCommentEndDash(cp);
                break;
            }
            case State.COMMENT_END: {
                this._stateCommentEnd(cp);
                break;
            }
            case State.COMMENT_END_BANG: {
                this._stateCommentEndBang(cp);
                break;
            }
            case State.DOCTYPE: {
                this._stateDoctype(cp);
                break;
            }
            case State.BEFORE_DOCTYPE_NAME: {
                this._stateBeforeDoctypeName(cp);
                break;
            }
            case State.DOCTYPE_NAME: {
                this._stateDoctypeName(cp);
                break;
            }
            case State.AFTER_DOCTYPE_NAME: {
                this._stateAfterDoctypeName(cp);
                break;
            }
            case State.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
                this._stateAfterDoctypePublicKeyword(cp);
                break;
            }
            case State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
                this._stateBeforeDoctypePublicIdentifier(cp);
                break;
            }
            case State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
                this._stateDoctypePublicIdentifierDoubleQuoted(cp);
                break;
            }
            case State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
                this._stateDoctypePublicIdentifierSingleQuoted(cp);
                break;
            }
            case State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
                this._stateAfterDoctypePublicIdentifier(cp);
                break;
            }
            case State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
                this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
                break;
            }
            case State.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
                this._stateAfterDoctypeSystemKeyword(cp);
                break;
            }
            case State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
                this._stateBeforeDoctypeSystemIdentifier(cp);
                break;
            }
            case State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
                this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
                break;
            }
            case State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
                this._stateDoctypeSystemIdentifierSingleQuoted(cp);
                break;
            }
            case State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
                this._stateAfterDoctypeSystemIdentifier(cp);
                break;
            }
            case State.BOGUS_DOCTYPE: {
                this._stateBogusDoctype(cp);
                break;
            }
            case State.CDATA_SECTION: {
                this._stateCdataSection(cp);
                break;
            }
            case State.CDATA_SECTION_BRACKET: {
                this._stateCdataSectionBracket(cp);
                break;
            }
            case State.CDATA_SECTION_END: {
                this._stateCdataSectionEnd(cp);
                break;
            }
            case State.CHARACTER_REFERENCE: {
                this._stateCharacterReference();
                break;
            }
            case State.AMBIGUOUS_AMPERSAND: {
                this._stateAmbiguousAmpersand(cp);
                break;
            }
            default: {
                throw new Error('Unknown state');
            }
        }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    _stateData(cp) {
        switch (cp) {
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.TAG_OPEN;
                break;
            }
            case CODE_POINTS.AMPERSAND: {
                this._startCharacterReference();
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitCodePoint(cp);
                break;
            }
            case CODE_POINTS.EOF: {
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    //  RCDATA state
    //------------------------------------------------------------------
    _stateRcdata(cp) {
        switch (cp) {
            case CODE_POINTS.AMPERSAND: {
                this._startCharacterReference();
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.RCDATA_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    _stateRawtext(cp) {
        switch (cp) {
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.RAWTEXT_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data state
    //------------------------------------------------------------------
    _stateScriptData(cp) {
        switch (cp) {
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    _statePlaintext(cp) {
        switch (cp) {
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // Tag open state
    //------------------------------------------------------------------
    _stateTagOpen(cp) {
        if (isAsciiLetter(cp)) {
            this._createStartTagToken();
            this.state = State.TAG_NAME;
            this._stateTagName(cp);
        }
        else
            switch (cp) {
                case CODE_POINTS.EXCLAMATION_MARK: {
                    this.state = State.MARKUP_DECLARATION_OPEN;
                    break;
                }
                case CODE_POINTS.SOLIDUS: {
                    this.state = State.END_TAG_OPEN;
                    break;
                }
                case CODE_POINTS.QUESTION_MARK: {
                    this._err(ERR.unexpectedQuestionMarkInsteadOfTagName);
                    this._createCommentToken(1);
                    this.state = State.BOGUS_COMMENT;
                    this._stateBogusComment(cp);
                    break;
                }
                case CODE_POINTS.EOF: {
                    this._err(ERR.eofBeforeTagName);
                    this._emitChars('<');
                    this._emitEOFToken();
                    break;
                }
                default: {
                    this._err(ERR.invalidFirstCharacterOfTagName);
                    this._emitChars('<');
                    this.state = State.DATA;
                    this._stateData(cp);
                }
            }
    }
    // End tag open state
    //------------------------------------------------------------------
    _stateEndTagOpen(cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this.state = State.TAG_NAME;
            this._stateTagName(cp);
        }
        else
            switch (cp) {
                case CODE_POINTS.GREATER_THAN_SIGN: {
                    this._err(ERR.missingEndTagName);
                    this.state = State.DATA;
                    break;
                }
                case CODE_POINTS.EOF: {
                    this._err(ERR.eofBeforeTagName);
                    this._emitChars('</');
                    this._emitEOFToken();
                    break;
                }
                default: {
                    this._err(ERR.invalidFirstCharacterOfTagName);
                    this._createCommentToken(2);
                    this.state = State.BOGUS_COMMENT;
                    this._stateBogusComment(cp);
                }
            }
    }
    // Tag name state
    //------------------------------------------------------------------
    _stateTagName(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this.state = State.BEFORE_ATTRIBUTE_NAME;
                break;
            }
            case CODE_POINTS.SOLIDUS: {
                this.state = State.SELF_CLOSING_START_TAG;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentTagToken();
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.tagName += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                token.tagName += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
            }
        }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    _stateRcdataLessThanSign(cp) {
        if (cp === CODE_POINTS.SOLIDUS) {
            this.state = State.RCDATA_END_TAG_OPEN;
        }
        else {
            this._emitChars('<');
            this.state = State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    _stateRcdataEndTagOpen(cp) {
        if (isAsciiLetter(cp)) {
            this.state = State.RCDATA_END_TAG_NAME;
            this._stateRcdataEndTagName(cp);
        }
        else {
            this._emitChars('</');
            this.state = State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    handleSpecialEndTag(_cp) {
        if (!this.preprocessor.startsWith(this.lastStartTagName, false)) {
            return !this._ensureHibernation();
        }
        this._createEndTagToken();
        const token = this.currentToken;
        token.tagName = this.lastStartTagName;
        const cp = this.preprocessor.peek(this.lastStartTagName.length);
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this._advanceBy(this.lastStartTagName.length);
                this.state = State.BEFORE_ATTRIBUTE_NAME;
                return false;
            }
            case CODE_POINTS.SOLIDUS: {
                this._advanceBy(this.lastStartTagName.length);
                this.state = State.SELF_CLOSING_START_TAG;
                return false;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._advanceBy(this.lastStartTagName.length);
                this.emitCurrentTagToken();
                this.state = State.DATA;
                return false;
            }
            default: {
                return !this._ensureHibernation();
            }
        }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    _stateRcdataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    _stateRawtextLessThanSign(cp) {
        if (cp === CODE_POINTS.SOLIDUS) {
            this.state = State.RAWTEXT_END_TAG_OPEN;
        }
        else {
            this._emitChars('<');
            this.state = State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    _stateRawtextEndTagOpen(cp) {
        if (isAsciiLetter(cp)) {
            this.state = State.RAWTEXT_END_TAG_NAME;
            this._stateRawtextEndTagName(cp);
        }
        else {
            this._emitChars('</');
            this.state = State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    _stateRawtextEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataLessThanSign(cp) {
        switch (cp) {
            case CODE_POINTS.SOLIDUS: {
                this.state = State.SCRIPT_DATA_END_TAG_OPEN;
                break;
            }
            case CODE_POINTS.EXCLAMATION_MARK: {
                this.state = State.SCRIPT_DATA_ESCAPE_START;
                this._emitChars('<!');
                break;
            }
            default: {
                this._emitChars('<');
                this.state = State.SCRIPT_DATA;
                this._stateScriptData(cp);
            }
        }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEndTagOpen(cp) {
        if (isAsciiLetter(cp)) {
            this.state = State.SCRIPT_DATA_END_TAG_NAME;
            this._stateScriptDataEndTagName(cp);
        }
        else {
            this._emitChars('</');
            this.state = State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStart(cp) {
        if (cp === CODE_POINTS.HYPHEN_MINUS) {
            this.state = State.SCRIPT_DATA_ESCAPE_START_DASH;
            this._emitChars('-');
        }
        else {
            this.state = State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStartDash(cp) {
        if (cp === CODE_POINTS.HYPHEN_MINUS) {
            this.state = State.SCRIPT_DATA_ESCAPED_DASH_DASH;
            this._emitChars('-');
        }
        else {
            this.state = State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escaped state
    //------------------------------------------------------------------
    _stateScriptDataEscaped(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.SCRIPT_DATA_ESCAPED_DASH;
                this._emitChars('-');
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDash(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.SCRIPT_DATA_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.state = State.SCRIPT_DATA_ESCAPED;
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            }
            default: {
                this.state = State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDashDash(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this._emitChars('-');
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.state = State.SCRIPT_DATA_ESCAPED;
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            }
            default: {
                this.state = State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataEscapedLessThanSign(cp) {
        if (cp === CODE_POINTS.SOLIDUS) {
            this.state = State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
        }
        else if (isAsciiLetter(cp)) {
            this._emitChars('<');
            this.state = State.SCRIPT_DATA_DOUBLE_ESCAPE_START;
            this._stateScriptDataDoubleEscapeStart(cp);
        }
        else {
            this._emitChars('<');
            this.state = State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagOpen(cp) {
        if (isAsciiLetter(cp)) {
            this.state = State.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
            this._stateScriptDataEscapedEndTagName(cp);
        }
        else {
            this._emitChars('</');
            this.state = State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeStart(cp) {
        if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, false) &&
            isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
            this._emitCodePoint(cp);
            for (let i = 0; i < SEQUENCES.SCRIPT.length; i++) {
                this._emitCodePoint(this._consume());
            }
            this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
        }
        else if (!this._ensureHibernation()) {
            this.state = State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscaped(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
                this._emitChars('-');
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDash(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            }
            default: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDashDash(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this._emitChars('-');
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars(REPLACEMENT_CHARACTER);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            }
            default: {
                this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
            }
        }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedLessThanSign(cp) {
        if (cp === CODE_POINTS.SOLIDUS) {
            this.state = State.SCRIPT_DATA_DOUBLE_ESCAPE_END;
            this._emitChars('/');
        }
        else {
            this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeEnd(cp) {
        if (this.preprocessor.startsWith(SEQUENCES.SCRIPT, false) &&
            isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek(SEQUENCES.SCRIPT.length))) {
            this._emitCodePoint(cp);
            for (let i = 0; i < SEQUENCES.SCRIPT.length; i++) {
                this._emitCodePoint(this._consume());
            }
            this.state = State.SCRIPT_DATA_ESCAPED;
        }
        else if (!this._ensureHibernation()) {
            this.state = State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Before attribute name state
    //------------------------------------------------------------------
    _stateBeforeAttributeName(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.SOLIDUS:
            case CODE_POINTS.GREATER_THAN_SIGN:
            case CODE_POINTS.EOF: {
                this.state = State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            }
            case CODE_POINTS.EQUALS_SIGN: {
                this._err(ERR.unexpectedEqualsSignBeforeAttributeName);
                this._createAttr('=');
                this.state = State.ATTRIBUTE_NAME;
                break;
            }
            default: {
                this._createAttr('');
                this.state = State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
            }
        }
    }
    // Attribute name state
    //------------------------------------------------------------------
    _stateAttributeName(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED:
            case CODE_POINTS.SOLIDUS:
            case CODE_POINTS.GREATER_THAN_SIGN:
            case CODE_POINTS.EOF: {
                this._leaveAttrName();
                this.state = State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            }
            case CODE_POINTS.EQUALS_SIGN: {
                this._leaveAttrName();
                this.state = State.BEFORE_ATTRIBUTE_VALUE;
                break;
            }
            case CODE_POINTS.QUOTATION_MARK:
            case CODE_POINTS.APOSTROPHE:
            case CODE_POINTS.LESS_THAN_SIGN: {
                this._err(ERR.unexpectedCharacterInAttributeName);
                this.currentAttr.name += String.fromCodePoint(cp);
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.currentAttr.name += REPLACEMENT_CHARACTER;
                break;
            }
            default: {
                this.currentAttr.name += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
            }
        }
    }
    // After attribute name state
    //------------------------------------------------------------------
    _stateAfterAttributeName(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.SOLIDUS: {
                this.state = State.SELF_CLOSING_START_TAG;
                break;
            }
            case CODE_POINTS.EQUALS_SIGN: {
                this.state = State.BEFORE_ATTRIBUTE_VALUE;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentTagToken();
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                this._createAttr('');
                this.state = State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
            }
        }
    }
    // Before attribute value state
    //------------------------------------------------------------------
    _stateBeforeAttributeValue(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                this.state = State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                this.state = State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.missingAttributeValue);
                this.state = State.DATA;
                this.emitCurrentTagToken();
                break;
            }
            default: {
                this.state = State.ATTRIBUTE_VALUE_UNQUOTED;
                this._stateAttributeValueUnquoted(cp);
            }
        }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueDoubleQuoted(cp) {
        switch (cp) {
            case CODE_POINTS.QUOTATION_MARK: {
                this.state = State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            }
            case CODE_POINTS.AMPERSAND: {
                this._startCharacterReference();
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.currentAttr.value += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                this.currentAttr.value += String.fromCodePoint(cp);
            }
        }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueSingleQuoted(cp) {
        switch (cp) {
            case CODE_POINTS.APOSTROPHE: {
                this.state = State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            }
            case CODE_POINTS.AMPERSAND: {
                this._startCharacterReference();
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.currentAttr.value += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                this.currentAttr.value += String.fromCodePoint(cp);
            }
        }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    _stateAttributeValueUnquoted(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this._leaveAttrValue();
                this.state = State.BEFORE_ATTRIBUTE_NAME;
                break;
            }
            case CODE_POINTS.AMPERSAND: {
                this._startCharacterReference();
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._leaveAttrValue();
                this.state = State.DATA;
                this.emitCurrentTagToken();
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                this.currentAttr.value += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.QUOTATION_MARK:
            case CODE_POINTS.APOSTROPHE:
            case CODE_POINTS.LESS_THAN_SIGN:
            case CODE_POINTS.EQUALS_SIGN:
            case CODE_POINTS.GRAVE_ACCENT: {
                this._err(ERR.unexpectedCharacterInUnquotedAttributeValue);
                this.currentAttr.value += String.fromCodePoint(cp);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                this.currentAttr.value += String.fromCodePoint(cp);
            }
        }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    _stateAfterAttributeValueQuoted(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this._leaveAttrValue();
                this.state = State.BEFORE_ATTRIBUTE_NAME;
                break;
            }
            case CODE_POINTS.SOLIDUS: {
                this._leaveAttrValue();
                this.state = State.SELF_CLOSING_START_TAG;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._leaveAttrValue();
                this.state = State.DATA;
                this.emitCurrentTagToken();
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingWhitespaceBetweenAttributes);
                this.state = State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
            }
        }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    _stateSelfClosingStartTag(cp) {
        switch (cp) {
            case CODE_POINTS.GREATER_THAN_SIGN: {
                const token = this.currentToken;
                token.selfClosing = true;
                this.state = State.DATA;
                this.emitCurrentTagToken();
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInTag);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.unexpectedSolidusInTag);
                this.state = State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
            }
        }
    }
    // Bogus comment state
    //------------------------------------------------------------------
    _stateBogusComment(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentComment(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.data += REPLACEMENT_CHARACTER;
                break;
            }
            default: {
                token.data += String.fromCodePoint(cp);
            }
        }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    _stateMarkupDeclarationOpen(cp) {
        if (this._consumeSequenceIfMatch(SEQUENCES.DASH_DASH, true)) {
            this._createCommentToken(SEQUENCES.DASH_DASH.length + 1);
            this.state = State.COMMENT_START;
        }
        else if (this._consumeSequenceIfMatch(SEQUENCES.DOCTYPE, false)) {
            // NOTE: Doctypes tokens are created without fixed offsets. We keep track of the moment a doctype *might* start here.
            this.currentLocation = this.getCurrentLocation(SEQUENCES.DOCTYPE.length + 1);
            this.state = State.DOCTYPE;
        }
        else if (this._consumeSequenceIfMatch(SEQUENCES.CDATA_START, true)) {
            if (this.inForeignNode) {
                this.state = State.CDATA_SECTION;
            }
            else {
                this._err(ERR.cdataInHtmlContent);
                this._createCommentToken(SEQUENCES.CDATA_START.length + 1);
                this.currentToken.data = '[CDATA[';
                this.state = State.BOGUS_COMMENT;
            }
        }
        //NOTE: Sequence lookups can be abrupted by hibernation. In that case, lookup
        //results are no longer valid and we will need to start over.
        else if (!this._ensureHibernation()) {
            this._err(ERR.incorrectlyOpenedComment);
            this._createCommentToken(2);
            this.state = State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
        }
    }
    // Comment start state
    //------------------------------------------------------------------
    _stateCommentStart(cp) {
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.COMMENT_START_DASH;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.abruptClosingOfEmptyComment);
                this.state = State.DATA;
                const token = this.currentToken;
                this.emitCurrentComment(token);
                break;
            }
            default: {
                this.state = State.COMMENT;
                this._stateComment(cp);
            }
        }
    }
    // Comment start dash state
    //------------------------------------------------------------------
    _stateCommentStartDash(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.COMMENT_END;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.abruptClosingOfEmptyComment);
                this.state = State.DATA;
                this.emitCurrentComment(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.data += '-';
                this.state = State.COMMENT;
                this._stateComment(cp);
            }
        }
    }
    // Comment state
    //------------------------------------------------------------------
    _stateComment(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.COMMENT_END_DASH;
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                token.data += '<';
                this.state = State.COMMENT_LESS_THAN_SIGN;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.data += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.data += String.fromCodePoint(cp);
            }
        }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    _stateCommentLessThanSign(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.EXCLAMATION_MARK: {
                token.data += '!';
                this.state = State.COMMENT_LESS_THAN_SIGN_BANG;
                break;
            }
            case CODE_POINTS.LESS_THAN_SIGN: {
                token.data += '<';
                break;
            }
            default: {
                this.state = State.COMMENT;
                this._stateComment(cp);
            }
        }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBang(cp) {
        if (cp === CODE_POINTS.HYPHEN_MINUS) {
            this.state = State.COMMENT_LESS_THAN_SIGN_BANG_DASH;
        }
        else {
            this.state = State.COMMENT;
            this._stateComment(cp);
        }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDash(cp) {
        if (cp === CODE_POINTS.HYPHEN_MINUS) {
            this.state = State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
        }
        else {
            this.state = State.COMMENT_END_DASH;
            this._stateCommentEndDash(cp);
        }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDashDash(cp) {
        if (cp !== CODE_POINTS.GREATER_THAN_SIGN && cp !== CODE_POINTS.EOF) {
            this._err(ERR.nestedComment);
        }
        this.state = State.COMMENT_END;
        this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    _stateCommentEndDash(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                this.state = State.COMMENT_END;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.data += '-';
                this.state = State.COMMENT;
                this._stateComment(cp);
            }
        }
    }
    // Comment end state
    //------------------------------------------------------------------
    _stateCommentEnd(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentComment(token);
                break;
            }
            case CODE_POINTS.EXCLAMATION_MARK: {
                this.state = State.COMMENT_END_BANG;
                break;
            }
            case CODE_POINTS.HYPHEN_MINUS: {
                token.data += '-';
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.data += '--';
                this.state = State.COMMENT;
                this._stateComment(cp);
            }
        }
    }
    // Comment end bang state
    //------------------------------------------------------------------
    _stateCommentEndBang(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.HYPHEN_MINUS: {
                token.data += '--!';
                this.state = State.COMMENT_END_DASH;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.incorrectlyClosedComment);
                this.state = State.DATA;
                this.emitCurrentComment(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.data += '--!';
                this.state = State.COMMENT;
                this._stateComment(cp);
            }
        }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    _stateDoctype(cp) {
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this.state = State.BEFORE_DOCTYPE_NAME;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                this._createDoctypeToken(null);
                const token = this.currentToken;
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingWhitespaceBeforeDoctypeName);
                this.state = State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
            }
        }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    _stateBeforeDoctypeName(cp) {
        if (isAsciiUpper(cp)) {
            this._createDoctypeToken(String.fromCharCode(toAsciiLower(cp)));
            this.state = State.DOCTYPE_NAME;
        }
        else
            switch (cp) {
                case CODE_POINTS.SPACE:
                case CODE_POINTS.LINE_FEED:
                case CODE_POINTS.TABULATION:
                case CODE_POINTS.FORM_FEED: {
                    // Ignore whitespace
                    break;
                }
                case CODE_POINTS.NULL: {
                    this._err(ERR.unexpectedNullCharacter);
                    this._createDoctypeToken(REPLACEMENT_CHARACTER);
                    this.state = State.DOCTYPE_NAME;
                    break;
                }
                case CODE_POINTS.GREATER_THAN_SIGN: {
                    this._err(ERR.missingDoctypeName);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this.state = State.DATA;
                    break;
                }
                case CODE_POINTS.EOF: {
                    this._err(ERR.eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
                default: {
                    this._createDoctypeToken(String.fromCodePoint(cp));
                    this.state = State.DOCTYPE_NAME;
                }
            }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    _stateDoctypeName(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this.state = State.AFTER_DOCTYPE_NAME;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.name += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.name += String.fromCodePoint(isAsciiUpper(cp) ? toAsciiLower(cp) : cp);
            }
        }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    _stateAfterDoctypeName(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                if (this._consumeSequenceIfMatch(SEQUENCES.PUBLIC, false)) {
                    this.state = State.AFTER_DOCTYPE_PUBLIC_KEYWORD;
                }
                else if (this._consumeSequenceIfMatch(SEQUENCES.SYSTEM, false)) {
                    this.state = State.AFTER_DOCTYPE_SYSTEM_KEYWORD;
                }
                //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
                //results are no longer valid and we will need to start over.
                else if (!this._ensureHibernation()) {
                    this._err(ERR.invalidCharacterSequenceAfterDoctypeName);
                    token.forceQuirks = true;
                    this.state = State.BOGUS_DOCTYPE;
                    this._stateBogusDoctype(cp);
                }
            }
        }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicKeyword(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this.state = State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                token.publicId = '';
                this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                token.publicId = '';
                this.state = State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.QUOTATION_MARK: {
                this.state = State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.publicId += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.publicId += String.fromCodePoint(cp);
            }
        }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.APOSTROPHE: {
                this.state = State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.publicId += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.publicId += String.fromCodePoint(cp);
            }
        }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this.state = State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemKeyword(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                this.state = State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.QUOTATION_MARK: {
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            }
            case CODE_POINTS.APOSTROPHE: {
                token.systemId = '';
                this.state = State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = State.DATA;
                this.emitCurrentDoctype(token);
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.QUOTATION_MARK: {
                this.state = State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.systemId += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.systemId += String.fromCodePoint(cp);
            }
        }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.APOSTROPHE: {
                this.state = State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                token.systemId += REPLACEMENT_CHARACTER;
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this._err(ERR.abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                token.systemId += String.fromCodePoint(cp);
            }
        }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.SPACE:
            case CODE_POINTS.LINE_FEED:
            case CODE_POINTS.TABULATION:
            case CODE_POINTS.FORM_FEED: {
                // Ignore whitespace
                break;
            }
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            default: {
                this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
                this.state = State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
            }
        }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    _stateBogusDoctype(cp) {
        const token = this.currentToken;
        switch (cp) {
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.emitCurrentDoctype(token);
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.NULL: {
                this._err(ERR.unexpectedNullCharacter);
                break;
            }
            case CODE_POINTS.EOF: {
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            }
            // Do nothing
        }
    }
    // CDATA section state
    //------------------------------------------------------------------
    _stateCdataSection(cp) {
        switch (cp) {
            case CODE_POINTS.RIGHT_SQUARE_BRACKET: {
                this.state = State.CDATA_SECTION_BRACKET;
                break;
            }
            case CODE_POINTS.EOF: {
                this._err(ERR.eofInCdata);
                this._emitEOFToken();
                break;
            }
            default: {
                this._emitCodePoint(cp);
            }
        }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    _stateCdataSectionBracket(cp) {
        if (cp === CODE_POINTS.RIGHT_SQUARE_BRACKET) {
            this.state = State.CDATA_SECTION_END;
        }
        else {
            this._emitChars(']');
            this.state = State.CDATA_SECTION;
            this._stateCdataSection(cp);
        }
    }
    // CDATA section end state
    //------------------------------------------------------------------
    _stateCdataSectionEnd(cp) {
        switch (cp) {
            case CODE_POINTS.GREATER_THAN_SIGN: {
                this.state = State.DATA;
                break;
            }
            case CODE_POINTS.RIGHT_SQUARE_BRACKET: {
                this._emitChars(']');
                break;
            }
            default: {
                this._emitChars(']]');
                this.state = State.CDATA_SECTION;
                this._stateCdataSection(cp);
            }
        }
    }
    // Character reference state
    //------------------------------------------------------------------
    _stateCharacterReference() {
        let length = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
        if (length < 0) {
            if (this.preprocessor.lastChunkWritten) {
                length = this.entityDecoder.end();
            }
            else {
                // Wait for the rest of the entity.
                this.active = false;
                // Mark the entire buffer as read.
                this.preprocessor.pos = this.preprocessor.html.length - 1;
                this.consumedAfterSnapshot = 0;
                this.preprocessor.endOfChunkHit = true;
                return;
            }
        }
        if (length === 0) {
            // This was not a valid entity. Go back to the beginning, and
            // figure out what to do.
            this.preprocessor.pos = this.entityStartPos;
            this._flushCodePointConsumedAsCharacterReference(CODE_POINTS.AMPERSAND);
            this.state =
                !this._isCharacterReferenceInAttribute() && isAsciiAlphaNumeric(this.preprocessor.peek(1))
                    ? State.AMBIGUOUS_AMPERSAND
                    : this.returnState;
        }
        else {
            // We successfully parsed an entity. Switch to the return state.
            this.state = this.returnState;
        }
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    _stateAmbiguousAmpersand(cp) {
        if (isAsciiAlphaNumeric(cp)) {
            this._flushCodePointConsumedAsCharacterReference(cp);
        }
        else {
            if (cp === CODE_POINTS.SEMICOLON) {
                this._err(ERR.unknownNamedCharacterReference);
            }
            this.state = this.returnState;
            this._callState(cp);
        }
    }
}

//Element utils
const IMPLICIT_END_TAG_REQUIRED = new Set([TAG_ID.DD, TAG_ID.DT, TAG_ID.LI, TAG_ID.OPTGROUP, TAG_ID.OPTION, TAG_ID.P, TAG_ID.RB, TAG_ID.RP, TAG_ID.RT, TAG_ID.RTC]);
const IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = new Set([
    ...IMPLICIT_END_TAG_REQUIRED,
    TAG_ID.CAPTION,
    TAG_ID.COLGROUP,
    TAG_ID.TBODY,
    TAG_ID.TD,
    TAG_ID.TFOOT,
    TAG_ID.TH,
    TAG_ID.THEAD,
    TAG_ID.TR,
]);
const SCOPING_ELEMENTS_HTML = new Set([
    TAG_ID.APPLET,
    TAG_ID.CAPTION,
    TAG_ID.HTML,
    TAG_ID.MARQUEE,
    TAG_ID.OBJECT,
    TAG_ID.TABLE,
    TAG_ID.TD,
    TAG_ID.TEMPLATE,
    TAG_ID.TH,
]);
const SCOPING_ELEMENTS_HTML_LIST = new Set([...SCOPING_ELEMENTS_HTML, TAG_ID.OL, TAG_ID.UL]);
const SCOPING_ELEMENTS_HTML_BUTTON = new Set([...SCOPING_ELEMENTS_HTML, TAG_ID.BUTTON]);
const SCOPING_ELEMENTS_MATHML = new Set([TAG_ID.ANNOTATION_XML, TAG_ID.MI, TAG_ID.MN, TAG_ID.MO, TAG_ID.MS, TAG_ID.MTEXT]);
const SCOPING_ELEMENTS_SVG = new Set([TAG_ID.DESC, TAG_ID.FOREIGN_OBJECT, TAG_ID.TITLE]);
const TABLE_ROW_CONTEXT = new Set([TAG_ID.TR, TAG_ID.TEMPLATE, TAG_ID.HTML]);
const TABLE_BODY_CONTEXT = new Set([TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TEMPLATE, TAG_ID.HTML]);
const TABLE_CONTEXT = new Set([TAG_ID.TABLE, TAG_ID.TEMPLATE, TAG_ID.HTML]);
const TABLE_CELLS = new Set([TAG_ID.TD, TAG_ID.TH]);
//Stack of open elements
class OpenElementStack {
    get currentTmplContentOrNode() {
        return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
    constructor(document, treeAdapter, handler) {
        this.treeAdapter = treeAdapter;
        this.handler = handler;
        this.items = [];
        this.tagIDs = [];
        this.stackTop = -1;
        this.tmplCount = 0;
        this.currentTagId = TAG_ID.UNKNOWN;
        this.current = document;
    }
    //Index of element
    _indexOf(element) {
        return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagId === TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
    push(element, tagID) {
        this.stackTop++;
        this.items[this.stackTop] = element;
        this.current = element;
        this.tagIDs[this.stackTop] = tagID;
        this.currentTagId = tagID;
        if (this._isInTemplate()) {
            this.tmplCount++;
        }
        this.handler.onItemPush(element, tagID, true);
    }
    pop() {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) {
            this.tmplCount--;
        }
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, true);
    }
    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) {
            this.current = newElement;
        }
    }
    insertAfter(referenceElement, newElement, newElementID) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        this.tagIDs.splice(insertionIdx, 0, newElementID);
        this.stackTop++;
        if (insertionIdx === this.stackTop) {
            this._updateCurrentElement();
        }
        this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
    popUntilTagNamePopped(tagName) {
        let targetIdx = this.stackTop + 1;
        do {
            targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
        } while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== NS.HTML);
        this.shortenToLength(targetIdx < 0 ? 0 : targetIdx);
    }
    shortenToLength(idx) {
        while (this.stackTop >= idx) {
            const popped = this.current;
            if (this.tmplCount > 0 && this._isInTemplate()) {
                this.tmplCount -= 1;
            }
            this.stackTop--;
            this._updateCurrentElement();
            this.handler.onItemPop(popped, this.stackTop < idx);
        }
    }
    popUntilElementPopped(element) {
        const idx = this._indexOf(element);
        this.shortenToLength(idx < 0 ? 0 : idx);
    }
    popUntilPopped(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx < 0 ? 0 : idx);
    }
    popUntilNumberedHeaderPopped() {
        this.popUntilPopped(NUMBERED_HEADERS, NS.HTML);
    }
    popUntilTableCellPopped() {
        this.popUntilPopped(TABLE_CELLS, NS.HTML);
    }
    popAllUpToHtmlElement() {
        //NOTE: here we assume that the root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.tmplCount = 0;
        this.shortenToLength(1);
    }
    _indexOfTagNames(tagNames, namespace) {
        for (let i = this.stackTop; i >= 0; i--) {
            if (tagNames.has(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace) {
                return i;
            }
        }
        return -1;
    }
    clearBackTo(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx + 1);
    }
    clearBackToTableContext() {
        this.clearBackTo(TABLE_CONTEXT, NS.HTML);
    }
    clearBackToTableBodyContext() {
        this.clearBackTo(TABLE_BODY_CONTEXT, NS.HTML);
    }
    clearBackToTableRowContext() {
        this.clearBackTo(TABLE_ROW_CONTEXT, NS.HTML);
    }
    remove(element) {
        const idx = this._indexOf(element);
        if (idx >= 0) {
            if (idx === this.stackTop) {
                this.pop();
            }
            else {
                this.items.splice(idx, 1);
                this.tagIDs.splice(idx, 1);
                this.stackTop--;
                this._updateCurrentElement();
                this.handler.onItemPop(element, false);
            }
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        return this.stackTop >= 1 && this.tagIDs[1] === TAG_ID.BODY ? this.items[1] : null;
    }
    contains(element) {
        return this._indexOf(element) > -1;
    }
    getCommonAncestor(element) {
        const elementIdx = this._indexOf(element) - 1;
        return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.tagIDs[0] === TAG_ID.HTML;
    }
    //Element in scope
    hasInDynamicScope(tagName, htmlScope) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.tagIDs[i];
            switch (this.treeAdapter.getNamespaceURI(this.items[i])) {
                case NS.HTML: {
                    if (tn === tagName)
                        return true;
                    if (htmlScope.has(tn))
                        return false;
                    break;
                }
                case NS.SVG: {
                    if (SCOPING_ELEMENTS_SVG.has(tn))
                        return false;
                    break;
                }
                case NS.MATHML: {
                    if (SCOPING_ELEMENTS_MATHML.has(tn))
                        return false;
                    break;
                }
            }
        }
        return true;
    }
    hasInScope(tagName) {
        return this.hasInDynamicScope(tagName, SCOPING_ELEMENTS_HTML);
    }
    hasInListItemScope(tagName) {
        return this.hasInDynamicScope(tagName, SCOPING_ELEMENTS_HTML_LIST);
    }
    hasInButtonScope(tagName) {
        return this.hasInDynamicScope(tagName, SCOPING_ELEMENTS_HTML_BUTTON);
    }
    hasNumberedHeaderInScope() {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.tagIDs[i];
            switch (this.treeAdapter.getNamespaceURI(this.items[i])) {
                case NS.HTML: {
                    if (NUMBERED_HEADERS.has(tn))
                        return true;
                    if (SCOPING_ELEMENTS_HTML.has(tn))
                        return false;
                    break;
                }
                case NS.SVG: {
                    if (SCOPING_ELEMENTS_SVG.has(tn))
                        return false;
                    break;
                }
                case NS.MATHML: {
                    if (SCOPING_ELEMENTS_MATHML.has(tn))
                        return false;
                    break;
                }
            }
        }
        return true;
    }
    hasInTableScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== NS.HTML) {
                continue;
            }
            switch (this.tagIDs[i]) {
                case tagName: {
                    return true;
                }
                case TAG_ID.TABLE:
                case TAG_ID.HTML: {
                    return false;
                }
            }
        }
        return true;
    }
    hasTableBodyContextInTableScope() {
        for (let i = this.stackTop; i >= 0; i--) {
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== NS.HTML) {
                continue;
            }
            switch (this.tagIDs[i]) {
                case TAG_ID.TBODY:
                case TAG_ID.THEAD:
                case TAG_ID.TFOOT: {
                    return true;
                }
                case TAG_ID.TABLE:
                case TAG_ID.HTML: {
                    return false;
                }
            }
        }
        return true;
    }
    hasInSelectScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            if (this.treeAdapter.getNamespaceURI(this.items[i]) !== NS.HTML) {
                continue;
            }
            switch (this.tagIDs[i]) {
                case tagName: {
                    return true;
                }
                case TAG_ID.OPTION:
                case TAG_ID.OPTGROUP: {
                    break;
                }
                default: {
                    return false;
                }
            }
        }
        return true;
    }
    //Implied end tags
    generateImpliedEndTags() {
        while (IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId)) {
            this.pop();
        }
    }
    generateImpliedEndTagsThoroughly() {
        while (IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId)) {
            this.pop();
        }
    }
    generateImpliedEndTagsWithExclusion(exclusionId) {
        while (this.currentTagId !== exclusionId && IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId)) {
            this.pop();
        }
    }
}

//Const
const NOAH_ARK_CAPACITY = 3;
var EntryType;
(function (EntryType) {
    EntryType[EntryType["Marker"] = 0] = "Marker";
    EntryType[EntryType["Element"] = 1] = "Element";
})(EntryType || (EntryType = {}));
const MARKER = { type: EntryType.Marker };
//List of formatting elements
class FormattingElementList {
    constructor(treeAdapter) {
        this.treeAdapter = treeAdapter;
        this.entries = [];
        this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for (let i = 0; i < this.entries.length; i++) {
            const entry = this.entries[i];
            if (entry.type === EntryType.Marker) {
                break;
            }
            const { element } = entry;
            if (this.treeAdapter.getTagName(element) === neTagName &&
                this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
                const elementAttrs = this.treeAdapter.getAttrList(element);
                if (elementAttrs.length === neAttrsLength) {
                    candidates.push({ idx: i, attrs: elementAttrs });
                }
            }
        }
        return candidates;
    }
    _ensureNoahArkCondition(newElement) {
        if (this.entries.length < NOAH_ARK_CAPACITY)
            return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < NOAH_ARK_CAPACITY)
            return;
        //NOTE: build attrs map for the new element, so we can perform fast lookups
        const neAttrsMap = new Map(neAttrs.map((neAttr) => [neAttr.name, neAttr.value]));
        let validCandidates = 0;
        //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met
        for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            // We know that `candidate.attrs.length === neAttrs.length`
            if (candidate.attrs.every((cAttr) => neAttrsMap.get(cAttr.name) === cAttr.value)) {
                validCandidates += 1;
                if (validCandidates >= NOAH_ARK_CAPACITY) {
                    this.entries.splice(candidate.idx, 1);
                }
            }
        }
    }
    //Mutations
    insertMarker() {
        this.entries.unshift(MARKER);
    }
    pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
            type: EntryType.Element,
            element,
            token,
        });
    }
    insertElementAfterBookmark(element, token) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
            type: EntryType.Element,
            element,
            token,
        });
    }
    removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex >= 0) {
            this.entries.splice(entryIndex, 1);
        }
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */
    clearToLastMarker() {
        const markerIdx = this.entries.indexOf(MARKER);
        if (markerIdx >= 0) {
            this.entries.splice(0, markerIdx + 1);
        }
        else {
            this.entries.length = 0;
        }
    }
    //Search
    getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry) => entry.type === EntryType.Marker || this.treeAdapter.getTagName(entry.element) === tagName);
        return entry && entry.type === EntryType.Element ? entry : null;
    }
    getElementEntry(element) {
        return this.entries.find((entry) => entry.type === EntryType.Element && entry.element === element);
    }
}

const defaultTreeAdapter = {
    //Node construction
    createDocument() {
        return {
            nodeName: '#document',
            mode: DOCUMENT_MODE.NO_QUIRKS,
            childNodes: [],
        };
    },
    createDocumentFragment() {
        return {
            nodeName: '#document-fragment',
            childNodes: [],
        };
    },
    createElement(tagName, namespaceURI, attrs) {
        return {
            nodeName: tagName,
            tagName,
            attrs,
            namespaceURI,
            childNodes: [],
            parentNode: null,
        };
    },
    createCommentNode(data) {
        return {
            nodeName: '#comment',
            data,
            parentNode: null,
        };
    },
    createTextNode(value) {
        return {
            nodeName: '#text',
            value,
            parentNode: null,
        };
    },
    //Tree mutation
    appendChild(parentNode, newNode) {
        parentNode.childNodes.push(newNode);
        newNode.parentNode = parentNode;
    },
    insertBefore(parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
        parentNode.childNodes.splice(insertionIdx, 0, newNode);
        newNode.parentNode = parentNode;
    },
    setTemplateContent(templateElement, contentElement) {
        templateElement.content = contentElement;
    },
    getTemplateContent(templateElement) {
        return templateElement.content;
    },
    setDocumentType(document, name, publicId, systemId) {
        const doctypeNode = document.childNodes.find((node) => node.nodeName === '#documentType');
        if (doctypeNode) {
            doctypeNode.name = name;
            doctypeNode.publicId = publicId;
            doctypeNode.systemId = systemId;
        }
        else {
            const node = {
                nodeName: '#documentType',
                name,
                publicId,
                systemId,
                parentNode: null,
            };
            defaultTreeAdapter.appendChild(document, node);
        }
    },
    setDocumentMode(document, mode) {
        document.mode = mode;
    },
    getDocumentMode(document) {
        return document.mode;
    },
    detachNode(node) {
        if (node.parentNode) {
            const idx = node.parentNode.childNodes.indexOf(node);
            node.parentNode.childNodes.splice(idx, 1);
            node.parentNode = null;
        }
    },
    insertText(parentNode, text) {
        if (parentNode.childNodes.length > 0) {
            const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
            if (defaultTreeAdapter.isTextNode(prevNode)) {
                prevNode.value += text;
                return;
            }
        }
        defaultTreeAdapter.appendChild(parentNode, defaultTreeAdapter.createTextNode(text));
    },
    insertTextBefore(parentNode, text, referenceNode) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
        if (prevNode && defaultTreeAdapter.isTextNode(prevNode)) {
            prevNode.value += text;
        }
        else {
            defaultTreeAdapter.insertBefore(parentNode, defaultTreeAdapter.createTextNode(text), referenceNode);
        }
    },
    adoptAttributes(recipient, attrs) {
        const recipientAttrsMap = new Set(recipient.attrs.map((attr) => attr.name));
        for (let j = 0; j < attrs.length; j++) {
            if (!recipientAttrsMap.has(attrs[j].name)) {
                recipient.attrs.push(attrs[j]);
            }
        }
    },
    //Tree traversing
    getFirstChild(node) {
        return node.childNodes[0];
    },
    getChildNodes(node) {
        return node.childNodes;
    },
    getParentNode(node) {
        return node.parentNode;
    },
    getAttrList(element) {
        return element.attrs;
    },
    //Node data
    getTagName(element) {
        return element.tagName;
    },
    getNamespaceURI(element) {
        return element.namespaceURI;
    },
    getTextNodeContent(textNode) {
        return textNode.value;
    },
    getCommentNodeContent(commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName(doctypeNode) {
        return doctypeNode.name;
    },
    getDocumentTypeNodePublicId(doctypeNode) {
        return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId(doctypeNode) {
        return doctypeNode.systemId;
    },
    //Node types
    isTextNode(node) {
        return node.nodeName === '#text';
    },
    isCommentNode(node) {
        return node.nodeName === '#comment';
    },
    isDocumentTypeNode(node) {
        return node.nodeName === '#documentType';
    },
    isElementNode(node) {
        return Object.prototype.hasOwnProperty.call(node, 'tagName');
    },
    // Source code location
    setNodeSourceCodeLocation(node, location) {
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation(node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation(node, endLocation) {
        node.sourceCodeLocation = { ...node.sourceCodeLocation, ...endLocation };
    },
};

//Const
const VALID_DOCTYPE_NAME = 'html';
const VALID_SYSTEM_ID = 'about:legacy-compat';
const QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
const QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//',
];
const QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...QUIRKS_MODE_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//',
];
const QUIRKS_MODE_PUBLIC_IDS = new Set([
    '-//w3o//dtd w3 html strict 3.0//en//',
    '-/w3c/dtd html 4.0 transitional/en',
    'html',
]);
const LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ['-//w3c//dtd xhtml 1.0 frameset//', '-//w3c//dtd xhtml 1.0 transitional//'];
const LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//',
];
//Utils
function hasPrefix(publicId, prefixes) {
    return prefixes.some((prefix) => publicId.startsWith(prefix));
}
//API
function isConforming(token) {
    return (token.name === VALID_DOCTYPE_NAME &&
        token.publicId === null &&
        (token.systemId === null || token.systemId === VALID_SYSTEM_ID));
}
function getDocumentMode(token) {
    if (token.name !== VALID_DOCTYPE_NAME) {
        return DOCUMENT_MODE.QUIRKS;
    }
    const { systemId } = token;
    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
        return DOCUMENT_MODE.QUIRKS;
    }
    let { publicId } = token;
    if (publicId !== null) {
        publicId = publicId.toLowerCase();
        if (QUIRKS_MODE_PUBLIC_IDS.has(publicId)) {
            return DOCUMENT_MODE.QUIRKS;
        }
        let prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
        if (hasPrefix(publicId, prefixes)) {
            return DOCUMENT_MODE.QUIRKS;
        }
        prefixes =
            systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
        if (hasPrefix(publicId, prefixes)) {
            return DOCUMENT_MODE.LIMITED_QUIRKS;
        }
    }
    return DOCUMENT_MODE.NO_QUIRKS;
}

//MIME types
const MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml',
};
//Attributes
const DEFINITION_URL_ATTR = 'definitionurl';
const ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const SVG_ATTRS_ADJUSTMENT_MAP = new Map([
    'attributeName',
    'attributeType',
    'baseFrequency',
    'baseProfile',
    'calcMode',
    'clipPathUnits',
    'diffuseConstant',
    'edgeMode',
    'filterUnits',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'kernelMatrix',
    'kernelUnitLength',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'limitingConeAngle',
    'markerHeight',
    'markerUnits',
    'markerWidth',
    'maskContentUnits',
    'maskUnits',
    'numOctaves',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'refX',
    'refY',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'specularConstant',
    'specularExponent',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stitchTiles',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textLength',
    'viewBox',
    'viewTarget',
    'xChannelSelector',
    'yChannelSelector',
    'zoomAndPan',
].map((attr) => [attr.toLowerCase(), attr]));
const XML_ATTRS_ADJUSTMENT_MAP = new Map([
    ['xlink:actuate', { prefix: 'xlink', name: 'actuate', namespace: NS.XLINK }],
    ['xlink:arcrole', { prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK }],
    ['xlink:href', { prefix: 'xlink', name: 'href', namespace: NS.XLINK }],
    ['xlink:role', { prefix: 'xlink', name: 'role', namespace: NS.XLINK }],
    ['xlink:show', { prefix: 'xlink', name: 'show', namespace: NS.XLINK }],
    ['xlink:title', { prefix: 'xlink', name: 'title', namespace: NS.XLINK }],
    ['xlink:type', { prefix: 'xlink', name: 'type', namespace: NS.XLINK }],
    ['xml:lang', { prefix: 'xml', name: 'lang', namespace: NS.XML }],
    ['xml:space', { prefix: 'xml', name: 'space', namespace: NS.XML }],
    ['xmlns', { prefix: '', name: 'xmlns', namespace: NS.XMLNS }],
    ['xmlns:xlink', { prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS }],
]);
//SVG tag names adjustment map
const SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map([
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'textPath',
].map((tn) => [tn.toLowerCase(), tn]));
//Tags that causes exit from foreign content
const EXITS_FOREIGN_CONTENT = new Set([
    TAG_ID.B,
    TAG_ID.BIG,
    TAG_ID.BLOCKQUOTE,
    TAG_ID.BODY,
    TAG_ID.BR,
    TAG_ID.CENTER,
    TAG_ID.CODE,
    TAG_ID.DD,
    TAG_ID.DIV,
    TAG_ID.DL,
    TAG_ID.DT,
    TAG_ID.EM,
    TAG_ID.EMBED,
    TAG_ID.H1,
    TAG_ID.H2,
    TAG_ID.H3,
    TAG_ID.H4,
    TAG_ID.H5,
    TAG_ID.H6,
    TAG_ID.HEAD,
    TAG_ID.HR,
    TAG_ID.I,
    TAG_ID.IMG,
    TAG_ID.LI,
    TAG_ID.LISTING,
    TAG_ID.MENU,
    TAG_ID.META,
    TAG_ID.NOBR,
    TAG_ID.OL,
    TAG_ID.P,
    TAG_ID.PRE,
    TAG_ID.RUBY,
    TAG_ID.S,
    TAG_ID.SMALL,
    TAG_ID.SPAN,
    TAG_ID.STRONG,
    TAG_ID.STRIKE,
    TAG_ID.SUB,
    TAG_ID.SUP,
    TAG_ID.TABLE,
    TAG_ID.TT,
    TAG_ID.U,
    TAG_ID.UL,
    TAG_ID.VAR,
]);
//Check exit from foreign content
function causesExit(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === TAG_ID.FONT &&
        startTagToken.attrs.some(({ name }) => name === ATTRS.COLOR || name === ATTRS.SIZE || name === ATTRS.FACE);
    return isFontWithAttrs || EXITS_FOREIGN_CONTENT.has(tn);
}
//Token adjustments
function adjustTokenMathMLAttrs(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
}
function adjustTokenSVGAttrs(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        const adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrName != null) {
            token.attrs[i].name = adjustedAttrName;
        }
    }
}
function adjustTokenXMLAttrs(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        const adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
}
function adjustTokenSVGTagName(token) {
    const adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP.get(token.tagName);
    if (adjustedTagName != null) {
        token.tagName = adjustedTagName;
        token.tagID = getTagID(token.tagName);
    }
}
//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === TAG_ID.MI || tn === TAG_ID.MO || tn === TAG_ID.MN || tn === TAG_ID.MS || tn === TAG_ID.MTEXT);
}
function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === TAG_ID.ANNOTATION_XML) {
        for (let i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                const value = attrs[i].value.toLowerCase();
                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }
    return ns === NS.SVG && (tn === TAG_ID.FOREIGN_OBJECT || tn === TAG_ID.DESC || tn === TAG_ID.TITLE);
}
function isIntegrationPoint(tn, ns, attrs, foreignNS) {
    return (((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs)) ||
        ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns)));
}

//Misc constants
const HIDDEN_INPUT_TYPE = 'hidden';
//Adoption agency loops iteration count
const AA_OUTER_LOOP_ITER = 8;
const AA_INNER_LOOP_ITER = 3;
//Insertion modes
var InsertionMode;
(function (InsertionMode) {
    InsertionMode[InsertionMode["INITIAL"] = 0] = "INITIAL";
    InsertionMode[InsertionMode["BEFORE_HTML"] = 1] = "BEFORE_HTML";
    InsertionMode[InsertionMode["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
    InsertionMode[InsertionMode["IN_HEAD"] = 3] = "IN_HEAD";
    InsertionMode[InsertionMode["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
    InsertionMode[InsertionMode["AFTER_HEAD"] = 5] = "AFTER_HEAD";
    InsertionMode[InsertionMode["IN_BODY"] = 6] = "IN_BODY";
    InsertionMode[InsertionMode["TEXT"] = 7] = "TEXT";
    InsertionMode[InsertionMode["IN_TABLE"] = 8] = "IN_TABLE";
    InsertionMode[InsertionMode["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
    InsertionMode[InsertionMode["IN_CAPTION"] = 10] = "IN_CAPTION";
    InsertionMode[InsertionMode["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
    InsertionMode[InsertionMode["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
    InsertionMode[InsertionMode["IN_ROW"] = 13] = "IN_ROW";
    InsertionMode[InsertionMode["IN_CELL"] = 14] = "IN_CELL";
    InsertionMode[InsertionMode["IN_SELECT"] = 15] = "IN_SELECT";
    InsertionMode[InsertionMode["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
    InsertionMode[InsertionMode["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
    InsertionMode[InsertionMode["AFTER_BODY"] = 18] = "AFTER_BODY";
    InsertionMode[InsertionMode["IN_FRAMESET"] = 19] = "IN_FRAMESET";
    InsertionMode[InsertionMode["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
    InsertionMode[InsertionMode["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
    InsertionMode[InsertionMode["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})(InsertionMode || (InsertionMode = {}));
const BASE_LOC = {
    startLine: -1,
    startCol: -1,
    startOffset: -1,
    endLine: -1,
    endCol: -1,
    endOffset: -1,
};
const TABLE_STRUCTURE_TAGS = new Set([TAG_ID.TABLE, TAG_ID.TBODY, TAG_ID.TFOOT, TAG_ID.THEAD, TAG_ID.TR]);
const defaultParserOptions = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    treeAdapter: defaultTreeAdapter,
    onParseError: null,
};
//Parser
class Parser {
    constructor(options, document, 
    /** @internal */
    fragmentContext = null, 
    /** @internal */
    scriptHandler = null) {
        this.fragmentContext = fragmentContext;
        this.scriptHandler = scriptHandler;
        this.currentToken = null;
        this.stopped = false;
        /** @internal */
        this.insertionMode = InsertionMode.INITIAL;
        /** @internal */
        this.originalInsertionMode = InsertionMode.INITIAL;
        /** @internal */
        this.headElement = null;
        /** @internal */
        this.formElement = null;
        /** Indicates that the current node is not an element in the HTML namespace */
        this.currentNotInHTML = false;
        /**
         * The template insertion mode stack is maintained from the left.
         * Ie. the topmost element will always have index 0.
         *
         * @internal
         */
        this.tmplInsertionModeStack = [];
        /** @internal */
        this.pendingCharacterTokens = [];
        /** @internal */
        this.hasNonWhitespacePendingCharacterToken = false;
        /** @internal */
        this.framesetOk = true;
        /** @internal */
        this.skipNextNewLine = false;
        /** @internal */
        this.fosterParentingEnabled = false;
        this.options = {
            ...defaultParserOptions,
            ...options,
        };
        this.treeAdapter = this.options.treeAdapter;
        this.onParseError = this.options.onParseError;
        // Always enable location info if we report parse errors.
        if (this.onParseError) {
            this.options.sourceCodeLocationInfo = true;
        }
        this.document = document !== null && document !== undefined ? document : this.treeAdapter.createDocument();
        this.tokenizer = new Tokenizer(this.options, this);
        this.activeFormattingElements = new FormattingElementList(this.treeAdapter);
        this.fragmentContextID = fragmentContext ? getTagID(this.treeAdapter.getTagName(fragmentContext)) : TAG_ID.UNKNOWN;
        this._setContextModes(fragmentContext !== null && fragmentContext !== undefined ? fragmentContext : this.document, this.fragmentContextID);
        this.openElements = new OpenElementStack(this.document, this.treeAdapter, this);
    }
    // API
    static parse(html, options) {
        const parser = new this(options);
        parser.tokenizer.write(html, true);
        return parser.document;
    }
    static getFragmentParser(fragmentContext, options) {
        const opts = {
            ...defaultParserOptions,
            ...options,
        };
        //NOTE: use a <template> element as the fragment context if no context element was provided,
        //so we will parse in a "forgiving" manner
        fragmentContext !== null && fragmentContext !== undefined ? fragmentContext : (fragmentContext = opts.treeAdapter.createElement(TAG_NAMES.TEMPLATE, NS.HTML, []));
        //NOTE: create a fake element which will be used as the `document` for fragment parsing.
        //This is important for jsdom, where a new `document` cannot be created. This led to
        //fragment parsing messing with the main `document`.
        const documentMock = opts.treeAdapter.createElement('documentmock', NS.HTML, []);
        const parser = new this(opts, documentMock, fragmentContext);
        if (parser.fragmentContextID === TAG_ID.TEMPLATE) {
            parser.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
        }
        parser._initTokenizerForFragmentParsing();
        parser._insertFakeRootElement();
        parser._resetInsertionMode();
        parser._findFormInFragmentContext();
        return parser;
    }
    getFragment() {
        const rootElement = this.treeAdapter.getFirstChild(this.document);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
    }
    //Errors
    /** @internal */
    _err(token, code, beforeToken) {
        var _a;
        if (!this.onParseError)
            return;
        const loc = (_a = token.location) !== null && _a !== undefined ? _a : BASE_LOC;
        const err = {
            code,
            startLine: loc.startLine,
            startCol: loc.startCol,
            startOffset: loc.startOffset,
            endLine: beforeToken ? loc.startLine : loc.endLine,
            endCol: beforeToken ? loc.startCol : loc.endCol,
            endOffset: beforeToken ? loc.startOffset : loc.endOffset,
        };
        this.onParseError(err);
    }
    //Stack events
    /** @internal */
    onItemPush(node, tid, isTop) {
        var _a, _b;
        (_b = (_a = this.treeAdapter).onItemPush) === null || _b === undefined ? undefined : _b.call(_a, node);
        if (isTop && this.openElements.stackTop > 0)
            this._setContextModes(node, tid);
    }
    /** @internal */
    onItemPop(node, isTop) {
        var _a, _b;
        if (this.options.sourceCodeLocationInfo) {
            this._setEndLocation(node, this.currentToken);
        }
        (_b = (_a = this.treeAdapter).onItemPop) === null || _b === undefined ? undefined : _b.call(_a, node, this.openElements.current);
        if (isTop) {
            let current;
            let currentTagId;
            if (this.openElements.stackTop === 0 && this.fragmentContext) {
                current = this.fragmentContext;
                currentTagId = this.fragmentContextID;
            }
            else {
                ({ current, currentTagId } = this.openElements);
            }
            this._setContextModes(current, currentTagId);
        }
    }
    _setContextModes(current, tid) {
        const isHTML = current === this.document || this.treeAdapter.getNamespaceURI(current) === NS.HTML;
        this.currentNotInHTML = !isHTML;
        this.tokenizer.inForeignNode = !isHTML && !this._isIntegrationPoint(tid, current);
    }
    /** @protected */
    _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, NS.HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = InsertionMode.TEXT;
    }
    switchToPlaintextParsing() {
        this.insertionMode = InsertionMode.TEXT;
        this.originalInsertionMode = InsertionMode.IN_BODY;
        this.tokenizer.state = TokenizerMode.PLAINTEXT;
    }
    //Fragment parsing
    /** @protected */
    _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext
            ? this.fragmentContext
            : this.openElements.current;
    }
    /** @protected */
    _findFormInFragmentContext() {
        let node = this.fragmentContext;
        while (node) {
            if (this.treeAdapter.getTagName(node) === TAG_NAMES.FORM) {
                this.formElement = node;
                break;
            }
            node = this.treeAdapter.getParentNode(node);
        }
    }
    _initTokenizerForFragmentParsing() {
        if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== NS.HTML) {
            return;
        }
        switch (this.fragmentContextID) {
            case TAG_ID.TITLE:
            case TAG_ID.TEXTAREA: {
                this.tokenizer.state = TokenizerMode.RCDATA;
                break;
            }
            case TAG_ID.STYLE:
            case TAG_ID.XMP:
            case TAG_ID.IFRAME:
            case TAG_ID.NOEMBED:
            case TAG_ID.NOFRAMES:
            case TAG_ID.NOSCRIPT: {
                this.tokenizer.state = TokenizerMode.RAWTEXT;
                break;
            }
            case TAG_ID.SCRIPT: {
                this.tokenizer.state = TokenizerMode.SCRIPT_DATA;
                break;
            }
            case TAG_ID.PLAINTEXT: {
                this.tokenizer.state = TokenizerMode.PLAINTEXT;
                break;
            }
            // Do nothing
        }
    }
    //Tree mutation
    /** @protected */
    _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
        if (token.location) {
            const documentChildren = this.treeAdapter.getChildNodes(this.document);
            const docTypeNode = documentChildren.find((node) => this.treeAdapter.isDocumentTypeNode(node));
            if (docTypeNode) {
                this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token.location);
            }
        }
    }
    /** @protected */
    _attachElementToTree(element, location) {
        if (this.options.sourceCodeLocationInfo) {
            const loc = location && {
                ...location,
                startTag: location,
            };
            this.treeAdapter.setNodeSourceCodeLocation(element, loc);
        }
        if (this._shouldFosterParentOnInsertion()) {
            this._fosterParentElement(element);
        }
        else {
            const parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.appendChild(parent, element);
        }
    }
    /**
     * For self-closing tags. Add an element to the tree, but skip adding it
     * to the stack.
     */
    /** @protected */
    _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
    }
    /** @protected */
    _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
        this.openElements.push(element, token.tagID);
    }
    /** @protected */
    _insertFakeElement(tagName, tagID) {
        const element = this.treeAdapter.createElement(tagName, NS.HTML, []);
        this._attachElementToTree(element, null);
        this.openElements.push(element, tagID);
    }
    /** @protected */
    _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl, token.location);
        this.openElements.push(tmpl, token.tagID);
        if (this.options.sourceCodeLocationInfo)
            this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
    /** @protected */
    _insertFakeRootElement() {
        const element = this.treeAdapter.createElement(TAG_NAMES.HTML, NS.HTML, []);
        if (this.options.sourceCodeLocationInfo)
            this.treeAdapter.setNodeSourceCodeLocation(element, null);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element, TAG_ID.HTML);
    }
    /** @protected */
    _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
        if (this.options.sourceCodeLocationInfo) {
            this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
        }
    }
    /** @protected */
    _insertCharacters(token) {
        let parent;
        let beforeElement;
        if (this._shouldFosterParentOnInsertion()) {
            ({ parent, beforeElement } = this._findFosterParentingLocation());
            if (beforeElement) {
                this.treeAdapter.insertTextBefore(parent, token.chars, beforeElement);
            }
            else {
                this.treeAdapter.insertText(parent, token.chars);
            }
        }
        else {
            parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.insertText(parent, token.chars);
        }
        if (!token.location)
            return;
        const siblings = this.treeAdapter.getChildNodes(parent);
        const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
        const textNode = siblings[textNodeIdx - 1];
        //NOTE: if we have a location assigned by another token, then just update the end position
        const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
        if (tnLoc) {
            const { endLine, endCol, endOffset } = token.location;
            this.treeAdapter.updateNodeSourceCodeLocation(textNode, { endLine, endCol, endOffset });
        }
        else if (this.options.sourceCodeLocationInfo) {
            this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
        }
    }
    /** @protected */
    _adoptNodes(donor, recipient) {
        for (let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }
    /** @protected */
    _setEndLocation(element, closingToken) {
        if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
            const ctLoc = closingToken.location;
            const tn = this.treeAdapter.getTagName(element);
            const endLoc = 
            // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            closingToken.type === TokenType.END_TAG && tn === closingToken.tagName
                ? {
                    endTag: { ...ctLoc },
                    endLine: ctLoc.endLine,
                    endCol: ctLoc.endCol,
                    endOffset: ctLoc.endOffset,
                }
                : {
                    endLine: ctLoc.startLine,
                    endCol: ctLoc.startCol,
                    endOffset: ctLoc.startOffset,
                };
            this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
        }
    }
    //Token processing
    shouldProcessStartTagTokenInForeignContent(token) {
        // Check that neither current === document, or ns === NS.HTML
        if (!this.currentNotInHTML)
            return false;
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
            current = this.fragmentContext;
            currentTagId = this.fragmentContextID;
        }
        else {
            ({ current, currentTagId } = this.openElements);
        }
        if (token.tagID === TAG_ID.SVG &&
            this.treeAdapter.getTagName(current) === TAG_NAMES.ANNOTATION_XML &&
            this.treeAdapter.getNamespaceURI(current) === NS.MATHML) {
            return false;
        }
        return (
        // Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode ||
            // If it _is_ an integration point, then we might have to check that it is not an HTML
            // integration point.
            ((token.tagID === TAG_ID.MGLYPH || token.tagID === TAG_ID.MALIGNMARK) &&
                !this._isIntegrationPoint(currentTagId, current, NS.HTML)));
    }
    /** @protected */
    _processToken(token) {
        switch (token.type) {
            case TokenType.CHARACTER: {
                this.onCharacter(token);
                break;
            }
            case TokenType.NULL_CHARACTER: {
                this.onNullCharacter(token);
                break;
            }
            case TokenType.COMMENT: {
                this.onComment(token);
                break;
            }
            case TokenType.DOCTYPE: {
                this.onDoctype(token);
                break;
            }
            case TokenType.START_TAG: {
                this._processStartTag(token);
                break;
            }
            case TokenType.END_TAG: {
                this.onEndTag(token);
                break;
            }
            case TokenType.EOF: {
                this.onEof(token);
                break;
            }
            case TokenType.WHITESPACE_CHARACTER: {
                this.onWhitespaceCharacter(token);
                break;
            }
        }
    }
    //Integration points
    /** @protected */
    _isIntegrationPoint(tid, element, foreignNS) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return isIntegrationPoint(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    /** @protected */
    _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.entries.length;
        if (listLength) {
            const endIndex = this.activeFormattingElements.entries.findIndex((entry) => entry.type === EntryType.Marker || this.openElements.contains(entry.element));
            const unopenIdx = endIndex < 0 ? listLength - 1 : endIndex - 1;
            for (let i = unopenIdx; i >= 0; i--) {
                const entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }
    //Close elements
    /** @protected */
    _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = InsertionMode.IN_ROW;
    }
    /** @protected */
    _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.P);
        this.openElements.popUntilTagNamePopped(TAG_ID.P);
    }
    //Insertion modes
    /** @protected */
    _resetInsertionMode() {
        for (let i = this.openElements.stackTop; i >= 0; i--) {
            //Insertion mode reset map
            switch (i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]) {
                case TAG_ID.TR: {
                    this.insertionMode = InsertionMode.IN_ROW;
                    return;
                }
                case TAG_ID.TBODY:
                case TAG_ID.THEAD:
                case TAG_ID.TFOOT: {
                    this.insertionMode = InsertionMode.IN_TABLE_BODY;
                    return;
                }
                case TAG_ID.CAPTION: {
                    this.insertionMode = InsertionMode.IN_CAPTION;
                    return;
                }
                case TAG_ID.COLGROUP: {
                    this.insertionMode = InsertionMode.IN_COLUMN_GROUP;
                    return;
                }
                case TAG_ID.TABLE: {
                    this.insertionMode = InsertionMode.IN_TABLE;
                    return;
                }
                case TAG_ID.BODY: {
                    this.insertionMode = InsertionMode.IN_BODY;
                    return;
                }
                case TAG_ID.FRAMESET: {
                    this.insertionMode = InsertionMode.IN_FRAMESET;
                    return;
                }
                case TAG_ID.SELECT: {
                    this._resetInsertionModeForSelect(i);
                    return;
                }
                case TAG_ID.TEMPLATE: {
                    this.insertionMode = this.tmplInsertionModeStack[0];
                    return;
                }
                case TAG_ID.HTML: {
                    this.insertionMode = this.headElement ? InsertionMode.AFTER_HEAD : InsertionMode.BEFORE_HEAD;
                    return;
                }
                case TAG_ID.TD:
                case TAG_ID.TH: {
                    if (i > 0) {
                        this.insertionMode = InsertionMode.IN_CELL;
                        return;
                    }
                    break;
                }
                case TAG_ID.HEAD: {
                    if (i > 0) {
                        this.insertionMode = InsertionMode.IN_HEAD;
                        return;
                    }
                    break;
                }
            }
        }
        this.insertionMode = InsertionMode.IN_BODY;
    }
    /** @protected */
    _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) {
            for (let i = selectIdx - 1; i > 0; i--) {
                const tn = this.openElements.tagIDs[i];
                if (tn === TAG_ID.TEMPLATE) {
                    break;
                }
                else if (tn === TAG_ID.TABLE) {
                    this.insertionMode = InsertionMode.IN_SELECT_IN_TABLE;
                    return;
                }
            }
        }
        this.insertionMode = InsertionMode.IN_SELECT;
    }
    //Foster parenting
    /** @protected */
    _isElementCausesFosterParenting(tn) {
        return TABLE_STRUCTURE_TAGS.has(tn);
    }
    /** @protected */
    _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
    /** @protected */
    _findFosterParentingLocation() {
        for (let i = this.openElements.stackTop; i >= 0; i--) {
            const openElement = this.openElements.items[i];
            switch (this.openElements.tagIDs[i]) {
                case TAG_ID.TEMPLATE: {
                    if (this.treeAdapter.getNamespaceURI(openElement) === NS.HTML) {
                        return { parent: this.treeAdapter.getTemplateContent(openElement), beforeElement: null };
                    }
                    break;
                }
                case TAG_ID.TABLE: {
                    const parent = this.treeAdapter.getParentNode(openElement);
                    if (parent) {
                        return { parent, beforeElement: openElement };
                    }
                    return { parent: this.openElements.items[i - 1], beforeElement: null };
                }
                // Do nothing
            }
        }
        return { parent: this.openElements.items[0], beforeElement: null };
    }
    /** @protected */
    _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) {
            this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        }
        else {
            this.treeAdapter.appendChild(location.parent, element);
        }
    }
    //Special elements
    /** @protected */
    _isSpecialElement(element, id) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        return SPECIAL_ELEMENTS[ns].has(id);
    }
    /** @internal */
    onCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            characterInForeignContent(this, token);
            return;
        }
        switch (this.insertionMode) {
            case InsertionMode.INITIAL: {
                tokenInInitialMode(this, token);
                break;
            }
            case InsertionMode.BEFORE_HTML: {
                tokenBeforeHtml(this, token);
                break;
            }
            case InsertionMode.BEFORE_HEAD: {
                tokenBeforeHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD: {
                tokenInHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD_NO_SCRIPT: {
                tokenInHeadNoScript(this, token);
                break;
            }
            case InsertionMode.AFTER_HEAD: {
                tokenAfterHead(this, token);
                break;
            }
            case InsertionMode.IN_BODY:
            case InsertionMode.IN_CAPTION:
            case InsertionMode.IN_CELL:
            case InsertionMode.IN_TEMPLATE: {
                characterInBody(this, token);
                break;
            }
            case InsertionMode.TEXT:
            case InsertionMode.IN_SELECT:
            case InsertionMode.IN_SELECT_IN_TABLE: {
                this._insertCharacters(token);
                break;
            }
            case InsertionMode.IN_TABLE:
            case InsertionMode.IN_TABLE_BODY:
            case InsertionMode.IN_ROW: {
                characterInTable(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                characterInTableText(this, token);
                break;
            }
            case InsertionMode.IN_COLUMN_GROUP: {
                tokenInColumnGroup(this, token);
                break;
            }
            case InsertionMode.AFTER_BODY: {
                tokenAfterBody(this, token);
                break;
            }
            case InsertionMode.AFTER_AFTER_BODY: {
                tokenAfterAfterBody(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onNullCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            nullCharacterInForeignContent(this, token);
            return;
        }
        switch (this.insertionMode) {
            case InsertionMode.INITIAL: {
                tokenInInitialMode(this, token);
                break;
            }
            case InsertionMode.BEFORE_HTML: {
                tokenBeforeHtml(this, token);
                break;
            }
            case InsertionMode.BEFORE_HEAD: {
                tokenBeforeHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD: {
                tokenInHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD_NO_SCRIPT: {
                tokenInHeadNoScript(this, token);
                break;
            }
            case InsertionMode.AFTER_HEAD: {
                tokenAfterHead(this, token);
                break;
            }
            case InsertionMode.TEXT: {
                this._insertCharacters(token);
                break;
            }
            case InsertionMode.IN_TABLE:
            case InsertionMode.IN_TABLE_BODY:
            case InsertionMode.IN_ROW: {
                characterInTable(this, token);
                break;
            }
            case InsertionMode.IN_COLUMN_GROUP: {
                tokenInColumnGroup(this, token);
                break;
            }
            case InsertionMode.AFTER_BODY: {
                tokenAfterBody(this, token);
                break;
            }
            case InsertionMode.AFTER_AFTER_BODY: {
                tokenAfterAfterBody(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onComment(token) {
        this.skipNextNewLine = false;
        if (this.currentNotInHTML) {
            appendComment(this, token);
            return;
        }
        switch (this.insertionMode) {
            case InsertionMode.INITIAL:
            case InsertionMode.BEFORE_HTML:
            case InsertionMode.BEFORE_HEAD:
            case InsertionMode.IN_HEAD:
            case InsertionMode.IN_HEAD_NO_SCRIPT:
            case InsertionMode.AFTER_HEAD:
            case InsertionMode.IN_BODY:
            case InsertionMode.IN_TABLE:
            case InsertionMode.IN_CAPTION:
            case InsertionMode.IN_COLUMN_GROUP:
            case InsertionMode.IN_TABLE_BODY:
            case InsertionMode.IN_ROW:
            case InsertionMode.IN_CELL:
            case InsertionMode.IN_SELECT:
            case InsertionMode.IN_SELECT_IN_TABLE:
            case InsertionMode.IN_TEMPLATE:
            case InsertionMode.IN_FRAMESET:
            case InsertionMode.AFTER_FRAMESET: {
                appendComment(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                tokenInTableText(this, token);
                break;
            }
            case InsertionMode.AFTER_BODY: {
                appendCommentToRootHtmlElement(this, token);
                break;
            }
            case InsertionMode.AFTER_AFTER_BODY:
            case InsertionMode.AFTER_AFTER_FRAMESET: {
                appendCommentToDocument(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onDoctype(token) {
        this.skipNextNewLine = false;
        switch (this.insertionMode) {
            case InsertionMode.INITIAL: {
                doctypeInInitialMode(this, token);
                break;
            }
            case InsertionMode.BEFORE_HEAD:
            case InsertionMode.IN_HEAD:
            case InsertionMode.IN_HEAD_NO_SCRIPT:
            case InsertionMode.AFTER_HEAD: {
                this._err(token, ERR.misplacedDoctype);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                tokenInTableText(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onStartTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        this._processStartTag(token);
        if (token.selfClosing && !token.ackSelfClosing) {
            this._err(token, ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
        }
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     * @protected
     */
    _processStartTag(token) {
        if (this.shouldProcessStartTagTokenInForeignContent(token)) {
            startTagInForeignContent(this, token);
        }
        else {
            this._startTagOutsideForeignContent(token);
        }
    }
    /** @protected */
    _startTagOutsideForeignContent(token) {
        switch (this.insertionMode) {
            case InsertionMode.INITIAL: {
                tokenInInitialMode(this, token);
                break;
            }
            case InsertionMode.BEFORE_HTML: {
                startTagBeforeHtml(this, token);
                break;
            }
            case InsertionMode.BEFORE_HEAD: {
                startTagBeforeHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD: {
                startTagInHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD_NO_SCRIPT: {
                startTagInHeadNoScript(this, token);
                break;
            }
            case InsertionMode.AFTER_HEAD: {
                startTagAfterHead(this, token);
                break;
            }
            case InsertionMode.IN_BODY: {
                startTagInBody(this, token);
                break;
            }
            case InsertionMode.IN_TABLE: {
                startTagInTable(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                tokenInTableText(this, token);
                break;
            }
            case InsertionMode.IN_CAPTION: {
                startTagInCaption(this, token);
                break;
            }
            case InsertionMode.IN_COLUMN_GROUP: {
                startTagInColumnGroup(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_BODY: {
                startTagInTableBody(this, token);
                break;
            }
            case InsertionMode.IN_ROW: {
                startTagInRow(this, token);
                break;
            }
            case InsertionMode.IN_CELL: {
                startTagInCell(this, token);
                break;
            }
            case InsertionMode.IN_SELECT: {
                startTagInSelect(this, token);
                break;
            }
            case InsertionMode.IN_SELECT_IN_TABLE: {
                startTagInSelectInTable(this, token);
                break;
            }
            case InsertionMode.IN_TEMPLATE: {
                startTagInTemplate(this, token);
                break;
            }
            case InsertionMode.AFTER_BODY: {
                startTagAfterBody(this, token);
                break;
            }
            case InsertionMode.IN_FRAMESET: {
                startTagInFrameset(this, token);
                break;
            }
            case InsertionMode.AFTER_FRAMESET: {
                startTagAfterFrameset(this, token);
                break;
            }
            case InsertionMode.AFTER_AFTER_BODY: {
                startTagAfterAfterBody(this, token);
                break;
            }
            case InsertionMode.AFTER_AFTER_FRAMESET: {
                startTagAfterAfterFrameset(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onEndTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        if (this.currentNotInHTML) {
            endTagInForeignContent(this, token);
        }
        else {
            this._endTagOutsideForeignContent(token);
        }
    }
    /** @protected */
    _endTagOutsideForeignContent(token) {
        switch (this.insertionMode) {
            case InsertionMode.INITIAL: {
                tokenInInitialMode(this, token);
                break;
            }
            case InsertionMode.BEFORE_HTML: {
                endTagBeforeHtml(this, token);
                break;
            }
            case InsertionMode.BEFORE_HEAD: {
                endTagBeforeHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD: {
                endTagInHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD_NO_SCRIPT: {
                endTagInHeadNoScript(this, token);
                break;
            }
            case InsertionMode.AFTER_HEAD: {
                endTagAfterHead(this, token);
                break;
            }
            case InsertionMode.IN_BODY: {
                endTagInBody(this, token);
                break;
            }
            case InsertionMode.TEXT: {
                endTagInText(this, token);
                break;
            }
            case InsertionMode.IN_TABLE: {
                endTagInTable(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                tokenInTableText(this, token);
                break;
            }
            case InsertionMode.IN_CAPTION: {
                endTagInCaption(this, token);
                break;
            }
            case InsertionMode.IN_COLUMN_GROUP: {
                endTagInColumnGroup(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_BODY: {
                endTagInTableBody(this, token);
                break;
            }
            case InsertionMode.IN_ROW: {
                endTagInRow(this, token);
                break;
            }
            case InsertionMode.IN_CELL: {
                endTagInCell(this, token);
                break;
            }
            case InsertionMode.IN_SELECT: {
                endTagInSelect(this, token);
                break;
            }
            case InsertionMode.IN_SELECT_IN_TABLE: {
                endTagInSelectInTable(this, token);
                break;
            }
            case InsertionMode.IN_TEMPLATE: {
                endTagInTemplate(this, token);
                break;
            }
            case InsertionMode.AFTER_BODY: {
                endTagAfterBody(this, token);
                break;
            }
            case InsertionMode.IN_FRAMESET: {
                endTagInFrameset(this, token);
                break;
            }
            case InsertionMode.AFTER_FRAMESET: {
                endTagAfterFrameset(this, token);
                break;
            }
            case InsertionMode.AFTER_AFTER_BODY: {
                tokenAfterAfterBody(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onEof(token) {
        switch (this.insertionMode) {
            case InsertionMode.INITIAL: {
                tokenInInitialMode(this, token);
                break;
            }
            case InsertionMode.BEFORE_HTML: {
                tokenBeforeHtml(this, token);
                break;
            }
            case InsertionMode.BEFORE_HEAD: {
                tokenBeforeHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD: {
                tokenInHead(this, token);
                break;
            }
            case InsertionMode.IN_HEAD_NO_SCRIPT: {
                tokenInHeadNoScript(this, token);
                break;
            }
            case InsertionMode.AFTER_HEAD: {
                tokenAfterHead(this, token);
                break;
            }
            case InsertionMode.IN_BODY:
            case InsertionMode.IN_TABLE:
            case InsertionMode.IN_CAPTION:
            case InsertionMode.IN_COLUMN_GROUP:
            case InsertionMode.IN_TABLE_BODY:
            case InsertionMode.IN_ROW:
            case InsertionMode.IN_CELL:
            case InsertionMode.IN_SELECT:
            case InsertionMode.IN_SELECT_IN_TABLE: {
                eofInBody(this, token);
                break;
            }
            case InsertionMode.TEXT: {
                eofInText(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                tokenInTableText(this, token);
                break;
            }
            case InsertionMode.IN_TEMPLATE: {
                eofInTemplate(this, token);
                break;
            }
            case InsertionMode.AFTER_BODY:
            case InsertionMode.IN_FRAMESET:
            case InsertionMode.AFTER_FRAMESET:
            case InsertionMode.AFTER_AFTER_BODY:
            case InsertionMode.AFTER_AFTER_FRAMESET: {
                stopParsing(this, token);
                break;
            }
            // Do nothing
        }
    }
    /** @internal */
    onWhitespaceCharacter(token) {
        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;
            if (token.chars.charCodeAt(0) === CODE_POINTS.LINE_FEED) {
                if (token.chars.length === 1) {
                    return;
                }
                token.chars = token.chars.substr(1);
            }
        }
        if (this.tokenizer.inForeignNode) {
            this._insertCharacters(token);
            return;
        }
        switch (this.insertionMode) {
            case InsertionMode.IN_HEAD:
            case InsertionMode.IN_HEAD_NO_SCRIPT:
            case InsertionMode.AFTER_HEAD:
            case InsertionMode.TEXT:
            case InsertionMode.IN_COLUMN_GROUP:
            case InsertionMode.IN_SELECT:
            case InsertionMode.IN_SELECT_IN_TABLE:
            case InsertionMode.IN_FRAMESET:
            case InsertionMode.AFTER_FRAMESET: {
                this._insertCharacters(token);
                break;
            }
            case InsertionMode.IN_BODY:
            case InsertionMode.IN_CAPTION:
            case InsertionMode.IN_CELL:
            case InsertionMode.IN_TEMPLATE:
            case InsertionMode.AFTER_BODY:
            case InsertionMode.AFTER_AFTER_BODY:
            case InsertionMode.AFTER_AFTER_FRAMESET: {
                whitespaceCharacterInBody(this, token);
                break;
            }
            case InsertionMode.IN_TABLE:
            case InsertionMode.IN_TABLE_BODY:
            case InsertionMode.IN_ROW: {
                characterInTable(this, token);
                break;
            }
            case InsertionMode.IN_TABLE_TEXT: {
                whitespaceCharacterInTableText(this, token);
                break;
            }
            // Do nothing
        }
    }
}
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        }
        else if (!p.openElements.hasInScope(token.tagID)) {
            formattingElementEntry = null;
        }
    }
    else {
        genericEndTagInBody(p, token);
    }
    return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    let idx = p.openElements.stackTop;
    for (; idx >= 0; idx--) {
        const element = p.openElements.items[idx];
        if (element === formattingElementEntry.element) {
            break;
        }
        if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) {
            furthestBlock = element;
        }
    }
    if (!furthestBlock) {
        p.openElements.shortenToLength(idx < 0 ? 0 : idx);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
}
//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for (let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store the next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);
        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) {
                p.activeFormattingElements.removeEntry(elementEntry);
            }
            p.openElements.remove(element);
        }
        else {
            element = aaRecreateElementFromEntry(p, elementEntry);
            if (lastElement === furthestBlock) {
                p.activeFormattingElements.bookmark = elementEntry;
            }
            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }
    return lastElement;
}
//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
}
//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    const tn = p.treeAdapter.getTagName(commonAncestor);
    const tid = getTagID(tn);
    if (p._isElementCausesFosterParenting(tid)) {
        p._fosterParentElement(lastElement);
    }
    else {
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
        if (tid === TAG_ID.TEMPLATE && ns === NS.HTML) {
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        }
        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}
//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const { token } = formattingElementEntry;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement, token.tagID);
}
//Algorithm entry point
function callAdoptionAgency(p, token) {
    for (let i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        const formattingElementEntry = aaObtainFormattingElementEntry(p, token);
        if (!formattingElementEntry) {
            break;
        }
        const furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);
        if (!furthestBlock) {
            break;
        }
        p.activeFormattingElements.bookmark = formattingElementEntry;
        const lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
        p.treeAdapter.detachNode(lastElement);
        if (commonAncestor)
            aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}
//Generic token handlers
//------------------------------------------------------------------
function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContentOrNode);
}
function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}
function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}
function stopParsing(p, token) {
    p.stopped = true;
    // NOTE: Set end locations for elements that remain on the open element stack.
    if (token.location) {
        // NOTE: If we are not in a fragment, `html` and `body` will stay on the stack.
        // This is a problem, as we might overwrite their end position here.
        const target = p.fragmentContext ? 0 : 2;
        for (let i = p.openElements.stackTop; i >= target; i--) {
            p._setEndLocation(p.openElements.items[i], token);
        }
        // Handle `html` and `body`
        if (!p.fragmentContext && p.openElements.stackTop >= 0) {
            const htmlElement = p.openElements.items[0];
            const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
            if (htmlLocation && !htmlLocation.endTag) {
                p._setEndLocation(htmlElement, token);
                if (p.openElements.stackTop >= 1) {
                    const bodyElement = p.openElements.items[1];
                    const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
                    if (bodyLocation && !bodyLocation.endTag) {
                        p._setEndLocation(bodyElement, token);
                    }
                }
            }
        }
    }
}
// The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? DOCUMENT_MODE.QUIRKS : getDocumentMode(token);
    if (!isConforming(token)) {
        p._err(token, ERR.nonConformingDoctype);
    }
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = InsertionMode.BEFORE_HTML;
}
function tokenInInitialMode(p, token) {
    p._err(token, ERR.missingDoctype, true);
    p.treeAdapter.setDocumentMode(p.document, DOCUMENT_MODE.QUIRKS);
    p.insertionMode = InsertionMode.BEFORE_HTML;
    p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagID === TAG_ID.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = InsertionMode.BEFORE_HEAD;
    }
    else {
        tokenBeforeHtml(p, token);
    }
}
function endTagBeforeHtml(p, token) {
    const tn = token.tagID;
    if (tn === TAG_ID.HTML || tn === TAG_ID.HEAD || tn === TAG_ID.BODY || tn === TAG_ID.BR) {
        tokenBeforeHtml(p, token);
    }
}
function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = InsertionMode.BEFORE_HEAD;
    p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.HEAD: {
            p._insertElement(token, NS.HTML);
            p.headElement = p.openElements.current;
            p.insertionMode = InsertionMode.IN_HEAD;
            break;
        }
        default: {
            tokenBeforeHead(p, token);
        }
    }
}
function endTagBeforeHead(p, token) {
    const tn = token.tagID;
    if (tn === TAG_ID.HEAD || tn === TAG_ID.BODY || tn === TAG_ID.HTML || tn === TAG_ID.BR) {
        tokenBeforeHead(p, token);
    }
    else {
        p._err(token, ERR.endTagWithoutMatchingOpenElement);
    }
}
function tokenBeforeHead(p, token) {
    p._insertFakeElement(TAG_NAMES.HEAD, TAG_ID.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.BASE:
        case TAG_ID.BASEFONT:
        case TAG_ID.BGSOUND:
        case TAG_ID.LINK:
        case TAG_ID.META: {
            p._appendElement(token, NS.HTML);
            token.ackSelfClosing = true;
            break;
        }
        case TAG_ID.TITLE: {
            p._switchToTextParsing(token, TokenizerMode.RCDATA);
            break;
        }
        case TAG_ID.NOSCRIPT: {
            if (p.options.scriptingEnabled) {
                p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
            }
            else {
                p._insertElement(token, NS.HTML);
                p.insertionMode = InsertionMode.IN_HEAD_NO_SCRIPT;
            }
            break;
        }
        case TAG_ID.NOFRAMES:
        case TAG_ID.STYLE: {
            p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
            break;
        }
        case TAG_ID.SCRIPT: {
            p._switchToTextParsing(token, TokenizerMode.SCRIPT_DATA);
            break;
        }
        case TAG_ID.TEMPLATE: {
            p._insertTemplate(token);
            p.activeFormattingElements.insertMarker();
            p.framesetOk = false;
            p.insertionMode = InsertionMode.IN_TEMPLATE;
            p.tmplInsertionModeStack.unshift(InsertionMode.IN_TEMPLATE);
            break;
        }
        case TAG_ID.HEAD: {
            p._err(token, ERR.misplacedStartTagForHeadElement);
            break;
        }
        default: {
            tokenInHead(p, token);
        }
    }
}
function endTagInHead(p, token) {
    switch (token.tagID) {
        case TAG_ID.HEAD: {
            p.openElements.pop();
            p.insertionMode = InsertionMode.AFTER_HEAD;
            break;
        }
        case TAG_ID.BODY:
        case TAG_ID.BR:
        case TAG_ID.HTML: {
            tokenInHead(p, token);
            break;
        }
        case TAG_ID.TEMPLATE: {
            templateEndTagInHead(p, token);
            break;
        }
        default: {
            p._err(token, ERR.endTagWithoutMatchingOpenElement);
        }
    }
}
function templateEndTagInHead(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTagsThoroughly();
        if (p.openElements.currentTagId !== TAG_ID.TEMPLATE) {
            p._err(token, ERR.closingOfElementWithOpenChildElements);
        }
        p.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
    }
    else {
        p._err(token, ERR.endTagWithoutMatchingOpenElement);
    }
}
function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = InsertionMode.AFTER_HEAD;
    p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function startTagInHeadNoScript(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.BASEFONT:
        case TAG_ID.BGSOUND:
        case TAG_ID.HEAD:
        case TAG_ID.LINK:
        case TAG_ID.META:
        case TAG_ID.NOFRAMES:
        case TAG_ID.STYLE: {
            startTagInHead(p, token);
            break;
        }
        case TAG_ID.NOSCRIPT: {
            p._err(token, ERR.nestedNoscriptInHead);
            break;
        }
        default: {
            tokenInHeadNoScript(p, token);
        }
    }
}
function endTagInHeadNoScript(p, token) {
    switch (token.tagID) {
        case TAG_ID.NOSCRIPT: {
            p.openElements.pop();
            p.insertionMode = InsertionMode.IN_HEAD;
            break;
        }
        case TAG_ID.BR: {
            tokenInHeadNoScript(p, token);
            break;
        }
        default: {
            p._err(token, ERR.endTagWithoutMatchingOpenElement);
        }
    }
}
function tokenInHeadNoScript(p, token) {
    const errCode = token.type === TokenType.EOF ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;
    p._err(token, errCode);
    p.openElements.pop();
    p.insertionMode = InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.BODY: {
            p._insertElement(token, NS.HTML);
            p.framesetOk = false;
            p.insertionMode = InsertionMode.IN_BODY;
            break;
        }
        case TAG_ID.FRAMESET: {
            p._insertElement(token, NS.HTML);
            p.insertionMode = InsertionMode.IN_FRAMESET;
            break;
        }
        case TAG_ID.BASE:
        case TAG_ID.BASEFONT:
        case TAG_ID.BGSOUND:
        case TAG_ID.LINK:
        case TAG_ID.META:
        case TAG_ID.NOFRAMES:
        case TAG_ID.SCRIPT:
        case TAG_ID.STYLE:
        case TAG_ID.TEMPLATE:
        case TAG_ID.TITLE: {
            p._err(token, ERR.abandonedHeadElementChild);
            p.openElements.push(p.headElement, TAG_ID.HEAD);
            startTagInHead(p, token);
            p.openElements.remove(p.headElement);
            break;
        }
        case TAG_ID.HEAD: {
            p._err(token, ERR.misplacedStartTagForHeadElement);
            break;
        }
        default: {
            tokenAfterHead(p, token);
        }
    }
}
function endTagAfterHead(p, token) {
    switch (token.tagID) {
        case TAG_ID.BODY:
        case TAG_ID.HTML:
        case TAG_ID.BR: {
            tokenAfterHead(p, token);
            break;
        }
        case TAG_ID.TEMPLATE: {
            templateEndTagInHead(p, token);
            break;
        }
        default: {
            p._err(token, ERR.endTagWithoutMatchingOpenElement);
        }
    }
}
function tokenAfterHead(p, token) {
    p._insertFakeElement(TAG_NAMES.BODY, TAG_ID.BODY);
    p.insertionMode = InsertionMode.IN_BODY;
    modeInBody(p, token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function modeInBody(p, token) {
    switch (token.type) {
        case TokenType.CHARACTER: {
            characterInBody(p, token);
            break;
        }
        case TokenType.WHITESPACE_CHARACTER: {
            whitespaceCharacterInBody(p, token);
            break;
        }
        case TokenType.COMMENT: {
            appendComment(p, token);
            break;
        }
        case TokenType.START_TAG: {
            startTagInBody(p, token);
            break;
        }
        case TokenType.END_TAG: {
            endTagInBody(p, token);
            break;
        }
        case TokenType.EOF: {
            eofInBody(p, token);
            break;
        }
        // Do nothing
    }
}
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}
function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}
function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) {
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
    }
}
function bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}
function framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = InsertionMode.IN_FRAMESET;
    }
}
function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._insertElement(token, NS.HTML);
}
function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    if (NUMBERED_HEADERS.has(p.openElements.currentTagId)) {
        p.openElements.pop();
    }
    p._insertElement(token, NS.HTML);
}
function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}
function formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope(TAG_ID.P)) {
            p._closePElement();
        }
        p._insertElement(token, NS.HTML);
        if (!inTemplate) {
            p.formElement = p.openElements.current;
        }
    }
}
function listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagID;
    for (let i = p.openElements.stackTop; i >= 0; i--) {
        const elementId = p.openElements.tagIDs[i];
        if ((tn === TAG_ID.LI && elementId === TAG_ID.LI) ||
            ((tn === TAG_ID.DD || tn === TAG_ID.DT) && (elementId === TAG_ID.DD || elementId === TAG_ID.DT))) {
            p.openElements.generateImpliedEndTagsWithExclusion(elementId);
            p.openElements.popUntilTagNamePopped(elementId);
            break;
        }
        if (elementId !== TAG_ID.ADDRESS &&
            elementId !== TAG_ID.DIV &&
            elementId !== TAG_ID.P &&
            p._isSpecialElement(p.openElements.items[i], elementId)) {
            break;
        }
    }
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._insertElement(token, NS.HTML);
}
function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    p.tokenizer.state = TokenizerMode.PLAINTEXT;
}
function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope(TAG_ID.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(TAG_ID.BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}
function aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(TAG_NAMES.A);
    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope(TAG_ID.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}
function tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = InsertionMode.IN_TABLE;
}
function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function isHiddenInput(token) {
    const inputType = getTokenAttr(token, ATTRS.TYPE);
    return inputType != null && inputType.toLowerCase() === HIDDEN_INPUT_TYPE;
}
function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    if (!isHiddenInput(token)) {
        p.framesetOk = false;
    }
    token.ackSelfClosing = true;
}
function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
}
function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function imageStartTagInBody(p, token) {
    token.tagName = TAG_NAMES.IMG;
    token.tagID = TAG_ID.IMG;
    areaStartTagInBody(p, token);
}
function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = TokenizerMode.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = InsertionMode.TEXT;
}
function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._closePElement();
    }
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
}
function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
}
//NOTE: here we assume that we always act as a user agent with enabled plugins/frames, so we parse
//<noembed>/<noframes> as rawtext.
function rawTextStartTagInBody(p, token) {
    p._switchToTextParsing(token, TokenizerMode.RAWTEXT);
}
function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode =
        p.insertionMode === InsertionMode.IN_TABLE ||
            p.insertionMode === InsertionMode.IN_CAPTION ||
            p.insertionMode === InsertionMode.IN_TABLE_BODY ||
            p.insertionMode === InsertionMode.IN_ROW ||
            p.insertionMode === InsertionMode.IN_CELL
            ? InsertionMode.IN_SELECT_IN_TABLE
            : InsertionMode.IN_SELECT;
}
function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagId === TAG_ID.OPTION) {
        p.openElements.pop();
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}
function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope(TAG_ID.RUBY)) {
        p.openElements.generateImpliedEndTags();
    }
    p._insertElement(token, NS.HTML);
}
function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope(TAG_ID.RUBY)) {
        p.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.RTC);
    }
    p._insertElement(token, NS.HTML);
}
function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    adjustTokenMathMLAttrs(token);
    adjustTokenXMLAttrs(token);
    if (token.selfClosing) {
        p._appendElement(token, NS.MATHML);
    }
    else {
        p._insertElement(token, NS.MATHML);
    }
    token.ackSelfClosing = true;
}
function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    adjustTokenSVGAttrs(token);
    adjustTokenXMLAttrs(token);
    if (token.selfClosing) {
        p._appendElement(token, NS.SVG);
    }
    else {
        p._insertElement(token, NS.SVG);
    }
    token.ackSelfClosing = true;
}
function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}
function startTagInBody(p, token) {
    switch (token.tagID) {
        case TAG_ID.I:
        case TAG_ID.S:
        case TAG_ID.B:
        case TAG_ID.U:
        case TAG_ID.EM:
        case TAG_ID.TT:
        case TAG_ID.BIG:
        case TAG_ID.CODE:
        case TAG_ID.FONT:
        case TAG_ID.SMALL:
        case TAG_ID.STRIKE:
        case TAG_ID.STRONG: {
            bStartTagInBody(p, token);
            break;
        }
        case TAG_ID.A: {
            aStartTagInBody(p, token);
            break;
        }
        case TAG_ID.H1:
        case TAG_ID.H2:
        case TAG_ID.H3:
        case TAG_ID.H4:
        case TAG_ID.H5:
        case TAG_ID.H6: {
            numberedHeaderStartTagInBody(p, token);
            break;
        }
        case TAG_ID.P:
        case TAG_ID.DL:
        case TAG_ID.OL:
        case TAG_ID.UL:
        case TAG_ID.DIV:
        case TAG_ID.DIR:
        case TAG_ID.NAV:
        case TAG_ID.MAIN:
        case TAG_ID.MENU:
        case TAG_ID.ASIDE:
        case TAG_ID.CENTER:
        case TAG_ID.FIGURE:
        case TAG_ID.FOOTER:
        case TAG_ID.HEADER:
        case TAG_ID.HGROUP:
        case TAG_ID.DIALOG:
        case TAG_ID.DETAILS:
        case TAG_ID.ADDRESS:
        case TAG_ID.ARTICLE:
        case TAG_ID.SEARCH:
        case TAG_ID.SECTION:
        case TAG_ID.SUMMARY:
        case TAG_ID.FIELDSET:
        case TAG_ID.BLOCKQUOTE:
        case TAG_ID.FIGCAPTION: {
            addressStartTagInBody(p, token);
            break;
        }
        case TAG_ID.LI:
        case TAG_ID.DD:
        case TAG_ID.DT: {
            listItemStartTagInBody(p, token);
            break;
        }
        case TAG_ID.BR:
        case TAG_ID.IMG:
        case TAG_ID.WBR:
        case TAG_ID.AREA:
        case TAG_ID.EMBED:
        case TAG_ID.KEYGEN: {
            areaStartTagInBody(p, token);
            break;
        }
        case TAG_ID.HR: {
            hrStartTagInBody(p, token);
            break;
        }
        case TAG_ID.RB:
        case TAG_ID.RTC: {
            rbStartTagInBody(p, token);
            break;
        }
        case TAG_ID.RT:
        case TAG_ID.RP: {
            rtStartTagInBody(p, token);
            break;
        }
        case TAG_ID.PRE:
        case TAG_ID.LISTING: {
            preStartTagInBody(p, token);
            break;
        }
        case TAG_ID.XMP: {
            xmpStartTagInBody(p, token);
            break;
        }
        case TAG_ID.SVG: {
            svgStartTagInBody(p, token);
            break;
        }
        case TAG_ID.HTML: {
            htmlStartTagInBody(p, token);
            break;
        }
        case TAG_ID.BASE:
        case TAG_ID.LINK:
        case TAG_ID.META:
        case TAG_ID.STYLE:
        case TAG_ID.TITLE:
        case TAG_ID.SCRIPT:
        case TAG_ID.BGSOUND:
        case TAG_ID.BASEFONT:
        case TAG_ID.TEMPLATE: {
            startTagInHead(p, token);
            break;
        }
        case TAG_ID.BODY: {
            bodyStartTagInBody(p, token);
            break;
        }
        case TAG_ID.FORM: {
            formStartTagInBody(p, token);
            break;
        }
        case TAG_ID.NOBR: {
            nobrStartTagInBody(p, token);
            break;
        }
        case TAG_ID.MATH: {
            mathStartTagInBody(p, token);
            break;
        }
        case TAG_ID.TABLE: {
            tableStartTagInBody(p, token);
            break;
        }
        case TAG_ID.INPUT: {
            inputStartTagInBody(p, token);
            break;
        }
        case TAG_ID.PARAM:
        case TAG_ID.TRACK:
        case TAG_ID.SOURCE: {
            paramStartTagInBody(p, token);
            break;
        }
        case TAG_ID.IMAGE: {
            imageStartTagInBody(p, token);
            break;
        }
        case TAG_ID.BUTTON: {
            buttonStartTagInBody(p, token);
            break;
        }
        case TAG_ID.APPLET:
        case TAG_ID.OBJECT:
        case TAG_ID.MARQUEE: {
            appletStartTagInBody(p, token);
            break;
        }
        case TAG_ID.IFRAME: {
            iframeStartTagInBody(p, token);
            break;
        }
        case TAG_ID.SELECT: {
            selectStartTagInBody(p, token);
            break;
        }
        case TAG_ID.OPTION:
        case TAG_ID.OPTGROUP: {
            optgroupStartTagInBody(p, token);
            break;
        }
        case TAG_ID.NOEMBED:
        case TAG_ID.NOFRAMES: {
            rawTextStartTagInBody(p, token);
            break;
        }
        case TAG_ID.FRAMESET: {
            framesetStartTagInBody(p, token);
            break;
        }
        case TAG_ID.TEXTAREA: {
            textareaStartTagInBody(p, token);
            break;
        }
        case TAG_ID.NOSCRIPT: {
            if (p.options.scriptingEnabled) {
                rawTextStartTagInBody(p, token);
            }
            else {
                genericStartTagInBody(p, token);
            }
            break;
        }
        case TAG_ID.PLAINTEXT: {
            plaintextStartTagInBody(p, token);
            break;
        }
        case TAG_ID.COL:
        case TAG_ID.TH:
        case TAG_ID.TD:
        case TAG_ID.TR:
        case TAG_ID.HEAD:
        case TAG_ID.FRAME:
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD:
        case TAG_ID.CAPTION:
        case TAG_ID.COLGROUP: {
            // Ignore token
            break;
        }
        default: {
            genericStartTagInBody(p, token);
        }
    }
}
function bodyEndTagInBody(p, token) {
    if (p.openElements.hasInScope(TAG_ID.BODY)) {
        p.insertionMode = InsertionMode.AFTER_BODY;
        //NOTE: <body> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo) {
            const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
            if (bodyElement) {
                p._setEndLocation(bodyElement, token);
            }
        }
    }
}
function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope(TAG_ID.BODY)) {
        p.insertionMode = InsertionMode.AFTER_BODY;
        endTagAfterBody(p, token);
    }
}
function addressEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const { formElement } = p;
    if (!inTemplate) {
        p.formElement = null;
    }
    if ((formElement || inTemplate) && p.openElements.hasInScope(TAG_ID.FORM)) {
        p.openElements.generateImpliedEndTags();
        if (inTemplate) {
            p.openElements.popUntilTagNamePopped(TAG_ID.FORM);
        }
        else if (formElement) {
            p.openElements.remove(formElement);
        }
    }
}
function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope(TAG_ID.P)) {
        p._insertFakeElement(TAG_NAMES.P, TAG_ID.P);
    }
    p._closePElement();
}
function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope(TAG_ID.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion(TAG_ID.LI);
        p.openElements.popUntilTagNamePopped(TAG_ID.LI);
    }
}
function ddEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}
function appletEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}
function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement(TAG_NAMES.BR, TAG_ID.BR);
    p.openElements.pop();
    p.framesetOk = false;
}
function genericEndTagInBody(p, token) {
    const tn = token.tagName;
    const tid = token.tagID;
    for (let i = p.openElements.stackTop; i > 0; i--) {
        const element = p.openElements.items[i];
        const elementId = p.openElements.tagIDs[i];
        // Compare the tag name here, as the tag might not be a known tag with an ID.
        if (tid === elementId && (tid !== TAG_ID.UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
            p.openElements.generateImpliedEndTagsWithExclusion(tid);
            if (p.openElements.stackTop >= i)
                p.openElements.shortenToLength(i);
            break;
        }
        if (p._isSpecialElement(element, elementId)) {
            break;
        }
    }
}
function endTagInBody(p, token) {
    switch (token.tagID) {
        case TAG_ID.A:
        case TAG_ID.B:
        case TAG_ID.I:
        case TAG_ID.S:
        case TAG_ID.U:
        case TAG_ID.EM:
        case TAG_ID.TT:
        case TAG_ID.BIG:
        case TAG_ID.CODE:
        case TAG_ID.FONT:
        case TAG_ID.NOBR:
        case TAG_ID.SMALL:
        case TAG_ID.STRIKE:
        case TAG_ID.STRONG: {
            callAdoptionAgency(p, token);
            break;
        }
        case TAG_ID.P: {
            pEndTagInBody(p);
            break;
        }
        case TAG_ID.DL:
        case TAG_ID.UL:
        case TAG_ID.OL:
        case TAG_ID.DIR:
        case TAG_ID.DIV:
        case TAG_ID.NAV:
        case TAG_ID.PRE:
        case TAG_ID.MAIN:
        case TAG_ID.MENU:
        case TAG_ID.ASIDE:
        case TAG_ID.BUTTON:
        case TAG_ID.CENTER:
        case TAG_ID.FIGURE:
        case TAG_ID.FOOTER:
        case TAG_ID.HEADER:
        case TAG_ID.HGROUP:
        case TAG_ID.DIALOG:
        case TAG_ID.ADDRESS:
        case TAG_ID.ARTICLE:
        case TAG_ID.DETAILS:
        case TAG_ID.SEARCH:
        case TAG_ID.SECTION:
        case TAG_ID.SUMMARY:
        case TAG_ID.LISTING:
        case TAG_ID.FIELDSET:
        case TAG_ID.BLOCKQUOTE:
        case TAG_ID.FIGCAPTION: {
            addressEndTagInBody(p, token);
            break;
        }
        case TAG_ID.LI: {
            liEndTagInBody(p);
            break;
        }
        case TAG_ID.DD:
        case TAG_ID.DT: {
            ddEndTagInBody(p, token);
            break;
        }
        case TAG_ID.H1:
        case TAG_ID.H2:
        case TAG_ID.H3:
        case TAG_ID.H4:
        case TAG_ID.H5:
        case TAG_ID.H6: {
            numberedHeaderEndTagInBody(p);
            break;
        }
        case TAG_ID.BR: {
            brEndTagInBody(p);
            break;
        }
        case TAG_ID.BODY: {
            bodyEndTagInBody(p, token);
            break;
        }
        case TAG_ID.HTML: {
            htmlEndTagInBody(p, token);
            break;
        }
        case TAG_ID.FORM: {
            formEndTagInBody(p);
            break;
        }
        case TAG_ID.APPLET:
        case TAG_ID.OBJECT:
        case TAG_ID.MARQUEE: {
            appletEndTagInBody(p, token);
            break;
        }
        case TAG_ID.TEMPLATE: {
            templateEndTagInHead(p, token);
            break;
        }
        default: {
            genericEndTagInBody(p, token);
        }
    }
}
function eofInBody(p, token) {
    if (p.tmplInsertionModeStack.length > 0) {
        eofInTemplate(p, token);
    }
    else {
        stopParsing(p, token);
    }
}
// The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    var _a;
    if (token.tagID === TAG_ID.SCRIPT) {
        (_a = p.scriptHandler) === null || _a === undefined ? undefined : _a.call(p, p.openElements.current);
    }
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}
function eofInText(p, token) {
    p._err(token, ERR.eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p.onEof(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    if (TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
        p.pendingCharacterTokens.length = 0;
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = InsertionMode.IN_TABLE_TEXT;
        switch (token.type) {
            case TokenType.CHARACTER: {
                characterInTableText(p, token);
                break;
            }
            case TokenType.WHITESPACE_CHARACTER: {
                whitespaceCharacterInTableText(p, token);
                break;
            }
            // Ignore null
        }
    }
    else {
        tokenInTable(p, token);
    }
}
function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = InsertionMode.IN_CAPTION;
}
function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
}
function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement(TAG_NAMES.COLGROUP, TAG_ID.COLGROUP);
    p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
    startTagInColumnGroup(p, token);
}
function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = InsertionMode.IN_TABLE_BODY;
}
function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement(TAG_NAMES.TBODY, TAG_ID.TBODY);
    p.insertionMode = InsertionMode.IN_TABLE_BODY;
    startTagInTableBody(p, token);
}
function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope(TAG_ID.TABLE)) {
        p.openElements.popUntilTagNamePopped(TAG_ID.TABLE);
        p._resetInsertionMode();
        p._processStartTag(token);
    }
}
function inputStartTagInTable(p, token) {
    if (isHiddenInput(token)) {
        p._appendElement(token, NS.HTML);
    }
    else {
        tokenInTable(p, token);
    }
    token.ackSelfClosing = true;
}
function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}
function startTagInTable(p, token) {
    switch (token.tagID) {
        case TAG_ID.TD:
        case TAG_ID.TH:
        case TAG_ID.TR: {
            tdStartTagInTable(p, token);
            break;
        }
        case TAG_ID.STYLE:
        case TAG_ID.SCRIPT:
        case TAG_ID.TEMPLATE: {
            startTagInHead(p, token);
            break;
        }
        case TAG_ID.COL: {
            colStartTagInTable(p, token);
            break;
        }
        case TAG_ID.FORM: {
            formStartTagInTable(p, token);
            break;
        }
        case TAG_ID.TABLE: {
            tableStartTagInTable(p, token);
            break;
        }
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD: {
            tbodyStartTagInTable(p, token);
            break;
        }
        case TAG_ID.INPUT: {
            inputStartTagInTable(p, token);
            break;
        }
        case TAG_ID.CAPTION: {
            captionStartTagInTable(p, token);
            break;
        }
        case TAG_ID.COLGROUP: {
            colgroupStartTagInTable(p, token);
            break;
        }
        default: {
            tokenInTable(p, token);
        }
    }
}
function endTagInTable(p, token) {
    switch (token.tagID) {
        case TAG_ID.TABLE: {
            if (p.openElements.hasInTableScope(TAG_ID.TABLE)) {
                p.openElements.popUntilTagNamePopped(TAG_ID.TABLE);
                p._resetInsertionMode();
            }
            break;
        }
        case TAG_ID.TEMPLATE: {
            templateEndTagInHead(p, token);
            break;
        }
        case TAG_ID.BODY:
        case TAG_ID.CAPTION:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.HTML:
        case TAG_ID.TBODY:
        case TAG_ID.TD:
        case TAG_ID.TFOOT:
        case TAG_ID.TH:
        case TAG_ID.THEAD:
        case TAG_ID.TR: {
            // Ignore token
            break;
        }
        default: {
            tokenInTable(p, token);
        }
    }
}
function tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    // Process token in `In Body` mode
    modeInBody(p, token);
    p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}
function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}
function tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++) {
            tokenInTable(p, p.pendingCharacterTokens[i]);
        }
    }
    else {
        for (; i < p.pendingCharacterTokens.length; i++) {
            p._insertCharacters(p.pendingCharacterTokens[i]);
        }
    }
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
const TABLE_VOID_ELEMENTS = new Set([TAG_ID.CAPTION, TAG_ID.COL, TAG_ID.COLGROUP, TAG_ID.TBODY, TAG_ID.TD, TAG_ID.TFOOT, TAG_ID.TH, TAG_ID.THEAD, TAG_ID.TR]);
function startTagInCaption(p, token) {
    const tn = token.tagID;
    if (TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope(TAG_ID.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(TAG_ID.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = InsertionMode.IN_TABLE;
            startTagInTable(p, token);
        }
    }
    else {
        startTagInBody(p, token);
    }
}
function endTagInCaption(p, token) {
    const tn = token.tagID;
    switch (tn) {
        case TAG_ID.CAPTION:
        case TAG_ID.TABLE: {
            if (p.openElements.hasInTableScope(TAG_ID.CAPTION)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped(TAG_ID.CAPTION);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = InsertionMode.IN_TABLE;
                if (tn === TAG_ID.TABLE) {
                    endTagInTable(p, token);
                }
            }
            break;
        }
        case TAG_ID.BODY:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.HTML:
        case TAG_ID.TBODY:
        case TAG_ID.TD:
        case TAG_ID.TFOOT:
        case TAG_ID.TH:
        case TAG_ID.THEAD:
        case TAG_ID.TR: {
            // Ignore token
            break;
        }
        default: {
            endTagInBody(p, token);
        }
    }
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.COL: {
            p._appendElement(token, NS.HTML);
            token.ackSelfClosing = true;
            break;
        }
        case TAG_ID.TEMPLATE: {
            startTagInHead(p, token);
            break;
        }
        default: {
            tokenInColumnGroup(p, token);
        }
    }
}
function endTagInColumnGroup(p, token) {
    switch (token.tagID) {
        case TAG_ID.COLGROUP: {
            if (p.openElements.currentTagId === TAG_ID.COLGROUP) {
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE;
            }
            break;
        }
        case TAG_ID.TEMPLATE: {
            templateEndTagInHead(p, token);
            break;
        }
        case TAG_ID.COL: {
            // Ignore token
            break;
        }
        default: {
            tokenInColumnGroup(p, token);
        }
    }
}
function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagId === TAG_ID.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = InsertionMode.IN_TABLE;
        p._processToken(token);
    }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    switch (token.tagID) {
        case TAG_ID.TR: {
            p.openElements.clearBackToTableBodyContext();
            p._insertElement(token, NS.HTML);
            p.insertionMode = InsertionMode.IN_ROW;
            break;
        }
        case TAG_ID.TH:
        case TAG_ID.TD: {
            p.openElements.clearBackToTableBodyContext();
            p._insertFakeElement(TAG_NAMES.TR, TAG_ID.TR);
            p.insertionMode = InsertionMode.IN_ROW;
            startTagInRow(p, token);
            break;
        }
        case TAG_ID.CAPTION:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD: {
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE;
                startTagInTable(p, token);
            }
            break;
        }
        default: {
            startTagInTable(p, token);
        }
    }
}
function endTagInTableBody(p, token) {
    const tn = token.tagID;
    switch (token.tagID) {
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD: {
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE;
            }
            break;
        }
        case TAG_ID.TABLE: {
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE;
                endTagInTable(p, token);
            }
            break;
        }
        case TAG_ID.BODY:
        case TAG_ID.CAPTION:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.HTML:
        case TAG_ID.TD:
        case TAG_ID.TH:
        case TAG_ID.TR: {
            // Ignore token
            break;
        }
        default: {
            endTagInTable(p, token);
        }
    }
}
// The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    switch (token.tagID) {
        case TAG_ID.TH:
        case TAG_ID.TD: {
            p.openElements.clearBackToTableRowContext();
            p._insertElement(token, NS.HTML);
            p.insertionMode = InsertionMode.IN_CELL;
            p.activeFormattingElements.insertMarker();
            break;
        }
        case TAG_ID.CAPTION:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD:
        case TAG_ID.TR: {
            if (p.openElements.hasInTableScope(TAG_ID.TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE_BODY;
                startTagInTableBody(p, token);
            }
            break;
        }
        default: {
            startTagInTable(p, token);
        }
    }
}
function endTagInRow(p, token) {
    switch (token.tagID) {
        case TAG_ID.TR: {
            if (p.openElements.hasInTableScope(TAG_ID.TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE_BODY;
            }
            break;
        }
        case TAG_ID.TABLE: {
            if (p.openElements.hasInTableScope(TAG_ID.TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE_BODY;
                endTagInTableBody(p, token);
            }
            break;
        }
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD: {
            if (p.openElements.hasInTableScope(token.tagID) || p.openElements.hasInTableScope(TAG_ID.TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = InsertionMode.IN_TABLE_BODY;
                endTagInTableBody(p, token);
            }
            break;
        }
        case TAG_ID.BODY:
        case TAG_ID.CAPTION:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.HTML:
        case TAG_ID.TD:
        case TAG_ID.TH: {
            // Ignore end tag
            break;
        }
        default: {
            endTagInTable(p, token);
        }
    }
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    const tn = token.tagID;
    if (TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope(TAG_ID.TD) || p.openElements.hasInTableScope(TAG_ID.TH)) {
            p._closeTableCell();
            startTagInRow(p, token);
        }
    }
    else {
        startTagInBody(p, token);
    }
}
function endTagInCell(p, token) {
    const tn = token.tagID;
    switch (tn) {
        case TAG_ID.TD:
        case TAG_ID.TH: {
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped(tn);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = InsertionMode.IN_ROW;
            }
            break;
        }
        case TAG_ID.TABLE:
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD:
        case TAG_ID.TR: {
            if (p.openElements.hasInTableScope(tn)) {
                p._closeTableCell();
                endTagInRow(p, token);
            }
            break;
        }
        case TAG_ID.BODY:
        case TAG_ID.CAPTION:
        case TAG_ID.COL:
        case TAG_ID.COLGROUP:
        case TAG_ID.HTML: {
            // Ignore token
            break;
        }
        default: {
            endTagInBody(p, token);
        }
    }
}
// The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.OPTION: {
            if (p.openElements.currentTagId === TAG_ID.OPTION) {
                p.openElements.pop();
            }
            p._insertElement(token, NS.HTML);
            break;
        }
        case TAG_ID.OPTGROUP: {
            if (p.openElements.currentTagId === TAG_ID.OPTION) {
                p.openElements.pop();
            }
            if (p.openElements.currentTagId === TAG_ID.OPTGROUP) {
                p.openElements.pop();
            }
            p._insertElement(token, NS.HTML);
            break;
        }
        case TAG_ID.HR: {
            if (p.openElements.currentTagId === TAG_ID.OPTION) {
                p.openElements.pop();
            }
            if (p.openElements.currentTagId === TAG_ID.OPTGROUP) {
                p.openElements.pop();
            }
            p._appendElement(token, NS.HTML);
            token.ackSelfClosing = true;
            break;
        }
        case TAG_ID.INPUT:
        case TAG_ID.KEYGEN:
        case TAG_ID.TEXTAREA:
        case TAG_ID.SELECT: {
            if (p.openElements.hasInSelectScope(TAG_ID.SELECT)) {
                p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
                p._resetInsertionMode();
                if (token.tagID !== TAG_ID.SELECT) {
                    p._processStartTag(token);
                }
            }
            break;
        }
        case TAG_ID.SCRIPT:
        case TAG_ID.TEMPLATE: {
            startTagInHead(p, token);
            break;
        }
        // Do nothing
    }
}
function endTagInSelect(p, token) {
    switch (token.tagID) {
        case TAG_ID.OPTGROUP: {
            if (p.openElements.stackTop > 0 &&
                p.openElements.currentTagId === TAG_ID.OPTION &&
                p.openElements.tagIDs[p.openElements.stackTop - 1] === TAG_ID.OPTGROUP) {
                p.openElements.pop();
            }
            if (p.openElements.currentTagId === TAG_ID.OPTGROUP) {
                p.openElements.pop();
            }
            break;
        }
        case TAG_ID.OPTION: {
            if (p.openElements.currentTagId === TAG_ID.OPTION) {
                p.openElements.pop();
            }
            break;
        }
        case TAG_ID.SELECT: {
            if (p.openElements.hasInSelectScope(TAG_ID.SELECT)) {
                p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
                p._resetInsertionMode();
            }
            break;
        }
        case TAG_ID.TEMPLATE: {
            templateEndTagInHead(p, token);
            break;
        }
        // Do nothing
    }
}
// The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === TAG_ID.CAPTION ||
        tn === TAG_ID.TABLE ||
        tn === TAG_ID.TBODY ||
        tn === TAG_ID.TFOOT ||
        tn === TAG_ID.THEAD ||
        tn === TAG_ID.TR ||
        tn === TAG_ID.TD ||
        tn === TAG_ID.TH) {
        p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
        p._resetInsertionMode();
        p._processStartTag(token);
    }
    else {
        startTagInSelect(p, token);
    }
}
function endTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === TAG_ID.CAPTION ||
        tn === TAG_ID.TABLE ||
        tn === TAG_ID.TBODY ||
        tn === TAG_ID.TFOOT ||
        tn === TAG_ID.THEAD ||
        tn === TAG_ID.TR ||
        tn === TAG_ID.TD ||
        tn === TAG_ID.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped(TAG_ID.SELECT);
            p._resetInsertionMode();
            p.onEndTag(token);
        }
    }
    else {
        endTagInSelect(p, token);
    }
}
// The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    switch (token.tagID) {
        // First, handle tags that can start without a mode change
        case TAG_ID.BASE:
        case TAG_ID.BASEFONT:
        case TAG_ID.BGSOUND:
        case TAG_ID.LINK:
        case TAG_ID.META:
        case TAG_ID.NOFRAMES:
        case TAG_ID.SCRIPT:
        case TAG_ID.STYLE:
        case TAG_ID.TEMPLATE:
        case TAG_ID.TITLE: {
            startTagInHead(p, token);
            break;
        }
        // Re-process the token in the appropriate mode
        case TAG_ID.CAPTION:
        case TAG_ID.COLGROUP:
        case TAG_ID.TBODY:
        case TAG_ID.TFOOT:
        case TAG_ID.THEAD: {
            p.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE;
            p.insertionMode = InsertionMode.IN_TABLE;
            startTagInTable(p, token);
            break;
        }
        case TAG_ID.COL: {
            p.tmplInsertionModeStack[0] = InsertionMode.IN_COLUMN_GROUP;
            p.insertionMode = InsertionMode.IN_COLUMN_GROUP;
            startTagInColumnGroup(p, token);
            break;
        }
        case TAG_ID.TR: {
            p.tmplInsertionModeStack[0] = InsertionMode.IN_TABLE_BODY;
            p.insertionMode = InsertionMode.IN_TABLE_BODY;
            startTagInTableBody(p, token);
            break;
        }
        case TAG_ID.TD:
        case TAG_ID.TH: {
            p.tmplInsertionModeStack[0] = InsertionMode.IN_ROW;
            p.insertionMode = InsertionMode.IN_ROW;
            startTagInRow(p, token);
            break;
        }
        default: {
            p.tmplInsertionModeStack[0] = InsertionMode.IN_BODY;
            p.insertionMode = InsertionMode.IN_BODY;
            startTagInBody(p, token);
        }
    }
}
function endTagInTemplate(p, token) {
    if (token.tagID === TAG_ID.TEMPLATE) {
        templateEndTagInHead(p, token);
    }
}
function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped(TAG_ID.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
        p.onEof(token);
    }
    else {
        stopParsing(p, token);
    }
}
// The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagID === TAG_ID.HTML) {
        startTagInBody(p, token);
    }
    else {
        tokenAfterBody(p, token);
    }
}
function endTagAfterBody(p, token) {
    var _a;
    if (token.tagID === TAG_ID.HTML) {
        if (!p.fragmentContext) {
            p.insertionMode = InsertionMode.AFTER_AFTER_BODY;
        }
        //NOTE: <html> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === TAG_ID.HTML) {
            p._setEndLocation(p.openElements.items[0], token);
            // Update the body element, if it doesn't have an end tag
            const bodyElement = p.openElements.items[1];
            if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === undefined ? undefined : _a.endTag)) {
                p._setEndLocation(bodyElement, token);
            }
        }
    }
    else {
        tokenAfterBody(p, token);
    }
}
function tokenAfterBody(p, token) {
    p.insertionMode = InsertionMode.IN_BODY;
    modeInBody(p, token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.FRAMESET: {
            p._insertElement(token, NS.HTML);
            break;
        }
        case TAG_ID.FRAME: {
            p._appendElement(token, NS.HTML);
            token.ackSelfClosing = true;
            break;
        }
        case TAG_ID.NOFRAMES: {
            startTagInHead(p, token);
            break;
        }
        // Do nothing
    }
}
function endTagInFrameset(p, token) {
    if (token.tagID === TAG_ID.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();
        if (!p.fragmentContext && p.openElements.currentTagId !== TAG_ID.FRAMESET) {
            p.insertionMode = InsertionMode.AFTER_FRAMESET;
        }
    }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.NOFRAMES: {
            startTagInHead(p, token);
            break;
        }
        // Do nothing
    }
}
function endTagAfterFrameset(p, token) {
    if (token.tagID === TAG_ID.HTML) {
        p.insertionMode = InsertionMode.AFTER_AFTER_FRAMESET;
    }
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagID === TAG_ID.HTML) {
        startTagInBody(p, token);
    }
    else {
        tokenAfterAfterBody(p, token);
    }
}
function tokenAfterAfterBody(p, token) {
    p.insertionMode = InsertionMode.IN_BODY;
    modeInBody(p, token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    switch (token.tagID) {
        case TAG_ID.HTML: {
            startTagInBody(p, token);
            break;
        }
        case TAG_ID.NOFRAMES: {
            startTagInHead(p, token);
            break;
        }
        // Do nothing
    }
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}
function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}
function popUntilHtmlOrIntegrationPoint(p) {
    while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML &&
        !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current)) {
        p.openElements.pop();
    }
}
function startTagInForeignContent(p, token) {
    if (causesExit(token)) {
        popUntilHtmlOrIntegrationPoint(p);
        p._startTagOutsideForeignContent(token);
    }
    else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);
        if (currentNs === NS.MATHML) {
            adjustTokenMathMLAttrs(token);
        }
        else if (currentNs === NS.SVG) {
            adjustTokenSVGTagName(token);
            adjustTokenSVGAttrs(token);
        }
        adjustTokenXMLAttrs(token);
        if (token.selfClosing) {
            p._appendElement(token, currentNs);
        }
        else {
            p._insertElement(token, currentNs);
        }
        token.ackSelfClosing = true;
    }
}
function endTagInForeignContent(p, token) {
    if (token.tagID === TAG_ID.P || token.tagID === TAG_ID.BR) {
        popUntilHtmlOrIntegrationPoint(p);
        p._endTagOutsideForeignContent(token);
        return;
    }
    for (let i = p.openElements.stackTop; i > 0; i--) {
        const element = p.openElements.items[i];
        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._endTagOutsideForeignContent(token);
            break;
        }
        const tagName = p.treeAdapter.getTagName(element);
        if (tagName.toLowerCase() === token.tagName) {
            //NOTE: update the token tag name for `_setEndLocation`.
            token.tagName = tagName;
            p.openElements.shortenToLength(i);
            break;
        }
    }
}

// Sets
new Set([
    TAG_NAMES.AREA,
    TAG_NAMES.BASE,
    TAG_NAMES.BASEFONT,
    TAG_NAMES.BGSOUND,
    TAG_NAMES.BR,
    TAG_NAMES.COL,
    TAG_NAMES.EMBED,
    TAG_NAMES.FRAME,
    TAG_NAMES.HR,
    TAG_NAMES.IMG,
    TAG_NAMES.INPUT,
    TAG_NAMES.KEYGEN,
    TAG_NAMES.LINK,
    TAG_NAMES.META,
    TAG_NAMES.PARAM,
    TAG_NAMES.SOURCE,
    TAG_NAMES.TRACK,
    TAG_NAMES.WBR,
]);

/**
 * @import {Options} from 'hast-util-raw'
 * @import {Comment, Doctype, Element, Nodes, RootContent, Root, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {DefaultTreeAdapterMap, ParserOptions} from 'parse5'
 * @import {Point} from 'unist'
 */


const gfmTagfilterExpression =
  /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi;

// Node types associated with MDX.
// <https://github.com/mdx-js/mdx/blob/8a56312/packages/mdx/lib/node-types.js>
const knownMdxNames = new Set([
  'mdxFlowExpression',
  'mdxJsxFlowElement',
  'mdxJsxTextElement',
  'mdxTextExpression',
  'mdxjsEsm'
]);

/** @type {ParserOptions<DefaultTreeAdapterMap>} */
const parseOptions = {sourceCodeLocationInfo: true, scriptingEnabled: false};

/**
 * Pass a hast tree through an HTML parser, which will fix nesting, and turn
 * raw nodes into actual nodes.
 *
 * @param {Nodes} tree
 *   Original hast tree to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {Nodes}
 *   Parsed again tree.
 */
function raw(tree, options) {
  const document = documentMode(tree);
  /** @type {(node: Nodes, state: State) => undefined} */
  const one = zwitch('type', {
    handlers: {root, element, text, comment, doctype, raw: handleRaw},
    unknown
  });

  /** @type {State} */
  const state = {
    parser: document
      ? new Parser(parseOptions)
      : Parser.getFragmentParser(undefined, parseOptions),
    handle(node) {
      one(node, state);
    },
    stitches: false,
    options: options || {}
  };

  one(tree, state);
  resetTokenizer(state, pointStart());

  const p5 = document ? state.parser.document : state.parser.getFragment();
  const result = fromParse5(p5, {
    // To do: support `space`?
    file: state.options.file
  });

  if (state.stitches) {
    visit(result, 'comment', function (node, index, parent) {
      const stitch = /** @type {Stitch} */ (/** @type {unknown} */ (node));
      if (stitch.value.stitch && parent && index !== undefined) {
        /** @type {Array<RootContent>} */
        const siblings = parent.children;
        // @ts-expect-error: assume the stitch is allowed.
        siblings[index] = stitch.value.stitch;
        return index
      }
    });
  }

  // Unpack if possible and when not given a `root`.
  if (
    result.type === 'root' &&
    result.children.length === 1 &&
    result.children[0].type === tree.type
  ) {
    return result.children[0]
  }

  return result
}

/**
 * Transform all nodes
 *
 * @param {Array<RootContent>} nodes
 *   hast content.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function all(nodes, state) {
  let index = -1;

  /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */
  if (nodes) {
    while (++index < nodes.length) {
      state.handle(nodes[index]);
    }
  }
}

/**
 * Transform a root.
 *
 * @param {Root} node
 *   hast root node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function root(node, state) {
  all(node.children, state);
}

/**
 * Transform an element.
 *
 * @param {Element} node
 *   hast element node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function element(node, state) {
  startTag(node, state);

  all(node.children, state);

  endTag(node, state);
}

/**
 * Transform a text.
 *
 * @param {Text} node
 *   hast text node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function text(node, state) {
  // Allow `DATA` through `PLAINTEXT`,
  // but when hanging in a tag for example,
  // switch back to `DATA`.
  // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
  // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
  if (state.parser.tokenizer.state > 4) {
    state.parser.tokenizer.state = 0;
  }

  /** @type {Token.CharacterToken} */
  const token = {
    type: TokenType.CHARACTER,
    chars: node.value,
    location: createParse5Location(node)
  };

  resetTokenizer(state, pointStart(node));
  // @ts-expect-error: private.
  state.parser.currentToken = token;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);
}

/**
 * Transform a doctype.
 *
 * @param {Doctype} node
 *   hast doctype node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function doctype(node, state) {
  /** @type {Token.DoctypeToken} */
  const token = {
    type: TokenType.DOCTYPE,
    name: 'html',
    forceQuirks: false,
    publicId: '',
    systemId: '',
    location: createParse5Location(node)
  };

  resetTokenizer(state, pointStart(node));
  // @ts-expect-error: private.
  state.parser.currentToken = token;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);
}

/**
 * Transform a stitch.
 *
 * @param {Nodes} node
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function stitch(node, state) {
  // Mark that there are stitches, so we need to walk the tree and revert them.
  state.stitches = true;

  /** @type {Nodes} */
  const clone = cloneWithoutChildren(node);

  // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
  // passed through node).
  if ('children' in node && 'children' in clone) {
    // Root in root out.
    const fakeRoot = /** @type {Root} */ (
      raw({type: 'root', children: node.children}, state.options)
    );
    clone.children = fakeRoot.children;
  }

  // Hack: `value` is supposed to be a string, but as none of the tools
  // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
  // through.
  comment({type: 'comment', value: {stitch: clone}}, state);
}

/**
 * Transform a comment (or stitch).
 *
 * @param {Comment | Stitch} node
 *   hast comment node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function comment(node, state) {
  /** @type {string} */
  // @ts-expect-error: we pass stitches through.
  const data = node.value;

  /** @type {Token.CommentToken} */
  const token = {
    type: TokenType.COMMENT,
    data,
    location: createParse5Location(node)
  };
  resetTokenizer(state, pointStart(node));
  // @ts-expect-error: private.
  state.parser.currentToken = token;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);
}

/**
 * Transform a raw node.
 *
 * @param {Raw} node
 *   hast raw node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function handleRaw(node, state) {
  // Reset preprocessor:
  // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/preprocessor.ts#L18-L31>.
  state.parser.tokenizer.preprocessor.html = '';
  state.parser.tokenizer.preprocessor.pos = -1;
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.lastGapPos = -2;
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.gapStack = [];
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.skipNextNewLine = false;
  state.parser.tokenizer.preprocessor.lastChunkWritten = false;
  state.parser.tokenizer.preprocessor.endOfChunkHit = false;
  // @ts-expect-error: private.
  // type-coverage:ignore-next-line
  state.parser.tokenizer.preprocessor.isEol = false;

  // Now pass `node.value`.
  setPoint(state, pointStart(node));

  state.parser.tokenizer.write(
    state.options.tagfilter
      ? node.value.replace(gfmTagfilterExpression, '&lt;$1$2')
      : node.value,
    false
  );
  // @ts-expect-error: private.
  state.parser.tokenizer._runParsingLoop();

  // Character references hang, so if we ended there, we need to flush
  // those too.
  // We reset the preprocessor as if the document ends here.
  // Then one single call to the relevant state does the trick, parse5
  // consumes the whole token.

  // Note: `State` is not exposed by `parse5`, so these numbers are fragile.
  // See: <https://github.com/inikulin/parse5/blob/46cba43/packages/parse5/lib/tokenizer/index.ts#L58>
  // Note: a change to `parse5`, which breaks this, was merged but not released.
  // Investigate when it is.
  // To do: remove next major.
  /* c8 ignore next 12 -- removed in <https://github.com/inikulin/parse5/pull/897> */
  if (
    state.parser.tokenizer.state === 72 /* NAMED_CHARACTER_REFERENCE */ ||
    // @ts-expect-error: removed.
    state.parser.tokenizer.state === 78 /* NUMERIC_CHARACTER_REFERENCE_END */
  ) {
    state.parser.tokenizer.preprocessor.lastChunkWritten = true;
    /** @type {number} */
    // @ts-expect-error: private.
    const cp = state.parser.tokenizer._consume();
    // @ts-expect-error: private.
    state.parser.tokenizer._callState(cp);
  }
}

/**
 * Crash on an unknown node.
 *
 * @param {unknown} node_
 *   unknown node.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Never.
 */
function unknown(node_, state) {
  const node = /** @type {Nodes} */ (node_);

  if (
    state.options.passThrough &&
    state.options.passThrough.includes(node.type)
  ) {
    stitch(node, state);
  } else {
    let extra = '';

    if (knownMdxNames.has(node.type)) {
      extra =
        ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax";
    }

    throw new Error('Cannot compile `' + node.type + '` node' + extra)
  }
}

/**
 * Reset the tokenizer of a parser.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */
function resetTokenizer(state, point) {
  setPoint(state, point);

  // Process final characters if they’re still there after hibernating.
  /** @type {Token.CharacterToken} */
  // @ts-expect-error: private.
  const token = state.parser.tokenizer.currentCharacterToken;

  if (token && token.location) {
    token.location.endLine = state.parser.tokenizer.preprocessor.line;
    token.location.endCol = state.parser.tokenizer.preprocessor.col + 1;
    token.location.endOffset = state.parser.tokenizer.preprocessor.offset + 1;
    // @ts-expect-error: private.
    state.parser.currentToken = token;
    // @ts-expect-error: private.
    state.parser._processToken(state.parser.currentToken);
  }

  // Reset tokenizer:
  // See: <https://github.com/inikulin/parse5/blob/6f7ca60/packages/parse5/lib/tokenizer/index.ts#L187-L223>.
  // Especially putting it back in the `data` state is useful: some elements,
  // like textareas and iframes, change the state.
  // See GH-7.
  // But also if broken HTML is in `raw`, and then a correct element is given.
  // See GH-11.
  // @ts-expect-error: private.
  state.parser.tokenizer.paused = false;
  // @ts-expect-error: private.
  state.parser.tokenizer.inLoop = false;

  // Note: don’t reset `state`, `inForeignNode`, or `lastStartTagName`, we
  // manually update those when needed.
  state.parser.tokenizer.active = false;
  // @ts-expect-error: private.
  state.parser.tokenizer.returnState = TokenizerMode.DATA;
  // @ts-expect-error: private.
  state.parser.tokenizer.charRefCode = -1;
  // @ts-expect-error: private.
  state.parser.tokenizer.consumedAfterSnapshot = -1;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentLocation = null;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentCharacterToken = null;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentToken = null;
  // @ts-expect-error: private.
  state.parser.tokenizer.currentAttr = {name: '', value: ''};
}

/**
 * Set current location.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Point | undefined} point
 *   Point.
 * @returns {undefined}
 *   Nothing.
 */
function setPoint(state, point) {
  if (point && point.offset !== undefined) {
    /** @type {Token.Location} */
    const location = {
      startLine: point.line,
      startCol: point.column,
      startOffset: point.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };

    // @ts-expect-error: private.
    // type-coverage:ignore-next-line
    state.parser.tokenizer.preprocessor.lineStartPos = -point.column + 1; // Looks weird, but ensures we get correct positional info.
    state.parser.tokenizer.preprocessor.droppedBufferSize = point.offset;
    state.parser.tokenizer.preprocessor.line = point.line;
    // @ts-expect-error: private.
    state.parser.tokenizer.currentLocation = location;
  }
}

/**
 * Emit a start tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function startTag(node, state) {
  const tagName = node.tagName.toLowerCase();

  // Ignore tags if we’re in plain text.
  if (state.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return

  resetTokenizer(state, pointStart(node));

  const current = state.parser.openElements.current;
  let ns = 'namespaceURI' in current ? current.namespaceURI : webNamespaces.html;

  if (ns === webNamespaces.html && tagName === 'svg') {
    ns = webNamespaces.svg;
  }

  const result = toParse5(
    // Shallow clone to not delve into `children`: we only need the attributes.
    {...node, children: []},
    {space: ns === webNamespaces.svg ? 'svg' : 'html'}
  );

  /** @type {Token.TagToken} */
  const tag = {
    type: TokenType.START_TAG,
    tagName,
    tagID: getTagID(tagName),
    // We always send start and end tags.
    selfClosing: false,
    ackSelfClosing: false,
    // Always element.
    /* c8 ignore next */
    attrs: 'attrs' in result ? result.attrs : [],
    location: createParse5Location(node)
  };

  // The HTML parsing algorithm works by doing half of the state management in
  // the tokenizer and half in the parser.
  // We can’t use the tokenizer here, as we don’t have strings.
  // So we act *as if* the tokenizer emits tokens:

  // @ts-expect-error: private.
  state.parser.currentToken = tag;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);

  // …but then we still need a bunch of work that the tokenizer would normally
  // do, such as:

  // Set a tag name, similar to how the tokenizer would do it.
  state.parser.tokenizer.lastStartTagName = tagName;

  // `inForeignNode` is correctly set by the parser.
}

/**
 * Emit an end tag.
 *
 * @param {Element} node
 *   Element.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {undefined}
 *   Nothing.
 */
function endTag(node, state) {
  const tagName = node.tagName.toLowerCase();
  // Do not emit closing tags for HTML void elements.
  if (
    !state.parser.tokenizer.inForeignNode &&
    htmlVoidElements.includes(tagName)
  ) {
    return
  }

  // Ignore tags if we’re in plain text.
  if (state.parser.tokenizer.state === TokenizerMode.PLAINTEXT) return

  resetTokenizer(state, pointEnd(node));

  /** @type {Token.TagToken} */
  const tag = {
    type: TokenType.END_TAG,
    tagName,
    tagID: getTagID(tagName),
    selfClosing: false,
    ackSelfClosing: false,
    attrs: [],
    location: createParse5Location(node)
  };

  // The HTML parsing algorithm works by doing half of the state management in
  // the tokenizer and half in the parser.
  // We can’t use the tokenizer here, as we don’t have strings.
  // So we act *as if* the tokenizer emits tokens:

  // @ts-expect-error: private.
  state.parser.currentToken = tag;
  // @ts-expect-error: private.
  state.parser._processToken(state.parser.currentToken);

  // …but then we still need a bunch of work that the tokenizer would normally
  // do, such as:

  // Switch back to the data state after alternative states that don’t accept
  // tags:
  if (
    // Current element is closed.
    tagName === state.parser.tokenizer.lastStartTagName &&
    // `<textarea>` and `<title>`
    (state.parser.tokenizer.state === TokenizerMode.RCDATA ||
      // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
      state.parser.tokenizer.state === TokenizerMode.RAWTEXT ||
      // `<script>`
      state.parser.tokenizer.state === TokenizerMode.SCRIPT_DATA)
    // Note: `<plaintext>` not needed, as it’s the last element.
  ) {
    state.parser.tokenizer.state = TokenizerMode.DATA;
  }
}

/**
 * Check if `node` represents a whole document or a fragment.
 *
 * @param {Nodes} node
 *   hast node.
 * @returns {boolean}
 *   Whether this represents a whole document or a fragment.
 */
function documentMode(node) {
  const head = node.type === 'root' ? node.children[0] : node;
  return Boolean(
    head &&
      (head.type === 'doctype' ||
        (head.type === 'element' && head.tagName.toLowerCase() === 'html'))
  )
}

/**
 * Get a `parse5` location from a node.
 *
 * @param {Nodes | Stitch} node
 *   hast node.
 * @returns {Token.Location}
 *   `parse5` location.
 */
function createParse5Location(node) {
  const start = pointStart(node) || {
    line: undefined,
    column: undefined,
    offset: undefined
  };
  const end = pointEnd(node) || {
    line: undefined,
    column: undefined,
    offset: undefined
  };

  /** @type {Record<keyof Token.Location, number | undefined>} */
  const location = {
    startLine: start.line,
    startCol: start.column,
    startOffset: start.offset,
    endLine: end.line,
    endCol: end.column,
    endOffset: end.offset
  };

  // @ts-expect-error: unist point values can be `undefined` in hast, which
  // `parse5` types don’t want.
  return location
}

/**
 * @template {Nodes} NodeType
 *   Node type.
 * @param {NodeType} node
 *   Node to clone.
 * @returns {NodeType}
 *   Cloned node, without children.
 */
function cloneWithoutChildren(node) {
  return 'children' in node
    ? structuredClone$1({...node, children: []})
    : structuredClone$1(node)
}

/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} RawOptions
 * @typedef {import('vfile').VFile} VFile
 */


/**
 * Parse the tree (and raw nodes) again, keeping positional info okay.
 *
 * @param {Options | null | undefined}  [options]
 *   Configuration (optional).
 * @returns
 *   Transform.
 */
function rehypeRaw(options) {
  /**
   * @param {Root} tree
   *   Tree.
   * @param {VFile} file
   *   File.
   * @returns {Root}
   *   New tree.
   */
  return function (tree, file) {
    // Assume root in -> root out.
    const result = /** @type {Root} */ (raw(tree, {...options, file}));
    return result
  }
}

const useLearnMoreStyles = makeStyles({
        learnMoreContainer: {},
        learnMoreHeading: {},
        learnMoreListContainer: {},
        learnMoreList: {},
        learnMoreLinks: {},
    }
);

const LearnMore = ({ links }) => {
  const classes = useLearnMoreStyles();
  const openLinkInNewTab = (link) => window.open(link, "_blank");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classes.learnMoreContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: classes.learnMoreHeading, children: LearnMoreText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: classes.learnMoreListContainer, children: links?.map((link, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: classes.learnMoreLinks, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "a",
      {
        href: "#",
        target: "_blank",
        onClick: (e) => {
          e.preventDefault();
          openLinkInNewTab(link.url);
        },
        className: classes.learnMoreLink,
        children: [
          " ",
          link?.title
        ]
      }
    ) }, index)) })
  ] });
};

const parseJson = (inputData) => {
    try {
        return inputData && JSON.parse(inputData);
    } catch (e) {
        console.error("Failed to parse data field:", e);
        return {};
    }
};


const formatAndConvertJsonBySourceAndType = (conversation) => {
    const parsedData = parseJson(conversation?.data);
    const formattedData = {
        ...conversation,
        dataToDisplay: {}
    };

    switch (conversation?.responseType) {

        case "command":
            if (parsedData.reply) {
                let markdown = parsedData.reply;
                formattedData.dataToDisplay['markdownString'] = markdown?.replace(/<\/?Cell>/g, "");
            }
            break;

        case "markdown":
            if (parsedData.reply) {
                let markdown = parsedData.reply;
                formattedData.dataToDisplay['markdownString'] = markdown?.replace(/<\/?Cell>/g, "");
            }
            if (parsedData.parentId) {
                formattedData.dataToDisplay['parentId'] = parsedData?.parentId;
            }
            if (parsedData.docs) {
                const docsContent = parsedData.docs;
                const jsonDocs = JSON.parse(docsContent);
                formattedData.dataToDisplay['learnMoreLInks'] = Array.from(new Map(jsonDocs.docs?.map(doc =>
                    [doc.metadata.url, {title: doc.metadata.title, url: doc.metadata.url}])).values()
                );
            }
            if (parsedData["Data"]) {
                const dataString = parsedData["Data"];
                const jsonData = parseJson(dataString);
               // console.log("jsonData", jsonData);

                if (jsonData.reply) {
                    let markdown = jsonData.reply;
                    formattedData.dataToDisplay['markdownString'] = markdown?.replace(/<\/?Cell>/g, "");
                }
                if (jsonData.parentId) {
                    formattedData.dataToDisplay['parentId'] = jsonData?.parentId;
                }
                if (jsonData.docs) {
                    const docsContent = jsonData.docs;
                    const jsonDocs = JSON.parse(docsContent);
                    formattedData.dataToDisplay['learnMoreLInks'] = Array.from(new Map(jsonDocs.docs?.map(doc =>
                        [doc.metadata.url, { title: doc.metadata.title, url: doc.metadata.url }])).values()
                    );
                }
            }

            break;

        case "graph":
            const {reply, api, rephrasedQuestion} = JSON.parse(parsedData);
            formattedData.dataToDisplay["graphType"] = parsedData.includes("pie");
            formattedData.dataToDisplay["match"] = parsedData.match(/(px\.(\w+)|plt\.(\w+))/);

            if (reply.data) formattedData.dataToDisplay["plotData"] = reply.data;
            if (reply.layout) formattedData.dataToDisplay["layout"] = reply.layout;
            if (api) formattedData.dataToDisplay["api"] = api;
            if (reply) formattedData.dataToDisplay["graphData"] = reply;


            console.log("reply", reply);
            console.log("api", api);
            console.log("parsedData", parsedData);
            formattedData.dataToDisplay["rephrasedQuestion"] = rephrasedQuestion;

            break;

        case "text":
            if (parsedData.rephrasedQuestion) {
                formattedData.dataToDisplay["rephrasedQuestion"] = parsedData.rephrasedQuestion;
            }
            if (parsedData.reply) {
                formattedData.dataToDisplay["replyMessages"] = parsedData.reply;
            }
            if (parsedData.parentId) {
                formattedData.dataToDisplay["parentId"] = parsedData.parentId;
            }
            if (parsedData.aiResponseData) {
                formattedData.dataToDisplay["aiResponseData"] = parsedData?.aiResponseData;
            }
            if (parsedData) {
                const jsonContentData = parseJson(parsedData)?.contentData;
                if (jsonContentData) {
                    formattedData.dataToDisplay["contentData"] = jsonContentData?.replace(/<\/?Cell>/g, "");
                }
            }
            if (parsedData.query) {
                formattedData.dataToDisplay["query"] = parsedData.query;
            }
            if (parsedData.intent) {
                formattedData.dataToDisplay["intent"] = parsedData?.intent;
            }
            break;

        case "htmltable":
            if (parsedData.reply) {
                formattedData.dataToDisplay["tableData"] = parsedData.reply;
            }
            if (parsedData.parentId) {
                formattedData.dataToDisplay["parentId"] = parsedData.parentId;
            }
            if (parsedData.note) {
                formattedData.dataToDisplay["note"] = parsedData.note;
            }
            break;
    }

   // console.log("formattedData", formattedData);
    return formattedData;
};

const useMarkdownStyles$1 = makeStyles({
    markdownMessageContainer: {
        padding: "0 0 8px 0",
    },
    markdownMessage: {
        fontFamily: "Segoe UI",
        fontSize: "12px",
        padding: "8px 0",
        selectors: {
            h1: {
                paddingBottom: tokens$2.spacingS,
                marginBottom: tokens$2.spacingM,
                fontSize: tokens$2.fontSizeHeading4,
                fontWeight: tokens$2.fontWeightBold,
            },
            h2: {
                paddingBottom: tokens$2.spacingS,
                marginBottom: tokens$2.spacingM,
                fontSize: tokens$2.fontSizeHeading5,
                fontWeight: tokens$2.fontWeightSemibold,
            },
            h3: {
                paddingBottom: tokens$2.spacingXS,
                marginBottom: tokens$2.spacingS,
                fontSize: tokens$2.fontSizeHeading6,
                fontWeight: tokens$2.fontWeightSemibold,
            },
            h4: {
                paddingBottom: tokens$2.spacingXS,
                marginBottom: tokens$2.spacingS,
                fontSize: tokens$2.fontSizeHeading6,
                fontWeight: tokens$2.fontWeightRegular,
            },
            h5: {
                paddingBottom: tokens$2.spacingXS,
                marginBottom: tokens$2.spacingS,
                fontSize: tokens$2.fontSizeHeading6,
                fontWeight: tokens$2.fontWeightRegular,
            },
            h6: {
                paddingBottom: tokens$2.spacingXS,
                marginBottom: tokens$2.spacingS,
                fontSize: tokens$2.fontSizeHeading6,
                fontWeight: tokens$2.fontWeightRegular,
            },
            p: {
                paddingTop: tokens$2.spacingXS,
                paddingBottom: tokens$2.spacingS,
                marginBottom: tokens$2.spacingL,
                lineHeight: tokens$2.lineHeightBase,
                fontSize: tokens$2.fontSizeBase,
            },
            a: {
                color: tokens$2.colorBrandForegroundLink,
                textDecoration: 'none',
                ':hover': {
                    textDecoration: 'underline',
                },
            },
            table: {
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: tokens$2.spacingL,
            },
            th: {
                backgroundColor: tokens$2.colorNeutralBackground3,
                padding: `${tokens$2.spacingXS} ${tokens$2.spacingS}`,
                fontWeight: tokens$2.fontWeightBold,
            },
            td: {
                padding: `${tokens$2.spacingXS} ${tokens$2.spacingS}`,
                border: `1px solid ${tokens$2.colorNeutralStroke2}`,
            },
            blockquote: {
                paddingLeft: tokens$2.spacingM,
                margin: `${tokens$2.spacingL} 0`,
                fontStyle: 'italic',
                color: tokens$2.colorNeutralForeground2,
                borderLeft: `4px solid ${tokens$2.colorNeutralStroke1}`,
            },
            pre: {
                backgroundColor: tokens$2.colorNeutralBackground1,
                padding: tokens$2.spacingL,
                marginBottom: tokens$2.spacingL,
                fontFamily: tokens$2.fontFamilyMonospace,
                borderRadius: tokens$2.borderRadiusSmall,
            },
            code: {
                backgroundColor: tokens$2.colorNeutralBackground2,
                padding: `${tokens$2.spacingXS} ${tokens$2.spacingS}`,
                fontFamily: tokens$2.fontFamilyMonospace,
                borderRadius: tokens$2.borderRadiusSmall,
            },
            hr: {
                border: `1px solid ${tokens$2.colorNeutralStroke1}`,
                margin: `${tokens$2.spacingL} 0`,
            },
        },
    },


});

const useChatbotActionButtonsStyles = makeStyles({
        chatbotActionContainer: {
            padding: "2px 0 0 0"
        },
        chatbotActionButtonsContainer: {
            display: "flex",
            justifyContent: "space-between",
        },
        chatbotLeftButtonsContainer: {
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
        },
    }
);

function useCopyToClipBoard() {
    const copyToClipBoard = useCallback((textToCopy) => {
        const tempElement = document.createElement('pre');
        tempElement.innerHTML = textToCopy;
        document.body.appendChild(tempElement);
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(tempElement);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        document.body.removeChild(tempElement);
    }, []);
    return {copyToClipBoard};
}

const CopilotCopyButton = ({ textToCopy, conversation, source }) => {
  useMCAPSBotFormContext();
  const { trackCopilotEvent } = useTrackCustomEvents();
  const { copyToClipBoard } = useCopyToClipBoard();
  const { featureName } = useMCAPSBotContext();
  const [tooltipText, setTooltipText] = useState("Copy");
  const handleClick = () => {
    copyToClipBoard(textToCopy);
    setTooltipText("Copied");
    if (source === "bot") {
      trackCopilotEvent(featureName + " Copy button clicked", "Copy button clicked", getQuesAns(conversation));
    }
    setTimeout(() => {
      setTooltipText("Copy");
    }, 1e4);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { content: tooltipText, withArrow: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      appearance: "secondary",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyRegular, {}),
      "aria-label": "Copy",
      title: "Copy",
      onClick: handleClick
    }
  ) });
};

const useCopilotCreateSupportTicketButtonStyles = makeStyles({
    copilotCreateSupportTicketButtonContainer:{
            display: "flex",
            justifyContent: "space-between",
            padding:0,
            margin:0,
        }
    }
);

const CopilotCreateSupportTicketButton = ({ conversation }) => {
  const copilotMode = useCopilotMode();
  const { trackCopilotEvent } = useTrackCustomEvents();
  const { featureName, supportTicket, setIsFullScreen, isVisible, isCreateIncidentButtonVisible } = useMCAPSBotContext();
  useMCAPSBotFormContext();
  const styles = useCopilotCreateSupportTicketButtonStyles();
  const createSupportTicket = () => {
    setIsFullScreen(false);
    trackCopilotEvent(featureName + " Create support ticket clicked", "Create support ticket clicked", getQuesAns(conversation));
    supportTicket();
  };
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"] {
        left: -787px !important;
      }
      div.ms-Panel.is-open.ms-Panel--custom.irisBot._2apRz.react-draggable[class*="root-"] > div {
        box-shadow: none !important;
      }
    `;
    if (isVisible) {
      document.head.appendChild(style);
    } else {
      document.head.removeChild(style);
    }
    return () => {
      document.head.removeChild(style);
    };
  }, [isVisible]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.copilotCreateSupportTicketButtonContainer, children: isCreateIncidentButtonVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      appearance: copilotMode === "canvas" ? "secondary" : "transparent",
      "aria-label": "Create a Support Ticket",
      onClick: createSupportTicket,
      children: "Create a Support Ticket"
    }
  ) });
};

const ChatBotActionButtons = ({ textToCopy, conversation }) => {
  const dispatch = useDispatch();
  const styles = useChatbotActionButtonsStyles();
  const { trackCopilotEvent } = useTrackCustomEvents();
  const { featureName, ocvData, positiveFeedback, negativeFeedback, isActionsButtonVisible } = useMCAPSBotContext();
  const isSelected = conversation?.isFeedbackUpvoted === true ? "positive" : conversation?.isFeedbackUpvoted === false ? "negative" : undefined;
  const [selected, setSelected] = useState(isSelected);
  const disabled = selected !== undefined;
  const handlePositiveFeedback = () => {
    setSelected("positive");
    const message = {
      ...conversation,
      isFeedbackUpvoted: true
    };
    dispatch(updateConversationsHistory(message));
    positiveFeedback();
    ocvData(true, message);
    trackCopilotEvent(featureName + " Positive feedback clicked", "Positive feedback clicked", getQuesAns(message));
  };
  const handleNegativeFeedback = () => {
    setSelected("negative");
    const message = {
      ...conversation,
      isFeedbackUpvoted: false
    };
    dispatch(updateConversationsHistory(message));
    negativeFeedback();
    ocvData(false, message);
    trackCopilotEvent(featureName + " Negative feedback clicked", "Negetive feedback clicked", getQuesAns(message));
  };
  return isActionsButtonVisible && isActionsButtonVisible === true && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.chatbotActionContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.chatbotActionButtonsContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.chatbotLeftButtonsContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotCreateSupportTicketButton, { conversation }),
      textToCopy && /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotCopyButton, { textToCopy, conversation, source: "bot" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FeedbackButtons,
      {
        disabled,
        selected,
        positiveFeedbackButton: { onClick: handlePositiveFeedback },
        negativeFeedbackButton: { onClick: handleNegativeFeedback },
        positiveFeedbackTooltip: {
          content: selected === "positive" ? "Like, Feedback sent" : "Like"
        },
        negativeFeedbackTooltip: {
          content: selected === "negative" ? "Dislike, Feedback sent" : "Dislike"
        }
      }
    )
  ] }) });
};

const MarkdownMessage = ({ conversation }) => {
  const { setFormState } = useMCAPSBotFormContext();
  const className = useMarkdownStyles$1();
  const jsonConversation = formatAndConvertJsonBySourceAndType(conversation)?.dataToDisplay;
  const { learnMoreLInks, markdownString } = jsonConversation;
  const LinkRenderer = ({ href, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children });
  const MarkdownRenderer = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: className.markdownMessage, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { components: { a: LinkRenderer }, remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], children: markdownString }),
      learnMoreLInks && /* @__PURE__ */ jsxRuntimeExports.jsx(LearnMore, { links: learnMoreLInks })
    ] });
  };
  useEffect(() => {
    if (jsonConversation?.parentId) {
      setFormState((prevState) => {
        return {
          ...prevState,
          parentId: jsonConversation?.parentId
        };
      });
    }
  }, [jsonConversation?.parentId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: className.markdownMessageContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { textToCopy: renderToString(/* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, {})), conversation })
  ] });
};

const useMessageTypesStyles$1 = makeStyles({
    defaultMessageContainer: {
        padding: "14px 0 0 0",
    },
    messageContainer: {
        padding: "0 0 8px 0",
        margin: 0,
    }
});

const DefaultMessage = ({ conversation }) => {
  const styles = useMessageTypesStyles$1();
  const isError = conversation?.responseType === "error";
  const defaultMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.messageContainer, children: defaultBotMessage });
  const errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.messageContainer, children: defaultErrorMessage });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.defaultMessageContainer, children: [
    isError ? errorMessage : defaultMessage,
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { textToCopy: renderToString(isError ? errorMessage : defaultMessage), conversation })
  ] });
};

const useMessageTypesStyles = makeStyles({
    defaultMessageContainer: {
        padding: "14px 0 0 0",
    },
    messageContainer: {
        padding: "0 0 8px 0",
        margin: 0,
    }
});

const ErrorMessage = ({ conversation }) => {
  const styles = useMessageTypesStyles();
  const isError = conversation?.responseType === "error";
  let responseErrorMessage;
  if (conversation && conversation.data && conversation.data.errorMessage) {
    responseErrorMessage = conversation?.data?.errorMessage;
  } else {
    responseErrorMessage = defaultErrorMessage;
  }
  const errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.messageContainer, children: responseErrorMessage });
  const defaultMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.messageContainer, children: defaultBotMessage });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.defaultMessageContainer, children: [
    isError ? errorMessage : defaultMessage,
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { textToCopy: renderToString(isError ? errorMessage : defaultMessage), conversation })
  ] });
};

const useGraphMessageStyles = makeStyles({
    graphMessageContainer: {
        padding: "10px 0",
    },
    graphContainer: {
        width: "100%",
        overflow: "auto",
    },
    rephrasedQuestion: {
        fontSize: "14px",
        padding: "8px 0",
    },
    graphActionButtonContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    graphSupportTicketButtonContainer: {
        padding: "10px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }
});

const filterData = (data) => {
    return data.filter((item) => {
        const numericValue = Number(item[1]);
        return !isNaN(numericValue) && item[1] !== null;
    });
};

const getChartData = (responseArray, isPieChart, match) => {
    const filteredData = filterData(responseArray.data);
    if (isPieChart) {
        return {
            labels: filteredData.map((item) => item[0]),
            values: filteredData.map((item) => item[1]),
            type: "pie",
            textinfo: "none",
        };
    }

    return {
        x: filteredData.map((item) => item[0]),
        y: filteredData.map((item) => item[1]),
        type: match[2] || match[3], // Choose the correct plot type from match
    };
};

const getChartLayout = (isPieChart, width, height) => {
    return isPieChart ? {
        width,
        height,
        margin: {l: 0, r: 0, t: 0, b: 0},
    } : {width, height};
};


const getPlotConfig = () => ({
    displaylogo: false,
    modeBarButtons: [["toImage"]],
});

const useConfidentialNoteStyles = makeStyles({
        confidentialNoteContainer: {
            marginTop: "10px",
            marginBottom: "10px",
            display: "flex",
            justifyContent: "flex-start",
        }
    }
);

const ConfidentialNote = ({ conversation }) => {
  const classes = useConfidentialNoteStyles();
  const note = conversation?.data?.note || noteInformation;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classes.confidentialNoteContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SensitivityLabel, { children: [
    "Note:- ",
    note
  ] }) });
};

const GraphMessage = ({ conversation }) => {
  const dispatch = useDispatch();
  const styles = useGraphMessageStyles();
  const { dataToDisplay } = formatAndConvertJsonBySourceAndType(conversation);
  getChartData(dataToDisplay?.graphData, dataToDisplay?.graphType, dataToDisplay?.match);
  getChartLayout(dataToDisplay.graphType, "600px", "400px");
  const plotConfig = getPlotConfig();
  const { setFormState } = useMCAPSBotFormContext();
  const { ocvData, positiveFeedback, negativeFeedback } = useMCAPSBotContext();
  const isSelected = conversation?.isFeedbackUpvoted === true ? "positive" : conversation?.isFeedbackUpvoted === false ? "negative" : undefined;
  const [selected, setSelected] = useState(isSelected);
  const disabled = selected !== undefined;
  useEffect(() => {
    if (dataToDisplay?.parentId) {
      setFormState((prevState) => {
        return {
          ...prevState,
          parentId: dataToDisplay?.parentId
        };
      });
    }
  }, [dataToDisplay?.parentId]);
  const handlePositiveFeedback = () => {
    setSelected("positive");
    const message = {
      ...conversation,
      isFeedbackUpvoted: true
    };
    dispatch(updateConversationsHistory(message));
    positiveFeedback();
    ocvData(true, message);
  };
  const handleNegativeFeedback = () => {
    setSelected("negative");
    const message = {
      ...conversation,
      isFeedbackUpvoted: false
    };
    dispatch(updateConversationsHistory(message));
    negativeFeedback();
    ocvData(false, message);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.graphMessageContainer, children: [
    dataToDisplay?.rephrasedQuestion && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.rephrasedQuestion, children: [
      "I assume you are asking about the",
      " ",
      dataToDisplay.rephrasedQuestion
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.graphContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Plot, { data: dataToDisplay.plotData, layout: dataToDisplay.layout, config: plotConfig }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.graphActionButtonContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConfidentialNote, { conversation }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.graphSupportTicketButtonContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotCreateSupportTicketButton, { conversation }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FeedbackButtons,
        {
          disabled,
          selected,
          positiveFeedbackButton: { onClick: handlePositiveFeedback },
          negativeFeedbackButton: { onClick: handleNegativeFeedback },
          positiveFeedbackTooltip: {
            content: selected === "positive" ? "Like, Feedback sent" : "Like"
          },
          negativeFeedbackTooltip: {
            content: selected === "negative" ? "Dislike, Feedback sent" : "Dislike"
          }
        }
      )
    ] })
  ] });
};

const useTextMessageStyles = makeStyles({
    textMessageContainer: {
        padding: "10px 0",
    },
    rephrasedQuestion: {
        fontSize: '10px',
    },
    listContainer: {
        marginTop: '10px',
        padding: '0',
    },
    listItemIndex: {
        marginTop: '0',
        padding: '0',
    },
    listItemContainer: {
        marginTop: '0',
        padding: '0',
    },
    listItem: {
        padding: '0 10px',
        listStyle: 'none',
        display: 'flex',
    },
    itemTitle: {
        fontWeight: '500',
        fontSize: '14px',
        padding: '0 10px ',
    },
    itemValue: {
        fontSize: '14px',
        padding: '0 10px ',
    },
});

const TextMessage = ({ conversation }) => {
  const { setFormState } = useMCAPSBotFormContext();
  const styles = useTextMessageStyles();
  const jsonConversation = formatAndConvertJsonBySourceAndType(conversation)?.dataToDisplay;
  const replyMessages = jsonConversation?.replyMessages;
  const aiResponseData = jsonConversation?.aiResponseData;
  const contentData = jsonConversation?.contentData;
  const query = jsonConversation?.query;
  const [data, setData] = useState(null);
  useEffect(() => {
    const regex = /(\d+)\.\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*(\d+)/g;
    let matches;
    let result = [];
    while ((matches = regex.exec(aiResponseData)) !== null) {
      let project = {};
      for (let i = 0; i < matches.length - 1; i++) {
        project[`field${i + 1}`] = matches[i + 1];
      }
      result.push(project);
    }
    result.length > 0 && setData(result);
  }, [aiResponseData]);
  useEffect(() => {
    if (jsonConversation?.parentId) {
      setFormState((prevState) => {
        return {
          ...prevState,
          parentId: jsonConversation.parentId
        };
      });
    }
  }, [jsonConversation?.parentId]);
  const ListDisplay = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.listContainer, children: [
    jsonConversation.rephrasedQuestion ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: styles.rephrasedQuestion, children: jsonConversation.rephrasedQuestion }) : null,
    data.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.listItem, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("h4", { className: styles.listItemIndex, children: [
        index + 1,
        ")"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: styles.listItemContainer, children: Object.entries(item).map(([key, value], idx) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { className: styles.listItem, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: styles.itemTitle, children: [
          key,
          ":"
        ] }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "span",
          {
            className: styles.itemValue,
            children: value
          }
        )
      ] }, idx)) })
    ] }, index))
  ] });
  const textMessage = () => {
    const htmlText = { __html: aiResponseData };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.textMessageContainer, children: [
      data?.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ListDisplay, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.listContainer, dangerouslySetInnerHTML: htmlText }),
      contentData && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.listContainer, children: contentData }),
      replyMessages && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.listContainer, dangerouslySetInnerHTML: replyMessages }),
      query && /* @__PURE__ */ jsxRuntimeExports.jsx(Query, { queryText: query })
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    textMessage(),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { textToCopy: renderToString(textMessage()), conversation })
  ] });
};

const useHtmlTableMessageTypesStyles = makeStyles({

    htmlTableMessageContainer: {
        padding: "18px 0 0",
        "& table": {
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: tokens$2.colorNeutralBackground1,
        },
        "& th": {
            textAlign: 'left',
            padding: '4px 6px',
            backgroundColor: tokens$2.colorNeutralBackground3,
            color: tokens$2.colorNeutralForeground1,
            fontWeight: 600,
            borderBottom: `2px solid ${tokens$2.colorNeutralBackground4}`,
        },
        "& td": {
            padding: '4px 6px',
            borderBottom: `1px solid ${tokens$2.colorNeutralBackground4}`,
            color: tokens$2.colorNeutralForeground2,
        },
        "& tr": {
            '&:hover': {
                backgroundColor: tokens$2.colorNeutralBackground2,
            },
        },
        "& .headerRow": {
            '&:hover': {
                backgroundColor: tokens$2.colorNeutralBackground3,
            },
        },
        "& .stripedRow": {
            backgroundColor: tokens$2.colorNeutralBackground1,
        },
    },

});

const HtmlTableMessage = ({ conversation }) => {
  const styles = useHtmlTableMessageTypesStyles();
  const { setFormState } = useMCAPSBotFormContext();
  const jsonConversation = formatAndConvertJsonBySourceAndType(conversation)?.dataToDisplay;
  const tableDataObject = jsonConversation.tableData;
  const tableColumns = tableDataObject?.columns;
  const tableData = tableDataObject?.data;
  const htmlTableMessage = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.htmlTableMessageContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: tableColumns.map((column, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: column }, index)) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: tableData.map((row, rowIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: row.map((cell, cellIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: cell }, cellIndex)) }, rowIndex)) })
      ] }),
      tableDataObject?.note && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.htmlTableMessageNote, children: tableData.note })
    ] });
  };
  useEffect(() => {
    if (jsonConversation?.parentId) {
      setFormState((prevState) => {
        return {
          ...prevState,
          parentId: jsonConversation?.parentId
        };
      });
    }
  }, [jsonConversation?.parentId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    htmlTableMessage(),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { textToCopy: renderToString(htmlTableMessage()), conversation })
  ] });
};

const useMarkdownStyles = makeStyles({
    markdownMessageContainer: {
        padding: "8px 0",
    },
    markdownMessage: {
        fontFamily: "Segoe UI",
        fontSize: "12px",
        "& h1": {
            fontSize: "18px",
            fontWeight: 600,
            padding: "18px 0 4px 0",
        },
        "& h2": {
            fontSize: "16px",
            fontWeight: 500,
            padding: "18px 0 4px 0",
        },
        "& h3": {
            fontSize: "16px",
            fontWeight: 500,
            padding: "18px 0 4px 0",
        },
        "& ul": {
            fontSize: "12px",
            listStyleType: "disc",
            paddingLeft: "1.5rem",
            margin: "0",
        },
        "& ol": {
            fontSize: "12px",
            listStyleType: "decimal",
            paddingLeft: "1.5rem",
            margin: "0",
        },
        "& li": {
            fontSize: "12px",
            marginBottom: "0.5rem",
        },
        "& blockquote": {
            fontSize: "12px",
            borderLeft: "4px solid #ccc",
            paddingLeft: "1rem",
            fontStyle: "italic",
            margin: "1rem 0",

        },
        "& pre": {

            padding: "1rem",
            borderRadius: "4px",
            fontFamily: "monospace",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            marginBottom: "1rem",
        },
        "& code": {
            padding: "0.2rem 0.4rem",
            borderRadius: "4px",
            fontFamily: "monospace",
            fontSize: "11px",
        },
        "& table": {
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "1rem",
        },
        "& th": {
            fontWeight: "bold",
            padding: "8px",

        },
        "& td": {
            padding: "8px",

        },
        "& tr:nth-child(even)": {},
    },
});

const CommandMessage = ({ conversation }) => {
  const { updateParentId } = useMCAPSBotContext();
  const className = useMarkdownStyles();
  const jsonConversation = formatAndConvertJsonBySourceAndType(conversation)?.dataToDisplay;
  const { markdownString } = jsonConversation;
  const LinkRenderer = ({ href, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children });
  const MarkdownRenderer = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: className.markdownMessage, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { components: { a: LinkRenderer }, remarkPlugins: [remarkGfm], children: markdownString }) });
  };
  useEffect(() => {
    if (jsonConversation?.parentId) {
      updateParentId(jsonConversation.parentId);
    }
  }, [jsonConversation?.parentId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: className.markdownMessageContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownRenderer, {}) });
};

const useGreetingsMessageStyles = makeStyles({
    greetingsMessageContainer: {
        padding: 0,
    },
    textMessageContainer: {
        padding: "10px 0",
    }
});

const GreetingsMessage = ({ conversation }) => {
  const styles = useGreetingsMessageStyles();
  const { setFormState } = useMCAPSBotFormContext();
  const jsonConversation = formatAndConvertJsonBySourceAndType(conversation).dataToDisplay;
  const greetingsMessage = () => {
    const htmlText = { __html: jsonConversation?.replyMessages?.replace(/\n/g, " </br> ") };
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.textMessageContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.listContainer, dangerouslySetInnerHTML: htmlText }) });
  };
  useEffect(() => {
    if (jsonConversation?.parentId) {
      setFormState((prevState) => {
        return {
          ...prevState,
          parentId: jsonConversation.parentId
        };
      });
    }
  }, [jsonConversation?.parentId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.greetingsMessageContainer, children: [
    greetingsMessage(),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { textToCopy: renderToString(greetingsMessage()), conversation })
  ] });
};

const useSqlCopilotMessageStyles = makeStyles({
    sqlCopilotMessageContainer: {
        padding: "10px 0",
        selectors: {
            "& pre": {
                marginTop: "10px !import",
            },
        },
    },
    chatDataContainer: {
        width: "100%",
        overflowX: "auto",
    },
    sqlCopilotMessage: {
        width: "100%",
        padding: "10px 0",
        overflowX: "auto",
    },
    confidentialNoteContainer: {
        marginTop: "10px",
    },
    additionalNoteContainer: {
        marginTop: "10px",
        fontSize: "10px",
        color: "#4b4b4b",
    }
});

const SqlCopilotMessage = ({ conversation }) => {
  const styles = useSqlCopilotMessageStyles();
  const data = conversation?.data;
  const markDownResult = data?.markDownResult;
  const error = data?.errorMessage;
  const errorCode = data?.errorCode;
  const isChart = data.isChart;
  const LinkRenderer = ({ href, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, target: "_blank", rel: "noopener noreferrer", children });
  const markdownMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "markdown-table", style: { overflowX: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { components: { a: LinkRenderer }, remarkPlugins: [remarkGfm], children: markDownResult }) });
  const errorMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: error });
  const chatBotActionProps = {
    textToCopy: !isChart ? renderToString(markdownMessage) : null,
    conversation
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.sqlCopilotMessageContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.sqlCopilotMessage, children: [
      isChart && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.chatDataContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Plot,
        {
          data: JSON.parse(data?.chartData)?.data,
          layout: JSON.parse(data?.chartData)?.layout,
          config: { displayModeBar: false, scrollZoom: false }
        }
      ) }),
      !isChart && markDownResult && markdownMessage,
      error && errorMessage,
      errorCode === null && data?.additionaNote !== "" && data?.additionaNote !== null && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.additionalNoteContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: data?.additionaNote }) }),
      errorCode === null && data?.ConfidentialNote && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.confidentialNoteContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConfidentialNote$1, { note: data?.confidentailNote }) }),
      errorCode === null && data?.resultStatistics && Object.keys(data?.resultStatistics).length !== 0 && data?.resultStatistics?.FinalSQLQuery !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(Query, { queryText: data?.resultStatistics?.FinalSQLQuery })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatBotActionButtons, { ...chatBotActionProps })
  ] });
};

class CopilotErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    this.setState({ error, errorInfo });
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { padding: "20px 0" }, children: "Something went wrong. Please try again later." });
    }
    return this.props.children;
  }
}

const Message = ({ conversation }) => {
  const props = { conversation };
  const componentMap = {
    cloudgpt: {
      text: /* @__PURE__ */ jsxRuntimeExports.jsx(TextMessage, { ...props }),
      htmltable: /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlTableMessage, { ...props }),
      markdown: /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownMessage, { ...props }),
      graph: /* @__PURE__ */ jsxRuntimeExports.jsx(GraphMessage, { ...props }),
      error: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { ...props })
    },
    dbcopilot: {
      text: /* @__PURE__ */ jsxRuntimeExports.jsx(TextMessage, { ...props }),
      htmltable: /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlTableMessage, { ...props }),
      markdown: /* @__PURE__ */ jsxRuntimeExports.jsx(MarkdownMessage, { ...props }),
      graph: /* @__PURE__ */ jsxRuntimeExports.jsx(GraphMessage, { ...props }),
      error: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { ...props })
    },
    copilot: {
      command: /* @__PURE__ */ jsxRuntimeExports.jsx(CommandMessage, { ...props })
    },
    greetings: {
      text: /* @__PURE__ */ jsxRuntimeExports.jsx(GreetingsMessage, { ...props })
    },
    nl2sqldbcopilot: {
      text: /* @__PURE__ */ jsxRuntimeExports.jsx(SqlCopilotMessage, { ...props })
    }
  };
  const defaultMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultMessage, { ...props });
  const { source, responseType } = conversation;
  const sourceMap = componentMap[source];
  if (sourceMap) {
    const component = sourceMap[responseType] || defaultMessage;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotErrorBoundary, { children: component });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotErrorBoundary, { children: defaultMessage });
};

const useChatbotMessageStyles = makeStyles({
        chatbotMessageContainer: {
            backgroundColor: tokens$2.colorNeutralBackground1,
            border: tokens$2.colorNeutralStroke1,
            borderRadius: "10px",
            padding: "20px 18px",
            overflow: "0",
            margin: "0"
        },
    }
);

const ChatbotMessage = ({ conversation }) => {
  const styles = useChatbotMessageStyles();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(OutputCard, { className: styles.chatbotMessageContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotMessageHeading, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Message, { conversation })
  ] });
};

const useStyles$1 = makeStyles({
    separatorContainer: {
        display: "inline-flex",
        width: "100%",
        color: "rgb(170, 170, 170)",
    },
    separatorLine: {
        borderTop: "1px solid rgb(170, 170, 170)",
        margin: "10px",
        width: "100%",
    },
    userMessageContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "0",
        "& > div": {
            padding: 0,
        },
        "& button": {
            visibility: "hidden",
            padding: 0,
            margin: 0,
            width: "40px",
            border: "solid 1px red"
        },
        "&:hover button": {
            visibility: "visible",
            padding: 0,
            background: "none !important",
            border: "none",
            margin: 0,
            height: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }
    },
    copyButtonContainer: {
        position: "relative",
    },
    copyButton: {
        position: "absolute",
        bottom: "26px",
        right: "-20px",
    }
});

const CopilotConversations = () => {
  const styles = useStyles$1();
  const { conversations, isLoading } = useMCAPSBotMessageContext();
  const { todayConversations } = classifyMessagesByDate(conversations);
  useEffect(() => {
    if (todayConversations.length > 0) {
      setTimeout(() => {
        const scrollableDiv = document.querySelector(".ms-Panel-scrollableContent");
        scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
      }, 200);
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: todayConversations.map((conversation) => {
    if (conversation?.from === "user") {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.userMessageContainer, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(UserMessage, { children: conversation?.message }, conversation?.id),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotCopyButton, { textToCopy: conversation?.message, source: "user" })
      ] }, conversation.id);
    }
    if (conversation?.from === "bot") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ChatbotMessage, { conversation, isLoading }, conversation.id);
    }
    if (conversation?.showNewConversation) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.separatorContainer, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.separatorLine }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { minWidth: 120, textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { children: newConversation }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.separatorLine })
      ] }, conversation.id);
    }
    return null;
  }) });
};

const useStyles = makeStyles({
  conversation: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens$2.spacingHorizontalS,
    margin: "24px auto",
    padding: "0",
    backgroundColor: "transparent"
  },
  promptHighlight: {
    color: tokens$2.colorBrandForegroundLink
  }
});
const CopilotMessages = () => {
  const styles = useStyles();
  const { theme } = useMCAPSBotContext();
  const { isLoading } = useMCAPSBotMessageContext();
  const copilotTheme = theme === "dark" ? webDarkTheme : webLightTheme;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FluentProvider,
    {
      theme: copilotTheme,
      style: { padding: "0" },
      className: styles.conversation,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotProvider, { theme: copilotTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CopilotChat, { style: { width: "100%" }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotConversations, {}),
        isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(ChatbotLoading, {})
      ] }) })
    }
  );
};

const getPanelStyles = (isMobile, copilotTheme) => {
    return {
        root: {
            top: isMobile ? 0 : '54px',
            height: isMobile ? "100%" : "calc(100% - 54px)",
        },
        content: {
            padding: 0,
            margin: 0,
        },
        main: {
            padding: 0,
            margin: 0,
            backgroundColor: copilotTheme.colorNeutralBackground1Hover,
        },
        commands: {
            zIndex: "100000 !important",
            padding: 0,
            margin: 0,
        },
        header: {
            padding: 0,
            margin: 0,
        },
        footer: {
            backgroundColor: `${copilotTheme.colorNeutralBackground1Hover} !important`,
            zIndex: "100000 !important",
            borderTop: "none !important",
            borderTop: "0 !important",
        },
        footerInner: {
            padding:"16px 18px",
        },
        scrollableContent: {
            padding: 0,
            margin: 0,
        }
    }
};


const usePanelStyles = makeStyles({
    panelMainInnerContainer: {
        backgroundColor: tokens$2.colorNeutralBackground1Hover,
    },
});

const CopilotPanel = () => {
  const { theme, isFullScreen, isVisible, panelProps, isMobile, maxWidth = "1024px", featureName } = useMCAPSBotContext();
  const { conversations } = useMCAPSBotMessageContext();
  const { formState } = useMCAPSBotFormContext();
  const getPanelWidth = isFullScreen ? "100vw" : "787px";
  const getPanelContentWidth = isFullScreen && !isMobile ? maxWidth : "100%";
  const getPanelPadding = isFullScreen && !isMobile ? "0" : "0 18px";
  const isConversation = conversations?.length > 0;
  const copilotTheme = theme === "dark" ? webDarkTheme : webLightTheme;
  const panelStyles = getPanelStyles(isMobile, copilotTheme);
  const className = usePanelStyles();
  const { trackCopilotEvent } = useTrackCustomEvents();
  const onOpened = useCallback(() => {
    trackCopilotEvent(featureName + " Opened", "Opened", formState);
  }, [isVisible]);
  useEffect(() => {
    onOpened();
  }, [isVisible]);
  const copilotPanelProps = {
    styles: panelStyles,
    isBlocking: false,
    isOpen: isVisible,
    type: PanelType.custom,
    customWidth: getPanelWidth,
    allowTouchBodyScroll: true,
    onRenderNavigation: () => /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotHeader, {}),
    onRenderFooterContent: () => /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotFooter, {}),
    isFooterAtBottom: true,
    hasCloseButton: false,
    themes: copilotTheme,
    ...panelProps
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Panel, { ...copilotPanelProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: getPanelContentWidth, margin: "0 auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: className.panelMainInnerContainer, style: { padding: getPanelPadding }, children: [
    !isConversation && /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotSuggestionPrompt, { source: "DefaulPrompt" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotMessages, {})
  ] }) }) });
};

const Context = ({ mcapsBotContext, children }) => {
  const { theme } = mcapsBotContext;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FluentProvider, { theme: theme === "dark" ? webDarkTheme : webLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotProvider, { mode: "canvas", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppContextProvider, { mcapsBotContext, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotMessageContextProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MCAPSBotFormContextProvider, { children }) }) }) }) });
};

const initialState$1 = {
    isLoading: false,
    error: null,
    suggestions: null,
};

const name$2 = "copilot";
const fetchSuggestions = createAsyncThunk(name$2 + "/suggestions",
    async ({tokenCallback, apiUrl, requestBody, additionalHeaderCallback}, {dispatch}) => {
        dispatch(fetchSuggestionsBegin());
        try {
            const response = await PostAsync(tokenCallback, apiUrl, requestBody, additionalHeaderCallback);
            if (response && response.status === 200 && response.data) {
                return response.data;
            } else {
                dispatch(fetchSuggestionsError(response.data));
            }
        } catch (err) {
            dispatch(fetchSuggestionsError(err));
        }

    }
);

const suggestionsSlice = createSlice({
        name: name$2,
        initialState: initialState$1,
        reducers: {
            fetchSuggestionsBegin: (state) => {
                state.isLoading = true;
                state.error = null;
            },
            fetchSuggestionsError: (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            }
        },
        extraReducers: (builder) => {
            builder.addCase(fetchSuggestions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.suggestions = action.payload;
            });
        }
    }
);

const {
    fetchSuggestionsBegin,
    fetchSuggestionsError
} = suggestionsSlice.actions;

const initialState = {
    isLoading: false,
    error: null,
    command: null,
};

const name$1 = "copilot";
const fetchCommand = createAsyncThunk(name$1 + "/command",
    async ({tokenCallback, apiUrl, requestBody, additionalHeaderCallback}, {dispatch}) => {
        dispatch(fetchCommandBegin());
        try {
            return await PostAsync(tokenCallback, apiUrl, requestBody, additionalHeaderCallback);
        } catch (err) {
            dispatch(fetchCommandError(err));
        }
    }
);

const commandSlice = createSlice({
        name: name$1,
        initialState,
        reducers: {
            fetchCommandBegin: (state) => {
                state.isLoading = true;
                state.error = null;
            },
            fetchCommandError: (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            }
        },
        extraReducers: (builder) => {
            builder.addCase(fetchCommand.fulfilled, (state, action) => {
                state.isLoading = false;
                state.command = action.payload;
            });
        }
    }
);

const {
    fetchCommandBegin,
    fetchCommandError
} = commandSlice.actions;

const combinedReducers = {
    command: commandSlice.reducer,
    suggestions: suggestionsSlice.reducer,
    question: questionSlice.reducer,
    conversationsHistory: conversationsHistorySlice.reducer,
};

const copilotRootReducer = combineReducers$1(combinedReducers);

const copilotStore = configureStore({
    reducer: copilotRootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
});

initializeIcons();
const Copilot = (props) => {
  console.log("props: ", props);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { store: copilotStore, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Context, { mcapsBotContext: { ...props }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FocusTrapZone,
    {
      isClickableOutsideFocusTrap: true,
      forceFocusInsideTrap: false,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopilotPanel, {})
    }
  ) }) });
};

const CSTCopilot = (props) => {
  const { height, width } = useWindowDimensions();
  const [copilotHeight, setCopilotHeight] = useState("auto");
  const [copilotZoom, setCopilotZoom] = useState("350dpi");
  useEffect(() => {
    props.useMockResponse && sessionStorage.setItem("useMockUiResponse", props.useMockResponse);
    if (width <= 1600) {
      setCopilotHeight("auto");
      setCopilotZoom("150dpi");
    } else if (width <= 2560) {
      setCopilotHeight("auto");
      setCopilotZoom("250dpi");
    } else if (width <= 3840) {
      setCopilotHeight("");
      setCopilotZoom("350dpi");
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { store, children: props.type === "dialog" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    DBCopilotBotDialog,
    {
      appName: props.applicationNameForCopilot,
      featureName: props.featureName,
      currentUserName: props.userName,
      isUserNameVisible: props.isUserNameVisible ? props.isUserNameVisible : false,
      apiUrls: props.apiUrls,
      appInsightConfig: props.appInsightConfig,
      image: props.image,
      trackCustomEvents: props.trackCustomEvents,
      getBearerTokenCallback: props.getBearerTokenCallback,
      getAdditionalHeaderCallback: props.getAdditionalHeaderCallback,
      negativeFeedback: props.negativeFeedback,
      positiveFeedback: props.positiveFeedback,
      pageInfo: props.pageInfo,
      theme: props.theme,
      receivedCommandFromExternalSystem: props.receivedCommandFromExternalSystem,
      setReplaceText: props.setReplaceText,
      ocvData: props.ocvData
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    DBCopilotBot,
    {
      appName: props.applicationNameForCopilot,
      featureName: props.featureName,
      currentUserName: props.userName,
      isUserNameVisible: props.isUserNameVisible ? props.isUserNameVisible : false,
      isPanelVisible: props.isVisible,
      isToggleVisible: props.isToggleVisible,
      isPromptButtonVisible: props.isPromptButtonVisible ? props.isPromptButtonVisible : false,
      isTypewritingOn: props.isTypewritingOn,
      apiUrls: props.apiUrls,
      msalInstance: props.msalInstance,
      appInsightConfig: props.appInsightConfig,
      botWelcomeMessage: props.botWelcomeMessage,
      botSuggestionMessage: props.botSuggestionMessage,
      IrisBotMessage: props.IrisBotMessage,
      image: props.image,
      trackCustomEvents: props.trackCustomEvents,
      getBearerTokenCallback: props.getBearerTokenCallback,
      getAdditionalHeaderCallback: props.getAdditionalHeaderCallback,
      negativeFeedback: props.negativeFeedback,
      positiveFeedback: props.positiveFeedback,
      ocvData: props.ocvData,
      pageInfo: props.pageInfo,
      onPanelDismiss: () => {
        props.closeBot();
      },
      panelStyles: {
        main: {
          backgroundColor: "rgb(245 245 245) !important",
          height: "calc(100vh - 50px)",
          top: "55px",
          [`@media (minResolution: ${copilotZoom})`]: {
            height: `${copilotHeight === "auto" ? "auto" : "calc(100vh - 50px)"}`,
            top: `${copilotHeight === "auto" ? "2px" : "55px"}`
          }
        },
        commands: {
          backgroundColor: "rgb(245 245 245) !important",
          height: 50,
          marginTop: 0,
          paddingTop: 0,
          color: "white !important",
          "@media (minResolution: 350dpi)": {
            height: "12px",
            position: "relative"
          }
        }
      },
      textBoxLength: props.textBoxLength,
      isCreateIncidentButtonVisible: props.isCreateIncidentButtonVisible,
      createSupportTicketButtonText: props.createSupportTicketButtonText,
      onShowIrisBot: props.supportTicket,
      addionalHelpButtonSetting: props.addionalHelpButtonSetting,
      additionalHelpButtonCallback: props.additionalHelpButtonCallback,
      isCopyButtonVisible: props.isCopyButtonVisible,
      isVersionVisible: props.isVersionVisible,
      theme: props.theme,
      suggestionPopupCharacterThreshold: props.suggestionPopupCharacterThreshold,
      suggestionPopupCount: props.suggestionPopupCount,
      isAutoSuggestionEnabled: props.isAutoSuggestionEnabled,
      isResponseSuggestionEnabled: props.isResponseSuggestionEnabled,
      additionalContextDetails: props.additionalContextDetails,
      isPromptCoachmarkVisible: props.isPromptCoachmarkVisible ? props.isPromptCoachmarkVisible : false,
      receivedCommandFromExternalSystem: props.receivedCommandFromExternalSystem,
      promptsSuggestions: props.promptsSuggestions,
      maintainHistory: props.maintainHistory,
      isHistoryFetched: props.isHistoryFetched,
      getProjectTeamsData: props.getProjectTeamsData,
      IsSlashCommandEnabled: props.IsSlashCommandEnabled
    }
  ) });
};

export { CSTCopilot, Copilot as CSTCopilotV2, CopilotCommandExtention };
